/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 85981:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ attachmentManagerWrapper)
});

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(87751);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
;// CONCATENATED MODULE: ./electron/attachResolveScheduler.js












function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var CHECK_TIMEOUT = 15e3;
var AttachResolveScheduler = /*#__PURE__*/function () {
  function AttachResolveScheduler(fn, successFn, attachmentManager) {
    var _this = this;
    _classCallCheck(this, AttachResolveScheduler);
    _defineProperty(this, "check", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var itemsNotResolved, _iterator, _step, item, attach, _ref2, editorInstance, _item, blotId;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.timeout = null;
              itemsNotResolved = [];
              _iterator = _createForOfIteratorHelper(_this.scheduled);
              _context.prev = 3;
              _iterator.s();
            case 5:
              if ((_step = _iterator.n()).done) {
                _context.next = 25;
                break;
              }
              item = _step.value;
              console.log('check item', item);
              _context.prev = 8;
              _context.next = 11;
              return _this.resolveFn.apply(_this, _toConsumableArray(item));
            case 11:
              attach = _context.sent;
              _this.successFn(attach);
              _context.next = 23;
              break;
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](8);
              _ref2 = _this.attachmentManager || {}, editorInstance = _ref2.editorInstance;
              _item = _slicedToArray(item, 2), blotId = _item[1].blotId; // в случае если блот был удалён, то останавливаем попытки загрузить файл
              if (!(editorInstance && !editorInstance.findById(blotId))) {
                _context.next = 22;
                break;
              }
              console.log("blot ".concat(blotId, " was not found. stop check item"));
              return _context.abrupt("continue", 23);
            case 22:
              itemsNotResolved.push(item);
            case 23:
              _context.next = 5;
              break;
            case 25:
              _context.next = 30;
              break;
            case 27:
              _context.prev = 27;
              _context.t1 = _context["catch"](3);
              _iterator.e(_context.t1);
            case 30:
              _context.prev = 30;
              _iterator.f();
              return _context.finish(30);
            case 33:
              _this.scheduled = itemsNotResolved;
              if (_this.scheduled.length) {
                _this.timeout = setTimeout(_this.check, CHECK_TIMEOUT);
              }
            case 35:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 27, 30, 33], [8, 15]]);
    })));
    this.timeout = null;
    this.scheduled = [];
    this.resolveFn = fn;
    this.successFn = successFn;
    this.attachmentManager = attachmentManager;
  }
  _createClass(AttachResolveScheduler, [{
    key: "schedule",
    value: function schedule(attachGlobalId) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      console.log('schedule attach', attachGlobalId, args);
      this.scheduled.push([attachGlobalId].concat(args));
      if (!this.timeout) {
        this.timeout = setTimeout(this.check, CHECK_TIMEOUT);
      }
    }
  }]);
  return AttachResolveScheduler;
}();

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/errors/attachmentNotFoundError.js
var attachmentNotFoundError = __webpack_require__(45405);
// EXTERNAL MODULE: ./electron/utils/isOnline.js
var isOnline = __webpack_require__(94166);
;// CONCATENATED MODULE: ./attachmentManagerWrapper.js

function attachmentManagerWrapper_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function attachmentManagerWrapper_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { attachmentManagerWrapper_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { attachmentManagerWrapper_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




function attachmentManagerWrapper(attachmentManager) {
  var isDesktopBuild = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var attachmentManagerResolve = attachmentManager.resolve.bind(attachmentManager);

  /**
   * Перезапрос attachment пока не удастся его получить
   * @type {AttachResolveScheduler}
   */
  var resolveScheduler = new AttachResolveScheduler(function (globalId) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Promise(function (resolve, reject) {
      attachmentManagerResolve(globalId, options).then(function (attachment) {
        if (!attachment) {
          return reject(new attachmentNotFoundError["default"]());
        }
        resolve(attachment);
      });
    });
  }, function (attachment) {
    if (attachmentManager.editorInstance) {
      attachmentManager.editorInstance.setAttachment(attachment);
    }
  }, attachmentManager);

  /**
   * Обёртка оригинального resolve  
   * @param {*} globalId 
   * @param {*} options 
   * @returns 
   */
  attachmentManager.resolve = /*#__PURE__*/function () {
    var _ref = attachmentManagerWrapper_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(globalId) {
      var options,
        _args = arguments;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              return _context.abrupt("return", new Promise(function (resolve, reject) {
                attachmentManagerResolve(globalId, options).then(function (attachment) {
                  // Если редактор был destroyed реджектим промис
                  if (attachmentManager.editorInstance && attachmentManager.editorInstance.destroyed) {
                    return reject('Editor has already been destroyed');
                  }

                  // Для того чтобы, если не удалось получить attachment, возвращалась ошибка AttachmentNotFoundError
                  // В этом случае если файл еще не загружен будет отображаться прогресс вместо ошиби Try again 
                  if (isDesktopBuild) {
                    if (!attachment) {
                      console.info('fail to resolve attach', globalId);
                      if ((0,isOnline/* default */.Z)()) {
                        resolveScheduler.schedule(globalId, options);
                      }
                      return reject(new attachmentNotFoundError["default"]());
                    }
                    console.info('the app resolved attach', globalId, 'into', attachment);
                  }
                  resolve(attachment);
                });
              }));
            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return attachmentManager;
}

/***/ }),

/***/ 87159:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ LocalDb)
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__(23123);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(21249);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(69600);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(15306);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/yjs/dist/yjs.mjs + 26 modules
var yjs = __webpack_require__(51718);
;// CONCATENATED MODULE: ./electron/store/ExtractText.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }













function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function extractTextFromDeltaOps(ops) {
  var texts = [];
  var markers = [];
  var text = '';
  var _iterator = _createForOfIteratorHelper(ops),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var op = _step.value;
      if (typeof op.insert === 'string' && op.insert !== '\n') {
        text += op.insert.replace(/\n+$/, '');
        if (op.attributes && op.attributes.background) {
          markers.push(op.insert);
        }
      } else if (op.insert && op.insert.linebreak) {
        if (text) {
          texts.push(text);
          text = '';
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (text) {
    texts.push(text);
  }
  return {
    text: texts.join('\n'),
    markers: markers
  };
}
function extractNoteText(data, Persistence) {
  return new Promise(function (resolve, reject) {
    var docName = data.docName;
    var persistence = new Persistence();
    var doc = new Y.Doc();
    try {
      console.log('readState:extractNoteText => data?', data);
      persistence.readState(docName, doc).then(function () {
        return resolve(getDocData(data, doc));
      });
    } catch (err) {
      console.log('persistence.readState err?', err);
      return resolve(null);
    }
  });
}
function getChildrenArr(map) {
  var possibleChildrenKey = ['children', 'rows'];
  var result = [];
  for (var _i = 0, _possibleChildrenKey = possibleChildrenKey; _i < _possibleChildrenKey.length; _i++) {
    var key = _possibleChildrenKey[_i];
    var children = map.get(key);
    if (children) {
      result.push.apply(result, _toConsumableArray(children));
      break;
    }
  }
  if (map.get('caption')) {
    result.push(map.get('caption'));
  }
  return result;
}
function extractTexts(map, children, blocks) {
  var texts = [];
  var markers = [];
  var chars = map.get('characters');
  if (chars) {
    var delta = chars.toDelta();
    var deltaRes = extractTextFromDeltaOps(delta);
    if (deltaRes.text) {
      texts.push(deltaRes.text);
    }
    if (deltaRes.markers) {
      markers.push.apply(markers, _toConsumableArray(deltaRes.markers));
    }
  }
  if (children) {
    var _iterator2 = _createForOfIteratorHelper(children),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var childId = _step2.value;
        var childMap = blocks.get(childId);
        if (childMap) {
          var childRes = extractTexts(childMap, getChildrenArr(childMap), blocks);
          texts.push.apply(texts, _toConsumableArray(childRes.texts));
          markers.push.apply(markers, _toConsumableArray(childRes.markers));
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return {
    texts: texts,
    markers: markers
  };
}
function getDocData(message, doc) {
  try {
    var workspaceId = message.workspaceId,
      noteGlobalId = message.noteGlobalId;
    var rootMap = doc.get('root', yjs.Map); // получаем root из заметки
    var rootChildren = doc.get('rootChildren', yjs.Array); // получаем rootChildren
    var blocks = doc.get('blocks', yjs.Map); // получаем blocks как Y.Map

    // для того чтобы избежать ошибку extractTexts "map.get is not a function"
    if (rootMap && !rootMap.get || !rootMap) {
      return null;
    }
    var _extractTexts = extractTexts(rootMap, rootChildren, blocks),
      texts = _extractTexts.texts;
    return {
      workspaceId: workspaceId,
      noteId: noteGlobalId,
      textString: texts.join('\n')
    };
  } catch (err) {
    console.log('failed', err);
    return null;
  }
}
;// CONCATENATED MODULE: ./electron/store/db.js
/* provided dependency */ var Buffer = __webpack_require__(13423)["Buffer"];





function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var LocalDb = /*#__PURE__*/function () {
  function LocalDb() {
    _classCallCheck(this, LocalDb);
  }
  _createClass(LocalDb, [{
    key: "_serializeBuffer",
    value:
    /**
     * Конвертировать буфер в закодированную base64 строку
     * @param buf
     * @returns {string}
     * @private
     */
    function _serializeBuffer(buf) {
      return Buffer.from(buf).toString('base64');
    }

    /**
     * Декодирование буфера из base64
     * @param str
     * @returns {Buffer}
     * @private
     */
  }, {
    key: "_deSerializeBuffer",
    value: function _deSerializeBuffer(str) {
      return Buffer.from(str, 'base64');
    }

    /**
     * Выводит строку вконсоль
     * @param err
     * @private
     */
  }, {
    key: "_convertError",
    value: function _convertError(err) {
      console.log(err);
    }

    /**
     * Запись значение в базу
     * @param key
     * @param value
     * @param y
     * @param cb
     */
  }, {
    key: "put",
    value: function put(key, value, y, cb) {
      var valueSerialized = this._serializeBuffer(value); // конвертирует value в base64
      var _this$getNoteData = this.getNoteData({
          key: key
        }),
        workspaceId = _this$getNoteData.workspaceId,
        noteId = _this$getNoteData.noteId; // раскладываем key на workspaceId и nodeId
      var valueShort; // короткое значение
      var valueFull; // полное значение

      if (y.conf.noteId === noteId) {
        // и если noteId полученный по ключу key и nodeId документа совпадают
        console.log('==> live editor => put > workspaceId, y._conf.workspaceId, noteId, y._conf.noteId?', workspaceId, y._conf.workspaceId, noteId, y._conf.noteId);

        // получаем текст заметки
        var _getDocData = getDocData({
            workspaceId: workspaceId,
            noteGlobalId: noteId
          }, y),
          textString = _getDocData.textString;

        // если текст получен
        if (typeof textString !== 'undefined') {
          valueShort = textString.substring(0, 500); // берем 500 первых символов для valueShort
          valueFull = textString; // полный текст заметки
        }

        // записываем результат в базу
        window.textEditor && window.textEditor.put && window.textEditor.put({
          key: key,
          valueSerialized: valueSerialized,
          valueShort: valueShort,
          valueFull: valueFull
        }).then(function (data) {
          return cb(null, data);
        });
      }
    }

    /**
     * Записать массив в базу
     * @param entries
     * @param y
     * @param cb
     * @returns {*}
     */
  }, {
    key: "putArray",
    value: function putArray(entries, y, cb) {
      if (!entries.length) {
        // если передан пустой массив то возвращаем пустой калбэк
        return cb(null, []);
      }
      var valueShort = '';
      var valueFull = '';
      var key = '';
      var saveLength = entries.length; // длина массива с записями
      for (var i = 0; i < saveLength; i++) {
        entries[i].valueSerialized = this._serializeBuffer(entries[i].buf); // конвертируем буфер в base64
        var _this$getNoteData2 = this.getNoteData({
            key: entries[i].key
          }),
          workspaceId = _this$getNoteData2.workspaceId,
          noteId = _this$getNoteData2.noteId; // получаем workspaceId и noteId по ключу записи

        if (y.conf.noteId === noteId) {
          // если nodeId документа совпадает с тем что получен по ключу записи
          console.log('=> live editor => putArray > workspaceId, y._conf.workspaceId, noteId, y._conf.noteId?', workspaceId, y.conf.workspaceId, noteId, y.conf.noteId);
          if (i === saveLength - 1) {
            // если i  совпадает с последним элементом массива
            key = entries[i].key; // ключ записи

            // получаем docData
            var docData = getDocData({
              workspaceId: workspaceId,
              noteGlobalId: noteId
            }, y);
            // пробуем извлечь textString
            var _ref = docData ? docData : {},
              textString = _ref.textString;

            // устанавливаем короткое и длинное значение если можно
            if (typeof textString !== 'undefined') {
              valueShort = textString.substring(0, 500);
              valueFull = textString;
            }
          }
        }
      }

      //записываем данные в базу
      window.textEditor && window.textEditor.putArray && window.textEditor.putArray({
        key: key,
        entries: entries,
        valueShort: valueShort,
        valueFull: valueFull
      }).then(function (data) {
        return cb(null, data);
      });
    }

    /**
     * Получает nodeId и workspaceId по ключу
     * @param args
     * @returns {{noteId: (*|string), workspaceId: (*|string)}}
     */
  }, {
    key: "getNoteData",
    value: function getNoteData(args) {
      var key = args.key;
      var workspaceId, noteId;
      if (key) {
        var data = key.split('#')[0];
        if (data) {
          var noteData = data.split('_');
          if (noteData.length > 1) {
            workspaceId = noteData[0];
            noteId = noteData[1];
          }
        }
      }
      return {
        noteId: noteId,
        workspaceId: workspaceId
      };
    }

    /**
     * Получить значение по ключу
     * @param key
     * @param cb
     */
  }, {
    key: "get",
    value: function get(key, cb) {
      var _this = this;
      window.textEditor && window.handleEditorGetDbRequest && window.handleEditorGetDbRequest({
        key: key
      }).then(function (data) {
        return cb(null, _this._deSerializeBuffer(data));
      });
    }

    /**
     * Получить значение в диапазоне ключей
     * @param keyFrom
     * @param keyTo
     * @param cb
     */
  }, {
    key: "getFromRange",
    value: function getFromRange(keyFrom, keyTo, cb) {
      var _this2 = this;
      window.textEditor && window.textEditor.getFromRange && window.textEditor.getFromRange({
        keyFrom: keyFrom,
        keyTo: keyTo
      }).then(function (data) {
        return cb(null, data.map(function (d) {
          return _this2._deSerializeBuffer(d);
        }));
      });
    }

    /**
     * Получить ключи в диапазоне
     * @param keyFrom
     * @param keyTo
     * @param cb
     */
  }, {
    key: "getKeysFromRange",
    value: function getKeysFromRange(keyFrom, keyTo, cb) {
      window.textEditor && window.textEditor.getKeysFromRange && window.textEditor.getKeysFromRange({
        keyFrom: keyFrom,
        keyTo: keyTo
      }).then(function (data) {
        return cb(null, data);
      });
    }

    /**
     * Удаление записей
     * @param keys
     * @param cb
     */
  }, {
    key: "delete",
    value: function _delete(keys, cb) {
      window.textEditor && window.textEditor.delete && window.textEditor.delete({
        keys: keys
      }).then(function (data) {
        return cb(null, data);
      });
    }
  }]);
  return LocalDb;
}();


/***/ }),

/***/ 47704:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "getPersistence": () => (/* binding */ getPersistence)
});

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(87751);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.pad-start.js
var es_string_pad_start = __webpack_require__(83112);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.uint8-array.js
var es_typed_array_uint8_array = __webpack_require__(82472);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.copy-within.js
var es_typed_array_copy_within = __webpack_require__(92990);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.every.js
var es_typed_array_every = __webpack_require__(18927);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.fill.js
var es_typed_array_fill = __webpack_require__(33105);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.filter.js
var es_typed_array_filter = __webpack_require__(35035);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.find.js
var es_typed_array_find = __webpack_require__(74345);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.find-index.js
var es_typed_array_find_index = __webpack_require__(7174);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.for-each.js
var es_typed_array_for_each = __webpack_require__(32846);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.includes.js
var es_typed_array_includes = __webpack_require__(44731);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.index-of.js
var es_typed_array_index_of = __webpack_require__(77209);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.iterator.js
var es_typed_array_iterator = __webpack_require__(96319);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.join.js
var es_typed_array_join = __webpack_require__(58867);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.last-index-of.js
var es_typed_array_last_index_of = __webpack_require__(37789);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.map.js
var es_typed_array_map = __webpack_require__(33739);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reduce.js
var es_typed_array_reduce = __webpack_require__(29368);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reduce-right.js
var es_typed_array_reduce_right = __webpack_require__(14483);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reverse.js
var es_typed_array_reverse = __webpack_require__(12056);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.set.js
var es_typed_array_set = __webpack_require__(3462);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.slice.js
var es_typed_array_slice = __webpack_require__(30678);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.some.js
var es_typed_array_some = __webpack_require__(27462);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.sort.js
var es_typed_array_sort = __webpack_require__(33824);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.subarray.js
var es_typed_array_subarray = __webpack_require__(55021);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.to-locale-string.js
var es_typed_array_to_locale_string = __webpack_require__(12974);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.to-string.js
var es_typed_array_to_string = __webpack_require__(15016);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(54747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/promisify-any/lib/index.js
var lib = __webpack_require__(93860);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./electron/store/db.js + 1 modules
var db = __webpack_require__(87159);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/util/y.js
var util_y = __webpack_require__(64467);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/util/encoding.js + 2 modules
var encoding = __webpack_require__(59150);
// EXTERNAL MODULE: ./node_modules/@lib/editor/node_modules/lib0/decoding.js
var decoding = __webpack_require__(29693);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.uint32-array.js
var es_typed_array_uint32_array = __webpack_require__(29135);
;// CONCATENATED MODULE: ./electron/utils/util.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
































function getConnectionUrlByTokenInfo(tokenInfo, cid) {
  return tokenInfo.url + '?token=' + encodeURIComponent(tokenInfo.token) + '&cid=' + encodeURIComponent(cid);
}
function getDocName(workspaceId, noteGlobalId) {
  return workspaceId + '_' + noteGlobalId;
}

/**
 * @param {string} noteId
 * @return {boolean}
 */
function getNoteSynced(noteId) {
  return window.textEditor && window.textEditor.getNoteSynced && window.textEditor.getNoteSynced(noteId);
}

/**
 * @param {{noteId:string}} data
 */
function setNoteSynced(data) {
  window.textEditor && window.textEditor.setNoteSynced && window.textEditor.setNoteSynced(data, true);
}

/**
 * @return {boolean}
 */
function isOnline() {
  if (window && window.textEditor && window.textEditor.online) {
    return window.textEditor.online();
  }
  return !!(navigator && navigator.onLine);
}

/**
 * @param {string} workspaceId
 * @param {string} noteId
 * @return {string}
 */
function getTokenUrl(workspaceId, noteId) {
  return "/api/workspaces/".concat(workspaceId, "/texts/").concat(noteId, "/tokens");
}

/**
 * @return {string}
 */
function getSocketUrl(_ref) {
  var nodeId = _ref.nodeId,
    workspaceId = _ref.workspaceId,
    textId = _ref.textId,
    token = _ref.token,
    cid = _ref.cid;
  return "ws://text-".concat(nodeId, ".develop.nimbustest.com/socket.io.ws/").concat(workspaceId, "/").concat(textId, "?token=").concat(token, "&cid=").concat(cid);
}

/**
 * @return {number}
 */
function generateRandomUint32() {
  if (typeof crypto !== 'undefined' && crypto.getRandomValues != null) {
    var arr = new Uint32Array(1);
    crypto.getRandomValues(arr);
    return arr[0];
  } else {
    return Math.ceil(Math.random() * 0xFFFFFFFF);
  }
}
function isLocalOrigin(origin) {
  return !(isRemoteOrigin(origin) || isStyleOrigin(origin));
}
function isStyleOrigin(origin) {
  return origin && _typeof(origin) === 'object' && origin.action === 'setStyle';
}
function isRemoteOrigin(origin) {
  return origin && origin === 'remote';
}
function needUpdateOrigin(entity) {
  if (!entity.origin) {
    return true;
  }
  var isRemote = isRemoteOrigin(entity.origin);
  var isStyle = isStyleOrigin(entity.origin);
  var needUpdate = !isRemote && !isStyle && _typeof(entity.origin) === 'object';
  return needUpdate;
}
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(33141);
;// CONCATENATED MODULE: ./electron/store/persistence.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }















































function getPersistence(Y) {
  var DB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var debounceTimeout = 1000;
  var typingAutosaveTimeout = 10000;
  if (!DB) {
    DB = new db["default"]();
  }
  var promisifiedDB = {
    put: lib_default()(DB.put.bind(DB), 3),
    putArray: lib_default()(DB.putArray.bind(DB), 2),
    get: lib_default()(DB.get.bind(DB), 1),
    getFromRange: function getFromRange(keyFrom, keyTo) {
      return new Promise(function (resolve, reject) {
        DB.getFromRange(keyFrom, keyTo, function (err, res) {
          if (err) {
            return reject(err);
          }
          resolve(res);
        });
      });
    },
    getKeysFromRange: lib_default()(DB.getKeysFromRange.bind(DB), 2),
    delete: lib_default()(DB.delete.bind(DB), 1)
  };
  var mux = (0,util_y.createMutex)();

  /*
   * Improves the uniqueness of timestamps.
   * We gamble with the fact that users won't create more than 10000 changes on a single document
   * within one millisecond (also assuming clock works correctly).
   */
  var timestampIterator = 0;
  /**
   * @return {string} A random, time-based string starting with "${roomName}:"
   */
  var getNextTimestamp = function getNextTimestamp() {
    timestampIterator = (timestampIterator + 1) % 10000;
    return "".concat(Date.now()).concat(timestampIterator.toString().padStart(4, '0'));
  };

  /**
   * @param {string} docName
   * @return {string}
   */
  var generateEntryKey = function generateEntryKey(docName) {
    return "".concat(docName, "#").concat(getNextTimestamp());
  };

  /**
   *
   * @param {any} db
   * @param {string} docName
   * @param {Uint8Array | ArrayBuffer} buf
   * @param {Y.Y} ydocument
   */
  var writeEntry = function writeEntry(db, docName, buf, ydocument) {
    return db.put(generateEntryKey(docName), buf, ydocument);
  };

  /**
   *
   * @param {any} db
   * @param {[{key:string, buf:Uint8Array}]} entries
   * @param {Y.Y} ydocument
   */
  var writeEntries = function writeEntries(db, entries, ydocument) {
    return db.putArray(entries, ydocument);
  };

  /**
   * @param {Uint8Array} arr
   * @param {Y.Y} ydocument
   */
  var readEntry = function readEntry(arr, ydocument) {
    return mux(function () {
      return (
        // Y.syncProtocol.readSyncMessage(Y.decoding.createDecoder(arr), Y.encoding.createEncoder(), ydocument)
        util_y.syncProtocol.readSyncMessage(decoding.createDecoder(new Uint8Array(arr)), encoding.createEncoder(), ydocument, null)
      );
    });
  };

  /**
   * @param {any} db
   * @param {string} docName
   * @param {Y.Y} ydocument
   */
  var loadFromPersistence = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(db, docName, ydocument) {
      var records, _iterator, _step, record;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return db.getFromRange("".concat(docName, "#"), "".concat(docName, "#Z"));
            case 2:
              records = _context.sent;
              console.log('has read', records.length, 'from db');
              _iterator = _createForOfIteratorHelper(records);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  record = _step.value;
                  readEntry(record, ydocument);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              console.log('all entries have been read from db');
            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function loadFromPersistence(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
  var persistState = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(db, docName, ydocument) {
      var encoder, entryKeyBefore, entryKey, keys;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              encoder = encoding.createEncoder();
              util_y.syncProtocol.writeSyncStep2(encoder, ydocument, (0,util_y.getEmptyStateSet)());
              entryKeyBefore = generateEntryKey(docName);
              entryKey = generateEntryKey(docName);
              _context2.next = 6;
              return db.getKeysFromRange("".concat(docName, "#"), entryKeyBefore);
            case 6:
              keys = _context2.sent;
              _context2.next = 9;
              return db.put(entryKey, encoding.toBuffer(encoder), ydocument);
            case 9:
              _context2.next = 11;
              return db.delete(keys);
            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function persistState(_x4, _x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }();

  /**
   * Persistence layer for Leveldb.
   */
  return /*#__PURE__*/function () {
    /**
     * @param {string} fpath Path to leveldb database
     */
    function LevelDbPersistence() {
      _classCallCheck(this, LevelDbPersistence);
      this.db = promisifiedDB;
    }
    /**
     * Retrieve all data from LevelDB and automatically persist all document updates to leveldb.
     *
     * @param {string} docName
     * @param {Y.Y} ydocument
     */
    _createClass(LevelDbPersistence, [{
      key: "bindState",
      value: function bindState(docName, ydocument) {
        var _this = this;
        var documentUpdateHandler = function documentUpdateHandler(update, origin, y) {
          var _dbSynced = y._dbSynced;
          var _y$conf = y.conf,
            workspaceId = _y$conf.workspaceId,
            noteId = _y$conf.noteId,
            _y$conf$saveUpdate = _y$conf.saveUpdate,
            saveUpdate = _y$conf$saveUpdate === void 0 ? true : _y$conf$saveUpdate;
          if (window.location.href.indexOf(noteId) < 0) {
            return;
          }
          console.log('syncProtocol.writeUpdate:bindState => workspaceId, noteId', workspaceId, noteId);
          var encoder = encoding.createEncoder();
          util_y.syncProtocol.writeUpdate(encoder, update);
          console.log('writeEntry:bindState => workspaceId, noteId', workspaceId, noteId);
          writeEntry(_this.db, docName, encoding.toUint8Array(encoder), y);
          if (isLocalOrigin(origin) && !saveUpdate) {
            y.conf.saveUpdate = true;
            return;
          }
          if (_dbSynced) {
            if (workspaceId && noteId) {
              window.postMessage({
                eventName: "event:web:editor:note:update:request",
                workspaceId: workspaceId,
                globalId: noteId,
                hasLocalChanges: isLocalOrigin(origin)
              }, "*");
            }
          }
        };
        var documentDateUpdate = function documentDateUpdate(hasLocalChanges, y) {
          var _dbSynced = y._dbSynced,
            _dbInit = y._dbInit;
          var _y$conf2 = y.conf,
            workspaceId = _y$conf2.workspaceId,
            noteId = _y$conf2.noteId;
          if (_dbSynced) {
            if (workspaceId && noteId) {
              // Отправка события чтобы в списке заметок текущая заметка встала в самом верху
              window.postMessage({
                eventName: "event:web:editor:note:update:request",
                workspaceId: workspaceId,
                globalId: noteId,
                hasLocalChanges: hasLocalChanges
              }, "*");
            }
          }
        };

        // в этот массив сохраняем временные апдейты
        var updateArray = [];
        var typing = false;
        var typingStartTime = 0;

        // записывает в базу updateArray
        var saveToDB = function saveToDB(_ref3) {
          var docName = _ref3.docName,
            origin = _ref3.origin,
            workspaceId = _ref3.workspaceId,
            noteId = _ref3.noteId,
            db = _ref3.db,
            y = _ref3.y;
          if (!updateArray.length) return false;
          console.log('syncProtocol.writeUpdate:ydocument.on => update => workspaceId, noteId', workspaceId, noteId);
          var entries = [];
          var hasLocalChanges = false;
          updateArray.forEach(function (update) {
            entries.push({
              key: generateEntryKey(docName),
              update: update,
              origin: origin
            });
            for (var i in entries) {
              var _entries$i = entries[i],
                _origin = _entries$i.origin,
                _update = _entries$i.update;
              if (isLocalOrigin(_origin)) {
                hasLocalChanges = true;
              }
              var encoder = encoding.createEncoder();
              util_y.syncProtocol.writeUpdate(encoder, _update);
              entries[i].buf = encoding.toUint8Array(encoder);
              if (needUpdateOrigin(entries[i])) {
                entries[i].origin = null;
              }
            }
          });
          updateArray = [];
          console.log('writeEntries:ydocument.on => update => workspaceId, noteId', workspaceId, noteId);
          writeEntries(db, entries, y);
          if (!isStyleOrigin(origin)) {
            documentDateUpdate(hasLocalChanges, y);
          }
          typing = false;
        };

        /**
         * Предназначена для автосохранения ввода за определённый интервал времени, если текст вводится долго
         * то происходит запись в базу каждый interval - промежутки времени
         * @param {*} params
         * @param {*} interval 
         */
        var autoSaveTyping = function autoSaveTyping(_ref4, interval) {
          var docName = _ref4.docName,
            origin = _ref4.origin,
            workspaceId = _ref4.workspaceId,
            noteId = _ref4.noteId,
            db = _ref4.db,
            y = _ref4.y;
          if (!typing) {
            typing = true;
            typingStartTime = performance.now();
          }
          if (performance.now() - typingStartTime >= interval) {
            typing = false;
            console.log('auto save');
            saveToDB({
              docName: docName,
              origin: origin,
              workspaceId: workspaceId,
              noteId: noteId,
              db: db,
              y: y
            });
          }
        };

        // дебаунс функция, предназначена для записи в базу 
        var writeDebounce = (0,lodash.debounce)(saveToDB, debounceTimeout, {
          trailing: true
        });

        // write all updates received from other clients
        // - unless it is created by this persistence layer (e.g. loadFromPersistence, we we mux).
        ydocument.on('update', function (update, origin, y) {
          var _dbSynced = y._dbSynced,
            _dbInit = y._dbInit;
          var _y$conf3 = y.conf,
            workspaceId = _y$conf3.workspaceId,
            noteId = _y$conf3.noteId,
            docName = _y$conf3.docName;
          if (!_dbInit) {
            return;
          }
          if (window.location.href.indexOf(noteId) < 0) {
            return;
          }
          updateArray.push(update);
          var params = {
            docName: docName,
            origin: origin,
            workspaceId: workspaceId,
            noteId: noteId,
            db: _this.db,
            y: y
          };
          writeDebounce(params);
          autoSaveTyping(params, typingAutosaveTimeout);
        });
        // read all data from persistence
        return loadFromPersistence(this.db, docName, ydocument);
      }
      /**
       * Write current state to persistence layer. Deletes all entries that were made before.
       * Call this method at any time - the recommended time to call this method is before the ydocument is destroyed.
       *
       * @param {string} docName
       * @param {Y.Y} ydocument
       */
    }, {
      key: "writeState",
      value: function writeState(docName, ydocument) {
        return persistState(this.db, docName, ydocument);
      }

      /**
       * @param {string} docName
       * @param {Y.Y} ydocument
       */
    }, {
      key: "readState",
      value: function readState(docName, ydocument) {
        // read all data from persistence
        return loadFromPersistence(this.db, docName, ydocument);
      }
    }]);
    return LevelDbPersistence;
  }();
}

/***/ }),

/***/ 94166:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ isOnline)
/* harmony export */ });
/**
 * Проверка на onLine
 * @returns {Boolean}
 */
function isOnline() {
  return navigator && navigator.onLine;
}

/***/ }),

/***/ 31900:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "initGetNoteSyncStatus": () => (/* binding */ initGetNoteSyncStatus),
/* harmony export */   "initSetNoteSyncStatus": () => (/* binding */ initSetNoteSyncStatus),
/* harmony export */   "getNoteSyncStatus": () => (/* binding */ getNoteSyncStatus),
/* harmony export */   "setNoteSyncStatus": () => (/* binding */ setNoteSyncStatus)
/* harmony export */ });
var syncedNotes = {};
var initGetNoteSyncStatus = function initGetNoteSyncStatus() {
  window.textEditor.getNoteSynced = getNoteSyncStatus;
};

/**
 * @param {Function} callback
 */
var initSetNoteSyncStatus = function initSetNoteSyncStatus() {
  var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  window.textEditor.setNoteSynced = function (noteId, syncStatus) {
    setNoteSyncStatus(noteId, syncStatus);
    callback(noteId, syncStatus);
  };
};
var getNoteSyncStatus = function getNoteSyncStatus(noteId) {
  return typeof syncedNotes[noteId] !== 'undefined' && syncedNotes[noteId];
};

/**
 * @param {string} noteId
 * @param {boolean} syncStatus
 */
var setNoteSyncStatus = function setNoteSyncStatus(noteId, syncStatus) {
  if (!noteId) {
    return;
  }
  if (!syncStatus) {
    return;
  }
  syncedNotes[noteId] = syncStatus;
};

/***/ }),

/***/ 37167:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ onAfterPersistenceBindState)
/* harmony export */ });
/* harmony import */ var _isOnline__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94166);

function onAfterPersistenceBindState(doc) {
  doc._dbInit = true;
  // @ts-ignore
  if ((0,_isOnline__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)()) {
    // для обновления даты заметки в online режиме
    // ждем когда сработает событие synced иначе если сразу сделать doc._dbSynced = true то все открытые
    // заметки будет автоматичеки попадать на верх списка заметок
    doc.on('synced', function () {
      doc._dbSynced = true;
    });
  } else {
    // если в offline режиме
    doc._dbSynced = true;
  }
}

/***/ }),

/***/ 85921:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getUpdateOrigin": () => (/* binding */ getUpdateOrigin),
/* harmony export */   "isLocalOrigin": () => (/* binding */ isLocalOrigin),
/* harmony export */   "isStyleOrigin": () => (/* binding */ isStyleOrigin),
/* harmony export */   "isRemoteOrigin": () => (/* binding */ isRemoteOrigin)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_6__);







function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
var getUpdateOrigin = function getUpdateOrigin(origin) {
  return isLocalOrigin(origin) ? null : origin;
};
var isLocalOrigin = function isLocalOrigin(origin) {
  return !(isRemoteOrigin(origin) || isStyleOrigin(origin));
};
var isStyleOrigin = function isStyleOrigin(origin) {
  return origin && _typeof(origin) === 'object' && origin.action === 'setStyle';
};
var isRemoteOrigin = function isRemoteOrigin(origin) {
  return origin && origin === 'remote';
};

/***/ }),

/***/ 35130:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(19601);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
module.exports = desvg;

/**
 * @name desvg
 * @summary Generate component using passed svg-loader output.
 *
 * @description
 * Generate component using passed svg-loader output.
 *
 * @param {Function} h
 * The helper function (e.g. `React.createElement` or Preact's `h`).
 *
 * @param {Object} svg
 * The svg-loader output.
 *
 * @returns {Object}
 * The generated component.
 *
 * @example
 * import { createElement } from 'react'
 * import svgContent from './icon.svg'
 * import desvg from 'desvg'
 *
 * // Basic usage
 * const Icon = desvg(createElement, svgContent)
 * <Icon fill='currentColor' />
 * //=> <svg fill='currentColor' ...>...</svg>
 */
function desvg(h, svg) {
  var content = svg.content;
  var attributes = svg.attributes;
  return /*#__PURE__*/function () {
    function _class() {
      _classCallCheck(this, _class);
    }
    _createClass(_class, [{
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate() {
        return false;
      }
    }, {
      key: "render",
      value: function render() {
        var props = this.props;
        return h('svg', Object.assign({
          dangerouslySetInnerHTML: {
            __html: content
          }
        }, attributes, props), props && props.children);
      }
    }]);
    return _class;
  }();
}

/***/ }),

/***/ 5813:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var desvg = __webpack_require__(35130);
var h = __webpack_require__(79758).h;
module.exports = desvg.bind(null, h);

/***/ }),

/***/ 95148:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
__webpack_require__(68309);
__webpack_require__(30489);
__webpack_require__(41539);
__webpack_require__(17727);
__webpack_require__(39714);
__webpack_require__(12419);
__webpack_require__(66992);
__webpack_require__(51532);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(47042);
__webpack_require__(91038);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var CancelError = /*#__PURE__*/function (_Error) {
  _inherits(CancelError, _Error);
  var _super = _createSuper(CancelError);
  function CancelError(reason) {
    var _this;
    _classCallCheck(this, CancelError);
    _this = _super.call(this, reason || 'Promise was canceled');
    _this.name = 'CancelError';
    return _this;
  }
  _createClass(CancelError, [{
    key: "isCanceled",
    get: function get() {
      return true;
    }
  }]);
  return CancelError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
var PCancelable = /*#__PURE__*/function () {
  function PCancelable(executor) {
    var _this2 = this;
    _classCallCheck(this, PCancelable);
    this._cancelHandlers = [];
    this._isPending = true;
    this._isCanceled = false;
    this._rejectOnCancel = true;
    this._promise = new Promise(function (resolve, reject) {
      _this2._reject = reject;
      var onResolve = function onResolve(value) {
        if (!_this2._isCanceled || !onCancel.shouldReject) {
          _this2._isPending = false;
          resolve(value);
        }
      };
      var onReject = function onReject(error) {
        _this2._isPending = false;
        reject(error);
      };
      var onCancel = function onCancel(handler) {
        if (!_this2._isPending) {
          throw new Error('The `onCancel` handler was attached after the promise settled.');
        }
        _this2._cancelHandlers.push(handler);
      };
      Object.defineProperties(onCancel, {
        shouldReject: {
          get: function get() {
            return _this2._rejectOnCancel;
          },
          set: function set(boolean) {
            _this2._rejectOnCancel = boolean;
          }
        }
      });
      return executor(onResolve, onReject, onCancel);
    });
  }
  _createClass(PCancelable, [{
    key: "then",
    value: function then(onFulfilled, onRejected) {
      // eslint-disable-next-line promise/prefer-await-to-then
      return this._promise.then(onFulfilled, onRejected);
    }
  }, {
    key: "catch",
    value: function _catch(onRejected) {
      return this._promise.catch(onRejected);
    }
  }, {
    key: "finally",
    value: function _finally(onFinally) {
      return this._promise.finally(onFinally);
    }
  }, {
    key: "cancel",
    value: function cancel(reason) {
      if (!this._isPending || this._isCanceled) {
        return;
      }
      this._isCanceled = true;
      if (this._cancelHandlers.length > 0) {
        try {
          var _iterator = _createForOfIteratorHelper(this._cancelHandlers),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var handler = _step.value;
              handler();
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } catch (error) {
          this._reject(error);
          return;
        }
      }
      if (this._rejectOnCancel) {
        this._reject(new CancelError(reason));
      }
    }
  }, {
    key: "isCanceled",
    get: function get() {
      return this._isCanceled;
    }
  }], [{
    key: "fn",
    value: function fn(userFn) {
      return function () {
        for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
          arguments_[_key] = arguments[_key];
        }
        return new PCancelable(function (resolve, reject, onCancel) {
          arguments_.push(onCancel);
          // eslint-disable-next-line promise/prefer-await-to-then
          userFn.apply(void 0, arguments_).then(resolve, reject);
        });
      };
    }
  }]);
  return PCancelable;
}();
Object.setPrototypeOf(PCancelable.prototype, Promise.prototype);
module.exports = PCancelable;
module.exports.CancelError = CancelError;

/***/ }),

/***/ 26074:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;__webpack_require__(68309);
__webpack_require__(69826);
__webpack_require__(91038);
__webpack_require__(78783);
__webpack_require__(21249);
__webpack_require__(54747);
__webpack_require__(66992);
__webpack_require__(41539);
__webpack_require__(33948);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(47042);
__webpack_require__(9653);
__webpack_require__(92222);
__webpack_require__(23123);
__webpack_require__(2707);
__webpack_require__(57327);
__webpack_require__(39714);
__webpack_require__(47941);
__webpack_require__(69600);
__webpack_require__(73210);
__webpack_require__(4723);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
(function webpackUniversalModuleDefinition(root, factory) {
  if (( false ? 0 : _typeof(exports)) === 'object' && ( false ? 0 : _typeof(module)) === 'object') module.exports = factory();else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {}
})(typeof self !== 'undefined' ? self : this, function () {
  return (/******/function (modules) {
      // webpackBootstrap
      /******/ // The module cache
      /******/
      var installedModules = {};
      /******/
      /******/ // The require function
      /******/
      function __nested_webpack_require_2357__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
          /******/return installedModules[moduleId].exports;
          /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
          /******/i: moduleId,
          /******/l: false,
          /******/exports: {}
          /******/
        };
        /******/
        /******/ // Execute the module function
        /******/
        modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_2357__);
        /******/
        /******/ // Flag the module as loaded
        /******/
        module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/
        return module.exports;
        /******/
      }
      /******/
      /******/
      /******/ // expose the modules object (__webpack_modules__)
      /******/
      __nested_webpack_require_2357__.m = modules;
      /******/
      /******/ // expose the module cache
      /******/
      __nested_webpack_require_2357__.c = installedModules;
      /******/
      /******/ // define getter function for harmony exports
      /******/
      __nested_webpack_require_2357__.d = function (exports, name, getter) {
        /******/if (!__nested_webpack_require_2357__.o(exports, name)) {
          /******/Object.defineProperty(exports, name, {
            /******/configurable: false,
            /******/enumerable: true,
            /******/get: getter
            /******/
          });
          /******/
        }
        /******/
      };
      /******/
      /******/ // getDefaultExport function for compatibility with non-harmony modules
      /******/
      __nested_webpack_require_2357__.n = function (module) {
        /******/var getter = module && module.__esModule ? /******/function getDefault() {
          return module['default'];
        } : /******/function getModuleExports() {
          return module;
        };
        /******/
        __nested_webpack_require_2357__.d(getter, 'a', getter);
        /******/
        return getter;
        /******/
      };
      /******/
      /******/ // Object.prototype.hasOwnProperty.call
      /******/
      __nested_webpack_require_2357__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/
      /******/ // __webpack_public_path__
      /******/
      __nested_webpack_require_2357__.p = "";
      /******/
      /******/ // Load entry module and return exports
      /******/
      return __nested_webpack_require_2357__(__nested_webpack_require_2357__.s = 9);
      /******/
    }([
      /* 0 */
      /***/

      /* 1 */
      /***/

      /* 2 */
      /***/

      /* 3 */
      /***/

      /* 4 */
      /***/

      /* 5 */
      /***/

      /* 6 */
      /***/

      /* 7 */
      /***/

      /* 8 */
      /***/

      /* 9 */
      /***/

      /* 10 */
      /***/

      /* 11 */
      /***/

      /* 12 */
      /***/

      /* 13 */
      /***/

      /* 14 */
      /***/

      /* 15 */
      /***/

      /* 16 */
      /***/

      /******/function (module, exports, __webpack_require__) {
      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var ParchmentError = function (_super) {
        __extends(ParchmentError, _super);
        function ParchmentError(message) {
          var _this = this;
          message = '[Parchment] ' + message;
          _this = _super.call(this, message) || this;
          _this.message = message;
          _this.name = _this.constructor.name;
          return _this;
        }
        return ParchmentError;
      }(Error);
      exports.ParchmentError = ParchmentError;
      var attributes = {};
      var classes = {};
      var tags = {};
      var types = {};
      var findByTagFn = function findByTagFn() {};
      exports.DATA_KEY = '__blot';
      var Scope;
      (function (Scope) {
        Scope[Scope["TYPE"] = 3] = "TYPE";
        Scope[Scope["LEVEL"] = 12] = "LEVEL";
        Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
        Scope[Scope["BLOT"] = 14] = "BLOT";
        Scope[Scope["INLINE"] = 7] = "INLINE";
        Scope[Scope["BLOCK"] = 11] = "BLOCK";
        Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
        Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
        Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
        Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
        Scope[Scope["ANY"] = 15] = "ANY";
      })(Scope = exports.Scope || (exports.Scope = {}));
      function create(input, value) {
        var match = query(input);
        if (match == null) {
          throw new ParchmentError("Unable to create " + input + " blot");
        }
        var BlotClass = match;
        var node =
        // @ts-ignore
        input instanceof Node || input['nodeType'] === Node.TEXT_NODE ? input : BlotClass.create(value);
        return new BlotClass(node, value);
      }
      exports.create = create;
      function find(node, bubble) {
        if (bubble === void 0) {
          bubble = false;
        }
        if (node == null) return null;
        // @ts-ignore
        if (node[exports.DATA_KEY] != null) return node[exports.DATA_KEY].blot;
        if (bubble) return find(node.parentNode, bubble);
        return null;
      }
      exports.find = find;
      function query(query, scope) {
        if (scope === void 0) {
          scope = Scope.ANY;
        }
        var match;
        if (typeof query === 'string') {
          match = types[query] || attributes[query];
          // @ts-ignore
        } else if (query instanceof Text || query['nodeType'] === Node.TEXT_NODE) {
          match = types['text'];
        } else if (typeof query === 'number') {
          if (query & Scope.LEVEL & Scope.BLOCK) {
            match = types['block'];
          } else if (query & Scope.LEVEL & Scope.INLINE) {
            match = types['inline'];
          }
        } else if (query instanceof HTMLElement) {
          var names = Array.from(query.classList);
          for (var i in names) {
            match = classes[names[i]];
            if (match) break;
          }
          match = match || findByTagFn(query.tagName, query) || tags[query.tagName];
        }
        if (match == null) return null;
        // @ts-ignore
        if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope) return match;
        return null;
      }
      exports.query = query;
      function register() {
        var Definitions = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          Definitions[_i] = arguments[_i];
        }
        if (Definitions.length > 1) {
          return Definitions.map(function (d) {
            return register(d);
          });
        }
        var Definition = Definitions[0];
        if (typeof Definition.blotName !== 'string' && typeof Definition.attrName !== 'string') {
          throw new ParchmentError('Invalid definition');
        } else if (Definition.blotName === 'abstract') {
          throw new ParchmentError('Cannot register abstract class');
        }
        types[Definition.blotName || Definition.attrName] = Definition;
        if (typeof Definition.keyName === 'string') {
          attributes[Definition.keyName] = Definition;
        } else {
          if (Definition.className != null) {
            classes[Definition.className] = Definition;
          }
          if (Definition.tagName != null) {
            if (Array.isArray(Definition.tagName)) {
              Definition.tagName = Definition.tagName.map(function (tagName) {
                return tagName.toUpperCase();
              });
            } else {
              Definition.tagName = Definition.tagName.toUpperCase();
            }
            var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [Definition.tagName];
            tagNames.forEach(function (tag) {
              if (tags[tag] == null || Definition.className == null) {
                tags[tag] = Definition;
              }
            });
          }
        }
        return Definition;
      }
      exports.register = register;
      function attachOnce(blot) {
        blot.ensureScrollIsAssigned();
        if (blot._isAttached || blot._isAttaching) {
          return;
        }
        blot._isAttaching = true;
        blot.attach();
        blot._isAttaching = false;
        blot._isDetached = false;
        blot._isAttached = true;
      }
      exports.attachOnce = attachOnce;
      function detachOnce(blot) {
        if (blot._isDetached || blot._isDetaching) {
          return;
        }
        blot._isDetaching = true;
        blot.detach();
        blot._isDetaching = false;
        blot._isDetached = true;
        blot._isAttached = false;
      }
      exports.detachOnce = detachOnce;
      function setFindByTagFn(fn) {
        findByTagFn = fn;
      }
      exports.setFindByTagFn = setFindByTagFn;

      /***/
    }, function (module, exports, __nested_webpack_require_12066__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var Registry = __nested_webpack_require_12066__(0);
      var Attributor = function () {
        function Attributor(attrName, keyName, options) {
          if (options === void 0) {
            options = {};
          }
          this.attrName = attrName;
          this.keyName = keyName;
          var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
          if (options.scope != null) {
            // Ignore type bits, force attribute bit
            this.scope = options.scope & Registry.Scope.LEVEL | attributeBit;
          } else {
            this.scope = Registry.Scope.ATTRIBUTE;
          }
          if (options.whitelist != null) this.whitelist = options.whitelist;
        }
        Attributor.keys = function (node) {
          return [].map.call(node.attributes, function (item) {
            return item.name;
          });
        };
        Attributor.prototype.add = function (node, value) {
          if (!this.canAdd(node, value)) return false;
          node.setAttribute(this.keyName, value);
          return true;
        };
        Attributor.prototype.canAdd = function (node, value) {
          var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
          if (match == null) return false;
          if (this.whitelist == null) return true;
          if (typeof value === 'string') {
            return this.whitelist.indexOf(value.replace(/["']/g, '')) > -1;
          } else {
            return this.whitelist.indexOf(value) > -1;
          }
        };
        Attributor.prototype.remove = function (node) {
          node.removeAttribute(this.keyName);
        };
        Attributor.prototype.value = function (node) {
          var value = node.getAttribute(this.keyName);
          if (this.canAdd(node, value) && value) {
            return value;
          }
          return '';
        };
        return Attributor;
      }();
      exports.default = Attributor;

      /***/
    }, function (module, exports, __nested_webpack_require_14195__) {
      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var linked_list_1 = __nested_webpack_require_14195__(11);
      var shadow_1 = __nested_webpack_require_14195__(5);
      var Registry = __nested_webpack_require_14195__(0);
      var ContainerBlot = function (_super) {
        __extends(ContainerBlot, _super);
        function ContainerBlot(domNode) {
          var _this = _super.call(this, domNode) || this;
          _this.build();
          return _this;
        }
        ContainerBlot.prototype.appendChild = function (other) {
          this.insertBefore(other);
        };
        ContainerBlot.prototype.ensureScrollIsAssigned = function () {
          _super.prototype.ensureScrollIsAssigned.call(this);
          this.children.forEach(function (child) {
            child.ensureScrollIsAssigned();
          });
        };
        ContainerBlot.prototype.attach = function () {
          _super.prototype.attach.call(this);
          this.children.forEach(function (child) {
            Registry.attachOnce(child);
          });
        };
        ContainerBlot.prototype.build = function () {
          var _this = this;
          this.children = new linked_list_1.default();
          // Need to be reversed for if DOM nodes already in order
          [].slice.call(this.domNode.childNodes).reverse().forEach(function (node) {
            try {
              var child = makeBlot(node);
              _this.insertBefore(child, _this.children.head || undefined);
            } catch (err) {
              if (err instanceof Registry.ParchmentError) return;else throw err;
            }
          });
        };
        ContainerBlot.prototype.deleteAt = function (index, length) {
          if (index === 0 && length === this.length()) {
            return this.remove();
          }
          this.children.forEachAt(index, length, function (child, offset, length) {
            child.deleteAt(offset, length);
          });
        };
        ContainerBlot.prototype.descendant = function (criteria, index) {
          var _a = this.children.find(index),
            child = _a[0],
            offset = _a[1];
          if (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) {
            return [child, offset];
          } else if (child instanceof ContainerBlot) {
            return child.descendant(criteria, offset);
          } else {
            return [null, -1];
          }
        };
        ContainerBlot.prototype.descendants = function (criteria, index, length) {
          if (index === void 0) {
            index = 0;
          }
          if (length === void 0) {
            length = Number.MAX_VALUE;
          }
          var descendants = [];
          var lengthLeft = length;
          this.children.forEachAt(index, length, function (child, index, length) {
            if (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) {
              descendants.push(child);
            }
            if (child instanceof ContainerBlot) {
              descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
            }
            lengthLeft -= length;
          });
          return descendants;
        };
        ContainerBlot.prototype.detach = function () {
          this.children.forEach(function (child) {
            child.detach();
          });
          _super.prototype.detach.call(this);
        };
        ContainerBlot.prototype.formatAt = function (index, length, name, value) {
          this.children.forEachAt(index, length, function (child, offset, length) {
            child.formatAt(offset, length, name, value);
          });
        };
        ContainerBlot.prototype.insertAt = function (index, value, def) {
          var _a = this.children.find(index),
            child = _a[0],
            offset = _a[1];
          if (child) {
            child.insertAt(offset, value, def);
          } else {
            var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
            this.appendChild(blot);
          }
        };
        ContainerBlot.prototype.insertBefore = function (childBlot, refBlot) {
          if (this.statics.allowedChildren != null && !this.statics.allowedChildren.some(function (child) {
            return childBlot instanceof child;
          })) {
            throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
          }
          childBlot.insertInto(this, refBlot);
        };
        ContainerBlot.prototype.length = function () {
          return this.children.reduce(function (memo, child) {
            return memo + child.length();
          }, 0);
        };
        ContainerBlot.prototype.moveChildren = function (targetParent, refNode) {
          this.children.forEach(function (child) {
            targetParent.insertBefore(child, refNode);
          });
        };
        ContainerBlot.prototype.optimize = function (context) {
          _super.prototype.optimize.call(this, context);
          if (this.children.length === 0) {
            if (this.statics.defaultChild != null) {
              var child = Registry.create(this.statics.defaultChild);
              this.appendChild(child);
              child.optimize(context);
            } else {
              this.remove();
            }
          }
        };
        ContainerBlot.prototype.path = function (index, inclusive) {
          if (inclusive === void 0) {
            inclusive = false;
          }
          var _a = this.children.find(index, inclusive),
            child = _a[0],
            offset = _a[1];
          var position = [[this, index]];
          if (child instanceof ContainerBlot) {
            return position.concat(child.path(offset, inclusive));
          } else if (child != null) {
            position.push([child, offset]);
          }
          return position;
        };
        ContainerBlot.prototype.removeChild = function (child) {
          this.children.remove(child);
        };
        ContainerBlot.prototype.replace = function (target) {
          if (target instanceof ContainerBlot) {
            target.moveChildren(this);
          }
          _super.prototype.replace.call(this, target);
        };
        ContainerBlot.prototype.split = function (index, force) {
          if (force === void 0) {
            force = false;
          }
          if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
          }
          var after = this.clone();
          this.parent.insertBefore(after, this.next);
          this.children.forEachAt(index, this.length(), function (child, offset, length) {
            child = child.split(offset, force);
            after.appendChild(child);
          });
          return after;
        };
        ContainerBlot.prototype.unwrap = function () {
          this.moveChildren(this.parent, this.next);
          this.remove();
        };
        ContainerBlot.prototype.update = function (mutations, context) {
          var _this = this;
          var addedNodes = [];
          var removedNodes = [];
          mutations.forEach(function (mutation) {
            if (mutation.target === _this.domNode && mutation.type === 'childList') {
              addedNodes.push.apply(addedNodes, mutation.addedNodes);
              removedNodes.push.apply(removedNodes, mutation.removedNodes);
            }
          });
          removedNodes.forEach(function (node) {
            // Check node has actually been removed
            // One exception is Chrome does not immediately remove IFRAMEs
            // from DOM but MutationRecord is correct in its reported removal
            if (node.parentNode != null &&
            // @ts-ignore
            node.tagName !== 'IFRAME' && document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
              return;
            }
            var blot = Registry.find(node);
            if (blot == null) return;
            if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) {
              if (blot.isAttached()) {
                blot.detach();
              }
            }
          });
          addedNodes.filter(function (node) {
            return node.parentNode == _this.domNode;
          }).sort(function (a, b) {
            if (a === b) return 0;
            if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) {
              return 1;
            }
            return -1;
          }).forEach(function (node) {
            var refBlot = null;
            if (node.nextSibling != null) {
              refBlot = Registry.find(node.nextSibling);
            }
            var blot = makeBlot(node);
            if (blot.next != refBlot || blot.next == null) {
              if (blot.parent != null) {
                blot.parent.removeChild(_this);
              }
              _this.insertBefore(blot, refBlot || undefined);
            }
          });
        };
        return ContainerBlot;
      }(shadow_1.default);
      function makeBlot(node) {
        var blot = Registry.find(node);
        if (blot == null) {
          try {
            blot = Registry.create(node);
          } catch (e) {
            blot = Registry.create(Registry.Scope.INLINE);
            [].slice.call(node.childNodes).forEach(function (child) {
              // @ts-ignore
              blot.domNode.appendChild(child);
            });
            if (node.parentNode) {
              node.parentNode.replaceChild(blot.domNode, node);
            }
            Registry.attachOnce(blot);
          }
        }
        return blot;
      }
      exports.default = ContainerBlot;

      /***/
    }, function (module, exports, __nested_webpack_require_24735__) {
      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var attributor_1 = __nested_webpack_require_24735__(1);
      var store_1 = __nested_webpack_require_24735__(6);
      var container_1 = __nested_webpack_require_24735__(2);
      var Registry = __nested_webpack_require_24735__(0);
      var FormatBlot = function (_super) {
        __extends(FormatBlot, _super);
        function FormatBlot(domNode) {
          var _this = _super.call(this, domNode) || this;
          _this.attributes = new store_1.default(_this.domNode);
          return _this;
        }
        FormatBlot.formats = function (domNode) {
          if (typeof this.tagName === 'string') {
            return true;
          } else if (Array.isArray(this.tagName)) {
            return domNode.tagName.toLowerCase();
          }
          return undefined;
        };
        FormatBlot.prototype.format = function (name, value) {
          var format = Registry.query(name);
          if (format instanceof attributor_1.default) {
            this.attributes.attribute(format, value);
          } else if (value) {
            if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) {
              this.replaceWith(name, value);
            }
          }
        };
        FormatBlot.prototype.formats = function () {
          var formats = this.attributes.values();
          var format = this.statics.formats(this.domNode);
          if (format != null) {
            formats[this.statics.blotName] = format;
          }
          return formats;
        };
        FormatBlot.prototype.replaceWith = function (name, value) {
          var replacement = _super.prototype.replaceWith.call(this, name, value);
          this.attributes.copy(replacement);
          return replacement;
        };
        FormatBlot.prototype.update = function (mutations, context) {
          var _this = this;
          _super.prototype.update.call(this, mutations, context);
          if (mutations.some(function (mutation) {
            return mutation.target === _this.domNode && mutation.type === 'attributes';
          })) {
            this.attributes.build();
          }
        };
        FormatBlot.prototype.wrap = function (name, value) {
          var wrapper = _super.prototype.wrap.call(this, name, value);
          if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) {
            this.attributes.move(wrapper);
          }
          return wrapper;
        };
        return FormatBlot;
      }(container_1.default);
      exports.default = FormatBlot;

      /***/
    }, function (module, exports, __nested_webpack_require_28011__) {
      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var shadow_1 = __nested_webpack_require_28011__(5);
      var Registry = __nested_webpack_require_28011__(0);
      var LeafBlot = function (_super) {
        __extends(LeafBlot, _super);
        function LeafBlot() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        LeafBlot.value = function (domNode) {
          return true;
        };
        LeafBlot.prototype.index = function (node, offset) {
          if (this.domNode === node || this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return Math.min(offset, 1);
          }
          return -1;
        };
        LeafBlot.prototype.position = function (index, inclusive) {
          var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
          if (index > 0) offset += 1;
          return [this.parent.domNode, offset];
        };
        LeafBlot.prototype.value = function () {
          var _a;
          return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
        };
        LeafBlot.scope = Registry.Scope.INLINE_BLOT;
        return LeafBlot;
      }(shadow_1.default);
      exports.default = LeafBlot;

      /***/
    }, function (module, exports, __nested_webpack_require_29987__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var Registry = __nested_webpack_require_29987__(0);
      var ShadowBlot = function () {
        function ShadowBlot(domNode) {
          this.domNode = domNode;
          this._isAttached = false;
          this._isAttaching = false;
          this._isDetached = true;
          this._isDetaching = false;
          // @ts-ignore
          this.domNode[Registry.DATA_KEY] = {
            blot: this
          };
        }
        Object.defineProperty(ShadowBlot.prototype, "statics", {
          // Hack for accessing inherited static methods
          get: function get() {
            return this.constructor;
          },
          enumerable: true,
          configurable: true
        });
        ShadowBlot.create = function (value) {
          if (this.tagName == null) {
            throw new Registry.ParchmentError('Blot definition missing tagName');
          }
          var node;
          if (Array.isArray(this.tagName)) {
            if (typeof value === 'string') {
              value = value.toUpperCase();
              if (parseInt(value).toString() === value) {
                value = parseInt(value);
              }
            }
            if (typeof value === 'number') {
              node = document.createElement(this.tagName[value - 1]);
            } else if (this.tagName.indexOf(value) > -1) {
              node = document.createElement(value);
            } else {
              node = document.createElement(this.tagName[0]);
            }
          } else {
            node = document.createElement(this.tagName);
          }
          if (this.className) {
            node.classList.add(this.className);
          }
          return node;
        };
        ShadowBlot.prototype.isAttached = function () {
          return this._isAttached;
        };
        ShadowBlot.prototype.attach = function () {};
        ShadowBlot.prototype.ensureScrollIsAssigned = function () {
          if (this.parent != null) {
            this.scroll = this.parent.scroll;
          }
        };
        ShadowBlot.prototype.clone = function () {
          var domNode = this.domNode.cloneNode(false);
          return Registry.create(domNode);
        };
        ShadowBlot.prototype.detach = function () {
          if (this.parent != null) this.parent.removeChild(this);
          // @ts-ignore
          delete this.domNode[Registry.DATA_KEY];
        };
        ShadowBlot.prototype.deleteAt = function (index, length) {
          var blot = this.isolate(index, length);
          blot.remove();
        };
        ShadowBlot.prototype.formatAt = function (index, length, name, value) {
          var blot = this.isolate(index, length);
          if (Registry.query(name, Registry.Scope.BLOT) != null && value) {
            blot.wrap(name, value);
          } else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
            var parent_1 = Registry.create(this.statics.scope);
            blot.wrap(parent_1);
            parent_1.format(name, value);
          }
        };
        ShadowBlot.prototype.insertAt = function (index, value, def) {
          var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
          var ref = this.split(index);
          this.parent.insertBefore(blot, ref);
        };
        ShadowBlot.prototype.insertInto = function (parentBlot, refBlot) {
          if (refBlot === void 0) {
            refBlot = null;
          }
          if (this.parent != null) {
            this.parent.children.remove(this);
          }
          var refDomNode = null;
          parentBlot.children.insertBefore(this, refBlot);
          if (refBlot != null) {
            refDomNode = refBlot.domNode;
          }
          if (this.domNode.parentNode != parentBlot.domNode || this.domNode.nextSibling != refDomNode) {
            parentBlot.domNode.insertBefore(this.domNode, refDomNode);
          }
          this.parent = parentBlot;
          Registry.attachOnce(this);
        };
        ShadowBlot.prototype.isolate = function (index, length) {
          var target = this.split(index);
          target.split(length);
          return target;
        };
        ShadowBlot.prototype.length = function () {
          return 1;
        };
        ShadowBlot.prototype.offset = function (root) {
          if (root === void 0) {
            root = this.parent;
          }
          if (this.parent == null || this == root) return 0;
          return this.parent.children.offset(this) + this.parent.offset(root);
        };
        ShadowBlot.prototype.optimize = function (context) {
          // TODO clean up once we use WeakMap
          // @ts-ignore
          if (this.domNode[Registry.DATA_KEY] != null) {
            // @ts-ignore
            delete this.domNode[Registry.DATA_KEY].mutations;
          }
        };
        ShadowBlot.prototype.remove = function () {
          if (this.domNode.parentNode != null) {
            this.domNode.parentNode.removeChild(this.domNode);
          }
          this.detach();
        };
        ShadowBlot.prototype.replace = function (target) {
          if (target.parent == null) return;
          target.parent.insertBefore(this, target.next);
          target.remove();
        };
        ShadowBlot.prototype.replaceWith = function (name, value) {
          var replacement = typeof name === 'string' ? Registry.create(name, value) : name;
          replacement.replace(this);
          return replacement;
        };
        ShadowBlot.prototype.split = function (index, force) {
          return index === 0 ? this : this.next;
        };
        ShadowBlot.prototype.update = function (mutations, context) {
          // Nothing to do by default
        };
        ShadowBlot.prototype.wrap = function (name, value) {
          var wrapper = typeof name === 'string' ? Registry.create(name, value) : name;
          if (this.parent != null) {
            this.parent.insertBefore(wrapper, this.next);
          }
          wrapper.appendChild(this);
          return wrapper;
        };
        ShadowBlot.blotName = 'abstract';
        return ShadowBlot;
      }();
      exports.default = ShadowBlot;

      /***/
    }, function (module, exports, __nested_webpack_require_36320__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var attributor_1 = __nested_webpack_require_36320__(1);
      var class_1 = __nested_webpack_require_36320__(7);
      var style_1 = __nested_webpack_require_36320__(8);
      var Registry = __nested_webpack_require_36320__(0);
      var AttributorStore = function () {
        function AttributorStore(domNode) {
          this.attributes = {};
          this.domNode = domNode;
          this.build();
        }
        AttributorStore.prototype.attribute = function (attribute, value) {
          // verb
          if (value) {
            if (attribute.add(this.domNode, value)) {
              if (attribute.value(this.domNode) != null) {
                this.attributes[attribute.attrName] = attribute;
              } else {
                delete this.attributes[attribute.attrName];
              }
            }
          } else {
            attribute.remove(this.domNode);
            delete this.attributes[attribute.attrName];
          }
        };
        AttributorStore.prototype.build = function () {
          var _this = this;
          this.attributes = {};
          var attributes = attributor_1.default.keys(this.domNode);
          var classes = class_1.default.keys(this.domNode);
          var styles = style_1.default.keys(this.domNode);
          attributes.concat(classes).concat(styles).forEach(function (name) {
            var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
            if (attr instanceof attributor_1.default) {
              _this.attributes[attr.attrName] = attr;
            }
          });
        };
        AttributorStore.prototype.copy = function (target) {
          var _this = this;
          Object.keys(this.attributes).forEach(function (key) {
            var value = _this.attributes[key].value(_this.domNode);
            target.format(key, value);
          });
        };
        AttributorStore.prototype.move = function (target) {
          var _this = this;
          this.copy(target);
          Object.keys(this.attributes).forEach(function (key) {
            _this.attributes[key].remove(_this.domNode);
          });
          this.attributes = {};
        };
        AttributorStore.prototype.values = function () {
          var _this = this;
          return Object.keys(this.attributes).reduce(function (attributes, name) {
            attributes[name] = _this.attributes[name].value(_this.domNode);
            return attributes;
          }, {});
        };
        return AttributorStore;
      }();
      exports.default = AttributorStore;

      /***/
    }, function (module, exports, __nested_webpack_require_38982__) {
      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var attributor_1 = __nested_webpack_require_38982__(1);
      function match(node, prefix) {
        return Array.from(node.classList).filter(function (name) {
          return name.indexOf(prefix + "-") === 0;
        });
      }
      var ClassAttributor = function (_super) {
        __extends(ClassAttributor, _super);
        function ClassAttributor() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        ClassAttributor.keys = function (node) {
          return (node.getAttribute('class') || '').split(/\s+/).map(function (name) {
            return name.split('-').slice(0, -1).join('-');
          });
        };
        ClassAttributor.prototype.add = function (node, value) {
          if (!this.canAdd(node, value)) return false;
          this.remove(node);
          node.classList.add(this.keyName + "-" + value);
          return true;
        };
        ClassAttributor.prototype.remove = function (node) {
          var matches = match(node, this.keyName);
          matches.forEach(function (name) {
            node.classList.remove(name);
          });
          if (node.classList.length === 0) {
            node.removeAttribute('class');
          }
        };
        ClassAttributor.prototype.value = function (node) {
          var result = match(node, this.keyName)[0] || '';
          var value = result.slice(this.keyName.length + 1); // +1 for hyphen
          return this.canAdd(node, value) ? value : '';
        };
        return ClassAttributor;
      }(attributor_1.default);
      exports.default = ClassAttributor;

      /***/
    }, function (module, exports, __nested_webpack_require_41348__) {
      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var attributor_1 = __nested_webpack_require_41348__(1);
      function camelize(name) {
        var parts = name.split('-');
        var rest = parts.slice(1).map(function (part) {
          return part[0].toUpperCase() + part.slice(1);
        }).join('');
        return parts[0] + rest;
      }
      var StyleAttributor = function (_super) {
        __extends(StyleAttributor, _super);
        function StyleAttributor() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        StyleAttributor.keys = function (node) {
          return (node.getAttribute('style') || '').split(';').map(function (value) {
            var arr = value.split(':');
            return arr[0].trim();
          });
        };
        StyleAttributor.prototype.add = function (node, value) {
          if (!this.canAdd(node, value)) return false;
          // @ts-ignore
          node.style[camelize(this.keyName)] = value;
          return true;
        };
        StyleAttributor.prototype.remove = function (node) {
          // @ts-ignore
          node.style[camelize(this.keyName)] = '';
          if (!node.getAttribute('style')) {
            node.removeAttribute('style');
          }
        };
        StyleAttributor.prototype.value = function (node) {
          // @ts-ignore
          var value = node.style[camelize(this.keyName)];
          return this.canAdd(node, value) ? value : '';
        };
        return StyleAttributor;
      }(attributor_1.default);
      exports.default = StyleAttributor;

      /***/
    }, function (module, exports, __nested_webpack_require_43656__) {
      module.exports = __nested_webpack_require_43656__(10);

      /***/
    }, function (module, exports, __nested_webpack_require_43774__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var container_1 = __nested_webpack_require_43774__(2);
      var format_1 = __nested_webpack_require_43774__(3);
      var leaf_1 = __nested_webpack_require_43774__(4);
      var scroll_1 = __nested_webpack_require_43774__(12);
      var inline_1 = __nested_webpack_require_43774__(13);
      var block_1 = __nested_webpack_require_43774__(14);
      var embed_1 = __nested_webpack_require_43774__(15);
      var text_1 = __nested_webpack_require_43774__(16);
      var attributor_1 = __nested_webpack_require_43774__(1);
      var class_1 = __nested_webpack_require_43774__(7);
      var style_1 = __nested_webpack_require_43774__(8);
      var store_1 = __nested_webpack_require_43774__(6);
      var Registry = __nested_webpack_require_43774__(0);
      var Parchment = {
        Scope: Registry.Scope,
        create: Registry.create,
        find: Registry.find,
        query: Registry.query,
        register: Registry.register,
        setFindByTagFn: Registry.setFindByTagFn,
        Container: container_1.default,
        Format: format_1.default,
        Leaf: leaf_1.default,
        Embed: embed_1.default,
        Scroll: scroll_1.default,
        Block: block_1.default,
        Inline: inline_1.default,
        Text: text_1.default,
        Attributor: {
          Attribute: attributor_1.default,
          Class: class_1.default,
          Style: style_1.default,
          Store: store_1.default
        }
      };
      exports.default = Parchment;

      /***/
    }, function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var LinkedList = function () {
        function LinkedList() {
          this.head = this.tail = null;
          this.length = 0;
        }
        LinkedList.prototype.append = function () {
          var nodes = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            nodes[_i] = arguments[_i];
          }
          this.insertBefore(nodes[0], null);
          if (nodes.length > 1) {
            this.append.apply(this, nodes.slice(1));
          }
        };
        LinkedList.prototype.contains = function (node) {
          var cur,
            next = this.iterator();
          while (cur = next()) {
            if (cur === node) return true;
          }
          return false;
        };
        LinkedList.prototype.insertBefore = function (node, refNode) {
          if (!node) return;
          node.next = refNode;
          if (refNode != null) {
            node.prev = refNode.prev;
            if (refNode.prev != null) {
              refNode.prev.next = node;
            }
            refNode.prev = node;
            if (refNode === this.head) {
              this.head = node;
            }
          } else if (this.tail != null) {
            this.tail.next = node;
            node.prev = this.tail;
            this.tail = node;
          } else {
            node.prev = null;
            this.head = this.tail = node;
          }
          this.length += 1;
        };
        LinkedList.prototype.offset = function (target) {
          var index = 0,
            cur = this.head;
          while (cur != null) {
            if (cur === target) return index;
            index += cur.length();
            cur = cur.next;
          }
          return -1;
        };
        LinkedList.prototype.remove = function (node) {
          if (!this.contains(node)) return;
          if (node.prev != null) node.prev.next = node.next;
          if (node.next != null) node.next.prev = node.prev;
          if (node === this.head) this.head = node.next;
          if (node === this.tail) this.tail = node.prev;
          this.length -= 1;
        };
        LinkedList.prototype.iterator = function (curNode) {
          if (curNode === void 0) {
            curNode = this.head;
          }
          // TODO use yield when we can
          return function () {
            var ret = curNode;
            if (curNode != null) curNode = curNode.next;
            return ret;
          };
        };
        LinkedList.prototype.find = function (index, inclusive) {
          if (inclusive === void 0) {
            inclusive = false;
          }
          var cur,
            next = this.iterator();
          while (cur = next()) {
            var length_1 = cur.length();
            if (index < length_1 || inclusive && index === length_1 && (cur.next == null || cur.next.length() !== 0)) {
              return [cur, index];
            }
            index -= length_1;
          }
          return [null, 0];
        };
        LinkedList.prototype.forEach = function (callback) {
          var cur,
            next = this.iterator();
          while (cur = next()) {
            callback(cur);
          }
        };
        LinkedList.prototype.forEachAt = function (index, length, callback) {
          if (length <= 0) return;
          var _a = this.find(index),
            startNode = _a[0],
            offset = _a[1];
          var cur,
            curIndex = index - offset,
            next = this.iterator(startNode);
          while ((cur = next()) && curIndex < index + length) {
            var curLength = cur.length();
            if (index > curIndex) {
              callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
            } else {
              callback(cur, 0, Math.min(curLength, index + length - curIndex));
            }
            curIndex += curLength;
          }
        };
        LinkedList.prototype.map = function (callback) {
          return this.reduce(function (memo, cur) {
            memo.push(callback(cur));
            return memo;
          }, []);
        };
        LinkedList.prototype.reduce = function (callback, memo) {
          var cur,
            next = this.iterator();
          while (cur = next()) {
            memo = callback(memo, cur);
          }
          return memo;
        };
        return LinkedList;
      }();
      exports.default = LinkedList;

      /***/
    }, function (module, exports, __nested_webpack_require_49838__) {
      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var container_1 = __nested_webpack_require_49838__(2);
      var Registry = __nested_webpack_require_49838__(0);
      var OBSERVER_CONFIG = {
        attributes: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
      };
      var MAX_OPTIMIZE_ITERATIONS = 100;
      var ScrollBlot = function (_super) {
        __extends(ScrollBlot, _super);
        function ScrollBlot(node) {
          var _this = _super.call(this, node) || this;
          _this.scroll = _this;
          _this.observer = new MutationObserver(function (mutations) {
            _this.update(mutations);
          });
          _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
          Registry.attachOnce(_this);
          return _this;
        }
        ScrollBlot.prototype.detach = function () {
          _super.prototype.detach.call(this);
          this.observer.disconnect();
        };
        ScrollBlot.prototype.deleteAt = function (index, length) {
          this.update();
          if (index === 0 && length === this.length()) {
            this.children.forEach(function (child) {
              child.remove();
            });
          } else {
            _super.prototype.deleteAt.call(this, index, length);
          }
        };
        ScrollBlot.prototype.formatAt = function (index, length, name, value) {
          this.update();
          _super.prototype.formatAt.call(this, index, length, name, value);
        };
        ScrollBlot.prototype.insertAt = function (index, value, def) {
          this.update();
          _super.prototype.insertAt.call(this, index, value, def);
        };
        ScrollBlot.prototype.optimize = function (mutations, context) {
          var _this = this;
          if (mutations === void 0) {
            mutations = [];
          }
          if (context === void 0) {
            context = {};
          }
          _super.prototype.optimize.call(this, context);
          // We must modify mutations directly, cannot make copy and then modify
          var records = [].slice.call(this.observer.takeRecords());
          // Array.push currently seems to be implemented by a non-tail recursive function
          // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());
          while (records.length > 0) {
            mutations.push(records.pop());
          }
          // TODO use WeakMap
          var mark = function mark(blot, markParent) {
            if (markParent === void 0) {
              markParent = true;
            }
            if (blot == null || blot === _this) return;
            if (blot.domNode.parentNode == null) return;
            // @ts-ignore
            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
              // @ts-ignore
              blot.domNode[Registry.DATA_KEY].mutations = [];
            }
            if (markParent) mark(blot.parent);
          };
          var optimize = function optimize(blot) {
            // Post-order traversal
            if (
            // @ts-ignore
            blot.domNode[Registry.DATA_KEY] == null ||
            // @ts-ignore
            blot.domNode[Registry.DATA_KEY].mutations == null) {
              return;
            }
            if (blot instanceof container_1.default) {
              blot.children.forEach(optimize);
            }
            blot.optimize(context);
          };
          var remaining = mutations;
          for (var i = 0; remaining.length > 0; i += 1) {
            if (i >= MAX_OPTIMIZE_ITERATIONS) {
              throw new Error('[Parchment] Maximum optimize iterations reached');
            }
            remaining.forEach(function (mutation) {
              var blot = Registry.find(mutation.target, true);
              if (blot == null) return;
              if (blot.domNode === mutation.target) {
                if (mutation.type === 'childList') {
                  mark(Registry.find(mutation.previousSibling, false));
                  [].forEach.call(mutation.addedNodes, function (node) {
                    var child = Registry.find(node, false);
                    mark(child, false);
                    if (child instanceof container_1.default) {
                      child.children.forEach(function (grandChild) {
                        mark(grandChild, false);
                      });
                    }
                  });
                } else if (mutation.type === 'attributes') {
                  mark(blot.prev);
                }
              }
              mark(blot);
            });
            this.children.forEach(optimize);
            remaining = [].slice.call(this.observer.takeRecords());
            records = remaining.slice();
            while (records.length > 0) {
              mutations.push(records.pop());
            }
          }
        };
        ScrollBlot.prototype.update = function (mutations, context) {
          var _this = this;
          if (context === void 0) {
            context = {};
          }
          mutations = mutations || this.observer.takeRecords();
          // TODO use WeakMap
          mutations.map(function (mutation) {
            var blot = Registry.find(mutation.target, true);
            if (blot == null) return null;
            // @ts-ignore
            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
              // @ts-ignore
              blot.domNode[Registry.DATA_KEY].mutations = [mutation];
              return blot;
            } else {
              // @ts-ignore
              blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
              return null;
            }
          }).forEach(function (blot) {
            if (blot == null || blot === _this ||
            //@ts-ignore
            blot.domNode[Registry.DATA_KEY] == null) return;
            // @ts-ignore
            blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
          });
          // @ts-ignore
          if (this.domNode[Registry.DATA_KEY].mutations != null) {
            // @ts-ignore
            _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
          }
          this.optimize(mutations, context);
        };
        ScrollBlot.blotName = 'scroll';
        ScrollBlot.defaultChild = 'block';
        ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
        ScrollBlot.tagName = 'DIV';
        return ScrollBlot;
      }(container_1.default);
      exports.default = ScrollBlot;

      /***/
    }, function (module, exports, __nested_webpack_require_57112__) {
      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var format_1 = __nested_webpack_require_57112__(3);
      var Registry = __nested_webpack_require_57112__(0);
      // Shallow object comparison
      function isEqual(obj1, obj2) {
        if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;
        // @ts-ignore
        for (var prop in obj1) {
          // @ts-ignore
          if (obj1[prop] !== obj2[prop]) return false;
        }
        return true;
      }
      var InlineBlot = function (_super) {
        __extends(InlineBlot, _super);
        function InlineBlot() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        InlineBlot.formats = function (domNode) {
          if (domNode.tagName === InlineBlot.tagName) return undefined;
          return _super.formats.call(this, domNode);
        };
        InlineBlot.prototype.format = function (name, value) {
          var _this = this;
          if (name === this.statics.blotName && !value) {
            this.children.forEach(function (child) {
              if (!(child instanceof format_1.default)) {
                child = child.wrap(InlineBlot.blotName, true);
              }
              _this.attributes.copy(child);
            });
            this.unwrap();
          } else {
            _super.prototype.format.call(this, name, value);
          }
        };
        InlineBlot.prototype.formatAt = function (index, length, name, value) {
          if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
            var blot = this.isolate(index, length);
            blot.format(name, value);
          } else {
            _super.prototype.formatAt.call(this, index, length, name, value);
          }
        };
        InlineBlot.prototype.optimize = function (context) {
          _super.prototype.optimize.call(this, context);
          var formats = this.formats();
          if (Object.keys(formats).length === 0) {
            return this.unwrap(); // unformatted span
          }

          var next = this.next;
          if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
            next.moveChildren(this);
            next.remove();
          }
        };
        InlineBlot.blotName = 'inline';
        InlineBlot.scope = Registry.Scope.INLINE_BLOT;
        InlineBlot.tagName = 'SPAN';
        return InlineBlot;
      }(format_1.default);
      exports.default = InlineBlot;

      /***/
    }, function (module, exports, __nested_webpack_require_60324__) {
      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var format_1 = __nested_webpack_require_60324__(3);
      var Registry = __nested_webpack_require_60324__(0);
      var BlockBlot = function (_super) {
        __extends(BlockBlot, _super);
        function BlockBlot() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        BlockBlot.formats = function (domNode) {
          var tagName = Registry.query(BlockBlot.blotName).tagName;
          if (domNode.tagName === tagName) return undefined;
          return _super.formats.call(this, domNode);
        };
        BlockBlot.prototype.format = function (name, value) {
          if (Registry.query(name, Registry.Scope.BLOCK) == null) {
            return;
          } else if (name === this.statics.blotName && !value) {
            this.replaceWith(BlockBlot.blotName);
          } else {
            _super.prototype.format.call(this, name, value);
          }
        };
        BlockBlot.prototype.formatAt = function (index, length, name, value) {
          if (Registry.query(name, Registry.Scope.BLOCK) != null) {
            this.format(name, value);
          } else {
            _super.prototype.formatAt.call(this, index, length, name, value);
          }
        };
        BlockBlot.prototype.insertAt = function (index, value, def) {
          if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) {
            // Insert text or inline
            _super.prototype.insertAt.call(this, index, value, def);
          } else {
            var after = this.split(index);
            var blot = Registry.create(value, def);
            after.parent.insertBefore(blot, after);
          }
        };
        BlockBlot.prototype.update = function (mutations, context) {
          if (navigator.userAgent.match(/Trident/)) {
            this.build();
          } else {
            _super.prototype.update.call(this, mutations, context);
          }
        };
        BlockBlot.blotName = 'block';
        BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
        BlockBlot.tagName = 'P';
        return BlockBlot;
      }(format_1.default);
      exports.default = BlockBlot;

      /***/
    }, function (module, exports, __nested_webpack_require_63223__) {
      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var leaf_1 = __nested_webpack_require_63223__(4);
      var EmbedBlot = function (_super) {
        __extends(EmbedBlot, _super);
        function EmbedBlot() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        EmbedBlot.formats = function (domNode) {
          return undefined;
        };
        EmbedBlot.prototype.format = function (name, value) {
          // super.formatAt wraps, which is what we want in general,
          // but this allows subclasses to overwrite for formats
          // that just apply to particular embeds
          _super.prototype.formatAt.call(this, 0, this.length(), name, value);
        };
        EmbedBlot.prototype.formatAt = function (index, length, name, value) {
          if (index === 0 && length === this.length()) {
            this.format(name, value);
          } else {
            _super.prototype.formatAt.call(this, index, length, name, value);
          }
        };
        EmbedBlot.prototype.formats = function () {
          return this.statics.formats(this.domNode);
        };
        return EmbedBlot;
      }(leaf_1.default);
      exports.default = EmbedBlot;

      /***/
    }, function (module, exports, __nested_webpack_require_65159__) {
      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var leaf_1 = __nested_webpack_require_65159__(4);
      var Registry = __nested_webpack_require_65159__(0);
      var TextBlot = function (_super) {
        __extends(TextBlot, _super);
        function TextBlot(node) {
          var _this = _super.call(this, node) || this;
          _this.text = _this.statics.value(_this.domNode);
          return _this;
        }
        TextBlot.create = function (value) {
          return document.createTextNode(value);
        };
        TextBlot.value = function (domNode) {
          var text = domNode.data;
          // @ts-ignore
          if (text['normalize']) text = text['normalize']();
          return text;
        };
        TextBlot.prototype.deleteAt = function (index, length) {
          this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
        };
        TextBlot.prototype.index = function (node, offset) {
          if (this.domNode === node) {
            return offset;
          }
          return -1;
        };
        TextBlot.prototype.insertAt = function (index, value, def) {
          if (def == null) {
            this.text = this.text.slice(0, index) + value + this.text.slice(index);
            this.domNode.data = this.text;
          } else {
            _super.prototype.insertAt.call(this, index, value, def);
          }
        };
        TextBlot.prototype.length = function () {
          return this.text.length;
        };
        TextBlot.prototype.optimize = function (context) {
          _super.prototype.optimize.call(this, context);
          this.text = this.statics.value(this.domNode);
          if (this.text.length === 0) {
            this.remove();
          } else if (this.next instanceof TextBlot && this.next.prev === this) {
            this.insertAt(this.length(), this.next.value());
            this.next.remove();
          }
        };
        TextBlot.prototype.position = function (index, inclusive) {
          if (inclusive === void 0) {
            inclusive = false;
          }
          return [this.domNode, index];
        };
        TextBlot.prototype.split = function (index, force) {
          if (force === void 0) {
            force = false;
          }
          if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
          }
          var after = Registry.create(this.domNode.splitText(index));
          this.parent.insertBefore(after, this.next);
          this.text = this.statics.value(this.domNode);
          return after;
        };
        TextBlot.prototype.update = function (mutations, context) {
          var _this = this;
          if (mutations.some(function (mutation) {
            return mutation.type === 'characterData' && mutation.target === _this.domNode;
          })) {
            this.text = this.statics.value(this.domNode);
          }
        };
        TextBlot.prototype.value = function () {
          return this.text;
        };
        TextBlot.blotName = 'text';
        TextBlot.scope = Registry.Scope.INLINE_BLOT;
        return TextBlot;
      }(leaf_1.default);
      exports.default = TextBlot;

      /***/
    }])
  );
});

/***/ }),

/***/ 86780:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ getTimeZone)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_6__);







function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
/**
 * Возвращает таймзону пользователя
 * @return {string}
 */
function getTimeZone() {
  var timeZone = 'America/New_York'; // часовой пояс по умолчанию
  if ((typeof Intl === "undefined" ? "undefined" : _typeof(Intl)) === 'object' && Intl.DateTimeFormat && Intl.DateTimeFormat().resolvedOptions) {
    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (timeZone instanceof Array) {
      timeZone = timeZone[0];
    }
  }
  return timeZone;
}

/***/ }),

/***/ 65224:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "createDocument": () => (/* binding */ createDocument)
});

// NAMESPACE OBJECT: ./node_modules/y-protocols/auth.js
var auth_namespaceObject = {};
__webpack_require__.r(auth_namespaceObject);
__webpack_require__.d(auth_namespaceObject, {
  "messagePermissionDenied": () => (messagePermissionDenied),
  "readAuthMessage": () => (readAuthMessage),
  "writePermissionDenied": () => (writePermissionDenied)
});

// EXTERNAL MODULE: ./node_modules/@lib/editor/node_modules/lib0/mutex.js
var mutex = __webpack_require__(70494);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/util/encoding.js + 2 modules
var encoding = __webpack_require__(59150);
// EXTERNAL MODULE: ./node_modules/@lib/editor/node_modules/lib0/decoding.js
var decoding = __webpack_require__(29693);
// EXTERNAL MODULE: ./node_modules/y-protocols/sync.js
var sync = __webpack_require__(53665);
// EXTERNAL MODULE: ./node_modules/lib0/encoding.js
var lib0_encoding = __webpack_require__(55529);
// EXTERNAL MODULE: ./node_modules/lib0/decoding.js + 2 modules
var lib0_decoding = __webpack_require__(49016);
;// CONCATENATED MODULE: ./node_modules/y-protocols/auth.js
 // eslint-disable-line


var messagePermissionDenied = 0;

/**
 * @param {encoding.Encoder} encoder
 * @param {string} reason
 */
var writePermissionDenied = function writePermissionDenied(encoder, reason) {
  lib0_encoding/* writeVarUint */.uE(encoder, messagePermissionDenied);
  lib0_encoding/* writeVarString */.uw(encoder, reason);
};

/**
 * @callback PermissionDeniedHandler
 * @param {any} y
 * @param {string} reason
 */

/**
 *
 * @param {decoding.Decoder} decoder
 * @param {Y.Doc} y
 * @param {PermissionDeniedHandler} permissionDeniedHandler
 */
var readAuthMessage = function readAuthMessage(decoder, y, permissionDeniedHandler) {
  switch (lib0_decoding/* readVarUint */.yg(decoder)) {
    case messagePermissionDenied:
      permissionDeniedHandler(y, lib0_decoding/* readVarString */.kf(decoder));
  }
};
// EXTERNAL MODULE: ./node_modules/y-protocols/awareness.js + 4 modules
var awareness = __webpack_require__(15264);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__(23123);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.map.js
var es_map = __webpack_require__(51532);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.uint8-array.js
var es_typed_array_uint8_array = __webpack_require__(82472);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.copy-within.js
var es_typed_array_copy_within = __webpack_require__(92990);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.every.js
var es_typed_array_every = __webpack_require__(18927);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.fill.js
var es_typed_array_fill = __webpack_require__(33105);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.filter.js
var es_typed_array_filter = __webpack_require__(35035);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.find.js
var es_typed_array_find = __webpack_require__(74345);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.find-index.js
var es_typed_array_find_index = __webpack_require__(7174);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.for-each.js
var es_typed_array_for_each = __webpack_require__(32846);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.includes.js
var es_typed_array_includes = __webpack_require__(44731);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.index-of.js
var es_typed_array_index_of = __webpack_require__(77209);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.iterator.js
var es_typed_array_iterator = __webpack_require__(96319);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.join.js
var es_typed_array_join = __webpack_require__(58867);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.last-index-of.js
var es_typed_array_last_index_of = __webpack_require__(37789);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.map.js
var es_typed_array_map = __webpack_require__(33739);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reduce.js
var es_typed_array_reduce = __webpack_require__(29368);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reduce-right.js
var es_typed_array_reduce_right = __webpack_require__(14483);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reverse.js
var es_typed_array_reverse = __webpack_require__(12056);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.set.js
var es_typed_array_set = __webpack_require__(3462);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.slice.js
var es_typed_array_slice = __webpack_require__(30678);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.some.js
var es_typed_array_some = __webpack_require__(27462);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.sort.js
var es_typed_array_sort = __webpack_require__(33824);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.subarray.js
var es_typed_array_subarray = __webpack_require__(55021);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.to-locale-string.js
var es_typed_array_to_locale_string = __webpack_require__(12974);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.to-string.js
var es_typed_array_to_string = __webpack_require__(15016);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__(69826);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(57327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(69600);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(19601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(30489);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__(12419);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.get.js
var es_reflect_get = __webpack_require__(74819);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__(38880);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url.js
var web_url = __webpack_require__(60285);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.js
var web_url_search_params = __webpack_require__(41637);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__(34553);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.splice.js
var es_array_splice = __webpack_require__(40561);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/providers/messageTypes.js
var messageSync = 0;
var messageAwareness = 1;
var messageQueryAwareness = 3;
var messageAuth = 2;
var messageNmbToken = 300;
var messageSwitch = 301;
var messageSwitchSuccess = 302;
var messageRelease = 303;
/**
 * message with custom body, to be parsed on the server side
 */
var messageCustom = 304;
var messagePing = 0x11;
var messagePong = 0x12;
;// CONCATENATED MODULE: ./node_modules/@lib/editor/providers/websocketVirtualConnection.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

































function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EventEmitter = __webpack_require__(94092);
var WebsocketVirtualConnection = /*#__PURE__*/function (_EventEmitter) {
  _inherits(WebsocketVirtualConnection, _EventEmitter);
  var _super = _createSuper(WebsocketVirtualConnection);
  function WebsocketVirtualConnection(ws, url, Y, encoding, decoding) {
    var _this;
    _classCallCheck(this, WebsocketVirtualConnection);
    _this = _super.call(this);
    ws._virtualConnection = _assertThisInitialized(_this);
    _this.ws = ws;
    _this.url = url;
    _this.isWaitingForSwitch = false;
    // this is a short string that identifies each switch for the current client(not globally)
    // so the client can distinguish if it has received the switch success for its switch request
    _this.switchToken = null;
    _this.Y = Y;
    _this.encoding = encoding;
    _this.decoding = decoding;
    return _this;
  }
  _createClass(WebsocketVirtualConnection, [{
    key: "onWsMessage",
    value: function onWsMessage(event) {
      if (this.isWaitingForSwitch) {
        var Y = this.Y,
          encoding = this.encoding,
          decoding = this.decoding;
        var decoder = decoding.createDecoder(new Uint8Array(event.data));
        var messageType = decoding.readVarUint(decoder);
        if (messageType === messageSwitchSuccess) {
          var switchUrl = decoding.readVarString(decoder);
          var switchToken = null;
          try {
            switchToken = decoding.readVarString(decoder);
          } catch (err) {
            // this can happen if the server is old and does not support switchTokens
          }
          if (switchToken === this.switchToken || !switchToken) {
            if (switchUrl === this.url) {
              this.isWaitingForSwitch = false;
              if (this.onopen) {
                this.onopen();
              }
            } else {
              console.error('CRITICAL: switched to URL', switchUrl, 'but expected', this.url, 'probably a few switch requests was queued', 'switch token is', switchToken);
            }
          }
        }
        return;
      }
      if (this.onmessage) {
        this.onmessage(event);
      }
    }
  }, {
    key: "onWsClose",
    value: function onWsClose() {
      if (this.onclose) {
        this.onclose();
      }
      this.ws._virtualConnection = null;
    }
  }, {
    key: "onWsOpen",
    value: function onWsOpen() {
      if (this.onopen) {
        this.onopen();
      }
    }
  }, {
    key: "send",
    value: function send() {
      var _this$ws;
      if (!this.ws) {
        return console.warn('attemp to send over closed WebsocketPooledConnection');
      }
      (_this$ws = this.ws).send.apply(_this$ws, arguments);
    }
  }, {
    key: "release",
    value: function release() {
      if (!this.ws) {
        console.warn('prevented attemp to release connection twice', this.url);
        return;
      }
      this.ws._virtualConnection = null;
      this.ws = null;
      this.emit('release');
    }
  }, {
    key: "close",
    value: function close() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (opts.final) {
        console.log('finally closing websocket connection');
        // может быть ситуация когда this.ws = null, поэтому делаем проверку
        if (this.ws && this.ws.close) {
          this.ws.close();
        }
      } else {
        this.release();
      }
    }
  }]);
  return WebsocketVirtualConnection;
}(EventEmitter);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/providers/websocketPool.js
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



















function websocketPool_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function websocketPool_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function websocketPool_createClass(Constructor, protoProps, staticProps) { if (protoProps) websocketPool_defineProperties(Constructor.prototype, protoProps); if (staticProps) websocketPool_defineProperties(Constructor, staticProps); return Constructor; }
var websocketPool_EventEmitter = __webpack_require__(94092);


var MAX_FREE_WEBSOCKETS = 1;
// we will be closing all the websockets that have not received any messages during this time interval
var WS_MESSAGE_TIMEOUT = 60e3;
var lastSwitchId = 0;
var lastWsId = 0;
var WebsocketPool = /*#__PURE__*/function () {
  function WebsocketPool(_ref) {
    var Y = _ref.Y,
      createMutex = _ref.createMutex,
      encoding = _ref.encoding,
      decoding = _ref.decoding,
      syncProtocol = _ref.syncProtocol,
      authProtocol = _ref.authProtocol;
    websocketPool_classCallCheck(this, WebsocketPool);
    this.freeByHost = {};
    this.usedByHost = {};
    this.Y = Y;
    this.encoding = encoding;
    this.decoding = decoding;
    this.syncProtocol = syncProtocol;
    this.docs = [];
  }
  websocketPool_createClass(WebsocketPool, [{
    key: "connect",
    value: function connect(url) {
      var _this = this;
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var urlInst = new URL(url);
      var host = urlInst.host.toLowerCase();
      var needSwitch = false;
      if (!this.freeByHost[host] || !this.freeByHost[host].length || !opts.enableSwitch) {
        this.createWebsocket(url, host);
      } else {
        needSwitch = true;
      }
      var ws = this.acquireFreeWebsocket(host);
      var vConn = new WebsocketVirtualConnection(ws, url, this.Y, this.encoding, this.decoding);
      var onRelease = function onRelease() {
        vConn.removeListener('release', onRelease);
        _this.runRelease(ws);
        _this.releaseWebsocket(ws);
      };
      vConn.on('release', onRelease);
      if (needSwitch) {
        vConn.isWaitingForSwitch = true;
        vConn.switchToken = (++lastSwitchId).toString();
        this.runSwitch(ws, url, vConn.switchToken);
      }
      return vConn;
    }
  }, {
    key: "setDoc",
    value: function setDoc(doc) {
      this.docs.push(doc);
    }
  }, {
    key: "onDocSynced",
    value: function onDocSynced(doc) {
      console.log("[editor] doc ".concat(doc.docName, " synced"));
      var findFn = function findFn(item) {
        return item.docName === doc.docName;
      };
      var syncedDoc = this.docs.find(findFn);
      var index = this.docs.findIndex(findFn);
      if (syncedDoc && syncedDoc.readyToDestroy) {
        console.log("[editor] destroy doc ".concat(doc.docName, " after sync"));
        syncedDoc.destroy();
      }
      if (index !== -1) {
        this.docs.splice(index, 1);
      }
    }
  }, {
    key: "acquireFreeWebsocket",
    value: function acquireFreeWebsocket(host) {
      var ws = this.freeByHost[host].pop();
      if (!this.usedByHost[host]) {
        this.usedByHost[host] = [];
      }
      this.usedByHost[host].push(ws);
      return ws;
    }
  }, {
    key: "releaseWebsocket",
    value: function releaseWebsocket(ws) {
      var _this2 = this;
      var host = ws._host;
      console.log('releasing websocket', host);
      console.log('Before release: count used websockets for host:', Object.keys(this.usedByHost[host]).length);
      console.log('Before release: count free websockets for host:', Object.keys(this.freeByHost[host]).length);
      if (!this.usedByHost[host].find(function (aWs) {
        return aWs === ws;
      })) {
        // вебсокет отсутствует в используемых сокетых
        // это может случится когда вебсокет релизится еще не открытым(_isOpen = false)
        return console.warn('fail to release websocket: websocket is not used(probably it was deleted in the early release stage)');
      }
      this.usedByHost[host] = this.usedByHost[host].filter(function (aWs) {
        return aWs !== ws;
      });
      this.freeByHost[host].push(ws);
      console.log('released websocket', host);
      console.log('After release: count used websockets for host:', Object.keys(this.usedByHost[host]).length);
      console.log('After release: count free websockets for host:', Object.keys(this.freeByHost[host]).length);
      var hostsWithWebsockets = [].concat(_toConsumableArray(Object.keys(this.usedByHost).filter(function (host) {
        return _this2.usedByHost[host].length;
      })), _toConsumableArray(Object.keys(this.freeByHost).filter(function (host) {
        return _this2.freeByHost[host].length;
      })));
      var cntHostsWithWebsockets = hostsWithWebsockets.length;
      console.log('Count hosts with websockets:', cntHostsWithWebsockets, hostsWithWebsockets);
    }
  }, {
    key: "deleteWebsocket",
    value: function deleteWebsocket(ws) {
      this.clearWebsocketMessageTimeout(ws);
      clearInterval(ws._messageTimeoutCheckInterval);
      var host = ws._host;
      this.usedByHost[host] = this.usedByHost[host].filter(function (aWs) {
        return aWs !== ws;
      });
      this.freeByHost[host] = this.freeByHost[host].filter(function (aWs) {
        return aWs !== ws;
      });
    }
  }, {
    key: "clearWebsocketMessageTimeout",
    value: function clearWebsocketMessageTimeout(ws) {
      ws._lastMessageReceivedAt = Date.now();
    }
  }, {
    key: "setWebsocketMessageTimeout",
    value: function setWebsocketMessageTimeout(ws) {
      this.clearWebsocketMessageTimeout(ws);
      if (ws._messageTimeoutCheckInterval) {
        console.warn('ws timeout check interval already set, skip');
        return;
      }
      ws._messageTimeoutCheckInterval = setInterval(function () {
        var now = Date.now();
        if (now - ws._lastMessageReceivedAt > WS_MESSAGE_TIMEOUT) {
          console.warn('closing websocket because no messages in the last', WS_MESSAGE_TIMEOUT, 'ms');
          ws.close();
        }
      }, 5e3);
    }
  }, {
    key: "createWebsocket",
    value: function createWebsocket(url, host) {
      console.log('[editor ws pool] creating new connection to URL', url, 'for host', host);
      var ws = new WebSocket(url);
      ws.binaryType = 'arraybuffer';
      ws._host = host;
      ws._id = ++lastWsId;
      ws.onmessage = this.handleWebsocketMessage.bind(this, ws);
      ws.onclose = this.handleWebsocketClose.bind(this, ws);
      ws.onopen = this.handleWebsocketOpen.bind(this, ws);
      if (!this.freeByHost[host]) {
        this.freeByHost[host] = [];
      }
      this.freeByHost[host].push(ws);
      this.closeExceedingWebsockets(ws);
    }
  }, {
    key: "getLastWsId",
    value: function getLastWsId() {
      return lastWsId;
    }
  }, {
    key: "getFreeSocketsCount",
    value: function getFreeSocketsCount() {
      var totalCount = 0;
      for (var host in this.freeByHost) {
        var _iterator = _createForOfIteratorHelper(this.freeByHost[host]),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var ws = _step.value;
            totalCount++;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return totalCount;
    }
  }, {
    key: "closeExceedingWebsockets",
    value: function closeExceedingWebsockets(except) {
      var _this3 = this;
      var toClose = [];
      var totalCount = this.getFreeSocketsCount();
      console.log('Count sockets before exceeding closing', totalCount);
      var closedCount = 0;
      var needToClose = totalCount - MAX_FREE_WEBSOCKETS;
      for (var host in this.freeByHost) {
        var _iterator2 = _createForOfIteratorHelper(this.freeByHost[host]),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var ws = _step2.value;
            if (closedCount < needToClose && ws !== except) {
              closedCount++;
              toClose.push({
                host: host,
                ws: ws
              });
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      var _loop = function _loop() {
        var _toClose$_i = _toClose[_i],
          host = _toClose$_i.host,
          ws = _toClose$_i.ws;
        _this3.freeByHost[host] = _this3.freeByHost[host].filter(function (websocket) {
          return websocket !== ws;
        });
        console.log('closing exceeding websocket for host', host);
        ws.close();
      };
      for (var _i = 0, _toClose = toClose; _i < _toClose.length; _i++) {
        _loop();
      }
      console.log('count sockets after exceeding closing', this.getFreeSocketsCount());
    }
  }, {
    key: "runSwitch",
    value: function runSwitch(ws, url, switchToken) {
      var Y = this.Y;
      console.info('Switching to URL', url, 'with token', switchToken);
      var encoder = this.encoding.createEncoder();
      this.encoding.writeVarUint(encoder, messageSwitch);
      this.encoding.writeVarString(encoder, url);
      this.encoding.writeVarString(encoder, switchToken);
      try {
        ws.send(this.encoding.toUint8Array(encoder));
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: "runRelease",
    value: function runRelease(ws) {
      var Y = this.Y;
      if (!ws._isOpen) {
        console.log('closing websocket in runRelease because it is not opened yet');
        try {
          ws.close();
        } catch (err) {
          console.error('error while closing websocket', err);
        }
        return;
      }
      var encoder = this.encoding.createEncoder();
      this.encoding.writeVarUint(encoder, messageRelease);
      try {
        ws.send(this.encoding.toUint8Array(encoder));
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: "handleWebsocketMessage",
    value: function handleWebsocketMessage(ws, event) {
      this.clearWebsocketMessageTimeout(ws);
      if (ws._virtualConnection) {
        ws._virtualConnection.onWsMessage(event);
      }
    }
  }, {
    key: "handleWebsocketClose",
    value: function handleWebsocketClose(ws) {
      console.warn('Editor WS Pool: websocket has closed');
      ws._isOpen = false;
      if (ws._virtualConnection) {
        ws._virtualConnection.onWsClose();
      }
      this.deleteWebsocket(ws);
    }
  }, {
    key: "handleWebsocketOpen",
    value: function handleWebsocketOpen(ws) {
      ws._isOpen = true;
      this.setWebsocketMessageTimeout(ws);
      if (ws._virtualConnection) {
        ws._virtualConnection.onWsOpen();
      }
    }
  }]);
  return WebsocketPool;
}();
;// CONCATENATED MODULE: ./node_modules/@lib/editor/providers/logger.js
var levels = ['error', 'warn', 'log', 'info'];
var level = 'info';
function debug(method) {
  if (levels.indexOf(method) <= levels.indexOf(level)) {
    var _console;
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
  }
}

function namespace(ns) {
  return levels.reduce(function (logger, method) {
    logger[method] = debug.bind(console, method, ns);
    return logger;
  }, {});
}
debug.level = namespace.level = function (newLevel) {
  level = newLevel;
};
/* harmony default export */ const providers_logger = (namespace);
// EXTERNAL MODULE: ./node_modules/@lib/editor/providers/utils.js
var utils = __webpack_require__(86780);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/providers/createDocument.js
function createDocument_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { createDocument_typeof = function _typeof(obj) { return typeof obj; }; } else { createDocument_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return createDocument_typeof(obj); }
function createDocument_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = createDocument_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function createDocument_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return createDocument_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return createDocument_arrayLikeToArray(o, minLen); }
function createDocument_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function createDocument_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function createDocument_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function createDocument_createClass(Constructor, protoProps, staticProps) { if (protoProps) createDocument_defineProperties(Constructor.prototype, protoProps); if (staticProps) createDocument_defineProperties(Constructor, staticProps); return Constructor; }
function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = createDocument_getPrototypeOf(object); if (object === null) break; } return object; }
function createDocument_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) createDocument_setPrototypeOf(subClass, superClass); }
function createDocument_setPrototypeOf(o, p) { createDocument_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return createDocument_setPrototypeOf(o, p); }
function createDocument_createSuper(Derived) { var hasNativeReflectConstruct = createDocument_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = createDocument_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = createDocument_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return createDocument_possibleConstructorReturn(this, result); }; }
function createDocument_possibleConstructorReturn(self, call) { if (call && (createDocument_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return createDocument_assertThisInitialized(self); }
function createDocument_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function createDocument_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function createDocument_getPrototypeOf(o) { createDocument_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return createDocument_getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


















































var websocketPool;
function createDocumentConstructor(createMutex, encoding, decoding, syncProtocol, authProtocol, awarenessProtocol) {
  return function createDocument(Y, params) {
    var logger = providers_logger('[' + params.editorId + ']');
    var _ref = params.providerConfig || {},
      _ref$getUpdateOrigin = _ref.getUpdateOrigin,
      getUpdateOrigin = _ref$getUpdateOrigin === void 0 ? function (origin) {
        return origin;
      } : _ref$getUpdateOrigin;
    if (!websocketPool) {
      websocketPool = new WebsocketPool({
        Y: Y,
        createMutex: createMutex,
        encoding: encoding,
        decoding: decoding,
        syncProtocol: syncProtocol,
        authProtocol: authProtocol
      });
    }
    var backoffBase = 2;
    var maxBackoff = Math.pow(backoffBase, 5);
    var urlRoom = params.url.split('/');
    var room = params.room || urlRoom[urlRoom.length - 1];
    var getEmptyStateSet = function getEmptyStateSet() {
      var encoder = encoding.createEncoder();
      encoding.writeVarUint(encoder, messageSync);
      syncProtocol.writeSyncStep1(encoder, {
        store: {
          clients: new Map()
        }
      });
      var buff = encoding.toUint8Array(encoder);
      return buff;
    };

    /**
     * @param {WebsocketsSharedDocument} doc
     * @param {string} reason
     */
    var permissionDeniedHandler = function permissionDeniedHandler(doc, reason) {
      return logger.warn("Permission denied to access ".concat(doc.url, ".\n").concat(reason));
    };

    /**
     * @param {WebsocketsSharedDocument} doc
     * @param {ArrayBuffer} buf
     * @return {Y.encoding.Encoder}
     */
    var readMessage = function readMessage(doc, buf) {
      if (doc.isExternalUpdatesPaused) {
        doc.externalUpdatesBacklog.push(buf);
        return null;
      }
      var decoder = decoding.createDecoder(buf);
      var encoder = encoding.createEncoder();
      var messageType = decoding.readVarUint(decoder);
      switch (messageType) {
        case messageSync:
          encoding.writeVarUint(encoder, messageSync);
          var syncMessageType = decoding.peekVarUint(decoder);
          doc.mux(function () {
            var opts = {};
            if (syncMessageType === syncProtocol.messageYjsSyncStep2 && doc.conf.useV2Encoder !== false) {
              opts.updateEncoderVersion = 2;
            }
            var syncMessageProcessedType = syncProtocol.readSyncMessage(decoder, encoder, doc, 'remote', opts);
            if (syncMessageProcessedType === 1) {
              console.timeEnd('[' + params.editorId + '] editor connection-to-receive-sync-step-2');
              if (!doc._initialSyncComplete) {
                doc._initialSyncComplete = true;
                doc.emit('synced', []);
                websocketPool.onDocSynced(doc);
              }
              doc._changed = false;
            }
          });
          break;
        case messageAuth:
          Y.authProtocol.readAuthMessage(decoder, doc, permissionDeniedHandler);
          break;
        case messageQueryAwareness:
          encoding.writeVarUint(encoder, messageAwareness);
          encoding.writeVarUint8Array(encoder, awarenessProtocol.encodeAwarenessUpdate(doc.awareness, Array.from(doc.awareness.getStates().keys())));
          break;
        case messageAwareness:
          awarenessProtocol.applyAwarenessUpdate(doc.awareness, decoding.readVarUint8Array(decoder), room);
          break;
      }
      return encoder;
    };
    var readControlMessage = function readControlMessage(buf) {
      if (buf.byteLength !== 1) {
        return;
      }
      var arr = new Uint8Array(buf);
      var compare = [messagePing, messagePong];
      return compare.find(function (item) {
        return item === arr[0];
      });
    };
    var respondControlMessage = function respondControlMessage(doc, controlMessage) {
      if (controlMessage === messagePing) {
        // sending pong
        if (doc.ws) {
          doc.ws.send(new Uint8Array([messagePong]).buffer);
        } else {
          logger.warn('doc.ws is not set, can not send ping reponse');
        }
      }
    };
    var readAndRespondMesage = function readAndRespondMesage(doc, buf) {
      var constrolMessage = readControlMessage(buf);
      if (constrolMessage) {
        return respondControlMessage(doc, constrolMessage);
      }
      var websocket = doc.ws;
      var encoder = readMessage(doc, buf);
      if (encoder && encoding.length(encoder) > 1) {
        websocket.send(encoding.toUint8Array(encoder));
      }
    };

    // число безуспешных попыток переконнектится по сокету, используется в exponential backoff
    var reconnectionAttempts = 0;
    var setupWS = function setupWS(doc, conf) {
      var isReconnect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (!doc.url) {
        console.info('doc.url was not set');
        return;
      }
      if (doc.ws && doc.wsconnected) {
        console.warn('setupWS was called, but ws is connected successfully for the document, skip');
        return;
      }
      if (doc.ws) {
        console.warn('[' + params.editorId + '] closing connecting websocket connection in favor of a new one');
        doc.ws.close();
      }
      console.time('[' + params.editorId + '] editor ws connection');
      var connectURL = doc.url;
      if (doc.url.indexOf('?') >= 0) {
        connectURL += '&';
      } else {
        connectURL += '?';
      }
      connectURL += 'ratempt=' + reconnectionAttempts;
      connectURL += '&widx=' + websocketPool.getLastWsId();
      connectURL += '&encv2=' + (conf.useV2Encoder !== false ? 'true' : 'false');
      connectURL += '&timezone=' + (0,utils/* getTimeZone */.Z)();
      if (conf.startFromEmptyState && !isReconnect) {
        connectURL += '&syncStep1=' + btoa(String.fromCharCode.apply(null, new Uint8Array(getEmptyStateSet())));
      }
      console.log('[' + params.editorId + '] connect websocket to', connectURL);
      var websocket = websocketPool.connect(connectURL, {
        enableSwitch: conf.enableSwitch
      });
      websocket.binaryType = 'arraybuffer';
      doc.ws = websocket;
      websocket.onmessage = function (event) {
        if (doc.ws !== websocket) {
          console.warn('[' + params.editorId + '] websocket received a message, but it is not the active one for document, ignore');
          return;
        }
        readAndRespondMesage(doc, new Uint8Array(event.data));
      };
      websocket.onclose = function () {
        if (websocket !== doc.ws) {
          console.warn('[' + params.editorId + '] websocket has closed, but it is not the active one for document, ignore closing');
          return;
        }
        console.timeEnd('[' + params.editorId + '] editor ws connection');
        console.warn('websocket has closed');
        doc.ws = null;
        doc.wsconnected = false;
        // update awareness (all users except local left)
        awarenessProtocol.removeAwarenessStates(doc.awareness, Array.from(doc.awareness.getStates().keys()).filter(function (client) {
          return client !== doc.clientID;
        }), doc);
        try {
          doc.emit('status', [{
            status: 'disconnected'
          }]);
        } catch (err) {
          // this happens if the document is destroyed
        }
        if (!doc.destroyed) {
          var reconnect = true;
          if (doc.conf.disconnectWhenSynced && doc._initialSyncComplete) {
            reconnect = false;
          }
          if (reconnect) {
            logger.log('document is still alive, will try to reconnect');
            var tryReconnect = true;
            if (typeof navigator !== 'undefined' && typeof navigator.onLine !== 'undefined') {
              if (navigator.onLine === false) {
                tryReconnect = false;
                logger.log('postponing connection to websocket until browser is online');
                var onOnlineListener = function onOnlineListener() {
                  window.removeEventListener('online', onOnlineListener, false);
                  if (!doc.destroyed) {
                    setupWS(doc, {}, true);
                  }
                };
                window.addEventListener('online', onOnlineListener, false);
              }
            }
            if (tryReconnect) {
              var reconnectTimeout = Math.min(Math.pow(backoffBase, reconnectionAttempts), maxBackoff) * 1000 + Math.round(Math.random() * 1000);
              logger.log('schedule reconnecting in', reconnectTimeout, 'ms,', 'attempt', reconnectionAttempts);
              reconnectionAttempts++;
              // if document is still alive(not destroyed) and browser is online try to reconnect
              doc.wsReconnectTimeout = setTimeout(setupWS, reconnectTimeout, doc, {}, true);
            }
          }
        }
      };
      websocket.onopen = function () {
        reconnectionAttempts = 0;
        if (websocket !== doc.ws) {
          console.warn('[' + params.editorId + '] websocket has opened, but it is not the active one for document, ignore opening');
          return;
        }
        console.timeEnd('[' + params.editorId + '] editor ws connection');
        console.time('[' + params.editorId + '] editor connection-to-receive-sync-step-2');
        doc.wsconnected = true;
        doc.emit('status', [{
          status: 'connected'
        }]);
        if (!conf.startFromEmptyState || isReconnect) {
          // always send sync step 1 when connected if it has not been sent in the url
          var encoder = encoding.createEncoder();
          encoding.writeVarUint(encoder, messageSync);
          syncProtocol.writeSyncStep1(encoder, doc);
          websocket.send(encoding.toUint8Array(encoder));
        }
        // broadcast local awareness state
        if (doc.awareness.getLocalState() !== null) {
          var encoderAwarenessState = encoding.createEncoder();
          encoding.writeVarUint(encoderAwarenessState, messageAwareness);
          encoding.writeVarUint8Array(encoderAwarenessState, awarenessProtocol.encodeAwarenessUpdate(doc.awareness, [doc.clientID]));
          websocket.send(encoding.toUint8Array(encoderAwarenessState));
        }
      };
      websocket.onerror = function (err) {
        console.error('[' + params.editorId + '] websocket error:', err, 'connected before:', doc.wsconnected);
      };
    };
    var isDumpChanged = function isDumpChanged(y) {
      return !y._changed && y._dumpInited && !y._initialSyncComplete;
    };
    var isDocChangedAfterDisconnect = function isDocChangedAfterDisconnect(y) {
      return !y._changed && y._initialSyncComplete && (!y.ws || y.ws && !y.ws.ws);
    };
    var broadcastUpdate = function broadcastUpdate(update, origin, y) {
      if (getUpdateOrigin(origin) !== 'remote') {
        // если документ подгружен через дамп и были изменения
        // помечаем документ как именённый

        if (isDumpChanged(y) || isDocChangedAfterDisconnect(y)) {
          y._changed = true;
          y._initialSyncComplete = false;
          websocketPool.setDoc(y);
        }
        var encoder = encoding.createEncoder();
        encoding.writeVarUint(encoder, messageSync);
        syncProtocol.writeUpdate(encoder, update);
        var buf = encoding.toUint8Array(encoder);
        if (y.wsconnected) {
          // @ts-ignore We know that wsconnected = true
          y.ws.send(buf);
        }
      }
    };
    var broadcastMessage = function broadcastMessage(provider, buf) {
      if (provider.wsconnected) {
        provider.ws.send(buf);
      }
    };
    var WebsocketsProvider = /*#__PURE__*/function (_Y$Doc) {
      createDocument_inherits(WebsocketsProvider, _Y$Doc);
      var _super = createDocument_createSuper(WebsocketsProvider);
      function WebsocketsProvider(_url) {
        var _this;
        var conf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        createDocument_classCallCheck(this, WebsocketsProvider);
        _this = _super.call(this, {
          gc: conf.gc
        });
        _defineProperty(createDocument_assertThisInitialized(_this), "_awarenessUpdateHandler", function (_ref2, origin) {
          var added = _ref2.added,
            updated = _ref2.updated,
            removed = _ref2.removed;
          var changedClients = added.concat(updated).concat(removed);
          var encoder = encoding.createEncoder();
          encoding.writeVarUint(encoder, messageAwareness);
          encoding.writeVarUint8Array(encoder, awarenessProtocol.encodeAwarenessUpdate(_this.awareness, changedClients));
          broadcastMessage(createDocument_assertThisInitialized(_this), encoding.toUint8Array(encoder));
          _this.mux = createMutex();
          _this.on('subdocs', _this.onSubDocs);
        });
        _defineProperty(createDocument_assertThisInitialized(_this), "onSubDocs", function (_ref3) {
          var added = _ref3.added,
            removed = _ref3.removed,
            loaded = _ref3.loaded;
          if (added.size) {
            console.log('added subdocs', added);
          }
          if (removed.size) {
            console.log('removed subdocs', removed);
          }
          if (loaded.size) {
            console.log('loaded subdocs', loaded);
            var _iterator = createDocument_createForOfIteratorHelper(loaded),
              _step;
            try {
              var _loop = function _loop() {
                var subDoc = _step.value;
                var urlParts = _this.url.split('/');
                urlParts.pop();
                var url = urlParts.join('/');
                subDoc.url = url + '/sub_' + subDoc.guid;
                subDoc.mux = createMutex();
                subDoc.conf = _this.conf;
                setupWS(subDoc, _this.conf);
                subDoc.on('update', broadcastUpdate);
                subDoc.on('synced', function () {
                  subDoc.loaded = true;
                  setTimeout(function () {
                    subDoc.emit('loaded', []);
                  }, 1000);
                });
              };
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                _loop();
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
        });
        _defineProperty(createDocument_assertThisInitialized(_this), "_beforeUnloadHandler", function () {
          awarenessProtocol.removeAwarenessStates(_this.awareness, [_this.clientID], 'window unload');
        });
        _defineProperty(createDocument_assertThisInitialized(_this), "onDocSynced", function () {
          if (_this.conf.disconnectWhenSynced) {
            _this.ws.close({
              final: true
            });
          }
        });
        _this.gc = typeof conf.gc !== 'undefined' ? conf.gc : true;
        _this.url = _url;
        _this.destroyed = false;
        _this.wsconnected = false;
        _this.ws = null;
        _this.wsReconnectTimeout = null;
        _this.conf = conf;
        _this.docName = conf.docName;
        _this.awareness = new awarenessProtocol.Awareness(createDocument_assertThisInitialized(_this));
        // для обеспечения нормальной работы некоторых функций(поиск в заметке) необходимо остановить обработку
        // приходящих по вебсокету операций. данные операции накапливаются в externalUpdatesBacklog и при вызове
        // resumeExternalUpdates исполняются
        _this.externalUpdatesBacklog = [];
        _this.isExternalUpdatesPaused = false;
        if (params.providerConfig && params.providerConfig.persistence) {
          var docName = _this.conf.docName;
          var _params$providerConfi = params.providerConfig,
            persistence = _params$providerConfi.persistence,
            _params$providerConfi2 = _params$providerConfi.onAfterPersistenceBindState,
            onAfterPersistenceBindState = _params$providerConfi2 === void 0 ? null : _params$providerConfi2;
          persistence.bindState(docName, createDocument_assertThisInitialized(_this)).then(function () {
            if (!_this.url) {
              _this.emit('synced', []);
            }
            // если в параметрах переданна функция onAfterPersistenceBindState
            // нужно для того чтобы выполнить какие-либо действия после bindState
            if (onAfterPersistenceBindState) {
              onAfterPersistenceBindState(createDocument_assertThisInitialized(_this));
            }
          });
        }
        if (!conf.hasOwnProperty('connectToSocket') || conf.connectToSocket) {
          setupWS(createDocument_assertThisInitialized(_this), conf);
        }
        _this.mux = createMutex();
        _this.on('update', broadcastUpdate);
        _this.on('synced', _this.onDocSynced);
        _this.awareness.on('update', _this._awarenessUpdateHandler);
        if (typeof window !== 'undefined') {
          window.addEventListener('beforeunload', _this._beforeUnloadHandler);
        }
        return _this;
      }
      createDocument_createClass(WebsocketsProvider, [{
        key: "readBuffer",
        value: function readBuffer(buf) {
          var decoder = decoding.createDecoder(buf);
          syncProtocol.readSyncMessage(decoder, encoding.createEncoder(), this, 'remote');
        }
      }, {
        key: "pauseExternalUpdates",
        value: function pauseExternalUpdates() {
          this.isExternalUpdatesPaused = true;
        }
      }, {
        key: "resumeExternalUpdates",
        value: function resumeExternalUpdates() {
          this.isExternalUpdatesPaused = false;
          var _iterator2 = createDocument_createForOfIteratorHelper(this.externalUpdatesBacklog),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var buf = _step2.value;
              readAndRespondMesage(this, buf);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      }, {
        key: "sendSyncToken",
        value: function sendSyncToken(token, url) {
          if (!token) {
            console.error('sendSyncToken: empty token was submitted:, token:', token, 'url:', url, 'skip');
            return;
          }
          logger.info('editor #sendSyncToken, token:', token, 'url:', url);
          if (url) {
            this.url = url;
          }
          if (!this.wsconnected) {
            if (!url) {
              return logger.warn('sendSyncToken: ws is not connected and url is not specified, aborting');
            }
            try {
              clearTimeout(this.wsReconnectTimeout);
            } catch (err) {}
            logger.info('reconnecting ws was initiated by sendSyncToken');
            setupWS(this, this.conf);
          } else {
            logger.info('Sending token to the server', token);
            var encoder = encoding.createEncoder();
            encoding.writeVarUint(encoder, messageNmbToken);
            encoding.writeVarString(encoder, token);
            try {
              this.ws.send(encoding.toUint8Array(encoder));
            } catch (err) {
              if (window.Raven && window.Raven.captureException) {
                window.Raven.captureException(new Error('could not send sync token to the server: ' + err.message));
              }
              console.error('could not send sync token to the server:', err);
            }
          }
        }

        /**
         * sends custom message to the server
         * @param {string} type message type
         * @param {*} body any JSON serializable object
         * @returns
         */
      }, {
        key: "sendCustomMessage",
        value: function sendCustomMessage(type, body) {
          if (!this.wsconnected) {
            return logger.warn('sendCustomMessage: ws is not connected, aborting');
          }
          var encoder = encoding.createEncoder();
          encoding.writeVarUint(encoder, messageCustom);
          encoding.writeVarString(encoder, JSON.stringify({
            type: type,
            body: body
          }));
          this.ws.send(encoding.toUint8Array(encoder));
        }
      }, {
        key: "destroy",
        value: function destroy() {
          logger.log('[editor] destroying yDocument...');
          this.destroyed = true;
          _get(createDocument_getPrototypeOf(WebsocketsProvider.prototype), "destroy", this).call(this);
          if (this.ws) {
            var opts = {};
            if (this.conf && this.conf.disablePooling) {
              opts.final = true;
            }
            this.ws.close(opts);
          }
          this.awareness.off('update', this._awarenessUpdateHandler);
        }
      }, {
        key: "isChangedWithoutSave",
        value: function isChangedWithoutSave() {
          return this._changed;
        }
      }, {
        key: "wspoolHasChangedWithoutSave",
        value: function wspoolHasChangedWithoutSave() {
          return websocketPool.docs.length;
        }
      }]);
      return WebsocketsProvider;
    }(Y.Doc);
    var doc = new WebsocketsProvider(params.url, Object.assign({}, params.providerConfig, {
      userID: params.userID
    }));
    return doc;
  };
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/providers/websocket.js
/**
 * slightly modified original WebSocket provider from Yjs
 * no concepts of rooms, it connects to a URL and that is it
 * one provider - one note
 *
 * broadcast channel is removed
 *
 * to create a document it is needed to only call create with Y and document params
 */








var createDocument = createDocumentConstructor(mutex/* createMutex */.M, encoding, decoding, sync, auth_namespaceObject, awareness);

/***/ }),

/***/ 77510:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ InfiniteLoader)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30489);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12419);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79758);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }









function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var InfiniteLoader = /*#__PURE__*/function (_Component) {
  _inherits(InfiniteLoader, _Component);
  var _super = _createSuper(InfiniteLoader);
  function InfiniteLoader() {
    _classCallCheck(this, InfiniteLoader);
    return _super.apply(this, arguments);
  }
  _createClass(InfiniteLoader, [{
    key: "render",
    value: function render() {
      var height = this.props.height;
      var style = {};
      if (height) {
        style.height = height + 'px';
      }
      return (0,preact__WEBPACK_IMPORTED_MODULE_9__.h)("div", {
        style: style,
        className: "editor-loader2-grey editor-loader-cc editor-loader-default-size"
      });
    }
  }]);
  return InfiniteLoader;
}(preact__WEBPACK_IMPORTED_MODULE_9__/* .Component */ .wA);


/***/ }),

/***/ 49096:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ PopupDialog)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30489);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12419);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(79758);
/* harmony import */ var _theme_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(49190);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }










function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var PopupDialog = /*#__PURE__*/function (_Component) {
  _inherits(PopupDialog, _Component);
  var _super = _createSuper(PopupDialog);
  function PopupDialog() {
    var _this;
    _classCallCheck(this, PopupDialog);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "onRef", function (node) {
      _this.node = node;
    });
    _defineProperty(_assertThisInitialized(_this), "onClose", function (event) {
      event.preventDefault();
      _this.props.wantsToClose();
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (event) {
      if (event.target === _this.node || event.target.closest('.popup-dialog-control')) {
        // запрещаем дефолтное действие при нажатии на диалог и его контролы, предотвращает выделение всего окна
        // при нажатии на него в ФФ на маке
        event.preventDefault();
      }
    });
    _this.node = null;
    return _this;
  }
  _createClass(PopupDialog, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        addClassName = _this$props.addClassName,
        noCloseButton = _this$props.noCloseButton;
      var closeButton = '';
      if (!noCloseButton) {
        closeButton = (0,preact__WEBPACK_IMPORTED_MODULE_10__.h)("span", {
          className: "close-popup popup-dialog-control",
          onClick: this.onClose
        }, (0,preact__WEBPACK_IMPORTED_MODULE_10__.h)(_theme_icons__WEBPACK_IMPORTED_MODULE_11__/* .IconClose */ .bMz, null));
      }
      return (0,preact__WEBPACK_IMPORTED_MODULE_10__.h)("div", {
        ref: this.onRef,
        onMouseDown: this.onMouseDown,
        className: 'popup-dialog ' + (addClassName ? addClassName : '')
      }, closeButton, this.props.children);
    }
  }]);
  return PopupDialog;
}(preact__WEBPACK_IMPORTED_MODULE_10__/* .Component */ .wA);


/***/ }),

/***/ 19617:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ PopupDialogBody)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79758);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PopupDialogBody = /*#__PURE__*/function () {
  function PopupDialogBody() {
    _classCallCheck(this, PopupDialogBody);
  }
  _createClass(PopupDialogBody, [{
    key: "render",
    value: function render() {
      var addClassName = this.props.addClassName;
      var props = Object.assign({}, this.props);
      delete props.addClassName;
      return (0,preact__WEBPACK_IMPORTED_MODULE_1__.h)("div", _extends({}, props, {
        className: 'popup-dialog-body ' + (addClassName ? addClassName : '')
      }), this.props.children);
    }
  }]);
  return PopupDialogBody;
}();


/***/ }),

/***/ 25251:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ PopupDialogButtons)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21249);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79758);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PopupDialogButtons = /*#__PURE__*/function () {
  function PopupDialogButtons() {
    _classCallCheck(this, PopupDialogButtons);
    _defineProperty(this, "onMouseDown", function (event) {
      event.preventDefault();
      event.stopPropagation();
    });
  }
  _createClass(PopupDialogButtons, [{
    key: "onButtonClick",
    value: function onButtonClick(key, button, event) {
      var wantsToClose = this.props.wantsToClose;
      if (button.onClick) {
        button.onClick(event);
      }
      if (key == 'cancel') {
        wantsToClose && wantsToClose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        addClassName = _this$props.addClassName,
        buttons = _this$props.buttons,
        editor = _this$props.editor,
        _this$props$revertBut = _this$props.revertButtons,
        revertButtons = _this$props$revertBut === void 0 ? false : _this$props$revertBut;
      var i18n = editor.plugins.i18n;
      var buttonSet = (revertButtons ? Object.keys(buttons).reverse() : Object.keys(buttons)).map(function (key) {
        var button = buttons[key];
        var text = button.text ? button.text : '';
        if (!text) {
          text = i18n.get("dialog_common.button.".concat(key)) || key;
        }
        return (0,preact__WEBPACK_IMPORTED_MODULE_2__.h)("span", {
          className: 'dialog-button ' + (button.style ? 'dialog-button-' + button.style : ''),
          onClick: _this.onButtonClick.bind(_this, key, button),
          onMouseDown: _this.onMouseDown
        }, text);
      });
      return (0,preact__WEBPACK_IMPORTED_MODULE_2__.h)("div", {
        className: 'popup-dialog-buttons ' + (addClassName ? addClassName : '')
      }, buttonSet);
    }
  }]);
  return PopupDialogButtons;
}();


/***/ }),

/***/ 83483:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ PopupDialogTitle)
/* harmony export */ });
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79758);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PopupDialogTitle = /*#__PURE__*/function () {
  function PopupDialogTitle() {
    _classCallCheck(this, PopupDialogTitle);
  }
  _createClass(PopupDialogTitle, [{
    key: "render",
    value: function render() {
      var addClassName = this.props.addClassName;
      return (0,preact__WEBPACK_IMPORTED_MODULE_0__.h)("div", {
        className: 'popup-dialog-title popup-dialog-control ' + (addClassName ? addClassName : '')
      }, this.props.children);
    }
  }]);
  return PopupDialogTitle;
}();


/***/ }),

/***/ 10856:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ PopupMenu)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79758);
/* harmony import */ var _theme_scss_popup_menu_vars_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81578);
/* harmony import */ var _theme_scss_popup_menu_vars_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_theme_scss_popup_menu_vars_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _util_popup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92143);
/* harmony import */ var _util_popupMenuItemsNav__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28480);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21791);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var is_hotkey__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28199);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var menuItemHeight = parseInt(_theme_scss_popup_menu_vars_scss__WEBPACK_IMPORTED_MODULE_2__.menuItemHeight);
var menuPadding = parseInt(_theme_scss_popup_menu_vars_scss__WEBPACK_IMPORTED_MODULE_2__.menuPadding);
var isEnterKey = (0,is_hotkey__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)('enter');
var isEscKey = (0,is_hotkey__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)('esc');
var PopupMenu = /*#__PURE__*/function () {
  function PopupMenu(props) {
    var _this = this;
    _classCallCheck(this, PopupMenu);
    _defineProperty(this, "onRef", function (node) {
      _this.domNode = node;
      _this.props.domRef && _this.props.domRef(node);
      _this.popper = null;
    });
    _defineProperty(this, "disableRecycling", function () {
      _this.nextBase = null;
    });
    _defineProperty(this, "onResize", function () {
      _this.popper.destroy();
      _this.createPopper();
    });
    _defineProperty(this, "onResizeDebounce", lodash_debounce__WEBPACK_IMPORTED_MODULE_5___default()(this.onResize, 200, {
      trailing: true
    }));
    _defineProperty(this, "onBodyMouseDown", function (event) {
      var target = event.target;
      if (target === _this.domNode || _this.domNode.contains(target)) {
        return;
      }
      _this.props.wantsToClose(event);
    });
    _defineProperty(this, "onBodyKeyDown", function (event) {
      var _this$props = _this.props,
        closeOnEsc = _this$props.closeOnEsc,
        onEnterAction = _this$props.onEnterAction,
        wantsToClose = _this$props.wantsToClose;
      if (isEscKey(event) && closeOnEsc && wantsToClose) {
        event.stopPropagation();
        var menues = _this.domNode && _this.domNode.getElementsByClassName('popup-menu');
        if (menues && menues.length === 0) {
          wantsToClose(event);
        }
      } else if (isEnterKey(event) && onEnterAction) {
        event.stopPropagation();
        var args = [event];
        if (_this.keyNavigator) {
          var item = _this.keyNavigator.getSelected();
          args.push(item);
        }
        onEnterAction.apply(void 0, args);
        wantsToClose && wantsToClose();
      } else if (_this.keyNavigator) {
        _this.keyNavigator.handleEvent(event);
      }
    });
    var keyNavigation = props.keyNavigation,
      _props$keyNavigationP = props.keyNavigationParams,
      keyNavigationParams = _props$keyNavigationP === void 0 ? {} : _props$keyNavigationP;
    var navParams = Object.assign({}, {
      popup: this,
      selector: '.menu-item',
      selectedClass: 'menu-item-selected'
    }, keyNavigationParams);
    this.keyNavigator = keyNavigation ? new _util_popupMenuItemsNav__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z(navParams) : false;
    this.resizeObserver = null;
  }
  _createClass(PopupMenu, [{
    key: "createPopper",
    value: function createPopper() {
      var _this$props2 = this.props,
        anchorNode = _this$props2.anchorNode,
        anchorOptions = _this$props2.anchorOptions,
        removeOnPopperDestroy = _this$props2.removeOnPopperDestroy;
      this.popper = (0,_util_popup__WEBPACK_IMPORTED_MODULE_3__/* .createPopper */ .f)(anchorNode, this.domNode, Object.assign({}, {
        removeOnDestroy: removeOnPopperDestroy || false
      }, anchorOptions));
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      // если установлено свойство freeze, то компонент не будет менятся, это удобно использовать в транзициях скрытия, когда
      // состояние среды поменялось, но оно не должно быть отражено на меню, т.е. меню должно закрытся таким каким было
      // при начале скрытия
      if (this.props.freeze || nextProps.freeze) {
        return false;
      }
      return true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var anchorNode = this.props.anchorNode;
      if (anchorNode && prevProps.anchorNode !== anchorNode) {
        this.popper.destroy();
        this.createPopper();
      } else {
        this.popper && this.popper.update && this.popper.update();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props3 = this.props,
        wantsToClose = _this$props3.wantsToClose,
        anchorNode = _this$props3.anchorNode;
      if (wantsToClose) {
        // используем таймаут чтобы подождать пока обработается event, который привел к открытию меню
        this.dispatchEventTimeout = setTimeout(function () {
          // отлавливаем нажатие мыши на теле документа и просим родительский компонент закрыть меню если нужно
          document.body.addEventListener('mousedown', _this2.onBodyMouseDown);
        }, 0);
      }
      document.body.addEventListener('keydown', this.onBodyKeyDown);
      if (anchorNode) {
        this.createPopper();
      }
      if (this.props.listenSizeChange) {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.domNode);
        window.addEventListener('resize', this.onResizeDebounce);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.dispatchEventTimeout) {
        clearTimeout(this.dispatchEventTimeout);
      }
      document.body.removeEventListener('mousedown', this.onBodyMouseDown);
      document.body.removeEventListener('keydown', this.onBodyKeyDown);
      if (this.popper) {
        this.popper.destroy();
      }
      if (this.props.listenSizeChange) {
        this.resizeObserver.disconnect();
        window.removeEventListener('resize', this.onResizeDebounce);
      }
      setTimeout(this.disableRecycling);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        maxHeight = _this$props4.maxHeight,
        addClassName = _this$props4.addClassName,
        customStyles = _this$props4.customStyles;
      var style = Object.assign({}, customStyles && customStyles || {});
      if (maxHeight) {
        // подготовливаем размер меню так, чтобы показывались пункты меню целиком при первом рендере
        // в рамках максимальной высоты
        var maxHeightStyle = Math.floor((maxHeight - menuPadding) / menuItemHeight) * menuItemHeight;
        style.maxHeight = maxHeightStyle + menuPadding + (style.overflowY === 'visible' ? menuPadding : 0) + 'px';
      }
      return (0,preact__WEBPACK_IMPORTED_MODULE_1__.h)("div", {
        style: style,
        className: 'popup-menu ' + (addClassName || ''),
        ref: this.onRef,
        onMouseDown: this.props.onMouseDown,
        onMouseEnter: this.props.onMouseEnter,
        onMouseLeave: this.props.onMouseLeave
      }, this.props.children);
    }
  }]);
  return PopupMenu;
}();


/***/ }),

/***/ 28411:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ PopupMenuItem)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69600);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30489);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12419);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(79758);
/* harmony import */ var _theme_scss_vars_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(20199);
/* harmony import */ var _theme_scss_vars_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_theme_scss_vars_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _theme_icons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(49190);
/* harmony import */ var preact_transition_group__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(49839);
/* harmony import */ var is_hotkey__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(28199);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }











function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var isEscKey = (0,is_hotkey__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)('esc');
var PopupMenuItem = /*#__PURE__*/function (_Component) {
  _inherits(PopupMenuItem, _Component);
  var _super = _createSuper(PopupMenuItem);
  function PopupMenuItem(props) {
    var _this;
    _classCallCheck(this, PopupMenuItem);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "disableRecycling", function () {
      _this.nextBase = null;
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function (event) {
      if (_this.props.submenu) {
        _this.setState(function () {
          return {
            submenuVisible: true
          };
        });
      }
      if (_this.props.onMenuItemEnter) {
        _this.props.onMenuItemEnter(event);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      if (_this.props.submenu) {
        _this.setState(function () {
          return {
            submenuVisible: false
          };
        });
      }
      if (_this.props.onMenuItemLeave) {
        _this.props.onMenuItemLeave();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseMove", function (event) {
      if (_this.props.onMenuItemMouseMove) {
        _this.props.onMenuItemMouseMove(event);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onRef", function (node) {
      _this.domNode = node;
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (event) {
      // чтобы не происходила смена range отменяем действие браузера по умолчанию
      event.preventDefault();
      event.stopPropagation();
      _this.props.onMouseDown && _this.props.onMouseDown();
    });
    _defineProperty(_assertThisInitialized(_this), "onContextMenu", function (event) {
      event.preventDefault();
    });
    _defineProperty(_assertThisInitialized(_this), "onBodyKeyDown", function (event) {
      if (isEscKey(event) && _this.props.submenu) {
        event.stopPropagation();
        _this.setState(function (prevState) {
          var submenuVisible = prevState.submenuVisible;
          if (submenuVisible) {
            var node = _this.props.submenu && _this.props.submenu.props && _this.props.submenu.props.anchorNode;
            if (node) {
              var currentSubmenu = node.lastChild && node.lastChild.firstChild && node.lastChild.firstChild.className;
              var menues = node.getElementsByClassName('popup-menu');
              if (menues.length === 1 || menues.length > 1 && currentSubmenu === 'popup-menu') {
                return {
                  submenuVisible: false
                };
              }
            }
          }
          return null;
        });
      }
    });
    _this.state = {
      submenuVisible: false
    };
    _this.domNode = null;
    return _this;
  }
  _createClass(PopupMenuItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (this.props.submenu) {
        this.dispatchEventTimeout = setTimeout(function () {
          document.body.addEventListener('keydown', _this2.onBodyKeyDown);
        }, 0);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.dispatchEventTimeout) {
        clearTimeout(this.dispatchEventTimeout);
      }
      if (this.props.submenu) {
        document.body.removeEventListener('keydown', this.onBodyKeyDown);
      }
      setTimeout(this.disableRecycling);
    }
  }, {
    key: "render",
    value: function render() {
      var submenuVisible = this.state.submenuVisible;
      var _this$props = this.props,
        id = _this$props.id,
        idAttr = _this$props.idAttr,
        menuStyle = _this$props.menuStyle,
        disabled = _this$props.disabled,
        submenu = _this$props.submenu,
        text = _this$props.text,
        className = _this$props.className,
        isNew = _this$props.isNew;
      var hint = this.props.hint;
      var Icon = this.props.icon;
      var attrs = {};
      if (idAttr) {
        attrs[idAttr] = id;
      }
      var classNames = ['menu-item'];
      if (className) {
        classNames.push(className);
      }

      // Стили можно задавать массивом
      if (menuStyle) {
        if (menuStyle === 'link') {
          classNames.shift();
          classNames.push('link-menu-item');
        } else {
          var menuStyleArr = menuStyle;
          if (typeof menuStyleArr == "string") menuStyleArr = [menuStyleArr];
          for (var i in menuStyleArr) {
            classNames.push('menu-item-' + menuStyleArr[i]);
          }
        }
      }
      if (disabled) {
        classNames.push('disabled');
      }
      if (submenu && !hint) {
        hint = (0,preact__WEBPACK_IMPORTED_MODULE_11__.h)(_theme_icons__WEBPACK_IMPORTED_MODULE_13__/* .IconArrowRight */ .Ec8, null);
      }
      var submenuContainer = null;
      if (submenu) {
        submenu.props.anchorNode = this.domNode;
        var submenuIfVisible = submenuVisible ? submenu : null;
        submenuContainer = (0,preact__WEBPACK_IMPORTED_MODULE_11__.h)(preact_transition_group__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
          transitionName: "popup-menu",
          transitionEnterTimeout: _theme_scss_vars_scss__WEBPACK_IMPORTED_MODULE_12__.popupAppearDuration,
          transitionLeaveTimeout: _theme_scss_vars_scss__WEBPACK_IMPORTED_MODULE_12__.popupAppearDuration
        }, submenuIfVisible);
      }
      var isNewLabel = null;
      if (isNew) {
        isNewLabel = (0,preact__WEBPACK_IMPORTED_MODULE_11__.h)("span", {
          className: "is-new"
        }, "New");
      }
      return (0,preact__WEBPACK_IMPORTED_MODULE_11__.h)("div", _extends({}, attrs, {
        ref: this.onRef,
        "data-menu-id": id,
        onClick: this.props.onClick,
        onMouseDown: this.onMouseDown,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        onMouseMove: this.onMouseMove,
        onContextMenu: this.onContextMenu,
        className: classNames.join(' ')
      }), Icon ? (0,preact__WEBPACK_IMPORTED_MODULE_11__.h)("div", {
        className: "icon"
      }, (0,preact__WEBPACK_IMPORTED_MODULE_11__.h)(Icon, null)) : null, (0,preact__WEBPACK_IMPORTED_MODULE_11__.h)("div", {
        className: "text"
      }, text, isNewLabel), hint ? (0,preact__WEBPACK_IMPORTED_MODULE_11__.h)("div", {
        className: "hint"
      }, hint) : null, submenuContainer);
    }
  }]);
  return PopupMenuItem;
}(preact__WEBPACK_IMPORTED_MODULE_11__/* .Component */ .wA);


/***/ }),

/***/ 2049:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "base64ToArrayBuffer": () => (/* binding */ base64ToArrayBuffer),
/* harmony export */   "getDumpByURL": () => (/* binding */ getDumpByURL)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_typed_array_uint8_array_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82472);
/* harmony import */ var core_js_modules_es_typed_array_uint8_array_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_uint8_array_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_typed_array_copy_within_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92990);
/* harmony import */ var core_js_modules_es_typed_array_copy_within_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_copy_within_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_typed_array_every_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18927);
/* harmony import */ var core_js_modules_es_typed_array_every_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_every_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_typed_array_fill_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33105);
/* harmony import */ var core_js_modules_es_typed_array_fill_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_fill_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_typed_array_filter_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35035);
/* harmony import */ var core_js_modules_es_typed_array_filter_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_filter_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_typed_array_find_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74345);
/* harmony import */ var core_js_modules_es_typed_array_find_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_find_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_typed_array_find_index_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7174);
/* harmony import */ var core_js_modules_es_typed_array_find_index_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_find_index_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_typed_array_for_each_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32846);
/* harmony import */ var core_js_modules_es_typed_array_for_each_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_for_each_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_typed_array_includes_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(44731);
/* harmony import */ var core_js_modules_es_typed_array_includes_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_includes_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_typed_array_index_of_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(77209);
/* harmony import */ var core_js_modules_es_typed_array_index_of_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_index_of_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_typed_array_iterator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96319);
/* harmony import */ var core_js_modules_es_typed_array_iterator_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_iterator_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_typed_array_join_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(58867);
/* harmony import */ var core_js_modules_es_typed_array_join_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_join_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_typed_array_last_index_of_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(37789);
/* harmony import */ var core_js_modules_es_typed_array_last_index_of_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_last_index_of_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_typed_array_map_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(33739);
/* harmony import */ var core_js_modules_es_typed_array_map_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_map_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_typed_array_reduce_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(29368);
/* harmony import */ var core_js_modules_es_typed_array_reduce_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_reduce_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_typed_array_reduce_right_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(14483);
/* harmony import */ var core_js_modules_es_typed_array_reduce_right_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_reduce_right_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_typed_array_reverse_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(12056);
/* harmony import */ var core_js_modules_es_typed_array_reverse_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_reverse_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_typed_array_set_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(3462);
/* harmony import */ var core_js_modules_es_typed_array_set_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_set_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_typed_array_slice_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(30678);
/* harmony import */ var core_js_modules_es_typed_array_slice_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_slice_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_typed_array_some_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(27462);
/* harmony import */ var core_js_modules_es_typed_array_some_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_some_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_typed_array_sort_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(33824);
/* harmony import */ var core_js_modules_es_typed_array_sort_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_sort_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_typed_array_subarray_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(55021);
/* harmony import */ var core_js_modules_es_typed_array_subarray_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_subarray_js__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_es_typed_array_to_locale_string_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(12974);
/* harmony import */ var core_js_modules_es_typed_array_to_locale_string_js__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_to_locale_string_js__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_es_typed_array_to_string_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(15016);
/* harmony import */ var core_js_modules_es_typed_array_to_string_js__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_to_string_js__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(26699);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(32023);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_27__);




























function base64ToArrayBuffer(base64) {
  var binary_string = window.atob(base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes;
}
function getDumpByURL(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    method: 'GET'
  };
  var allowStatusCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [200];
  return new Promise(function (resolve, reject) {
    fetch(url, params).then(function (res) {
      if (!allowStatusCode.includes(+res.status)) {
        return reject("Status code is ".concat(res.status));
      }
      return res.blob();
    }).then(function (blob) {
      var reader = new FileReader();
      reader.onloadend = function (e) {
        resolve(new Uint8Array(reader.result));
      };
      reader.onerror = function () {
        throw Error('Error read file as ArrayBuffer');
      };
      reader.readAsArrayBuffer(blob);
    }).catch(function (err) {
      console.error(err);
      reject();
    });
  });
}

/***/ }),

/***/ 62785:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ATTACH_GLOBAL_ID_HTML_ATTR": () => (/* reexport */ ATTACH_GLOBAL_ID_HTML_ATTR),
  "AttachmentNotFoundError": () => (/* reexport */ attachmentNotFoundError["default"]),
  "BLOT_COUNT_TYPES": () => (/* reexport */ BLOT_COUNT_TYPES),
  "CHECKBOX_ELEM_CLASS": () => (/* reexport */ CHECKBOX_ELEM_CLASS),
  "FILE_NAME_HTML_ATTR": () => (/* reexport */ FILE_NAME_HTML_ATTR),
  "IMAGE_ORIGINAL_HEIGHT_ATTR": () => (/* reexport */ IMAGE_ORIGINAL_HEIGHT_ATTR),
  "IMAGE_ORIGINAL_WIDTH_ATTR": () => (/* reexport */ IMAGE_ORIGINAL_WIDTH_ATTR),
  "ToHTMLContext": () => (/* reexport */ ToHTMLContext),
  "initEditor": () => (/* binding */ initEditor),
  "yUtil": () => (/* reexport */ util_y)
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(19601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.uint8-array.js
var es_typed_array_uint8_array = __webpack_require__(82472);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.copy-within.js
var es_typed_array_copy_within = __webpack_require__(92990);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.every.js
var es_typed_array_every = __webpack_require__(18927);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.fill.js
var es_typed_array_fill = __webpack_require__(33105);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.filter.js
var es_typed_array_filter = __webpack_require__(35035);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.find.js
var es_typed_array_find = __webpack_require__(74345);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.find-index.js
var es_typed_array_find_index = __webpack_require__(7174);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.for-each.js
var es_typed_array_for_each = __webpack_require__(32846);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.includes.js
var es_typed_array_includes = __webpack_require__(44731);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.index-of.js
var es_typed_array_index_of = __webpack_require__(77209);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.iterator.js
var es_typed_array_iterator = __webpack_require__(96319);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.join.js
var es_typed_array_join = __webpack_require__(58867);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.last-index-of.js
var es_typed_array_last_index_of = __webpack_require__(37789);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.map.js
var es_typed_array_map = __webpack_require__(33739);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reduce.js
var es_typed_array_reduce = __webpack_require__(29368);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reduce-right.js
var es_typed_array_reduce_right = __webpack_require__(14483);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reverse.js
var es_typed_array_reverse = __webpack_require__(12056);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.set.js
var es_typed_array_set = __webpack_require__(3462);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.slice.js
var es_typed_array_slice = __webpack_require__(30678);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.some.js
var es_typed_array_some = __webpack_require__(27462);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.sort.js
var es_typed_array_sort = __webpack_require__(33824);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.subarray.js
var es_typed_array_subarray = __webpack_require__(55021);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.to-locale-string.js
var es_typed_array_to_locale_string = __webpack_require__(12974);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.to-string.js
var es_typed_array_to_string = __webpack_require__(15016);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__(26833);
// EXTERNAL MODULE: ./node_modules/yjs/dist/yjs.mjs + 26 modules
var yjs = __webpack_require__(51718);
// EXTERNAL MODULE: ./node_modules/@lib/editor/providers/websocket.js + 6 modules
var websocket = __webpack_require__(65224);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(54747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(32023);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(15306);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(69600);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__(69826);
// EXTERNAL MODULE: ./node_modules/@lib/editor/node_modules/parchment/dist/parchment.js
var parchment = __webpack_require__(26074);
var parchment_default = /*#__PURE__*/__webpack_require__.n(parchment);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(21249);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__(70189);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(57327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__(23123);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__(2707);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(9653);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.map.js
var es_map = __webpack_require__(51532);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__(73210);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(30489);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__(12419);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.get.js
var es_reflect_get = __webpack_require__(74819);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__(38880);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.string.match-all.js
var esnext_string_match_all = __webpack_require__(13728);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__(49337);
// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(87751);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url.to-json.js
var web_url_to_json = __webpack_require__(83753);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.splice.js
var es_array_splice = __webpack_require__(40561);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__(69720);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.ends-with.js
var es_string_ends_with = __webpack_require__(27852);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__(23157);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__(43290);
// EXTERNAL MODULE: ./node_modules/preact/dist/preact.module.js
var preact_module = __webpack_require__(79758);
// EXTERNAL MODULE: ./node_modules/quill-delta/dist/Delta.js
var dist_Delta = __webpack_require__(22463);
var Delta_default = /*#__PURE__*/__webpack_require__.n(dist_Delta);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/block.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }









function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var block_Block = /*#__PURE__*/function (_Parchment$Block) {
  _inherits(Block, _Parchment$Block);
  var _super = _createSuper(Block);
  function Block(domNode) {
    _classCallCheck(this, Block);
    return _super.call(this, domNode);
  }
  _createClass(Block, [{
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      var type = this.constructor.blotName || null;
      return {
        type: type,
        initParams: {}
      };
    }
  }]);
  return Block;
}((parchment_default()).Block);
/* harmony default export */ const block = (block_Block);
// EXTERNAL MODULE: ./node_modules/extend/index.js
var extend = __webpack_require__(40040);
var extend_default = /*#__PURE__*/__webpack_require__.n(extend);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/blockEmbed.js
function blockEmbed_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { blockEmbed_typeof = function _typeof(obj) { return typeof obj; }; } else { blockEmbed_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return blockEmbed_typeof(obj); }













function blockEmbed_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function blockEmbed_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function blockEmbed_createClass(Constructor, protoProps, staticProps) { if (protoProps) blockEmbed_defineProperties(Constructor.prototype, protoProps); if (staticProps) blockEmbed_defineProperties(Constructor, staticProps); return Constructor; }
function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = blockEmbed_getPrototypeOf(object); if (object === null) break; } return object; }
function blockEmbed_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) blockEmbed_setPrototypeOf(subClass, superClass); }
function blockEmbed_setPrototypeOf(o, p) { blockEmbed_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return blockEmbed_setPrototypeOf(o, p); }
function blockEmbed_createSuper(Derived) { var hasNativeReflectConstruct = blockEmbed_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = blockEmbed_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = blockEmbed_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return blockEmbed_possibleConstructorReturn(this, result); }; }
function blockEmbed_possibleConstructorReturn(self, call) { if (call && (blockEmbed_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return blockEmbed_assertThisInitialized(self); }
function blockEmbed_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function blockEmbed_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function blockEmbed_getPrototypeOf(o) { blockEmbed_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return blockEmbed_getPrototypeOf(o); }



var BlockEmbed = /*#__PURE__*/function (_Parchment$Embed) {
  blockEmbed_inherits(BlockEmbed, _Parchment$Embed);
  var _super = blockEmbed_createSuper(BlockEmbed);
  function BlockEmbed(domNode) {
    var _this;
    blockEmbed_classCallCheck(this, BlockEmbed);
    _this = _super.call(this, domNode);
    _this.isSeparableByClickApplicable = true;
    return _this;
  }
  blockEmbed_createClass(BlockEmbed, [{
    key: "attach",
    value: function attach() {
      _get(blockEmbed_getPrototypeOf(BlockEmbed.prototype), "attach", this).call(this);
      this.attributes = new (parchment_default()).Attributor.Store(this.domNode);
    }
  }, {
    key: "delta",
    value: function delta() {
      return new (Delta_default())().insert(this.value(), extend_default()(this.formats(), this.attributes.values()));
    }
  }, {
    key: "format",
    value: function format(name, value) {
      var attribute = parchment_default().query(name, (parchment_default()).Scope.BLOCK_ATTRIBUTE);
      if (attribute != null) {
        this.attributes.attribute(attribute, value);
      }
    }
  }, {
    key: "formatAt",
    value: function formatAt(index, length, name, value) {
      this.format(name, value);
    }
  }, {
    key: "insertAt",
    value: function insertAt(index, value, def) {
      if (typeof value === 'string' && value.endsWith('\n')) {
        var block = parchment_default().create(Block.blotName);
        this.parent.insertBefore(block, index === 0 ? this : this.next);
        block.insertAt(0, value.slice(0, -1));
      } else {
        _get(blockEmbed_getPrototypeOf(BlockEmbed.prototype), "insertAt", this).call(this, index, value, def);
      }
    }
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      var type = this.constructor.blotName || null;
      return {
        type: type,
        initParams: {}
      };
    }
  }]);
  return BlockEmbed;
}((parchment_default()).Embed);
BlockEmbed.scope = (parchment_default()).Scope.BLOCK_BLOT;
// It is important for cursor behavior BlockEmbeds use tags that are block level elements

/* harmony default export */ const blockEmbed = (BlockEmbed);
// EXTERNAL MODULE: ./node_modules/preact/hooks/dist/hooks.module.js
var hooks_module = __webpack_require__(8065);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/tableScrollComponent.js











function tableScrollComponent_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { tableScrollComponent_typeof = function _typeof(obj) { return typeof obj; }; } else { tableScrollComponent_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return tableScrollComponent_typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



function TableScrollComponent(_ref) {
  var children = _ref.children,
    size = _ref.size,
    settings = _ref.settings,
    setTableContext = _ref.setTableContext;
  var _useState = (0,hooks_module/* useState */.eJ)(0),
    _useState2 = _slicedToArray(_useState, 2),
    scrollWidth = _useState2[0],
    setScrollWidth = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    canScrollLeft = _useState4[0],
    setCanScrollLeft = _useState4[1];
  var _useState5 = (0,hooks_module/* useState */.eJ)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    canScrollRight = _useState6[0],
    setCanScrollRight = _useState6[1];
  var tableContext = (0,hooks_module/* useContext */.qp)(TableContext);
  var editor = tableContext.editor,
    useRefs = tableContext.useRefs,
    tableExec = tableContext.tableExec;
  (0,hooks_module/* useEffect */.d4)(function () {
    setTableContext(tableContext);
  }, [tableContext]);

  /**
   * Прокручивает scrollComponent, чтобы target находился в видимой области
   * @param { string | node } target: 'right' или node ячейки
   * @param { object } options?
   * @param { number } options.offset? (100)
   * @param { string } options.behavior? (auto)
   */
  var scrollTo = function scrollTo(target) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (target === 'right') {
      scrollItemsRef.current.scrollLeft = scrollItemsRef.current.scrollWidth - scrollItemsRef.current.offsetWidth;
    } else if (tableScrollComponent_typeof(target) === 'object') {
      var _options$offset = options.offset,
        offset = _options$offset === void 0 ? 0 : _options$offset,
        _options$behavior = options.behavior,
        behavior = _options$behavior === void 0 ? 'auto' : _options$behavior;
      var offsetLeft = offset + 64; // Размер первых двух ячеек (заголовок и пропуск), при доработке закрепленных столбцов надо будет сделать динамическим
      var offsetRight = offset - 32; // Отступ на элементы справа таблицы (кнопка создания столбца, ресайз и т.д.)
      var targetRect = target.getBoundingClientRect();
      var scrollRect = scrollItemsRef.current.getBoundingClientRect();
      var scrollLeft = scrollItemsRef.current.scrollLeft;
      var shiftLeft = targetRect.left - scrollRect.left - offsetLeft;
      var shiftRight = targetRect.right - scrollRect.right - offsetRight;
      var scroll = false; //объявляем переменную, так как глобально она объявлена как функция
      if (shiftLeft < 0) {
        scroll = scrollLeft + shiftLeft;
      } else if (shiftRight > 0) {
        scroll = scrollLeft + Math.min(shiftRight, shiftLeft);
      }
      if (scroll !== false) {
        scrollItemsRef.current.scrollTo({
          left: Math.max(0, scroll),
          behavior: behavior
        });
      }
    } else {
      console.info('Unknown target', tableScrollComponent_typeof(target), target);
    }
  };
  var getNode = function getNode() {
    return scrollItemsRef.current;
  };
  var updateScroll = function updateScroll() {
    if (scrollItemsRef.current) {
      setScrollWidth(scrollItemsRef.current.scrollWidth);
    }
    checkScrollRight();
    checkScrollLeft();
    return true;
  };
  useRefs.setUI('scroll', {
    getNode: getNode.bind(this),
    scrollTo: scrollTo.bind(this),
    updateScroll: updateScroll.bind(this)
  });
  var scrollItemsRef = (0,hooks_module/* useRef */.sO)(null);
  var onScroll = function onScroll(event) {
    if (scrollItemsRef.current) {
      setCanScrollLeft(scrollItemsRef.current.scrollLeft > 0);
      checkScrollRight();
    }
  };
  var checkScrollLeft = function checkScrollLeft() {
    if (scrollItemsRef.current) {
      setCanScrollLeft(scrollItemsRef.current.scrollLeft > 0);
    }
  };
  var checkScrollRight = function checkScrollRight() {
    if (scrollItemsRef.current) {
      var itemsRect = scrollItemsRef.current.getBoundingClientRect();
      var scrollRight = scrollItemsRef.current.scrollWidth - itemsRect.width - scrollItemsRef.current.scrollLeft;
      setCanScrollRight(scrollRight > 10);
    }
  };
  (0,hooks_module/* useEffect */.d4)(function () {
    updateScroll();
  });
  (0,hooks_module/* useEffect */.d4)(function () {
    if (scrollWidth) {
      tableExec('render-fullwidth');
    }
  }, [scrollWidth]);
  var scrollClasses = ['table-scroll'];
  if (canScrollLeft) {
    scrollClasses.push('can-scroll-left');
  }
  if (canScrollRight) {
    scrollClasses.push('can-scroll-right');
  }
  if (settings.colHeadings === false) {
    scrollClasses.push('can-hide-col-header');
  }
  return (0,preact_module.h)("div", {
    className: scrollClasses.join(' ')
  }, (0,preact_module.h)("div", {
    className: "table-scroll-items",
    ref: scrollItemsRef,
    onScroll: onScroll
  }, children));
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.trunc.js
var es_math_trunc = __webpack_require__(73689);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/tableConfig.js
var CONFIG = {
  version: 2,
  table: {
    /*
    * {object}
    *   {string} key: ключ в map таблицы
    *   {string} type: тип данных
    *   {any} default: значение по умолчанию
    *   {any} export?: значение в режиме экспорта (установленное в map будет проигнорировано)
    *   {string} permission?: ключ для проверки разрешений при изменении настройки
    */
    settings: {
      wrapCells: {
        key: 'wrapCellsMode',
        type: 'boolean',
        default: true,
        export: true,
        permission: 'nowrap'
      },
      rowHeadings: {
        key: 'rowHeadingsMode',
        type: 'boolean',
        default: true
      },
      colHeadings: {
        key: 'columnHeadingsMode',
        type: 'boolean',
        default: true
      },
      showSummaries: {
        key: 'showSummaries',
        type: 'boolean',
        default: true
      },
      disableFilter: {
        key: 'filter-disabled',
        type: 'boolean',
        default: false
      }
    },
    // Список аттрибутов для копирования, вставки и дублирования
    copy: [/*'size',*/'wrapCellsMode', 'rowHeadingsMode', 'columnHeadingsMode', 'showSummaries', 'fullwidthMode', 'embed-align', 'color']
  },
  row: {
    indexAttr: 'data-index',
    className: 'table-head-item',
    props: {
      height: 36
    },
    limit: {
      minHeight: 36,
      maxHeight: 1000
    },
    // Атрибуты, которые будут отрендерены для тега компонента
    attrs: [/*'id',*/'height'],
    // Список аттрибутов для копирования, вставки и дублирования
    copy: ['type', 'height', 'color', 'align', 'valign'],
    // Время анимации при перемещении строки, мс
    transition: 500
  },
  col: {
    indexAttr: 'data-index',
    className: 'table-head-item',
    props: {
      columnType: 'none',
      width: 180
    },
    limit: {
      minWidth: 100,
      maxWidth: 1000
    },
    // Атрибуты, которые будут отрендерены для тега компонента
    attrs: [/*'id',*/'width'],
    // Список аттрибутов для копирования, вставки и дублирования
    copy: ['text', 'type', 'columnType', 'format', 'width', 'color', 'align', 'valign', 'dbSelect', 'summary'],
    // Список ключей map, изменение которых должно обновлять summary
    updateSummary: ['summary'],
    // Список аттрибутов, обновление которых в колонке должно вызывать обновление ячеек
    updateCells: ['color', 'align', 'valign', 'dbSelect']
  },
  cell: {
    props: {},
    // Атрибуты, которые будут отрендерены для тега компонента
    attrs: {
      'colspan': 'colspan',
      'rowspan': 'rowspan',
      'hidden': 'hidden',
      'valign': 'valign',
      'color': 'data-palette-bg-rgb'
    },
    inherit: {
      // Наследование свойств от колонки и строки
      // Порядок col и row определяет приоритет
      colData: ['color', 'valign'],
      rowData: ['color', 'valign']
    },
    // Список ключей map, изменение которых должно обновлять summary
    updateSummary: ['checked', 'rating', 'progress'],
    // Список аттрибутов для копирования, вставки и дублирования
    copy: ['type', 'cellType', 'colspan', 'rowspan', 'hidden', 'timestamp', 'reminders', 'checked', 'users', 'rating', 'progress', 'selected', 'value', 'format', 'align', 'valign', 'color', 'attachments', 'attachmentglobalids', 'commentThreads'],
    // Список ключей, удаляемых при очищении ячейки
    clear: ['timestamp', 'reminders', 'checked', 'progress', 'rating', 'users', 'selected', 'value', 'attachments', 'attachmentsType'],
    // Свойства, наследуюемые от большой ячейки при анмердже
    divide: ['color', 'align', 'valign']
  },
  child: {
    style: {
      'align': {
        prop: 'text-align',
        default: 'left'
      }
    },
    // Список аттрибутов для копирования, вставки и дублирования
    copy: ['align']
  },
  selection: {
    timeout: 50 // Таймаут удержания кнопки мыши, после которого начинается выделение
  },

  resize: {
    offset: 5,
    // Ширина области ресайза строки/колонки, px
    timeout: 100 // Таймаут удержания кнопки мыши, после которого начинается ресайз
  },

  // Типы значений для map
  types: {
    width: 'number',
    height: 'number',
    colspan: 'number',
    rowspan: 'number',
    hidden: 'boolean',
    rating: 'number',
    progress: 'number',
    timestamp: 'number'
  }
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(4723);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/text.js
function text_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { text_typeof = function _typeof(obj) { return typeof obj; }; } else { text_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return text_typeof(obj); }











function text_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function text_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) text_setPrototypeOf(subClass, superClass); }
function text_setPrototypeOf(o, p) { text_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return text_setPrototypeOf(o, p); }
function text_createSuper(Derived) { var hasNativeReflectConstruct = text_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = text_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = text_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return text_possibleConstructorReturn(this, result); }; }
function text_possibleConstructorReturn(self, call) { if (call && (text_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return text_assertThisInitialized(self); }
function text_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function text_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function text_getPrototypeOf(o) { text_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return text_getPrototypeOf(o); }

var text_Text = /*#__PURE__*/function (_Parchment$Text) {
  text_inherits(Text, _Parchment$Text);
  var _super = text_createSuper(Text);
  function Text() {
    text_classCallCheck(this, Text);
    return _super.apply(this, arguments);
  }
  return Text;
}((parchment_default()).Text);
function escapeText(text) {
  return text.replace(/[&<>"']/g, function (s) {
    var entityMap = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    };
    return entityMap[s];
  });
}

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/util/dom.js
var dom = __webpack_require__(67546);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/inlineEmbed.js
function inlineEmbed_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { inlineEmbed_typeof = function _typeof(obj) { return typeof obj; }; } else { inlineEmbed_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return inlineEmbed_typeof(obj); }

















function inlineEmbed_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function inlineEmbed_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function inlineEmbed_createClass(Constructor, protoProps, staticProps) { if (protoProps) inlineEmbed_defineProperties(Constructor.prototype, protoProps); if (staticProps) inlineEmbed_defineProperties(Constructor, staticProps); return Constructor; }
function inlineEmbed_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { inlineEmbed_get = Reflect.get; } else { inlineEmbed_get = function _get(target, property, receiver) { var base = inlineEmbed_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return inlineEmbed_get(target, property, receiver || target); }
function inlineEmbed_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = inlineEmbed_getPrototypeOf(object); if (object === null) break; } return object; }
function inlineEmbed_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) inlineEmbed_setPrototypeOf(subClass, superClass); }
function inlineEmbed_setPrototypeOf(o, p) { inlineEmbed_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return inlineEmbed_setPrototypeOf(o, p); }
function inlineEmbed_createSuper(Derived) { var hasNativeReflectConstruct = inlineEmbed_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = inlineEmbed_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = inlineEmbed_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return inlineEmbed_possibleConstructorReturn(this, result); }; }
function inlineEmbed_possibleConstructorReturn(self, call) { if (call && (inlineEmbed_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return inlineEmbed_assertThisInitialized(self); }
function inlineEmbed_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function inlineEmbed_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function inlineEmbed_getPrototypeOf(o) { inlineEmbed_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return inlineEmbed_getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var GUARD_TEXT = "\uFEFF";
// Используется в src/blots/text/textLine.js.
// Для того чтобы блот корректно удалялся через Backspace
var INLINE_EMBED_BLOTS = ['mention', 'date', 'button', 'progress', 'dropdown-list'];
// При выделении инлайн блота, будет отображаться флоатинг тулбал
var SHOW_TOOLBAR_FOR_SELECTED_EMBED = ['button'];
/**
 * Класс InlineEmbed
 * Предназначен для того, чтобы исправить проблему с курсором перед и после Embed блота
 */
var InlineEmbed = /*#__PURE__*/function (_Parchment$Embed) {
  inlineEmbed_inherits(InlineEmbed, _Parchment$Embed);
  var _super = inlineEmbed_createSuper(InlineEmbed);
  function InlineEmbed(node) {
    var _this;
    inlineEmbed_classCallCheck(this, InlineEmbed);
    _this = _super.call(this, node);
    _defineProperty(inlineEmbed_assertThisInitialized(_this), "onSelectionChange", function (range, oldRange, source) {
      if (source === 'silent') return;
      //прохождение курсора через блот
      try {
        var allowUpdate = false;
        var _this$scroll$selectio = _this.scroll.selection.getNativeRange(),
          start = _this$scroll$selectio.start,
          end = _this$scroll$selectio.end,
          reversed = _this$scroll$selectio.reversed;
        var startNode = start.node,
          startOffset = start.offset,
          endNode = end.node,
          endOffset = end.offset;

        // если добавить от одного символа перед блотом потом удалить, потом опять добавить то следующие
        // начинают добавляться с форматированием блота, здесь решается этот кейс
        var insertBefore = null;
        if (startNode.parentElement && startNode.parentElement.parentElement === _this.domNode) {
          if (startNode.parentElement !== _this.contentNode) {
            var textNode = document.createTextNode(startNode.textContent);
            startNode.remove();
            insertBefore = textNode;
          }
        }
        // еще может быть случай когда текст оборачивается в тег font и для этого нужна следующая проверка
        if (startNode.parentElement && startNode.parentElement.parentElement && startNode.parentElement.parentElement.parentElement === _this.domNode) {
          if (startNode.parentElement.parentElement !== _this.contentNode) {
            var _textNode = document.createTextNode(startNode.textContent);
            var parentElement = startNode.parentElement;
            startNode.remove();
            parentElement.remove();
            insertBefore = _textNode;
          }
        }
        // если нужно вынести текст перед объектом
        if (insertBefore) {
          _this.parent.insertBefore(parchment_default().create(insertBefore), inlineEmbed_assertThisInitialized(_this));
          allowUpdate = true;
          startNode = _this.leftGuard;
          startOffset = 0;
        }

        // При нажатии ArrowLeft когда каретка находится справа от блота, курсок сначало попадает в GUARD внутри блота
        // и только если нажать еще раз ArrowLeft курсор встанит слева от него.
        // Аналогично когда курсор стоит слева от блота и нажимаем ArrowRight.
        // Здесь рашается данный кейс
        if (startNode === endNode && startOffset === endOffset) {
          if (startNode === _this.leftGuard && startOffset === 1) {
            allowUpdate = true;
            startNode = _this.rightGuard;
          } else if (startNode === _this.rightGuard && startOffset === 0) {
            allowUpdate = true;
            startNode = _this.leftGuard;
          } else if ((0,dom/* isNodeEqualOrContain */.nN)(_this.contentNode, startNode)) {
            if (startOffset < _this.contentNode.textContent.length / 2) {
              allowUpdate = true;
              startNode = _this.leftGuard;
              startOffset = 0;
            } else {
              allowUpdate = true;
              startNode = _this.rightGuard;
              startOffset = 1;
            }
          }
          if (allowUpdate) {
            _this.scroll.selection.setNativeRange(startNode, startOffset);
          }
        } else {
          if (startNode === _this.leftGuard && startOffset === 1) {
            allowUpdate = true;
            startNode = _this.rightGuard;
          } else if (startNode === _this.rightGuard && startOffset === 0) {
            allowUpdate = true;
            startNode = _this.leftGuard;
          } else if (endNode === _this.leftGuard && endOffset === 1) {
            allowUpdate = true;
            endNode = _this.rightGuard;
          } else if (endNode === _this.rightGuard && endOffset === 0) {
            allowUpdate = true;
            endNode = _this.leftGuard;
          }
          if (allowUpdate) {
            _this.scroll.selection.setNativeRange(startNode, startOffset, endNode, endOffset, false, reversed);
          }
        }
        if (allowUpdate) {
          _this.scroll.selection.update('silent');
        }
      } catch (err) {}
    });
    _this.contentNode = document.createElement('span');
    _this.contentNode.setAttribute('contenteditable', false);
    Array.from(_this.domNode.childNodes).forEach(function (childNode) {
      _this.contentNode.appendChild(childNode);
    });
    // функция вставляет this.contentNode в блот и добавляет спец. символы справа и слева
    // нужно для того, чтобы курсор корректно вставал перед и после блота
    _this.setGuards(_this.contentNode);
    return _this;
  }
  inlineEmbed_createClass(InlineEmbed, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = inlineEmbed_get(inlineEmbed_getPrototypeOf(InlineEmbed.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      this.scroll.emitter.on('selectionchange', this.onSelectionChange);
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = inlineEmbed_get(inlineEmbed_getPrototypeOf(InlineEmbed.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      this.scroll.emitter.off('selectionchange', this.onSelectionChange);
    }
  }, {
    key: "index",
    value: function index(node, offset) {
      if (node === this.leftGuard) return 0;
      if (node === this.rightGuard) return 1;
      return inlineEmbed_get(inlineEmbed_getPrototypeOf(InlineEmbed.prototype), "index", this).call(this, node, offset);
    }
  }, {
    key: "setGuards",
    value: function setGuards(contentNode) {
      this.leftGuard = document.createTextNode(GUARD_TEXT);
      this.rightGuard = document.createTextNode(GUARD_TEXT);
      this.domNode.appendChild(this.leftGuard);
      this.domNode.appendChild(contentNode);
      this.domNode.appendChild(this.rightGuard);
    }
  }, {
    key: "restore",
    value: function restore(node) {
      var range, textNode;
      var text = node.data.split(GUARD_TEXT).join('');
      if (node === this.leftGuard) {
        if (this.prev instanceof text_Text) {
          var prevLength = this.prev.length();
          this.prev.insertAt(prevLength, text);
          range = {
            startNode: this.prev.domNode,
            startOffset: prevLength + text.length
          };
        } else {
          textNode = document.createTextNode(text);
          this.parent.insertBefore(parchment_default().create(textNode), this);
          range = {
            startNode: textNode,
            startOffset: text.length
          };
        }
      } else if (node === this.rightGuard) {
        if (this.next instanceof text_Text) {
          this.next.insertAt(0, text);
          range = {
            startNode: this.next.domNode,
            startOffset: text.length
          };
        } else {
          textNode = document.createTextNode(text);
          this.parent.insertBefore(parchment_default().create(textNode), this.next);
          range = {
            startNode: textNode,
            startOffset: text.length
          };
        }
      }
      node.data = GUARD_TEXT;
      return range;
    }
  }, {
    key: "update",
    value: function update(mutations, context) {
      var _this2 = this;
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData' && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
          var range = _this2.restore(mutation.target);
          if (range) context.range = range;
        } else if (mutation.type === 'childList' && mutation.target === _this2.domNode && mutation.removedNodes.length === 1 && (mutation.removedNodes[0] === _this2.leftGuard || mutation.removedNodes[0] === _this2.rightGuard)) {
          _this2.remove();
        }
      });
    }
  }]);
  return InlineEmbed;
}((parchment_default()).Embed);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/blot.js
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = blot_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function blot_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return blot_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return blot_arrayLikeToArray(o, minLen); }
function blot_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }















/**
 * проверяет имеет ли заданный блот map, если нет то ищет блот с map в родительских блотах
 * @param  {Blot} blot - проверяемый блот
 * @return {Blot} блот c map
 */
function normalizeToStoredBlot(blot) {
  while (blot && !blot.map) {
    blot = blot.parent;
  }
  return blot;
}
function normalizeToTextBlot(blot) {
  while (blot && !blot.isText) {
    blot = blot.parent;
  }
  return blot;
}

/**
 * проверяет является ли нода блотом, если нет то пытается найти блот в родительских элементах
 * @param  {DOMNode} node - проверяемая нода
 */
function getBlotForNode(node) {
  if (!node) {
    return null;
  }
  var blot = src_parchment.find(node);
  if (blot) {
    return blot;
  }
  return getBlotForNode(node.parentNode);
}

/**
 * проверяет имеет ли заданный блот нужный класс, если нет то ищет блот с нужным классом в родительских блотах
 * @param  {Blot} blot - проверяемый блот
 * @param  {String|Array} classArr - нужный класс или классы
 * @return {Blot} блот нужного класса
 */
function findWithClass(blot, classArr) {
  if (!Array.isArray(classArr)) {
    classArr = [classArr];
  }
  while (blot) {
    if (classArr.every(function (cl) {
      return blot instanceof cl;
    })) {
      return blot;
    }
    blot = blot.parent;
  }
  return null;
}

/**
 * проверяет удовлетворяет ли блот заданной функции, если нет то ищет удовлетворяющий блот в родительских блотах
 * @param  {Blot} blot - проверяемый блот
 * @param  {Function} fn - функция возвращающая true или false
 * @return {Blot} удовлетворяющий функции блот
 */
function searchUp(blot, fn) {
  while (blot) {
    if (fn(blot)) {
      return blot;
    }
    blot = blot.parent;
  }
  return null;
}
function getFocusableBlot(blot) {
  if (blot instanceof Parchment.Scroll || !blot) return null;
  while (blot !== null && !blot.isFocusable) {
    if (blot instanceof Parchment.Scroll) {
      blot = null;
    } else {
      blot = blot.parent;
    }
  }
  return blot;
}
function getChildByIndex(blot, index) {
  var i = 0;
  blot = blot.children.head;
  while (blot && i !== index) {
    i++;
    blot = blot.next;
  }
  return blot;
}
function getChildIndex(blot, child) {
  var i = -1;
  blot = blot.children.head;
  while (blot) {
    i++;
    if (blot === child) {
      return i;
    }
    blot = blot.next;
  }
  return -1;
}
function mix(mixins) {
  return function (baseClass) {
    var cl = baseClass;
    for (var i = mixins.length - 1; i >= 0; i--) {
      cl = mixins[i](cl);
    }
    return cl;
  };
}
function getContainerOffset(node, container) {
  var x = 0;
  var y = 0;
  var el = node;
  while (el !== container && el !== null) {
    x += el.offsetLeft - el.scrollLeft;
    y += el.offsetTop - el.scrollTop;
    el = el.offsetParent;
  }
  return {
    x: x,
    y: y
  };
}

// тоже самое что и forEach для children блотов, только передает в функцию и индекс обрабатываемого элемента
function llForEach(items, fn) {
  var item = items.head;
  var i = -1;
  while (item) {
    i++;
    fn(item, i);
    item = item.next;
  }
}
function doBlotsHaveSameConstructor(blots) {
  if (!blots.length) {
    return false;
  }
  var constr = null;
  var _iterator = _createForOfIteratorHelper(blots),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var blot = _step.value;
      if (!constr) {
        constr = blot.constructor;
        continue;
      }
      if (constr !== blot.constructor) {
        return false;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return true;
}

// выполняет проход по всем блотам в container, принимает во внимание гриды
function eachBlot(container, fn) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var blot = container.children.head;
  while (blot) {
    var _blot$constructor, _blot$constructor2;
    if (fn(blot) === false) {
      return;
    }
    if (((_blot$constructor = blot.constructor) === null || _blot$constructor === void 0 ? void 0 : _blot$constructor.blotName) === 'grid') {
      var gridCol = blot.children.head;
      while (gridCol) {
        eachBlot(gridCol, fn);
        gridCol = gridCol.next;
      }
    }
    if (((_blot$constructor2 = blot.constructor) === null || _blot$constructor2 === void 0 ? void 0 : _blot$constructor2.blotName) === 'toggleWrapper') {
      // для тогла сразу перебираются мапы т.к. тоггл может быть закрытым
      blot.map.get('children').toArray().forEach(function (childId) {
        fn({
          map: blot.editor.store.blocks.get(childId)
        });
      });
    }
    /*
    Не подходит для таблиц V2
    else if(blot.constructor.blotName === 'tableWrapper' && params.inTables) {
      let cells = blot.table.getCellsWithBlots()
      for(let cell of cells) {
        eachBlot(cell, fn)
      }
    }
    */
    blot = blot.next;
  }
}
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/plugins/i18n/index.js + 15 modules
var plugins_i18n = __webpack_require__(407);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/util.js
var util = __webpack_require__(33103);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/common.js
function common_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { common_typeof = function _typeof(obj) { return typeof obj; }; } else { common_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return common_typeof(obj); }















function generateId() {
  var mask = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'xxxxxx';
  var id = mask.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
  return id;
}

/**
 * Проверяет является строка эл.почтой
 * @param email
 * @returns {boolean}
 */
function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

/**
 * Проверяет, что массив содержит только разрешенные элементы
 * @param { array } arr: массив
 * @param { array } allowed: разрешенные элементы
 * @returns { boolean }
 */
function includesOnly() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var allowed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return arr.every(function (elem) {
    return allowed.includes(elem);
  });
}

/**
 * Проверяет тип данных на входе и при необходимости парсит их из строки JSON или join
 * Возвращает объект с данными указанного типа
 * @param { string } type: 'object', 'array'
 * @param { any } data: данные в виде объекта или строки
 * @returns { object | array }
 */
function parseObject() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'object';
  var data = arguments.length > 1 ? arguments[1] : undefined;
  var result;
  var dataType = common_typeof(data);
  if (!data) {
    if (type === 'object') {
      result = {};
    } else if (type === 'array') {
      result = [];
    }
  } else if (type === 'object') {
    if (dataType === 'object') {
      result = data;
    } else {
      result = {};
      if (dataType === 'string' && data.startsWith('{') && data.endsWith('}')) {
        result = JSON.parse(data);
      }
    }
  } else if (type === 'array') {
    if (dataType === 'object') {
      result = data;
    } else {
      result = [];
      if (dataType === 'string') {
        if (data.startsWith('[') && data.endsWith(']')) {
          result = JSON.parse(data);
        } else {
          result = data.split(',');
        }
      }
    }
  }
  return result;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/button/button.js
function button_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { button_typeof = function _typeof(obj) { return typeof obj; }; } else { button_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return button_typeof(obj); }

















function button_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function button_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function button_createClass(Constructor, protoProps, staticProps) { if (protoProps) button_defineProperties(Constructor.prototype, protoProps); if (staticProps) button_defineProperties(Constructor, staticProps); return Constructor; }
function button_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) button_setPrototypeOf(subClass, superClass); }
function button_setPrototypeOf(o, p) { button_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return button_setPrototypeOf(o, p); }
function button_createSuper(Derived) { var hasNativeReflectConstruct = button_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = button_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = button_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return button_possibleConstructorReturn(this, result); }; }
function button_possibleConstructorReturn(self, call) { if (call && (button_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return button_assertThisInitialized(self); }
function button_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function button_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function button_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { button_get = Reflect.get; } else { button_get = function _get(target, property, receiver) { var base = button_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return button_get(target, property, receiver || target); }
function button_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = button_getPrototypeOf(object); if (object === null) break; } return object; }
function button_getPrototypeOf(o) { button_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return button_getPrototypeOf(o); }
function button_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








/**
 * Возвращает сгенерированный css id для кнопки
 * @returns {string}
 */
function generateButtonId() {
  return generateId('button_xxxxxxxx');
}
var Button = /*#__PURE__*/function (_InlineEmbed) {
  button_inherits(Button, _InlineEmbed);
  var _super = button_createSuper(Button);
  function Button(node) {
    var _this;
    button_classCallCheck(this, Button);
    _this = _super.call(this, node);
    button_defineProperty(button_assertThisInitialized(_this), "onButtonClick", function (event) {
      event.preventDefault();
      event.stopPropagation();
      var url = _this.domNode.getAttribute('data-url');
      var target = _this.domNode.getAttribute('data-target');
      var blot = _this.parent;
      var isBlotLocked = blot && blot.isBlotLocked;
      var _ref = _this.editor || {},
        options = _ref.options;
      var _ref2 = options && options.blots && options.blots.button || {},
        _ref2$showButtonForma = _ref2.showButtonFormat,
        showButtonFormat = _ref2$showButtonForma === void 0 ? true : _ref2$showButtonForma;
      if (_this.editor.mode === MODE_EDIT && !isBlotLocked && showButtonFormat) {
        _this.editor.emitter.emit('click-button', button_assertThisInitialized(_this));
      } else {
        if (!_this.editor.plugins.linkManager.processNavigation(url)) {
          window.open(url, target, 'noopener');
        }
      }
    });
    button_defineProperty(button_assertThisInitialized(_this), "setSelfControlled", function () {
      _this.node.classList.add(util/* SELF_CONTROLLED_CONTENT_CLASS */.W$);
    });
    button_defineProperty(button_assertThisInitialized(_this), "removeSelfControlled", function () {
      _this.node.classList.remove(util/* SELF_CONTROLLED_CONTENT_CLASS */.W$);
    });
    _this.node = node;
    _this.contentNode.classList.add('button-content');
    _this.titleNode = _this.contentNode.querySelector('b');
    return _this;
  }
  button_createClass(Button, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = button_get(button_getPrototypeOf(Button.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      var _normalizeToStoredBlo = normalizeToStoredBlot(this),
        editor = _normalizeToStoredBlo.editor;
      this.editor = editor;
      this.domNode.addEventListener('click', this.onButtonClick, false);
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = button_get(button_getPrototypeOf(Button.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      this.domNode.removeEventListener('click', this.onButtonClick);
    }
  }, {
    key: "changeButton",
    value: function changeButton(formats) {
      var title = formats.title,
        url = formats.url,
        target = formats.target,
        shape = formats.shape,
        background = formats.background,
        size = formats.size,
        buttonType = formats.buttonType,
        id = formats.id;
      this.setUrl(url);
      this.setTitle(title);
      this.setTarget(target);
      this.setShape(shape);
      this.setBackground(background);
      this.setSize(size);
      this.setType(buttonType);
      if (!this.domNode.getAttribute('id')) {
        this.domNode.setAttribute('id', id);
      }
    }
  }, {
    key: "setTitle",
    value: function setTitle(title) {
      this.titleNode.innerText = title;
      this.domNode.setAttribute('data-title', title);
    }
  }, {
    key: "setUrl",
    value: function setUrl(url) {
      this.domNode.setAttribute('data-url', url);
    }
  }, {
    key: "setTarget",
    value: function setTarget(target) {
      this.domNode.setAttribute('data-target', target);
    }
  }, {
    key: "setShape",
    value: function setShape(shape) {
      this.domNode.setAttribute('data-shape', shape);
    }
  }, {
    key: "setBackground",
    value: function setBackground(background) {
      this.domNode.setAttribute('data-background', background);
    }
  }, {
    key: "setSize",
    value: function setSize(size) {
      this.domNode.setAttribute('data-size', size);
    }
  }, {
    key: "setType",
    value: function setType(buttonType) {
      this.domNode.setAttribute('data-type', buttonType);
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      var url = this.domNode.getAttribute('data-url');
      var target = this.domNode.getAttribute('data-target');
      this.domNode.setAttribute('onclick', "window.open('".concat(url, "', '").concat(target, "', 'noopener')"));
      return this.domNode.outerHTML;
    }

    /**
     * Проверяет можно ли конвертировать выделенный текст в кнопку
     * @param editor
     * @returns {boolean}
     */
  }], [{
    key: "create",
    value: function create(value) {
      var node = button_get(button_getPrototypeOf(Button), "create", this).call(this, value);
      var _JSON$parse = JSON.parse(value),
        _JSON$parse$title = _JSON$parse.title,
        title = _JSON$parse$title === void 0 ? plugins_i18n/* default.get */.ZP.get('floating_toolbar.button') : _JSON$parse$title,
        _JSON$parse$url = _JSON$parse.url,
        url = _JSON$parse$url === void 0 ? '' : _JSON$parse$url,
        _JSON$parse$target = _JSON$parse.target,
        target = _JSON$parse$target === void 0 ? '_blank' : _JSON$parse$target,
        shape = _JSON$parse.shape,
        background = _JSON$parse.background,
        _JSON$parse$size = _JSON$parse.size,
        size = _JSON$parse$size === void 0 ? 'small' : _JSON$parse$size,
        _JSON$parse$type = _JSON$parse.type,
        type = _JSON$parse$type === void 0 ? '3d' : _JSON$parse$type,
        id = _JSON$parse.id;
      url = this.sanitize(url);
      node.classList.add('inline-button');
      node.setAttribute('data-title', title);
      node.setAttribute('data-url', url);
      node.setAttribute('data-target', target);
      node.setAttribute('data-shape', shape);
      node.setAttribute('data-background', background);
      node.setAttribute('data-size', size);
      node.setAttribute('data-type', type);
      node.setAttribute('id', id);
      var titleText = document.createTextNode(title);
      var b = document.createElement('b');
      b.appendChild(titleText);
      node.appendChild(b);
      return node;
    }
  }, {
    key: "value",
    value: function value(domNode) {
      // конвертируем в JSON для того, чтобы можно было создавать кнопку из выделенной кнопки и текста
      // или из двух выделенных кнопок. также чтобы кнопка корректно сохранялась в map
      return JSON.stringify({
        title: domNode.getAttribute('data-title'),
        url: domNode.getAttribute('data-url'),
        target: domNode.getAttribute('data-target'),
        shape: domNode.getAttribute('data-shape'),
        background: domNode.getAttribute('data-background'),
        size: domNode.getAttribute('data-size'),
        type: domNode.getAttribute('data-type'),
        id: domNode.getAttribute('id')
      });
    }
  }, {
    key: "sanitize",
    value: function sanitize(url) {
      return url;
    }
  }, {
    key: "getOpText",
    value: function getOpText(_ref3) {
      var button = _ref3.button;
      var value = JSON.parse(button) || {};
      return value.title || '';
    }
  }, {
    key: "isAbleToConvert",
    value: function isAbleToConvert(editor) {
      var _getSelectedText = (0,util/* getSelectedText */.ZT)(editor),
        text = _getSelectedText.text,
        _getSelectedText$delt = _getSelectedText.delta,
        delta = _getSelectedText$delt === void 0 ? [{
          ops: []
        }] : _getSelectedText$delt;
      // дисаблим кнопку для таблицы
      var isInTable = editor.scroll.getSelectedBlocks()[0] instanceof table_table;
      // если выделено больше одной строки текста или  в строке есть символ переноса строки
      var isManyLines = editor.scroll.getSelectedBlocks().length > 1 || text.match(/\n/);
      // если текст с пробелами или пустая строка
      var isEmptyText = text.trim() === '';
      // если есть кнопки в выделении
      var hasButton = delta[0].ops.filter(function (op) {
        return op.insert && op.insert.button;
      }).length;
      return !(isEmptyText || isInTable || isManyLines || hasButton);
    }
  }]);
  return Button;
}(InlineEmbed);
Button.blotName = 'button';
Button.tagName = 'nimbus-button';
Button.SANITIZED_URL = 'about:blank';
Button.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];
function sanitize(url, protocols) {
  var anchor = document.createElement('a');
  anchor.href = url;
  var protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
  return protocols.indexOf(protocol) > -1;
}

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/delta.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || delta_unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return delta_arrayLikeToArray(arr); }
function delta_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = delta_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function delta_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return delta_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return delta_arrayLikeToArray(o, minLen); }
function delta_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
















function clearComments(delta) {
  if (delta.ops.length) {
    return new (Delta_default())(delta.reduce(function (ops, op) {
      if (op.attributes) {
        var keys = Object.keys(op.attributes);
        var commentKeys = keys.filter(function (key) {
          return key.startsWith('comment-');
        });
        if (commentKeys.length) {
          // если кроме атрибутов комментариев в операции есть другие атрибуты, нужно удалить только атрибуты комментариев
          if (commentKeys.length !== keys.length) {
            var _iterator = delta_createForOfIteratorHelper(commentKeys),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var key = _step.value;
                delete op.attributes[key];
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          } else {
            delete op.attributes;
          }
        }
      }
      return [].concat(_toConsumableArray(ops), [op]);
    }, []));
  }
  return delta;
}

/**
 * Функция заменяет id у инлайн кнопки на новый
 * @param delta
 * @returns {*}
 */
function updateButtonCssId(delta) {
  if (delta.ops.length) {
    return new (Delta_default())(delta.reduce(function (ops, op) {
      if (op.insert && op.insert.button) {
        var button = JSON.parse(op.insert.button);
        button.id = generateButtonId();
        op.insert.button = JSON.stringify(button);
      }
      return [].concat(_toConsumableArray(ops), [op]);
    }, []));
  }
  return delta;
}

/**
 * Подготавливает дельту для копирования
 * @param delta
 * @returns {*}
 */
function prepareDeltaForCopy(delta) {
  var res = null;
  res = clearComments(delta);
  res = updateButtonCssId(res);
  return res;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.finally.js
var es_promise_finally = __webpack_require__(17727);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/scss/palette.scss
var palette = __webpack_require__(62297);
var palette_default = /*#__PURE__*/__webpack_require__.n(palette);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/scss/material/color-names.scss
var color_names = __webpack_require__(13916);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/scss/material/color-names-assoc.scss
var color_names_assoc = __webpack_require__(84221);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/scss/material/highlights-names.scss
var highlights_names = __webpack_require__(57673);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/scss/material/highlights-names-assoc.scss
var highlights_names_assoc = __webpack_require__(62775);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/scss/material/light-palette.scss
var light_palette = __webpack_require__(84087);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/scss/material/dark-palette.scss
var dark_palette = __webpack_require__(68055);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/scss/material/neutral-palette.scss
var neutral_palette = __webpack_require__(70133);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/theme/colors.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { colors_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function colors_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



















var defaultFontColor = '#000000';
var defaultDarkThemeFontColor = 'rgba(255, 255, 255, 0.87)';
var paletteColors = ['aqua',
//bleuDeFrance
'carrot',
//neonCarrot
'yellow',
//sunglow
'red',
//carminePink
'light-green',
//dollarBill
'thistle',
//lightPastelPurple
'ucla-blue', 'blue', 'cherry', 'orange', 'yellow-green', 'green', 'jade', 'green-sea', 'aquamarine', 'dark-sky', 'purple', 'pink', 'cloudy', 'grey', 'brown'];
var blackAndWhite = ['black', 'white'];
var additionalColorNames = ['rose'];
var selectcolors = Object.assign([], paletteColors);
var tablecolors = Object.assign([], paletteColors);
var colorsandbw = Object.assign([], paletteColors.concat(blackAndWhite));
var colors = {
  'dark-sky-blue': '#42a5f5',
  'macaroni-and-cheese': '#fac92f',
  'mango': '#fda639',
  'coral': '#ed5454',
  'turtle-green': '#8bc34a',
  'pale-purple': '#b39ddb',
  'stormy-blue': '#5573a7'
};
var colorsTheme = {
  'light': {
    'dark-sky-blue': '#42a5f5',
    'macaroni-and-cheese': '#fac92f',
    'mango': '#fda639',
    'coral': '#ed5454',
    'turtle-green': '#8bc34a',
    'pale-purple': '#b39ddb',
    'stormy-blue': '#5573a7'
  },
  'dark': {
    'dark-sky-blue': '#42a5f5',
    'macaroni-and-cheese': '#fac92f',
    'mango': '#fda639',
    'coral': '#ed5454',
    'turtle-green': '#8bc34a',
    'pale-purple': '#b39ddb',
    'stormy-blue': '#5573a7',
    'black': '#000000'
  }
};
var avatarcolors = {
  'dark-sky-blue': '#42a5f5',
  'macaroni-and-cheese': '#fac92f',
  'mango': '#fda639',
  'coral': '#ed5454',
  'turtle-green': '#8bc34a',
  'pale-purple': '#b39ddb',
  'stormy-blue': '#5573a7'
};
var highlights = {
  'dark-sky-blue-highlight': '#cbefff',
  'macaroni-and-cheese-highlight': '#feebd3',
  'mango-highlight': '#ffdbd8',
  'coral-highlight': '#f8d3df',
  'turtle-green-highlight': '#deeed4',
  'pale-purple-highlight': '#d9c8fe',
  'stormy-blue-highlight': '#d2e1ff'
};
var backgrounds = {
  'dark-sky-blue': '#42a5f5',
  'macaroni-and-cheese': '#fac92f',
  'mango': '#fda639',
  'coral': '#ed5454',
  'turtle-green': '#8bc34a',
  'pale-purple': '#b39ddb',
  'stormy-blue': '#5573a7',
  'dark-sky-blue-highlight': '#cbefff',
  'macaroni-and-cheese-highlight': '#feebd3',
  'mango-highlight': '#ffdbd8',
  'coral-highlight': '#f8d3df',
  'turtle-green-highlight': '#deeed4',
  'pale-purple-highlight': '#d9c8fe',
  'stormy-blue-highlight': '#d2e1ff',
  'gray': '#999999'
};
var colors_palette = Object.keys((palette_default())).filter(function (varName) {
  return paletteColors.concat(blackAndWhite).includes(varName);
}).map(function (colorName) {
  return new Object(colors_defineProperty({}, colorName, (palette_default())[colorName]));
}).reduce(function (obj, item) {
  return Object.assign(obj, item);
}, {});
var extraHighlights = {
  'extra-cherry': {
    bg: 'cherry',
    text: 'cherry'
  },
  'orange-red': {
    bg: 'orange',
    text: 'red'
  },
  'yellow-carrot': {
    bg: 'yellow',
    text: 'carrot'
  },
  'yellow-green-jade': {
    bg: 'yellow-green',
    text: 'jade'
  },
  'extra-aquamarine': {
    bg: 'aquamarine',
    text: 'aquamarine'
  },
  'purple-aqua': {
    bg: 'purple',
    text: 'aqua'
  },
  'extra-purple': {
    bg: 'purple',
    text: 'purple'
  }
};
function getColorName(color) {
  var newColor = color;
  if (String(color).indexOf('#') === 0) {
    var colorsReplace = {
      '#42a5f5': 'aqua',
      '#fac92f': 'yellow',
      '#fda639': 'carrot',
      '#ed5454': 'cherry',
      '#8bc34a': 'green',
      '#b39ddb': 'thistle',
      '#5573a7': 'blue'
    };
    if (colorsReplace[color]) {
      newColor = colorsReplace[color];
    }
  }
  return newColor;
}
var inlineCommentColors = ['yellow', 'orange', 'red', 'pink', 'purple', 'aqua', 'aquamarine', 'light-green', 'green-sea', 'ucla-blue', 'brown'];
var matColorNames = Object.keys(color_names);
var matColorNamesAssoc = _objectSpread({}, color_names_assoc);
var matHighlightNames = Object.keys(highlights_names);
var matHighlightNamesAssoc = _objectSpread({}, highlights_names_assoc);
var matLightPalette = _objectSpread({}, light_palette);
var matDarkPalette = _objectSpread({}, dark_palette);
var matNeutralPalette = _objectSpread({}, neutral_palette);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/preact.js







function preact_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { preact_typeof = function _typeof(obj) { return typeof obj; }; } else { preact_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return preact_typeof(obj); }

function NullComponent() {
  return null;
}

/**
 * Preact X при попытке добавить компонент в контейнер, в некоторых случаях, затирает контент ранее созданный в контейнере через document.createElement.
 * Функция создает в контейнере враппер и безопасно рендерит в нем preact компонент,
 * при передаче null вместо компонента удаляет враппер
 * @param {<component> | null} component - preact компонент или null
 * @param {node} container - контейнер, внутри которого создается враппер и рендерится компонент
 * @param {string} name - уникальное имя для враппера
 * @return {boolean}
 */
function pRenderInContainer(component, container, name) {
  //const container = this.scroll.editor.scrollingContainer
  if (container) {
    var elem = container.querySelector("[prender-wrapper='".concat(name, "']"));
    if (component) {
      if (!elem) {
        elem = document.createElement('span');
        elem.setAttribute('prender-wrapper', name);
        container.appendChild(elem);
      }
      (0,preact_module/* render */.sY)(component, elem);
    } else {
      if (elem) {
        (0,preact_module/* render */.sY)(component, elem);
        elem.remove();
      }
    }
    return true;
  } else {
    console.warn("Container is", preact_typeof(container));
    return false;
  }
}
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/icons.js
var icons = __webpack_require__(49190);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/errors/customDisplayableError.js
var customDisplayableError = __webpack_require__(41552);
// EXTERNAL MODULE: ./node_modules/preact-transition-group/dist/preact-transition-group.mjs
var preact_transition_group = __webpack_require__(49839);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/cssTransitionGroup.js
function cssTransitionGroup_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { cssTransitionGroup_typeof = function _typeof(obj) { return typeof obj; }; } else { cssTransitionGroup_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return cssTransitionGroup_typeof(obj); }









function cssTransitionGroup_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function cssTransitionGroup_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function cssTransitionGroup_createClass(Constructor, protoProps, staticProps) { if (protoProps) cssTransitionGroup_defineProperties(Constructor.prototype, protoProps); if (staticProps) cssTransitionGroup_defineProperties(Constructor, staticProps); return Constructor; }
function cssTransitionGroup_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) cssTransitionGroup_setPrototypeOf(subClass, superClass); }
function cssTransitionGroup_setPrototypeOf(o, p) { cssTransitionGroup_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return cssTransitionGroup_setPrototypeOf(o, p); }
function cssTransitionGroup_createSuper(Derived) { var hasNativeReflectConstruct = cssTransitionGroup_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = cssTransitionGroup_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = cssTransitionGroup_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return cssTransitionGroup_possibleConstructorReturn(this, result); }; }
function cssTransitionGroup_possibleConstructorReturn(self, call) { if (call && (cssTransitionGroup_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return cssTransitionGroup_assertThisInitialized(self); }
function cssTransitionGroup_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function cssTransitionGroup_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function cssTransitionGroup_getPrototypeOf(o) { cssTransitionGroup_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return cssTransitionGroup_getPrototypeOf(o); }


var CSSTransitionGroup = /*#__PURE__*/function (_Component) {
  cssTransitionGroup_inherits(CSSTransitionGroup, _Component);
  var _super = cssTransitionGroup_createSuper(CSSTransitionGroup);
  function CSSTransitionGroup(props) {
    var _this;
    cssTransitionGroup_classCallCheck(this, CSSTransitionGroup);
    _this = _super.call(this, props);
    _this.state = {
      allowRenderChildren: false
    };
    return _this;
  }
  cssTransitionGroup_createClass(CSSTransitionGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState(function () {
        return {
          allowRenderChildren: true
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        transitionName = _this$props.transitionName,
        transitionEnterTimeout = _this$props.transitionEnterTimeout,
        transitionLeaveTimeout = _this$props.transitionLeaveTimeout;
      var allowRenderChildren = this.state.allowRenderChildren;
      return (0,preact_module.h)(preact_transition_group/* default */.Z, {
        transitionName: transitionName,
        transitionEnterTimeout: transitionEnterTimeout,
        transitionLeaveTimeout: transitionLeaveTimeout
      }, allowRenderChildren ? this.props.children : null);
    }
  }]);
  return CSSTransitionGroup;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/scss/vars.scss
var vars = __webpack_require__(20199);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/popupMenuTransition.js
function popupMenuTransition_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { popupMenuTransition_typeof = function _typeof(obj) { return typeof obj; }; } else { popupMenuTransition_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return popupMenuTransition_typeof(obj); }









function popupMenuTransition_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function popupMenuTransition_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function popupMenuTransition_createClass(Constructor, protoProps, staticProps) { if (protoProps) popupMenuTransition_defineProperties(Constructor.prototype, protoProps); if (staticProps) popupMenuTransition_defineProperties(Constructor, staticProps); return Constructor; }
function popupMenuTransition_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) popupMenuTransition_setPrototypeOf(subClass, superClass); }
function popupMenuTransition_setPrototypeOf(o, p) { popupMenuTransition_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return popupMenuTransition_setPrototypeOf(o, p); }
function popupMenuTransition_createSuper(Derived) { var hasNativeReflectConstruct = popupMenuTransition_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = popupMenuTransition_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = popupMenuTransition_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return popupMenuTransition_possibleConstructorReturn(this, result); }; }
function popupMenuTransition_possibleConstructorReturn(self, call) { if (call && (popupMenuTransition_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return popupMenuTransition_assertThisInitialized(self); }
function popupMenuTransition_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function popupMenuTransition_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function popupMenuTransition_getPrototypeOf(o) { popupMenuTransition_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return popupMenuTransition_getPrototypeOf(o); }



var popupAppearDuration = parseInt(vars.popupAppearDuration);
var PopupMenuTransition = /*#__PURE__*/function (_Component) {
  popupMenuTransition_inherits(PopupMenuTransition, _Component);
  var _super = popupMenuTransition_createSuper(PopupMenuTransition);
  function PopupMenuTransition() {
    popupMenuTransition_classCallCheck(this, PopupMenuTransition);
    return _super.apply(this, arguments);
  }
  popupMenuTransition_createClass(PopupMenuTransition, [{
    key: "render",
    value: function render() {
      return (0,preact_module.h)(CSSTransitionGroup, {
        transitionName: "popup-menu",
        transitionEnterTimeout: popupAppearDuration,
        transitionLeaveTimeout: popupAppearDuration
      }, this.props.children);
    }
  }]);
  return PopupMenuTransition;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/components/popupMenu.js
var popupMenu = __webpack_require__(10856);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/mentionManager/mentionInfo.js
function mentionInfo_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { mentionInfo_typeof = function _typeof(obj) { return typeof obj; }; } else { mentionInfo_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return mentionInfo_typeof(obj); }














function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function mentionInfo_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function mentionInfo_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function mentionInfo_createClass(Constructor, protoProps, staticProps) { if (protoProps) mentionInfo_defineProperties(Constructor.prototype, protoProps); if (staticProps) mentionInfo_defineProperties(Constructor, staticProps); return Constructor; }
function mentionInfo_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) mentionInfo_setPrototypeOf(subClass, superClass); }
function mentionInfo_setPrototypeOf(o, p) { mentionInfo_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return mentionInfo_setPrototypeOf(o, p); }
function mentionInfo_createSuper(Derived) { var hasNativeReflectConstruct = mentionInfo_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = mentionInfo_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = mentionInfo_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return mentionInfo_possibleConstructorReturn(this, result); }; }
function mentionInfo_possibleConstructorReturn(self, call) { if (call && (mentionInfo_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return mentionInfo_assertThisInitialized(self); }
function mentionInfo_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function mentionInfo_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function mentionInfo_getPrototypeOf(o) { mentionInfo_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return mentionInfo_getPrototypeOf(o); }
function mentionInfo_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var MentionInfo = /*#__PURE__*/function (_Component) {
  mentionInfo_inherits(MentionInfo, _Component);
  var _super = mentionInfo_createSuper(MentionInfo);
  function MentionInfo(props) {
    var _this;
    mentionInfo_classCallCheck(this, MentionInfo);
    _this = _super.call(this, props);
    mentionInfo_defineProperty(mentionInfo_assertThisInitialized(_this), "loadInfo", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(type, objectId) {
        var workspaceId,
          manager,
          newState,
          _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                workspaceId = _args.length > 2 && _args[2] !== undefined ? _args[2] : null;
                manager = _this.editor.plugins.mentionManager;
                newState = {
                  contentLoaded: true
                };
                _context.prev = 3;
                _context.t0 = type;
                _context.next = _context.t0 === 'note' ? 7 : _context.t0 === 'folder' ? 11 : _context.t0 === 'workspace' ? 15 : _context.t0 === 'user' ? 19 : 23;
                break;
              case 7:
                _context.next = 9;
                return manager.getNoteTeaser(objectId, workspaceId);
              case 9:
                _this.contentObject = _context.sent;
                return _context.abrupt("break", 23);
              case 11:
                _context.next = 13;
                return manager.getFolderInfo(objectId, workspaceId);
              case 13:
                _this.contentObject = _context.sent;
                return _context.abrupt("break", 23);
              case 15:
                _context.next = 17;
                return manager.getWorkspaceInfo(objectId);
              case 17:
                _this.contentObject = _context.sent;
                return _context.abrupt("break", 23);
              case 19:
                _context.next = 21;
                return manager.getUserInfo(objectId, workspaceId);
              case 21:
                _this.contentObject = _context.sent;
                return _context.abrupt("break", 23);
              case 23:
                _context.next = 28;
                break;
              case 25:
                _context.prev = 25;
                _context.t1 = _context["catch"](3);
                newState.loadError = _context.t1;
              case 28:
                if (!_this.contentObject) _this.contentObject = {};
                _this.setState(newState);
              case 30:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 25]]);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    _this.editor = _this.props.editor;
    _this.contentObject = {};
    _this.state = {
      contentLoaded: false
    };
    _this.i18n = _this.editor.plugins.i18n;
    return _this;
  }
  mentionInfo_createClass(MentionInfo, [{
    key: "getNoteHtml",
    value: function getNoteHtml() {
      var htmlClass = 'mention-note-teaser';
      var onlyTitle = false;
      // проверяем, если нет текста и превью, нужно выставить класс 'only-title'
      if (!this.contentObject.content) {
        if (!this.contentObject.previewUrl) {
          onlyTitle = true;
        }
      }
      return (0,preact_module.h)("div", {
        className: htmlClass
      }, (0,preact_module.h)("div", {
        className: htmlClass + '_content'
      }, (0,preact_module.h)("div", {
        className: htmlClass + '_body'
      }, (0,preact_module.h)("div", {
        className: htmlClass + '_body__title ' + (onlyTitle ? 'only-title' : '')
      }, this.contentObject.title), this.contentObject.createdDate || this.contentObject.content ? (0,preact_module.h)("div", {
        className: htmlClass + '_body__text'
      }, this.contentObject.createdDate ? (0,preact_module.h)("span", {
        className: htmlClass + '_date'
      }, this.contentObject.createdDate) : null, this.contentObject.content ? (this.contentObject.createdDate ? ' ' : '') + this.contentObject.content : null) : null), this.contentObject.previewUrl ? (0,preact_module.h)("div", {
        className: htmlClass + '_body__image'
      }, (0,preact_module.h)("img", {
        src: this.contentObject.previewUrl
      })) : null), this.contentObject.isShared || this.contentObject.isFavorite || this.contentObject.todoCount && this.contentObject.todoCount > 0 ? (0,preact_module.h)("div", {
        className: htmlClass + '_socials'
      }, this.contentObject.isShared ? (0,preact_module.h)("div", {
        className: htmlClass + '_socials__shared'
      }, (0,preact_module.h)(icons/* IconShared */.LQ1, null)) : null, this.contentObject.isFavorite ? (0,preact_module.h)("div", {
        className: htmlClass + '_socials__favorites'
      }, (0,preact_module.h)(icons/* IconFavorites */.dUh, null)) : null, this.contentObject.todoCount && this.contentObject.todoCount > 0 ? (0,preact_module.h)("div", {
        className: htmlClass + '_socials__tasks'
      }, (0,preact_module.h)(icons/* IconTodo */.ws, null), (0,preact_module.h)("span", {
        className: "tasks_count"
      }, this.contentObject.todoCount)) : null) : null);
    }
  }, {
    key: "getFolderHtml",
    value: function getFolderHtml() {
      var htmlClass = 'mention-folder-info';
      var nCnt = parseInt(this.contentObject.notes_count);
      var sCnt = parseInt(this.contentObject.subfolders_count);
      return (0,preact_module.h)("div", {
        className: htmlClass
      }, nCnt + ' ' + this.i18n.get('mention.info.note.' + getTranslateCnt(nCnt)) + ' / ' + sCnt + ' ' + this.i18n.get('mention.info.subfolder.' + getTranslateCnt(sCnt)));
    }
  }, {
    key: "getWorkspaceHtml",
    value: function getWorkspaceHtml() {
      var htmlClass = 'mention-workspace-info';
      var mCnt = parseInt(this.contentObject.members_count);
      return (0,preact_module.h)("div", {
        className: htmlClass
      }, mCnt + ' ' + this.i18n.get('mention.info.member.' + getTranslateCnt(mCnt)) + ' / ' + this.i18n.get('mention.info.owner') + ': ' + this.contentObject.owner);
    }
  }, {
    key: "getUserHtml",
    value: function getUserHtml() {
      var htmlClass = 'mention-user-info';
      return (0,preact_module.h)("div", {
        className: htmlClass
      }, (0,preact_module.h)("div", {
        className: htmlClass + '_avatar'
      }, this.contentObject.avatar_url ? (0,preact_module.h)("img", {
        src: this.contentObject.avatar_url
      }) : (0,preact_module.h)("div", {
        className: htmlClass + '_avatar__no-avatar'
      }, this.contentObject.user_name.split('')[0].toUpperCase())), (0,preact_module.h)("div", {
        className: htmlClass + '_body'
      }, (0,preact_module.h)("div", {
        className: htmlClass + '_name'
      }, this.contentObject.user_name), (0,preact_module.h)("div", {
        className: htmlClass + '_email'
      }, this.contentObject.user_email)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        type = _this$props.type,
        objectId = _this$props.objectId,
        workspaceId = _this$props.workspaceId;
      var _this$state = this.state,
        contentLoaded = _this$state.contentLoaded,
        loadError = _this$state.loadError;
      var info = (0,preact_module.h)("div", {
        className: "mention-info-loading"
      }, this.i18n.get('mention.info.loading'));
      if (!contentLoaded) {
        this.loadInfo(type, objectId, workspaceId);
      } else {
        if (Object.keys(this.contentObject).length) {
          switch (type) {
            case 'note':
              info = this.getNoteHtml();
              break;
            case 'folder':
              info = this.getFolderHtml();
              break;
            case 'workspace':
              info = this.getWorkspaceHtml();
              break;
            case 'user':
              info = this.getUserHtml();
              break;
          }
        } else if (loadError) {
          var message = this.i18n.get('mention.info.loading_failed');
          if (loadError instanceof customDisplayableError["default"]) {
            message = loadError.message;
          } else {
            console.log('got mention load error:', loadError, ' which is not CustomDisplayableError', loadError.constructor.name);
          }
          info = message;
        } else {
          info = null;
        }
      }
      return (0,preact_module.h)(PopupMenuTransition, null, (0,preact_module.h)(popupMenu/* default */.Z, {
        wantsToClose: this.props.hideInfo,
        anchorNode: this.props.mentionNode,
        anchorOptions: {
          placement: 'bottom-start',
          behavior: ['bottom', 'top', 'bottom'],
          offset: '5px, 8px',
          priority: ['right', 'left'],
          boundariesElement: this.editor.getScrollingContainer()
        }
      }, (0,preact_module.h)("div", {
        className: "mention-info"
      }, info)));
    }
  }]);
  return MentionInfo;
}(preact_module/* Component */.wA);

function getTranslateCnt(cnt) {
  return cnt % 10 === 1 && (cnt < 10 || cnt > 20) && 'one' || cnt % 10 >= 2 && cnt % 10 <= 4 && (cnt < 10 || cnt > 20) && 'some' || 'many';
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/mention.js
function mention_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { mention_typeof = function _typeof(obj) { return typeof obj; }; } else { mention_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return mention_typeof(obj); }

function mention_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function mention_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { mention_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { mention_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }













function mention_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function mention_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function mention_createClass(Constructor, protoProps, staticProps) { if (protoProps) mention_defineProperties(Constructor.prototype, protoProps); if (staticProps) mention_defineProperties(Constructor, staticProps); return Constructor; }
function mention_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) mention_setPrototypeOf(subClass, superClass); }
function mention_setPrototypeOf(o, p) { mention_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return mention_setPrototypeOf(o, p); }
function mention_createSuper(Derived) { var hasNativeReflectConstruct = mention_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = mention_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = mention_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return mention_possibleConstructorReturn(this, result); }; }
function mention_possibleConstructorReturn(self, call) { if (call && (mention_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return mention_assertThisInitialized(self); }
function mention_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function mention_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function mention_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { mention_get = Reflect.get; } else { mention_get = function _get(target, property, receiver) { var base = mention_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return mention_get(target, property, receiver || target); }
function mention_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = mention_getPrototypeOf(object); if (object === null) break; } return object; }
function mention_getPrototypeOf(o) { mention_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return mention_getPrototypeOf(o); }
function mention_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var Mention = /*#__PURE__*/function (_InlineEmbed) {
  mention_inherits(Mention, _InlineEmbed);
  var _super = mention_createSuper(Mention);
  function Mention(node) {
    var _this;
    mention_classCallCheck(this, Mention);
    _this = _super.call(this, node);
    mention_defineProperty(mention_assertThisInitialized(_this), "onMouseOver", function () {
      if (!_this.getInfoByTypeMethodImplemented()) return;
      var infoRenderContainer = _this.scroll.editor.scrollingContainer;
      var infoNode = infoRenderContainer.querySelector('.mention-info-popup');
      if (infoNode) {
        if (infoNode.getAttribute('data-mention-id') === _this.value().mention.id) return;
        _this.hideInfo();
      }
      pRenderInContainer((0,preact_module.h)("div", {
        className: "mention-info-popup",
        "data-mention-id": _this.value().mention.id
      }, (0,preact_module.h)(MentionInfo, {
        type: _this.value().mention.type,
        objectId: _this.value().mention.object_id,
        workspaceId: _this.value().mention.workspace_id,
        editor: _this.scroll.editor,
        hideInfo: _this.hideInfo,
        mentionNode: _this.contentNode
      })), _this.scroll.editor.scrollingContainer, 'mention-popup-wrapper');
    });
    mention_defineProperty(mention_assertThisInitialized(_this), "onMouseOut", function () {
      _this.hideInfo();
    });
    mention_defineProperty(mention_assertThisInitialized(_this), "onMentionClick", function (event) {
      event.preventDefault();
      var _this$contentNode$get = _this.contentNode.getBoundingClientRect(),
        x = _this$contentNode$get.x,
        y = _this$contentNode$get.y,
        height = _this$contentNode$get.height;
      var clientX = event.clientX,
        clientY = event.clientY;
      if (clientY >= y && clientY <= y + height && clientX >= x && clientX <= x + 10) {
        var storedBlot = normalizeToStoredBlot(mention_assertThisInitialized(_this));
        var offset = _this.offset(normalizeToStoredBlot(mention_assertThisInitialized(_this)));
        _this.scroll.selection.setRange({
          index: storedBlot.offset(_this.scroll) + offset,
          length: 0
        });
      } else if (_this.scroll.editor.plugins.mentionManager) {
        _this.scroll.editor.plugins.mentionManager.onMentionClick(_this.value().mention.type, _this.value().mention.object_id, _this.value().mention.workspace_id);
      }
    });
    mention_defineProperty(mention_assertThisInitialized(_this), "hideInfo", function () {
      pRenderInContainer(null, _this.scroll.editor.scrollingContainer, 'mention-popup-wrapper');
    });
    _this.isSeparableByClickApplicable = true;
    _this.contentNode.classList.add('mention-link');
    _this.contentNode.setAttribute('data-mention-id', _this.domNode.getAttribute('data-mention-id'));
    _this.contentNode.setAttribute('data-mention-type', _this.domNode.getAttribute('data-mention-type'));
    _this.contentNode.setAttribute('data-mention-name', _this.domNode.getAttribute('data-mention-name'));
    _this.contentNode.setAttribute('data-mention-object_id', _this.domNode.getAttribute('data-mention-object_id'));
    if (_this.domNode.getAttribute('data-mention-workspace_id')) {
      _this.contentNode.setAttribute('data-mention-workspace_id', _this.domNode.getAttribute('data-mention-workspace_id'));
    }
    return _this;
  }
  mention_createClass(Mention, [{
    key: "attach",
    value: function attach() {
      var _get2,
        _this$scroll$editor$p,
        _this$scroll$editor$p2,
        _this$scroll$editor$p3,
        _this2 = this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = mention_get(mention_getPrototypeOf(Mention.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      if (this.attached) return;
      this.attached = true;
      var mentionName = (_this$scroll$editor$p = this.scroll.editor.plugins.mentionManager) === null || _this$scroll$editor$p === void 0 ? void 0 : (_this$scroll$editor$p2 = _this$scroll$editor$p.cache) === null || _this$scroll$editor$p2 === void 0 ? void 0 : (_this$scroll$editor$p3 = _this$scroll$editor$p2.get(this.domNode.getAttribute('data-mention-object_id'))) === null || _this$scroll$editor$p3 === void 0 ? void 0 : _this$scroll$editor$p3.name;
      if (!mentionName || typeof mentionName === 'undefined') {
        Mention.getMentionName(this.value().mention, this.domNode.getAttribute('data-mention-name'), this.scroll.editor).then(function (name) {
          _this2.attachMentionTitle(name);
        }).catch(function (err) {});
      } else {
        this.attachMentionTitle(mentionName);
      }
      this.contentNode.addEventListener('mouseover', this.onMouseOver, false);
      this.contentNode.addEventListener('mouseout', this.onMouseOut, false);
      this.contentNode.addEventListener('click', this.onMentionClick, false);
    }
  }, {
    key: "attachMentionTitle",
    value: function attachMentionTitle(name) {
      if (this.domNode.getAttribute('data-mention-name') !== name) {
        this.domNode.setAttribute('data-mention-name', name);
      }
      this.contentNode.innerText = name;
    }
  }, {
    key: "getInfoByTypeMethodImplemented",
    value: function getInfoByTypeMethodImplemented() {
      var managerOptions = this.scroll.editor.plugins.mentionManager.options;
      switch (this.value().mention.type) {
        case 'note':
          return managerOptions.getNoteTeaser;
        case 'folder':
          return managerOptions.getFolderInfo;
        case 'workspace':
          return managerOptions.getWorkspaceInfo;
        case 'user':
          return managerOptions.getUserInfo;
      }
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = mention_get(mention_getPrototypeOf(Mention.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      this.contentNode.removeEventListener('mouseover', this.onMouseOver, false);
      this.contentNode.removeEventListener('mouseout', this.onMouseOut, false);
      this.contentNode.removeEventListener('click', this.onMentionClick, false);
      this.attached = null;
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      var node = this.domNode.cloneNode(true);
      var url = context && context.getMentionUrl && context.getMentionUrl(node.getAttribute('data-mention-type'), node.getAttribute('data-mention-object_id'));
      if (url) {
        var oldMention = node.querySelector('.mention-link');
        var mention = oldMention.cloneNode();
        var link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('target', '_blank');
        var text = document.createTextNode(this.contentNode.innerText);
        link.appendChild(text);
        mention.appendChild(link);
        oldMention.parentNode.replaceChild(mention, oldMention);
      }
      return node.outerHTML;
    }
  }], [{
    key: "create",
    value: function create(value) {
      var node = mention_get(mention_getPrototypeOf(Mention), "create", this).call(this);
      node.classList.add('mention');
      node.setAttribute('data-mention-id', value.id);
      node.setAttribute('data-mention-type', value.type);
      node.setAttribute('data-mention-name', value.name);
      node.setAttribute('data-mention-object_id', value.object_id);
      if (value.workspace_id) {
        node.setAttribute('data-mention-workspace_id', value.workspace_id);
      }
      return node;
    }
  }, {
    key: "value",
    value: function value(domNode) {
      var result = {
        id: domNode.getAttribute('data-mention-id'),
        type: domNode.getAttribute('data-mention-type'),
        name: domNode.getAttribute('data-mention-name'),
        object_id: domNode.getAttribute('data-mention-object_id')
      };
      if (domNode.getAttribute('data-mention-workspace_id')) {
        result.workspace_id = domNode.getAttribute('data-mention-workspace_id');
      }
      return result;
    }
  }, {
    key: "getOpText",
    value: function getOpText(op, children, editor) {
      if (editor && editor.plugins.mentionManager.cache) {
        var _editor$plugins$menti;
        var name = (_editor$plugins$menti = editor.plugins.mentionManager.cache.get(op.mention.object_id)) === null || _editor$plugins$menti === void 0 ? void 0 : _editor$plugins$menti.name;
        if (name && typeof name === 'string') {
          return name;
        }
      }
      return op.mention.name;
    }
  }, {
    key: "getMentionName",
    value: function getMentionName(mention) {
      var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var editor = arguments.length > 2 ? arguments[2] : undefined;
      return new Promise( /*#__PURE__*/function () {
        var _ref = mention_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve) {
          var type, object_id, workspace_id;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  type = mention.type, object_id = mention.object_id, workspace_id = mention.workspace_id;
                  if (!(!name || typeof name === 'undefined' || name === 'undefined')) {
                    _context.next = 5;
                    break;
                  }
                  _context.next = 4;
                  return editor.plugins.mentionManager.getMentionTitle(type, object_id, workspace_id);
                case 4:
                  name = _context.sent;
                case 5:
                  if (name) {
                    editor.plugins.mentionManager.cache.save(object_id, {
                      type: type,
                      name: name,
                      workspace_id: workspace_id
                    });
                    resolve(name);
                  } else {
                    resolve('undefined');
                  }
                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }]);
  return Mention;
}(InlineEmbed);

Mention.blotName = 'mention';
Mention.tagName = 'mention';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/interface/deltaComponent.js
function deltaComponent_slicedToArray(arr, i) { return deltaComponent_arrayWithHoles(arr) || deltaComponent_iterableToArrayLimit(arr, i) || deltaComponent_unsupportedIterableToArray(arr, i) || deltaComponent_nonIterableRest(); }
function deltaComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function deltaComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return deltaComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return deltaComponent_arrayLikeToArray(o, minLen); }
function deltaComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function deltaComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function deltaComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function deltaComponent_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { deltaComponent_typeof = function _typeof(obj) { return typeof obj; }; } else { deltaComponent_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return deltaComponent_typeof(obj); }





















var oldHighlightNames = Object.keys(matHighlightNamesAssoc);

/**
 * Рендерит дельту в виде preact компонента
 * ВНИМАНИЕ! Используется в ячейках таблицы, если перегрузить компонент тяжелым функционалом, таблицы начнут тормозить
 * @param { array } delta
 * @param { object } linkProps: props, устанавливаемые в ноду ссылки, допустим ref, onClick
 * @param { object } mentionProps: props, устанавливаемые в ноду меншина, допустим ref, onClick
 */
function DeltaComponent(props) {
  var delta = props.delta,
    editor = props.editor;
  var children = delta.reduce(function (children, item) {
    var insertType = deltaComponent_typeof(item.insert);
    if (insertType === 'object') {
      if (item.insert.hasOwnProperty('linebreak') && item.insert.linebreak === 's') {
        children.push((0,preact_module.h)("br", {
          class: "separator"
        }));
      } else if (item.insert.hasOwnProperty('mention')) {
        var _props$mentionProps = props.mentionProps,
          mentionProps = _props$mentionProps === void 0 ? {} : _props$mentionProps;
        var mention = item.insert.mention;
        var component = (0,preact_module.h)(MentionComponent, {
          editor: editor,
          mentionProps: mentionProps,
          mention: mention
        });
        children.push(component);
      }
    } else if (insertType === 'string') {
      var insert = item.insert;
      if (insert === ' \n') {
        insert = (0,preact_module.h)("br", null);
      }
      if (!item.hasOwnProperty('attributes')) {
        children.push(insert);
      } else {
        // Сортируем атрибуты, чтобы вложенность тегов всегда имела одинаковый порядок, таким образом избегаем артефактов в стилях
        // Например color > strikethrough и strikethrough > color отображались бы по разному
        var resultComponent = Object.keys(item.attributes).sort().reverse().reduce(function (result, attr) {
          var value = item.attributes[attr];
          switch (attr) {
            case 'color':
              var colorProps = {};
              if ((value === null || value === void 0 ? void 0 : value[0]) === '#') {
                colorProps.style = {
                  color: value
                };
              } else {
                colorProps['data-font-color'] = value;
              }
              result = (0,preact_module.h)("span", _extends({
                className: "font-color"
              }, colorProps), result);
              break;
            case 'strikethrough':
              result = (0,preact_module.h)("del", null, result);
              break;
            case 'bold':
              result = (0,preact_module.h)("strong", null, result);
              break;
            case 'italic':
              result = (0,preact_module.h)("em", null, result);
              break;
            case 'underline':
              result = (0,preact_module.h)("u", null, result);
              break;
            case 'code':
              result = (0,preact_module.h)("code", {
                className: "inline-code"
              }, result);
              break;
            case 'background':
              var classes = ['background-color'];
              if (matHighlightNames.includes(value) || oldHighlightNames.includes(value)) {
                classes.push('extra-highlight');
              }
              result = (0,preact_module.h)("span", {
                className: classes.join(' '),
                "data-highlight": value
              }, result);
              break;
            case 'placeholder':
              result = (0,preact_module.h)("placeholder", null, result);
              break;
            case 'link':
              var _props$linkProps = props.linkProps,
                linkProps = _props$linkProps === void 0 ? {} : _props$linkProps;
              result = (0,preact_module.h)("a", _extends({
                href: value,
                target: "_blank",
                rel: "nofollow noopener"
              }, linkProps), result);
              break;
          }
          return result;
        }, insert);
        children.push(resultComponent);
      }
    }
    return children;
  }, []);
  return (0,preact_module.h)(preact_module/* Fragment */.HY, null, children);
}

/**
 * Экспортирует дельту в html строку
 * Возможно, стоит использовать аналог renderToString / renderToStaticMarkup
 * @param {delta} delta
 * @returns {string} html
 */
function DeltaToHTML(delta) {
  var node = document.createElement('div');
  (0,preact_module/* render */.sY)((0,preact_module.h)(DeltaComponent, {
    delta: delta
  }), node);
  var html = node.innerHTML;
  (0,preact_module/* render */.sY)(null, node);
  return html;
}

/**
 * Компонент упоминания для рендера дельты (в старых таблицах возможно наличие нескольких упоминаний)
 * @param { object } mentionProps: props, устанавливаемые в ноду меншина, допустим ref, onClick
 * @param { object } mention: объект упоминания хранимый в дельте
 * @param { object } editor: инстанс редактора
 */
function MentionComponent(props) {
  var _editor$plugins$menti;
  var mentionRef = (0,hooks_module/* useRef */.sO)(null);
  var _props$mentionProps2 = props.mentionProps,
    mentionProps = _props$mentionProps2 === void 0 ? {} : _props$mentionProps2,
    mention = props.mention,
    editor = props.editor;
  var attrs = ['id', 'type', 'object_id', 'workspace_id'];
  var mentionAttrs = attrs.reduce(function (acc, attr) {
    if (mention.hasOwnProperty(attr)) {
      acc['data-mention-' + attr] = mention[attr];
    }
    return acc;
  }, {});
  var mentionName = editor ? (_editor$plugins$menti = editor.plugins.mentionManager.cache.get(String(mention.object_id))) === null || _editor$plugins$menti === void 0 ? void 0 : _editor$plugins$menti.name : false;
  var _useState = (0,hooks_module/* useState */.eJ)(mentionName ? mentionName : ''),
    _useState2 = deltaComponent_slicedToArray(_useState, 2),
    mentionText = _useState2[0],
    setMentionText = _useState2[1];
  (0,hooks_module/* useEffect */.d4)(function () {
    if (mentionProps.ref) {
      mentionProps.ref.current = mentionRef.current;
    }
  }, [mentionRef.current]);
  (0,hooks_module/* useEffect */.d4)(function () {
    if (!mentionName && editor) {
      Mention.getMentionName(mention, mention.name, editor).then(function (result) {
        if (mentionRef.current) {
          if (result) {
            setMentionText(result);
          } else if (mention.name) {
            setMentionText(mention.name);
          } else {
            setMentionText('undefined');
          }
        }
      }).catch(function (err) {
        if (mention.name && mentionRef.current) {
          setMentionText(mention.name);
        } else {
          setMentionText('undefined');
        }
      }).finally(function () {
        if (mentionRef.current) {
          mentionRef.current.setAttribute('data-mention-name', mentionRef.current.innerText);
        }
      });
    } else if (editor) {
      setMentionText(mentionName);
    }
  }, [mention]);
  return (0,preact_module.h)("span", {
    className: "mention-component-wrap"
  }, (0,preact_module.h)("span", _extends({
    contenteditable: "false",
    className: "mention-link"
  }, mentionAttrs, mentionProps, {
    ref: mentionRef
  }), mentionText));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/interface/ratingComponent.js
function ratingComponent_extends() { ratingComponent_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ratingComponent_extends.apply(this, arguments); }


function ratingComponent_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function ratingComponent_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function ratingComponent_createClass(Constructor, protoProps, staticProps) { if (protoProps) ratingComponent_defineProperties(Constructor.prototype, protoProps); if (staticProps) ratingComponent_defineProperties(Constructor, staticProps); return Constructor; }



var RatingIcon = /*#__PURE__*/function () {
  function RatingIcon() {
    ratingComponent_classCallCheck(this, RatingIcon);
  }
  ratingComponent_createClass(RatingIcon, null, [{
    key: "getFullIconSet",
    value: function getFullIconSet() {
      var iconSet = {
        star: {
          active: icons/* IconRatingStarRed */.l_R,
          inactive: icons/* IconRatingStarLight */.tZi,
          gray: icons/* IconRatingStarGray */.xnp,
          blue: icons/* IconRatingStarBlue */._rD
        },
        flag: {
          active: icons/* IconRatingFlagRed */.SVd,
          inactive: icons/* IconRatingFlagLight */.$Eb,
          gray: icons/* IconRatingFlagGray */.ffD,
          blue: icons/* IconRatingFlagBlue */.Ec4
        },
        heart: {
          active: icons/* IconRatingHeartRed */.hjt,
          inactive: icons/* IconRatingHeartLight */.VRy,
          gray: icons/* IconRatingHeartGray */.CSG,
          blue: icons/* IconRatingHeartBlue */.OYV
        }
      };
      return iconSet;
    }
  }, {
    key: "getIconSet",
    value: function getIconSet(type) {
      var iconSet = RatingIcon.getFullIconSet();
      if (type == 'heart') {
        return iconSet.heart;
      } else if (type == 'flag') {
        return iconSet.flag;
      } else {
        return iconSet.star;
      }
    }
  }]);
  return RatingIcon;
}();

/**
 * Компонент рейтинг
 * @param { object } editor
 * @param { boolean } editable: разрешение редактировать список
 * @param { number } rating: активный рейтинг
 * @param { format } format: формат рейтинга
 * @param { string } format.type: тип элемента
 * @param { number } format.amount: общее число элементов
 * @param { function } onChange: функция при изменении рейтинга
 */
function RatingComponent(_ref) {
  var editor = _ref.editor,
    editable = _ref.editable,
    _ref$format = _ref.format,
    format = _ref$format === void 0 ? {} : _ref$format,
    rating = _ref.rating,
    onChange = _ref.onChange;
  var setRating = function setRating(r, event) {
    onChange(r === 1 && r === rating ? 0 : r);
  };
  var componentClasses = ['rating-component'];
  if (editable) {
    componentClasses.push('rating-editable');
  }
  var icons = RatingIcon.getIconSet(format.type);
  var items = [];
  for (var r = 1; r <= format.amount; r++) {
    var Icon = void 0;
    var enabled = r <= rating;
    var classes = ['rating-item'];
    if (enabled) {
      Icon = icons.active;
      classes.push('rating-active');
    } else {
      Icon = icons.inactive;
      classes.push('rating-inactive');
    }
    var listeners = {};
    if (editable) {
      listeners.onClick = setRating.bind(this, r);
    }
    items.push((0,preact_module.h)("span", ratingComponent_extends({
      className: classes.join(' ')
    }, listeners), (0,preact_module.h)(Icon, null)));
  }
  return (0,preact_module.h)("div", {
    className: componentClasses.join(' ')
  }, items);
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/async.js


function async_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function async_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { async_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { async_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function timeout() {
  return _timeout.apply(this, arguments);
}
function _timeout() {
  _timeout = async_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var delay,
      _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            delay = _args.length > 0 && _args[0] !== undefined ? _args[0] : 0;
            return _context.abrupt("return", new Promise(function (resolve) {
              setTimeout(function () {
                resolve(true);
              }, parseInt(delay) || 0);
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _timeout.apply(this, arguments);
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/toggle.js
function toggle_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { toggle_typeof = function _typeof(obj) { return typeof obj; }; } else { toggle_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return toggle_typeof(obj); }









function toggle_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function toggle_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function toggle_createClass(Constructor, protoProps, staticProps) { if (protoProps) toggle_defineProperties(Constructor.prototype, protoProps); if (staticProps) toggle_defineProperties(Constructor, staticProps); return Constructor; }
function toggle_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) toggle_setPrototypeOf(subClass, superClass); }
function toggle_setPrototypeOf(o, p) { toggle_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return toggle_setPrototypeOf(o, p); }
function toggle_createSuper(Derived) { var hasNativeReflectConstruct = toggle_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = toggle_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = toggle_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return toggle_possibleConstructorReturn(this, result); }; }
function toggle_possibleConstructorReturn(self, call) { if (call && (toggle_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return toggle_assertThisInitialized(self); }
function toggle_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function toggle_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function toggle_getPrototypeOf(o) { toggle_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return toggle_getPrototypeOf(o); }

/*
<Toggle
  status={boolean}
  listenUpdates={boolean}
  onChange={function}
/>
*/
var Toggle = /*#__PURE__*/function (_Component) {
  toggle_inherits(Toggle, _Component);
  var _super = toggle_createSuper(Toggle);
  function Toggle(props) {
    var _this;
    toggle_classCallCheck(this, Toggle);
    _this = _super.call(this, props);
    _this.state = {
      status: props.status || false
    };
    return _this;
  }
  toggle_createClass(Toggle, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(newProps, newState) {
      if (this.props.listenUpdates) {
        if (this.state.status !== newProps.status) {
          this.changeStatus(newProps.status, true);
        }
      }
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown(event) {
      var status = this.state.status;
      // для таблиц делаем stopPropogation иначе время будет устанавливаться не корректно NIM-18260
      if (this.props.mode === 'table') {
        event.stopPropagation();
      }
      this.changeStatus(status ? false : true);
    }
  }, {
    key: "changeStatus",
    value: function changeStatus(status, passive) {
      var _this2 = this;
      status = status ? true : false;
      this.setState(function () {
        return {
          status: status
        };
      }, function () {
        if (!passive) {
          _this2.onChangeAction(status);
        }
      });
    }
  }, {
    key: "onChangeAction",
    value: function onChangeAction(status) {
      var onChange = this.props.onChange;
      if (onChange) {
        onChange(status);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var status = this.state.status;
      return (0,preact_module.h)("div", {
        onMouseDown: this.onMouseDown.bind(this),
        className: 'component-toggle ' + (status ? 'component-toggle-active ' : '') + (this.props.addClassName ? this.props.addClassName : '')
      }, (0,preact_module.h)("div", {
        className: "component-toggle-slider"
      }, (0,preact_module.h)("div", {
        className: "component-toggle-handler"
      })));
    }
  }]);
  return Toggle;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/components/popupMenuItem.js
var popupMenuItem = __webpack_require__(28411);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/popupMenuSeparator.js
function popupMenuSeparator_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { popupMenuSeparator_typeof = function _typeof(obj) { return typeof obj; }; } else { popupMenuSeparator_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return popupMenuSeparator_typeof(obj); }









function popupMenuSeparator_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function popupMenuSeparator_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function popupMenuSeparator_createClass(Constructor, protoProps, staticProps) { if (protoProps) popupMenuSeparator_defineProperties(Constructor.prototype, protoProps); if (staticProps) popupMenuSeparator_defineProperties(Constructor, staticProps); return Constructor; }
function popupMenuSeparator_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) popupMenuSeparator_setPrototypeOf(subClass, superClass); }
function popupMenuSeparator_setPrototypeOf(o, p) { popupMenuSeparator_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return popupMenuSeparator_setPrototypeOf(o, p); }
function popupMenuSeparator_createSuper(Derived) { var hasNativeReflectConstruct = popupMenuSeparator_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = popupMenuSeparator_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = popupMenuSeparator_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return popupMenuSeparator_possibleConstructorReturn(this, result); }; }
function popupMenuSeparator_possibleConstructorReturn(self, call) { if (call && (popupMenuSeparator_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return popupMenuSeparator_assertThisInitialized(self); }
function popupMenuSeparator_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function popupMenuSeparator_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function popupMenuSeparator_getPrototypeOf(o) { popupMenuSeparator_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return popupMenuSeparator_getPrototypeOf(o); }

var PopupMenuSeparator = /*#__PURE__*/function (_Component) {
  popupMenuSeparator_inherits(PopupMenuSeparator, _Component);
  var _super = popupMenuSeparator_createSuper(PopupMenuSeparator);
  function PopupMenuSeparator() {
    popupMenuSeparator_classCallCheck(this, PopupMenuSeparator);
    return _super.apply(this, arguments);
  }
  popupMenuSeparator_createClass(PopupMenuSeparator, [{
    key: "render",
    value: function render() {
      return (0,preact_module.h)("div", {
        className: "popup-menu-separator"
      });
    }
  }]);
  return PopupMenuSeparator;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/is-hotkey/lib/index.js
var lib = __webpack_require__(28199);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/inputDateMenuReminder.js
function inputDateMenuReminder_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { inputDateMenuReminder_typeof = function _typeof(obj) { return typeof obj; }; } else { inputDateMenuReminder_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return inputDateMenuReminder_typeof(obj); }
function inputDateMenuReminder_extends() { inputDateMenuReminder_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return inputDateMenuReminder_extends.apply(this, arguments); }













function inputDateMenuReminder_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function inputDateMenuReminder_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function inputDateMenuReminder_createClass(Constructor, protoProps, staticProps) { if (protoProps) inputDateMenuReminder_defineProperties(Constructor.prototype, protoProps); if (staticProps) inputDateMenuReminder_defineProperties(Constructor, staticProps); return Constructor; }
function inputDateMenuReminder_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) inputDateMenuReminder_setPrototypeOf(subClass, superClass); }
function inputDateMenuReminder_setPrototypeOf(o, p) { inputDateMenuReminder_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return inputDateMenuReminder_setPrototypeOf(o, p); }
function inputDateMenuReminder_createSuper(Derived) { var hasNativeReflectConstruct = inputDateMenuReminder_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = inputDateMenuReminder_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = inputDateMenuReminder_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return inputDateMenuReminder_possibleConstructorReturn(this, result); }; }
function inputDateMenuReminder_possibleConstructorReturn(self, call) { if (call && (inputDateMenuReminder_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return inputDateMenuReminder_assertThisInitialized(self); }
function inputDateMenuReminder_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function inputDateMenuReminder_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function inputDateMenuReminder_getPrototypeOf(o) { inputDateMenuReminder_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return inputDateMenuReminder_getPrototypeOf(o); }
function inputDateMenuReminder_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var isEnterKey = (0,lib/* default */.ZP)('enter');
var isEsc = (0,lib/* default */.ZP)('esc');

var PEROIODS = ['m', 'h', 'd', 'w'];
var InputDateMenuReminder = /*#__PURE__*/function (_Component) {
  inputDateMenuReminder_inherits(InputDateMenuReminder, _Component);
  var _super = inputDateMenuReminder_createSuper(InputDateMenuReminder);
  function InputDateMenuReminder(props) {
    var _props$editor, _props$editor$plugins, _props$editor$plugins2, _props$editor$plugins3;
    var _this;
    inputDateMenuReminder_classCallCheck(this, InputDateMenuReminder);
    _this = _super.call(this, props);
    inputDateMenuReminder_defineProperty(inputDateMenuReminder_assertThisInitialized(_this), "onChangeItem", function (value, event) {
      event.stopPropagation();
      var _this$props = _this.props,
        onChange = _this$props.onChange,
        wantsToClose = _this$props.wantsToClose;
      if (value !== 'none') {
        var _ref = _this.props.editor.plugins || {},
          reminderManager = _ref.reminderManager;
        if (reminderManager && reminderManager.onSetReminder) {
          reminderManager.onSetReminder(value);
        }
      }
      onChange && onChange(value);
      if (value !== 'custom') {
        wantsToClose && wantsToClose();
      }
    });
    inputDateMenuReminder_defineProperty(inputDateMenuReminder_assertThisInitialized(_this), "onInputClick", function (event) {
      event.stopPropagation();
      var len = String(_this.nodes.value.value).length;
      if (len) {
        _this.nodes.value.setSelectionRange(0, len);
      }
    });
    inputDateMenuReminder_defineProperty(inputDateMenuReminder_assertThisInitialized(_this), "stopPropagation", function (event) {
      event.stopPropagation();
    });
    inputDateMenuReminder_defineProperty(inputDateMenuReminder_assertThisInitialized(_this), "onKeyDownCustom", function (event) {
      var value = parseInt(_this.nodes.value.value) || 0;
      var key = parseInt(event.key);
      var nan = isNaN(key);
      if (event.key.length === 1 && nan) {
        event.preventDefault();
      } else if (value > 99 && !nan) {
        if (_this.nodes.value.selectionStart === _this.nodes.value.selectionEnd) {
          event.preventDefault();
        }
      }
    });
    inputDateMenuReminder_defineProperty(inputDateMenuReminder_assertThisInitialized(_this), "onChangeCustom", function (event) {
      event.stopPropagation();
      var _this$props2 = _this.props,
        onChange = _this$props2.onChange,
        wantsToClose = _this$props2.wantsToClose;
      var before = '';
      before += parseInt(_this.nodes.value.value) || 0;
      before += _this.nodes.period.value;
      onChange && onChange('custom', before);
      if (isEnterKey(event) || isEsc(event)) {
        wantsToClose && wantsToClose();
      }
    });
    _this.nodes = {};
    _this.showCustom = ((_props$editor = props.editor) === null || _props$editor === void 0 ? void 0 : (_props$editor$plugins = _props$editor.plugins) === null || _props$editor$plugins === void 0 ? void 0 : (_props$editor$plugins2 = _props$editor$plugins.reminderManager) === null || _props$editor$plugins2 === void 0 ? void 0 : (_props$editor$plugins3 = _props$editor$plugins2.options) === null || _props$editor$plugins3 === void 0 ? void 0 : _props$editor$plugins3.showCustom) || false;
    return _this;
  }
  inputDateMenuReminder_createClass(InputDateMenuReminder, [{
    key: "onRef",
    value: function onRef(name, node) {
      if (node) {
        this.nodes[name] = node;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        editor = _this$props3.editor,
        reminder = _this$props3.reminder,
        shift = _this$props3.shift,
        showTime = _this$props3.showTime,
        remindItemDependOnTime = _this$props3.remindItemDependOnTime;
      var i18n = editor.plugins.i18n;
      var menuItems = REMINDER_VALUES.map(function (value) {
        var seconds = strToSeconds(value);
        var active = reminder && value === reminder.value;
        if (value !== 'none' && !active) {
          if (seconds > shift && remindItemDependOnTime) {
            if (seconds || !showTime) {
              return '';
            }
          }
          if (!showTime && seconds > 0 && seconds < 86400) {
            return '';
          }
        }
        var style, icon;
        if (active || !reminder && value === 'none') {
          style = 'done';
          icon = icons/* IconDone */.EZi;
        } else {
          style = 'undone';
        }
        return (0,preact_module.h)(popupMenuItem/* default */.Z, {
          id: "reminder-item-".concat(value),
          onClick: _this2.onChangeItem.bind(_this2, value),
          menuStyle: style,
          icon: icon,
          text: i18n.get("calendar.ui.reminder.value.".concat(value))
        });
      });
      var customItemSyle, customItemIcon, customReminder;
      if (reminder && reminder.value === 'custom') {
        customItemSyle = 'done';
        customItemIcon = icons/* IconDone */.EZi;
        var text = reminder.text || '';
        var value = parseInt(text) || '';
        var period = text.replace(/\d+/, '');
        var options = PEROIODS.map(function (key) {
          if (!showTime && key !== period && ['m', 'h'].indexOf(key) !== -1) {
            return '';
          }
          var optionProps = {
            value: key
          };
          if (key === period) {
            optionProps.selected = 'selected';
          }
          return (0,preact_module.h)("option", optionProps, i18n.get("calendar.ui.reminder.period.".concat(key), null, value || 0));
        });
        var nodeBefore, nodeAfter;
        var txtBefore = i18n.get('calendar.ui.reminder.before_period');
        var txtAfter = i18n.get('calendar.ui.reminder.after_period');
        if (txtBefore) {
          nodeBefore = (0,preact_module.h)("span", {
            className: "reminder-text"
          }, txtBefore);
        }
        if (txtAfter) {
          nodeAfter = (0,preact_module.h)("span", {
            className: "reminder-text"
          }, txtAfter);
        }
        customReminder = (0,preact_module.h)("span", {
          className: "date-reminder-item",
          onMouseDown: this.stopPropagation.bind(this)
        }, nodeBefore, (0,preact_module.h)("input", {
          className: "reminder-value",
          type: "text",
          value: value,
          ref: this.onRef.bind(this, 'value'),
          onClick: this.onInputClick.bind(this),
          onKeyDown: this.onKeyDownCustom.bind(this),
          onKeyUp: this.onChangeCustom.bind(this)
        }), (0,preact_module.h)("select", {
          className: "reminder-period",
          ref: this.onRef.bind(this, 'period'),
          onClick: this.stopPropagation.bind(this),
          onChange: this.onChangeCustom.bind(this)
        }, options), (0,preact_module.h)(icons/* IconArrowDown */.BDo, null), nodeAfter);
      } else {
        customItemSyle = 'undone';
      }
      var customItems = this.showCustom ? (0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)(PopupMenuSeparator, null), (0,preact_module.h)(popupMenuItem/* default */.Z, {
        id: "reminder-item-custom",
        onClick: this.onChangeItem.bind(this, 'custom'),
        menuStyle: customItemSyle,
        icon: customItemIcon,
        text: i18n.get('calendar.ui.reminder.value.custom')
      }), customReminder) : null;
      return (0,preact_module.h)(PopupMenuTransition, null, (0,preact_module.h)(popupMenu/* default */.Z, inputDateMenuReminder_extends({
        addClassName: "popup-menu-reminders",
        closeOnEsc: true
      }, this.props), menuItems, customItems));
    }
  }]);
  return InputDateMenuReminder;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/plugins/popupManager/confirmPopup.js
var confirmPopup = __webpack_require__(23497);
// EXTERNAL MODULE: ./node_modules/path/index.js
var path = __webpack_require__(15583);
// EXTERNAL MODULE: ./node_modules/@lib/editor/providers/utils.js
var utils = __webpack_require__(86780);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/time.js

function getTimeCase(number) {
  return number % 10 === 1 && number % 100 !== 11 ? 'one' : number % 10 >= 2 && number % 10 <= 4 && (number % 100 < 10 || number % 100 >= 20) ? 'some' : 'many';
}
//сюда передаем время в милисекундах
function getRelativeTime(previousTime) {
  var currentTime = new Date().getTime();
  var elapsed = currentTime - previousTime;
  var msPerMinute = 60 * 1000;
  var msPerHour = msPerMinute * 60;
  var msPerDay = msPerHour * 24;
  var msPerMonth = msPerDay * 30;
  var msPerYear = msPerDay * 365;
  var unit, count;
  if (elapsed < msPerMinute) {
    unit = 'seconds';
    count = Math.round(elapsed / 1000);
  } else if (elapsed < msPerHour) {
    unit = 'minutes';
    count = Math.round(elapsed / msPerMinute);
  } else if (elapsed < msPerDay) {
    unit = 'hours';
    count = Math.round(elapsed / msPerHour);
  } else if (elapsed < msPerMonth) {
    unit = 'days';
    count = Math.round(elapsed / msPerDay);
  } else if (elapsed < msPerYear) {
    unit = 'months';
    count = Math.round(elapsed / msPerMonth);
  } else {
    unit = 'years';
    count = Math.round(elapsed / msPerYear);
  }
  return {
    unit: unit,
    count: count,
    case: getTimeCase(count)
  };
}

/**
 * Возвращает timestamp с нулевым временем 00:00:00
 * @param { Number } timestamp 
 * @returns { Number }
 */
var getTimestampWithZeroTime = function getTimestampWithZeroTime(timestamp) {
  var d = new Date(timestamp);
  d.setHours(0, 0, 0, 0);
  return d.getTime();
};

// экспортируем здесь, т.к. функция используется в других клиентах

function checkBrowserTimeFormat() {
  var time = new Date().toLocaleTimeString();
  if (time.indexOf('AM') !== -1 || time.indexOf('PM') !== -1
  // || true
  ) {
    return 12;
  } else {
    return 24;
  }
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/inputDate.js
function inputDate_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function inputDate_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { inputDate_ownKeys(Object(source), true).forEach(function (key) { inputDate_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { inputDate_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function inputDate_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = inputDate_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function inputDate_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return inputDate_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return inputDate_arrayLikeToArray(o, minLen); }
function inputDate_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

























function inputDate_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function inputDate_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { inputDate_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { inputDate_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function inputDate_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function inputDate_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function inputDate_createClass(Constructor, protoProps, staticProps) { if (protoProps) inputDate_defineProperties(Constructor.prototype, protoProps); if (staticProps) inputDate_defineProperties(Constructor, staticProps); return Constructor; }
function inputDate_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) inputDate_setPrototypeOf(subClass, superClass); }
function inputDate_setPrototypeOf(o, p) { inputDate_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return inputDate_setPrototypeOf(o, p); }
function inputDate_createSuper(Derived) { var hasNativeReflectConstruct = inputDate_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = inputDate_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = inputDate_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return inputDate_possibleConstructorReturn(this, result); }; }
function inputDate_possibleConstructorReturn(self, call) { if (call && (inputDate_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return inputDate_assertThisInitialized(self); }
function inputDate_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function inputDate_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function inputDate_getPrototypeOf(o) { inputDate_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return inputDate_getPrototypeOf(o); }
function inputDate_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function inputDate_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { inputDate_typeof = function _typeof(obj) { return typeof obj; }; } else { inputDate_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return inputDate_typeof(obj); }











var isEnter = (0,lib/* default */.ZP)('enter');
var inputDate_isEsc = (0,lib/* default */.ZP)('esc');
var isTabKey = (0,lib/* default */.ZP)('tab');
var isShiftTabKey = (0,lib/* default */.ZP)('shift+tab');
var isDeleteKey = (0,lib/* default */.ZP)('delete');
var isBackspaceKey = (0,lib/* default */.ZP)('backspace');
var DATE_FORMATS = {
  'ddmmyyyy': 'dd/mm/yyyy',
  'mmddyyyy': 'mm/dd/yyyy',
  'yyyyddmm': 'yyyy/mm/dd',
  'monthddyyyy': 'month dd, yyyy'
};
var REMINDER_VALUES = ['none', '0m', '5m', '10m', '30m', '1h', '1d', '7d', '14d'];
var DEFAULT_DATE_FORMAT = {
  type: 'default',
  showTime: false,
  timeZoneGMT: false,
  timeFormat: checkBrowserTimeFormat() == 12 ? 12 : 24
};
function getFirstWeekDay(editor) {
  var day = 0;
  if (inputDate_typeof(editor) === 'object') {
    if (editor.plugins.i18n.language === 'ru') {
      day = 1;
    }
  } else if (checkBrowserTimeFormat() == 24) {
    day = 1;
  }
  return day;
}
function strToSeconds(str) {
  var time = parseInt(str) || 0;
  if (str.indexOf('m') !== -1) {
    time *= 60;
  } else if (str.indexOf('h') !== -1) {
    time *= 3600;
  } else if (str.indexOf('d') !== -1) {
    time *= 86400;
  } else if (str.indexOf('w') !== -1) {
    time *= 604800;
  }
  return time;
}
var oneHour = 60 * 60 * 1000;
var oneDay = oneHour * 24;
var TIME_ZONE_REAL = 60e3 * new Date().getTimezoneOffset();
var InputDate = /*#__PURE__*/function (_Component) {
  inputDate_inherits(InputDate, _Component);
  var _super = inputDate_createSuper(InputDate);
  function InputDate(props) {
    var _this;
    inputDate_classCallCheck(this, InputDate);
    _this = _super.call(this, props);
    inputDate_defineProperty(inputDate_assertThisInitialized(_this), "remindersLimit", 5);
    inputDate_defineProperty(inputDate_assertThisInitialized(_this), "keysAllowed", [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 59, 111, 191, 186 // punct
    ]);
    inputDate_defineProperty(inputDate_assertThisInitialized(_this), "keysControl", [9, 27, 35, 36, 37, 38, 39, 40]);
    _this.skipBlur = false;
    _this.skipCloseAfterBlur = false;
    _this.touched = false;
    _this.nodes = {};
    _this.reminderNodes = {};
    _this.wrap = (0,preact_module/* createRef */.Vf)();
    _this.stringNode = null;
    _this.newReminderId = null;
    _this.panelDelay = null;
    _this.state = {
      oneHour: oneHour,
      oneDay: oneDay,
      ampm: 'am',
      timeField: '',
      dateField: '',
      timeZoneSelected: InputDate.getTimeZoneSelected(props.editor),
      reminderMenus: {},
      showPanel: false,
      timeZoneReal: TIME_ZONE_REAL
    };
    return _this;
  }

  /**
   * Получить выбранную таймзону
   * @param {Object} editor 
   * @returns number
   */
  inputDate_createClass(InputDate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props = this.props,
        editor = _this$props.editor,
        active = _this$props.active,
        firstWeekDay = _this$props.firstWeekDay,
        setReturnDateString = _this$props.setReturnDateString,
        setReturnDateComponent = _this$props.setReturnDateComponent;
      this.setState(function () {
        return {
          firstWeekDay: typeof firstWeekDay !== 'undefined' ? firstWeekDay : getFirstWeekDay(editor)
        };
      }, function () {
        if (setReturnDateString) {
          setReturnDateString(_this2.dateString.bind(_this2));
        }
        if (setReturnDateComponent) {
          setReturnDateComponent(_this2.dateStringComponent.bind(_this2));
        }
        if (active) {
          _this2.setFocus('date', 150);
        }
        _this2.setTimeZone();
        _this2.calculateGrid();
        _this2.fillFields();
        _this2.presetValue();
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps, oldState) {
      var _this3 = this;
      if (this.props.value != oldProps.value) {
        this.calculateGrid();
        this.fillFields();
      }
      if (this.props.firstWeekDay != oldProps.firstWeekDay) {
        this.setState(function () {
          return {
            firstWeekDay: _this3.props.firstWeekDay
          };
        });
      }
      if (this.props.timeZoneGMT != oldProps.timeZoneGMT) {
        this.setTimeZone(true);
      }
      if (this.props.showTime != oldProps.showTime) {
        //this.setTimeZone(true)
        if (!this.props.showTime) {
          this.writeValue(getTimestampWithZeroTime(this.props.value));
        }
      }
      if (this.state.firstWeekDay != oldState.firstWeekDay) {
        this.calculateGrid();
      }
    }
  }, {
    key: "onComponentResize",
    value: function onComponentResize() {
      var onResize = this.props.onResize;
      if (onResize) {
        setTimeout(function () {
          onResize();
        }, 0);
      }
    }
  }, {
    key: "onInputRef",
    value: function onInputRef(field, node) {
      if (field && node) {
        this.nodes[field] = node;
      }
    }
  }, {
    key: "onStringRef",
    value: function onStringRef(node) {
      if (node) {
        this.stringNode = node;
      }
    }
  }, {
    key: "onWrapMouseUp",
    value: function onWrapMouseUp() {
      this.skipCloseAfterBlur = false;
    }
  }, {
    key: "onWrapMouseDown",
    value: function onWrapMouseDown(event) {
      this.skipCloseAfterBlur = true;
      if (event.target.tagName != "INPUT") {
        this.setHiddenFocus();
      }
      this.closeReminderMenu();
      this.handlePanel(false);
    }

    /**
     * Получить тайм-зону (статический метод)
     * @param {Object} params 
     * @param {Number} params.timeZoneSelected
     * @param {Number} params.timeZoneReal
     * @param {Number} params.timeZoneGMT
     */
  }, {
    key: "setTimeZone",
    value: function setTimeZone(write) {
      var _this4 = this;
      var _this$props2 = this.props,
        value = _this$props2.value,
        timeZoneGMT = _this$props2.timeZoneGMT,
        showTime = _this$props2.showTime;
      this.setState(function (prevState) {
        var timeZoneReal = prevState.timeZoneReal,
          timeZoneSelected = prevState.timeZoneSelected;
        var newTimeZone = InputDate.getTimeZone({
          timeZoneReal: timeZoneReal,
          timeZoneSelected: timeZoneSelected,
          timeZoneGMT: timeZoneGMT
        });
        if (write && value) {
          var timeShift = newTimeZone - timeZoneSelected;
          _this4.writeValue(value + timeShift);
        }
        return {
          timeZoneSelected: newTimeZone
        };
      }, function () {
        _this4.calculateGrid();
      });
    }
  }, {
    key: "nextField",
    value: function nextField(field) {
      var _this$props3 = this.props,
        showTime = _this$props3.showTime,
        wantsToClose = _this$props3.wantsToClose;
      this.skipBlur = true;
      this.skipCloseAfterBlur = true;
      if (field === 'date' && showTime) {
        this.setFocus('time', 100);
      } else {
        this.blurInput(field);
      }
      if (field === 'time' || field === 'date' && !showTime) {
        wantsToClose && wantsToClose();
      }
    }
  }, {
    key: "setFocus",
    value: function () {
      var _setFocus = inputDate_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(field, delay) {
        var showTime, input, len;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return timeout(delay);
              case 2:
                showTime = this.props.showTime;
                if (field === 'last') {
                  if (showTime) {
                    field = 'time';
                  } else {
                    field = 'date';
                  }
                }
                if (!this.nodes[field]) {
                  _context.next = 12;
                  break;
                }
                input = this.nodes[field];
                input.focus();
                if (!(input.setSelectionRange && input.value)) {
                  _context.next = 12;
                  break;
                }
                len = input.value.length * 2;
                _context.next = 11;
                return timeout(1);
              case 11:
                input.setSelectionRange(len, len);
              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function setFocus(_x, _x2) {
        return _setFocus.apply(this, arguments);
      }
      return setFocus;
    }()
  }, {
    key: "setHiddenFocus",
    value: function () {
      var _setHiddenFocus = inputDate_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(delay) {
        var input;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!parseInt(delay)) {
                  _context2.next = 3;
                  break;
                }
                _context2.next = 3;
                return timeout(delay);
              case 3:
                input = this.nodes.hidden;
                if (input) {
                  input.focus();
                }
              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function setHiddenFocus(_x3) {
        return _setHiddenFocus.apply(this, arguments);
      }
      return setHiddenFocus;
    }()
  }, {
    key: "blurInput",
    value: function blurInput(field) {
      if (!this.nodes[field]) {
        return;
      }
      var input = this.nodes[field];
      input.blur();
    }
  }, {
    key: "onBlur",
    value: function onBlur(field, event) {
      var _this$props4 = this.props,
        active = _this$props4.active,
        listenBlur = _this$props4.listenBlur;
      if (!listenBlur) {
        return;
      }
      if (!this.skipBlur) {
        if (active) {
          if (this.touched) {
            this.setFieldsDate(field);
          }
        }
      } else {
        this.skipBlur = false;
      }
      this.closeAfterBlur();
    }
  }, {
    key: "onInputTouch",
    value: function onInputTouch(field, event) {
      event.stopPropagation();
      this.skipCloseAfterBlur = true;
      this.touched = true;
    }

    /**
     * Добавляет к числу меншему 10 — ноль
     * @param {*} num 
     * @returns 
     */
  }, {
    key: "closeAfterBlur",
    value: function () {
      var _closeAfterBlur = inputDate_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return timeout(1);
              case 2:
                if (!this.skipCloseAfterBlur) {
                  //this.close()
                } else {
                  this.skipCloseAfterBlur = false;
                }
              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function closeAfterBlur() {
        return _closeAfterBlur.apply(this, arguments);
      }
      return closeAfterBlur;
    }()
  }, {
    key: "close",
    value: function close(event) {
      var wantsToClose = this.props.wantsToClose;
      if (wantsToClose) {
        wantsToClose(event);
      }
    }
  }, {
    key: "setGrid",
    value: function setGrid(direction) {
      var _this$state = this.state,
        oneDay = _this$state.oneDay,
        firstMonthDayTime = _this$state.firstMonthDayTime,
        lastMonthDayTime = _this$state.lastMonthDayTime;
      var timestamp = firstMonthDayTime;
      if (direction == 'left') {
        timestamp = firstMonthDayTime - oneDay;
      } else if (direction == 'right') {
        timestamp = lastMonthDayTime + oneDay;
      }
      this.calculateGrid(timestamp);
    }
  }, {
    key: "calculateGrid",
    value: function calculateGrid(date) {
      var _this5 = this;
      var value = this.props.value;
      this.setState(function (prevState) {
        var oneHour = prevState.oneHour,
          oneDay = prevState.oneDay,
          firstWeekDay = prevState.firstWeekDay,
          timeZoneSelected = prevState.timeZoneSelected,
          timeZoneReal = prevState.timeZoneReal;
        var now = new Date();
        var datetime = date || value ? new Date(date || value) : new Date();
        var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        var year = datetime.getFullYear();
        var month = datetime.getMonth();
        var firstMonthDay = new Date(year, month, 1);
        var nextMonth = new Date(year, month + 1, 1);
        var lastMonthDay = new Date(nextMonth.getTime() - oneDay - _this5.timeShift);
        var numOfDays = Math.ceil((nextMonth.getTime() - firstMonthDay.getTime() - oneHour) / oneDay);
        var firstDayShift = firstMonthDay.getDay() - firstWeekDay;
        if (firstDayShift < 0) firstDayShift = 6;
        var firstGridDay = new Date(year, month, 1 - firstDayShift);
        var lastDayShift = 6 - lastMonthDay.getDay() + firstWeekDay;
        if (lastDayShift > 6) lastDayShift = 0;
        var lastGridDay = new Date(lastMonthDay.getTime() + oneDay * lastDayShift);
        //const lastGridDay = new Date(year, month, lastMonthDay.getDay() + lastDayShift)

        var gridDays = 1 + (lastGridDay.getTime() - firstGridDay.getTime()) / oneDay;
        return {
          now: now,
          nowTime: now.getTime() - _this5.timeShift,
          today: today,
          todayTime: today.getTime() - _this5.timeShift,
          firstMonthDay: firstMonthDay,
          firstMonthDayTime: firstMonthDay.getTime(),
          lastMonthDay: lastMonthDay,
          lastMonthDayTime: lastMonthDay.getTime(),
          numOfDays: numOfDays,
          firstGridDay: firstGridDay,
          lastGridDay: lastGridDay,
          gridDays: gridDays
        };
      });
      this.onComponentResize();
    }

    /**
     * Получить дату в виде строки (статический метод)
     * @param {Object} props 
     * @param {Object} props.editor
     * @param {Number} props.value
     * @param {Boolean} props.showTime
     * @param {String} props.timeFormat
     * @param {String} props.dateFormat
     * @param {Object} params 
     * @param {Number} params.value 
     * @param {Boolean} params.showTime 
     * @param {Number} params.oneDay 
     * @param {Number} params.timeZoneReal 
     * @param {Number} params.timeZoneSelected 
     * @param {Number} params.timeShift 
     * @returns string
     */
  }, {
    key: "dateString",
    value:
    /**
     * Получить дату в виде строки
     * @param {*} params 
     * @param {Number} params.value 
     * @param {Boolean} params.showTime 
     * @returns string
     */
    function dateString() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$state2 = this.state,
        oneDay = _this$state2.oneDay,
        timeZoneReal = _this$state2.timeZoneReal,
        timeZoneSelected = _this$state2.timeZoneSelected;
      return InputDate.dateString(this.props, {
        oneDay: oneDay,
        timeZoneReal: timeZoneReal,
        timeZoneSelected: timeZoneSelected,
        value: params.value,
        showTime: params.showTime,
        timeShift: this.timeShift
      });
    }

    /**
     * Получить дату по шаблону (ститический метод)
     * @param {Date} date 
     * @param {String} tmpl 
     * @param {Object} editor
     * @returns {String}
     */
  }, {
    key: "dateByTemplate",
    value:
    /**
     * Получить дату по шаблону
     * @param {Date} date 
     * @param {String} tmpl 
     * @returns {String}
     */
    function dateByTemplate(date, tmpl) {
      return InputDate.dateByTemplate(date, tmpl, this.props.editor);
    }
  }, {
    key: "presetValue",
    value: function () {
      var _presetValue = inputDate_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var value;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                value = this.props.value;
                if (!(value && isNaN(parseInt(value)))) {
                  _context4.next = 6;
                  break;
                }
                if (!(value !== 'custom')) {
                  _context4.next = 5;
                  break;
                }
                _context4.next = 5;
                return timeout(0);
              case 5:
                this.setDate(value, false);
              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function presetValue() {
        return _presetValue.apply(this, arguments);
      }
      return presetValue;
    }()
  }, {
    key: "clearEmptyDate",
    value: function clearEmptyDate() {
      var value = this.props.value;
      if (!value || isNaN(parseInt(value))) {
        this.clearDate();
      }
    }
  }, {
    key: "clearDate",
    value: function clearDate() {
      var _this$props5 = this.props,
        mode = _this$props5.mode,
        reminders = _this$props5.reminders,
        anchorNode = _this$props5.anchorNode,
        dateId = _this$props5.dateId;
      var reminderManager = this.props.editor.plugins.reminderManager;
      if (Object.keys(reminders || {}).length) {
        if (mode === 'inline') {
          var blot = anchorNode.__blot.blot;
          reminderManager.deleteReminder(blot.getDateId(), {
            reminders: reminders
          });
        }
        if (mode === 'table' && dateId) {
          reminderManager.deleteReminder(dateId, {
            reminders: reminders
          });
        }
      }
      this.setDate(null, true);
      if (mode === 'inline') {
        this.close();
      }
    }
  }, {
    key: "setDate",
    value: function setDate(timestamp, focus) {
      if (timestamp === 'now') {
        this.changeOption('showTime', true);
      }
      var showTime = this.props.showTime;
      var _this$state3 = this.state,
        oneDay = _this$state3.oneDay,
        oneHour = _this$state3.oneHour,
        todayTime = _this$state3.todayTime,
        nowTime = _this$state3.nowTime,
        timeZoneSelected = _this$state3.timeZoneSelected;
      if (focus) {
        this.setFocus('date', 0);
      }
      var timestampFormat = timestamp;
      if (timestamp === 'custom') {
        timestamp = '';
      }
      if (timestamp) {
        if (isNaN(parseInt(timestamp))) {
          if (timestamp === 'now' || timestamp === 'today') {
            timestamp = todayTime;
          } else if (timestamp === 'tomorrow') {
            timestamp = todayTime + oneDay;
          } else if (timestamp === 'yesterday') {
            timestamp = todayTime - oneDay;
          }
        } else {
          var selectedDate = new Date(timestamp);
          var timeZoneShift = timeZoneSelected / oneHour - selectedDate.getTimezoneOffset() / 60;
          if (timeZoneShift) {
            timestamp += timeZoneShift * oneHour;
          }
        }
        if (showTime) {
          var parseTime = this.parseTime();
          if (timestampFormat === 'now' && parseTime.value === 0 && !parseTime.is12) {
            timestamp = nowTime;
          } else {
            timestamp += parseTime.value;
          }
        } else {
          //timestamp += 8 * oneHour
        }
      }
      this.writeValue(timestamp);
    }
  }, {
    key: "setTimeIfNecessary",
    value: function setTimeIfNecessary(addTime) {
      var value = this.props.value;
      var _this$state4 = this.state,
        oneDay = _this$state4.oneDay,
        timeZoneSelected = _this$state4.timeZoneSelected;
      if (!value) {
        return;
      }
      var curDate = this.newDate(value, {
        correctEmptyTimeZone: true
      });
      var curTimePieces = this.getPiecesFromTime(curDate.getTime() % oneDay);
      var nowDate = this.newDate(false, {
        correctEmptyTimeZone: true
      });

      // если value без времени просто текущая дата (1610470800000)
      // то к дате добавляем текущее время
      if (curTimePieces.zeroHours) {
        if (!parseInt(addTime)) {
          addTime = nowDate.getTime() % oneDay - timeZoneSelected;
        }
        this.setDate(value + addTime);
      }
    }
  }, {
    key: "writeValue",
    value: function writeValue(timestamp) {
      var setValue = this.props.setValue;
      setValue && setValue(timestamp);
    }
  }, {
    key: "setFieldsDate",
    value: function setFieldsDate(field) {
      var timeZoneSelected = this.state.timeZoneSelected;
      var vals = {};
      var dateValue = this.nodes.date.value;
      var now = this.newDate(false, {
        correctEmptyTimeZone: true
      });
      if (!dateValue) {
        vals.yyyy = now.getFullYear();
        vals.mm = now.getMonth();
        vals.dd = now.getDate();
      } else {
        var parsedDate = this.parseDate(dateValue);
        vals.yyyy = parseInt(parsedDate.yyyy) || now.getFullYear();
        vals.mm = (parseInt(parsedDate.mm) || 1) - 1;
        vals.dd = parseInt(parsedDate.dd) || 1;
      }
      var date = Date.UTC(vals.yyyy, vals.mm, vals.dd) + timeZoneSelected;
      this.setDate(date);
    }
  }, {
    key: "setAmPm",
    value: function setAmPm(mode) {
      var _this6 = this;
      this.setState(function (prevState) {
        var ampm = prevState.ampm;
        if (mode == "toggle") {
          mode = ampm == "am" ? "pm" : "am";
        }
        return {
          ampm: mode
        };
      }, function () {
        _this6.setFieldsDate();
        _this6.setFocus('time', 50);
      });
    }
  }, {
    key: "fillFields",
    value: function fillFields() {
      var _this7 = this;
      var _this$props6 = this.props,
        value = _this$props6.value,
        timeFormat = _this$props6.timeFormat;
      this.setState(function (prevState) {
        var oneDay = prevState.oneDay,
          timeZoneReal = prevState.timeZoneReal,
          timeZoneSelected = prevState.timeZoneSelected;
        var dateField = '';
        var timeField = '';
        var date = _this7.newDate(value, {
          correctEmptyTimeZone: true
        });
        var timePieces = _this7.getPiecesFromTime(date.getTime() % oneDay - (value ? _this7.timeShift : 0));
        timeField = timeFormat == 12 ? timePieces.h12 : timePieces.h24;
        date = _this7.newDate(value, {
          correctTimeZone: false
        });
        dateField = _this7.tmplDate({
          yyyy: date.getFullYear(),
          mm: InputDate.zero(1 + date.getMonth()),
          dd: InputDate.zero(date.getDate())
        });
        return {
          timeField: timeField,
          dateField: dateField,
          ampm: timePieces.ampm
        };
      });
    }

    /**
     * Получить объект даты (статический метод)
     * @param {Number} value 
     * @param {Object} props 
     * @param {Boolean} props.correctEmptyTimeZone
     * @param {Boolean} props.correctTimeZone
     * @param {Object} opt 
     * @param {Number} opt.timeZoneReal
     * @param {Number} opt.timeZoneSelected
     * @returns {Date}
     */
  }, {
    key: "newDate",
    value:
    /**
     * Получить объект даты
     * @param {Number} value 
     * @param {Object} props 
     * @param {Boolean} props.correctEmptyTimeZone
     * @param {Boolean} props.correctTimeZone
     * @returns {Date}
     */
    function newDate(value) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$state5 = this.state,
        timeZoneReal = _this$state5.timeZoneReal,
        timeZoneSelected = _this$state5.timeZoneSelected;
      return InputDate.newDate(value, props, {
        timeZoneReal: timeZoneReal,
        timeZoneSelected: timeZoneSelected
      });
    }
  }, {
    key: "timeShift",
    get: function get() {
      var _this$state6 = this.state,
        timeZoneReal = _this$state6.timeZoneReal,
        timeZoneSelected = _this$state6.timeZoneSelected;
      var timeShift = timeZoneReal - timeZoneSelected;
      return timeShift;
    }

    /**
     * Возвращает сдвиг часовой зоны
     * @param {Object} params 
     * @param {Number} params.timeZoneReal
     * @param {Number} params.timeZoneSelected
     * @returns 
     */
  }, {
    key: "getMask",
    value: function getMask(field) {
      var type = this.props.type;
      if (field === 'time') {
        return '12:00';
      } else if (field === 'date') {
        if (type && DATE_FORMATS[type] && DATE_FORMATS[type].indexOf(' ') === -1) {
          return DATE_FORMATS[type];
        } else {
          var date = new Date(1e10);
          var str = date.toLocaleDateString([], {
            year: 'numeric',
            day: '2-digit',
            month: '2-digit'
          });
          for (var key in DATE_FORMATS) {
            var tmpl = this.dateByTemplate(date, DATE_FORMATS[key]);
            if (tmpl === str) {
              return DATE_FORMATS[key];
            }
          }
          return DATE_FORMATS[Object.keys(DATE_FORMATS)[0]];
        }
      } else {
        return '';
      }
    }
  }, {
    key: "inputKeyDown",
    value: function inputKeyDown(field, event) {
      var mask = this.getMask(field);
      if (isEnter(event) || isTabKey(event)) {
        event.preventDefault();
        event.stopPropagation();
        this.setFieldsDate(field);
        this.nextField(field);
      } else if (isShiftTabKey(event)) {
        this.clearEmptyDate();
      } else if (isDeleteKey(event) || isBackspaceKey(event)) {
        // do nothing
      } else if (this.keysAllowed.indexOf(event.keyCode) !== -1) {
        this.touched = true;
        var input = this.nodes[field];
        if (input.value.length >= mask.length && input.selectionStart === input.selectionEnd) {
          event.preventDefault();
          event.stopPropagation();
        }
      } else if (this.keysControl.indexOf(event.keyCode) === -1) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }, {
    key: "inputKeyUp",
    value: function inputKeyUp(field, event) {
      if (isDeleteKey(event) || isBackspaceKey(event) || this.keysAllowed.indexOf(event.keyCode) !== -1) {
        // Format while typing
        //this.pendingApply(field)
      }
    }
  }, {
    key: "parseDate",
    value: function parseDate(value) {
      var valueArr = [];
      var resultArr = {};
      var mask = this.getMask('date');
      var maskArr = mask.split('/');
      if (value.indexOf('/') !== -1) {
        valueArr = value.split('/');
      } else {
        var start = 0;
        var clean = value.replace(/[^0-9]/g, '');
        var _iterator = inputDate_createForOfIteratorHelper(maskArr),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            var len = item.length;
            var val = clean.slice(start, start + len);
            valueArr.push(val);
            start += len;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      for (var i in maskArr) {
        var _item = maskArr[i];
        var _val = valueArr[i] || (_item == 'yyyy' ? 2000 : 1);
        var intVal = parseInt(_val);
        if (intVal) {
          if (_item == 'mm') {
            if (intVal > 12) {
              _val = '12';
            }
          } else if (_item == 'dd') {
            if (intVal > 31) {
              _val = '31';
            }
          } else if (_item == 'yyyy') {
            if (intVal < 30) {
              _val = '20' + InputDate.zero(intVal);
            } else if (intVal < 100) {
              _val = '19' + InputDate.zero(intVal);
            } else if (intVal < 1000) {
              _val = '1900';
            } else if (intVal > 9999) {
              _val = '9999';
            }
          }
        }
        resultArr[_item] = _val;
      }
      resultArr.result = this.tmplDate(resultArr);
      return resultArr;
    }
  }, {
    key: "tmplDate",
    value: function tmplDate(pices) {
      var result = String(this.getMask('date'));
      for (var key in pices) {
        var val = pices[key];
        result = result.replace(key, val);
      }
      result = result.replace(/(\/|\.)+$/g, '');
      return result;
    }
  }, {
    key: "parseTime",
    value: function parseTime(value) {
      var timeFormat = this.props.timeFormat;
      var ampm = this.state.ampm;
      var parts = [];
      if (!value) {
        if (this.nodes && this.nodes.time && this.nodes.time.value) {
          value = this.nodes.time.value;
        } else {
          value = 0;
        }
      }
      if (String(value).indexOf(':') !== -1) {
        parts = String(value).split(':');
      } else {
        var clean = String(value).replace(/[^0-9]/g, '');
        if (clean.length >= 4) {
          parts[0] = clean.slice(0, 2);
          parts[1] = clean.slice(2, 4);
        } else {
          parts[0] = clean.slice(0, 2);
          if (parseInt(parts[0]) > 23) {
            parts[0] = clean.slice(0, 1);
            parts[1] = clean.slice(1, 3);
          } else {
            parts[1] = clean.slice(2, 3);
          }
        }
      }
      if (!parts[0] || isNaN(parseInt(parts[0]))) {
        parts[0] = 0;
      } else if (parseInt(parts[0]) > 24) {
        parts[0] = 24;
      }
      if (!parts[1] || isNaN(parseInt(parts[1]))) {
        parts[1] = 0;
      } else if (parseInt(parts[1]) > 59) {
        parts[1] = 59;
      }
      var str = "".concat(parts[0], ":").concat(parts[1]);
      if (timeFormat === 12 && parts[0] <= 12) {
        str += ' ' + ampm.toUpperCase();
      }
      if (value === 0 && timeFormat === 12) {
        var currentTime = new Date().toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        });
        str = currentTime;
        var _parts = currentTime.split(' ');
        parts = _parts[0].split(':');
      }
      var resultArr = {
        str: str,
        hours: InputDate.zero(parts[0]),
        mins: InputDate.zero(parts[1]),
        value: this.getTimeFromString(str),
        is12: timeFormat === 12
      };
      var pieces = this.getPiecesFromTime(resultArr.value);
      resultArr = inputDate_objectSpread(inputDate_objectSpread({}, resultArr), pieces);
      return resultArr;
    }
  }, {
    key: "getTimeFromString",
    value: function getTimeFromString(str) {
      var oneDay = this.state.oneDay;
      if (inputDate_typeof(str) == "object") {
        str = (str[0] || 0) + ':' + (str[1] || 0);
      }
      var date = '2000/01/01';
      var start = new Date(date);
      var datetime = new Date("".concat(date, " ").concat(str));
      var time = datetime - start;
      if (isNaN(time) || time < 0) {
        time = 0;
      } else if (time >= oneDay) {
        time = oneDay - 1;
      }
      return time;
    }

    /**
     * Разбить время на составляющие (статический метод)
     * @param {Number} time 
     * @param {Object} params 
     * @param {Number} params.timeZoneSelected
     * @returns - {ampm: string, h12full: string, h12: string[], h24: string[], zeroHours: boolean}
     */
  }, {
    key: "getPiecesFromTime",
    value:
    /**
     * Разбить время на составляющие
     * @param {Number} time
     * @returns - {ampm: string, h12full: string, h12: string[], h24: string[], zeroHours: boolean}
     */
    function getPiecesFromTime(time) {
      var timeZoneSelected = this.state.timeZoneSelected;
      return InputDate.getPiecesFromTime(time, {
        timeZoneSelected: timeZoneSelected
      });
    }

    /**
     * Проверяет есть ли установленные ремайндеры со временем и если есть показывает диалог для подтверждения их удаления
     * @returns {Promise<void>}
     */
  }, {
    key: "processToDeleteReminders",
    value: function () {
      var _processToDeleteReminders = inputDate_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this8 = this;
        var withTime, _this$props7, reminders, editor, _editor$plugins, i18n, popupManager, id, seconds, confirm;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                withTime = [];
                _this$props7 = this.props, reminders = _this$props7.reminders, editor = _this$props7.editor;
                _editor$plugins = editor.plugins, i18n = _editor$plugins.i18n, popupManager = _editor$plugins.popupManager;
                for (id in reminders) {
                  seconds = reminders[id].seconds;
                  if (seconds > 0 && seconds < 86400) {
                    withTime.push(id);
                  }
                }
                if (!withTime.length) {
                  _context5.next = 9;
                  break;
                }
                _context5.next = 7;
                return new Promise(function (resolve) {
                  var onCancel = function onCancel() {
                    resolve(true);
                  };
                  var onConfirm = function onConfirm() {
                    _this8.props.removeReminders(withTime);
                    resolve(false);
                  };
                  confirm = (0,preact_module.h)(confirmPopup/* default */.Z, {
                    onCancel: onCancel,
                    onConfirm: onConfirm,
                    title: i18n.get('calendar.ui.reminder.push_name'),
                    message: i18n.get('calendar.ui.reminder.remove_confirm_message'),
                    confirmText: i18n.get('calendar.ui.reminder.remove_confirm_text'),
                    cancelText: i18n.get('calendar.ui.reminder.remove_cancel_text'),
                    editor: editor
                  });
                  popupManager.dialog(confirm);
                });
              case 7:
                confirm = null;
                popupManager.dialog(null);
              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
      function processToDeleteReminders() {
        return _processToDeleteReminders.apply(this, arguments);
      }
      return processToDeleteReminders;
    }()
  }, {
    key: "changeOption",
    value: function () {
      var _changeOption = inputDate_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(option, value) {
        var params,
          onChangeOption,
          updated,
          _args6 = arguments;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                params = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                onChangeOption = this.props.onChangeOption;
                if (!(option === 'showTime')) {
                  _context6.next = 9;
                  break;
                }
                if (!value) {
                  _context6.next = 7;
                  break;
                }
                this.setTimeIfNecessary();
                _context6.next = 9;
                break;
              case 7:
                _context6.next = 9;
                return this.processToDeleteReminders();
              case 9:
                if (onChangeOption) {
                  updated = {};
                  updated[option] = value;
                  onChangeOption(updated);
                }
                if (option == 'showTime' && !params.noFocus) {
                  this.setFocus(value ? 'time' : 'date', 10);
                }
              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
      function changeOption(_x4, _x5) {
        return _changeOption.apply(this, arguments);
      }
      return changeOption;
    }()
  }, {
    key: "onReminderRef",
    value: function onReminderRef(reminderId, node) {
      if (node) {
        this.reminderNodes[reminderId] = node;
      }
    }
  }, {
    key: "onChangeReminder",
    value: function onChangeReminder(reminderId, value, text) {
      var _this$props8 = this.props,
        _this$props8$reminder = _this$props8.reminders,
        reminders = _this$props8$reminder === void 0 ? {} : _this$props8$reminder,
        setReminder = _this$props8.setReminder,
        showTime = _this$props8.showTime;
      var oneHour = this.state.oneHour;
      if (reminderId === this.newReminderId) {
        this.newReminderId = null;
      }
      if (value === 'custom') {
        if (!text) {
          if (reminders[reminderId] && reminders[reminderId].text) {
            text = reminders[reminderId].text;
          } else {
            text = showTime ? '6h' : '1d';
          }
        }
      } else {
        text = value;
      }
      var seconds = strToSeconds(text);
      setReminder && setReminder(reminderId, {
        value: value,
        text: text,
        seconds: seconds
      });
      if (value !== 'none') {
        // this.setTimeIfNecessary(10 * oneHour)
        // this.changeOption('showTime', true, {noFocus: true})
      }
    }
  }, {
    key: "onReminderMenuButtonClick",
    value: function () {
      var _onReminderMenuButtonClick = inputDate_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(reminderId) {
        var value, reminderMenus, open;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                value = this.props.value;
                reminderMenus = this.state.reminderMenus;
                if (!value) {
                  this.setDate('today', false);
                }
                open = reminderMenus[reminderId] ? false : true;
                this.closeReminderMenu();
                if (!open) {
                  _context7.next = 10;
                  break;
                }
                _context7.next = 8;
                return timeout(50);
              case 8:
                reminderMenus[reminderId] = open;
                this.setState(function () {
                  return {
                    reminderMenus: reminderMenus
                  };
                });
              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
      function onReminderMenuButtonClick(_x6) {
        return _onReminderMenuButtonClick.apply(this, arguments);
      }
      return onReminderMenuButtonClick;
    }()
  }, {
    key: "closeReminderMenu",
    value: function closeReminderMenu() {
      var _this9 = this;
      this.setState(function (prevState) {
        var reminderMenus = prevState.reminderMenus;
        for (var id in reminderMenus) {
          reminderMenus[id] = false;
        }
        _this9.setFocus('last', 0);
        return {
          reminderMenus: reminderMenus
        };
      });
    }
  }, {
    key: "newReminder",
    get: function get() {
      if (!this.newReminderId) {
        this.newReminderId = generateId();
      }
      return this.newReminderId;
    }
  }, {
    key: "reminderText",
    value: function reminderText(reminder) {
      var editor = this.props.editor;
      var i18n = editor.plugins.i18n;
      var text;
      if (reminder) {
        if (reminder.value !== 'custom') {
          text = i18n.get("calendar.ui.reminder.value.".concat(String(reminder.value)));
        } else {
          var txtBefore = i18n.get('calendar.ui.reminder.before_period');
          var txtAfter = i18n.get('calendar.ui.reminder.after_period');
          var reminderText = reminder.text || '';
          var period = reminderText.replace(/\d+/, '');
          var intVal = parseInt(reminderText) || 0;
          text = '';
          if (txtBefore) {
            text += txtBefore + ' ';
          }
          text += String(intVal);
          text += ' ' + i18n.get("calendar.ui.reminder.period.".concat(period), null, intVal);
          if (txtAfter) {
            text += ' ' + txtAfter;
          }
        }
      } else {
        text = i18n.get('calendar.ui.reminder.value.none');
      }
      return text;
    }
  }, {
    key: "reminderInfo",
    value: function reminderInfo(reminder) {
      var _this$props9 = this.props,
        value = _this$props9.value,
        reminderTimeToString = _this$props9.reminderTimeToString;
      if (!reminder) {
        return '';
      }
      var now = Date.now();
      var reminderTime = value - 1e3 * reminder.seconds;
      var timeString = this.dateString({
        value: reminderTime,
        showTime: true
      });
      var seconds = (reminderTime - now) / 1e3;
      var untilReminder = reminderTimeToString(seconds);
      var result = untilReminder + ' / ' + timeString;
      return result;
    }
  }, {
    key: "handlePanel",
    value: function handlePanel(state) {
      var _this10 = this;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!state) {
        clearTimeout(this.panelDelay);
        this.setState(function () {
          return {
            showPanel: false
          };
        });
      } else {
        this.panelDelay = setTimeout(function () {
          _this10.setState(function () {
            return {
              showPanel: true
            };
          });
        }, params.delay || 0);
      }
    }
  }, {
    key: "dateStringComponent",
    value: function dateStringComponent() {
      var _this11 = this;
      var _this$props10 = this.props,
        editor = _this$props10.editor,
        _this$props10$reminde = _this$props10.reminders,
        reminders = _this$props10$reminde === void 0 ? {} : _this$props10$reminde,
        enableReminders = _this$props10.enableReminders;
      var showPanel = this.state.showPanel;
      var i18n = editor.plugins.i18n;
      var reminderIcon, reminderPanel;
      var reminderIds = Object.keys(reminders);
      if (enableReminders && reminderIds.length) {
        reminderIcon = (0,preact_module.h)("span", {
          className: "input-date-bell",
          onMouseEnter: this.handlePanel.bind(this, true, {
            delay: 1e3
          }),
          onMouseLeave: this.handlePanel.bind(this, false)
        }, (0,preact_module.h)(icons/* IconBell */.YK1, null));
        if (showPanel) {
          var reminderItems = reminderIds.map(function (reminderId, n) {
            var reminder = reminders[reminderId] || null;
            if (!reminder) {
              return '';
            }
            var name = i18n.get('calendar.ui.reminder.panel_name');
            if (n > 0) {
              name += " ".concat(n + 1);
            }
            var text = _this11.reminderInfo(reminder);
            return (0,preact_module.h)("span", {
              className: "reminder-item"
            }, (0,preact_module.h)(icons/* IconBell */.YK1, null), (0,preact_module.h)("span", null, name, ": ", text));
          });
          reminderPanel = (0,preact_module.h)(popupMenu/* default */.Z, {
            key: "reminder-panel",
            closeOnEsc: true,
            addClassName: "reminder-panel",
            anchorNode: this.stringNode,
            anchorOptions: {
              placement: 'top-start',
              priority: ['top'],
              positionFixed: true,
              boundariesElement: editor.getScrollingContainer()
            }
          }, (0,preact_module.h)("span", {
            className: "reminder-container"
          }, reminderItems));
        }
      }
      return (0,preact_module.h)("span", {
        className: "input-date-string",
        ref: this.onStringRef.bind(this)
      }, (0,preact_module.h)("span", {
        className: "input-date-text"
      }, this.dateString()), reminderIcon, reminderPanel);
    }
  }, {
    key: "render",
    value: function render() {
      var _this12 = this;
      var _this$props11 = this.props,
        mode = _this$props11.mode,
        editor = _this$props11.editor,
        active = _this$props11.active,
        value = _this$props11.value,
        _this$props11$reminde = _this$props11.reminders,
        reminders = _this$props11$reminde === void 0 ? {} : _this$props11$reminde,
        showTime = _this$props11.showTime,
        timeFormat = _this$props11.timeFormat,
        enableReminders = _this$props11.enableReminders;
      var _this$state7 = this.state,
        oneDay = _this$state7.oneDay,
        firstWeekDay = _this$state7.firstWeekDay,
        timeZoneReal = _this$state7.timeZoneReal,
        timeZoneSelected = _this$state7.timeZoneSelected,
        reminderMenus = _this$state7.reminderMenus,
        showPanel = _this$state7.showPanel,
        todayTime = _this$state7.todayTime;
      var i18n = editor.plugins.i18n;
      var str;
      var calendar = '';
      var reminderIds = Object.keys(reminders);
      if (active && this.state.firstGridDay) {
        //const start = this.state.firstGridDay.getTime()
        //const stop = this.state.lastGridDay.getTime()

        var week = Array.apply(null, {
          length: 7
        }).map(function (i, day) {
          var weekDay = day + firstWeekDay;
          if (weekDay == 7) weekDay = 0;
          return (0,preact_module.h)("span", {
            className: "grid-item grid-week-day"
          }, i18n.get('calendar.days.short.' + weekDay));
        });

        //let currentTimezoneOffset = new Date().getTimezoneOffset()
        var grid = Array.apply(null, {
          length: this.state.gridDays
        }).map(function (i, day) {
          //let itemDate = new Date(day * oneDay + start)
          var itemDate = new Date(_this12.state.firstGridDay.getFullYear(), _this12.state.firstGridDay.getMonth(), _this12.state.firstGridDay.getDate() + day);
          /*
          let itemZoneShift = 60e3 * (itemDate.getTimezoneOffset() - currentTimezoneOffset)
          if (itemZoneShift) {
            itemDate = new Date(day * oneDay + start + itemZoneShift)
          }
          */
          var itemDateTime = itemDate.getTime() - _this12.timeShift;
          var selectedItem = false;
          var className = "grid-item grid-day";
          if (itemDateTime < _this12.state.firstMonthDayTime || (itemDateTime - _this12.state.lastMonthDayTime) / 36e5 >= 24) {
            className += " other-month-day";
          }
          if (itemDateTime == _this12.state.todayTime) {
            className += " today";
          }
          if (value && itemDateTime <= value && oneDay + itemDateTime > value) {
            className += " selected";
            selectedItem = true;
          }
          var dateText = itemDate.getDate();
          return (0,preact_module.h)("span", {
            className: className,
            onClick: selectedItem ? _this12.close.bind(_this12) : _this12.setDate.bind(_this12, itemDateTime, true)
          }, dateText);
        });
        var headerLines = [];
        var footerLines = [];
        var ampmBlock = '';
        var timeBlock = (0,preact_module.h)("input", {
          type: "text",
          ref: this.onInputRef.bind(this, 'time'),
          className: "calendar-input calendar-input-time",
          onBlur: this.onBlur.bind(this, 'time'),
          onMouseDown: this.onInputTouch.bind(this, 'time'),
          onKeyUp: this.inputKeyUp.bind(this, 'time'),
          onKeyDown: this.inputKeyDown.bind(this, 'time'),
          placeholder: this.getMask('time'),
          value: this.state.timeField
          // для предотвращения ошибки, когда фокус на input-е и выключили отображение времени
          ,
          style: {
            display: showTime ? 'inline-block' : 'none'
          }
        });
        if (showTime && timeFormat == '12') {
          ampmBlock = (0,preact_module.h)("span", {
            className: "ampm-container"
          }, (0,preact_module.h)("span", {
            className: "ampm-toggle",
            onClick: this.setAmPm.bind(this, 'toggle')
          }, i18n.get("calendar.ui.".concat(this.state.ampm))));
        }
        footerLines.push((0,preact_module.h)("div", {
          className: "calendar-footer-line"
        }, (0,preact_module.h)("span", {
          className: "footer-left bold"
        }, i18n.get('calendar.ui.date')), (0,preact_module.h)("span", {
          className: "footer-main align-right"
        }, (0,preact_module.h)("input", {
          type: "text",
          ref: this.onInputRef.bind(this, 'date'),
          className: "calendar-input calendar-input-date",
          onBlur: this.onBlur.bind(this, 'date'),
          onMouseDown: this.onInputTouch.bind(this, 'date'),
          onKeyUp: this.inputKeyUp.bind(this, 'date'),
          onKeyDown: this.inputKeyDown.bind(this, 'date'),
          placeholder: this.getMask('date'),
          value: this.state.dateField
        }), timeBlock, ampmBlock, (0,preact_module.h)("input", {
          type: "text",
          className: "input-hidden",
          ref: this.onInputRef.bind(this, 'hidden')
        }))));
        var reminderContainer, reminderItems;
        var now = Date.now();
        var reminderShift = (value - now) / 1e3;
        if (enableReminders) {
          var showNextReminder = true;
          if (reminderIds.length < this.remindersLimit) {
            reminderIds.push(this.newReminder);
          }
          reminderItems = reminderIds.map(function (reminderId, n) {
            var reminder = reminders[reminderId] || null;
            if (!showNextReminder && !reminder) {
              return '';
            } else if (reminder) {
              showNextReminder = true;
            } else {
              showNextReminder = false;
            }
            var menu;
            var name = i18n.get('calendar.ui.reminder.name');
            if (n > 0) {
              name += " ".concat(n + 1);
            }
            var text = _this12.reminderText(reminder);
            var className = "option-reminder-name";
            if (!reminder) {
              className += ' grey';
            }
            if (reminderMenus[reminderId]) {
              menu = (0,preact_module.h)(InputDateMenuReminder, {
                editor: editor,
                reminder: reminder,
                value: value,
                shift: reminderShift,
                showTime: showTime,
                todayTime: todayTime,
                anchorNode: _this12.reminderNodes[reminderId],
                anchorOptions: {
                  priority: ['bottom'],
                  offset: '5px, 17px',
                  placement: 'right-end',
                  boundariesElement: editor.getScrollingContainer()
                },
                onChange: _this12.onChangeReminder.bind(_this12, reminderId),
                wantsToClose: _this12.closeReminderMenu.bind(_this12, reminderId),
                remindItemDependOnTime: false
              });
            }
            return (0,preact_module.h)("div", {
              className: "footer-option"
            }, (0,preact_module.h)("div", {
              className: "option-left"
            }, name), (0,preact_module.h)("div", {
              className: "option-right pointer",
              onClick: _this12.onReminderMenuButtonClick.bind(_this12, reminderId)
            }, (0,preact_module.h)("span", {
              className: "option-reminder"
            }, (0,preact_module.h)("span", {
              className: className,
              ref: _this12.onReminderRef.bind(_this12, reminderId)
            }, text)), (0,preact_module.h)(icons/* IconArrowDown */.BDo, null), menu));
          });
          reminderContainer = (0,preact_module.h)("div", {
            className: "footer-scroll"
          }, reminderItems);
        }
        calendar = (0,preact_module.h)("div", {
          className: "calendar-container"
        }, headerLines.length ? (0,preact_module.h)("div", {
          className: "calendar-header"
        }, headerLines) : '', (0,preact_module.h)("div", {
          className: "calendar-body"
        }, (0,preact_module.h)("div", {
          className: "month-header"
        }, (0,preact_module.h)("span", {
          className: "arrow arrow-left",
          onMouseDown: this.setGrid.bind(this, 'left')
        }, (0,preact_module.h)(icons/* IconArrowLeft */.D6v, null)), (0,preact_module.h)("span", {
          className: "month-text"
        }, i18n.get('calendar.months.' + this.state.firstMonthDay.getMonth()), " ", this.state.firstMonthDay.getFullYear()), (0,preact_module.h)("span", {
          className: "arrow arrow-right",
          onMouseDown: this.setGrid.bind(this, 'right')
        }, (0,preact_module.h)(icons/* IconArrowRight */.Ec8, null))), (0,preact_module.h)("div", {
          className: "weeks-grid"
        }, (0,preact_module.h)("div", {
          className: "grid-seven grid-week"
        }, week), (0,preact_module.h)("div", {
          className: "grid-seven grid-days"
        }, grid))), (0,preact_module.h)("div", {
          className: "calendar-footer"
        }, footerLines, (0,preact_module.h)("div", {
          className: "footer-options"
        }, (0,preact_module.h)("div", {
          className: "footer-option"
        }, (0,preact_module.h)("div", {
          className: "option-left"
        }, i18n.get('calendar.ui.show_time')), (0,preact_module.h)("div", {
          className: "option-right"
        }, (0,preact_module.h)(Toggle, {
          mode: mode,
          status: showTime,
          listenUpdates: true,
          onChange: this.changeOption.bind(this, 'showTime')
        }))), reminderContainer, (0,preact_module.h)("div", {
          className: "footer-option"
        }, (0,preact_module.h)("div", {
          className: "option-left"
        }, (0,preact_module.h)("span", {
          className: "footer-button",
          onClick: this.clearDate.bind(this)
        }, i18n.get("calendar.ui.".concat(mode, ".clear"))))))));
      }
      var content;
      if (active) {
        content = calendar;
      } else {
        content = this.dateStringComponent();
      }
      return (0,preact_module.h)("span", {
        ref: this.wrap,
        onMouseUp: this.onWrapMouseUp.bind(this),
        onMouseDown: this.onWrapMouseDown.bind(this),
        className: 'input-date ' + (active ? 'input-date-active ' : '') + (this.props.addClassName ? this.props.addClassName : '')
      }, content);
    }
  }], [{
    key: "getTimeZoneSelected",
    value: function getTimeZoneSelected(editor) {
      var timeZoneSelected = -1;
      if (editor && editor.blotsConfig.date && editor.blotsConfig.date.hasOwnProperty('timezone')) {
        timeZoneSelected = 60e3 * editor.blotsConfig.date.timezone;
      }
      return timeZoneSelected;
    }
  }, {
    key: "getTimeZone",
    value: function getTimeZone(params) {
      var timeZoneSelected = params.timeZoneSelected,
        timeZoneReal = params.timeZoneReal,
        _params$timeZoneGMT = params.timeZoneGMT,
        timeZoneGMT = _params$timeZoneGMT === void 0 ? false : _params$timeZoneGMT;
      var newTimeZone = timeZoneSelected !== -1 ? timeZoneSelected : timeZoneReal;
      if (timeZoneGMT) {
        newTimeZone = 0;
      }
      return newTimeZone;
    }
  }, {
    key: "zero",
    value: function zero(num) {
      var str = '0' + String(num);
      str = str.slice(-2);
      return str;
    }
  }, {
    key: "dateString",
    value: function dateString(props) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var editor = props.editor,
        value = props.value,
        showTime = props.showTime,
        timeFormat = props.timeFormat,
        dateFormat = props.dateFormat;
      var oneDay = params.oneDay,
        timeZoneReal = params.timeZoneReal,
        timeZoneSelected = params.timeZoneSelected,
        timeShift = params.timeShift;
      var str = '';
      var timestamp = params.value || value;
      if (timestamp && !isNaN(timestamp)) {
        var datetime = InputDate.newDate(timestamp, {
          correctTimeZone: true
        }, {
          timeZoneReal: timeZoneReal,
          timeZoneSelected: timeZoneSelected
        });
        if (dateFormat && DATE_FORMATS[dateFormat]) {
          var tmpl = String(DATE_FORMATS[dateFormat]);
          str = InputDate.dateByTemplate(datetime, tmpl, editor);
        } else {
          str = datetime.toLocaleDateString();
        }
        if (showTime || params.showTime) {
          var time = datetime.getTime() % oneDay - timeShift;
          var pieces = InputDate.getPiecesFromTime(time, {
            timeZoneSelected: timeZoneSelected
          });
          if (timeFormat == 12) {
            str += ' ' + pieces.h12full;
          } else {
            str += ' ' + pieces.h24;
          }
        }
      }
      return str;
    }
  }, {
    key: "dateByTemplate",
    value: function dateByTemplate(date, tmpl, editor) {
      var i18n = editor.plugins.i18n;
      var str = String(tmpl);
      if (str.indexOf('month') !== -1) {
        str = str.replace('month', i18n.get('calendar.months.' + date.getMonth()));
      } else {
        str = str.replace('mm', InputDate.zero(date.getMonth() + 1));
      }
      str = str.replace('yyyy', date.getFullYear());
      str = str.replace('dd', InputDate.zero(date.getDate()));
      return str;
    }
  }, {
    key: "newDate",
    value: function newDate(value) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var opt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var timeZoneReal = opt.timeZoneReal,
        timeZoneSelected = opt.timeZoneSelected;
      if (!value) {
        var shift;
        if (props.correctEmptyTimeZone) {
          shift = InputDate.getTimeShift({
            timeZoneReal: timeZoneReal,
            timeZoneSelected: timeZoneSelected
          });
        } else {
          shift = timeZoneSelected;
        }
        value = Date.now() - shift;
      } else {
        if (props.correctTimeZone) {
          value += InputDate.getTimeShift({
            timeZoneReal: timeZoneReal,
            timeZoneSelected: timeZoneSelected
          });
        }
      }
      return new Date(value);
    }
  }, {
    key: "getTimeShift",
    value: function getTimeShift(params) {
      var _params$timeZoneReal = params.timeZoneReal,
        timeZoneReal = _params$timeZoneReal === void 0 ? 60e3 * new Date().getTimezoneOffset() : _params$timeZoneReal,
        _params$timeZoneSelec = params.timeZoneSelected,
        timeZoneSelected = _params$timeZoneSelec === void 0 ? -1 : _params$timeZoneSelec;
      return timeZoneReal - timeZoneSelected;
    }
  }, {
    key: "getPiecesFromTime",
    value: function getPiecesFromTime(time, params) {
      var timeZoneSelected = params.timeZoneSelected;
      var start = new Date('2000/01/01').getTime();
      var timeFull = start + (parseInt(time) || 0);
      if (timeZoneSelected) {
        timeFull -= timeZoneSelected;
      }
      var str = new Date(timeFull).toLocaleTimeString('en-US', {
        hour12: true
      }); // переводим в американский формат, так как ниже код написан именно под него
      var h24full = new Date(timeFull).toLocaleTimeString('en-US', {
        hour12: false
      }); // переводим в американский формат, так как ниже код написан именно под него
      var arr = str.split(' '); // в 110 хроме во времени изменился символ пробела
      if (arr.length === 1) {
        arr = str.split(' ');
      }
      var ampm = arr.pop();
      var h12;
      var h24;
      var zeroHours = true; // по умолчанию текущий timestamp без времени (1610470800000)

      h12 = arr[0].split(':');
      h12.pop();
      h12 = h12.join(':');
      h24 = h24full.split(':');
      h24.pop();
      h24 = h24.join(':');
      if (h24 !== '00:00' && h24 !== '24:00') {
        zeroHours = false;
      }

      /*
      let currTimeField = (new Date()).toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'}).split(' ')
      if ( (h12 === '12:00' || h12 === '3:00') && currTimeField[1]) {
        h12 = currTimeField[0]
        ampm = currTimeField[1]
      }
      */

      h12 = h12.split(':');
      if (!parseInt(h12[0])) {
        h12[0] = '12';
      } else if (h12[0].startsWith('0')) {
        h12[0] = h12[0].substring(1);
      }
      h12 = h12.join(':');
      var result = {
        ampm: ampm.toLowerCase(),
        h12full: h12 + ' ' + ampm,
        h12: h12,
        h24: h24,
        zeroHours: zeroHours
      };
      return result;
    }
  }]);
  return InputDate;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/tableConfigTypes.js
function tableConfigTypes_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = tableConfigTypes_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function tableConfigTypes_toConsumableArray(arr) { return tableConfigTypes_arrayWithoutHoles(arr) || tableConfigTypes_iterableToArray(arr) || tableConfigTypes_unsupportedIterableToArray(arr) || tableConfigTypes_nonIterableSpread(); }
function tableConfigTypes_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tableConfigTypes_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tableConfigTypes_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tableConfigTypes_arrayLikeToArray(o, minLen); }
function tableConfigTypes_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function tableConfigTypes_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return tableConfigTypes_arrayLikeToArray(arr); }
function tableConfigTypes_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function tableConfigTypes_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { tableConfigTypes_typeof = function _typeof(obj) { return typeof obj; }; } else { tableConfigTypes_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return tableConfigTypes_typeof(obj); }























function tableConfigTypes_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function tableConfigTypes_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { tableConfigTypes_ownKeys(Object(source), true).forEach(function (key) { tableConfigTypes_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { tableConfigTypes_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function tableConfigTypes_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/**
 * Конфигурация и обработчики связанные с типами ячеек
 * Включая обработку копируемых, вставляемых и сортируемых данных по каждому типу
 */








function sumObj(arr) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return arr.reduce(function (acc, mode) {
    acc[mode] = tableConfigTypes_objectSpread({
      mode: mode
    }, params);
    return acc;
  }, {});
}
var every = sumObj(['none']);
var SUMMARIES = {
  common: Object.assign({}, every, sumObj(['all', 'empty', 'fill', 'unique', 'empty_percent', 'fill_percent', 'unique_percent'])),
  checkbox: Object.assign({}, every, sumObj(['all', 'checked', 'unchecked', 'checked_percent', 'unchecked_percent'])),
  number: Object.assign({}, every, sumObj(['sum', 'average', 'min', 'max', 'median'])),
  date: Object.assign({}, every, sumObj(['min_date', 'max_date', 'range_days', 'range_month'])),
  collaborator: Object.assign({}, every, sumObj(['all', 'empty', 'fill', 'unique'])),
  rating: Object.assign({}, every, sumObj(['min', 'max', 'average']), sumObj(['filter_rating'], {
    filter: '5',
    max: 10
  })),
  progress: Object.assign({}, every, sumObj(['min', 'max', 'average']), sumObj(['filter_progress'], {
    filter: '>50',
    max: 100
  })),
  attachment: Object.assign({}, every, sumObj(['all', 'empty', 'fill', 'filesize_min', 'filesize_max']))
};
var FILTER_CONDITIONS = {
  text: ['contains', 'is', 'is not', 'contains not', 'empty', 'not empty'],
  number: ['=', '≠', '>', '<', '≥', '≤', 'empty', 'not empty'],
  currency: ['=', '≠', '>', '<', '≥', '≤', 'empty', 'not empty'],
  attachment: ['filetype', 'empty', 'not empty'],
  checkbox: ['is'],
  singleselect: ['has any of', 'has none of', 'empty', 'not empty'],
  multiselect: ['has any of', 'has none of', 'empty', 'not empty'],
  mention: ['contains', 'is', 'is not', 'contains not', 'empty', 'not empty'],
  collaborator: ['has any of', 'has none of', 'empty', 'not empty'],
  date: ['is'],
  link: ['contains', 'is', 'is not', 'contains not', 'empty', 'not empty'],
  rating: ['=', '≠', '>', '<', '≥', '≤'],
  progress: ['=', '≠', '>', '<', '≥', '≤']
};
var CURRENCY = {
  dollar: '$',
  euro: '€',
  yen: '¥',
  yuan: '¥',
  rouble: '₽',
  pound: '£',
  rupee: '₹',
  hryvnia: '₴',
  won: '₩',
  frank: 'fr',
  real: 'R$'
};
var typeNames = {
  tableCellText: 'text',
  tableCellNumber: 'number',
  tableCellCurrency: 'currency',
  tableCellAttachment: 'attachment',
  tableCellCheckbox: 'checkbox',
  tableCellSelect: 'singleselect',
  //tableCellSelect: 'multiselect',
  tableCellMention: 'mention',
  tableCellCollaborator: 'collaborator',
  tableCellDate: 'date',
  tableCellLink: 'link',
  tableCellRating: 'rating',
  tableCellProgress: 'progress'
};
var defaultType = 'text';
var getLabelsText = function getLabelsText() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cellMap = options.cellMap,
    colMap = options.colMap;
  var value = [];
  var selected = cellMap === null || cellMap === void 0 ? void 0 : cellMap.get('selected');
  if (selected) {
    var _colMap$get;
    if (typeof selected === 'string' && selected[0] === '[') {
      selected = JSON.parse(selected);
    }
    var dbSelect = colMap === null || colMap === void 0 ? void 0 : (_colMap$get = colMap.get) === null || _colMap$get === void 0 ? void 0 : _colMap$get.call(colMap, 'dbSelect');
    if (typeof selected === 'string' && selected[0] === '{') {
      dbSelect = JSON.parse(dbSelect);
    }
    if (tableConfigTypes_typeof(dbSelect) === 'object' && tableConfigTypes_typeof(selected) === 'object') {
      for (var key in selected) {
        var _dbSelect$id;
        var id = selected[key];
        value.push((_dbSelect$id = dbSelect[id]) === null || _dbSelect$id === void 0 ? void 0 : _dbSelect$id.name);
      }
    }
  }
  return value.join(', ');
};
var getMentionData = function getMentionData() {
  var _childMap$get, _delta$;
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var childMap = options.childMap,
    _options$timestamp = options.timestamp,
    timestamp = _options$timestamp === void 0 ? false : _options$timestamp,
    _options$withType = options.withType,
    withType = _options$withType === void 0 ? false : _options$withType;
  var result = {};
  var delta = childMap === null || childMap === void 0 ? void 0 : (_childMap$get = childMap.get('characters')) === null || _childMap$get === void 0 ? void 0 : _childMap$get.toDelta();
  var insert = delta === null || delta === void 0 ? void 0 : (_delta$ = delta[0]) === null || _delta$ === void 0 ? void 0 : _delta$.insert;
  if (tableConfigTypes_typeof(insert) === 'object') {
    result.mention = insert.date;
    if (insert.date) {
      if (timestamp) {
        result.text = insert.date.value;
      }
      for (var key in insert.date) {
        result["data-date-".concat(key)] = insert.date[key];
      }
    } else if (insert.mention) {
      result.mention = insert.mention;
      result.text = insert.mention.name;
      if (withType) {
        result.text = insert.mention.type + ' ' + result.text;
      }
      for (var _key in insert.mention) {
        result["data-mention-".concat(_key)] = insert.mention[_key];
      }
    }
  }
  return result;
};
var CELL_TYPES = {
  none: {
    summaries: SUMMARIES.common
  },
  text: {
    typeOrder: 3,
    icon: icons/* IconTypeText */.JpT,
    value: {
      key: 'characters'
    },
    summaries: SUMMARIES.common,
    type: 'tableCellText',
    props: {
      children: 'children',
      align: 'string'
    },
    filterConditions: FILTER_CONDITIONS.text
  },
  number: {
    typeOrder: 1,
    icon: icons/* IconTypeNumber */.uJ$,
    type: 'tableCellNumber',
    value: {
      key: 'characters'
    },
    summaries: SUMMARIES.number,
    format: {
      type: 'number',
      decimal_separator: 'point'
    },
    limit: {
      minWidth: 120
    },
    style: {
      align: 'right'
    },
    submenu: [{
      type: 'header',
      i18n: 'table.menu.number_format.name'
    }, {
      type: 'radio',
      prop: 'type',
      selectedIcon: true,
      values: ['number', 'commas', 'percent'],
      i18n: 'table.menu.number_format.${value}',
      rightText: function rightText(value, selected) {
        return value === 'commas' ? '1,000' : value === 'percent' ? '100%' : '100';
      }
    }, {
      type: 'header',
      i18n: 'table.menu.decimal_format.name',
      hint: 'table.menu.decimal_format.hint'
    }, {
      type: 'radio',
      prop: 'decimal_separator',
      selectedIcon: true,
      values: ['point', 'comma'],
      i18n: 'table.menu.decimal_format.${value}'
    }, {
      type: 'header',
      i18n: 'table.menu.color_numbers.name'
    }, {
      type: 'checkbox',
      prop: 'colorNumbers',
      selectedIcon: true,
      i18n: 'table.menu.color_numbers.enable'
    }],
    filterConditions: FILTER_CONDITIONS.number
  },
  currency: {
    typeOrder: 2,
    icon: icons/* IconTypeCurrency */.SCs,
    type: 'tableCellCurrency',
    value: {
      key: 'characters'
    },
    summaries: SUMMARIES.number,
    format: {
      type: 'commas',
      stick: 'before',
      currency: 'dollar',
      decimal_separator: 'point',
      otherCurrency: '',
      decimals: 2
    },
    limit: {
      minWidth: 120
    },
    style: {
      align: 'right'
    },
    className: 'currency-menu',
    submenu: [{
      type: 'header',
      i18n: 'table.menu.currency_format.name'
    }, {
      type: 'radio',
      prop: 'currency',
      selectedIcon: true,
      values: [].concat(tableConfigTypes_toConsumableArray(Object.keys(CURRENCY)), ['other']),
      i18n: 'table.menu.currency_format.${value}',
      rightText: function rightText(value) {
        return CURRENCY[value] || false;
      },
      rightInput: function rightInput(value) {
        if (value === 'other') {
          return {
            prop: 'otherCurrency',
            maxLength: 5
          };
        }
        return false;
      }
    }, {
      type: 'header',
      i18n: 'table.menu.currency_format.stick'
    }, {
      type: 'radio',
      prop: 'stick',
      selectedIcon: true,
      values: ['before', 'after'],
      i18n: 'table.menu.currency_format.${value}'
    }, {
      type: 'header',
      i18n: 'table.menu.decimal_format.name',
      hint: 'table.menu.decimal_format.hint'
    }, {
      type: 'radio',
      prop: 'decimal_separator',
      selectedIcon: true,
      values: ['point', 'comma'],
      i18n: 'table.menu.decimal_format.${value}'
    }, {
      type: 'header',
      i18n: 'table.menu.color_numbers.name'
    }, {
      type: 'checkbox',
      prop: 'colorNumbers',
      selectedIcon: true,
      i18n: 'table.menu.color_numbers.enable'
    }],
    filterConditions: FILTER_CONDITIONS.currency
  },
  attachment: {
    typeOrder: 13,
    icon: icons/* IconTypeAttachment */.eI7,
    type: 'tableCellAttachment',
    value: {},
    summaries: SUMMARIES.attachment,
    limit: {
      minWidth: 228
    },
    filterConditions: FILTER_CONDITIONS.attachment
  },
  checkbox: {
    typeOrder: 4,
    icon: icons/* IconTypeCheckbox */.STX,
    summaries: SUMMARIES.checkbox,
    type: 'tableCellCheckbox',
    value: {
      key: 'checked',
      type: 'boolean'
    },
    createForce: true,
    getText: function getText() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var cellMap = options.cellMap;
      var text = 'table.checkbox.' + (cellMap !== null && cellMap !== void 0 && cellMap.get('checked') ? 'checked' : 'not_checked');
      return options.i18n ? options.i18n.get(text) : 'i18n:' + text;
    },
    limit: {
      minWidth: 60
    },
    filterConditions: FILTER_CONDITIONS.checkbox
  },
  singleselect: {
    typeOrder: 6,
    icon: icons/* IconTypeSingleselect */.Rd8,
    type: 'tableCellSelect',
    value: {
      key: 'selected',
      type: 'array',
      single: true
    },
    summaries: SUMMARIES.common,
    getText: getLabelsText,
    filterConditions: FILTER_CONDITIONS.singleselect
  },
  multiselect: {
    typeOrder: 7,
    icon: icons/* IconTypeMultiselect */.zLI,
    type: 'tableCellSelect',
    value: {
      key: 'selected',
      type: 'array'
    },
    summaries: SUMMARIES.common,
    getText: getLabelsText,
    filterConditions: FILTER_CONDITIONS.multiselect
  },
  mention: {
    typeOrder: 11,
    icon: icons/* IconTypeMention */.vGU,
    type: 'tableCellMention',
    value: {
      key: 'characters'
    },
    summaries: SUMMARIES.common,
    getText: function getText(options) {
      var _getMentionData;
      return ((_getMentionData = getMentionData(options)) === null || _getMentionData === void 0 ? void 0 : _getMentionData.text) || '';
    },
    getData: getMentionData,
    filterConditions: FILTER_CONDITIONS.mention
  },
  collaborator: {
    typeOrder: 12,
    icon: icons/* IconTypeCollaborator */.UhQ,
    type: 'tableCellCollaborator',
    value: {
      key: 'users',
      type: 'object'
    },
    summaries: SUMMARIES.collaborator,
    limit: {
      minWidth: 192
    },
    getText: function getText() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var cellMap = options.cellMap;
      var value = [];
      var users = cellMap === null || cellMap === void 0 ? void 0 : cellMap.get('users');
      if (users) {
        if (typeof users === 'string' && users[0] === '{') {
          users = JSON.parse(users);
        }
        if (tableConfigTypes_typeof(users) === 'object') {
          for (var key in users) {
            value.push(users[key].name);
          }
        }
      }
      return value.join(', ');
    },
    filterConditions: FILTER_CONDITIONS.collaborator
  },
  date: {
    typeOrder: 8,
    icon: icons/* IconTypeDate */.Yy4,
    type: 'tableCellDate',
    value: {
      key: 'timestamp',
      type: 'number',
      default: undefined
    },
    summaries: SUMMARIES.date,
    format: tableConfigTypes_objectSpread({}, DEFAULT_DATE_FORMAT),
    getText: function getText() {
      var _cellMap$has;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var cellMap = options.cellMap,
        cellLink = options.cellLink;
      if (cellLink !== null && cellLink !== void 0 && cellLink.getText) {
        return cellLink.getText();
      } else if (cellMap !== null && cellMap !== void 0 && (_cellMap$has = cellMap.has) !== null && _cellMap$has !== void 0 && _cellMap$has.call(cellMap, 'timestamp')) {
        return String(cellMap.get('timestamp'));
      }
      return '';
    },
    limit: {
      minWidth: 90
    },
    submenu: [{
      type: 'header',
      i18n: 'calendar.ui.date_format'
    }, {
      type: 'radio',
      prop: 'type',
      selectedIcon: true,
      i18n: 'calendar.date_format.${value}',
      values: ['default'].concat(tableConfigTypes_toConsumableArray(Object.keys(DATE_FORMATS)))
    }, {
      type: 'header',
      i18n: 'calendar.ui.time_format'
    }, {
      type: 'checkbox',
      prop: 'showTime',
      keepMenu: true,
      selectedIcon: true,
      i18n: 'calendar.ui.show_time'
    }, {
      type: 'radio',
      prop: 'timeFormat',
      selectedIcon: true,
      i18n: 'calendar.ui.time_${value}',
      values: [12, 24],
      condition: function condition(f) {
        return f.showTime;
      }
    }, {
      type: 'header',
      i18n: 'calendar.ui.first_week_day'
    }, {
      type: 'radio',
      prop: 'firstWeekDay',
      selectedIcon: true,
      i18n: 'calendar.days.full.${value}',
      values: [0, 1]
    }, {
      type: 'header',
      i18n: 'calendar.ui.time_zone',
      hint: 'calendar.ui.use_gmt_hint',
      condition: function condition(f) {
        return f.showTime;
      }
    }, {
      type: 'checkbox',
      prop: 'timeZoneGMT',
      keepMenu: true,
      selectedIcon: true,
      i18n: 'calendar.ui.use_gmt',
      condition: function condition(f) {
        return f.showTime;
      }
    }],
    filterConditions: FILTER_CONDITIONS.date
  },
  link: {
    typeOrder: 5,
    icon: icons/* IconTypeLink */.$nO,
    type: 'tableCellLink',
    value: {
      key: 'characters'
    },
    summaries: SUMMARIES.common,
    limit: {
      minWidth: 140
    },
    filterConditions: FILTER_CONDITIONS.link
  },
  rating: {
    typeOrder: 9,
    icon: icons/* IconTypeRating */._rK,
    type: 'tableCellRating',
    value: {
      key: 'rating',
      type: 'number',
      default: 0,
      min: 0,
      max: 5
    },
    summaries: SUMMARIES.rating,
    createForce: true,
    format: {
      type: 'star',
      amount: 5
    },
    limit: {
      minWidth: 102
    },
    submenu: [{
      type: 'radio',
      prop: 'type',
      values: ['star', 'flag', 'heart'],
      i18n: 'table.menu.rating_format.${value}',
      selectedIcon: false,
      textIcon: function textIcon(value, selected) {
        return RatingIcon.getIconSet(value)[selected ? 'blue' : 'gray'];
      }
    }, {
      type: 'number',
      prop: 'amount',
      i18n: 'table.menu.rating_format.amount',
      min: 1,
      max: 10
    }],
    filterConditions: FILTER_CONDITIONS.rating
  },
  progress: {
    typeOrder: 10,
    icon: icons/* IconTypeProgress */.qlW,
    type: 'tableCellProgress',
    value: {
      key: 'progress',
      type: 'number',
      default: 0,
      min: 0,
      max: 100
    },
    summaries: SUMMARIES.progress,
    createForce: true,
    format: {
      type: 'colored',
      default: 0
    },
    limit: {
      minWidth: 155
    },
    getText: function getText() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var cellMap = options.cellMap;
      return ((cellMap === null || cellMap === void 0 ? void 0 : cellMap.get('progress')) || 0) + '%';
    },
    submenu: [{
      type: 'radio',
      prop: 'type',
      values: ['colored', 'simple'],
      i18n: 'table.menu.progress_format.${value}',
      selectedIcon: true,
      iconPosition: 'right',
      textIcon: function textIcon(value) {
        return value === 'colored' ? icons/* IconProgressColored */.puQ : icons/* IconProgressSimple */.iLV;
      }
    }, {
      type: 'number',
      prop: 'default',
      i18n: 'table.menu.progress_format.default_amount',
      min: 0,
      max: 100
    }],
    filterConditions: FILTER_CONDITIONS.progress
  }
};

/**
 * Возвращает данные по типу ячейки
 * @param {string} Тип ячейки
 * @returns {object}
 */
function getTypeData(type) {
  if (type && CELL_TYPES[type]) {
    return CELL_TYPES[type];
  } else {
    return CELL_TYPES[defaultType];
  }
}

/**
 * Перебирает типы ячееки и передает в cb функцию
 * @param {function} cb
 * @callback
 *    @param {string} Название типа ячейки
 *    @param {object} Данные тип ячейки
 */
function eachType(cb) {
  if (typeof cb === 'function') {
    Object.keys(CELL_TYPES).forEach(function (type) {
      cb(type, CELL_TYPES[type]);
    });
  }
}

/**
 * Возвращает тип ячейки из названия (блота)
 * Если название не найдено или не передано то возвращает 'text'
 * @param {string} name
 * @returns {string}
 */
function getTypeFromName(name) {
  return typeNames[name] || defaultType;
}

/**
 * Возвращает тип ячейки из map
 * @param {Ymap} map
 * @returns {string}
 */
function typeFromMap(map) {
  var currentType;
  if (map !== null && map !== void 0 && map.has('type')) {
    var type = typeNames[map.get('type')];
    if (type) {
      currentType = type;
    }
  }
  return currentType || defaultType;
}

/**
 * Возвращает значение для сравнения ячейки
 * @param {Ymap} cellMap: map ячейки
 * @param {Ymap} childMap: map контента ячейки
 * @param {object} options?
 * @param {string} options.cellType?: тип сортировки для несозданных map (выбран у колонки)
 * @param {string} options.colMap?: map колонки
 * @returns {object} {
 *    value: значение,
 *    order: приоритет по типу ячейки
 * }
 */
function comparisonValue(cellMap, childMap) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var cellType = options.cellType || typeFromMap(cellMap);
  var value = null;
  if (cellType === 'checkbox') {
    value = cellMap !== null && cellMap !== void 0 && cellMap.get('checked') ? 1 : 0;
  } else if (cellType === 'rating') {
    value = parseInt(cellMap === null || cellMap === void 0 ? void 0 : cellMap.get('rating')) || 0;
  } else if (cellType === 'progress') {
    value = parseInt(cellMap === null || cellMap === void 0 ? void 0 : cellMap.get('progress')) || 0;
  } else if (cellType === 'date') {
    value = parseInt(cellMap === null || cellMap === void 0 ? void 0 : cellMap.get('timestamp')) || 0;
  } else if (cellType === 'collaborator') {
    var _CELL_TYPES$cellType, _CELL_TYPES$cellType$;
    value = ((_CELL_TYPES$cellType = CELL_TYPES[cellType]) === null || _CELL_TYPES$cellType === void 0 ? void 0 : (_CELL_TYPES$cellType$ = _CELL_TYPES$cellType.getText) === null || _CELL_TYPES$cellType$ === void 0 ? void 0 : _CELL_TYPES$cellType$.call(_CELL_TYPES$cellType, {
      cellMap: cellMap
    })) || null;
  } else if (cellType === 'mention') {
    var _CELL_TYPES$cellType2, _CELL_TYPES$cellType3;
    value = ((_CELL_TYPES$cellType2 = CELL_TYPES[cellType]) === null || _CELL_TYPES$cellType2 === void 0 ? void 0 : (_CELL_TYPES$cellType3 = _CELL_TYPES$cellType2.getText) === null || _CELL_TYPES$cellType3 === void 0 ? void 0 : _CELL_TYPES$cellType3.call(_CELL_TYPES$cellType2, {
      childMap: childMap,
      withType: true,
      timestamp: true
    })) || null;
  } else if (cellType === 'singleselect' || cellType === 'multiselect') {
    var _CELL_TYPES$cellType4, _CELL_TYPES$cellType5;
    value = ((_CELL_TYPES$cellType4 = CELL_TYPES[cellType]) === null || _CELL_TYPES$cellType4 === void 0 ? void 0 : (_CELL_TYPES$cellType5 = _CELL_TYPES$cellType4.getText) === null || _CELL_TYPES$cellType5 === void 0 ? void 0 : _CELL_TYPES$cellType5.call(_CELL_TYPES$cellType4, {
      cellMap: cellMap,
      colMap: options.colMap
    })) || '';
  } else if (cellType === 'number' || cellType === 'currency') {
    if (childMap !== null && childMap !== void 0 && childMap.has('characters')) {
      var chars = String(childMap.get('characters')).trim().replace(/‚/g, '').replace(',', '.');
      if (!isNaN(chars)) {
        value = parseFloat(chars);
      }
    }
  } else {
    if (childMap !== null && childMap !== void 0 && childMap.has('characters')) {
      var text = String(childMap.get('characters')).trim();
      if (text) {
        var float = parseFloat(text);
        if (!isNaN(float)) {
          value = float;
        } else {
          value = text;
        }
      }
    }
  }
  return {
    value: value,
    order: CELL_TYPES[cellType].typeOrder
  };
}

/**
 * Возвращает значение ячейки
 * @param { Ymap } cellMap: map ячейки
 * @param { Ymap } childMap?: map контента ячейки
 * @returns { any } text, number, boolean, null
 */
function parseTypeProps(cellType) {
  var _CELL_TYPES$cellType6;
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var store = arguments.length > 2 ? arguments[2] : undefined;
  var mapProps = {};
  var value = (_CELL_TYPES$cellType6 = CELL_TYPES[cellType]) === null || _CELL_TYPES$cellType6 === void 0 ? void 0 : _CELL_TYPES$cellType6.value;
  if (value !== null && value !== void 0 && value.key && value.key !== 'characters') {
    var result;
    var propsValue = props.hasOwnProperty(value.key) ? props[value.key] : props.hasOwnProperty('value') ? props.value : '';
    if (value.type === 'number') {
      result = !isNaN(propsValue) && propsValue !== null ? parseFloat(propsValue) : value.hasOwnProperty('default') ? value.default : 0;
      if (value.hasOwnProperty('min')) {
        result = Math.max(value.min, result);
      }
      if (value.hasOwnProperty('max')) {
        result = Math.min(value.max, result);
      }
    } else if (value.type === 'boolean') {
      result = [true, 'true', 1, '1'].includes(propsValue) ? true : false;
    } else if (value.type === 'object') {
      result = props.hasOwnProperty(value.key) ? props[value.key] : {};
      if (typeof result === 'string' && result[0] === '{') {
        result = JSON.parse(result);
      }
    } else if (value.type === 'array') {
      var _result;
      result = props.hasOwnProperty(value.key) ? props[value.key] : [];
      if (typeof result === 'string') {
        if (result[0] === '[') {
          result = JSON.parse(result);
        } else {
          result = result.split(',');
        }
      }
      if (value.single && ((_result = result) === null || _result === void 0 ? void 0 : _result.length) > 1) {
        result = [result[0]];
      }
    } else {
      result = propsValue;
    }
    mapProps[value.key] = result;
  } else {
    var _props$delta, _props$delta2, _props$delta2$ops, _props$children;
    var delta;
    if ((_props$delta = props.delta) !== null && _props$delta !== void 0 && _props$delta.length || (_props$delta2 = props.delta) !== null && _props$delta2 !== void 0 && (_props$delta2$ops = _props$delta2.ops) !== null && _props$delta2$ops !== void 0 && _props$delta2$ops.length) {
      delta = new (Delta_default())(props.delta);
    } else if ((_props$children = props.children) !== null && _props$children !== void 0 && _props$children.length) {
      var childId = props.children[0];
      var childMap = store.getMap(childId);
      if (childMap !== null && childMap !== void 0 && childMap.has('characters')) {
        var characters = childMap.get('characters');
        delta = new (Delta_default())(characters.toDelta());
      }
    } else if (props.hasOwnProperty('text') && props.text) {
      delta = new (Delta_default())().insert(String(props.text));
    } else if (props.hasOwnProperty('value') && props.value !== 0) {
      delta = new (Delta_default())().insert(String(props.value));
    }
    if (delta) {
      mapProps.delta = prepareDeltaToType(cellType, delta);
    }
  }
  return mapProps;
}

/**
 * Подготавливает дельту для вставки в типизированную ячейку
 * @param { string } type: тип ячейки
 * @param { delta } delta: дельта, которую необходимо подготовить
 * @returns { delta } обработанная дельта
 */
function prepareDeltaToType(type, delta) {
  var newDelta;
  if (type === 'text') {
    var _delta$ops;
    if (delta !== null && delta !== void 0 && (_delta$ops = delta.ops) !== null && _delta$ops !== void 0 && _delta$ops.length && typeof delta.ops[0].insert !== 'string' && !delta.ops[0].insert.mention) {
      newDelta = new (Delta_default())();
    } else {
      newDelta = delta;
    }
  } else if (type === 'number' || type === 'currency') {
    var _delta$ops2;
    // Для чисел и валюты вставляем только значение с плавающей точкой
    // Аттрибуты не вставляем, так как числовые ячейки не поддерживают стилевое форматирование
    if (delta !== null && delta !== void 0 && (_delta$ops2 = delta.ops) !== null && _delta$ops2 !== void 0 && _delta$ops2.length) {
      var _delta$ops$0$insert;
      newDelta = new (Delta_default())();
      var value = (_delta$ops$0$insert = delta.ops[0].insert) === null || _delta$ops$0$insert === void 0 ? void 0 : _delta$ops$0$insert.trim().replace(/ /g, '').replace(',', '.').replace(/^[-]+/, '-');
      var floatValue = parseFloat(value);
      if (!isNaN(floatValue)) {
        newDelta.insert(String(floatValue) + '\n');
      }
    }
  } else if (type === 'link') {
    var _delta$ops3, _delta$ops3$, _delta$ops3$$attribut, _delta$ops3$$attribut2;
    // Для типа ячейки "ссылка" очищаем дельту, если в ней нет атрибута ссылки
    if (delta !== null && delta !== void 0 && (_delta$ops3 = delta.ops) !== null && _delta$ops3 !== void 0 && (_delta$ops3$ = _delta$ops3[0]) !== null && _delta$ops3$ !== void 0 && (_delta$ops3$$attribut = _delta$ops3$.attributes) !== null && _delta$ops3$$attribut !== void 0 && (_delta$ops3$$attribut2 = _delta$ops3$$attribut.hasOwnProperty) !== null && _delta$ops3$$attribut2 !== void 0 && _delta$ops3$$attribut2.call(_delta$ops3$$attribut, 'link')) {
      newDelta = delta;
    }
  } else {
    newDelta = delta;
  }
  return newDelta;
}

/**
 * Возвращает параметры для копирования ячейки
 * @param { string } options.cellType?: тип ячейки, если не задан то пытается определить
 * @param { Ymap } cellMap: map ячейки
 * @param { Ymap } childMap: map контента ячейки
 * @param { object } options?
 * @param { object } options.colMap?  map колонки, опционально
 * @param { object } options.cellLink?  cellLink отрендеренной ячейки
 * @param { object } options.i18n?: плагин i18n
 * @returns { object } result
 * @returns { object }  result.params: параметры map ячейки
 * @returns { object }  result.text: текстовое содержимое ячейки
 * @returns { any }     result.value: значение ячейки
 */
function getCellCopyParams(cellType, cellMap, childMap) {
  var _CELL_TYPES$cellType7, _CELL_TYPES$cellType8, _CELL_TYPES$cellType9;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var colMap = options.colMap,
    cellLink = options.cellLink,
    _options$i18n = options.i18n,
    i18n = _options$i18n === void 0 ? false : _options$i18n;
  var type = cellType || typeFromMap(cellMap);
  var value = (_CELL_TYPES$cellType7 = CELL_TYPES[cellType]) === null || _CELL_TYPES$cellType7 === void 0 ? void 0 : _CELL_TYPES$cellType7.value;
  var getText = (_CELL_TYPES$cellType8 = CELL_TYPES[cellType]) === null || _CELL_TYPES$cellType8 === void 0 ? void 0 : _CELL_TYPES$cellType8.getText;
  var getData = (_CELL_TYPES$cellType9 = CELL_TYPES[cellType]) === null || _CELL_TYPES$cellType9 === void 0 ? void 0 : _CELL_TYPES$cellType9.getData;
  var result = {
    params: {
      cellType: type
    },
    text: '',
    value: ''
  };
  if (value !== null && value !== void 0 && value.key && value.key !== 'characters') {
    var _cellMap$get;
    result.value = cellMap === null || cellMap === void 0 ? void 0 : (_cellMap$get = cellMap.get) === null || _cellMap$get === void 0 ? void 0 : _cellMap$get.call(cellMap, value.key);
    if (value.type === 'number') {
      var float = parseFloat(result.value);
      result.value = !isNaN(float) ? float : value.hasOwnProperty('default') ? value.default : 0;
    } else if (value.type === 'boolean') {
      result.value = [1, '1', true, 'true'].includes(result.value) ? true : false;
    } else if (value.type === 'array') {
      result.value = result.value || [];
    } else if (value.type === 'object') {
      result.value = '';
    }
  }
  if (typeof getData === 'function') {
    var data = getData({
      cellMap: cellMap,
      childMap: childMap,
      colMap: colMap,
      cellLink: cellLink
    });
    Object.assign(result, data);
  } else if (typeof getText === 'function') {
    result.text = getText({
      cellMap: cellMap,
      childMap: childMap,
      colMap: colMap,
      cellLink: cellLink,
      i18n: i18n
    });
  } else if (childMap !== null && childMap !== void 0 && childMap.has('characters')) {
    result.text = DeltaToHTML(childMap.get('characters').toDelta()).replace(/\n$/, '');
  } else {
    if (result.value || [0, false].includes(result.value)) {
      result.text = String(result.value);
    }
  }
  if ((value === null || value === void 0 ? void 0 : value.key) === 'characters') {
    result.value = result.text;
  }
  if (cellMap) {
    var _iterator = tableConfigTypes_createForOfIteratorHelper(CONFIG.cell.copy),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _key2 = _step.value;
        if (cellMap.has(_key2)) {
          result.params[_key2] = cellMap.get(_key2);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (childMap) {
      var _iterator2 = tableConfigTypes_createForOfIteratorHelper(CONFIG.child.copy),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var key = _step2.value;
          if (childMap.has(key)) {
            result.params[key] = childMap.get(key);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      if (childMap.has('characters')) {
        var sourceDelta = childMap.get('characters').toDelta();
        var delta = sourceDelta.reduce(function (delta, op) {
          return delta.insert(op.insert, op.attributes);
        }, new (Delta_default())());
        result.params.delta = prepareDeltaForCopy(delta);
      }
    }
  }
  return result;
}
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/plugins/tooltipManager/index.js
var tooltipManager = __webpack_require__(95174);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/tableUIMenuButtons.js











function tableUIMenuButtons_extends() { tableUIMenuButtons_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tableUIMenuButtons_extends.apply(this, arguments); }
function tableUIMenuButtons_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function tableUIMenuButtons_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { tableUIMenuButtons_typeof = function _typeof(obj) { return typeof obj; }; } else { tableUIMenuButtons_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return tableUIMenuButtons_typeof(obj); }
function tableUIMenuButtons_slicedToArray(arr, i) { return tableUIMenuButtons_arrayWithHoles(arr) || tableUIMenuButtons_iterableToArrayLimit(arr, i) || tableUIMenuButtons_unsupportedIterableToArray(arr, i) || tableUIMenuButtons_nonIterableRest(); }
function tableUIMenuButtons_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tableUIMenuButtons_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tableUIMenuButtons_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tableUIMenuButtons_arrayLikeToArray(o, minLen); }
function tableUIMenuButtons_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function tableUIMenuButtons_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function tableUIMenuButtons_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }





function TableMenuButtonCell() {
  var _useState = (0,hooks_module/* useState */.eJ)(true),
    _useState2 = tableUIMenuButtons_slicedToArray(_useState, 2),
    target = _useState2[0],
    setTarget = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(0),
    _useState4 = tableUIMenuButtons_slicedToArray(_useState3, 2),
    update = _useState4[0],
    setUpdate = _useState4[1];
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    data = _useContext.data,
    editable = _useContext.editable,
    useRefs = _useContext.useRefs;
  var renderBtn = function renderBtn() {
    if (editable && tableUIMenuButtons_typeof(target) === 'object') {
      setUpdate(update + 1);
    }
  };
  useRefs.setUI('cell-menu-btn', {
    render: renderBtn.bind(this),
    setTarget: setTarget.bind(this)
  });
  (0,hooks_module/* useEffect */.d4)(function () {
    var lastCell;
    if (tableUIMenuButtons_typeof(target) === 'object' && target) {
      if (target.row === data.size.rows - 1 && target.col === data.size.cols - 1) {
        var _useRefs$links$ui$res, _useRefs$links$ui$res2;
        lastCell = true;
        (_useRefs$links$ui$res = useRefs.links.ui['resizer-grip']) === null || _useRefs$links$ui$res === void 0 ? void 0 : (_useRefs$links$ui$res2 = _useRefs$links$ui$res.setHidden) === null || _useRefs$links$ui$res2 === void 0 ? void 0 : _useRefs$links$ui$res2.call(_useRefs$links$ui$res, true);
      }
    }
    return function () {
      if (lastCell) {
        var _useRefs$links$ui$res3, _useRefs$links$ui$res4;
        (_useRefs$links$ui$res3 = useRefs.links.ui['resizer-grip']) === null || _useRefs$links$ui$res3 === void 0 ? void 0 : (_useRefs$links$ui$res4 = _useRefs$links$ui$res3.setHidden) === null || _useRefs$links$ui$res4 === void 0 ? void 0 : _useRefs$links$ui$res4.call(_useRefs$links$ui$res3, false);
      }
    };
  }, [target]);
  var onMouseDown = function onMouseDown(event) {
    var _links$cell$target$ro, _links$cell$target$ro2, _links$cell$target$ro3;
    var links = useRefs.links;
    (_links$cell$target$ro = links.cell[target.row]) === null || _links$cell$target$ro === void 0 ? void 0 : (_links$cell$target$ro2 = _links$cell$target$ro[target.col]) === null || _links$cell$target$ro2 === void 0 ? void 0 : (_links$cell$target$ro3 = _links$cell$target$ro2.onMenuButton) === null || _links$cell$target$ro3 === void 0 ? void 0 : _links$cell$target$ro3.call(_links$cell$target$ro2, event);
  };
  var button = null;
  if (editable && target) {
    var _links$cell$target$ro4;
    var links = useRefs.links;
    var cell = (_links$cell$target$ro4 = links.cell[target.row]) === null || _links$cell$target$ro4 === void 0 ? void 0 : _links$cell$target$ro4[target.col];
    if (cell && cell.getNode()) {
      var tableRect = links.ui.table.getNode().getBoundingClientRect();
      var cellRect = cell.getNode().getBoundingClientRect();
      var style = {
        top: cellRect.top + cellRect.height - tableRect.top,
        left: cellRect.left + cellRect.width - tableRect.left
      };
      button = (0,preact_module.h)("div", {
        className: "menu-btn menu-btn-cell",
        onMouseDown: onMouseDown,
        style: style
      }, (0,preact_module.h)(icons/* IconPinBtn */.aXx, null));
    }
  }
  return button;
}
function TableMenuButtonRow() {
  var _useContext2 = (0,hooks_module/* useContext */.qp)(TableContext),
    editable = _useContext2.editable,
    i18n = _useContext2.i18n;
  var button = null;
  if (editable) {
    var _buttonAttrs;
    var buttonAttrs = (_buttonAttrs = {}, tableUIMenuButtons_defineProperty(_buttonAttrs, tooltipManager/* TOOLTIP_ATTR */.qZ, i18n.get('block_menu.tooltip')), tableUIMenuButtons_defineProperty(_buttonAttrs, tooltipManager/* TOOLTIP_ATTR_ALLOW_UNSAFE_HTML */.aP, 1), _buttonAttrs);
    button = (0,preact_module.h)("div", tableUIMenuButtons_extends({}, buttonAttrs, {
      className: "menu-btn menu-btn-row"
    }), (0,preact_module.h)(icons/* IconPinBtn */.aXx, null));
  }
  return button;
}
function TableMenuButtonCol() {
  var _useContext3 = (0,hooks_module/* useContext */.qp)(TableContext),
    editable = _useContext3.editable,
    i18n = _useContext3.i18n;
  var button = null;
  if (editable) {
    var _buttonAttrs2;
    var buttonAttrs = (_buttonAttrs2 = {}, tableUIMenuButtons_defineProperty(_buttonAttrs2, tooltipManager/* TOOLTIP_ATTR */.qZ, i18n.get('block_menu.tooltip')), tableUIMenuButtons_defineProperty(_buttonAttrs2, tooltipManager/* TOOLTIP_ATTR_ALLOW_UNSAFE_HTML */.aP, 1), _buttonAttrs2);
    button = (0,preact_module.h)("div", tableUIMenuButtons_extends({}, buttonAttrs, {
      className: "menu-btn menu-btn-col"
    }), (0,preact_module.h)(icons/* IconPinBtn */.aXx, null));
  }
  return button;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__(64765);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/action.js
function action_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = action_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function action_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return action_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return action_arrayLikeToArray(o, minLen); }
function action_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }











function action_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function action_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function action_createClass(Constructor, protoProps, staticProps) { if (protoProps) action_defineProperties(Constructor.prototype, protoProps); if (staticProps) action_defineProperties(Constructor, staticProps); return Constructor; }
var Action = /*#__PURE__*/function () {
  function Action(type, params, editor) {
    action_classCallCheck(this, Action);
    this.type = type;
    this.params = params;
    this.editor = editor;
    this.selectedBlots = [];
    this.cache = {};
    this.cache.blotRange = {};
    this.restoreSelection = false;
    this.isHandledByBrowser = false;
    // признак что действие было инициаровано нажатием клавишь на клавиатуре
    this.keyboard = false;
    // результаты действия
    this.results = [];
  }
  action_createClass(Action, [{
    key: "addResult",
    value: function addResult(result) {
      this.results.push(result);
    }
  }, {
    key: "dontRestoreSelection",
    value: function dontRestoreSelection() {
      this.restoreSelection = false;
    }
  }, {
    key: "handleByBrowser",
    value: function handleByBrowser() {
      this.isHandledByBrowser = true;
    }
  }, {
    key: "getBlotRange",
    value: function getBlotRange(blot) {
      if (!this.cache.blotRange[blot.id]) {
        this.cache.blotRange[blot.id] = this.editor.scroll.selection.getRange({
          offsetBlot: blot
        })[0];
      }
      return this.cache.blotRange[blot.id];
    }
  }, {
    key: "setBlotRange",
    value: function setBlotRange(blot, range) {
      this.cache.blotRange[blot.id] = range;
    }
  }, {
    key: "setSelectedBlots",
    value: function setSelectedBlots(selectedBlots) {
      this.selectedBlots = selectedBlots;
    }
  }, {
    key: "before",
    value: function before() {}
  }, {
    key: "after",
    value: function after() {}
  }, {
    key: "run",
    value: function run(opts) {
      if (!this.allowWithoutFocus && !this.editor.hasFocus()) return;
      this.before(opts);
      var res = this.exec(opts);
      this.after(opts);
      return res;
    }
  }, {
    key: "exec",
    value: function exec(_ref) {
      var processingBlots = _ref.processingBlots,
        abortOnFirstProcess = _ref.abortOnFirstProcess;
      // устанавливаем чтобы блоты имели доступ к списку обрабатываемых в этом действии блотов
      this.processingBlots = processingBlots;
      var isProcessed = false;
      var _iterator = action_createForOfIteratorHelper(processingBlots),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var blot = _step.value;
          var processed = blot.exec(this, this.params);
          if (processed === true) {
            isProcessed = true;
            if (abortOnFirstProcess) {
              break;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return isProcessed;
    }
  }]);
  return Action;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/delete.js
function delete_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { delete_typeof = function _typeof(obj) { return typeof obj; }; } else { delete_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return delete_typeof(obj); }
function delete_slicedToArray(arr, i) { return delete_arrayWithHoles(arr) || delete_iterableToArrayLimit(arr, i) || delete_unsupportedIterableToArray(arr, i) || delete_nonIterableRest(); }
function delete_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function delete_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function delete_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function delete_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = delete_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function delete_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return delete_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return delete_arrayLikeToArray(o, minLen); }
function delete_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



















function delete_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function delete_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function delete_createClass(Constructor, protoProps, staticProps) { if (protoProps) delete_defineProperties(Constructor.prototype, protoProps); if (staticProps) delete_defineProperties(Constructor, staticProps); return Constructor; }
function delete_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { delete_get = Reflect.get; } else { delete_get = function _get(target, property, receiver) { var base = delete_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return delete_get(target, property, receiver || target); }
function delete_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = delete_getPrototypeOf(object); if (object === null) break; } return object; }
function delete_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) delete_setPrototypeOf(subClass, superClass); }
function delete_setPrototypeOf(o, p) { delete_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return delete_setPrototypeOf(o, p); }
function delete_createSuper(Derived) { var hasNativeReflectConstruct = delete_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = delete_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = delete_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return delete_possibleConstructorReturn(this, result); }; }
function delete_possibleConstructorReturn(self, call) { if (call && (delete_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return delete_assertThisInitialized(self); }
function delete_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function delete_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function delete_getPrototypeOf(o) { delete_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return delete_getPrototypeOf(o); }
function delete_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var DeleteAction = /*#__PURE__*/function (_Action) {
  delete_inherits(DeleteAction, _Action);
  var _super = delete_createSuper(DeleteAction);
  function DeleteAction(type, params, editor) {
    var _this;
    delete_classCallCheck(this, DeleteAction);
    type = type || BackspaceAction.type;
    _this = _super.call(this, type, params, editor);
    delete_defineProperty(delete_assertThisInitialized(_this), "rangeBefore", null);
    _this.restoreSelection = true;
    return _this;
  }
  delete_createClass(DeleteAction, [{
    key: "isAllTextSelected",
    value: function isAllTextSelected(blot) {
      var blotRange = this.getBlotRange(blot);
      return blotRange.length === blot.length() - 1;
    }
  }, {
    key: "before",
    value: function before(_ref) {
      var processingBlots = _ref.processingBlots;
      this.rangeBefore = this.editor.scroll.selection.getRange()[0];
    }
  }, {
    key: "after",
    value: function after() {
      if (!this.restoreSelection || !this.rangeBefore) {
        if (this._blurAfter) {
          this.editor.scroll.selection.setRange(null);
        } else {
          // FIXME из-за бага в хроме https://bugs.chromium.org/p/chromium/issues/detail?id=725890 при нажатии Delete не генерируется событие selectionchange
          // генерируем его сами. На Firefox наблюдается такая же проблема, но только с Delete, с Backspace все нормально.
          if (this.editor.browser === 'Chrome' || this.editor.browser === 'Firefox') {
            var selectionChangeEvent = new CustomEvent('selectionchange', {});
            document.dispatchEvent(selectionChangeEvent);
          }
        }
        return;
      }
      var newRange = {
        index: this.rangeBefore.index,
        length: 0
      };
      this.editor.scroll.selection.setRange(newRange);
    }
  }, {
    key: "getNextTextLineBlot",
    value: function getNextTextLineBlot(blot) {
      var tryNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (typeof blot === 'undefined') return null;
      var nextBlot = blot.next;
      if (!nextBlot) {
        // blot последний в своем контейнере
        if (tryNum === 1) {
          return null;
        }
        // попробуем проверить следующий блот после контейнера в котором находится blot
        return this.getNextTextLineBlot(blot.container, tryNum + 1);
      }
      if (nextBlot.isContainer) {
        nextBlot = nextBlot.children.head;
      }
      if (nextBlot && !nextBlot.isText || !nextBlot) {
        return null;
      }
      return nextBlot;
    }
  }, {
    key: "getNextBlot",
    value: function getNextBlot(blot) {
      var tryNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (typeof blot === 'undefined') return null;
      var nextBlot = blot.getWrapper ? blot.getWrapper().next : blot.next;
      if (!nextBlot) {
        // blot последний в своем контейнере
        if (tryNum === 1) {
          return null;
        }
        // попробуем проверить следующий блот после контейнера в котором находится blot
        return this.getNextBlot(blot.container, tryNum + 1);
      }
      if (nextBlot.isContainer) {
        nextBlot = nextBlot.children.head;
      } else if (nextBlot.getInnerTextLine) {
        nextBlot = nextBlot.getInnerTextLine();
      }
      if (!nextBlot) {
        return null;
      }
      return nextBlot;
    }

    /**
     * получение дельты для первого блота в ситуации когда юзер выделяет часть текста в блотах и жмет delete
     * мы должны объединить оставшися текста первого и последнего блотов в выделении
     * это функция возвращает дельту, которую надо применить на первый блот, чтобы произвести это объединение
     * @param  {Blot} firstBlot первый блот в выделении
     * @param  {Blot} lastBlot  последний блот в выделении
     * @return {Delta}           дельта для объединения текста последнего блота с первым
     */
  }, {
    key: "getFirstBlotDelta",
    value: function getFirstBlotDelta(firstBlot, lastBlot) {
      var firstBlotText = firstBlot.constructor.isTextBlot ? firstBlot.getTextBlot() : firstBlot;
      var lastBlotText = lastBlot.constructor.isTextBlot ? lastBlot.getTextBlot() : lastBlot;
      var firstBlotRange = this.getBlotRange(firstBlot);
      var firstBlotDelta = firstBlotText.delta();
      var firstBlotDeltaNew = firstBlotDelta.compose(new (Delta_default())().retain(firstBlotRange.index).delete(firstBlotRange.length));
      if (lastBlotText.isText) {
        var lastBlotRange = this.getBlotRange(lastBlot);
        var lastBlotDelta = lastBlotText.delta();
        var lastBlotRemainsDelta = new (Delta_default())().retain(firstBlotRange.index).concat(lastBlotDelta.compose(new (Delta_default())().delete(lastBlotRange.length)));
        lastBlotRemainsDelta = DeleteAction.removeNewLinesFromDelta(lastBlotRemainsDelta);
        firstBlotDeltaNew = firstBlotDeltaNew.compose(lastBlotRemainsDelta);
      }
      firstBlotDeltaNew = firstBlotDelta.diff(firstBlotDeltaNew);
      return firstBlotDeltaNew;
    }
  }, {
    key: "handleFirstTextLineDelete",
    value: function handleFirstTextLineDelete(_ref2) {
      var processingBlots = _ref2.processingBlots,
        firstBlot = _ref2.firstBlot,
        lastBlot = _ref2.lastBlot;
      // обработка ситуации когда первый и последний блот в выделении являются текстовыми строками
      // в этой ситуации все блоты между ними должны быть удалены, оставшийся текст последнего блота
      // должен переместится в первый блот и последний блот также должен быть удален
      var firstBlotDelta = this.getFirstBlotDelta(firstBlot, lastBlot);
      processingBlots = processingBlots.slice();
      processingBlots.shift();
      var firstBlotText = firstBlot.constructor.isTextBlot ? firstBlot.getTextBlot() : firstBlot;
      firstBlotText.applyForCharacters(firstBlotDelta.ops);
      var _iterator = delete_createForOfIteratorHelper(processingBlots),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var blot = _step.value;
          blot.remove();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "handleDeleteBeforeTextLine",
    value: function handleDeleteBeforeTextLine(firstBlot) {
      // каретка стоит в конце блота, если следующий блот наследует TextLine, то его контент должен перенестись в текущий блот,
      // а сам следующий блот должен удалится
      var nextBlot = this.getNextBlot(firstBlot);
      if (nextBlot) {
        if (firstBlot.isEmpty()) {
          // нажатие delete в пустой строке, надо удалить строку
          firstBlot.remove();
          this.rangeBefore = {
            index: nextBlot.offset(this.editor.scroll),
            length: 0
          };
          return true;
        } else if ((nextBlot.isText || nextBlot.constructor.isTextBlot) && !nextBlot.isBlotLocked) {
          var firstBlotText = firstBlot.constructor.isTextBlot ? firstBlot.getTextBlot() : firstBlot;
          var nextBlotText = nextBlot.constructor.isTextBlot ? nextBlot.getTextBlot() : nextBlot;
          var delta = DeleteAction.getBlotDelta(nextBlotText, firstBlotText);
          firstBlotText.applyForCharacters(delta.ops);
          nextBlot.remove();
          return true;
        }
      }
      return false;
    }
  }, {
    key: "deleteBlotsWithTextLineCheck",
    value: function deleteBlotsWithTextLineCheck(blots) {
      // удаляем все выделенные блоты, если последний является TextLine то вызываем действие на нем
      var last = blots.pop();
      // сначало обрабатываем последний блот,
      // т.к. если не нем надо выполнить действие то выделение должно быть таким как в начале удаления,
      // т.к. выделение слетает после удаления блотов
      var _iterator2 = delete_createForOfIteratorHelper(blots),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var blot = _step2.value;
          blot.remove();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      if (last.isText || last.constructor.isTextBlot) {
        delete_get(delete_getPrototypeOf(DeleteAction.prototype), "exec", this).call(this, {
          processingBlots: [last]
        });
      } else {
        last.remove();
      }
    }
  }, {
    key: "deleteEmbedBlot",
    value: function deleteEmbedBlot(blot) {
      var nextBlot = this.getNextBlot(blot.getWrapper());
      var setRangeToAfterBlot = false;
      if (nextBlot) {
        if (nextBlot.image) {
          this.rangeBefore = null;
          this._blurAfter = true;
        } else {
          setRangeToAfterBlot = true;
        }
      } else {
        var _this$editor$scroll$s = this.editor.scroll.selection.getRange(),
          _this$editor$scroll$s2 = delete_slicedToArray(_this$editor$scroll$s, 1),
          range = _this$editor$scroll$s2[0];
        if (!range) {
          this.rangeBefore = {
            index: 0,
            length: 0
          };
        } else {
          this.rangeBefore = {
            index: range.index - 1,
            length: 0
          };
        }
      }
      blot.remove();
      if (setRangeToAfterBlot) {
        this.rangeBefore = {
          index: nextBlot.offset(this.editor.scroll),
          length: 0
        };
      }
      return true;
    }
  }, {
    key: "deleteBlots",
    value: function deleteBlots(blots) {
      // тут удаляем всегда через map, так как этот метод вызывается когда удаляем весь контент
      var _iterator3 = delete_createForOfIteratorHelper(blots),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var blot = _step3.value;
          blot.container.removeChildById(blot.id);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "tryMergeLists",
    value: function tryMergeLists(blot) {
      if (!blot || !blot.isListItem) return false;
      var list = blot.parent;
      if (list.children.tail === blot) {
        //целевой блот является последним в списке?
        var nextList = list.next;
        if (nextList && nextList.constructor.blotName === 'list') {
          var moveIds = nextList.children.map(function (listItem) {
            return listItem.id;
          }); //следующий за списком блот, тоже является списком?
          var index = list.getChildIndex(blot.id) + 1;
          this.editor.store.transaction(function () {
            var _iterator4 = delete_createForOfIteratorHelper(moveIds),
              _step4;
            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var id = _step4.value;
                //перемещаем все блоты из следующего списка, в текущий
                nextList.removeChildById(id);
                index = Math.min(index, list.containerChildren.length);
                list.containerChildren.insert(index, [id]);
                index++;
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
          });
          list.render();
          return true;
        }
      }
      return false;
    }
  }, {
    key: "tryHandleEmptyTextLineBeforeEmbeddable",
    value: function tryHandleEmptyTextLineBeforeEmbeddable(blot) {
      var next = blot.getWrapper().next;
      if (next && (next.isEmbeddable || next.getWrappedBlot && next.getWrappedBlot().isEmbeddable)) {
        blot.remove();
        return true;
      }
      return false;
    }
  }, {
    key: "exec",
    value: function exec(_ref3) {
      var _this2 = this;
      var processingBlots = _ref3.processingBlots;
      var range = this.rangeBefore;
      processingBlots = processingBlots.filter(function (blot) {
        return blot.canExec(_this2);
      }).filter(function (blot) {
        var collapsibleContainer = searchUp(blot, function (b) {
          return b.isCollapsibleContainer;
        });
        return !collapsibleContainer || !collapsibleContainer.getSelectableBlot().props.selected;
      });
      var firstBlot = processingBlots[0];
      var lastBlot = processingBlots[processingBlots.length - 1];
      var processed = true;
      if (processingBlots.length === 1 && firstBlot.constructor.skipDeleteAction) {
        processed = true;
      } else if (range && range.index === 0 && range.length === this.editor.scroll.length() - 1) {
        this.rangeBefore = null;
        // выделен весь контент в редакторе, удаляем все блоты
        this.deleteBlots(processingBlots);
        // некоторые блоки (тапример тоггл) при выполнении удаления 
        // не дают редактору выставить каретку в нулевую позицию,
        // поэтому дожидаемся выполнения всех событий и выставляем картетку принудительно
        setTimeout(function () {
          _this2.editor.scroll.selection.setRange({
            index: 0,
            length: 0
          });
        });
      } else if (processingBlots.length > 1 && (firstBlot.isText || firstBlot.constructor.isTextBlot)) {
        this.handleFirstTextLineDelete({
          processingBlots: processingBlots,
          firstBlot: firstBlot,
          lastBlot: lastBlot
        });
        processed = true;
      } else if (processingBlots.length === 1 && (firstBlot.isText || firstBlot.constructor.isTextBlot) && this.getBlotRange(firstBlot).index === firstBlot.length() - 1 && this.getBlotRange(firstBlot).length === 0) {
        processed = this.tryMergeLists(firstBlot);
        if (!processed) {
          processed = this.handleDeleteBeforeTextLine(firstBlot);
        }
        if (!processed && firstBlot.isEmpty()) {
          processed = this.tryHandleEmptyTextLineBeforeEmbeddable(firstBlot);
        }
      } else if (processingBlots.length === 1 && firstBlot.isEmbeddable && firstBlot.constructor.blotName !== 'table') {
        processed = this.deleteEmbedBlot(firstBlot);
      } else if (processingBlots.length > 1) {
        this.deleteBlotsWithTextLineCheck(processingBlots);
        processed = true;
      } else {
        return delete_get(delete_getPrototypeOf(DeleteAction.prototype), "exec", this).call(this, {
          processingBlots: processingBlots
        });
      }
      return processed;
    }
  }], [{
    key: "removeNewLinesFromDelta",
    value: function removeNewLinesFromDelta(delta) {
      return new (Delta_default())(delta.map(function (op) {
        if (op.insert && typeof op.insert === 'string') {
          op.insert = op.insert.replace(/\n/g, '');
        }
        return op;
      }).filter(function (op) {
        if (op.insert === '') {
          return false;
        }
        return true;
      }));
    }

    /**
     * Возвращает дельту которую надо применить на prevBlot чтобы получилось объединение текста
     * двух блотов: prevBlot.text + blot.text
     * @param  {Blot} blot     блот с которого берется текст
     * @param  {Blot} prevBlot блот в который вставляется текст
     * @return {Delta}          дельта которую надо применить на prevBlot чтобы получилось объединение текста блотов
     */
  }, {
    key: "getBlotDelta",
    value: function getBlotDelta(blot, prevBlot) {
      var blotDelta = new (Delta_default())().retain(prevBlot.length() - 1).concat(DeleteAction.removeNewLinesFromDelta(blot.delta()));
      var currentDelta = prevBlot.delta();
      var newDelta = currentDelta.compose(blotDelta);
      var delta = currentDelta.diff(newDelta);
      return delta;
    }
  }]);
  return DeleteAction;
}(Action);

DeleteAction.type = 'delete';
// EXTERNAL MODULE: ./node_modules/events/events.js
var events = __webpack_require__(94092);
var events_default = /*#__PURE__*/__webpack_require__.n(events);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/emitter.js
function emitter_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { emitter_typeof = function _typeof(obj) { return typeof obj; }; } else { emitter_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return emitter_typeof(obj); }













function emitter_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function emitter_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function emitter_createClass(Constructor, protoProps, staticProps) { if (protoProps) emitter_defineProperties(Constructor.prototype, protoProps); if (staticProps) emitter_defineProperties(Constructor, staticProps); return Constructor; }
function emitter_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { emitter_get = Reflect.get; } else { emitter_get = function _get(target, property, receiver) { var base = emitter_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return emitter_get(target, property, receiver || target); }
function emitter_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = emitter_getPrototypeOf(object); if (object === null) break; } return object; }
function emitter_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) emitter_setPrototypeOf(subClass, superClass); }
function emitter_setPrototypeOf(o, p) { emitter_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return emitter_setPrototypeOf(o, p); }
function emitter_createSuper(Derived) { var hasNativeReflectConstruct = emitter_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = emitter_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = emitter_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return emitter_possibleConstructorReturn(this, result); }; }
function emitter_possibleConstructorReturn(self, call) { if (call && (emitter_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return emitter_assertThisInitialized(self); }
function emitter_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function emitter_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function emitter_getPrototypeOf(o) { emitter_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return emitter_getPrototypeOf(o); }

var emitter_Emitter = /*#__PURE__*/function (_EventEmitter) {
  emitter_inherits(Emitter, _EventEmitter);
  var _super = emitter_createSuper(Emitter);
  function Emitter() {
    var _this;
    emitter_classCallCheck(this, Emitter);
    _this = _super.call(this);
    _this.listeners = {};
    return _this;
  }
  emitter_createClass(Emitter, [{
    key: "emit",
    value: function emit() {
      emitter_get(emitter_getPrototypeOf(Emitter.prototype), "emit", this).apply(this, arguments);
    }
  }, {
    key: "handleDOM",
    value: function handleDOM(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      (this.listeners[event.type] || []).forEach(function (_ref) {
        var node = _ref.node,
          handler = _ref.handler;
        if (event.target === node || node.contains(event.target)) {
          handler.apply(void 0, [event].concat(args));
        }
      });
    }
  }, {
    key: "listenDOM",
    value: function listenDOM(eventName, node, handler) {
      if (!this.listeners[eventName]) {
        this.listeners[eventName] = [];
      }
      this.listeners[eventName].push({
        node: node,
        handler: handler
      });
    }
  }]);
  return Emitter;
}((events_default()));
/* harmony default export */ const emitter = (emitter_Emitter);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__(29254);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/inline.js
function inline_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { inline_typeof = function _typeof(obj) { return typeof obj; }; } else { inline_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return inline_typeof(obj); }











function inline_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function inline_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function inline_createClass(Constructor, protoProps, staticProps) { if (protoProps) inline_defineProperties(Constructor.prototype, protoProps); if (staticProps) inline_defineProperties(Constructor, staticProps); return Constructor; }
function inline_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { inline_get = Reflect.get; } else { inline_get = function _get(target, property, receiver) { var base = inline_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return inline_get(target, property, receiver || target); }
function inline_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = inline_getPrototypeOf(object); if (object === null) break; } return object; }
function inline_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) inline_setPrototypeOf(subClass, superClass); }
function inline_setPrototypeOf(o, p) { inline_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return inline_setPrototypeOf(o, p); }
function inline_createSuper(Derived) { var hasNativeReflectConstruct = inline_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = inline_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = inline_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return inline_possibleConstructorReturn(this, result); }; }
function inline_possibleConstructorReturn(self, call) { if (call && (inline_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return inline_assertThisInitialized(self); }
function inline_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function inline_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function inline_getPrototypeOf(o) { inline_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return inline_getPrototypeOf(o); }




var Inline = /*#__PURE__*/function (_Parchment$Inline) {
  inline_inherits(Inline, _Parchment$Inline);
  var _super = inline_createSuper(Inline);
  function Inline() {
    inline_classCallCheck(this, Inline);
    return _super.apply(this, arguments);
  }
  inline_createClass(Inline, [{
    key: "formatAt",
    value: function formatAt(index, length, name, value) {
      if (Inline.compare(this.statics.blotName, name) < 0 && parchment_default().query(name, (parchment_default()).Scope.BLOT)) {
        var blot = this.isolate(index, length);
        if (value) {
          blot.wrap(name, value);
        }
      } else {
        inline_get(inline_getPrototypeOf(Inline.prototype), "formatAt", this).call(this, index, length, name, value);
      }
    }
  }, {
    key: "optimize",
    value: function optimize(context) {
      inline_get(inline_getPrototypeOf(Inline.prototype), "optimize", this).call(this, context);
      if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
        var parent = this.parent.isolate(this.offset(), this.length());
        this.moveChildren(parent);
        parent.wrap(this);
      }
    }
  }, {
    key: "getTextBase",
    value: function getTextBase() {
      if (this.parent instanceof textBase) return this.parent;
      return this.parent.getTextBase();
    }
  }], [{
    key: "compare",
    value: function compare(self, other) {
      var selfIndex = Inline.order.indexOf(self);
      var otherIndex = Inline.order.indexOf(other);
      if (selfIndex >= 0 || otherIndex >= 0) {
        return selfIndex - otherIndex;
      } else if (self === other) {
        return 0;
      } else if (self < other) {
        return -1;
      } else {
        return 1;
      }
    }
  }]);
  return Inline;
}((parchment_default()).Inline);
Inline.allowedChildren = [Inline, (parchment_default()).Embed, text_Text, Mention];
// Lower index means deeper in the DOM tree, since not found (-1) is for embeds
Inline.order = ['inline', 'comment', 'italic', 'bold', 'underline', 'strikethrough', 'color', 'link', 'background', 'code', 'placeholder'];
/* harmony default export */ const inline = (Inline);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/break.js
function break_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { break_typeof = function _typeof(obj) { return typeof obj; }; } else { break_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return break_typeof(obj); }











function break_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function break_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function break_createClass(Constructor, protoProps, staticProps) { if (protoProps) break_defineProperties(Constructor.prototype, protoProps); if (staticProps) break_defineProperties(Constructor, staticProps); return Constructor; }
function break_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { break_get = Reflect.get; } else { break_get = function _get(target, property, receiver) { var base = break_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return break_get(target, property, receiver || target); }
function break_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = break_getPrototypeOf(object); if (object === null) break; } return object; }
function break_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) break_setPrototypeOf(subClass, superClass); }
function break_setPrototypeOf(o, p) { break_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return break_setPrototypeOf(o, p); }
function break_createSuper(Derived) { var hasNativeReflectConstruct = break_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = break_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = break_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return break_possibleConstructorReturn(this, result); }; }
function break_possibleConstructorReturn(self, call) { if (call && (break_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return break_assertThisInitialized(self); }
function break_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function break_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function break_getPrototypeOf(o) { break_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return break_getPrototypeOf(o); }

var Break = /*#__PURE__*/function (_Parchment$Embed) {
  break_inherits(Break, _Parchment$Embed);
  var _super = break_createSuper(Break);
  function Break() {
    break_classCallCheck(this, Break);
    return _super.apply(this, arguments);
  }
  break_createClass(Break, [{
    key: "optimize",
    value: function optimize() {
      if (this.prev || this.next) {
        this.remove();
      }
    }
  }, {
    key: "insertInto",
    value: function insertInto(parent, ref) {
      if (parent.children.length === 0) {
        break_get(break_getPrototypeOf(Break.prototype), "insertInto", this).call(this, parent, ref);
      } else {
        this.remove();
      }
    }
  }, {
    key: "length",
    value: function length() {
      return 0;
    }
  }, {
    key: "value",
    value: function value() {
      return '';
    }
  }, {
    key: "toHTML",
    value: function toHTML() {
      return '<br/>';
    }
  }], [{
    key: "value",
    value: function value() {
      return undefined;
    }
  }]);
  return Break;
}((parchment_default()).Embed);
Break.blotName = 'break';
Break.tagName = 'BR';
/* harmony default export */ const blots_break = (Break);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/linebreak.js
function linebreak_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { linebreak_typeof = function _typeof(obj) { return typeof obj; }; } else { linebreak_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return linebreak_typeof(obj); }












function linebreak_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function linebreak_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function linebreak_createClass(Constructor, protoProps, staticProps) { if (protoProps) linebreak_defineProperties(Constructor.prototype, protoProps); if (staticProps) linebreak_defineProperties(Constructor, staticProps); return Constructor; }
function linebreak_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { linebreak_get = Reflect.get; } else { linebreak_get = function _get(target, property, receiver) { var base = linebreak_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return linebreak_get(target, property, receiver || target); }
function linebreak_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = linebreak_getPrototypeOf(object); if (object === null) break; } return object; }
function linebreak_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) linebreak_setPrototypeOf(subClass, superClass); }
function linebreak_setPrototypeOf(o, p) { linebreak_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return linebreak_setPrototypeOf(o, p); }
function linebreak_createSuper(Derived) { var hasNativeReflectConstruct = linebreak_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = linebreak_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = linebreak_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return linebreak_possibleConstructorReturn(this, result); }; }
function linebreak_possibleConstructorReturn(self, call) { if (call && (linebreak_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return linebreak_assertThisInitialized(self); }
function linebreak_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function linebreak_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function linebreak_getPrototypeOf(o) { linebreak_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return linebreak_getPrototypeOf(o); }

var Linebreak = /*#__PURE__*/function (_Parchment$Embed) {
  linebreak_inherits(Linebreak, _Parchment$Embed);
  var _super = linebreak_createSuper(Linebreak);
  function Linebreak(node, value) {
    var _this;
    linebreak_classCallCheck(this, Linebreak);
    _this = _super.call(this, node, value);
    if (value === 's') {
      node.classList.add('separator');
    }
    return _this;
  }
  linebreak_createClass(Linebreak, [{
    key: "length",
    value: function length() {
      if (this.domNode.classList.contains('separator')) {
        return 1;
      }
      return 0;
    }
  }, {
    key: "optimize",
    value: function optimize() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = linebreak_get(linebreak_getPrototypeOf(Linebreak.prototype), "optimize", this)).call.apply(_get2, [this].concat(args));
      if (this.value().linebreak === 'h') {
        if (this.next) {
          this.remove();
        }
      }
    }
  }], [{
    key: "value",
    value: function value(node) {
      if (node.classList.contains('separator')) {
        return 's';
      }
      return 'h';
    }
  }, {
    key: "getOpText",
    value: function getOpText(op) {
      return '\n';
    }
  }]);
  return Linebreak;
}((parchment_default()).Embed);
Linebreak.blotName = 'linebreak';
Linebreak.tagName = 'BR';
/* harmony default export */ const linebreak = (Linebreak);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.repeat.js
var es_string_repeat = __webpack_require__(83714);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/util/browser.js
var browser = __webpack_require__(12650);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/text.js

function text_slicedToArray(arr, i) { return text_arrayWithHoles(arr) || text_iterableToArrayLimit(arr, i) || text_unsupportedIterableToArray(arr, i) || text_nonIterableRest(); }
function text_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function text_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function text_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function text_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function text_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { text_ownKeys(Object(source), true).forEach(function (key) { text_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { text_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function text_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function util_text_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { util_text_typeof = function _typeof(obj) { return typeof obj; }; } else { util_text_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return util_text_typeof(obj); }
function text_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = text_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function text_toConsumableArray(arr) { return text_arrayWithoutHoles(arr) || text_iterableToArray(arr) || text_unsupportedIterableToArray(arr) || text_nonIterableSpread(); }
function text_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function text_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return text_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return text_arrayLikeToArray(o, minLen); }
function text_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function text_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return text_arrayLikeToArray(arr); }
function text_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function text_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function text_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { text_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { text_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }






























function escapeHtml(text) {
  return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}

// добавил отдельно, т.к. в документации написано что String.prototype.trimEnd() и trimRight()
// не являются стандартами и могут работать не везде
function stringTrimEnd() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return string.replace(/[\s\uFEFF\xA0]+$/g, '');
}
function addLinkAction(_x) {
  return _addLinkAction.apply(this, arguments);
}
function _addLinkAction() {
  _addLinkAction = text_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(editor) {
    var params,
      addAction,
      editAction,
      scroll,
      selection,
      _selection$getRange,
      _selection$getRange2,
      range,
      processMoreBlots,
      blot,
      editing,
      textBlots,
      blotRange,
      _blot$descendant,
      _blot$descendant2,
      link,
      nbsp,
      nbspLength,
      _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            params = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            addAction = _args.length > 2 && _args[2] !== undefined ? _args[2] : 'addLink';
            editAction = _args.length > 3 && _args[3] !== undefined ? _args[3] : 'editLink';
            scroll = editor.scroll, selection = scroll.selection;
            selection.focus();
            _selection$getRange = selection.getRange(), _selection$getRange2 = text_slicedToArray(_selection$getRange, 1), range = _selection$getRange2[0];
            if (!range) {
              selection.setRange(selection.savedRange);
              range = selection.getRange()[0];
            }
            processMoreBlots = function processMoreBlots() {
              var blots = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
              var getTextBlots = function getTextBlots(blocks) {
                return blocks.filter(function (block) {
                  return block instanceof textBase;
                });
              };
              if (!blots.length) {
                blots = scroll.selectedBlocks;
              }
              var blotsNotBlocked = blots.filter(function (item) {
                return !item.isBlotLocked;
              });
              var blotsToExec = getTextBlots(blotsNotBlocked);
              var blotRangeCache = {};
              var _iterator6 = text_createForOfIteratorHelper(blotsToExec),
                _step6;
              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  var _blot = _step6.value;
                  if (!blotRangeCache[_blot.id]) {
                    blotRangeCache[_blot.id] = scroll.selection.getRange({
                      offsetBlot: _blot
                    })[0];
                  }
                }
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }
              var link = null;
              var _iterator7 = text_createForOfIteratorHelper(blotsToExec),
                _step7;
              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  var _blot2 = _step7.value;
                  var blotLinkUrl = _blot2.getFormat(blotRangeCache[_blot2.id].index, blotRangeCache[_blot2.id].length).link;
                  if (!blotLinkUrl) break;
                  if (!link && blotLinkUrl) {
                    link = blotLinkUrl;
                  } else if (link && blotLinkUrl !== link) {
                    link = null;
                    break;
                  }
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }
              params = Object.assign({}, params, {
                range: range,
                linkUrl: link,
                singleBlock: false,
                execBlots: blotsToExec,
                cache: {
                  blotRange: blotRangeCache
                }
              });
              editor.plugins.popupManager[addAction](params);
            };
            if (!(scroll.selectedBlocks.length > 1)) {
              _context.next = 11;
              break;
            }
            processMoreBlots();
            return _context.abrupt("return");
          case 11:
            blot = scroll.selectedBlocks[0];
            if (blot instanceof table_table) {
              editing = blot.getEditing();
              if (editing) {
                blot = editing.blot;
              }
            }
            if (blot instanceof textBase) {
              _context.next = 20;
              break;
            }
            if (blot.hasTextLine) {
              _context.next = 18;
              break;
            }
            return _context.abrupt("return");
          case 18:
            textBlots = blot.getChildrenForAction();
            if (textBlots.length > 1) {
              processMoreBlots(textBlots);
            } else {
              blot = textBlots[0];
            }
          case 20:
            blotRange = scroll.selection.getRange({
              offsetBlot: blot
            })[0];
            params = Object.assign({}, params, {
              id: blot.id,
              execBlots: [blot],
              singleBlock: true,
              range: range,
              blotRange: blotRange,
              text: blot.getText(blotRange.index, blotRange.length),
              formats: blot.getFormat(blotRange.index, blotRange.length !== 0 ? blotRange.length : 1)
            });
            if (params.formats.link && addAction === 'addLink') {
              _blot$descendant = blot.descendant(src_parchment.query('link'), params.blotRange.index), _blot$descendant2 = text_slicedToArray(_blot$descendant, 1), link = _blot$descendant2[0];
              editor.plugins.popupManager[editAction](link);
            } else {
              if (addAction === 'addButton') {
                nbsp = params.text.match(/^[\s]{1,}/);
                nbspLength = nbsp && nbsp[0].length || 0; // получаем формат первого символа не учитывая пробелы в начале
                params.formats = blot.getFormat(params.blotRange.index + nbspLength, 1);
                params.singleBlock = false;
              }
              editor.plugins.popupManager[addAction](params);
            }
          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _addLinkAction.apply(this, arguments);
}
function bubbleFormats(blot) {
  var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (blot == null) return formats;
  // если блот является блоком и не является текстом, значит выже уже не будет текстовых блоков и формат определять на них не надо
  if (blot instanceof src_parchment.Block && !(blot instanceof textBase)) {
    return formats;
  }
  if (typeof blot.formats === 'function') {
    formats = extend_default()(formats, blot.formats());
  }
  // не уходим дальше текстовых блотов
  if (blot instanceof textBase) {
    return formats;
  }
  if (blot.parent == null || blot.parent.blotName == 'scroll' || blot.parent.statics.scope !== blot.statics.scope) {
    return formats;
  }
  return bubbleFormats(blot.parent, formats);
}
function combineFormats(formats, combined) {
  return Object.keys(combined).reduce(function (merged, name) {
    if (formats[name] == null) return merged;
    if (combined[name] === formats[name]) {
      merged[name] = combined[name];
    } else if (Array.isArray(combined[name])) {
      if (combined[name].indexOf(formats[name]) < 0) {
        merged[name] = combined[name].concat([formats[name]]);
      }
    } else {
      merged[name] = [combined[name], formats[name]];
    }
    return merged;
  }, {});
}

/**
 * нормализация дельты
 * @param  {Delta} delta
 * @param  {Object} opts
 * @param  {Boolean} opts.trimNewLines - убирает из дельты символы \n и \r
 * @return {Delta} новая нормализованная дельа
 */
function normalizeDelta(delta) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return delta.reduce(function (delta, op) {
    if (op.insert === 1) {
      var attributes = clone(op.attributes);
      delete attributes['image'];
      return delta.insert({
        image: op.attributes.image
      }, attributes);
    }
    if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
      op = clone(op);
      if (op.attributes.list) {
        op.attributes.list = 'ordered';
      } else {
        op.attributes.list = 'bullet';
        delete op.attributes.bullet;
      }
    }
    if (typeof op.insert === 'string') {
      var text = op.insert;
      if (opts.trimNewLines) {
        text = text.replace(/[\r\n]/g, '');
      } else {
        text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
      }
      return delta.insert(text, op.attributes);
    }
    return delta.push(op);
  }, new (Delta_default())());
}
function mergeDeltas(deltas) {
  var ops = [];
  if (!deltas.length) {
    return {
      ops: ops
    };
  }
  for (var i = 0; i < deltas.length - 1; i++) {
    var delta = deltas[i];
    var deltaOps = delta.ops.map(function (op) {
      return Object.assign({}, op);
    });
    var lastOpIndex = deltaOps.length - 1;
    if (deltaOps[lastOpIndex] === '\n') {
      deltaOps.pop();
    } else {
      deltaOps[lastOpIndex].insert = deltaOps[lastOpIndex].insert.replace(/\n$/, '');
    }
    if (!deltaOps.length) {
      continue;
    }
    ops.push.apply(ops, text_toConsumableArray(deltaOps));
  }
  ops.push.apply(ops, text_toConsumableArray(deltas[deltas.length - 1].ops));
  return {
    ops: ops
  };
}

/**
 * удаляет аттрибуты(форматирование) у текста и оставляет только linebreak эмебеды
 * @param opts.removeNewLines - удалять ли символы \n из строк в результирующей дельте
 */
function toRawTextDelta(delta) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var newDelta = new (Delta_default())();
  var _iterator = text_createForOfIteratorHelper(delta.ops),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var op = _step.value;
      if (op.insert && typeof op.insert === 'string') {
        if (opts.removeNewLines) {
          op.insert = op.insert.replace(/\n/g, '');
        }
        newDelta = newDelta.insert(op.insert);
      } else if (op.insert && op.insert.linebreak === 's') {
        newDelta = newDelta.insert(op.insert);
      } else if (op.insert && op.insert.hasOwnProperty('progress')) {
        newDelta = newDelta.insert(' ' + op.insert.progress + '%');
      } else if (op.insert && op.insert.hasOwnProperty('dropdown-list')) {
        var DropdownBlotClass = src_parchment.query('dropdown-list');
        var value = DropdownBlotClass.getOpText(op.insert);
        newDelta = newDelta.insert(' ' + value + ' ');
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return newDelta;
}
function onConvertBlotPrepareDelta(delta) {
  return delta.reduce(function (delta, op) {
    if (util_text_typeof(op.insert) === 'object') {
      var BlotClass = src_parchment.query(Object.keys(op.insert)[0]);
      if (BlotClass && BlotClass.onConvertBlotGetOp) {
        var blotOp = BlotClass.onConvertBlotGetOp(op);
        return delta.push(blotOp);
      }
    }
    return delta.push(op);
  }, new (Delta_default())());
}

/**
 * проверяет имеет ли дельта в конце символ \n, если нет, то добавляет его. Меняет дельту на месте
 * @param  {Delta} delta]
 * @return {Delta}       delta, которая на входе
 */
function ensureDeltaEndsWithNewLine(delta) {
  if (!delta.ops.length) {
    delta.ops.push({
      insert: '\n'
    });
    return delta;
  }
  var lastOp = delta.ops[delta.ops.length - 1];
  if (typeof lastOp.insert === 'string') {
    if (!/\n$/.test(lastOp.insert)) {
      lastOp.insert += '\n';
    }
  } else {
    delta.ops.push({
      insert: '\n'
    });
  }
  return delta;
}

/**
 * Преобразует массив в объект дельты
 * @param {Array<{insert: string}>} ops
 * @return {Delta}
 */
function arrToDelta(ops) {
  if (!ops.length) {
    return {
      ops: [{
        insert: '\n'
      }]
    };
  }
  if (typeof ops[ops.length - 1].insert !== 'string') {
    // добавлеяем новую строку в конце дельты
    ops.push({
      insert: '\n'
    });
  } else {
    // надо исправить последнюю операцию чтоб в конце был \n
    ops[ops.length - 1].insert = ops[ops.length - 1].insert.replace(/\s$/, '\n');
  }
  return {
    ops: ops
  };
}

/**
 * убирает пробелы в начале и конце дельты, также убирает пробелы идущие друг за другом, оставляя только один
 * @param  {Delta} delta
 * @return {Delta} обработанная дельта
 */
function trimSpaces(delta) {
  var ops = [];
  var prevSpace = true;
  if (!delta.ops.length) {
    return delta;
  }
  var _iterator2 = text_createForOfIteratorHelper(delta.ops),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var op = _step2.value;
      op = Object.assign({}, op);
      if (typeof op.insert === 'string') {
        if (prevSpace) {
          // предыдущий символ - пробел, удаляем все пробелы в начале строки
          op.insert = op.insert.replace(/^\s+/, '');
        }
        // заменяем повторяющиеся пробелы на один пробел
        op.insert = op.insert.replace(/\s+/g, ' ');
        if (!op.insert.length) {
          // игнорируем пустые строки
          continue;
        }
        if (/\s$/.test(op.insert)) {
          prevSpace = true;
        } else {
          prevSpace = false;
        }
      } else {
        if (util_text_typeof(op.insert) === 'object' && op.insert.date) {
          // Если элемент является датой
          prevSpace = false;
        }
      }
      ops.push(op);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return arrToDelta(ops);
}

/**
 * Удаляет первый и последний пробелы после вставки в Windows
 * Так как в OS Windows в конце и начале строки добавляются дополнительне пробелы
 * @param {Delta} delta
 * @param {Boolean} skipOs пропустить проверку OS
 * @return {Delta}
 */
function trimSpacesWin(delta) {
  var skipOs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var ops = [];
  var isOsWin = (0,browser/* detectPlatform */.tz)() === 'Windows' || skipOs;
  if (!delta.ops.length || !isOsWin) {
    return delta;
  }
  // тут нужно расматривать дельту не как операцию вставки одной строки, а именно как набор операций,
  // винда пробелы добавляет именно в начале и конце всей строки, это нужно учитывать, потому что между этими пробелами, может быть не одна операция,
  // поэтому обрабатывать нужно первую и последнюю операции
  for (var i = 0; i < delta.ops.length; i++) {
    var op = Object.assign({}, delta.ops[i]);
    if (typeof op.insert === 'string') {
      // удаляем первый пробел в начале строки
      if (i === 0) {
        op.insert = op.insert.replace(/^[\s]{1}/, '');
      }
      // удаляем последние два пробела в конце строки
      if (i === delta.ops.length - 1) {
        op.insert = op.insert.replace(/[\s]{2}\n$/, '\n');
      }
      if (!op.insert.length) {
        // игнорируем пустые строки
        continue;
      }
    }
    ops.push(op);
  }
  return arrToDelta(ops);
}

/**
 * заменяет табы в начале строк на пробелы
 * @param opts.spacesInTab - число пробелов в табе, по умолчанию 2
 */
function tabToSpaceDelta(delta) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!opts.spacesInTab) {
    opts.spacesInTab = 2;
  }
  var spaces = ' '.repeat(opts.spacesInTab);
  var newDelta = new Delta();
  var _iterator3 = text_createForOfIteratorHelper(delta.ops),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var op = _step3.value;
      if (op.insert && typeof op.insert === 'string') {
        op.insert = op.insert.replace(/\t/g, spaces);
        newDelta = newDelta.insert(op.insert);
      } else if (op.insert) {
        newDelta = newDelta.insert(op.insert);
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return newDelta;
}
function matchAny(text, substrings) {
  text = text.toLowerCase();
  var _iterator4 = text_createForOfIteratorHelper(substrings),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var substring = _step4.value;
      if (text.indexOf(substring) >= 0) {
        return true;
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return false;
}
function deltaToString(delta) {
  var source;
  if (delta.ops) {
    source = delta.ops;
  } else {
    source = delta;
  }
  var text = source.reduce(function (text, op) {
    if (op.insert) {
      if (typeof op.insert === 'string') {
        text += ' ' + op.insert.trim();
      } else {
        if ('linebreak' in op.insert) {
          text += '\n';
        } else {
          text += '';
        }
      }
    }
    return text;
  }, '');
  text = text.trim();
  return text;
}
function getDeltaInsertOps(delta) {
  return delta.filter(function (op) {
    return op.insert;
  });
}

/**
 * Применяет аттрибуты форматирования текста ко всей дельте
 * @param { delta } delta
 * @param { object } format: Формат, напр: {bold: true, color: 'orange'}
 * @param { object } options?
 * @param { boolean } options.diff: В случае true возвращает diff c исходной дельтой, false возвращает чистую новую дельту
 * @returns { delta } Новая дельта или diff новой и старой дельты в зависимости от options.diff
 */
function applyFormatToDelta(delta) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var oldDelta = new (Delta_default())(delta);
  var newDelta = oldDelta.ops.reduce(function (curDelta, oldOp, i) {
    var op = Object.assign({}, oldOp);
    if (typeof op.insert === 'string' && (i === 0 || op.insert !== '\n')) {
      var attributes = Object.assign({}, op.attributes || {});
      for (var attr in format) {
        attributes[attr] = format[attr] || null;
      }
      if (Object.keys(attributes).length) {
        op.attributes = attributes;
      } else if (op.hasOwnProperty('attributes')) {
        delete op.attributes;
      }
    }
    return curDelta.push(op);
  }, new (Delta_default())());
  //console.info('old', oldDelta, 'new', newDelta, 'diff', oldDelta.diff(newDelta))
  if (options.diff) {
    return oldDelta.diff(newDelta);
  } else {
    return newDelta;
  }
}

/**
 * Возвращает diff для безопасного применения или удаления атрибута через characters.applyDelta
 * @param { Delta } curDelta: текущая дельта
 * @param { number } index: индекс для атрибута
 * @param { number } length: длина атрибута
 * @param { string } name: имя атрибута
 * @param { any } value: значение атрибута
 * @returns { Delta } Дельта для применения к исходной через applyDelta
 */
function diffToApplyAttribute(curDelta, index, length, name) {
  var value = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var tail = new (Delta_default())(curDelta).slice(index + length);
  // Продлеваем retain до ближайшего перекрывающего атрибута или его отсутствия, либо до конца дельты
  // Это позволяет избежать формирования неправильной дельты при characters.applyDelta
  var retain = length;
  var _iterator5 = text_createForOfIteratorHelper(tail.ops),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var _op$attributes, _op$attributes2;
      var op = _step5.value;
      if (!value && (_op$attributes = op.attributes) !== null && _op$attributes !== void 0 && _op$attributes[name] || value && value !== ((_op$attributes2 = op.attributes) === null || _op$attributes2 === void 0 ? void 0 : _op$attributes2[name])) {
        break;
      } else if (op.insert) {
        retain += op.insert.length;
      }
    }
    // Если value=false то меняем его на null, т.к. по спецификации delta для удаления атрибута нужно установить null
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
  var attributes = text_defineProperty({}, name, value || null);
  var delta = new (Delta_default())().retain(index).retain(retain, text_objectSpread({}, attributes));
  return delta;
}
function decodeHtmlEntities(string) {
  var txt = document.createElement('textarea');
  txt.innerHTML = string;
  var result = txt.value;
  txt.remove();
  return result;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/cursor.js
function cursor_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { cursor_typeof = function _typeof(obj) { return typeof obj; }; } else { cursor_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return cursor_typeof(obj); }

















function cursor_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function cursor_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function cursor_createClass(Constructor, protoProps, staticProps) { if (protoProps) cursor_defineProperties(Constructor.prototype, protoProps); if (staticProps) cursor_defineProperties(Constructor, staticProps); return Constructor; }
function cursor_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { cursor_get = Reflect.get; } else { cursor_get = function _get(target, property, receiver) { var base = cursor_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return cursor_get(target, property, receiver || target); }
function cursor_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = cursor_getPrototypeOf(object); if (object === null) break; } return object; }
function cursor_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) cursor_setPrototypeOf(subClass, superClass); }
function cursor_setPrototypeOf(o, p) { cursor_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return cursor_setPrototypeOf(o, p); }
function cursor_createSuper(Derived) { var hasNativeReflectConstruct = cursor_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = cursor_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = cursor_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return cursor_possibleConstructorReturn(this, result); }; }
function cursor_possibleConstructorReturn(self, call) { if (call && (cursor_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return cursor_assertThisInitialized(self); }
function cursor_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function cursor_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function cursor_getPrototypeOf(o) { cursor_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return cursor_getPrototypeOf(o); }




var Cursor = /*#__PURE__*/function (_Parchment$Embed) {
  cursor_inherits(Cursor, _Parchment$Embed);
  var _super = cursor_createSuper(Cursor);
  function Cursor(domNode, selection) {
    var _this;
    cursor_classCallCheck(this, Cursor);
    _this = _super.call(this, domNode);
    _this.selection = selection;
    _this.textNode = document.createTextNode(Cursor.CONTENTS);
    _this.domNode.appendChild(_this.textNode);
    _this._length = 0;
    _this.isSeparableByClickApplicable = true;
    return _this;
  }
  cursor_createClass(Cursor, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = cursor_get(cursor_getPrototypeOf(Cursor.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      this.isCursorAttached = true;
    }
  }, {
    key: "detach",
    value: function detach() {
      this.isCursorAttached = false;
      if (this.parent != null) this.parent.removeChild(this);
    }
  }, {
    key: "format",
    value: function format(name, value) {
      if (this._length !== 0) {
        return cursor_get(cursor_getPrototypeOf(Cursor.prototype), "format", this).call(this, name, value);
      }
      var target = this,
        index = 0;
      while (target != null && target.statics.scope !== (parchment_default()).Scope.BLOCK_BLOT) {
        index += target.offset(target.parent);
        target = target.parent;
      }
      if (target != null) {
        this._length = Cursor.CONTENTS.length;
        target.optimize();
        target.formatAt(index, Cursor.CONTENTS.length, name, value);
        this._length = 0;
      }
    }
  }, {
    key: "index",
    value: function index(node, offset) {
      if (node === this.textNode) return 0;
      return cursor_get(cursor_getPrototypeOf(Cursor.prototype), "index", this).call(this, node, offset);
    }
  }, {
    key: "length",
    value: function length() {
      return this._length;
    }
  }, {
    key: "position",
    value: function position() {
      return [this.textNode, this.textNode.data.length];
    }
  }, {
    key: "remove",
    value: function remove() {
      cursor_get(cursor_getPrototypeOf(Cursor.prototype), "remove", this).call(this);
      this.parent = null;
    }
  }, {
    key: "restore",
    value: function restore() {
      if (this.parent == null) return null;
      var range = this.selection.getNativeRange();
      while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {
        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
      }
      var prevTextBlot = this.prev instanceof text_Text ? this.prev : null;
      var prevTextLength = prevTextBlot ? prevTextBlot.length() : 0;
      var nextTextBlot = this.next instanceof text_Text ? this.next : null;
      var nextText = nextTextBlot ? nextTextBlot.text : '';
      var textNode = this.textNode;
      var newText = textNode.data.split(Cursor.CONTENTS).join('');
      textNode.data = Cursor.CONTENTS;
      var mergedTextBlot;
      if (prevTextBlot) {
        mergedTextBlot = prevTextBlot;
        if (newText || nextTextBlot) {
          prevTextBlot.insertAt(prevTextBlot.length(), newText + nextText);
          if (nextTextBlot) {
            nextTextBlot.remove();
          }
        }
      } else if (nextTextBlot) {
        mergedTextBlot = nextTextBlot;
        nextTextBlot.insertAt(0, newText);
      } else {
        var newTextNode = document.createTextNode(newText);
        mergedTextBlot = parchment_default().create(newTextNode);
        this.parent.insertBefore(mergedTextBlot, this);
      }
      this.remove();
      if (range) {
        var remapOffset = function remapOffset(node, offset) {
          if (prevTextBlot && node === prevTextBlot.domNode) {
            return offset;
          }
          if (node === textNode) {
            return prevTextLength + offset - 1;
          }
          if (nextTextBlot && node === nextTextBlot.domNode) {
            return prevTextLength + newText.length + offset;
          }
          return null;
        };
        var start = remapOffset(range.start.node, range.start.offset);
        var end = remapOffset(range.end.node, range.end.offset);
        if (start !== null && end !== null) {
          return {
            startNode: mergedTextBlot.domNode,
            startOffset: start,
            endNode: mergedTextBlot.domNode,
            endOffset: end
          };
        }
      }
      return null;
    }
  }, {
    key: "getFormat",
    value: function getFormat() {
      var leaves = [];
      var parent = this.parent;
      while (!parent.map) {
        leaves.push(parent);
        parent = parent.parent;
      }
      var formatsArr = [leaves].map(function (blots) {
        if (blots.length === 0) return {};
        var formats = bubbleFormats(blots.shift());
        while (Object.keys(formats).length > 0) {
          var blot = blots.shift();
          if (blot === null) return formats;
          formats = combineFormats(bubbleFormats(blot), formats);
        }
        return formats;
      });
      return extend_default().apply((extend_default()), formatsArr);
    }
  }, {
    key: "update",
    value: function update(mutations, context) {
      var _this2 = this;
      if (mutations.some(function (mutation) {
        return mutation.type === 'characterData' && mutation.target === _this2.textNode;
      })) {
        var range = this.restore();
        if (range) this.selection.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
      }
    }
  }, {
    key: "value",
    value: function value() {
      return '';
    }
  }], [{
    key: "value",
    value: function value() {
      return undefined;
    }
  }]);
  return Cursor;
}((parchment_default()).Embed);
Cursor.blotName = 'cursor';
Cursor.className = 'note-cursor';
Cursor.tagName = 'span';
Cursor.CONTENTS = "\uFEFF"; // Zero width no break space

/* harmony default export */ const cursor = (Cursor);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.sub.js
var es_string_sub = __webpack_require__(60086);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/date/dateActions.js
function dateActions_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { dateActions_typeof = function _typeof(obj) { return typeof obj; }; } else { dateActions_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return dateActions_typeof(obj); }
function dateActions_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = dateActions_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function dateActions_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return dateActions_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return dateActions_arrayLikeToArray(o, minLen); }
function dateActions_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

















function dateActions_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function dateActions_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function dateActions_createClass(Constructor, protoProps, staticProps) { if (protoProps) dateActions_defineProperties(Constructor.prototype, protoProps); if (staticProps) dateActions_defineProperties(Constructor, staticProps); return Constructor; }
function dateActions_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) dateActions_setPrototypeOf(subClass, superClass); }
function dateActions_setPrototypeOf(o, p) { dateActions_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return dateActions_setPrototypeOf(o, p); }
function dateActions_createSuper(Derived) { var hasNativeReflectConstruct = dateActions_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = dateActions_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = dateActions_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return dateActions_possibleConstructorReturn(this, result); }; }
function dateActions_possibleConstructorReturn(self, call) { if (call && (dateActions_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return dateActions_assertThisInitialized(self); }
function dateActions_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function dateActions_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function dateActions_getPrototypeOf(o) { dateActions_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return dateActions_getPrototypeOf(o); }
function dateActions_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var DateActions = function DateActions(superclass) {
  return /*#__PURE__*/function (_superclass) {
    dateActions_inherits(_class2, _superclass);
    var _super = dateActions_createSuper(_class2);
    function _class2() {
      var _this;
      dateActions_classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      dateActions_defineProperty(dateActions_assertThisInitialized(_this), "removeReminders", function (ids) {
        var reminders = _this.getItem('reminders');
        var val = {};
        for (var id in reminders) {
          if (!ids.includes(id)) {
            val[id] = reminders[id];
          }
        }
        _this.setItem('reminders', val);
      });
      _this.returnDateString = null;
      return _this;
    }
    dateActions_createClass(_class2, [{
      key: "getDateId",
      value: function getDateId(setId) {
        var dateId = this.getItem('dateId') || null;
        if (!dateId && setId) {
          dateId = this.createDateId();
        }
        return dateId;
      }
    }, {
      key: "createDateId",
      value: function createDateId() {
        var dateId = generateId();
        this.setItem('dateId', dateId);
        return dateId;
      }
    }, {
      key: "setReturnDateString",
      value: function setReturnDateString(func) {
        if (func) {
          this.returnDateString = func;
        }
      }
    }, {
      key: "setReturnDateComponent",
      value: function setReturnDateComponent(func) {
        if (func) {
          this.returnDateComponent = func;
        }
      }
    }, {
      key: "setValue",
      value: function setValue(timestamp) {
        if (timestamp) {
          this.setItem('timestamp', timestamp);
        } else {
          this.removeItem('timestamp');
          this.removeItem('reminders');
          this.removeItem('alerts');
        }
        this.setAlertsPending();
        this.render && this.render();
      }
    }, {
      key: "updateFormat",
      value: function updateFormat(format) {
        for (var key in format) {
          this.setItem(key, format[key], {
            sub: 'format'
          });
        }
        this.render(); // для того чтобы изменения в датапикере отображались синхронно
      }
    }, {
      key: "getReminders",
      value: function getReminders() {
        var reminders = this.getItem('reminders') || {};
        return reminders;
      }
    }, {
      key: "setReminder",
      value: function setReminder(reminderId, data) {
        var reminders = this.getReminders();
        if (data === 'none' || data.value === 'none') {
          delete reminders[reminderId];
        } else {
          reminders[reminderId] = data;
        }
        this.setReminders(reminders);
      }
    }, {
      key: "setReminders",
      value: function setReminders(reminders) {
        if (reminders) {
          this.setItem('reminders', reminders);
        } else {
          this.removeItem('reminders');
        }
        this.setAlertsPending();
      }

      /**
       * Удаляет ремайндеры
       * @param ids: Array<String>
       */
    }, {
      key: "getAlerts",
      value: function getAlerts() {
        var alerts = this.getItem('alerts');
        return alerts && alerts.length ? alerts : null;
      }
    }, {
      key: "setAlertsPending",
      value: function setAlertsPending() {
        this.needSetAlerts = true;
      }
    }, {
      key: "setAlerts",
      value: function setAlerts() {
        var _this$scroll$editor$p = this.scroll.editor.plugins,
          reminderManager = _this$scroll$editor$p.reminderManager,
          i18n = _this$scroll$editor$p.i18n;
        this.needSetAlerts = false;
        var reminders = this.getReminders();
        var alerts = Object.keys(reminders).reduce(function (result, value) {
          var seconds = reminders[value].seconds;
          if (result.indexOf(seconds) === -1) {
            result.push(seconds);
          }
          return result;
        }, []);
        if (alerts.length) {
          alerts.sort(function (a, b) {
            return a > b ? 1 : -1;
          });
        } else {
          alerts = null;
        }
        if (alerts) {
          this.setItem('alerts', alerts);
          var title = i18n.get('calendar.ui.reminder.push_name');
          var dateId = this.getDateId(true);
          var timestamp = this.getValue();
          var date = this.getText();
          var bodies = {};
          var _iterator = dateActions_createForOfIteratorHelper(alerts),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var seconds = _step.value;
              bodies[seconds] = this.getAlertText(seconds);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          reminderManager.setReminder(dateId, {
            timestamp: timestamp,
            alerts: alerts,
            date: date,
            title: title,
            bodies: bodies,
            reminders: reminders
          });
        } else {
          this.deleteAlerts();
        }
      }
    }, {
      key: "deleteAlerts",
      value: function deleteAlerts() {
        var reminderManager = this.scroll.editor.plugins.reminderManager;
        var dateId = this.getDateId(true);
        var alerts = this.getAlerts();
        if (!alerts) {
          return;
        }
        reminderManager.deleteReminder(dateId);
      }
    }, {
      key: "getValue",
      value: function getValue() {
        var timestamp = this.getItem('timestamp');
        return parseInt(timestamp) || null;
      }
    }, {
      key: "getAlertText",
      value: function getAlertText(seconds) {
        var text;
        if (this.reminderTimeToString) {
          text = this.reminderTimeToString(seconds);
        } else {
          text = "".concat(seconds, "s");
        }
        return text;
      }
    }, {
      key: "getText",
      value: function getText() {
        var text;
        if (this.returnDateString) {
          text = this.returnDateString();
        } else {
          text = String(this.getValue());
        }
        return text;
      }
    }, {
      key: "getComponent",
      value: function getComponent() {
        var component;
        if (this.returnDateComponent) {
          component = this.returnDateComponent();
        } else {
          component = (0,preact_module.h)("span", null, this.getText());
        }
        return component;
      }
    }, {
      key: "dateConfig",
      get: function get() {
        var config = this.scroll.editor.blotsConfig['date'];
        return config || {};
      }
    }, {
      key: "reminderTimeToString",
      value: function reminderTimeToString(seconds) {
        var editor = this.scroll.editor;
        var i18n = editor.plugins.i18n;
        var str;
        if (seconds < 0) {
          str = i18n.get('calendar.ui.reminder.until.already_been');
        } else if (seconds === 0) {
          str = i18n.get('calendar.ui.reminder.until.now');
        } else if (seconds <= 60) {
          str = i18n.get('calendar.ui.reminder.until.less_minute');
        } else {
          str = i18n.get('calendar.ui.reminder.until.in');
          var oneMin = 60;
          var oneHour = 60 * oneMin;
          var oneDay = 24 * oneHour;
          var days = Math.floor(seconds / oneDay);
          var hours = Math.floor(seconds % oneDay / oneHour);
          var mins = Math.round(seconds % oneHour / oneMin);
          if (days > 0) {
            str += ' ' + days + i18n.get('calendar.ui.reminder.until.d');
          }
          if (hours > 0 || days > 0 && mins > 0) {
            str += ' ' + hours + i18n.get('calendar.ui.reminder.until.h');
          }
          if (mins > 0) {
            str += ' ' + mins + i18n.get('calendar.ui.reminder.until.m');
          }
        }
        return str;
      }
    }]);
    return _class2;
  }(superclass);
};
/* harmony default export */ const dateActions = (DateActions);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/key.js

var IS_MAC = typeof window != 'undefined' && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);
var modModifier = IS_MAC ? 'metaKey' : 'ctrlKey';
var modKeyProperty = (0,lib/* toKeyName */.rs)('mod') + 'Key';
function isModKeyPressed(event) {
  return event[modModifier];
}
function isShiftKeyPressed(event) {
  return event.shiftKey;
}
function isOptionKeyPressed(event) {
  return event && event.altKey;
}
function isLeftMouseButtonPressed(event) {
  if (event.button === 0) {
    // для мака нажатие левой кнопкой + ctrl считаем за нажатие правой кнопкой
    if (!IS_MAC || !event.ctrlKey) {
      return true;
    }
  }
  return false;
}
function isRightMouseButtonPressed(event) {
  if (event.button === 2) {
    return true;
  }
  if (IS_MAC && event.ctrlKey && event.button === 0) {
    // для мака нажатие левой кнопкой + ctrl считаем за нажатие правой кнопкой
    return true;
  }
  return false;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/date/date.js
function date_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { date_typeof = function _typeof(obj) { return typeof obj; }; } else { date_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return date_typeof(obj); }






















function date_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = date_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function date_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return date_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return date_arrayLikeToArray(o, minLen); }
function date_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function date_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function date_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function date_createClass(Constructor, protoProps, staticProps) { if (protoProps) date_defineProperties(Constructor.prototype, protoProps); if (staticProps) date_defineProperties(Constructor, staticProps); return Constructor; }
function date_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) date_setPrototypeOf(subClass, superClass); }
function date_setPrototypeOf(o, p) { date_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return date_setPrototypeOf(o, p); }
function date_createSuper(Derived) { var hasNativeReflectConstruct = date_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = date_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = date_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return date_possibleConstructorReturn(this, result); }; }
function date_possibleConstructorReturn(self, call) { if (call && (date_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return date_assertThisInitialized(self); }
function date_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function date_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function date_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { date_get = Reflect.get; } else { date_get = function _get(target, property, receiver) { var base = date_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return date_get(target, property, receiver || target); }
function date_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = date_getPrototypeOf(object); if (object === null) break; } return object; }
function date_getPrototypeOf(o) { date_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return date_getPrototypeOf(o); }
function date_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var PREFIX = 'data-date';
var PROPS = ['dateId', 'timestamp', 'reminders', 'alerts'];
var date_GUARD_TEXT = "\uFEFF";
var TIME_LOCALE_FORMATS = {
  'en-US': 12,
  'en-GB': 24
};
var DATE_LOCALE_FORMATS = {
  'en-US': 'mmddyyyy',
  'en-GB': 'ddmmyyyy'
};
var date_Date = /*#__PURE__*/function (_DateActions) {
  date_inherits(Date, _DateActions);
  var _super = date_createSuper(Date);
  function Date(node) {
    var _this;
    date_classCallCheck(this, Date);
    _this = _super.call(this, node);
    date_defineProperty(date_assertThisInitialized(_this), "onSelectionChange", function (range, oldRange, source) {
      //прохождение курсора через блот
      return;
    });
    date_defineProperty(date_assertThisInitialized(_this), "onDateClick", function (event) {
      if (_this.active) {
        return;
      }
      if (_this.isBlotLocked) {
        return;
      }
      if (isLeftMouseButtonPressed(event)) {
        event.preventDefault();
        if (!_this.isReadOnly) {
          var props = {
            type: 'date',
            dateId: _this.getItem('dateId'),
            timestamp: _this.getItem('timestamp'),
            showTime: _this.getItem('format-showtime'),
            reminders: _this.getItem('reminders')
          };
          if (_this.scroll.editor.plugins.dateManager && _this.scroll.editor.plugins.dateManager.openDatePicker(props)) {
            console.info('Use native date picker');
          } else {
            _this.beginEdit();
          }
        }
      }
    });
    date_defineProperty(date_assertThisInitialized(_this), "beginEdit", function () {
      if (!_this.isReadOnly && !_this.active) {
        _this.active = true;
        _this.range = _this.scroll.selection.getRange()[0];
        _this.render();
      }
    });
    date_defineProperty(date_assertThisInitialized(_this), "endEdit", function () {
      _this.active = false;
      _this.render();
      if (_this.needSetAlerts) {
        _this.setAlerts();
      }
      if (_this.parent && _this.parent.selectCell) {
        _this.parent.selectCell({
          focus: true
        });
      } else if (_this.range && _this.range.index) {
        _this.scroll.selection.setRange(_this.range);
      }
      var timestamp = _this.getItem('timestamp');
      if (!timestamp) {
        _this.removeDate();
      }
    });
    date_defineProperty(date_assertThisInitialized(_this), "removeDate", function () {
      _this.remove();
      if (_this.parent.emptyCell) {
        _this.parent.emptyCell({
          focus: true
        });
      }
    });
    _this.range = {};
    _this.needCreateId = true;
    _this.needBeginEdit = false;
    _this.contentNode = document.createElement('span');
    _this.contentNode.setAttribute('contenteditable', false);
    node.classList.add('date-content');
    var _iterator = date_createForOfIteratorHelper(PROPS),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _key = _step.value;
        var _attr = "".concat(PREFIX, "-").concat(_key);
        var val = _this.domNode.getAttribute(_attr);
        node.setAttribute(_attr, val);
        if (_key === 'timestamp' && val === 'custom') {
          _this.needBeginEdit = true;
        }
        if (_key === 'dateId' && val) {
          _this.needCreateId = false;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    for (var key in DEFAULT_DATE_FORMAT) {
      var attr = "".concat(PREFIX, "-format-").concat(key);
      node.setAttribute(attr, _this.domNode.getAttribute(attr));
    }
    Array.from(_this.domNode.childNodes).forEach(function (childNode) {
      _this.contentNode.appendChild(childNode);
    });

    //this.leftGuard = document.createTextNode(GUARD_TEXT)
    _this.rightGuard = document.createTextNode(date_GUARD_TEXT);

    //this.domNode.appendChild(this.leftGuard)
    _this.domNode.appendChild(_this.contentNode);
    _this.domNode.appendChild(_this.rightGuard);
    _this.needSetAlerts = false;
    _this.active = false;
    return _this;
  }
  date_createClass(Date, [{
    key: "parentTable",
    get: function get() {
      if (this.parent.getBlotName && this.parent.getBlotName() === 'tableMention') {
        return this.parent.parentTable;
      } else {
        return false;
      }
    }
  }, {
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get2 = date_get(date_getPrototypeOf(Date.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      if (this.attached) return;
      this.attached = true;
      this.scroll.emitter.on('selectionchange', this.onSelectionChange);
      this.contentNode.addEventListener('mousedown', this.onDateClick, false);
      this.render();
      if (this.needCreateId) {
        this.createDateId();
      }
      // ремайндеры устанавливаются если блок был добавлен после undo или первоначальной вставке даты
      var undoManager = this.scroll.editor.plugins.undoManager;
      if (undoManager.isUndoing() || undoManager.isRedoing() || window.customDateId === this.getItem('dateId')) {
        this.setAlerts();
      }
      if (this.needBeginEdit) {
        if (window.customDateId && window.customDateId === this.getItem('dateId')) {
          this.needBeginEdit = false;
          this.beginEdit();
        } else {
          this.removeDate();
        }
      }
      if (window.customDateId) {
        delete window.customDateId;
      }
    }

    /**
     * Получить форматы даты и времени (статический метод)
     * @param {*} date 
     * @param {*} dateConfig 
     * @returns - {dateFormat: string, timeFormat: string}
     */
  }, {
    key: "render",
    value: function render() {
      var reminderManager = this.scroll.editor.plugins.reminderManager;
      var data = this.value().date;
      var timestamp = data.timestamp || false;
      var dateInline, datePopup;
      if (timestamp && !isNaN(parseInt(timestamp))) {
        timestamp = parseInt(timestamp);
      }
      if (this.dateConfig.readOnly || this.scroll.editor.mode === this.scroll.editor.constructor.MODE_READONLY) {
        this.domNode.classList.add('readonly');
      } else {
        this.domNode.classList.remove('readonly');
      }
      var _Date$getDateTimeForm = Date.getDateTimeFormat(data, this.dateConfig),
        timeFormat = _Date$getDateTimeForm.timeFormat,
        dateFormat = _Date$getDateTimeForm.dateFormat;
      var dateComponent = (0,preact_module.h)(InputDate, {
        mode: "inline",
        editor: this.scroll.editor,
        active: this.active,
        anchorNode: this.domNode,
        scrollNode: this.scroll.domNode,
        enableReminders: reminderManager.options.enabled ? true : false,
        type: 'default',
        showTime: data.format.showTime,
        timeFormat: timeFormat,
        dateFormat: dateFormat,
        firstWeekDay: data.format.firstWeekDay,
        timeZoneGMT: data.format.timeZoneGMT,
        value: timestamp,
        setValue: this.setValue.bind(this),
        reminders: this.getReminders(),
        setReminder: this.setReminder.bind(this),
        removeReminders: this.removeReminders,
        listenBlur: true,
        reminderTimeToString: this.reminderTimeToString.bind(this),
        onChangeOption: this.updateFormat.bind(this),
        wantsToClose: this.endEdit.bind(this),
        setReturnDateString: this.setReturnDateString.bind(this),
        setReturnDateComponent: this.setReturnDateComponent.bind(this)
      });
      if (this.active) {
        datePopup = (0,preact_module.h)(PopupMenuTransition, null, (0,preact_module.h)(popupMenu/* default */.Z, {
          addClassName: "date-input-popup",
          wantsToClose: this.endEdit.bind(this),
          anchorNode: this.contentNode,
          closeOnEsc: true,
          anchorOptions: {
            placement: 'top-start',
            offset: '0px, 8px',
            positionFixed: true,
            priority: ['bottom', 'left', 'right'],
            boundariesElement: this.scroll.editor.getScrollingContainer(),
            overflowBoundariesElement: this.scroll.editor.getScrollingContainer()
          },
          listenSizeChange: true
        }, dateComponent));
        dateInline = (0,preact_module.h)("div", {
          className: "input-date"
        }, this.getComponent());
      } else {
        dateInline = dateComponent;
      }
      var blot = this.parent;
      if (blot.isBlotLocked) {
        datePopup = null;
      }
      (0,preact_module/* render */.sY)((0,preact_module.h)("span", {
        contenteditable: "false"
      }, dateInline, datePopup), this.domNode);
    }
  }, {
    key: "isReadOnly",
    get: function get() {
      if (this.dateConfig.readOnly || this.scroll.editor.mode !== this.scroll.editor.constructor.MODE_EDIT) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "isBlotLocked",
    get: function get() {
      return !!(this.parentTable && this.parentTable.isBlotLocked);
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3, _this$parent, _this$parent$parent, _this$parent2, _this$parent2$parent, _this$parent3;
      for (var _len2 = arguments.length, args = new Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
        args[_key3] = arguments[_key3];
      }
      (_get3 = date_get(date_getPrototypeOf(Date.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      var reminderManager = this.scroll.editor.plugins.reminderManager;
      this.scroll.emitter.off('selectionchange', this.onSelectionChange);
      this.contentNode.removeEventListener('mousedown', this.onDateClick, false);
      this.attached = null;
      var date;
      var inList = ((_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : (_this$parent$parent = _this$parent.parent) === null || _this$parent$parent === void 0 ? void 0 : _this$parent$parent.map.get('type')) === 'list' || false;
      var parent = inList ? (_this$parent2 = this.parent) === null || _this$parent2 === void 0 ? void 0 : (_this$parent2$parent = _this$parent2.parent) === null || _this$parent2$parent === void 0 ? void 0 : _this$parent2$parent.parent : (_this$parent3 = this.parent) === null || _this$parent3 === void 0 ? void 0 : _this$parent3.parent;
      var inToggle = (parent === null || parent === void 0 ? void 0 : parent.map.get('type')) === 'toggle' || false;
      var isToggleCollapsed = inToggle && (parent === null || parent === void 0 ? void 0 : parent.map.get('collapsed')) || false;

      // если не внутри свёрнутого списка
      if (!isToggleCollapsed) {
        var dateId = this.getItem('dateId');
        // если родительский блот не удалён
        if (this.scroll.editor.findById(this.parent.id)) {
          var delta = this.parent.map.get('characters').toDelta();
          date = delta.find(function (_ref) {
            var insert = _ref.insert;
            return (insert === null || insert === void 0 ? void 0 : insert.date) && insert.date.dateId === dateId;
          });
        }

        // при удалении даты с ремайндерами, также удаляем ремайндеры через reminderManager
        if (!date && Object.keys(this.getReminders()).length) {
          reminderManager.deleteReminder(dateId, {
            reminders: this.getReminders()
          });
        }
      }
      // удаляем объект из памяти так как при undo или сворачивании/разворачивании тоггла может сработать старый detach
      delete this;
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var attr = this.getAttrName(key, params);
      var val = this.domNode.getAttribute(attr);
      if (val) {
        if (['true', 'false'].indexOf(val) !== -1) {
          val = val === 'true' ? true : false;
        } else if (val[0] === '{' && val[val.length - 1] === '}' || val[0] === '[' && val[val.length - 1] === ']') {
          val = JSON.parse(val);
        } else if (key === 'timestamp') {
          val = parseInt(val);
        }
      }
      return val;
    }
  }, {
    key: "setItem",
    value: function setItem(key, val) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var attr = this.getAttrName(key, params);
      if (date_typeof(val) === 'object') {
        val = JSON.stringify(val);
      }
      this.domNode.setAttribute(attr, val);
      this.render && this.render();
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var attr = this.getAttrName(key, params);
      this.domNode.removeAttribute(attr);
      this.render && this.render();
    }
  }, {
    key: "getAttrName",
    value: function getAttrName(key) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var attr = PREFIX;
      if (params.sub) {
        attr += "-".concat(params.sub);
      }
      attr += "-".concat(key);
      return attr;
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      return this.domNode.outerHTML;
    }
  }, {
    key: "handleInput",
    value: function handleInput(event) {
      if (event.which === 0 && event.inputType === 'deleteContentBackward') {
        this.remove();
        return true;
      }
      return false;
    }
  }], [{
    key: "create",
    value: function create(value) {
      var node = date_get(date_getPrototypeOf(Date), "create", this).call(this);
      node.classList.add('date-inline');
      value.timestamp = value.timestamp || value.value;
      var _iterator2 = date_createForOfIteratorHelper(PROPS),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _key4 = _step2.value;
          node.setAttribute("".concat(PREFIX, "-").concat(_key4), value[_key4] || '');
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      for (var key in DEFAULT_DATE_FORMAT) {
        var val = value.format && value.format.hasOwnProperty(key) ? value.format[key] : DEFAULT_DATE_FORMAT[key];
        node.setAttribute("".concat(PREFIX, "-format-").concat(key), val);
      }
      return node;
    }
  }, {
    key: "value",
    value: function value(domNode) {
      var value = {
        format: {}
      };
      var _iterator3 = date_createForOfIteratorHelper(PROPS),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _key5 = _step3.value;
          value[_key5] = domNode.getAttribute("".concat(PREFIX, "-").concat(_key5));
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      for (var key in DEFAULT_DATE_FORMAT) {
        var val = domNode.getAttribute("".concat(PREFIX, "-format-").concat(key));
        if (['true', 'false'].indexOf(val) !== -1) {
          val = val === 'true' ? true : false;
        } else if (!isNaN(parseInt(val))) {
          val = parseInt(val);
        }
        value.format[key] = val;
      }
      return value;
    }
  }, {
    key: "getOpText",
    value: function getOpText(op, children) {
      var value = op.date.timestamp;
      if (children && children.forEach) {
        children.forEach(function (child) {
          if (child.getDateId && child.getDateId() === op.date.dateId) {
            if (child.returnDateString) {
              value = child.returnDateString();
            }
          }
        });
      }
      return value;
    }
  }, {
    key: "getDateTimeFormat",
    value: function getDateTimeFormat(date) {
      var _date$format, _date$format2;
      var dateConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var timeFormat = (date === null || date === void 0 ? void 0 : (_date$format = date.format) === null || _date$format === void 0 ? void 0 : _date$format.timeFormat) || DEFAULT_DATE_FORMAT.timeFormat;
      var dateFormat = (date === null || date === void 0 ? void 0 : (_date$format2 = date.format) === null || _date$format2 === void 0 ? void 0 : _date$format2.type) || 'default';
      if (dateConfig.timeFormat) {
        var intTimeFormatFromConfig = parseInt(dateConfig.timeFormat);
        if (intTimeFormatFromConfig === 24 || intTimeFormatFromConfig === 12) {
          timeFormat = intTimeFormatFromConfig;
        }
      } else if (dateConfig.timeLocale) {
        if (Object.keys(TIME_LOCALE_FORMATS).includes(dateConfig.timeLocale)) {
          timeFormat = TIME_LOCALE_FORMATS[dateConfig.timeLocale];
        }
        if (dateFormat === 'default' && Object.keys(DATE_LOCALE_FORMATS).includes(dateConfig.timeLocale)) {
          dateFormat = DATE_LOCALE_FORMATS[dateConfig.timeLocale];
        }
      }
      return {
        timeFormat: timeFormat,
        dateFormat: dateFormat
      };
    }
  }]);
  return Date;
}(dateActions((parchment_default()).Embed));

date_Date.blotName = 'date';
date_Date.tagName = 'date';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/progressSlider.js











function progressSlider_slicedToArray(arr, i) { return progressSlider_arrayWithHoles(arr) || progressSlider_iterableToArrayLimit(arr, i) || progressSlider_unsupportedIterableToArray(arr, i) || progressSlider_nonIterableRest(); }
function progressSlider_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function progressSlider_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return progressSlider_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return progressSlider_arrayLikeToArray(o, minLen); }
function progressSlider_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function progressSlider_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function progressSlider_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }





// Новый компонент прогресса, так как старый InputSlider не подошел из-за использованного в нем асинхронного состояния с таймаутами,
// которое вызывает рендер компонента, когда он уже должен был обновиться с новыми props, это в свою очередь вызывает
// рендер копии компонента, в котором находится InputSlider. В данном компоненте нет асинхронного состояния и управление стилями происходит сразу в DOM,
// без использования обновления состояния при mousemove и лишних обработчиков.
function ProgressSilder(_ref) {
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? 0 : _ref$value,
    _ref$addClassName = _ref.addClassName,
    addClassName = _ref$addClassName === void 0 ? '' : _ref$addClassName,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$showProgress = _ref.showProgress,
    showProgress = _ref$showProgress === void 0 ? false : _ref$showProgress,
    _ref$readonly = _ref.readonly,
    readonly = _ref$readonly === void 0 ? false : _ref$readonly;
  var _useState = (0,hooks_module/* useState */.eJ)(value || 0),
    _useState2 = progressSlider_slicedToArray(_useState, 2),
    progress = _useState2[0],
    setProgress = _useState2[1];
  var domRef = (0,hooks_module/* useRef */.sO)(null);
  var sliderRef = (0,hooks_module/* useRef */.sO)(null);
  var progressRef = (0,hooks_module/* useRef */.sO)(null);
  var precentRef = (0,hooks_module/* useRef */.sO)(null);
  var getProgress = function getProgress(event) {
    if (!sliderRef.current) return progress;
    var x = event.clientX;
    var rect = sliderRef.current.getBoundingClientRect();
    return Math.min(100, Math.max(0, Math.round(100 * (x - rect.left) / rect.width)));
  };
  var onMouseDown = function onMouseDown(event) {
    event.preventDefault();
    if (!isLeftMouseButtonPressed(event)) {
      return;
    }
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };
  var onMouseMove = function onMouseMove(event) {
    setDomState(getProgress(event));
  };
  var onMouseUp = function onMouseUp(event) {
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseup', onMouseUp);
    var newProgress = getProgress(event);
    setProgress(newProgress);
    onChange(newProgress);
  };
  var getProgressClassName = function getProgressClassName(val) {
    if (val < 30) {
      return 'progress-low';
    } else if (val < 75) {
      return 'progress-middle';
    } else {
      return 'progress-high';
    }
  };
  var setDomState = function setDomState(val) {
    if (domRef.current) {
      var className = getProgressClassName(val);
      if (domRef.current.className !== className) {
        domRef.current.setAttribute('class', className);
      }
    }
    if (progressRef.current) {
      progressRef.current.style.width = val + '%';
    }
    if (precentRef.current) {
      precentRef.current.innerHTML = val + '%';
    }
  };
  (0,hooks_module/* useEffect */.d4)(function () {
    setDomState(progress);
  }, []);
  (0,hooks_module/* useEffect */.d4)(function () {
    setDomState(progress);
  }, [progress]);
  (0,hooks_module/* useEffect */.d4)(function () {
    setProgress(value);
  }, [value]);
  var domStyle = {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    width: '100%'
  };
  var classNames = ['input-slider', util/* SELF_CONTROLLED_CONTENT_CLASS */.W$];
  if (addClassName) {
    classNames.push(addClassName);
  }
  if (readonly) {
    classNames.push('readonly');
  }
  return (0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)("div", {
    className: getProgressClassName(progress),
    ref: domRef,
    style: domStyle
  }, (0,preact_module.h)("div", {
    className: classNames.join(' '),
    onMouseDown: !readonly ? onMouseDown : null
  }, (0,preact_module.h)("span", {
    className: "slider-range",
    ref: sliderRef
  }, (0,preact_module.h)("span", {
    className: "slider-progress",
    ref: progressRef,
    style: {
      width: progress + '%'
    }
  }, (0,preact_module.h)("span", {
    className: "slider-holder"
  })))), showProgress ? (0,preact_module.h)("span", {
    className: "progress-value table-text-common",
    ref: precentRef
  }) : null));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/progress.js
function progress_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { progress_typeof = function _typeof(obj) { return typeof obj; }; } else { progress_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return progress_typeof(obj); }












function progress_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function progress_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function progress_createClass(Constructor, protoProps, staticProps) { if (protoProps) progress_defineProperties(Constructor.prototype, protoProps); if (staticProps) progress_defineProperties(Constructor, staticProps); return Constructor; }
function progress_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) progress_setPrototypeOf(subClass, superClass); }
function progress_setPrototypeOf(o, p) { progress_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return progress_setPrototypeOf(o, p); }
function progress_createSuper(Derived) { var hasNativeReflectConstruct = progress_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = progress_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = progress_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return progress_possibleConstructorReturn(this, result); }; }
function progress_possibleConstructorReturn(self, call) { if (call && (progress_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return progress_assertThisInitialized(self); }
function progress_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function progress_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function progress_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { progress_get = Reflect.get; } else { progress_get = function _get(target, property, receiver) { var base = progress_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return progress_get(target, property, receiver || target); }
function progress_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = progress_getPrototypeOf(object); if (object === null) break; } return object; }
function progress_getPrototypeOf(o) { progress_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return progress_getPrototypeOf(o); }
function progress_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var Progress = /*#__PURE__*/function (_InlineEmbed) {
  progress_inherits(Progress, _InlineEmbed);
  var _super = progress_createSuper(Progress);
  function Progress(node) {
    var _this;
    progress_classCallCheck(this, Progress);
    _this = _super.call(this, node);
    progress_defineProperty(progress_assertThisInitialized(_this), "onChange", function (value) {
      _this.domNode.setAttribute('data-progress-value', value);
    });
    _this.isSeparableByClickApplicable = true;
    _this.contentNode.classList.add('progress-slider');
    return _this;
  }
  progress_createClass(Progress, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = progress_get(progress_getPrototypeOf(Progress.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      if (this.attached) return;
      this.attached = true;
      this.render();
    }
  }, {
    key: "onParentRenderUpdate",
    value: function onParentRenderUpdate() {
      this.render();
    }
  }, {
    key: "render",
    value: function render() {
      var blot = normalizeToStoredBlot(this);
      (0,preact_module/* render */.sY)((0,preact_module.h)(ProgressSilder, {
        addClassName: "inline-progress-slider",
        value: this.value().progress,
        onChange: this.onChange,
        showProgress: true,
        readonly: blot.isBlotLocked || this.scroll.editor.mode !== MODE_EDIT
      }), this.contentNode);
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = progress_get(progress_getPrototypeOf(Progress.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      this.attached = null;
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      var node = this.domNode.cloneNode(true);
      return node.outerHTML;
    }
  }], [{
    key: "create",
    value: function create(value) {
      var node = progress_get(progress_getPrototypeOf(Progress), "create", this).call(this);
      node.classList.add('inline-progress');
      node.setAttribute('data-progress-value', value || 0);
      return node;
    }
  }, {
    key: "value",
    value: function value(domNode) {
      return domNode.getAttribute('data-progress-value');
    }
  }, {
    key: "getOpText",
    value: function getOpText(op, children, editor) {
      return ' ' + op.progress + '%';
    }
  }]);
  return Progress;
}(InlineEmbed);

Progress.blotName = 'progress';
Progress.tagName = 'inline-progress';
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__(34553);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.freeze.js
var es_object_freeze = __webpack_require__(43371);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/math.js
function math_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = math_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function math_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return math_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return math_arrayLikeToArray(o, minLen); }
function math_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }











function math_distance(a, b) {
  return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));
}
function isNumbersInOrder(indexes) {
  var lastIndex = indexes[0];
  for (var i = 1; i < indexes.length; i++) {
    if (indexes[i] !== lastIndex + 1) {
      return false;
    }
    lastIndex = indexes[i];
  }
  return true;
}
function math_doRangesIntersect(x1, x1End, x2, x2End) {
  if (x2 >= x1 && x2 <= x1End) {
    return true;
  }
  if (x2End >= x1 && x2End <= x1End) {
    return true;
  }
  if (x1 >= x2 && x1 <= x2End) {
    return true;
  }
  if (x1End >= x2 && x1End <= x2End) {
    return true;
  }
  return false;
}
function math_getItemWithMaxFn(items, fn) {
  var maxItem = null;
  var maxValue = Number.NEGATIVE_INFINITY;
  var _iterator = math_createForOfIteratorHelper(items),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      var v = fn(item);
      if (v >= maxValue) {
        maxValue = v;
        maxItem = item;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return maxItem;
}
function math_getItemWithMinFn(items, fn) {
  var minItem = null;
  var minValue = Number.POSITIVE_INFINITY;
  var _iterator2 = math_createForOfIteratorHelper(items),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var item = _step2.value;
      var v = fn(item);
      if (v < minValue) {
        minValue = v;
        minItem = item;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return minItem;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/sortable.js
function sortable_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { sortable_typeof = function _typeof(obj) { return typeof obj; }; } else { sortable_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return sortable_typeof(obj); }
function sortable_slicedToArray(arr, i) { return sortable_arrayWithHoles(arr) || sortable_iterableToArrayLimit(arr, i) || sortable_unsupportedIterableToArray(arr, i) || sortable_nonIterableRest(); }
function sortable_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function sortable_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function sortable_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function sortable_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = sortable_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function sortable_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return sortable_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return sortable_arrayLikeToArray(o, minLen); }
function sortable_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }













function sortable_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function sortable_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function sortable_createClass(Constructor, protoProps, staticProps) { if (protoProps) sortable_defineProperties(Constructor.prototype, protoProps); if (staticProps) sortable_defineProperties(Constructor, staticProps); return Constructor; }
function sortable_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TRIGGER_DISTANCE = 5;
var CONTAINER_OVERFLOW_MAX = 10; // переменная указывает на максимальный вынос перетаскиваемой ноды, за пределы контейнера,
// улучшает отзывчивость при переносе в начало или конец

var DEFAULT_OPTIONS = {
  selector: '.sortable',
  // cелектор элеменов, которые можно сортировать
  allowDraggingSelector: null,
  // селектор за который можно тянуть, для старта сортировки, если не передан, используется selector
  draggingClass: 'dragging-process',
  // класс добавляется к элементу, который тащим
  sortingClass: 'sorting-process',
  // класс добавляется к контейнеру, в котором происходит процесс сортировки
  phantomClass: 'sortable-phantom',
  // класс для плейсхолдера (рендерится на месте элемента, который тащим, имитирует место, куда дропнется сортируемый элемент)
  triggerDistance: TRIGGER_DISTANCE,
  // дистанция, которую пройдет мышь от момента нажатия кнопки мыши, до начала процесса сортировки
  onChange: function onChange(children) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  },
  // функция, которая выполнится по окончании сортировки. 
  // `children` - массив сортируемых элементов в том порядке, который получился в процессе сортировки
  allowedSortContainerClass: null,
  // класс для контейнера, который указывает на то, что сортировка возможна 
  allowPullItemsOut: true,
  // если `true`, сортируемые элементы можно вытащить из контейнера
  autoscroll: false,
  // если `true`, при наведении на верхний или нижний край контейнера, он будет подскроливатьсяъ
  autoscrollDistance: 30,
  // область в пикселях сверху и снизу для срабатывания автоскролла
  autoscrollStep: 10,
  // шаг, на который нужно скроллить контейнер при включенном автоскролле
  autoscrollTimeout: 20 // интервал с которым будет работать автоскролл
};
var Sortable = /*#__PURE__*/function () {
  function Sortable(container, options) {
    var _this = this;
    sortable_classCallCheck(this, Sortable);
    sortable_defineProperty(this, "onContainerMouseDown", function (event) {
      event.stopPropagation();
      if (_this.options.allowedSortContainerClass && !_this.container.classList.contains(_this.options.allowedSortContainerClass)) return;
      if (_this.options.allowDraggingSelector && !event.target.closest(_this.options.allowDraggingSelector)) return;
      if (!event.target.closest(_this.options.selector)) return;
      _this.mouseDownPosition = {
        x: event.clientX,
        y: event.clientY
      };
      document.addEventListener('mousemove', _this.onMouseDownDocumentMouseMove, false);
      document.addEventListener('mouseup', _this.onMouseDownDocumentMouseUp, false);
    });
    sortable_defineProperty(this, "onMouseDownDocumentMouseMove", function (event) {
      if (_this.mouseDownPosition) {
        var nowPosition = {
          x: event.clientX,
          y: event.clientY
        };
        if (math_distance(nowPosition, _this.mouseDownPosition) >= _this.options.triggerDistance) {
          document.removeEventListener('mousemove', _this.onMouseDownDocumentMouseMove, false);
          document.removeEventListener('mouseup', _this.onMouseDownDocumentMouseUp, false);
          _this.mouseDownPosition = null;
          var node = event.target.closest(_this.options.selector);
          if (node) {
            _this.startSorting(node, nowPosition);
          }
        }
      }
    });
    sortable_defineProperty(this, "onMouseDownDocumentMouseUp", function (event) {
      if (_this.mouseDownPosition) {
        document.removeEventListener('mousemove', _this.onMouseDownDocumentMouseMove, false);
        document.removeEventListener('mouseup', _this.onMouseDownDocumentMouseUp, false);
        _this.mouseDownPosition = null;
      }
    });
    sortable_defineProperty(this, "onDragMouseMove", function (event) {
      var x = event.clientX,
        y = event.clientY;
      _this.tryAutoscroll(y);
      var rect = _this.draggingNode.getBoundingClientRect();
      var containerRect = _this.container.getBoundingClientRect();
      var top = parseInt(y - _this.innerDraggingNodeCursorCoords.y);
      var left = parseInt(x - _this.innerDraggingNodeCursorCoords.x);
      if (!_this.options.allowPullItemsOut) {
        if (top < containerRect.top - CONTAINER_OVERFLOW_MAX) {
          top = containerRect.top - CONTAINER_OVERFLOW_MAX;
        }
        if (top + rect.height > containerRect.bottom + CONTAINER_OVERFLOW_MAX) {
          top = containerRect.bottom + CONTAINER_OVERFLOW_MAX - rect.height;
        }
      }
      _this.draggingNode.style.top = top + 'px';
      if (_this.options.allowPullItemsOut) {
        _this.draggingNode.style.left = left + 'px';
      }
      _this.onDraggingNodePosChange();
    });
    sortable_defineProperty(this, "onDragMouseUp", function (event) {
      _this.clearAutoscrollInterval();
      document.removeEventListener('mousemove', _this.onDragMouseMove, false);
      document.removeEventListener('mouseup', _this.onDragMouseUp, false);
      var containerScrollTop = _this.container.scrollTop;
      _this.container.removeChild(_this.dropPhantom);
      _this.container.classList.remove(_this.options.sortingClass);
      _this.draggingNode.removeAttribute('style');
      _this.draggingNode.classList.remove(_this.options.draggingClass);
      var children = Array.from(_this.container.childNodes);
      for (var _i = 0, _children = children; _i < _children.length; _i++) {
        var node = _children[_i];
        node.style.transform = '';
      }
      if (_this.dropIndex === children.length - 1) {
        _this.container.appendChild(_this.draggingNode);
      } else {
        if (children.indexOf(_this.draggingNode) > _this.dropIndex) {
          _this.container.insertBefore(_this.draggingNode, children[_this.dropIndex]);
        } else {
          _this.container.insertBefore(_this.draggingNode, children[_this.dropIndex + 1]);
        }
      }
      if (_this.options.onChange) {
        _this.options.onChange(Array.from(_this.container.childNodes), {
          scrollTop: containerScrollTop
        });
      }
      _this.draggingNode = null;
      _this.cursorPosition = null;
      _this.dropPhantom = null;
      _this.dropIndex = null;
      _this.innerDraggingNodeCursorCoords = null;
    });
    this.container = container;
    this.options = Object.assign({}, DEFAULT_OPTIONS, options);
    this.container.addEventListener('mousedown', this.onContainerMouseDown, false);
  }
  sortable_createClass(Sortable, [{
    key: "setInnerDraggingNodeCursorCoords",
    value: function setInnerDraggingNodeCursorCoords(node, coords) {
      var rect = node.getBoundingClientRect();
      var innerNodeCursorCoords = {
        x: coords.x - rect.x,
        y: coords.y - rect.y
      };
      this.innerDraggingNodeCursorCoords = Object.freeze(innerNodeCursorCoords);
    }
  }, {
    key: "isMouseOverContainer",
    value: function isMouseOverContainer(_ref) {
      var x = _ref.x,
        y = _ref.y;
      var rect = this.container.getBoundingClientRect();
      return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
    }
  }, {
    key: "prepareForDrag",
    value: function prepareForDrag(coords) {
      var rect = this.draggingNode.getBoundingClientRect();
      this.addDropPhantom(rect.width, rect.height);
      var segmentX = coords.x - rect.x;
      var segmentY = coords.y - rect.y;
      this.draggingNode.classList.add(this.options.draggingClass);
      this.draggingNode.style.position = 'fixed';
      this.draggingNode.style.width = rect.width + 'px';
      this.draggingNode.style.height = rect.height + 'px';
      this.draggingNode.style.top = parseInt(coords.y - segmentY) + 'px';
      this.draggingNode.style.left = parseInt(coords.x - segmentX) + 'px';
      this.container.classList.add(this.options.sortingClass);
    }
  }, {
    key: "addDropPhantom",
    value: function addDropPhantom(width, height) {
      this.dropIndex = Array.from(this.container.childNodes).indexOf(this.draggingNode);
      this.dropPhantom = document.createElement('div');
      this.dropPhantom.classList.add(this.options.phantomClass);
      this.dropPhantom.style.width = width + 'px';
      this.dropPhantom.style.paddingTop = height / 2 + 'px';
      this.dropPhantom.style.paddingBottom = height / 2 + 'px';
      this.container.insertBefore(this.dropPhantom, this.draggingNode);
    }
  }, {
    key: "movePhantomToIndex",
    value: function movePhantomToIndex(index) {
      var children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (!children.length) return;
      if (this.dropIndex === index) return;
      var phantomDomIndex = children.indexOf(this.dropPhantom);
      var phantomHeight = this.dropPhantom.getBoundingClientRect().height;
      var _iterator = sortable_createForOfIteratorHelper(children),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var node = _step.value;
          var nodeIndex = children.indexOf(node);
          if (nodeIndex > phantomDomIndex) {
            if (nodeIndex <= index) {
              node.style.transform = 'translateY(-' + phantomHeight + 'px)';
            } else {
              node.style.transform = 'translateY(0px)';
            }
          } else if (nodeIndex < phantomDomIndex) {
            if (nodeIndex >= index) {
              node.style.transform = 'translateY(' + phantomHeight + 'px)';
            } else {
              node.style.transform = 'translateY(0px)';
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var phantomTranslate = 0;
      if (phantomDomIndex < index) {
        for (var i = phantomDomIndex + 1; i <= index; i++) {
          phantomTranslate += children[i].getBoundingClientRect().height;
        }
      } else {
        for (var _i2 = index; _i2 <= phantomDomIndex - 1; _i2++) {
          phantomTranslate -= children[_i2].getBoundingClientRect().height;
        }
      }
      this.dropPhantom.style.transform = 'translateY(' + phantomTranslate + 'px)';
      this.dropIndex = index;
    }
  }, {
    key: "onDraggingNodePosChange",
    value: function onDraggingNodePosChange() {
      var _this2 = this;
      var rect = this.draggingNode.getBoundingClientRect();
      var draggingNodeMiddleY = rect.y + rect.height / 2;
      var children = Array.from(this.container.childNodes).filter(function (node) {
        return node !== _this2.draggingNode;
      });
      var _children$filter = children.filter(function (node) {
          var nodeRect = node.getBoundingClientRect();
          return draggingNodeMiddleY > nodeRect.y && draggingNodeMiddleY < nodeRect.y + nodeRect.height;
        }),
        _children$filter2 = sortable_slicedToArray(_children$filter, 1),
        overNode = _children$filter2[0];
      if (overNode && overNode !== this.dropPhantom) {
        var overNodeRect = overNode.getBoundingClientRect();
        var index;
        if (children.indexOf(overNode) > children.indexOf(this.dropPhantom)) {
          index = draggingNodeMiddleY > overNodeRect.y && draggingNodeMiddleY <= overNodeRect.y + overNodeRect.height / 2 ? children.indexOf(overNode) - 1 : children.indexOf(overNode);
        } else {
          index = draggingNodeMiddleY > overNodeRect.y && draggingNodeMiddleY <= overNodeRect.y + overNodeRect.height / 2 ? children.indexOf(overNode) : children.indexOf(overNode) + 1;
        }
        this.movePhantomToIndex(index, children);
      }
    }
  }, {
    key: "clearAutoscrollInterval",
    value: function clearAutoscrollInterval() {
      if (sortable_typeof(this.autoscrollInterval) === 'object') {
        if (this.autoscrollInterval.top) {
          clearInterval(this.autoscrollInterval.top);
          this.autoscrollInterval.top = null;
        }
        if (this.autoscrollInterval.bottom) {
          clearInterval(this.autoscrollInterval.bottom);
          this.autoscrollInterval.bottom = null;
        }
      }
    }
  }, {
    key: "setAutoscrollInterval",
    value: function setAutoscrollInterval(fn, timeout, direction) {
      if (!this.autoscrollInterval) {
        this.autoscrollInterval = {};
      }
      this.autoscrollInterval[direction] = setInterval(fn, timeout);
    }
  }, {
    key: "tryAutoscroll",
    value: function tryAutoscroll(yCoord) {
      var _this3 = this;
      if (!(this.container.scrollHeight > this.container.clientHeight)) return;
      var _this$options = this.options,
        autoscroll = _this$options.autoscroll,
        autoscrollDistance = _this$options.autoscrollDistance,
        autoscrollStep = _this$options.autoscrollStep,
        autoscrollTimeout = _this$options.autoscrollTimeout;
      if (!autoscroll) return;
      var rect = this.container.getBoundingClientRect();
      var allowScrollDown = this.container.clientHeight + this.container.scrollTop < this.container.scrollHeight;
      var allowScrollTop = this.container.scrollTop !== 0;
      if (yCoord > rect.bottom - autoscrollDistance && allowScrollDown) {
        if (this.autoscrollInterval && this.autoscrollInterval.bottom) return;
        this.setAutoscrollInterval(function () {
          if (_this3.container.clientHeight + _this3.container.scrollTop < _this3.container.scrollHeight) {
            if (_this3.container.clientHeight + _this3.container.scrollTop + autoscrollStep <= _this3.container.scrollHeight) {
              _this3.container.scrollTop = _this3.container.scrollTop + autoscrollStep;
            } else {
              _this3.container.scrollTop = _this3.container.scrollHeight - _this3.container.clientHeight + _this3.container.scrollTop;
            }
            _this3.onDraggingNodePosChange();
          } else {
            _this3.clearAutoscrollInterval();
          }
        }, autoscrollTimeout, 'bottom');
      } else if (yCoord < rect.top + autoscrollDistance && allowScrollTop) {
        if (this.autoscrollInterval && this.autoscrollInterval.top) return;
        this.setAutoscrollInterval(function () {
          if (_this3.container.scrollTop !== 0) {
            if (_this3.container.scrollTop > autoscrollStep) {
              _this3.container.scrollTop = _this3.container.scrollTop - autoscrollStep;
            } else {
              _this3.container.scrollTop = 0;
            }
            _this3.onDraggingNodePosChange();
          } else {
            _this3.clearAutoscrollInterval();
          }
        }, autoscrollTimeout, 'top');
      } else {
        this.clearAutoscrollInterval();
      }
    }
  }, {
    key: "startSorting",
    value: function startSorting(node, coords) {
      this.draggingNode = node;
      this.prepareForDrag(coords);
      this.setInnerDraggingNodeCursorCoords(node, coords);
      document.addEventListener('mousemove', this.onDragMouseMove, false);
      document.addEventListener('mouseup', this.onDragMouseUp, false);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.options = null;
      this.container.removeEventListener('mousedown', this.onContainerMouseDown, false);
      this.container = null;
    }
  }]);
  return Sortable;
}();
/* harmony default export */ const sortable = (Sortable);
// EXTERNAL MODULE: ./node_modules/parse-color/index.js
var parse_color = __webpack_require__(15461);
var parse_color_default = /*#__PURE__*/__webpack_require__.n(parse_color);
// EXTERNAL MODULE: ./node_modules/moize/dist/moize.min.js
var moize_min = __webpack_require__(24412);
var moize_min_default = /*#__PURE__*/__webpack_require__.n(moize_min);
// EXTERNAL MODULE: ./node_modules/rgb-lab/color.js
var rgb_lab_color = __webpack_require__(52298);
// EXTERNAL MODULE: ./node_modules/delta-e/src/index.js
var src = __webpack_require__(24508);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/color.js
function color_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = color_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function color_toConsumableArray(arr) { return color_arrayWithoutHoles(arr) || color_iterableToArray(arr) || color_unsupportedIterableToArray(arr) || color_nonIterableSpread(); }
function color_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function color_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return color_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return color_arrayLikeToArray(o, minLen); }
function color_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function color_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return color_arrayLikeToArray(arr); }
function color_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }




















var colorsCache = new Map();
function isCssVariable(string) {
  if (string.indexOf('var(--') >= 0) {
    return true;
  }
  return false;
}
function getRgbColor(color) {
  if (!colorsCache[color]) {
    colorsCache[color] = parse_color_default()(color);
    if (!colorsCache[color] || !colorsCache[color]) {
      console.error('could not parse color', color, 'fallback to black');
      colorsCache[color] = {
        rgb: [0, 0, 0]
      };
    }
  }
  return colorsCache[color].rgb;
}
function rgbToHex(r, g, b) {
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}
function componentToHex(c) {
  if (!c) {
    return '00';
  } else {
    var hex = c.toString(16);
    return hex.length == 1 ? '0' + hex : hex;
  }
}
var getLabColor = moize_min_default()(function (color) {
  var rgb = getRgbColor(color);
  return (0,rgb_lab_color/* rgb2lab */.Rw)(rgb);
});
var getRgbColorFromLab = moize_min_default()(function (labColor) {
  var rgb = getRgbColor(color);
  return (0,rgb_lab_color/* rgb2lab */.Rw)(rgb);
}, {
  isDeepEqual: true
});
function toLabObject(labArr) {
  return {
    L: labArr[0],
    A: labArr[1],
    B: labArr[2]
  };
}
var getClosestColor = moize_min_default()(function (color, fromColors, defaultColor) {
  var maxDelta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 20;
  if (color === 'transparent' || !color || isCssVariable(color) || color === 'initial') {
    return defaultColor;
  }
  var rgbColor = getRgbColor(color);
  if (!rgbColor) {
    return null;
  }
  var exceptions = ['#2f3738', '#161A1E', '#000000', '#ffffff'];
  var hexColor = rgbToHex.apply(void 0, color_toConsumableArray(rgbColor));
  if (hexColor && exceptions.indexOf(hexColor) !== -1) {
    return null;
  }
  var labColor = (0,rgb_lab_color/* rgb2lab */.Rw)(rgbColor);
  var closest = null;
  var closestDelta = Number.POSITIVE_INFINITY;
  var _iterator = color_createForOfIteratorHelper(fromColors),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var compareColor = _step.value;
      var compareLab = getLabColor(compareColor);
      var delta = src_default().getDeltaE00(toLabObject(labColor), toLabObject(compareLab));
      if (delta < closestDelta && delta < maxDelta) {
        closestDelta = delta;
        closest = compareColor;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return closest;
});
function isColorsEqual(color1, color2) {
  if (color1 === color2) {
    return true;
  }
  var c1 = parse_color_default()(color1);
  var c2 = parse_color_default()(color2);
  if (!c1.rgba || !c2.rgba) {
    return false;
  }
  return c1.rgba.join(',') === c2.rgba.join(',');
}
function isRealColor(color) {
  if (color === 'inherit') {
    return false;
  }
  return true;
}
/*
  @param color{string} - hex код цвета, например #000000
  @param opacity{string} - прозрачность цвета от 0 до 1
  @return {string} - rgba код цвета
*/
function hexToRgbaString(color) {
  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
  if (result) {
    var rgb = [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)];
    return 'rgba(' + rgb.join(', ') + ', ' + (opacity !== null ? opacity : '1') + ')';
  }
  return null;
}
function stringIsColor(string) {
  if (typeof string !== 'string') return false;
  if (string.startsWith('#')) {
    return string.length === 4 || string.length === 7;
  }
  return string.startsWith('rgb(') || string.startsWith('rgba(');
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/popupColorItem.js
function popupColorItem_extends() { popupColorItem_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return popupColorItem_extends.apply(this, arguments); }


function popupColorItem_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function PopupColorItem(props) {
  var idAttr = props.idAttr,
    selected = props.selected,
    colorValue = props.colorValue,
    colorName = props.colorName,
    mode = props.mode,
    useNewIcons = props.useNewIcons;
  var attrs = popupColorItem_defineProperty({}, idAttr, colorName);
  var style = {};
  var itemClassName = ['color-menu-item '];
  if (selected) {
    itemClassName.push('active');
  }
  if (mode && mode === 'disabled') {
    itemClassName.push('disabled');
  }
  var iconClassName = ['color-icon'];
  if (stringIsColor(colorValue)) {
    style.background = colorValue;
  } else {
    if (mode && typeof mode !== 'undefined') {
      iconClassName.push('color-icon-' + mode);
      switch (mode) {
        case 'default':
        case 'disabled':
          iconClassName.push("bg-palette-".concat(colorValue));
          break;
        case 'outline':
          iconClassName.push("shadow-palette-".concat(colorValue));
          break;
        case 'font':
          iconClassName.push("bg-not-opacity-palette-".concat(colorValue));
          break;
        case 'mat-font-color':
          iconClassName.push("bg-material-font-color-".concat(colorName));
          break;
        default:
          iconClassName.push(colorName + '-' + mode + '-color-icon');
      }
    } else {
      if (colorValue) {
        iconClassName.push("bg-palette-".concat(colorValue));
      }
    }
  }
  return (0,preact_module.h)("div", popupColorItem_extends({}, attrs, {
    onClick: props.onClick,
    onMouseDown: props.onMouseDown,
    className: itemClassName.join(' ')
  }), (0,preact_module.h)("div", {
    className: iconClassName.join(' '),
    "data-block-background": colorName,
    style: style
  }, useNewIcons ? (0,preact_module.h)("span", {
    className: "color-icon-label"
  }, "A") : null));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/popupColorPicker.js
function popupColorPicker_extends() { popupColorPicker_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return popupColorPicker_extends.apply(this, arguments); }





function popupColorPicker_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function popupColorPicker_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function popupColorPicker_createClass(Constructor, protoProps, staticProps) { if (protoProps) popupColorPicker_defineProperties(Constructor.prototype, protoProps); if (staticProps) popupColorPicker_defineProperties(Constructor, staticProps); return Constructor; }
function popupColorPicker_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var COLOR_ATTR = 'data-color-name';
var PopupColorPicker = /*#__PURE__*/function () {
  function PopupColorPicker() {
    popupColorPicker_classCallCheck(this, PopupColorPicker);
    popupColorPicker_defineProperty(this, "onMouseDown", function (event) {
      event.preventDefault();
    });
  }
  popupColorPicker_createClass(PopupColorPicker, [{
    key: "onItemClick",
    value: function onItemClick(color, event) {
      var _this$props = this.props,
        mode = _this$props.mode,
        onColorPicked = _this$props.onColorPicked;
      event.preventDefault();
      if (!mode || mode !== 'disabled') {
        onColorPicked && onColorPicked(color);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props2 = this.props,
        color = _this$props2.color,
        colors = _this$props2.colors,
        mode = _this$props2.mode;
      var resetColor = this.props.resetColor;
      if (typeof resetColor === 'undefined') {
        resetColor = true;
      }
      var colorsArray = Array.isArray(colors) ? Array.from(colors) : Object.keys(colors);
      var items = colorsArray.map(function (name) {
        return (0,preact_module.h)(PopupColorItem, {
          idAttr: COLOR_ATTR,
          key: name,
          onClick: _this.onItemClick.bind(_this, Array.isArray(colors) ? name : colors[name]),
          onMouseDown: _this.onMouseDown,
          colorValue: Array.isArray(colors) ? name : colors[name],
          colorName: name,
          selected: color === (Array.isArray(colors) ? name : colors[name]),
          mode: mode
        });
      });
      var noColorIcon = (0,preact_module.h)("div", {
        onClick: this.onItemClick.bind(this, null),
        className: 'color-menu-item'
      }, (0,preact_module.h)("div", {
        className: "color-icon no-color-icon"
      }, (0,preact_module.h)(icons/* IconNoColor */.voX, null)));
      return (0,preact_module.h)(popupMenu/* default */.Z, popupColorPicker_extends({
        addClassName: 'popup-menu-colorpicker'
      }, this.props), items, resetColor ? noColorIcon : null);
    }
  }]);
  return PopupColorPicker;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/interface/inputComponent.js











function inputComponent_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = inputComponent_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function inputComponent_slicedToArray(arr, i) { return inputComponent_arrayWithHoles(arr) || inputComponent_iterableToArrayLimit(arr, i) || inputComponent_unsupportedIterableToArray(arr, i) || inputComponent_nonIterableRest(); }
function inputComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function inputComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return inputComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return inputComponent_arrayLikeToArray(o, minLen); }
function inputComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function inputComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function inputComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }






/**
 * Поле ввода contenteditable с плейсхолдером
 * @param { string } value?: начальное значение
 * @param { string } type?: тип поля - text, number
 * @param { number } min?: минимальное значение
 * @param { number } max?: максимальное значение
 * @param { number } maxLength?: максимальная длина текста
 * @param { string } placeholder?: плейсхолдер для поля ввода
 * @param { boolean } autofocus?: автофокус при создании
 * @param { boolean } reset?: сброс введенного текста
 * @param { function } onInput?: вызывается при вводе каждого символа, возвращает event и значение поля
 * @param { function } onApply?: вызывается при enter, возвращает значение поля
 * @param { function } onClick?: вызывается при click в поле ввода
 * @param { function } onFocus?: вызывается при фокусе в поле ввода
 */
var COMMAND_KEYS = [{
  key: 'enter'
}, {
  key: 'esc'
}, {
  key: 'arrowup'
}, {
  key: 'arrowdown'
}, {
  key: 'backspace',
  empty: true
}];
function InputComponent(props) {
  var onInput = props.onInput,
    onApply = props.onApply,
    value = props.value,
    _props$autofocus = props.autofocus,
    autofocus = _props$autofocus === void 0 ? false : _props$autofocus,
    reset = props.reset,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
    type = props.type,
    min = props.min,
    max = props.max,
    maxLength = props.maxLength;
  var _useState = (0,hooks_module/* useState */.eJ)(''),
    _useState2 = inputComponent_slicedToArray(_useState, 2),
    text = _useState2[0],
    setText = _useState2[1];
  var inputRef = (0,hooks_module/* useRef */.sO)(null);
  var setValue = function setValue(val) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    val = String(val);
    if (inputRef !== null && inputRef !== void 0 && inputRef.current) {
      inputRef.current.textContent = val;
    }
    setText(val);
    if (options.cursor) [(0,dom/* contenteditableCursorToEnd */.FU)(inputRef.current)];
  };
  (0,hooks_module/* useEffect */.d4)(function () {
    if (reset) {
      setValue('');
    }
  }, [reset]);
  (0,hooks_module/* useEffect */.d4)(function () {
    if (typeof value === 'string' || typeof value === 'number') {
      setValue(String(value));
    }
  }, [value]);
  (0,hooks_module/* useEffect */.d4)(function () {
    if (autofocus && inputRef !== null && inputRef !== void 0 && inputRef.current) {
      (0,dom/* contenteditableCursorToEnd */.FU)(inputRef.current);
    }
  }, [inputRef, value]);
  var onChange = function onChange(event) {
    var textContent = inputRef.current.textContent;
    setText(textContent);
    if (event.inputType !== 'insertText') {
      onInput === null || onInput === void 0 ? void 0 : onInput(event, textContent);
    }
  };
  var onFocus = function onFocus(event) {
    var _props$onFocus;
    event.stopPropagation();
    (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 ? void 0 : _props$onFocus.call(props, event);
  };
  var isCommand = function isCommand(event) {
    var result = {
      state: false
    };
    var _iterator = inputComponent_createForOfIteratorHelper(COMMAND_KEYS),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        if ((0,lib/* default */.ZP)(item.key, event) && (!item.empty || !text)) {
          result.state = true;
          result.key = item.key;
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return result;
  };
  var onKeyDown = function onKeyDown(event) {
    var isCommandKey = isCommand(event);
    if (isCommandKey.state) {
      if (isCommandKey.key !== 'esc') {
        event.stopPropagation();
      }
      event.preventDefault();
      onInput === null || onInput === void 0 ? void 0 : onInput(event, text);
    } else {
      event.stopPropagation();
      var key = String(event.key);
      if (key.length === 1) {
        var _inputRef$current;
        if (maxLength && ((_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.textContent.length) >= maxLength) {
          event.preventDefault();
        } else if (type === 'number') {
          if (isNaN(key) || max && text.length >= String(max).length) {
            event.preventDefault();
          }
        }
      }
    }
  };
  var onKeyUp = function onKeyUp(event) {
    event.stopPropagation();
    var command = isCommand(event);
    if (!command.state) {
      var val = validate({
        write: true
      });
      onInput === null || onInput === void 0 ? void 0 : onInput(event, val);
    } else if (command.key === 'enter') {
      sendOnChange();
    }
  };
  var onMouseDown = function onMouseDown(event) {
    event.stopPropagation();
  };
  var onClick = function onClick(event) {
    var _props$onClick;
    event.stopPropagation();
    (_props$onClick = props.onClick) === null || _props$onClick === void 0 ? void 0 : _props$onClick.call(props, event);
  };
  var validate = function validate() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var val = text;
    if (type === 'number') {
      val = parseInt(val) || 0;
      if (typeof min === 'number' && options.min) {
        val = Math.max(val, min);
      }
      if (typeof max === 'number') {
        val = Math.min(val, max);
      }
    }
    if (options.write && String(val) !== text) {
      setValue(val, {
        cursor: true
      });
    }
    return val;
  };
  var sendOnChange = function sendOnChange() {
    var val = validate({
      min: true
    });
    onApply === null || onApply === void 0 ? void 0 : onApply(val);
  };
  var classes = ['input-component', util/* SELF_CONTROLLED_CONTENT_CLASS */.W$];
  var placeholderComponent;
  if (!text) {
    placeholderComponent = (0,preact_module.h)("span", {
      className: "input-placeholder editable-text"
    }, placeholder);
  }
  return (0,preact_module.h)("div", {
    className: classes.join(' '),
    onMouseDown: onMouseDown
  }, placeholderComponent, (0,preact_module.h)("span", {
    ref: inputRef,
    contenteditable: true,
    className: "input-field",
    onInput: onChange,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onClick: onClick,
    spellcheck: false
  }));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/palette.js





function getMaterialColorName(color) {
  if (matColorNames.includes(color)) return color;
  // пробуем получить название цвета из старой палитры по значению цвета
  var colorNamePalette = Object.keys(colors_palette).find(function (colorName) {
    return colors_palette[colorName] === color;
  });
  if (matColorNames.includes(colorNamePalette)) {
    return colorNamePalette;
  } else {
    // тут берем ассоциацию либо по названию цвета из старой палитры, либо по значению,
    // так как раньше, когда не было старой палитры, подставлялись значения цвета или еще более старая палитра
    var colorAssocName = matColorNamesAssoc[colorNamePalette] || matColorNamesAssoc[color];
    if (colorAssocName) {
      return colorAssocName;
    }
  }
  return color;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/inlineDropdown.js
function inlineDropdown_extends() { inlineDropdown_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return inlineDropdown_extends.apply(this, arguments); }
function inlineDropdown_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function inlineDropdown_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { inlineDropdown_ownKeys(Object(source), true).forEach(function (key) { inlineDropdown_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { inlineDropdown_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function inlineDropdown_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function inlineDropdown_toConsumableArray(arr) { return inlineDropdown_arrayWithoutHoles(arr) || inlineDropdown_iterableToArray(arr) || inlineDropdown_unsupportedIterableToArray(arr) || inlineDropdown_nonIterableSpread(); }
function inlineDropdown_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function inlineDropdown_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function inlineDropdown_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return inlineDropdown_arrayLikeToArray(arr); }
function inlineDropdown_slicedToArray(arr, i) { return inlineDropdown_arrayWithHoles(arr) || inlineDropdown_iterableToArrayLimit(arr, i) || inlineDropdown_unsupportedIterableToArray(arr, i) || inlineDropdown_nonIterableRest(); }
function inlineDropdown_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function inlineDropdown_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return inlineDropdown_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return inlineDropdown_arrayLikeToArray(o, minLen); }
function inlineDropdown_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function inlineDropdown_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function inlineDropdown_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




































var inlineDropdown_isEnterKey = (0,lib/* default */.ZP)('Enter');
var isEscKey = (0,lib/* default */.ZP)('Esc');
function getLabelClassName(label, style) {
  var labelClasses = ['select-label', 'adaptive-text'];
  var colorStylePrefix = 'bg-palette-';
  if (style && style !== 'default') {
    labelClasses.push('fill-' + style);
    if (style === 'outline') {
      colorStylePrefix = 'shadow-palette-';
    } else if (style === 'none') {
      colorStylePrefix = false;
    }
  }
  if (label.color && colorStylePrefix) {
    labelClasses.push(colorStylePrefix + label.color);
  }
  return labelClasses.join(' ');
}
function InlineDropdown(props) {
  var _props$labels = props.labels,
    labels = _props$labels === void 0 ? [] : _props$labels,
    _props$selected = props.selected,
    selected = _props$selected === void 0 ? null : _props$selected,
    style = props.style,
    onChange = props.onChange,
    onEndEdit = props.onEndEdit,
    ownerId = props.ownerId,
    userId = props.userId,
    getPopupParams = props.getPopupParams,
    i18n = props.i18n,
    canEdit = props.canEdit;
  var _useState = (0,hooks_module/* useState */.eJ)(false),
    _useState2 = inlineDropdown_slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var onClick = function onClick(event) {
    if (!canEdit) return;
    if (!open) {
      setOpen(true);
    }
  };
  var onUpdate = function onUpdate(value) {
    var _value$labels;
    if (value !== null && value !== void 0 && (_value$labels = value.labels) !== null && _value$labels !== void 0 && _value$labels.length) {
      onChange(value);
    } else {
      onChange(false);
    }
  };
  var wantsToClose = function wantsToClose() {
    setOpen(false);
    setTimeout(function () {
      onEndEdit();
    }, 0);
  };
  (0,hooks_module/* useEffect */.d4)(function () {
    if (!labels.length && ownerId === userId) {
      setOpen(true);
    }
  }, []);
  (0,hooks_module/* useEffect */.d4)(function () {
    var onDocumentMouseDown = function onDocumentMouseDown(event) {
      if (event.target !== props.domNode && !props.domNode.contains(event.target)) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener('mousedown', onDocumentMouseDown, false);
    }
    return function () {
      document.removeEventListener('mousedown', onDocumentMouseDown, false);
    };
  }, [open]);
  var selectedLabel = selected ? labels.find(function (label) {
    return String(label.id) === String(selected);
  }) : labels[0];
  return (0,preact_module.h)(preact_module/* Fragment */.HY, null, labels.length && selectedLabel ? (0,preact_module.h)("span", {
    className: "inline-dropdown-label",
    onClick: onClick
  }, (0,preact_module.h)("span", {
    className: getLabelClassName(selectedLabel, style)
  }, (0,preact_module.h)("span", {
    className: "select-label-text"
  }, selectedLabel.name))) : "\uFEFF", open ? (0,preact_module.h)(InlineDropdownListComponent, {
    labels: labels.slice(),
    selected: selected,
    style: style,
    onCloseApply: onUpdate,
    getPopupParams: getPopupParams,
    i18n: i18n,
    wantsToClose: wantsToClose
  }) : null);
}
function InlineDropdownListComponent(props) {
  var originLabels = props.labels,
    selectedLabel = props.selected,
    originStyle = props.style,
    onCloseApply = props.onCloseApply,
    getPopupParams = props.getPopupParams,
    i18n = props.i18n,
    wantsToClose = props.wantsToClose;
  var _useState3 = (0,hooks_module/* useState */.eJ)(originLabels),
    _useState4 = inlineDropdown_slicedToArray(_useState3, 2),
    labels = _useState4[0],
    setLabels = _useState4[1];
  var _useState5 = (0,hooks_module/* useState */.eJ)(selectedLabel),
    _useState6 = inlineDropdown_slicedToArray(_useState5, 2),
    selected = _useState6[0],
    setSelected = _useState6[1];
  var _useState7 = (0,hooks_module/* useState */.eJ)(originStyle),
    _useState8 = inlineDropdown_slicedToArray(_useState7, 2),
    style = _useState8[0],
    setStyle = _useState8[1];
  var _useState9 = (0,hooks_module/* useState */.eJ)(''),
    _useState10 = inlineDropdown_slicedToArray(_useState9, 2),
    search = _useState10[0],
    setSearch = _useState10[1];
  var _useState11 = (0,hooks_module/* useState */.eJ)(null),
    _useState12 = inlineDropdown_slicedToArray(_useState11, 2),
    showMenuId = _useState12[0],
    setMenuState = _useState12[1];
  var valueRef = (0,hooks_module/* useRef */.sO)({
    selected: selected,
    labels: labels,
    style: style
  });
  var inputRef = (0,hooks_module/* useRef */.sO)(null);
  var labelsRef = (0,hooks_module/* useRef */.sO)(null);
  var sortableRef = (0,hooks_module/* useRef */.sO)(null);
  var menuIdRef = (0,hooks_module/* useRef */.sO)(null);
  var filteredLabels = search ? labels.filter(function (label) {
    return label.name.toLowerCase().includes(search.toLowerCase());
  }) : labels;
  var getLabel = function getLabel(id) {
    return labels.find(function (label) {
      return String(label.id) === String(id);
    });
  };
  var onCreate = function onCreate(text) {
    var color = matColorNames[Math.floor(Math.random() * matColorNames.length)];
    var label = {
      name: text,
      color: color,
      id: new Date().getTime()
    };
    setLabels([].concat(inlineDropdown_toConsumableArray(labels), [label]));
  };
  var onUpdate = function onUpdate(labels) {
    setLabels(labels);
  };
  var onInput = function onInput(event) {
    setSearch(event.target.value.trim());
  };
  var onSearchSetLabel = function onSearchSetLabel(id) {
    valueRef.current = {
      selected: id,
      labels: labels,
      style: style
    };
    wantsToClose();
  };
  var onInputKeydown = function onInputKeydown(event) {
    if (inlineDropdown_isEnterKey(event)) {
      event.stopPropagation();
      event.preventDefault();
      var value = event.target.value.trim();
      if (!value) {
        wantsToClose();
      } else {
        var searchLabel = filteredLabels.find(function (label) {
          return label.name === value;
        });
        var create = !filteredLabels.length || !Boolean(searchLabel);
        if (create) {
          onCreate(value);
          setSearch('');
          setTimeout(function () {
            inputRef.current.value = '';
          }, 0);
        } else {
          if (searchLabel) {
            if (searchLabel.id !== selected) {
              onSearchSetLabel(searchLabel.id);
            } else {
              wantsToClose();
            }
          } else if (filteredLabels[0].id !== selected) {
            setSelected(filteredLabels[0].id);
          }
        }
      }
    }
  };
  var onCreateClick = function onCreateClick() {
    onCreate(search);
    setSearch('');
    setTimeout(function () {
      inputRef.current.value = '';
    }, 0);
  };
  var onSortableChange = function onSortableChange(items) {
    var sorted = items.reduce(function (arr, item) {
      var id = item.dataset.labelId;
      var label = getLabel(id);
      if (label) {
        arr.push(Object.assign({}, label));
      }
      return arr;
    }, []);
    onUpdate(sorted);
  };
  var onLabelSelect = function onLabelSelect(id) {
    setSelected(id);
  };
  var onLabelShowMenu = function onLabelShowMenu(labelId) {
    setMenuState(labelId);
  };
  var onLabelCloseMenu = function onLabelCloseMenu() {
    setMenuState(null);
  };
  var onLabelUpdate = function onLabelUpdate(label) {
    var toUpdate = Array.from(labels);
    var index = toUpdate.findIndex(function (lbl) {
      return lbl.id === label.id;
    });
    toUpdate.splice(index, 1, label);
    onUpdate(toUpdate);
  };
  var onUpdateStyle = function onUpdateStyle(value) {
    setStyle(value);
  };
  var onLabelDelete = function onLabelDelete(id) {
    var toUpdate = Array.from(labels);
    var index = toUpdate.findIndex(function (lbl) {
      return lbl.id === id;
    });
    toUpdate.splice(index, 1);
    if (selected && selected === id) {
      setSelected(null);
    }
    onUpdate(toUpdate);
  };
  (0,hooks_module/* useEffect */.d4)(function () {
    if (labelsRef.current) {
      sortableRef.current = new sortable(labelsRef.current, {
        selector: '.inline-dropdown-component-item',
        allowDraggingSelector: '.inline-dropdown-component-label-pin',
        onChange: onSortableChange,
        allowPullItemsOut: false,
        autoscroll: true
      });
      return function () {
        if (sortableRef.current) {
          sortableRef.current.destroy();
          sortableRef.current = null;
        }
      };
    }
  }, [labelsRef.current, labels]);
  (0,hooks_module/* useEffect */.d4)(function () {
    valueRef.current = {
      selected: selected,
      labels: labels,
      style: style
    };
  }, [selected, labels, style]);
  (0,hooks_module/* useEffect */.d4)(function () {
    menuIdRef.current = showMenuId;
  }, [showMenuId]);
  (0,hooks_module/* useEffect */.d4)(function () {
    if (inputRef.current) {
      inputRef.current.focus();
    }
    return function () {
      onCloseApply(valueRef.current);
    };
  }, []);
  (0,hooks_module/* useEffect */.d4)(function () {
    var onDocumentKeyDown = function onDocumentKeyDown(event) {
      if (isEscKey(event)) {
        if (menuIdRef.current) {
          setMenuState(null);
        } else {
          wantsToClose();
        }
      }
    };
    document.addEventListener('keydown', onDocumentKeyDown, false);
    return function () {
      document.removeEventListener('keydown', onDocumentKeyDown, false);
    };
  }, []);
  var classNames = ['inline-dropdown-component'];
  if (!labels.length && !search) {
    classNames.push('empty');
  }
  var popupParams = getPopupParams();
  if (popupParams.revertY) {
    classNames.push('direction-top');
  }
  if (popupParams.revertX) {
    classNames.push('direction-right');
  }
  return (0,preact_module.h)("div", {
    className: classNames.join(' ')
  }, (0,preact_module.h)("div", {
    className: "inline-dropdown-component-selected"
  }, (0,preact_module.h)(SelectedLabelComponent, {
    labels: labels,
    selected: selected,
    style: style,
    getLabel: getLabel
  }), (0,preact_module.h)("input", {
    className: "inline-dropdown-component-input",
    type: "text",
    ref: inputRef,
    onInput: onInput,
    onKeyDown: onInputKeydown,
    placeholder: i18n ? i18n.get('table.select.create_label') : 'Type to create label'
  })), filteredLabels.length || search.length ? (0,preact_module.h)("div", {
    className: 'inline-dropdown-component-labels' + (!filteredLabels.length ? 'no-labels' : ''),
    ref: labelsRef
  }, filteredLabels.length ? filteredLabels.map(function (label) {
    return (0,preact_module.h)("div", {
      className: "inline-dropdown-component-item",
      "data-label-id": label.id
    }, (0,preact_module.h)(LabelComponent, {
      label: label,
      style: style,
      onLabelSelect: onLabelSelect,
      onShowMenu: onLabelShowMenu,
      onCloseMenu: onLabelCloseMenu,
      onLabelUpdate: onLabelUpdate,
      onUpdateStyle: onUpdateStyle,
      onLabelDelete: onLabelDelete,
      menuActive: showMenuId === label.id,
      i18n: i18n
    }));
  }) : (0,preact_module.h)("div", {
    className: "inline-dropdown-component-item"
  }, (0,preact_module.h)("span", {
    className: "inline-dropdown-component-create",
    onClick: onCreateClick
  }, i18n ? i18n.get('table.select.create') : 'Create', " ", search))) : null);
}
function SelectedLabelComponent(_ref) {
  var labels = _ref.labels,
    selected = _ref.selected,
    style = _ref.style,
    getLabel = _ref.getLabel;
  if (!selected && !labels.length) return null;
  var label = selected ? getLabel(selected) : labels[0];
  return (0,preact_module.h)("span", {
    className: getLabelClassName(label, style)
  }, (0,preact_module.h)("span", {
    className: "select-label-text"
  }, label.name));
}
function LabelComponent(props) {
  var label = props.label,
    style = props.style,
    onLabelSelect = props.onLabelSelect,
    onShowMenu = props.onShowMenu,
    onCloseMenu = props.onCloseMenu,
    onLabelUpdate = props.onLabelUpdate,
    onUpdateStyle = props.onUpdateStyle,
    onLabelDelete = props.onLabelDelete,
    _props$menuActive = props.menuActive,
    menuActive = _props$menuActive === void 0 ? false : _props$menuActive,
    i18n = props.i18n;
  var menuRef = (0,hooks_module/* useRef */.sO)(null);
  var onLabelMenuClick = function onLabelMenuClick(event) {
    onShowMenu(label.id);
  };
  var onLabelClick = function onLabelClick() {
    onLabelSelect(label.id);
  };
  return (0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)("span", {
    ref: menuRef,
    className: "inline-dropdown-component-label-pin",
    onClick: onLabelMenuClick
  }, (0,preact_module.h)(icons/* IconMoreVertical */.nqv, null)), (0,preact_module.h)("span", {
    className: getLabelClassName(label, style),
    onClick: onLabelClick
  }, (0,preact_module.h)("span", {
    className: "select-label-text"
  }, label.name)), menuActive ? (0,preact_module.h)(LabelMenuComponent, {
    label: label,
    style: style,
    anchorNode: menuRef.current,
    getLabelClassName: getLabelClassName,
    wantsToClose: onCloseMenu,
    onLabelUpdate: onLabelUpdate,
    onUpdateStyle: onUpdateStyle,
    onLabelDelete: onLabelDelete,
    i18n: i18n
  }) : null);
}
function LabelMenuComponent(props) {
  var _this = this;
  var label = props.label,
    style = props.style,
    wantsToClose = props.wantsToClose,
    onLabelUpdate = props.onLabelUpdate,
    onUpdateStyle = props.onUpdateStyle,
    onLabelDelete = props.onLabelDelete,
    i18n = props.i18n;
  var styles = ['default', 'outline', 'none'];
  var onColorPicked = function onColorPicked(color) {
    onLabelUpdate(inlineDropdown_objectSpread(inlineDropdown_objectSpread({}, label), {
      color: color
    }));
    wantsToClose === null || wantsToClose === void 0 ? void 0 : wantsToClose();
  };
  var onStylePicked = function onStylePicked(value) {
    onUpdateStyle(value);
    wantsToClose === null || wantsToClose === void 0 ? void 0 : wantsToClose();
  };
  var onTextInput = function onTextInput(event, text) {
    if ((0,lib/* default */.ZP)('enter', event)) {
      var name = text.trim();
      if (name) {
        onLabelUpdate(inlineDropdown_objectSpread(inlineDropdown_objectSpread({}, label), {
          name: name
        }));
      }
      wantsToClose === null || wantsToClose === void 0 ? void 0 : wantsToClose();
    }
  };
  var onRemove = function onRemove(event) {
    event.stopPropagation();
    onLabelDelete(label.id);
    wantsToClose === null || wantsToClose === void 0 ? void 0 : wantsToClose();
  };
  var styleItems = styles.map(function (value) {
    var classes = [getLabelClassName(label, value)];
    if (value !== (style || 'default')) {
      classes.push('disabled');
    }
    return (0,preact_module.h)("span", {
      className: classes.join(' '),
      onClick: onStylePicked.bind(_this, value)
    }, (0,preact_module.h)("span", {
      className: "select-label-text adaptive-text"
    }, "\xA0A\xA0"));
  });
  return (0,preact_module.h)(popupMenu/* default */.Z, inlineDropdown_extends({}, props, {
    anchorOptions: {
      positionFixed: true
    }
  }), (0,preact_module.h)("div", {
    className: "menu-input menu-input-wide"
  }, (0,preact_module.h)(InputComponent, {
    autofocus: true,
    value: label.name,
    onInput: onTextInput
  })), (0,preact_module.h)("div", {
    className: "menu-block label-style-selection"
  }, styleItems), (0,preact_module.h)(PopupColorPicker, {
    resetColor: false,
    mode: label.style === 'none' ? 'disabled' : label.style || 'default',
    color: getMaterialColorName(label.color),
    colors: matColorNames,
    onColorPicked: onColorPicked,
    addClassName: "popup-menu-colorpicker popup-menu-wide popup-menu-builtin"
  }), (0,preact_module.h)(popupMenuItem/* default */.Z, {
    text: i18n ? i18n.get('table.select.delete') : 'Delete',
    onClick: onRemove
  }));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/dropdownList.js
function dropdownList_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { dropdownList_typeof = function _typeof(obj) { return typeof obj; }; } else { dropdownList_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return dropdownList_typeof(obj); }

















function dropdownList_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function dropdownList_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function dropdownList_createClass(Constructor, protoProps, staticProps) { if (protoProps) dropdownList_defineProperties(Constructor.prototype, protoProps); if (staticProps) dropdownList_defineProperties(Constructor, staticProps); return Constructor; }
function dropdownList_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) dropdownList_setPrototypeOf(subClass, superClass); }
function dropdownList_setPrototypeOf(o, p) { dropdownList_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return dropdownList_setPrototypeOf(o, p); }
function dropdownList_createSuper(Derived) { var hasNativeReflectConstruct = dropdownList_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = dropdownList_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = dropdownList_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return dropdownList_possibleConstructorReturn(this, result); }; }
function dropdownList_possibleConstructorReturn(self, call) { if (call && (dropdownList_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return dropdownList_assertThisInitialized(self); }
function dropdownList_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function dropdownList_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function dropdownList_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { dropdownList_get = Reflect.get; } else { dropdownList_get = function _get(target, property, receiver) { var base = dropdownList_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return dropdownList_get(target, property, receiver || target); }
function dropdownList_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = dropdownList_getPrototypeOf(object); if (object === null) break; } return object; }
function dropdownList_getPrototypeOf(o) { dropdownList_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return dropdownList_getPrototypeOf(o); }
function dropdownList_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var DropdownList = /*#__PURE__*/function (_InlineEmbed) {
  dropdownList_inherits(DropdownList, _InlineEmbed);
  var _super = dropdownList_createSuper(DropdownList);
  function DropdownList(node) {
    var _this;
    dropdownList_classCallCheck(this, DropdownList);
    _this = _super.call(this, node);
    dropdownList_defineProperty(dropdownList_assertThisInitialized(_this), "onChange", function (value) {
      if (value) {
        _this.domNode.dropdown = value;
        _this.domNode.setAttribute('data-update-time', new Date().getTime());
      } else {
        var _normalizeToStoredBlo = normalizeToStoredBlot(dropdownList_assertThisInitialized(_this)),
          scroll = _normalizeToStoredBlo.scroll;
        var offset = _this.offset(scroll);
        _this.remove();
        setTimeout(function () {
          scroll.selection.setRange({
            index: offset,
            length: 0
          });
        }, 0);
      }
      _this.render();
    });
    dropdownList_defineProperty(dropdownList_assertThisInitialized(_this), "onEndEdit", function () {
      var _normalizeToStoredBlo2 = normalizeToStoredBlot(dropdownList_assertThisInitialized(_this)),
        scroll = _normalizeToStoredBlo2.scroll;
      var offset = _this.offset(scroll);
      scroll.selection.setRange({
        index: offset + 1,
        length: 0
      });
    });
    dropdownList_defineProperty(dropdownList_assertThisInitialized(_this), "getPopupParams", function () {
      var _editor$getScrollingC;
      var _normalizeToStoredBlo3 = normalizeToStoredBlot(dropdownList_assertThisInitialized(_this)),
        editor = _normalizeToStoredBlo3.editor;
      var containerRect = editor === null || editor === void 0 ? void 0 : (_editor$getScrollingC = editor.getScrollingContainer()) === null || _editor$getScrollingC === void 0 ? void 0 : _editor$getScrollingC.getBoundingClientRect();
      var params = {};
      if (containerRect) {
        var rect = _this.domNode.getBoundingClientRect();
        if (containerRect.bottom - rect.top < 250) {
          params.revertY = true;
        }
        if (containerRect.right - rect.left < 200) {
          params.revertX = true;
        }
      }
      return params;
    });
    dropdownList_defineProperty(dropdownList_assertThisInitialized(_this), "onSelectionChange", function () {
      return;
    });
    _this.isSeparableByClickApplicable = true;
    _this.contentNode.classList.add('dropdown-list-component');
    _this.contentNode.classList.add(util/* SELF_CONTROLLED_CONTENT_CLASS */.W$);
    return _this;
  }
  dropdownList_createClass(DropdownList, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = dropdownList_get(dropdownList_getPrototypeOf(DropdownList.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      if (this.attached) return;
      this.attached = true;
      this.render();
    }
  }, {
    key: "onParentRenderUpdate",
    value: function onParentRenderUpdate() {
      this.render();
    }
  }, {
    key: "render",
    value: function render() {
      var blot = normalizeToStoredBlot(this);
      var editor = blot.editor;
      var _ref = this.domNode.dropdown || {
          labels: [],
          selected: null,
          style: 'default'
        },
        labels = _ref.labels,
        selected = _ref.selected,
        ownerId = _ref.ownerId,
        style = _ref.style;
      (0,preact_module/* render */.sY)((0,preact_module.h)(InlineDropdown, {
        labels: labels,
        selected: selected,
        style: style,
        domNode: this.domNode,
        onChange: this.onChange,
        onEndEdit: this.onEndEdit,
        ownerId: ownerId,
        userId: editor ? editor.store.userId : undefined,
        getPopupParams: this.getPopupParams,
        i18n: editor ? editor.plugins.i18n : undefined,
        canEdit: editor && editor.mode === MODE_EDIT && !blot.isBlotLocked
      }), this.contentNode);
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = dropdownList_get(dropdownList_getPrototypeOf(DropdownList.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      this.attached = null;
    }
  }, {
    key: "optimize",
    value: function optimize() {
      var _get4;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      (_get4 = dropdownList_get(dropdownList_getPrototypeOf(DropdownList.prototype), "optimize", this)).call.apply(_get4, [this].concat(args));
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      var node = this.domNode.cloneNode(true);
      return node.outerHTML;
    }
  }], [{
    key: "create",
    value: function create(value) {
      var node = dropdownList_get(dropdownList_getPrototypeOf(DropdownList), "create", this).call(this);
      node.setAttribute('data-update-time', new Date().getTime());
      if (value) {
        node.dropdown = value;
      } else {
        node.dropdown = {
          labels: [],
          selected: null,
          style: 'default'
        };
      }
      node.classList.add('inline-dropdown-list');
      return node;
    }
  }, {
    key: "value",
    value: function value(domNode) {
      return domNode.dropdown || {
        labels: [],
        selected: null,
        style: 'default'
      };
    }
  }, {
    key: "getOpText",
    value: function getOpText(op, children, editor) {
      var _op$dropdownList = op['dropdown-list'],
        labels = _op$dropdownList.labels,
        selected = _op$dropdownList.selected;
      var value = ' ';
      if (labels && labels.length) {
        if (!selected) {
          var _labels$shift;
          value += ((_labels$shift = labels.shift()) === null || _labels$shift === void 0 ? void 0 : _labels$shift.name) || '';
        } else {
          var index = labels.findIndex(function (label) {
            return label.id === selected;
          });
          if (index !== -1) {
            var _label$;
            var label = labels.splice(index, 1);
            value += ((_label$ = label[0]) === null || _label$ === void 0 ? void 0 : _label$.name) || '';
          }
        }
        if (labels.length) {
          value += ' ' + labels.map(function (label) {
            return (label === null || label === void 0 ? void 0 : label.name) || '';
          }).join(' ');
        }
      }
      return value;
    }
  }, {
    key: "onConvertBlotGetOp",
    value: function onConvertBlotGetOp(op) {
      return {
        insert: this.getOpText(op.insert)
      };
    }
  }]);
  return DropdownList;
}(InlineEmbed);

DropdownList.blotName = 'dropdown-list';
DropdownList.tagName = 'dropdown-list';
// EXTERNAL MODULE: ./node_modules/quill-delta/dist/AttributeMap.js
var AttributeMap = __webpack_require__(23328);
var AttributeMap_default = /*#__PURE__*/__webpack_require__.n(AttributeMap);
// EXTERNAL MODULE: ./node_modules/deep-equal/index.js
var deep_equal = __webpack_require__(35234);
var deep_equal_default = /*#__PURE__*/__webpack_require__.n(deep_equal);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.anchor.js
var es_string_anchor = __webpack_require__(15218);
// EXTERNAL MODULE: ./node_modules/clone/clone.js
var clone_clone = __webpack_require__(58575);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/relposition.js











function relposition_slicedToArray(arr, i) { return relposition_arrayWithHoles(arr) || relposition_iterableToArrayLimit(arr, i) || relposition_unsupportedIterableToArray(arr, i) || relposition_nonIterableRest(); }
function relposition_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function relposition_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return relposition_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return relposition_arrayLikeToArray(o, minLen); }
function relposition_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function relposition_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function relposition_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



/**
 * Расчитывает относильные позиции индексов слева и справа от текста
 * @param editor
 * @returns {{relLeft: RelativePosition, relRight: RelativePosition, doc: *, firstBlot: *, lastBlot: *}}
 */
var getRelativePosition = function getRelativePosition(editor) {
  var onlySelectedBlots = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _editor$scroll$select = editor.scroll.selection.getRange(),
    _editor$scroll$select2 = relposition_slicedToArray(_editor$scroll$select, 2),
    editorRange = _editor$scroll$select2[0],
    nativeRange = _editor$scroll$select2[1];
  if (!editorRange) {
    return null;
  }
  var firstBlot = normalizeToStoredBlot(getBlotForNode(nativeRange.start.node));
  var lastBlot = normalizeToStoredBlot(getBlotForNode(nativeRange.end.node));
  if (onlySelectedBlots) {
    var selectedBlots = Array.from(editor.scroll.selectedBlocks);
    firstBlot = selectedBlots.shift();
    if (selectedBlots.length) {
      lastBlot = selectedBlots.pop();
    } else {
      lastBlot = firstBlot;
    }
  }
  if (!firstBlot || !lastBlot || firstBlot && !firstBlot.map || lastBlot && !lastBlot.map) {
    return null;
  }
  var _editor$scroll$select3 = editor.scroll.selection.getRange({
      offsetBlot: firstBlot,
      nativeRange: nativeRange,
      editorRange: editorRange
    }),
    _editor$scroll$select4 = relposition_slicedToArray(_editor$scroll$select3, 1),
    leftIndex = _editor$scroll$select4[0].index;
  var _editor$scroll$select5 = editor.scroll.selection.getRange({
      offsetBlot: lastBlot,
      nativeRange: nativeRange,
      editorRange: editorRange
    }),
    _editor$scroll$select6 = relposition_slicedToArray(_editor$scroll$select5, 1),
    _editor$scroll$select7 = _editor$scroll$select6[0],
    rightIndex = _editor$scroll$select7.index,
    rightLength = _editor$scroll$select7.length;
  var textLeft = firstBlot.map.get('characters');
  var textRight = lastBlot.map.get('characters');
  if (!textLeft || !textRight) {
    return null;
  }

  // позиция слева от текста
  var relLeft = yjs.createRelativePositionFromTypeIndex(textLeft, leftIndex);
  // позиция справа от текста
  var relRight = yjs.createRelativePositionFromTypeIndex(textRight, rightIndex + rightLength, -1);
  return {
    relLeft: relLeft,
    relRight: relRight,
    firstBlot: firstBlot,
    lastBlot: lastBlot,
    doc: editor.store.y
  };
};

/**
 * Конвертирует относительную позицию в абсолютную
 * @param relLeft
 * @param relRight
 * @param firstBlot
 * @param lastBlot
 * @param doc
 * @returns {{length: number, index: *}}
 */
var getAbsolutePosition = function getAbsolutePosition(_ref) {
  var relLeft = _ref.relLeft,
    relRight = _ref.relRight,
    firstBlot = _ref.firstBlot,
    lastBlot = _ref.lastBlot,
    doc = _ref.doc;
  var posLeft = yjs.createAbsolutePositionFromRelativePosition(relLeft, doc);
  var posRight = yjs.createAbsolutePositionFromRelativePosition(relRight, doc);
  var index = firstBlot.offset(firstBlot.scroll) + posLeft.index;
  var length = lastBlot.offset(lastBlot.scroll) + posRight.index - posLeft.index - firstBlot.offset(firstBlot.scroll);
  return {
    index: index,
    length: length
  };
};
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/selection.js
function selection_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = selection_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function selection_toConsumableArray(arr) { return selection_arrayWithoutHoles(arr) || selection_iterableToArray(arr) || selection_unsupportedIterableToArray(arr) || selection_nonIterableSpread(); }
function selection_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function selection_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function selection_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return selection_arrayLikeToArray(arr); }
function selection_slicedToArray(arr, i) { return selection_arrayWithHoles(arr) || selection_iterableToArrayLimit(arr, i) || selection_unsupportedIterableToArray(arr, i) || selection_nonIterableRest(); }
function selection_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function selection_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return selection_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return selection_arrayLikeToArray(o, minLen); }
function selection_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function selection_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function selection_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


















function selection_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function selection_createClass(Constructor, protoProps, staticProps) { if (protoProps) selection_defineProperties(Constructor.prototype, protoProps); if (staticProps) selection_defineProperties(Constructor, staticProps); return Constructor; }
function selection_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function selection_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








// selection spy
/* var s = getSelection()
let oldRemoveAllRanges = s.removeAllRanges
let oldAddRange = s.addRange
s.removeAllRanges = function() {
  console.log('Remove all ranges', new Error().stack)
  return oldRemoveAllRanges.apply(s)
}
s.addRange = function(range) {
  console.log(
    'Add range',
    'start', range.startContainer, range.startOffset,
    'end', range.endContainer, range.endOffset,
    'commonAncestor', range.commonAncestorContainer.outerHTML,
    new Error().stack
  )
  let res = oldAddRange.apply(s, [range])
  return res
} */
var selection_Range = function Range(index) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  selection_classCallCheck(this, Range);
  this.index = index;
  this.length = length;
};
var Selection = /*#__PURE__*/function () {
  function Selection(scroll, emitter) {
    var _this = this;
    selection_classCallCheck(this, Selection);
    selection_defineProperty(this, "onEditorReady", function () {
      if (_this.editor.mode === MODE_LITE) {
        _this.focus({
          setCaretToEnd: true
        });
      }
    });
    this.scroll = scroll;
    this.emitter = emitter;
    this.editor = this.scroll.editor;
    this.composing = false;
    this.mouseDown = false;
    this.root = this.scroll.domNode;
    var isRendered = this.editor.options.render;
    this.cursor = isRendered ? src_parchment.create('cursor', this) : null;
    this.lastRange = this.savedRange = new selection_Range(0, 0);
    this.lastRelPosition = null;
    this.savedNativeRange;
    this.lastOffset = false;
    this.lastTableSel = false;
    this.lastTableCur = false;
    this.savedFormats = false;
    this._rangeStack = [];
    this.ignoringScrollUpdates = false;
    this.prevSelection = null;
    this.updatesPaused = false;
    this.hasUpdatesDuringPause = false;
    if (isRendered) {
      this.handleComposition();
      this.emitter.listenDOM('selectionchange', document, function () {
        var isUserSelecting = _this.checkUserSelecting(getSelection());
        _this.update('user', {
          isUserSelecting: isUserSelecting
        });
      });
      this.emitter.listenDOM('mousedown', document, function () {
        _this.prevSelection = null;
      });
      this.emitter.on('SCROLL_UPDATE', function () {
        _this.update('silent');
      });
    }

    // denis: пока закоменчиваю т.к. у нас не всегда после SCROLL_BEFORE_UPDATE вызывается BLOCK_UPDATE
    // и когда потом вызывается BLOCK_UPDATE то он устаналвивает устаревшее выделение
    // не ясно зачем этот код нужен в quill, возможно для сохранения выделения при совместной работе
    // UPD 2018.12.07: смотри ниже для чего этот код
    /*
    this.emitter.on('SCROLL_BEFORE_UPDATE', () => {
      if (!this.hasFocus()) return;
      let native = this.getNativeRange();
      if (native == null) return;
      if (native.start.node === this.cursor.textNode) return;  // cursor.restore() will handle
      // TODO unclear if this has negative side effects
      this.emitter.once('BLOCK_UPDATE', () => {
        try {
          this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
        } catch (ignored) {}
      });
    });
    */

    // установка выделения нужна для следующего случая:
    // если в параграфе есть контент:
    // <a href="http://google.com/" target="_blank"><strong>google.coma</strong></a>
    // далее юзер печает символ "b" после этой ссылки
    // Хром превращает HTML в такой:
    // <strong><a href="http://google.com/" target="_blank">google.coma</a>b</strong>
    // Parchment после изменения хрома, меняет html на такой:
    // <a href="http://google.com/" target="_blank"><strong>google.coma</strong></a><strong>b</strong>
    // после удаления <strong> вехнего уровня парчментом, Хром ставит каретку перед удаленным контентом
    // после добавления контента парчментом она там и остается
    //
    // этот код сохраняет range перед обработкой мутаций и восстанавливает его после
    // баг связанный с этим #459

    if (isRendered) {
      this.emitter.on('SCROLL_BEFORE_UPDATE', function () {
        if (!_this.hasFocus()) return;
        var native = _this.getNativeRange();
        if (native == null) return;
        if (!native.native.collapsed) {
          // обрабатываем только коллапсированные выделения
          return;
        }
        _this.emitter.once('SCROLL_UPDATE', function (source, mutations) {
          if (_this.ignoringScrollUpdates || source !== 'user') {
            return;
          }
          try {
            var currentNativeRange = _this.getNativeRange();
            // восстанавливаем range только если выделение изменено
            if ((currentNativeRange.start.node !== native.start.node || currentNativeRange.start.offset !== native.start.offset || currentNativeRange.end.node !== native.end.node || currentNativeRange.end.offset !== native.end.offset) && _this.root.contains(native.start.node) && _this.root.contains(native.end.node)) {
              _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
            }
            _this.update('silent');
          } catch (ignored) {
            console.warn('fail to set native range', native, ignored);
          }
        });
      });
      this.emitter.on('SCROLL_OPTIMIZE', function (mutations, context) {
        if (context.range) {
          var _context$range = context.range,
            startNode = _context$range.startNode,
            startOffset = _context$range.startOffset,
            endNode = _context$range.endNode,
            endOffset = _context$range.endOffset;
          _this.emitter.once('SCROLL_UPDATE', function () {
            if (_this.ignoringScrollUpdates) {
              return;
            }
            try {
              _this.setNativeRange(startNode, startOffset, endNode, endOffset);
              _this.update('silent');
            } catch (ignored) {
              console.warn('fail to set native range', context.range, ignored);
            }
          });
        }
      });
      this.update('silent');
    }
    this.emitter.once('editor-ready', this.onEditorReady);
  }
  selection_createClass(Selection, [{
    key: "containsBlot",
    value: function containsBlot(blot) {
      return window.getSelection().containsNode(blot.domNode, true);
    }
  }, {
    key: "pauseUpdates",
    value: function pauseUpdates() {
      this.updatesPaused = true;
      this.hasUpdatesDuringPause = false;
    }
  }, {
    key: "resumeUpdates",
    value: function resumeUpdates() {
      this.updatesPaused = false;
      if (this.hasUpdatesDuringPause) {
        this.update();
      }
    }
  }, {
    key: "ignoreScrollUpdates",
    value: function ignoreScrollUpdates(fn) {
      try {
        this.ignoringScrollUpdates = true;
        fn();
      } finally {
        this.ignoringScrollUpdates = false;
      }
    }

    // детект процесса выделения юзером - когда тянет за мышку, когда держит шифт и выделяет стрелками
    // и другие варианты, этот метод работает независимо от этих вариантов выделения
  }, {
    key: "checkUserSelecting",
    value: function checkUserSelecting(selection) {
      var userSelecting = false;
      if (this.prevSelection) {
        var p = this.prevSelection;
        if (selection.type !== 'Caret' && p.anchor.node === selection.anchorNode && p.anchor.offset === selection.anchorOffset && (p.focus.node !== selection.focusNode || p.focus.offset !== selection.focusOffset)) {
          userSelecting = true;
        } else {
          userSelecting = false;
        }
      }
      this.prevSelection = {
        anchor: {
          node: selection.anchorNode,
          offset: selection.anchorOffset
        },
        focus: {
          node: selection.focusNode,
          offset: selection.focusOffset
        }
      };
      return userSelecting;
    }
  }, {
    key: "handleComposition",
    value: function handleComposition() {
      var _this2 = this;
      this.root.addEventListener('compositionstart', function () {
        _this2.composing = true;
      });
      this.root.addEventListener('compositionend', function () {
        _this2.composing = false;
        if (_this2.cursor.parent) {
          var range = _this2.cursor.restore();
          if (!range) return;
          setTimeout(function () {
            _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
          }, 1);
        }
      });
    }
  }, {
    key: "hasFocus",
    value: function hasFocus() {
      return document.activeElement && (document.activeElement === this.root || this.root.contains(document.activeElement));
    }
  }, {
    key: "focus",
    value: function focus() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (this.hasFocus()) return;
      this.root.focus({
        preventScroll: params.preventScroll ? true : false
      });
      if (this.editor.isEditable()) {
        this.root.setAttribute('contenteditable', true);
        var needSetRange = true;
        var range = this.savedRange;
        if (params.setCaretToEnd) {
          range = {
            index: this.scroll.length() - 1,
            length: 0
          };
        } else {
          var currentRange = this.scroll.selection.getRange()[0];
          if (currentRange && this.savedRange && currentRange.index === this.savedRange.index && currentRange.length === this.savedRange.length) {
            // if range is the same do not need to set it
            needSetRange = false;
          }
        }
        if (needSetRange) {
          this.setRange(range);
        }
      }
    }
  }, {
    key: "getBounds",
    value: function getBounds(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var scrollLength = this.scroll.length();
      index = Math.min(index, scrollLength - 1);
      length = Math.min(index + length, scrollLength - 1) - index;
      var node,
        _this$scroll$leaf = this.scroll.leaf(index),
        _this$scroll$leaf2 = selection_slicedToArray(_this$scroll$leaf, 2),
        leaf = _this$scroll$leaf2[0],
        offset = _this$scroll$leaf2[1];
      if (leaf == null) return null;
      var _leaf$position = leaf.position(offset, true);
      var _leaf$position2 = selection_slicedToArray(_leaf$position, 2);
      node = _leaf$position2[0];
      offset = _leaf$position2[1];
      var range = document.createRange();
      if (length > 0) {
        range.setStart(node, offset);
        var _this$scroll$leaf3 = this.scroll.leaf(index + length);
        var _this$scroll$leaf4 = selection_slicedToArray(_this$scroll$leaf3, 2);
        leaf = _this$scroll$leaf4[0];
        offset = _this$scroll$leaf4[1];
        if (leaf == null) return null;
        var _leaf$position3 = leaf.position(offset, true);
        var _leaf$position4 = selection_slicedToArray(_leaf$position3, 2);
        node = _leaf$position4[0];
        offset = _leaf$position4[1];
        range.setEnd(node, offset);
        return range.getBoundingClientRect();
      } else {
        var side = 'left';
        var rect;
        if (node instanceof Text) {
          if (offset < node.data.length) {
            range.setStart(node, offset);
            range.setEnd(node, offset + 1);
          } else {
            range.setStart(node, offset - 1);
            range.setEnd(node, offset);
            side = 'right';
          }
          rect = range.getBoundingClientRect();
        } else {
          rect = leaf.domNode.getBoundingClientRect();
          if (offset > 0) side = 'right';
        }
        return {
          bottom: rect.top + rect.height,
          height: rect.height,
          left: rect[side],
          right: rect[side],
          top: rect.top,
          width: 0
        };
      }
    }
  }, {
    key: "setCursorToEmpty",
    value: function setCursorToEmpty(el) {
      var range = document.createRange();
      var sel = window.getSelection();
      range.setEndBefore(el, 0);
      range.collapse(true);
      sel.removeAllRanges();
      sel.addRange(range);
    }
  }, {
    key: "getBlotsOfSelection",
    value: function getBlotsOfSelection() {
      var getBlot = function getBlot(node) {
        return node.__blot.blot;
      };
      var sel = window.getSelection();
      if (sel.type == 'Range') {
        var range = sel.getRangeAt(0);
        return {
          start: getBlot(range.startContainer),
          end: getBlot(range.endContainer)
        };
      } else if (sel.type == 'Caret') {
        return false;
      } else {
        return false;
      }
    }
  }, {
    key: "getSelectedBlocks",
    value: function getSelectedBlocks(range) {
      var startBlock = range.getStart();
      var endBlock = range.getEnd();
      var blocks = [];
      blocks.push(startBlock);
      for (var i = startBlock.index + 1; i < endBlock.index; i++) {
        blocks.push(this.scroll.getByIndex(i));
      }
      return blocks;
    }
  }, {
    key: "getColsOfSelection",
    value: function getColsOfSelection() {
      var getBlot = function getBlot(node) {
        return node.__blot.blot;
      };
      var sel = window.getSelection();
      if (sel.type == 'Range' || sel.type == 'Caret') {
        var range = sel.getRangeAt(0);
        return {
          start: getBlot(range.startContainer),
          end: getBlot(range.endContainer)
        };
      } else {
        return false;
      }
    }
  }, {
    key: "getScrollSelection",
    value: function getScrollSelection() {
      var sel = window.getSelection();
      if (sel.anchorNode == this.root && sel.baseNode == this.root && sel.extentNode == this.root && sel.focusNode == this.root) {
        return 'embed';
      } else {
        return 'block';
      }
    }
  }, {
    key: "clearSelection",
    value: function clearSelection() {
      var sel = window.getSelection();
      sel.removeAllRanges();
    }
  }, {
    key: "setNativeRange",
    value: function setNativeRange(startNode, startOffset) {
      var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
      var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
      var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var reverse = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) {
        return;
      }
      var selection = document && document.getSelection() || null;
      if (selection == null) return;
      if (startNode != null) {
        var _ref = this.getNativeRange() || {},
          native = _ref.native;
        if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
          if (startNode.tagName == "BR") {
            startOffset = Array.from(startNode.parentNode.childNodes).indexOf(startNode);
            startNode = startNode.parentNode;
          }
          if (endNode.tagName == "BR") {
            endOffset = Array.from(endNode.parentNode.childNodes).indexOf(endNode);
            endNode = endNode.parentNode;
          }
          if (this.editor.options.keyboardMode === 'mobile' && startOffset === endOffset && startNode === endNode) {
            // Используем collapse() для мобильного редактора, чтобы избежать сворачивания клавиатуры в андроиде
            selection.collapse(startNode, Math.min(startOffset, (startNode.textContent || '').length));
          } else {
            var range = document.createRange();
            // тут разложил на условия отдельные чтобы не писать в одну строку и было понятно
            if (startOffset >= 0) {
              range.setStart(startNode, startOffset);
            } else {
              range.setStart(startNode, 0);
            }
            if (endOffset >= 0) {
              range.setEnd(endNode, endOffset);
            } else {
              range.setEnd(endNode, 0);
            }
            selection.removeAllRanges();
            selection.addRange(range);
          }
          //для правильной работы shift + arrow left/right (выделения с клавиатуры), нужно развернуть выделение, если это необходимо
          if (reverse) {
            selection.setBaseAndExtent(selection.focusNode, selection.focusOffset, selection.anchorNode, selection.anchorOffset);
          }
        }
      } else {
        selection.removeAllRanges();
        this.root.blur();
        document.body.focus();
      }
    }

    //было ли выделение справа налево?
  }, {
    key: "nativeRangeReversed",
    value: function nativeRangeReversed(selection) {
      var position = selection.anchorNode.compareDocumentPosition(selection.focusNode);
      var reversed = false;
      if (!position && selection.anchorOffset > selection.focusOffset || position === Node.DOCUMENT_POSITION_PRECEDING) reversed = true;
      return reversed;
    }
  }, {
    key: "getNativeRange",
    value: function getNativeRange() {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      var selection = document && document.getSelection() || null;
      if (selection == null || selection.rangeCount <= 0) return null;
      var nativeRange = selection.getRangeAt(0);
      if (nativeRange == null) return null;
      var range = this.normalizeNative(nativeRange);
      if (range) {
        range.reversed = this.nativeRangeReversed(selection);
      }
      callback(range);
      return range;
    }
  }, {
    key: "normalizeNative",
    value: function normalizeNative(nativeRange) {
      if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) {
        return null;
      }
      var nonTextStartContainer = nativeRange.startContainer.nodeType === Node.TEXT_NODE ? nativeRange.startContainer.parentNode : nativeRange.startContainer;
      if (nonTextStartContainer.closest && nonTextStartContainer.closest('.' + util/* SELF_CONTROLLED_CONTENT_CLASS */.W$)) {
        // элемент в котором находится выделение является недоступным для общего редактирования
        return null;
      }
      var range = {
        start: {
          node: nativeRange.startContainer,
          offset: nativeRange.startOffset
        },
        end: {
          node: nativeRange.endContainer,
          offset: nativeRange.endOffset
        },
        native: nativeRange
      };
      [range.start, range.end].forEach(function (position) {
        var node = position.node,
          offset = position.offset;
        while (!(node instanceof Text) && node.childNodes.length > 0) {
          if (node.childNodes.length > offset) {
            node = node.childNodes[offset];
            offset = 0;
          } else if (node.childNodes.length === offset) {
            node = node.lastChild;
            offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
          } else {
            break;
          }
        }
        position.node = node, position.offset = offset;
      });
      return range;
    }
  }, {
    key: "pushRange",
    value: function pushRange() {
      var rangeData = this.getRange();
      this._rangeStack.push(rangeData);
    }
  }, {
    key: "popRange",
    value: function popRange() {
      var rangeData = this._rangeStack.pop();
      this.setRange(rangeData[0]);
    }

    /**
     * options.nativeRange - нативное выделение полученное через this.getNativeRange(), можно передать для ускорения работы функции, например для получения ренджа c offsetBlot
     * options.editorRange - можно передать для ускорения работы функции, например для получения ренджа c offsetBlot
     * options.offsetBlot - блот относительно которого рассчитывать объект EditorRange
     *
     * @return [ EditorRange, NativeRange ]
     * */
  }, {
    key: "getRange",
    value: function getRange() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var normalized = options.nativeRange || this.getNativeRange();
      if (normalized == null) return [null, null];
      var range = options.editorRange || this.normalizedToRange(normalized);
      if (options.offsetBlot) {
        // надо вычислить позицию выделения относительного заданного блота
        var offsetFromScroll = options.offsetBlot.offset(this.scroll);
        // позиция выделения внутри offsetBlot
        var index = Math.max(range.index - offsetFromScroll, 0);
        // длина выделения внутри offsetBlot(предварительная т.к. не учитывается длина самого offsetBlot)
        var length = Math.min(range.index - offsetFromScroll + range.length, range.length);
        var newRange = new selection_Range(index, Math.min(length, options.offsetBlot.length() - index - 1));
        range = newRange;
      }
      return [range, normalized];
    }
  }, {
    key: "normalizedToRange",
    value: function normalizedToRange(range) {
      var _this3 = this;
      var positions = [[range.start.node, range.start.offset]];
      if (!range.native.collapsed) {
        positions.push([range.end.node, range.end.offset]);
      }
      var indexes = positions.map(function (position) {
        var _position = selection_slicedToArray(position, 2),
          node = _position[0],
          offset = _position[1];
        var blot = src_parchment.find(node, true);
        var index = blot.offset(_this3.scroll);
        if (offset === 0) {
          return index;
        } else if (blot instanceof src_parchment.Container) {
          return index + blot.length();
        } else {
          if (typeof blot.index == 'function') {
            return index + blot.index(node, offset);
          } else {
            return index + blot.index;
          }
        }
      });
      var end = Math.min(Math.max.apply(Math, selection_toConsumableArray(indexes)), this.scroll.length() - 1);
      var start = Math.min.apply(Math, [end].concat(selection_toConsumableArray(indexes)));
      return new selection_Range(start, end - start);
    }
  }, {
    key: "rangeToNative",
    value: function rangeToNative(range) {
      var _this4 = this;
      var indexes = range.collapsed ? [range.index] : [range.index, range.index + range.length];
      var args = [];
      var scrollLength = this.scroll.length();
      indexes.forEach(function (index, i) {
        var indexOrig = index;
        index = Math.min(scrollLength - 1, index);
        var node,
          _this4$scroll$leaf = _this4.scroll.leaf(index),
          _this4$scroll$leaf2 = selection_slicedToArray(_this4$scroll$leaf, 2),
          leaf = _this4$scroll$leaf2[0],
          offset = _this4$scroll$leaf2[1];
        if (leaf && leaf.position) {
          // leaf.position can be undefined
          ;
          var _leaf$position5 = leaf.position(offset, i !== 0);
          var _leaf$position6 = selection_slicedToArray(_leaf$position5, 2);
          node = _leaf$position6[0];
          offset = _leaf$position6[1];
        }
        // из-за того что в quill текстовый блот всегда имеет длину текста + 1(а у нас нет) нам надо обходить это с помощью
        // уменьшения индекса на 1 для поиска и затем увеличения offset на 1, если этого не делать то последний символ в тексте
        // не выделится
        if (index < indexOrig) {
          offset += 1;
        }
        args.push(node, offset);
      });
      if (args.length < 2) {
        args = args.concat(args);
      }
      return args;
    }
  }, {
    key: "scrollIntoView",
    value: function scrollIntoView(scrollingContainer) {
      try {
        var range = this.lastRange;
        if (range == null) return;
        var bounds = this.getBounds(range.index, range.length);
        if (bounds == null) return;
        var limit = this.scroll.length() - 1;
        var _this$scroll$line = this.scroll.line(Math.min(range.index, limit)),
          _this$scroll$line2 = selection_slicedToArray(_this$scroll$line, 1),
          first = _this$scroll$line2[0];
        var last = first;
        if (range.length > 0) {
          var _this$scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));
          var _this$scroll$line4 = selection_slicedToArray(_this$scroll$line3, 1);
          last = _this$scroll$line4[0];
        }
        if (first == null || last == null) return;
        var scrollBounds = scrollingContainer.getBoundingClientRect();
        if (bounds.top < scrollBounds.top) {
          scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
        } else if (bounds.bottom > scrollBounds.bottom) {
          scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
        }
      } catch (err) {
        console.error('Selection.scrollIntoView has failed', scrollingContainer, err);
      }
    }
  }, {
    key: "setRange",
    value: function setRange(range) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'api';
      if (typeof force === 'string') {
        source = force;
        force = false;
      }
      if (range != null) {
        var args = this.rangeToNative(range);
        this.setNativeRange.apply(this, selection_toConsumableArray(args).concat([force]));
      } else {
        this.setNativeRange(null);
      }
      this.update(source, {
        fromSetRange: true
      });
    }
  }, {
    key: "format",
    value: function format(_format, value) {
      this.scroll.update();
      var nativeRange = this.getNativeRange();
      if (nativeRange == null || !nativeRange.native.collapsed || src_parchment.query(_format, src_parchment.Scope.BLOCK)) return;
      if (nativeRange.start.node !== this.cursor.textNode) {
        var blot = src_parchment.find(nativeRange.start.node, false);
        if (blot == null) return;
        // TODO Give blot ability to not split
        if (blot instanceof src_parchment.Leaf) {
          var after = blot.split(nativeRange.start.offset);
          blot.parent.insertBefore(this.cursor, after);
        } else {
          blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
        }

        this.cursor.attach();
      }
      this.cursor.format(_format, value);
      this.scroll.optimize();
      this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
    }
  }, {
    key: "update",
    value: function update() {
      var _this$emitter;
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'user';
      var misc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (source === 'user') {
        if (this.updatesPaused) {
          this.hasUpdatesDuringPause = true;
          return;
        }
      }
      var browser = this.editor.browser;
      var oldRange = this.lastRange;
      var _this$getRange = this.getRange(),
        _this$getRange2 = selection_slicedToArray(_this$getRange, 2),
        lastRange = _this$getRange2[0],
        nativeRange = _this$getRange2[1];

      // исправление позиции каретки если она становится в скролл блот
      // безопасно можем исправить только если в скролл блоте всего один дочерний блот
      // иначе может произойти непредвиденный скролл вверх.
      // эта ситуация может произойти с удалением всех блотов в Firefox
      if (nativeRange && nativeRange.native && nativeRange.native.startContainer === this.scroll.domNode && lastRange.length === 0 && this.scroll.children.length === 1 && (!misc || !misc.fromSetRange)) {
        return this.setRange({
          index: 0,
          length: 0
        });
      }
      this.lastRange = lastRange;
      if (this.lastRange != null) {
        this.savedRange = this.lastRange;
      }
      try {
        var _findNextImgORTable = function _findNextImgORTable(block, callback) {
          if (block.nextSibling) {
            if (!block.nextSibling.classList.contains('image') && !block.nextSibling.classList.contains('table-wrapper')) {
              callback(block.nextSibling);
            } else {
              _findNextImgORTable(block.nextSibling, callback);
            }
          } else {
            callback(false);
          }
        };
        var findNextImgORTable = function findNextImgORTable(node) {
          var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
          if (node.nodeName == 'IMG' || node.nodeName == 'TABLE') {
            _findNextImgORTable(node.parentElement, function (ans) {
              callback(ans);
            });
          } else if (node.nodeName == '#text') {
            findNextImgORTable(node.parentElement, callback);
          } else if (node.classList.contains('note-container')) {
            callback(false);
          } else {
            findNextImgORTable(node.parentElement, callback);
          }
        };
        findNextImgORTable(nativeRange.start.node, function (ans) {
          if (ans) {
            nativeRange.start = {
              node: ans,
              offset: 0
            };
          }
        });
      } catch (ignored) {}

      //firefox fix ctrl + a in table cell
      /*
      if (nativeRange != null &&
            browser == 'Firefox' &&
              equal(nativeRange.start, nativeRange.end) &&
                nativeRange.native.collapsed &&
                  (Parchment.find(nativeRange.native.commonAncestorContainer) instanceof Parchment.Block) &&
                    nativeRange.native.startOffset == 0 &&
                      nativeRange.native.endOffset == 0 &&
                        Parchment.find(nativeRange.native.commonAncestorContainer).length() != 0) {
         this.setNativeRange(nativeRange.start.node, nativeRange.start.node.length);
      }
      */
      //endfix

      //firefox fix for click from the side of the table
      // denis: закоментил это т.к. при разбиении на колонки этот код возвращает курсор в ту позицию где он был до разбиения,
      // но место(параграф) куда он ставится никак не связано с действием, поэтому выглядит не очень
      /*
      if (nativeRange != null &&
            browser == 'Firefox' &&
              equal(nativeRange.end, nativeRange.start) &&
                nativeRange.native.collapsed &&
                  nativeRange.native.commonAncestorContainer == this.scroll.domNode &&
                    (Parchment.find(nativeRange.start.node) instanceof Parchment.Leaf)) {
         this.setNativeRange(nativeRange.start.node, nativeRange.start.offset);
      }
      */
      //endfix

      // denis: пока закоментил т.к. если менять тип сфокусированного блота то событие изменение range не вызывается
      // и блот теряет фокус. это происходит т.к. квилловский range не меняется
      //if (!equal(oldRange, this.lastRange)) {
      if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode && nativeRange.end.node !== this.cursor.textNode) {
        try {
          this.cursor.restore();
        } catch (e) {}
      }
      if (this.cursor && this.cursor.isCursorAttached && this.lastRange && this.lastRange.length > 0) {
        this.cursor.restore();
      }
      var args = ['selectionchange', this.lastRange, oldRange, source, misc];
      (_this$emitter = this.emitter).emit.apply(_this$emitter, ['EDITOR_CHANGE'].concat(args));
      if (source !== 'silent') {
        var _this$emitter2;
        (_this$emitter2 = this.emitter).emit.apply(_this$emitter2, args);
      }
      //this.scrollIntoView(this.root);
      //}

      if (source === 'user') {
        this.lastRelPosition = getRelativePosition(this.editor);
      }
    }

    /**
     * options.filterLastBlotHalfSelection - определяет надо ли включать в результат нетекстовый блот, в начале которого(индекс 0)
     * находится конец выделение
     */
  }, {
    key: "getBlotsInRange",
    value: function getBlotsInRange(range) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      function getNextNode(node, skipChildren, endNode) {
        //if there are child nodes and we didn't come from a child node
        if (endNode == node) {
          return null;
        }
        if (node.firstChild && !skipChildren) {
          return node.firstChild;
        }
        if (!node.parentNode) {
          return null;
        }
        return node.nextSibling || getNextNode(node.parentNode, true, endNode);
      }
      var startNode = range.native.startContainer.childNodes[range.native.startOffset] || range.native.startContainer;
      var endNode = range.native.endContainer.childNodes[range.native.endOffset] || range.native.endContainer;
      var skipNode = null;
      if (options.filterLastBlotHalfSelection && range.native.endContainer.nodeType !== Node.TEXT_NODE && range.native.endOffset === 0 && range.native.endContainer !== this.scroll.domNode) {
        var getSkip = true;
        var sb1 = normalizeToStoredBlot(getBlotForNode(range.native.startContainer));
        var sb2 = normalizeToStoredBlot(getBlotForNode(range.native.endContainer));
        if (sb1 === sb2 || sb2 && sb2.isEmbeddable) {
          getSkip = false;
        }
        if (getSkip) {
          skipNode = range.native.endContainer;
          var blot = getBlotForNode(skipNode);
          if (blot) {
            skipNode = blot.domNode;
          }
        }
      }
      var skipEndNode = null;
      if (endNode !== range.native.endContainer && endNode !== range.native.startContainer) {
        skipEndNode = endNode;
      }
      var nodes = [];
      if (startNode === endNode && startNode.childNodes.length === 0) {
        nodes = [startNode];
      } else if (range.start.node === range.end.node && range.start.offset === range.end.offset) {
        nodes = [range.start.node];
      } else {
        do {
          if (startNode === range.end.node && startNode.nodeType === Node.TEXT_NODE && range.end.offset === 0) {
            // do not add text end node with offset = 0(nothing selected in that text)
            continue;
          }
          if (skipNode && (startNode === skipNode || skipNode.contains(startNode) || startNode.contains(skipNode))) {
            continue;
          }
          if (startNode === skipEndNode) {
            continue;
          }
          nodes.push(startNode);
        } while (startNode = getNextNode(startNode, false, endNode));
      }
      nodes = nodes.map(function (node) {
        if (node.nodeType === Node.TEXT_NODE) {
          return node.parentNode;
        }
        return node;
      });
      // оставляем только те элементы для которых нет дочерних элементов в полученном списке
      // надо найти более оптимальный путь для этого
      /*
      let foundNodes = []
      for(let node1 of nodes) {
        let c = false
        for(let node2 of nodes) {
          if(node1 !== node2 && contains(node1, node2)) {
            c = true
            break
          }
        }
        if(c) {
          continue
        }
        foundNodes.push(node1)
      }*/
      var foundNodes = nodes;
      var blots = new Set();
      var _iterator = selection_createForOfIteratorHelper(foundNodes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var node = _step.value;
          var _blot = src_parchment.find(node, true);
          blots.add(_blot);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (this.editor.browser === 'Firefox' && this.editor.mode === this.editor.constructor.MODE_READONLY) {
        return this.addBlotsIfNeed(Array.from(blots));
      }
      return Array.from(blots);
    }
  }, {
    key: "addBlotsIfNeed",
    value: function addBlotsIfNeed() {
      var blots = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var selection = window.getSelection();
      var blotNodeInSelection = function blotNodeInSelection(blot) {
        var blotHasDomNode = Boolean(blot.domNode);
        var blotHasChildren = Boolean(blot.children);
        return blotHasDomNode && selection.containsNode(blot.domNode) || blotHasChildren && (blot.children.head && selection.containsNode(blot.children.head.domNode) || blot.children.tail && selection.containsNode(blot.children.tail.domNode));
      };
      this.scroll.descendants(function (blot) {
        return blot.isSelectable;
      }).forEach(function (blot) {
        if (blotNodeInSelection(blot) && !blots.some(function (blotInBlots) {
          return blotInBlots.id && blotInBlots.id === blot.id;
        })) {
          blots.push(blot);
        }
      });
      return blots;
    }
  }, {
    key: "isWithinNode",
    value: function isWithinNode(node) {
      var selection = getSelection();
      if (!selection.rangeCount) {
        return false;
      }
      var range = selection.getRangeAt(0);
      return contains(node, range.commonAncestorContainer);
    }
  }]);
  return Selection;
}();
function contains(parent, descendant) {
  try {
    // Firefox inserts inaccessible nodes around video elements
    descendant.parentNode;
  } catch (e) {
    return false;
  }
  // IE11 has bug with Text nodes
  // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
  if (descendant instanceof Text) {
    descendant = descendant.parentNode;
  }
  return parent.contains(descendant);
}

// EXTERNAL MODULE: ./node_modules/url/url.js
var url_url = __webpack_require__(34546);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/url.js

function getFullUrl(url) {
  if (url && url[0] === '/') {
    url = document.location.protocol + '//' + document.location.host + url;
  }
  return url;
}
function getHostFromUrl(url) {
  var parsed = url_url.parse(url);
  return parsed.host;
}
var urlRegex = {
  url: /(https?:\/\/[^\s]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,})/g,
  email: /([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)/g,
  emailStrong: /(?:^|\s)(([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?))(?:$|\s)/gm
};
function stringIsUrl(string) {
  var regex = /^(http: \/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/g;
  return regex.test(string);
}
function urlHasProtocol(url) {
  var regex = /^https?.*$/g;
  return regex.test(url);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.bold.js
var es_string_bold = __webpack_require__(50915);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.italics.js
var es_string_italics = __webpack_require__(58734);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/text/util/deltatomarkdown.js
function deltatomarkdown_slicedToArray(arr, i) { return deltatomarkdown_arrayWithHoles(arr) || deltatomarkdown_iterableToArrayLimit(arr, i) || deltatomarkdown_unsupportedIterableToArray(arr, i) || deltatomarkdown_nonIterableRest(); }
function deltatomarkdown_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function deltatomarkdown_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function deltatomarkdown_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function deltatomarkdown_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function deltatomarkdown_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { deltatomarkdown_ownKeys(Object(source), true).forEach(function (key) { deltatomarkdown_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { deltatomarkdown_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function deltatomarkdown_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function deltatomarkdown_toConsumableArray(arr) { return deltatomarkdown_arrayWithoutHoles(arr) || deltatomarkdown_iterableToArray(arr) || deltatomarkdown_unsupportedIterableToArray(arr) || deltatomarkdown_nonIterableSpread(); }
function deltatomarkdown_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function deltatomarkdown_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return deltatomarkdown_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return deltatomarkdown_arrayLikeToArray(o, minLen); }
function deltatomarkdown_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function deltatomarkdown_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return deltatomarkdown_arrayLikeToArray(arr); }
function deltatomarkdown_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function deltatomarkdown_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { deltatomarkdown_typeof = function _typeof(obj) { return typeof obj; }; } else { deltatomarkdown_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return deltatomarkdown_typeof(obj); }































/**
 * Convert delta's operation in markdown
 * @param {*} op
 * @param {Boolean} options.trim
 * @returns - markdown string
 */
function opToMarkdown(op, options) {
  var text = '';
  if (typeof op.insert === 'string') {
    text = op.insert;
    if (options && options.trim) {
      text = text.trim();
    }
    var attr = op.attributes;
    if (attr) {
      if (attr.code) {
        text = '`' + text + '`';
      }
      if (attr.bold) {
        text = '**' + text + '**';
      }
      if (attr.italic) {
        text = '*' + text + '*';
      }
      if (attr.strikethrough) {
        text = '~~' + text + '~~';
      }
      if (attr.link) {
        text = '[' + text + '](' + attr.link + ')';
      }
    }
  }
  if (deltatomarkdown_typeof(op.insert) === 'object') {
    if (op.insert.linebreak === 's') {
      text = '\n';
    }
  }
  return text;
}

/**
 * Convert delta to markdown
 * @param {*} delta
 * @param {Boolean} options.trim
 * @returns - markdown string
 */
function deltaToMarkdown(delta, options) {
  var markdown = '';
  delta.ops.forEach(function (op) {
    markdown += opToMarkdown(op, options);
  });
  return markdown;
}

/**
 * Convert caption to markdown
 * @param {*} captionParams
 * @param {Object} captionParams.delta
 * @param {Object} captionParams.delta.ops
 * @returns
 */
function captionToMarkdown(captionParams) {
  var _captionParams$delta, _captionParams$delta$, _captionParams$delta2;
  var markdown = '';
  if (captionParams && captionParams !== null && captionParams !== void 0 && (_captionParams$delta = captionParams.delta) !== null && _captionParams$delta !== void 0 && (_captionParams$delta$ = _captionParams$delta.ops) !== null && _captionParams$delta$ !== void 0 && _captionParams$delta$.length && captionParams !== null && captionParams !== void 0 && (_captionParams$delta2 = captionParams.delta) !== null && _captionParams$delta2 !== void 0 && _captionParams$delta2.ops[0].insert.trim()) {
    markdown += '\n\n' + deltaToMarkdown(captionParams.delta).trim() + '\n\n';
  }
  return markdown;
}

/**
 * Convert table to markdown
 * @param {*} params
 * @param {Number} params.cols
 * @param {Number} params.rows
 * @param {Object} params.captionParams
 * @param {Object} params.captionParams.delta
 * @param {Object} params.content
 * @param {Array} params.content.columns
 * @param {Array} params.content.rows
 * @returns - markdown string
 */
function tableToMarkdown(params) {
  var columnTitle = [];
  var rows = [];
  for (var col = 0; col < params.cols; col++) {
    var title = params.content.columns[col].text;
    if (!title) {
      var defaultTitle = [];
      var num = col || 0;
      do {
        defaultTitle.unshift((10 + num % 26).toString(36).toUpperCase());
        num = Math.trunc(num / 26) - 1;
      } while (num > -1);
      title = defaultTitle.join('');
    }
    columnTitle.push(title);
  }
  for (var row = 0; row < params.rows; row++) {
    var rowValues = [];
    for (var _col = 0; _col < params.cols; _col++) {
      var _params$content$rows$, _params$content$rows$2;
      var delta = (_params$content$rows$ = params.content.rows[row]) === null || _params$content$rows$ === void 0 ? void 0 : (_params$content$rows$2 = _params$content$rows$.children[_col]) === null || _params$content$rows$2 === void 0 ? void 0 : _params$content$rows$2.delta;
      var content = deltaToMarkdown(delta || {
        ops: []
      }, {
        trim: true
      });
      rowValues.push(content);
    }
    rows.push(rowValues);
  }
  var headerRow = "| ".concat(columnTitle.join(' | '), " |");
  var separatorRow = "|".concat(Array(columnTitle.length).fill('---').join('|'), "|");
  var dataRows = rows.map(function (row) {
    return "| ".concat(row.join(' | '), " |");
  });
  var markdown = '\n' + [headerRow, separatorRow].concat(deltatomarkdown_toConsumableArray(dataRows)).join('\n');
  markdown += captionToMarkdown(params.captionParams);
  return '\n' + markdown.trim() + '\n';
}

/**
 * Convert syntax to markdown
 * @param {*} params
 * @param {Object} params.delta
 * @param {Object} params.captionParams
 * @param {Object} params.captionParams.delta
 * @param {String} params['data-language']
 * @returns
 */
function syntaxToMarkdown(params) {
  var _params$delta, _params$delta$ops;
  var language = params['data-language'] || '';
  var code = '';
  (_params$delta = params.delta) === null || _params$delta === void 0 ? void 0 : (_params$delta$ops = _params$delta.ops) === null || _params$delta$ops === void 0 ? void 0 : _params$delta$ops.forEach(function (op) {
    if (typeof op.insert === 'string') {
      code += op.insert;
    }
  });
  var markdown = '```' + language + '\n' + code.trim() + '\n```\n';
  markdown += captionToMarkdown(params.captionParams);
  return markdown;
}

/**
 * Convert list item to markdown
 * @param {*} item
 * @param {'listItemBullet'|'listItemNumber'|'listItemCheckbox'} item.type
 * @param {Object} item.params
 * @param {Number} item.params.counter
 * @param {Object} item.params.delta
 * @param {Number} item.indent
 * @returns
 */
function listItemToMarkdown(item) {
  var markdown = '';
  if (item.type === 'listItemBullet' || item.type === 'listItemCheckbox') {
    markdown += '- ';
  }
  if (item.type === 'listItemNumber') {
    markdown += "".concat(item.params.counter, ". ");
  }
  markdown += deltaToMarkdown(item.params.delta).trim();
  markdown += '\n';
  return '\t'.repeat(item.indent || 0) + markdown;
}

/**
 * Convert list to markdown
 * @param {*} params
 * @param {Object} params.content
 * @param {Array<{type: string; counter: number; delta: Delta;}>} params.content.items
 * @returns - markdown string
 */
function listToMarkdown(items) {
  var markdown = '';
  items === null || items === void 0 ? void 0 : items.forEach(function (item) {
    markdown += listItemToMarkdown({
      type: item.type,
      indent: item.params.indent || 0,
      params: {
        counter: item.params.counter,
        delta: item.params.delta
      }
    });
  });
  return markdown;
}

/**
 *
 * @param {*} params
 * @param {Object} params.delta
 * @param {'hLarge'|'hMedium'|'hSmall'} params.textLineType
 * @returns
 */
function textLineToMarkdown(params) {
  var markdown = deltaToMarkdown((params === null || params === void 0 ? void 0 : params.delta) || {
    ops: []
  }) || '';
  if (params.textLineType === 'hLarge') {
    markdown = '# ' + markdown;
  }
  if (params.textLineType === 'hMedium') {
    markdown = '## ' + markdown;
  }
  if (params.textLineType === 'hSmall') {
    markdown = '### ' + markdown;
  }
  return markdown;
}

/**
 * Convert content to markdown
 * @param {*} content
 * @param {Object} content.initParams
 * @param {Object} content.params
 * @returns
 */
function contentToMarkdown(content) {
  var result = '';
  if (content.type === 'textLine') {
    result += textLineToMarkdown(deltatomarkdown_objectSpread(deltatomarkdown_objectSpread({}, content.initParams), {}, {
      textLineType: content.textLineType
    })) + '\n';
  } else if (content.type === 'list') {
    result += listToMarkdown(content.items).trim() + '\n\n';
  } else if (content.type === 'table') {
    result += tableToMarkdown(content.initParams) + '\n';
  } else if (content.type === 'syntax') {
    result += syntaxToMarkdown(content.initParams);
  } else if (['hLarge-toggle', 'hMedium-toggle', 'hSmall-toggle'].includes(content.type)) {
    var _content$initParams$i;
    var _content$type$split = content.type.split('-'),
      _content$type$split2 = deltatomarkdown_slicedToArray(_content$type$split, 1),
      textLineType = _content$type$split2[0];
    result += textLineToMarkdown({
      delta: content.initParams.delta,
      textLineType: textLineType
    }).trim();
    (_content$initParams$i = content.initParams.items) === null || _content$initParams$i === void 0 ? void 0 : _content$initParams$i.forEach(function (item) {
      result += contentToMarkdown(item);
    });
  } else {
    var _content$initParams, _content$params, _content$initParams2, _content$initParams2$, _content$items;
    var text = deltaToMarkdown(((_content$initParams = content.initParams) === null || _content$initParams === void 0 ? void 0 : _content$initParams.delta) || ((_content$params = content.params) === null || _content$params === void 0 ? void 0 : _content$params.delta) || {
      ops: []
    }).trim();
    if (text) {
      result += text + '\n\n';
    }
    (_content$initParams2 = content.initParams) === null || _content$initParams2 === void 0 ? void 0 : (_content$initParams2$ = _content$initParams2.items) === null || _content$initParams2$ === void 0 ? void 0 : _content$initParams2$.forEach(function (item) {
      result += contentToMarkdown(item);
    });
    content === null || content === void 0 ? void 0 : (_content$items = content.items) === null || _content$items === void 0 ? void 0 : _content$items.forEach(function (item) {
      result += contentToMarkdown(item);
    });
    if (content.initParams && content.initParams.captionParams) {
      var caption = captionToMarkdown(content.initParams.captionParams).trim();
      if (caption) {
        result += caption + '\n\n';
      }
    }
  }
  return result;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/text/textBase.js
function textBase_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { textBase_typeof = function _typeof(obj) { return typeof obj; }; } else { textBase_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return textBase_typeof(obj); }































function textBase_slicedToArray(arr, i) { return textBase_arrayWithHoles(arr) || textBase_iterableToArrayLimit(arr, i) || textBase_unsupportedIterableToArray(arr, i) || textBase_nonIterableRest(); }
function textBase_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function textBase_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return textBase_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return textBase_arrayLikeToArray(o, minLen); }
function textBase_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function textBase_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function textBase_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function textBase_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function textBase_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function textBase_createClass(Constructor, protoProps, staticProps) { if (protoProps) textBase_defineProperties(Constructor.prototype, protoProps); if (staticProps) textBase_defineProperties(Constructor, staticProps); return Constructor; }
function textBase_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { textBase_get = Reflect.get; } else { textBase_get = function _get(target, property, receiver) { var base = textBase_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return textBase_get(target, property, receiver || target); }
function textBase_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = textBase_getPrototypeOf(object); if (object === null) break; } return object; }
function textBase_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) textBase_setPrototypeOf(subClass, superClass); }
function textBase_setPrototypeOf(o, p) { textBase_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return textBase_setPrototypeOf(o, p); }
function textBase_createSuper(Derived) { var hasNativeReflectConstruct = textBase_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = textBase_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = textBase_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return textBase_possibleConstructorReturn(this, result); }; }
function textBase_possibleConstructorReturn(self, call) { if (call && (textBase_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return textBase_assertThisInitialized(self); }
function textBase_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function textBase_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function textBase_getPrototypeOf(o) { textBase_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return textBase_getPrototypeOf(o); }
function textBase_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


























var isSpaceKey = (0,lib/* default */.ZP)('space');
var TextBase = /*#__PURE__*/function (_Block) {
  textBase_inherits(TextBase, _Block);
  var _super = textBase_createSuper(TextBase);
  function TextBase(domNode) {
    var _this;
    textBase_classCallCheck(this, TextBase);
    _this = _super.call(this, domNode);
    textBase_defineProperty(textBase_assertThisInitialized(_this), "mapObserver", function (event) {
      _this.render();
    });
    textBase_defineProperty(textBase_assertThisInitialized(_this), "execInBatch", function (fn) {
      _this.batch = true;
      try {
        fn();
        _this.updateBlock(null);
      } catch (ex) {
        throw ex;
      } finally {
        _this.batch = false;
      }
    });
    textBase_defineProperty(textBase_assertThisInitialized(_this), "textBaseOnTextChange", function (delta, oldDelta, source) {
      if (source === 'yjs') return;
      var insertedSymbol = getDeltaInsertOps(delta)[0] ? getDeltaInsertOps(delta)[0].insert : false;
      var blotRange = _this.scroll.selection.getRange({
        offsetBlot: textBase_assertThisInitialized(_this)
      })[0];
      if (delta.changeLength() === 1) {
        if (blotRange) {
          var _this$children$find = _this.children.find(blotRange.index, false),
            _this$children$find2 = textBase_slicedToArray(_this$children$find, 1),
            format = _this$children$find2[0];
          if (format && format.onTextChange) {
            format.onTextChange(blotRange, insertedSymbol, textBase_assertThisInitialized(_this));
          }
        }
      }
    });
    _this.isText = true;
    _this.cache = {};
    _this.batch = false;
    _this.emitter = new emitter();
    _this._textLength = null;
    domNode.classList.add('editable-text');
    return _this;
  }
  textBase_createClass(TextBase, [{
    key: "isEmpty",
    value: function isEmpty() {
      return !Boolean(this.domNode.textContent);
    }
  }, {
    key: "attach",
    value: function attach() {
      var _get2,
        _this2 = this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = textBase_get(textBase_getPrototypeOf(TextBase.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      var editMode = this.scroll.editor.isEditable();
      if (!editMode && this.scroll.ignoringUpdates) {
        this.scroll.resumeUpdates();
      }
      if (this._quillBinding) {
        // already attached
        return;
      }
      this.delta();
      this._quillBinding = new this.store.QuillBinding(this.map.get('characters'), this);
      this._quillBinding.init();
      this.store.observe(this.map, this.mapObserver);

      // TODO обновить это, чтоб каждый раз не вызывалось при изменнии текста в редакторе на каждом блоке.
      // сделать определение на каком блоке должна быть вызвана функция исходя из списка мутаций
      this.scroll.emitter.on('SCROLL_UPDATE', function (source, mutations, updatedBlots) {
        if (!updatedBlots.has(_this2)) {
          return;
        }
        //let range = this.selection.lastRange;
        //let index = range && range.length === 0 ? range.index : undefined;
        var index = undefined;
        if (_this2.scroll.selectedBlocks.indexOf(_this2) >= 0) {
          var range = _this2.scroll.selection.getRange({
            relBlot: _this2
          });
          if (range.length === 0) {
            index = range.index;
          }
        }
        modify.call(_this2, function () {
          return _this2.updateBlock(null, mutations, index);
        }, source);
        var editMode = _this2.scroll.editor.isEditable();
        if (!editMode && !_this2.scroll.ignoringUpdates) {
          _this2.scroll.ignoreUpdates();
        }
      });
      this.on('text-change', this.textBaseOnTextChange);
    }

    // on и off для совместимости с quill для биндинга YText
  }, {
    key: "on",
    value: function on() {
      return this.emitter.on.apply(this.emitter, arguments);
    }
  }, {
    key: "off",
    value: function off() {
      return this.emitter.removeListener.apply(this.emitter, arguments);
    }
  }, {
    key: "render",
    value: function render() {
      this.domNode.style.textAlign = this.textAlign;
    }
  }, {
    key: "textAlign",
    get: function get() {
      return this.map.get('align');
    }
  }, {
    key: "applyDelta",
    value: function applyDelta(delta) {
      var _this3 = this;
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'api';
      var empty = this.isEmpty();
      var blockLength = this.length();
      this.scroll.execInBatch(function () {
        delta = normalizeDelta(delta, {
          trimNewLines: true
        });
        delta.reduce(function (index, op) {
          var length = op.retain || op.delete || op.insert.length || 1;
          var attributes = op.attributes || {};
          if (op.insert != null) {
            if (typeof op.insert === 'string') {
              var text = op.insert;
              text = text.replace(/[\n]/g, '');
              if (text) {
                _this3.insertAt(index, text);
                var formats = extend_default()({}, bubbleFormats(_this3));
                var _this3$descendant = _this3.descendant((parchment_default()).Leaf, index),
                  _this3$descendant2 = textBase_slicedToArray(_this3$descendant, 1),
                  leaf = _this3$descendant2[0];
                formats = extend_default()(formats, bubbleFormats(leaf));
                attributes = AttributeMap_default().diff(formats, attributes) || {};
                if (index == 0 && source == 'api') {
                  if (text.length !== 0 && _this3.children.length > 1 && _this3.children.head.constructor.blotName == 'break' && _this3.domNode.firstChild.tagName == 'BR') {
                    _this3.domNode.firstChild.remove();
                  }
                }
              }
            } else if (textBase_typeof(op.insert) === 'object') {
              var key = Object.keys(op.insert)[0]; // There should only be one key
              if (key == null) return index;
              _this3.insertAt(index, key, op.insert[key]);
            }
            blockLength += length;
          }
          Object.keys(attributes).forEach(function (name) {
            /*
            if (empty && name === 'align' && attributes[name]) {
              if (this.map.get('align') !== attributes[name]) {
                console.info('set', name, attributes[name])
                this.map.set('align', attributes[name])
              }
            }
            */
            _this3.formatAt(index, length, name, attributes[name]);
          });
          return index + length;
        }, 0);
        delta.reduce(function (index, op) {
          if (typeof op.delete === 'number') {
            if (_this3.length() == 1 && index == 0) {
              var br = parchment_default().create(_this3.statics.defaultChild);
              _this3.insertBefore(br, _this3.children.head);
              var textBlot = _this3.children.tail;
              textBlot.remove();
              //this.domNode.innerHTML = '<br>';
            } else {
              _this3.deleteAt(index, op.delete);
            }
            return index;
          }
          var opLength = op.retain || op.insert.length || 1;
          if (op.insert && typeof op.insert === 'string') {
            var text = op.insert.replace(/[\n]/g, '');
            opLength = text.length;
          }
          return index + opLength;
        }, 0);
      }, source);
      return this.updateBlock(delta);
    }
  }, {
    key: "delta",
    value: function delta() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.cache.delta = this.descendants((parchment_default()).Leaf).reduce(function (delta, leaf) {
        if (leaf.length() === 0) {
          return delta;
        } else {
          return delta.insert(leaf.value(), bubbleFormats(leaf));
        }
      }, new (Delta_default())()).insert('\n');
      if (options.forCopy) {
        return prepareDeltaForCopy(this.cache.delta.slice());
      }
      return this.cache.delta.slice();
    }
  }, {
    key: "setContents",
    value: function setContents(delta) {
      var _this4 = this;
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'api';
      return modify.call(this, function () {
        delta = new (Delta_default())(delta);
        var length = _this4.length();
        var deleted;
        if (length === 1) {
          deleted = new (Delta_default())();
        } else {
          deleted = _this4.deleteAt(0, length);
        }
        var applied = _this4.applyDelta(delta, source);
        var lastOp = applied.ops[applied.ops.length - 1];
        if (lastOp != null && typeof lastOp.insert === 'string' && lastOp.insert[lastOp.insert.length - 1] === '\n') {
          _this4.deleteAt(_this4.length() - 1, 1);
          applied.delete(1);
        }
        var ret = deleted.compose(applied);
        return ret;
      }, source);
    }
  }, {
    key: "updateContents",
    value: function updateContents(delta) {
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'api';
      // TODO возможно надо найти более красивое решение чтобы textBase не знал о undo/redo
      // если в undo стеке есть операция которая одновременно создает текстовый блот и добавляет в него символ,
      // то происходит следующее:
      // 1. операция добавления блота вызывает его полный рендер
      // 2. операция добавления символа вызывает updateContents с дельтой которая добавляет символ
      // после выполнения мы имеем дополнительный левый символ, который пропадает после рефреша.
      // текущее решение - это сравнить хранимую дельту и текущую дельту блота и если они одинаковые то updateContents
      // проигнорируется. эта проверка запускается только если процесс undo или redo происходит на данный момент.
      // на видео https://www.dropbox.com/s/gebgf1xuyaquitg/dublicate.mov?dl=0 это воспроизводится с двумя колонками
      // и нажатием delete в конце первой.
      if (this.editor.plugins.undoManager && this.editor.plugins.undoManager.isUndoingOrRedoing()) {
        var deltaStored = new (Delta_default())(this.map.get('characters').toDelta());
        var currentDelta = this.delta().slice();
        ensureDeltaEndsWithNewLine(deltaStored);
        ensureDeltaEndsWithNewLine(currentDelta);
        if (deltaStored.diff(currentDelta).ops.length === 0) {
          return;
        }
      }
      var selection = this.editor.scroll.selection;
      var hasChange = !deep_equal_default()(new (Delta_default())(this.cache.delta).compose(new (Delta_default())(delta)), this.cache.delta);
      if (!hasChange) return;
      var needToRestoreSelection = false;
      if (source === 'remote') {
        if (selection.containsBlot(this)) {
          needToRestoreSelection = true;
        }
      }
      var absPos = selection.lastRelPosition ? getAbsolutePosition(selection.lastRelPosition) : null;
      var applyDeltaRes = this.applyDelta(delta, source);
      if (needToRestoreSelection && absPos) {
        selection.setRange(absPos);
      }
      this.scroll.emitter.emit('delta', {
        id: this.id,
        delta: delta,
        source: source
      });
      return applyDeltaRes;
    }
  }, {
    key: "deleteAt",
    value: function deleteAt(index, length) {
      var _this5 = this;
      this._textLength = null;
      this.scroll.execInBatch(function () {
        if (index == 0 && length == _this5.length()) {
          var br = parchment_default().create(_this5.statics.defaultChild);
          _this5.children.forEach(function (blot) {
            blot.remove();
          });
          _this5.appendChild(br);
          _this5.optimize();
        } else {
          textBase_get(textBase_getPrototypeOf(TextBase.prototype), "deleteAt", _this5).call(_this5, index, length);
        }
      });
      return this.updateBlock(new (Delta_default())().retain(index).delete(length));
    }
  }, {
    key: "formatAt",
    value: function formatAt(index, length, name, value) {
      // Мы храним комментарии в дельте в виде 'comment-threadId-color': true
      // Для того, чтобы Parchment понял как ему нужно отформатировать текст нужно привести формат комментария
      // в нормальный для него вид 'comment': JSON.stringify({threadId, color})
      if (name.startsWith('comment-') && value === true) {
        var attrs = name.split('-');
        name = attrs.shift();
        value = JSON.stringify({
          threadId: attrs.shift(),
          color: attrs.length > 1 ? attrs.join('-') : attrs.shift()
        });
      }
      textBase_get(textBase_getPrototypeOf(TextBase.prototype), "formatAt", this).call(this, index, length, name, value);
      if (!this.batch) {
        var formats = textBase_defineProperty({}, name, value);
        return this.updateBlock(new (Delta_default())().retain(index).retain(length, formats));
      }
    }
  }, {
    key: "insertAt",
    value: function insertAt() {
      var _get3;
      this._textLength = null;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = textBase_get(textBase_getPrototypeOf(TextBase.prototype), "insertAt", this)).call.apply(_get3, [this].concat(args));
    }
  }, {
    key: "insertText",
    value: function insertText(index, text) {
      var _this6 = this;
      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
      this.insertAt(index, text);
      Object.keys(formats).forEach(function (format) {
        _this6.formatText(index, text.length, format, formats[format]);
      });
      return this.updateBlock(new (Delta_default())().retain(index).insert(text, formats));
    }
  }, {
    key: "deleteText",
    value: function deleteText(index, length, source) {
      var _this7 = this;
      ;
      var _overload = overload(index, length, source);
      var _overload2 = textBase_slicedToArray(_overload, 4);
      index = _overload2[0];
      length = _overload2[1];
      source = _overload2[3];
      return modify.call(this, function () {
        return _this7.deleteAt(index, length);
      }, source, index, -1 * length);
    }
  }, {
    key: "formatText",
    value: function formatText(index, length, name, value, source) {
      var _this8 = this;
      var formats;
      var _overload3 = overload(index, length, name, value, source);
      var _overload4 = textBase_slicedToArray(_overload3, 4);
      index = _overload4[0];
      length = _overload4[1];
      formats = _overload4[2];
      source = _overload4[3];
      return modify.call(this, function () {
        var _Object$keys$map = Object.keys(formats).map(function (format) {
            if (source === 'api') {
              console.warn('Formatting id: ' + _this8.id + ' format: %s', index + ' ' + length + ' ' + format + ' ' + formats[format]);
            }
            return _this8.formatAt(index, length, format, formats[format]);
          }),
          _Object$keys$map2 = textBase_slicedToArray(_Object$keys$map, 1),
          change = _Object$keys$map2[0];
        return change;
      }, source, index, 0);
    }
  }, {
    key: "clearFormat",
    value: function clearFormat(index, length) {
      var _this9 = this;
      var checkDelta = this.delta().slice();
      var foundStyles = new Set();
      checkDelta.forEach(function (op) {
        if (op.attributes) {
          for (var _i2 = 0, _Object$keys = Object.keys(op.attributes); _i2 < _Object$keys.length; _i2++) {
            var key = _Object$keys[_i2];
            foundStyles.add(key);
          }
        }
      });
      var styles = ['bold', 'italic', 'underline', 'strikethrough', 'color', 'size', 'font', 'link', 'background', 'code', 'placeholder'];
      styles.forEach(function (style) {
        if (foundStyles.has(style)) {
          _this9.formatText(index, length, style, false, 'user');
        }
      });
    }
  }, {
    key: "length",
    value: function length() {
      if (this._textLength === null) {
        this._textLength = textBase_get(textBase_getPrototypeOf(TextBase.prototype), "length", this).call(this) + 1;
      }
      return this._textLength;
    }
  }, {
    key: "getFormat",
    value: function getFormat(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var leaves = this.descendants((parchment_default()).Leaf, index, length);
      var formatsArr = [leaves].map(function (blots) {
        if (blots.length === 0) return {};
        var formats = bubbleFormats(blots.shift());
        while (Object.keys(formats).length > 0) {
          var blot = blots.shift();
          if (blot instanceof linebreak) {
            blot = blots.shift();
          }
          if (blot == null) return formats;
          formats = combineFormats(bubbleFormats(blot), formats);
        }
        return formats;
      });
      return extend_default().apply((extend_default()), formatsArr);
    }
  }, {
    key: "getTextContent",
    value: function getTextContent() {
      var _this10 = this;
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.length() - index;
      var mapCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (op) {};
      var _overload5 = overload(index, length);
      var _overload6 = textBase_slicedToArray(_overload5, 2);
      index = _overload6[0];
      length = _overload6[1];
      return this.getContents(index, length).filter(function (op) {
        if (typeof op.insert === 'string') {
          return true;
        } else if (textBase_typeof(op.insert) === 'object') {
          var blotClass = parchment_default().query(Object.keys(op.insert)[0]);
          if (blotClass && blotClass.getOpText) {
            return true;
          }
        }
        return false;
      }).map(function (op) {
        var res = mapCb(op);
        if (res) {
          return res;
        }
        return parchment_default().query(Object.keys(op.insert)[0]).getOpText(op.insert, _this10 && _this10.children, _this10.editor);
      }).join('');
    }
  }, {
    key: "getText",
    value: function getText() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.length() - index;
      return this.getTextContent(index, length, function (op) {
        if (typeof op.insert === 'string') {
          return op.insert;
        }
        return undefined;
      });
    }
  }, {
    key: "getMarkdown",
    value: function getMarkdown() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.length() - index;
      return this.getTextContent(index, length, opToMarkdown) + '\n';
    }
  }, {
    key: "getContents",
    value: function getContents(index, length) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var delta = this.cache.delta.slice(index, index + length);
      if (options.forCopy) {
        return prepareDeltaForCopy(delta);
      }
      return delta;
    }
  }, {
    key: "remove",
    value: function remove() {
      var _get4;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      (_get4 = textBase_get(textBase_getPrototypeOf(TextBase.prototype), "remove", this)).call.apply(_get4, [this].concat(args));
      if (this._quillBinding) {
        this._quillBinding.destroy();
      }
    }
  }, {
    key: "optimize",
    value: function optimize(context) {
      this._textLength = null;
      if (this.children.length > 1 && this.children.head.constructor.blotName === 'break') {
        var brNode = this.children.head.domNode;
        this.children.head.remove();
      }
      textBase_get(textBase_getPrototypeOf(TextBase.prototype), "optimize", this).call(this, context);
      // fix delta map if need
      var deltaFromMap = this.map ? this.map.get('characters').toDelta() : null;
      if (deltaFromMap && deltaFromMap.length === 0) {
        var fixDelta = new (Delta_default())().insert('\n');
        this.applyForCharacters(fixDelta.ops);
      }
    }
  }, {
    key: "update",
    value: function update() {
      var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var context = arguments.length > 1 ? arguments[1] : undefined;
      if (mutations === 'yjs' || mutations === 'remote') {
        // отменяем update если его пытается выполнить yjs, пока не известно насколько это повредит работе(т.к. зачем-то этот вызов был сделан)
        // но если его оставлять то при батч апдейтах и undo/redo не выполняется оптимизация блотов, из-за того что этот update
        // забирает мутации из обсервера и после выхода из батча их уже не остается
        return;
      }
      textBase_get(textBase_getPrototypeOf(TextBase.prototype), "update", this).call(this, mutations, context);
      this.optimize();
    }
  }, {
    key: "path",
    value: function path(index) {
      return textBase_get(textBase_getPrototypeOf(TextBase.prototype), "path", this).call(this, index, true);
    }
  }, {
    key: "updateBlock",
    value: function updateBlock(change) {
      var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var cursorIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
      var oldDelta = this.cache.delta || new (Delta_default())([]);
      this.cache.delta = this.delta();
      if (!change || !deep_equal_default()(oldDelta.compose(change), this.cache.delta)) {
        change = oldDelta.diff(this.cache.delta, cursorIndex);
      }
      if (change.ops.length > 0) {
        this.scroll.emitter.emit('BLOCK_UPDATE', {});
      }
      return change;
    }
  }, {
    key: "exec",
    value: function exec(action) {
      var processed = false;
      var blotRange;
      if (action.cache.blotRange && action.cache.blotRange[this.id]) {
        blotRange = action.cache.blotRange[this.id];
      } else {
        blotRange = this.selection.getRange({
          offsetBlot: this
        })[0];
      }
      var params = action.params;
      if (action.type === 'set-align') {
        this.map.set('align', params);
        this.selection.focus();
        processed = true;
      } else if (action.type === 'clear-formatting') {
        this.clearFormat(blotRange.index, blotRange.length);
        processed = true;
      } else if (action.type === 'add-link') {
        var link = params.url;
        var hasProtokol = link.match(/(?:(?:[a-z][a-z0-9+.-]*:)(?:.*))/gm);
        var url = link;
        if (!hasProtokol) {
          url = 'http://' + link;
        }
        var delta = [{
          retain: blotRange.index
        }];
        delta.push({
          insert: params.text,
          attributes: {
            link: url
          }
        });
        if (blotRange.length > 0) {
          if (params.delete) {
            this.deleteText(blotRange.index, blotRange.length);
            this.map.get('characters').applyDelta(delta);
          } else {
            this.formatText(blotRange.index, blotRange.length, 'link', url, 'user');
          }
        } else {
          this.map.get('characters').applyDelta(delta);
        }
        params.callback && params.callback({
          parent: this,
          range: blotRange
        });
        processed = true;
      } else if (action.type === 'format') {
        var start = blotRange.index;
        var length = blotRange.length;
        var value = params.value;
        if (length === 0) {
          this.selection.format(params.style, value);
        } else {
          this.formatText(start, length, params.style, value, 'user');
        }
        processed = true;
      } else if (action.type === 'backspace') {
        processed = this.textBaseProcessBackspace(action);
      } else if (action.type === 'delete') {
        processed = this.textBaseProcessDelete(action);
      }
      return processed;
    }
  }, {
    key: "textBaseProcessBackspace",
    value: function textBaseProcessBackspace(action) {
      var blotRange = action.getBlotRange(this);
      if (blotRange.length > 0) {
        throw new Error('textBase: Cannot process backspace on uncollapsed range');
      }
      if (blotRange.index === 0) {
        // если каретка стоит в начале блота, не обрабатываем этот backspace здесь
        return false;
      }
      // позволяем браузеру обрабатывать удаление, т.к. в данном случае нам не надо отрабатывать символы более 2-ух байт
      // длина которых в JS > 1(emoji). также хром отрабатывает удаление составных последовательностей объединенных U+200D
      // таких как emoji "семья"
      action.dontRestoreSelection();
      action.handleByBrowser();
      return true;
    }
  }, {
    key: "textBaseProcessDelete",
    value: function textBaseProcessDelete(action) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (typeof opts.allowRemove === 'undefined') {
        opts.allowRemove = true;
      }
      var blotLength = this.length();
      var blotRange = action.getBlotRange(this);
      if (blotRange.length === 0 && blotRange.index === blotLength - 1) {
        // если каретка стоит в конце блота, не обрабатываем здесь
        return false;
      }
      if (blotRange.length === 0) {
        action.dontRestoreSelection();
        action.handleByBrowser();
      } else {
        this.map.get('characters').applyDelta([{
          retain: blotRange.index
        }, {
          delete: blotRange.length
        }]);
      }
      return true;
    }
  }, {
    key: "textBaseOnSpaceKey",
    value: function textBaseOnSpaceKey(event) {
      var shiftLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$selection$getRa = this.selection.getRange(),
        _this$selection$getRa2 = textBase_slicedToArray(_this$selection$getRa, 1),
        range = _this$selection$getRa2[0];
      if (range && range.length === 0) {
        var _this$selection$getRa3 = this.selection.getRange({
            offsetBlot: this
          }),
          _this$selection$getRa4 = textBase_slicedToArray(_this$selection$getRa3, 1),
          blotRange = _this$selection$getRa4[0];
        var inCursorBlot = this.selection.cursor.isCursorAttached && this.selection.getNativeRange().start.node === this.selection.cursor.textNode;
        var formats = inCursorBlot ? this.selection.cursor.getFormat() : this.getFormat(blotRange.index - 1, 1);
        var handle = !this.dontConvertLinks && this.tryConvertLink(blotRange, shiftLeft);
        var format = false;
        if (!handle && Object.keys(formats).length) {
          handle = true;
          if (!formats.placeholder) {
            format = true;
          }
        }
        if (handle) {
          event && event.preventDefault();
          if (format) {
            this.insertText(blotRange.index, ' ', formats);
          } else {
            this.insertAt(blotRange.index, ' ');
          }
          range.index++;
          this.selection.setRange(range);
        }
      }
    }

    /**
     * Удаляет строку по аналогии с тем как удаляется в MacOS
     * при нажатии Alt+Backspace
     * @param indexAt
     * @param string
     * @param btn
     * @returns {{str: string, cursor: number}}
     */
  }, {
    key: "deleteAsAltBackspace",
    value: function deleteAsAltBackspace(indexAt, string) {
      var btn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      // проверяем чтобы тип у string был строкой
      if (typeof string !== 'string') {
        return {
          str: '',
          cursor: 0
        };
      }
      var left = string.slice(0, indexAt);
      var right = string.slice(indexAt);
      var str = '';

      // елси btn Alt то удаление по словам
      if (btn === 'alt') {
        var words = left.split(' ');
        var deleted = words.pop();
        if (deleted && words.length) {
          words.push('');
        }
        left = words.length ? words.join(' ') : '';
        str = [left, right].join('');
      } else {
        left = '';
        str = right;
      }
      return {
        str: str,
        cursor: left.length
      };
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (isSpaceKey(event)) {
        if (this.editor.options.keyboardMode !== 'mobile') {
          return this.textBaseOnSpaceKey(event);
        }
      }
      var delta = this.getContents(0, this.length());
      var canDelete = false;
      // можем удалять только там где у дельты один элемент
      if (delta.ops.length === 1) {
        canDelete = true;
      }
      // или второй элемент это пустая строка или строка с проблеами
      if (delta.ops.length === 2 && typeof delta.ops[1].insert === 'string') {
        if (delta.ops[1].insert.trim() === '') canDelete = true;
      }
      // предотвращаем ошибку при удалении через Alt|Ctrl|Meta+Backspace
      if ((event.altKey || event.metaKey || event.ctrlKey) && event.code === "Backspace" && (canDelete || event.metaKey)) {
        event.preventDefault();
        var length = this.length() - 1;
        var btn = event.altKey || event.ctrlKey ? 'alt' : '';
        var _this$selection$getRa5 = this.selection.getRange(),
          _this$selection$getRa6 = textBase_slicedToArray(_this$selection$getRa5, 2),
          index = _this$selection$getRa6[0].index,
          _this$selection$getRa7 = _this$selection$getRa6[1],
          startOffset = _this$selection$getRa7.start.offset,
          endOffset = _this$selection$getRa7.end.offset;
        var _delta$ops$0$attribut = delta.ops[0].attributes,
          attributes = _delta$ops$0$attribut === void 0 ? {} : _delta$ops$0$attribut;
        var _this$deleteAsAltBack = this.deleteAsAltBackspace(endOffset, delta.ops[0].insert, btn),
          insert = _this$deleteAsAltBack.str,
          cursor = _this$deleteAsAltBack.cursor;

        // из-за бага в yjs пока разделяем на две операции https://github.com/yjs/yjs/issues/305
        this.map.get('characters').applyDelta([{
          delete: length
        }]);
        this.map.get('characters').applyDelta([{
          insert: insert,
          attributes: attributes
        }]);
        this.selection.setRange({
          index: index - startOffset + cursor,
          length: 0
        });
      }
    }
  }, {
    key: "tryConvertLink",
    value: function tryConvertLink(blotRange, shiftLeft) {
      var wordIndex = blotRange.index,
        wordLength = 0;
      if (shiftLeft && wordIndex) {
        wordIndex -= 1;
      }
      var symbol = this.getText(wordIndex - 1, 1);
      //find processed word
      while (symbol !== ' ' && symbol !== '\n' && wordIndex !== 0) {
        wordIndex--;
        wordLength++;
        symbol = this.getText(wordIndex - 1, 1);
      }
      var word = this.getText(wordIndex, wordLength);
      //formatted?
      if (this.getFormat(wordIndex, 1).link) {
        return true;
      }
      //link?
      var isLink = word.match(urlRegex.url);
      if (isLink && isLink.length) {
        var index = word.indexOf(isLink[0]);
        if (index !== 0) {
          wordIndex = wordIndex + word.indexOf(isLink[0]);
          wordLength = isLink[0].length;
        }
        var url = word.search('http') != -1 ? isLink[0] : 'http://' + word;
        this.formatText(wordIndex, wordLength, 'link', url, 'user');
        return true;
      }

      //email?
      var isEmail = word.match(urlRegex.email);
      if (isEmail && isEmail.length) {
        var emailUrl = word.search('mailto:') != -1 ? word : 'mailto:' + word;
        this.formatText(wordIndex, wordLength, 'link', emailUrl, 'user');
        return true;
      }
      return false;
    }
  }, {
    key: "applyForCharacters",
    value: function applyForCharacters(delta) {
      this.map.get('characters').applyDelta(delta);
    }
  }, {
    key: "detach",
    value: function detach() {
      textBase_get(textBase_getPrototypeOf(TextBase.prototype), "detach", this).call(this);
      if (this._quillBinding) {
        this._quillBinding.destroy();
        this._quillBinding = null;
      }
      this.store.unobserve(this.map, this.mapObserver);
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      if (!this.children.length) {
        return '<br>';
      }
      var html = [];
      this.children.forEach(function (blot) {
        if (blot instanceof text_Text) {
          html.push(escapeHtml(blot.value()));
        } else {
          var blotHTML = '';
          if (blot.toHTML) {
            blotHTML = blot.toHTML(context);
          } else if (blot.domNode) {
            blotHTML = blot.domNode.outerHTML;
          }
          html.push(blotHTML);
        }
      });
      return html.join('');
    }
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      var selectedBlots = this.scroll.selectedBlocks;
      var params = textBase_get(textBase_getPrototypeOf(TextBase.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
      var delta = !blotRange || blotRange.length < 0 || selectedBlots.indexOf(this) !== selectedBlots.length - 1 && blotRange.length < 1 ? this.getContents(0, this.length(), {
        forCopy: true
      }).insert('\n') : this.getContents(blotRange.index, blotRange.length, {
        forCopy: true
      }).insert('\n');
      if (delta.ops[delta.ops.length - 1].insert.endsWith('\n\n')) {
        delta = delta.slice(0, delta.length() - 1);
      }
      return (0,util/* mergeDeep */.Ee)(params, {
        type: 'textLine',
        initParams: {
          align: this.map.get('align'),
          delta: delta
        }
      });
    }
  }], [{
    key: "initMap",
    value: function initMap(map, store) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (map.has('characters')) {
        throw new Error('TextBase map already has characters, skip initMap');
      }
      if (params.align || !params.noDefaultAlign) {
        map.set('align', params.align || 'left');
      }
      map.set('characters', new store.types.Text());
      if (params.color) map.set('color', params.color);
      var content = map.get('characters');
      if (params.delta) {
        content.applyDelta(params.delta.ops);
      } else {
        content.insert(0, '\n');
      }
    }
  }, {
    key: "formats",
    value: function formats(domNode) {
      var tagName = parchment_default().query(this.blotName).tagName;
      if (domNode.tagName === tagName) {
        return undefined;
      }
      return parchment_default().Format.formats.call(this, domNode);
    }
  }]);
  return TextBase;
}(block);
function urlify(text) {
  var urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.replace(urlRegex, function (url) {
    return '<a href="' + url + '">' + url + '</a>';
  });
}
function modify(modifier, source, index, shift) {
  var range = index == null ? null : this.scroll.getSelection();
  var oldDelta = this.cache.delta.slice();
  var change = modifier();
  if (range != null) {
    // вызываем update чтобы перед восстановлением выделения(для форматирования и других действий) обработать все мутации,
    // которые могли появится в очереди во время выполнения modifier,
    // если этого не делать то после восстановления выделения оно может слететь т.к. вызывается
    // update если в очереди останутся мутации
    this.scroll.update();
  }
  if (change.length() > 0) {
    if (change.ops.length === 1 && change.ops[0].delete && this.constructor.blotName === 'paragraph') {
      var oldDeltaLength = oldDelta.length();
      if ((change.ops[0].delete === oldDeltaLength || change.ops[0].delete === oldDeltaLength - 1) && oldDeltaLength > 2) {
        this.editor.plugins.debugLogger.captureException(new Error('Potentially lost user text(bug investigation process)'));
      }
    }
    var args = ['text-change', change, oldDelta, source];
    this.scroll.emitter.emit('delta', {
      id: this.id,
      delta: change,
      source: source
    });
    if (source !== 'silent') {
      var _this$emitter;
      (_this$emitter = this.emitter).emit.apply(_this$emitter, args);
    }
  }
  return change;
}
function overload(index, length, name, value, source) {
  var formats = {};
  if (typeof index.index === 'number' && typeof index.length === 'number') {
    // Allow for throwaway end (used by insertText/insertEmbed)
    if (typeof length !== 'number') {
      source = value, value = name, name = length, length = index.length, index = index.index;
    } else {
      length = index.length, index = index.index;
    }
  } else if (typeof length !== 'number') {
    source = value, value = name, name = length, length = 0;
  }
  // Handle format being object, two format name/value strings or excluded
  if (textBase_typeof(name) === 'object') {
    formats = name;
    source = value;
  } else if (typeof name === 'string') {
    if (value != null) {
      formats[name] = value;
    } else {
      source = name;
    }
  }
  // Handle optional source
  source = source || 'api';
  return [index, length, formats, source];
}
function shiftRange(range, index, length, source) {
  if (range == null) return null;
  var start, end;
  if (index instanceof Delta) {
    var _map = [range.index, range.index + range.length].map(function (pos) {
      return index.transformPosition(pos, source !== 'user');
    });
    var _map2 = textBase_slicedToArray(_map, 2);
    start = _map2[0];
    end = _map2[1];
  } else {
    var _map3 = [range.index, range.index + range.length].map(function (pos) {
      if (pos < index || pos === index && source === 'user') return pos;
      if (length >= 0) {
        return pos + length;
      } else {
        return Math.max(index, pos + length);
      }
    });
    var _map4 = textBase_slicedToArray(_map3, 2);
    start = _map4[0];
    end = _map4[1];
  }
  return new Range(start, end - start);
}
TextBase.defaultChild = 'break';
TextBase.allowedChildren = [blots_break, linebreak, text_Text, inline, cursor, Mention, date_Date, Button, Progress, DropdownList];
TextBase.canExecActions = ['set-align', 'clear-formatting', 'add-link', 'format', 'set-background', 'backspace', 'delete', 'begin-mention'];
/* harmony default export */ const textBase = (TextBase);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/text/textLine.js
function textLine_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { textLine_typeof = function _typeof(obj) { return typeof obj; }; } else { textLine_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return textLine_typeof(obj); }
function textLine_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = textLine_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function textLine_slicedToArray(arr, i) { return textLine_arrayWithHoles(arr) || textLine_iterableToArrayLimit(arr, i) || textLine_unsupportedIterableToArray(arr, i) || textLine_nonIterableRest(); }
function textLine_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function textLine_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return textLine_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return textLine_arrayLikeToArray(o, minLen); }
function textLine_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function textLine_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function textLine_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

























function textLine_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function textLine_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function textLine_createClass(Constructor, protoProps, staticProps) { if (protoProps) textLine_defineProperties(Constructor.prototype, protoProps); if (staticProps) textLine_defineProperties(Constructor, staticProps); return Constructor; }
function textLine_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { textLine_get = Reflect.get; } else { textLine_get = function _get(target, property, receiver) { var base = textLine_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return textLine_get(target, property, receiver || target); }
function textLine_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = textLine_getPrototypeOf(object); if (object === null) break; } return object; }
function textLine_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) textLine_setPrototypeOf(subClass, superClass); }
function textLine_setPrototypeOf(o, p) { textLine_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return textLine_setPrototypeOf(o, p); }
function textLine_createSuper(Derived) { var hasNativeReflectConstruct = textLine_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = textLine_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = textLine_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return textLine_possibleConstructorReturn(this, result); }; }
function textLine_possibleConstructorReturn(self, call) { if (call && (textLine_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return textLine_assertThisInitialized(self); }
function textLine_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function textLine_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function textLine_getPrototypeOf(o) { textLine_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return textLine_getPrototypeOf(o); }
function textLine_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var textLine_isEnterKey = (0,lib/* default */.ZP)('enter');
var isShiftEnterKey = (0,lib/* default */.ZP)('shift+enter');
var textLine_isTabKey = (0,lib/* default */.ZP)('tab');
var textLine_isShiftTabKey = (0,lib/* default */.ZP)('shift+tab');
var INLINE_MARKDOWNS = {
  'bold': '**',
  'italic': '*',
  'strikethrough': '~',
  'underline': '__',
  'code': '`'
};
var BLOT_MARKDOWNS = {
  'hLine': '---',
  'syntax': '```',
  'hLarge': '#',
  'hMedium': '##',
  'hSmall': '###',
  'list': {
    'listItemBullet': ['*', '+', '-'],
    'listItemNumber': '1.',
    'listItemCheckbox': '[]'
  },
  'blockquote': '"'
};
var MAX_INDENT_LEVEL = 5;
var TextLine = /*#__PURE__*/function (_TextBase) {
  textLine_inherits(TextLine, _TextBase);
  var _super = textLine_createSuper(TextLine);
  // если тут стоит true, то значит у блота установлено min-height, которое ставится для пустых блотов, которые последние в своем
  // контейнере

  function TextLine(domNode) {
    var _this;
    textLine_classCallCheck(this, TextLine);
    _this = _super.call(this, domNode);
    textLine_defineProperty(textLine_assertThisInitialized(_this), "lastBlotHeightSet", false);
    textLine_defineProperty(textLine_assertThisInitialized(_this), "onDocumentTextLineMouseUp", function (event) {
      if (_this.isBlotLocked) return;
      var manager = _this.editor && _this.editor.plugins && _this.editor.plugins.mentionManager;
      if (_this.isFocusedClassSet() && manager) {
        var blotRange = _this.scroll.selection.getRange({
          offsetBlot: textLine_assertThisInitialized(_this)
        })[0];
        if (blotRange) {
          var targetSymbol = blotRange.index > 0 ? _this.getText(blotRange.index - 1, 1) : null;
          var prevSymbol = blotRange.index > 0 ? _this.getText(blotRange.index - 2, 1) : null;
          var nextSymbol = _this.getText(blotRange.index, 1);
          if (targetSymbol === '@' && !manager.session && _this.editor.isEditable()) {
            if ((blotRange.index === 1 || prevSymbol === ' ' || prevSymbol === '\n') && (nextSymbol === ' ' || !nextSymbol || nextSymbol === '\n')) {
              if (manager) {
                _this.editor.plugins.mentionManager.start(textLine_assertThisInitialized(_this), blotRange);
              }
            }
          }
        }
      }
    });
    textLine_defineProperty(textLine_assertThisInitialized(_this), "textLineOnTextChange", function (delta, oldDelta, source) {
      if (source === 'yjs') return;
      var insertedSymbol = getDeltaInsertOps(delta)[0] ? getDeltaInsertOps(delta)[0].insert : false;
      var blotRange = _this.scroll.selection.getRange({
        offsetBlot: textLine_assertThisInitialized(_this)
      })[0];
      var isMarkdownAllowed = !_this.disallowMarkDown;
      if (isMarkdownAllowed && Object.keys(_this.editor.options).includes('markdown')) {
        isMarkdownAllowed = _this.editor.options.markdown;
      }
      if (_this.editor.mode === MODE_LITE) {
        isMarkdownAllowed = false;
      }
      if (isMarkdownAllowed) {
        if (delta.changeLength() === 1 && blotRange) {
          _this.tryConvertMarkdown(insertedSymbol, blotRange);
        }
      }
      if (_this.editor.plugins.mentionManager.session) return; //если сессия добавления упоминания уже запущена, код не выполняем

      if (delta.changeLength() === 1 && blotRange) {
        var prevSymbol = blotRange.index > 1 ? _this.getText(blotRange.index - 2, 1) : null;
        var nextSymbol = _this.getText(blotRange.index, 1);
        if (nextSymbol === '\n') {
          nextSymbol = null;
        }
        if (insertedSymbol === '@' && !_this.disallowMention) {
          if ((blotRange.index === 1 || prevSymbol === ' ' || prevSymbol === '\n') && (nextSymbol === ' ' || !nextSymbol)) {
            _this.editor.plugins.mentionManager.start(textLine_assertThisInitialized(_this), blotRange);
          }
        }
        if (insertedSymbol === '/' && _this.editor.plugins.convertBlotManager && _this.editor.plugins.convertBlotManager.options.enabled) {
          if ((blotRange.index === 1 || prevSymbol === ' ' || prevSymbol === '\n') && (nextSymbol === ' ' || !nextSymbol)) {
            _this.editor.plugins.convertBlotManager.start(textLine_assertThisInitialized(_this), blotRange);
          }
        }
        if (blotRange.index === 1 && delta.ops[0].attributes && delta.ops[0].attributes.link) {
          _this.formatAt(0, 1, 'link', false);
        }
        _this.editor.emitter.emit('character-input', {
          character: insertedSymbol,
          prev: prevSymbol,
          next: nextSymbol,
          blotId: _this.id
        });
      }
    });
    _this.isSeparableByClickApplicable = true;
    return _this;
  }
  textLine_createClass(TextLine, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = textLine_get(textLine_getPrototypeOf(TextLine.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      this.on('text-change', this.textLineOnTextChange);
      var manager = this.editor && this.editor.plugins && this.editor.plugins.mentionManager;
      this.domNode && manager && this.domNode.addEventListener('mouseup', this.onDocumentTextLineMouseUp.bind(this), false);
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = textLine_get(textLine_getPrototypeOf(TextLine.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      var manager = this.editor && this.editor.plugins && this.editor.plugins.mentionManager;
      this.domNode && manager && this.domNode.removeEventListener('mouseup', this.onDocumentTextLineMouseUp, false);
    }
  }, {
    key: "textLineAddBlotParams",
    value:
    // наследующие блоты могут переопределять эту функцию чтобы изменять параметры при создании блота, когда разбивается строка
    function textLineAddBlotParams(params) {
      return params;
    }
  }, {
    key: "textLineAddNextBlot",
    value: function textLineAddNextBlot() {
      var initParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var blotType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var indent = this.map.get('indent');
      var params = Object.assign(initParams, this.textLineAddBlotParams({
        indent: initParams.hasOwnProperty('indent') ? initParams.indent : indent,
        after: this.id
      }));
      blotType = blotType || this.constructor.blotName;
      return this.parent.addBlot(blotType, params);
    }
  }, {
    key: "textLineSplit",
    value: function textLineSplit(index) {
      var _this2 = this;
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$selection$getRa = this.selection.getRange({
          offsetBlot: this
        }),
        _this$selection$getRa2 = textLine_slicedToArray(_this$selection$getRa, 1),
        blotRange = _this$selection$getRa2[0];
      var formats = this.getFormat(blotRange.index, 1);
      Object.keys(formats).map(function (format) {
        _this2.selection.format(format, false);
      });
      var initDelta = null;
      var newBlot = this.split(index, true);
      if (newBlot && newBlot !== this.next) {
        //to build delta with formats set parent to the detached blot
        newBlot.parent = this.parent;
        initDelta = newBlot.delta();
        this.scroll.update();
      }
      var addNextBlotOpts = {
        delta: initDelta
      };
      if (opts.focus) {
        addNextBlotOpts.focus = {
          index: 0
        };
      }
      this.textLineAddNextBlot(addNextBlotOpts);
    }
  }, {
    key: "textLineOnEnterKey",
    value: function textLineOnEnterKey(event) {
      console.groupCollapsed('textLine: handle ENTER key');
      var range = this.scroll.selection.getNativeRange();
      if (!range) {
        event.preventDefault();
        return;
      }
      var preventDefault = true;
      if (this.editor.options.keyboardMode === 'mobile') {
        if (range.start.node == range.end.node && range.start.node.length === range.start.offset) {
          if (this.parent && this.parent === this.scroll) {
            // В мобильной вресии не выполняем preventDefault
            // 1. При выполнении preventDefault в некоторых раскладках происходит замена нескольких символов разделенных enter на один символ/иероглиф
            // 2. В iOS при выполнении preventDefault клавиатура не переходит в верхний регистр на новой строке
            preventDefault = false;
          }
        }
      }
      if (preventDefault) {
        event.preventDefault();
      }
      if (range.start.node == range.end.node) {
        this.editor.plugins.undoManager.stopCapturing();
        var _this$selection$getRa3 = this.selection.getRange({
            offsetBlot: this
          }),
          _this$selection$getRa4 = textLine_slicedToArray(_this$selection$getRa3, 1),
          blotRange = _this$selection$getRa4[0];
        this.tryConvertLink(blotRange);
        if (preventDefault) {
          this.textLineSplit(blotRange.index, {
            focus: true
          });
        }
      }
      console.groupEnd();
      return true;
    }
  }, {
    key: "textLineOnShiftEnterKey",
    value: function textLineOnShiftEnterKey(event) {
      var _this$selection$getRa5 = this.selection.getRange({
          offsetBlot: this
        }),
        _this$selection$getRa6 = textLine_slicedToArray(_this$selection$getRa5, 1),
        blotRange = _this$selection$getRa6[0];
      var _this$selection$getRa7 = this.selection.getRange(),
        _this$selection$getRa8 = textLine_slicedToArray(_this$selection$getRa7, 2),
        quillRange = _this$selection$getRa8[0],
        nativeRange = _this$selection$getRa8[1];
      var range = this.selection.getNativeRange();
      if (range.start.node != range.end.node) {
        return;
      }
      if (range.start.offset != range.end.offset) {
        return;
      }
      this.tryConvertLink(blotRange);
      this.map.get('characters').applyDelta([{
        retain: blotRange.index
      }, {
        insert: {
          linebreak: 's'
        }
      }]);
      event.preventDefault();
      // устанавливаем курсор после элемента <br>
      quillRange.index++;
      this.selection.setRange(quillRange);
      return true;
    }

    /**
     * вставляет символ \t в позицию заданную blotRange
     * @param {Range} blotRange   Range относительно текущего блота
     * @param {Range} scrollRange Range относительного всего редактора, используется для установки
     *                            позиции каретки после вставки символа
     */
  }, {
    key: "addTabToRange",
    value: function addTabToRange(blotRange, scrollRange) {
      this.map.get('characters').applyDelta([{
        retain: blotRange.index
      }, {
        delete: blotRange.length
      }, {
        insert: '\t'
      }]);
      this.selection.setRange({
        index: scrollRange.index + 1,
        length: 0
      });
    }
  }, {
    key: "textLineOnTabKey",
    value: function textLineOnTabKey(event) {
      var addIndent = false;
      var _this$selection$getRa9 = this.selection.getRange({
          offsetBlot: this
        }),
        _this$selection$getRa10 = textLine_slicedToArray(_this$selection$getRa9, 1),
        blotRange = _this$selection$getRa10[0];
      // если выделен более чем 1 блот, то выполняется сдвиг блотов
      addIndent = this.scroll.selectedBlocks.length > 1;
      if (!addIndent) {
        // нажатие таба в начале элемента
        addIndent = blotRange.index === 0;
      }
      if (addIndent) {
        // надо выполнить сдвиг элемента на +1
        this.addIndent();
      } else {
        var _this$selection$getRa11 = this.selection.getRange(),
          _this$selection$getRa12 = textLine_slicedToArray(_this$selection$getRa11, 1),
          range = _this$selection$getRa12[0];
        // надо вставить символ табуляции в текущую позицию каретки
        this.addTabToRange(blotRange, range);
      }
      event.preventDefault();
      return true;
    }
  }, {
    key: "textLineOnShiftTabKey",
    value: function textLineOnShiftTabKey(event) {
      var delIndent = false;
      var _this$selection$getRa13 = this.selection.getRange({
          offsetBlot: this
        }),
        _this$selection$getRa14 = textLine_slicedToArray(_this$selection$getRa13, 1),
        blotRange = _this$selection$getRa14[0];
      // если выделен более чем 1 блот, то выполняется сдвиг блотов
      delIndent = this.scroll.selectedBlocks.length > 1;
      if (!delIndent) {
        // нажатие shift + tab в начале элемента списка
        delIndent = blotRange.index === 0;
      }
      if (delIndent) {
        // надо выполнить сдвиг элемента на -1
        this.removeIndent();
      } else {
        var _this$selection$getRa15 = this.selection.getRange(),
          _this$selection$getRa16 = textLine_slicedToArray(_this$selection$getRa15, 1),
          range = _this$selection$getRa16[0];
        // надо вставить символ табуляции в текущую позицию каретки
        this.addTabToRange(blotRange, range);
      }
      event.preventDefault();
      return true;
    }
  }, {
    key: "textLineOnBackspace",
    value: function textLineOnBackspace(action) {
      var processed = false;
      var blotRange = action.getBlotRange(this);
      if (blotRange.index === 0 && this.map.get('indent') > 0) {
        this.removeIndent();
        action.dontRestoreSelection();
        processed = true;
      }
      if (blotRange.index !== 0 && blotRange.length === 0) {
        var deleteDelta = this.getContents(blotRange.index - 1, 1);
        var insert = deleteDelta.ops[0].insert;
        var _Object$keys = Object.keys(insert),
          _Object$keys2 = textLine_slicedToArray(_Object$keys, 1),
          blotCode = _Object$keys2[0];
        if (insert instanceof Object && INLINE_EMBED_BLOTS.includes(blotCode)) {
          this.map.get('characters').applyDelta([{
            retain: blotRange.index - 1
          }, {
            delete: 1
          }]);
          processed = true;
        }
      }
      return processed;
    }
  }, {
    key: "handleInput",
    value: function handleInput(event) {
      // Если в событии keydown keyCode = 229 и последний введённый символо \n то самостоятельно диспатчим событие
      // нажатия на Enter
      if (this.isMobileKeyDown && this.parent && this.parent !== this.scroll) {
        if (event.data && event.data.substr(event.data.length - 1, 1) === "\n") {
          if (this.domNode.nextSibling && this.domNode.nextSibling.innerText.trim() === '') {
            if (!this.domNode.nextSibling.id || this.domNode.nextSibling.id === this.id) {
              this.domNode.nextSibling.remove();
            }
          }
          // устанавливаем курсок в конце строки
          this.focusableFocus();
          var range = this.scroll.selection.getRange(this);
          this.scroll.selection.setRange({
            index: range[0].index + this.length() - 1,
            length: 0
          });
          var keyEvent = new KeyboardEvent('keydown', {
            bubbles: true,
            cancelable: true,
            key: 'Enter',
            keyCode: 13
          });
          this.domNode.dispatchEvent(keyEvent);
        }
        this.isMobileKeyDown = false;
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (this.isBlotLocked) {
        return;
      }
      // Нажатие ENTER
      if (this.editor.options.keyboardMode === 'mobile') {
        this.isMobileKeyDown = event.keyCode === 229;
        //this.parent.isMobileKeyDown = event.keyCode === 229
      }

      if (textLine_isEnterKey(event)) {
        return this.textLineOnEnterKey(event);
      } else if (isShiftEnterKey(event)) {
        if (this.blotConfig && this.blotConfig.disableShiftEnter) {
          return this.textLineOnEnterKey(event);
        } else {
          return this.textLineOnShiftEnterKey(event);
        }
      } else if (textLine_isTabKey(event)) {
        return this.textLineOnTabKey(event);
      } else if (textLine_isShiftTabKey(event)) {
        return this.textLineOnShiftTabKey(event);
      }
      return textLine_get(textLine_getPrototypeOf(TextLine.prototype), "handleKeyDown", this).call(this, event);
    }
  }, {
    key: "render",
    value: function render() {
      textLine_get(textLine_getPrototypeOf(TextLine.prototype), "render", this).call(this);
      var currentIndent = this.map.get('indent');
      var maxIndent = this.constructor.textLineGetMaxIndent();
      for (var indent = 0; indent <= maxIndent; indent++) {
        var className = 'indent-' + indent;
        if (indent === currentIndent) {
          this.domNode.classList.add(className);
        } else {
          this.domNode.classList.remove(className);
        }
      }
      if (this.editor.options.setHeightForLastTextLine) {
        var resetLastBlotHeight = true;
        if (this.props.focused && this.cache && this.cache.delta) {
          var delta = this.cache.delta;
          if (delta.ops && delta.ops.length === 1 && delta.ops[0].insert === '\n') {
            if (this.parent.children.tail === this) {
              var height = (0,dom/* getComputedStyle */.Dx)(this.domNode, 'height', 'px');
              if (height) {
                this.domNode.style.minHeight = height + 'px';
                this.lastBlotHeightSet = true;
                resetLastBlotHeight = false;
              }
            }
          }
        }
        if (resetLastBlotHeight && this.lastBlotHeightSet) {
          this.domNode.style.minHeight = '';
          this.lastBlotHeightSet = false;
        }
      }
    }
  }, {
    key: "exec",
    value: function exec(action) {
      if (action.type === 'backspace') {
        if (this.textLineOnBackspace(action)) {
          return true;
        }
      }
      return textLine_get(textLine_getPrototypeOf(TextLine.prototype), "exec", this).call(this, action);
    }
  }, {
    key: "appendChild",
    value: function appendChild() {
      var _get4;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      var blot = args[0];
      if (this.children.tail instanceof linebreak && this.children.tail.value().linebreak === 'h' && blot && blot.length && blot.length()) {
        this.children.tail.remove();
      }
      (_get4 = textLine_get(textLine_getPrototypeOf(TextLine.prototype), "appendChild", this)).call.apply(_get4, [this].concat(args));
    }

    /**
     * splits textLine blot and returns a new blot with contents filled
     * the only difference from parchment's Container#split is that this method doesn't append new blot to the tree
     * @param  {int}  index
     * @param  {Boolean} forc
     * @return {Blot}
     */
  }, {
    key: "split",
    value: function split(index) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!force) {
        if (index === 0) return this;
        if (index === this.length()) return this.next;
      }
      var after = this.clone();
      this.children.forEachAt(index, this.length(), function (child, offset, length) {
        child = child.split(offset, force);
        after.appendChild(child);
      });
      return after;
    }
  }, {
    key: "getRightClickMenu",
    value: function getRightClickMenu(menu) {
      var _this3 = this;
      var _this$selection$getRa17 = this.selection.getRange({
          offsetBlot: this
        }),
        _this$selection$getRa18 = textLine_slicedToArray(_this$selection$getRa17, 1),
        blotRange = _this$selection$getRa18[0];
      if (blotRange) {
        menu.push({
          id: 'link',
          icon: 'fa-link',
          title: 'link...',
          func: function func() {
            addLinkAction(_this3.editor);
          },
          commandKey: true,
          keys: 'K'
        });
        var _start$end = {
            start: this.getFormat(blotRange.index, 1),
            end: this.getFormat(blotRange.index + blotRange.length - 1, 1)
          },
          start = _start$end.start,
          end = _start$end.end;
        if (start.link && start.link === end.link) {
          menu.push.apply(menu, [{
            id: 'open-link',
            icon: 'fa-external-link',
            title: 'Open link',
            func: function func() {
              window.open(start.link, 'noopener');
            },
            commandKey: false,
            keys: (this.editor.platform == 'Mac OS' ? 'Option' : 'Alt') + '+Enter'
          }, {
            id: 'copy-url',
            icon: 'fa-clone',
            title: 'Copy url',
            func: function func() {
              _this3.editor.plugins.copyManager.copy(start.link);
            },
            commandKey: false,
            keys: false
          }]);
        }
        if (blotRange.length > 0) {
          menu.push({
            id: 'clear-format',
            icon: 'fa-trash-o',
            title: 'clear formatting',
            func: function func() {
              _this3.editor.exec('clear-formatting');
            },
            commandKey: true,
            keys: '/'
          });
        }
      }
      return menu;
    }
  }, {
    key: "optimize",
    value: function optimize() {
      textLine_get(textLine_getPrototypeOf(TextLine.prototype), "optimize", this).call(this);
      if (this.children.tail instanceof linebreak) {
        if (this.children.tail.value().linebreak === 's') {
          this.appendChild(parchment_default().create('linebreak'));
        } else {
          if (this.children.tail.prev && !(this.children.tail.prev instanceof linebreak)) {
            this.children.tail.remove();
          }
        }
      }
    }

    // Данная функция реулизует форматирование markdown непосредственно при печати
    // и ищет только первое совпадение правила. Поиск происходит от каретки к началу блока, справа налево.
  }, {
    key: "tryConvertMarkdown",
    value: function tryConvertMarkdown(sym, blotRange) {
      var _this4 = this;
      var undoManagerCapture = function undoManagerCapture() {
        _this4.editor.plugins.undoManager.stopCapturing();
        _this4.editor.plugins.undoManager.captureRange();
      };
      // функция ищет совпадения правил форматирования и форматирует текст, при успешном нахождении и форматировании возвращает true, иначе false
      var tryFormatInline = function tryFormatInline(format) {
        var length = INLINE_MARKDOWNS[format].length;
        var processed = false;
        // если длина текста в блоте меньше двойной длины markdown и плюс хотя бы одного символа, возвращаем false
        if (_this4.length() - 1 < length * 2 + 1) {
          return false;
        }
        // проверяем является ли текст перед кареткой markdown
        var allow = _this4.getText(blotRange.index - length, length) === INLINE_MARKDOWNS[format];
        if (allow) {
          // если текст перед кареткой является markdown, проверяем, что перед markdown не пробел
          var symBeforeMark = _this4.getText(blotRange.index - length - 1, 1);
          allow = symBeforeMark !== ' ' && (length > 1 || symBeforeMark !== sym);
        }
        if (allow) {
          // текст перед markdown длиной в markdown
          var textBeforeMark = _this4.getText(blotRange.index - length * 2, length);
          // индекс с которого начинаем поиск назад
          var index = blotRange.index - length - 1;
          // ищем в тексте предыдущий markdown, соответствующий format
          while (textBeforeMark !== INLINE_MARKDOWNS[format] && index > 0) {
            index--;
            textBeforeMark = _this4.getText(index, length);
          }
          if (textBeforeMark === INLINE_MARKDOWNS[format]) {
            // проверяем чтоб после найденного начала markdown не стоял пробел и перед ним стоял пробел, если это не так возвращаем false
            var before = index !== 0 ? _this4.getText(index - 1, 1) : false;
            var after = _this4.getText(index + length, 1);
            if (after !== ' ' && (index === 0 || before === ' ')) {
              // получаем текст заключенный в markdown
              var markedText = _this4.getText(index + length, blotRange.index - index - length * 2);
              if (markedText) {
                undoManagerCapture();
                // удаляем конец markdown
                _this4.deleteAt(blotRange.index - length, length);
                // удаляем начало markdown
                _this4.deleteAt(index, length);
                // форматируем текст
                _this4.formatText(index, markedText.length, format, true);
                _this4.selection.setRange({
                  index: _this4.offset(_this4.scroll) + blotRange.index - length * 2,
                  length: 0
                });
                _this4.selection.format(format, false);
                processed = true;
              }
            }
          }
        }
        return processed;
      };
      var tryConvertBlot = function tryConvertBlot(sym, blotRange) {
        var text = _this4.getText().trim();
        for (var type in BLOT_MARKDOWNS) {
          if (typeof BLOT_MARKDOWNS[type] === 'string') {
            if (text === BLOT_MARKDOWNS[type]) {
              undoManagerCapture();
              _this4.deleteAt(0, BLOT_MARKDOWNS[type].length + 1);
              _this4.container.containerConvertBlots([_this4], {
                type: type
              });
              break;
            }
          } else {
            for (var key in BLOT_MARKDOWNS[type]) {
              if (typeof BLOT_MARKDOWNS[type][key] === 'string') {
                if (text === BLOT_MARKDOWNS[type][key] || type === 'list' && text.startsWith(BLOT_MARKDOWNS[type][key] + ' ')) {
                  var markdownLength = BLOT_MARKDOWNS[type][key].length;
                  var cursorPoint = blotRange.index - markdownLength - 1;
                  if (sym === ' ' && cursorPoint === 0) {
                    undoManagerCapture();
                    _this4.deleteAt(0, BLOT_MARKDOWNS[type][key].length + 1);
                    _this4.container.containerConvertBlots([_this4], {
                      type: type,
                      items: [key]
                    });
                    break;
                  }
                }
              } else {
                var _iterator = textLine_createForOfIteratorHelper(BLOT_MARKDOWNS[type][key]),
                  _step;
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    var i = _step.value;
                    if (text === i || type === 'list' && text.startsWith(i + ' ')) {
                      var _markdownLength = i.length;
                      var _cursorPoint = blotRange.index - _markdownLength - 1;
                      if (sym === ' ' && _cursorPoint === 0) {
                        undoManagerCapture();
                        _this4.deleteAt(0, i.length + 1);
                        _this4.container.containerConvertBlots([_this4], {
                          type: type,
                          items: [key]
                        });
                        break;
                      }
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              }
            }
          }
        }
      };
      switch (sym) {
        case '*':
          if (!tryFormatInline('italic')) {
            tryFormatInline('bold');
          }
          break;
        case '~':
          tryFormatInline('strikethrough');
          break;
        case '_':
          tryFormatInline('underline');
          break;
        case '`':
          tryFormatInline('code');
          break;
        case '>':
          var prevSymbol = blotRange.index > 1 ? this.getText(blotRange.index - 2, 1) : null;
          if (prevSymbol === '-') {
            this.convertArrow();
          }
          break;
        case ' ':
          if (this.constructor.blotName === 'paragraph') {
            tryConvertBlot(sym, blotRange);
          }
          break;
      }
    }
  }, {
    key: "convertArrow",
    value: function convertArrow() {
      // получаем quillRange до манипуляций с контентом
      var _this$scroll$selectio = this.scroll.selection.getRange(),
        _this$scroll$selectio2 = textLine_slicedToArray(_this$scroll$selectio, 1),
        quillRange = _this$scroll$selectio2[0];
      // получаем blotRange для работы с конентентом блота
      var _this$scroll$selectio3 = this.scroll.selection.getRange({
          offsetBlot: this
        }),
        _this$scroll$selectio4 = textLine_slicedToArray(_this$scroll$selectio3, 1),
        blotRange = _this$scroll$selectio4[0];
      // получаем форматирование символа перед кареткой, чтобы стрелка приняла то же форматирование
      var attributes = this.getFormat(blotRange.index - 1, 1);
      // пишем операции сразу в map блота, без лишних вызовов функций изменения контента в самом блоте
      this.map.get('characters').applyDelta([{
        retain: blotRange.index - 2 // отступ от начала блота
      }, {
        delete: 2 // удаляем 2 символа
      }, {
        insert: '→',
        // вставляем стрелку вместо 2х удаленных символов
        attributes: attributes // с атрибутами второго символа
      }]);

      quillRange.index -= 1; // уменьшаем quillRange.index на 1, так как было 2 символа, стал 1, каретка должна встать после него
      this.scroll.selection.setRange(quillRange); // применяем новый quillRange к редактору
    }
  }, {
    key: "beforeCopyContent",
    value: function beforeCopyContent() {
      // нужно удалить фон блока, который ставиться при selected-block
      // сначала удаляем transition, чтобы фон исчез сразу, иначе если не убрать, во время действия он еще есть
      if (!this.map.get('color') || this.map.get('color') === 'transparent') {
        this.domNode.style.transition = 'unset';
        this.domNode.style.background = 'transparent !important';
      }
      this.scroll.selection.setRange({
        index: this.offset(this.scroll),
        length: this.length() - 1
      });
    }
  }, {
    key: "afterCopyContent",
    value: function afterCopyContent() {
      if (!this.map.get('color') || this.map.get('color') === 'transparent') {
        this.domNode.style.removeProperty('transition');
        this.domNode.style.removeProperty('background');
      }
    }
  }], [{
    key: "initMap",
    value: function initMap(map, store, params) {
      if (textLine_get(textLine_getPrototypeOf(TextLine), "initMap", this)) {
        textLine_get(textLine_getPrototypeOf(TextLine), "initMap", this).call(this, map, store, params);
      }
      if (!map.has('indent')) {
        if (this.getMaxIndent) {
          map.set('indent', Math.min(params.indent || 0, this.getMaxIndent()));
        } else {
          map.set('indent', Math.min(params.indent || 0, this.textLineGetMaxIndent()));
        }
      }
    }
  }, {
    key: "textLineGetMaxIndent",
    value: function textLineGetMaxIndent() {
      return MAX_INDENT_LEVEL;
    }
  }]);
  return TextLine;
}(textBase);
TextLine.defaultChild = textBase.defaultChild;
TextLine.allowedChildren = textBase.allowedChildren;
TextLine.canExecActions = textBase.canExecActions.slice();
/* harmony default export */ const textLine = (TextLine);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/abstractBlots.js
/* harmony default export */ const abstractBlots = ({});
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/mixins/commentable.js
function commentable_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { commentable_typeof = function _typeof(obj) { return typeof obj; }; } else { commentable_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return commentable_typeof(obj); }
function commentable_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function commentable_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { commentable_ownKeys(Object(source), true).forEach(function (key) { commentable_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { commentable_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function commentable_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


















function commentable_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function commentable_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function commentable_createClass(Constructor, protoProps, staticProps) { if (protoProps) commentable_defineProperties(Constructor.prototype, protoProps); if (staticProps) commentable_defineProperties(Constructor, staticProps); return Constructor; }
function commentable_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { commentable_get = Reflect.get; } else { commentable_get = function _get(target, property, receiver) { var base = commentable_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return commentable_get(target, property, receiver || target); }
function commentable_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = commentable_getPrototypeOf(object); if (object === null) break; } return object; }
function commentable_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) commentable_setPrototypeOf(subClass, superClass); }
function commentable_setPrototypeOf(o, p) { commentable_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return commentable_setPrototypeOf(o, p); }
function commentable_createSuper(Derived) { var hasNativeReflectConstruct = commentable_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = commentable_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = commentable_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return commentable_possibleConstructorReturn(this, result); }; }
function commentable_possibleConstructorReturn(self, call) { if (call && (commentable_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return commentable_assertThisInitialized(self); }
function commentable_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function commentable_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function commentable_getPrototypeOf(o) { commentable_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return commentable_getPrototypeOf(o); }
var Commentable = function Commentable(superclass) {
  return /*#__PURE__*/function (_superclass) {
    commentable_inherits(_class, _superclass);
    var _super = commentable_createSuper(_class);
    function _class() {
      commentable_classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _super.call.apply(_super, [this].concat(args));
    }
    commentable_createClass(_class, [{
      key: "commentBlock",
      value: function commentBlock() {
        var _this = this;
        var commentManager = this.editor.plugins.commentManager;
        if (commentManager && commentManager.openComments) {
          // для того, чтобы при повторном добавлении комментария открыть тред
          // проверяем добавлен ли тред для блота
          var comment = commentManager.comments.find(function (_ref) {
            var blotId = _ref.blotId,
              target = _ref.target;
            return blotId === _this.id && target === 'blot';
          });
          var params = {};
          if (comment) {
            params.threadId = comment.threadId;
          }
          commentManager.openComments(this.id, commentable_objectSpread({
            target: 'blot'
          }, params)).then(function (_ref2) {
            var threadId = _ref2.threadId,
              isNew = _ref2.isNew;
            if (isNew) {
              commentManager.constructor.addThreadToBlot(_this, threadId);
            }
          });
        }
      }
    }, {
      key: "contextMenu",
      get: function get() {
        var i18n = this.editor.plugins.i18n;
        var menu = commentable_get(commentable_getPrototypeOf(_class.prototype), "contextMenu", this);
        if (this.editor.plugins.commentManager && this.editor.plugins.commentManager.options.enabled) {
          menu.comment = {
            label: i18n.get('block_menu.comment_block'),
            index: -21,
            group: 0,
            action: 'commentBlock',
            stackable: false
          };
        }
        return menu;
      }
    }], [{
      key: "setCommentThreads",
      value: function setCommentThreads(blot, obj) {
        if (blot) {
          if (blot.map.has('commentThreads')) {
            obj.commentThreads = blot.map.get('commentThreads');
          } else {
            // для обратной совместимости со старой версией комментариев
            if (blot.editor) {
              // если у конвертируемого блота есть комментарий, то в сконвертируемый запишется threadId комментария
              var comment = blot.editor.plugins.commentManager.comments.find(function (c) {
                return c.blotId === blot.id;
              });
              if (comment) {
                obj.commentThreads = comment.threadId;
              }
            }
          }
        }
      }
    }, {
      key: "initMap",
      value: function initMap(map, store) {
        var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        commentable_get(commentable_getPrototypeOf(_class), "initMap", this) && commentable_get(commentable_getPrototypeOf(_class), "initMap", this).call(this, map, store, params);
        if (params.commentThreads) {
          map.set('commentThreads', params.commentThreads);
        }
      }
    }]);
    return _class;
  }(superclass);
};
/* harmony default export */ const commentable = (Commentable);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/mixins/container.js
function container_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { container_typeof = function _typeof(obj) { return typeof obj; }; } else { container_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return container_typeof(obj); }
function container_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = container_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function container_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return container_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return container_arrayLikeToArray(o, minLen); }
function container_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
























function container_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function container_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function container_createClass(Constructor, protoProps, staticProps) { if (protoProps) container_defineProperties(Constructor.prototype, protoProps); if (staticProps) container_defineProperties(Constructor, staticProps); return Constructor; }
function container_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) container_setPrototypeOf(subClass, superClass); }
function container_setPrototypeOf(o, p) { container_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return container_setPrototypeOf(o, p); }
function container_createSuper(Derived) { var hasNativeReflectConstruct = container_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = container_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = container_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return container_possibleConstructorReturn(this, result); }; }
function container_possibleConstructorReturn(self, call) { if (call && (container_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return container_assertThisInitialized(self); }
function container_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function container_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function container_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { container_get = Reflect.get; } else { container_get = function _get(target, property, receiver) { var base = container_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return container_get(target, property, receiver || target); }
function container_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = container_getPrototypeOf(object); if (object === null) break; } return object; }
function container_getPrototypeOf(o) { container_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return container_getPrototypeOf(o); }
function container_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var Container = function Container(superclass) {
  return /*#__PURE__*/function (_superclass) {
    container_inherits(_class2, _superclass);
    var _super = container_createSuper(_class2);
    function _class2() {
      var _this;
      container_classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      container_defineProperty(container_assertThisInitialized(_this), "onChildrenUpdated", function (event) {
        var isRemote = event._transaction.origin === 'remote';
        if (isRemote) {
          _this.scroll.update();
        }
        _this.render();
        if (isRemote) {
          _this.scroll.update(undefined, undefined, 'remote');
        }

        // Мы анализируем всю транзакцию и находим в ней все удаления и добавления дочерних блотов
        // это нужно для того, чтобы при перемещении блотов не вызывать лишний раз события удаления/добавления
        // для перемещаемых блотов.
        // Тут раскрываются внутренности yjs, т.к. мы берем значение из ContentJSON прямо из айтема
        // и анализируем changed у транзакции
        var wholeTransactionAddedIds = new Set();
        var wholeTransactionDeletedIds = new Set();
        event._transaction.changed.forEach(function (subs, itemtype) {
          if (itemtype instanceof _this.rootStore.types.Array && itemtype !== event.target) {
            // созаем событие YEvent, т.к. оно внутри умеет высчитывать изменения, которые произошли
            // внутри типа
            var yEvent = new _this.rootStore.Y.YEvent(itemtype, event._transaction);
            var _iterator = container_createForOfIteratorHelper(yEvent.changes.added),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var addedItem = _step.value;
                if (addedItem.content && addedItem.content.arr && typeof addedItem.content.arr[0] === 'string') {
                  wholeTransactionAddedIds.add(addedItem.content.arr[0]);
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            var _iterator2 = container_createForOfIteratorHelper(yEvent.changes.deleted),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var deletedItem = _step2.value;
                if (deletedItem.content && deletedItem.content.arr && typeof deletedItem.content.arr[0] === 'string') {
                  wholeTransactionDeletedIds.add(deletedItem.content.arr[0]);
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        });
        var _iterator3 = container_createForOfIteratorHelper(event.changes.added),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var addedItem = _step3.value;
            var id = addedItem.content.arr[0];
            if (wholeTransactionDeletedIds.has(id)) {
              continue;
            }
            _this.editor.emit(EVENT_BLOT_ADDED, {
              id: id
            });
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        var _iterator4 = container_createForOfIteratorHelper(event.changes.deleted),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var deletedItem = _step4.value;
            var _id = deletedItem.content.arr[0];
            if (wholeTransactionAddedIds.has(_id)) {
              continue;
            }
            _this.editor.emit(EVENT_BLOT_REMOVED, {
              id: _id
            });
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      });
      _this.isContainer = true;
      _this._onceRenderedActions = [];
      return _this;
    }
    container_createClass(_class2, [{
      key: "containerChildren",
      get: function get() {
        var map = this.map;
        if (this.map.has('subDoc')) {
          return this.subDoc.getArray('rootChildren');
        }
        return map.get(this.getChildrenKey());
      }
    }, {
      key: "getChildrenKey",
      value: function getChildrenKey() {
        var key = 'children';
        if (this.childrenKey) {
          key = this.childrenKey;
        }
        return key;
      }
    }, {
      key: "setChildrenListener",
      value: function setChildrenListener(map) {
        var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        if (this._childrenListenerSet) {
          return;
        }
        this._childrenListenerSet = true;
        store = store || this.rootStore;
        store.observe(this.containerChildren, this.onChildrenUpdated);
      }
    }, {
      key: "removeChildListener",
      value: function removeChildListener(map) {
        var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        if (!this._childrenListenerSet) {
          return;
        }
        this._childrenListenerSet = false;
        store = store || this.rootStore;
        var typeInst = map.get(this.containerChildren);
        if (typeInst) {
          store.unobserve(typeInst, this.onChildrenUpdated);
        }
      }
    }, {
      key: "attach",
      value: function attach() {
        var _get2;
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        (_get2 = container_get(container_getPrototypeOf(_class2.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
        if (this.map && this.editor.options.render) {
          this.render();
          this.setChildrenListener(this.map);
        }
      }
    }, {
      key: "detach",
      value: function detach() {
        var _get3;
        var store = this.rootStore;
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }
        (_get3 = container_get(container_getPrototypeOf(_class2.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
        if (this.map && this.editor.options.render) {
          this.removeChildListener(this.map, store);
        }
      }

      // возвращает store для ближайшего родительского документа
      // именно в нем хранятся мапы блотов и children данного контейнер-блота
      // если в родителях есть сабдокумент, то возвращает его
    }, {
      key: "getChildrenStore",
      value: function getChildrenStore() {
        var subDoc = this.subDoc;
        var store = this.rootStore;
        if (subDoc) {
          store = this.rootStore.getSubStore(subDoc);
        }
        return store;
      }
    }, {
      key: "insertBefore",
      value: function insertBefore(childBlot, refBlot) {
        if (!childBlot.map && !childBlot.constructor.notStored) {
          // блот не содержит map, скорей всего он был вставлен браузером автоматически и без контроля редактора
          // необходимо удалить этот блот и заменить на параграф
          var domNode = childBlot.domNode;
          if (domNode.parentNode) {
            domNode.parentNode.removeChild(domNode);
          }
          // проверяем можем ли мы вставить параграф в текущий контейнер
          if (!this.constructor.allowedChildren || this.constructor.allowedChildren.indexOf(abstractBlots.ParagraphAbstract) < 0) {
            return;
          }
          console.info('fixing blot attached not via Editor', domNode);
          var params = {
            before: refBlot ? refBlot.id : null
          };
          var innerText = domNode.innerText && domNode.innerText.trim();
          if (this.editor.options.keyboardMode === 'mobile' && innerText) {
            // Мобильная клавиатура при вводе иероглифов может автоматически стирать несколько последних симовлов и на их место вствлять новый иероглиф.
            // Поэтому при автоматической вставке параграфа в мобильном редакторе сохраняем его контент.
            // Аналогично при замене символов на смайл
            params.delta = {
              ops: [{
                insert: innerText
              }]
            };
            var paragraphId = this.addBlot('paragraph', params).id;
            var blot = this.editor.findById(paragraphId);
            this.scroll.selection.setRange({
              index: blot.offset(this.scroll) + innerText.length,
              length: 0
            });
          } else {
            this.addBlot('paragraph', params);
          }
          return;
        }
        container_get(container_getPrototypeOf(_class2.prototype), "insertBefore", this).call(this, childBlot, refBlot);
      }
    }, {
      key: "getChildIndex",
      value: function getChildIndex(id) {
        var index = 0;
        var _iterator5 = container_createForOfIteratorHelper(this.containerChildren),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var cid = _step5.value;
            if (id === cid) {
              return index;
            }
            index++;
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        return -1;
      }
    }, {
      key: "_onceRendered",
      value: function _onceRendered(action) {
        this._onceRenderedActions.push(action);
      }
    }, {
      key: "removeChildById",
      value: function removeChildById(id) {
        var moving = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var index = this.getChildIndex(id);
        this.removeChildByIndex(index, moving);
      }
    }, {
      key: "addChildById",
      value: function addChildById(id) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var index = params.hasOwnProperty('index') ? params.index : -1;
        if (params.after) {
          var childIndex = this.getChildIndex(params.after);
          if (childIndex >= 0) {
            index = childIndex + 1;
          }
        }
        if (params.before) {
          var _childIndex = this.getChildIndex(params.before);
          if (_childIndex >= 0) {
            index = _childIndex;
          }
        }
        if (index >= 0) {
          this.containerChildren.insert(index, [id]);
        } else {
          this.containerChildren.push([id]);
        }
      }
    }, {
      key: "removeChildByIndex",
      value: function removeChildByIndex(index) {
        var moving = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (index >= 0) {
          var id = this.containerChildren.get(index);
          this.containerChildren.delete(index);
        }
      }
      /**
       * перемещение блота в текущий контейнер
       * @param  {string/Object} id      идентификатор блота для перемещения или сам блот
       * @param  {int} index   индекс куда надо переместить
       * @param  {Object} context контекст перемещения, произвольный объект может использоватся блотами в #beforeMove
       * @return {string}         идентификатор добавленного блота
       */
    }, {
      key: "moveChild",
      value: function moveChild(id, index) {
        var _this2 = this;
        var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var blot;
        if (id instanceof Object) {
          blot = id;
          id = blot.id;
        }
        var insertId = id;
        if (!blot) {
          blot = this.editor.findById(id);
        }
        var store = this.getChildrenStore();
        var sourceStore = blot.store;
        store.transaction(function () {
          //console.groupCollapsed('Container#moveChild: ' + id + ' to ' + index)
          if (!blot) {
            console.error('cant find blot for move!', id, blot);
            return;
          }
          var removeBlot = blot;
          var removeId = id;
          if (blot.beforeMove) {
            var beforeMoveRes = blot.beforeMove(_this2, {
              index: index
            }, context);
            if (beforeMoveRes) {
              if (typeof beforeMoveRes.id !== 'undefined') {
                // переносимый блот хочет вставить другой блот
                // вместо себя(может быть в случае если данный блот не может быть дочерним от данного контейнера)
                insertId = beforeMoveRes.id;
              }
              if (beforeMoveRes.removeBlot) {
                // переносимый блот хочет удалить вместо себя указанный блот
                removeBlot = beforeMoveRes.removeBlot;
                removeId = removeBlot.id;
              }
            }
          }
          var currentIndex = _this2.getChildIndex(removeId);
          if (currentIndex >= 0) {
            _this2.containerChildren.delete(currentIndex);
            if (index > currentIndex) {
              // корректировка нового индекса с учетом удаления данного элемента с текущей позиции
              index--;
            }
          } else {
            // need to remove the child from its previous container
            var prevContainer = removeBlot.container;
            // проверка на наличие контейнера, т.к. блот может быть детаченым и не иметь контейнера
            if (prevContainer) {
              prevContainer.removeChildById(removeId, true);
            }
            if (!store.getMap(blot.map.get('id'))) {
              store.copyBlotMap(blot.map, sourceStore);
            }
          }
          if (insertId) {
            index = Math.min(index, _this2.containerChildren.length);
            _this2.containerChildren.insert(index, [insertId]);
          } else {}
          //console.groupEnd()
        });
        // TODO fix this, it's excessive because update listener should be called(not called by some reason)
        this.render();
        if (blot.afterMove) {
          var beforeMoveRes = blot.afterMove(this, {
            index: index
          }, context);
        }
        return insertId;
      }
    }, {
      key: "addBlot",
      value: function addBlot(type) {
        var _this3 = this;
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var limitManager = this.editor.plugins.limitManager;
        var Blot = src_parchment.query(type);
        if (!Blot) {
          console.error("Couldn't find blot type", type);
        }
        if (Blot.verify) {
          Blot.verify(params);
        }
        if (limitManager && !limitManager.canAddBlot({
          type: type,
          alert: true
        })) {
          return false;
        }
        var store = this.getChildrenStore();
        var id;
        store.transaction(function () {
          var map = store.createMapForBlot(Blot, params);
          var index = params.hasOwnProperty('index') ? params.index : -1;
          if (params.after) {
            var childIndex = _this3.getChildIndex(params.after);
            if (childIndex >= 0) {
              index = childIndex + 1;
            }
          }
          if (params.before) {
            var _childIndex2 = _this3.getChildIndex(params.before);
            if (_childIndex2 >= 0) {
              index = _childIndex2;
            }
          }
          if (params.focus) {
            _this3._onceRendered({
              id: map.get('id'),
              focus: params.focus
            });
          }
          if (index >= 0) {
            _this3.containerChildren.insert(index, [map.get('id')]);
          } else {
            _this3.containerChildren.push([map.get('id')]);
          }
          id = map.get('id');
        });
        return {
          id: id
        };
      }
    }, {
      key: "onChildDetached",
      value:
      // вызывается когда дочерний блот отсоединяется
      function onChildDetached(blot) {
        if (this.editor.destroyed) {
          // редактор деинициализирован, игнорируем этот вызов, т.к. он является следствием детача каждого блота при
          // деинициализации редактора
          return;
        }
        // если блот является контейнером, нужно проверить не находится ли он внутри сворачиваемого (скрываемого) контейнера,
        // если сам сворачиваемого контейнер удален из редактора, то удалять дочерние блоты из такого контейнера не нужно
        var collapsibleContainer = searchUp(blot, function (blot) {
          return blot.isCollapsibleContainer;
        });
        if (collapsibleContainer) {
          if (!this.editor.findById(collapsibleContainer.id)) {
            return;
          }
        }
        var removedByContainerBlot = searchUp(blot, function (blot) {
          return blot._removedByContainer;
        });
        if (removedByContainerBlot) {
          // блот удален каким-либо контейнером, пропускаем
          return;
        }
        if (!blot.id) {
          return;
        }
        // блот был удален из дерева документа, необходимо проверить есть ли данный блот в children и удалить если есть
        this.removeChildById(blot.id);
      }
    }, {
      key: "getChildrenMap",
      value: function getChildrenMap() {
        var map = new Map();
        var currentChild = this.children.head;
        while (currentChild) {
          map.set(currentChild.id, currentChild);
          currentChild = currentChild.next;
        }
        return map;
      }
    }, {
      key: "getBlotById",
      value: function getBlotById(id) {
        var currentChild = this.children.head;
        while (currentChild) {
          if (currentChild.id === id) {
            return currentChild;
          }
          currentChild = currentChild.next;
        }
        return null;
      }
    }, {
      key: "getChildBlotsForExec",
      value: function getChildBlotsForExec() {
        var blots = [];
        this.children.forEach(function (child) {
          if (child.exec) {
            blots.push(child);
          }
        });
        return blots;
      }
    }, {
      key: "containerConvertBlots",
      value: function containerConvertBlots(blots, params) {
        var _this4 = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var limitManager = this.editor.plugins.limitManager;
        var processed = false;
        var ToBlot = src_parchment.query(params.type);
        var ids = blots.map(function (blot) {
          return blot.id;
        });
        var _iterator6 = container_createForOfIteratorHelper(blots),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var blot = _step6.value;
            blot.onConvertBlot && blot.onConvertBlot();
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
        var addedIds = [];
        this.selection.pushRange();
        var allowPopRange = true;
        if (options.batch) {
          this.scroll.batchStart();
        }
        var store = this.getChildrenStore();
        try {
          limitManager && limitManager.freeze();
          store.transaction(function () {
            var defaultConvert = true;
            if (ToBlot.convertBlots) {
              defaultConvert = false;
              var convertResult = ToBlot.convertBlots(ids, store, {
                params: params,
                container: _this4
              });
              // если convertBlots возвращает default, то обрабатываем конверт дефолтным способом ниже
              if (convertResult === 'default') {
                defaultConvert = true;
              } else if (convertResult === true) {
                if (!blots.every(function (blot) {
                  return blot instanceof textLine;
                }) || !textLine.isPrototypeOf(ToBlot)) {
                  allowPopRange = false;
                }
                processed = true;
              } else if (convertResult) {
                var insertIndex = convertResult.removeBlots.length !== 0 ? _this4.getChildIndex(ids[0]) : _this4.getChildIndex(ids[ids.length - 1]) + 1;
                var _iterator7 = container_createForOfIteratorHelper(convertResult.removeBlots),
                  _step7;
                try {
                  for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                    var id = _step7.value;
                    var blot = _this4.editor.findById(id);
                    blot.container.removeChildById(id);
                  }
                  //в будущем нужна дополнительная проверка может ли контейнтер вставить в себя блоки из массива convertResult.insertBlots,
                  //например List не может вставить в себя ничего кроме ListItem..., если этого не сделать то в store контейнера
                  //добавится id не поддерживаемого контейнером блока и редактор выдаст ошибку, а после обновления страницы не загрузится до конца
                } catch (err) {
                  _iterator7.e(err);
                } finally {
                  _iterator7.f();
                }
                var _iterator8 = container_createForOfIteratorHelper(convertResult.insertBlots),
                  _step8;
                try {
                  for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                    var _id2 = _step8.value;
                    if (!_id2) {
                      console.error('empty id element', _id2, 'was passed into convert result -> insertBlots', convertResult);
                      continue;
                    }
                    _this4.containerChildren.insert(insertIndex++, [_id2]);
                    addedIds.push(_id2);
                  }
                } catch (err) {
                  _iterator8.e(err);
                } finally {
                  _iterator8.f();
                }
                if (convertResult.focus) {
                  allowPopRange = false;
                  _this4._onceRendered(convertResult.focus);
                }
                processed = true;
              }
            }
            if (defaultConvert) {
              if (blots.length === 1) {
                var _blot = blots[0];
                store.transaction(function () {
                  var insertParams = Object.assign({}, params);
                  insertParams.indent = _blot.map.get('indent');
                  if (_blot.isEmpty && _blot.isEmpty() || insertParams.replaceBlotId) {
                    var replaceBlotId = insertParams.replaceBlotId ? insertParams.replaceBlotId : _blot.id;
                    var index = _this4.getChildIndex(replaceBlotId);
                    insertParams.index = index;
                    _this4.removeChildById(replaceBlotId);
                  } else {
                    insertParams.after = _blot.id;
                  }
                  commentable(Object).setCommentThreads(_blot, insertParams);
                  var _this4$addBlot = _this4.addBlot(params.type, insertParams),
                    addedId = _this4$addBlot.id;
                  addedIds.push(addedId);
                  if (insertParams.focus) {
                    allowPopRange = false;
                    _this4._onceRendered(insertParams.focus);
                  }
                });
                processed = true;
              }
            }
          });
        } catch (ex) {
          throw ex;
        } finally {
          if (options.batch) {
            this.scroll.batchEnd();
          }
          limitManager && limitManager.unfreeze();
        }
        if (allowPopRange) {
          this.selection.popRange();
        }
        return {
          processed: processed,
          addedIds: addedIds
        };
      }
    }, {
      key: "exec",
      value: function exec(action) {
        var selectedBlots = action.selectedBlots;
        var params = action.params;
        var processed = container_get(container_getPrototypeOf(_class2.prototype), "exec", this) ? container_get(container_getPrototypeOf(_class2.prototype), "exec", this).call(this, action) : false;
        if (action.type === 'insert-block') {
          this.addBlot(params.type, params);
          processed = true;
        } else if (action.type === 'convert-blot') {
          selectedBlots = selectedBlots.filter(function (blot) {
            return !blot.isBlotLocked && !blot.isSelectableBlotChild;
          });
          var res = this.containerConvertBlots(selectedBlots, params, {
            batch: params.batch
          });
          processed = res.processed;
          if (processed) {
            action.addResult({
              addedIds: res.addedIds
            });
          }
        }
        return processed;
      }
    }, {
      key: "renderFast",
      value: function renderFast() {
        if (!this.containerChildren || this.containerChildren.length === this.children.length) {
          return;
        }
        var _iterator9 = container_createForOfIteratorHelper(this.containerChildren),
          _step9;
        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var childId = _step9.value;
            var childMap = this.store.getMap(childId);
            var Blot = src_parchment.query(childMap.get('type'));
            var type = childMap.get('type');
            var blot = Blot.createBlot ? Blot.createBlot(this.editor) : src_parchment.create(type);
            blot.map = childMap;
            blot.scroll = this.scroll;
            this.insertBefore(blot);
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }
      }
    }, {
      key: "subDoc",
      get: function get() {
        var blot = searchUp(this, function (blot) {
          if (!blot.map) {
            return false;
          }
          return blot.map.has('subDoc');
        });
        if (!blot) {
          return false;
        }
        return this.rootStore.subDocs.get(blot.map.get('subDoc'));
      }
    }, {
      key: "render",
      value: function render() {
        var _this5 = this;
        if (!this.editor.options.render) {
          return;
        }
        if (container_get(container_getPrototypeOf(_class2.prototype), "render", this)) {
          container_get(container_getPrototypeOf(_class2.prototype), "render", this).call(this);
        }
        var store = this.getChildrenStore(0);
        if (this.map.has('subDoc')) {
          var subDoc = this.subDoc;
          if (!subDoc.shouldLoad) {
            subDoc.load();
          }
          if (!subDoc.loaded) {
            if (!this.children.head) {
              var loader = src_parchment.create('loader');
              this.insertBefore(loader, this.children.head);
              subDoc.on('loaded', function () {
                if (_this5.onSubDocLoaded) {
                  _this5.onSubDocLoaded();
                }
                _this5.render();
              });
            }
            return;
          }
        }
        if (this.dontRenderChilden) return;

        // containerFixedChildren - указывает что список дочерних блотов фиксированный и не изменяется
        if (this.containerFixedChildren) {
          return this.renderFast();
        }

        //console.groupCollapsed('Rendering: ', this.constructor.blotName)
        // make sure that list of child elements is the same as in the underlying map
        var children = this.containerChildren ? this.containerChildren.toArray() : [];
        var currentChildrenById = this.getChildrenMap();
        // delete children that exist as blots but aren't presented in the children array
        var childrenIdsSet = new Set();
        var _iterator10 = container_createForOfIteratorHelper(children),
          _step10;
        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var id = _step10.value;
            childrenIdsSet.add(id);
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
        var currentChild = this.children.head;
        while (currentChild) {
          if (!childrenIdsSet.has(currentChild.id)) {
            currentChild._removedByContainer = true;
            currentChild.remove();
          }
          currentChild = currentChild.next;
        }
        for (var i = 0; i != children.length; i++) {
          var prevChildId = i > 0 ? children[i - 1] : null;
          var childId = children[i];
          var childBlot = currentChildrenById.get(childId);
          if (!childBlot) {
            // need to add the blot
            var childMap = store.getMap(childId);
            if (!childMap) {
              console.warn('childMap is ', childMap, ' for ', childId, this.subDoc && this.subDoc.guid, 'self-heal by removing the item');
              console.info(this);
              console.trace();
              this.containerChildren.delete(i);
              // abort render, because rendering will be(or have all ready been) triggered by the children array change
              break;
            }
            var blotType = childMap.get('type');
            // Если в мапе не указан тип блота то пропускаем его
            if (blotType === undefined) {
              var jsonStr = JSON.stringify((childMap === null || childMap === void 0 ? void 0 : childMap.toJSON()) || '{}');
              this.editor.plugins.debugLogger.captureException("type for blot ".concat(childMap === null || childMap === void 0 ? void 0 : childMap.get('id'), " not found. ").concat(jsonStr));
              this.containerChildren.delete(i);
              // останавливаем реднер так как удаление потомка из массива вызовет перерендер
              break;
            }
            var Blot = src_parchment.query(blotType);
            if (!Blot) {
              return this.editor.emit(EVENT_BLOT_NOT_SUPPORTED, {
                type: blotType
              });
            }
            var blot = Blot.createBlot ? Blot.createBlot(this.editor) : src_parchment.create(blotType);
            blot.map = childMap;
            blot.scroll = this.scroll;
            try {
              if (prevChildId === null) {
                this.insertBefore(blot, this.children.head);
              } else {
                var prevBlot = prevChildId && currentChildrenById.get(prevChildId);
                this.insertBefore(blot, prevBlot && prevBlot.next);
              }
              // блот успешно добавлен
              currentChildrenById.set(childId, blot);
            } catch (err) {
              if (typeof err.message === 'string' && err.message.indexOf('[Parchment]') === 0) {
                // получили ошибку от parchment при добавлении блота
                // необходимо удалить этот блот и прекратить текущий процесс рендера
                console.warn('Got error from Parchment', err.message, 'blot', blot, 'will be removed from the container', this);
                //console.groupEnd()
                this.removeChildById(childId);
                return;
              } else {
                throw err;
              }
            }
          } else {
            var currentPrevChildId = childBlot.prev ? childBlot.prev.id : null;
            if (currentPrevChildId !== prevChildId) {
              // reposition blot
              if (prevChildId === null) {
                this.insertBefore(childBlot, this.children.head);
              } else {
                var _prevBlot = prevChildId && currentChildrenById.get(prevChildId);
                var insertBefore = _prevBlot && _prevBlot.next;
                if (childBlot !== insertBefore) {
                  this.insertBefore(childBlot, insertBefore);
                }
              }
            }
          }
        }
        var _iterator11 = container_createForOfIteratorHelper(this._onceRenderedActions),
          _step11;
        try {
          for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
            var action = _step11.value;
            if (action.focus) {
              var _blot2 = this.getBlotById(action.id);
              if (!_blot2) continue;
              // сейчас можем поставить фокус только на текстовом блоте
              if (!_blot2.isText && !_blot2.isEmbeddable) {
                // пытаемся найти текстовый блот в дочерних элементах
                var child = _blot2.children.head;
                while (child) {
                  if (child.isText) {
                    _blot2 = child;
                    break;
                  }
                  child = child.next;
                }
              } else if (_blot2.isEmbeddable) {
                _blot2.embeddableFocus();
                continue;
              }
              var blotOffset = _blot2.offset(this.scroll);
              var range = {
                index: blotOffset + action.focus.index,
                length: action.focus.length || 0
              };
              this.scroll.selection.setRange(range);
              if (this.editor.options.scrollOnNewBlotFocus) {
                this.editor.plugins.selectionScroller.ensureSelectionVisible();
              }
              //this.scroll.selection.setNativeRange(blot.children.head.domNode, action.focus.index)
            }
          }
        } catch (err) {
          _iterator11.e(err);
        } finally {
          _iterator11.f();
        }
        this._onceRenderedActions = [];

        //console.groupEnd()
      }
    }], [{
      key: "initMap",
      value: function initMap(map, store, params) {
        if (container_get(container_getPrototypeOf(_class2), "initMap", this)) {
          container_get(container_getPrototypeOf(_class2), "initMap", this).call(this, map, store, params);
        }
        Container.initMap(map, store, params);
      }
    }]);
    return _class2;
  }(superclass);
};
Container.initMap = function (map, store) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (map.has('subDoc')) {} else {
    if (!map.has('children')) {
      var children = new store.types.Array();
      if (Array.isArray(params.children)) {
        children.push(params.children);
      }
      map.set('children', children);
    }
  }
};
Container.canExecActions = ['insert-block', 'convert-blot'];
/* harmony default export */ const container = (Container);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/mixins/props.js
function props_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { props_typeof = function _typeof(obj) { return typeof obj; }; } else { props_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return props_typeof(obj); }











function props_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function props_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function props_createClass(Constructor, protoProps, staticProps) { if (protoProps) props_defineProperties(Constructor.prototype, protoProps); if (staticProps) props_defineProperties(Constructor, staticProps); return Constructor; }
function props_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) props_setPrototypeOf(subClass, superClass); }
function props_setPrototypeOf(o, p) { props_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return props_setPrototypeOf(o, p); }
function props_createSuper(Derived) { var hasNativeReflectConstruct = props_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = props_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = props_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return props_possibleConstructorReturn(this, result); }; }
function props_possibleConstructorReturn(self, call) { if (call && (props_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return props_assertThisInitialized(self); }
function props_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function props_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function props_getPrototypeOf(o) { props_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return props_getPrototypeOf(o); }
var Props = function Props(superclass) {
  return /*#__PURE__*/function (_superclass) {
    props_inherits(_class, _superclass);
    var _super = props_createSuper(_class);
    function _class() {
      var _this;
      props_classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _this.props = {};
      return _this;
    }
    props_createClass(_class, [{
      key: "setProps",
      value: function setProps(_setProps) {
        var propsChanged = false;
        var newProps = Object.assign({}, this.props);
        for (var k in _setProps) {
          if (_setProps[k] !== this.props[k]) {
            newProps[k] = _setProps[k];
            propsChanged = true;
          }
        }
        if (propsChanged) {
          if (this.blotWillReceiveProps) {
            this.blotWillReceiveProps(newProps);
          }
          this.props = newProps;
          this.render();
        }
      }
    }]);
    return _class;
  }(superclass);
};
/* harmony default export */ const props = (Props);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/mixins/basic.js
function basic_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { basic_typeof = function _typeof(obj) { return typeof obj; }; } else { basic_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return basic_typeof(obj); }
















function basic_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function basic_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function basic_createClass(Constructor, protoProps, staticProps) { if (protoProps) basic_defineProperties(Constructor.prototype, protoProps); if (staticProps) basic_defineProperties(Constructor, staticProps); return Constructor; }
function basic_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { basic_get = Reflect.get; } else { basic_get = function _get(target, property, receiver) { var base = basic_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return basic_get(target, property, receiver || target); }
function basic_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = basic_getPrototypeOf(object); if (object === null) break; } return object; }
function basic_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) basic_setPrototypeOf(subClass, superClass); }
function basic_setPrototypeOf(o, p) { basic_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return basic_setPrototypeOf(o, p); }
function basic_createSuper(Derived) { var hasNativeReflectConstruct = basic_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = basic_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = basic_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return basic_possibleConstructorReturn(this, result); }; }
function basic_possibleConstructorReturn(self, call) { if (call && (basic_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return basic_assertThisInitialized(self); }
function basic_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function basic_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function basic_getPrototypeOf(o) { basic_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return basic_getPrototypeOf(o); }




var Basic = function Basic(superclass) {
  return /*#__PURE__*/function (_PropsMixin) {
    basic_inherits(_class, _PropsMixin);
    var _super = basic_createSuper(_class);
    function _class() {
      var _this;
      basic_classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _this.props = {};
      _this.batchDepth = 0;
      _this.hasBeenAttached = false;
      return _this;
    }
    basic_createClass(_class, [{
      key: "attach",
      value: function attach() {
        var _get2;
        var attached = this.hasBeenAttached;
        this.hasBeenAttached = true;
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        (_get2 = basic_get(basic_getPrototypeOf(_class.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
        var id = this.id;
        if (!attached) {
          // загружаем персистентные свойства блота
          if (this.editor.persistedBlotsProps[id]) {
            var props = this.editor.persistedBlotsProps[id];
            Object.assign(this.props, props);
          }
          if (this.onFirstAttach) {
            this.onFirstAttach();
          }
        }
        if (id) {
          var domID = id;
          if (this.editor.options.idPrefix) {
            domID = this.editor.options.idPrefix + domID;
          }
          this.setDomNodeAttribute('id', domID);
        }
      }
    }, {
      key: "detach",
      value: function detach() {
        var _get3;
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }
        (_get3 = basic_get(basic_getPrototypeOf(_class.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
        this.hasBeenAttached = false;
        if (this.container) {
          // если родительский блот является контейнером уведомляем его что дочерний блот отсоединился
          this.container.onChildDetached(this);
        }
      }
    }, {
      key: "clone",
      value: function clone() {
        var blotType = this.constructor.blotName;
        return src_parchment.create(blotType);
      }
    }, {
      key: "cloneSelf",
      value: function cloneSelf() {
        if (this.keepSuperCloneSelf && basic_get(basic_getPrototypeOf(_class.prototype), "cloneSelf", this)) {
          return basic_get(basic_getPrototypeOf(_class.prototype), "cloneSelf", this).call(this);
        }
      }
    }, {
      key: "setDomNodeAttribute",
      value: function setDomNodeAttribute(key, value) {
        this.domNode.setAttribute(key, value);
      }
      /**
       * если блот имеет враппер то он должен переопределить этот метод и вернуть блот враппера
       * иначе этот метод просто возращает текущий блот
       * @return {Blot} враппер если есть, иначе текущий блот
       */
    }, {
      key: "getWrapper",
      value: function getWrapper() {
        return this;
      }
      /**
       * если блот является враппером то он должен переопределить этот метод и вернуть оборачиваемый блот(который описывается с
       * помощью Map)
       * иначе этот метод просто возращает текущий блот
       * @return {Blot} оборачеваемый блот если текущий блот это враппер, иначе текущий блот
       */
    }, {
      key: "getWrappedBlot",
      value: function getWrappedBlot() {
        return this;
      }

      // возвращает блот-контейнер для текущего блота
    }, {
      key: "container",
      get: function get() {
        var blot = this.parent;
        while (blot) {
          if (blot.isContainer) {
            return blot;
          }
          blot = blot.parent;
        }
        return null;
      }
    }, {
      key: "blotConfig",
      get: function get() {
        var lists = ['listItemNumber', 'listItemCheckbox', 'listItemBullet'];
        var config;
        var type = this.constructor.blotName;
        //console.log('type', type)
        if (lists.indexOf(type) !== -1 && this.editor.blotsConfig && this.editor.blotsConfig.list) {
          config = this.editor.blotsConfig.list[type];
        } else {
          config = this.editor.blotsConfig[type];
        }
        return config || {};
      }
    }, {
      key: "selection",
      get: function get() {
        return this.scroll.selection;
      }
    }, {
      key: "parent_id",
      get: function get() {
        if (!this.parent) {
          // если у блота нет родителя значит он еще не приаттачен
          return null;
        }
        return this.parent.id;
      }
    }, {
      key: "id",
      get: function get() {
        return this.map.get('id');
      }
    }, {
      key: "store",
      get: function get() {
        // получает store из ближайшего контейнера
        var closestContainer = searchUp(this, function (blot) {
          return blot.isContainer;
        });
        if (!closestContainer) {
          // такое может быть когда блот детачен, например при d&d файла в редактор
          return this.rootStore;
        }
        return closestContainer.getChildrenStore();
      }
    }, {
      key: "rootStore",
      get: function get() {
        return this.editor.store;
      }
    }, {
      key: "parentStore",
      get: function get() {
        var parent = searchUp(this.parent, function (blot) {
          return blot.isContainer;
        });
        if (!parent) {
          return this.rootStore;
        }
        return parent.store;
      }
    }, {
      key: "editor",
      get: function get() {
        return this.scroll.editor;
      }
    }, {
      key: "index",
      get: function get() {
        // find the first container in the ancestors
        var container = this.parent;
        while (container) {
          if (container.isContainer) {
            break;
          }
          container = container.parent;
        }
        if (!container) {
          return -1;
        }
        return container.getChildIndex(this.id);
      }
    }, {
      key: "contextMenu",
      get: function get() {
        var i18n = this.editor.plugins.i18n;
        var menu = {
          add: {
            label: i18n.get('block_menu.add.name'),
            index: -20,
            group: 0,
            action: false,
            submenu: {
              above: {
                label: i18n.get('block_menu.add.above'),
                index: 0,
                group: 0,
                action: 'add-paragraph',
                actionParams: {
                  position: 'above'
                },
                actionExec: true,
                stackable: false
              },
              below: {
                label: i18n.get('block_menu.add.below'),
                index: 1,
                group: 0,
                action: 'add-paragraph',
                actionParams: {
                  position: 'below'
                },
                actionExec: true,
                stackable: false
              },
              left: {
                label: i18n.get('block_menu.add.left'),
                index: 0,
                group: 1,
                action: 'add-grid',
                actionParams: {
                  position: 'left'
                },
                actionExec: true,
                stackable: false
              },
              right: {
                label: i18n.get('block_menu.add.right'),
                index: 1,
                group: 1,
                action: 'add-grid',
                actionParams: {
                  position: 'right'
                },
                actionExec: true,
                stackable: false
              }
            },
            stackable: false
          },
          duplicate: {
            label: i18n.get('block_menu.duplicate'),
            index: 1,
            group: 0,
            action: 'duplicate-blots',
            actionExec: true,
            stackable: true
          },
          copyBlocks: {
            label: i18n.get('block_menu.' + (this.scroll.selectedBlocks.length > 1 ? 'copy_blocks' : 'copy_block')),
            index: 2,
            group: 0,
            action: 'copy-blocks',
            actionExec: true,
            stackable: true
          },
          copyLink: {
            label: i18n.get('block_menu.copy_link'),
            index: 3,
            group: 0,
            action: 'copyLink',
            stackable: false
          },
          delete: {
            label: i18n.get('block_menu.delete'),
            index: 4,
            group: 0,
            action: 'deleteSingeBlot',
            stackable: true
          }
        };
        var disableSideDrop = searchUp(this, function (blot) {
          return blot.disallowInsideSideDrop;
        });
        if (disableSideDrop) {
          delete menu.add.submenu.left;
          delete menu.add.submenu.right;
        }
        if (searchUp(this, function (blot) {
          return blot.constructor.blotName === 'gridCol';
        })) {
          menu.add.submenu.aboveColumn = {
            label: i18n.get('block_menu.add.above_column'),
            index: 0,
            group: 2,
            action: 'addParagraphAboveColumn',
            stackable: false
          };
          menu.add.submenu.belowColumn = {
            label: i18n.get('block_menu.add.below_column'),
            index: 1,
            group: 2,
            action: 'addParagraphBelowColumn',
            stackable: false
          };
        }
        return menu;
      }
    }, {
      key: "setProps",
      value: function setProps(_setProps) {
        var persist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var propsChanged = false;
        var newProps = Object.assign({}, this.props);
        var oldProps = Object.assign({}, this.props);
        for (var k in _setProps) {
          if (_setProps[k] !== this.props[k]) {
            newProps[k] = _setProps[k];
            propsChanged = true;
          }
        }
        if (propsChanged && this.hasBeenAttached) {
          if (this.blotWillReceiveProps) {
            this.blotWillReceiveProps(newProps);
          }
          this.props = newProps;
          if (!this.isInBatch()) {
            this.render();
            if (this.blotDidUpdate) {
              this.blotDidUpdate(oldProps);
            }
          }
        }
        if (persist) {
          var id = this.id;
          if (id) {
            if (!this.editor.persistedBlotsProps[id]) {
              this.editor.persistedBlotsProps[id] = {};
            }
            var persistedProps = this.editor.persistedBlotsProps[id];
            Object.assign(persistedProps, _setProps);
          }
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;
        if (basic_get(basic_getPrototypeOf(_class.prototype), "render", this)) {
          var _get4;
          for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
          }
          (_get4 = basic_get(basic_getPrototypeOf(_class.prototype), "render", this)).call.apply(_get4, [this].concat(args));
        }
        if (this.descendants && typeof this.descendants === 'function') {
          this.descendants(function (blot) {
            return blot.onParentRenderUpdate;
          }).forEach(function (blot) {
            blot.onParentRenderUpdate(_this2);
          });
        }
      }
    }, {
      key: "isBlotAttached",
      value: function isBlotAttached() {
        return src_parchment.find(this.domNode);
      }
    }, {
      key: "deleteSingeBlot",
      value: function deleteSingeBlot() {
        var next = this.getWrapper().next;
        if (!this.isBlotLocked) {
          // если удаляем блок через меню, то делаем это при помощи store
          this.container.removeChildById(this.id);
        }
        if (next) {
          this.scroll.selection.setRange({
            index: next.offset(this.scroll),
            length: 0
          });
        }
      }
    }, {
      key: "addParagraphAboveColumn",
      value: function addParagraphAboveColumn() {
        var grid = searchUp(this, function (blot) {
          return blot.constructor.blotName === 'grid';
        });
        if (grid) {
          this.scroll.addBlot('paragraph', {
            focus: {
              index: 0
            },
            before: grid.id
          });
        }
        this.editor.plugins.selectionScroller.ensureSelectionVisible();
      }
    }, {
      key: "addParagraphBelowColumn",
      value: function addParagraphBelowColumn() {
        var grid = searchUp(this, function (blot) {
          return blot.constructor.blotName === 'grid';
        });
        if (grid) {
          this.scroll.addBlot('paragraph', {
            focus: {
              index: 0
            },
            after: grid.id
          });
        }
        this.editor.plugins.selectionScroller.ensureSelectionVisible();
      }
    }, {
      key: "isInBatch",
      value: function isInBatch() {
        return this.batchDepth > 0;
      }
    }, {
      key: "batchPropsUpdate",
      value: function batchPropsUpdate(fn) {
        var propsBefore = Object.assign({}, this.props);
        this.batchDepth++;
        var err;
        try {
          fn();
        } catch (e) {
          err = e;
        }
        this.batchDepth--;
        if (err) {
          throw err;
        }
        if (this.batchDepth === 0) {
          this.render();
          if (this.blotDidUpdate) {
            this.blotDidUpdate(propsBefore);
          }
        }
      }
    }, {
      key: "getBlotName",
      value: function getBlotName() {
        return this.constructor.blotName;
      }
    }, {
      key: "copyLink",
      value: function copyLink() {
        var _this$editor$plugins = this.editor.plugins,
          copyManager = _this$editor$plugins.copyManager,
          notificationManager = _this$editor$plugins.notificationManager,
          i18n = _this$editor$plugins.i18n;
        var baseUrl = this.editor.options.baseUrl || String(window.location.origin + window.location.pathname);
        var link = String(baseUrl + '#' + this.id);
        copyManager.copy(link);
      }
    }, {
      key: "getBlotInsertParams",
      value: function getBlotInsertParams(blotRange, contextHelper) {
        var params = basic_get(basic_getPrototypeOf(_class.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
        if (contextHelper) {
          contextHelper.processBlot(this, params);
        }
        return params;
      }
    }, {
      key: "remove",
      value: function remove() {
        var _get5;
        if (!this.isBlotAttached()) return;
        for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          args[_key5] = arguments[_key5];
        }
        (_get5 = basic_get(basic_getPrototypeOf(_class.prototype), "remove", this)).call.apply(_get5, [this].concat(args));
      }
    }]);
    return _class;
  }(props(superclass));
};
/* harmony default export */ const basic = (Basic);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/mixins/dropAcceptor.js
function dropAcceptor_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { dropAcceptor_typeof = function _typeof(obj) { return typeof obj; }; } else { dropAcceptor_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return dropAcceptor_typeof(obj); }
function dropAcceptor_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = dropAcceptor_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function dropAcceptor_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return dropAcceptor_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return dropAcceptor_arrayLikeToArray(o, minLen); }
function dropAcceptor_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function dropAcceptor_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function dropAcceptor_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function dropAcceptor_createClass(Constructor, protoProps, staticProps) { if (protoProps) dropAcceptor_defineProperties(Constructor.prototype, protoProps); if (staticProps) dropAcceptor_defineProperties(Constructor, staticProps); return Constructor; }
function dropAcceptor_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { dropAcceptor_get = Reflect.get; } else { dropAcceptor_get = function _get(target, property, receiver) { var base = dropAcceptor_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return dropAcceptor_get(target, property, receiver || target); }
function dropAcceptor_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = dropAcceptor_getPrototypeOf(object); if (object === null) break; } return object; }
function dropAcceptor_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) dropAcceptor_setPrototypeOf(subClass, superClass); }
function dropAcceptor_setPrototypeOf(o, p) { dropAcceptor_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return dropAcceptor_setPrototypeOf(o, p); }
function dropAcceptor_createSuper(Derived) { var hasNativeReflectConstruct = dropAcceptor_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = dropAcceptor_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = dropAcceptor_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return dropAcceptor_possibleConstructorReturn(this, result); }; }
function dropAcceptor_possibleConstructorReturn(self, call) { if (call && (dropAcceptor_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return dropAcceptor_assertThisInitialized(self); }
function dropAcceptor_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function dropAcceptor_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function dropAcceptor_getPrototypeOf(o) { dropAcceptor_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return dropAcceptor_getPrototypeOf(o); }
function dropAcceptor_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


















var DND_HOVER_CLASSES = {
  left: 'hover-left',
  top: 'hover-top',
  right: 'hover-right',
  bottom: 'hover-bottom'
};
var DND_HOVER_CLASSES_ARRAY = Object.keys(DND_HOVER_CLASSES).map(function (key) {
  return DND_HOVER_CLASSES[key];
});
var DND_HOVER_CLASS = 'hover-block';
var DropAcceptor = function DropAcceptor(superclass) {
  return /*#__PURE__*/function (_superclass) {
    dropAcceptor_inherits(_class2, _superclass);
    var _super = dropAcceptor_createSuper(_class2);
    function _class2() {
      var _this;
      dropAcceptor_classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      dropAcceptor_defineProperty(dropAcceptor_assertThisInitialized(_this), "onItemDragging", function (event) {
        if (event._dropAcceptorHandled) {
          return;
        }
        if (!_this.scroll) {
          console.error('no scroll for blot:', dropAcceptor_assertThisInitialized(_this));
        }
        if (_this.scroll.selectedBlocks.indexOf(dropAcceptor_assertThisInitialized(_this)) != -1) return;
        var rect = _this.domNode.getBoundingClientRect();
        var xInElem = rect.x < event.x && rect.x + rect.width > event.x;
        var yInElem = rect.y < event.y && rect.y + rect.height > event.y;
        var cond = yInElem;
        if (_this.dropAcceptorIsBlotInGrid(dropAcceptor_assertThisInitialized(_this)) || _this.disallowSideDrop) {
          // если текущий блот находится в гриде, то не разрешаем перенос слева и справа от него
          cond = cond && xInElem;
        }
        if (cond) {
          _this._removeDraggingStyles(dropAcceptor_assertThisInitialized(_this));
          if (!_this.domNode.classList.contains('hover-block')) {
            _this.domNode.classList.add('hover-block');
          }
          event._dropAcceptorHandled = true;
          if (rect.x < event.x && rect.x + rect.width > event.x) {
            if (rect.y < event.y && rect.y + rect.height / 2 > event.y) {
              if (!_this.domNode.classList.contains('hover-top')) {
                _this.domNode.classList.add('hover-top');
              }
            }
            if (rect.y + rect.height / 2 < event.y && rect.y + rect.height > event.y) {
              if (!_this.domNode.classList.contains('hover-bottom')) {
                _this.domNode.classList.add('hover-bottom');
              }
            }
          } else {
            if (rect.x > event.x) {
              if (!_this.domNode.classList.contains('hover-left')) {
                _this.domNode.classList.add('hover-left');
              }
            }
            if (rect.x + rect.width < event.x) {
              if (!_this.domNode.classList.contains('hover-right')) {
                _this.domNode.classList.add('hover-right');
              }
            }
          }
        }
      });
      return _this;
    }
    dropAcceptor_createClass(_class2, [{
      key: "attach",
      value: function attach() {
        var _get2;
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        (_get2 = dropAcceptor_get(dropAcceptor_getPrototypeOf(_class2.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
        this.scroll.emitter.on('dragging', this.onItemDragging);
      }
    }, {
      key: "isDropAcceptor",
      get: function get() {
        return true;
      }
    }, {
      key: "dropAcceptorIsBlotInGrid",
      value: function dropAcceptorIsBlotInGrid(blot) {
        while (blot) {
          if (blot.constructor.blotName === 'gridCol') {
            return true;
          }
          blot = blot.parent;
        }
        return false;
      }
    }, {
      key: "render",
      value: function render() {
        if (dropAcceptor_get(dropAcceptor_getPrototypeOf(_class2.prototype), "render", this)) {
          dropAcceptor_get(dropAcceptor_getPrototypeOf(_class2.prototype), "render", this).call(this);
        }
        if (this.props.dragAndDropHover) {
          this.domNode.classList.add(DND_HOVER_CLASS);
          var className = DND_HOVER_CLASSES[this.props.dragAndDropHover];
          this.domNode.classList.add(className);
        } else {
          this.domNode.classList.remove(DND_HOVER_CLASS);
          var _iterator = dropAcceptor_createForOfIteratorHelper(DND_HOVER_CLASSES_ARRAY),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var cl = _step.value;
              this.domNode.classList.remove(cl);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }
    }]);
    return _class2;
  }(superclass);
};
/* harmony default export */ const dropAcceptor = (DropAcceptor);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/mixins/executable.js
function executable_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { executable_typeof = function _typeof(obj) { return typeof obj; }; } else { executable_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return executable_typeof(obj); }












function executable_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function executable_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function executable_createClass(Constructor, protoProps, staticProps) { if (protoProps) executable_defineProperties(Constructor.prototype, protoProps); if (staticProps) executable_defineProperties(Constructor, staticProps); return Constructor; }
function executable_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) executable_setPrototypeOf(subClass, superClass); }
function executable_setPrototypeOf(o, p) { executable_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return executable_setPrototypeOf(o, p); }
function executable_createSuper(Derived) { var hasNativeReflectConstruct = executable_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = executable_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = executable_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return executable_possibleConstructorReturn(this, result); }; }
function executable_possibleConstructorReturn(self, call) { if (call && (executable_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return executable_assertThisInitialized(self); }
function executable_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function executable_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function executable_getPrototypeOf(o) { executable_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return executable_getPrototypeOf(o); }
/**
 * миксин применные на блот означает что блот может выполнять действия через exec
 */

var Executable = function Executable(superclass) {
  return /*#__PURE__*/function (_superclass) {
    executable_inherits(_class, _superclass);
    var _super = executable_createSuper(_class);
    function _class() {
      var _this;
      executable_classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _this.canExecActions = new Set();
      return _this;
    }
    executable_createClass(_class, [{
      key: "addCanExecActions",
      value: function addCanExecActions(actionsTypes) {
        var _this2 = this;
        actionsTypes.forEach(function (actionType) {
          return _this2.canExecActions.add(actionType);
        });
      }
    }, {
      key: "canExec",
      value: function canExec(action) {
        return this.canExecActions.has(action.type);
      }
    }]);
    return _class;
  }(superclass);
};
/* harmony default export */ const executable = (Executable);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/mixins/draggable.js
function draggable_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { draggable_typeof = function _typeof(obj) { return typeof obj; }; } else { draggable_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return draggable_typeof(obj); }












function draggable_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function draggable_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function draggable_createClass(Constructor, protoProps, staticProps) { if (protoProps) draggable_defineProperties(Constructor.prototype, protoProps); if (staticProps) draggable_defineProperties(Constructor, staticProps); return Constructor; }
function draggable_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { draggable_get = Reflect.get; } else { draggable_get = function _get(target, property, receiver) { var base = draggable_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return draggable_get(target, property, receiver || target); }
function draggable_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = draggable_getPrototypeOf(object); if (object === null) break; } return object; }
function draggable_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) draggable_setPrototypeOf(subClass, superClass); }
function draggable_setPrototypeOf(o, p) { draggable_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return draggable_setPrototypeOf(o, p); }
function draggable_createSuper(Derived) { var hasNativeReflectConstruct = draggable_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = draggable_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = draggable_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return draggable_possibleConstructorReturn(this, result); }; }
function draggable_possibleConstructorReturn(self, call) { if (call && (draggable_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return draggable_assertThisInitialized(self); }
function draggable_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function draggable_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function draggable_getPrototypeOf(o) { draggable_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return draggable_getPrototypeOf(o); }

var Draggable = function Draggable(superclass) {
  return /*#__PURE__*/function (_superclass) {
    draggable_inherits(_class, _superclass);
    var _super = draggable_createSuper(_class);
    function _class() {
      var _this;
      draggable_classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _this.isDraggable = true;
      return _this;
    }
    draggable_createClass(_class, [{
      key: "attach",
      value: function attach() {
        var _get2;
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        (_get2 = draggable_get(draggable_getPrototypeOf(_class.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      }
    }, {
      key: "render",
      value: function render() {
        if (draggable_get(draggable_getPrototypeOf(_class.prototype), "render", this)) {
          draggable_get(draggable_getPrototypeOf(_class.prototype), "render", this).call(this);
        }
        if (this.props.focused) {
          this.domNode.classList.add('allow-dragging');
        } else {
          this.domNode.classList.remove('allow-dragging');
        }
        if (this.props.dragging) {
          this.domNode.classList.add('dragging');
        } else {
          this.domNode.classList.remove('dragging');
        }
      }
    }]);
    return _class;
  }(superclass);
};
/* harmony default export */ const draggable = (Draggable);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/mixins/selectable.js
function selectable_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { selectable_typeof = function _typeof(obj) { return typeof obj; }; } else { selectable_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return selectable_typeof(obj); }












function selectable_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function selectable_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function selectable_createClass(Constructor, protoProps, staticProps) { if (protoProps) selectable_defineProperties(Constructor.prototype, protoProps); if (staticProps) selectable_defineProperties(Constructor, staticProps); return Constructor; }
function selectable_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { selectable_get = Reflect.get; } else { selectable_get = function _get(target, property, receiver) { var base = selectable_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return selectable_get(target, property, receiver || target); }
function selectable_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = selectable_getPrototypeOf(object); if (object === null) break; } return object; }
function selectable_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) selectable_setPrototypeOf(subClass, superClass); }
function selectable_setPrototypeOf(o, p) { selectable_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return selectable_setPrototypeOf(o, p); }
function selectable_createSuper(Derived) { var hasNativeReflectConstruct = selectable_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = selectable_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = selectable_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return selectable_possibleConstructorReturn(this, result); }; }
function selectable_possibleConstructorReturn(self, call) { if (call && (selectable_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return selectable_assertThisInitialized(self); }
function selectable_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function selectable_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function selectable_getPrototypeOf(o) { selectable_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return selectable_getPrototypeOf(o); }


/**
 * если данный миксин пременен на блот это означет что блот может быть выделен при мульти выделении
 */

var Selectable = function Selectable(superclass) {
  return /*#__PURE__*/function (_superclass) {
    selectable_inherits(_class, _superclass);
    var _super = selectable_createSuper(_class);
    function _class() {
      var _this;
      selectable_classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _this.isSelectable = true;
      return _this;
    }
    selectable_createClass(_class, [{
      key: "render",
      value: function render() {
        var _this$getWrapper;
        if (selectable_get(selectable_getPrototypeOf(_class.prototype), "render", this)) {
          selectable_get(selectable_getPrototypeOf(_class.prototype), "render", this).call(this);
        }
        var wrapper = (_this$getWrapper = this.getWrapper) === null || _this$getWrapper === void 0 ? void 0 : _this$getWrapper.call(this);
        if (wrapper) {
          if (this.props.selected || this.props.highlighted) {
            this.domNode.classList.add('selected-block');
            if (!this.isSelectableBlotChild) {
              wrapper.domNode.classList.add('selected-block-wrapper');
            }
          } else {
            this.domNode.classList.remove('selected-block');
            if (!this.isSelectableBlotChild) {
              wrapper.domNode.classList.remove('selected-block-wrapper');
            }
          }
        }
      }
    }]);
    return _class;
  }(superclass);
};
/* harmony default export */ const selectable = (Selectable);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/mixins/indentable.js
function indentable_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { indentable_typeof = function _typeof(obj) { return typeof obj; }; } else { indentable_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return indentable_typeof(obj); }














function indentable_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function indentable_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function indentable_createClass(Constructor, protoProps, staticProps) { if (protoProps) indentable_defineProperties(Constructor.prototype, protoProps); if (staticProps) indentable_defineProperties(Constructor, staticProps); return Constructor; }
function indentable_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { indentable_get = Reflect.get; } else { indentable_get = function _get(target, property, receiver) { var base = indentable_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return indentable_get(target, property, receiver || target); }
function indentable_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = indentable_getPrototypeOf(object); if (object === null) break; } return object; }
function indentable_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) indentable_setPrototypeOf(subClass, superClass); }
function indentable_setPrototypeOf(o, p) { indentable_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return indentable_setPrototypeOf(o, p); }
function indentable_createSuper(Derived) { var hasNativeReflectConstruct = indentable_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = indentable_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = indentable_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return indentable_possibleConstructorReturn(this, result); }; }
function indentable_possibleConstructorReturn(self, call) { if (call && (indentable_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return indentable_assertThisInitialized(self); }
function indentable_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function indentable_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function indentable_getPrototypeOf(o) { indentable_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return indentable_getPrototypeOf(o); }


var indentable_MAX_INDENT_LEVEL = 30;
function getIndentClassName(indent) {
  return 'indent-' + (parseInt(indent) || 0);
}
var Indentable = function Indentable(superclass) {
  return /*#__PURE__*/function (_superclass) {
    indentable_inherits(_class, _superclass);
    var _super = indentable_createSuper(_class);
    function _class() {
      var _this;
      indentable_classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _this.indentableCurrentIndent = null;
      _this.addCanExecActions(['indent', 'outdent']);
      return _this;
    }
    indentable_createClass(_class, [{
      key: "contextMenu",
      get: function get() {
        var menu = indentable_get(indentable_getPrototypeOf(_class.prototype), "contextMenu", this);
        Object.assign(menu, {
          indent: true
        });
        return menu;
      }
    }, {
      key: "render",
      value: function render() {
        indentable_get(indentable_getPrototypeOf(_class.prototype), "render", this).call(this);
        var currentIndent = this.map.get('indent');
        var maxIndent = this.constructor.getMaxIndent();
        currentIndent = Math.min(currentIndent, maxIndent);
        if (this.indentableCurrentIndent !== currentIndent) {
          if (this.indentableCurrentIndent !== null) {
            this.getWrapper().domNode.classList.remove(getIndentClassName(this.indentableCurrentIndent));
          }
          this.getWrapper().domNode.classList.add(getIndentClassName(currentIndent));
          this.indentableCurrentIndent = currentIndent;
        }
      }
    }, {
      key: "getIndent",
      value: function getIndent() {
        return this.map.get('indent') || 0;
      }
    }, {
      key: "setIndent",
      value: function setIndent(indent) {
        this.map.set('indent', indent);
      }
    }, {
      key: "addIndent",
      value: function addIndent() {
        var currentIndent = this.map.get('indent') || 0;
        if (currentIndent < this.constructor.getMaxIndent()) {
          var newIndentLevel = currentIndent + 1;
          this.map.set('indent', newIndentLevel);
        }
        return true;
      }
    }, {
      key: "removeIndent",
      value: function removeIndent() {
        var currentIndent = this.map.get('indent');
        if (currentIndent > 0) {
          var newIndentLevel = currentIndent - 1;
          this.map.set('indent', newIndentLevel);
        }
        return true;
      }
    }, {
      key: "exec",
      value: function exec(action) {
        var processed = indentable_get(indentable_getPrototypeOf(_class.prototype), "exec", this) ? indentable_get(indentable_getPrototypeOf(_class.prototype), "exec", this).call(this, action) : false;
        if (action.type === 'indent') {
          processed = this.addIndent();
          if (!this.isEmbeddable) this.selection.focus();
        } else if (action.type === 'outdent') {
          processed = this.removeIndent();
          if (!this.isEmbeddable) this.selection.focus();
        }
        if (processed) {
          this.editor.emitter.emit('indent', {});
        }
        return processed;
      }
    }, {
      key: "getBlotInsertParams",
      value: function getBlotInsertParams(blotRange, contextHelper) {
        var params = indentable_get(indentable_getPrototypeOf(_class.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
        var indent = this.map.get('indent');
        if (indent > 0) {
          return (0,util/* mergeDeep */.Ee)(params, {
            initParams: {
              indent: indent
            }
          });
        }
        return params;
      }
    }, {
      key: "getCloneParams",
      value: function getCloneParams() {
        var _get2;
        var cloneParams = ((_get2 = indentable_get(indentable_getPrototypeOf(_class.prototype), "getCloneParams", this)) === null || _get2 === void 0 ? void 0 : _get2.call(this)) || {};
        var indent = this.map.get('indent');
        if (indent > 0) {
          cloneParams.indent = indent;
        }
        return cloneParams;
      }
    }], [{
      key: "getMaxIndent",
      value: function getMaxIndent() {
        return indentable_MAX_INDENT_LEVEL;
      }
    }]);
    return _class;
  }(superclass);
};
Indentable.initMap = function (map, store) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  map.set('indent', Math.min(params.indent || 0, src_parchment.query(map.get('type')).getMaxIndent()));
};
/* harmony default export */ const indentable = (Indentable);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/mixins/colorable.js
function colorable_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { colorable_typeof = function _typeof(obj) { return typeof obj; }; } else { colorable_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return colorable_typeof(obj); }













function colorable_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function colorable_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function colorable_createClass(Constructor, protoProps, staticProps) { if (protoProps) colorable_defineProperties(Constructor.prototype, protoProps); if (staticProps) colorable_defineProperties(Constructor, staticProps); return Constructor; }
function colorable_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { colorable_get = Reflect.get; } else { colorable_get = function _get(target, property, receiver) { var base = colorable_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return colorable_get(target, property, receiver || target); }
function colorable_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = colorable_getPrototypeOf(object); if (object === null) break; } return object; }
function colorable_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) colorable_setPrototypeOf(subClass, superClass); }
function colorable_setPrototypeOf(o, p) { colorable_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return colorable_setPrototypeOf(o, p); }
function colorable_createSuper(Derived) { var hasNativeReflectConstruct = colorable_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = colorable_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = colorable_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return colorable_possibleConstructorReturn(this, result); }; }
function colorable_possibleConstructorReturn(self, call) { if (call && (colorable_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return colorable_assertThisInitialized(self); }
function colorable_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function colorable_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function colorable_getPrototypeOf(o) { colorable_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return colorable_getPrototypeOf(o); }


var Colorable = function Colorable(superclass) {
  return /*#__PURE__*/function (_superclass) {
    colorable_inherits(_class, _superclass);
    var _super = colorable_createSuper(_class);
    function _class() {
      var _this;
      colorable_classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _this.isColorable = true;
      _this.addCanExecActions(['set-background']);
      return _this;
    }
    colorable_createClass(_class, [{
      key: "render",
      value: function render() {
        colorable_get(colorable_getPrototypeOf(_class.prototype), "render", this).call(this);
        var color = this.map.get('color');
        if (!this.selfColorManagement) {
          // это на случай копирования html из других источников, где блоку имеет бэкграунд и старых заметок, где в map блока записан цвет
          if (stringIsColor(color)) {
            if (this.domNode.hasAttribute('data-block-background')) {
              this.domNode.removeAttribute('data-block-background');
            }
            this.domNode.style.backgroundColor = color;
          } else {
            this.domNode.style.backgroundColor = null;
            if (color === 'transparent') {
              this.domNode.removeAttribute('data-block-background');
            } else {
              this.domNode.setAttribute('data-block-background', color);
            }
          }
        }
      }
    }, {
      key: "getColor",
      value: function getColor() {
        return this.map.get('color');
      }
    }, {
      key: "contextMenu",
      get: function get() {
        var i18n = this.editor.plugins.i18n;
        var menu = colorable_get(colorable_getPrototypeOf(_class.prototype), "contextMenu", this);
        menu['change-color'] = {
          label: i18n.get('block_menu.color.background_color'),
          index: -1,
          group: 0,
          action: 'change-color',
          stackable: true,
          submenu: 'ColorPicker'
        };
        return menu;
      }
    }, {
      key: "exec",
      value: function exec(action) {
        var processed = colorable_get(colorable_getPrototypeOf(_class.prototype), "exec", this) ? colorable_get(colorable_getPrototypeOf(_class.prototype), "exec", this).call(this, action) : false;
        if (action.type === 'set-background') {
          this.map.set('color', action.params);
          processed = true;
        }
        return processed;
      }
    }, {
      key: "getBlotInsertParams",
      value: function getBlotInsertParams(blotRange, contextHelper) {
        var params = colorable_get(colorable_getPrototypeOf(_class.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
        var color = this.map.get('color');
        if (color && color !== Colorable.defaultBgColor) {
          return (0,util/* mergeDeep */.Ee)(params, {
            initParams: {
              color: color
            }
          });
        }
        return params;
      }

      /**
       * Добавляет цвет фона при клонировании блота
       * @memberof Colorable
       * @returns { object }
       */
    }, {
      key: "getCloneParams",
      value: function getCloneParams() {
        var _get2;
        var cloneParams = ((_get2 = colorable_get(colorable_getPrototypeOf(_class.prototype), "getCloneParams", this)) === null || _get2 === void 0 ? void 0 : _get2.call(this)) || {};
        var color = this.map.get('color');
        if (color && color !== Colorable.defaultBgColor) {
          cloneParams.color = color;
        }
        return cloneParams;
      }
    }]);
    return _class;
  }(superclass);
};
Colorable.initMap = function (map, store) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (params.color) {
    map.set('color', params.color);
  } else if (!params.noDefaultColor) {
    map.set('color', Colorable.defaultBgColor);
  }
};
Colorable.defaultBgColor = 'transparent';
/* harmony default export */ const colorable = (Colorable);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/mixins/focusable.js
function focusable_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { focusable_typeof = function _typeof(obj) { return typeof obj; }; } else { focusable_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return focusable_typeof(obj); }












function focusable_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function focusable_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function focusable_createClass(Constructor, protoProps, staticProps) { if (protoProps) focusable_defineProperties(Constructor.prototype, protoProps); if (staticProps) focusable_defineProperties(Constructor, staticProps); return Constructor; }
function focusable_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { focusable_get = Reflect.get; } else { focusable_get = function _get(target, property, receiver) { var base = focusable_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return focusable_get(target, property, receiver || target); }
function focusable_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = focusable_getPrototypeOf(object); if (object === null) break; } return object; }
function focusable_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) focusable_setPrototypeOf(subClass, superClass); }
function focusable_setPrototypeOf(o, p) { focusable_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return focusable_setPrototypeOf(o, p); }
function focusable_createSuper(Derived) { var hasNativeReflectConstruct = focusable_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = focusable_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = focusable_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return focusable_possibleConstructorReturn(this, result); }; }
function focusable_possibleConstructorReturn(self, call) { if (call && (focusable_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return focusable_assertThisInitialized(self); }
function focusable_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function focusable_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function focusable_getPrototypeOf(o) { focusable_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return focusable_getPrototypeOf(o); }


/**
 * если данный миксин пременен на блот это означет что блот может быть в активном режиме(иметь фокус)
 */

var FOCUSED_CLASS = 'focused-block';

// храним в этой переменной, глобальной для редактора, ссылку на последний блот на котором был фокус
var lastFocusedBlot = null;
var Focusable = function Focusable(superclass) {
  return /*#__PURE__*/function (_superclass) {
    focusable_inherits(_class, _superclass);
    var _super = focusable_createSuper(_class);
    function _class() {
      var _this;
      focusable_classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _this.isFocusable = true;
      _this.props.selected = false;
      return _this;
    }
    focusable_createClass(_class, [{
      key: "isFocusedClassSet",
      value: function isFocusedClassSet() {
        return this.domNode.classList.contains(FOCUSED_CLASS);
      }

      // вызывается если надо сделать фокус только на данном блоте
      // все остальное выделение должно быть очищено
    }, {
      key: "focusableFocus",
      value: function focusableFocus() {
        this.scroll.selection.setRange({
          index: this.offset(this.scroll),
          length: 0
        });
      }
    }, {
      key: "render",
      value: function render() {
        if (focusable_get(focusable_getPrototypeOf(_class.prototype), "render", this)) {
          focusable_get(focusable_getPrototypeOf(_class.prototype), "render", this).call(this);
        }
        if (this.props.focused && !this.isFocusedClassSet()) {
          this.domNode.classList.add(FOCUSED_CLASS);
          this.onFocusableFocus(lastFocusedBlot);
          lastFocusedBlot = this;
        } else if (!this.props.focused && this.isFocusedClassSet()) {
          this.domNode.classList.remove(FOCUSED_CLASS);
          this.onFocusableBlur();
        }
      }
    }, {
      key: "onFocusableFocus",
      value: function onFocusableFocus() {
        if (focusable_get(focusable_getPrototypeOf(_class.prototype), "onFocusableFocus", this)) {
          focusable_get(focusable_getPrototypeOf(_class.prototype), "onFocusableFocus", this).call(this);
        }
        var event = new CustomEvent('focusable-focus', {
          bubbles: true
        });
        this.domNode.dispatchEvent(event);
      }
    }, {
      key: "onFocusableBlur",
      value: function onFocusableBlur() {
        if (focusable_get(focusable_getPrototypeOf(_class.prototype), "onFocusableBlur", this)) {
          focusable_get(focusable_getPrototypeOf(_class.prototype), "onFocusableBlur", this).call(this);
        }
        var event = new CustomEvent('focusable-blur', {
          bubbles: true
        });
        this.domNode.dispatchEvent(event);
      }
    }, {
      key: "remove",
      value: function remove() {
        if (this.props.focused) {
          this.onFocusableBlur();
        }
        focusable_get(focusable_getPrototypeOf(_class.prototype), "remove", this).call(this);
      }
    }]);
    return _class;
  }(superclass);
};
/* harmony default export */ const focusable = (Focusable);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/mixins/blotLock.js
function blotLock_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { blotLock_typeof = function _typeof(obj) { return typeof obj; }; } else { blotLock_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return blotLock_typeof(obj); }














function blotLock_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function blotLock_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function blotLock_createClass(Constructor, protoProps, staticProps) { if (protoProps) blotLock_defineProperties(Constructor.prototype, protoProps); if (staticProps) blotLock_defineProperties(Constructor, staticProps); return Constructor; }
function blotLock_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { blotLock_get = Reflect.get; } else { blotLock_get = function _get(target, property, receiver) { var base = blotLock_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return blotLock_get(target, property, receiver || target); }
function blotLock_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = blotLock_getPrototypeOf(object); if (object === null) break; } return object; }
function blotLock_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) blotLock_setPrototypeOf(subClass, superClass); }
function blotLock_setPrototypeOf(o, p) { blotLock_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return blotLock_setPrototypeOf(o, p); }
function blotLock_createSuper(Derived) { var hasNativeReflectConstruct = blotLock_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = blotLock_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = blotLock_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return blotLock_possibleConstructorReturn(this, result); }; }
function blotLock_possibleConstructorReturn(self, call) { if (call && (blotLock_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return blotLock_assertThisInitialized(self); }
function blotLock_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function blotLock_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function blotLock_getPrototypeOf(o) { blotLock_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return blotLock_getPrototypeOf(o); }
function blotLock_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var BlotLock = function BlotLock(superclass) {
  return /*#__PURE__*/function (_superclass) {
    blotLock_inherits(_class2, _superclass);
    var _super = blotLock_createSuper(_class2);
    function _class2() {
      var _this;
      blotLock_classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      blotLock_defineProperty(blotLock_assertThisInitialized(_this), "lockBlotAction", function () {
        if (_this.canLock) {
          _this.map.set('blotLocked', true);
          _this.setProps({
            blotLocked: true,
            contenteditable: 1
          });
          _this.editor.emitter.emit('lockBlot');
        } else {
          _this.showPopup();
        }
      });
      blotLock_defineProperty(blotLock_assertThisInitialized(_this), "unlockBlotAction", function () {
        if (_this.canUnlock) {
          _this.map.set('blotLocked', false);
          _this.setProps({
            blotLocked: false,
            contenteditable: 0
          });
          _this.editor.emitter.emit('unlockBlot');
        } else {
          _this.showPopup();
        }
      });
      _this.addCanExecActions(['lock', 'unlock']);
      return _this;
    }
    blotLock_createClass(_class2, [{
      key: "canLock",
      get: function get() {
        var options = this.editor.options;
        return options.user && options.user.manage === 'full';
      }
    }, {
      key: "canUnlock",
      get: function get() {
        var options = this.editor.options;
        var canUnlock = options.user && options.user.manage === 'canUnlock';
        return !!(this.canLock || canUnlock);
      }
    }, {
      key: "manageBlotsLockConfig",
      get: function get() {
        return this.editor.options.manageBlotsLock;
      }
    }, {
      key: "showPopup",
      value: function showPopup() {
        this.editor.plugins.popupManager.customAlert({
          type: "blots_lock_disabled_alert"
        });
      }
    }, {
      key: "isBlotLocked",
      get: function get() {
        if (this.manageBlotsLockConfig) {
          if (this.props.blotLocked) {
            return true;
          }
        }
        return false;
      }
    }, {
      key: "contextMenu",
      get: function get() {
        var menu = blotLock_get(blotLock_getPrototypeOf(_class2.prototype), "contextMenu", this);
        var i18n = this.editor.plugins.i18n;

        // получаем иконку доступности фичи
        var blocksLockEe = new (events_default())();
        var onLockBlotMouseEnter = function onLockBlotMouseEnter() {
          blocksLockEe.emit('enter', {});
        };
        var onLockBlotMouseLeave = function onLockBlotMouseLeave() {
          blocksLockEe.emit('leave', {});
        };
        var featureIcon = this.editor.plugins.featuresAvailabilityPlugin.getFeatureIcon('blocks-lock', blocksLockEe);
        var blots = this.editor.scroll.selectedBlocks;
        var lockName = (0,preact_module.h)("div", {
          onMouseEnter: onLockBlotMouseEnter,
          onMouseLeave: onLockBlotMouseLeave
        }, i18n.get('block_menu.blot_lock') + (blots.length > 1 && i18n.language === 'en' ? 's' : ''), featureIcon);
        var unlockName = i18n.get('block_menu.blot_unlock') + (blots.length > 1 && i18n.language === 'en' ? 's' : '');
        if (this.manageBlotsLockConfig && this.canUnlock) {
          if (this.isBlotLocked) {
            menu["blotUnlock"] = {
              label: unlockName,
              index: 2,
              group: 0,
              action: 'unlockBlotAction',
              stackable: true
            };
          } else {
            menu["blotLock"] = {
              label: lockName,
              index: 2,
              group: 0,
              action: 'lockBlotAction',
              stackable: true
            };
          }
        }
        return menu;
      }
    }, {
      key: "renderLockAfter",
      value: function renderLockAfter() {
        if (this.props.blotLocked) {
          this.floatingToolbarDisabled = !(this.scroll.selectedBlocks && this.scroll.selectedBlocks.length !== 1);
          this.domNode.setAttribute('contenteditable', false);
          if (this.getTextBlot) {
            this.getTextBlot().domNode.setAttribute('contenteditable', false);
          }
        } else {
          if (this.props.contenteditable === 0) {
            if (this.domNode.hasAttribute('contenteditable') && !this.isEmbeddable) {
              this.domNode.removeAttribute('contenteditable');
            }
            if (this.getTextBlot) {
              this.getTextBlot().domNode.setAttribute('contenteditable', true);
            }
            if (this.floatingToolbarDisabled) {
              this.floatingToolbarDisabled = false;
            }
          }
        }
      }
    }, {
      key: "renderLock",
      value: function renderLock() {
        if (this.manageBlotsLockConfig) {
          this.renderLockAfter();
        }
      }
    }, {
      key: "attach",
      value: function attach() {
        blotLock_get(blotLock_getPrototypeOf(_class2.prototype), "attach", this).call(this);
        if (!this.props.blotLocked && this.map.get('blotLocked')) {
          this.props.blotLocked = true;
          this.props.contenteditable = 1;
        }
        document.oncontextmenu = function () {
          var blots = this.editor.scroll.selectedBlocks;
          if (blots.length > 1) {
            var hasLocked = false;
            blots.map(function (item) {
              if (item.isBlotLocked) {
                hasLocked = true;
              }
            });
            if (hasLocked) {
              var blotsToTempBlock = blots.filter(function (item) {
                return !item.isBlotLocked;
              });
              blotsToTempBlock.map(function (blot) {
                blot.props.contenteditable = 0;
                blot.domNode.setAttribute('contenteditable', false);
              });
            }
          }
        }.bind(this);
      }
    }, {
      key: "render",
      value: function render() {
        if (blotLock_get(blotLock_getPrototypeOf(_class2.prototype), "render", this)) {
          blotLock_get(blotLock_getPrototypeOf(_class2.prototype), "render", this).call(this);
        }
        this.renderLock();
      }
    }, {
      key: "exec",
      value: function exec(action) {
        var processed = blotLock_get(blotLock_getPrototypeOf(_class2.prototype), "exec", this) ? blotLock_get(blotLock_getPrototypeOf(_class2.prototype), "exec", this).call(this, action) : false;
        if (!processed) {
          if (action.type === 'lock') {
            this.lockBlotAction();
            processed = true;
          } else if (action.type === 'unlock') {
            this.unlockBlotAction();
            processed = true;
          }
        }
        return processed;
      }
    }]);
    return _class2;
  }(superclass);
};
/* harmony default export */ const blotLock = (BlotLock);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/textMenu.js






function textMenu_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function textMenu_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { textMenu_ownKeys(Object(source), true).forEach(function (key) { textMenu_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { textMenu_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function textMenu_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





function textMenu() {
  var editor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _editor$blotsConfig = editor.blotsConfig,
    blotsConfig = _editor$blotsConfig === void 0 ? {
      hint: {},
      button: {}
    } : _editor$blotsConfig;
  var _ref = blotsConfig.hint || {},
    _ref$showMenuItem = _ref.showMenuItem,
    showHintMenuItem = _ref$showMenuItem === void 0 ? true : _ref$showMenuItem;
  var _ref2 = blotsConfig.button || {},
    _ref2$showButtonForma = _ref2.showButtonFormat,
    showButtonFormat = _ref2$showButtonForma === void 0 ? true : _ref2$showButtonForma;
  var showToggleMenuItem = editor.scroll.selectedBlocks.every(function (blot) {
    return !searchUp(blot, function (b) {
      return b.constructor.blotName === 'toggleContent';
    });
  });
  var itemsByConditions = {};
  if (showHintMenuItem) {
    itemsByConditions = textMenu_objectSpread(textMenu_objectSpread({}, itemsByConditions), {}, {
      turnToHint: {
        label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
          id: "block_menu.convert_to.hint"
        }, "Hint"),
        index: 9,
        group: 0,
        action: 'convert-blot',
        actionParams: {
          type: 'hint'
        },
        actionExec: true,
        stackable: true,
        icon: icons/* IconHint */.qE2,
        hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+u'
      }
    });
  }
  if (showToggleMenuItem) {
    itemsByConditions = textMenu_objectSpread(textMenu_objectSpread({}, itemsByConditions), {}, {
      turnToToggleBlock: {
        label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
          id: "block_menu.convert_to.toggle"
        }, "Toggle Block"),
        index: 3,
        group: 0,
        action: 'convert-blot',
        actionParams: {
          type: 'toggle'
        },
        actionExec: true,
        stackable: true,
        icon: icons/* IconToggle */.oe4,
        hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+6'
      },
      turnToStepBlock: {
        label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
          id: "block_menu.convert_to.step"
        }, "Step"),
        index: 4,
        group: 0,
        action: 'convert-blot',
        actionParams: {
          type: 'step'
        },
        actionExec: true,
        stackable: true,
        icon: icons/* IconStep */.tuc
      },
      turnToHLargeToggle: {
        label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
          id: "block_menu.convert_to.large_heading_toggle"
        }, "Collapsible Large Heading"),
        index: 11,
        group: 0,
        action: 'convert-blot',
        actionParams: {
          type: 'hLarge-toggle'
        },
        actionExec: true,
        stackable: true,
        icon: icons/* IconLargeHeaderToggle */.THL,
        style: 'bolder'
      },
      turnToHMediumToggle: {
        label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
          id: "block_menu.convert_to.medium_heading_toggle"
        }, "Collapsible Medium Heading"),
        index: 12,
        group: 0,
        action: 'convert-blot',
        actionParams: {
          type: 'hMedium-toggle'
        },
        actionExec: true,
        stackable: true,
        icon: icons/* IconMediumHeaderToggle */.V6h,
        style: 'bold'
      },
      turnToHSmallToggle: {
        label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
          id: "block_menu.convert_to.small_heading_toggle"
        }, "Collapsible Small Heading"),
        index: 13,
        group: 0,
        action: 'convert-blot',
        actionParams: {
          type: 'hSmall-toggle'
        },
        actionExec: true,
        stackable: true,
        icon: icons/* IconSmallHeaderToggle */.gM0
      }
    });
  }
  return {
    "turn-into": {
      label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
        id: "block_menu.convert_to.name"
      }, "Convert to"),
      index: -5,
      group: 0,
      action: false,
      submenu: textMenu_objectSpread(textMenu_objectSpread({
        turnToChecklist: {
          label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
            id: "block_menu.convert_to.to_do_list"
          }, "Task"),
          index: 0,
          group: 0,
          action: 'convert-blot',
          actionParams: {
            type: 'list',
            items: ['listItemCheckbox']
          },
          actionExec: true,
          stackable: true,
          icon: icons/* IconChecklist */.$Nx,
          hint: browser/* modKey */.CF + '+shift+c'
        },
        turnToNumberList: {
          label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
            id: "block_menu.convert_to.number_list"
          }, "Number List"),
          index: 1,
          group: 0,
          action: 'convert-blot',
          actionParams: {
            type: 'list',
            items: ['listItemNumber']
          },
          actionExec: true,
          stackable: true,
          icon: icons/* IconListNumber */.UcJ,
          hint: browser/* modKey */.CF + '+shift+7'
        },
        turnToBulletList: {
          label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
            id: "block_menu.convert_to.bullet_list"
          }, "Bullet List"),
          index: 2,
          group: 0,
          action: 'convert-blot',
          actionParams: {
            type: 'list',
            items: ['listItemBullet']
          },
          actionExec: true,
          stackable: true,
          icon: icons/* IconListBullet */.pfx,
          hint: browser/* modKey */.CF + '+shift+8'
        },
        turnToParagraph: {
          label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
            id: "block_menu.convert_to.paragraph"
          }, "Paragraph"),
          index: 4,
          group: 0,
          action: 'convert-blot',
          actionParams: {
            type: 'paragraph'
          },
          actionExec: true,
          stackable: true,
          icon: icons/* IconParagraph */.V_f,
          hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+7'
        },
        turnToLarge: {
          label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
            id: "block_menu.convert_to.large_heading"
          }, "Large Heading"),
          index: 5,
          group: 0,
          action: 'convert-blot',
          actionParams: {
            type: 'hLarge'
          },
          actionExec: true,
          stackable: true,
          icon: icons/* IconHeaderLarge */.oIo,
          hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+1',
          style: 'bolder'
        },
        turnToMedium: {
          label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
            id: "block_menu.convert_to.medium_heading"
          }, "Medium Heading"),
          index: 6,
          group: 0,
          action: 'convert-blot',
          actionParams: {
            type: 'hMedium'
          },
          actionExec: true,
          stackable: true,
          icon: icons/* IconHeaderMedium */.L9t,
          hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+2',
          style: 'bold'
        },
        turnToSmall: {
          label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
            id: "block_menu.convert_to.small_heading"
          }, "Small Heading"),
          index: 7,
          group: 0,
          action: 'convert-blot',
          actionParams: {
            type: 'hSmall'
          },
          actionExec: true,
          stackable: true,
          icon: icons/* IconHeaderSmall */.Q2d,
          hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+3'
        },
        turnToSyntax: {
          label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
            id: "block_menu.convert_to.code"
          }, "Code"),
          index: 8,
          group: 0,
          action: 'convert-blot',
          actionParams: {
            type: 'syntax'
          },
          actionExec: true,
          stackable: true,
          icon: icons/* IconSyntax */.UUr,
          hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+c'
        },
        turnToBlockquote: {
          label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
            id: "block_menu.convert_to.quote"
          }, "Quote"),
          index: 9,
          group: 0,
          action: 'convert-blot',
          actionParams: {
            type: 'blockquote',
            link: true
          },
          actionExec: true,
          stackable: true,
          icon: icons/* IconQuote */.kVp,
          hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+y'
        }
      }, showButtonFormat ? {
        turnToButton: {
          label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
            id: "block_menu.convert_to.button"
          }, "Button"),
          index: 10,
          group: 0,
          action: 'convert-blot',
          actionParams: {
            type: 'button-single',
            link: true
          },
          actionExec: true,
          stackable: false,
          icon: icons/* IconButton */.hU,
          hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+5'
        }
      } : {}), itemsByConditions),
      stackable: true
    },
    align: true,
    indent: true
  };
}
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/scss/list.scss
var list = __webpack_require__(49851);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/scss/block-menu.scss
var block_menu = __webpack_require__(21324);
var block_menu_default = /*#__PURE__*/__webpack_require__.n(block_menu);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/list/listCollapseComponent.js
function listCollapseComponent_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { listCollapseComponent_typeof = function _typeof(obj) { return typeof obj; }; } else { listCollapseComponent_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return listCollapseComponent_typeof(obj); }










function listCollapseComponent_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function listCollapseComponent_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function listCollapseComponent_createClass(Constructor, protoProps, staticProps) { if (protoProps) listCollapseComponent_defineProperties(Constructor.prototype, protoProps); if (staticProps) listCollapseComponent_defineProperties(Constructor, staticProps); return Constructor; }
function listCollapseComponent_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) listCollapseComponent_setPrototypeOf(subClass, superClass); }
function listCollapseComponent_setPrototypeOf(o, p) { listCollapseComponent_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return listCollapseComponent_setPrototypeOf(o, p); }
function listCollapseComponent_createSuper(Derived) { var hasNativeReflectConstruct = listCollapseComponent_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = listCollapseComponent_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = listCollapseComponent_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return listCollapseComponent_possibleConstructorReturn(this, result); }; }
function listCollapseComponent_possibleConstructorReturn(self, call) { if (call && (listCollapseComponent_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return listCollapseComponent_assertThisInitialized(self); }
function listCollapseComponent_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function listCollapseComponent_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function listCollapseComponent_getPrototypeOf(o) { listCollapseComponent_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return listCollapseComponent_getPrototypeOf(o); }
function listCollapseComponent_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var ListCollapseComponent = /*#__PURE__*/function (_Component) {
  listCollapseComponent_inherits(ListCollapseComponent, _Component);
  var _super = listCollapseComponent_createSuper(ListCollapseComponent);
  function ListCollapseComponent(domNode) {
    var _this;
    listCollapseComponent_classCallCheck(this, ListCollapseComponent);
    _this = _super.call(this, domNode);
    listCollapseComponent_defineProperty(listCollapseComponent_assertThisInitialized(_this), "onButtonClick", function (event) {
      var blot = _this.props.blot;
      var collapsed = blot.map.get('collapsed');
      blot.map.set('collapsed', !collapsed);
      _this.setState(function () {
        return {
          state: _this.state
        };
      });
    });
    _this.isSeparableByClickApplicable = true;
    return _this;
  }
  listCollapseComponent_createClass(ListCollapseComponent, [{
    key: "render",
    value: function render() {
      var blot = this.props.blot;
      var collapsed = blot.map.get('collapsed');
      return (0,preact_module.h)("div", {
        className: 'list-item-collapse-component',
        onClick: this.onButtonClick
      }, (0,preact_module.h)("div", {
        className: 'list-collapse-icon ' + (collapsed ? 'collapsed' : 'expanded')
      }, (0,preact_module.h)(icons/* IconListCollapse */.J0H, null)));
    }
  }]);
  return ListCollapseComponent;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/list.js

/*
  Функция возвращает массив ListItem blot's, которые находятся ниже по уровню относительно {listItem} и имеющих больший indent
  @param {listItem} - Blot элемент списка, относительно которого нужно найти его псевдодетей
  @return {Array} - массив блотов, которые являются элементами списка
*/

function getSubListItems(listItem) {
  var currentIndent = listItem.getIndent();
  var result = [];
  var blot = listItem.next;
  while (blot && blot.getIndent() > currentIndent) {
    result.push(blot);
    blot = blot.next;
  }
  return result;
}

/*
  Функция возвращает true если есть вышестоящий ListItem с меньшим indent и имеющий статус collapsed
  @param {listItem} - Blot элемент списка, у которого нужно найти свернутый псевдородитель
  @return {Boolean}
*/

function isListItemParentCollapsed(listItem) {
  var blot = listItem.prev;
  var currentIndent = listItem.getIndent();
  var result = false;
  while (blot) {
    var indent = blot.getIndent();
    if (indent < currentIndent) {
      currentIndent = indent;
      if (blot.map.get('collapsed')) {
        result = true;
        blot = null;
      } else {
        blot = blot.prev;
      }
    } else {
      blot = blot.prev;
    }
  }
  return result;
}

/*
  Функция возвращает вышестоящий видимый Blot, имеющий статус collapsed
  @param {listItem} - Blot элемент списка, у которого нужно найти свернутый псевдородитель
  @return {Blot} - ListItem свернутый видимый родительский элемент списка
*/

function getVisibleParentListItem(listItem) {
  var blot = listItem.prev;
  var currentIndent = listItem.getIndent();
  var result = null;
  while (blot) {
    var indent = blot.getIndent();
    if (indent < currentIndent) {
      currentIndent = indent;
      if (blot.map.get('collapsed') && !blot.props.hidden) {
        result = blot;
        blot = null;
      } else {
        blot = blot.prev;
      }
    } else {
      blot = blot.prev;
    }
  }
  return result;
}

/*
  Функция возвращает номер элемента нумерованного списка
  @param {listItem} - Blot элемент списка, у которого нужно получить номер
  @return {String} - строка - номер элемента списка
*/

function getNumberedListNumberString(listItem) {
  if (listItem.map.get('type') !== 'listItemNumber') {
    return false;
  }
  var number = 1;
  var currentIndent = listItem.getIndent();
  var blot = listItem.prev;
  while (blot) {
    if (currentIndent > blot.getIndent()) {
      blot = null;
    } else {
      if (currentIndent === blot.getIndent()) {
        if (blot.constructor.blotName !== 'listItemNumber') {
          blot = null;
        } else {
          number++;
        }
      }
      if (blot) {
        blot = blot.prev;
      }
    }
  }
  return String(number);
}

/*
  Функция возвращает первый вышестоящий ListItem имеющий такой же indent, что и переданный в функцию
  @param {listItem} - Blot элемент списка, выше которого нужно найти ListItem с таким же indent
  @return {Blot} - ListItem
*/

function getPrevListItemWithSameIndent(listItem) {
  var currentIndent = listItem.getIndent();
  var blot = listItem.prev;
  while (blot && blot.getIndent() !== currentIndent) {
    blot = blot.prev;
  }
  return blot;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/list/listItem.js
function listItem_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { listItem_typeof = function _typeof(obj) { return typeof obj; }; } else { listItem_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return listItem_typeof(obj); }
function listItem_slicedToArray(arr, i) { return listItem_arrayWithHoles(arr) || listItem_iterableToArrayLimit(arr, i) || listItem_unsupportedIterableToArray(arr, i) || listItem_nonIterableRest(); }
function listItem_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function listItem_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function listItem_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function listItem_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = listItem_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }





















function listItem_toConsumableArray(arr) { return listItem_arrayWithoutHoles(arr) || listItem_iterableToArray(arr) || listItem_unsupportedIterableToArray(arr) || listItem_nonIterableSpread(); }
function listItem_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function listItem_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return listItem_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return listItem_arrayLikeToArray(o, minLen); }
function listItem_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function listItem_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return listItem_arrayLikeToArray(arr); }
function listItem_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function listItem_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function listItem_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function listItem_createClass(Constructor, protoProps, staticProps) { if (protoProps) listItem_defineProperties(Constructor.prototype, protoProps); if (staticProps) listItem_defineProperties(Constructor, staticProps); return Constructor; }
function listItem_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) listItem_setPrototypeOf(subClass, superClass); }
function listItem_setPrototypeOf(o, p) { listItem_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return listItem_setPrototypeOf(o, p); }
function listItem_createSuper(Derived) { var hasNativeReflectConstruct = listItem_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = listItem_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = listItem_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return listItem_possibleConstructorReturn(this, result); }; }
function listItem_possibleConstructorReturn(self, call) { if (call && (listItem_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return listItem_assertThisInitialized(self); }
function listItem_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function listItem_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function listItem_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { listItem_get = Reflect.get; } else { listItem_get = function _get(target, property, receiver) { var base = listItem_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return listItem_get(target, property, receiver || target); }
function listItem_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = listItem_getPrototypeOf(object); if (object === null) break; } return object; }
function listItem_getPrototypeOf(o) { listItem_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return listItem_getPrototypeOf(o); }
function listItem_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }























var listMarginLeft = parseInt(list.listMarginLeft);
var blockMenuPinButtonSize = parseInt(block_menu.blockMenuPinButtonSize);
var listItem_isTabKey = (0,lib/* default */.ZP)('tab');
var listItem_isBackspaceKey = (0,lib/* default */.ZP)('backspace');
var listItem_MAX_INDENT_LEVEL = 29;
var ALLOWED_BLOT_TYPES = ['listItemBullet', 'listItemCheckbox', 'listItemNumber'];
var mixin = mix([commentable, blotLock, dropAcceptor, draggable, colorable, indentable, selectable, focusable, executable, basic]);
var ListItem = /*#__PURE__*/function (_mixin) {
  listItem_inherits(ListItem, _mixin);
  var _super = listItem_createSuper(ListItem);
  function ListItem(domNode) {
    var _this;
    listItem_classCallCheck(this, ListItem);
    _this = _super.call(this, domNode);
    listItem_defineProperty(listItem_assertThisInitialized(_this), "onMapChanged", function () {
      _this.render();
      // если в опциях список не сворачиваемый, не выполняем эти функции, чтоб не нагружать редактор
      if (_this.editor.blotsConfig.hasOwnProperty('list') && _this.editor.blotsConfig.list.collapsible === true) {
        _this.parent.render();
      }
    });
    _this.emitter = new emitter();
    _this.emitter.setMaxListeners(999999);
    _this.isListItem = true;
    // запрещаем перенос блотов справа или слева от элемента списка для создания грида
    // перенос справа и слева разрешен только для элемента List
    _this.disallowSideDrop = true;
    domNode.classList.add('list-item');
    _this.isSeparableByClickApplicable = true;
    _this.draggableHandleRect = {
      x: -30,
      y: 0,
      width: 10,
      height: 18
    };
    _this.addCanExecActions(listItem_toConsumableArray(textLine.canExecActions));
    _this.isMobileKeyDown = false; // для проверки кода 229 в мобильной версии
    _this.counter = 1;
    return _this;
  }
  listItem_createClass(ListItem, [{
    key: "beforeMove",
    value: function beforeMove(containerBlot, params) {
      var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (containerBlot instanceof list_list) {
        return;
      }
      if (this.container.children.length === 1 && (!context.listWrappings || !context.listWrappings[this.container.id])) {
        // для оптимизации если переносится единственный элемент списка, то переносим вместе с ним весь список
        return {
          id: this.container.id,
          removeBlot: this.container
        };
      }
      if (!context.listWrappings) {
        context.listWrappings = {};
      }
      var insertId = null;
      if (context.listWrappings[this.container.id]) {
        // какой-то элемент старого списка уже обернул себя в список, необходимо добавить текущий элемент в этот список
        context.listWrappings[this.container.id].get('children').push([this.id]);
      } else {
        // оборачиваем данный элемент в список
        // нельзя создавать элементы используя addBlot в данном методе, только работа с базой
        var listMap = containerBlot.store.createMap();
        list_list.initMap(listMap, this.store, {
          children: [this.id]
        });
        insertId = listMap.get('id');
        context.listWrappings[this.container.id] = listMap;
      }
      var res = {
        id: insertId
      };
      return res;
    }
  }, {
    key: "attach",
    value: function attach() {
      listItem_get(listItem_getPrototypeOf(ListItem.prototype), "attach", this).call(this);
      if (this._listItemInitialized) {
        return;
      }
      this._listItemInitialized = true;
      this.store.observe(this.map, this.onMapChanged);
      if (this.map.get('type') === 'listItemNumber') {
        var _this$parent;
        // for numbered list items, we need to update the counter
        (_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.updateChildren();
      }
      this.render();
    }
  }, {
    key: "detach",
    value: function detach() {
      if (listItem_get(listItem_getPrototypeOf(ListItem.prototype), "detach", this)) {
        var _get2;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        (_get2 = listItem_get(listItem_getPrototypeOf(ListItem.prototype), "detach", this)).call.apply(_get2, [this].concat(args));
      }
      this.store.unobserve(this.map, this.onMapChanged);
      this.listItemExpand();
    }
  }, {
    key: "listItemHandleBackspace",
    value: function listItemHandleBackspace(action) {
      var blotRange = action.getBlotRange(this);
      if (blotRange.index === 0 && blotRange.length === 0) {
        action.dontRestoreSelection();
        // нажатие backspace в начале элемента списка, если элемент имеет сдвиг, то надо уменьшить его на 1
        var currentIndent = this.map.get('indent');
        if (currentIndent > 0) {
          this.removeIndent();
        } else {
          // если блот не имеет сдвига значит надо разбить список на два и заполнить параграф текстом из текущего блота
          this.parent.splitList(this.index, {
            initParams: {
              delta: this.delta()
            }
          });
        }
        return true;
      }
    }
  }, {
    key: "listItemHandleShiftBackspace",
    value: function listItemHandleShiftBackspace(action) {
      if (this.parent.children.head !== this) return false;
      var blotRange = action.getBlotRange(this);
      if (blotRange.index === 0 && blotRange.length === 0) {
        var list = this.parent;
        var prevList = list.prev;
        if (prevList && prevList.constructor.blotName === 'list') {
          var moveIds = list.children.map(function (listItem) {
            return listItem.id;
          }); //следующий за списком блот, тоже является списком?
          var index = prevList.getChildIndex(prevList.children.tail.id) + 1;
          this.editor.store.transaction(function () {
            var _iterator = listItem_createForOfIteratorHelper(moveIds),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var id = _step.value;
                //перемещаем все блоты из следующего списка, в текущий
                list.removeChildById(id);
                index = Math.min(index, prevList.containerChildren.length);
                prevList.containerChildren.insert(index, [id]);
                index++;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          });
          prevList.render();
          return true;
        }
      }
      return false;
    }
  }, {
    key: "exec",
    value: function exec(action) {
      if (action.type === 'backspace') {
        if (action.params.shiftKey) {
          if (this.listItemHandleShiftBackspace(action)) {
            return true;
          }
        }
        if (this.listItemHandleBackspace(action)) {
          return true;
        }
      }
      if (action.type === 'indent') {
        if (!this.prev || this.prev.getIndent() >= this.getIndent()) {
          this.addIndent();
          this.selection.focus();
        }
        this.editor.emitter.emit('indent', {});
        return true;
      }
      return listItem_get(listItem_getPrototypeOf(ListItem.prototype), "exec", this).call(this, action);
    }
  }, {
    key: "cloneSelf",
    value: function cloneSelf() {
      var map = this.store.createMap();
      parchment_default().query(this.map.get('type')).initMap(map, this.store, {
        color: this.map.get('color'),
        align: this.map.get('align'),
        indent: this.map.get('indent'),
        collapsed: this.map.get('collapsed'),
        delta: this.delta({
          forCopy: true
        })
      });
      return map.get('id');
    }
  }, {
    key: "listItemHandleEnterOnEmptyItem",
    value: function listItemHandleEnterOnEmptyItem() {
      var indent = this.map.get('indent');
      if (indent <= 0) {
        this.parent.splitList(this.index);
      } else {
        this.removeIndent();
      }
    }
  }, {
    key: "handleInput",
    value: function handleInput(event) {
      // Если в событии keydown keyCode = 229 и последний введённый символо \n то самостоятельно диспатчим событие
      // нажатия на Enter
      if (this.isMobileKeyDown) {
        if (event.data && event.data.substr(event.data.length - 1, 1) === "\n") {
          // устанавливаем курсок в конце строки
          this.focusableFocus();
          var range = this.scroll.selection.getRange(this);
          this.scroll.selection.setRange({
            index: range[0].index + this.length() - 1,
            length: 0
          });
          var keyEvent = new KeyboardEvent('keydown', {
            bubbles: true,
            cancelable: true,
            key: 'Enter',
            keyCode: 13
          });
          this.domNode.dispatchEvent(keyEvent);
        }
        this.isMobileKeyDown = false;
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (this.editor.options.keyboardMode === 'mobile') {
        // При клике на Enter на виртуальной клавиатуре в Android возвращается код 229, из-за этого, если курсор стоит в конце
        // строки последнего элемента, следующий элемент не создаётся.
        this.isMobileKeyDown = event.keyCode === 229;
      }

      // существует баг с нативным выделением, когда каретка стоит в конце свернутого listItem, но браузер говорит что каретка в конце скрытого итема
      // проверяем если это так, то выставляем сами range и вызываем функцию у родительского элемента.
      // если в опциях список не сворачиваемый, не выполняем эти функции, чтоб не нагружать редактор
      if (this.editor.blotsConfig.hasOwnProperty('list') && this.editor.blotsConfig.list.collapsible === true) {
        var range = this.scroll.selection.getRange()[0];
        if (this.props.hidden && range.length === 0) {
          var parentVisibleListItem = getVisibleParentListItem(this);
          if (parentVisibleListItem) {
            this.scroll.selection.setRange({
              index: parentVisibleListItem.offset(this.scroll) + parentVisibleListItem.length() - 1,
              length: 0
            });
            return parentVisibleListItem.handleKeyDown(event);
          }
        }
      }
      if (event.keyCode === 13 && !event.shiftKey) {
        if (this.domNode.textContent === '') {
          // нажатие enter на пустом элементе списка
          this.listItemHandleEnterOnEmptyItem();
          event.preventDefault();
          return true;
        }
      }
      return listItem_get(listItem_getPrototypeOf(ListItem.prototype), "handleKeyDown", this).call(this, event);
    }
  }, {
    key: "onBlotMenuUpdatePosition",
    value: function onBlotMenuUpdatePosition(_ref) {
      var left = _ref.left,
        top = _ref.top;
      left -= listMarginLeft;
      if (this.editor.mode !== this.editor.constructor.MODE_EDIT && (!this.editor.plugins.blockMenu.options.showCopyBlotButton || this.isEmpty())) {
        left += blockMenuPinButtonSize;
      }
      return {
        left: left,
        top: top
      };
    }
  }, {
    key: "addSubText",
    value: function addSubText() {
      this.map.get('characters').applyDelta([{
        retain: this.length() - 1
      }, {
        insert: {
          linebreak: 's'
        }
      }]);
      this.selection.setRange({
        index: this.offset(this.scroll) + this.length() - 1,
        length: 0
      });
    }
  }, {
    key: "contextMenu",
    get: function get() {
      var menu = listItem_get(listItem_getPrototypeOf(ListItem.prototype), "contextMenu", this);
      var i18n = this.editor.plugins.i18n;
      Object.assign(menu, textMenu(this.editor));
      if (!this.isEmpty()) {
        menu.addSubText = {
          label: i18n.get('block_menu.add_sub_text'),
          index: -2,
          group: 0,
          action: 'addSubText',
          stackable: false
        };
      }
      var addExpandAll = false;
      var addCollapseAll = false;
      if (this.getSubItems().length) {
        if (!this.isCollapsed()) {
          addCollapseAll = true;
        }
        if (this.isCollapsed() || this.hasCollapsedSubItems()) {
          addExpandAll = true;
        }
      }
      // тут добавляем возможность свернуть/развернуть весь список для первого элемента меню
      if (this === this.parent.children.head) {
        if (this.parent.hasCollapsedListItems()) {
          addExpandAll = true;
        }
        if (!this.getSubItems().length && this.parent.hasExpandedListItems()) {
          addCollapseAll = true;
        }
      }
      if (addCollapseAll) {
        menu.collapseAll = {
          label: i18n.get('block_menu.collapse_all'),
          index: -1,
          group: 0,
          action: 'onCollapseAll',
          stackable: false
        };
      }
      if (addExpandAll) {
        menu.expandAll = {
          label: i18n.get('block_menu.expand_all'),
          index: 0,
          group: 0,
          action: 'onExpandAll',
          stackable: false
        };
      }
      return menu;
    }
    // в связи с тем, что поведение Enter в свернутом элементе и элементе имеющем псевдодетей отличается от обычного поведения текстового блока
    // все 3 функции отвечающие за нажатие Enter на текстовом элементе были переписаны тут с дополнительными параметрами
  }, {
    key: "textLineAddNextBlot",
    value: function textLineAddNextBlot() {
      var initParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var blotType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var after = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var indent = this.map.get('indent');
      var afterId = after || this.id;
      var params = Object.assign(initParams, this.textLineAddBlotParams({
        indent: initParams.hasOwnProperty('indent') ? initParams.indent : indent,
        after: afterId
      }));
      blotType = ALLOWED_BLOT_TYPES.indexOf(blotType) !== -1 ? blotType : this.constructor.blotName;
      return this.parent.addBlot(blotType, params);
    }
  }, {
    key: "textLineSplit",
    value: function textLineSplit(index) {
      var _this2 = this;
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$selection$getRa = this.selection.getRange({
          offsetBlot: this
        }),
        _this$selection$getRa2 = listItem_slicedToArray(_this$selection$getRa, 1),
        blotRange = _this$selection$getRa2[0];
      var formats = this.getFormat(blotRange.index, 1);
      Object.keys(formats).map(function (format) {
        _this2.selection.format(format, false);
      });
      var initDelta = null;
      var newBlot = this.split(index, true);
      if (newBlot && newBlot !== this.next) {
        //to build delta with formats set parent to the detached blot
        newBlot.parent = this.parent;
        initDelta = newBlot.delta();
        this.scroll.update();
      }
      var addNextBlotOpts = {
        delta: initDelta
      };
      if (opts.focus) {
        addNextBlotOpts.focus = {
          index: 0
        };
      }
      if (opts.hasOwnProperty('indent')) {
        addNextBlotOpts.indent = opts.indent;
      }
      var blotType = this.constructor.blotName;
      var after = this.id;
      if (opts.isEnterKeyEvent) {
        if (this.isCollapsed()) {
          var subItems = this.getSubItems();
          if (subItems.length) {
            after = subItems[subItems.length - 1].id;
          }
        }
      }
      this.textLineAddNextBlot(addNextBlotOpts, blotType, after);
    }
  }, {
    key: "textLineOnEnterKey",
    value: function textLineOnEnterKey(event) {
      event.preventDefault();
      console.groupCollapsed('listItem: handle ENTER key');
      var range = this.scroll.selection.getNativeRange();
      if (range && range.start.node === range.end.node) {
        this.editor.plugins.undoManager.stopCapturing();
        var _this$selection$getRa3 = this.selection.getRange({
            offsetBlot: this
          }),
          _this$selection$getRa4 = listItem_slicedToArray(_this$selection$getRa3, 1),
          blotRange = _this$selection$getRa4[0];
        var indent = this.getIndent();
        if (!this.isCollapsed() && blotRange.length === 0 && blotRange.index === this.length() - 1 && this.next && this.next.getIndent() > indent) {
          indent += 1;
        }
        this.tryConvertLink(blotRange);
        this.textLineSplit(blotRange.index, {
          focus: true,
          indent: indent,
          isEnterKeyEvent: true
        });
        console.groupEnd();
        return true;
      } else {
        console.groupEnd();
        return listItem_get(listItem_getPrototypeOf(ListItem.prototype), "textLineOnEnterKey", this).call(this, event);
      }
    }
  }, {
    key: "textLineOnDblClick",
    value: function textLineOnDblClick(event, blot) {
      if (this.dblClick) {
        this.dblClick = undefined;
        return false;
      }
      event.preventDefault();
      var liBlot = blot;
      var liBlotNext = liBlot.next;
      if (!liBlotNext) {
        return;
      } else {
        this.editor.plugins.undoManager.stopCapturing();
        var blotType = this.constructor.blotName;
        var params = {
          after: liBlot.id,
          delta: null,
          focus: {
            index: 0
          },
          indent: 0
        };
        this.parent.addBlot(blotType, params);
        if (liBlot.indentableCurrentIndent > 0) {
          var indent = liBlot.getIndent();
          liBlot.next.setIndent(indent);
        }
        this.dblClick = true;
      }
      return true;
    }

    //в связи с тем что работа Tab и Shift+Tab в списках, должна отличаться, функции отвечающие за эти действия были переписаны тут
  }, {
    key: "textLineOnTabKey",
    value: function textLineOnTabKey(event) {
      event.preventDefault();
      if (this.prev && this.prev.getIndent() + 1 === this.getIndent()) {
        return true;
      }
      if (this.isCollapsed()) {
        console.log('add indent to sub items');
        var subItems = this.getSubItems();
        var _iterator2 = listItem_createForOfIteratorHelper(subItems),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            item.addIndent();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      this.addIndent();
      this.parent.render();
      return true;
    }
  }, {
    key: "textLineOnShiftTabKey",
    value: function textLineOnShiftTabKey(event) {
      event.preventDefault();
      if (this.getIndent() === 0) {
        return true;
      }
      if (this.isCollapsed()) {
        var subItems = this.getSubItems();
        subItems.forEach(function (item) {
          item.removeIndent();
        });
      }
      this.removeIndent();
      this.parent.render();
      return true;
    }
  }, {
    key: "blockMenuAddComponent",
    value: function blockMenuAddComponent() {
      // если в опциях список не сворачиваемый, возвращаем null
      if (this.editor.blotsConfig.hasOwnProperty('list') && this.editor.blotsConfig.list.collapsible === true && this.next && this.next.getIndent() > this.getIndent()) {
        return ListCollapseComponent;
      } else {
        return null;
      }
    }
  }, {
    key: "isCollapsed",
    value: function isCollapsed() {
      // если в опциях список не сворачиваемый, всегда возвращаем false
      if (this.editor.blotsConfig.hasOwnProperty('list') && this.editor.blotsConfig.list.collapsible === true) {
        return Boolean(this.map.get('collapsed'));
      } else {
        return false;
      }
    }
  }, {
    key: "hasCollapsedSubItems",
    value: function hasCollapsedSubItems() {
      var result = false;
      var items = this.getSubItems();
      var _iterator3 = listItem_createForOfIteratorHelper(items),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var item = _step3.value;
          if (item.isCollapsed()) {
            result = true;
            break;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return result;
    }
  }, {
    key: "getSubItems",
    value: function getSubItems() {
      return getSubListItems(this);
    }
  }, {
    key: "listItemCollapse",
    value: function listItemCollapse() {
      var items = this.getSubItems();
      var _iterator4 = listItem_createForOfIteratorHelper(items),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var item = _step4.value;
          item.setProps({
            'hidden': true
          });
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "listItemExpand",
    value: function listItemExpand() {
      var items = this.getSubItems();
      var skip = false;
      var skipToIndent = null;
      var _iterator5 = listItem_createForOfIteratorHelper(items),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var item = _step5.value;
          if (skip) {
            if (item.getIndent() > skipToIndent) {
              continue;
            } else {
              skip = false;
              skipToIndent = null;
            }
          }
          if (item.map.get('collapsed')) {
            skip = true;
            skipToIndent = item.getIndent();
          }
          item.setProps({
            'hidden': false
          });
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "render",
    value: function render() {
      listItem_get(listItem_getPrototypeOf(ListItem.prototype), "render", this).call(this);

      // если в опциях список не сворачиваемый, не выполняем эти функции, чтоб не нагружать редактор
      if (this.editor.blotsConfig.hasOwnProperty('list') && this.editor.blotsConfig.list.collapsible === true) {
        if (this.props.hidden) {
          if (!this.domNode.classList.contains('list-item-hidden')) {
            this.domNode.classList.add('list-item-hidden');
          }
        } else {
          if (this.domNode.classList.contains('list-item-hidden')) {
            this.domNode.classList.remove('list-item-hidden');
          }
        }
        if (this.isCollapsed()) {
          this.listItemCollapse();
          if (!this.domNode.classList.contains('collapsed-list-item')) {
            this.domNode.classList.add('collapsed-list-item');
          }
        } else {
          if (!isListItemParentCollapsed(this)) {
            this.listItemExpand();
          }
          if (this.domNode.classList.contains('collapsed-list-item')) {
            this.domNode.classList.remove('collapsed-list-item');
          }
        }
      }
    }
    // Фунция проверяет, актуальны ли текущие статусы collapsed в map и hidden в props, если нет, меняет на false.
    // Так же вызывает рендер если статусы актуальны, это нужно для корректной работы различных действий (duplicate, undo/redo и т.п.)
    // Функция должна вызываться после выполнения всех манипуляций со вставкой/удалением в родительском контейнере, на данный момент она вызвается в
    // List.render() так как рендер списка, как раз вызывается после всех этих манипуляций
    // P.S. возможно тут нужно протестировать какую нагрузку вызовет выполнение данной функции, так как вызываться она будет довольно часто
  }, {
    key: "updateListItemPropsIfNeed",
    value: function updateListItemPropsIfNeed(counter) {
      this.counter = counter;
      if (this.next && this.next.getIndent() <= this.getIndent() && this.isCollapsed()) {
        this.map.set('collapsed', false);
      } else if (this.props.hidden && !isListItemParentCollapsed(this)) {
        this.setProps({
          hidden: false
        });
      } else {
        this.render();
      }
    }
  }, {
    key: "addIndent",
    value: function addIndent() {
      // если в опциях список не сворачиваемый, не выполняем эти функции, чтоб не нагружать редактор
      if (this.editor.blotsConfig.hasOwnProperty('list') && this.editor.blotsConfig.list.collapsible === true) {
        var prevItemWithSameIndent = getPrevListItemWithSameIndent(this);
        if (prevItemWithSameIndent && prevItemWithSameIndent.isCollapsed()) {
          prevItemWithSameIndent.map.set('collapsed', false);
        }
      }
      listItem_get(listItem_getPrototypeOf(ListItem.prototype), "addIndent", this).call(this);
    }
  }, {
    key: "delete",
    value: function _delete() {
      var subItems = this.getSubItems();
      var _iterator6 = listItem_createForOfIteratorHelper(subItems),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var item = _step6.value;
          item.remove();
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      this.remove();
    }
  }, {
    key: "onExpandAll",
    value: function onExpandAll() {
      if (this === this.parent.children.head) {
        this.parent.onExpandAll();
      } else {
        var items = this.getSubItems();
        for (var _i2 = 0, _arr2 = [this].concat(listItem_toConsumableArray(items)); _i2 < _arr2.length; _i2++) {
          var item = _arr2[_i2];
          if (item.isCollapsed()) {
            item.map.set('collapsed', false);
          }
        }
      }
    }
  }, {
    key: "onCollapseAll",
    value: function onCollapseAll() {
      if (this === this.parent.children.head && !this.getSubItems().length) {
        this.parent.onCollapseAll();
      } else {
        var items = this.getSubItems();
        for (var _i3 = 0, _arr3 = [this].concat(listItem_toConsumableArray(items)); _i3 < _arr3.length; _i3++) {
          var item = _arr3[_i3];
          if (item.getSubItems().length && !item.isCollapsed()) {
            item.map.set('collapsed', true);
          }
        }
      }
    }
  }, {
    key: "onMustSetVisible",
    value: function onMustSetVisible() {
      if (this.props.hidden) {
        while (this.props.hidden) {
          var parent = getVisibleParentListItem(this);
          if (parent && parent.isCollapsed()) {
            parent.map.set('collapsed', false);
          }
        }
      }
    }
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      var blots = this.scroll.selectedBlocks;
      var isFullySelected = !blotRange || blotRange.length - blotRange.index === this.length() - 1;
      // если ListItem в массиве выделенных блоков один и выделен он не полнотью,
      // возвращаем его операцию как textLine, не передавая contextHelper,
      // иначе он обернет операцию в list
      if (blots.length === 1 && blots[0] === this && !isFullySelected) {
        return (0,util/* mergeDeep */.Ee)(listItem_get(listItem_getPrototypeOf(ListItem.prototype), "getBlotInsertParams", this).call(this, blotRange), {
          type: 'textLine'
        });
      }
      var op = listItem_get(listItem_getPrototypeOf(ListItem.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
      op.type = this.constructor.blotName;
      var collapsed = this.isCollapsed();
      // если элемент списка свернут и выделение в блоке заканчивается на его конце, нужно вернуть так же саблисты
      // P.S. нужно учитывать в условии: если элемент свернут, и он является частью свернутого списка,
      // данные о его сабсписках не добавляем, так как они добавляются у родительского
      var subItemsOps = [];
      if (blots[blots.length - 1] === this) {
        if (isFullySelected) {
          if (collapsed && !isListItemParentCollapsed(this)) {
            var subItems = this.getSubItems();
            if (subItems.length) {
              var _iterator7 = listItem_createForOfIteratorHelper(subItems),
                _step7;
              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  var item = _step7.value;
                  subItemsOps.push(item.getBlotInsertParams({
                    index: 0,
                    length: item.length() - 1
                  }, contextHelper));
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }
            }
          }
        } else if (collapsed) {
          collapsed = false;
        }
      }
      var addParams = {};
      if (this.getListItemInsertParams) {
        addParams = this.getListItemInsertParams();
      }
      op.params = (0,util/* mergeDeep */.Ee)(op.initParams, {
        collapsed: collapsed,
        counter: this.counter
      }, addParams);
      delete op.initParams;
      if (!subItemsOps.length) {
        return op;
      } else {
        return [op].concat(subItemsOps);
      }
    }
  }, {
    key: "getMarkdown",
    value: function getMarkdown() {
      var _this$map, _this$map2, _this$map2$get, _this$map3;
      var type = ((_this$map = this.map) === null || _this$map === void 0 ? void 0 : _this$map.get('type')) || 'listItemBullet';
      var ops = (_this$map2 = this.map) === null || _this$map2 === void 0 ? void 0 : (_this$map2$get = _this$map2.get('characters')) === null || _this$map2$get === void 0 ? void 0 : _this$map2$get.toDelta();
      var indent = (_this$map3 = this.map) === null || _this$map3 === void 0 ? void 0 : _this$map3.get('indent');
      var params = {
        counter: this.counter,
        delta: ops && {
          ops: ops
        } || {
          ops: []
        }
      };
      return listItemToMarkdown({
        params: params,
        type: type,
        indent: indent
      });
    }
  }], [{
    key: "getMaxIndent",
    value: function getMaxIndent() {
      return listItem_MAX_INDENT_LEVEL;
    }
  }, {
    key: "initMap",
    value: function initMap(map, store) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      listItem_get(listItem_getPrototypeOf(ListItem), "initMap", this).call(this, map, store, params);
      indentable.initMap(map, store, params);
      colorable.initMap(map, store, params);
      map.set('collapsed', params.collapsed || false);
    }
  }, {
    key: "getDropTarget",
    value: function getDropTarget(position, blots, target, context) {
      if (!(target instanceof list_list)) {
        return {
          target: target
        };
      }
      if (position === 'bottom') {
        context.skipListIndent = true;
        return {
          target: target.children.tail
        };
      } else if (position === 'top') {
        context.skipListIndent = true;
        return {
          target: target.children.head
        };
      } else {
        return {
          target: target
        };
      }
    }
  }]);
  return ListItem;
}(mixin(textLine));
ListItem.tagName = 'LI';
ListItem.blotName = 'listItem';
ListItem.scope = (parchment_default()).Scope.BLOCK_BLOT;
ListItem.defaultChild = textLine.defaultChild;
ListItem.allowedChildren = textLine.allowedChildren;
/* harmony default export */ const listItem = (ListItem);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/list/listItemBullet.js
function listItemBullet_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { listItemBullet_typeof = function _typeof(obj) { return typeof obj; }; } else { listItemBullet_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return listItemBullet_typeof(obj); }
function listItemBullet_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = listItemBullet_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function listItemBullet_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return listItemBullet_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return listItemBullet_arrayLikeToArray(o, minLen); }
function listItemBullet_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }















function listItemBullet_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function listItemBullet_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function listItemBullet_createClass(Constructor, protoProps, staticProps) { if (protoProps) listItemBullet_defineProperties(Constructor.prototype, protoProps); if (staticProps) listItemBullet_defineProperties(Constructor, staticProps); return Constructor; }
function listItemBullet_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { listItemBullet_get = Reflect.get; } else { listItemBullet_get = function _get(target, property, receiver) { var base = listItemBullet_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return listItemBullet_get(target, property, receiver || target); }
function listItemBullet_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = listItemBullet_getPrototypeOf(object); if (object === null) break; } return object; }
function listItemBullet_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) listItemBullet_setPrototypeOf(subClass, superClass); }
function listItemBullet_setPrototypeOf(o, p) { listItemBullet_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return listItemBullet_setPrototypeOf(o, p); }
function listItemBullet_createSuper(Derived) { var hasNativeReflectConstruct = listItemBullet_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = listItemBullet_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = listItemBullet_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return listItemBullet_possibleConstructorReturn(this, result); }; }
function listItemBullet_possibleConstructorReturn(self, call) { if (call && (listItemBullet_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return listItemBullet_assertThisInitialized(self); }
function listItemBullet_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function listItemBullet_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function listItemBullet_getPrototypeOf(o) { listItemBullet_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return listItemBullet_getPrototypeOf(o); }








var listCollapseIconWidth = parseInt(list.listCollapseIconWidth);
var spaceBetweenBulletAndText = parseInt(list.spaceBetweenBulletAndText);
var smallBulletSize = parseInt(list.smallBulletSize);
var normalBulletSize = parseInt(list.normalBulletSize);
var largeBulletSize = parseInt(list.largeBulletSize);
var bulletSizes = {
  small: smallBulletSize,
  normal: normalBulletSize,
  large: largeBulletSize
};
var BULLET_LIST_ICON_SEQUENCE = ['circle', 'rectangle', 'star', 'dart', 'rounded', 'arrow', 'diamond'];
var LIST_STYLES = [{
  label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
    id: "list.type_default"
  }),
  key: 'default',
  icon: icons/* IconListCircle */.J59
}, {
  label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
    id: "list.type_rectangle"
  }),
  key: 'rectangle',
  icon: icons/* IconListRectangle */.wE3
}, {
  label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
    id: "list.type_star"
  }),
  key: 'star',
  icon: icons/* IconListStar */.m7c
}, {
  label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
    id: "list.type_dart"
  }),
  key: 'dart',
  icon: icons/* IconListDart */.gDF
}, {
  label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
    id: "list.type_rounded"
  }),
  key: 'rounded',
  icon: icons/* IconListRounded */.yDK
}, {
  label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
    id: "list.type_arrow"
  }),
  key: 'arrow',
  icon: icons/* IconListArrow */.Oa8
}, {
  label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
    id: "list.type_diamond"
  }),
  key: 'diamond',
  icon: icons/* IconListDiamond */.gEd
}];
var ListItemBullet = /*#__PURE__*/function (_ListItem) {
  listItemBullet_inherits(ListItemBullet, _ListItem);
  var _super = listItemBullet_createSuper(ListItemBullet);
  function ListItemBullet(domNode) {
    var _this;
    listItemBullet_classCallCheck(this, ListItemBullet);
    _this = _super.call(this, domNode);
    _this.isSeparableByClickApplicable = true;
    return _this;
  }
  listItemBullet_createClass(ListItemBullet, [{
    key: "render",
    value: function render() {
      listItemBullet_get(listItemBullet_getPrototypeOf(ListItemBullet.prototype), "render", this).call(this);
      var indent = this.getIndent();
      var template = this.parent.getBulletTemplate();
      if (template && !template[indent]) {
        var lastTemplateStyle = template[template.length - 1];
        var newTemplate = template.slice();
        for (var i = template.length; i <= indent; i++) {
          lastTemplateStyle = BULLET_LIST_ICON_SEQUENCE[BULLET_LIST_ICON_SEQUENCE.indexOf(lastTemplateStyle) + 1] || BULLET_LIST_ICON_SEQUENCE[0];
          newTemplate.push(lastTemplateStyle);
        }
        this.parent.setBulletTemplate(newTemplate);
      } else if (template && this.getListStyle() !== template[indent]) {
        this.domNode.setAttribute('list-style', template[indent]);
      }
    }
  }, {
    key: "getListStyle",
    value: function getListStyle() {
      return this.domNode.getAttribute('list-style');
    }
  }, {
    key: "contextMenu",
    get: function get() {
      var menu = listItemBullet_get(listItemBullet_getPrototypeOf(ListItemBullet.prototype), "contextMenu", this);
      var listStyleSubMenu = {};
      var i = 0;
      var _iterator = listItemBullet_createForOfIteratorHelper(LIST_STYLES),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var style = _step.value;
          var key = style.key;
          key = key !== 'default' ? key : 'circle';
          listStyleSubMenu[key] = {
            label: style.label,
            index: i,
            group: 0,
            action: 'setListStyle',
            actionParams: {
              style: key
            },
            actionExec: false,
            stackable: true,
            icon: style.icon,
            style: this.getListStyle() === key ? 'selected' : ''
          };
          i++;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      menu['list-style'] = {
        label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
          id: "list.list_style"
        }),
        index: 0,
        group: 0,
        action: false,
        stackable: false,
        submenu: listStyleSubMenu
      };
      return menu;
    }
  }, {
    key: "addIndent",
    value: function addIndent() {
      var currentListStyle = this.getListStyle();
      var currentTemplate = this.parent.getBulletTemplate();
      var indent = this.getIndent();
      if (!currentTemplate[indent + 1]) {
        var newTemplate = currentTemplate.slice();
        var nextListStyle = BULLET_LIST_ICON_SEQUENCE[BULLET_LIST_ICON_SEQUENCE.indexOf(currentListStyle) + 1] || BULLET_LIST_ICON_SEQUENCE[0];
        newTemplate.push(nextListStyle);
        this.parent.setBulletTemplate(newTemplate);
      }
      return listItemBullet_get(listItemBullet_getPrototypeOf(ListItemBullet.prototype), "addIndent", this).call(this);
    }
  }, {
    key: "setListStyle",
    value: function setListStyle(_ref) {
      var style = _ref.style;
      var currentTemplate = this.parent.getBulletTemplate();
      var indent = this.getIndent();
      var newTemplate = currentTemplate.slice();
      newTemplate.splice(indent, 1, style);
      this.parent.setBulletTemplate(newTemplate);
    }
  }], [{
    key: "create",
    value: function create() {
      var node = listItemBullet_get(listItemBullet_getPrototypeOf(ListItemBullet), "create", this).call(this);
      node.classList.add('list-item-bullet');
      return node;
    }
  }, {
    key: "initMap",
    value: function initMap(map, store) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      map.set('type', ListItemBullet.blotName);
      listItemBullet_get(listItemBullet_getPrototypeOf(ListItemBullet), "initMap", this).call(this, map, store, params);
    }
  }]);
  return ListItemBullet;
}(listItem);
ListItemBullet.blotName = 'listItemBullet';
ListItemBullet.tagName = listItem.tagName;
ListItemBullet.scope = listItem.scope;
ListItemBullet.allowedChildren = listItem.allowedChildren;
/* harmony default export */ const listItemBullet = (ListItemBullet);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/list/listItemNumber.js
function listItemNumber_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { listItemNumber_typeof = function _typeof(obj) { return typeof obj; }; } else { listItemNumber_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return listItemNumber_typeof(obj); }











function listItemNumber_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function listItemNumber_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function listItemNumber_createClass(Constructor, protoProps, staticProps) { if (protoProps) listItemNumber_defineProperties(Constructor.prototype, protoProps); if (staticProps) listItemNumber_defineProperties(Constructor, staticProps); return Constructor; }
function listItemNumber_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { listItemNumber_get = Reflect.get; } else { listItemNumber_get = function _get(target, property, receiver) { var base = listItemNumber_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return listItemNumber_get(target, property, receiver || target); }
function listItemNumber_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = listItemNumber_getPrototypeOf(object); if (object === null) break; } return object; }
function listItemNumber_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) listItemNumber_setPrototypeOf(subClass, superClass); }
function listItemNumber_setPrototypeOf(o, p) { listItemNumber_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return listItemNumber_setPrototypeOf(o, p); }
function listItemNumber_createSuper(Derived) { var hasNativeReflectConstruct = listItemNumber_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = listItemNumber_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = listItemNumber_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return listItemNumber_possibleConstructorReturn(this, result); }; }
function listItemNumber_possibleConstructorReturn(self, call) { if (call && (listItemNumber_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return listItemNumber_assertThisInitialized(self); }
function listItemNumber_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function listItemNumber_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function listItemNumber_getPrototypeOf(o) { listItemNumber_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return listItemNumber_getPrototypeOf(o); }






var listItemNumber_listCollapseIconWidth = parseInt(list.listCollapseIconWidth);
var spaceBetweenNumberAndText = parseInt(list.spaceBetweenNumberAndText);
// Эти цифры выставлены методом подбора
var symbolWidth = {
  small: 9,
  normal: 10,
  large: 11
};
var ListItemNumber = /*#__PURE__*/function (_ListItem) {
  listItemNumber_inherits(ListItemNumber, _ListItem);
  var _super = listItemNumber_createSuper(ListItemNumber);
  function ListItemNumber() {
    listItemNumber_classCallCheck(this, ListItemNumber);
    return _super.apply(this, arguments);
  }
  listItemNumber_createClass(ListItemNumber, [{
    key: "getDraggingNode",
    value: function getDraggingNode() {
      var node = this.domNode.cloneNode(true);
      // узнаем значение счетчика для данного списка
      var cnt = 1;
      var cur = this.prev;
      while (cur) {
        if (!(cur instanceof ListItemNumber)) {
          break;
        }
        cnt += 1;
        cur = cur.prev;
      }
      node.setAttribute('data-counter', cnt);
      return node;
    }
  }, {
    key: "render",
    value: function render() {
      listItemNumber_get(listItemNumber_getPrototypeOf(ListItemNumber.prototype), "render", this).call(this);
      var numberString = getNumberedListNumberString(this);
      if (numberString && numberString.length === 1) {
        if (!this.domNode.classList.contains('one-cnt-sym')) {
          this.domNode.classList.add('one-cnt-sym');
        }
      } else {
        if (this.domNode.classList.contains('one-cnt-sym')) {
          this.domNode.classList.remove('one-cnt-sym');
        }
      }
    }
  }], [{
    key: "create",
    value: function create() {
      var node = listItemNumber_get(listItemNumber_getPrototypeOf(ListItemNumber), "create", this).call(this);
      node.classList.add('list-item-number');
      return node;
    }
  }, {
    key: "initMap",
    value: function initMap(map, store) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      map.set('type', ListItemNumber.blotName);
      listItemNumber_get(listItemNumber_getPrototypeOf(ListItemNumber), "initMap", this).call(this, map, store, params);
    }
  }]);
  return ListItemNumber;
}(listItem);
ListItemNumber.blotName = 'listItemNumber';
ListItemNumber.tagName = listItem.tagName;
ListItemNumber.scope = listItem.scope;
ListItemNumber.allowedChildren = listItem.allowedChildren;
/* harmony default export */ const listItemNumber = (ListItemNumber);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/list/listItemCheckbox.js
function listItemCheckbox_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { listItemCheckbox_typeof = function _typeof(obj) { return typeof obj; }; } else { listItemCheckbox_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return listItemCheckbox_typeof(obj); }
















function listItemCheckbox_slicedToArray(arr, i) { return listItemCheckbox_arrayWithHoles(arr) || listItemCheckbox_iterableToArrayLimit(arr, i) || listItemCheckbox_unsupportedIterableToArray(arr, i) || listItemCheckbox_nonIterableRest(); }
function listItemCheckbox_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function listItemCheckbox_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return listItemCheckbox_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return listItemCheckbox_arrayLikeToArray(o, minLen); }
function listItemCheckbox_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function listItemCheckbox_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function listItemCheckbox_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function listItemCheckbox_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function listItemCheckbox_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function listItemCheckbox_createClass(Constructor, protoProps, staticProps) { if (protoProps) listItemCheckbox_defineProperties(Constructor.prototype, protoProps); if (staticProps) listItemCheckbox_defineProperties(Constructor, staticProps); return Constructor; }
function listItemCheckbox_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { listItemCheckbox_get = Reflect.get; } else { listItemCheckbox_get = function _get(target, property, receiver) { var base = listItemCheckbox_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return listItemCheckbox_get(target, property, receiver || target); }
function listItemCheckbox_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = listItemCheckbox_getPrototypeOf(object); if (object === null) break; } return object; }
function listItemCheckbox_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) listItemCheckbox_setPrototypeOf(subClass, superClass); }
function listItemCheckbox_setPrototypeOf(o, p) { listItemCheckbox_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return listItemCheckbox_setPrototypeOf(o, p); }
function listItemCheckbox_createSuper(Derived) { var hasNativeReflectConstruct = listItemCheckbox_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = listItemCheckbox_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = listItemCheckbox_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return listItemCheckbox_possibleConstructorReturn(this, result); }; }
function listItemCheckbox_possibleConstructorReturn(self, call) { if (call && (listItemCheckbox_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return listItemCheckbox_assertThisInitialized(self); }
function listItemCheckbox_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function listItemCheckbox_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function listItemCheckbox_getPrototypeOf(o) { listItemCheckbox_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return listItemCheckbox_getPrototypeOf(o); }
function listItemCheckbox_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var BOX_REL_POS = {
  x: [-30, -10],
  y: [5, 28]
};
var listItemCheckbox_listCollapseIconWidth = parseInt(list.listCollapseIconWidth);
var spaceBetweenCheckboxAndText = parseInt(list.spaceBetweenCheckboxAndText);
var smallCheckboxSize = parseInt(list.smallCheckboxSize);
var normalCheckboxSize = parseInt(list.normalCheckboxSize);
var largeCheckboxSize = parseInt(list.largeCheckboxSize);
var checkBoxSizes = {
  small: smallCheckboxSize,
  normal: normalCheckboxSize,
  large: largeCheckboxSize
};
var CHECKBOX_ELEM_CLASS = 'list-item-checkbox';
var ListItemCheckbox = /*#__PURE__*/function (_ListItem) {
  listItemCheckbox_inherits(ListItemCheckbox, _ListItem);
  var _super = listItemCheckbox_createSuper(ListItemCheckbox);
  function ListItemCheckbox(domNode) {
    var _this;
    listItemCheckbox_classCallCheck(this, ListItemCheckbox);
    _this = _super.call(this, domNode);
    listItemCheckbox_defineProperty(listItemCheckbox_assertThisInitialized(_this), "onCheckboxMouseMove", function (event) {
      var x = event.clientX,
        y = event.clientY;
      var rect = _this.domNode.getBoundingClientRect();
      var relX = x - rect.x;
      var relY = y - rect.y;
      if (relX > BOX_REL_POS.x[0] && relX < BOX_REL_POS.x[1] && relY > BOX_REL_POS.y[0] && relY < BOX_REL_POS.y[1]) {
        if (!_this.domNode.classList.contains('mouseover-checkbox')) {
          _this.domNode.classList.add('mouseover-checkbox');
        }
      } else if (_this.domNode.classList.contains('mouseover-checkbox')) {
        _this.domNode.classList.remove('mouseover-checkbox');
      }
    });
    listItemCheckbox_defineProperty(listItemCheckbox_assertThisInitialized(_this), "onCheckboxMouseLeave", function () {
      if (_this.domNode.classList.contains('mouseover-checkbox')) {
        _this.domNode.classList.remove('mouseover-checkbox');
      }
    });
    listItemCheckbox_defineProperty(listItemCheckbox_assertThisInitialized(_this), "onCheckboxMouseDown", function (event) {
      var x = event.clientX;
      var y = event.clientY;
      var rect = _this.domNode.getBoundingClientRect();
      var relX = x - rect.x;
      var relY = y - rect.y;
      if (relX > BOX_REL_POS.x[0] && relX < BOX_REL_POS.x[1] && relY > BOX_REL_POS.y[0] && relY < BOX_REL_POS.y[1]) {
        event.preventDefault();
        event.stopPropagation();
        if (!_this.parent || !_this.parent.blotConfig || !_this.parent.blotConfig.keepFocus) {
          var _this$scroll$selectio = _this.scroll.selection.getRange(),
            _this$scroll$selectio2 = listItemCheckbox_slicedToArray(_this$scroll$selectio, 1),
            range = _this$scroll$selectio2[0];
          if (range) {
            _this.editor.blur();
          }
        }
        var checked = !_this.map.get('checked');
        _this.map.set('checked', checked);
      }
    });
    _this.isSeparableByClickApplicable = true;
    return _this;
  }
  listItemCheckbox_createClass(ListItemCheckbox, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = listItemCheckbox_get(listItemCheckbox_getPrototypeOf(ListItemCheckbox.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      if (this.editor.mode !== this.editor.constructor.MODE_READONLY) {
        this.domNode.addEventListener('mousedown', this.onCheckboxMouseDown, false);
      }
      // тут только для сафари фикс курсора (pointer) для чекбокса, стилями в сафари не работает
      if (this.editor.browser === 'Safari') {
        this.domNode.addEventListener('mousemove', this.onCheckboxMouseMove, false);
        this.domNode.addEventListener('mouseleave', this.onCheckboxMouseLeave, false);
      }
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = listItemCheckbox_get(listItemCheckbox_getPrototypeOf(ListItemCheckbox.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      this.domNode.removeEventListener('mousedown', this.onCheckboxMouseDown, false);
      this.domNode.removeEventListener('mousemove', this.onCheckboxMouseMove, false);
      this.domNode.removeEventListener('mouseleave', this.onCheckboxMouseLeave, false);
    }
  }, {
    key: "render",
    value: function render() {
      listItemCheckbox_get(listItemCheckbox_getPrototypeOf(ListItemCheckbox.prototype), "render", this).call(this);
      this.domNode.setAttribute('data-checked', this.map.get('checked'));
    }
  }, {
    key: "addSubTask",
    value: function addSubTask() {
      if (this.isCollapsed()) {
        this.map.set('collapsed', false);
      }
      this.parent.addBlot(this.map.get('type'), {
        indent: this.map.get('indent') + 1,
        after: this.id,
        focus: {
          index: 0
        }
      });
    }
  }, {
    key: "cloneSelf",
    value: function cloneSelf() {
      var map = this.store.createMap();
      parchment_default().query(this.map.get('type')).initMap(map, this.store, {
        color: this.map.get('color'),
        align: this.map.get('align'),
        indent: this.map.get('indent'),
        collapsed: this.map.get('collapsed'),
        delta: this.delta({
          forCopy: true
        }),
        checked: this.map.get('checked')
      });
      return map.get('id');
    }
  }, {
    key: "contextMenu",
    get: function get() {
      var menu = listItemCheckbox_get(listItemCheckbox_getPrototypeOf(ListItemCheckbox.prototype), "contextMenu", this);
      menu.addSubTask = {
        label: this.editor.plugins.i18n.get('block_menu.add_sub_task'),
        index: -3,
        group: 0,
        action: 'addSubTask',
        stackable: false
      };
      return menu;
    }
  }, {
    key: "getListItemInsertParams",
    value: function getListItemInsertParams() {
      return {
        checked: this.map.get('checked')
      };
    }
  }], [{
    key: "create",
    value: function create() {
      var node = listItemCheckbox_get(listItemCheckbox_getPrototypeOf(ListItemCheckbox), "create", this).call(this);
      node.classList.add(CHECKBOX_ELEM_CLASS);
      return node;
    }
  }, {
    key: "initMap",
    value: function initMap(map, store) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      map.set('type', ListItemCheckbox.blotName);
      map.set('checked', params.hasOwnProperty('checked') && params.checked || false);
      listItemCheckbox_get(listItemCheckbox_getPrototypeOf(ListItemCheckbox), "initMap", this).call(this, map, store, params);
    }
  }]);
  return ListItemCheckbox;
}(listItem);
ListItemCheckbox.blotName = 'listItemCheckbox';
ListItemCheckbox.tagName = listItem.tagName;
ListItemCheckbox.scope = listItem.scope;
ListItemCheckbox.allowedChildren = listItem.allowedChildren;
/* harmony default export */ const listItemCheckbox = (ListItemCheckbox);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/paragraphAbstract.js
function paragraphAbstract_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { paragraphAbstract_typeof = function _typeof(obj) { return typeof obj; }; } else { paragraphAbstract_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return paragraphAbstract_typeof(obj); }
function paragraphAbstract_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = paragraphAbstract_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function paragraphAbstract_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function paragraphAbstract_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { paragraphAbstract_ownKeys(Object(source), true).forEach(function (key) { paragraphAbstract_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { paragraphAbstract_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function paragraphAbstract_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





















function paragraphAbstract_toConsumableArray(arr) { return paragraphAbstract_arrayWithoutHoles(arr) || paragraphAbstract_iterableToArray(arr) || paragraphAbstract_unsupportedIterableToArray(arr) || paragraphAbstract_nonIterableSpread(); }
function paragraphAbstract_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function paragraphAbstract_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return paragraphAbstract_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return paragraphAbstract_arrayLikeToArray(o, minLen); }
function paragraphAbstract_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function paragraphAbstract_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return paragraphAbstract_arrayLikeToArray(arr); }
function paragraphAbstract_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function paragraphAbstract_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function paragraphAbstract_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function paragraphAbstract_createClass(Constructor, protoProps, staticProps) { if (protoProps) paragraphAbstract_defineProperties(Constructor.prototype, protoProps); if (staticProps) paragraphAbstract_defineProperties(Constructor, staticProps); return Constructor; }
function paragraphAbstract_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) paragraphAbstract_setPrototypeOf(subClass, superClass); }
function paragraphAbstract_setPrototypeOf(o, p) { paragraphAbstract_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return paragraphAbstract_setPrototypeOf(o, p); }
function paragraphAbstract_createSuper(Derived) { var hasNativeReflectConstruct = paragraphAbstract_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = paragraphAbstract_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = paragraphAbstract_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return paragraphAbstract_possibleConstructorReturn(this, result); }; }
function paragraphAbstract_possibleConstructorReturn(self, call) { if (call && (paragraphAbstract_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return paragraphAbstract_assertThisInitialized(self); }
function paragraphAbstract_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function paragraphAbstract_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function paragraphAbstract_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { paragraphAbstract_get = Reflect.get; } else { paragraphAbstract_get = function _get(target, property, receiver) { var base = paragraphAbstract_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return paragraphAbstract_get(target, property, receiver || target); }
function paragraphAbstract_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = paragraphAbstract_getPrototypeOf(object); if (object === null) break; } return object; }
function paragraphAbstract_getPrototypeOf(o) { paragraphAbstract_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return paragraphAbstract_getPrototypeOf(o); }




















var paragraphAbstract_MAX_INDENT_LEVEL = 30;
var paragraphAbstract_mixin = mix([commentable, blotLock, focusable, selectable, dropAcceptor, draggable, colorable, indentable, executable, basic]);
var ParagraphAbstract = /*#__PURE__*/function (_mixin) {
  paragraphAbstract_inherits(ParagraphAbstract, _mixin);
  var _super = paragraphAbstract_createSuper(ParagraphAbstract);
  function ParagraphAbstract(domNode) {
    var _this;
    paragraphAbstract_classCallCheck(this, ParagraphAbstract);
    _this = _super.call(this, domNode);
    _this.isText = true;
    _this.scroll;
    _this.content;
    _this.token = false;
    _this.align;
    _this.color;
    _this.savedContent = '';
    _this.lastInColumn = false;
    _this.domNode.classList.add('paragraph');
    _this.allowUpdate = true;
    _this.isSeparableByClickApplicable = true;
    _this.addCanExecActions(paragraphAbstract_toConsumableArray(textLine.canExecActions));
    return _this;
  }
  paragraphAbstract_createClass(ParagraphAbstract, [{
    key: "textLineOnEnterKey",
    value: function textLineOnEnterKey(event) {
      var blotRange = this.scroll.selection.getRange({
        offsetBlot: this
      })[0];
      if (blotRange && blotRange.index === 0 && blotRange.length === 0) {
        event.preventDefault();
        // нажатие enter в начале блота, считаем что пользователь просто хочет опустить текущий блот ниже,
        // поэтому добавляем параграф перед текущим блотом
        this.container.addBlot('paragraph', {
          before: this.id
        });
        // вызываем обновление скролла вручную, т.к. range не меняется
        this.editor.plugins.selectionScroller.triggerSelectionChange();
        return true;
      } else {
        return paragraphAbstract_get(paragraphAbstract_getPrototypeOf(ParagraphAbstract.prototype), "textLineOnEnterKey", this).call(this, event);
      }
    }
  }, {
    key: "textLineAddNextBlot",
    value: function textLineAddNextBlot() {
      var initParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var blotType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'paragraph';
      // после нажатия enter на параграф-like блотах новым блотом будет параграф
      return paragraphAbstract_get(paragraphAbstract_getPrototypeOf(ParagraphAbstract.prototype), "textLineAddNextBlot", this).call(this, initParams, blotType);
    }
  }, {
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = paragraphAbstract_get(paragraphAbstract_getPrototypeOf(ParagraphAbstract.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      if (this._paragraphInitialized) {
        return;
      }
      this._paragraphInitialized = true;
      this.render();
    }
  }, {
    key: "render",
    value: function render() {
      paragraphAbstract_get(paragraphAbstract_getPrototypeOf(ParagraphAbstract.prototype), "render", this).call(this);
    }
  }, {
    key: "contextMenu",
    get: function get() {
      var menu = paragraphAbstract_get(paragraphAbstract_getPrototypeOf(ParagraphAbstract.prototype), "contextMenu", this);
      Object.assign(menu, textMenu(this.editor));
      return menu;
    }
  }, {
    key: "cloneSelf",
    value: function cloneSelf() {
      var map = this.store.createMap();
      parchment_default().query(this.map.get('type')).initMap(map, this.store, {
        color: this.map.get('color'),
        align: this.map.get('align'),
        delta: this.delta({
          forCopy: true
        })
      });
      return map.get('id');
    }
  }, {
    key: "exec",
    value: function exec(action) {
      return paragraphAbstract_get(paragraphAbstract_getPrototypeOf(ParagraphAbstract.prototype), "exec", this).call(this, action);
    }
  }], [{
    key: "initMap",
    value: function initMap(map, store) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      indentable.initMap(map, store, params);
      colorable.initMap(map, store, params);
      paragraphAbstract_get(paragraphAbstract_getPrototypeOf(ParagraphAbstract), "initMap", this).call(this, map, store, params);
    }
  }, {
    key: "formats",
    value: function formats(domNode) {
      var tagName = parchment_default().query(this.blotName).tagName;
      if (domNode.tagName === tagName) {
        return undefined;
      }
      return parchment_default().Format.formats.call(this, domNode);
    }
  }, {
    key: "convertBlots",
    value: function convertBlots(ids, store, _ref) {
      var _this2 = this;
      var params = _ref.params,
        container = _ref.container;
      if (!ids.length) {
        return null;
      }
      if (!params.initParams) {
        params.initParams = {};
      }
      var blots = ids.map(function (id) {
        var blot = container.editor.findById(id);
        if (!blot) {
          console.error('ParagraphAbstract.convertBlots could not find blot with id ' + id);
        }
        return blot;
      });
      if (!blots.every(function (blot) {
        return searchUp(blot, function (b) {
          return b.isCollapsibleContainer;
        });
      })) {
        blots = blots.filter(function (blot) {
          return !searchUp(blot, function (b) {
            return b.isCollapsibleContainer;
          });
        });
      }
      if (!blots.every(function (blot) {
        return blot.container === container;
      })) {
        if (container !== container.scroll) {
          container = container.container;
        }
      }
      var removeGroups = {};
      var convertedAll = true;
      blots.map(function (blot) {
        if (blot instanceof textLine || blot instanceof primary) {
          if (blot instanceof listItem) {
            if (!removeGroups[blot.parent.id]) removeGroups[blot.parent.id] = [];
            removeGroups[blot.parent.id].push(blot.id);
          } else {
            var options = {
              after: blot.id,
              delta: onConvertBlotPrepareDelta(blot.delta()),
              focus: {
                index: 0
              },
              color: params.color || blot.map.get('color'),
              align: params.align || blot.map.get('align')
            };
            options = paragraphAbstract_objectSpread(paragraphAbstract_objectSpread({}, options), params.initParams);
            _this2.setCommentThreads(blot, options);
            var keys = ['lineColor', 'borderColor'];
            keys.forEach(function (key) {
              if (blot.map.has(key)) {
                options[key] = blot.map.get(key);
              }
            });
            if (blot.hasChildrenContainer && !blot.isCollapsed()) {
              var childrenIds = blot.map.get('children').toArray();
              if (childrenIds.length) {
                var childIndex = container.getChildIndex(blot.id) + 1;
                var _iterator = paragraphAbstract_createForOfIteratorHelper(childrenIds),
                  _step;
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    var childId = _step.value;
                    container.moveChild(childId, childIndex);
                    childIndex++;
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              }
            }
            container.addBlot(params.type, options);
            container.removeChildById(blot.id);
          }
        }
        // некоторые блоты сами по себе не являеются текстовыми(syntax), но имеют внутри текст, они могут реализовать
        // метод getTextDelta, чтобы дать возможность получить этот текст при конвертации в текстовый параграф
        else if (blot.getTextDelta) {
          var delta = blot.getTextDelta(params);
          var focusIndex = params.focusIndex || 0;
          var blotParams = {
            after: blot.id,
            delta: delta,
            focus: {
              index: focusIndex
            }
          };
          blotParams = paragraphAbstract_objectSpread(paragraphAbstract_objectSpread({}, blotParams), params.initParams);
          _this2.setCommentThreads(blot, blotParams);
          container.addBlot(params.type, blotParams);
          container.removeChildById(blot.id);
        } else {
          convertedAll = false;
        }
      });
      Object.keys(removeGroups).map(function (listId) {
        var list = container.editor.findById(listId);
        list.splitList(list.getChildIndex(removeGroups[listId][0]), removeGroups[listId].length, {
          initParams: params.initParams
        }, params.type);
      });
      return convertedAll;
    }
  }, {
    key: "getMaxIndent",
    value: function getMaxIndent() {
      return paragraphAbstract_MAX_INDENT_LEVEL;
    }
  }]);
  return ParagraphAbstract;
}(paragraphAbstract_mixin(textLine));
ParagraphAbstract.defaultChild = textLine.defaultChild;
ParagraphAbstract.allowedChildren = textLine.allowedChildren;
abstractBlots.ParagraphAbstract = ParagraphAbstract;
/* harmony default export */ const paragraphAbstract = (ParagraphAbstract);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(21791);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/list/list.js
function list_slicedToArray(arr, i) { return list_arrayWithHoles(arr) || list_iterableToArrayLimit(arr, i) || list_unsupportedIterableToArray(arr, i) || list_nonIterableRest(); }
function list_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function list_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function list_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function list_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = list_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }






















function list_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { list_typeof = function _typeof(obj) { return typeof obj; }; } else { list_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return list_typeof(obj); }
function list_toConsumableArray(arr) { return list_arrayWithoutHoles(arr) || list_iterableToArray(arr) || list_unsupportedIterableToArray(arr) || list_nonIterableSpread(); }
function list_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function list_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return list_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return list_arrayLikeToArray(o, minLen); }
function list_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function list_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return list_arrayLikeToArray(arr); }
function list_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function list_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function list_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function list_createClass(Constructor, protoProps, staticProps) { if (protoProps) list_defineProperties(Constructor.prototype, protoProps); if (staticProps) list_defineProperties(Constructor, staticProps); return Constructor; }
function list_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) list_setPrototypeOf(subClass, superClass); }
function list_setPrototypeOf(o, p) { list_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return list_setPrototypeOf(o, p); }
function list_createSuper(Derived) { var hasNativeReflectConstruct = list_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = list_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = list_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return list_possibleConstructorReturn(this, result); }; }
function list_possibleConstructorReturn(self, call) { if (call && (list_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return list_assertThisInitialized(self); }
function list_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function list_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function list_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { list_get = Reflect.get; } else { list_get = function _get(target, property, receiver) { var base = list_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return list_get(target, property, receiver || target); }
function list_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = list_getPrototypeOf(object); if (object === null) break; } return object; }
function list_getPrototypeOf(o) { list_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return list_getPrototypeOf(o); }


















var UPDATE_CHILDREN_TIMEOUT = 10;
var List = /*#__PURE__*/function (_BasicMixin) {
  list_inherits(List, _BasicMixin);
  var _super = list_createSuper(List);
  function List(domNode) {
    var _this;
    list_classCallCheck(this, List);
    _this = _super.call(this, domNode);
    _this.isSelectable = false;
    _this.token = false;
    _this.emitter = new emitter();
    _this.emitter.setMaxListeners(999999);
    _this.domNode.classList.add('editor-list');
    _this.draggingElement;
    _this.allowUpdate = true;
    _this.numberTemplateClass = 'number-template-decimal-all';
    _this.domNode.classList.add(_this.numberTemplateClass);
    _this.updateChildrenDebounced = lodash_debounce_default()(_this.updateChildren, UPDATE_CHILDREN_TIMEOUT, {
      trailing: true
    });
    _this.isSeparableByClickApplicable = true;
    _this.addCanExecActions(list_toConsumableArray(container.canExecActions));
    return _this;
  }
  list_createClass(List, [{
    key: "splitList",
    value:
    /**
     * разбивает текущий список на два конвертируя выделенные элементы в другой блот, если передан параметр type
     * @param {int} index - индекс элемента где будет разбитие, элемент заменится на blot другого типа если передан параметр type
     * @param {int} length - количество элементов, которые нужно удалить, будут заменены на blot другого типа если передан параметр type
     * @param {Object} params - параметры разбиения
     * @param {Object} params.initParams - параметры передаваемые в initMap для блота, разбивающего списки
     * @param {String} type - тип блота, в который будут сконвертированны элементы списка от index до length
     */
    function splitList(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'paragraph';
      var returnValue = {};
      // нормализация аргументов
      if (list_typeof(length) === 'object') {
        params = length;
        length = 1;
      }
      var childrenIds = Array.from(this.map.get('children'));
      // получаем IDs элементов второго списка и элементов для конвертации
      var blotIds = childrenIds.slice(index, index + length);
      var newListChildrenIds = childrenIds.slice(index + length);
      var deleteChildrenIds = [].concat(list_toConsumableArray(blotIds), list_toConsumableArray(newListChildrenIds));
      var lastId = this.id;
      // если передан тип, конвертируем элементы списка
      if (type) {
        var _iterator = list_createForOfIteratorHelper(blotIds),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var id = _step.value;
            var listItem = this.editor.findById(id);
            if (listItem !== null) {
              var blotParams = Object.assign({}, {
                after: lastId,
                color: listItem.map.get('color'),
                indent: listItem.map.get('indent'),
                delta: listItem.delta()
              }, params.initParams);
              if (blotIds.indexOf(id) === blotIds.length - 1) {
                blotParams.focus = {
                  index: 0
                };
              }
              commentable(Object).setCommentThreads(listItem, blotParams);
              lastId = this.parent.addBlot(type, blotParams).id;
              returnValue.id = lastId;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      if (deleteChildrenIds.length === this.children.length) {
        this.container.removeChildById(this.id);
      } else {
        var _iterator2 = list_createForOfIteratorHelper(deleteChildrenIds),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _id = _step2.value;
            this.removeChildById(_id);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      if (newListChildrenIds.length) {
        this.parent.addBlot('list', {
          after: lastId,
          children: newListChildrenIds,
          bulletTemplate: this.getBulletTemplate()
        });
      }
      return returnValue;
    }

    // Этот метод разбивает список новым блотом, не удаляя элементы списка, не конвертируя их
    // Возвращает ID блока, которым был разделен список
  }, {
    key: "splitWithBlot",
    value: function splitWithBlot(index) {
      var blotType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'paragraph';
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var newListChildren = [];
      var i = 0;
      var _iterator3 = list_createForOfIteratorHelper(this.map.get('children')),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _childId = _step3.value;
          if (i > index) {
            newListChildren.push(_childId);
          }
          i++;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      for (var _i = 0, _newListChildren = newListChildren; _i < _newListChildren.length; _i++) {
        var childId = _newListChildren[_i];
        this.removeChildById(childId);
      }
      params.after = this.id;
      var _this$parent$addBlot = this.parent.addBlot(blotType, params),
        id = _this$parent$addBlot.id;
      if (newListChildren.length) {
        this.parent.addBlot('list', {
          after: id,
          children: newListChildren,
          bulletTemplate: this.getBulletTemplate()
        });
      }
      return {
        id: id
      };
    }
  }, {
    key: "containerConvertBlots",
    value: function containerConvertBlots(blots, params) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var ToBlot = parchment_default().query(params.type);
      // TODO сделать чтоб разбивалось только при добавлении embeddable блота
      // для этого надо сделать установку для класса блота, что он embeddable
      if (ToBlot !== listItem && Object.getPrototypeOf(ToBlot) !== listItem && ToBlot !== List && !(0,util/* getAllPrototypes */.yG)(ToBlot).includes(paragraphAbstract) && !ToBlot.isTextBlot && !ToBlot.hasInnerTextLine && !ToBlot.blotName.includes('toggle') && ToBlot.blotName !== 'step' && blots.length === 1) {
        if (ToBlot.getConvertParams) {
          params = ToBlot.getConvertParams(blots[0], params);
        }
        var _this$splitWithBlot = this.splitWithBlot(this.getChildIndex(blots[0].id), params.type, params),
          id = _this$splitWithBlot.id;
        if (params.removeOriginal) {
          blots[0].remove();
        }
        return {
          processed: true,
          addedIds: [id]
        };
      } else {
        return list_get(list_getPrototypeOf(List.prototype), "containerConvertBlots", this).call(this, blots, params, options);
      }
    }
  }, {
    key: "moveChild",
    value: function moveChild(id, index) {
      var _this2 = this;
      var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var blot;
      if (id instanceof Object) {
        blot = id;
        id = blot.id;
      } else {
        blot = this.editor.findById(id);
      }
      var relBlot = context.relBlot;
      var insertId;
      // проверяем является ли пермещаемый блот элементом списка и если нет то может ли он быть сконвертирован в элемент списка
      if (!(blot instanceof listItem)) {
        if (!(blot instanceof textLine)) {
          // не можем сконвертировать в ListItem
          var container = this.container;
          if (index === 0) {
            // вставка перед списком, просто перемещаем блот в контейнер перед списком
            container.moveChild(blot, container.getChildIndex(this.id), context);
          } else if (index === this.children.length) {
            // вставка после списка, просто перемещаем блот в контейнер после списка
            container.moveChild(blot, container.getChildIndex(this.id) + 1, context);
          } else {
            // вставка в середине списка
            // разбиваем список и вставляем элемент в контейнер после старого списка
            this.splitList(index, 0);
            container.moveChild(blot, container.getChildIndex(this.id) + 1, context);
          }
          return;
        }
        var delta = blot.delta();
        var blotParams = {
          delta: delta,
          index: index
        };
        var blotType = 'listItemBullet';
        if (relBlot) {
          // если задан блот относительно которого происходит перемещение(до или после)
          // то копируем его тип и сдвиг
          blotParams.indent = relBlot.getIndent();
          blotType = relBlot.getBlotName();
        }
        this.store.transaction(function () {
          blot.remove();
          var _this2$addBlot = _this2.addBlot(blotType, blotParams);
          insertId = _this2$addBlot.id;
        });
      } else {
        if (relBlot) {
          // обновляем сдвиг чтобы соответствовал элементу списка если skipListIndent не установлен
          // если элемент имет сабсписки, устанавливаем skipListIndent в true и добавляем в контекст разницу сдвига между родительским
          // и relBlot'ом, для дальнейшего расчета сдвига сабсписков
          if (!context.skipListIndent) {
            if (blot.getSubItems && blot.getSubItems().length) {
              context.skipListIndent = true;
              context.indentDiff = relBlot.getIndent() - blot.getIndent();
            }
            blot.setIndent(relBlot.getIndent());
          } else {
            if (context.hasOwnProperty('indentDiff')) {
              blot.setIndent(blot.getIndent() + context.indentDiff);
            }
          }
        }
        insertId = list_get(list_getPrototypeOf(List.prototype), "moveChild", this).call(this, id, index);
      }
      return insertId;
    }
  }, {
    key: "optimize",
    value: function optimize(context) {
      var _this3 = this;
      list_get(list_getPrototypeOf(List.prototype), "optimize", this).call(this, context);
      if (this.next instanceof List && !this._mergingBottomList && !this.editor.plugins.undoManager.isUndoingOrRedoing() &&
      // если текущий список пустой то не надо пытаться прикрепить к нему нижний список
      this.children.length &&
      // если следующий список пустой то не надо пытаться прикрепить его к текущему
      this.next.children.length &&
      // следующий список должен быть уже приаттачен
      this.next.isAttached()) {
        var allow = false;
        if (context.mutations && Array.isArray(context.mutations) && context.source !== 'remote') {
          var _iterator4 = list_createForOfIteratorHelper(context.mutations),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var mutation = _step4.value;
              if (mutation.type === 'childList' && mutation.previousSibling === this.domNode && mutation.removedNodes.length) {
                console.log('Mutation', mutation, context, 'current node', this.domNode, 'next node', this.next.domNode.outerHTML, 'next blot', Object.assign({}, this.next));
                allow = true;
                break;
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
        if (allow) {
          try {
            var _this$scroll$selectio = this.scroll.selection.getRange(),
              _this$scroll$selectio2 = list_slicedToArray(_this$scroll$selectio, 1),
              range = _this$scroll$selectio2[0];
            this._mergingBottomList = true;
            this.scroll.execInBatch(function () {
              _this3.editor.store.transaction(function () {
                var moveIds = _this3.next.children.map(function (listItem) {
                  return listItem.id;
                });
                var index = _this3.getChildIndex(_this3.children.tail.id) + 1;
                var _iterator5 = list_createForOfIteratorHelper(moveIds),
                  _step5;
                try {
                  for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                    var id = _step5.value;
                    _this3.next.removeChildById(id);
                    index = Math.min(index, _this3.containerChildren.length);
                    _this3.containerChildren.insert(index, [id]);
                    index++;
                  }
                } catch (err) {
                  _iterator5.e(err);
                } finally {
                  _iterator5.f();
                }
              });
            });
            if (range) {
              this.scroll.selection.setRange(range);
            }
          } finally {
            this._mergingBottomList = false;
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      list_get(list_getPrototypeOf(List.prototype), "render", this).call(this);
      var numberTemplateClass = 'number-template-' + this.map.get('number-list-template');
      if (this.numberTemplateClass !== numberTemplateClass) {
        this.domNode.classList.remove(this.numberTemplateClass);
        this.numberTemplateClass = numberTemplateClass;
        this.domNode.classList.add(this.numberTemplateClass);
      }
      // если в опциях список не сворачиваемый, не выполняем эти функции, чтоб не нагружать редактор
      if (this.editor.blotsConfig.hasOwnProperty('list') && this.editor.blotsConfig.list.collapsible === true) {
        if (!this.editor.ready) {
          this.updateChildren();
        } else {
          this.updateChildrenDebounced();
        }
        // обновляем blockMenu если оно находится в текущем списке
        var blot = this.editor.plugins.blockMenu ? this.editor.plugins.blockMenu.anchorBlot : null;
        if (blot) {
          var blotIsChildOfThis = this.getChildIndex(blot.id) !== -1;
          if (blotIsChildOfThis) {
            this.editor.plugins.blockMenu.updateBlockMenu(true);
          }
        }
      }
    }
  }, {
    key: "getBulletTemplate",
    value: function getBulletTemplate() {
      return this.map.get('bullet-list-template');
    }
  }, {
    key: "setBulletTemplate",
    value: function setBulletTemplate(template) {
      this.map.set('bullet-list-template', template);
      this.children.forEach(function (child) {
        child.render();
      });
    }
  }, {
    key: "updateChildren",
    value: function updateChildren() {
      var cnt = {
        0: 1
      }; // counters for markdown
      var prevIndent = 0;
      this.children.forEach(function (blot) {
        var _blot$map;
        var indent = ((_blot$map = blot.map) === null || _blot$map === void 0 ? void 0 : _blot$map.get('indent')) || 0;
        if (indent === 0) {
          Object.keys(cnt).forEach(function (key) {
            if (key > 0) delete cnt[key];
          });
        }
        if (!cnt.hasOwnProperty(indent)) {
          cnt[indent] = 1;
        }
        blot.updateListItemPropsIfNeed(cnt[indent]);
        cnt[indent]++;
        prevIndent = indent;
      });
    }
  }, {
    key: "hasCollapsedListItems",
    value: function hasCollapsedListItems() {
      return Boolean(this.children.map(function (item) {
        return item;
      }).filter(function (item) {
        return item.isCollapsed();
      }).length);
    }
  }, {
    key: "hasExpandedListItems",
    value: function hasExpandedListItems() {
      return Boolean(this.children.map(function (item) {
        return item;
      }).filter(function (item) {
        return item.getSubItems().length && !item.isCollapsed();
      }).length);
    }
  }, {
    key: "onExpandAll",
    value: function onExpandAll() {
      this.children.forEach(function (item) {
        if (item.isCollapsed()) {
          item.map.set('collapsed', false);
        }
      });
    }
  }, {
    key: "onCollapseAll",
    value: function onCollapseAll() {
      this.children.forEach(function (item) {
        if (item.getSubItems().length && !item.isCollapsed()) {
          item.map.set('collapsed', true);
        }
      });
    }
  }, {
    key: "update",
    value: function update() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = list_get(list_getPrototypeOf(List.prototype), "update", this)).call.apply(_get2, [this].concat(args));
    }
  }, {
    key: "toHTML",
    value: function toHTML() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.domNode.outerHTML;
    }
  }, {
    key: "getMarkdown",
    value: function getMarkdown() {
      var markdown = '';
      this.updateChildren();
      this.children.forEach(function (child) {
        markdown += child.getMarkdown();
      });
      return markdown;
    }
  }], [{
    key: "normalizeParams",
    value: function normalizeParams(params) {
      params = Object.assign({}, params);
      if (Array.isArray(params.items)) {
        params.items = params.items.map(function (item) {
          if (typeof item === 'string') {
            return {
              type: item
            };
          }
          return item;
        });
      }
      return params;
    }
  }, {
    key: "initMap",
    value: function initMap(map, store) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      list_get(list_getPrototypeOf(List), "initMap", this).call(this, map, store, params);
      params = this.normalizeParams(params);
      map.set('type', 'list');
      if (params.numberTemplate) {
        map.set('number-list-template', params.numberTemplate);
      } else {
        map.set('number-list-template', 'decimal-all');
      }
      if (params.bulletTemplate) {
        map.set('bullet-list-template', params.bulletTemplate);
      } else {
        map.set('bullet-list-template', ['circle']);
      }
      if (Array.isArray(params.items)) {
        var _iterator6 = list_createForOfIteratorHelper(params.items),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var item = _step6.value;
            var itemMap = store.createMap();
            parchment_default().query(item.type).initMap(itemMap, store, item.params);
            map.get('children').push([itemMap.get('id')]);
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
    }
  }, {
    key: "convertBlots",
    value: function convertBlots(ids, store, _ref) {
      var _this4 = this;
      var params = _ref.params,
        container = _ref.container;
      if (!ids.length) {
        return null;
      }
      params = this.normalizeParams(params);
      var result = {
        removeBlots: [],
        insertBlots: []
      };

      // проверяем все ли переданные блоки могут быть сконвертированы в элементы списка, сконвертированы могут быть только наследуемые
      // от TextLine
      var blots = ids.map(function (id) {
        return container.editor.findById(id);
      });
      if (!blots.every(function (blot) {
        return searchUp(blot, function (b) {
          return b.isCollapsibleContainer;
        });
      })) {
        blots = blots.filter(function (blot) {
          return !searchUp(blot, function (b) {
            return b.isCollapsibleContainer;
          });
        });
      }
      var _iterator7 = list_createForOfIteratorHelper(blots),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var blot = _step7.value;
          if (!blot) {
            throw new Error('some of the blots passed in List#convertBlots not found');
          }
          if (!(blot instanceof textLine) && !(blot instanceof primary) && blot.constructor.hasInnerTextLine !== false) {
            return null;
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      result.removeBlots = blots.map(function (blot) {
        return blot.id;
      });
      var itemsParams = params.items;
      while (itemsParams.length < ids.length) {
        var item = Object.assign({}, itemsParams[itemsParams.length - 1]);
        itemsParams.push(item);
      }
      var createList = function createList(itemsParams) {
        var listMap = store.createMap();
        // оборачиваем элементы в список
        var listParams = {
          items: itemsParams
        };
        if (params.numberTemplate) listParams.numberTemplate = params.numberTemplate;
        if (params.bulletTemplate) listParams.bulletTemplate = params.bulletTemplate;
        _this4.initMap(listMap, store, listParams);
        return {
          id: listMap.get('id')
        };
      };
      var itemsInitParams = [];
      var index = 1;
      var _iterator8 = list_createForOfIteratorHelper(blots),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _blot = _step8.value;
          var itemParams = itemsParams.shift();
          var itemType = itemParams.type;
          var itemInitParams = itemParams.params || {};
          if (!itemInitParams.delta) {
            itemInitParams.delta = onConvertBlotPrepareDelta(_blot.delta());
          }
          if (_blot.map.get('indent')) {
            itemInitParams.indent = _blot.map.get('indent');
          }
          if (_blot.map.get('color')) {
            itemInitParams.color = _blot.map.get('color');
          }
          commentable(Object).setCommentThreads(_blot, itemInitParams);
          itemsInitParams.push({
            type: itemType,
            params: itemInitParams
          });
          if (_blot.hasChildrenContainer && !_blot.isCollapsed() && _blot.map.get('children').toArray().length) {
            var _result$insertBlots;
            result.insertBlots.push(createList(itemsInitParams).id);
            (_result$insertBlots = result.insertBlots).push.apply(_result$insertBlots, list_toConsumableArray(_blot.map.get('children').toArray()));
            itemsInitParams = [];
          } else if (index === blots.length) {
            if (!(container instanceof List)) {
              result.insertBlots.push(createList(itemsInitParams).id);
            } else {
              if (params.numberTemplate) container.map.set('number-list-template', params.numberTemplate);
              if (params.bulletTemplate) container.map.set('bullet-list-template', params.bulletTemplate);
              var _iterator9 = list_createForOfIteratorHelper(itemsInitParams),
                _step9;
              try {
                for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                  var listItemParams = _step9.value;
                  var itemMap = store.createMap();
                  parchment_default().query(listItemParams.type).initMap(itemMap, store, listItemParams.params);
                  result.insertBlots.push(itemMap.get('id'));
                }
              } catch (err) {
                _iterator9.e(err);
              } finally {
                _iterator9.f();
              }
            }
          }
          index++;
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      return result;
    }
  }]);
  return List;
}(basic(dropAcceptor(executable(container((parchment_default()).Container)))));
List.blotName = 'list';
List.scope = (parchment_default()).Scope.BLOCK_BLOT;
List.tagName = ['UL'];
List.defaultChild = null;
List.allowedChildren = [listItemBullet, listItemNumber, listItemCheckbox];
/* harmony default export */ const list_list = (List);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/primary.js
function primary_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { primary_typeof = function _typeof(obj) { return typeof obj; }; } else { primary_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return primary_typeof(obj); }
function primary_slicedToArray(arr, i) { return primary_arrayWithHoles(arr) || primary_iterableToArrayLimit(arr, i) || primary_unsupportedIterableToArray(arr, i) || primary_nonIterableRest(); }
function primary_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function primary_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function primary_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function primary_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = primary_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function primary_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return primary_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return primary_arrayLikeToArray(o, minLen); }
function primary_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



















function primary_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function primary_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function primary_createClass(Constructor, protoProps, staticProps) { if (protoProps) primary_defineProperties(Constructor.prototype, protoProps); if (staticProps) primary_defineProperties(Constructor, staticProps); return Constructor; }
function primary_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { primary_get = Reflect.get; } else { primary_get = function _get(target, property, receiver) { var base = primary_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return primary_get(target, property, receiver || target); }
function primary_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = primary_getPrototypeOf(object); if (object === null) break; } return object; }
function primary_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) primary_setPrototypeOf(subClass, superClass); }
function primary_setPrototypeOf(o, p) { primary_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return primary_setPrototypeOf(o, p); }
function primary_createSuper(Derived) { var hasNativeReflectConstruct = primary_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = primary_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = primary_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return primary_possibleConstructorReturn(this, result); }; }
function primary_possibleConstructorReturn(self, call) { if (call && (primary_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return primary_assertThisInitialized(self); }
function primary_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function primary_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function primary_getPrototypeOf(o) { primary_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return primary_getPrototypeOf(o); }
function primary_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var Primary = /*#__PURE__*/function (_Parchment$Block) {
  primary_inherits(Primary, _Parchment$Block);
  var _super = primary_createSuper(Primary);
  function Primary(domNode) {
    var _this;
    primary_classCallCheck(this, Primary);
    _this = _super.call(this, domNode);
    primary_defineProperty(primary_assertThisInitialized(_this), "mapObserver", function (event) {
      _this.render();
    });
    _this.domNode.classList.add('primary-blot');
    return _this;
  }
  primary_createClass(Primary, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = primary_get(primary_getPrototypeOf(Primary.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      this.store.observe(this.map, this.mapObserver);
      this.render();
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = primary_get(primary_getPrototypeOf(Primary.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      this.store.unobserve(this.map, this.mapObserver);
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.hasTextLine ? this.getTextBlot().isEmpty() : false;
    }
  }, {
    key: "optimize",
    value: function optimize() {}
  }, {
    key: "update",
    value: function update() {}
  }, {
    key: "exec",
    value: function exec(action) {
      var processed = false;
      var children = this.getChildrenForAction();
      var _iterator = primary_createForOfIteratorHelper(children),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var blot = _step.value;
          // если хотя бы один блот из дочерних вернул true, считаем action выполненным
          if (blot.handleAction(action)) {
            processed = true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return processed;
    }
  }, {
    key: "allowInlinePaste",
    get: function get() {
      return true;
    }
  }, {
    key: "getChildrenForAction",
    value: function getChildrenForAction() {
      var _this2 = this;
      var children = this.children.map(function (blot) {
        return blot;
      });
      return children.filter(function (blot) {
        var _this2$scroll$selecti = _this2.scroll.selection.getRange({
            offsetBlot: blot
          }),
          _this2$scroll$selecti2 = primary_slicedToArray(_this2$scroll$selecti, 1),
          blotRange = _this2$scroll$selecti2[0];
        return blotRange && blotRange.index >= 0 && blotRange.length >= 0;
      });
    }
  }, {
    key: "getTextBlot",
    value: function getTextBlot() {
      return this.hasTextLine ? this.children.head : null;
    }
  }, {
    key: "delta",
    value: function delta() {
      var _this$getTextBlot;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (_this$getTextBlot = this.getTextBlot()) === null || _this$getTextBlot === void 0 ? void 0 : _this$getTextBlot.delta(options);
    }
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      var type = this.constructor.blotName || null;
      var initParams = {};
      var textBlot = this.getTextBlot();
      if (textBlot) {
        var selectedBlots = this.scroll.selectedBlocks;
        var delta = !blotRange || blotRange.length < 0 || selectedBlots.indexOf(this) !== selectedBlots.length - 1 && blotRange.length < 1 ? textBlot.getContents(0, textBlot.length(), {
          forCopy: true
        }).insert('\n') : textBlot.getContents(blotRange.index, blotRange.length, {
          forCopy: true
        }).insert('\n');
        if (delta.ops[delta.ops.length - 1].insert.endsWith('\n\n')) {
          delta = delta.slice(0, delta.length() - 1);
        }
        initParams.delta = delta;
      }
      return {
        type: type,
        initParams: initParams
      };
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _get4;
      (_get4 = primary_get(primary_getPrototypeOf(Primary.prototype), "render", this)) === null || _get4 === void 0 ? void 0 : _get4.call(this);
      var content = this.renderContent();
      (0,preact_module/* render */.sY)(content, this.domNode);
    }
  }, {
    key: "cloneSelf",
    value: function cloneSelf() {
      var _this$getCloneParams;
      var cloneParams = ((_this$getCloneParams = this.getCloneParams) === null || _this$getCloneParams === void 0 ? void 0 : _this$getCloneParams.call(this)) || {};
      cloneParams.delta = this.delta({
        forCopy: true
      });
      var map = this.store.createMap();
      parchment_default().query(this.map.get('type')).initMap(map, this.store, cloneParams);
      return map.get('id');
    }
  }], [{
    key: "convertBlots",
    value: function convertBlots(ids, store, _ref) {
      var params = _ref.params,
        container = _ref.container;
      if (!ids.length) {
        return null;
      }
      var blots = ids.map(function (id) {
        var blot = container.editor.findById(id);
        if (!blot) {
          console.error('Primary.convertBlots could not find blot with id ' + id);
        }
        return blot;
      });
      if (!blots.every(function (blot) {
        return searchUp(blot, function (b) {
          return b.isCollapsibleContainer;
        });
      })) {
        blots = blots.filter(function (blot) {
          return !searchUp(blot, function (b) {
            return b.isCollapsibleContainer;
          });
        });
      }
      if (!blots.every(function (blot) {
        return blot.container === container;
      }) && container !== container.scroll) {
        container = container.container;
      }
      var convertedAll = true;
      var removeGroups = {};
      blots.map(function (blot) {
        if (blot instanceof textLine || blot instanceof Primary) {
          if (blot.container instanceof list_list) {
            if (!removeGroups[blot.parent.id]) removeGroups[blot.parent.id] = [];
            removeGroups[blot.parent.id].push(blot.id);
          } else {
            var keys = ['color', 'align', 'indent', 'lineColor', 'borderColor'];
            var options = keys.reduce(function (options, key) {
              if (params.hasOwnProperty(key)) {
                options[key] = params[key];
              } else if (blot.map.has(key)) {
                options[key] = blot.map.get(key);
              }
              return options;
            }, {
              after: blot.id,
              delta: onConvertBlotPrepareDelta(blot.delta()),
              focus: {
                index: 0
              }
            });
            if (blot.hasChildrenContainer && !blot.isCollapsed()) {
              var childrenIds = blot.map.get('children').toArray();
              if (childrenIds.length) {
                var childIndex = container.getChildIndex(blot.id) + 1;
                var _iterator2 = primary_createForOfIteratorHelper(childrenIds),
                  _step2;
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    var childId = _step2.value;
                    container.moveChild(childId, childIndex);
                    childIndex++;
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
              }
            }
            container.addBlot(params.type, options);
            container.removeChildById(blot.id);
          }
        } else if (blot.getTextDelta) {
          var delta = blot.getTextDelta(params);
          var focusIndex = params.focusIndex || 0;
          var blotParams = {
            after: blot.id,
            delta: delta,
            focus: {
              index: focusIndex
            }
          };
          container.addBlot(params.type, blotParams);
          container.removeChildById(blot.id);
        } else {
          convertedAll = false;
        }
      });
      Object.keys(removeGroups).map(function (listId) {
        var list = container.editor.findById(listId);
        list.splitList(list.getChildIndex(removeGroups[listId][0]), removeGroups[listId].length, {}, params.type);
      });
      return convertedAll;
    }
  }]);
  return Primary;
}((parchment_default()).Block);
Primary.defaultChild = null;
/* harmony default export */ const primary = (Primary);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/mixins/embeddable.js
function embeddable_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { embeddable_typeof = function _typeof(obj) { return typeof obj; }; } else { embeddable_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return embeddable_typeof(obj); }












function embeddable_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function embeddable_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function embeddable_createClass(Constructor, protoProps, staticProps) { if (protoProps) embeddable_defineProperties(Constructor.prototype, protoProps); if (staticProps) embeddable_defineProperties(Constructor, staticProps); return Constructor; }
function embeddable_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { embeddable_get = Reflect.get; } else { embeddable_get = function _get(target, property, receiver) { var base = embeddable_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return embeddable_get(target, property, receiver || target); }
function embeddable_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = embeddable_getPrototypeOf(object); if (object === null) break; } return object; }
function embeddable_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) embeddable_setPrototypeOf(subClass, superClass); }
function embeddable_setPrototypeOf(o, p) { embeddable_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return embeddable_setPrototypeOf(o, p); }
function embeddable_createSuper(Derived) { var hasNativeReflectConstruct = embeddable_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = embeddable_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = embeddable_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return embeddable_possibleConstructorReturn(this, result); }; }
function embeddable_possibleConstructorReturn(self, call) { if (call && (embeddable_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return embeddable_assertThisInitialized(self); }
function embeddable_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function embeddable_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function embeddable_getPrototypeOf(o) { embeddable_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return embeddable_getPrototypeOf(o); }
function embeddable_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var embeddable_isEnterKey = (0,lib/* default */.ZP)('enter');
var embeddable_isShiftEnterKey = (0,lib/* default */.ZP)('shift+enter');
var CARET_TRAP_CLASS = 'caret-trap';
/**
 * если данный миксин пременен на блот это означет что блот сам следит за своим фокусом
 * его полезно использовать на блотах которые частично или полностью не содержат текст
 * таких как изображения или таблицы
 */

var defaultCaretTrapContentEditable;
function setDefaultCaretTrapContentEditable(value) {
  defaultCaretTrapContentEditable = value;
}
var Embeddable = function Embeddable(superclass) {
  return /*#__PURE__*/function (_superclass) {
    embeddable_inherits(_class2, _superclass);
    var _super = embeddable_createSuper(_class2);
    function _class2() {
      var _this;
      embeddable_classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      embeddable_defineProperty(embeddable_assertThisInitialized(_this), "onEmbeddableMouseDown", function (event) {
        var focus = true;
        if (_this.embeddableFocusableNode) {
          if (!(0,dom/* isNodeEqualOrContain */.nN)(_this.embeddableFocusableNode, event.target)) {
            focus = false;
          }
        }
        if (focus) {
          _this.embeddableFocus(event);
          if (!_this.props.focused) {
            event.preventDefault();
          }
        } else {
          _this.selection.clearSelection();
          _this.scroll.setSelectedBlots([]);
          event.preventDefault();
        }
      });
      _this.isEmbeddable = true;
      // DOM элемент, если указан то фокус при клике на блот будет выполнятся только при клике на этот элемент
      _this.embeddableFocusableNode = null;
      return _this;
    }
    embeddable_createClass(_class2, [{
      key: "attach",
      value: function attach() {
        embeddable_get(embeddable_getPrototypeOf(_class2.prototype), "attach", this).call(this);
        if (this.editor && this.editor.mode === this.editor.constructor.MODE_EDIT) {
          this.domNode.addEventListener('mousedown', this.onEmbeddableMouseDown, false);
        }
      }
    }, {
      key: "detach",
      value: function detach() {
        embeddable_get(embeddable_getPrototypeOf(_class2.prototype), "detach", this).call(this);
        this.domNode.removeEventListener('mousedown', this.onEmbeddableMouseDown, false);
      }
    }, {
      key: "handleKeyDown",
      value: function handleKeyDown(event) {
        if (embeddable_get(embeddable_getPrototypeOf(_class2.prototype), "handleKeyDown", this)) {
          if (embeddable_get(embeddable_getPrototypeOf(_class2.prototype), "handleKeyDown", this).call(this, event)) {
            return;
          }
        }
        var isSingleSelected = this.scroll && this.scroll.selectedBlocks && this.scroll.selectedBlocks.length === 1 && this.scroll.selectedBlocks[0] === this;
        var isSymOrShiftEnterKey = !isModKeyPressed(event) && event.key && event.key.length === 1 || embeddable_isShiftEnterKey(event);
        var preventDefault = embeddable_isEnterKey(event) || isSymOrShiftEnterKey && isSingleSelected;
        var isNotFirst = this.scroll && this.scroll.selectedBlocks && this.scroll.selectedBlocks[0] !== this;
        var isLast = this.scroll && this.scroll.selectedBlocks && this.scroll.selectedBlocks[this.scroll.selectedBlocks.length - 1] === this;
        if (preventDefault) {
          event.preventDefault();
        }
        if (isSymOrShiftEnterKey) {
          if (isSingleSelected || isNotFirst && !isLast) {
            return;
          } else if (isLast) {
            this.remove();
          } else {
            var deleteAction = new DeleteAction(DeleteAction.type, {}, this.editor);
            deleteAction.dontRestoreSelection();
            deleteAction.run({
              processingBlots: this.scroll.selectedBlocks
            });
          }
        } else if (embeddable_isEnterKey(event)) {
          this.container.addBlot('paragraph', {
            after: this.id,
            focus: {
              index: 0
            }
          });
        }
      }
    }, {
      key: "exec",
      value: function exec(action) {
        if (embeddable_get(embeddable_getPrototypeOf(_class2.prototype), "exec", this) && embeddable_get(embeddable_getPrototypeOf(_class2.prototype), "exec", this).call(this, action)) {
          return;
        }
        var processed = false;
        if (action.type === 'delete-blot') {
          processed = true;
          this.remove();
        }
        return processed;
      }
    }, {
      key: "embeddableFocus",
      value: function embeddableFocus() {
        if (this.scroll.selectedBlocks.length === 1 && this.scroll.selectedBlocks[0] === this) {
          // недокументированная опция, пока используется только на ios
          // т.к. если кликать повторно на фокусированный hline, то с него уходит фокус и с документа вообще уходит
          // любое выделение
          if (this.editor.options.embeddableSetCaretInTrapIfFocusedAgain) {
            this.setCaretInTrap();
          }
          return;
        }
        // нужно удалить любое выделение которое находится за пределами данного блота
        var range = this.selection.getRange();
        if (range && range[1]) {
          var nativeRange = range[1].native;
          if (nativeRange.commonAncestorContainer !== this.getWrapper().domNode && !this.getWrapper().domNode.contains(nativeRange.commonAncestorContainer)) {
            this.selection.clearSelection();
          }
        }
        this.scroll.setSelectedBlots([this]);
      }
    }, {
      key: "setCaretInTrap",
      value: function setCaretInTrap() {
        var nRange = new Range();
        var caretTrap = this.getWrapper().domNode.querySelector('.' + CARET_TRAP_CLASS);
        if (!caretTrap) {
          return false;
        }
        var caretTrapText = caretTrap.childNodes[0];
        nRange.setStart(caretTrapText, 0);
        nRange.setEnd(caretTrapText, 0);
        getSelection().removeAllRanges();
        getSelection().addRange(nRange);
        return true;
      }
    }, {
      key: "getCaretTrap",
      value: function getCaretTrap() {
        return this.getWrapper().domNode.querySelector('.' + CARET_TRAP_CLASS);
      }
    }, {
      key: "onFocusableFocus",
      value: function onFocusableFocus() {
        if (embeddable_get(embeddable_getPrototypeOf(_class2.prototype), "onFocusableFocus", this)) {
          embeddable_get(embeddable_getPrototypeOf(_class2.prototype), "onFocusableFocus", this).call(this);
        }
        var range = this.scroll.selection.getRange()[0];
        if (!range || range.length === 0) {
          this.setCaretInTrap();
        }
      }
    }, {
      key: "position",
      value: function position(index, inclusive) {
        var returnData = null;
        if (index !== 0) {} else {
          var trap = this.getCaretTrap();
          if (trap) {
            returnData = [trap.firstChild, 0];
          }
        }
        if (!returnData) {
          returnData = embeddable_get(embeddable_getPrototypeOf(_class2.prototype), "position", this).call(this, index, inclusive);
        }
        return returnData;
      }
    }, {
      key: "render",
      value: function render() {
        if (embeddable_get(embeddable_getPrototypeOf(_class2.prototype), "render", this)) {
          embeddable_get(embeddable_getPrototypeOf(_class2.prototype), "render", this).call(this);
        }
      }
    }, {
      key: "beforeCopyContent",
      value: function beforeCopyContent() {
        var blot = this.getWrapper();
        var isLastInContainer = blot.container.children.tail === blot;
        var blotLength = 1;
        if (!isLastInContainer) {
          if (blot.next !== null) {
            blotLength = blot.next.offset(this.scroll) - blot.offset(this.scroll);
          }
        } else {
          var containerLength = blot.container.length();
          blotLength = containerLength - blot.offset(blot.container);
        }
        this.scroll.selection.setRange({
          index: this.offset(this.scroll),
          length: blotLength
        });
      }
    }], [{
      key: "addCaretTrap",
      value: function addCaretTrap(editor, node, contenteditable) {
        if (editor.mode === editor.constructor.MODE_EXPORT) {
          return;
        }
        var caretTrap = document.createElement('div');
        caretTrap.innerHTML = '&nbsp;';
        caretTrap.classList.add(CARET_TRAP_CLASS);
        if (typeof contenteditable === 'undefined') {
          contenteditable = defaultCaretTrapContentEditable;
        }
        if (contenteditable === true) {
          caretTrap.setAttribute('contenteditable', true);
        } else if (contenteditable === false) {
          caretTrap.setAttribute('contenteditable', false);
        }
        var container = node.querySelector('.caret-trap-container');
        if (container) {
          container.appendChild(caretTrap);
        } else {
          node.insertBefore(caretTrap, node.firstChild);
        }
      }
    }]);
    return _class2;
  }(superclass);
};
/* harmony default export */ const embeddable = (Embeddable);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/hLine.js
function hLine_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { hLine_typeof = function _typeof(obj) { return typeof obj; }; } else { hLine_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return hLine_typeof(obj); }













function hLine_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function hLine_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function hLine_createClass(Constructor, protoProps, staticProps) { if (protoProps) hLine_defineProperties(Constructor.prototype, protoProps); if (staticProps) hLine_defineProperties(Constructor, staticProps); return Constructor; }
function hLine_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) hLine_setPrototypeOf(subClass, superClass); }
function hLine_setPrototypeOf(o, p) { hLine_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return hLine_setPrototypeOf(o, p); }
function hLine_createSuper(Derived) { var hasNativeReflectConstruct = hLine_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = hLine_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = hLine_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return hLine_possibleConstructorReturn(this, result); }; }
function hLine_possibleConstructorReturn(self, call) { if (call && (hLine_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return hLine_assertThisInitialized(self); }
function hLine_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function hLine_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function hLine_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { hLine_get = Reflect.get; } else { hLine_get = function _get(target, property, receiver) { var base = hLine_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return hLine_get(target, property, receiver || target); }
function hLine_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = hLine_getPrototypeOf(object); if (object === null) break; } return object; }
function hLine_getPrototypeOf(o) { hLine_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return hLine_getPrototypeOf(o); }
function hLine_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

















var LINE_COLOR = vars.nimbusWhite;
var hLine_mixin = mix([commentable, blotLock, embeddable, dropAcceptor, draggable, selectable, focusable, executable, basic]);
var HLine = /*#__PURE__*/function (_mixin) {
  hLine_inherits(HLine, _mixin);
  var _super = hLine_createSuper(HLine);
  function HLine(domNode) {
    var _this;
    hLine_classCallCheck(this, HLine);
    _this = _super.call(this, domNode);
    hLine_defineProperty(hLine_assertThisInitialized(_this), "mapObserver", function (event) {
      _this.render();
    });
    hLine_defineProperty(hLine_assertThisInitialized(_this), "setLineType", function () {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (opts.hasOwnProperty('lineType')) {
        _this.map.set('line-type', opts.lineType);
      }
    });
    _this.addCanExecActions(['set-background', 'delete', 'backspace']);
    return _this;
  }
  hLine_createClass(HLine, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = hLine_get(hLine_getPrototypeOf(HLine.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      if (this.line) {
        return;
      }
      this.line = document.createElement('hr');
      this.domNode.appendChild(this.line);
      this.store.observe(this.map, this.mapObserver);
      this.render();
      this.domNode.addEventListener('mousedown', function (event) {
        event.preventDefault();
      });
    }
  }, {
    key: "detach",
    value: function detach() {
      if (hLine_get(hLine_getPrototypeOf(HLine.prototype), "detach", this)) {
        var _get3;
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        (_get3 = hLine_get(hLine_getPrototypeOf(HLine.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      }
      this.store.unobserve(this.map, this.mapObserver);
    }
  }, {
    key: "render",
    value: function render() {
      if (hLine_get(hLine_getPrototypeOf(HLine.prototype), "render", this)) {
        hLine_get(hLine_getPrototypeOf(HLine.prototype), "render", this).call(this);
      }
      var color = this.getColor();
      var hasDataLineColor = this.domNode.hasAttribute('data-line-color');
      if (color) {
        if (stringIsColor(color)) {
          if (hasDataLineColor) {
            this.domNode.removeAttribute('data-line-color');
          }
          this.line.style.borderColor = color;
        } else {
          this.line.style.borderColor = null;
          this.domNode.setAttribute('data-line-color', color);
        }
      } else {
        if (hasDataLineColor) {
          this.domNode.removeAttribute('data-line-color');
        }
      }
      if (this.map.get('line-type') !== this.line.getAttribute('data-lineType')) {
        this.line.setAttribute('data-lineType', this.map.get('line-type'));
      }
    }
  }, {
    key: "contextMenu",
    get: function get() {
      var menu = hLine_get(hLine_getPrototypeOf(HLine.prototype), "contextMenu", this);
      var i18n = this.editor.plugins.i18n;
      var getLineType = this.getLineType();
      menu['change-color'] = {
        label: i18n.get('block_menu.color.line_color'),
        index: -1,
        group: 0,
        action: 'change-color',
        stackable: false,
        submenu: 'ColorPicker',
        colorPickerParams: {
          closeOnChoice: false
        }
      };
      menu['line-type'] = {
        label: i18n.get('block_menu.color.line_type'),
        index: -1,
        group: 0,
        stackable: false,
        submenu: {
          Solid: {
            label: i18n.get('block_menu.line_type.default'),
            index: 0,
            group: 0,
            stackable: false,
            action: 'setLineType',
            actionParams: {
              lineType: 'solid'
            },
            icon: getLineType ? icons/* IconDone */.EZi : icons/* IconEmpty */.Zlx
          },
          Dotted: {
            label: i18n.get('block_menu.line_type.dotted'),
            index: 1,
            group: 0,
            stackable: false,
            action: 'setLineType',
            actionParams: {
              lineType: 'dotted'
            },
            icon: getLineType ? icons/* IconEmpty */.Zlx : icons/* IconDone */.EZi
          }
        }
      };
      menu.align = false;
      menu.indent = false;
      return menu;
    }
  }, {
    key: "cloneSelf",
    value: function cloneSelf() {
      var map = this.store.createMap();
      parchment_default().query(this.map.get('type')).initMap(map, this.store, {
        color: this.map.get('color'),
        lineType: this.map.get('line-type')
      });
      return map.get('id');
    }
  }, {
    key: "exec",
    value: function exec(action) {
      var processed = false;
      var params = action.params;
      if (action.type === 'set-background') {
        if (params === 'transparent') {
          params = null;
        }
        this.map.set('color', params);
        processed = true;
      } else if (action.type === 'backspace') {
        action.dontRestoreSelection();
        processed = true;
      }
      return processed;
    }
  }, {
    key: "getColor",
    value: function getColor() {
      return this.map.get('color');
    }
  }, {
    key: "getLineType",
    value: function getLineType() {
      if (this.map.get('line-type') === 'dotted') return false;else return true;
    }
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      var params = hLine_get(hLine_getPrototypeOf(HLine.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
      return (0,util/* mergeDeep */.Ee)(params, {
        initParams: {
          color: this.map.get('color'),
          lineType: this.map.get('line-type')
        }
      });
    }
  }, {
    key: "getMarkdown",
    value: function getMarkdown() {
      return '\n\n';
    }
  }], [{
    key: "initMap",
    value: function initMap(map, store) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      map.set('type', 'hLine');
      if (params.color) {
        map.set('color', params.color);
      }
      if (params.lineType) {
        map.set('line-type', params.lineType);
      }
    }
  }, {
    key: "create",
    value: function create(value) {
      var node = hLine_get(hLine_getPrototypeOf(HLine), "create", this).call(this);
      node.classList.add('horizontal-line');
      node.setAttribute('contenteditable', false);
      return node;
    }
  }, {
    key: "createBlot",
    value: function createBlot(editor) {
      var blot = parchment_default().create('hLine');
      this.addCaretTrap(editor, blot.domNode);
      return blot;
    }
  }, {
    key: "convertBlots",
    value: function convertBlots(ids, store, _ref) {
      var params = _ref.params,
        container = _ref.container;
      if (!ids.length) {
        return null;
      }
      var result = {
        removeBlots: [],
        insertBlots: []
      };
      var blot = container.editor.findById(ids[ids.length - 1]);
      if (ids.length === 1) {
        if (blot.isEmpty && blot.isEmpty()) {
          result.removeBlots = ids;
        }
      } else {
        result.removeBlots = ids;
      }
      var map = store.createMap();
      this.initMap(map, store);
      result.insertBlots.push(map.get('id'));
      var next = blot.next;
      if (!next || next.isEmbeddable || next.getWrappedBlot && next.getWrappedBlot().isEmbeddable) {
        var pMap = store.createMap();
        parchment_default().query('paragraph').initMap(pMap, store);
        result.insertBlots.push(pMap.get('id'));
        result.focus = {
          id: pMap.get('id'),
          focus: {
            index: 0
          }
        };
      } else {
        result.focus = {
          id: blot.next instanceof list_list ? blot.next.children.head.id : blot.next.id,
          focus: {
            index: 0
          }
        };
      }
      return result;
    }
  }]);
  return HLine;
}(hLine_mixin(blockEmbed));
HLine.blotName = 'hLine';
HLine.tagName = 'DIV';
/* harmony default export */ const hLine = (HLine);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/blockquote.js
function blockquote_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { blockquote_typeof = function _typeof(obj) { return typeof obj; }; } else { blockquote_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return blockquote_typeof(obj); }
function blockquote_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = blockquote_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function blockquote_slicedToArray(arr, i) { return blockquote_arrayWithHoles(arr) || blockquote_iterableToArrayLimit(arr, i) || blockquote_unsupportedIterableToArray(arr, i) || blockquote_nonIterableRest(); }
function blockquote_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function blockquote_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return blockquote_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return blockquote_arrayLikeToArray(o, minLen); }
function blockquote_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function blockquote_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function blockquote_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




















function blockquote_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function blockquote_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function blockquote_createClass(Constructor, protoProps, staticProps) { if (protoProps) blockquote_defineProperties(Constructor.prototype, protoProps); if (staticProps) blockquote_defineProperties(Constructor, staticProps); return Constructor; }
function blockquote_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) blockquote_setPrototypeOf(subClass, superClass); }
function blockquote_setPrototypeOf(o, p) { blockquote_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return blockquote_setPrototypeOf(o, p); }
function blockquote_createSuper(Derived) { var hasNativeReflectConstruct = blockquote_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = blockquote_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = blockquote_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return blockquote_possibleConstructorReturn(this, result); }; }
function blockquote_possibleConstructorReturn(self, call) { if (call && (blockquote_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return blockquote_assertThisInitialized(self); }
function blockquote_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function blockquote_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function blockquote_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { blockquote_get = Reflect.get; } else { blockquote_get = function _get(target, property, receiver) { var base = blockquote_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return blockquote_get(target, property, receiver || target); }
function blockquote_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = blockquote_getPrototypeOf(object); if (object === null) break; } return object; }
function blockquote_getPrototypeOf(o) { blockquote_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return blockquote_getPrototypeOf(o); }
function blockquote_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var FORMAT_STYLES = ['bold', 'italic', 'underline', 'strikethrough', 'link', 'background', 'color', 'comment'];
var Blockquote = /*#__PURE__*/function (_ParagraphAbstract) {
  blockquote_inherits(Blockquote, _ParagraphAbstract);
  var _super = blockquote_createSuper(Blockquote);
  function Blockquote(domNode) {
    var _this;
    blockquote_classCallCheck(this, Blockquote);
    _this = _super.call(this, domNode);
    blockquote_defineProperty(blockquote_assertThisInitialized(_this), "getCurrentLineColor", function () {
      return _this.map.get('lineColor') || _this.map.get('line-color') || null;
    });
    blockquote_defineProperty(blockquote_assertThisInitialized(_this), "onPaste", function (_ref) {
      var text = _ref.text;
      var _this$scroll$selectio = _this.scroll.selection.getRange({
          offsetBlot: blockquote_assertThisInitialized(_this)
        }),
        _this$scroll$selectio2 = blockquote_slicedToArray(_this$scroll$selectio, 1),
        blotRange = _this$scroll$selectio2[0];
      var linkTarget = text.trim();
      if (stringIsUrl(linkTarget)) {
        _this.editor.plugins.pasteManager.pasteUrlIntoText(blockquote_assertThisInitialized(_this), blotRange, linkTarget);
        return true;
      }
      text = text.replace(/\r\n/g, '\n');
      var content = text.split('\n');
      var _this$scroll$selectio3 = _this.scroll.selection.getRange(),
        _this$scroll$selectio4 = blockquote_slicedToArray(_this$scroll$selectio3, 1),
        quillRange = _this$scroll$selectio4[0];
      quillRange.index += text.length;
      quillRange.length = 0;
      var insertOps = [{
        retain: blotRange.index
      }];
      if (blotRange.length > 0) {
        insertOps.push({
          delete: blotRange.length
        });
      }
      content.map(function (string, index) {
        insertOps.push({
          insert: string
        });
        if (index !== content.length - 1) {
          insertOps.push({
            insert: {
              linebreak: 's'
            }
          });
        }
      });
      _this.map.get('characters').applyDelta(insertOps);
      _this.scroll.selection.setRange(quillRange);
      return true;
    });
    _this.addCanExecActions(['set-line-color']);
    _this.onStartBackspaceConvertToParagraph = true;
    return _this;
  }
  blockquote_createClass(Blockquote, [{
    key: "getAllowedStyles",
    value: function getAllowedStyles() {
      return FORMAT_STYLES;
    }
  }, {
    key: "contextMenu",
    get: function get() {
      var menu = blockquote_get(blockquote_getPrototypeOf(Blockquote.prototype), "contextMenu", this);
      var i18n = this.editor.plugins.i18n;
      menu['change-line-color'] = {
        label: i18n.get('block_menu.color.line_color'),
        index: -1,
        group: 0,
        action: 'change-color',
        stackable: false,
        submenu: 'ColorPicker',
        colorPickerParams: {
          getSelectedColor: this.getCurrentLineColor,
          execAction: 'set-line-color',
          defaultColor: 'transparent'
        }
      };
      return menu;
    }
  }, {
    key: "render",
    value: function render() {
      blockquote_get(blockquote_getPrototypeOf(Blockquote.prototype), "render", this).call(this);
      var hasBlockquoteClass = this.domNode.classList.contains('blockquote');
      if (!hasBlockquoteClass) {
        this.domNode.classList.add('blockquote');
      }
      var lineColor = this.getCurrentLineColor();
      var currentColorAttr = this.domNode.style.getPropertyValue('--editor-quote-line-color');
      var hasLineColor = this.domNode.hasAttribute('data-border-color');
      if (lineColor) {
        if (stringIsColor(lineColor)) {
          if (hasLineColor) {
            this.domNode.removeAttribute('data-border-color');
          }
          if (!this.domNode.hasAttribute('has-line-color')) {
            this.domNode.setAttribute('has-line-color', true);
          }
          this.domNode.style.setProperty('--editor-quote-line-color', lineColor);
        } else {
          if (currentColorAttr) {
            this.domNode.style.removeProperty('--editor-quote-line-color');
          }
          if (this.domNode.hasAttribute('has-line-color')) {
            this.domNode.removeAttribute('has-line-color');
          }
          this.domNode.setAttribute('data-border-color', lineColor);
        }
      } else {
        if (hasLineColor) {
          this.domNode.removeAttribute('data-border-color');
        }
      }
    }
  }, {
    key: "exec",
    value: function exec(action) {
      var processed = false;
      var params = action.params;
      if (action.type === 'set-line-color') {
        if (params === 'transparent') {
          params = null;
        }
        this.map.set('lineColor', params);
        processed = true;
      }
      if (!processed) {
        return blockquote_get(blockquote_getPrototypeOf(Blockquote.prototype), "exec", this).call(this, action);
      }
      return processed;
    }
  }, {
    key: "cloneSelf",
    value: function cloneSelf() {
      var map = this.store.createMap();
      parchment_default().query(this.map.get('type')).initMap(map, this.store, {
        color: this.map.get('color'),
        align: this.map.get('align'),
        lineColor: this.getCurrentLineColor(),
        delta: this.delta({
          forCopy: true
        })
      });
      return map.get('id');
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      var dataAttrs = '';
      var _iterator = blockquote_createForOfIteratorHelper(this.domNode.attributes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var attr = _step.value;
          if (attr.name.startsWith('data-')) {
            dataAttrs += ' ' + attr.name + '="' + attr.value + '"';
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var css = '';
      if (context.options.toEmail) {
        css = " padding: 5px; margin: 5px 0;";
      }
      return '<blockquote class="' + this.domNode.className + '"' + dataAttrs + ' style="text-align:' + this.map.get('align') + ';' + css + '">' + blockquote_get(blockquote_getPrototypeOf(Blockquote.prototype), "toHTML", this).call(this, context) + '</blockquote>';
    }
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      var params = blockquote_get(blockquote_getPrototypeOf(Blockquote.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
      return (0,util/* mergeDeep */.Ee)(params, {
        textLineType: 'blockquote',
        initParams: {
          lineColor: this.getCurrentLineColor()
        }
      });
    }
  }], [{
    key: "initMap",
    value: function initMap(map, store) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      map.set('type', 'blockquote');
      if (params.lineColor) {
        map.set('lineColor', params.lineColor);
      }
      blockquote_get(blockquote_getPrototypeOf(Blockquote), "initMap", this).call(this, map, store, params);
    }
  }]);
  return Blockquote;
}(paragraphAbstract);
Blockquote.blotName = 'blockquote';
Blockquote.tagName = 'BLOCKQUOTE';
/* harmony default export */ const blockquote = (Blockquote);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/paragraph.js
function paragraph_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { paragraph_typeof = function _typeof(obj) { return typeof obj; }; } else { paragraph_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return paragraph_typeof(obj); }
function paragraph_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = paragraph_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function paragraph_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return paragraph_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return paragraph_arrayLikeToArray(o, minLen); }
function paragraph_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }





















function paragraph_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function paragraph_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function paragraph_createClass(Constructor, protoProps, staticProps) { if (protoProps) paragraph_defineProperties(Constructor.prototype, protoProps); if (staticProps) paragraph_defineProperties(Constructor, staticProps); return Constructor; }
function paragraph_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) paragraph_setPrototypeOf(subClass, superClass); }
function paragraph_setPrototypeOf(o, p) { paragraph_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return paragraph_setPrototypeOf(o, p); }
function paragraph_createSuper(Derived) { var hasNativeReflectConstruct = paragraph_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = paragraph_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = paragraph_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return paragraph_possibleConstructorReturn(this, result); }; }
function paragraph_possibleConstructorReturn(self, call) { if (call && (paragraph_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return paragraph_assertThisInitialized(self); }
function paragraph_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function paragraph_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function paragraph_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { paragraph_get = Reflect.get; } else { paragraph_get = function _get(target, property, receiver) { var base = paragraph_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return paragraph_get(target, property, receiver || target); }
function paragraph_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = paragraph_getPrototypeOf(object); if (object === null) break; } return object; }
function paragraph_getPrototypeOf(o) { paragraph_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return paragraph_getPrototypeOf(o); }
function paragraph_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var NO_HIGHLIGHT_CLASS = 'no-highlight';
var Paragraph = /*#__PURE__*/function (_ParagraphAbstract) {
  paragraph_inherits(Paragraph, _ParagraphAbstract);
  var _super = paragraph_createSuper(Paragraph);
  function Paragraph() {
    var _thisSuper, _thisSuper2, _this;
    paragraph_classCallCheck(this, Paragraph);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    paragraph_defineProperty(paragraph_assertThisInitialized(_this), "paragraphMapObserver", function () {
      _this.render();
    });
    paragraph_defineProperty(paragraph_assertThisInitialized(_this), "handleInput", function (event) {
      if (paragraph_get((_thisSuper = paragraph_assertThisInitialized(_this), paragraph_getPrototypeOf(Paragraph.prototype)), "handleInput", _thisSuper)) {
        paragraph_get((_thisSuper2 = paragraph_assertThisInitialized(_this), paragraph_getPrototypeOf(Paragraph.prototype)), "handleInput", _thisSuper2).call(_thisSuper2, event);
      }
      var blotRange = _this.editor.scroll.selection.getRange({
        offsetBlot: paragraph_assertThisInitialized(_this)
      })[0];
      if (blotRange.length === 0) {
        var processed = false;
        _this.children.forEach(function (child) {
          if (!processed && blotRange.index === child.offset(paragraph_assertThisInitialized(_this))) {
            if (child.handleInput) {
              processed = child.handleInput(event);
            }
          }
        });
      }
    });
    return _this;
  }

  // блот получает апдейты размера только если он сфокусирован
  paragraph_createClass(Paragraph, [{
    key: "isSizeAware",
    get: function get() {
      return this.props.focused;
    }
  }, {
    key: "sizeAwareUpdateSize",
    value: function sizeAwareUpdateSize(maxAvailableWidth) {
      this.setProps({
        maxAvailableWidth: maxAvailableWidth
      });
    }
  }, {
    key: "attach",
    value: function attach() {
      paragraph_get(paragraph_getPrototypeOf(Paragraph.prototype), "attach", this).call(this);
      this.map.get('characters').observe(this.paragraphMapObserver);
    }
  }, {
    key: "detach",
    value: function detach() {
      paragraph_get(paragraph_getPrototypeOf(Paragraph.prototype), "detach", this).call(this);
      var characters = this.map.get('characters');
      if (characters) {
        characters.unobserve(this.paragraphMapObserver);
      }
      // скрываем эмбеддед меню. можно безопасно вызывать без проверки есть на текущем блоте оно или нет,
      // т.к. в нем самом есть эта проверка и мы передаем в hide блот, если оно было не на этом блоте, то оно не скроется
      this.editor.plugins.embeddedMenu && this.editor.plugins.embeddedMenu.hide(this);
    }
  }, {
    key: "render",
    value: function render() {
      paragraph_get(paragraph_getPrototypeOf(Paragraph.prototype), "render", this).call(this);
      if (this.editor.mode === this.editor.constructor.MODE_EDIT) {
        var isEmpty = this.isEmpty();
        if (isEmpty && this.scroll.selectedBlocks.length <= 1 && this.delta().ops.length === 1 && this.props.focused || isEmpty && !this.next && !this.prev && this.parent === this.scroll && this.store.rootChildren.length === 1 && !(this.hasOwnProperty('_removedByContainer') && this._removedByContainer)) {
          this.editor.plugins.embeddedMenu.show(this, {
            maxWidth: this.domNode.offsetWidth
          });
          this.domNode.classList.add(NO_HIGHLIGHT_CLASS);
        } else {
          this.editor.plugins.embeddedMenu.hide(this);
          if (this.domNode.classList.contains(NO_HIGHLIGHT_CLASS)) {
            this.domNode.classList.remove(NO_HIGHLIGHT_CLASS);
          }
        }
      }
    }
  }, {
    key: "contextMenu",
    get: function get() {
      var menu = paragraph_get(paragraph_getPrototypeOf(Paragraph.prototype), "contextMenu", this);
      var ops = this.delta().ops,
        i18n = this.editor.plugins.i18n;
      var allowConvertToEmbed = ops.length === 2 && ops[0].attributes && ops[0].attributes.hasOwnProperty('link') && ops[1].insert.replace(' ', '') === '\n';
      if (this.scroll.selectedBlocks.length === 1 && allowConvertToEmbed) {
        menu['turn-into'].submenu.convertToRemoteFrame = {
          label: i18n.get('block_menu.convert_to.remote_frame'),
          index: 9,
          group: 0,
          action: 'convert-blot',
          actionParams: {
            type: 'remote-frame',
            src: this.delta().ops[0].attributes.link
          },
          actionExec: true,
          stackable: false,
          icon: icons/* IconEmbed */.g9E,
          hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+m'
        };
        menu['turn-into'].submenu['turnToBookmark'] = {
          label: i18n.get('block_menu.convert_to.bookmark'),
          index: 10,
          group: 0,
          action: 'convert-blot',
          actionParams: {
            type: 'bookmark',
            src: this.delta().ops[0].attributes.link,
            replaceBlotId: this.id
          },
          actionExec: true,
          icon: icons/* IconBookmark */.BZM,
          hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+b'
        };
      }
      return menu;
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      var dataAttrs = '';
      var _iterator = paragraph_createForOfIteratorHelper(this.domNode.attributes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var attr = _step.value;
          if (attr.name.startsWith('data-')) {
            dataAttrs += ' ' + attr.name + '="' + attr.value + '"';
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var css = '';
      if (context.options.toEmail) {
        css = " padding: 5px; margin: 5px 0;";
      }
      return '<div class="' + this.domNode.className + '"' + dataAttrs + ' style="text-align:' + this.map.get('align') + ';' + css + '">' + paragraph_get(paragraph_getPrototypeOf(Paragraph.prototype), "toHTML", this).call(this, context) + '</div>';
    }
  }, {
    key: "getMarkdown",
    value: function getMarkdown() {
      return paragraph_get(paragraph_getPrototypeOf(Paragraph.prototype), "getMarkdown", this).call(this);
    }
  }], [{
    key: "initMap",
    value: function initMap(map, store) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      map.set('type', 'paragraph');
      paragraph_get(paragraph_getPrototypeOf(Paragraph), "initMap", this).call(this, map, store, params);
    }
  }]);
  return Paragraph;
}(paragraphAbstract);
Paragraph.blotName = 'paragraph';
Paragraph.tagName = 'DIV';
Paragraph.allowedChildren = paragraphAbstract.allowedChildren;
/* harmony default export */ const paragraph = (Paragraph);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/addParagraph.js
function addParagraph_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { addParagraph_typeof = function _typeof(obj) { return typeof obj; }; } else { addParagraph_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return addParagraph_typeof(obj); }









function addParagraph_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function addParagraph_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function addParagraph_createClass(Constructor, protoProps, staticProps) { if (protoProps) addParagraph_defineProperties(Constructor.prototype, protoProps); if (staticProps) addParagraph_defineProperties(Constructor, staticProps); return Constructor; }
function addParagraph_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) addParagraph_setPrototypeOf(subClass, superClass); }
function addParagraph_setPrototypeOf(o, p) { addParagraph_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return addParagraph_setPrototypeOf(o, p); }
function addParagraph_createSuper(Derived) { var hasNativeReflectConstruct = addParagraph_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = addParagraph_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = addParagraph_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return addParagraph_possibleConstructorReturn(this, result); }; }
function addParagraph_possibleConstructorReturn(self, call) { if (call && (addParagraph_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return addParagraph_assertThisInitialized(self); }
function addParagraph_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function addParagraph_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function addParagraph_getPrototypeOf(o) { addParagraph_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return addParagraph_getPrototypeOf(o); }



var AddParagraphAction = /*#__PURE__*/function (_Action) {
  addParagraph_inherits(AddParagraphAction, _Action);
  var _super = addParagraph_createSuper(AddParagraphAction);
  function AddParagraphAction(type, params, editor) {
    addParagraph_classCallCheck(this, AddParagraphAction);
    type = type || AddParagraphAction.type;
    if (typeof params === 'string') {
      params = {
        position: params
      };
    }
    return _super.call(this, type, params, editor);
  }
  addParagraph_createClass(AddParagraphAction, [{
    key: "getAllowedContainer",
    value: function getAllowedContainer(blot) {
      if (blot.container.constructor.allowedChildren.some(function (child) {
        return child.isPrototypeOf(paragraph);
      })) {
        return {
          blot: blot,
          container: blot.container
        };
      } else {
        return this.getAllowedContainer(blot.container);
      }
    }
  }, {
    key: "exec",
    value: function exec(_ref) {
      var processingBlots = _ref.processingBlots;
      if (processingBlots.length === 0) {
        processingBlots = this.editor.scroll.selectedBlocks.length !== 0 ? this.editor.scroll.selectedBlocks : false;
      }
      if (!processingBlots) return false;
      var processingBlot = this.params.position === 'above' ? processingBlots[0] : processingBlots[processingBlots.length - 1];
      if (processingBlot instanceof listItem) {
        var index = this.params.position === 'above' ? processingBlot.index - 1 : processingBlot.index;
        if (processingBlot.getSubItems && this.params.position !== 'above') {
          var subItems = processingBlot.getSubItems();
          if (subItems.length) {
            index = subItems[subItems.length - 1].index;
          }
        }
        processingBlot.parent.splitWithBlot(index, 'paragraph', {
          focus: {
            index: 0
          }
        });
        return true;
      }
      var _this$getAllowedConta = this.getAllowedContainer(processingBlot),
        blot = _this$getAllowedConta.blot,
        container = _this$getAllowedConta.container;
      if (this.params.position === 'above') {
        container.addBlot('paragraph', {
          focus: {
            index: 0
          },
          before: blot.id
        });
      } else {
        container.addBlot('paragraph', {
          focus: {
            index: 0
          },
          after: blot.id
        });
      }
      return true;
    }
  }]);
  return AddParagraphAction;
}(Action);

AddParagraphAction.type = 'add-paragraph';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/backspace.js
function backspace_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { backspace_typeof = function _typeof(obj) { return typeof obj; }; } else { backspace_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return backspace_typeof(obj); }













function backspace_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function backspace_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function backspace_createClass(Constructor, protoProps, staticProps) { if (protoProps) backspace_defineProperties(Constructor.prototype, protoProps); if (staticProps) backspace_defineProperties(Constructor, staticProps); return Constructor; }
function backspace_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { backspace_get = Reflect.get; } else { backspace_get = function _get(target, property, receiver) { var base = backspace_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return backspace_get(target, property, receiver || target); }
function backspace_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = backspace_getPrototypeOf(object); if (object === null) break; } return object; }
function backspace_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) backspace_setPrototypeOf(subClass, superClass); }
function backspace_setPrototypeOf(o, p) { backspace_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return backspace_setPrototypeOf(o, p); }
function backspace_createSuper(Derived) { var hasNativeReflectConstruct = backspace_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = backspace_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = backspace_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return backspace_possibleConstructorReturn(this, result); }; }
function backspace_possibleConstructorReturn(self, call) { if (call && (backspace_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return backspace_assertThisInitialized(self); }
function backspace_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function backspace_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function backspace_getPrototypeOf(o) { backspace_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return backspace_getPrototypeOf(o); }
function backspace_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var backspace_BackspaceAction = /*#__PURE__*/function (_Action) {
  backspace_inherits(BackspaceAction, _Action);
  var _super = backspace_createSuper(BackspaceAction);
  function BackspaceAction(type, params, editor) {
    var _this;
    backspace_classCallCheck(this, BackspaceAction);
    type = type || BackspaceAction.type;
    _this = _super.call(this, type, params, editor);
    backspace_defineProperty(backspace_assertThisInitialized(_this), "rangeBefore", null);
    _this.restoreSelection = true;
    _this.deleteAction = null;
    _this.newRange = null;
    _this.bcount = 0;
    return _this;
  }
  backspace_createClass(BackspaceAction, [{
    key: "isTextBlot",
    value: function isTextBlot(blot) {
      return blot instanceof textLine || blot.statics.isTextBlot;
    }
  }, {
    key: "before",
    value: function before(_ref) {
      var processingBlots = _ref.processingBlots;
      this.rangeBefore = this.editor.scroll.selection.getRange()[0];
      if (this.rangeBefore && this.rangeBefore.length > 0) {
        // если выделение не сколлапсировано то выполнение backspace аналогично выполнению delete
        this.deleteAction = new DeleteAction(DeleteAction.type, this.params, this.editor);
        this.deleteAction.before({
          processingBlots: processingBlots
        });
      }
    }
  }, {
    key: "after",
    value: function after() {
      if (this.focusToLineblot) {
        var index = this.prevPrevBlot.offset(this.scroll);
        if (this.prevBlot && this.prevBlot instanceof tableWrapper) {
          var prevIndex = this.prevBlot.offset(this.scroll);
          if (this.prevPrevBlot.parent && this.prevPrevBlot.parent.constructor.blotName === 'gridCol' || this.prevPrevBlot instanceof listItem) {
            prevIndex = this.rangeBefore.index - 7;
          }
          this.newRange = this.newRange || {
            index: prevIndex - 1,
            length: 0
          };
        } else if (this.prevPrevBlot && this.prevPrevBlot instanceof listItem) {
          this.newRange = this.newRange || {
            index: this.rangeBefore.index - (this.bcount + 1) - 1,
            length: 0
          };
        } else {
          var length = this.prevPrevBlot.length();
          if (length > 0) {
            index = index + length - 1;
          }
          this.newRange = this.newRange || {
            index: index,
            length: 0
          };
        }
        try {
          this.editor.scroll.selection.setRange(this.newRange);
        } catch (e) {
          this.editor.scroll.selection.setRange({
            index: index,
            length: 0
          });
        }
      } else {
        if (this.deleteAction) {
          this.deleteAction.after();
        } else {
          if (!this.restoreSelection || !this.rangeBefore) {} else {
            this.newRange = this.newRange || {
              index: this.rangeBefore.index - 1,
              length: 0
            };
            this.editor.scroll.selection.setRange(this.newRange);
          }
        }
      }
      if (this.editor.browser === 'Chrome' && !this.deleteAction && !(this.restoreSelection && this.rangeBefore)) {
        // FIXME из-за бага в хроме https://bugs.chromium.org/p/chromium/issues/detail?id=725890 при нажатии backspace не генерируется событие selectionchange
        // генерируем его сами
        var selectionChangeEvent = new CustomEvent('selectionchange', {});
        document.dispatchEvent(selectionChangeEvent);
      }
    }
  }, {
    key: "getPrevTextLineBlot",
    value: function getPrevTextLineBlot(blot) {
      var prevBlot = blot.prev;
      if (!prevBlot) {
        return null;
      }
      if (prevBlot.isContainer) {
        prevBlot = prevBlot.children.tail;
      } else if (prevBlot.getInnerTextLine) {
        prevBlot = prevBlot.getInnerTextLine();
      }
      if (!prevBlot || !this.isTextBlot(prevBlot)) {
        return null;
      }
      return prevBlot;
    }
  }, {
    key: "getPreviousTextLineBlot",
    value: function getPreviousTextLineBlot(blot) {
      if (!blot) return false;
      var doNext = false;
      var prevBlot = blot.prev;
      if (!prevBlot) {
        return null;
      } else if (this.isTextBlot(prevBlot)) {
        return prevBlot;
      } else if (prevBlot.isContainer) {
        prevBlot = prevBlot.children.tail;
        if (this.isTextBlot(prevBlot)) {
          return prevBlot;
        } else {
          doNext = true;
        }
      } else if (prevBlot.getInnerTextLine) {
        prevBlot = prevBlot.getInnerTextLine();
        if (this.isTextBlot(prevBlot)) {
          return prevBlot;
        } else {
          doNext = true;
        }
      } else {
        doNext = true;
      }
      if (doNext) {
        this.bcount++;
        return this.getPreviousTextLineBlot(prevBlot);
      }
    }
  }, {
    key: "getPrevEmbeddableBlot",
    value: function getPrevEmbeddableBlot(blot) {
      var prevBlot = blot.prev;
      if (!prevBlot) {
        return null;
      }
      if (prevBlot.table || prevBlot.embed) {
        return prevBlot;
      }
      if (prevBlot.isContainer) {
        prevBlot = prevBlot.children.tail;
      }
      if (!prevBlot || !prevBlot.isEmbeddable) {
        return null;
      }
      return prevBlot;
    }
  }, {
    key: "useDelAction",
    value: function useDelAction(processingBlots) {
      this.deleteAction = new DeleteAction(DeleteAction.type, this.params, this.editor);
      this.deleteAction.before({
        processingBlots: processingBlots
      });
      this.deleteAction.exec({
        processingBlots: processingBlots
      });
    }
  }, {
    key: "exec",
    value: function exec(_ref2) {
      var processingBlots = _ref2.processingBlots;
      // проверяем наличие заблокированных блотов для юзера при множественном выделении
      // и запрещаем удалять массово если внутри есть залоченый блот
      if (this.deleteAction) {
        var deleteActionProcessed = this.deleteAction.exec({
          processingBlots: processingBlots
        });
        if (this.deleteAction.isHandledByBrowser) {
          this.handleByBrowser();
        }
        return deleteActionProcessed;
      } else {
        // нажатие backspace на коллапсированном выделении
        var processed = false;
        var blot = processingBlots[0];
        if (blot && blot.canExec && blot.canExec(this)) {
          processed = backspace_get(backspace_getPrototypeOf(BackspaceAction.prototype), "exec", this).call(this, {
            processingBlots: processingBlots
          });
          if (!processed && this.getBlotRange(blot).index === 0) {
            // нажатие backspace в начале блота, если предыдущий блот реализует textLine
            // то надо скопировать контент текущего блота в него и удалить текущий
            // Правка: если предыдущий блот пустой, нужно его удалить, а курсор оставить в текущем
            // Правка: если предыдущий блот является embeddable, нужно его удалить, а курсор оставить в текущем (для businessCard и Outline)
            var prevBlot = this.getPrevTextLineBlot(blot);
            if (blot.onStartBackspaceConvertToParagraph) {
              // Нажатие backspace в начале блота с флагом onStartBackspaceConvertToParagraph должно сконверитровать его в параграф
              // каретка должна остаться в начале этого блота
              this.dontRestoreSelection();
              blot.container.containerConvertBlots([blot], {
                type: 'paragraph',
                color: 'transparent'
              });
              processed = true;
            } else if (prevBlot) {
              if (!prevBlot.isEmpty() || prevBlot.dontRemoveWithBackspace) {
                var delta = DeleteAction.getBlotDelta(blot, prevBlot);
                prevBlot.map.get('characters').applyDelta(delta.ops);
                processed = true;
                blot.remove();
              } else {
                prevBlot.remove();
                processed = true;
              }
            } else {
              prevBlot = this.getPrevEmbeddableBlot(blot);
              if (prevBlot) {
                if (prevBlot.dontRemoveWithBackspace) {
                  processed = true;
                } else {
                  var prevPrevBlot = this.getPreviousTextLineBlot(prevBlot);
                  if (prevPrevBlot && this.isTextBlot(prevPrevBlot)) {
                    var _delta = DeleteAction.getBlotDelta(blot, prevPrevBlot);
                    prevPrevBlot.map.get('characters').applyDelta(_delta.ops);
                    this.focusToLineblot = true;
                    this.prevPrevBlot = prevPrevBlot;
                  }
                  prevBlot.remove();
                  blot.remove();
                  processed = true;
                }
              } else {
                this.dontRestoreSelection();
                processed = true;
              }
            }
          } else if (blot instanceof hLine) {
            this.useDelAction(processingBlots);
            processed = true;
          } else if (!(blot instanceof primary)) {
            processed = true;
          }
        }
        return processed;
      }
    }
  }]);
  return BackspaceAction;
}(Action);

backspace_BackspaceAction.type = 'backspace';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/toHTML.js


function childrenToHTML(blot, context) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var html = [];
  blot.children.forEach(function (blot) {
    if (blot.toHTML) {
      html.push(blot.toHTML(context));
    } else if (opts.allowRawHTML && blot.domNode) {
      html.push(blot.domNode.outerHTML);
    }
  });
  return html.join('');
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/attachment/embedWrapperAbstract.js
function embedWrapperAbstract_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { embedWrapperAbstract_typeof = function _typeof(obj) { return typeof obj; }; } else { embedWrapperAbstract_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return embedWrapperAbstract_typeof(obj); }












function embedWrapperAbstract_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function embedWrapperAbstract_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function embedWrapperAbstract_createClass(Constructor, protoProps, staticProps) { if (protoProps) embedWrapperAbstract_defineProperties(Constructor.prototype, protoProps); if (staticProps) embedWrapperAbstract_defineProperties(Constructor, staticProps); return Constructor; }
function embedWrapperAbstract_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { embedWrapperAbstract_get = Reflect.get; } else { embedWrapperAbstract_get = function _get(target, property, receiver) { var base = embedWrapperAbstract_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return embedWrapperAbstract_get(target, property, receiver || target); }
function embedWrapperAbstract_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = embedWrapperAbstract_getPrototypeOf(object); if (object === null) break; } return object; }
function embedWrapperAbstract_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) embedWrapperAbstract_setPrototypeOf(subClass, superClass); }
function embedWrapperAbstract_setPrototypeOf(o, p) { embedWrapperAbstract_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return embedWrapperAbstract_setPrototypeOf(o, p); }
function embedWrapperAbstract_createSuper(Derived) { var hasNativeReflectConstruct = embedWrapperAbstract_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = embedWrapperAbstract_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = embedWrapperAbstract_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return embedWrapperAbstract_possibleConstructorReturn(this, result); }; }
function embedWrapperAbstract_possibleConstructorReturn(self, call) { if (call && (embedWrapperAbstract_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return embedWrapperAbstract_assertThisInitialized(self); }
function embedWrapperAbstract_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function embedWrapperAbstract_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function embedWrapperAbstract_getPrototypeOf(o) { embedWrapperAbstract_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return embedWrapperAbstract_getPrototypeOf(o); }
function embedWrapperAbstract_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var EmbedWrapper = /*#__PURE__*/function (_DropAcceptorMixin) {
  embedWrapperAbstract_inherits(EmbedWrapper, _DropAcceptorMixin);
  var _super = embedWrapperAbstract_createSuper(EmbedWrapper);
  function EmbedWrapper(domNode) {
    var _this;
    embedWrapperAbstract_classCallCheck(this, EmbedWrapper);
    _this = _super.call(this, domNode);
    embedWrapperAbstract_defineProperty(embedWrapperAbstract_assertThisInitialized(_this), "onImageWrapperMouseDown", function (event) {
      if (event.target == _this.domNode) {
        event.preventDefault();
        event.stopPropagation();
        if (_this.embed.domNode.classList.contains('focused-block')) {
          return false;
        } else {
          _this.embed.embeddableFocus();
        }
      }
    });
    _this.domNode.classList.add('embed-wrapper');
    _this.containerFixedChildren = true;
    _this.embed = null;
    return _this;
  }

  // тут описаны функции блота, которые могут быть вызваны на сервере
  embedWrapperAbstract_createClass(EmbedWrapper, [{
    key: "id",
    get: function get() {
      return this.map.get('id');
    }
  }, {
    key: "getWrappedBlot",
    value: function getWrappedBlot() {
      return this.embed;
    }
  }, {
    key: "setDomNodeAttribute",
    value: function setDomNodeAttribute(key, value) {
      if (key === 'id') {
        return;
      }
      this.domNode.setAttribute(key, value);
    }
  }, {
    key: "buildBlot",
    value: function buildBlot() {
      if (this.embed) {
        return;
      }
      this.embed = parchment_default().create(this.map.get('type'));
      this.embed.map = this.map;
      this.appendChild(this.embed);
      this.domNode.addEventListener('mousedown', this.onEmbedWrapperMouseDown, false);
    }
  }, {
    key: "attach",
    value: function attach() {
      embedWrapperAbstract_get(embedWrapperAbstract_getPrototypeOf(EmbedWrapper.prototype), "attach", this).call(this);
      this.buildBlot();
    }
  }, {
    key: "render",
    value: function render() {}
  }, {
    key: "detach",
    value: function detach() {
      embedWrapperAbstract_get(embedWrapperAbstract_getPrototypeOf(EmbedWrapper.prototype), "detach", this).call(this);
      this.domNode.removeEventListener('mousedown', this.onEmbedWrapperMouseDown, false);
    }
  }, {
    key: "addBlot",
    value: function addBlot() {
      var _this$parent;
      return (_this$parent = this.parent).addBlot.apply(_this$parent, arguments);
    }
  }, {
    key: "getChildBlotsForExec",
    value: function getChildBlotsForExec() {
      return [this.embed];
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      if (context.options.noAttachments) {
        return '';
      }
      return '<' + this.constructor.tagName + ' ' + (0,dom/* getAttributesString */.No)(this.domNode) + ' ' + (context.options.pdf ? 'style="page-break-inside: avoid;"' : '') + '>' + childrenToHTML(this, context, {
        allowRawHTML: true
      }) + '</' + this.constructor.tagName + '>';
    }
  }], [{
    key: "setCaption",
    value: function setCaption(editor, map, newOps) {
      var captionId = map.get('caption');
      if (!captionId) {
        return;
      }
      var captionMap = editor.store.blocks.get(captionId);
      if (!captionMap) {
        return;
      }
      var newDelta = new (Delta_default())(newOps);
      var prevDelta = new (Delta_default())(captionMap.get('characters').toDelta());
      var diff = prevDelta.diff(newDelta);
      captionMap.get('characters').applyDelta(diff.ops);
    }
  }]);
  return EmbedWrapper;
}(dropAcceptor(basic((parchment_default()).Container)));
embedWrapperAbstract_defineProperty(EmbedWrapper, "serverCallable", ['setCaption']);
EmbedWrapper.allowedChildren = [(parchment_default()).Embed];
EmbedWrapper.blotName = 'embedWrapper';
EmbedWrapper.tagName = 'DIV';
EmbedWrapper.scope = (parchment_default()).Scope.BLOCK_BLOT;
/* harmony default export */ const embedWrapperAbstract = (EmbedWrapper);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/mixins/resizeable.js
function resizeable_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { resizeable_typeof = function _typeof(obj) { return typeof obj; }; } else { resizeable_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return resizeable_typeof(obj); }
function resizeable_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = resizeable_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function resizeable_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return resizeable_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return resizeable_arrayLikeToArray(o, minLen); }
function resizeable_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function resizeable_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function resizeable_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { resizeable_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { resizeable_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }






















function resizeable_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function resizeable_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function resizeable_createClass(Constructor, protoProps, staticProps) { if (protoProps) resizeable_defineProperties(Constructor.prototype, protoProps); if (staticProps) resizeable_defineProperties(Constructor, staticProps); return Constructor; }
function resizeable_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { resizeable_get = Reflect.get; } else { resizeable_get = function _get(target, property, receiver) { var base = resizeable_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return resizeable_get(target, property, receiver || target); }
function resizeable_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = resizeable_getPrototypeOf(object); if (object === null) break; } return object; }
function resizeable_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) resizeable_setPrototypeOf(subClass, superClass); }
function resizeable_setPrototypeOf(o, p) { resizeable_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return resizeable_setPrototypeOf(o, p); }
function resizeable_createSuper(Derived) { var hasNativeReflectConstruct = resizeable_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = resizeable_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = resizeable_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return resizeable_possibleConstructorReturn(this, result); }; }
function resizeable_possibleConstructorReturn(self, call) { if (call && (resizeable_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return resizeable_assertThisInitialized(self); }
function resizeable_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function resizeable_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function resizeable_getPrototypeOf(o) { resizeable_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return resizeable_getPrototypeOf(o); }
function resizeable_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var MIN_BLOCK_MENU_AREA = 55;
var MIN_BLOCK_MENU_AREA_MOBILE = 16;
var RESIZEABLE_CLASSES = {
  containerOversize: 'over-width-enabled',
  enabled: 'resize-over-width'
};
var RESIZE_POINTS = ['top-right', 'right', 'bottom-right', 'bottom'];
var Resizeable = function Resizeable(superclass) {
  return /*#__PURE__*/function (_superclass) {
    resizeable_inherits(_class2, _superclass);
    var _super = resizeable_createSuper(_class2);
    function _class2() {
      var _this;
      resizeable_classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      resizeable_defineProperty(resizeable_assertThisInitialized(_this), "onResizePointsMouseDown", function (event) {
        event.preventDefault();
        event.stopPropagation();
        _this.ignoringUpdateRender = true;
        // при нажатии не запоминаем координаты, чтобы обычный клик не вызывал ресайз изображения
        _this.setMousePos({
          direction: event.target.getAttribute('data-direction'),
          altKey: event.altKey,
          ratio: _this.map.get('ratio')
        });
        _this.onStartResizeBlot();
        _this.resizeContainer.classList.add('resize-process');
        _this.editor.emit('blot-resize-start');
        document.addEventListener('mousemove', _this.onResizeDocumentMouseMove, false);
        document.addEventListener('mouseup', _this.onResizeDocumentMouseUp, false);
        document.addEventListener('keydown', _this.onResizeDocumentKeyDown, false);
        document.addEventListener('keyup', _this.onResizeDocumentKeyUp, false);
      });
      resizeable_defineProperty(resizeable_assertThisInitialized(_this), "onResizeDocumentMouseUp", function () {
        clearInterval(_this.scrollingInterval);
        _this.ignoringUpdateRender = false;
        var _this$resizeContainer = _this.resizeContainer.getBoundingClientRect(),
          width = _this$resizeContainer.width,
          height = _this$resizeContainer.height;
        _this.setMousePos();
        _this.onEndResizeBlot();
        _this.map.set('width', width);
        _this.map.set('ratio', width / height);
        _this.resizeContainer.classList.remove('resize-process');
        _this.editor.emit('blot-resize-end');
        document.removeEventListener('mousemove', _this.onResizeDocumentMouseMove, false);
        document.removeEventListener('mouseup', _this.onResizeDocumentMouseUp, false);
        document.removeEventListener('keydown', _this.onResizeDocumentKeyDown, false);
        document.removeEventListener('keyup', _this.onResizeDocumentKeyUp, false);
      });
      resizeable_defineProperty(resizeable_assertThisInitialized(_this), "onResizeDocumentMouseMove", function (event) {
        if (!_this.savedMousePos) return;
        var _this$savedMousePos = _this.savedMousePos,
          direction = _this$savedMousePos.direction,
          ratio = _this$savedMousePos.ratio;
        var clientX = event.clientX,
          clientY = event.clientY,
          altKey = event.altKey;
        _this.setMousePos({
          x: clientX,
          y: clientY,
          direction: direction,
          altKey: altKey,
          ratio: ratio
        });
      });
      resizeable_defineProperty(resizeable_assertThisInitialized(_this), "onResizeDocumentKeyDown", function (event) {
        if (!_this.savedMousePos || _this.savedMousePos.direction !== 'bottom-right') return;
        if (event.key === 'Alt') {
          event.preventDefault();
          _this.setMousePos(Object.assign({}, _this.savedMousePos, {
            altKey: true
          }));
        }
      });
      resizeable_defineProperty(resizeable_assertThisInitialized(_this), "onResizeDocumentKeyUp", function (event) {
        if (!_this.savedMousePos || _this.savedMousePos.direction !== 'bottom-right') return;
        if (event.key === 'Alt') {
          event.preventDefault();
          var _this$resizeContainer2 = _this.resizeContainer.getBoundingClientRect(),
            width = _this$resizeContainer2.width,
            height = _this$resizeContainer2.height;
          _this.setMousePos(Object.assign({}, _this.savedMousePos, {
            altKey: false,
            ratio: width / height
          }));
        }
      });
      resizeable_defineProperty(resizeable_assertThisInitialized(_this), "resolveAndSetContainerSize", /*#__PURE__*/resizeable_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var savedWidth, savedRatio;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                savedWidth = _this.map.get('width');
                savedRatio = _this.map.get('ratio');
                if (!(!savedWidth && !savedRatio)) {
                  _context.next = 9;
                  break;
                }
                if (_this.getContentSize) {
                  _context.next = 5;
                  break;
                }
                return _context.abrupt("return");
              case 5:
                _this.resizeContainer.classList.add('width-is-undefined');
                _this.getContentSize().then(function (size) {
                  if (size) {
                    // записываем ширину только в случае если редактор в режиме редактирования
                    if (_this.editor.mode === _this.editor.constructor.MODE_EDIT) {
                      if (size.width) {
                        if (!_this.allowOverWidth && size.width > _this.maxContentWidth) {
                          _this.map.set('width', _this.maxContentWidth);
                        } else {
                          _this.map.set('width', size.width);
                        }
                      }
                      if (size.ratio) {
                        _this.map.set('ratio', size.ratio);
                      }
                    } else {
                      _this.setResizeContainerSize({
                        width: size.width,
                        ratio: size.ratio
                      });
                    }
                  }
                }).finally(function () {
                  _this.resizeContainer.classList.remove('width-is-undefined');
                  if (_this.editor.mode === _this.editor.constructor.MODE_EDIT) {
                    _this.onResizeableResolveSize({
                      width: _this.map.get('width'),
                      ratio: _this.map.get('ratio')
                    });
                  }
                });
                _context.next = 10;
                break;
              case 9:
                if (!_this.allowOverWidth && savedWidth > _this.maxContentWidth) {
                  _this.setResizeContainerSize({
                    width: _this.maxContentWidth,
                    ratio: savedRatio
                  });
                } else {
                  _this.setResizeContainerSize({
                    width: savedWidth,
                    ratio: savedRatio
                  });
                }
              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
      _this.resizeable = true;
      _this.resizeContainer = _this.createResizeContainer();
      return _this;
    }
    resizeable_createClass(_class2, [{
      key: "attach",
      value: function attach() {
        var _get2;
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        (_get2 = resizeable_get(resizeable_getPrototypeOf(_class2.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
        var children = Array.from(this.domNode.childNodes);
        this.domNode.insertBefore(this.resizeContainer, this.domNode.firstChild);
        for (var _i = 0, _children = children; _i < _children.length; _i++) {
          var child = _children[_i];
          this.resizeContainer.appendChild(child);
        }
      }
    }, {
      key: "maxContentWidth",
      get: function get() {
        return this.getWrapper && !this.allowOverWidth ? this.getWrapper().domNode.getBoundingClientRect().width : this.container.domNode.offsetWidth;
      }
    }, {
      key: "maxContentOverWidth",
      get: function get() {
        var menu_area = MIN_BLOCK_MENU_AREA;
        // для мобильного редактора устанавливаем своё значение отступов справа и слева
        if (this.editor.options.deviceType === 'mobile') {
          menu_area = MIN_BLOCK_MENU_AREA_MOBILE;
        }
        return this.editor.scrollingContainer.offsetWidth - menu_area * 2;
      }
    }, {
      key: "allowOverWidth",
      get: function get() {
        var mapAllowParam = this.map.get('allowOverWidth');
        return this.container === this.scroll && (typeof mapAllowParam === 'undefined' || mapAllowParam === true);
      }
    }, {
      key: "isResizeAvailableGlobal",
      get: function get() {
        if (this.editor.options.blots && this.editor.options.blots.mixins && this.editor.options.blots.mixins.resizable) {
          if (this.editor.options.blots.mixins.resizable.hasOwnProperty('available')) {
            return this.editor.options.blots.mixins.resizable.available;
          }
        }
        return true;
      }
    }, {
      key: "createResizeContainer",
      value: function createResizeContainer() {
        var node = document.createElement('div');
        node.classList.add('resize-container');
        return node;
      }

      /**
       * Срабатывает после добавления/удаления класса .resize-over-width
       * @param isOverWidth
       */
    }, {
      key: "onResizeOverWidth",
      value: function onResizeOverWidth(isOverWidth) {}
    }, {
      key: "renderResizePoints",
      value: function renderResizePoints() {
        var i18n = this.editor.plugins.i18n;
        var node = document.createElement('div');
        node.classList.add('resize-points');
        var opts = {};
        if (this.getResizeOpts) {
          opts = this.getResizeOpts();
        }
        var points = RESIZE_POINTS.filter(function (point) {
          if (opts.allowedResizePoints) {
            if (Array.isArray(opts.allowedResizePoints)) {
              return opts.allowedResizePoints.includes(point);
            } else if (typeof opts.allowedResizePoints === 'string') {
              return point === opts.allowedResizePoints;
            }
          }
          return true;
        });
        var _iterator = resizeable_createForOfIteratorHelper(points),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var point = _step.value;
            var pointNode = document.createElement('div');
            pointNode.classList.add('resize-point');
            pointNode.setAttribute('data-direction', point);
            if (point !== 'bottom-right') {
              pointNode.setAttribute(tooltipManager/* TOOLTIP_ATTR */.qZ, i18n.get('resizeable.point_tooltip.default'));
            } else {
              var altKey = browser/* optionKey.charAt */.$d.charAt(0).toUpperCase() + browser/* optionKey.slice */.$d.slice(1);
              pointNode.setAttribute(tooltipManager/* TOOLTIP_ATTR */.qZ, i18n.get('resizeable.point_tooltip.' + point, {
                altKey: altKey
              }));
              pointNode.setAttribute(tooltipManager/* TOOLTIP_ADD_CLASS */.Bg, 'resizeable-bottom-right-tooltip');
            }
            node.appendChild(pointNode);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        node.addEventListener('mousedown', this.onResizePointsMouseDown);
        if (this.resizePointsNode) {
          this.resizePointsNode.replaceWith(node);
        } else {
          this.resizeContainer.appendChild(node);
        }
        this.resizePointsNode = node;
      }
    }, {
      key: "render",
      value: function render() {
        var _get3;
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }
        (_get3 = resizeable_get(resizeable_getPrototypeOf(_class2.prototype), "render", this)).call.apply(_get3, [this].concat(args));
        var editMode = this.editor.mode === this.editor.constructor.MODE_EDIT;
        var allowSetHeight = this.props.isContentRendered;
        var availableResize = allowSetHeight;
        if (!this.isResizeAvailableGlobal || !this.isResizeAvailable || !this.isResizeAvailable()) {
          availableResize = false;
        }
        var resizeBlockPoints = false;
        if (this.isBlotLocked) {
          resizeBlockPoints = true;
        }
        if (!availableResize || resizeBlockPoints) {
          // добавляем контейнеру класс, указывающий на то что ресайз отключен
          if (!this.resizeContainer.classList.contains('disabled-resize')) {
            this.resizeContainer.classList.add('disabled-resize');
          }
          // удаляем вспомогательный класс оверсайза если он есть
          if (this.domNode.classList.contains(RESIZEABLE_CLASSES.containerOversize)) {
            this.domNode.classList.remove(RESIZEABLE_CLASSES.containerOversize);
          }
          if (!this.resizeContainer.classList.contains(RESIZEABLE_CLASSES.enabled)) {
            this.resizeContainer.classList.remove(RESIZEABLE_CLASSES.enabled);
          }
          // удаляем возможные стили из контейнера, стили по умолчанию прописаны в scss
          if (!this.onDisabledResizeAllowSize || !this.onDisabledResizeAllowSize()) {
            this.resizeContainer.removeAttribute('style');
          }
        } else if (this.resizeContainer.classList.contains('disabled-resize') && editMode) {
          this.resizeContainer.classList.remove('disabled-resize');
          this.renderResizePoints();
        }
        if (availableResize) {
          this.resolveAndSetContainerSize();
        } else if (allowSetHeight) {
          this.setResizeContainerSize({
            ratio: this.map.get('ratio')
          });
        }
      }
    }, {
      key: "onResizeableResolveSize",
      value: function onResizeableResolveSize() {
        var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      }
    }, {
      key: "setResizeContainerSize",
      value: function setResizeContainerSize(_ref2) {
        var width = _ref2.width,
          ratio = _ref2.ratio;
        // отношение должно быть передано всегда
        if (!ratio && this.allowResizeHeight()) {
          if (this.tryGetRatio) {
            ratio = this.tryGetRatio();
          }
          if (!ratio) {
            console.error('Resizeable#setResizeContainerSize: ratio is required');
            return;
          }
        }

        // в мобильном редакторе отключен ресайз изображения и из-за этого картинки расширяются на всю ширину экрана
        // чтобы это поправить задаём ширину если она не передана в параметрах функции
        if (this instanceof attachment_image && !width && this.editor.options.deviceType === 'mobile') {
          width = this.map.get('width');
          if (width > this.maxContentOverWidth) {
            width = this.maxContentOverWidth;
          }
        }

        // если ширина не превышает ширину scrollBlot, убираем лишние стили и классы и сетим ширину
        if (width) {
          if (width <= this.maxContentWidth || !this.allowOverWidth) {
            if (this.domNode.classList.contains(RESIZEABLE_CLASSES.containerOversize)) {
              this.domNode.classList.remove(RESIZEABLE_CLASSES.containerOversize);
            }
            if (this.resizeContainer.classList.contains(RESIZEABLE_CLASSES.enabled)) {
              this.resizeContainer.classList.remove(RESIZEABLE_CLASSES.enabled);
              this.onResizeOverWidth(false);
            }
            this.resizeContainer.style.width = width + 'px';
            this.resizeContainer.style.marginLeft = '';
            this.resizeContainer.style.maxWidth = '';
          } else {
            // добавляем ноде блота вспомогательный класс, чтобы убрать, например, display: flex, который не дает выйти контейнеру за свои пределы
            if (!this.domNode.classList.contains(RESIZEABLE_CLASSES.containerOversize)) {
              this.domNode.classList.add(RESIZEABLE_CLASSES.containerOversize);
            }
            if (!this.resizeContainer.classList.contains(RESIZEABLE_CLASSES.enabled)) {
              this.resizeContainer.classList.add(RESIZEABLE_CLASSES.enabled);
              this.onResizeOverWidth(true);
            }
            // если ширина превышает максимально допустимую, делаем ширину максимально допустимой
            if (width > this.maxContentOverWidth) {
              width = this.maxContentOverWidth;
            }
            // получаем значение, на которое контейнер должен сместиться влево, чтобы в редакторе он оставалься по центру
            width = Math.round(width);
            var marginLeft = (width - this.maxContentWidth) / 2;
            this.resizeContainer.style.maxWidth = 'unset';
            this.resizeContainer.style.marginLeft = -marginLeft + 'px';
            this.resizeContainer.style.width = width + 'px';
          }
        }
        if (this.allowResizeHeight()) {
          if (!width) {
            width = Math.round(this.resizeContainer.getBoundingClientRect().width);
          }
          var height = Math.round(width / ratio);
          if (this.resizeContainer.getAttribute('data-content-height')) {
            height = this.resizeContainer.getAttribute('data-content-height');
          }
          this.resizeContainer.style.height = height + 'px';
        }
      }
    }, {
      key: "setMousePos",
      value: function setMousePos() {
        var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        this.savedMousePos = pos;
      }
    }, {
      key: "updateResizeContainerSize",
      value: function updateResizeContainerSize() {
        var _this$savedMousePos2 = this.savedMousePos,
          x = _this$savedMousePos2.x,
          y = _this$savedMousePos2.y,
          direction = _this$savedMousePos2.direction,
          altKey = _this$savedMousePos2.altKey;
        if (!x || !y) return;
        var _this$resizeContainer3 = this.resizeContainer.getBoundingClientRect(),
          width = _this$resizeContainer3.width,
          height = _this$resizeContainer3.height,
          right = _this$resizeContainer3.right,
          bottom = _this$resizeContainer3.bottom;
        var _this$scroll$domNode$ = this.scroll.domNode.getBoundingClientRect(),
          scrollWidth = _this$scroll$domNode$.width;
        var minWidth = this.constructor.minContentWidth;
        var newWidth = width;
        var newHeight = height;
        var ratio = this.savedMousePos.ratio;
        var reCalcRatio = false;
        if (direction !== 'bottom') {
          newWidth -= right - x;
          // разрешаем оверсайз только при ручном ресайзе
          if (newWidth > scrollWidth && !this.map.get('allowOverWidth')) {
            this.map.set('allowOverWidth', true);
          }
          if (newWidth < minWidth) {
            newWidth = minWidth;
          } else if (!this.allowOverWidth && newWidth > this.maxContentWidth) {
            newWidth = this.maxContentWidth;
          } else if (newWidth > this.maxContentOverWidth) {
            newWidth = this.maxContentOverWidth;
          }
          if (direction === 'right') {
            reCalcRatio = true;
          }
        }
        if (direction === 'bottom' || direction === 'bottom-right' && altKey) {
          newHeight -= bottom - y;
          reCalcRatio = true;
        }
        if (reCalcRatio) {
          ratio = newWidth / newHeight;
        }
        this.setResizeContainerSize({
          width: newWidth,
          ratio: ratio
        });
      }
    }, {
      key: "updateContainerSizeContinuously",
      value: function updateContainerSizeContinuously() {
        var _this2 = this;
        var clear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var update = function update() {
          if (!_this2.savedMousePos) {
            return;
          }
          _this2.updateResizeContainerSize();
          _this2.updateContainerSizeFrameRequest = requestAnimationFrame(update);
        };
        if (clear) {
          if (this.updateContainerSizeFrameRequest) {
            cancelAnimationFrame(this.updateContainerSizeFrameRequest);
          }
        } else {
          update();
        }
      }
    }, {
      key: "onStartResizeBlot",
      value: function onStartResizeBlot() {
        this.updateContainerSizeContinuously();
        this.editor.emitter.emit('embed-resize-start', {});
      }
    }, {
      key: "onEndResizeBlot",
      value: function onEndResizeBlot() {
        this.updateContainerSizeContinuously(true);
        this.editor.emitter.emit('embed-resize-end', {});
      }
    }, {
      key: "allowResizeHeight",
      value: function allowResizeHeight() {
        var opts = {};
        if (this.getResizeOpts) {
          opts = this.getResizeOpts();
        }
        if (opts.hasOwnProperty('allowResizeHeight')) {
          return opts.allowResizeHeight;
        }
        var allowedResizePoints = opts.allowedResizePoints;
        if (allowedResizePoints) {
          if (typeof allowedResizePoints === 'string') {
            allowedResizePoints = [allowedResizePoints];
          }
          var result = false;
          RESIZE_POINTS.filter(function (point) {
            return point !== 'right';
          }).forEach(function (point) {
            if (allowedResizePoints.includes(point)) {
              result = true;
            }
          });
          return result;
        }
        return true;
      }
    }]);
    return _class2;
  }(superclass);
};
Resizeable.initMap = function (map, store) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (params.hasOwnProperty('width')) {
    map.set('width', params.width || null);
    map.set('ratio', params.ratio || null);
  }
  map.set('allowOverWidth', params.allowOverWidth || false);
};
/* harmony default export */ const resizeable = (Resizeable);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/scss/fullwidth.scss
var fullwidth = __webpack_require__(50450);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/mixins/fullWidth.js
function fullWidth_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { fullWidth_typeof = function _typeof(obj) { return typeof obj; }; } else { fullWidth_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return fullWidth_typeof(obj); }

function fullWidth_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function fullWidth_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { fullWidth_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { fullWidth_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }













function fullWidth_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function fullWidth_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function fullWidth_createClass(Constructor, protoProps, staticProps) { if (protoProps) fullWidth_defineProperties(Constructor.prototype, protoProps); if (staticProps) fullWidth_defineProperties(Constructor, staticProps); return Constructor; }
function fullWidth_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { fullWidth_get = Reflect.get; } else { fullWidth_get = function _get(target, property, receiver) { var base = fullWidth_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return fullWidth_get(target, property, receiver || target); }
function fullWidth_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = fullWidth_getPrototypeOf(object); if (object === null) break; } return object; }
function fullWidth_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) fullWidth_setPrototypeOf(subClass, superClass); }
function fullWidth_setPrototypeOf(o, p) { fullWidth_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return fullWidth_setPrototypeOf(o, p); }
function fullWidth_createSuper(Derived) { var hasNativeReflectConstruct = fullWidth_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = fullWidth_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = fullWidth_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return fullWidth_possibleConstructorReturn(this, result); }; }
function fullWidth_possibleConstructorReturn(self, call) { if (call && (fullWidth_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return fullWidth_assertThisInitialized(self); }
function fullWidth_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function fullWidth_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function fullWidth_getPrototypeOf(o) { fullWidth_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return fullWidth_getPrototypeOf(o); }
function fullWidth_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var FULLWIDTH_CLASSES = {
  enabled: 'fullwidth-mixin-enabled',
  animate: 'fullwidth-mixin-animate',
  delayed: 'fullwidth-mixin-animate-delayed'
};

// отступы слева и справа, которые нужно оставить для FullWidth елемента,
// чтобы редактор смог отрендерить элементы интерфейса, которые находятся за пределами scrollBlot'a слева и справа
var LEFT_MARGIN = 55;
var RIGHT_MARGIN = 55;
var FullWidthMixin = function FullWidthMixin(superclass) {
  return /*#__PURE__*/function (_superclass) {
    fullWidth_inherits(_class2, _superclass);
    var _super = fullWidth_createSuper(_class2);
    function _class2() {
      var _this;
      fullWidth_classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      fullWidth_defineProperty(fullWidth_assertThisInitialized(_this), "onEditorBodyResize", function () {
        _this.render();
      });
      _this.fullWidth = {
        default: false,
        wrapperNode: _this.domNode,
        scrollNode: _this.domNode,
        _animation: false,
        _transition: parseInt(fullwidth.fullwidthTransition) || 0,
        _state: false,
        submenu: 'layout',
        margins: {
          left: LEFT_MARGIN,
          right: RIGHT_MARGIN,
          toolbar: 37
        },
        afterFunc: function afterFunc() {}
      };
      _this.fullwidthMenuMargin = 0;
      return _this;
    }
    fullWidth_createClass(_class2, [{
      key: "attach",
      value: function attach() {
        fullWidth_get(fullWidth_getPrototypeOf(_class2.prototype), "attach", this).call(this);
        this.editor.emitter.on('editorBodyResize', this.onEditorBodyResize);
      }
    }, {
      key: "detach",
      value: function detach() {
        fullWidth_get(fullWidth_getPrototypeOf(_class2.prototype), "detach", this).call(this);
        this.editor.emitter.off('editorBodyResize', this.onEditorBodyResize);
      }
    }, {
      key: "fullwidthUnavailable",
      get: function get() {
        if (this.blotConfig && this.blotConfig.disableFullwidthMode || this.getWrapper && this.getWrapper().parent && this.getWrapper().parent.constructor.blotName === 'gridCol') {
          return true;
        }
        return false;
      }
    }, {
      key: "fullwidthMode",
      get: function get() {
        var mode = this.fullWidth.default ? true : false;
        if (this.fullwidthUnavailable) {
          mode = false;
        } else {
          var fullwidthMode = this.map.get('fullwidthMode');
          if (typeof fullwidthMode !== "undefined") {
            mode = fullwidthMode;
          }
        }
        return mode;
      }
    }, {
      key: "toggleFullwidth",
      value: function toggleFullwidth() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var mode;
        if (params.hasOwnProperty('mode')) {
          mode = params.mode ? true : false;
        } else {
          mode = !this.fullwidthMode;
        }
        this.fullWidth._animation = true;
        this.map.set('fullwidthMode', mode);
        this.renderFullWidth();
      }
    }, {
      key: "isResizeAvailable",
      value: function isResizeAvailable() {
        if (this.fullwidthMode || this.inTransition) {
          return false;
        } else {
          return true;
        }
      }
    }, {
      key: "render",
      value: function render() {
        fullWidth_get(fullWidth_getPrototypeOf(_class2.prototype), "render", this).call(this);
        this.renderFullWidth();
      }
    }, {
      key: "inTransition",
      get: function get() {
        return this._animationInProgress;
      }
    }, {
      key: "contextMenu",
      get: function get() {
        var i18n = this.editor.plugins.i18n;
        var menu = fullWidth_get(fullWidth_getPrototypeOf(_class2.prototype), "contextMenu", this);
        var isFullwidthMode = this.fullwidthMode;
        if (!this.fullwidthUnavailable) {
          var fullWidth = {
            label: i18n.get('fullwidth.menu_item'),
            index: 0,
            group: 0,
            action: 'toggleFullwidth',
            icon: isFullwidthMode ? icons/* IconDone */.EZi : false,
            style: isFullwidthMode ? 'done' : 'undone'
          };
          if (this.fullWidth.submenu) {
            menu[this.fullWidth.submenu] = {
              submenu: {
                fullWidth: fullWidth
              }
            };
          } else {
            menu['fullWidth'] = fullWidth;
          }
        }
        return menu;
      }
    }, {
      key: "fullwidthPosition",
      get: function get() {
        var fullwidth = false;
        var editorWidth = this.editor.scroll.domNode.offsetWidth;
        var containerWidth = this.scroll.domNode.offsetWidth;
        var scrollingContainerWidth = this.editor.scrollingContainer.offsetWidth;
        var blotScrollWidth = this.fullWidth.scrollNode.offsetWidth;
        if (this.fullwidthMode && containerWidth >= editorWidth && blotScrollWidth + this.fullWidth.margins.toolbar >= containerWidth && scrollingContainerWidth - this.fullWidth.margins.left - this.fullWidth.margins.right > containerWidth) {
          fullwidth = true;
        }
        var result = {
          enabled: false,
          width: 'auto',
          marginLeft: 0,
          blotScrollWidth: blotScrollWidth,
          containerWidth: containerWidth,
          editorWidth: editorWidth
        };
        if (fullwidth) {
          result.enabled = true;
          result.width = scrollingContainerWidth - this.fullWidth.margins.left - this.fullWidth.margins.right;
          result.marginLeft = this.fullWidth.margins.left + (containerWidth - scrollingContainerWidth) / 2;
        }
        return result;
      }
    }, {
      key: "isFullwidth",
      get: function get() {
        var position = this.fullwidthPosition;
        return position.enabled;
      }
    }, {
      key: "animateClasses",
      value: function () {
        var _animateClasses = fullWidth_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(add) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!add) {
                    _context.next = 4;
                    break;
                  }
                  this.fullWidth.wrapperNode.classList.add(FULLWIDTH_CLASSES.animate, FULLWIDTH_CLASSES.delayed);
                  _context.next = 8;
                  break;
                case 4:
                  this.fullWidth.wrapperNode.classList.remove(FULLWIDTH_CLASSES.animate);
                  _context.next = 7;
                  return timeout(50);
                case 7:
                  this.fullWidth.wrapperNode.classList.remove(FULLWIDTH_CLASSES.delayed);
                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
        function animateClasses(_x) {
          return _animateClasses.apply(this, arguments);
        }
        return animateClasses;
      }()
    }, {
      key: "renderFullWidth",
      value: function renderFullWidth() {
        var _this2 = this;
        var fullwidth = this.fullwidthPosition;
        if (this.fullWidth._state === fullwidth.width + fullwidth.marginLeft || fullwidth.enabled === false && this.fullWidth._state === false) {
          if (fullwidth.enabled) {
            this.calcBlotMenuMargin(fullwidth);
          }
          this.fullWidth._animation = false;
          return fullwidth;
        }
        if (this.fullWidth._animation) {
          this._animationInProgress = true;
          if (fullwidth.enabled) {
            clearTimeout(this._animationTimeout);
            var changeWidth = this.fullWidth.wrapperNode.offsetWidth !== fullwidth.width;
            this.fullWidth._state = fullwidth.width + fullwidth.marginLeft;
            if (changeWidth) {
              this.animateClasses(true);
              this.fullWidth.wrapperNode.style.width = Math.max(fullwidth.editorWidth, fullwidth.blotScrollWidth) + 'px';
            }
            setTimeout(function () {
              _this2.fullWidth.wrapperNode.classList.add(FULLWIDTH_CLASSES.enabled);
              _this2.fullWidth.wrapperNode.style.marginLeft = fullwidth.marginLeft + 'px';
              if (changeWidth) {
                _this2.fullWidth.wrapperNode.style.width = fullwidth.width + 'px';
              }
            }, 0);
            this._animationTimeout = setTimeout(function () {
              _this2.animateClasses(false);
              _this2.fullWidth.afterFunc();
              _this2._animationInProgress = false;
              _this2.fullWidth._animation = false;
            }, changeWidth ? this.fullWidth._transition : 1);
          } else {
            clearTimeout(this._animationTimeout);
            this.fullWidth._state = false;
            this.animateClasses(true);
            this.fullWidth.wrapperNode.style.width = fullwidth.editorWidth + 'px';
            this.fullWidth.wrapperNode.style.marginLeft = fullwidth.marginLeft + 'px';
            this._animationTimeout = setTimeout(function () {
              _this2.fullWidth.wrapperNode.style.width = fullwidth.width;
              _this2.fullWidth.wrapperNode.classList.remove(FULLWIDTH_CLASSES.enabled);
              _this2.animateClasses(false);
              _this2.fullWidth.afterFunc();
              _this2._animationInProgress = false;
              _this2.fullWidth._animation = false;
            }, this.fullWidth._transition);
          }
        } else {
          if (fullwidth.enabled) {
            this.fullWidth.wrapperNode.classList.add(FULLWIDTH_CLASSES.enabled);
            this.fullWidth.wrapperNode.style.marginLeft = fullwidth.marginLeft + 'px';
            this.fullWidth.wrapperNode.style.width = fullwidth.width + 'px';
            this.fullWidth._state = fullwidth.width + fullwidth.marginLeft;
          } else {
            this.fullWidth.wrapperNode.classList.remove(FULLWIDTH_CLASSES.enabled);
            this.fullWidth.wrapperNode.style.marginLeft = fullwidth.marginLeft + 'px';
            this.fullWidth.wrapperNode.style.width = fullwidth.width;
            this.fullWidth._state = false;
          }
          this.fullWidth.afterFunc();
        }
        this.calcBlotMenuMargin(fullwidth, this.fullWidth._transition + 100);
        return fullwidth;
      }
    }, {
      key: "calcBlotMenuMargin",
      value: function () {
        var _calcBlotMenuMargin = fullWidth_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(fullwidth, delay) {
          var menuMargin, containerWidth, blotScrollWidth;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return timeout(delay);
                case 2:
                  menuMargin = 0;
                  if (fullwidth.enabled) {
                    containerWidth = this.scroll.domNode.offsetWidth + this.fullWidth.margins.left;
                    blotScrollWidth = this.fullWidth.scrollNode.offsetWidth;
                    menuMargin = Math.min(0, (containerWidth - blotScrollWidth) / 2);
                  }
                  this.setBlotMenuMargin(menuMargin);
                  return _context2.abrupt("return", menuMargin);
                case 6:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));
        function calcBlotMenuMargin(_x2, _x3) {
          return _calcBlotMenuMargin.apply(this, arguments);
        }
        return calcBlotMenuMargin;
      }()
    }, {
      key: "setBlotMenuMargin",
      value: function setBlotMenuMargin(margin) {
        this.fullwidthMenuMargin = parseInt(margin) || 0;
      }
    }, {
      key: "getBlotInsertParams",
      value: function getBlotInsertParams(blotRange, contextHelper) {
        var params = fullWidth_get(fullWidth_getPrototypeOf(_class2.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
        return (0,util/* mergeDeep */.Ee)(params, {
          initParams: {
            fullwidth: this.map.get('fullwidthMode')
          }
        });
      }
    }]);
    return _class2;
  }(superclass);
};
FullWidthMixin.initMap = function (map, store) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var keys = ['fullwidth', 'fullwidthmode'];
  for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
    var key = _keys[_i];
    if (params.hasOwnProperty(key)) {
      map.set('fullwidthMode', String(params[key]) === 'true' ? true : false);
    }
  }
};
/* harmony default export */ const fullWidth = (FullWidthMixin);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/mixins/withCaption.js
function withCaption_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { withCaption_typeof = function _typeof(obj) { return typeof obj; }; } else { withCaption_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return withCaption_typeof(obj); }













function withCaption_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function withCaption_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function withCaption_createClass(Constructor, protoProps, staticProps) { if (protoProps) withCaption_defineProperties(Constructor.prototype, protoProps); if (staticProps) withCaption_defineProperties(Constructor, staticProps); return Constructor; }
function withCaption_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { withCaption_get = Reflect.get; } else { withCaption_get = function _get(target, property, receiver) { var base = withCaption_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return withCaption_get(target, property, receiver || target); }
function withCaption_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = withCaption_getPrototypeOf(object); if (object === null) break; } return object; }
function withCaption_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) withCaption_setPrototypeOf(subClass, superClass); }
function withCaption_setPrototypeOf(o, p) { withCaption_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return withCaption_setPrototypeOf(o, p); }
function withCaption_createSuper(Derived) { var hasNativeReflectConstruct = withCaption_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = withCaption_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = withCaption_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return withCaption_possibleConstructorReturn(this, result); }; }
function withCaption_possibleConstructorReturn(self, call) { if (call && (withCaption_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return withCaption_assertThisInitialized(self); }
function withCaption_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function withCaption_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function withCaption_getPrototypeOf(o) { withCaption_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return withCaption_getPrototypeOf(o); }
function withCaption_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var WithCaption = function WithCaption(superclass) {
  return /*#__PURE__*/function (_superclass) {
    withCaption_inherits(_class2, _superclass);
    var _super = withCaption_createSuper(_class2);
    function _class2() {
      var _this;
      withCaption_classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      withCaption_defineProperty(withCaption_assertThisInitialized(_this), "addCaption", function () {
        var captionId = _this.map.get('caption');
        var caption = captionId && _this.editor.findById(captionId);
        if (caption && caption.showCaption) {
          caption.showCaption();
        }
      });
      _this.isCaptionHiding = true; // скрываемая подпись
      return _this;
    }
    withCaption_createClass(_class2, [{
      key: "contextMenu",
      get: function get() {
        var i18n = this.editor.plugins.i18n;
        var menu = withCaption_get(withCaption_getPrototypeOf(_class2.prototype), "contextMenu", this);
        menu['addCaption'] = {
          label: i18n.get('block_menu.add_caption'),
          index: -3,
          group: 0,
          action: 'addCaption',
          stackable: false
        };
        return menu;
      }

      /**
       * Событие при клике на пункт меню
       * показывает caption
       */
    }]);
    return _class2;
  }(superclass);
};
/* harmony default export */ const withCaption = (WithCaption);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/blockMenu/blockMenuHeaderItem.js
function blockMenuHeaderItem_extends() { blockMenuHeaderItem_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return blockMenuHeaderItem_extends.apply(this, arguments); }


function blockMenuHeaderItem_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function blockMenuHeaderItem_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function blockMenuHeaderItem_createClass(Constructor, protoProps, staticProps) { if (protoProps) blockMenuHeaderItem_defineProperties(Constructor.prototype, protoProps); if (staticProps) blockMenuHeaderItem_defineProperties(Constructor, staticProps); return Constructor; }
function blockMenuHeaderItem_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BlockMenuHeaderItem = /*#__PURE__*/function () {
  function BlockMenuHeaderItem() {
    var _this = this;
    blockMenuHeaderItem_classCallCheck(this, BlockMenuHeaderItem);
    blockMenuHeaderItem_defineProperty(this, "onClick", function (event) {
      _this.props.onClick && _this.props.onClick();
    });
    blockMenuHeaderItem_defineProperty(this, "onMouseDown", function (event) {
      event.preventDefault();
    });
  }
  blockMenuHeaderItem_createClass(BlockMenuHeaderItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        id = _this$props.id,
        Icon = _this$props.icon,
        active = _this$props.active,
        disabled = _this$props.disabled;
      var tooltipAttrs = this.props.tooltipAttrs;
      if (!tooltipAttrs) {
        tooltipAttrs = {};
      }
      var classes = ['icon'];
      if (active) {
        classes.push('active');
      }
      if (disabled) {
        classes.push('disabled');
      }
      return (0,preact_module.h)("div", blockMenuHeaderItem_extends({
        className: "block-menu-header-item",
        onMouseDown: this.onMouseDown,
        onClick: this.onClick,
        "data-menu-id": id
      }, tooltipAttrs), (0,preact_module.h)("div", {
        className: classes.join(' ')
      }, (0,preact_module.h)(Icon, null)));
    }
  }]);
  return BlockMenuHeaderItem;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/blockMenu/blockMenuHeader.js
function blockMenuHeader_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { blockMenuHeader_typeof = function _typeof(obj) { return typeof obj; }; } else { blockMenuHeader_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return blockMenuHeader_typeof(obj); }









function blockMenuHeader_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function blockMenuHeader_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function blockMenuHeader_createClass(Constructor, protoProps, staticProps) { if (protoProps) blockMenuHeader_defineProperties(Constructor.prototype, protoProps); if (staticProps) blockMenuHeader_defineProperties(Constructor, staticProps); return Constructor; }
function blockMenuHeader_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) blockMenuHeader_setPrototypeOf(subClass, superClass); }
function blockMenuHeader_setPrototypeOf(o, p) { blockMenuHeader_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return blockMenuHeader_setPrototypeOf(o, p); }
function blockMenuHeader_createSuper(Derived) { var hasNativeReflectConstruct = blockMenuHeader_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = blockMenuHeader_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = blockMenuHeader_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return blockMenuHeader_possibleConstructorReturn(this, result); }; }
function blockMenuHeader_possibleConstructorReturn(self, call) { if (call && (blockMenuHeader_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return blockMenuHeader_assertThisInitialized(self); }
function blockMenuHeader_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function blockMenuHeader_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function blockMenuHeader_getPrototypeOf(o) { blockMenuHeader_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return blockMenuHeader_getPrototypeOf(o); }

var BlockMenuHeader = /*#__PURE__*/function (_Component) {
  blockMenuHeader_inherits(BlockMenuHeader, _Component);
  var _super = blockMenuHeader_createSuper(BlockMenuHeader);
  function BlockMenuHeader() {
    blockMenuHeader_classCallCheck(this, BlockMenuHeader);
    return _super.apply(this, arguments);
  }
  blockMenuHeader_createClass(BlockMenuHeader, [{
    key: "render",
    value: function render() {
      return (0,preact_module.h)("div", {
        className: "block-menu-group block-menu-header-menu"
      }, this.props.children);
    }
  }]);
  return BlockMenuHeader;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/attachment/imageBlotMenuHeader.js
function imageBlotMenuHeader_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { imageBlotMenuHeader_typeof = function _typeof(obj) { return typeof obj; }; } else { imageBlotMenuHeader_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return imageBlotMenuHeader_typeof(obj); }











function imageBlotMenuHeader_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function imageBlotMenuHeader_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function imageBlotMenuHeader_createClass(Constructor, protoProps, staticProps) { if (protoProps) imageBlotMenuHeader_defineProperties(Constructor.prototype, protoProps); if (staticProps) imageBlotMenuHeader_defineProperties(Constructor, staticProps); return Constructor; }
function imageBlotMenuHeader_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) imageBlotMenuHeader_setPrototypeOf(subClass, superClass); }
function imageBlotMenuHeader_setPrototypeOf(o, p) { imageBlotMenuHeader_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return imageBlotMenuHeader_setPrototypeOf(o, p); }
function imageBlotMenuHeader_createSuper(Derived) { var hasNativeReflectConstruct = imageBlotMenuHeader_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = imageBlotMenuHeader_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = imageBlotMenuHeader_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return imageBlotMenuHeader_possibleConstructorReturn(this, result); }; }
function imageBlotMenuHeader_possibleConstructorReturn(self, call) { if (call && (imageBlotMenuHeader_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return imageBlotMenuHeader_assertThisInitialized(self); }
function imageBlotMenuHeader_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function imageBlotMenuHeader_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function imageBlotMenuHeader_getPrototypeOf(o) { imageBlotMenuHeader_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return imageBlotMenuHeader_getPrototypeOf(o); }
function imageBlotMenuHeader_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





function getState(map) {
  return {
    align: map.get('align') || 'center',
    fullwidth: map.get('fullwidthMode')
  };
}
var ImageBlotMenuHeader = /*#__PURE__*/function (_Component) {
  imageBlotMenuHeader_inherits(ImageBlotMenuHeader, _Component);
  var _super = imageBlotMenuHeader_createSuper(ImageBlotMenuHeader);
  function ImageBlotMenuHeader(props) {
    var _this;
    imageBlotMenuHeader_classCallCheck(this, ImageBlotMenuHeader);
    _this = _super.call(this, props);
    imageBlotMenuHeader_defineProperty(imageBlotMenuHeader_assertThisInitialized(_this), "onMapChange", function () {
      var map = _this.props.blot.map;
      _this.setState(getState(map));
    });
    imageBlotMenuHeader_defineProperty(imageBlotMenuHeader_assertThisInitialized(_this), "setFullWidth", function () {
      var _this$props = _this.props,
        blot = _this$props.blot,
        menu = _this$props.menu;
      if (blot.toggleFullwidth) {
        blot.toggleFullwidth();
      }
      menu.onMenuClose();
    });
    _this.state = getState(props.blot.map);
    return _this;
  }
  imageBlotMenuHeader_createClass(ImageBlotMenuHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var blot = this.props.blot;
      var store = blot.editor.store;
      store.observe(blot.map, this.onMapChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var blot = this.props.blot;
      var store = blot.editor.store;
      store.unobserve(blot.map, this.onMapChange);
    }
  }, {
    key: "setAlign",
    value: function setAlign(align) {
      var _this$props2 = this.props,
        blot = _this$props2.blot,
        editor = _this$props2.blot.editor,
        menu = _this$props2.menu;
      if (this.state.fullwidth && blot.toggleFullwidth) {
        blot.toggleFullwidth();
      }
      editor.exec('set-align', align);
      menu.onMenuClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        align = _this$state.align,
        fullwidth = _this$state.fullwidth;
      var i18n = this.props.blot.editor.plugins.i18n;
      var tooltips = {
        left: imageBlotMenuHeader_defineProperty({}, tooltipManager/* TOOLTIP_ATTR */.qZ, i18n.get('block_menu.embed_align.left')),
        center: imageBlotMenuHeader_defineProperty({}, tooltipManager/* TOOLTIP_ATTR */.qZ, i18n.get('block_menu.embed_align.center')),
        right: imageBlotMenuHeader_defineProperty({}, tooltipManager/* TOOLTIP_ATTR */.qZ, i18n.get('block_menu.embed_align.right')),
        default: imageBlotMenuHeader_defineProperty({}, tooltipManager/* TOOLTIP_ATTR */.qZ, i18n.get('block_menu.embed_align.default')),
        fullWidth: imageBlotMenuHeader_defineProperty({}, tooltipManager/* TOOLTIP_ATTR */.qZ, i18n.get('block_menu.embed_align.full_width'))
      };
      for (var key in tooltips) {
        tooltips[key][tooltipManager/* TOOLTIP_ADD_CLASS */.Bg] = 'text-align-tooltip';
      }
      return (0,preact_module.h)(BlockMenuHeader, null, (0,preact_module.h)(BlockMenuHeaderItem, {
        tooltipAttrs: tooltips.left,
        active: align === 'left' && !fullwidth,
        onClick: this.setAlign.bind(this, 'left'),
        icon: icons/* EmbedAlignLeft */.sws
      }), (0,preact_module.h)(BlockMenuHeaderItem, {
        tooltipAttrs: tooltips.center,
        active: align === 'center' && !fullwidth,
        onClick: this.setAlign.bind(this, 'center'),
        icon: icons/* EmbedAlignCenter */.fm
      }), (0,preact_module.h)(BlockMenuHeaderItem, {
        tooltipAttrs: tooltips.right,
        active: align === 'right' && !fullwidth,
        onClick: this.setAlign.bind(this, 'right'),
        icon: icons/* EmbedAlignRight */.vSI
      }), (0,preact_module.h)(BlockMenuHeaderItem, {
        tooltipAttrs: tooltips.default,
        active: align === 'full' && !fullwidth,
        onClick: this.setAlign.bind(this, 'full'),
        icon: icons/* EmbedAlignFullWidth */.pV3
      }), (0,preact_module.h)(BlockMenuHeaderItem, {
        tooltipAttrs: tooltips.fullWidth,
        active: fullwidth,
        onClick: this.setFullWidth,
        icon: icons/* IconFullWidthMode */._CN
      }));
    }
  }]);
  return ImageBlotMenuHeader;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/progressRing.js
function progressRing_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { progressRing_typeof = function _typeof(obj) { return typeof obj; }; } else { progressRing_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return progressRing_typeof(obj); }










function progressRing_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function progressRing_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function progressRing_createClass(Constructor, protoProps, staticProps) { if (protoProps) progressRing_defineProperties(Constructor.prototype, protoProps); if (staticProps) progressRing_defineProperties(Constructor, staticProps); return Constructor; }
function progressRing_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) progressRing_setPrototypeOf(subClass, superClass); }
function progressRing_setPrototypeOf(o, p) { progressRing_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return progressRing_setPrototypeOf(o, p); }
function progressRing_createSuper(Derived) { var hasNativeReflectConstruct = progressRing_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = progressRing_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = progressRing_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return progressRing_possibleConstructorReturn(this, result); }; }
function progressRing_possibleConstructorReturn(self, call) { if (call && (progressRing_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return progressRing_assertThisInitialized(self); }
function progressRing_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function progressRing_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function progressRing_getPrototypeOf(o) { progressRing_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return progressRing_getPrototypeOf(o); }

var ProgressRing = /*#__PURE__*/function (_Component) {
  progressRing_inherits(ProgressRing, _Component);
  var _super = progressRing_createSuper(ProgressRing);
  function ProgressRing(props) {
    var _this;
    progressRing_classCallCheck(this, ProgressRing);
    _this = _super.call(this, props);
    var _this$props = _this.props,
      radius = _this$props.radius,
      stroke = _this$props.stroke;
    //чтобы получить радиус кольца по макету в props.radius надо передавать radius + stroke * 2
    _this.normalizedRadius = radius - stroke * 2;
    _this.circumference = _this.normalizedRadius * 2 * Math.PI;
    return _this;
  }
  progressRing_createClass(ProgressRing, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        radius = _this$props2.radius,
        stroke = _this$props2.stroke,
        progress = _this$props2.progress,
        ringColor = _this$props2.ringColor,
        progressColor = _this$props2.progressColor,
        withPercent = _this$props2.withPercent,
        _this$props2$animatio = _this$props2.animation,
        animation = _this$props2$animatio === void 0 ? false : _this$props2$animatio;
      var strokeDashoffset = this.circumference - progress / 100 * this.circumference;
      var precentCounter = null;
      if (withPercent) {
        precentCounter = (0,preact_module.h)("div", {
          className: "progress-ring-percent"
        }, progress + '%');
      }
      var secondCirceClassName = ['progress-ring'];
      if (animation) {
        secondCirceClassName.push('progress-ring-animated');
      }
      return (0,preact_module.h)("div", {
        className: "editor-progress-ring"
      }, precentCounter, (0,preact_module.h)("svg", {
        height: radius * 2,
        width: radius * 2
      }, (0,preact_module.h)("circle", {
        className: "progress-ring",
        stroke: ringColor,
        fill: "transparent",
        strokeWidth: stroke,
        "stroke-width": stroke,
        r: this.normalizedRadius,
        cx: radius,
        cy: radius
      }), (0,preact_module.h)("circle", {
        className: secondCirceClassName.join(' '),
        stroke: progressColor,
        fill: "transparent",
        strokeWidth: stroke,
        strokeDasharray: this.circumference + ' ' + this.circumference,
        style: {
          strokeDashoffset: strokeDashoffset
        },
        "stroke-width": stroke,
        r: this.normalizedRadius,
        cx: radius,
        cy: radius
      })));
    }
  }]);
  return ProgressRing;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/errors/quotaerror.js
function quotaerror_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { quotaerror_typeof = function _typeof(obj) { return typeof obj; }; } else { quotaerror_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return quotaerror_typeof(obj); }











function quotaerror_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function quotaerror_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) quotaerror_setPrototypeOf(subClass, superClass); }
function quotaerror_createSuper(Derived) { var hasNativeReflectConstruct = quotaerror_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = quotaerror_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = quotaerror_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return quotaerror_possibleConstructorReturn(this, result); }; }
function quotaerror_possibleConstructorReturn(self, call) { if (call && (quotaerror_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return quotaerror_assertThisInitialized(self); }
function quotaerror_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, quotaerror_getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return quotaerror_setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (quotaerror_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) quotaerror_setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function quotaerror_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function quotaerror_setPrototypeOf(o, p) { quotaerror_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return quotaerror_setPrototypeOf(o, p); }
function quotaerror_getPrototypeOf(o) { quotaerror_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return quotaerror_getPrototypeOf(o); }
var QuotaError = /*#__PURE__*/function (_Error) {
  quotaerror_inherits(QuotaError, _Error);
  var _super = quotaerror_createSuper(QuotaError);
  function QuotaError(message, file) {
    var _this;
    quotaerror_classCallCheck(this, QuotaError);
    _this = _super.call(this, message);
    _this.file = file;
    return _this;
  }
  return QuotaError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/util/popup.js
var popup = __webpack_require__(92143);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/popupNotification.js
function popupNotification_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function popupNotification_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function popupNotification_createClass(Constructor, protoProps, staticProps) { if (protoProps) popupNotification_defineProperties(Constructor.prototype, protoProps); if (staticProps) popupNotification_defineProperties(Constructor, staticProps); return Constructor; }
function popupNotification_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var PopupNotification = /*#__PURE__*/function () {
  function PopupNotification() {
    var _this = this;
    popupNotification_classCallCheck(this, PopupNotification);
    popupNotification_defineProperty(this, "onRef", function (node) {
      _this.domNode = node;
      _this.props.domRef && _this.props.domRef(node);
      _this.popper = null;
    });
    popupNotification_defineProperty(this, "disableRecycling", function () {
      _this.nextBase = null;
    });
    popupNotification_defineProperty(this, "onBodyMouseDown", function (_ref) {
      var target = _ref.target;
      if (target === _this.domNode || _this.domNode.contains(target)) {
        return;
      }
      _this.props.wantsToClose();
    });
    popupNotification_defineProperty(this, "onBodyKeyDown", function (event) {
      _this.props.wantsToClose();
    });
  }
  popupNotification_createClass(PopupNotification, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props = this.props,
        wantsToClose = _this$props.wantsToClose,
        anchorNode = _this$props.anchorNode,
        anchorOptions = _this$props.anchorOptions;
      if (wantsToClose) {
        this.dispatchEventTimeout = setTimeout(function () {
          document.body.addEventListener('mousedown', _this2.onBodyMouseDown);
          document.body.addEventListener('keydown', _this2.onBodyKeyDown);
        }, 0);
      }
      if (anchorNode) {
        this.popper = (0,popup/* createPopper */.f)(anchorNode, this.domNode, anchorOptions);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.dispatchEventTimeout) {
        clearTimeout(this.dispatchEventTimeout);
      }
      document.body.removeEventListener('mousedown', this.onBodyMouseDown);
      document.body.removeEventListener('keydown', this.onBodyKeyDown);
      if (this.popper) {
        this.popper.destroy();
      }
      setTimeout(this.disableRecycling);
    }
  }, {
    key: "render",
    value: function render() {
      return (0,preact_module.h)("div", {
        className: "popup-notification",
        ref: this.onRef
      }, this.props.children);
    }
  }]);
  return PopupNotification;
}();

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/images/loader2.svg
var loader2 = __webpack_require__(29184);
var loader2_default = /*#__PURE__*/__webpack_require__.n(loader2);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/attachment/imageEmptyPlaceholder.js
function imageEmptyPlaceholder_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { imageEmptyPlaceholder_typeof = function _typeof(obj) { return typeof obj; }; } else { imageEmptyPlaceholder_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return imageEmptyPlaceholder_typeof(obj); }
function imageEmptyPlaceholder_extends() { imageEmptyPlaceholder_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return imageEmptyPlaceholder_extends.apply(this, arguments); }












function imageEmptyPlaceholder_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function imageEmptyPlaceholder_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function imageEmptyPlaceholder_createClass(Constructor, protoProps, staticProps) { if (protoProps) imageEmptyPlaceholder_defineProperties(Constructor.prototype, protoProps); if (staticProps) imageEmptyPlaceholder_defineProperties(Constructor, staticProps); return Constructor; }
function imageEmptyPlaceholder_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) imageEmptyPlaceholder_setPrototypeOf(subClass, superClass); }
function imageEmptyPlaceholder_setPrototypeOf(o, p) { imageEmptyPlaceholder_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return imageEmptyPlaceholder_setPrototypeOf(o, p); }
function imageEmptyPlaceholder_createSuper(Derived) { var hasNativeReflectConstruct = imageEmptyPlaceholder_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = imageEmptyPlaceholder_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = imageEmptyPlaceholder_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return imageEmptyPlaceholder_possibleConstructorReturn(this, result); }; }
function imageEmptyPlaceholder_possibleConstructorReturn(self, call) { if (call && (imageEmptyPlaceholder_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return imageEmptyPlaceholder_assertThisInitialized(self); }
function imageEmptyPlaceholder_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function imageEmptyPlaceholder_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function imageEmptyPlaceholder_getPrototypeOf(o) { imageEmptyPlaceholder_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return imageEmptyPlaceholder_getPrototypeOf(o); }
function imageEmptyPlaceholder_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var imageEmptyPlaceholder_isBackspaceKey = (0,lib/* default */.ZP)('backspace');
var imageEmptyPlaceholder_isEnterKey = (0,lib/* default */.ZP)('enter');
var imageEmptyPlaceholder_isEscKey = (0,lib/* default */.ZP)('esc');
var upgradeAccountUrl = 'https://nimbusweb.me/pricing.php';
var minImageWidthForFullLoader = 170;
var minImageWidthForMediumLoader = 110;
var minImageWidthForSmallLoader = 80;
var defaultPlaceholder = (0,preact_module.h)("div", {
  className: "no-image-content-wrapper hidden"
});
function placeHolderState() {
  var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var available = ['placeholderVisible', 'errorNotification'];
  var state = {};
  for (var _i = 0, _available = available; _i < _available.length; _i++) {
    var item = _available[_i];
    if (item === active) {
      state[item] = true;
    } else {
      state[item] = false;
    }
  }
  return state;
}
function setCaretToEnd(input) {
  input.focus();
  input.setSelectionRange(input.value.length, input.value.length);
}
var ImageEmptyPlaceholder = /*#__PURE__*/function (_Component) {
  imageEmptyPlaceholder_inherits(ImageEmptyPlaceholder, _Component);
  var _super = imageEmptyPlaceholder_createSuper(ImageEmptyPlaceholder);
  function ImageEmptyPlaceholder(props) {
    var _this;
    imageEmptyPlaceholder_classCallCheck(this, ImageEmptyPlaceholder);
    _this = _super.call(this, props);
    imageEmptyPlaceholder_defineProperty(imageEmptyPlaceholder_assertThisInitialized(_this), "onPlaceholderRef", function (node) {
      _this.domNode = node;
    });
    imageEmptyPlaceholder_defineProperty(imageEmptyPlaceholder_assertThisInitialized(_this), "onInputNodeRef", function (node) {
      _this.inputNode = node;
    });
    imageEmptyPlaceholder_defineProperty(imageEmptyPlaceholder_assertThisInitialized(_this), "onBrowseBtnRef", function (node) {
      _this.browseBtnNode = node;
    });
    imageEmptyPlaceholder_defineProperty(imageEmptyPlaceholder_assertThisInitialized(_this), "onBufferRef", function (node) {
      _this.bufferNode = node;
    });
    imageEmptyPlaceholder_defineProperty(imageEmptyPlaceholder_assertThisInitialized(_this), "onDeleteRef", function (node) {
      _this.deleteBtnNode = node;
    });
    imageEmptyPlaceholder_defineProperty(imageEmptyPlaceholder_assertThisInitialized(_this), "onAbortRef", function (node) {
      _this.abortBtnNode = node;
    });
    imageEmptyPlaceholder_defineProperty(imageEmptyPlaceholder_assertThisInitialized(_this), "onErrorNotificationRef", function (node) {
      _this.errorPopupNode = node;
    });
    imageEmptyPlaceholder_defineProperty(imageEmptyPlaceholder_assertThisInitialized(_this), "onPlaceholderClick", function (event) {
      if (_this.errorPopupNode && (event.target === _this.errorPopupNode || _this.errorPopupNode.contains(event.target))) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      _this.clearError();
      _this.onFocus();
    });
    imageEmptyPlaceholder_defineProperty(imageEmptyPlaceholder_assertThisInitialized(_this), "onDblClick", function (event) {
      event.preventDefault();
      event.stopPropagation();
    });
    imageEmptyPlaceholder_defineProperty(imageEmptyPlaceholder_assertThisInitialized(_this), "onBrowseClick", function (event) {
      event.preventDefault();
      event.stopPropagation();
      _this.props.blot.editor.plugins.unsplashManager.hidePicker();
      _this.props.blot.onAttachmentChooseFile();
    });
    imageEmptyPlaceholder_defineProperty(imageEmptyPlaceholder_assertThisInitialized(_this), "onUnsplashClick", function (event) {
      event.preventDefault();
      event.stopPropagation();
      _this.props.blot.editor.plugins.unsplashManager.hidePicker();
      _this.props.blot.editor.plugins.unsplashManager.openPicker(_this.props.blot, function (img) {
        _this.props.blot.onImageChooseUnsplash(img);
      });
    });
    imageEmptyPlaceholder_defineProperty(imageEmptyPlaceholder_assertThisInitialized(_this), "onFocus", function () {
      if (_this.inputNode) {
        setCaretToEnd(_this.inputNode);
        _this.focusInput = false;
      }
    });
    imageEmptyPlaceholder_defineProperty(imageEmptyPlaceholder_assertThisInitialized(_this), "hasFocus", function () {
      return document.activeElement === _this.inputNode;
    });
    imageEmptyPlaceholder_defineProperty(imageEmptyPlaceholder_assertThisInitialized(_this), "onInputKeyDown", function (event) {
      event.stopPropagation();
      if (imageEmptyPlaceholder_isBackspaceKey(event) && event.target.value === '') {
        event.preventDefault();
        _this.props.blot.scroll.selection.setRange({
          index: _this.props.blot.offset(_this.props.blot.scroll) - 1,
          length: 0
        });
        _this.props.blot.getWrapper().parent.removeChildById(_this.props.blot.id);
      } else if (imageEmptyPlaceholder_isEnterKey(event) && event.target.value !== '') {
        event.preventDefault();
        _this.props.blot.onEmbedAttachment(event.target.value);
      } else if (imageEmptyPlaceholder_isEscKey(event)) {
        event.preventDefault();
        _this.props.blot.onAttachmentCancelAdd();
      }
    });
    imageEmptyPlaceholder_defineProperty(imageEmptyPlaceholder_assertThisInitialized(_this), "onInput", function (event) {
      _this.setState(function (prevState) {
        var newState = null;
        var text = event.target.value;
        _this.bufferNode.innerHTML = text;
        var placeholderVisible = prevState.placeholderVisible,
          errorNotification = prevState.errorNotification;
        _this.savedInputValue = event.target.value;
        if (event.target.value !== '') {
          _this.inputNode.style.width = _this.bufferNode.clientWidth + 10 + 'px';
          if (placeholderVisible || errorNotification) {
            _this.focusInput = true;
            newState = placeHolderState();
          }
        } else {
          _this.inputNode.style.width = '';
          if (!placeholderVisible) {
            _this.clearError();
            newState = placeHolderState('placeholderVisible');
          }
        }
        return newState;
      });
    });
    imageEmptyPlaceholder_defineProperty(imageEmptyPlaceholder_assertThisInitialized(_this), "onPaste", function (event) {
      event.stopPropagation();
      var files = event.clipboardData.files;
      var url = event.clipboardData.getData('text/plain');
      if (files.length === 1) {
        event.preventDefault();
        if (files[0] && files[0].type && files[0].type.indexOf('image') !== -1) {
          files = [_this.props.blot.editor.plugins.attachmentManager.nFileFromWebFile(files[0])];
          try {
            _this.props.blot.setHTMLFilesForUpload(files);
          } catch (err) {
            _this.props.blot.onSetAttachmentError(err);
          }
        } else {
          _this.props.blot.onSetAttachmentError('Please browse "image" file');
        }
      } else if (url !== '') {
        var hasProtokol = url.match(/(?:(?:[a-z][a-z0-9+.-]*:)(?:.*))/g);
        if (hasProtokol) {
          event.preventDefault();
          _this.savedInputValue = url;
          _this.props.blot.onEmbedAttachment(url);
          _this.setState(placeHolderState());
        }
      }
    });
    imageEmptyPlaceholder_defineProperty(imageEmptyPlaceholder_assertThisInitialized(_this), "onPerformingElMouseDown", function (event) {
      event.preventDefault();
      event.stopPropagation();
    });
    imageEmptyPlaceholder_defineProperty(imageEmptyPlaceholder_assertThisInitialized(_this), "onInputMouseDown", function (event) {
      event.stopPropagation();
    });
    imageEmptyPlaceholder_defineProperty(imageEmptyPlaceholder_assertThisInitialized(_this), "onClickDelete", function (event) {
      _this.focusInput = true;
      _this.savedInputValue = null;
      _this.clearError();
      _this.setState(placeHolderState('placeholderVisible'));
    });
    imageEmptyPlaceholder_defineProperty(imageEmptyPlaceholder_assertThisInitialized(_this), "onClickAbort", function (event) {
      _this.props.blot.onTaskAbortClick();
    });
    imageEmptyPlaceholder_defineProperty(imageEmptyPlaceholder_assertThisInitialized(_this), "onRemoveClick", function (event) {
      event.preventDefault();
      event.stopPropagation();
      _this.props.blot.remove();
    });
    imageEmptyPlaceholder_defineProperty(imageEmptyPlaceholder_assertThisInitialized(_this), "onErrorMouseEnter", function (event) {
      _this.setState(function (prevState) {
        var errorNotification = prevState.errorNotification;
        if (!errorNotification) {
          return {
            'errorNotification': true
          };
        } else {
          return null;
        }
      });
    });
    imageEmptyPlaceholder_defineProperty(imageEmptyPlaceholder_assertThisInitialized(_this), "clearError", function () {
      if (_this.props.blot.props.setAttachmentError) {
        _this.props.blot.props.setAttachmentError = false;
      }
    });
    imageEmptyPlaceholder_defineProperty(imageEmptyPlaceholder_assertThisInitialized(_this), "hideNotification", function () {
      _this.setState(function (prevState) {
        var placeholderVisible = prevState.placeholderVisible;
        if (placeholderVisible) {
          return placeHolderState('placeholderVisible');
        } else {
          return placeHolderState();
        }
      });
    });
    _this.state = {
      placeholderVisible: true
    };
    _this.uploadByUrl = true;
    _this.props.onRenderPlaceholder(imageEmptyPlaceholder_assertThisInitialized(_this));
    return _this;
  }
  imageEmptyPlaceholder_createClass(ImageEmptyPlaceholder, [{
    key: "isUnsplashEnabled",
    value: function isUnsplashEnabled() {
      var _this$props, _this$props$blot, _this$props$blot$edit, _this$props$blot$edit2, _this$props$blot$edit3;
      return (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$blot = _this$props.blot) === null || _this$props$blot === void 0 ? void 0 : (_this$props$blot$edit = _this$props$blot.editor) === null || _this$props$blot$edit === void 0 ? void 0 : (_this$props$blot$edit2 = _this$props$blot$edit.plugins) === null || _this$props$blot$edit2 === void 0 ? void 0 : (_this$props$blot$edit3 = _this$props$blot$edit2.unsplashManager) === null || _this$props$blot$edit3 === void 0 ? void 0 : _this$props$blot$edit3.enabled;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.inputNode && this.bufferNode && this.savedInputValue) {
        this.inputNode.style.width = this.bufferNode.clientWidth + 10 + 'px';
      }
      if (this.focusInput) {
        this.onFocus();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.onRenderPlaceholder();
    }
  }, {
    key: "render",
    value: function render() {
      var _arrgs;
      var _this$props2 = this.props,
        blot = _this$props2.blot,
        abortable = _this$props2.abortable;
      var placeholderVisible = this.state.placeholderVisible;
      var editor = blot.editor;
      var placeholder = defaultPlaceholder;
      var error = null;
      var errorNotification = null;
      var input = null;
      var text = '';
      var addClassName = '';
      var loadingReady = false;
      var styles = {};
      if (blot.props.uploading) {
        addClassName = 'uploading';
        if (!blot._previewOnLoadReady && !this.props.blot.props.file) {
          addClassName += ' wait';
          placeholder = (0,preact_module.h)("div", {
            className: "image-loading-icon"
          }, (0,preact_module.h)((loader2_default()), null));
        } else {
          addClassName += ' on-preview';
          var progressInRing = false;
          var imageOffsets = getContainerOffset(blot.image, blot.domNode);
          var imageWidth = blot.image.width;
          styles = {
            position: 'absolute',
            top: imageOffsets.y + 8 + 'px',
            left: imageOffsets.x + 6 + 'px'
          };
          //в зависимости от ширины изображения генерируем лоадер или же вообще его скрываем если изображение слишком узкое
          if (imageWidth >= minImageWidthForFullLoader) {
            text = 'Uploading ' + blot.props.progress + '%';
            addClassName += ' full-loader';
          } else if (imageWidth < minImageWidthForFullLoader && imageWidth >= minImageWidthForSmallLoader) {
            if (imageWidth >= minImageWidthForMediumLoader) {
              text = blot.props.progress + '%';
              addClassName += ' medium-loader';
            } else if (imageWidth < minImageWidthForMediumLoader) {
              progressInRing = true;
              addClassName += ' small-loader';
            }
          } else {
            addClassName += ' hidden';
          }
          var abortButton = abortable ? (0,preact_module.h)("div", {
            className: "image-placeholder-abort",
            ref: this.onAbortRef,
            onClick: this.onClickAbort,
            onMouseDown: this.onPerformingElMouseDown
          }, (0,preact_module.h)(icons/* IconClose */.bMz, null)) : null;
          placeholder = (0,preact_module.h)("div", {
            className: "no-image-content-wrapper"
          }, (0,preact_module.h)(ProgressRing, {
            radius: 17,
            stroke: 2,
            progress: blot.props.progress,
            ringColor: "rgba(0, 161, 183, 0.2)",
            progressColor: "#00a1b7",
            withPercent: progressInRing
          }), (0,preact_module.h)("div", {
            className: "no-image-text uploading-image"
          }, text), abortButton);
        }
      } else {
        if (blot.props.setAttachmentError) {
          addClassName = 'error';
          if (blot.props.setAttachmentError instanceof QuotaError) {
            error = (0,preact_module.h)("div", {
              className: "no-image-error with-notification",
              onMouseEnter: this.onErrorMouseEnter
            }, (0,preact_module.h)(plugins_i18n/* Text */.xv, {
              id: "image.too_large_error"
            }));
          } else {
            console.error('Unknown attachment error:', blot.props.setAttachmentError);
            error = (0,preact_module.h)("div", {
              className: "no-image-error"
            }, (0,preact_module.h)(plugins_i18n/* Text */.xv, {
              id: "attachment.unknown_error"
            }));
          }
        }
        var deleteButton = false;
        if (placeholderVisible) {
          if (editor.mode === editor.constructor.MODE_EDIT) {
            var textMessage;
            var browseMessage;
            if (this.uploadByUrl) {
              if (blot.container && blot.container.constructor.blotName === 'gridCol') {
                textMessage = (0,preact_module.h)(plugins_i18n/* Text */.xv, {
                  id: "image.add_image_small"
                });
              } else {
                textMessage = (0,preact_module.h)(plugins_i18n/* Text */.xv, {
                  id: "image.add_image"
                });
              }
              browseMessage = (0,preact_module.h)(plugins_i18n/* Text */.xv, {
                id: "image.browse"
              });
            } else {
              browseMessage = (0,preact_module.h)(plugins_i18n/* Text */.xv, {
                id: "image.browse_image"
              });
            }
            var unsplashOption = null;
            if (this.isUnsplashEnabled()) {
              unsplashOption = (0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)("span", null, " ", (0,preact_module.h)(plugins_i18n/* Text */.xv, {
                id: "image.add_image_or"
              }), " "), (0,preact_module.h)("span", {
                className: "image-browse toggle-unsplash",
                onMouseDown: this.onPerformingElMouseDown,
                onClick: this.onUnsplashClick
              }, (0,preact_module.h)(plugins_i18n/* Text */.xv, {
                id: "image.unsplash.name"
              })));
            }
            placeholder = (0,preact_module.h)("div", {
              className: "no-image-content-wrapper"
            }, (0,preact_module.h)("div", {
              className: "no-image-text add-image"
            }, textMessage, (0,preact_module.h)("div", {
              className: "image-browse",
              onMouseDown: this.onPerformingElMouseDown,
              onClick: this.onBrowseClick,
              ref: this.onBrowseBtnRef
            }, browseMessage), unsplashOption, (0,preact_module.h)("div", {
              className: "image-placeholder-delete ml",
              onClick: this.onRemoveClick
            }, (0,preact_module.h)(icons/* IconTrash */.IT9, null))));
          } else {
            placeholder = (0,preact_module.h)("div", {
              className: "no-image-content-wrapper"
            }, (0,preact_module.h)("div", {
              className: "no-image-text add-image readonly-placeholder"
            }, (0,preact_module.h)(plugins_i18n/* Text */.xv, {
              id: "image.readonly_placeholder"
            })));
          }
        } else {
          deleteButton = true;
          placeholder = defaultPlaceholder;
        }
        var bufferText = this.savedInputValue || '';
        if (this.uploadByUrl && editor.mode === editor.constructor.MODE_EDIT) {
          input = (0,preact_module.h)(PlaceholderInput, {
            onDomRef: this.onInputNodeRef,
            onBufferDomRef: this.onBufferRef,
            bufferText: bufferText,
            onInputKeyDown: this.onInputKeyDown,
            onInput: this.onInput,
            onPerformingElMouseDown: this.onPerformingElMouseDown,
            onInputMouseDown: this.onInputMouseDown,
            onPaste: this.onPaste,
            savedInputValue: this.savedInputValue,
            deleteButton: deleteButton,
            onClickDelete: this.onClickDelete
          });
        }
      }
      if (this.state.errorNotification) {
        errorNotification = (0,preact_module.h)(PopupNotification, {
          domRef: this.onErrorNotificationRef,
          anchorNode: this.domNode,
          anchorOptions: {
            placement: 'top-start',
            offset: '0, 25px'
          },
          wantsToClose: this.hideNotification
        }, (0,preact_module.h)("div", {
          className: "image-error-notification"
        }, "You are trying to upload the image with size more than 10 Mb. You can ", (0,preact_module.h)("a", {
          href: upgradeAccountUrl,
          target: "_blank"
        }, "upgrade your account"), " for larger images."));
      }
      var arrgs = (_arrgs = {
        contenteditable: 'false'
      }, imageEmptyPlaceholder_defineProperty(_arrgs, scroll_IGNORE_SELECT_ATTR, 1), imageEmptyPlaceholder_defineProperty(_arrgs, "onMouseDown", this.onPlaceholderClick), imageEmptyPlaceholder_defineProperty(_arrgs, "onDblclick", this.onDblClick), _arrgs);
      return (0,preact_module.h)(plugins_i18n/* IntlProvider */.Pj, null, (0,preact_module.h)("div", imageEmptyPlaceholder_extends({}, arrgs, {
        className: 'no-image-wrapper ' + addClassName,
        ref: this.onPlaceholderRef,
        style: styles
      }), error, input, (0,preact_module.h)(preact_transition_group/* default */.Z, {
        transitionName: "no-image-placeholder",
        transitionEnterTimeout: 200,
        transitionLeave: false
      }, placeholder), (0,preact_module.h)(preact_transition_group/* default */.Z, {
        transitionName: "image-error",
        transitionEnterTimeout: 200,
        transitionLeaveTimeout: 200
      }, errorNotification)));
    }
  }]);
  return ImageEmptyPlaceholder;
}(preact_module/* Component */.wA);

var PlaceholderInput = /*#__PURE__*/function () {
  function PlaceholderInput() {
    var _this2 = this;
    imageEmptyPlaceholder_classCallCheck(this, PlaceholderInput);
    imageEmptyPlaceholder_defineProperty(this, "onRef", function (node) {
      _this2.domNode = node;
      _this2.props.onDomRef(node);
    });
    imageEmptyPlaceholder_defineProperty(this, "onBufferRef", function (node) {
      _this2.bufferDomNode = node;
      _this2.props.onBufferDomRef(node);
    });
  }
  imageEmptyPlaceholder_createClass(PlaceholderInput, [{
    key: "render",
    value: function render() {
      var deleteButton = this.props.deleteButton;
      return (0,preact_module.h)("div", {
        className: "input-wrapper"
      }, (0,preact_module.h)("div", {
        className: "image-link-buffer",
        ref: this.onBufferRef
      }, this.props.bufferText), (0,preact_module.h)("input", {
        className: "image-link-input",
        type: "text",
        ref: this.onRef,
        onKeyDown: this.props.onInputKeyDown,
        onInput: this.props.onInput,
        onMouseDown: this.props.onInputMouseDown,
        onPaste: this.props.onPaste,
        value: this.props.savedInputValue || ''
      }), deleteButton ? (0,preact_module.h)("div", {
        className: "image-placeholder-delete",
        onClick: this.props.onClickDelete,
        onMouseDown: this.props.onPerformingElMouseDown
      }, (0,preact_module.h)(icons/* IconTrash */.IT9, null)) : null);
    }
  }]);
  return PlaceholderInput;
}();
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/components/popupDialog.js
var popupDialog = __webpack_require__(49096);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/components/popupDialogTitle.js
var popupDialogTitle = __webpack_require__(83483);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/components/popupDialogBody.js
var popupDialogBody = __webpack_require__(19617);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/components/infiniteLoader.js
var infiniteLoader = __webpack_require__(77510);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/attachment/imageInfoPopup.js
function imageInfoPopup_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { imageInfoPopup_typeof = function _typeof(obj) { return typeof obj; }; } else { imageInfoPopup_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return imageInfoPopup_typeof(obj); }













function imageInfoPopup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function imageInfoPopup_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { imageInfoPopup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { imageInfoPopup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function imageInfoPopup_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function imageInfoPopup_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function imageInfoPopup_createClass(Constructor, protoProps, staticProps) { if (protoProps) imageInfoPopup_defineProperties(Constructor.prototype, protoProps); if (staticProps) imageInfoPopup_defineProperties(Constructor, staticProps); return Constructor; }
function imageInfoPopup_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) imageInfoPopup_setPrototypeOf(subClass, superClass); }
function imageInfoPopup_setPrototypeOf(o, p) { imageInfoPopup_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return imageInfoPopup_setPrototypeOf(o, p); }
function imageInfoPopup_createSuper(Derived) { var hasNativeReflectConstruct = imageInfoPopup_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = imageInfoPopup_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = imageInfoPopup_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return imageInfoPopup_possibleConstructorReturn(this, result); }; }
function imageInfoPopup_possibleConstructorReturn(self, call) { if (call && (imageInfoPopup_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return imageInfoPopup_assertThisInitialized(self); }
function imageInfoPopup_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function imageInfoPopup_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function imageInfoPopup_getPrototypeOf(o) { imageInfoPopup_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return imageInfoPopup_getPrototypeOf(o); }
function imageInfoPopup_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var ImageInfoPopup = /*#__PURE__*/function (_Component) {
  imageInfoPopup_inherits(ImageInfoPopup, _Component);
  var _super = imageInfoPopup_createSuper(ImageInfoPopup);
  function ImageInfoPopup() {
    var _this;
    imageInfoPopup_classCallCheck(this, ImageInfoPopup);
    _this = _super.call(this);
    imageInfoPopup_defineProperty(imageInfoPopup_assertThisInitialized(_this), "onImageInfoCopyLocationClick", function () {
      var editor = _this.props.editor;
      var i18n = editor.plugins.i18n;
      var _this$props$attachmen = _this.props.attachment,
        url = _this$props$attachmen.url,
        displayUrl = _this$props$attachmen.displayUrl;
      var copyLocation = displayUrl ? displayUrl : getFullUrl(url);
      editor.plugins.copyManager.copy(copyLocation);
    });
    _this.state = {
      imageSize: null
    };
    return _this;
  }
  imageInfoPopup_createClass(ImageInfoPopup, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = imageInfoPopup_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var imageSize;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getImgSize(this.props.attachment.url);
              case 2:
                imageSize = _context.sent;
                this.setState({
                  imageSize: imageSize
                });
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var content;
      if (this.state.imageSize) {
        var _this$state$imageSize = this.state.imageSize,
          width = _this$state$imageSize.width,
          height = _this$state$imageSize.height;
        var _this$props$attachmen2 = this.props.attachment,
          mime = _this$props$attachmen2.mime,
          url = _this$props$attachmen2.url;
        var displayUrl = this.props.attachment.displayUrl || url;
        var type = mime && typeof mime === 'string' ? mime.indexOf('image/') !== -1 && mime.replace('image/', '') : mime;
        var _this$props$blotConfi = this.props.blotConfig.showImageUrlDependOfDisplayUrl,
          showImageUrlDependOfDisplayUrl = _this$props$blotConfi === void 0 ? false : _this$props$blotConfi;
        var info = [{
          label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
            id: "image.image_info_dialog.type"
          }),
          content: type.toUpperCase()
        }, {
          label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
            id: "image.image_info_dialog.size"
          }),
          content: width + 'x' + height
        }];
        // показываем путь к изображению в зависимости от настроек блота
        if (showImageUrlDependOfDisplayUrl && this.props.attachment.displayUrl || !showImageUrlDependOfDisplayUrl) {
          info.push({
            label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
              id: "image.image_info_dialog.location"
            }),
            content: function content() {
              return (0,preact_module.h)("div", {
                className: "popup-image-location"
              }, (0,preact_module.h)("div", {
                className: "image-location-url"
              }, displayUrl), (0,preact_module.h)("div", {
                className: "copy-image-url",
                onClick: _this2.onImageInfoCopyLocationClick
              }, (0,preact_module.h)(plugins_i18n/* Text */.xv, {
                id: "image.image_info_dialog.copy_link"
              })));
            }
          });
        }
        content = (0,preact_module.h)("div", null, info.map(function (el) {
          return (0,preact_module.h)("div", {
            className: "image-info-item"
          }, (0,preact_module.h)("div", {
            className: "image-info-item-label"
          }, el.label), (0,preact_module.h)("div", {
            className: "image-info-item-info"
          }, typeof el.content === 'function' ? (0,preact_module.h)(el.content, null) : el.content));
        }));
      } else {
        content = (0,preact_module.h)(infiniteLoader/* default */.Z, null);
      }
      return (0,preact_module.h)(popupMenu/* default */.Z, {
        wantsToClose: this.props.wantsToClose,
        addClassName: "image-info-popup"
      }, (0,preact_module.h)(popupDialog/* default */.Z, {
        wantsToClose: this.props.wantsToClose
      }, (0,preact_module.h)(popupDialogTitle/* default */.Z, null, (0,preact_module.h)(plugins_i18n/* Text */.xv, {
        id: "image.image_info_dialog.title"
      })), (0,preact_module.h)(popupDialogBody/* default */.Z, {
        onMouseDown: function onMouseDown(event) {
          return event.preventDefault();
        }
      }, content)));
    }
  }]);
  return ImageInfoPopup;
}(preact_module/* Component */.wA);

function getImgSize(url) {
  return new Promise(function (resolve) {
    var newImg = new Image();
    newImg.onload = function () {
      var height = newImg.height;
      var width = newImg.width;
      resolve({
        width: width,
        height: height
      });
    };
    newImg.src = url;
  });
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/attachment/imageTextPopup.js
function imageTextPopup_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { imageTextPopup_typeof = function _typeof(obj) { return typeof obj; }; } else { imageTextPopup_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return imageTextPopup_typeof(obj); }










function imageTextPopup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function imageTextPopup_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { imageTextPopup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { imageTextPopup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function imageTextPopup_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function imageTextPopup_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function imageTextPopup_createClass(Constructor, protoProps, staticProps) { if (protoProps) imageTextPopup_defineProperties(Constructor.prototype, protoProps); if (staticProps) imageTextPopup_defineProperties(Constructor, staticProps); return Constructor; }
function imageTextPopup_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) imageTextPopup_setPrototypeOf(subClass, superClass); }
function imageTextPopup_setPrototypeOf(o, p) { imageTextPopup_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return imageTextPopup_setPrototypeOf(o, p); }
function imageTextPopup_createSuper(Derived) { var hasNativeReflectConstruct = imageTextPopup_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = imageTextPopup_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = imageTextPopup_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return imageTextPopup_possibleConstructorReturn(this, result); }; }
function imageTextPopup_possibleConstructorReturn(self, call) { if (call && (imageTextPopup_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return imageTextPopup_assertThisInitialized(self); }
function imageTextPopup_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function imageTextPopup_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function imageTextPopup_getPrototypeOf(o) { imageTextPopup_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return imageTextPopup_getPrototypeOf(o); }






var imageTextPopup_ImageInfoPopup = /*#__PURE__*/function (_Component) {
  imageTextPopup_inherits(ImageInfoPopup, _Component);
  var _super = imageTextPopup_createSuper(ImageInfoPopup);
  function ImageInfoPopup() {
    var _this;
    imageTextPopup_classCallCheck(this, ImageInfoPopup);
    _this = _super.call(this);
    _this.state = {
      text: null
    };
    return _this;
  }
  imageTextPopup_createClass(ImageInfoPopup, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = imageTextPopup_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = this;
                _context.next = 3;
                return this.props.textPromise;
              case 3:
                _context.t1 = _context.sent;
                _context.t2 = {
                  text: _context.t1
                };
                _context.t0.setState.call(_context.t0, _context.t2);
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render(_ref, _ref2) {
      var editor = _ref.editor;
      var text = _ref2.text;
      var i18n = editor.plugins.i18n;
      var content;
      if (text === null) {
        content = (0,preact_module.h)(infiniteLoader/* default */.Z, null);
      } else if (text === false) {
        content = (0,preact_module.h)("div", {
          className: "text-from-image-no-text"
        }, i18n.get('image.text_from_image_popup.no_text'));
      } else {
        content = (0,preact_module.h)("div", {
          className: "text-from-image-wrap"
        }, (0,preact_module.h)("div", {
          className: "text-from-image-content"
        }, (0,preact_module.h)("textarea", {
          contenteditable: "true"
        }, text)), (0,preact_module.h)("span", {
          className: "text-from-image-copy",
          onMouseDown: function onMouseDown(event) {
            return event.preventDefault();
          },
          onClick: function onClick(event) {
            event.preventDefault();
            editor.plugins.copyManager.copy(text);
          }
        }, i18n.get('image.text_from_image_popup.copy')));
      }
      return (0,preact_module.h)(popupMenu/* default */.Z, {
        wantsToClose: this.props.wantsToClose,
        addClassName: "text-from-image-popup"
      }, (0,preact_module.h)(popupDialog/* default */.Z, {
        wantsToClose: this.props.wantsToClose
      }, (0,preact_module.h)(popupDialogTitle/* default */.Z, null, i18n.get('image.text_from_image_popup.title')), (0,preact_module.h)(popupDialogBody/* default */.Z, null, content)));
    }
  }]);
  return ImageInfoPopup;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/scss/search.scss
var search = __webpack_require__(46804);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/attachment/imageHighlights.js
function imageHighlights_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { imageHighlights_typeof = function _typeof(obj) { return typeof obj; }; } else { imageHighlights_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return imageHighlights_typeof(obj); }
function imageHighlights_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = imageHighlights_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function imageHighlights_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return imageHighlights_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return imageHighlights_arrayLikeToArray(o, minLen); }
function imageHighlights_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }













function imageHighlights_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function imageHighlights_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function imageHighlights_createClass(Constructor, protoProps, staticProps) { if (protoProps) imageHighlights_defineProperties(Constructor.prototype, protoProps); if (staticProps) imageHighlights_defineProperties(Constructor, staticProps); return Constructor; }
function imageHighlights_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) imageHighlights_setPrototypeOf(subClass, superClass); }
function imageHighlights_setPrototypeOf(o, p) { imageHighlights_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return imageHighlights_setPrototypeOf(o, p); }
function imageHighlights_createSuper(Derived) { var hasNativeReflectConstruct = imageHighlights_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = imageHighlights_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = imageHighlights_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return imageHighlights_possibleConstructorReturn(this, result); }; }
function imageHighlights_possibleConstructorReturn(self, call) { if (call && (imageHighlights_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return imageHighlights_assertThisInitialized(self); }
function imageHighlights_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function imageHighlights_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function imageHighlights_getPrototypeOf(o) { imageHighlights_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return imageHighlights_getPrototypeOf(o); }
function imageHighlights_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var ImageHighlights = /*#__PURE__*/function (_Component) {
  imageHighlights_inherits(ImageHighlights, _Component);
  var _super = imageHighlights_createSuper(ImageHighlights);
  function ImageHighlights() {
    var _this;
    imageHighlights_classCallCheck(this, ImageHighlights);
    _this = _super.call(this);
    imageHighlights_defineProperty(imageHighlights_assertThisInitialized(_this), "onRef", function (node) {
      _this.canvas = node;
    });
    _this.canvas = null;
    return _this;
  }
  imageHighlights_createClass(ImageHighlights, [{
    key: "drawPoly",
    value: function drawPoly(vertices) {
      var ctx = this.canvas.getContext('2d');
      ctx.fillStyle = search.searchTermHighlightColor;
      ctx.beginPath();
      ctx.moveTo(vertices[0].x, vertices[0].y);
      for (var i = 1; i < vertices.length; i++) {
        ctx.lineTo(vertices[i].x, vertices[i].y);
      }
      ctx.closePath();
      ctx.fill();
    }
  }, {
    key: "drawHighlights",
    value: function drawHighlights() {
      var highlights = this.props.highlights;
      var _iterator = imageHighlights_createForOfIteratorHelper(highlights),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var poly = _step.value;
          this.drawPoly(poly);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.drawHighlights();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.drawHighlights();
    }
  }, {
    key: "render",
    value: function render() {
      var style = {
        width: this.props.width + 'px',
        height: this.props.height + 'px'
      };
      return (0,preact_module.h)("canvas", {
        style: style,
        width: this.props.naturalWidth,
        height: this.props.naturalHeight,
        ref: this.onRef
      });
    }
  }]);
  return ImageHighlights;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/attachment/caption.js
function caption_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { caption_typeof = function _typeof(obj) { return typeof obj; }; } else { caption_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return caption_typeof(obj); }
function caption_toConsumableArray(arr) { return caption_arrayWithoutHoles(arr) || caption_iterableToArray(arr) || caption_unsupportedIterableToArray(arr) || caption_nonIterableSpread(); }
function caption_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function caption_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function caption_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return caption_arrayLikeToArray(arr); }

function caption_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function caption_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { caption_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { caption_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




















function caption_slicedToArray(arr, i) { return caption_arrayWithHoles(arr) || caption_iterableToArrayLimit(arr, i) || caption_unsupportedIterableToArray(arr, i) || caption_nonIterableRest(); }
function caption_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function caption_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return caption_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return caption_arrayLikeToArray(o, minLen); }
function caption_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function caption_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function caption_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function caption_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function caption_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function caption_createClass(Constructor, protoProps, staticProps) { if (protoProps) caption_defineProperties(Constructor.prototype, protoProps); if (staticProps) caption_defineProperties(Constructor, staticProps); return Constructor; }
function caption_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) caption_setPrototypeOf(subClass, superClass); }
function caption_setPrototypeOf(o, p) { caption_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return caption_setPrototypeOf(o, p); }
function caption_createSuper(Derived) { var hasNativeReflectConstruct = caption_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = caption_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = caption_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return caption_possibleConstructorReturn(this, result); }; }
function caption_possibleConstructorReturn(self, call) { if (call && (caption_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return caption_assertThisInitialized(self); }
function caption_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function caption_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function caption_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { caption_get = Reflect.get; } else { caption_get = function _get(target, property, receiver) { var base = caption_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return caption_get(target, property, receiver || target); }
function caption_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = caption_getPrototypeOf(object); if (object === null) break; } return object; }
function caption_getPrototypeOf(o) { caption_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return caption_getPrototypeOf(o); }
function caption_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var caption_isSpaceKey = (0,lib/* default */.ZP)('space');
var caption_FORMAT_STYLES = ['bold', 'italic', 'underline', 'strikethrough', 'link', 'background', 'color', 'comment'];
var MIN_CAPTION_WIDTH = 50;
var Caption = /*#__PURE__*/function (_BlotLockMixin) {
  caption_inherits(Caption, _BlotLockMixin);
  var _super = caption_createSuper(Caption);
  function Caption(domNode) {
    var _this;
    caption_classCallCheck(this, Caption);
    _this = _super.call(this, domNode);
    caption_defineProperty(caption_assertThisInitialized(_this), "onObserveDeep", function (_ref) {
      var _ref2 = caption_slicedToArray(_ref, 1),
        event = _ref2[0];
      if (event.transaction.local) {
        // если подпись скрываемая
        var hasText = !!_this.getText().trim();
        if (hasText !== _this.hasText) {
          // изменяем show только тогда когда текст пустой и затем появляется или наоборот
          _this.map.set('show', hasText);
          _this.hasText = hasText;
        }
      }
    });
    caption_defineProperty(caption_assertThisInitialized(_this), "mapObserver", function (event) {
      // в случае работы на нескольких клиентах, при показе/скрытии кашнена на одном,
      // на другом капшен также отображается/скрывается
      if (!event.transaction.local) {
        if (event.keysChanged.has('show')) {
          var show = _this.map.get('show');
          if (show) {
            _this.domNode.classList.remove('empty-caption');
          } else {
            _this.domNode.classList.add('empty-caption');
          }
          _this.setProps({
            show: show
          });
        }
      }
    });
    caption_defineProperty(caption_assertThisInitialized(_this), "onEditorReady", function () {
      _this.render();
    });
    caption_defineProperty(caption_assertThisInitialized(_this), "setWidth", function (width) {
      _this.domNode.style.width = width + 'px';
    });
    caption_defineProperty(caption_assertThisInitialized(_this), "onBlur", function () {
      if (_this.props.hiding) {
        if (_this.domNode.innerText.trim() === '') {
          _this.setProps({
            show: false
          });
        }
      }
    });
    caption_defineProperty(caption_assertThisInitialized(_this), "onFocus", function () {
      if (_this.props.hiding && _this.editor.mode === _this.editor.constructor.MODE_EDIT) {
        var parentBlot = _this.embedBlot;
        if (parentBlot && parentBlot.checkCaptionFocus) {
          parentBlot.checkCaptionFocus();
        } else {
          _this.setProps({
            show: true
          });
        }
      }
    });
    caption_defineProperty(caption_assertThisInitialized(_this), "showCaption", /*#__PURE__*/caption_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var parentBlot, _getElementPosition, top, delta;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.editor && _this.editor.options.keyboardMode === 'mobile')) {
                _context.next = 6;
                break;
              }
              _context.next = 3;
              return timeout(500);
            case 3:
              parentBlot = _this.embedBlot;
              _this.editor.focus();
              if (parentBlot && parentBlot.focusableFocus) {
                parentBlot.focusableFocus();
              }
            case 6:
              _this.setProps({
                show: true
              });
              _this.focusableFocus();
              // для того чтобы проскролить к капшену
              _getElementPosition = (0,dom/* getElementPosition */._z)(_this.domNode, _this.editor.plugins.scrollSaver.getScrollingContainer()), top = _getElementPosition.top;
              delta = 100; // растояние от капшена до верха страницы
              _this.editor.plugins.selectionScroller.scrollTo(top > delta ? top - delta : top);
            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    _this.domNode.classList.add('attachment-caption');
    _this.addCanExecActions(caption_toConsumableArray(textLine.canExecActions));
    _this.dontRemoveWithBackspace = true;
    _this.props.show = true; // отображать подпись
    _this.props.hiding = false; // подпись скрываемая
    _this.dontProcessDragAndDrop = true;
    _this.isSelectableBlotChild = true;
    _this.hasText = null; // есть ли текст подписи
    return _this;
  }
  caption_createClass(Caption, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = caption_get(caption_getPrototypeOf(Caption.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      if (this.scroll.editor.mode !== MODE_EXPORT) {
        var i18n = this.scroll.editor.plugins && this.scroll.editor.plugins.i18n;
        if (i18n) {
          this.domNode.setAttribute('data-placeholder-text', i18n.get('caption.placeholder'));
        }
      }
      this.editor.emitter.once('editor-ready', this.onEditorReady);
      if (this.embedBlot) {
        // если есть элемент для подписи и у него указано что подпись скрываемая
        if (this.embedBlot.isCaptionHiding) {
          this.prevBlot = this.embedBlot; // для использования в detach. Т.к. в detach this.embedBlot становится null

          this.hasText = !!this.getText().trim();
          this.scroll.store.observeDeep(this.map, this.onObserveDeep);

          // при фокусе показываем caption
          this.domNode.addEventListener('focusable-focus', this.onFocus);
          // при потере фокуса, если caption без текста скрываем caption
          this.domNode.addEventListener('focusable-blur', this.onBlur);
          var _this$blotConfig$show = this.blotConfig.showCaptionAfterBlotFocus,
            showCaptionAfterBlotFocus = _this$blotConfig$show === void 0 ? false : _this$blotConfig$show;
          if (showCaptionAfterBlotFocus) {
            // отслеживаем события фокуса и потери фокуса на родительском блоте
            // аналогично при фокусе на родительский блот показываем caption
            this.prevBlot.domNode.addEventListener('focusable-focus', this.onFocus);
            // при потере фокуса с родительского блота и если caption без текста
            // скрываем caption
            this.prevBlot.domNode.addEventListener('focusable-blur', this.onBlur);
          }
          // тут для начала проверяем наличие innerText на undefined, чтобы не было ошибки
          this.setProps({
            show: this.domNode && this.domNode.innerText && this.domNode.innerText.trim() !== '' || this.prevBlot.domNode.classList.contains('focused-block') && showCaptionAfterBlotFocus,
            hiding: true
          });
        }
      }
    }
  }, {
    key: "detach",
    value: function detach() {
      if (this.prevBlot) {
        // если есть элемент для подписи и у него указано что подпись скрываемая
        if (this.prevBlot.isCaptionHiding) {
          this.scroll.store.unobserveDeep(this.map, this.onObserveDeep);

          // удаляем листенеры для caption
          this.domNode.removeEventListener('focusable-focus', this.onFocus);
          this.domNode.removeEventListener('focusable-blur', this.onBlur);
          var _this$blotConfig$show2 = this.blotConfig.showCaptionAfterBlotFocus,
            showCaptionAfterBlotFocus = _this$blotConfig$show2 === void 0 ? false : _this$blotConfig$show2;
          if (this.prevBlot && showCaptionAfterBlotFocus) {
            // удаляем листенеры для родительского блота
            this.prevBlot.domNode.removeEventListener('focusable-focus', this.onFocus);
            this.prevBlot.domNode.removeEventListener('focusable-blur', this.onBlur);
          }
        }
      }
    }
  }, {
    key: "getWrapper",
    value: function getWrapper() {
      return this.parent;
    }
  }, {
    key: "getBlotForMenu",
    value: function getBlotForMenu() {
      return this.embedBlot;
    }
  }, {
    key: "textLineOnBackspace",
    value: function textLineOnBackspace(action) {
      var processed = false;
      var blotRange = action.getBlotRange(this);
      if (blotRange.index === 1 && blotRange.length === 0) {
        this.map.get('characters').applyDelta([{
          delete: 1
        }]);
        action.dontRestoreSelection();
        processed = true;
      } else if (blotRange.index === 0 && blotRange.length === 0) {
        action.dontRestoreSelection();
        processed = true;
      }
      return processed;
    }
  }, {
    key: "textBaseProcessDelete",
    value: function textBaseProcessDelete(action) {
      var blotLength = this.length() - 1;
      var blotRange = action.getBlotRange(this);
      if (blotRange.length === 0 && blotRange.index === 0 && blotLength === 1) {
        this.deleteAt(0, 1);
        action.dontRestoreSelection();
        return true;
      } else {
        return caption_get(caption_getPrototypeOf(Caption.prototype), "textBaseProcessDelete", this).call(this, action);
      }
    }
  }, {
    key: "textLineAddNextBlot",
    value: function textLineAddNextBlot() {
      var initParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var indent = this.embedBlot.map.get('indent');
      var params = Object.assign(initParams, this.textLineAddBlotParams({
        indent: indent,
        after: this.getWrapper().id
      }));
      return this.parent.addBlot('paragraph', params);
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (caption_isSpaceKey(event)) {
        var _this$selection$getRa = this.selection.getRange({
            offsetBlot: this
          }),
          _this$selection$getRa2 = caption_slicedToArray(_this$selection$getRa, 1),
          range = _this$selection$getRa2[0];
        var length = this.length() - 1;
        if (range.index === 0 && range.length > 0 && range.length === length) {
          // предотвращаем ошибку при удалении через пробел когда весь текст выделен
          event.preventDefault();
          this.map.get('characters').applyDelta([{
            delete: length
          }, {
            insert: "\n"
          }]);
          this.selection.setRange({
            index: this.offset(this.editor.scroll),
            length: 0
          });
          return false;
        }
      }
      if (caption_get(caption_getPrototypeOf(Caption.prototype), "handleKeyDown", this)) {
        return caption_get(caption_getPrototypeOf(Caption.prototype), "handleKeyDown", this).call(this, event);
      }
    }
  }, {
    key: "onPaste",
    value: function onPaste(params) {
      var text = params.text;
      if (!text) {
        return false;
      }
      text = text.trim();
      if (!text) {
        return false;
      }
      var _this$scroll$selectio = this.scroll.selection.getRange({
          offsetBlot: this
        }),
        _this$scroll$selectio2 = caption_slicedToArray(_this$scroll$selectio, 1),
        blotRange = _this$scroll$selectio2[0];
      if (stringIsUrl(text)) {
        this.editor.plugins.pasteManager.pasteUrlIntoText(this, blotRange, text);
        return true;
      }
      text = text.replace(/\s+/g, ' ');
      if (blotRange) {
        var ops = [];
        if (blotRange.index > 0) {
          ops.push({
            retain: blotRange.index
          });
        }
        if (blotRange.length > 0) {
          ops.push({
            delete: blotRange.length
          });
        }
        ops.push({
          insert: text
        });
        this.map.get('characters').applyDelta(ops);
        var newIndex = blotRange.index + text.length;
        var blotOffset = this.offset(this.scroll);
        this.scroll.selection.setRange({
          index: blotOffset + newIndex,
          length: 0
        });
      }
      return true;
    }

    /**
     * Событие при потере фокуса с Caption-а
     */
  }, {
    key: "blotDidUpdate",
    value: function blotDidUpdate() {
      if (this.props.show) {
        this.domNode.classList.remove('empty-caption-hidden');
      } else {
        if (!this.domNode.classList.contains('empty-caption-hidden')) {
          this.domNode.classList.add('empty-caption-hidden');
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var parentBlot = this.embedBlot;
      if (parentBlot && parentBlot.isBlotLocked) {
        this.props.blotLocked = true;
      } else {
        if (this.props.blotLocked) {
          this.props.blotLocked = false;
          this.props.contenteditable = 0;
        }
      }
      caption_get(caption_getPrototypeOf(Caption.prototype), "render", this).call(this);
      this.domNode.style.textAlign = 'center';
      this.domNode.classList.remove('indent-' + this.map.get('indent'));
      var width = MIN_CAPTION_WIDTH;
      if (this.embedBlot.map.get('width') && this.embedBlot.map.get('width') > width) {
        width = this.embedBlot.map.get('width');
      } else {
        var attachmentNodeWidth = this.embedBlot.domNode.getBoundingClientRect().width;
        if (attachmentNodeWidth > width) {
          width = attachmentNodeWidth;
        }
      }
      this.domNode.style.width = width + 'px';
      if (this.isEmpty()) {
        if (!this.domNode.classList.contains('empty-caption')) this.domNode.classList.add('empty-caption');
      } else {
        if (this.domNode.classList.contains('empty-caption')) this.domNode.classList.remove('empty-caption');
      }
    }
  }, {
    key: "getAllowedStyles",
    value: function getAllowedStyles() {
      return caption_FORMAT_STYLES;
    }
  }, {
    key: "toHTML",
    value: function toHTML() {
      // так как функция showCaption выставляющая статус видимости caption асинхронная,
      // она может не успеть отработать при экспорте, поэтому удаляем класс, который скрывает caption
      // тут, если caption не пустой
      var node = this.domNode.cloneNode(true);
      if (!this.isEmpty()) {
        node.classList.remove('empty-caption-hidden');
        if (node.style.width === MIN_CAPTION_WIDTH + 'px') {
          node.style.width = '100%';
        }
      }
      return node.outerHTML;
    }
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      if (!blotRange) {
        return {
          delta: this.getContents(0, this.length()).insert('\n')
        };
      } else {
        return caption_get(caption_getPrototypeOf(Caption.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
      }
    }
  }], [{
    key: "initMap",
    value: function initMap(map, store) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      map.set('type', 'caption');
      caption_get(caption_getPrototypeOf(Caption), "initMap", this).call(this, map, store, params);
    }
  }]);
  return Caption;
}(blotLock(focusable(selectable(executable(basic(textLine))))));

Caption.blotName = 'caption';
Caption.tagName = 'DIV';
Caption.convertLinkOpts = ['url', 'title'];
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url.js
var web_url = __webpack_require__(60285);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.js
var web_url_search_params = __webpack_require__(41637);
// EXTERNAL MODULE: ./node_modules/filesize/lib/filesize.js
var filesize = __webpack_require__(26863);
var filesize_default = /*#__PURE__*/__webpack_require__.n(filesize);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/file.js







function createTempFileUrl(file) {
  var urlCreator = window.URL || window.webkitURL;
  return urlCreator.createObjectURL(file);
}
function file_filesize(size) {
  // предварительно обрабатываем валидность параметра size, это должно быть число
  // иначе filesize модуль выкинет эксепшн
  if (isNaN(size)) {
    return '-';
  }
  return filesize_default()(size, {
    base: 10
  });
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/formats/link.js
function link_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { link_typeof = function _typeof(obj) { return typeof obj; }; } else { link_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return link_typeof(obj); }
















function link_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function link_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function link_createClass(Constructor, protoProps, staticProps) { if (protoProps) link_defineProperties(Constructor.prototype, protoProps); if (staticProps) link_defineProperties(Constructor, staticProps); return Constructor; }
function link_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { link_get = Reflect.get; } else { link_get = function _get(target, property, receiver) { var base = link_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return link_get(target, property, receiver || target); }
function link_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = link_getPrototypeOf(object); if (object === null) break; } return object; }
function link_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) link_setPrototypeOf(subClass, superClass); }
function link_setPrototypeOf(o, p) { link_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return link_setPrototypeOf(o, p); }
function link_createSuper(Derived) { var hasNativeReflectConstruct = link_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = link_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = link_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return link_possibleConstructorReturn(this, result); }; }
function link_possibleConstructorReturn(self, call) { if (call && (link_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return link_assertThisInitialized(self); }
function link_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function link_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function link_getPrototypeOf(o) { link_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return link_getPrototypeOf(o); }
function link_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var Link = /*#__PURE__*/function (_Inline) {
  link_inherits(Link, _Inline);
  var _super = link_createSuper(Link);
  function Link() {
    var _this;
    link_classCallCheck(this, Link);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    link_defineProperty(link_assertThisInitialized(_this), "onLinkClick", function (event) {
      event.preventDefault();
      event.stopPropagation();
      var editor = normalizeToStoredBlot(link_assertThisInitialized(_this)).editor;
      var url = _this.domNode.getAttribute('href');
      var blot = _this.parent;
      if (editor.mode === MODE_LITE) {
        window.open(url, '_blank', 'noopener');
        return;
      }
      if (blot && blot.isBlotLocked) {
        if (!editor.plugins.linkManager.processNavigation(url)) {
          window.open(url, '_blank', 'noopener');
        }
        return;
      }
      if (isModKeyPressed(event)) {
        window.open(url, '_blank', 'noopener');
      } else if (!editor.options.showLinkPanel) {
        if (!editor.plugins.linkManager.processNavigation(url)) {
          window.open(url, '_blank', 'noopener');
        }
      } else {
        editor.emitter.emit('click-link', link_assertThisInitialized(_this));
      }
    });
    return _this;
  }
  link_createClass(Link, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get2 = link_get(link_getPrototypeOf(Link.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      this.domNode.addEventListener('click', this.onLinkClick, false);
      this.domNode.setAttribute('rel', 'nofollow noopener');
    }
  }, {
    key: "changeUrl",
    value: function changeUrl(url) {
      var blot = normalizeToStoredBlot(this);
      if (!blot.isText) {
        blot = normalizeToTextBlot(this);
      }
      if (!blot) return;
      var index = this.offset(blot);
      var length = this.domNode.innerText.length;
      blot.formatText(index, length, 'link', url, 'user');
    }
  }, {
    key: "changeText",
    value: function changeText(text) {
      var blot = normalizeToStoredBlot(this);
      if (!blot.isText) {
        blot = normalizeToTextBlot(this);
      }
      if (!blot) return;
      var index = this.offset(blot);
      var formats = {};
      var textIsChanged = this.domNode.innerText !== text;
      if (textIsChanged) {
        // если поменялся текст ссылки, получаем форматирование первой буквы ссылки
        formats = blot.getFormat(index, 1);
        delete formats.link;
        this.domNode.innerText = text;
      }
      blot.scroll.update('user');
      if (textIsChanged) {
        // если поменялся текст ссылки, форматируем ссылку форматами первой буквы полученные выше
        Object.keys(formats).map(function (format) {
          blot.formatText(index, text.length, format, formats[format], 'user');
        });
      }
      blot.selection.setRange({
        index: blot.offset(blot.scroll) + index + text.length,
        length: 0
      });
    }
  }, {
    key: "format",
    value: function format(name, value) {
      if (name !== this.statics.blotName || !value) return link_get(link_getPrototypeOf(Link.prototype), "format", this).call(this, name, value);
      value = this.constructor.sanitize(value);
      this.domNode.setAttribute('href', value);
    }
  }, {
    key: "onCancelEditSetCaretAfter",
    value: function onCancelEditSetCaretAfter() {
      var blot = normalizeToStoredBlot(this);
      blot.selection.setRange({
        index: blot.offset(blot.scroll) + this.offset(blot) + this.length(),
        length: 0
      });
    }
  }], [{
    key: "create",
    value: function create(value) {
      var node = link_get(link_getPrototypeOf(Link), "create", this).call(this, value);
      value = this.sanitize(value);
      node.setAttribute('href', value);
      node.setAttribute('target', '_blank');
      return node;
    }
  }, {
    key: "formats",
    value: function formats(domNode) {
      return domNode.getAttribute('href');
    }
  }, {
    key: "sanitize",
    value: function sanitize(url) {
      return url;
    }
  }]);
  return Link;
}(inline);
Link.blotName = 'link';
Link.tagName = 'A';
Link.SANITIZED_URL = 'about:blank';
Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];
function link_sanitize(url, protocols) {
  var anchor = document.createElement('a');
  anchor.href = url;
  var protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
  return protocols.indexOf(protocol) > -1;
}

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/addFile.js
function addFile_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { addFile_typeof = function _typeof(obj) { return typeof obj; }; } else { addFile_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return addFile_typeof(obj); }












function addFile_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function addFile_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { addFile_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { addFile_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function addFile_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function addFile_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function addFile_createClass(Constructor, protoProps, staticProps) { if (protoProps) addFile_defineProperties(Constructor.prototype, protoProps); if (staticProps) addFile_defineProperties(Constructor, staticProps); return Constructor; }
function addFile_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) addFile_setPrototypeOf(subClass, superClass); }
function addFile_setPrototypeOf(o, p) { addFile_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return addFile_setPrototypeOf(o, p); }
function addFile_createSuper(Derived) { var hasNativeReflectConstruct = addFile_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = addFile_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = addFile_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return addFile_possibleConstructorReturn(this, result); }; }
function addFile_possibleConstructorReturn(self, call) { if (call && (addFile_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return addFile_assertThisInitialized(self); }
function addFile_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function addFile_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function addFile_getPrototypeOf(o) { addFile_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return addFile_getPrototypeOf(o); }

var AddFileAction = /*#__PURE__*/function (_Action) {
  addFile_inherits(AddFileAction, _Action);
  var _super = addFile_createSuper(AddFileAction);
  function AddFileAction(type, params, editor) {
    addFile_classCallCheck(this, AddFileAction);
    type = type || AddFileAction.type;
    return _super.call(this, type, params || {}, editor);
  }
  addFile_createClass(AddFileAction, [{
    key: "exec",
    value: function () {
      var _exec = addFile_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
        var processingBlots, source, files, blot, fileParams, validateRes, type, res, addedIds, addedId;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                processingBlots = _ref.processingBlots, source = _ref.source;
                files = this.params.files;
                blot = this.params.blot;
                if (this.params.blotId) {
                  blot = this.editor.findById(this.params.blotId);
                }
                if (files) {
                  _context.next = 12;
                  break;
                }
                if (this.editor.plugins.attachmentManager.isMethodImplemented('chooseFile')) {
                  _context.next = 7;
                  break;
                }
                return _context.abrupt("return", console.warn('chooseFile is not implemented in the attachmentManager plugin, skip executing add-file action'));
              case 7:
                fileParams = {
                  multiple: true,
                  source: source,
                  blotName: 'file',
                  blotId: blot ? blot.id : undefined
                };
                if (this.params && this.params.accept) {
                  fileParams.accept = this.params.accept;
                }
                _context.next = 11;
                return this.editor.plugins.attachmentManager.chooseFile(fileParams);
              case 11:
                files = _context.sent;
              case 12:
                if (files) {
                  _context.next = 14;
                  break;
                }
                return _context.abrupt("return", false);
              case 14:
                _context.next = 16;
                return this.editor.plugins.attachmentManager.validateFiles(files);
              case 16:
                validateRes = _context.sent;
                if (validateRes) {
                  _context.next = 19;
                  break;
                }
                return _context.abrupt("return");
              case 19:
                if (blot) {
                  _context.next = 35;
                  break;
                }
                if (!this.params.createFileBlot) {
                  _context.next = 24;
                  break;
                }
                // если передана функция создания блота, то создаем его
                blot = this.params.createFileBlot();
                _context.next = 35;
                break;
              case 24:
                // если не задан файл-блот, то конвертим в файл текущий блот

                if (this.params.detectFileType) {
                  type = detectFileBlotType(files.length && files[0]);
                } else {
                  type = 'file';
                }
                res = this.editor.exec('convert-blot', {
                  type: type
                });
                if (!res.action) {
                  console.error('res does not contain action', res);
                }
                addedIds = res.action.results[0].addedIds;
                if (addedIds.length) {
                  _context.next = 30;
                  break;
                }
                return _context.abrupt("return", false);
              case 30:
                if (!(addedIds.length !== 1)) {
                  _context.next = 33;
                  break;
                }
                console.error('addFile expects 1 id to be in the result of convert-blot, but got', addedIds);
                return _context.abrupt("return", false);
              case 33:
                addedId = addedIds[0];
                blot = this.editor.findById(addedId);
              case 35:
                blot.clearAttachment();
                blot.setHTMLFilesForUpload(files, {
                  dontPutCaretAfter: this.params.dontPutCaretAfter || false,
                  detectFileType: this.params.detectFileType || false
                });
                return _context.abrupt("return", true);
              case 38:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function exec(_x) {
        return _exec.apply(this, arguments);
      }
      return exec;
    }()
  }]);
  return AddFileAction;
}(Action);

AddFileAction.type = 'add-file';
function detectFileBlotType(file) {
  var type = 'file';
  if (file && addFile_typeof(file) === 'object' && file.type) {
    if (file.type.startsWith('image')) {
      type = 'image';
    }
  }
  return type;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/attachment/attachmentBase.js
function attachmentBase_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { attachmentBase_typeof = function _typeof(obj) { return typeof obj; }; } else { attachmentBase_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return attachmentBase_typeof(obj); }

function attachmentBase_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function attachmentBase_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { attachmentBase_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { attachmentBase_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

















function attachmentBase_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function attachmentBase_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function attachmentBase_createClass(Constructor, protoProps, staticProps) { if (protoProps) attachmentBase_defineProperties(Constructor.prototype, protoProps); if (staticProps) attachmentBase_defineProperties(Constructor, staticProps); return Constructor; }
function attachmentBase_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) attachmentBase_setPrototypeOf(subClass, superClass); }
function attachmentBase_setPrototypeOf(o, p) { attachmentBase_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return attachmentBase_setPrototypeOf(o, p); }
function attachmentBase_createSuper(Derived) { var hasNativeReflectConstruct = attachmentBase_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = attachmentBase_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = attachmentBase_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return attachmentBase_possibleConstructorReturn(this, result); }; }
function attachmentBase_possibleConstructorReturn(self, call) { if (call && (attachmentBase_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return attachmentBase_assertThisInitialized(self); }
function attachmentBase_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function attachmentBase_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function attachmentBase_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { attachmentBase_get = Reflect.get; } else { attachmentBase_get = function _get(target, property, receiver) { var base = attachmentBase_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return attachmentBase_get(target, property, receiver || target); }
function attachmentBase_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = attachmentBase_getPrototypeOf(object); if (object === null) break; } return object; }
function attachmentBase_getPrototypeOf(o) { attachmentBase_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return attachmentBase_getPrototypeOf(o); }
function attachmentBase_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var TOOLTIP_CLASS = 'attachment-tooltip';
var UPLOADING_BY_MAX_DURATION = 3600 * 24 * 1000;
var ATTACH_GLOBAL_ID_HTML_ATTR = 'data-nimbus-attachment-global-id';
var ATTACH_ROOM_HTML_ATTR = 'data-nimbus-room';
var FILE_NAME_HTML_ATTR = 'data-nimbus-file-name';
var isEscapeKey = (0,lib/* default */.ZP)('esc');
function setAttachmentForMap(map, attachmentGlobalId) {
  // проверка помогает не генерировать дополнительные операции в yjs, т.к. он удаляет старое значение и устанавливает новое
  // даже если значения одинаковы
  if (map.get('attachmentGlobalId') === attachmentGlobalId) {
    return;
  }
  map.set('attachmentGlobalId', attachmentGlobalId);
  map.set('setAttachmentTime', Math.round(Date.now() / 1000));
}
var AttachmentsBase = /*#__PURE__*/function (_BlockEmbed) {
  attachmentBase_inherits(AttachmentsBase, _BlockEmbed);
  var _super = attachmentBase_createSuper(AttachmentsBase);
  function AttachmentsBase() {
    var _this;
    attachmentBase_classCallCheck(this, AttachmentsBase);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    attachmentBase_defineProperty(attachmentBase_assertThisInitialized(_this), "onAttachmentTooltipClose", function () {
      _this.remove();
    });
    attachmentBase_defineProperty(attachmentBase_assertThisInitialized(_this), "onAttachmentCancelAdd", function () {
      _this.putCaretInEmptyParagraphAfterAttachment();
      _this.remove();
    });
    attachmentBase_defineProperty(attachmentBase_assertThisInitialized(_this), "onAttachmentChooseFile", /*#__PURE__*/attachmentBase_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var files, validateRes;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.editor.plugins.attachmentManager.chooseFile({
                accept: _this.attachmentConfig.acceptFiles,
                multiple: true,
                blotName: _this.constructor.blotName
              });
            case 3:
              files = _context.sent;
              if (files) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              _context.next = 8;
              return _this.editor.plugins.attachmentManager.validateFiles(files);
            case 8:
              validateRes = _context.sent;
              if (validateRes) {
                _context.next = 11;
                break;
              }
              return _context.abrupt("return");
            case 11:
              _this.setHTMLFilesForUpload(files);
              _context.next = 17;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](0);
              _this.onSetAttachmentError(_context.t0);
            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 14]]);
    })));
    attachmentBase_defineProperty(attachmentBase_assertThisInitialized(_this), "onEmbedAttachment", function (url) {
      _this.putCaretInNextBlotAfterAttachment();
      _this.embedAttachmentUrl(url);
    });
    attachmentBase_defineProperty(attachmentBase_assertThisInitialized(_this), "onSetAttachmentError", function (err) {
      console.warn('set upload attachment error', err);
      _this.setProps({
        setAttachmentError: err,
        uploading: false
      });
    });
    attachmentBase_defineProperty(attachmentBase_assertThisInitialized(_this), "onTaskAbortClick", function () {
      if (_this.props.saveFileTask) {
        _this.props.saveFileTask.abort();
        _this.setProps({
          file: null,
          uploading: null,
          progress: null,
          saveFileTask: null,
          setAttachmentError: null
        }, true);
      }
    });
    attachmentBase_defineProperty(attachmentBase_assertThisInitialized(_this), "onAttachmentUploadProgress", function (progress) {
      var _this$props$saveFileT;
      _this.setProps({
        // на случай если проценты превысят 100
        // (У Кузьмы было больше чем 100 почему-то https://gl.nimbusweb.co/lib/editor/issues/102#note_84489)
        progress: Math.min(Math.round(progress.loaded / progress.total * 100), 100),
        taskAbortable: (_this$props$saveFileT = _this.props.saveFileTask) === null || _this$props$saveFileT === void 0 ? void 0 : _this$props$saveFileT.abortable
      }, true);
    });
    _this.messages = {
      'embed_file': 'Embed File',
      'paste_the_file_link': 'Paste the file link...',
      'choose_a_file': 'Choose files'
    };
    _this.attachmentConfig = {
      allowEmbedUrl: true
    };
    return _this;
  }
  // Функция загружает аттач на сервер, если он был вставленны из другого инстанса редактора
  // и в мапе блота существует об этом информация, а так же ссылка для загрузки.
  // Функция должна быть вызвана в функции attach() после рендера, в конечном блоте (наследнике),
  // это нужно для того чтобы не поехала верстка, так как блот в первом рендере выставляет свои размеры
  // и рендерит необходимые компоненты.
  attachmentBase_createClass(AttachmentsBase, [{
    key: "onAttachUploadResoursesIfNeed",
    value: function onAttachUploadResoursesIfNeed() {
      var _this2 = this;
      this.editor.plugins.undoManager.skip(function () {
        if (_this2.map.get('originalRoomId')) {
          if (_this2.editor.room !== _this2.map.get('originalRoomId') && !_this2.map.get('attachmentGlobalId')) {
            var src = _this2.map.get('src');
            if (src) {
              _this2.embedAttachmentUrl(src);
            }
          }
          _this2.map.delete('originalRoomId');
        }
      });
    }
    // При резолве аттача функция проверяет есть ли в мапе блота запись о прямой ссылке на аттач
    // если её нет или она не совпадает с url отрезолвленого аттача, создает/обновляет запись в мапе.
    // P.S. Нужна для сбора операций вставки при копипасте между инстансами
  }, {
    key: "onAttachmentResolvedUpdateMap",
    value: function onAttachmentResolvedUpdateMap() {
      var _this3 = this;
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.editor.plugins.undoManager.skip(function () {
        if (params.url) {
          if (_this3.map.get('src') !== params.url) {
            _this3.map.set('src', params.url);
          }
        }
      });
    }
  }, {
    key: "onFirstAttach",
    value: function onFirstAttach() {
      if (this.props.saveFileTask) {
        this.processTask(this.props.saveFileTask, this.props.saveFileTask.getResultPromise());
      }
    }
  }, {
    key: "clearAttachment",
    value: function clearAttachment() {
      var attachmentGlobalId = this.map.get('attachmentGlobalId');
      if (attachmentGlobalId) {
        this.editor.emit(EVENT_ATTACHMENT_CLEARED, {
          attachmentGlobalId: attachmentGlobalId
        });
      }
      this.map.set('attachmentGlobalId', null);
      this.setProps({
        attachment: null
      });
    }
  }, {
    key: "setAttachment",
    value: function setAttachment(attachmentGlobalId) {
      setAttachmentForMap(this.map, attachmentGlobalId);
    }
  }, {
    key: "getSetAttachmentTime",
    value: function getSetAttachmentTime() {
      return this.map.get('setAttachmentTime');
    }
  }, {
    key: "isAttachmentMightBeUploading",
    value: function isAttachmentMightBeUploading() {
      var setAttachmentTime = this.getSetAttachmentTime();
      if (!setAttachmentTime) {
        return false;
      }
      var now = Math.round(Date.now() / 1000);
      return now - setAttachmentTime < UPLOADING_BY_MAX_DURATION / 1000;
    }
  }, {
    key: "getUploadingBy",
    value: function getUploadingBy() {
      var str = this.map.get('uploading_by');
      if (!str || typeof str !== 'string') {
        return null;
      }
      var parts = str.split('|');
      if (parts.length !== 2) {
        return null;
      }
      return {
        userId: parseInt(parts[0]),
        time: parseInt(parts[1])
      };
    }
  }, {
    key: "isUploadingByExpired",
    value: function isUploadingByExpired(uploadingBy) {
      var now = new Date().getTime();
      if (now - uploadingBy.time > UPLOADING_BY_MAX_DURATION) {
        return true;
      }
      return false;
    }
  }, {
    key: "isUploadingByCurrentUser",
    value: function isUploadingByCurrentUser(uploadingBy) {
      var now = new Date().getTime();
      if (now - uploadingBy.time > UPLOADING_BY_MAX_DURATION) {
        return true;
      }
      return false;
    }
  }, {
    key: "onNoAttachmentWrapperMouseDown",
    value: function onNoAttachmentWrapperMouseDown(event) {
      // предовтращаем установку каретки в панель загрузки аттача
      event.preventDefault();
    }
  }, {
    key: "clearUploadingBy",
    value: function clearUploadingBy() {
      this.map.delete('uploading_by');
    }

    // возвращает true если uploadingBy был очищен
  }, {
    key: "clearUploadingByIfNeeded",
    value: function clearUploadingByIfNeeded(uploadingBy) {
      if (this.isUploadingByExpired(uploadingBy)) {
        // uploading_by просрочилась, скорей всего другой клиент закрыл редактор так и не закачав аттач до конца
        this.clearUploadingBy();
        return true;
      }
      if (uploadingBy.userId === this.scroll.store.userId) {
        // если аплоад делал текущий юзер и аплоад на данный момент не идет, то скорей всего он отменил файл
        // через undo и мы должны стереть статус uploading_by
        this.clearUploadingBy();
        return true;
      }
      return false;
    }
  }, {
    key: "render",
    value: function render() {}
  }, {
    key: "attachmentAdjustTooltipPosition",
    value: function attachmentAdjustTooltipPosition() {
      if (!this._tooltip) {
        return;
      }
      var rect = this.domNode.getBoundingClientRect();
      var scrollRect = this.scroll.editor.scrollingContainer.getBoundingClientRect();
      this._tooltip.style.position = 'absolute';
      this._tooltip.style.left = rect.left + 'px';
      this._tooltip.style.top = rect.top + rect.height + this.scroll.editor.scrollingContainer.scrollTop - scrollRect.top + 'px';
    }
  }, {
    key: "adjustTooltipPositionContinuously",
    value: function adjustTooltipPositionContinuously() {
      var _this4 = this;
      var adjust = function adjust() {
        if (!_this4._tooltip) {
          return;
        }
        if (!_this4._tooltip.parentNode) {
          return;
        }
        _this4.attachmentAdjustTooltipPosition();
        requestAnimationFrame(adjust);
      };
      adjust();
    }
  }, {
    key: "showAttachmentToolTipIfNeeded",
    value: function showAttachmentToolTipIfNeeded() {
      if (!this.hasAttachment() && !this.props.uploading && !document.querySelector('.' + TOOLTIP_CLASS)) {
        var tooltip = this.renderAttachmentTooltip(this.onAttachmentChooseFile, this.onEmbedAttachment, this.onAttachmentTooltipClose, {
          maxFileSize: this.editor.plugins.attachmentManager.getMaxFileSize()
        });
        this._tooltip = tooltip;
        this.scroll.editor.scrollingContainer.appendChild(tooltip);
        this.adjustTooltipPositionContinuously();
      }
    }
  }, {
    key: "attachmentRemoveTooltip",
    value: function attachmentRemoveTooltip() {
      if (this._tooltip && this._tooltip.parentNode) {
        this._tooltip.parentNode.removeChild(this._tooltip);
      }
      this._tooltip = null;
      try {
        clearInterval(this._adjustPositionInterval);
      } catch (err) {}
    }
  }, {
    key: "onFocusableFocus",
    value: function onFocusableFocus() {
      if (attachmentBase_get(attachmentBase_getPrototypeOf(AttachmentsBase.prototype), "onFocusableFocus", this)) {
        attachmentBase_get(attachmentBase_getPrototypeOf(AttachmentsBase.prototype), "onFocusableFocus", this).call(this);
      }
    }
  }, {
    key: "onFocusableBlur",
    value: function onFocusableBlur() {
      if (attachmentBase_get(attachmentBase_getPrototypeOf(AttachmentsBase.prototype), "onFocusableBlur", this)) {
        attachmentBase_get(attachmentBase_getPrototypeOf(AttachmentsBase.prototype), "onFocusableBlur", this).call(this);
      }
      if (!this.hasAttachment()) {
        this.attachmentRemoveTooltip();
      }
    }
  }, {
    key: "setHTMLFileForUpload",
    value: function setHTMLFileForUpload(file) {
      var _this5 = this;
      var putCaretAfter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      console.log('setting file for upload', file);
      return Promise.resolve().then(function () {
        if (!_this5.editor.plugins.attachmentManager.checkFileSize(file.size)) {
          throw new QuotaError('file is too big', file);
        }
        if (putCaretAfter) {
          _this5.putCaretInNextBlotAfterAttachment();
        }
        var res;
        file = _this5.editor.plugins.attachmentManager.beforeSaveFile(file);
        _this5.scroll.store.transaction(function () {
          var fileIsUploaded = false;
          if (file.attachmentGlobalId) {
            if (file.isUploaded === false) {} else {
              fileIsUploaded = true;
            }
          }
          if (!fileIsUploaded) {
            res = _this5.uploadFile(file);
          }
          if (file.attachmentGlobalId) {
            // устанавливаем аттач из file только после запуска this.uploadFile
            // т.к. нужно чтобы был установлен props.uploading = true, иначе редактор начнет делать преждевременные запросы
            // на ресолв аттача
            _this5.setAttachment(file.attachmentGlobalId);
          }
        });
        return res;
      }).catch(this.onSetAttachmentError);
    }
  }, {
    key: "setHTMLFilesForUpload",
    value: function setHTMLFilesForUpload(files) {
      var _this6 = this;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!files || !files.length) {
        return;
      }
      files = Array.from(files);
      var blots = [this];
      var lastAddedBlotId = this.id;
      var uploadPromises = [];
      while (blots.length < files.length) {
        this.scroll.execInBatch(function () {
          var _this6$container;
          var createAttachBlot = ((_this6$container = _this6.container) === null || _this6$container === void 0 ? void 0 : _this6$container.createAttachBlot) || _this6.createAttachBlot;
          if (createAttachBlot) {
            var blot = createAttachBlot();
            lastAddedBlotId = blot.id;
            blots.push(blot);
          } else {
            var type;
            if (params.detectFileType) {
              type = detectFileBlotType(files[blots.length]);
            } else {
              type = _this6.constructor.blotName;
            }
            var _this6$container$addB = _this6.container.addBlot(type, {
                after: lastAddedBlotId
              }),
              id = _this6$container$addB.id;
            lastAddedBlotId = id;
            blots.push(id);
          }
        });
      }
      for (var _i = 0, _blots = blots; _i < _blots.length; _i++) {
        var blot = _blots[_i];
        var file = files.shift();
        if (typeof blot === 'string') {
          blot = this.editor.findById(blot);
        }
        uploadPromises.push(blot.setHTMLFileForUpload(file, params.dontPutCaretAfter ? false : files.length === 0));
      }
      return Promise.all(uploadPromises);
    }
  }, {
    key: "embedAttachmentUrl",
    value: function embedAttachmentUrl(url) {
      var _this7 = this;
      this.attachmentRemoveTooltip();
      this.setProps({
        uploading: true,
        progress: 0,
        saveFileTask: null
      }, true);
      this.editor.plugins.attachmentManager.chooseFileFromUrl(url).then(function (file) {
        return _this7.uploadFile(file);
      }).catch(this.onSetAttachmentError);
    }
  }, {
    key: "uploadFile",
    value: function uploadFile(file) {
      var _this8 = this;
      this.setProps({
        file: file,
        uploading: true,
        progress: 0,
        saveFileTask: null,
        setAttachmentError: null
      }, true);
      this.attachmentRemoveTooltip();
      var task = this.editor.plugins.attachmentManager.saveFile(file, {
        blotName: this.constructor.blotName,
        blotId: this.id
      });
      this.editor.plugins.undoManager.skip(function () {
        _this8.map.set('uploading_by', [_this8.scroll.store.userId, new Date().getTime()].join('|'));
        console.log('set file uploading task id', task, task.id);
        if (task.id) {
          _this8.map.set('upload_task_id', task.id);
        }
      });
      return this.processTask(task, task.run());
    }
  }, {
    key: "getUploadTaskId",
    value: function getUploadTaskId() {
      return this.map.get('upload_task_id');
    }
  }, {
    key: "setUploadTask",
    value: function () {
      var _setUploadTask = attachmentBase_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(task) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setProps({
                  file: task.file,
                  uploading: true,
                  progress: 0,
                  saveFileTask: null,
                  setAttachmentError: null
                }, true);
                _context2.prev = 1;
                _context2.next = 4;
                return this.processTask(task, task.getResultPromise());
              case 4:
                _context2.next = 9;
                break;
              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](1);
                this.onSetAttachmentError(_context2.t0);
              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 6]]);
      }));
      function setUploadTask(_x) {
        return _setUploadTask.apply(this, arguments);
      }
      return setUploadTask;
    }()
  }, {
    key: "processTask",
    value: function processTask(task, taskResultPromise) {
      var _this9 = this;
      task.onProgress = this.onAttachmentUploadProgress;
      console.log('processing task...', task);
      this.setProps({
        saveFileTask: task,
        taskAbortable: task.abortable
      }, true);
      return taskResultPromise.then(function (attachment) {
        if (!attachment) {
          return;
        }
        console.log('processTask: file was uploaded successfully, received attachment info', attachment);
        _this9.setAttachment(attachment.globalId);

        // если определено событие при загрузке файла
        if (typeof _this9.onFileUploaded === "function") {
          _this9.onFileUploaded();
        }
      }).then(function () {
        _this9.setProps({
          uploading: false,
          saveFileTask: null
        }, true);
        _this9.editor.plugins.undoManager.skip(function () {
          _this9.map.delete('uploading_by');
        });
      }).catch(function (err) {
        if (task.file && task.file.attachmentGlobalId) {
          // clear attachment because it was set for the blot already, but the file was failed to upload
          _this9.editor.plugins.undoManager.skip(function () {
            _this9.clearAttachment();
          });
        }
        _this9.editor.plugins.undoManager.skip(function () {
          _this9.map.delete('uploading_by');
        });
        if (task.aborted) {
          _this9.setProps({
            uploading: false,
            saveFileTask: null
          }, true);
          return;
        }
        throw err;
      });
    }
  }, {
    key: "resolveAttachment",
    value: function resolveAttachment() {
      var _this10 = this;
      if (this._resolveInProgress) {
        return;
      }
      this._resolveInProgress = true;
      this.editor.plugins.attachmentManager.resolve(this.map.get('attachmentGlobalId'), {
        blotName: this.constructor.blotName,
        blotId: this.id
      }).then(function (attachment) {
        var attachmentGlobalId = _this10.map.get('attachmentGlobalId');
        if (isNaN(attachment.size) && !_this10.editor.plugins.attachmentManager.isPseudoAttachment(attachmentGlobalId)) {
          console.warn('attachment', attachmentGlobalId, 'resolved with incorrect size, attachment:', JSON.stringify(attachment));
        }
        _this10.setProps({
          attachment: attachment
        });
        _this10.onAttachmentResolvedUpdateMap({
          url: attachment.url
        });
        _this10._resolveInProgress = false;
        if (typeof _this10.onAttachmentResolved === 'function') {
          _this10.onAttachmentResolved();
        }
      }).catch(function (err) {
        console.error('fail to resolve attachment', err);
        _this10._resolveInProgress = false;
        _this10.setProps({
          setAttachmentError: err
        });
      });
    }
  }, {
    key: "hasAttachment",
    value: function hasAttachment() {
      if (this.props.uploading) {
        return false;
      }
      return Boolean(this.map.get('attachmentGlobalId'));
    }
  }, {
    key: "replaceAttachment",
    value: function replaceAttachment(attachmentGlobalId) {
      if (attachmentGlobalId && this.map.get('attachmentGlobalId') !== attachmentGlobalId) {
        if (this.hasAttachment()) {
          this.clearAttachment();
        }
        this.setAttachment(attachmentGlobalId);
        return true;
      }
      return false;
    }
  }, {
    key: "putCaretInEmptyParagraphAfterAttachment",
    value: function putCaretInEmptyParagraphAfterAttachment() {
      if (this.map.get('mode') == 'tableCell') return;
      // надо поставить курсор в существующий пустой параграф под изображением или создать новый
      var next = this.getWrapper().next;
      if (next && next instanceof paragraphAbstract && next.isEmpty()) {
        this.scroll.selection.setRange({
          index: next.offset(this.scroll),
          length: 0
        });
        this.editor.plugins.selectionScroller.ensureSelectionVisible();
        return;
      }
      this.parent.addBlot('paragraph', {
        after: this.id,
        focus: {
          index: 0
        }
      });
    }
  }, {
    key: "putCaretInNextBlotAfterAttachment",
    value: function putCaretInNextBlotAfterAttachment() {
      var next = this.getWrapper().next;
      if (next) {
        if (next instanceof list_list) {
          this.scroll.selection.setRange({
            index: next.children.head.offset(this.scroll),
            length: 0
          });
        } else {
          this.scroll.selection.setRange({
            index: next.offset(this.scroll),
            length: 0
          });
        }
        this.editor.plugins.selectionScroller.ensureSelectionVisible();
      } else {
        this.putCaretInEmptyParagraphAfterAttachment();
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (isEscapeKey(event)) {
        return this.putCaretInNextBlotAfterAttachment();
      }
      if (attachmentBase_get(attachmentBase_getPrototypeOf(AttachmentsBase.prototype), "handleKeyDown", this)) {
        return attachmentBase_get(attachmentBase_getPrototypeOf(AttachmentsBase.prototype), "handleKeyDown", this).call(this, event);
      }
    }
  }, {
    key: "renderAttachmentTooltip",
    value: function renderAttachmentTooltip(onChooseFile, onEmbedAttachment, onClose) {
      var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var toolTip = document.createElement('div');
      toolTip.setAttribute(scroll_IGNORE_SELECT_ATTR, 1);
      toolTip.classList.add(TOOLTIP_CLASS);
      toolTip.classList.add('chrome-tooltip');
      var maxFileSizeNote = '';
      if (opts.maxFileSize) {
        maxFileSizeNote = '<div class="max-file-size-note">Maximum size per file ' + filesize_default()(opts.maxFileSize) + '</div>';
      }
      toolTip.innerHTML = "<div class=\"chrome-tabs\">\n      <div class=\"chrome-tab active\" data-tab=\"upload\">Upload</div>\n      ".concat(this.attachmentConfig.allowEmbedUrl ? "<div class=\"chrome-tab\" data-tab=\"link\">Embed Link</div>" : '', "\n    </div>\n    <div class=\"chrome-tab-content active\" data-tab=\"upload\">\n      <button class=\"chrome-button btn-choose-file\">").concat(this.messages.choose_a_file, "</button>\n      ").concat(maxFileSizeNote, "\n    </div>\n    ").concat(this.attachmentConfig.allowEmbedUrl ? "<div class=\"chrome-tab-content\" data-tab=\"link\">\n      <input type=\"text\" class=\"attachment-input chrome-input\" placeholder=\"".concat(this.messages.paste_the_file_link, "\"/>\n      <button class=\"chrome-button btn-embed-attachment\">").concat(this.messages.embed_file, "</button>\n    </div>") : '', "\n    <div class=\"chrome-close\">\xD7</div>");
      toolTip.querySelector('.btn-choose-file').addEventListener('click', onChooseFile, false);
      if (this.attachmentConfig.allowEmbedUrl) {
        toolTip.querySelector('.btn-embed-attachment').addEventListener('click', function () {
          var url = toolTip.querySelector('.attachment-input').value;
          onEmbedAttachment(url);
        }, false);
      }
      toolTip.querySelector('.chrome-close').addEventListener('click', onClose, false);
      toolTip.addEventListener('click', function (event) {
        if (event.target.matches('.chrome-tab')) {
          if (event.target.classList.contains('active')) {
            return;
          }
          var tab = event.target.getAttribute('data-tab');
          toolTip.querySelector('.chrome-tab.active').classList.remove('active');
          toolTip.querySelector('.chrome-tab-content.active').classList.remove('active');
          toolTip.querySelector('.chrome-tab[data-tab="' + tab + '"]').classList.add('active');
          toolTip.querySelector('.chrome-tab-content[data-tab="' + tab + '"]').classList.add('active');
          if (tab === 'link') {
            toolTip.querySelector('.attachment-input').focus();
          }
        }
      }, false);
      if (this.attachmentConfig.allowEmbedUrl) {
        toolTip.querySelector('.attachment-input').addEventListener('keydown', function (event) {
          return event.stopPropagation();
        }, false);
      }
      return toolTip;
    }
  }, {
    key: "remove",
    value: function remove() {
      var _get2;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get2 = attachmentBase_get(attachmentBase_getPrototypeOf(AttachmentsBase.prototype), "remove", this)).call.apply(_get2, [this].concat(args));
      this.attachmentRemoveTooltip();
    }
  }], [{
    key: "convertBlots",
    value: function convertBlots(ids, store, _ref2) {
      var params = _ref2.params,
        container = _ref2.container;
      if (ids.length > 1) {
        return 'default';
      }
      if (!params.attachmentGlobalId) {
        return 'default';
      }
      var map = store.createMap();
      if (container && container.editor && this.setCommentThreads) {
        container && container.editor && this.setCommentThreads(container.editor.findById(ids[0]), params);
      }
      this.initMap(map, store, params);
      return {
        removeBlots: ids,
        insertBlots: [map.get('id')]
      };
    }
  }, {
    key: "setAttachment",
    value: function setAttachment(editor, map, attachmentGlobalId) {
      setAttachmentForMap(map, attachmentGlobalId);
    }
  }]);
  return AttachmentsBase;
}(blockEmbed);
attachmentBase_defineProperty(AttachmentsBase, "initMap", function (map, store) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  // Если в параметрах есть информация об инстасе редактора,
  // откуда происходит добавление блота, нужно добавить эту информацию в map
  // для того, чтобы в дальнейшем блот смог выполнить необходимые манипуляции с контентом,
  // если это необходимо, например копипаст аттачей между инстансами (заметками)
  if (params.room) {
    map.set('originalRoomId', params.room);
  }
  attachmentBase_get(attachmentBase_getPrototypeOf(AttachmentsBase), "initMap", AttachmentsBase) && attachmentBase_get(attachmentBase_getPrototypeOf(AttachmentsBase), "initMap", AttachmentsBase).call(AttachmentsBase, map, store, params);
});

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/errors/attachmentNotFoundError.js
var attachmentNotFoundError = __webpack_require__(45405);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/attachment/image.js
function image_slicedToArray(arr, i) { return image_arrayWithHoles(arr) || image_iterableToArrayLimit(arr, i) || image_unsupportedIterableToArray(arr, i) || image_nonIterableRest(); }
function image_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function image_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return image_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return image_arrayLikeToArray(o, minLen); }
function image_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function image_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function image_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function image_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { image_typeof = function _typeof(obj) { return typeof obj; }; } else { image_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return image_typeof(obj); }
function image_extends() { image_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return image_extends.apply(this, arguments); }

function image_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function image_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { image_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { image_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }


























function image_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function image_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function image_createClass(Constructor, protoProps, staticProps) { if (protoProps) image_defineProperties(Constructor.prototype, protoProps); if (staticProps) image_defineProperties(Constructor, staticProps); return Constructor; }
function image_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) image_setPrototypeOf(subClass, superClass); }
function image_setPrototypeOf(o, p) { image_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return image_setPrototypeOf(o, p); }
function image_createSuper(Derived) { var hasNativeReflectConstruct = image_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = image_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = image_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return image_possibleConstructorReturn(this, result); }; }
function image_possibleConstructorReturn(self, call) { if (call && (image_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return image_assertThisInitialized(self); }
function image_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function image_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function image_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { image_get = Reflect.get; } else { image_get = function _get(target, property, receiver) { var base = image_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return image_get(target, property, receiver || target); }
function image_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = image_getPrototypeOf(object); if (object === null) break; } return object; }
function image_getPrototypeOf(o) { image_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return image_getPrototypeOf(o); }
function image_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










































var IMAGE_ORIGINAL_WIDTH_ATTR = 'original-width';
var IMAGE_ORIGINAL_HEIGHT_ATTR = 'original-height';
var MAX_WIDTH = 500;
var MAX_HEIGHT = 300;
var SUPPORTED_TYPES = ['image/png', 'image/jpeg', 'image/gif'];
var image_isTabKey = (0,lib/* default */.ZP)('tab');
var image_isShiftTabKey = (0,lib/* default */.ZP)('shift+tab');
var image_MAX_INDENT_LEVEL = 30;
var DEFAULT_ALIGN = 'center';
var ALLOWED_ALIGNS = ['left', 'center', 'right'];
var UNSPLASH_DEFAULT_WIDTH_RATIO = 0.5;
var IMAGE_FILE_EXTENCIONS = {
  'image/png': '.png',
  'image/jpeg': '.jpg',
  'image/gif': '.gif'
};
var image_mixin = mix([commentable, withCaption, blotLock, resizeable, fullWidth, embeddable, draggable, colorable, indentable, selectable, focusable, executable, basic]);
function getFilePreviewUrl(file) {
  if (file.previewUrl) {
    return file.previewUrl;
  }
  return createTempFileUrl(file.instance);
}
var ImageBlot = /*#__PURE__*/function (_mixin) {
  image_inherits(ImageBlot, _mixin);
  var _super = image_createSuper(ImageBlot);
  function ImageBlot(domNode) {
    var _thisSuper, _this;
    image_classCallCheck(this, ImageBlot);
    _this = _super.call(this, domNode);
    image_defineProperty(image_assertThisInitialized(_this), "onTaskAbortClick", function () {
      if (_this.props.saveFileTask) {
        if (_this.map.get('attachmentGlobalId')) {
          _this.clearAttachment();
        }
        _this.props.saveFileTask.abort();
        _this.clearUploadingCache();
        _this._previewOnLoadReady = null;
        _this.domNode.classList.remove('preview-image');
      }
    });
    image_defineProperty(image_assertThisInitialized(_this), "onFileClickMenuImageShadow", function () {
      var attachment = _this.props.attachment;
      if (attachment.imageShadow) {
        _this.map.set('imageShadow', false);
      } else {
        _this.map.set('imageShadow', true);
      }
      _this.setProps({
        attachment: Object.assign({}, attachment, {
          imageShadow: !attachment.imageShadow
        })
      });
    });
    image_defineProperty(image_assertThisInitialized(_this), "onSetImageCover", function () {
      var cover = _this.map.get('cover');
      _this.map.set('cover', !cover);
    });
    image_defineProperty(image_assertThisInitialized(_this), "onRenderPlaceholder", function () {
      var placeholder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      _this.placeholder = placeholder;
    });
    image_defineProperty(image_assertThisInitialized(_this), "setPreviewImage", function (src) {
      if (_this._fetchingPreviewInProgress) {
        return;
      }
      _this._fetchingPreviewInProgress = true;
      var img = new Image();
      img.onload = function () {
        // для начала пробуем взять размеры в map
        // (тут нужно учесть что при смене изображения и других манипуляциях, нужно следить за тем,
        // чтобы эти параметры были актуальны или очищены для их получения из превью)
        var _this$map$toJSON = _this.map.toJSON(),
          width = _this$map$toJSON.width,
          ratio = _this$map$toJSON.ratio;
        if (!width || !ratio) {
          var maxResolveWidth = _this.getWrapper().domNode.getBoundingClientRect().width;
          var resolveRate = 1;
          if (_this.map.get('unsplash') && _this.getWrapper().parent.constructor.blotName !== 'gridCol') {
            resolveRate = UNSPLASH_DEFAULT_WIDTH_RATIO;
          }
          var sizeParams = ImageBlot.optimizeSize(img, maxResolveWidth, resolveRate);
          width = sizeParams.width;
          ratio = sizeParams.ratio;
          _this.editor.plugins.undoManager.skip(function () {
            _this.scroll.execInBatch(function () {
              _this.setWidthToMap(width);
              _this.map.set('ratio', ratio);
              _this.map.set('noGridWidth', width);
              _this.map.set('originalSize', {
                width: sizeParams.originalWidth,
                height: sizeParams.originalHeight
              });
            });
          });
        }
        _this.image.setAttribute('src', src);
        _this.domNode.classList.add('preview-image');
        _this.setResizeContainerSize({
          width: width,
          ratio: ratio
        });
        //тут форсированно вызываем триггер selectionChange из selectionScroller, чтобы при прогрузке превью, редактор проскролился до каретки,
        //потому что блок с изображением поменял свои размеры и если он находится внизу редактора то блок с кареткой уйдет из поля видимости.
        //TODO: force = true потому что с selection что то не так, при вставке картинки selectionScroller.onSelectionChange() вызывается 10+ раз
        if (_this.props.scrollToCaretOnOnload) {
          _this.editor.plugins.selectionScroller.triggerSelectionChange(true);
          _this.setProps({
            scrollToCaretOnOnload: null
          });
        }
        _this._previewOnLoadReady = true;
        _this._fetchingPreviewInProgress = false;
      };
      img.onerror = function (err) {
        _this._fetchingPreviewInProgress = false;
        _this._previewOnLoadReady = true;
        _this.setProps({
          isPreviewNotAvailable: true
        });
      };
      img.src = src;
    });
    image_defineProperty(image_assertThisInitialized(_this), "onImageDelete", function () {
      _this.remove();
    });
    image_defineProperty(image_assertThisInitialized(_this), "renderDeleteButton", function () {
      return (0,preact_module.h)("div", {
        className: "delete-image-btn",
        onClick: _this.onImageDelete
      }, (0,preact_module.h)(icons/* IconClose */.bMz, null));
    });
    image_defineProperty(image_assertThisInitialized(_this), "replace", function () {
      _this.clearAttachment();
      _this.onFocusableFocus();
    });
    image_defineProperty(image_assertThisInitialized(_this), "setAsPreview", function () {
      _this.editor.plugins.attachmentManager.setAsPreview(_this.props.attachment);
    });
    image_defineProperty(image_assertThisInitialized(_this), "getTextFromImage", function () {
      if (_this.blotConfig.processGetTextFromImage) {
        _this.blotConfig.processGetTextFromImage(_this.map.get('attachmentGlobalId'));
        return;
      }
      var text;
      var getTextPromise = _this.blotConfig.ocr.getTextForAttachment(_this.map.get('attachmentGlobalId'));
      if (getTextPromise === false) {
        // клиент отменяет получение текста
        return;
      }
      var component = (0,preact_module.h)(imageTextPopup_ImageInfoPopup, {
        textPromise: getTextPromise,
        attachment: _this.props.attachment,
        editor: _this.editor
      });
      _this.editor.plugins.popupManager.dialog(component);
    });
    image_defineProperty(image_assertThisInitialized(_this), "download", /*#__PURE__*/image_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var attachment, originalSize, blob;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              attachment = _this.props.attachment;
              if (_this.map.get('unsplash')) {
                attachment.isPseudoImg = true;
                originalSize = _this.map.get('originalSize');
                if (originalSize) {
                  attachment.width = originalSize.width;
                  attachment.height = originalSize.height;
                }
              }
              if (_this.editor.plugins.attachmentManager.download(attachment)) {
                _context.next = 7;
                break;
              }
              _context.next = 5;
              return fetch(_this.props.attachment.url).then(function (r) {
                return r.blob();
              });
            case 5:
              blob = _context.sent;
              window.saveAs(blob, String(attachment.global_id + IMAGE_FILE_EXTENCIONS[blob.type]));
            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    image_defineProperty(image_assertThisInitialized(_this), "viewFullSize", function () {
      var processed = false;
      // в дальнейшем в клиентах лучше использовать единую функцию из плагина ImageManager для открытия изображений,
      // а передаваемую в конфигурции блота `processEnterFullSize` пометить как deprecated
      if (_this.blotConfig.processEnterFullSize) {
        if (_this.blotConfig.processEnterFullSize(_this.props.attachment) !== false) {
          processed = true;
        }
      }
      if (!processed) {
        if (_this.editor.plugins.imageManager.enterFullSize(_this.props.attachment.global_id) !== false) {
          processed = true;
        }
      }
      if (!processed) {
        _this.editor.plugins.lightBox.open(_this.props.attachment.url);
      }
      _this.scroll.setSelectedBlots([]);
    });
    image_defineProperty(image_assertThisInitialized(_this), "editImage", /*#__PURE__*/image_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var currentId, newId;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              currentId = _this.map.get('attachmentGlobalId');
              _context2.next = 3;
              return _this.editor.plugins.attachmentManager.editImage(currentId);
            case 3:
              newId = _context2.sent;
              if (newId) {
                _this.setAttachment(newId);
                _this.resolveAttachment();
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    image_defineProperty(image_assertThisInitialized(_this), "openInNewTab", function () {
      window.open(_this.props.attachment.url, '_blank', 'noopener');
    });
    image_defineProperty(image_assertThisInitialized(_this), "imageInfo", /*#__PURE__*/image_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var info, component;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              info = [];
              component = (0,preact_module.h)(ImageInfoPopup, {
                attachment: _this.props.attachment,
                editor: _this.editor,
                blotConfig: _this.blotConfig
              });
              _this.editor.plugins.popupManager.dialog(component);
            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    image_defineProperty(image_assertThisInitialized(_this), "closeInfoPopup", function () {
      _this.imageInfo(false);
    });
    image_defineProperty(image_assertThisInitialized(_this), "rotateImage", /*#__PURE__*/image_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var currentId, allowRotate, width, ratio, id, self;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              currentId = _this.map.get('attachmentGlobalId');
              _context4.next = 3;
              return _this.editor.plugins.attachmentManager.allowRotateImage(currentId);
            case 3:
              allowRotate = _context4.sent;
              if (allowRotate) {
                _context4.next = 6;
                break;
              }
              return _context4.abrupt("return");
            case 6:
              _this.domNode.classList.add('rotate-processing');
              width = _this.image.getBoundingClientRect().height;
              ratio = width / _this.image.getBoundingClientRect().width;
              _this.setProps({
                rotateProcessing: true
              });
              image_get((_thisSuper = image_assertThisInitialized(_this), image_getPrototypeOf(ImageBlot.prototype)), "clearAttachment", _thisSuper).call(_thisSuper);
              _this.onClearAttachmentSetProps();
              _context4.next = 14;
              return _this.editor.plugins.attachmentManager.rotateImage(currentId);
            case 14:
              id = _context4.sent;
              _this.setAttachment(id);
              self = image_assertThisInitialized(_this); //Назначаем ширину после того как загрузилось перевернутое изображение в браузер, чтобы избежать графических багов с масштабированием.
              //Тут сделал не через "once" (слушать событие один раз), потому что во время процесса поворота изображения пользователь может загружать другое изображение,
              //и эвент может отрботать на событие загрузки другого изображения и не назначить ширину текущему,
              //поэтому вешаем постоянный слушатель, и когда условие в нем сработает и загрузится текущее перевернутое изображение, снимаем слушатель
              _this.editor.emitter.on('embed-loaded', function onImageLoad(_ref5) {
                var id = _ref5.id;
                if (id === self.id) {
                  self.editor.emitter.off('embed-loaded', onImageLoad);
                  self.setWidthToMap(width);
                  self.map.set('ratio', ratio);
                  self.props.rotateProcessing = null;
                  self.detachRotateLoader(self.domNode.querySelector('.rotate-loader'));
                }
              });
            case 18:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    image_defineProperty(image_assertThisInitialized(_this), "onImageDblClick", function (event) {
      if (_this.getOpenFullSize() !== 'doubleClick') {
        return;
      }
      event.preventDefault();
      _this.viewFullSize();
    });
    image_defineProperty(image_assertThisInitialized(_this), "onImageMouseDown", function (event) {
      if (_this.getOpenFullSize() !== 'focusedClick') {
        return;
      }
      if (_this.props.focused) {
        event.preventDefault();
        _this.viewFullSize();
      }
    });
    image_defineProperty(image_assertThisInitialized(_this), "onImageClick", function (event) {
      if (_this.getOpenFullSize() !== 'click') {
        return;
      }
      event.preventDefault();
      _this.viewFullSize();
    });
    image_defineProperty(image_assertThisInitialized(_this), "mapObserver", function (event) {
      _this.render();
    });
    _this.domNode.classList.add('image');
    _this.domNode.setAttribute('contenteditable', false);
    _this.wrapper = _this.domNode.querySelector('.image-container');
    _this.image = _this.wrapper.firstChild;
    _this.commentsCounter = _this.addCommentsCounter(image_assertThisInitialized(_this));
    _this.wrapper.appendChild(_this.commentsCounter.node);
    _this.placeholder = null;
    _this.attachmentConfig.acceptFiles = 'image/*';
    Object.assign(_this.messages, {});
    _this.isSeparableByClickApplicable = true;
    _this.embeddableFocusableNode = _this.image;
    _this.selfColorManagement = true;
    _this.addCanExecActions(['set-align', 'delete', 'backspace']);
    // фикс для возврата функций рейсайза после выхода из fullWidth
    if (_this.fullWidth) {
      _this.fullWidth.afterFunc = function () {
        setTimeout(function () {
          _this.render();
          // если изображение растянуто на весь экран
          // проверяем что у изображения установлен размер и изображение загружено
          if (_this.image.width && !_this.domNode.classList.contains('loading')) {
            // сохраняем значение ширины, для того чтобы корректно отображать изображение при экспорте в PDF/HTML
            _this.map.set('fullWidth', _this.image.width);
          }
        }, 0);
      };
    }
    _this.dontRemoveWithBackspace = true;
    return _this;
  }
  image_createClass(ImageBlot, [{
    key: "addCommentsCounter",
    value: function addCommentsCounter(imageBlot) {
      var _this2 = this;
      var node = document.createElement('div');
      node.classList.add('image-comments-counter');
      var onClickCounter = function onClickCounter(event) {
        imageBlot.commentImageBlot();
      };
      var setCount = function setCount() {
        var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        if (imageBlot.map.get('unsplash') || imageBlot.editor.mode !== imageBlot.editor.constructor.MODE_EDIT || !_this2.editor.plugins.commentManager.enabled) {
          if (!node.classList.contains('disabled')) {
            node.classList.add('disabled');
          }
          return;
        }
        var imageWidth = imageBlot.map.get('width') || imageBlot.image.clientWidth;
        var imageHeight = imageBlot.map.get('ratio') ? imageWidth / imageBlot.map.get('ratio') : imageBlot.image.clientHeight;
        if (imageWidth < 100 || imageHeight < 100) {
          if (!node.classList.contains('disabled')) {
            node.classList.add('disabled');
          }
        } else {
          if (node.classList.contains('disabled')) {
            node.classList.remove('disabled');
          }
        }
        var iconClassName = ['comment-counter-icon'];
        var counterClassName = ['comments-count'];
        var hasComments = typeof count === 'number' && count > 0;
        if (hasComments) {
          if (count >= 10 && count < 100) {
            counterClassName.push('over-ten');
          }
          if (count >= 100) {
            counterClassName.push('over-hundred');
          }
        } else {
          iconClassName.push('no-comments');
        }
        var attrs = image_defineProperty({}, tooltipManager/* TOOLTIP_ATTR */.qZ, imageBlot.editor.plugins.i18n.get('image.comments'));
        (0,preact_module/* render */.sY)((0,preact_module.h)("div", image_extends({
          className: iconClassName.join(' '),
          onClick: onClickCounter
        }, attrs), (0,preact_module.h)(icons/* IconComment */.ge4, null), hasComments ? (0,preact_module.h)("span", {
          className: counterClassName.join(' ')
        }, count < 100 ? count : '99') : null), node);
      };
      return {
        node: node,
        update: setCount
      };
    }

    /**
     * Срабатывает когда у .resize-container добавляется/удаляется класс .resize-over-width
     * @param isOverWidth
     */
  }, {
    key: "onResizeOverWidth",
    value: function onResizeOverWidth(isOverWidth) {
      // Разрешаем изменять isResizeOverWidth только в режиме редактирования
      if (this.editor.mode === this.editor.constructor.MODE_EDIT) {
        // Если isResizeOverWidth уже установлен то не сохраняем его повторно, нужно чтобы не срабатывалй render при
        // первой загрузке, иначе будет постоянно отображаться лоадер
        if (this.map.get('isResizeOverWidth') !== isOverWidth && !this.domNode.classList.contains('loading')) {
          // При изменении размера изображения устанавливаем в map isResizeOverWidth для того чтобы
          // использовать при экспорте в HTML/PDF
          this.map.set('isResizeOverWidth', isOverWidth);
        }
      }
    }
  }, {
    key: "setResizeContainerSize",
    value: function setResizeContainerSize(params) {
      image_get(image_getPrototypeOf(ImageBlot.prototype), "setResizeContainerSize", this).call(this, params);
    }
  }, {
    key: "onBlotMenuUpdatePosition",
    value: function onBlotMenuUpdatePosition(_ref6) {
      var left = _ref6.left,
        top = _ref6.top;
      top += 1;
      var loaderNode = this.wrapper.querySelector('.image-remote-loading-container');
      if (loaderNode) {
        var nodeX = loaderNode.getBoundingClientRect().x;
        left += nodeX - this.domNode.getBoundingClientRect().x;
      }
      return {
        left: left,
        top: top
      };
    }
  }, {
    key: "onGetCommentPosition",
    value: function onGetCommentPosition(_ref7) {
      var left = _ref7.left,
        top = _ref7.top;
      if (this.image && this.image.src) {
        var _getRelRect = (0,dom/* getRelRect */.vk)(this.image, this.editor.editorBody),
          iLeft = _getRelRect.left,
          width = _getRelRect.width;
        left -= left - (iLeft + width);
        top += 10;
      }
      return {
        left: left,
        top: top
      };
    }
  }, {
    key: "onUpdateCommentsCount",
    value: function onUpdateCommentsCount(count) {
      this.setProps && this.setProps({
        commentsCount: count
      });
    }
  }, {
    key: "onRemoveCommentsCount",
    value: function onRemoveCommentsCount() {
      this.setProps && this.setProps({
        commentsCount: null
      });
    }
  }, {
    key: "clearAttachment",
    value: function clearAttachment() {
      image_get(image_getPrototypeOf(ImageBlot.prototype), "clearAttachment", this).call(this);
      this.map.set('color', 'transparent');
      this.map.delete('width');
      this.map.delete('ratio');
      this.map.delete('noGridWidth');
      this.map.delete('originalSize');
      this.map.delete('unsplash');
      this.onClearAttachmentSetProps();
    }
  }, {
    key: "embedAttachmentUrl",
    value: function embedAttachmentUrl(url) {
      var _this3 = this;
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'user';
      var newProps = {
        scrollToCaretOnOnload: source === 'user' ? true : null
      };
      // если задан chooseFileFromUrl метод, то показываем сразу значек загрузки для изображения
      // иначе будет добавлен псевдо аттач, который вставляется быстро и не требует загрузки на сервер
      if (this.editor.plugins.attachmentManager.options.chooseFileFromUrl) {
        Object.assign(newProps, {
          uploading: true,
          progress: 0,
          saveFileTask: null
        });
      }
      this.setProps(newProps);
      this.editor.plugins.attachmentManager.chooseFileFromUrl(url).then(function (file) {
        if (!_this3.editor.plugins.attachmentManager.checkFileSize(file.size)) {
          throw new QuotaError('file is too big', file);
        }
        if (file && file.type && file.type.indexOf('image') !== -1) {
          return _this3.setHTMLFileForUpload(file, false, source);
        } else {
          _this3.onSetAttachmentError(_this3.editor.plugins.i18n.get('image.unknown_error'));
        }
      }).catch(this.onSetAttachmentError);
    }
  }, {
    key: "onImageChooseUnsplash",
    value: function onImageChooseUnsplash(img) {
      var _img$user,
        _img$user2,
        _img$user2$links,
        _this4 = this;
      var url = img && (img.urls.regular || img.urls.full || img.urls.raw);
      if (!url) {
        this.onSetAttachmentError(this.editor.plugins.i18n.get('image.unknown_error'));
      }
      var authorParams = {
        name: (_img$user = img.user) === null || _img$user === void 0 ? void 0 : _img$user.name,
        link: (_img$user2 = img.user) === null || _img$user2 === void 0 ? void 0 : (_img$user2$links = _img$user2.links) === null || _img$user2$links === void 0 ? void 0 : _img$user2$links.html
      };
      this.editor.plugins.attachmentManager.resolvePseudoAttachment(url).then(function (attachment) {
        if (attachment && attachment.attachmentGlobalId) {
          _this4.map.set('unsplash', true);
          _this4.setAttachment(attachment.attachmentGlobalId);
          if (authorParams.name || authorParams.link) {
            var _this4$editor, _this4$editor$plugins, _this4$editor$plugins2;
            var linkAttrs = authorParams.link ? {
              link: authorParams.link
            } : null;
            var preffix = (((_this4$editor = _this4.editor) === null || _this4$editor === void 0 ? void 0 : (_this4$editor$plugins = _this4$editor.plugins) === null || _this4$editor$plugins === void 0 ? void 0 : (_this4$editor$plugins2 = _this4$editor$plugins.i18n) === null || _this4$editor$plugins2 === void 0 ? void 0 : _this4$editor$plugins2.get('image.unsplash.caption_preffix')) || 'Photo by') + ' ';
            embedWrapperAbstract.setCaption(_this4.editor, _this4.map, [{
              insert: preffix
            }, {
              insert: authorParams.name || authorParams.link,
              attributes: linkAttrs
            }]);
          }
          _this4.putCaretInNextBlotAfterAttachment();
        } else {
          _this4.onSetAttachmentError(_this4.editor.plugins.i18n.get('image.unknown_error'));
        }
      }).catch(function (err) {
        console.error(err);
        _this4.onSetAttachmentError(err);
      });
    }
  }, {
    key: "setHTMLFileForUpload",
    value: function setHTMLFileForUpload(file) {
      var putCaretAfter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'user';
      this.setProps({
        scrollToCaretOnOnload: source === 'user' ? true : null
      });
      if (file.attachmentGlobalId && file.isUploaded) {
        // удаляем сразу плейсхолдер, в котором показывается прогресс аплоада, т.к. аттач будет установлен сразу
        // для картинки
        var placeholder = this.domNode.querySelector('.no-image-wrapper');
        if (placeholder) {
          this.detachPlaceholder(placeholder);
        }
      }
      return image_get(image_getPrototypeOf(ImageBlot.prototype), "setHTMLFileForUpload", this).call(this, file, putCaretAfter);
    }
  }, {
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = image_get(image_getPrototypeOf(ImageBlot.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      // выставляем алайн если его нет в map по дефолту, до инициализации map обсервера
      if (!this.map.has('align')) {
        var align = this.blotConfig.defaultAlign;
        if (!align || !ALLOWED_ALIGNS.includes(align)) {
          align = DEFAULT_ALIGN;
        }
        this.map.set('align', align);
      }
      this.store.observe(this.map, this.mapObserver);
      if (this.editor.mode === this.editor.constructor.MODE_EDIT) {
        this.initPopupContainer();
      }
      this.image.addEventListener('dblclick', this.onImageDblClick, false);
      this.image.addEventListener('mousedown', this.onImageMouseDown, false);
      this.image.addEventListener('click', this.onImageClick, false);
      if (this.fullWidth) {
        this.fullWidth = Object.assign(this.fullWidth, {
          wrapperNode: this.getWrapper().domNode
        });
      }
      this.resizeContainer = this.image.closest('.resize-container');
      var _this$blotConfig = this.blotConfig,
        _this$blotConfig$show = _this$blotConfig.showMenuItemOpenInNewTab,
        showMenuItemOpenInNewTab = _this$blotConfig$show === void 0 ? true : _this$blotConfig$show,
        _this$blotConfig$show2 = _this$blotConfig.showLeftMenuItemCopyLink,
        showLeftMenuItemCopyLink = _this$blotConfig$show2 === void 0 ? true : _this$blotConfig$show2,
        _this$blotConfig$show3 = _this$blotConfig.showMenuItemGetTextFromImage,
        showMenuItemGetTextFromImage = _this$blotConfig$show3 === void 0 ? true : _this$blotConfig$show3,
        _this$blotConfig$show4 = _this$blotConfig.showMenuItemEditImage,
        showMenuItemEditImage = _this$blotConfig$show4 === void 0 ? false : _this$blotConfig$show4;
      this.showMenuItemOpenInNewTab = showMenuItemOpenInNewTab;
      this.showLeftMenuItemCopyLink = showLeftMenuItemCopyLink;
      this.showMenuItemGetTextFromImage = showMenuItemGetTextFromImage;
      this.showMenuItemEditImage = showMenuItemEditImage;
      this.render();
      this.onAttachUploadResoursesIfNeed();
    }
  }, {
    key: "detach",
    value: function detach() {
      if (this.map) {
        this.store.unobserve(this.map, this.mapObserver);
      }
      //detach плейсхолдера и лоадера если они есть
      this.detachPlaceholder();
      this.detachLoader(this.domNode.querySelector('.image-loading-icon'));
      this.image.removeEventListener('dblclick', this.onImageDblClick, false);
      this.image.removeEventListener('mousedown', this.onImageMouseDown, false);
      this.image.removeEventListener('click', this.onImageClick, false);
      image_get(image_getPrototypeOf(ImageBlot.prototype), "detach", this).call(this);
    }
  }, {
    key: "canDragWith",
    value: function canDragWith(node) {
      if (this.isBlotLocked) {
        return false;
      } else {
        return node === this.image && !this.ignoringUpdateRender;
      }
    }
  }, {
    key: "getContentElement",
    value: function getContentElement() {
      if (this.hasAttachment()) {
        return this.image;
      } else {
        false;
      }
    }
  }, {
    key: "originalSize",
    get: function get() {
      if (!this.hasAttachment() || !this.map.get('originalSize')) {
        return null;
      } else {
        return this.map.get('originalSize');
      }
    }
  }, {
    key: "setWidthToMap",
    value: function setWidthToMap(width) {
      if (!width) return;
      if (this.editor.options.deviceType === 'mobile') {
        if (this.maxContentOverWidth <= width) {
          width = 1000;
        }
      }
      this.map.set('width', width);
    }
  }, {
    key: "getWrapper",
    value: function getWrapper() {
      return this.parent;
    }
  }, {
    key: "fetchSizeIfNeed",
    value:
    //TODO: пока не ясно нужны ли отдельные функции для получения ширины изображения,
    //возможно в мульти редактировании будет работать не корректно если оставить получение ширины только из превью файла,
    //хотя поидее ширину будет выставлять клиент который выполняет загрузку
    function fetchSizeIfNeed() {
      var _this5 = this;
      if (this._fetchingSizeInProgress) {
        return;
      }
      this._fetchingSizeInProgress = true;
      if (!this.map.has('width')) {
        var url = this.props.attachment.url;
        if ((typeof window === "undefined" ? "undefined" : image_typeof(window)) === 'object' && url.startsWith('/')) {
          url = window.location.origin + url;
        }
        var img = new Image();
        img.onload = function () {
          var maxResolveWidth = _this5.getWrapper().domNode.getBoundingClientRect().width;
          var resolveRate = 1;
          if (_this5.map.get('unsplash') && _this5.getWrapper().parent.constructor.blotName !== 'gridCol') {
            resolveRate = UNSPLASH_DEFAULT_WIDTH_RATIO;
          }
          var _ImageBlot$optimizeSi = ImageBlot.optimizeSize(img, maxResolveWidth, resolveRate),
            width = _ImageBlot$optimizeSi.width,
            ratio = _ImageBlot$optimizeSi.ratio,
            originalWidth = _ImageBlot$optimizeSi.originalWidth,
            originalHeight = _ImageBlot$optimizeSi.originalHeight;
          _this5.editor.plugins.undoManager.skip(function () {
            _this5.setWidthToMap(width);
            _this5.map.set('ratio', ratio);
            _this5.map.set('noGridWidth', width);
            _this5.map.set('originalSize', {
              width: originalWidth,
              height: originalHeight
            });
          });
          _this5._fetchingSizeInProgress = false;
        };
        img.onerror = function (err) {
          console.error('Fail to load image', err);
          _this5.onSetAttachmentError(_this5.editor.plugins.i18n.get('image.unknown_error'));
          _this5._fetchingSizeInProgress = false;
        };
        img.src = url;
      }
    }
  }, {
    key: "attachPlaceholder",
    value: function attachPlaceholder() {
      var _this6 = this;
      this.domNode.classList.add('no-image');
      this.parent.domNode.classList.add('no-attachment');
      if (this.image) {
        this.image.classList.forEach(function (cls) {
          return _this6.image.classList.remove(cls);
        });
        this.image.classList.add('img-hide');
      }
      this.setProps({
        attachmentLoaded: false,
        isContentRendered: false
      });
      pRenderInContainer((0,preact_module.h)(ImageEmptyPlaceholder, {
        blot: this,
        abortable: Boolean(this.props.saveFileTask),
        onRenderPlaceholder: this.onRenderPlaceholder
      }), this.domNode, 'no-image-wrapper');
    }
  }, {
    key: "detachPlaceholder",
    value: function detachPlaceholder() {
      this.domNode.classList.remove('no-image');
      this.parent.domNode.classList.remove('no-attachment');
      pRenderInContainer(null, this.domNode, 'no-image-wrapper');
    }
  }, {
    key: "attachLoader",
    value: function attachLoader() {
      if (this.editor.mode === MODE_EXPORT) {
        return;
      }
      this.domNode.classList.add('loading');
      //тут выставляем временно ширину/высоту для контейнера изображения, если она доступна, для корректоного отображения лоадера
      var width = this.map.get('width');
      if (width) {
        if (!this.allowOverWidth && width > this.maxContentWidth) {
          width = this.maxContentWidth;
        }
        var ratio = this.map.get('ratio');
        // ожидаем пока отработает рендер во всех миксинах и выставляем размер
        this.setResizeContainerSize({
          width: width,
          ratio: ratio
        });
      }
      pRenderInContainer((0,preact_module.h)("div", {
        className: "image-loading-icon"
      }, (0,preact_module.h)((loader2_default()), null)), this.wrapper, 'image-loader-wrapper');
    }
  }, {
    key: "detachLoader",
    value: function detachLoader() {
      this.domNode.classList.remove('loading');
      pRenderInContainer(null, this.wrapper, 'image-loader-wrapper');
    }
  }, {
    key: "attachRemoteLoader",
    value: function attachRemoteLoader(container) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.domNode.classList.add('remote-loading');
      var styles = {};
      //тут выставляем ширину/высоту если доступна, потому что у пользователя, который загружает изображение, ширина выставляется до загрузки файла
      if (this.map.get('width')) {
        styles.width = this.map.get('width') + 'px';
        if (this.map.get('ratio')) {
          styles.height = this.map.get('width') / this.map.get('ratio') + 'px';
        }
      }
      var text = (0,preact_module.h)(plugins_i18n/* Text */.xv, {
        id: "attachment.attachment_is_being_uploaded"
      });
      var deleteBtn = null;
      if (opts.isOffline) {
        text = (0,preact_module.h)(plugins_i18n/* Text */.xv, {
          id: "attachment.attachment_will_be_downloaded_online"
        });
      } else if (opts.isPreviewNotAvailable) {
        text = (0,preact_module.h)(plugins_i18n/* Text */.xv, {
          id: "attachment.attachment_preview_is_not_available"
        });
        deleteBtn = this.renderDeleteButton();
      }
      if (opts.error) {
        text = (0,preact_module.h)(plugins_i18n/* Text */.xv, {
          id: "image.attachment_not_found_error"
        });
        deleteBtn = this.renderDeleteButton();
      }
      pRenderInContainer((0,preact_module.h)(plugins_i18n/* IntlProvider */.Pj, null, (0,preact_module.h)("div", {
        className: "image-remote-loading-container",
        style: styles
      }, (0,preact_module.h)(icons/* IconEmptyImage */.I19, null), (0,preact_module.h)("div", {
        className: "loading-text"
      }, text), deleteBtn)), this.wrapper, 'image-remote-loader-wrapper');
    }
  }, {
    key: "detachRemoteLoader",
    value: function detachRemoteLoader() {
      this.domNode.classList.remove('remote-loading');
      pRenderInContainer(null, this.wrapper, 'image-remote-loader-wrapper');
    }
  }, {
    key: "attachRotateLoader",
    value: function attachRotateLoader() {
      this.domNode.classList.add('rotate-processing');
      var width = this.map.get('width');
      var blotDomWidth = this.getWrapper().domNode.getBoundingClientRect().width;
      if (width) {
        if (width > blotDomWidth) {
          width = blotDomWidth;
        }
        this.setResizeContainerSize({
          width: width,
          ratio: this.map.get('ratio')
        });
      }
      var text = '';
      var addClassName = '';
      if (width >= minImageWidthForFullLoader) {
        text = this.editor.plugins.i18n.get('image.rotate_wait.full');
        addClassName += 'full-loader';
      } else if (width < minImageWidthForFullLoader && width >= minImageWidthForSmallLoader) {
        if (width >= minImageWidthForMediumLoader) {
          text = this.editor.plugins.i18n.get('image.rotate_wait.medium');
          addClassName += 'medium-loader';
        } else if (width < minImageWidthForMediumLoader) {
          addClassName += 'small-loader';
        }
      } else {
        addClassName += 'hidden';
      }
      pRenderInContainer((0,preact_module.h)("div", {
        className: 'rotate-loader ' + addClassName
      }, (0,preact_module.h)("div", {
        className: "image-wait-icon"
      }, (0,preact_module.h)((loader2_default()), null)), (0,preact_module.h)("div", {
        className: "rotate-loader-wait-text"
      }, text)), this.wrapper, 'image-rotate-loader-wrapper');
    }
  }, {
    key: "detachRotateLoader",
    value: function detachRotateLoader() {
      this.domNode.classList.remove('rotate-processing');
      pRenderInContainer(null, this.wrapper, 'image-rotate-loader-wrapper');
    }
  }, {
    key: "clearUploadingCache",
    value: function clearUploadingCache() {
      this.setProps({
        file: null,
        uploading: null,
        progress: null,
        saveFileTask: null,
        setAttachmentError: null
      });
    }
  }, {
    key: "renderHighlights",
    value: function renderHighlights() {
      var containerClass = 'image-highlights';
      var container = this.wrapper.querySelector('.' + containerClass);
      var highlights = this.props.highlights;
      var component;
      if (highlights) {
        component = (0,preact_module.h)("div", {
          className: containerClass
        }, (0,preact_module.h)(ImageHighlights, {
          highlights: highlights,
          width: this.image.width,
          height: this.image.height,
          naturalWidth: this.image.naturalWidth,
          naturalHeight: this.image.naturalHeight
        }));
      } else {
        component = (0,preact_module.h)(NullComponent, null);
        if (!container) {
          return;
        }
      }
      (0,preact_module/* render */.sY)(component, this.wrapper);
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;
      if (this.ignoringUpdateRender) return;
      image_get(image_getPrototypeOf(ImageBlot.prototype), "render", this).call(this);
      this.getWrapper().render();
      this.commentsCounter.update(this.props.commentsCount);
      var loader = this.wrapper.querySelector('.image-loading-icon');
      var remote = this.wrapper.querySelector('.image-remote-loading-container');
      var rotateLoader = this.domNode.querySelector('.rotate-loader');
      var self = this;
      if (!this.hasAttachment()) {
        //рендер загрузчика поворота, если идет процесс поворота изображения
        if (this.props.rotateProcessing) {
          this.attachRotateLoader(rotateLoader);
        }
        //рендер превью, если изображение не загружено, но уже получен или выбран файл для его загрузки,
        //также здесь получаем ширину изображения из временного файла
        else {
          if (this.props.file) {
            if (!this._previewOnLoadReady) {
              this.setPreviewImage(getFilePreviewUrl(this.props.file));
            }
          }
          //если изображение не загружено или был сделан, например, реплейс, когда globalId в map отсутствует,
          //так же если нет файла в props, удаляем src изображения
          else {
            if (this.image.getAttribute('src')) {
              this.image.removeAttribute('src');
            }
            if (this.props.attachment) {
              this.props.attachment = null;
            }
          }
          var uploadingBy = this.getUploadingBy();
          if (uploadingBy && uploadingBy.userId !== this.scroll.store.userId || this.props.isPreviewNotAvailable) {
            //рендер удаленного загрузчика, если изображение начал загружать другой пользователь
            this.attachRemoteLoader(remote, {
              isPreviewNotAvailable: this.props.isPreviewNotAvailable
            });
            this.detachPlaceholder();
          } else {
            //рендер плейсхолдера
            this.attachPlaceholder();
            this.detachRemoteLoader(remote);
            this.detachLoader();
          }
        }
      } else {
        var needDetachRemoteLoader = false;
        if (this.props.isPreviewNotAvailable) {
          this.setProps({
            isPreviewNotAvailable: false
          });
        }
        if (this.props.attachment) {
          this.detachRemoteLoader(remote);
          //TODO: тут нужно будет провести оптимизацию кода, потому что оба вида рендера поидее одинаковые,
          //и нужно просто выставить правильно условия рендера с превью или с лоадером

          var imageShadow = this.map.get('imageShadow');
          if (!this.props.attachment.imageShadow && imageShadow) {
            this.props.attachment.imageShadow = true;
          }

          //рендер загруженного на сервер изображения,
          //здесь рендерим без лоадера, так как у нас есть временный файл в props,
          //дожидаемся загрузки файла с сервера и сетим src уже загруженного файла
          if (this.props.file && this.props.attachment && this.image.getAttribute('src') !== this.props.attachment.url) {
            var img = new Image();
            img.onload = function () {
              _this7.image.setAttribute('src', _this7.props.attachment.url);
              _this7.domNode.classList.remove('preview-image');
              _this7._previewOnLoadReady = false;
              //detach плейсхолдера
              _this7.detachPlaceholder();
              _this7.setProps({
                attachmentLoaded: true,
                isContentRendered: true
              });
              _this7.clearUploadingCache();
              _this7.editor.emitter.emit('embed-loaded', {
                id: _this7.id
              });
              _this7.image.classList.remove('img-hide');
              _this7.image.classList.add('img-loaded');
            };
            img.onerror = function (err) {
              console.error('Preview image loading error: ', err);
            };
            img.src = this.props.attachment.url;
          }
          //рендер загруженного на сервер изображения с применением лоадера при загрузке редактора, когда получен его url,
          //так как загрузку превью в любом случае придется ждать и смысла в этом нет
          else {
            this.fetchSizeIfNeed();
            if (this.image.getAttribute('src') !== this.props.attachment.url) {
              this.image.setAttribute('src', this.props.attachment.url);
              //TODO: detach плейсхолдера - тут какая то ерунда происходит: если нажать abort, когда изображение как будто бы загружено на 100%,
              //но еще висит превью с лоадером, то мы обнуляем file и тд в props, и таск поидее должен отмениться,
              //но видимо saveFileTask в props в этот момент уже не существует и abort() из него не вызывается,
              //изображение все равно закачивается на сервер и в map пишется globalId, получается что у нас условие выше не выполняется,
              //потому что file уже нет, но редактор все равно подгружает изображение и срабатывает текущее условие,
              //изображение грузится с кругом загрузки и после загрузки все равно остается плейсхолдер, потому тут мы его детачим
              this.detachPlaceholder();
              this.image.addEventListener('load', function onImageLoad() {
                self.image.removeEventListener('load', onImageLoad, false);
                //назначение ширины делаем после загрузки изображения, чтобы при ротации не было графических багов с масштабированием
                //detach лоадера
                self.detachLoader(loader);
                self.setProps({
                  attachmentLoaded: true,
                  isContentRendered: true
                });
                self.editor.emitter.emit('embed-loaded', {
                  id: self.id
                });
                self.image.classList.remove('img-hide');
                self.image.classList.add('img-loaded');
              }, false);
            }
          }
          if (this.props.attachment.imageShadow) {
            this.image.classList.add('image-shadow');
          } else {
            this.image.classList.remove('image-shadow');
          }
          if (this.map.get('cover')) {
            if (!this.image.classList.contains('cover-image')) {
              this.image.classList.add('cover-image');
            }
          } else if (this.image.classList.contains('cover-image')) {
            this.image.classList.remove('cover-image');
          }
        }
        //Получаем url загруженного на сервер изображения если его еще нет в props. Рендерим лоадер если нет превью (!this.props.file)
        else {
          var attachmentErrorProcessed = false;
          if (this.props.setAttachmentError) {
            if (this.props.setAttachmentError instanceof attachmentNotFoundError["default"]) {
              this.detachLoader(loader);
              this.detachPlaceholder();
              attachmentErrorProcessed = true;
              if (this.isAttachmentMightBeUploading()) {
                this.attachRemoteLoader(remote, {
                  isOffline: this.props.setAttachmentError.isOffline
                });
              } else {
                this.attachRemoteLoader(remote, {
                  error: this.props.setAttachmentError
                });
              }
            }
          }
          if (!attachmentErrorProcessed) {
            if (!this.props.file && !this.props.rotateProcessing) {
              this.attachLoader(loader);
            }
            this.resolveAttachment();
          }
        }
        if (needDetachRemoteLoader) {
          this.detachRemoteLoader(remote);
        }
      }
      this.renderHighlights();
    }
  }, {
    key: "onClearAttachmentSetProps",
    value: function onClearAttachmentSetProps() {
      this.props.attachmentLoaded = false;
      this.props.isPreviewNotAvailable = false;
    }
  }, {
    key: "initPopupContainer",
    value: function initPopupContainer() {
      if (this.popupContainer) return;
      this.popupContainer = document.createElement('div');
      this.popupContainer.setAttribute('contenteditable', false);
      this.popupContainer.setAttribute(scroll_IGNORE_SELECT_ATTR, 1);
      this.popupContainer.classList.add('image-popup-container');
      this.domNode.appendChild(this.popupContainer);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.editor.emitter.emit('toolbar-status', {}, "#FFFFFF");
      var focused = [].slice.call(this.scroll.domNode.querySelectorAll('.focused-block'));
      focused.map(function (block) {
        block.classList.remove('focused-block');
      });
      this.domNode.classList.add('focused-block');
      this.scroll.selectedBlocks = [];
      if (this.scroll.selectedBlocks.indexOf(this) == -1) {
        this.scroll.selectedBlocks.push(this);
      }
      this.scroll.domNode.setAttribute('contenteditable', false);
      var selectedCols = [].slice.call(this.scroll.domNode.getElementsByClassName('col-selected'));
      selectedCols.map(function (col) {
        col.classList.remove('col-selected');
      });
      var currentCols = [].slice.call(this.scroll.domNode.getElementsByClassName('current'));
      currentCols.map(function (col) {
        col.classList.remove('current');
      });
      var writeCols = [].slice.call(this.scroll.domNode.getElementsByClassName('write'));
      writeCols.map(function (col) {
        var colBlot = parchment_default().find(col);
        var block = colBlot.children.head;
        block.domNode.removeAttribute('contenteditable');
        col.classList.remove('write');
      });
      var changeCols = [].slice.call(this.scroll.domNode.getElementsByClassName('change'));
      changeCols.map(function (col) {
        var colBlot = parchment_default().find(col);
        var block = colBlot.children.head;
        block.domNode.removeAttribute('contenteditable');
        col.classList.remove('write');
      });
      this.scroll.focused = false;
      this.editor.api.allowMerge = false;
      this.editor.emitter.emit('allow-merge', false);
      this.editor.api.allowDivide = false;
      this.editor.emitter.emit('allow-divide', false);
      this.scroll.selection.clearSelection();
      this.editor.emitter.emit('changed-current', {});
    }
  }, {
    key: "handleRemove",
    value: function handleRemove() {
      var _this8 = this;
      document.addEventListener('keydown', function (event) {
        if (_this8.domNode.classList.contains('focused-block')) {
          if (event.keyCode == 8 || event.keyCode == 46) {
            event.preventDefault();
            event.stopPropagation();
            _this8.remove();
            _this8.scroll.update('user');
          }
        }
      });
    }
  }, {
    key: "imageOnTabKey",
    value: function imageOnTabKey(event) {
      event.preventDefault();
      return this.addIndent();
    }
  }, {
    key: "imageOnShiftTabKey",
    value: function imageOnShiftTabKey(event) {
      event.preventDefault();
      return this.removeIndent();
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (image_isTabKey(event)) {
        return this.imageOnTabKey(event);
      } else if (image_isShiftTabKey(event)) {
        return this.imageOnShiftTabKey(event);
      }
      return image_get(image_getPrototypeOf(ImageBlot.prototype), "handleKeyDown", this).call(this, event);
    }
  }, {
    key: "toSelect",
    value: function toSelect() {
      this.scroll.selectedBlocks.push(this);
      var range = this.scroll.selection.getNativeRange();
      var endBlock = this.editor.api.getBlock(range.end.node);
      var nextBlock = function nextBlock(blot) {
        if (!blot) return false;
        if (blot.next != null && typeof blot.next != 'undefined') {
          return blot.next;
        } else {
          return nextBlock(blot.parent);
        }
      };
      if (endBlock != this) {
        var ans = nextBlock(this);
        if (ans['toSelect']) {
          ans.toSelect();
        }
      }
    }
  }, {
    key: "commentImageBlot",
    value: function commentImageBlot() {
      var processed = false;
      if (!processed) {
        if (this.editor.plugins.imageManager.enterFullSize(this.props.attachment.global_id, {
          commentMode: true
        }) !== false) {
          processed = true;
        }
      }
      if (!processed) {
        this.editor.plugins.lightBox.open(this.props.attachment.url);
      }
    }
  }, {
    key: "contextMenu",
    get: function get() {
      var menu = image_get(image_getPrototypeOf(ImageBlot.prototype), "contextMenu", this);
      var _this$editor$plugins = this.editor.plugins,
        i18n = _this$editor$plugins.i18n,
        attachmentManager = _this$editor$plugins.attachmentManager;
      if (!this.showLeftMenuItemCopyLink) {
        delete menu['copyLink'];
      }
      var isPseudoAttachment = Boolean(this.map.get('attachmentGlobalId')) && attachmentManager.isPseudoAttachment(this.map.get('attachmentGlobalId'));
      if (this.hasAttachment()) {
        if (!isPseudoAttachment) {
          menu['turn-into'] = {
            label: i18n.get('block_menu.convert_to.name'),
            index: -11,
            group: 0,
            action: false,
            submenu: {
              turnToFile: {
                label: i18n.get('block_menu.convert_to.file'),
                index: 0,
                group: 0,
                action: 'convert-blot',
                actionParams: {
                  type: 'file',
                  attachmentGlobalId: this.map.get('attachmentGlobalId'),
                  caption: this.map.get('caption')
                },
                actionExec: true,
                icon: icons/* IconFile */.XhR
              }
            }
          };
        }
        menu['addCaption'].index = -12;
        menu['replace'] = {
          label: i18n.get('block_menu.replace'),
          index: -10,
          group: 0,
          action: 'replace',
          stackable: false
        };
        if (!isPseudoAttachment) {
          menu['set-as-preview'] = {
            label: i18n.get('block_menu.set_as_preview'),
            index: -8,
            group: 0,
            action: 'setAsPreview',
            stakable: false
          };
          var ocr = this.blotConfig.ocr;
          if (typeof ocr != "undefined" && this.showMenuItemGetTextFromImage) {
            // получаем иконку доступности фичи
            var getTextFromImageEe = new (events_default())();
            var onGTFIMouseEnter = function onGTFIMouseEnter() {
              getTextFromImageEe.emit('enter', {});
            };
            var onGTFIMMouseLeave = function onGTFIMMouseLeave() {
              getTextFromImageEe.emit('leave', {});
            };
            var featureIcon = this.editor.plugins.featuresAvailabilityPlugin.getFeatureIcon('get-text-from-image', getTextFromImageEe);
            menu['get-text-from-image'] = {
              label: (0,preact_module.h)("div", {
                onMouseEnter: onGTFIMouseEnter,
                onMouseLeave: onGTFIMMouseLeave
              }, (0,preact_module.h)(plugins_i18n/* Text */.xv, {
                id: "block_menu.get_text_from_image"
              }), featureIcon),
              index: -7,
              group: 0,
              action: 'getTextFromImage',
              stakable: false
            };
          }
          if (this.showMenuItemEditImage) {
            menu['edit-image'] = {
              label: i18n.get('block_menu.edit_image'),
              index: -6,
              group: 0,
              action: 'editImage',
              stakable: false
            };
          }
        }
        menu['download'] = {
          label: i18n.get('block_menu.download'),
          index: -6,
          group: 0,
          action: 'download',
          stackable: false
        };
        menu['view-full-size'] = {
          label: i18n.get('block_menu.view_full_size'),
          index: -5,
          group: 0,
          action: 'viewFullSize',
          stackable: false
        };

        // Показываем Открыть в новой вкладке в зависимости от настроек
        if (this.showMenuItemOpenInNewTab) {
          menu['open-in-new-tab'] = {
            label: i18n.get('block_menu.open_in_new_tab'),
            index: -4,
            group: 0,
            action: 'openInNewTab',
            stackable: false
          };
        }
        if (!isPseudoAttachment) {
          menu['image-info'] = {
            label: i18n.get('block_menu.image_info'),
            index: -3,
            group: 0,
            action: 'imageInfo',
            stackable: false
          };
          if (this.editor.plugins.attachmentManager.isMethodImplemented('rotateImage') && this.props.attachmentLoaded) {
            menu['rotate'] = {
              label: i18n.get('block_menu.rotate_image'),
              index: -9,
              group: 0,
              action: 'rotateImage',
              stackable: false
            };
          }
        }
        menu['layout'] = (0,util/* mergeDeep */.Ee)(menu['layout'], {
          label: i18n.get('block_menu.layout'),
          index: -2,
          group: 0,
          action: false
        });
        var imageShadow = this.map.get('imageShadow');
        var isDoneSHI = icons/* IconEmpty */.Zlx;
        if (this.props.attachment && this.props.attachment.imageShadow || imageShadow) {
          if (!this.props.attachment.imageShadow) {
            this.props.attachment.imageShadow = true;
          }
          isDoneSHI = icons/* IconDone */.EZi;
        }
        // если сабменю меню стиля не определено миксинами, нужно его определить как объект
        if (!menu['layout'].submenu) {
          menu['layout'].submenu = {};
        }
        menu['layout'].submenu.imageShadow = {
          icon: isDoneSHI,
          label: i18n.get('file.menu.shadow_image'),
          index: 0,
          group: 0,
          action: 'onFileClickMenuImageShadow'
        };
        menu['layout'].submenu.cover = {
          icon: this.map.get('cover') ? icons/* IconDone */.EZi : icons/* IconEmpty */.Zlx,
          label: 'Cover',
          index: 3,
          group: 0,
          action: 'onSetImageCover'
        };
        if (menu['comment']) {
          if (isPseudoAttachment) {
            delete menu['comment'];
          } else {
            menu['comment'].action = 'commentImageBlot';
          }
        }
      } else {
        delete menu['layout'];
        delete menu['comment'];
        delete menu['change-color'];
      }
      return menu;
    }
  }, {
    key: "delete",
    value: function _delete() {
      var needBlur = false;
      if (this.scroll.selectedBlocks[this.scroll.selectedBlocks.length - 1] === this) {
        if (this.getWrapper().next && this.getWrapper().next.image) {
          needBlur = true;
        }
      }
      this.remove();
      if (needBlur) {
        this.editor.scroll.selection.setRange(null);
      }
    }
  }, {
    key: "getRightClickMenu",
    value: function getRightClickMenu(menu) {
      return false;
    }
  }, {
    key: "getOpenFullSize",
    value: function getOpenFullSize() {
      if (this.editor.mode === this.editor.constructor.MODE_READONLY || this.editor.mode === this.editor.constructor.MODE_PREVIEW) {
        return 'click';
      }
      return this.blotConfig.openFullSize || 'doubleClick';
    }
  }, {
    key: "onFocusableFocus",
    value: function onFocusableFocus() {
      var _this$selection$getRa = this.selection.getRange(),
        _this$selection$getRa2 = image_slicedToArray(_this$selection$getRa, 1),
        range = _this$selection$getRa2[0];
      if (!this.hasAttachment() && this.placeholder && (!range || range.length === 0)) {
        this.placeholder.onFocus();
      } else {
        image_get(image_getPrototypeOf(ImageBlot.prototype), "onFocusableFocus", this).call(this);
      }
    }
  }, {
    key: "onStartResizeBlot",
    value: function onStartResizeBlot() {
      image_get(image_getPrototypeOf(ImageBlot.prototype), "onStartResizeBlot", this).call(this);
      if (this.map.get('align') === 'full') {
        this.map.set('align', 'center');
      }
    }
  }, {
    key: "focusableFocus",
    value: function focusableFocus() {
      this.setCaretInTrap();
    }
  }, {
    key: "cloneSelf",
    value: function cloneSelf() {
      var map = this.store.createMap();
      var captionMap = this.store.createMap();
      Caption.initMap(captionMap, this.store, {
        delta: this.getWrapper().caption.delta({
          forCopy: true
        })
      });
      parchment_default().query(this.map.get('type')).initMap(map, this.store, {
        src: this.map.get('src'),
        attachmentGlobalId: this.map.get('attachmentGlobalId'),
        color: this.map.get('color'),
        imageShadow: this.map.get('imageShadow'),
        align: this.map.get('align'),
        caption: captionMap.get('id'),
        unsplash: this.map.get('unsplash'),
        width: this.map.get('width'),
        ratio: this.map.get('ratio'),
        noGridWidth: this.map.get('noGridWidth'),
        originalSize: this.map.get('originalSize')
      });
      return map.get('id');
    }
  }, {
    key: "exec",
    value: function exec(action) {
      var processed = image_get(image_getPrototypeOf(ImageBlot.prototype), "exec", this).call(this, action);
      var params = action.params;
      if (action.type === 'set-align') {
        this.map.set('align', params);
        if (params === 'full') {
          var _this$originalSize = this.originalSize,
            width = _this$originalSize.width,
            height = _this$originalSize.height;
          this.setWidthToMap(width);
          this.map.set('ratio', width / height);
        }
        processed = true;
      } else if (action.type === 'backspace') {
        var _this$scroll$selectio = this.scroll.selection.getRange(),
          _this$scroll$selectio2 = image_slicedToArray(_this$scroll$selectio, 1),
          range = _this$scroll$selectio2[0];
        var blur = false;
        if (this.getWrapper().next && this.getWrapper().next.image || this.getWrapper().prev && this.getWrapper().prev.image) {
          blur = true;
        }
        this.container.removeChildById(this.id);
        if (blur) {
          this.scroll.selection.setRange(null);
        } else {
          this.scroll.selection.setRange({
            index: range.index - 1,
            length: 0
          });
        }
        action.dontRestoreSelection();
        processed = true;
      }
      return processed;
    }
  }, {
    key: "getCopyHTML",
    value: function getCopyHTML() {
      var room = this.editor.options.serverRoom;
      var roomAttr = room ? ATTACH_ROOM_HTML_ATTR + '="' + room + '"' : '';
      var html = '<img src="' + this.image.getAttribute('src') + '"' + ' ' + ATTACH_GLOBAL_ID_HTML_ATTR + '="' + this.map.get('attachmentGlobalId') + '"' + ' ' + roomAttr + '>';
      var text = '![' + this.image.getAttribute('src') + '](' + this.image.getAttribute('src') + ')';
      return {
        html: html,
        text: text
      };
    }
  }, {
    key: "getCopyParams",
    value: function getCopyParams() {
      var _this$getCopyHTML = this.getCopyHTML(),
        html = _this$getCopyHTML.html,
        text = _this$getCopyHTML.text;
      var op = this.getBlotInsertParams(this.scroll.selection.getRange({
        offsetBlot: this
      })[0]);
      return {
        html: html,
        text: text,
        op: op
      };
    }
  }, {
    key: "getDraggingNode",
    value: function getDraggingNode() {
      var _this$map$toJSON2 = this.map.toJSON(),
        width = _this$map$toJSON2.width,
        ratio = _this$map$toJSON2.ratio,
        originalSize = _this$map$toJSON2.originalSize;
      var _this$container$domNo = this.container.domNode.getBoundingClientRect(),
        containerWidth = _this$container$domNo.width;
      var minWidth = originalSize && originalSize.width ? Math.min(width, containerWidth, originalSize.width) : Math.min(width, containerWidth);
      var node;
      if (this.image.src && this.image.src !== '') {
        node = document.createElement('div');
        var image = this.image.cloneNode();
        image.style.width = minWidth + 'px';
        image.style.height = minWidth / ratio + 'px';
        image.style.display = 'block';
        node.appendChild(image);
      } else if (!this.hasAttachment() && this.placeholder) {
        node = this.placeholder.domNode.cloneNode(true);
      }
      return node;
    }
  }, {
    key: "getBlotMenuHeaderComponent",
    value: function getBlotMenuHeaderComponent() {
      return ImageBlotMenuHeader;
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      if (context.options.noAttachments) {
        return '';
      }
      if (this.props.attachment) {
        if (context && context.addAttachment) {
          context.addAttachment(this.props.attachment);
        }
        var node = this.domNode.cloneNode(true);
        var imgPath = context && context.getAttachmentPath && context.getAttachmentPath(this.props.attachment);
        var oldImg = node.querySelector('img');
        if (context.options.toEmail) {
          oldImg.setAttribute('style', 'width:100%; height:100%;');
        }
        var resizeContainer = oldImg.closest('.resize-container');
        var img = oldImg.cloneNode();
        img.setAttribute('src', imgPath);
        var isFullWidthMode = this.map.get('fullwidthMode'); // расятинуто ли изображение на весь экран
        var width = isFullWidthMode ? this.map.get('fullWidth') : this.map.get('width');
        // если изображение растянуто на весь экран или превышает размеры редактора
        if (isFullWidthMode || this.map.get('isResizeOverWidth')) {
          resizeContainer.classList.add('resize-full-width-mode');
        }
        if (context.options.debug) {
          console.log('width:', width);
        }
        if (width) {
          var setWidth = true;
          if (context.options.pdf) {
            if (this.getWrapper().parent.constructor.blotName === 'gridCol') {
              setWidth = false;
            } else if (context.options.papperFormat === 'A4' && width >= 600) {
              setWidth = false;
            } else if (context.options.papperFormat === 'A5' && width >= 500) {
              setWidth = false;
            } else if (context.options.papperFormat === 'A3' && width >= 1000) {
              setWidth = false;
            }
          }
          if (setWidth) {
            // устанавливаем width именно у resizeContainer, а не у img для того чтобы кореектно работало выравниванеие
            resizeContainer.style.width = width + 'px';
            // устанавливаем --width для того, чтобы использовать в css стилях для правильно расчета margin-left
            resizeContainer.style.setProperty('--width', width + 'px');
            var ratio = this.map.get('ratio');
            if (ratio) {
              // если установлено ratio расчитываем и устанавливаем высоту у resizeContainer-а
              var height = width / ratio;
              resizeContainer.style.height = height + 'px';
            }
          }
        }
        if (context.options.toEmail) {
          var rWidth = resizeContainer.style.width;
          resizeContainer.style = 'width: ' + rWidth;
        }
        if (!context.options.pdf) {
          var aWrapper = document.createElement('a');
          aWrapper.setAttribute('href', imgPath);
          aWrapper.setAttribute('target', '_blank');
          aWrapper.appendChild(img);
          oldImg.parentNode.replaceChild(aWrapper, oldImg);
        } else {
          oldImg.parentNode.replaceChild(img, oldImg);
        }
        return node.outerHTML;
      } else {
        return '';
      }
    }
  }, {
    key: "isResizeAvailable",
    value: function isResizeAvailable() {
      if (typeof image_get(image_getPrototypeOf(ImageBlot.prototype), "isResizeAvailable", this) !== 'function' || image_get(image_getPrototypeOf(ImageBlot.prototype), "isResizeAvailable", this).call(this)) {
        return this.props.isContentRendered && !this.blotConfig.disableResize;
      }
      return false;
    }
  }, {
    key: "onDisabledResizeAllowSize",
    value: function onDisabledResizeAllowSize() {
      return this.domNode.classList.contains('preview-image');
    }
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      var _this$getWrapper$capt;
      var params = image_get(image_getPrototypeOf(ImageBlot.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
      return (0,util/* mergeDeep */.Ee)(params, {
        initParams: {
          src: this.map.get('src'),
          attachmentGlobalId: this.map.get('attachmentGlobalId'),
          align: this.map.get('align'),
          imageShadow: this.map.get('imageShadow'),
          width: this.map.get('width'),
          ratio: this.map.get('ratio'),
          noGridWidth: this.map.get('noGridWidth'),
          originalSize: this.map.get('originalSize'),
          captionParams: (_this$getWrapper$capt = this.getWrapper().caption) === null || _this$getWrapper$capt === void 0 ? void 0 : _this$getWrapper$capt.getBlotInsertParams(),
          unsplash: this.map.get('unsplash'),
          room: this.editor.options.serverRoom
        }
      });
    }
  }], [{
    key: "getMaxIndent",
    value: function getMaxIndent() {
      return image_MAX_INDENT_LEVEL;
    }

    /**
     * Возвращает ширину и высоту изображения
     * @param  {Object} img         оригинальное изображение (Blob)
     * @return {Array}              новые ширина и высота изображения
     */
  }, {
    key: "optimizeSize",
    value: function optimizeSize(img) {
      var maxWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var rate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var width = img.width,
        height = img.height;
      var ratio = width / height;
      var resolveWidth = width;
      var resolveHeight = height;
      if (maxWidth && width > maxWidth) {
        resolveWidth = maxWidth;
        resolveHeight = resolveWidth / ratio;
      }
      resolveWidth = resolveWidth * rate;
      resolveHeight = resolveWidth / ratio;
      var originalWidth = width,
        originalHeight = height;
      return {
        width: resolveWidth,
        height: resolveHeight,
        ratio: ratio,
        originalWidth: originalWidth,
        originalHeight: originalHeight
      };
    }
  }, {
    key: "createBlot",
    value: function createBlot(editor) {
      var blot = parchment_default().create('imageWrapper');
      this.addCaretTrap(editor, blot.domNode);
      return blot;
    }
  }, {
    key: "create",
    value: function create(value) {
      var node = image_get(image_getPrototypeOf(ImageBlot), "create", this).call(this);
      var image = document.createElement('IMG');
      var wrapper = document.createElement('div');
      image.classList.add('img-hide');
      wrapper.classList.add('image-container');
      wrapper.appendChild(image);
      node.appendChild(wrapper);
      wrapper.setAttribute('contenteditable', false);
      return node;
    }
  }, {
    key: "value",
    value: function value(node) {
      return {
        alt: this.image.getAttribute('alt'),
        url: this.image.getAttribute('src')
      };
    }
  }, {
    key: "match",
    value: function match(url) {
      return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
    }
  }, {
    key: "sanitize",
    value: function sanitize(url) {
      return link_sanitize(url, ['http', 'https', 'data']) ? url : '//:0';
    }
  }]);
  return ImageBlot;
}(image_mixin(AttachmentsBase));
image_defineProperty(ImageBlot, "initMap", function (map, store) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  map.set('type', 'image');
  map.set('src', params.src);
  if (params.align) {
    map.set('align', params.align);
  }
  if (params.unsplash) {
    map.set('unsplash', params.unsplash);
  }
  map.set('imageShadow', !params.imageShadow ? false : params.imageShadow);
  if (params.attachmentGlobalId) {
    map.set('attachmentGlobalId', params.attachmentGlobalId);
  }
  var captionId = params.caption;
  if (!captionId) {
    var captionMap = store.createMap();
    Caption.initMap(captionMap, store, params.captionParams || {});
    captionId = captionMap.get('id');
  }
  map.set('caption', captionId);
  // пробуем получить размеры изображения из параметров
  var width = params.width,
    height = params.height,
    ratio = params.ratio,
    noGridWidth = params.noGridWidth,
    originalSize = params.originalSize;
  // если размеры в параметрах есть, возможно они требуют оптимизации
  if (width && height) {
    var sizeParams = ImageBlot.optimizeSize({
      width: width,
      height: height
    });
    if (width !== sizeParams.width) {
      width = sizeParams.width;
    }
    if (!ratio) {
      ratio = sizeParams.ratio;
    }
    if (!noGridWidth) {
      noGridWidth = sizeParams.noGridWidth;
    }
    if (!originalSize) {
      originalSize = {
        width: sizeParams.originalWidth,
        height: sizeParams.originalHeight
      };
    }
  }
  // сохраняем полученные размеры если они есть
  if (width) {
    map.set('width', width);
  }
  if (ratio) {
    map.set('ratio', ratio);
  }
  if (noGridWidth) {
    map.set('noGridWidth', noGridWidth);
  }
  if (originalSize) {
    map.set('originalSize', originalSize);
  }
  map.set('allowOverWidth', params.allowOverWidth || false);
  indentable.initMap(map, store, params);
  colorable.initMap(map, store, params);
  image_get(image_getPrototypeOf(ImageBlot), "initMap", ImageBlot) && image_get(image_getPrototypeOf(ImageBlot), "initMap", ImageBlot).call(ImageBlot, map, store, params);
});
ImageBlot.blotName = 'image';
ImageBlot.tagName = 'DIV';
ImageBlot.parent = AttachmentsBase;
ImageBlot.wrapper = 'imageWrapper';
ImageBlot.minContentWidth = 50;
/* harmony default export */ const attachment_image = (ImageBlot);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/mixins/sizeaware.js
function sizeaware_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { sizeaware_typeof = function _typeof(obj) { return typeof obj; }; } else { sizeaware_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return sizeaware_typeof(obj); }










function sizeaware_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function sizeaware_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function sizeaware_createClass(Constructor, protoProps, staticProps) { if (protoProps) sizeaware_defineProperties(Constructor.prototype, protoProps); if (staticProps) sizeaware_defineProperties(Constructor, staticProps); return Constructor; }
function sizeaware_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) sizeaware_setPrototypeOf(subClass, superClass); }
function sizeaware_setPrototypeOf(o, p) { sizeaware_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return sizeaware_setPrototypeOf(o, p); }
function sizeaware_createSuper(Derived) { var hasNativeReflectConstruct = sizeaware_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = sizeaware_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = sizeaware_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return sizeaware_possibleConstructorReturn(this, result); }; }
function sizeaware_possibleConstructorReturn(self, call) { if (call && (sizeaware_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return sizeaware_assertThisInitialized(self); }
function sizeaware_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function sizeaware_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function sizeaware_getPrototypeOf(o) { sizeaware_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return sizeaware_getPrototypeOf(o); }
// блот с этим миксином будет иметь свою максимальную ширину в props.maxAvailableWidth

var SizeAware = function SizeAware(superclass) {
  return /*#__PURE__*/function (_superclass) {
    sizeaware_inherits(_class, _superclass);
    var _super = sizeaware_createSuper(_class);
    function _class() {
      var _this;
      sizeaware_classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _this.isSizeAware = true;
      return _this;
    }
    sizeaware_createClass(_class, [{
      key: "sizeAwareUpdateSize",
      value: function sizeAwareUpdateSize(maxAvailableWidth) {
        this.setProps({
          maxAvailableWidth: maxAvailableWidth
        });
      }
    }]);
    return _class;
  }(superclass);
};
/* harmony default export */ const sizeaware = (SizeAware);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/attachment/imageWrapper.js
function imageWrapper_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { imageWrapper_typeof = function _typeof(obj) { return typeof obj; }; } else { imageWrapper_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return imageWrapper_typeof(obj); }










function imageWrapper_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function imageWrapper_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function imageWrapper_createClass(Constructor, protoProps, staticProps) { if (protoProps) imageWrapper_defineProperties(Constructor.prototype, protoProps); if (staticProps) imageWrapper_defineProperties(Constructor, staticProps); return Constructor; }
function imageWrapper_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) imageWrapper_setPrototypeOf(subClass, superClass); }
function imageWrapper_setPrototypeOf(o, p) { imageWrapper_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return imageWrapper_setPrototypeOf(o, p); }
function imageWrapper_createSuper(Derived) { var hasNativeReflectConstruct = imageWrapper_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = imageWrapper_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = imageWrapper_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return imageWrapper_possibleConstructorReturn(this, result); }; }
function imageWrapper_possibleConstructorReturn(self, call) { if (call && (imageWrapper_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return imageWrapper_assertThisInitialized(self); }
function imageWrapper_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function imageWrapper_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function imageWrapper_getPrototypeOf(o) { imageWrapper_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return imageWrapper_getPrototypeOf(o); }





var ImageWrapper = /*#__PURE__*/function (_SizeAwareMixin) {
  imageWrapper_inherits(ImageWrapper, _SizeAwareMixin);
  var _super = imageWrapper_createSuper(ImageWrapper);
  function ImageWrapper(domNode) {
    var _this;
    imageWrapper_classCallCheck(this, ImageWrapper);
    _this = _super.call(this, domNode);
    _this.domNode.classList.add('image-wrapper');
    _this.caption = null;
    return _this;
  }
  imageWrapper_createClass(ImageWrapper, [{
    key: "image",
    get: function get() {
      return this.embed;
    }
  }, {
    key: "getInnerTextLine",
    value: function getInnerTextLine() {
      return this.caption;
    }
  }, {
    key: "sizeAwareUpdateSize",
    value: function sizeAwareUpdateSize(maxAvailableWidth) {
      this.embed.setProps({
        maxAvailableWidth: maxAvailableWidth
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.embed.hasAttachment() && this.embed.props.attachment && this.map.has('width')) {
        if (!this.caption) {
          this.caption = parchment_default().create('caption');
          this.caption.map = this.store.getMap(this.map.get('caption'));
          this.caption.embedBlot = this.embed;
          this.appendChild(this.caption);
        }
        this.caption.render();
      } else {
        if (this.caption) {
          this.caption.remove();
          this.caption = null;
        }
      }
      var align = this.map.get('align');
      if (align === 'full') {
        if (!this.domNode.classList.contains('full-width')) {
          this.domNode.classList.add('full-width');
        }
        this.domNode.setAttribute('data-content-align', 'center');
      } else {
        if (this.domNode.classList.contains('full-width')) {
          this.domNode.classList.remove('full-width');
        }
        this.domNode.setAttribute('data-content-align', align);
      }
      var color = this.map.get('color') || 'transparent';
      this.domNode.setAttribute('data-block-background', color);
    }
  }]);
  return ImageWrapper;
}(sizeaware(embedWrapperAbstract));

ImageWrapper.allowedChildren = [attachment_image, Caption];
ImageWrapper.blotName = 'imageWrapper';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/deleteBlock.js
function deleteBlock_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { deleteBlock_typeof = function _typeof(obj) { return typeof obj; }; } else { deleteBlock_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return deleteBlock_typeof(obj); }









function deleteBlock_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function deleteBlock_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function deleteBlock_createClass(Constructor, protoProps, staticProps) { if (protoProps) deleteBlock_defineProperties(Constructor.prototype, protoProps); if (staticProps) deleteBlock_defineProperties(Constructor, staticProps); return Constructor; }
function deleteBlock_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) deleteBlock_setPrototypeOf(subClass, superClass); }
function deleteBlock_setPrototypeOf(o, p) { deleteBlock_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return deleteBlock_setPrototypeOf(o, p); }
function deleteBlock_createSuper(Derived) { var hasNativeReflectConstruct = deleteBlock_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = deleteBlock_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = deleteBlock_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return deleteBlock_possibleConstructorReturn(this, result); }; }
function deleteBlock_possibleConstructorReturn(self, call) { if (call && (deleteBlock_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return deleteBlock_assertThisInitialized(self); }
function deleteBlock_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function deleteBlock_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function deleteBlock_getPrototypeOf(o) { deleteBlock_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return deleteBlock_getPrototypeOf(o); }








var DeleteBlockAction = /*#__PURE__*/function (_Action) {
  deleteBlock_inherits(DeleteBlockAction, _Action);
  var _super = deleteBlock_createSuper(DeleteBlockAction);
  function DeleteBlockAction(type, params, editor) {
    var _this;
    deleteBlock_classCallCheck(this, DeleteBlockAction);
    type = type || DeleteBlockAction.type;
    _this = _super.call(this, type, params, editor);
    _this.rangeBefore = null;
    _this.newRange = null;
    _this.deleteBlock = false;
    return _this;
  }
  deleteBlock_createClass(DeleteBlockAction, [{
    key: "before",
    value: function before(_ref) {
      var processingBlots = _ref.processingBlots;
      this.rangeBefore = this.editor.scroll.selection.getRange()[0];
    }
  }, {
    key: "after",
    value: function after() {
      if (this.deleteBlock) {
        this.newRange = this.newRange || {
          index: this.rangeBefore.index - (this.deleteBlock.index + 1),
          length: 0
        };
        try {
          this.editor.scroll.selection.setRange(this.newRange);
        } catch (e) {
          this.editor.scroll.selection.setRange({
            index: 0,
            length: 0
          });
        }
      }
    }
  }, {
    key: "exec",
    value: function exec(_ref2) {
      var processingBlots = _ref2.processingBlots;
      var processed = false;
      var blot = processingBlots[0];
      var blotRange = this.getBlotRange(blot);
      var prevBlot = blot.prev;
      if (!prevBlot && blotRange.index === 1) {
        this.setBlotRange(blot, {
          index: 0,
          length: 0
        });
        blotRange = this.getBlotRange(blot);
      }
      if (blot instanceof textLine && !(blot instanceof blockEmbed)) {
        if (!prevBlot || prevBlot instanceof listItemBullet || prevBlot instanceof listItemNumber || prevBlot instanceof listItemCheckbox) {
          prevBlot = blot.parent.prev;
        }
        if (prevBlot && prevBlot.constructor && (prevBlot instanceof list_list || prevBlot instanceof textLine || prevBlot.constructor.blotName === 'gridCol' || prevBlot.constructor.blotName === 'grid')) {
          blot.remove();
          this.deleteBlock = blotRange;
        } else if (!prevBlot) {
          if (blot.parent.constructor.blotName === 'gridCol') {
            var grid = blot.parent.parent;
            if (grid.prev && (grid.prev instanceof blockEmbed || grid.prev instanceof ImageWrapper)) {
              return;
            } else {
              blot.remove();
              this.deleteBlock = blotRange;
            }
          } else {
            blot.remove();
            this.deleteBlock = blotRange;
          }
        }
        processed = true;
      }
      return processed;
    }
  }]);
  return DeleteBlockAction;
}(Action);

DeleteBlockAction.type = 'deleteBlock';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/undo.js
function undo_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { undo_typeof = function _typeof(obj) { return typeof obj; }; } else { undo_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return undo_typeof(obj); }









function undo_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function undo_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function undo_createClass(Constructor, protoProps, staticProps) { if (protoProps) undo_defineProperties(Constructor.prototype, protoProps); if (staticProps) undo_defineProperties(Constructor, staticProps); return Constructor; }
function undo_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) undo_setPrototypeOf(subClass, superClass); }
function undo_setPrototypeOf(o, p) { undo_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return undo_setPrototypeOf(o, p); }
function undo_createSuper(Derived) { var hasNativeReflectConstruct = undo_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = undo_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = undo_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return undo_possibleConstructorReturn(this, result); }; }
function undo_possibleConstructorReturn(self, call) { if (call && (undo_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return undo_assertThisInitialized(self); }
function undo_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function undo_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function undo_getPrototypeOf(o) { undo_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return undo_getPrototypeOf(o); }
function undo_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UndoAction = /*#__PURE__*/function (_Action) {
  undo_inherits(UndoAction, _Action);
  var _super = undo_createSuper(UndoAction);
  function UndoAction(type, params, editor) {
    var _this;
    undo_classCallCheck(this, UndoAction);
    type = type || UndoAction.type;
    _this = _super.call(this, type, params, editor);
    undo_defineProperty(undo_assertThisInitialized(_this), "rangeBefore", null);
    return _this;
  }
  undo_createClass(UndoAction, [{
    key: "exec",
    value: function exec() {
      if (!this.editor.plugins.undoManager.canUndo()) {
        // все равно отдаем true, чтобы запретить обработку браузером
        return true;
      }
      this.editor.plugins.undoManager.undo();
      return true;
    }
  }]);
  return UndoAction;
}(Action);

UndoAction.type = 'undo';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/redo.js
function redo_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { redo_typeof = function _typeof(obj) { return typeof obj; }; } else { redo_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return redo_typeof(obj); }









function redo_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function redo_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function redo_createClass(Constructor, protoProps, staticProps) { if (protoProps) redo_defineProperties(Constructor.prototype, protoProps); if (staticProps) redo_defineProperties(Constructor, staticProps); return Constructor; }
function redo_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) redo_setPrototypeOf(subClass, superClass); }
function redo_setPrototypeOf(o, p) { redo_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return redo_setPrototypeOf(o, p); }
function redo_createSuper(Derived) { var hasNativeReflectConstruct = redo_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = redo_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = redo_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return redo_possibleConstructorReturn(this, result); }; }
function redo_possibleConstructorReturn(self, call) { if (call && (redo_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return redo_assertThisInitialized(self); }
function redo_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function redo_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function redo_getPrototypeOf(o) { redo_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return redo_getPrototypeOf(o); }
function redo_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RedoAction = /*#__PURE__*/function (_Action) {
  redo_inherits(RedoAction, _Action);
  var _super = redo_createSuper(RedoAction);
  function RedoAction(type, params, editor) {
    var _this;
    redo_classCallCheck(this, RedoAction);
    type = type || RedoAction.type;
    _this = _super.call(this, type, params, editor);
    redo_defineProperty(redo_assertThisInitialized(_this), "rangeBefore", null);
    return _this;
  }
  redo_createClass(RedoAction, [{
    key: "exec",
    value: function exec() {
      if (!this.editor.plugins.undoManager.canRedo()) {
        // все равно отдаем true, чтобы запретить обработку браузером
        return true;
      }
      this.editor.plugins.undoManager.redo();
      return true;
    }
  }]);
  return RedoAction;
}(Action);

RedoAction.type = 'redo';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/selectAll.js
function selectAll_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { selectAll_typeof = function _typeof(obj) { return typeof obj; }; } else { selectAll_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return selectAll_typeof(obj); }














function selectAll_slicedToArray(arr, i) { return selectAll_arrayWithHoles(arr) || selectAll_iterableToArrayLimit(arr, i) || selectAll_unsupportedIterableToArray(arr, i) || selectAll_nonIterableRest(); }
function selectAll_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function selectAll_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return selectAll_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return selectAll_arrayLikeToArray(o, minLen); }
function selectAll_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function selectAll_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function selectAll_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function selectAll_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function selectAll_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function selectAll_createClass(Constructor, protoProps, staticProps) { if (protoProps) selectAll_defineProperties(Constructor.prototype, protoProps); if (staticProps) selectAll_defineProperties(Constructor, staticProps); return Constructor; }
function selectAll_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { selectAll_get = Reflect.get; } else { selectAll_get = function _get(target, property, receiver) { var base = selectAll_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return selectAll_get(target, property, receiver || target); }
function selectAll_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = selectAll_getPrototypeOf(object); if (object === null) break; } return object; }
function selectAll_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) selectAll_setPrototypeOf(subClass, superClass); }
function selectAll_setPrototypeOf(o, p) { selectAll_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return selectAll_setPrototypeOf(o, p); }
function selectAll_createSuper(Derived) { var hasNativeReflectConstruct = selectAll_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = selectAll_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = selectAll_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return selectAll_possibleConstructorReturn(this, result); }; }
function selectAll_possibleConstructorReturn(self, call) { if (call && (selectAll_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return selectAll_assertThisInitialized(self); }
function selectAll_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function selectAll_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function selectAll_getPrototypeOf(o) { selectAll_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return selectAll_getPrototypeOf(o); }



var SelectAllAction = /*#__PURE__*/function (_Action) {
  selectAll_inherits(SelectAllAction, _Action);
  var _super = selectAll_createSuper(SelectAllAction);
  function SelectAllAction(type, params, editor) {
    selectAll_classCallCheck(this, SelectAllAction);
    return _super.call(this, type, params, editor);
  }
  selectAll_createClass(SelectAllAction, [{
    key: "exec",
    value: function exec() {
      var scroll = this.editor.scroll;
      var processedByBlots = selectAll_get(selectAll_getPrototypeOf(SelectAllAction.prototype), "exec", this).call(this, {
        processingBlots: scroll.selectedBlocks
      });
      if (processedByBlots) {
        // таблица сама обработает ctrl + a
        // возможно надо вынести это как свойство таблицы, чтобы selectedAll действие не знало о таблице
        return true;
      }
      var length = scroll.length();
      //это действие должно распространяться только на текстовые блоки
      if (scroll.selectedBlocks.length === 1 && (scroll.selectedBlocks[0] instanceof textLine || scroll.selectedBlocks[0] instanceof primary)) {
        var _scroll$selectedBlock = selectAll_slicedToArray(scroll.selectedBlocks, 1),
          blot = _scroll$selectedBlock[0];
        var blotLength = blot.length() - 1;
        var _scroll$selection$get = scroll.selection.getRange({
            offsetBlot: blot
          }),
          _scroll$selection$get2 = selectAll_slicedToArray(_scroll$selection$get, 1),
          blotRange = _scroll$selection$get2[0];
        //если выделен весь блот то выделяем весь контент в редакторе
        if (blotRange.index === 0 && blotRange.length === blotLength) {
          scroll.selection.setRange({
            index: 0,
            length: length - 1
          });
          return true;
        }
        //иначе выделяем все содержимое блота
        else {
          scroll.selection.setRange({
            index: blot.offset(scroll),
            length: blotLength
          });
          return true;
        }
      }
      scroll.selection.setRange({
        index: 0,
        length: length - 1
      });
      return true;
    }
  }]);
  return SelectAllAction;
}(Action);

SelectAllAction.type = 'select-all';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/typingCleanup.js
function typingCleanup_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { typingCleanup_typeof = function _typeof(obj) { return typeof obj; }; } else { typingCleanup_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return typingCleanup_typeof(obj); }









function typingCleanup_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function typingCleanup_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function typingCleanup_createClass(Constructor, protoProps, staticProps) { if (protoProps) typingCleanup_defineProperties(Constructor.prototype, protoProps); if (staticProps) typingCleanup_defineProperties(Constructor, staticProps); return Constructor; }
function typingCleanup_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) typingCleanup_setPrototypeOf(subClass, superClass); }
function typingCleanup_setPrototypeOf(o, p) { typingCleanup_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return typingCleanup_setPrototypeOf(o, p); }
function typingCleanup_createSuper(Derived) { var hasNativeReflectConstruct = typingCleanup_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = typingCleanup_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = typingCleanup_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return typingCleanup_possibleConstructorReturn(this, result); }; }
function typingCleanup_possibleConstructorReturn(self, call) { if (call && (typingCleanup_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return typingCleanup_assertThisInitialized(self); }
function typingCleanup_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function typingCleanup_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function typingCleanup_getPrototypeOf(o) { typingCleanup_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return typingCleanup_getPrototypeOf(o); }



// данное действие очищает выделение при печати, если выделено несколько символов/блоков
var TypingCleanupAction = /*#__PURE__*/function (_Action) {
  typingCleanup_inherits(TypingCleanupAction, _Action);
  var _super = typingCleanup_createSuper(TypingCleanupAction);
  function TypingCleanupAction(type, params, editor) {
    typingCleanup_classCallCheck(this, TypingCleanupAction);
    type = type || FormatAction.type;
    return _super.call(this, type, params, editor);
  }
  typingCleanup_createClass(TypingCleanupAction, [{
    key: "exec",
    value: function exec(_ref) {
      var processingBlots = _ref.processingBlots;
      var range = this.editor.scroll.selection.getRange()[0];
      if (!range) {
        return false;
      }
      if (range.length > 0) {
        var deleteAction = new DeleteAction(DeleteAction.type, {}, this.editor);
        deleteAction.run({
          processingBlots: processingBlots
        });
      }
      // false возвращается специально чтобы продолжить обработку события в блотах
      return false;
    }
  }]);
  return TypingCleanupAction;
}(Action);

TypingCleanupAction.type = 'typingCleanup';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/formats.js












function formats_slicedToArray(arr, i) { return formats_arrayWithHoles(arr) || formats_iterableToArrayLimit(arr, i) || formats_unsupportedIterableToArray(arr, i) || formats_nonIterableRest(); }
function formats_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function formats_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return formats_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return formats_arrayLikeToArray(o, minLen); }
function formats_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function formats_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function formats_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


function getFormatsBeforeCaret(editor) {
  if (!editor) {
    console.error('#getFormatsBeforeCaret: "editor" is not defined or null');
    return null;
  }
  var scroll = editor.scroll;
  var selection = scroll.selection;
  var _selection$getRange = selection.getRange(),
    _selection$getRange2 = formats_slicedToArray(_selection$getRange, 2),
    range = _selection$getRange2[0],
    native = _selection$getRange2[1];
  if (range) {
    if (range.length > 0) {
      console.error('It is impossible to get formats before caret, because editor has a selection range length ' + range.length);
      return null;
    }
    var textBlotsInRange = scroll.selection.getBlotsInRange(native).map(function (blot) {
      return findWithClass(blot, textBase);
    }).filter(function (blot) {
      return blot !== null;
    }).filter(function (blot, index, array) {
      return array.indexOf(blot) === index;
    });
    if (textBlotsInRange.length === 0 || textBlotsInRange.length > 1) {
      console.error('Selection range located in two or some blocks');
      return null;
    }
    var _textBlotsInRange = formats_slicedToArray(textBlotsInRange, 1),
      blot = _textBlotsInRange[0];
    var _selection$getRange3 = selection.getRange({
        offsetBlot: blot
      }),
      _selection$getRange4 = formats_slicedToArray(_selection$getRange3, 1),
      blotRange = _selection$getRange4[0];
    return blot.getFormat(blotRange.index - 1, 1);
  }
  console.error('Editor is not focused or selection range is not defined');
  return null;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/toggleHighlight.js
function toggleHighlight_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { toggleHighlight_typeof = function _typeof(obj) { return typeof obj; }; } else { toggleHighlight_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return toggleHighlight_typeof(obj); }










function toggleHighlight_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function toggleHighlight_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function toggleHighlight_createClass(Constructor, protoProps, staticProps) { if (protoProps) toggleHighlight_defineProperties(Constructor.prototype, protoProps); if (staticProps) toggleHighlight_defineProperties(Constructor, staticProps); return Constructor; }
function toggleHighlight_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) toggleHighlight_setPrototypeOf(subClass, superClass); }
function toggleHighlight_setPrototypeOf(o, p) { toggleHighlight_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return toggleHighlight_setPrototypeOf(o, p); }
function toggleHighlight_createSuper(Derived) { var hasNativeReflectConstruct = toggleHighlight_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = toggleHighlight_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = toggleHighlight_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return toggleHighlight_possibleConstructorReturn(this, result); }; }
function toggleHighlight_possibleConstructorReturn(self, call) { if (call && (toggleHighlight_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return toggleHighlight_assertThisInitialized(self); }
function toggleHighlight_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function toggleHighlight_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function toggleHighlight_getPrototypeOf(o) { toggleHighlight_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return toggleHighlight_getPrototypeOf(o); }


var ToggleHighlightAction = /*#__PURE__*/function (_Action) {
  toggleHighlight_inherits(ToggleHighlightAction, _Action);
  var _super = toggleHighlight_createSuper(ToggleHighlightAction);
  function ToggleHighlightAction(type, params, editor) {
    toggleHighlight_classCallCheck(this, ToggleHighlightAction);
    type = type || ToggleHighlightAction.type;
    return _super.call(this, type, params, editor);
  }
  toggleHighlight_createClass(ToggleHighlightAction, [{
    key: "exec",
    value: function exec() {
      var range = this.editor.scroll.selection.getRange()[0];
      if (range && range.length === 0) {
        var caretFormats = getFormatsBeforeCaret(this.editor);
        if (caretFormats['background']) {
          this.editor.exec('format', {
            style: 'background',
            value: false
          });
          if (caretFormats['color']) {
            this.editor.exec('format', {
              style: 'color',
              value: false
            });
          }
        } else {
          this.editor.plugins.floatingToolbar.applyHighlight();
        }
      } else {
        var _this$editor$plugins$ = this.editor.plugins.floatingToolbar.getSelectionFormatsDetails(),
          formats = _this$editor$plugins$.formats;
        if (formats && formats['background']) {
          this.editor.plugins.floatingToolbar.clearHighlight();
        } else {
          this.editor.plugins.floatingToolbar.applyHighlight();
        }
      }
      return true;
    }
  }]);
  return ToggleHighlightAction;
}(Action);

ToggleHighlightAction.type = 'toggle-highlight';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/clearSelection.js
function clearSelection_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { clearSelection_typeof = function _typeof(obj) { return typeof obj; }; } else { clearSelection_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return clearSelection_typeof(obj); }












function clearSelection_slicedToArray(arr, i) { return clearSelection_arrayWithHoles(arr) || clearSelection_iterableToArrayLimit(arr, i) || clearSelection_unsupportedIterableToArray(arr, i) || clearSelection_nonIterableRest(); }
function clearSelection_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function clearSelection_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return clearSelection_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return clearSelection_arrayLikeToArray(o, minLen); }
function clearSelection_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function clearSelection_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function clearSelection_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function clearSelection_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function clearSelection_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function clearSelection_createClass(Constructor, protoProps, staticProps) { if (protoProps) clearSelection_defineProperties(Constructor.prototype, protoProps); if (staticProps) clearSelection_defineProperties(Constructor, staticProps); return Constructor; }
function clearSelection_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) clearSelection_setPrototypeOf(subClass, superClass); }
function clearSelection_setPrototypeOf(o, p) { clearSelection_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return clearSelection_setPrototypeOf(o, p); }
function clearSelection_createSuper(Derived) { var hasNativeReflectConstruct = clearSelection_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = clearSelection_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = clearSelection_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return clearSelection_possibleConstructorReturn(this, result); }; }
function clearSelection_possibleConstructorReturn(self, call) { if (call && (clearSelection_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return clearSelection_assertThisInitialized(self); }
function clearSelection_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function clearSelection_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function clearSelection_getPrototypeOf(o) { clearSelection_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return clearSelection_getPrototypeOf(o); }


// данное действие снимает выделение в редакторе и ставит курсор в то место откуда начиналось выделение клавиатурой или мышью
var ClearSelectionAction = /*#__PURE__*/function (_Action) {
  clearSelection_inherits(ClearSelectionAction, _Action);
  var _super = clearSelection_createSuper(ClearSelectionAction);
  function ClearSelectionAction(type, params, editor) {
    clearSelection_classCallCheck(this, ClearSelectionAction);
    type = type || ClearSelectionAction.type;
    return _super.call(this, type, params, editor);
  }
  clearSelection_createClass(ClearSelectionAction, [{
    key: "exec",
    value: function exec(_ref) {
      var processingBlots = _ref.processingBlots;
      var _this$editor$scroll$s = this.editor.scroll.selection.getRange(),
        _this$editor$scroll$s2 = clearSelection_slicedToArray(_this$editor$scroll$s, 2),
        range = _this$editor$scroll$s2[0],
        nativeRange = _this$editor$scroll$s2[1];
      if (range && range.length > 0) {
        if (nativeRange.reversed) {
          this.editor.scroll.selection.setRange({
            index: range.index + range.length,
            length: 0
          });
        } else {
          this.editor.scroll.selection.setRange({
            index: range.index,
            length: 0
          });
        }
        return true;
      } else {
        return false;
      }
    }
  }]);
  return ClearSelectionAction;
}(Action);

ClearSelectionAction.type = 'clearSelection';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/button/buttonSingleComponent.js
function buttonSingleComponent_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { buttonSingleComponent_typeof = function _typeof(obj) { return typeof obj; }; } else { buttonSingleComponent_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return buttonSingleComponent_typeof(obj); }









function buttonSingleComponent_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function buttonSingleComponent_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function buttonSingleComponent_createClass(Constructor, protoProps, staticProps) { if (protoProps) buttonSingleComponent_defineProperties(Constructor.prototype, protoProps); if (staticProps) buttonSingleComponent_defineProperties(Constructor, staticProps); return Constructor; }
function buttonSingleComponent_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) buttonSingleComponent_setPrototypeOf(subClass, superClass); }
function buttonSingleComponent_setPrototypeOf(o, p) { buttonSingleComponent_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return buttonSingleComponent_setPrototypeOf(o, p); }
function buttonSingleComponent_createSuper(Derived) { var hasNativeReflectConstruct = buttonSingleComponent_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = buttonSingleComponent_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = buttonSingleComponent_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return buttonSingleComponent_possibleConstructorReturn(this, result); }; }
function buttonSingleComponent_possibleConstructorReturn(self, call) { if (call && (buttonSingleComponent_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return buttonSingleComponent_assertThisInitialized(self); }
function buttonSingleComponent_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function buttonSingleComponent_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function buttonSingleComponent_getPrototypeOf(o) { buttonSingleComponent_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return buttonSingleComponent_getPrototypeOf(o); }

var ButtonSingleComponent = /*#__PURE__*/function (_Component) {
  buttonSingleComponent_inherits(ButtonSingleComponent, _Component);
  var _super = buttonSingleComponent_createSuper(ButtonSingleComponent);
  function ButtonSingleComponent() {
    buttonSingleComponent_classCallCheck(this, ButtonSingleComponent);
    return _super.apply(this, arguments);
  }
  buttonSingleComponent_createClass(ButtonSingleComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        cssId = _this$props.cssId,
        background = _this$props.background,
        shape = _this$props.shape,
        size = _this$props.size,
        target = _this$props.target,
        url = _this$props.url,
        buttonType = _this$props.buttonType,
        onMouseClick = _this$props.onMouseClick;
      var title = this.props.title;
      if (!title) {
        title = this.props.editor.plugins.i18n.get('floating_toolbar.button');
      }
      return (0,preact_module.h)("nimbus-button", {
        id: cssId,
        className: "single-button",
        "data-background": background,
        "data-shape": shape,
        "data-size": size,
        "data-target": target,
        "data-url": url,
        "data-type": buttonType,
        onClick: onMouseClick
      }, (0,preact_module.h)("span", {
        className: "button-content"
      }, (0,preact_module.h)("b", null, title)));
    }
  }]);
  return ButtonSingleComponent;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/scss/link-form.scss
var link_form = __webpack_require__(29199);
var link_form_default = /*#__PURE__*/__webpack_require__.n(link_form);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/popupManager/buttonForm.js
function buttonForm_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { buttonForm_typeof = function _typeof(obj) { return typeof obj; }; } else { buttonForm_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return buttonForm_typeof(obj); }
function buttonForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function buttonForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { buttonForm_ownKeys(Object(source), true).forEach(function (key) { buttonForm_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { buttonForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function buttonForm_toConsumableArray(arr) { return buttonForm_arrayWithoutHoles(arr) || buttonForm_iterableToArray(arr) || buttonForm_unsupportedIterableToArray(arr) || buttonForm_nonIterableSpread(); }
function buttonForm_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function buttonForm_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return buttonForm_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return buttonForm_arrayLikeToArray(o, minLen); }
function buttonForm_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function buttonForm_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return buttonForm_arrayLikeToArray(arr); }
function buttonForm_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function buttonForm_extends() { buttonForm_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return buttonForm_extends.apply(this, arguments); }


























function buttonForm_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function buttonForm_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function buttonForm_createClass(Constructor, protoProps, staticProps) { if (protoProps) buttonForm_defineProperties(Constructor.prototype, protoProps); if (staticProps) buttonForm_defineProperties(Constructor, staticProps); return Constructor; }
function buttonForm_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) buttonForm_setPrototypeOf(subClass, superClass); }
function buttonForm_setPrototypeOf(o, p) { buttonForm_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return buttonForm_setPrototypeOf(o, p); }
function buttonForm_createSuper(Derived) { var hasNativeReflectConstruct = buttonForm_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = buttonForm_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = buttonForm_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return buttonForm_possibleConstructorReturn(this, result); }; }
function buttonForm_possibleConstructorReturn(self, call) { if (call && (buttonForm_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return buttonForm_assertThisInitialized(self); }
function buttonForm_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function buttonForm_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function buttonForm_getPrototypeOf(o) { buttonForm_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return buttonForm_getPrototypeOf(o); }
function buttonForm_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var buttonForm_isEscKey = (0,lib/* default */.ZP)('esc');
var linkFormAppearDuration = (link_form_default()).linkFormAppearDuration;




var ButtonFormComponent = /*#__PURE__*/function (_Component) {
  buttonForm_inherits(ButtonFormComponent, _Component);
  var _super = buttonForm_createSuper(ButtonFormComponent);
  function ButtonFormComponent(props) {
    var _this;
    buttonForm_classCallCheck(this, ButtonFormComponent);
    _this = _super.call(this, props);
    buttonForm_defineProperty(buttonForm_assertThisInitialized(_this), "onButtonFormRef", function (node) {
      _this.buttonFormNode = node;
    });
    buttonForm_defineProperty(buttonForm_assertThisInitialized(_this), "onDisplayInputRef", function (node) {
      _this.titleInputNode = node;
    });
    buttonForm_defineProperty(buttonForm_assertThisInitialized(_this), "onAdressInputRef", function (node) {
      _this.urlInputNode = node;
    });
    buttonForm_defineProperty(buttonForm_assertThisInitialized(_this), "onClickOpen", function (event) {
      event.stopPropagation();
      _this.props.openLink(_this.props.url);
    });
    buttonForm_defineProperty(buttonForm_assertThisInitialized(_this), "onClickCopy", function () {
      _this.props.copyLinkUrl(_this.clearUrl(_this.state.url));
    });
    buttonForm_defineProperty(buttonForm_assertThisInitialized(_this), "onClickEdit", function (event) {
      event.stopPropagation();
      _this.props.showEditForm();
    });
    buttonForm_defineProperty(buttonForm_assertThisInitialized(_this), "onClickDelete", function () {
      _this.props.deleteButton(true);
    });
    buttonForm_defineProperty(buttonForm_assertThisInitialized(_this), "onInputKeydown", function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        event.stopPropagation();
        _this.onDoneClick();
      }
    });
    buttonForm_defineProperty(buttonForm_assertThisInitialized(_this), "onAdressInput", function (event) {
      _this.setState(function (prevState) {
        var url = event.target.value;
        _this.props.setUrl(url);
        var newState = {
          url: url
        };
        if (url.trim() !== '' && prevState.error_url) {
          newState.error_url = false;
        }
        return newState;
      });
    });
    buttonForm_defineProperty(buttonForm_assertThisInitialized(_this), "onTitleInput", function (event) {
      var value = event.target.value;
      _this.setState(function (prevState) {
        var newState = null;
        if (value.length <= ButtonFormComponent.maxTitleSize) {
          if (value.trim()) {
            _this.props.setTitle(value);
          }
          newState = {
            title: value
          };
        }
        if (value.trim() !== '' && prevState.error_title) {
          newState = {
            error_title: false
          };
        }
        return newState;
      }, function () {
        // для того чтобы сделать инпут управляемым как в react
        // иначе не действует ограничение на ввод
        event.target.value = _this.state.title;
      });
    });
    buttonForm_defineProperty(buttonForm_assertThisInitialized(_this), "onTargetChange", function (event) {
      var target = event.target.checked ? '_blank' : '_self';
      _this.props.setTarget(target);
      _this.setState(function () {
        return {
          target: target
        };
      });
    });
    buttonForm_defineProperty(buttonForm_assertThisInitialized(_this), "onShapeClick", function (shape) {
      return function () {
        _this.props.setShape(shape);
        _this.setState(function () {
          return {
            shape: shape
          };
        });
      };
    });
    buttonForm_defineProperty(buttonForm_assertThisInitialized(_this), "onBackgroundClick", function (background) {
      return function () {
        _this.props.setBackground(background);
        _this.setState(function () {
          return {
            background: background
          };
        });
      };
    });
    buttonForm_defineProperty(buttonForm_assertThisInitialized(_this), "onSizeClick", function (size) {
      return function () {
        _this.props.setSize(size);
        _this.setState(function () {
          return {
            size: size
          };
        });
      };
    });
    buttonForm_defineProperty(buttonForm_assertThisInitialized(_this), "onTypeChange", function (buttonType) {
      return function () {
        _this.props.setType(buttonType);
        _this.setState({
          buttonType: buttonType
        });
      };
    });
    buttonForm_defineProperty(buttonForm_assertThisInitialized(_this), "drawShapes", function () {
      var shapes = ['rounded', 'square'];
      var shape = _this.state.shape;
      return (0,preact_module.h)("div", {
        className: "button-form-shapes"
      }, shapes.map(function (item) {
        var className = ['button-form-button'];
        className.push(item);
        if (item === shape) {
          className.push('selected');
        }
        return (0,preact_module.h)("a", {
          className: className.join(' '),
          onClick: _this.onShapeClick(item)
        }, (0,preact_module.h)("span", null, (0,preact_module.h)("b", null, "a")));
      }));
    });
    buttonForm_defineProperty(buttonForm_assertThisInitialized(_this), "drawBackgroundColor", function () {
      var colors = ['bondi-blue', 'bleu-de-france', 'neon-carrot', 'sunglow', 'carmine-pink', 'dollar-bill', 'light-pastel-purple'];
      var background = _this.state.background;
      return (0,preact_module.h)("div", {
        className: "button-form-colors"
      }, colors.map(function (color) {
        var className = ['color-menu-item'];
        if (color === background) {
          className.push('selected');
        }
        return (0,preact_module.h)("div", {
          className: className.join(' '),
          "data-color": color,
          onClick: _this.onBackgroundClick(color)
        }, (0,preact_module.h)("div", {
          className: "color-icon",
          style: {
            backgroundColor: "var(--".concat(color, ")")
          }
        }));
      }));
    });
    buttonForm_defineProperty(buttonForm_assertThisInitialized(_this), "drawSizes", function () {
      var i18n = _this.props.editor.plugins.i18n;
      var sizes = [{
        title: i18n.get('button.small'),
        code: 'small'
      }, {
        title: i18n.get('button.medium'),
        code: 'medium'
      }, {
        title: i18n.get('button.big'),
        code: 'big'
      }];
      var size = _this.state.size;
      return (0,preact_module.h)("div", {
        className: "button-form-sizes"
      }, sizes.map(function (_ref) {
        var title = _ref.title,
          code = _ref.code;
        var className = ['button-form-button', 'rounded'];
        if (code === size) {
          className.push('selected');
        }
        return (0,preact_module.h)("a", {
          className: className.join(' '),
          onClick: _this.onSizeClick(code)
        }, (0,preact_module.h)("span", null, (0,preact_module.h)("b", null, title)));
      }));
    });
    buttonForm_defineProperty(buttonForm_assertThisInitialized(_this), "drawTypes", function () {
      var i18n = _this.props.editor.plugins.i18n;
      var types = [{
        title: i18n.get('button.3d'),
        code: '3d'
      }, {
        title: i18n.get('button.withShadow'),
        code: 'shadow'
      }, {
        title: i18n.get('button.default'),
        code: 'default'
      }];
      var _this$state = _this.state,
        buttonType = _this$state.buttonType,
        id = _this$state.id;
      return (0,preact_module.h)("div", {
        className: "button-form-types"
      }, types.map(function (_ref2) {
        var title = _ref2.title,
          code = _ref2.code;
        return (0,preact_module.h)("div", {
          className: "button-form-type-item"
        }, (0,preact_module.h)("label", {
          className: "button-form-radio"
        }, (0,preact_module.h)("input", {
          type: "radio",
          name: 'buttonType' + id,
          value: code,
          checked: code === buttonType,
          onChange: _this.onTypeChange(code)
        }), (0,preact_module.h)("b", null), (0,preact_module.h)("span", null, title)));
      }));
    });
    buttonForm_defineProperty(buttonForm_assertThisInitialized(_this), "cancel", function (cb) {
      _this.setState(function () {
        return _this.firstState;
      }, function () {
        _this.props.setTitle(_this.state.title);
        _this.props.setUrl(_this.state.url);
        _this.props.setTarget(_this.state.target);
        _this.props.setShape(_this.state.shape);
        _this.props.setBackground(_this.state.background);
        _this.props.setSize(_this.state.size);
        _this.props.setType(_this.state.buttonType);
        cb && cb();
      });
    });
    buttonForm_defineProperty(buttonForm_assertThisInitialized(_this), "onCancelClick", function () {
      if (!_this.newButton) {
        _this.cancel();
      }
      _this.props.onCancelClick(true);
    });
    buttonForm_defineProperty(buttonForm_assertThisInitialized(_this), "onDoneClick", function () {
      var err = 0;
      _this.setState(function (prevState) {
        var newState = null;
        var validate = ['title', 'url'];
        var errors = {};
        var fields = [];
        validate.forEach(function (field) {
          if (prevState[field].trim() === '') {
            errors['error_' + field] = true;
            fields.push(field);
            err = 1;
          }
        });
        if (err) {
          newState = errors;
          _this[fields[0] + 'InputNode'].focus();
        } else {
          _this.props.onDoneClick();
        }
        return newState;
      });
    });
    _this.state = {
      title: _this.props.title || '',
      url: _this.props.url || '',
      isEmail: validateEmail(_this.clearUrl(_this.props.url || '')),
      target: _this.props.target || '_blank',
      shape: _this.props.shape || 'rounded',
      background: _this.props.background || 'bondi-blue',
      size: _this.props.size || 'small',
      buttonType: _this.props.buttonType || '3d',
      id: _this.props.id || generateButtonId(),
      error_url: false,
      error_title: false
    };
    return _this;
  }
  buttonForm_createClass(ButtonFormComponent, [{
    key: "clearUrl",
    value:
    /**
     * Удаляет mailto: переда адресом
     * @param url
     * @returns {*}
     */
    function clearUrl(url) {
      return url.match(/^mailto:/) ? url.slice('mailto:'.length) : url;
    }
  }, {
    key: "parentTable",
    get: function get() {
      var textBlot = this.props.textBlot;
      if (textBlot && textBlot.getBlotName && textBlot.getBlotName() === 'tableLink') {
        return textBlot.parentTable;
      } else {
        return false;
      }
    }
  }, {
    key: "isBlotLocked",
    get: function get() {
      return !!(this.parentTable && this.parentTable.isBlotLocked);
    }
  }, {
    key: "getPanelItems",
    value: function getPanelItems() {
      var items = {
        link: {
          fn: this.onClickOpen,
          url: this.props.url,
          tooltip: this.props.url
        },
        buttons: [{
          id: 'open',
          fn: this.onClickOpen,
          title: this.props.getIntlText(this.state.isEmail ? 'link.send' : 'link.open')
        }, {
          id: 'copy',
          fn: this.onClickCopy,
          title: this.props.getIntlText('link.copy')
        }]
      };
      var hideEditButtons = false;
      if (this.isBlotLocked) {
        hideEditButtons = true;
      }
      if (this.props.editor.mode === this.props.editor.constructor.MODE_EDIT && (!this.props.button || !this.props.button.disableEditing) && !hideEditButtons) {
        items.buttons.push({
          id: 'edit',
          fn: this.onClickEdit,
          title: this.props.getIntlText('link.edit')
        });
        items.buttons.push({
          id: 'remove',
          fn: this.onClickDelete,
          title: this.props.getIntlText('link.remove')
        });
      }
      return items;
    }
  }, {
    key: "getFormItems",
    value: function getFormItems() {
      return [];
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.formComponentRef(this);
      this.props.adjustPositionContinuously(false, this.props.form ? 'edit' : 'click');
      var formVisible = this.props.form;
      if (formVisible) {
        if (this.state.title === '' || this.props.focusField === 'title') {
          if (this.state.title !== '') {
            this.titleInputNode.select();
          } else {
            this.titleInputNode.focus();
          }
        } else if (this.state.url === '') {
          this.urlInputNode.focus();
        } else {
          this.urlInputNode.focus();
        }
      }
      this.firstState = JSON.parse(JSON.stringify(this.state));
      if (!this.props.button) {
        this.newButton = true;
        this.props.changeButton(this.state, false);
        this.props.setButton(this.state.id);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.formComponentRef(null);
    }
  }, {
    key: "render",
    value: function render() {
      var formVisible = this.props.form;
      var items = formVisible ? this.getFormItems() : this.getPanelItems();
      var form = null;
      var i18n = this.props.editor.plugins.i18n;
      var target = this.state.target;
      if (formVisible) {
        // показываем размеры в зависимости от параметра showSizes
        var sizes = this.props.showSizes ? (0,preact_module.h)("div", {
          className: "button-form-item sizes"
        }, (0,preact_module.h)("div", {
          className: "button-form-title"
        }, i18n.get('button.size')), this.drawSizes()) : null;
        var titleCls = ['button-form-input'];
        if (this.state.error_title) titleCls.push('button-form-input-error');
        var urlCls = ['button-form-input'];
        if (this.state.error_url) urlCls.push('button-form-input-error');
        form = (0,preact_module.h)(popupMenu/* default */.Z, {
          wantsToClose: this.props.hideForm(true),
          closeOnEsc: true,
          addClassName: "link-edit no-scroll button-edit",
          key: "link-form-edit",
          domRef: this.onButtonFormRef
        }, (0,preact_module.h)("div", {
          className: "button-form-item title"
        }, (0,preact_module.h)("label", {
          className: "button-form-title",
          htmlFor: "button-form-title"
        }, i18n.get('button.title')), (0,preact_module.h)("input", {
          id: "button-form-title",
          className: titleCls.join(' '),
          type: "text",
          placeholder: i18n.get('floating_toolbar.button'),
          ref: this.onDisplayInputRef,
          onKeyDown: this.onInputKeydown,
          onInput: this.onTitleInput,
          value: this.state.title
        }), (0,preact_module.h)("div", {
          class: "button-form-note"
        }, "ID:\xA0", (0,preact_module.h)("span", {
          className: "button-form-id"
        }, "#", this.state.id), (0,preact_module.h)("span", {
          className: "button-form-question-icon",
          "data-editor-toolip": i18n.get('button.id_info_tooltip'),
          "data-editor-toolip-small": ""
        }, (0,preact_module.h)(icons/* IconQuestion */.BS3, null)))), (0,preact_module.h)("div", {
          className: "button-form-item"
        }, (0,preact_module.h)("label", {
          className: "button-form-title",
          htmlFor: "button-form-address"
        }, i18n.get('button.address')), (0,preact_module.h)("input", {
          id: "button-form-address",
          className: urlCls.join(' '),
          type: "url",
          placeholder: "http://example.com",
          autoCapitalize: 'off',
          ref: this.onAdressInputRef,
          onKeyDown: this.onInputKeydown,
          onInput: this.onAdressInput,
          value: this.state.url
        }), (0,preact_module.h)("div", null, (0,preact_module.h)("label", {
          className: "button-form-checkbox button-form-target"
        }, (0,preact_module.h)("input", {
          type: "checkbox",
          onChange: this.onTargetChange,
          checked: target === '_blank'
        }), (0,preact_module.h)("b", null), (0,preact_module.h)("span", null, i18n.get('button.open_in_new_tab'))))), (0,preact_module.h)("div", {
          className: "button-form-item shapes"
        }, (0,preact_module.h)("div", {
          className: "button-form-title"
        }, i18n.get('button.shape')), this.drawShapes()), (0,preact_module.h)("div", {
          className: "button-form-item colors"
        }, (0,preact_module.h)("div", {
          className: "button-form-title"
        }, i18n.get('button.background')), this.drawBackgroundColor()), sizes, (0,preact_module.h)("div", {
          className: "button-form-item types"
        }, (0,preact_module.h)("div", {
          className: "button-form-title"
        }, i18n.get('button.type')), this.drawTypes()), (0,preact_module.h)("div", {
          className: "button-form-item actions"
        }, (0,preact_module.h)("div", {
          className: "button-form-actions"
        }, (0,preact_module.h)("a", {
          className: "button-form-button rounded button-cancel",
          onClick: this.onCancelClick
        }, (0,preact_module.h)("span", null, (0,preact_module.h)("b", null, i18n.get('button.cancel')))), (0,preact_module.h)("a", {
          className: "button-form-button rounded button-done",
          onClick: this.onDoneClick
        }, (0,preact_module.h)("span", null, (0,preact_module.h)("b", null, i18n.get('button.done')))))));
      } else {
        var _linkAttrs;
        var linkAttrs = (_linkAttrs = {}, buttonForm_defineProperty(_linkAttrs, tooltipManager/* TOOLTIP_ATTR */.qZ, items.link.tooltip), buttonForm_defineProperty(_linkAttrs, tooltipManager/* TOOLTIP_ADD_CLASS */.Bg, 'link-tooltip'), _linkAttrs);
        form = (0,preact_module.h)(popupMenu/* default */.Z, {
          wantsToClose: this.props.hideForm(false),
          closeOnEsc: true,
          addClassName: "link-panel no-scroll button-panel",
          key: "link-form-panel",
          domRef: this.onButtonFormRef
        }, (0,preact_module.h)("div", buttonForm_extends({}, linkAttrs, {
          className: "link-panel-item link-panel-item-link",
          key: "link",
          onClick: items.link.fn
        }), (0,preact_module.h)("a", {
          href: items.link.url,
          className: "link-text",
          onClick: function onClick(e) {
            e.preventDefault();
          }
        }, items.link.url)), (0,preact_module.h)("div", {
          className: "link-panel-buttons"
        }, items.buttons.map(function (_ref3) {
          var id = _ref3.id,
            title = _ref3.title,
            fn = _ref3.fn;
          var buttonAttrs = {
            'data-button-key': id
          };
          return (0,preact_module.h)("div", buttonForm_extends({
            className: 'link-panel-item',
            key: id,
            onClick: fn
          }, buttonAttrs), title);
        })));
      }
      return (0,preact_module.h)("div", {
        className: "link-form"
      }, (0,preact_module.h)(preact_transition_group/* default */.Z, {
        transitionName: "link-menu",
        transitionEnterTimeout: linkFormAppearDuration,
        transitionLeaveTimeout: linkFormAppearDuration
      }, form));
    }
  }]);
  return ButtonFormComponent;
}(preact_module/* Component */.wA);
buttonForm_defineProperty(ButtonFormComponent, "maxTitleSize", 50);
var ButtonForm = /*#__PURE__*/function () {
  function ButtonForm(_ref4) {
    var _this2 = this;
    var editor = _ref4.editor,
      scroll = _ref4.scroll,
      button = _ref4.button,
      params = _ref4.params;
    buttonForm_classCallCheck(this, ButtonForm);
    buttonForm_defineProperty(this, "formComponentRef", function (component) {
      _this2.formComponent = component;
    });
    buttonForm_defineProperty(this, "onEditorTextChange", function () {
      _this2.hide();
    });
    buttonForm_defineProperty(this, "getNbspBeforeAfter", function (blot) {
      var range = _this2.params.blotRange ? _this2.params.blotRange : _this2.params.range || null;
      if (!range) return {
        left: '',
        right: ''
      };
      var left = blot ? blot.getText(range.index - 1, 1) : '';
      var right = blot ? blot.getText(range.index + range.length, 1) : '';
      return {
        left: left === " " || left === "" || left === "\n" ? '' : " ",
        right: right === " " || right === "" || right === "\n" ? '' : " "
      };
    });
    buttonForm_defineProperty(this, "changeButton", function (formats) {
      var needHideCall = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (_this2.params.singleBlock) {
        _this2.textBlot.changeButton(formats);
      } else {
        if (_this2.button) {
          _this2.button.changeButton(formats);
        } else {
          var blot = _this2.editor.findById(_this2.params.id);
          if (!blot && _this2.params.execBlots && _this2.params.execBlots.length) {
            blot = _this2.params.execBlots[0];
          }
          var nbsp = _this2.getNbspBeforeAfter(blot);
          var range = _this2.params.blotRange ? _this2.params.blotRange : _this2.params.range || null;
          var insert = [].concat(buttonForm_toConsumableArray(nbsp.left !== '' ? [{
            insert: ' '
          }] : []), [{
            insert: {
              button: JSON.stringify(formats)
            }
          }], buttonForm_toConsumableArray(nbsp.right !== '' ? [{
            insert: ' '
          }] : []));
          var ops = [{
            retain: range && range.index ? range.index : 0
          }, {
            delete: range && range.length ? range.length : 0
          }];

          // применяем дельту поочередно иначе если у выделенного текста было форматирование,
          // то текст после кнопки применяет это форматирование
          blot.applyForCharacters([ops[0], ops[1]]);
          blot.applyForCharacters([ops[0]].concat(buttonForm_toConsumableArray(insert)));
          _this2.editor.emitter.emit('add-button', {
            formats: formats
          });
        }
      }
      if (needHideCall) {
        _this2.hide();
      }
    });
    buttonForm_defineProperty(this, "openLink", function (url) {
      var target = _this2.formComponent.state.target;
      if (!_this2.editor.plugins.linkManager.processNavigation(url)) {
        window.open(url, target, 'noopener');
      }
      _this2.hide();
    });
    buttonForm_defineProperty(this, "copyLinkUrl", function (url) {
      _this2.editor.plugins.copyManager.copy(url);
      _this2.hide();
    });
    buttonForm_defineProperty(this, "showEditForm", function () {
      _this2.editor.off('delta', _this2.onEditorTextChange);
      _this2.render(_this2.container);
      _this2.adjustPositionContinuously(true);
      setTimeout(function () {
        _this2.show();
      }, linkFormAppearDuration);
    });
    buttonForm_defineProperty(this, "deleteButton", function () {
      var needHideCall = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (_this2.deleted) return false;
      _this2.deleted = true;
      _this2.editor.off('delta', _this2.onEditorTextChange);
      if (!_this2.params.singleBlock) {
        if (_this2.button) {
          if (_this2.textBlot.onEmpty) {
            _this2.textBlot.onEmpty();
          } else {
            var parent = normalizeToStoredBlot(_this2.button);
            var retain = _this2.button.offset(parent);
            var title = _this2.button.domNode.getAttribute('data-title');
            var insert = {
              insert: title
            };
            if (_this2.params.formats) {
              insert = buttonForm_objectSpread(buttonForm_objectSpread({}, insert), {}, {
                attributes: _this2.params.formats
              });
            }
            parent.map.get('characters').applyDelta([{
              retain: retain
            }, {
              delete: 1
            }, insert]);
          }
        }
      } else {
        _this2.button.deleteButton();
      }
      if (needHideCall) {
        _this2.hide();
      }
    });
    buttonForm_defineProperty(this, "setTitle", function (title) {
      _this2.button && _this2.button.setTitle(title);
    });
    buttonForm_defineProperty(this, "setUrl", function (url) {
      _this2.button && _this2.button.setUrl(url);
    });
    buttonForm_defineProperty(this, "setTarget", function (target) {
      _this2.button && _this2.button.setTarget(target);
    });
    buttonForm_defineProperty(this, "setShape", function (shape) {
      _this2.button && _this2.button.setShape(shape);
    });
    buttonForm_defineProperty(this, "setBackground", function (background) {
      _this2.button && _this2.button.setBackground(background);
    });
    buttonForm_defineProperty(this, "setSize", function (size) {
      _this2.button && _this2.button.setSize(size);
    });
    buttonForm_defineProperty(this, "setType", function (buttonType) {
      _this2.button && _this2.button.setType(buttonType);
    });
    buttonForm_defineProperty(this, "onDoneClick", function () {
      _this2.hide();
    });
    buttonForm_defineProperty(this, "onCancelClick", function () {
      var cancel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      _this2.hide(true, cancel);
    });
    buttonForm_defineProperty(this, "setButton", function (id) {
      if (!_this2.params.singleBlock) {
        _this2.button = _this2.editor.findById(id);
        // устанавливаеи self-controlled-content для новой кнопки для того чтобы не записывать изменения в undoManager
        // и в случае отмены можно было отменить создание кнопки, иначе при изменении заголовка не получится корректно
        // сделать отмену
        _this2.button.setSelfControlled();
        _this2.newButton = true;
      }
    });
    buttonForm_defineProperty(this, "getIntlText", function (key) {
      var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _this2.editor.plugins.i18n.get(key, opt);
    });
    buttonForm_defineProperty(this, "adjustPositionContinuously", function () {
      var clear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var formType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'edit';
      if (clear) {
        if (_this2.popper) {
          _this2.popper.destroy();
        }
      } else {
        var popperOptions = {
          placement: 'right-start',
          offset: '0px, 10px',
          preservePosition: false,
          positionFixed: true,
          priority: ['right', 'bottom', 'left', 'top'],
          removeOnDestroy: false
        };
        if (formType === 'click') {
          popperOptions.placement = 'top-start';
        }
        if (!_this2.button) {
          _this2.popper = (0,popup/* createPopper */.f)({
            getBoundingClientRect: function getBoundingClientRect() {
              // return button rect if the button is available, during the first render it is not available
              if (_this2.button) {
                return _this2.button.domNode.getBoundingClientRect();
              }
              // return selection range position for the first render
              var rect = {
                width: _this2.rangeParams.width,
                height: _this2.rangeParams.height,
                top: _this2.rangeParams.offsetYOrig,
                left: _this2.rangeParams.offsetXOrig,
                right: _this2.rangeParams.offsetXOrig + _this2.rangeParams.width,
                bottom: _this2.rangeParams.offsetYOrig + _this2.rangeParams.height
              };
              return rect;
            },
            clientWidth: _this2.rangeParams.width || 1,
            clientHeight: _this2.rangeParams.height
          }, _this2.container, popperOptions);
        } else {
          _this2.popper = (0,popup/* createPopper */.f)(_this2.button.domNode, _this2.container, popperOptions);
        }
      }
    });
    buttonForm_defineProperty(this, "hideForm", function () {
      var cancel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return function (event) {
        var isEsc = false;
        if (typeof event !== 'undefined' && buttonForm_isEscKey(event) || cancel) isEsc = true;
        _this2.hide(isEsc);
      };
    });
    buttonForm_defineProperty(this, "cancelNewButton", function (isEsc) {
      if (isEsc) {
        var undoManager = _this2.editor.plugins.undoManager;
        // если был cancel, esc или скрыли форму кликом за пределы формы
        // делаем undo
        if (undoManager.canUndo()) {
          undoManager.undo();
        } else {
          _this2.deleteButton();
        }
      }
    });
    buttonForm_defineProperty(this, "afterHide", function () {});
    this.editor = editor;
    this.scroll = scroll;
    this.params = params || null;
    this.button = button || null;
    this.textBlot = this.params && this.params.id && this.editor.findById(this.params.id) || this.button && normalizeToStoredBlot(this.button) || this.params.execBlots && this.params.execBlots[0];
    this.direction = null;
    this.scrollingContainer = this.editor.getScrollingContainer();
  }
  buttonForm_createClass(ButtonForm, [{
    key: "render",
    value: function render(container) {
      var withMenu = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      props = Object.assign({}, props);
      var ActiveComponent = ButtonFormComponent;
      if (props.form) {
        var blotsOptions = this.editor.options.blots;
        var buttonBlotOptions = blotsOptions && blotsOptions.button;
        if (buttonBlotOptions && buttonBlotOptions.buttonFormComponent) {
          // позволяем пользователю редактора задать свой компонент для формы ссылки
          ActiveComponent = buttonBlotOptions.buttonFormComponent;
          props.ButtonFormComponent = ButtonFormComponent;
        }
      }
      (0,preact_module/* render */.sY)((0,preact_module.h)(preact_transition_group/* default */.Z, {
        transitionName: "link-form",
        transitionEnterTimeout: linkFormAppearDuration,
        transitionLeaveTimeout: linkFormAppearDuration
      }, withMenu ? (0,preact_module.h)(ActiveComponent, buttonForm_extends({
        changeButton: this.changeButton,
        openLink: this.openLink,
        copyLinkUrl: this.copyLinkUrl,
        showEditForm: this.showEditForm,
        deleteButton: this.deleteButton,
        key: "button-form",
        hideForm: this.hideForm,
        getIntlText: this.getIntlText,
        adjustPositionContinuously: this.adjustPositionContinuously,
        editor: this.editor,
        button: this.button,
        formComponentRef: this.formComponentRef,
        textBlot: this.textBlot,
        onDoneClick: this.onDoneClick,
        onCancelClick: this.onCancelClick,
        setUrl: this.setUrl,
        setTitle: this.setTitle,
        setShape: this.setShape,
        setBackground: this.setBackground,
        setSize: this.setSize,
        setType: this.setType,
        setTarget: this.setTarget,
        setButton: this.setButton
      }, props)) : null), container);
    }

    /**
     *
     * @param {boolean} clear whether to clear the form
     * @param {'click' or 'edit'} formType click or edit
     */
  }, {
    key: "normalizePosition",
    value: function normalizePosition(x, y) {
      //тут рассмотрены не все возможные варианты расположения редактора на странице, в дальнейшем возможно нужны доработки
      var top = y,
        left = x;
      var rect = this.container.getBoundingClientRect();
      var buttonRect = this.button && this.button.domNode.getBoundingClientRect() || {
        width: 0,
        height: 0,
        x: 0,
        y: 0
      };
      var offsetBetweenEditorAndScroll = this.scrollingContainer !== this.editor.scrollingContainer && getContainerOffset(this.editor.scrollingContainer, this.scrollingContainer) || false;
      var scrollingContainerRect = this.scrollingContainer.getBoundingClientRect();
      var formOffset = this.formComponent.buttonFormNode.getBoundingClientRect();

      // корректируем учитывая оффсеты между редактором и скроллинг контейнером если есть кастомный, так как позиционирование идет в контейнере редактора
      if (offsetBetweenEditorAndScroll) {
        top -= offsetBetweenEditorAndScroll.y;
        left -= offsetBetweenEditorAndScroll.x;
      }
      // корректируем left если часть редактора справа перекрывается окном (сдвигаем левее)
      if (document.body.offsetWidth < scrollingContainerRect.x + scrollingContainerRect.width) {
        left -= scrollingContainerRect.x + scrollingContainerRect.width - document.body.offsetWidth;
      }

      // нужна переменная которая запомнит, что позиция left была откорректирована
      // корректируем left если часть панели справа перекрывается скроллинг контейнером (сдвигаем левее)
      var offset = 15;
      if (scrollingContainerRect.x + left + rect.width > scrollingContainerRect.x + scrollingContainerRect.width - offset && !this.correctLeft) {
        this.correctLeft = scrollingContainerRect.x + left + rect.width - (scrollingContainerRect.x + scrollingContainerRect.width - offset) + this.editor.scrollbarWidth;
      }
      if (this.correctLeft) {
        left -= this.correctLeft;
      }

      // Если форма выходит за нижную границу экрана, то поднимаем её выше
      var dy = 0;
      if (y + formOffset.height > scrollingContainerRect.height + this.scrollingContainer.scrollTop) {
        dy = y + formOffset.height - scrollingContainerRect.height - this.scrollingContainer.scrollTop + buttonRect.height;
        top -= dy;
      }
      var isFormHideButton = formOffset.y + formOffset.height > buttonRect.y + buttonRect.height && formOffset.y - buttonRect.height < buttonRect.y;
      // Если форма закрывает кнопку
      // в условии участвует dy - такак коррекция нужна только в том случае если под формой не достаточно пространства
      if (isFormHideButton && this.formComponent.props.form && dy) {
        if (x + buttonRect.width + formOffset.width + 40 < scrollingContainerRect.width) {
          // позиционирование формы справа
          left = x + buttonRect.width + 3;
        } else {
          // позиционирование формы слева
          left = buttonRect.x - scrollingContainerRect.x - formOffset.width - 3;
        }
      }

      // предотвращаем выход формы за экран слева
      if (left < 0) {
        left = x;
      }

      // предотвращаем выход формы за экран справа
      if (left + formOffset.width > scrollingContainerRect.width) {
        left = scrollingContainerRect.x + scrollingContainerRect.width - formOffset.width - 40;
      }
      if (top < 20) {
        top = 20;
      }
      return {
        top: top,
        left: left
      };
    }
  }, {
    key: "show",
    value: function show() {
      var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (!form) {
        this.editor.on('delta', this.onEditorTextChange);
      }
      var props = {};
      if (this.params.singleBlock) {
        if (this.button) {
          props = this.button.getButtonProps();
          props.id = props.cssId;
          this.button.setEditForm(this);
        }
      } else {
        if (!this.button) {
          props.title = this.params.title || '';
          props.url = this.params.formats && this.params.formats.link || '';

          //после того как функцию #setRangedPosition засунули в requestAnimationFrame все поломалось, range берется из window.getSelection(),
          //соответственно, когда фокус падает на сам попап, координаты range изменяются и это происходит постоянно если скролить редактор,
          //поэтому берем координаты при первом вызове (т.е. которые берутся, когда выделен текст в textBlot) и запоминаем их в переменную,
          //чтобы при обновлении использовать их же
          if (!this.rangeParams) {
            var blotRect = this.textBlot.domNode.getBoundingClientRect();
            var selection = window.getSelection();
            if (!selection.rangeCount) {
              return;
            }
            var range = selection.getRangeAt(0);
            var rangeRects = Array.from(range.getClientRects());
            var rangeRect = rangeRects.length === 0 ? blotRect : rangeRects.shift();
            while (blotRect.y > rangeRect.y && rangeRects.length !== 0) {
              rangeRect = rangeRects.shift();
            }
            this.rangeParams = {
              offsetX: rangeRect.x - blotRect.x,
              offsetY: rangeRect.y - blotRect.y,
              offsetXOrig: rangeRect.x,
              offsetYOrig: rangeRect.y,
              height: rangeRect.height,
              width: rangeRect.width
            };
          }
        } else {
          props.title = this.button.domNode.getAttribute('data-title');
          props.url = this.button.domNode.getAttribute('data-url');
          props.target = this.button.domNode.getAttribute('data-target');
          props.shape = this.button.domNode.getAttribute('data-shape');
          props.background = this.button.domNode.getAttribute('data-background');
          props.size = this.button.domNode.getAttribute('data-size');
          props.buttonType = this.button.domNode.getAttribute('data-type');
          props.id = this.button.domNode.getAttribute('id');
        }
      }
      props.form = form;
      props.focusField = this.params.focusField;
      if (!this.container) {
        this.container = document.createElement('div');
        this.container.classList.add('link-form-container');
        this.editor.scrollingContainer.appendChild(this.container);
        this.render(this.container);
      }
      var container = this.container;
      container.removeAttribute('style');
      setTimeout(this.render.bind(this, container, true, props), 0);
    }
  }, {
    key: "onHideApplyLink",
    value: function onHideApplyLink() {
      var title = this.formComponent.state.title || '';
      var url = this.formComponent.state.url.replace(/\s/g, '');
      var _this$formComponent$s = this.formComponent.state,
        target = _this$formComponent$s.target,
        shape = _this$formComponent$s.shape,
        background = _this$formComponent$s.background,
        size = _this$formComponent$s.size,
        buttonType = _this$formComponent$s.buttonType,
        id = _this$formComponent$s.id;
      if (url !== '') {
        url = url.replace(/^(payload:)?(javascript){1,}/ig, '');
        var hasProtocol = url.match(/(?:(?:[a-z][a-z0-9+.-]*:)(?:.*))/gm);
        var internalUrlPattern = /^\/[a-zA-Z0-9/_-]*$/;
        var isEmail = validateEmail(url);
        if (isEmail) {
          url = 'mailto:' + url;
        } else if (!hasProtocol && !internalUrlPattern.test(url)) {
          url = 'https://' + url;
        }
        this.changeButton({
          title: title,
          url: url,
          target: target,
          shape: shape,
          background: background,
          size: size,
          buttonType: buttonType,
          id: id
        }, false);
      } else {
        this.deleteButton();
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this3 = this;
      var isEsc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var cancel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!isEsc) {
        if (this.formComponent && this.formComponent.urlInputNode) {
          this.onHideApplyLink();
        }
      }
      if (this.newButton || this.button && this.button.newButton) {
        // при cancel или done удаляем self-controlled-content для новой инлайн кнопки
        this.button && this.button.removeSelfControlled && this.button.removeSelfControlled();
        this.cancelNewButton(isEsc);
      } else {
        isEsc && !cancel && this.formComponent && this.formComponent.cancel();
      }
      this.editor.off('delta', this.onEditorTextChange);
      var container = this.container;
      setTimeout(function () {
        _this3.container = null;
        _this3.button = null;
        _this3.params = null;
        _this3.direction = null;
        _this3.correctLeft = null;
        _this3.rangeParams = null;
        _this3.render(container);
        if (container && container.parentNode)
          //так же временное условие из за дубликата
          container.parentNode.removeChild(container);
      }, 0);
    }
  }]);
  return ButtonForm;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/button/buttonSingleBlotMenuHeader.js
function buttonSingleBlotMenuHeader_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { buttonSingleBlotMenuHeader_typeof = function _typeof(obj) { return typeof obj; }; } else { buttonSingleBlotMenuHeader_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return buttonSingleBlotMenuHeader_typeof(obj); }











function buttonSingleBlotMenuHeader_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function buttonSingleBlotMenuHeader_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function buttonSingleBlotMenuHeader_createClass(Constructor, protoProps, staticProps) { if (protoProps) buttonSingleBlotMenuHeader_defineProperties(Constructor.prototype, protoProps); if (staticProps) buttonSingleBlotMenuHeader_defineProperties(Constructor, staticProps); return Constructor; }
function buttonSingleBlotMenuHeader_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) buttonSingleBlotMenuHeader_setPrototypeOf(subClass, superClass); }
function buttonSingleBlotMenuHeader_setPrototypeOf(o, p) { buttonSingleBlotMenuHeader_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return buttonSingleBlotMenuHeader_setPrototypeOf(o, p); }
function buttonSingleBlotMenuHeader_createSuper(Derived) { var hasNativeReflectConstruct = buttonSingleBlotMenuHeader_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = buttonSingleBlotMenuHeader_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = buttonSingleBlotMenuHeader_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return buttonSingleBlotMenuHeader_possibleConstructorReturn(this, result); }; }
function buttonSingleBlotMenuHeader_possibleConstructorReturn(self, call) { if (call && (buttonSingleBlotMenuHeader_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return buttonSingleBlotMenuHeader_assertThisInitialized(self); }
function buttonSingleBlotMenuHeader_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function buttonSingleBlotMenuHeader_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function buttonSingleBlotMenuHeader_getPrototypeOf(o) { buttonSingleBlotMenuHeader_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return buttonSingleBlotMenuHeader_getPrototypeOf(o); }
function buttonSingleBlotMenuHeader_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




function buttonSingleBlotMenuHeader_getState(map) {
  return {
    align: map.get('embed-align') || 'left'
  };
}
var ButtonSingleBlotMenuHeader = /*#__PURE__*/function (_Component) {
  buttonSingleBlotMenuHeader_inherits(ButtonSingleBlotMenuHeader, _Component);
  var _super = buttonSingleBlotMenuHeader_createSuper(ButtonSingleBlotMenuHeader);
  function ButtonSingleBlotMenuHeader(props) {
    var _this;
    buttonSingleBlotMenuHeader_classCallCheck(this, ButtonSingleBlotMenuHeader);
    _this = _super.call(this, props);
    buttonSingleBlotMenuHeader_defineProperty(buttonSingleBlotMenuHeader_assertThisInitialized(_this), "onMapChange", function () {
      var map = _this.props.blot.map;
      _this.setState(buttonSingleBlotMenuHeader_getState(map));
    });
    _this.state = buttonSingleBlotMenuHeader_getState(props.blot.map);
    return _this;
  }
  buttonSingleBlotMenuHeader_createClass(ButtonSingleBlotMenuHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var blot = this.props.blot;
      var store = blot.editor.store;
      store.observe(blot.map, this.onMapChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var blot = this.props.blot;
      var store = blot.editor.store;
      store.unobserve(blot.map, this.onMapChange);
    }
  }, {
    key: "setAlign",
    value: function setAlign(align) {
      var _this$props = this.props,
        editor = _this$props.blot.editor,
        menu = _this$props.menu;
      editor.exec('set-embed-align', {
        align: align
      });
      menu.onMenuClose();
    }
  }, {
    key: "render",
    value: function render() {
      var align = this.state.align;
      return (0,preact_module.h)(BlockMenuHeader, null, (0,preact_module.h)(BlockMenuHeaderItem, {
        id: "align-left",
        active: align === 'left',
        onClick: this.setAlign.bind(this, 'left'),
        icon: icons/* EmbedAlignLeft */.sws
      }), (0,preact_module.h)(BlockMenuHeaderItem, {
        id: "align-center",
        active: align === 'center',
        onClick: this.setAlign.bind(this, 'center'),
        icon: icons/* EmbedAlignCenter */.fm
      }), (0,preact_module.h)(BlockMenuHeaderItem, {
        id: "align-right",
        active: align === 'right',
        onClick: this.setAlign.bind(this, 'right'),
        icon: icons/* EmbedAlignRight */.vSI
      }));
    }
  }]);
  return ButtonSingleBlotMenuHeader;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/button/buttonSingle.js
function buttonSingle_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { buttonSingle_typeof = function _typeof(obj) { return typeof obj; }; } else { buttonSingle_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return buttonSingle_typeof(obj); }


















var _excluded = ["showForm"],
  _excluded2 = ["showSizes"];
function buttonSingle_toConsumableArray(arr) { return buttonSingle_arrayWithoutHoles(arr) || buttonSingle_iterableToArray(arr) || buttonSingle_unsupportedIterableToArray(arr) || buttonSingle_nonIterableSpread(); }
function buttonSingle_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function buttonSingle_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return buttonSingle_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return buttonSingle_arrayLikeToArray(o, minLen); }
function buttonSingle_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function buttonSingle_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return buttonSingle_arrayLikeToArray(arr); }
function buttonSingle_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function buttonSingle_extends() { buttonSingle_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return buttonSingle_extends.apply(this, arguments); }
function buttonSingle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function buttonSingle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { buttonSingle_ownKeys(Object(source), true).forEach(function (key) { buttonSingle_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { buttonSingle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





function buttonSingle_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function buttonSingle_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function buttonSingle_createClass(Constructor, protoProps, staticProps) { if (protoProps) buttonSingle_defineProperties(Constructor.prototype, protoProps); if (staticProps) buttonSingle_defineProperties(Constructor, staticProps); return Constructor; }
function buttonSingle_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) buttonSingle_setPrototypeOf(subClass, superClass); }
function buttonSingle_setPrototypeOf(o, p) { buttonSingle_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return buttonSingle_setPrototypeOf(o, p); }
function buttonSingle_createSuper(Derived) { var hasNativeReflectConstruct = buttonSingle_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = buttonSingle_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = buttonSingle_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return buttonSingle_possibleConstructorReturn(this, result); }; }
function buttonSingle_possibleConstructorReturn(self, call) { if (call && (buttonSingle_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return buttonSingle_assertThisInitialized(self); }
function buttonSingle_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function buttonSingle_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function buttonSingle_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { buttonSingle_get = Reflect.get; } else { buttonSingle_get = function _get(target, property, receiver) { var base = buttonSingle_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return buttonSingle_get(target, property, receiver || target); }
function buttonSingle_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = buttonSingle_getPrototypeOf(object); if (object === null) break; } return object; }
function buttonSingle_getPrototypeOf(o) { buttonSingle_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return buttonSingle_getPrototypeOf(o); }
function buttonSingle_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






















var buttonSingle_mixin = mix([commentable, blotLock, embeddable, draggable, dropAcceptor, selectable, focusable, executable, basic]);
var HTML_CLASS = 'button-single';
var HTML_CONTAINER_CLASS = 'button-single-container';
var ButtonSingle = /*#__PURE__*/function (_mixin) {
  buttonSingle_inherits(ButtonSingle, _mixin);
  var _super = buttonSingle_createSuper(ButtonSingle);
  function ButtonSingle() {
    var _this;
    buttonSingle_classCallCheck(this, ButtonSingle);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    buttonSingle_defineProperty(buttonSingle_assertThisInitialized(_this), "isShowForm", function () {
      return _this.map.get('showForm') !== false;
    });
    buttonSingle_defineProperty(buttonSingle_assertThisInitialized(_this), "setAllButtonProps", function () {
      var props = ButtonSingle.properties;
      _this.setProps({
        cssId: _this.map.get('cssId'),
        title: _this.map.get('title') || props.title.def,
        url: _this.map.get('url') || props.url.def,
        target: _this.map.get('target') || props.target.def,
        shape: _this.map.get('shape') || props.shape.def,
        background: _this.map.get('background') || props.background.def,
        size: _this.map.get('size') || props.size.def,
        buttonType: _this.map.get('buttonType') || props.buttonType.def,
        showSizes: true
      });
    });
    buttonSingle_defineProperty(buttonSingle_assertThisInitialized(_this), "mapObserver", function () {
      _this.setAllButtonProps();
      _this.render();
    });
    buttonSingle_defineProperty(buttonSingle_assertThisInitialized(_this), "getButtonToForm", function () {
      return {
        setTitle: _this.setTitle,
        setUrl: _this.setUrl,
        setTarget: _this.setTarget,
        setShape: _this.setShape,
        setBackground: _this.setBackground,
        setSize: _this.setSize,
        setType: _this.setType,
        getButtonProps: _this.getButtonProps,
        deleteButton: _this.deleteButton,
        newButton: _this.isShowForm(),
        setEditForm: _this.setEditForm,
        domNode: _this.button
      };
    });
    buttonSingle_defineProperty(buttonSingle_assertThisInitialized(_this), "onMouseClick", function () {
      var _assertThisInitialize = buttonSingle_assertThisInitialized(_this),
        editor = _assertThisInitialize.editor;
      var linkManager = editor.plugins.linkManager;
      var url = _this.map.get('url');
      var isBlotLocked = _this.isBlotLocked;
      var options = editor.options;
      var _ref = options && options.blots && options.blots.button || {},
        _ref$showButtonFormat = _ref.showButtonFormat,
        showButtonFormat = _ref$showButtonFormat === void 0 ? true : _ref$showButtonFormat;
      if (editor.mode === MODE_EDIT && !isBlotLocked && showButtonFormat) {
        ButtonSingle.showEditForm(editor, _this.id, false);
      } else {
        if (!linkManager.processNavigation(url)) {
          window.open(url, _this.map.get('target'), 'noopener');
        }
      }
    });
    buttonSingle_defineProperty(buttonSingle_assertThisInitialized(_this), "changeButton", function (formats) {
      var _ButtonSingle$propert = ButtonSingle.properties,
        showForm = _ButtonSingle$propert.showForm,
        properties = _objectWithoutProperties(_ButtonSingle$propert, _excluded);
      var setMapProp = ButtonSingle.setMapProp;
      for (var key in properties) {
        setMapProp(key, properties[key], _this.map, formats);
      }
      _this.render();
    });
    buttonSingle_defineProperty(buttonSingle_assertThisInitialized(_this), "setTitle", function (title) {
      _this.setProps({
        title: title
      });
    });
    buttonSingle_defineProperty(buttonSingle_assertThisInitialized(_this), "setUrl", function (url) {
      _this.setProps({
        url: url
      });
    });
    buttonSingle_defineProperty(buttonSingle_assertThisInitialized(_this), "setTarget", function (target) {
      _this.setProps({
        target: target
      });
    });
    buttonSingle_defineProperty(buttonSingle_assertThisInitialized(_this), "setShape", function (shape) {
      _this.setProps({
        shape: shape
      });
    });
    buttonSingle_defineProperty(buttonSingle_assertThisInitialized(_this), "setBackground", function (background) {
      _this.setProps({
        background: background
      });
    });
    buttonSingle_defineProperty(buttonSingle_assertThisInitialized(_this), "setSize", function (size) {
      _this.setProps({
        size: size
      });
    });
    buttonSingle_defineProperty(buttonSingle_assertThisInitialized(_this), "setEditForm", function (editForm) {
      _this.editForm = editForm;
    });
    buttonSingle_defineProperty(buttonSingle_assertThisInitialized(_this), "setType", function (buttonType) {
      _this.setProps({
        buttonType: buttonType
      });
    });
    buttonSingle_defineProperty(buttonSingle_assertThisInitialized(_this), "deleteButton", function () {
      _this.props.focus = true; // устанавливаем фокус т.к. удаление может быть вызвано когда нет фокуса на кнопке
      _this.remove();
    });
    buttonSingle_defineProperty(buttonSingle_assertThisInitialized(_this), "getButtonProps", function () {
      return _this.props;
    });
    buttonSingle_defineProperty(buttonSingle_assertThisInitialized(_this), "onButtonRef", function (ref) {
      _this.button = ref.base;
    });
    buttonSingle_defineProperty(buttonSingle_assertThisInitialized(_this), "getAlign", function () {
      return _this.map.get('embed-align') || 'left';
    });
    _this.addCanExecActions(['set-embed-align', 'delete', 'backspace']);
    _this.maxTitleSize = ButtonFormComponent.maxTitleSize; // для проверки в тестах
    _this.editForm = null;
    return _this;
  }
  buttonSingle_createClass(ButtonSingle, [{
    key: "showEditForm",
    value: function showEditForm() {
      ButtonSingle.showEditForm(this.editor, this.id, true);
    }
  }, {
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get2 = buttonSingle_get(buttonSingle_getPrototypeOf(ButtonSingle.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      var editor = this.editor;
      this.htmlContainer = this.domNode.querySelector('.' + HTML_CONTAINER_CLASS);
      this.editor.store.observe(this.map, this.mapObserver);
      this.setAllButtonProps();
      this.render();

      // показываем форму только один раз после создания
      if (this.isShowForm()) {
        ButtonSingle.showEditForm(editor, this.id);
        this.map.set('showForm', false);
      }
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      (_get3 = buttonSingle_get(buttonSingle_getPrototypeOf(ButtonSingle.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      var range = this.scroll.selection.getRange()[0];
      if (range) {
        this.scroll.selection.setRange(range);
      }
      this.editor.store.unobserve(this.map, this.mapObserver);
    }
  }, {
    key: "cloneSelf",
    value: function cloneSelf() {
      var map = this.store.createMap();
      var _this$getButtonProps = this.getButtonProps(),
        showSizes = _this$getButtonProps.showSizes,
        params = _objectWithoutProperties(_this$getButtonProps, _excluded2);
      params.showForm = false;
      parchment_default().query(this.map.get('type')).initMap(map, this.store, params);
      return map.get('id');
    }
  }, {
    key: "getBlotMenuHeaderComponent",
    value: function getBlotMenuHeaderComponent() {
      return ButtonSingleBlotMenuHeader;
    }
  }, {
    key: "exec",
    value: function exec(action) {
      var processed = false;
      var type = action.type,
        params = action.params;
      var setMapProp = ButtonSingle.setMapProp;
      switch (type) {
        case 'set-embed-align':
          {
            setMapProp('embed-align', {
              def: 'left'
            }, this.map, {
              'embed-align': params.align
            });
            processed = true;
            break;
          }
        case 'backspace':
          {
            this.editForm && this.editForm.hide(true); // если нажали на кнопку и появилось меню редактирования, скрываем его
            this.remove();
            processed = true;
            break;
          }
      }
      if (!processed) {
        processed = buttonSingle_get(buttonSingle_getPrototypeOf(ButtonSingle.prototype), "exec", this).call(this, action);
      }
      return processed;
    }

    /**
     * Корректирует положение меню
     * @param left
     * @param top
     * @returns {{top: *, left: number}}
     */
  }, {
    key: "onBlotMenuUpdatePosition",
    value: function onBlotMenuUpdatePosition(_ref2) {
      var left = _ref2.left,
        top = _ref2.top;
      top += 2;
      var loaderNode = this.domNode;
      if (loaderNode) {
        var nodeX = loaderNode.getBoundingClientRect().x;
        left += this.button.getBoundingClientRect().x - nodeX;
      }
      return {
        left: left,
        top: top
      };
    }
  }, {
    key: "contextMenu",
    get: function get() {
      var menu = buttonSingle_get(buttonSingle_getPrototypeOf(ButtonSingle.prototype), "contextMenu", this);
      var i18n = this.editor.plugins.i18n;
      menu['edit-button'] = {
        label: i18n.get('block_menu.edit'),
        index: -12,
        group: 0,
        action: 'showEditForm'
      };
      menu['turn-into'] = {
        label: i18n.get('block_menu.convert_to.name'),
        index: -11,
        group: 0,
        action: false,
        submenu: {
          turnToParagraph: {
            label: i18n.get('block_menu.convert_to.paragraph'),
            index: 0,
            group: 0,
            action: 'convert-blot',
            actionParams: {
              type: 'paragraph'
            },
            stackable: false,
            actionExec: true,
            icon: icons/* IconParagraph */.V_f
          },
          turnToLink: {
            label: i18n.get('floating_toolbar.link'),
            index: 0,
            group: 0,
            action: 'convert-blot',
            actionParams: {
              type: 'paragraph',
              link: true
            },
            stackable: false,
            actionExec: true,
            icon: icons/* IconLink */.JHz
          },
          turnToChecklist: {
            label: i18n.get('block_menu.convert_to.to_do_list'),
            index: 0,
            group: 0,
            action: 'convert-blot',
            actionParams: {
              type: 'list',
              items: ['listItemCheckbox']
            },
            actionExec: true,
            stackable: ['Paragraph', 'ListItemCheckbox', 'ListItemBullet', 'ListItemNumber'],
            icon: icons/* IconTasks */.G40
          },
          turnToNumberList: {
            label: i18n.get('block_menu.convert_to.number_list'),
            index: 0,
            group: 0,
            action: 'convert-blot',
            actionParams: {
              type: 'list',
              items: ['listItemNumber']
            },
            stackable: false,
            actionExec: true,
            icon: icons/* IconListNumber */.UcJ
          },
          turnToBulletList: {
            label: i18n.get('block_menu.convert_to.bullet_list'),
            index: 0,
            group: 0,
            action: 'convert-blot',
            actionParams: {
              type: 'list',
              items: ['listItemBullet']
            },
            stackable: false,
            actionExec: true,
            icon: icons/* IconListBullet */.pfx
          },
          turnToBlockquote: {
            label: i18n.get('block_menu.convert_to.quote'),
            index: 8,
            group: 0,
            action: 'convert-blot',
            actionParams: {
              type: 'blockquote',
              link: true
            },
            actionExec: true,
            stackable: ['Paragraph', 'ListItemCheckbox', 'ListItemBullet', 'ListItemNumber'],
            icon: icons/* IconQuote */.kVp
          },
          turnToBookmark: {
            label: i18n.get('block_menu.convert_to.bookmark'),
            index: 0,
            group: 0,
            action: 'convert-blot',
            actionParams: {
              type: 'bookmark',
              src: this.map.get('url'),
              replaceBlotId: this.id
            },
            stackable: false,
            actionExec: true,
            icon: icons/* IconBookmark */.BZM
          },
          turnToEmbed: {
            label: i18n.get('block_menu.convert_to.remote_frame'),
            index: 0,
            group: 0,
            action: 'convert-blot',
            actionParams: {
              type: 'remote-frame',
              src: this.map.get('url'),
              replaceBlotId: this.id
            },
            stackable: false,
            actionExec: true,
            icon: icons/* IconEmbed */.g9E
          }
        }
      };
      return menu;
    }

    /**
     * Получение параметров для конвертации в другие объекты
     * @param blot
     * @param params
     * @returns {{removeOriginal: boolean}}
     */
  }, {
    key: "getTextDelta",
    value: function getTextDelta(params) {
      var insert = this.map.get('title');
      var op = {
        insert: insert,
        attributes: {}
      };
      if (params && params.link) {
        op.attributes.link = this.map.get('url');
      }
      return {
        ops: [op]
      };
    }
  }, {
    key: "delta",
    value: function delta() {
      return {
        ops: [{
          insert: this.map.get('title'),
          attributes: {
            link: this.map.get('url')
          }
        }]
      };
    }

    /**
     * Параметры для скопированной кнопки
     * @param blotRange
     * @param contextHelper
     * @returns {*}
     */
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      var params = buttonSingle_get(buttonSingle_getPrototypeOf(ButtonSingle.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
      return (0,util/* mergeDeep */.Ee)(params, {
        initParams: buttonSingle_objectSpread(buttonSingle_objectSpread({}, this.getButtonProps()), {}, {
          showForm: false
        })
      });
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      var url = this.props.url;
      var target = this.props.target;
      this.button.setAttribute('onclick', "window.open('".concat(url, "', '").concat(target, "', 'noopener')"));
      return this.domNode.outerHTML;
    }
  }, {
    key: "render",
    value: function render() {
      buttonSingle_get(buttonSingle_getPrototypeOf(ButtonSingle.prototype), "render", this).call(this);
      this.htmlContainer.setAttribute('data-align', this.getAlign());
      (0,preact_module/* render */.sY)((0,preact_module.h)(ButtonSingleComponent, buttonSingle_extends({
        editor: this.editor,
        ref: this.onButtonRef,
        onMouseClick: this.onMouseClick
      }, this.getButtonProps())), this.htmlContainer);
    }
  }], [{
    key: "createBlot",
    value: function createBlot(editor) {
      var blot = parchment_default().create(ButtonSingle.blotName);
      this.addCaretTrap(editor, blot.domNode);
      return blot;
    }
  }, {
    key: "create",
    value: function create(value) {
      var node = buttonSingle_get(buttonSingle_getPrototypeOf(ButtonSingle), "create", this).call(this);
      var htmlContainer = document.createElement('div');
      node.classList.add(HTML_CLASS);
      node.setAttribute('contenteditable', false);
      htmlContainer.classList.add(HTML_CONTAINER_CLASS);
      node.appendChild(htmlContainer);
      return node;
    }

    /**
     * Чтобы не увеличивать размер документа, устанавливает в map только явно переданные параметры
     * и удаляет из map-а дефолтные значения
     * @param code
     * @param property
     * @param map
     * @param params
     */
  }, {
    key: "showEditForm",
    value:
    /**
     * Показать форму редактирования кнопки
     * @param editor
     * @param blotId
     * @param editForm
     * @param buttonParams
     */
    // тут в параметры передаем не блот а blotId так как в некоторых случаях
    // при вызове этой функции блот может не успеть заатачиться в DOM
    // и для формы не существовать, если же получить блот с помощью редактора по его id то все ок.
    function showEditForm(editor, blotId) {
      var editForm = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var buttonParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var params = {
        id: blotId,
        singleBlock: true
      };
      var blot = editor.findById(blotId);
      var button = buttonSingle_objectSpread(buttonSingle_objectSpread({}, blot.getButtonToForm()), buttonParams);
      new ButtonForm({
        editor: editor,
        scroll: editor.scroll,
        button: button,
        params: params
      }).show(editForm);
    }
  }, {
    key: "getConvertParams",
    value: function getConvertParams(blot) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var textBlot = blot.constructor.isTextBlot && blot.getTextBlot ? blot.getTextBlot() : blot;
      var buttonParams = {
        removeOriginal: true
      };
      var title = textBlot.getText().trim().substr(0, ButtonFormComponent.maxTitleSize);
      var ops = textBlot.delta().ops;
      var links = ops.filter(function (item) {
        return item.attributes && item.attributes.link;
      });
      var buttons = ops.filter(function (item) {
        return item.insert && item.insert.button;
      });
      if (title.trim()) {
        buttonParams.title = title;
      }
      this.setCommentThreads(blot, buttonParams);
      if (links.length) {
        buttonParams.url = links[0].attributes.link;
        if (buttonParams.title === buttonParams.url) {
          buttonParams.title = '';
        }
      } else if (buttons.length) {
        buttonParams = buttonSingle_objectSpread(buttonSingle_objectSpread({}, JSON.parse(buttons[0].insert.button)), buttonParams);
      }
      return buttonSingle_objectSpread(buttonSingle_objectSpread({}, params), buttonParams);
    }
  }, {
    key: "convertBlots",
    value: function convertBlots(ids, store, _ref3) {
      var params = _ref3.params,
        container = _ref3.container;
      var editor = container.editor;
      if (!ids.length) {
        return null;
      }
      var result = {
        removeBlots: [],
        insertBlots: []
      };
      var blot = container.editor.findById(ids[ids.length - 1]);
      if (ids.length) {
        result.removeBlots = ids;
      }
      var map = store.createMap();
      var id = map.get('id');
      var buttonParams = params;
      if (blot instanceof textLine || blot.constructor.isTextBlot) {
        buttonParams = ButtonSingle.getConvertParams(blot, params);
      } else {
        // для сохранения треда комментариев при конвертации не из текстовых блотов
        this.setCommentThreads(blot, buttonParams);
      }
      this.initMap(map, store, buttonParams);
      result.insertBlots.push(id);
      if (blot.hasChildrenContainer) {
        var _result$insertBlots;
        (_result$insertBlots = result.insertBlots).push.apply(_result$insertBlots, buttonSingle_toConsumableArray(blot.map.get('children').toArray()));
      }
      return result;
    }
  }, {
    key: "isAbleToConvert",
    value: function isAbleToConvert(editor) {
      var blots = editor.scroll.getSelectedBlocks();
      if (blots.length === 1) {
        if (blots[0] instanceof paragraphAbstract && blots[0].getText().trim() === '') {
          return true;
        }
      }
      return false;
    }
  }]);
  return ButtonSingle;
}(buttonSingle_mixin(blockEmbed));
buttonSingle_defineProperty(ButtonSingle, "hasInnerTextLine", false);
buttonSingle_defineProperty(ButtonSingle, "setMapProp", function (code, property, map, params) {
  var def = property.def;
  if (params.hasOwnProperty(code)) {
    var value = params[code];
    if (code === 'title') {
      value = value.trim().substr(0, ButtonFormComponent.maxTitleSize);
    }
    if (value === def) {
      if (map.get(code)) {
        map.delete(code);
      }
    } else {
      map.set(code, value);
    }
  }
});
buttonSingle_defineProperty(ButtonSingle, "properties", {
  'showForm': {
    def: true
  },
  'background': {
    def: 'bondi-blue'
  },
  'shape': {
    def: 'rounded'
  },
  'size': {
    def: 'small'
  },
  'buttonType': {
    def: '3d'
  },
  'target': {
    def: '_blank'
  },
  'title': {
    def: ''
  },
  'url': {
    def: ''
  }
});
buttonSingle_defineProperty(ButtonSingle, "initMap", function (map, store) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var setMapProp = ButtonSingle.setMapProp,
    properties = ButtonSingle.properties;
  map.set('cssId', generateButtonId());
  map.set('type', ButtonSingle.blotName);
  for (var key in properties) {
    setMapProp(key, properties[key], map, params);
  }
  buttonSingle_get(buttonSingle_getPrototypeOf(ButtonSingle), "initMap", ButtonSingle) && buttonSingle_get(buttonSingle_getPrototypeOf(ButtonSingle), "initMap", ButtonSingle).call(ButtonSingle, map, store, params);
});

ButtonSingle.blotName = 'button-single';
ButtonSingle.tagName = 'div';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/keyboard.js
function keyboard_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = keyboard_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function keyboard_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return keyboard_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return keyboard_arrayLikeToArray(o, minLen); }
function keyboard_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }




























var isCtrlCKey = (0,lib/* default */.ZP)('mod+c');
var KEYS = [
// typing keys
{
  hotkey: 'backspace',
  action: function action(editor) {
    return new backspace_BackspaceAction(backspace_BackspaceAction.type, {}, editor);
  },
  liteMode: true
}, {
  hotkey: 'shift+backspace',
  action: function action(editor) {
    return new backspace_BackspaceAction(backspace_BackspaceAction.type, {
      shiftKey: true
    }, editor);
  },
  liteMode: true
}, {
  hotkey: 'delete',
  action: function action(editor) {
    return new DeleteAction(DeleteAction.type, {}, editor);
  },
  liteMode: true
}, {
  hotkey: 'alt+shift+delete',
  action: function action(editor) {
    return new DeleteBlockAction(DeleteBlockAction.type, {}, editor);
  },
  liteMode: true
}, {
  hotkey: 'mod+z',
  action: function action(editor) {
    return new UndoAction(UndoAction.type, {}, editor);
  },
  liteMode: true
}, {
  hotkey: 'mod+shift+z',
  altHotkey: 'mod+y',
  action: function action(editor) {
    return new RedoAction(RedoAction.type, {}, editor);
  },
  liteMode: true
}, {
  hotkey: 'mod+a',
  action: function action(editor) {
    return new SelectAllAction(SelectAllAction.type, {}, editor);
  },
  liteMode: true
}, {
  hotkey: 'enter',
  altHotkey: 'shift+enter',
  action: function action(editor) {
    return new TypingCleanupAction(TypingCleanupAction.type, {}, editor);
  },
  liteMode: true
}, {
  hotkey: 'escape',
  action: function action(editor) {
    return new ClearSelectionAction(ClearSelectionAction.type, {}, editor);
  },
  liteMode: true
},
// format keys
{
  hotkey: 'mod+b',
  action: function action(editor) {
    editor.exec('format', 'bold');
    return true;
  }
}, {
  hotkey: 'mod+i',
  action: function action(editor) {
    editor.exec('format', 'italic');
    return true;
  }
}, {
  hotkey: 'mod+shift+s',
  action: function action(editor) {
    editor.exec('format', 'strikethrough');
    return true;
  }
}, {
  hotkey: 'mod+u',
  action: function action(editor) {
    editor.exec('format', 'underline');
    return true;
  }
}, {
  hotkey: 'mod+k',
  action: function action(editor) {
    addLinkAction(editor);
    return true;
  }
}, {
  hotkey: 'mod+option+e',
  action: function action(editor) {
    editor.exec('format', 'code');
    return true;
  }
}, {
  hotkey: 'mod+/',
  action: function action(editor) {
    editor.exec('clear-formatting');
    return true;
  }
}, {
  hotkey: 'mod+option+h',
  action: function action(editor) {
    return new ToggleHighlightAction(ToggleHighlightAction.type, {}, editor);
  }
}, {
  hotkey: 'mod+option+p',
  action: function action(editor) {
    editor.exec('format', 'placeholder');
    return true;
  }
},
// align keys
{
  hotkey: 'mod+shift+1',
  action: function action(editor) {
    editor.exec('set-align', 'left');
    return true;
  }
}, {
  hotkey: 'mod+shift+2',
  action: function action(editor) {
    editor.exec('set-align', 'center');
    return true;
  }
}, {
  hotkey: 'mod+shift+3',
  action: function action(editor) {
    editor.exec('set-align', 'right');
    return true;
  }
},
// convert keys
{
  hotkey: 'mod+option+u',
  action: function action(editor) {
    editor.exec('convert-blot', {
      type: 'hint'
    });
    return true;
  }
}, {
  hotkey: 'mod+opt+l',
  action: function action(editor) {
    editor.exec('convert-blot', {
      type: 'hLine'
    });
    return true;
  }
}, {
  hotkey: 'mod+option+t',
  action: function action(editor) {
    editor.exec('convert-blot', {
      type: 'table',
      rows: 2,
      cols: 3,
      batch: true
    });
    return true;
  }
}, {
  hotkey: 'mod+shift+c',
  action: function action(editor) {
    editor.exec('convert-blot', {
      type: 'list',
      items: ['listItemCheckbox']
    });
    return true;
  }
}, {
  hotkey: 'mod+shift+7',
  action: function action(editor) {
    editor.exec('convert-blot', {
      type: 'list',
      items: ['listItemNumber']
    });
    return true;
  }
}, {
  hotkey: 'mod+shift+8',
  action: function action(editor) {
    editor.exec('convert-blot', {
      type: 'list',
      items: ['listItemBullet']
    });
    return true;
  }
}, {
  hotkey: 'mod+opt+1',
  action: function action(editor) {
    editor.exec('convert-blot', {
      type: 'hLarge'
    });
    return true;
  }
}, {
  hotkey: 'mod+opt+2',
  action: function action(editor) {
    editor.exec('convert-blot', {
      type: 'hMedium'
    });
    return true;
  }
}, {
  hotkey: 'mod+opt+3',
  action: function action(editor) {
    editor.exec('convert-blot', {
      type: 'hSmall'
    });
    return true;
  }
}, {
  hotkey: 'mod+opt+5',
  action: function action(editor) {
    if (ButtonSingle.isAbleToConvert(editor)) {
      editor.exec('convert-blot', {
        type: 'button-single'
      });
    }
    return true;
  }
}, {
  hotkey: 'mod+opt+7',
  action: function action(editor) {
    editor.exec('convert-blot', {
      type: 'paragraph'
    });
    return true;
  }
}, {
  hotkey: 'mod+opt+8',
  action: function action(editor) {
    if (!editor.plugins.webRTCPlugin.isExistsRecords.audio) {
      editor.exec('convert-blot', {
        type: 'file',
        audioRecord: true
      });
    }
    return true;
  }
}, {
  hotkey: 'mod+opt+9',
  action: function action(editor) {
    if (!editor.plugins.webRTCPlugin.isExistsRecords.media && (0,browser/* detectBrowser */.Ao)() !== 'Safari') {
      editor.plugins.webRTCPlugin.prepareMediaRecord();
    }
    return true;
  }
}, {
  hotkey: 'mod+shift+f',
  action: function action(editor) {
    editor.exec('add-file');
    return true;
  }
}, {
  hotkey: 'mod+shift+i',
  action: function action(editor) {
    if (editor.plugins.attachmentManager.isMethodImplemented('chooseFile')) {
      editor.exec('convert-blot', {
        type: 'image'
      });
    }
    return true;
  }
}, {
  hotkey: 'mod+option+o',
  action: function action(editor) {
    editor.exec('convert-blot', {
      type: 'outline'
    });
    return true;
  }
}, {
  hotkey: 'mod+option+m',
  action: function action(editor) {
    editor.exec('convert-blot', {
      type: 'remote-frame'
    });
    return true;
  }
}, {
  hotkey: 'mod+option+g',
  action: function action(editor) {
    editor.exec('add-remote-file', {
      service: 'google-drive'
    });
    return true;
  }
}, {
  hotkey: 'mod+option+b',
  action: function action(editor) {
    editor.exec('convert-blot', {
      type: 'bookmark'
    });
    return true;
  }
}, {
  hotkey: 'mod+option+c',
  action: function action(editor) {
    editor.exec('convert-blot', {
      type: 'syntax'
    });
    return true;
  }
}, {
  hotkey: 'mod+option+y',
  action: function action(editor) {
    editor.exec('convert-blot', {
      type: 'blockquote'
    });
    return true;
  }
}, {
  hotkey: 'mod+option+6',
  action: function action(editor) {
    editor.exec('convert-blot', {
      type: 'toggle'
    });
    return true;
  }
}, {
  hotkey: 'mod+option+d',
  action: function action(editor) {
    editor.exec('convert-blot', {
      type: 'tasks-list'
    });
    return true;
  }
},
// search keys
{
  hotkey: 'mod+f',
  action: function action(editor) {
    editor.plugins.search.start();
    return true;
  }
}];
var ABORT_KEYBOARD_PROCESSING_SIGN = 'nedit-abort-keyboard-processing';
/* harmony default export */ const keyboard = ({
  process: function process(event, editor) {
    if (editor.mode !== MODE_EDIT && editor.mode !== MODE_LITE) {
      return;
    }
    if (event[ABORT_KEYBOARD_PROCESSING_SIGN]) {
      return;
    }
    if (!editor.hasFocus()) {
      return;
    }
    var processingBlots = editor.scroll.selectedBlocks;

    // Check locked blots
    var activeBlot = processingBlots[0];
    if (activeBlot && activeBlot.isBlotLocked) {
      if (!isCtrlCKey(event)) {
        event.preventDefault();
        return true;
      }
    }
    var hasBlocked = false;
    if (processingBlots && processingBlots.length > 0) {
      processingBlots.forEach(function (blot) {
        if (blot.isBlotLocked) {
          hasBlocked = true;
        }
      });
    }
    if (hasBlocked) {
      if (!isCtrlCKey(event)) {
        event.preventDefault();
        return true;
      }
    }
    // End check locked blots

    var action = null;
    var _iterator = keyboard_createForOfIteratorHelper(KEYS),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        if ((0,lib/* default */.ZP)(key.hotkey, event) || key.altHotkey && (0,lib/* default */.ZP)(key.altHotkey, event)) {
          // если редактор в режиме редактирования или редактор в лайт режиме и кнопка доступна в лайт режиме,
          // выполняем дествие из объекта кнопки. Иначе просто приравниваем action true, чтобы выполнилось event.preventDefault()
          // и браузер не выполнил действие по умолчанию, чтобы избежать форматирования или других действий с контентом
          if (editor.mode === MODE_EDIT || editor.mode === MODE_LITE && key.liteMode) {
            action = key.action(editor);
          } else {
            action = true;
          }
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (action) {
      if (action instanceof Action) {
        action.keyboard = true;
        if (action.run({
          processingBlots: processingBlots
        })) {
          if (!action.isHandledByBrowser) {
            event.preventDefault();
          }
          return true;
        }
      } else {
        event.preventDefault();
        return true;
      }
    }
    return false;
  }
});
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/dragging.js
function dragging_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { dragging_typeof = function _typeof(obj) { return typeof obj; }; } else { dragging_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return dragging_typeof(obj); }









function dragging_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function dragging_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function dragging_createClass(Constructor, protoProps, staticProps) { if (protoProps) dragging_defineProperties(Constructor.prototype, protoProps); if (staticProps) dragging_defineProperties(Constructor, staticProps); return Constructor; }
function dragging_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) dragging_setPrototypeOf(subClass, superClass); }
function dragging_setPrototypeOf(o, p) { dragging_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return dragging_setPrototypeOf(o, p); }
function dragging_createSuper(Derived) { var hasNativeReflectConstruct = dragging_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = dragging_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = dragging_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return dragging_possibleConstructorReturn(this, result); }; }
function dragging_possibleConstructorReturn(self, call) { if (call && (dragging_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return dragging_assertThisInitialized(self); }
function dragging_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function dragging_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function dragging_getPrototypeOf(o) { dragging_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return dragging_getPrototypeOf(o); }
function dragging_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var memoizer = moize_min_default().maxSize(5);
var isNodeIgnored = memoizer(function (node, ignore) {
  if (node.closest(ignore)) {
    return true;
  }
  return false;
});
var isUnchange = memoizer(function (node, unchange) {
  if (node.closest(unchange)) {
    return true;
  }
  return false;
});
var resolveNode = memoizer(function (node, selector) {
  return node.closest(selector);
});
var Dragging = /*#__PURE__*/function (_EventEmitter) {
  dragging_inherits(Dragging, _EventEmitter);
  var _super = dragging_createSuper(Dragging);
  function Dragging(options) {
    var _this;
    dragging_classCallCheck(this, Dragging);
    _this = _super.call(this);
    dragging_defineProperty(dragging_assertThisInitialized(_this), "onMouseMove", function (event) {
      if (_this.unchange && isUnchange(event.target, _this.unchange)) {
        return;
      }
      if (_this.ignore && isNodeIgnored(event.target, _this.ignore)) {
        _this.emit('skip');
        return;
      }
      var node = resolveNode(event.target, _this.selector);
      _this.emit('drag', node, event);
    });
    dragging_defineProperty(dragging_assertThisInitialized(_this), "onMouseUp", function () {
      _this.stop();
    });
    _this.initPoint = options.initPoint;
    _this.selector = options.selector;
    _this.ignore = options.ignore;
    _this.unchange = options.unchange;
    return _this;
  }
  dragging_createClass(Dragging, [{
    key: "start",
    value: function start() {
      document.body.addEventListener('mousemove', this.onMouseMove, false);
      document.body.addEventListener('mouseup', this.onMouseUp, false);
    }
  }, {
    key: "stop",
    value: function stop() {
      document.body.removeEventListener('mousemove', this.onMouseMove, false);
      document.body.removeEventListener('mouseup', this.onMouseUp, false);
      this.emit('end');
    }
  }]);
  return Dragging;
}((events_default()));

function onMouseDownWaitDragging(mouseDownPos, triggerDistance, onDraggingStart) {
  var onMouseUp = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var onDocumentMouseMove = function onDocumentMouseMove(event) {
    if (!mouseDownPos) {
      return;
    }
    var nowPosition = {
      x: event.clientX,
      y: event.clientY
    };
    if (math_distance(nowPosition, mouseDownPos) >= triggerDistance) {
      document.removeEventListener('mousemove', onDocumentMouseMove, false);
      document.removeEventListener('mouseup', onDocumentMouseUp, false);
      if (onDraggingStart && typeof onDraggingStart === 'function') {
        onDraggingStart();
      }
    }
  };
  var onDocumentMouseUp = function onDocumentMouseUp(event) {
    if (onMouseUp && typeof onMouseUp === 'function') {
      onMouseUp(event);
    }
    document.removeEventListener('mousemove', onDocumentMouseMove, false);
    document.removeEventListener('mouseup', onDocumentMouseUp, false);
  };
  document.addEventListener('mousemove', onDocumentMouseMove, false);
  document.addEventListener('mouseup', onDocumentMouseUp, false);
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/moveTableColumn.js
function moveTableColumn_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { moveTableColumn_typeof = function _typeof(obj) { return typeof obj; }; } else { moveTableColumn_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return moveTableColumn_typeof(obj); }









function moveTableColumn_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function moveTableColumn_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) moveTableColumn_setPrototypeOf(subClass, superClass); }
function moveTableColumn_setPrototypeOf(o, p) { moveTableColumn_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return moveTableColumn_setPrototypeOf(o, p); }
function moveTableColumn_createSuper(Derived) { var hasNativeReflectConstruct = moveTableColumn_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = moveTableColumn_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = moveTableColumn_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return moveTableColumn_possibleConstructorReturn(this, result); }; }
function moveTableColumn_possibleConstructorReturn(self, call) { if (call && (moveTableColumn_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return moveTableColumn_assertThisInitialized(self); }
function moveTableColumn_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function moveTableColumn_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function moveTableColumn_getPrototypeOf(o) { moveTableColumn_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return moveTableColumn_getPrototypeOf(o); }

var MoveTableColumnAction = /*#__PURE__*/function (_Action) {
  moveTableColumn_inherits(MoveTableColumnAction, _Action);
  var _super = moveTableColumn_createSuper(MoveTableColumnAction);
  function MoveTableColumnAction(type, params, editor) {
    moveTableColumn_classCallCheck(this, MoveTableColumnAction);
    type = type || MoveTableColumnAction.type;
    return _super.call(this, type, params, editor);
  }
  return MoveTableColumnAction;
}(Action);

MoveTableColumnAction.type = 'move-table-column';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/tableColumnComponent.js
function tableColumnComponent_extends() { tableColumnComponent_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tableColumnComponent_extends.apply(this, arguments); }
function tableColumnComponent_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
















function tableColumnComponent_slicedToArray(arr, i) { return tableColumnComponent_arrayWithHoles(arr) || tableColumnComponent_iterableToArrayLimit(arr, i) || tableColumnComponent_unsupportedIterableToArray(arr, i) || tableColumnComponent_nonIterableRest(); }
function tableColumnComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tableColumnComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tableColumnComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tableColumnComponent_arrayLikeToArray(o, minLen); }
function tableColumnComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function tableColumnComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function tableColumnComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }














var tableColumnComponent_isEnter = (0,lib/* default */.ZP)('enter');
var isShiftEnter = (0,lib/* default */.ZP)('shift+enter');
var isCtrlAKey = (0,lib/* default */.ZP)('mod+a');
var tableColumnComponent_isEsc = (0,lib/* default */.ZP)('esc');

// пользователь должен сдвинуть мышку на 5 пикселей после нажатия чтобы запустить процесс перемещения блотов
var DRAGGING_TRIGGER_DISTANCE = 5;

/**
 * Хедер колонки
 * @param { object } pos: позиция колонки {col}
 */
function TableColumnComponent(_ref) {
  var _typeData$limit;
  var pos = _ref.pos;
  var _useState = (0,hooks_module/* useState */.eJ)({
      ver: 0
    }),
    _useState2 = tableColumnComponent_slicedToArray(_useState, 2),
    update = _useState2[0],
    setUpdate = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(false),
    _useState4 = tableColumnComponent_slicedToArray(_useState3, 2),
    editing = _useState4[0],
    setEdit = _useState4[1];
  var _useState5 = (0,hooks_module/* useState */.eJ)(false),
    _useState6 = tableColumnComponent_slicedToArray(_useState5, 2),
    selected = _useState6[0],
    setSelected = _useState6[1];
  var _useState7 = (0,hooks_module/* useState */.eJ)({}),
    _useState8 = tableColumnComponent_slicedToArray(_useState7, 2),
    overwrite = _useState8[0],
    setOverwrite = _useState8[1];
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    data = _useContext.data,
    i18n = _useContext.i18n,
    editor = _useContext.editor,
    editable = _useContext.editable,
    setProp = _useContext.setProp,
    useRefs = _useContext.useRefs,
    useMenu = _useContext.useMenu,
    useResize = _useContext.useResize,
    useSelection = _useContext.useSelection,
    tableExec = _useContext.tableExec,
    onTableAction = _useContext.onTableAction,
    useFilter = _useContext.useFilter,
    globalConfig = _useContext.globalConfig;
  var colData = data.colsData[pos.col] || {};
  var typeData = getTypeData(colData.columnType);
  var colFormat = Object.assign({}, typeData.format || {}, colData.format || {});
  var _window = (0,util/* getWindow */.Jj)();
  (0,hooks_module/* useEffect */.d4)(function () {
    if (editing) {
      (0,dom/* contenteditableCursorToEnd */.FU)(editRef.current);
      _window.addEventListener('mousedown', onBodyMouseDown);
    } else {
      _window.removeEventListener('mousedown', onBodyMouseDown);
    }
    return function () {
      return _window.removeEventListener('mousedown', onBodyMouseDown);
    };
  }, [editing]);
  var _setProp = function _setProp(key, value) {
    if (CONFIG.col.props[key] === value) {
      value = null;
    }
    if (colData[key] !== value) {
      setProp(key, value, {
        pos: pos,
        type: 'col'
      });
    }
  };
  var colProps = CONFIG.col.attrs.reduce(function (props, attr) {
    var _ref2, _colData$attr;
    var val = (_ref2 = (_colData$attr = colData[attr]) !== null && _colData$attr !== void 0 ? _colData$attr : CONFIG.col.props[attr]) !== null && _ref2 !== void 0 ? _ref2 : null;
    if (val !== null) {
      props[attr] = val;
    }
    return props;
  }, {});
  if ((_typeData$limit = typeData.limit) !== null && _typeData$limit !== void 0 && _typeData$limit.minWidth) {
    colProps.width = Math.max(colProps.width, typeData.limit.minWidth);
  }
  for (var attr in overwrite) {
    if (overwrite[attr] === colProps[attr]) {
      delete overwrite[attr];
      setOverwrite(overwrite);
    } else {
      colProps[attr] = overwrite[attr];
    }
  }
  var colRef = (0,hooks_module/* useRef */.sO)(null);
  var editRef = (0,hooks_module/* useRef */.sO)(null);
  var titleRef = (0,hooks_module/* useRef */.sO)(null);
  var menuButtonRef = (0,hooks_module/* useRef */.sO)(null);

  /**
   * Ресайз колонки
   * @param {event} event: событие
   * @param {object} options?
   * @param {boolean} options.save?: сохранить значение в map
   */
  var onResize = function onResize(event) {
    var _typeData$limit2;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var rect = colRef.current.getBoundingClientRect();
    var width = Math.min(Math.max(Math.round(event.clientX - rect.left), ((_typeData$limit2 = typeData.limit) === null || _typeData$limit2 === void 0 ? void 0 : _typeData$limit2.minWidth) || CONFIG.col.limit.minWidth));
    setOverwrite(Object.assign({}, {
      width: width
    }));
    if (options.save) {
      _setProp('width', width);
    }
  };
  var onMoveDraggingDrag = function onMoveDraggingDrag(node, event) {
    var _useSelection$selecti = useSelection.selection,
      start = _useSelection$selecti.start,
      last = _useSelection$selecti.last;
    if (!node || !start || !last) {
      return onMoveDruggingClear();
    }
    var nodeRect = node.getBoundingClientRect();
    var position = event.clientX - nodeRect.left > nodeRect.width / 2 ? 'after' : 'before';
    var index = parseInt(node.getAttribute(CONFIG.col.indexAttr));
    // не даем перемещать в ту же позицию в которой сейчас находятся элементы
    if (isNaN(index) || index >= start.col && index <= last.col || index === start.col - 1 && position === 'after' || index === last.col + 1 && position === 'before') {
      return onMoveDruggingClear();
    }
    var highlight = useRefs.links.ui['moving-highlight'];
    var currentState = highlight === null || highlight === void 0 ? void 0 : highlight.sharedState;
    if (!currentState || currentState.index !== index || currentState.position !== position) {
      var _useRefs$links$col$, _useRefs$links$col$$g;
      highlight.setSharedState({
        index: index,
        position: position,
        type: 'col',
        highlightXOffset: ((_useRefs$links$col$ = useRefs.links.col[0]) === null || _useRefs$links$col$ === void 0 ? void 0 : (_useRefs$links$col$$g = _useRefs$links$col$.getNode) === null || _useRefs$links$col$$g === void 0 ? void 0 : _useRefs$links$col$$g.call(_useRefs$links$col$).offsetLeft) || 41
      });
    }
  };
  var onMoveDraggingEnd = function onMoveDraggingEnd() {
    var _useSelection$selecti2 = useSelection.selection,
      start = _useSelection$selecti2.start,
      last = _useSelection$selecti2.last;
    var highlight = useRefs.links.ui['moving-highlight'];
    var currentState = highlight === null || highlight === void 0 ? void 0 : highlight.sharedState;
    if ((currentState === null || currentState === void 0 ? void 0 : currentState.type) === 'col' && start && last) {
      onTableAction(new MoveTableColumnAction(MoveTableColumnAction.type, {
        start: start,
        last: last,
        index: currentState.position === 'before' ? currentState.index : currentState.index + 1
      }, editor));
    }
    onMoveDruggingClear();
  };
  var onMoveDruggingClear = function onMoveDruggingClear() {
    var highlight = useRefs.links.ui['moving-highlight'];
    highlight.setSharedState(false);
    return true;
  };
  var onDraggingStart = function onDraggingStart() {
    var moveDragging = new Dragging({
      selector: ".".concat(CONFIG.col.className),
      ignore: "[".concat(CONFIG.col.indexAttr, "=\"").concat(pos.col, "\"]"),
      unchange: '.vertical-move-highlight'
    });
    moveDragging.on('drag', onMoveDraggingDrag);
    moveDragging.on('end', onMoveDraggingEnd);
    moveDragging.start();
  };
  var rename = function rename() {
    if (editable) {
      setEdit(true);
    }
  };
  var getNode = function getNode() {
    return colRef === null || colRef === void 0 ? void 0 : colRef.current;
  };

  /**
   * Событие, вызываемое при изменении ячейки колонки
   * @param {object} pos: {row, col}
   */
  var onCellChange = function onCellChange(pos) {
    if (colData.sortby) {
      tableExec('renew-sort-order', {
        animate: pos
      });
    }
  };

  /**
   * Метод позволяет обновить колонку без обновления таблицы
   * @param {object} options?
   * @param {boolean} options.withSummary?: вызывать обновление summary после обновления колонки
   */
  var renderCol = function renderCol() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    setUpdate({
      ver: update.ver + 1,
      withSummary: options.withSummary ? true : false
    });
  };
  (0,hooks_module/* useEffect */.d4)(function () {
    if (update.withSummary) {
      var _useRefs$links$summar;
      (_useRefs$links$summar = useRefs.links.summary[pos.col]) === null || _useRefs$links$summar === void 0 ? void 0 : _useRefs$links$summar.render();
    }
  }, [update]);
  useRefs.setCol(pos, {
    colData: colData,
    colFormat: colFormat,
    setSelected: setSelected.bind(this),
    onCellChange: onCellChange.bind(this),
    onResize: onResize.bind(this),
    rename: rename.bind(this),
    getNode: getNode.bind(this),
    render: renderCol.bind(this)
  });
  var saveTitle = function saveTitle(event) {
    if (editing) {
      var _editRef$current;
      _setProp('text', ((_editRef$current = editRef.current) === null || _editRef$current === void 0 ? void 0 : _editRef$current.innerText) || null);
      setEdit(false);
      titleRef.current.scrollLeft = 0;
    }
  };
  var onBodyMouseDown = function onBodyMouseDown(event) {
    if (editing && !colRef.current.contains(event.target)) {
      saveTitle();
    }
  };
  var stopPropagation = function stopPropagation(event) {
    event.stopPropagation();
  };
  var onBlur = function onBlur(event) {
    var innerText = titleRef ? titleRef.innerText : colData.text;
    if (!innerText) {
      var storedCol = editor.store.blocks.get(colData.id);
      if (storedCol && typeof storedCol !== 'undefined') {
        storedCol.set('text', '');
      } else {
        console.warn('Failed to clear column header in table storage, column data: ', colData);
      }
      colData.text = ''; // для того, чтобы ячейка корректно перерисовалась
      renderCol();
    }
    setEdit(false);
  };
  var onKeyUp = function onKeyUp(event) {
    // innterText сохраняется в titleRef вместо использования useState по двум причинам:
    // 1. при установке стейта после onKeyUp курсор втает не правильно
    // 2. для того чтобы не выносить переменную innerText вне компонента
    titleRef.innerText = event.target.innerText;
  };
  var onKeyDown = function onKeyDown(event) {
    if (editing) {
      event.stopPropagation();
      event[ABORT_KEYBOARD_PROCESSING_SIGN] = true;
      if (tableColumnComponent_isEnter(event) || isShiftEnter(event)) {
        saveTitle(event);
      } else if (tableColumnComponent_isEsc(event)) {
        setEdit(false);
      } else if (isCtrlAKey(event)) {
        event.preventDefault();
        var selection = getSelection();
        var range = new Range();
        range.selectNodeContents(editRef.current);
        selection.removeAllRanges();
        selection.addRange(range);
      }
      return true;
    }
  };
  var onMouseDown = function onMouseDown(event) {
    var _selection$start, _selection$last;
    var selection = useSelection.selection;
    var resize = false;
    var isModKey = (event === null || event === void 0 ? void 0 : event.metaKey) || (event === null || event === void 0 ? void 0 : event.ctrlKey);
    var isShiftKey = (event === null || event === void 0 ? void 0 : event.metaKey) || (event === null || event === void 0 ? void 0 : event.ctrlKey) || (event === null || event === void 0 ? void 0 : event.shiftKey);
    var onlyThisSelected = ((_selection$start = selection.start) === null || _selection$start === void 0 ? void 0 : _selection$start.col) === pos.col && ((_selection$last = selection.last) === null || _selection$last === void 0 ? void 0 : _selection$last.col) === pos.col;
    if (event.target === (colRef === null || colRef === void 0 ? void 0 : colRef.current)) {
      var rect = colRef.current.getBoundingClientRect();
      var right = Math.abs(rect.width - event.offsetX);
      if (right <= CONFIG.resize.offset) {
        resize = true;
      }
    }
    if (resize) {
      useResize.sessionStart('col', pos);
    } else if (isModKey && onlyThisSelected) {
      useSelection.unselectAll();
    } else if (isModKey || isShiftKey) {
      useSelection.setSelection(pos, {
        force: true
      });
    } else {
      if (!selected) {
        useSelection.setCurrent(pos, {
          session: false
        });
      }
      if (editable) {
        onMouseDownWaitDragging({
          x: event.clientX,
          y: event.clientY
        }, DRAGGING_TRIGGER_DISTANCE, onDraggingStart, onMenuButton);
      }
    }
  };
  var onMouseEnter = function onMouseEnter(event) {
    useSelection.setSelection(pos);
  };
  var onContextMenu = function onContextMenu(event) {
    if (globalConfig.enableMenu !== false) {
      event.preventDefault();
      useMenu.toggleMenu(event, 'col');
    }
  };
  var onMenuButton = function onMenuButton(event) {
    if (menuButtonRef.current && (event.target === menuButtonRef.current.base || menuButtonRef.current.base.contains(event.target))) {
      useMenu.toggleMenu(event, 'col');
    }
  };
  var onDoubleClick = function onDoubleClick(event) {
    event.preventDefault();
    rename();
  };
  var onSortableMouseDown = function onSortableMouseDown(event) {
    event.preventDefault();
    event.stopPropagation();
    if (editable) {
      tableExec('sort-table-column', {
        pos: pos,
        order: colData.sortby === 'desc' ? 'asc' : 'desc'
      });
    }
  };
  var onFilterMouseDown = function onFilterMouseDown(event) {
    event.preventDefault();
    event.stopPropagation();
    useFilter.toggleFilter(false, {
      anchorCol: pos.col
    });
  };
  var listeners = {};
  if (editable) {
    listeners = {
      onMouseDown: onMouseDown,
      onMouseEnter: onMouseEnter,
      onDoubleClick: onDoubleClick,
      onContextMenu: onContextMenu
    };
  }

  // Для ellipsis, но можо попробовать обойти в css
  var titleStyle = {
    'max-width': colProps.width - 44 + 'px'
  };
  var attrs = tableColumnComponent_defineProperty({}, CONFIG.col.indexAttr, pos.col);
  var classes = [CONFIG.col.className];
  if (selected) {
    classes.push('selected');
  }
  var title,
    titleAttrs = [],
    editNode;
  if (colData.text) {
    title = colData.text;
    titleAttrs[tooltipManager/* TOOLTIP_ATTR */.qZ] = colData.text;
  } else {
    title = [];
    var num = pos.col || 0;
    do {
      title.unshift((10 + num % 26).toString(36).toUpperCase());
      num = Math.trunc(num / 26) - 1;
    } while (num > -1);
    title = title.join('');
  }
  if (editing) {
    classes.push('edit');
    editNode = (0,preact_module.h)("div", {
      className: "table-head-item-edit",
      ref: editRef,
      contenteditable: "true",
      onKeyDown: onKeyDown,
      onKeyUp: onKeyUp,
      onPaste: stopPropagation,
      onCopy: stopPropagation,
      onCut: stopPropagation,
      onBlur: onBlur,
      style: titleStyle
    }, colData.text);
  }
  var hasFilter = !Boolean(data.props['filter-disabled']) && data.props.filter && Array.isArray(data.props.filter.filters) && data.props.filter.filters.some(function (filter) {
    return filter.colId === colData.id;
  });
  var TypeIcon, SortIcon, FilterIcon;
  if (colData.sortby || hasFilter) {
    if (colData.sortby) {
      var tooltip = tableColumnComponent_defineProperty({}, tooltipManager/* TOOLTIP_ATTR */.qZ, i18n.get("table.sorting.".concat(colData.sortby, ".common")));
      if (!selected) {
        tooltip[tooltipManager/* TOOLTIP_ATTR */.qZ] += ' / ' + i18n.get('table.sorting.change');
      }
      classes.push('sorting', 'sorting-' + colData.sortby);
      SortIcon = (0,preact_module.h)("div", tableColumnComponent_extends({
        className: "col-sorting-icon col-sorting-icon-" + colData.sortby,
        onMouseDown: onSortableMouseDown
      }, tooltip), colData.sortby == 'asc' ? (0,preact_module.h)(icons/* SortAsc */.HzO, null) : (0,preact_module.h)(icons/* SortDesc */.tXd, null));
    }
    if (hasFilter) {
      var filterTooltip = tableColumnComponent_defineProperty({}, tooltipManager/* TOOLTIP_ATTR */.qZ, i18n.get("table.filter.by_field"));
      classes.push('with-filter');
      FilterIcon = (0,preact_module.h)("div", tableColumnComponent_extends({
        className: "col-filter-icon",
        onMouseDown: onFilterMouseDown
      }, filterTooltip), (0,preact_module.h)(icons/* IconFilter */.wHY, null));
    }
  } else if (colData.columnType) {
    if (typeData.icon) {
      var iconClasses = ['icon', 'col-icon-' + colData.columnType];
      TypeIcon = (0,preact_module.h)("div", {
        className: iconClasses.join(' ')
      }, (0,preact_module.h)(typeData.icon, null));
    }
  }
  return (0,preact_module.h)("th", tableColumnComponent_extends({
    ref: colRef,
    className: classes.join(' ')
  }, attrs, colProps, listeners), (0,preact_module.h)("div", {
    className: "item-ui"
  }, SortIcon || FilterIcon ? (0,preact_module.h)(preact_module/* Fragment */.HY, null, FilterIcon, SortIcon) : TypeIcon, (0,preact_module.h)("div", tableColumnComponent_extends({
    ref: titleRef,
    className: "item-title",
    style: titleStyle
  }, titleAttrs), title), editNode), globalConfig.enableMenu !== false && (0,preact_module.h)(TableMenuButtonCol, {
    ref: menuButtonRef
  }));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/tableUIAddButtons.js




function TableUIAddRow() {
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    editor = _useContext.editor,
    tableExec = _useContext.tableExec;
  var buttonRef = (0,hooks_module/* useRef */.sO)(null);
  var onMouseDown = function onMouseDown(event) {
    tableExec('add-row');
    editor.plugins.selectionScroller.ensureNodeVisible(buttonRef.current);
  };
  return (0,preact_module.h)("div", {
    ref: buttonRef,
    className: "add-row-btn",
    onMouseDown: onMouseDown
  }, (0,preact_module.h)(icons/* IconAddRow */.cpC, null));
}
function TableUIAddCol() {
  var _useContext2 = (0,hooks_module/* useContext */.qp)(TableContext),
    useRefs = _useContext2.useRefs,
    tableExec = _useContext2.tableExec;
  var onMouseDown = function onMouseDown(event) {
    var _useRefs$links$ui$scr;
    tableExec('add-col');
    (_useRefs$links$ui$scr = useRefs.links.ui.scroll) === null || _useRefs$links$ui$scr === void 0 ? void 0 : _useRefs$links$ui$scr.scrollTo('right');
  };
  return (0,preact_module.h)("div", {
    className: "add-col-btn",
    onMouseDown: onMouseDown
  }, (0,preact_module.h)(icons/* IconAddColumn */.InV, null));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/tableHeadComponent.js











function tableHeadComponent_slicedToArray(arr, i) { return tableHeadComponent_arrayWithHoles(arr) || tableHeadComponent_iterableToArrayLimit(arr, i) || tableHeadComponent_unsupportedIterableToArray(arr, i) || tableHeadComponent_nonIterableRest(); }
function tableHeadComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tableHeadComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tableHeadComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tableHeadComponent_arrayLikeToArray(o, minLen); }
function tableHeadComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function tableHeadComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function tableHeadComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }






/**
 * Шапка таблицы с заголовками колонок
 * @param {object} param0
 * @returns
 */
function TableHeadComponent() {
  var _useState = (0,hooks_module/* useState */.eJ)(false),
    _useState2 = tableHeadComponent_slicedToArray(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    data = _useContext.data,
    editable = _useContext.editable,
    useRefs = _useContext.useRefs,
    useSelection = _useContext.useSelection;
  var circleRef = (0,hooks_module/* useRef */.sO)(null);
  var getNode = function getNode() {
    return circleRef === null || circleRef === void 0 ? void 0 : circleRef.current;
  };
  useRefs.setUI('circle', {
    getNode: getNode.bind(this),
    setSelected: setSelected.bind(this)
  });
  var cols = [];
  for (var col = 0; col < data.size.cols; col++) {
    cols.push((0,preact_module.h)(TableColumnComponent, {
      pos: {
        col: col
      }
    }));
  }
  var onMouseDown = function onMouseDown(event) {
    if (selected) {
      useSelection.unselectAll();
    } else {
      useSelection.setCurrent({
        col: 0,
        row: 0
      });
      useSelection.selectAll();
    }
  };
  var addCol;
  if (editable) {
    addCol = (0,preact_module.h)("div", {
      className: "add-col"
    }, (0,preact_module.h)(TableUIAddCol, null));
  } else {
    //addCol = <div/>
  }
  var classes = ['table-head-start'];
  if (selected) {
    classes.push('selected');
  }
  return (0,preact_module.h)("thead", null, (0,preact_module.h)("tr", null, (0,preact_module.h)("th", {
    className: classes.join(' '),
    onMouseDown: onMouseDown,
    ref: circleRef
  }, (0,preact_module.h)("div", {
    className: "table-header-circle"
  })), (0,preact_module.h)("th", null), cols), addCol);
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/tableRowHeaderComponent.js
function tableRowHeaderComponent_extends() { tableRowHeaderComponent_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tableRowHeaderComponent_extends.apply(this, arguments); }


function tableRowHeaderComponent_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





function TableRowHeaderComponent(_ref) {
  var pos = _ref.pos,
    relPos = _ref.relPos,
    selected = _ref.selected,
    onMouseDown = _ref.onMouseDown,
    onMouseEnter = _ref.onMouseEnter,
    onContextMenu = _ref.onContextMenu,
    onRef = _ref.onRef,
    rowProps = _ref.rowProps,
    onMenuButtonRef = _ref.onMenuButtonRef;
  var attrs = tableRowHeaderComponent_defineProperty({}, CONFIG.row.indexAttr, pos.row);
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    globalConfig = _useContext.globalConfig;
  var classes = [CONFIG.row.className];
  if (selected) {
    classes.push('selected');
  }
  if (pos.row >= 99) {
    classes.push('long-name');
  }
  var title = 1 + relPos;
  return (0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)("td", tableRowHeaderComponent_extends({
    className: classes.join(' '),
    height: rowProps.height,
    ref: onRef,
    onMouseDown: onMouseDown,
    onMouseEnter: onMouseEnter,
    onContextMenu: onContextMenu
  }, attrs), (0,preact_module.h)("div", {
    className: "item-ui"
  }, (0,preact_module.h)("div", {
    className: "item-title"
  }, title, globalConfig.enableMenu !== false && (0,preact_module.h)(TableMenuButtonRow, {
    ref: onMenuButtonRef
  })))), (0,preact_module.h)("td", null));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/cells/tableCellTextComponent.js
function tableCellTextComponent_extends() { tableCellTextComponent_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tableCellTextComponent_extends.apply(this, arguments); }
function tableCellTextComponent_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { tableCellTextComponent_typeof = function _typeof(obj) { return typeof obj; }; } else { tableCellTextComponent_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return tableCellTextComponent_typeof(obj); }
















function tableCellTextComponent_slicedToArray(arr, i) { return tableCellTextComponent_arrayWithHoles(arr) || tableCellTextComponent_iterableToArrayLimit(arr, i) || tableCellTextComponent_unsupportedIterableToArray(arr, i) || tableCellTextComponent_nonIterableRest(); }
function tableCellTextComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tableCellTextComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tableCellTextComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tableCellTextComponent_arrayLikeToArray(o, minLen); }
function tableCellTextComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function tableCellTextComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function tableCellTextComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }






/**
 * Тип ячейки текст
 * @param { object } pos: {row, col}
 * @param { object } cellData: данные ячейки
 * @param { object } cellProps: стиль ячейки
 * @param { object } rowProps: стиль строки
 * @param { boolean } editing: статус  режима редактирования
 * @param { function } setEditing: установить статус редактировани
 */
function TableCellTextComponent(_ref) {
  var _this = this,
    _childData$characters;
  var pos = _ref.pos,
    cellRef = _ref.cellRef,
    rowProps = _ref.rowProps,
    cellProps = _ref.cellProps,
    cellData = _ref.cellData,
    childStyle = _ref.childStyle,
    editing = _ref.editing,
    setEditing = _ref.setEditing;
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    data = _useContext.data,
    editor = _useContext.editor,
    editable = _useContext.editable,
    startEdit = _useContext.startEdit,
    useRefs = _useContext.useRefs,
    useUtils = _useContext.useUtils,
    applyDelta = _useContext.applyDelta;
  var _useState = (0,hooks_module/* useState */.eJ)(false),
    _useState2 = tableCellTextComponent_slicedToArray(_useState, 2),
    characters = _useState2[0],
    setCharacters = _useState2[1];
  if (characters) {
    cellData.child = Object.assign({}, cellData.child, characters);
  }

  // Во время редактирования заполняем ячейку значением из блота
  // Это нужно для установки ее размеров и размеров таблицы
  var onInput = function onInput(characters) {
    if (characters !== null && characters !== void 0 && characters.toDelta) {
      setCharacters({
        delta: characters.toDelta(),
        characters: characters.toString()
      });
    }
  };
  var endEdit = function endEdit() {
    var _useRefs$links$col$po;
    setEditing(false);
    setCharacters(false);
    (_useRefs$links$col$po = useRefs.links.col[pos.col]) === null || _useRefs$links$col$po === void 0 ? void 0 : _useRefs$links$col$po.onCellChange(pos);
  };
  var editCell = function editCell(event) {
    if (editable && !editing && startEdit) {
      var _useRefs$links$col$po2, _useRefs$links$col$po3, _useRefs$links$col$po4, _useRefs$links$col$po5, _useRefs$links$ui$scr;
      var coords = data.settings.wrapCell ? false : useUtils.expandCoords(pos);
      var format = ((_useRefs$links$col$po2 = useRefs.links.col[pos.col]) === null || _useRefs$links$col$po2 === void 0 ? void 0 : (_useRefs$links$col$po3 = _useRefs$links$col$po2.colData) === null || _useRefs$links$col$po3 === void 0 ? void 0 : _useRefs$links$col$po3.style) || {};
      var align = ((_useRefs$links$col$po4 = useRefs.links.col[pos.col]) === null || _useRefs$links$col$po4 === void 0 ? void 0 : (_useRefs$links$col$po5 = _useRefs$links$col$po4.colData) === null || _useRefs$links$col$po5 === void 0 ? void 0 : _useRefs$links$col$po5.align) || undefined;
      startEdit({
        type: "text",
        pos: pos,
        event: event,
        coords: coords,
        cellData: cellData,
        node: cellRef.current,
        scrollNode: (_useRefs$links$ui$scr = useRefs.links.ui.scroll) === null || _useRefs$links$ui$scr === void 0 ? void 0 : _useRefs$links$ui$scr.getNode(),
        rowHeight: rowProps === null || rowProps === void 0 ? void 0 : rowProps.height,
        onInput: onInput.bind(_this),
        endEdit: endEdit.bind(_this),
        style: Object.assign({}, childStyle, cellProps),
        nowrap: data.settings.wrapCells === false,
        textFormat: format,
        textAlign: align
      });
      setEditing(true);
    }
    return true;
  };
  var childData = cellData.child;

  // Поддержка меншинов в текстовых ячейках из V1
  var mentions = [];
  if (childData !== null && childData !== void 0 && childData.delta) {
    for (var i in childData.delta) {
      var op = childData.delta[i];
      if (op && tableCellTextComponent_typeof(op.insert) === 'object' && op.insert.mention) {
        mentions.push(op.insert.mention);
      }
    }
  }
  var onMentionOpen = function onMentionOpen(event) {
    var _event$target, _event$target$getAttr;
    var mentionManager = editor.plugins.mentionManager;
    var mentionId = (event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : (_event$target$getAttr = _event$target.getAttribute) === null || _event$target$getAttr === void 0 ? void 0 : _event$target$getAttr.call(_event$target, 'data-mention-id')) || false;
    for (var _i2 in mentions) {
      if (!mentionId || mentionId === mentions[_i2].id) {
        if (mentions[_i2].type !== 'user') {
          mentionManager.onMentionClick(mentions[_i2].type, mentions[_i2].object_id);
        }
        break;
      }
    }
  };
  var getLinkOpParams = function getLinkOpParams(linkNode) {
    if (childData !== null && childData !== void 0 && childData.delta) {
      var beforeLinkOps = [];
      var linkOp = [];
      for (var _i3 in childData.delta) {
        var _op = childData.delta[_i3];
        if (_op) {
          if (_op.insert && _op.attributes && _op.attributes.link && _op.insert.trim() === linkNode.innerText.trim() && _op.attributes.link === linkNode.getAttribute('href')) {
            linkOp.push(_op);
            break;
          } else {
            beforeLinkOps.push(_op);
          }
        }
      }
      var attributes = Object.keys(linkOp[0].attributes).reduce(function (attrs, format) {
        if (format !== 'link') {
          attrs[format] = linkOp[0].attributes[format];
        }
        return attrs;
      }, {});
      return {
        index: new (Delta_default())(beforeLinkOps).length(),
        length: new (Delta_default())(linkOp).length(),
        attributes: attributes
      };
    }
    return {};
  };
  var onLinkChangeText = function onLinkChangeText(linkNode, text) {
    if (linkNode.innerText !== text) {
      var _cellData$child;
      var _getLinkOpParams = getLinkOpParams(linkNode),
        index = _getLinkOpParams.index,
        length = _getLinkOpParams.length,
        attributes = _getLinkOpParams.attributes;
      if ((_cellData$child = cellData.child) !== null && _cellData$child !== void 0 && _cellData$child.delta && typeof index === 'number' && typeof length === 'number') {
        var newDelta = new (Delta_default())(cellData.child.delta).compose(new (Delta_default())().retain(index).delete(length).insert(text, Object.assign({
          link: linkNode.getAttribute('href')
        }, attributes)));
        updateLink(newDelta);
      }
    }
  };
  var onLinkChangeUrl = function onLinkChangeUrl(linkNode, url) {
    if (linkNode.getAttribute('href') !== url) {
      var _cellData$child2;
      var _getLinkOpParams2 = getLinkOpParams(linkNode),
        index = _getLinkOpParams2.index,
        length = _getLinkOpParams2.length,
        attributes = _getLinkOpParams2.attributes;
      if ((_cellData$child2 = cellData.child) !== null && _cellData$child2 !== void 0 && _cellData$child2.delta && typeof index === 'number' && typeof length === 'number') {
        var newDelta = new (Delta_default())(cellData.child.delta).compose(new (Delta_default())().retain(index).delete(length).insert(linkNode.innerText, Object.assign({
          link: url
        }, attributes)));
        updateLink(newDelta);
      }
    }
  };
  var onLinkDelete = function onLinkDelete(linkNode) {
    var _cellData$child3;
    var _getLinkOpParams3 = getLinkOpParams(linkNode),
      index = _getLinkOpParams3.index,
      length = _getLinkOpParams3.length,
      attributes = _getLinkOpParams3.attributes;
    if ((_cellData$child3 = cellData.child) !== null && _cellData$child3 !== void 0 && _cellData$child3.delta && typeof index === 'number' && typeof length === 'number') {
      var newDelta = new (Delta_default())(cellData.child.delta).compose(new (Delta_default())().retain(index).delete(length).insert(linkNode.innerText, attributes));
      updateLink(newDelta);
    }
  };
  var updateLink = function updateLink(delta) {
    var _useRefs$links$col$po6;
    applyDelta(delta, {
      pos: pos,
      replace: true
    });
    (_useRefs$links$col$po6 = useRefs.links.col[pos.col]) === null || _useRefs$links$col$po6 === void 0 ? void 0 : _useRefs$links$col$po6.onCellChange(pos);
  };
  var onLinkClick = function onLinkClick(event) {
    event === null || event === void 0 ? void 0 : event.preventDefault();
    event === null || event === void 0 ? void 0 : event.stopPropagation();
    var link = event.target && event.target.closest('a');
    if (!editing && link) {
      editor.emitter.emit('click-link', {
        domNode: link,
        changeText: onLinkChangeText.bind(undefined, link),
        changeUrl: onLinkChangeUrl.bind(undefined, link),
        onEmpty: onLinkDelete.bind(undefined, link),
        withoutRange: true
      });
    }
  };
  var value = childData === null || childData === void 0 ? void 0 : (_childData$characters = childData.characters) === null || _childData$characters === void 0 ? void 0 : _childData$characters.toString();
  var empty = (!value || value === '\n' && (childData === null || childData === void 0 ? void 0 : childData.delta)) && !mentions.length;
  useRefs.addToCell(pos, {
    empty: empty,
    value: value,
    editCell: editCell.bind(this)
  });
  var classes = ['table-text-common'];
  var child = null,
    text;
  if (!empty && childData) {
    if (childData.delta && (childData.delta.length > 1 || childData.delta[0].hasOwnProperty('attributes') || mentions.length)) {
      var deltaProps = {};
      if (mentions.length) {
        deltaProps.mentionProps = {
          onClick: onMentionOpen
        };
      }
      deltaProps.linkProps = {
        onClick: onLinkClick
      };
      text = (0,preact_module.h)(DeltaComponent, tableCellTextComponent_extends({
        delta: childData.delta,
        editor: editor
      }, deltaProps));
    } else {
      text = childData.characters;
    }
  }
  if (text) {
    child = (0,preact_module.h)("div", {
      className: classes.join(' '),
      style: childStyle
    }, text);
  }
  return child;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.to-fixed.js
var es_number_to_fixed = __webpack_require__(56977);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/cells/tableCellNumberComponent.js



















function tableCellNumberComponent_slicedToArray(arr, i) { return tableCellNumberComponent_arrayWithHoles(arr) || tableCellNumberComponent_iterableToArrayLimit(arr, i) || tableCellNumberComponent_unsupportedIterableToArray(arr, i) || tableCellNumberComponent_nonIterableRest(); }
function tableCellNumberComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tableCellNumberComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tableCellNumberComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tableCellNumberComponent_arrayLikeToArray(o, minLen); }
function tableCellNumberComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function tableCellNumberComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function tableCellNumberComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




var ALLOW_BIGINT = true;
var SEPARATOR = {
  'comma': ',',
  'point': '.'
};

/**
 * Тип ячейки числа и валюта
 * @param { object } pos: {row, col}
 * @param { string } cellType: тип ячейки, number, currency
 * @param { object } cellData: данные ячейки
 * @param { object } cellProps: стиль ячейки
 * @param { object } rowProps: стиль строки
 * @param { object } cellRef: ref ячейки
 * @param { object } parents:
 * @param { object } parents.colData: данные колонки
 */
function TableCellNumberComponent(_ref) {
  var _this = this,
    _cellData$child,
    _cellData$child$chara;
  var pos = _ref.pos,
    cellType = _ref.cellType,
    cellRef = _ref.cellRef,
    rowProps = _ref.rowProps,
    cellProps = _ref.cellProps,
    cellData = _ref.cellData,
    childStyle = _ref.childStyle,
    parents = _ref.parents,
    editing = _ref.editing,
    setEditing = _ref.setEditing;
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    data = _useContext.data,
    editable = _useContext.editable,
    startEdit = _useContext.startEdit,
    useRefs = _useContext.useRefs,
    useUtils = _useContext.useUtils;
  var _useState = (0,hooks_module/* useState */.eJ)(false),
    _useState2 = tableCellNumberComponent_slicedToArray(_useState, 2),
    characters = _useState2[0],
    setCharacters = _useState2[1];
  var typeData = getTypeData(cellType);
  var format = Object.assign({}, typeData.format, parents.colData.format || {}, cellData.format || {});
  var decimalSeparator = format.decimal_separator && SEPARATOR[format.decimal_separator];
  var orderSeparator = format.type !== 'commas' ? false : decimalSeparator === ',' ? '.' : ',';
  var colorNumbers = format.colorNumbers;
  var symbolBefore = false,
    symbolAfter = false;
  if (format.type === 'percent') {
    symbolAfter = '%';
  } else if (format.currency) {
    var symbol;
    if (format.currency === 'other') {
      symbol = format.otherCurrency;
    } else {
      symbol = CURRENCY[format.currency];
    }
    if (format.stick === 'before') {
      symbolBefore = symbol;
    } else {
      symbolAfter = symbol;
    }
  }
  var numberFormat = {
    symbolAfter: symbolAfter,
    symbolBefore: symbolBefore,
    orderSeparator: orderSeparator,
    decimalSeparator: decimalSeparator,
    decimals: format.decimals || false,
    colorNumbers: typeof colorNumbers !== 'undefined' ? colorNumbers : false
  };
  if (characters) {
    cellData.child = Object.assign({}, cellData.child, characters);
  }
  var onInput = function onInput(characters) {
    if (characters !== null && characters !== void 0 && characters.toDelta) {
      setCharacters({
        delta: characters.toDelta(),
        characters: characters.toString()
      });
    }
  };
  var endEdit = function endEdit() {
    var _useRefs$links$col$po;
    setEditing(false);
    setCharacters(false);
    (_useRefs$links$col$po = useRefs.links.col[pos.col]) === null || _useRefs$links$col$po === void 0 ? void 0 : _useRefs$links$col$po.onCellChange(pos);
  };
  var editCell = function editCell(event) {
    if (editable && !editing && startEdit) {
      var _useRefs$links$col$po2, _useRefs$links$col$po3, _useRefs$links$ui$scr;
      var coords = data.settings.wrapCell ? false : useUtils.expandCoords(pos);
      var align = ((_useRefs$links$col$po2 = useRefs.links.col[pos.col]) === null || _useRefs$links$col$po2 === void 0 ? void 0 : (_useRefs$links$col$po3 = _useRefs$links$col$po2.colData) === null || _useRefs$links$col$po3 === void 0 ? void 0 : _useRefs$links$col$po3.align) || undefined;
      startEdit({
        type: "number",
        pos: pos,
        event: event,
        coords: coords,
        cellData: cellData,
        node: cellRef.current,
        scrollNode: (_useRefs$links$ui$scr = useRefs.links.ui.scroll) === null || _useRefs$links$ui$scr === void 0 ? void 0 : _useRefs$links$ui$scr.getNode(),
        rowHeight: rowProps === null || rowProps === void 0 ? void 0 : rowProps.height,
        onInput: onInput.bind(_this),
        endEdit: endEdit.bind(_this),
        style: Object.assign({}, childStyle, cellProps),
        nowrap: data.settings.wrapCells === false,
        format: numberFormat,
        textAlign: align
      });
      setEditing(true);
    }
    return true;
  };
  var value,
    bigint = false,
    decimal = 0;
  var chars = (_cellData$child = cellData.child) === null || _cellData$child === void 0 ? void 0 : (_cellData$child$chara = _cellData$child.characters) === null || _cellData$child$chara === void 0 ? void 0 : _cellData$child$chara.replace('\n', '').trim();
  var isMinus = chars && chars.startsWith('-');
  if (isMinus) chars = chars.replace('-', '');

  // Очищаем разделитель в characters для данных из V1, в будущем можно убрать
  if (chars && /^(\d|\.|\,|‚)*$/i.test(chars)) {
    if (chars.indexOf('‚')) {
      chars = chars.replace(/‚/g, '');
    }
    var pointChars = chars.replace(',', '.');
    value = parseFloat(pointChars);
    var expParts = value.toString().split('e-');
    if (expParts.length === 2) {
      value = decimal = value.toFixed(expParts[1]);
      if (ALLOW_BIGINT) {
        bigint = BigInt(0);
      }
    } else {
      var floatParts = pointChars.split('.');
      if (floatParts.length === 2) {
        decimal = parseFloat("0.".concat(floatParts[1]));
      }
      if (ALLOW_BIGINT) {
        bigint = BigInt(floatParts[0] || 0);
        if (isMinus) bigint = -bigint;
      }
    }
    if (isMinus) {
      if (value) {
        value = -value;
      }
      if (decimal) {
        decimal = -decimal;
      }
    }
  }
  useRefs.addToCell(pos, {
    value: value,
    bigint: bigint,
    decimal: decimal,
    empty: typeof value !== 'number',
    format: numberFormat,
    editCell: editCell.bind(this)
  });
  var child = null,
    text;
  if (typeof value === 'number') {
    text = chars;
    if (orderSeparator) {
      text = addOrderSeparator(text, orderSeparator, decimalSeparator);
    }
    if (symbolBefore) {
      text = symbolBefore + text;
    } else if (symbolAfter) {
      text = text + symbolAfter;
    }
    if (isMinus) {
      text = '-' + text;
    }
  }
  if (text) {
    var classes = ['table-text-common'];
    if (colorNumbers) {
      if (isMinus) {
        classes.push('negative-number');
      } else {
        classes.push('positive-number');
      }
    }
    child = (0,preact_module.h)("div", {
      className: classes.join(' '),
      style: childStyle
    }, text);
  }
  return child;
}
function addOrderSeparator(str) {
  var orderSeparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
  var decimalSeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!str || !orderSeparator) {
    return str;
  }
  str += '';
  var x = str.split(decimalSeparator);
  var x1 = x[0];
  var x2 = x.length > 1 ? decimalSeparator + x[1] : '';
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + orderSeparator + '$2');
  }
  return x1 + x2;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/hooks/onDocumentEsc.js



/**
 * Preact hook, выполняющий коллбек при нажатии ESC в документе
 * @param { function } handler: функция, которая будет выполнена при нажатии ESC
 * @param { boolean } disabled: отключает hook
 */
function useOnDocumentEsc(handler) {
  var disabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  (0,hooks_module/* useEffect */.d4)(function () {
    var listener;
    if (!disabled) {
      listener = function listener(event) {
        if ((0,lib/* default */.ZP)('esc', event)) {
          handler === null || handler === void 0 ? void 0 : handler(event);
        }
      };
      document.addEventListener("keydown", listener);
    }
    return function () {
      if (listener) {
        document.removeEventListener("keydown", listener);
      }
    };
  }, [handler, disabled]);
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/hooks/onOutsideMouseDown.js


/**
 * Preact hook, выполняющий коллбек при нажатии нажатии мыши вне ноды
 * @param { node } ref: Нода, полученная через useRef
 * @param { function } handler: функция, которая будет выполнена
 * @param { boolean } disabled: отключает hook
 */
function useOnOutsideMouseDown(ref, handler) {
  var disabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  (0,hooks_module/* useLayoutEffect */.bt)(function () {
    var listener;
    if (!disabled) {
      listener = function listener(event) {
        if (ref !== null && ref !== void 0 && ref.current && !ref.current.contains(event.target)) {
          handler === null || handler === void 0 ? void 0 : handler(event);
        }
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
    }
    return function () {
      if (listener) {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      }
    };
  }, [ref === null || ref === void 0 ? void 0 : ref.current, disabled]);
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/hooks/preventEditorScroll.js

/**
 * Preact hook, предотвращающий скролл редактора при создании компонента (обычно открытии всплывающего элемента)
 * @param { editor } editor
 * @param { ref } scrollRef: ref внутреннего компонента в котором разрешена прокрутка, напр. нижняя часть дропадуна с найденными элементами
 * @param { boolean } disabled: отключает hook
 */
function usePreventEditorScroll(editor, scrollRef) {
  var disabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var preventDefault = function preventDefault(event) {
    var _scrollRef$current;
    var prevent = true;
    if ((scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current) instanceof HTMLElement && typeof scrollRef.current.contains === 'function') {
      if (scrollRef.current.contains(event.target)) {
        prevent = false;
      }
    } else if ((scrollRef === null || scrollRef === void 0 ? void 0 : (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 ? void 0 : _scrollRef$current.base) instanceof HTMLElement && typeof scrollRef.current.base.contains === 'function') {
      if (scrollRef.current.base.contains(event.target)) {
        prevent = false;
      }
    }
    if (prevent) {
      event.preventDefault();
    }
  };
  (0,hooks_module/* useLayoutEffect */.bt)(function () {
    var scrollNode;
    if (!disabled) {
      scrollNode = editor.getScrollingContainer();
      if (scrollNode) {
        scrollNode.addEventListener('wheel', preventDefault);
        scrollNode.addEventListener('mousewheel', preventDefault);
      }
    }
    return function () {
      if (scrollNode) {
        scrollNode.removeEventListener('wheel', preventDefault);
        scrollNode.removeEventListener('mousewheel', preventDefault);
      }
    };
  }, [disabled]);
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/hooks/resizeObserver.js







function resizeObserver_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { resizeObserver_typeof = function _typeof(obj) { return typeof obj; }; } else { resizeObserver_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return resizeObserver_typeof(obj); }

/**
 * Preact hook, выполняющий callback при изменении изменении размера ноды переданного ref
 * @param { node } ref: Нода, полученная через useRef
 * @param { function } handler: функция, которая будет выполнена
 * @param { boolean } disabled: отключает hook
 */
function useResizeObserver(ref, handler) {
  var disabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var observerAvailable = (typeof window === "undefined" ? "undefined" : resizeObserver_typeof(window)) === 'object' && window && typeof window.ResizeObserver === 'function';
  (0,hooks_module/* useLayoutEffect */.bt)(function () {
    var resizeObserver;
    if (!disabled && observerAvailable && ref !== null && ref !== void 0 && ref.current) {
      var onResize = function onResize(entries) {
        handler === null || handler === void 0 ? void 0 : handler(entries);
      };
      resizeObserver = new window.ResizeObserver(onResize);
      resizeObserver.observe(ref.current);
    }
    return function () {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [ref === null || ref === void 0 ? void 0 : ref.current, disabled]);
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/cells/floatComponent.js
function floatComponent_extends() { floatComponent_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return floatComponent_extends.apply(this, arguments); }












function floatComponent_slicedToArray(arr, i) { return floatComponent_arrayWithHoles(arr) || floatComponent_iterableToArrayLimit(arr, i) || floatComponent_unsupportedIterableToArray(arr, i) || floatComponent_nonIterableRest(); }
function floatComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function floatComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return floatComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return floatComponent_arrayLikeToArray(o, minLen); }
function floatComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function floatComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function floatComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }







var OFFSET = {
  offsetLeft: 44,
  offsetShadow: 25,
  offsetRight: 28,
  offsetTop: 40,
  offsetBottom: 48
};

/**
 * Вспомогательный компонент для рендера всплывающих над ячейкой элементов
 * Например: редактирование даты, меню ссылки, меншина и т.д.
 * @param { object } children: потомки, preact элементы
 * @param { node } container?: нода контейнера
 * @param { object } corrective?: корректировка позиции {top, left, right}
 * @param { boolean } adjustToParent?: настраивает размер по родителю контейнера
 * @param { function } onWantsToClose: функция для закрытия всплывающего компонента
 * @param { boolean } disabled: отключает всплывающий компонент, содержимое выводится в чистом <div>
 */
function FloatComponent(_ref) {
  var children = _ref.children,
    container = _ref.container,
    adjustToParent = _ref.adjustToParent,
    onWantsToClose = _ref.onWantsToClose,
    _ref$corrective = _ref.corrective,
    corrective = _ref$corrective === void 0 ? {
      top: -1,
      left: -1,
      right: -1
    } : _ref$corrective,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    editor = _useContext.editor,
    useRefs = _useContext.useRefs;
  var _useState = (0,hooks_module/* useState */.eJ)({}),
    _useState2 = floatComponent_slicedToArray(_useState, 2),
    margin = _useState2[0],
    setMargin = _useState2[1];
  var floatRef = (0,hooks_module/* useRef */.sO)(null);
  var componentProps = {};
  var align = function align() {
    if (!disabled && floatRef) {
      var _useRefs$links$ui$scr, _useRefs$links$ui$scr2;
      var scrollNode = (_useRefs$links$ui$scr = useRefs.links.ui['scroll']) === null || _useRefs$links$ui$scr === void 0 ? void 0 : (_useRefs$links$ui$scr2 = _useRefs$links$ui$scr.getNode) === null || _useRefs$links$ui$scr2 === void 0 ? void 0 : _useRefs$links$ui$scr2.call(_useRefs$links$ui$scr);
      if (scrollNode) {
        var _floatRef$current$sty, _floatRef$current$sty2;
        var rect = floatRef.current.getBoundingClientRect();
        var scrollRect = scrollNode.getBoundingClientRect();
        var marginTop = parseInt((_floatRef$current$sty = floatRef.current.style) === null || _floatRef$current$sty === void 0 ? void 0 : _floatRef$current$sty.marginTop) || 0;
        var marginLeft = parseInt((_floatRef$current$sty2 = floatRef.current.style) === null || _floatRef$current$sty2 === void 0 ? void 0 : _floatRef$current$sty2.marginLeft) || 0;
        var offsetLeft = OFFSET.offsetLeft,
          offsetRight = OFFSET.offsetRight,
          offsetShadow = OFFSET.offsetShadow,
          offsetTop = OFFSET.offsetTop,
          offsetBottom = OFFSET.offsetBottom;
        if (scrollNode.scrollLeft > 0) {
          offsetLeft += offsetShadow;
        }
        var shift = {};
        var left = rect.left - scrollRect.left - marginLeft - offsetLeft;
        var right = scrollRect.right - rect.right + marginLeft - offsetRight;
        if (left < 0) {
          shift.left = -left;
        } else if (right < 0) {
          var leftMax = scrollRect.left - rect.left + marginLeft + offsetLeft;
          shift.left = Math.max(right, leftMax);
        }
        var scrollTop = scrollRect.top;
        var scrollBottom = scrollRect.bottom;
        var editorScrollNode = editor.getScrollingContainer();
        var editorRect = editorScrollNode.getBoundingClientRect();
        var editorTop = editorRect.top - offsetTop;
        var editorBottom = editorRect.bottom + offsetBottom;
        if (editorTop > scrollTop) {
          scrollTop = editorTop;
        }
        if (editorBottom < scrollBottom) {
          scrollBottom = editorBottom;
        }
        var bottom = scrollBottom - rect.bottom + marginTop - offsetBottom;
        if (bottom < 0) {
          var topMax = scrollTop - rect.top + marginTop + offsetTop;
          shift.top = Math.max(bottom, topMax);
          if (container) {
            var containerRect = container.getBoundingClientRect();
            // Не даем компоненту уйти ниже области видимости редактора
            var bottomViewShift = editorRect.height - rect.height - containerRect.top + offsetTop; // - shift.top + editorScrollNode.scrollTop
            if (bottomViewShift < 0) {
              shift.top = bottomViewShift;
            }
          }
        }
        setMargin(shift);
      }
    }
  };
  useResizeObserver(floatRef, align, disabled);
  useOnDocumentEsc(onWantsToClose, disabled);
  usePreventEditorScroll(editor, floatRef, disabled);
  useOnOutsideMouseDown(floatRef, onWantsToClose, disabled);
  (0,hooks_module/* useEffect */.d4)(function () {
    if (!disabled) {
      useRefs.links.ui.table.setState('float', true);
    }
    return function () {
      if (!disabled) {
        useRefs.links.ui.table.setState('float', false);
      }
    };
  }, [disabled]);
  (0,hooks_module/* useLayoutEffect */.bt)(function () {
    align();
  }, [disabled, floatRef]);
  if (!disabled) {
    var componentClasses = ['float-component'];
    var componentStyle = {};
    if (container) {
      var rect;
      if (adjustToParent && container.parentElement) {
        rect = container.parentElement.getBoundingClientRect();
      } else {
        rect = container.getBoundingClientRect();
      }
      if (rect) {
        componentStyle.top = rect.top + ((corrective === null || corrective === void 0 ? void 0 : corrective.top) || -1);
        componentStyle.left = rect.left + ((corrective === null || corrective === void 0 ? void 0 : corrective.left) || -1);
        componentStyle.minWidth = rect.width + ((corrective === null || corrective === void 0 ? void 0 : corrective.left) + (corrective === null || corrective === void 0 ? void 0 : corrective.right) || -2);
      }
      if (margin.top) {
        componentStyle.marginTop = margin.top;
      }
      if (margin.left) {
        componentStyle.marginLeft = margin.left;
      }
    }
    Object.assign(componentProps, {
      className: componentClasses.join(' '),
      style: componentStyle
    });
  }
  return (0,preact_module.h)("div", floatComponent_extends({
    ref: floatRef
  }, componentProps), children);
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/cells/dateComponent.js
function dateComponent_extends() { dateComponent_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return dateComponent_extends.apply(this, arguments); }











function dateComponent_slicedToArray(arr, i) { return dateComponent_arrayWithHoles(arr) || dateComponent_iterableToArrayLimit(arr, i) || dateComponent_unsupportedIterableToArray(arr, i) || dateComponent_nonIterableRest(); }
function dateComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function dateComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return dateComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return dateComponent_arrayLikeToArray(o, minLen); }
function dateComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function dateComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function dateComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }








var typeData = getTypeData('date');

/**
 * Универсальный компонент даты для ячеек даты и меншина
 * @param { object } pos: {row, col}
 * @param { object } cellRef: ref ячейки
 * @param { number } value: timestamp даты
 * @param { function } setValue: функция установки значения
 * @param { object } reminders: напоминания
 * @param { function } setValue: функция установки напоминаний
 * @param { object } format: формат даты
 * @param { function } onChangeFormat: функция установки формата даты
 * @param { event } editEvent: событие, взывавшее начало редактирования родительской ячейки, при его изменении открывается попап даты
 * @param { event } onEndEdit: взывается после завершения редактирования даты
 */
function DateComponent(_ref) {
  var pos = _ref.pos,
    cellRef = _ref.cellRef,
    format = _ref.format,
    value = _ref.value,
    setValue = _ref.setValue,
    reminders = _ref.reminders,
    setReminder = _ref.setReminder,
    removeReminders = _ref.removeReminders,
    onChangeFormat = _ref.onChangeFormat,
    editEvent = _ref.editEvent,
    onEndEdit = _ref.onEndEdit,
    dateId = _ref.dateId,
    deviceType = _ref.deviceType;
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    editor = _useContext.editor,
    editable = _useContext.editable,
    useRefs = _useContext.useRefs;
  var dateConfig = editor.blotsConfig['date'] || {};
  var _useState = (0,hooks_module/* useState */.eJ)({}),
    _useState2 = dateComponent_slicedToArray(_useState, 2),
    that = _useState2[0],
    setThat = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(null),
    _useState4 = dateComponent_slicedToArray(_useState3, 2),
    endAction = _useState4[0],
    setEndAction = _useState4[1];
  var _useState5 = (0,hooks_module/* useState */.eJ)(false),
    _useState6 = dateComponent_slicedToArray(_useState5, 2),
    editAction = _useState6[0],
    setEditAction = _useState6[1];
  var active = editAction && deviceType !== 'mobile' ? true : false; // проверка на deviceType чтобы не показывать календарь в мобильных аппах

  (0,hooks_module/* useEffect */.d4)(function () {
    if (editEvent && editable && !editAction) {
      if (editEvent !== endAction) {
        setEditAction(editEvent || true);
      }
    }
  }, [editEvent]);
  (0,hooks_module/* useEffect */.d4)(function () {
    if (active) {
      if (!cellRef.current.classList.contains('open-date-picker')) {
        cellRef.current.classList.add('open-date-picker');
      }
    } else {
      if (cellRef.current.classList.contains('open-date-picker')) {
        cellRef.current.classList.remove('open-date-picker');
      }
    }
  }, [active]);
  var dateTimeFormat = date_Date.getDateTimeFormat(typeData, editor.blotsConfig['date'] || {});
  var dateFormat = Object.assign({}, typeData.format, format);
  var dateParams = Object.assign({}, dateTimeFormat, dateFormat, {
    dateFormat: dateFormat.type && dateFormat.type !== 'default' ? dateFormat.type : dateTimeFormat.dateFormat
  });
  var endEdit = function endEdit(event) {
    setEndAction(event);
    setEditAction(null);
    onEndEdit === null || onEndEdit === void 0 ? void 0 : onEndEdit(event);
  };
  var setReturnDateString = function setReturnDateString(func) {
    setThat(Object.assign(that, {
      returnDateString: func
    }));
  };
  var getText = function getText() {
    var text = that.returnDateString ? that.returnDateString() : String(value);
    return text;
  };
  useRefs.addToCell(pos, {
    getText: getText.bind(this)
  });
  var component;
  if (value || active) {
    var _reminderManager$opti;
    var reminderManager = editor.plugins.reminderManager;
    var dateComponent = (0,preact_module.h)(InputDate, dateComponent_extends({
      mode: "table",
      enableReminders: reminderManager !== null && reminderManager !== void 0 && (_reminderManager$opti = reminderManager.options) !== null && _reminderManager$opti !== void 0 && _reminderManager$opti.enabled ? true : false,
      active: active,
      editor: editor,
      value: value,
      setValue: setValue,
      reminders: reminders,
      setReminder: setReminder,
      removeReminders: removeReminders,
      onChangeOption: onChangeFormat,
      setReturnDateString: setReturnDateString,
      wantsToClose: endEdit,
      listenBlur: true,
      dateId: dateId
    }, dateParams));
    if (active) {
      component = (0,preact_module.h)(FloatComponent, {
        container: cellRef === null || cellRef === void 0 ? void 0 : cellRef.current,
        onWantsToClose: endEdit
      }, dateComponent);
    } else {
      component = dateComponent;
    }
  }
  return component;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/formatTableCells.js
function formatTableCells_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { formatTableCells_typeof = function _typeof(obj) { return typeof obj; }; } else { formatTableCells_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return formatTableCells_typeof(obj); }









function formatTableCells_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function formatTableCells_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) formatTableCells_setPrototypeOf(subClass, superClass); }
function formatTableCells_setPrototypeOf(o, p) { formatTableCells_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return formatTableCells_setPrototypeOf(o, p); }
function formatTableCells_createSuper(Derived) { var hasNativeReflectConstruct = formatTableCells_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = formatTableCells_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = formatTableCells_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return formatTableCells_possibleConstructorReturn(this, result); }; }
function formatTableCells_possibleConstructorReturn(self, call) { if (call && (formatTableCells_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return formatTableCells_assertThisInitialized(self); }
function formatTableCells_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function formatTableCells_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function formatTableCells_getPrototypeOf(o) { formatTableCells_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return formatTableCells_getPrototypeOf(o); }

var FormatTableCellsAction = /*#__PURE__*/function (_Action) {
  formatTableCells_inherits(FormatTableCellsAction, _Action);
  var _super = formatTableCells_createSuper(FormatTableCellsAction);
  function FormatTableCellsAction(type, params, editor) {
    formatTableCells_classCallCheck(this, FormatTableCellsAction);
    type = type || FormatTableCellsAction.type;
    return _super.call(this, type, params, editor);
  }
  return FormatTableCellsAction;
}(Action);

FormatTableCellsAction.type = 'format-table-cells';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/cells/tableCellDateComponent.js
function tableCellDateComponent_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function tableCellDateComponent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { tableCellDateComponent_ownKeys(Object(source), true).forEach(function (key) { tableCellDateComponent_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { tableCellDateComponent_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function tableCellDateComponent_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


















function tableCellDateComponent_slicedToArray(arr, i) { return tableCellDateComponent_arrayWithHoles(arr) || tableCellDateComponent_iterableToArrayLimit(arr, i) || tableCellDateComponent_unsupportedIterableToArray(arr, i) || tableCellDateComponent_nonIterableRest(); }
function tableCellDateComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tableCellDateComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tableCellDateComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tableCellDateComponent_arrayLikeToArray(o, minLen); }
function tableCellDateComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function tableCellDateComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function tableCellDateComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }









/**
 * Тип ячейки "дата"
 * @param { object } pos: {row, col}
 * @param { object } cellData: данные ячейки
 * @param { object } parents:
 * @param { object } parents.colData: данные колонки
 * @param { function } onEndEdit: событие вызываемое при завершении редаткирования
 */
function TableCellDate(_ref) {
  var pos = _ref.pos,
    parents = _ref.parents,
    cellData = _ref.cellData,
    cellRef = _ref.cellRef,
    touch = _ref.touch,
    onEndEdit = _ref.onEndEdit;
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    editor = _useContext.editor,
    editable = _useContext.editable,
    setProp = _useContext.setProp,
    useRefs = _useContext.useRefs,
    onTableAction = _useContext.onTableAction,
    tableExec = _useContext.tableExec;
  var _useState = (0,hooks_module/* useState */.eJ)(false),
    _useState2 = tableCellDateComponent_slicedToArray(_useState, 2),
    editEvent = _useState2[0],
    setEditEvent = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(cellData.timestamp),
    _useState4 = tableCellDateComponent_slicedToArray(_useState3, 2),
    timestampState = _useState4[0],
    setTimestampState = _useState4[1];
  var _useState5 = (0,hooks_module/* useState */.eJ)(),
    _useState6 = tableCellDateComponent_slicedToArray(_useState5, 2),
    remindersState = _useState6[0],
    setRemindersState = _useState6[1];
  var _useState7 = (0,hooks_module/* useState */.eJ)(false),
    _useState8 = tableCellDateComponent_slicedToArray(_useState7, 2),
    didMount = _useState8[0],
    setDidMount = _useState8[1];
  var format = Object.assign({}, parents.colData.format || {}, cellData.format || {});
  var timestamp = parseInt(cellData.timestamp) || 0;
  var reminders = cellData.reminders || {};
  (0,hooks_module/* useEffect */.d4)(function () {
    var _tableExec = tableExec('get-table-blot'),
      attachedByUndo = _tableExec.attachedByUndo;
    // ремайндеры устанавливаются только если таблицы былда добавлена через undo или при изменении даты
    if (didMount || attachedByUndo) {
      var reminderManager = editor.plugins.reminderManager;

      // при удалении даты удаляем ремайндеры через reminderManager
      if (!(cellData !== null && cellData !== void 0 && cellData.timestamp) && cellData !== null && cellData !== void 0 && cellData.id && timestampState) {
        reminderManager.deleteReminder(cellData.id, tableCellDateComponent_objectSpread(tableCellDateComponent_objectSpread({}, cellData), {}, {
          reminders: remindersState
        }));
      }

      // при установке ремайндера для даты, устанавливаем ремайндерв через reminderManager
      if (cellData.timestamp && cellData.reminders) {
        var result = [];
        for (var id in cellData.reminders) {
          result.push({
            id: id,
            dateId: cellData.id,
            timestamp: timestamp,
            seconds: cellData.reminders[id].seconds,
            format: cellData.format,
            before: remindersState || {}
          });
        }
        if (result.length) {
          table_table.setInlineRemindersByArray(editor, result);
        } else {
          // если удалили последний ремайндер в датапикере то удаляем ремайндеры через reminderManager
          if (Object.keys(remindersState || {}).length) {
            reminderManager.deleteReminder(cellData.id, {
              cellData: cellData,
              reminders: remindersState
            });
          }
        }
      }
    } else {
      setDidMount(true);
    }
    setTimestampState(cellData.timestamp);
    setRemindersState(cellData.reminders);
  }, [cellData]);

  /**
   * Запуск редактирования ячейки
   * @param { event } event: событие, вызывавшее редактирование
   * @param { object } options?
   * @param { boolean } options.isMouse?: редактирование вызывано мышью
   * @param { boolean } options.isEnter?: редактирование вызывано нажатием enter
   * @returns { boolean }
   */
  var editCell = function editCell(event) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (editable) {
      if (options.isEnter || options.isMouse) {
        if (!clientDatePicker()) {
          setEditEvent(event);
        }
      }
    }
    return true;
  };
  var getFullDateFormat = function getFullDateFormat() {
    var _getTypeData;
    var firstWeekDay = getFirstWeekDay();
    console.info('getFirstWeekDay', firstWeekDay);
    var dateFormat = Object.assign({
      firstWeekDay: firstWeekDay
    }, ((_getTypeData = getTypeData('date')) === null || _getTypeData === void 0 ? void 0 : _getTypeData.format) || {}, format);
    return dateFormat;
  };
  var clientDatePicker = function clientDatePicker() {
    var _editor$plugins$dateM;
    var result = false;
    if ((_editor$plugins$dateM = editor.plugins.dateManager) !== null && _editor$plugins$dateM !== void 0 && _editor$plugins$dateM.openDatePicker) {
      var dateId = cellData.id;
      if (!dateId) {
        dateId = touch();
      }
      var dateFormat = getFullDateFormat();
      var params = tableCellDateComponent_objectSpread(tableCellDateComponent_objectSpread({}, dateFormat), {}, {
        dateId: dateId,
        type: 'table',
        timestamp: timestamp || null,
        reminders: cellData.reminders || {}
      });
      result = editor.plugins.dateManager.openDatePicker(params);
    }
    return result;
  };
  var onChange = function onChange(timestamp) {
    if (editable) {
      if (timestamp !== cellData.timestamp) {
        setProp('timestamp', timestamp, {
          pos: pos,
          type: 'cell'
        });
      } else {
        //setActive(false)
      }
    }
  };
  var setReminder = function setReminder(key) {
    var reminder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (editable) {
      var newReminders = tableCellDateComponent_objectSpread({}, reminders);
      if (reminder.value === 'none') {
        if (newReminders.hasOwnProperty(key)) {
          delete newReminders[key];
        }
      } else {
        newReminders[key] = reminder;
      }
      setProp('reminders', newReminders, {
        pos: pos,
        type: 'cell'
      });
    }
  };
  var removeReminders = function removeReminders(ids) {
    var _ref2 = cellData || {},
      _ref2$reminders = _ref2.reminders,
      reminders = _ref2$reminders === void 0 ? {} : _ref2$reminders;
    var newReminders = {};
    for (var reminderId in reminders) {
      if (!ids.includes(reminderId)) {
        newReminders[reminderId] = reminders[reminderId];
      }
    }
    setProp('reminders', newReminders, {
      pos: pos,
      type: 'cell'
    });
  };
  var onChangeFormat = function onChangeFormat(newFormat) {
    var formatKeys = Object.keys(newFormat);
    if (formatKeys.length) {
      onTableAction(new FormatTableCellsAction(FormatTableCellsAction.type, {
        start: pos,
        last: pos,
        type: 'date',
        prop: formatKeys[0],
        value: newFormat[formatKeys[0]]
      }, editor));
    }
  };
  var onEndEditCell = function onEndEditCell() {
    var _useRefs$links$col$po;
    (_useRefs$links$col$po = useRefs.links.col[pos.col]) === null || _useRefs$links$col$po === void 0 ? void 0 : _useRefs$links$col$po.onCellChange(pos);
    onEndEdit.apply(void 0, arguments);
  };
  useRefs.addToCell(pos, {
    value: timestamp,
    empty: !timestamp,
    editCell: editCell.bind(this)
  });
  return (0,preact_module.h)(DateComponent, {
    pos: pos,
    cellRef: cellRef,
    format: format,
    value: timestamp,
    setValue: onChange,
    reminders: reminders,
    setReminder: setReminder,
    removeReminders: removeReminders,
    onChangeFormat: onChangeFormat,
    editEvent: editEvent,
    onEndEdit: onEndEditCell,
    dateId: cellData === null || cellData === void 0 ? void 0 : cellData.id
  });
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/cells/tableCellLinkComponent.js
function tableCellLinkComponent_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function tableCellLinkComponent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { tableCellLinkComponent_ownKeys(Object(source), true).forEach(function (key) { tableCellLinkComponent_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { tableCellLinkComponent_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function tableCellLinkComponent_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


















/**
 * Тип ячейки "ссылка"
 * @param { object } pos: {row, col}
 * @param { object } cellData: данные ячейки
 * @param { object } cellRef: ref ячейки
 * @param { function } emptyCell: функция очистки ячейки
 * @param { function } onEndEdit: событие вызываемое при завершении редаткирования
 */
function TableCellLinkComponent(_ref) {
  var _cellData$child4, _cellData$child4$char;
  var pos = _ref.pos,
    cellRef = _ref.cellRef,
    cellData = _ref.cellData,
    emptyCell = _ref.emptyCell,
    onEndEdit = _ref.onEndEdit;
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    editor = _useContext.editor,
    editable = _useContext.editable,
    useRefs = _useContext.useRefs,
    applyDelta = _useContext.applyDelta;
  var linkRef = (0,hooks_module/* useRef */.sO)(null);
  var childStyle = {};
  if (cellData.child) {
    for (var attr in CONFIG.child.style) {
      var item = CONFIG.child.style[attr];
      var val = cellData.child[attr];
      if (val && val !== item.default) {
        childStyle[item.prop] = val;
      }
    }
  }
  var getLink = function getLink() {
    var _cellData$child, _cellData$child$delta;
    var link = null;
    if ((_cellData$child = cellData.child) !== null && _cellData$child !== void 0 && (_cellData$child$delta = _cellData$child.delta) !== null && _cellData$child$delta !== void 0 && _cellData$child$delta.length) {
      var _cellData$child$delta2, _cellData$child$delta3;
      link = {
        text: (_cellData$child$delta2 = cellData.child.delta[0].insert) === null || _cellData$child$delta2 === void 0 ? void 0 : _cellData$child$delta2.trim(),
        url: (_cellData$child$delta3 = cellData.child.delta[0].attributes) === null || _cellData$child$delta3 === void 0 ? void 0 : _cellData$child$delta3.link
      };
    }
    return link;
  };
  var changeText = function changeText(text) {
    var link = getLink();
    if (text && text !== (link === null || link === void 0 ? void 0 : link.text)) {
      setLink(tableCellLinkComponent_objectSpread(tableCellLinkComponent_objectSpread({}, link), {
        text: text
      }));
    }
  };
  var changeUrl = function changeUrl(url) {
    var link = getLink();
    if (url && url !== (link === null || link === void 0 ? void 0 : link.url)) {
      setLink(tableCellLinkComponent_objectSpread(tableCellLinkComponent_objectSpread({}, link), {
        url: url
      }));
    } else {
      onEndEdit === null || onEndEdit === void 0 ? void 0 : onEndEdit(null, {
        select: true
      });
    }
  };
  var setLink = function setLink(link) {
    if (editable) {
      var _cellData$child2, _cellData$child3;
      var newDelta = (_cellData$child2 = cellData.child) !== null && _cellData$child2 !== void 0 && _cellData$child2.delta ? (_cellData$child3 = cellData.child) === null || _cellData$child3 === void 0 ? void 0 : _cellData$child3.delta : [{}];
      newDelta[0].insert = link.text;
      newDelta[0].attributes = Object.assign(newDelta[0].attributes || {}, {
        link: link.url
      });
      applyDelta(newDelta, {
        pos: pos,
        replace: true
      });
      onEndEdit === null || onEndEdit === void 0 ? void 0 : onEndEdit(null, {
        select: true
      });
    }
  };
  var linkClick = function linkClick(event) {
    var link = cellRef === null || cellRef === void 0 ? void 0 : cellRef.current.querySelector('a');
    if (link) {
      editor.emitter.emit('click-link', {
        domNode: link,
        changeText: changeText,
        changeUrl: changeUrl,
        onEmpty: emptyCell,
        disableEditing: !editable,
        withoutRange: true
      });
    } else if (editable) {
      editor.plugins.popupManager.addLink({
        setLink: setLink,
        text: '',
        singleBlock: true,
        anchorNode: cellRef.current
      });
    }
  };
  var onLinkClick = function onLinkClick(event) {
    event === null || event === void 0 ? void 0 : event.preventDefault();
    event === null || event === void 0 ? void 0 : event.stopPropagation();
    linkClick(event);
  };
  var editCell = function editCell(event) {
    linkClick(event);
    return true;
  };
  var value = (_cellData$child4 = cellData.child) === null || _cellData$child4 === void 0 ? void 0 : (_cellData$child4$char = _cellData$child4.characters) === null || _cellData$child4$char === void 0 ? void 0 : _cellData$child4$char.toString();
  var empty = !value || value === '\n';
  useRefs.addToCell(pos, {
    empty: empty,
    value: value,
    editCell: editCell.bind(this)
  });
  var child = null,
    text;
  if (!empty && cellData.child) {
    text = (0,preact_module.h)(DeltaComponent, {
      delta: cellData.child.delta,
      editor: editor,
      linkProps: {
        ref: linkRef,
        onClick: onLinkClick
      }
    });
  }
  if (text) {
    var classes = ['table-text-common'];
    child = (0,preact_module.h)("div", {
      className: classes.join(' '),
      style: childStyle
    }, text);
  }
  return child;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/rootPlacement.js
function rootPlacement_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { rootPlacement_typeof = function _typeof(obj) { return typeof obj; }; } else { rootPlacement_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return rootPlacement_typeof(obj); }













function rootPlacement_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function rootPlacement_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function rootPlacement_createClass(Constructor, protoProps, staticProps) { if (protoProps) rootPlacement_defineProperties(Constructor.prototype, protoProps); if (staticProps) rootPlacement_defineProperties(Constructor, staticProps); return Constructor; }
function rootPlacement_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) rootPlacement_setPrototypeOf(subClass, superClass); }
function rootPlacement_setPrototypeOf(o, p) { rootPlacement_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return rootPlacement_setPrototypeOf(o, p); }
function rootPlacement_createSuper(Derived) { var hasNativeReflectConstruct = rootPlacement_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = rootPlacement_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = rootPlacement_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return rootPlacement_possibleConstructorReturn(this, result); }; }
function rootPlacement_possibleConstructorReturn(self, call) { if (call && (rootPlacement_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return rootPlacement_assertThisInitialized(self); }
function rootPlacement_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function rootPlacement_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function rootPlacement_getPrototypeOf(o) { rootPlacement_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return rootPlacement_getPrototypeOf(o); }
function rootPlacement_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = rootPlacement_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function rootPlacement_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return rootPlacement_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return rootPlacement_arrayLikeToArray(o, minLen); }
function rootPlacement_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


function pickNotUndefined(values) {
  var _iterator = rootPlacement_createForOfIteratorHelper(values),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var v = _step.value;
      if (typeof v !== 'undefined') {
        return v;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return undefined;
}
var RootPlacementContainer = /*#__PURE__*/function (_Component) {
  rootPlacement_inherits(RootPlacementContainer, _Component);
  var _super = rootPlacement_createSuper(RootPlacementContainer);
  function RootPlacementContainer() {
    rootPlacement_classCallCheck(this, RootPlacementContainer);
    return _super.apply(this, arguments);
  }
  rootPlacement_createClass(RootPlacementContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.transitionTimeout) {
        this.setState(function () {
          return {
            elemVisible: true
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        editor = _this$props.editor,
        transitionLeaveTimeout = _this$props.transitionLeaveTimeout,
        transitionTimeout = _this$props.transitionTimeout,
        transitionName = _this$props.transitionName;
      var elemVisible = this.state.elemVisible;
      var elem = (0,preact_module/* toChildArray */.bR)(this.props.children)[0];
      var child = null;
      if (transitionTimeout) {
        child = (0,preact_module.h)(preact_transition_group/* default */.Z, {
          transitionName: transitionName,
          transitionEnterTimeout: transitionTimeout,
          transitionLeaveTimeout: pickNotUndefined([transitionLeaveTimeout, transitionTimeout])
        }, elemVisible ? elem : null);
      } else {
        child = elem;
      }
      var componentProps = {};
      var classes = [];
      var theme = editor === null || editor === void 0 ? void 0 : editor.plugins.editorStyle.getTheme();
      if (theme) {
        classes.push('theme-' + theme);
      }
      if (this.props.styled) {
        classes.push('root-placement-styled');
        var style = editor === null || editor === void 0 ? void 0 : editor.plugins.editorStyle.getStyle();
        if (style) {
          classes.push('size-' + style.size);
          classes.push('style-' + style.style);
        }
      }
      componentProps.className = classes.join(' ');
      return (0,preact_module.h)("div", componentProps, child);
    }
  }]);
  return RootPlacementContainer;
}(preact_module/* Component */.wA);
var RootPlacement = /*#__PURE__*/function (_Component2) {
  rootPlacement_inherits(RootPlacement, _Component2);
  var _super2 = rootPlacement_createSuper(RootPlacement);
  function RootPlacement(props) {
    var _this;
    rootPlacement_classCallCheck(this, RootPlacement);
    _this = _super2.call(this, props);
    _this.container = document.createElement('div');
    return _this;
  }
  rootPlacement_createClass(RootPlacement, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
        editor = _this$props2.editor,
        containerNode = _this$props2.containerNode,
        _this$props2$document = _this$props2.documentRoot,
        documentRoot = _this$props2$document === void 0 ? false : _this$props2$document,
        children = _this$props2.children,
        _this$props2$useEdito = _this$props2.useEditorOuterScrollingContainer,
        useEditorOuterScrollingContainer = _this$props2$useEdito === void 0 ? false : _this$props2$useEdito;
      if (editor) {
        if (useEditorOuterScrollingContainer) {
          containerNode = editor.getScrollingContainer();
        } else {
          containerNode = editor.scrollingContainer;
        }
      }
      if (documentRoot) {
        containerNode = document.body;
      }
      containerNode.appendChild(this.container);
      this.renderChildren();
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var children = this.props.children;
      (0,preact_module/* render */.sY)((0,preact_module.h)(RootPlacementContainer, this.props, children), this.container);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.renderChildren();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this2 = this;
      (0,preact_module/* render */.sY)((0,preact_module.h)(RootPlacementContainer, this.props, null), this.container);
      var timeout = pickNotUndefined([this.props.transitionLeaveTimeout, this.props.transitionTimeout, 0]);
      var onTimeoutFn = function onTimeoutFn() {
        var Nothing = function Nothing() {};
        (0,preact_module/* render */.sY)((0,preact_module.h)(Nothing, null), _this2.container);
        _this2.container.parentNode.removeChild(_this2.container);
      };
      if (timeout) {
        setTimeout(onTimeoutFn, timeout);
      } else {
        onTimeoutFn();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return (0,preact_module.h)("span", null);
    }
  }]);
  return RootPlacement;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/interface/dropdownComponent.js
function dropdownComponent_extends() { dropdownComponent_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return dropdownComponent_extends.apply(this, arguments); }













function dropdownComponent_slicedToArray(arr, i) { return dropdownComponent_arrayWithHoles(arr) || dropdownComponent_iterableToArrayLimit(arr, i) || dropdownComponent_unsupportedIterableToArray(arr, i) || dropdownComponent_nonIterableRest(); }
function dropdownComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function dropdownComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return dropdownComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return dropdownComponent_arrayLikeToArray(o, minLen); }
function dropdownComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function dropdownComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function dropdownComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }










/**
 * Компонент редактируемого выпадающего списка
 * @param { object } editor
 * @param { boolean } editable: разрешить редактирование
 * @param { boolean } float: элемент с абсолютным позиционированием
 * @param { array } selectedItems: массив с комопнентами выбранных элементов
 * @param { array } searchItems: массив с комопнентами найденных элементов
 * @param { function } onInput: вызывается при вводе в текстовое поле, возвращает значение поля
 * @param { function } onSelect: вызывается при выборе элемента
 * @param { function } onRemoveItem: вызывается при удалении выбранного элемента (через backspace)
 * @param { function } onWantsToClose: вызывается при необходимости закрыть дропдаун
 * @param { node } container?: нода контейнера, в случае float=true используется для позиционирования
 * @param { object } corrective?: корректировка размеров (top, left, right)
 * @param { boolean } adjustToParent?: настраивает размер не по контейнеру, а по его родителю, удобно если у родителя есть padding либо контейнер имеет нулевой размер
 * @param { string } placeholder?: текст плейсхолдера для поля ввода
 * @param { string } loadingMessage?: сообщение, показываемое при создании дропдауна и до предзагрузки списка
 * @param { string } noResultMessage?: сообщение, показываемое при отсутсвтии результатов поиска
 * @param { string } className?: дополнительные классы для компонента
 * @param { boolean } reset?: сброс введенного текста
 */

function DropdownComponent(_ref) {
  var _this = this;
  var editor = _ref.editor,
    editable = _ref.editable,
    float = _ref.float,
    container = _ref.container,
    reset = _ref.reset,
    _ref$selectedItems = _ref.selectedItems,
    selectedItems = _ref$selectedItems === void 0 ? {} : _ref$selectedItems,
    _ref$searchItems = _ref.searchItems,
    searchItems = _ref$searchItems === void 0 ? {} : _ref$searchItems,
    onInput = _ref.onInput,
    onSelect = _ref.onSelect,
    onRemoveItem = _ref.onRemoveItem,
    onWantsToClose = _ref.onWantsToClose,
    placeholder = _ref.placeholder,
    loadingMessage = _ref.loadingMessage,
    noResultMessage = _ref.noResultMessage,
    adjustToParent = _ref.adjustToParent,
    _ref$corrective = _ref.corrective,
    corrective = _ref$corrective === void 0 ? {} : _ref$corrective,
    className = _ref.className;
  var _useState = (0,hooks_module/* useState */.eJ)(true),
    _useState2 = dropdownComponent_slicedToArray(_useState, 2),
    preload = _useState2[0],
    setPreload = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(null),
    _useState4 = dropdownComponent_slicedToArray(_useState3, 2),
    active = _useState4[0],
    setActive = _useState4[1];
  var dropdownRef = (0,hooks_module/* useRef */.sO)();
  var searchScrollRef = (0,hooks_module/* useRef */.sO)(null);
  var searchActiveRef = (0,hooks_module/* useRef */.sO)(null);
  useOnDocumentEsc(onWantsToClose);
  useOnOutsideMouseDown(dropdownRef, onWantsToClose);
  usePreventEditorScroll(editor, searchScrollRef);
  var arrows = function arrows(dir) {
    var keys = Object.keys(searchItems);
    var activeNew = null;
    var length = keys.length;
    if (length) {
      if (active === null) {
        activeNew = 0;
      } else if (dir === 'up') {
        activeNew = (active > 0 ? active : length) - 1;
      } else {
        activeNew = active < length - 1 ? active + 1 : 0;
      }
    }
    setActive(activeNew);
  };
  var onTextInput = function onTextInput(event, text) {
    if ((0,lib/* default */.ZP)('enter', event)) {
      var key = null;
      var keys = Object.keys(searchItems);
      if (keys.length) {
        var index = Math.max(0, keys.indexOf('create'));
        key = keys[!isNaN(parseInt(active)) ? active : index];
      }
      onSelect === null || onSelect === void 0 ? void 0 : onSelect(key, text);
    } else if ((0,lib/* default */.ZP)('arrowup', event)) {
      arrows('up');
    } else if ((0,lib/* default */.ZP)('arrowdown', event)) {
      arrows('down');
    } else if ((0,lib/* default */.ZP)('esc', event)) {
      onWantsToClose === null || onWantsToClose === void 0 ? void 0 : onWantsToClose(event);
    } else if ((0,lib/* default */.ZP)('backspace', event) && !text) {
      var _keys = Object.keys(selectedItems);
      if (_keys.length) {
        onRemoveItem === null || onRemoveItem === void 0 ? void 0 : onRemoveItem(_keys.pop());
      }
    } else {
      onInputProcessing(text);
    }
  };
  var onInputProcessing = function onInputProcessing(text) {
    onInput(text);
    setPreload(false);
  };
  var onSearchItemMouseDown = function onSearchItemMouseDown(key, event) {
    onSelect === null || onSelect === void 0 ? void 0 : onSelect(key, null);
  };
  (0,hooks_module/* useEffect */.d4)(function () {
    setActive(null);
  }, [selectedItems]);
  (0,hooks_module/* useEffect */.d4)(function () {
    if (active !== null && searchActiveRef !== null && searchActiveRef !== void 0 && searchActiveRef.current) {
      searchActiveRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  }, [active]);
  var componentStyle = {};
  var componentClasses = ["dropdown-component"];
  if (className) {
    componentClasses.push(className);
  }
  if (float) {
    componentClasses.push("dropdown-component-float");
    var rect;
    if (adjustToParent && container !== null && container !== void 0 && container.parentElement) {
      rect = container.parentElement.getBoundingClientRect();
    } else {
      rect = container === null || container === void 0 ? void 0 : container.getBoundingClientRect();
    }
    if (rect) {
      var scrollingContainerRect = editor.getScrollingContainer().getBoundingClientRect();
      if (scrollingContainerRect.bottom - rect.bottom > 300) {
        componentStyle.top = rect.top + ((corrective === null || corrective === void 0 ? void 0 : corrective.top) || 0);
      } else {
        componentClasses.push('reverse-items');
        componentStyle.bottom = scrollingContainerRect.bottom - rect.bottom + ((corrective === null || corrective === void 0 ? void 0 : corrective.bottom) || 0);
      }
      componentStyle.left = rect.left + ((corrective === null || corrective === void 0 ? void 0 : corrective.left) || 0);
      componentStyle.minWidth = rect.width + ((corrective === null || corrective === void 0 ? void 0 : corrective.left) + (corrective === null || corrective === void 0 ? void 0 : corrective.right) || 0);
      /*
      // Автокорректировка на padding родителя, но работает не во всех браузерах
      const corrective = {left:0, right:0}
      try {
        const computedStyle = container.parentElement?.computedStyleMap?.()
        if (computedStyle) {
          corrective.top = computedStyle.get('padding-top')?.value
          corrective.left = computedStyle.get('padding-left')?.value
          corrective.right = computedStyle.get('padding-right')?.value
        }
      } catch (ex) {
        console.warn(ex)
      }
      */
    }
  }

  var selected = Object.keys(selectedItems).reduce(function (arr, key) {
    var item = selectedItems[key];
    var component = (0,preact_module.h)("span", {
      className: "dropdown-item"
    }, item);
    arr.push(component);
    return arr;
  }, []);
  var input = null;
  if (editable) {
    input = (0,preact_module.h)(InputComponent, {
      reset: reset,
      autofocus: true,
      placeholder: placeholder,
      onInput: onTextInput
    });
  }
  var searchCollection = Object.keys(searchItems).reduce(function (arr, key, index) {
    var item = searchItems[key];
    var itemClasses = ["dropdown-item"];
    var props = {};
    if (index === active) {
      itemClasses.push('active');
      props.ref = searchActiveRef;
    }
    var component = (0,preact_module.h)("div", dropdownComponent_extends({
      className: itemClasses.join(' '),
      onMouseDown: onSearchItemMouseDown.bind(_this, key)
    }, props), item);
    arr.push(component);
    return arr;
  }, []);
  var bottom;
  if (searchCollection.length) {
    bottom = (0,preact_module.h)("div", {
      ref: searchScrollRef,
      className: "dropdown-search-items"
    }, searchCollection);
  } else if (loadingMessage || noResultMessage) {
    var message;
    if (preload) {
      message = loadingMessage || noResultMessage;
    } else {
      message = noResultMessage || loadingMessage;
    }
    bottom = (0,preact_module.h)("div", {
      className: "dropdown-message"
    }, message);
  }
  var dropdown = (0,preact_module.h)("div", {
    className: componentClasses.join(' '),
    style: componentStyle
  }, (0,preact_module.h)("div", {
    ref: dropdownRef,
    className: "dropdown-component-content"
  }, (0,preact_module.h)("div", {
    className: "dropdown-selected-items"
  }, selected, input), bottom));
  return float ? (0,preact_module.h)(RootPlacement, {
    editor: editor,
    styled: true,
    transitionName: "popup-menu",
    transitionTimeout: vars.popupAppearDuration
  }, dropdown) : dropdown;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/interface/selectComponent.js
function selectComponent_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function selectComponent_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function selectComponent_createClass(Constructor, protoProps, staticProps) { if (protoProps) selectComponent_defineProperties(Constructor.prototype, protoProps); if (staticProps) selectComponent_defineProperties(Constructor, staticProps); return Constructor; }
function selectComponent_extends() { selectComponent_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return selectComponent_extends.apply(this, arguments); }
function selectComponent_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function selectComponent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { selectComponent_ownKeys(Object(source), true).forEach(function (key) { selectComponent_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { selectComponent_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function selectComponent_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






















function selectComponent_slicedToArray(arr, i) { return selectComponent_arrayWithHoles(arr) || selectComponent_iterableToArrayLimit(arr, i) || selectComponent_unsupportedIterableToArray(arr, i) || selectComponent_nonIterableRest(); }
function selectComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function selectComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return selectComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return selectComponent_arrayLikeToArray(o, minLen); }
function selectComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function selectComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function selectComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }












/**
 * Компонент singleselect / multiselect
 * @param { object } editor
 * @param { boolean } editable: разрешение редактировать список
 * @param { boolean } nowrap: однострочный режим, отображается первый пункт и символ + с числом оставшихся
 * @param { function } onChange: функция, вызываемая при изменении, возвращает {array} selected
 * @param { function } onEndEdit: функция, вызываемая при выходе из редактирования
 * @param { event } editEvent: event передаваемый родительским компонентом, при его изменении запускается редактирование
 * @param { boolean } multiselect: возможность выбирать несколько пунктов
 * @param { array } selected: массив с id выбранных пунктов
 * @param { object } database: интерфейс для работы с базой данных
 * @param { object } database.get: возвращает все лейблы {id: label, ...}
 * @param { function } database.insert(label): возвращает id лейбла
 * @param { function } database.update(labelId, label): обновляет лейбл
 * @param { function } database.delete(labelId): удаляет лейбл
 *
 * label: {
 *    @param { string } name: уникальное имя
 *    @param { string } color: цвет из selectcolors
 *    @param { string } style: стиль заливки - default, outline, none
 * }
 */
function SelectComponent(_ref) {
  var _this = this;
  var editor = _ref.editor,
    editable = _ref.editable,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? [] : _ref$selected,
    database = _ref.database,
    nowrap = _ref.nowrap,
    onChange = _ref.onChange,
    editEvent = _ref.editEvent,
    onEndEdit = _ref.onEndEdit,
    multiselect = _ref.multiselect;
  var i18n = editor.plugins.i18n;
  var _useState = (0,hooks_module/* useState */.eJ)(''),
    _useState2 = selectComponent_slicedToArray(_useState, 2),
    text = _useState2[0],
    setText = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(false),
    _useState4 = selectComponent_slicedToArray(_useState3, 2),
    opened = _useState4[0],
    setOpened = _useState4[1];
  var _useState5 = (0,hooks_module/* useState */.eJ)(null),
    _useState6 = selectComponent_slicedToArray(_useState5, 2),
    labelMenu = _useState6[0],
    setLabelMenu = _useState6[1];
  var containerRef = (0,hooks_module/* useRef */.sO)(null);
  (0,hooks_module/* useEffect */.d4)(function () {
    if (editEvent) {
      openDropdown(editEvent);
    }
  }, [editEvent]);
  (0,hooks_module/* useEffect */.d4)(function () {
    setText('');
  }, [selected]);
  var createLabel = function createLabel(name) {
    var label = {
      name: String(name).trim()
    };
    if (!label.name) {
      return false;
    }
    label.style = 'default';
    var colors = matColorNames.reduce(function (obj, color) {
      obj[color] = {
        color: color,
        used: 0
      };
      return obj;
    }, {});
    var labels = database.get;
    for (var k in labels) {
      var l = labels[k];
      if (l) {
        // Считаем использованные цвета
        if (colors[l.color]) {
          colors[l.color].used++;
        }
        // Наследуюем последний из стилей в бд
        label.style = l.style;
      }
    }

    // Берем наименнее использованный цвет
    var colorsArr = Object.values(colors);
    colorsArr.sort(function () {
      return Math.random() - 0.5;
    });
    colorsArr.sort(function (a, b) {
      return a.used - b.used;
    });
    label.color = colorsArr.shift().color;
    return label;
  };
  var onClick = function onClick(event) {
    openDropdown();
  };
  var onInput = function onInput(text) {
    setText(text || '');
  };
  var onSelect = function onSelect(key, event) {
    if (labelMenu) {
      return;
    }
    var close = !key;
    if (key) {
      if (key === 'create') {
        var label = createLabel(text);
        key = database.insert(label);
      } else if (!multiselect) {
        close = true;
      }
      if (key && selected.indexOf(key) === -1) {
        var newSelected = Object.assign([], multiselect ? selected : []);
        newSelected.push(key);
        onChange === null || onChange === void 0 ? void 0 : onChange(newSelected);
      }
    }
    if (close) {
      closeDropdown();
    }
  };
  var onRemoveMouseDown = function onRemoveMouseDown(labelId, event) {
    event === null || event === void 0 ? void 0 : event.stopPropagation();
    removeItem(labelId);
  };
  var removeItem = function removeItem(labelId) {
    if (editable) {
      var newSelected = Object.assign([], selected);
      var index = newSelected.indexOf(labelId);
      if (index > -1) {
        newSelected.splice(index, 1);
        onChange === null || onChange === void 0 ? void 0 : onChange(newSelected);
      }
    }
  };
  var openDropdown = function openDropdown(event) {
    if (!opened) {
      if (editable || nowrap && selected.length > 1) {
        var rect = containerRef.current.getBoundingClientRect();
        setOpened(rect);
      }
    }
  };
  var closeDropdown = function closeDropdown(event) {
    setOpened(null);
    onEndEdit === null || onEndEdit === void 0 ? void 0 : onEndEdit(event);
  };
  var onLabelMenuMouseDown = function onLabelMenuMouseDown(id, event) {
    event.stopPropagation();
    setLabelMenu((labelMenu === null || labelMenu === void 0 ? void 0 : labelMenu.id) === id ? null : {
      id: id,
      target: event.target
    });
  };
  var componentClasses = ['select-component'];
  var listClasses = ['select-list'];
  var getLabelClassName = function getLabelClassName(label) {
    var labelClasses = ['select-label', 'adaptive-text'];
    var colorStylePrefix = 'bg-palette-';
    if (label.style && label.style !== 'default') {
      labelClasses.push('fill-' + label.style);
      if (label.style === 'outline') {
        colorStylePrefix = 'shadow-palette-';
      } else if (label.style === 'none') {
        colorStylePrefix = false;
      }
    }
    if (label.color && colorStylePrefix) {
      labelClasses.push(colorStylePrefix + label.color);
    }
    return labelClasses.join(' ');
  };
  var labelComponent = function labelComponent(labelId) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var component;
    var label = database.get[labelId];
    if (label) {
      var remove, menu, menuButton;
      var labelClassName = getLabelClassName(label);
      if (editable && options.menu) {
        menuButton = (0,preact_module.h)("span", {
          className: "select-label-menu",
          onMouseDown: onLabelMenuMouseDown.bind(_this, labelId)
        }, (0,preact_module.h)(icons/* IconMoreVertical */.nqv, null));
        if ((labelMenu === null || labelMenu === void 0 ? void 0 : labelMenu.id) === labelId) {
          menu = (0,preact_module.h)(SelectComponentMenu, {
            editor: editor,
            labelId: labelId,
            database: database,
            anchorNode: labelMenu.target,
            getLabelClassName: getLabelClassName,
            wantsToClose: setLabelMenu.bind(_this, null)
          });
        }
      }
      if (options.remove) {
        remove = (0,preact_module.h)("span", {
          className: "select-label-remove",
          onMouseDown: onRemoveMouseDown.bind(_this, labelId)
        }, (0,preact_module.h)(icons/* IconCross */.WcQ, null));
      }
      component = (0,preact_module.h)("span", {
        className: labelClassName
      }, (0,preact_module.h)("span", {
        className: "select-label-text searchable"
      }, label.name), remove, menuButton, menu);
    }
    return component;
  };
  var plusComponent,
    plus = 0;
  var selectedItems = selected.reduce(function (data, labelId, n) {
    if (nowrap && n > 0 && !opened) {
      plus++;
      return data;
    }
    if (database.get.hasOwnProperty(labelId)) {
      data[labelId] = labelComponent(labelId, {
        remove: opened && editable
      });
    }
    return data;
  }, {});
  if (!opened && plus) {
    listClasses.push('select-list-plus');
    plusComponent = (0,preact_module.h)("span", {
      className: "nowrap-plus"
    }, "+", plus);
  }
  var searchItems = {};
  if (opened) {
    var databaseKeys = Object.keys(database.get);
    var filter = String(text).toLowerCase().trim();
    var createItem = filter.length ? true : false;
    searchItems = databaseKeys.reduce(function (data, labelId) {
      var label = database.get[labelId];
      if (label) {
        var _label$name;
        var name = (_label$name = label.name) === null || _label$name === void 0 ? void 0 : _label$name.toLowerCase();
        if (!filter || name.indexOf(filter) !== -1) {
          data[labelId] = labelComponent(labelId, {
            menu: true
          });
        }
        if (name === filter) {
          createItem = false;
        }
      }
      return data;
    }, {});
    if (createItem) {
      searchItems['create'] = (0,preact_module.h)("span", {
        className: "label-create"
      }, (0,preact_module.h)("span", {
        className: "label-create-text"
      }, i18n.get('table.select.create') + ' ' + text));
    }
  }
  var content;
  if (!opened) {
    content = (0,preact_module.h)("div", {
      className: listClasses.join(' ')
    }, Object.values(selectedItems), plusComponent);
  } else {
    content = (0,preact_module.h)(DropdownComponent, {
      disabled: !!labelMenu,
      float: true,
      reset: text ? false : true,
      editor: editor,
      editable: editable,
      onInput: onInput,
      onSelect: onSelect,
      onRemoveItem: removeItem,
      selectedItems: selectedItems,
      searchItems: searchItems,
      placeholder: i18n.get('table.select.create_label'),
      onWantsToClose: closeDropdown,
      container: containerRef === null || containerRef === void 0 ? void 0 : containerRef.current,
      adjustToParent: true,
      corrective: {
        top: -1,
        left: -1,
        bottom: 8
      },
      className: "dropdown-select"
    });
  }
  var componentStyle = {};
  if (opened) {
    componentStyle.width = opened.width;
    componentStyle.height = opened.height;
  }
  return (0,preact_module.h)("div", {
    ref: containerRef,
    style: componentStyle,
    className: componentClasses.join(' '),
    onClick: onClick
  }, content);
}

/**
 * Меню редактирования лейбла
 * @param { object } editor
 * @param { string } labelId
 * @param { object } database: интерфейс работы с базой данных
 * @param { function } getLabelClassName: функция для генерации классов лейбла
 * @param { function } wantsToClose: функция закрытия меню
 */
function SelectComponentMenu(props) {
  var _this2 = this;
  var editor = props.editor,
    labelId = props.labelId,
    database = props.database,
    getLabelClassName = props.getLabelClassName,
    wantsToClose = props.wantsToClose;
  var i18n = editor.plugins.i18n;
  var label = database.get[labelId];
  var styles = ['default', 'outline', 'none'];
  var onColorPicked = function onColorPicked(color) {
    database.update(labelId, selectComponent_objectSpread(selectComponent_objectSpread({}, label), {
      color: color
    }));
    wantsToClose === null || wantsToClose === void 0 ? void 0 : wantsToClose();
  };
  var onStylePicked = function onStylePicked(style) {
    database.update(labelId, selectComponent_objectSpread(selectComponent_objectSpread({}, label), {
      style: style
    }));
    wantsToClose === null || wantsToClose === void 0 ? void 0 : wantsToClose();
  };
  var onTextInput = function onTextInput(event, text) {
    if ((0,lib/* default */.ZP)('enter', event)) {
      var name = text.trim();
      if (name) {
        database.update(labelId, selectComponent_objectSpread(selectComponent_objectSpread({}, label), {
          name: name
        }));
      }
      wantsToClose === null || wantsToClose === void 0 ? void 0 : wantsToClose();
    }
  };
  var onRemove = function onRemove(event) {
    event.stopPropagation();
    database.delete(labelId);
    wantsToClose === null || wantsToClose === void 0 ? void 0 : wantsToClose();
  };
  var styleItems = styles.map(function (style) {
    var classes = [getLabelClassName(selectComponent_objectSpread(selectComponent_objectSpread({}, label), {
      style: style
    }))];
    if (style !== (label.style || 'default')) {
      classes.push('disabled');
    }
    return (0,preact_module.h)("span", {
      className: classes.join(' '),
      onClick: onStylePicked.bind(_this2, style)
    }, (0,preact_module.h)("span", {
      className: "select-label-text adaptive-text"
    }, "\xA0A\xA0"));
  });
  return (0,preact_module.h)(popupMenu/* default */.Z, selectComponent_extends({}, props, {
    anchorOptions: {
      positionFixed: true
    }
  }), (0,preact_module.h)("div", {
    className: "menu-input menu-input-wide"
  }, (0,preact_module.h)(InputComponent, {
    autofocus: true,
    value: label.name,
    onInput: onTextInput
  })), (0,preact_module.h)("div", {
    className: "menu-block label-style-selection"
  }, styleItems), (0,preact_module.h)(PopupColorPicker, {
    resetColor: false,
    mode: label.style === 'none' ? 'disabled' : label.style || 'default',
    color: getMaterialColorName(label.color),
    colors: matColorNames,
    onColorPicked: onColorPicked,
    addClassName: "popup-menu-colorpicker popup-menu-wide popup-menu-builtin"
  }), (0,preact_module.h)(popupMenuItem/* default */.Z, {
    text: i18n.get('table.select.delete'),
    onClick: onRemove
  }));
}

/**
 * Интерфейс для работы с базой данных лейблов
 */
var LabelsDatabase = /*#__PURE__*/function () {
  function LabelsDatabase() {
    var labels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var setDatabase = arguments.length > 1 ? arguments[1] : undefined;
    selectComponent_classCallCheck(this, LabelsDatabase);
    this.labels = labels;
    this.setDatabase = setDatabase;
  }
  selectComponent_createClass(LabelsDatabase, [{
    key: "newId",
    get: function get() {
      return String(Date.now());
    }
  }, {
    key: "get",
    get: function get() {
      return this.labels;
    }
  }, {
    key: "set",
    set: function set(labels) {
      this.labels = labels;
      this.setDatabase(labels);
    }
  }, {
    key: "insert",
    value: function insert() {
      var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var labelId = this.newId;
      this.set = Object.assign({}, this.labels, selectComponent_defineProperty({}, labelId, label));
      //setProp('dbSelect', db, {pos, type:'col'})
      return labelId;
    }
  }, {
    key: "update",
    value: function update(labelId, label) {
      this.set = Object.assign({}, this.labels, selectComponent_defineProperty({}, labelId, label));
      return true;
    }
  }, {
    key: "delete",
    value: function _delete(labelId) {
      var db = Object.assign({}, this.labels);
      delete db[labelId];
      this.set = db;
      return true;
    }
  }]);
  return LabelsDatabase;
}();
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/cells/tableCellSelectComponent.js










function tableCellSelectComponent_slicedToArray(arr, i) { return tableCellSelectComponent_arrayWithHoles(arr) || tableCellSelectComponent_iterableToArrayLimit(arr, i) || tableCellSelectComponent_unsupportedIterableToArray(arr, i) || tableCellSelectComponent_nonIterableRest(); }
function tableCellSelectComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tableCellSelectComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tableCellSelectComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tableCellSelectComponent_arrayLikeToArray(o, minLen); }
function tableCellSelectComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function tableCellSelectComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function tableCellSelectComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }






/**
 * Тип ячейки singleselect и multiselect
 * @param { object } pos: {row, col}
 * @param { object } cellData: данные ячейки
 * @param { object } parents:
 * @param { object } parents.colData: данные колонки
 * @param { function } onEndEdit: событие вызываемое при завершении редаткирования
 */
function TableCellSelect(_ref) {
  var pos = _ref.pos,
    parents = _ref.parents,
    cellData = _ref.cellData,
    onEndEdit = _ref.onEndEdit;
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    data = _useContext.data,
    editor = _useContext.editor,
    editable = _useContext.editable,
    setProp = _useContext.setProp,
    useRefs = _useContext.useRefs,
    globalConfig = _useContext.globalConfig;
  var _useState = (0,hooks_module/* useState */.eJ)(null),
    _useState2 = tableCellSelectComponent_slicedToArray(_useState, 2),
    editEvent = _useState2[0],
    setEditEvent = _useState2[1];
  var editCell = function editCell(event) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setEditEvent(event);
    return true;
  };
  var onChange = function onChange() {
    var selected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (editable) {
      var _useRefs$links$col$po;
      setProp('selected', selected, {
        pos: pos,
        type: 'cell'
      });
      (_useRefs$links$col$po = useRefs.links.col[pos.col]) === null || _useRefs$links$col$po === void 0 ? void 0 : _useRefs$links$col$po.onCellChange(pos);
    }
  };
  var selected = parseObject('array', cellData.selected);
  var length = selected.length;
  useRefs.addToCell(pos, {
    value: length,
    empty: length === 0,
    editCell: editCell.bind(this)
  });
  var dbSelect = parseObject('object', parents.colData.dbSelect);
  var databaseInterface = new LabelsDatabase(dbSelect, function (db) {
    setProp('dbSelect', db, {
      pos: pos,
      type: 'col'
    });
  });
  return length || editEvent ? (0,preact_module.h)(SelectComponent, {
    editor: editor,
    editable: editable && !globalConfig.disableNonTextCellsEdit,
    selected: selected,
    database: databaseInterface,
    editEvent: editEvent,
    onChange: onChange,
    onEndEdit: onEndEdit,
    nowrap: !data.settings.wrapCells,
    multiselect: cellData.cellType === 'multiselect'
  }) : null;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/cells/tableCellRatingComponent.js






var tableCellRatingComponent_typeData = getTypeData('rating');

/**
 * Тип ячейки "рейтинг"
 * @param { object } pos: {row, col}
 * @param { object } cellData: данные ячейки
 * @param { object } parents:
 * @param { object } parents.colData: данные колонки
 */
function TableCellRating(_ref) {
  var pos = _ref.pos,
    parents = _ref.parents,
    cellData = _ref.cellData;
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    editor = _useContext.editor,
    editable = _useContext.editable,
    setProp = _useContext.setProp,
    useRefs = _useContext.useRefs,
    useAction = _useContext.useAction,
    globalConfig = _useContext.globalConfig,
    tableExec = _useContext.tableExec;
  var format = Object.assign({}, tableCellRatingComponent_typeData.format, parents.colData.format || {}, cellData.format || {});
  var editCell = function editCell(event) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (options.isEnter) {
      useAction.onAction({
        type: 'add-row-and-move-down'
      });
    }
    event === null || event === void 0 ? void 0 : event.preventDefault();
    return true;
  };
  var onChange = function onChange(rating) {
    if (editable && rating !== cellData.rating) {
      var _useRefs$links$col$po;
      setProp('rating', rating, {
        pos: pos,
        type: 'cell'
      });
      (_useRefs$links$col$po = useRefs.links.col[pos.col]) === null || _useRefs$links$col$po === void 0 ? void 0 : _useRefs$links$col$po.onCellChange(pos);
      tableExec('focus');
    }
  };
  var rating = cellData.rating || 0;
  useRefs.addToCell(pos, {
    value: rating,
    empty: rating === 0,
    editCell: editCell.bind(this)
  });
  return (0,preact_module.h)(RatingComponent, {
    editor: editor,
    editable: editable && !globalConfig.disableNonTextCellsEdit,
    onChange: onChange,
    rating: rating,
    format: format
  });
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/cells/tableCellMentionComponent.js
function tableCellMentionComponent_extends() { tableCellMentionComponent_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tableCellMentionComponent_extends.apply(this, arguments); }
function tableCellMentionComponent_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function tableCellMentionComponent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { tableCellMentionComponent_ownKeys(Object(source), true).forEach(function (key) { tableCellMentionComponent_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { tableCellMentionComponent_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function tableCellMentionComponent_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




















function tableCellMentionComponent_slicedToArray(arr, i) { return tableCellMentionComponent_arrayWithHoles(arr) || tableCellMentionComponent_iterableToArrayLimit(arr, i) || tableCellMentionComponent_unsupportedIterableToArray(arr, i) || tableCellMentionComponent_nonIterableRest(); }
function tableCellMentionComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tableCellMentionComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tableCellMentionComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tableCellMentionComponent_arrayLikeToArray(o, minLen); }
function tableCellMentionComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function tableCellMentionComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function tableCellMentionComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }











/**
 * Тип ячейки "mention"
 * @param { object } pos: {row, col}
 * @param { object } cellData: данные ячейки
 * @param { object } cellRef: ref ячейки
 * @param { function } emptyCell: функция очистки ячейки
 * @param { function } onEndEdit: событие вызываемое при завершении редаткирования
 */
function TableCellMentionComponent(_ref) {
  var _cellData$child,
    _this = this;
  var pos = _ref.pos,
    rowProps = _ref.rowProps,
    cellRef = _ref.cellRef,
    cellProps = _ref.cellProps,
    cellData = _ref.cellData,
    emptyCell = _ref.emptyCell,
    onEndEdit = _ref.onEndEdit;
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    editor = _useContext.editor,
    editable = _useContext.editable,
    useRefs = _useContext.useRefs,
    startEdit = _useContext.startEdit,
    applyDelta = _useContext.applyDelta,
    tableExec = _useContext.tableExec;
  var _useState = (0,hooks_module/* useState */.eJ)(false),
    _useState2 = tableCellMentionComponent_slicedToArray(_useState, 2),
    mentionPanel = _useState2[0],
    setMentionPanel = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(false),
    _useState4 = tableCellMentionComponent_slicedToArray(_useState3, 2),
    editEvent = _useState4[0],
    setEditEvent = _useState4[1];
  var _useState5 = (0,hooks_module/* useState */.eJ)(false),
    _useState6 = tableCellMentionComponent_slicedToArray(_useState5, 2),
    dateState = _useState6[0],
    setDateState = _useState6[1];
  var _useState7 = (0,hooks_module/* useState */.eJ)(false),
    _useState8 = tableCellMentionComponent_slicedToArray(_useState7, 2),
    didMount = _useState8[0],
    setDidMount = _useState8[1];
  var mentionRef = (0,hooks_module/* useRef */.sO)(null);
  var value,
    date = false,
    mention = false;
  var delta = (_cellData$child = cellData.child) === null || _cellData$child === void 0 ? void 0 : _cellData$child.delta;
  if (delta !== null && delta !== void 0 && delta.length && delta[0].insert) {
    if (delta[0].insert.hasOwnProperty('mention')) {
      mention = delta[0].insert.mention;
      value = mention.name;
    } else if (delta[0].insert.hasOwnProperty('date')) {
      date = delta[0].insert.date;
      value = date.value;
      setDateState(date);
    }
  }
  var childStyle = {};
  if (cellData.child) {
    for (var attr in CONFIG.child.style) {
      var item = CONFIG.child.style[attr];
      var val = cellData.child[attr];
      if (val && val !== item.default) {
        childStyle[item.prop] = val;
      }
    }
  }
  (0,hooks_module/* useEffect */.d4)(function () {
    var _tableExec = tableExec('get-table-blot'),
      attachedByUndo = _tableExec.attachedByUndo;
    if (didMount || attachedByUndo) {
      // при удалении даты, вызываем удаление ремайндеров через reminderManager
      var reminderManager = editor.plugins.reminderManager;
      if (!date && dateState) {
        reminderManager.deleteReminder(dateState.dateId, dateState);
      }

      // при установке даты, устанавливаем ремайндеры через reminderManager
      if (date) {
        var _date = date,
          dateId = _date.dateId,
          timestamp = _date.value,
          reminders = _date.reminders,
          format = _date.format;
        var result = [];
        for (var id in reminders) {
          result.push({
            id: id,
            dateId: dateId,
            timestamp: timestamp,
            seconds: reminders[id].seconds,
            before: dateState.reminders || {},
            format: format
          });
        }
        if (result.length) {
          table_table.setInlineRemindersByArray(editor, result);
        } else {
          // если удалили последний ремайндер в датапикере то удаляем ремайндеры через reminderManager
          if (Object.keys(dateState.reminders || {}).length) {
            reminderManager.deleteReminder(dateId, dateState);
          }
        }
      }
    } else {
      setDidMount(true);
    }
  }, [date]);
  var clientDatePicker = function clientDatePicker() {
    var _editor$plugins$dateM;
    var result = false;
    if ((_editor$plugins$dateM = editor.plugins.dateManager) !== null && _editor$plugins$dateM !== void 0 && _editor$plugins$dateM.openDatePicker) {
      var dateId = date.dateId;
      var dateFormat = getFullDateFormat();
      var params = tableCellMentionComponent_objectSpread(tableCellMentionComponent_objectSpread({}, dateFormat), {}, {
        dateId: dateId,
        type: 'date',
        timestamp: date.value || null,
        reminders: date.reminders || {}
      });
      result = editor.plugins.dateManager.openDatePicker(params);
    }
    return result;
  };
  var getFullDateFormat = function getFullDateFormat() {
    var firstWeekDay = getFirstWeekDay();
    console.info('getFirstWeekDay', firstWeekDay);
    var dateFormat = Object.assign({
      firstWeekDay: firstWeekDay,
      showTime: false
    }, date.format);
    return dateFormat;
  };
  var mentionClick = function mentionClick(event) {
    if (date) {
      if (clientDatePicker()) {
        console.info('Use native date picker');
      } else {
        setEditEvent(event);
      }
    } else if (mention) {
      if (editable) {
        setMentionPanel(true);
      } else {
        onMentionOpen(event);
      }
    } else {
      editMention();
    }
  };
  var editMention = function editMention(event) {
    if (editable) {
      var _useRefs$links$ui$scr;
      startEdit({
        type: "mention",
        pos: pos,
        event: event,
        cellData: cellData,
        node: cellRef.current,
        scrollNode: (_useRefs$links$ui$scr = useRefs.links.ui.scroll) === null || _useRefs$links$ui$scr === void 0 ? void 0 : _useRefs$links$ui$scr.getNode(),
        rowHeight: rowProps === null || rowProps === void 0 ? void 0 : rowProps.height,
        endEdit: onMentionEnd.bind(_this),
        style: Object.assign({}, childStyle, cellProps)
      });
    }
    return true;
  };
  var onMentionEnd = function onMentionEnd() {
    var mentions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    if (mentions !== null && mentions !== void 0 && mentions.length && mentions[0].type === 'date' && mentions[0].object_id === 'custom') {
      setEditEvent({});
    } else {
      onChange();
    }
    onEndEdit === null || onEndEdit === void 0 ? void 0 : onEndEdit();
  };
  var onMentionClick = function onMentionClick(event) {
    event === null || event === void 0 ? void 0 : event.preventDefault();
    mentionClick(event);
  };
  var editCell = function editCell(event) {
    mentionClick(event);
    return true;
  };
  var onChange = function onChange() {
    if (editable) {
      var _useRefs$links$col$po;
      (_useRefs$links$col$po = useRefs.links.col[pos.col]) === null || _useRefs$links$col$po === void 0 ? void 0 : _useRefs$links$col$po.onCellChange(pos);
    }
  };
  var setDate = function setDate(newDate) {
    if (editable) {
      date = Object.assign({}, date || {}, newDate);
      var newDelta = [{
        insert: {
          date: date
        }
      }];
      applyDelta(newDelta, {
        pos: pos,
        replace: true
      });
    }
  };
  var onDateChange = function onDateChange(value) {
    setDate({
      value: value
    });
  };
  var onDateSetReminder = function onDateSetReminder(key, reminder) {
    var newReminders = tableCellMentionComponent_objectSpread({}, date.reminders || {});
    if (reminder.value === 'none') {
      if (newReminders.hasOwnProperty(key)) {
        delete newReminders[key];
      }
    } else {
      newReminders[key] = reminder;
    }
    setDate({
      reminders: newReminders
    });
  };
  var onDateRemoveReminders = function onDateRemoveReminders(ids) {
    var _delta$0$insert;
    var _ref2 = date || {},
      reminders = _ref2.reminders;
    var newReminders = {};
    for (var reminderId in reminders) {
      if (!ids.includes(reminderId)) {
        newReminders[reminderId] = reminders[reminderId];
      }
    }
    // устанавливаем в дельту, т.к. при изменении формата так же используется deta из дельты
    // и эта date может подменить результат установленный в setDate ниже
    if (delta && (_delta$0$insert = delta[0].insert) !== null && _delta$0$insert !== void 0 && _delta$0$insert.date) {
      delta[0].insert.date.reminders = newReminders;
    }
    setDate({
      reminders: newReminders
    });
  };
  var onDateChangeFormat = function onDateChangeFormat(format) {
    var newFormat = Object.assign({}, date.format || {}, format);
    setDate({
      format: newFormat
    });
  };
  var onDateEndEdit = function onDateEndEdit(event) {
    onChange();
    onEndEdit === null || onEndEdit === void 0 ? void 0 : onEndEdit();
  };
  var onMentionEdit = function onMentionEdit(event) {
    setMentionPanel(false);
    emptyCell();
  };
  var onMentionOpen = function onMentionOpen(event) {
    setMentionPanel(false);
    var mentionManager = editor.plugins.mentionManager;
    if (mention && mention.type !== 'user') {
      mentionManager.onMentionClick(mention.type, mention.object_id, mention.workspace_id);
    }
  };
  var onClear = function onClear(event) {
    event === null || event === void 0 ? void 0 : event.stopPropagation();
    setMentionPanel(false);
    emptyCell();
  };
  useRefs.addToCell(pos, {
    value: value,
    empty: !value,
    editCell: editCell.bind(this)
  });
  var child = null,
    component;
  var classes = [];
  if (mention) {
    var mentionPanelMenu;
    if (mentionPanel) {
      mentionPanelMenu = (0,preact_module.h)(MentionMenuComponent, {
        editor: editor,
        editable: editable,
        useRefs: useRefs,
        parentRef: mentionRef,
        mention: mention,
        onMentionEdit: onMentionEdit,
        onMentionOpen: onMentionOpen,
        onClear: onClear,
        onWantsToClose: setMentionPanel.bind(this, false)
      });
    }
    component = (0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)(DeltaComponent, {
      editor: editor,
      delta: [cellData.child.delta[0]],
      mentionProps: {
        ref: mentionRef,
        onClick: onMentionClick
      }
    }), mentionPanelMenu);
  } else if (date) {
    classes.push('date-inline');
    component = (0,preact_module.h)(DateComponent, {
      pos: pos,
      cellRef: cellRef,
      format: date.format,
      value: date.value,
      setValue: onDateChange,
      reminders: date.reminders,
      setReminder: onDateSetReminder,
      removeReminders: onDateRemoveReminders,
      onChangeFormat: onDateChangeFormat,
      editEvent: editEvent,
      onEndEdit: onDateEndEdit,
      dateId: date.dateId,
      deviceType: editor.options.deviceType
    });
  }
  if (component) {
    child = (0,preact_module.h)("span", {
      className: classes.join(' '),
      style: childStyle
    }, component);
  }
  return child;
}
function MentionMenuComponent(_ref3) {
  var _this2 = this;
  var editor = _ref3.editor,
    editable = _ref3.editable,
    useRefs = _ref3.useRefs,
    mention = _ref3.mention,
    parentRef = _ref3.parentRef,
    onMentionEdit = _ref3.onMentionEdit,
    onMentionOpen = _ref3.onMentionOpen,
    onClear = _ref3.onClear,
    onWantsToClose = _ref3.onWantsToClose;
  usePreventEditorScroll(editor);
  (0,hooks_module/* useEffect */.d4)(function () {
    useRefs.links.ui.table.setState('float', true);
    return function () {
      useRefs.links.ui.table.setState('float', false);
    };
  }, []);
  var getMentionItems = function getMentionItems() {
    var i18n = editor.plugins.i18n;
    var result = {
      buttons: []
    };
    if (editable) {
      result.buttons.push({
        id: 'edit',
        fn: onMentionEdit.bind(_this2),
        title: i18n.get('table.menu.mention_panel.edit')
      });
    }
    if ((mention === null || mention === void 0 ? void 0 : mention.type) != 'user') {
      result.buttons.push({
        id: 'open',
        fn: onMentionOpen.bind(_this2),
        title: i18n.get('table.menu.mention_panel.open')
      });
    }
    if (editable) {
      result.buttons.push({
        id: 'clear',
        fn: onClear.bind(_this2),
        title: i18n.get('table.menu.mention_panel.clear')
      });
    }
    return result;
  };
  var menuItems = getMentionItems();
  var menu = (0,preact_module.h)(popupMenu/* default */.Z, {
    key: "mention-cell-panel",
    addClassName: "mention-panel no-scroll",
    closeOnEsc: true,
    wantsToClose: onWantsToClose,
    anchorNode: parentRef === null || parentRef === void 0 ? void 0 : parentRef.current,
    anchorOptions: {
      positionFixed: true,
      offset: '0px, 0px',
      placement: 'bottom-start',
      priority: ['top', 'left', 'right'],
      overflowBoundariesElement: editor.getScrollingContainer()
    }
  }, (0,preact_module.h)("div", {
    className: "mention-panel-buttons"
  }, menuItems.buttons.map(function (_ref4) {
    var id = _ref4.id,
      title = _ref4.title,
      fn = _ref4.fn;
    var buttonAttrs = {
      'data-button-key': id
    };
    return (0,preact_module.h)("div", tableCellMentionComponent_extends({
      className: "mention-panel-item",
      key: id,
      onClick: fn
    }, buttonAttrs), title);
  })));
  return menu;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/inputSlider.js
function inputSlider_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { inputSlider_typeof = function _typeof(obj) { return typeof obj; }; } else { inputSlider_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return inputSlider_typeof(obj); }









function inputSlider_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function inputSlider_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function inputSlider_createClass(Constructor, protoProps, staticProps) { if (protoProps) inputSlider_defineProperties(Constructor.prototype, protoProps); if (staticProps) inputSlider_defineProperties(Constructor, staticProps); return Constructor; }
function inputSlider_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) inputSlider_setPrototypeOf(subClass, superClass); }
function inputSlider_setPrototypeOf(o, p) { inputSlider_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return inputSlider_setPrototypeOf(o, p); }
function inputSlider_createSuper(Derived) { var hasNativeReflectConstruct = inputSlider_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = inputSlider_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = inputSlider_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return inputSlider_possibleConstructorReturn(this, result); }; }
function inputSlider_possibleConstructorReturn(self, call) { if (call && (inputSlider_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return inputSlider_assertThisInitialized(self); }
function inputSlider_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function inputSlider_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function inputSlider_getPrototypeOf(o) { inputSlider_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return inputSlider_getPrototypeOf(o); }
function inputSlider_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var InputSlider = /*#__PURE__*/function (_Component) {
  inputSlider_inherits(InputSlider, _Component);
  var _super = inputSlider_createSuper(InputSlider);
  function InputSlider(props) {
    var _this;
    inputSlider_classCallCheck(this, InputSlider);
    _this = _super.call(this, props);
    inputSlider_defineProperty(inputSlider_assertThisInitialized(_this), "sliding", false);
    inputSlider_defineProperty(inputSlider_assertThisInitialized(_this), "slideDelayTimeout", false);
    inputSlider_defineProperty(inputSlider_assertThisInitialized(_this), "skipClick", false);
    inputSlider_defineProperty(inputSlider_assertThisInitialized(_this), "clickSlider", function (event) {
      var readonly = _this.props.readonly;
      event.preventDefault();
      if (_this.skipClick || readonly) {
        _this.skipClick = false;
        return;
      }
      if (_this.sliding) {
        _this.sliding = false;
        return;
      }
      clearTimeout(_this.slideDelayTimeout);
      var progress = _this.getProgress(event);
      _this.setState(function () {
        return {
          progress: progress
        };
      }, function () {
        if (_this.props.onChange) {
          _this.props.onChange(progress);
        }
      });
    });
    inputSlider_defineProperty(inputSlider_assertThisInitialized(_this), "startSlide", function (event) {
      var readonly = _this.props.readonly;
      if (!isLeftMouseButtonPressed(event)) {
        return;
      }
      if (readonly) {
        _this.skipClick = true;
        return;
      }
      clearTimeout(_this.slideDelayTimeout);
      _this.slideDelayTimeout = setTimeout(function () {
        _this.sliding = true;
        document.addEventListener('mousemove', _this.onMouseMove);
        document.addEventListener('onmouseout', _this.stopSlide);
        document.addEventListener('mouseup', _this.stopSlide);
        _this.onMouseMove(event);
      }, 125);
    });
    inputSlider_defineProperty(inputSlider_assertThisInitialized(_this), "stopSlide", function (event) {
      _this.sliding = false;
      document.removeEventListener('mousemove', _this.onMouseMove);
      document.removeEventListener('onmouseout', _this.stopSlide);
      document.removeEventListener('mouseup', _this.stopSlide);
      if (_this.props.onChange) {
        _this.props.onChange(_this.state.progress);
      }
    });
    inputSlider_defineProperty(inputSlider_assertThisInitialized(_this), "onMouseMove", function (event) {
      var progress = _this.getProgress(event);
      _this.setState(function () {
        return {
          progress: progress
        };
      }, function () {
        if (_this.props.onSlide) {
          _this.props.onSlide(progress);
        }
      });
    });
    inputSlider_defineProperty(inputSlider_assertThisInitialized(_this), "getProgress", function (event) {
      var x = event.clientX;
      var rect = _this.slider.current.getBoundingClientRect();
      var progress = Math.min(100, Math.max(0, Math.round(100 * (x - rect.left) / rect.width)));
      return progress;
    });
    _this.slider = (0,preact_module/* createRef */.Vf)();
    _this.state = {
      progress: Math.max(0, Math.min(100, parseInt(_this.props.progress) || 0))
    };
    return _this;
  }
  inputSlider_createClass(InputSlider, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;
      if (!this.sliding) {
        if (prevProps.progress != this.props.progress) {
          this.setState(function () {
            return {
              progress: _this2.props.progress
            };
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        readonly = _this$props.readonly,
        addClassName = _this$props.addClassName;
      var progress = this.state.progress;
      return (0,preact_module.h)("div", {
        className: 'input-slider ' + (readonly ? 'readonly ' : '') + (addClassName ? addClassName : ''),
        ref: this.slider,
        onClick: !readonly ? this.clickSlider : null,
        onMouseDown: this.startSlide
      }, (0,preact_module.h)("span", {
        className: 'slider-range ' + (this.sliding ? 'sliding' : ''),
        ref: this.slider
      }, (0,preact_module.h)("span", {
        className: "slider-progress",
        style: {
          width: progress + '%'
        }
      }, (0,preact_module.h)("span", {
        className: "slider-holder"
      }))));
    }
  }]);
  return InputSlider;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/cells/tableCellProgressComponent.js
function tableCellProgressComponent_slicedToArray(arr, i) { return tableCellProgressComponent_arrayWithHoles(arr) || tableCellProgressComponent_iterableToArrayLimit(arr, i) || tableCellProgressComponent_unsupportedIterableToArray(arr, i) || tableCellProgressComponent_nonIterableRest(); }
function tableCellProgressComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tableCellProgressComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tableCellProgressComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tableCellProgressComponent_arrayLikeToArray(o, minLen); }
function tableCellProgressComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function tableCellProgressComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function tableCellProgressComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

















var tableCellProgressComponent_typeData = getTypeData('progress');

/**
 * Тип ячейки "прогресс"
 * @param { object } pos: {row, col}
 * @param { object } cellData: данные ячейки
 * @param { object } parents:
 * @param { object } parents.colData: данные колонки
 */
function TableCellProgress(_ref) {
  var pos = _ref.pos,
    parents = _ref.parents,
    cellData = _ref.cellData;
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    editable = _useContext.editable,
    setProp = _useContext.setProp,
    useRefs = _useContext.useRefs,
    useAction = _useContext.useAction,
    globalConfig = _useContext.globalConfig;
  var format = Object.assign({}, tableCellProgressComponent_typeData.format, parents.colData.format || {}, cellData.format || {});
  var initProgress = parseInt(cellData.progress) || parseInt(format.default) || 0;
  var _useState = (0,hooks_module/* useState */.eJ)(initProgress),
    _useState2 = tableCellProgressComponent_slicedToArray(_useState, 2),
    progress = _useState2[0],
    setProgress = _useState2[1];
  (0,hooks_module/* useEffect */.d4)(function () {
    var dataProgress = parseInt(cellData.progress) || 0;
    if (progress !== dataProgress) {
      setProgress(dataProgress);
    }
  }, [cellData.progress]);
  (0,hooks_module/* useEffect */.d4)(function () {
    if (progress !== format.default && isNaN(cellData.progress) && !isNaN(format.default)) {
      setProgress(format.default);
    }
  }, [format.default]);
  var editCell = function editCell(event) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (options.isEnter) {
      useAction.onAction({
        type: 'add-row-and-move-down'
      });
    }
    return true;
  };
  var onChange = function onChange(progress) {
    if (editable) {
      var _useRefs$links$col$po;
      onSlide(progress);
      setProp('progress', progress, {
        pos: pos,
        type: 'cell'
      });
      (_useRefs$links$col$po = useRefs.links.col[pos.col]) === null || _useRefs$links$col$po === void 0 ? void 0 : _useRefs$links$col$po.onCellChange(pos);
    }
  };
  var onSlide = function onSlide(progress) {
    if (editable) {
      setProgress(progress);
    }
  };

  //const progress = cellData.progress || 0
  useRefs.addToCell(pos, {
    value: progress,
    empty: progress === 0,
    editCell: editCell.bind(this)
  });
  var classes = ['table-progress'];
  if (format.type === 'colored') {
    if (progress < 30) {
      classes.push('progress-low');
    } else if (progress < 75) {
      classes.push('progress-middle');
    } else {
      classes.push('progress-high');
    }
  }
  return (0,preact_module.h)("div", {
    className: classes.join(' ')
  }, (0,preact_module.h)(InputSlider, {
    addClassName: "table-progress-slider",
    readonly: !editable || globalConfig.disableNonTextCellsEdit,
    progress: progress,
    onChange: onChange,
    onSlide: onSlide
  }), (0,preact_module.h)("span", {
    className: "progress-value table-text-common"
  }, progress, "%"));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/interface/checkboxComponent.js




/**
 * Чекбокс компонент
 * @param { boolean } editable
 * @param { boolean } checked
 * @param { function } onChange (state)
 * @param { useIcon } boolean - если true, для стилизации использовать компонент иконки, если false - бэкграунд
 */
function CheckboxComponent(_ref) {
  var editable = _ref.editable,
    checked = _ref.checked,
    onChange = _ref.onChange,
    _ref$useIcon = _ref.useIcon,
    useIcon = _ref$useIcon === void 0 ? false : _ref$useIcon;
  var onMouseDown = function onMouseDown(event) {
    event.stopPropagation();
    if (editable) {
      onChange === null || onChange === void 0 ? void 0 : onChange(!checked);
    }
  };
  var classes = ['checkbox-component'];
  if (checked) {
    classes.push('checked');
  }
  if (useIcon) {
    classes.push('checkbox-icon');
  }
  return (0,preact_module.h)("span", {
    className: classes.join(' '),
    onMouseDown: onMouseDown
  }, (0,preact_module.h)("span", {
    className: "checkbox-component-inner"
  }, (0,preact_module.h)(icons/* IconCheckboxChecked */.ry0, null)));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/cells/tableCellCheckboxComponent.js





/**
 * Тип ячейки checkbox
 * @param { object } pos: {row, col}
 * @param { object } cellData: данные ячейки
 */
function TableCellCheckbox(_ref) {
  var pos = _ref.pos,
    cellData = _ref.cellData;
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    editable = _useContext.editable,
    setProp = _useContext.setProp,
    useRefs = _useContext.useRefs;
  var editCell = function editCell(event) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (options.isEnter) {
      onChange(!cellData.checked);
    }
    return true;
  };
  var onChange = function onChange(checked) {
    if (editable) {
      var _useRefs$links$col$po;
      setProp('checked', checked, {
        pos: pos,
        type: 'cell'
      });
      (_useRefs$links$col$po = useRefs.links.col[pos.col]) === null || _useRefs$links$col$po === void 0 ? void 0 : _useRefs$links$col$po.onCellChange(pos);
    }
  };
  var value = cellData.checked ? true : false;
  var empty = !value;
  useRefs.addToCell(pos, {
    empty: empty,
    value: value,
    editCell: editCell.bind(this)
  });
  return (0,preact_module.h)(CheckboxComponent, {
    editable: editable,
    checked: cellData.checked,
    onChange: onChange
  });
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/cells/attachmentComponent.js















function attachmentComponent_slicedToArray(arr, i) { return attachmentComponent_arrayWithHoles(arr) || attachmentComponent_iterableToArrayLimit(arr, i) || attachmentComponent_unsupportedIterableToArray(arr, i) || attachmentComponent_nonIterableRest(); }
function attachmentComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function attachmentComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return attachmentComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return attachmentComponent_arrayLikeToArray(o, minLen); }
function attachmentComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function attachmentComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function attachmentComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }





/**
 * Тип ячейки attachment
 * @param { string } attachId: id аттача
 * @param { function } onAttachAction: действия, вызываемые аттачем
 */
function AttachmentComponent(_ref) {
  var attachId = _ref.attachId,
    onAttachAction = _ref.onAttachAction;
  var _useState = (0,hooks_module/* useState */.eJ)(null),
    _useState2 = attachmentComponent_slicedToArray(_useState, 2),
    blot = _useState2[0],
    setBlot = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(null),
    _useState4 = attachmentComponent_slicedToArray(_useState3, 2),
    attachmentType = _useState4[0],
    setAttachmentType = _useState4[1];
  var attachRef = (0,hooks_module/* useRef */.sO)(null);
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    editor = _useContext.editor,
    editable = _useContext.editable;
  var blotAction = function blotAction(blot, attachId, type, arg) {
    if (editable || type === 'click') {
      if (type === 'click') {
        var _blot$onFileDownload;
        blot === null || blot === void 0 ? void 0 : (_blot$onFileDownload = blot.onFileDownload) === null || _blot$onFileDownload === void 0 ? void 0 : _blot$onFileDownload.call(blot);
      } else {
        onAttachAction === null || onAttachAction === void 0 ? void 0 : onAttachAction(blot, attachId, type, arg);
      }
    }
    if (type === 'resolved' && blot.getFileKind) {
      setAttachmentType(blot.getFileKind());
    }
  };
  var childBlotIds = function childBlotIds() {
    var ids = [];
    if (attachRef && attachRef.current) {
      if (attachRef.current.children && attachRef.current.children.forEach) {
        attachRef.current.children.forEach(function (node) {
          if (node && node.classList) {
            if (node.classList.contains('file')) {
              ids.push(node.id);
            }
          }
        });
      }
    }
    return ids;
  };
  var attachBlot = function attachBlot(attachId) {
    if (attachId) {
      if (blot !== null && blot !== void 0 && blot.id && blot.id !== attachId) {
        detachBlot();
      }
      var ids = childBlotIds();
      if (!ids.includes(attachId)) {
        var _attachRef$current;
        var fileBlot = getAttachmentBlot(editor, attachId, {
          blotAction: blotAction
        });
        if (fileBlot && !(attachRef !== null && attachRef !== void 0 && (_attachRef$current = attachRef.current) !== null && _attachRef$current !== void 0 && _attachRef$current.childNodes.length)) {
          var _attachRef$current2;
          attachRef === null || attachRef === void 0 ? void 0 : (_attachRef$current2 = attachRef.current) === null || _attachRef$current2 === void 0 ? void 0 : _attachRef$current2.appendChild(fileBlot.domNode);
          fileBlot.attach();
          setBlot(fileBlot);
        }
      }
    }
  };
  var detachBlot = function detachBlot() {
    if (blot) {
      var _blot$isAttached;
      if ((_blot$isAttached = blot.isAttached) !== null && _blot$isAttached !== void 0 && _blot$isAttached.call(blot)) {
        blot.detach();
      }
      if (attachRef !== null && attachRef !== void 0 && attachRef.current && blot.domNode) {
        if (attachRef.current.contains(blot.domNode)) {
          attachRef.current.removeChild(blot.domNode);
        }
      }
    }
  };
  var useEffectFunction = editor.isExport() ? hooks_module/* useLayoutEffect */.bt : hooks_module/* useEffect */.d4;
  useEffectFunction(function () {
    attachBlot(attachId);
    return function () {
      detachBlot();
    };
  }, [attachId]);
  useEffectFunction(function () {
    if (blot) {
      blot.parentReadOnly = !editable;
    }
  }, [editable]);
  var classNames = ['attachment-item'];
  if (attachmentType) {
    classNames.push('is-' + attachmentType);
  }
  return (0,preact_module.h)("div", {
    ref: attachRef,
    className: classNames.join(' ')
  });
}
function getAttachmentBlot(editor, mapId) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var blotMap;
  if (!mapId && params.create) {
    var Blot = parchment_default().query('file');
    blotMap = editor.store.createMapForBlot(Blot, {
      type: 'file',
      mode: 'tableCell'
    });
    mapId = blotMap.get('id');
  } else {
    blotMap = editor.store.getMap(mapId);
    if (blotMap && blotMap.get('mode') !== 'tableCell') {
      blotMap.set('mode', 'tableCell');
    }
  }
  if (!mapId || !blotMap) {
    console.warn(mapId, blotMap);
    return;
  }
  var blot = parchment_default().create(blotMap.get('type'));
  blot.map = blotMap;
  blot.scroll = editor.scroll;
  blot.isSelectable = false;
  blot.dontFileNameTrim = true;
  blot.dontDetachWhenDND = true;
  blot.dontToggleViewMode = true;
  blot.kindsDefaultViewModes = {};
  if (params.blotAction) {
    blot.onAttachmentResolved = params.blotAction.bind(this, blot, mapId, 'resolved');
    blot.onFileNameClick = params.blotAction.bind(this, blot, mapId, 'click');
    blot.onFileClickMenuDelete = params.blotAction.bind(this, blot, mapId, 'delete');
    blot.onFileDelete = params.blotAction.bind(this, blot, mapId, 'delete');
    blot.onCompactViewClickAction = params.blotAction.bind(this, blot, mapId, 'click');
  } else {
    blot.parentReadOnly = true;
  }
  if (params.createFileBlot) {
    blot.createAttachBlot = params.createFileBlot;
  }
  return blot;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/cells/tableCellAttachmentComponent.js
function tableCellAttachmentComponent_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = tableCellAttachmentComponent_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

















function tableCellAttachmentComponent_slicedToArray(arr, i) { return tableCellAttachmentComponent_arrayWithHoles(arr) || tableCellAttachmentComponent_iterableToArrayLimit(arr, i) || tableCellAttachmentComponent_unsupportedIterableToArray(arr, i) || tableCellAttachmentComponent_nonIterableRest(); }
function tableCellAttachmentComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tableCellAttachmentComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tableCellAttachmentComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tableCellAttachmentComponent_arrayLikeToArray(o, minLen); }
function tableCellAttachmentComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function tableCellAttachmentComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function tableCellAttachmentComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }









var ATTACHMENT_MARGIN = 10;
var COUNTER_WIDTH = 35;

/**
 * Тип ячейки attachment
 * @param { object } pos: {row, col}
 * @param { object } cellData: данные ячейки
 */
function TableCellAttachment(_ref) {
  var _data$rowsData$pos$ro, _cellData$attachments;
  var pos = _ref.pos,
    parents = _ref.parents,
    cellRef = _ref.cellRef;
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    data = _useContext.data,
    editor = _useContext.editor,
    editable = _useContext.editable,
    setProp = _useContext.setProp,
    useRefs = _useContext.useRefs;
  var wrapRef = (0,hooks_module/* useRef */.sO)(null);
  var attachmentsWrapRef = (0,hooks_module/* useRef */.sO)(null);
  var counterRef = (0,hooks_module/* useRef */.sO)(null);
  var sortableRef = (0,hooks_module/* useRef */.sO)(null);
  var resizeObserver = (0,hooks_module/* useRef */.sO)(null);
  var _useState = (0,hooks_module/* useState */.eJ)({
      attachments: {}
    }),
    _useState2 = tableCellAttachmentComponent_slicedToArray(_useState, 2),
    that = _useState2[0],
    setThat = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(false),
    _useState4 = tableCellAttachmentComponent_slicedToArray(_useState3, 2),
    active = _useState4[0],
    setActive = _useState4[1];
  var cellData = ((_data$rowsData$pos$ro = data.rowsData[pos.row]) === null || _data$rowsData$pos$ro === void 0 ? void 0 : _data$rowsData$pos$ro.cellsData[pos.col]) || {};
  var attachsLength = (_cellData$attachments = cellData.attachments) === null || _cellData$attachments === void 0 ? void 0 : _cellData$attachments.length;
  var useEffectFunction = editor.isExport() ? hooks_module/* useLayoutEffect */.bt : hooks_module/* useEffect */.d4;
  var getAttachmentNodes = function getAttachmentNodes() {
    if (attachmentsWrapRef.current) {
      return Array.from(attachmentsWrapRef.current.childNodes).filter(function (node) {
        return node !== counterRef.current;
      });
    }
    return [];
  };
  var cleanMaxAttachments = function cleanMaxAttachments() {
    var children = getAttachmentNodes();
    var _iterator = tableCellAttachmentComponent_createForOfIteratorHelper(children),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var child = _step.value;
        if (child.classList.contains('invisible-attachment')) {
          child.classList.remove('invisible-attachment');
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
  var setMaxAttahcments = function setMaxAttahcments() {
    var children = getAttachmentNodes();
    var maxWidth = attachmentsWrapRef.current.getBoundingClientRect().width;
    var width = 0;
    var index = 0;
    var _iterator2 = tableCellAttachmentComponent_createForOfIteratorHelper(children),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var child = _step2.value;
        if (width < maxWidth) {
          var childWidth = child.getBoundingClientRect().width;
          var forCounterSpace = index === children.length - 1 && width + childWidth < maxWidth ? 0 : COUNTER_WIDTH;
          if (width === 0 || width + childWidth < maxWidth - forCounterSpace) {
            width += childWidth + ATTACHMENT_MARGIN;
            index++;
          } else {
            break;
          }
        } else {
          break;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    var attachmentsToHide = children.slice(index);
    var _iterator3 = tableCellAttachmentComponent_createForOfIteratorHelper(attachmentsToHide),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var attachNode = _step3.value;
        attachNode.classList.add('invisible-attachment');
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    if (counterRef.current) {
      var count = children.length - index;
      if (!count) {
        counterRef.current.classList.add('invisible-counter');
      } else if (counterRef.current.classList.contains('invisible-counter')) {
        counterRef.current.classList.remove('invisible-counter');
      }
      counterRef.current.innerText = '+' + count;
    }
  };
  var onResize = function onResize() {
    if (attachmentsWrapRef.current) {
      cleanMaxAttachments();
      setMaxAttahcments();
    }
  };
  (0,hooks_module/* useEffect */.d4)(function () {
    setTimeout(function () {
      onResize();
    }, 0);
  });
  useEffectFunction(function () {
    if (attachmentsWrapRef.current) {
      cleanMaxAttachments();
      if (!data.settings.wrapCells && !active) {
        setMaxAttahcments();
      }
    }
  }, [data.settings.wrapCells, active]);
  useResizeObserver(wrapRef, onResize);
  var editCell = function editCell(event) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (editable || attachsLength) {
      var _wrapRef$current, _wrapRef$current$getB;
      var rect = wrapRef === null || wrapRef === void 0 ? void 0 : (_wrapRef$current = wrapRef.current) === null || _wrapRef$current === void 0 ? void 0 : (_wrapRef$current$getB = _wrapRef$current.getBoundingClientRect) === null || _wrapRef$current$getB === void 0 ? void 0 : _wrapRef$current$getB.call(_wrapRef$current);
      setActive({
        rect: rect
      });
    }
    return true;
  };
  var endEdit = function endEdit() {
    setActive(false);
  };
  var onAttachAction = function onAttachAction(blot, attachId, type) {
    if (type === 'resolved') {
      var _blot$props;
      if (attachId && blot !== null && blot !== void 0 && (_blot$props = blot.props) !== null && _blot$props !== void 0 && _blot$props.attachment) {
        var _blot$props2;
        setAttachmentsData(attachId, blot === null || blot === void 0 ? void 0 : (_blot$props2 = blot.props) === null || _blot$props2 === void 0 ? void 0 : _blot$props2.attachment);
        if (blot !== null && blot !== void 0 && blot.id) {
          var attachmentsType = parseObject('object', cellData.attachmentsType) || {};
          var _blot$props$attachmen = blot.props.attachment,
            display_name = _blot$props$attachmen.display_name,
            mime = _blot$props$attachmen.mime,
            _type = _blot$props$attachmen.type,
            type_extra = _blot$props$attachmen.type_extra;
          attachmentsType[blot.id] = {
            display_name: display_name,
            mime: mime,
            type: _type,
            type_extra: parseObject('object', type_extra)
          };
          setProp('attachmentsType', attachmentsType, {
            pos: pos,
            type: 'cell'
          });
        }
      }
    } else if (type === 'delete') {
      var _attachments = parseObject('array', cellData.attachments);
      var _attachmentsType = parseObject('object', cellData.attachmentsType);
      var index = _attachments.indexOf(attachId);
      if (editable && index !== -1) {
        _attachments.splice(index, 1);
        delete _attachmentsType[attachId];
        setProp('attachments', _attachments, {
          pos: pos,
          type: 'cell',
          yArray: 'children'
        });
        setProp('attachmentsType', _attachmentsType, {
          pos: pos,
          type: 'cell'
        });
        // notify attachment watcher that blot has been removed
        // we have to do this here because table does not use the Container mixin
        editor.plugins.attachmentWatcher.onBlotRemoved({
          id: attachId
        });
      }
      if (that.attachments[attachId]) {
        delete that.attachments[attachId];
        setAttachmentsDataToCell();
      }
    }
  };
  var createFileBlot = function createFileBlot() {
    var _data$rowsData$pos$ro2, _data$rowsData$pos$ro3;
    var blot = getAttachmentBlot(editor, false, {
      create: true,
      createFileBlot: createFileBlot
    });
    var attachments = parseObject('array', (_data$rowsData$pos$ro2 = data.rowsData[pos.row]) === null || _data$rowsData$pos$ro2 === void 0 ? void 0 : (_data$rowsData$pos$ro3 = _data$rowsData$pos$ro2.cellsData[pos.col]) === null || _data$rowsData$pos$ro3 === void 0 ? void 0 : _data$rowsData$pos$ro3.attachments);
    attachments.push(blot.id);
    setProp('attachments', attachments, {
      pos: pos,
      type: 'cell',
      yArray: 'children'
    });
    return blot;
  };
  var onClickUpload = function onClickUpload(event) {
    if (editable) {
      editor.exec('add-file', {
        dontPutCaretAfter: true,
        createFileBlot: createFileBlot
      });
    }
  };
  var attachmentIds = parseObject('array', cellData.attachments);
  var attachments = attachmentIds.reduce(function (arr, attachId) {
    var component = (0,preact_module.h)(AttachmentComponent, {
      attachId: attachId,
      onAttachAction: onAttachAction
    });
    arr.push(component);
    return arr;
  }, []);
  useRefs.addToCell(pos, {
    value: attachsLength,
    empty: !attachsLength,
    editCell: editCell.bind(this),
    attachments: that.attachments,
    onDrop: createFileBlot
  });
  var setAttachmentsData = function setAttachmentsData(attachId, data) {
    if (!that.attachments.hasOwnProperty(attachId)) {
      that.attachments[attachId] = data;
      if (Object.keys(that.attachments).length === attachsLength) {
        setAttachmentsDataToCell();
      }
    }
  };
  var setAttachmentsDataToCell = function setAttachmentsDataToCell() {
    var _parents$colData, _parents$colData$summ;
    useRefs.addToCell(pos, {
      attachments: that.attachments
    });
    // Вызываем обновление панели суммирования только если нужно посчитать размер файлов
    if (['filesize_min', 'filesize_max'].includes((_parents$colData = parents.colData) === null || _parents$colData === void 0 ? void 0 : (_parents$colData$summ = _parents$colData.summary) === null || _parents$colData$summ === void 0 ? void 0 : _parents$colData$summ.mode)) {
      var _useRefs$links$summar;
      (_useRefs$links$summar = useRefs.links.summary[pos.col]) === null || _useRefs$links$summar === void 0 ? void 0 : _useRefs$links$summar.render();
    }
  };
  var wrapStyle = {};
  var component;
  if (attachments.length || active) {
    var i18n = editor.plugins.i18n;
    var moreButton;
    var listWrapClasses = ['table-attachment'];
    if (!data.settings.wrapCells) {
      listWrapClasses.push('no-wrap-attachmens-cell');
    }
    if (active) {
      listWrapClasses.push('active');
      if (active.rect) {
        wrapStyle.height = active.rect.height;
      }
      if (editable) {
        moreButton = (0,preact_module.h)("div", {
          className: "float-head"
        }, (0,preact_module.h)("div", {
          className: "upload-button"
        }, (0,preact_module.h)("div", {
          className: "upload-more",
          onClick: onClickUpload
        }, (0,preact_module.h)("span", {
          className: "circle"
        }, (0,preact_module.h)(icons/* IconPlus */.SC9, null)), (0,preact_module.h)("span", null, i18n.get('table.attachment.upload_more')))));
      }
    }
    var attachmentsList = (0,preact_module.h)("div", {
      ref: attachmentsWrapRef,
      className: listWrapClasses.join(' ')
    }, attachments, !active ? (0,preact_module.h)("span", {
      className: "nowrap-plus",
      ref: counterRef
    }) : null);
    component = (0,preact_module.h)(FloatComponent, {
      container: cellRef === null || cellRef === void 0 ? void 0 : cellRef.current,
      onWantsToClose: endEdit,
      disabled: !active
    }, moreButton, attachmentsList);
  }
  var onSortableChange = function onSortableChange(children, _ref2) {
    var scrollTop = _ref2.scrollTop;
    if (editable) {
      var _attachments2 = children.map(function (child) {
        if (child) {
          var blotNode = child.querySelector('.file');
          if (blotNode && blotNode.id) {
            return blotNode.id;
          }
        }
        return null;
      }).filter(function (id) {
        return id !== null;
      });
      setProp('attachments', _attachments2, {
        pos: pos,
        type: 'cell',
        yArray: 'children'
      });
      setAttachmentsDataToCell();
      // возвращаем скролл в положение, котором он был, хуками не получилось сделать
      setTimeout(function () {
        if (attachmentsWrapRef.current && typeof scrollTop !== 'undefined') {
          if (scrollTop > attachmentsWrapRef.current.scrollHeight - attachmentsWrapRef.current.clientHeight) {
            scrollTop = attachmentsWrapRef.current.scrollHeight - attachmentsWrapRef.current.clientHeight;
          }
          attachmentsWrapRef.current.scrollTop = scrollTop;
        }
      }, 50);
    }
  };
  useEffectFunction(function () {
    if (attachmentsWrapRef.current && editable) {
      sortableRef.current = new sortable(attachmentsWrapRef.current, {
        selector: '.attachment-item',
        onChange: onSortableChange,
        allowedSortContainerClass: 'active',
        allowPullItemsOut: false,
        autoscroll: true
      });
      return function () {
        if (sortableRef.current) {
          sortableRef.current.destroy();
          sortableRef.current = null;
        }
      };
    }
  }, [attachmentsWrapRef.current]);
  return component ? (0,preact_module.h)("div", {
    ref: wrapRef,
    style: wrapStyle,
    className: "table-attachment-wrap"
  }, component) : null;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/mention.js
function generateMentionId() {
  var mid = "";
  var allowed = "abcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < 6; i++) {
    mid += allowed.charAt(Math.floor(Math.random() * allowed.length));
  }
  return mid;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/interface/collaborateComponent.js

function collaborateComponent_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function collaborateComponent_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { collaborateComponent_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { collaborateComponent_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function collaborateComponent_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = collaborateComponent_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function collaborateComponent_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function collaborateComponent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { collaborateComponent_ownKeys(Object(source), true).forEach(function (key) { collaborateComponent_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { collaborateComponent_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function collaborateComponent_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function collaborateComponent_slicedToArray(arr, i) { return collaborateComponent_arrayWithHoles(arr) || collaborateComponent_iterableToArrayLimit(arr, i) || collaborateComponent_unsupportedIterableToArray(arr, i) || collaborateComponent_nonIterableRest(); }
function collaborateComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function collaborateComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return collaborateComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return collaborateComponent_arrayLikeToArray(o, minLen); }
function collaborateComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function collaborateComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function collaborateComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



























var colorKeys = Object.keys(avatarcolors);

/**
 * Компонент "участники"
 * @param { object } editor
 * @param { boolean } editable: разрешение редактировать список
 * @param { boolean } nowrap: однострочный режим, отображается первый участник и символ + с числом оставшихся
 * @param { function } onChange: функция, вызываемая при изменении, возвращает {object} users
 * @param { function } onEndEdit: функция, вызываемая при выходе из редактирования
 * @param { event } editEvent: event передаваемый родительским компонентом, при его изменении запускается редактирование
 * @param { object } users: участники
 *    {
 *      [object_id]: {object_id, name},
 *      ...
 *    }
 */
var MAX_SEARCH_RESULTS = 15;
function CollaborateComponent(_ref) {
  var _this = this,
    _searchResult$result3,
    _searchResult$result4;
  var editor = _ref.editor,
    editable = _ref.editable,
    _ref$users = _ref.users,
    users = _ref$users === void 0 ? {} : _ref$users,
    nowrap = _ref.nowrap,
    onChange = _ref.onChange,
    onEndEdit = _ref.onEndEdit,
    editEvent = _ref.editEvent;
  var i18n = editor.plugins.i18n;
  var _useState = (0,hooks_module/* useState */.eJ)(false),
    _useState2 = collaborateComponent_slicedToArray(_useState, 2),
    opened = _useState2[0],
    setOpened = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(null),
    _useState4 = collaborateComponent_slicedToArray(_useState3, 2),
    searchResult = _useState4[0],
    setSearchResult = _useState4[1];
  var containerRef = (0,hooks_module/* useRef */.sO)(null);
  var usersIds = Object.keys(users);
  var searchText, searchTimeout;
  var search = function search(text) {
    var mentionManager = editor.plugins.mentionManager;
    if (text === (searchResult === null || searchResult === void 0 ? void 0 : searchResult.text)) {
      return;
    }
    searchText = text;
    // Таймаут, чтобы не запускать поиск на каждый символ при быстром наборе текста
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(function () {
      mentionManager.searchItems(text, 'user', MAX_SEARCH_RESULTS).then(function (result) {
        // Игнорируем результат, если запущен новый поиск
        if (text === searchText) {
          setSearchResult(collaborateComponent_objectSpread({
            text: text
          }, {
            result: result
          }));
        }
      });
    }, 100);
  };
  var getFromSearchResults = function getFromSearchResults(userId) {
    var _searchResult$result;
    if (userId && searchResult !== null && searchResult !== void 0 && (_searchResult$result = searchResult.result) !== null && _searchResult$result !== void 0 && _searchResult$result.user) {
      var _searchResult$result2;
      userId = String(userId);
      var _iterator = collaborateComponent_createForOfIteratorHelper(searchResult === null || searchResult === void 0 ? void 0 : (_searchResult$result2 = searchResult.result) === null || _searchResult$result2 === void 0 ? void 0 : _searchResult$result2.user),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var user = _step.value;
          if (user !== null && user !== void 0 && user.object_id && String(user.object_id) === userId) {
            return user;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return false;
  };
  (0,hooks_module/* useEffect */.d4)(function () {
    if (opened) {
      search(searchText || '');
    }
  }, [opened]);
  (0,hooks_module/* useEffect */.d4)(function () {
    if (editEvent) {
      openDropdown(editEvent);
    }
  }, [editEvent]);
  var onClick = function onClick(event) {
    openDropdown();
  };
  var onInput = function onInput(text) {
    search(text);
  };
  var onSelect = function onSelect(key, text) {
    if (key) {
      var user = getFromSearchResults(key);
      if (user) {
        var newUsers = Object.assign({}, users);
        newUsers[key] = Object.assign({
          mention_id: generateMentionId()
        }, user);
        onChange === null || onChange === void 0 ? void 0 : onChange(newUsers);
      }
    } else {
      closeDropdown();
    }
  };
  var onRemoveMouseDown = function onRemoveMouseDown(userId, event) {
    event === null || event === void 0 ? void 0 : event.preventDefault();
    removeItem(userId);
  };
  var removeItem = function removeItem(userId) {
    if (editable) {
      var newUsers = Object.assign({}, users);
      if (newUsers[userId]) {
        delete newUsers[userId];
        onChange === null || onChange === void 0 ? void 0 : onChange(newUsers);
      }
    }
  };
  var openDropdown = function openDropdown(event) {
    if (!opened) {
      if (editable || nowrap && usersIds.length > 1) {
        var rect = containerRef.current.getBoundingClientRect();
        setOpened(rect);
        /*
        if (event?.key?.length === 1) {
          search(event.key)
        }
        */
      }
    }
  };

  var closeDropdown = /*#__PURE__*/function () {
    var _ref2 = collaborateComponent_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setOpened(null);
              _context.next = 3;
              return timeout(1);
            case 3:
              onEndEdit === null || onEndEdit === void 0 ? void 0 : onEndEdit(event);
            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function closeDropdown(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var componentClasses = ['collaborate-component'];
  var listClasses = ['collaborate-list'];
  var getAvatar = function getAvatar() {
    var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var letter,
      color,
      code = 0;
    var name = user.name || user.user_name;
    if (name) {
      letter = name[0].toUpperCase();
      var _iterator2 = collaborateComponent_createForOfIteratorHelper(name),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var char = _step2.value;
          code += char.charCodeAt();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    } else {
      letter = '?';
      code = letter.charCodeAt();
    }
    color = avatarcolors[colorKeys[code % colorKeys.length]];
    return (0,preact_module.h)("span", {
      className: "user-avatar",
      style: {
        background: color
      }
    }, letter);
  };
  var plusComponent,
    plus = 0;
  var userItems = usersIds.reduce(function (data, userId, n) {
    if (nowrap && n > 0 && !opened) {
      plus++;
      return data;
    }
    var user = users[userId];
    var avatar = getAvatar(user);
    var userName = user.name || i18n.get('table.collaborator.unknown');
    var remove;
    if (opened && editable) {
      remove = (0,preact_module.h)("span", {
        className: "collaborate-item-remove",
        onMouseDown: onRemoveMouseDown.bind(_this, userId)
      }, (0,preact_module.h)(icons/* IconCross */.WcQ, null));
    }
    data[userId] = (0,preact_module.h)("span", {
      "data-mention-type": "user",
      className: "collaborate-item",
      "data-mention-name": userName,
      "data-user-id": user.object_id,
      "data-mention-id": user.mention_id
    }, (0,preact_module.h)("span", {
      className: "collaborate-item-img"
    }, avatar), (0,preact_module.h)("span", {
      className: "collaborate-item-name"
    }, (0,preact_module.h)("span", {
      className: "collaborate-item-text searchable"
    }, userName)), remove);
    return data;
  }, {});
  if (!opened && plus) {
    listClasses.push('collaborate-list-plus');
    plusComponent = (0,preact_module.h)("span", {
      className: "nowrap-plus"
    }, "+", plus);
  }
  var searchItems = searchResult === null || searchResult === void 0 ? void 0 : (_searchResult$result3 = searchResult.result) === null || _searchResult$result3 === void 0 ? void 0 : (_searchResult$result4 = _searchResult$result3.user) === null || _searchResult$result4 === void 0 ? void 0 : _searchResult$result4.reduce(function (data, user) {
    var avatar = getAvatar(user);
    if (!usersIds.includes(String(user.object_id))) {
      data[user.object_id] = (0,preact_module.h)("span", {
        className: "collaborate-item",
        "data-user-id": user.object_id
      }, (0,preact_module.h)("span", {
        className: "collaborate-item-img"
      }, avatar), (0,preact_module.h)("span", {
        className: "collaborate-item-name"
      }, (0,preact_module.h)("span", {
        className: "collaborate-item-text"
      }, user.name)));
    }
    return data;
  }, {});
  var content;
  if (!opened) {
    content = (0,preact_module.h)("div", {
      className: listClasses.join(' ')
    }, Object.values(userItems), plusComponent);
  } else {
    content = (0,preact_module.h)(DropdownComponent, {
      float: true,
      editor: editor,
      editable: editable,
      onInput: onInput,
      onSelect: onSelect,
      onRemoveItem: removeItem,
      selectedItems: userItems,
      searchItems: searchItems,
      loadingMessage: i18n.get('table.collaborator.loading'),
      noResultMessage: i18n.get('table.collaborator.no_result'),
      placeholder: i18n.get('table.collaborator.placeholder'),
      onWantsToClose: closeDropdown,
      container: containerRef === null || containerRef === void 0 ? void 0 : containerRef.current,
      adjustToParent: true,
      corrective: {
        top: -1,
        left: -1
      }
    });
  }
  var componentStyle = {};
  if (opened) {
    componentStyle.width = opened.width;
    componentStyle.height = opened.height;
  }
  return (0,preact_module.h)("div", {
    ref: containerRef,
    style: componentStyle,
    className: componentClasses.join(' '),
    onClick: onClick
  }, content);
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/cells/tableCellCollaboarateComponent.js











function tableCellCollaboarateComponent_slicedToArray(arr, i) { return tableCellCollaboarateComponent_arrayWithHoles(arr) || tableCellCollaboarateComponent_iterableToArrayLimit(arr, i) || tableCellCollaboarateComponent_unsupportedIterableToArray(arr, i) || tableCellCollaboarateComponent_nonIterableRest(); }
function tableCellCollaboarateComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tableCellCollaboarateComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tableCellCollaboarateComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tableCellCollaboarateComponent_arrayLikeToArray(o, minLen); }
function tableCellCollaboarateComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function tableCellCollaboarateComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function tableCellCollaboarateComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }






/**
 * Тип ячейки collaborate
 * @param { object } pos: {row, col}
 * @param { object } cellData: данные ячейки
 * @param { function } onEndEdit: событие вызываемое при завершении редаткирования
 */
function TableCellCollaborate(_ref) {
  var pos = _ref.pos,
    cellData = _ref.cellData,
    onEndEdit = _ref.onEndEdit;
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    data = _useContext.data,
    editor = _useContext.editor,
    editable = _useContext.editable,
    setProp = _useContext.setProp,
    useRefs = _useContext.useRefs,
    globalConfig = _useContext.globalConfig;
  var _useState = (0,hooks_module/* useState */.eJ)(null),
    _useState2 = tableCellCollaboarateComponent_slicedToArray(_useState, 2),
    editEvent = _useState2[0],
    setEditEvent = _useState2[1];
  var editCell = function editCell(event) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setEditEvent(event);
    return true;
  };
  var onChange = function onChange() {
    var users = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (editable) {
      var _useRefs$links$col$po;
      setProp('users', users, {
        pos: pos,
        type: 'cell'
      });
      (_useRefs$links$col$po = useRefs.links.col[pos.col]) === null || _useRefs$links$col$po === void 0 ? void 0 : _useRefs$links$col$po.onCellChange(pos);
    }
  };
  var users = parseObject('object', cellData.users);
  var length = Object.keys(users).length;
  useRefs.addToCell(pos, {
    value: length,
    empty: length === 0,
    editCell: editCell.bind(this)
  });
  return length || editEvent ? (0,preact_module.h)(CollaborateComponent, {
    editor: editor,
    users: users,
    editEvent: editEvent,
    editable: editable && !globalConfig.disableNonTextCellsEdit,
    onChange: onChange,
    onEndEdit: onEndEdit,
    nowrap: !data.settings.wrapCells
  }) : null;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/tableCellComponent.js
function tableCellComponent_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function tableCellComponent_extends() { tableCellComponent_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tableCellComponent_extends.apply(this, arguments); }














function tableCellComponent_slicedToArray(arr, i) { return tableCellComponent_arrayWithHoles(arr) || tableCellComponent_iterableToArrayLimit(arr, i) || tableCellComponent_unsupportedIterableToArray(arr, i) || tableCellComponent_nonIterableRest(); }
function tableCellComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tableCellComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tableCellComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tableCellComponent_arrayLikeToArray(o, minLen); }
function tableCellComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function tableCellComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function tableCellComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

















function TableCellComponent(props) {
  var _data$rowsData$pos$ro;
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    data = _useContext.data,
    editable = _useContext.editable,
    useRefs = _useContext.useRefs,
    useMenu = _useContext.useMenu,
    tableExec = _useContext.tableExec,
    useResize = _useContext.useResize,
    useSelection = _useContext.useSelection,
    globalConfig = _useContext.globalConfig,
    renderWithFilter = _useContext.renderWithFilter,
    editor = _useContext.editor;
  var cellType = props.cellType,
    pos = props.pos,
    _props$rowProps = props.rowProps,
    rowProps = _props$rowProps === void 0 ? {} : _props$rowProps;
  var cellData = ((_data$rowsData$pos$ro = data.rowsData[pos.row]) === null || _data$rowsData$pos$ro === void 0 ? void 0 : _data$rowsData$pos$ro.cellsData[pos.col]) || {};
  var parents = {
    colData: data.colsData[pos.col] || {},
    rowData: data.rowsData[pos.row] || {}
  };
  var _useState = (0,hooks_module/* useState */.eJ)({
      ver: 0
    }),
    _useState2 = tableCellComponent_slicedToArray(_useState, 2),
    update = _useState2[0],
    setUpdate = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(false),
    _useState4 = tableCellComponent_slicedToArray(_useState3, 2),
    current = _useState4[0],
    setCurrent = _useState4[1];
  var _useState5 = (0,hooks_module/* useState */.eJ)(false),
    _useState6 = tableCellComponent_slicedToArray(_useState5, 2),
    selected = _useState6[0],
    setSelected = _useState6[1];
  var _useState7 = (0,hooks_module/* useState */.eJ)(false),
    _useState8 = tableCellComponent_slicedToArray(_useState7, 2),
    editing = _useState8[0],
    setEditingState = _useState8[1];
  var _useState9 = (0,hooks_module/* useState */.eJ)(false),
    _useState10 = tableCellComponent_slicedToArray(_useState9, 2),
    dropTarget = _useState10[0],
    setDrop = _useState10[1];
  var _useState11 = (0,hooks_module/* useState */.eJ)(false),
    _useState12 = tableCellComponent_slicedToArray(_useState11, 2),
    isResizeProcess = _useState12[0],
    setIsResizePrecess = _useState12[1];
  var _useState13 = (0,hooks_module/* useState */.eJ)(null),
    _useState14 = tableCellComponent_slicedToArray(_useState13, 2),
    commentsCount = _useState14[0],
    setCommentsCountState = _useState14[1];
  var setEditing = function setEditing(value) {
    if (renderWithFilter()) {
      if (value === false) {
        setTimeout(function () {
          tableExec('table-selection-update');
        }, 0);
      }
    }
    setEditingState(value);
  };
  var setCommentsCount = function setCommentsCount(value) {
    setCommentsCountState(value);
  };
  var getCommentsCount = function getCommentsCount() {
    return commentsCount;
  };
  var onCommentsCounterClick = function onCommentsCounterClick(event) {
    event.preventDefault();
    tableExec('comment-cell', {
      pos: pos
    });
  };
  var typeData = getTypeData(cellType);
  var cellProps = {};
  for (var attr in CONFIG.cell.attrs) {
    var _ref, _val;
    var val = void 0;
    if (cellData.hasOwnProperty(attr)) {
      val = cellData[attr];
    } else {
      for (var key in CONFIG.cell.inherit) {
        if (CONFIG.cell.inherit[key].includes(attr)) {
          var _parents$key;
          if ((_parents$key = parents[key]) !== null && _parents$key !== void 0 && _parents$key.hasOwnProperty(attr)) {
            val = parents[key][attr];
            break;
          }
        }
      }
    }
    val = (_ref = (_val = val) !== null && _val !== void 0 ? _val : CONFIG.cell.props[attr]) !== null && _ref !== void 0 ? _ref : null;
    if (val !== null) {
      cellProps[CONFIG.cell.attrs[attr]] = val;
    }
  }
  if (!cellData.cellType) {
    var columnType = parents.colData.columnType;
    if (columnType && columnType !== 'none') {
      cellData.cellType = columnType;
    } else {
      cellData.cellType = 'text';
    }
  }
  var cellRef = (0,hooks_module/* useRef */.sO)(null);
  var getNode = function getNode() {
    return cellRef === null || cellRef === void 0 ? void 0 : cellRef.current;
  };
  var isMouseInResizeArea = function isMouseInResizeArea(event) {
    var resizeMode = false;
    var resizePos = Object.assign({}, pos);
    var rect = getNode().getBoundingClientRect();
    var right = Math.abs(rect.width - event.offsetX);
    var bottom = Math.abs(rect.height - event.offsetY);
    if (right <= CONFIG.resize.offset) {
      resizeMode = 'col';
      resizePos.col += (cellProps.colspan || 1) - 1;
    } else if (bottom <= CONFIG.resize.offset) {
      resizeMode = 'row';
      resizePos.row += (cellProps.rowspan || 1) - 1;
    }
    return {
      resizeMode: resizeMode,
      resizePos: resizePos
    };
  };
  var onContextMenu = function onContextMenu(event) {
    if (globalConfig.enableMenu !== false) {
      event.preventDefault();
      useMenu.toggleMenu(event, 'cell');
    }
  };
  var onMenuButton = function onMenuButton(event) {
    if (!useSelection.inSelection(pos)) {
      useSelection.setCurrent(pos, {
        session: false
      });
    }
    useMenu.toggleMenu(event, 'cell', getNode());
  };
  var onMouseDown = function onMouseDown(event) {
    var processed = false;
    var selectionKey = (event === null || event === void 0 ? void 0 : event.metaKey) || (event === null || event === void 0 ? void 0 : event.ctrlKey) || (event === null || event === void 0 ? void 0 : event.shiftKey);
    if (!selectionKey && event.target === getNode()) {
      var _isMouseInResizeArea = isMouseInResizeArea(event),
        resizeMode = _isMouseInResizeArea.resizeMode,
        resizePos = _isMouseInResizeArea.resizePos;
      if (resizeMode !== false) {
        processed = true;
        setIsResizePrecess(true);
        useResize.sessionStart(resizeMode, resizePos);
      }
    }
    if (!processed) {
      if (selectionKey) {
        useSelection.setSelection(pos, {
          force: true
        });
      } else if (!selected || event.button !== 2) {
        useSelection.setCurrent(pos, {
          session: true
        });
      }
    }
  };
  var onMouseEnter = function onMouseEnter(event) {
    if (event.target === getNode()) {
      useSelection.setSelection(pos);
    }
  };
  var cellLink = function cellLink() {
    var _useRefs$links$cell$p;
    return (_useRefs$links$cell$p = useRefs.links.cell[pos.row]) === null || _useRefs$links$cell$p === void 0 ? void 0 : _useRefs$links$cell$p[pos.col];
  };
  var scrollIntoView = function scrollIntoView() {
    if (cellRef !== null && cellRef !== void 0 && cellRef.current) {
      var _useRefs$links$ui$scr;
      // && globalConfig.mobile) {
      (_useRefs$links$ui$scr = useRefs.links.ui.scroll) === null || _useRefs$links$ui$scr === void 0 ? void 0 : _useRefs$links$ui$scr.scrollTo(cellRef === null || cellRef === void 0 ? void 0 : cellRef.current, {
        offset: 0
      });
    }
  };
  var onEditAction = function onEditAction(event) {
    var _cellLink, _cellLink$editCell;
    event.stopPropagation();
    if (isResizeProcess) {
      setIsResizePrecess(false);
      if (event.type === 'click') {
        return;
      }
    }
    if (isMouseInResizeArea(event).resizeMode !== false) return;
    scrollIntoView();
    (_cellLink = cellLink()) === null || _cellLink === void 0 ? void 0 : (_cellLink$editCell = _cellLink.editCell) === null || _cellLink$editCell === void 0 ? void 0 : _cellLink$editCell.call(_cellLink, event, {
      isMouse: true
    });
  };
  var onEndEdit = function onEndEdit() {
    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (options.select) {
      useSelection.setCurrent(pos);
    }
    tableExec('focus');
  };
  var emptyCell = function emptyCell() {
    if (editable) {
      tableExec('clear-cells', {
        start: pos
      });
    }
  };
  var onDragEnter = function onDragEnter(event) {
    var _parents$colData;
    var columnType = (_parents$colData = parents.colData) === null || _parents$colData === void 0 ? void 0 : _parents$colData.columnType;
    var allow = false;
    if (!columnType || ['none', 'attachment'].includes(columnType)) {
      var _cellLink2;
      if (cellData.cellType === 'attachment' || (_cellLink2 = cellLink()) !== null && _cellLink2 !== void 0 && _cellLink2.empty) {
        allow = true;
      }
    }
    useRefs.setPointer('drop', allow ? pos : false);
  };

  /**
   * Метод позволяет обновить ячейку без обновления всей таблицы
   * @param {object} options?
   * @param {boolean} options.withSummary?: вызывать обновление summary после обновления ячейки
   */
  var renderCell = function renderCell() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    setUpdate({
      ver: update.ver + 1,
      withSummary: options.withSummary ? true : false
    });
  };
  (0,hooks_module/* useEffect */.d4)(function () {
    if (update.withSummary) {
      var _useRefs$links$summar;
      (_useRefs$links$summar = useRefs.links.summary[pos.col]) === null || _useRefs$links$summar === void 0 ? void 0 : _useRefs$links$summar.render();
    }
  }, [update]);
  var getText = function getText() {
    var selfRef = useRefs.getCell(pos);
    var text = editor.plugins.i18n.get('table.menu.type.' + cellData.cellType);
    if (!['attachment', 'rating', 'progress', 'checkbox', 'singleselect', 'multiselect', 'collaborator'].includes(cellData.cellType)) {
      if (selfRef && !selfRef.empty) {
        var clonedNode = getNode().cloneNode(true);
        var commentNode = clonedNode.querySelector('.table-cell-comments-counter');
        if (commentNode) {
          clonedNode.removeChild(commentNode);
        }
        text = clonedNode.innerText;
      }
    }
    return text;
  };
  useRefs.setCell(pos, {
    cellProps: cellProps,
    type: cellData.type,
    cellData: cellData,
    getNode: getNode.bind(this),
    render: renderCell.bind(this),
    setDrop: setDrop.bind(this),
    setCurrent: setCurrent.bind(this),
    setSelected: setSelected.bind(this),
    onMenuButton: onMenuButton.bind(this),
    onDragEnter: onDragEnter.bind(this),
    scrollIntoView: scrollIntoView.bind(this),
    setCommentsCount: setCommentsCount.bind(this),
    getCommentsCount: getCommentsCount.bind(this),
    getText: getText.bind(this)
  });
  var classes = [];
  if (!cellData.hidden) {
    if (current) {
      classes.push('current', 'selected');
    } else if (selected) {
      classes.push('selected');
    }
    if (editing) {
      classes.push('editing');
    }
    if (dropTarget) {
      classes.push('dnd-highlight');
    }
  }
  var childStyle = function childStyle() {
    var style = {};
    if (cellData.child || typeData.style) {
      var typeStyle = typeData.style || {};
      var _childStyle = cellData.child || {};
      for (var _attr in CONFIG.child.style) {
        var _childStyle$_attr;
        var item = CONFIG.child.style[_attr];
        var _val2 = (_childStyle$_attr = _childStyle[_attr]) !== null && _childStyle$_attr !== void 0 ? _childStyle$_attr : typeStyle[_attr];
        if (_val2 && _val2 !== item.default) {
          style[item.prop] = _val2;
        }
      }
    }
    return style;
  };
  var touch = function touch() {
    var id = tableExec('touch', {
      type: 'cell',
      pos: pos
    });
    return id;
  };
  var cellAttrs = {
    pos: pos,
    cellType: cellType,
    cellRef: cellRef,
    cellData: cellData,
    cellProps: cellProps,
    rowProps: rowProps,
    parents: parents,
    editing: editing,
    setEditing: setEditing,
    emptyCell: emptyCell,
    onEndEdit: onEndEdit
  };

  // Режим активации редактирования по одинарному или двойному клику
  var allowNotEditable = false;
  var doubleClickToEdit = false;
  var nonTextType = false;
  var component;
  switch (cellType) {
    case 'text':
      doubleClickToEdit = true;
      component = (0,preact_module.h)(TableCellTextComponent, tableCellComponent_extends({}, cellAttrs, {
        childStyle: childStyle()
      }));
      break;
    case 'number':
    case 'currency':
      doubleClickToEdit = true;
      component = (0,preact_module.h)(TableCellNumberComponent, tableCellComponent_extends({}, cellAttrs, {
        childStyle: childStyle()
      }));
      break;
    case 'mention':
      //nonTextType = true
      classes.push('cell-mention', 'table-text-common');
      component = (0,preact_module.h)(TableCellMentionComponent, cellAttrs);
      break;
    case 'link':
      nonTextType = true;
      allowNotEditable = true;
      component = (0,preact_module.h)(TableCellLinkComponent, cellAttrs);
      break;
    case 'checkbox':
      component = (0,preact_module.h)(TableCellCheckbox, cellAttrs);
      break;
    case 'collaborator':
      nonTextType = true;
      allowNotEditable = true;
      classes.push('full-height', 'cell-collaborator');
      component = (0,preact_module.h)(TableCellCollaborate, cellAttrs);
      break;
    case 'singleselect':
    case 'multiselect':
      nonTextType = true;
      allowNotEditable = true;
      classes.push('full-height', 'cell-select');
      component = (0,preact_module.h)(TableCellSelect, cellAttrs);
      break;
    case 'rating':
      nonTextType = true;
      component = (0,preact_module.h)(TableCellRating, cellAttrs);
      break;
    case 'progress':
      nonTextType = true;
      classes.push('cell-progress');
      component = (0,preact_module.h)(TableCellProgress, cellAttrs);
      break;
    case 'date':
      //nonTextType = true
      classes.push('cell-date', 'table-text-common');
      component = (0,preact_module.h)(TableCellDate, tableCellComponent_extends({}, cellAttrs, {
        touch: touch
      }));
      break;
    case 'attachment':
      nonTextType = true;
      allowNotEditable = true;
      classes.push('cell-attachment');
      component = (0,preact_module.h)(TableCellAttachment, {
        pos: pos,
        cellRef: cellRef,
        cellData: cellData,
        parents: parents
      });
      break;
    default:
      console.warn('Unknown cell type', cellType);
  }
  var listeners = {};
  if (!cellData.hidden) {
    var disabledByConfig = globalConfig.disableNonTextCellsEdit && nonTextType;
    var singleTapEditByConfig = globalConfig.singleTapEdit || false;
    // Какой тип клика слушать для редактирования: двойной или одинарный
    // Зависит от типа ячейки
    var editListener = doubleClickToEdit && !singleTapEditByConfig ? 'onDoubleClick' : 'onClick';
    if (editable) {
      // В будущем хотели разрешить выделение в залоченной таблице
      // Первый assign надо вынести из условия (editable) и прорабатывать само выделение
      Object.assign(listeners, !globalConfig.mobile ? {
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter
      } : {
        onTouchStart: onMouseDown
      });
      if (!disabledByConfig) {
        Object.assign(listeners, tableCellComponent_defineProperty({
          onContextMenu: onContextMenu,
          ondragenter: onDragEnter
        }, editListener, onEditAction));
      }
    } else if (allowNotEditable) {
      if (!disabledByConfig) {
        Object.assign(listeners, tableCellComponent_defineProperty({}, editListener, onEditAction));
      }
    }
  }
  if (classes.length) {
    cellProps.className = classes.join(' ');
  }
  var COMMENT_ATTRS = {};
  if (commentsCount !== null) {
    COMMENT_ATTRS[tooltipManager/* TOOLTIP_ATTR */.qZ] = editor.plugins.i18n.get('table.comments.tooltip.' + (commentsCount === 1 ? 'one' : 'more'));
  }
  return (0,preact_module.h)("td", tableCellComponent_extends({
    ref: cellRef
  }, listeners, cellProps), commentsCount !== null && (0,preact_module.h)("span", tableCellComponent_extends({
    className: "table-cell-comments-counter",
    onClick: onCommentsCounterClick
  }, COMMENT_ATTRS), commentsCount > 9 ? '9+' : commentsCount), component);
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/moveTableRow.js
function moveTableRow_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { moveTableRow_typeof = function _typeof(obj) { return typeof obj; }; } else { moveTableRow_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return moveTableRow_typeof(obj); }









function moveTableRow_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function moveTableRow_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) moveTableRow_setPrototypeOf(subClass, superClass); }
function moveTableRow_setPrototypeOf(o, p) { moveTableRow_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return moveTableRow_setPrototypeOf(o, p); }
function moveTableRow_createSuper(Derived) { var hasNativeReflectConstruct = moveTableRow_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = moveTableRow_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = moveTableRow_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return moveTableRow_possibleConstructorReturn(this, result); }; }
function moveTableRow_possibleConstructorReturn(self, call) { if (call && (moveTableRow_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return moveTableRow_assertThisInitialized(self); }
function moveTableRow_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function moveTableRow_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function moveTableRow_getPrototypeOf(o) { moveTableRow_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return moveTableRow_getPrototypeOf(o); }

var MoveTableRowAction = /*#__PURE__*/function (_Action) {
  moveTableRow_inherits(MoveTableRowAction, _Action);
  var _super = moveTableRow_createSuper(MoveTableRowAction);
  function MoveTableRowAction(type, params, editor) {
    moveTableRow_classCallCheck(this, MoveTableRowAction);
    type = type || MoveTableRowAction.type;
    return _super.call(this, type, params, editor);
  }
  return MoveTableRowAction;
}(Action);

MoveTableRowAction.type = 'move-table-row';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/tableRowComponent.js
function tableRowComponent_extends() { tableRowComponent_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tableRowComponent_extends.apply(this, arguments); }
function tableRowComponent_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function tableRowComponent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { tableRowComponent_ownKeys(Object(source), true).forEach(function (key) { tableRowComponent_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { tableRowComponent_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function tableRowComponent_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function tableRowComponent_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function tableRowComponent_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { tableRowComponent_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { tableRowComponent_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }


















function tableRowComponent_slicedToArray(arr, i) { return tableRowComponent_arrayWithHoles(arr) || tableRowComponent_iterableToArrayLimit(arr, i) || tableRowComponent_unsupportedIterableToArray(arr, i) || tableRowComponent_nonIterableRest(); }
function tableRowComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tableRowComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tableRowComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tableRowComponent_arrayLikeToArray(o, minLen); }
function tableRowComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function tableRowComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function tableRowComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }











// пользователь должен сдвинуть мышку на 5 пикселей после нажатия чтобы запустить процесс перемещения блотов
var tableRowComponent_DRAGGING_TRIGGER_DISTANCE = 5;
function TableRowComponent(_ref) {
  var pos = _ref.pos,
    relPos = _ref.relPos,
    size = _ref.size,
    _ref$rowData = _ref.rowData,
    rowData = _ref$rowData === void 0 ? {} : _ref$rowData,
    _ref$colsData = _ref.colsData,
    colsData = _ref$colsData === void 0 ? {} : _ref$colsData,
    _ref$isTempRow = _ref.isTempRow,
    isTempRow = _ref$isTempRow === void 0 ? false : _ref$isTempRow;
  var _useState = (0,hooks_module/* useState */.eJ)({
      ver: 0
    }),
    _useState2 = tableRowComponent_slicedToArray(_useState, 2),
    update = _useState2[0],
    setUpdate = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(false),
    _useState4 = tableRowComponent_slicedToArray(_useState3, 2),
    selected = _useState4[0],
    setSelected = _useState4[1];
  var _useState5 = (0,hooks_module/* useState */.eJ)({}),
    _useState6 = tableRowComponent_slicedToArray(_useState5, 2),
    overwrite = _useState6[0],
    setOverwrite = _useState6[1];
  var _useState7 = (0,hooks_module/* useState */.eJ)(false),
    _useState8 = tableRowComponent_slicedToArray(_useState7, 2),
    animate = _useState8[0],
    setAnimate = _useState8[1];
  var _useState9 = (0,hooks_module/* useState */.eJ)({}),
    _useState10 = tableRowComponent_slicedToArray(_useState9, 2),
    styles = _useState10[0],
    setStyles = _useState10[1];
  var scrollInterval = (0,hooks_module/* useRef */.sO)(null);
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    editor = _useContext.editor,
    editable = _useContext.editable,
    setProp = _useContext.setProp,
    useRefs = _useContext.useRefs,
    useMenu = _useContext.useMenu,
    useResize = _useContext.useResize,
    useSelection = _useContext.useSelection,
    onTableAction = _useContext.onTableAction,
    globalConfig = _useContext.globalConfig;
  var _setProp = function _setProp(key, value) {
    if (CONFIG.row.props[key] === value) {
      value = null;
    }
    if (!rowData || rowData[key] !== value) {
      setProp(key, value, {
        pos: pos,
        type: 'row'
      });
    }
  };
  var rowProps = CONFIG.row.attrs.reduce(function (props, attr) {
    var _ref2, _rowData$attr;
    var val = (_ref2 = (_rowData$attr = rowData[attr]) !== null && _rowData$attr !== void 0 ? _rowData$attr : CONFIG.row.props[attr]) !== null && _ref2 !== void 0 ? _ref2 : null;
    if (val !== null) {
      props[attr] = val;
    }
    return props;
  }, {});
  for (var attr in overwrite) {
    if (overwrite[attr] === rowProps[attr]) {
      delete overwrite[attr];
      setOverwrite(overwrite);
    } else {
      rowProps[attr] = overwrite[attr];
    }
  }
  var rowRef = (0,hooks_module/* useRef */.sO)(null);
  var rowHeaderRef = (0,hooks_module/* useRef */.sO)(null);
  var menuButtonRef = (0,hooks_module/* useRef */.sO)(null);

  /**
   * Ресайз строки
   * @param {event} event: событие
   * @param {object} options?
   * @param {boolean} options.save?: сохранить значение в map
   */
  var onResize = function onResize(event) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var rect = rowRef.current.getBoundingClientRect();
    var height = Math.min(Math.max(Math.round(event.clientY - rect.top), CONFIG.row.limit.minHeight), CONFIG.row.limit.maxHeight);
    setOverwrite(Object.assign({}, {
      height: height
    }));
    if (options.save) {
      _setProp('height', height);
    }
  };

  /**
   * Создает анимацию перемещения строки при сортировке
   * @param {number} to: новая позиция строки
   */
  var moveAnimate = /*#__PURE__*/function () {
    var _ref3 = tableRowComponent_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to) {
      var _useRefs$links$row$to, _useRefs$links$row$to2;
      var fromRect, toRect;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              fromRect = getNode().getBoundingClientRect();
              toRect = (_useRefs$links$row$to = useRefs.links.row[to]) === null || _useRefs$links$row$to === void 0 ? void 0 : (_useRefs$links$row$to2 = _useRefs$links$row$to.getNode()) === null || _useRefs$links$row$to2 === void 0 ? void 0 : _useRefs$links$row$to2.getBoundingClientRect();
              if (!(!fromRect || !toRect)) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              setAnimate(true);
              _context.next = 7;
              return timeout(1);
            case 7:
              setStyles({
                '--pseudo-top': toRect.top - fromRect.top + 'px'
              });
              _context.next = 10;
              return timeout(CONFIG.row.transition);
            case 10:
              setAnimate(false);
              setStyles({});
            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function moveAnimate(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var getNode = function getNode() {
    return rowRef === null || rowRef === void 0 ? void 0 : rowRef.current;
  };

  /**
   * Метод позволяет обновить строку без обновления таблицы
   */
  var renderRow = function renderRow() {
    setUpdate({
      ver: update.ver + 1
    });
  };
  useRefs.setRow(pos, {
    rowData: rowData,
    setSelected: setSelected.bind(this),
    moveAnimate: moveAnimate.bind(this),
    onResize: onResize.bind(this),
    getNode: getNode.bind(this),
    render: renderRow.bind(this)
  });
  var onMoveDraggingScroll = (0,hooks_module/* useCallback */.I4)(function (dir, container) {
    if (dir === 'top' && container.scrollTop !== 0) {
      if (container.scrollTop < 10) {
        container.scrollTop = 0;
      } else {
        container.scrollTop -= 10;
      }
    } else if (dir === 'bottom') {
      if (container.scrollHeight - (container.scrollTop + container.clientHeight) > 10) {
        container.scrollTop += 10;
      } else {
        container.scrollTop = container.scrollHeight;
      }
    }
  });
  var onMoveDraggingScrollStart = (0,hooks_module/* useCallback */.I4)(function (dir, container) {
    scrollInterval.current = setInterval(function () {
      onMoveDraggingScroll(dir, container);
    }, 10);
  });
  var onMoveDraggingScrollEnd = (0,hooks_module/* useCallback */.I4)(function () {
    clearInterval(scrollInterval.current);
    scrollInterval.current = null;
  });
  var onMoveDraggingScrolling = (0,hooks_module/* useCallback */.I4)(function (event) {
    var y = event.clientY;
    var scrollingContainer = editor.getScrollingContainer();
    var containerRect = scrollingContainer.getBoundingClientRect();
    if (y <= containerRect.y + 80) {
      if (!scrollInterval.current) {
        onMoveDraggingScrollStart('top', scrollingContainer);
      }
    } else if (y >= containerRect.y + containerRect.height - 80) {
      if (!scrollInterval.current) {
        onMoveDraggingScrollStart('bottom', scrollingContainer);
      }
    } else {
      if (scrollInterval.current) {
        onMoveDraggingScrollEnd();
      }
    }
  });
  var onMoveDraggingDrag = function onMoveDraggingDrag(node, event) {
    var _useSelection$selecti = useSelection.selection,
      start = _useSelection$selecti.start,
      last = _useSelection$selecti.last;
    onMoveDraggingScrolling(event);
    if (!node || !start || !last) {
      return onMoveDruggingClear();
    }
    var nodeRect = node.getBoundingClientRect();
    var position = event.clientY - nodeRect.top > nodeRect.height / 2 ? 'after' : 'before';
    var index = parseInt(node.getAttribute(CONFIG.row.indexAttr));
    // не даем перемещать в ту же позицию в которой сейчас находятся элементы
    if (isNaN(index) || index >= start.row && index <= last.row || index === start.row - 1 && position === 'after' || index === last.row + 1 && position === 'before') {
      return onMoveDruggingClear();
    }
    var highlight = useRefs.links.ui['moving-highlight'];
    var currentState = highlight === null || highlight === void 0 ? void 0 : highlight.sharedState;
    if (!currentState || currentState.index !== index || currentState.position !== position) {
      highlight.setSharedState({
        index: index,
        position: position,
        type: 'row',
        highlightYOffset: 40 //rowRef.current.offsetTop
      });
    }
  };

  var onMoveDraggingEnd = function onMoveDraggingEnd() {
    var _useSelection$selecti2 = useSelection.selection,
      start = _useSelection$selecti2.start,
      last = _useSelection$selecti2.last;
    var highlight = useRefs.links.ui['moving-highlight'];
    var currentState = highlight === null || highlight === void 0 ? void 0 : highlight.sharedState;
    if ((currentState === null || currentState === void 0 ? void 0 : currentState.type) === 'row' && start && last) {
      onTableAction(new MoveTableRowAction(MoveTableRowAction.type, {
        start: start,
        last: last,
        index: currentState.position === 'before' ? currentState.index : currentState.index + 1
      }, editor));
    }
    onMoveDruggingClear();
    onMoveDraggingScrollEnd();
  };
  var onMoveDruggingClear = function onMoveDruggingClear() {
    var highlight = useRefs.links.ui['moving-highlight'];
    highlight.setSharedState(false);
    return true;
  };
  var onDraggingStart = function onDraggingStart() {
    var moveDragging = new Dragging({
      selector: ".".concat(CONFIG.row.className),
      ignore: "[".concat(CONFIG.row.indexAttr, "=\"").concat(pos.row, "\"]"),
      unchange: '.horizontal-move-highlight'
    });
    moveDragging.on('drag', onMoveDraggingDrag);
    moveDragging.on('end', onMoveDraggingEnd);
    moveDragging.start();
  };
  var onMouseDown = function onMouseDown(event) {
    var _selection$start, _selection$last;
    var selection = useSelection.selection;
    var resize = false;
    var isModKey = (event === null || event === void 0 ? void 0 : event.metaKey) || (event === null || event === void 0 ? void 0 : event.ctrlKey);
    var isShiftKey = (event === null || event === void 0 ? void 0 : event.metaKey) || (event === null || event === void 0 ? void 0 : event.ctrlKey) || (event === null || event === void 0 ? void 0 : event.shiftKey);
    var onlyThisSelected = ((_selection$start = selection.start) === null || _selection$start === void 0 ? void 0 : _selection$start.row) === pos.row && ((_selection$last = selection.last) === null || _selection$last === void 0 ? void 0 : _selection$last.row) === pos.row;
    if (event.target === (rowHeaderRef === null || rowHeaderRef === void 0 ? void 0 : rowHeaderRef.current)) {
      var rect = rowHeaderRef.current.getBoundingClientRect();
      var bottom = Math.abs(rect.height - event.offsetY);
      if (bottom <= CONFIG.resize.offset) {
        resize = true;
      }
    }
    if (resize) {
      useResize.sessionStart('row', pos);
    } else if (isModKey && onlyThisSelected) {
      useSelection.unselectAll();
    } else if (isModKey || isShiftKey) {
      useSelection.setSelection(pos, {
        force: true
      });
    } else {
      if (!selected) {
        useSelection.setCurrent(pos, {
          session: false
        });
      }
      if (editable) {
        onMouseDownWaitDragging({
          x: event.clientX,
          y: event.clientY
        }, tableRowComponent_DRAGGING_TRIGGER_DISTANCE, onDraggingStart, onMenuButton);
      }
    }
  };
  var onMouseEnter = function onMouseEnter(event) {
    useSelection.setSelection(pos);
  };
  var onContextMenu = function onContextMenu(event) {
    if (globalConfig.enableMenu !== false) {
      event.preventDefault();
      useMenu.toggleMenu(event, 'row');
    }
  };
  var onMenuButton = function onMenuButton(event) {
    if (menuButtonRef.current && (event.target === menuButtonRef.current.base || menuButtonRef.current.base.contains(event.target))) {
      useMenu.toggleMenu(event, 'row');
    }
  };
  var cells = [];
  for (var col = 0; col < size.cols; col++) {
    var _colsData$col;
    var cellType = void 0;
    if ((_colsData$col = colsData[col]) !== null && _colsData$col !== void 0 && _colsData$col.columnType && colsData[col].columnType !== 'none') {
      cellType = colsData[col].columnType;
    } else {
      var _rowData$cellsData, _rowData$cellsData$co;
      cellType = getTypeFromName((_rowData$cellsData = rowData.cellsData) === null || _rowData$cellsData === void 0 ? void 0 : (_rowData$cellsData$co = _rowData$cellsData[col]) === null || _rowData$cellsData$co === void 0 ? void 0 : _rowData$cellsData$co.type);
    }
    cells.push((0,preact_module.h)(TableCellComponent, {
      pos: tableRowComponent_objectSpread(tableRowComponent_objectSpread({}, pos), {}, {
        col: col
      }),
      size: size,
      cellType: cellType,
      rowProps: rowProps
    }));
  }
  var classes = [];
  if (selected) {
    classes.push('selected');
  }
  if (animate) {
    classes.push('fade', 'moving');
  }
  if (isTempRow) {
    classes.push('is-temp-row');
  }
  if (classes.length) {
    rowProps.className = classes.join(' ');
  }
  var listeners = {};
  if (editable) {
    Object.assign(listeners, {
      onMouseDown: onMouseDown.bind(this),
      onMouseEnter: onMouseEnter.bind(this),
      onContextMenu: onContextMenu.bind(this)
    });
  }
  return (0,preact_module.h)("tr", tableRowComponent_extends({
    ref: rowRef,
    style: styles
  }, rowProps), (0,preact_module.h)(TableRowHeaderComponent, tableRowComponent_extends({
    pos: pos,
    relPos: relPos,
    selected: selected,
    rowProps: rowProps,
    onRef: rowHeaderRef,
    onMenuButtonRef: menuButtonRef
  }, listeners)), cells);
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/tableResizeComponent.js
function tableResizeComponent_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function tableResizeComponent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { tableResizeComponent_ownKeys(Object(source), true).forEach(function (key) { tableResizeComponent_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { tableResizeComponent_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function tableResizeComponent_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function tableResizeComponent_slicedToArray(arr, i) { return tableResizeComponent_arrayWithHoles(arr) || tableResizeComponent_iterableToArrayLimit(arr, i) || tableResizeComponent_unsupportedIterableToArray(arr, i) || tableResizeComponent_nonIterableRest(); }
function tableResizeComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tableResizeComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tableResizeComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tableResizeComponent_arrayLikeToArray(o, minLen); }
function tableResizeComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function tableResizeComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function tableResizeComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }





















var OVERFLOW_SPAN = 10;
var OVERFLOW_INTERVAL_MS = 150;
var SIZE = {
  width: CONFIG.col.props.width / 2,
  height: CONFIG.row.props.height
};
Object.assign(SIZE, {
  px: {
    width: SIZE.width + 'px',
    height: SIZE.height + 'px'
  }
});
function TableResize(_ref) {
  var size = _ref.size;
  var _useState = (0,hooks_module/* useState */.eJ)(false),
    _useState2 = tableResizeComponent_slicedToArray(_useState, 2),
    hidden = _useState2[0],
    setHidden = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(0),
    _useState4 = tableResizeComponent_slicedToArray(_useState3, 2),
    version = _useState4[0],
    setVersion = _useState4[1];
  var _useState5 = (0,hooks_module/* useState */.eJ)(null),
    _useState6 = tableResizeComponent_slicedToArray(_useState5, 2),
    session = _useState6[0],
    setSession = _useState6[1];
  var _useState7 = (0,hooks_module/* useState */.eJ)({
      overflow: false
    }),
    _useState8 = tableResizeComponent_slicedToArray(_useState7, 2),
    that = _useState8[0],
    setThat = _useState8[1];
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    editor = _useContext.editor,
    editable = _useContext.editable,
    useRefs = _useContext.useRefs,
    tableExec = _useContext.tableExec;
  var buttonRef = (0,hooks_module/* useRef */.sO)(null);
  if (!editable) {
    return (0,preact_module.h)("span", null);
  }
  var onMouseUp = function onMouseUp(event) {
    endSession();
  };
  var onMouseMove = function onMouseMove(event) {
    calcResize(event);
  };
  var onMouseDown = function onMouseDown(event) {
    startSession(event);
  };
  useRefs.setUI('resizer-grip', {
    setHidden: setHidden.bind(this)
  });
  (0,hooks_module/* useEffect */.d4)(function () {
    if (session) {
      window.addEventListener('mouseup', onMouseUp);
      window.addEventListener('mousemove', onMouseMove);
    }
    return function () {
      window.removeEventListener('mouseup', onMouseUp);
      window.removeEventListener('mousemove', onMouseMove);
    };
  }, [session]);
  var startSession = function startSession(event) {
    var scrollLeft = useRefs.links.ui.scroll.getNode().scrollLeft;
    var skipped = 0;
    var skipLeft = parseFloat(scrollLeft) || 0;
    var cells = useRefs.links.col.reduce(function (arr, col, i) {
      var classes = ['resize-cell'];
      if (i < size.cols) {
        var _col$getNode;
        var rect = (_col$getNode = col.getNode) === null || _col$getNode === void 0 ? void 0 : _col$getNode.call(col).getBoundingClientRect();
        var width = rect.width - 1;
        if (skipLeft >= width) {
          skipped++;
          skipLeft -= width;
          width = 0;
        } else if (skipLeft > 0) {
          classes.push('resize-cell-cut');
          width -= skipLeft - skipped;
          skipLeft = 0;
        }
        if (width) {
          arr.push((0,preact_module.h)("span", {
            className: classes.join(' '),
            style: {
              'width': width + 'px',
              'min-width': width + 'px'
            }
          }));
        }
      }
      return arr;
    }, []);
    var x = event.x,
      y = event.y;
    var _useRefs$links$row$0$ = useRefs.links.row[0].getNode().getBoundingClientRect(),
      top = _useRefs$links$row$0$.top,
      left = _useRefs$links$row$0$.left;
    setSession({
      x: x,
      y: y,
      cells: cells,
      style: {
        top: top + 'px',
        left: left + scrollLeft + 'px',
        scrollLeft: scrollLeft
      },
      over: {
        rows: 0,
        cols: 0
      }
    });
  };
  var endSession = function endSession() {
    var fullOver = getFullOver();
    if (fullOver.cols) {
      tableExec('add-col', {
        count: fullOver.cols,
        render: fullOver.rows ? false : true
      });
    }
    if (fullOver.rows) {
      tableExec('add-row', {
        count: fullOver.rows
      });
    }
    if (fullOver.cols) {
      var _useRefs$links$ui$scr;
      //editor.plugins.selectionScroller.ensureNodeVisible(buttonRef.current)
      (_useRefs$links$ui$scr = useRefs.links.ui.scroll) === null || _useRefs$links$ui$scr === void 0 ? void 0 : _useRefs$links$ui$scr.scrollTo('right');
      setTimeout(function () {
        var _useRefs$links$ui$scr2;
        (_useRefs$links$ui$scr2 = useRefs.links.ui.scroll) === null || _useRefs$links$ui$scr2 === void 0 ? void 0 : _useRefs$links$ui$scr2.scrollTo('right');
      });
    }
    setOverflowInterval({});
    setSession(null);
  };
  var overflowInterval = function overflowInterval() {
    var _that$overflow, _that$overflow2;
    that.overflow.rows = (_that$overflow = that.overflow) !== null && _that$overflow !== void 0 && _that$overflow.rowsOver ? that.overflow.rows + 1 : 0;
    that.overflow.cols = (_that$overflow2 = that.overflow) !== null && _that$overflow2 !== void 0 && _that$overflow2.colsOver ? that.overflow.cols + 1 : 0;
    setVersion(Date.now());
  };
  var setOverflowInterval = function setOverflowInterval() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!params.rowsOver && !params.colsOver) {
      if (that.overflow) {
        clearInterval(that.overflow.interval);
        that.overflow = false;
      }
    } else if (!that.overflow || params.rowsOver !== that.overflow.rows || params.colsOver !== that.overflow.cols) {
      var _that$overflow3;
      clearInterval((_that$overflow3 = that.overflow) === null || _that$overflow3 === void 0 ? void 0 : _that$overflow3.interval);
      that.overflow = tableResizeComponent_objectSpread(tableResizeComponent_objectSpread({}, params), {}, {
        interval: setInterval(overflowInterval, OVERFLOW_INTERVAL_MS),
        rows: that.overflow.rows || 0,
        cols: that.overflow.cols || 0
      });
    }
  };
  var calcResize = function calcResize(event) {
    var cols = Math.min(20, Math.max(0, Math.round((event.x - session.x) / SIZE.width)));
    var rows = Math.min(100, Math.max(0, Math.floor((event.y - session.y) / SIZE.height)));
    if (session.over.rows !== rows || session.over.cols !== cols) {
      session.over = {
        rows: rows,
        cols: cols
      };
      setVersion(Date.now());
    }
    setOverflowInterval({
      rowsOver: event.clientY > window.innerHeight - OVERFLOW_SPAN,
      colsOver: event.clientX > window.innerWidth - OVERFLOW_SPAN
    });
  };

  /**
   * Отдает общий размер ресайза: область выделенная мышью + ресайз а счет интервала у краев
   * @returns { rows, cols }
   */
  var getFullOver = function getFullOver() {
    var _that$overflow4, _that$overflow5;
    return {
      rows: session.over.rows + (((_that$overflow4 = that.overflow) === null || _that$overflow4 === void 0 ? void 0 : _that$overflow4.rows) || 0),
      cols: session.over.cols + (((_that$overflow5 = that.overflow) === null || _that$overflow5 === void 0 ? void 0 : _that$overflow5.cols) || 0)
    };
  };
  var button, table;
  var classes = ['table-grip-resizer'];
  if (hidden) {
    classes.push('hidden');
  }
  if (session) {
    classes.push('resizing');
    var cells = Object.assign([], session.cells);
    for (var i = 0; i < session.over.cols || 0; i++) {
      cells.push((0,preact_module.h)("span", {
        className: "resize-cell",
        style: {
          width: SIZE.px.width
        }
      }));
    }
    var rows = [];
    var rowsCount = size.rows + (session.over.rows || 0) - 1;
    for (var row = 0; row <= rowsCount; row++) {
      var height = void 0;
      if (row < size.rows) {
        var _useRefs$links$row$ro, _useRefs$links$row$ro2;
        var rect = (_useRefs$links$row$ro = useRefs.links.row[row]) === null || _useRefs$links$row$ro === void 0 ? void 0 : (_useRefs$links$row$ro2 = _useRefs$links$row$ro.getNode()) === null || _useRefs$links$row$ro2 === void 0 ? void 0 : _useRefs$links$row$ro2.getBoundingClientRect();
        height = rect && rect.height + 'px';
      }
      rows.push((0,preact_module.h)("div", {
        className: "resize-row",
        style: {
          height: height || SIZE.px.height
        }
      }, cells));
    }
    var fullOver = getFullOver();
    var _session$style = session.style,
      top = _session$style.top,
      left = _session$style.left;
    table = (0,preact_module.h)("div", {
      className: "resize-grid",
      style: {
        top: top,
        left: left
      }
    }, (0,preact_module.h)("div", {
      className: "resize-info"
    }, size.cols + fullOver.cols, "x", size.rows + fullOver.rows), rows);
  }
  button = (0,preact_module.h)("div", {
    ref: buttonRef,
    className: classes.join(' '),
    onMouseDown: onMouseDown
  }, (0,preact_module.h)("div", {
    className: "resize-handle"
  }));
  return (0,preact_module.h)(preact_module/* Fragment */.HY, null, button, table);
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/tableUIAuxiliaryElements.js











function tableUIAuxiliaryElements_slicedToArray(arr, i) { return tableUIAuxiliaryElements_arrayWithHoles(arr) || tableUIAuxiliaryElements_iterableToArrayLimit(arr, i) || tableUIAuxiliaryElements_unsupportedIterableToArray(arr, i) || tableUIAuxiliaryElements_nonIterableRest(); }
function tableUIAuxiliaryElements_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tableUIAuxiliaryElements_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tableUIAuxiliaryElements_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tableUIAuxiliaryElements_arrayLikeToArray(o, minLen); }
function tableUIAuxiliaryElements_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function tableUIAuxiliaryElements_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function tableUIAuxiliaryElements_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




function MovingHighlight() {
  var _useState = (0,hooks_module/* useState */.eJ)(null),
    _useState2 = tableUIAuxiliaryElements_slicedToArray(_useState, 2),
    sharedState = _useState2[0],
    setSharedState = _useState2[1];
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    useRefs = _useContext.useRefs;
  useRefs.setUI('moving-highlight', {
    sharedState: sharedState,
    setSharedState: setSharedState
  });
  (0,hooks_module/* useEffect */.d4)(function () {
    if (sharedState) {
      useRefs.links.ui.table.setState('moving', true);
    } else if (sharedState !== null) {
      useRefs.links.ui.table.setState('moving', false);
    }
  }, [sharedState]);
  if (!sharedState) {
    return null;
  } else {
    var type = sharedState.type,
      index = sharedState.index,
      position = sharedState.position,
      _sharedState$highligh = sharedState.highlightYOffset,
      highlightYOffset = _sharedState$highligh === void 0 ? 0 : _sharedState$highligh,
      _sharedState$highligh2 = sharedState.highlightXOffset,
      highlightXOffset = _sharedState$highligh2 === void 0 ? 0 : _sharedState$highligh2;
    var _useRefs$links = useRefs.links,
      row = _useRefs$links.row,
      col = _useRefs$links.col;
    var style = [],
      classes = [];
    var graphic;
    if (type === 'row') {
      var y = 0;
      for (var i = 0; i < index; i++) {
        // делаем проверку на существование строки, так как к таблице может быть применён фильтр
        if (row[i]) {
          y += row[i].getNode().getBoundingClientRect().height;
        }
      }
      if (position === 'after') {
        if (row[index]) {
          y += row[index].getNode().getBoundingClientRect().height;
        }
      }
      style.top = y + highlightYOffset + 'px';
      classes.push('horizontal-move-highlight');
      graphic = 'M 0 0 L 300 150 L 0 300 z';
    } else if (type === 'col') {
      var x = 0;
      for (var _i2 = 0; _i2 < index; _i2++) {
        x += col[_i2].getNode().getBoundingClientRect().width;
      }
      var scrollNode = useRefs.links.ui.scroll.getNode();
      if (position === 'after') {
        x += col[index].getNode().getBoundingClientRect().width;
        if (x + highlightXOffset > scrollNode.offsetWidth + scrollNode.scrollLeft) {
          useRefs.links.ui.scroll.scrollTo(col[index].getNode());
        }
      } else {
        if (x + highlightXOffset < 42 + scrollNode.scrollLeft) {
          useRefs.links.ui.scroll.scrollTo(col[index].getNode());
        }
      }
      style.left = x + highlightXOffset + 'px';
      classes.push('vertical-move-highlight');
      graphic = 'M 0 0 L 300 0 L 150 300 z';
    }
    return (0,preact_module.h)("div", {
      className: classes.join(' '),
      style: style
    }, (0,preact_module.h)("div", {
      className: "highlight-pin"
    }, (0,preact_module.h)("svg", {
      viewBox: "0 0 300 300",
      xmlns: "http://www.w3.org/2000/svg"
    }, (0,preact_module.h)("path", {
      className: "graphic",
      d: graphic
    }))));
  }
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/tableBodyComponent.js









function TableBodyComponent(_ref) {
  var data = _ref.data;
  var size = data.size,
    rowsData = data.rowsData,
    colsData = data.colsData;
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    useRefs = _useContext.useRefs,
    useFilter = _useContext.useFilter,
    editor = _useContext.editor,
    useSelection = _useContext.useSelection;
  var bodyRef = (0,hooks_module/* useRef */.sO)(null);
  var isTempRowSelected = (0,hooks_module/* useRef */.sO)(false);
  var onResize = function onResize() {
    var _links$ui$cellMenuB;
    var links = useRefs.links;
    (_links$ui$cellMenuB = links.ui['cell-menu-btn']) === null || _links$ui$cellMenuB === void 0 ? void 0 : _links$ui$cellMenuB.render();
  };
  useResizeObserver(bodyRef, onResize);
  (0,hooks_module/* useEffect */.d4)(function () {
    if (!Boolean(data.props['filter-disabled']) && data.props.tempRow) {
      var rowPos = Object.keys(data.rowsData).find(function (index) {
        return data.rowsData[index].id === data.props.tempRow;
      });
      var _useSelection$selecti = useSelection.selection,
        start = _useSelection$selecti.start,
        end = _useSelection$selecti.end;
      if (!isTempRowSelected.current) {
        if (rowPos) {
          if (!start || !end || start.row !== parseInt(rowPos) && end.row !== parseInt(rowPos)) {
            useSelection.setCurrent({
              row: parseInt(rowPos)
            }, {
              tempRow: true
            });
            isTempRowSelected.current = true;
          }
        }
      } else {
        isTempRowSelected.current = false;
      }
    }
  });
  var rows = [];
  //const viewArea = {from:0, to:10000} // Тест lazy
  //for (let row = viewArea.from; row < viewArea.to; row++) {
  var relIndex = 0;
  var renderAll = Boolean(data.props['filter-disabled']);
  for (var row = 0; row < size.rows; row++) {
    var isTempRow = !renderAll && Boolean(rowsData[row] && data.props.tempRow && data.props.tempRow === rowsData[row].id);
    if (renderAll || isTempRow || useFilter.acceptRenderRow(rowsData[row], size.cols)) {
      var rowComponent = (0,preact_module.h)(TableRowComponent, {
        pos: {
          row: row
        },
        relPos: relIndex,
        rowData: rowsData[row],
        isTempRow: isTempRow,
        size: size,
        colsData: colsData
      });
      rows.push(rowComponent);
      relIndex++;
    }
    /*
    if (row >= viewArea.from && row <= viewArea.to) {
      rows.push(rowComponent)
    }
    */
  }

  return (0,preact_module.h)("tbody", {
    ref: bodyRef,
    className: !rows.length ? 'empty-filter-result' : ''
  }, (0,preact_module.h)(TableResize, {
    size: size
  }), (0,preact_module.h)(MovingHighlight, null), rows.length ? rows : (0,preact_module.h)(EmptyTableComponent, {
    size: size,
    editor: editor
  }));
}
function EmptyTableComponent(_ref2) {
  var size = _ref2.size,
    editor = _ref2.editor;
  return (0,preact_module.h)("tr", null, (0,preact_module.h)("td", {
    className: "table-head-item empty-table"
  }), (0,preact_module.h)("td", null), (0,preact_module.h)("td", {
    colspan: size.cols,
    style: {
      textAlign: 'center',
      padding: '10px 0'
    }
  }, editor.plugins.i18n.get('table.filter.empty_table')));
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.big.js
var es_string_big = __webpack_require__(74475);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.fixed.js
var es_string_fixed = __webpack_require__(29253);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.max-safe-integer.js
var es_number_max_safe_integer = __webpack_require__(44363);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.pad-start.js
var es_string_pad_start = __webpack_require__(83112);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/summaries/summaryAlgorithms.js
function summaryAlgorithms_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { summaryAlgorithms_typeof = function _typeof(obj) { return typeof obj; }; } else { summaryAlgorithms_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return summaryAlgorithms_typeof(obj); }






















function summaryAlgorithms_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function summaryAlgorithms_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function summaryAlgorithms_createClass(Constructor, protoProps, staticProps) { if (protoProps) summaryAlgorithms_defineProperties(Constructor.prototype, protoProps); if (staticProps) summaryAlgorithms_defineProperties(Constructor, staticProps); return Constructor; }

var summaryAlgorithms_ALLOW_BIGINT = true;
var VAL = {
  day: 24 * 60 * 60 * 1e3,
  month: 30
};
var SummaryAlgorithms = /*#__PURE__*/function () {
  function SummaryAlgorithms() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    summaryAlgorithms_classCallCheck(this, SummaryAlgorithms);
    this.setProps(props);
  }
  summaryAlgorithms_createClass(SummaryAlgorithms, [{
    key: "setProps",
    value: function setProps() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.cache = {};
      this.props = props;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var _this$props = this.props,
        columnType = _this$props.columnType,
        summary = _this$props.summary;
      var result = {
        count: null
      };
      var mode = summary.mode.split('_');
      switch (mode[0]) {
        case "all":
          result.count = this.all;
          break;
        case "empty":
        case "unchecked":
          result.count = this.empty;
          break;
        case "fill":
        case "checked":
          result.count = this.fill;
          break;
        case "unique":
          result.count = this.unique;
          break;
        case "sum":
          result.count = this.string(this.sum);
          break;
        case "average":
          result.count = this.string(this.average);
          break;
        case "min":
          result.count = this.string(this.min);
          break;
        case "max":
          result.count = this.string(this.max);
          break;
        case "median":
          result.count = this.string(this.median);
          break;
        case "range":
          result.count = this.range;
          if (columnType === 'date') {
            result.count = this.period(result.count, mode);
          }
          break;
        case "filter":
          result.count = this.filter;
          break;
        case "filesize":
          var info = this.filesize(mode[1]);
          result = Object.assign(result, info);
          break;
        default:
          console.warn('Unknown summary', summary);
          result.count = '?';
      }
      if (columnType === 'number' || columnType === 'currency') {
        result.count = this.symbol(result.count);
        result.classes = this.classes(result.count);
      } else if (columnType === 'progress' && mode.indexOf('filter') === -1) {
        result.count = this.progress(result.count);
      }
      if (mode.length > 1) {
        if (mode.indexOf('percent') !== -1) {
          result.count = this.percent(result.count, {
            mode: mode
          });
        } else if (mode.indexOf('date') !== -1) {
          result.count = this.date(result.count);
        }
      }
      return result;
    }
  }, {
    key: "format",
    get: function get() {
      var format = {};
      return format;
      var cells = this.props.cells;
      if (cells.length && cells[0].parentColumn) {
        if (cells[0].parentColumn.typeFormat) {
          format = cells[0].parentColumn.typeFormat;
        }
      }
      return format;
    }
  }, {
    key: "all",
    get: function get() {
      var size = this.props.size;
      return size.visibleRows;
    }
  }, {
    key: "empty",
    get: function get() {
      var _this$props2 = this.props,
        pos = _this$props2.pos,
        links = _this$props2.links,
        columnType = _this$props2.columnType;
      var empty = 0;
      if (columnType !== 'progress') {
        links.cell.forEach(function (row) {
          if (row[pos.col].empty) {
            empty++;
          }
        });
      }
      return empty;
    }
  }, {
    key: "fill",
    get: function get() {
      return this.not(this.empty);
    }
  }, {
    key: "unique",
    get: function get() {
      var unique = 0;
      var uniqueValues = [];
      this.each(function (cell) {
        if (uniqueValues.indexOf(cell.value) === -1) {
          uniqueValues.push(cell.value);
          unique++;
        }
      });
      return unique;
    }
  }, {
    key: "numTmpl",
    get: function get() {
      var tmpl = {
        value: 0,
        decimal: 0,
        bigint: summaryAlgorithms_ALLOW_BIGINT && BigInt(0)
      };
      return tmpl;
    }
  }, {
    key: "sum",
    get: function get() {
      var _this = this;
      var result = false;
      this.each(function (item) {
        result = result === false ? item : _this.math('+', result, item);
      });
      return result || this.numTmpl;
    }
  }, {
    key: "average",
    get: function get() {
      var average;
      var fill = this.fill;
      if (fill) {
        average = fill === 1 ? this.sum : this.math('/', this.sum, fill);
      }
      return average;
    }
  }, {
    key: "min",
    get: function get() {
      var _this2 = this;
      var columnType = this.props.columnType;
      var params = {};
      if (columnType === 'progress') {
        params.all = true;
      }
      var min;
      this.each(params, function (item) {
        min = _this2.math('min', min, item);
      });
      return min;
    }
  }, {
    key: "max",
    get: function get() {
      var _this3 = this;
      var max;
      this.each(function (item) {
        max = _this3.math('max', max, item);
      });
      return max;
    }
  }, {
    key: "median",
    get: function get() {
      var median,
        vals = [];
      this.each(function (item) {
        vals.push(item);
      });
      vals.sort(this.sort);
      var length = vals.length;
      if (length) {
        var middle = length / 2;
        if (length % 2 === 1) {
          median = vals[Math.floor(middle)];
        } else {
          var sum = this.math('+', vals[middle - 1], vals[middle]);
          median = this.math('/', sum, 2);
        }
      }
      return median;
    }
  }, {
    key: "range",
    get: function get() {
      var min = this.min;
      var max = this.max;
      var range = null;
      if (min && max) {
        range = max.value - min.value;
      }
      return range;
    }
  }, {
    key: "filter",
    get: function get() {
      var _this4 = this;
      var summary = this.props.summary;
      var count = 0,
        op = '=';
      var filter = summary.filter;
      if (summary.filter) {
        for (var _i = 0, _arr = ['<', '>']; _i < _arr.length; _i++) {
          var sign = _arr[_i];
          if (summary.filter.startsWith(sign)) {
            op = sign;
            filter = filter.replace(sign, '');
          }
        }
      }
      filter = parseInt(filter || 0);
      if (!isNaN(filter)) {
        this.each({
          all: true
        }, function (item) {
          var incerase = _this4.compare(op, parseInt(item.value), filter);
          if (incerase) {
            count++;
          }
        });
      }
      return count;
    }
  }, {
    key: "math",
    value: function math(op, item1, item2) {
      var result = {};
      var isObject1 = summaryAlgorithms_typeof(item1) === 'object';
      var isObject2 = summaryAlgorithms_typeof(item2) === 'object';
      var hasValue1 = isObject1 && item1.hasOwnProperty('value');
      var hasValue2 = isObject2 && item2.hasOwnProperty('value');
      var hasValues = hasValue1 && hasValue2;
      var hasDecimal1 = isObject1 && item1.hasOwnProperty('decimal');
      var hasDecimal2 = isObject2 && item2.hasOwnProperty('decimal');
      var hasDecimals = hasDecimal1 && hasDecimal2;
      var hasBigint1 = summaryAlgorithms_ALLOW_BIGINT && isObject1 && item1.hasOwnProperty('bigint') && item1.bigint !== false;
      var hasBigint2 = summaryAlgorithms_ALLOW_BIGINT && isObject2 && item2.hasOwnProperty('bigint') && item2.bigint !== false;
      var hasBigints = hasBigint1 && hasBigint2;
      switch (op) {
        case '+':
          if (hasValues) {
            result.value = this.math('+.', item1.value, item2.value);
          }
          if (hasDecimals) {
            result.decimal = this.math('+.', item1.decimal, item2.decimal);
          }
          if (hasBigints) {
            result.bigint = item1.bigint + item2.bigint;
          }
          break;
        case '+.':
          var fixed = Math.max(this.split(item1).fixed, this.split(item2).fixed);
          result = this.parseFloat(item1 - -item2, fixed);
          break;
        case '/':
          if (hasValue1 && (item1.value < Number.MAX_SAFE_INTEGER || !hasBigint1)) {
            var split = this.split(item1.value);
            result.value = this.parseFloat(item1.value / item2, Math.max(3, split.fixed + 1));
          } else if (hasBigint1) {
            result.bigint = item1.bigint / BigInt(item2);
          }
          break;
        case 'min':
          result = item2;
          if (item1) {
            if (hasBigints) {
              if (item1.bigint === item2.bigint && hasDecimals && item1.decimal < item2.decimal || item1.bigint < item2.bigint) {
                result = item1;
              }
            } else if (hasValues && item1.value < item2.value) {
              result = item1;
            }
          }
          break;
        case 'max':
          result = item2;
          if (item1) {
            if (hasBigints) {
              if (item1.bigint === item2.bigint && hasDecimals && item1.decimal > item2.decimal || item1.bigint > item2.bigint) {
                result = item1;
              }
            } else if (hasValues && item1.value > item2.value) {
              result = item1;
            }
          }
          break;
        default:
          console.warn('Unknown operation', op, item1, item2);
      }
      return result;
    }
  }, {
    key: "split",
    value: function split(value) {
      var result = {
        value: value,
        number: parseInt(value),
        fixed: 0,
        decimal: 0,
        decimalStr: ''
      };
      if (result.number === -0) {
        result.number = 0;
      }
      if (result.value != result.number) {
        var isMinus = value < 0;
        var arr = Math.abs(value).toString().split('.');
        if (arr.length === 2) {
          result.fixed = arr[1].length;
          result.decimal = this.parseFloat("0.".concat(arr[1]));
          if (isMinus) result.decimal = -result.decimal;
          result.decimalStr = arr[1].toString();
        }
      }
      return result;
    }
  }, {
    key: "parseFloat",
    value: function (_parseFloat) {
      function parseFloat(_x) {
        return _parseFloat.apply(this, arguments);
      }
      parseFloat.toString = function () {
        return _parseFloat.toString();
      };
      return parseFloat;
    }(function (value) {
      var fixed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      value = parseFloat(value);
      if (value.toString().indexOf('e-') !== -1) {
        var parts = value.toString().split('e-');
        value = value.toFixed(parts[1]);
      } else if (fixed !== false) {
        value = parseFloat(value.toFixed(fixed));
      }
      return value;
    })
  }, {
    key: "filesize",
    value: function filesize(logic) {
      var result = {
        count: null,
        tooltip: null
      };
      this.each(function (item) {
        if (item.attachments) {
          for (var id in item.attachments) {
            var attachment = item.attachments[id];
            if (attachment.hasOwnProperty('size')) {
              if (result.count === null || logic === 'max' && result.count < attachment.size || logic === 'min' && result.count > attachment.size) {
                result.count = attachment.size;
                result.tooltip = attachment.display_name;
              }
            }
          }
        }
      });
      if (result.count !== null) {
        result.count = this.formatBytes(result.count);
      }
      return result;
    }
  }, {
    key: "sort",
    value: function sort(a, b) {
      if (summaryAlgorithms_ALLOW_BIGINT && a.hasOwnProperty('bigint') && a.bigint !== false && b.hasOwnProperty('bigint') && b.bigint !== false) {
        if (a.bigint === b.bigint && !isNaN(parseFloat(a.decimal)) && !isNaN(parseFloat(a.decimal))) {
          return a.decimal - b.decimal;
        } else {
          return Number(a.bigint - b.bigint);
        }
      } else {
        return a.value - b.value;
      }
    }
  }, {
    key: "compare",
    value: function compare(op, a, b) {
      var operators = {
        '=': function _(a, b) {
          return a === b;
        },
        '>': function _(a, b) {
          return a > b;
        },
        '<': function _(a, b) {
          return a < b;
        }
      };
      return operators[op](a, b);
    }
    /**
     * converts numeric item to string
     * @param {*} item
     * @returns
     */
  }, {
    key: "string",
    value: function string(item) {
      var str = '';
      if (item) {
        if (summaryAlgorithms_ALLOW_BIGINT && item.hasOwnProperty('bigint') && item.bigint !== false) {
          if (!item.decimal) {
            str = item.bigint.toString();
          } else {
            var decimal = this.split(item.decimal);
            var decimalNum = Math.round(decimal.decimal * Math.pow(10, decimal.fixed));
            var bigint = item.bigint + BigInt(decimal.number || 0);
            var bigintNum = Number(bigint);
            if (bigintNum > 0 && decimalNum < 0) {
              bigintNum -= 1;
              decimalNum = Math.pow(10, decimal.fixed) - Math.abs(decimalNum);
            } else if (bigintNum < 0 && decimalNum > 0) {
              bigintNum += 1;
              decimalNum = Math.pow(10, decimal.fixed) - decimalNum;
            }
            var decimalNumWithZeroes = Math.abs(decimalNum).toString().padStart(decimal.fixed, '0');
            str = bigintNum.toString() + '.' + decimalNumWithZeroes;
          }
        } else if (item.hasOwnProperty('value')) {
          str = String(item.value);
        }
      }
      return str;
    }
    /*
    number (value) {
      const format = this.format
      if (format && format.type) {
        if (format.type === 'percent') {
          if (!isNaN(parseInt(value)))
          value += '%'
        } else if (format.type === 'commas') {
          value = this.separate(value)
        }
      }
      return value
    }
    */
  }, {
    key: "symbol",
    value: function symbol(value) {
      var _this$props$format;
      if (((_this$props$format = this.props.format) === null || _this$props$format === void 0 ? void 0 : _this$props$format.type) === 'commas') {
        value = this.separate(value);
      }
      var symbolBefore = null,
        symbolAfter = null;
      this.each(function (item) {
        if (item.format) {
          if (item.format.hasOwnProperty('symbolBefore')) {
            symbolBefore = symbolBefore === null || symbolBefore === item.format.symbolBefore ? item.format.symbolBefore : false;
          }
          if (item.format.hasOwnProperty('symbolAfter')) {
            symbolAfter = symbolAfter === null || symbolAfter === item.format.symbolAfter ? item.format.symbolAfter : false;
          }
        }
      });
      if (symbolBefore) {
        if (typeof value === 'string' && value.startsWith('-')) {
          value = '-' + symbolBefore + value.replace('-', '');
        } else if (typeof value === 'number' && value < 0) {
          value = '-' + symbolBefore + Math.abs(value);
        } else {
          value = symbolBefore + value;
        }
      } else if (symbolAfter) {
        value += symbolAfter;
      }
      return value;
    }
  }, {
    key: "classes",
    value: function classes(value) {
      var _this$props$format2;
      var result = [];
      var colorNumbers = (_this$props$format2 = this.props.format) === null || _this$props$format2 === void 0 ? void 0 : _this$props$format2.colorNumbers;
      if (!colorNumbers) {
        var index = 0;
        this.each(function (item) {
          var _item$format, _item$format2;
          if (index === 0 && (_item$format = item.format) !== null && _item$format !== void 0 && _item$format.colorNumbers) {
            colorNumbers = true;
          }
          if (!((_item$format2 = item.format) !== null && _item$format2 !== void 0 && _item$format2.colorNumbers)) {
            colorNumbers = false;
          }
          index++;
        });
      }
      if (colorNumbers) {
        if (String(value).startsWith('-')) {
          result.push('negative-number');
        } else {
          result.push('positive-number');
        }
      }
      return result;
    }
  }, {
    key: "separate",
    value: function separate(value) {
      if (!isNaN(parseFloat(value))) {
        value = addOrderSeparator(value);
      }
      return value;
    }
  }, {
    key: "not",
    value: function not(val) {
      return this.all - val;
    }
  }, {
    key: "each",
    value: function each() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var func = arguments.length > 1 ? arguments[1] : undefined;
      if (typeof params === 'function') {
        func = params;
        params = {};
      }
      var _this$props3 = this.props,
        pos = _this$props3.pos,
        links = _this$props3.links;
      links.cell.forEach(function (row) {
        if (row[pos.col] && (params.all || !row[pos.col].empty)) {
          func(row[pos.col]);
        }
      });
    }
  }, {
    key: "percent",
    value: function percent(value) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (isNaN(parseInt(value))) {
        return value;
      }
      var all, percent;
      if (params.mode && params.mode[0] === 'unique') {
        all = this.fill;
      } else {
        all = this.all;
      }
      if (all === 0) {
        percent = 0;
      } else {
        percent = 100 * value / all;
        percent = this.round(percent, params);
      }
      return percent + '%';
    }
  }, {
    key: "progress",
    value: function progress(value) {
      if (!isNaN(parseInt(value))) {
        value += '%';
      }
      return value;
    }
  }, {
    key: "round",
    value: function round(value) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!params.hasOwnProperty('decimal')) {
        params.decimal = 2;
      }
      var factor = +"1e".concat(params.decimal);
      var round = Math.round(factor * value) / factor;
      return round;
    }
  }, {
    key: "date",
    value: function date(value) {
      if (isNaN(parseInt(value))) {
        return value;
      }
      var date;
      value = parseInt(value);
      this.each(function (item) {
        if (!date && item.hasOwnProperty('getText') && parseInt(item.value) === value) {
          date = item.getText();
        }
      });
      return date || value;
    }
  }, {
    key: "period",
    value: function period(value, mode) {
      var editor = this.props.editor;
      var i18n = editor.plugins.i18n;
      if (isNaN(parseInt(value))) {
        return value;
      }
      var postfix = 'day';
      var result = 1 + Math.floor(value / VAL.day);
      if (mode.indexOf('month') !== -1) {
        result = Math.floor(result / VAL.month);
        postfix = 'month';
      }
      result += i18n.get("calendar.ui.postfix.".concat(postfix));
      return result;
    }
  }, {
    key: "formatBytes",
    value: function formatBytes(bytes) {
      var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      if (bytes === 0) {
        return '0 B';
      }
      var k = 1000; // 1024
      var dm = decimals < 0 ? 0 : decimals;
      var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      var i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
  }]);
  return SummaryAlgorithms;
}();
/* harmony default export */ const summaryAlgorithms = (SummaryAlgorithms);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/summaries/summaryValueComponent.js
function summaryValueComponent_extends() { summaryValueComponent_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return summaryValueComponent_extends.apply(this, arguments); }













function summaryValueComponent_toConsumableArray(arr) { return summaryValueComponent_arrayWithoutHoles(arr) || summaryValueComponent_iterableToArray(arr) || summaryValueComponent_unsupportedIterableToArray(arr) || summaryValueComponent_nonIterableSpread(); }
function summaryValueComponent_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function summaryValueComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return summaryValueComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return summaryValueComponent_arrayLikeToArray(o, minLen); }
function summaryValueComponent_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function summaryValueComponent_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return summaryValueComponent_arrayLikeToArray(arr); }
function summaryValueComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }





var TOOLTIP_OPTIONS = JSON.stringify({
  positionFixed: true,
  modifiers: {
    offset: {
      offset: '0,0'
    }
  }
});
function SummaryValue(_ref) {
  var _useRefs$links$col$po, _value$count;
  var pos = _ref.pos,
    size = _ref.size,
    columnType = _ref.columnType,
    summary = _ref.summary;
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    editor = _useContext.editor,
    useRefs = _useContext.useRefs;
  var algorithms = new summaryAlgorithms({
    editor: editor,
    pos: pos,
    size: size,
    summary: summary,
    columnType: columnType,
    links: useRefs.links,
    format: ((_useRefs$links$col$po = useRefs.links.col[pos.col]) === null || _useRefs$links$col$po === void 0 ? void 0 : _useRefs$links$col$po.colFormat) || {}
  });
  var value = algorithms.getValue();
  var nodeProps = {};
  if (value) {
    nodeProps[tooltipManager/* TOOLTIP_ATTR */.qZ] = value.tooltip || value.count;
    nodeProps[tooltipManager/* TOOLTIP_ADD_OPTIONS */.cD] = TOOLTIP_OPTIONS;
  }
  var classes = ['summary-value'];
  if (value && value.classes && value.classes.length) {
    classes.push.apply(classes, summaryValueComponent_toConsumableArray(value.classes));
  }
  return (0,preact_module.h)("div", summaryValueComponent_extends({
    className: classes.join(' '),
    valueLength: value === null || value === void 0 ? void 0 : (_value$count = value.count) === null || _value$count === void 0 ? void 0 : _value$count.toString().length
  }, nodeProps), value === null || value === void 0 ? void 0 : value.count);
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/popupMenuHeader.js
function popupMenuHeader_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { popupMenuHeader_typeof = function _typeof(obj) { return typeof obj; }; } else { popupMenuHeader_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return popupMenuHeader_typeof(obj); }









function popupMenuHeader_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function popupMenuHeader_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function popupMenuHeader_createClass(Constructor, protoProps, staticProps) { if (protoProps) popupMenuHeader_defineProperties(Constructor.prototype, protoProps); if (staticProps) popupMenuHeader_defineProperties(Constructor, staticProps); return Constructor; }
function popupMenuHeader_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) popupMenuHeader_setPrototypeOf(subClass, superClass); }
function popupMenuHeader_setPrototypeOf(o, p) { popupMenuHeader_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return popupMenuHeader_setPrototypeOf(o, p); }
function popupMenuHeader_createSuper(Derived) { var hasNativeReflectConstruct = popupMenuHeader_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = popupMenuHeader_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = popupMenuHeader_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return popupMenuHeader_possibleConstructorReturn(this, result); }; }
function popupMenuHeader_possibleConstructorReturn(self, call) { if (call && (popupMenuHeader_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return popupMenuHeader_assertThisInitialized(self); }
function popupMenuHeader_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function popupMenuHeader_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function popupMenuHeader_getPrototypeOf(o) { popupMenuHeader_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return popupMenuHeader_getPrototypeOf(o); }

var PopupMenuHeader = /*#__PURE__*/function (_Component) {
  popupMenuHeader_inherits(PopupMenuHeader, _Component);
  var _super = popupMenuHeader_createSuper(PopupMenuHeader);
  function PopupMenuHeader() {
    popupMenuHeader_classCallCheck(this, PopupMenuHeader);
    return _super.apply(this, arguments);
  }
  popupMenuHeader_createClass(PopupMenuHeader, [{
    key: "render",
    value: function render() {
      return (0,preact_module.h)("div", {
        className: "header-menu"
      }, this.props.children);
    }
  }]);
  return PopupMenuHeader;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/popupMenuHeaderItem.js
function popupMenuHeaderItem_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { popupMenuHeaderItem_typeof = function _typeof(obj) { return typeof obj; }; } else { popupMenuHeaderItem_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return popupMenuHeaderItem_typeof(obj); }











function popupMenuHeaderItem_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function popupMenuHeaderItem_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function popupMenuHeaderItem_createClass(Constructor, protoProps, staticProps) { if (protoProps) popupMenuHeaderItem_defineProperties(Constructor.prototype, protoProps); if (staticProps) popupMenuHeaderItem_defineProperties(Constructor, staticProps); return Constructor; }
function popupMenuHeaderItem_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) popupMenuHeaderItem_setPrototypeOf(subClass, superClass); }
function popupMenuHeaderItem_setPrototypeOf(o, p) { popupMenuHeaderItem_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return popupMenuHeaderItem_setPrototypeOf(o, p); }
function popupMenuHeaderItem_createSuper(Derived) { var hasNativeReflectConstruct = popupMenuHeaderItem_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = popupMenuHeaderItem_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = popupMenuHeaderItem_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return popupMenuHeaderItem_possibleConstructorReturn(this, result); }; }
function popupMenuHeaderItem_possibleConstructorReturn(self, call) { if (call && (popupMenuHeaderItem_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return popupMenuHeaderItem_assertThisInitialized(self); }
function popupMenuHeaderItem_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function popupMenuHeaderItem_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function popupMenuHeaderItem_getPrototypeOf(o) { popupMenuHeaderItem_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return popupMenuHeaderItem_getPrototypeOf(o); }
function popupMenuHeaderItem_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PopupMenuHeaderItem = /*#__PURE__*/function (_Component) {
  popupMenuHeaderItem_inherits(PopupMenuHeaderItem, _Component);
  var _super = popupMenuHeaderItem_createSuper(PopupMenuHeaderItem);
  function PopupMenuHeaderItem() {
    var _this;
    popupMenuHeaderItem_classCallCheck(this, PopupMenuHeaderItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    popupMenuHeaderItem_defineProperty(popupMenuHeaderItem_assertThisInitialized(_this), "onClick", function (event) {
      _this.props.onClick && _this.props.onClick();
    });
    popupMenuHeaderItem_defineProperty(popupMenuHeaderItem_assertThisInitialized(_this), "onMouseDown", function (event) {
      event.preventDefault();
    });
    return _this;
  }
  popupMenuHeaderItem_createClass(PopupMenuHeaderItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        id = _this$props.id,
        Icon = _this$props.icon,
        active = _this$props.active,
        disabled = _this$props.disabled;
      var classes = ['icon'];
      if (active) {
        classes.push('active');
      }
      if (disabled) {
        classes.push('disabled');
      }
      return (0,preact_module.h)("div", {
        className: "header-item",
        onMouseDown: this.onMouseDown,
        onClick: this.onClick,
        "data-menu-id": id
      }, (0,preact_module.h)("div", {
        className: classes.join(' ')
      }, (0,preact_module.h)(Icon, null)));
    }
  }]);
  return PopupMenuHeaderItem;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/menu/tableMenuHeader.js




function TableMenuHeaderComponent(_ref) {
  var onAction = _ref.onAction;
  return (0,preact_module.h)(PopupMenuHeader, null, (0,preact_module.h)(PopupMenuHeaderItem, {
    onClick: onAction.bind(null, 'align', 'left'),
    icon: icons/* IconAlignLeft */.hID
  }), (0,preact_module.h)(PopupMenuHeaderItem, {
    onClick: onAction.bind(null, 'align', 'center'),
    icon: icons/* IconAlignCenter */.k5Z
  }), (0,preact_module.h)(PopupMenuHeaderItem, {
    onClick: onAction.bind(null, 'align', 'right'),
    icon: icons/* IconAlignRight */.Qz9
  }), (0,preact_module.h)(PopupMenuHeaderItem, {
    onClick: onAction.bind(null, 'valign', 'top'),
    icon: icons/* IconVAlignTop */.LO$
  }), (0,preact_module.h)(PopupMenuHeaderItem, {
    onClick: onAction.bind(null, 'valign', 'middle'),
    icon: icons/* IconVAlignCenter */._oX
  }), (0,preact_module.h)(PopupMenuHeaderItem, {
    onClick: onAction.bind(null, 'valign', 'bottom'),
    icon: icons/* IconVAlignBottom */.PKJ
  }));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/menu/tableMenuFormatting.js
function tableMenuFormatting_extends() { tableMenuFormatting_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tableMenuFormatting_extends.apply(this, arguments); }
function tableMenuFormatting_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function tableMenuFormatting_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { tableMenuFormatting_ownKeys(Object(source), true).forEach(function (key) { tableMenuFormatting_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { tableMenuFormatting_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function tableMenuFormatting_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function tableMenuFormatting_slicedToArray(arr, i) { return tableMenuFormatting_arrayWithHoles(arr) || tableMenuFormatting_iterableToArrayLimit(arr, i) || tableMenuFormatting_unsupportedIterableToArray(arr, i) || tableMenuFormatting_nonIterableRest(); }
function tableMenuFormatting_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tableMenuFormatting_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function tableMenuFormatting_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function tableMenuFormatting_toConsumableArray(arr) { return tableMenuFormatting_arrayWithoutHoles(arr) || tableMenuFormatting_iterableToArray(arr) || tableMenuFormatting_unsupportedIterableToArray(arr) || tableMenuFormatting_nonIterableSpread(); }
function tableMenuFormatting_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tableMenuFormatting_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tableMenuFormatting_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tableMenuFormatting_arrayLikeToArray(o, minLen); }
function tableMenuFormatting_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function tableMenuFormatting_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return tableMenuFormatting_arrayLikeToArray(arr); }
function tableMenuFormatting_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


























var textColors = Array.from(matColorNames);
textColors.push.apply(textColors, tableMenuFormatting_toConsumableArray(blackAndWhite));

function TableMenuTextFormattingComponent() {
  var _this = this;
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var onAction = props.onAction,
    getStyle = props.getStyle;
  var _useState = (0,hooks_module/* useState */.eJ)(getStyle()),
    _useState2 = tableMenuFormatting_slicedToArray(_useState, 2),
    itemsState = _useState2[0],
    setItemsState = _useState2[1];
  var items = [{
    name: 'bold',
    icon: icons/* IconBold */.lM8
  }, {
    name: 'italic',
    icon: icons/* IconItalic */.C9_
  }, {
    name: 'strikethrough',
    icon: icons/* IconStrikethrough */.dZu
  }, {
    name: 'underline',
    icon: icons/* IconUnderline */.xxo
  }];
  var onItemClick = function onItemClick(name) {
    var format = tableMenuFormatting_defineProperty({}, name, (itemsState === null || itemsState === void 0 ? void 0 : itemsState[name]) === true ? null : true);
    onAction.bind(null)('style', format);
    setItemsState(tableMenuFormatting_objectSpread(tableMenuFormatting_objectSpread({}, itemsState || {}), format));
  };
  var menuItems = items.reduce(function (collection, item) {
    collection.push((0,preact_module.h)(popupMenuItem/* default */.Z, {
      id: "text-formatting-".concat(item.name),
      icon: itemsState !== null && itemsState !== void 0 && itemsState[item.name] ? icons/* IconDone */.EZi : item.icon,
      onClick: onItemClick.bind(_this, item.name),
      text: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
        id: "table.formatting_menu.".concat(item.name)
      }, item.name)
    }));
    return collection;
  }, []);
  return (0,preact_module.h)(popupMenu/* default */.Z, props, menuItems);
}
function TableMenuTextAlignComponent() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var onAction = props.onAction;
  return (0,preact_module.h)(popupMenu/* default */.Z, props, (0,preact_module.h)(popupMenuItem/* default */.Z, {
    id: "halign-left",
    icon: icons/* IconAlignLeft */.hID,
    onClick: onAction.bind(null, 'align', 'left'),
    text: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
      id: "table.formatting_menu.align_left"
    }, "Left")
  }), (0,preact_module.h)(popupMenuItem/* default */.Z, {
    id: "halign-center",
    icon: icons/* IconAlignCenter */.k5Z,
    onClick: onAction.bind(null, 'align', 'center'),
    text: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
      id: "table.formatting_menu.align_center"
    }, "Center")
  }), (0,preact_module.h)(popupMenuItem/* default */.Z, {
    id: "halign-right",
    icon: icons/* IconAlignRight */.Qz9,
    onClick: onAction.bind(null, 'align', 'right'),
    text: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
      id: "table.formatting_menu.align_right"
    }, "Right")
  }), (0,preact_module.h)(PopupMenuSeparator, null), (0,preact_module.h)(popupMenuItem/* default */.Z, {
    id: "valign-top",
    icon: icons/* IconVAlignTop */.LO$,
    onClick: onAction.bind(null, 'valign', 'top'),
    text: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
      id: "table.formatting_menu.valign_top"
    }, "Top")
  }), (0,preact_module.h)(popupMenuItem/* default */.Z, {
    id: "valign-middle",
    icon: icons/* IconVAlignCenter */._oX,
    onClick: onAction.bind(null, 'valign', 'middle'),
    text: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
      id: "table.formatting_menu.valign_center"
    }, "Middle")
  }), (0,preact_module.h)(popupMenuItem/* default */.Z, {
    id: "valign-bottom",
    icon: icons/* IconVAlignBottom */.PKJ,
    onClick: onAction.bind(null, 'valign', 'bottom'),
    text: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
      id: "table.formatting_menu.valign_bottom"
    }, "Bottom")
  }));
}
function TableMenuFormattingComponent() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var editor = props.editor,
    onAction = props.onAction,
    type = props.type,
    allowTextStyle = props.allowTextStyle,
    useRefs = props.useRefs,
    selection = props.selection;
  var getStyle = function getStyle() {
    var style = {};
    if (allowTextStyle && selection.start) {
      if (type === 'col') {
        var _useRefs$links$col$se, _useRefs$links$col$se2;
        style = ((_useRefs$links$col$se = useRefs.links.col[selection.start.col]) === null || _useRefs$links$col$se === void 0 ? void 0 : (_useRefs$links$col$se2 = _useRefs$links$col$se.colData) === null || _useRefs$links$col$se2 === void 0 ? void 0 : _useRefs$links$col$se2.style) || {};
      } else if (type === 'row') {
        var _useRefs$links$row$se, _useRefs$links$row$se2;
        style = ((_useRefs$links$row$se = useRefs.links.row[selection.start.row]) === null || _useRefs$links$row$se === void 0 ? void 0 : (_useRefs$links$row$se2 = _useRefs$links$row$se.rowData) === null || _useRefs$links$row$se2 === void 0 ? void 0 : _useRefs$links$row$se2.style) || {};
      } else if (type === 'cell') {
        var _useRefs$links$cell$s, _useRefs$links$cell$s2, _useRefs$links$cell$s3, _useRefs$links$cell$s4;
        var delta = (_useRefs$links$cell$s = useRefs.links.cell[selection.start.row]) === null || _useRefs$links$cell$s === void 0 ? void 0 : (_useRefs$links$cell$s2 = _useRefs$links$cell$s[selection.start.col]) === null || _useRefs$links$cell$s2 === void 0 ? void 0 : (_useRefs$links$cell$s3 = _useRefs$links$cell$s2.cellData) === null || _useRefs$links$cell$s3 === void 0 ? void 0 : (_useRefs$links$cell$s4 = _useRefs$links$cell$s3.child) === null || _useRefs$links$cell$s4 === void 0 ? void 0 : _useRefs$links$cell$s4.delta;
        if (delta !== null && delta !== void 0 && delta.length) {
          style = delta[0].attributes || {};
        }
      }
    }
    return style;
  };
  var _useState3 = (0,hooks_module/* useState */.eJ)(getStyle()),
    _useState4 = tableMenuFormatting_slicedToArray(_useState3, 2),
    style = _useState4[0],
    setStyle = _useState4[1];
  var onTextColorPicked = function onTextColorPicked(value) {
    onAction('style', {
      color: value
    });
    setStyle(getStyle());
  };
  var menuItems = [];
  if (allowTextStyle) {
    menuItems.push((0,preact_module.h)(popupMenuItem/* default */.Z, {
      id: "text-formatting",
      icon: icons/* IconBold */.lM8,
      text: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
        id: "table.formatting_menu.text"
      }, "Text"),
      submenu: (0,preact_module.h)(TableMenuTextFormattingComponent, {
        editor: editor,
        onAction: onAction,
        getStyle: getStyle.bind(this),
        anchorOptions: props.anchorOptions
      })
    }));
  }
  menuItems.push((0,preact_module.h)(popupMenuItem/* default */.Z, {
    id: "align",
    icon: icons/* IconAlignCenter */.k5Z,
    text: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
      id: "table.formatting_menu.text_align"
    }, "Text align"),
    submenu: (0,preact_module.h)(TableMenuTextAlignComponent, {
      editor: editor,
      onAction: onAction,
      anchorOptions: props.anchorOptions
    })
  }));
  if (allowTextStyle) {
    menuItems.push((0,preact_module.h)(popupMenuItem/* default */.Z, {
      id: "text-formatting-color",
      icon: icons/* IconEmpty */.Zlx,
      text: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
        id: "table.formatting_menu.text_color"
      }, "Text color"),
      submenu: (0,preact_module.h)(PopupColorPicker, {
        mode: "mat-font-color",
        resetColor: false,
        color: getMaterialColorName(style.color) || false,
        colors: textColors,
        onColorPicked: onTextColorPicked,
        addClassName: 'popup-menu-colorpicker popup-menu-wide popup-menu-builtin',
        anchorOptions: props.anchorOptions
      })
    }));
  }
  return (0,preact_module.h)(popupMenu/* default */.Z, tableMenuFormatting_extends({
    addClassName: "with-submenu"
  }, props), menuItems);
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/hint.js
function hint_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { hint_typeof = function _typeof(obj) { return typeof obj; }; } else { hint_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return hint_typeof(obj); }










function hint_extends() { hint_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return hint_extends.apply(this, arguments); }
function hint_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function hint_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function hint_createClass(Constructor, protoProps, staticProps) { if (protoProps) hint_defineProperties(Constructor.prototype, protoProps); if (staticProps) hint_defineProperties(Constructor, staticProps); return Constructor; }
function hint_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) hint_setPrototypeOf(subClass, superClass); }
function hint_setPrototypeOf(o, p) { hint_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return hint_setPrototypeOf(o, p); }
function hint_createSuper(Derived) { var hasNativeReflectConstruct = hint_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = hint_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = hint_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return hint_possibleConstructorReturn(this, result); }; }
function hint_possibleConstructorReturn(self, call) { if (call && (hint_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return hint_assertThisInitialized(self); }
function hint_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function hint_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function hint_getPrototypeOf(o) { hint_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return hint_getPrototypeOf(o); }
function hint_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var Hint = /*#__PURE__*/function (_Component) {
  hint_inherits(Hint, _Component);
  var _super = hint_createSuper(Hint);
  function Hint(props) {
    var _this;
    hint_classCallCheck(this, Hint);
    _this = _super.call(this, props);
    hint_defineProperty(hint_assertThisInitialized(_this), "onRef", function (node) {
      if (node) {
        _this.rootNode = node;
      }
    });
    _this.state = {
      open: false
    };
    return _this;
  }
  hint_createClass(Hint, [{
    key: "render",
    value: function render() {
      var text = this.props.text;
      var props = {};
      props[tooltipManager/* TOOLTIP_ATTR */.qZ] = text;
      props[tooltipManager/* TOOLTIP_ADD_CLASS */.Bg] = 'hint-tooltip';
      props[tooltipManager/* TOOLTIP_ADD_OPTIONS */.cD] = JSON.stringify({
        placement: 'top-start'
      });
      return (0,preact_module.h)("div", hint_extends({
        ref: this.onRef,
        className: "component-hint"
      }, props), (0,preact_module.h)(icons/* IconQuestion */.BS3, null));
    }
  }]);
  return Hint;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/menu/tableMenuCommon.js
function tableMenuCommon_extends() { tableMenuCommon_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tableMenuCommon_extends.apply(this, arguments); }




















function TableMenuComponent(_ref) {
  var menuItems = _ref.menuItems,
    anchorNode = _ref.anchorNode,
    wantsToClose = _ref.wantsToClose,
    _ref$anchorOptions = _ref.anchorOptions,
    anchorOptions = _ref$anchorOptions === void 0 ? {} : _ref$anchorOptions;
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    editor = _useContext.editor;
  var i18n = editor.plugins.i18n;
  var menuRef = (0,hooks_module/* useRef */.sO)(null);
  usePreventEditorScroll(editor, menuRef);
  var addAnchorOpts = {
    overflowBoundariesElement: editor.getScrollingContainer(),
    boundariesElement: editor.getScrollingContainer()
  };
  var createItems = function createItems(currentItems) {
    var items = Object.keys(currentItems).reduce(function (items, key) {
      var item = currentItems[key];
      if (key === 'menu-header') {
        items.push((0,preact_module.h)(TableMenuHeaderComponent, {
          onAction: item.onAction
        }));
      } else if (key === 'separator' && item === true) {
        items.push((0,preact_module.h)(PopupMenuSeparator, null));
      } else if (item) {
        var props = {};
        if (item.submenu) {
          props.submenu = (0,preact_module.h)(popupMenu/* default */.Z, {
            anchorOptions: addAnchorOpts
          }, createItems(item.submenu));
        } else if (key === 'background') {
          props.submenu = (0,preact_module.h)(PopupColorPicker, {
            color: item.value,
            onColorPicked: item.onAction,
            colors: matColorNames,
            addClassName: "popup-menu-colorpicker popup-menu-wide popup-menu-builtin",
            anchorOptions: addAnchorOpts
          });
        } else if (key === 'formatting') {
          props.submenu = (0,preact_module.h)(TableMenuFormattingComponent, {
            editor: editor,
            onAction: item.onAction,
            type: item.type,
            useRefs: item.useRefs,
            selection: item.selection,
            allowTextStyle: item.allowTextStyle,
            anchorOptions: addAnchorOpts
          });
        }
        if (!props.submenu && item.onAction) {
          props.onClick = function () {
            if (!item.disabled) {
              if (!item.keepMenu) {
                wantsToClose();
              }
              if (!item.selected || item.clickOnSelected) {
                item.onAction();
              }
            }
          };
        }
        if (item.text) {
          var textProps = {};
          if (item.hasOwnProperty('plural')) {
            textProps.plural = item.plural;
            textProps.fields = {
              count: parseInt(item.plural) || 1
            };
          }
          var text = (0,preact_module.h)(plugins_i18n/* Text */.xv, tableMenuCommon_extends({
            id: item.text
          }, textProps));
          if (item.textIcon) {
            if (item.iconPosition === 'right') {
              props.text = (0,preact_module.h)("span", {
                className: "menu-item-flex"
              }, (0,preact_module.h)("span", {
                className: "left"
              }, text), (0,preact_module.h)("span", {
                className: "right"
              }, (0,preact_module.h)(item.textIcon, null)));
            } else {
              props.text = (0,preact_module.h)("span", {
                className: "content"
              }, (0,preact_module.h)("span", {
                className: "ico"
              }, (0,preact_module.h)(item.textIcon, null)), (0,preact_module.h)("span", {
                className: "name"
              }, text));
            }
          } else if (item.hint) {
            props.text = (0,preact_module.h)("span", {
              className: "flex"
            }, text, (0,preact_module.h)(Hint, {
              text: i18n.get(item.hint)
            }));
          } else if (item.rightText) {
            props.text = (0,preact_module.h)("span", {
              className: "menu-item-flex"
            }, (0,preact_module.h)("span", {
              className: "left"
            }, text), (0,preact_module.h)("span", {
              className: "right"
            }, item.rightText));
          } else if (item.rightInput) {
            var inputProps = {};
            for (var _i = 0, _arr = ['type', 'value', 'min', 'max', 'placeholder', 'maxLength', 'onClick']; _i < _arr.length; _i++) {
              var k = _arr[_i];
              if (item.rightInput.hasOwnProperty(k)) {
                inputProps[k] = item.rightInput[k];
              }
            }
            props.text = (0,preact_module.h)("span", {
              className: "menu-item-flex"
            }, (0,preact_module.h)("span", {
              className: "left"
            }, text), (0,preact_module.h)("span", {
              className: "right"
            }, (0,preact_module.h)(InputComponent, tableMenuCommon_extends({
              onApply: item.rightInput.onAction
            }, inputProps))));
          } else {
            props.text = text;
          }
        }
        props.menuStyle = [];
        if (item.header) {
          props.menuStyle.push('header');
        }
        if (item.wide) {
          props.menuStyle.push('wide');
        }
        if (item.hasOwnProperty('disabled')) {
          props.menuStyle.push(item.disabled ? 'disabled' : 'enabled');
        }
        if (item.hasOwnProperty('selected')) {
          props.icon = item.selected ? icons/* IconDone */.EZi : '';
          props.menuStyle.push(item.selected ? 'done' : 'undone');
        }
        if (item.hasOwnProperty('className')) {
          props.className = item.className;
        }
        if (item.type) {
          if (item.type === 'number') {
            props.menuStyle.push('input');
            var _inputProps = {};
            for (var _i2 = 0, _arr2 = ['type', 'value', 'min', 'max', 'placeholder']; _i2 < _arr2.length; _i2++) {
              var _k = _arr2[_i2];
              if (item.hasOwnProperty(_k)) {
                _inputProps[_k] = item[_k];
              }
            }
            props.text = (0,preact_module.h)("span", null, props.text, (0,preact_module.h)(InputComponent, tableMenuCommon_extends({
              onApply: item.onAction
            }, _inputProps)));
          }
        }
        items.push((0,preact_module.h)(popupMenuItem/* default */.Z, tableMenuCommon_extends({
          id: key
        }, props)));
      }
      return items;
    }, []);
    return items;
  };
  var popupMenuItems = createItems(menuItems);
  Object.assign(anchorOptions, addAnchorOpts);
  var onMenuMouseDown = function onMenuMouseDown(event) {
    event.preventDefault();
    event.stopPropagation();
  };
  return (0,preact_module.h)(RootPlacement, {
    editor: editor,
    transitionName: "popup-menu",
    transitionTimeout: vars.popupAppearDuration
  }, (0,preact_module.h)(plugins_i18n/* IntlProvider */.Pj, null, (0,preact_module.h)(popupMenu/* default */.Z, {
    ref: menuRef,
    addClassName: "with-submenu position-absolute",
    closeOnEsc: true,
    anchorNode: anchorNode,
    wantsToClose: wantsToClose,
    anchorOptions: anchorOptions,
    onMouseDown: onMenuMouseDown
  }, popupMenuItems)));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/summaries/summaryMenuComponent.js





function SummaryMenu(_ref) {
  var _CELL_TYPES$columnTyp;
  var columnType = _ref.columnType,
    summary = _ref.summary,
    anchorNode = _ref.anchorNode,
    onAction = _ref.onAction,
    wantsToClose = _ref.wantsToClose;
  var summaries = (_CELL_TYPES$columnTyp = CELL_TYPES[columnType]) === null || _CELL_TYPES$columnTyp === void 0 ? void 0 : _CELL_TYPES$columnTyp.summaries;
  var menuItems = {};
  Object.keys(summaries).map(function (key) {
    var summaryItem = summaries[key];
    menuItems[key] = {
      text: "table.summary.name.".concat(summaryItem.mode),
      selected: summaryItem.mode === summary.mode,
      onAction: onAction.bind(null, summaryItem)
    };
  });
  return (0,preact_module.h)(TableMenuComponent, {
    menuItems: menuItems,
    wantsToClose: wantsToClose,
    anchorNode: anchorNode,
    anchorOptions: {
      placement: 'right-start',
      priority: ['top', 'bottom'],
      positionFixed: true
    }
  });
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/summaries/summaryItemComponent.js



















function summaryItemComponent_slicedToArray(arr, i) { return summaryItemComponent_arrayWithHoles(arr) || summaryItemComponent_iterableToArrayLimit(arr, i) || summaryItemComponent_unsupportedIterableToArray(arr, i) || summaryItemComponent_nonIterableRest(); }
function summaryItemComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function summaryItemComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return summaryItemComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return summaryItemComponent_arrayLikeToArray(o, minLen); }
function summaryItemComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function summaryItemComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function summaryItemComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }










function SummaryItem(_ref) {
  var _CELL_TYPES$columnTyp;
  var pos = _ref.pos,
    size = _ref.size;
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    i18n = _useContext.i18n,
    data = _useContext.data,
    setProp = _useContext.setProp,
    useRefs = _useContext.useRefs,
    editable = _useContext.editable,
    globalConfig = _useContext.globalConfig;
  var colData = data.colsData[pos.col] || {};
  var _useState = (0,hooks_module/* useState */.eJ)(0),
    _useState2 = summaryItemComponent_slicedToArray(_useState, 2),
    update = _useState2[0],
    setUpdate = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(false),
    _useState4 = summaryItemComponent_slicedToArray(_useState3, 2),
    menuState = _useState4[0],
    setMenuState = _useState4[1];
  var _useState5 = (0,hooks_module/* useState */.eJ)(null),
    _useState6 = summaryItemComponent_slicedToArray(_useState5, 2),
    tempSummary = _useState6[0],
    setTempSummary = _useState6[1];
  var iconRef = (0,hooks_module/* useRef */.sO)(null);
  var columnType = colData.columnType || CONFIG.col.props.columnType;
  var summary = tempSummary || colData.summary || {
    mode: Object.keys((_CELL_TYPES$columnTyp = CELL_TYPES[columnType]) === null || _CELL_TYPES$columnTyp === void 0 ? void 0 : _CELL_TYPES$columnTyp.summaries)[1]
  };
  var itemClasses = ['summary-item'];
  var nameClasses = ['summary-name'];
  var groupClasses = ['summary-wrap'];
  var renderSummary = function renderSummary() {
    setUpdate(update + 1);
  };
  useRefs.setSummary(pos, {
    render: renderSummary.bind(this)
  });
  var onAction = function onAction(summary) {
    if (editable) {
      setProp('summary', summary, {
        pos: pos,
        type: 'col'
      });
    } else {
      // Для залоченной таблицы или readonly режима разрешаем временно менять summary, но не пишем в map
      setTempSummary(summary);
    }
  };
  var onContextMenu = function onContextMenu(event) {
    event.preventDefault();
    setMenuState(!menuState);
  };
  var onMouseDown = function onMouseDown(event) {
    event.preventDefault();
    //event.stopPropagation()
    setMenuState(!menuState);
  };
  var filterRef = (0,hooks_module/* useRef */.sO)(null);
  var onFilterKeyDown = function onFilterKeyDown(event) {
    if ([8, 13, 27, 37, 38, 39, 40].includes(event.keyCode)) {
      // control keys
    } else if (event.key.length === 1 && (!isNaN(event.key) || !filterRef.current.value && ['<', '>'].includes(event.key))) {
      // change
    } else {
      event.preventDefault();
    }
  };
  var onFilterKeyUp = function onFilterKeyUp(event) {
    if ((0,lib/* default */.ZP)('enter', event)) {
      var filter = String(filterRef.current.value);
      if (filter !== String(summary.filter)) {
        if (summary && summary.max) {
          var number = filter.replace(/[^0-9]*/g, '');
          if (number && parseInt(number) > summary.max) {
            if (isNaN(parseInt(filter[0]))) {
              filter = "".concat(filter[0]).concat(summary.max);
            } else {
              filter = summary.max.toString();
            }
          }
        }
        onAction(Object.assign({}, summary, {
          filter: filter
        }));
        renderSummary();
      }
    }
  };
  var onFilterMouseDown = function onFilterMouseDown(event) {
    event.stopPropagation();
  };
  var name = i18n.get("table.summary.item.".concat(summary.mode)) || i18n.get("table.summary.name.".concat(summary.mode));
  if (name.indexOf(' ') !== -1) {
    nameClasses.push('overflow-ellipsis');
  }
  var input, symbol, value;
  if (summary.mode !== 'none') {
    symbol = ':';
    value = (0,preact_module.h)(SummaryValue, {
      pos: pos,
      size: size,
      summary: summary,
      columnType: columnType
    });
    if (summary.mode.indexOf('filter') === 0) {
      input = (0,preact_module.h)("input", {
        className: "summary-input",
        maxLength: "4",
        ref: filterRef,
        value: summary.filter,
        maxValue: summary.max || 100,
        onMouseDown: onFilterMouseDown,
        onKeyDown: onFilterKeyDown,
        onKeyUp: onFilterKeyUp,
        browser: (0,browser/* detectBrowser */.Ao)()
      });
    }
  } else {
    itemClasses.push('fade-out');
  }
  var icon, menu;
  if (!(globalConfig !== null && globalConfig !== void 0 && globalConfig.disableSummariesMenu)) {
    icon = (0,preact_module.h)("span", {
      ref: iconRef,
      className: "summary-menu-icon"
    }, menuState ? (0,preact_module.h)(icons/* IconArrowRight */.Ec8, null) : (0,preact_module.h)(icons/* IconArrowDown */.BDo, null));
    if (menuState) {
      itemClasses.push('menu-active');
      menu = (0,preact_module.h)(SummaryMenu, {
        summary: summary,
        columnType: columnType,
        anchorNode: iconRef === null || iconRef === void 0 ? void 0 : iconRef.current,
        onAction: onAction.bind(this),
        wantsToClose: setMenuState.bind(this, false)
      });
    }
  } else {
    itemClasses.push('hover-disabled');
  }
  return (0,preact_module.h)("div", {
    className: groupClasses.join(' ')
  }, (0,preact_module.h)("div", {
    className: itemClasses.join(' '),
    onMouseDown: onMouseDown,
    onContextMenu: onContextMenu
  }, (0,preact_module.h)("span", {
    className: nameClasses.join(' ')
  }, name), input, symbol, value, icon, menu));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/tableFootComponent.js







function TableFootComponent(_ref) {
  var size = _ref.size;
  var _useContext = (0,hooks_module/* useContext */.qp)(TableContext),
    data = _useContext.data,
    editable = _useContext.editable,
    useRefs = _useContext.useRefs;
  var skipCols = [];
  for (var col in useRefs.links.big.byCol) {
    for (var row in useRefs.links.big.byCol[col]) {
      var cell = useRefs.links.big.byCol[col][row];
      if (cell.colspan > 1) {
        var start = parseInt(col);
        var end = start + parseInt(cell.colspan);
        for (var c = start; c < end; c++) {
          if (!skipCols.includes(c)) {
            skipCols.push(c);
          }
        }
      }
    }
  }
  var tdArr = [];
  for (var _col = 0; _col < size.cols; _col++) {
    var showSummaries = void 0;
    if (data.settings.showSummaries) {
      if (!skipCols.includes(_col)) {
        showSummaries = true;
      }
    }
    tdArr.push((0,preact_module.h)("td", null, showSummaries ? (0,preact_module.h)(SummaryItem, {
      size: size,
      pos: {
        col: _col
      }
    }) : null));
  }
  return (0,preact_module.h)("tfoot", null, (0,preact_module.h)("tr", null, (0,preact_module.h)("td", {
    className: "add-row"
  }, editable ? (0,preact_module.h)(TableUIAddRow, null) : null), (0,preact_module.h)("td", null), tdArr));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/hooks/useRefs.js
function useRefs_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function useRefs_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { useRefs_ownKeys(Object(source), true).forEach(function (key) { useRefs_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { useRefs_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function useRefs_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

















function useRefs_slicedToArray(arr, i) { return useRefs_arrayWithHoles(arr) || useRefs_iterableToArrayLimit(arr, i) || useRefs_unsupportedIterableToArray(arr, i) || useRefs_nonIterableRest(); }
function useRefs_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function useRefs_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return useRefs_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useRefs_arrayLikeToArray(o, minLen); }
function useRefs_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function useRefs_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function useRefs_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


/**
 * Индексируем элементы таблицы: колонки, ячейки, строки
 * Для того, чтобы обновлять отдельные элементы, а не таблицу целиком
 */
function useRefsHook(_ref) {
  var data = _ref.data;
  var nullState = {
    ui: {},
    col: [],
    row: [],
    cell: [],
    big: {
      byRow: {},
      byCol: {}
    },
    summary: [],
    pointer: {}
  };
  var _useState = (0,hooks_module/* useState */.eJ)(nullState),
    _useState2 = useRefs_slicedToArray(_useState, 2),
    links = _useState2[0],
    setLinks = _useState2[1];
  (0,hooks_module/* useMemo */.Ye)(function () {
    setLinks(nullState);
  }, [data.size.rows, data.size.cols]);
  (0,hooks_module/* useEffect */.d4)(function () {
    if (links.row.length > data.size.rows) {
      links.row = links.row.slice(0, data.size.rows);
      links.cell = links.cell.slice(0, data.size.rows);
    }
    if (links.col.length > data.size.cols) {
      links.col = links.col.slice(0, data.size.cols);
      for (var cell in links.row) {
        links.cell[cell] = links.cell[cell].slice(0, data.size.col);
      }
    }
    setLinks(Object.assign({}, links));
  }, [data.size.rows, data.size.cols, data.size.visibleRows]);

  /**
   * Добавить / обновить ссылку на ячейку
   * @param { object } pos: позиция ячейки
   * @param { number } pos.col: индекс колонки
   * @param { number } pos.row: индекс строки
   * @param { object } options
   * @param { string } options.type: тип ячейки
   * @param { object } options.cellData: данные ячейки
   * @param { object } options.cellProps: параметры ячейки (hidden, colspan, rowspan)
   * @param { function } options.getNode: получение DOM Node компонента
   * @param { function } options.setCurrent: установка статуса current
   * @param { function } options.setSelected: установка статуса selected
   * @param { function } options.onMenuButton: нажатие кнопки меню
   * @param { function } options.onDragEnter: событие вызываемое при наведении dnd
   * @param { function } options.scrollIntoView: прокрутить скролл таблицы, чтобы ячейка была в видимой области
   */
  var setCell = function setCell(pos, actions) {
    var render = actions.render,
      cellData = actions.cellData,
      cellProps = actions.cellProps,
      getNode = actions.getNode,
      setCurrent = actions.setCurrent,
      setSelected = actions.setSelected,
      setDrop = actions.setDrop,
      onMenuButton = actions.onMenuButton,
      onDragEnter = actions.onDragEnter,
      scrollIntoView = actions.scrollIntoView,
      setCommentsCount = actions.setCommentsCount,
      getCommentsCount = actions.getCommentsCount,
      getText = actions.getText;
    if (!links.cell[pos.row]) {
      links.cell[pos.row] = [];
    }
    links.cell[pos.row][pos.col] = {
      render: render,
      cellData: cellData,
      cellProps: cellProps,
      getNode: getNode,
      setDrop: setDrop,
      setCurrent: setCurrent,
      setSelected: setSelected,
      onMenuButton: onMenuButton,
      onDragEnter: onDragEnter,
      scrollIntoView: scrollIntoView,
      setCommentsCount: setCommentsCount,
      getCommentsCount: getCommentsCount,
      getText: getText
    };
    if (cellData) {
      setBigCell(pos, cellData);
    }
  };
  var getCell = function getCell(pos) {
    var _links$cell, _links$cell$pos$row;
    return (_links$cell = links.cell) === null || _links$cell === void 0 ? void 0 : (_links$cell$pos$row = _links$cell[pos.row]) === null || _links$cell$pos$row === void 0 ? void 0 : _links$cell$pos$row[pos.col];
  };
  var setBigCell = function setBigCell(pos) {
    var cellData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _cellData$rowspan = cellData.rowspan,
      rowspan = _cellData$rowspan === void 0 ? 1 : _cellData$rowspan,
      _cellData$colspan = cellData.colspan,
      colspan = _cellData$colspan === void 0 ? 1 : _cellData$colspan;
    if (rowspan > 1 || colspan > 1) {
      if (!links.big.byRow[pos.row]) {
        links.big.byRow[pos.row] = {};
      }
      if (!links.big.byCol[pos.col]) {
        links.big.byCol[pos.col] = {};
      }
      var _data = {
        rowspan: rowspan,
        colspan: colspan
      };
      links.big.byRow[pos.row][pos.col] = _data;
      links.big.byCol[pos.col][pos.row] = _data;
    } else {
      var _links$big$byRow$pos$, _links$big$byCol$pos$;
      if ((_links$big$byRow$pos$ = links.big.byRow[pos.row]) !== null && _links$big$byRow$pos$ !== void 0 && _links$big$byRow$pos$[pos.col]) {
        delete links.big.byRow[pos.row][pos.col];
      }
      if ((_links$big$byCol$pos$ = links.big.byCol[pos.col]) !== null && _links$big$byCol$pos$ !== void 0 && _links$big$byCol$pos$[pos.row]) {
        delete links.big.byCol[pos.col][pos.row];
      }
    }
  };

  /**
   * Добвить данные к существующей ссылке на ячейку
   * @param { object } pos: позиция ячейки
   * @param { any } options.value: значение ячейки
   * @param { boolean } options.empty: признак пустой ячейки
   * @param { function } options.editCell: запуск редактирования ячейки
   * @param { function } options.getText: функция для запроса текстового значения ячейки
   */
  var addToCell = function addToCell(pos) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var items = ['empty', 'value', 'bigint', 'decimal', 'format', 'editCell', 'getText', 'attachments', 'onDrop'];
    for (var _i2 = 0, _items = items; _i2 < _items.length; _i2++) {
      var item = _items[_i2];
      if (props.hasOwnProperty(item)) {
        if (links.cell[pos.row] && links.cell[pos.row][pos.col]) {
          links.cell[pos.row][pos.col][item] = props[item];
        }
      }
    }
  };

  /**
   * Добавить / обновить ссылку на строку
   * @param { object } pos: позиция
   * @param { number } pos.row: индекс строки
   * @param { object } options
   * @param { function } options.render: рендер строки
   * @param { function } options.getNode: получение DOM Node компонента
   * @param { function } options.onResize: установка высоты
   * @param { function } options.setSelected: установка статуса selected
   * @param { function } options.moveAnimate: анимирование перемещения строки
   */
  var setRow = function setRow(pos, _ref2) {
    var rowData = _ref2.rowData,
      render = _ref2.render,
      getNode = _ref2.getNode,
      setSelected = _ref2.setSelected,
      onResize = _ref2.onResize,
      moveAnimate = _ref2.moveAnimate;
    links.row[pos.row] = {
      rowData: rowData,
      render: render,
      getNode: getNode,
      setSelected: setSelected,
      onResize: onResize,
      moveAnimate: moveAnimate
    };
  };

  /**
   * Добавить / обновить ссылку на колонку
   * @param { object } pos: позиция
   * @param { number } pos.col: индекс колонки
   * @param { object } options
   * @param { object } options.colData: данные колонки ( из map )
   * @param { object } options.colFormat: формат колонки объединенный из общего формата типа ее настроек
   * @param { function } options.render: рендер колонки
   * @param { function } options.getNode: получение DOM Node компонента
   * @param { function } options.onResize: установка ширины
   * @param { function } options.setSelected: установка статуса selected
   * @param { function } options.onCellEdit: событие, вызываемое при изменении ячейки
   */
  var setCol = function setCol(pos, _ref3) {
    var colData = _ref3.colData,
      colFormat = _ref3.colFormat,
      getNode = _ref3.getNode,
      setSelected = _ref3.setSelected,
      onCellChange = _ref3.onCellChange,
      onResize = _ref3.onResize,
      rename = _ref3.rename,
      render = _ref3.render;
    links.col[pos.col] = {
      colData: colData,
      colFormat: colFormat,
      getNode: getNode,
      setSelected: setSelected,
      onCellChange: onCellChange,
      onResize: onResize,
      rename: rename,
      render: render
    };
  };

  /**
   * Добвить данные к существующей колонке
   * @param { object } pos: { col } позиция колонки
   * @param { function } options.render: рендер суммирования
   */
  var setSummary = function setSummary(pos, _ref4) {
    var render = _ref4.render;
    links.summary[pos.col] = {
      render: render
    };
  };

  /**
   * Добавить / обновить ссылку на элемент интерфейса
   * @param { string } name: имя элемента
   * @param { object } options: параметры и методы элемента
   */
  var setUI = function setUI(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    links.ui[name] = options;
  };
  var getPointer = function getPointer(name) {
    var _links$pointer$name;
    if ((_links$pointer$name = links.pointer[name]) !== null && _links$pointer$name !== void 0 && _links$pointer$name.pos) {
      var _links$cell$pos$row2;
      var pos = links.pointer[name].pos;
      return useRefs_objectSpread(useRefs_objectSpread({}, ((_links$cell$pos$row2 = links.cell[pos.row]) === null || _links$cell$pos$row2 === void 0 ? void 0 : _links$cell$pos$row2[pos.col]) || {}), links.pointer[name]);
    }
    return false;
  };
  var setPointer = function setPointer(name, pos) {
    var _links$pointer$name2;
    links.pointer[name];
    if ((_links$pointer$name2 = links.pointer[name]) !== null && _links$pointer$name2 !== void 0 && _links$pointer$name2.pos) {
      var oldPos = links.pointer[name].pos;
      if (pos && pos.col === oldPos.col && pos.row === oldPos.ros) {
        return;
      }
      if (name === 'drop') {
        var _links$cell$oldPos$ro, _links$cell$oldPos$ro2, _links$cell$oldPos$ro3;
        (_links$cell$oldPos$ro = links.cell[oldPos.row]) === null || _links$cell$oldPos$ro === void 0 ? void 0 : (_links$cell$oldPos$ro2 = _links$cell$oldPos$ro[oldPos.col]) === null || _links$cell$oldPos$ro2 === void 0 ? void 0 : (_links$cell$oldPos$ro3 = _links$cell$oldPos$ro2.setDrop) === null || _links$cell$oldPos$ro3 === void 0 ? void 0 : _links$cell$oldPos$ro3.call(_links$cell$oldPos$ro2, false);
      }
    }
    if (pos) {
      var _links$cell$pos$row3, _links$cell$pos$row3$, _links$cell$pos$row3$2;
      links.pointer[name] = {
        pos: pos
      };
      (_links$cell$pos$row3 = links.cell[pos.row]) === null || _links$cell$pos$row3 === void 0 ? void 0 : (_links$cell$pos$row3$ = _links$cell$pos$row3[pos.col]) === null || _links$cell$pos$row3$ === void 0 ? void 0 : (_links$cell$pos$row3$2 = _links$cell$pos$row3$.setDrop) === null || _links$cell$pos$row3$2 === void 0 ? void 0 : _links$cell$pos$row3$2.call(_links$cell$pos$row3$, true);
    } else {
      links.pointer[name] = null;
    }
  };
  return {
    links: links,
    setUI: setUI,
    setRow: setRow,
    setCol: setCol,
    setSummary: setSummary,
    setCell: setCell,
    addToCell: addToCell,
    setBigCell: setBigCell,
    setPointer: setPointer,
    getPointer: getPointer,
    getCell: getCell
  };
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/hooks/useResize.js











function useResize_slicedToArray(arr, i) { return useResize_arrayWithHoles(arr) || useResize_iterableToArrayLimit(arr, i) || useResize_unsupportedIterableToArray(arr, i) || useResize_nonIterableRest(); }
function useResize_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function useResize_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return useResize_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useResize_arrayLikeToArray(o, minLen); }
function useResize_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function useResize_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function useResize_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


/**
 * Ресайз колонок / столбцов
 */
function UseResize(_ref) {
  var useRefs = _ref.useRefs;
  var links = useRefs.links;
  var _useState = (0,hooks_module/* useState */.eJ)({
      session: false,
      mode: null,
      pos: null
    }),
    _useState2 = useResize_slicedToArray(_useState, 2),
    resize = _useState2[0],
    setResize = _useState2[1];
  var _setResize = function _setResize() {
    var updValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    Object.assign(resize, updValue);
    setResize(Object.assign({}, resize));
  };
  var _addListeners = function _addListeners() {
    document.addEventListener('mouseup', onMouseUp, true);
    document.addEventListener('mousemove', onMouseMove, true);
  };
  var _removeListeners = function _removeListeners() {
    document.removeEventListener('mouseup', onMouseUp, true);
    document.removeEventListener('mousemove', onMouseMove, true);
  };
  var onMouseUp = function onMouseUp(event) {
    onResize(event, {
      save: true
    });
    sessionEnd();
  };
  var onMouseMove = function onMouseMove(event) {
    onResize(event);
  };

  /**
   * Передает событие ресайза в колонку или строку
   * @param {event} event: событие
   * @param {object} options?
   * @param {boolean} options.save?: сохранить значение в map
   */
  var onResize = function onResize(event) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (resize.mode === 'col') {
      var _links$col$resize$pos;
      (_links$col$resize$pos = links.col[resize.pos.col]) === null || _links$col$resize$pos === void 0 ? void 0 : _links$col$resize$pos.onResize(event, options);
    } else if (resize.mode === 'row') {
      var _links$row$resize$pos;
      (_links$row$resize$pos = links.row[resize.pos.row]) === null || _links$row$resize$pos === void 0 ? void 0 : _links$row$resize$pos.onResize(event, options);
    }
  };

  /**
   * Начать сессию ресайза
   * @param {string} mode: режим ресайза: col / row
   * @param {object} pos: позиция
   * @param {number} pos.col?: индекс колонки
   * @param {number} pos.row?: индекс строки
   */
  var sessionStart = function sessionStart(mode) {
    var pos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _addListeners();
    _setResize({
      pos: pos,
      mode: mode,
      session: true
    });
  };

  /**
   * Завершить сессию выделения ячеек
   */
  var sessionEnd = function sessionEnd() {
    _removeListeners();
    _setResize({
      pos: null,
      mode: null,
      session: false
    });
  };
  return {
    resize: resize,
    sessionStart: sessionStart,
    sessionEnd: sessionEnd
  };
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/hooks/useSelection.js
function useSelection_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = useSelection_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }



















function useSelection_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function useSelection_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { useSelection_ownKeys(Object(source), true).forEach(function (key) { useSelection_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { useSelection_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function useSelection_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function useSelection_slicedToArray(arr, i) { return useSelection_arrayWithHoles(arr) || useSelection_iterableToArrayLimit(arr, i) || useSelection_unsupportedIterableToArray(arr, i) || useSelection_nonIterableRest(); }
function useSelection_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function useSelection_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return useSelection_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useSelection_arrayLikeToArray(o, minLen); }
function useSelection_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function useSelection_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function useSelection_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




/**
 * Выделение ячеек таблицы
 */
function UseSelection(_ref) {
  var editor = _ref.editor,
    version = _ref.version,
    data = _ref.data,
    useRefs = _ref.useRefs,
    useUtils = _ref.useUtils,
    tableExec = _ref.tableExec,
    renderWithFilter = _ref.renderWithFilter;
  var selectionScroller = editor.plugins.selectionScroller;
  var links = useRefs.links;
  var _sessionStartTimeout = null;
  var nullState = {
    current: null,
    // текущая ячейка
    enter: null,
    // ячейка наведения мыши/клавиатуры
    start: null,
    // первая позиция в выделении <= end
    end: null,
    // конец области выделения >= start
    last: null,
    // последняя позциция в выделении, может быть меньше end в случае мерджа, >= start, <= end
    mode: null
  };
  var _useState = (0,hooks_module/* useState */.eJ)(useSelection_objectSpread({
      session: false,
      mode: null
    }, nullState)),
    _useState2 = useSelection_slicedToArray(_useState, 2),
    selection = _useState2[0],
    setSelected = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(selection),
    _useState4 = useSelection_slicedToArray(_useState3, 2),
    selectionCache = _useState4[0],
    setSelectedCache = _useState4[1];
  var isTempRowSelected = (0,hooks_module/* useRef */.sO)(false);
  var _setSelected = function _setSelected() {
    var updSelection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var newSelection = Object.assign(selection, updSelection);
    if (!(0,util/* isEqual */.Xy)(selection, newSelection)) {
      setSelected(newSelection);
    }
  };
  var _addListeners = function _addListeners() {
    document.addEventListener('mouseup', onMouseUp, true);
  };
  var _removeListeners = function _removeListeners() {
    document.removeEventListener('mouseup', onMouseUp, true);
  };
  var onMouseUp = function onMouseUp() {
    sessionEnd();
  };

  /**
   * Начать сессию выделения ячеек
   * @param {object} options?
   * @param {boolean} options.timeout? запускать сессию с таймаутом (удержание мыши), чтобы не переключать state при любом в клике по ячейке
   */
  var sessionStart = function sessionStart() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _addListeners();
    _sessionStartTimeout = setTimeout(function () {
      _setSelected({
        session: true
      });
    }, options.timeout ? CONFIG.selection.timeout : 0);
  };

  /**
   * Завершить сессию выделения ячеек
   */
  var sessionEnd = function sessionEnd() {
    _removeListeners();
    clearTimeout(_sessionStartTimeout);
    if (selection.session) {
      _setSelected({
        session: false
      });
    }
  };

  /**
   * Установить текущую ячейку
   * @param {object} pos: позиция ячейки
   * @param {number} pos.col: индекс колонки
   * @param {number} pos.row: индекс строки
   * @param {object} options: опции
   * @param {boolean} options.session: запуск сессии выделения
   * @param {boolean} options.ensureCellVisible: скроллить к ячейке при необходимости
   */
  var setCurrent = function setCurrent(pos) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (options.session) {
      sessionStart({
        timeout: true
      });
    }
    unselectCurrent();
    var edge,
      current,
      mode = null;
    if (pos.hasOwnProperty('row') && pos.hasOwnProperty('col')) {
      // Выбор ячейки
      current = pos;
      mode = 'cell';
    } else {
      if (pos.hasOwnProperty('col')) {
        // Выбор колонки
        mode = 'col';
        current = Object.assign({
          row: 0
        }, pos);
        edge = Object.assign({
          row: links.row.length - 1
        }, pos);
      } else if (pos.hasOwnProperty('row')) {
        // Выбор строки
        mode = 'row';
        current = Object.assign({
          col: 0
        }, pos);
        edge = Object.assign({
          col: links.col.length - 1
        }, pos);
        if (options.tempRow) {
          isTempRowSelected.current = true;
        }
      }
    }
    // при фильтрации строки могут быть скрыты, поэтому делаем проверку на существование строки
    if (links.cell[current.row]) {
      links.cell[current.row][current.col].setCurrent(true);
    }
    if (options.ensureCellVisible) {
      ensureCellVisible(current);
    }
    calculateSelection(edge || pos, current);
    _setSelected({
      current: current,
      enter: current,
      mode: mode
    });
    menuBtn();
    setSelectedCache(useSelection_objectSpread({}, selection));
  };

  /**
   * Cкроллить к ячейке при необходимости
   * @param { object } pos?: позиция ячейки, если не переданна то берет current ячейку
   * @param { number } pos.col: индекс колонки
   * @param { number } pos.row: индекс строки
   */
  var ensureCellVisible = function ensureCellVisible() {
    var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : selection.current;
    if (pos.hasOwnProperty('row') && pos.hasOwnProperty('col')) {
      var _links$cell$pos$row$p, _links$cell$pos$row$p2;
      var cellNode = (_links$cell$pos$row$p = (_links$cell$pos$row$p2 = links.cell[pos.row][pos.col]).getNode) === null || _links$cell$pos$row$p === void 0 ? void 0 : _links$cell$pos$row$p.call(_links$cell$pos$row$p2);
      if (cellNode) {
        var _useRefs$links$ui$scr;
        selectionScroller.ensureNodeVisible(cellNode, {
          offset: Math.max(100, cellNode.offsetHeight + 20)
        });
        (_useRefs$links$ui$scr = useRefs.links.ui.scroll) === null || _useRefs$links$ui$scr === void 0 ? void 0 : _useRefs$links$ui$scr.scrollTo(cellNode);
      }
    }
  };

  /**
   * Наведение на ячейку
   * При активной сессии пересчитывает range
   * @param {object} pos: позиция ячейки
   * @param {number} pos.col: индекс колонки
   * @param {number} pos.row: индекс строки
   * @param {object} options
   * @param {boolean} options.force?: выделять при неактивной сессии (напр. клавиатура)
   * @param {boolean} options.menu?: позиционировать кнопку меню на выделенную область или наведенную ячейку
   * @returns {object} {start, end}: позиции выделения
   */
  var setSelection = function setSelection(position) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var result = null;
    if (options.force && !selection.current) {
      setCurrent(position);
    } else if (selection.session || options.force) {
      var pos = Object.assign({}, position);
      if (selection.mode === 'col') {
        pos.row = links.row.length - 1;
      } else if (selection.mode === 'row') {
        pos.col = links.col.length - 1;
      } else {
        pos.col = pos.col || 0;
        pos.row = pos.row || 0;
      }
      if (pos.hasOwnProperty('col') && pos.hasOwnProperty('row')) {
        var _calculateSelection = calculateSelection(pos),
          start = _calculateSelection.start,
          end = _calculateSelection.end;
        _setSelected({
          enter: pos
        });
        if (options.menu) {
          var _links$ui$cellMenuB;
          (_links$ui$cellMenuB = links.ui['cell-menu-btn']) === null || _links$ui$cellMenuB === void 0 ? void 0 : _links$ui$cellMenuB.setTarget(end);
        }
        result = {
          start: start,
          end: end
        };
      }
    }
    menuBtn(position);
    return result;
  };

  /**
   * Позиционирует кнопку меню на ячейку или выделенную область
   * @param {object} pos?: позиция
   * @param {number} pos.col: индекс колонки
   * @param {number} pos.row: индекс строки
   */
  var menuBtn = function menuBtn() {
    var _links$ui$cellMenuB2;
    var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (selection.last) {
      pos = selection.last;
    }
    (_links$ui$cellMenuB2 = links.ui['cell-menu-btn']) === null || _links$ui$cellMenuB2 === void 0 ? void 0 : _links$ui$cellMenuB2.setTarget(pos);
  };

  /**
   * Возвращает данные ячейки, по умолчанию выделенной
   * @param {object} pos?: позиция
   * @param {number} pos.col: индекс колонки
   * @param {number} pos.row: индекс строки
   */
  var getCell = function getCell() {
    var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : selection.current;
    var cell = null;
    if (pos) {
      cell = links.cell[pos.row][pos.col];
    }
    return cell;
  };

  /**
   * Возвращает ближайшую заполненную ячейку в переданном направлении относительно заданной позиции
   * Если ни одна ячейка по направлению не заполнена, то вернет крайнуюю ячейку таблицы по этом направлению
   * @param { string } dir: направление up, duwn, left, right
   * @param { object } pos: начальная позиция { row, col }
   * @returns { object } позиция { row, col }
   */
  var getFilledOrEdgeCell = function getFilledOrEdgeCell(dir) {
    var pos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var result = useSelection_objectSpread({}, pos);
    if (dir === 'up') {
      result.row = 0;
      for (var row = pos.row - 1; row >= 0; row--) {
        var _links$cell$row, _link$cellData;
        var link = (_links$cell$row = links.cell[row]) === null || _links$cell$row === void 0 ? void 0 : _links$cell$row[pos.col];
        if (link && !link.empty && !((_link$cellData = link.cellData) !== null && _link$cellData !== void 0 && _link$cellData.hidden)) {
          result.row = row;
          break;
        }
      }
    } else if (dir === 'down') {
      var rowMax = links.row.length - 1;
      result.row = rowMax;
      for (var _row = pos.row + 1; _row <= rowMax; _row++) {
        var _links$cell$_row, _link$cellData2;
        var _link = (_links$cell$_row = links.cell[_row]) === null || _links$cell$_row === void 0 ? void 0 : _links$cell$_row[pos.col];
        if (_link && !_link.empty && !((_link$cellData2 = _link.cellData) !== null && _link$cellData2 !== void 0 && _link$cellData2.hidden)) {
          result.row = _row;
          break;
        }
      }
    } else if (dir === 'left') {
      result.col = 0;
      for (var col = pos.col - 1; col >= 0; col--) {
        var _links$cell$pos$row, _link2$cellData;
        var _link2 = (_links$cell$pos$row = links.cell[pos.row]) === null || _links$cell$pos$row === void 0 ? void 0 : _links$cell$pos$row[col];
        if (_link2 && !_link2.empty && !((_link2$cellData = _link2.cellData) !== null && _link2$cellData !== void 0 && _link2$cellData.hidden)) {
          result.col = col;
          break;
        }
      }
    } else if (dir === 'right') {
      var colMax = links.col.length - 1;
      result.col = colMax;
      for (var _col = pos.col + 1; _col <= colMax; _col++) {
        var _links$cell$pos$row2, _link3$cellData;
        var _link3 = (_links$cell$pos$row2 = links.cell[pos.row]) === null || _links$cell$pos$row2 === void 0 ? void 0 : _links$cell$pos$row2[_col];
        if (_link3 && !_link3.empty && !((_link3$cellData = _link3.cellData) !== null && _link3$cellData !== void 0 && _link3$cellData.hidden)) {
          result.col = _col;
          break;
        }
      }
    }
    return result;
  };

  /**
   * Перемещает выделение в таблице
   * @param {string} dir: направление up, duwn, left, right
   * @param {object} options:
   * @param {boolean} options.selection: режим выделения
   * @param {boolean} options.end: переместить в конец таблицы
   * @param {boolean} options.filled: переместить к заполненной ячейке или в конец таблицы, если заполненной нет
   */
  var moveSelection = (0,hooks_module/* useCallback */.I4)(function (dir) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var handled = false;
    var pos = {
      row: 0,
      col: 0
    };
    if (options.selection && selection.enter) {
      pos = Object.assign(pos, selection.enter);
    } else if (selection.current) {
      pos = Object.assign(pos, selection.current);
    }
    var props = {
      colspan: 1,
      rowspan: 1
    };
    var cell = getCell(pos);
    if (cell !== null && cell !== void 0 && cell.cellProps) {
      props.rowspan = cell.cellProps.rowspan ? cell.cellProps.rowspan : 1;
      props.colspan = cell.cellProps.colspan ? cell.cellProps.colspan : 1;
    }
    var filled;
    if (options.filled) {
      filled = getFilledOrEdgeCell(dir, pos);
    }
    if (dir === 'up') {
      if (options.end) {
        pos.row = 0;
      } else if (options.filled) {
        pos.row = filled.row;
      } else {
        pos.row = Math.max(0, pos.row - 1);
      }
    } else if (dir === 'down') {
      if (options.end) {
        pos.row = links.row.length - 1;
      } else if (options.filled) {
        pos.row = filled.row;
      } else {
        pos.row = Math.min(pos.row + props.rowspan, links.row.length - 1);
      }
    } else if (dir === 'left') {
      if (options.end) {
        pos.col = 0;
      } else if (options.filled) {
        pos.col = filled.col;
      } else {
        pos.col = Math.max(0, pos.col - 1);
      }
      handled = true;
    } else if (dir === 'right') {
      if (options.end) {
        pos.col = links.col.length - 1;
      } else if (options.filled) {
        pos.col = filled.col;
      } else {
        pos.col = Math.min(pos.col + props.colspan, links.col.length - 1);
      }
      handled = true;
    }
    pos = getMainCell(pos);
    if (options.selection) {
      setSelection(pos, {
        force: true
      });
      handled = true;
    } else {
      if (!(0,util/* isEqual */.Xy)(pos, selection.current) || !(0,util/* isEqual */.Xy)(selection.start, selection.end)) {
        setCurrent(pos, {
          ensureCellVisible: true
        });
        handled = true;
      }
    }
    return handled;
  }, [version]);

  /**
   * Сдвигает область выделения целиком
   * @param {object} shift:
   * @param {number} shift.rows: количество строк
   * @param {number} shift.cols: количество колонок
   */
  var shiftSelection = function shiftSelection() {
    var shift = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (selection.start && selection.end) {
      var start = {
        row: selection.start.row + (shift.rows || 0),
        col: selection.start.col + (shift.cols || 0)
      };
      var end = {
        row: selection.end.row + (shift.rows || 0),
        col: selection.end.col + (shift.cols || 0)
      };
      setCurrent(start);
      setSelection(end, {
        force: true
      });
    }
  };

  /**
   * Возвращает позицию главной ячейки из позиции выделенной
   * Если передана позиция не мердженной ячейки то вернет ту же самую позицию
   * @param {object} pos: позиция
   * @param {number} pos.col: индекс колонки
   * @param {number} pos.row: индекс строки
   * @returns {object} позиция главной ячейки
   */
  var getMainCell = function getMainCell(pos) {
    var main = null;
    for (var row = pos.row; row >= 0; row--) {
      for (var col = pos.col; col >= 0; col--) {
        var _links$cell$row2, _links$cell$row2$col;
        var cellProps = (_links$cell$row2 = links.cell[row]) === null || _links$cell$row2 === void 0 ? void 0 : (_links$cell$row2$col = _links$cell$row2[col]) === null || _links$cell$row2$col === void 0 ? void 0 : _links$cell$row2$col.cellProps;
        if (!cellProps.hidden) {
          if (row + (cellProps.rowspan || 1) - 1 >= pos.row && col + (cellProps.colspan || 1) - 1 >= pos.col) {
            main = {
              row: row,
              col: col
            };
          }
          break;
        }
      }
      if (main) {
        break;
      }
    }
    return main;
  };

  /**
   * Выделить все ячейки
   */
  var selectAll = function selectAll() {
    var start = {
      col: 0,
      row: 0
    };
    var end = {
      row: links.row.length - 1,
      col: links.col.length - 1
    };
    selectionWillUpdate({
      start: start,
      end: end
    });
    _setSelected({
      start: start,
      end: end,
      last: end
    });
    menuBtn();
  };

  /**
   * Снять выделение с текущей ячейки
   */
  var unselectCurrent = function unselectCurrent() {
    if (selection.current) {
      var _links$cell$selection, _links$cell$selection2;
      (_links$cell$selection = links.cell[selection.current.row]) === null || _links$cell$selection === void 0 ? void 0 : (_links$cell$selection2 = _links$cell$selection[selection.current.col]) === null || _links$cell$selection2 === void 0 ? void 0 : _links$cell$selection2.setCurrent(false);
      if (renderWithFilter()) {
        var _links$ui$table, _links$ui$table$getNo;
        Array.from((_links$ui$table = links.ui.table) === null || _links$ui$table === void 0 ? void 0 : (_links$ui$table$getNo = _links$ui$table.getNode()) === null || _links$ui$table$getNo === void 0 ? void 0 : _links$ui$table$getNo.querySelectorAll('tbody tr td')).filter(function (cellNode) {
          return cellNode.classList.contains('current');
        }).forEach(function (cellNode) {
          cellNode.classList.remove('current');
          cellNode.classList.remove('selected');
        });
      }
      return true;
    }
    return false;
  };

  /**
   * Снять выделение полностью
   */
  var unselectAll = function unselectAll() {
    selectionWillUpdate(useSelection_objectSpread({}, nullState));
    unselectCurrent();
    _setSelected(useSelection_objectSpread({}, nullState));
    menuBtn(null);
  };

  /**
   * Возвращает большую ячейку по координатам внутренней
   * @param { object } pos: { row, col }
   * @returns { object } bigCell
   * @returns { object } bigCell.pos: {row, col} позиция ячейки
   * @returns { number } bigCell.rowspan: число смержденных строк
   * @returns { number } bigCell.colspan: число смержденных колонок
   * @returns { boolean } bigCell.merged: ячейка является смердженной
   * @returns { boolean } bigCell.main: переданная позициция является первой позицией в ячейке
   */
  var getBigCell = function getBigCell() {
    var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    links.cell[pos.row][pos.col].cellProps;
    var _links$cell$pos$row$p3 = links.cell[pos.row][pos.col].cellProps,
      _links$cell$pos$row$p4 = _links$cell$pos$row$p3.rowspan,
      rowspan = _links$cell$pos$row$p4 === void 0 ? 1 : _links$cell$pos$row$p4,
      _links$cell$pos$row$p5 = _links$cell$pos$row$p3.colspan,
      colspan = _links$cell$pos$row$p5 === void 0 ? 1 : _links$cell$pos$row$p5,
      _links$cell$pos$row$p6 = _links$cell$pos$row$p3.hidden,
      hidden = _links$cell$pos$row$p6 === void 0 ? false : _links$cell$pos$row$p6;
    var result = {
      pos: useSelection_objectSpread({}, pos),
      rowspan: rowspan,
      colspan: colspan,
      merged: rowspan > 1 || colspan > 1
    };
    if (!hidden) {
      result.main = true;
    } else {
      for (var row = pos.row; row >= 0; row--) {
        for (var col = pos.col; col >= 0; col--) {
          var _links$cell$row$col$c = links.cell[row][col].cellProps,
            _links$cell$row$col$c2 = _links$cell$row$col$c.rowspan,
            _rowspan = _links$cell$row$col$c2 === void 0 ? 1 : _links$cell$row$col$c2,
            _links$cell$row$col$c3 = _links$cell$row$col$c.colspan,
            _colspan = _links$cell$row$col$c3 === void 0 ? 1 : _links$cell$row$col$c3,
            _links$cell$row$col$c4 = _links$cell$row$col$c.hidden,
            _hidden = _links$cell$row$col$c4 === void 0 ? false : _links$cell$row$col$c4;
          if (!_hidden) {
            if (row + _rowspan - 1 >= pos.row && col + _colspan - 1 >= pos.col) {
              result = {
                pos: {
                  row: row,
                  col: col
                },
                rowspan: _rowspan,
                colspan: _colspan,
                merged: _rowspan > 1 || _colspan > 1,
                main: false
              };
            }
            break;
          }
        }
        if (result.pos) {
          break;
        }
      }
    }
    result.end = {
      row: result.pos.row + result.rowspan - 1,
      col: result.pos.col + result.colspan - 1
    };
    return result;
  };

  /**
   * Определяет итоговую область выделения, с учетом всех мердженных ячеек
   * @param { object } pos: { row, col }
   * @param { object } current: { row, col }
   * @returns { object }: { start, end, last }
   */
  var calculateSelection = function calculateSelection(pos) {
    var current = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : selection.current;
    var start = {
      row: Math.min(pos.row, current.row),
      col: Math.min(pos.col, current.col)
    };
    var end = {
      row: Math.max(pos.row, current.row),
      col: Math.max(pos.col, current.col)
    };
    var last = {
      row: 0,
      col: 0
    };
    var checked;
    var bigCells = [];
    var calcCells = function calcCells() {
      for (var row = start.row; row <= end.row; row++) {
        for (var col = start.col; col <= end.col; col++) {
          if (
          // Избегаем повторной проверки одних и тех же областей
          !checked || row <= checked.start.row || row >= checked.end.row || col <= checked.start.col || col >= checked.end.col) {
            var _links$cell$row3, _links$cell$row3$col;
            if ((_links$cell$row3 = links.cell[row]) !== null && _links$cell$row3 !== void 0 && (_links$cell$row3$col = _links$cell$row3[col]) !== null && _links$cell$row3$col !== void 0 && _links$cell$row3$col.cellProps) {
              var _links$cell$row$col$c5 = links.cell[row][col].cellProps,
                _links$cell$row$col$c6 = _links$cell$row$col$c5.rowspan,
                rowspan = _links$cell$row$col$c6 === void 0 ? 1 : _links$cell$row$col$c6,
                _links$cell$row$col$c7 = _links$cell$row$col$c5.colspan,
                colspan = _links$cell$row$col$c7 === void 0 ? 1 : _links$cell$row$col$c7,
                _links$cell$row$col$c8 = _links$cell$row$col$c5.hidden,
                hidden = _links$cell$row$col$c8 === void 0 ? false : _links$cell$row$col$c8;
              if (colspan > 1 || rowspan > 1 || hidden) {
                var skip = false;
                var _iterator = useSelection_createForOfIteratorHelper(bigCells),
                  _step;
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    var big = _step.value;
                    if (row >= big.pos.row && row <= big.end.row && col >= big.pos.col && col <= big.end.col) {
                      skip = true;
                      break;
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
                if (!skip) {
                  var bigCell = getBigCell({
                    row: row,
                    col: col
                  });
                  bigCells.push(bigCell);
                  start.row = Math.min(start.row, bigCell.pos.row);
                  start.col = Math.min(start.col, bigCell.pos.col);
                  end.row = Math.max(end.row, bigCell.end.row);
                  end.col = Math.max(end.col, bigCell.end.col);
                }
              }
              if (!hidden) {
                var rowspanEnd = row + rowspan - 1;
                var colspanEnd = col + colspan - 1;
                if (rowspanEnd >= last.row && colspanEnd >= last.col) {
                  last.row = row;
                  last.col = col;
                }
              }
            }
          }
        }
      }
      checked = {
        start: {
          row: start.row,
          col: start.col
        },
        end: {
          row: end.row,
          col: end.col
        }
      };
    };
    var pre,
      i = 0;
    do {
      // При расширении области выделения в нее могут попасть новые мердженные ячейки
      // Запуск в цикле позволяет выделить любые комбинации ячеек (была проблема в таблицах V1)
      pre = {
        start: Object.assign({}, start),
        end: Object.assign({}, end)
      };
      calcCells();
    } while (i++ < 3 && (end.col !== pre.end.col || end.row !== pre.end.row || start.col !== pre.start.col || start.row !== pre.start.row));
    selectionWillUpdate({
      start: start,
      end: end
    });
    _setSelected({
      start: start,
      end: end,
      last: last
    });
    return {
      start: start,
      end: end,
      last: last
    };
  };
  var selectionWillUpdate = function selectionWillUpdate(_ref2) {
    var start = _ref2.start,
      end = _ref2.end;
    var selected = start && end;
    var isFullRow = selected && start.col === 0 && end.col === links.col.length - 1;
    var isFullCol = selected && start.row === 0 && end.row === links.row.length - 1;
    var isFullTable = isFullRow && isFullCol;

    // Снимаем старое выделение
    if (!isFullTable && selection.start && selection.end) {
      for (var row = selection.start.row; row <= selection.end.row; row++) {
        var unselectRow = false;
        for (var col = selection.start.col; col <= selection.end.col; col++) {
          if (!selected || !start.col || !end.col || col < start.col || col > end.col || row < start.row || row > end.row) {
            var _links$cell$row4, _links$cell$row4$col;
            (_links$cell$row4 = links.cell[row]) === null || _links$cell$row4 === void 0 ? void 0 : (_links$cell$row4$col = _links$cell$row4[col]) === null || _links$cell$row4$col === void 0 ? void 0 : _links$cell$row4$col.setSelected(false);
            unselectRow = true;
          }
        }
        if (unselectRow) {
          var _links$row$row;
          (_links$row$row = links.row[row]) === null || _links$row$row === void 0 ? void 0 : _links$row$row.setSelected(false);
        }
      }
      for (var _col2 = selection.start.col; _col2 <= selection.end.col; _col2++) {
        var _links$col$_col;
        (_links$col$_col = links.col[_col2]) === null || _links$col$_col === void 0 ? void 0 : _links$col$_col.setSelected(false);
      }
    }
    if (selected) {
      for (var _row2 = start.row; _row2 <= end.row; _row2++) {
        for (var _col3 = start.col; _col3 <= end.col; _col3++) {
          var _links$cell$_row2, _links$cell$_row2$_co;
          (_links$cell$_row2 = links.cell[_row2]) === null || _links$cell$_row2 === void 0 ? void 0 : (_links$cell$_row2$_co = _links$cell$_row2[_col3]) === null || _links$cell$_row2$_co === void 0 ? void 0 : _links$cell$_row2$_co.setSelected(true);
        }
        if (isFullRow) {
          var _links$row$_row;
          (_links$row$_row = links.row[_row2]) === null || _links$row$_row === void 0 ? void 0 : _links$row$_row.setSelected(true);
        }
      }
      if (isFullCol) {
        for (var _col4 = start.col; _col4 <= end.col; _col4++) {
          var _links$col$_col2;
          (_links$col$_col2 = links.col[_col4]) === null || _links$col$_col2 === void 0 ? void 0 : _links$col$_col2.setSelected(true);
        }
      }
    } else {
      if (selection.current) {
        var _links$cell$selection3, _links$cell$selection4;
        (_links$cell$selection3 = links.cell[selection.current.row]) === null || _links$cell$selection3 === void 0 ? void 0 : (_links$cell$selection4 = _links$cell$selection3[selection.current.row]) === null || _links$cell$selection4 === void 0 ? void 0 : _links$cell$selection4.setCurrent(false);
      }
    }
    links.ui.circle.setSelected(isFullTable ? true : false);
    if (data.props.tempRow && isTempRowSelected.current) {
      var rowPos = Object.keys(data.rowsData).find(function (index) {
        return data.rowsData[index].id === data.props.tempRow;
      });
      if (rowPos) {
        if (!selected || start.row !== parseInt(rowPos) && end.row !== parseInt(rowPos)) {
          isTempRowSelected.current = false;
          tableExec('unset-temp-row');
        }
      }
    }
  };

  /**
   * Возвращает массив с индексами выделенных строк
   * @returns {array} [index, ...]
   */
  var rows = function rows() {
    var rows = [];
    if (selection.start && selection.end) {
      for (var r = selection.start.row; r <= selection.end.row; r++) {
        rows.push(r);
      }
    }
    return rows;
  };

  /**
   * Возвращает массив с индексами выделенных колонок
   * @returns {array} [index, ...]
   */
  var cols = function cols() {
    var cols = [];
    if (selection.start && selection.end) {
      for (var c = selection.start.col; c <= selection.end.col; c++) {
        cols.push(c);
      }
    }
    return cols;
  };

  /**
   * Возвращает расширенную информацию о выделении
   * @param { object } options?
   * @param { boolean } options.merged?: возвращать информацию о мердже
   * @param { boolean } options.colsInfo?: расширенная информация о колонках
   * @param { boolean } options.cellsInfo?: расширенная информация о ячейках
   * @returns { object } {
   *   ...selection - стандартная информация о выделении
   *   { number } rows - число строк в выделении
   *   { number } cols - число колонок в выделении
   *   { boolean } single - выделение является одной ячейкой, включая мердж
   *   { boolean } lastRow - старт выделения находится на последней строке
   *   { boolean } lastRowEnd - конец выделения находится в последней строке
   *   { object } merged? - информация о мердже, если запрошена в options.merge=true
   *      { boolean } cells - наличие мердженных ячеек
   *      { boolean } rows - наличие мердженных по строкам ячеек
   *      { boolean } cols - наличие мердженных по колонкам ячеек
   *   { object } colsInfo? - информация о колоках, если запрошена в options.colInfo=true
   *      { string | boolean } sameType - вернет тип, если он одинаков у всех колонок и false если отличается
   *      { object } data - данные колонок по их индексу
   * }
   */
  var extra = function extra() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var result = Object.assign({}, selection, {
      rows: rows().length,
      cols: cols().length,
      single: false,
      lastRow: false,
      lastRowEnd: false
    });
    if (selection.start && selection.last) {
      if (selection.start.row === selection.last.row && selection.start.col === selection.last.col) {
        result.single = true;
      }
      if (selection.start.row === links.row.length - 1) {
        result.lastRow = true;
        result.lastRowEnd = true;
      } else if (selection.end.row === links.row.length - 1) {
        result.lastRowEnd = true;
      }
      if (options.merged) {
        result.merged = useUtils.isMerged(selection.start, selection.end);
      }
      if (options.cellsInfo) {
        result.cellsInfo = {
          types: []
        };
        for (var row = selection.start.row; row <= selection.last.row; row++) {
          for (var col = selection.start.col; col <= selection.last.col; col++) {
            var _useRefs$links$cell$r, _cell$cellData;
            var cell = (_useRefs$links$cell$r = useRefs.links.cell[row]) === null || _useRefs$links$cell$r === void 0 ? void 0 : _useRefs$links$cell$r[col];
            var cellType = cell === null || cell === void 0 ? void 0 : (_cell$cellData = cell.cellData) === null || _cell$cellData === void 0 ? void 0 : _cell$cellData.cellType;
            if (cellType && !result.cellsInfo.types.includes(cellType)) {
              result.cellsInfo.types.push(cellType);
            }
          }
        }
      }
      if (options.colsInfo) {
        result.colsInfo = {
          sameType: null,
          data: {}
        };
        for (var _col5 = selection.start.col; _col5 <= selection.last.col; _col5++) {
          var column = useRefs.links.col[_col5];
          result.colsInfo.data[_col5] = column.colData;
          var columnType = column.colData.columnType || 'none';
          if (result.colsInfo.sameType === null) {
            result.colsInfo.sameType = columnType;
          } else if (columnType !== result.colsInfo.sameType) {
            result.colsInfo.sameType = false;
          }
        }
      }
    }
    return result;
  };

  /**
   * Проверяет находится ли позиция в выделении
   * @param {object} pos: позиция
   * @param {number} pos.col: индекс колонки
   * @param {number} pos.row: индекс строки
   * @returns {boolean}
   */
  var inSelection = function inSelection() {
    var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var start = selection.start,
      last = selection.last;
    if (start && last && start.row <= pos.row && pos.row <= last.row && start.col <= pos.col && pos.col <= last.col) {
      return true;
    }
    return false;
  };

  /**
   * Обновляем выделение после изменения набора данных таблицы
   */
  var recalculate = function recalculate() {
    if (selection.start && selection.end) {
      calculateSelection(selection.end, selection.start);
    }
  };
  (0,hooks_module/* useEffect */.d4)(function () {
    recalculate();
  }, [version]);
  return {
    selection: selection,
    selectionCache: selectionCache,
    extra: extra,
    recalculate: recalculate,
    rows: rows,
    cols: cols,
    inSelection: inSelection,
    sessionStart: sessionStart,
    sessionEnd: sessionEnd,
    setCurrent: setCurrent,
    setSelection: setSelection,
    moveSelection: moveSelection,
    shiftSelection: shiftSelection,
    getFilledOrEdgeCell: getFilledOrEdgeCell,
    selectAll: selectAll,
    unselectAll: unselectAll,
    ensureCellVisible: ensureCellVisible
  };
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/hooks/useAction.js







function useAction_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { useAction_typeof = function _typeof(obj) { return typeof obj; }; } else { useAction_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return useAction_typeof(obj); }
/**
 * Выполнение действий или запрос данных из таблицы
 */
function UseAction(_ref) {
  var data = _ref.data,
    editable = _ref.editable,
    setOnAction = _ref.setOnAction,
    tableExec = _ref.tableExec,
    useRefs = _ref.useRefs,
    useSelection = _ref.useSelection,
    useUtils = _ref.useUtils,
    useMenu = _ref.useMenu;
  /**
   * @param { action } exec action
   */
  var onAction = function onAction(action) {
    var result = false;
    if (action.type === 'select-all') {
      useSelection.selectAll();
      result = true;
    } else if (action.type === 'select-range') {
      var _action$start = action.start,
        start = _action$start === void 0 ? {} : _action$start,
        _action$last = action.last,
        last = _action$last === void 0 ? {} : _action$last;
      if (start !== null && start !== void 0 && start.hasOwnProperty('row') && start !== null && start !== void 0 && start.hasOwnProperty('col')) {
        useSelection.setCurrent(start);
      }
      if (last !== null && last !== void 0 && last.hasOwnProperty('row') && last !== null && last !== void 0 && last.hasOwnProperty('col')) {
        useSelection.setSelection(last, {
          force: true
        });
      }
      result = true;
    } else if (action.type === 'unselect-all') {
      useSelection.unselectAll();
      result = true;
    } else if (action.type === 'selection') {
      result = useSelection.extra({
        merged: true
      });
    } else if (action.type === 'add-row-and-move-down') {
      var selection = useSelection.extra();
      if (selection.lastRowEnd) {
        tableExec('add-row');
      }
      useSelection.moveSelection('down');
    } else if (action.type === 'delete' || action.type === 'backspace') {
      if (editable) {
        var _useSelection$selecti = useSelection.selection,
          _start = _useSelection$selecti.start,
          _last = _useSelection$selecti.last;
        if (_start) {
          tableExec('clear-cells', {
            start: _start,
            last: _last
          });
        }
      }
      result = true;
    } else if (action.type === 'is-merged') {
      result = useUtils.isMerged();
    } else if (action.type === 'is-selection-merged') {
      var _useSelection$selecti2 = useSelection.selection,
        _start2 = _useSelection$selecti2.start,
        _last2 = _useSelection$selecti2.last;
      result = useUtils.isMerged(_start2, _last2);
    } else if (action.type === 'get-drop-cell') {
      result = useRefs.getPointer('drop');
    } else if (action.type === 'animate-row-sorting') {
      var _useRefs$links$row$fr, _useRefs$links$row$fr2;
      /**
       * Запуск анимации при сортировке
       */
      var from = action.from,
        to = action.to;
      (_useRefs$links$row$fr = useRefs.links.row[from]) === null || _useRefs$links$row$fr === void 0 ? void 0 : (_useRefs$links$row$fr2 = _useRefs$links$row$fr.moveAnimate) === null || _useRefs$links$row$fr2 === void 0 ? void 0 : _useRefs$links$row$fr2.call(_useRefs$links$row$fr, to);
      result = true;
    } else if (action.type === 'render') {
      /**
       * Позволяет заново отрендерить вложенный компонент (ячейку, строку, колонку, сумму) без рендера всей таблицы
       * @param { string } mode: cells, rows, cols, summary
       * @param { object } start: {row, col}
       * @param { object } last: {row, col}
       * @param { boolean } withSummary?: для mode=cell вызывает обновление summary после обновления ячейки
       * @param { boolean } withAllCells?: для mode=col|row, обновить также вложенные ячейки
       * @param { boolean } withCellsInRange?: для mode=col, обновить вложенные ячейки из диапазона start - last
       */
      var tableData = action.data,
        mode = action.mode,
        _action$start2 = action.start,
        _start3 = _action$start2 === void 0 ? {} : _action$start2,
        _action$last2 = action.last,
        _last3 = _action$last2 === void 0 ? {} : _action$last2,
        _action$withAllCells = action.withAllCells,
        withAllCells = _action$withAllCells === void 0 ? false : _action$withAllCells,
        _action$withSummary = action.withSummary,
        withSummary = _action$withSummary === void 0 ? false : _action$withSummary,
        _action$withCellsInRa = action.withCellsInRange,
        withCellsInRange = _action$withCellsInRa === void 0 ? false : _action$withCellsInRa;
      if (tableData && useAction_typeof(tableData) === 'object') {
        data = tableData;
      }
      if (!_start3.hasOwnProperty('row')) {
        _start3.row = -1;
      }
      if (!_start3.hasOwnProperty('col')) {
        _start3.col = -1;
      }
      if (!_last3.hasOwnProperty('row')) {
        _last3.row = _start3.row;
      }
      if (!_last3.hasOwnProperty('col')) {
        _last3.col = _start3.col;
      }
      if (mode === 'cells') {
        for (var row = _start3.row; row <= _last3.row; row++) {
          for (var col = _start3.col; col <= _last3.col; col++) {
            var _useRefs$links$cell$r, _useRefs$links$cell$r2, _useRefs$links$cell$r3, _useRefs$links$cell$r4;
            (_useRefs$links$cell$r = useRefs.links.cell[row]) === null || _useRefs$links$cell$r === void 0 ? void 0 : (_useRefs$links$cell$r2 = _useRefs$links$cell$r[col]) === null || _useRefs$links$cell$r2 === void 0 ? void 0 : (_useRefs$links$cell$r3 = (_useRefs$links$cell$r4 = _useRefs$links$cell$r2).render) === null || _useRefs$links$cell$r3 === void 0 ? void 0 : _useRefs$links$cell$r3.call(_useRefs$links$cell$r4, {
              withSummary: withSummary
            });
          }
        }
      } else if (mode === 'rows') {
        for (var _row = _start3.row; _row <= _last3.row; _row++) {
          var _useRefs$links$row$_r, _useRefs$links$row$_r2, _useRefs$links$row$_r3;
          (_useRefs$links$row$_r = useRefs.links.row[_row]) === null || _useRefs$links$row$_r === void 0 ? void 0 : (_useRefs$links$row$_r2 = (_useRefs$links$row$_r3 = _useRefs$links$row$_r).render) === null || _useRefs$links$row$_r2 === void 0 ? void 0 : _useRefs$links$row$_r2.call(_useRefs$links$row$_r3);
        }
      } else if (mode === 'cols') {
        for (var _col = _start3.col; _col <= _last3.col; _col++) {
          var _useRefs$links$col$_c, _useRefs$links$col$_c2, _useRefs$links$col$_c3;
          (_useRefs$links$col$_c = useRefs.links.col[_col]) === null || _useRefs$links$col$_c === void 0 ? void 0 : (_useRefs$links$col$_c2 = (_useRefs$links$col$_c3 = _useRefs$links$col$_c).render) === null || _useRefs$links$col$_c2 === void 0 ? void 0 : _useRefs$links$col$_c2.call(_useRefs$links$col$_c3, {
            withSummary: withSummary
          });
          if (withAllCells || withCellsInRange) {
            // Сначала обновляем переданный диапазон ячеек
            for (var _row2 = _start3.row; _row2 <= _last3.row; _row2++) {
              if (_row2 > -1) {
                var _useRefs$links$cell$_, _useRefs$links$cell$_2, _useRefs$links$cell$_3, _useRefs$links$cell$_4;
                (_useRefs$links$cell$_ = useRefs.links.cell[_row2]) === null || _useRefs$links$cell$_ === void 0 ? void 0 : (_useRefs$links$cell$_2 = _useRefs$links$cell$_[_col]) === null || _useRefs$links$cell$_2 === void 0 ? void 0 : (_useRefs$links$cell$_3 = (_useRefs$links$cell$_4 = _useRefs$links$cell$_2).render) === null || _useRefs$links$cell$_3 === void 0 ? void 0 : _useRefs$links$cell$_3.call(_useRefs$links$cell$_4);
              }
            }
          }
          if (withAllCells) {
            // Далее обновляем остальные остальные ячейки колонки
            var toRow = useRefs.links.row.length - 1;
            for (var _row3 = 0; _row3 <= toRow; _row3++) {
              if (_row3 < _start3.row || _row3 > _last3.row) {
                var _useRefs$links$cell$_5, _useRefs$links$cell$_6, _useRefs$links$cell$_7, _useRefs$links$cell$_8;
                (_useRefs$links$cell$_5 = useRefs.links.cell[_row3]) === null || _useRefs$links$cell$_5 === void 0 ? void 0 : (_useRefs$links$cell$_6 = _useRefs$links$cell$_5[_col]) === null || _useRefs$links$cell$_6 === void 0 ? void 0 : (_useRefs$links$cell$_7 = (_useRefs$links$cell$_8 = _useRefs$links$cell$_6).render) === null || _useRefs$links$cell$_7 === void 0 ? void 0 : _useRefs$links$cell$_7.call(_useRefs$links$cell$_8);
              }
            }
          }
        }
      } else if (mode === 'summary') {
        for (var _col2 = _start3.col; _col2 <= _last3.col; _col2++) {
          var _useRefs$links$summar;
          (_useRefs$links$summar = useRefs.links.summary[pos.col]) === null || _useRefs$links$summar === void 0 ? void 0 : _useRefs$links$summar.render();
        }
      }
      result = true;
    } else if (action.type === 'context-menu') {
      useMenu.toggleMenu(action.event, action.mode);
    } else if (action.type === 'get-cell') {
      var _useRefs$links$cell$_9;
      var _action$pos = action.pos,
        _pos = _action$pos === void 0 ? {} : _action$pos;
      result = (_useRefs$links$cell$_9 = useRefs.links.cell[_pos.row]) === null || _useRefs$links$cell$_9 === void 0 ? void 0 : _useRefs$links$cell$_9[_pos.col];
    } else if (action.type === 'get-col') {
      var _action$pos2 = action.pos,
        _pos2 = _action$pos2 === void 0 ? {} : _action$pos2;
      result = useRefs.links.col[_pos2.col];
    } else if (action.type === 'scroll-update') {
      result = useRefs.links.ui.scroll.updateScroll();
    } else if (action.type === 'scroll-to-cell') {
      var ensureCellVisible = useSelection.ensureCellVisible,
        setCurrent = useSelection.setCurrent;
      result = tableExec('scroll-to-cell', {
        ensureCellVisible: ensureCellVisible,
        setCurrent: setCurrent,
        blotId: action.blotId,
        select: action.select || false
      });
    } else if (action.type === 'selection-cache') {
      result = useSelection.selectionCache;
    }
    return result;
  };
  setOnAction(onAction);
  return {
    onAction: onAction
  };
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/hooks/useKeyboard.js










function useKeyboard_slicedToArray(arr, i) { return useKeyboard_arrayWithHoles(arr) || useKeyboard_iterableToArrayLimit(arr, i) || useKeyboard_unsupportedIterableToArray(arr, i) || useKeyboard_nonIterableRest(); }
function useKeyboard_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function useKeyboard_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return useKeyboard_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useKeyboard_arrayLikeToArray(o, minLen); }
function useKeyboard_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function useKeyboard_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function useKeyboard_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


/**
 * Правила обработки клавиатуры
 * @item { array } [
 *   @item 1 { string } хоткей, проверяемый через is-hotkey,
 *   @item 2 { string } имя обработчика для функции handle,
 *   @item 3 { object } ? опции, передаваемые в исполняющую функцию
 * ]
 */
var KEYBOARD = [['arrowup', 'up'], ['arrowdown', 'down'], ['arrowright', 'right'], ['arrowleft', 'left'], ['tab', 'right'], ['shift+tab', 'left'], ['mod+arrowup', 'up', {
  filled: true
}], ['mod+arrowdown', 'down', {
  filled: true
}], ['mod+arrowright', 'right', {
  filled: true
}], ['mod+arrowleft', 'left', {
  filled: true
}], ['shift+arrowup', 'up', {
  selection: true
}], ['shift+arrowdown', 'down', {
  selection: true
}], ['shift+arrowright', 'right', {
  selection: true
}], ['shift+arrowleft', 'left', {
  selection: true
}], ['mod+shift+arrowup', 'up', {
  selection: true,
  end: true
}], ['mod+shift+arrowdown', 'down', {
  selection: true,
  end: true
}], ['mod+shift+arrowright', 'right', {
  selection: true,
  end: true
}], ['mod+shift+arrowleft', 'left', {
  selection: true,
  end: true
}], ['esc', 'unselect'], ['enter', 'edit', {
  isEnter: true
}], ['letter', 'edit'], ['number', 'edit']];

/**
 * Обработка клавиатуры
 */
function UseKeyboard(_ref) {
  var setOnKeyDown = _ref.setOnKeyDown,
    useRefs = _ref.useRefs,
    useSelection = _ref.useSelection,
    data = _ref.data,
    tableExec = _ref.tableExec;
  /**
   * Проверяет событие по правилам обработки клавиатуры
   * @param { event } событие клавиатуры
   * @returns { boolean } handled
   */
  var onKeyDown = function onKeyDown(event) {
    var _event$target;
    var handled = false;
    var modKey = event.ctrlKey || event.metaKey;
    var editing = (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.classList.contains('editable-text');
    if (!editing) {
      for (var key in KEYBOARD) {
        var _KEYBOARD$key = useKeyboard_slicedToArray(KEYBOARD[key], 3),
          hotkey = _KEYBOARD$key[0],
          action = _KEYBOARD$key[1],
          _KEYBOARD$key$ = _KEYBOARD$key[2],
          options = _KEYBOARD$key$ === void 0 ? {} : _KEYBOARD$key$;
        if ((0,lib/* default */.ZP)(hotkey, event) || hotkey === 'letter' && !modKey && event.keyCode >= 65 && event.keyCode <= 105 || hotkey === 'number' && !modKey && (event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode >= 96 && event.keyCode <= 105 || event.keyCode === 189 || event.keyCode === 109 || event.keyCode === 173)) {
          handled = handle(event, action, options);
          break;
        }
      }
    }
    return handled;
  };
  setOnKeyDown(onKeyDown);

  /**
   * Обработчик
   * @param { event } событие клавиатуры
   * @param { string } выполняемое действие
   * @param { object } опции, зависят от действия, см. KEYBOARD
   * @returns { boolean } handled
   */
  var handle = function handle(event, action) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var handled = true;
    switch (action) {
      case 'up':
      case 'down':
      case 'right':
      case 'left':
        handled = useSelection.moveSelection(action, options);
        if (handled) {
          event === null || event === void 0 ? void 0 : event.stopPropagation();
        }
        break;
      case 'unselect':
        handled = useSelection.unselectAll();
        break;
      case 'edit':
        handled = false;
        var _useSelection$selecti = useSelection.selection,
          current = _useSelection$selecti.current,
          mode = _useSelection$selecti.mode;
        if (mode === 'row' && data.props.tempRow) {
          var row = useRefs.links.row[current.row];
          if (row && row.rowData && row.rowData.id === data.props.tempRow) {
            handled = true;
            useSelection.unselectAll();
          }
        }
        if (current && !handled) {
          var _useRefs$links$cell$c, _cell$scrollIntoView;
          var cell = (_useRefs$links$cell$c = useRefs.links.cell[current.row]) === null || _useRefs$links$cell$c === void 0 ? void 0 : _useRefs$links$cell$c[current.col];
          cell === null || cell === void 0 ? void 0 : (_cell$scrollIntoView = cell.scrollIntoView) === null || _cell$scrollIntoView === void 0 ? void 0 : _cell$scrollIntoView.call(cell);
          handled = cell === null || cell === void 0 ? void 0 : cell.editCell(event, options);
        }
        break;
      default:
        handled = false;
    }
    if (handled) {
      event.preventDefault();
    }
    return handled;
  };
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/copyCells.js
function copyCells_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { copyCells_typeof = function _typeof(obj) { return typeof obj; }; } else { copyCells_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return copyCells_typeof(obj); }









function copyCells_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function copyCells_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) copyCells_setPrototypeOf(subClass, superClass); }
function copyCells_setPrototypeOf(o, p) { copyCells_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return copyCells_setPrototypeOf(o, p); }
function copyCells_createSuper(Derived) { var hasNativeReflectConstruct = copyCells_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = copyCells_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = copyCells_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return copyCells_possibleConstructorReturn(this, result); }; }
function copyCells_possibleConstructorReturn(self, call) { if (call && (copyCells_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return copyCells_assertThisInitialized(self); }
function copyCells_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function copyCells_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function copyCells_getPrototypeOf(o) { copyCells_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return copyCells_getPrototypeOf(o); }

var CopyCellsAction = /*#__PURE__*/function (_Action) {
  copyCells_inherits(CopyCellsAction, _Action);
  var _super = copyCells_createSuper(CopyCellsAction);
  function CopyCellsAction(type, params, editor) {
    copyCells_classCallCheck(this, CopyCellsAction);
    type = type || CopyCellsAction.type;
    return _super.call(this, type, params, editor);
  }
  return CopyCellsAction;
}(Action);

CopyCellsAction.type = 'copy-cells';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/convertTableCells.js
function convertTableCells_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { convertTableCells_typeof = function _typeof(obj) { return typeof obj; }; } else { convertTableCells_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return convertTableCells_typeof(obj); }









function convertTableCells_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function convertTableCells_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) convertTableCells_setPrototypeOf(subClass, superClass); }
function convertTableCells_setPrototypeOf(o, p) { convertTableCells_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return convertTableCells_setPrototypeOf(o, p); }
function convertTableCells_createSuper(Derived) { var hasNativeReflectConstruct = convertTableCells_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = convertTableCells_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = convertTableCells_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return convertTableCells_possibleConstructorReturn(this, result); }; }
function convertTableCells_possibleConstructorReturn(self, call) { if (call && (convertTableCells_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return convertTableCells_assertThisInitialized(self); }
function convertTableCells_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function convertTableCells_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function convertTableCells_getPrototypeOf(o) { convertTableCells_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return convertTableCells_getPrototypeOf(o); }

var ConvertTableCellsAction = /*#__PURE__*/function (_Action) {
  convertTableCells_inherits(ConvertTableCellsAction, _Action);
  var _super = convertTableCells_createSuper(ConvertTableCellsAction);
  function ConvertTableCellsAction(type, params, editor) {
    convertTableCells_classCallCheck(this, ConvertTableCellsAction);
    type = type || ConvertTableCellsAction.type;
    return _super.call(this, type, params, editor);
  }
  return ConvertTableCellsAction;
}(Action);

ConvertTableCellsAction.type = 'convert-table-cells';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/convertTableColumn.js
function convertTableColumn_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { convertTableColumn_typeof = function _typeof(obj) { return typeof obj; }; } else { convertTableColumn_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return convertTableColumn_typeof(obj); }









function convertTableColumn_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function convertTableColumn_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) convertTableColumn_setPrototypeOf(subClass, superClass); }
function convertTableColumn_setPrototypeOf(o, p) { convertTableColumn_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return convertTableColumn_setPrototypeOf(o, p); }
function convertTableColumn_createSuper(Derived) { var hasNativeReflectConstruct = convertTableColumn_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = convertTableColumn_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = convertTableColumn_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return convertTableColumn_possibleConstructorReturn(this, result); }; }
function convertTableColumn_possibleConstructorReturn(self, call) { if (call && (convertTableColumn_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return convertTableColumn_assertThisInitialized(self); }
function convertTableColumn_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function convertTableColumn_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function convertTableColumn_getPrototypeOf(o) { convertTableColumn_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return convertTableColumn_getPrototypeOf(o); }

var ConvertTableColumnAction = /*#__PURE__*/function (_Action) {
  convertTableColumn_inherits(ConvertTableColumnAction, _Action);
  var _super = convertTableColumn_createSuper(ConvertTableColumnAction);
  function ConvertTableColumnAction(type, params, editor) {
    convertTableColumn_classCallCheck(this, ConvertTableColumnAction);
    type = type || ConvertTableColumnAction.type;
    return _super.call(this, type, params, editor);
  }
  return ConvertTableColumnAction;
}(Action);

ConvertTableColumnAction.type = 'convert-table-column';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/formatTableColumn.js
function formatTableColumn_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { formatTableColumn_typeof = function _typeof(obj) { return typeof obj; }; } else { formatTableColumn_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return formatTableColumn_typeof(obj); }









function formatTableColumn_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function formatTableColumn_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) formatTableColumn_setPrototypeOf(subClass, superClass); }
function formatTableColumn_setPrototypeOf(o, p) { formatTableColumn_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return formatTableColumn_setPrototypeOf(o, p); }
function formatTableColumn_createSuper(Derived) { var hasNativeReflectConstruct = formatTableColumn_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = formatTableColumn_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = formatTableColumn_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return formatTableColumn_possibleConstructorReturn(this, result); }; }
function formatTableColumn_possibleConstructorReturn(self, call) { if (call && (formatTableColumn_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return formatTableColumn_assertThisInitialized(self); }
function formatTableColumn_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function formatTableColumn_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function formatTableColumn_getPrototypeOf(o) { formatTableColumn_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return formatTableColumn_getPrototypeOf(o); }

var FormatTableColumnAction = /*#__PURE__*/function (_Action) {
  formatTableColumn_inherits(FormatTableColumnAction, _Action);
  var _super = formatTableColumn_createSuper(FormatTableColumnAction);
  function FormatTableColumnAction(type, params, editor) {
    formatTableColumn_classCallCheck(this, FormatTableColumnAction);
    type = type || FormatTableColumnAction.type;
    return _super.call(this, type, params, editor);
  }
  return FormatTableColumnAction;
}(Action);

FormatTableColumnAction.type = 'format-table-column';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/hooks/useMenu.js
function useMenu_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { useMenu_typeof = function _typeof(obj) { return typeof obj; }; } else { useMenu_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return useMenu_typeof(obj); }
function useMenu_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = useMenu_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function useMenu_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function useMenu_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { useMenu_ownKeys(Object(source), true).forEach(function (key) { useMenu_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { useMenu_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function useMenu_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





















function useMenu_slicedToArray(arr, i) { return useMenu_arrayWithHoles(arr) || useMenu_iterableToArrayLimit(arr, i) || useMenu_unsupportedIterableToArray(arr, i) || useMenu_nonIterableRest(); }
function useMenu_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function useMenu_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return useMenu_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useMenu_arrayLikeToArray(o, minLen); }
function useMenu_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function useMenu_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function useMenu_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }











/**
 * Меню таблицы
 */
function UseMenu(_ref) {
  var _this = this;
  var editor = _ref.editor,
    data = _ref.data,
    tableExec = _ref.tableExec,
    onTableAction = _ref.onTableAction,
    useRefs = _ref.useRefs,
    useSelection = _ref.useSelection,
    useFilter = _ref.useFilter;
  var _useState = (0,hooks_module/* useState */.eJ)(null),
    _useState2 = useMenu_slicedToArray(_useState, 2),
    menuState = _useState2[0],
    setMenuState = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)({}),
    _useState4 = useMenu_slicedToArray(_useState3, 2),
    menuProps = _useState4[0],
    setMenuProps = _useState4[1];
  var _useState5 = (0,hooks_module/* useState */.eJ)({}),
    _useState6 = useMenu_slicedToArray(_useState5, 2),
    menuParams = _useState6[0],
    setMenuParams = _useState6[1];

  /**
   * Создает меню
   * @param {event} event: событие клика по кнопке или context menu
   * @param {string} type: тип меню row, col, cell
   * @param {node} anchor: нода
   */
  var toggleMenu = function toggleMenu(event, type) {
    var anchor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : event === null || event === void 0 ? void 0 : event.target;
    if (!menuState) {
      showMenu(event, type, anchor);
    } else {
      if (anchor === menuParams.anchor) {
        closeMenu();
      }
    }
  };

  /**
   * Создает меню
   * @param {event} event: событие клика по кнопке или context menu
   * @param {string} type: тип меню row, col, cell
   * @param {node} anchor: нода
   */
  var showMenu = function showMenu(event, type) {
    var anchor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : event === null || event === void 0 ? void 0 : event.target;
    clearMenu();
    setMenuParams(Object.assign(menuParams, {
      event: event,
      type: type,
      anchor: anchor,
      props: {}
    }));
    setMenuState(true);
  };
  /**
   * Скрывает меню
   */
  var closeMenu = function closeMenu() {
    setMenuState(false);
    clearMenu();
  };
  /**
   * Очищает данные меню
   */
  var clearMenu = function clearMenu() {
    setMenuParams({});
    setMenuProps({});
  };

  /**
   * Смерджить ячейки в выделении
   */
  var onMerge = function onMerge() {
    var _useSelection$selecti = useSelection.selection,
      start = _useSelection$selecti.start,
      last = _useSelection$selecti.last;
    var processed = tableExec('merge-cells', {
      start: start,
      last: last
    });
    if (processed) {
      useSelection.setCurrent(start);
    }
  };

  /**
   * Разделить ячейки в выделении
   */
  var onDivide = function onDivide() {
    var start = useSelection.selection.start;
    tableExec('divide-cells', {
      pos: start
    });
    useSelection.setCurrent(start);
  };

  /**
   * Добавить строки
   * @param {string} dir: направление after / before
   */
  var onAddRows = function onAddRows() {
    var _data$props$filter, _data$props$filter$fi;
    var dir = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'after';
    var selection = useSelection.extra();
    var options = {
      count: (_data$props$filter = data.props.filter) !== null && _data$props$filter !== void 0 && (_data$props$filter$fi = _data$props$filter.filters) !== null && _data$props$filter$fi !== void 0 && _data$props$filter$fi.length ? 1 : selection.rows
    };
    if (dir === 'after') {
      options.after = selection.end.row;
    } else if (dir === 'before') {
      options.before = selection.start.row;
    }
    tableExec('add-row', options);
    if (dir === 'before') {
      useSelection.shiftSelection({
        rows: selection.rows
      });
    }
  };

  /**
   * Удалить строки
   */
  var onDeleteRows = function onDeleteRows() {
    var _useSelection$selecti2 = useSelection.selection,
      start = _useSelection$selecti2.start,
      last = _useSelection$selecti2.last;
    useSelection.unselectAll();
    tableExec('delete-rows', {
      start: start,
      last: last
    });
  };

  /**
   * Добавить колонки
   * @param {string} dir: направление after / before
   */
  var onAddCols = function onAddCols() {
    var dir = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'after';
    var selection = useSelection.extra();
    var options = {
      count: selection.cols
    };
    if (dir === 'after') {
      options.after = selection.end.col;
    } else if (dir === 'before') {
      options.before = selection.start.col;
    }
    tableExec('add-col', options);
    if (dir === 'before') {
      useSelection.shiftSelection({
        cols: selection.cols
      });
    }
  };

  /**
   * Дублировать колонки
   */
  var onDuplicateCols = function onDuplicateCols() {
    var selection = useSelection.extra();
    var options = {
      start: {
        col: selection.start.col
      },
      count: selection.cols
    };
    tableExec('duplicate-column', options);
  };

  /**
   * Удалить колонки
   */
  var onDeleteCols = function onDeleteCols() {
    var _useSelection$selecti3 = useSelection.selection,
      start = _useSelection$selecti3.start,
      last = _useSelection$selecti3.last;
    useSelection.unselectAll();
    tableExec('delete-cols', {
      start: start,
      last: last
    });
  };
  var onClear = function onClear() {
    var _useSelection$selecti4 = useSelection.selection,
      start = _useSelection$selecti4.start,
      last = _useSelection$selecti4.last;
    tableExec('clear-cells', {
      start: start,
      last: last
    });
  };

  /**
   * Сортировка колонки
   * @param {string | boolean} order: тип сортировки asc, desc, false
   */
  var onColumnSort = function onColumnSort() {
    var order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var start = useSelection.selection.start;
    tableExec(order ? 'sort-table-column' : 'exit-sort-table-column', {
      pos: start,
      order: order
    });
  };
  var onComment = function onComment(pos) {
    tableExec('comment-cell', {
      pos: pos
    });
  };

  /**
   * Фильтрация колонки
   */
  var onFilter = function onFilter() {
    var start = useSelection.selection.start;
    if (tableExec('open-filter', {
      col: start.col
    })) {
      useFilter.toggleFilter(start.col, {
        anchorCol: start.col
      });
    }
  };

  /**
   * Установка свойств для ячеек, строк, колонок
   * @param {string} type: тип элемента - cell, row, col
   * @param {string} key: имя свойства
   * @param {any} val: значение
   */
  var onSetProp = function onSetProp() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cell';
    var key = arguments.length > 1 ? arguments[1] : undefined;
    var val = arguments.length > 2 ? arguments[2] : undefined;
    var _useSelection$selecti5 = useSelection.selection,
      start = _useSelection$selecti5.start,
      last = _useSelection$selecti5.last;
    tableExec('set-prop', {
      start: start,
      last: last,
      type: type,
      key: key,
      val: val
    });
  };

  /**
   * Переименование колонки
   */
  var renameCol = function renameCol() {
    var _useRefs$links$col$st;
    var start = useSelection.selection.start;
    (_useRefs$links$col$st = useRefs.links.col[start.col]) === null || _useRefs$links$col$st === void 0 ? void 0 : _useRefs$links$col$st.rename();
  };

  /**
   * Копирование ячеек
   */
  var onCopyCells = function onCopyCells() {
    var _useSelection$selecti6 = useSelection.selection,
      start = _useSelection$selecti6.start,
      last = _useSelection$selecti6.last;
    onTableAction(new CopyCellsAction(CopyCellsAction.type, {
      start: start,
      last: last
    }, editor));
  };

  /**
   * Смена типа ячеек или колонок
   * @param {string} mode: режим изменения типа, col или cell
   * @param {string} type: новый тип ячеек / колонок
   */
  var onChangeType = function onChangeType(mode, type) {
    var _useSelection$selecti7 = useSelection.selection,
      start = _useSelection$selecti7.start,
      last = _useSelection$selecti7.last;
    if (!start || !last) return;
    if (mode === 'cell') {
      onTableAction(new ConvertTableCellsAction(ConvertTableCellsAction.type, {
        start: start,
        last: last,
        type: type
      }, editor));
    } else if (mode === 'col') {
      onTableAction(new ConvertTableColumnAction(ConvertTableColumnAction.type, {
        start: start,
        last: last,
        type: type
      }, editor));
    }
  };
  var onChangeTypeFormat = function onChangeTypeFormat(mode, type, prop, value) {
    var _useSelection$selecti8 = useSelection.selection,
      start = _useSelection$selecti8.start,
      last = _useSelection$selecti8.last;
    setMenuProps(useMenu_objectSpread(useMenu_objectSpread({}, menuProps), useMenu_defineProperty({}, prop, value)));
    if (mode === 'cell') {
      onTableAction(new FormatTableCellsAction(FormatTableCellsAction.type, {
        start: start,
        last: last,
        type: type,
        prop: prop,
        value: value
      }, editor));
    } else if (mode === 'col') {
      onTableAction(new FormatTableColumnAction(FormatTableColumnAction.type, {
        start: start,
        last: last,
        type: type,
        prop: prop,
        value: value
      }, editor));
    }
  };

  /**
   * Возвращает текущее значение свойства в выделении, если оно одинаково для всех элементов либо false
   * @param {string} type: тип элемента - cell, row, col
   * @param {string} key: имя свойства
   * @return {any} значение
   */
  var getCurrentProp = function getCurrentProp() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cell';
    var key = arguments.length > 1 ? arguments[1] : undefined;
    var _useSelection$selecti9 = useSelection.selection,
      start = _useSelection$selecti9.start,
      last = _useSelection$selecti9.last;
    var val = null;
    if (type === 'row') {
      if (start && last) {
        for (var row = start.row; row <= last.row; row++) {
          var _data$rowsData$row;
          if (!((_data$rowsData$row = data.rowsData[row]) !== null && _data$rowsData$row !== void 0 && _data$rowsData$row.hasOwnProperty(key)) || val !== null && val !== data.rowsData[row][key]) {
            val = false;
            break;
          } else {
            val = data.rowsData[row][key];
          }
        }
      }
    }
    return val;
  };

  /**
   * Возвращает значение свойства, если оно одинаковое для всех выделенных колонок
   * Если значение отличается в колонках возвращает `diff`
   * Если значение не установлено возвращает `null`
   * @param {string} prop: свойство
   * @returns { value | null }
   */
  var getColumnsProp = function getColumnsProp(prop) {
    var _useSelection$selecti10 = useSelection.selection,
      start = _useSelection$selecti10.start,
      last = _useSelection$selecti10.last;
    var values = [];
    if (start && last) {
      for (var col = start.col; col <= last.col; col++) {
        var _useRefs$links$col$co;
        var _data = (_useRefs$links$col$co = useRefs.links.col[col]) === null || _useRefs$links$col$co === void 0 ? void 0 : _useRefs$links$col$co.colData;
        var value = _data !== null && _data !== void 0 && _data.hasOwnProperty(prop) ? _data[prop] : null;
        if (!values.includes(value)) {
          values.push(value);
          if (values.length > 1) {
            break;
          }
        }
      }
    }
    if (!values.length) {
      return null;
    } else if (values.length === 1) {
      return values[0];
    } else {
      return 'diff';
    }
  };

  /**
   * Возвращает значение свойства, если оно одинаковое для всех выделенных ячеек
   * Если значение отличается в колонках возвращает `diff`
   * Если значение не установлено возвращает `null`
   * @param {string} prop: свойство
   * @returns { value | null }
   */
  var getCellsProp = function getCellsProp(prop) {
    var _useSelection$selecti11 = useSelection.selection,
      start = _useSelection$selecti11.start,
      last = _useSelection$selecti11.last;
    var values = [];
    if (start && last) {
      for (var row = start.row; row <= last.row; row++) {
        for (var col = start.col; col <= last.col; col++) {
          var _useRefs$links$cell$r, _useRefs$links$cell$r2;
          var _data2 = (_useRefs$links$cell$r = useRefs.links.cell[row]) === null || _useRefs$links$cell$r === void 0 ? void 0 : (_useRefs$links$cell$r2 = _useRefs$links$cell$r[col]) === null || _useRefs$links$cell$r2 === void 0 ? void 0 : _useRefs$links$cell$r2.cellData;
          var value = _data2 !== null && _data2 !== void 0 && _data2.hasOwnProperty(prop) ? _data2[prop] : null;
          if (!values.includes(value)) {
            values.push(value);
            if (values.length > 1) {
              break;
            }
          }
        }
        if (values.length > 1) {
          break;
        }
      }
    }
    if (!values.length) {
      return null;
    } else if (values.length === 1) {
      return values[0];
    } else {
      return 'diff';
    }
  };

  /**
   * Возвращает общие значения формата для выделенных колонок
   * @param { object } defaultFormat: формат по умолчанию
   * @returns { object }
   */
  var getColumnsFormat = function getColumnsFormat(defaultFormat) {
    var _useSelection$selecti12 = useSelection.selection,
      start = _useSelection$selecti12.start,
      last = _useSelection$selecti12.last;
    var commonFormat = false;
    if (start && last) {
      for (var col = start.col; col <= last.col; col++) {
        var _useRefs$links$col$co2, _useRefs$links$col$co3;
        var dataFormat = Object.assign({}, defaultFormat, ((_useRefs$links$col$co2 = useRefs.links.col[col]) === null || _useRefs$links$col$co2 === void 0 ? void 0 : (_useRefs$links$col$co3 = _useRefs$links$col$co2.colData) === null || _useRefs$links$col$co3 === void 0 ? void 0 : _useRefs$links$col$co3.format) || {});
        if (!commonFormat) {
          commonFormat = dataFormat;
        } else {
          for (var key in commonFormat) {
            if (dataFormat[key] !== commonFormat[key]) {
              commonFormat[key] = null;
            }
          }
        }
      }
    }
    return commonFormat;
  };

  /**
   * Возвращает общие значения формата для выделенных ячеек
   * @param { object } defaultFormat: формат по умолчанию
   * @returns { object }
   */
  var getCellsFormat = function getCellsFormat(defaultFormat) {
    var _useSelection$selecti13 = useSelection.selection,
      start = _useSelection$selecti13.start,
      last = _useSelection$selecti13.last;
    var commonFormat = false;
    if (start && last) {
      for (var row = start.row; row <= last.row; row++) {
        for (var col = start.col; col <= last.col; col++) {
          var _useRefs$links$cell$r3, _useRefs$links$cell$r4, _useRefs$links$cell$r5;
          var dataFormat = Object.assign({}, defaultFormat, ((_useRefs$links$cell$r3 = useRefs.links.cell[row]) === null || _useRefs$links$cell$r3 === void 0 ? void 0 : (_useRefs$links$cell$r4 = _useRefs$links$cell$r3[col]) === null || _useRefs$links$cell$r4 === void 0 ? void 0 : (_useRefs$links$cell$r5 = _useRefs$links$cell$r4.cellData) === null || _useRefs$links$cell$r5 === void 0 ? void 0 : _useRefs$links$cell$r5.format) || {});
          if (!commonFormat) {
            commonFormat = dataFormat;
          } else {
            for (var key in commonFormat) {
              if (dataFormat[key] !== commonFormat[key]) {
                commonFormat[key] = null;
              }
            }
          }
        }
      }
    }
    return commonFormat;
  };

  /**
   * Функция заглушка
   * Передаем в некоторые пункты меню для избежания ошибок и удобства отладки
   * @param  {...any} args
   */
  var stub = function stub() {};

  /**
   * Возвращает компонент меню или null
   * @return {object} component | null
   */
  var getMenu = function getMenu() {
    var menu = null;
    if (menuState) {
      var _selection$cellsInfo, _data$props$filter2, _data$props$filter2$f, _data$props$filter3, _data$props$filter3$f, _selection$merged;
      var selection = useSelection.extra({
        merged: true,
        cellsInfo: true,
        colsInfo: true
      });
      var types = ((_selection$cellsInfo = selection.cellsInfo) === null || _selection$cellsInfo === void 0 ? void 0 : _selection$cellsInfo.types) || [];
      var allowAlign = includesOnly(types, ['text', 'number', 'currency']);
      var allowTextStyle = includesOnly(types, ['text']);
      if (!selection.start) {
        console.warn('Call getMenu without selection', selection);
        return null;
      }
      var menuItems = {};
      var allItems = {
        'menu-header': allowAlign ? {
          onAction: onSetProp.bind(_this, menuParams.type)
        } : false,
        'add-row-before': !data.props.hasOwnProperty('sortableColumn') ? {
          text: 'table.row_menu.add_row_before',
          plural: (_data$props$filter2 = data.props.filter) !== null && _data$props$filter2 !== void 0 && (_data$props$filter2$f = _data$props$filter2.filters) !== null && _data$props$filter2$f !== void 0 && _data$props$filter2$f.length ? 1 : selection.rows,
          onAction: onAddRows.bind(_this, 'before')
        } : false,
        'add-row-after': !data.props.hasOwnProperty('sortableColumn') ? {
          text: 'table.row_menu.add_row_after',
          plural: (_data$props$filter3 = data.props.filter) !== null && _data$props$filter3 !== void 0 && (_data$props$filter3$f = _data$props$filter3.filters) !== null && _data$props$filter3$f !== void 0 && _data$props$filter3$f.length ? 1 : selection.rows,
          onAction: onAddRows.bind(_this, 'after')
        } : false,
        'delete-rows': {
          text: 'table.menu.delete_row',
          plural: selection.rows,
          onAction: onDeleteRows.bind(_this)
        },
        'add-col-before': {
          text: 'table.col_menu.add_column_before',
          plural: selection.cols,
          onAction: onAddCols.bind(_this, 'before')
        },
        'add-col-after': {
          text: 'table.col_menu.add_column_after',
          plural: selection.cols,
          onAction: onAddCols.bind(_this, 'after')
        },
        'duplicate-cols': {
          text: 'table.col_menu.duplicate_column',
          plural: selection.cols,
          onAction: onDuplicateCols.bind(_this)
        },
        'delete-cols': {
          text: 'table.menu.delete_column',
          plural: selection.cols,
          onAction: onDeleteCols.bind(_this)
        },
        'rename': selection.cols === 1 ? {
          text: 'table.col_menu.rename',
          onAction: renameCol.bind(_this)
        } : false,
        'merge': !selection.single && selection.colsInfo.sameType !== false ? {
          text: 'table.menu.merge_cells',
          onAction: onMerge.bind(_this)
        } : false,
        'divide': selection.single && (_selection$merged = selection.merged) !== null && _selection$merged !== void 0 && _selection$merged.cells ? {
          text: 'table.menu.divide_cells',
          onAction: onDivide.bind(_this)
        } : false,
        'background': {
          text: 'table.menu.background_color',
          value: getCurrentProp(menuParams.type, 'color'),
          onAction: onSetProp.bind(_this, menuParams.type, 'color')
        },
        'formatting': allowAlign ? {
          allowTextStyle: allowTextStyle,
          type: menuParams.type,
          selection: selection,
          useRefs: useRefs,
          text: 'table.menu.formatting',
          onAction: onSetProp.bind(_this, menuParams.type)
        } : false,
        'copy': {
          text: 'table.menu.copy_cell',
          plural: selection.single ? 1 : 2,
          onAction: onCopyCells.bind(_this)
        },
        'clear': {
          text: 'table.menu.clear',
          onAction: onClear.bind(_this, menuParams.type)
        }
      };
      if (menuParams.type === 'cell' || menuParams.type === 'col') {
        var columnType = getColumnsProp('columnType') || 'none';
        var commonType,
          cellsType,
          current,
          disabled = false,
          sameAsCol = false;
        if (menuParams.type === 'col') {
          current = columnType;
          commonType = columnType;
        } else {
          cellsType = getCellsProp('cellType') || 'text';
          commonType = columnType !== 'none' ? columnType : cellsType;
          if (columnType === 'none') {
            current = cellsType;
          } else {
            disabled = true;
            sameAsCol = true;
          }
        }

        // Выбор типа
        if (true) {
          var submenu = {};
          if (sameAsCol) {
            submenu['same'] = {
              text: 'table.menu.type.same_as_column',
              wide: true,
              selected: true,
              onAction: stub
            };
          }
          eachType(function (type, data) {
            if (menuParams.type === 'col' || type !== 'none') {
              submenu["set-type-".concat(type)] = {
                text: 'table.menu.type.' + type,
                textIcon: data.icon,
                wide: true,
                disabled: disabled,
                selected: type === current,
                onAction: onChangeType.bind(_this, menuParams.type, type)
              };
            }
          });
          allItems['change-type'] = {
            text: 'table.menu.type.type_' + menuParams.type,
            plural: selection.cols === 1 && (selection.rows === 1 || menuParams.type === 'col') ? 1 : 2,
            submenu: submenu
          };
        }
        var typeData = getTypeData(commonType);
        if (typeData.submenu && typeData.format) {
          var format = menuParams.type === 'col' ? getColumnsFormat(typeData.format) : getCellsFormat(typeData.format);
          for (var key in format) {
            if (menuProps.hasOwnProperty(key)) {
              format[key] = menuProps[key];
            }
          }
          var _submenu = {};
          for (var i in typeData.submenu) {
            var item = typeData.submenu[i];
            var commonProps = {
              text: item.i18n || false,
              hint: item.hint || false
            };
            if (typeof item.condition === 'function') {
              if (!item.condition(format)) {
                continue;
              }
            }
            if (item.keepMenu) {
              commonProps.keepMenu = item.keepMenu;
            }
            if (item.type === 'header') {
              _submenu[item.type + i] = useMenu_objectSpread({
                header: true
              }, commonProps);
            }
            if (item.type === 'radio') {
              var _iterator = useMenu_createForOfIteratorHelper(item.values),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var value = _step.value;
                  var onAction = onChangeTypeFormat.bind(_this, menuParams.type, commonType, item.prop, value);
                  var selected = value === format[item.prop];
                  var props = {};
                  if (item.textIcon) {
                    if (typeof item.textIcon === 'function') {
                      props.textIcon = item.textIcon(value, selected);
                    }
                  }
                  if (item.selectedIcon) {
                    props.selected = selected;
                  }
                  if (item.iconPosition) {
                    props.iconPosition = item.iconPosition;
                  }
                  if (item.hasOwnProperty('rightText')) {
                    if (typeof item.rightText === 'function') {
                      props.rightText = item.rightText(value, selected);
                    } else {
                      props.rightText = item.rightText;
                    }
                    props.wide = true;
                  }
                  if (item.hasOwnProperty('rightInput')) {
                    props.rightInput = item.rightInput(value, selected);
                    if (useMenu_typeof(props.rightInput) === 'object') {
                      props.rightInput.value = format[props.rightInput.prop];
                      props.rightInput.onClick = onAction;
                      props.rightInput.onAction = onChangeTypeFormat.bind(_this, menuParams.type, commonType, props.rightInput.prop);
                    }
                  }
                  _submenu["".concat(item.prop, "_").concat(value)] = useMenu_objectSpread(useMenu_objectSpread(useMenu_objectSpread({}, props), commonProps), {}, {
                    onAction: onAction,
                    text: item.i18n.replace('${value}', value)
                  });
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            }
            if (item.type === 'checkbox') {
              var _selected = format[item.prop] ? true : false;
              var _props = {};
              if (item.selectedIcon) {
                _props.selected = _selected;
              }
              _submenu[item.prop] = useMenu_objectSpread(useMenu_objectSpread(useMenu_objectSpread({}, _props), commonProps), {}, {
                clickOnSelected: true,
                onAction: onChangeTypeFormat.bind(_this, menuParams.type, commonType, item.prop, !_selected)
              });
            } else if (item.type === 'number') {
              _submenu[item.prop] = useMenu_objectSpread(useMenu_objectSpread(useMenu_objectSpread({}, item), commonProps), {}, {
                placeholder: '?',
                value: format[item.prop],
                onAction: onChangeTypeFormat.bind(_this, menuParams.type, commonType, item.prop)
              });
            }
          }
          allItems['type-menu'] = {
            text: "table.menu.".concat(commonType, "_format.name"),
            submenu: _submenu
          };
          if (typeData.hasOwnProperty('className')) {
            allItems['type-menu'].className = typeData.className;
          }
        }
      }
      if (menuParams.type === 'row') {
        var allowed = ['add-row-before', 'add-row-after', 'merge', 'background', 'formatting', 'delete-rows'];
        for (var _i2 = 0, _allowed = allowed; _i2 < _allowed.length; _i2++) {
          var _key = _allowed[_i2];
          if (allItems[_key]) {
            menuItems[_key] = allItems[_key];
          }
        }
      } else if (menuParams.type === 'col') {
        if (selection.cols === 1) {
          var _useRefs$links$col$se;
          var sortby = ((_useRefs$links$col$se = useRefs.links.col[selection.start.col]) === null || _useRefs$links$col$se === void 0 ? void 0 : _useRefs$links$col$se.colData.sortby) || false;
          allItems['sorting'] = {
            text: 'table.sorting.name',
            submenu: {
              'asc': {
                text: 'table.sorting.asc.common',
                selected: sortby === 'asc',
                onAction: onColumnSort.bind(_this, 'asc')
              },
              'desc': {
                text: 'table.sorting.desc.common',
                selected: sortby === 'desc',
                onAction: onColumnSort.bind(_this, 'desc')
              },
              'disable': sortby ? {
                text: 'table.sorting.disable',
                selected: false,
                onAction: onColumnSort.bind(_this, false)
              } : false
            }
          };
          allItems['filter'] = {
            text: 'table.filter.by_field',
            onAction: onFilter.bind(_this)
          };
        }
        var _allowed2 = ['change-type', 'type-menu', 'add-col-before', 'add-col-after', 'duplicate-cols', 'sorting', 'filter', 'rename', 'merge', 'background', 'formatting', 'delete-cols', 'clear'];
        for (var _i3 = 0, _allowed3 = _allowed2; _i3 < _allowed3.length; _i3++) {
          var _key2 = _allowed3[_i3];
          if (allItems[_key2]) {
            menuItems[_key2] = allItems[_key2];
          }
        }
      } else if (menuParams.type === 'cell') {
        allItems['group-add'] = {
          text: 'table.menu.add',
          submenu: {
            'add-row-before': allItems['add-row-before'],
            'add-row-after': allItems['add-row-after'],
            'separator': allItems['add-row-after'] !== false || allItems['add-row-before'] !== false,
            'add-col-before': allItems['add-col-before'],
            'add-col-after': allItems['add-col-after']
          }
        };
        allItems['group-delete'] = {
          text: 'table.menu.delete',
          submenu: {
            'delete-rows': allItems['delete-rows'],
            'delete-cols': allItems['delete-cols']
          }
        };
        if (editor.plugins.commentManager && editor.plugins.commentManager.options.enabled && editor.plugins.commentManager.options.tableCellComments && selection.single) {
          allItems['comment'] = {
            text: 'table.menu.comment',
            onAction: onComment.bind(_this, selection.current)
          };
        }
        var _allowed4 = ['menu-header', 'comment', 'change-type', 'type-menu', 'group-add', 'group-delete', 'merge', 'divide', 'background', 'formatting', 'copy', 'clear'];
        for (var _i4 = 0, _allowed5 = _allowed4; _i4 < _allowed5.length; _i4++) {
          var _key3 = _allowed5[_i4];
          if (allItems[_key3]) {
            menuItems[_key3] = allItems[_key3];
          }
        }
      }
      menu = (0,preact_module.h)(TableMenuComponent, {
        editor: editor,
        menuItems: menuItems,
        anchorNode: menuParams.anchor,
        anchorOptions: {
          placement: 'right-start',
          priority: ['top', 'bottom', 'right', 'left'],
          positionFixed: true
        },
        wantsToClose: closeMenu.bind(_this)
      });
    }
    return menu;
  };
  return {
    getMenu: getMenu,
    showMenu: showMenu,
    closeMenu: closeMenu,
    toggleMenu: toggleMenu
  };
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/hooks/useUtils.js


/**
 * Утилиты
 */
function UseUtils(_ref) {
  var useRefs = _ref.useRefs;
  var links = useRefs.links;
  /**
   * Рассчет координат для расширения ячейки
   * @param {object} pos: {row, cols} позиция ячейки
   */
  var expandCoords = function expandCoords() {
    var _links$cell$pos$row, _links$cell$pos$row$p, _links$cell$pos$row$p2;
    var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var limit = {
      col: Math.min(3, links.col.length),
      row: Math.min(3, links.row.length)
    };
    var left = 0,
      right = 0,
      top = 0,
      bottom = 0;
    var tableMaxRow = links.row.length - 1;
    var tableMaxCol = links.col.length - 1;
    var cellRect = ((_links$cell$pos$row = links.cell[pos.row]) === null || _links$cell$pos$row === void 0 ? void 0 : (_links$cell$pos$row$p = _links$cell$pos$row[pos.col]) === null || _links$cell$pos$row$p === void 0 ? void 0 : (_links$cell$pos$row$p2 = _links$cell$pos$row$p.getNode()) === null || _links$cell$pos$row$p2 === void 0 ? void 0 : _links$cell$pos$row$p2.getBoundingClientRect()) || {
      width: CONFIG.col.props.width,
      height: CONFIG.col.props.height
    };
    var coords = {
      col: [{
        left: left,
        right: right,
        index: 0,
        width: cellRect.width
      }],
      row: [{
        top: top,
        bottom: bottom,
        index: 0,
        height: cellRect.height
      }],
      limit: limit
    };
    var minCol = pos.col;
    var maxCol = pos.col + limit.col - 1;
    if (maxCol > tableMaxCol) {
      minCol = Math.max(0, pos.col - (maxCol - tableMaxCol));
      maxCol = tableMaxCol;
    }
    var index = 0;
    for (var col = pos.col + 1; col <= maxCol; col++) {
      var _links$col$col, _links$col$col$getNod, _links$col$col$getNod2;
      var width = ((_links$col$col = links.col[col]) === null || _links$col$col === void 0 ? void 0 : (_links$col$col$getNod = _links$col$col.getNode()) === null || _links$col$col$getNod === void 0 ? void 0 : (_links$col$col$getNod2 = _links$col$col$getNod.getBoundingClientRect()) === null || _links$col$col$getNod2 === void 0 ? void 0 : _links$col$col$getNod2.width) || CONFIG.col.props.width;
      var last = coords.col.length - 1;
      right -= width;
      coords.col.push({
        left: coords.col[last].left,
        right: right,
        width: coords.col[last].width + width,
        index: ++index
      });
    }
    index = 0;
    for (var _col = pos.col - 1; _col >= minCol; _col--) {
      var _links$col$_col, _links$col$_col$getNo, _links$col$_col$getNo2;
      var _width = ((_links$col$_col = links.col[_col]) === null || _links$col$_col === void 0 ? void 0 : (_links$col$_col$getNo = _links$col$_col.getNode()) === null || _links$col$_col$getNo === void 0 ? void 0 : (_links$col$_col$getNo2 = _links$col$_col$getNo.getBoundingClientRect()) === null || _links$col$_col$getNo2 === void 0 ? void 0 : _links$col$_col$getNo2.width) || CONFIG.col.props.width;
      var _last = coords.col.length - 1;
      left -= _width;
      coords.col.push({
        left: left,
        right: coords.col[_last].right,
        width: coords.col[_last].width + _width,
        index: --index
      });
    }
    var minRow = pos.row;
    var maxRow = pos.row + limit.row - 1;
    if (maxRow > tableMaxRow) {
      minRow = Math.max(0, pos.row - (maxRow - tableMaxRow));
      maxRow = tableMaxRow;
    }
    index = 0;
    for (var row = pos.row + 1; row <= maxRow; row++) {
      var _links$row$row, _links$row$row$getNod;
      var height = ((_links$row$row = links.row[row]) === null || _links$row$row === void 0 ? void 0 : (_links$row$row$getNod = _links$row$row.getNode()) === null || _links$row$row$getNod === void 0 ? void 0 : _links$row$row$getNod.getBoundingClientRect().height) || CONFIG.row.props.height;
      var _last2 = coords.row.length - 1;
      bottom -= height;
      coords.row.push({
        top: coords.row[_last2].top,
        bottom: bottom,
        height: coords.row[_last2].height + height,
        index: ++index
      });
    }
    index = 0;
    for (var _row = pos.row - 1; _row >= minRow; _row--) {
      var _links$row$_row, _links$row$_row$getNo;
      var _height = ((_links$row$_row = links.row[_row]) === null || _links$row$_row === void 0 ? void 0 : (_links$row$_row$getNo = _links$row$_row.getNode()) === null || _links$row$_row$getNo === void 0 ? void 0 : _links$row$_row$getNo.getBoundingClientRect().height) || CONFIG.row.props.height;
      var _last3 = coords.row.length - 1;
      top -= _height;
      coords.row.push({
        top: top,
        bottom: coords.row[_last3].bottom,
        height: coords.row[_last3].height + _height,
        index: --index
      });
    }
    return coords;
  };

  /**
   * Возвращает информацию о мердже в диапазоне ячеек
   * Если диапазон не задан то проверяет всю таблицу
   * @param {object} start: {row, col}
   * @param {object} end: {row, col}
   * @return {object} {
   *    {boolean} cells - наличие мердженных ячеек
   *    {boolean} rows - наличие мердженных по строкам ячеек
   *    {boolean} cols - наличие мердженных по колонкам ячеек
   * }
   */
  var isMerged = function isMerged() {
    var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      row: 0,
      col: 0
    };
    var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      row: links.row.length - 1,
      col: links.col.length - 1
    };
    var merged = {
      cells: false,
      rows: false,
      cols: false
    };
    if (start && end) {
      for (var row = start.row; row <= end.row; row++) {
        for (var col = start.col; col <= end.col; col++) {
          var _links$cell$row, _links$cell$row$col;
          if ((_links$cell$row = links.cell[row]) !== null && _links$cell$row !== void 0 && (_links$cell$row$col = _links$cell$row[col]) !== null && _links$cell$row$col !== void 0 && _links$cell$row$col.cellProps) {
            var _links$cell$row$col$c = links.cell[row][col].cellProps,
              _links$cell$row$col$c2 = _links$cell$row$col$c.rowspan,
              rowspan = _links$cell$row$col$c2 === void 0 ? 1 : _links$cell$row$col$c2,
              _links$cell$row$col$c3 = _links$cell$row$col$c.colspan,
              colspan = _links$cell$row$col$c3 === void 0 ? 1 : _links$cell$row$col$c3;
            if (rowspan > 1) {
              merged.cells = true;
              merged.rows = true;
            }
            if (colspan > 1) {
              merged.cells = true;
              merged.cols = true;
            }
          }
          if (merged.rows && merged.cols) {
            break;
          }
        }
      }
    }
    return merged;
  };
  return {
    expandCoords: expandCoords,
    isMerged: isMerged
  };
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/select.js
function select_slicedToArray(arr, i) { return select_arrayWithHoles(arr) || select_iterableToArrayLimit(arr, i) || select_unsupportedIterableToArray(arr, i) || select_nonIterableRest(); }
function select_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function select_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return select_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return select_arrayLikeToArray(o, minLen); }
function select_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function select_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function select_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


























var select_isEnterKey = (0,lib/* default */.ZP)('Enter');
var select_isBackspaceKey = (0,lib/* default */.ZP)('Backspace');
var ListItemsComponent = function ListItemsComponent(props) {
  var ListComponent = props.ListComponent,
    filteredOptionsList = props.filteredOptionsList,
    selectedValue = props.selectedValue,
    OptionComponent = props.OptionComponent,
    onOptionClick = props.onOptionClick,
    onOptionUnselect = props.onOptionUnselect,
    multiselect = props.multiselect,
    onSelectedItemsRef = props.onSelectedItemsRef;
  if (ListComponent) {
    return (0,preact_module.h)("div", {
      className: "custom-select-list"
    }, (0,preact_module.h)(ListComponent, {
      options: filteredOptionsList,
      selectedValue: selectedValue,
      OptionComponent: OptionComponent,
      onSelect: onOptionClick,
      onUnselect: onOptionUnselect,
      onSelectedItemsRef: onSelectedItemsRef
    }));
  } else {
    return (0,preact_module.h)("div", {
      className: "custom-select-list"
    }, filteredOptionsList.length ? filteredOptionsList.map(function (option) {
      var optionClassNames = ['option-item'];
      var isSelected = false;
      if (multiselect && Array.isArray(selectedValue)) {
        if (selectedValue.find(function (val) {
          return deep_equal_default()(val, option);
        })) {
          isSelected = true;
        }
      } else {
        if (deep_equal_default()(option, selectedValue)) {
          isSelected = true;
        }
      }
      if (isSelected) {
        optionClassNames.push('selected');
      }
      return (0,preact_module.h)("span", {
        className: optionClassNames.join(' '),
        onClick: onOptionClick.bind(undefined, option)
      }, OptionComponent ? (0,preact_module.h)(OptionComponent, {
        option: option,
        selected: isSelected
      }) : option.text);
    }) : (0,preact_module.h)("span", {
      style: {
        textAlign: 'center'
      }
    }, "No result"));
  }
};
function Select(props) {
  var _props$options = props.options,
    options = _props$options === void 0 ? [] : _props$options,
    _props$selected = props.selected,
    selected = _props$selected === void 0 ? false : _props$selected,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? function () {} : _props$onChange,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? 'Select item' : _props$placeholder,
    _props$addClassName = props.addClassName,
    addClassName = _props$addClassName === void 0 ? '' : _props$addClassName,
    search = props.search,
    multiselect = props.multiselect,
    _props$hideSelected = props.hideSelected,
    hideSelected = _props$hideSelected === void 0 ? false : _props$hideSelected,
    _props$dontCloseOnSel = props.dontCloseOnSelect,
    dontCloseOnSelect = _props$dontCloseOnSel === void 0 ? false : _props$dontCloseOnSel,
    _props$optionComponen = props.optionComponent,
    OptionComponent = _props$optionComponen === void 0 ? null : _props$optionComponen,
    _props$selectedItemCo = props.selectedItemComponent,
    SelectedItemComponent = _props$selectedItemCo === void 0 ? null : _props$selectedItemCo,
    _props$selectedCompon = props.selectedComponent,
    SelectedComponent = _props$selectedCompon === void 0 ? null : _props$selectedCompon,
    _props$listComponent = props.listComponent,
    ListComponent = _props$listComponent === void 0 ? null : _props$listComponent;
  var selectRef = (0,hooks_module/* useRef */.sO)(null);
  var inputRef = (0,hooks_module/* useRef */.sO)(null);
  var _useState = (0,hooks_module/* useState */.eJ)(null),
    _useState2 = select_slicedToArray(_useState, 2),
    selectedItemsRef = _useState2[0],
    setSelectedItemsRef = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(false),
    _useState4 = select_slicedToArray(_useState3, 2),
    isDisabled = _useState4[0],
    setDisabled = _useState4[1];
  var _useState5 = (0,hooks_module/* useState */.eJ)(false),
    _useState6 = select_slicedToArray(_useState5, 2),
    open = _useState6[0],
    setOpen = _useState6[1];
  var _useState7 = (0,hooks_module/* useState */.eJ)(multiselect ? [] : {}),
    _useState8 = select_slicedToArray(_useState7, 2),
    selectedValue = _useState8[0],
    setSelectedValueState = _useState8[1];
  var _useState9 = (0,hooks_module/* useState */.eJ)(''),
    _useState10 = select_slicedToArray(_useState9, 2),
    searchValue = _useState10[0],
    setSearchValue = _useState10[1];
  var onSelectClick = function onSelectClick(event) {
    if (isDisabled || event.target === inputRef.current) return;
    if (selectedItemsRef && selectedItemsRef.current && selectedItemsRef.current.contains(event.target)) return;
    setOpen(!open);
  };
  var setSelectedValue = function setSelectedValue(value) {
    var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    setSelectedValueState(value);
    if (update) {
      onChange(value);
    }
    if (search) {
      if (searchValue) {
        setSearchValue('');
      }
      if (multiselect) {
        // ожидаем всех обновлений и ставим каретку в инпут
        setTimeout(function () {
          inputRef.current.focus();
        }, 100);
      }
    }
  };
  var onOptionClick = function onOptionClick(value, event) {
    if (dontCloseOnSelect) {
      event.stopPropagation();
    }
    if (multiselect) {
      var toSelect = Array.from(selectedValue);
      var valIndex = toSelect.findIndex(function (val) {
        return deep_equal_default()(val, value);
      });
      if (valIndex >= 0) {
        toSelect.splice(valIndex, 1);
      } else {
        toSelect.push(value);
      }
      setSelectedValue(toSelect);
    } else {
      setSelectedValue(value);
    }
  };
  var onOptionUnselect = function onOptionUnselect(value) {
    if (!multiselect && !Array.isArray(selectedValue)) {
      console.error('it is not possible to remove the option because the multiselect parameter was not passed, or an error in the state');
    } else {
      var index = selectedValue.findIndex(function (val) {
        return deep_equal_default()(val, value);
      });
      if (index >= 0) {
        var toSelectValue = Array.from(selectedValue);
        toSelectValue.splice(index, 1);
        setSelectedValue(toSelectValue);
      }
    }
  };
  var onDocumentMouseUp = function onDocumentMouseUp(event) {
    if (open) {
      if (event.target !== selectRef.current && !selectRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
  };
  // нормальзация опций, для дальнейшего использования в компоненте
  var getOptions = function getOptions() {
    var opts = options.map(function (opt) {
      if (typeof opt === 'string') return {
        text: opt
      };
      return opt;
    });
    if (!opts.length && selected) {
      if (typeof selected === 'string') {
        return [{
          text: selected
        }];
      } else {
        return [selected];
      }
    }
    return opts;
  };
  // получаем список опций и фильтруем
  var optionsList = getOptions();
  var filteredOptionsList = (!searchValue ? optionsList : optionsList.filter(function (opt) {
    return opt.text.toLowerCase().includes(searchValue.toLowerCase());
  })).filter(function (opt) {
    if (hideSelected && Array.isArray(selectedValue)) {
      return !Boolean(selectedValue.find(function (o) {
        return deep_equal_default()(o, opt);
      }));
    } else {
      return true;
    }
  });
  // сразу выставляем состояние с первой выбранной опцией если это необходимо
  (0,hooks_module/* useEffect */.d4)(function () {
    if (disabled || !optionsList.length) {
      setDisabled(true);
    }
    if (selected) {
      if (typeof selected === 'string') {
        if (multiselect) {
          setSelectedValue([{
            text: selected
          }], false);
        } else {
          setSelectedValue({
            text: selected
          }, false);
        }
      } else {
        setSelectedValue(selected, false);
      }
    }
    if (search && inputRef.current) {
      setTimeout(function () {
        inputRef.current.focus();
      }, 0);
    }
  }, []);
  // вешаем события отпускния кнопки (нажатие где-то не всплывает сюда) мыши на документ,
  // если дропдаун раскрыт, чтобы при нажатии вне его, закрыть
  (0,hooks_module/* useEffect */.d4)(function () {
    if (open && !isDisabled) {
      setTimeout(function () {
        if (search && inputRef.current && document.activeElement !== inputRef.current) {
          inputRef.current.focus();
        }
      }, 0);
      document.addEventListener('mouseup', onDocumentMouseUp, false);
      return function () {
        document.removeEventListener('mouseup', onDocumentMouseUp, false);
      };
    }
  }, [open]);
  (0,hooks_module/* useEffect */.d4)(function () {
    setDisabled(disabled);
  }, [disabled]);

  // Внутренний компонент с полем поиска
  function SearchInputComponent() {
    var onSearch = function onSearch(event) {
      var selectionStart = event.target.selectionStart;
      var value = event.target.value;
      setSearchValue(value);
      if (!open) {
        setOpen(true);
      }
      // ожидаем всех обновлений и ставим каретку в инпут, туда где была
      setTimeout(function () {
        inputRef.current.focus();
        inputRef.current.setSelectionRange(selectionStart, selectionStart);
      }, 0);
    };
    var onInputKeyDown = function onInputKeyDown(event) {
      if (select_isEnterKey(event)) {
        event.stopPropagation();
        var value = event.target.value;
        var toSelectOption = filteredOptionsList.find(function (opt) {
          return opt.text.toLowerCase() === value.toLowerCase();
        });
        if (toSelectOption) {
          onOptionClick(toSelectOption, event);
        } else if (filteredOptionsList.length === 1) {
          onOptionClick(filteredOptionsList[0], event);
        }
      } else if (select_isBackspaceKey(event)) {
        event.stopPropagation();
        var selectionStart = event.target.selectionStart;
        if (selectionStart === 0 && Array.isArray(selectedValue) && selectedValue.length) {
          var toSelectValue = Array.from(selectedValue);
          toSelectValue.pop();
          setSelectedValue(toSelectValue);
        }
      }
    };
    var onInputMouseDown = function onInputMouseDown(event) {
      event.stopPropagation();
    };
    return (0,preact_module.h)("input", {
      ref: inputRef,
      type: "text",
      placeholder: Object.keys(selectedValue).length ? '' : placeholder,
      onChange: onSearch,
      onMouseDown: onInputMouseDown,
      onKeyDown: onInputKeyDown,
      value: searchValue,
      disabled: isDisabled
    });
  }

  // Внутренний компонент с выбранными значениями
  function SelectedItemsComponent() {
    var toRenderNode = null;
    var renderSearchInput = false;
    if (SelectedComponent) {
      toRenderNode =
      // если родительский компонент хочет сам управлять внешним видом выделенных элементов
      // и для этого передан компонент, возвращаем его
      (0,preact_module.h)(SelectedComponent, {
        ItemComponent: SelectedItemComponent,
        value: selectedValue,
        onUnselect: onOptionUnselect,
        placeholder: placeholder,
        disabled: isDisabled
      });
    } else {
      if (!Object.keys(selectedValue).length) {
        // тут не важно объект или массив, если пустой объект или массив, вернет true
        if (!search) {
          toRenderNode = placeholder;
        }
      } else {
        // думаю в будущем, если компонент где-то будет переиспользоваться,
        // можно вынести эту константу в props
        var delimeter = multiselect ? ', ' : '';
        toRenderNode = (multiselect && Array.isArray(selectedValue) ? selectedValue : [selectedValue]).map(function (val, index, arr) {
          return SelectedItemComponent ? (0,preact_module.h)(SelectedItemComponent, {
            option: val,
            onUnselect: multiselect ? onOptionUnselect : false,
            disabled: isDisabled
          }) : (0,preact_module.h)("span", null, val.text + (arr.length - 1 !== index ? delimeter : ''));
        });
      }
    }
    if (search && (multiselect || !Object.keys(selectedValue).length)) {
      renderSearchInput = true;
    }
    return (0,preact_module.h)(preact_module/* Fragment */.HY, null, toRenderNode, renderSearchInput ? (0,preact_module.h)(SearchInputComponent, null) : null);
  }
  var domNodeClassNames = ['custom-select', addClassName];
  if (open) {
    domNodeClassNames.push('open');
  }
  if (isDisabled) {
    domNodeClassNames.push('disabled');
  }
  return (0,preact_module.h)("div", {
    className: domNodeClassNames.join(' '),
    onClick: onSelectClick,
    ref: selectRef
  }, (0,preact_module.h)("span", {
    className: "selected-item"
  }, (0,preact_module.h)(SelectedItemsComponent, null)), (0,preact_module.h)("span", {
    className: "custom-select-arrow"
  }, (0,preact_module.h)(icons/* IconArrowDown */.BDo, null)), !open ? null : (0,preact_module.h)(ListItemsComponent, {
    ListComponent: ListComponent,
    filteredOptionsList: filteredOptionsList,
    selectedValue: selectedValue,
    OptionComponent: OptionComponent,
    onOptionClick: onOptionClick,
    onOptionUnselect: onOptionUnselect,
    multiselect: multiselect,
    onSelectedItemsRef: setSelectedItemsRef
  }));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/filter/fields/typeText.js


function TypeTextField(props) {
  var i18n = props.editor.plugins.i18n;
  var inputRef = (0,hooks_module/* useRef */.sO)(null);
  var onChange = props.onChange;
  var onInputMouseDown = function onInputMouseDown(event) {
    event.stopPropagation();
  };
  var onInputChange = function onInputChange(event) {
    onChange(event.target.value);
  };
  (0,hooks_module/* useEffect */.d4)(function () {
    inputRef.current.focus();
  }, []);
  return (0,preact_module.h)("input", {
    ref: inputRef,
    className: "table-filter-input",
    placeholder: i18n.get('table.filter.type_text_placeholder'),
    type: "text",
    value: props.value,
    onMouseDown: onInputMouseDown,
    onChange: onInputChange,
    disabled: props.disabled
  });
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/filter/fields/typeNumber.js










function typeNumber_slicedToArray(arr, i) { return typeNumber_arrayWithHoles(arr) || typeNumber_iterableToArrayLimit(arr, i) || typeNumber_unsupportedIterableToArray(arr, i) || typeNumber_nonIterableRest(); }
function typeNumber_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function typeNumber_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return typeNumber_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return typeNumber_arrayLikeToArray(o, minLen); }
function typeNumber_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function typeNumber_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function typeNumber_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


function TypeNumberField(props) {
  var i18n = props.editor.plugins.i18n;
  var _useState = (0,hooks_module/* useState */.eJ)(props.value || ''),
    _useState2 = typeNumber_slicedToArray(_useState, 2),
    value = _useState2[0],
    setValueState = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(),
    _useState4 = typeNumber_slicedToArray(_useState3, 2),
    updateState = _useState4[1];
  var forceUpdate = (0,hooks_module/* useCallback */.I4)(function () {
    return updateState({});
  }, []);
  var onChange = props.onChange,
    _props$isRating = props.isRating,
    isRating = _props$isRating === void 0 ? false : _props$isRating;
  var inputRef = (0,hooks_module/* useRef */.sO)(null);
  var regexp = !isRating ? /^-?[0-9]\d*\.?\d*$/ : /^([0-9]|10){1}$/;
  var setValue = function setValue(value) {
    setValueState(value);
    if (value === '-') {
      onChange('');
    } else {
      onChange(value);
    }
  };
  var onInputChange = function onInputChange(event) {
    if (regexp.test(event.target.value)) {
      setValue(event.target.value);
    } else if (event.target.value === '' || !isRating && event.target.value === '-') {
      setValue(event.target.value);
    }
    forceUpdate();
  };
  var onInputMouseDown = function onInputMouseDown(event) {
    event.stopPropagation();
  };
  (0,hooks_module/* useEffect */.d4)(function () {
    inputRef.current.focus();
  }, []);
  return (0,preact_module.h)("input", {
    ref: inputRef,
    className: "table-filter-input",
    placeholder: i18n.get('table.filter.type_number_placeholder'),
    type: "text",
    value: value,
    onMouseDown: onInputMouseDown,
    onChange: onInputChange,
    disabled: props.disabled
  });
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/filter/fields/typeCheckbox.js











function typeCheckbox_slicedToArray(arr, i) { return typeCheckbox_arrayWithHoles(arr) || typeCheckbox_iterableToArrayLimit(arr, i) || typeCheckbox_unsupportedIterableToArray(arr, i) || typeCheckbox_nonIterableRest(); }
function typeCheckbox_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function typeCheckbox_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return typeCheckbox_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return typeCheckbox_arrayLikeToArray(o, minLen); }
function typeCheckbox_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function typeCheckbox_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function typeCheckbox_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


function TypeCheckboxField(_ref) {
  var value = _ref.value,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var _useState = (0,hooks_module/* useState */.eJ)(Boolean(value)),
    _useState2 = typeCheckbox_slicedToArray(_useState, 2),
    checked = _useState2[0],
    setChecked = _useState2[1];
  var onMouseDown = function onMouseDown(event) {
    if (disabled) return;
    event.stopPropagation();
    var newState = !checked;
    setChecked(newState);
    onChange(newState);
  };
  var classes = ['checkbox-component', 'table-filter-checkbox-field'];
  if (checked) {
    classes.push('checked');
  }
  if (disabled) {
    classes.push('disabled');
  }
  return (0,preact_module.h)("span", {
    className: classes.join(' '),
    onMouseDown: onMouseDown
  });
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/filter/fields/typeFile.js




var TYPES = {
  images: 'png, jpg, jpeg, gif',
  documents: 'doc, pdf, xls, html, txt',
  media: 'mp4, mp3, mov, avi, webm',
  other: 'all other file types'
};
function OptionComponent(_ref) {
  var option = _ref.option;
  return (0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)("div", {
    className: "table-filter-file-option-title"
  }, option.text), (0,preact_module.h)("div", {
    className: "table-filter-file-option-description"
  }, TYPES[option.value]));
}
function TypeFileField(_ref2) {
  var value = _ref2.value,
    _ref2$onChange = _ref2.onChange,
    onChange = _ref2$onChange === void 0 ? function () {} : _ref2$onChange,
    editor = _ref2.editor,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled;
  var i18n = editor.plugins.i18n;
  var options = Object.keys(TYPES).map(function (type) {
    return {
      text: i18n.get('table.filter.filetypes.' + type),
      value: type
    };
  });
  var onSelectChange = function onSelectChange(value) {
    onChange(value.value);
  };
  return (0,preact_module.h)(Select, {
    addClassName: 'table-filter-filetype-select',
    optionComponent: OptionComponent,
    options: options,
    selected: value ? {
      text: i18n.get('table.filter.filetypes.' + value),
      value: value
    } : false,
    onChange: onSelectChange,
    placeholder: i18n.get('table.filter.select_type_placeholder'),
    disabled: disabled
  });
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/filter/fields/typeLabel.js














function typeLabel_LabelComponent(_ref) {
  var option = _ref.option,
    onUnselect = _ref.onUnselect,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var onMouseDown = (0,hooks_module/* useCallback */.I4)(function (event) {
    if (disabled) return;
    event.stopPropagation();
    onUnselect(option);
  }, [option, onUnselect]);
  return (0,preact_module.h)("span", {
    class: 'select-label adaptive-text bg-palette-' + option.color
  }, (0,preact_module.h)("span", {
    class: "select-label-text"
  }, option.text), onUnselect && !disabled ? (0,preact_module.h)("span", {
    className: "select-label-remove",
    onMouseDown: onMouseDown
  }, (0,preact_module.h)(icons/* IconCross */.WcQ, null)) : null);
}
function LabelSelectedComponent(_ref2) {
  var ItemComponent = _ref2.ItemComponent,
    _ref2$value = _ref2.value,
    labels = _ref2$value === void 0 ? [] : _ref2$value,
    _ref2$onUnselect = _ref2.onUnselect,
    onUnselect = _ref2$onUnselect === void 0 ? function () {} : _ref2$onUnselect,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled;
  var domRef = (0,hooks_module/* useRef */.sO)(null);
  var maxLength = 8;
  var toShowLabels = labels.length;
  if (labels.length) {
    var remainingLength = maxLength;
    var toHide = labels.reduce(function (count, label) {
      if ((remainingLength === maxLength || remainingLength >= label.text.length || remainingLength >= 2 && label.text.length <= 3) && count === 0) {
        remainingLength -= label.text.length <= 3 ? label.text.length + 1 : label.text.length;
      } else {
        count++;
      }
      return count;
    }, 0);
    if (toHide > 0) {
      toShowLabels -= toHide;
    }
  }
  var styles = {};
  if (!labels.length) {
    styles.height = '27px';
  } else {
    styles.display = 'contents';
  }
  return (0,preact_module.h)("div", {
    ref: domRef,
    style: styles
  }, labels.slice(0, toShowLabels).map(function (val) {
    return (0,preact_module.h)(ItemComponent, {
      option: val,
      onUnselect: onUnselect,
      disabled: disabled
    });
  }), toShowLabels < labels.length ? (0,preact_module.h)("span", {
    class: "nowrap-plus"
  }, "+", labels.length - toShowLabels) : null);
}
function LabelListComponent(_ref3) {
  var options = _ref3.options,
    selectedOptions = _ref3.selectedValue,
    OptionComponent = _ref3.OptionComponent,
    onSelect = _ref3.onSelect,
    onUnselect = _ref3.onUnselect,
    onSelectedItemsRef = _ref3.onSelectedItemsRef;
  var selectedItemsRef = (0,hooks_module/* useRef */.sO)(null);
  (0,hooks_module/* useEffect */.d4)(function () {
    onSelectedItemsRef(selectedItemsRef);
  }, [selectedItemsRef.current]);
  if (options.length) {
    var _options$reduce = options.reduce(function (res, option) {
        if (selectedOptions.find(function (val) {
          return deep_equal_default()(val, option);
        })) {
          res.selected.push(option);
        } else {
          res.list.push(option);
        }
        return res;
      }, {
        selected: [],
        list: []
      }),
      selected = _options$reduce.selected,
      list = _options$reduce.list;
    return (0,preact_module.h)(preact_module/* Fragment */.HY, null, selected.length ? (0,preact_module.h)("div", {
      className: "table-filter-selected-labels",
      ref: selectedItemsRef
    }, selected.map(function (option) {
      return (0,preact_module.h)("span", {
        className: "option-item selected"
      }, (0,preact_module.h)(OptionComponent, {
        option: option,
        onUnselect: onUnselect
      }));
    })) : null, list.length ? (0,preact_module.h)("div", {
      className: "table-filter-labels-list"
    }, list.map(function (option) {
      return (0,preact_module.h)("span", {
        className: "option-item",
        onClick: onSelect.bind(undefined, option)
      }, (0,preact_module.h)(OptionComponent, {
        option: option
      }));
    })) : null);
  } else {
    return (0,preact_module.h)("span", {
      style: {
        textAlign: 'center'
      }
    }, "No result");
  }
}
function TypeLabelField(_ref4) {
  var value = _ref4.value,
    colData = _ref4.colData,
    _ref4$onChange = _ref4.onChange,
    onChange = _ref4$onChange === void 0 ? function () {} : _ref4$onChange,
    editor = _ref4.editor,
    _ref4$disabled = _ref4.disabled,
    disabled = _ref4$disabled === void 0 ? false : _ref4$disabled;
  var i18n = editor.plugins.i18n;
  var parsedLabels = parseObject('object', colData.dbSelect);
  var labels = Object.keys(parsedLabels).map(function (id) {
    return {
      id: id,
      text: parsedLabels[id].name,
      name: parsedLabels[id].name,
      style: parsedLabels[id].style,
      color: parsedLabels[id].color
    };
  });
  var selected = value && value.length ? labels.filter(function (label) {
    return value.includes(label.id);
  }) : false;
  var onSelectChange = function onSelectChange(labelsArr) {
    onChange(labelsArr.map(function (label) {
      return label.id;
    }));
  };
  return (0,preact_module.h)(Select, {
    addClassName: "table-filter-label-select",
    placeholder: i18n.get('table.filter.type_text_or_select_placeholder'),
    selectedComponent: LabelSelectedComponent,
    selectedItemComponent: typeLabel_LabelComponent,
    listComponent: LabelListComponent,
    optionComponent: typeLabel_LabelComponent,
    options: labels,
    selected: selected,
    multiselect: true,
    search: true,
    hideSelected: false,
    dontCloseOnSelect: true,
    onChange: onSelectChange,
    disabled: disabled
  });
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/filter/fields/typeCollaborate.js
function typeCollaborate_toConsumableArray(arr) { return typeCollaborate_arrayWithoutHoles(arr) || typeCollaborate_iterableToArray(arr) || typeCollaborate_unsupportedIterableToArray(arr) || typeCollaborate_nonIterableSpread(); }
function typeCollaborate_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function typeCollaborate_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function typeCollaborate_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return typeCollaborate_arrayLikeToArray(arr); }
function typeCollaborate_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = typeCollaborate_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function typeCollaborate_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return typeCollaborate_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return typeCollaborate_arrayLikeToArray(o, minLen); }
function typeCollaborate_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }





















var typeCollaborate_colorKeys = Object.keys(avatarcolors);
function getAvatar() {
  var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var letter,
    color,
    code = 0;
  var name = user.name || user.user_name;
  if (name) {
    letter = name[0].toUpperCase();
    var _iterator = typeCollaborate_createForOfIteratorHelper(name),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var char = _step.value;
        code += char.charCodeAt();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else {
    letter = '?';
    code = letter.charCodeAt();
  }
  color = avatarcolors[typeCollaborate_colorKeys[code % typeCollaborate_colorKeys.length]];
  return (0,preact_module.h)("span", {
    className: "user-avatar",
    style: {
      background: color
    }
  }, letter);
}
function UserOptionComponent(_ref) {
  var user = _ref.option,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected;
  var avatar = getAvatar(user);
  return (0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)("span", {
    "data-mention-type": "user",
    className: "collaborate-item",
    "data-mention-name": user.name,
    "data-user-id": user.object_id,
    "data-mention-id": user.mention_id
  }, (0,preact_module.h)("span", {
    className: "collaborate-item-img"
  }, avatar), (0,preact_module.h)("span", {
    className: "collaborate-item-name"
  }, (0,preact_module.h)("span", {
    className: "collaborate-item-text searchable"
  }, user.name))), selected ? (0,preact_module.h)("span", {
    className: "collaborate-item-done"
  }, (0,preact_module.h)(icons/* IconDone */.EZi, null)) : null);
}
function UserSelectedComponent(_ref2) {
  var _ref2$value = _ref2.value,
    users = _ref2$value === void 0 ? [] : _ref2$value,
    _ref2$placeholder = _ref2.placeholder,
    placeholder = _ref2$placeholder === void 0 ? 'Select users' : _ref2$placeholder;
  if (users.length) {
    var toRenderChildren = [];
    var classNames = ['table-filter-selected-users'];
    if (users.length <= 2) {
      if (users.length === 1) {
        classNames.push('one-selected');
      } else if (users.length === 2) {
        classNames.push('two-selected');
      }
      toRenderChildren.push.apply(toRenderChildren, typeCollaborate_toConsumableArray(users.map(function (user) {
        return (0,preact_module.h)(UserOptionComponent, {
          option: user
        });
      })));
    } else {
      if (users.length === 3) {
        classNames.push('some-selected');
      } else {
        classNames.push('more-selected');
      }
      toRenderChildren.push.apply(toRenderChildren, typeCollaborate_toConsumableArray(users.slice(0, 2).map(function (user) {
        var avatar = getAvatar(user);
        return (0,preact_module.h)("span", {
          "data-mention-type": "user",
          className: "collaborate-item",
          "data-mention-name": user.name,
          "data-user-id": user.object_id,
          "data-mention-id": user.mention_id
        }, (0,preact_module.h)("span", {
          className: "collaborate-item-img"
        }, avatar));
      })));
      toRenderChildren.push((0,preact_module.h)(UserOptionComponent, {
        option: users[2]
      }));
      if (users.length > 3) {
        toRenderChildren.push((0,preact_module.h)("span", {
          className: "nowrap-plus"
        }, '+' + String(users.length - 3)));
      }
    }
    return (0,preact_module.h)("div", {
      className: classNames.join(' ')
    }, toRenderChildren);
  }
  return (0,preact_module.h)("span", {
    className: "table-filter-user-select-empty"
  }, placeholder);
}
function TypeCollaborateField(_ref3) {
  var value = _ref3.value,
    colData = _ref3.colData,
    _ref3$onChange = _ref3.onChange,
    onChange = _ref3$onChange === void 0 ? function () {} : _ref3$onChange,
    editor = _ref3.editor,
    _ref3$disabled = _ref3.disabled,
    disabled = _ref3$disabled === void 0 ? false : _ref3$disabled;
  var i18n = editor.plugins.i18n;
  var parsedUsers = parseObject('object', colData.users);
  var users = Object.keys(parsedUsers).map(function (id) {
    return {
      id: id,
      text: parsedUsers[id].name,
      name: parsedUsers[id].name,
      mention_id: parsedUsers[id].mention_id,
      object_id: parsedUsers[id].object_id
    };
  });
  var selected = value && value.length ? users.filter(function (user) {
    return value.includes(user.id);
  }) : null;
  var onSelectChange = function onSelectChange(usersArr) {
    onChange(usersArr.map(function (user) {
      return user.id;
    }));
  };
  return (0,preact_module.h)(Select, {
    addClassName: "table-filter-user-select",
    placeholder: i18n.get('table.filter.select_users_placeholder'),
    selectedComponent: UserSelectedComponent,
    optionComponent: UserOptionComponent,
    options: users,
    selected: selected,
    multiselect: true,
    dontCloseOnSelect: true,
    onChange: onSelectChange,
    disabled: disabled
  });
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/filter/fields/typeRating.js

function typeRating_extends() { typeRating_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return typeRating_extends.apply(this, arguments); }


function TypeRatingField(props) {
  return (0,preact_module.h)(TypeNumberField, typeRating_extends({
    isRating: true,
    disabled: props.disabled
  }, props));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/filter/fields/typeProgress.js


function TypeProgressField(props) {
  var value = props.value,
    onChange = props.onChange,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled;
  var onEndSlide = function onEndSlide(progress) {
    onChange(progress);
  };
  return (0,preact_module.h)("div", {
    className: "table-filter-progress table-progress"
  }, (0,preact_module.h)(ProgressSilder, {
    addClassName: "table-progress-slider",
    value: value,
    onChange: onEndSlide,
    showProgress: true,
    readonly: disabled
  }));
}
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(25992);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/datepicker.js








function DatePicker(props) {
  var selected = props.selected,
    onChange = props.onChange,
    startDate = props.startDate,
    endDate = props.endDate,
    selectsRange = props.selectsRange,
    language = props.language;
  var lngZone = language === 'ru' ? 'ru-RU' : 'en-US';
  function DatePickerHeader() {
    var parts = startDate.toLocaleDateString(lngZone, {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }).split(' ');
    parts.pop();
    if (language === 'ru') {
      parts.pop();
    }
    if (parts[parts.length - 1].endsWith(',')) {
      parts[parts.length - 1] = parts[parts.length - 1].replace(',', '');
    }
    return (0,preact_module.h)("div", {
      className: "datepicker-header"
    }, (0,preact_module.h)("span", {
      className: "datepicker-header-year"
    }, startDate.getFullYear()), (0,preact_module.h)("span", {
      className: "datepicker-header-date"
    }, parts.join(' ')));
  }
  var renderCustomNavigation = function renderCustomNavigation(_ref) {
    var date = _ref.date,
      decreaseMonth = _ref.decreaseMonth,
      increaseMonth = _ref.increaseMonth,
      prevMonthButtonDisabled = _ref.prevMonthButtonDisabled,
      nextMonthButtonDisabled = _ref.nextMonthButtonDisabled;
    return (0,preact_module.h)("div", {
      className: "react-datepicker-nav-header"
    }, (0,preact_module.h)("button", {
      className: "react-datepicker-nav react-datepicker-nav-prev",
      onClick: decreaseMonth,
      disabled: prevMonthButtonDisabled
    }, (0,preact_module.h)(icons/* IconChevronLeft */.ed9, null)), (0,preact_module.h)("div", {
      className: "react-datepicker-month"
    }, date.toLocaleDateString(lngZone, {
      month: 'long'
    }) + ' ' + date.getFullYear()), (0,preact_module.h)("button", {
      className: "react-datepicker-nav react-datepicker-nav-next",
      onClick: increaseMonth,
      disabled: nextMonthButtonDisabled
    }, (0,preact_module.h)(icons/* IconChevronRight */.VG8, null)));
  };
  return (0,preact_module.h)("div", {
    className: "nim-editor-datepicker nimbus-theme"
  }, (0,preact_module.h)(DatePickerHeader, null), (0,preact_module.h)((react_datepicker_min_default()), {
    renderCustomHeader: renderCustomNavigation,
    selected: selected,
    onChange: onChange,
    startDate: startDate,
    endDate: endDate,
    selectsRange: selectsRange,
    inline: true
  }));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/filter/fields/typeDate.js










function typeDate_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { typeDate_typeof = function _typeof(obj) { return typeof obj; }; } else { typeDate_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return typeDate_typeof(obj); }
function typeDate_slicedToArray(arr, i) { return typeDate_arrayWithHoles(arr) || typeDate_iterableToArrayLimit(arr, i) || typeDate_unsupportedIterableToArray(arr, i) || typeDate_nonIterableRest(); }
function typeDate_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function typeDate_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return typeDate_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return typeDate_arrayLikeToArray(o, minLen); }
function typeDate_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function typeDate_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function typeDate_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }





function TypeDateField(_ref) {
  var initialValue = _ref.value,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? 'en' : _ref$language,
    editor = _ref.editor,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var i18n = editor.plugins.i18n;
  var today = new Date().setHours(0, 0, 0, 0);
  var yesterday = new Date(new Date().setDate(new Date().getDate() - 1)).setHours(0, 0, 0, 0);
  var tomorrow = new Date(new Date().setDate(new Date().getDate() + 1)).setHours(0, 0, 0, 0);
  var _useState = (0,hooks_module/* useState */.eJ)(initialValue ? typeof initialValue === 'number' ? new Date(initialValue) : new Date(initialValue.start) : null),
    _useState2 = typeDate_slicedToArray(_useState, 2),
    startDate = _useState2[0],
    setStartDate = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(typeDate_typeof(initialValue) === 'object' ? new Date(initialValue.end) : null),
    _useState4 = typeDate_slicedToArray(_useState3, 2),
    endDate = _useState4[0],
    setEndDate = _useState4[1];
  var _useState5 = (0,hooks_module/* useState */.eJ)(false),
    _useState6 = typeDate_slicedToArray(_useState5, 2),
    datepickerOpen = _useState6[0],
    setDatepickerOpenState = _useState6[1];
  var _useState7 = (0,hooks_module/* useState */.eJ)(false),
    _useState8 = typeDate_slicedToArray(_useState7, 2),
    attached = _useState8[0],
    setAttached = _useState8[1];
  var _useState9 = (0,hooks_module/* useState */.eJ)(false),
    _useState10 = typeDate_slicedToArray(_useState9, 2),
    allowRange = _useState10[0],
    setAllowRange = _useState10[1];
  var selectRef = (0,hooks_module/* useRef */.sO)(null);
  var datepickerRef = (0,hooks_module/* useRef */.sO)(null);
  var options = [{
    text: i18n.get('table.filter.date.today'),
    date: today
  }, {
    text: i18n.get('table.filter.date.yesterday'),
    date: yesterday
  }, {
    text: i18n.get('table.filter.date.tomorrow'),
    date: tomorrow
  }, {
    text: i18n.get('table.filter.date.custom'),
    date: 'custom'
  }];
  var onDatepickerRef = function onDatepickerRef(node) {
    datepickerRef.current = node;
  };
  (0,hooks_module/* useEffect */.d4)(function () {
    setAttached(true);
    document.addEventListener('mouseup', onDocumentMouseUp, false);
    return function () {
      document.removeEventListener('mouseup', onDocumentMouseUp, false);
    };
  }, []);
  var onDocumentMouseUp = function onDocumentMouseUp(event) {
    var target = event.target;
    if (datepickerRef.current && target !== datepickerRef.current && !datepickerRef.current.contains(target)) {
      onDatepickerWantsToClose();
    }
  };
  var setDatepickerOpen = function setDatepickerOpen(value, start, end) {
    if (value === false && start) {
      if (!end || start.getTime() === end.getTime()) {
        onChange(new Date(start).setHours(0, 0, 0, 0));
      } else {
        onChange({
          start: new Date(start).setHours(0, 0, 0, 0),
          end: new Date(end).setHours(0, 0, 0, 0)
        });
      }
    }
    setAllowRange(false);
    setDatepickerOpenState(value);
  };
  var onDateChange = function onDateChange(date) {
    if (Array.isArray(date)) {
      var _date = typeDate_slicedToArray(date, 2),
        start = _date[0],
        end = _date[1];
      setStartDate(start);
      setEndDate(end);
      if (end) {
        setDatepickerOpen(false, start, end);
      }
    } else {
      var _start = date;
      setStartDate(_start);
      if (endDate) {
        setEndDate(null);
      }
      setAllowRange(true);
    }
  };
  var onSelectChange = function onSelectChange(value) {
    if (value.date === 'custom') {
      if (!startDate) {
        setStartDate(new Date());
      }
      if (attached) {
        setDatepickerOpen(true);
      }
    } else {
      if (datepickerOpen) {
        setDatepickerOpen(false);
      }
      onChange(value.date);
    }
  };
  var onDatepickerWantsToClose = function onDatepickerWantsToClose() {
    setDatepickerOpen(false, startDate, endDate);
  };
  function getSelectedOption() {
    if (typeof initialValue === 'number') {
      var startInitialTime = new Date(initialValue).setHours(0, 0, 0, 0);
      if (startInitialTime === today) {
        return options[0];
      } else if (startInitialTime === yesterday) {
        return options[1];
      } else if (startInitialTime === tomorrow) {
        return options[2];
      } else {
        return options[3];
      }
    } else if (typeDate_typeof(initialValue) === 'object') {
      return options[3];
    }
    return false;
  }
  function SelectedItemComponent(_ref2) {
    var item = _ref2.option;
    if (item.date === 'custom' && startDate) {
      var dateString = startDate.toLocaleDateString();
      if (endDate && startDate.getTime() !== endDate.getTime()) {
        dateString += ' -> ' + endDate.toLocaleDateString();
      }
      return (0,preact_module.h)(preact_module/* Fragment */.HY, null, item.text + ': ', (0,preact_module.h)("span", {
        className: "table-filter-date-range-selected"
      }, dateString));
    }
    return item.text;
  }
  return (0,preact_module.h)("div", {
    className: "table-filter-date-field"
  }, (0,preact_module.h)(Select, {
    ref: selectRef,
    addClassName: 'table-filter-date-select',
    selectedItemComponent: SelectedItemComponent,
    options: options,
    selected: getSelectedOption(),
    onChange: onSelectChange,
    placeholder: i18n.get('table.filter.select_date_placeholder'),
    disabled: disabled
  }), datepickerOpen ? (0,preact_module.h)(popupMenu/* default */.Z, {
    domRef: onDatepickerRef,
    addClassName: "date-picker-popup no-scroll",
    closeOnEsc: true,
    wantsToClose: onDatepickerWantsToClose,
    anchorNode: selectRef.current.base,
    anchorOptions: {
      positionFixed: true,
      offset: '0px, -1px',
      placement: 'top-start',
      priority: ['bottom', 'left', 'right'],
      boundariesElement: editor.getScrollingContainer(),
      overflowBoundariesElement: editor.getScrollingContainer()
    }
  }, (0,preact_module.h)(DatePicker, {
    selected: startDate,
    onChange: onDateChange,
    startDate: startDate,
    endDate: endDate,
    selectsRange: allowRange,
    language: language
  })) : null);
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/filter/tableFilterRow.js













var COMPONENTS = {
  text: TypeTextField,
  number: TypeNumberField,
  currency: TypeNumberField,
  attachment: TypeFileField,
  checkbox: TypeCheckboxField,
  singleselect: TypeLabelField,
  multiselect: TypeLabelField,
  mention: TypeTextField,
  collaborator: TypeCollaborateField,
  date: TypeDateField,
  link: TypeTextField,
  rating: TypeRatingField,
  progress: TypeProgressField
};
var LNG_KEYS = {
  'where': 'table.filter.where',
  'Or': 'table.filter.or',
  'And': 'table.filter.and',
  'contains': 'table.filter.contains',
  'is': 'table.filter.is',
  'is not': 'table.filter.is_not',
  'contains not': 'table.filter.contains_not',
  'has any of': 'table.filter.has_any_of',
  'has none of': 'table.filter.has_none_of',
  'empty': 'table.filter.empty',
  'not empty': 'table.filter.not_empty',
  'filetype': 'table.filter.filetype'
};
function TableFilterRow(props) {
  var index = props.index,
    operator = props.operator,
    column = props.column,
    columns = props.columns,
    condition = props.condition,
    value = props.value,
    onColumnChange = props.onColumnChange,
    onOperatorChange = props.onOperatorChange,
    onConditionChange = props.onConditionChange,
    onDeleteClick = props.onDeleteClick,
    onValueChange = props.onValueChange,
    editor = props.editor,
    disabled = props.disabled;
  var i18n = editor.plugins.i18n;
  if (!column) {
    return null;
  } else {
    var FieldComponent = COMPONENTS[column.type] || 'Error data';
    var withoutValue = condition === 'empty' || condition === 'not empty';
    return (0,preact_module.h)("div", {
      className: 'table-filter-row' + (withoutValue ? ' without-value' : '') + ' ' + column.type + '-filter-row' + (disabled ? ' disabled' : '')
    }, (0,preact_module.h)("div", {
      className: 'table-filter-col' + (index > 1 ? ' table-filter-operator' : '')
    }, index === 0 ? i18n.get(LNG_KEYS['where']) : index === 1 ? (0,preact_module.h)(Select, {
      addClassName: "table-filter-operator-select",
      options: ['Or', 'And'].map(function (opt) {
        return {
          text: i18n.get(LNG_KEYS[opt]),
          value: opt
        };
      }),
      selected: {
        text: i18n.get(LNG_KEYS[operator]),
        value: operator
      },
      onChange: onOperatorChange,
      disabled: disabled
    }) : i18n.get(LNG_KEYS[operator])), (0,preact_module.h)("div", {
      className: "table-filter-col"
    }, (0,preact_module.h)(Select, {
      addClassName: "table-filter-column-select",
      options: columns.map(function (col) {
        return {
          text: col.colName,
          id: col.colId
        };
      }),
      selected: {
        text: column.colName,
        id: column.colId
      },
      onChange: onColumnChange.bind(undefined, index),
      disabled: disabled
    })), (0,preact_module.h)("div", {
      className: "table-filter-col"
    }, (0,preact_module.h)(Select, {
      addClassName: "table-filter-condition-select",
      options: column.conditions.map(function (cndt) {
        return {
          text: LNG_KEYS[cndt] ? i18n.get(LNG_KEYS[cndt]) : cndt,
          value: cndt
        };
      }),
      selected: {
        text: LNG_KEYS[condition] ? i18n.get(LNG_KEYS[condition]) : condition,
        value: condition
      },
      onChange: onConditionChange.bind(undefined, index),
      disabled: disabled || !(column.conditions.length > 1)
    })), !withoutValue ? (0,preact_module.h)("div", {
      className: "table-filter-col"
    }, (0,preact_module.h)(FieldComponent, {
      value: value,
      onChange: onValueChange.bind(undefined, index),
      colData: column,
      language: i18n.language,
      editor: editor,
      disabled: disabled
    })) : null, (0,preact_module.h)("div", {
      className: "table-filter-col"
    }, (0,preact_module.h)("span", {
      className: "delete-filter-row",
      onClick: onDeleteClick.bind(undefined, index)
    }, (0,preact_module.h)(icons/* IconTrash */.IT9, null))));
  }
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/switch.js

function switch_extends() { switch_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return switch_extends.apply(this, arguments); }



/**
 * 
 * @param {Object} params
 * @param {Editor} params.editor
 * @param {Function} params.onChange
 * @param {Boolean} params.enabled
 * @param {String} params.tooltip
 * @param {'small' | 'large'} params.size
 * @returns 
 */
var Switch = function Switch(_ref) {
  var _ref$editor = _ref.editor,
    editor = _ref$editor === void 0 ? null : _ref$editor,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? false : _ref$enabled,
    _ref$tooltip = _ref.tooltip,
    tooltip = _ref$tooltip === void 0 ? false : _ref$tooltip,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size;
  var onClick = function onClick(event) {
    if (editor && tooltip) {
      editor.plugins.tooltipManager.hide();
    }
    onChange(!enabled);
  };
  var attrs = {};
  if (tooltip) {
    attrs[tooltipManager/* TOOLTIP_ATTR */.qZ] = tooltip;
  }
  return (0,preact_module.h)("div", switch_extends({
    onClick: onClick,
    className: 'editor-switch-option editor-switch-option_size_' + size + ' switch-option-' + (enabled ? 'on' : 'off')
  }, attrs));
};
/* harmony default export */ const components_switch = (Switch);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/filter/tableFilterComponent.js
function tableFilterComponent_slicedToArray(arr, i) { return tableFilterComponent_arrayWithHoles(arr) || tableFilterComponent_iterableToArrayLimit(arr, i) || tableFilterComponent_unsupportedIterableToArray(arr, i) || tableFilterComponent_nonIterableRest(); }
function tableFilterComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tableFilterComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tableFilterComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tableFilterComponent_arrayLikeToArray(o, minLen); }
function tableFilterComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function tableFilterComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function tableFilterComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


























var APPLY_ON_MOUNT = ['checkbox', 'progress'];
function cleanFiltersKeys() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return filters.map(function (filter) {
    var result = Object.assign({}, filter);
    delete result.key;
    return result;
  });
}
function TableFilterComponent(_ref) {
  var _ref$filterProps = _ref.filterProps,
    filterProps = _ref$filterProps === void 0 ? {} : _ref$filterProps,
    editor = _ref.editor,
    useRefs = _ref.useRefs,
    anchorNode = _ref.anchorNode,
    wantsToClose = _ref.wantsToClose,
    _ref$anchorOptions = _ref.anchorOptions,
    anchorOptions = _ref$anchorOptions === void 0 ? {} : _ref$anchorOptions,
    onChange = _ref.onChange,
    onChangeView = _ref.onChangeView,
    filterDisabled = _ref.filterDisabled;
  var _useState = (0,hooks_module/* useState */.eJ)([]),
    _useState2 = tableFilterComponent_slicedToArray(_useState, 2),
    filters = _useState2[0],
    setFiltersState = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(filterProps.operator || 'Or'),
    _useState4 = tableFilterComponent_slicedToArray(_useState3, 2),
    operator = _useState4[0],
    setOperator = _useState4[1];
  var _useState5 = (0,hooks_module/* useState */.eJ)(false),
    _useState6 = tableFilterComponent_slicedToArray(_useState5, 2),
    isAttached = _useState6[0],
    setIsAttached = _useState6[1];
  var filterRef = (0,hooks_module/* useRef */.sO)(null);
  var prevFilters = (0,hooks_module/* useRef */.sO)(null);
  var columnsData = filterProps.columnsData,
    initialColumn = filterProps.initialColumn;
  var i18n = editor.plugins.i18n;
  (0,hooks_module/* useEffect */.d4)(function () {
    var initialFilters = JSON.parse(JSON.stringify(filterProps.filters || []));
    var columnData = initialColumn ? getColumnData(initialColumn) : columnsData[0];
    // если передана колонка для фильтрации, или фильтры отсутствуют в таблице, пушим новое условие
    if (!filterDisabled && (initialColumn || !initialFilters.length)) {
      initialFilters.push({
        colId: columnData.colId,
        type: columnData.type,
        condition: columnData.conditions[0],
        value: ''
      });
    }
    setFilters(initialFilters);
    setIsAttached(true);
    return function () {
      setIsAttached(false);
    };
  }, []);
  (0,hooks_module/* useEffect */.d4)(function () {
    var applyForce = filters.length && APPLY_ON_MOUNT.includes(filters[filters.length - 1].type) && filters[filters.length - 1].value === '';
    if (filters.length && (isAttached || applyForce)) {
      var currentFilters = {
        operator: operator,
        filters: cleanFiltersKeys(filters)
      };
      if ((prevFilters.current || applyForce) && !deep_equal_default()(prevFilters.current, currentFilters)) {
        prevFilters.current = currentFilters;
        onChange(currentFilters);
      } else {
        prevFilters.current = currentFilters;
      }
    } else if (prevFilters.current) {
      prevFilters.current = null;
    }
  }, [operator, filters]);
  var setFilters = function setFilters(value) {
    var toStateFilters = Array.from(value);
    var keyPreffix = 'nim-table-filter-';
    for (var _i2 = 0, _toStateFilters = toStateFilters; _i2 < _toStateFilters.length; _i2++) {
      var filter = _toStateFilters[_i2];
      if (!filter.key) {
        filter.key = keyPreffix + Math.floor(Math.random() * 10000);
      }
    }
    setFiltersState(toStateFilters);
  };
  var getColumnData = function getColumnData(colId) {
    return columnsData.find(function (columnData) {
      return columnData.colId === colId;
    });
  };
  var onMouseDown = function onMouseDown(event) {
    event.preventDefault();
    event.stopPropagation();
  };
  var onCloseClick = function onCloseClick(event) {
    wantsToClose();
  };
  var onAddConditionClick = function onAddConditionClick(event) {
    if (Boolean(filterDisabled)) {
      onChangeView(true);
    }
    var toChangeFilters = Array.from(filters);
    var columnData = initialColumn ? getColumnData(initialColumn) : columnsData[0];
    toChangeFilters.push({
      colId: columnData.colId,
      type: columnData.type,
      condition: columnData.conditions[0],
      value: ''
    });
    setFilters(toChangeFilters);
  };
  var onClearAllClick = function onClearAllClick(event) {
    if (Boolean(filterDisabled)) {
      onChangeView(true);
    }
    onChange(null);
    prevFilters.current = null;
    setFilters([]);
  };
  var onColumnChange = function onColumnChange(index, value) {
    var toChangeFilters = Array.from(filters);
    var columnData = getColumnData(value.id);
    toChangeFilters.splice(index, 1, {
      colId: columnData.colId,
      type: columnData.type,
      condition: columnData.conditions[0],
      value: ''
    });
    setFilters(toChangeFilters);
  };
  var onOperatorChange = function onOperatorChange(value) {
    setOperator(value.value);
  };
  var onConditionChange = function onConditionChange(index, value) {
    var toChangeFilters = Array.from(filters);
    toChangeFilters[index].condition = value.value;
    setFilters(toChangeFilters);
  };
  var onValueChange = function onValueChange(index, value) {
    var toChangeFilters = Array.from(filters);
    toChangeFilters[index].value = value;
    setFilters(toChangeFilters);
  };
  var onDeleteClick = function onDeleteClick(index) {
    if (Boolean(filterDisabled)) return;
    var toChangeFilters = Array.from(filters);
    if (index === 0 && toChangeFilters.length === 1) {
      onClearAllClick();
    } else {
      toChangeFilters.splice(index, 1);
      setFilters(toChangeFilters);
    }
  };
  var classes = ['table-filter'];
  if (filters.length && !filters.every(function (value) {
    return value.colId === filters[0].colId;
  })) {
    classes.push('multicolumn-filter');
  }
  var filterNode = (0,preact_module.h)("div", {
    className: classes.join(' ')
  }, (0,preact_module.h)("div", {
    className: "table-filter-header"
  }, (0,preact_module.h)("div", {
    className: "table-filter-header-switch"
  }, i18n.get('table.filter.enable_filter'), (0,preact_module.h)(components_switch, {
    editor: editor,
    onChange: onChangeView,
    enabled: !filterDisabled,
    tooltip: i18n.get('table.filter.' + (filterDisabled ? 'enable_filter' : 'disable_filter'))
  })), (0,preact_module.h)("div", {
    className: "table-filter-header-title"
  }, i18n.get('table.filter.popup_title'))), (0,preact_module.h)("div", {
    className: "table-filter-close",
    onClick: onCloseClick
  }, (0,preact_module.h)(icons/* IconClose */.bMz, null)), filters.length ? filters.map(function (filter, index) {
    return (0,preact_module.h)(TableFilterRow, {
      key: filter.key,
      index: index,
      editor: editor,
      useRefs: useRefs,
      operator: operator,
      column: getColumnData(filter.colId),
      columns: columnsData,
      condition: filter.condition,
      value: filter.value,
      onColumnChange: onColumnChange,
      onOperatorChange: onOperatorChange,
      onConditionChange: onConditionChange,
      onValueChange: onValueChange,
      onDeleteClick: onDeleteClick,
      disabled: Boolean(filterDisabled)
    });
  }) : (0,preact_module.h)("div", {
    className: "table-filter-no-filter-conditions"
  }, i18n.get('table.filter.empty_filters')), (0,preact_module.h)("div", {
    className: "table-filter-footer"
  }, (0,preact_module.h)("div", {
    className: "table-filter-add",
    onClick: onAddConditionClick
  }, "+ ", i18n.get('table.filter.add_condition')), filters.length ? (0,preact_module.h)("div", {
    className: "table-filter-clear",
    onClick: onClearAllClick
  }, i18n.get('table.filter.clear_all')) : null));
  return (0,preact_module.h)(RootPlacement, {
    editor: editor,
    styled: true,
    transitionName: "popup-menu",
    transitionTimeout: vars.popupAppearDuration
  }, (0,preact_module.h)(plugins_i18n/* IntlProvider */.Pj, null, (0,preact_module.h)(popupMenu/* default */.Z, {
    ref: filterRef,
    addClassName: "position-absolute table-filter-component",
    closeOnEsc: true,
    anchorNode: anchorNode,
    wantsToClose: wantsToClose,
    anchorOptions: anchorOptions,
    onMouseDown: onMouseDown
  }, filterNode)));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/filter/util.js
function util_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = util_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function util_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return util_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return util_arrayLikeToArray(o, minLen); }
function util_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function util_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { util_typeof = function _typeof(obj) { return typeof obj; }; } else { util_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return util_typeof(obj); }




























var TYPE_ASSOC = {
  'text': processTypeText,
  'number': processTypeNumber,
  'currency': processTypeNumber,
  'attachment': processTypeAttachment,
  'checkbox': processTypeCheckbox,
  'singleselect': processTypeSelect,
  'multiselect': processTypeSelect,
  'mention': processTypeMention,
  'collaborator': processTypeCollaborator,
  'link': processTypeLink,
  'rating': processTypeRating,
  'progress': processTypeProgress,
  'date': processTypeDate
};

/**
 * Получить дату в виде строки
 * @param {Object} date 
 * @param {Number} date.value
 * @param {Object} date.format
 * @param {Boolean} date.format.timeZoneGMT
 * @param {Boolean} date.format.showTime
 * @param {Object} editor 
 * @returns string
 */
function getStringFromDate(date, editor) {
  var _date$format, _date$format2;
  var timeZoneReal = TIME_ZONE_REAL;
  var timeZoneSelected = InputDate.getTimeZone({
    timeZoneSelected: -1,
    timeZoneReal: timeZoneReal,
    timeZoneGMT: (date === null || date === void 0 ? void 0 : (_date$format = date.format) === null || _date$format === void 0 ? void 0 : _date$format.timeZoneGMT) || false
  });
  var _Date$getDateTimeForm = date_Date.getDateTimeFormat(date, editor.blotsConfig['date'] || {}),
    timeFormat = _Date$getDateTimeForm.timeFormat,
    dateFormat = _Date$getDateTimeForm.dateFormat;
  var dateStr = InputDate.dateString({
    editor: editor,
    value: date.value,
    showTime: (date === null || date === void 0 ? void 0 : (_date$format2 = date.format) === null || _date$format2 === void 0 ? void 0 : _date$format2.showTime) || false,
    timeFormat: timeFormat,
    dateFormat: dateFormat
  }, {
    oneDay: oneDay,
    timeZoneReal: timeZoneReal,
    timeZoneSelected: timeZoneSelected,
    timeShift: InputDate.getTimeShift({
      timeZoneReal: timeZoneReal,
      timeZoneSelected: timeZoneSelected
    })
  });
  return dateStr;
}
function getTextFromDelta(editor, delta) {
  var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var length = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new (Delta_default())(delta).length() - index;
  var fromDelta = delta.slice(index, index + length);
  return fromDelta.filter(function (op) {
    if (typeof op.insert === 'string') {
      return true;
    } else if (util_typeof(op.insert) === 'object') {
      var BlotClass = parchment_default().query(Object.keys(op.insert)[0]);
      if (BlotClass && BlotClass.getOpText) {
        return true;
      }
    }
    return false;
  }).map(function (op) {
    if (typeof op.insert === 'string') {
      return op.insert;
    }
    if (op.insert.date) {
      return getStringFromDate(op.insert.date, editor);
    }
    return parchment_default().query(Object.keys(op.insert)[0]).getOpText(op.insert, undefined, editor);
  }).join('');
}
function processTypeText(condition, cellData, value) {
  var cellText = cellData && cellData.child ? cellData.child.characters : '';
  if (typeof cellText !== 'string') {
    cellText = '';
  }
  cellText = cellText.toLowerCase().replace('\n', '');
  if (!Boolean(value) && condition !== 'empty' && condition !== 'not empty') {
    return true;
  }
  switch (condition) {
    case 'contains':
      return cellText.indexOf(value.toLowerCase()) >= 0;
    case 'is':
      return cellText === value.toLowerCase();
    case 'is not':
      return cellText !== value.toLowerCase();
    case 'contains not':
      return cellText.indexOf(value.toLowerCase()) < 0;
    case 'empty':
      return !Boolean(cellText);
    case 'not empty':
      return Boolean(cellText);
    default:
      return true;
  }
}
function processTypeNumber(condition, cellData, value) {
  var cellValue = cellData && cellData.child ? cellData.child.characters : '';
  if (typeof cellValue !== 'string') {
    cellValue = '';
  }
  cellValue = cellValue.toLowerCase().replace(',', '.').replace('\n', '');
  if (!Boolean(cellValue)) {
    cellValue = false;
  } else {
    cellValue = parseFloat(cellValue);
  }
  var filterValue = String(value).length ? parseFloat(value) : false;
  if (typeof filterValue === 'boolean' && condition !== 'empty' && condition !== 'not empty') {
    return true;
  }
  switch (condition) {
    case '=':
      return typeof cellValue === 'number' && cellValue === filterValue;
    case '≠':
      return typeof cellValue === 'boolean' && !cellValue || typeof cellValue === 'number' && cellValue !== filterValue;
    case '>':
      return typeof cellValue === 'number' && cellValue > filterValue;
    case '<':
      return typeof cellValue === 'number' && cellValue < filterValue;
    case '≥':
      return typeof cellValue === 'number' && cellValue >= filterValue;
    case '≤':
      return typeof cellValue === 'number' && cellValue <= filterValue;
    case 'empty':
      return typeof cellValue === 'boolean' && !cellValue;
    case 'not empty':
      return typeof cellValue === 'number';
    default:
      return true;
  }
}
function processTypeAttachment(condition, cellData, value, editor) {
  var attachments = cellData ? cellData.attachments || [] : [];
  var attachmentsType = cellData ? cellData.attachmentsType || {} : {};
  if (condition === 'empty') {
    return !Boolean(attachments.length);
  } else if (condition === 'not empty') {
    return Boolean(attachments.length);
  } else {
    var files = attachments.map(function (id) {
      return attachmentsType[id];
    });
    if (!files.length && value) {
      return false;
    }
    function isImage(file) {
      var imgExt = ['png', 'jpg', 'jpeg', 'gif'];
      if (!file) return false;
      if (file.type) return file.type === 'image' || imgExt.some(function (type) {
        return type === file.type;
      });
      if (file.type_extra) return imgExt.some(function (type) {
        return type === file.type_extra.type;
      });
      if (file.mime) return file.mime.split('/')[0] === 'image' || imgExt.some(function (type) {
        return file.type.indexOf(type) >= 0;
      });
      if (file.display_name) return imgExt.includes(file.display_name.split('.').pop());
    }
    function isDocument(file) {
      var docExt = ['doc', 'pdf', 'xls', 'html', 'txt'];
      if (!file) return false;
      if (file.type) return docExt.some(function (type) {
        return type === file.type;
      });
      if (file.type_extra) return docExt.some(function (type) {
        return type === file.type_extra.type;
      });
      if (file.mime) return [].concat(docExt, ['document']).some(function (type) {
        return file.mime.indexOf(type) >= 0;
      });
      if (file.display_name) return docExt.includes(file.display_name.split('.').pop());
    }
    function isMedia(file) {
      var mediaExt = ['mp4', 'mp3', 'mov', 'avi', 'webm'];
      if (!file) return false;
      if (file.type) return file.type === 'video' || mediaExt.some(function (type) {
        return type === file.type;
      });
      if (file.type_extra) return mediaExt.some(function (type) {
        return type === file.type_extra.type;
      });
      if (file.mime) return file.mime.split('/')[0] === 'video' || mediaExt.some(function (type) {
        return file.type.indexOf(type) >= 0;
      });
      if (file.display_name) return mediaExt.includes(file.display_name.split('.').pop());
    }
    switch (value) {
      case 'images':
        return files.some(function (file) {
          return isImage(file);
        });
      case 'documents':
        return files.some(function (file) {
          return isDocument(file);
        });
      case 'media':
        return files.some(function (file) {
          return isMedia(file);
        });
      case 'other':
        return files.some(function (file) {
          return !isImage(file) && !isDocument(file) && !isMedia(file);
        });
      default:
        return true;
    }
  }
}
function processTypeSelect(condition, cellData, value) {
  var cellLabels = cellData ? cellData.selected || [] : [];
  if (condition === 'empty') {
    return !Boolean(cellLabels.length);
  } else if (condition === 'not empty') {
    return Boolean(cellLabels.length);
  } else {
    if (!Boolean(value) || !Array.isArray(value) || !value.length) return true;
    if (!cellLabels.length) return false;
    switch (condition) {
      case 'has any of':
        return cellLabels.some(function (labelId) {
          return value.includes(labelId);
        });
      case 'has none of':
        return value.every(function (labelId) {
          return !cellLabels.includes(labelId);
        });
      default:
        return true;
    }
  }
}
function processTypeMention(condition, cellData, value, editor) {
  var _cellData$child;
  var delta = cellData ? (_cellData$child = cellData.child) === null || _cellData$child === void 0 ? void 0 : _cellData$child.delta : false;
  var cellText = delta ? getTextFromDelta(editor, delta) : '';
  // если ввод меншена в ячейку был прерван, в ячейке остаётся символ @
  // поэтому считаем символ меншена пустой строкой
  if (['@', '@\n'].includes(cellText)) {
    cellText = '';
  }
  return processTypeText(condition, {
    child: {
      characters: cellText
    }
  }, value);
}
function processTypeCollaborator(condition, cellData, value) {
  var cellUsers = cellData ? cellData.users ? Object.keys(cellData.users) : [] : [];
  if (condition === 'empty') {
    return !Boolean(cellUsers.length);
  } else if (condition === 'not empty') {
    return Boolean(cellUsers.length);
  } else {
    if (!Boolean(value) || !Array.isArray(value) || !value.length) return true;
    if (!cellUsers.length) return false;
    switch (condition) {
      case 'has any of':
        return cellUsers.some(function (userId) {
          return value.includes(userId);
        });
      case 'has none of':
        return value.every(function (userId) {
          return !cellUsers.includes(userId);
        });
      default:
        return true;
    }
  }
}
function processTypeLink(condition, cellData, value) {
  var _cellData$child2, _cellData$child3;
  var cellText = (cellData ? ((_cellData$child2 = cellData.child) === null || _cellData$child2 === void 0 ? void 0 : _cellData$child2.characters) || '' : '').replace('\n', '');
  var cellLinks = cellData && (_cellData$child3 = cellData.child) !== null && _cellData$child3 !== void 0 && _cellData$child3.delta ? cellData.child.delta.reduce(function (links, op) {
    if (op.attributes && op.attributes.link) {
      links.push(op.attributes.link);
    }
    return links;
  }, []) : [];
  // возвращаем либо совпадение условия с текстом, либо если хотя бы одна из ссылок совпадает с условием
  // PS: тут массив ссылок наверно лишний, так как сейчас нет множественных ссылок, но вдруг в будущем будет
  var textRes = processTypeText(condition, {
    child: {
      characters: cellText
    }
  }, value);
  var linkRes = cellLinks.map(function (link) {
    return processTypeText(condition, {
      child: {
        characters: link
      }
    }, value);
  }).some(function (res) {
    return res === true;
  });
  if (condition !== 'is not' && condition !== 'contains not') {
    return textRes || linkRes;
  } else {
    return textRes && (linkRes || !cellLinks.length);
  }
}
function processTypeProgress(condition, cellData, value) {
  var filterValue = parseInt(value !== '' ? value : 0);
  if (typeof filterValue !== 'number' || isNaN(filterValue)) return true;
  var progress = typeof cellData === 'undefined' || typeof cellData.progress !== 'number' ? 0 : cellData.progress;
  switch (condition) {
    case '=':
      return progress === filterValue;
    case '≠':
      return progress !== filterValue;
    case '>':
      return progress > filterValue;
    case '<':
      return progress < filterValue;
    case '≥':
      return progress >= filterValue;
    case '≤':
      return progress <= filterValue;
    default:
      return true;
  }
}
function processTypeCheckbox(condition, cellData, value, editor, filters) {
  var filterValue = Boolean(value);
  if (filterValue === false && (!cellData || typeof cellData.checked === 'undefined' || !cellData.checked)) {
    return true;
  } else if (filterValue === true && cellData && cellData.checked) {
    return true;
  }
  return false;
}
function processTypeRating(condition, cellData, value, editor, filters, filter) {
  var _editor$store$getMap$, _editor$store$getMap$2;
  var typeData = getTypeData('rating');
  var maxAmount = ((_editor$store$getMap$ = editor.store.getMap(filter.colId).toJSON()) === null || _editor$store$getMap$ === void 0 ? void 0 : (_editor$store$getMap$2 = _editor$store$getMap$.format) === null || _editor$store$getMap$2 === void 0 ? void 0 : _editor$store$getMap$2.amount) || typeData.format.amount;
  var cellRating = cellData && typeof cellData.rating === 'number' && !isNaN(cellData.rating) ? cellData.rating > maxAmount ? maxAmount : cellData.rating : 0;
  var filterValue = parseInt(value);
  if (typeof filterValue !== 'number' || isNaN(filterValue)) return true;
  switch (condition) {
    case '=':
      return cellRating === filterValue;
    case '≠':
      return cellRating !== filterValue;
    case '>':
      return cellRating > filterValue;
    case '<':
      return cellRating < filterValue;
    case '≥':
      return cellRating >= filterValue;
    case '≤':
      return cellRating <= filterValue;
    default:
      return true;
  }
}
function processTypeDate(condition, cellData, value) {
  if (Boolean(value)) {
    if (!cellData || !cellData.timestamp) return false;
    var timestamp = getTimestampWithZeroTime(cellData.timestamp);
    if (typeof value === 'number') {
      return timestamp === value;
    } else {
      return value.start <= timestamp && value.end >= timestamp;
    }
  }
  return true;
}
function processCell(type, cellData, filters, operator, editor) {
  if (TYPE_ASSOC[type]) {
    var filtersResult = [];
    var _iterator = util_createForOfIteratorHelper(filters),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var filter = _step.value;
        filtersResult.push(TYPE_ASSOC[type](filter.condition, cellData, filter.value, editor, filters, filter));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (operator === 'And') {
      return filtersResult.every(function (res) {
        return res === true;
      });
    } else {
      return filtersResult.some(function (res) {
        return res === true;
      });
    }
  }
  return true;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/hooks/useFilter.js
function useFilter_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { useFilter_typeof = function _typeof(obj) { return typeof obj; }; } else { useFilter_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return useFilter_typeof(obj); }













function useFilter_slicedToArray(arr, i) { return useFilter_arrayWithHoles(arr) || useFilter_iterableToArrayLimit(arr, i) || useFilter_unsupportedIterableToArray(arr, i) || useFilter_nonIterableRest(); }
function useFilter_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function useFilter_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return useFilter_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useFilter_arrayLikeToArray(o, minLen); }
function useFilter_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function useFilter_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function useFilter_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }






function UseFilter(_ref) {
  var _this = this;
  var editor = _ref.editor,
    data = _ref.data,
    tableExec = _ref.tableExec,
    useRefs = _ref.useRefs,
    useSelection = _ref.useSelection;
  var _useState = (0,hooks_module/* useState */.eJ)(null),
    _useState2 = useFilter_slicedToArray(_useState, 2),
    filterState = _useState2[0],
    setFilterState = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)({}),
    _useState4 = useFilter_slicedToArray(_useState3, 2),
    filterProps = _useState4[0],
    setFilterProps = _useState4[1];
  var _useState5 = (0,hooks_module/* useState */.eJ)({}),
    _useState6 = useFilter_slicedToArray(_useState5, 2),
    filterParams = _useState6[0],
    setFilterParams = _useState6[1];
  var toggleFilter = function toggleFilter(col) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!filterState) {
      useSelection.unselectAll();
      showFilter(col, params);
    } else {
      setFilterState(false);
    }
  };
  var showFilter = function showFilter(col, params) {
    var _useRefs$links$ui$cir, _useRefs$links, _useRefs$links$ui, _useRefs$links$ui$tab;
    var anchor = params.anchorCol !== 'undefined' && useRefs.links.col[params.anchorCol] ? useRefs.links.col[params.anchorCol].getNode() : (_useRefs$links$ui$cir = useRefs.links.ui.circle) === null || _useRefs$links$ui$cir === void 0 ? void 0 : _useRefs$links$ui$cir.getNode();
    var tableNode = (_useRefs$links = useRefs.links) === null || _useRefs$links === void 0 ? void 0 : (_useRefs$links$ui = _useRefs$links.ui) === null || _useRefs$links$ui === void 0 ? void 0 : (_useRefs$links$ui$tab = _useRefs$links$ui.table) === null || _useRefs$links$ui$tab === void 0 ? void 0 : _useRefs$links$ui$tab.getNode();
    if (tableNode) {
      var _tableNode$closest;
      var _tableNode$getBoundin = tableNode.getBoundingClientRect(),
        top = _tableNode$getBoundin.top;
      var contentRect = editor.getScrollingContainer().getBoundingClientRect();
      var tableId = (_tableNode$closest = tableNode.closest('.table-blot')) === null || _tableNode$closest === void 0 ? void 0 : _tableNode$closest.id;
      if (top > contentRect.bottom - (contentRect.bottom - contentRect.top) / 3 || contentRect.bottom - top < 250) {
        if (tableId) {
          editor.plugins.scrollSaver.scrollToBlot(tableId);
        }
      }
    }
    setFilterParams({
      anchor: anchor
    });
    prepareAndSetFilterProps(col);
    setFilterState(true);
  };
  var prepareAndSetFilterProps = function prepareAndSetFilterProps(col) {
    var _data$props;
    var initFilters = ((_data$props = data.props) === null || _data$props === void 0 ? void 0 : _data$props.filter) || {
      operator: 'Or',
      filters: []
    };
    var operator = initFilters.operator,
      filters = initFilters.filters;
    var columnsData = [];
    var initialColumn = null;
    for (var i = 0; i < useRefs.links.col.length; i++) {
      var column = useRefs.links.col[i];
      var colData = column.colData;
      if (colData && colData.columnType && colData.columnType !== 'none') {
        var _getTypeData;
        if ((typeof col === 'number' || typeof col === 'string') && i === parseInt(col)) {
          initialColumn = colData.id;
        }
        var param = {
          colId: colData.id // так как сейчас фильтры могут работать только для колонок, которые имеют конкретный тип, можно брать из data
        };

        if (colData.text) {
          param.colName = colData.text;
        } else {
          param.colName = column.getNode().innerText;
        }
        if ((colData.columnType === 'singleselect' || colData.columnType === 'multiselect') && colData.dbSelect) {
          param.dbSelect = colData.dbSelect;
        }
        if (colData.columnType === 'collaborator') {
          var users = {};
          for (var rowIndex in data.rowsData) {
            var cellData = data.rowsData[rowIndex].cellsData[i];
            if (cellData && cellData.users) {
              for (var _i2 = 0, _Object$keys = Object.keys(cellData.users); _i2 < _Object$keys.length; _i2++) {
                var userId = _Object$keys[_i2];
                if (!users[userId]) {
                  users[userId] = cellData.users[userId];
                }
              }
            }
          }
          if (Object.keys(users).length) {
            param.users = users;
          }
        }
        param.conditions = (_getTypeData = getTypeData(colData.columnType)) === null || _getTypeData === void 0 ? void 0 : _getTypeData.filterConditions;
        param.type = colData.columnType;
        param.colIndex = col;
        columnsData.push(param);
      }
    }
    setFilterProps({
      operator: operator,
      filters: filters,
      columnsData: columnsData,
      initialColumn: initialColumn
    });
  };
  var closeFilter = function closeFilter() {
    setFilterProps({});
    setFilterParams({});
    setFilterState(false);
  };
  var onFilterChange = function onFilterChange(value) {
    if (value) {
      var operator = value.operator,
        filters = value.filters;
      var toChange = value ? filters.reduce(function (res, filter) {
        if (filter.condition === 'empty' || filter.condition === 'not empty') {
          res.push(filter);
        } else if (typeof filter.value === 'boolean' || typeof filter.value === 'number') {
          res.push(filter);
        } else if (useFilter_typeof(filter.value) === 'object' && Object.keys(filter.value).length) {
          res.push(filter);
        } else if (typeof filter.value === 'string') {
          if (filter.value !== '') {
            res.push(filter);
          } else if (filter.type === 'checkbox') {
            filter.value = false;
            res.push(filter);
          } else if (filter.type === 'progress') {
            filter.value = 0;
            res.push(filter);
          }
        }
        return res;
      }, []) : null;
      if (!toChange.length) {
        var _data$props2;
        if ((_data$props2 = data.props) !== null && _data$props2 !== void 0 && _data$props2.filter) {
          tableExec('filter', {
            filter: null
          });
        }
      } else {
        tableExec('filter', {
          filter: {
            operator: operator,
            filters: toChange
          }
        });
      }
    } else {
      tableExec('filter', {
        filter: null
      });
    }
  };
  var onChangeView = function onChangeView(value) {
    tableExec('filter-disabled', {
      disabled: !value
    });
  };
  var debouncedOnFilterChange = lodash_debounce_default()(onFilterChange, 500, {
    trailing: true
  });
  var getFilter = function getFilter() {
    var filterNode = null;
    if (filterState) {
      filterNode = (0,preact_module.h)(TableFilterComponent, {
        key: "table-filter-component",
        filterProps: filterProps,
        onChange: debouncedOnFilterChange,
        onChangeView: onChangeView,
        filterDisabled: Boolean(data.props['filter-disabled']),
        editor: editor,
        useRefs: useRefs,
        anchorNode: filterParams.anchor,
        anchorOptions: {
          placement: 'top-start',
          priority: ['right', 'left', 'top'],
          positionFixed: true,
          offset: '10px, -30px',
          boundariesElement: editor.getScrollingContainer(),
          overflowBoundariesElement: editor.getScrollingContainer()
        },
        wantsToClose: closeFilter.bind(_this)
      });
    }
    return filterNode;
  };
  var getFiltersById = function getFiltersById(id) {
    var filters = data.props.filter.filters;
    if (filters && id) {
      var colFilters = filters.filter(function (filter) {
        return filter.colId === id;
      });
      if (colFilters.length) {
        return colFilters;
      }
    }
    return false;
  };
  var acceptRenderRow = function acceptRenderRow() {
    var _data$props3;
    var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var length = arguments.length > 1 ? arguments[1] : undefined;
    if ((_data$props3 = data.props) !== null && _data$props3 !== void 0 && _data$props3.filter) {
      var _row$cellsData = row.cellsData,
        cellsData = _row$cellsData === void 0 ? {} : _row$cellsData;
      var operator = data.props.filter.operator;
      var result = [];
      for (var colIndex = 0; colIndex < length; colIndex++) {
        var colData = data.colsData[colIndex];
        var colFilters = getFiltersById(colData === null || colData === void 0 ? void 0 : colData.id);
        if (!colFilters) {
          continue;
        } else {
          result.push(processCell(colData === null || colData === void 0 ? void 0 : colData.columnType, cellsData[colIndex], colFilters, operator, editor));
        }
      }
      if (operator === 'And') {
        return result.every(function (res) {
          return res === true;
        });
      } else {
        return result.some(function (res) {
          return res === true;
        });
      }
    }
    return true;
  };
  return {
    getFilter: getFilter,
    showFilter: showFilter,
    toggleFilter: toggleFilter,
    acceptRenderRow: acceptRenderRow
  };
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/components/tableComponent.js











function tableComponent_slicedToArray(arr, i) { return tableComponent_arrayWithHoles(arr) || tableComponent_iterableToArrayLimit(arr, i) || tableComponent_unsupportedIterableToArray(arr, i) || tableComponent_nonIterableRest(); }
function tableComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tableComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tableComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tableComponent_arrayLikeToArray(o, minLen); }
function tableComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function tableComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function tableComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }















var count = {
  N: 1,
  M: 1
};
var TableContext = (0,preact_module/* createContext */.kr)({});
function TableComponent(_ref) {
  var editor = _ref.editor,
    bench = _ref.bench,
    version = _ref.version,
    editable = _ref.editable,
    data = _ref.data,
    setProp = _ref.setProp,
    applyDelta = _ref.applyDelta,
    startEdit = _ref.startEdit,
    _ref$globalConfig = _ref.globalConfig,
    globalConfig = _ref$globalConfig === void 0 ? {} : _ref$globalConfig,
    tableExec = _ref.tableExec,
    onTableAction = _ref.onTableAction,
    setOnAction = _ref.setOnAction,
    setOnKeyDown = _ref.setOnKeyDown,
    setTableContext = _ref.setTableContext,
    onTableRenderComponent = _ref.onTableRenderComponent,
    renderWithFilter = _ref.renderWithFilter;
  var i18n = editor.plugins.i18n;
  var useRefs = useRefsHook({
    version: version,
    data: data
  });
  var useUtils = UseUtils({
    useRefs: useRefs
  });
  var useResize = UseResize({
    useRefs: useRefs
  });
  var useSelection = UseSelection({
    editor: editor,
    version: version,
    data: data,
    useRefs: useRefs,
    useUtils: useUtils,
    tableExec: tableExec,
    renderWithFilter: renderWithFilter
  });
  var useFilter = UseFilter({
    editor: editor,
    data: data,
    tableExec: tableExec,
    useRefs: useRefs,
    useSelection: useSelection
  });
  var useMenu = UseMenu({
    editor: editor,
    data: data,
    tableExec: tableExec,
    onTableAction: onTableAction,
    useRefs: useRefs,
    useSelection: useSelection,
    useFilter: useFilter
  });
  var useAction = UseAction({
    data: data,
    editable: editable,
    tableExec: tableExec,
    setOnAction: setOnAction,
    useRefs: useRefs,
    useSelection: useSelection,
    useUtils: useUtils,
    useMenu: useMenu
  });
  UseKeyboard({
    editable: editable,
    setOnKeyDown: setOnKeyDown,
    useRefs: useRefs,
    useSelection: useSelection,
    data: data,
    tableExec: tableExec
  });
  var _useState = (0,hooks_module/* useState */.eJ)(false),
    _useState2 = tableComponent_slicedToArray(_useState, 2),
    floatContent = _useState2[0],
    setFloatContent = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(false),
    _useState4 = tableComponent_slicedToArray(_useState3, 2),
    movingContent = _useState4[0],
    setMovingContent = _useState4[1];
  var tableRef = (0,hooks_module/* useRef */.sO)(null);
  var getNode = function getNode() {
    return tableRef === null || tableRef === void 0 ? void 0 : tableRef.current;
  };
  var setState = function setState(key, value) {
    if (key === 'float') {
      setFloatContent(value ? true : false);
    } else if (key === 'moving') {
      setMovingContent(value ? true : false);
    }
  };
  useRefs.setUI('table', {
    getNode: getNode.bind(this),
    setState: setState.bind(this)
  });
  var classes = ['table-component'];
  if (editable) {
    classes.push('editable');
  }
  if (useResize.resize.session) {
    classes.push('resizing');
  }
  if (data.settings.rowHeadings === false) {
    classes.push('hide-row-header');
  }
  if (data.settings.colHeadings === false) {
    classes.push('hide-col-header');
  }
  if (data.settings.wrapCells === false) {
    classes.push('cells-nowrap');
  }
  if (floatContent) {
    classes.push('float-content');
  }
  if (movingContent) {
    classes.push('moving-content');
  }

  /* Применяем фильтр к строкам если он есть.
  В будущем нужно сразу передать этот массив в компонент TableBody, чтобы не применять фильтр 2 раза,
  сейчас это нужно для того, чтобы правильно работал summary */
  if (!Boolean(data.props['filter-disabled'])) {
    var visibleRows = [];
    for (var row = 0; row < data.size.rows; row++) {
      if (useFilter.acceptRenderRow(data.rowsData[row], data.size.cols) || data.rowsData[row] && data.props.tempRow && data.props.tempRow === data.rowsData[row].id) {
        visibleRows.push(data.rowsData[row]);
      }
    }
    data.size.visibleRows = visibleRows.length;
  } else {
    data.size.visibleRows = data.size.rows;
  }
  if (data.size.rows !== data.size.visibleRows) {
    useRefs.links.row = [];
    useRefs.links.cell = [];
  }
  // handle from props function onTableRenderComponent
  onTableRenderComponent(function (tableBodyEmbed) {
    var tableBlot = tableBodyEmbed.tableBlot;
    if (!data.size.visibleRows) {
      if (!tableBlot.domNode.classList.contains('all-records-filtered')) {
        tableBlot.domNode.classList.add('all-records-filtered');
      }
    } else {
      if (tableBlot.domNode.classList.contains('all-records-filtered')) {
        tableBlot.domNode.classList.remove('all-records-filtered');
      }
    }
  });

  // console.info('Table render #', count.N++, classes, version)
  var tableChildren = (0,hooks_module/* useMemo */.Ye)(function () {
    console.info('Render table children (MEMO) #', count.M++);
    return (0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)(TableHeadComponent, null), (0,preact_module.h)(TableBodyComponent, {
      data: data
    }), (0,preact_module.h)(TableFootComponent, {
      size: data.size
    }));
  }, [version]);
  return (0,preact_module.h)(TableContext.Provider, {
    value: {
      i18n: i18n,
      bench: bench,
      editor: editor,
      editable: editable,
      setProp: setProp,
      applyDelta: applyDelta,
      startEdit: startEdit,
      tableExec: tableExec,
      onTableAction: onTableAction,
      globalConfig: globalConfig,
      renderWithFilter: renderWithFilter,
      data: data,
      useRefs: useRefs,
      useMenu: useMenu,
      useUtils: useUtils,
      useAction: useAction,
      useResize: useResize,
      useSelection: useSelection,
      useFilter: useFilter
    }
  }, (0,preact_module.h)(TableScrollComponent, {
    size: data.size,
    settings: data.settings,
    setTableContext: setTableContext
  }, (0,preact_module.h)("table", {
    ref: tableRef,
    className: classes.join(' ')
  }, editable && globalConfig.enableMenu !== false ? (0,preact_module.h)(TableMenuButtonCell, null) : null, tableChildren)), useMenu.getMenu(), useFilter.getFilter());
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/tableBodyEmbed.js
function tableBodyEmbed_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { tableBodyEmbed_typeof = function _typeof(obj) { return typeof obj; }; } else { tableBodyEmbed_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return tableBodyEmbed_typeof(obj); }





















function tableBodyEmbed_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function tableBodyEmbed_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function tableBodyEmbed_createClass(Constructor, protoProps, staticProps) { if (protoProps) tableBodyEmbed_defineProperties(Constructor.prototype, protoProps); if (staticProps) tableBodyEmbed_defineProperties(Constructor, staticProps); return Constructor; }
function tableBodyEmbed_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) tableBodyEmbed_setPrototypeOf(subClass, superClass); }
function tableBodyEmbed_setPrototypeOf(o, p) { tableBodyEmbed_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return tableBodyEmbed_setPrototypeOf(o, p); }
function tableBodyEmbed_createSuper(Derived) { var hasNativeReflectConstruct = tableBodyEmbed_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = tableBodyEmbed_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = tableBodyEmbed_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return tableBodyEmbed_possibleConstructorReturn(this, result); }; }
function tableBodyEmbed_possibleConstructorReturn(self, call) { if (call && (tableBodyEmbed_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return tableBodyEmbed_assertThisInitialized(self); }
function tableBodyEmbed_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function tableBodyEmbed_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function tableBodyEmbed_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { tableBodyEmbed_get = Reflect.get; } else { tableBodyEmbed_get = function _get(target, property, receiver) { var base = tableBodyEmbed_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return tableBodyEmbed_get(target, property, receiver || target); }
function tableBodyEmbed_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = tableBodyEmbed_getPrototypeOf(object); if (object === null) break; } return object; }
function tableBodyEmbed_getPrototypeOf(o) { tableBodyEmbed_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return tableBodyEmbed_getPrototypeOf(o); }
function tableBodyEmbed_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var TableBodyEmbed = /*#__PURE__*/function (_BlockEmbed) {
  tableBodyEmbed_inherits(TableBodyEmbed, _BlockEmbed);
  var _super = tableBodyEmbed_createSuper(TableBodyEmbed);
  function TableBodyEmbed(domNode) {
    var _this;
    tableBodyEmbed_classCallCheck(this, TableBodyEmbed);
    _this = _super.call(this, domNode);
    tableBodyEmbed_defineProperty(tableBodyEmbed_assertThisInitialized(_this), "updateHeaderPos", function () {
      var thead = _this.domNode.querySelector('thead');
      var table = _this.tableBlot.domNode;
      var container = _this.editor.getScrollingContainer();
      var lastRow = _this.domNode.querySelector('tbody tr:last-child');
      var OFFSET = _this.tableBlot.blotConfig.floatingHeaderOffset ? parseInt(_this.tableBlot.blotConfig.floatingHeaderOffset) : 0;
      if (thead && container) {
        var containerRect = container.getBoundingClientRect();
        var tableRect = table.getBoundingClientRect();
        var theadRect = thead.getBoundingClientRect();
        var lastRowRect = lastRow.getBoundingClientRect();
        var htop = containerRect.y + OFFSET - tableRect.y;
        if (htop < 0) {
          htop = 0;
        } else if (lastRowRect.y - theadRect.height < containerRect.top + OFFSET) {
          htop = lastRowRect.y - tableRect.y - theadRect.height;
        }
        var prevHtop = thead.getAttribute('data-htop') || 0;
        if (parseInt(prevHtop) > htop) {
          if (!thead.classList.contains('disabled-transition')) {
            thead.classList.add('disabled-transition');
          }
        } else {
          if (thead.classList.contains('disabled-transition')) {
            thead.classList.remove('disabled-transition');
          }
        }
        thead.setAttribute('style', "--htop:".concat(htop, "px;"));
        thead.setAttribute('data-htop', htop);
      }
    });
    tableBodyEmbed_defineProperty(tableBodyEmbed_assertThisInitialized(_this), "onTableRenderComponent", function (fn) {
      if (typeof fn === 'function') {
        fn(tableBodyEmbed_assertThisInitialized(_this));
      }
    });
    _this.domNode.classList.add('table-embed');
    return _this;
  }
  tableBodyEmbed_createClass(TableBodyEmbed, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = tableBodyEmbed_get(tableBodyEmbed_getPrototypeOf(TableBodyEmbed.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      this.version = 0;
      this.currentCell = null;
      this.mapToObject({
        render: true
      });
      this.editor.on('editorUpdate', this.updateHeaderPos);
      this.editor.getScrollingContainer().addEventListener('scroll', this.updateHeaderPos, false);
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = tableBodyEmbed_get(tableBodyEmbed_getPrototypeOf(TableBodyEmbed.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      this.editor.off('editorUpdate', this.updateHeaderPos);
      this.editor.getScrollingContainer().removeEventListener('scroll', this.updateHeaderPos, false);
    }
  }, {
    key: "_clearData",
    value: function _clearData() {
      this.table = {};
      this.index = {
        cell: {},
        child: {}
      };
    }
  }, {
    key: "tableBlot",
    get: function get() {
      return this.parent;
    }
  }, {
    key: "editable",
    get: function get() {
      return !this.tableBlot.isBlotLocked && this.editor.mode === MODE_EDIT;
    }
  }, {
    key: "getWrappedBlot",
    value: function getWrappedBlot() {
      return this.tableBlot;
    }

    /**
     * Конвертирует данные map таблицы в объект this.table
     * @param { object } options?
     * @param { boolean } options.mode?: тип обновления, позволяет ускорить обработку
     *                  options.mode = full: полное обновление, по умолчанию
     *                  options.mode = table: корневые данные таблицы (size, настройки), без перебора строк, столбцов и ячеек
     *                  options.mode = rows: обновить данные строк, без содержимого
     *                  options.mode = cols: обновить корневые данные колонок, без содержимого
     *                  options.mode = cols_cells: обновить данные колонок и ячейки в них
     * @param { object } options.start?: обновляемые поизции ( совместно с mode=row/col)
     * @param { object } options.last?: обновляемые поизции ( совместно с mode=row/col)
     * @param { boolean } options.render?: вызывает полный рендер таблицы, после обновления данных
     * @param { boolean } options.fastRender?: вызывает быстрый рендер затронутых компонентов, после обновления данных
     * @param { boolean } options.withAllCells?: передается в fastRender
     * @param { boolean } options.withSummary?: передается в fastRender
     */
  }, {
    key: "mapToObject",
    value: function mapToObject() {
      var _this2 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.mode) {
        options.mode = 'full';
      }
      if (options.start) {
        if (!options.last) {
          options.last = {};
        }
        if (!options.last.hasOwnProperty('row') && options.start.hasOwnProperty('row')) {
          options.last.row = options.start.row;
        }
        if (!options.last.hasOwnProperty('col') && options.start.hasOwnProperty('col')) {
          options.last.col = options.start.col;
        }
      }
      var bench = this.tableBlot.bench;
      var mark = bench.mark('Embed mapToObject');
      var table = this.map.toJSON();
      var update = {
        table: options.mode === 'full' || options.mode === 'table',
        rows: options.mode === 'full' || options.mode === 'rows' || options.mode === 'cols_cells',
        cols: options.mode === 'full' || options.mode === 'cols' || options.mode === 'cols_cells'
      };
      if (options.mode === 'full') {
        this._clearData();
        this.table = {
          colsData: {},
          rowsData: {}
        };
      }
      if (update.cols) {
        var _table$columns;
        if ((_table$columns = table.columns) !== null && _table$columns !== void 0 && _table$columns.length) {
          var _options$start, _options$last;
          var from = options.mode === 'full' ? 0 : ((_options$start = options.start) === null || _options$start === void 0 ? void 0 : _options$start.col) || 0;
          var to = options.mode === 'full' ? table.columns.length - 1 : ((_options$last = options.last) === null || _options$last === void 0 ? void 0 : _options$last.col) || table.columns.length - 1;
          for (var col = from; col <= to; col++) {
            var colId = table.columns[col];
            if (colId) {
              var colMap = this.store.getMap(colId);
              var colData = colMap ? colMap.toJSON() : {};
              if (colData.summaries) {
                colData.summary = colData.summaries[0];
              }
              if (colData.hasOwnProperty('dbSelect')) {
                colData.dbSelect = parseObject('object', colData.dbSelect);
              }
              this.table.colsData[col] = colData;
            }
          }
        }
      }
      if (update.rows) {
        var _table$rows;
        if ((_table$rows = table.rows) !== null && _table$rows !== void 0 && _table$rows.length) {
          var _options$start2, _options$last2;
          var _from = options.mode === 'full' ? 0 : ((_options$start2 = options.start) === null || _options$start2 === void 0 ? void 0 : _options$start2.row) || 0;
          var _to = options.mode === 'full' ? table.rows.length - 1 : ((_options$last2 = options.last) === null || _options$last2 === void 0 ? void 0 : _options$last2.row) || table.rows.length - 1;
          var _loop = function _loop(row) {
            var rowId = table.rows[row];
            if (rowId) {
              var _rowData$children;
              var rowMap = _this2.store.getMap(rowId);
              var rowData = rowMap ? rowMap.toJSON() : {};
              rowData.cellsData = {};
              _this2.table.rowsData[row] = rowData;
              if ((_rowData$children = rowData.children) !== null && _rowData$children !== void 0 && _rowData$children.length) {
                rowData.children.forEach(function (cellId, col) {
                  if (cellId) {
                    _this2.fillCellData({
                      row: row,
                      col: col
                    }, cellId);
                  }
                });
              }
            }
          };
          for (var row = _from; row <= _to; row++) {
            _loop(row);
          }
        }
      }
      if (update.table) {
        if (table.hasOwnProperty('size')) {
          this.table.size = table.size;
        } else {
          // Table V1
          this.table.size = {
            cols: table.columns.length,
            rows: table.rows.length
          };
        }
        this.table.settings = {};
        for (var name in CONFIG.table.settings) {
          var prop = CONFIG.table.settings[name];
          if (table.hasOwnProperty(prop.key)) {
            this.table.settings[name] = table[prop.key];
          } else {
            this.table.settings[name] = prop.default || false;
          }
        }
        this.table.props = {};
        var props = ['sortableColumn', 'filter', 'filter-disabled'];
        for (var _i = 0, _props = props; _i < _props.length; _i++) {
          var _prop = _props[_i];
          if (table.hasOwnProperty(_prop)) {
            this.table.props[_prop] = table[_prop];
          }
        }
        if (this.tableBlot.props.tempRow) {
          this.table.props.tempRow = this.tableBlot.props.tempRow;
        }
      }
      //console.info('DATA', this.table)

      bench.measure(mark);
      var fullRender = options.render && !options.fastRender;
      if (options.fastRender) {
        var mode;
        if (update.rows && !update.cols) {
          mode = 'rows';
        } else if (update.cols && !update.rows) {
          mode = 'cols';
        }
        if (mode && options.start) {
          this.fastRender(mode, options.start, options.last, {
            withAllCells: options.withAllCells,
            withSummary: options.withSummary
          });
        } else {
          fullRender = true;
        }
      }
      if (fullRender) {
        this.render();
      }
      this.tableBlot.updateCommentsCounters();
    }

    /**
     * Заполнить данные ячейки
     * @param { object } pos: позиция ячейки
     * @param { number }  pos.col: колонка
     * @param { number }  pos.row: строка
     * @param { string } cellId?: id ячейки, если не передан то пытается получить из this.table
     * @param { object } options?
     * @param { boolean } options.render?: вызывает fastRender после обновления данных ячейки
     * @param { boolean } options.withSummary?: при render=true передается в функцию fastRender
     */
  }, {
    key: "fillCellData",
    value: function fillCellData() {
      var _cellData$children;
      var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var cellId = arguments.length > 1 ? arguments[1] : undefined;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!cellId) {
        var _this$table$rowsData, _this$table$rowsData$, _this$table$rowsData$2, _this$table$rowsData$3;
        cellId = (_this$table$rowsData = this.table.rowsData) === null || _this$table$rowsData === void 0 ? void 0 : (_this$table$rowsData$ = _this$table$rowsData[pos.row]) === null || _this$table$rowsData$ === void 0 ? void 0 : (_this$table$rowsData$2 = _this$table$rowsData$.cellsData) === null || _this$table$rowsData$2 === void 0 ? void 0 : (_this$table$rowsData$3 = _this$table$rowsData$2[pos.col]) === null || _this$table$rowsData$3 === void 0 ? void 0 : _this$table$rowsData$3.id;
      }
      if (!cellId) {
        console.warn('cellId is', tableBodyEmbed_typeof(cellId));
        return false;
      }
      if (!this.table.rowsData[pos.row]) {
        this.mapToObject({
          mode: 'rows',
          start: pos
        });
      }
      var cellMap = this.store.getMap(cellId);
      var cellData = cellMap.toJSON();
      //const pos = cellData.hasOwnProperty(pos) ? cellData[pos] : i
      if ((_cellData$children = cellData.children) !== null && _cellData$children !== void 0 && _cellData$children.length) {
        this.index.child[cellData.children[0]] = pos;
        var childMap = this.store.getMap(cellData.children[0]);
        if (childMap) {
          cellData.child = childMap.toJSON();
          // Получение дельты замедляет
          //if ((cellData.child.hasOwnProperty('characters') && cellData.child.characters.length > 1) || cellData.type === 'tableCellMention') {
          if (cellData.child.hasOwnProperty('characters')) {
            var delta = childMap.get('characters').toDelta();
            cellData.child.delta = delta;
          }
        }
      }
      this.table.rowsData[pos.row].cellsData[pos.col] = cellData;
      this.index.cell[cellId] = pos;
      if (options.render) {
        this.fastRender('cells', pos, pos, {
          withSummary: options.withSummary
        });
      }
      return cellData;
    }

    /**
     * Обновить ячейку по map id
     * @param {string} id
     * @param {string}? type: тип id cell / child
     * @return {boolean} если id найден в индексе позиций то true, иначе false
     */
  }, {
    key: "updateCellById",
    value: function updateCellById(id) {
      var _this$index$type;
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cell';
      if ((_this$index$type = this.index[type]) !== null && _this$index$type !== void 0 && _this$index$type.hasOwnProperty(id)) {
        this.fillCellData(this.index[type][id]);
        return true;
      }
      return false;
    }

    /**
     * Возвращает mapId
     * Если map не создан, то создает его и добавляет в структуру таблицы
     * @param {string} type: тип (row, col, cell, child)
     * @param {object} pos: позиция
     * @param {object} pos.row?: строка
     * @param {object} pos.col?: колонка
     * @param {object} options: дополнительные параметры
     * @param {object} options: дополнительные параметры
     * @return {string} mapId
     */
  }, {
    key: "getOrCreateMapId",
    value: function getOrCreateMapId(type, pos) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var mapId;
      var updOptions = {
        mode: 'rows',
        start: pos,
        render: false,
        fastRender: false
      };
      if (type === 'col') {
        var _this$table$colsData, _this$table$colsData$;
        updOptions.mode = 'full';
        updOptions.render = true;
        mapId = (_this$table$colsData = this.table.colsData) === null || _this$table$colsData === void 0 ? void 0 : (_this$table$colsData$ = _this$table$colsData[pos.col]) === null || _this$table$colsData$ === void 0 ? void 0 : _this$table$colsData$.id;
      } else if (type === 'row') {
        var _this$table$rowsData2, _this$table$rowsData3;
        updOptions.render = true;
        mapId = (_this$table$rowsData2 = this.table.rowsData) === null || _this$table$rowsData2 === void 0 ? void 0 : (_this$table$rowsData3 = _this$table$rowsData2[pos.row]) === null || _this$table$rowsData3 === void 0 ? void 0 : _this$table$rowsData3.id;
      } else if (type === 'cell') {
        var _this$table$rowsData4, _this$table$rowsData5, _this$table$rowsData6, _this$table$rowsData7;
        updOptions.fastRender = true;
        mapId = (_this$table$rowsData4 = this.table.rowsData) === null || _this$table$rowsData4 === void 0 ? void 0 : (_this$table$rowsData5 = _this$table$rowsData4[pos.row]) === null || _this$table$rowsData5 === void 0 ? void 0 : (_this$table$rowsData6 = _this$table$rowsData5.cellsData) === null || _this$table$rowsData6 === void 0 ? void 0 : (_this$table$rowsData7 = _this$table$rowsData6[pos.col]) === null || _this$table$rowsData7 === void 0 ? void 0 : _this$table$rowsData7.id;
      } else if (type === 'child') {
        var _this$table$rowsData8, _this$table$rowsData9, _this$table$rowsData10, _this$table$rowsData11, _this$table$rowsData12;
        updOptions.fastRender = true;
        mapId = (_this$table$rowsData8 = this.table.rowsData) === null || _this$table$rowsData8 === void 0 ? void 0 : (_this$table$rowsData9 = _this$table$rowsData8[pos.row]) === null || _this$table$rowsData9 === void 0 ? void 0 : (_this$table$rowsData10 = _this$table$rowsData9.cellsData) === null || _this$table$rowsData10 === void 0 ? void 0 : (_this$table$rowsData11 = _this$table$rowsData10[pos.col]) === null || _this$table$rowsData11 === void 0 ? void 0 : (_this$table$rowsData12 = _this$table$rowsData11.child) === null || _this$table$rowsData12 === void 0 ? void 0 : _this$table$rowsData12.id;
      }
      if (!mapId) {
        console.info('Create map', type, pos, options);
        mapId = this.tableBlot.createInnerMap(type, pos);
        if (options.render) {
          this.mapToObject(updOptions);
        }
      }
      return mapId;
    }

    /**
     * Устанавливает значение в блот
     * @param { string } key: ключ
     * @param { any } value: значение, если null то ключ будет удален из map
     * @param { object } options
     * @param { object }   options.pos: позиция
     * @param { string }   options.type: тип блока: column / row / cell / child
     * @param { string }   options.yArray?: дублирует значение массива value как yArray в соответствующий ключ
     */
  }, {
    key: "setProp",
    value: function setProp(key, value) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      console.info('setProp', key, value, options);
      if (!this.editable) {
        console.info('return');
        return false;
      }
      var mapId = this.getOrCreateMapId(options.type, options.pos, {
        render: true
      });
      var map = this.store.getMap(mapId);
      if (map) {
        if (value === null) {
          map.delete(key);
        } else {
          map.set(key, value);
          if (options.yArray && tableBodyEmbed_typeof(value) === 'object') {
            var yArray = new this.store.types.Array();
            yArray.push(value);
            map.set(options.yArray, yArray);
          }
        }
        var withSummary;
        switch (options.type) {
          case "col":
            var withAllCells = CONFIG.col.updateCells.includes(key);
            withSummary = CONFIG.col.updateSummary.includes(key);
            this.mapToObject({
              mode: 'cols',
              /*start:options.pos,*/fastRender: true,
              withAllCells: withAllCells,
              withSummary: withSummary
            });
            break;
          case "row":
            this.mapToObject({
              mode: 'rows',
              render: true
            });
            break;
          case "cell":
            withSummary = CONFIG.cell.updateSummary.includes(key);
            this.fillCellData(options.pos, false, {
              render: true,
              withSummary: withSummary
            });
            break;
        }
      } else {
        console.warn('map not found', mapId, options);
      }
      if (!['width', 'height', 'title'].includes(key)) {
        var _options$pos;
        // Для миграции V1 -> V2, позже можно удалить
        this.tableBlot.ensureNewRowType(((_options$pos = options.pos) === null || _options$pos === void 0 ? void 0 : _options$pos.row) || 0);
      }
    }

    /**
     * Устанавливает дельту в child map ячейки
     * @param { delta } delta
     * @param { object } options
     * @param { object }  options.pos: позиция ячейки
     * @param { boolean } options.replace: заменить имеющуюся дельту
     */
  }, {
    key: "applyDelta",
    value: function applyDelta(delta) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this.editable) {
        return false;
      }
      var mapId = this.getOrCreateMapId('child', options.pos, {
        render: true
      });
      var map = this.store.getMap(mapId);
      if (map) {
        if (map.has('characters')) {
          var setDelta;
          if (options.replace) {
            var currentDelta = new (Delta_default())(map.get('characters').toDelta());
            setDelta = currentDelta.diff(new (Delta_default())(delta));
          } else {
            setDelta = new (Delta_default())(delta);
          }
          map.get('characters').applyDelta(setDelta.ops);
        }
        this.fillCellData(options.pos, false, {
          render: true,
          withSummary: true
        });
      } else {
        console.warn('map not found', mapId, options);
      }
    }

    /**
     * Запуск редактирования ячейки
     * @param { object } options
     * @param { object }   options.pos: позиция ячейки в таблице
     * @param { object }   options.style: форматирование ячейки
     * @param { object }   options.cellData: данные ячейки
     * @param { node }    options.node: нода компонента ячейки
     * @param { event }    options.event: событие вызвавшее начало редактирования
     * @param { function } options.endEdit: функция, вызываемая при завершении редактирования
     */
  }, {
    key: "startEdit",
    value: function startEdit() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var childId = this.getOrCreateMapId('child', options.pos, {
        render: true
      });
      this.currentCell = options;
      return this.tableBlot.tableBlotEditCell.startEdit(childId, options);
    }

    /**
     * Завершение редактирования ячейки
     * @param { any } options
     */
  }, {
    key: "endEdit",
    value: function endEdit(options) {
      var _this$currentCell = this.currentCell,
        pos = _this$currentCell.pos,
        cellData = _this$currentCell.cellData,
        endEdit = _this$currentCell.endEdit;
      var selectionScroller = this.editor.plugins.selectionScroller;
      this.fillCellData(pos, cellData.id);
      this.render();
      endEdit && endEdit(options);
      selectionScroller === null || selectionScroller === void 0 ? void 0 : selectionScroller.ignoreNextSelectionChange();
    }

    /**
     * Быстрый повторный рендер вложенных компонентов таблицы
     * @param { string } mode: Тип вложенного компонента - cells, rows, cols, cols_cells, summary
     * @param { object } start: {row, col} - Стартовая позиция
     * @param { object } last?: {row, cols} - Конечная позиция, при рендере нескольких компонентов
     * @param { options } options?
     * @param { boolean } options.withAllCells? - Для mode=col|row, обновить вложенные ячейки
     * @param { boolean } options.withSummary? - Для mode=cell, обновить summary после рендера
     */
  }, {
    key: "fastRender",
    value: function fastRender(mode) {
      var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var last = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var _options$withSummary = options.withSummary,
        withSummary = _options$withSummary === void 0 ? false : _options$withSummary,
        _options$withAllCells = options.withAllCells,
        withAllCells = _options$withAllCells === void 0 ? false : _options$withAllCells,
        _options$withCellsInR = options.withCellsInRange,
        withCellsInRange = _options$withCellsInR === void 0 ? false : _options$withCellsInR;
      if (mode === 'cols_cells') {
        mode = 'cols';
        withAllCells = false;
        withCellsInRange = true;
      }
      this.tableBlot.componentOnAction({
        type: 'render',
        data: this.table,
        mode: mode,
        start: start,
        last: last,
        withSummary: withSummary,
        withAllCells: withAllCells
      });
    }
  }, {
    key: "render",
    value:
    /**
     * Полный рендер компонента таблицы
     */
    function render() {
      var _this$tableBlot = this.tableBlot,
        bench = _this$tableBlot.bench,
        tableExec = _this$tableBlot.tableExec,
        onTableAction = _this$tableBlot.onTableAction,
        setOnAction = _this$tableBlot.setOnAction,
        setOnKeyDown = _this$tableBlot.setOnKeyDown,
        setTableContext = _this$tableBlot.setTableContext,
        renderWithFilter = _this$tableBlot.renderWithFilter;
      var mark = bench.mark('Embed render full');
      var globalConfig = Object.assign({}, this.tableBlot.blotConfig, {
        mobile: this.editor.options.deviceType === 'mobile'
      });
      (0,preact_module/* render */.sY)((0,preact_module.h)(TableComponent, {
        editor: this.editor,
        bench: bench,
        editable: this.editable,
        version: ++this.version,
        data: this.table,
        setProp: this.setProp.bind(this),
        startEdit: this.startEdit.bind(this),
        applyDelta: this.applyDelta.bind(this),
        tableExec: tableExec.bind(this.tableBlot),
        renderWithFilter: renderWithFilter.bind(this.tableBlot),
        onTableAction: onTableAction.bind(this.tableBlot),
        setOnAction: setOnAction.bind(this.tableBlot),
        setOnKeyDown: setOnKeyDown.bind(this.tableBlot),
        globalConfig: globalConfig,
        setTableContext: setTableContext.bind(this.tableBlot),
        onTableRenderComponent: this.onTableRenderComponent
      }), this.domNode);
      var duration = bench.measure(mark);
      console.info('#' + mark.split('#').pop(), duration);
    }
  }], [{
    key: "create",
    value: function create() {
      var _get4;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      var node = (_get4 = tableBodyEmbed_get(tableBodyEmbed_getPrototypeOf(TableBodyEmbed), "create", this)).call.apply(_get4, [this].concat(args));
      return node;
    }
  }]);
  return TableBodyEmbed;
}(blockEmbed);

TableBodyEmbed.blotName = 'tableBodyEmbed';
TableBodyEmbed.tagName = 'div';
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__(24603);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/tableBlotEditText.js
function tableBlotEditText_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { tableBlotEditText_typeof = function _typeof(obj) { return typeof obj; }; } else { tableBlotEditText_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return tableBlotEditText_typeof(obj); }
function tableBlotEditText_slicedToArray(arr, i) { return tableBlotEditText_arrayWithHoles(arr) || tableBlotEditText_iterableToArrayLimit(arr, i) || tableBlotEditText_unsupportedIterableToArray(arr, i) || tableBlotEditText_nonIterableRest(); }
function tableBlotEditText_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tableBlotEditText_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tableBlotEditText_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tableBlotEditText_arrayLikeToArray(o, minLen); }
function tableBlotEditText_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function tableBlotEditText_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function tableBlotEditText_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




























function tableBlotEditText_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function tableBlotEditText_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function tableBlotEditText_createClass(Constructor, protoProps, staticProps) { if (protoProps) tableBlotEditText_defineProperties(Constructor.prototype, protoProps); if (staticProps) tableBlotEditText_defineProperties(Constructor, staticProps); return Constructor; }
function tableBlotEditText_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { tableBlotEditText_get = Reflect.get; } else { tableBlotEditText_get = function _get(target, property, receiver) { var base = tableBlotEditText_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return tableBlotEditText_get(target, property, receiver || target); }
function tableBlotEditText_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = tableBlotEditText_getPrototypeOf(object); if (object === null) break; } return object; }
function tableBlotEditText_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) tableBlotEditText_setPrototypeOf(subClass, superClass); }
function tableBlotEditText_setPrototypeOf(o, p) { tableBlotEditText_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return tableBlotEditText_setPrototypeOf(o, p); }
function tableBlotEditText_createSuper(Derived) { var hasNativeReflectConstruct = tableBlotEditText_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = tableBlotEditText_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = tableBlotEditText_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return tableBlotEditText_possibleConstructorReturn(this, result); }; }
function tableBlotEditText_possibleConstructorReturn(self, call) { if (call && (tableBlotEditText_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return tableBlotEditText_assertThisInitialized(self); }
function tableBlotEditText_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function tableBlotEditText_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function tableBlotEditText_getPrototypeOf(o) { tableBlotEditText_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return tableBlotEditText_getPrototypeOf(o); }
function tableBlotEditText_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var tableBlotEditText_isEnter = (0,lib/* default */.ZP)('enter');
var tableBlotEditText_isEsc = (0,lib/* default */.ZP)('esc');
var isDelete = (0,lib/* default */.ZP)('delete');
var isBackspace = (0,lib/* default */.ZP)('backspace');
var isShiftBackspace = (0,lib/* default */.ZP)('shift+backspace');
var tableBlotEditText_isShiftEnter = (0,lib/* default */.ZP)('shift+enter');
var isArrowUp = (0,lib/* default */.ZP)('arrowup');
var isArrowDown = (0,lib/* default */.ZP)('arrowdown');
var isArrowLeft = (0,lib/* default */.ZP)('arrowleft');
var isArrowRight = (0,lib/* default */.ZP)('arrowright');
var tableBlotEditText_isCtrlAKey = (0,lib/* default */.ZP)('mod+a');
var NUMBER_KEYS = (/* unused pure expression or super */ null && ([33, 34, 35, 36, 37, 38, 39, 40, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105]));
var skipBlurIds = ['link-form-adress'];
var TableBlotEditText = /*#__PURE__*/function (_ExecutableMixin) {
  tableBlotEditText_inherits(TableBlotEditText, _ExecutableMixin);
  var _super = tableBlotEditText_createSuper(TableBlotEditText);
  function TableBlotEditText(node) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    tableBlotEditText_classCallCheck(this, TableBlotEditText);
    _this = _super.call(this, node, options);
    tableBlotEditText_defineProperty(tableBlotEditText_assertThisInitialized(_this), "onContextMenu", function (event) {
      event.preventDefault();
      _this.parentTable.componentOnAction({
        type: 'context-menu',
        mode: 'cell',
        event: event
      });
    });
    tableBlotEditText_defineProperty(tableBlotEditText_assertThisInitialized(_this), "onTouchStartBound", _this.onTouchStart.bind(tableBlotEditText_assertThisInitialized(_this)));
    tableBlotEditText_defineProperty(tableBlotEditText_assertThisInitialized(_this), "onBlur", function (event) {
      var _event$relatedTarget;
      if (skipBlurIds.includes(event === null || event === void 0 ? void 0 : (_event$relatedTarget = event.relatedTarget) === null || _event$relatedTarget === void 0 ? void 0 : _event$relatedTarget.id)) {
        console.info('Skip blur to', event === null || event === void 0 ? void 0 : event.relatedTarget);
      } else if (_this.preventBlur) {
        _this.setCursorTo(_this.preventBlur);
      } else if (Date.now() - (_this.started || 0) > 10) {
        // Во воремя тестов блок получал blur сразу после фокусировки, в реальном браузере timeShift неактуален
        _this.endWrite(event);
      } else {
        console.info('Skip blur event');
      }
    });
    tableBlotEditText_defineProperty(tableBlotEditText_assertThisInitialized(_this), "onKeyDown", function (event) {
      var processed = false;
      if (_this.editor.options.keyboardMode === 'mobile') {
        _this.isMobileKeyDown = event.keyCode === 229;
      }
      if (tableBlotEditText_isEnter(event)) {
        if (!_this.isMention) {
          event.preventDefault();
          event.stopPropagation();
          _this.endWrite(event);
          if (!_this.parentTable.hasFilter()) {
            _this.parentTable.componentOnAction({
              type: 'add-row-and-move-down'
            });
          }
        }
        processed = true;
      } else if (tableBlotEditText_isEsc(event)) {
        _this.endWrite(event);
        processed = true;
      } else if (tableBlotEditText_isShiftEnter(event)) {
        event.preventDefault();
        if (_this.isText) {
          _this.onShiftEnterKey(event);
        }
        processed = true;
      } else if (isBackspace(event) || isShiftBackspace(event) || isDelete(event)) {
        event.stopPropagation();
        processed = true;
      } else if (isArrowUp(event) || isArrowDown(event)) {
        if (_this.isMention) {
          event.preventDefault();
        } else {
          _this.preventBlur = isArrowUp(event) ? 'start' : 'end';
        }
        processed = true;
      } else if (isArrowLeft(event) || isArrowRight(event)) {
        // не позволяем курсору уйти за пределы ячейки
        var range = _this.scroll.selection.getRange({
          offsetBlot: tableBlotEditText_assertThisInitialized(_this)
        })[0];
        if (range.index === 0 && isArrowLeft(event) || range.index === _this.length() - 1 && isArrowRight(event)) {
          event.preventDefault();
          processed = true;
        }
      } else if (tableBlotEditText_isCtrlAKey(event)) {
        event.preventDefault();
        event.stopPropagation();
        processed = true;
        _this.scroll.selection.setRange({
          index: _this.offset(_this.scroll),
          length: _this.length() - 1
        });
      } else if (event.altKey || event.ctrlKey || event.metaKey) {
        processed = false;
      } else if (_this.isNumber) {
        //this.testNumber(event)
        processed = true;
      }
      return processed;
    });
    tableBlotEditText_defineProperty(tableBlotEditText_assertThisInitialized(_this), "onKeyUp", function (event) {
      var processed = false;
      if (isArrowUp(event) || isArrowDown(event)) {
        processed = true;
        _this.preventBlur = false;
      } else if (event.keyCode === 229 && _this.editor.options.keyboardMode === 'mobile') {
        _this.filterNumber(event);
      }
      return processed;
    });
    tableBlotEditText_defineProperty(tableBlotEditText_assertThisInitialized(_this), "onBeforeInputBound", _this.onBeforeInput.bind(tableBlotEditText_assertThisInitialized(_this)));
    tableBlotEditText_defineProperty(tableBlotEditText_assertThisInitialized(_this), "onInputBound", _this.onInput.bind(tableBlotEditText_assertThisInitialized(_this)));
    _this.addCanExecActions(textBase.canExecActions);
    _this.keepNewLines = true;
    _this.dontConvertLinks = true;
    _this.options = options || {};
    _this.format = options.format || {};
    _this.textFormat = options.textFormat || {};
    _this.type = options.type || 'text';
    _this.isMention = _this.type === 'mention';
    _this.isNumber = _this.type === 'number';
    _this.isText = !_this.isNumber && !_this.isMention;
    _this.floatingToolbarDisabled = !_this.isText;
    _this.disableAddNote = true;
    _this.preventBlur = false;
    _this.isMobileKeyDown = false;
    if (_this.isNumber) {
      var pattern = "0-9\\" + (_this.format.decimalSeparator || '.');
      _this.regexTest = new RegExp("^([".concat(pattern, "]{1,})$"));
      _this.regexReplace = new RegExp("[^".concat(pattern, "]"), 'g');
    }
    return _this;
  }
  tableBlotEditText_createClass(TableBlotEditText, [{
    key: "attach",
    value: function attach() {
      var _get2, _this$parent$options;
      var initialized = this._quillBinding;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = tableBlotEditText_get(tableBlotEditText_getPrototypeOf(TableBlotEditText.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      if (initialized) {
        return;
      }
      if (!this.map.has('align') && this.options.textAlign) {
        this.map.set('align', this.options.textAlign);
      }
      this.started = Date.now();
      this.domNode.setAttribute('data-gramm', false);
      this.domNode.setAttribute('contenteditable', true);
      this.domNode.classList.add('table-blot-edit-text', 'table-text-common', 'focused-block');
      this.domNode.addEventListener('blur', this.onBlur, false);
      this.domNode.addEventListener('keyup', this.onKeyUp, false);
      this.domNode.addEventListener('keydown', this.onKeyDown, false);
      this.domNode.addEventListener('input', this.onInputBound, false);
      this.domNode.addEventListener('beforeinput', this.onBeforeInputBound, false);
      //this.domNode.addEventListener('compositionstart', this.onCompositionStartBound, true)
      this.domNode.addEventListener('contextmenu', this.onContextMenu, false);
      if ((_this$parent$options = this.parent.options) !== null && _this$parent$options !== void 0 && _this$parent$options.scrollNode) {
        this.parent.options.scrollNode.addEventListener("touchstart", this.onTouchStartBound, false);
      }
      this.beginWrite();
      this.render();
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3, _this$parent$options2;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = tableBlotEditText_get(tableBlotEditText_getPrototypeOf(TableBlotEditText.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      this.domNode.removeEventListener('blur', this.onBlur, false);
      this.domNode.removeEventListener('keyup', this.onKeyUp, false);
      this.domNode.removeEventListener('keydown', this.onKeyDown, false);
      this.domNode.removeEventListener('input', this.onInputBound, false);
      this.domNode.removeEventListener('beforeinput', this.onBeforeInputBound, false);
      this.domNode.removeEventListener('contextmenu', this.onContextMenu, false);
      if ((_this$parent$options2 = this.parent.options) !== null && _this$parent$options2 !== void 0 && _this$parent$options2.scrollNode) {
        this.parent.options.scrollNode.removeEventListener("touchstart", this.onTouchStartBound, false);
      }
    }
  }, {
    key: "parentTable",
    get: function get() {
      return this.parent.parent;
    }
  }, {
    key: "onTouchStart",
    value: function onTouchStart(event) {
      if (this.editor.options.keyboardMode === 'mobile') {
        if ((event === null || event === void 0 ? void 0 : event.target) !== this.domNode) {
          this.onBlur(event);
        }
      }
    }
  }, {
    key: "onBeforeInput",
    value: function onBeforeInput(event) {
      this.testNumber(event);
    }
  }, {
    key: "onInput",
    value: function onInput(event) {
      if (this.isMobileKeyDown) {
        var symbol = event.data && event.data.substr(event.data.length - 1, 1);
        if (symbol === "\n") {
          event.stopPropagation();
          var range = this.scroll.selection.getRange(this);
          this.scroll.selection.setRange({
            index: range[0].index + this.length() - 1,
            length: 0
          });
          var keyEvent = new KeyboardEvent('keydown', {
            bubbles: true,
            cancelable: true,
            key: 'Enter',
            keyCode: 13
          });
          this.domNode.dispatchEvent(keyEvent);
        }
        //event.inputType === 'insertCompositionText'
        this.isMobileKeyDown = false;
      }
    }
  }, {
    key: "testNumber",
    value: function testNumber(event) {
      var processed = false;
      if (this.isNumber) {
        processed = true;
        var symbol = event.data && event.data.substr(event.data.length - 1, 1);
        if (symbol) {
          var parts = this.getText().trim().split(/[\.,]+/);
          var test = /[0-9]/.test(symbol);
          var prevent = true;
          var _this$selection$getRa = this.selection.getRange({
              offsetBlot: this
            }),
            _this$selection$getRa2 = tableBlotEditText_slicedToArray(_this$selection$getRa, 1),
            range = _this$selection$getRa2[0];
          if (test) {
            if (parts.length === 1 || !this.format.decimals || parts[1].length < this.format.decimals) {
              prevent = false;
            } else {
              // Запрещаем добавлять десятичные знаки, если есть ограничение format.decimals и курсор в десятичной области
              if (range.length !== 0 || range.index <= parts[0].length) {
                prevent = false;
              }
            }
          } else if (parts.length === 1 && symbol === this.format.decimalSeparator) {
            prevent = false;
          } else if (symbol === '-' && range.index === 0 && !parts[0].startsWith('-')) {
            // разрешаем знак минус, если курсор стоит в начале
            prevent = false;
          }
          if (prevent) {
            event.preventDefault();
          }
        }
      }
      return processed;
    }
  }, {
    key: "filterNumber",
    value: function filterNumber(event) {
      if (this.isNumber) {
        var text = this.getText().trim();
        if (text) {
          var test = this.regexTest.test(text);
          if (!test) {
            var insert = text.replace(this.regexReplace, '');
            event === null || event === void 0 ? void 0 : event.stopPropagation();
            this.clear();
            if (insert.length) {
              this.map.get('characters').applyDelta([{
                retain: 0
              }, {
                insert: insert
              }]);
            }
            this.setCursorTo('end');
          }
        }
      }
    }
  }, {
    key: "onEndWriteNormalize",
    value: function onEndWriteNormalize() {
      var _this2 = this;
      var store = this.map.get('characters');
      if (this.isText) {
        // Фикс редких событий битой дельты на сервере, когда она не может нормально засинхрониться с фротендом,
        // такое может произойти при вставке в ячкейку текста или при копипасте всей таблицы,
        // с чем связано не смог выяснить так как при копипасте дельта корректная.
        // если diff дельты блока и дельты на сервере имеет длину больше двух, или это не операция вставки в конец символа \n
        // чистим полностью дельту и заменяем её на дельту блока, тесты показали, что после проделанной операции повторный фикс не вызывается
        // и дальнейшая работа с текстом в ячейке проходит корректно
        var storedDelta = new (Delta_default())(store.toDelta());
        if (!deep_equal_default()(storedDelta, this.cache.delta)) {
          var diff = storedDelta.diff(this.cache.delta);
          if (Boolean(diff.ops.length)) {
            this.store.transaction(function () {
              store.applyDelta([{
                delete: storedDelta.length()
              }]);
              store.applyDelta(_this2.cache.delta.ops);
            });
          }
        }
      } else if (this.isNumber) {
        var characters = this.getText().replace('\n', '');
        if (characters === '-') {
          this.clear();
        } else if (characters === '-0') {
          store.applyDelta([{
            delete: 1
          }]);
        }
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.map.get('characters').applyDelta([{
        delete: this.length()
      }, {
        insert: "\n"
      }]);
    }
  }, {
    key: "setCursorTo",
    value: function setCursorTo() {
      var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'start';
      var minus = this.getText().endsWith('\n') ? 1 : 0;
      var max = this.length() - minus;
      pos = !isNaN(pos) ? Math.min(max, Math.max(0, pos)) : pos === 'end' ? max : 0;
      this.scroll.selection.setRange({
        index: this.offset(this.scroll) + pos,
        length: 0
      });
    }
  }, {
    key: "onShiftEnterKey",
    value: function onShiftEnterKey(event) {
      var _this$selection$getRa3 = this.selection.getRange({
          offsetBlot: this
        }),
        _this$selection$getRa4 = tableBlotEditText_slicedToArray(_this$selection$getRa3, 1),
        blotRange = _this$selection$getRa4[0];
      var _this$selection$getRa5 = this.selection.getRange(),
        _this$selection$getRa6 = tableBlotEditText_slicedToArray(_this$selection$getRa5, 1),
        quillRange = _this$selection$getRa6[0];
      var range = this.selection.getNativeRange();
      if (range.start.node != range.end.node || range.start.offset != range.end.offset) {
        return;
      }
      var ops = [{
        retain: blotRange.index
      }, {
        insert: {
          linebreak: 's'
        }
      }];
      if (blotRange.index === this.delta().length() - 1) {
        ops.push({
          insert: ' '
        });
      }
      var needToScroll = false;
      if (this.delta().length() - blotRange.index < 3) {
        needToScroll = true;
      }
      this.map.get('characters').applyDelta(ops);
      quillRange.index++;
      this.selection.setRange(quillRange);
      if (needToScroll) {
        this.domNode.scrollTop = this.domNode.scrollHeight;
      }
    }
  }, {
    key: "beginWrite",
    value: function beginWrite() {
      this.editing = true;
      this.domNode.focus();
      this.setCursorTo('end');
      this.checkMention();
    }
  }, {
    key: "endWrite",
    value: function endWrite(options) {
      this.onEndWriteNormalize();
      if (this.editing) {
        this.editing = false;
        this.parent.endEdit(options);
      }
    }
  }, {
    key: "update",
    value: function update() {
      var _get4;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      (_get4 = tableBlotEditText_get(tableBlotEditText_getPrototypeOf(TableBlotEditText.prototype), "update", this)).call.apply(_get4, [this].concat(args));
      this.applyColumnFormatsIfNeed();
      this.render();
      this.parent.childUpdate();
      this.checkMention();
    }
  }, {
    key: "render",
    value: function render() {
      if (this.options.hasOwnProperty('text-align')) {
        this.domNode.style.textAlign = this.options['text-align'];
      }
      tableBlotEditText_get(tableBlotEditText_getPrototypeOf(TableBlotEditText.prototype), "render", this).call(this);
    }
  }, {
    key: "checkMention",
    value: function checkMention() {
      if (!this.isMention) {
        return;
      }
      var mentionManager = this.editor.plugins.mentionManager;
      if (this.getText().trim() === '@') {
        var blotRange = this.scroll.selection.getRange({
          offsetBlot: this
        })[0];
        mentionManager.start(this, blotRange, {
          mentionMode: 'table',
          customPlaceholder: ' ',
          onMentionEnd: this.endWrite.bind(this)
        });
      }
    }
  }, {
    key: "onPaste",
    value: function onPaste() {
      var _params$html;
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var allow = true;
      var text = String(params.text || ((_params$html = params.html) === null || _params$html === void 0 ? void 0 : _params$html.replace(/(<([^>]+)>)/ig, ''))).trim();
      if (!text || this.isMention) {
        allow = false;
      } else if (this.isNumber) {
        text = text.replace(',', '.');
        if (isNaN(text)) {
          allow = false;
        } else if (text.includes('.')) {
          var decimalSeparator = this.format.decimalSeparator || '.';
          if (this.getText().trim().includes(decimalSeparator)) {
            allow = false;
          } else if (decimalSeparator !== '.') {
            text = text.replace('.', decimalSeparator);
          }
        }
      }
      if (!allow) {
        return true;
      }
      var blotRange = this.scroll.selection.getRange({
        offsetBlot: this
      })[0];
      var ops = [];
      if (blotRange.index > 0) {
        ops.push({
          retain: blotRange.index
        });
      }
      var lines = this.isNumber ? [text] : text.split('\n');
      for (var i in lines) {
        var op = {
          insert: lines[i].trim()
        };
        if (stringIsUrl(op.insert)) {
          op.attributes = {
            link: op.insert
          };
        }
        ops.push(op);
        if (lines.length > 1 && i < lines.length - 1) {
          ops.push({
            insert: {
              linebreak: 's'
            }
          });
        }
      }
      if (blotRange.length > 0) {
        ops.push({
          delete: blotRange.length
        });
      }
      this.map.get('characters').applyDelta(ops);
      var newIndex = blotRange.index + text.length;
      var blotOffset = this.offset(this.scroll);
      this.scroll.selection.setRange({
        index: blotOffset + newIndex,
        length: 0
      });
      this.parent.childUpdate();
    }
  }, {
    key: "getCopyParams",
    value: function getCopyParams() {
      var cut = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var copyManager = this.editor.plugins.copyManager;
      var _copyManager$getNativ = copyManager.getNativeCopyData(),
        html = _copyManager$getNativ.html,
        text = _copyManager$getNativ.text;
      var _this$scroll$selectio = this.scroll.selection.getRange({
          offsetBlot: this
        }),
        _this$scroll$selectio2 = tableBlotEditText_slicedToArray(_this$scroll$selectio, 1),
        blotRange = _this$scroll$selectio2[0];
      var op = this.getBlotInsertParams(blotRange);
      if (cut) [copyManager.useDeleteAction([this], this.scroll.selection.getRange()[0])];
      return {
        html: html,
        text: text,
        op: op
      };
    }
  }, {
    key: "applyColumnFormatsIfNeed",
    value: function applyColumnFormatsIfNeed() {
      var _this3 = this;
      var formats = this.getFormat(0, this.length() - 1);
      Object.keys(this.textFormat).forEach(function (format) {
        if (!formats.hasOwnProperty(format) || formats[format] !== _this3.textFormat[format]) {
          _this3.formatAt(0, _this3.length() - 1, format, _this3.textFormat[format]);
        }
      });
    }
  }]);
  return TableBlotEditText;
}(executable(basic(textBase)));

TableBlotEditText.tagName = 'DIV';
TableBlotEditText.blotName = 'tableBlotEditText';
TableBlotEditText.allowedChildren = textBase.allowedChildren;
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/tableBlotEditCell.js
function tableBlotEditCell_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = tableBlotEditCell_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function tableBlotEditCell_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tableBlotEditCell_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tableBlotEditCell_arrayLikeToArray(o, minLen); }
function tableBlotEditCell_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function tableBlotEditCell_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { tableBlotEditCell_typeof = function _typeof(obj) { return typeof obj; }; } else { tableBlotEditCell_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return tableBlotEditCell_typeof(obj); }
function tableBlotEditCell_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function tableBlotEditCell_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { tableBlotEditCell_ownKeys(Object(source), true).forEach(function (key) { tableBlotEditCell_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { tableBlotEditCell_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function tableBlotEditCell_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }























function tableBlotEditCell_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function tableBlotEditCell_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function tableBlotEditCell_createClass(Constructor, protoProps, staticProps) { if (protoProps) tableBlotEditCell_defineProperties(Constructor.prototype, protoProps); if (staticProps) tableBlotEditCell_defineProperties(Constructor, staticProps); return Constructor; }
function tableBlotEditCell_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { tableBlotEditCell_get = Reflect.get; } else { tableBlotEditCell_get = function _get(target, property, receiver) { var base = tableBlotEditCell_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return tableBlotEditCell_get(target, property, receiver || target); }
function tableBlotEditCell_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = tableBlotEditCell_getPrototypeOf(object); if (object === null) break; } return object; }
function tableBlotEditCell_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) tableBlotEditCell_setPrototypeOf(subClass, superClass); }
function tableBlotEditCell_setPrototypeOf(o, p) { tableBlotEditCell_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return tableBlotEditCell_setPrototypeOf(o, p); }
function tableBlotEditCell_createSuper(Derived) { var hasNativeReflectConstruct = tableBlotEditCell_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = tableBlotEditCell_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = tableBlotEditCell_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return tableBlotEditCell_possibleConstructorReturn(this, result); }; }
function tableBlotEditCell_possibleConstructorReturn(self, call) { if (call && (tableBlotEditCell_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return tableBlotEditCell_assertThisInitialized(self); }
function tableBlotEditCell_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function tableBlotEditCell_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function tableBlotEditCell_getPrototypeOf(o) { tableBlotEditCell_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return tableBlotEditCell_getPrototypeOf(o); }








var tableBlotEditCell_mixin = mix([basic, container, executable]);
var TableBlotEditCell = /*#__PURE__*/function (_mixin) {
  tableBlotEditCell_inherits(TableBlotEditCell, _mixin);
  var _super = tableBlotEditCell_createSuper(TableBlotEditCell);
  function TableBlotEditCell(domNode) {
    tableBlotEditCell_classCallCheck(this, TableBlotEditCell);
    return _super.call(this, domNode);
  }
  tableBlotEditCell_createClass(TableBlotEditCell, [{
    key: "attach",
    value: function attach() {
      this.edit = false;
      this.padding = {
        width: 22
      };
      this.domNode.classList.add('table-blot-edit-area');
    }
  }, {
    key: "exec",
    value: function exec(action) {
      var processed = tableBlotEditCell_get(tableBlotEditCell_getPrototypeOf(TableBlotEditCell.prototype), "exec", this).call(this, action);
      if (action.type === 'delete' || action.type === 'backspace') {
        return this.childBlot.exec(action);
      }
      return processed;
    }
  }, {
    key: "table",
    get: function get() {
      return this.parent;
    }
  }, {
    key: "isEdit",
    get: function get() {
      return this.editing;
    }
  }, {
    key: "containerChildren",
    get: function get() {
      return [];
    }
  }, {
    key: "optimize",
    value: function optimize() {
      return;
    }

    /**
     * Запуск редактирования ячейки
     * @param { string } mapId: id map ячейки
     * @param { object } options
     * @param { string } options.type: тип редактируемой ячейки - text, mention, number
     * @param { event } options.event: событие, вызвавшее начало редактирования
     * @param { object } options.pos: позиция ячейки {row, col}
     * @param { node } options.node: нода ячейки в таблице (для выравнивания)
     * @param { node } options.scrollNode: нода скролла таблицы
     * @param { function } options.onInput: действие, вызываемое при вводе в ячейку
     * @param { boolean } options.nowrap? режим nowrap
     * @param { function } options.coords?: координаты для расширения ячейки
     * @param { boolean } options.rowHeight? высота строки
     * @param { object } options.style? стили ячейки
     * @param { string } options.style.valign? вертикальное выравнивание
     * @param { object } format? форматирование ячейки
     */
  }, {
    key: "startEdit",
    value: function startEdit(mapId) {
      var _options$event, _options$event$key, _options$node, _options$style;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.endEdit();
      this.editing = true;
      this.options = options;
      var insertSymbols = false;
      if (options.type === 'mention') {
        // Старт меншина
        insertSymbols = '@';
      } else if (((_options$event = options.event) === null || _options$event === void 0 ? void 0 : _options$event.type) === 'keydown' && ((_options$event$key = options.event.key) === null || _options$event$key === void 0 ? void 0 : _options$event$key.length) === 1 && (options.type === 'text' || options.type === 'number' && (options.event.key === '-' || !isNaN(options.event.key)))) {
        // Устанавливаем символ при активации через клавиатуру
        insertSymbols = options.event.key;
      } else if (options.type === 'number') {
        // Удаляем разделитель в characters для данных из V1, в будущем можно убрать
        if (charsString && charsString.indexOf('‚') !== -1) {
          insertSymbols = charsString.replace(/‚/g, '');
        }
      }
      this.options.minHeight = insertSymbols ? options.rowHeight : Math.max(options.rowHeight, (_options$node = options.node) === null || _options$node === void 0 ? void 0 : _options$node.offsetHeight);
      this.expandReset();
      if ((_options$style = options.style) !== null && _options$style !== void 0 && _options$style.valign) {
        this.domNode.setAttribute('valign', options.style.valign);
      } else {
        this.domNode.removeAttribute('valign');
      }
      this.domNode[options.nowrap ? 'setAttribute' : 'removeAttribute']('nowrap', true);
      this.render();
      this.childBlot = parchment_default().create('tableBlotEditText', tableBlotEditCell_objectSpread(tableBlotEditCell_objectSpread({}, options.style), {}, {
        type: options.type,
        format: options.format,
        textFormat: options.type === 'text' ? options.textFormat : {},
        textAlign: options.textAlign
      }));
      this.childBlot.map = this.store.getMap(mapId);
      var characters = this.childBlot.map.get('characters');
      var charsString = characters === null || characters === void 0 ? void 0 : characters.toString();
      if (insertSymbols) {
        var deleteLength = characters.length;
        if (charsString !== null && charsString !== void 0 && charsString.endsWith('\n')) {
          deleteLength -= 1;
        }
        var deltaToApply = [];
        if (deleteLength) {
          deltaToApply.push({
            delete: deleteLength
          });
        }
        deltaToApply.push({
          insert: insertSymbols
        });
        characters.applyDelta(deltaToApply);
      }
      this.appendChild(this.childBlot);
      this.table.setClass('text-editing', true);
    }

    /**
     * Завершение редактирования ячейки
     * @param { any } options
     */
  }, {
    key: "endEdit",
    value: function endEdit(options) {
      if (this.isEdit) {
        this.childBlot.remove();
        this.table.tableBodyEmbed.endEdit(options);
        this.editing = false;
        this.render();
        this.table.setClass('text-editing', false);
        if (tableBlotEditCell_typeof(options) === 'object') {
          if (options.type === 'keydown' || options.object_id) {
            this.table.focusableFocus();
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.isEdit) {
        this.domNode.classList.remove('active');
      } else {
        this.domNode.classList.add('active');
        this.align();
      }
    }

    /**
     * Общая функция выравнивания ячейки
     */
  }, {
    key: "align",
    value: function align() {
      this.wrapRect = this.parent.domNode.parentNode.getBoundingClientRect();
      this.cellRect = this.options.node.getBoundingClientRect();
      this.zero = {
        top: Math.max(0, this.cellRect.top - this.wrapRect.top) - 1,
        left: Math.max(0, this.cellRect.left - this.wrapRect.left) + 1
      };
      if (this.options.nowrap) {
        this.expand();
      } else {
        this.fitCell();
        if (this.options.minHeight) {
          this.domNode.style.minHeight = this.options.minHeight + 'px';
        }
      }
    }

    /**
     * Подстроить позицию и размер редактируемой ячейки ячейку таблицы
     */
  }, {
    key: "fitCell",
    value: function fitCell() {
      this.domNode.style.top = this.zero.top + 'px';
      this.domNode.style.left = this.zero.left - 0.5 + 'px';
      this.domNode.style.width = this.cellRect.width - this.padding.width + 1 + 'px';
      this.domNode.style.height = this.cellRect.height + 'px';
    }

    /**
     * Вызывается при обновлении блота потомка
     */
  }, {
    key: "childUpdate",
    value: function childUpdate() {
      if (this.editing) {
        var characters = this.childBlot.map.get('characters');
        this.options.onInput && this.options.onInput(characters);
        if (this.options.nowrap) {
          this.domNode.style.height = CONFIG.row.props.height + 'px';
          this.expand();
        } else {
          this.domNode.style.height = this.childBlot.domNode.offsetHeight + 'px';
        }
      }
    }

    /**
     * Подстраивает размер редактируемой ячейки в nowrap режиме
     */
  }, {
    key: "expand",
    value: function expand() {
      var needExpand = false;
      if (this.isOverflow || this.isExceedDefaultHeight || this.expandedCol && this.expandedCol > 1 || this.expandedRow && this.expandedRow > 1) {
        needExpand = true;
      }
      if (needExpand) {
        this.domNode.classList.add('expanded');
        if (!this.expandedRow || this.expandedRow === 1) {
          this.domNode.classList.add('expanded-col');
          this.expandedCol = 0;
          var _iterator = tableBlotEditCell_createForOfIteratorHelper(this.options.coords.col),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var xPos = _step.value;
              this.expandedCol++;
              this.domNode.style.left = this.zero.left + xPos.left - 2 + 'px';
              this.domNode.style.width = xPos.width - this.padding.width + 'px';
              if (!this.isOverflow && !this.isExceedDefaultHeight) {
                break;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        this.expandedRow = 1;
        if (this.expandedCol === this.options.coords.limit.col) {
          var scroll = true;
          this.domNode.classList.add('expanded-row');
          var _iterator2 = tableBlotEditCell_createForOfIteratorHelper(this.options.coords.row),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var yPos = _step2.value;
              this.domNode.style.top = this.zero.top + yPos.top + 'px';
              this.domNode.style.height = yPos.height + 1 + 'px';
              this.expandedRow++;
              if (this.isOverflow) {
                //this.expandedRow++
              } else {
                scroll = false;
                break;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          this.domNode.classList[scroll ? 'add' : 'remove']('expanded-scroll');
        }
        if (this.expandedRow === 1) {
          this.domNode.classList.remove('expanded-row');
        }
        if (this.expandedCol === 1 && this.expandedRow === 1) {
          needExpand = false;
        }
      }
      if (!needExpand) {
        this.expandReset();
        this.fitCell();
      }
    }

    /**
     * Сброс статуса расширенной ячейки
     */
  }, {
    key: "expandReset",
    value: function expandReset() {
      this.domNode.classList.remove('expanded', 'expanded-col', 'expanded-row');
      this.expandedCol = 1;
      this.expandedRow = 1;
    }

    /**
     * Проверка превышает ли контент размер ячейки
     * @returns {boolean}
     */
  }, {
    key: "isOverflow",
    get: function get() {
      return this.isOverflowX || this.isOverflowY;
    }

    /**
     * Проверка превышает ли контент размер ячейки по ширине
     * @returns {boolean}
     */
  }, {
    key: "isOverflowX",
    get: function get() {
      return this.domNode.scrollWidth - this.domNode.offsetWidth > 0;
    }

    /**
     * Проверка превышает ли контент размер ячейки по высоте
     * @returns {boolean}
     */
  }, {
    key: "isOverflowY",
    get: function get() {
      return this.domNode.scrollHeight - this.domNode.offsetHeight > 0;
    }

    /**
     * Проверка превышает ли контент дефолтную высоту ячейки
     * @returns {boolean}
     */
  }, {
    key: "isExceedDefaultHeight",
    get: function get() {
      return this.domNode.offsetHeight - CONFIG.row.props.height - 2 > 0;
    }
  }]);
  return TableBlotEditCell;
}(tableBlotEditCell_mixin(block));
TableBlotEditCell.blotName = 'tableBlotEditCell';
TableBlotEditCell.tagName = 'DIV';
TableBlotEditCell.allowedChildren = [TableBlotEditText];
/* harmony default export */ const tableBlotEditCell = (TableBlotEditCell);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.flat.js
var es_array_flat = __webpack_require__(84944);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/performance.js
function performance_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { performance_typeof = function _typeof(obj) { return typeof obj; }; } else { performance_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return performance_typeof(obj); }




















function performance_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function performance_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function performance_createClass(Constructor, protoProps, staticProps) { if (protoProps) performance_defineProperties(Constructor.prototype, protoProps); if (staticProps) performance_defineProperties(Constructor, staticProps); return Constructor; }
/**
 * Оценка производительности кода
 */var Performance = /*#__PURE__*/function () {
  /**
   * Конструктор
   * @param {string} id?: идентификатор для записей в буфер, например id блота
   */
  function Performance(id) {
    performance_classCallCheck(this, Performance);
    this.id = id || 'id_' + Date.now().toString().substr(5);
    this.prefixMark = '_mark_';
    this.prefixMeasure = '_measure_';
    this.marks = {};
    this.level = 0;
    this.performance = this.getPerformance();
  }

  /**
   * Возвращает заглушку глобального объекта performance если он не существует
   * @return {{measure: measure, clearMeasures: clearMeasures, clearMarks: clearMarks, getEntriesByType: (function(): *[]), mark: mark}|Performance}
   */
  performance_createClass(Performance, [{
    key: "getPerformance",
    value: function getPerformance() {
      if ((typeof performance === "undefined" ? "undefined" : performance_typeof(performance)) === 'object') {
        return performance;
      }
      return {
        mark: function mark() {},
        measure: function measure() {},
        getEntriesByType: function getEntriesByType() {
          return [];
        },
        getEntriesByName: function getEntriesByName() {
          return [];
        },
        clearMeasures: function clearMeasures() {},
        clearMarks: function clearMarks() {}
      };
    }

    /**
     * Создает уникальный идентификатор метки
     * @param {string} name: имя метки
     * @return {string} идентификатор метки
     */
  }, {
    key: "_mark",
    value: function _mark(name) {
      if (!this.marks.hasOwnProperty(name)) {
        this.marks[name] = {
          count: 1,
          level: this.level++
        };
      } else {
        this.marks[name].count++;
      }
      var mark = "".concat(this.id).concat(this.prefixMark, "#").concat(this.marks[name].count, "_").concat(name);
      return mark;
    }

    /**
     * Создать метку для измерения производительности
     * Ставится в начале измеряемого кода
     * @param {string} name: имя метки, будет выведено в отчете
     * @return {string} идентификатор метки
     */
  }, {
    key: "mark",
    value: function mark(name) {
      var mark = this._mark(name);
      this.performance.mark(mark);
      return mark;
    }
    /**
     * Завершить измерение
     * Ставится в конце кода
     * @param {string} mark: идентификатор метки, возвращенный mark()
     * @return {number} измеренное время, мс
     */
  }, {
    key: "measure",
    value: function measure(mark) {
      var _result$pop;
      this.level--;
      var name = mark.replace(this.prefixMark, this.prefixMeasure);
      this.performance.measure(name, mark);
      var result = this.performance.getEntriesByName(name);
      return (result === null || result === void 0 ? void 0 : (_result$pop = result.pop()) === null || _result$pop === void 0 ? void 0 : _result$pop.duration) || null;
    }
    /**
     * Вывести в консоль результаты измерений
     * @param {object} options?
     * @param {boolean} options.clear?: очистить буфер
     * @param {boolean} options.flat?: не объединять повторные вызовы меток
     * @param {boolean} options.tree?: отображать вложенность меток
     */
  }, {
    key: "print",
    value: function print() {
      var _this = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var multi = false;
      var data = this.performance.getEntriesByType('measure').reduce(function (result, item) {
        var name = item.name,
          startTime = item.startTime,
          duration = item.duration;
        if (item.name.startsWith(_this.id)) {
          name = name.replace(_this.id + _this.prefixMeasure, '').trim();
          var parts = name.split('_');
          var num = parts.shift();
          name = parts.join('_');
          var mark = _this.marks[name];
          if (options.flat && (mark === null || mark === void 0 ? void 0 : mark.count) > 1) {
            name = "".concat(num, "_").concat(name);
          }
          var displayName = name;
          if (options.tree) {
            displayName = '-'.repeat(mark.level) + (mark.level ? ' ' : '') + name;
          }
          if (options.flat || !result.hasOwnProperty(name)) {
            result[name] = {
              name: displayName,
              startTime: [startTime],
              duration: [duration],
              min: duration,
              max: duration,
              calls: 1
            };
          } else {
            multi = true;
            result[name].calls += 1;
            result[name].startTime.push(startTime);
            result[name].duration.push(duration);
            result[name].min = Math.min(duration, result[name].min);
            result[name].max = Math.max(duration, result[name].max);
          }
        }
        return result;
      }, {});
      var dataArr = [];
      for (var k in data) {
        data[k].duration = data[k].duration.reduce(function (sum, val) {
          return sum + val;
        }, 0) / data[k].duration.length;
        data[k].average = data[k].duration;
        data[k].startTime = data[k].startTime[0]; //data[k].startTime.join(',')
        dataArr.push(data[k]);
      }
      // Need to implement logger with different log levels. Now this logs are commented to not pollute console.
      // console.info('Performance #', this.id)
      // console.table(
      //   dataArr,
      //   multi ? ['name', 'calls', 'startTime', 'average', 'min', 'max'] : ['name', 'startTime', 'duration']
      // )
      if (options.clear) {
        this.clear();
      }
    }
    /**
     * Очищает буфер измерений
     */
  }, {
    key: "clear",
    value: function clear() {
      var _this2 = this;
      ['measure', 'mark'].map(function (type) {
        _this2.marks = {};
        _this2.level = 0;
        _this2.performance.getEntriesByType(type).forEach(function (item) {
          if (item.name.startsWith(_this2.id)) {
            if (type === 'measure') {
              _this2.performance.clearMeasures(item.name);
            } else if (type === 'mark') {
              _this2.performance.clearMarks(item.name);
            }
          }
        });
      });
    }
  }]);
  return Performance;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/tableCopy.js
function tableCopy_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function tableCopy_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { tableCopy_ownKeys(Object(source), true).forEach(function (key) { tableCopy_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { tableCopy_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function tableCopy_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function tableCopy_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { tableCopy_typeof = function _typeof(obj) { return typeof obj; }; } else { tableCopy_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return tableCopy_typeof(obj); }
function tableCopy_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = tableCopy_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function tableCopy_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tableCopy_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tableCopy_arrayLikeToArray(o, minLen); }
function tableCopy_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


























function tableCopy_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function tableCopy_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function tableCopy_createClass(Constructor, protoProps, staticProps) { if (protoProps) tableCopy_defineProperties(Constructor.prototype, protoProps); if (staticProps) tableCopy_defineProperties(Constructor, staticProps); return Constructor; }
function tableCopy_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { tableCopy_get = Reflect.get; } else { tableCopy_get = function _get(target, property, receiver) { var base = tableCopy_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return tableCopy_get(target, property, receiver || target); }
function tableCopy_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = tableCopy_getPrototypeOf(object); if (object === null) break; } return object; }
function tableCopy_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) tableCopy_setPrototypeOf(subClass, superClass); }
function tableCopy_setPrototypeOf(o, p) { tableCopy_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return tableCopy_setPrototypeOf(o, p); }
function tableCopy_createSuper(Derived) { var hasNativeReflectConstruct = tableCopy_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = tableCopy_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = tableCopy_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return tableCopy_possibleConstructorReturn(this, result); }; }
function tableCopy_possibleConstructorReturn(self, call) { if (call && (tableCopy_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return tableCopy_assertThisInitialized(self); }
function tableCopy_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function tableCopy_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function tableCopy_getPrototypeOf(o) { tableCopy_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return tableCopy_getPrototypeOf(o); }





var TableCopy = function TableCopy(superclass) {
  return /*#__PURE__*/function (_superclass) {
    tableCopy_inherits(_class, _superclass);
    var _super = tableCopy_createSuper(_class);
    function _class() {
      tableCopy_classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _super.call.apply(_super, [this].concat(args));
    }

    /**
     * Запрещаем копирование через nimbusOps для таблиц в шарах
     */
    tableCopy_createClass(_class, [{
      key: "nimbusOpsForbidden",
      get: function get() {
        return !this.editor.isEditable();
      }

      /**
       * Копирование выделенных ячеек
       * @param {params} params?
       * @param {params} params.start? Старт выделения {row, col}
       * @param {params} params.last? Конец выделения {row, col}
       */
    }, {
      key: "copySelectedCells",
      value: function copySelectedCells() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var i18n = this.editor.plugins.i18n;
        if (params.start && params.last) {
          // Возможно понадобится выделять ячейки, если вызывать из сторонних источников
          // При вызове через меню нет необходимости повторять выделение
        }
        var result = this.getCopyHTML(false);
        (0,util/* copyHtmlToClipboard */.qN)(result.html);
        this.editor.plugins.notificationManager.toast(i18n.get('copy.copied'));
        return result;
      }

      /**
       * Возвращает HTML и текст таблицы
       * @param {boolean} fullTable: копировать полную таблицу, иначе только выделенные ячейки
       * @returns {object}: {html, text}
       */
    }, {
      key: "getCopyHTML",
      value: function getCopyHTML() {
        var _this = this;
        var fullTable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var i18n = this.editor.plugins.i18n;
        var size = this.tableSize;
        var selection;
        if (fullTable) {
          selection = {
            start: {
              row: 0,
              col: 0
            },
            end: {
              row: size.rows - 1,
              col: size.cols - 1
            },
            single: size.rows === 1 && size.cols === 1
          };
        } else {
          selection = this.componentOnAction({
            type: 'selection'
          });
        }
        var table = document.createElement('table');
        var thead = document.createElement('thead');
        var tbody = document.createElement('tbody');

        /*
        for (let key in CONFIG.table.settings) {
          table.setAttribute(key, this.getMode(key))
        }
        */
        var _iterator = tableCopy_createForOfIteratorHelper(CONFIG.table.copy),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var attr = _step.value;
            if (this.map.has(attr)) {
              table.setAttribute(attr, this.map.get(attr));
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var tr = document.createElement('tr');
        this.eachColMap(selection.start, selection.end, {
          create: false
        }, function (colMap, colPos) {
          var th = document.createElement('th');
          var _iterator2 = tableCopy_createForOfIteratorHelper(CONFIG.col.copy),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var attr = _step2.value;
              var value = colMap && colMap.has(attr) ? colMap.get(attr) : CONFIG.col.props[attr];
              if (value && tableCopy_typeof(value) === 'object') {
                if (Object.keys(value).length) {
                  value = JSON.stringify(value);
                } else {
                  value = undefined;
                }
              }
              if (value !== null && typeof value !== 'undefined') {
                th.setAttribute(attr, value);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          tr.appendChild(th);
        });
        thead.appendChild(tr);
        this.eachRowMap(selection.start, selection.end, {
          create: false
        }, function (rowMap, rowPos) {
          if (_this.hasFilter()) {
            var _this$tableComponentC, _this$tableComponentC2, _this$tableComponentC3, _this$tableComponentC4;
            var rowContext = (_this$tableComponentC = _this.tableComponentContext) === null || _this$tableComponentC === void 0 ? void 0 : (_this$tableComponentC2 = _this$tableComponentC.useRefs) === null || _this$tableComponentC2 === void 0 ? void 0 : (_this$tableComponentC3 = _this$tableComponentC2.links) === null || _this$tableComponentC3 === void 0 ? void 0 : (_this$tableComponentC4 = _this$tableComponentC3.row) === null || _this$tableComponentC4 === void 0 ? void 0 : _this$tableComponentC4[rowPos.row];
            if (!rowContext || !rowContext.rowData || rowContext.rowData.id !== rowMap.get('id')) return;
          }
          var tr = document.createElement('tr');
          var _iterator3 = tableCopy_createForOfIteratorHelper(CONFIG.row.copy),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var attr = _step3.value;
              var value = rowMap && rowMap.has(attr) ? rowMap.get(attr) : CONFIG.row.props[attr];
              if (typeof value !== 'undefined') {
                tr.setAttribute(attr, value);
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          _this.eachCellMap(Object.assign({}, selection.start, rowPos), Object.assign({}, selection.end, rowPos), {
            create: false
          }, function (cellMap, cellPos) {
            if (!(cellMap !== null && cellMap !== void 0 && cellMap.get('hidden'))) {
              var td = document.createElement('td');
              if (cellMap) {
                var _iterator4 = tableCopy_createForOfIteratorHelper(CONFIG.cell.copy),
                  _step4;
                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    var _attr = _step4.value;
                    var value = cellMap.get(_attr);
                    if (tableCopy_typeof(value) === 'object') {
                      value = JSON.stringify(value);
                    }
                    if (cellMap.has(_attr)) {
                      td.setAttribute(_attr, value);
                    }
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }
                var childMap = _this.childMapByPos(cellPos, {
                  cellMap: cellMap
                });
                if (childMap) {
                  var _iterator5 = tableCopy_createForOfIteratorHelper(CONFIG.child.copy),
                    _step5;
                  try {
                    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                      var attr = _step5.value;
                      if (childMap.has(attr)) {
                        td.setAttribute(attr, childMap.get(attr));
                      }
                    }
                  } catch (err) {
                    _iterator5.e(err);
                  } finally {
                    _iterator5.f();
                  }
                }
                var colMap = _this.colMapByIndex(cellPos.col);
                var cellType = _this.getCellType(cellPos);
                var cellLink = _this.getCellLink(cellPos);
                var copyParams = getCellCopyParams(cellType, cellMap, childMap, {
                  colMap: colMap,
                  cellLink: cellLink,
                  i18n: i18n
                });
                if (cellType === 'mention') {
                  if (copyParams.mention) {
                    var mention = document.createElement('mention');
                    mention.setAttribute('mention', JSON.stringify(copyParams['mention']));
                    mention.innerText = copyParams.text;
                    for (var key in copyParams) {
                      if (key.startsWith('data-')) {
                        mention.setAttribute(key, copyParams[key]);
                      }
                    }
                    td.appendChild(mention);
                  }
                } else {
                  var text = copyParams.text;
                  if (text) {
                    if (text.startsWith('i18n:')) {
                      text = i18n.get(text.replace('i18n:', ''));
                    }
                    if (!selection.single) {
                      text += ' ';
                    }
                    td.innerHTML = text;
                  }
                }
              }
              tr.appendChild(td);
            }
          });
          if (tr.childNodes.length) {
            tbody.appendChild(tr);
          }
        });
        table.appendChild(thead);
        table.appendChild(tbody);
        return {
          html: table.outerHTML,
          text: table.textContent
        };
      }
    }, {
      key: "getCopyParams",
      value: function getCopyParams() {
        var cut = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var editing = this.getEditing();
        if (editing) {
          var _editing$blot$getCopy, _editing$blot;
          return (_editing$blot$getCopy = (_editing$blot = editing.blot).getCopyParams) === null || _editing$blot$getCopy === void 0 ? void 0 : _editing$blot$getCopy.call(_editing$blot, cut);
        } else {
          var params = tableCopy_get(tableCopy_getPrototypeOf(_class.prototype), "getBlotInsertParams", this).call(this);
          var initParams = this.getContent({
            selection: true
          });
          initParams.room = this.editor.options.serverRoom;
          var _ref = cut ? this.onCut() : this.getCopyHTML(),
            text = _ref.text,
            html = _ref.html;
          return (0,util/* mergeDeep */.Ee)(params, {
            text: text,
            html: html
          }, {
            initParams: initParams
          });
        }
      }

      /**
       * Вырезаение
       * @returns {object}: {html, text}
       */
    }, {
      key: "onCut",
      value: function onCut() {
        var _this$getCopyHTML = this.getCopyHTML(),
          text = _this$getCopyHTML.text,
          html = _this$getCopyHTML.html;
        this.clearSelectedCells();
        return {
          text: text,
          html: html
        };
      }

      /**
       * /plugins/copyManager/README.md
       */
    }, {
      key: "getBlotInsertParams",
      value: function getBlotInsertParams(blotRange, contextHelper) {
        var params = tableCopy_get(tableCopy_getPrototypeOf(_class.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
        var initParams = this.getContent();
        initParams.room = this.editor.options.serverRoom;
        return (0,util/* mergeDeep */.Ee)(params, {
          initParams: initParams
        });
      }

      /**
       * Возвращает данные таблицы для копирования / дублирования
       * @params {object} options?
       * @params {boolean} options.selection?: контент выделенных ячеек, иначе копирует всю таблицу
       * @returns {object}
       */
    }, {
      key: "getContent",
      value: function getContent() {
        var _this2 = this,
          _this$getWrapper$capt;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var content = {
          columns: [],
          rows: []
        };
        var start = {
          row: 0,
          col: 0
        };
        var last = {
          row: this.rowLast,
          col: this.colLast
        };
        if (options.selection) {
          var selection = this.componentOnAction({
            type: 'selection'
          });
          if (selection.start && selection.last) {
            start = selection.start;
            last = selection.last;
          }
        }
        this.eachColMap(start, last, {
          create: false
        }, function (colMap, colPos) {
          var columnParams = _this2.getColCloneParams(colMap);
          content.columns.push(columnParams);
        });
        this.eachRowMap(start, last, {
          create: false
        }, function (rowMap, rowPos) {
          var rowParams = _this2.getRowCloneParams(rowMap);
          rowParams.children = [];
          _this2.eachCellMap({
            row: rowPos.row,
            col: start.col
          }, {
            row: rowPos.row,
            col: last.col
          }, {
            create: false
          }, function (cellMap, cellPos) {
            var cellParams = _this2.getCellCloneParams(cellPos, cellMap);
            rowParams.children.push(cellParams);
          });
          content.rows.push(rowParams);
        });
        var size = this.tableSize;
        var tableParams = {};
        var _iterator6 = tableCopy_createForOfIteratorHelper(CONFIG.table.copy),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var attr = _step6.value;
            if (this.map.has(attr)) {
              tableParams[attr] = this.map.get(attr);
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
        return Object.assign({}, tableCopy_objectSpread(tableCopy_objectSpread({
          cols: size.cols,
          rows: size.rows,
          content: content
        }, tableParams), {}, {
          lineByLine: true,
          captionParams: (_this$getWrapper$capt = this.getWrapper().caption) === null || _this$getWrapper$capt === void 0 ? void 0 : _this$getWrapper$capt.getBlotInsertParams()
        }));
      }

      /**
       * Параметры клонирования колонки
       * @param { Ymap } map: map клонки
       * @returns { object }
       */
    }, {
      key: "getColCloneParams",
      value: function getColCloneParams(map) {
        var resultParams = {};
        var excludeParams = ['id'];
        if (map) {
          var params = map.toJSON();
          for (var key in params) {
            if (!excludeParams.includes(key)) {
              resultParams[key] = params[key];
            }
          }
        }
        return resultParams;
      }

      /**
       * Параметры клонирования строки
       * @param { Ymap } map: map строки
       * @returns { object }
       */
    }, {
      key: "getRowCloneParams",
      value: function getRowCloneParams(map) {
        var resultParams = {};
        var excludeParams = ['id', 'children'];
        if (map) {
          var params = map.toJSON();
          for (var key in params) {
            if (!excludeParams.includes(key)) {
              resultParams[key] = params[key];
            }
          }
        }
        return resultParams;
      }

      /**
       * Параметры клонирования ячейки
       * @param { object } pos: позиция ячейки
       * @param { Ymap } cellMap: map ячейки
       * @returns {object}
       */
    }, {
      key: "getCellCloneParams",
      value: function getCellCloneParams() {
        var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var cellMap = arguments.length > 1 ? arguments[1] : undefined;
        var i18n = this.editor.plugins.i18n;
        var cellType = this.getCellType(pos);
        var cellLink = this.getCellLink(pos);
        var colMap = this.colMapByIndex(pos.col);
        var childMap = this.childMapByPos(pos, {
          cellMap: cellMap
        });
        var copyParams = getCellCopyParams(cellType, cellMap, childMap, {
          colMap: colMap,
          cellLink: cellLink,
          i18n: i18n
        });
        return tableCopy_objectSpread(tableCopy_objectSpread({}, copyParams.params), {
          value: copyParams.value,
          text: copyParams.text
        });
      }

      /**
       * Клонировать таблицу
       * @returns {string} mapId нового блота
       */
    }, {
      key: "cloneSelf",
      value: function cloneSelf() {
        var _this3 = this;
        var content = this.getContent();
        var map = this.store.createMap();
        if (this.getWrapper().caption) {
          var captionMap = this.store.createMap();
          Caption.initMap(captionMap, this.store, {
            delta: this.getWrapper().caption.delta()
          });
          content.caption = captionMap.get('id');
        }
        this.editor.store.transaction(function () {
          parchment_default().query(_this3.map.get('type')).initMap(map, _this3.store, content);
        });
        return map.get('id');
      }
    }]);
    return _class;
  }(superclass);
};
/* harmony default export */ const tableCopy = (TableCopy);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/table.js










function table_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = table_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function table_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return table_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return table_arrayLikeToArray(o, minLen); }
function table_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


function getPos(x, y) {
  return x + 'x' + y;
}

// добавляет в объект ячейки, которые надо игнорировать из-за того что они поглощены colspan/rowspan
function addToIgnoreCells(ignoreCells, xCell, yCell, colspan, rowspan) {
  var value = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
  var xStart = xCell;
  var yStart = yCell;
  var xMax = xCell + colspan;
  var yMax = yCell + rowspan;
  for (var x = xStart; x < xMax; x++) {
    for (var y = yStart; y < yMax; y++) {
      ignoreCells[getPos(x, y)] = value;
    }
  }
}
function getDOMTableSize(table) {
  var width = 0;
  var tableBody = table;
  var tableBodyChildren = (0,dom/* querySelectorAllDirectChildren */.Im)(table, 'TBODY');
  if (tableBodyChildren.length) {
    tableBody = tableBodyChildren[0];
  }
  var rows = (0,dom/* querySelectorAllDirectChildren */.Im)(tableBody, 'tr');
  var getRowSize = function getRowSize(row) {
    var width = 0;
    var cells = (0,dom/* querySelectorAllDirectChildren */.Im)(row, 'td,th');
    var _iterator = table_createForOfIteratorHelper(cells),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var cell = _step.value;
        width += parseInt(cell.getAttribute('colspan')) || 1;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return width;
  };
  var _iterator2 = table_createForOfIteratorHelper(rows),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _row = _step2.value;
      width = Math.max(getRowSize(_row), width);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var height = 0;
  var y = 0;
  for (var _y = 0; _y < rows.length; _y++) {
    var row = rows[_y];
    var cell = (0,dom/* querySelectorAllDirectChildren */.Im)(row, 'td,th')[0];
    if (!cell) {
      continue;
    }
    var rowspan = parseInt(cell.getAttribute('rowspan')) || 1;
    height += rowspan;
    var colspan = parseInt(cell.getAttribute('colspan')) || 1;
    if (colspan === width) {} else {
      _y += rowspan - 1;
    }
  }
  return {
    width: width,
    height: height
  };
}
function distanceBetweenCells(cell1, cell2) {
  var colspan1 = cell1.colspan,
    rowspan1 = cell1.rowspan,
    x1 = cell1.positionX,
    y1 = cell1.positionY;
  var colspan2 = cell2.colspan,
    rowspan2 = cell2.rowspan,
    x2 = cell2.positionX,
    y2 = cell2.positionY;

  // определяем можем ли мы провести прямую между ячейками перпендикулярную обоим ячейкам
  // по X:
  if (doRangesIntersect(y1, y1 + rowspan1 - 1, y2, y2 + rowspan2 - 1)) {
    return Math.abs(x2 - x1);
  }
  // по Y:
  if (doRangesIntersect(x1, x1 + colspan1 - 1, x2, x2 + colspan2 - 1)) {
    return Math.abs(y2 - y1);
  }
  return distance({
    x: cell1.positionX,
    y: cell1.positionY
  }, {
    x: cell2.positionX,
    y: cell2.positionY
  });
}
function getOppositeCornerCell(targetCell, allCells) {
  var leftTopCell = allCells[0];
  var rightTopCell = allCells[0];
  var rightBottomCell = allCells[0];
  var leftBottomCell = allCells[0];

  // находим ячейки-углы квадрата
  var _iterator3 = table_createForOfIteratorHelper(allCells),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var cell = _step3.value;
      var x = cell.positionX,
        y = cell.positionY;
      var _leftTopCell = leftTopCell,
        leftTopX = _leftTopCell.positionX,
        leftTopY = _leftTopCell.positionY;
      var _rightTopCell = rightTopCell,
        rightTopX = _rightTopCell.positionX,
        rightTopY = _rightTopCell.positionY;
      var _rightBottomCell = rightBottomCell,
        rightBottomX = _rightBottomCell.positionX,
        rightBottomY = _rightBottomCell.positionY;
      var _leftBottomCell = leftBottomCell,
        leftBottomX = _leftBottomCell.positionX,
        leftBottomY = _leftBottomCell.positionY;
      if (x <= leftTopX && y <= leftTopY) {
        leftTopCell = cell;
      }
      if (x >= rightTopX && y <= rightTopY) {
        rightTopCell = cell;
      }
      if (x >= rightBottomX && y >= rightBottomY) {
        rightBottomCell = cell;
      }
      if (x <= leftBottomX && y >= leftBottomY) {
        leftBottomCell = cell;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  if (targetCell === leftTopCell) {
    return rightBottomCell;
  }
  if (targetCell === rightTopCell) {
    return leftBottomCell;
  }
  if (targetCell === rightBottomCell) {
    return leftTopCell;
  }
  if (targetCell === leftBottomCell) {
    return rightTopCell;
  }
  throw new Error('target cell must be part of the square selection');
}
function getFarthestCell(targetCell, allCells) {
  var confictResolutionPos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var farthestCell = null;
  var dist = 0;
  var conflictingCells = [];
  var _iterator4 = table_createForOfIteratorHelper(allCells),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var cell = _step4.value;
      var d = distanceBetweenCells(targetCell, cell);
      if (d > dist) {
        dist = d;
        farthestCell = cell;
        conflictingCells = [cell];
      } else if (d === dist) {
        farthestCell = cell;
        if (cell !== targetCell) {
          conflictingCells.push(cell);
        }
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  if (conflictingCells.length && confictResolutionPos) {
    conflictingCells.push(farthestCell);
    if (confictResolutionPos === 'top') {
      farthestCell = getItemWithMinFn(conflictingCells, function (item) {
        return item.positionY;
      });
    } else if (confictResolutionPos === 'bottom') {
      farthestCell = getItemWithMaxFn(conflictingCells, function (item) {
        return item.positionY;
      });
    } else if (confictResolutionPos === 'left') {
      farthestCell = getItemWithMinFn(conflictingCells, function (item) {
        return item.positionX;
      });
    } else if (confictResolutionPos === 'right') {
      farthestCell = getItemWithMaxFn(conflictingCells, function (item) {
        return item.positionX;
      });
    }
  }
  return farthestCell;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/pasteManager/elements.js
var blockElements = {
  'ADDRESS': true,
  'ARTICLE': true,
  'ASIDE': true,
  'BLOCKQUOTE': true,
  'DETAILS': true,
  'DIALOG': true,
  'DD': true,
  'DIV': true,
  'DL': true,
  'DT': true,
  'FIELDSET': true,
  'FIGCAPTION': true,
  'FIGURE': true,
  'FOOTER': true,
  'FORM': true,
  'HEADER': true,
  'HGROUP': true,
  'HR': true,
  'LI': true,
  'MAIN': true,
  'NAV': true,
  'P': true,
  'PRE': true,
  'SECTION': true
};
var inlineElements = {
  'B': true,
  'BIG': true,
  'I': true,
  'U': true,
  'SMALL': true,
  'TT': true,
  'ABBR': true,
  'ACRONYM': true,
  'CITE': true,
  'CODE': true,
  'DEL': true,
  'DFN': true,
  'EM': true,
  'KBD': true,
  'STRONG': true,
  'SAMP': true,
  'VAR': true,
  'A': true,
  'BDO': true,
  'BR': true,
  'IMG': true,
  'MAP': true,
  'OBJECT': true,
  'Q': true,
  'SCRIPT': true,
  'SPAN': true,
  'SUB': true,
  'SUP': true,
  'BUTTON': true,
  'INPUT': true,
  'LABEL': true,
  'SELECT': true,
  'TEXTAREA': true
};

// элементы, которые должны содержать дочерние элементы, иначе они признаются пустыми
var contanerElements = {
  'B': true,
  'BIG': true,
  'I': true,
  'SMALL': true,
  'TT': true,
  'ABBR': true,
  'ACRONYM': true,
  'CITE': true,
  'CODE': true,
  'DFN': true,
  'EM': true,
  'KBD': true,
  'STRONG': true,
  'SAMP': true,
  'VAR': true,
  'A': true,
  'BDO': true,
  'MAP': true,
  'Q': true,
  'SPAN': true,
  'SUB': true,
  'SUP': true,
  'BUTTON': true,
  'LABEL': true,
  'DIV': true
};

// элементы, которые будут обернуты в контейнер при условии что они являются прямым потомком контейнера,
// в котором есть другие контейнеры
// https://gl.nimbusweb.co/lib/editor/issues/723
var wrapInContainerElements = {
  STRONG: true,
  B: true,
  A: true
};
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/pasteManager/util.js
function pasteManager_util_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { pasteManager_util_typeof = function _typeof(obj) { return typeof obj; }; } else { pasteManager_util_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return pasteManager_util_typeof(obj); }
function pasteManager_util_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = pasteManager_util_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function pasteManager_util_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return pasteManager_util_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return pasteManager_util_arrayLikeToArray(o, minLen); }
function pasteManager_util_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
























var COMPOSABLE_STYLES = {
  'text-decoration-line': true
};
function getNodeStyles(node) {
  var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  for (var i = 0; i !== node.style.length; i++) {
    var name = node.style[i];
    if (COMPOSABLE_STYLES[name]) {
      if (!styles[name]) {
        styles[name] = [];
      }
      var val = node.style.getPropertyValue(name);
      if (styles[name].indexOf(val) < 0) {
        styles[name].push(val);
      }
    } else {
      styles[name] = node.style.getPropertyValue(name);
    }
  }
  return styles;
}
function bubbleStyles(node) {
  var limitFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var filterFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (!node || limitFn && !limitFn(node)) {
    return {};
  }
  var styles = bubbleStyles(node.parentNode, limitFn, filterFn);
  if (filterFn) {
    styles = filterFn(node.parentNode, styles);
  }
  if (node.style) {
    var nodeStyles = getNodeStyles(node, styles);
    if (filterFn) {
      nodeStyles = filterFn(node, nodeStyles);
    }
    Object.assign(styles, nodeStyles);
  }
  return styles;
}

// помещает дочерние элементы node вместо самой node
function extractNode(node) {
  var children = Array.from(node.childNodes);
  for (var _i = 0, _children = children; _i < _children.length; _i++) {
    var child = _children[_i];
    node.parentNode.insertBefore(child, node);
  }
  node.parentNode.removeChild(node);
}

// возврашает true если delta содержит пустой текст или только пробелы
function isEmptyDelta(delta) {
  var _iterator = pasteManager_util_createForOfIteratorHelper(delta.ops),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var op = _step.value;
      if (typeof op.insert === 'string') {
        var text = op.insert.trim();
        if (text) {
          return false;
        }
      } else {
        return false;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return true;
}
function isEmptyContainer(node) {
  return node.nodeType === Node.ELEMENT_NODE && contanerElements[node.tagName] && !node.childNodes.length;
}

// преобразует несколько рядом стоящих переносов строк в один
function fixMutipleConsecutiveLinebreaks(delta) {
  var isLineBreakOp = function isLineBreakOp(op) {
    return pasteManager_util_typeof(op.insert) === 'object' && op.insert.linebreak;
  };
  var newOps = [];
  var skipping = false;
  var _iterator2 = pasteManager_util_createForOfIteratorHelper(delta.ops),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var op = _step2.value;
      if (skipping && (isLineBreakOp(op) || typeof op.insert === 'string' && !op.insert.trim())) {
        continue;
      }
      skipping = false;
      newOps.push(op);
      if (isLineBreakOp(op)) {
        skipping = true;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return {
    ops: newOps
  };
}

// удаляет множественные переносы строк в конце, оставляя только один
// модифицирует входной параметр
function fixMutipleEndingLinebreaks(delta) {
  var preLastOpIdx = delta.ops.length - 2;
  if (preLastOpIdx < 1) {
    return delta;
  }
  if (pasteManager_util_typeof(delta.ops[preLastOpIdx].insert) === 'object' && delta.ops[preLastOpIdx].insert.linebreak) {} else {
    return delta;
  }
  var startDeleteIndex = preLastOpIdx - 1;
  while (startDeleteIndex >= 0) {
    if (pasteManager_util_typeof(delta.ops[startDeleteIndex].insert) === 'object' && delta.ops[startDeleteIndex].insert.linebreak) {
      startDeleteIndex--;
      continue;
    }
    startDeleteIndex++;
    break;
  }
  if (startDeleteIndex !== preLastOpIdx) {
    delta.ops.splice(startDeleteIndex, preLastOpIdx - startDeleteIndex);
  }
  return delta;
}

// удаляет переносы строк в конце дельты
// модифицирует входной параметр
function removeEndingLinebreaks(delta) {
  var endIndex = delta.ops.length - 1;
  while (endIndex >= 0) {
    var op = delta.ops[endIndex];
    if (typeof op.insert === 'string' && op.insert.trim()) {
      break;
    } else if (pasteManager_util_typeof(op.insert) === 'object' && !op.insert.linebreak) {
      break;
    }
    endIndex--;
  }
  delta.ops = delta.ops.slice(0, endIndex + 1);
  return delta;
}

// удаляет из дельты переносы строк и пустой текст в ее начале
function removeLeadingLinebreaks(delta) {
  var startIndex = 0;
  var _iterator3 = pasteManager_util_createForOfIteratorHelper(delta.ops),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var op = _step3.value;
      if (pasteManager_util_typeof(op.insert) === 'object' && op.insert.linebreak || typeof op.insert === 'string' && !op.insert.trim()) {
        startIndex++;
      } else {
        break;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  if (startIndex > 0) {
    delta.ops.splice(0, startIndex);
  }
  return delta;
}
function parseMarkdowns(plainText) {
  var escapes = '\\[!]#{()}*+-._';
  var esc_ofs = 16;
  var headers = ['h1', 'h2', 'h3'];
  var makeLinksFromUrls = function makeLinksFromUrls(content) {
    content = content.replace(urlRegex.url, function (text) {
      return '<a href="' + text + '">' + text + '</a>';
    });
    return content;
  };
  var wrapInline = function wrapInline(string) {
    return string.replace(/\\([(){}[\]#*+\-.!_\\])/g, function (match, char) {
      return String.fromCharCode(1, escapes.indexOf(char) + esc_ofs);
    }).replace(/(^|[\s*_`~><])(\*\*)(\S(?:[\s\S]*?\S)?)(\*\*)($|[\s*_`~><])/g, function (match, sep1, delim1, text, delim2, sep2) {
      return sep1 + '<strong>' + text + '</strong>' + sep2;
    }).replace(/(^|[\s*_~><])(\`)(\S(?:[\s\S]*?\S)?)(\`)($|[\s*_~><])/g, function (match, sep1, delim1, text, delim2, sep2) {
      return sep1 + '<code>' + text + '</code>' + sep2;
    }).replace(/(^|[\s_`~><])(\*)(\S(?:[\s\S]*?\S)?)(\*)($|[\s_`~><])/g, function (match, sep1, delim1, text, delim2, sep2) {
      return sep1 + '<em>' + text + '</em>' + sep2;
    }).replace(/(^|[\s*`~><])(\_)(\S(?:[\s\S]*?\S)?)(\_)($|[\s*`~><])/g, function (match, sep1, delim1, text, delim2, sep2) {
      return sep1 + '<u>' + text + '</u>' + sep2;
    }).replace(/(^|[\s*_`><])(\~)(\S(?:[\s\S]*?\S)?)(\~)($|[\s*_`><])/g, function (match, sep1, delim1, text, delim2, sep2) {
      return sep1 + '<del>' + text + '</del>' + sep2;
    });
  };
  var unesc = function unesc(content) {
    return content.replace(/\x01([\x0f-\x1c])/g, function (match, char) {
      return escapes.charAt(char.charCodeAt(0) - esc_ofs);
    });
  };
  // функция удаляет символ \n в конце последней строки, это нужно для того чтобы убрать пустую подстроку перед открытым тегом,
  // вызываем ее перед каждым открытием тега (исключение <li>, так как находится внутри тега <ul>) и передаем массив уже распарсеных линий
  var removeLastLineBreak = function removeLastLineBreak(lines) {
    if (!lines.length) return;
    lines[lines.length - 1] = lines[lines.length - 1].replace('\n', '');
  };
  var rows = plainText.replace('\r\n', '\n').split('\n');
  var result = [];
  var beginList = false;
  var beginText = false;
  var beginCode = false;
  var prevListItemIndentParams = false;
  for (var i = 0; i < rows.length; i++) {
    var row = rows[i];
    row = row.trim();
    // пропускаем пустые строки
    if (!row) {
      continue;
    }

    // if row starts with :PARSED: it is already parsed
    if (row.startsWith(':PARSED:')) {
      result.push(row.replace(':PARSED:', ''));
      continue;
    }
    var line = row;
    var html = '';

    // parse inline markdown image
    line = line.replace(/!\[(.*?)\]\(([^\s{]+)\)(\{.+?\})?/g, function (match, alt, src, attributes) {
      attributes = attributes ? attributes.substr(1).substr(0, attributes.length - 2).replace(/&quot;/g, '"') : '';
      return '\n:PARSED:<img src="' + src + '" alt="' + alt.replace('"', '\\"') + '" ' + attributes + '/>\n';
    });
    // parse inline iframes
    line = line.replace(/:iframe\[(.+?)\]\{(.+?)\}/g, function (match, title, attributes) {
      attributes = attributes.replace(/&quot;/g, '"');
      return '\n:PARSED:<iframe title="' + title.replace('"', '\\"') + '" ' + attributes + '></iframe>\n';
    });
    var lineParts = line.split('\n');
    // append line parts to rows, except the first line
    if (lineParts.length > 1) {
      for (var j = 1; j < lineParts.length; j++) {
        rows.splice(i + j, 0, lineParts[j]);
      }
      line = lineParts[0];
    }
    line = wrapInline(line);
    line = makeLinksFromUrls(line);
    var commentOpen = /^\s*(\/\*)/.test(line);
    if (commentOpen) {
      if (!beginCode) {
        removeLastLineBreak(result);
        html += '<pre>';
        beginCode = true;
      }
      html += line;
      var _commentClose = /(\*\/)$/.test(line);
      if (_commentClose) {
        html += '</pre>';
        beginCode = false;
      }
      result.push(html);
      continue;
    }
    // тут продублировал, потому что комментарий может быть в несколько строк
    var commentClose = /(\*\/)$/.test(line);
    if (commentClose) {
      html += '</pre>';
      beginCode = false;
    }
    // parse raw line with all spaces for multilvl lists
    var list = /^(\s*)(?:[\*\-\+]|(\d+[.)])|(\[\])) (.+)/.exec(rows[i]);
    if (list) {
      // вычисляем уровень лист айтема
      var indent = 0;
      if (list[1].length) {
        if (prevListItemIndentParams) {
          if (list[1].length > prevListItemIndentParams.spaces) {
            indent = prevListItemIndentParams.indent + 1;
          } else if (list[1].length < prevListItemIndentParams.spaces) {
            indent = prevListItemIndentParams.indent - 1;
          } else if (list[1].length === prevListItemIndentParams.spaces) {
            indent = prevListItemIndentParams.indent;
          }
        } else {
          indent = 1;
        }
        prevListItemIndentParams = {
          spaces: list[1].length,
          indent: indent
        };
      } else if (prevListItemIndentParams) {
        prevListItemIndentParams = false;
      }
      if (indent < 0) {
        indent = 0;
      }
      // если лист начат или распознан не нумерованый элемент списка или лист не начат и распознан нумерованный элемент списка начинающийся с 1
      // оборачиваем в список, если же лист не начат и распознан элемент начинающийся не с 1 то пропускаем
      if (beginList || !list[2] || list[2].startsWith('1')) {
        if (!beginList) {
          removeLastLineBreak(result);
          html += '<ul>';
          beginList = true;
        }
        var listType = 'bullet';
        if (list[2]) {
          listType = 'number';
        } else if (list[3]) {
          listType = 'checkbox';
        }
        var classString = "list-item-".concat(listType);
        if (indent > 0) {
          classString += " indent-".concat(indent);
        }
        html += '<li class="' + classString + '">' + list[4] + '</li>';
        result.push(html);
        continue;
      }
    }
    if (beginList) {
      html += '</ul>';
      beginList = false;
      if (prevListItemIndentParams) {
        prevListItemIndentParams = false;
      }
    }
    var head = /^\s{0,3}(\#{1,3})\s+(.*?)\s*#*\s*$/.exec(line);
    if (head) {
      removeLastLineBreak(result);
      html += '<' + headers[head[1].length - 1] + '>' + head[2] + '</' + headers[head[1].length - 1] + '>';
      result.push(html);
      continue;
    }
    var quote = /^\s{0,3}(?:[\"]|&quot;) (.+)$/.exec(line);
    if (quote) {
      removeLastLineBreak(result);
      html += '<blockquote>' + quote[1] + '</blockquote>';
      result.push(html);
      continue;
    }
    if (/^\s{0,3}([-])(\s*\1){2,}\s*$/.test(line)) {
      removeLastLineBreak(result);
      html += '<hr/>';
      result.push(html);
      continue;
    }
    html += line + '\n';
    result.push(html);
  }
  return unesc(result.join(''));
}
function pastedContentIsLink(blotsData) {
  // провеяем наличие не текстовых блоков или наличие в текстоквых блоках больше одной операции
  if (blotsData.filter(function (blotData) {
    return blotData.type !== 'textLine' || blotData.initParams.delta.ops.filter(function (op) {
      return op.insert !== '\n';
    }).length > 1;
  }).length) return false;
  // отсеиваем пустые строки
  var filteredData = blotsData.filter(function (blotData) {
    return blotData.initParams.delta.ops[0].insert !== '\n';
  });
  if (filteredData.length > 1 || filteredData.length === 0) return false;
  var op = filteredData[0].initParams.delta.ops[0];
  if (op.hasOwnProperty('attributes') && op.attributes.hasOwnProperty('link') && op.insert.trim() === op.attributes.link) {
    return op.insert.trim();
  } else {
    if (op.insert && op.insert.trim && stringIsUrl(op.insert.trim())) {
      return op.insert.trim();
    }
  }
  return false;
}
function prepareColorAttributesForInlineCode(delta) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var ops = [];
  var attrsHasBackground = attrs.background && Array.isArray(attrs.background);
  var attrsHasColor = attrs.color && Array.isArray(attrs.color);
  var _iterator4 = pasteManager_util_createForOfIteratorHelper(delta.ops),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var op = _step4.value;
      if (op.attributes) {
        var _op$attributes = op.attributes,
          color = _op$attributes.color,
          background = _op$attributes.background,
          code = _op$attributes.code;
        if (code) {
          if (color && attrsHasColor && attrs.color.includes(color)) {
            delete op.attributes.color;
          }
          if (background && attrsHasBackground && attrs.background.includes(background)) {
            delete op.attributes.background;
          }
        } else {
          // эта функция не работает если отформатировать текст внутри кода цветом текста или хайлайтом,
          // выделить только текст внутри inline code и вставить, потому что браузер возвращает span со цветами,
          // по которым не возможно определить inline code

          // в темной и светлой теме разные цвета текста из-за opacity
          if (color && attrsHasColor && attrs.color.includes(color) && background && attrsHasBackground && attrs.background.includes(background)) {
            delete op.attributes.color;
            delete op.attributes.background;
            op.attributes.code = true;
          }
        }
      }
      ops.push(op);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return {
    ops: ops
  };
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/pasteManager/deserializers/textAbstract.js










var _SKIP_HIGHLIGHT_COLOR;
function textAbstract_toConsumableArray(arr) { return textAbstract_arrayWithoutHoles(arr) || textAbstract_iterableToArray(arr) || textAbstract_unsupportedIterableToArray(arr) || textAbstract_nonIterableSpread(); }
function textAbstract_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function textAbstract_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function textAbstract_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return textAbstract_arrayLikeToArray(arr); }
function textAbstract_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = textAbstract_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function textAbstract_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return textAbstract_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return textAbstract_arrayLikeToArray(o, minLen); }
function textAbstract_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function textAbstract_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { textAbstract_typeof = function _typeof(obj) { return typeof obj; }; } else { textAbstract_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return textAbstract_typeof(obj); }










function textAbstract_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var EDITOR_HIGHLIGHT_COLOR = 'rgb(242, 242, 242)';
var EDITOR_DARK_THEME_BG = 'rgb(50, 50, 50)';
var EDITOR_LIGHT_THEME_SELECTED_BLOCK_COLOR = 'rgba(0, 0, 0, 0.05)';
var EDITOR_DARK_THEME_SELECTED_BLOCK_COLOR = 'rgba(255, 255, 255, 0.16)';
var SKIP_HIGHLIGHT_COLORS = (_SKIP_HIGHLIGHT_COLOR = {}, textAbstract_defineProperty(_SKIP_HIGHLIGHT_COLOR, EDITOR_HIGHLIGHT_COLOR, true), textAbstract_defineProperty(_SKIP_HIGHLIGHT_COLOR, EDITOR_DARK_THEME_BG, true), textAbstract_defineProperty(_SKIP_HIGHLIGHT_COLOR, 'rgb(255, 255, 255)', true), textAbstract_defineProperty(_SKIP_HIGHLIGHT_COLOR, 'rgb(0, 0, 0)', true), textAbstract_defineProperty(_SKIP_HIGHLIGHT_COLOR, EDITOR_LIGHT_THEME_SELECTED_BLOCK_COLOR, true), textAbstract_defineProperty(_SKIP_HIGHLIGHT_COLOR, EDITOR_DARK_THEME_SELECTED_BLOCK_COLOR, true), _SKIP_HIGHLIGHT_COLOR);
// цвета, которые возвращает нода при вставке inline-code из редактора
var INLINE_CODE_COLORS = {
  color: [colors_palette.red, colors_palette.brown],
  // цвета текста inline-code в темной и светлой теме
  background: ['#f8d3df'] // цвета бэкграунда, #f8d3df такого цвета в палитре нет, он достигается за счет opacity
};
// палитра
var textAbstract_palette = Object.values(matNeutralPalette);
var ALLOW_INNER_TAGS = {
  'SPAN': function SPAN(node, context, options) {
    if ((node.classList.contains('mention') || node.classList.contains('mention-link')) && node.getAttribute('data-mention-id') && node.getAttribute('data-mention-type') && node.getAttribute('data-mention-name') && node.getAttribute('data-mention-object_id') && !options.onlyText) {
      return {
        dontProcessChildren: true,
        insert: {
          mention: {
            id: generateMentionId(),
            type: node.getAttribute('data-mention-type'),
            name: node.getAttribute('data-mention-name'),
            object_id: node.getAttribute('data-mention-object_id')
          }
        }
      };
    } else if (node.classList.contains('date-inline')) {
      var value = date_Date.value(node);
      delete value.dateId;
      return {
        dontProcessChildren: true,
        insert: {
          date: value
        }
      };
    } else {
      return true;
    }
  },
  'NIMBUS-BUTTON': function NIMBUSBUTTON(node, context, options) {
    if (node.classList.contains('inline-button')) {
      return {
        dontProcessChildren: true,
        insert: {
          button: JSON.stringify({
            id: node.getAttribute('id'),
            title: node.getAttribute('data-title'),
            url: node.getAttribute('data-url'),
            target: node.getAttribute('data-target'),
            shape: node.getAttribute('data-shape'),
            background: node.getAttribute('data-background'),
            size: node.getAttribute('data-size')
          })
        }
      };
    }
    return true;
  },
  'SMALL': true,
  'INS': true,
  'SUB': true,
  'SUP': true,
  'MARK': true,
  'FONT': true,
  'TIME': true,
  'LABEL': true,
  'A': function A(a) {
    return {
      attributes: {
        link: a.getAttribute('href')
      }
    };
  },
  'BR': function BR(node, context, options) {
    var res = {
      insert: {
        linebreak: 's'
      }
    };
    if (options.onlyText) {
      res.insert = ' ';
    }
    return res;
  },
  'I': {
    attributes: {
      italic: true
    }
  },
  'B': {
    attributes: {
      bold: true
    }
  },
  'STRONG': {
    attributes: {
      bold: true
    }
  },
  'U': {
    attributes: {
      underline: true
    }
  },
  'EM': {
    attributes: {
      italic: true
    }
  },
  'DEL': {
    attributes: {
      strikethrough: true
    }
  },
  'STRIKE': {
    attributes: {
      strikethrough: true
    }
  },
  'CODE': {
    attributes: {
      code: true
    }
  },
  'TT': {
    attributes: {
      code: true
    }
  }
};
var SKIP_PROCESS_LINEBREAK_BETWEEN_LINES = ['BLOCKQUOTE'];
function textAbstract_getColorName(color) {
  return Object.keys(matNeutralPalette).find(function (colorName) {
    return matNeutralPalette[colorName] === color;
  });
}
function getBackgroundFromAttribute(node) {
  if (node.parentNode) {
    if (node.parentNode.getAttribute && node.parentNode.getAttribute('data-highlight')) {
      return node.parentNode.getAttribute('data-highlight');
    } else {
      return getBackgroundFromAttribute(node.parentNode);
    }
  }
  return false;
}
function tryConvertColorsToHighlight(attributes) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!attributes.background) return;
  var highlightName = null;
  var colorName = null;
  for (var name in matNeutralPalette) {
    var normalizedValue = matNeutralPalette[name].toLowerCase();
    if (!highlightName && normalizedValue === attributes.background.toLowerCase()) {
      highlightName = name;
    }
    if (!colorName && attributes.color && normalizedValue === attributes.color.toLowerCase()) {
      colorName = name;
    }
    if (highlightName && colorName) break;
  }
  if (highlightName) {
    attributes.background = highlightName;
  }
}
function isEqualAttributes(attrs1, attrs2) {
  if (typeof attrs1 === 'undefined' && typeof attrs2 === 'undefined') {
    return true;
  }
  if (!attrs1) {
    attrs1 = {};
  }
  if (!attrs2) {
    attrs2 = {};
  }
  for (var k in attrs1) {
    if (attrs2[k] !== attrs1[k]) {
      return false;
    }
  }
  for (var _k in attrs2) {
    if (attrs2[_k] !== attrs1[_k]) {
      return false;
    }
  }
  return true;
}
function getNodeOpts(node, options, context) {
  var opts = null;
  if (options.allowInnerTags.hasOwnProperty(node.tagName)) {
    opts = options.allowInnerTags[node.tagName];
  } else if (blockElements[node.tagName] && options.allowInnerTags['*BLOCK']) {
    opts = options.allowInnerTags['*BLOCK'];
  } else if (node instanceof HTMLUnknownElement) {
    // обрабатываем неизвестные элементы как если бы они были инлайновыми элементами
    opts = true;
  }
  if (typeof opts === 'function') {
    opts = opts(node, context, options);
  }
  return opts;
}
function canProcessNode(node, options, context) {
  if (getNodeOpts(node, options, context) || node.nodeType === Node.TEXT_NODE) {
    return true;
  }
  return false;
}
function addOpAttributes(op) {
  var anyAttributesHasValues = false;
  for (var _len = arguments.length, attributesArr = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    attributesArr[_key - 1] = arguments[_key];
  }
  for (var _i = 0, _attributesArr = attributesArr; _i < _attributesArr.length; _i++) {
    var attrs = _attributesArr[_i];
    if (Object.keys(attrs).length) {
      anyAttributesHasValues = true;
      break;
    }
  }
  if (!anyAttributesHasValues) {
    return op;
  }
  op.attributes = Object.assign.apply(Object, [{}].concat(attributesArr));
  return op;
}
function bubbleAttributes(node) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var style = bubbleStyles(node, options.bubbleStylesLimitFn, options.bubbleStylesFilterFn);
  var inlineStyles = bubbleStyles(node, function (node) {
    return !node.tagName || inlineElements[node.tagName];
  });
  var attributes = {};
  if (style['font-style'] === 'italic') {
    attributes.italic = true;
  }
  if (style['font-weight'] === 'bold' || style['font-weight'] > 400) {
    attributes.bold = true;
  }
  if (style['text-decoration-line']) {
    if (style['text-decoration-line'].indexOf('underline') >= 0) {
      attributes.underline = true;
    }
    if (style['text-decoration-line'].indexOf('line-through') >= 0) {
      attributes.strikethrough = true;
    }
  }
  if (style['text-decoration']) {
    if (style['text-decoration'] === 'line-through') {
      attributes.strikethrough = true;
    }
    if (style['text-decoration'] === 'underline') {
      attributes.underline = true;
    }
  }
  if (inlineStyles['color'] && isRealColor(inlineStyles['color'])) {
    attributes.color = getClosestColor(inlineStyles['color'], textAbstract_palette, null);
    if (!attributes.color) {
      delete attributes.color;
    } else {
      var colorName = textAbstract_getColorName(attributes.color);
      if (colorName) {
        attributes.color = colorName;
      }
    }
  }
  // при установке фона игнорируем цвет которым мы подсвечиваем блоки при ховере, т.к. хром копирует это цвет как
  // фон если при копировании текста курсор был на блоте либо было выделено несколько блотов
  if (inlineStyles['background-color'] && !Object.keys(SKIP_HIGHLIGHT_COLORS).some(function (skipColor) {
    return isColorsEqual(skipColor, inlineStyles['background-color']);
  }) && !SKIP_HIGHLIGHT_COLORS[inlineStyles['background-color']] && isRealColor(inlineStyles['background-color'])) {
    attributes.background = getClosestColor(inlineStyles['background-color'], textAbstract_palette, null);
    // если не удалось подобрать цвет хайлайта или ближайший цвет запрещен как цвет хайлайта, то убираем хайлайт
    if (!attributes.background) {
      delete attributes.background;
    } else {
      var _colorName = textAbstract_getColorName(attributes.background);
      if (_colorName) {
        attributes.background = _colorName;
      }
    }
  }
  if (!attributes.background && node.nodeType === 3) {
    var backgroundAttribute = getBackgroundFromAttribute(node);
    if (backgroundAttribute) {
      attributes.background = backgroundAttribute;
    }
  }
  if (attributes.background && isRealColor(attributes.background)) {
    tryConvertColorsToHighlight(attributes, options);
  }
  return attributes;
}
function flattenNode(node) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var res = [];
  if (!canProcessNode(node, options, context)) {
    return [node];
  }
  if (node.nodeType === Node.TEXT_NODE) {
    var text = node.textContent;
    // символы переноса строки и возврата каретки не должны быть в дельте(кроме конца дельты)
    text = text.replace(/[\r\n] ?/g, ' ');
    if (!text) {
      return [];
    }
    context.stringOpMade = true;
    if (!context.nonEmptyStringOpMade && text.trim()) {
      context.nonEmptyStringOpMade = true;
    }
    return [addOpAttributes({
      insert: text
    }, attributes, bubbleAttributes(node, options))];
  }
  attributes = Object.assign({}, attributes);
  var opts = getNodeOpts(node, options, context);
  var dontProcessChildren = false;
  if (opts) {
    if (textAbstract_typeof(opts) === 'object') {
      if (opts.attributes) {
        attributes = Object.assign(attributes, opts.attributes);
      }
      if (opts.insert) {
        context.opMade = true;
        if (typeof opts.insert === 'string') {
          context.stringOpMade = true;
          if (!context.nonEmptyStringOpMade && opts.insert.trim()) {
            context.nonEmptyStringOpMade = true;
          }
        }
        res.push({
          insert: opts.insert
        });
      }
      if (opts.dontProcessChildren) {
        dontProcessChildren = true;
      }
    }
  }
  if (!dontProcessChildren) {
    var _iterator = textAbstract_createForOfIteratorHelper(node.childNodes),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var child = _step.value;
        res.push.apply(res, textAbstract_toConsumableArray(flattenNode(child, options, attributes, context)));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return res;
}
function addOp(ops, op) {
  var lastIndex = ops.length - 1;
  if (ops.length === 0 || !isEqualAttributes(ops[lastIndex].attributes, op.attributes) || typeof op.insert !== 'string' || typeof ops[lastIndex].insert !== 'string') {
    ops.push(op);
  } else {
    ops[lastIndex].insert += op.insert;
  }
  return ops;
}
function prepareTextElemData(textElemData) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!opts.tagName || !SKIP_PROCESS_LINEBREAK_BETWEEN_LINES.includes(opts.tagName)) {
    textElemData.initParams.delta = fixMutipleEndingLinebreaks(textElemData.initParams.delta);
    textElemData.initParams.delta = fixMutipleConsecutiveLinebreaks(textElemData.initParams.delta);
  }
  textElemData.initParams.delta = removeLeadingLinebreaks(textElemData.initParams.delta);
  textElemData.initParams.delta = ensureDeltaEndsWithNewLine(textElemData.initParams.delta);
  textElemData.initParams.delta = prepareColorAttributesForInlineCode(textElemData.initParams.delta, INLINE_CODE_COLORS);
  return textElemData;
}
function isLineBreakOp(op) {
  if (!op) {
    return false;
  }
  return op.insert && op.insert.linebreak === 's';
}
function deserializeText(node, body) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  options = Object.assign({}, options);
  if (options.allowInnerTags) {
    options.allowInnerTags = Object.assign({}, ALLOW_INNER_TAGS, options.allowInnerTags);
  } else {
    options.allowInnerTags = ALLOW_INNER_TAGS;
  }
  // сначало нам надо поместить все дочерние элементы в плоский список
  // в результате мы должны получить фрагменты дельт и элементы, которые не могут быть обработаны
  var childList = [];
  var context = {};
  var _iterator2 = textAbstract_createForOfIteratorHelper(node.childNodes),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _childList;
      var _child = _step2.value;
      (_childList = childList).push.apply(_childList, textAbstract_toConsumableArray(flattenNode(_child, options, {}, context)));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  if (options.skipUnknownNodes) {
    childList = childList.filter(function (child) {
      return !(child instanceof Element);
    });
  }

  // объединяем близлежащие дельты в единые параграфы
  var res = [];
  var textElemData = null;
  for (var i = 0; i < childList.length; i++) {
    var child = childList[i];
    if (child instanceof Element) {
      if (isEmptyContainer(child)) {
        // пропускаем пустые контейнер-элементы
        continue;
      }
      if (textElemData) {
        addOp(textElemData.initParams.delta.ops, {
          insert: '\n'
        });
        res.push(prepareTextElemData(textElemData, {
          tagName: node.tagName
        }));
        textElemData = null;
      }
      res.push(child);
    } else if (isLineBreakOp(child) && isLineBreakOp(childList[i + 1]) && !SKIP_PROCESS_LINEBREAK_BETWEEN_LINES.includes(node.tagName)) {
      i++;
      // двойной перенос строки считаем за новый textLine
      if (textElemData) {
        addOp(textElemData.initParams.delta.ops, {
          insert: '\n'
        });
        res.push(prepareTextElemData(textElemData, {
          tagName: node.tagName
        }));
        textElemData = null;
      }
      continue;
    } else {
      if (!textElemData) {
        textElemData = {
          initParams: {
            delta: {
              ops: []
            }
          }
        };
      }
      addOp(textElemData.initParams.delta.ops, child);
    }
  }
  if (textElemData) {
    addOp(textElemData.initParams.delta.ops, {
      insert: '\n'
    });
    res.push(prepareTextElemData(textElemData, {
      tagName: node.tagName
    }));
  }
  return res;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/pasteManager/deserializers/table.js
function table_toConsumableArray(arr) { return table_arrayWithoutHoles(arr) || table_iterableToArray(arr) || deserializers_table_unsupportedIterableToArray(arr) || table_nonIterableSpread(); }
function table_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function table_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function table_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return deserializers_table_arrayLikeToArray(arr); }
function table_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { table_typeof = function _typeof(obj) { return typeof obj; }; } else { table_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return table_typeof(obj); }
function deserializers_table_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = deserializers_table_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function deserializers_table_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return deserializers_table_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return deserializers_table_arrayLikeToArray(o, minLen); }
function deserializers_table_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

























var TAGS = {
  'TABLE': {
    excludeClass: 'highlight'
  }
};
var UNWRAP_TAGS = {
  'TFOOT': true
};
var HEAD_TAG = 'THEAD';
var BODY_TAG = 'TBODY';
var ROW_TAG = 'TR';
var CELL_TAGS = {
  'TD': true,
  'TH': true
};
var CELLS_DELTA = ['text', 'link', 'mention', 'number', 'currency'];
var tableBackgroundColors = Object.values(backgrounds);
function mergeTexts(items) {
  items = items.filter(function (item) {
    return item.initParams;
  });
  var deltas = items.map(function (item) {
    return item.initParams.delta;
  });
  return mergeDeltas(deltas);
}
function prepareTable(node) {
  var children = Array.from(node.childNodes);
  for (var _i = 0, _children = children; _i < _children.length; _i++) {
    var child = _children[_i];
    if (UNWRAP_TAGS[child.tagName]) {
      extractNode(child);
    }
  }
}
function getTableRows(node, wrapTag) {
  var rows = [];
  var _iterator = deserializers_table_createForOfIteratorHelper(node.childNodes),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var child = _step.value;
      if (wrapTag) {
        if (child.tagName === wrapTag) {
          return getTableRows(child);
        } else {
          continue;
        }
      }
      if (child.tagName === ROW_TAG) {
        rows.push(child);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return rows;
}
function getRowCells(row) {
  var cells = [];
  var _iterator2 = deserializers_table_createForOfIteratorHelper(row.childNodes),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var child = _step2.value;
      if (CELL_TAGS[child.tagName]) {
        cells.push(child);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return cells;
}
function getAttrValue(node, attr) {
  var value = node.getAttribute(attr);
  if (value && value[0] == '{') {
    var elem = document.createElement('textarea');
    elem.innerHTML = value;
    try {
      value = JSON.parse(elem.value);
    } catch (ex) {
      console.warn(ex);
      value = elem.value;
    }
  }
  return value;
}
function parseTable(node, body) {
  prepareTable(node);
  var rows = getTableRows(node);
  if (!rows.length) {
    rows = getTableRows(node, BODY_TAG);
  }
  var head = getTableRows(node, HEAD_TAG);
  var rowsContent = [];
  var colsContent = [];
  var hiddenCellsByRow = {};
  var unparsedNodes = [];
  var _getDOMTableSize = getDOMTableSize(node),
    colsCount = _getDOMTableSize.width,
    rowsCount = _getDOMTableSize.height;
  if (table_typeof(head) == "object" && head[0]) {
    var row = head[0];
    var cells = Array.from(row.querySelectorAll('td,th'));
    cells = cells.filter(function (cell) {
      return cell.parentNode === row;
    });
    var cellsInitParams = [];
    for (var ci = 0; ci !== colsCount; ci++) {
      colsContent[ci] = {};
      var th = cells.shift();
      var _iterator3 = deserializers_table_createForOfIteratorHelper(CONFIG.col.copy),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var key = _step3.value;
          var value = getAttrValue(th, key);
          if (typeof value !== 'undefined') {
            colsContent[ci][key] = value;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      var width = parseInt(th.getAttribute('width')) || false;
      if (width) {
        colsContent[ci].width = width;
      }
      var text = th.innerText;
      if (text) {
        colsContent[ci].text = th.innerText.trim();
      }
    }
  }
  var _loop = function _loop(ri) {
    var singleRowContent = {};
    var row = rows[ri];
    if (row.hasAttribute('height')) {
      var height = parseInt(row.getAttribute('height')) || false;
      if (height) singleRowContent.height = height;
    }
    var cells = Array.from(row.querySelectorAll('td,th'));
    cells = cells.filter(function (cell) {
      return cell.parentNode === row;
    });
    var cellsInitParams = [];
    for (var _ci = 0; _ci !== colsCount; _ci++) {
      if (hiddenCellsByRow[ri] && hiddenCellsByRow[ri][_ci]) {
        cellsInitParams.push({
          delta: {
            ops: [{
              insert: '\n'
            }]
          },
          hidden: true,
          colspan: 1,
          rowspan: 1
        });
        continue;
      }
      var cell = cells.shift();
      if (!cell) {
        // таблица содержит меньше ячеек чем нужно в данной строке
        // добавляем пустую ячейку
        cellsInitParams.push({
          delta: {
            ops: [{
              insert: '\n'
            }]
          },
          colspan: 1,
          rowspan: 1
        });
        continue;
      }
      var colspan = 1;
      var rowspan = 1;
      var cellStyles = getNodeStyles(cell);
      if (cell.getAttribute('colspan') && cell.getAttribute('colspan') > 1) {
        colspan = parseInt(cell.getAttribute('colspan'));
      }
      if (cell.getAttribute('rowspan') && cell.getAttribute('rowspan') > 1) {
        rowspan = parseInt(cell.getAttribute('rowspan'));
      }
      if (colspan > 1 || rowspan > 1) {
        var maxRowIndex = ri + rowspan - 1;
        for (var rri = ri; rri !== rowsCount && rri <= maxRowIndex; rri++) {
          if (!hiddenCellsByRow[rri]) {
            hiddenCellsByRow[rri] = {};
          }
          var maxColIndex = _ci + colspan - 1;
          for (var cci = _ci; cci <= maxColIndex; cci++) {
            hiddenCellsByRow[rri][cci] = {};
          }
        }
      }
      if (colspan === colsCount) {
        for (var k = 0; k < rowspan - 1; k++) {
          rows.splice(ri + 1, 0, document.createElement('tr'));
        }
      }
      var cellParams = {
        colspan: colspan,
        rowspan: rowspan
      };
      var _iterator4 = deserializers_table_createForOfIteratorHelper(CONFIG.cell.copy),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _key = _step4.value;
          var _value2 = getAttrValue(cell, _key);
          if (typeof _value2 !== 'undefined' && _value2) {
            if (_value2 === 'true') {
              _value2 = true;
            }
            if (_value2 === 'false') {
              _value2 = false;
            }
            cellParams[_key] = _value2;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      if (!cellParams.color && cellStyles['background-color'] && isRealColor(cellStyles['background-color'])) {
        var color = getClosestColor(cellStyles['background-color'], tableBackgroundColors, null);
        if (color) {
          cellParams.color = color;
        }
      }
      if (!cellParams.cellType) {
        if (cellParams.type) {
          cellParams.cellType = getTypeFromName(cellParams.type);
        } else {
          cellParams.cellType = 'text';
        }
      }
      if (!cellParams.cellType || CELLS_DELTA.includes(cellParams.cellType)) {
        // ни один тип ячейки не смог обработать этот html элемент, обрабатываем как текст
        var deserializeTextResult = deserializeText(cell, body, {
          onlyText: cellParams.cellType !== 'mention',
          bubbleStylesFilterFn: function bubbleStylesFilterFn(node, styles) {
            if (node && node.tagName === 'TD' && styles) {
              delete styles['background-color'];
            }
            return styles;
          },
          allowInnerTags: {
            '*BLOCK': function BLOCK(node, context) {
              if (context.stringOpMade) {
                return {
                  insert: ' '
                };
              }
              return true;
            },
            'BR': function BR(node, context) {
              return {
                insert: {
                  linebreak: 's'
                }
              };
            }
          }
        });
        var textItems = [];
        var _iterator5 = deserializers_table_createForOfIteratorHelper(deserializeTextResult),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var item = _step5.value;
            if (item instanceof Element) {
              unparsedNodes.push(item);
            } else {
              textItems.push(item);
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        var delta = mergeTexts(textItems);
        delta = trimSpaces(delta);
        Object.assign(cellParams, {
          delta: delta
        });
      }
      cellsInitParams.push(cellParams);
    }
    singleRowContent.children = cellsInitParams;
    rowsContent.push(singleRowContent);
  };
  for (var ri = 0; ri < rows.length; ri++) {
    _loop(ri);
  }
  var table = {
    cols: colsCount,
    rows: rowsCount,
    lineByLine: true,
    content: {
      rows: rowsContent,
      columns: colsContent
    }
  };
  var attributes = [{
    name: 'columnHeadingsMode',
    type: 'boolean'
  }, {
    name: 'rowHeadingsMode',
    type: 'boolean'
  }, {
    name: 'wrapCellsMode',
    type: 'boolean'
  }, {
    name: 'fullwidthMode',
    type: 'boolean'
  }, {
    name: 'embedAlign',
    type: 'string'
  }, {
    name: 'embed-align',
    type: 'string'
  }, {
    name: 'color',
    type: 'string'
  }];
  for (var _i2 = 0, _attributes = attributes; _i2 < _attributes.length; _i2++) {
    var attr = _attributes[_i2];
    if (node.hasAttribute(attr.name)) {
      var _value = node.getAttribute(attr.name);
      if (attr.type === 'boolean') {
        _value = _value === 'true' || _value === true ? true : false;
      }
      table[attr.name] = _value;
    }
  }
  var parseResult = {
    unparsedNodes: unparsedNodes,
    table: table
  };
  return parseResult;
}
function deserializeTable(node, body) {
  var tagName = node.tagName;
  if (!TAGS.hasOwnProperty(tagName)) {
    return null;
  }
  if (node.classList.contains(TAGS.TABLE.excludeClass)) {
    return null;
  }
  var parseResult = parseTable(node, body);
  if (!parseResult) {
    return null;
  }
  var res = [];
  if (parseResult.table) {
    res.push({
      type: 'table',
      initParams: parseResult.table
    });
  }
  res.push.apply(res, table_toConsumableArray(parseResult.unparsedNodes));
  return res;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/tableInitInnerMap.js
function tableInitInnerMap_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function tableInitInnerMap_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { tableInitInnerMap_ownKeys(Object(source), true).forEach(function (key) { tableInitInnerMap_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { tableInitInnerMap_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function tableInitInnerMap_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function tableInitInnerMap_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { tableInitInnerMap_typeof = function _typeof(obj) { return typeof obj; }; } else { tableInitInnerMap_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return tableInitInnerMap_typeof(obj); }




















/**
 * Создает map для внутренних элементов таблицы: колонок, строк, ячеек и их потомков разных типов
 * @param { store } store
 * @param { string } type: тип map
 * @param { object | Ymap } props?: Значения для записи в map, будут отфильтрованы согласно типу
 *                                  Может быть передан другой Ymap для копирования его свойств
 * @param { object } options?
 * @param { boolean } options.onlyIfNecessary?: создавать map только если есть
 * @param { boolean } options.initChild?: создавать child для cell
 * @returns { Ymap | false }
 */
function initInnerMap(store, type) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  if (props instanceof store.types.Map) {
    props = props.toJSON();
    delete props.id;
  }
  var map = false;
  if (type === 'column') {
    var mapProps = (0,util/* filterProps */.L6)(props, CONFIG.col.copy, CONFIG.types);
    map = store.createMap(false, Object.assign(mapProps, {
      type: 'column'
    }));
  } else if (type === 'row') {
    var _mapProps = (0,util/* filterProps */.L6)(props, CONFIG.row.copy, CONFIG.types);
    map = store.createMap(false, Object.assign(_mapProps, {
      type: 'row',
      children: new store.types.Array()
    }));
  } else if (type === 'cell') {
    var _mapProps2 = (0,util/* filterProps */.L6)(props, CONFIG.cell.copy, CONFIG.types);
    if (!options.comments) {
      delete _mapProps2.commentThreads;
    }
    var typeData = getTypeData(props.cellType);
    _mapProps2.type = typeData.type;
    var parsedProps = parseTypeProps(props.cellType, props, store);
    if (tableInitInnerMap_typeof(typeData.value) === 'object' && typeData.value.key !== 'characters') {
      // Нетекстовые типы ячеек
      Object.assign(_mapProps2, parsedProps);
    } else {
      var _props$children;
      //  Текстовые типы ячейки
      _mapProps2.children = new store.types.Array();
      if (options.initChild || parsedProps.delta || (_props$children = props.children) !== null && _props$children !== void 0 && _props$children.length) {
        var _props$children2;
        var childProps = {};
        if ((_props$children2 = props.children) !== null && _props$children2 !== void 0 && _props$children2.length) {
          var childId = props.children[0];
          var _childMap = store.getMap(childId);
          childProps = _childMap.toJSON();
          delete childProps.id;
          delete childProps.characters;
        }
        var childMap = initInnerMap(store, 'child', tableInitInnerMap_objectSpread(tableInitInnerMap_objectSpread(tableInitInnerMap_objectSpread({}, props), childProps), parsedProps));
        _mapProps2.children.push([childMap.get('id')]);
      }
    }
    if (!options.onlyIfNecessary || Object.keys(_mapProps2).length > 1) {
      var createMap = Object.assign({}, _mapProps2);
      for (var _i = 0, _arr = ['value', 'delta']; _i < _arr.length; _i++) {
        var prop = _arr[_i];
        if (createMap.hasOwnProperty(prop)) {
          delete createMap[prop];
        }
      }
      map = store.createMap(false, createMap);
    }
  } else if (type === 'child') {
    var _mapProps3 = (0,util/* filterProps */.L6)(props, CONFIG.child.copy, CONFIG.types);
    var delta;
    if (props.cellType && props.delta) {
      delta = prepareDeltaToType(props.cellType, props.delta);
    } else {
      delta = props.delta || false;
    }
    map = store.createMap(false, Object.assign(_mapProps3, {
      type: 'tableText'
    }));
    textBase.initMap(map, store, {
      delta: delta,
      noDefaultAlign: true,
      noDefaultColor: true
    });
  }
  return map;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/tablePaste.js
function tablePaste_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { tablePaste_typeof = function _typeof(obj) { return typeof obj; }; } else { tablePaste_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return tablePaste_typeof(obj); }
function tablePaste_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = tablePaste_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function tablePaste_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tablePaste_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tablePaste_arrayLikeToArray(o, minLen); }
function tablePaste_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }





















function tablePaste_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function tablePaste_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function tablePaste_createClass(Constructor, protoProps, staticProps) { if (protoProps) tablePaste_defineProperties(Constructor.prototype, protoProps); if (staticProps) tablePaste_defineProperties(Constructor, staticProps); return Constructor; }
function tablePaste_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) tablePaste_setPrototypeOf(subClass, superClass); }
function tablePaste_setPrototypeOf(o, p) { tablePaste_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return tablePaste_setPrototypeOf(o, p); }
function tablePaste_createSuper(Derived) { var hasNativeReflectConstruct = tablePaste_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = tablePaste_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = tablePaste_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return tablePaste_possibleConstructorReturn(this, result); }; }
function tablePaste_possibleConstructorReturn(self, call) { if (call && (tablePaste_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return tablePaste_assertThisInitialized(self); }
function tablePaste_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function tablePaste_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function tablePaste_getPrototypeOf(o) { tablePaste_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return tablePaste_getPrototypeOf(o); }






var TablePaste = function TablePaste(superclass) {
  return /*#__PURE__*/function (_superclass) {
    tablePaste_inherits(_class, _superclass);
    var _super = tablePaste_createSuper(_class);
    function _class() {
      tablePaste_classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _super.call.apply(_super, [this].concat(args));
    }

    /**
     * Вызывается в pasteManager при вставке в таблицу
     * @param {object} params
     * @param {string} params.html
     * @returns {boolean} обработана ли операция вставки
     */
    tablePaste_createClass(_class, [{
      key: "onPaste",
      value: function onPaste() {
        var _this = this;
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var selection = Object.assign({}, this.componentOnAction({
          type: 'selection'
        }));
        if (!selection.current) {
          return false;
        } else {
          var editing = this.getEditing();
          if (editing) {
            var _editing$blot$onPaste, _editing$blot;
            (_editing$blot$onPaste = (_editing$blot = editing.blot).onPaste) === null || _editing$blot$onPaste === void 0 ? void 0 : _editing$blot$onPaste.call(_editing$blot, params);
            return true;
          }
        }
        var hasTableHtml = params.html && params.html.indexOf('<table') !== -1;
        if (!hasTableHtml && params.text && params.text.trim().indexOf('\n') === -1) {
          for (var row = selection.start.row; row <= selection.last.row; row++) {
            for (var col = selection.start.col; col <= selection.last.col; col++) {
              this.pasteToCell({
                row: row,
                col: col
              }, params);
            }
          }
          return true;
        }

        // При вставке нескольких строк текста преобразуем их в табличный вид
        if (!hasTableHtml && params.text && params.text.indexOf("\n") !== -1) {
          var table = document.createElement('table');
          var rows = params.text.replace(/\r/g, '').trim().split('\n');
          var cols = 1;
          var _iterator = tablePaste_createForOfIteratorHelper(rows),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _row = _step.value;
              var cells = _row.split('\t').length;
              cols = Math.max(cols, cells);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          var _iterator2 = tablePaste_createForOfIteratorHelper(rows),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _row2 = _step2.value;
              var _cells = _row2.split('\t');
              var tr = document.createElement('tr');
              for (var _col = 0; _col < cols; _col++) {
                var td = document.createElement('td');
                if (_cells[_col]) {
                  td.innerText = _cells[_col];
                }
                tr.append(td);
              }
              table.append(tr);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          params.html = table.outerHTML;
        }
        if (params.html) {
          var domNode = new DOMParser().parseFromString(params.html, 'text/html');
          var _table = domNode.querySelector('table');
          if (_table) {
            // Сравниваем типы вставляемых ячеек и типы целевых колонок, чтобы исключить неразрешенные данные
            var res = parseTable(_table, domNode);
            var curTypes = [];
            for (var _col2 = selection.current.col; _col2 <= selection.current.col + res.table.cols - 1; _col2++) {
              curTypes.push(this.getColType(_col2) || 'none');
            }
            if (!includesOnly(curTypes, ['none'])) {
              /*
              for (let col in res.table.content.columns) {
                const pasteType = res.table.content.columns[col].columnType || 'none'
                const curType = curTypes[col]
                if (curType !== 'none' && pasteType !== curType) {
                  if (curType !== 'text' || !['number', 'currency'].includes(pasteType)) {
                    console.warn(`Can't paste column "${pasteType}" into current column "${curType}"`)
                    return true
                  }
                }
              }
              */
              for (var _row3 in res.table.content.rows) {
                for (var _col3 in res.table.content.rows[_row3].children) {
                  var cell = res.table.content.rows[_row3].children[_col3];
                  var pasteType = cell.cellType || 'text';
                  var curType = curTypes[_col3];
                  if (curType !== 'none' && pasteType !== curType) {
                    if (['number', 'currency'].includes(curType) && pasteType === 'text') {
                      var _cell$delta, _cell$delta$ops, _cell$delta$ops$, _cell$delta$ops$$inse;
                      var value = (_cell$delta = cell.delta) === null || _cell$delta === void 0 ? void 0 : (_cell$delta$ops = _cell$delta.ops) === null || _cell$delta$ops === void 0 ? void 0 : (_cell$delta$ops$ = _cell$delta$ops[0]) === null || _cell$delta$ops$ === void 0 ? void 0 : (_cell$delta$ops$$inse = _cell$delta$ops$.insert) === null || _cell$delta$ops$$inse === void 0 ? void 0 : _cell$delta$ops$$inse.trim();
                      if (value && isNaN(parseFloat(value))) {
                        console.warn("Can't paste value \"".concat(value, "\" into current column \"").concat(curType, "\""));
                        return true;
                      }
                    } else if ((curType !== 'text' || !['number', 'currency'].includes(pasteType)) && !(['number', 'currency'].includes(curType) && ['number', 'currency'].includes(pasteType))) {
                      console.warn("Can't paste cell \"".concat(pasteType, "\" into current column \"").concat(curType, "\""));
                      return true;
                    }
                  }
                }
              }
            }
            var currentSize = this.tableSize;
            // Расширяем таблицу при необходимости
            var _getDOMTableSize = getDOMTableSize(_table),
              pasteCols = _getDOMTableSize.width,
              pasteRows = _getDOMTableSize.height;
            var end = {
              col: selection.current.col + pasteCols - 1,
              row: selection.current.row + pasteRows - 1
            };
            var addCols = Math.max(0, end.col - currentSize.cols + 1);
            if (addCols) {
              this.changeSize({
                cols: addCols
              });
            }
            var addRows = Math.max(0, end.row - currentSize.rows + 1);
            if (addRows) {
              this.changeSize({
                rows: addRows
              });
            }
            // Разделяем мердженные ячейки, если они есть в области
            this.divideCells(selection.current, end);
            this.store.transaction(function () {
              for (var rowIndex in res.table.content.rows) {
                var _row4 = res.table.content.rows[rowIndex];
                var rowMap = _this.rowMapByIndex(selection.current.row + parseInt(rowIndex), {
                  create: true,
                  inTransaction: true
                });
                var children = rowMap.get('children');
                var cellsIds = [];
                for (var colIndex in _row4.children) {
                  var _cell = _row4.children[colIndex];
                  var cellMapId = false;
                  _this.onPasteUpdateDbSelectIfNeed(selection.current.col + parseInt(colIndex), _cell, res.table.content.columns[colIndex]);
                  if (_cell && Object.keys(_cell).length) {
                    cellMapId = initInnerMap(_this.store, 'cell', _cell, {
                      initChild: true
                    }).get('id');
                  }
                  cellsIds.push(cellMapId);
                }
                _this.mapArraySet(children, selection.current.col, cellsIds);
              }
            });
            this.tableBodyEmbed.mapToObject({
              render: true,
              mode: 'full'
            });
          }
        }
        return true;
      }

      /**
       * Вставка контента в ячейку
       * Полностью заменяет содержимое ячейки
       * @param { object } pos: позиция ячейки {row, col}
       * @param { object } params
       * @param { string } params.text: вставляемый текст
       * @returns { boolean }
       */
    }, {
      key: "pasteToCell",
      value: function pasteToCell() {
        var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var processed = false,
          render = true;
        var cellType = this.getCellType(pos);
        if (cellType === 'text') {
          processed = true;
          var ops = [{
            insert: params.text.trim()
          }];
          if (stringIsUrl(ops[0].insert)) {
            ops[0].attributes = {
              link: ops[0].insert
            };
            ops.push({
              insert: '\n'
            });
          } else {
            ops[0].insert = ops[0].insert + '\n';
          }
          var pasteDelta = new (Delta_default())(ops);
          render = this.setCellDelta(pos, pasteDelta);
        } else if (cellType === 'number' || cellType === 'currency') {
          processed = true;
          var text = params.text.trim().replace(/\s/g, '').replace(',', '.');
          var value = parseFloat(text);
          if (!isNaN(value)) {
            var format = this.getCellFormat(pos);
            if ((format === null || format === void 0 ? void 0 : format['decimal_separator']) === 'comma') {
              value = String(value).replace('.', ',');
            }
            var _pasteDelta = new (Delta_default())().insert(value + '\n');
            render = this.setCellDelta(pos, _pasteDelta);
          }
        }
        if (render) {
          var cellMap = this.cellMapByPos(pos);
          if (cellMap) {
            this.tableBodyEmbed.fillCellData(pos, cellMap.get('id'), {
              render: true,
              withSummary: true
            });
          }
        }
        return processed;
      }
    }, {
      key: "onPasteUpdateDbSelectIfNeed",
      value: function onPasteUpdateDbSelectIfNeed(index, cell, col) {
        var _this2 = this;
        if (cell.type === 'tableCellSelect' && col.dbSelect) {
          (function () {
            var selectedLabels = JSON.parse(cell.selected);
            var colMap = _this2.colMapByIndex(index, {
              create: true,
              inTransaction: true
            });
            var dbSelect = colMap.get('dbSelect') || {};
            var _loop = function _loop(id) {
              var idInCurrentCol = Object.keys(dbSelect).find(function (labelId) {
                return dbSelect[labelId].name === col.dbSelect[id].name;
              });
              if (!idInCurrentCol) {
                dbSelect[id] = col.dbSelect[id];
              } else {
                if (selectedLabels.indexOf(id) !== -1) {
                  selectedLabels[selectedLabels.indexOf(id)] = idInCurrentCol;
                }
              }
            };
            for (var id in col.dbSelect) {
              _loop(id);
            }
            cell.selected = JSON.stringify(selectedLabels);
            colMap.set('dbSelect', dbSelect);
          })();
        }
      }
    }]);
    return _class;
  }(superclass);
};
/* harmony default export */ const tablePaste = (TablePaste);
// EXTERNAL MODULE: ./node_modules/papaparse/papaparse.min.js
var papaparse_min = __webpack_require__(82360);
var papaparse_min_default = /*#__PURE__*/__webpack_require__.n(papaparse_min);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/tableImportCsv.js
function tableImportCsv_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { tableImportCsv_typeof = function _typeof(obj) { return typeof obj; }; } else { tableImportCsv_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return tableImportCsv_typeof(obj); }
function tableImportCsv_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = tableImportCsv_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function tableImportCsv_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tableImportCsv_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tableImportCsv_arrayLikeToArray(o, minLen); }
function tableImportCsv_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function tableImportCsv_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function tableImportCsv_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { tableImportCsv_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { tableImportCsv_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

















function tableImportCsv_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function tableImportCsv_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function tableImportCsv_createClass(Constructor, protoProps, staticProps) { if (protoProps) tableImportCsv_defineProperties(Constructor.prototype, protoProps); if (staticProps) tableImportCsv_defineProperties(Constructor, staticProps); return Constructor; }
function tableImportCsv_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) tableImportCsv_setPrototypeOf(subClass, superClass); }
function tableImportCsv_setPrototypeOf(o, p) { tableImportCsv_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return tableImportCsv_setPrototypeOf(o, p); }
function tableImportCsv_createSuper(Derived) { var hasNativeReflectConstruct = tableImportCsv_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = tableImportCsv_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = tableImportCsv_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return tableImportCsv_possibleConstructorReturn(this, result); }; }
function tableImportCsv_possibleConstructorReturn(self, call) { if (call && (tableImportCsv_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return tableImportCsv_assertThisInitialized(self); }
function tableImportCsv_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function tableImportCsv_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function tableImportCsv_getPrototypeOf(o) { tableImportCsv_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return tableImportCsv_getPrototypeOf(o); }
function tableImportCsv_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




// Импорт из CSV реализован с помощью библиотеки https://www.papaparse.com/docs

var TableImportCsv = function TableImportCsv(superclass) {
  return /*#__PURE__*/function (_superclass) {
    tableImportCsv_inherits(_class2, _superclass);
    var _super = tableImportCsv_createSuper(_class2);
    function _class2() {
      var _this;
      tableImportCsv_classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      tableImportCsv_defineProperty(tableImportCsv_assertThisInitialized(_this), "onImportCsvFile", /*#__PURE__*/tableImportCsv_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var fileParams, files;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.editor.plugins.attachmentManager.isMethodImplemented('chooseFile')) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", console.warn('chooseFile is not implemented in the attachmentManager plugin, skip executing import csv file action'));
              case 2:
                fileParams = {
                  multiple: false,
                  blotName: 'table',
                  accept: ".csv"
                };
                _context.next = 5;
                return _this.editor.plugins.attachmentManager.chooseFile(fileParams);
              case 5:
                files = _context.sent;
                if (files) {
                  _context.next = 8;
                  break;
                }
                return _context.abrupt("return", false);
              case 8:
                papaparse_min_default().parse(files[0].instance, {
                  header: true,
                  skipEmptyLines: true,
                  dynamicTyping: true,
                  complete: function complete(_ref2) {
                    var data = _ref2.data,
                      errors = _ref2.errors,
                      meta = _ref2.meta;
                    var fields = meta.fields;
                    if (errors.length) {
                      _this.onCsvImportHasErrors(errors);
                    }
                    _this.pasteCsvImportData(fields, data);
                  }
                });
              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
      return _this;
    }
    tableImportCsv_createClass(_class2, [{
      key: "onCsvImportHasErrors",
      value: function onCsvImportHasErrors(errors) {
        var _iterator = tableImportCsv_createForOfIteratorHelper(errors),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var err = _step.value;
            console.error(err);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }, {
      key: "pasteCsvImportData",
      value: function pasteCsvImportData(cols, data) {
        var _this$tableBodyEmbed,
          _this2 = this;
        var _this$tableBodyEmbed$ = (_this$tableBodyEmbed = this.tableBodyEmbed) === null || _this$tableBodyEmbed === void 0 ? void 0 : _this$tableBodyEmbed.table,
          colsData = _this$tableBodyEmbed$.colsData;
        var lastRow = 0;
        var currentSize = this.tableSize;
        for (var rowIndex = 0; rowIndex <= currentSize.rows; rowIndex++) {
          if (!this.isRangeEmpty({
            row: rowIndex,
            col: 0
          }, {
            row: rowIndex,
            col: currentSize.cols - 1
          })) {
            lastRow = rowIndex;
          }
        }
        if (lastRow) {
          lastRow++;
        }
        // массив всех тайтлов колонок таблицы
        var colTitles = [];
        var untitledColsIndexes = [];
        // Выставляем тайтлы колонок
        for (var colIndex = 0; colIndex < currentSize.cols; colIndex++) {
          var _colsData$colIndex$to;
          var title = ((_colsData$colIndex$to = colsData[colIndex.toString()]) === null || _colsData$colIndex$to === void 0 ? void 0 : _colsData$colIndex$to.text) || '';
          // если колонка имеет тайтл
          if (title) {
            colTitles.push(title);
            var index = cols.indexOf(title);
            // если в csv есть такой тайтл, нужно его удалить из пула
            if (index >= 0) {
              cols.splice(index, 1);
            } else {
              continue;
            }
          } else {
            // запомниаем индексы колонок без тайтла
            untitledColsIndexes.push(colIndex);
          }
        }
        // заполняем пустые тайтлы в середине
        for (var _i = 0, _untitledColsIndexes = untitledColsIndexes; _i < _untitledColsIndexes.length; _i++) {
          var _colIndex = _untitledColsIndexes[_i];
          if (cols.length) {
            var addTitle = cols.shift();
            colTitles.splice(_colIndex, 0, addTitle);
            this.tableBodyEmbed.setProp('text', addTitle, {
              pos: {
                col: _colIndex
              },
              type: 'col'
            });
          } else {
            colTitles.splice(_colIndex, 0, '');
          }
        }
        // добавляем колонки, которые остались в csv
        var addCols = cols.length;
        if (addCols) {
          this.changeSize({
            cols: addCols
          });
          // Выставляем тайтлы новых колонок
          for (var _colIndex2 = currentSize.cols; _colIndex2 < currentSize.cols + addCols; _colIndex2++) {
            var _addTitle = cols.shift();
            colTitles.push(_addTitle);
            this.tableBodyEmbed.setProp('text', _addTitle, {
              pos: {
                col: _colIndex2
              },
              type: 'col'
            });
          }
        }
        // добавляем строки, если это необходимо
        var pasteRows = data.length;
        var endRow = lastRow + pasteRows - 1;
        var addRows = Math.max(0, endRow - currentSize.rows + 1);
        if (addRows) {
          this.changeSize({
            rows: addRows
          });
        }
        this.store.transaction(function () {
          for (var _index = 0; _index < data.length; _index++) {
            var rowMap = _this2.rowMapByIndex(_index + lastRow, {
              create: true,
              inTransaction: true
            });
            var children = rowMap.get('children');
            var cellsIds = [];
            // сюда запоминаем колонки которые уже использовали, чтобы не создавать дубли
            var usedTitles = [];
            var pushIndex = 0;
            for (var _colIndex3 = 0; _colIndex3 < currentSize.cols + addCols; _colIndex3++) {
              var colName = colTitles[_colIndex3];
              if (usedTitles.includes(colName) || !data[_index].hasOwnProperty(colName)) {
                if (cellsIds.length) {
                  _this2.mapArraySet(children, pushIndex, cellsIds);
                  cellsIds = [];
                }
                pushIndex = _colIndex3 + 1;
                continue;
              }
              usedTitles.push(colName);
              var text = data[_index][colName] || '';
              var cell = {
                cellType: 'text',
                colspan: 1,
                delta: new (Delta_default())().insert(text + '\n'),
                rowspan: 1
              };
              var cellMapId = false;
              if (cell && Object.keys(cell).length) {
                cellMapId = initInnerMap(_this2.store, 'cell', cell, {
                  initChild: true
                }).get('id');
              }
              cellsIds.push(cellMapId);
            }
            if (cellsIds.length) {
              _this2.mapArraySet(children, pushIndex, cellsIds);
            }
          }
        });
        this.tableBodyEmbed.mapToObject({
          render: true,
          mode: 'full'
        });
      }
    }]);
    return _class2;
  }(superclass);
};
/* harmony default export */ const tableImportCsv = (TableImportCsv);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/tableBlotMenuHeader.js
function tableBlotMenuHeader_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { tableBlotMenuHeader_typeof = function _typeof(obj) { return typeof obj; }; } else { tableBlotMenuHeader_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return tableBlotMenuHeader_typeof(obj); }











function tableBlotMenuHeader_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function tableBlotMenuHeader_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function tableBlotMenuHeader_createClass(Constructor, protoProps, staticProps) { if (protoProps) tableBlotMenuHeader_defineProperties(Constructor.prototype, protoProps); if (staticProps) tableBlotMenuHeader_defineProperties(Constructor, staticProps); return Constructor; }
function tableBlotMenuHeader_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) tableBlotMenuHeader_setPrototypeOf(subClass, superClass); }
function tableBlotMenuHeader_setPrototypeOf(o, p) { tableBlotMenuHeader_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return tableBlotMenuHeader_setPrototypeOf(o, p); }
function tableBlotMenuHeader_createSuper(Derived) { var hasNativeReflectConstruct = tableBlotMenuHeader_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = tableBlotMenuHeader_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = tableBlotMenuHeader_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return tableBlotMenuHeader_possibleConstructorReturn(this, result); }; }
function tableBlotMenuHeader_possibleConstructorReturn(self, call) { if (call && (tableBlotMenuHeader_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return tableBlotMenuHeader_assertThisInitialized(self); }
function tableBlotMenuHeader_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function tableBlotMenuHeader_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function tableBlotMenuHeader_getPrototypeOf(o) { tableBlotMenuHeader_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return tableBlotMenuHeader_getPrototypeOf(o); }
function tableBlotMenuHeader_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




function tableBlotMenuHeader_getState(map) {
  return {
    align: map.get('embed-align') || 'left'
  };
}
var TableBlotMenuHeader = /*#__PURE__*/function (_Component) {
  tableBlotMenuHeader_inherits(TableBlotMenuHeader, _Component);
  var _super = tableBlotMenuHeader_createSuper(TableBlotMenuHeader);
  function TableBlotMenuHeader(props) {
    var _this;
    tableBlotMenuHeader_classCallCheck(this, TableBlotMenuHeader);
    _this = _super.call(this, props);
    tableBlotMenuHeader_defineProperty(tableBlotMenuHeader_assertThisInitialized(_this), "onMapChange", function () {
      var map = _this.props.blot.map;
      _this.setState(function () {
        return tableBlotMenuHeader_getState(map);
      });
    });
    _this.state = tableBlotMenuHeader_getState(props.blot.map);
    return _this;
  }
  tableBlotMenuHeader_createClass(TableBlotMenuHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var blot = this.props.blot;
      var store = blot.editor.store;
      store.observe(blot.map, this.onMapChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var blot = this.props.blot;
      var store = blot.editor.store;
      store.unobserve(blot.map, this.onMapChange);
    }
  }, {
    key: "setAlign",
    value: function setAlign(align) {
      var _this$props = this.props,
        editor = _this$props.blot.editor,
        menu = _this$props.menu;
      editor.exec('set-embed-align', {
        align: align
      });
      menu.onMenuClose();
    }
  }, {
    key: "render",
    value: function render() {
      var align = this.state.align;
      return (0,preact_module.h)(BlockMenuHeader, null, (0,preact_module.h)(BlockMenuHeaderItem, {
        id: "align-left",
        active: align === 'left',
        onClick: this.setAlign.bind(this, 'left'),
        icon: icons/* EmbedAlignLeft */.sws
      }), (0,preact_module.h)(BlockMenuHeaderItem, {
        id: "align-center",
        active: align === 'center',
        onClick: this.setAlign.bind(this, 'center'),
        icon: icons/* EmbedAlignCenter */.fm
      }), (0,preact_module.h)(BlockMenuHeaderItem, {
        id: "align-right",
        active: align === 'right',
        onClick: this.setAlign.bind(this, 'right'),
        icon: icons/* EmbedAlignRight */.vSI
      }));
    }
  }]);
  return TableBlotMenuHeader;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/scss/table/table.scss
var table = __webpack_require__(80453);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/tableErrors.js
function tableErrors_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { tableErrors_typeof = function _typeof(obj) { return typeof obj; }; } else { tableErrors_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return tableErrors_typeof(obj); }











function tableErrors_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function tableErrors_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) tableErrors_setPrototypeOf(subClass, superClass); }
function tableErrors_createSuper(Derived) { var hasNativeReflectConstruct = tableErrors_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = tableErrors_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = tableErrors_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return tableErrors_possibleConstructorReturn(this, result); }; }
function tableErrors_possibleConstructorReturn(self, call) { if (call && (tableErrors_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return tableErrors_assertThisInitialized(self); }
function tableErrors_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function tableErrors_wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; tableErrors_wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !tableErrors_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return tableErrors_construct(Class, arguments, tableErrors_getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return tableErrors_setPrototypeOf(Wrapper, Class); }; return tableErrors_wrapNativeSuper(Class); }
function tableErrors_construct(Parent, args, Class) { if (tableErrors_isNativeReflectConstruct()) { tableErrors_construct = Reflect.construct; } else { tableErrors_construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) tableErrors_setPrototypeOf(instance, Class.prototype); return instance; }; } return tableErrors_construct.apply(null, arguments); }
function tableErrors_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function tableErrors_isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function tableErrors_setPrototypeOf(o, p) { tableErrors_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return tableErrors_setPrototypeOf(o, p); }
function tableErrors_getPrototypeOf(o) { tableErrors_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return tableErrors_getPrototypeOf(o); }
var TableMoveItemError = /*#__PURE__*/function (_Error) {
  tableErrors_inherits(TableMoveItemError, _Error);
  var _super = tableErrors_createSuper(TableMoveItemError);
  function TableMoveItemError(reason) {
    var _this;
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    tableErrors_classCallCheck(this, TableMoveItemError);
    _this = _super.call(this, message);
    _this.reason = reason;
    return _this;
  }
  return TableMoveItemError;
}( /*#__PURE__*/tableErrors_wrapNativeSuper(Error));
TableMoveItemError.CANNOT_MOVE_MERGED_CELLS_PART = 1;
TableMoveItemError.CANNOT_MOVE_INTO_MERGED_CELL = 2;
TableMoveItemError.CANNOT_MOVE_ROW_IN_SORTABLE_TABLE = 3;
TableMoveItemError.CANNOT_MOVE_INVALID_POSITION = 4;
TableMoveItemError.CANNOT_MOVE_ROW_IN_FILTERED_TABLE = 5;
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/components/popupDialogButtons.js
var popupDialogButtons = __webpack_require__(25251);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/popup/columnConvertPopup.js
function columnConvertPopup_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { columnConvertPopup_typeof = function _typeof(obj) { return typeof obj; }; } else { columnConvertPopup_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return columnConvertPopup_typeof(obj); }









function columnConvertPopup_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function columnConvertPopup_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function columnConvertPopup_createClass(Constructor, protoProps, staticProps) { if (protoProps) columnConvertPopup_defineProperties(Constructor.prototype, protoProps); if (staticProps) columnConvertPopup_defineProperties(Constructor, staticProps); return Constructor; }
function columnConvertPopup_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) columnConvertPopup_setPrototypeOf(subClass, superClass); }
function columnConvertPopup_setPrototypeOf(o, p) { columnConvertPopup_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return columnConvertPopup_setPrototypeOf(o, p); }
function columnConvertPopup_createSuper(Derived) { var hasNativeReflectConstruct = columnConvertPopup_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = columnConvertPopup_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = columnConvertPopup_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return columnConvertPopup_possibleConstructorReturn(this, result); }; }
function columnConvertPopup_possibleConstructorReturn(self, call) { if (call && (columnConvertPopup_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return columnConvertPopup_assertThisInitialized(self); }
function columnConvertPopup_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function columnConvertPopup_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function columnConvertPopup_getPrototypeOf(o) { columnConvertPopup_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return columnConvertPopup_getPrototypeOf(o); }






var ColumnConvertPopup = /*#__PURE__*/function (_Component) {
  columnConvertPopup_inherits(ColumnConvertPopup, _Component);
  var _super = columnConvertPopup_createSuper(ColumnConvertPopup);
  function ColumnConvertPopup() {
    columnConvertPopup_classCallCheck(this, ColumnConvertPopup);
    return _super.call(this);
  }
  columnConvertPopup_createClass(ColumnConvertPopup, [{
    key: "onClick",
    value: function onClick() {
      var _this$props = this.props,
        onAction = _this$props.onAction,
        wantsToClose = _this$props.wantsToClose;
      onAction && onAction();
      wantsToClose && wantsToClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        editor = _this$props2.editor,
        wantsToClose = _this$props2.wantsToClose;
      var i18n = editor.plugins.i18n;
      return (0,preact_module.h)(popupMenu/* default */.Z, {
        wantsToClose: wantsToClose,
        addClassName: "column-convert-popup",
        closeOnEsc: true
      }, (0,preact_module.h)(popupDialog/* default */.Z, {
        wantsToClose: wantsToClose,
        addClassName: 'reduced-padding',
        noCloseButton: true
      }, (0,preact_module.h)(popupDialogTitle/* default */.Z, null, i18n.get('table.convert_column.title')), (0,preact_module.h)(popupDialogBody/* default */.Z, {
        style: {
          'max-width': '520px'
        }
      }, (0,preact_module.h)("p", null, (0,preact_module.h)("span", null, i18n.get('table.convert_column.text_before')), (0,preact_module.h)("strong", null, " ", i18n.get('table.convert_column.text_cmd'), " "), (0,preact_module.h)("span", null, i18n.get('table.convert_column.text_after')))), (0,preact_module.h)(popupDialogButtons/* default */.Z, {
        editor: editor,
        wantsToClose: wantsToClose,
        buttons: {
          cancel: {},
          accept: {
            text: i18n.get('table.convert_column.accept'),
            style: 'active',
            onClick: this.onClick.bind(this)
          }
        }
      })));
    }
  }]);
  return ColumnConvertPopup;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/popup/columnDuplicatePopup.js
function columnDuplicatePopup_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { columnDuplicatePopup_typeof = function _typeof(obj) { return typeof obj; }; } else { columnDuplicatePopup_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return columnDuplicatePopup_typeof(obj); }









function columnDuplicatePopup_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function columnDuplicatePopup_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function columnDuplicatePopup_createClass(Constructor, protoProps, staticProps) { if (protoProps) columnDuplicatePopup_defineProperties(Constructor.prototype, protoProps); if (staticProps) columnDuplicatePopup_defineProperties(Constructor, staticProps); return Constructor; }
function columnDuplicatePopup_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) columnDuplicatePopup_setPrototypeOf(subClass, superClass); }
function columnDuplicatePopup_setPrototypeOf(o, p) { columnDuplicatePopup_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return columnDuplicatePopup_setPrototypeOf(o, p); }
function columnDuplicatePopup_createSuper(Derived) { var hasNativeReflectConstruct = columnDuplicatePopup_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = columnDuplicatePopup_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = columnDuplicatePopup_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return columnDuplicatePopup_possibleConstructorReturn(this, result); }; }
function columnDuplicatePopup_possibleConstructorReturn(self, call) { if (call && (columnDuplicatePopup_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return columnDuplicatePopup_assertThisInitialized(self); }
function columnDuplicatePopup_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function columnDuplicatePopup_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function columnDuplicatePopup_getPrototypeOf(o) { columnDuplicatePopup_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return columnDuplicatePopup_getPrototypeOf(o); }







var ColumnDuplicatePopup = /*#__PURE__*/function (_Component) {
  columnDuplicatePopup_inherits(ColumnDuplicatePopup, _Component);
  var _super = columnDuplicatePopup_createSuper(ColumnDuplicatePopup);
  function ColumnDuplicatePopup() {
    var _this;
    columnDuplicatePopup_classCallCheck(this, ColumnDuplicatePopup);
    _this = _super.call(this);
    _this.state = {
      duplicateContent: true
    };
    return _this;
  }
  columnDuplicatePopup_createClass(ColumnDuplicatePopup, [{
    key: "toggleDuplicateContent",
    value: function toggleDuplicateContent() {
      this.setState(function (prevState) {
        var duplicateContent = prevState.duplicateContent;
        return {
          duplicateContent: !duplicateContent
        };
      });
    }
  }, {
    key: "onClick",
    value: function onClick() {
      var _this$props = this.props,
        onAction = _this$props.onAction,
        wantsToClose = _this$props.wantsToClose;
      var duplicateContent = this.state.duplicateContent;
      if (onAction) {
        onAction(duplicateContent);
      }
      wantsToClose && wantsToClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        editor = _this$props2.editor,
        wantsToClose = _this$props2.wantsToClose;
      var duplicateContent = this.state.duplicateContent;
      var i18n = editor.plugins.i18n;
      return (0,preact_module.h)(popupMenu/* default */.Z, {
        wantsToClose: wantsToClose,
        addClassName: "column-duplicate-popup",
        closeOnEsc: true
      }, (0,preact_module.h)(popupDialog/* default */.Z, {
        wantsToClose: wantsToClose,
        addClassName: 'reduced-padding',
        noCloseButton: true
      }, (0,preact_module.h)(popupDialogTitle/* default */.Z, null, i18n.get('table.duplicate_column.title')), (0,preact_module.h)(popupDialogBody/* default */.Z, {
        style: {
          'max-width': '520px'
        }
      }, (0,preact_module.h)("p", {
        class: "flex"
      }, (0,preact_module.h)("span", null, i18n.get('table.duplicate_column.text_1')), (0,preact_module.h)(Toggle, {
        status: duplicateContent,
        onChange: this.toggleDuplicateContent.bind(this)
      })), (0,preact_module.h)("p", null, i18n.get('table.duplicate_column.text_2'))), (0,preact_module.h)(popupDialogButtons/* default */.Z, {
        editor: editor,
        wantsToClose: wantsToClose,
        buttons: {
          cancel: {},
          accept: {
            text: i18n.get('table.duplicate_column.accept'),
            style: 'active',
            onClick: this.onClick.bind(this)
          }
        }
      })));
    }
  }]);
  return ColumnDuplicatePopup;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/popup/columnExitSortingPopup.js
function columnExitSortingPopup_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { columnExitSortingPopup_typeof = function _typeof(obj) { return typeof obj; }; } else { columnExitSortingPopup_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return columnExitSortingPopup_typeof(obj); }









function columnExitSortingPopup_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function columnExitSortingPopup_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function columnExitSortingPopup_createClass(Constructor, protoProps, staticProps) { if (protoProps) columnExitSortingPopup_defineProperties(Constructor.prototype, protoProps); if (staticProps) columnExitSortingPopup_defineProperties(Constructor, staticProps); return Constructor; }
function columnExitSortingPopup_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) columnExitSortingPopup_setPrototypeOf(subClass, superClass); }
function columnExitSortingPopup_setPrototypeOf(o, p) { columnExitSortingPopup_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return columnExitSortingPopup_setPrototypeOf(o, p); }
function columnExitSortingPopup_createSuper(Derived) { var hasNativeReflectConstruct = columnExitSortingPopup_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = columnExitSortingPopup_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = columnExitSortingPopup_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return columnExitSortingPopup_possibleConstructorReturn(this, result); }; }
function columnExitSortingPopup_possibleConstructorReturn(self, call) { if (call && (columnExitSortingPopup_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return columnExitSortingPopup_assertThisInitialized(self); }
function columnExitSortingPopup_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function columnExitSortingPopup_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function columnExitSortingPopup_getPrototypeOf(o) { columnExitSortingPopup_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return columnExitSortingPopup_getPrototypeOf(o); }







var ColumnExitSortingPopup = /*#__PURE__*/function (_Component) {
  columnExitSortingPopup_inherits(ColumnExitSortingPopup, _Component);
  var _super = columnExitSortingPopup_createSuper(ColumnExitSortingPopup);
  function ColumnExitSortingPopup() {
    var _this;
    columnExitSortingPopup_classCallCheck(this, ColumnExitSortingPopup);
    _this = _super.call(this);
    _this.state = {
      keepOrder: false
    };
    return _this;
  }
  columnExitSortingPopup_createClass(ColumnExitSortingPopup, [{
    key: "toggleKeepOrder",
    value: function toggleKeepOrder() {
      this.setState(function (prevState) {
        var keepOrder = prevState.keepOrder;
        return {
          keepOrder: !keepOrder
        };
      });
    }
  }, {
    key: "onClick",
    value: function onClick() {
      var _this$props = this.props,
        onAction = _this$props.onAction,
        wantsToClose = _this$props.wantsToClose;
      var keepOrder = this.state.keepOrder;
      if (onAction) {
        onAction(keepOrder);
      }
      wantsToClose && wantsToClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        editor = _this$props2.editor,
        wantsToClose = _this$props2.wantsToClose;
      var keepOrder = this.state.keepOrder;
      var i18n = editor.plugins.i18n;
      return (0,preact_module.h)(popupMenu/* default */.Z, {
        wantsToClose: wantsToClose,
        addClassName: "column-exit-sorting-popup",
        closeOnEsc: true,
        onEnterAction: this.onClick.bind(this)
      }, (0,preact_module.h)(popupDialog/* default */.Z, {
        wantsToClose: wantsToClose,
        addClassName: 'reduced-padding',
        noCloseButton: true
      }, (0,preact_module.h)(popupDialogTitle/* default */.Z, null, i18n.get('table.sorting.exit_dialog.title')), (0,preact_module.h)(popupDialogBody/* default */.Z, {
        style: {
          'width': '350px'
        }
      }, (0,preact_module.h)("p", {
        class: "flex"
      }, (0,preact_module.h)("span", null, i18n.get('table.sorting.exit_dialog.toggle')), (0,preact_module.h)(Toggle, {
        status: keepOrder,
        onChange: this.toggleKeepOrder.bind(this)
      }))), (0,preact_module.h)(popupDialogButtons/* default */.Z, {
        editor: editor,
        wantsToClose: wantsToClose,
        buttons: {
          cancel: {},
          accept: {
            text: i18n.get('table.sorting.exit_dialog.apply'),
            style: 'active',
            onClick: this.onClick.bind(this)
          }
        }
      })));
    }
  }]);
  return ColumnExitSortingPopup;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/popup/mergeCellsWithCommentsPopup.js
function mergeCellsWithCommentsPopup_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { mergeCellsWithCommentsPopup_typeof = function _typeof(obj) { return typeof obj; }; } else { mergeCellsWithCommentsPopup_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return mergeCellsWithCommentsPopup_typeof(obj); }









function mergeCellsWithCommentsPopup_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function mergeCellsWithCommentsPopup_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function mergeCellsWithCommentsPopup_createClass(Constructor, protoProps, staticProps) { if (protoProps) mergeCellsWithCommentsPopup_defineProperties(Constructor.prototype, protoProps); if (staticProps) mergeCellsWithCommentsPopup_defineProperties(Constructor, staticProps); return Constructor; }
function mergeCellsWithCommentsPopup_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) mergeCellsWithCommentsPopup_setPrototypeOf(subClass, superClass); }
function mergeCellsWithCommentsPopup_setPrototypeOf(o, p) { mergeCellsWithCommentsPopup_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return mergeCellsWithCommentsPopup_setPrototypeOf(o, p); }
function mergeCellsWithCommentsPopup_createSuper(Derived) { var hasNativeReflectConstruct = mergeCellsWithCommentsPopup_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = mergeCellsWithCommentsPopup_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = mergeCellsWithCommentsPopup_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return mergeCellsWithCommentsPopup_possibleConstructorReturn(this, result); }; }
function mergeCellsWithCommentsPopup_possibleConstructorReturn(self, call) { if (call && (mergeCellsWithCommentsPopup_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return mergeCellsWithCommentsPopup_assertThisInitialized(self); }
function mergeCellsWithCommentsPopup_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function mergeCellsWithCommentsPopup_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function mergeCellsWithCommentsPopup_getPrototypeOf(o) { mergeCellsWithCommentsPopup_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return mergeCellsWithCommentsPopup_getPrototypeOf(o); }






var MergeCellsWithCommentsPopup = /*#__PURE__*/function (_Component) {
  mergeCellsWithCommentsPopup_inherits(MergeCellsWithCommentsPopup, _Component);
  var _super = mergeCellsWithCommentsPopup_createSuper(MergeCellsWithCommentsPopup);
  function MergeCellsWithCommentsPopup() {
    mergeCellsWithCommentsPopup_classCallCheck(this, MergeCellsWithCommentsPopup);
    return _super.call(this);
  }
  mergeCellsWithCommentsPopup_createClass(MergeCellsWithCommentsPopup, [{
    key: "onClick",
    value: function onClick() {
      var _this$props = this.props,
        onAction = _this$props.onAction,
        wantsToClose = _this$props.wantsToClose;
      onAction && onAction();
      wantsToClose && wantsToClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        editor = _this$props2.editor,
        wantsToClose = _this$props2.wantsToClose;
      var i18n = editor.plugins.i18n;
      return (0,preact_module.h)(popupMenu/* default */.Z, {
        wantsToClose: wantsToClose,
        addClassName: "merge-cells-with-comments-popup",
        closeOnEsc: true
      }, (0,preact_module.h)(popupDialog/* default */.Z, {
        wantsToClose: wantsToClose,
        addClassName: 'reduced-padding',
        noCloseButton: true
      }, (0,preact_module.h)(popupDialogTitle/* default */.Z, null, i18n.get('table.merge_cells_with_comments.title')), (0,preact_module.h)(popupDialogBody/* default */.Z, {
        style: {
          'max-width': '520px'
        }
      }, (0,preact_module.h)("p", null, (0,preact_module.h)("span", null, i18n.get('table.merge_cells_with_comments.text')))), (0,preact_module.h)(popupDialogButtons/* default */.Z, {
        editor: editor,
        wantsToClose: wantsToClose,
        buttons: {
          cancel: {},
          accept: {
            text: i18n.get('table.merge_cells_with_comments.accept'),
            style: 'active',
            onClick: this.onClick.bind(this)
          }
        }
      })));
    }
  }]);
  return MergeCellsWithCommentsPopup;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/table.js











var table_excluded = ["dateId"];
function table_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = table_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function table_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function table_table_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = table_table_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function table_table_toConsumableArray(arr) { return table_table_arrayWithoutHoles(arr) || table_table_iterableToArray(arr) || table_table_unsupportedIterableToArray(arr) || table_table_nonIterableSpread(); }
function table_table_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function table_table_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return table_table_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return table_table_arrayLikeToArray(o, minLen); }
function table_table_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function table_table_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return table_table_arrayLikeToArray(arr); }
function table_table_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function table_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function table_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { table_ownKeys(Object(source), true).forEach(function (key) { table_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { table_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function table_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function table_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { table_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { table_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function table_table_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { table_table_typeof = function _typeof(obj) { return typeof obj; }; } else { table_table_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return table_table_typeof(obj); }


























function table_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function table_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function table_createClass(Constructor, protoProps, staticProps) { if (protoProps) table_defineProperties(Constructor.prototype, protoProps); if (staticProps) table_defineProperties(Constructor, staticProps); return Constructor; }
function table_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { table_get = Reflect.get; } else { table_get = function _get(target, property, receiver) { var base = table_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return table_get(target, property, receiver || target); }
function table_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = table_getPrototypeOf(object); if (object === null) break; } return object; }
function table_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) table_setPrototypeOf(subClass, superClass); }
function table_setPrototypeOf(o, p) { table_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return table_setPrototypeOf(o, p); }
function table_createSuper(Derived) { var hasNativeReflectConstruct = table_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = table_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = table_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return table_possibleConstructorReturn(this, result); }; }
function table_possibleConstructorReturn(self, call) { if (call && (table_table_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return table_assertThisInitialized(self); }
function table_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function table_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function table_getPrototypeOf(o) { table_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return table_getPrototypeOf(o); }
function table_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










































var DateActionsCls = dateActions(Object);
var table_MAX_INDENT_LEVEL = 30;
var table_mixin = mix([commentable, tableCopy, tablePaste, tableImportCsv, withCaption, blotLock, fullWidth, embeddable, dropAcceptor, draggable, colorable, indentable, selectable, focusable, basic, executable]);
var Table = /*#__PURE__*/function (_mixin) {
  table_inherits(Table, _mixin);
  var _super = table_createSuper(Table);
  function Table(domNode) {
    var _this;
    table_classCallCheck(this, Table);
    _this = _super.call(this, domNode);
    //this.domNode.classList.add('table-blot')
    table_defineProperty(table_assertThisInitialized(_this), "tableMapObserve", function () {
      _this.setAttachedByUndo();
    });
    table_defineProperty(table_assertThisInitialized(_this), "onEditorContentUpdate", function (_ref) {
      var source = _ref.source,
        transaction = _ref.transaction;
      var undoManager = _this.editor.plugins.undoManager;
      if (source !== null && (source === 'remote' || source === 'client' || undoManager !== null && undoManager !== void 0 && undoManager.isYUndoManager(source))) {
        var needRender = false,
          needMapToObject = false;
        transaction.changed.forEach(function (i, map) {
          if (map.parent && needMapToObject !== 'full') {
            var _map$get, _map$get$call, _map$parent$get;
            var mapType = (_map$get = map.get) === null || _map$get === void 0 ? void 0 : (_map$get$call = _map$get.call(map, 'type')) === null || _map$get$call === void 0 ? void 0 : _map$get$call.toLowerCase();
            var parentType = (_map$parent$get = map.parent.get('type')) === null || _map$parent$get === void 0 ? void 0 : _map$parent$get.toLowerCase();
            if (mapType === 'table' || parentType === 'table') {
              var _map$parent;
              // Апдеиты корневой таблицы
              if (map.get('id') === _this.id || ((_map$parent = map.parent) === null || _map$parent === void 0 ? void 0 : _map$parent.get('id')) === _this.id) {
                needMapToObject = 'full';
              }
            } else if (mapType === 'column') {
              // Апдеиты колонок
              if (_this.cols.toArray().includes(map.get('id'))) {
                needMapToObject = 'full';
              }
            } else if (mapType === 'row' || mapType === 'tablerow') {
              // Апдеиты строк
              if (_this.rows.toArray().includes(map.get('id'))) {
                needMapToObject = 'full';
              }
            } else if (parentType === 'row' || parentType === 'tablerow') {
              if (_this.rows.toArray().includes(map.parent.get('id'))) {
                needMapToObject = 'full';
              }
            } else if (mapType && mapType.indexOf('cell') !== -1) {
              // Апдеиты ячейки блота
              needRender = _this.tableBodyEmbed.updateCellById(map.get('id'), 'cell') || needRender;
            } else if (parentType === 'tabletext') {
              // Апдеиты текстового блота
              needRender = _this.tableBodyEmbed.updateCellById(map.parent.get('id'), 'child') || needRender;
            }
          }
        });
        if (needMapToObject) {
          _this.tableBodyEmbed.mapToObject({
            mode: needMapToObject,
            render: true
          });
        } else if (needRender) {
          _this.tableBodyEmbed.render();
        }
      }
    });
    table_defineProperty(table_assertThisInitialized(_this), "onBodyResizeBound", _this.onBodyResize.bind(table_assertThisInitialized(_this)));
    table_defineProperty(table_assertThisInitialized(_this), "updateCommentsCounters", function () {
      // если таблица рендерится впервые, она не имеет доступа к компонентам, так как они еще не отрендерились и не имеют ссылок
      // в этом случае апдейт счетчиков комментариев делать не нужно
      if (!_this.tableComponentContext) return;
      var commentManager = _this.editor.plugins.commentManager;
      if (commentManager && commentManager.options.enabled && commentManager.options.tableCellComments) {
        var comments = commentManager.getTableComments(_this.id);
        _this.eachCellMap({}, {}, {}, function (cellMap, pos) {
          var cellRef = _this.tableComponentContext.useRefs.getCell(pos);
          // при фильтрации ссылки на ячейку по позиции может не быть, для такой ячейки пропускаем выполнение функции
          if (!cellRef) return;
          var count = null;
          if (cellMap) {
            if (cellMap.has('commentThreads')) {
              var comment = comments && comments.length && comments.find(function (c) {
                return c.threadId === cellMap.get('commentThreads');
              });
              if (comment && comment.count && !comment.resolved) {
                if (cellMap.get('hidden') !== true) {
                  if (cellRef) {
                    count = comment.count;
                  }
                }
              }
            }
            var _this$getMergedCellsC = _this.getMergedCellsComments(cellMap, pos, comments),
              mergedCommentsCount = _this$getMergedCellsC.count;
            if (mergedCommentsCount > 0) {
              if (typeof count === 'number') {
                count += mergedCommentsCount;
              } else {
                count = mergedCommentsCount;
              }
            }
          }
          if (cellRef.getCommentsCount() !== count) {
            cellRef.setCommentsCount(count);
          }
        });
      }
    });
    table_defineProperty(table_assertThisInitialized(_this), "onMenuTableFilter", function () {
      if (_this.tableExec('open-filter', {})) {
        _this.tableComponentContext.useFilter.toggleFilter();
      }
    });
    table_defineProperty(table_assertThisInitialized(_this), "fullPos", function () {
      var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'min';
      var resultPos = Object.assign({}, table_table_typeof(pos) === 'object' ? pos : {});
      if (!resultPos.hasOwnProperty('row')) {
        resultPos.row = mode === 'min' ? 0 : _this.rowLast;
      }
      if (!resultPos.hasOwnProperty('col')) {
        resultPos.col = mode === 'min' ? 0 : _this.colLast;
      }
      return resultPos;
    });
    table_defineProperty(table_assertThisInitialized(_this), "compareCellsByValue", function () {
      var order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'asc';
      var a = arguments.length > 1 ? arguments[1] : undefined;
      var b = arguments.length > 2 ? arguments[2] : undefined;
      if (a.value !== b.value || a.order !== b.order) {
        var aType = table_table_typeof(a.value);
        var bType = table_table_typeof(b.value);
        var aIsEmpty = aType == "undefined" || a.value === null || aType == "number" && isNaN(a.value);
        var bIsEmpty = bType == "undefined" || b.value === null || bType == "number" && isNaN(b.value);
        if (aIsEmpty && !bIsEmpty) {
          return -1;
        } else if (bIsEmpty && !aIsEmpty) {
          return 1;
        }
        // Сортировка по типу ячейки
        if (a.order !== b.order) {
          return a.order - b.order > 0 ? 1 : -1;
        }
        if (aType == "number" && bType == "number") {
          return a.value - b.value > 0 ? 1 : -1;
        }
        if (aType == "string" && bType == "string") {
          return a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1;
        }
        if (aType == "number" && bType == "string") {
          return -1;
        }
        if (aType == "string" && bType == "number") {
          return 1;
        }
      }
      if (order === 'desc') {
        return a.row - b.row > 0 ? -1 : 1;
      } else {
        return a.row - b.row > 0 ? 1 : -1;
      }
    });
    _this.tableBodyEmbed = parchment_default().create('tableBodyEmbed');
    _this.tableBlotEditCell = parchment_default().create('tableBlotEditCell');
    _this.allowUpdate = true;
    _this.allowInsideDrop = true;
    _this.selfColorManagement = true;
    _this.isSeparableByClickApplicable = true;
    _this.attachedByUndo = false; // был ли блот добавлен/изменён через undo
    _this.addCanExecActions(['add-column', 'add-row', 'duplicate-column', 'delete-cols', 'delete-rows', 'divide-cols', 'merge-cells', 'delete-blot', 'delete', 'backspace', 'convert-table-cells', 'convert-table-column', 'format-table-cells', 'format-table-column', 'select-all', 'set-embed-align', 'copy-cells', 'sort-table-column', 'exit-sort-table-column', 'render-fullwidth']);
    return _this;
  }
  table_createClass(Table, [{
    key: "setAttachedByUndo",
    value: function setAttachedByUndo() {
      this.attachedByUndo = this.editor.plugins.undoManager.isUndoing();
    }
  }, {
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = table_get(table_getPrototypeOf(Table.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      if (this._initialized) {
        return;
      }
      this.bench = new Performance(this.map.get('id'));
      var mark = this.bench.mark('Table attach full');
      this._initialized = true;
      this._skipFocusEvent = false;
      this.domNode.setAttribute('contenteditable', false);
      var mark2 = this.bench.mark('Table attach body');
      this.tableBodyEmbed.map = this.map;
      this.tableBodyEmbed.store = this.store;
      this.tableBodyEmbed.editor = this.editor;
      this.appendChild(this.tableBodyEmbed);
      this.bench.measure(mark2);
      if (this.fullWidth) {
        this.fullWidth = Object.assign(this.fullWidth, {
          default: true,
          wrapperNode: this.getWrapper().domNode,
          afterFunc: this.onFullwidthChange.bind(this),
          scrollNode: this.getScrollItems()
        });
      }
      this.tableBlotEditCell.map = this.map;
      this.appendChild(this.tableBlotEditCell);
      this.editor.on('contentUpdate', this.onEditorContentUpdate);
      this.editor.on('editorBodyResize', this.onBodyResizeBound);
      this.editor.on('set-comments', this.updateCommentsCounters);
      this.bench.measure(mark);
      this.bench.print({
        flat: false,
        clear: true,
        tree: true
      });
      if ((typeof localStorage === "undefined" ? "undefined" : table_table_typeof(localStorage)) === 'object' && localStorage.getItem('logs')) {
        console.info('TABLE', this);
      }
      this.store.observe(this.map, this.tableMapObserve);
      this.setAttachedByUndo();
    }
  }, {
    key: "detach",
    value: function detach() {
      var cleanupError;
      try {
        this.editor.off('contentUpdate', this.onEditorContentUpdate);
        this.editor.off('editorBodyResize', this.onBodyResizeBound);
        this.editor.on('set-comments', this.updateCommentsCounters);
        this.clearDateReminders();
      } catch (err) {
        cleanupError = err;
      }
      table_get(table_getPrototypeOf(Table.prototype), "detach", this).call(this);
      this.store.unobserve(this.map, this.tableMapObserve);

      // выкидываем ошибку только после детача блота
      if (cleanupError) {
        throw cleanupError;
      }
    }
  }, {
    key: "setDateRemineders",
    value: function setDateRemineders() {
      var _ref2 = this.map.toJSON() || {},
        _ref2$rows = _ref2.rows,
        rows = _ref2$rows === void 0 ? [] : _ref2$rows;
      var reminders = Table.findReminders(this.editor, rows);
      Table.setReminders(this.editor, rows);
    }

    /**
     * Вызывается при удалении таблицы, для последующего удаления инлайн ремайндеров
     */
  }, {
    key: "clearDateReminders",
    value: function clearDateReminders() {
      var _this$parent, _this$parent$parent, _this$parent2, _this$parent2$parent;
      var inToggle = ((_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : (_this$parent$parent = _this$parent.parent) === null || _this$parent$parent === void 0 ? void 0 : _this$parent$parent.map.get('type')) === 'toggle' || false;
      var isToggleCollapsed = inToggle && ((_this$parent2 = this.parent) === null || _this$parent2 === void 0 ? void 0 : (_this$parent2$parent = _this$parent2.parent) === null || _this$parent2$parent === void 0 ? void 0 : _this$parent2$parent.map.get('collapsed')) || false;
      if (!isToggleCollapsed) {
        var _ref3 = this.map.toJSON() || {},
          _ref3$rows = _ref3.rows,
          rows = _ref3$rows === void 0 ? [] : _ref3$rows;
        Table.removeReminders(this.editor, rows);
      }
    }

    /**
     * Находит все айди блотов аттачей, которые используются таблицей
     * @param { YMap } tableMap map для таблицы, так как метод статический и не имеет доступа к блотам
     * @returns { string[] }
     */
  }, {
    key: "getAttachments",
    value:
    /**
     * Обертка над static getAttachments, но для экземпляра блота таблицы
     * @returns
     */
    function getAttachments() {
      return Table.getAttachments(this.editor, this.map);
    }

    /**
     * Находит все инлайн ремайндеры в таблице
     * @param { Object } editor
     * @param { Array } rows
     * @returns { Array }
     */
  }, {
    key: "onFullwidthChange",
    value: function onFullwidthChange() {
      if (this.skipFullwidthChange) {
        this.skipFullwidthChange = false;
      } else {
        this.tableBodyEmbed.render();
      }
    }

    /**
     * Обработка апдеитов контента редактора, слушаем remote source и undo manager
     * При апдеите map'ов в в редакторе таблица проверяет относится ли id к ней (корневой map, строки, столбцы и ячейки)
     * Если относятся, то заново рендерится соответствующий компонент таблицы
     */
  }, {
    key: "onBodyResize",
    value: function onBodyResize() {
      var _this$componentOnActi;
      (_this$componentOnActi = this.componentOnAction) === null || _this$componentOnActi === void 0 ? void 0 : _this$componentOnActi.call(this, {
        type: 'scroll-update'
      });
    }
  }, {
    key: "contextMenu",
    get: function get() {
      var menu = table_get(table_getPrototypeOf(Table.prototype), "contextMenu", this);
      var i18n = this.editor.plugins.i18n;
      var colHeadingsMode = this.getMode('colHeadings');
      var rowHeadingsMode = this.getMode('rowHeadings');
      var wrapCellsMode = this.getMode('wrapCells');
      var summariesMode = this.getMode('showSummaries');
      var enabledFilterMode = Boolean(!this.getMode('disableFilter'));
      if (this.getWrapper().caption && menu.hasOwnProperty('addCaption')) {
        menu['addCaption'].index = -4;
      } else {
        if (menu.hasOwnProperty('addCaption')) {
          delete menu['addCaption'];
        }
      }
      menu['layout'] = (0,util/* mergeDeep */.Ee)(menu['layout'], {
        label: i18n.get('table.menu.table_layout.name'),
        index: -1,
        group: 0,
        stackable: false,
        action: false,
        submenu: {
          columnHeadings: {
            label: i18n.get('table.menu.table_layout.column_headings'),
            index: 1,
            group: 0,
            action: 'switchMode',
            actionParams: 'colHeadings',
            icon: colHeadingsMode ? icons/* IconDone */.EZi : false,
            style: colHeadingsMode ? 'done' : 'undone'
          },
          rowHeadings: {
            label: i18n.get('table.menu.table_layout.row_headings'),
            index: 2,
            group: 0,
            action: 'switchMode',
            actionParams: 'rowHeadings',
            icon: rowHeadingsMode ? icons/* IconDone */.EZi : false,
            style: rowHeadingsMode ? 'done' : 'undone'
          },
          wrapCells: {
            label: i18n.get('table.wrap_cells.layout_menu'),
            index: 3,
            group: 0,
            action: 'switchMode',
            actionParams: 'wrapCells',
            icon: wrapCellsMode ? icons/* IconDone */.EZi : false,
            style: wrapCellsMode ? 'done' : 'undone'
          },
          summaries: {
            label: i18n.get('table.summary.layout_menu'),
            index: 4,
            group: 0,
            action: 'switchMode',
            actionParams: 'showSummaries',
            icon: summariesMode ? icons/* IconDone */.EZi : false,
            style: summariesMode ? 'done' : 'undone'
          }
        }
      });
      if (this.hasFilter()) {
        menu['layout'].submenu.disableFilter = {
          label: i18n.get('table.filter.enable_filter'),
          index: 5,
          group: 0,
          action: 'switchMode',
          actionParams: 'disableFilter',
          icon: enabledFilterMode ? icons/* IconDone */.EZi : false,
          style: enabledFilterMode ? 'done' : 'undone'
        };
      }
      menu['filter'] = {
        label: i18n.get('table.menu.filter'),
        index: 2,
        group: 0,
        action: 'onMenuTableFilter',
        stackable: false
      };
      menu['import-csv'] = {
        label: i18n.get('table.menu.import_csv'),
        index: 3,
        group: 0,
        action: 'importCsvFile',
        stackable: false
      };
      menu['open-help'] = {
        label: i18n.get('table.menu.help'),
        index: 4,
        group: 0,
        action: 'openHelpPage',
        stackable: false
      };
      menu.align = false;
      menu.indent = false;

      // для таблицы меняем лейбл пунтка копирования
      if (menu.copyBlocks) {
        menu.copyBlocks.label = i18n.get('table.menu.copy_table');
      }
      return menu;
    }
  }, {
    key: "getBlotMenuHeaderComponent",
    value: function getBlotMenuHeaderComponent() {
      var _this$fullwidthPositi;
      if ((_this$fullwidthPositi = this.fullwidthPosition) !== null && _this$fullwidthPositi !== void 0 && _this$fullwidthPositi.enabled) {
        return null;
      } else {
        return TableBlotMenuHeader;
      }
    }
  }, {
    key: "onFocusableFocus",
    value: function onFocusableFocus(lastFocusedBlot) {
      if (this.editor.mode !== this.editor.constructor.MODE_EDIT || this.isBlotLocked) {
        return;
      }
      if (table_get(table_getPrototypeOf(Table.prototype), "onFocusableFocus", this)) {
        table_get(table_getPrototypeOf(Table.prototype), "onFocusableFocus", this).call(this);
      }
      this.domNode.classList.add('focused-table');
      if (!this.getSelection.current) {
        var _this$getWrapper;
        var pos = {
          row: 0,
          col: 0
        };
        if (lastFocusedBlot === ((_this$getWrapper = this.getWrapper()) === null || _this$getWrapper === void 0 ? void 0 : _this$getWrapper.next)) {
          var bigCell = this.getBigCell({
            col: 0,
            row: this.rowLast
          });
          pos.row = bigCell.pos.row;
        }
        this.selectCells(pos);
      }
    }
  }, {
    key: "onFocusableBlur",
    value: function onFocusableBlur() {
      if (table_get(table_getPrototypeOf(Table.prototype), "onFocusableBlur", this)) {
        table_get(table_getPrototypeOf(Table.prototype), "onFocusableBlur", this).call(this);
      }
      this.domNode.classList.remove('focused-table');
    }
  }, {
    key: "focusableFocus",
    value: function focusableFocus() {
      this.setCaretInTrap();
    }
  }, {
    key: "onTableSelectionUpdate",
    value: function onTableSelectionUpdate() {
      if (this.renderWithFilter()) {
        this.tableBodyEmbed.mapToObject({
          render: true,
          mode: 'full'
        });
      }
    }
  }, {
    key: "getMergedCellsComments",
    value: function getMergedCellsComments(cellMap, pos, comments) {
      var _this2 = this;
      var count = 0;
      var mergedThreads = [];
      var colspan = parseInt(cellMap.get('colspan'));
      var rowspan = parseInt(cellMap.get('rowspan'));
      if (!isNaN(colspan) && typeof colspan === 'number' && !isNaN(rowspan) && typeof rowspan === 'number') {
        for (var i = 0; i < colspan; i++) {
          var _loop = function _loop(j) {
            if (i === 0 && j === 0) return "continue";
            var mergedCellMap = _this2.cellMapByPos({
              col: pos.col + i,
              row: pos.row + j
            });
            if (mergedCellMap && mergedCellMap.has('commentThreads')) {
              var mergedComment = comments && comments.length > 0 && comments.find(function (c) {
                return c.threadId === mergedCellMap.get('commentThreads');
              });
              if (mergedComment && mergedComment.count && !mergedComment.resolved) {
                count += mergedComment.count;
                mergedThreads.push(mergedComment.threadId);
              }
            }
          };
          for (var j = 0; j < rowspan; j++) {
            var _ret = _loop(j);
            if (_ret === "continue") continue;
          }
        }
      }
      return {
        count: count,
        mergedThreads: mergedThreads
      };
    }
  }, {
    key: "onTableCommentCell",
    value: function onTableCommentCell(_ref4) {
      var pos = _ref4.pos;
      if (!this.tableComponentContext) return;
      var commentManager = this.editor.plugins.commentManager;
      if (commentManager && commentManager.options.enabled && commentManager.options.tableCellComments) {
        var row = pos.row,
          col = pos.col;
        var cellRef = this.tableComponentContext.useRefs.getCell(pos);
        var rowMap = this.rowMapByIndex(row);
        var cellMap;
        var cellId;
        if (rowMap) {
          cellMap = this.cellMapByPos({
            row: row,
            col: col
          }, {
            rowMap: rowMap
          });
          if (cellMap) {
            cellId = cellMap.get('id');
          }
        }
        if (!cellMap) {
          cellId = this.createInnerMap('cell', {
            row: row,
            col: col,
            inTransaction: false
          });
          cellMap = this.store.getMap(cellId);
        }
        if (cellId) {
          var commentThreadId = cellMap.get('commentThreads');
          var comments = commentManager.getTableComments(this.id);
          // если ячейка имеет тред id, но комментарии к ней удалены, не нужно открывать комменты для этого тред id
          if (commentThreadId && !comments.find(function (c) {
            return c.threadId === commentThreadId;
          })) {
            commentThreadId = undefined;
          }
          // если ячейка не имеет тредов, возможно ячейки, которые смерджены в неё, имеют треды
          if (!commentThreadId) {
            var _this$getMergedCellsC2 = this.getMergedCellsComments(cellMap, pos, comments),
              mergedThreads = _this$getMergedCellsC2.mergedThreads;
            if (mergedThreads && mergedThreads.length) {
              commentThreadId = mergedThreads[0];
            }
          }
          var cellNode = cellRef.getNode();
          var text = '';
          if (cellRef) {
            text = cellRef.getText();
          }
          text = text.length <= 50 ? text : text.substr(0, 50) + '...';
          if (cellNode) {
            var params = {
              threadId: commentThreadId,
              text: text,
              targetParams: {
                type: 'tableCell',
                position: pos
              },
              target: 'cell'
            };
            this.editor.plugins.commentManager.openComments(cellId, params).then(function (_ref5) {
              var threadId = _ref5.threadId,
                isNew = _ref5.isNew;
              if (isNew) {
                cellMap.set('commentThreads', threadId);
              }
            }).catch(function (err) {
              return console.error(err);
            });
          }
        }
      }
    }

    /**
     * Возвращает значение для опций таблицы, установленное в map либо дефолтное из конфига
     * @param { string } name: имя опции, (напр. wrapCells, rowHeadings, colHeadings, showSummaries)
     * @returns { boolean }
     */
  }, {
    key: "getMode",
    value: function getMode(name) {
      var prop = CONFIG.table.settings[name];
      if (prop !== null && prop !== void 0 && prop.hasOwnProperty('export') && this.editor.mode === this.editor.constructor.MODE_EXPORT) {
        return prop.export;
      }
      return this.map.has(prop.key) ? this.map.get(prop.key) : prop.default;
    }

    /**
     * Переключает значение для опций таблицы
     * @param { string } name: имя опции, (напр. wrapCells, rowHeadings, colHeadings, showSummaries)
     * @returns
     */
  }, {
    key: "switchMode",
    value: function switchMode(name) {
      var mode = this.getMode(name);
      var prop = CONFIG.table.settings[name];
      if (prop.hasOwnProperty('permission')) {
        var permission = this.permission(prop.permission, {
          alert: true
        });
        if (!permission) {
          return;
        }
      }
      this.map.set(prop.key, !mode);
      this.tableBodyEmbed.mapToObject({
        render: true,
        mode: 'table'
      });
    }
  }, {
    key: "openHelpPage",
    value: function openHelpPage() {
      var i18n = this.editor.plugins.i18n;
      var url = 'https://nimbusweb.me/share/3630871/2hfp17421cshqqgnqs3z';
      if (i18n.language === 'ru') {
        url = 'https://nimbusweb.me/share/3610312/rmzfthr644osw5cqre3e';
      }
      window.open(url, '_blank', 'noopener');
    }
  }, {
    key: "importCsvFile",
    value: function importCsvFile() {
      if (!this.onImportCsvFile) return;
      this.onImportCsvFile();
    }
  }, {
    key: "getWrapper",
    value: function getWrapper() {
      return this.parent;
    }
  }, {
    key: "getScrollItems",
    value: function getScrollItems() {
      var _this$tableBodyEmbed$;
      return (_this$tableBodyEmbed$ = this.tableBodyEmbed.domNode.getElementsByClassName('table-scroll-items')) === null || _this$tableBodyEmbed$ === void 0 ? void 0 : _this$tableBodyEmbed$[0];
    }
  }, {
    key: "onBlotMenuUpdatePosition",
    value: function onBlotMenuUpdatePosition(_ref6) {
      var left = _ref6.left,
        top = _ref6.top;
      var correction = this.fullwidthMenuMargin < 0 ? -table.toolbarMargin : 0;
      return {
        left: left + this.fullwidthMenuMargin + correction,
        top: top
      };
    }
  }, {
    key: "blotWillReceiveProps",
    value: function blotWillReceiveProps(newProps) {
      if (this.props.focused && !newProps.focused) {
        // блот таблицы теряет форкус, нужно убрать выделение с текущих активных ячеек
        // проверяем также что элемент не удален со страницы, т.к. focused может менятся скроллом для удалнных элементов,
        // если они раньше были в фокусе
        if (this.isBlotAttached()) {
          // не анселектим ячейки, если фокус переходит на эту же таблицу или ее вложения
          var unselect = true;
          var focusedBlot = this.scroll.willBeFocused;
          if (focusedBlot) {
            if (focusedBlot === this) {
              unselect = false;
            } else {
              var blot = focusedBlot.parent;
              while (blot) {
                if (blot === this) {
                  unselect = false;
                  break;
                }
                blot = blot.parent;
              }
            }
          } else {
            unselect = true;
          }
          if (unselect) {
            this.unselectAllCells();
          }
        }
        if (newProps.tempRow) {
          delete newProps.tempRow;
        }
      }
      if (this.props.blotLocked !== newProps.blotLocked) {
        if (newProps.blotLocked) {
          this.unselectAllCells();
        }
        this.needRenderComponent = 'table';
      }
    }

    /**
     * Рендер враппера таблицы
     * @param { object } opts
     */
  }, {
    key: "render",
    value: function render() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      table_get(table_getPrototypeOf(Table.prototype), "render", this).call(this);
      if (!this.isBlotAttached()) {
        // если таблица не заатачена не рендерим ее
        return;
      }
      this.renderWrapper(opts);
      if (this.needRenderComponent) {
        this.tableBodyEmbed.mapToObject({
          render: true,
          mode: this.needRenderComponent
        });
        this.needRenderComponent = false;
      }
    }

    /**
     * Принудительный полный рендер компонента таблицы
     */
  }, {
    key: "forceFullRender",
    value: function forceFullRender() {
      this.tableBodyEmbed.mapToObject({
        mode: 'full',
        render: true
      });
    }

    /**
     * Рендер враппера таблицы
     * @param { object } opts
     */
  }, {
    key: "renderWrapper",
    value: function renderWrapper() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.getWrapper().render({
        align: this.map.get('embed-align'),
        color: this.map.get('color'),
        focused: this.props.focused,
        init: opts.init ? true : false
      });
    }

    /**
     * Вызываем рендер капшина
     * С таймаутом надо разобраться
     */
  }, {
    key: "renderCaption",
    value: function () {
      var _renderCaption = table_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this$getWrapper2, _this$getWrapper2$cap, _this$getWrapper2$cap2;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return 0;
              case 2:
                (_this$getWrapper2 = this.getWrapper()) === null || _this$getWrapper2 === void 0 ? void 0 : (_this$getWrapper2$cap = _this$getWrapper2.caption) === null || _this$getWrapper2$cap === void 0 ? void 0 : (_this$getWrapper2$cap2 = _this$getWrapper2$cap.render) === null || _this$getWrapper2$cap2 === void 0 ? void 0 : _this$getWrapper2$cap2.call(_this$getWrapper2$cap);
              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function renderCaption() {
        return _renderCaption.apply(this, arguments);
      }
      return renderCaption;
    }() /**
         * Устанавливает или удаляет класс из blot.domNode
         * @param { string } className: имя класса
         * @param { boolean } state: установить или удалить класс
         */
  }, {
    key: "setClass",
    value: function setClass(className) {
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.domNode.classList[state ? 'add' : 'remove'](String(className));
    }
  }, {
    key: "optimize",
    value: function optimize() {
      table_get(table_getPrototypeOf(Table.prototype), "optimize", this).call(this);
    }

    /**
    * Создаем map для внутренних элементов таблицы: строк, колонок, ячеек, контента
    * Если map в данной позиции уже есть, то вернет его, для принудительной замены на новый используй options.forceCreate
    * @param { string } type: тип map (row, col, cell, child)
    * @param { object } options?
    * @param { boolean } options.forceCreate?: заменять на новый map, если он уже есть в этой позиции
    * @param { boolean } options.inTransaction?: true если функция вызывается из внешней транзакции, тогда она не создает собственную
    * @returns { string } mapId
    */
  }, {
    key: "createInnerMap",
    value: function createInnerMap(type, pos) {
      var _this3 = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var map, mapId;
      var execute = function execute() {
        if (type === 'row') {
          var rows = _this3.rows;
          if (!options.forceCreate && rows.get(pos.row)) {
            mapId = rows.get(pos.row);
          } else {
            map = _this3.store.createMap(false, {
              type: 'row',
              children: new _this3.store.types.Array()
            });
            mapId = map.get('id');
            _this3.mapArraySet(rows, pos.row, [mapId]);
          }
        } else if (type === 'col') {
          var cols = _this3.cols;
          if (!options.forceCreate && cols.get(pos.col)) {
            mapId = cols.get(pos.col);
          } else {
            map = _this3.store.createMap(false, {
              type: 'column'
            });
            mapId = map.get('id');
            _this3.mapArraySet(cols, pos.col, [mapId]);
          }
        } else if (type === 'cell' || type === 'child') {
          var rowId = _this3.rows.get(pos.row);
          // Проверяем строку
          if (!rowId) {
            rowId = _this3.createInnerMap('row', pos, table_objectSpread(table_objectSpread({}, options), {}, {
              inTransaction: true,
              forceCreate: false
            }));
          }
          var rowMap = _this3.store.getMap(rowId);
          var colId = _this3.cols.get(pos.col);
          var colMap = colId && _this3.store.getMap(colId);
          if (type === 'cell') {
            var children = rowMap.get('children');
            if (!options.forceCreate && children.get(pos.col)) {
              mapId = children.get(pos.col);
            } else {
              map = initInnerMap(_this3.store, 'cell', {
                cellType: colMap && colMap.get('columnType') || 'text'
              });
              mapId = map.get('id');
              _this3.mapArraySet(children, pos.col, [mapId]);
            }
          } else if (type === 'child') {
            var cellId = rowMap.get('children').get(pos.col);
            // Проверяем ячейку
            if (!cellId) {
              cellId = _this3.createInnerMap('cell', pos, table_objectSpread(table_objectSpread({}, options), {}, {
                inTransaction: true,
                forceCreate: false
              }));
            }
            var cellMap = _this3.store.getMap(cellId);
            var _children = cellMap.get('children');
            if (!options.forceCreate && _children.get(0)) {
              mapId = _children.get(0);
            } else {
              map = _this3.store.createMap(false, {
                type: 'tableText'
              });
              mapId = map.get('id');
              textBase.initMap(map, _this3.store, {
                noDefaultAlign: true,
                noDefaultColor: true
              });
              cellMap.get('children').push([mapId]);
            }
          }
        }
      };
      if (!options.inTransaction) {
        this.store.transaction(function () {
          execute();
        });
      } else {
        execute();
      }
      return mapId;
    }

    /**
     * Выделить все ячейки таблицы
     */
  }, {
    key: "selectAllCells",
    value: function selectAllCells() {
      this.selectCells({
        row: 0,
        col: 0
      }, {
        row: this.rowLast,
        col: this.colLast
      });
    }

    /**
     * Выделить ячейки
     * @param { object } start: {col, row, current} координаты первой ячейки
     * @param { object } last: {col, row} координаты последней ячейки
     */
  }, {
    key: "selectCells",
    value: function selectCells() {
      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var last = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!last.hasOwnProperty('row') && start.hasOwnProperty('row')) {
        last.row = start.row;
      }
      if (!last.hasOwnProperty('col') && start.hasOwnProperty('col')) {
        last.col = start.col;
      }
      this.componentOnAction({
        type: 'select-range',
        start: start,
        last: last
      });
    }

    /**
     * Снять выделение со всех ячеек
     */
  }, {
    key: "unselectAllCells",
    value: function unselectAllCells() {
      this.exec({
        type: 'unselect-all'
      });
    }

    /**
     * Нормализует позицию, при необходимости добавляет значение начала или конца таблицы
     * @param { object } pos: {row?, col?}
     * @param { string } mode: min, max привести к максимальной или мнимальной позиции в таблице
     * @returns { object } {row, col}
     */
  }, {
    key: "eachCellMap",
    value:
    /**
    * Передает позицию ячейки и map в cb функцию
    * @param { object } start: {col, row} координаты первой ячейки
    * @param { object } last: {col, row} координаты последней ячейки
    * @param { object } options?
    * @param { boolean } options.create?: создавать map при его отсутствии
    * @param { boolean } options.exist?: вызывать cb только для существующего map ячейки
    * @param { function } cb: cb функция (cellMap, {row, col}, {rowMap})
    */
    function eachCellMap() {
      var _this4 = this;
      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var last = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var cb = arguments.length > 3 ? arguments[3] : undefined;
      start = this.fullPos(start, 'min');
      last = this.fullPos(last, 'max');
      this.store.transaction(function () {
        for (var row = start.row; row <= last.row; row++) {
          var rowMap = _this4.rowMapByIndex(row);
          for (var col = start.col; col <= last.col; col++) {
            var cellMap = void 0;
            if (rowMap) {
              cellMap = _this4.cellMapByPos({
                row: row,
                col: col
              }, {
                rowMap: rowMap
              });
            }
            if (!cellMap && options.create) {
              var cellId = _this4.createInnerMap('cell', {
                row: row,
                col: col,
                inTransaction: true
              });
              cellMap = _this4.store.getMap(cellId);
            }
            if (!options.exist || cellMap) {
              cb === null || cb === void 0 ? void 0 : cb(cellMap, {
                row: row,
                col: col
              }, {
                rowMap: rowMap
              });
            }
          }
        }
      });
    }

    /**
    * Передает позицию и map строки в cb функцию
    * Если start или last не переданы они будут первой и последней строкой
    * @param { object } start?: {col, row} координаты первой строки
    * @param { object } last?: {col, row} координаты последней строки
    * @param { object } options?
    * @param { boolean } options.create?: создавать map при его отсутствии
    * @param { boolean } options.exist?: вызывать cb только для существующего map
    * @param { function } cb? cb функиця (rowMap, {row})
    */
  }, {
    key: "eachRowMap",
    value: function eachRowMap(start, last) {
      var _this5 = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var cb = arguments.length > 3 ? arguments[3] : undefined;
      if (!start || !start.hasOwnProperty('row')) {
        start = {
          row: 0
        };
      }
      if (!last || !last.hasOwnProperty('row')) {
        last = {
          row: this.tableSize.rows - 1
        };
      }
      this.store.transaction(function () {
        for (var row = start.row; row <= last.row; row++) {
          var rowMap = _this5.rowMapByIndex(row, {
            create: options.create
          });
          if (rowMap || !options.exist) {
            cb === null || cb === void 0 ? void 0 : cb(rowMap, {
              row: row
            });
          }
        }
      });
    }

    /**
    * Передает позицию и map колонки в cb функцию
    * Если start или last не переданы они будут первой и последней колонкой
    * @param { object } start?: {col} координаты первой колонки
    * @param { object } last?: {col} координаты последней колонки
    * @param { object } options?
    * @param { boolean } options.create?: создавать map при его отсутствии
    * @param { boolean } options.exist?: вызывать cb только для существующего map
    * @param { function } cb? функция (colMap, {col})
    */
  }, {
    key: "eachColMap",
    value: function eachColMap(start, last) {
      var _this6 = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var cb = arguments.length > 3 ? arguments[3] : undefined;
      if (!start || !start.hasOwnProperty('col')) {
        start = {
          col: 0
        };
      }
      if (!last || !last.hasOwnProperty('col')) {
        last = {
          col: this.tableSize.cols - 1
        };
      }
      this.store.transaction(function () {
        for (var col = start.col; col <= last.col; col++) {
          var colMap = _this6.colMapByIndex(col, {
            create: options.create
          });
          if (colMap || !options.exist) {
            cb === null || cb === void 0 ? void 0 : cb(colMap, {
              col: col
            });
          }
        }
      });
    }

    /**
    * Возвращает массив id строк таблицы
    * @returns { YArray }
    */
  }, {
    key: "rows",
    get: function get() {
      return this.map.get('rows');
    }

    /**
     * Индекс последней строки
     * Частая операция, вынес отдельно
     */
  }, {
    key: "rowLast",
    get: function get() {
      return this.tableSize.rows - 1;
    }

    /**
    * Возвращает массив id колонок таблицы
    * @returns { YArray }
    */
  }, {
    key: "cols",
    get: function get() {
      return this.map.get('columns');
    }
    /**
     * Индекс последней колонки
     */
  }, {
    key: "colLast",
    get: function get() {
      return this.tableSize.cols - 1;
    }
  }, {
    key: "ensureNewRowType",
    value: function ensureNewRowType() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var map = this.rowMapByIndex(index, {
        create: options.create
      });
      if (map && map.get('type') !== 'row') {
        map.set('type', 'row');
        return true;
      }
      return false;
    }

    /**
    * Возвращает map строки по ее индексу
    * @param { number } index
    * @param { object } options?
    * @param { boolean } options.create?: разрешает создавать map
    * @returns { YMap }
    */
  }, {
    key: "rowMapByIndex",
    value: function rowMapByIndex(index) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (table_table_typeof(index) === 'object') {
        index = index.row;
      }
      var rowMap;
      var rowId = this.rows.get(index);
      if (!rowId && options.create) {
        rowId = this.createInnerMap('row', {
          row: index,
          inTransaction: !!options.inTransaction
        });
      }
      if (rowId) {
        rowMap = this.store.getMap(rowId);
      }
      return rowMap;
    }

    /**
    * Возвращает map колонки по ее индексу
    * @param { number } index
    * @param { object } options?
    * @param { boolean } options.create?: разрешает создавать map
    * @returns { YMap }
    */
  }, {
    key: "colMapByIndex",
    value: function colMapByIndex(index) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (table_table_typeof(index) === 'object') {
        index = index.col;
      }
      var colMap;
      var colId = this.cols.get(index);
      if (!colId && options.create) {
        colId = this.createInnerMap('col', {
          col: index,
          inTransaction: !!options.inTransaction
        });
      }
      if (colId) {
        colMap = this.store.getMap(colId);
      }
      return colMap;
    }

    /**
    * Возвращает map ячейки по ее позиции, если он создан
    * @param { object } pos: {row, col}
    * @param { object } options?
    * @param { YMap } options.rowMap?: map строки, опционально для экономии в циклах
    * @param { YMap } options.create?: создавать map строки и ячейки при необходимости
    * @returns { YMap }
    */
  }, {
    key: "cellMapByPos",
    value: function cellMapByPos(pos) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cellMap;
      var rowMap = options.hasOwnProperty('rowMap') ? options.rowMap : this.rowMapByIndex(pos.row, {
        create: options.create
      });
      if (rowMap) {
        var children = rowMap.get('children');
        if (children) {
          var cellId = children.get(pos.col);
          if (!cellId && options.create) {
            cellId = this.createInnerMap('cell', pos);
          }
          if (cellId) {
            cellMap = this.store.getMap(cellId);
          }
        }
      }
      return cellMap;
    }

    /**
    * Возвращает map контента ячейки по ее позиции, если он создан
    * @param { object } pos?: {row, col}
    * @param { object } options?
    * @param { YMap } options.rowMap?: map строки, опционально для экономии в циклах
    * @param { YMap } options.cellMap?: map ячейки, опционально для экономии в циклах
    * @param { YMap } options.create?: создавать map строки, ячейки и контента при необходимости
    * @returns { YMap }
    */
  }, {
    key: "childMapByPos",
    value: function childMapByPos() {
      var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var childMap;
      var cellMap = options.hasOwnProperty('cellMap') ? options.cellMap : this.cellMapByPos(pos, options);
      if (cellMap) {
        var _children$get;
        var children = cellMap.get('children');
        var childId = children === null || children === void 0 ? void 0 : (_children$get = children.get) === null || _children$get === void 0 ? void 0 : _children$get.call(children, 0);
        if (!childId && options.create) {
          childId = this.createInnerMap('child', pos);
        }
        if (childId) {
          childMap = this.store.getMap(childId);
        }
      }
      return childMap;
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      var handled = this.onKeyDown && this.onKeyDown(event);
      return handled;
    }
  }, {
    key: "setOnKeyDown",
    value: function setOnKeyDown(func) {
      this.onKeyDown = func;
    }

    /**
     * Биндит и передает action в exec
     * @param {action} action
     */
  }, {
    key: "onTableAction",
    value: function onTableAction(action) {
      this.exec.bind(this, action)();
    }
  }, {
    key: "exec",
    value: function exec(action) {
      var processed = table_get(table_getPrototypeOf(Table.prototype), "exec", this).call(this, action);
      if (!processed) {
        processed = this.tableExec(action.type, action.params, action);
      }
      if (!processed) {
        processed = this.componentOnAction && this.componentOnAction(action);
      }
      return processed;
    }

    /**
    * Выполнение действий с таблицей
    * @param { string } type: тип действия
    * @param { object } params?: дополнительные параметры
    * @param { object } action
    * @returns { boolean } было ли действие обработано
    */
  }, {
    key: "tableExec",
    value: function tableExec(type) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var action = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      console.log(type, params, action);
      var processed = true;
      if (params === null || table_table_typeof(params) !== 'object') {
        params = {
          params: params
        };
      }
      if (type === 'copy-cells') {
        this.copySelectedCells(params);
      } else if (type === 'add-row') {
        this.changeSize({
          rows: params.count || 1
        }, table_objectSpread(table_objectSpread({}, params), {}, {
          render: true
        }));
      } else if (type === 'add-col') {
        this.changeSize({
          cols: params.count || 1
        }, table_objectSpread(table_objectSpread({}, params), {}, {
          render: true
        }));
      } else if (type === 'duplicate-column') {
        this.duplicateCols(params.start, table_objectSpread(table_objectSpread({}, params), {}, {
          render: true
        }));
      } else if (type === 'merge-cells') {
        processed = this.mergeCells(params.start, params.last, {
          render: true,
          dialog: true
        });
      } else if (type === 'divide-cells') {
        this.divideCells(params.pos, params.pos, {
          render: true
        });
      } else if (type === 'delete-rows') {
        this.deleteRows(params.start, params.last, {
          render: true
        });
      } else if (type === 'delete-cols') {
        this.deleteCols(params.start, params.last, {
          render: true
        });
      } else if (type === 'set-prop') {
        this.setInnerMapProp(params.start, params.last, params.key, params.val, {
          render: true,
          type: params.type
        });
      } else if (type === 'clear-cells') {
        this.clearCells(params.start, params.last, {
          render: true
        });
      } else if (type === 'sort-table-column') {
        this.setSortableColumn(params.pos, {
          order: params.order,
          render: true
        });
      } else if (type === 'exit-sort-table-column') {
        this.exitColumnSortingDialog({
          render: true
        });
      } else if (type === 'renew-sort-order') {
        this.renewSortOrder({
          animate: params.animate,
          render: true
        });
      } else if (type === 'convert-table-column') {
        this.convertColumn(params.start, params.last, params.type, {
          dialog: true,
          render: true
        });
      } else if (type === 'convert-table-cells') {
        this.convertCells(params.start, params.last, params.type, {
          render: true
        });
      } else if (type === 'format-table-column') {
        this.formatColumn(params.start, params.last, params.type, params.prop, params.value, {
          render: true
        });
      } else if (type === 'format-table-cells') {
        this.formatCells(params.start, params.last, params.type, params.prop, params.value, {
          render: true
        });
      } else if (type === 'set-embed-align') {
        this.map.set('embed-align', params.align);
        this.renderWrapper();
      } else if (type === 'move-table-row') {
        try {
          this.moveRow(params.start, params.last, params.index, {
            render: true
          });
          this.onFirstDragAndDropShowToastIfNeed();
        } catch (err) {
          console.warn(err);
        }
      } else if (type === 'move-table-column') {
        try {
          this.moveCol(params.start, params.last, params.index, {
            render: true
          });
          this.onFirstDragAndDropShowToastIfNeed();
        } catch (err) {
          console.warn(err);
        }
      } else if (type === 'delete' || type === 'backspace') {
        processed = this.deleteAction(action);
      } else if (type === 'render-fullwidth') {
        this.skipFullwidthChange = true;
        this.renderFullWidth();
      } else if (type === 'focus') {
        this.focusableFocus();
      } else if (type === 'touch') {
        processed = this.touch(params.type, params.pos);
      } else if (type === 'scroll-to-cell') {
        processed = this.scrollToCell(params);
      } else if (type === 'get-table-blot') {
        processed = this;
      } else if (type === 'filter') {
        this.setTableFilter(params);
      } else if (type === 'open-filter') {
        processed = this.openTableFilter(params);
      } else if (type === 'unset-temp-row') {
        if (this.props.tempRow) {
          this.setProps({
            tempRow: null
          });
          this.tableBodyEmbed.mapToObject({
            render: true,
            mode: 'full'
          });
        }
        processed = true;
      } else if (type === 'filter-disabled') {
        if (params.disabled) {
          this.map.set('filter-disabled', true);
        } else {
          this.map.delete('filter-disabled');
        }
        this.tableBodyEmbed.mapToObject({
          render: true,
          mode: 'full'
        });
      } else if (type === 'table-selection-update') {
        this.onTableSelectionUpdate();
      } else if (type === 'comment-cell') {
        this.onTableCommentCell(params);
      } else {
        console.info('tableExec', type, params);
        processed = false;
      }
      return processed;
    }
  }, {
    key: "onFirstDragAndDropShowToastIfNeed",
    value: function onFirstDragAndDropShowToastIfNeed() {
      var _this$editor$plugins = this.editor.plugins,
        notificationManager = _this$editor$plugins.notificationManager,
        i18n = _this$editor$plugins.i18n;
      var firstProcessed = this.editor.store.root.get('tableDragAndDropFirstProcessed');
      if (typeof firstProcessed === 'undefined' || !firstProcessed) {
        this.editor.store.root.set('tableDragAndDropFirstProcessed', true);
        notificationManager.toast(i18n.get('table.first_move_column_or_row_message'));
      }
    }

    /**
     * Touch функия, создает map при необходимости и возвращает его id
     * @param { string } type: cell
     * @param { object } pos {row,col}
     * @returns { string } id map
     */
  }, {
    key: "touch",
    value: function touch(type) {
      var _map;
      var pos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var map;
      if (type === 'cell') {
        map = this.cellMapByPos(pos, {
          create: true
        });
      }
      this.tableBodyEmbed.mapToObject({
        mode: 'rows',
        start: table_objectSpread({}, pos)
      });
      return (_map = map) === null || _map === void 0 ? void 0 : _map.get('id');
    }

    /**
    * Через эту функцию preact устанавливает обработчик ation событий
    * @param { function } func: функция обработчика в компоненте
    */
  }, {
    key: "setOnAction",
    value: function setOnAction(func) {
      this.componentOnAction = func;
    }

    /**
    * Через эту функцию прокидывается контекст preact компонента таблицы
    * @param { object } context: контекст компонента
    */
  }, {
    key: "setTableContext",
    value: function setTableContext(context) {
      this.tableComponentContext = context;
    }

    /**
     * Проверка, выделены ли все ячейки таблицы
     * @returns { boolean }
     */
  }, {
    key: "isAllCellsSelected",
    value: function isAllCellsSelected() {
      var result = false;
      var selection = this.componentOnAction({
        type: 'selection'
      });
      if (selection && selection.start && selection.last) {
        if (selection.start.row === 0 && selection.start.col === 0) {
          if (selection.last.row === this.rowLast && selection.last.col === this.colLast) {
            result = true;
          }
        }
      }
      return result;
    }
    /**
     * Обработка deleteAction
     * @param { object } action
     * @returns { boolean } processed
     */
  }, {
    key: "deleteAction",
    value: function deleteAction(action) {
      var _this7 = this;
      var processed = false;
      if (this.isAllCellsSelected() && action.keyboard) {
        var selection = this.componentOnAction({
          type: 'selection'
        });
        // при нажатии на delete/backspace на клавиатуре если вся ячейки выделены и они все пусты, то надо удалить таблицу
        var allCellsIsEmpty = true;
        this.eachCellMap(false, false, {
          exist: true
        }, function (cellMap, pos) {
          if (allCellsIsEmpty) {
            var _childMap$get, _childMap$get$toStrin;
            var childMap = _this7.childMapByPos(pos, {
              cellMap: cellMap
            });
            if (childMap !== null && childMap !== void 0 && (_childMap$get = childMap.get('characters')) !== null && _childMap$get !== void 0 && (_childMap$get$toStrin = _childMap$get.toString()) !== null && _childMap$get$toStrin !== void 0 && _childMap$get$toStrin.trim()) {
              allCellsIsEmpty = false;
            }
          }
        });
        if (action.type === 'delete') {
          if (allCellsIsEmpty) {
            if (action.rangeBefore && action.rangeBefore.index > 0) {
              action.rangeBefore.index = action.rangeBefore.index - 1;
            }
            this.remove();
            processed = true;
          }
        } else if (action.type === 'backspace') {
          if (allCellsIsEmpty && !selection.single) {
            this.remove();
            processed = true;
          }
        }
      }
      if (!processed) {
        // очищаем выделенные ячейки
        this.clearSelectedCells();
        processed = true;
      }
      return processed;
    }

    /**
      * Разрешение на выполенение действия
      * @param { string } type: действие
      * @param { object } options?
      * @param { boolean } options.alert?: разрешить показывать предупреждения
      * @returns { boolean | object }: true, false, { error }
      */
  }, {
    key: "permission",
    value: function permission(type) {
      var _this8 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$editor$plugins2 = this.editor.plugins,
        i18n = _this$editor$plugins2.i18n,
        popupManager = _this$editor$plugins2.popupManager,
        notificationManager = _this$editor$plugins2.notificationManager;
      var prm = true;
      if (type === 'merge-cells') {
        if (this.getMode('wrapCells') === false) {
          prm = false;
          if (options.alert) {
            popupManager.alert(i18n.get('table.wrap_cells.warnings.merge.title'), i18n.get('table.wrap_cells.warnings.merge.text'));
          }
        } else if (this.map.has('sortableColumn')) {
          prm = false;
          if (options.alert) {
            popupManager.alert(i18n.get('table.sorting.warning.merge.title'), i18n.get('table.sorting.warning.merge.text'));
          }
        } else if (this.map.has('filter') && this.map.get('filter') !== null) {
          prm = false;
          if (options.alert) {
            popupManager.alert(i18n.get('table.filter.warning.merge.title'), i18n.get('table.filter.warning.merge.text'));
          }
        }
      } else if (type === 'nowrap') {
        var merged = this.componentOnAction({
          type: 'is-merged'
        });
        prm = !(merged !== null && merged !== void 0 && merged.cells);
        if (!prm && options.alert) {
          popupManager.alert(i18n.get('table.wrap_cells.warnings.toggle.title'), i18n.get('table.wrap_cells.warnings.toggle.text'));
        }
      } else if (type === 'sort-column') {
        var _merged = this.componentOnAction({
          type: 'is-merged'
        });
        prm = !(_merged !== null && _merged !== void 0 && _merged.rows);
        if (!prm && options.alert) {
          popupManager.alert(i18n.get('table.sorting.warning.table_rowspan.title'), i18n.get('table.sorting.warning.table_rowspan.text'));
        }
      } else if (type === 'convert') {
        var _merged2 = this.componentOnAction({
          type: 'is-selection-merged'
        });
        prm = !(_merged2 !== null && _merged2 !== void 0 && _merged2.cells);
        if (!prm && options.alert) {
          notificationManager.toast(i18n.get('table.warning.convert_merged'));
        }
      } else if (type === 'move-row' || type === 'move-col') {
        var err = false;
        if (type === 'move-row') {
          if (!options.start.hasOwnProperty('row') || isNaN(options.index) || options.index < 0 || options.index > this.tableSize.rows) {
            err = 'position';
          } else if (this.sortableColumn) {
            err = 'sortable';
          } else if (this.renderWithFilter()) {
            err = 'filter';
          }
          if (!err) {
            this.eachCellMap(options.start, options.last, {
              exist: true
            }, function (cellMap, pos) {
              var bigCell = _this8.getBigCell(pos);
              if (bigCell.rowspan > 1 && (bigCell.pos.row < options.start.row || bigCell.posEnd.row > options.last.row)) {
                err = 'cells-part';
              }
            });
          }
          if (!err) {
            this.eachCellMap({
              row: options.index
            }, {
              row: options.index
            }, {
              exist: true
            }, function (cellMap, pos) {
              var bigCell = _this8.getBigCell(pos);
              if (_this8.getBigCell(pos).rowspan > 1 && bigCell.pos.row < options.index) {
                err = 'into-merged';
              }
            });
          }
        } else if (type === 'move-col') {
          if (!options.start.hasOwnProperty('col') || isNaN(options.index) || options.index < 0 || options.index > this.tableSize.cols) {
            err = 'position';
          }
          if (!err) {
            this.eachCellMap(options.start, options.last, {
              exist: true
            }, function (cellMap, pos) {
              var bigCell = _this8.getBigCell(pos);
              if (bigCell.colspan > 1 && (bigCell.pos.col < options.start.col || bigCell.posEnd.col > options.last.col)) {
                err = 'cells-part';
              }
            });
          }
          if (!err) {
            this.eachCellMap({
              col: options.index
            }, {
              col: options.index
            }, {
              exist: true
            }, function (cellMap, pos) {
              var bigCell = _this8.getBigCell(pos);
              if (_this8.getBigCell(pos).colspan > 1 && bigCell.pos.col < options.index) {
                err = 'into-merged';
              }
            });
          }
        }
        if (err === 'position') {
          prm = {
            error: TableMoveItemError.CANNOT_MOVE_INVALID_POSITION
          };
          if (options.alert) {
            popupManager.alert(i18n.get('table.move_row_failed.title'), i18n.get('table.move_row_failed.text'));
          }
        } else if (err === 'sortable') {
          prm = {
            error: TableMoveItemError.CANNOT_MOVE_ROW_IN_SORTABLE_TABLE
          };
          if (options.alert) {
            popupManager.alert(i18n.get('table.move_row_cant_move_in_sortable_table.title'), i18n.get('table.move_row_cant_move_in_sortable_table.text'));
          }
        } else if (err === 'cells-part') {
          prm = {
            error: TableMoveItemError.CANNOT_MOVE_MERGED_CELLS_PART
          };
          if (options.alert) {
            popupManager.alert(i18n.get('table.move_row_cant_move_part_of_merged_cells.title'), i18n.get('table.move_row_cant_move_part_of_merged_cells.text'));
          }
        } else if (err === 'into-merged') {
          prm = {
            error: TableMoveItemError.CANNOT_MOVE_INTO_MERGED_CELL
          };
          if (options.alert) {
            popupManager.alert(i18n.get('table.move_row_cant_split_merged_cells.title'), i18n.get('table.move_row_cant_split_merged_cells.text'));
          }
        } else if (err === 'filter') {
          prm = {
            error: TableMoveItemError.CANNOT_MOVE_ROW_IN_FILTERED_TABLE
          };
          if (options.alert) {
            popupManager.alert(i18n.get('table.move_row_cant_move_in_filtered_table.title'), i18n.get('table.move_row_cant_move_in_filtered_table.text'));
          }
        }
      } else if (type === 'filter-table') {
        var _colsData$col;
        var _merged3 = this.componentOnAction({
          type: 'is-merged'
        });
        var col = options.col;
        // проверяем возможна ли фильтрация колонки или таблицы,
        // если колонка не имеет типа или таблица не имеет колонок с типом, фильтровать нельзя
        var hasColOption = typeof col === 'string' && col || typeof col === 'number';
        var colsData = this.tableBodyEmbed.table.colsData;
        var allowTypedFilter = hasColOption ? ((_colsData$col = colsData[col]) === null || _colsData$col === void 0 ? void 0 : _colsData$col.columnType) && colsData[col].columnType !== 'none' : Object.keys(colsData).some(function (index) {
          var _colsData$index;
          return ((_colsData$index = colsData[index]) === null || _colsData$index === void 0 ? void 0 : _colsData$index.columnType) && colsData[index].columnType !== 'none';
        });
        if (!allowTypedFilter) {
          prm = false;
          if (options.alert) {
            if (hasColOption) {
              popupManager.alert(i18n.get('table.filter.warning.column_multitype.title'), i18n.get('table.filter.warning.column_multitype.text'));
            } else {
              popupManager.alert(i18n.get('table.filter.warning.table_not_have_typed_columns.title'), i18n.get('table.filter.warning.table_not_have_typed_columns.text'));
            }
          }
        } else if (_merged3 !== null && _merged3 !== void 0 && _merged3.cells) {
          prm = false;
          if (options.alert) {
            popupManager.alert(i18n.get('table.filter.warning.cells_merged.title'), i18n.get('table.filter.warning.cells_merged.text'));
          }
        }
      }
      return prm;
    }

    /**
      * Проверяет условия, при необходимости выводит диалог и вызывает cb
      * @param { string } type: действие
      * @param { object } options: опции
      * @param {  boolean } options.silent: выполнять cb без отображения диалога ( в основном для тестов )
      * @param { function } cb: callback функция
      */
  }, {
    key: "dialog",
    value: function dialog(type) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 ? arguments[2] : undefined;
      var popupManager = this.editor.plugins.popupManager;
      if (type === 'convert-cols') {
        var withoutDialog = options.silent || this.isRangeEmpty(options.start, options.last);
        if (withoutDialog) {
          cb();
        } else {
          popupManager.dialog((0,preact_module.h)(ColumnConvertPopup, {
            editor: this.editor,
            onAction: cb
          }));
        }
      } else if (type === 'duplicate-cols') {
        var _withoutDialog = options.skipData || options.silent || this.isRangeEmpty(options.start, options.last);
        if (_withoutDialog) {
          cb(options.skipData ? false : true);
        } else {
          popupManager.dialog((0,preact_module.h)(ColumnDuplicatePopup, {
            editor: this.editor,
            onAction: cb
          }));
        }
      } else if (type === 'merge-cells') {
        var hasComments = false;
        this.eachCellMap(options.start, options.last, {}, function (cellMap) {
          if (cellMap && cellMap.has('commentThreads')) {
            hasComments = true;
          }
        });
        if (!hasComments) {
          cb();
        } else {
          popupManager.dialog((0,preact_module.h)(MergeCellsWithCommentsPopup, {
            editor: this.editor,
            onAction: cb
          }));
        }
      }
    }

    /**
     * Проверяет, являются ли ячейки в диапазоне пустыми (без контента)
     * @param { object } start : {row, col}
     * @param { object } last  : {row, col}
     * @returns { boolean }
     */
  }, {
    key: "isRangeEmpty",
    value: function isRangeEmpty() {
      var _this9 = this;
      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var last = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var isEmpty = true;
      this.eachCellMap(start, last, {
        exist: true
      }, function (cellMap, pos) {
        if (isEmpty) {
          if (!cellMap.has('children')) {
            // Для типов ячеек без child элемента
            isEmpty = false;
          } else {
            var childMap = _this9.childMapByPos(pos, {
              cellMap: cellMap
            });
            if (childMap) {
              // Исходим из того что childMap создается только при вводе в ячейку
              isEmpty = false;
            }
          }
        }
      });
      return isEmpty;
    }

    /**
    * Установить значение для параметров строк, колонок или ячеек
    * @param { object } start: {row} координаты первой строки
    * @param { object } last?: {row} координаты последней строки
    * @param { string } key: имя свойства
    * @param { string } key?: имя свойства
    * @param { object } options?
    * @param { number } options.type=cell ?: тип map - cell, row, col
    * @param { number } options.render?: рендер после обновления
    */
  }, {
    key: "setInnerMapProp",
    value: function setInnerMapProp() {
      var _this10 = this;
      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var last = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var key = arguments.length > 2 ? arguments[2] : undefined;
      var val = arguments.length > 3 ? arguments[3] : undefined;
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      if (!start || typeof start === 'undefined') {
        start = {};
      }
      if (!last || typeof last === 'undefined') {
        last = {};
      }
      if (!last.hasOwnProperty('row') && start.hasOwnProperty('row')) {
        last.col = start.col;
      }
      if (!last.hasOwnProperty('col') && start.hasOwnProperty('col')) {
        last.col = start.col;
      }
      var isCellProp = CONFIG.cell.attrs.hasOwnProperty(key);
      var isChildProp = CONFIG.child.style.hasOwnProperty(key);
      this.store.transaction(function () {
        var styleAssign = function styleAssign(map, val) {
          var style = map.get('style') || {};
          Object.assign(style, val);
          for (var k in style) {
            if (style[k] === 'false') {
              delete style[k];
            }
          }
          if (Object.keys(style).length) {
            map.set('style', style);
          } else {
            map.delete('style');
          }
        };
        var eachCellInherit = function eachCellInherit() {
          _this10.eachCellMap(start, last, {
            exist: true
          }, function (cellMap, pos) {
            if (isCellProp) {
              if (cellMap !== null && cellMap !== void 0 && cellMap.has(key)) {
                cellMap.delete(key);
              }
            } else if (isChildProp) {
              var childMap = _this10.childMapByPos(pos, {
                cellMap: cellMap
              });
              childMap === null || childMap === void 0 ? void 0 : childMap.set(key, val);
            } else if (key === 'style') {
              _this10.childEffect('style', val, pos, cellMap);
            }
          });
        };
        if (options.type === 'row') {
          for (var row = start.row; row <= last.row; row++) {
            var rowMap = _this10.rowMapByIndex(row, {
              create: true,
              inTransaction: true
            });
            if (key === 'style') {
              styleAssign(rowMap, val);
            } else if (val !== null) {
              rowMap.set(key, val);
            } else {
              rowMap.delete(key);
            }
            eachCellInherit();
          }
        } else if (options.type === 'col') {
          for (var col = start.col; col <= last.col; col++) {
            var colMap = _this10.colMapByIndex(col, {
              create: true,
              inTransaction: true
            });
            if (key === 'style') {
              styleAssign(colMap, val);
            } else if (val !== null) {
              colMap.set(key, val);
            } else {
              colMap.delete(key);
            }
            eachCellInherit();
          }
        } else {
          // cell
          _this10.eachCellMap(start, last, {
            create: true
          }, function (cellMap, pos) {
            if (!cellMap.get('hidden')) {
              if (isCellProp) {
                cellMap.set(key, val);
              } else if (isChildProp) {
                var childMap = _this10.childMapByPos(pos, {
                  cellMap: cellMap
                });
                childMap === null || childMap === void 0 ? void 0 : childMap.set(key, val);
              } else if (key === 'style') {
                _this10.childEffect('style', val, pos, cellMap);
              }
            }
          });
        }
        // Для миграции V1 -> V2, позже можно удалить
        _this10.ensureNewRowType(start.row || 0);
      });
      if (options.render) {
        var mode = 'rows';
        if (options.type === 'col') {
          if (isCellProp || isChildProp || key === 'style') {
            mode = 'cols_cells';
          } else {
            mode = 'cols';
          }
        }
        this.tableBodyEmbed.mapToObject({
          mode: mode,
          start: start,
          last: last,
          fastRender: true,
          withAllCells: CONFIG.col.updateCells.includes(key),
          withSummary: options.type === 'col' && key === 'summary'
        });
      }
    }

    /**
    * Возвращает сортируемую колонку
    * @returns false | {index, columnId, order}
    */
  }, {
    key: "sortableColumn",
    get: function get() {
      if (this.map.has('sortableColumn')) {
        var sortable = this.map.get('sortableColumn');
        var index = this.cols.toArray().indexOf(sortable.columnId);
        return table_objectSpread({
          index: index
        }, sortable);
      }
      return false;
    }
  }, {
    key: "rowsOrder",
    get: function get() {
      return this.map.get('rowsOrder');
    }

    /**
    * Включить сортировку колонок
    * @param { object } pos: {col} координаты колонки
    * @param { object } options?
    * @param { string } options.order?: режим сортировки asc, desc
    * @param { number } options.render?: рендер после обновления
    */
  }, {
    key: "setSortableColumn",
    value: function setSortableColumn(pos) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$order = options.order,
        order = _options$order === void 0 ? 'asc' : _options$order;
      var permission = this.permission('sort-column', {
        alert: true
      });
      if (permission) {
        this.exitSortableColumn();
        var colMap = this.colMapByIndex(pos.col, {
          create: true
        });
        colMap.set('sortby', order);
        this.map.set('sortableColumn', {
          columnId: colMap.get('id'),
          order: order
        });
        if (!this.map.has('rowsOrder')) {
          this.map.set('rowsOrder', this.rows.toArray());
        }
        this.renewSortOrder();
        if (options.render) {
          this.tableBodyEmbed.mapToObject({
            render: true,
            mode: 'full'
          });
        }
      }
    }
  }, {
    key: "hasFilter",
    value: function hasFilter() {
      return this.map.has('filter') && this.map.get('filter') !== null && this.map.get('filter').filters.length > 0;
    }
  }, {
    key: "renderWithFilter",
    value: function renderWithFilter() {
      return this.hasFilter() && !Boolean(this.map.get('filter-disabled'));
    }
  }, {
    key: "setTableFilter",
    value: function setTableFilter(params) {
      var permission = !params.filter || params.filter === null || this.permission('filter-table', {
        alert: true
      });
      if (permission) {
        this.map.set('filter', params.filter);
        this.tableBodyEmbed.mapToObject({
          render: true,
          mode: 'full'
        });
      }
    }
  }, {
    key: "openTableFilter",
    value: function openTableFilter() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var permission = this.permission('filter-table', {
        col: params.col,
        alert: true
      });
      return permission;
    }

    /**
    * Диалог, сохранить ли порядок строк при отключении сортировки
    * @param { object } options?: передается в exitSortableColumn
    */
  }, {
    key: "exitColumnSortingDialog",
    value: function exitColumnSortingDialog() {
      var _this11 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var popupManager = this.editor.plugins.popupManager;
      var confirm = (0,preact_module.h)(ColumnExitSortingPopup, {
        editor: this.editor,
        onAction: function onAction(keepOrder) {
          _this11.exitSortableColumn(table_objectSpread({
            keepOrder: keepOrder
          }, options));
        }
      });
      popupManager.dialog(confirm);
    }

    /**
    * Отключает режим сортировки колонки, если он включен
    * @param { object } options?
    * @param { boolean } options.keepOrder?: сохранить отсортированный порядок строк
    * @param { number } options.render?: рендер после обновления
    */
  }, {
    key: "exitSortableColumn",
    value: function exitSortableColumn() {
      var _this12 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (this.sortableColumn) {
        this.eachColMap(false, false, {
          create: false
        }, function (colMap) {
          if (colMap !== null && colMap !== void 0 && colMap.has('sortby')) {
            colMap.delete('sortby');
          }
        });
        this.store.transaction(function () {
          if (!options.keepOrder) {
            // Восстанавливаем порядок строк до сортировки
            var rowsOrder = _this12.rowsOrder;
            if (rowsOrder) {
              _this12.setRowsOrder(rowsOrder);
            }
          }
          _this12.map.delete('sortableColumn');
          _this12.map.delete('rowsOrder');
        });
        if (options.render) {
          this.tableBodyEmbed.mapToObject({
            render: true,
            mode: 'full'
          });
        }
      }
      return true;
    }

    /**
     * Функия для сортировки строк по значению и типу ячеек
     */
  }, {
    key: "renewSortOrder",
    value: /**
            * Обновить порядок сортировки строк
            * @param { object } options?
            * @param { object } options.animate?: анимировать перемещение строки {row}
            * @param { number } options.render?: рендер после обновления
            * @param { object } options.inRange?: обновить, если сортируемая колонка находится в диапазоне
            * @param { object } options.inRange.start: {col}
            * @param { object } options.inRange.last?: {col}
            */function () {
      var _renewSortOrder = table_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this13 = this;
        var options,
          sortable,
          _options$inRange,
          _options$inRange$star,
          start,
          _options$inRange$last,
          last,
          filledRows,
          col,
          colMap,
          columnType,
          rows,
          filledRowsIds,
          emptyRowsIds,
          newOrder,
          diff,
          k,
          rowId,
          newRow,
          _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
                sortable = this.sortableColumn;
                if (!(!sortable || sortable.index < 0)) {
                  _context2.next = 4;
                  break;
                }
                return _context2.abrupt("return");
              case 4:
                if (!options.inRange) {
                  _context2.next = 9;
                  break;
                }
                _options$inRange = options.inRange, _options$inRange$star = _options$inRange.start, start = _options$inRange$star === void 0 ? {} : _options$inRange$star, _options$inRange$last = _options$inRange.last, last = _options$inRange$last === void 0 ? {} : _options$inRange$last;
                if (!last.hasOwnProperty('col')) {
                  last.col = start.col;
                }
                if (!(sortable.index < start.col || sortable.index > last.col)) {
                  _context2.next = 9;
                  break;
                }
                return _context2.abrupt("return");
              case 9:
                filledRows = [];
                col = sortable.index;
                colMap = this.colMapByIndex(col);
                columnType = colMap.get('columnType');
                this.eachCellMap({
                  col: col
                }, {
                  col: col
                }, {
                  create: false
                }, function (cellMap, _ref7, _ref8) {
                  var row = _ref7.row,
                    col = _ref7.col;
                  var rowMap = _ref8.rowMap;
                  if (cellMap) {
                    var childMap = cellMap && _this13.childMapByPos({
                      row: row,
                      col: col
                    }, {
                      cellMap: cellMap
                    });
                    var compare = comparisonValue(cellMap, childMap, {
                      colMap: colMap,
                      cellType: columnType
                    });
                    if (compare.value !== null) {
                      filledRows.push(Object.assign(compare, {
                        row: row
                      }));
                    }
                  }
                });
                filledRows.sort(this.compareCellsByValue.bind(undefined, sortable.order));
                if (sortable.order === 'desc') {
                  filledRows.reverse();
                }
                rows = this.rows.toArray();
                filledRowsIds = filledRows.reduce(function (result, item) {
                  result.push(rows[item.row]);
                  return result;
                }, []);
                emptyRowsIds = rows.reduce(function (result, rowId) {
                  if (!filledRowsIds.includes(rowId)) {
                    result.push(rowId);
                  }
                  return result;
                }, []);
                newOrder = [].concat(table_table_toConsumableArray(filledRowsIds), table_table_toConsumableArray(emptyRowsIds));
                diff = false;
                _context2.t0 = regeneratorRuntime.keys(newOrder);
              case 22:
                if ((_context2.t1 = _context2.t0()).done) {
                  _context2.next = 29;
                  break;
                }
                k = _context2.t1.value;
                if (!(newOrder[k] !== rows[k])) {
                  _context2.next = 27;
                  break;
                }
                diff = true;
                return _context2.abrupt("break", 29);
              case 27:
                _context2.next = 22;
                break;
              case 29:
                if (!diff) {
                  _context2.next = 38;
                  break;
                }
                this.setRowsOrder(newOrder);
                if (!options.animate) {
                  _context2.next = 37;
                  break;
                }
                rowId = rows[options.animate.row];
                newRow = newOrder.indexOf(rowId);
                if (newRow !== -1) {
                  this.componentOnAction({
                    type: 'animate-row-sorting',
                    from: options.animate.row,
                    to: newRow
                  });
                }
                // Таймаут на проигрываение анимации
                _context2.next = 37;
                return timeout(CONFIG.row.transition);
              case 37:
                if (options.render) {
                  this.tableBodyEmbed.mapToObject({
                    render: true,
                    mode: 'full'
                  });
                }
              case 38:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function renewSortOrder() {
        return _renewSortOrder.apply(this, arguments);
      }
      return renewSortOrder;
    }()
  }, {
    key: "setRowsOrder",
    value: function setRowsOrder(newOrder) {
      var _this14 = this;
      var oldOrder = this.rows.toArray();
      this.store.transaction(function () {
        var newRowsArray = new _this14.store.types.Array();
        for (var oldIndex in oldOrder) {
          var oldRowId = oldOrder[oldIndex];
          if (oldRowId) {
            if (newOrder.indexOf(oldRowId) === -1) {
              var indexOfFalse = newOrder.indexOf(false);
              if (indexOfFalse !== -1) {
                newOrder.splice(indexOfFalse, 1, oldRowId);
              } else {
                newOrder.push(oldRowId);
              }
            }
          }
        }
        for (var newIndex in newOrder) {
          var rowId = newOrder[newIndex];
          newRowsArray.insert(newIndex, [rowId]);
        }
        _this14.map.set('rows', newRowsArray);
      });
    }

    /**
    * Очистить содержимое всех ячеек
    */
  }, {
    key: "clearAllCells",
    value: function clearAllCells() {
      this.clearCells({
        row: 0,
        col: 0
      }, {
        row: this.rowLast,
        col: this.colLast
      }, {
        render: true
      });
    }

    /**
     * Очистить выделенные ячейки
     */
  }, {
    key: "clearSelectedCells",
    value: function clearSelectedCells() {
      var selection = this.componentOnAction({
        type: 'selection'
      });
      if (selection && selection.start && selection.last) {
        this.clearCells(selection.start, selection.last, {
          render: true
        });
      }
    }

    /**
    * Очистить содержимое ячеек
    * @param { object } start: {row, col} координаты первой ячейки
    * @param { object } last?: {row, col} координаты последней ячейки
    * @param { object } options?
    * @param { number } options.render?: рендер после обновления
    */
  }, {
    key: "clearCells",
    value: function clearCells(start) {
      var _this15 = this;
      var last = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!last.hasOwnProperty('row') && start.hasOwnProperty('row')) {
        last.row = start.row;
      }
      if (!last.hasOwnProperty('col') && start.hasOwnProperty('col')) {
        last.col = start.col;
      }
      this.store.transaction(function () {
        _this15.eachCellMap(start, last, {
          create: false
        }, function (cellMap, _ref9) {
          var row = _ref9.row,
            col = _ref9.col;
          _this15.clearCellMap(cellMap);
        });
      });
      if (options.render) {
        this.tableBodyEmbed.mapToObject({
          mode: 'rows',
          fastRender: true,
          start: start,
          last: last
        });
        var animate = start.row === last.row ? {
          row: start.row
        } : false;
        this.renewSortOrder({
          animate: animate,
          render: true,
          inRange: {
            start: start,
            last: last
          }
        });
      }
    }

    /**
     * Очищает map ячейки для всех типов
     * @param {Ymap} cellMap
     */
  }, {
    key: "clearCellMap",
    value: function clearCellMap(cellMap) {
      if (cellMap) {
        var _iterator = table_table_createForOfIteratorHelper(CONFIG.cell.clear),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var key = _step.value;
            if (cellMap.has(key)) {
              cellMap.delete(key);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var childMap = this.childMapByPos({}, {
          cellMap: cellMap
        });
        if (childMap) {
          if (childMap.has('characters')) {
            var currentDelta = new (Delta_default())(childMap.get('characters').toDelta());
            var emptyDelta = new (Delta_default())([{
              insert: "\n"
            }]);
            var clearDelta = currentDelta.diff(emptyDelta);
            childMap.get('characters').applyDelta(clearDelta.ops);
          }
        }
      }
    }

    /**
    * Удалить строки
    * @param { object } start: {row} координаты первой строки
    * @param { object } last?: {row} координаты последней строки
    * @param { object } options?
    * @param { number } options.render?: рендер после обновления
    */
  }, {
    key: "deleteRows",
    value: function deleteRows() {
      var _this16 = this;
      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var last = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!last.row) {
        last.row = start.row;
      }
      this.store.transaction(function () {
        // Разделяем мердженные ячейки, начало которых в выделении
        _this16.divideCells({
          row: start.row
        }, {
          row: last.row
        }, {});

        // Уменьшаем мердженные ячейки, которые захватывает выделение
        var bigCells = {};
        _this16.eachCellMap({
          row: start.row
        }, {
          row: last.row
        }, {
          exist: true
        }, function (cellMap, _ref10) {
          var row = _ref10.row,
            col = _ref10.col;
          _this16.removeCellReminders(cellMap);
          if (cellMap.get('hidden')) {
            var bigCell = _this16.getBigCell({
              row: row,
              col: col
            });
            var key = Object.entries(bigCell.pos).toString();
            if (!bigCells[key]) {
              bigCells[key] = table_objectSpread(table_objectSpread({}, bigCell), {}, {
                decrease: [row]
              });
            } else if (!bigCells[key].decrease.includes(row)) {
              bigCells[key].decrease.push(row);
            }
          }
        });
        for (var key in bigCells) {
          var bigCell = bigCells[key];
          var rowspan = bigCell.map.get('rowspan') - bigCell.decrease.length || 1;
          bigCell.map.set('rowspan', rowspan);
        }
        var rows = _this16.rows;
        for (var row = last.row; row >= start.row; row--) {
          var rowId = rows.get(row);
          if (rowId) {
            var rowMap = _this16.store.getMap(rowId);
            var cellIds = rowMap === null || rowMap === void 0 ? void 0 : rowMap.get('children');
            if (cellIds) {
              cellIds.forEach(function (cellId) {
                _this16.deleteCellMapById(cellId);
              });
            }
            _this16.deleteMapById(rowId);
          }
          if (typeof rowId !== 'undefined') {
            rows.delete(row);
            var rowsOrder = _this16.rowsOrder;
            if (rowsOrder) {
              for (var i in rowsOrder) {
                if (rowsOrder[i] === rowId) {
                  rowsOrder.splice(i, 1);
                  _this16.map.set('rowsOrder', rowsOrder);
                  break;
                }
              }
            }
          }
        }
        _this16.changeSize({
          rows: start.row - last.row - 1
        });
      });
      if (options.render) {
        this.tableBodyEmbed.mapToObject({
          render: true,
          mode: 'full'
        });
      }
    }

    /**
    * Удалить колонки
    * @param { object } start: {col} координаты первой строки
    * @param { object } last?: {col} координаты последней строки
    * @param { object } options?
    * @param { number } options.render?: рендер после обновления
    */
  }, {
    key: "deleteCols",
    value: function deleteCols() {
      var _this17 = this;
      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var last = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!last.col) {
        last.col = start.col;
      }
      this.store.transaction(function () {
        // Разделяем мердженные ячейки, начало которых в выделении
        _this17.divideCells({
          col: start.col
        }, {
          col: last.col
        }, {});

        // Уменьшаем мердженные ячейки, которые захватывает выделение
        var bigCells = {};
        _this17.eachCellMap({
          col: start.col
        }, {
          col: last.col
        }, {
          exist: true
        }, function (cellMap, _ref11) {
          var row = _ref11.row,
            col = _ref11.col;
          _this17.removeCellReminders(cellMap);
          if (cellMap.get('hidden')) {
            var bigCell = _this17.getBigCell({
              row: row,
              col: col
            });
            var key = Object.entries(bigCell.pos).toString();
            if (!bigCells[key]) {
              bigCells[key] = table_objectSpread(table_objectSpread({}, bigCell), {}, {
                decrease: [col]
              });
            } else if (!bigCells[key].decrease.includes(col)) {
              bigCells[key].decrease.push(col);
            }
          }
        });
        for (var key in bigCells) {
          var bigCell = bigCells[key];
          var colspan = bigCell.map.get('colspan') - bigCell.decrease.length || 1;
          bigCell.map.set('colspan', colspan);
        }
        var rows = _this17.rows;
        var cols = _this17.cols;
        rows.forEach(function (rowId, row) {
          var rowMap = _this17.rowMapByIndex(row);
          var cellIds = rowMap === null || rowMap === void 0 ? void 0 : rowMap.get('children');
          if (cellIds) {
            for (var col = last.col; col >= start.col; col--) {
              if (cellIds.length > col) {
                _this17.deleteCellMapById(cellIds[col]);
                cellIds.delete(col);
              }
            }
          }
        });
        var tableFilter = _this17.map.get('filter');
        var _loop2 = function _loop2(col) {
          var colId = cols.get(col);
          // удаляем фильтры по данной колонке
          if (tableFilter && tableFilter.filters) {
            tableFilter.filters = tableFilter.filters.filter(function (filter) {
              return filter.colId !== colId;
            });
          }
          if (cols.length > col) {
            _this17.deleteMapById(cols[col]);
            cols.delete(col);
          }
        };
        for (var col = last.col; col >= start.col; col--) {
          _loop2(col);
        }
        if (tableFilter) {
          if (tableFilter.filters && !tableFilter.filters.length) {
            _this17.map.delete('filter');
          } else {
            _this17.map.set('filter', tableFilter);
          }
        }
        _this17.changeSize({
          cols: start.col - last.col - 1
        });
      });
      if (options.render) {
        this.tableBodyEmbed.mapToObject({
          render: true,
          mode: 'full'
        });
      }
    }

    /**
     * Удаляет ремайндеры из ячейки таблицы
     * @param {*} cellMap
     */
  }, {
    key: "removeCellReminders",
    value: function removeCellReminders(cellMap) {
      var _this18 = this;
      var reminderManager = this.editor.plugins.reminderManager;
      var type = cellMap === null || cellMap === void 0 ? void 0 : cellMap.get('type');
      if (type === 'tableCellDate') {
        reminderManager.deleteReminder(cellMap.get('id'), cellMap.toJSON());
      }
      if (type === 'tableCellMention') {
        var _cellMap$toJSON = cellMap.toJSON(),
          mentionChildren = _cellMap$toJSON.children;
        mentionChildren.forEach(function (mentionBlotId) {
          var _this18$editor$store$, _this18$editor$store$2;
          var delta = ((_this18$editor$store$ = _this18.editor.store.blocks) === null || _this18$editor$store$ === void 0 ? void 0 : (_this18$editor$store$2 = _this18$editor$store$.get(mentionBlotId).get('characters')) === null || _this18$editor$store$2 === void 0 ? void 0 : _this18$editor$store$2.toDelta()) || [];
          delta.forEach(function (_ref12) {
            var insert = _ref12.insert;
            if (insert !== null && insert !== void 0 && insert.date && insert.date.reminders) {
              reminderManager.deleteReminder(insert.date.dateId, insert.date);
            }
          });
        });
      }
    }

    /**
    * Удаляет map ячейки и ее содержимое по id
    * @param { string } mapId
    */
  }, {
    key: "deleteCellMapById",
    value: function deleteCellMapById(mapId) {
      var _this19 = this;
      if (mapId) {
        var map = this.store.getMap(mapId);
        var childrenIds = map === null || map === void 0 ? void 0 : map.get('children');
        if (childrenIds) {
          childrenIds.forEach(function (childId) {
            _this19.deleteMapById(childId);
          });
        }
        this.deleteMapById(mapId);
      }
      return true;
    }

    /**
    * Удалить map по id
    * @param { string } mapId
    */
  }, {
    key: "deleteMapById",
    value: function deleteMapById(mapId) {
      // В таблице V1 при ее удалении map'ы остаются в store.blocks
      return;
      if (mapId && this.store.blocks.has(mapId)) {
        this.store.blocks.delete(mapId);
      }
    }

    /**
    * Объединить ячейки
    * Если координаты не переданы, то запрашивает текущее выделение
    * @param { object } start: {col, row} координаты первой ячейки
    * @param { object } end: {col, row} координаты последней ячейки
    * @param { object } options?
    * @param { number } options.render?: рендер после обновления
    */
  }, {
    key: "mergeCells",
    value: function mergeCells(start, end) {
      var _this20 = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!start && !end) {
        var selection = this.getSelection;
        start = selection.start;
        end = selection.end;
        if (!start || !end) {
          console.warn("Can't merge cells, range:", start, end);
          return false;
        }
      }
      var exec = function exec() {
        _this20.store.transaction(function () {
          var toMergeDeltas = [];
          var _this20$divideCells = _this20.divideCells(start, end),
            last = _this20$divideCells.last;
          _this20.eachCellMap(start, last, {
            create: true
          }, function (cellMap, _ref13) {
            var row = _ref13.row,
              col = _ref13.col;
            if (row > start.row || col > start.col) {
              var type = _this20.getCellType({
                row: row,
                col: col
              });
              if (!type || type === 'text') {
                var childMap = _this20.childMapByPos({
                  row: row,
                  col: col
                }, {
                  cellMap: cellMap
                });
                if (childMap) {
                  var characters = childMap.get('characters');
                  // Проверяем наличие текста и его длину больше 1 (больше '\n')
                  if (characters && characters.length > 1) {
                    toMergeDeltas.push(characters.toDelta());
                  }
                }
                _this20.clearCellMap(cellMap);
              }
              cellMap.set('hidden', true);
              cellMap.delete('rowspan');
              cellMap.delete('colspan');
            }
          });
          // Действия с основной ячейкой
          var cellMap = _this20.cellMapByPos(start);
          cellMap.set('rowspan', Math.max(1, 1 + last.row - start.row));
          cellMap.set('colspan', Math.max(1, 1 + last.col - start.col));
          cellMap.delete('hidden');
          cellMap.delete('mergedCol');
          // Объединяем текст ячеек
          toMergeDeltas.map(function (delta) {
            _this20.mergeDelta(start, delta);
          });

          // Для миграции V1 -> V2, позже можно удалить
          _this20.ensureNewRowType(start.row || 0);
        });
        if (options.render) {
          _this20.tableBodyEmbed.mapToObject({
            render: true,
            mode: 'full'
          });
        }
      };
      var permission = this.permission('merge-cells', {
        alert: true
      });
      if (permission) {
        if (options.dialog && this.editor.plugins.commentManager.options.tableCellComments) {
          this.dialog('merge-cells', {
            start: start,
            last: end
          }, exec);
        } else {
          exec();
        }
      }
      return permission;
    }

    /**
     * Добавляет дельту к текущей дельте текстовой ячейки, текст соединяется через пробел
     * @param { object } pos: {row, col}
     * @param { array } delta: ops
     */
  }, {
    key: "mergeDelta",
    value: function mergeDelta() {
      var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var delta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var cellMap = this.cellMapByPos(pos, {
        create: true
      });
      var type = cellMap.get('cellType');
      if (!type || type === 'text') {
        var childMap = this.childMapByPos(pos, {
          create: true,
          cellMap: cellMap
        });
        var characters = childMap.get('characters');
        var newLine = characters.toString().endsWith('\n');
        var deltaToApply = [{
          retain: characters.length - (newLine ? 1 : 0)
        }];
        if (newLine) {
          deltaToApply.push({
            delete: 1
          });
        }
        if (characters.length > (newLine ? 1 : 0)) {
          deltaToApply.push({
            insert: ' '
          });
        }
        deltaToApply.push.apply(deltaToApply, table_table_toConsumableArray(delta));
        characters.applyDelta(deltaToApply);
      }
    }

    /**
     * Возвращает координаты смердженной области
     * @param {object} start: {col, row}
     * @param {object} end?: {col, row}
     * @returns {object} {start, last}
     */
  }, {
    key: "getMergedArea",
    value: function getMergedArea() {
      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var last = Object.assign({}, end);
      this.eachCellMap(start, end, {
        create: false
      }, function (cellMap, _ref14) {
        var row = _ref14.row,
          col = _ref14.col;
        if (cellMap) {
          last.row = Math.max(last.row, row - 1 + (cellMap.get('rowspan') || 1));
          last.col = Math.max(last.col, col - 1 + (cellMap.get('colspan') || 1));
        }
      });
      return {
        start: start,
        last: last
      };
    }

    /**
     * Находит и разделяет все большие ячейки в переданной области
     * @param { object } start: {col?, row?}
     * @param { object } end?: {col?, row?}
     * @param { object } options?
     * @param { number } options.render?: рендер после обновления
     */
  }, {
    key: "divideCells",
    value: function divideCells() {
      var _this21 = this;
      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!end) {
        end = table_objectSpread({}, start);
      }
      start = this.fullPos(start, 'min');
      end = this.fullPos(end, 'max');
      var _this$getMergedArea = this.getMergedArea(start, end),
        last = _this$getMergedArea.last;
      var keys = ['rowspan', 'colspan', 'hidden', 'mergedCol'];
      this.store.transaction(function () {
        _this21.eachCellMap(start, end, {
          exist: true
        }, function (bigCellMap, bigPos) {
          var rowspan = bigCellMap.get('rowspan') || 1;
          var colspan = bigCellMap.get('colspan') || 1;
          if (rowspan > 1 || colspan > 1) {
            _this21.eachCellMap({
              row: bigPos.row,
              col: bigPos.col
            }, {
              row: bigPos.row + rowspan - 1,
              col: bigPos.col + colspan - 1
            }, {
              exist: true
            }, function (cellMap, pos) {
              var _iterator2 = table_table_createForOfIteratorHelper(keys),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var _key2 = _step2.value;
                  cellMap.delete(_key2);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              if (pos.row > bigPos.row || pos.col > bigPos.col) {
                var _iterator3 = table_table_createForOfIteratorHelper(CONFIG.cell.divide),
                  _step3;
                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var key = _step3.value;
                    if (bigCellMap.has(key)) {
                      cellMap.set(key, bigCellMap.get(key));
                    }
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
              }
            });
          }
        });
      });
      if (options.render) {
        this.tableBodyEmbed.mapToObject({
          render: true,
          mode: 'full'
        });
      }
      return {
        start: start,
        last: last
      };
    }

    /**
    * Возвращает размер таблицы
    * @returns { object } {cols, rows}
    */
  }, {
    key: "tableSize",
    get: function get() {
      var size = {
        rows: 1,
        cols: 1
      };
      if (this.map.has('size')) {
        Object.assign(size, this.map.get('size'));
      } else {
        // Table V1
        size.rows = this.rows.length;
        size.cols = this.cols.length;
      }
      return size;
    }

    /**
     * Конвертация колонок в новый формат
     * @param { object } start: {col} стартовая позиция
     * @param { object } last: {col} конечная позиция
     * @param { string } type: новый тип колонки
     * @param { object } options?
     * @param { number } options.dialog?: показывать диалог о возможной потере данных
     * @param { number } options.render?: рендер после обновления
     */
  }, {
    key: "convertColumn",
    value: function convertColumn() {
      var _this22 = this;
      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var last = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var type = arguments.length > 2 ? arguments[2] : undefined;
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (!start.hasOwnProperty('row')) {
        start.row = 0;
      }
      if (!last.hasOwnProperty('col')) {
        last.col = start.col;
      }
      if (!last.hasOwnProperty('row')) {
        last.row = this.rowLast;
      }
      var allCellsIsEmpty = true;
      this.eachCellMap(start, last, {
        create: false
      }, function (cellMap, pos) {
        if (cellMap) {
          var _type = cellMap.get('cellType');
          var childMap = _this22.childMapByPos(pos, {
            cellMap: cellMap
          });
          if (_type === 'attachment') {
            var attachments = cellMap.get('attachments');
            if (attachments && attachments.length) {
              allCellsIsEmpty = false;
            }
          } else if (_type === 'checkbox') {
            allCellsIsEmpty = false;
          } else if (_type === 'multiselect' || _type === 'singleselect') {
            if (cellMap.get('selected').length) {
              allCellsIsEmpty = false;
            }
          } else if (_type === 'mention') {
            var delta = childMap.get('characters').toDelta();
            if (delta.length && table_table_typeof(delta[0].insert) === 'object') {
              allCellsIsEmpty = false;
            }
          } else if (_type === 'collaborator') {
            if (Object.keys(cellMap.get('users')).length) {
              allCellsIsEmpty = false;
            }
          } else if (_type === 'date') {
            if (cellMap.get('timestamp')) {
              allCellsIsEmpty = false;
            }
          } else if (_type === 'rating') {
            if (!isNaN(cellMap.get('rating'))) {
              allCellsIsEmpty = false;
            }
          } else if (_type === 'progress') {
            if (!isNaN(cellMap.get('progress'))) {
              allCellsIsEmpty = false;
            }
          } else if (childMap) {
            var _childMap$get2, _childMap$get2$toStri;
            if (childMap !== null && childMap !== void 0 && (_childMap$get2 = childMap.get('characters')) !== null && _childMap$get2 !== void 0 && (_childMap$get2$toStri = _childMap$get2.toString()) !== null && _childMap$get2$toStri !== void 0 && _childMap$get2$toStri.trim()) {
              allCellsIsEmpty = false;
            }
          }
        }
      });
      var toTypeNone = type === 'none';
      var colType = type === 'reset' ? 'none' : type;
      var cellType = type === 'reset' ? 'text' : type;
      var exec = function exec() {
        var typeData = getTypeData(colType);
        var tableFilter = _this22.map.get('filter');
        _this22.eachColMap(start, last, {
          create: true
        }, function (colMap, col) {
          colMap.delete('format');
          // удаляем фильтры по данной колонке
          var colId = colMap.get('id');
          if (tableFilter && tableFilter.filters) {
            tableFilter.filters = tableFilter.filters.filter(function (filter) {
              return filter.colId !== colId;
            });
          }
          colMap.set('columnType', colType);
          if (colMap.has('summary')) {
            var summary = colMap.get('summary');
            if (!summary.mode || !typeData[summary.mode]) {
              colMap.delete('summary');
            }
          }
          if (colMap.has('width')) {
            var width = colMap.get('width');
            if (typeData.minColumnWidth && width < typeData.minColumnWidth) {
              colMap.set('width', typeData.minColumnWidth);
            }
          }
        });
        if (tableFilter && tableFilter.filters && tableFilter.filters.length) {
          _this22.map.set('filter', tableFilter);
        } else {
          _this22.map.delete('filter');
        }
        if (!toTypeNone) {
          _this22.convertCells(start, last, cellType, {
            column: true,
            render: !!options.render
          });
        } else {
          if (options.render) {
            _this22.tableBodyEmbed.mapToObject({
              render: true,
              mode: 'full'
            });
          }
        }
      };
      var permission = toTypeNone || this.permission('convert', {
        alert: true
      });
      if (permission) {
        if (options.dialog && !toTypeNone && !allCellsIsEmpty) {
          this.dialog('convert-cols', {
            start: start,
            last: last
          }, exec);
        } else {
          exec();
        }
      }
    }

    /**
     * Конвертация ячеек в новый формат
     * @param { object } start: {col, row} стартовая позиция
     * @param { object } last: {col, row} конечная позиция
     * @param { string } type: новый тип ячейки
     * @param { object } options?
     * @param { boolean } options.column?: если колонка конвертирована целиком, то можно не создавать map, для общего типа это обязательно
     * @param { boolean } options.render?: рендер после обновления
     */
  }, {
    key: "convertCells",
    value: function convertCells() {
      var _this23 = this;
      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var last = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var type = arguments.length > 2 ? arguments[2] : undefined;
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (!last) {
        last = table_objectSpread({}, start);
      }
      var typeData = getTypeData(type);
      var createForce = !options.column || typeData.createForce;
      this.store.transaction(function () {
        // Убеждаемся, что строки созданы, если map ячейки создается принудительно
        if (createForce) {
          _this23.eachRowMap(start, last, {
            create: true
          });
        }
        _this23.eachCellMap(start, last, {
          create: false
        }, function (cellMap, _ref15, _ref16) {
          var row = _ref15.row,
            col = _ref15.col;
          var rowMap = _ref16.rowMap;
          if (createForce || cellMap) {
            var cellParams = _this23.getCellCloneParams({
              row: row,
              col: col
            }, cellMap);
            var toMergeProps = {
              cellType: type
            };
            if (cellMap && cellMap.has('commentThreads')) {
              toMergeProps['commentThreads'] = cellMap.get('commentThreads');
            }
            var props = Object.assign({}, cellParams, toMergeProps);
            var newMapOrFalse = initInnerMap(_this23.store, 'cell', props, {
              initChild: true,
              onlyIfNecessary: !createForce,
              comments: true
            });
            _this23.mapArraySet(rowMap.get('children'), col, [newMapOrFalse ? newMapOrFalse.get('id') : false]);
          }
        });
        // Для миграции V1 -> V2, позже можно удалить
        _this23.ensureNewRowType(start.row || 0);
      });
      if (options.render) {
        this.tableBodyEmbed.mapToObject({
          render: true,
          mode: 'full'
        });
      }
    }

    /**
     * Установка свойств формата колонок, для типов поддерживущих форматирование
     * Если value = null или соответствует дефолтному, то оно будет удалено из map.format
     * @param { object } start: начальная позиция {col, row}
     * @param { object } last: конечная позиция {col, row}
     * @param { string } type: тип колонки
     * @param { string } prop: свойство форматирования
     * @param { any } value: значение свойства
     * @param { object } options?
     * @param { boolean } options.render?: вызывает рендер колонок после установки свойства
     */
  }, {
    key: "formatColumn",
    value: function formatColumn() {
      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var last = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var type = arguments.length > 2 ? arguments[2] : undefined;
      var prop = arguments.length > 3 ? arguments[3] : undefined;
      var value = arguments.length > 4 ? arguments[4] : undefined;
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      if (!last.col) {
        last.col = start.col;
      }
      var typeData = getTypeData(type);
      if (typeData.format[prop] === value) {
        value = null;
      }
      this.eachColMap(start, last, {
        create: false
      }, function (colMap, col) {
        if (colMap) {
          var format = Object.assign({}, colMap.get('format') || {});
          if (value !== null) {
            format[prop] = value;
          } else if (format.hasOwnProperty(prop)) {
            delete format[prop];
          }
          if (Object.keys(format).length) {
            colMap.set('format', format);
          } else {
            colMap.delete('format');
          }
        }
      });
      this.formatCells(start, last, type, prop, value, table_objectSpread(table_objectSpread({}, options), {}, {
        clear: true
      }));
    }

    /**
     * Установка свойств формата ячеек, для типов поддерживущих форматирование
     * Если value = null, то оно будет удалено из map.format
     * @param { object } start: начальная позиция {col, row}
     * @param { object } last: конечная позиция {col, row}
     * @param { string } type: тип колонки
     * @param { string } prop: свойство форматирования
     * @param { any } value: значение свойства
     * @param { object } options?
     * @param { boolean } options.clear?: удаляет свойство из map ячейки
     * @param { boolean } options.render?: вызывает рендер ячеек после установки свойства
     */
  }, {
    key: "formatCells",
    value: function formatCells() {
      var _this24 = this;
      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var last = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var type = arguments.length > 2 ? arguments[2] : undefined;
      var prop = arguments.length > 3 ? arguments[3] : undefined;
      var value = arguments.length > 4 ? arguments[4] : undefined;
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      if (!last.hasOwnProperty('row') && start.hasOwnProperty('row')) {
        last.row = start.row;
      }
      if (!last.hasOwnProperty('col') && start.hasOwnProperty('col')) {
        last.col = start.col;
      }
      this.eachCellMap(start, last, {
        create: value !== null
      }, function (cellMap, _ref17) {
        var row = _ref17.row,
          col = _ref17.col;
        if (cellMap) {
          var format = Object.assign({}, cellMap.get('format') || {});
          if (value !== null && !options.clear) {
            format[prop] = value;
          } else if (format.hasOwnProperty(prop)) {
            delete format[prop];
          }
          if (Object.keys(format).length) {
            cellMap.set('format', format);
          } else {
            cellMap.delete('format');
          }
          _this24.childEffect(prop, value, {
            row: row,
            col: col
          }, cellMap);
        }
      });
      if (options.render) {
        this.tableBodyEmbed.mapToObject({
          mode: 'cols_cells',
          start: start,
          last: last,
          fastRender: true
        });
      }
    }

    /**
     * Выполнение действий над child элементом при форматировании, стилизации и т.д.
     * @param { string } prop: свойство форматирования
     * @param { any } value: значение свойства
     * @param { object } pos: позиция ячейки
     * @param { ymap } cellMap: map ячейки
     * @returns { boolean }
     */
  }, {
    key: "childEffect",
    value: function childEffect(prop, value, pos, cellMap) {
      var processed = false;
      if (cellMap) {
        var childMap = this.childMapByPos(pos, {
          cellMap: cellMap
        });
        if (childMap) {
          if (prop === 'decimal_separator') {
            processed = true;
            var characters = childMap.get('characters');
            if (characters) {
              var insert;
              var chars = characters.toString();
              if (value === 'comma') {
                if (chars.indexOf('.')) {
                  insert = chars.replace('.', ',');
                }
              } else {
                if (chars.indexOf(',') !== -1) {
                  insert = chars.replace(',', '.');
                }
              }
              if (insert) {
                characters.applyDelta([{
                  delete: characters.length - 1
                }, {
                  insert: insert
                }]);
              }
            }
          } else if (prop === 'style') {
            var _characters = childMap.get('characters');
            if (_characters) {
              var _diff$ops;
              var diff = applyFormatToDelta(_characters.toDelta(), value, {
                diff: true
              });
              if ((_diff$ops = diff.ops) !== null && _diff$ops !== void 0 && _diff$ops.length) {
                _characters.applyDelta(diff.ops);
                processed = true;
              }
            }
          }
        }
      }
      return processed;
    }
  }, {
    key: "moveRow",
    value: function moveRow() {
      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var last = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var index = arguments.length > 2 ? arguments[2] : undefined;
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (!last.hasOwnProperty('row')) {
        last.row = start.row;
      }
      var permission = this.permission('move-row', {
        start: start,
        last: last,
        index: index,
        alert: true
      });
      if (permission === true) {
        var correctedIndex = Math.min(this.tableSize.rows, Math.max(0, index || 0));
        var count = last.row - start.row + 1;
        this.mapArrayMove(this.rows, start.row, index, count);
        this.renewSortOrder();
        if (options.render) {
          this.tableBodyEmbed.mapToObject({
            render: true,
            mode: 'full'
          });
          var selectRow = index < start.row ? correctedIndex : correctedIndex - count;
          this.selectCells({
            row: selectRow,
            col: 0
          }, {
            row: selectRow + count - 1,
            col: this.colLast
          });
        }
      } else if (table_table_typeof(permission) === 'object' && permission.error) {
        throw new TableMoveItemError(permission.error);
      }
    }
  }, {
    key: "moveCol",
    value: function moveCol() {
      var _this25 = this;
      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var last = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var index = arguments.length > 2 ? arguments[2] : undefined;
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (!last.hasOwnProperty('col')) {
        last.col = start.col;
      }
      var permission = this.permission('move-col', {
        start: start,
        last: last,
        index: index,
        alert: true
      });
      if (permission === true) {
        var correctedIndex = Math.min(this.tableSize.cols, Math.max(0, index || 0));
        var count = last.col - start.col + 1;
        this.mapArrayMove(this.cols, start.col, index, count);
        this.eachRowMap(false, false, {
          exist: true
        }, function (rowMap, pos) {
          var children = rowMap.get('children');
          if (children) {
            _this25.mapArrayMove(children, start.col, index, count);
          }
        });
        this.renewSortOrder();
        if (options.render) {
          this.tableBodyEmbed.mapToObject({
            render: true,
            mode: 'full'
          });
          var selectCol = index < start.col ? correctedIndex : correctedIndex - count;
          this.selectCells({
            row: 0,
            col: selectCol
          }, {
            row: this.rowLast,
            col: selectCol + count - 1
          });
        }
      } else if (table_table_typeof(permission) === 'object' && permission.error) {
        throw new TableMoveItemError(permission.error);
      }
    }

    /**
     * Возвращает данные большой ячейки, в которую входит указанная
     * @param { object } pos: {row, col}
     * @returns { object } bigCell
     * @returns { object } bigCell.pos: {row, col} | false
     * @returns { yMap } bigCell.map: map большой ячейки
     * @returns { object } bigCell.pos: позиция большой ячейки {row, col}
     * @returns { object } bigCell.posEnd: конечная позиция большой ячейки {row, col}
     * @returns { number } bigCell.colspan: смердженные колонки
     * @returns { number } bigCell.rowspan: смердженные строки
     * @returns { boolean } bigCell.merged: является ли ячейка смердженной по строкам или столбцам
     * @returns { boolean } bigCell.main: true если переданная в позиция сама является большой ячейкой, false если входит в состав большой
     */
  }, {
    key: "getBigCell",
    value: function getBigCell() {
      var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var bigCell = {};
      var cellMap = this.cellMapByPos(pos);
      if (!(cellMap !== null && cellMap !== void 0 && cellMap.get('hidden'))) {
        var _ref18 = (cellMap === null || cellMap === void 0 ? void 0 : cellMap.toJSON()) || {},
          _ref18$colspan = _ref18.colspan,
          colspan = _ref18$colspan === void 0 ? 1 : _ref18$colspan,
          _ref18$rowspan = _ref18.rowspan,
          rowspan = _ref18$rowspan === void 0 ? 1 : _ref18$rowspan;
        Object.assign(bigCell, {
          main: true,
          pos: pos,
          map: cellMap,
          rowspan: rowspan,
          colspan: colspan
        });
      } else {
        var found = false;
        for (var row = pos.row; row >= 0; row--) {
          var rowMap = this.rowMapByIndex(row);
          for (var col = pos.col; col >= 0; col--) {
            var _cellMap = rowMap && this.cellMapByPos({
              row: row,
              col: col
            }, {
              rowMap: rowMap
            });
            if (!(_cellMap !== null && _cellMap !== void 0 && _cellMap.get('hidden'))) {
              var _ref19 = (_cellMap === null || _cellMap === void 0 ? void 0 : _cellMap.toJSON()) || {},
                _ref19$colspan = _ref19.colspan,
                _colspan = _ref19$colspan === void 0 ? 1 : _ref19$colspan,
                _ref19$rowspan = _ref19.rowspan,
                _rowspan = _ref19$rowspan === void 0 ? 1 : _ref19$rowspan;
              if (_rowspan + row - 1 >= pos.row && _colspan + col - 1 >= pos.col) {
                Object.assign(bigCell, {
                  main: false,
                  pos: {
                    row: row,
                    col: col
                  },
                  map: _cellMap,
                  rowspan: _rowspan,
                  colspan: _colspan
                });
                found = true;
              }
              break;
            }
          }
          if (found) {
            break;
          }
        }
      }
      bigCell.posEnd = {
        row: bigCell.pos.row + bigCell.rowspan - 1,
        col: bigCell.pos.col + bigCell.colspan - 1
      };
      bigCell.merged = bigCell.rowspan > 1 || bigCell.colspan;
      return bigCell;
    }

    /**
     * Дублирование колонки
     * @param { object } startPos: {col}
     * @param { object } options?
     * @param { number } options.count: число столбцов
     * @param { boolean } options.render: рендер таблицы после дублирования
     * @param { boolean } options.silent: дублировать контент без вызова диалога
     * @param { boolean } options.skipData: дублировать без данных
     */
  }, {
    key: "duplicateCols",
    value: function duplicateCols() {
      var _this26 = this;
      var startPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var i18n = this.editor.plugins.i18n;
      var count = parseInt(options.count) || 1;
      var start = {
        col: startPos.col
      };
      var last = {
        col: startPos.col + count - 1
      };
      this.dialog('duplicate-cols', {
        start: start,
        last: last,
        silent: options.silent,
        skipData: options.skipData
      }, function () {
        var withContent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        _this26.store.transaction(function () {
          _this26.changeSize({
            cols: count
          }, {
            after: last.col
          });
          _this26.eachColMap(start, last, {
            exist: true
          }, function (colMap, pos) {
            var props = colMap.toJSON();
            delete props.id;
            if (props.text) {
              props.text += " (".concat(i18n.get('table.duplicate_column.copy'), ")");
            }
            var map = initInnerMap(_this26.editor.store, 'column', props);
            _this26.mapArraySet(_this26.cols, pos.col + count, [map.get('id')]);
          });
          if (withContent) {
            _this26.eachCellMap(start, last, {
              exist: true
            }, function (cellMap, pos, _ref20) {
              var _duplicatedMap$get;
              var rowMap = _ref20.rowMap;
              var duplicatedMap = _this26.cellMapByPos({
                row: pos.row,
                col: pos.col + count
              });
              if (!(duplicatedMap !== null && duplicatedMap !== void 0 && (_duplicatedMap$get = duplicatedMap.get) !== null && _duplicatedMap$get !== void 0 && _duplicatedMap$get.call(duplicatedMap, 'hidden'))) {
                var map = initInnerMap(_this26.editor.store, 'cell', cellMap);
                _this26.mapArraySet(rowMap.get('children'), pos.col + count, [map.get('id')]);
              }
            });
          }
        });
        if (options.render) {
          _this26.tableBodyEmbed.mapToObject({
            render: true,
            mode: 'full'
          });
        }
      });
    }

    /**
     * Заполенение строки данными из фильтра, если подходят условия
     * @param { number } index: индекс строки, которую нужно заполнить данными из фильтра
     * @param { array } filters: массив фильтров
     * @returns { boolean }: заполнение строки прошло успешно
     */
  }, {
    key: "fillRowFromFilters",
    value: function fillRowFromFilters(index) {
      var _this27 = this;
      var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var result = false;
      if (filters.length) {
        if (filters.every(function (filter) {
          return filter.type !== 'mention' && (filter.condition === 'is' || filter.condition === '=');
        })) {
          this.store.transaction(function () {
            var tableCols = _this27.cols.toJSON();
            var rowMap = _this27.rowMapByIndex(index, {
              create: true,
              inTransaction: true
            });
            var children = rowMap.get('children');
            var cellsIds = [];
            var _loop3 = function _loop3(i) {
              var cellMapId = false;
              var cell = false;
              if (tableCols[i]) {
                var forColFilter = filters.find(function (filter) {
                  return filter.colId === tableCols[i];
                });
                if (forColFilter) {
                  cell = {
                    colspan: 1,
                    rowspan: 1,
                    type: getTypeData(forColFilter.type).type,
                    cellType: forColFilter.type
                  };
                  if (forColFilter.type === 'text' || forColFilter.type === 'number' || forColFilter.type === 'currency') {
                    cell.delta = {
                      ops: [{
                        insert: forColFilter.value + '\n'
                      }]
                    };
                  } else if (forColFilter.type === 'link') {
                    var linkFilled = false;
                    var firstVisibleRow = _this27.tableComponentContext.useRefs.links.cell.find(function (row) {
                      return Boolean(row);
                    });
                    if (firstVisibleRow && firstVisibleRow.length) {
                      var firstCellInColumn = firstVisibleRow[i];
                      if (firstCellInColumn && firstCellInColumn.cellData && firstCellInColumn.cellData.cellType === 'link') {
                        var _firstCellInColumn$ce;
                        if ((_firstCellInColumn$ce = firstCellInColumn.cellData.child) !== null && _firstCellInColumn$ce !== void 0 && _firstCellInColumn$ce.delta) {
                          cell.delta = firstCellInColumn.cellData.child.delta;
                          linkFilled = true;
                        }
                      }
                    }
                    if (!linkFilled) {
                      cell.delta = {
                        ops: [{
                          insert: forColFilter.value,
                          attributes: {
                            link: forColFilter.value.startsWith('http') ? forColFilter.value : 'http://' + forColFilter.value
                          }
                        }]
                      };
                    }
                  } else if (forColFilter.type === 'date' && table_table_typeof(forColFilter.value) !== 'object') {
                    cell.timestamp = String(forColFilter.value);
                  } else if (forColFilter.type === 'checkbox') {
                    cell.checked = forColFilter.value;
                  } else if (forColFilter.type === 'rating') {
                    cell.rating = String(forColFilter.value);
                  } else if (forColFilter.type === 'progress') {
                    cell.progress = String(forColFilter.value);
                  } else if (forColFilter.type === 'date' && table_table_typeof(forColFilter.value) === 'object') {
                    cell = false;
                  }
                }
              }
              if (cell && Object.keys(cell).length) {
                cellMapId = initInnerMap(_this27.store, 'cell', cell, {
                  initChild: true
                }).get('id');
                result = true;
              }
              cellsIds.push(cellMapId);
            };
            for (var i = 0; i < tableCols.length; i++) {
              _loop3(i);
            }
            _this27.mapArraySet(children, 0, cellsIds);
          });
        }
      }
      return result;
    }

    /**
     * Изменяет размер таблицы
     * @param { object } diff: разница относительно текущего размера
     * @param { number } diff.rows?: изменение числа строк
     * @param { number } diff.cols?: изменение числа колонок
     * @param { object } options?
     * @param { number } options.render?: рендер после обновления
     * @param { number } options.after?: указывает, после какой строки / столбца добавлять
     * @param { number } options.before?: указывает, перед какой строкой / столбцом добавлять (приоритетней, чем after)
     * @returns { object } {rows, cols}: результирующий размер таблицы
     */
  }, {
    key: "changeSize",
    value: function changeSize() {
      var _this28 = this;
      var diff = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this.props.tempRow) return;
      var updateMode = 'table';
      if (diff.rows < 0 || diff.cols < 0) {
        updateMode = 'full';
      }
      var size = this.tableSize;
      var index = false;
      if (options.hasOwnProperty('before')) {
        index = options.before;
      } else if (options.hasOwnProperty('after')) {
        index = options.after + 1;
      }
      this.store.transaction(function () {
        // Устанавливаем v2, т.к. таблица v1 не сможет обработать size
        _this28.map.set('version', CONFIG.version);
        if (diff.hasOwnProperty('rows') && !_this28.props.tempRow) {
          var _this28$map$get;
          var count = parseInt(diff.rows) || 1;
          size.rows = Math.max(0, size.rows + count);
          if (index !== false) {
            var filled = _this28.mapArrayFillOptional(_this28.rows, index, count);
            if (filled) {
              updateMode = 'full';
              if (index > 0) {
                var bigCells = {};
                // Перебираем строку, чтобы увеличить мердженные ячейки
                _this28.eachCellMap({
                  row: index - 1
                }, {
                  row: index - 1
                }, {
                  exist: true,
                  inTransaction: true
                }, function (cellMap, _ref21) {
                  var row = _ref21.row,
                    col = _ref21.col;
                  if (cellMap.get('hidden') || cellMap.get('colspan') > 1 || cellMap.get('rowspan') > 1) {
                    var bigCell = _this28.getBigCell({
                      row: row,
                      col: col
                    });
                    if (bigCell.posEnd.row > row) {
                      var key = Object.entries(bigCell.pos).toString();
                      bigCells[key] = bigCell;
                      _this28.eachCellMap({
                        row: index,
                        col: col
                      }, {
                        row: index + count - 1,
                        col: col
                      }, {
                        create: true,
                        inTransaction: true
                      }, function (hCellMap) {
                        hCellMap.set('hidden', true);
                      });
                    }
                  }
                });
                for (var key in bigCells) {
                  var cell = bigCells[key];
                  cell.map.set('rowspan', cell.rowspan + count);
                }
              }
            }
          }
          var filters = (_this28$map$get = _this28.map.get('filter')) === null || _this28$map$get === void 0 ? void 0 : _this28$map$get.filters;
          var filtersEnabled = !Boolean(_this28.map.get('filter-disabled'));
          if (diff.rows === 1 && filters && filters.length && filtersEnabled) {
            var rowIndex = index !== false ? index : size.rows - 1;
            var filledFromFilters = _this28.fillRowFromFilters(rowIndex, filters);
            if (!filledFromFilters) {
              var rowMap = _this28.rowMapByIndex(rowIndex, {
                create: true,
                inTransaction: true
              });
              var rowId = rowMap.get('id');
              _this28.props.tempRow = rowId;
            }
            size.visibleRows = size.visibleRows + 1;
            updateMode = 'full';
          }
          _this28.map.set('size', size);
        }
        if (diff.hasOwnProperty('cols')) {
          var _count = parseInt(diff.cols) || 1;
          size.cols = Math.max(0, size.cols + _count);
          _this28.map.set('size', size);
          if (index !== false) {
            var _filled = _this28.mapArrayFillOptional(_this28.cols, index, _count);
            _this28.rows.map(function (rowId) {
              if (rowId) {
                var _rowMap = _this28.store.getMap(rowId);
                if (_rowMap) {
                  _filled = _this28.mapArrayFillOptional(_rowMap.get('children'), index, _count) || _filled;
                }
              }
            });
            if (_filled) {
              updateMode = 'full';
              if (index > 0) {
                var _bigCells = {};
                // Перебираем колонку, чтобы увеличить мердженные ячейки
                _this28.eachCellMap({
                  col: index - 1
                }, {
                  col: index - 1
                }, {
                  exist: true,
                  inTransaction: true
                }, function (cellMap, _ref22) {
                  var row = _ref22.row,
                    col = _ref22.col;
                  if (cellMap.get('hidden') || cellMap.get('colspan') > 1 || cellMap.get('rowspan') > 1) {
                    var bigCell = _this28.getBigCell({
                      row: row,
                      col: col
                    });
                    if (bigCell.posEnd.col > col) {
                      _bigCells["".concat(bigCell.pos.row, ":").concat(bigCell.pos.col)] = bigCell;
                      _this28.eachCellMap({
                        col: index,
                        row: row
                      }, {
                        col: index + _count - 1,
                        row: row
                      }, {
                        create: true,
                        inTransaction: true
                      }, function (hCellMap, hPos) {
                        hCellMap.set('hidden', true);
                      });
                    }
                  }
                });
                for (var i in _bigCells) {
                  var _cell = _bigCells[i];
                  _cell.map.set('colspan', _cell.colspan + _count);
                }
              }
            }
          }
        }
        // Для миграции V1 -> V2, позже можно удалить
        _this28.ensureNewRowType();
      });
      var newSize = this.tableSize;
      if (diff.rows < 0 || diff.cols < 0) {
        this.unselectAllCells();
      }
      // Удаляем таблицу, при удалении последней строки
      if (newSize.rows < 1 || newSize.cols < 1) {
        console.info('Remove table, reason:', newSize);
        return this.remove();
      }
      if (options.render) {
        this.tableBodyEmbed.mapToObject({
          render: true,
          mode: updateMode
        });
      }
      this.renderCaption();
      return size;
    }

    /**
    * Устанавливает значение в mapArray по индексу
    * При необходимости создает промежуточные значения и заполняет значением false
    * @param { YArray } mapArray
    * @param { number } index
    * @param { array } items: массив значений, например childId
    * @returns { boolean } true, если были вставлены значения
    */
  }, {
    key: "mapArraySet",
    value: function mapArraySet(mapArray, index, items) {
      var count = index - mapArray.length;
      if (count > 0) {
        mapArray.insert(mapArray.length, new Array(count).fill(false));
      }
      for (var i in items) {
        if (mapArray.length > index) {
          mapArray.delete(index);
        } else {
          break;
        }
      }
      mapArray.insert(index, items);
      return true;
    }

    /**
    * Перемещает значения в map на новую позицию, если они созданы
    * При необходимости создает промежуточные значения и заполняет значением false
    * @param { YArray } mapArray
    * @param { number } from: начальная позиция
    * @param { number } to: конечная позиция
    * @param { number } count: число значений
    * @returns { boolean } выполнено ли перемещение, при перемещении из несозданной области в несозданную будет false
    */
  }, {
    key: "mapArrayMove",
    value: function mapArrayMove(mapArray, from, to) {
      var count = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
      if (mapArray.length < from && mapArray.length < to) {
        return false;
      }
      this.store.transaction(function () {
        var maxIndex = Math.max(from, to) + count;
        var create = maxIndex - mapArray.length;
        if (create > 0) {
          mapArray.insert(mapArray.length, new Array(create).fill(false));
        }
        var ids = mapArray.toArray().splice(from, count);
        mapArray.delete(from, count);
        var index = from < to ? to - count : to;
        mapArray.insert(index, ids);
      });
      return true;
    }

    /**
    * Заполняет mapArray значениями false при необходимости
    * Необходимость определяется длиной массива больше индекса
    * @param { YArray } mapArray
    * @param { number } index
    * @param { number } count: количество вставляемых значений
    * @returns {boolean} true, если были вставлены значения
    */
  }, {
    key: "mapArrayFillOptional",
    value: function mapArrayFillOptional(mapArray, index) {
      var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      if (mapArray.length > index) {
        mapArray.insert(index, new Array(count).fill(false));
        return true;
      }
      return false;
    }

    /**
     * Может ли таблица принимать dnd файлы
     */
  }, {
    key: "isDropAcceptor",
    get: function get() {
      var cell = this.componentOnAction({
        type: 'get-drop-cell'
      });
      return cell ? true : false;
    }

    /**
     * Создает блот для dnd файла в ячейке
     * При необходимости конвертирует ячейку в аттач
     * @returns { blot } FileBlot
     */
  }, {
    key: "createFileBlot",
    value: function createFileBlot() {
      var _cell2;
      var blot;
      var cell = this.componentOnAction({
        type: 'get-drop-cell'
      });
      if ((_cell2 = cell) !== null && _cell2 !== void 0 && _cell2.pos) {
        var colMap = this.colMapByIndex(cell.pos.col);
        var cellMap = this.cellMapByPos(cell.pos);
        if ((colMap === null || colMap === void 0 ? void 0 : colMap.get('columnType')) === 'attachment' || (cellMap === null || cellMap === void 0 ? void 0 : cellMap.get('cellType')) === 'attachment') {
          var _cell$onDrop, _cell3;
          blot = (_cell$onDrop = (_cell3 = cell).onDrop) === null || _cell$onDrop === void 0 ? void 0 : _cell$onDrop.call(_cell3);
        } else if (!colMap || colMap.get('columnType') === 'none') {
          var _cell$onDrop2, _cell4;
          this.convertCells(cell.pos, cell.pos, 'attachment', {
            render: true
          });
          cell = this.componentOnAction({
            type: 'get-drop-cell'
          });
          blot = (_cell$onDrop2 = (_cell4 = cell).onDrop) === null || _cell$onDrop2 === void 0 ? void 0 : _cell$onDrop2.call(_cell4);
        }
      }
      return blot;
    }

    /**
     * Возвращает редактируемую ячейку
     * @returns { object } { pos }
     */
  }, {
    key: "getEditCell",
    get: function get() {
      if (this.tableBlotEditCell.isEdit && this.tableBlotEditCell.options) {
        var _this$tableBlotEditCe = this.tableBlotEditCell.options.pos,
          pos = _this$tableBlotEditCe === void 0 ? {} : _this$tableBlotEditCe;
        return pos;
      }
      return {};
    }

    /**
     * Возвращает выделенную область
     * @returns { object } { pos }
     */
  }, {
    key: "getSelection",
    get: function get() {
      return this.componentOnAction({
        type: 'selection'
      });
    }

    /**
     * Возвращает кэш выделенной области
     * @returns { object }
     */
  }, {
    key: "getSelectionCache",
    get: function get() {
      return this.componentOnAction({
        type: 'selection-cache'
      });
    }

    /**
     * Заменяет содержимое дельты потомка ячейки
     * Для текстовых и числовых типов
     * @param { object } pos: позиция ячейки
     * @param { delta } delta
     * @returns { boolean } было ли изменено содержимое
     */
  }, {
    key: "setCellDelta",
    value: function setCellDelta() {
      var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var delta = arguments.length > 1 ? arguments[1] : undefined;
      var changed = false;
      var childMap = this.childMapByPos(pos, {
        create: true
      });
      var characters = childMap.get('characters');
      var diff = new (Delta_default())(characters.toDelta()).diff(delta);
      if (diff !== null && diff !== void 0 && diff.ops.length) {
        characters.applyDelta(diff.ops);
        changed = true;
      }
      return changed;
    }

    /**
     * Возвращает link компонента колонки
     * @param { object } pos: {col} позиция колонки в отрендеренной таблице
     * @returns { object }
     */
  }, {
    key: "getColLink",
    value: function getColLink() {
      var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.componentOnAction({
        type: 'get-col',
        pos: pos
      });
    }

    /**
     * Возвращает domNode отрендеренной колонки
     * Используется только для чтения в тестах, и проверке статуса
     * Манипуляций над domNode проводить не стоит, т.к. это preact компонент
     * @param { object } pos: {col} позиция колонки в отрендеренной таблице
     * @returns { object }
     */
  }, {
    key: "getColNode",
    value: function getColNode() {
      var _colLink$getNode;
      var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var colLink = this.getColLink(pos);
      return colLink === null || colLink === void 0 ? void 0 : (_colLink$getNode = colLink.getNode) === null || _colLink$getNode === void 0 ? void 0 : _colLink$getNode.call(colLink);
    }

    /**
     * Возвращает link компонента ячейки
     * @param { object } pos: {row, col} позиция ячейки в отрендеренной таблице
     * @returns { object }
     */
  }, {
    key: "getCellLink",
    value: function getCellLink() {
      var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.componentOnAction({
        type: 'get-cell',
        pos: pos
      });
    }

    /**
     * Возвращает domNode отрендеренной ячейки
     * Используется только для чтения в тестах, и проверке статуса
     * Манипуляций над domNode проводить не стоит, т.к. это preact компонент
     * @param { object } pos: {row, col}
     * @returns { node }
     */
  }, {
    key: "getCellNode",
    value: function getCellNode() {
      var _cellLink$getNode;
      var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var cellLink = this.getCellLink(pos);
      return cellLink === null || cellLink === void 0 ? void 0 : (_cellLink$getNode = cellLink.getNode) === null || _cellLink$getNode === void 0 ? void 0 : _cellLink$getNode.call(cellLink);
    }

    /**
     * Начать редактирование ячейки
     * @param { object } pos: {row, col}
     * @returns { boolean }
     */
  }, {
    key: "startEditCell",
    value: function startEditCell() {
      var _cellLink$editCell;
      var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var cellLink = this.getCellLink(pos);
      return cellLink === null || cellLink === void 0 ? void 0 : (_cellLink$editCell = cellLink.editCell) === null || _cellLink$editCell === void 0 ? void 0 : _cellLink$editCell.call(cellLink, {});
    }

    /**
     * Возвращает тип колонки
     * @param { numbet } index: индекс колонки
     * @returns { string | boolean } type | false
     */
  }, {
    key: "getColType",
    value: function getColType(index) {
      var _colMap$get;
      if (index > this.colLast) {
        return false;
      }
      var colMap = this.colMapByIndex(index);
      var columnType = colMap === null || colMap === void 0 ? void 0 : (_colMap$get = colMap.get) === null || _colMap$get === void 0 ? void 0 : _colMap$get.call(colMap, 'columnType');
      return columnType || 'none';
    }

    /**
     * Возвращает реальный тип ячейки
     * @param { object } pos: позиция ячейки
     * @returns { string }
     */
  }, {
    key: "getCellType",
    value: function getCellType() {
      var _cellMap$get;
      var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var cellMap = this.cellMapByPos(pos);
      var cellType = cellMap === null || cellMap === void 0 ? void 0 : (_cellMap$get = cellMap.get) === null || _cellMap$get === void 0 ? void 0 : _cellMap$get.call(cellMap, 'cellType');
      if (!cellType) {
        var _cellMap$get2;
        var type = cellMap === null || cellMap === void 0 ? void 0 : (_cellMap$get2 = cellMap.get) === null || _cellMap$get2 === void 0 ? void 0 : _cellMap$get2.call(cellMap, 'type');
        if (type) {
          cellType = getTypeFromName(type);
        }
      }
      if (!cellType || cellType === 'none') {
        var _colMap$get2;
        var colMap = this.colMapByIndex(pos.col);
        var columnType = colMap === null || colMap === void 0 ? void 0 : (_colMap$get2 = colMap.get) === null || _colMap$get2 === void 0 ? void 0 : _colMap$get2.call(colMap, 'columnType');
        if (columnType && columnType !== 'none') {
          cellType = columnType;
        }
      }
      cellType = cellType && cellType !== 'none' ? cellType : 'text';
      return cellType;
    }

    /**
     * Возвращает формат типа ячейки
     * @param { object } pos: позиция ячейки
     * @returns { string }
     */
  }, {
    key: "getCellFormat",
    value: function getCellFormat() {
      var _colMap$get3, _cellMap$get3;
      var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var cellType = this.getCellType(pos);
      var cellMap = this.cellMapByPos(pos);
      var colMap = this.colMapByIndex(pos.col);
      var defaultFormat = getTypeData(cellType).format || {};
      var colFormat = (colMap === null || colMap === void 0 ? void 0 : (_colMap$get3 = colMap.get) === null || _colMap$get3 === void 0 ? void 0 : _colMap$get3.call(colMap, 'format')) || {};
      var cellFormat = (cellMap === null || cellMap === void 0 ? void 0 : (_cellMap$get3 = cellMap.get) === null || _cellMap$get3 === void 0 ? void 0 : _cellMap$get3.call(cellMap, 'format')) || {};
      var format = Object.assign({}, defaultFormat, colFormat, cellFormat);
      return format;
    }

    /**
     * Возвращает значение ячейки для сравнения
     * @param { object } pos: {row, col}
     * @returns { object } {type, value, order}
     */
  }, {
    key: "getCellComparisonValue",
    value: function getCellComparisonValue() {
      var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var cellType = this.getCellType(pos);
      var cellMap = this.cellMapByPos(pos);
      var childMap = this.childMapByPos(pos, {
        cellMap: cellMap
      });
      var colMap = this.colMapByIndex(pos.col);
      var value = comparisonValue(cellMap, childMap, {
        cellType: cellType,
        colMap: colMap
      });
      return table_objectSpread({
        cellType: cellType
      }, value);
    }

    /**
     * Возвращает текст ячейки
     * @param { object } pos: {row, col}
     * @param { object } options?
     * @param { boolean } options.trim?
     * @param { boolean } options.delta?
     * @returns { string }
     */
  }, {
    key: "getCellText",
    value: function getCellText() {
      var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var text = '';
      var cellType = this.getCellType(pos);
      var cellMap = this.cellMapByPos(pos);
      var childMap = this.childMapByPos(pos, {
        cellMap: cellMap
      });
      var cellLink = this.getCellLink(pos);
      if (['text', 'number', 'currency'].includes(cellType)) {
        if (options.delta) {
          var _childMap$get3, _childMap$get3$call;
          text = (childMap === null || childMap === void 0 ? void 0 : (_childMap$get3 = childMap.get) === null || _childMap$get3 === void 0 ? void 0 : (_childMap$get3$call = _childMap$get3.call(childMap, 'characters')) === null || _childMap$get3$call === void 0 ? void 0 : _childMap$get3$call.toDelta()) || [{
            insert: text
          }];
        } else {
          var _childMap$get4, _childMap$get4$call;
          text = (childMap === null || childMap === void 0 ? void 0 : (_childMap$get4 = childMap.get) === null || _childMap$get4 === void 0 ? void 0 : (_childMap$get4$call = _childMap$get4.call(childMap, 'characters')) === null || _childMap$get4$call === void 0 ? void 0 : _childMap$get4$call.toString()) || text;
        }
      } else {
        var colMap = this.colMapByIndex(pos.col);
        var copyParams = getCellCopyParams(cellType, cellMap, childMap, {
          colMap: colMap,
          cellLink: cellLink
        });
        if (options.delta) {
          text = [{
            insert: copyParams.text
          }];
        } else {
          text = copyParams.text;
        }
      }
      if (options.trim && !options.delta) {
        text = text.trim();
      }
      return text;
    }

    /**
     * Возвращает дельту потомка ячейки, если она существует
     * @param { object } pos: {row, col}
     * @returns { delta | false }
     */
  }, {
    key: "getChildDelta",
    value: function getChildDelta() {
      var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var childMap = this.childMapByPos(pos);
      if (childMap !== null && childMap !== void 0 && childMap.has('characters')) {
        return childMap.get('characters').toDelta();
      }
      return false;
    }

    /**
     * Возвращает значение ячейки
     * Текст в случае text, number, currency, mention, link
     * Выбранные значения для остальных типов
     * @param { object } pos: {row, col}
     * @returns { string }
     */
  }, {
    key: "getCellValue",
    value: function getCellValue() {
      var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var cellType = this.getCellType(pos);
      var cellMap = this.cellMapByPos(pos);
      var childMap = this.childMapByPos(pos, {
        cellMap: cellMap
      });
      var copyParams = getCellCopyParams(cellType, cellMap, childMap);
      return copyParams.value;
    }

    /**
     * Возвращает редактируемую ячейку
     * @returns { false | object } result
     * @returns { blot } result.blot: текстовый блот
     * @returns { object } result.pos: позиция редактируемой ячейки {row, col}
     */
  }, {
    key: "getEditing",
    value: function getEditing() {
      var blot = this.tableBlotEditCell.childBlot;
      if (blot !== null && blot !== void 0 && blot.editing) {
        var selection = this.componentOnAction({
          type: 'selection'
        });
        var result = {
          editing: blot.editing,
          pos: selection.current,
          blot: blot
        };
        return result;
      } else {
        return false;
      }
    }

    /**
     * Скролит к ячейке по blotId
     * @param { object } params: {blotId, ensureCellVisible}
     * @returns { boolean }
     */
  }, {
    key: "scrollToCell",
    value: function scrollToCell(_ref23) {
      var blotId = _ref23.blotId,
        ensureCellVisible = _ref23.ensureCellVisible,
        setCurrent = _ref23.setCurrent,
        _ref23$select = _ref23.select,
        select = _ref23$select === void 0 ? false : _ref23$select;
      var result = false;
      var pos = this.tableBodyEmbed.index.cell[blotId];
      if (pos) {
        ensureCellVisible(pos);
        if (select) {
          setCurrent(pos, {
            session: false
          });
        }
        result = true;
      }
      return result;
    }
  }, {
    key: "getMarkdown",
    value: function getMarkdown() {
      var columns = [];
      var rows = [];
      for (var col = 0; col < this.tableSize.cols; col++) {
        var _this$colMapByIndex;
        columns.push(((_this$colMapByIndex = this.colMapByIndex(col)) === null || _this$colMapByIndex === void 0 ? void 0 : _this$colMapByIndex.get('text')) || '');
      }
      for (var row = 0; row < this.tableSize.rows; row++) {
        var rowItem = {
          children: []
        };
        for (var _col = 0; _col < this.tableSize.cols; _col++) {
          var ops = this.getCellText({
            row: row,
            col: _col
          }, {
            delta: true
          }) || [];
          rowItem.children.push({
            delta: {
              ops: ops
            }
          });
        }
        rows.push(rowItem);
      }
      var captionOps;
      if (this.map.get('caption')) {
        var _this$editor$store$bl, _this$editor$store$bl2;
        captionOps = (_this$editor$store$bl = this.editor.store.blocks.get(this.map.get('caption'))) === null || _this$editor$store$bl === void 0 ? void 0 : (_this$editor$store$bl2 = _this$editor$store$bl.get('characters')) === null || _this$editor$store$bl2 === void 0 ? void 0 : _this$editor$store$bl2.toDelta();
      }
      var params = {
        cols: this.tableSize.cols,
        rows: this.tableSize.rows,
        captionParams: captionOps ? {
          delta: {
            ops: captionOps
          }
        } : undefined,
        content: {
          columns: columns,
          rows: rows
        }
      };
      return tableToMarkdown(params);
    }
  }], [{
    key: "initMap",
    value: function initMap(map, store) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      map.set('type', 'table');
      map.set('version', CONFIG.version);
      map.set('size', {
        cols: params.cols,
        rows: params.rows
      });
      if (true) {
        // Таблица V2 способна работать без создания реальных колонок и строк
        // Но реализация V1 удаляет таблицы без колонок или строк в map
        // Чтбы избежать удаления принудительно создаем первую колонку и строку
        // В будущем (когда все клиенты перейдут на V2) это можно убрать
        if (!params.content) {
          params.content = {
            columns: [],
            rows: []
          };
        }
        if (!params.content.columns.length) {
          params.content.columns.push({
            type: 'column'
          });
        }
        if (!params.content.rows.length) {
          params.content.rows.push({
            type: 'row'
          });
        }
      }
      var columns = new store.types.Array();
      var rows = new store.types.Array();
      if (params.content) {
        if (params.content.columns) {
          var colsIds = [];
          var _iterator4 = table_table_createForOfIteratorHelper(params.content.columns),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var column = _step4.value;
              var colMap = void 0;
              if (column && Object.keys(column).length) {
                colMap = initInnerMap(store, 'column', column);
              }
              colsIds.push(colMap ? colMap.get('id') : false);
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          columns.push((0,util/* arrayTrimEnd */.J8)(colsIds));
        }
        if (params.content.rows) {
          var rowsIds = [];
          var _iterator5 = table_table_createForOfIteratorHelper(params.content.rows),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var row = _step5.value;
              var rowMap = void 0;
              if (row && Object.keys(row).length) {
                var _row$children;
                rowMap = initInnerMap(store, 'row', row);
                if ((_row$children = row.children) !== null && _row$children !== void 0 && _row$children.length) {
                  var cellsIds = [];
                  var _iterator6 = table_table_createForOfIteratorHelper(row.children),
                    _step6;
                  try {
                    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                      var cell = _step6.value;
                      var cellMap = void 0;
                      if (cell && Object.keys(cell).length) {
                        cellMap = initInnerMap(store, 'cell', cell, {
                          initChild: true
                        });
                      }
                      cellsIds.push(cellMap ? cellMap.get('id') : false);
                    }
                  } catch (err) {
                    _iterator6.e(err);
                  } finally {
                    _iterator6.f();
                  }
                  rowMap.get('children').push((0,util/* arrayTrimEnd */.J8)(cellsIds));
                }
              }
              rowsIds.push(rowMap ? rowMap.get('id') : false);
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
          rows.push((0,util/* arrayTrimEnd */.J8)(rowsIds));
        }
      }
      map.set('columns', columns);
      map.set('rows', rows);
      var _iterator7 = table_table_createForOfIteratorHelper(CONFIG.table.copy),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var attr = _step7.value;
          if (params.hasOwnProperty(attr)) {
            map.set(attr, params[attr]);
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      indentable.initMap(map, store, params);
      colorable.initMap(map, store, table_objectSpread({
        noDefaultColor: true
      }, params));
      fullWidth.initMap(map, store, params);
      var captionId = params.caption;
      if (!captionId) {
        var captionMap = store.createMap();
        Caption.initMap(captionMap, store, params.captionParams || {});
        captionId = captionMap.get('id');
      }
      map.set('caption', captionId);
    }
  }, {
    key: "createBlot",
    value: function createBlot(editor) {
      var blot = parchment_default().create('tableWrapper');
      this.addCaretTrap(editor, blot.domNode);
      return blot;
    }
  }, {
    key: "getMaxIndent",
    value: function getMaxIndent() {
      return table_MAX_INDENT_LEVEL;
    }
  }, {
    key: "getAttachments",
    value: function getAttachments(editor, tableMap) {
      var rowsIds = tableMap.get('rows');
      var attachments = [];
      var _iterator8 = table_table_createForOfIteratorHelper(rowsIds),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var rowId = _step8.value;
          var rowMap = editor.store.blocks.get(rowId);
          if (rowMap) {
            var cellsIds = rowMap.get('children');
            var _iterator9 = table_table_createForOfIteratorHelper(cellsIds),
              _step9;
            try {
              for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                var cellId = _step9.value;
                var cellMap = editor.store.blocks.get(cellId);
                if (cellMap) {
                  var attachmentsForCell = cellMap.get('attachments');
                  if (attachmentsForCell && attachmentsForCell.length) {
                    attachments.push.apply(attachments, table_table_toConsumableArray(attachmentsForCell));
                  }
                }
              }
            } catch (err) {
              _iterator9.e(err);
            } finally {
              _iterator9.f();
            }
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      return attachments;
    }
  }, {
    key: "findReminders",
    value: function findReminders(editor, rows) {
      var blocks = editor.store.blocks;
      var reminders = [];
      rows.forEach(function (row) {
        var _blocks$get;
        var _ref24 = row && ((_blocks$get = blocks.get(row)) === null || _blocks$get === void 0 ? void 0 : _blocks$get.toJSON()) || {},
          _ref24$children = _ref24.children,
          children = _ref24$children === void 0 ? [] : _ref24$children;
        children.forEach(function (blotId) {
          var map = blocks.get(blotId);
          if (map && map.get('type') === 'tableCellDate') {
            var blotReminders = map.get('reminders');
            for (var key in blotReminders) {
              var seconds = blotReminders[key].seconds;
              reminders.push({
                id: key,
                dateId: map.get('id'),
                timestamp: map.get('timestamp'),
                format: map.get('format'),
                seconds: seconds
              });
            }
          }
          if (map && map.get('type') === 'tableCellMention') {
            var _map$toJSON = map.toJSON(),
              mentionChildren = _map$toJSON.children;
            mentionChildren.forEach(function (mentionBlotId) {
              var _blocks$get2;
              var delta = ((_blocks$get2 = blocks.get(mentionBlotId)) === null || _blocks$get2 === void 0 ? void 0 : _blocks$get2.get('characters').toDelta()) || [];
              delta.forEach(function (_ref25) {
                var insert = _ref25.insert;
                if (insert !== null && insert !== void 0 && insert.date && insert.date.reminders) {
                  for (var _key3 in insert.date.reminders) {
                    var _seconds = insert.date.reminders[_key3].seconds;
                    reminders.push({
                      id: _key3,
                      dateId: insert.date.dateId,
                      timestamp: insert.date.value,
                      format: insert.date.format,
                      seconds: _seconds
                    });
                  }
                }
              });
            });
          }
        });
      });
      return reminders;
    }

    /**
     * Вызывает удаление инлайн ремайндеров таблицы через reminderManager
     * @param { Object } editor
     * @param { Array } rows
     */
  }, {
    key: "removeReminders",
    value: function removeReminders(editor, rows) {
      var reminderManager = editor.plugins.reminderManager;
      var tableReminders = Table.findReminders(editor, rows);
      var reminders = table_table_toConsumableArray(new Set(tableReminders.map(function (_ref26) {
        var dateId = _ref26.dateId;
        return dateId;
      })));
      reminders.forEach(function (dateId) {
        var params = {
          reminders: {}
        };
        tableReminders.filter(function (item) {
          return item.dateId === dateId;
        }).forEach(function (item) {
          params.dateId = dateId;
          params.timestamp = item.timestamp;
          params.reminders[item.id] = {
            seconds: item.seconds
          };
        });
        reminderManager.deleteReminder(dateId, params);
      });
    }

    /**
     * Устанавливает инлайн ремайндеры таблицы через reminderManager
     * @param { Object } editor
     * @param { Array } rows
     */
  }, {
    key: "setReminders",
    value: function setReminders(editor, rows) {
      var reminders = Table.findReminders(editor, rows);
      Table.setInlineRemindersByArray(editor, reminders);
    }

    /**
     * Устанавливает инлайн ремайндеры
     * @param { Array } reminders
     */
  }, {
    key: "setInlineRemindersByArray",
    value: function setInlineRemindersByArray(editor, reminders) {
      var reminderManager = editor.plugins.reminderManager;
      var dates = {};
      var dateActions = new DateActionsCls();
      dateActions.scroll = editor.scroll;
      reminders.forEach(function (_ref27) {
        var id = _ref27.id,
          dateId = _ref27.dateId,
          timestamp = _ref27.timestamp,
          seconds = _ref27.seconds,
          format = _ref27.format,
          before = _ref27.before;
        if (!dates[dateId]) {
          var _ref28 = format || {},
            _ref28$showTime = _ref28.showTime,
            showTime = _ref28$showTime === void 0 ? false : _ref28$showTime;
          var dateObj = new Date(timestamp);
          var date = [dateObj.toLocaleDateString()];
          if (showTime) {
            date.push(dateObj.toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit'
            }));
          }
          dates[dateId] = {
            title: editor.plugins.i18n.get('calendar.ui.reminder.push_name'),
            dateId: dateId,
            timestamp: timestamp,
            alerts: [],
            bodies: {},
            reminders: {},
            remindersBefore: before,
            date: date.join(' ')
          };
        }
        dates[dateId].alerts.push(seconds);
        dates[dateId].bodies[id] = dateActions.reminderTimeToString(seconds);
        dates[dateId].reminders[id] = {
          seconds: seconds
        };
      });
      for (var key in dates) {
        var _dates$key = dates[key],
          dateId = _dates$key.dateId,
          params = table_objectWithoutProperties(_dates$key, table_excluded);
        reminderManager.setReminder(dateId, params);
      }
    }
  }]);
  return Table;
}(table_mixin(block));
Table.blotName = 'table';
Table.tagName = 'DIV';
Table.wrapper = 'tableWrapper';
Table.className = 'table-blot';
Table.allowedChildren = [TableBodyEmbed, tableBlotEditCell];
/* harmony default export */ const table_table = (Table);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/container.js
function blots_container_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { blots_container_typeof = function _typeof(obj) { return typeof obj; }; } else { blots_container_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return blots_container_typeof(obj); }










function blots_container_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function blots_container_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function blots_container_createClass(Constructor, protoProps, staticProps) { if (protoProps) blots_container_defineProperties(Constructor.prototype, protoProps); if (staticProps) blots_container_defineProperties(Constructor, staticProps); return Constructor; }
function blots_container_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) blots_container_setPrototypeOf(subClass, superClass); }
function blots_container_setPrototypeOf(o, p) { blots_container_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return blots_container_setPrototypeOf(o, p); }
function blots_container_createSuper(Derived) { var hasNativeReflectConstruct = blots_container_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = blots_container_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = blots_container_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return blots_container_possibleConstructorReturn(this, result); }; }
function blots_container_possibleConstructorReturn(self, call) { if (call && (blots_container_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return blots_container_assertThisInitialized(self); }
function blots_container_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function blots_container_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function blots_container_getPrototypeOf(o) { blots_container_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return blots_container_getPrototypeOf(o); }

var container_Container = /*#__PURE__*/function (_Parchment$Container) {
  blots_container_inherits(Container, _Parchment$Container);
  var _super = blots_container_createSuper(Container);
  function Container(domNode) {
    var _this;
    blots_container_classCallCheck(this, Container);
    _this = _super.call(this, domNode);
    _this.isSeparableByClickApplicable = true;
    return _this;
  }
  blots_container_createClass(Container, [{
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      var type = this.constructor.blotName || null;
      return {
        type: type,
        initParams: {}
      };
    }
  }, {
    key: "toHTML",
    value: function toHTML() {
      return this.domNode.outerHTML;
    }
  }, {
    key: "getMarkdown",
    value: function getMarkdown() {
      var markdown = '';
      this.children.forEach(function (blot) {
        if (blot.getMarkdown) {
          markdown += blot.getMarkdown();
        }
      });
      return markdown;
    }
  }]);
  return Container;
}((parchment_default()).Container);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/table/tableWrapper.js
function tableWrapper_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { tableWrapper_typeof = function _typeof(obj) { return typeof obj; }; } else { tableWrapper_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return tableWrapper_typeof(obj); }
function tableWrapper_toConsumableArray(arr) { return tableWrapper_arrayWithoutHoles(arr) || tableWrapper_iterableToArray(arr) || tableWrapper_unsupportedIterableToArray(arr) || tableWrapper_nonIterableSpread(); }
function tableWrapper_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tableWrapper_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function tableWrapper_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return tableWrapper_arrayLikeToArray(arr); }
function tableWrapper_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = tableWrapper_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function tableWrapper_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tableWrapper_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tableWrapper_arrayLikeToArray(o, minLen); }
function tableWrapper_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



















function tableWrapper_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function tableWrapper_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function tableWrapper_createClass(Constructor, protoProps, staticProps) { if (protoProps) tableWrapper_defineProperties(Constructor.prototype, protoProps); if (staticProps) tableWrapper_defineProperties(Constructor, staticProps); return Constructor; }
function tableWrapper_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { tableWrapper_get = Reflect.get; } else { tableWrapper_get = function _get(target, property, receiver) { var base = tableWrapper_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return tableWrapper_get(target, property, receiver || target); }
function tableWrapper_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = tableWrapper_getPrototypeOf(object); if (object === null) break; } return object; }
function tableWrapper_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) tableWrapper_setPrototypeOf(subClass, superClass); }
function tableWrapper_setPrototypeOf(o, p) { tableWrapper_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return tableWrapper_setPrototypeOf(o, p); }
function tableWrapper_createSuper(Derived) { var hasNativeReflectConstruct = tableWrapper_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = tableWrapper_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = tableWrapper_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return tableWrapper_possibleConstructorReturn(this, result); }; }
function tableWrapper_possibleConstructorReturn(self, call) { if (call && (tableWrapper_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return tableWrapper_assertThisInitialized(self); }
function tableWrapper_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function tableWrapper_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function tableWrapper_getPrototypeOf(o) { tableWrapper_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return tableWrapper_getPrototypeOf(o); }
function tableWrapper_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var ALIGNS = ['left', 'center', 'right', 'full-width'];
function getAlignClass(align) {
  return 'table-align-' + align;
}
var tableWrapper_mixin = mix([dropAcceptor, basic]);
var TableWrapper = /*#__PURE__*/function (_mixin) {
  tableWrapper_inherits(TableWrapper, _mixin);
  var _super = tableWrapper_createSuper(TableWrapper);
  function TableWrapper(domNode) {
    var _this;
    tableWrapper_classCallCheck(this, TableWrapper);
    _this = _super.call(this, domNode);
    tableWrapper_defineProperty(tableWrapper_assertThisInitialized(_this), "onTableWrapperMouseDown", function (event) {
      if (event.target == _this.domNode) {
        event.preventDefault();
        if (_this.table.domNode.classList.contains('focused-block')) {
          _this.table.unselectAllCells();
          return false;
        } else {
          _this.table.embeddableFocus();
        }
      }
    });
    tableWrapper_defineProperty(tableWrapper_assertThisInitialized(_this), "renderCaptionMargin", function () {
      var columns = _this.table.columns.length;
      var parentNode = _this.table.domNode.parentNode;
      var noSummaries = _this.caption.domNode.classList.contains('no-summaries');
      var mode = _this.table.getSummariesMode();
      if (!mode) {
        var tableWidth = _this.table.domNode.offsetWidth;
        var isGrid = _this.domNode.parentNode.classList.contains('grid');
        var scrolitemsWidth = parentNode && parentNode.offsetWidth || 0;
        var lastRowSelected = _this.table.domNode.classList.contains('last-row-selected');
        var focused = _this.table.domNode.classList.contains('focused-table');
        var setMarginCaption = false;
        if (tableWidth <= scrolitemsWidth) {
          setMarginCaption = true;
        }
        if (setMarginCaption && (!isGrid && columns > 2 || isGrid) && (!lastRowSelected || !focused)) {
          if (columns < 5 && !isGrid && _this.domNode.offsetWidth > 1000) {
            if (noSummaries) {
              _this.caption.domNode.classList.remove('no-summaries');
            }
          } else {
            if (!noSummaries) {
              _this.caption.domNode.classList.add('no-summaries');
            }
          }
        } else {
          if (noSummaries) {
            _this.caption.domNode.classList.remove('no-summaries');
          }
        }
      } else {
        if (noSummaries) {
          _this.caption.domNode.classList.remove('no-summaries');
        }
      }
    });
    _this.domNode.classList.add('embed-wrapper');
    _this.domNode.classList.add('table-wrapper');
    _this.table = null;
    _this._animationTimeout = null;
    return _this;
  }
  tableWrapper_createClass(TableWrapper, [{
    key: "id",
    get: function get() {
      return this.map.get('id');
    }
  }, {
    key: "getWrappedBlot",
    value: function getWrappedBlot() {
      return this.table;
    }
  }, {
    key: "setDomNodeAttribute",
    value: function setDomNodeAttribute(key, value) {
      if (key === 'id') {
        // враппер не должен содержать аттрибута ID у DOM элемента, чтобы избежать неуникальных айди в документе
        return;
      }
      this.domNode.setAttribute(key, value);
    }
  }, {
    key: "attach",
    value: function attach() {
      tableWrapper_get(tableWrapper_getPrototypeOf(TableWrapper.prototype), "attach", this).call(this);
      if (this.table) {
        return;
      }
      this.table = parchment_default().create('table');
      this.table.map = this.map;
      this.appendChild(this.table);
      var CaptionMap = this.map.get('caption');
      if (CaptionMap) {
        this.caption = parchment_default().create('caption');
        this.caption.map = this.store.getMap(this.map.get('caption'));
        this.caption.scroll = this.scroll;
        this.caption.embedBlot = this.table;
      }
      if (this.caption) {
        this.appendChild(this.caption);
      }
      if (this.editor.mode === this.editor.constructor.MODE_EDIT || this.table.wrapCellsMode === false) {
        this.mouseEvents();
        this.domNode.addEventListener('mousedown', this.onTableWrapperMouseDown, false);
      }
    }
  }, {
    key: "detach",
    value: function detach() {
      tableWrapper_get(tableWrapper_getPrototypeOf(TableWrapper.prototype), "detach", this).call(this);
      this.domNode.removeEventListener('mousedown', this.onTableWrapperMouseDown, false);
    }
  }, {
    key: "addBlot",
    value: function addBlot() {
      var _this$parent;
      (_this$parent = this.parent).addBlot.apply(_this$parent, arguments);
    }
  }, {
    key: "mouseEvents",
    value: function mouseEvents() {
      var _this2 = this;
      var mouseleave = function mouseleave(event) {
        var blockRect = event.target.getBoundingClientRect();
        var block = {
          left: blockRect.left,
          top: blockRect.top,
          right: blockRect.right,
          bottom: blockRect.bottom
        };
        var mouse = {
          x: event.clientX,
          y: event.clientY
        };
        var childs = [].slice.call(_this2.domNode.getElementsByClassName('col-resizing'));
        var childsRow = [].slice.call(_this2.domNode.getElementsByClassName('row-resizing'));
        var row = _this2.domNode.getElementsByTagName('tr')[0];
        var rowRect = row.getBoundingClientRect();
        var table = _this2.table;
        var colspan, rowspan;
        if (childs[0]) {
          colspan = Number(childs[0].getAttribute('colspan'));
        }
        if (childsRow[0]) {
          rowspan = Number(childsRow[0].getAttribute('rowspan'));
        }
        var column = table.colgroup.getByIndex(table.colgroup.index - 1);

        //need resize
        if (mouse.x > block.right) {
          var raz = blockRect.width - rowRect.width;
          var width = Number(column.domNode.getAttribute('width')) + raz;
          column.domNode.setAttribute('width', width);
        } else if (mouse.x < block.left) {
          var _raz = blockRect.width - rowRect.width;
          var _width = 10;
          column.domNode.setAttribute('width', _width);
        }

        //need mouseup
        if (mouse.y < block.top) {} else if (mouse.y > block.bottom) {}
        childs.map(function (child) {
          var event = new Event("mouseup");
          child.dispatchEvent(event);
        });
        childsRow.map(function (child) {
          var event = new Event("mouseup");
          child.dispatchEvent(event);
        });
        _this2.domNode.removeEventListener('mouseleave', mouseleave);
      };
    }
  }, {
    key: "render",
    value: function render() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var color = props.color || 'transparent';
      var focused = props.hasOwnProperty('focused') ? props.focused : true;
      var alignClass = getAlignClass(props.align || 'left');
      var containAlignClass = this.domNode.classList.contains(alignClass);
      var isFullwidth = this.table.fullWidth && this.table.isFullwidth;
      if (!containAlignClass || isFullwidth) {
        var _iterator = tableWrapper_createForOfIteratorHelper(ALIGNS),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var align = _step.value;
            this.domNode.classList.remove(getAlignClass(align));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      if (!containAlignClass && !isFullwidth) {
        this.domNode.classList.add(alignClass);
      }
      if (stringIsColor(color)) {
        this.domNode.style.backgroundColor = color;
      } else {
        this.domNode.style.removeProperty('background-color');
        this.domNode.setAttribute('data-block-background', color);
      }
      if (focused) {
        this.domNode.classList.add('focused-wrap');
      } else {
        this.domNode.classList.remove('focused-wrap');
      }
      if (this.caption) {
        this.caption.render();
        //this.renderCaptionMargin()
      }
    }
  }, {
    key: "getInnerTextLine",
    value: function getInnerTextLine() {
      return this.caption;
    }
  }, {
    key: "getChildBlotsForExec",
    value: function getChildBlotsForExec() {
      return [this.table];
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      var editor = this.editor;
      var node = this.domNode.cloneNode(true);
      var matches = tableWrapper_toConsumableArray(node.outerHTML.matchAll(/data-file-export="(.*?)\.end"/g));
      var attachesFromHTML = [];
      if (!context.options.noAttachments) {
        if (matches && matches.length > 0) {
          matches.forEach(function (item) {
            attachesFromHTML.push(item[1]);
          });
        }
      }
      if (attachesFromHTML.length > 0) {
        attachesFromHTML.forEach(function (attach_id) {
          var attachmentBlot = editor.findById(attach_id);
          if (attachmentBlot) {
            context.addAttachment(attachmentBlot.props.attachment);
            var fileNode = attachmentBlot.domNode;
            if (context.options.toEmail) {
              var vcontent = fileNode.querySelector('.compact-view-content');
              vcontent.style.display = 'flex';
              vcontent.style.border = '1px solid #c8c8c8';
              vcontent.style.borderRadius = '4px';
              var size = fileNode.querySelector('.file-size');
              size.remove();
            }
            var filePath = context.getAttachmentPath(attachmentBlot.props.attachment);
            var link = document.createElement('a');
            link.setAttribute('href', filePath);
            link.setAttribute('target', '_blank');
            var fileName = fileNode.querySelector('.file-name');
            Array.from(fileName.childNodes).map(function (child) {
              link.appendChild(child);
            });
            fileName.appendChild(link);
          }
        });
      }
      if (context.options.noAttachments) {
        var attachments = this.domNode.getElementsByClassName('table-attachment');
        for (var i = 0; i < attachments.length; i++) {
          attachments[i].innerHTML = '';
        }
      }
      node = this.domNode.cloneNode(true);
      node.classList.add('export');
      if (context.options.pdf) {
        node.classList.add('export-pdf');
      }
      var table = node.getElementsByTagName('table')[0];
      if (!context.options.toEmail) {
        var colgroup = table.getElementsByTagName('colgroup')[0];
        if (colgroup && colgroup.insertBefore) {
          for (var _i = 0; _i < 2; _i++) {
            colgroup.insertBefore(document.createElement('col'), colgroup.getElementsByTagName('col')[0]);
          }
        }
      } else {
        table.style = 'border-spacing: 0;';
      }
      // Добавляем хедеры строк и отсутп
      var rowHeader = node.getElementsByClassName('table-toolbar-row-header');
      if (rowHeader.length) {
        rowHeader[0].remove();
      }
      var r = 1;
      for (var _i2 = 0, _arr = ['tbody', 'tfoot']; _i2 < _arr.length; _i2++) {
        var mode = _arr[_i2];
        var rows = void 0;
        if (mode === 'tbody') {
          rows = table.tBodies[0].rows;
        } else if (mode === 'tfoot') {
          if (table.tFoot && table.tFoot.rows.length) {
            rows = table.tFoot.rows;
          } else {
            continue;
          }
        }
        var _iterator2 = tableWrapper_createForOfIteratorHelper(rows),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var row = _step2.value;
            var div = document.createElement('div');
            div.classList.add('cell-head-item');
            div.style.whiteSpace = 'nowrap';
            if (context.options.pdf) {
              div.classList.add('border-top-width');
            }
            if (mode === 'tbody') {
              div.innerHTML = r++;
            }
            if (context.options.toEmail) {
              for (var _i3 = 0; _i3 < row.children.length; _i3++) {
                var td = row.children[_i3];
                if (td.className === 'cell-head') {
                  td.style = "text-align:center; border: 1px solid #c8c8c8;";
                } else if (td.className !== 'cell-margin') {
                  td.style = "border: 1px solid #c8c8c8;";
                }
                if (mode === 'tfoot') {
                  if (td.children[0] && td.children[0].className === 'summaries-group') {
                    var _div = td.children[0].children[0];
                    _div.style = "display: flex;";
                  }
                }
              }
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      var caption = node.getElementsByClassName('attachment-caption')[0];
      if (caption && caption.textContent && caption.textContent.trim() !== '') {
        caption.style.width = '100%';
        caption.classList.remove('empty-caption-hidden');
      }
      var colHeader = node.getElementsByClassName('table-toolbar-col-header');
      if (context.options.pdf) {
        if (colHeader.length) {
          var isHiddenColHeader = node.classList.contains('hide-col-header');
          var tr = document.createElement('tr');
          var td1 = document.createElement('td');
          var td2 = document.createElement('td');
          td1.classList.add('col-header-pdf');
          td1.classList.add('cell-margin');
          td2.classList.add('col-header-pdf');
          td2.classList.add('cell-margin');
          tr.appendChild(td1);
          tr.appendChild(td2);
          var _iterator3 = tableWrapper_createForOfIteratorHelper(colHeader[0].children),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var item = _step3.value;
              var _td = document.createElement('td');
              _td.classList.add('col-header-pdf');
              _td.innerHTML = item.innerHTML;
              tr.appendChild(_td);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          if (isHiddenColHeader) {
            tr.classList.add('tr-hidden');
          }
          table.tBodies[0].insertBefore(tr, table.tBodies[0].firstChild);
          colHeader[0].remove();
        }
        var tfoot = node.getElementsByTagName('tfoot');
        var trFoot = tfoot[0].children[0];
        trFoot.classList.add('pdf-tr-foot');
        if (context.options.papperFormat === 'A5') {
          trFoot.classList.add('A5');
        }
        trFoot.firstChild.classList.remove('cell-head');
        trFoot.firstChild.classList.add('cell-margin');
        trFoot.firstChild.innerHTML = '';
        table.tBodies[0].appendChild(trFoot, table.tBodies[0].lastChild);
        tfoot[0].remove();
      }
      if (context.options.toEmail) {
        if (colHeader.length) {
          var _colgroup = table.getElementsByTagName('colgroup')[0];
          var thead = document.createElement('thead');
          for (var _i4 = 0; _i4 < 2; _i4++) {
            var th = document.createElement('th');
            thead.appendChild(th);
            var col = document.createElement('col');
            col.width = 20;
            _colgroup.insertBefore(col, _colgroup.getElementsByTagName('col')[0]);
          }
          var _iterator4 = tableWrapper_createForOfIteratorHelper(colHeader[0].children),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _item = _step4.value;
              var _th = document.createElement('th');
              _th.setAttribute('style', 'border: 1px solid #c8c8c8;');
              _th.innerHTML = _item.innerHTML;
              thead.appendChild(_th);
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          table.insertBefore(thead, table.tBodies[0]);
          colHeader[0].remove();
        }
      }
      return node.outerHTML;
    }
  }]);
  return TableWrapper;
}(tableWrapper_mixin(container_Container));
TableWrapper.blotName = 'tableWrapper';
TableWrapper.allowedChildren = [table_table, Caption];
TableWrapper.tagName = 'DIV';
TableWrapper.scope = (parchment_default()).Scope.BLOCK_BLOT;
/* harmony default export */ const tableWrapper = (TableWrapper);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/setAlign.js
function setAlign_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { setAlign_typeof = function _typeof(obj) { return typeof obj; }; } else { setAlign_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return setAlign_typeof(obj); }









function setAlign_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function setAlign_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) setAlign_setPrototypeOf(subClass, superClass); }
function setAlign_setPrototypeOf(o, p) { setAlign_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return setAlign_setPrototypeOf(o, p); }
function setAlign_createSuper(Derived) { var hasNativeReflectConstruct = setAlign_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = setAlign_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = setAlign_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return setAlign_possibleConstructorReturn(this, result); }; }
function setAlign_possibleConstructorReturn(self, call) { if (call && (setAlign_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return setAlign_assertThisInitialized(self); }
function setAlign_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function setAlign_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function setAlign_getPrototypeOf(o) { setAlign_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return setAlign_getPrototypeOf(o); }

var SetAlignAction = /*#__PURE__*/function (_Action) {
  setAlign_inherits(SetAlignAction, _Action);
  var _super = setAlign_createSuper(SetAlignAction);
  function SetAlignAction(type, params, editor) {
    setAlign_classCallCheck(this, SetAlignAction);
    type = type || SetAlignAction.type;
    return _super.call(this, type, params, editor);
  }
  return SetAlignAction;
}(Action);

SetAlignAction.type = 'set-align';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/mixins/alignable.js
function alignable_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { alignable_typeof = function _typeof(obj) { return typeof obj; }; } else { alignable_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return alignable_typeof(obj); }
function alignable_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
















function alignable_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function alignable_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function alignable_createClass(Constructor, protoProps, staticProps) { if (protoProps) alignable_defineProperties(Constructor.prototype, protoProps); if (staticProps) alignable_defineProperties(Constructor, staticProps); return Constructor; }
function alignable_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { alignable_get = Reflect.get; } else { alignable_get = function _get(target, property, receiver) { var base = alignable_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return alignable_get(target, property, receiver || target); }
function alignable_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = alignable_getPrototypeOf(object); if (object === null) break; } return object; }
function alignable_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) alignable_setPrototypeOf(subClass, superClass); }
function alignable_setPrototypeOf(o, p) { alignable_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return alignable_setPrototypeOf(o, p); }
function alignable_createSuper(Derived) { var hasNativeReflectConstruct = alignable_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = alignable_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = alignable_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return alignable_possibleConstructorReturn(this, result); }; }
function alignable_possibleConstructorReturn(self, call) { if (call && (alignable_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return alignable_assertThisInitialized(self); }
function alignable_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function alignable_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function alignable_getPrototypeOf(o) { alignable_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return alignable_getPrototypeOf(o); }


/**
 * Конфигурация миксина
 * @constant
 * @default
 * @memberof Alignable
 * @prop { string } action - имя action
 * @prop { string } key - ключ значения в map блота
 * @prop { string } default - значение по умолчанию
 * @prop { array<string> } allow - разрешенные значения
 */
var alignable_CONFIG = {
  action: SetAlignAction.type,
  key: 'align',
  default: 'left',
  allow: ['left', 'right', 'center', 'justify']
};

/**
 * Миксин, добавляющий блоту функционал выравнивания<br>
 * Включает в меню блока опции выравнивания<br>
 * Устанавливает в map блота значение выравнивания по ключу CONFIG.key
 * @mixin
 */
var Alignable = function Alignable(superclass) {
  return /*#__PURE__*/function (_superclass) {
    alignable_inherits(_class, _superclass);
    var _super = alignable_createSuper(_class);
    /**
     * Конструктор
     * @param { any } ...args
     * @memberof Alignable
     * @constructs
     */
    function _class() {
      var _this;
      alignable_classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _this.addCanExecActions([alignable_CONFIG.action]);
      return _this;
    }
    /**
     * Геттер, включает в меню блока элементы выравнивания
     * @memberof Alignable
     * @kind function
     * @returns { object }
     */
    alignable_createClass(_class, [{
      key: "contextMenu",
      get: function get() {
        var menu = alignable_get(alignable_getPrototypeOf(_class.prototype), "contextMenu", this);
        Object.assign(menu, {
          align: true
        });
        return menu;
      }
      /**
       * Геттер, возвращает значение выравнивания блота<br>
       * Если значение не установлено, возвращает дефолтное
       * @memberof Alignable
       * @returns { string }
       */
    }, {
      key: "align",
      get: function get() {
        return this.map.get(alignable_CONFIG.key) || alignable_CONFIG.default;
      }
      /**
       * Сеттер, устанавливает выравнивание блота<br>
       * Если передано дефолтное значение то удаляет align из map
       * @memberof Alignable
       * @kind function
       * @param { string } align - устанавливаемое значение выравнивания
       */,
      set: function set(align) {
        if (align === void 0) {
          align = alignable_CONFIG.default;
        }
        if (!alignable_CONFIG.allow.includes(align)) {
          console.warn('Attempt to set invalid align:', align);
        } else if (align === alignable_CONFIG.default) {
          this.map.delete(alignable_CONFIG.key);
        } else {
          this.map.set(alignable_CONFIG.key, align);
        }
      }
      /**
       * Установка выравнивания через action
       * @memberof Alignable
       * @param { any } ...args аргументы
       * @returns { object }
       */
    }, {
      key: "exec",
      value: function exec(action) {
        var processed = alignable_get(alignable_getPrototypeOf(_class.prototype), "exec", this) ? alignable_get(alignable_getPrototypeOf(_class.prototype), "exec", this).call(this, action) : false;
        if (action.type === alignable_CONFIG.action) {
          this.align = action.params;
          processed = true;
        }
        return processed;
      }
      /**
       * Возвращает парамеметры блота при копировании<br>
       * Добавляет к параметрам значение выравнивания
       * @memberof Alignable
       * @param { any } ...args аргументы
       * @returns { object }
       */
    }, {
      key: "getBlotInsertParams",
      value: function getBlotInsertParams() {
        var _get2;
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        var params = (_get2 = alignable_get(alignable_getPrototypeOf(_class.prototype), "getBlotInsertParams", this)).call.apply(_get2, [this].concat(args));
        var align = this.align;
        if (align !== alignable_CONFIG.default) {
          params.initParams = Object.assign(params.initParams || {}, alignable_defineProperty({}, alignable_CONFIG.key, align));
        }
        return params;
      }
      /**
       * Добавляет выравнивание блота при клонировании
       * @memberof Alignable
       * @returns { object }
       */
    }, {
      key: "getCloneParams",
      value: function getCloneParams() {
        var _get3;
        var cloneParams = ((_get3 = alignable_get(alignable_getPrototypeOf(_class.prototype), "getCloneParams", this)) === null || _get3 === void 0 ? void 0 : _get3.call(this)) || {};
        var align = this.align;
        if (align !== alignable_CONFIG.default) {
          cloneParams[alignable_CONFIG.key] = align;
        }
        return cloneParams;
      }
    }]);
    return _class;
  }(superclass);
};

/**
 * Инициализация map для миксина
 * @param { Ymap } map - map блока
 * @param { object } store - store
 * @param { object } params - параметры инициализации
 * @param { object } [params.align] - вырвавнивание
 * @memberof Alignable
 */
Alignable.initMap = function (map, store) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (params.hasOwnProperty(alignable_CONFIG.key) && alignable_CONFIG.allow.includes(params[alignable_CONFIG.key])) {
    map.set(alignable_CONFIG.key, params[alignable_CONFIG.key]);
  }
};
/* harmony default export */ const alignable = (Alignable);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/mixins/colorsConfigurable.js
function colorsConfigurable_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { colorsConfigurable_typeof = function _typeof(obj) { return typeof obj; }; } else { colorsConfigurable_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return colorsConfigurable_typeof(obj); }
function colorsConfigurable_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = colorsConfigurable_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function colorsConfigurable_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return colorsConfigurable_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return colorsConfigurable_arrayLikeToArray(o, minLen); }
function colorsConfigurable_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function colorsConfigurable_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






















function colorsConfigurable_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function colorsConfigurable_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function colorsConfigurable_createClass(Constructor, protoProps, staticProps) { if (protoProps) colorsConfigurable_defineProperties(Constructor.prototype, protoProps); if (staticProps) colorsConfigurable_defineProperties(Constructor, staticProps); return Constructor; }
function colorsConfigurable_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { colorsConfigurable_get = Reflect.get; } else { colorsConfigurable_get = function _get(target, property, receiver) { var base = colorsConfigurable_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return colorsConfigurable_get(target, property, receiver || target); }
function colorsConfigurable_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = colorsConfigurable_getPrototypeOf(object); if (object === null) break; } return object; }
function colorsConfigurable_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) colorsConfigurable_setPrototypeOf(subClass, superClass); }
function colorsConfigurable_setPrototypeOf(o, p) { colorsConfigurable_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return colorsConfigurable_setPrototypeOf(o, p); }
function colorsConfigurable_createSuper(Derived) { var hasNativeReflectConstruct = colorsConfigurable_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = colorsConfigurable_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = colorsConfigurable_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return colorsConfigurable_possibleConstructorReturn(this, result); }; }
function colorsConfigurable_possibleConstructorReturn(self, call) { if (call && (colorsConfigurable_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return colorsConfigurable_assertThisInitialized(self); }
function colorsConfigurable_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function colorsConfigurable_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function colorsConfigurable_getPrototypeOf(o) { colorsConfigurable_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return colorsConfigurable_getPrototypeOf(o); }
/**
 * Конфигурация цветов
 * @constant
 * @default
 * @memberof ColorsConfigurable
 * @prop { string } key - ключ значения в map блота
 * @prop { string } action - имя action
 * @prop { string } default - значение по умолчанию
 * @prop { string } i18n - строка локализации для пункта меню
 */
var COLORS = [{
  key: 'borderColor',
  action: 'set-border-color',
  attribute: 'data-border-color',
  default: 'transparent',
  i18n: 'outline.context_menu.style.border_color'
}, {
  key: 'lineColor',
  action: 'set-line-color',
  attribute: 'data-line-color',
  default: 'transparent',
  i18n: 'block_menu.color.line_color'
}];

/**
 * Миксин, добавляющий блоту функционал установки дополнительных цветов<br>
 * Добавляет в меню блока субменю с необходимыми цветами<br>
 * Устанавливает в map блота значение цвета по ключу COLORS[].key
 * @mixin
 */
var ColorsConfigurable = function ColorsConfigurable(superclass) {
  return /*#__PURE__*/function (_superclass) {
    colorsConfigurable_inherits(_class, _superclass);
    var _super = colorsConfigurable_createSuper(_class);
    /**
     * Конструктор
     * @param { node } domNode
     * @param { object } params
     * @param { array } params.colorsConfig - перечень используемых в блоте цветов, COLORS[].key
     * @memberof ColorsConfigurable
     * @constructs
     */
    function _class(domNode) {
      var _this;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      colorsConfigurable_classCallCheck(this, _class);
      _this = _super.call(this, domNode, params);
      _this.colorsAvailable = COLORS.filter(function (item) {
        var _params$colorsConfig;
        return (_params$colorsConfig = params.colorsConfig) === null || _params$colorsConfig === void 0 ? void 0 : _params$colorsConfig.includes(item.key);
      });
      _this.addCanExecActions(_this.colorsAvailable.reduce(function (result, item) {
        result.push(item.action);
        return result;
      }, []));
      return _this;
    }
    /**
     * Геттер, добавляет в меню блока субменю с необходимыми цветами
     * @memberof ColorsConfigurable
     * @kind function
     * @returns { object }
     */
    colorsConfigurable_createClass(_class, [{
      key: "contextMenu",
      get: function get() {
        var _this2 = this;
        var menu = colorsConfigurable_get(colorsConfigurable_getPrototypeOf(_class.prototype), "contextMenu", this);
        var i18n = this.editor.plugins.i18n;
        var colorsMenu = this.colorsAvailable.reduce(function (result, item) {
          var name = item.action.replace('set', 'change');
          result[name] = {
            index: 0,
            group: 0,
            stackable: false,
            action: 'change-color',
            submenu: 'ColorPicker',
            label: i18n.get(item.i18n),
            colorPickerParams: {
              execAction: item.action,
              defaultColor: 'transparent',
              closeOnChoice: false,
              getSelectedColor: function getSelectedColor() {
                return _this2.colorsConfig[item.key];
              }
            }
          };
          return result;
        }, {});
        return Object.assign(menu, colorsMenu);
      }
      /**
       * Геттер, возвращает массив со значениям цветов<br>
       * Если значение цвета не установлено, возвращает дефолтное
       * @memberof ColorsConfigurable
       * @returns { object }
       */
    }, {
      key: "colorsConfig",
      get: function get() {
        var _this3 = this;
        return this.colorsAvailable.reduce(function (result, item) {
          Object.assign(result, colorsConfigurable_defineProperty({}, item.key, _this3.map.get(item.key) || item.default));
          return result;
        }, {});
      }
      /**
       * Устанавливает значение цвета<br>
       * Если передано дефолтное значение то удаляет из map
       * @memberof ColorsConfigurable
       * @kind function
       * @param { string } key - ключ цвета ( COLORS[].key )
       * @param { string } value - значение
       */
    }, {
      key: "setColorConfig",
      value: function setColorConfig(key, value) {
        console.info('setColorConfig', key, value);
        var _iterator = colorsConfigurable_createForOfIteratorHelper(this.colorsAvailable),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            if (key === item.key) {
              if (!value || value === item.default) {
                this.map.delete(item.key);
              } else {
                this.map.set(item.key, value);
              }
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      /**
       * При рендере добавляем значения цветов как атрибуты domNode
       * @memberof ColorsConfigurable
       */
    }, {
      key: "render",
      value: function render() {
        var _this4 = this;
        colorsConfigurable_get(colorsConfigurable_getPrototypeOf(_class.prototype), "render", this).call(this);
        var colorsConfig = this.colorsConfig;
        this.colorsAvailable.map(function (item) {
          var value = colorsConfig[item.key];
          if (value && value !== 'transparent') {
            _this4.domNode.setAttribute(item.attribute, value);
          } else {
            _this4.domNode.removeAttribute(item.attribute);
          }
        });
      }

      /**
       * Установка цветов через action
       * @memberof ColorsConfigurable
       * @param { any } ...args аргументы
       * @returns { object }
       */
    }, {
      key: "exec",
      value: function exec(action) {
        var processed = colorsConfigurable_get(colorsConfigurable_getPrototypeOf(_class.prototype), "exec", this) ? colorsConfigurable_get(colorsConfigurable_getPrototypeOf(_class.prototype), "exec", this).call(this, action) : false;
        var _iterator2 = colorsConfigurable_createForOfIteratorHelper(this.colorsAvailable),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            if (action.type === item.action) {
              this.setColorConfig(item.key, action.params);
              processed = true;
              break;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        return processed;
      }
      /**
       * Возвращает парамеметры блота при копировании<br>
       * Добавляем к параметрам значения цветов
       * @memberof ColorsConfigurable
       * @param { any[] } ...args - аргументы
       * @returns { object }
       */
    }, {
      key: "getBlotInsertParams",
      value: function getBlotInsertParams() {
        var _get2;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        var params = (_get2 = colorsConfigurable_get(colorsConfigurable_getPrototypeOf(_class.prototype), "getBlotInsertParams", this)).call.apply(_get2, [this].concat(args));
        params.initParams = Object.assign(params.initParams || {}, this.colorsConfig);
        return params;
      }
      /**
       * Добавляет цвета блота при клонировании
       * @memberof ColorsConfigurable
       * @returns { object }
       */
    }, {
      key: "getCloneParams",
      value: function getCloneParams() {
        var _get3;
        var cloneParams = ((_get3 = colorsConfigurable_get(colorsConfigurable_getPrototypeOf(_class.prototype), "getCloneParams", this)) === null || _get3 === void 0 ? void 0 : _get3.call(this)) || {};
        Object.assign(cloneParams, this.colorsConfig);
        return cloneParams;
      }
    }]);
    return _class;
  }(superclass);
};

/**
 * Инициализация map для миксина
 * @param { Ymap } map - map блока
 * @param { object } store - store
 * @param { object } params - параметры инициализации
 * @param { string } [params.COLOR_KEY] - цвета из COLORS[].key
 * @memberof ColorsConfigurable
 */
ColorsConfigurable.initMap = function (map, store) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  COLORS.map(function (item) {
    if (params.hasOwnProperty(item.key)) {
      map.set(item.key, params[item.key]);
    }
  });
};
/* harmony default export */ const colorsConfigurable = (ColorsConfigurable);
// EXTERNAL MODULE: ./node_modules/@lib/editor/node_modules/lib0/mutex.js
var mutex = __webpack_require__(70494);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/quillBinding.js
function quillBinding_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function quillBinding_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function quillBinding_createClass(Constructor, protoProps, staticProps) { if (protoProps) quillBinding_defineProperties(Constructor.prototype, protoProps); if (staticProps) quillBinding_defineProperties(Constructor, staticProps); return Constructor; }
/**
 * @module bindings/quill
 */


var typeObserver = function typeObserver(event) {
  var quill = this.target;
  var beforeState = event.transaction.beforeState;
  var typeId = this.type._item.id;
  if (beforeState && (!beforeState.get(typeId.client) || beforeState.get(typeId.client) < typeId.clock)) {
    // ignore this event because the type was created in this transaction and should have actual content on the first render
    return;
  }
  var origin = 'yjs';
  if (event.transaction.origin && event.transaction.origin === 'remote') {
    origin = 'remote';
  }
  // Force flush Quill changes.
  quill.update(origin);
  this._mutualExclude(function () {
    // Apply computed delta.
    quill.updateContents(event.delta, origin);
    // Force flush Quill changes. Ignore applied changes.
    quill.update(origin);
  });
};
var quillObserver = function quillObserver(delta) {
  var _this = this;
  this._mutualExclude(function () {
    _this.type.applyDelta(delta.ops);
  });
};

/**
 * A Binding that binds a YText type to a Quill editor.
 *
 * @example
 * const quill = new Quill(document.createElement('div'))
 * const type = y.define('quill', Y.Text)
 * const binding = new Y.QuillBinding(quill, type)
 * // Now modifications on the DOM will be reflected in the Type, and the other
 * // way around!
 */
var QuillBinding = /*#__PURE__*/function () {
  /**
   * @param {YText} textType
   * @param {Quill} quill
   * @param {awareness} awareness
   */
  function QuillBinding(textType, quill) {
    quillBinding_classCallCheck(this, QuillBinding);
    // Binding handles textType as this.type and quill as this.target.
    /**
     * The Yjs type that is bound to `target`
     * @type {YText}
     */
    this.type = textType;
    /**
     * The target that `type` is bound to.
     * @type {Quill}
     */
    this.target = quill;
    /**
     * @private
     */
    this._mutualExclude = (0,mutex/* createMutex */.M)();
    this.scroll = quill.scroll;
  }
  quillBinding_createClass(QuillBinding, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      // Set initial value.
      var delta;
      // wrap getting delta in a transaction because yjs under the hood runs its own transaction for snapshots
      // in YText.toDelta which causes to some operation appear in the wrong transaction(that one that is created in the toDelta)
      // considering current transaction cleanup implementation in yjs
      this.type.doc.transact(function () {
        delta = _this2.type.toDelta();
      });
      // Observers are handled by this class.
      this._typeObserver = typeObserver.bind(this);
      this._quillObserver = quillObserver.bind(this);
      this.type.observe(this._typeObserver);
      this.target.on('text-change', this._quillObserver);
      // Set initial value.
      this._mutualExclude(function () {
        _this2.target.setContents(_this2.type.toDelta(), 'yjs');
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      // Remove everything that is handled by this class.
      if (this.type) {
        this.type.unobserve(this._typeObserver);
      }
      if (this.target) {
        this.target.off('text-change', this._quillObserver);
      }
      this.type = null;
      this.target = null;
    }
  }]);
  return QuillBinding;
}();
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/text/newTextBase.js
function newTextBase_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = newTextBase_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function newTextBase_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { newTextBase_typeof = function _typeof(obj) { return typeof obj; }; } else { newTextBase_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return newTextBase_typeof(obj); }
function newTextBase_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function newTextBase_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { newTextBase_ownKeys(Object(source), true).forEach(function (key) { newTextBase_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { newTextBase_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function newTextBase_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function newTextBase_slicedToArray(arr, i) { return newTextBase_arrayWithHoles(arr) || newTextBase_iterableToArrayLimit(arr, i) || newTextBase_unsupportedIterableToArray(arr, i) || newTextBase_nonIterableRest(); }
function newTextBase_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function newTextBase_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return newTextBase_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return newTextBase_arrayLikeToArray(o, minLen); }
function newTextBase_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function newTextBase_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function newTextBase_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



























function newTextBase_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function newTextBase_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function newTextBase_createClass(Constructor, protoProps, staticProps) { if (protoProps) newTextBase_defineProperties(Constructor.prototype, protoProps); if (staticProps) newTextBase_defineProperties(Constructor, staticProps); return Constructor; }
function newTextBase_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { newTextBase_get = Reflect.get; } else { newTextBase_get = function _get(target, property, receiver) { var base = newTextBase_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return newTextBase_get(target, property, receiver || target); }
function newTextBase_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = newTextBase_getPrototypeOf(object); if (object === null) break; } return object; }
function newTextBase_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) newTextBase_setPrototypeOf(subClass, superClass); }
function newTextBase_setPrototypeOf(o, p) { newTextBase_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return newTextBase_setPrototypeOf(o, p); }
function newTextBase_createSuper(Derived) { var hasNativeReflectConstruct = newTextBase_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = newTextBase_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = newTextBase_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return newTextBase_possibleConstructorReturn(this, result); }; }
function newTextBase_possibleConstructorReturn(self, call) { if (call && (newTextBase_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return newTextBase_assertThisInitialized(self); }
function newTextBase_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function newTextBase_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function newTextBase_getPrototypeOf(o) { newTextBase_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return newTextBase_getPrototypeOf(o); }


















var EMPTY_LINE_LENGTH = 1;

// Новый текстовый блот, сам не подписан на апдейты scroll блота,
// таким образом мы избегаем лишних вызовов фукнций и работы кода,
// вместо этого в scroll блоте были сделаны изменения,
// которые вызывают update в этом блоте если в нем произошли какие то изменения.

// TODO: этот блот в будущем можно использовать как базовый для текста,
// все что он будет уметь - синхронизировать контент с yText.
// Базовые функции для его работы я пометил как base
var NewTextBase = /*#__PURE__*/function (_Parchment$Block) {
  newTextBase_inherits(NewTextBase, _Parchment$Block);
  var _super = newTextBase_createSuper(NewTextBase);
  function NewTextBase(domNode) {
    var _this;
    newTextBase_classCallCheck(this, NewTextBase);
    // base
    _this = _super.call(this, domNode);
    _this.isText = true;
    _this.cache = {
      length: null
    };
    _this.emitter = new emitter();
    domNode.classList.add('editable-text');
    return _this;
  }
  newTextBase_createClass(NewTextBase, [{
    key: "editor",
    get: function get() {
      // base
      return this.scroll.editor;
    }
  }, {
    key: "selection",
    get: function get() {
      // base
      return this.scroll.selection;
    }
  }, {
    key: "container",
    get: function get() {
      // base
      return this.parent.container;
    }
  }, {
    key: "attach",
    value: function attach() {
      var _get2,
        _this2 = this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      // base
      (_get2 = newTextBase_get(newTextBase_getPrototypeOf(NewTextBase.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      if (this.characters) {
        this._quillBinding = new QuillBinding(this.characters, this);
        this._quillBinding.init();
      }
      if (this.editor.isEditable()) {
        this.domNode.setAttribute('contenteditable', true);
        this.domNode.style.whiteSpace = 'pre-wrap'; // фиксит события удаления, когда символ и пробел удаляются вместе
      }

      this.scroll.emitter.on('SCROLL_UPDATE', function (source, mutations, updatedBlots) {
        if (!updatedBlots.has(_this2) && !updatedBlots.has(_this2.parent)) {
          return;
        }
        newTextBase_modify.call(_this2, function () {
          return _this2.updateBlot();
        }, source);
      });
    }
  }, {
    key: "applyDelta",
    value: function applyDelta(delta) {
      var _this3 = this;
      // base
      this.scroll.execInBatch(function () {
        var normalizedDelta = normalizeDelta(delta, {
          trimNewLines: true
        });
        // обарабатываем операции вставки
        var deleteDelta = new (Delta_default())();
        normalizedDelta.reduce(function (index, op) {
          var length = dist_Delta.Op.length(op);
          var attributes = op.attributes || {};
          if (op.insert) {
            deleteDelta.retain(length);
            if (typeof op.insert === 'string') {
              var text = op.insert;
              text = text.replace(/[\n]/g, '');
              if (text) {
                _this3.insertAt(index, text);
                var _this3$descendant = _this3.descendant((parchment_default()).Leaf, index),
                  _this3$descendant2 = newTextBase_slicedToArray(_this3$descendant, 1),
                  leaf = _this3$descendant2[0];
                var formats = newTextBase_objectSpread({}, newTextBase_bubbleFormats(_this3, leaf));
                attributes = dist_Delta.AttributeMap.diff(formats, attributes) || {};
              }
            } else if (newTextBase_typeof(op.insert) === 'object') {
              var key = Object.keys(op.insert)[0]; // There should only be one key
              if (key === null) return index;
              _this3.insertAt(index, key, op.insert[key]);
            }
          } else {
            deleteDelta.push(op);
          }
          Object.keys(attributes).forEach(function (name) {
            _this3.formatAt(index, length, name, attributes[name]);
          });
          return index + length;
        }, 0);
        // обарабтываем операции удаления
        deleteDelta.reduce(function (index, op) {
          if (typeof op.delete === 'number') {
            _this3.deleteAt(index, op.delete);
            return index;
          }
          return index + dist_Delta.Op.length(op);
        }, 0);
        // обновляем кэш дельты, чтобы не эммитилось событие text-change, если дельта пришла с сервера
        _this3.delta();
      });
      //this.scroll.update()
    }
    // метод применяет delta к characters
  }, {
    key: "applyForCharacters",
    value: function applyForCharacters(delta) {
      // base
      this.characters.applyDelta(delta);
    }
  }, {
    key: "clearFormat",
    value: function clearFormat(index, length) {
      // base
      var exclude = ['comment'];
      // тут упростил получение форматов на отрезке, в отличии от textBase, так будет более правильно
      var formats = new Set(this.descendants((parchment_default()).Inline, index, length).map(function (blot) {
        return blot.statics.blotName;
      }).filter(function (format) {
        return !exclude.includes(format);
      }));
      var _iterator = newTextBase_createForOfIteratorHelper(formats),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var format = _step.value;
          this.formatText(index, length, format, false);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "getFormat",
    value: function getFormat(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      // base
      var leaves = this.descendants((parchment_default()).Leaf, index, length);
      if (!leaves.length) return {};
      var formats = newTextBase_bubbleFormats(this, leaves.shift());
      while (leaves.length) {
        var leaf = leaves.shift();
        if (leaf instanceof linebreak) {
          leaf = leaves.shift();
        }
        if (leaf) {
          formats = combineFormats(newTextBase_bubbleFormats(this, leaf), formats);
        }
      }
      return formats;
    }
  }, {
    key: "getText",
    value: function getText() {
      var _this4 = this;
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.length() - index;
      // base
      var delta = this.getContents(index, length);
      return delta.filter(function (op) {
        if (typeof op.insert === 'string') {
          return true;
        } else if (newTextBase_typeof(op.insert) === 'object') {
          var BlotClass = parchment_default().query(Object.keys(op.insert)[0]);
          if (BlotClass && BlotClass.getOpText) {
            return true;
          }
        }
        return false;
      }).map(function (op) {
        if (typeof op.insert === 'string') {
          return op.insert;
        }
        return parchment_default().query(Object.keys(op.insert)[0]).getOpText(op.insert, _this4 && _this4.children, _this4.editor);
      }).join('');
    }
  }, {
    key: "getContents",
    value: function getContents(index, length) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var delta = this.cache.delta.slice(index, index + length);
      if (options.forCopy) {
        return prepareDeltaForCopy(delta);
      }
      return delta;
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      // base
      (_get3 = newTextBase_get(newTextBase_getPrototypeOf(NewTextBase.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      if (this._quillBinding) {
        this._quillBinding.destroy();
        this._quillBinding = null;
      }
    }
  }, {
    key: "delta",
    value: function delta() {
      var _this5 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // base
      this.cache.delta = this.descendants((parchment_default()).Leaf).reduce(function (delta, leaf) {
        if (leaf.length() === 0) {
          return delta;
        }
        return delta.insert(leaf.value(), newTextBase_bubbleFormats(_this5, leaf, {}));
      }, new (Delta_default())()).insert('\n');
      if (options.forCopy) {
        return prepareDeltaForCopy(this.cache.delta.slice());
      }
      return this.cache.delta;
    }
    // функции удаления и форматирования,
    // так как они обрабатываются програмно, взаимодействуют на прямую с yText,
    // чтобы не вызывать лишних обновлений, yText сам обновит блот до нужного состояния.
  }, {
    key: "deleteText",
    value: function deleteText(index, length) {
      // base
      var delta = new (Delta_default())().retain(index).delete(length);
      this.characters.applyDelta(delta.ops);
    }
  }, {
    key: "formatAt",
    value: function formatAt(index, length, name, value) {
      // base
      // Мы храним комментарии в дельте в виде 'comment-threadId-color': true
      // Для того, чтобы Parchment понял как ему нужно отформатировать текст нужно привести формат комментария
      // в нормальный для него вид 'comment': JSON.stringify({threadId, color})
      if (name.startsWith('comment-') && value === true) {
        var attrs = name.split('-');
        name = attrs.shift();
        value = JSON.stringify({
          threadId: attrs.shift(),
          color: attrs.length > 1 ? attrs.join('-') : attrs.shift()
        });
      }
      newTextBase_get(newTextBase_getPrototypeOf(NewTextBase.prototype), "formatAt", this).call(this, index, length, name, value);
    }
  }, {
    key: "formatText",
    value: function formatText(index, length, name, value) {
      // base
      // Для сохранения комментария в дельту на сервере используем формат 'comment-threadId-color': true
      if (name === 'comment') {
        var _JSON$parse = JSON.parse(value),
          threadId = _JSON$parse.threadId,
          color = _JSON$parse.color;
        name = name + '-' + threadId + '-' + color;
        value = true;
      }
      var diff = diffToApplyAttribute(this.characters.toDelta(), index, length, name, value);
      this.characters.applyDelta(diff.ops);
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      // base
      return !Boolean(this.domNode.textContent);
    }
  }, {
    key: "insertText",
    value: function insertText(index, text) {
      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      // base
      if (typeof text === 'string') {
        text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
      }
      var delta = new (Delta_default())().retain(index).insert(text, newTextBase_objectSpread({}, formats));
      this.characters.applyDelta(delta.ops);
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(blot, ref) {
      // base
      var head = this.children.head;
      newTextBase_get(newTextBase_getPrototypeOf(NewTextBase.prototype), "insertBefore", this).call(this, blot, ref);
      if (head instanceof blots_break) {
        head.remove();
      }
    }
  }, {
    key: "length",
    value: function length() {
      // base
      if (this.cache.length === null) {
        this.cache.length = newTextBase_get(newTextBase_getPrototypeOf(NewTextBase.prototype), "length", this).call(this) + EMPTY_LINE_LENGTH;
      }
      return this.cache.length;
    }

    // on и off для совместимости с quill для биндинга YText
  }, {
    key: "on",
    value: function on() {
      // base
      return this.emitter.on.apply(this.emitter, arguments);
    }
  }, {
    key: "off",
    value: function off() {
      // base
      return this.emitter.removeListener.apply(this.emitter, arguments);
    }
  }, {
    key: "optimize",
    value: function optimize() {
      var _get4;
      // base
      this.cache.length = null;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      (_get4 = newTextBase_get(newTextBase_getPrototypeOf(NewTextBase.prototype), "optimize", this)).call.apply(_get4, [this].concat(args));
      var tail = this.children.tail;
      if (tail instanceof linebreak && tail.value().linebreak === 's') {
        this.appendChild(parchment_default().create('linebreak'));
      }
      // fix delta map if need
      var deltaFromMap = this.characters.toDelta();
      if (deltaFromMap.length === 0) {
        var fixDelta = new (Delta_default())().insert('\n');
        this.applyForCharacters(fixDelta.ops);
      }
    }
  }, {
    key: "path",
    value: function path(index) {
      // base
      return newTextBase_get(newTextBase_getPrototypeOf(NewTextBase.prototype), "path", this).call(this, index, true);
    }
  }, {
    key: "setCharacters",
    value: function setCharacters(yText) {
      // base
      this.characters = yText;
    }
  }, {
    key: "setContents",
    value: function setContents(delta) {
      // base
      // тут важно использовать deleteAt метод, так как deleteText вызовет emit события text-change
      delta = new (Delta_default())(delta);
      var length = this.length();
      if (length !== 1) {
        this.deleteAt(0, length);
      }
      this.applyDelta(delta);
    }
  }, {
    key: "split",
    value: function split(index) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      // base
      if (!force) {
        if (index === 0) return this;
        if (index === this.length()) return this.next;
      }
      var after = this.clone();
      this.children.forEachAt(index, this.length(), function (child, offset) {
        child = child.split(offset, force);
        after.appendChild(child);
      });
      return after;
    }
  }, {
    key: "updateContents",
    value: function updateContents(delta, source) {
      // base
      delta = new (Delta_default())(delta);
      var needToRestoreSelection = false;
      if (source === 'remote') {
        if (this.selection.containsBlot(this)) {
          needToRestoreSelection = true;
        }
      }
      this.applyDelta(delta);
      if (needToRestoreSelection) {
        if (this.selection.lastRelPosition) {
          var absPos = getAbsolutePosition(this.selection.lastRelPosition);
          this.selection.setRange(absPos);
        }
      }
    }

    // Этот метод передается в качестве modifier в функцию modify,
    // eсли передан change то возвращает change,
    // если нет возвращает разницу между старой и новой дельтой блота.
  }, {
    key: "updateBlot",
    value: function updateBlot(change) {
      var cursorIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      // base
      var oldDelta = this.cache.delta || new (Delta_default())([]);
      var delta = this.delta();
      if (!change || !deep_equal_default()(oldDelta.compose(change), delta)) {
        change = oldDelta.diff(this.cache.delta, cursorIndex);
      }
      if (change.ops.length > 0) {
        this.scroll.emitter.emit('BLOCK_UPDATE', {});
      }
      return change;
    }
    // в scroll.update в переборе мутаций ищется блот для каждой mutation.target,
    // нативный parchment вызывает update только в тех блотах, в которых произошла мутация,
    // например мы просто изменили текст, update вызовется в Parchment.Text блоте, а не в этом.
    // Для того, чтобы для этого блота update вызывался всегда,
    // когда в его внутренних блотах произошли какие то изменения,
    // в scroll блоте были добавлены соответствующие изменения
  }, {
    key: "update",
    value: function update() {
      var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var context = arguments.length > 1 ? arguments[1] : undefined;
      // base
      if (mutations === 'yjs' || mutations === 'remote') {
        return;
      }
      newTextBase_get(newTextBase_getPrototypeOf(NewTextBase.prototype), "update", this).call(this, mutations, context);
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      if (!this.children.length) {
        return '<br>';
      }
      var html = [];
      this.children.forEach(function (blot) {
        if (blot instanceof text_Text) {
          html.push(escapeHtml(blot.value()));
        } else {
          var blotHTML = '';
          if (blot.toHTML) {
            blotHTML = blot.toHTML(context);
          } else if (blot.domNode) {
            blotHTML = blot.domNode.outerHTML;
          }
          html.push(blotHTML);
        }
      });
      return html.join('');
    }
  }]);
  return NewTextBase;
}((parchment_default()).Block);

NewTextBase.defaultChild = 'break';
NewTextBase.allowedChildren = [blots_break, cursor, linebreak, text_Text, inline, Mention, date_Date, Button, Progress, DropdownList];
NewTextBase.initMap = function (map, store) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (map.has('characters')) {
    throw new Error('TextBase map already has characters, skip initMap');
  }
  map.set('characters', new store.types.Text());
  if (params.delta) {
    map.get('characters').applyDelta(params.delta.ops);
  } else {
    map.get('characters').insert(0, '\n');
  }
};

// пока отдельно вынес новый сборщик форматов блота, он более оптимизированный,
// без лишних функций типа extend, которые требуют стороннего импорта,
// так же этот сборщик понимает, что собирает форматы только внутри одного блота и не пытается подняться выше
function newTextBase_bubbleFormats(blot, leaf) {
  var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (leaf == null) return formats;
  if (typeof leaf.formats === 'function') {
    formats = newTextBase_objectSpread(newTextBase_objectSpread({}, formats), leaf.formats());
  }
  if (leaf.parent === null || leaf.parent === blot || leaf.parent.statics.scope !== leaf.statics.scope) {
    return formats;
  }
  return newTextBase_bubbleFormats(blot, leaf.parent, formats);
}
// функция modify получает изменения в дельте блота с помощью переданной функции modifier,
// если есть какие то изменения эмиттит событие text-change
function newTextBase_modify(modifier) {
  var oldDelta = this.cache.delta;
  var change = modifier();
  if (change.length() > 0) {
    var _this$emitter;
    // по сути это событие сейчас работает как insert-text,
    // так как другие события типа удаления и т.п. диспатчатся напрямую в yText и не эммитятся сюда,
    // отсюда следует, что эта функция отрабатывает когда юзер в данном инстансе вводит текст в браузере,
    // поэтому мы не отслеживаем тут source
    var args = ['text-change', change, oldDelta];
    (_this$emitter = this.emitter).emit.apply(_this$emitter, args);
  }
  return change;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/text/util/textHotkeys.js














function textHotkeys_slicedToArray(arr, i) { return textHotkeys_arrayWithHoles(arr) || textHotkeys_iterableToArrayLimit(arr, i) || textHotkeys_unsupportedIterableToArray(arr, i) || textHotkeys_nonIterableRest(); }
function textHotkeys_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function textHotkeys_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return textHotkeys_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return textHotkeys_arrayLikeToArray(o, minLen); }
function textHotkeys_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function textHotkeys_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function textHotkeys_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/* harmony default export */ const textHotkeys = ([{
  hotkey: 'backspace',
  action: function action(event) {
    event.preventDefault();
    var _this$selection$getRa = this.selection.getRange({
        offsetBlot: this
      }),
      _this$selection$getRa2 = textHotkeys_slicedToArray(_this$selection$getRa, 1),
      blotRange = _this$selection$getRa2[0];
    this.deleteText(blotRange.index, 1);
    this.selection.setRange({
      index: this.offset(this.scroll) + blotRange.index,
      length: 0
    });
  }
}, {
  hotkey: 'enter',
  action: function action(event) {
    var _this$selection$getRa3 = this.selection.getRange({
        offsetBlot: this
      }),
      _this$selection$getRa4 = textHotkeys_slicedToArray(_this$selection$getRa3, 1),
      blotRange = _this$selection$getRa4[0];
    if (this.editor.options.keyboardMode !== 'mobile') {
      event.preventDefault();
      this.tryConvertLink(blotRange.index);
      var addNextBlotOpts = {
        focus: {
          index: 0
        }
      };
      if (blotRange.index !== this.length() - 1) {
        var fragment = this.split(blotRange.index, true);
        addNextBlotOpts.delta = fragment.delta();
      }
      this.parent.addNextBlot(addNextBlotOpts);
    } else {
      // TODO: mobile research
      // тут придется по новой писать для мобил, потому что у старого блота не было обертки
      // и мы могли просто не выполнять preventDefault
    }
  }
}, {
  hotkey: 'shift+enter',
  //altHotkey: 'enter', // временно блокирую Enter, тут работает как shift+enter
  action: function action(event) {
    event.preventDefault();
    var _this$selection$getRa5 = this.selection.getRange({
        offsetBlot: this
      }),
      _this$selection$getRa6 = textHotkeys_slicedToArray(_this$selection$getRa5, 1),
      blotRange = _this$selection$getRa6[0];
    this.tryConvertLink(blotRange.index);
    this.insertText(blotRange.index, {
      linebreak: 's'
    });
    this.selection.setRange({
      index: this.offset(this.scroll) + blotRange.index + 1,
      length: 0
    });
  }
}, {
  hotkey: 'tab',
  action: function action(event) {
    event.preventDefault();
    var _this$selection$getRa7 = this.selection.getRange({
        offsetBlot: this
      }),
      _this$selection$getRa8 = textHotkeys_slicedToArray(_this$selection$getRa7, 1),
      blotRange = _this$selection$getRa8[0];
    if (blotRange.index === 0) {
      var _this$parent$addInden, _this$parent;
      (_this$parent$addInden = (_this$parent = this.parent).addIndent) === null || _this$parent$addInden === void 0 ? void 0 : _this$parent$addInden.call(_this$parent);
    } else {
      if (blotRange.length > 0) {
        this.deleteText(blotRange.index, blotRange.length);
      }
      this.insertText(blotRange.index, '\t');
      this.selection.setRange({
        index: this.offset(this.scroll) + blotRange.index + 1,
        length: 0
      });
    }
  }
}, {
  hotkey: 'shift+tab',
  action: function action(event) {
    event.preventDefault();
    var _this$selection$getRa9 = this.selection.getRange({
        offsetBlot: this
      }),
      _this$selection$getRa10 = textHotkeys_slicedToArray(_this$selection$getRa9, 1),
      blotRange = _this$selection$getRa10[0];
    if (blotRange.index === 0 || blotRange.length > 0) {
      var _this$parent$removeIn, _this$parent2;
      (_this$parent$removeIn = (_this$parent2 = this.parent).removeIndent) === null || _this$parent$removeIn === void 0 ? void 0 : _this$parent$removeIn.call(_this$parent2);
    } else {
      // тут на мой взгляд будет более правильно удалять табуляцию до каретки если она есть
      // в отличии от аналогичного действия в textLine
      var hasTabBeforeCaret = this.getText(blotRange.index - 1, 1) === '\t';
      if (hasTabBeforeCaret) {
        this.deleteText(blotRange.index - 1, 1);
        this.selection.setRange({
          index: this.offset(this.scroll) + blotRange.index - 1,
          length: 0
        });
      } else {
        var _this$parent$removeIn2, _this$parent3;
        (_this$parent$removeIn2 = (_this$parent3 = this.parent).removeIndent) === null || _this$parent$removeIn2 === void 0 ? void 0 : _this$parent$removeIn2.call(_this$parent3);
      }
    }
  }
}, {
  hotkey: 'alt+backspace',
  altHotkey: ['mod+backspace', 'ctrl+backspace'],
  action: function action(event) {
    var deleteAsAltBackspace = function deleteAsAltBackspace(indexAt, string) {
      var btn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      // проверяем чтобы тип у string был строкой
      if (typeof string !== 'string') {
        return {
          str: '',
          cursor: 0
        };
      }
      var left = string.slice(0, indexAt);
      var right = string.slice(indexAt);
      var str = '';

      // если btn Alt то удаление по словам
      if (btn === 'alt') {
        var words = left.split(' ');
        var deleted = words.pop();
        if (deleted && words.length) {
          words.push('');
        }
        left = words.length ? words.join(' ') : '';
        str = [left, right].join('');
      } else {
        left = '';
        str = right;
      }
      return {
        str: str,
        cursor: left.length
      };
    };
    var delta = this.getContents(0, this.length());
    var canDelete = false;
    // можем удалять только там где у дельты один элемент
    if (delta.ops.length === 1) {
      canDelete = true;
    }
    // или второй элемент это пустая строка или строка с пробелами
    if (delta.ops.length === 2 && typeof delta.ops[1].insert === 'string') {
      if (delta.ops[1].insert.trim() === '') canDelete = true;
    }
    // предотвращаем ошибку при удалении через Alt|Ctrl|Meta+Backspace
    if (canDelete || event.metaKey) {
      event.preventDefault();
      var length = this.length() - 1;
      var btn = event.altKey || event.ctrlKey ? 'alt' : '';
      var _this$selection$getRa11 = this.selection.getRange(),
        _this$selection$getRa12 = textHotkeys_slicedToArray(_this$selection$getRa11, 2),
        index = _this$selection$getRa12[0].index,
        _this$selection$getRa13 = _this$selection$getRa12[1],
        startOffset = _this$selection$getRa13.start.offset,
        endOffset = _this$selection$getRa13.end.offset;
      var _delta$ops$0$attribut = delta.ops[0].attributes,
        attributes = _delta$ops$0$attribut === void 0 ? {} : _delta$ops$0$attribut;
      var _deleteAsAltBackspace = deleteAsAltBackspace(endOffset, delta.ops[0].insert, btn),
        insert = _deleteAsAltBackspace.str,
        cursor = _deleteAsAltBackspace.cursor;

      // из-за бага в yjs пока разделяем на две операции https://github.com/yjs/yjs/issues/305
      this.applyForCharacters([{
        delete: length
      }]);
      this.applyForCharacters([{
        insert: insert,
        attributes: attributes
      }]);
      this.selection.setRange({
        index: index - startOffset + cursor,
        length: 0
      });
    }
  }
}]);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/text/util/markdowns.js
function markdowns_toConsumableArray(arr) { return markdowns_arrayWithoutHoles(arr) || markdowns_iterableToArray(arr) || markdowns_unsupportedIterableToArray(arr) || markdowns_nonIterableSpread(); }
function markdowns_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function markdowns_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function markdowns_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return markdowns_arrayLikeToArray(arr); }
function markdowns_slicedToArray(arr, i) { return markdowns_arrayWithHoles(arr) || markdowns_iterableToArrayLimit(arr, i) || markdowns_unsupportedIterableToArray(arr, i) || markdowns_nonIterableRest(); }
function markdowns_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function markdowns_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return markdowns_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return markdowns_arrayLikeToArray(o, minLen); }
function markdowns_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function markdowns_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function markdowns_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function markdowns_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { markdowns_typeof = function _typeof(obj) { return typeof obj; }; } else { markdowns_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return markdowns_typeof(obj); }






















// Cразу объявляем переменные возможных значений маркдаунов,
// чтобы в дальнейшем при проверке обращаться именно к ним.
// Такая реализация позволит не выполнять лишние функции и переборы массивов/объектов.

// Маркдауны блотов
var blotMarkdownValues = Object.keys(BLOT_MARKDOWNS).reduce(function (markdowns, type) {
  if (typeof BLOT_MARKDOWNS[type] === 'string') {
    markdowns.push(BLOT_MARKDOWNS[type]);
  } else if (markdowns_typeof(BLOT_MARKDOWNS[type]) === 'object') {
    for (var _i = 0, _Object$entries = Object.entries(BLOT_MARKDOWNS[type]); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = markdowns_slicedToArray(_Object$entries[_i], 2),
        value = _Object$entries$_i[1];
      if (typeof value === 'string') {
        markdowns.push(value);
      } else if (Array.isArray(value)) {
        markdowns.push.apply(markdowns, markdowns_toConsumableArray(value));
      }
    }
  }
  return markdowns;
}, []);
// Инлайн маркдауны
var inlineMarkdownValues = Object.keys(INLINE_MARKDOWNS).map(function (type) {
  return INLINE_MARKDOWNS[type];
});
// пропускаем undo стэк
function undoManagerCapture(editor) {
  editor.plugins.undoManager.stopCapturing();
  editor.plugins.undoManager.captureRange();
}
// получаем параметры для конвертации
function getConvertBlotParams(text) {
  var params = false;
  for (var _i2 = 0, _Object$entries2 = Object.entries(BLOT_MARKDOWNS); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = markdowns_slicedToArray(_Object$entries2[_i2], 2),
      key = _Object$entries2$_i[0],
      value = _Object$entries2$_i[1];
    // простые блоки
    if (typeof value === 'string' && value === text) {
      params = {
        type: key,
        markdown: value
      };
    } else if (markdowns_typeof(value) === 'object') {
      // маркдауны списка
      for (var _i3 = 0, _Object$entries3 = Object.entries(value); _i3 < _Object$entries3.length; _i3++) {
        var _Object$entries3$_i = markdowns_slicedToArray(_Object$entries3[_i3], 2),
          itemType = _Object$entries3$_i[0],
          mark = _Object$entries3$_i[1];
        if (typeof mark === 'string' && text.startsWith(mark + ' ') || Array.isArray(mark) && mark.some(function (m) {
          return text.startsWith(m + ' ');
        })) {
          params = {
            type: key,
            items: [itemType]
          };
          if (typeof mark === 'string') {
            params.markdown = mark;
          } else {
            params.markdown = mark.find(function (m) {
              return text.startsWith(m);
            });
          }
          break;
        }
      }
    }
    if (params) {
      break;
    }
  }
  return params;
}
// контекстом данной функции должен являться блот
function convertMarkdown(insertText, blotRange) {
  var isMarkdownAllowed = !this.disallowMarkDown;
  if (isMarkdownAllowed && Object.keys(this.editor.options).includes('markdown')) {
    isMarkdownAllowed = this.editor.options.markdown;
  }
  if (this.editor.mode === MODE_LITE) {
    isMarkdownAllowed = false;
  }
  if (!isMarkdownAllowed || !insertText || !blotRange) {
    return;
  }
  if (insertText === ' ') {
    var text = this.getText().trim();
    // если текст не начинается как хотя бы один маркдаун, не выполняем код
    if (!blotMarkdownValues.some(function (value) {
      return text.startsWith(value);
    })) return;
    var convertParams = getConvertBlotParams(text);
    if (convertParams) {
      if (convertParams.markdown && convertParams.type === 'list') {
        var cursorPos = blotRange.index - convertParams.markdown.length - 1;
        if (cursorPos !== 0) return;
      }
      undoManagerCapture(this.editor);
      this.deleteText(0, convertParams.markdown.length + 1);
      delete convertParams.markdown;
      this.parent.container.containerConvertBlots([this.parent], convertParams);
    }
  } else if (inlineMarkdownValues.some(function (value) {
    return value.startsWith(insertText);
  })) {
    var prevSymbol = this.getText(blotRange.index - 2, 1);
    var markdown = prevSymbol === insertText ? prevSymbol + insertText : insertText;
    var index = blotRange.index - markdown.length - 1;
    if (index <= 0) return;
    var _text = '';
    while (index !== -1 && !_text.startsWith(markdown)) {
      if (!_text) {
        _text = this.getText(index, 1) + markdown;
      } else {
        _text = this.getText(index, 1) + _text;
      }
      index--;
      if (_text.startsWith(markdown) && this.getText(index, 1) === insertText) {
        markdown = insertText + insertText;
      }
    }
    if (_text.startsWith(markdown) && _text.endsWith(markdown)) {
      var format = Object.keys(INLINE_MARKDOWNS).find(function (key) {
        return INLINE_MARKDOWNS[key] === markdown;
      });
      if (format) {
        undoManagerCapture(this.editor);
        // удаляем конец markdown
        this.deleteText(blotRange.index - markdown.length, markdown.length);
        // удаляем начало markdown
        this.deleteText(index + 1, markdown.length);
        // форматируем текст
        this.formatText(index + 1, _text.length - markdown.length * 2, format, true);
        this.scroll.update();
        this.selection.setRange({
          index: this.offset(this.scroll) + blotRange.index - markdown.length * 2,
          length: 0
        });
        this.selection.format(format, false);
      }
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/text/newTextLine.js
function newTextLine_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { newTextLine_typeof = function _typeof(obj) { return typeof obj; }; } else { newTextLine_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return newTextLine_typeof(obj); }
function newTextLine_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = newTextLine_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function newTextLine_slicedToArray(arr, i) { return newTextLine_arrayWithHoles(arr) || newTextLine_iterableToArrayLimit(arr, i) || newTextLine_unsupportedIterableToArray(arr, i) || newTextLine_nonIterableRest(); }
function newTextLine_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function newTextLine_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return newTextLine_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return newTextLine_arrayLikeToArray(o, minLen); }
function newTextLine_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function newTextLine_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function newTextLine_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

























function newTextLine_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function newTextLine_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function newTextLine_createClass(Constructor, protoProps, staticProps) { if (protoProps) newTextLine_defineProperties(Constructor.prototype, protoProps); if (staticProps) newTextLine_defineProperties(Constructor, staticProps); return Constructor; }
function newTextLine_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { newTextLine_get = Reflect.get; } else { newTextLine_get = function _get(target, property, receiver) { var base = newTextLine_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return newTextLine_get(target, property, receiver || target); }
function newTextLine_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = newTextLine_getPrototypeOf(object); if (object === null) break; } return object; }
function newTextLine_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) newTextLine_setPrototypeOf(subClass, superClass); }
function newTextLine_setPrototypeOf(o, p) { newTextLine_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return newTextLine_setPrototypeOf(o, p); }
function newTextLine_createSuper(Derived) { var hasNativeReflectConstruct = newTextLine_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = newTextLine_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = newTextLine_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return newTextLine_possibleConstructorReturn(this, result); }; }
function newTextLine_possibleConstructorReturn(self, call) { if (call && (newTextLine_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return newTextLine_assertThisInitialized(self); }
function newTextLine_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function newTextLine_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function newTextLine_getPrototypeOf(o) { newTextLine_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return newTextLine_getPrototypeOf(o); }
function newTextLine_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var NewTextLine = /*#__PURE__*/function (_NewTextBase) {
  newTextLine_inherits(NewTextLine, _NewTextBase);
  var _super = newTextLine_createSuper(NewTextLine);
  function NewTextLine(domNode) {
    var _this;
    newTextLine_classCallCheck(this, NewTextLine);
    _this = _super.call(this, domNode);
    newTextLine_defineProperty(newTextLine_assertThisInitialized(_this), "onUserInsertText", function (delta, oldDelta) {
      // если активны какие либо сессии плагинов для текста, не выполняем код
      if (_this.editor.plugins.mentionManager.session) return;
      var insertOps = delta.filter(function (op) {
        return op.insert;
      });
      var _this$selection$getRa = _this.selection.getRange({
          offsetBlot: newTextLine_assertThisInitialized(_this)
        }),
        _this$selection$getRa2 = newTextLine_slicedToArray(_this$selection$getRa, 1),
        blotRange = _this$selection$getRa2[0];
      if (insertOps.length === 1 && blotRange) {
        var insertText = insertOps[0].insert;
        var prevSymbol = blotRange.index > 1 ? _this.getText(blotRange.index - 2, 1) : null;
        var nextSymbol = _this.getText(blotRange.index, 1) === '\n' ? _this.getText(blotRange.index, 1) : null;
        // если курсор стоит внутри или перед форматом, формат возможно имеет свой обработчик печати
        _this.tryHandleTextChangeOnFormat(blotRange, insertText);
        // пробуем сконвертировать маркдаун
        _this.tryConvertMarkdown(insertText, blotRange);
        // Обрабатываем упоминания
        if (insertText === '@') {
          _this.tryStartMention(blotRange, prevSymbol, nextSymbol);
        }
        // Конвертируем стрелку в один символ если это возможно
        if (insertText === '>') {
          _this.tryConvertArrow(blotRange, prevSymbol);
        }
        // Пробуем сконвертировать текст в ссылку
        if (insertText === ' ') {
          _this.tryConvertLink(blotRange.index - 1);
        }
        // При печати текста вначале строки перед ссылкой, нужно отменить форматирование в ссылку
        // P.S. этот фикс нужен вроде только для Firefox, так как в Chrome все ок и без него
        if (blotRange.index === 1 && delta.ops[0].attributes && delta.ops[0].attributes.link) {
          _this.formatText(0, 1, 'link', false);
        }
      }
    });
    _this.isNotIndependent = true;
    return _this;
  }
  newTextLine_createClass(NewTextLine, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = newTextLine_get(newTextLine_getPrototypeOf(NewTextLine.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      this.on('text-change', this.onUserInsertText);
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = newTextLine_get(newTextLine_getPrototypeOf(NewTextLine.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      this.off('text-change', this.onUserInsertText);
    }

    /**
     * Обработка клавиатуры
     * @memberof NewTextLine
     * @param { object } event
     * @param { object } replace - подменяемые хоткеи, например {'enter': 'shift+enter'}
     * @returns { boolean } processed
     */
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var processed = false;
      var replaceKeys = Object.keys(replace);
      var replaceVals = Object.values(replace);
      var _iterator = newTextLine_createForOfIteratorHelper(textHotkeys),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          // Предотвращаем выполнение, если key.hotkey находится в списке подмен
          if (replaceKeys.includes(key.hotkey)) {
            continue;
          }
          var replaceIndex = replaceVals.indexOf(key.hotkey);
          var handle = false;
          if ((0,lib/* default */.ZP)(key.hotkey, event)) {
            handle = true;
          } else if (key.altHotkey) {
            if (Array.isArray(key.altHotkey)) {
              if (key.altHotkey.some(function (hotkey) {
                return (0,lib/* default */.ZP)(hotkey, event);
              })) {
                handle = true;
              }
            } else if (typeof key.altHotkey === 'string') {
              if ((0,lib/* default */.ZP)(key.altHotkey, event)) {
                handle = true;
              }
            }
          }
          if (handle || replaceIndex !== -1 && (0,lib/* default */.ZP)(replaceKeys[replaceIndex], event)) {
            processed = true;
            key.action.call(this, event);
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return processed;
    }
  }, {
    key: "handleAction",
    value: function handleAction(action) {
      var processed = false;
      var type = action.type,
        params = action.params;
      var _this$scroll$selectio = this.scroll.selection.getRange({
          offsetBlot: this
        }),
        _this$scroll$selectio2 = newTextLine_slicedToArray(_this$scroll$selectio, 1),
        blotRange = _this$scroll$selectio2[0];
      if (type === 'format') {
        var style = params.style,
          value = params.value;
        this.formatText(blotRange.index, blotRange.length, style, value);
        processed = true;
      } else if (action.type === 'clear-formatting') {
        this.clearFormat(blotRange.index, blotRange.length);
        processed = true;
      } else if (action.type === 'delete') {
        if (blotRange.length === 0) {
          if (blotRange.index === this.length() - 1) {
            // если каретка стоит в конце блота, не обрабатываем здесь
            return false;
          } else {
            action.dontRestoreSelection();
            action.handleByBrowser();
          }
        } else {
          this.deleteText(blotRange.index, blotRange.length);
        }
        processed = true;
      }
      return processed;
    }
  }, {
    key: "tryConvertMarkdown",
    value: function tryConvertMarkdown(insertText, blotRange) {
      convertMarkdown.call(this, insertText, blotRange);
    }
  }, {
    key: "tryConvertArrow",
    value: function tryConvertArrow(blotRange, prev) {
      if (prev !== '-') return;
      var formats = this.getFormat(blotRange.index - 1, 1);
      this.deleteText(blotRange.index - 2, 2);
      this.insertText(blotRange.index - 2, '→', formats);
      this.scroll.selection.setRange({
        index: this.offset(this.scroll) + blotRange.index - 1,
        length: 0
      });
    }
  }, {
    key: "tryConvertLink",
    value: function tryConvertLink(searchPos) {
      if (this.dontConvertLinks) return;
      var text = '';
      var searchIndex = searchPos;
      var lastSymbol = this.getText(searchIndex - 1, 1);
      // реверсивно ищем текст от каретки до пробела или до linebreak
      while (lastSymbol !== ' ' && lastSymbol !== '\n' && searchIndex !== 0) {
        text = lastSymbol + text;
        searchIndex--;
        lastSymbol = this.getText(searchIndex - 1, 1);
      }
      if (text) {
        // текст уже отформатирован в ссылку
        if (this.getFormat(searchPos - text.length, 1).link) {
          return true;
        }
        // проверяем является ли текст ссылкой
        var urlMatch = text.match(urlRegex.url);
        if (urlMatch && urlMatch.length) {
          var linkIndexInText = text.indexOf(urlMatch[0]);
          if (linkIndexInText !== 0) {
            searchIndex += linkIndexInText;
            text = urlMatch[0];
          }
          var url = text.search('http') != -1 ? text : 'http://' + text;
          this.formatText(searchPos - text.length, text.length, 'link', url);
          return true;
        }
        // проверяем является ли текст email'ом
        var emailMatch = text.match(urlRegex.email);
        if (emailMatch && emailMatch.length) {
          var _url = text.search('mailto:') != -1 ? text : 'mailto:' + text;
          this.formatText(searchPos - text.length, text.length, 'link', _url);
          return true;
        }
      }
      return false;
    }
  }, {
    key: "tryStartMention",
    value: function tryStartMention(blotRange, prev, next) {
      if ((blotRange.index === 1 || prev === ' ' || prev === '\n') && (next === ' ' || next === '\n' || !next)) {
        this.editor.plugins.mentionManager.start(this, blotRange);
      }
    }
  }, {
    key: "tryHandleTextChangeOnFormat",
    value: function tryHandleTextChangeOnFormat(blotRange, insertText) {
      var _this$children$find = this.children.find(blotRange.index, false),
        _this$children$find2 = newTextLine_slicedToArray(_this$children$find, 1),
        format = _this$children$find2[0];
      if (format && format.onTextChange) {
        format.onTextChange(blotRange, insertText, this);
      }
    }
  }]);
  return NewTextLine;
}(NewTextBase);
NewTextLine.tagName = 'p';
NewTextLine.blotName = 'text-line';
NewTextLine.defaultChild = NewTextBase.defaultChild;
NewTextLine.allowedChildren = NewTextBase.allowedChildren;
NewTextLine.initMap = function (map, store) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  NewTextBase.initMap(map, store, params);
};
/* harmony default export */ const newTextLine = (NewTextLine);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/nimbusText.js
function nimbusText_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { nimbusText_typeof = function _typeof(obj) { return typeof obj; }; } else { nimbusText_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return nimbusText_typeof(obj); }










function nimbusText_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function nimbusText_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function nimbusText_createClass(Constructor, protoProps, staticProps) { if (protoProps) nimbusText_defineProperties(Constructor.prototype, protoProps); if (staticProps) nimbusText_defineProperties(Constructor, staticProps); return Constructor; }
function nimbusText_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) nimbusText_setPrototypeOf(subClass, superClass); }
function nimbusText_setPrototypeOf(o, p) { nimbusText_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return nimbusText_setPrototypeOf(o, p); }
function nimbusText_createSuper(Derived) { var hasNativeReflectConstruct = nimbusText_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = nimbusText_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = nimbusText_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return nimbusText_possibleConstructorReturn(this, result); }; }
function nimbusText_possibleConstructorReturn(self, call) { if (call && (nimbusText_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return nimbusText_assertThisInitialized(self); }
function nimbusText_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function nimbusText_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function nimbusText_getPrototypeOf(o) { nimbusText_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return nimbusText_getPrototypeOf(o); }
function nimbusText_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var NimbusText = /*#__PURE__*/function (_Component) {
  nimbusText_inherits(NimbusText, _Component);
  var _super = nimbusText_createSuper(NimbusText);
  function NimbusText(props) {
    var _this;
    nimbusText_classCallCheck(this, NimbusText);
    _this = _super.call(this, props);
    nimbusText_defineProperty(nimbusText_assertThisInitialized(_this), "onTextRef", function (node) {
      _this.textNode = node;
      if (_this.props.onTextRef) {
        _this.props.onTextRef(node);
      }
    });
    _this.blot = _this.createBlot();
    _this.state = {
      showPlaceholder: false
    };
    return _this;
  }
  nimbusText_createClass(NimbusText, [{
    key: "createBlot",
    value: function createBlot() {
      var blot = parchment_default().create('text-line');
      blot.setCharacters(this.props.characters);
      return blot;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var parentBlot = this.props.parent;
      if (parentBlot) {
        parentBlot.appendChild(this.blot);
        parentBlot.hasTextLine = true;
        this.textNode.appendChild(this.blot.domNode);
      }
      this.setState({
        showPlaceholder: !this.props.parent.props.focused && this.blot.isEmpty()
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!this.state.showPlaceholder) {
        if (!this.props.parent.props.focused && this.blot.isEmpty()) {
          this.setState({
            showPlaceholder: true
          });
        }
      } else {
        if (this.props.parent.props.focused || !this.blot.isEmpty()) {
          this.setState({
            showPlaceholder: false
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render(_ref) {
      var placeholder = _ref.placeholder,
        align = _ref.align;
      var showPlaceholder = this.state.showPlaceholder;
      var classes = ['nimbus-text'];
      if (align) {
        classes.push('text-align-' + align);
      }
      var placeholderComponent = placeholder && showPlaceholder ? (0,preact_module.h)("div", {
        className: "nimbus-text-placeholder",
        contenteditable: "false"
      }, placeholder) : null;
      return (0,preact_module.h)("div", {
        className: classes.join(' '),
        style: {
          position: 'relative'
        },
        ref: this.onTextRef
      }, placeholderComponent);
    }
  }]);
  return NimbusText;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/hint.js
function blots_hint_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { blots_hint_typeof = function _typeof(obj) { return typeof obj; }; } else { blots_hint_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return blots_hint_typeof(obj); }
function blots_hint_extends() { blots_hint_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return blots_hint_extends.apply(this, arguments); }
function hint_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = hint_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function hint_slicedToArray(arr, i) { return hint_arrayWithHoles(arr) || hint_iterableToArrayLimit(arr, i) || hint_unsupportedIterableToArray(arr, i) || hint_nonIterableRest(); }
function hint_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function hint_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return hint_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return hint_arrayLikeToArray(o, minLen); }
function hint_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function hint_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function hint_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function blots_hint_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function blots_hint_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function blots_hint_createClass(Constructor, protoProps, staticProps) { if (protoProps) blots_hint_defineProperties(Constructor.prototype, protoProps); if (staticProps) blots_hint_defineProperties(Constructor, staticProps); return Constructor; }
function hint_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { hint_get = Reflect.get; } else { hint_get = function _get(target, property, receiver) { var base = hint_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return hint_get(target, property, receiver || target); }
function hint_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = blots_hint_getPrototypeOf(object); if (object === null) break; } return object; }
function blots_hint_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) blots_hint_setPrototypeOf(subClass, superClass); }
function blots_hint_setPrototypeOf(o, p) { blots_hint_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return blots_hint_setPrototypeOf(o, p); }
function blots_hint_createSuper(Derived) { var hasNativeReflectConstruct = blots_hint_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = blots_hint_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = blots_hint_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return blots_hint_possibleConstructorReturn(this, result); }; }
function blots_hint_possibleConstructorReturn(self, call) { if (call && (blots_hint_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return blots_hint_assertThisInitialized(self); }
function blots_hint_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function blots_hint_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function blots_hint_getPrototypeOf(o) { blots_hint_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return blots_hint_getPrototypeOf(o); }
function blots_hint_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }














































var hint_mixin = mix([commentable, colorsConfigurable, alignable, colorable, indentable, blotLock, sizeaware, executable, dropAcceptor, draggable, focusable, selectable, basic]);
var hint_FORMAT_STYLES = ['bold', 'italic', 'underline', 'strikethrough', 'link', 'background', 'color', 'comment'];

/**
 * Компонент иконки для хинта
 * @param { string } icon - текущая иконка
 * @param { function } setIcon - функция, меняющая иконку
 * @memberof Hint
 */
function HintIcon(_ref) {
  var icon = _ref.icon,
    setIcon = _ref.setIcon,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var onMouseDown = function onMouseDown(event) {
    event.stopPropagation();
    if (disabled) return;
    setIcon(event);
  };
  var clases = ['uneditable-container', 'hintblock-icon'];
  var iconNode = stringIsUrl(icon) ? (0,preact_module.h)("img", {
    src: icon,
    style: {
      maxWidth: '24px',
      maxHeight: '24px'
    },
    alt: ""
  }) : icon;
  return (0,preact_module.h)("div", {
    contenteditable: "false",
    className: clases.join(' '),
    onClick: onMouseDown
  }, (0,preact_module.h)("span", null, iconNode));
}

/**
 * Hint блот
 * @class
 * @classdesc Hint блот
 */
var hint_Hint = /*#__PURE__*/function (_mixin) {
  blots_hint_inherits(Hint, _mixin);
  var _super = blots_hint_createSuper(Hint);
  /**
   * Конструктор
   * @param { node } domNode
   * @memberof Hint
   * @constructs
   */
  function Hint(domNode) {
    var _this;
    blots_hint_classCallCheck(this, Hint);
    // Конфигурация для миксина ColorsConfigurable
    var params = {
      colorsConfig: ['borderColor', 'lineColor']
    };
    _this = _super.call(this, domNode, params);
    blots_hint_defineProperty(blots_hint_assertThisInitialized(_this), "onPaste", function (_ref2) {
      var text = _ref2.text;
      var _this$scroll$selectio = _this.scroll.selection.getRange({
          offsetBlot: blots_hint_assertThisInitialized(_this)
        }),
        _this$scroll$selectio2 = hint_slicedToArray(_this$scroll$selectio, 1),
        blotRange = _this$scroll$selectio2[0];
      var linkTarget = text.trim();
      if (stringIsUrl(linkTarget)) {
        _this.editor.plugins.pasteManager.pasteUrlIntoText(_this.getTextBlot(), blotRange, linkTarget);
        return true;
      }
      text = text.replace(/\r\n/g, '\n');
      var content = text.split('\n');
      var _this$scroll$selectio3 = _this.scroll.selection.getRange(),
        _this$scroll$selectio4 = hint_slicedToArray(_this$scroll$selectio3, 1),
        quillRange = _this$scroll$selectio4[0];
      quillRange.index += text.length;
      quillRange.length = 0;
      var insertOps = [{
        retain: blotRange.index
      }];
      if (blotRange.length > 0) {
        insertOps.push({
          delete: blotRange.length
        });
      }
      content.map(function (string, index) {
        insertOps.push({
          insert: string
        });
        if (index !== content.length - 1) {
          insertOps.push({
            insert: {
              linebreak: 's'
            }
          });
        }
      });
      _this.map.get('characters').applyDelta(insertOps);
      _this.scroll.selection.setRange(quillRange);
      return true;
    });
    _this.selfColorManagement = true;
    _this.dontRemoveWithBackspace = true;
    _this.onStartBackspaceConvertToParagraph = true;
    // Не позволяем глушить cloneSelf в BasicMixin
    _this.keepSuperCloneSelf = true;
    _this.domNode.classList.add('text-blot', 'hintblock');
    _this.addCanExecActions(['format', 'clear-formatting', 'delete', 'backspace']);
    // Список заменяемых хоткеев
    _this.hotkeyReplace = {
      'enter': 'shift+enter'
    };
    return _this;
  }

  /**
   * attach
   * @param { any[] } ...args
   * @memberof Hint
   */
  blots_hint_createClass(Hint, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = hint_get(blots_hint_getPrototypeOf(Hint.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      this.editor.on('grid-resize-end', this.renderContent);
    }

    /**
     * detach
     * @param { any[] } ...args
     * @memberof Hint
     */
  }, {
    key: "detach",
    value: function detach() {
      var _get3;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = hint_get(blots_hint_getPrototypeOf(Hint.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      this.editor.off('grid-resize-end', this.renderContent);
    }

    /**
     * Геттер, добавляет в меню блока опции работы с текстом
     * @memberof Hint
     * @kind function
     * @returns { object }
     */
  }, {
    key: "contextMenu",
    get: function get() {
      var menu = hint_get(blots_hint_getPrototypeOf(Hint.prototype), "contextMenu", this);
      Object.assign(menu, textMenu(this.editor));
      return menu;
    }

    /**
     * Обработчик нажатий клавиатуры
     * @memberof Hint
     * @returns { object } event - событие клавиатуры
     */
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      var processed = false;
      var children = this.getChildrenForAction();
      var _iterator = hint_createForOfIteratorHelper(children),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var blot = _step.value;
          if (blot.handleKeyDown && blot.handleKeyDown(event, this.hotkeyReplace)) {
            processed = true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return processed;
    }

    /**
     * Геттер, возвращает текущую иконку хинта
     * @memberof Hint
     * @returns { string } icon
     */
  }, {
    key: "icon",
    get: function get() {
      return this.map.get('icon') || '🚩';
    }

    /**
     * Изменение иконки<br>
     * Вызывает функцию из конфига блота
     * @memberof Hint
     */
  }, {
    key: "setIcon",
    value: function setIcon(event) {
      var _this2 = this;
      if (this.editor.mode !== MODE_READONLY) {
        if (typeof this.blotConfig.setIcon === 'function') {
          this.blotConfig.setIcon(this.id, event.target).then(function (data) {
            if (data.icon) {
              _this2.map.set('icon', data.icon);
            }
          });
        }
      }
    }

    /**
     * Переопределяем функцию getColor() в Colorable миксине<br>
     * для собственного дефолтного фона
     * @memberof Hint
     */
  }, {
    key: "getColor",
    value: function getColor() {
      var color = this.map.get('color');
      return color && color !== 'transparent' ? color : 'grey';
    }

    /**
     * Возвращает допустимые форматы для всплывающего меню
     * @memberof Hint
     */
  }, {
    key: "getAllowedStyles",
    value: function getAllowedStyles() {
      return hint_FORMAT_STYLES;
    }

    /**
     * Рендер<br>
     * Используется для установки background color
     * @memberof Hint
     */
  }, {
    key: "render",
    value: function render() {
      hint_get(blots_hint_getPrototypeOf(Hint.prototype), "render", this).call(this);
      // Стоит вынести в colorable mixin, но его используют и другие блоты, их надо перепроверить
      this.domNode.setAttribute('data-block-background', this.getColor());
    }

    /**
     * Рендер контента блока
     * @memberof Hint
     */
  }, {
    key: "renderContent",
    value: function renderContent() {
      var i18n = this.editor.plugins.i18n;
      var maxAvailableWidth = this.props.maxAvailableWidth || this.domNode.offsetWidth;
      var placeholder = !maxAvailableWidth || maxAvailableWidth >= 300 ? i18n.get('embedded_menu.hint_placeholder') : false;
      var props = {
        align: this.align
      };
      return (0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)(HintIcon, {
        icon: this.icon,
        setIcon: this.setIcon.bind(this),
        disabled: Boolean(this.props.blotLocked)
      }), (0,preact_module.h)(NimbusText, blots_hint_extends({
        parent: this,
        characters: this.map.get('characters'),
        placeholder: placeholder
      }, props)));
    }

    /**
     * Возвращает парамеметры блота при копировании<br>
     * Добавляем к параметрам textLineType и icon
     * @memberof Hint
     * @param { any[] } ...args - аргументы
     * @returns { object }
     */
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams() {
      var _get4;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      var params = (_get4 = hint_get(blots_hint_getPrototypeOf(Hint.prototype), "getBlotInsertParams", this)).call.apply(_get4, [this].concat(args));
      return (0,util/* mergeDeep */.Ee)(params, {
        textLineType: this.constructor.blotName,
        initParams: {
          icon: this.icon
        }
      });
    }

    /**
     * Обработчик вставки
     * @memberof Hint
     * @param { object } param
     * @param { string } param.text - вставляемый текст
     * @returns { boolean }
     */
  }, {
    key: "toHTML",
    value:
    /**
     * Возвращает html код блота
     * @memberof Hint
     * @param { object } context
     * @returns { string } html
     */
    function toHTML(context) {
      var _this3 = this;
      var dataAttrs = '';
      var _iterator2 = hint_createForOfIteratorHelper(this.domNode.attributes),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var attr = _step2.value;
          if (attr.name.startsWith('data-')) {
            dataAttrs += ' ' + attr.name + '="' + attr.value + '"';
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var css = '';
      if (context.options.toEmail) {
        css = " background-color: rgba(96,125,139,.2); padding: 5px 10px 5px 10px; margin: 5px 0;";
      }
      var iconNode = stringIsUrl(this.icon) ? "<img src=\"".concat(this.icon, "\" style=\"max-width: 24px; max-height: 24px\" alt=\"\" />") : this.icon;
      var iconHTML = "<div class=\"uneditable-container hintblock-icon\"><span>".concat(iconNode, "</span></div>");
      var innerText = this.children.map(function (child) {
        return "<div className=\"nimbus-text text-align-".concat(_this3.map.get('align'), "\">").concat(child.toHTML ? child.toHTML(context) : '', "</div>");
      }).join('');
      return "<div class=\"".concat(this.domNode.className, "\" ").concat(dataAttrs, " style=\"").concat(css, "\">").concat(iconHTML).concat(innerText, "</div>");
    }
    /**
     * Добавляет иконку при клонировании
     * @memberof Hint
     * @returns { object }
     */
  }, {
    key: "getCloneParams",
    value: function getCloneParams() {
      var _get5;
      var cloneParams = ((_get5 = hint_get(blots_hint_getPrototypeOf(Hint.prototype), "getCloneParams", this)) === null || _get5 === void 0 ? void 0 : _get5.call(this)) || {};
      cloneParams.icon = this.icon;
      return cloneParams;
    }
  }, {
    key: "getMarkdown",
    value: function getMarkdown() {
      var _this$map$get;
      var ops = ((_this$map$get = this.map.get('characters')) === null || _this$map$get === void 0 ? void 0 : _this$map$get.toDelta()) || [];
      return deltaToMarkdown({
        ops: ops
      }).trim() + '\n\n';
    }
  }]);
  return Hint;
}(hint_mixin(primary));
hint_Hint.blotName = 'hint';
hint_Hint.tagName = 'DIV';
hint_Hint.isTextBlot = true;
/**
 * Инициализация map блота
 * @param { Ymap } map - map блока
 * @param { object } store - store
 * @param { object } params - параметры инициализации
 * @memberof Hint
 */
hint_Hint.initMap = function (map, store) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  map.set('type', hint_Hint.blotName);
  if (params.icon) {
    map.set('icon', params.icon);
  }
  newTextLine.initMap(map, store, params);
  alignable.initMap(map, store, params);
  indentable.initMap(map, store, params);
  colorable.initMap(map, store, params);
  colorsConfigurable.initMap(map, store, params);
};
hint_Hint.allowedChildren = [newTextLine];
/* harmony default export */ const hint = (hint_Hint);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/mixins/clickParagraph.js
function clickParagraph_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { clickParagraph_typeof = function _typeof(obj) { return typeof obj; }; } else { clickParagraph_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return clickParagraph_typeof(obj); }












function clickParagraph_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function clickParagraph_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function clickParagraph_createClass(Constructor, protoProps, staticProps) { if (protoProps) clickParagraph_defineProperties(Constructor.prototype, protoProps); if (staticProps) clickParagraph_defineProperties(Constructor, staticProps); return Constructor; }
function clickParagraph_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { clickParagraph_get = Reflect.get; } else { clickParagraph_get = function _get(target, property, receiver) { var base = clickParagraph_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return clickParagraph_get(target, property, receiver || target); }
function clickParagraph_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = clickParagraph_getPrototypeOf(object); if (object === null) break; } return object; }
function clickParagraph_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) clickParagraph_setPrototypeOf(subClass, superClass); }
function clickParagraph_setPrototypeOf(o, p) { clickParagraph_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return clickParagraph_setPrototypeOf(o, p); }
function clickParagraph_createSuper(Derived) { var hasNativeReflectConstruct = clickParagraph_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = clickParagraph_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = clickParagraph_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return clickParagraph_possibleConstructorReturn(this, result); }; }
function clickParagraph_possibleConstructorReturn(self, call) { if (call && (clickParagraph_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return clickParagraph_assertThisInitialized(self); }
function clickParagraph_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function clickParagraph_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function clickParagraph_getPrototypeOf(o) { clickParagraph_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return clickParagraph_getPrototypeOf(o); }






/**
 * данный миксин обрабатывает клик на элементе и ставит курсор в последний TextLine в этом элементе
 * если такового нету, то он создается.
 * миксин может быть применен только на контейнер
 */

function getMouseEventPosition(event, blot) {
  // позиция клика относительно текущего контейнера
  var containerY = (0,dom/* getElementPosition */._z)(blot.domNode).top;
  var layerY = event.pageY - containerY;
  var lastChildDim = (0,dom/* getElementPosition */._z)(blot.children.tail.domNode);
  var firstChildY = (0,dom/* getElementPosition */._z)(blot.children.head.domNode).top - containerY;
  var lastChildYBottom = lastChildDim.top - containerY + lastChildDim.height;
  if (layerY < firstChildY) {
    return {
      checkChild: blot.children.head,
      position: 'top'
    };
  } else if (layerY > lastChildYBottom) {
    return {
      checkChild: blot.children.tail,
      position: 'bottom'
    };
  } else {
    return null;
  }
}
function onMouseDown(event) {
  if (event.target !== this.domNode) {
    return;
  }
  if (!this.children.length) {
    return;
  }

  // определяем пользователь кликнул в начале элемента или в конце
  var mouseDownPosition = getMouseEventPosition(event, this);
  if (mouseDownPosition && mouseDownPosition instanceof Object) {
    this.mouseDownPosition = mouseDownPosition.position;
  } else {
    return;
  }
}
function onMouseUp(event) {
  if (!this.mouseDownPosition) {
    return;
  }
  if (event.target !== this.domNode) {
    this.mouseDownPosition = false;
    return;
  }
  var child, checkChild, position;
  var mouseUpPosition = getMouseEventPosition(event, this);
  if (mouseUpPosition && mouseUpPosition instanceof Object && this.mouseDownPosition === mouseUpPosition.position) {
    checkChild = mouseUpPosition.checkChild;
    position = mouseUpPosition.position;
    this.mouseDownPosition = false;
  } else {
    this.mouseDownPosition = false;
    return;
  }
  if (checkChild instanceof textLine && !(checkChild.constructor.blotName === 'syntax') && !(checkChild instanceof hint) && (position === 'top' || checkChild.length() - 1 === 0)) {
    return;
  } else if (checkChild instanceof list_list && position === 'top') {
    return;
  } else if (checkChild instanceof list_list && position === 'bottom' && checkChild.children.tail.length() - 1 === 0) {
    return;
  } else {
    var params = {
      focus: {
        index: 0
      }
    };
    if (position === 'top') {
      params.before = checkChild.id;
    }
    this.addBlot('paragraph', params);
    this.editor.scroll.selection.focus();
  }
}
var ClickParagraph = function ClickParagraph(superclass) {
  return /*#__PURE__*/function (_superclass) {
    clickParagraph_inherits(_class, _superclass);
    var _super = clickParagraph_createSuper(_class);
    function _class() {
      var _this;
      clickParagraph_classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _this.clickParagraphListenerSet = false;
      _this.mouseDownPosition = false;
      if (args[1] && args[1].editor) {
        _this.setClickParagraphListener(args[1].editor);
      }
      return _this;
    }
    clickParagraph_createClass(_class, [{
      key: "attach",
      value: function attach() {
        var _get2;
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        (_get2 = clickParagraph_get(clickParagraph_getPrototypeOf(_class.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
        if (this.editor) {
          this.setClickParagraphListener();
        }
      }
    }, {
      key: "setClickParagraphListener",
      value: function setClickParagraphListener() {
        var editor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        if (this.clickParagraphListenerSet) {
          return;
        }
        this.clickParagraphListenerSet = true;
        editor = editor || this.editor;
        if (editor.mode === editor.constructor.MODE_EDIT && editor.options.render) {
          if (!this.onClickParagraphMouseDown) {
            this.onClickParagraphMouseDown = onMouseDown.bind(this);
          }
          if (!this.onDocumentClickParagraphMouseUp) {
            this.onDocumentClickParagraphMouseUp = onMouseUp.bind(this);
          }
          this.domNode.addEventListener('mousedown', this.onClickParagraphMouseDown, false);
          document.body.addEventListener('mouseup', this.onDocumentClickParagraphMouseUp, false);
        }
      }
    }, {
      key: "detach",
      value: function detach() {
        var _get3;
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }
        (_get3 = clickParagraph_get(clickParagraph_getPrototypeOf(_class.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
        if (this.editor.options.render) {
          this.domNode.removeEventListener('mousedown', this.onClickParagraphMouseDown, false);
          document.body.removeEventListener('mouseup', this.onDocumentClickParagraphMouseUp, false);
        }
      }
    }]);
    return _class;
  }(superclass);
};
/* harmony default export */ const clickParagraph = (ClickParagraph);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/contentContextHelper.js
function contentContextHelper_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = contentContextHelper_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function contentContextHelper_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return contentContextHelper_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return contentContextHelper_arrayLikeToArray(o, minLen); }
function contentContextHelper_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }












function contentContextHelper_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function contentContextHelper_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function contentContextHelper_createClass(Constructor, protoProps, staticProps) { if (protoProps) contentContextHelper_defineProperties(Constructor.prototype, protoProps); if (staticProps) contentContextHelper_defineProperties(Constructor, staticProps); return Constructor; }
var ContentContextHelper = /*#__PURE__*/function () {
  function ContentContextHelper(scroll) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      skipContainers: []
    };
    contentContextHelper_classCallCheck(this, ContentContextHelper);
    this.scroll = scroll;
    this.options = options;
  }
  contentContextHelper_createClass(ContentContextHelper, [{
    key: "getContainerContext",
    value: function getContainerContext(blot) {
      var container = blot.container;
      var containerType = container.constructor.blotName;
      // не возвращаем контейнеры, названия которых указаны в опциях контекста
      if (this.options.skipContainers.includes(containerType)) return false;
      var context = {
        containerId: container.id,
        containerType: containerType
      };
      var lastContextParentParams = context;
      while (container.container !== this.scroll) {
        container = container.container;
        containerType = container.constructor.blotName;
        // пропускаем контейнеры, названия которых указаны в опциях контекста
        if (this.options.skipContainers.includes(containerType)) continue;
        lastContextParentParams.containerParent = {
          containerId: container.id,
          containerType: containerType
        };
        lastContextParentParams = lastContextParentParams.containerParent;
      }
      return context;
    }
  }, {
    key: "processBlot",
    value: function processBlot(blot, params) {
      if (blot.container !== this.scroll) {
        params.context = this.getContainerContext(blot);
      }
      if (!params.context) {
        delete params.context;
      }
    }
  }, {
    key: "normalizeOps",
    value: function normalizeOps(ops) {
      var _this = this;
      var normalized = ops.reduce(function (result, op) {
        if (!op.context) {
          result.push(op);
        } else {
          var lastOp = result[result.length - 1];
          if (lastOp && _this.findTopLevelContainerType(op) === lastOp.type && _this.findTopLevelContainerId(op) === lastOp.id) {
            var opContainer = _this.findOpContainerInLastOp(op.context.containerId, lastOp);
            if (opContainer) {
              opContainer.items.push(op);
            } else {
              _this.addOpToLastContainerOpItems(op, lastOp);
            }
          } else {
            _this.addContainerOp(op, result);
          }
        }
        return result;
      }, []);
      this.clearOpsContext(normalized);
      return normalized;
    }
  }, {
    key: "addContainerOp",
    value: function addContainerOp(op, ops) {
      var item = op;
      while (item.context) {
        item = {
          type: item.context.containerType,
          items: [item],
          id: item.context.containerId,
          context: item.context.containerParent || null
        };
      }
      ops.push(item);
    }
  }, {
    key: "addOpToLastContainerOpItems",
    value: function addOpToLastContainerOpItems(op, lastOp) {
      var item = op;
      var isPushed = false;
      while (item.context.containerType !== lastOp.type) {
        item = {
          type: item.context.containerType,
          items: [item],
          id: item.context.containerId,
          context: item.context.containerParent
        };
        // если вложенность большая, возможно в последней запушенной операции мы найдем контейнер для вставки
        var opContainer = this.findOpContainerInLastOp(item.context.containerId, lastOp);
        if (opContainer) {
          isPushed = true;
          opContainer.items.push(item);
        }
      }
      if (!isPushed) {
        lastOp.items.push(item);
      }
    }
  }, {
    key: "findOpContainerInLastOp",
    value: function findOpContainerInLastOp(containerId, op) {
      var result = false;
      if (!op.items) return false;
      var _iterator = contentContextHelper_createForOfIteratorHelper(op.items),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item.id === containerId) {
            result = item;
          } else {
            result = this.findOpContainerInLastOp(containerId, item);
          }
          if (result) break;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return result;
    }
  }, {
    key: "findTopLevelContainerType",
    value: function findTopLevelContainerType(op) {
      var context = op.context;
      var type = context.containerType;
      while (context.containerParent) {
        context = context.containerParent;
        if (context) {
          type = context.containerType;
        }
      }
      return type;
    }
  }, {
    key: "findTopLevelContainerId",
    value: function findTopLevelContainerId(op) {
      var context = op.context;
      var id = context.containerId;
      while (context.containerParent) {
        context = context.containerParent;
        if (context) {
          id = context.containerId;
        }
      }
      return id;
    }
  }, {
    key: "clearOpsContext",
    value: function clearOpsContext(ops) {
      var _iterator2 = contentContextHelper_createForOfIteratorHelper(ops),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var op = _step2.value;
          if (op.hasOwnProperty('context')) {
            delete op.context;
          }
          if (op.hasOwnProperty('id')) {
            delete op.id;
          }
          if (op.items) {
            this.clearOpsContext(op.items);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }]);
  return ContentContextHelper;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/toggle/toggle.js
function toggle_toggle_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { toggle_toggle_typeof = function _typeof(obj) { return typeof obj; }; } else { toggle_toggle_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return toggle_toggle_typeof(obj); }
function toggle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function toggle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { toggle_ownKeys(Object(source), true).forEach(function (key) { toggle_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { toggle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function toggle_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = toggle_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

























function toggle_toConsumableArray(arr) { return toggle_arrayWithoutHoles(arr) || toggle_iterableToArray(arr) || toggle_unsupportedIterableToArray(arr) || toggle_nonIterableSpread(); }
function toggle_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function toggle_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return toggle_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return toggle_arrayLikeToArray(o, minLen); }
function toggle_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function toggle_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return toggle_arrayLikeToArray(arr); }
function toggle_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function toggle_toggle_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function toggle_toggle_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function toggle_toggle_createClass(Constructor, protoProps, staticProps) { if (protoProps) toggle_toggle_defineProperties(Constructor.prototype, protoProps); if (staticProps) toggle_toggle_defineProperties(Constructor, staticProps); return Constructor; }
function toggle_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { toggle_get = Reflect.get; } else { toggle_get = function _get(target, property, receiver) { var base = toggle_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return toggle_get(target, property, receiver || target); }
function toggle_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = toggle_toggle_getPrototypeOf(object); if (object === null) break; } return object; }
function toggle_toggle_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) toggle_toggle_setPrototypeOf(subClass, superClass); }
function toggle_toggle_setPrototypeOf(o, p) { toggle_toggle_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return toggle_toggle_setPrototypeOf(o, p); }
function toggle_toggle_createSuper(Derived) { var hasNativeReflectConstruct = toggle_toggle_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = toggle_toggle_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = toggle_toggle_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return toggle_toggle_possibleConstructorReturn(this, result); }; }
function toggle_toggle_possibleConstructorReturn(self, call) { if (call && (toggle_toggle_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return toggle_toggle_assertThisInitialized(self); }
function toggle_toggle_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function toggle_toggle_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function toggle_toggle_getPrototypeOf(o) { toggle_toggle_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return toggle_toggle_getPrototypeOf(o); }
function toggle_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
















var TOGGLE_CLASS_NAME = 'nimbus-toggle-header';
var HIDDEN_EXPANDED_ADD_CLASS = 'hidden-content';
var toggle_mixin = mix([commentable, blotLock, focusable, selectable, executable, basic]);
var toggle_Toggle = /*#__PURE__*/function (_mixin) {
  toggle_toggle_inherits(Toggle, _mixin);
  var _super = toggle_toggle_createSuper(Toggle);
  function Toggle(domNode) {
    var _this;
    toggle_toggle_classCallCheck(this, Toggle);
    _this = _super.call(this, domNode);
    toggle_defineProperty(toggle_toggle_assertThisInitialized(_this), "updatePlaceholderState", function () {
      if (_this.isEmpty()) {
        _this.domNode.classList.add('show-placeholder');
      } else if (_this.domNode.classList.contains('show-placeholder')) {
        _this.domNode.classList.remove('show-placeholder');
      }
    });
    _this.isCollapsibleContainerTextLine = true;
    _this.addCanExecActions(toggle_toConsumableArray(textLine.canExecActions));
    _this.hasChildrenContainer = true;
    return _this;
  }
  toggle_toggle_createClass(Toggle, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = toggle_get(toggle_toggle_getPrototypeOf(Toggle.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      if (this.getTitlePlaceholder) {
        var placeholder = this.getTitlePlaceholder();
        this.domNode.setAttribute('data-placeholder', placeholder);
        this.updatePlaceholderState();
        this.editor.on('SCROLL_UPDATE', this.updatePlaceholderState);
      }
      this.render();
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = toggle_get(toggle_toggle_getPrototypeOf(Toggle.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      this.editor.off('SCROLL_UPDATE', this.updatePlaceholderState);
    }
  }, {
    key: "getWrapper",
    value: function getWrapper() {
      return this.parent;
    }
  }, {
    key: "isCollapsed",
    value: function isCollapsed() {
      return Boolean(this.map.get('collapsed'));
    }
    // метод устанавливает флаг для рендера контента в скрытом виде,
    // необходим для сбора информации о контенте, если тоггл свернут
  }, {
    key: "setHiddenExpanded",
    value: function setHiddenExpanded() {
      var expanded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.setProps({
        isHiddenExpanded: expanded
      });
    }
  }, {
    key: "onBlotMenuUpdatePosition",
    value: function onBlotMenuUpdatePosition(_ref) {
      var left = _ref.left,
        top = _ref.top;
      left -= 32;
      return {
        left: left,
        top: top
      };
    }
  }, {
    key: "onRemoveBlot",
    value: function onRemoveBlot() {
      if (!this.isCollapsed()) {
        if (!this.content.descendants(function (blot) {
          return blot.isSelectable;
        }).every(function (blot) {
          return blot.props.selected;
        })) {
          var children = this.content.containerChildren.toArray();
          var index = this.container.getChildIndex(this.id);
          var _iterator = toggle_createForOfIteratorHelper(children),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var id = _step.value;
              this.container.moveChild(id, index);
              index++;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }
      this.container.removeChildById(this.id);
    }
  }, {
    key: "onConvertBlot",
    value: function onConvertBlot() {
      if (this.isCollapsed()) {
        this.map.set('collapsed', false);
      }
    }
  }, {
    key: "textLineAddNextBlot",
    value: function textLineAddNextBlot() {
      var initParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var blotType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var params = initParams;
      blotType = blotType || 'paragraph';
      if (this.isCollapsed()) {
        params.after = this.id;
        return this.container.addBlot(this.constructor.blotName, params);
      } else if (this.content) {
        params.before = this.content.children.head.id;
        return this.content.addBlot(blotType, params);
      }
      return false;
    }
  }, {
    key: "textLineOnEnterKey",
    value: function textLineOnEnterKey(event) {
      if (this.isCollapsed() && this.isEmpty()) {
        event.preventDefault();
        this.container.addBlot('paragraph', {
          before: this.id,
          focus: {
            index: 0
          }
        });
        this.container.removeChildById(this.id);
        return true;
      } else {
        return toggle_get(toggle_toggle_getPrototypeOf(Toggle.prototype), "textLineOnEnterKey", this).call(this, event);
      }
    }
  }, {
    key: "textLineOnTabKey",
    value: function textLineOnTabKey(event) {
      return true;
    }
  }, {
    key: "textLineOnShiftTabKey",
    value: function textLineOnShiftTabKey(event) {
      return true;
    }
  }, {
    key: "textLineOnBackspace",
    value: function textLineOnBackspace(action) {
      var blotRange = action.getBlotRange(this);
      if (blotRange.index === 0 && blotRange.length === 0) {
        action.dontRestoreSelection();
        this.container.addBlot('paragraph', {
          before: this.id,
          delta: this.delta(),
          focus: {
            index: 0
          }
        });
        this.remove();
        return true;
      }
    }
  }, {
    key: "textLineOnDblClick",
    value: function textLineOnDblClick(event, blot) {
      if (this.dblClick) {
        this.dblClick = undefined;
        return false;
      }
      event.preventDefault();
      var toggleBlot = blot;
      var isContentAvailable = !this.isCollapsed() && this.content;
      var container = isContentAvailable ? this.content : this.container;
      var toggleBlotNext = isContentAvailable ? this.content.children.head : toggleBlot.getWrapper().next;
      if (!toggleBlotNext) {
        return;
      } else {
        var blotType = toggleBlotNext.constructor.blotName === Toggle.wrapper ? this.constructor.blotName : 'paragraph';
        var params = {
          focus: {
            index: 0
          }
        };
        if (isContentAvailable) {
          params.before = toggleBlotNext.id;
        } else {
          params.after = toggleBlot.id;
        }
        container.addBlot(blotType, params);
        this.dblClick = true;
      }
      return true;
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      if (!this.content) {
        this.content = parchment_default().create('toggleContent');
        this.content.map = this.map;
        this.getWrapper().appendChild(this.content);
      }
      this.content.render();
    }
  }, {
    key: "render",
    value: function render() {
      toggle_get(toggle_toggle_getPrototypeOf(Toggle.prototype), "render", this).call(this);
      var canRenderContent = !this.isCollapsed() || this.editor.mode === MODE_EXPORT;
      if (this.props.isHiddenExpanded) {
        canRenderContent = true;
        this.getWrapper().domNode.classList.add(HIDDEN_EXPANDED_ADD_CLASS);
      } else if (this.getWrapper().domNode.classList.contains(HIDDEN_EXPANDED_ADD_CLASS)) {
        this.getWrapper().domNode.classList.remove(HIDDEN_EXPANDED_ADD_CLASS);
      }
      this.getWrapper().render();
      if (canRenderContent) {
        this.renderContent();
      } else {
        if (this.content) {
          this.content.remove();
          this.content = null;
        }
      }
    }
  }, {
    key: "cloneSelf",
    value: function cloneSelf() {
      var map = this.store.createMap();
      parchment_default().query(this.map.get('type')).initMap(map, this.store, {
        collapsed: this.isCollapsed(),
        delta: this.delta({
          forCopy: true
        }),
        items: this.getChildrenOps()
      });
      return map.get('id');
    }
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      var isSingleSelected = this.scroll.selectedBlocks.length === 1;
      var range = isSingleSelected && !this.props.selected ? blotRange : {
        index: 0,
        length: this.length() - 1
      };
      var op = toggle_get(toggle_toggle_getPrototypeOf(Toggle.prototype), "getBlotInsertParams", this).call(this, range, contextHelper);
      if (!isSingleSelected || this.props.selected) {
        op.type = this.constructor.blotName;
        op.initParams.collapsed = this.isCollapsed();
        op.initParams.items = this.getChildrenOps();
      }
      return op;
    }
  }, {
    key: "remove",
    value: function remove() {
      var _get4;
      this.onRemoveBlot();
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      (_get4 = toggle_get(toggle_toggle_getPrototypeOf(Toggle.prototype), "remove", this)).call.apply(_get4, [this].concat(args));
    }
  }, {
    key: "getChildrenOps",
    value: function getChildrenOps() {
      this.setHiddenExpanded();
      if (!this.content) return []; // на случай если контент все таки не примонтировался
      var contextHelper = new ContentContextHelper(this.content);
      var blots = this.content.descendants(function (blot) {
        return blot.isSelectable && !blot.isSelectableBlotChild;
      });
      var ops = [];
      var _iterator2 = toggle_createForOfIteratorHelper(blots),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var blot = _step2.value;
          if (blot.getBlotInsertParams) {
            var op = blot.getBlotInsertParams({
              index: 0,
              length: blot.length() - 1
            }, contextHelper);
            // блот может вернуть набор операций, например свернутый список возвращает операции элементов подсписка
            if (Array.isArray(op)) {
              ops.push.apply(ops, toggle_toConsumableArray(op));
            } else {
              ops.push(op);
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.setHiddenExpanded(false);
      return contextHelper.normalizeOps(ops);
    }
  }, {
    key: "contextMenu",
    get: function get() {
      var menu = Object.assign({}, toggle_get(toggle_toggle_getPrototypeOf(Toggle.prototype), "contextMenu", this), textMenu(this.editor));
      return menu;
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      return '<div class="' + this.domNode.className + '">' + toggle_get(toggle_toggle_getPrototypeOf(Toggle.prototype), "toHTML", this).call(this, context) + '</div>';
    }
  }, {
    key: "getMarkdown",
    value: function getMarkdown() {
      var _this$map, _this$map$get;
      var ops = ((_this$map = this.map) === null || _this$map === void 0 ? void 0 : (_this$map$get = _this$map.get('characters')) === null || _this$map$get === void 0 ? void 0 : _this$map$get.toDelta()) || [];
      var markdown = contentToMarkdown({
        initParams: {
          delta: {
            ops: ops
          }
        },
        type: this.map.get('type')
      });
      this.getChildrenOps().forEach(function (item) {
        var itemMarkdown = contentToMarkdown(item);
        if (itemMarkdown.trim()) {
          markdown += itemMarkdown;
        }
      });
      return markdown.trim() ? markdown.trim() + '\n\n' : '';
    }
  }, {
    key: "getDraggingNode",
    value: function getDraggingNode() {
      return this.getWrapper().domNode.cloneNode(true);
    }
  }], [{
    key: "convertBlots",
    value: function convertBlots(ids, store, _ref2) {
      var params = _ref2.params,
        container = _ref2.container;
      var blots = ids.map(function (id) {
        var blot = container.editor.findById(id);
        if (!blot) {
          console.error('Toggle.convertBlots could not find blot with id ' + id);
        }
        return blot;
      });
      if (!blots.every(function (blot) {
        return searchUp(blot, function (b) {
          return b.isCollapsibleContainer;
        });
      })) {
        blots = blots.filter(function (blot) {
          return !searchUp(blot, function (b) {
            return b.isCollapsibleContainer;
          });
        });
      }
      if (!blots.every(function (blot) {
        return blot.container === container;
      })) {
        if (container !== container.scroll) {
          container = container.container;
        }
      }
      // convert toggle blots
      var _iterator3 = toggle_createForOfIteratorHelper(blots),
        _step3;
      try {
        var _loop = function _loop() {
          var blot = _step3.value;
          if (blot.constructor.blotName.includes('toggle') || blot.constructor.blotName === 'step') {
            var _blot$map$toJSON = blot.map.toJSON(),
              children = _blot$map$toJSON.children;
            container.addBlot(params.type, {
              after: blot.id,
              focus: {
                index: 0
              },
              children: children,
              collapsed: blot.isCollapsed(),
              delta: onConvertBlotPrepareDelta(blot.delta())
            });
            container.removeChildById(blot.id);
            ids = ids.filter(function (id) {
              return blot.id !== id;
            });
          }
        };
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop();
        }
        // convert other blots
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      if (ids.length) {
        var initParams = {
          collapsed: false
        };
        params.initParams = params.initParams ? toggle_objectSpread(toggle_objectSpread({}, params.initParams), initParams) : initParams;
        return paragraphAbstract.convertBlots(ids, store, {
          params: params,
          container: container
        });
      }
      return true;
    }
  }, {
    key: "createBlot",
    value: function createBlot(editor) {
      var blot = parchment_default().create('toggleWrapper');
      return blot;
    }
  }, {
    key: "initMap",
    value: function initMap(map, store) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      map.set('type', 'toggle');
      map.set('collapsed', params.hasOwnProperty('collapsed') ? params.collapsed : true);
      if (!map.has('children')) {
        var children = new store.types.Array();
        if (Array.isArray(params.children)) {
          children.push(params.children);
        }
        map.set('children', children);
      }
      if (Array.isArray(params.items)) {
        var _iterator4 = toggle_createForOfIteratorHelper(params.items),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var item = _step4.value;
            var type = item.type;
            if (type === 'textLine') {
              type = item.textLineType || 'paragraph';
            }
            var itemMap = store.createMap();
            var itemParams = Object.assign({
              type: type
            }, item.initParams ? item.initParams : item);
            parchment_default().query(type).initMap(itemMap, store, itemParams);
            map.get('children').push([itemMap.get('id')]);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
      if (map.has('characters')) {
        throw new Error('Toggle\'s map already has characters, skip initMap');
      }
      map.set('characters', new store.types.Text());
      var content = map.get('characters');
      if (params.delta) {
        content.applyDelta(params.delta.ops);
      } else {
        content.insert(0, '\n');
      }
    }
  }]);
  return Toggle;
}(toggle_mixin(textLine));
toggle_Toggle.blotName = 'toggle';
toggle_Toggle.tagName = 'DIV';
toggle_Toggle.className = TOGGLE_CLASS_NAME;
toggle_Toggle.wrapper = 'toggleWrapper';
/* harmony default export */ const toggle = (toggle_Toggle);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/mixins/separableByClick.js
function separableByClick_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { separableByClick_typeof = function _typeof(obj) { return typeof obj; }; } else { separableByClick_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return separableByClick_typeof(obj); }
function separableByClick_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function separableByClick_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function separableByClick_createClass(Constructor, protoProps, staticProps) { if (protoProps) separableByClick_defineProperties(Constructor.prototype, protoProps); if (staticProps) separableByClick_defineProperties(Constructor, staticProps); return Constructor; }
function separableByClick_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { separableByClick_get = Reflect.get; } else { separableByClick_get = function _get(target, property, receiver) { var base = separableByClick_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return separableByClick_get(target, property, receiver || target); }
function separableByClick_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = separableByClick_getPrototypeOf(object); if (object === null) break; } return object; }
function separableByClick_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) separableByClick_setPrototypeOf(subClass, superClass); }
function separableByClick_setPrototypeOf(o, p) { separableByClick_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return separableByClick_setPrototypeOf(o, p); }
function separableByClick_createSuper(Derived) { var hasNativeReflectConstruct = separableByClick_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = separableByClick_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = separableByClick_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return separableByClick_possibleConstructorReturn(this, result); }; }
function separableByClick_possibleConstructorReturn(self, call) { if (call && (separableByClick_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return separableByClick_assertThisInitialized(self); }
function separableByClick_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function separableByClick_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function separableByClick_getPrototypeOf(o) { separableByClick_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return separableByClick_getPrototypeOf(o); }



















var SEARCH_BLOT_THRESHOLD = 100;
function findApplicableBlot(node) {
  if (!node) {
    return;
  }
  var blot = getBlotForNode(node);
  if (!blot) {
    return;
  }
  blot = normalizeToStoredBlot(blot);
  if (!blot) {
    return;
  }
  if (blot.getWrappedBlot && !blot.ignoreWrappedBlotOnSeparableByClick) {
    blot = blot.getWrappedBlot();
  }
  if (blot instanceof Caption) {
    blot = blot.embedBlot;
  }
  if (!blot.isSeparableByClickApplicable) {
    return;
  }
  return blot;
}
function onSeparableByClickDblClick(event) {
  var _this = this;
  if (event.target !== this.domNode) {
    if (event.target.classList[0] !== 'editor-list') {
      return;
    }
  }
  var searchStartPoint = {
    x: event.clientX,
    y: event.clientY
  };
  // search top
  var node = (0,dom/* searchByCoordinates */.Fp)(searchStartPoint, 'y', -1, event.clientY - SEARCH_BLOT_THRESHOLD, function (node) {
    return node !== _this.domNode;
  });
  var blot = findApplicableBlot(node);
  var position = 'after';
  if (!blot) {
    // search bottom
    node = (0,dom/* searchByCoordinates */.Fp)(searchStartPoint, 'y', 1, event.clientY + SEARCH_BLOT_THRESHOLD, function (node) {
      return node !== _this.domNode;
    });
    blot = findApplicableBlot(node);
    position = 'before';
  }
  if (!blot) {
    return;
  }
  event.preventDefault();
  var isList;
  if (blot instanceof list_list) {
    var liBlotNode;
    blot.domNode.childNodes.forEach(function (node) {
      var thisNode = node;
      var liNode = (0,dom/* searchByCoordinates */.Fp)(searchStartPoint, 'y', -1, event.clientY - SEARCH_BLOT_THRESHOLD, function (node) {
        return node === thisNode;
      });
      if (liNode !== null) {
        liBlotNode = liNode;
      }
    });
    if (liBlotNode) {
      blot = findApplicableBlot(liBlotNode);
      if (blot) {
        isList = true;
      }
    }
  }
  if (!isList && blot instanceof listItem) {
    blot = blot.parent;
  }
  if (!isList && !(blot instanceof toggle)) {
    if (position === 'after') {
      this.addBlot('paragraph', {
        after: blot.id,
        focus: {
          index: 0
        }
      });
    } else if (position === 'before') {
      this.addBlot('paragraph', {
        before: blot.id,
        focus: {
          index: 0
        }
      });
    }
  } else {
    blot.textLineOnDblClick(event, blot);
  }
}
var SeparableByClick = function SeparableByClick(superclass) {
  return /*#__PURE__*/function (_superclass) {
    separableByClick_inherits(_class, _superclass);
    var _super = separableByClick_createSuper(_class);
    function _class() {
      var _this2;
      separableByClick_classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this2 = _super.call.apply(_super, [this].concat(args));
      _this2.isSeparableByClick = true;
      _this2.separableByClickListenerSet = false;
      if (args[1] && args[1].editor) {
        _this2.setSeparableByClickListener(args[1].editor);
      }
      return _this2;
    }
    separableByClick_createClass(_class, [{
      key: "attach",
      value: function attach() {
        separableByClick_get(separableByClick_getPrototypeOf(_class.prototype), "attach", this).call(this);
        if (this.editor) {
          this.setSeparableByClickListener();
        }
      }
    }, {
      key: "setSeparableByClickListener",
      value: function setSeparableByClickListener() {
        var editor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        if (this.separableByClickListenerSet) {
          return;
        }
        this.separableByClickListenerSet = true;
        editor = editor || this.editor;
        if (editor.mode === editor.constructor.MODE_EDIT && editor.options.render) {
          if (!this.onSeparableByClickDblClick) {
            this.onSeparableByClickDblClick = onSeparableByClickDblClick.bind(this);
          }
          this.domNode.addEventListener('dblclick', this.onSeparableByClickDblClick, false);
        }
      }
    }, {
      key: "detach",
      value: function detach() {
        separableByClick_get(separableByClick_getPrototypeOf(_class.prototype), "detach", this).call(this);
        if (this.editor.options.render) {
          this.domNode.removeEventListener('dblclick', this.onSeparableByClickDblClick, false);
        }
      }
    }]);
    return _class;
  }(superclass);
};
/* harmony default export */ const separableByClick = (SeparableByClick);
// EXTERNAL MODULE: ./node_modules/downloadjs/download.js
var download = __webpack_require__(27266);
var download_default = /*#__PURE__*/__webpack_require__.n(download);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/attachment/audioPlayer.js
function audioPlayer_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function audioPlayer_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function audioPlayer_createClass(Constructor, protoProps, staticProps) { if (protoProps) audioPlayer_defineProperties(Constructor.prototype, protoProps); if (staticProps) audioPlayer_defineProperties(Constructor, staticProps); return Constructor; }
function audioPlayer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var audioPlayer_palette = {
  light: matLightPalette,
  dark: matDarkPalette
};
var AudioPlayer = /*#__PURE__*/function () {
  function AudioPlayer() {
    var _this = this;
    audioPlayer_classCallCheck(this, AudioPlayer);
    audioPlayer_defineProperty(this, "updateCurrentTime", function () {
      _this.fileInterface.setAudioPlayerState({
        currentProgress: _this.getCurrentTime()
      });
    });
    audioPlayer_defineProperty(this, "onThemeChange", function (event) {
      var theme = _this.blot.editor.plugins.editorStyle.getTheme();
      if (theme === 'undefined' || typeof theme === 'undefined') {
        theme = 'light';
      }
      _this.theme = theme;
      _this.updateWaveColor();
    });
    this.WaveSurfer = __webpack_require__(72863);
    this.theme = 'light';
    this.themeColors = {
      light: {
        linGrad1: vars.linGrad1,
        linGrad2: vars.linGrad2,
        progressColor: vars.progressColor,
        cursorColor: 'transparent'
      },
      dark: {
        linGrad1: vars.linGrad1dark,
        linGrad2: vars.linGrad2,
        progressColor: vars.progressColor,
        cursorColor: 'transparent'
      }
    };
    this.wfTimer = undefined;
    this.audioFile = null;
    this.global_id = null;
    this.uid = null;
    this.domNode = null;
    this.url = null;
    this.blot = null;
    this.volume = 0.5;
    this.backend = 'MediaElement';
  }
  audioPlayer_createClass(AudioPlayer, [{
    key: "initPlayer",
    value: function initPlayer(options) {
      this.global_id = options.global_id;
      this.uid = options.blot.id;
      this.domNode = options.domNode;
      this.theme = options.theme;
      this.url = options.url;
      this.blot = options.blot;
      this.fileInterface = options.fileInterface;
      this.blot.editor.emitter.on('set-theme', this.onThemeChange);
      this.fileInterface.onInitPlayer();
      this.create();
    }
  }, {
    key: "create",
    value: function create() {
      // Создаем плеер
      this.audioFile = this.WaveSurfer.create({
        container: '#wf-audio-' + this.uid,
        waveColor: this.getLinGrad(this.theme),
        progressColor: this.getProgressColor(),
        cursorColor: this.themeColors[this.theme].cursorColor,
        barWidth: 3,
        height: 50,
        backend: this.backend
      });
      this.audioFile.audio_id = this.uid;
      this.register();
    }
  }, {
    key: "register",
    value: function register() {
      var _this2 = this;
      this.audioFile.on('ready', function () {
        return _this2.onReady();
      });
      this.audioFile.on('waveform-ready', function () {
        return _this2.onWaveReady();
      });
      this.audioFile.on('finish', function () {
        return _this2.onFinish();
      });
      this.audioFile.on('play', function () {
        return _this2.onPlay();
      });
      this.audioFile.on('error', function (message) {
        return _this2.onError(message);
      });
      this.audioFile.on('pause', function () {
        return _this2.onPause();
      });
      this.audioFile.on('seek', function () {
        return _this2.onSeek();
      });
      this.audioFile.on('finish', function () {
        return _this2.onFinish();
      });
      this.loadFile(this.url);
    }
  }, {
    key: "loadFile",
    value: function loadFile(file) {
      this.audioFile.load(file);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      try {
        this.audioFile.destroy();
      } catch (e) {
        console.log('e', e);
      }
      delete this.blot.props['filePlaying'];
      delete this.blot.props['audioPlayer'];
      delete this.blot.props['isMuted'];
    }
  }, {
    key: "isPlaying",
    value: function isPlaying() {
      return this.audioFile.isPlaying();
    }
  }, {
    key: "play",
    value: function play() {
      var auid = this.blot.domNode.querySelector('#wf-audio-' + this.blot.id);
      if (auid) {
        this.audioFile.play();
      } else {
        this.audioFile = undefined;
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      this.audioFile.pause();
    }
  }, {
    key: "onWaveReady",
    value: function onWaveReady() {
      if (this.backend === 'MediaElement') {
        if (this.fileInterface.state.initPlayer) {
          this.audioDrawBuffer();
        }
        this.play();
      }
    }
  }, {
    key: "onReady",
    value: function onReady() {
      if (this.backend === 'WebAudio') {
        if (this.fileInterface.state.initPlayer) {
          this.audioDrawBuffer();
        }
        this.play();
      }
    }
  }, {
    key: "onError",
    value: function onError(message) {
      if (this.backend === 'WebAudio') {
        this.backend = 'MediaElement';
        this.create();
      } else {
        this.blot.setProps({
          fileError: true
        });
      }
    }
  }, {
    key: "onPlay",
    value: function onPlay() {
      if (this.blot.editor.scroll.activeAudioBlotId) {
        var activeBlotId = this.blot.editor.scroll.activeAudioBlotId;
        var currentBlotId = this.blot.domNode.id;
        if (currentBlotId !== activeBlotId) {
          var activeBlot = this.getBlotById(this.blot.editor.scroll, activeBlotId);
          var attachment = activeBlot && activeBlot.caption && activeBlot.caption.embedBlot;
          if (attachment && attachment.props.audioPlayer) {
            attachment.props.audioPlayer.pause();
          }
          this.blot.editor.scroll.activeAudioBlotId = this.blot.domNode.id;
        }
      } else {
        this.blot.editor.scroll.activeAudioBlotId = this.blot.domNode.id;
      }
      this.blot.setProps({
        filePlaying: true
      });
      this.updateCurrentTime();
      this.startTimer();
    }
  }, {
    key: "onPause",
    value: function onPause() {
      var renaming = this.blot.props.renaming;
      this.blot.setProps({
        filePlaying: false
      });
      if (!renaming) {
        this.updateCurrentTime();
      }
      this.stopTimer();
    }
  }, {
    key: "onSeek",
    value: function onSeek() {
      // обновляем стейт т.к. пропсы некорректно передаются
      var currentProgress = this.formatTime(this.audioFile.getCurrentTime());
      this.fileInterface.setAudioPlayerState({
        currentProgress: currentProgress
      });
      if (this.audioFile.isPlaying()) {
        this.audioFile.play();
      } else {
        this.stopTimer();
      }
    }
  }, {
    key: "onFinish",
    value: function onFinish() {
      this.blot.setProps({
        filePlaying: false
      });
      this.updateCurrentTime();
      this.stopTimer();
    }
  }, {
    key: "startTimer",
    value: function startTimer() {
      if (!this.wfTimer) {
        this.wfTimer = setInterval(this.updateCurrentTime, 1000);
      }
    }
  }, {
    key: "stopTimer",
    value: function stopTimer() {
      if (this.wfTimer) {
        clearInterval(this.wfTimer);
        this.wfTimer = undefined;
      }
    }
  }, {
    key: "getLinGrad",
    value: function getLinGrad(theme) {
      if (theme === 'brand-dark-ios') {
        theme = this.theme = 'dark';
      } else if (theme === 'undefined' || typeof theme === 'undefined') {
        theme = this.theme = 'light';
      }
      var ctx = document.createElement('canvas').getContext('2d');
      var linGrad = ctx.createLinearGradient(0, 64, 0, 200);
      linGrad.addColorStop(0.5, this.themeColors[theme].linGrad1);
      return linGrad;
    }
  }, {
    key: "audioDrawBuffer",
    value: function audioDrawBuffer() {
      this.fileInterface.onAudioDrawBuffer(this.getDuration());
      this.drawBuffer();
      this.updateCurrentTime();
      this.audioFile.setVolume(this.volume);
    }
  }, {
    key: "drawBuffer",
    value: function drawBuffer() {
      this.audioFile.drawBuffer();
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      var currentProgress = 0;
      // испольузем try т.к. audioFile.getCurrentTime может быть но внутри вейвсерфера backend.getCurrentTime может отсутствовать.
      try {
        currentProgress = this.audioFile && this.audioFile.getCurrentTime && this.audioFile.getCurrentTime();
      } catch (e) {}
      return this.formatTime(currentProgress);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      var duration = this.audioFile && this.audioFile.getDuration() || 0;
      return this.formatTime(duration);
    }
  }, {
    key: "updateVolume",
    value: function updateVolume(volume) {
      this.volume = volume;
      this.audioFile.setVolume(this.volume);
    }
  }, {
    key: "updateMute",
    value: function updateMute(mute) {
      this.audioFile.setMute(mute);
    }
  }, {
    key: "updateWaveColor",
    value: function updateWaveColor() {
      var linGrad = this.getLinGrad(this.theme);
      try {
        this.audioFile.setWaveColor(linGrad);
      } catch (e) {
        this.updateWaveColor();
      }
      this.setProgressColor();
    }
  }, {
    key: "setProgressColor",
    value: function setProgressColor() {
      var color = this.getProgressColor();
      this.audioFile && this.audioFile.setProgressColor(color);
    }
  }, {
    key: "getProgressColor",
    value: function getProgressColor() {
      var playerColor = this.blot && this.blot.getSyncedInterfaceState && getMaterialColorName(this.blot.getSyncedInterfaceState.audioPlayerColor);
      var progressColor = this.themeColors[this.theme].progressColor;
      if (playerColor && audioPlayer_palette[this.theme] && audioPlayer_palette[this.theme][playerColor]) {
        progressColor = audioPlayer_palette[this.theme][playerColor];
      }
      if (this.theme === 'light' && playerColor === 'white') {
        progressColor = this.themeColors[this.theme].progressColor;
      }
      return progressColor;
    }
  }, {
    key: "formatTime",
    value: function formatTime(secs) {
      var minutes = Math.floor(secs / 60) || 0;
      var seconds = Math.floor(secs - minutes * 60) || 0;
      return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
    }
  }, {
    key: "getBlotById",
    value: function getBlotById(scroll, id) {
      var currentChild = scroll.children.head;
      while (currentChild) {
        if (currentChild.constructor.blotName === 'grid') {
          var gridCol = currentChild.children.head;
          while (gridCol) {
            var currentChild2 = gridCol.children.head;
            while (currentChild2) {
              if (currentChild2.id === id) {
                return currentChild2;
              }
              currentChild2 = currentChild2.next;
            }
            gridCol = gridCol.next;
          }
        }
        if (currentChild.id === id) {
          return currentChild;
        }
        currentChild = currentChild.next;
      }
      return null;
    }
  }]);
  return AudioPlayer;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/wrtc/index.js
function wrtc_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { wrtc_typeof = function _typeof(obj) { return typeof obj; }; } else { wrtc_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return wrtc_typeof(obj); }
function wrtc_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) wrtc_setPrototypeOf(subClass, superClass); }
function wrtc_setPrototypeOf(o, p) { wrtc_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return wrtc_setPrototypeOf(o, p); }
function wrtc_createSuper(Derived) { var hasNativeReflectConstruct = wrtc_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = wrtc_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = wrtc_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return wrtc_possibleConstructorReturn(this, result); }; }
function wrtc_possibleConstructorReturn(self, call) { if (call && (wrtc_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return wrtc_assertThisInitialized(self); }
function wrtc_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function wrtc_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function wrtc_getPrototypeOf(o) { wrtc_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return wrtc_getPrototypeOf(o); }











function wrtc_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function wrtc_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function wrtc_createClass(Constructor, protoProps, staticProps) { if (protoProps) wrtc_defineProperties(Constructor.prototype, protoProps); if (staticProps) wrtc_defineProperties(Constructor, staticProps); return Constructor; }
function wrtc_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var wrtc_isEscapeKey = (0,lib/* default */.ZP)('esc');



var MediaRecordPopup = /*#__PURE__*/function () {
  function MediaRecordPopup(editor) {
    var _this = this;
    wrtc_classCallCheck(this, MediaRecordPopup);
    wrtc_defineProperty(this, "onBodyKeyDown", function (event) {
      if (wrtc_isEscapeKey(event)) {
        _this.detach();
        if (_this.anchorBlot) {
          _this.anchorBlot.focusableFocus();
        }
        _this.scroll.selection.setRange(_this.rangeBefore);
      }
    });
    wrtc_defineProperty(this, "chooseScreenCam", function (event) {
      if (_this.lockedButton) {
        return false;
      }
      _this.chosenOption = 'screencam';
      _this.render();
    });
    wrtc_defineProperty(this, "chooseScreenOnly", function (event) {
      if (_this.lockedButton) {
        return false;
      }
      _this.chosenOption = 'screenonly';
      _this.render();
    });
    wrtc_defineProperty(this, "chooseCamOnly", function (event) {
      if (_this.lockedButton) {
        return false;
      }
      _this.chosenOption = 'camonly';
      _this.render();
    });
    wrtc_defineProperty(this, "cancelChoose", function (event) {
      if (_this.lockedButton) {
        return false;
      }
      _this.detach();
      if (_this.anchorBlot) {
        _this.anchorBlot.focusableFocus();
      }
      _this.scroll.selection.setRange(_this.rangeBefore);
    });
    wrtc_defineProperty(this, "startRecording", function (event) {
      if (_this.lockedButton) {
        return false;
      }
      _this.lockedButton = true;
      if (_this.anchorBlot) {
        var delta = _this.anchorBlot.map.get('characters').toDelta();
        if (delta[0].insert !== '\n') {
          var _id = _this.scroll.addBlot('paragraph', {
            after: _this.anchorBlot.id
          }).id;
          _this.anchorBlot = _this.editor.findById(_id);
        }
        _this.anchorBlot.focusableFocus();
      }
      var results = _this.editor.exec('convert-blot', {
        type: 'file',
        mediaRecord: true
      }).action.results;
      var id = results[0].addedIds[0];
      var blot = _this.editor.findById(id);
      var _blot$props = blot.props,
        wrtc = _blot$props.wrtc,
        mediaComponent = _blot$props.mediaComponent;
      mediaComponent.chosenOption = _this.chosenOption;
      if (_this.chosenOption === 'screencam') {
        wrtc.initMediaCam(blot, _this.component.chosenMicro).then(function () {
          blot.props.wrtc = wrtc.wrtc;
          mediaComponent.onWrtcInited();
        });
      } else if (_this.chosenOption === 'screenonly') {
        wrtc.initMedia(blot, _this.component.chosenMicro).then(function () {
          blot.props.wrtc = wrtc.wrtc;
          mediaComponent.onWrtcInited();
        });
      } else if (_this.chosenOption === 'camonly') {
        wrtc.initCamera(blot, _this.component.chosenMicro).then(function () {
          blot.props.wrtc = wrtc.wrtc;
          mediaComponent.onWrtcInited();
        });
      }
      _this.detach();
    });
    wrtc_defineProperty(this, "onRef", function (node) {
      _this.component = node;
    });
    this.editor = editor;
    this.scroll = editor.scroll;
    this.anchorBlot = this.scroll.selectedBlocks && this.scroll.selectedBlocks.length === 1 && this.scroll.selectedBlocks[0].getBlotName() === 'paragraph' ? this.scroll.selectedBlocks[0] : null;
    this.plugin = editor.plugins.webRTCPlugin;
    var theme = this.editor.plugins.editorStyle.getTheme();
    this.domNode = document.createElement('div');
    this.domNode.id = "mediaRecordPopup";
    this.domNode.classList.add('media-record-popup');
    this.domNode.classList.add('theme-' + theme);
    this.mediaRecordComponent = null;
  }
  wrtc_createClass(MediaRecordPopup, [{
    key: "attach",
    value: function attach() {
      this.rangeBefore = this.scroll.selection.getRange()[0];
      document.body.appendChild(this.domNode);
      this.render();
      document.body.addEventListener('keydown', this.onBodyKeyDown);
    }
  }, {
    key: "detach",
    value: function detach() {
      document.body.removeEventListener('keydown', this.onBodyKeyDown);
      this.domNode.remove();
    }
  }, {
    key: "render",
    value: function render() {
      (0,preact_module/* render */.sY)((0,preact_module.h)(plugins_i18n/* IntlProvider */.Pj, null, (0,preact_module.h)(MediaRecordPopupComponent, {
        popup: this,
        ref: this.onRef
      })), this.domNode);
    }
  }]);
  return MediaRecordPopup;
}();
var MediaRecordPopupComponent = /*#__PURE__*/function (_Component) {
  wrtc_inherits(MediaRecordPopupComponent, _Component);
  var _super = wrtc_createSuper(MediaRecordPopupComponent);
  function MediaRecordPopupComponent(props) {
    var _this2;
    wrtc_classCallCheck(this, MediaRecordPopupComponent);
    _this2 = _super.call(this, props);
    wrtc_defineProperty(wrtc_assertThisInitialized(_this2), "chooseMicro", function () {
      if (_this2.popup.lockedButton) {
        return false;
      }
      _this2.setState(function (prevState) {
        var state = {
          microChecked: false
        };
        if (!prevState.microChecked && typeof prevState.microChecked !== 'undefined') {
          state.microChecked = true;
        }
        return state;
      });
    });
    _this2.popup = props.popup;
    _this2.editor = _this2.popup.editor;
    return _this2;
  }
  wrtc_createClass(MediaRecordPopupComponent, [{
    key: "chosenMicro",
    get: function get() {
      return typeof this.state.microChecked === 'undefined' ? true : this.state.microChecked;
    }
  }, {
    key: "render",
    value: function render() {
      var i18n = this.editor.plugins.i18n;
      var screencamIco = (0,preact_module.h)(icons/* IconScreenCamIcon */.LEv, null);
      var screenonlyIco = (0,preact_module.h)(icons/* IconScreenIcon */.Y0K, null);
      var camonlyIco = (0,preact_module.h)(icons/* IconCamIcon */.vw4, null);
      var chooseMicro = null;
      var enable_micro = i18n.get('file.wrtc.enable_micro');
      if (this.popup.chosenOption === 'screencam') {
        screencamIco = (0,preact_module.h)(icons/* IconScreenCamAIcon */.RGc, null);
      } else if (this.popup.chosenOption === 'screenonly') {
        screenonlyIco = (0,preact_module.h)(icons/* IconScreenAIcon */.R4$, null);
      } else if (this.popup.chosenOption === 'camonly') {
        camonlyIco = (0,preact_module.h)(icons/* IconCamAIcon */.ShA, null);
      }
      var disableRecording = 'disabled';
      if (this.popup.chosenOption) {
        disableRecording = null;
        var disabled = false;
        if (this.popup.lockedButton) {
          disabled = true;
        }
        chooseMicro = (0,preact_module.h)("div", {
          className: "choose-micro"
        }, (0,preact_module.h)("input", {
          type: "checkbox",
          disabled: disabled,
          checked: this.chosenMicro,
          id: "choose-micro",
          onClick: this.chooseMicro
        }), (0,preact_module.h)("label", {
          htmlFor: "choose-micro"
        }, enable_micro));
      }
      return (0,preact_module.h)("div", {
        className: "choose-media-content"
      }, (0,preact_module.h)("div", {
        className: "select"
      }, i18n.get('file.wrtc.select_opt')), (0,preact_module.h)("div", {
        className: "select-buttons"
      }, (0,preact_module.h)("div", {
        className: "select-icons",
        onClick: this.popup.chooseScreenCam
      }, (0,preact_module.h)("div", null, screencamIco), (0,preact_module.h)("div", {
        className: "labels"
      }, i18n.get('file.wrtc.screencam'))), (0,preact_module.h)("div", {
        className: "select-icons",
        onClick: this.popup.chooseScreenOnly
      }, (0,preact_module.h)("div", null, screenonlyIco), (0,preact_module.h)("div", {
        className: "labels"
      }, i18n.get('file.wrtc.screenonly'))), (0,preact_module.h)("div", {
        className: "select-icons",
        onClick: this.popup.chooseCamOnly
      }, (0,preact_module.h)("div", null, camonlyIco), (0,preact_module.h)("div", {
        className: "labels"
      }, i18n.get('file.wrtc.camonly')))), chooseMicro, (0,preact_module.h)("div", {
        className: "choose-buttons"
      }, (0,preact_module.h)("button", {
        className: "choose-button",
        onClick: this.popup.cancelChoose
      }, i18n.get('file.wrtc.cancel')), (0,preact_module.h)("button", {
        className: "choose-button",
        disabled: disableRecording,
        onMouseDown: this.popup.startRecording
      }, i18n.get('file.wrtc.startRecording'))));
    }
  }]);
  return MediaRecordPopupComponent;
}(preact_module/* Component */.wA);
var WrtcRecord = /*#__PURE__*/function () {
  function WrtcRecord() {
    wrtc_classCallCheck(this, WrtcRecord);
  }
  wrtc_createClass(WrtcRecord, null, [{
    key: "prepareMediaRecord",
    value: function prepareMediaRecord(editor) {
      var mediaRecordPopup = new MediaRecordPopup(editor);
      mediaRecordPopup.attach();
    }
  }, {
    key: "onAttach",
    value: function onAttach(blot) {
      this.editor = blot.editor;
      this.scroll = this.editor.scroll;
      if (blot.map.get('audioRecord')) {
        blot.audioRecord = true;
      } else if (blot.map.get('mediaRecord')) {
        blot.mediaRecord = true;
      }
      if (blot.audioRecord || blot.mediaRecord) {
        blot.domNode.addEventListener('uploadRecordEvent', blot.uploadRecord);
        blot.dontProcessDragAndDrop = true;
        blot.parent.disallowSideDrop = true;
      }
      if (blot.audioRecord) {
        blot.props.wrtc = blot.editor.plugins.webRTCPlugin;
        blot.props.wrtc.initAudio(blot);
        blot.props.wrtc = blot.props.wrtc.wrtc;
      } else if (blot.mediaRecord) {
        blot.props.wrtc = blot.editor.plugins.webRTCPlugin;
      }
    }
  }, {
    key: "onDetach",
    value: function onDetach(blot) {
      if (blot.props.mediaRecordPopup) {
        blot.props.mediaRecordPopup.detach();
      }
      if (blot.audioRecord || blot.mediaRecord) {
        if (!blot.isChooseMedia && blot.props.wrtc) {
          if (blot.audioRecord) {
            if (blot.props.wrtc) {
              blot.props.wrtc.stopAudioRecord();
            }
          } else if (blot.mediaRecord) {
            if (blot.props.wrtc.additionalWrtc) {
              blot.props.wrtc.additionalWrtc.stopMediaRecord();
            }
            if (blot.props.wrtc) {
              blot.props.wrtc.stopMediaRecord();
            }
            if (blot.mediaComponent) {
              blot.mediaComponent.destroyComponent();
            }
          }
          blot.audioRecord = undefined;
          blot.mediaRecord = undefined;
        }
        blot.domNode.removeEventListener('uploadRecordEvent', blot.uploadRecord);
      }
      blot.scroll.selection.update();
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(blot, event) {
      if (blot.mediaRecord && blot.props.mediaComponent.state.countdownDisbaled !== true) {
        if (wrtc_isEscapeKey(event)) {
          blot.remove();
        }
      }
    }
  }, {
    key: "uploadRecord",
    value: function uploadRecord(blot, event) {
      var recordInstance = event.detail;
      if (blot.audioRecord) {
        blot.audioRecord = false;
        blot.map.delete('audioRecord');
        blot.map.delete('recordUserId');
      } else if (blot.mediaRecord) {
        blot.mediaRecord = false;
        blot.map.delete('mediaRecord');
        blot.map.delete('recordUserId');
        recordInstance.role = "streaming_video";
      }
      blot.domNode.removeEventListener('uploadRecordEvent', blot.uploadRecord);
      var file = blot.editor.plugins.attachmentManager.beforeSaveFile(recordInstance);
      var task = blot.editor.plugins.attachmentManager.saveFile(file, {
        blotName: blot.constructor.blotName,
        blotId: blot.id
      });
      blot.setProps({
        file: task.file,
        uploading: true,
        progress: 0,
        saveFileTask: null,
        setAttachmentError: null,
        recordUploading: true
      }, true);
      blot.processTask(task, task.run());
    }
  }]);
  return WrtcRecord;
}();
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/menu.js
function menu_extends() { menu_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return menu_extends.apply(this, arguments); }






function getMenuArray(menu) {
  var arr = [];
  for (var k in menu) {
    var item = Object.assign({}, menu[k]);
    item.id = k;
    arr.push(item);
  }
  arr.sort(function (item1, item2) {
    return item1.index - item2.index;
  });
  return arr;
}
function getMenuItems(menu, opts) {
  var items = getMenuArray(menu).map(function (item) {
    var props = {};
    if (item.action) {
      props.onClick = opts.onClick.bind(opts.thisArg, item);
    }
    var Icon = item.icon ? item.icon : null;
    if (item.submenu) {
      var submenuItems = getMenuItems(item.submenu, opts);
      var submenuProps = {};
      if (item.submenuOptions) {
        var submenuOptions = item.submenuOptions;
        if (submenuOptions.anchorOptions) {
          submenuProps.anchorOptions = submenuOptions.anchorOptions;
        }
      }
      props.submenu = (0,preact_module.h)(popupMenu/* default */.Z, submenuProps, submenuItems);
    }
    return (0,preact_module.h)(popupMenuItem/* default */.Z, menu_extends({
      key: item.id,
      id: item.id,
      text: item.label,
      icon: Icon,
      hint: item.hint
    }, props));
  });
  return items;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/attachment/filePopupMenu.js
function filePopupMenu_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { filePopupMenu_typeof = function _typeof(obj) { return typeof obj; }; } else { filePopupMenu_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return filePopupMenu_typeof(obj); }










function filePopupMenu_extends() { filePopupMenu_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return filePopupMenu_extends.apply(this, arguments); }
function filePopupMenu_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function filePopupMenu_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function filePopupMenu_createClass(Constructor, protoProps, staticProps) { if (protoProps) filePopupMenu_defineProperties(Constructor.prototype, protoProps); if (staticProps) filePopupMenu_defineProperties(Constructor, staticProps); return Constructor; }
function filePopupMenu_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) filePopupMenu_setPrototypeOf(subClass, superClass); }
function filePopupMenu_setPrototypeOf(o, p) { filePopupMenu_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return filePopupMenu_setPrototypeOf(o, p); }
function filePopupMenu_createSuper(Derived) { var hasNativeReflectConstruct = filePopupMenu_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = filePopupMenu_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = filePopupMenu_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return filePopupMenu_possibleConstructorReturn(this, result); }; }
function filePopupMenu_possibleConstructorReturn(self, call) { if (call && (filePopupMenu_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return filePopupMenu_assertThisInitialized(self); }
function filePopupMenu_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function filePopupMenu_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function filePopupMenu_getPrototypeOf(o) { filePopupMenu_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return filePopupMenu_getPrototypeOf(o); }



var FilePopupMenu = /*#__PURE__*/function (_Component) {
  filePopupMenu_inherits(FilePopupMenu, _Component);
  var _super = filePopupMenu_createSuper(FilePopupMenu);
  function FilePopupMenu(props) {
    filePopupMenu_classCallCheck(this, FilePopupMenu);
    return _super.call(this, props);
  }
  filePopupMenu_createClass(FilePopupMenu, [{
    key: "onClickItem",
    value: function onClickItem(item, event) {
      event && event.stopPropagation();
      this.props.parent[item.action]();
      if (this.props.wantsToClose) this.props.wantsToClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        menu = _this$props.menu,
        additionalMenu = _this$props.additionalMenu;
      var menuItems = getMenuItems(menu, {
        thisArg: this,
        onClick: this.onClickItem
      });
      return (0,preact_module.h)(popupMenu/* default */.Z, filePopupMenu_extends({
        closeOnEsc: true,
        addClassName: "with-language-submenu"
      }, this.props), additionalMenu, menuItems);
    }
  }]);
  return FilePopupMenu;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/attachment/fileRenameInput.js
function fileRenameInput_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { fileRenameInput_typeof = function _typeof(obj) { return typeof obj; }; } else { fileRenameInput_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return fileRenameInput_typeof(obj); }










function fileRenameInput_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function fileRenameInput_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function fileRenameInput_createClass(Constructor, protoProps, staticProps) { if (protoProps) fileRenameInput_defineProperties(Constructor.prototype, protoProps); if (staticProps) fileRenameInput_defineProperties(Constructor, staticProps); return Constructor; }
function fileRenameInput_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) fileRenameInput_setPrototypeOf(subClass, superClass); }
function fileRenameInput_setPrototypeOf(o, p) { fileRenameInput_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return fileRenameInput_setPrototypeOf(o, p); }
function fileRenameInput_createSuper(Derived) { var hasNativeReflectConstruct = fileRenameInput_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = fileRenameInput_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = fileRenameInput_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return fileRenameInput_possibleConstructorReturn(this, result); }; }
function fileRenameInput_possibleConstructorReturn(self, call) { if (call && (fileRenameInput_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return fileRenameInput_assertThisInitialized(self); }
function fileRenameInput_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function fileRenameInput_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function fileRenameInput_getPrototypeOf(o) { fileRenameInput_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return fileRenameInput_getPrototypeOf(o); }
function fileRenameInput_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var fileRenameInput_isEnter = (0,lib/* default */.ZP)('enter');
var fileRenameInput_isEsc = (0,lib/* default */.ZP)('esc');
var FileRenameInput = /*#__PURE__*/function (_Component) {
  fileRenameInput_inherits(FileRenameInput, _Component);
  var _super = fileRenameInput_createSuper(FileRenameInput);
  function FileRenameInput(props) {
    var _this;
    fileRenameInput_classCallCheck(this, FileRenameInput);
    _this = _super.call(this, props);
    fileRenameInput_defineProperty(fileRenameInput_assertThisInitialized(_this), "onInputRef", function (node) {
      _this.inputNode = node;
      _this.props.inputRef(node);
    });
    fileRenameInput_defineProperty(fileRenameInput_assertThisInitialized(_this), "onKeyDown", function (event) {
      _this.isEscEvent = undefined;
      _this.isEnterEvent = undefined;
      if (fileRenameInput_isEnter(event)) {
        _this.isEnterEvent = true;
        _this.saveName();
      } else if (fileRenameInput_isEsc(event)) {
        _this.isEscEvent = true;
        _this.props.onAbort();
      }
    });
    fileRenameInput_defineProperty(fileRenameInput_assertThisInitialized(_this), "onBlur", function (event) {
      if (!_this.isEscEvent && !_this.isEnterEvent) {
        _this.saveName();
      }
    });
    fileRenameInput_defineProperty(fileRenameInput_assertThisInitialized(_this), "onInput", function (event) {
      _this.setState(function () {
        return {
          name: event.target.value
        };
      });
    });
    _this.state = {
      name: props.name
    };
    _this.inputNode = null;
    return _this;
  }
  fileRenameInput_createClass(FileRenameInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var name = this.props.name;
      // выделяем текст в input до последней точки
      // const dotIndex = name.lastIndexOf('.')
      // let lastIndex = dotIndex >= 0 ? dotIndex : name.length - 1
      this.inputNode.focus();
      this.inputNode.setSelectionRange(0, name.length);
    }
  }, {
    key: "saveName",
    value: function saveName() {
      this.props.onApply(this.state.name + '.' + this.props.ext, this.isEnterEvent);
    }
  }, {
    key: "render",
    value: function render() {
      return (0,preact_module.h)("div", null, (0,preact_module.h)("input", {
        contenteditable: "true",
        ref: this.onInputRef,
        type: "text",
        defaultValue: this.state.name,
        onKeyDown: this.onKeyDown,
        onInput: this.onInput,
        onBlur: this.onBlur
      }));
    }
  }]);
  return FileRenameInput;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/scss/file-vars.scss
var file_vars = __webpack_require__(26158);
// EXTERNAL MODULE: ./node_modules/popper.js/dist/esm/popper.js
var popper = __webpack_require__(12212);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/attachment/fileActionTooltip.js
function fileActionTooltip_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { fileActionTooltip_typeof = function _typeof(obj) { return typeof obj; }; } else { fileActionTooltip_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return fileActionTooltip_typeof(obj); }










function fileActionTooltip_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function fileActionTooltip_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function fileActionTooltip_createClass(Constructor, protoProps, staticProps) { if (protoProps) fileActionTooltip_defineProperties(Constructor.prototype, protoProps); if (staticProps) fileActionTooltip_defineProperties(Constructor, staticProps); return Constructor; }
function fileActionTooltip_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) fileActionTooltip_setPrototypeOf(subClass, superClass); }
function fileActionTooltip_setPrototypeOf(o, p) { fileActionTooltip_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return fileActionTooltip_setPrototypeOf(o, p); }
function fileActionTooltip_createSuper(Derived) { var hasNativeReflectConstruct = fileActionTooltip_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = fileActionTooltip_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = fileActionTooltip_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return fileActionTooltip_possibleConstructorReturn(this, result); }; }
function fileActionTooltip_possibleConstructorReturn(self, call) { if (call && (fileActionTooltip_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return fileActionTooltip_assertThisInitialized(self); }
function fileActionTooltip_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function fileActionTooltip_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function fileActionTooltip_getPrototypeOf(o) { fileActionTooltip_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return fileActionTooltip_getPrototypeOf(o); }
function fileActionTooltip_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var FileActionTooltip = /*#__PURE__*/function (_Component) {
  fileActionTooltip_inherits(FileActionTooltip, _Component);
  var _super = fileActionTooltip_createSuper(FileActionTooltip);
  function FileActionTooltip() {
    var _this;
    fileActionTooltip_classCallCheck(this, FileActionTooltip);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    fileActionTooltip_defineProperty(fileActionTooltip_assertThisInitialized(_this), "onRef", function (node) {
      _this.rootNode = node;
    });
    fileActionTooltip_defineProperty(fileActionTooltip_assertThisInitialized(_this), "onSizeUpdate", function () {
      _this._popper.scheduleUpdate();
    });
    return _this;
  }
  fileActionTooltip_createClass(FileActionTooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var attachToNode = this.rootNode.parentNode.querySelector('.compact-view-content');
      this._popper = new popper/* default */.Z(attachToNode, this.rootNode, {
        placement: 'top',
        modifiers: {
          preventOverflow: {
            enabled: true,
            priority: ['left', 'right']
          },
          flip: {
            enabled: false
          }
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._popper.destroy();
    }
  }, {
    key: "render",
    value: function render() {
      var children = (0,preact_module/* toChildArray */.bR)(this.props.children);
      if (children[0] && children[0].props) {
        children[0].props.onSizeUpdate = this.onSizeUpdate;
      }
      return (0,preact_module.h)("div", {
        className: "file-action-tooltip",
        ref: this.onRef
      }, children);
    }
  }]);
  return FileActionTooltip;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/lodash.tofinite/index.js
var lodash_tofinite = __webpack_require__(62899);
var lodash_tofinite_default = /*#__PURE__*/__webpack_require__.n(lodash_tofinite);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js
var compat_module = __webpack_require__(10097);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(23398);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/text-metrics/dist/text-metrics.js
var text_metrics = __webpack_require__(56153);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/node_modules/preact-middle-truncate/src/react-middle-truncate/middle-truncate.js
function middle_truncate_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { middle_truncate_typeof = function _typeof(obj) { return typeof obj; }; } else { middle_truncate_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return middle_truncate_typeof(obj); }














var middle_truncate_excluded = ["text", "ellipsis", "style", "onResizeDebounceMs", "smartCopy"];
function middle_truncate_extends() { middle_truncate_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return middle_truncate_extends.apply(this, arguments); }
function middle_truncate_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function middle_truncate_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { middle_truncate_ownKeys(Object(source), true).forEach(function (key) { middle_truncate_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { middle_truncate_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function middle_truncate_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = middle_truncate_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function middle_truncate_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






function middle_truncate_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function middle_truncate_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function middle_truncate_createClass(Constructor, protoProps, staticProps) { if (protoProps) middle_truncate_defineProperties(Constructor.prototype, protoProps); if (staticProps) middle_truncate_defineProperties(Constructor, staticProps); return Constructor; }
function middle_truncate_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) middle_truncate_setPrototypeOf(subClass, superClass); }
function middle_truncate_setPrototypeOf(o, p) { middle_truncate_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return middle_truncate_setPrototypeOf(o, p); }
function middle_truncate_createSuper(Derived) { var hasNativeReflectConstruct = middle_truncate_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = middle_truncate_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = middle_truncate_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return middle_truncate_possibleConstructorReturn(this, result); }; }
function middle_truncate_possibleConstructorReturn(self, call) { if (call && (middle_truncate_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return middle_truncate_assertThisInitialized(self); }
function middle_truncate_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function middle_truncate_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function middle_truncate_getPrototypeOf(o) { middle_truncate_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return middle_truncate_getPrototypeOf(o); }
function middle_truncate_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






// A React component for truncating text in the middle of the string.
//
// This component automatically calculates the required width and height of the text
// taking into consideration any inherited font and line-height styles, and compares it to
// the available space to determine whether to truncate or not.

// By default the component will truncate the middle of the text if
// the text would otherwise overflow using a position 0 at the start of the string,
// and position 0 at the end of the string.
//
// You can pass start and end props a number to offset this position, or alternatively
// a Regular Expression to calculate these positions dynamically against the text itself.
var MiddleTruncate = /*#__PURE__*/function (_Component) {
  middle_truncate_inherits(MiddleTruncate, _Component);
  var _super = middle_truncate_createSuper(MiddleTruncate);
  function MiddleTruncate(props) {
    var _this;
    middle_truncate_classCallCheck(this, MiddleTruncate);
    _this = _super.call(this, props);
    middle_truncate_defineProperty(middle_truncate_assertThisInitialized(_this), "onComponentRef", function (node) {
      _this.refComponent = node;
    });
    middle_truncate_defineProperty(middle_truncate_assertThisInitialized(_this), "onTextRef", function (node) {
      _this.refText = node;
    });
    middle_truncate_defineProperty(middle_truncate_assertThisInitialized(_this), "onEllipsisRef", function (node) {
      _this.refEllipsis = node;
    });
    middle_truncate_defineProperty(middle_truncate_assertThisInitialized(_this), "state", {
      truncatedText: _this.props.text,
      start: _this.getStartOffset(_this.props.start, _this.props.text),
      end: _this.getEndOffset(_this.props.end, _this.props.text)
    });
    middle_truncate_defineProperty(middle_truncate_assertThisInitialized(_this), "getTextMeasurement", function (ref) {
      var node = (0,compat_module.findDOMNode)(ref);
      var text = node.textContent;
      var metrics = (0,text_metrics.init)(node);
      var width = metrics.width(text);
      return {
        width: {
          value: width,
          unit: 'px'
        }
      };
    });
    middle_truncate_defineProperty(middle_truncate_assertThisInitialized(_this), "getComponentMeasurement", function () {
      var node = _this.refComponent;
      var offsetWidth = node.offsetWidth,
        offsetHeight = node.offsetHeight;
      return {
        width: {
          value: offsetWidth,
          unit: 'px'
        },
        height: {
          value: offsetHeight,
          unit: 'px'
        }
      };
    });
    _this.getStartOffset = _this.getStartOffset.bind(middle_truncate_assertThisInitialized(_this));
    _this.getEndOffset = _this.getEndOffset.bind(middle_truncate_assertThisInitialized(_this));
    _this.onCopy = _this.onCopy.bind(middle_truncate_assertThisInitialized(_this));
    _this.calculateMeasurements = _this.calculateMeasurements.bind(middle_truncate_assertThisInitialized(_this));
    _this.truncateText = _this.truncateText.bind(middle_truncate_assertThisInitialized(_this));
    _this.refComponent = null;
    _this.refText = null;
    _this.refEllipsis = null;
    _this.textCache = null;
    _this.initTruncateComplete = false;
    return _this;
  }
  middle_truncate_createClass(MiddleTruncate, [{
    key: "init",
    value: function init() {
      if (this.initTruncateComplete) {
        return;
      }
      this.onResize();
      this.initTruncateComplete = true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (this.props.autoTruncate !== false) {
        setTimeout(function () {
          return _this2.parseTextForTruncation(_this2.props.text);
        }, 0);
      }
      // truncate again when the window is loaded, doing so we make sure that
      // the text will be truncated with its font loaded
      if (document.fonts.ready) {
        document.fonts.ready.then(function () {
          return _this2.parseTextForTruncation(_this2.props.text);
        });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;
      if (nextProps.text !== this.props.text) {
        setTimeout(function () {
          return _this3.parseTextForTruncation(nextProps.text);
        }, 0);
      }
      if (nextProps.start !== this.props.start) {
        this.setState({
          start: this.getStartOffset(nextProps.start, nextProps.text)
        });
      }
      if (nextProps.end !== this.props.end) {
        this.setState({
          end: this.getEndOffset(nextProps.end, nextProps.text)
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
    }
  }, {
    key: "onCopy",
    value: function onCopy(event) {
      var smartCopy = this.props.smartCopy;

      // If smart copy is not enabled, simply return and use the default behaviour of the copy event
      if (!smartCopy) {
        return;
      }
      var selectedText = window.getSelection().toString();

      // If smartCopy is set to partial or if smartCopy is set to all and the entire string was selected
      // copy the original full text to the user's clipboard
      if (smartCopy === 'partial' || smartCopy === 'all' && selectedText === this.state.truncatedText) {
        event.preventDefault();
        var clipboardData = event.clipboardData || window.clipboardData || event.originalEvent.clipboardData;
        clipboardData.setData('text/plain', this.props.text);
      }
    }
  }, {
    key: "onResize",
    value: function onResize() {
      this.parseTextForTruncation(this.props.text);
    }
  }, {
    key: "getStartOffset",
    value: function getStartOffset(start, text) {
      if (start === '' || start === null) {
        return 0;
      }
      if (!isNaN(parseInt(start, 10))) {
        return Math.round(lodash_tofinite_default()(start));
      }
      var result = new RegExp(start).exec(text);
      return result ? result.index + result[0].length : 0;
    }
  }, {
    key: "getEndOffset",
    value: function getEndOffset(end, text) {
      if (end === '' || end === null) {
        return 0;
      }
      if (!isNaN(parseInt(end, 10))) {
        return Math.round(lodash_tofinite_default()(end));
      }
      var result = new RegExp(end).exec(text);
      return result ? result[0].length : 0;
    }
  }, {
    key: "calculateMeasurements",
    value: function calculateMeasurements() {
      return {
        component: this.getComponentMeasurement(),
        ellipsis: this.getTextMeasurement(this.refEllipsis),
        text: this.getTextMeasurement(this.refText)
      };
    }
  }, {
    key: "truncateText",
    value: function truncateText(measurements) {
      var _this$props = this.props,
        text = _this$props.text,
        ellipsis = _this$props.ellipsis;
      var _this$state = this.state,
        start = _this$state.start,
        end = _this$state.end;
      if (measurements.component.width.value <= measurements.ellipsis.width.value) {
        return ellipsis;
      }
      if (this.textCache) {
        if (this.textCache.text === text && this.textCache.componentWidth === measurements.component.width.value && this.textCache.textWidth === measurements.text.width) {
          return this.textCache.truncatedText;
        }
      }
      var newText;
      for (var k = 1; k > 0.5; k -= 0.05) {
        var charWidth = measurements.text.width.value / text.length * k;
        var delta = measurements.text.width.value - measurements.component.width.value;
        if (delta <= 0) {
          newText = text;
          break;
        }
        var totalLettersToRemove = Math.ceil(delta / charWidth / 2);
        var middleIndex = Math.round(text.length / 2);
        if (totalLettersToRemove >= middleIndex) {
          newText = '...';
          break;
        }
        var preserveLeftSide = text.slice(0, start);
        var leftSide = text.slice(start, middleIndex - totalLettersToRemove);
        var rightSide = text.slice(middleIndex + totalLettersToRemove, text.length - end);
        var preserveRightSide = text.slice(text.length - end, text.length);
        newText = "".concat(preserveLeftSide).concat(leftSide).concat(ellipsis).concat(rightSide).concat(preserveRightSide);
        this.refText.textContent = newText;
        var newTextMeasurement = this.getTextMeasurement(this.refText);
        this.refText.textContent = this.props.text;
        if (newTextMeasurement.width.value <= measurements.component.width.value) {
          break;
        }
      }
      this.textCache = {
        text: text,
        truncatedText: newText,
        componentWidth: measurements.component.width.value,
        textWidth: measurements.text.width.value
      };
      return newText;
    }
  }, {
    key: "parseTextForTruncation",
    value: function parseTextForTruncation(text) {
      var measurements = this.calculateMeasurements();
      var truncatedText = Math.round(measurements.text.width.value) > Math.round(measurements.component.width.value) ? this.truncateText(measurements) : text;
      this.setState(function () {
        return {
          truncatedText: truncatedText
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props2 = this.props,
        text = _this$props2.text,
        ellipsis = _this$props2.ellipsis,
        style = _this$props2.style,
        onResizeDebounceMs = _this$props2.onResizeDebounceMs,
        smartCopy = _this$props2.smartCopy,
        otherProps = middle_truncate_objectWithoutProperties(_this$props2, middle_truncate_excluded);
      var truncatedText = this.state.truncatedText;
      var componentStyle = middle_truncate_objectSpread(middle_truncate_objectSpread({}, style), {}, {
        display: 'block',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
      });
      var hiddenStyle = {
        display: 'none'
      };
      delete otherProps.onClick;
      return (0,preact_module.h)("div", middle_truncate_extends({
        ref: this.onComponentRef,
        style: componentStyle,
        onCopy: this.onCopy
      }, otherProps), (0,preact_module.h)("span", {
        ref: this.onTextRef,
        style: hiddenStyle
      }, text), (0,preact_module.h)("span", {
        ref: this.onEllipsisRef,
        style: hiddenStyle
      }, ellipsis), (0,preact_module.h)("span", {
        onClick: this.props.onClick,
        className: "truncated-text"
      }, truncatedText));
    }
  }]);
  return MiddleTruncate;
}(preact_module/* Component */.wA);
middle_truncate_defineProperty(MiddleTruncate, "propTypes", {
  className: (prop_types_default()).string,
  ellipsis: (prop_types_default()).string,
  end: prop_types_default().oneOfType([(prop_types_default()).number, prop_types_default().instanceOf(RegExp), (prop_types_default()).string]),
  onResizeDebounceMs: (prop_types_default()).number,
  smartCopy: prop_types_default().oneOfType([prop_types_default().oneOf(['partial', 'all']), (prop_types_default()).bool]),
  start: prop_types_default().oneOfType([(prop_types_default()).number, prop_types_default().instanceOf(RegExp), (prop_types_default()).string]),
  style: (prop_types_default()).object,
  text: (prop_types_default()).string
});
middle_truncate_defineProperty(MiddleTruncate, "defaultProps", {
  className: '',
  ellipsis: '...',
  end: 0,
  onResizeDebounceMs: 100,
  smartCopy: 'all',
  start: 0,
  style: {},
  text: ''
});
/* harmony default export */ const middle_truncate = (MiddleTruncate);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/node_modules/preact-middle-truncate/src/react-middle-truncate/index.js

/* harmony default export */ const react_middle_truncate = (middle_truncate);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/attachment/interfaces/Common.js
function Common_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Common_typeof = function _typeof(obj) { return typeof obj; }; } else { Common_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Common_typeof(obj); }
function Common_extends() { Common_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Common_extends.apply(this, arguments); }




















function Common_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function Common_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function Common_createClass(Constructor, protoProps, staticProps) { if (protoProps) Common_defineProperties(Constructor.prototype, protoProps); if (staticProps) Common_defineProperties(Constructor, staticProps); return Constructor; }
function Common_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Common_setPrototypeOf(subClass, superClass); }
function Common_setPrototypeOf(o, p) { Common_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Common_setPrototypeOf(o, p); }
function Common_createSuper(Derived) { var hasNativeReflectConstruct = Common_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Common_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Common_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Common_possibleConstructorReturn(this, result); }; }
function Common_possibleConstructorReturn(self, call) { if (call && (Common_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return Common_assertThisInitialized(self); }
function Common_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function Common_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function Common_getPrototypeOf(o) { Common_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Common_getPrototypeOf(o); }
function Common_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



















var MAX_VIEWER_HEIGHT = 600;
var CommonInterface = /*#__PURE__*/function (_Component) {
  Common_inherits(CommonInterface, _Component);
  var _super = Common_createSuper(CommonInterface);
  function CommonInterface(props) {
    var _this;
    Common_classCallCheck(this, CommonInterface);
    _this = _super.call(this, props);
    Common_defineProperty(Common_assertThisInitialized(_this), "downloadRecord", function () {
      var wrtc = _this.blot.props.wrtc;
      wrtc.download();
    });
    Common_defineProperty(Common_assertThisInitialized(_this), "setSyncedInterfaceState", function (stateUpdate) {
      _this.blot.setSyncedInterfaceState(stateUpdate);
    });
    _this.blot = props.blot;
    _this.editor = _this.blot.editor;
    _this.kindsIcons = {
      pdf: icons/* IconDocument */.szK,
      image: icons/* IconImage */.Zay,
      video: icons/* IconVideo */.OiJ,
      audio: icons/* IconAudio */.PWQ,
      doc: icons/* IconDocument */.szK,
      archive: icons/* IconFileOther */.mrQ,
      file: icons/* IconFileOther */.mrQ,
      play: icons/* IconPlayIcon */.YIl,
      pause: icons/* IconPauseIcon */.qV0,
      soundOn: icons/* IconSoundOn */.BKE,
      soundOff: icons/* IconSoundOff */.JfY
    };
    return _this;
  }
  Common_createClass(CommonInterface, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps() {
      // В компоненте обновляются только props'ы,
      // Preact X при этом не рендерит его заново.
      // При обновлении state работает нормально.
      this.setState(function (prevState) {
        return {
          ver: (prevState.ver || 0) + 1
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var editMode = this.editor.mode === MODE_EDIT;
      var fileContainer = this.props.fileContainer;
      if (this.blot.hasAttachment() && !this.blot.props.setAttachmentError && !this.blot.getUploadingBy()) {
        if (!this.blot.props.attachment) {
          this.blot.resolveAttachment();
          return this.renderUploading({
            noProgress: true,
            progress: 100,
            fileContainer: fileContainer
          });
        } else {
          if (this.blot.props.attachment.is_fetching) {
            return this.renderFetching({
              fileContainer: fileContainer,
              progress: this.blot.props.attachment.fetching_progress
            });
          }
        }
      } else if (this.blot.props.uploading) {
        return this.renderUploading({
          fileContainer: fileContainer,
          editMode: editMode
        });
      } else if (this.blot.props.setAttachmentError) {
        if (this.blot.props.setAttachmentError instanceof attachmentNotFoundError["default"] && this.blot.isAttachmentMightBeUploading()) {
          return this.renderUploading({
            noProgress: true,
            progress: 0,
            otherClientUploading: true,
            fileContainer: fileContainer,
            editMode: editMode,
            isOffline: this.blot.props.setAttachmentError.isOffline
          });
        } else {
          return this.renderError(this.blot.props.setAttachmentError);
        }
      } else {
        var uploadingBy = this.blot.getUploadingBy();
        var otherClientUploading = false;
        if (uploadingBy) {
          var uploadingByCleared = this.blot.clearUploadingByIfNeeded(uploadingBy);
          if (uploadingByCleared) {
            return;
          }
          otherClientUploading = true;
        }
        if (otherClientUploading) {
          return this.renderUploading({
            noProgress: true,
            progress: 0,
            otherClientUploading: otherClientUploading,
            fileContainer: fileContainer,
            editMode: editMode
          });
        } else {
          return this.renderEmpty();
        }
      }
    }
  }, {
    key: "setViewMode",
    value: function setViewMode(viewMode, fileContainer) {
      if (viewMode === 'compact') {
        fileContainer.classList.remove('view-mode-full');
        fileContainer.classList.add('view-mode-compact');
      } else {
        fileContainer.classList.remove('view-mode-compact');
        fileContainer.classList.add('view-mode-full');
      }
    }
  }, {
    key: "buildMenu",
    value: function buildMenu() {
      var _this2 = this;
      var menu = null;
      if (this.blot.props.menuOpen) {
        var menuRaw = this.blot.getSpecialBlotMenu();
        var addMenuRaw = this.blot.getAdditionlSpecialBlotMenu();
        var addMenuItems = Object.keys(addMenuRaw).map(function (key) {
          return Object.assign({}, addMenuRaw[key], {
            key: key
          });
        }).sort(function (item1, item2) {
          return item1.index - item2.index;
        }).map(function (item) {
          return (0,preact_module.h)(popupMenuItem/* default */.Z, {
            key: item.key,
            id: 'file-' + item.key,
            onClick: _this2.blot[item.action],
            text: item.label,
            submenu: item.submenu
          });
        });
        menu = (0,preact_module.h)(FilePopupMenu, {
          closeOnEsc: true,
          addClassName: "file-menu position-absolute",
          anchorNode: this.blot.fileMenuIconNode,
          wantsToClose: this.blot.onMenuWantsToClose,
          menu: menuRaw,
          additionalMenu: addMenuItems,
          parent: this.blot,
          anchorOptions: {
            placement: 'left-start',
            boundariesElement: this.editor.scrollingContainer
          }
        });
      }
      return menu;
    }
  }, {
    key: "buildSpecMenu",
    value: function buildSpecMenu(menu) {
      var editMode = this.editor.mode === MODE_EDIT;
      var readonlyMode = this.editor.mode === MODE_READONLY && !this.editor.options.isShare;
      var shareMode = this.editor.mode === MODE_READONLY && this.editor.options.isShare;
      var specmenu = null;
      if (editMode || readonlyMode) {
        specmenu = (0,preact_module.h)(PopupMenuTransition, null, menu);
      } else if (shareMode) {
        if (!this.blot.disallowFileMenuIcon) {
          specmenu = (0,preact_module.h)(PopupMenuTransition, null, menu);
        }
      }
      return specmenu;
    }
  }, {
    key: "renderMiddleTruncater",
    value: function renderMiddleTruncater() {
      var fileKind = this.props.fileKind;
      var fileViewer = this.blot.getFileViewer();
      var fileInfoCropNameClass;
      var fileNameInst;
      var onFileNameClick;
      if (!this.blot.blotConfig.fileNameTrim) {
        this.blot.blotConfig.fileNameTrim = 'middle';
      }
      if (fileKind === 'audio' && !this.blot.props.fileError && fileViewer) {
        if (this.editor.scroll.domNode.offsetWidth < 700) {
          fileNameInst = (0,preact_module.h)(react_middle_truncate, {
            autoTruncate: false,
            ref: this.blot.onFileNameTruncaterRef,
            text: this.blot.props.attachment.display_name,
            onClick: this.blot.onFileNameClick
          });
        } else {
          fileNameInst = (0,preact_module.h)("span", null, (0,preact_module.h)("span", {
            className: "file-name-main"
          }, this.blot.props.attachment.display_name));
          onFileNameClick = this.blot.onFileNameClick;
        }
        fileInfoCropNameClass = 'file-name-trim-middle';
      } else if (this.blot.blotConfig.fileNameTrim === 'middle' && !this.blot.dontFileNameTrim) {
        if (this.blot.disallowDownloading) {
          fileNameInst = (0,preact_module.h)(react_middle_truncate, {
            autoTruncate: false,
            ref: this.blot.onFileNameTruncaterRef,
            text: this.blot.props.attachment.display_name
          });
        } else {
          fileNameInst = (0,preact_module.h)("span", null, (0,preact_module.h)("span", {
            className: "file-name-main"
          }, this.blot.props.attachment.display_name));
          onFileNameClick = this.blot.onFileNameClick;
        }
        fileInfoCropNameClass = 'file-name-trim-middle';
      } else {
        var fileName = String(this.blot.props.attachment.display_name).split('.');
        var fileExt = fileName.pop();
        fileName = fileName.join('.');
        if (this.blot.editor.mode === MODE_EXPORT) {
          var _this$blot$getWrapper;
          var parent = (_this$blot$getWrapper = this.blot.getWrapper()) === null || _this$blot$getWrapper === void 0 ? void 0 : _this$blot$getWrapper.parent;
          if (fileName.length > 10 && parent && parent instanceof blots_gridCol) {
            fileName = fileName.substr(0, 10) + '..';
          }
        }
        fileNameInst = (0,preact_module.h)("span", null, (0,preact_module.h)("span", {
          className: "file-name-main"
        }, fileName, "."), (0,preact_module.h)("span", {
          className: "file-name-ext"
        }, fileExt));
        onFileNameClick = this.blot.onFileNameClick;
        fileInfoCropNameClass = 'file-name-trim-end';
      }
      return {
        fileNameInst: fileNameInst,
        onFileNameClick: onFileNameClick,
        fileInfoCropNameClass: fileInfoCropNameClass
      };
    }
  }, {
    key: "renderMenuButton",
    value: function renderMenuButton() {
      var editMode = this.editor.mode === MODE_EDIT;
      var shareMode = this.editor.mode === MODE_READONLY && this.editor.options.isShare;
      var menuButton = null;
      if (editMode && this.blot.blotConfig.menuVisible !== false) {
        var menuButtonAttrs = {};
        if (this.blot.isTableCell()) {
          var _menuButtonAttrs;
          menuButtonAttrs = (_menuButtonAttrs = {}, Common_defineProperty(_menuButtonAttrs, tooltipManager/* TOOLTIP_ATTR */.qZ, this.editor.plugins.i18n.get('block_menu.tooltip')), Common_defineProperty(_menuButtonAttrs, tooltipManager/* TOOLTIP_ATTR_ALLOW_UNSAFE_HTML */.aP, 1), Common_defineProperty(_menuButtonAttrs, tooltipManager/* TOOLTIP_TIMEOUT_ATTR */.xQ, 300), _menuButtonAttrs);
        }
        menuButton = (0,preact_module.h)("div", Common_extends({
          ref: this.blot.onFileMenuIconRef,
          className: "file-menu-icon",
          onClick: this.blot.onMenuButtonClick,
          onMouseDown: this.blot.onMenuButtonMouseDown
        }, menuButtonAttrs), (0,preact_module.h)(icons/* IconMoreVertical */.nqv, null));
      } else if (shareMode) {
        if (!this.blot.disallowFileMenuIcon) {
          menuButton = (0,preact_module.h)("div", {
            ref: this.blot.onFileMenuIconRef,
            className: "file-menu-icon",
            onClick: this.blot.onMenuButtonClick,
            onMouseDown: this.blot.onMenuButtonMouseDown
          }, (0,preact_module.h)(icons/* IconMoreVertical */.nqv, null));
        }
      }
      if (this.blot.isBlotLocked) {
        menuButton = null;
      }
      return menuButton;
    }
  }, {
    key: "renderDownloadButton",
    value: function renderDownloadButton() {
      if (!this.blot.disallowDownloading) {
        return (0,preact_module.h)("div", {
          className: "file-download-button",
          onClick: this.blot.onFileDownloadClick
        }, (0,preact_module.h)(icons/* IconPlayerDownload */.hoH, null));
      }
      return null;
    }
  }, {
    key: "renderAlertIcon",
    value: function renderAlertIcon() {
      var attachment = this.blot.props.attachment;
      if (attachment.alert) {
        return (0,preact_module.h)("div", {
          className: "file-alert",
          onClick: this.blot.onFileAlertClick
        }, (0,preact_module.h)(icons/* IconAlert */.az_, null));
      } else {
        return null;
      }
    }
  }, {
    key: "renderFetchIcon",
    value: function renderFetchIcon() {
      var attachment = this.blot.props.attachment;
      if (attachment.need_fetch === true) {
        // иконка скачивания
        var iconContent = (0,preact_module.h)(icons/* IconDownload */.DjJ, null);
        // если уже нажали на иконку скачивания, то показываем иконку загрузки
        if (this.blot.props.fetchingFile) {
          iconContent = (0,preact_module.h)(ProgressRing, {
            radius: 11,
            stroke: 2,
            progress: 80,
            ringColor: "rgba(0, 161, 183, 0.2)",
            progressColor: "#00a1b7",
            animation: true
          });
        }
        return (0,preact_module.h)("div", {
          className: "file-fetch",
          onClick: this.blot.onFileClickFetch
        }, iconContent);
      } else {
        return null;
      }
    }
  }, {
    key: "renderFileActionContent",
    value: function renderFileActionContent() {
      var fileViewer = this.blot.getFileViewer();
      var viewMode = this.props.viewMode;
      if (this.blot.props.isPrinting) {
        var PrintAction = fileViewer.class.PrintAction;
        return (0,preact_module.h)(FileActionTooltip, null, (0,preact_module.h)(PrintAction, {
          onPrinted: this.blot.onFilePrinted,
          onAbort: this.blot.onFilePrintAbort,
          options: fileViewer.options,
          editor: this.editor,
          attachment: this.blot.props.attachment
        }));
      } else if (this.blot.props.fullscreen && fileViewer && viewMode !== 'full') {
        var FullScreenAction = fileViewer.class.FullScreenAction;
        return (0,preact_module.h)(FileActionTooltip, null, (0,preact_module.h)(FullScreenAction, {
          options: fileViewer.options,
          attachment: this.blot.props.attachment,
          editor: this.editor,
          onClose: this.blot.onFullScreenClose,
          blot: this.blot
        }));
      }
    }
  }, {
    key: "renderFullView",
    value: function renderFullView() {
      var fileBorderWidth = parseInt(file_vars.fileBorderWidth);
      var fileKind = this.props.fileKind;
      var fileContainer = this.props.fileContainer;
      var fileViewer = this.blot.getFileViewer();
      var Viewer = fileViewer.class;
      var fileContainerPaddings = (0,dom/* getComputedStyles */.AH)(fileContainer, ['padding-left', 'padding-right'], 'px');
      fileContainerPaddings = fileContainerPaddings['padding-left'] + fileContainerPaddings['padding-right'];
      var maxWidth = fileContainer.offsetWidth - fileContainerPaddings - fileBorderWidth * 2;
      var fullViewClass = 'full-view-content';
      if (fileKind) {
        fullViewClass = 'full-view-content full-view-' + fileKind;
      }
      return (0,preact_module.h)("div", {
        className: fullViewClass
      }, (0,preact_module.h)(Viewer, {
        maxWidth: maxWidth,
        maxHeight: MAX_VIEWER_HEIGHT,
        attachment: this.blot.props.attachment,
        options: fileViewer.options,
        setSyncedState: this.blot.setViewerSyncedState,
        focused: this.blot.props.focused,
        fullscreen: this.blot.props.isViewerFullscreen,
        onFullScreenClose: this.blot.onFullScreenClose,
        onViewerGoFullScreen: this.blot.onViewerGoFullScreen,
        editor: this.editor,
        blot: this.blot,
        isBlotLocked: this.blot.isBlotLocked,
        syncedState: this.blot.getMemoizedSyncedState(this.blot.map.get('syncedViewerState').toJSON())
      }));
    }
  }, {
    key: "renderRenaming",
    value: function renderRenaming() {
      return (0,preact_module.h)("div", {
        className: "compact-view-content"
      }, (0,preact_module.h)("div", {
        className: 'file-renaming ' + util/* SELF_CONTROLLED_CONTENT_CLASS */.W$
      }, (0,preact_module.h)(FileRenameInput, {
        onApply: this.blot.onRenameApply,
        onAbort: this.blot.onRenameAbort,
        inputRef: this.blot.onFileFileRenameInputNodeRef,
        name: this.blot.props.attachment.display_name.split('.').filter(function (word, index, arr) {
          return index !== arr.length - 1;
        }).join('.'),
        ext: this.blot.props.attachment.display_name.split('.').pop()
      })));
    }
  }, {
    key: "renderUploading",
    value: function renderUploading() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var i18n = this.editor.plugins.i18n;
      var noProgress = opts.noProgress,
        progress = opts.progress,
        otherClientUploading = opts.otherClientUploading,
        fileContainer = opts.fileContainer,
        editMode = opts.editMode,
        isOffline = opts.isOffline;
      progress = progress || 0;
      if (!noProgress) {
        progress = this.blot.props.progress;
      }
      var sizeClass = this.blot.getSizeClass({
        fileContainer: fileContainer
      });
      var downloadBtn = null;
      var fileInfo;
      if (this.blot.props.file) {
        if (this.blot.props.file.type && this.blot.props.file.type.startsWith('audio/')) {
          this.blot.isAudioUplading = true;
        }
        if (isNaN(this.blot.props.file.size)) {
          console.warn('invariant: file size is not a number file:', this.blot.props.file);
        }
        fileInfo = (0,preact_module.h)("div", {
          className: "file-info file-name-trim-end"
        }, (0,preact_module.h)("div", null, (0,preact_module.h)("span", {
          className: "file-name"
        }, (0,preact_module.h)("span", {
          className: "file-name-main"
        }, this.blot.props.file.name)), (0,preact_module.h)("span", {
          className: "file-size"
        }, "(", file_filesize(this.blot.props.file.size), ")")));
      } else if (otherClientUploading) {
        var text = isOffline ? (0,preact_module.h)(plugins_i18n/* Text */.xv, {
          id: "attachment.attachment_will_be_downloaded_online"
        }) : (0,preact_module.h)(plugins_i18n/* Text */.xv, {
          id: "attachment.attachment_is_being_uploaded"
        });
        fileInfo = (0,preact_module.h)("div", {
          className: "file-info"
        }, (0,preact_module.h)("span", {
          className: "file-info-message"
        }, text));
      } else {
        fileInfo = (0,preact_module.h)("div", {
          className: "file-info"
        }, (0,preact_module.h)("span", {
          className: "file-info-message"
        }, (0,preact_module.h)(plugins_i18n/* Text */.xv, {
          id: "attachment.wait_resolving_without_info"
        })));
      }
      if (this.blot.props.recordUploading) {
        var _ref;
        downloadBtn = (0,preact_module.h)("div", Common_extends({}, (_ref = {}, Common_defineProperty(_ref, tooltipManager/* TOOLTIP_ATTR */.qZ, i18n.get('file.download_file')), Common_defineProperty(_ref, tooltipManager/* TOOLTIP_ADD_OPTIONS */.cD, JSON.stringify({
          positionFixed: true
        })), _ref), {
          className: "file-download",
          onClick: this.downloadRecord
        }), (0,preact_module.h)(icons/* IconDownload */.DjJ, null));
      }
      return (0,preact_module.h)("div", {
        className: sizeClass
      }, (0,preact_module.h)("div", {
        className: 'compact-view-content file-uploading'
      }, (0,preact_module.h)("div", {
        className: "file-left loading"
      }, (0,preact_module.h)(ProgressRing, {
        radius: 17,
        stroke: 2,
        progress: progress,
        ringColor: "rgba(0, 161, 183, 0.2)",
        progressColor: "#00a1b7"
      })), fileInfo, noProgress ? null : (0,preact_module.h)("div", {
        className: "file-right"
      }, (0,preact_module.h)("div", Common_extends({
        className: "progress"
      }, Common_defineProperty({}, tooltipManager/* TOOLTIP_ATTR */.qZ, this.blot.props.file ? this.blot.props.file.name : null)), (0,preact_module.h)("span", {
        className: "progress-text"
      }, i18n.get('file.uploading'), " "), (0,preact_module.h)("span", {
        className: "progress-percent"
      }, this.blot.props.progress, "%")), downloadBtn, (0,preact_module.h)("div", {
        className: "file-abort",
        onMouseDown: this.blot.onFileAbortClick
      }, (0,preact_module.h)(icons/* IconClose */.bMz, null)))));
    }
  }, {
    key: "renderFetching",
    value: function renderFetching() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var progress = opts.progress,
        fileContainer = opts.fileContainer;
      var hasProgress = typeof progress !== 'undefined';
      var sizeClass = this.blot.getSizeClass({
        fileContainer: fileContainer
      });
      var attachment = this.blot.props.attachment;
      if (isNaN(attachment.size)) {
        console.warn('invariant: size field in attachment should be numeric, attachment:', attachment);
      }
      var fileInfo = (0,preact_module.h)("div", {
        className: "file-info"
      }, (0,preact_module.h)("div", null, (0,preact_module.h)("span", {
        className: "file-name"
      }, attachment.display_name), (0,preact_module.h)("span", {
        className: "file-size"
      }, "(", file_filesize(attachment.size), ")")));
      var drawFileRightWrap = function drawFileRightWrap() {
        for (var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++) {
          children[_key] = arguments[_key];
        }
        return (0,preact_module.h)("div", {
          className: "file-right"
        }, children);
      };
      var fileRight = drawFileRightWrap(this.renderFetchIcon());
      if (this.blot.props.fetchingFile || this.blot.props.attachment.is_fetching && this.blot.props.fetchingFile !== false) {
        fileRight = drawFileRightWrap((0,preact_module.h)("div", {
          className: "progress"
        }, (0,preact_module.h)(plugins_i18n/* Text */.xv, {
          id: "file.downloading"
        }), " ", hasProgress ? progress + "%" : ""), (0,preact_module.h)("div", {
          className: "file-abort",
          onClick: this.blot.onFileAbortFetchClick
        }, (0,preact_module.h)(icons/* IconClose */.bMz, null)));
      }
      return (0,preact_module.h)("div", {
        className: sizeClass
      }, (0,preact_module.h)("div", {
        className: 'compact-view-content file-fetching'
      }, (0,preact_module.h)("div", {
        className: "file-left loading"
      }, (0,preact_module.h)(ProgressRing, {
        radius: 17,
        stroke: 2,
        progress: progress || 0,
        ringColor: "rgba(0, 161, 183, 0.2)",
        progressColor: "#00a1b7"
      })), fileInfo, fileRight));
    }
  }, {
    key: "renderError",
    value: function renderError(err) {
      var errorText;
      var canTryAgain = true;
      if (err instanceof QuotaError) {
        var file = this.blot.props.setAttachmentError.file || {};
        if (isNaN(file.size)) {
          console.warn('invariant: file size is not a number file:', file);
        }
        var fileName = file.name || 'File';
        var fileSize = file.size && '(' + file_filesize(file.size) + ')' || '';
        errorText = fileName + ' ' + fileSize + ' is too big';
      } else if (err instanceof attachmentNotFoundError["default"]) {
        canTryAgain = false;
        errorText = this.editor.plugins.i18n.get('file.attachment_not_found_error');
      } else {
        errorText = 'Could not upload the file';
      }
      return (0,preact_module.h)("div", null, (0,preact_module.h)("div", {
        className: "compact-view-content"
      }, (0,preact_module.h)("div", {
        className: "file-info"
      }, (0,preact_module.h)("span", {
        className: "file-error"
      }, errorText)), (0,preact_module.h)("div", {
        className: "file-spacer"
      }), this.editor.mode === MODE_EDIT ? (0,preact_module.h)("div", {
        className: "file-right"
      }, canTryAgain ? (0,preact_module.h)("div", {
        className: "file-try-again",
        onClick: this.blot.onFileReplace
      }, "Try again") : null, (0,preact_module.h)("div", {
        className: "file-abort",
        onClick: this.blot.onFileDelete
      }, (0,preact_module.h)(icons/* IconClose */.bMz, null))) : null));
    }
  }, {
    key: "renderEmpty",
    value: function renderEmpty() {
      return (0,preact_module.h)("div", null, (0,preact_module.h)("div", {
        className: "compact-view-content"
      }, (0,preact_module.h)("div", {
        className: "file-left"
      }, (0,preact_module.h)(icons/* IconFileOther */.mrQ, null)), (0,preact_module.h)("div", {
        className: "file-info"
      }, (0,preact_module.h)("span", {
        className: "file-name",
        onClick: this.blot.onFileReplace
      }, (0,preact_module.h)(plugins_i18n/* Text */.xv, {
        id: "attachment.choose_a_file"
      }))), (0,preact_module.h)("div", {
        className: "file-spacer"
      }), (0,preact_module.h)("div", {
        className: "file-right"
      }, (0,preact_module.h)("div", {
        className: "file-abort",
        onClick: this.blot.onFileDelete
      }, (0,preact_module.h)(icons/* IconClose */.bMz, null)))));
    }
  }, {
    key: "getSyncedInterfaceState",
    get: function get() {
      return this.blot.getSyncedInterfaceState;
    }
  }]);
  return CommonInterface;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/attachment/interfaces/AudioPlayer.js
function AudioPlayer_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { AudioPlayer_typeof = function _typeof(obj) { return typeof obj; }; } else { AudioPlayer_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return AudioPlayer_typeof(obj); }
function AudioPlayer_extends() { AudioPlayer_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return AudioPlayer_extends.apply(this, arguments); }














function AudioPlayer_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function AudioPlayer_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function AudioPlayer_createClass(Constructor, protoProps, staticProps) { if (protoProps) AudioPlayer_defineProperties(Constructor.prototype, protoProps); if (staticProps) AudioPlayer_defineProperties(Constructor, staticProps); return Constructor; }
function AudioPlayer_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { AudioPlayer_get = Reflect.get; } else { AudioPlayer_get = function _get(target, property, receiver) { var base = AudioPlayer_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return AudioPlayer_get(target, property, receiver || target); }
function AudioPlayer_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = AudioPlayer_getPrototypeOf(object); if (object === null) break; } return object; }
function AudioPlayer_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) AudioPlayer_setPrototypeOf(subClass, superClass); }
function AudioPlayer_setPrototypeOf(o, p) { AudioPlayer_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return AudioPlayer_setPrototypeOf(o, p); }
function AudioPlayer_createSuper(Derived) { var hasNativeReflectConstruct = AudioPlayer_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = AudioPlayer_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = AudioPlayer_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return AudioPlayer_possibleConstructorReturn(this, result); }; }
function AudioPlayer_possibleConstructorReturn(self, call) { if (call && (AudioPlayer_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return AudioPlayer_assertThisInitialized(self); }
function AudioPlayer_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function AudioPlayer_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function AudioPlayer_getPrototypeOf(o) { AudioPlayer_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return AudioPlayer_getPrototypeOf(o); }
function AudioPlayer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var AudioPlayerInterface = /*#__PURE__*/function (_CommonInterface) {
  AudioPlayer_inherits(AudioPlayerInterface, _CommonInterface);
  var _super = AudioPlayer_createSuper(AudioPlayerInterface);
  function AudioPlayerInterface(props) {
    var _this;
    AudioPlayer_classCallCheck(this, AudioPlayerInterface);
    _this = _super.call(this, props);
    AudioPlayer_defineProperty(AudioPlayer_assertThisInitialized(_this), "setAudioPlayerState", function (state) {
      if (Object.keys(state).length !== 0) {
        _this.setState(function () {
          return state;
        });
      }
    });
    AudioPlayer_defineProperty(AudioPlayer_assertThisInitialized(_this), "onInitPlayer", function () {
      _this.setAudioPlayerState({
        initPlayer: true
      });
    });
    AudioPlayer_defineProperty(AudioPlayer_assertThisInitialized(_this), "onAudioDrawBuffer", function (duration) {
      _this.setAudioPlayerState({
        initPlayer: false,
        duration: duration,
        drawBuffer: true
      });
    });
    AudioPlayer_defineProperty(AudioPlayer_assertThisInitialized(_this), "clearPlayer", function () {
      _this.setAudioPlayerState({
        initPlayer: false,
        drawBuffer: false
      });
    });
    AudioPlayer_defineProperty(AudioPlayer_assertThisInitialized(_this), "getAudioPlayerColor", function () {
      return _this.getSyncedInterfaceState && _this.getSyncedInterfaceState.audioPlayerColor || 'transparent';
    });
    return _this;
  }
  AudioPlayer_createClass(AudioPlayerInterface, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Если заменить аудиофайл на новый, то ref компонента уже не срабатывает.
      // т.к. старый компонент который висит blot.props.fileInterface анмаунтится
      // после перезалива файла, новый экземпляр интерфейса надо обновить через componentDidMount
      this.blot.props.fileInterface = this;
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps, nextState) {
      AudioPlayer_get(AudioPlayer_getPrototypeOf(AudioPlayerInterface.prototype), "componentWillReceiveProps", this).call(this);
      var renaming = this.blot.props.renaming;
      if (renaming) {
        this.clearPlayer();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        fileKind = _this$props.fileKind,
        fileContainer = _this$props.fileContainer,
        viewMode = _this$props.viewMode;
      var compactViewContent = null;
      var fullViewContent = null;
      var fileActionContent = null;
      var fileViewer = this.blot.getFileViewer();
      var menu = null;
      var renaming = this.blot.props.renaming;
      var sizeClass = this.blot.getSizeClass({
        fileContainer: fileContainer
      });
      var attachment = this.blot.props.attachment;
      var playerColor = this.getSyncedInterfaceState && this.getSyncedInterfaceState.audioPlayerColor;
      if (playerColor) {
        this.blot.domNode.setAttribute('data-player-color', playerColor);
      } else {
        this.blot.domNode.removeAttribute('data-player-color');
      }
      if (attachment) {
        if (this.blot.isAudioUplading) {
          this.blot.isAudioUplading = undefined;
        }
        var scroll = this.editor.getScrollingContainer();
        scroll.removeEventListener('scroll', this.blot.onScrollVideoPlayer);
        menu = this.buildMenu();
        fileActionContent = this.renderFileActionContent();
        if (renaming) {
          compactViewContent = this.renderRenaming();
        } else {
          var _this$blot, _this$blot$isTableCel, _ref2;
          var menuButton = this.renderMenuButton();
          var alertIcon = this.renderAlertIcon();
          var fetchIcon = this.renderFetchIcon();
          var compactViewClasses = ['compact-view-content'];
          if (attachment.need_fetch === true) {
            compactViewClasses.push('need-fetch');
          }
          if (fileViewer) {
            compactViewClasses.push('viewer-support');
          }
          var _this$renderMiddleTru = this.renderMiddleTruncater(),
            fileNameInst = _this$renderMiddleTru.fileNameInst,
            onFileNameClick = _this$renderMiddleTru.onFileNameClick,
            fileInfoCropNameClass = _this$renderMiddleTru.fileInfoCropNameClass;
          if (isNaN(this.blot.props.attachment.size)) {
            console.warn('invariant: size field in attachment should be numeric, attachment:', this.blot.props.attachment);
          }
          var aFile = 'a-file';
          if ((_this$blot = this.blot) !== null && _this$blot !== void 0 && (_this$blot$isTableCel = _this$blot.isTableCell) !== null && _this$blot$isTableCel !== void 0 && _this$blot$isTableCel.call(_this$blot)) {
            this.blot.props.fileError = true;
          }
          if (this.blot.props.fileError) {
            aFile = '';
          }
          var Icon = this.kindsIcons[fileKind];
          var IconSound;
          var typeFile = 'play';
          if (!this.blot.props.fileError) {
            Icon = this.kindsIcons['play'];
            IconSound = this.kindsIcons['soundOn'];
            if (this.blot.props.audioPlayer) {
              if (this.blot.props.filePlaying) {
                Icon = this.kindsIcons['pause'];
                typeFile = 'stop';
              }
              if (this.blot.props.isMuted) {
                IconSound = this.kindsIcons['soundOff'];
              }
            }
          }
          var audioContainer = null;
          var classAudioinfo = null;
          var leftBlock = (0,preact_module.h)("div", {
            className: 'file-left'
          }, (0,preact_module.h)(Icon, null));
          if (!this.blot.props.fileError) {
            var _ref;
            var volume = this.blot.getVolume();
            if (this.blot.props.audioPlayer) {
              if (!this.blot.props.isMuted) {
                this.blot.props.audioPlayer.updateVolume(volume / 100);
              }
            }
            var audioWaveContainerId = 'wf-audio-container-' + this.blot.id;
            var audioId = 'wf-audio-' + this.blot.id;
            var audioTimerId = 'wf-audio-timer-' + this.blot.id;
            var audioDurationId = 'wf-audio-duration-' + this.blot.id;
            var audioVolumeId = 'wf-audio-volume-' + this.blot.id;
            var audioIconId = 'wf-audio-icon-' + this.blot.id;
            var soundIconId = 'wf-sound-icon-' + this.blot.id;
            var audioWaveWidth = 'width: 76%';
            if (this.editor.scroll.domNode.offsetWidth > 1115) {
              audioWaveWidth = 'width: 79%';
            } else if (this.editor.scroll.domNode.offsetWidth > 1000 && this.editor.scroll.domNode.offsetWidth < 1115) {
              audioWaveWidth = 'width: 73%';
            } else if (this.editor.scroll.domNode.offsetWidth > 800 && this.editor.scroll.domNode.offsetWidth <= 900) {
              audioWaveWidth = 'width: 70%';
            } else if (this.editor.scroll.domNode.offsetWidth <= 800) {
              if (this.editor.scroll.domNode.classList[4] && this.editor.scroll.domNode.classList[4] === 'style-mono') {
                audioWaveWidth = 'width: 64%';
              } else {
                audioWaveWidth = 'width: 66%';
              }
            }
            var wfAudioWave = (0,preact_module.h)("div", {
              className: "wf-audioWave",
              id: audioId,
              style: audioWaveWidth
            });
            var wfSound = (0,preact_module.h)("div", {
              className: "wf-sound",
              id: soundIconId,
              onClick: this.blot.toogleMute
            }, (0,preact_module.h)(IconSound, null));
            var wfVolumeClass = 'wf-volume';
            if (this.editor.scroll.domNode.offsetWidth < 700) {
              wfVolumeClass = 'wf-volume hidden';
            }
            var wfAudioVolume = (0,preact_module.h)("div", {
              className: wfVolumeClass,
              id: audioVolumeId
            }, (0,preact_module.h)(InputSlider, {
              addClassName: "audio-volume-slider",
              progress: volume,
              onChange: this.blot.updateVolume.bind(this.blot),
              onSlide: this.blot.updateVolume.bind(this.blot)
            }));
            var timerClass = 'wf-timer';
            if (this.blot.props.maxAvailableWidth < 150) {
              timerClass = 'wf-timer hidden';
            }
            if (this.editor.scroll.domNode.offsetWidth < 500) {
              timerClass = 'wf-timer wf-margin-left';
            }
            var currentProgress = this.state && this.state.currentProgress || '0:00';
            var duration = this.state && this.state.duration || '';
            var wfAudioTimer = (0,preact_module.h)("div", {
              className: timerClass,
              id: audioTimerId
            }, currentProgress);
            var durationClass = 'wf-duration';
            if (this.blot.props.maxAvailableWidth < 590 || this.editor.scroll.domNode.offsetWidth < 500) {
              durationClass = 'wf-duration hidden';
            }
            var wfAudioDuration = (0,preact_module.h)("div", {
              className: durationClass,
              id: audioDurationId
            }, "/ ", duration);
            var audioIconClass = this.state.initPlayer ? 'audio-preloader' : 'audio';
            leftBlock = (0,preact_module.h)("div", AudioPlayer_extends({
              id: audioIconId,
              className: 'file-left ' + audioIconClass,
              onClick: this.blot.onFilePlayClick
            }, (_ref = {}, AudioPlayer_defineProperty(_ref, tooltipManager/* TOOLTIP_ATTR */.qZ, this.blot.tooltipTextAudio(typeFile)), AudioPlayer_defineProperty(_ref, tooltipManager/* TOOLTIP_ADD_OPTIONS */.cD, JSON.stringify({
              positionFixed: true
            })), _ref)), (0,preact_module.h)(Icon, null));
            var volumePanel = (0,preact_module.h)("div", null, wfSound, wfAudioVolume);
            var hidden = this.state.drawBuffer ? '' : 'hidden';
            audioContainer = (0,preact_module.h)("div", {
              className: "wf-audioWaveContainer " + hidden,
              id: audioWaveContainerId
            }, wfAudioWave, volumePanel, wfAudioTimer, wfAudioDuration);
            classAudioinfo = 'audioInfo';
          }
          var dataFileExport = "".concat(this.blot.id, ".end");
          var fileNameClass = "file-name";
          var span = (0,preact_module.h)("span", AudioPlayer_extends({}, (_ref2 = {}, AudioPlayer_defineProperty(_ref2, tooltipManager/* TOOLTIP_ATTR */.qZ, this.blot.tooltipText()), AudioPlayer_defineProperty(_ref2, tooltipManager/* TOOLTIP_ADD_OPTIONS */.cD, JSON.stringify({
            positionFixed: true
          })), _ref2), {
            onClick: onFileNameClick,
            className: fileNameClass,
            "data-file-export": dataFileExport
          }), fileNameInst);
          if (this.blot.disallowDownloading) {
            fileNameClass = "file-name disallow";
            span = (0,preact_module.h)("span", {
              className: fileNameClass,
              "data-file-export": dataFileExport
            }, fileNameInst);
          }
          var specmenu = this.buildSpecMenu(menu);
          var displayNone = this.state.drawBuffer ? ' wf-hidden' : '';
          classAudioinfo = classAudioinfo + displayNone;
          compactViewContent = (0,preact_module.h)("div", {
            className: compactViewClasses.join(' '),
            onClick: this.blot.onCompactViewClick,
            onMouseDown: this.blot.onCompactViewMouseDown
          }, leftBlock, (0,preact_module.h)("div", {
            className: 'file-info ' + fileInfoCropNameClass
          }, audioContainer, (0,preact_module.h)("div", {
            className: classAudioinfo
          }, span, (0,preact_module.h)("span", {
            className: 'file-size ' + aFile
          }, "(", file_filesize(this.blot.props.attachment.size), ")"))), alertIcon, fetchIcon, menuButton, specmenu);
        }
      }
      this.setViewMode(viewMode, fileContainer);
      if (this.blot.props.attachment && this.blot.props.attachment.type === 'audio') {
        this.blot.hasMusicAttachment = true;
      }
      return (0,preact_module.h)("div", {
        className: sizeClass,
        onMouseDown: this.blot.onFileContainerMouseDown
      }, compactViewContent, fullViewContent, fileActionContent);
    }
  }, {
    key: "contextMenu",
    get: function get() {
      var i18n = this.editor.plugins.i18n;
      var menu = {};
      menu['change-audio-player-color'] = {
        label: i18n.get('block_menu.color.player_color'),
        index: 0,
        group: 0,
        action: 'change-color',
        stackable: false,
        submenu: 'ColorPicker',
        colorPickerParams: {
          getSelectedColor: this.getAudioPlayerColor,
          execAction: 'set-audio-player-color',
          defaultColor: 'transparent',
          closeOnChoice: false
        }
      };
      return menu;
    }
  }, {
    key: "exec",
    value: function exec(action) {
      var processed = false;
      var params = action.params;
      if (action.type === 'set-audio-player-color') {
        if (params) {
          if (params === 'transparent') {
            this.setSyncedInterfaceState({
              audioPlayerColor: false
            });
          } else {
            this.setSyncedInterfaceState({
              audioPlayerColor: params
            });
          }
          this.blot.props.audioPlayer.setProgressColor();
          processed = true;
        }
      }
      return processed;
    }
  }, {
    key: "interfaceState",
    get: function get() {
      return {
        syncedInterfaceState: {
          audioPlayerColor: this.getSyncedInterfaceState.audioPlayerColor
        }
      };
    }
  }]);
  return AudioPlayerInterface;
}(CommonInterface);

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/video/index.js + 52 modules
var video = __webpack_require__(11526);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/attachment/interfaces/VideoPlayer.js
function VideoPlayer_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { VideoPlayer_typeof = function _typeof(obj) { return typeof obj; }; } else { VideoPlayer_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return VideoPlayer_typeof(obj); }
function VideoPlayer_extends() { VideoPlayer_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return VideoPlayer_extends.apply(this, arguments); }














function VideoPlayer_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function VideoPlayer_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function VideoPlayer_createClass(Constructor, protoProps, staticProps) { if (protoProps) VideoPlayer_defineProperties(Constructor.prototype, protoProps); if (staticProps) VideoPlayer_defineProperties(Constructor, staticProps); return Constructor; }
function VideoPlayer_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) VideoPlayer_setPrototypeOf(subClass, superClass); }
function VideoPlayer_setPrototypeOf(o, p) { VideoPlayer_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return VideoPlayer_setPrototypeOf(o, p); }
function VideoPlayer_createSuper(Derived) { var hasNativeReflectConstruct = VideoPlayer_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = VideoPlayer_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = VideoPlayer_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return VideoPlayer_possibleConstructorReturn(this, result); }; }
function VideoPlayer_possibleConstructorReturn(self, call) { if (call && (VideoPlayer_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return VideoPlayer_assertThisInitialized(self); }
function VideoPlayer_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function VideoPlayer_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function VideoPlayer_getPrototypeOf(o) { VideoPlayer_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return VideoPlayer_getPrototypeOf(o); }
function VideoPlayer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var ONLY_TRANSCRIBE_ICONS_THRESHOLD = 900;
var NO_TRANSCRIBE_BUTTONS_THRESHOLD = 550;
var VideoPlayerInterface = /*#__PURE__*/function (_CommonInterface) {
  VideoPlayer_inherits(VideoPlayerInterface, _CommonInterface);
  var _super = VideoPlayer_createSuper(VideoPlayerInterface);
  function VideoPlayerInterface(props) {
    var _this;
    VideoPlayer_classCallCheck(this, VideoPlayerInterface);
    _this = _super.call(this, props);
    VideoPlayer_defineProperty(VideoPlayer_assertThisInitialized(_this), "onVideoEditMouseDown", function (event) {
      event.stopPropagation();
    });
    VideoPlayer_defineProperty(VideoPlayer_assertThisInitialized(_this), "onVideoEditClick", function (event) {
      event.preventDefault();
      event.stopPropagation();
      var _this$props$blot = _this.props.blot,
        editor = _this$props$blot.editor,
        id = _this$props$blot.id;
      var attachmentGlobalId = _this.props.blot.map.get('attachmentGlobalId');
      if (editor) {
        editor.plugins.attachmentManager.editAttachment(id, attachmentGlobalId);
      }
    });
    VideoPlayer_defineProperty(VideoPlayer_assertThisInitialized(_this), "onTranscriptClick", function (transcriptAction, event) {
      event.preventDefault();
      event.stopPropagation();
      var editor = _this.props.blot.editor;
      if (editor) {
        var _this$props$blot$prop;
        if ((_this$props$blot$prop = _this.props.blot.props) !== null && _this$props$blot$prop !== void 0 && _this$props$blot$prop.attachment) {
          var attachment = Object.assign({}, _this.props.blot.props.attachment);
          var video = document.createElement('video');
          video.src = attachment.url;
          video.onloadedmetadata = function () {
            attachment.duration = video.duration;
            // in the case client want to access the video itself (for example to create pictures from video frames)
            attachment.videoElement = video;
            editor.plugins.attachmentManager.options.onTranscript(attachment, transcriptAction);
          };
        }
      }
    });
    return _this;
  }
  VideoPlayer_createClass(VideoPlayerInterface, [{
    key: "renderEditVideoIcon",
    value: function renderEditVideoIcon() {
      return (0,preact_module.h)("div", {
        className: "edit-video-button",
        onMouseDown: this.onVideoEditMouseDown,
        onClick: this.onVideoEditClick
      }, (0,preact_module.h)(icons/* IconEditVideo */.pj0, null));
    }
  }, {
    key: "renderTranscriptButtons",
    value: function renderTranscriptButtons(containerWidth) {
      var _ref = this.props.blot.editor.plugins.attachmentManager.options || {},
        isTranscriptEnabled = _ref.isTranscriptEnabled,
        isGuidegenEnabled = _ref.isGuidegenEnabled;
      if (!isTranscriptEnabled) {
        return null;
      }
      var showText = containerWidth > ONLY_TRANSCRIBE_ICONS_THRESHOLD;
      if (containerWidth < NO_TRANSCRIBE_BUTTONS_THRESHOLD) {
        return null;
      }
      return (0,preact_module.h)("div", {
        className: 'transcript-buttons ' + (showText ? '' : 'no-text')
      }, isGuidegenEnabled ? (0,preact_module.h)("button", {
        onClick: this.onTranscriptClick.bind(null, 'guide'),
        className: "transcript-buttons__item"
      }, "Guide") : null, (0,preact_module.h)("button", {
        onClick: this.onTranscriptClick.bind(null, 'transcript'),
        className: "transcript-buttons__item"
      }, (0,preact_module.h)(icons/* IconPlayerTranscript */.aJY, {
        className: "colorize"
      }), showText && (0,preact_module.h)(plugins_i18n/* Text */.xv, {
        id: "file.video_transcribe"
      })), (0,preact_module.h)("button", {
        onClick: this.onTranscriptClick.bind(null, 'summary'),
        className: "transcript-buttons__item"
      }, (0,preact_module.h)(icons/* IconFileCheckAlt */.KLP, null), showText && (0,preact_module.h)(plugins_i18n/* Text */.xv, {
        id: "file.video_summary"
      })), (0,preact_module.h)("button", {
        onClick: this.onTranscriptClick.bind(null, 'meeting_notes'),
        className: "transcript-buttons__item"
      }, (0,preact_module.h)(icons/* IconUserPenAlt */.S1t, null), showText && (0,preact_module.h)(plugins_i18n/* Text */.xv, {
        id: "file.video_meeting_notes"
      })), (0,preact_module.h)("button", {
        onClick: this.onTranscriptClick.bind(null, 'ask_ai'),
        className: "transcript-buttons__item"
      }, (0,preact_module.h)(icons/* IconPromtIcon */.nST, {
        className: "colorize"
      }), showText && (0,preact_module.h)(plugins_i18n/* Text */.xv, {
        id: "file.video_ask_ai"
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        fileKind = _this$props.fileKind,
        fileContainer = _this$props.fileContainer,
        viewMode = _this$props.viewMode,
        blot = _this$props.blot;
      var showVideoEditButton = Boolean(blot.blotConfig.showVideoEditButton) && (0,video.getVideoTypes)().includes(this.props.blot.props.attachment.mime) && !this.blot.isTableCell();
      var compactViewContent = null;
      var fullViewContent = null;
      var fileActionContent = null;
      var fileViewer = this.blot.getFileViewer();
      var menu = null;
      var syncedState = this.blot.getSyncedState();
      var renaming = this.blot.props.renaming;
      var sizeClass = this.blot.getSizeClass({
        fileContainer: fileContainer
      });
      var containerWidth = fileContainer.offsetWidth;
      var attachment = this.blot.props.attachment;
      var exportMode = this.editor.mode === MODE_EXPORT;
      if (attachment) {
        if (!blot.props.attachment.autoplay && syncedState.autoplay) {
          blot.props.attachment.autoplay = true;
        }
        if (!blot.props.attachment.soundDefault && syncedState.mute) {
          blot.props.attachment.soundDefault = true;
        }
        if (!blot.props.attachment.loop && syncedState.loop) {
          blot.props.attachment.loop = true;
        }
        if (!blot.props.attachment.hideControl && (syncedState.hideControl || syncedState.hideControls)) {
          blot.props.attachment.hideControl = true;
        }
        if ((!syncedState.hasOwnProperty('showPanel') || syncedState.showPanel) && !syncedState.hideControls) {
          blot.props.attachment.showPanel = true;
        } else {
          blot.props.attachment.showPanel = false;
        }
        if (!blot.props.attachment.videoShadow && syncedState.videoShadow) {
          blot.props.attachment.videoShadow = true;
        }
        if (blot.props.attachment.videoShadow) {
          fileContainer.classList.add('video-shadow');
        } else {
          fileContainer.classList.remove('video-shadow');
        }
        menu = this.buildMenu();
        fileActionContent = this.renderFileActionContent();
        if (renaming) {
          compactViewContent = this.renderRenaming();
        } else {
          var _ref2;
          var menuButton = this.renderMenuButton();
          var alertIcon = this.renderAlertIcon();
          var fetchIcon = this.renderFetchIcon();
          var downloadButton = null;
          // для мобильного редактора не показываем иконку скачивания
          if (this.props.blot.editor.options.deviceType !== 'mobile' && !this.blot.isTableCell()) {
            downloadButton = this.renderDownloadButton();
          }
          var compactViewClasses = ['compact-view-content'];
          if (attachment.need_fetch === true) {
            compactViewClasses.push('need-fetch');
          }
          if (fileViewer) {
            compactViewClasses.push('viewer-support');
          }
          var _this$renderMiddleTru = this.renderMiddleTruncater(),
            fileNameInst = _this$renderMiddleTru.fileNameInst,
            onFileNameClick = _this$renderMiddleTru.onFileNameClick,
            fileInfoCropNameClass = _this$renderMiddleTru.fileInfoCropNameClass;
          if (isNaN(this.blot.props.attachment.size)) {
            console.warn('invariant: size field in attachment should be numeric, attachment:', this.blot.props.attachment);
          }
          var Icon = this.kindsIcons[fileKind];
          var leftBlock = (0,preact_module.h)("div", {
            className: 'file-left'
          }, (0,preact_module.h)(Icon, null));
          var dataFileExport = "".concat(this.blot.id, ".end");
          var fileNameClass = "file-name";
          var span = (0,preact_module.h)("span", VideoPlayer_extends({}, (_ref2 = {}, VideoPlayer_defineProperty(_ref2, tooltipManager/* TOOLTIP_ATTR */.qZ, this.blot.tooltipText()), VideoPlayer_defineProperty(_ref2, tooltipManager/* TOOLTIP_ADD_OPTIONS */.cD, JSON.stringify({
            positionFixed: true
          })), _ref2), {
            onClick: onFileNameClick,
            className: fileNameClass,
            "data-file-export": dataFileExport
          }), fileNameInst);
          if (this.blot.disallowDownloading) {
            fileNameClass = "file-name disallow";
            span = (0,preact_module.h)("span", {
              className: fileNameClass,
              "data-file-export": dataFileExport
            }, fileNameInst);
          }
          var specmenu = this.buildSpecMenu(menu);
          var editVideoIcon = showVideoEditButton ? this.renderEditVideoIcon() : null;
          var transcriptButtons = showVideoEditButton ? this.renderTranscriptButtons(containerWidth) : null;
          compactViewContent = (0,preact_module.h)("div", {
            className: compactViewClasses.join(' '),
            onClick: this.blot.onCompactViewClick,
            onMouseDown: this.blot.onCompactViewMouseDown
          }, leftBlock, (0,preact_module.h)("div", {
            className: 'file-info ' + fileInfoCropNameClass
          }, (0,preact_module.h)("div", null, span, (0,preact_module.h)("span", {
            className: 'file-size'
          }, "(", file_filesize(this.blot.props.attachment.size), ")"))), alertIcon, fetchIcon, transcriptButtons, editVideoIcon, downloadButton, menuButton, specmenu);
        }
        if (!exportMode && fileViewer && viewMode === 'full') {
          fullViewContent = this.renderFullView();
        }
      }
      if (attachment && fileViewer && this.blot.isVideoFile() && !this.blot.props.attachment.showPanel) {
        compactViewContent = null;
        fileContainer.classList.add('border_none');
      } else {
        fileContainer.classList.remove('border_none');
      }
      this.setViewMode(viewMode, fileContainer);
      return (0,preact_module.h)("div", {
        className: sizeClass,
        onMouseDown: this.blot.onFileContainerMouseDown
      }, compactViewContent, fullViewContent, fileActionContent);
    }
  }]);
  return VideoPlayerInterface;
}(CommonInterface);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/wrtc/audio.js
function audio_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { audio_typeof = function _typeof(obj) { return typeof obj; }; } else { audio_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return audio_typeof(obj); }
function audio_extends() { audio_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return audio_extends.apply(this, arguments); }











function audio_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function audio_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function audio_createClass(Constructor, protoProps, staticProps) { if (protoProps) audio_defineProperties(Constructor.prototype, protoProps); if (staticProps) audio_defineProperties(Constructor, staticProps); return Constructor; }
function audio_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) audio_setPrototypeOf(subClass, superClass); }
function audio_setPrototypeOf(o, p) { audio_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return audio_setPrototypeOf(o, p); }
function audio_createSuper(Derived) { var hasNativeReflectConstruct = audio_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = audio_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = audio_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return audio_possibleConstructorReturn(this, result); }; }
function audio_possibleConstructorReturn(self, call) { if (call && (audio_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return audio_assertThisInitialized(self); }
function audio_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function audio_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function audio_getPrototypeOf(o) { audio_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return audio_getPrototypeOf(o); }
function audio_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var AudioRecord = /*#__PURE__*/function (_Component) {
  audio_inherits(AudioRecord, _Component);
  var _super = audio_createSuper(AudioRecord);
  function AudioRecord(props) {
    var _this;
    audio_classCallCheck(this, AudioRecord);
    _this = _super.call(this, props);
    audio_defineProperty(audio_assertThisInitialized(_this), "startRecord", function (event) {
      var _this$props = _this.props,
        wrtc = _this$props.wrtc,
        blot = _this$props.blot;
      wrtc.startAudioRecord();
      _this.setRecordInterval();
      blot.render();
    });
    audio_defineProperty(audio_assertThisInitialized(_this), "stopRecord", function (event) {
      var _this$props2 = _this.props,
        wrtc = _this$props2.wrtc,
        blot = _this$props2.blot;
      wrtc.removeRecord = true;
      wrtc.stopAudioRecord();
      if (_this.timer) {
        clearInterval(_this.timer);
      }
      blot.render();
    });
    audio_defineProperty(audio_assertThisInitialized(_this), "pauseRecord", function (event) {
      var _this$props3 = _this.props,
        wrtc = _this$props3.wrtc,
        blot = _this$props3.blot;
      wrtc.pauseRecord();
      blot.render();
    });
    audio_defineProperty(audio_assertThisInitialized(_this), "resumeRecord", function (event) {
      var _this$props4 = _this.props,
        wrtc = _this$props4.wrtc,
        blot = _this$props4.blot;
      wrtc.resumeRecord();
      blot.render();
    });
    audio_defineProperty(audio_assertThisInitialized(_this), "restoreRecord", function (event) {
      var blot = _this.props.blot;
      var wrtc = blot.props.wrtc;
      wrtc.removeRecord = true;
      wrtc.restoreRecord(blot);
    });
    audio_defineProperty(audio_assertThisInitialized(_this), "deleteRecord", function (event) {
      var _this$props5 = _this.props,
        wrtc = _this$props5.wrtc,
        blot = _this$props5.blot;
      if (_this.timer) {
        clearInterval(_this.timer);
      }
      wrtc.removeRecord = true;
      blot.remove();
    });
    audio_defineProperty(audio_assertThisInitialized(_this), "cancelRecord", function (event) {
      var blot = _this.props.blot;
      var i18n = blot.editor.plugins.i18n;
      var text = i18n.get('file.wrtc.confirmCancel');
      if (confirm(text)) {
        _this.deleteRecord();
      }
    });
    audio_defineProperty(audio_assertThisInitialized(_this), "openLink", function () {
      var _this$props6 = _this.props,
        wrtc = _this$props6.wrtc,
        blot = _this$props6.blot;
      var i18n = blot.editor.plugins.i18n;
      var stream = wrtc.stream;
      var error = wrtc.error;
      var howtourl;
      if (!stream && !error || error && error === 'macSystemError') {
        howtourl = i18n.get('file.wrtc.how_to_url2');
      } else if (!stream && error) {
        howtourl = i18n.get('file.wrtc.how_to_url');
      }
      if (howtourl) {
        window.open(howtourl);
      }
    });
    _this.totalTime = 0;
    return _this;
  }
  audio_createClass(AudioRecord, [{
    key: "autoStartRecord",
    value: function autoStartRecord() {
      if (this.recordInited) return false;
      this.recordInited = true;
      var _this$props7 = this.props,
        wrtc = _this$props7.wrtc,
        blot = _this$props7.blot;
      wrtc.startAudioRecord();
      this.setRecordInterval();
      blot.render();
    }
  }, {
    key: "setRecordInterval",
    value: function setRecordInterval() {
      var _this2 = this;
      var _this$props8 = this.props,
        wrtc = _this$props8.wrtc,
        blot = _this$props8.blot;
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(function () {
        if (wrtc.recorder && wrtc.recorder.state === 'recording') {
          _this2.totalTime = _this2.totalTime + 1;
        }
        wrtc.getRecordData(_this2.totalTime);
        blot.render();
      }, 1000);
    }
  }, {
    key: "isManualRecord",
    get: function get() {
      var blot = this.props.blot;
      var manualRecord = false;
      if (blot.blotConfig && blot.blotConfig.wrtc && blot.blotConfig.wrtc.manualRecord) {
        manualRecord = true;
      }
      return manualRecord;
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this3 = this;
      var _this$props9 = this.props,
        wrtc = _this$props9.wrtc,
        blot = _this$props9.blot;
      var recordUserId = blot.map.get('recordUserId');
      var currentUserId = blot.store.userId;
      wrtc.checkTmpRecord(blot).then(function (result) {
        if (result) {
          _this3.hasTmpFile = true;
          blot.render();
        } else {
          if (recordUserId === currentUserId) {
            _this3.setCanRecord();
          }
          if (!_this3.isManualRecord && !_this3.recordInited && _this3.totalTime === 0 && wrtc && wrtc.granted) {
            if (typeof blot.props.focused === 'undefined') {
              _this3.autoStartRecord();
            }
          }
        }
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this4 = this;
      var _this$props10 = this.props,
        wrtc = _this$props10.wrtc,
        blot = _this$props10.blot;
      if (!this.isManualRecord && !this.recordInited && this.totalTime === 0 && blot.props.focused && wrtc && wrtc.granted) {
        setTimeout(function () {
          _this4.autoStartRecord();
        }, 50);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var blot = this.props.blot;
      if (this.timer) {
        clearInterval(this.timer);
      }
      if (blot.dontProcessDragAndDrop) {
        blot.dontProcessDragAndDrop = undefined;
        blot.parent.disallowSideDrop = undefined;
      }
    }
  }, {
    key: "setCanRecord",
    value: function setCanRecord() {
      this.setState(function () {
        return {
          canRecord: true
        };
      });
    }
  }, {
    key: "render",
    value: function render(_, _ref) {
      var canRecord = _ref.canRecord;
      var _this$props11 = this.props,
        wrtc = _this$props11.wrtc,
        blot = _this$props11.blot;
      var i18n = blot.editor.plugins.i18n;
      if (this.hasTmpFile) {
        var hasTmpRecordText = i18n.get('file.wrtc.hasTmpRecord');
        var restoreText = i18n.get('file.wrtc.restore');
        var deleteText = i18n.get('file.wrtc.delete');
        var _fileInfo = (0,preact_module.h)("div", {
          className: "file-info"
        }, hasTmpRecordText, (0,preact_module.h)("a", {
          className: "records",
          onClick: this.restoreRecord
        }, restoreText), (0,preact_module.h)("a", {
          className: "records",
          onClick: this.deleteRecord
        }, deleteText));
        return (0,preact_module.h)("div", null, (0,preact_module.h)("div", {
          className: "compact-view-content"
        }, _fileInfo));
      } else if (!canRecord) {
        var infotext = i18n.get('file.wrtc.recordOnAnotherDevice');
        var _fileInfo2 = (0,preact_module.h)("div", {
          className: "file-info"
        }, infotext);
        return (0,preact_module.h)("div", null, (0,preact_module.h)("div", {
          className: "compact-view-content"
        }, _fileInfo2));
      }
      var stream = wrtc.stream;
      var error = wrtc.error;
      var recorder = wrtc.recorder;
      var errorMessage = null;
      var recordIcons = null;
      var cancelRecordIcon = null;
      var fileInfo = null;
      var recordTime = wrtc.renderTime(this.totalTime);
      if (!stream && error) {
        var msg = i18n.get('file.wrtc.rec_err_au');
        var howtofix = i18n.get('file.wrtc.how_to_fix');
        var fixUrl = (0,preact_module.h)("span", {
          className: "link",
          onMouseUp: this.openLink
        }, howtofix);
        errorMessage = (0,preact_module.h)("div", {
          className: "file-info"
        }, msg, " ", fixUrl);
      } else if (!stream && !error) {
        var _fixUrl = (0,preact_module.h)("span", {
          className: "link",
          onMouseUp: this.openLink
        }, (0,preact_module.h)(icons/* IconQuestion */.BS3, null));
        var _msg = i18n.get('file.wrtc.allow_micro');
        errorMessage = (0,preact_module.h)("div", {
          className: "file-info"
        }, _msg, " ", _fixUrl);
      }
      if (!errorMessage) {
        var _ref2, _ref6;
        var tooltipRecord = i18n.get('file.wrtc.startRecording');
        var tooltipStopRec = i18n.get('file.wrtc.stopRecording');
        var recordButton = (0,preact_module.h)("div", audio_extends({
          className: "record-icons",
          onClick: this.startRecord
        }, (_ref2 = {}, audio_defineProperty(_ref2, tooltipManager/* TOOLTIP_ATTR */.qZ, tooltipRecord), audio_defineProperty(_ref2, tooltipManager/* TOOLTIP_ADD_OPTIONS */.cD, JSON.stringify({
          positionFixed: true
        })), _ref2)), (0,preact_module.h)(icons/* IconRecordIcon */.ETU, null));
        var stopButton = null;
        if (recorder) {
          var _ref5;
          if (recorder.state === 'recording') {
            var _ref3;
            tooltipRecord = i18n.get('file.wrtc.pauseRecording');
            recordButton = (0,preact_module.h)("div", audio_extends({
              className: "record-icons",
              onClick: this.pauseRecord
            }, (_ref3 = {}, audio_defineProperty(_ref3, tooltipManager/* TOOLTIP_ATTR */.qZ, tooltipRecord), audio_defineProperty(_ref3, tooltipManager/* TOOLTIP_ADD_OPTIONS */.cD, JSON.stringify({
              positionFixed: true
            })), _ref3)), (0,preact_module.h)(icons/* IconPauseIcon */.qV0, null));
          } else if (recorder.state === 'paused') {
            var _ref4;
            tooltipRecord = i18n.get('file.wrtc.resumeRecording');
            recordButton = (0,preact_module.h)("div", audio_extends({
              className: "record-icons",
              onClick: this.resumeRecord
            }, (_ref4 = {}, audio_defineProperty(_ref4, tooltipManager/* TOOLTIP_ATTR */.qZ, tooltipRecord), audio_defineProperty(_ref4, tooltipManager/* TOOLTIP_ADD_OPTIONS */.cD, JSON.stringify({
              positionFixed: true
            })), _ref4)), (0,preact_module.h)(icons/* IconRecordIcon */.ETU, null));
          }
          stopButton = (0,preact_module.h)("div", audio_extends({
            className: "record-icons",
            onClick: this.stopRecord
          }, (_ref5 = {}, audio_defineProperty(_ref5, tooltipManager/* TOOLTIP_ATTR */.qZ, tooltipStopRec), audio_defineProperty(_ref5, tooltipManager/* TOOLTIP_ADD_OPTIONS */.cD, JSON.stringify({
            positionFixed: true
          })), _ref5)), (0,preact_module.h)(icons/* IconStopIcon */.Sui, null));
        }
        var tooltipCancelRec = i18n.get('file.wrtc.cancelRecording');
        cancelRecordIcon = (0,preact_module.h)("div", audio_extends({
          className: "record-icons",
          onClick: this.cancelRecord
        }, (_ref6 = {}, audio_defineProperty(_ref6, tooltipManager/* TOOLTIP_ATTR */.qZ, tooltipCancelRec), audio_defineProperty(_ref6, tooltipManager/* TOOLTIP_ADD_OPTIONS */.cD, JSON.stringify({
          positionFixed: true
        })), _ref6)), (0,preact_module.h)(icons/* IconRemoveRecord */.Jl4, null));
        recordIcons = (0,preact_module.h)("div", {
          className: "file-left audio records-buttons"
        }, recordButton, stopButton, cancelRecordIcon);
        fileInfo = (0,preact_module.h)("div", {
          className: "file-info"
        }, recordTime);
      }
      return (0,preact_module.h)("div", {
        className: "compact-view-content"
      }, errorMessage, recordIcons, fileInfo);
    }
  }]);
  return AudioRecord;
}(preact_module/* Component */.wA);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/attachment/interfaces/AudioRecord.js
function AudioRecord_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { AudioRecord_typeof = function _typeof(obj) { return typeof obj; }; } else { AudioRecord_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return AudioRecord_typeof(obj); }









function AudioRecord_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function AudioRecord_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function AudioRecord_createClass(Constructor, protoProps, staticProps) { if (protoProps) AudioRecord_defineProperties(Constructor.prototype, protoProps); if (staticProps) AudioRecord_defineProperties(Constructor, staticProps); return Constructor; }
function AudioRecord_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) AudioRecord_setPrototypeOf(subClass, superClass); }
function AudioRecord_setPrototypeOf(o, p) { AudioRecord_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return AudioRecord_setPrototypeOf(o, p); }
function AudioRecord_createSuper(Derived) { var hasNativeReflectConstruct = AudioRecord_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = AudioRecord_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = AudioRecord_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return AudioRecord_possibleConstructorReturn(this, result); }; }
function AudioRecord_possibleConstructorReturn(self, call) { if (call && (AudioRecord_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return AudioRecord_assertThisInitialized(self); }
function AudioRecord_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function AudioRecord_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function AudioRecord_getPrototypeOf(o) { AudioRecord_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return AudioRecord_getPrototypeOf(o); }



var AudioRecordInterface = /*#__PURE__*/function (_CommonInterface) {
  AudioRecord_inherits(AudioRecordInterface, _CommonInterface);
  var _super = AudioRecord_createSuper(AudioRecordInterface);
  function AudioRecordInterface(props) {
    AudioRecord_classCallCheck(this, AudioRecordInterface);
    return _super.call(this, props);
  }
  AudioRecord_createClass(AudioRecordInterface, [{
    key: "render",
    value: function render() {
      return (0,preact_module.h)("div", null, (0,preact_module.h)(AudioRecord, {
        wrtc: this.blot.props.wrtc,
        blot: this.blot
      }));
    }
  }]);
  return AudioRecordInterface;
}(CommonInterface);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/wrtc/media.js
function media_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { media_typeof = function _typeof(obj) { return typeof obj; }; } else { media_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return media_typeof(obj); }
function media_extends() { media_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return media_extends.apply(this, arguments); }













function media_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function media_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function media_createClass(Constructor, protoProps, staticProps) { if (protoProps) media_defineProperties(Constructor.prototype, protoProps); if (staticProps) media_defineProperties(Constructor, staticProps); return Constructor; }
function media_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) media_setPrototypeOf(subClass, superClass); }
function media_setPrototypeOf(o, p) { media_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return media_setPrototypeOf(o, p); }
function media_createSuper(Derived) { var hasNativeReflectConstruct = media_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = media_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = media_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return media_possibleConstructorReturn(this, result); }; }
function media_possibleConstructorReturn(self, call) { if (call && (media_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return media_assertThisInitialized(self); }
function media_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function media_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function media_getPrototypeOf(o) { media_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return media_getPrototypeOf(o); }
function media_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var MediaRecord = /*#__PURE__*/function (_Component) {
  media_inherits(MediaRecord, _Component);
  var _super = media_createSuper(MediaRecord);
  function MediaRecord(props) {
    var _this;
    media_classCallCheck(this, MediaRecord);
    _this = _super.call(this, props);
    media_defineProperty(media_assertThisInitialized(_this), "startRecord", function (event) {
      var _this$props = _this.props,
        wrtc = _this$props.wrtc,
        blot = _this$props.blot;
      wrtc.startMediaRecord();
      _this.timer = setInterval(function () {
        if (wrtc.recorder && wrtc.recorder.state === 'recording') {
          _this.totalTime = _this.totalTime + 1;
        }
        wrtc.getRecordData(_this.totalTime);
        blot.render();
      }, 1000);
      blot.render();
    });
    media_defineProperty(media_assertThisInitialized(_this), "stopRecord", function (event) {
      var _this$props2 = _this.props,
        wrtc = _this$props2.wrtc,
        blot = _this$props2.blot;
      wrtc.removeRecord = true;
      wrtc.stopMediaRecord();
      if (_this.timer) {
        clearInterval(_this.timer);
      }
      blot.render();
    });
    media_defineProperty(media_assertThisInitialized(_this), "pauseRecord", function (event) {
      var _this$props3 = _this.props,
        wrtc = _this$props3.wrtc,
        blot = _this$props3.blot;
      wrtc.pauseRecord();
      blot.render();
    });
    media_defineProperty(media_assertThisInitialized(_this), "resumeRecord", function (event) {
      var _this$props4 = _this.props,
        wrtc = _this$props4.wrtc,
        blot = _this$props4.blot;
      wrtc.resumeRecord();
      blot.render();
    });
    media_defineProperty(media_assertThisInitialized(_this), "restoreRecord", function (event) {
      var blot = _this.props.blot;
      var wrtc = blot.props.wrtc;
      wrtc.removeRecord = true;
      wrtc.restoreRecord(blot);
    });
    media_defineProperty(media_assertThisInitialized(_this), "deleteRecord", function (event) {
      var _this$props5 = _this.props,
        wrtc = _this$props5.wrtc,
        blot = _this$props5.blot;
      if (_this.timer) {
        clearInterval(_this.timer);
      }
      wrtc.removeRecord = true;
      blot.remove();
    });
    media_defineProperty(media_assertThisInitialized(_this), "cancelRecord", function (event) {
      var blot = _this.props.blot;
      var i18n = blot.editor.plugins.i18n;
      var text = i18n.get('file.wrtc.confirmCancel');
      if (confirm(text)) {
        _this.deleteRecord();
      }
    });
    media_defineProperty(media_assertThisInitialized(_this), "onWrtcInited", function () {
      var blot = _this.props.blot;
      if (blot) {
        blot.focusableFocus();
        blot.render();
      }
      if (!_this.isManualRecord) {
        var countdownNode = document.createElement('div');
        countdownNode.id = "mediaRecordCountdown";
        countdownNode.classList.add('media-record-countdown');
        document.body.appendChild(countdownNode);
        _this.setState(function () {
          return {
            countdownNumber: 3,
            countdownDisbaled: false,
            countdownNode: countdownNode
          };
        }, function () {
          _this.checkCowntdown();
        });
      }
    });
    media_defineProperty(media_assertThisInitialized(_this), "startMoving", function (event) {
      var blot = _this.props.blot;
      var evt = event || window.event;
      var divid = _this.state.videoContentBlock;
      var container = blot.scroll.domNode;
      var posX = evt.clientX,
        posY = evt.clientY,
        divTop = divid.style.top,
        divLeft = divid.style.left,
        eWi = parseInt(divid.style.width),
        eHe = parseInt(divid.style.height),
        cWi = parseInt(container.style.width),
        cHe = parseInt(container.style.height);
      divTop = divTop.replace('px', '');
      divLeft = divLeft.replace('px', '');
      var diffX = posX - divLeft,
        diffY = posY - divTop;
      document.onmousemove = function (evt) {
        evt = evt || window.event;
        var top = document.body.clientHeight - 250;
        var left = document.body.clientWidth - 250;
        var posX = evt.clientX,
          posY = evt.clientY,
          aX = posX - diffX,
          aY = posY - diffY;
        if (aX < 20) aX = 20;
        if (aY < 20) aY = 20;
        if (aY > top) aY = top;
        if (aX > left) aX = left;
        if (aX + eWi > cWi) aX = cWi - eWi;
        if (aY + eHe > cHe) aY = cHe - eHe;
        _this.move(aX, aY);
      };
    });
    media_defineProperty(media_assertThisInitialized(_this), "stopMoving", function (event) {
      document.onmousemove = function () {};
    });
    media_defineProperty(media_assertThisInitialized(_this), "onRefVideoContent", function (node) {
      _this.setState(function () {
        return {
          videoContentBlock: node
        };
      });
    });
    media_defineProperty(media_assertThisInitialized(_this), "checkCowntdown", function () {
      if (!_this.isManualRecord) {
        if (typeof _this.countdown === 'undefined' && _this.state.countdownDisbaled !== true) {
          _this.setCowntdown();
        }
      }
    });
    media_defineProperty(media_assertThisInitialized(_this), "openLink", function () {
      var _this$props6 = _this.props,
        wrtc = _this$props6.wrtc,
        blot = _this$props6.blot;
      var i18n = blot.editor.plugins.i18n;
      var stream = wrtc.stream;
      var error = wrtc.error;
      var howtourl;
      if (!stream && !error || error && error === 'macSystemError') {
        howtourl = i18n.get('file.wrtc.how_to_url2');
      } else if (!stream && error) {
        howtourl = i18n.get('file.wrtc.how_to_url');
      }
      if (howtourl) {
        window.open(howtourl);
      }
    });
    _this.totalTime = 0;
    return _this;
  }
  media_createClass(MediaRecord, [{
    key: "move",
    value: function move(xpos, ypos) {
      this.setState(function () {
        return {
          videoContent: {
            top: ypos,
            left: xpos
          }
        };
      });
    }
  }, {
    key: "setCowntdown",
    value: function setCowntdown() {
      var _this2 = this;
      var blot = this.props.blot;
      this.countdown = setInterval(function () {
        _this2.setState(function (prevState) {
          var newState = null;
          if (prevState.countdownNumber > 0) {
            newState = {
              countdownNumber: prevState.countdownNumber - 1
            };
          }
          return newState;
        }, function () {
          var _this2$state = _this2.state,
            countdownNumber = _this2$state.countdownNumber,
            countdownNode = _this2$state.countdownNode;
          if (countdownNumber === 1) {
            blot.render();
          } else if (countdownNumber === 0) {
            clearInterval(_this2.countdown);
            _this2.setState(function () {
              return {
                countdownDisbaled: true,
                countdownNode: null
              };
            }, function () {
              countdownNode.remove();
              _this2.startRecord();
            });
          }
        });
      }, 1000);
    }
  }, {
    key: "isManualRecord",
    get: function get() {
      var blot = this.props.blot;
      var manualRecord = false;
      if (blot.blotConfig && blot.blotConfig.wrtc && blot.blotConfig.wrtc.manualRecord) {
        manualRecord = true;
      }
      return manualRecord;
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this3 = this;
      var _this$props7 = this.props,
        wrtc = _this$props7.wrtc,
        blot = _this$props7.blot;
      blot.mediaComponent = this;
      var recordUserId = blot.map.get('recordUserId');
      var currentUserId = blot.store.userId;
      wrtc.checkTmpRecord(blot).then(function (result) {
        if (result) {
          blot.props.wrtc = wrtc.wrtc;
          _this3.hasTmpFile = true;
        }
        blot.render();
      });
      if (recordUserId === currentUserId) {
        this.setCanRecord();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var wrtc = this.props.wrtc;
      if (this.chosenOption === 'screencam') {
        if (wrtc.additionalWrtc && !wrtc.additionalWrtc.mediaElemId) {} else if (wrtc.additionalWrtc && wrtc.additionalWrtc.mediaElemId && !wrtc.additionalWrtc.mediaElem) {
          wrtc.additionalWrtc.initCapture();
        }
      } else if (this.chosenOption === 'camonly') {
        if (wrtc.mediaElemId && !wrtc.mediaElem) {
          wrtc.initCapture();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyComponent();
    }
  }, {
    key: "destroyComponent",
    value: function destroyComponent() {
      var _this$props8 = this.props,
        wrtc = _this$props8.wrtc,
        blot = _this$props8.blot;
      var countdownNode = this.state.countdownNode;
      if (wrtc.additionalWrtc) {
        wrtc.additionalWrtc.stopMediaRecord();
      }
      if (this.timer) {
        clearInterval(this.timer);
      }
      if (this.countdown && this.countdown !== 'disabled') {
        clearInterval(this.countdown);
      }
      if (blot.dontProcessDragAndDrop) {
        blot.dontProcessDragAndDrop = undefined;
        blot.parent.disallowSideDrop = undefined;
      }
      blot.mediaComponent = undefined;
      if (countdownNode) {
        countdownNode.remove();
      }
    }
  }, {
    key: "setCanRecord",
    value: function setCanRecord() {
      this.setState(function () {
        return {
          canRecord: true
        };
      });
    }
  }, {
    key: "render",
    value: function render(_, _ref) {
      var countdownNode = _ref.countdownNode,
        canRecord = _ref.canRecord;
      var _this$props9 = this.props,
        wrtc = _this$props9.wrtc,
        blot = _this$props9.blot,
        cameraNode = _this$props9.cameraNode;
      var fileInterface = blot.props.fileInterface;
      var fileContainer = fileInterface.props.fileContainer;
      var i18n = blot.editor.plugins.i18n;
      var stream, error, recorder, chooseMedia;
      if (!wrtc.isPlugin) {
        stream = wrtc.stream;
        error = wrtc.error;
        recorder = wrtc.recorder;
      } else {
        chooseMedia = true;
      }
      if (this.hasTmpFile) {
        var hasTmpRecordText = i18n.get('file.wrtc.hasTmpRecord');
        var restoreText = i18n.get('file.wrtc.restore');
        var deleteText = i18n.get('file.wrtc.delete');
        var fileInfo = (0,preact_module.h)("div", {
          className: "file-info"
        }, hasTmpRecordText, (0,preact_module.h)("a", {
          className: "records",
          onClick: this.restoreRecord
        }, restoreText), (0,preact_module.h)("a", {
          className: "records",
          onClick: this.deleteRecord
        }, deleteText));
        return (0,preact_module.h)("div", null, (0,preact_module.h)("div", {
          className: "compact-view-content"
        }, fileInfo));
      } else if (!canRecord) {
        var infotext = i18n.get('file.wrtc.recordOnAnotherDevice');
        var _fileInfo = (0,preact_module.h)("div", {
          className: "file-info"
        }, infotext);
        return (0,preact_module.h)("div", null, (0,preact_module.h)("div", {
          className: "compact-view-content"
        }, _fileInfo));
      }
      var noborder = fileContainer.classList.contains('no-border');
      if (chooseMedia) {
        if (!noborder) {
          fileContainer.classList.add('no-border');
        }
        return null;
      } else {
        var errorMessage = null;
        var recordIcons = null;
        var cancelRecordIcon = null;
        var _fileInfo2 = null;
        var videoContent = null;
        var recordTime = wrtc.renderTime(this.totalTime);
        if (noborder) {
          fileContainer.classList.remove('no-border');
        }
        if (!stream && !error || error && error === 'macSystemError') {
          var fixUrl = (0,preact_module.h)("span", {
            className: "link",
            onMouseUp: this.openLink
          }, (0,preact_module.h)(icons/* IconQuestion */.BS3, null));
          var msg = i18n.get('file.wrtc.allow_micro');
          errorMessage = (0,preact_module.h)("div", {
            className: "file-info"
          }, msg, " ", fixUrl);
        } else if (!stream && error) {
          var _msg = i18n.get('file.wrtc.rec_err_vi');
          var howtofix = i18n.get('file.wrtc.how_to_fix');
          var _fixUrl = (0,preact_module.h)("span", {
            className: "link",
            onMouseUp: this.openLink
          }, howtofix);
          errorMessage = (0,preact_module.h)("div", {
            className: "file-info"
          }, _msg, " ", _fixUrl);
        }
        if (!errorMessage) {
          var _ref2, _ref6;
          var tooltipRecord = i18n.get('file.wrtc.startRecording');
          var tooltipStopRec = i18n.get('file.wrtc.stopRecording');
          var recordButton = (0,preact_module.h)("div", media_extends({
            className: "record-icons",
            onClick: this.startRecord
          }, (_ref2 = {}, media_defineProperty(_ref2, tooltipManager/* TOOLTIP_ATTR */.qZ, tooltipRecord), media_defineProperty(_ref2, tooltipManager/* TOOLTIP_ADD_OPTIONS */.cD, JSON.stringify({
            positionFixed: true
          })), _ref2)), (0,preact_module.h)(icons/* IconRecordIcon */.ETU, null));
          var stopButton = null;
          if (recorder) {
            var _ref5;
            if (recorder.state === 'recording') {
              var _ref3;
              tooltipRecord = i18n.get('file.wrtc.pauseRecording');
              recordButton = (0,preact_module.h)("div", media_extends({
                className: "record-icons",
                onClick: this.pauseRecord
              }, (_ref3 = {}, media_defineProperty(_ref3, tooltipManager/* TOOLTIP_ATTR */.qZ, tooltipRecord), media_defineProperty(_ref3, tooltipManager/* TOOLTIP_ADD_OPTIONS */.cD, JSON.stringify({
                positionFixed: true
              })), _ref3)), (0,preact_module.h)(icons/* IconPauseIcon */.qV0, null));
            } else if (recorder.state === 'paused') {
              var _ref4;
              tooltipRecord = i18n.get('file.wrtc.resumeRecording');
              recordButton = (0,preact_module.h)("div", media_extends({
                className: "record-icons",
                onClick: this.resumeRecord
              }, (_ref4 = {}, media_defineProperty(_ref4, tooltipManager/* TOOLTIP_ATTR */.qZ, tooltipRecord), media_defineProperty(_ref4, tooltipManager/* TOOLTIP_ADD_OPTIONS */.cD, JSON.stringify({
                positionFixed: true
              })), _ref4)), (0,preact_module.h)(icons/* IconRecordIcon */.ETU, null));
            }
            stopButton = (0,preact_module.h)("div", media_extends({
              className: "record-icons",
              onClick: this.stopRecord
            }, (_ref5 = {}, media_defineProperty(_ref5, tooltipManager/* TOOLTIP_ATTR */.qZ, tooltipStopRec), media_defineProperty(_ref5, tooltipManager/* TOOLTIP_ADD_OPTIONS */.cD, JSON.stringify({
              positionFixed: true
            })), _ref5)), (0,preact_module.h)(icons/* IconStopIcon */.Sui, null));
          }
          var tooltipCancelRec = i18n.get('file.wrtc.cancelRecording');
          cancelRecordIcon = (0,preact_module.h)("div", media_extends({
            className: "record-icons",
            onClick: this.cancelRecord
          }, (_ref6 = {}, media_defineProperty(_ref6, tooltipManager/* TOOLTIP_ATTR */.qZ, tooltipCancelRec), media_defineProperty(_ref6, tooltipManager/* TOOLTIP_ADD_OPTIONS */.cD, JSON.stringify({
            positionFixed: true
          })), _ref6)), (0,preact_module.h)(icons/* IconRemoveRecord */.Jl4, null));
          recordIcons = (0,preact_module.h)("div", {
            className: "file-left audio records-buttons"
          }, recordButton, stopButton, cancelRecordIcon);
          _fileInfo2 = (0,preact_module.h)("div", {
            className: "file-info"
          }, recordTime);
          var mediaElemId = 'mediaElem-' + blot.id;
          if (this.chosenOption === 'screencam') {
            if (cameraNode) {
              this.renderCamera();
            }
          } else if (this.chosenOption === 'camonly') {
            wrtc.mediaElemId = mediaElemId;
            videoContent = (0,preact_module.h)("div", {
              className: "full-view-content full-view-video"
            }, (0,preact_module.h)("video", {
              className: "mediaElem",
              id: mediaElemId,
              autoPlay: true,
              muted: true
            }));
          }
          if (!this.isManualRecord && countdownNode) {
            this.renderCountdown();
          }
        }
        return (0,preact_module.h)("div", null, (0,preact_module.h)("div", {
          className: "compact-view-content"
        }, errorMessage, recordIcons, _fileInfo2), videoContent);
      }
    }
  }, {
    key: "renderCamera",
    value: function renderCamera() {
      var cameraNode = this.props.cameraNode;
      this.renderComponent((0,preact_module.h)(MediaRecordCamera, {
        mediaRecord: this
      }), cameraNode);
    }
  }, {
    key: "renderCountdown",
    value: function renderCountdown() {
      var countdownNode = this.state.countdownNode;
      this.renderComponent((0,preact_module.h)(MediaRecordCountdown, {
        mediaRecord: this
      }), countdownNode);
    }
  }, {
    key: "renderComponent",
    value: function renderComponent(component, node) {
      (0,preact_module/* render */.sY)((0,preact_module.h)(plugins_i18n/* IntlProvider */.Pj, null, component), node);
    }
  }]);
  return MediaRecord;
}(preact_module/* Component */.wA);
var MediaRecordCountdown = /*#__PURE__*/function (_Component2) {
  media_inherits(MediaRecordCountdown, _Component2);
  var _super2 = media_createSuper(MediaRecordCountdown);
  function MediaRecordCountdown(props) {
    media_classCallCheck(this, MediaRecordCountdown);
    return _super2.call(this, props);
  }
  media_createClass(MediaRecordCountdown, [{
    key: "render",
    value: function render() {
      var mediaRecord = this.props.mediaRecord;
      var countdownNumber = mediaRecord.state.countdownNumber;
      var number = (0,preact_module.h)("div", {
        className: "number"
      }, countdownNumber);
      return (0,preact_module.h)("div", {
        id: "record-countdown",
        className: "record-countdown"
      }, number);
    }
  }]);
  return MediaRecordCountdown;
}(preact_module/* Component */.wA);
var MediaRecordCamera = /*#__PURE__*/function (_Component3) {
  media_inherits(MediaRecordCamera, _Component3);
  var _super3 = media_createSuper(MediaRecordCamera);
  function MediaRecordCamera(props) {
    media_classCallCheck(this, MediaRecordCamera);
    return _super3.call(this, props);
  }
  media_createClass(MediaRecordCamera, [{
    key: "render",
    value: function render() {
      var mediaRecord = this.props.mediaRecord;
      var _mediaRecord$props = mediaRecord.props,
        wrtc = _mediaRecord$props.wrtc,
        blot = _mediaRecord$props.blot;
      var mediaElemId = 'mediaElem-' + blot.id;
      var videoContentBlockId = 'mediaElem-' + blot.id + '-wrapper';
      wrtc.additionalWrtc.mediaElemId = mediaElemId;
      var top = mediaRecord.state.videoContent && mediaRecord.state.videoContent.top || document.body.clientHeight - 300;
      var left = mediaRecord.state.videoContent && mediaRecord.state.videoContent.left || 50;
      var style = "top:" + top + "px; left:" + left + "px;";
      return (0,preact_module.h)("div", {
        ref: mediaRecord.onRefVideoContent,
        id: videoContentBlockId,
        className: "additional-camera-content camera",
        style: style,
        onMouseDown: mediaRecord.startMoving,
        onMouseUp: mediaRecord.stopMoving
      }, (0,preact_module.h)("video", {
        className: "mediaElem camera",
        id: mediaElemId,
        autoPlay: true,
        muted: true
      }));
    }
  }]);
  return MediaRecordCamera;
}(preact_module/* Component */.wA);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/attachment/interfaces/MediaRecord.js
function MediaRecord_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { MediaRecord_typeof = function _typeof(obj) { return typeof obj; }; } else { MediaRecord_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return MediaRecord_typeof(obj); }









function MediaRecord_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function MediaRecord_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function MediaRecord_createClass(Constructor, protoProps, staticProps) { if (protoProps) MediaRecord_defineProperties(Constructor.prototype, protoProps); if (staticProps) MediaRecord_defineProperties(Constructor, staticProps); return Constructor; }
function MediaRecord_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) MediaRecord_setPrototypeOf(subClass, superClass); }
function MediaRecord_setPrototypeOf(o, p) { MediaRecord_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return MediaRecord_setPrototypeOf(o, p); }
function MediaRecord_createSuper(Derived) { var hasNativeReflectConstruct = MediaRecord_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = MediaRecord_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = MediaRecord_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return MediaRecord_possibleConstructorReturn(this, result); }; }
function MediaRecord_possibleConstructorReturn(self, call) { if (call && (MediaRecord_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return MediaRecord_assertThisInitialized(self); }
function MediaRecord_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function MediaRecord_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function MediaRecord_getPrototypeOf(o) { MediaRecord_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return MediaRecord_getPrototypeOf(o); }
function MediaRecord_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var MediaRecordInterface = /*#__PURE__*/function (_CommonInterface) {
  MediaRecord_inherits(MediaRecordInterface, _CommonInterface);
  var _super = MediaRecord_createSuper(MediaRecordInterface);
  function MediaRecordInterface(props) {
    var _this;
    MediaRecord_classCallCheck(this, MediaRecordInterface);
    _this = _super.call(this, props);
    MediaRecord_defineProperty(MediaRecord_assertThisInitialized(_this), "onRef", function (mediaComponent) {
      _this.blot.props.mediaComponent = mediaComponent;
    });
    _this.cameraNode = document.createElement('div');
    _this.cameraNode.id = "mediaRecordAdditionalCamera";
    _this.cameraNode.classList.add('media-record-additional-camera');
    return _this;
  }
  MediaRecord_createClass(MediaRecordInterface, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.appendChild(this.cameraNode);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cameraNode.remove();
    }
  }, {
    key: "render",
    value: function render() {
      return (0,preact_module.h)("div", null, (0,preact_module.h)(MediaRecord, {
        wrtc: this.blot.props.wrtc,
        blot: this.blot,
        cameraNode: this.cameraNode,
        ref: this.onRef
      }));
    }
  }]);
  return MediaRecordInterface;
}(CommonInterface);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/attachment/interfaces/File.js
function File_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { File_typeof = function _typeof(obj) { return typeof obj; }; } else { File_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return File_typeof(obj); }
function File_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = File_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function File_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return File_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return File_arrayLikeToArray(o, minLen); }
function File_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }















function File_extends() { File_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return File_extends.apply(this, arguments); }
function File_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function File_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function File_createClass(Constructor, protoProps, staticProps) { if (protoProps) File_defineProperties(Constructor.prototype, protoProps); if (staticProps) File_defineProperties(Constructor, staticProps); return Constructor; }
function File_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) File_setPrototypeOf(subClass, superClass); }
function File_setPrototypeOf(o, p) { File_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return File_setPrototypeOf(o, p); }
function File_createSuper(Derived) { var hasNativeReflectConstruct = File_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = File_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = File_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return File_possibleConstructorReturn(this, result); }; }
function File_possibleConstructorReturn(self, call) { if (call && (File_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return File_assertThisInitialized(self); }
function File_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function File_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function File_getPrototypeOf(o) { File_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return File_getPrototypeOf(o); }
function File_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var FileInterface = /*#__PURE__*/function (_CommonInterface) {
  File_inherits(FileInterface, _CommonInterface);
  var _super = File_createSuper(FileInterface);
  function FileInterface(props) {
    var _this;
    File_classCallCheck(this, FileInterface);
    _this = _super.call(this, props);
    File_defineProperty(File_assertThisInitialized(_this), "renderImagePreview", function () {
      return (0,preact_module.h)(FileImagePreviewIcon, {
        blot: _this.blot,
        editor: _this.editor,
        attachment: _this.blot.props.attachment,
        icon: _this.kindsIcons[_this.props.fileKind]
      });
    });
    return _this;
  }
  File_createClass(FileInterface, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        fileKind = _this$props.fileKind,
        fileContainer = _this$props.fileContainer,
        viewMode = _this$props.viewMode;
      var compactViewContent = null;
      var fullViewContent = null;
      var fileActionContent = null;
      var fileViewer = this.blot.getFileViewer();
      var menu = null;
      var renaming = this.blot.props.renaming;
      var sizeClass = this.blot.getSizeClass({
        fileContainer: fileContainer
      });
      var attachment = this.blot.props.attachment;
      var exportMode = this.editor.mode === MODE_EXPORT;
      if (attachment) {
        var scroll = this.editor.getScrollingContainer();
        scroll.removeEventListener('scroll', this.blot.onScrollVideoPlayer);
        menu = this.buildMenu();
        fileActionContent = this.renderFileActionContent();
        if (renaming) {
          compactViewContent = this.renderRenaming();
        } else {
          var _ref;
          var menuButton = this.renderMenuButton();
          var alertIcon = this.renderAlertIcon();
          var fetchIcon = this.renderFetchIcon();
          var downloadButton = null;
          // для мобильного редактора не показываем иконку скачивания
          if (this.props.blot.editor.options.deviceType !== 'mobile' && !this.blot.isTableCell()) {
            downloadButton = this.renderDownloadButton();
          }
          var compactViewClasses = ['compact-view-content'];
          if (attachment.need_fetch === true) {
            compactViewClasses.push('need-fetch');
          }
          if (fileViewer) {
            compactViewClasses.push('viewer-support');
          }
          var _this$renderMiddleTru = this.renderMiddleTruncater(),
            fileNameInst = _this$renderMiddleTru.fileNameInst,
            onFileNameClick = _this$renderMiddleTru.onFileNameClick,
            fileInfoCropNameClass = _this$renderMiddleTru.fileInfoCropNameClass;
          if (isNaN(this.blot.props.attachment.size)) {
            console.warn('invariant: size field in attachment should be numeric, attachment:', this.blot.props.attachment);
          }
          var Icon = this.kindsIcons[fileKind];
          if (fileKind === 'image' && this.blot.isTableCell()) {
            Icon = this.renderImagePreview;
          }
          var leftBlock = (0,preact_module.h)("div", {
            className: 'file-left'
          }, (0,preact_module.h)(Icon, null));
          var dataFileExport = "".concat(this.blot.id, ".end");
          var fileNameClass = "file-name";
          var span = (0,preact_module.h)("span", File_extends({}, (_ref = {}, File_defineProperty(_ref, tooltipManager/* TOOLTIP_ATTR */.qZ, this.blot.tooltipText()), File_defineProperty(_ref, tooltipManager/* TOOLTIP_ADD_OPTIONS */.cD, JSON.stringify({
            positionFixed: true
          })), _ref), {
            onClick: onFileNameClick,
            className: fileNameClass,
            "data-file-export": dataFileExport
          }), fileNameInst);
          if (this.blot.disallowDownloading) {
            fileNameClass = "file-name disallow";
            span = (0,preact_module.h)("span", {
              className: fileNameClass,
              "data-file-export": dataFileExport
            }, fileNameInst);
          }
          var specmenu = this.buildSpecMenu(menu);
          compactViewContent = (0,preact_module.h)("div", {
            className: compactViewClasses.join(' '),
            onClick: this.blot.onCompactViewClick,
            onMouseDown: this.blot.onCompactViewMouseDown
          }, leftBlock, (0,preact_module.h)("div", {
            className: 'file-info ' + fileInfoCropNameClass
          }, (0,preact_module.h)("div", null, span, (0,preact_module.h)("span", {
            className: 'file-size'
          }, "(", file_filesize(this.blot.props.attachment.size), ")"))), alertIcon, fetchIcon, downloadButton, menuButton, specmenu);
        }
        if (!exportMode && fileViewer && viewMode === 'full') {
          fullViewContent = this.renderFullView();
        }
      }
      this.setViewMode(viewMode, fileContainer);
      return (0,preact_module.h)("div", {
        className: sizeClass,
        onMouseDown: this.blot.onFileContainerMouseDown
      }, compactViewContent, fullViewContent, fileActionContent);
    }
  }]);
  return FileInterface;
}(CommonInterface);

var FileImagePreviewIcon = /*#__PURE__*/function (_Component) {
  File_inherits(FileImagePreviewIcon, _Component);
  var _super2 = File_createSuper(FileImagePreviewIcon);
  function FileImagePreviewIcon(props) {
    var _this2;
    File_classCallCheck(this, FileImagePreviewIcon);
    _this2 = _super2.call(this, props);
    File_defineProperty(File_assertThisInitialized(_this2), "onRef", function (node) {
      _this2.domNode = node;
    });
    File_defineProperty(File_assertThisInitialized(_this2), "onImageRef", function (node) {
      _this2.imageNode = node;
    });
    File_defineProperty(File_assertThisInitialized(_this2), "onClick", function (event) {
      event.preventDefault();
      if (!_this2.state.focused && _this2.props.editor.mode === MODE_EDIT) {
        _this2.setState(function () {
          return {
            focused: true
          };
        });
      } else {
        _this2.onFocusedClick();
      }
    });
    File_defineProperty(File_assertThisInitialized(_this2), "onMouseDown", function (event) {
      if (!_this2.state.focused || _this2.props.editor.mode !== MODE_EDIT) return;
      var x = event.clientX;
      var rect = _this2.domNode.getBoundingClientRect();
      if (x >= rect.x + rect.width - 2 && rect.x <= rect.x + rect.width + 2) {
        var cellNode = _this2.domNode.closest('.table-attachment');
        cellNode.closest('td.cell-attachment').style.pointerEvents = 'none';
        event.preventDefault();
        event.stopPropagation();
        _this2.setState(function () {
          var _cellNode$getBounding;
          return {
            resize: {
              cellNode: cellNode,
              maxWidth: cellNode === null || cellNode === void 0 ? void 0 : (_cellNode$getBounding = cellNode.getBoundingClientRect()) === null || _cellNode$getBounding === void 0 ? void 0 : _cellNode$getBounding.width
            }
          };
        });
        _this2.onStartResize();
      }
    });
    File_defineProperty(File_assertThisInitialized(_this2), "onStartResize", function () {
      document.addEventListener('mousemove', _this2.onResizeDocumentMouseMove, false);
      document.addEventListener('mouseup', _this2.onResizeDocumentMouseUp, false);
    });
    File_defineProperty(File_assertThisInitialized(_this2), "onResizeDocumentMouseMove", function (event) {
      var rect = _this2.domNode.getBoundingClientRect();
      var newWidth = event.clientX - rect.x;
      if (newWidth < _this2.defaultWidth) {
        newWidth = _this2.defaultWidth;
      }
      if (_this2.state.resize.maxWidth && newWidth > _this2.state.resize.maxWidth) {
        newWidth = _this2.state.resize.maxWidth;
      }
      _this2.domNode.style.width = newWidth + 'px';
      var currentImageWidth = _this2.imageNode.getBoundingClientRect().width;
      if (newWidth > currentImageWidth + 1) {
        _this2.domNode.style.width = currentImageWidth + 'px';
      }
    });
    File_defineProperty(File_assertThisInitialized(_this2), "onResizeDocumentMouseUp", function (event) {
      document.removeEventListener('mousemove', _this2.onResizeDocumentMouseMove, false);
      document.removeEventListener('mouseup', _this2.onResizeDocumentMouseUp, false);
      var blot = _this2.props.blot;
      blot.map.set('imagePreviewWidth', _this2.domNode.getBoundingClientRect().width);
      // дожидаемся всех событий, чтобы не отработал клик по картинке и не отпал фокус
      setTimeout(function () {
        _this2.state.resize.cellNode.closest('td.cell-attachment').style.removeProperty('pointer-events');
        _this2.setState(function () {
          return {
            resize: false
          };
        });
      }, 0);
    });
    File_defineProperty(File_assertThisInitialized(_this2), "onDocumentMouseUp", function (event) {
      if (!_this2.state.resize && _this2.state.focused && event.target !== _this2.domNode && !_this2.domNode.contains(event.target)) {
        _this2.setState(function () {
          return {
            focused: false
          };
        });
      }
    });
    _this2.state = {
      focused: false,
      resize: false
    };
    _this2.defaultWidth = 40;
    return _this2;
  }
  File_createClass(FileImagePreviewIcon, [{
    key: "onFocusedClick",
    value: function onFocusedClick() {
      var _this$props2 = this.props,
        attachment = _this$props2.attachment,
        editor = _this$props2.editor;
      var processed = false;
      var onlyForAttachments = [];
      var cellNode = this.props.blot.domNode.closest('.table-attachment');
      if (cellNode) {
        var cellAttachments = cellNode.querySelectorAll('.attachment-item .file');
        if (cellAttachments.length) {
          var _iterator = File_createForOfIteratorHelper(cellAttachments),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var node = _step.value;
              if (node.id) {
                var _blot$props, _blot$props$attachmen;
                var blot = editor.findById(node.id);
                if (blot && (blot === null || blot === void 0 ? void 0 : (_blot$props = blot.props) === null || _blot$props === void 0 ? void 0 : (_blot$props$attachmen = _blot$props.attachment) === null || _blot$props$attachmen === void 0 ? void 0 : _blot$props$attachmen.type) === 'image') {
                  var blotAttachment = Object.assign({}, blot.props.attachment);
                  blotAttachment.blotType = 'TableAttachment';
                  onlyForAttachments.push(blotAttachment);
                  if (blot.disallowDownloading) {
                    blotAttachment.disallowDownloading = true;
                  }
                }
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }
      if (editor.plugins.imageManager.enterFullSize(attachment.global_id, {
        onlyForAttachments: onlyForAttachments.length ? onlyForAttachments : null
      }) !== false) {
        processed = true;
      }
      if (!processed) {
        editor.plugins.lightBox.open(attachment.url, {
          onlyForAttachments: onlyForAttachments.length ? onlyForAttachments : null
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mouseup', this.onDocumentMouseUp, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mouseup', this.onDocumentMouseUp, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        attachment = _this$props3.attachment,
        blot = _this$props3.blot;
      var width = blot.map.get('imagePreviewWidth') || this.defaultWidth;
      var styles = {
        width: width + 'px',
        maxWidth: '100%'
      };
      if (attachment) {
        return (0,preact_module.h)("div", {
          className: 'image-attachment-wrapper' + (this.state.focused ? ' focused-image' : ''),
          ref: this.onRef,
          onMouseDown: this.onMouseDown,
          onClick: this.onClick,
          style: styles
        }, this.state.focused ? (0,preact_module.h)("div", {
          className: "resize-point"
        }) : null, (0,preact_module.h)("img", {
          src: attachment.url,
          style: {
            maxWidth: '100%',
            maxHeight: '100%'
          },
          ref: this.onImageRef
        }));
      }
      return this.props.icon;
    }
  }]);
  return FileImagePreviewIcon;
}(preact_module/* Component */.wA);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/attachment/interfaces/index.js
function interfaces_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { interfaces_typeof = function _typeof(obj) { return typeof obj; }; } else { interfaces_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return interfaces_typeof(obj); }









function interfaces_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function interfaces_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function interfaces_createClass(Constructor, protoProps, staticProps) { if (protoProps) interfaces_defineProperties(Constructor.prototype, protoProps); if (staticProps) interfaces_defineProperties(Constructor, staticProps); return Constructor; }
function interfaces_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) interfaces_setPrototypeOf(subClass, superClass); }
function interfaces_setPrototypeOf(o, p) { interfaces_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return interfaces_setPrototypeOf(o, p); }
function interfaces_createSuper(Derived) { var hasNativeReflectConstruct = interfaces_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = interfaces_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = interfaces_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return interfaces_possibleConstructorReturn(this, result); }; }
function interfaces_possibleConstructorReturn(self, call) { if (call && (interfaces_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return interfaces_assertThisInitialized(self); }
function interfaces_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function interfaces_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function interfaces_getPrototypeOf(o) { interfaces_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return interfaces_getPrototypeOf(o); }
function interfaces_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var CompatibleInterface = /*#__PURE__*/function (_Component) {
  interfaces_inherits(CompatibleInterface, _Component);
  var _super = interfaces_createSuper(CompatibleInterface);
  function CompatibleInterface(props) {
    var _this;
    interfaces_classCallCheck(this, CompatibleInterface);
    _this = _super.call(this, props);
    interfaces_defineProperty(interfaces_assertThisInitialized(_this), "onRef", function (node) {
      var blot = _this.props.blot;
      if (blot && node) {
        blot.props.fileInterface = node;
      }
    });
    _this.listComponents = {
      "audio": (0,preact_module.h)(AudioPlayerInterface, {
        ref: _this.onRef
      }),
      "video": (0,preact_module.h)(VideoPlayerInterface, {
        ref: _this.onRef
      }),
      "audioRecord": (0,preact_module.h)(AudioRecordInterface, {
        ref: _this.onRef
      }),
      "mediaRecord": (0,preact_module.h)(MediaRecordInterface, {
        ref: _this.onRef
      }),
      "file": (0,preact_module.h)(FileInterface, {
        ref: _this.onRef
      }),
      "common": (0,preact_module.h)(CommonInterface, {
        ref: _this.onRef
      })
    };
    return _this;
  }
  interfaces_createClass(CompatibleInterface, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        blot = _this$props.blot,
        fileKind = _this$props.fileKind;
      var component = this.listComponents['common'];
      if (blot.hasAttachment()) {
        if (blot.props.attachment) {
          if (this.listComponents[fileKind]) {
            component = this.listComponents[fileKind];
          } else {
            component = this.listComponents['file'];
          }
          // показываем корректный компонент для мобильных клиентов во время скачивания
          if (blot.props.attachment.is_fetching && blot.props.fetchingFile !== false) {
            component = this.listComponents['common'];
          }
        }
      } else {
        if (this.listComponents[fileKind]) {
          component = this.listComponents[fileKind];
        }
      }
      component.props = this.props;
      return component;
    }
  }]);
  return CompatibleInterface;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/attachment/file.js
function file_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { file_typeof = function _typeof(obj) { return typeof obj; }; } else { file_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return file_typeof(obj); }
function file_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function file_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { file_ownKeys(Object(source), true).forEach(function (key) { file_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { file_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function file_slicedToArray(arr, i) { return file_arrayWithHoles(arr) || file_iterableToArrayLimit(arr, i) || file_unsupportedIterableToArray(arr, i) || file_nonIterableRest(); }
function file_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function file_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function file_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function file_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = file_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function file_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return file_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return file_arrayLikeToArray(o, minLen); }
function file_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



























function file_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function file_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { file_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { file_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function file_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function file_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function file_createClass(Constructor, protoProps, staticProps) { if (protoProps) file_defineProperties(Constructor.prototype, protoProps); if (staticProps) file_defineProperties(Constructor, staticProps); return Constructor; }
function file_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) file_setPrototypeOf(subClass, superClass); }
function file_setPrototypeOf(o, p) { file_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return file_setPrototypeOf(o, p); }
function file_createSuper(Derived) { var hasNativeReflectConstruct = file_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = file_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = file_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return file_possibleConstructorReturn(this, result); }; }
function file_possibleConstructorReturn(self, call) { if (call && (file_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return file_assertThisInitialized(self); }
function file_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function file_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function file_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { file_get = Reflect.get; } else { file_get = function _get(target, property, receiver) { var base = file_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return file_get(target, property, receiver || target); }
function file_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = file_getPrototypeOf(object); if (object === null) break; } return object; }
function file_getPrototypeOf(o) { file_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return file_getPrototypeOf(o); }
function file_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

































var mimeKinds = {
  'application/pdf': 'pdf',
  'audio/vnd.dlna.adts': 'audio',
  'audio/x-m4a': 'audio',
  'audio/mp4': 'audio'
};
var kindsDefaultViewModes = {
  pdf: 'full',
  video: 'full'
};
var allowMenuInShareFileTypes = ['pdf', 'audio'];
var file_mixin = mix([commentable, withCaption, blotLock, embeddable, draggable, selectable, focusable, executable, basic]);
var FILE_CONTAINER_CLASS = 'file-container';
var FILE_MENU_CLASS = 'file-menu';
var file_MAX_VIEWER_HEIGHT = 600;
var SMALL_SIZE_THRESHOLD = 300;
var TOO_SMALL_SIZE_THRESHOLD = 160;
var FileBlot = /*#__PURE__*/function (_mixin) {
  file_inherits(FileBlot, _mixin);
  var _super = file_createSuper(FileBlot);
  function FileBlot(domNode) {
    var _this;
    file_classCallCheck(this, FileBlot);
    _this = _super.call(this, domNode);
    file_defineProperty(file_assertThisInitialized(_this), "onEditorBodyResize", function () {
      _this.render();
      _this.reDrawBuffer();
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileMenuIconRef", function (node) {
      _this.fileMenuIconNode = node;
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileNameTruncaterRef", function (ref) {
      _this.fileNameTruncater = ref;
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileFileRenameInputNodeRef", function (node) {
      _this.fileRenameInputNode = node;
    });
    file_defineProperty(file_assertThisInitialized(_this), "processAvailableWidthChangeDebounced", lodash_debounce_default()(function () {
      if (_this.fileNameTruncater) {
        _this.fileNameTruncater.onResize();
      }
      _this.reDrawBuffer();
    }, 200));
    file_defineProperty(file_assertThisInitialized(_this), "onDrop", /*#__PURE__*/function () {
      var _ref = file_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(blot) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0,util/* wait */.Dc)(250);
              case 2:
                // для работы после дропа а не во время, 250ms - для определения родителя перемещенного блота
                if (blot.id === _this.id) {
                  if (_this.isVideoFile()) {
                    _this.onVideoDrop();
                  }
                } else {
                  _this.onOtherBlotDrop(blot);
                }
              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    file_defineProperty(file_assertThisInitialized(_this), "onVideoDrop", function () {
      var _this$editor$findById, _this$editor$findById2;
      var _this$editor$plugins = _this.editor.plugins,
        ctaManager = _this$editor$plugins.ctaManager,
        i18n = _this$editor$plugins.i18n;
      var parent = ((_this$editor$findById = _this.editor.findById(_this.id)) === null || _this$editor$findById === void 0 ? void 0 : (_this$editor$findById2 = _this$editor$findById.parent) === null || _this$editor$findById2 === void 0 ? void 0 : _this$editor$findById2.parent) || null;
      if (parent instanceof blots_gridCol) {
        if (ctaManager.getCta(_this.id, _this.props.attachment.global_id)) {
          _this.processToShowDialog({
            title: i18n.get('file.menu.grid'),
            message: i18n.get('file.menu.cta_drop_in_grid')
          });
        }
      }
    });
    file_defineProperty(file_assertThisInitialized(_this), "onOtherBlotDrop", /*#__PURE__*/function () {
      var _ref2 = file_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(blot) {
        var _blot$props, _blot$props$attachmen, _editor$findById;
        var _assertThisInitialize, editor, _editor$plugins, ctaManager, i18n, parent, col, cols;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _assertThisInitialize = file_assertThisInitialized(_this), editor = _assertThisInitialize.editor;
                _editor$plugins = editor.plugins, ctaManager = _editor$plugins.ctaManager, i18n = _editor$plugins.i18n;
                if (!(blot.isVideoFile && blot.isVideoFile() && ctaManager.getCta(blot.id, (_blot$props = blot.props) === null || _blot$props === void 0 ? void 0 : (_blot$props$attachmen = _blot$props.attachment) === null || _blot$props$attachmen === void 0 ? void 0 : _blot$props$attachmen.global_id))) {
                  _context2.next = 4;
                  break;
                }
                return _context2.abrupt("return");
              case 4:
                parent = ((_editor$findById = editor.findById(blot.id)) === null || _editor$findById === void 0 ? void 0 : _editor$findById.parent) || null;
                col = null;
                if (parent instanceof blots_gridCol) {
                  col = parent;
                }
                // check for parent here, because files in tables do not have the parent blot
                else if (parent && parent.parent instanceof blots_gridCol) {
                  col = parent.parent;
                }

                // если дроп происходит в колонку
                if (col) {
                  cols = [];
                  if (col.prev) cols.push(col.prev);
                  if (col.next) cols.push(col.next);
                  // и если справа или слева от блота есть видео с включенным CTA то показываем сообщение
                  cols.forEach(function (gridColBlot) {
                    gridColBlot.map.get('children').forEach(function (blotId) {
                      var child = editor.findById(blotId);
                      if (child instanceof FileBlot) {
                        var props = child.props,
                          id = child.id;
                        if (child.isVideoFile() && props.attachment && ctaManager.getCta(id, props.attachment.global_id)) {
                          _this.processToShowDialog({
                            title: i18n.get('file.menu.grid'),
                            message: i18n.get('file.menu.cta_exists_in_grid')
                          });
                        }
                      }
                    });
                  });
                }
              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    file_defineProperty(file_assertThisInitialized(_this), "onScrollVideoPlayer", function (event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (_this.editor.mode !== _this.editor.constructor.MODE_EXPORT) {
        if (!_this.ticking) {
          window.requestAnimationFrame(function () {
            this.getBlotPosition();
            this.ticking = false;
          }.bind(file_assertThisInitialized(_this)));
          _this.ticking = true;
        }
      }
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileContainerMouseDown", function (event) {
      if (event.target === _this.fileRenameInputNode) {
        event.stopPropagation();
        return;
      }
      // отменяем нажатие кнопки мыши, чтобы каретка не ставилась внутрь элемента
      event.preventDefault();
    });
    file_defineProperty(file_assertThisInitialized(_this), "onMenuButtonClick", function (event) {
      if (_this._swallowMenuClick) {
        _this._swallowMenuClick = false;
        return;
      }
      if (!_this.props.menuOpen) {
        _this.editor.emitter.emit('file-menu-open', {
          menuOpen: !_this.props.menuOpen
        });
      }
      _this.setProps({
        menuOpen: !_this.props.menuOpen
      });
    });
    file_defineProperty(file_assertThisInitialized(_this), "onMenuButtonMouseDown", function (event) {
      if (!_this.isTableCell()) {
        event.stopPropagation();
      }
      if (_this.props.menuOpen) {
        // запрещаем появление меню сразу после его скрытия. это происходит когда меню открыто
        // и нажимается значек меню.
        _this._swallowMenuClick = true;
        var _restore = function _restore() {
          setTimeout(function () {
            return _this._swallowMenuClick = false;
          });
          document.removeEventListener('mouseup', _restore, false);
        };
        document.addEventListener('mouseup', _restore, false);
      }
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileClickMenuDownload", function () {
      _this.onFileDownload();
      _this.hideFileMenu();
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileClickMenuOpenInNewTab", function () {
      _this.onFileOpenInNewTab();
      _this.hideFileMenu();
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileClickMenuLinkCopy", function () {
      _this.onFileLinkCopy();
      _this.hideFileMenu();
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileClickMenuRename", function () {
      _this.onFileRename();
      _this.hideFileMenu();
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileClickMenuReplace", function () {
      _this.onFileReplace();
      _this.hideFileMenu();
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileClickMenuDelete", function () {
      _this.onFileDelete();
      _this.hideFileMenu();
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileClickMenuSetCompactView", function () {
      _this.onFileSetCompactView();
      _this.hideFileMenu();
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileClickMenuSetFullView", function () {
      _this.onFileSetFullView();
      _this.hideFileMenu();
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileClickMenuGoFullScreen", function () {
      _this.onGoFullScreen();
      _this.hideFileMenu();
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileClickMenuAutoplay", function () {
      var attachment = _this.props.attachment;
      var i18n = _this.editor.plugins.i18n;
      var syncedState = {};
      if (attachment.autoplay) {
        syncedState.autoplay = false;
        var title = i18n.get('file.menu.autoplay') + ': ' + i18n.get('file.menu.disabled');
        _this.editor.plugins.notificationManager.toast(title);
      } else {
        syncedState.autoplay = true;
        var _title = i18n.get('file.menu.autoplay') + ': ' + i18n.get('file.menu.enabled');
        _this.editor.plugins.notificationManager.toast(_title);
      }
      _this.setProps({
        attachment: Object.assign({}, attachment, {
          autoplay: !attachment.autoplay
        })
      });
      _this.setViewerSyncedState(syncedState);
      _this.updateMotionState();
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileClickMenuSoundDefault", function () {
      var attachment = _this.props.attachment;
      var i18n = _this.editor.plugins.i18n;
      var syncedState = {};
      if (attachment.soundDefault) {
        syncedState.mute = false;
        var title = i18n.get('file.menu.sound_default') + ': ' + i18n.get('file.menu.enabled');
        _this.editor.plugins.notificationManager.toast(title);
      } else {
        syncedState.mute = true;
        var _title2 = i18n.get('file.menu.sound_default') + ': ' + i18n.get('file.menu.disabled');
        _this.editor.plugins.notificationManager.toast(_title2);
      }
      _this.setProps({
        attachment: Object.assign({}, attachment, {
          soundDefault: !attachment.soundDefault
        })
      });
      _this.setViewerSyncedState(syncedState);
      _this.updateMotionState();
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileClickMenuSoundLoop", /*#__PURE__*/file_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var attachment, _this$editor$plugins2, i18n, ctaManager, syncedState, title, _title3;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              attachment = _this.props.attachment;
              _this$editor$plugins2 = _this.editor.plugins, i18n = _this$editor$plugins2.i18n, ctaManager = _this$editor$plugins2.ctaManager; // Если для видео установлен CTA то показываем сообщение о том, что нельзя включить зацикливание
              if (!(_this.isVideoFile() && ctaManager.getCta(_this.id, attachment.global_id) && !attachment.loop)) {
                _context3.next = 6;
                break;
              }
              _context3.next = 5;
              return _this.processToShowDialog({
                title: i18n.get('file.menu.sound_loop'),
                message: i18n.get('file.menu.cta_loop_message')
              });
            case 5:
              return _context3.abrupt("return", _context3.sent);
            case 6:
              syncedState = {};
              if (attachment.loop) {
                syncedState.loop = false;
                title = i18n.get('file.menu.sound_loop') + ': ' + i18n.get('file.menu.disabled');
                _this.editor.plugins.notificationManager.toast(title);
              } else {
                syncedState.loop = true;
                _title3 = i18n.get('file.menu.sound_loop') + ': ' + i18n.get('file.menu.enabled');
                _this.editor.plugins.notificationManager.toast(_title3);
              }
              _this.setProps({
                attachment: Object.assign({}, attachment, {
                  loop: !attachment.loop
                })
              });
              _this.setViewerSyncedState(syncedState);
              _this.updateMotionState();
            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    file_defineProperty(file_assertThisInitialized(_this), "onFileClickMenuSoundHideControl", function () {
      var attachment = _this.props.attachment;
      var i18n = _this.editor.plugins.i18n;
      var syncedState = {};
      if (attachment.hideControl) {
        syncedState.hideControl = false;
        var title = i18n.get('file.menu.sound_hideControls') + ': ' + i18n.get('file.menu.disabled');
        _this.editor.plugins.notificationManager.toast(title);
      } else {
        syncedState.hideControl = true;
        var _title4 = i18n.get('file.menu.sound_hideControls') + ': ' + i18n.get('file.menu.enabled');
        _this.editor.plugins.notificationManager.toast(_title4);
      }
      _this.setProps({
        attachment: Object.assign({}, attachment, {
          hideControl: !attachment.hideControl
        })
      });
      _this.setViewerSyncedState(syncedState);
      _this.updateMotionState();
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileClickMenuPlayerShowTopPanel", function () {
      var attachment = _this.props.attachment;
      var i18n = _this.editor.plugins.i18n;
      var syncedState = {};
      if (attachment.showPanel) {
        syncedState.showPanel = false;
        var title = i18n.get('file.menu.sound_showPanel') + ': ' + i18n.get('file.menu.disabled');
        _this.editor.plugins.notificationManager.toast(title);
      } else {
        syncedState.showPanel = true;
        var _title5 = i18n.get('file.menu.sound_showPanel') + ': ' + i18n.get('file.menu.enabled');
        _this.editor.plugins.notificationManager.toast(_title5);
      }
      _this.setProps({
        attachment: Object.assign({}, attachment, {
          showPanel: !attachment.showPanel
        })
      });
      _this.setViewerSyncedState(syncedState);
      _this.updateMotionState();
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileClickMenuSoundVideoShadow", function () {
      var attachment = _this.props.attachment;
      var i18n = _this.editor.plugins.i18n;
      var syncedState = {};
      if (attachment.videoShadow) {
        syncedState.videoShadow = false;
        var title = i18n.get('file.menu.shadow_video') + ': ' + i18n.get('file.menu.disabled');
        _this.editor.plugins.notificationManager.toast(title);
      } else {
        syncedState.videoShadow = true;
        var _title6 = i18n.get('file.menu.shadow_video') + ': ' + i18n.get('file.menu.enabled');
        _this.editor.plugins.notificationManager.toast(_title6);
      }
      _this.setProps({
        attachment: Object.assign({}, attachment, {
          videoShadow: !attachment.videoShadow
        })
      });
      _this.setViewerSyncedState(syncedState);
      _this.updateMotionState();
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileClickMenuDisallowNote", function () {
      if (_this.disallowNote) {
        _this.map.set('disallowNoteDownloading', false);
      } else {
        _this.map.set('disallowNoteDownloading', true);
      }
      _this.hideFileMenu();
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileClickMenuDisallowShare", function () {
      if (_this.disallowShare) {
        _this.map.set('disallowShareDownloading', false);
      } else {
        _this.map.set('disallowShareDownloading', true);
      }
      _this.hideFileMenu();
    });
    file_defineProperty(file_assertThisInitialized(_this), "processToShowDialog", /*#__PURE__*/function () {
      var _ref5 = file_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref4) {
        var title, message, _assertThisInitialize2, editor, _editor$plugins2, popupManager, i18n, confirm;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                title = _ref4.title, message = _ref4.message;
                _assertThisInitialize2 = file_assertThisInitialized(_this), editor = _assertThisInitialize2.editor;
                _editor$plugins2 = editor.plugins, popupManager = _editor$plugins2.popupManager, i18n = _editor$plugins2.i18n;
                confirm = null;
                _context4.next = 6;
                return new Promise(function (resolve) {
                  var onCancel = function onCancel() {
                    resolve(true);
                  };
                  var onConfirm = function onConfirm() {
                    resolve(false);
                  };
                  confirm = (0,preact_module.h)(confirmPopup/* default */.Z, {
                    onCancel: onCancel,
                    onConfirm: onConfirm,
                    title: title,
                    message: message,
                    confirmText: "Ok",
                    editor: editor
                  });
                  popupManager.dialog(confirm);
                });
              case 6:
                confirm = null;
                popupManager.dialog(null);
              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return function (_x3) {
        return _ref5.apply(this, arguments);
      };
    }());
    file_defineProperty(file_assertThisInitialized(_this), "onFileClickMenuPreviewVideo", /*#__PURE__*/file_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var attachment, _assertThisInitialize3, id, editor, syncedState, newState;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              attachment = _this.props.attachment;
              _assertThisInitialize3 = file_assertThisInitialized(_this), id = _assertThisInitialize3.id, editor = _assertThisInitialize3.editor;
              syncedState = _this.getSyncedState();
              _context5.next = 5;
              return _this.editor.plugins.videoPreview.onEditPreview(syncedState.videoPreview || {
                videoAttachmentId: attachment.global_id,
                textOverlay: null,
                activePreviewType: "first_frame",
                previews: {}
              });
            case 5:
              newState = _context5.sent;
              if (newState) {
                newState.videoAttachmentId = attachment.global_id;
                console.log('setNewState', newState);
                _this.setViewerSyncedState({
                  videoPreview: newState
                });
              }
            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })));
    file_defineProperty(file_assertThisInitialized(_this), "onFileClickMenuMotionVideo", /*#__PURE__*/file_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var attachment, _assertThisInitialize4, id, editor, _editor$plugins3, i18n, ctaManager, viewerState, title, _viewerState, _title7;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              attachment = _this.props.attachment;
              _assertThisInitialize4 = file_assertThisInitialized(_this), id = _assertThisInitialize4.id, editor = _assertThisInitialize4.editor;
              _editor$plugins3 = editor.plugins, i18n = _editor$plugins3.i18n, ctaManager = _editor$plugins3.ctaManager; // Если у видео установлен CTA показываем сообщение о том что нельзя включить Motion видео
              if (!(ctaManager.getCta(id, attachment.global_id) && !attachment.motionVideo)) {
                _context6.next = 7;
                break;
              }
              _context6.next = 6;
              return _this.processToShowDialog({
                title: i18n.get('file.menu.motion_video'),
                message: i18n.get('file.menu.cta_motion_video_message')
              });
            case 6:
              return _context6.abrupt("return", _context6.sent);
            case 7:
              if (attachment.motionVideo) {
                viewerState = {
                  motionVideo: false,
                  autoplay: false,
                  mute: false,
                  loop: false,
                  videoShadow: false,
                  hideControl: false,
                  showPanel: true
                };
                _this.setViewerSyncedState(viewerState);
                title = i18n.get('file.menu.motion_video') + ': ' + i18n.get('file.menu.disabled');
                _this.editor.plugins.notificationManager.toast(title);
                _this.setProps({
                  attachment: Object.assign({}, attachment, viewerState)
                });
              } else {
                _viewerState = {
                  motionVideo: true,
                  autoplay: true,
                  mute: true,
                  loop: true,
                  videoShadow: true,
                  hideControl: true,
                  showPanel: false
                };
                _this.setViewerSyncedState(_viewerState);
                _title7 = i18n.get('file.menu.motion_video') + ': ' + i18n.get('file.menu.enabled');
                _this.editor.plugins.notificationManager.toast(_title7);
                _this.setProps({
                  attachment: Object.assign({}, attachment, _viewerState)
                });
              }
            case 8:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    })));
    file_defineProperty(file_assertThisInitialized(_this), "onFileClickMenuPrint", function () {
      _this.onFilePrint();
      _this.hideFileMenu();
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileDownloadClick", function (event) {
      event.preventDefault();
      event.stopPropagation();
      _this.onFileDownload();
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileDownload", function () {
      if (!_this.editor.plugins.attachmentManager.download(_this.props.attachment)) {
        download_default()(_this.props.attachment.url);
      }
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileNameClick", function (event) {
      if (_this.blotConfig.allowDownloadByFileNameClick === false) {
        return;
      }
      event.stopPropagation();
      _this.onFileDownload();
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileLinkCopy", function () {
      var i18n = _this.editor.plugins.i18n;
      _this.editor.plugins.copyManager.copy(getFullUrl(_this.props.attachment.url));
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileMenuClick", function (event) {
      event.marked = 'ok';
      _this.setProps({
        menuOpen: false
      });
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileReplace", function () {
      var addFileAction = new AddFileAction(AddFileAction.type, {
        blot: file_assertThisInitialized(_this),
        dontPutCaretAfter: true
      }, _this.editor);
      addFileAction.run({});
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileRename", function () {
      _this.setProps({
        renaming: true
      });
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileDelete", function (event) {
      var action = new DeleteAction(DeleteAction.type, {}, _this.editor);
      action.run({
        processingBlots: [file_assertThisInitialized(_this)]
      });
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileOpenInNewTab", function () {
      window.open(_this.props.attachment.url, 'noopener');
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileSetCellView", function () {
      _this.map.set('view_mode', 'cell');
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileSetCompactView", function () {
      _this.map.set('view_mode', 'compact');
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileSetFullView", function () {
      _this.map.set('view_mode', 'full');
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFilePrint", function () {
      _this.setProps({
        isPrinting: true
      });
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFilePrinted", function () {
      _this.setProps({
        isPrinting: false
      });
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFilePrintAbort", function () {
      _this.setProps({
        isPrinting: false
      });
    });
    file_defineProperty(file_assertThisInitialized(_this), "onGoFullScreen", function () {
      _this.setProps({
        fullscreen: {
          enable: true
        }
      });
      _this.onViewerGoFullScreen();
    });
    file_defineProperty(file_assertThisInitialized(_this), "onViewerGoFullScreen", function () {
      _this.setProps({
        isViewerFullscreen: true
      });
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFullScreenClose", function () {
      _this.setProps({
        fullscreen: null,
        isViewerFullscreen: false
      });
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFullScreenKeyDown", function (event) {
      event.preventDefault();
      event.stopPropagation();
      console.log('On fullscreen keydown');
    });
    file_defineProperty(file_assertThisInitialized(_this), "onCompactViewClick", function (event) {
      event.stopPropagation();
      var disableClickOn = ['file-alert', 'file-fetch', 'file-menu-icon', FILE_MENU_CLASS];
      if (_this.blotConfig.allowDownloadByFileNameClick !== false) {
        disableClickOn.push('truncated-text');
        disableClickOn.push('file-name');
      }
      if (event.target.closest) {
        var _iterator = file_createForOfIteratorHelper(disableClickOn),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var cl = _step.value;
            if (event.target.closest('.' + cl)) {
              return;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      if (_this.props.renaming) {
        return;
      }
      if (!_this.isTableCell()) {
        if (_this.onCompactViewClickAction) {
          _this.onCompactViewClickAction();
        }
      }
      if (_this.blotConfig.toggleIfFocused) {
        return;
      }
      if (_this.blotConfig.disableToggleViewModeOnClick) {
        return;
      }
      _this.onUserOpenFileIntent();
    });
    file_defineProperty(file_assertThisInitialized(_this), "onCompactViewMouseDown", function (event) {
      if (_this.editor && _this.editor.options.keyboardMode === 'mobile') {
        _this.editor.blur();
      }
      /* if (this.isTableCell()) {
        event.stopPropagation()
      } */
      if (_this.blotConfig.toggleIfFocused && _this.props.focused) {
        _this.onUserOpenFileIntent();
      }
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileAlertClick", function (event) {
      _this.editor.plugins.popupManager.customAlert(_this.props.attachment.alert);
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileClickFetch", function (event) {
      _this.editor.plugins.attachmentManager.fetch(_this.props.attachment);
      if (!_this.props.fetchingFile) {
        _this.setProps({
          fetchingFile: true
        }); // устанавливаем свойство что идёт скачивание
      }
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileAbortClick", function (event) {
      event.preventDefault();
      event.stopPropagation();
      _this.onTaskAbortClick();
      _this.remove();
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileAbortFetchClick", function () {
      _this.editor.plugins.attachmentManager.abortFetch(_this.props.attachment);
      _this.props.attachment.is_fetching = false; // для того чтобы показать состояние файла до загрузки
      _this.setProps({
        fetchingFile: false
      }); // для того, чтобы отключить анимацию иконки скачивания
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFilePlayClick", function (event) {
      var fileInterface = _this.props.fileInterface;
      // Добавление аудиоплеера если блот музыкальный
      if (_this.hasMusicAttachment) {
        // Если плеера нет
        if (!_this.props.audioPlayer) {
          _this.initAudioPlayer();
        } else {
          if (_this.props.audioPlayer.isPlaying()) {
            _this.props.audioPlayer.pause();
          } else {
            if (fileInterface.state.initPlayer) {
              fileInterface.clearPlayer();
              _this.props.audioPlayer.destroy();
            } else {
              _this.props.audioPlayer.play();
            }
          }
        }
      }
    });
    file_defineProperty(file_assertThisInitialized(_this), "setViewerSyncedState", function (stateUpdate) {
      var stateMap = _this.map.get('syncedViewerState');
      // нормализация состояния после разделения настроек скрытия панели управления видео и верхней панели
      if (stateUpdate.hasOwnProperty('showPanel') && stateMap.get('hideControls')) {
        stateMap.delete('hideControls');
        if (!stateMap.has('hideControl')) {
          stateMap.set('hideControl', true);
        }
      }
      if (stateUpdate.hasOwnProperty('hideControl') && stateMap.get('hideControls')) {
        stateMap.delete('hideControls');
        if (!stateMap.has('showPanel')) {
          stateMap.set('showPanel', false);
        }
      }
      var current = stateMap.toJSON();
      _this.editor.store.transaction(function () {
        for (var k in stateUpdate) {
          if (current[k] !== stateUpdate[k]) {
            stateMap.set(k, stateUpdate[k]);
          }
        }
      });
    });
    file_defineProperty(file_assertThisInitialized(_this), "setSyncedInterfaceState", function (stateUpdate) {
      var stateMap = _this.map.get('syncedInterfaceState');
      if (!stateMap) {
        // для совместимости с уже созданными блотами
        _this.map.set('syncedInterfaceState', new _this.store.types.Map());
        stateMap = _this.map.get('syncedInterfaceState');
      }
      var current = stateMap.toJSON();
      _this.editor.store.transaction(function () {
        for (var k in stateUpdate) {
          if (current[k] !== stateUpdate[k]) {
            stateMap.set(k, stateUpdate[k]);
          }
        }
      });
    });
    file_defineProperty(file_assertThisInitialized(_this), "onMenuWantsToClose", function () {
      _this.setProps({
        menuOpen: false
      });
    });
    file_defineProperty(file_assertThisInitialized(_this), "onRenameApply", /*#__PURE__*/function () {
      var _ref8 = file_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(newName, isEnter) {
        var attachment, can;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                attachment = _this.props.attachment;
                can = false;
                if (!newName) {
                  _context7.next = 6;
                  break;
                }
                _context7.next = 5;
                return _this.editor.plugins.attachmentManager.renameAttachment(attachment.global_id, newName);
              case 5:
                can = _context7.sent;
              case 6:
                if (can) {
                  _this.setProps({
                    attachment: Object.assign({}, attachment, {
                      display_name: newName
                    }),
                    renaming: false
                  });
                } else {
                  _this.setProps({
                    renaming: false
                  });
                }
                if (!isEnter && _this.scroll.selection.isWithinNode(_this.domNode)) {
                  _this.setCaretInTrap();
                }
              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
      return function (_x4, _x5) {
        return _ref8.apply(this, arguments);
      };
    }());
    file_defineProperty(file_assertThisInitialized(_this), "onRenameAbort", function () {
      _this.setProps({
        renaming: false
      });
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileMenuOpenEvent", function (event) {
      if (event.menuOpen && _this.props.menuOpen) {
        _this.hideFileMenu();
      }
    });
    file_defineProperty(file_assertThisInitialized(_this), "getViewAs", function () {
      return _this.map.get('view_as') || _this.viewAsDefault;
    });
    file_defineProperty(file_assertThisInitialized(_this), "onViewPdfAsChange", function (viewAs) {
      return function (event) {
        event && event.stopPropagation();
        _this.map.set('view_as', viewAs);
        _this.hideFileMenu();
      };
    });
    file_defineProperty(file_assertThisInitialized(_this), "uploadRecord", function (event) {
      if (event.detail) {
        WrtcRecord.uploadRecord(file_assertThisInitialized(_this), event);
      }
    });
    file_defineProperty(file_assertThisInitialized(_this), "toogleMute", function (event) {
      if (event) {
        event.preventDefault();
      }
      if (_this.props.audioPlayer) {
        if (_this.props.isMuted) {
          _this.props.audioPlayer.updateMute(false);
          _this.setProps({
            isMuted: false
          });
        } else {
          _this.props.audioPlayer.updateMute(true);
          _this.setProps({
            isMuted: true
          });
        }
      }
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileInUploaderConvertToFile", function () {
      var uploaderWrapper = searchUp(file_assertThisInitialized(_this), function (b) {
        return b.constructor.blotName === 'uploaderWrapper';
      });
      if (uploaderWrapper) {
        var uploader = uploaderWrapper.basicBlot;
        var container = uploader.container;
        container.moveChild(_this.id, container.getChildIndex(uploader.id) + 1);
      }
    });
    file_defineProperty(file_assertThisInitialized(_this), "onFileConvertToImage", function () {
      if (_this.inUploader()) {
        var uploaderWrapper = searchUp(file_assertThisInitialized(_this), function (b) {
          return b.constructor.blotName === 'uploaderWrapper';
        });
        if (uploaderWrapper) {
          var uploader = uploaderWrapper.basicBlot;
          var container = uploader.container;
          container.addBlot('image', {
            attachmentGlobalId: _this.map.get('attachmentGlobalId'),
            after: uploader.id
          });
          _this.remove();
        }
      } else {
        _this.editor.exec('convert-blot', {
          type: 'image',
          attachmentGlobalId: _this.map.get('attachmentGlobalId')
        });
      }
    });
    file_defineProperty(file_assertThisInitialized(_this), "onGetTextFromImage", function () {
      var imageBlotConfig = _this.editor.blotsConfig['image'];
      if (imageBlotConfig.processGetTextFromImage) {
        imageBlotConfig.processGetTextFromImage(_this.map.get('attachmentGlobalId'));
        return;
      }
      var text;
      var getTextPromise = imageBlotConfig.ocr.getTextForAttachment(_this.map.get('attachmentGlobalId'));
      if (getTextPromise === false) {
        // клиент отменяет получение текста
        return;
      }
      var component = (0,preact_module.h)(imageTextPopup_ImageInfoPopup, {
        textPromise: getTextPromise,
        attachment: _this.props.attachment,
        editor: _this.editor
      });
      _this.editor.plugins.popupManager.dialog(component);
      _this.onMenuWantsToClose();
    });
    file_defineProperty(file_assertThisInitialized(_this), "fileMapObserver", function (event, _ref9) {
      var local = _ref9.local;
      var _event = file_slicedToArray(event, 1),
        target = _event[0].target;
      var listenUpdates = ['loop', 'motionVideo', 'autoplay', 'videoShadow', 'hideControl', 'showPanel'];
      if (!local) {
        target.forEach(function (value, key) {
          if (listenUpdates.includes(key)) {
            _this.props.attachment[key] = value;
          }
        });
      }
      _this.render();
    });
    _this.attachmentConfig.allowEmbedUrl = false;
    _this.getMemoizedSyncedState = moize_min_default()(function (state) {
      return state;
    }, {
      isDeepEqual: true,
      maxSize: 3
    });
    _this.addCanExecActions(['delete', 'backspace', 'set-audio-player-color']);
    _this.fileMenuIconNode = null;
    _this.fileRenameInputNode = null;
    _this.isSeparableByClickApplicable = true;
    _this.fileNameTruncater = null;
    _this.kindsDefaultViewModes = Object.assign({}, kindsDefaultViewModes);
    _this.ticking = false;
    _this.viewAsDefault = 'single';
    _this.pdfNumPages = 0; // количество страниц в pdf документе, устанавливается из pdf-вьювера

    _this.props.fetchingFile = null;
    return _this;
  }
  file_createClass(FileBlot, [{
    key: "blotDidUpdate",
    value: function blotDidUpdate(oldProps) {
      if (this.props.maxAvailableWidth !== oldProps.maxAvailableWidth) {
        if (oldProps.maxAvailableWidth) {
          console.warn('max width updated', oldProps.maxAvailableWidth);
          // обновляем только если изменение ширины, а не ее установка
          this.processAvailableWidthChangeDebounced();
        }
      }
      if (this.props.attachment && oldProps.attachment) {
        if (this.props.attachment.need_fetch !== oldProps.attachment.need_fetch) {
          if (this.props.attachment.need_fetch === false) {
            this.setProps({
              fetchingFile: false
            });
            this.toggleViewMode('full'); // переключаем просмотр в full режим после того как скачивание закончилось
          }
        }

        if (this.props.attachment.is_fetching !== oldProps.attachment.is_fetching) {
          if (this.props.attachment.is_fetching === false && this.props.fetchingFile === true) {
            // не показываем прогресс на иконке загрузки если изменился is_fetching
            this.setProps({
              fetchingFile: false
            });
          }
        }
      }
    }
  }, {
    key: "reDrawBuffer",
    value: function reDrawBuffer() {
      var fileInterface = this.props.fileInterface;
      if (this.hasMusicAttachment) {
        if (this.props.audioPlayer) {
          if (fileInterface.state.drawBuffer) {
            this.props.audioPlayer.drawBuffer();
          }
        }
      }
    }
  }, {
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = file_get(file_getPrototypeOf(FileBlot.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      this.store.observeDeep(this.map, this.fileMapObserver);
      var scroll = this.editor.getScrollingContainer();
      scroll.addEventListener('scroll', this.onScrollVideoPlayer);
      this.editor.on('file-menu-open', this.onFileMenuOpenEvent);
      this.render();
      this.editor.on('editorBodyResize', this.onEditorBodyResize);
      setTimeout(this.getBlotPosition.bind(this), 300);
      var _this$blotConfig = this.blotConfig,
        _this$blotConfig$show = _this$blotConfig.showMenuItemOpenInNewTab,
        showMenuItemOpenInNewTab = _this$blotConfig$show === void 0 ? true : _this$blotConfig$show,
        _this$blotConfig$show2 = _this$blotConfig.showRightMenuItemCopyLink,
        showRightMenuItemCopyLink = _this$blotConfig$show2 === void 0 ? true : _this$blotConfig$show2,
        _this$blotConfig$show3 = _this$blotConfig.showLeftMenuItemCopyLink,
        showLeftMenuItemCopyLink = _this$blotConfig$show3 === void 0 ? true : _this$blotConfig$show3,
        _this$blotConfig$show4 = _this$blotConfig.showMenuItemGetTextFromImage,
        showMenuItemGetTextFromImage = _this$blotConfig$show4 === void 0 ? true : _this$blotConfig$show4;
      this.showMenuItemOpenInNewTab = showMenuItemOpenInNewTab;
      this.showRightMenuItemCopyLink = showRightMenuItemCopyLink;
      this.showLeftMenuItemCopyLink = showLeftMenuItemCopyLink;
      this.showMenuItemGetTextFromImage = showMenuItemGetTextFromImage;
      WrtcRecord.onAttach(this);
      this.onAttachUploadResoursesIfNeed();
      this.isSelectable = this.inUploader() ? false : true;
      this.editor.emitter.on('drop', this.onDrop);
    }
  }, {
    key: "detach",
    value: function detach() {
      if (file_get(file_getPrototypeOf(FileBlot.prototype), "detach", this)) {
        var _get3;
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        (_get3 = file_get(file_getPrototypeOf(FileBlot.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      }
      this.store.unobserveDeep(this.map, this.fileMapObserver);
      var scroll = this.editor.getScrollingContainer();
      scroll.removeEventListener('scroll', this.onScrollVideoPlayer);
      this.editor.off('editorBodyResize', this.onEditorBodyResize);
      this.editor.off('file-menu-open', this.onFileMenuOpenEvent);
      WrtcRecord.onDetach(this);
      this.editor.emitter.off('drop', this.onDrop);
    }

    /**
     * Событие при дропе файла
     * @param { Object } blot - блот
     */
  }, {
    key: "embedAttachmentUrl",
    value: function embedAttachmentUrl(url) {
      file_get(file_getPrototypeOf(FileBlot.prototype), "embedAttachmentUrl", this).call(this, url);
      if (this.map.get('src')) {
        this.map.delete('src');
      }
      this.render();
    }
  }, {
    key: "getBlotPositionShare",
    value: function getBlotPositionShare() {
      this.getBlotPosition(250);
    }
  }, {
    key: "getBlotPosition",
    value: function getBlotPosition(yPos) {
      // когда запуск происходит на сервере в node.js в этом месте может не быть document
      if (!document || !document.elementFromPoint) {
        return;
      }
      var scroll = this.editor.getScrollingContainer();
      var _this$editor$scroll$d = this.editor.scroll.domNode.getBoundingClientRect(),
        x = _this$editor$scroll$d.x;
      var _scroll$getBoundingCl = scroll.getBoundingClientRect(),
        y = _scroll$getBoundingCl.y;
      x += 10;
      if (yPos) {
        y += yPos;
      } else {
        y += 100;
      }
      var node = document && document.elementFromPoint(x, y);
      while (node === this.editor.scroll.domNode) {
        y += 1;
        node = document && document.elementFromPoint(x, y);
      }
      if (node && (node.className === 'video-loader' || node.className === 'compact-view-content file-uploading' || node.className === 'note-text-loader ng-scope')) {
        setTimeout(this.getBlotPosition.bind(this), 200);
        return false;
      } else if (node && node.className === 'nns-breadcrumbs-prev') {
        setTimeout(this.getBlotPositionShare.bind(this), 200);
        return false;
      }
      if (node && node.className === 'grid grid_50') {
        var fileBlot = node.getElementsByClassName('video-player-playpause-big')[0];
        // пробуем автовоспроизвести видео
        if (fileBlot && fileBlot.dataset.videoblotid) {
          this.videoPlayAuto(fileBlot.dataset.videoblotid);
        } else {
          var rightGrid = node.nextSibling;
          if (rightGrid) {
            var _fileBlot = rightGrid.getElementsByClassName('video-player-playpause-big')[0];
            if (_fileBlot && _fileBlot.dataset.videoblotid) {
              this.videoPlayAuto(_fileBlot.dataset.videoblotid);
            }
          }
        }
      } else if (node && node.className === 'compact-view-content viewer-support') {
        var _fileBlot2 = node.parentNode.getElementsByClassName('video-player-playpause-big')[0];
        // пробуем автовоспроизвести видео
        if (_fileBlot2 && _fileBlot2.dataset.videoblotid) {
          this.videoPlayAuto(_fileBlot2.dataset.videoblotid);
        }
      } else if (node && node.className === 'video-player-controls') {
        var _fileBlot3 = node.getElementsByClassName('video-player-playpause-big')[0];
        if (_fileBlot3.classList.contains('hidden')) {
          _fileBlot3.classList.remove('hidden');
        }
        // пробуем автовоспроизвести видео
        if (_fileBlot3 && _fileBlot3.dataset.videoblotid) {
          this.videoPlayAuto(_fileBlot3.dataset.videoblotid);
        }
      } else if (node && (node.className === 'video-player-playpause-big' || node.className === 'video-player-playpause-big hidden')) {
        // пробуем автовоспроизвести видео
        if (node.dataset.videoblotid) {
          this.videoPlayAuto(node.dataset.videoblotid);
        }
      } else {
        // паузим видео если оно ушло за экран
        if (node && !node.dataset.videoblotid) {
          this.videoPauseAuto();
        }
      }
    }
  }, {
    key: "videoPauseAuto",
    value: function videoPauseAuto() {
      return;
    }
  }, {
    key: "videoPlayAuto",
    value: function videoPlayAuto(blotId) {
      return;
    }
  }, {
    key: "getWrapper",
    value: function getWrapper() {
      return this.parent;
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (this.props.videoPlayer && this.props.videoPlayer.handleKeyDown) {
        return this.props.videoPlayer.handleKeyDown(event);
      }
      return false;
    }
  }, {
    key: "getFileViewer",
    value: function getFileViewer() {
      var viewers = this.blotConfig.viewers;
      var mime = this.props.attachment && this.props.attachment.mime;
      if (mime === 'audio/vnd.dlna.adts') {
        mime = 'audio/aac';
      }
      if (!viewers) {
        return;
      }
      var viewer;
      var _iterator2 = file_createForOfIteratorHelper(viewers),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var v = _step2.value;
          if (v.mime.includes(mime)) {
            if (v.class === 'AudioWiewer') {
              if (v.options.audioPlayerEnabled) {
                viewer = v;
                break;
              }
            } else {
              viewer = v;
              break;
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return viewer;
    }
  }, {
    key: "hasFileViewer",
    value: function hasFileViewer() {
      return Boolean(this.getFileViewer());
    }
  }, {
    key: "getFileKind",
    value: function getFileKind() {
      if (!this.props.attachment) {
        if (this.audioRecord) {
          return "audioRecord";
        } else if (this.mediaRecord) {
          return "mediaRecord";
        } else {
          return 'resolving';
        }
      }
      if (mimeKinds[this.props.attachment.mime]) {
        this.props.attachment.type = mimeKinds[this.props.attachment.mime];
      }
      return this.props.attachment.type;
    }
  }, {
    key: "onFocusableBlur",
    value: function onFocusableBlur() {
      if (file_get(file_getPrototypeOf(FileBlot.prototype), "onFocusableBlur", this)) {
        file_get(file_getPrototypeOf(FileBlot.prototype), "onFocusableBlur", this).call(this);
      }
      this.setProps({
        menuOpen: false,
        renaming: false
      });
    }
  }, {
    key: "hideFileMenu",
    value: function hideFileMenu() {
      this.setProps({
        menuOpen: false
      });
    }
  }, {
    key: "isTableCell",
    value: function isTableCell() {
      return this.map.get('mode') === 'tableCell';
    }
  }, {
    key: "embeddableFocus",
    value: function embeddableFocus() {
      if (this.isTableCell()) return;
      file_get(file_getPrototypeOf(FileBlot.prototype), "embeddableFocus", this).call(this);
    }
  }, {
    key: "updateMotionState",
    value: function updateMotionState() {
      var attachment = this.props.attachment;
      var autoplay = attachment.autoplay,
        hideControl = attachment.hideControl,
        loop = attachment.loop,
        videoShadow = attachment.videoShadow,
        motionVideo = attachment.motionVideo,
        showPanel = attachment.showPanel;
      if (autoplay && hideControl && loop && videoShadow && !motionVideo && !showPanel) {
        this.setProps({
          attachment: Object.assign({}, attachment, {
            motionVideo: true
          })
        });
        this.setViewerSyncedState({
          motionVideo: true
        });
      } else if (motionVideo) {
        this.setProps({
          attachment: Object.assign({}, attachment, {
            motionVideo: false
          })
        });
        this.setViewerSyncedState({
          motionVideo: false
        });
      }
    }
  }, {
    key: "deleteSingeBlot",
    value: function deleteSingeBlot() {
      this.onFileClickMenuDelete();
    }
  }, {
    key: "onUserOpenFileIntent",
    value:
    // вызывается когда пользователь нажимает на компакт вью файла для выполнения действия с файлом:
    // развернуть/свернуть или открыть
    function onUserOpenFileIntent() {
      var fileViewer = this.getFileViewer();
      if (fileViewer) {
        this.toggleViewMode();
      } else if (this.blotConfig.open) {
        // чтобы предотвратить одновременный вызов fetch(id: String) и open(id: String), что приводит к не возможности
        // отменить загрузку в мобильных клиентах, проверяем что файл уже загружается
        if (!this.props.attachment.need_fetch) {
          this.blotConfig.open(this.props.attachment);
        }
      }
    }
  }, {
    key: "toggleViewMode",
    value: function toggleViewMode() {
      var viewMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (this.dontToggleViewMode || this.props.attachment.need_fetch) {
        return;
      }
      var fileKind = this.getFileKind();
      var fileViewer = this.getFileViewer();
      var currentViewMode = this.getFileViewMode(fileKind);
      if (!fileViewer) {
        return;
      }
      var newViewMode;
      if (viewMode !== '') {
        newViewMode = viewMode;
      } else {
        if (currentViewMode === 'compact') {
          newViewMode = 'full';
        } else {
          newViewMode = 'compact';
        }
      }
      this.map.set('view_mode', newViewMode);
    }
  }, {
    key: "clearAttachment",
    value: function clearAttachment() {
      var _this2 = this;
      this.batchPropsUpdate(function () {
        _this2.store.transaction(function () {
          _this2.map.set('syncedViewerState', new _this2.store.types.Map());
          _this2.map.set('syncedInterfaceState', new _this2.store.types.Map());
          _this2.map.delete('imagePreviewWidth');
          file_get(file_getPrototypeOf(FileBlot.prototype), "clearAttachment", _this2).call(_this2);
        });
      });
    }
  }, {
    key: "cloneSelf",
    value: function cloneSelf() {
      var map = this.store.createMap();
      var interfaceState = {};
      var fileInterface = this.props.fileInterface;
      if (fileInterface && fileInterface.interfaceState) {
        interfaceState = fileInterface.interfaceState;
      }
      parchment_default().query(this.map.get('type')).initMap(map, this.store, file_objectSpread({
        attachmentGlobalId: this.map.get('attachmentGlobalId')
      }, interfaceState));
      return map.get('id');
    }
  }, {
    key: "getSyncedState",
    value: function getSyncedState() {
      return this.getMemoizedSyncedState(this.map.get('syncedViewerState').toJSON());
    }
  }, {
    key: "getSyncedInterfaceState",
    get: function get() {
      return this.getMemoizedSyncedState(this.map.get('syncedInterfaceState') && this.map.get('syncedInterfaceState').toJSON());
    }
  }, {
    key: "getFileViewMode",
    value: function getFileViewMode(kind) {
      kind = kind || this.getFileKind();
      if (this.props.attachment && this.props.attachment.need_fetch) {
        // если аттач еще не скачан локально, то показываем файл в компакт режиме
        return 'compact';
      }
      var setViewMode = this.map.get('view_mode');
      if (setViewMode) {
        return setViewMode;
      }
      if (this.blotConfig.defaultViewMode) {
        return this.blotConfig.defaultViewMode;
      }
      if (this.kindsDefaultViewModes[kind]) {
        return this.kindsDefaultViewModes[kind];
      }
      return 'compact';
    }
  }, {
    key: "getSizeClass",
    value: function getSizeClass(_ref10) {
      var fileContainer = _ref10.fileContainer;
      var width = fileContainer.offsetWidth;
      if (width < TOO_SMALL_SIZE_THRESHOLD) {
        return 'file-too-small';
      } else if (width < SMALL_SIZE_THRESHOLD) {
        return 'file-small';
      }
      return '';
    }
  }, {
    key: "getSpecialBlotMenu",
    value: function getSpecialBlotMenu() {
      if (!this.props.attachment) {
        return {};
      }
      var i18n = this.editor.plugins.i18n;
      var fileViewer = this.getFileViewer();
      var fileKind = this.getFileKind();
      var readonlyMode = this.editor.mode === MODE_READONLY;
      var shareMode = readonlyMode && this.editor.options.isShare;
      var menu = {};
      if (!this.disallowDownloading) {
        if (this.showMenuItemOpenInNewTab) {
          menu['open-in-new-tab'] = {
            label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
              id: "file.menu.open_in_new_tab"
            }),
            index: 1,
            action: 'onFileClickMenuOpenInNewTab'
          };
        }
        if (this.showRightMenuItemCopyLink) {
          menu['copyLink'] = {
            label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
              id: "file.menu.copy_link"
            }),
            index: 2,
            action: 'onFileClickMenuLinkCopy'
          };
        }
        menu['download'] = {
          label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
            id: "file.menu.download"
          }),
          index: 0,
          action: 'onFileClickMenuDownload'
        };
      }
      if (fileViewer) {
        if (fileViewer.class.supportsFullscreen) {
          var viewMode = this.getFileViewMode();
          if (viewMode === 'full' && !this.videoError) {
            menu['go-fullscreen'] = {
              label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
                id: "file.menu.expand_in_full_window"
              }),
              index: 3,
              action: 'onFileClickMenuGoFullScreen'
            };
          }
        }
        if (fileViewer.class.printable && !this.disallowDownloading) {
          menu['print'] = {
            label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
              id: "file.menu.print"
            }),
            index: 4,
            action: 'onFileClickMenuPrint'
          };
        }
      }
      if (this.isImageFile() && !this.isTableCell()) {
        menu['convert-to-image'] = {
          label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
            id: "file.menu.convert_to_image"
          }),
          index: 5,
          action: 'onFileConvertToImage'
        };
        var imageBlotConfig = this.editor.blotsConfig['image'] || {};
        if (typeof imageBlotConfig.ocr !== 'undefined' && this.showMenuItemGetTextFromImage) {
          // получаем иконку доступности фичи
          var getTextFromImageEe = new (events_default())();
          var onGTFIMouseEnter = function onGTFIMouseEnter() {
            getTextFromImageEe.emit('enter', {});
          };
          var onGTFIMMouseLeave = function onGTFIMMouseLeave() {
            getTextFromImageEe.emit('leave', {});
          };
          var featureIcon = this.editor.plugins.featuresAvailabilityPlugin.getFeatureIcon('get-text-from-image', getTextFromImageEe);
          menu['get-text-from-image'] = {
            label: (0,preact_module.h)("div", {
              onMouseEnter: onGTFIMouseEnter,
              onMouseLeave: onGTFIMMouseLeave
            }, (0,preact_module.h)(plugins_i18n/* Text */.xv, {
              id: "file.menu.get_text_from_image"
            }), featureIcon),
            index: 6,
            action: 'onGetTextFromImage'
          };
        }
      }
      if (!readonlyMode && !shareMode && !this.parentReadOnly) {
        if (this.inUploader()) {
          menu['convert-to-file'] = {
            label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
              id: "file.menu.convert_to_file"
            }),
            index: 5,
            action: 'onFileInUploaderConvertToFile'
          };
        }
        menu['rename'] = {
          label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
            id: "file.menu.rename"
          }),
          index: 7,
          action: 'onFileClickMenuRename'
        };
        if (!this.inUploader()) {
          menu['replace'] = {
            label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
              id: "file.menu.replace"
            }),
            index: 8,
            action: 'onFileClickMenuReplace'
          };
        }
        menu['delete'] = {
          label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
            id: "file.menu.delete"
          }),
          index: 9,
          action: 'onFileClickMenuDelete'
        };
      }
      if (readonlyMode) {
        if (!this.disallowDownloading && fileKind === 'audio' && fileViewer) {
          menu = {
            download: {
              label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
                id: "file.menu.download"
              }),
              index: 0,
              action: 'onFileClickMenuDownload'
            }
          };
        }
      }
      if (!shareMode && !this.parentReadOnly && this.blotConfig.downloading && this.editor.options.keyboardMode !== 'mobile') {
        var iconNote = icons/* IconDone */.EZi;
        var iconShare = icons/* IconDone */.EZi;
        if (this.disallowNote) {
          iconNote = icons/* IconEmpty */.Zlx;
        }
        if (this.disallowShare) {
          iconShare = icons/* IconEmpty */.Zlx;
        }
        var subMenu = {};
        subMenu['for_note'] = {
          label: i18n.get("file.menu.for_note"),
          index: 0,
          group: 0,
          action: 'onFileClickMenuDisallowNote',
          icon: iconNote
        };
        subMenu['for_share'] = {
          label: i18n.get("file.menu.for_share"),
          index: 1,
          group: 0,
          action: 'onFileClickMenuDisallowShare',
          icon: iconShare
        };
        menu["disallowDownloading"] = {
          label: i18n.get("file.menu.disallow_download"),
          index: 0,
          submenuOptions: {
            anchorNode: null,
            anchorOptions: {
              boundariesElement: this.editor.getScrollingContainer()
            }
          },
          submenu: subMenu
        };
      }
      if (this.inUploader()) {
        var uploaderWrapper = searchUp(this, function (blot) {
          return blot.constructor.blotName === 'uploaderWrapper';
        });
        if (uploaderWrapper) {
          var _uploaderWrapper$basi;
          var isUploaderEdiatable = uploaderWrapper === null || uploaderWrapper === void 0 ? void 0 : (_uploaderWrapper$basi = uploaderWrapper.basicBlot) === null || _uploaderWrapper$basi === void 0 ? void 0 : _uploaderWrapper$basi.isEditable();
          if (!isUploaderEdiatable) {
            delete menu['convert-to-image'];
            delete menu['convert-to-file'];
            delete menu['disallowDownloading'];
            delete menu['rename'];
            delete menu['delete'];
          }
        }
      }
      return menu;
    }
  }, {
    key: "getAdditionlSpecialBlotMenu",
    value: function getAdditionlSpecialBlotMenu() {
      var fileViewer = this.getFileViewer();
      var menu = {};
      // Добавляем дополнительные пункты меню если они есть у вьювера
      if (fileViewer && fileViewer.class.hasAdditionMenuItems) {
        menu = file_objectSpread(file_objectSpread({}, menu), fileViewer.class.getMenuItems(this, fileViewer.options));
      }
      return menu;
    }

    /**
     * Устанавливает количество страниц в pdf документе
     * необходимо для использования в меню
     * @param numPages
     */
  }, {
    key: "setPdfNumPages",
    value: function setPdfNumPages(numPages) {
      this.pdfNumPages = numPages;
    }

    /**
     * Получить текущий вид "Отображать как"
     * @returns {string}
     */
  }, {
    key: "tooltipText",
    value: function tooltipText() {
      var i18n = this.editor.plugins.i18n;
      return i18n.get('file.download_file', {
        name: this.props.attachment.display_name
      });
    }
  }, {
    key: "tooltipTextAudio",
    value: function tooltipTextAudio() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'play';
      var i18n = this.editor.plugins.i18n;
      type === 'stop' ? type = 'file.stop_file' : type = 'file.listen_file';
      return i18n.get(type, {
        name: this.props.attachment.display_name
      });
    }
  }, {
    key: "makeUid",
    value: function makeUid(length) {
      var result = '';
      var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    }
  }, {
    key: "disallowNote",
    get: function get() {
      return this.map.get('disallowNoteDownloading');
    }
  }, {
    key: "disallowShare",
    get: function get() {
      return this.map.get('disallowShareDownloading');
    }
  }, {
    key: "disallowDownloading",
    get: function get() {
      if ((this.editor.mode === this.editor.constructor.MODE_EDIT || this.editor.mode === this.editor.constructor.MODE_READONLY) && !this.editor.options.isShare) {
        return !!this.disallowNote;
      } else if (this.editor.mode === this.editor.constructor.MODE_READONLY && this.editor.options.isShare) {
        return !!this.disallowShare;
      } else {
        return false;
      }
    }
  }, {
    key: "disallowFileMenuIcon",
    get: function get() {
      var fileViewer = this.getFileViewer();
      var fileKind = this.getFileKind();
      return !(fileViewer && !this.disallowDownloading && allowMenuInShareFileTypes.indexOf(fileKind) !== -1);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      file_get(file_getPrototypeOf(FileBlot.prototype), "render", this).call(this);
      var wrapper = this.getWrapper();
      if (wrapper && wrapper.getBlotName() === FileWrapper.blotName) {
        this.getWrapper().render();
      } else {
        //console.log('no file wrapper')
      }
      var fileContainer = this.domNode.querySelector('.' + FILE_CONTAINER_CLASS);
      var fileKind = this.getFileKind();
      var viewMode = this.getFileViewMode(fileKind);
      var nodeToRender = (0,preact_module.h)(CompatibleInterface, {
        blot: this,
        fileKind: fileKind,
        viewMode: viewMode,
        fileContainer: fileContainer
      });
      (0,preact_module/* render */.sY)((0,preact_module.h)(plugins_i18n/* IntlProvider */.Pj, null, nodeToRender), fileContainer);
      if (this.fileNameTruncater && !this.fileNameTruncater.initTruncateComplete) {
        setTimeout(function () {
          var _this3$fileNameTrunca;
          return (_this3$fileNameTrunca = _this3.fileNameTruncater) === null || _this3$fileNameTrunca === void 0 ? void 0 : _this3$fileNameTrunca.init();
        }, 0);
      }
      if (this.hasMusicAttachment) {
        if (this.props.audioPlayer) {
          var wfAudioWave = this.domNode.querySelector('#wf-audio-' + this.props.audioPlayer.uid);
          if (!wfAudioWave || !wfAudioWave.innerHTML) {
            this.props.audioPlayer.destroy();
          }
        } else {
          var wfAudioContainer = this.domNode.querySelector('#wf-audio-container-' + this.id);
          if (wfAudioContainer && !wfAudioContainer.classList.contains('hidden')) {
            wfAudioContainer.classList.add('hidden');
            var aInfo = this.domNode.querySelector('.audioInfo');
            aInfo.removeAttribute('style');
          }
        }
      }
    }
  }, {
    key: "afterMove",
    value: function afterMove(containerBlot, params) {
      var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (this.props.audioPlayer) {
        var emptyWave = false;
        var wfAudioWave = this.scroll.domNode.querySelector('#wf-audio-' + this.props.audioPlayer.uid);
        if (!wfAudioWave || !wfAudioWave.innerHTML) {
          emptyWave = true;
        }
        if (Object.keys(context).length === 0 || containerBlot instanceof blots_gridCol && emptyWave) {
          this.props.audioPlayer.destroy();
        }
      }
    }
  }, {
    key: "initAudioPlayer",
    value: function initAudioPlayer() {
      var fileInterface = this.props.fileInterface;
      var theme = this.editor.plugins.editorStyle.getTheme();
      if (theme === 'undefined' || typeof theme === 'undefined') {
        theme = 'light';
      }
      var options = {
        blot: this,
        domNode: this.domNode,
        global_id: this.props.attachment.global_id,
        theme: theme,
        url: this.props.attachment.url,
        fileInterface: fileInterface
      };
      this.props.audioPlayer = new AudioPlayer();
      this.props.audioPlayer.initPlayer(options);
    }
  }, {
    key: "getVolume",
    value: function getVolume() {
      return this.map.get('volume') || 50;
    }
  }, {
    key: "updateVolume",
    value: function updateVolume(volume) {
      this.map.set('volume', volume);
      volume = volume / 100;
      if (this.props.audioPlayer) {
        this.props.audioPlayer.updateVolume(volume);
        if (volume === 0) {
          this.props.isMuted = false;
          this.toogleMute();
        } else {
          this.props.isMuted = true;
          this.toogleMute();
        }
      }
    }
  }, {
    key: "isImageFile",
    value: function isImageFile() {
      var attachment = this.props.attachment;
      if (attachment && attachment.mime) {
        if (attachment.mime.indexOf('image/') === 0) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "isVideoFile",
    value: function isVideoFile() {
      var attachment = this.props.attachment;
      if (attachment && attachment.mime) {
        if (attachment.mime.indexOf('video/') === 0) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "inTableCell",
    value: function inTableCell() {
      var attachment = this.props.attachment;
      if (attachment && attachment.mime) {
        if (attachment.mime.indexOf('image/') === 0) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "inUploader",
    value: function inUploader() {
      return Boolean(searchUp(this, function (blot) {
        return blot.constructor.blotName === 'uploaderContent';
      }));
    }
  }, {
    key: "isDefaultSoundAvailable",
    value: function isDefaultSoundAvailable() {
      return typeof this.props.attachment.autoplay === 'undefined' || !this.props.attachment.autoplay;
    }
  }, {
    key: "commentImageBlot",
    value: function commentImageBlot() {
      var processed = false;
      if (!processed) {
        if (this.editor.plugins.imageManager.enterFullSize(this.props.attachment.global_id, {
          commentMode: true
        }) !== false) {
          processed = true;
        }
      }
      if (!processed) {
        this.editor.plugins.lightBox.open(this.props.attachment.url);
      }
    }
  }, {
    key: "contextMenu",
    get: function get() {
      var menu = file_get(file_getPrototypeOf(FileBlot.prototype), "contextMenu", this);
      if (this.mediaRecord || this.audioRecord) {
        var recordMenu = {};
        recordMenu.add = menu.add;
        recordMenu.add.submenu.left = false;
        recordMenu.add.submenu.right = false;
        recordMenu.delete = menu.delete;
        return recordMenu;
      }
      var i18n = this.editor.plugins.i18n;
      var syncedState = this.getSyncedState();
      var fileViewer = this.getFileViewer();
      var fileInterface = this.props.fileInterface;
      if (!this.showLeftMenuItemCopyLink) {
        delete menu['copyLink'];
      }
      menu['addCaption'].index = -4;
      if (this.isImageFile()) {
        menu["turn-into"] = {
          label: i18n.get('block_menu.convert_to.name'),
          index: -3,
          group: 0,
          action: false,
          submenu: {
            turnToImage: {
              label: i18n.get('block_menu.convert_to.image'),
              index: 0,
              group: 0,
              action: 'convert-blot',
              actionParams: {
                type: 'image',
                attachmentGlobalId: this.map.get('attachmentGlobalId'),
                caption: this.map.get('caption')
              },
              actionExec: true,
              icon: icons/* IconImage */.Zay
            }
          }
        };
      }
      if (fileInterface && fileInterface.contextMenu) {
        Object.assign(menu, fileInterface.contextMenu);
      }
      if (fileViewer && this.isVideoFile() && this.editor.plugins.videoPreview.isEditAvailable()) {
        var plugins = this.editor.plugins;
        var previewVideoEe = new (events_default())();
        var onPreviewVideoMouseEnter = function onPreviewVideoMouseEnter() {
          previewVideoEe.emit('enter', {});
        };
        var onPreviewVideoMouseLeave = function onPreviewVideoMouseLeave() {
          previewVideoEe.emit('leave', {});
        };
        var previewVideoAvailabilityIcon = plugins.featuresAvailabilityPlugin.getFeatureIcon('preview-video', previewVideoEe);
        menu["video-preview"] = {
          label: (0,preact_module.h)("div", {
            onMouseEnter: onPreviewVideoMouseEnter,
            onMouseLeave: onPreviewVideoMouseLeave
          }, i18n.get('file.menu.preview_video'), previewVideoAvailabilityIcon),
          index: 2,
          group: 0,
          action: 'onFileClickMenuPreviewVideo'
        };
      }
      if (fileViewer && this.isVideoFile() && fileViewer.options && fileViewer.options.motion) {
        // AutoPlay Video
        var autoplay = "file.menu.autoplay";
        var isDoneAP = icons/* IconEmpty */.Zlx;
        if (this.props.attachment.autoplay || syncedState.autoplay) {
          if (!this.props.attachment.autoplay) {
            this.props.attachment.autoplay = true;
          }
          isDoneAP = icons/* IconDone */.EZi;
        }
        // SoundDefault Video
        var sound_default = "file.menu.sound_default";
        var isDoneSD = icons/* IconDone */.EZi;
        if (this.props.attachment.soundDefault || syncedState.mute || !this.isDefaultSoundAvailable()) {
          if (!this.props.attachment.soundDefault) {
            this.props.attachment.soundDefault = true;
          }
          isDoneSD = icons/* IconEmpty */.Zlx;
        }
        // Loop Video
        var sound_loop = "file.menu.sound_loop";
        var isDoneL = icons/* IconEmpty */.Zlx;
        if (this.props.attachment.loop || syncedState.loop) {
          if (!this.props.attachment.loop) {
            this.props.attachment.loop = true;
          }
          isDoneL = icons/* IconDone */.EZi;
        }
        // hideControl Video
        var hideControl = "file.menu.sound_hideControls";
        var isDoneHC = icons/* IconEmpty */.Zlx;
        if (this.props.attachment.hideControl || syncedState.hideControls || syncedState.hideControl) {
          if (!this.props.attachment.hideControl) {
            this.props.attachment.hideControl = true;
          }
          isDoneHC = icons/* IconDone */.EZi;
        }
        // showPanel Video
        var showPanel = "file.menu.sound_showPanel";
        var isDoneHP = icons/* IconEmpty */.Zlx;
        if ((this.props.attachment.showPanel || syncedState.showPanel) && !syncedState.hideControls) {
          if (!this.props.attachment.hasOwnProperty('showPanel')) {
            this.props.attachment.showPanel = true;
          }
          isDoneHP = icons/* IconDone */.EZi;
        }
        // Shadow for video
        var shadow = "file.menu.shadow_video";
        var isDoneSH = icons/* IconEmpty */.Zlx;
        if (this.props.attachment.videoShadow || syncedState.videoShadow) {
          if (!this.props.attachment.videoShadow) {
            this.props.attachment.videoShadow = true;
          }
          isDoneSH = icons/* IconDone */.EZi;
        }
        // Motion Video
        var motiontext = "file.menu.motion_video";
        var isDoneM = icons/* IconEmpty */.Zlx;
        if (this.props.attachment.motionVideo || syncedState.motionVideo) {
          if (!this.props.attachment.motionVideo) {
            this.props.attachment.motionVideo = true;
          }
          isDoneM = icons/* IconDone */.EZi;
        }
        var ap_func = 'onFileClickMenuAutoplay';
        var sd_func = 'onFileClickMenuSoundDefault';
        var sl_func = 'onFileClickMenuSoundLoop';
        var hc_func = 'onFileClickMenuSoundHideControl';
        var sh_func = 'onFileClickMenuSoundVideoShadow';
        var sp_func = 'onFileClickMenuPlayerShowTopPanel';
        menu["video-params"] = {
          label: i18n.get('file.menu.video_params'),
          index: 2,
          group: 0,
          action: false,
          submenu: {
            motion: {
              icon: isDoneM,
              label: i18n.get(motiontext),
              index: 1,
              group: 0,
              action: 'onFileClickMenuMotionVideo'
            },
            autoplay: {
              icon: isDoneAP,
              label: i18n.get(autoplay),
              index: 2,
              group: 1,
              action: ap_func
            },
            sound_default: {
              icon: isDoneSD,
              label: i18n.get(sound_default),
              index: 3,
              group: 1,
              action: sd_func,
              active: this.isDefaultSoundAvailable()
            },
            sound_loop: {
              icon: isDoneL,
              label: i18n.get(sound_loop),
              index: 6,
              group: 1,
              action: sl_func
            },
            videoShadow: {
              icon: isDoneSH,
              label: i18n.get(shadow),
              index: 7,
              group: 1,
              action: sh_func
            }
          }
        };
        var viewMode = this.map.get('view_mode');
        if (this.props.videoPlayer && viewMode !== 'compact') {
          menu["video-params"].submenu.hideControl = {
            icon: isDoneHC,
            label: i18n.get(hideControl),
            index: 4,
            group: 1,
            action: hc_func
          };
          menu["video-params"].submenu.showPanel = {
            icon: isDoneHP,
            label: i18n.get(showPanel),
            index: 5,
            group: 1,
            action: sp_func
          };
        }
      }
      if (this.blotConfig.downloading && this.editor.options.keyboardMode !== 'mobile') {
        var disallowDownloading = "file.menu.disallow_download";
        if (this.disallowDownloading) {
          menu['duplicate'] = undefined;
        }
        var iconNote = icons/* IconDone */.EZi;
        var iconShare = icons/* IconDone */.EZi;
        if (this.disallowNote) {
          iconNote = icons/* IconEmpty */.Zlx;
        }
        if (this.disallowShare) {
          iconShare = icons/* IconEmpty */.Zlx;
        }
        menu["disallowDownloading"] = {
          label: i18n.get(disallowDownloading),
          index: 2,
          group: 0,
          action: false,
          submenu: {
            motion: {
              icon: iconNote,
              label: i18n.get("file.menu.for_note"),
              index: 1,
              group: 0,
              action: 'onFileClickMenuDisallowNote'
            },
            autoplay: {
              icon: iconShare,
              label: i18n.get("file.menu.for_share"),
              index: 2,
              group: 0,
              action: 'onFileClickMenuDisallowShare'
            }
          }
        };
      } else {
        menu['duplicate'] = undefined;
      }
      if (this.isAudioUplading) {
        menu['duplicate'] = undefined;
      }
      if (this.isImageFile() && menu.comment) {
        menu['comment'].action = 'commentImageBlot';
      }
      return menu;
    }
  }, {
    key: "getRightClickMenu",
    value: function getRightClickMenu(menu) {
      var _this4 = this;
      if (!this.hasAttachment()) return false;
      var fileKind = this.getFileKind();
      var fileViewer = this.getFileViewer();
      var withViewerItems = [];
      if (fileViewer) {
        var viewMode = this.getFileViewMode(fileKind);
        withViewerItems.push({
          id: 'file-compact-view',
          icon: 'fa-compress',
          title: 'Compact view',
          selected: viewMode === 'compact',
          restoreSelection: false,
          func: function func() {
            _this4.onFileSetCompactView();
          }
        }, {
          id: 'file-full-view',
          icon: 'fa-eye',
          title: 'Full view',
          selected: viewMode === 'full',
          restoreSelection: false,
          func: function func() {
            _this4.onFileSetFullView();
          }
        });
        if (fileViewer.class.supportsFullscreen) {
          withViewerItems.push({
            id: 'file-full-screen',
            icon: 'fa-arrows-alt',
            title: 'Expand in Full Window',
            restoreSelection: false,
            func: function func() {
              _this4.onGoFullScreen();
            }
          });
        }
        if (fileViewer.class.printable) {
          withViewerItems.push({
            id: 'file-print',
            icon: 'fa-print',
            title: 'Print',
            restoreSelection: false,
            func: function func() {
              _this4.onFilePrint();
            }
          });
        }
      }
      var termItems = [];
      if (this.showMenuItemOpenInNewTab) {
        termItems.push({
          id: 'file-open-new-tab',
          icon: 'fa-external-link',
          title: 'open in new tab',
          restoreSelection: false,
          func: function func() {
            _this4.onFileOpenInNewTab();
          }
        });
      }
      if (this.showRightMenuItemCopyLink) {
        termItems.push({
          id: 'copy-file-link',
          icon: 'fa-clone',
          title: 'copy link',
          restoreSelection: false,
          func: function func() {
            _this4.onFileLinkCopy();
          }
        });
      }
      return [{
        id: 'download-file',
        icon: 'fa-download',
        title: 'download',
        restoreSelection: false,
        func: function func() {
          _this4.onFileDownload();
        }
      }].concat(termItems, withViewerItems, [{
        id: 'file-replace',
        icon: 'fa-pencil',
        title: 'replace',
        restoreSelection: false,
        func: function func() {
          _this4.onFileReplace();
        }
      }, {
        id: 'file-rename',
        icon: 'fa-pencil-square-o',
        title: 'rename',
        restoreSelection: false,
        func: function func() {
          _this4.onFileRename();
        }
      }, {
        id: 'file-delete',
        icon: 'fa-trash-o',
        title: 'delete',
        restoreSelection: false,
        func: function func() {
          _this4.onFileDelete();
        }
      }]);
    }
  }, {
    key: "exec",
    value: function exec(action) {
      var processed = file_get(file_getPrototypeOf(FileBlot.prototype), "exec", this).call(this, action);
      var fileInterface = this.props.fileInterface;
      if (action.type === 'backspace') {
        this.remove();
        action.dontRestoreSelection();
        processed = true;
      }
      if (!processed && fileInterface && fileInterface.exec) {
        processed = fileInterface.exec(action);
      }
      return processed;
    }
  }, {
    key: "getBlotMenuHeaderComponent",
    value: function getBlotMenuHeaderComponent() {
      return function () {
        return null;
      };
    }
  }, {
    key: "getBlotForMenu",
    value: function getBlotForMenu() {
      if (this.inUploader()) {
        var uploaderWrapper = searchUp(this, function (b) {
          return b.constructor.blotName === 'uploaderWrapper';
        });
        if (uploaderWrapper) {
          return uploaderWrapper.basicBlot;
        }
      }
      return this;
    }
  }, {
    key: "canDragWith",
    value: function canDragWith(node) {
      if (this.inUploader()) {
        var uploaderWrapper = searchUp(this, function (blot) {
          return blot.constructor.blotName === 'uploaderWrapper';
        });
        if (uploaderWrapper) {
          var _uploaderWrapper$basi2;
          var isUploaderEdiatable = uploaderWrapper === null || uploaderWrapper === void 0 ? void 0 : (_uploaderWrapper$basi2 = uploaderWrapper.basicBlot) === null || _uploaderWrapper$basi2 === void 0 ? void 0 : _uploaderWrapper$basi2.isEditable();
          if (!isUploaderEdiatable) {
            return false;
          }
        }
        return this.domNode.contains(node);
      }
      return false;
    }
  }, {
    key: "onlySingleDragging",
    value: function onlySingleDragging() {
      return this.inUploader();
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      if (context.options.noAttachments) {
        return '';
      }
      var node;
      if (this.props.attachment && !context.options.pdf) {
        context.addAttachment(this.props.attachment);
        node = this.domNode.cloneNode(true);
        var filePath = context.getAttachmentPath(this.props.attachment);
        var link = document.createElement('a');
        link.setAttribute('href', filePath);
        link.setAttribute('target', '_blank');
        var fileName = node.querySelector('.file-name');
        Array.from(fileName.childNodes).map(function (child) {
          link.appendChild(child);
        });
        fileName.appendChild(link);
      } else {
        node = this.domNode;
      }
      if (context.options.toEmail) {
        var vcontent = node.querySelector('.compact-view-content');
        vcontent.style.display = 'flex';
        vcontent.style.border = '1px solid #c8c8c8';
        vcontent.style.padding = '5px';
        vcontent.style.borderRadius = '4px';
      }
      return node.outerHTML;
    }
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      var _this$getWrapper$capt;
      var params = file_get(file_getPrototypeOf(FileBlot.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
      var interfaceState = {};
      var fileInterface = this.props.fileInterface;
      if (fileInterface && fileInterface.interfaceState) {
        interfaceState = fileInterface.interfaceState;
      }
      return (0,util/* mergeDeep */.Ee)(params, {
        initParams: file_objectSpread({
          src: this.map.get('src'),
          attachmentGlobalId: this.map.get('attachmentGlobalId'),
          viewMode: this.map.get('view_mode'),
          captionParams: (_this$getWrapper$capt = this.getWrapper().caption) === null || _this$getWrapper$capt === void 0 ? void 0 : _this$getWrapper$capt.getBlotInsertParams(),
          room: this.editor.options.serverRoom
        }, interfaceState)
      });
    }
  }], [{
    key: "createBlot",
    value: function createBlot(editor) {
      var blot = parchment_default().create('fileWrapper');
      this.addCaretTrap(editor, blot.domNode);
      return blot;
    }
  }, {
    key: "create",
    value: function create(value) {
      var node = file_get(file_getPrototypeOf(FileBlot), "create", this).call(this);
      node.classList.add('file');
      var fileContainer = document.createElement('div');
      fileContainer.setAttribute('contenteditable', false);
      fileContainer.classList.add(FILE_CONTAINER_CLASS);
      node.appendChild(fileContainer);
      return node;
    }
  }]);
  return FileBlot;
}(file_mixin(AttachmentsBase));
file_defineProperty(FileBlot, "initMap", function (map, store) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  map.set('type', 'file');
  map.set('syncedViewerState', new store.types.Map());
  map.set('syncedInterfaceState', new store.types.Map());
  if (params.attachmentGlobalId) {
    map.set('attachmentGlobalId', params.attachmentGlobalId);
  }
  if (params.viewMode) {
    map.set('view_mode', params.viewMode);
  }
  if (params.src) {
    map.set('src', params.src);
  }
  var captionId = params.caption;
  if (!captionId) {
    var captionMap = store.createMap();
    Caption.initMap(captionMap, store, params.captionParams || {});
    captionId = captionMap.get('id');
  }
  map.set('caption', captionId);
  if (params.audioRecord) {
    map.set('audioRecord', true);
    map.set('recordUserId', store.userId);
  } else if (params.mediaRecord) {
    map.set('mediaRecord', true);
    map.set('recordUserId', store.userId);
  }
  if (params.mode) {
    map.set('mode', params.mode);
  }
  if (params.syncedInterfaceState) {
    var stateMap = map.get('syncedInterfaceState');
    for (var key in params.syncedInterfaceState) {
      stateMap.set(key, params.syncedInterfaceState[key]);
    }
  }
  if (params.disallowNoteDownloading) {
    map.set('disallowNoteDownloading', params.disallowNoteDownloading);
  }
  if (params.disallowShareDownloading) {
    map.set('disallowShareDownloading', params.disallowShareDownloading);
  }
  if (params.imagePreviewWidth) {
    // width of image for table cell
    map.set('imagePreviewWidth', params.imagePreviewWidth);
  }
  file_get(file_getPrototypeOf(FileBlot), "initMap", FileBlot) && file_get(file_getPrototypeOf(FileBlot), "initMap", FileBlot).call(FileBlot, map, store, params);
});
FileBlot.blotName = 'file';
FileBlot.tagName = 'DIV';
FileBlot.parent = AttachmentsBase;
FileBlot.wrapper = 'fileWrapper';
/* harmony default export */ const file = (FileBlot);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/attachment/fileWrapper.js
function fileWrapper_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { fileWrapper_typeof = function _typeof(obj) { return typeof obj; }; } else { fileWrapper_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return fileWrapper_typeof(obj); }












function fileWrapper_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function fileWrapper_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function fileWrapper_createClass(Constructor, protoProps, staticProps) { if (protoProps) fileWrapper_defineProperties(Constructor.prototype, protoProps); if (staticProps) fileWrapper_defineProperties(Constructor, staticProps); return Constructor; }
function fileWrapper_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { fileWrapper_get = Reflect.get; } else { fileWrapper_get = function _get(target, property, receiver) { var base = fileWrapper_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return fileWrapper_get(target, property, receiver || target); }
function fileWrapper_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = fileWrapper_getPrototypeOf(object); if (object === null) break; } return object; }
function fileWrapper_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) fileWrapper_setPrototypeOf(subClass, superClass); }
function fileWrapper_setPrototypeOf(o, p) { fileWrapper_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return fileWrapper_setPrototypeOf(o, p); }
function fileWrapper_createSuper(Derived) { var hasNativeReflectConstruct = fileWrapper_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = fileWrapper_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = fileWrapper_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return fileWrapper_possibleConstructorReturn(this, result); }; }
function fileWrapper_possibleConstructorReturn(self, call) { if (call && (fileWrapper_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return fileWrapper_assertThisInitialized(self); }
function fileWrapper_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function fileWrapper_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function fileWrapper_getPrototypeOf(o) { fileWrapper_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return fileWrapper_getPrototypeOf(o); }





var FileWrapper = /*#__PURE__*/function (_SizeAwareMixin) {
  fileWrapper_inherits(FileWrapper, _SizeAwareMixin);
  var _super = fileWrapper_createSuper(FileWrapper);
  function FileWrapper(domNode) {
    var _this;
    fileWrapper_classCallCheck(this, FileWrapper);
    _this = _super.call(this, domNode);
    _this.domNode.classList.add('file-wrapper');
    _this.caption = null;
    return _this;
  }
  fileWrapper_createClass(FileWrapper, [{
    key: "isDropAcceptor",
    get: function get() {
      if (this.embed.inUploader()) {
        return false;
      }
      return true;
    }
  }, {
    key: "onFirstAttach",
    value: function onFirstAttach() {
      if (this.embed) {
        this.embed.setProps(this.props);
        this.embed.onFirstAttach();
      }
    }
  }, {
    key: "getInnerTextLine",
    value: function getInnerTextLine() {
      return this.caption;
    }
  }, {
    key: "sizeAwareUpdateSize",
    value: function sizeAwareUpdateSize(maxAvailableWidth) {
      this.embed.setProps({
        maxAvailableWidth: maxAvailableWidth
      });
    }
  }, {
    key: "render",
    value: function render() {
      fileWrapper_get(fileWrapper_getPrototypeOf(FileWrapper.prototype), "render", this).call(this);
      var hasAttachmentIdAssigned = this.embed && this.embed.hasAttachment();
      if (this.embed && hasAttachmentIdAssigned && this.embed.props.attachment) {
        if (!this.caption) {
          this.caption = parchment_default().create('caption');
          this.caption.map = this.store.getMap(this.map.get('caption'));
          this.caption.embedBlot = this.embed;
          this.appendChild(this.caption);
        }
        this.caption.render();
      } else {
        if (this.caption) {
          this.caption.remove();
          this.caption = null;
        }
      }
      if (this.embed) {
        var noAttachment = true;
        if (hasAttachmentIdAssigned && this.embed.props.attachment) {
          noAttachment = false;
        }
        if (!noAttachment) {
          this.domNode.classList.remove('no-attachment');
        } else {
          this.domNode.classList.add('no-attachment');
        }
        if (!hasAttachmentIdAssigned) {
          this.domNode.classList.add('no-attachment-id');
        } else {
          this.domNode.classList.remove('no-attachment-id');
        }
      }
    }
  }]);
  return FileWrapper;
}(sizeaware(embedWrapperAbstract));

FileWrapper.allowedChildren = [file, Caption];
FileWrapper.blotName = 'fileWrapper';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/remoteFrame/loader.js
function loader_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function loader_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function loader_createClass(Constructor, protoProps, staticProps) { if (protoProps) loader_defineProperties(Constructor.prototype, protoProps); if (staticProps) loader_defineProperties(Constructor, staticProps); return Constructor; }
function loader_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var RemoteFrameLoader = /*#__PURE__*/function () {
  function RemoteFrameLoader() {
    var _this = this;
    loader_classCallCheck(this, RemoteFrameLoader);
    loader_defineProperty(this, "onAbortClick", function () {
      _this.props.clearFrame();
    });
  }
  loader_createClass(RemoteFrameLoader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        height = _this$props.height,
        editMode = _this$props.editMode,
        i18n = _this$props.i18n;
      var full = Boolean(height);
      var abortNode = null;
      if (editMode) {
        if (!full) {
          abortNode = (0,preact_module.h)("div", {
            className: "clear-frame-button",
            onClick: this.onAbortClick
          }, (0,preact_module.h)(icons/* IconClose */.bMz, null));
        }
        return (0,preact_module.h)("div", {
          className: 'remote-frame-loader ' + (full ? 'full-loader' : 'small-loader')
        }, i18n.get('remote_frame.loading'), abortNode);
      } else {
        return (0,preact_module.h)("div", {
          className: "remote-frame-loader share-embed-loader"
        });
      }
    }
  }]);
  return RemoteFrameLoader;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/remoteFrame/widgets/githubGist.js
function githubGist_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { githubGist_typeof = function _typeof(obj) { return typeof obj; }; } else { githubGist_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return githubGist_typeof(obj); }












function githubGist_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function githubGist_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { githubGist_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { githubGist_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function githubGist_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function githubGist_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function githubGist_createClass(Constructor, protoProps, staticProps) { if (protoProps) githubGist_defineProperties(Constructor.prototype, protoProps); if (staticProps) githubGist_defineProperties(Constructor, staticProps); return Constructor; }
function githubGist_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) githubGist_setPrototypeOf(subClass, superClass); }
function githubGist_setPrototypeOf(o, p) { githubGist_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return githubGist_setPrototypeOf(o, p); }
function githubGist_createSuper(Derived) { var hasNativeReflectConstruct = githubGist_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = githubGist_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = githubGist_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return githubGist_possibleConstructorReturn(this, result); }; }
function githubGist_possibleConstructorReturn(self, call) { if (call && (githubGist_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return githubGist_assertThisInitialized(self); }
function githubGist_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function githubGist_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function githubGist_getPrototypeOf(o) { githubGist_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return githubGist_getPrototypeOf(o); }
function githubGist_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var GithubGistComponent = /*#__PURE__*/function (_Component) {
  githubGist_inherits(GithubGistComponent, _Component);
  var _super = githubGist_createSuper(GithubGistComponent);
  function GithubGistComponent(props) {
    var _this;
    githubGist_classCallCheck(this, GithubGistComponent);
    _this = _super.call(this, props);
    githubGist_defineProperty(githubGist_assertThisInitialized(_this), "onGistLoaded", function (data) {
      if (data.stylesheet) {
        _this.addStylesheet(data.stylesheet);
      }
      _this.setState(function () {
        return {
          html: data.div
        };
      });
    });
    githubGist_defineProperty(githubGist_assertThisInitialized(_this), "onGistError", function (url) {
      console.error('Error HTTP: unknown error. Gist from ' + url + ' not loaded.');
      _this.props.blot.setProps({
        setEmbedError: {
          errorType: 'unknown',
          errorKey: 'remote_frame.error.unknown_error'
        }
      });
    });
    githubGist_defineProperty(githubGist_assertThisInitialized(_this), "fetchGist", /*#__PURE__*/githubGist_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var src, jsonUrl, callbackName;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              src = _this.props.src;
              jsonUrl = 'https://gist.github.com/' + _this.getGistId(src) + '.json';
              callbackName = 'nimbusJsopCallbackGist_' + Math.floor(Math.random() * Math.floor(999));
              scriptRequest(jsonUrl, callbackName, _this.onGistLoaded, _this.onGistError);
            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    _this.state = {
      html: false
    };
    return _this;
  }
  githubGist_createClass(GithubGistComponent, [{
    key: "getGistId",
    value: function getGistId(src) {
      return (url_url.parse(src).pathname || '').split('/').pop();
    }
  }, {
    key: "addStylesheet",
    value: function addStylesheet(link) {
      var isAppended = Boolean(document.querySelector('link[href="' + link + '"]'));
      if (!isAppended) {
        var linkNode = document.createElement('link');
        linkNode.setAttribute('type', 'text/css');
        linkNode.setAttribute('rel', 'stylesheet');
        linkNode.setAttribute('href', link);
        document.head && document.head.appendChild(linkNode);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var html = this.state.html;
      var nodeToRender = null;
      if (!html) {
        this.fetchGist();
        nodeToRender = (0,preact_module.h)(RemoteFrameLoader, {
          editMode: this.props.editMode,
          i18n: this.props.i18n,
          clearFrame: this.props.clearFrame
        });
      } else {
        nodeToRender = (0,preact_module.h)("div", {
          ref: this.props.onDomRef
        }, (0,preact_module.h)("div", {
          dangerouslySetInnerHTML: {
            __html: html
          }
        }));
      }
      return nodeToRender;
    }
  }]);
  return GithubGistComponent;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/remoteFrame/widgets/nimbusVideo.js
function nimbusVideo_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { nimbusVideo_typeof = function _typeof(obj) { return typeof obj; }; } else { nimbusVideo_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return nimbusVideo_typeof(obj); }









function nimbusVideo_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function nimbusVideo_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function nimbusVideo_createClass(Constructor, protoProps, staticProps) { if (protoProps) nimbusVideo_defineProperties(Constructor.prototype, protoProps); if (staticProps) nimbusVideo_defineProperties(Constructor, staticProps); return Constructor; }
function nimbusVideo_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) nimbusVideo_setPrototypeOf(subClass, superClass); }
function nimbusVideo_setPrototypeOf(o, p) { nimbusVideo_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return nimbusVideo_setPrototypeOf(o, p); }
function nimbusVideo_createSuper(Derived) { var hasNativeReflectConstruct = nimbusVideo_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = nimbusVideo_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = nimbusVideo_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return nimbusVideo_possibleConstructorReturn(this, result); }; }
function nimbusVideo_possibleConstructorReturn(self, call) { if (call && (nimbusVideo_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return nimbusVideo_assertThisInitialized(self); }
function nimbusVideo_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function nimbusVideo_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function nimbusVideo_getPrototypeOf(o) { nimbusVideo_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return nimbusVideo_getPrototypeOf(o); }
function nimbusVideo_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var NimbusVideoPlayerWidget = /*#__PURE__*/function (_Component) {
  nimbusVideo_inherits(NimbusVideoPlayerWidget, _Component);
  var _super = nimbusVideo_createSuper(NimbusVideoPlayerWidget);
  function NimbusVideoPlayerWidget(props) {
    var _this;
    nimbusVideo_classCallCheck(this, NimbusVideoPlayerWidget);
    _this = _super.call(this, props);
    nimbusVideo_defineProperty(nimbusVideo_assertThisInitialized(_this), "onGoFullScreen", function () {
      _this.setState(function () {
        return {
          fullscreen: true
        };
      });
    });
    nimbusVideo_defineProperty(nimbusVideo_assertThisInitialized(_this), "onFullScreenClose", function () {
      _this.setState(function () {
        return {
          fullscreen: false
        };
      });
    });
    _this.state = {
      fullscreen: false
    };
    return _this;
  }
  nimbusVideo_createClass(NimbusVideoPlayerWidget, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        blot = _this$props.blot,
        editor = _this$props.editor,
        attachment = _this$props.attachment;
      return (0,preact_module.h)("div", {
        className: "embed-video-viewer"
      }, (0,preact_module.h)(video["default"], {
        blot: blot,
        editor: editor,
        attachment: attachment,
        onViewerGoFullScreen: this.onGoFullScreen,
        onFullScreenClose: this.onFullScreenClose,
        fullscreen: this.state.fullscreen,
        disallowVideoPreview: true
      }));
    }
  }]);
  return NimbusVideoPlayerWidget;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/remoteFrame/remoteFrameComponent.js
function remoteFrameComponent_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { remoteFrameComponent_typeof = function _typeof(obj) { return typeof obj; }; } else { remoteFrameComponent_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return remoteFrameComponent_typeof(obj); }
function remoteFrameComponent_extends() { remoteFrameComponent_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return remoteFrameComponent_extends.apply(this, arguments); }












function remoteFrameComponent_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function remoteFrameComponent_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function remoteFrameComponent_createClass(Constructor, protoProps, staticProps) { if (protoProps) remoteFrameComponent_defineProperties(Constructor.prototype, protoProps); if (staticProps) remoteFrameComponent_defineProperties(Constructor, staticProps); return Constructor; }
function remoteFrameComponent_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) remoteFrameComponent_setPrototypeOf(subClass, superClass); }
function remoteFrameComponent_setPrototypeOf(o, p) { remoteFrameComponent_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return remoteFrameComponent_setPrototypeOf(o, p); }
function remoteFrameComponent_createSuper(Derived) { var hasNativeReflectConstruct = remoteFrameComponent_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = remoteFrameComponent_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = remoteFrameComponent_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return remoteFrameComponent_possibleConstructorReturn(this, result); }; }
function remoteFrameComponent_possibleConstructorReturn(self, call) { if (call && (remoteFrameComponent_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return remoteFrameComponent_assertThisInitialized(self); }
function remoteFrameComponent_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function remoteFrameComponent_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function remoteFrameComponent_getPrototypeOf(o) { remoteFrameComponent_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return remoteFrameComponent_getPrototypeOf(o); }
function remoteFrameComponent_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var DEFAULT_FRAME_HEIGHT = 50; //высота фрейма в процентах от ширины
var RemoteFrameComponent = /*#__PURE__*/function (_PureComponent) {
  remoteFrameComponent_inherits(RemoteFrameComponent, _PureComponent);
  var _super = remoteFrameComponent_createSuper(RemoteFrameComponent);
  function RemoteFrameComponent(props) {
    var _this;
    remoteFrameComponent_classCallCheck(this, RemoteFrameComponent);
    _this = _super.call(this, props);
    remoteFrameComponent_defineProperty(remoteFrameComponent_assertThisInitialized(_this), "onFrameLoad", function () {
      _this.setState(function () {
        return {
          loading: false
        };
      });
    });
    remoteFrameComponent_defineProperty(remoteFrameComponent_assertThisInitialized(_this), "onFrameError", function () {
      if (_this.props.skipErrorLoading) return;
      // если контент уже был загружен и функция onFrameLoad отработала вновь, выдаем ошибку внутренней ссылки
      if (!_this.state.loading) {
        _this.props.onInternalLinkError();
      } else {
        // если контент ниразу не был загружен, значит фрейм не смог загрузиться, выдаем ошибку контента
        _this.props.onFrameLoadError();
      }
    });
    remoteFrameComponent_defineProperty(remoteFrameComponent_assertThisInitialized(_this), "onRef", function (node) {
      _this.domNode = node;
      _this.props.onDomRef(node);
    });
    _this.state = {
      loading: true
    };
    return _this;
  }
  remoteFrameComponent_createClass(RemoteFrameComponent, [{
    key: "getSrcFromHTML",
    value: function getSrcFromHTML(html) {
      if (!html) return false;
      var isFrame = IFramePattern.test(html);
      if (isFrame) {
        var src = deserializeEmbedString(html.match(IFramePattern)[0]);
        if (typeof src === 'string') {
          return src;
        }
      }
      return false;
    }
  }, {
    key: "renderWidget",
    value: function renderWidget() {
      var frameOptions = this.props.frameOptions;
      var WidgetComponent = frameOptions.component;
      return (0,preact_module.h)(WidgetComponent, this.props);
    }
  }, {
    key: "renderPdf",
    value: function renderPdf() {
      this.setState(function (prevState) {
        if (prevState.loading) {
          return {
            loading: false
          };
        } else {
          return null;
        }
      });
      var _this$props = this.props,
        src = _this$props.src,
        addClassName = _this$props.addClassName;
      return (0,preact_module.h)("div", {
        className: addClassName
      }, (0,preact_module.h)("object", {
        data: decodeURI(src),
        width: "100%",
        height: "100%",
        type: "application/pdf",
        ref: this.onRef
      }));
    }
  }, {
    key: "renderHTML",
    value: function renderHTML() {
      this.setState(function (prevState) {
        if (prevState.loading) {
          return {
            loading: false
          };
        } else {
          return null;
        }
      });
      var _this$props2 = this.props,
        html = _this$props2.html,
        addClassName = _this$props2.addClassName;
      return (0,preact_module.h)("div", {
        className: addClassName,
        ref: this.onRef,
        dangerouslySetInnerHTML: {
          __html: html
        }
      });
    }
  }, {
    key: "renderNimbusVideoPlayer",
    value: function renderNimbusVideoPlayer(html) {
      var videoSrcMatch = html.match(videoSrcPattern);
      if (videoSrcMatch && videoSrcMatch[1]) {
        var url = videoSrcMatch[1];
        var mimeMatch = html.match(/type=["|'](.*?)["|']/);
        var mime = mimeMatch && mimeMatch[1] || undefined;
        this.setState(function (prevState) {
          if (prevState.loading) {
            return {
              loading: false
            };
          } else {
            return null;
          }
        });
        return (0,preact_module.h)(NimbusVideoPlayerWidget, {
          blot: this.props.blot,
          editor: this.props.editor,
          attachment: {
            mime: mime,
            url: url,
            display_name: url
          }
        });
      } else {
        return this.renderHTML();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return this.state.loading;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        src = _this$props3.src,
        type = _this$props3.type,
        html = _this$props3.html,
        addClassName = _this$props3.addClassName,
        frameOptions = _this$props3.frameOptions,
        isDirectUrl = _this$props3.isDirectUrl;
      if (frameOptions.component) {
        // если это виджет сразу возвращаем компонент виджета
        return this.renderWidget();
      } else if (type === 'pdf') {
        // если PDF сразу возвращаем объект PDF
        return this.renderPdf();
      } else if (isNimbusVideoEmbed(src, html)) {
        return this.renderNimbusVideoPlayer(html);
      }
      // получаем ссылку фрейма
      var frameSrc = null;
      var renderFromHtml = frameOptions.allowDirectUrl && isDirectUrl || type === 'unknown';
      if (renderFromHtml) {
        frameSrc = this.getSrcFromHTML(html);
        if (!frameSrc) {
          // если не был получен src из html, значит там не фрейм, возвращаем компонент HTML
          return this.renderHTML();
        }
      } else if (frameOptions.getFrameSrc) {
        frameSrc = frameOptions.getFrameSrc(src);
      } else {
        frameSrc = decodeURI(src);
      }
      frameSrc = decodeHtmlEntities(frameSrc);
      // получаем высоту
      var loading = this.state.loading;

      // определяем стили фрейма
      var frameStyles = {
        border: '0',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        position: 'absolute'
      };
      // определяем дополнительные атрибуты фрейма
      var frameAttrs = {};
      if (frameOptions.attributes && !renderFromHtml) {
        frameAttrs = frameOptions.attributes;
      } else if (type === 'other' || type === 'unknown') {
        frameAttrs = {
          sandbox: 'allow-scripts allow-same-origin allow-popups allow-forms'
        };
      }
      return (0,preact_module.h)("div", {
        className: addClassName
      }, loading ? (0,preact_module.h)(RemoteFrameLoader, {
        height: true,
        editMode: this.props.editMode,
        i18n: this.props.i18n,
        clearFrame: this.props.clearFrame
      }) : null, (0,preact_module.h)("iframe", remoteFrameComponent_extends({
        ref: this.onRef,
        src: frameSrc,
        allowfullscreen: "allowfullscreen",
        style: frameStyles,
        onLoad: this.onFrameLoad,
        onError: this.onFrameError
      }, frameAttrs)));
    }
  }]);
  return RemoteFrameComponent;
}(compat_module.PureComponent);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/remoteFrame/widgets/typeform.js
function typeform_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { typeform_typeof = function _typeof(obj) { return typeof obj; }; } else { typeform_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return typeform_typeof(obj); }









function typeform_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function typeform_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function typeform_createClass(Constructor, protoProps, staticProps) { if (protoProps) typeform_defineProperties(Constructor.prototype, protoProps); if (staticProps) typeform_defineProperties(Constructor, staticProps); return Constructor; }
function typeform_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) typeform_setPrototypeOf(subClass, superClass); }
function typeform_setPrototypeOf(o, p) { typeform_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return typeform_setPrototypeOf(o, p); }
function typeform_createSuper(Derived) { var hasNativeReflectConstruct = typeform_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = typeform_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = typeform_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return typeform_possibleConstructorReturn(this, result); }; }
function typeform_possibleConstructorReturn(self, call) { if (call && (typeform_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return typeform_assertThisInitialized(self); }
function typeform_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function typeform_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function typeform_getPrototypeOf(o) { typeform_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return typeform_getPrototypeOf(o); }
function typeform_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var TypeformComponent = /*#__PURE__*/function (_Component) {
  typeform_inherits(TypeformComponent, _Component);
  var _super = typeform_createSuper(TypeformComponent);
  function TypeformComponent(props) {
    var _this;
    typeform_classCallCheck(this, TypeformComponent);
    _this = _super.call(this, props);
    typeform_defineProperty(typeform_assertThisInitialized(_this), "onRef", function (node) {
      _this.domNode = node;
      _this.props.onDomRef(node);
    });
    typeform_defineProperty(typeform_assertThisInitialized(_this), "onFrameNodeRef", function (node) {
      _this.frameNode = node;
    });
    _this.state = {
      scriptReady: false
    };
    return _this;
  }
  typeform_createClass(TypeformComponent, [{
    key: "includeWidgetScript",
    value: function includeWidgetScript() {
      var _this2 = this;
      // тут нужно дождаться загрузки скрипта, но эта функция может вызваться несколько раз, 
      // из-за обновления блота, и до загрузки скрипта state.scriptReady выставляется в true,
      // потому добавил проверку и если не загружен то дополнительно вешаем эвент
      var src = 'https://embed.typeform.com/embed.js';
      var script = document.querySelector('script[src="' + src + '"]');
      var isAppended = Boolean(script);
      if (!isAppended) {
        script = document.createElement('script');
        script.onload = function () {
          _this2.setState(function () {
            return {
              scriptReady: true
            };
          });
        };
        script.src = src;
        document.head && document.head.appendChild(script);
      } else {
        if (!window.typeformEmbed) {
          script.addEventListener('load', function () {
            _this2.setState(function () {
              return {
                scriptReady: true
              };
            });
          });
        } else {
          this.setState(function () {
            return {
              scriptReady: true
            };
          });
        }
      }
    }
  }, {
    key: "renderWidget",
    value: function renderWidget() {
      typeformEmbed.makeWidget(this.frameNode, this.props.src);
      this.state.widgetReady = true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.includeWidgetScript();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.state.scriptReady && this.frameNode && !this.state.widgetReady) {
        this.renderWidget();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.state.widgetReady) return false;
    }
  }, {
    key: "render",
    value: function render() {
      var scriptReady = this.state.scriptReady;
      if (!scriptReady) {
        return (0,preact_module.h)(RemoteFrameLoader, {
          editMode: this.props.editMode,
          i18n: this.props.i18n,
          clearFrame: this.props.clearFrame
        });
      } else {
        return (0,preact_module.h)("div", {
          ref: this.onRef,
          className: "typeform-embed-frame"
        }, (0,preact_module.h)("div", {
          ref: this.onFrameNodeRef
        }));
      }
    }
  }]);
  return TypeformComponent;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/remoteFrame/widgets/twitter.js
function twitter_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { twitter_typeof = function _typeof(obj) { return typeof obj; }; } else { twitter_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return twitter_typeof(obj); }











function twitter_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function twitter_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function twitter_createClass(Constructor, protoProps, staticProps) { if (protoProps) twitter_defineProperties(Constructor.prototype, protoProps); if (staticProps) twitter_defineProperties(Constructor, staticProps); return Constructor; }
function twitter_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) twitter_setPrototypeOf(subClass, superClass); }
function twitter_setPrototypeOf(o, p) { twitter_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return twitter_setPrototypeOf(o, p); }
function twitter_createSuper(Derived) { var hasNativeReflectConstruct = twitter_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = twitter_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = twitter_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return twitter_possibleConstructorReturn(this, result); }; }
function twitter_possibleConstructorReturn(self, call) { if (call && (twitter_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return twitter_assertThisInitialized(self); }
function twitter_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function twitter_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function twitter_getPrototypeOf(o) { twitter_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return twitter_getPrototypeOf(o); }
function twitter_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var TweetComponent = /*#__PURE__*/function (_Component) {
  twitter_inherits(TweetComponent, _Component);
  var _super = twitter_createSuper(TweetComponent);
  function TweetComponent(props) {
    var _this;
    twitter_classCallCheck(this, TweetComponent);
    _this = _super.call(this, props);
    twitter_defineProperty(twitter_assertThisInitialized(_this), "onRef", function (node) {
      _this.domNode = node;
      _this.props.onDomRef(node);
    });
    twitter_defineProperty(twitter_assertThisInitialized(_this), "getTweetId", function () {
      return (url_url.parse(_this.props.src).pathname || '').split('/').pop();
    });
    twitter_defineProperty(twitter_assertThisInitialized(_this), "renderWidget", function (twttr) {
      twttr.widgets.createTweet(_this.getTweetId(), _this.domNode, {
        theme: _this.props.theme
      });
    });
    return _this;
  }
  twitter_createClass(TweetComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (!window.twttr) {
        // вынес и оптимизировал функцию добавления скрипта,
        // так как раньше каждый новый виджет во время загрузки заметки пересоздавал переменную window.twttr
        // сейчас инициация скрипта вынесена в одно место и есть проверки на существование переменной
        // если скрипт уже инициирован или иницииация еще идет, повторная иницииация не запускается
        includeTwttrScript(this.renderWidget);
      } else {
        window.twttr.ready(function (twttr) {
          _this2.renderWidget(twttr);
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return (0,preact_module.h)("div", {
        className: "twitter-widget-container",
        ref: this.onRef
      });
    }
  }], [{
    key: "onRenderContent",
    value: function onRenderContent(blot, _ref) {
      var height = _ref.height;
      if (blot && height && blot.resizeContainer) {
        blot.resizeContainer.setAttribute('data-content-height', height);
        blot.render();
      }
    }
  }]);
  return TweetComponent;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/remoteFrame/widgets/facebook.js
function facebook_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { facebook_typeof = function _typeof(obj) { return typeof obj; }; } else { facebook_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return facebook_typeof(obj); }









function facebook_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function facebook_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function facebook_createClass(Constructor, protoProps, staticProps) { if (protoProps) facebook_defineProperties(Constructor.prototype, protoProps); if (staticProps) facebook_defineProperties(Constructor, staticProps); return Constructor; }
function facebook_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) facebook_setPrototypeOf(subClass, superClass); }
function facebook_setPrototypeOf(o, p) { facebook_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return facebook_setPrototypeOf(o, p); }
function facebook_createSuper(Derived) { var hasNativeReflectConstruct = facebook_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = facebook_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = facebook_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return facebook_possibleConstructorReturn(this, result); }; }
function facebook_possibleConstructorReturn(self, call) { if (call && (facebook_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return facebook_assertThisInitialized(self); }
function facebook_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function facebook_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function facebook_getPrototypeOf(o) { facebook_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return facebook_getPrototypeOf(o); }
function facebook_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FacebookComponent = /*#__PURE__*/function (_Component) {
  facebook_inherits(FacebookComponent, _Component);
  var _super = facebook_createSuper(FacebookComponent);
  function FacebookComponent(props) {
    var _this;
    facebook_classCallCheck(this, FacebookComponent);
    _this = _super.call(this, props);
    facebook_defineProperty(facebook_assertThisInitialized(_this), "onRef", function (node) {
      _this.domNode = node;
      _this.props.onDomRef(node);
    });
    facebook_defineProperty(facebook_assertThisInitialized(_this), "disableRecycling", function () {
      _this.nextBase = null;
    });
    _this.includeWidgetScript();
    return _this;
  }
  facebook_createClass(FacebookComponent, [{
    key: "includeWidgetScript",
    value: function includeWidgetScript() {
      //функция добавления скрипта
      if (window.fbAsyncInit) return;
      window.fbAsyncInit = function () {
        FB.init({
          appId: 'Nimbus Note',
          xfbml: true,
          version: 'v9.0'
        });
      };
      (function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "//connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (window.FB) {
        if (!this.domNode.getAttribute('fb-xfbml-state')) {
          window.FB.XFBML.parse(this.domNode.parentNode);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      setTimeout(this.disableRecycling);
    }
  }, {
    key: "render",
    value: function render() {
      return (0,preact_module.h)("div", {
        className: "fb-post",
        "data-href": this.props.src,
        "data-show-text": true,
        ref: this.onRef
      });
    }
  }], [{
    key: "getInitialWidth",
    value: function getInitialWidth(src) {
      return new Promise(function (resolve, reject) {
        var timeout = 300;
        var maxCnt = 5;
        var cnt = 0;
        var wait = function wait() {
          if (cnt > maxCnt) {
            reject();
          } else {
            var post = document.querySelector('.fb-post[data-href="' + src + '"]');
            if (!post || post.getAttribute('fb-xfbml-state') !== 'rendered') {
              cnt++;
              setTimeout(wait, timeout);
            } else {
              if (post.firstChild) {
                resolve(post.firstChild.getBoundingClientRect().width);
              } else {
                reject();
              }
            }
          }
        };
        wait();
      });
    }
  }]);
  return FacebookComponent;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/remoteFrame/widgets/script.js
function script_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { script_typeof = function _typeof(obj) { return typeof obj; }; } else { script_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return script_typeof(obj); }










function script_extends() { script_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return script_extends.apply(this, arguments); }
function script_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function script_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function script_createClass(Constructor, protoProps, staticProps) { if (protoProps) script_defineProperties(Constructor.prototype, protoProps); if (staticProps) script_defineProperties(Constructor, staticProps); return Constructor; }
function script_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) script_setPrototypeOf(subClass, superClass); }
function script_setPrototypeOf(o, p) { script_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return script_setPrototypeOf(o, p); }
function script_createSuper(Derived) { var hasNativeReflectConstruct = script_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = script_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = script_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return script_possibleConstructorReturn(this, result); }; }
function script_possibleConstructorReturn(self, call) { if (call && (script_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return script_assertThisInitialized(self); }
function script_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function script_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function script_getPrototypeOf(o) { script_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return script_getPrototypeOf(o); }
function script_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var ScriptComponent = /*#__PURE__*/function (_Component) {
  script_inherits(ScriptComponent, _Component);
  var _super = script_createSuper(ScriptComponent);
  function ScriptComponent(props) {
    var _this;
    script_classCallCheck(this, ScriptComponent);
    _this = _super.call(this, props);
    script_defineProperty(script_assertThisInitialized(_this), "onFrameLoad", function () {
      _this.setState(function () {
        return {
          loading: false
        };
      });
    });
    script_defineProperty(script_assertThisInitialized(_this), "onRef", function (node) {
      _this.domNode = node;
      _this.props.onDomRef(node);
    });
    _this.state = {
      loading: true
    };
    return _this;
  }
  script_createClass(ScriptComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        src = _this$props.src,
        addClassName = _this$props.addClassName;
      var loading = this.state.loading;
      var frameStyles = {
        border: '0',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        position: 'absolute'
      };
      var frameAttrs = {
        sandbox: 'allow-scripts allow-same-origin allow-popups allow-forms'
      };
      var html = "<style>iframe { width: 100%; height: 100%; }</style>\n<div>".concat(src, "</div>");
      return (0,preact_module.h)("div", {
        className: addClassName
      }, loading ? (0,preact_module.h)(RemoteFrameLoader, {
        height: true,
        editMode: this.props.editMode,
        i18n: this.props.i18n,
        clearFrame: this.props.clearFrame
      }) : null, (0,preact_module.h)("iframe", script_extends({
        ref: this.onRef
        /* src={'data:text/html;charset=utf-8,' + encodeURI(html)} */,
        src: 'javascript:void(0);',
        srcdoc: html,
        allowfullscreen: "allowfullscreen",
        style: frameStyles,
        onLoad: this.onFrameLoad
      }, frameAttrs)));
    }
  }]);
  return ScriptComponent;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/remoteFrame/widgets/oneDrive.js
function oneDrive_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { oneDrive_typeof = function _typeof(obj) { return typeof obj; }; } else { oneDrive_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return oneDrive_typeof(obj); }













function oneDrive_extends() { oneDrive_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return oneDrive_extends.apply(this, arguments); }
function oneDrive_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function oneDrive_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function oneDrive_createClass(Constructor, protoProps, staticProps) { if (protoProps) oneDrive_defineProperties(Constructor.prototype, protoProps); if (staticProps) oneDrive_defineProperties(Constructor, staticProps); return Constructor; }
function oneDrive_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) oneDrive_setPrototypeOf(subClass, superClass); }
function oneDrive_setPrototypeOf(o, p) { oneDrive_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return oneDrive_setPrototypeOf(o, p); }
function oneDrive_createSuper(Derived) { var hasNativeReflectConstruct = oneDrive_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = oneDrive_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = oneDrive_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return oneDrive_possibleConstructorReturn(this, result); }; }
function oneDrive_possibleConstructorReturn(self, call) { if (call && (oneDrive_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return oneDrive_assertThisInitialized(self); }
function oneDrive_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function oneDrive_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function oneDrive_getPrototypeOf(o) { oneDrive_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return oneDrive_getPrototypeOf(o); }
function oneDrive_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var OneDriveComponent = /*#__PURE__*/function (_Component) {
  oneDrive_inherits(OneDriveComponent, _Component);
  var _super = oneDrive_createSuper(OneDriveComponent);
  function OneDriveComponent(props) {
    var _this;
    oneDrive_classCallCheck(this, OneDriveComponent);
    _this = _super.call(this, props);
    oneDrive_defineProperty(oneDrive_assertThisInitialized(_this), "onFrameLoad", function () {
      _this.setState(function () {
        return {
          loading: false
        };
      });
    });
    oneDrive_defineProperty(oneDrive_assertThisInitialized(_this), "onFrameError", function () {
      if (_this.props.skipErrorLoading) return;
      // если контент уже был загружен и функция onFrameLoad отработала вновь, выдаем ошибку внутренней ссылки
      if (!_this.state.loading) {
        _this.props.onInternalLinkError();
      } else {
        // если контент ниразу не был загружен, значит фрейм не смог загрузиться, выдаем ошибку контента
        _this.props.onFrameLoadError();
      }
    });
    oneDrive_defineProperty(oneDrive_assertThisInitialized(_this), "onRef", function (node) {
      _this.domNode = node;
      _this.props.onDomRef(node);
    });
    oneDrive_defineProperty(oneDrive_assertThisInitialized(_this), "imgHtmlPattern", /<img.*?s*src=["|'](.*?)["|'].*?\/>/);
    oneDrive_defineProperty(oneDrive_assertThisInitialized(_this), "imgPattern", /(https?:\/\/)?([\w\.-]+\.)?storage\.live\.com\/[^\/]+/);
    oneDrive_defineProperty(oneDrive_assertThisInitialized(_this), "frameStyles", {
      border: '0',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      position: 'absolute'
    });
    oneDrive_defineProperty(oneDrive_assertThisInitialized(_this), "frameAttrs", {
      sandbox: 'allow-scripts allow-same-origin allow-popups allow-forms'
    });
    _this.state = {
      loading: true
    };
    return _this;
  }
  oneDrive_createClass(OneDriveComponent, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return this.state.loading;
    }
  }, {
    key: "renderImageEmbed",
    value: function renderImageEmbed(html) {
      var wrapperStyles = 'width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;';
      return (0,preact_module.h)("iframe", oneDrive_extends({
        src: 'data:text/html;charset=utf-8,' + encodeURI("<div style=\"".concat(wrapperStyles, "\">").concat(html, "</div>")),
        allowfullscreen: "allowfullscreen",
        style: this.frameStyles
      }, this.frameAttrs));
    }
  }, {
    key: "render",
    value: function render() {
      var src = this.props.src;
      var loading = this.state.loading;
      if (this.imgHtmlPattern.test(src)) {
        var imgSrcMatch = src.match(this.imgHtmlPattern);
        if (imgSrcMatch[1] && imgSrcMatch[1].length) {
          return this.renderImageEmbed("<img style=\"max-width: 100%; max-height: 100%;\" src=\"".concat(imgSrcMatch[1], "\" />"));
        } else {
          this.renderImageEmbed(src);
        }
      } else if (this.imgPattern.test(src)) {
        return this.renderImageEmbed("<img style=\"max-width: 100%; max-height: 100%;\" src=\"".concat(src, "\" />"));
      } else {
        var match = src.match(IFramePattern);
        var frameSrc = decodeURI((match && match[1] && match[1].length ? match[1] : src).replace('/redir?', '/embed?').replace(/&amp;/g, '&'));
        return (0,preact_module.h)("div", {
          className: "onedrive-embed-frame"
        }, loading ? (0,preact_module.h)(RemoteFrameLoader, {
          height: true,
          editMode: this.props.editMode,
          i18n: this.props.i18n,
          clearFrame: this.props.clearFrame
        }) : null, (0,preact_module.h)("iframe", oneDrive_extends({
          ref: this.onRef,
          src: frameSrc,
          allowfullscreen: "allowfullscreen",
          style: this.frameStyles,
          onLoad: this.onFrameLoad,
          onError: this.onFrameError
        }, this.frameAttrs)));
      }
    }
  }]);
  return OneDriveComponent;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/remoteFrame/widgets/card.js












function card_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function card_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function card_createClass(Constructor, protoProps, staticProps) { if (protoProps) card_defineProperties(Constructor.prototype, protoProps); if (staticProps) card_defineProperties(Constructor, staticProps); return Constructor; }
function card_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) card_setPrototypeOf(subClass, superClass); }
function card_setPrototypeOf(o, p) { card_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return card_setPrototypeOf(o, p); }
function card_createSuper(Derived) { var hasNativeReflectConstruct = card_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = card_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = card_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return card_possibleConstructorReturn(this, result); }; }
function card_possibleConstructorReturn(self, call) { if (call && (card_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return card_assertThisInitialized(self); }
function card_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function card_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function card_getPrototypeOf(o) { card_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return card_getPrototypeOf(o); }
function card_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function card_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = card_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function card_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return card_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return card_arrayLikeToArray(o, minLen); }
function card_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function card_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { card_typeof = function _typeof(obj) { return typeof obj; }; } else { card_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return card_typeof(obj); }


function findMetaValue(meta, key) {
  if (card_typeof(meta) === 'object') {
    if (Array.isArray(meta)) {
      var _iterator = card_createForOfIteratorHelper(meta),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var v = _step.value;
          if (card_typeof(v) === 'object') {
            var result = findMetaValue(v, key);
            if (result) {
              return result;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } else {
      for (var k in meta) {
        if (k === key) {
          return meta[k];
        } else if (card_typeof(meta[k]) === 'object') {
          var _result = findMetaValue(meta[k], key);
          if (_result) {
            return _result;
          }
        }
      }
    }
  }
}
var Card = /*#__PURE__*/function (_Component) {
  card_inherits(Card, _Component);
  var _super = card_createSuper(Card);
  function Card(props) {
    var _this;
    card_classCallCheck(this, Card);
    _this = _super.call(this, props);
    card_defineProperty(card_assertThisInitialized(_this), "onRef", function (node) {
      _this.domNode = node;
      _this.props.onDomRef(node);
    });
    _this.state = {
      loading: true,
      meta: null
    };
    return _this;
  }
  card_createClass(Card, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return this.state.loading;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props$blot$blot = this.props.blot.blotConfig,
        iframelyHost = _this$props$blot$blot.iframelyHost,
        iframelyPort = _this$props$blot$blot.iframelyPort;
      var requestUrl = iframelyHost + (iframelyPort ? ':' + iframelyPort : '') + '/meta?url=' + this.props.src;
      fetch(requestUrl).then(function (res) {
        return res.json();
      }).then(function (meta) {
        _this2.setState(function () {
          return {
            meta: meta,
            loading: false
          };
        });
      }).catch(function (_) {
        _this2.props.onFrameLoadError();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        meta = _this$state.meta,
        loading = _this$state.loading;
      return loading && !meta ? (0,preact_module.h)(RemoteFrameLoader, {
        height: true,
        editMode: this.props.editMode,
        i18n: this.props.i18n,
        clearFrame: this.props.clearFrame
      }) : (0,preact_module.h)(MetaCard, {
        meta: meta,
        url: this.props.src
      });
    }
  }]);
  return Card;
}(preact_module/* Component */.wA);

function MetaCard(_ref) {
  var _meta$open_graph, _meta$open_graph$imag, _meta$twitter_card, _meta$twitter_card$im;
  var meta = _ref.meta,
    url = _ref.url;
  var title = findMetaValue(meta, 'title');
  var name = findMetaValue(meta, 'site_name');
  var description = findMetaValue(meta, 'description');
  var author = findMetaValue(meta, 'author');
  var image = ((_meta$open_graph = meta.open_graph) === null || _meta$open_graph === void 0 ? void 0 : (_meta$open_graph$imag = _meta$open_graph.images) === null || _meta$open_graph$imag === void 0 ? void 0 : _meta$open_graph$imag[0]) || ((_meta$twitter_card = meta.twitter_card) === null || _meta$twitter_card === void 0 ? void 0 : (_meta$twitter_card$im = _meta$twitter_card.images) === null || _meta$twitter_card$im === void 0 ? void 0 : _meta$twitter_card$im[0]);
  var favicon = meta.favicon;
  return (0,preact_module.h)("div", {
    className: "embed-card-wrapper"
  }, image && image.url && (0,preact_module.h)("div", {
    className: "embed-card-img"
  }, (0,preact_module.h)("a", {
    href: url,
    style: {
      backgroundImage: "url(".concat(image.url, ")"),
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      position: 'absolute',
      top: 0,
      left: 0,
      display: 'block',
      width: '100%',
      height: '100%'
    }
  })), (0,preact_module.h)("div", {
    className: "embed-card-info"
  }, (0,preact_module.h)("div", {
    className: "embed-card-info-top"
  }, title && (0,preact_module.h)("div", {
    className: "embed-card-title"
  }, (0,preact_module.h)("a", {
    href: url
  }, (0,preact_module.h)("h3", null, title))), description && (0,preact_module.h)("div", {
    className: "embed-card-description"
  }, (0,preact_module.h)("p", null, description))), (0,preact_module.h)("div", {
    className: "embed-card-info-bottom"
  }, (0,preact_module.h)("a", {
    className: "embed-card-link",
    href: url
  }, favicon && (0,preact_module.h)("img", {
    className: "embed-card-favicon",
    src: favicon
  }), (0,preact_module.h)("span", {
    className: "embed-card-site"
  }, name || url), author && (0,preact_module.h)("span", {
    className: "embed-card-author"
  }, author)))));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/remoteFrame/remoteFrameOptions.js
























var WIDE_SCREEN_RATIO = 16 / 9;
var remoteFrameOptions_frames = {
  googleDocs: {
    name: 'Google Docs',
    pattern: /https:\/\/([\w\.-]+\.)?docs.google.com\/(document|spreadsheets)\/d\//,
    allowOpenOrigin: true,
    allowDirectUrl: true,
    errorMessageKey: 'google_docs_auth_error',
    frameRatio: 0.71,
    attributes: {
      sandbox: 'allow-downloads allow-forms allow-presentation allow-same-origin allow-scripts allow-modals allow-popups allow-popups-to-escape-sandbox allow-storage-access-by-user-activation',
      //loading: 'lazy',
      allow: "fullscreen https://docs.google.com ; focus-without-user-activation 'none'"
    }
  },
  googleCalendar: {
    name: 'Google Calendar',
    pattern: /https:\/\/calendar\.google\.com\/calendar\/embed/,
    frameRatio: 3 / 4
  },
  googleMaps: {
    name: 'Google Maps',
    pattern: /https:\/\/www.google.[a-z]{1,3}\/maps\//,
    frameRatio: 450 / 600,
    icon: icons/* IconGoogleMaps */.kXu,
    getFrameSrc: function getFrameSrc(src) {
      return getGoogleMapsEmbedSrc(src);
    }
  },
  googleDrive: {
    name: 'Google Drive',
    pattern: /(https?:)?(\/\/)?drive.google.[a-z]{1,3}\/file\//,
    frameRatio: WIDE_SCREEN_RATIO,
    getFrameSrc: function getFrameSrc(src) {
      var match = src.match(/\/file\/d\/([^\/]+)/);
      if (match && match[0]) return 'https://drive.google.com' + match[0] + '/preview';
      return src;
    }
  },
  googleForms: {
    name: 'Google Forms',
    pattern: /(https?:)?(\/\/)?docs.google.[a-z]{1,3}\/forms\/d\/e\//,
    frameRatio: WIDE_SCREEN_RATIO,
    getFrameSrc: function getFrameSrc(src) {
      return src;
    }
  },
  googleDriveFolder: {
    name: 'Google Drive Folder',
    pattern: /(https?:)?(\/\/)?drive.google.[a-z]{1,3}\/drive\/folders\//,
    frameRatio: WIDE_SCREEN_RATIO,
    getFrameSrc: function getFrameSrc(src) {
      var folderMatch = src.match(/(https?:)?(\/\/)?drive.google.[a-z]{1,3}\/drive\/folders\/([0-9A-Za-z-_]+)/);
      if (folderMatch && folderMatch[3]) {
        var folderId = folderMatch[3];
        var keyMatch = src.match(/resourcekey=[0-9A-Za-z-]+/);
        var key = keyMatch ? '&' + keyMatch[0] : '';
        return "https://drive.google.com/embeddedfolderview?id=".concat(folderId).concat(key, "#list");
      }
      return src;
    }
  },
  dailymotion: {
    name: 'Dailymotion',
    pattern: /(https?:)?(\/\/)?(www\.)?dailymotion.com\/(embed\/video|video)\/[a-z,0-9]+/,
    allowOpenOrigin: true,
    frameRatio: WIDE_SCREEN_RATIO,
    getFrameSrc: function getFrameSrc(src) {
      return 'https://www.dailymotion.com/embed/video/' + (url_url.parse(src).pathname || '').split('/').pop();
    }
  },
  figma: {
    name: 'Figma',
    pattern: /https:\/\/([\w\.-]+\.)?figma.com\/(((file|proto|design)\/([0-9a-zA-Z]{22,128})(\/.*)?$)|embed\?)/,
    allowOpenOrigin: true,
    frameRatio: WIDE_SCREEN_RATIO,
    icon: icons/* IconFigma */.JCH,
    getFrameSrc: function getFrameSrc(src) {
      if (/https:\/\/([\w\.-]+\.)?figma.com\/embed\?/.test(src)) {
        return src;
      }
      return 'https://www.figma.com/embed?embed_host=astra&url=' + src;
    }
  },
  vimeo: {
    name: 'Vimeo',
    pattern: /(https?:)?(\/\/)?(player\.)?vimeo.com\/(video\/)?[0-9]+/,
    allowOpenOrigin: true,
    frameRatio: WIDE_SCREEN_RATIO,
    icon: icons/* IconVimeo */.Tz3,
    getFrameSrc: function getFrameSrc(src) {
      if (/(https?:)?(\/\/)?vimeo.com\/[0-9]+/.test(src)) {
        return 'https://player.vimeo.com/video/' + (url_url.parse(src).pathname || '').split('/').pop();
      }
      return src;
    }
  },
  // в Youtube на данный момент работает эмбеддинг видео, ссылки на юзера, ссылки на канал юзера
  // нужно будет так же добавить поддержку ссылок на плейлист
  youtube: {
    name: 'YouTube',
    pattern: /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/|channel\/|user\/|c\/)?)([\w\-]+)(\S+)?$/,
    allowOpenOrigin: true,
    frameRatio: WIDE_SCREEN_RATIO,
    icon: icons/* IconYoutube */.zA_,
    getFrameSrc: function getFrameSrc(src) {
      var match = src.match(remoteFrameOptions_frames.youtube.pattern);
      var type = match[4] && ['c', 'user', 'channel'].includes(match[4].replace(/\//g, '')) && match[4].replace(/\//g, '') || 'video';
      if (match[5]) {
        if (type === 'video') {
          var startTime = getYoutubeFrameStartTime(src);
          return 'https://www.youtube.com/embed/' + match[5] + (startTime ? '?start=' + startTime : '');
        } else {
          if (type === 'user') {
            return 'https://www.youtube.com/embed?listType=user_uploads&list=' + match[5];
          } else {
            var playlistIdFromUserChannel = match[5].replace(/^UC/, 'UU');
            return 'https://www.youtube.com/embed/videoseries?list=' + playlistIdFromUserChannel;
          }
        }
      }
      return src;
    },
    getOriginUrl: function getOriginUrl(src) {
      var match = src.match(remoteFrameOptions_frames.youtube.pattern);
      if (!match[4] || !['c', 'user', 'channel'].includes(match[4].replace(/\//g, ''))) {
        var startTime = getYoutubeFrameStartTime(src);
        if (match[5]) {
          return 'https://www.youtube.com/watch?v=' + match[5] + (startTime ? '?t=' + startTime : '');
        }
      }
      return src;
    }
  },
  miro: {
    name: 'Miro Board',
    pattern: /(https?:)?(\/\/)?(www\.)?miro\.com\/app\/board\/.+/,
    allowOpenOrigin: true,
    frameRatio: WIDE_SCREEN_RATIO,
    getFrameSrc: function getFrameSrc(src) {
      var parsed = url_url.parse(src);
      var id = parsed.pathname.split('/')[3];
      return 'https://miro.com/app/live-embed/'.concat(id, '/?');
    }
  },
  canva: {
    name: 'Canva',
    pattern: /(https?:\/\/)?(www\.)?(.+\.)?canva.com\/design/,
    allowOpenOrigin: true,
    frameRatio: WIDE_SCREEN_RATIO,
    getFrameSrc: function getFrameSrc(src) {
      var parsed = url_url.parse(src);
      if (!new URLSearchParams(parsed.search).has('embed')) {
        var urlPatch = parsed.pathname.split('/').map(function (str, index, arr) {
          return index === arr.length - 1 ? 'view' : str;
        }).join('/');
        return 'https://www.canva.com' + urlPatch + '?embed';
      }
      return src;
    }
  },
  tiktok: {
    name: 'TikTok',
    pattern: /(https?:\/\/)?(m\.|www\.)?tiktok.com\/.+/,
    allowOpenOrigin: true,
    initialWidth: 605,
    frameRatio: 0.776,
    getFrameSrc: function getFrameSrc(src) {
      var lang = url_url.parse(src, true).query.lang;
      var match = src.match(/(?:https?:\/\/)?(?:www\.)?(?:tiktok\.com)(?:\/)(?:@\w+|embed|share|trending)(?:\/|\?)(?:video|user|shareId=|[\D=&]+)?(?:\/)?([0-9]+)/);
      if (match && match[1]) {
        return 'https://www.tiktok.com/embed/v2/' + match[1] + (lang ? '?lang=' + lang + '-' + lang.toUpperCase() : '');
      }
    }
  },
  codepen: {
    name: 'CodePen',
    pattern: /(https?:\/\/)codepen.io\/(.+)\/(pen|embed)(\/preview)?\/(\w+)/,
    allowOpenOrigin: true,
    getFrameSrc: function getFrameSrc(src) {
      return isCodepenEmbed(src);
    },
    getOriginUrl: function getOriginUrl(src) {
      var match = src.match(remoteFrameOptions_frames.codepen.pattern);
      if (match && match[2] && match[5]) {
        return 'https://codepen.io/' + match[2] + '/pen/' + match[5];
      }
      return src;
    }
  },
  instagram: {
    name: 'Instagram',
    pattern: /(https?:\/\/)(www\.)?instagram.com\/p\/.+/,
    allowOpenOrigin: true,
    frameRatio: 0.57,
    initialWidth: 420,
    getFrameSrc: function getFrameSrc(src) {
      var params = url_url.parse(src);
      return "https://www.instagram.com".concat(params.pathname, "embed");
    }
  },
  loom: {
    name: 'Loom',
    pattern: /(https?:\/\/)(www\.)?loom.com\/(share|embed)\/.+/,
    allowOpenOrigin: true,
    frameRatio: WIDE_SCREEN_RATIO,
    getFrameSrc: function getFrameSrc(src) {
      var match = src.match(/(?:share|embed)\/([^\/]+)/);
      if (match && match[1]) return 'https://www.loom.com/embed/' + match[1];
      return src;
    }
  },
  appBox: {
    name: 'AppBOX',
    pattern: /(https?:\/\/)([\w\.-]+\.)?app.box.com\/embed\/.+/,
    allowOpenOrigin: true,
    attributes: {
      sandbox: 'allow-scripts allow-same-origin allow-popups allow-forms allow-downloads'
    }
  },
  internalNimbus: {
    name: 'Internal Nimbus link',
    pattern: /^https?:\/\/[\.a-zA-Z0-9_-]+\/ws|space\/[a-zA-Z0-9_]+\/(.+\/)?note|page\/.+/,
    allowOpenOrigin: true,
    frameRatio: WIDE_SCREEN_RATIO,
    getFrameSrc: function getFrameSrc(src) {
      return src + '?e=cd1bb9313a696d2247e805cb3db7aa36';
    }
  },
  airtable: {
    name: 'Airtable',
    pattern: /(https?:\/\/)?(www\.)?airtable.com\//,
    icon: icons/* IconAirtable */.uSR,
    getFrameSrc: function getFrameSrc(src) {
      if (/(https?:\/\/)?(www\.)?airtable.com\/embed\//.test(src)) {
        return src;
      } else {
        var params = url_url.parse(src);
        return 'https://' + params.hostname + '/embed' + params.pathname;
      }
    }
  }
};
var widgets = {
  githubGist: {
    name: 'GitHub Gist',
    pattern: /(https?:)?(\/\/)?gist\.github\.com\/([^\/]+\/)?[0-9a-f]+/,
    icon: icons/* IconGithubGist */.LC9,
    allowedResizePoints: 'right',
    component: GithubGistComponent
  },
  typeform: {
    name: 'Typeform',
    pattern: /^(https?:\/\/)?([\da-z\.-]+\.)?typeform.com\/to\/[\w]+?$/,
    frameRatio: 2,
    icon: icons/* IconTypeform */.qdP,
    component: TypeformComponent
  },
  twitter: {
    name: 'Twitter',
    pattern: /(https?:)?(\/\/)?twitter\.com\/[^\/]+\/status\/[^\/]+/,
    allowOpenOrigin: true,
    disallowResize: true,
    icon: icons/* IconTwitter */.JDv,
    component: TweetComponent,
    onRenderContent: TweetComponent.onRenderContent
  },
  facebook: {
    name: 'Facebook',
    pattern: /(https?:)?(\/\/)?facebook\.com\/[^\/]+/,
    allowOpenOrigin: true,
    component: FacebookComponent,
    getInitialWidth: FacebookComponent.getInitialWidth,
    allowedResizePoints: 'right'
  },
  script: {
    name: 'Embed Script',
    pattern: /<script([\s\S]+)?(src="[\s\S]+")?([\s\S]+)?>([\s\S]+)?(<\/script>)?/,
    component: ScriptComponent
  },
  onedrive: {
    name: 'One Drive',
    pattern: /(https?:\/\/)?([\w\.-]+\.)?(storage|onedrive)\.live\.com\/[^\/]+/,
    component: OneDriveComponent
  },
  card: {
    name: 'Iframely embed',
    component: Card
  }
};
var skipIframelyEmbeds = {
  metacafe: {
    name: 'Metacafe',
    pattern: /(https?:\/\/)?www.metacafe.com\/(watch|embed)\/[0-9]+/
  },
  invisionapp: {
    name: 'InvisionApp',
    pattern: /(https?:\/\/)?(\w+\.)invisionapp.com\/([\w\.\/]+|overview)?\/(share|live-embed)?/,
    icon: icons/* IconInvision */.i2f
  },
  invisio: {
    name: 'Invisio',
    pattern: /(https?:\/\/)?invis.io\/\w+/,
    icon: icons/* IconInvision */.i2f
  },
  litres: {
    name: 'Litres',
    pattern: /(https?:\/\/)?(www\.)?litres.ru/
  },
  tableau: {
    name: 'TableAu',
    pattern: /(https?:\/\/)?public\.tableau\.com\/(.+)&:embed=true/
  },
  desmos: {
    name: 'Desmos',
    pattern: /(https?:\/\/)?(www\.)?desmos.com\/calculator\//
  },
  designrr: {
    name: 'Designrr',
    pattern: /(https?:\/\/)?(www\.)?(.+\.)?designrr.co\//
  },
  questionscout: {
    name: 'Questionscout',
    pattern: /(https?:\/\/)?(www\.)?(.+\.)?questionscout.com\//
  },
  nowalepszastrona: {
    name: 'Nowalepszastrona',
    pattern: /(https?:\/\/)?(www\.)?(.+\.)?nowalepszastrona.pl\//
  },
  miniextensions: {
    name: 'Miniextensions',
    pattern: /(https?:\/\/)?(.+\.)?miniextensions.com\//
  },
  redditmedia: {
    name: 'Redditmedia',
    pattern: /(https?:\/\/)?(.+\.)?redditmedia.com\//
  },
  masterlyclients: {
    name: 'Masterly',
    pattern: /(https?:\/\/)?(.+\.)?masterlyclients.com\//
  },
  clickup: {
    name: 'Click-up',
    pattern: /(https?:\/\/)?(.+\.)?sharing.clickup.com\//
  },
  fliphtml5: {
    name: 'FlipHtml5',
    pattern: /(https?:\/\/)?(.+\.)?fliphtml5.com\//
  },
  sharepoint: {
    name: 'SharePoint',
    pattern: /(https?:\/\/)?(.+\.)?sharepoint.com\//
  },
  iclosed: {
    name: 'iclosed',
    pattern: /(https?:\/\/)?app.iclosed.io\//
  },
  berrycast: {
    name: 'berrycast',
    pattern: /^https?:\/\/.+\/conversations\/[a-zA-Z-0-9]+(\/video-player)?$/
  }
};
var skipXFOSupport = {
  googleSlides: {
    name: 'Google Slides',
    pattern: /https:\/\/([\w\.-]+\.)?docs.google.com\/presentation\/d\//
  }
};
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/remoteFrame/util.js
function remoteFrame_util_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = remoteFrame_util_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function remoteFrame_util_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return remoteFrame_util_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return remoteFrame_util_arrayLikeToArray(o, minLen); }
function remoteFrame_util_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }























var GOOGLE_API_KEY = 'AIzaSyBtcUZ2bqXlsRLDA9SYkvs-xx_DkORt7yc'; //TODO: ключ апи, для тестов, в дальнейшем нужно изменить на нормальный

var IFramePattern = /<iframe.*?\s*[.\s\S]*src=["|'|“]?(.*?)["|'|“| ][.\s\S]*?<\/iframe>/;
var videoSrcPattern = /<video.*?s*src=["|'|“](.*?)["|'|“].*?<\/video>/m;
var nimbusSharePattern = /^https?:\/\/[\.a-zA-Z0-9_-]+(\/s)?\/share\/[0-9]+\/[a-zA-Z0-9_]+(\/.+)?/;
var nimbusShareShortPattern = /^https?:\/\/nimb\.ws\/[a-zA-Z0-9_]+(\/)?/;

// тут сразу делаем проверку строки и в случае если строка не пройдет проверки возвращаем false 
function deserializeEmbedString(string) {
  var isUrlPattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
  var hasProtocolPattern = /^https?\:\/\//;
  var match = string.match(IFramePattern);
  if (match && match[1] && match[1].length) {
    return match[1];
  } else {
    var isUrl = Boolean(string.match(isUrlPattern));
    if (isUrl) {
      var hasProtocol = Boolean(string.match(hasProtocolPattern));
      if (!hasProtocol) {
        return 'http://' + string;
      } else {
        return string;
      }
    } else {
      return {
        errorType: 'url',
        errorKey: 'remote_frame.error.is_not_link'
      };
    }
  }
}
function isLinkToPdfFile(url) {
  var pattern = /^(https?:\/\/)?(www\.)?([\da-z\.-]+)\.([a-z\.]{2,6})\/[\w \.-\/%]+?\.pdf$/;
  return pattern.test(encodeURI(url));
}

//jsonp
function scriptRequest(url, callbackName, onSuccess, onError) {
  if (!window.editorJsonpCallbackRegistry) {
    window.editorJsonpCallbackRegistry = {};
  }
  var scriptOk = false;
  var script = document.createElement('script');
  url += ~url.indexOf('?') ? '&' : '?';
  url += 'callback=editorJsonpCallbackRegistry.' + callbackName;
  editorJsonpCallbackRegistry[callbackName] = function (data) {
    scriptOk = true;
    delete window.editorJsonpCallbackRegistry[callbackName];
    onSuccess(data);
    script.parentNode.removeChild(script);
  };
  function checkCallback() {
    if (scriptOk) return;
    delete window.editorJsonpCallbackRegistry[callbackName];
    onError(url);
    script.parentNode.removeChild(script);
  }
  script.onreadystatechange = function () {
    if (this.readyState == 'complete' || this.readyState == 'loaded') {
      this.onreadystatechange = null;
      setTimeout(checkCallback, 0);
    }
  };
  script.onload = script.onerror = checkCallback;
  script.src = url;
  document.body.appendChild(script);
}
function getGoogleMapsEmbedSrc(url) {
  var parsed = url_url.parse(url);
  var query = parsed.query || '';
  var urlParams = new URLSearchParams(query);
  if (urlParams.has('q')) {
    var q = urlParams.get('q');
    return 'https://www.google.com/maps/embed/v1/place?key=' + GOOGLE_API_KEY + '&q=' + q;
  } else if (urlParams.has('pb')) {
    var pb = urlParams.get('pb');
    return 'https://www.google.com/maps/embed?pb=' + pb;
  } else if (urlParams.has('mid')) {
    // mid = map id - если указан этот параметр, то карта создана юзером
    var mid = urlParams.get('mid');
    return 'https://www.google.com/maps/d/embed?mid=' + mid;
  } else {
    var pathArr = parsed.path.split('/');
    var coords = url.match(/@(.*?),(.*?),/);
    if (pathArr.indexOf('place') !== -1) {
      var queryString = pathArr[pathArr.indexOf('place') + 1];
      if (queryString) {
        return 'https://www.google.com/maps/embed/v1/place?q=' + queryString + '&key=' + GOOGLE_API_KEY;
      } else {
        return url;
      }
    } else if (coords) {
      return 'https://www.google.com/maps/embed/v1/view?center=' + coords[1] + ',' + coords[2] + '&key=' + GOOGLE_API_KEY + '&zoom=17';
    } else {
      return url;
    }
  }
}
function getYoutubeFrameStartTime(url) {
  var query = url_url.parse(url).search;
  if (query) {
    var searchParams = new URLSearchParams(query);
    if (searchParams.has('t')) {
      return searchParams.get('t');
    } else if (searchParams.has('start')) {
      return searchParams.get('start');
    } else {
      return false;
    }
  }
  return false;
}
function isLitresEmbed(string) {
  var scriptPattern = /(<div(\s(.+)?\s?class="litres_fragment_body"\s(.+)?><\/div>))?<script.+lw\.src\s?=\s?"https:\/\/www\.litres\.ru\/static\/widgets\/js\/fragment\.js".+<\/script>/;
  var bookIdPattern = /<script.+var\slitres_fragment_book_view_id\s?=\s?(\d+);.+<\/script>/;
  var partnerIdPattern = /<script.+var\slitres_fragment_lfrom\s?=\s?(\d+);.+<\/script>/;
  var match = string.match(bookIdPattern);
  var bookId = match && match[1];
  if (!bookId) return false;
  match = string.match(partnerIdPattern);
  var partnerId = match && match[1];
  if (!partnerId) {
    partnerId = 123456;
  }
  if (scriptPattern.test(string)) {
    return 'https://www.litres.ru/pages/quickread/?art=' + bookId + '&skin=normal&lfrom=' + partnerId + '&widget=1.00&iframe=1';
  } else {
    return false;
  }
}
function isCodepenEmbed(string) {
  var htmlPattern = /<p class="codepen" [\s\S]+<\/p>[\s\S]*<script async src="https:\/\/static\.codepen\.io[\s\S]+><\/script>/;
  var linkPattern = /(https?:\/\/)?codepen.io\/(.+)\/(pen|embed)(\/preview)?\/(\w+)/;
  var attrsPattern = /data-[\w-]+="[\w, -]+"/g;
  var forIframeAttrs = ['height', 'theme-id', 'default-tab'];
  var match = string.match(linkPattern);
  var result = false;
  if (match && match[2] && match[5]) {
    result = 'https://codepen.io/' + match[2] + '/embed/' + (match[4] ? 'preview/' : '') + match[5];
    var isHtml = htmlPattern.test(string);
    if (isHtml) {
      var attrs = string.match(attrsPattern);
      var withPreview = false;
      if (attrs.length) {
        attrs = attrs.map(function (attr) {
          return attr.replace('data-', '').replace('"', '');
        }).filter(function (attr) {
          if (attr.startsWith('preview')) {
            withPreview = true;
          }
          return forIframeAttrs.includes(attr.split('=')[0]);
        });
        if (withPreview) {
          result = 'https://codepen.io/' + match[2] + '/embed/preview/' + match[4];
        }
        if (attrs.length) {
          result += '?';
          var _iterator = remoteFrame_util_createForOfIteratorHelper(attrs),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var attr = _step.value;
              result += attr;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }
    }
  }
  return result;
}
function isOneDriveEmbed(string) {
  if (widgets.onedrive.pattern.test(string)) {
    return string;
  }
  return false;
}
function isSpecEmbed(string) {
  var specFns = [isLitresEmbed, isCodepenEmbed, isOneDriveEmbed];
  var result = false;
  for (var _i = 0, _specFns = specFns; _i < _specFns.length; _i++) {
    var fn = _specFns[_i];
    result = fn(string);
    if (result) {
      break;
    }
  }
  return result;
}
function isNimbusVideoEmbed(src, html) {
  return (nimbusSharePattern.test(src) || nimbusShareShortPattern.test(src)) && videoSrcPattern.test(html);
}
function includeTwttrScript() {
  var onReady = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var onWidgetRendered = function onWidgetRendered(event) {
    var blot = normalizeToStoredBlot(getBlotForNode(event.target));
    if (blot && blot.onRenderContent) {
      var iframe = event.target.querySelector('iframe');
      if (iframe) {
        // Тут даже не знаю как поступить, поидее это лишняя нагрузка, но не думаю что твитов будет много на странице,
        // да и фрейм ресайзится тока во время загрузки, потом его размеры статичны.
        // Другого способа как дождаться полной загрузки фрейма не нашел, так как доступа к содержимому нет.
        // Если не дожидаться, то фрейм в начале загрузки содержимого имеет меньшую высоту.
        new ResizeObserver(function () {
          var _event$target$parentN = event.target.parentNode.getBoundingClientRect(),
            width = _event$target$parentN.width,
            height = _event$target$parentN.height;
          blot.onRenderContent('twitter', {
            width: width,
            height: height
          });
        }).observe(iframe);
      } else {
        var _event$target$parentN2 = event.target.parentNode.getBoundingClientRect(),
          width = _event$target$parentN2.width,
          height = _event$target$parentN2.height;
        blot.onRenderContent('twitter', {
          width: width,
          height: height
        });
      }
    }
  };

  //функция добавления скрипта взята из API твиттера
  window.twttr = function (d, s, id) {
    var js,
      fjs = d.getElementsByTagName(s)[0],
      t = window.twttr || {};
    if (d.getElementById(id)) return t;
    js = d.createElement(s);
    js.id = id;
    js.src = "https://platform.twitter.com/widgets.js";
    fjs.parentNode.insertBefore(js, fjs);
    t._e = [];
    t.ready = function (f) {
      t._e.push(f);
    };
    return t;
  }(document, "script", "twitter-wjs");
  window.twttr.ready(function (twttr) {
    twttr.events.bind('rendered', onWidgetRendered);
    onReady(twttr);
  });
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/remoteFrame/placeholder.js
function placeholder_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { placeholder_typeof = function _typeof(obj) { return typeof obj; }; } else { placeholder_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return placeholder_typeof(obj); }













function placeholder_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function placeholder_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function placeholder_createClass(Constructor, protoProps, staticProps) { if (protoProps) placeholder_defineProperties(Constructor.prototype, protoProps); if (staticProps) placeholder_defineProperties(Constructor, staticProps); return Constructor; }
function placeholder_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) placeholder_setPrototypeOf(subClass, superClass); }
function placeholder_setPrototypeOf(o, p) { placeholder_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return placeholder_setPrototypeOf(o, p); }
function placeholder_createSuper(Derived) { var hasNativeReflectConstruct = placeholder_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = placeholder_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = placeholder_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return placeholder_possibleConstructorReturn(this, result); }; }
function placeholder_possibleConstructorReturn(self, call) { if (call && (placeholder_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return placeholder_assertThisInitialized(self); }
function placeholder_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function placeholder_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function placeholder_getPrototypeOf(o) { placeholder_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return placeholder_getPrototypeOf(o); }
function placeholder_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var placeholder_isEnterKey = (0,lib/* default */.ZP)('enter');
var placeholder_isEscKey = (0,lib/* default */.ZP)('esc');
var RemoteFramePlaceholder = /*#__PURE__*/function (_Component) {
  placeholder_inherits(RemoteFramePlaceholder, _Component);
  var _super = placeholder_createSuper(RemoteFramePlaceholder);
  function RemoteFramePlaceholder(_props) {
    var _this;
    placeholder_classCallCheck(this, RemoteFramePlaceholder);
    _this = _super.call(this, _props);
    placeholder_defineProperty(placeholder_assertThisInitialized(_this), "onInputRef", function (node) {
      _this.inputNode = node;
      if (node) {
        _this.props.onInputRef(node);
      }
    });
    placeholder_defineProperty(placeholder_assertThisInitialized(_this), "onChangeInputRef", function (node) {
      _this.changeInputNode = node;
      if (node) {
        _this.props.onInputRef(node);
      }
    });
    placeholder_defineProperty(placeholder_assertThisInitialized(_this), "onErrorInputRef", function (node) {
      _this.errorInputNode = node;
      if (node) {
        _this.props.onInputRef(node);
      }
    });
    placeholder_defineProperty(placeholder_assertThisInitialized(_this), "onBufferRef", function (node) {
      _this.bufferNode = node;
    });
    placeholder_defineProperty(placeholder_assertThisInitialized(_this), "onPlaceholderMouseDown", function (event) {
      event.preventDefault();
      _this.inputNode.focus();
    });
    placeholder_defineProperty(placeholder_assertThisInitialized(_this), "onAbortClick", function (event) {
      event.preventDefault();
      event.stopPropagation();
      _this.setState(function () {
        return {
          savedValue: '',
          showError: false
        };
      }, function () {
        _this.inputNode.focus();
      });
    });
    placeholder_defineProperty(placeholder_assertThisInitialized(_this), "onRemoveClick", function (event) {
      event.preventDefault();
      event.stopPropagation();
      _this.props.blot.remove();
    });
    placeholder_defineProperty(placeholder_assertThisInitialized(_this), "onErrorWrapperClick", function (event) {
      if (event.target === _this.errorInputNode) return;
      if (_this.errorInputNode) {
        _this.errorInputNode.select();
      }
    });
    placeholder_defineProperty(placeholder_assertThisInitialized(_this), "onInput", function (event) {
      var value = event.target.value;
      _this.setState(function () {
        return {
          savedValue: value,
          showError: false
        };
      });
    });
    placeholder_defineProperty(placeholder_assertThisInitialized(_this), "onPaste", function (event) {
      event.preventDefault();
      event.stopPropagation();
      var urlValue = event.clipboardData.getData('text/plain').trim();
      //сохраняем значение и разрешаем показывать ошибки на случай если вставленная строка не пройдет проверку url
      _this.setState(function () {
        return {
          savedValue: urlValue,
          showError: true
        };
      }, function () {
        _this.props.onApplySource(urlValue);
      });
    });
    placeholder_defineProperty(placeholder_assertThisInitialized(_this), "onCopy", function (event) {
      event.stopPropagation();
    });
    placeholder_defineProperty(placeholder_assertThisInitialized(_this), "onKeyDown", function (event) {
      event.stopPropagation();
      if (placeholder_isEnterKey(event)) {
        event.preventDefault();
        if (event.target.value === '') return;
        _this.state.showError = true;
        _this.props.onApplySource(event.target.value);
      }
      if (placeholder_isEscKey(event)) {
        event.preventDefault();
        if (_this.props.changeLink && _this.props.onEscape) {
          _this.props.onEscape(event);
        } else if (_this.props.onSourceInputCancel) {
          _this.props.onSourceInputCancel();
        }
      }
    });
    placeholder_defineProperty(placeholder_assertThisInitialized(_this), "convertTo", function (props) {
      return _this.props.blot.editor.exec('convert-blot', props);
    });
    placeholder_defineProperty(placeholder_assertThisInitialized(_this), "convertToBookmark", function () {
      return _this.convertTo({
        type: 'bookmark',
        src: _this.props.blot.map.get('src'),
        replaceBlotId: _this.props.blot.id
      });
    });
    placeholder_defineProperty(placeholder_assertThisInitialized(_this), "convertToLink", function () {
      return _this.convertTo({
        type: 'paragraph',
        focusIndex: _this.props.blot.map.get('src').length
      });
    });
    var editor = _props.blot.editor;
    var editMode = editor.mode === editor.constructor.MODE_EDIT;
    _this.state = {
      savedValue: null,
      showError: false,
      editMode: editMode
    };
    return _this;
  }
  placeholder_createClass(RemoteFramePlaceholder, [{
    key: "getPlaceholderText",
    value: function getPlaceholderText() {
      var blot = this.props.blot;
      if (blot.getWrapper().parent.constructor.blotName === 'gridCol') {
        return blot.editor.plugins.i18n.get('remote_frame.placeholder_small');
      } else {
        return blot.editor.plugins.i18n.get('remote_frame.placeholder_full');
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!this.state.editMode) return;
      if (this.inputNode && this.bufferNode && !this.props.changeLink) {
        this.inputNode.style.width = this.bufferNode.clientWidth + 10 + 'px';
      }
      if (this.props.blot.props.focused) {
        var input = this.changeInputNode || this.inputNode || this.errorInputNode;
        if (document.activeElement !== input) {
          input.select();
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.errorInputNode) {
        this.errorInputNode.select();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.onInputRef(null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        blot = _this$props.blot,
        error = _this$props.error,
        src = _this$props.src,
        changeLink = _this$props.changeLink,
        showConvertButtonsOnError = _this$props.showConvertButtonsOnError;
      var _this$state = this.state,
        savedValue = _this$state.savedValue,
        showError = _this$state.showError,
        editMode = _this$state.editMode;
      var inputValue = src || '';
      if (savedValue !== null) {
        inputValue = savedValue;
      }
      var placeholder = !Boolean(inputValue);
      var placeholderNode = null;
      var errorNode = null;
      var bufferNode = null;
      var abortNode = null;
      var phAbortNode = null;
      if (changeLink) {
        if (error) {
          errorNode = (0,preact_module.h)("div", {
            className: "embed-error"
          }, blot.editor.plugins.i18n.get(error.errorKey));
        }
        return (0,preact_module.h)("div", {
          className: "add-embed change-link"
        }, errorNode, (0,preact_module.h)("div", {
          className: "add-embed-input"
        }, (0,preact_module.h)("input", {
          type: "text",
          style: {
            width: '100%'
          },
          ref: this.onChangeInputRef,
          onKeyDown: this.onKeyDown,
          onInput: this.onInput,
          onPaste: this.onPaste,
          onCopy: this.onCopy,
          value: inputValue
        })));
      } else if (!error || error.errorType === 'url') {
        bufferNode = (0,preact_module.h)("div", {
          className: "buffer-text",
          ref: this.onBufferRef,
          dangerouslySetInnerHTML: {
            __html: escapeHtml(inputValue).replace(/ /g, '&nbsp;')
          }
        });
        if (placeholder) {
          phAbortNode = (0,preact_module.h)("div", {
            className: "clear-input",
            onClick: this.onRemoveClick
          }, (0,preact_module.h)(icons/* IconTrash */.IT9, null));
          placeholderNode = (0,preact_module.h)("div", {
            className: "embed-placeholder",
            onMouseDown: this.onPlaceholderMouseDown
          }, this.getPlaceholderText(), phAbortNode);
        } else {
          abortNode = (0,preact_module.h)("div", {
            className: "clear-input",
            onClick: this.onAbortClick
          }, (0,preact_module.h)(icons/* IconTrash */.IT9, null));
        }
        if (error) {
          var errorStyles = {};
          if (!showError) {
            errorStyles.display = 'none';
          }
          errorNode = (0,preact_module.h)("div", {
            style: errorStyles,
            className: "embed-error"
          }, blot.editor.plugins.i18n.get(error.errorKey));
        }
        return (0,preact_module.h)("div", {
          className: "add-embed"
        }, errorNode, (0,preact_module.h)("div", {
          className: "add-embed-input"
        }, bufferNode, (0,preact_module.h)("input", {
          type: "text",
          ref: this.onInputRef,
          onKeyDown: this.onKeyDown,
          onInput: this.onInput,
          onPaste: this.onPaste,
          onCopy: this.onCopy,
          value: inputValue,
          class: "embed-input"
        }), abortNode), placeholderNode);
      } else {
        //тут ошибку засетил через функцию в див, потому что в переводах есть html, если этого делать нельзя то в ошибке почта не будет ссылкой...
        errorNode = (0,preact_module.h)("div", {
          className: 'bottom-error' + (showConvertButtonsOnError ? ' with-buttons' : '')
        }, (0,preact_module.h)("div", {
          className: "error-icon"
        }, (0,preact_module.h)(icons/* IconCloudError */.CYl, null)), (0,preact_module.h)("div", {
          className: "embed-error",
          dangerouslySetInnerHTML: {
            __html: blot.editor.plugins.i18n.get(error.errorKey)
          }
        }), editMode && showConvertButtonsOnError ? (0,preact_module.h)("div", {
          className: "embed-buttons"
        }, [{
          method: this.convertToBookmark,
          translate: 'remote_frame.convert_bookmark'
        }, {
          method: this.convertToLink,
          translate: 'remote_frame.convert_link'
        }].map(function (_ref) {
          var method = _ref.method,
            translate = _ref.translate;
          return (0,preact_module.h)("button", {
            class: "chrome-button",
            onClick: method
          }, blot.editor.plugins.i18n.get(translate));
        })) : null);
        return (0,preact_module.h)("div", {
          className: "add-embed error-loading",
          onClick: this.onErrorWrapperClick
        }, editMode ? (0,preact_module.h)("input", {
          type: "text",
          placeholder: blot.editor.plugins.i18n.get('remote_frame.placeholder_full'),
          ref: this.onErrorInputRef,
          onKeyDown: this.onKeyDown,
          onInput: this.onInput,
          onPaste: this.onPaste,
          onCopy: this.onCopy,
          value: inputValue
        }) : (0,preact_module.h)("div", {
          className: "error-loading-input-readonly"
        }, inputValue), errorNode);
      }
    }
  }]);
  return RemoteFramePlaceholder;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/remoteFrame/internalLinkError.js
function internalLinkError_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function internalLinkError_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function internalLinkError_createClass(Constructor, protoProps, staticProps) { if (protoProps) internalLinkError_defineProperties(Constructor.prototype, protoProps); if (staticProps) internalLinkError_defineProperties(Constructor, staticProps); return Constructor; }


var RemoteFrameInternalLinkError = /*#__PURE__*/function () {
  function RemoteFrameInternalLinkError() {
    internalLinkError_classCallCheck(this, RemoteFrameInternalLinkError);
  }
  internalLinkError_createClass(RemoteFrameInternalLinkError, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        message = _this$props.message,
        onBackCkick = _this$props.onBackCkick,
        backButtonText = _this$props.backButtonText;
      return (0,preact_module.h)("div", {
        className: "add-embed error-loading internal-link-error"
      }, (0,preact_module.h)("div", {
        className: "bottom-error"
      }, (0,preact_module.h)("div", {
        className: "error-icon"
      }, (0,preact_module.h)(icons/* IconCloudError */.CYl, null)), (0,preact_module.h)("div", {
        className: "embed-error"
      }, message), (0,preact_module.h)("div", {
        className: "embed-buttons"
      }, (0,preact_module.h)("button", {
        class: "chrome-button",
        onClick: onBackCkick
      }, backButtonText))));
    }
  }]);
  return RemoteFrameInternalLinkError;
}();

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array-buffer.constructor.js
var es_array_buffer_constructor = __webpack_require__(18264);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/signature/index.js
function signature_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { signature_typeof = function _typeof(obj) { return typeof obj; }; } else { signature_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return signature_typeof(obj); }
function signature_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function signature_createClass(Constructor, protoProps, staticProps) { if (protoProps) signature_defineProperties(Constructor.prototype, protoProps); if (staticProps) signature_defineProperties(Constructor, staticProps); return Constructor; }
function signature_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function signature_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function signature_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) signature_setPrototypeOf(subClass, superClass); }
function signature_createSuper(Derived) { var hasNativeReflectConstruct = signature_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = signature_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = signature_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return signature_possibleConstructorReturn(this, result); }; }
function signature_possibleConstructorReturn(self, call) { if (call && (signature_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return signature_assertThisInitialized(self); }
function signature_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function signature_wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; signature_wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !signature_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return signature_construct(Class, arguments, signature_getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return signature_setPrototypeOf(Wrapper, Class); }; return signature_wrapNativeSuper(Class); }
function signature_construct(Parent, args, Class) { if (signature_isNativeReflectConstruct()) { signature_construct = Reflect.construct; } else { signature_construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) signature_setPrototypeOf(instance, Class.prototype); return instance; }; } return signature_construct.apply(null, arguments); }
function signature_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function signature_isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function signature_setPrototypeOf(o, p) { signature_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return signature_setPrototypeOf(o, p); }
function signature_getPrototypeOf(o) { signature_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return signature_getPrototypeOf(o); }




































/**
 * чтобы избежать подстановки произвольного содержмого в HTML блот мы подписываем контент на сервере с помощью приватного ключа,
 * а в редакторе проверяем верность сигнатуры с помощью публичного ключа
 */

function str2ab(str) {
  str = window.atob(str);
  var buf = new ArrayBuffer(str.length);
  var bufView = new Uint8Array(buf);
  for (var i = 0, strLen = str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
}
var CryptoIncompatibleError = /*#__PURE__*/function (_Error) {
  signature_inherits(CryptoIncompatibleError, _Error);
  var _super = signature_createSuper(CryptoIncompatibleError);
  function CryptoIncompatibleError() {
    signature_classCallCheck(this, CryptoIncompatibleError);
    return _super.apply(this, arguments);
  }
  return CryptoIncompatibleError;
}( /*#__PURE__*/signature_wrapNativeSuper(Error));
var Signature = /*#__PURE__*/function () {
  function Signature(_ref) {
    var scroll = _ref.scroll,
      editor = _ref.editor,
      options = _ref.options;
    signature_classCallCheck(this, Signature);
    signature_defineProperty(this, "CryptoIncompatibleError", CryptoIncompatibleError);
    this.options = options || {};
    this.enableVerify = this.options.verify === false ? false : true;
    this.publicKey = this.options.publicKey;
  }
  signature_createClass(Signature, [{
    key: "verifySignature",
    value: function verifySignature(content, signatureBase64) {
      var _this = this;
      return new Promise(function (resolve, reject) {
        if (!_this.enableVerify) {
          resolve(true);
        }
        if (!window.crypto) {
          reject(new CryptoIncompatibleError('no window.crypto'));
        }
        if (!window.crypto.subtle || !window.crypto.subtle.importKey || !window.crypto.subtle.verify) {
          reject(new CryptoIncompatibleError('no window.crypto or it does not have importKey or verify methods'));
        }
        if (!window.TextEncoder) {
          reject(new CryptoIncompatibleError('no window.TextEncoder'));
        }
        if (!window.Uint8Array) {
          reject(new CryptoIncompatibleError('no window.Uint8Array'));
        }
        var derPublicKey = _this.publicKey;
        var enc = new TextEncoder();
        var contentEncoded = enc.encode(content);
        var pubkBuf = str2ab(derPublicKey);
        crypto.subtle.importKey("spki", pubkBuf, {
          name: "RSASSA-PKCS1-v1_5",
          // Consider using a 4096-bit key for systems that require long-term security
          modulusLength: 2048,
          publicExponent: new Uint8Array([1, 0, 1]),
          hash: "SHA-256"
        }, true, ["verify"]).then(function (pubk) {
          var signature = new Uint8Array(str2ab(signatureBase64));
          window.crypto.subtle.verify({
            name: "RSASSA-PKCS1-v1_5",
            saltLength: 32
          }, pubk, signature, contentEncoded).then(function (result) {
            resolve(result);
          }).catch(function (error) {
            reject(error);
          });
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }]);
  return Signature;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/errors/iframeNotSupportedError.js
function iframeNotSupportedError_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { iframeNotSupportedError_typeof = function _typeof(obj) { return typeof obj; }; } else { iframeNotSupportedError_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return iframeNotSupportedError_typeof(obj); }











function iframeNotSupportedError_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function iframeNotSupportedError_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) iframeNotSupportedError_setPrototypeOf(subClass, superClass); }
function iframeNotSupportedError_createSuper(Derived) { var hasNativeReflectConstruct = iframeNotSupportedError_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = iframeNotSupportedError_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = iframeNotSupportedError_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return iframeNotSupportedError_possibleConstructorReturn(this, result); }; }
function iframeNotSupportedError_possibleConstructorReturn(self, call) { if (call && (iframeNotSupportedError_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return iframeNotSupportedError_assertThisInitialized(self); }
function iframeNotSupportedError_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function iframeNotSupportedError_wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; iframeNotSupportedError_wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !iframeNotSupportedError_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return iframeNotSupportedError_construct(Class, arguments, iframeNotSupportedError_getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return iframeNotSupportedError_setPrototypeOf(Wrapper, Class); }; return iframeNotSupportedError_wrapNativeSuper(Class); }
function iframeNotSupportedError_construct(Parent, args, Class) { if (iframeNotSupportedError_isNativeReflectConstruct()) { iframeNotSupportedError_construct = Reflect.construct; } else { iframeNotSupportedError_construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) iframeNotSupportedError_setPrototypeOf(instance, Class.prototype); return instance; }; } return iframeNotSupportedError_construct.apply(null, arguments); }
function iframeNotSupportedError_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function iframeNotSupportedError_isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function iframeNotSupportedError_setPrototypeOf(o, p) { iframeNotSupportedError_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return iframeNotSupportedError_setPrototypeOf(o, p); }
function iframeNotSupportedError_getPrototypeOf(o) { iframeNotSupportedError_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return iframeNotSupportedError_getPrototypeOf(o); }
var IframeNotSupportedError = /*#__PURE__*/function (_Error) {
  iframeNotSupportedError_inherits(IframeNotSupportedError, _Error);
  var _super = iframeNotSupportedError_createSuper(IframeNotSupportedError);
  function IframeNotSupportedError() {
    iframeNotSupportedError_classCallCheck(this, IframeNotSupportedError);
    return _super.apply(this, arguments);
  }
  return IframeNotSupportedError;
}( /*#__PURE__*/iframeNotSupportedError_wrapNativeSuper(Error));

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/remoteFrame/remoteFrame.js
function remoteFrame_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { remoteFrame_typeof = function _typeof(obj) { return typeof obj; }; } else { remoteFrame_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return remoteFrame_typeof(obj); }
function remoteFrame_slicedToArray(arr, i) { return remoteFrame_arrayWithHoles(arr) || remoteFrame_iterableToArrayLimit(arr, i) || remoteFrame_unsupportedIterableToArray(arr, i) || remoteFrame_nonIterableRest(); }
function remoteFrame_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function remoteFrame_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return remoteFrame_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return remoteFrame_arrayLikeToArray(o, minLen); }
function remoteFrame_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function remoteFrame_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function remoteFrame_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function remoteFrame_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function remoteFrame_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { remoteFrame_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { remoteFrame_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
























function remoteFrame_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function remoteFrame_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function remoteFrame_createClass(Constructor, protoProps, staticProps) { if (protoProps) remoteFrame_defineProperties(Constructor.prototype, protoProps); if (staticProps) remoteFrame_defineProperties(Constructor, staticProps); return Constructor; }
function remoteFrame_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) remoteFrame_setPrototypeOf(subClass, superClass); }
function remoteFrame_setPrototypeOf(o, p) { remoteFrame_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return remoteFrame_setPrototypeOf(o, p); }
function remoteFrame_createSuper(Derived) { var hasNativeReflectConstruct = remoteFrame_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = remoteFrame_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = remoteFrame_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return remoteFrame_possibleConstructorReturn(this, result); }; }
function remoteFrame_possibleConstructorReturn(self, call) { if (call && (remoteFrame_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return remoteFrame_assertThisInitialized(self); }
function remoteFrame_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function remoteFrame_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function remoteFrame_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { remoteFrame_get = Reflect.get; } else { remoteFrame_get = function _get(target, property, receiver) { var base = remoteFrame_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return remoteFrame_get(target, property, receiver || target); }
function remoteFrame_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = remoteFrame_getPrototypeOf(object); if (object === null) break; } return object; }
function remoteFrame_getPrototypeOf(o) { remoteFrame_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return remoteFrame_getPrototypeOf(o); }
function remoteFrame_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }































var remoteFrame_isEscKey = (0,lib/* default */.ZP)('escape');
var REMOTE_FRAME_CLASS = 'remote-frame';
var REMOTE_FRAME_CONTAINER_CLASS = 'remote-frame-container';
var MIN_WIDTH_FOR_SHOW_CONVERT_BUTTONS = 450;
var remoteFrame_mixin = mix([commentable, withCaption, blotLock, fullWidth, resizeable, embeddable, draggable, selectable, focusable, executable, basic]);
var getFrameType = function getFrameType(src) {
  var result = null;
  for (var key in remoteFrameOptions_frames) {
    if (remoteFrameOptions_frames[key].pattern && remoteFrameOptions_frames[key].pattern.test(src)) {
      result = key;
      break;
    }
  }
  return result;
};
var getWidgetType = function getWidgetType(src) {
  var result = null;
  for (var key in widgets) {
    if (widgets[key].pattern && widgets[key].pattern.test(src)) {
      result = key;
      break;
    }
  }
  return result;
};
var isSkipIframelyEmbed = function isSkipIframelyEmbed(src) {
  var asName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var result = null;
  for (var key in skipIframelyEmbeds) {
    if (skipIframelyEmbeds[key].pattern && skipIframelyEmbeds[key].pattern.test(src)) {
      if (asName) {
        result = key;
      } else {
        result = true;
      }
      break;
    }
  }
  return result;
};
var isSkipXFOSupportEmbed = function isSkipXFOSupportEmbed(src) {
  var result = null;
  for (var key in skipXFOSupport) {
    if (skipXFOSupport[key].pattern && skipXFOSupport[key].pattern.test(src)) {
      result = key;
      break;
    }
  }
  return result;
};
var RemoteFrame = /*#__PURE__*/function (_mixin) {
  remoteFrame_inherits(RemoteFrame, _mixin);
  var _super = remoteFrame_createSuper(RemoteFrame);
  function RemoteFrame(domNode) {
    var _thisSuper, _this;
    remoteFrame_classCallCheck(this, RemoteFrame);
    _this = _super.call(this, domNode);
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "mapObserver", function () {
      _this.render();
    });
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "onStartNeditSelection", function () {
      _this.domNode.classList.add('locked-mouseover');
    });
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "onEndNeditSelection", function () {
      _this.domNode.classList.remove('locked-mouseover');
    });
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "clearFrame", function () {
      //задаем props для рендера плейсхолдера не через setProps, чтобы не вызвать двойного рендера, потому что изменение в map вызовет рендер
      _this.map.set('src', null);
      _this.map.delete('html');
      _this.map.delete('embed-type');
      _this.map.delete('width');
      _this.map.delete('directUrl');
      _this.map.delete('originalSize');
      _this.map.delete('origin');
    });
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "copyOriginal", function () {
      var string = _this.map.get('origin') || _this.map.get('src');
      _this.editor.plugins.copyManager.copy(string);
    });
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "changeLink", function () {
      _this.setProps({
        changeLink: true
      });
      _this.inputNode.select();
    });
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "onFullSize", function () {
      _this.frameNode.requestFullscreen();
      document.addEventListener('keydown', _this.onFullSizeDocumentKeyDown, false);
    });
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "onFullSizeDocumentKeyDown", function (event) {
      if (remoteFrame_isEscKey(event)) {
        event.preventDefault();
        document.exitFullscreen();
        document.removeEventListener('keydown', _this.onFullSizeDocumentKeyDown, false);
      }
    });
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "onResetSize", /*#__PURE__*/remoteFrame_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var originalSize, _ref2, width, ratio;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              originalSize = _this.map.get('originalSize');
              if (originalSize) {
                _context.next = 5;
                break;
              }
              _context.next = 4;
              return _this.getContentSize();
            case 4:
              originalSize = _context.sent;
            case 5:
              _ref2 = originalSize ? originalSize : {
                ratio: 16 / 9
              }, width = _ref2.width, ratio = _ref2.ratio;
              _this.renderInBatch(function () {
                if (width) {
                  _this.map.set('width', width);
                } else {
                  _this.map.delete('width');
                }
                if (!ratio) {
                  ratio = 16 / 9;
                }
                _this.map.set('ratio', ratio);
                _this.setResizeContainerSize({
                  width: !width ? _this.scroll.domNode.getBoundingClientRect().width : width,
                  ratio: ratio
                });
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "onApplySource", function (string) {
      string = string.replace(/”/g, '"');
      var isSpecEmbedSrc = isSpecEmbed(string); //возможно в будущем надо будет все подобные распознавалки в массив закинуть и чекать одной функцией
      var src = isSpecEmbedSrc || deserializeEmbedString(string);
      if (!src || src instanceof Object) {
        if (widgets.script.pattern.test(string)) {
          _this.renderInBatch(function () {
            _this.setProps({
              setEmbedError: false,
              changeLink: false
            });
            _this.map.set('embed-type', 'script');
            _this.map.delete('html');
            _this.map.set('src', string);
            _this.map.delete('originalSize');
            _this.map.set('origin', string);
          });
          _this.putCaretInNextBlotAfterEmbed();
          return;
        }
      }
      //тут проверяем если линк на pdf и реализована функция загрузки аттачей по URL, конвертируем в файл
      if (isLinkToPdfFile(src) && _this.editor.plugins.attachmentManager.options.chooseFileFromUrl) {
        var fileId = _this.parent.addBlot('file', {
          before: _this.id
        }).id;
        var file = _this.editor.findById(fileId);
        file.embedAttachmentUrl(src);
        _this.putCaretInNextBlotAfterEmbed();
        _this.remove();
      } else if (src instanceof Object) {
        _this.setProps({
          setEmbedError: src
        });
      } else {
        _this.renderInBatch(function () {
          _this.setProps({
            setEmbedError: false,
            changeLink: false
          });
          _this.map.delete('embed-type');
          _this.map.delete('html');
          _this.map.delete('originalSize');
          _this.map.set('src', src);
          _this.map.set('origin', string);
        });
        _this.putCaretInNextBlotAfterEmbed();
      }
    });
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "onInputRef", function (node) {
      _this.inputNode = node;
    });
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "onFrameRef", function (node) {
      _this.frameNode = node;
    });
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "onFrameLoadError", function () {
      var type = _this.map.get('embed-type');
      var messageKey = 'content_error';
      if (remoteFrameOptions_frames[type] && remoteFrameOptions_frames[type].errorMessageKey) {
        messageKey = remoteFrameOptions_frames[type].errorMessageKey;
      }
      _this.setProps({
        setEmbedError: {
          errorType: 'content',
          errorKey: 'remote_frame.error.' + messageKey
        }
      });
    });
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "onPlaceholderEscapeKeyDown", function () {
      var changeLink = _this.props.changeLink;
      if (changeLink) {
        _this.setProps({
          changeLink: false
        });
      }
    });
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "onInternalLinkError", function () {
      _this.setProps({
        internalLinkError: true
      });
    });
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "onInternalLinkErrorBackClick", function () {
      _this.setProps({
        internalLinkError: false
      });
    });
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "renderFrame", /*#__PURE__*/remoteFrame_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var type, src, frameOptions, html, signature, verifyRes;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              type = _this.map.get('embed-type');
              src = _this.map.get('src');
              frameOptions = remoteFrameOptions_frames[type];
              if (!frameOptions) {
                frameOptions = widgets[type];
              }
              if (!frameOptions) {
                frameOptions = {};
              }
              html = _this.map.get('html');
              signature = _this.map.get('signature');
              if (!(type === 'unknown' || _this.map.get('directUrl'))) {
                _context2.next = 22;
                break;
              }
              _context2.prev = 8;
              _context2.next = 11;
              return _this.editor.plugins.signature.verifySignature(html, signature);
            case 11:
              verifyRes = _context2.sent;
              if (verifyRes) {
                _context2.next = 14;
                break;
              }
              throw new Error('signature does not match the content');
            case 14:
              _context2.next = 22;
              break;
            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](8);
              _this.editor.plugins.debugLogger.captureException(_context2.t0);
              // сетим ошибку только в случае если тип фрейма не определен, или применен вид фрейма из iframely (см. Google Docs)
              if (!(!remoteFrameOptions_frames[type] || _this.map.get('directUrl'))) {
                _context2.next = 22;
                break;
              }
              _this.setProps({
                setEmbedError: {
                  errorType: 'content',
                  errorKey: 'remote_frame.error.wrong_signature'
                }
              });
              return _context2.abrupt("return", null);
            case 22:
              return _context2.abrupt("return", (0,preact_module.h)(RemoteFrameComponent, {
                src: src,
                type: type,
                html: html,
                onDomRef: _this.onFrameRef,
                addClassName: type + '-embed-frame',
                getFrameOriginalSizeFromHtml: _this.getFrameOriginalSizeFromHtml,
                skipErrorLoading: isSkipIframelyEmbed(src),
                frameOptions: frameOptions,
                onFrameLoadError: _this.onFrameLoadError,
                isDirectUrl: _this.map.get('directUrl'),
                editMode: _this.editor.mode === _this.editor.constructor.MODE_EDIT,
                i18n: _this.editor.plugins.i18n,
                clearFrame: _this.clearFrame,
                theme: _this.editor.plugins.editorStyle.getTheme(),
                onInternalLinkError: _this.onInternalLinkError,
                editor: _this.editor,
                blot: remoteFrame_assertThisInitialized(_this)
              }));
            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[8, 16]]);
    })));
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "render", /*#__PURE__*/remoteFrame_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var nodeToRender;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!_this.ignoringUpdateRender) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              remoteFrame_get((_thisSuper = remoteFrame_assertThisInitialized(_this), remoteFrame_getPrototypeOf(RemoteFrame.prototype)), "render", _thisSuper).call(_thisSuper);
              _this.getWrapper().render();
              if (!(!_this.map.get('src') && _this.editor.mode !== _this.editor.constructor.MODE_EDIT)) {
                _context3.next = 6;
                break;
              }
              return _context3.abrupt("return");
            case 6:
              nodeToRender = null;
              if (!(!_this.hasEmbed() || _this.props.setEmbedError || _this.props.changeLink)) {
                _context3.next = 11;
                break;
              }
              if (!_this.frameContainer.classList.contains('placeholder')) {
                _this.frameContainer.classList.add('placeholder');
              }
              _context3.next = 25;
              break;
            case 11:
              if (_this.frameContainer.classList.contains('placeholder')) {
                _this.frameContainer.classList.remove('placeholder');
              }
              if (_this.isTypeDefined()) {
                _context3.next = 17;
                break;
              }
              nodeToRender = _this.renderLoader();
              _this.defineType();
              _context3.next = 25;
              break;
            case 17:
              if (!_this.props.internalLinkError) {
                _context3.next = 21;
                break;
              }
              nodeToRender = _this.renderInternalLinkError();
              _context3.next = 25;
              break;
            case 21:
              _context3.next = 23;
              return _this.renderFrame();
            case 23:
              nodeToRender = _context3.sent;
              _this.frameContainer.classList.add(_this.map.get('embed-type') + '-embed');
            case 25:
              if (!nodeToRender) {
                nodeToRender = _this.renderPlaceholder();
                if (_this.props.isContentRendered) {
                  _this.setProps({
                    isContentRendered: false
                  });
                }
              } else if (!_this.props.isContentRendered) {
                _this.setProps({
                  isContentRendered: true
                });
              }
              (0,preact_module/* render */.sY)(nodeToRender, _this.frameContainer);
            case 27:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "onSrcInputCancel", function () {
      _this.putCaretInEmptyParagraphAfterEmbed();
      _this.remove();
    });
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "fetchIframelyEmbedHtml", /*#__PURE__*/function () {
      var _ref5 = remoteFrame_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(src) {
        var isTypeDefined,
          type,
          _this$blotConfig,
          iframelyHost,
          iframelyPort,
          requestUrl,
          iframeSupportRequestUrl,
          isIframelyResponseSuccess,
          response,
          isHtmlResolved,
          body,
          html,
          html_signature,
          _body$meta,
          canonical,
          iframeSupportResponse,
          _args4 = arguments;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                isTypeDefined = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : false;
                if (!_this._iframelyFetchInProgress) {
                  _context4.next = 3;
                  break;
                }
                return _context4.abrupt("return");
              case 3:
                _this._iframelyFetchInProgress = true;
                type = _this.map.get('embed-type');
                _this$blotConfig = _this.blotConfig, iframelyHost = _this$blotConfig.iframelyHost, iframelyPort = _this$blotConfig.iframelyPort;
                requestUrl = iframelyHost + (iframelyPort ? ':' + iframelyPort : '') + '/iframely?url=' + decodeURI(src);
                iframeSupportRequestUrl = iframelyHost + (iframelyPort ? ':' + iframelyPort : '') + '/support-iframe?url=' + decodeURI(src);
                isIframelyResponseSuccess = false;
                _context4.prev = 9;
                _context4.next = 12;
                return fetch(requestUrl);
              case 12:
                response = _context4.sent;
                // если запрос на Iframely server прошел успешно, обрабатываем результат запроса
                isHtmlResolved = false;
                if (!(response.status === 200)) {
                  _context4.next = 21;
                  break;
                }
                isIframelyResponseSuccess = true;
                _context4.next = 18;
                return response.json();
              case 18:
                body = _context4.sent;
                html = body.html, html_signature = body.html_signature;
                if (html && html_signature) {
                  isHtmlResolved = true;
                  _this.renderInBatch(function () {
                    if (!isTypeDefined) {
                      _this.map.set('embed-type', 'unknown');
                    }
                    _this.map.set('signature', html_signature);
                    _this.map.set('html', html);
                  });
                } else {
                  canonical = body === null || body === void 0 ? void 0 : (_body$meta = body.meta) === null || _body$meta === void 0 ? void 0 : _body$meta.canonical;
                  if (canonical && widgets.onedrive.pattern.test(canonical)) {
                    isHtmlResolved = true;
                    _this.renderInBatch(function () {
                      _this.map.set('embed-type', 'onedrive');
                      _this.map.set('src', canonical);
                    });
                  }
                }
              case 21:
                if (isHtmlResolved) {
                  _context4.next = 38;
                  break;
                }
                if (isSkipXFOSupportEmbed(src)) {
                  _context4.next = 37;
                  break;
                }
                _context4.next = 25;
                return fetch(iframeSupportRequestUrl);
              case 25:
                iframeSupportResponse = _context4.sent;
                if (!(iframeSupportResponse.status !== 200)) {
                  _context4.next = 28;
                  break;
                }
                throw new IframeNotSupportedError('Cannot fetch embed from Iframely, response status ' + response.status);
              case 28:
                _context4.next = 30;
                return iframeSupportResponse.json();
              case 30:
                if (!_context4.sent) {
                  _context4.next = 34;
                  break;
                }
                throw new Error('Request did not return embed or content is corrupted, insert url into iframe as is');
              case 34:
                throw new IframeNotSupportedError('Request did not return embed and url is not supported iframe render');
              case 35:
                _context4.next = 38;
                break;
              case 37:
                throw new Error('Request did not return embed or content is corrupted, insert url into iframe as is');
              case 38:
                _context4.next = 44;
                break;
              case 40:
                _context4.prev = 40;
                _context4.t0 = _context4["catch"](9);
                console.warn(_context4.t0.name + ': ' + _context4.t0.message);
                if (isTypeDefined) {
                  if (remoteFrameOptions_frames[type] && remoteFrameOptions_frames[type].errorMessageKey) {
                    _this.setProps({
                      setEmbedError: {
                        errorType: 'content',
                        errorKey: 'remote_frame.error.' + remoteFrameOptions_frames[type].errorMessageKey
                      }
                    });
                  }
                } else {
                  if (_context4.t0 instanceof IframeNotSupportedError) {
                    if (isIframelyResponseSuccess) {
                      _this.renderInBatch(function () {
                        _this.map.set('embed-type', 'card');
                        _this.map.set('src', src);
                      });
                    } else {
                      _this.onFrameLoadError();
                      _this.map.set('embed-type', 'not-supported');
                    }
                  } else {
                    _this.map.set('embed-type', 'other');
                  }
                }
              case 44:
                _context4.prev = 44;
                _this._iframelyFetchInProgress = false;
                return _context4.finish(44);
              case 47:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[9, 40, 44, 47]]);
      }));
      return function (_x) {
        return _ref5.apply(this, arguments);
      };
    }());
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "openOrigin", function () {
      var type = _this.map.get('embed-type');
      var url = _this.map.get('src');
      if (remoteFrameOptions_frames[type] && remoteFrameOptions_frames[type].getOriginUrl) {
        url = remoteFrameOptions_frames[type].getOriginUrl(url);
      } else if (widgets[type] && widgets[type].getOriginUrl) {
        url = widgets[type].getOriginUrl(url);
      }
      if (!_this.editor.plugins.linkManager.processNavigation(url)) {
        window.open(url, '_blank', 'noopener');
      }
    });
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "switchLayout", function () {
      var currentLayout = _this.map.get('directUrl');
      _this.map.set('directUrl', !currentLayout);
    });
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "getContentSize", /*#__PURE__*/remoteFrame_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var services, type, width, ratio, html, size;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              services = Object.assign({}, remoteFrameOptions_frames, widgets);
              type = _this.map.get('embed-type');
              if (!services[type]) {
                _context5.next = 7;
                break;
              }
              if (services[type].initialWidth) {
                width = services[type].initialWidth;
              }
              if (services[type].frameRatio) {
                ratio = services[type].frameRatio;
              }
              if (!ratio) {
                _context5.next = 7;
                break;
              }
              return _context5.abrupt("return", {
                width: width,
                ratio: ratio
              });
            case 7:
              html = _this.map.get('html');
              if (!html) {
                _context5.next = 14;
                break;
              }
              _context5.next = 11;
              return _this.getFrameOriginalSizeFromHtml(html);
            case 11:
              size = _context5.sent;
              if (!size) {
                _context5.next = 14;
                break;
              }
              return _context5.abrupt("return", {
                width: size.width,
                ratio: size.width / size.height
              });
            case 14:
              return _context5.abrupt("return", {
                ratio: 16 / 9
              });
            case 15:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })));
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "getFrameOriginalSizeFromHtml", function (html) {
      return new Promise(function (resolve) {
        var isFrame = IFramePattern.test(html);
        if (isFrame) {
          var container = document.createElement('div');
          container.classList.add('hidden-frame-container-for-detect-size');
          container.style.width = _this.scroll.domNode.getBoundingClientRect().width + 'px';
          container.innerHTML = html;
          var iframe = container.querySelector('iframe');
          iframe.onload = function () {
            var _iframe$getBoundingCl = iframe.getBoundingClientRect(),
              width = _iframe$getBoundingCl.width,
              height = _iframe$getBoundingCl.height;
            container.parentNode.removeChild(container);
            resolve({
              width: Math.ceil(width),
              height: Math.ceil(height)
            });
          };
          iframe.onerror = function () {
            container.parentNode.removeChild(container);
            resolve(null);
          };
          document.body.appendChild(container);
        } else {
          resolve(null);
        }
      });
    });
    remoteFrame_defineProperty(remoteFrame_assertThisInitialized(_this), "onRenderContent", function (type) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var services = Object.assign({}, remoteFrameOptions_frames, widgets);
      if (services[type] && services[type].onRenderContent) {
        services[type].onRenderContent(remoteFrame_assertThisInitialized(_this), params);
      }
    });
    _this.isSeparableByClickApplicable = true;
    _this.addCanExecActions(['delete', 'backspace']);
    _this.frameContainer = _this.domNode.querySelector('.' + REMOTE_FRAME_CONTAINER_CLASS);
    _this.disallowReplace = true;
    // фикс для возврата функций рейсайза после выхода из fullWidth
    if (_this.fullWidth) {
      _this.fullWidth.afterFunc = function () {
        setTimeout(function () {
          _this.render();
        }, 0);
      };
    }
    return _this;
  }
  remoteFrame_createClass(RemoteFrame, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = remoteFrame_get(remoteFrame_getPrototypeOf(RemoteFrame.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      if (!this.hasEmbed()) {
        this.props.placeholderVisible = true;
        this.props.inputValue = '';
      }
      this.props.maxAvailableWidth = this.getWrapper().domNode.getBoundingClientRect().width;
      if (this.fullWidth) {
        this.fullWidth = Object.assign(this.fullWidth, {
          wrapperNode: this.getWrapper().domNode
        });
      }
      if (this.isNotSupportedRender()) {
        this.onFrameLoadError();
      }
      this.store.observe(this.map, this.mapObserver);
      this.editor.on('start-nedit-selection', this.onStartNeditSelection);
      this.editor.on('end-nedit-selection', this.onEndNeditSelection);
      this.render();
    }
  }, {
    key: "detach",
    value: function detach() {
      if (remoteFrame_get(remoteFrame_getPrototypeOf(RemoteFrame.prototype), "detach", this)) {
        var _get3;
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        (_get3 = remoteFrame_get(remoteFrame_getPrototypeOf(RemoteFrame.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      }
      this.store.unobserve(this.map, this.mapObserver);
      this.editor.off('start-nedit-selection', this.onStartNeditSelection);
      this.editor.off('end-nedit-selection', this.onEndNeditSelection);
    }
  }, {
    key: "hasEmbed",
    value: function hasEmbed() {
      return Boolean(this.map.get('src'));
    }
  }, {
    key: "isTypeDefined",
    value: function isTypeDefined() {
      return Boolean(this.map.get('embed-type'));
    }
  }, {
    key: "hasEmbedHtml",
    value: function hasEmbedHtml() {
      return Boolean(this.map.get('html'));
    }
  }, {
    key: "isNotSupportedRender",
    value: function isNotSupportedRender() {
      return this.map.get('embed-type') === 'not-supported';
    }
  }, {
    key: "onFocusableFocus",
    value: function onFocusableFocus() {
      var _this2 = this;
      var _this$selection$getRa = this.selection.getRange(),
        _this$selection$getRa2 = remoteFrame_slicedToArray(_this$selection$getRa, 1),
        range = _this$selection$getRa2[0];
      if (!this.hasEmbed() && this.inputNode && (!range || range.length === 0)) {
        setTimeout(function () {
          _this2.inputNode.focus();
        }, 0);
      } else {
        var _get4;
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }
        (_get4 = remoteFrame_get(remoteFrame_getPrototypeOf(RemoteFrame.prototype), "onFocusableFocus", this)).call.apply(_get4, [this].concat(args));
      }
    }
  }, {
    key: "onFocusableBlur",
    value: function onFocusableBlur() {
      var _get5;
      if (this.props.changeLink) {
        this.setProps({
          changeLink: false
        });
      }
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      (_get5 = remoteFrame_get(remoteFrame_getPrototypeOf(RemoteFrame.prototype), "onFocusableBlur", this)).call.apply(_get5, [this].concat(args));
    }
    // тут важно учитывать последовательность вызова рендера при разных состояних блока, в предыдущем варианте не было учтено
    // и в конце, если рендер компонента фрейма сетил ошибку, она обнулялась функцией setProps, в итоге компонент был вынужден отправлять постоянно лоадер
  }, {
    key: "renderPlaceholder",
    value: function renderPlaceholder() {
      var _this$props = this.props,
        changeLink = _this$props.changeLink,
        maxAvailableWidth = _this$props.maxAvailableWidth;
      var showConvertButtonsOnError = maxAvailableWidth ? maxAvailableWidth >= MIN_WIDTH_FOR_SHOW_CONVERT_BUTTONS : true;
      return (0,preact_module.h)(RemoteFramePlaceholder, {
        blot: this,
        onInputRef: this.onInputRef,
        onApplySource: this.onApplySource,
        onEscape: this.onPlaceholderEscapeKeyDown,
        src: this.map.get('src'),
        error: this.props.setEmbedError,
        changeLink: changeLink,
        onSourceInputCancel: this.onSrcInputCancel,
        showConvertButtonsOnError: showConvertButtonsOnError
      });
    }
  }, {
    key: "renderLoader",
    value: function renderLoader() {
      return (0,preact_module.h)(RemoteFrameLoader, {
        editMode: this.editor.mode === this.editor.constructor.MODE_EDIT,
        i18n: this.editor.plugins.i18n,
        clearFrame: this.clearFrame
      });
    }
  }, {
    key: "renderInternalLinkError",
    value: function renderInternalLinkError() {
      var type = this.map.get('embed-type');
      var services = Object.assign({}, remoteFrameOptions_frames, widgets);
      var serviceName = services[type] && services[type].name || getHostFromUrl(this.map.get('src'));
      var i18n = this.editor.plugins.i18n;
      return (0,preact_module.h)(RemoteFrameInternalLinkError, {
        message: i18n.get('remote_frame.error.internal_link_error', {
          serviceName: serviceName
        }),
        onBackCkick: this.onInternalLinkErrorBackClick,
        backButtonText: i18n.get('remote_frame.back_button')
      });
    }
  }, {
    key: "defineType",
    value: function defineType() {
      var src = this.map.get('src');
      var isFrame = false;
      var type = getFrameType(src);
      // если тип фрейма не определен, возможно это виджет
      if (type) {
        isFrame = true;
      } else {
        type = getWidgetType(src);
      }
      if (type) {
        this.map.set('embed-type', type);
        if (isFrame) {
          if (remoteFrameOptions_frames[type].allowDirectUrl) {
            this.fetchIframelyEmbedHtml(src, true);
          }
        }
      } else {
        // если тип не определен, возможно его нужно вставлять как есть
        type = isSkipIframelyEmbed(src);
        if (type) {
          this.map.set('embed-type', 'embed');
        }
      }
      if (!type) {
        if (isLinkToPdfFile(src)) {
          this.map.set('embed-type', 'pdf');
        } else {
          // если не удалось определить тип фрейма возможностями редактора, получаем его из iframely
          this.fetchIframelyEmbedHtml(src);
        }
      }
    }
  }, {
    key: "contextMenu",
    get: function get() {
      var menu = remoteFrame_get(remoteFrame_getPrototypeOf(RemoteFrame.prototype), "contextMenu", this);
      var i18n = this.editor.plugins.i18n;
      menu['layout'] = (0,util/* mergeDeep */.Ee)(menu['layout'], {
        label: i18n.get('remote_frame.context_menu.layout'),
        index: -1,
        group: 0,
        action: false
      });
      if (this.hasEmbed() && !this.props.setEmbedError) {
        menu['copy-original'] = {
          label: i18n.get('remote_frame.context_menu.copy_original'),
          index: -2,
          group: 0,
          action: 'copyOriginal'
        };
        menu['change-link'] = {
          label: i18n.get('remote_frame.context_menu.change_link'),
          index: 0,
          group: 0,
          action: 'changeLink'
        };
        menu['full-size'] = {
          label: i18n.get('remote_frame.context_menu.full_size'),
          index: 1,
          group: 0,
          action: 'onFullSize'
        };
        if (!this.isFullwidth) {
          var _this$map$toJSON = this.map.toJSON(),
            originalSize = _this$map$toJSON.originalSize,
            width = _this$map$toJSON.width,
            ratio = _this$map$toJSON.ratio;
          var isWidthAvailable = Boolean(originalSize && originalSize.width) || Boolean(width);
          if (!originalSize || isWidthAvailable && originalSize.width !== width || originalSize.ratio !== ratio) {
            menu['reset-size'] = {
              label: i18n.get('remote_frame.context_menu.reset_size'),
              index: 1,
              group: 0,
              action: 'onResetSize'
            };
          }
        }
      }
      if (this.scroll.selectedBlocks.length === 1 && this.hasEmbed()) {
        menu['turn-into'] = {
          label: i18n.get('block_menu.convert_to.name'),
          index: -3,
          group: 0,
          action: false,
          submenu: {
            turnToParagraph: {
              label: i18n.get('block_menu.convert_to.paragraph'),
              index: 0,
              group: 0,
              action: 'convert-blot',
              actionParams: {
                type: 'paragraph'
              },
              actionExec: true,
              stackable: false,
              icon: icons/* IconParagraph */.V_f,
              hint: false
            },
            turnToLink: {
              label: i18n.get('block_menu.convert_to.link'),
              index: 0,
              group: 0,
              action: 'convert-blot',
              actionParams: {
                type: 'paragraph'
              },
              actionExec: true,
              stackable: false,
              icon: icons/* IconLink */.JHz
            },
            turnToBookmark: {
              label: i18n.get('block_menu.convert_to.bookmark'),
              index: 10,
              group: 0,
              action: 'convert-blot',
              actionParams: {
                type: 'bookmark',
                src: this.map.get('src'),
                replaceBlotId: this.id
              },
              actionExec: true,
              icon: icons/* IconBookmark */.BZM
            },
            turnToButton: {
              label: i18n.get('floating_toolbar.button'),
              index: 11,
              group: 0,
              action: 'convert-blot',
              actionParams: {
                type: 'button-single',
                url: this.map.get('src')
              },
              actionExec: true,
              stackable: false,
              icon: icons/* IconButton */.hU
            }
          }
        };
        var type = this.map.get('embed-type');
        var allowOpenOrigin = type === 'unknown' || type === 'other' || remoteFrameOptions_frames[type] && remoteFrameOptions_frames[type].allowOpenOrigin || widgets[type] && widgets[type].allowOpenOrigin;
        if (allowOpenOrigin) {
          menu['open-origin'] = {
            label: i18n.get('remote_frame.context_menu.open_origin'),
            index: -3,
            group: 0,
            action: 'openOrigin'
          };
        }
        /* if (frames[type] && frames[type].allowDirectUrl && this.hasEmbedHtml()) {
          menu.layout.submenu['switchLayout'] = {
            label: i18n.get('remote_frame.context_menu.show_toolbar'),
            index: 0,
            group: 0,
            action: 'switchLayout',
            icon : !this.map.get('directUrl') ? IconDone : null,
            style: !this.map.get('directUrl') ? 'done' : 'undone'
          }
        } */
      }

      return menu;
    }
  }, {
    key: "getTextDelta",
    value: function getTextDelta() {
      return {
        ops: [{
          insert: this.map.get('src'),
          attributes: {
            link: this.map.get('src')
          }
        }, {
          insert: '\n'
        }]
      };
    }
  }, {
    key: "getWrapper",
    value: function getWrapper() {
      return this.parent;
    }
  }, {
    key: "getDraggingNode",
    value: function getDraggingNode() {
      if (this.isTypeDefined()) {
        var node = this.domNode.cloneNode();
        var _this$frameContainer$ = this.frameContainer.getBoundingClientRect(),
          width = _this$frameContainer$.width,
          height = _this$frameContainer$.height;
        node.innerHTML = '<div class="remote-frame-dragging-placeholder" style="width: ' + width + 'px; height: ' + height + 'px"></div>';
        return node;
      } else {
        return this.domNode.cloneNode(true);
      }
    }
  }, {
    key: "putCaretInEmptyParagraphAfterEmbed",
    value: function putCaretInEmptyParagraphAfterEmbed() {
      var next = this.getWrapper().next;
      if (next && next instanceof paragraphAbstract && next.isEmpty()) {
        this.scroll.selection.setRange({
          index: next.offset(this.scroll),
          length: 0
        });
        this.editor.plugins.selectionScroller.ensureSelectionVisible();
        return;
      }
      this.parent.addBlot('paragraph', {
        after: this.id,
        focus: {
          index: 0
        }
      });
    }
  }, {
    key: "putCaretInNextBlotAfterEmbed",
    value: function putCaretInNextBlotAfterEmbed() {
      var next = this.getWrapper().next;
      if (next) {
        this.scroll.selection.setRange({
          index: next.offset(this.scroll),
          length: 0
        });
        this.editor.plugins.selectionScroller.ensureSelectionVisible();
      } else {
        this.putCaretInEmptyParagraphAfterEmbed();
      }
    }
  }, {
    key: "renderInBatch",
    value: function renderInBatch(fn) {
      var render = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      try {
        this.ignoringUpdateRender = true;
        fn();
      } finally {
        this.ignoringUpdateRender = false;
        if (render) {
          this.render();
        }
      }
    }
  }, {
    key: "onBlotMenuUpdatePosition",
    value: function onBlotMenuUpdatePosition(_ref7) {
      var left = _ref7.left,
        top = _ref7.top;
      var frameX = this.frameNode && this.frameNode.getBoundingClientRect().x || this.frameContainer.getBoundingClientRect().x;
      left += frameX - this.domNode.getBoundingClientRect().x;
      if (this.fullwidthMenuMargin) {
        left += this.fullwidthMenuMargin - 25;
      }
      return {
        left: left,
        top: top
      };
    }
  }, {
    key: "onGetCommentPosition",
    value: function onGetCommentPosition(_ref8) {
      var left = _ref8.left,
        top = _ref8.top;
      if (this.frameNode) {
        var _getRelRect = (0,dom/* getRelRect */.vk)(this.frameNode, this.editor.editorBody),
          iLeft = _getRelRect.left,
          width = _getRelRect.width;
        left -= left - (iLeft + width);
        top += 10;
      }
      return {
        left: left,
        top: top
      };
    }
  }, {
    key: "cloneSelf",
    value: function cloneSelf() {
      var map = this.store.createMap();
      var captionMap = this.store.createMap();
      Caption.initMap(captionMap, this.store, {
        delta: this.getWrapper().caption.delta({
          forCopy: true
        })
      });
      parchment_default().query(this.map.get('type')).initMap(map, this.store, {
        src: this.map.get('src'),
        caption: captionMap.get('id'),
        width: this.map.get('width'),
        ratio: this.map.get('ratio'),
        originalSize: this.map.get('originalSize')
      });
      return map.get('id');
    }
  }, {
    key: "toHTML",
    value: function toHTML() {
      var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var node = document.createElement('div');
      node.classList.add('exported-remote-frame');
      var src = this.map.get('src');
      var isFrame = false;
      if (this.hasEmbed() && context.options && !context.options.pdf) {
        var type = this.map.get('embed-type');
        var frameSrc = false;
        if (remoteFrameOptions_frames[type]) {
          frameSrc = src;
          if (remoteFrameOptions_frames[type].getFrameSrc) {
            frameSrc = remoteFrameOptions_frames[type].getFrameSrc(src);
          }
        } else if (type === 'other' || type === 'embed') {
          frameSrc = src;
        } else if (type === 'unknown') {
          var html = this.map.get('html');
          if (html && IFramePattern.test(html)) {
            var srcFromHtml = deserializeEmbedString(html.match(IFramePattern)[0]);
            if (typeof srcFromHtml === 'string') {
              frameSrc = srcFromHtml;
            }
          }
        }
        if (frameSrc) {
          isFrame = true;
          var _this$map$toJSON2 = this.map.toJSON(),
            width = _this$map$toJSON2.width,
            ratio = _this$map$toJSON2.ratio;
          if (!width) {
            width = 1000;
          }
          node.innerHTML = "<iframe src=\"".concat(frameSrc, "\" style=\"width:").concat(width, "px;height:").concat(width / ratio, "px;border:0;\" sandbox=\"allow-scripts allow-same-origin allow-popups allow-forms\" allowfullscreen=\"allowfullscreen\"></iframe>");
          node.classList.add('as-iframe');
        }
      }
      if (!isFrame) {
        // используем именно новый экземпляр регулярного выражения, иначе условие срабатывает через раз
        var regex = new RegExp(urlRegex.url);
        var isLink = regex.test(src);
        if (isLink) {
          node.innerHTML = "<a href=\"".concat(src, "\">").concat(src, "</a>");
          node.classList.add('as-link');
        } else {
          if (src) {
            // условие для предотвращения ошибки в escapeHtml если src null
            node.innerHTML = escapeHtml(src); // тут надо потестить со скриптами и тп, возможно их стоит обработать выше и закинуть во фрейм
          }

          node.classList.add('as-text');
        }
      }
      return node.outerHTML;
    }
  }, {
    key: "isResizeAvailable",
    value: function isResizeAvailable() {
      if (this.props.internalLinkError) return false;
      if (typeof remoteFrame_get(remoteFrame_getPrototypeOf(RemoteFrame.prototype), "isResizeAvailable", this) !== 'function' || remoteFrame_get(remoteFrame_getPrototypeOf(RemoteFrame.prototype), "isResizeAvailable", this).call(this)) {
        var type = this.map.get('embed-type');
        var services = Object.assign({}, remoteFrameOptions_frames, widgets);
        if (type === 'other' || type === 'embed') {
          return true;
        }
        if (services[type]) {
          if (services[type].disallowResize) {
            return false;
          }
          return true;
        }
        var html = this.map.get('html');
        if (html && IFramePattern.test(html)) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "onResizeableResolveSize",
    value: function onResizeableResolveSize() {
      var _this3 = this;
      var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      remoteFrame_get(remoteFrame_getPrototypeOf(RemoteFrame.prototype), "onResizeableResolveSize", this).call(this, size);
      this.renderInBatch(function () {
        _this3.map.set('originalSize', size);
      }, false);
    }
  }, {
    key: "getResizeOpts",
    value: function getResizeOpts() {
      var type = this.map.get('embed-type');
      var opts = {};
      var services = Object.assign({}, remoteFrameOptions_frames, widgets);
      if (services[type]) {
        if (services[type].allowedResizePoints) {
          opts.allowedResizePoints = services[type].allowedResizePoints; // string or array
        }
      }

      return opts;
    }
  }, {
    key: "tryGetRatio",
    value: function tryGetRatio() {
      var ratio = this.map.get('ratio');
      if (!ratio) {
        var type = this.map.get('embed-type');
        var services = Object.assign({}, remoteFrameOptions_frames, widgets);
        if (services[type] && services[type].frameRatio) {
          ratio = services[type].frameRatio;
        }
      }
      if (!ratio) {
        ratio = 16 / 9;
      }
      return ratio;
    }
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      var _this$getWrapper$capt;
      var params = remoteFrame_get(remoteFrame_getPrototypeOf(RemoteFrame.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
      return (0,util/* mergeDeep */.Ee)(params, {
        initParams: {
          src: this.map.get('src'),
          width: this.map.get('width'),
          ratio: this.map.get('ratio'),
          originalSize: this.map.get('originalSize'),
          captionParams: (_this$getWrapper$capt = this.getWrapper().caption) === null || _this$getWrapper$capt === void 0 ? void 0 : _this$getWrapper$capt.getBlotInsertParams()
        }
      });
    }
  }], [{
    key: "convertBlots",
    value: function convertBlots(ids, store, _ref9) {
      var params = _ref9.params,
        container = _ref9.container;
      if (!ids.length || ids.length > 1) {
        return null;
      }
      var initParams = Object.assign({}, params);
      var blot = container.editor.findById(ids[0]);
      if (blot.constructor.blotName === 'paragraph') {
        var ops = blot.delta().ops;
        var hasOnlyLink = ops.length === 2 && ops[0].attributes && ops[0].attributes.hasOwnProperty('link') && ops[1].insert.replace(' ', '') === '\n';
        if (hasOnlyLink) {
          initParams.src = blot.delta().ops[0].attributes.link;
        }
      }
      this.setCommentThreads(blot, initParams);
      var map = store.createMap();
      this.initMap(map, store, initParams);
      return {
        removeBlots: ids,
        insertBlots: [map.get('id')]
      };
    }
  }, {
    key: "createBlot",
    value: function createBlot(editor) {
      var blot = parchment_default().create('remoteFrameWrapper');
      this.addCaretTrap(editor, blot.domNode);
      return blot;
    }
  }, {
    key: "create",
    value: function create(value) {
      var node = remoteFrame_get(remoteFrame_getPrototypeOf(RemoteFrame), "create", this).call(this);
      node.classList.add(REMOTE_FRAME_CLASS);
      var frameContainer = document.createElement('div');
      frameContainer.setAttribute('contenteditable', false);
      frameContainer.classList.add(REMOTE_FRAME_CONTAINER_CLASS);
      node.appendChild(frameContainer);
      return node;
    }
  }, {
    key: "value",
    value: function value(node) {
      return {
        src: this.map.get('src')
      };
    }
  }]);
  return RemoteFrame;
}(remoteFrame_mixin(blockEmbed));
remoteFrame_defineProperty(RemoteFrame, "initMap", function (map, store) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  map.set('type', 'remote-frame');
  map.set('src', params.src || null);
  var captionId = params.caption;
  if (!captionId) {
    var captionMap = store.createMap();
    Caption.initMap(captionMap, store, params.captionParams || {});
    captionId = captionMap.get('id');
  }
  map.set('caption', captionId);
  map.set('embed-type', params.embedType || null);
  map.set('html', params.html || null);
  map.set('signature', params.signature ? params.signature : '');
  if (params.originalSize) {
    map.set('originalSize', params.originalSize);
  }
  fullWidth.initMap(map, store, params);
  resizeable.initMap(map, store, params);
  remoteFrame_get(remoteFrame_getPrototypeOf(RemoteFrame), "initMap", RemoteFrame) && remoteFrame_get(remoteFrame_getPrototypeOf(RemoteFrame), "initMap", RemoteFrame).call(RemoteFrame, map, store, params);
});

RemoteFrame.blotName = 'remote-frame';
RemoteFrame.tagName = 'DIV';
RemoteFrame.wrapper = 'remoteFrameWrapper';
RemoteFrame.minContentWidth = 100;
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/remoteFrame/remoteFrameWrapper.js
function remoteFrameWrapper_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { remoteFrameWrapper_typeof = function _typeof(obj) { return typeof obj; }; } else { remoteFrameWrapper_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return remoteFrameWrapper_typeof(obj); }












function remoteFrameWrapper_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function remoteFrameWrapper_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function remoteFrameWrapper_createClass(Constructor, protoProps, staticProps) { if (protoProps) remoteFrameWrapper_defineProperties(Constructor.prototype, protoProps); if (staticProps) remoteFrameWrapper_defineProperties(Constructor, staticProps); return Constructor; }
function remoteFrameWrapper_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { remoteFrameWrapper_get = Reflect.get; } else { remoteFrameWrapper_get = function _get(target, property, receiver) { var base = remoteFrameWrapper_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return remoteFrameWrapper_get(target, property, receiver || target); }
function remoteFrameWrapper_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = remoteFrameWrapper_getPrototypeOf(object); if (object === null) break; } return object; }
function remoteFrameWrapper_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) remoteFrameWrapper_setPrototypeOf(subClass, superClass); }
function remoteFrameWrapper_setPrototypeOf(o, p) { remoteFrameWrapper_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return remoteFrameWrapper_setPrototypeOf(o, p); }
function remoteFrameWrapper_createSuper(Derived) { var hasNativeReflectConstruct = remoteFrameWrapper_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = remoteFrameWrapper_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = remoteFrameWrapper_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return remoteFrameWrapper_possibleConstructorReturn(this, result); }; }
function remoteFrameWrapper_possibleConstructorReturn(self, call) { if (call && (remoteFrameWrapper_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return remoteFrameWrapper_assertThisInitialized(self); }
function remoteFrameWrapper_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function remoteFrameWrapper_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function remoteFrameWrapper_getPrototypeOf(o) { remoteFrameWrapper_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return remoteFrameWrapper_getPrototypeOf(o); }





var RemoteFrameWrapper = /*#__PURE__*/function (_SizeAwareMixin) {
  remoteFrameWrapper_inherits(RemoteFrameWrapper, _SizeAwareMixin);
  var _super = remoteFrameWrapper_createSuper(RemoteFrameWrapper);
  function RemoteFrameWrapper(domNode) {
    var _this;
    remoteFrameWrapper_classCallCheck(this, RemoteFrameWrapper);
    _this = _super.call(this, domNode);
    _this.domNode.classList.add('remote-frame-wrapper');
    _this.caption = null;
    return _this;
  }
  remoteFrameWrapper_createClass(RemoteFrameWrapper, [{
    key: "getInnerTextLine",
    value: function getInnerTextLine() {
      return this.caption;
    }
  }, {
    key: "sizeAwareUpdateSize",
    value: function sizeAwareUpdateSize(maxAvailableWidth) {
      this.embed.setProps({
        maxAvailableWidth: maxAvailableWidth
      });
    }
  }, {
    key: "render",
    value: function render() {
      remoteFrameWrapper_get(remoteFrameWrapper_getPrototypeOf(RemoteFrameWrapper.prototype), "render", this).call(this);
      if (this.embed.hasEmbed() && !this.embed.props.setEmbedError && this.embed.isTypeDefined()) {
        if (!this.caption) {
          this.caption = parchment_default().create('caption');
          this.caption.map = this.store.getMap(this.map.get('caption'));
          this.caption.embedBlot = this.embed;
          this.appendChild(this.caption);
        }
        this.caption.render();
      } else {
        if (this.caption) {
          this.caption.remove();
          this.caption = null;
        }
      }
    }
  }]);
  return RemoteFrameWrapper;
}(sizeaware(embedWrapperAbstract));

RemoteFrameWrapper.allowedChildren = [RemoteFrame, Caption];
RemoteFrameWrapper.blotName = 'remoteFrameWrapper';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/remoteFile/services/googleDrive.js
function googleDrive_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { googleDrive_typeof = function _typeof(obj) { return typeof obj; }; } else { googleDrive_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return googleDrive_typeof(obj); }













function googleDrive_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function googleDrive_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function googleDrive_createClass(Constructor, protoProps, staticProps) { if (protoProps) googleDrive_defineProperties(Constructor.prototype, protoProps); if (staticProps) googleDrive_defineProperties(Constructor, staticProps); return Constructor; }
function googleDrive_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) googleDrive_setPrototypeOf(subClass, superClass); }
function googleDrive_setPrototypeOf(o, p) { googleDrive_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return googleDrive_setPrototypeOf(o, p); }
function googleDrive_createSuper(Derived) { var hasNativeReflectConstruct = googleDrive_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = googleDrive_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = googleDrive_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return googleDrive_possibleConstructorReturn(this, result); }; }
function googleDrive_possibleConstructorReturn(self, call) { if (call && (googleDrive_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return googleDrive_assertThisInitialized(self); }
function googleDrive_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function googleDrive_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function googleDrive_getPrototypeOf(o) { googleDrive_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return googleDrive_getPrototypeOf(o); }
function googleDrive_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var GOOGLE_DRIVE_MENU_CLASS = 'google-drive-menu';
var DEFAULT_PREVIEW_HEIGHT = 400;
var GoogleDriveFile = /*#__PURE__*/function (_Component) {
  googleDrive_inherits(GoogleDriveFile, _Component);
  var _super = googleDrive_createSuper(GoogleDriveFile);
  function GoogleDriveFile(props) {
    var _this;
    googleDrive_classCallCheck(this, GoogleDriveFile);
    _this = _super.call(this, props);
    googleDrive_defineProperty(googleDrive_assertThisInitialized(_this), "onMenuIconRef", function (node) {
      _this.menuIconNode = node;
    });
    googleDrive_defineProperty(googleDrive_assertThisInitialized(_this), "onMenuButtonMouseDown", function () {
      if (_this.state.menuOpen) {
        _this._swallowMenuClick = true;
        var _restore = function _restore() {
          setTimeout(function () {
            return _this._swallowMenuClick = false;
          });
          document.removeEventListener('mouseup', _restore, false);
        };
        document.addEventListener('mouseup', _restore, false);
      }
    });
    googleDrive_defineProperty(googleDrive_assertThisInitialized(_this), "onMenuButtonClick", function () {
      if (_this._swallowMenuClick) {
        _this._swallowMenuClick = false;
        return;
      }
      _this.setState(function (prevState) {
        return {
          menuOpen: !prevState.menuOpen
        };
      });
    });
    googleDrive_defineProperty(googleDrive_assertThisInitialized(_this), "onClickMenuExpand", function () {
      _this.expandPreview();
      _this.hideMenu();
    });
    googleDrive_defineProperty(googleDrive_assertThisInitialized(_this), "onClickMenuOpenOrigin", function () {
      _this.openOriginal();
      _this.hideMenu();
    });
    googleDrive_defineProperty(googleDrive_assertThisInitialized(_this), "onClickMenuDownload", function () {
      var link = _this.props.fileData.downloadUrl;
      if (link) {
        if (!_this.editor.plugins.linkManager.processNavigation(link)) {
          window.open(link, '_blank', 'noopener');
        }
      }
      _this.hideMenu();
    });
    googleDrive_defineProperty(googleDrive_assertThisInitialized(_this), "onClickMenuReplaceFile", function () {
      _this.props.onFileReplace();
      _this.hideMenu();
    });
    googleDrive_defineProperty(googleDrive_assertThisInitialized(_this), "onMenuWantsToClose", function () {
      _this.hideMenu();
    });
    googleDrive_defineProperty(googleDrive_assertThisInitialized(_this), "onExpandClick", function (event) {
      var asyncContent = _this.props.asyncContent;
      if (!asyncContent || !asyncContent.preview) return;
      _this.expandPreview();
    });
    googleDrive_defineProperty(googleDrive_assertThisInitialized(_this), "onInfoClick", function (event) {
      _this.openOriginal();
    });
    googleDrive_defineProperty(googleDrive_assertThisInitialized(_this), "onPreviewClick", function (event) {
      _this.openOriginal();
    });
    _this.editor = props.editor;
    _this.i18n = _this.editor.plugins.i18n;
    _this.state = {
      menuOpen: false,
      thumbnail: null
    };
    return _this;
  }
  googleDrive_createClass(GoogleDriveFile, [{
    key: "expandPreview",
    value: function expandPreview() {
      var expanded = this.props.expanded;
      this.props.setPreviewState(!expanded);
    }
  }, {
    key: "hideMenu",
    value: function hideMenu() {
      this.setState(function () {
        return {
          menuOpen: false
        };
      });
    }
  }, {
    key: "openOriginal",
    value: function openOriginal() {
      var url = this.props.fileData.url;
      if (url) {
        if (!this.editor.plugins.linkManager.processNavigation(url)) {
          window.open(url, '_blank', 'noopener');
        }
      }
    }
  }, {
    key: "resolveThumbnail",
    value: function resolveThumbnail() {
      var _this2 = this;
      var thumbnailAttachmentGlobalId = this.props.asyncContent.preview;
      if (this._resolveInProgress || !thumbnailAttachmentGlobalId) {
        return;
      }
      this._resolveInProgress = true;
      this.editor.plugins.attachmentManager.resolve(thumbnailAttachmentGlobalId).then(function (thumbnail) {
        _this2.props.onServiceAttachmentResolved(_this2.constructor.serviceName, 'thumbnail', thumbnail);
        _this2.setState(function () {
          return {
            thumbnail: thumbnail
          };
        }, function () {
          _this2._resolveInProgress = false;
        });
      }).catch(function (err) {
        console.error('fail to resolve attachment', err);
        _this2._resolveInProgress = false;
        // тут решил сетить ошибку прямо в thumbnail, а в рендере просто проверять есть ли у thumbnail url и если нет то не рендерить превью
        _this2.setState(function () {
          return {
            thumbnail: {
              error: err
            }
          };
        });
      });
    }
  }, {
    key: "getMenu",
    value: function getMenu() {
      var menu = {};
      if (this.props.fileData) {
        menu.openOrigin = {
          label: this.i18n.get('google_drive.menu.open_origin'),
          index: 1,
          action: 'onClickMenuOpenOrigin'
        };
        menu.replaceFile = {
          label: this.i18n.get('google_drive.menu.choose_another_file'),
          index: 3,
          action: 'onClickMenuReplaceFile'
        };
        if (this.state.thumbnail && this.state.thumbnail.url) {
          menu.expand = {
            label: !this.props.expanded ? this.i18n.get('google_drive.menu.expand') : this.i18n.get('google_drive.menu.collapse'),
            index: 0,
            action: 'onClickMenuExpand'
          };
        }
        if (this.props.fileData.downloadUrl) {
          menu.download = {
            label: this.i18n.get('google_drive.menu.download'),
            index: 2,
            action: 'onClickMenuDownload'
          };
        }
      }
      return menu;
    }
  }, {
    key: "renderLoader",
    value: function renderLoader() {
      return (0,preact_module.h)("div", {
        className: "google-drive-loading"
      }, (0,preact_module.h)("div", {
        className: "google-drive-icon"
      }, (0,preact_module.h)(icons/* IconGoogleDrive */.dhu, null)), (0,preact_module.h)("div", {
        className: "google-drive-loading-text"
      }, this.i18n.get('google_drive.loading')));
    }
  }, {
    key: "renderHeader",
    value: function renderHeader(editMode) {
      var _this3 = this;
      var menuOpen = this.state.menuOpen;
      var asyncContent = this.props.asyncContent;
      var menuIcon = null;
      var menuNode = null;
      if (editMode && this.props.fileData) {
        menuIcon = (0,preact_module.h)("div", {
          className: "google-drive-menu-icon",
          ref: this.onMenuIconRef,
          onClick: this.onMenuButtonClick,
          onMouseDown: this.onMenuButtonMouseDown
        }, (0,preact_module.h)(icons/* IconMoreVertical */.nqv, null));
        if (menuOpen) {
          var menuRaw = this.getMenu();
          var menuItems = Object.keys(menuRaw).map(function (key) {
            return Object.assign({}, menuRaw[key], {
              key: key
            });
          }).sort(function (item1, item2) {
            return item1.index - item2.index;
          }).map(function (item) {
            return (0,preact_module.h)(popupMenuItem/* default */.Z, {
              key: item.key,
              id: 'google-drive-' + item.key,
              onClick: _this3[item.action],
              text: item.label
            });
          });
          menuNode = (0,preact_module.h)(popupMenu/* default */.Z, {
            addClassName: GOOGLE_DRIVE_MENU_CLASS + " position-absolute",
            anchorNode: this.menuIconNode,
            wantsToClose: this.onMenuWantsToClose,
            anchorOptions: {
              placement: 'left-start'
            }
          }, menuItems);
        }
      }
      return (0,preact_module.h)("div", {
        className: 'google-drive-header' + (!asyncContent || !asyncContent.preview ? ' no-preview' : '')
      }, (0,preact_module.h)("div", {
        className: "google-drive-block-name",
        onClick: this.onExpandClick,
        onMouseDown: function onMouseDown(event) {
          event.preventDefault();
        }
      }, (0,preact_module.h)("div", {
        className: "google-drive-block-name-icon"
      }, (0,preact_module.h)(icons/* IconGoogleDrive */.dhu, null)), this.i18n.get('google_drive.block_name')), (0,preact_module.h)("div", {
        className: "google-drive-right"
      }, menuIcon, (0,preact_module.h)(PopupMenuTransition, null, menuNode)));
    }
  }, {
    key: "renderFileInfo",
    value: function renderFileInfo() {
      var fileData = this.props.fileData;
      var modified = getRelativeTime(fileData.modified_time);
      var modifiedTimeText = this.i18n.get('relative_time.' + modified.unit + '.' + modified.case, {
        count: modified.count
      });
      return (0,preact_module.h)("div", {
        className: "google-drive-file-info",
        onClick: this.onInfoClick
      }, (0,preact_module.h)("div", {
        className: "google-drive-file-name"
      }, fileData.title), (0,preact_module.h)("div", {
        className: "google-drive-last-modified"
      }, this.i18n.get('google_drive.last_modified', {
        userName: fileData.user_name,
        time: modifiedTimeText
      })), (0,preact_module.h)("div", {
        className: "google-drive-file-source"
      }, (0,preact_module.h)("div", {
        className: "google-drive-file-icon"
      }, (0,preact_module.h)("img", {
        src: fileData.icon
      })), getHostFromUrl(fileData.url)));
    }
  }, {
    key: "renderPreview",
    value: function renderPreview() {
      var thumbnail = this.state.thumbnail;
      var nodeToRender = null;
      var styles = {
        height: (this.props.height || DEFAULT_PREVIEW_HEIGHT) + 'px'
      };
      if (!thumbnail) {
        this.resolveThumbnail();
        nodeToRender = (0,preact_module.h)("div", {
          className: "google-drive-file-preview",
          style: styles
        }, (0,preact_module.h)("div", {
          className: "google-drive-file-preview-loader"
        }, (0,preact_module.h)((loader2_default()), null)));
      } else {
        if (thumbnail.url) {
          nodeToRender = (0,preact_module.h)("div", {
            className: "google-drive-file-preview",
            style: styles,
            onClick: this.onPreviewClick
          }, (0,preact_module.h)("img", {
            className: "google-drive-file-preview-image",
            src: thumbnail.url
          }));
        }
      }
      return nodeToRender;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onServiceRendered();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        fileData = _this$props.fileData,
        asyncContent = _this$props.asyncContent,
        expanded = _this$props.expanded;
      var editMode = this.editor.mode === this.editor.constructor.MODE_EDIT;
      var exportMode = this.editor.mode === this.editor.constructor.MODE_EXPORT;
      var nodeToRender = null;
      var headerNode = this.renderHeader(editMode);
      var contentNode = null;
      var infoNode = null;
      // тут на всякий случай оставил рендер загрузчика
      if (!fileData) {
        contentNode = this.renderLoader();
      } else {
        if (asyncContent && asyncContent.preview && (expanded || exportMode)) {
          contentNode = this.renderPreview();
        } else if ((!asyncContent || !asyncContent.preview) && this.state.thumbnail) {
          this.state.thumbnail = null;
        }
        infoNode = this.renderFileInfo();
      }
      return (0,preact_module.h)("div", {
        className: "google-drive-content-wrapper"
      }, headerNode, contentNode, infoNode);
    }
  }], [{
    key: "toHTML",
    value: function toHTML(file, context) {
      var thumbnailAttachment = file.serviceAttachments[this.serviceName] && file.serviceAttachments[this.serviceName].thumbnail;
      var node = file.domNode.cloneNode(true);
      var previewNode = node.querySelector('.google-drive-file-preview');
      var aWrapper = document.createElement('a');
      aWrapper.setAttribute('href', file.map.get('fileData').url);
      aWrapper.setAttribute('target', '_blank');
      aWrapper.classList.add('export-link-wrapper');
      var wrapNode = node.querySelector('.google-drive-file-info');
      aWrapper.appendChild(wrapNode.cloneNode(true));
      wrapNode.parentNode.replaceChild(aWrapper, wrapNode);
      if (thumbnailAttachment) {
        context.addAttachment(thumbnailAttachment);
        var thumbnailPath = context.getAttachmentPath(thumbnailAttachment);
        var thumbnail = document.createElement('img');
        thumbnail.setAttribute('src', thumbnailPath);
        if (previewNode) {
          previewNode.replaceChild(thumbnail, previewNode.firstChild);
        } else {
          var newPreviewNode = document.createElement('div');
          newPreviewNode.classList.add('google-drive-file-preview');
          newPreviewNode.style.height = DEFAULT_PREVIEW_HEIGHT + 'px';
          newPreviewNode.appendChild(thumbnail);
          aWrapper.parentNode.insertBefore(newPreviewNode, aWrapper);
        }
      }
      return node.outerHTML;
    }
  }]);
  return GoogleDriveFile;
}(preact_module/* Component */.wA);

GoogleDriveFile.serviceName = 'google-drive';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/remoteFile/services/index.js
function services_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* harmony default export */ const services = (services_defineProperty({}, GoogleDriveFile.serviceName, GoogleDriveFile));
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/addRemoteFile.js
function addRemoteFile_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { addRemoteFile_typeof = function _typeof(obj) { return typeof obj; }; } else { addRemoteFile_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return addRemoteFile_typeof(obj); }











function addRemoteFile_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function addRemoteFile_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { addRemoteFile_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { addRemoteFile_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function addRemoteFile_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function addRemoteFile_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function addRemoteFile_createClass(Constructor, protoProps, staticProps) { if (protoProps) addRemoteFile_defineProperties(Constructor.prototype, protoProps); if (staticProps) addRemoteFile_defineProperties(Constructor, staticProps); return Constructor; }
function addRemoteFile_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) addRemoteFile_setPrototypeOf(subClass, superClass); }
function addRemoteFile_setPrototypeOf(o, p) { addRemoteFile_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return addRemoteFile_setPrototypeOf(o, p); }
function addRemoteFile_createSuper(Derived) { var hasNativeReflectConstruct = addRemoteFile_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = addRemoteFile_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = addRemoteFile_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return addRemoteFile_possibleConstructorReturn(this, result); }; }
function addRemoteFile_possibleConstructorReturn(self, call) { if (call && (addRemoteFile_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return addRemoteFile_assertThisInitialized(self); }
function addRemoteFile_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function addRemoteFile_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function addRemoteFile_getPrototypeOf(o) { addRemoteFile_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return addRemoteFile_getPrototypeOf(o); }


var AddRemoteFileAction = /*#__PURE__*/function (_Action) {
  addRemoteFile_inherits(AddRemoteFileAction, _Action);
  var _super = addRemoteFile_createSuper(AddRemoteFileAction);
  function AddRemoteFileAction(type, params, editor) {
    addRemoteFile_classCallCheck(this, AddRemoteFileAction);
    type = type || AddRemoteFileAction.type;
    return _super.call(this, type, params || {}, editor);
  }
  addRemoteFile_createClass(AddRemoteFileAction, [{
    key: "exec",
    value: function () {
      var _exec = addRemoteFile_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
        var processingBlots, fileData, blot, service, res, convertRes, addedIds, addedId;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                processingBlots = _ref.processingBlots;
                fileData = this.params.fileData;
                blot = this.params.blot;
                service = this.params.service;
                if (this.params.blotId) {
                  blot = this.editor.findById(this.params.blotId);
                }
                // если переданный блот не является RemoteFile,
                // записываем его в action для дальнейшей конвертации в RemoteFile и обнуляем переменную
                if (blot && !(blot instanceof RemoteFile)) {
                  this.setSelectedBlots([blot]);
                  blot = null;
                }
                if (fileData) {
                  _context.next = 10;
                  break;
                }
                _context.next = 9;
                return this.editor.plugins.remoteFileManager.chooseFile({
                  service: service,
                  blotId: blot ? blot.id : undefined
                });
              case 9:
                fileData = _context.sent;
              case 10:
                if (fileData) {
                  _context.next = 12;
                  break;
                }
                return _context.abrupt("return", false);
              case 12:
                if (blot) {
                  _context.next = 27;
                  break;
                }
                if (!this.params.createRemoteFileBlot) {
                  _context.next = 17;
                  break;
                }
                // если передана функция создания блота, то создаем его
                blot = this.params.createRemoteFileBlot();
                _context.next = 27;
                break;
              case 17:
                // если не задан файл-блот, то конвертим в файл текущий блот
                res = this.editor.exec('convert-blot', {
                  type: 'remote-file',
                  service: service
                });
                if (!res || !res.action) {
                  if (this.selectedBlots.length) {
                    convertRes = this.selectedBlots[0].container.containerConvertBlots(this.selectedBlots, {
                      type: 'remote-file',
                      service: service
                    });
                    if (!convertRes) {
                      console.error('res does not contain action', res);
                    } else {
                      // тут привел к виду, когда exec('convert-blot') выполняется, чтобы ниже код был один для обоих случаев 
                      res = {
                        action: {
                          results: [convertRes]
                        }
                      };
                    }
                  }
                }
                addedIds = res.action.results[0].addedIds;
                if (addedIds.length) {
                  _context.next = 22;
                  break;
                }
                return _context.abrupt("return", false);
              case 22:
                if (!(addedIds.length !== 1)) {
                  _context.next = 25;
                  break;
                }
                console.error('addRemoteFile expects 1 id to be in the result of convert-blot, but got', addedIds);
                return _context.abrupt("return", false);
              case 25:
                addedId = addedIds[0];
                blot = this.editor.findById(addedId);
              case 27:
                blot.clearFileData();
                blot.setFileData(fileData);
                return _context.abrupt("return", true);
              case 30:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function exec(_x) {
        return _exec.apply(this, arguments);
      }
      return exec;
    }()
  }]);
  return AddRemoteFileAction;
}(Action);

AddRemoteFileAction.type = 'add-remote-file';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/remoteFile/remoteFile.js
function remoteFile_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { remoteFile_typeof = function _typeof(obj) { return typeof obj; }; } else { remoteFile_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return remoteFile_typeof(obj); }













function remoteFile_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function remoteFile_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function remoteFile_createClass(Constructor, protoProps, staticProps) { if (protoProps) remoteFile_defineProperties(Constructor.prototype, protoProps); if (staticProps) remoteFile_defineProperties(Constructor, staticProps); return Constructor; }
function remoteFile_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) remoteFile_setPrototypeOf(subClass, superClass); }
function remoteFile_setPrototypeOf(o, p) { remoteFile_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return remoteFile_setPrototypeOf(o, p); }
function remoteFile_createSuper(Derived) { var hasNativeReflectConstruct = remoteFile_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = remoteFile_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = remoteFile_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return remoteFile_possibleConstructorReturn(this, result); }; }
function remoteFile_possibleConstructorReturn(self, call) { if (call && (remoteFile_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return remoteFile_assertThisInitialized(self); }
function remoteFile_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function remoteFile_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function remoteFile_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { remoteFile_get = Reflect.get; } else { remoteFile_get = function _get(target, property, receiver) { var base = remoteFile_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return remoteFile_get(target, property, receiver || target); }
function remoteFile_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = remoteFile_getPrototypeOf(object); if (object === null) break; } return object; }
function remoteFile_getPrototypeOf(o) { remoteFile_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return remoteFile_getPrototypeOf(o); }
function remoteFile_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
















var remoteFile_mixin = mix([commentable, withCaption, embeddable, draggable, selectable, focusable, executable, basic]);
var REMOTE_FILE_CLASS = 'remote-file';
var REMOTE_FILE_CONTAINER_CLASS = 'remote-file-container';
var REMOTE_FILE_MENU_CLASS = 'remote-file-menu';
var MAX_EXPAND_HEIGHT = 600;
var RemoteFile = /*#__PURE__*/function (_mixin) {
  remoteFile_inherits(RemoteFile, _mixin);
  var _super = remoteFile_createSuper(RemoteFile);
  function RemoteFile(domNode) {
    var _this;
    remoteFile_classCallCheck(this, RemoteFile);
    _this = _super.call(this, domNode);
    remoteFile_defineProperty(remoteFile_assertThisInitialized(_this), "onFileReplace", function () {
      var addRemoteFileAction = new AddRemoteFileAction(AddRemoteFileAction.type, {
        blot: remoteFile_assertThisInitialized(_this),
        service: _this.map.get('service')
      }, _this.editor);
      addRemoteFileAction.run({});
    });
    remoteFile_defineProperty(remoteFile_assertThisInitialized(_this), "mapObserver", function () {
      _this.render();
    });
    remoteFile_defineProperty(remoteFile_assertThisInitialized(_this), "setFileData", function (data) {
      if (data.fileData) {
        _this.map.set('fileData', data.fileData);
      }
      if (data.asyncContent) {
        data.asyncContent.then(function (result) {
          _this.map.set('asyncContent', result);
        }).catch(function (error) {
          console.error(error);
        });
      }
    });
    remoteFile_defineProperty(remoteFile_assertThisInitialized(_this), "onServiceAttachmentResolved", function (service, key, attachment) {
      if (!_this.serviceAttachments[service]) {
        _this.serviceAttachments[service] = {};
      }
      _this.serviceAttachments[service][key] = attachment;
    });
    remoteFile_defineProperty(remoteFile_assertThisInitialized(_this), "onServiceRendered", function () {
      _this.setProps({
        serviceRendered: true
      });
    });
    remoteFile_defineProperty(remoteFile_assertThisInitialized(_this), "setPreviewState", function (value) {
      _this.map.set('expanded', value);
    });
    _this.isSeparableByClickApplicable = true;
    _this.addCanExecActions(['delete', 'backspace']);
    _this.disallowReplace = true;
    // переменная не в props, так как не должна влиять на ререндер, ререндер управляется сервисами
    _this.serviceAttachments = {};
    return _this;
  }
  remoteFile_createClass(RemoteFile, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = remoteFile_get(remoteFile_getPrototypeOf(RemoteFile.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      this.store.observe(this.map, this.mapObserver);
      this.render();
    }
  }, {
    key: "hasFileData",
    value: function hasFileData() {
      return Boolean(this.map.get('fileData'));
    }
  }, {
    key: "hasAsyncContent",
    value: function hasAsyncContent() {
      return Boolean(this.map.get('asyncContent'));
    }
  }, {
    key: "clearFileData",
    value: function clearFileData() {
      this.map.set('fileData', null);
      this.map.set('asyncContent', null);
    }
  }, {
    key: "render",
    value: function render() {
      remoteFile_get(remoteFile_getPrototypeOf(RemoteFile.prototype), "render", this).call(this);
      this.getWrapper().render();
      var fileService = this.map.get('service');
      if (fileService && this.hasFileData()) {
        var remoteFileContainer = this.domNode.querySelector('.' + REMOTE_FILE_CONTAINER_CLASS);
        if (!services[fileService]) {
          throw new Error('Service "' + fileService + '" is not supported');
        }
        var FileComponent = services[fileService];
        (0,preact_module/* render */.sY)((0,preact_module.h)(FileComponent, {
          fileData: this.map.get('fileData'),
          asyncContent: this.map.get('asyncContent'),
          onFileReplace: this.onFileReplace,
          expanded: this.map.get('expanded'),
          onServiceRendered: this.onServiceRendered,
          onServiceAttachmentResolved: this.onServiceAttachmentResolved,
          setPreviewState: this.setPreviewState,
          editor: this.editor
        }), remoteFileContainer);
      }
    }
  }, {
    key: "contextMenu",
    get: function get() {
      var menu = remoteFile_get(remoteFile_getPrototypeOf(RemoteFile.prototype), "contextMenu", this);
      var i18n = this.editor.plugins.i18n;
      var serviceMenuFn = services[this.map.get('service')].getContextMenu;
      if (serviceMenuFn) {
        menu = serviceMenuFn(menu);
      }
      return menu;
    }
  }, {
    key: "cloneSelf",
    value: function cloneSelf() {
      var map = this.store.createMap();
      var captionMap = this.store.createMap();
      Caption.initMap(captionMap, this.store, {
        delta: this.getWrapper().caption.delta({
          forCopy: true
        })
      });
      parchment_default().query(this.map.get('type')).initMap(map, this.store, {
        service: this.map.get('service'),
        fileData: this.map.get('fileData'),
        asyncContent: this.map.get('asyncContent'),
        expanded: this.map.get('expanded'),
        caption: captionMap.get('id')
      });
      return map.get('id');
    }
  }, {
    key: "exec",
    value: function exec(action) {
      var processed = remoteFile_get(remoteFile_getPrototypeOf(RemoteFile.prototype), "exec", this).call(this, action);
      if (action.type === 'backspace') {
        action.dontRestoreSelection();
        processed = true;
      }
      return processed;
    }
  }, {
    key: "remove",
    value: function remove() {
      var _get3;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = remoteFile_get(remoteFile_getPrototypeOf(RemoteFile.prototype), "remove", this)).call.apply(_get3, [this].concat(args));
    }
  }, {
    key: "getWrapper",
    value: function getWrapper() {
      return this.parent;
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get4;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      (_get4 = remoteFile_get(remoteFile_getPrototypeOf(RemoteFile.prototype), "detach", this)).call.apply(_get4, [this].concat(args));
      this.store.unobserve(this.map, this.mapObserver);
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      var fileService = this.map.get('service');
      if (fileService && this.hasFileData() && services[fileService].toHTML) {
        return services[fileService].toHTML(this, context);
      } else {
        return this.domNode.outerHTML;
      }
    }
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      var _this$getWrapper$capt;
      var params = remoteFile_get(remoteFile_getPrototypeOf(RemoteFile.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
      return (0,util/* mergeDeep */.Ee)(params, {
        initParams: {
          service: this.map.get('service'),
          fileData: this.map.get('fileData'),
          asyncContent: this.map.get('asyncContent'),
          expanded: this.map.get('expanded'),
          captionParams: (_this$getWrapper$capt = this.getWrapper().caption) === null || _this$getWrapper$capt === void 0 ? void 0 : _this$getWrapper$capt.getBlotInsertParams()
        }
      });
    }
  }], [{
    key: "createBlot",
    value: function createBlot(editor) {
      var blot = parchment_default().create('remoteFileWrapper');
      this.addCaretTrap(editor, blot.domNode);
      return blot;
    }
  }, {
    key: "create",
    value: function create(value) {
      var node = remoteFile_get(remoteFile_getPrototypeOf(RemoteFile), "create", this).call(this);
      node.classList.add(REMOTE_FILE_CLASS);
      var remoteFileContainer = document.createElement('div');
      remoteFileContainer.setAttribute('contenteditable', false);
      remoteFileContainer.classList.add(REMOTE_FILE_CONTAINER_CLASS);
      node.appendChild(remoteFileContainer);
      return node;
    }
  }]);
  return RemoteFile;
}(remoteFile_mixin(blockEmbed));
remoteFile_defineProperty(RemoteFile, "initMap", function (map, store) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  map.set('type', 'remote-file');
  map.set('service', params.service);
  map.set('fileData', params.fileData || null);
  map.set('asyncContent', params.asyncContent || null);
  map.set('expanded', params.hasOwnProperty('expanded') ? params.expanded : true);
  var captionId = params.caption;
  if (!captionId) {
    var captionMap = store.createMap();
    Caption.initMap(captionMap, store, params.captionParams || {});
    captionId = captionMap.get('id');
  }
  map.set('caption', captionId);
  remoteFile_get(remoteFile_getPrototypeOf(RemoteFile), "initMap", RemoteFile) && remoteFile_get(remoteFile_getPrototypeOf(RemoteFile), "initMap", RemoteFile).call(RemoteFile, map, store, params);
});

RemoteFile.blotName = 'remote-file';
RemoteFile.tagName = 'DIV';
RemoteFile.wrapper = 'remoteFileWrapper';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/remoteFile/remoteFileWrapper.js
function remoteFileWrapper_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { remoteFileWrapper_typeof = function _typeof(obj) { return typeof obj; }; } else { remoteFileWrapper_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return remoteFileWrapper_typeof(obj); }












function remoteFileWrapper_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function remoteFileWrapper_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function remoteFileWrapper_createClass(Constructor, protoProps, staticProps) { if (protoProps) remoteFileWrapper_defineProperties(Constructor.prototype, protoProps); if (staticProps) remoteFileWrapper_defineProperties(Constructor, staticProps); return Constructor; }
function remoteFileWrapper_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { remoteFileWrapper_get = Reflect.get; } else { remoteFileWrapper_get = function _get(target, property, receiver) { var base = remoteFileWrapper_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return remoteFileWrapper_get(target, property, receiver || target); }
function remoteFileWrapper_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = remoteFileWrapper_getPrototypeOf(object); if (object === null) break; } return object; }
function remoteFileWrapper_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) remoteFileWrapper_setPrototypeOf(subClass, superClass); }
function remoteFileWrapper_setPrototypeOf(o, p) { remoteFileWrapper_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return remoteFileWrapper_setPrototypeOf(o, p); }
function remoteFileWrapper_createSuper(Derived) { var hasNativeReflectConstruct = remoteFileWrapper_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = remoteFileWrapper_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = remoteFileWrapper_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return remoteFileWrapper_possibleConstructorReturn(this, result); }; }
function remoteFileWrapper_possibleConstructorReturn(self, call) { if (call && (remoteFileWrapper_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return remoteFileWrapper_assertThisInitialized(self); }
function remoteFileWrapper_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function remoteFileWrapper_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function remoteFileWrapper_getPrototypeOf(o) { remoteFileWrapper_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return remoteFileWrapper_getPrototypeOf(o); }




var RemoteFileWrapper = /*#__PURE__*/function (_EmbedWrapper) {
  remoteFileWrapper_inherits(RemoteFileWrapper, _EmbedWrapper);
  var _super = remoteFileWrapper_createSuper(RemoteFileWrapper);
  function RemoteFileWrapper(domNode) {
    var _this;
    remoteFileWrapper_classCallCheck(this, RemoteFileWrapper);
    _this = _super.call(this, domNode);
    _this.domNode.classList.add('remote-file-wrapper');
    _this.caption = null;
    return _this;
  }
  remoteFileWrapper_createClass(RemoteFileWrapper, [{
    key: "getInnerTextLine",
    value: function getInnerTextLine() {
      return this.caption;
    }
  }, {
    key: "render",
    value: function render() {
      remoteFileWrapper_get(remoteFileWrapper_getPrototypeOf(RemoteFileWrapper.prototype), "render", this).call(this);
      if (this.embed && this.embed.hasFileData() && this.embed.props.serviceRendered) {
        if (!this.caption) {
          this.caption = parchment_default().create('caption');
          this.caption.map = this.store.getMap(this.map.get('caption'));
          this.caption.embedBlot = this.embed;
          this.appendChild(this.caption);
        }
        this.caption.render();
      } else {
        if (this.caption) {
          this.caption.remove();
          this.caption = null;
        }
      }
    }
  }]);
  return RemoteFileWrapper;
}(embedWrapperAbstract);

RemoteFileWrapper.allowedChildren = [RemoteFile, Caption];
RemoteFileWrapper.blotName = 'remoteFileWrapper';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/businessCard/businessCardAttachment.js
function businessCardAttachment_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function businessCardAttachment_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function businessCardAttachment_createClass(Constructor, protoProps, staticProps) { if (protoProps) businessCardAttachment_defineProperties(Constructor.prototype, protoProps); if (staticProps) businessCardAttachment_defineProperties(Constructor, staticProps); return Constructor; }
function businessCardAttachment_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var BusinessCardAttachment = /*#__PURE__*/function () {
  function BusinessCardAttachment() {
    var _this = this;
    businessCardAttachment_classCallCheck(this, BusinessCardAttachment);
    businessCardAttachment_defineProperty(this, "openImg", function (url) {
      _this.props.editor.plugins.lightBox.open(url);
    });
  }
  businessCardAttachment_createClass(BusinessCardAttachment, [{
    key: "renderAttachment",
    value: function renderAttachment(attachment) {
      var _this2 = this;
      return (0,preact_module.h)("div", {
        onClick: function onClick() {
          attachment && _this2.openImg(attachment.url);
        },
        className: "business-card-image-container"
      }, !attachment ? (0,preact_module.h)((loader2_default()), null) : (0,preact_module.h)("img", {
        src: attachment.url
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var hasTwoImages = this.props.hasFrontSide && this.props.hasBackSide;
      var frontSide = this.props.hasFrontSide ? this.renderAttachment(this.props.frontSideAttachment) : null;
      var backSide = this.props.hasBackSide ? this.renderAttachment(this.props.backSideAttachment) : null;
      return (0,preact_module.h)("div", {
        className: 'business-card-images ' + (hasTwoImages ? 'two-sides' : '')
      }, frontSide, backSide);
    }
  }]);
  return BusinessCardAttachment;
}();
/* harmony default export */ const businessCardAttachment = (BusinessCardAttachment);
// EXTERNAL MODULE: ./node_modules/equal/equal.js
var equal = __webpack_require__(52382);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/format.js
function format_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { format_typeof = function _typeof(obj) { return typeof obj; }; } else { format_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return format_typeof(obj); }
function format_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function format_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { format_ownKeys(Object(source), true).forEach(function (key) { format_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { format_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function format_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function format_slicedToArray(arr, i) { return format_arrayWithHoles(arr) || format_iterableToArrayLimit(arr, i) || format_unsupportedIterableToArray(arr, i) || format_nonIterableRest(); }
function format_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function format_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function format_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



















function format_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = format_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function format_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return format_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return format_arrayLikeToArray(o, minLen); }
function format_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function format_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function format_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function format_createClass(Constructor, protoProps, staticProps) { if (protoProps) format_defineProperties(Constructor.prototype, protoProps); if (staticProps) format_defineProperties(Constructor, staticProps); return Constructor; }
function format_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) format_setPrototypeOf(subClass, superClass); }
function format_setPrototypeOf(o, p) { format_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return format_setPrototypeOf(o, p); }
function format_createSuper(Derived) { var hasNativeReflectConstruct = format_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = format_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = format_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return format_possibleConstructorReturn(this, result); }; }
function format_possibleConstructorReturn(self, call) { if (call && (format_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return format_assertThisInitialized(self); }
function format_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function format_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function format_getPrototypeOf(o) { format_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return format_getPrototypeOf(o); }

var format_FormatAction = /*#__PURE__*/function (_Action) {
  format_inherits(FormatAction, _Action);
  var _super = format_createSuper(FormatAction);
  function FormatAction(type, params, editor) {
    format_classCallCheck(this, FormatAction);
    type = type || FormatAction.type;
    if (typeof params === 'string') {
      params = {
        style: params
      };
    }
    return _super.call(this, type, params, editor);
  }
  format_createClass(FormatAction, [{
    key: "before",
    value: function before(_ref) {
      var _this = this;
      var processingBlots = _ref.processingBlots;
      // выполняем beforeExec на каждом блоте
      var _iterator = format_createForOfIteratorHelper(processingBlots),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _blot3 = _step.value;
          if (_blot3.beforeExec) {
            _blot3.beforeExec(this);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (!this.params.hasOwnProperty('value')) {
        // надо установить значение для формата, используя текущий формат блотов, если хотябы один блот не имеет данный формат,
        // то форматирование устанавливается для всех. т.е. форматирование убирается только в том случае, если во всем выделении
        // задан данный формат
        var getFormat = function getFormat(blot, index, length) {
          // TODO: временная реализация
          if (!blot.getFormat) {
            var children = blot.children.map(function (blot) {
              return blot;
            });
            return children.reduce(function (formats, child) {
              if (child.getFormat) {
                var _this$editor$scroll$s = _this.editor.scroll.selection.getRange({
                    offsetBlot: child
                  }),
                  _this$editor$scroll$s2 = format_slicedToArray(_this$editor$scroll$s, 1),
                  blotRange = _this$editor$scroll$s2[0];
                return format_objectSpread(format_objectSpread({}, formats), child.getFormat(blotRange.index, blotRange.length));
              }
              return formats;
            }, {});
          }
          if (!length) {
            return blot.getFormat(index - 1, 1);
          } else {
            return blot.getFormat(index, length);
          }
        };
        var hasFormat = true;
        if (processingBlots.length == 1) {
          var blot = processingBlots[0];
          var range = this.getBlotRange(blot);
          var currentFormat = getFormat(blot, range.index, range.length);
          if (!currentFormat[this.params.style]) {
            hasFormat = false;
          }
        } else {
          var _iterator2 = format_createForOfIteratorHelper(processingBlots),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _blot = _step2.value;
              var _range = this.getBlotRange(_blot);
              if (processingBlots.length > 1 && (!_range || !_range.length)) {
                // в данном блоте ничего не выделено и выделение проходит через несколько блотов, игноируем
                continue;
              }
              var _currentFormat = getFormat(_blot, _range.index, _range.length);
              if (!_currentFormat[this.params.style]) {
                hasFormat = false;
                break;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
        var value = !hasFormat;
        this.params = Object.assign({}, this.params, {
          value: value
        });
      } else {
        var _iterator3 = format_createForOfIteratorHelper(processingBlots),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _blot2 = _step3.value;
            // пре-кешируем ренджи выделения для обрабатываемых блотов
            this.getBlotRange(_blot2);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      this.rangeBeforeFormat = this.editor.scroll.selection.getRange()[0];
    }
  }, {
    key: "after",
    value: function after() {
      this.editor.scroll.selection.setRange(this.rangeBeforeFormat);
    }
  }]);
  return FormatAction;
}(Action);

format_FormatAction.type = 'format';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/addTasksList.js
function addTasksList_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { addTasksList_typeof = function _typeof(obj) { return typeof obj; }; } else { addTasksList_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return addTasksList_typeof(obj); }














function addTasksList_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function addTasksList_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { addTasksList_ownKeys(Object(source), true).forEach(function (key) { addTasksList_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { addTasksList_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function addTasksList_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function addTasksList_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function addTasksList_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function addTasksList_createClass(Constructor, protoProps, staticProps) { if (protoProps) addTasksList_defineProperties(Constructor.prototype, protoProps); if (staticProps) addTasksList_defineProperties(Constructor, staticProps); return Constructor; }
function addTasksList_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) addTasksList_setPrototypeOf(subClass, superClass); }
function addTasksList_setPrototypeOf(o, p) { addTasksList_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return addTasksList_setPrototypeOf(o, p); }
function addTasksList_createSuper(Derived) { var hasNativeReflectConstruct = addTasksList_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = addTasksList_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = addTasksList_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return addTasksList_possibleConstructorReturn(this, result); }; }
function addTasksList_possibleConstructorReturn(self, call) { if (call && (addTasksList_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return addTasksList_assertThisInitialized(self); }
function addTasksList_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function addTasksList_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function addTasksList_getPrototypeOf(o) { addTasksList_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return addTasksList_getPrototypeOf(o); }

var AddTasksListAction = /*#__PURE__*/function (_Action) {
  addTasksList_inherits(AddTasksListAction, _Action);
  var _super = addTasksList_createSuper(AddTasksListAction);
  function AddTasksListAction(type, params, editor) {
    addTasksList_classCallCheck(this, AddTasksListAction);
    type = type || AddTasksListAction.type;
    if (typeof params === 'string') {
      params = {
        position: params
      };
    }
    return _super.call(this, type, params, editor);
  }
  addTasksList_createClass(AddTasksListAction, [{
    key: "getAllowedContainer",
    value: function getAllowedContainer(blot) {
      return {
        blot: blot,
        container: blot.container
      };
    }
  }, {
    key: "exec",
    value: function exec(_ref) {
      var processingBlots = _ref.processingBlots;
      if (processingBlots.length === 0) {
        processingBlots = this.editor.scroll.selectedBlocks.length !== 0 ? this.editor.scroll.selectedBlocks : false;
      }
      if (!processingBlots) return false;
      var processingBlot = this.params.position === 'above' ? processingBlots[0] : processingBlots[processingBlots.length - 1];
      var _this$getAllowedConta = this.getAllowedContainer(processingBlot),
        blot = _this$getAllowedConta.blot,
        container = _this$getAllowedConta.container;
      var _this$params = this.params,
        tasksListId = _this$params.tasksListId,
        _this$params$extra = _this$params.extra,
        extra = _this$params$extra === void 0 ? {} : _this$params$extra;
      if (this.params.position === 'above') {
        container.addBlot('tasks-list', addTasksList_objectSpread({
          tasksListId: tasksListId,
          before: blot.id
        }, extra));
      } else {
        container.addBlot('tasks-list', addTasksList_objectSpread({
          tasksListId: tasksListId,
          after: blot.id
        }, extra));
      }
      return true;
    }
  }]);
  return AddTasksListAction;
}(Action);

AddTasksListAction.type = 'add-tasks-list';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/addBoard.js
function addBoard_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { addBoard_typeof = function _typeof(obj) { return typeof obj; }; } else { addBoard_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return addBoard_typeof(obj); }














function addBoard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function addBoard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { addBoard_ownKeys(Object(source), true).forEach(function (key) { addBoard_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { addBoard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function addBoard_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function addBoard_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function addBoard_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function addBoard_createClass(Constructor, protoProps, staticProps) { if (protoProps) addBoard_defineProperties(Constructor.prototype, protoProps); if (staticProps) addBoard_defineProperties(Constructor, staticProps); return Constructor; }
function addBoard_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) addBoard_setPrototypeOf(subClass, superClass); }
function addBoard_setPrototypeOf(o, p) { addBoard_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return addBoard_setPrototypeOf(o, p); }
function addBoard_createSuper(Derived) { var hasNativeReflectConstruct = addBoard_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = addBoard_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = addBoard_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return addBoard_possibleConstructorReturn(this, result); }; }
function addBoard_possibleConstructorReturn(self, call) { if (call && (addBoard_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return addBoard_assertThisInitialized(self); }
function addBoard_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function addBoard_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function addBoard_getPrototypeOf(o) { addBoard_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return addBoard_getPrototypeOf(o); }

var AddBoardAction = /*#__PURE__*/function (_Action) {
  addBoard_inherits(AddBoardAction, _Action);
  var _super = addBoard_createSuper(AddBoardAction);
  function AddBoardAction(type, params, editor) {
    addBoard_classCallCheck(this, AddBoardAction);
    type = type || AddBoardAction.type;
    if (typeof params === 'string') {
      params = {
        position: params
      };
    }
    return _super.call(this, type, params, editor);
  }
  addBoard_createClass(AddBoardAction, [{
    key: "getAllowedContainer",
    value: function getAllowedContainer(blot) {
      return {
        blot: blot,
        container: blot.container
      };
    }
  }, {
    key: "exec",
    value: function exec(_ref) {
      var processingBlots = _ref.processingBlots;
      if (processingBlots.length === 0) {
        processingBlots = this.editor.scroll.selectedBlocks.length !== 0 ? this.editor.scroll.selectedBlocks : false;
      }
      if (!processingBlots) return false;
      var processingBlot = this.params.position === 'above' ? processingBlots[0] : processingBlots[processingBlots.length - 1];
      var _this$getAllowedConta = this.getAllowedContainer(processingBlot),
        blot = _this$getAllowedConta.blot,
        container = _this$getAllowedConta.container;
      var _this$params = this.params,
        boardId = _this$params.boardId,
        _this$params$extra = _this$params.extra,
        extra = _this$params$extra === void 0 ? {} : _this$params$extra;
      if (this.params.position === 'above') {
        container.addBlot('board', addBoard_objectSpread({
          boardId: boardId,
          before: blot.id
        }, extra));
      } else {
        container.addBlot('board', addBoard_objectSpread({
          boardId: boardId,
          after: blot.id
        }, extra));
      }
      return true;
    }
  }]);
  return AddBoardAction;
}(Action);

AddBoardAction.type = 'add-board';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/clearFormat.js
function clearFormat_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { clearFormat_typeof = function _typeof(obj) { return typeof obj; }; } else { clearFormat_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return clearFormat_typeof(obj); }












function clearFormat_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = clearFormat_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function clearFormat_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return clearFormat_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return clearFormat_arrayLikeToArray(o, minLen); }
function clearFormat_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function clearFormat_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function clearFormat_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function clearFormat_createClass(Constructor, protoProps, staticProps) { if (protoProps) clearFormat_defineProperties(Constructor.prototype, protoProps); if (staticProps) clearFormat_defineProperties(Constructor, staticProps); return Constructor; }
function clearFormat_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) clearFormat_setPrototypeOf(subClass, superClass); }
function clearFormat_setPrototypeOf(o, p) { clearFormat_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return clearFormat_setPrototypeOf(o, p); }
function clearFormat_createSuper(Derived) { var hasNativeReflectConstruct = clearFormat_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = clearFormat_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = clearFormat_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return clearFormat_possibleConstructorReturn(this, result); }; }
function clearFormat_possibleConstructorReturn(self, call) { if (call && (clearFormat_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return clearFormat_assertThisInitialized(self); }
function clearFormat_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function clearFormat_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function clearFormat_getPrototypeOf(o) { clearFormat_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return clearFormat_getPrototypeOf(o); }

var ClearFormatAction = /*#__PURE__*/function (_Action) {
  clearFormat_inherits(ClearFormatAction, _Action);
  var _super = clearFormat_createSuper(ClearFormatAction);
  function ClearFormatAction(type, params, editor) {
    clearFormat_classCallCheck(this, ClearFormatAction);
    type = type || ClearFormatAction.type;
    if (params) {
      params = false;
    }
    return _super.call(this, type, params, editor);
  }
  clearFormat_createClass(ClearFormatAction, [{
    key: "before",
    value: function before(_ref) {
      var processingBlots = _ref.processingBlots;
      // выполняем beforeExec на каждом блоте
      var _iterator = clearFormat_createForOfIteratorHelper(processingBlots),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var blot = _step.value;
          if (blot.beforeExec) {
            blot.beforeExec(this);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var _iterator2 = clearFormat_createForOfIteratorHelper(processingBlots),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _blot = _step2.value;
          // пре-кешируем ренджи выделения для обрабатываемых блотов
          this.getBlotRange(_blot);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.rangeBeforeFormat = this.editor.scroll.selection.getRange()[0];
    }
  }, {
    key: "after",
    value: function after() {
      this.editor.scroll.selection.setRange(this.rangeBeforeFormat);
    }
  }]);
  return ClearFormatAction;
}(Action);

ClearFormatAction.type = 'clear-formatting';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/addGrid.js
function addGrid_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { addGrid_typeof = function _typeof(obj) { return typeof obj; }; } else { addGrid_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return addGrid_typeof(obj); }
function addGrid_slicedToArray(arr, i) { return addGrid_arrayWithHoles(arr) || addGrid_iterableToArrayLimit(arr, i) || addGrid_unsupportedIterableToArray(arr, i) || addGrid_nonIterableRest(); }
function addGrid_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function addGrid_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function addGrid_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
















function addGrid_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = addGrid_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function addGrid_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return addGrid_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return addGrid_arrayLikeToArray(o, minLen); }
function addGrid_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function addGrid_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function addGrid_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function addGrid_createClass(Constructor, protoProps, staticProps) { if (protoProps) addGrid_defineProperties(Constructor.prototype, protoProps); if (staticProps) addGrid_defineProperties(Constructor, staticProps); return Constructor; }
function addGrid_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) addGrid_setPrototypeOf(subClass, superClass); }
function addGrid_setPrototypeOf(o, p) { addGrid_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return addGrid_setPrototypeOf(o, p); }
function addGrid_createSuper(Derived) { var hasNativeReflectConstruct = addGrid_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = addGrid_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = addGrid_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return addGrid_possibleConstructorReturn(this, result); }; }
function addGrid_possibleConstructorReturn(self, call) { if (call && (addGrid_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return addGrid_assertThisInitialized(self); }
function addGrid_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function addGrid_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function addGrid_getPrototypeOf(o) { addGrid_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return addGrid_getPrototypeOf(o); }


var AddGridAction = /*#__PURE__*/function (_Action) {
  addGrid_inherits(AddGridAction, _Action);
  var _super = addGrid_createSuper(AddGridAction);
  function AddGridAction(type, params, editor) {
    var _this;
    addGrid_classCallCheck(this, AddGridAction);
    type = type || AddGridAction.type;
    if (typeof params === 'string') {
      params = {
        position: params
      };
    }
    _this = _super.call(this, type, params, editor);
    _this.setRangeInto = null;
    _this.allowWithoutFocus = true;
    return _this;
  }
  addGrid_createClass(AddGridAction, [{
    key: "updateBlock",
    value: function updateBlock(block, parent_id, index) {
      var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      block = block.getWrappedBlot();
      var parentBlot = this.editor.findById(parent_id);
      parentBlot.moveChild(block, index, context);
      if (context.subListItems) {
        var moveIndex = index + 1;
        var _iterator = addGrid_createForOfIteratorHelper(context.subListItems),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            parentBlot.moveChild(item, moveIndex, context);
            moveIndex++;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }, {
    key: "findParentGridCol",
    value: function findParentGridCol(blot) {
      while (blot) {
        if (blot.constructor.blotName === 'gridCol') {
          return blot;
        }
        blot = blot.parent;
      }
      return null;
    }
  }, {
    key: "before",
    value: function before(opts) {
      var _this2 = this;
      this.editor.scroll.batchStart();
      if (opts.moveBlocks && opts.moveBlocks.length) {
        opts.moveBlocks.map(function (block) {
          _this2.getBlotRange(block);
        });
      }
      var _this$editor$scroll$s = this.editor.scroll.selection.getRange(),
        _this$editor$scroll$s2 = addGrid_slicedToArray(_this$editor$scroll$s, 1),
        range = _this$editor$scroll$s2[0];
      this.cache.rangeLength = range ? range.length : 0;
    }
  }, {
    key: "after",
    value: function after(opts) {
      this.editor.scroll.batchEnd();
      this.editor.scroll.update('user');
      var ids = Object.keys(this.cache.blotRange);
      if (this.setRangeInto) {
        this.editor.scroll.selection.setRange({
          index: this.setRangeInto.offset(this.editor.scroll),
          length: 0
        });
      }
    }

    /**
    * Добавляет новую колонку с "side" стороны от блока "hover"
    * @param {string} side Сторона, с которой надо добавить новую колонку
    * @param {Blot} block Блот, на который ориентироваться для добавления новой колонки
    * @param {array} moveBlocks Массив блотов, которые будут перенесены в новую колонку, может быть false если нужно добавить пустую колонку
    * @param {object} context Контекст для обновления (переноса) блоков
    */
  }, {
    key: "addGrid",
    value: function addGrid(side, block) {
      var _this3 = this;
      var moveBlocks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var gridColForLeft, gridColForRight, newParagraph;
      var parentGridCol = this.findParentGridCol(block);
      var grid;
      if (side === 'left') {
        if (parentGridCol) {
          var _parentGridCol$parent = parentGridCol.parent.addBlot('gridCol', {
              index: Math.max(0, parentGridCol.index)
            }),
            id = _parentGridCol$parent.id;
          gridColForLeft = this.editor.findById(id);
        } else {
          var _id;
          //handle listItem
          if (block.isListItem && (!moveBlocks || !moveBlocks.length)) {
            //split list
            var splitIndex = block.parent.getChildIndex(block.id);
            // если ListItem имеет псевдодочерние элементы, делим список по последнему псевдодочернему элементу
            if (block.getSubItems) {
              var subListItems = block.getSubItems();
              if (subListItems.length) {
                splitIndex = block.parent.getChildIndex(subListItems[subListItems.length - 1].id);
                context.subListItems = subListItems;
              }
            }
            _id = block.parent.splitWithBlot(splitIndex, 'grid').id;
            console.log('Split list index', splitIndex, 'grid id', _id);
          } else {
            // create grid
            _id = this.editor.scroll.addBlot('grid', {
              index: block.index
            }).id;
          }
          grid = this.editor.findById(_id);
          gridColForLeft = grid.children.head;
          gridColForRight = grid.children.head.next;
        }
        if (moveBlocks && moveBlocks.length !== 0) {
          var counter = 0;
          moveBlocks.forEach(function (block) {
            _this3.updateBlock(block, gridColForLeft.id, counter, context);
            counter++;
          });
        } else {
          var pId = gridColForLeft.addBlot('paragraph').id;
          newParagraph = this.editor.findById(pId);
        }
        if (gridColForRight) {
          this.updateBlock(block, gridColForRight.id, 0, context);
        }
      } else if (side === 'right') {
        if (parentGridCol) {
          var _parentGridCol$parent2 = parentGridCol.parent.addBlot('gridCol', {
              index: parentGridCol.index + 1
            }),
            _id2 = _parentGridCol$parent2.id;
          gridColForRight = this.editor.findById(_id2);
        } else {
          var _id3;
          //handle listItem
          if (block.isListItem && (!moveBlocks || !moveBlocks.length)) {
            //split list
            var _splitIndex = block.parent.getChildIndex(block.id);
            // если ListItem имеет псевдодочерние элементы, делим список по последнему псевдодочернему элементу
            if (block.getSubItems) {
              var _subListItems = block.getSubItems();
              if (_subListItems.length) {
                _splitIndex = block.parent.getChildIndex(_subListItems[_subListItems.length - 1].id);
                context.subListItems = _subListItems;
              }
            }
            _id3 = block.parent.splitWithBlot(_splitIndex, 'grid').id;
          } else {
            // create grid
            _id3 = this.editor.scroll.addBlot('grid', {
              index: block.index
            }).id;
          }
          grid = this.editor.findById(_id3);
          gridColForLeft = grid.children.head;
          gridColForRight = grid.children.head.next;
        }
        if (moveBlocks && moveBlocks.length !== 0) {
          var _counter = 0;
          moveBlocks.forEach(function (block) {
            _this3.updateBlock(block, gridColForRight.id, _counter, context);
            _counter++;
          });
        } else {
          var _pId = gridColForRight.addBlot('paragraph').id;
          newParagraph = this.editor.findById(_pId);
        }
        if (gridColForLeft) {
          this.updateBlock(block, gridColForLeft.id, 0, context);
        }
      }
      if (typeof newParagraph !== 'undefined' && newParagraph) {
        this.setRangeInto = newParagraph;
      }
    }
  }, {
    key: "exec",
    value: function exec(params) {
      params = this.constructor.normalizeParams(params, this.editor);
      if (params.moveBlocks.length === 0) {
        return false;
      }
      if (params.processingBlots) {
        this.addGrid(this.params.position, params.processingBlots, params.moveBlocks, params.context);
        return true;
      } else {
        return false;
      }
    }
  }], [{
    key: "normalizeParams",
    value: function normalizeParams(params, editor) {
      params = Object.assign({}, params);
      if (!params.processingBlots || params.processingBlots.length === 0) {
        params.processingBlots = editor.scroll.selectedBlocks.length !== 0 ? editor.scroll.selectedBlocks[0] : false;
      }
      if (!params.moveBlocks) params.moveBlocks = false;
      if (!params.context) params.context = {};
      return params;
    }
  }]);
  return AddGridAction;
}(Action);
AddGridAction.type = 'add-grid';
/* harmony default export */ const actions_addGrid = (AddGridAction);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/addImage.js
function addImage_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { addImage_typeof = function _typeof(obj) { return typeof obj; }; } else { addImage_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return addImage_typeof(obj); }











function addImage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function addImage_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { addImage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { addImage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function addImage_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function addImage_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function addImage_createClass(Constructor, protoProps, staticProps) { if (protoProps) addImage_defineProperties(Constructor.prototype, protoProps); if (staticProps) addImage_defineProperties(Constructor, staticProps); return Constructor; }
function addImage_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) addImage_setPrototypeOf(subClass, superClass); }
function addImage_setPrototypeOf(o, p) { addImage_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return addImage_setPrototypeOf(o, p); }
function addImage_createSuper(Derived) { var hasNativeReflectConstruct = addImage_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = addImage_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = addImage_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return addImage_possibleConstructorReturn(this, result); }; }
function addImage_possibleConstructorReturn(self, call) { if (call && (addImage_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return addImage_assertThisInitialized(self); }
function addImage_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function addImage_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function addImage_getPrototypeOf(o) { addImage_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return addImage_getPrototypeOf(o); }

var AddImageAction = /*#__PURE__*/function (_Action) {
  addImage_inherits(AddImageAction, _Action);
  var _super = addImage_createSuper(AddImageAction);
  function AddImageAction(type, params, editor) {
    addImage_classCallCheck(this, AddImageAction);
    type = type || AddImageAction.type;
    return _super.call(this, type, params || {}, editor);
  }

  // TODO move source into params for consistency among actions
  addImage_createClass(AddImageAction, [{
    key: "exec",
    value: function () {
      var _exec = addImage_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
        var source, files, blot, validateRes, res, addedIds, addedId;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                source = _ref.source;
                files = this.params.files;
                blot = this.params.blot;
                if (this.params.blotId) {
                  blot = this.editor.findById(this.params.blotId);
                }
                if (files) {
                  _context.next = 10;
                  break;
                }
                if (this.editor.plugins.attachmentManager.isMethodImplemented('chooseFile')) {
                  _context.next = 7;
                  break;
                }
                return _context.abrupt("return", console.warn('chooseFile is not implemented in the attachmentManager plugin, skip executing add-file action'));
              case 7:
                _context.next = 9;
                return this.editor.plugins.attachmentManager.chooseFile({
                  multiple: true,
                  source: source,
                  blotName: 'image',
                  blotId: blot ? blot.id : undefined
                });
              case 9:
                files = _context.sent;
              case 10:
                if (files) {
                  _context.next = 12;
                  break;
                }
                return _context.abrupt("return", false);
              case 12:
                _context.next = 14;
                return this.editor.plugins.attachmentManager.validateFiles(files);
              case 14:
                validateRes = _context.sent;
                if (validateRes) {
                  _context.next = 17;
                  break;
                }
                return _context.abrupt("return");
              case 17:
                if (blot) {
                  _context.next = 28;
                  break;
                }
                // если не задан image-блот, то конвертим в image текущий блот
                res = this.editor.exec('convert-blot', {
                  type: 'image'
                });
                if (!res.action) {
                  console.error('res does not contain action', res);
                }
                addedIds = res.action.results[0].addedIds;
                if (addedIds.length) {
                  _context.next = 23;
                  break;
                }
                return _context.abrupt("return", false);
              case 23:
                if (!(addedIds.length !== 1)) {
                  _context.next = 26;
                  break;
                }
                console.error('addImage expects 1 id to be in the result of convert-blot, but got', addedIds);
                return _context.abrupt("return", false);
              case 26:
                addedId = addedIds[0];
                blot = this.editor.findById(addedId);
              case 28:
                blot.clearAttachment();
                blot.setHTMLFilesForUpload(files, {
                  dontPutCaretAfter: this.params.dontPutCaretAfter || false
                });
                return _context.abrupt("return", true);
              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function exec(_x) {
        return _exec.apply(this, arguments);
      }
      return exec;
    }()
  }]);
  return AddImageAction;
}(Action);

AddImageAction.type = 'add-image';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/addBusinessCard.js
function addBusinessCard_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { addBusinessCard_typeof = function _typeof(obj) { return typeof obj; }; } else { addBusinessCard_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return addBusinessCard_typeof(obj); }











function addBusinessCard_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function addBusinessCard_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { addBusinessCard_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { addBusinessCard_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function addBusinessCard_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function addBusinessCard_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function addBusinessCard_createClass(Constructor, protoProps, staticProps) { if (protoProps) addBusinessCard_defineProperties(Constructor.prototype, protoProps); if (staticProps) addBusinessCard_defineProperties(Constructor, staticProps); return Constructor; }
function addBusinessCard_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) addBusinessCard_setPrototypeOf(subClass, superClass); }
function addBusinessCard_setPrototypeOf(o, p) { addBusinessCard_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return addBusinessCard_setPrototypeOf(o, p); }
function addBusinessCard_createSuper(Derived) { var hasNativeReflectConstruct = addBusinessCard_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = addBusinessCard_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = addBusinessCard_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return addBusinessCard_possibleConstructorReturn(this, result); }; }
function addBusinessCard_possibleConstructorReturn(self, call) { if (call && (addBusinessCard_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return addBusinessCard_assertThisInitialized(self); }
function addBusinessCard_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function addBusinessCard_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function addBusinessCard_getPrototypeOf(o) { addBusinessCard_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return addBusinessCard_getPrototypeOf(o); }

var AddBusinessCardAction = /*#__PURE__*/function (_Action) {
  addBusinessCard_inherits(AddBusinessCardAction, _Action);
  var _super = addBusinessCard_createSuper(AddBusinessCardAction);
  function AddBusinessCardAction(type, params, editor) {
    addBusinessCard_classCallCheck(this, AddBusinessCardAction);
    type = type || AddBusinessCardAction.type;
    return _super.call(this, type, params || {}, editor);
  }
  addBusinessCard_createClass(AddBusinessCardAction, [{
    key: "exec",
    value: function () {
      var _exec = addBusinessCard_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
        var processingBlots, frontSideAttachmentGlobalId, backSideAttachmentGlobalId, fields, replaceBlotId, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                processingBlots = _ref.processingBlots;
                frontSideAttachmentGlobalId = this.params.frontSideAttachmentGlobalId;
                backSideAttachmentGlobalId = this.params.backSideAttachmentGlobalId;
                fields = this.params.fields;
                replaceBlotId = this.params.replaceBlotId;
                res = this.editor.exec('convert-blot', {
                  type: 'businessCard',
                  frontSideAttachmentGlobalId: frontSideAttachmentGlobalId,
                  backSideAttachmentGlobalId: backSideAttachmentGlobalId,
                  fields: fields,
                  replaceBlotId: replaceBlotId
                });
                return _context.abrupt("return", true);
              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function exec(_x) {
        return _exec.apply(this, arguments);
      }
      return exec;
    }()
  }]);
  return AddBusinessCardAction;
}(Action);

AddBusinessCardAction.type = 'add-business-card';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/moveBlotOneStep.js
function moveBlotOneStep_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { moveBlotOneStep_typeof = function _typeof(obj) { return typeof obj; }; } else { moveBlotOneStep_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return moveBlotOneStep_typeof(obj); }













function moveBlotOneStep_slicedToArray(arr, i) { return moveBlotOneStep_arrayWithHoles(arr) || moveBlotOneStep_iterableToArrayLimit(arr, i) || moveBlotOneStep_unsupportedIterableToArray(arr, i) || moveBlotOneStep_nonIterableRest(); }
function moveBlotOneStep_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function moveBlotOneStep_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return moveBlotOneStep_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return moveBlotOneStep_arrayLikeToArray(o, minLen); }
function moveBlotOneStep_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function moveBlotOneStep_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function moveBlotOneStep_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function moveBlotOneStep_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function moveBlotOneStep_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function moveBlotOneStep_createClass(Constructor, protoProps, staticProps) { if (protoProps) moveBlotOneStep_defineProperties(Constructor.prototype, protoProps); if (staticProps) moveBlotOneStep_defineProperties(Constructor, staticProps); return Constructor; }
function moveBlotOneStep_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) moveBlotOneStep_setPrototypeOf(subClass, superClass); }
function moveBlotOneStep_setPrototypeOf(o, p) { moveBlotOneStep_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return moveBlotOneStep_setPrototypeOf(o, p); }
function moveBlotOneStep_createSuper(Derived) { var hasNativeReflectConstruct = moveBlotOneStep_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = moveBlotOneStep_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = moveBlotOneStep_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return moveBlotOneStep_possibleConstructorReturn(this, result); }; }
function moveBlotOneStep_possibleConstructorReturn(self, call) { if (call && (moveBlotOneStep_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return moveBlotOneStep_assertThisInitialized(self); }
function moveBlotOneStep_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function moveBlotOneStep_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function moveBlotOneStep_getPrototypeOf(o) { moveBlotOneStep_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return moveBlotOneStep_getPrototypeOf(o); }

var MoveBlotOneStep = /*#__PURE__*/function (_Action) {
  moveBlotOneStep_inherits(MoveBlotOneStep, _Action);
  var _super = moveBlotOneStep_createSuper(MoveBlotOneStep);
  function MoveBlotOneStep(type, params, editor) {
    var _this;
    moveBlotOneStep_classCallCheck(this, MoveBlotOneStep);
    type = type || MoveBlotOneStep.type;
    _this = _super.call(this, type, params, editor);
    _this.rangeBefore = null;
    return _this;
  }
  moveBlotOneStep_createClass(MoveBlotOneStep, [{
    key: "getBlotsToProcess",
    value: function getBlotsToProcess(processingBlots) {
      if (processingBlots[0].constructor.blotName === 'scroll') {
        processingBlots = this.editor.scroll.selectedBlocks;
      }
      return processingBlots;
    }
  }, {
    key: "before",
    value: function before(_ref) {
      var processingBlots = _ref.processingBlots;
      var blot = this.getBlotsToProcess(processingBlots)[0];
      var _this$editor$scroll$s = this.editor.scroll.selection.getRange({
          offsetBlot: blot
        }),
        _this$editor$scroll$s2 = moveBlotOneStep_slicedToArray(_this$editor$scroll$s, 1),
        rangeBefore = _this$editor$scroll$s2[0];
      this.rangeBefore = rangeBefore;
    }
  }, {
    key: "after",
    value: function after(_ref2) {
      var processingBlots = _ref2.processingBlots;
      var blot = this.getBlotsToProcess(processingBlots)[0];
      var newRange = {
        index: blot.offset(this.editor.scroll) + this.rangeBefore.index,
        length: 0
      };
      this.editor.scroll.selection.setRange(newRange);
      this.editor.plugins.selectionScroller.ensureSelectionVisible();
    }
  }, {
    key: "exec",
    value: function exec(_ref3) {
      var processingBlots = _ref3.processingBlots;
      var editor = this.editor;
      processingBlots = this.getBlotsToProcess(processingBlots);
      if (processingBlots.length !== 1) {
        throw new Error('processingBlots must contain only single blot');
      }
      if (!['up', 'down'].includes(this.params.direction)) {
        throw new Error('direction must be either up or down');
      }
      var blot = processingBlots[0];
      var blotWrapper = blot.getWrapper();
      var container = blot.container;
      var destIndex;
      if (this.params.direction === 'up') {
        var prevBlotIndex = container.getChildIndex(blotWrapper.prev.id);
        destIndex = prevBlotIndex;
      } else {
        var nextBlotIndex = container.getChildIndex(blotWrapper.next.id);
        destIndex = nextBlotIndex + 1;
      }
      container.moveChild(blot.id, destIndex);
    }
  }]);
  return MoveBlotOneStep;
}(Action);

MoveBlotOneStep.type = 'move-blot-one-step';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/convertBlot.js
function convertBlot_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { convertBlot_typeof = function _typeof(obj) { return typeof obj; }; } else { convertBlot_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return convertBlot_typeof(obj); }













function convertBlot_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function convertBlot_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function convertBlot_createClass(Constructor, protoProps, staticProps) { if (protoProps) convertBlot_defineProperties(Constructor.prototype, protoProps); if (staticProps) convertBlot_defineProperties(Constructor, staticProps); return Constructor; }
function convertBlot_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { convertBlot_get = Reflect.get; } else { convertBlot_get = function _get(target, property, receiver) { var base = convertBlot_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return convertBlot_get(target, property, receiver || target); }
function convertBlot_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = convertBlot_getPrototypeOf(object); if (object === null) break; } return object; }
function convertBlot_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) convertBlot_setPrototypeOf(subClass, superClass); }
function convertBlot_setPrototypeOf(o, p) { convertBlot_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return convertBlot_setPrototypeOf(o, p); }
function convertBlot_createSuper(Derived) { var hasNativeReflectConstruct = convertBlot_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = convertBlot_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = convertBlot_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return convertBlot_possibleConstructorReturn(this, result); }; }
function convertBlot_possibleConstructorReturn(self, call) { if (call && (convertBlot_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return convertBlot_assertThisInitialized(self); }
function convertBlot_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function convertBlot_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function convertBlot_getPrototypeOf(o) { convertBlot_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return convertBlot_getPrototypeOf(o); }


var TOGGLE_BLOTS = ['toggle', 'step', 'hLarge-toggle', 'hMedium-toggle', 'hSmall-toggle'];
var ConvertBlotAction = /*#__PURE__*/function (_Action) {
  convertBlot_inherits(ConvertBlotAction, _Action);
  var _super = convertBlot_createSuper(ConvertBlotAction);
  function ConvertBlotAction(type, params, editor) {
    convertBlot_classCallCheck(this, ConvertBlotAction);
    type = type || ConvertBlotAction.type;
    return _super.call(this, type, params, editor);
  }
  convertBlot_createClass(ConvertBlotAction, [{
    key: "exec",
    value: function exec(params) {
      if (TOGGLE_BLOTS.includes(this.params.type) && params.processingBlots) {
        params.processingBlots = params.processingBlots.filter(function (blot) {
          return !searchUp(blot, function (b) {
            return b.constructor.blotName === 'toggleContent';
          });
        });
      }
      params.abortOnFirstProcess = true;
      return convertBlot_get(convertBlot_getPrototypeOf(ConvertBlotAction.prototype), "exec", this).call(this, params);
    }
  }]);
  return ConvertBlotAction;
}(Action);

ConvertBlotAction.type = 'convert-blot';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/setBackground.js
function setBackground_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { setBackground_typeof = function _typeof(obj) { return typeof obj; }; } else { setBackground_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return setBackground_typeof(obj); }









function setBackground_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function setBackground_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function setBackground_createClass(Constructor, protoProps, staticProps) { if (protoProps) setBackground_defineProperties(Constructor.prototype, protoProps); if (staticProps) setBackground_defineProperties(Constructor, staticProps); return Constructor; }
function setBackground_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) setBackground_setPrototypeOf(subClass, superClass); }
function setBackground_setPrototypeOf(o, p) { setBackground_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return setBackground_setPrototypeOf(o, p); }
function setBackground_createSuper(Derived) { var hasNativeReflectConstruct = setBackground_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = setBackground_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = setBackground_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return setBackground_possibleConstructorReturn(this, result); }; }
function setBackground_possibleConstructorReturn(self, call) { if (call && (setBackground_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return setBackground_assertThisInitialized(self); }
function setBackground_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function setBackground_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function setBackground_getPrototypeOf(o) { setBackground_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return setBackground_getPrototypeOf(o); }

var SetBackgroundAction = /*#__PURE__*/function (_Action) {
  setBackground_inherits(SetBackgroundAction, _Action);
  var _super = setBackground_createSuper(SetBackgroundAction);
  function SetBackgroundAction(type, params, editor) {
    setBackground_classCallCheck(this, SetBackgroundAction);
    type = type || SetBackgroundAction.type;
    return _super.call(this, type, params, editor);
  }
  setBackground_createClass(SetBackgroundAction, [{
    key: "after",
    value: function after() {
      this.editor.scroll.selection.focus({
        preventScroll: true
      });
    }
  }]);
  return SetBackgroundAction;
}(Action);

SetBackgroundAction.type = 'set-background';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/beginMention.js
function beginMention_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { beginMention_typeof = function _typeof(obj) { return typeof obj; }; } else { beginMention_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return beginMention_typeof(obj); }











function beginMention_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function beginMention_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { beginMention_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { beginMention_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function beginMention_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function beginMention_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function beginMention_createClass(Constructor, protoProps, staticProps) { if (protoProps) beginMention_defineProperties(Constructor.prototype, protoProps); if (staticProps) beginMention_defineProperties(Constructor, staticProps); return Constructor; }
function beginMention_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) beginMention_setPrototypeOf(subClass, superClass); }
function beginMention_setPrototypeOf(o, p) { beginMention_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return beginMention_setPrototypeOf(o, p); }
function beginMention_createSuper(Derived) { var hasNativeReflectConstruct = beginMention_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = beginMention_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = beginMention_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return beginMention_possibleConstructorReturn(this, result); }; }
function beginMention_possibleConstructorReturn(self, call) { if (call && (beginMention_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return beginMention_assertThisInitialized(self); }
function beginMention_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function beginMention_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function beginMention_getPrototypeOf(o) { beginMention_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return beginMention_getPrototypeOf(o); }

var BeginMentionAction = /*#__PURE__*/function (_Action) {
  beginMention_inherits(BeginMentionAction, _Action);
  var _super = beginMention_createSuper(BeginMentionAction);
  function BeginMentionAction(type, params, editor) {
    beginMention_classCallCheck(this, BeginMentionAction);
    type = type || BeginMentionAction.type;
    return _super.call(this, type, params || {}, editor);
  }
  beginMention_createClass(BeginMentionAction, [{
    key: "exec",
    value: function () {
      var _exec = beginMention_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
        var processingBlots, blot, blotRange, addText, newBlotRange;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                processingBlots = _ref.processingBlots;
                if (!(processingBlots.length > 1 || !processingBlots.length)) {
                  _context.next = 3;
                  break;
                }
                return _context.abrupt("return", false);
              case 3:
                blot = processingBlots[0];
                blotRange = this.editor.scroll.selection.getRange({
                  offsetBlot: blot
                })[0];
                if (!(!blotRange || blotRange.length > 0)) {
                  _context.next = 7;
                  break;
                }
                return _context.abrupt("return", false);
              case 7:
                addText = '';
                if (blotRange.index === 0 || blot.getText(blotRange.index - 1, 1) === ' ') {} else {
                  addText += ' ';
                }
                addText += '@';
                blot.map.get('characters').applyDelta([{
                  retain: blotRange.index
                }, {
                  insert: addText
                }]);
                this.editor.scroll.selection.setRange({
                  index: blot.offset(this.editor.scroll) + blotRange.index + addText.length,
                  length: 0
                });
                newBlotRange = this.editor.scroll.selection.getRange({
                  offsetBlot: blot
                })[0];
                this.editor.plugins.mentionManager.start(blot, newBlotRange);
                return _context.abrupt("return", true);
              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function exec(_x) {
        return _exec.apply(this, arguments);
      }
      return exec;
    }()
  }]);
  return BeginMentionAction;
}(Action);

BeginMentionAction.type = 'begin-mention';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/duplicate.js
function duplicate_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = duplicate_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function duplicate_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return duplicate_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return duplicate_arrayLikeToArray(o, minLen); }
function duplicate_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function duplicate_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { duplicate_typeof = function _typeof(obj) { return typeof obj; }; } else { duplicate_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return duplicate_typeof(obj); }














function duplicate_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function duplicate_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function duplicate_createClass(Constructor, protoProps, staticProps) { if (protoProps) duplicate_defineProperties(Constructor.prototype, protoProps); if (staticProps) duplicate_defineProperties(Constructor, staticProps); return Constructor; }
function duplicate_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) duplicate_setPrototypeOf(subClass, superClass); }
function duplicate_setPrototypeOf(o, p) { duplicate_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return duplicate_setPrototypeOf(o, p); }
function duplicate_createSuper(Derived) { var hasNativeReflectConstruct = duplicate_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = duplicate_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = duplicate_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return duplicate_possibleConstructorReturn(this, result); }; }
function duplicate_possibleConstructorReturn(self, call) { if (call && (duplicate_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return duplicate_assertThisInitialized(self); }
function duplicate_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function duplicate_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function duplicate_getPrototypeOf(o) { duplicate_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return duplicate_getPrototypeOf(o); }


var DuplicateAction = /*#__PURE__*/function (_Action) {
  duplicate_inherits(DuplicateAction, _Action);
  var _super = duplicate_createSuper(DuplicateAction);
  function DuplicateAction(type, params, editor) {
    duplicate_classCallCheck(this, DuplicateAction);
    type = type || DuplicateAction.type;
    return _super.call(this, type, params, editor);
  }
  duplicate_createClass(DuplicateAction, [{
    key: "getCloneIds",
    value: function getCloneIds() {
      var blots = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var items = [];
      var newList = false;
      blots && blots.length > 0 && blots.map(function (blot) {
        if (blot.parent.constructor.blotName === 'list') {
          var subItems = [];
          if (blot.isCollapsed()) {
            subItems = blot.getSubItems().map(function (sub) {
              return sub.id;
            });
          }
          var item = items[items.length - 1];
          var listItem = blot.id;
          if (subItems.length) {
            listItem = {
              blotId: blot.id,
              subItems: subItems
            };
          }
          if (duplicate_typeof(item) === 'object' && item.listId === blot.parent.id) {
            item.children.push(listItem);
          } else {
            item = {};
            item.listId = blot.parent.id;
            item.children = [];
            item.children.push(listItem);
            items.push(item);
          }
        } else if (blot.parent.constructor.blotName === 'syntax') {
          var _item = items[items.length - 1];
          _item = {};
          _item.syntaxId = blot.parent.id;
          _item.children = [];
          _item.children.push(blot.id);
          items.push(_item);
        } else {
          items.push(blot.id);
        }
      });
      return items;
    }
  }, {
    key: "getDuplicatedBlots",
    value: function getDuplicatedBlots() {
      var _this = this;
      if (this.duplicatedIds && this.duplicatedIds.length) {
        return this.duplicatedIds.map(function (id) {
          return _this.editor.findById(id);
        });
      }
      return null;
    }
  }, {
    key: "exec",
    value: function exec(_ref) {
      var _this2 = this;
      var processingBlots = _ref.processingBlots;
      var limitManager = this.editor.plugins.limitManager;
      var duplicateBlots = processingBlots && processingBlots.length ? processingBlots : this.editor.scroll.selectedBlocks;
      if (limitManager && !limitManager.canAddBlot({
        type: 'any',
        amount: duplicateBlots.length,
        alert: true
      })) {
        return false;
      }
      duplicateBlots = duplicateBlots.filter(function (blot) {
        // отсеиваем содержимое выделяемых блоков являющимися также "контейнерами" для других
        var collapsibleContainer = searchUp(blot, function (b) {
          return b.isCollapsibleContainer;
        });
        if (collapsibleContainer && collapsibleContainer.getSelectableBlot && collapsibleContainer.getSelectableBlot().props.selected) {
          return false;
        }
        return !blot.isBlotLocked && blot.constructor.blotName !== 'caption';
      });
      var cloneIds = this.getCloneIds(duplicateBlots);
      var insertedIds = [];
      cloneIds.map(function (id) {
        var blot, insertContainer, insertId, insertIndex;
        if (duplicate_typeof(id) !== 'object' || typeof id.syntaxId !== 'undefined') {
          blot = duplicate_typeof(id) !== 'object' ? _this2.editor.findById(id) : _this2.editor.findById(id.syntaxId);
          insertContainer = blot.container;
          insertIndex = insertContainer.getChildIndex(id);
          insertId = blot.cloneSelf();
          insertContainer.containerChildren.insert(insertIndex + 1, [insertId]);
          insertedIds.push(insertId);
        } else {
          insertContainer = _this2.editor.findById(id.listId);
          var _iterator = duplicate_createForOfIteratorHelper(id.children),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var itemId = _step.value;
              if (duplicate_typeof(itemId) === 'object') {
                blot = _this2.editor.findById(itemId.blotId);
                insertIndex = insertContainer.getChildIndex(itemId.blotId) + 1;
                if (itemId.subItems.length) {
                  insertIndex = insertContainer.getChildIndex(itemId.subItems[itemId.subItems.length - 1]) + 1;
                }
              } else {
                blot = _this2.editor.findById(itemId);
                insertIndex = insertContainer.getChildIndex(itemId) + 1;
              }
              insertId = blot.cloneSelf();
              insertContainer.containerChildren.insert(insertIndex, [insertId]);
              insertedIds.push(insertId);
              if (duplicate_typeof(itemId) === 'object' && itemId.subItems.length) {
                var _iterator2 = duplicate_createForOfIteratorHelper(itemId.subItems),
                  _step2;
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    var subId = _step2.value;
                    var subBlot = _this2.editor.findById(subId);
                    insertIndex++;
                    insertId = subBlot.cloneSelf();
                    insertContainer.containerChildren.insert(insertIndex, [insertId]);
                    insertedIds.push(insertId);
                    // Нужно выставить props после дублирования такие же как у оригинала,
                    // для того чтобы элемент отрендерился скрытым если это нужно
                    var insertedSubBlot = _this2.editor.findById(insertId);
                    insertedSubBlot.setProps(subBlot.props);
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      });
      this.duplicatedIds = insertedIds;
      return true;
    }
  }]);
  return DuplicateAction;
}(Action);

DuplicateAction.type = 'duplicate-blots';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/copyAll.js
function copyAll_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { copyAll_typeof = function _typeof(obj) { return typeof obj; }; } else { copyAll_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return copyAll_typeof(obj); }









function copyAll_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function copyAll_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function copyAll_createClass(Constructor, protoProps, staticProps) { if (protoProps) copyAll_defineProperties(Constructor.prototype, protoProps); if (staticProps) copyAll_defineProperties(Constructor, staticProps); return Constructor; }
function copyAll_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) copyAll_setPrototypeOf(subClass, superClass); }
function copyAll_setPrototypeOf(o, p) { copyAll_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return copyAll_setPrototypeOf(o, p); }
function copyAll_createSuper(Derived) { var hasNativeReflectConstruct = copyAll_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = copyAll_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = copyAll_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return copyAll_possibleConstructorReturn(this, result); }; }
function copyAll_possibleConstructorReturn(self, call) { if (call && (copyAll_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return copyAll_assertThisInitialized(self); }
function copyAll_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function copyAll_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function copyAll_getPrototypeOf(o) { copyAll_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return copyAll_getPrototypeOf(o); }


var CopyAllAction = /*#__PURE__*/function (_Action) {
  copyAll_inherits(CopyAllAction, _Action);
  var _super = copyAll_createSuper(CopyAllAction);
  function CopyAllAction(type, params, editor) {
    copyAll_classCallCheck(this, CopyAllAction);
    type = type || CopyAllAction.type;
    return _super.call(this, type, params, editor);
  }
  copyAll_createClass(CopyAllAction, [{
    key: "before",
    value: function before() {
      this.savedRange = this.editor.scroll.selection.getRange()[0];
    }
  }, {
    key: "after",
    value: function after() {
      if (this.savedRange) {
        this.editor.scroll.selection.setRange(this.savedRange);
      } else {
        this.editor.scroll.selection.setRange({
          index: 0,
          length: 0
        });
      }
    }
  }, {
    key: "exec",
    value: function exec() {
      var length = this.editor.scroll.length();
      var lastBlot = this.editor.scroll.children.tail;
      if (lastBlot.constructor.blotName === 'list') {
        lastBlot = lastBlot.children.tail;
      }
      if (lastBlot.constructor.blotName === 'grid') {
        lastBlot = lastBlot.children.tail.children.tail;
      }
      if (lastBlot instanceof textLine && lastBlot.isEmpty && !lastBlot.isEmpty()) {
        length -= 1;
      }
      this.editor.scroll.selection.setRange({
        index: 0,
        length: length
      });
      document.execCommand('copy');
      if (this.editor.plugins.notificationManager) {
        this.editor.plugins.notificationManager.toast(this.editor.plugins.i18n.get('copy.copied'));
      }
      return true;
    }
  }]);
  return CopyAllAction;
}(Action);

CopyAllAction.type = 'copy-all';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/copyBlocks.js
function copyBlocks_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { copyBlocks_typeof = function _typeof(obj) { return typeof obj; }; } else { copyBlocks_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return copyBlocks_typeof(obj); }
function copyBlocks_toConsumableArray(arr) { return copyBlocks_arrayWithoutHoles(arr) || copyBlocks_iterableToArray(arr) || copyBlocks_unsupportedIterableToArray(arr) || copyBlocks_nonIterableSpread(); }
function copyBlocks_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function copyBlocks_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function copyBlocks_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return copyBlocks_arrayLikeToArray(arr); }














function copyBlocks_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = copyBlocks_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function copyBlocks_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return copyBlocks_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return copyBlocks_arrayLikeToArray(o, minLen); }
function copyBlocks_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function copyBlocks_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function copyBlocks_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function copyBlocks_createClass(Constructor, protoProps, staticProps) { if (protoProps) copyBlocks_defineProperties(Constructor.prototype, protoProps); if (staticProps) copyBlocks_defineProperties(Constructor, staticProps); return Constructor; }
function copyBlocks_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) copyBlocks_setPrototypeOf(subClass, superClass); }
function copyBlocks_setPrototypeOf(o, p) { copyBlocks_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return copyBlocks_setPrototypeOf(o, p); }
function copyBlocks_createSuper(Derived) { var hasNativeReflectConstruct = copyBlocks_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = copyBlocks_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = copyBlocks_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return copyBlocks_possibleConstructorReturn(this, result); }; }
function copyBlocks_possibleConstructorReturn(self, call) { if (call && (copyBlocks_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return copyBlocks_assertThisInitialized(self); }
function copyBlocks_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function copyBlocks_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function copyBlocks_getPrototypeOf(o) { copyBlocks_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return copyBlocks_getPrototypeOf(o); }



var CopyBlocksAction = /*#__PURE__*/function (_Action) {
  copyBlocks_inherits(CopyBlocksAction, _Action);
  var _super = copyBlocks_createSuper(CopyBlocksAction);
  function CopyBlocksAction(type, params, editor) {
    copyBlocks_classCallCheck(this, CopyBlocksAction);
    type = type || CopyBlocksAction.type;
    return _super.call(this, type, params, editor);
  }
  copyBlocks_createClass(CopyBlocksAction, [{
    key: "getContents",
    value: function getContents(blots) {
      var ops = [],
        html = [],
        text = [];
      var contextHelper = new ContentContextHelper(this.editor.scroll, {
        skipContainers: ['grid', 'gridCol', 'toggleContent']
      });
      var _iterator = copyBlocks_createForOfIteratorHelper(blots),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var blot = _step.value;
          if (blot.getBlotInsertParams) {
            var op = blot.getBlotInsertParams(null, contextHelper);
            if (Array.isArray(op)) {
              ops.push.apply(ops, copyBlocks_toConsumableArray(op));
            } else {
              ops.push(op);
            }
          }
          html.push(blot.getWrapper().domNode.outerHTML);
          text.push(blot.getWrapper().domNode.textContent);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return {
        ops: contextHelper.normalizeOps(ops),
        html: html.join(''),
        text: text.join('\n')
      };
    }
  }, {
    key: "exec",
    value: function exec() {
      var blots = this.selectedBlots.filter(function (blot, index) {
        if (blot.isSelectableBlotChild && index > 0) {
          return false;
        }
        // отсеиваем содержимое выделяемых блоков являющимися также "контейнерами" для других
        var collapsibleContainer = searchUp(blot, function (b) {
          return b.isCollapsibleContainer;
        });
        if (collapsibleContainer && collapsibleContainer.getSelectableBlot && collapsibleContainer.getSelectableBlot().props.selected) {
          return false;
        }
        return true;
      });
      var _this$getContents = this.getContents(blots),
        text = _this$getContents.text,
        html = _this$getContents.html,
        ops = _this$getContents.ops;
      this.editor.plugins.copyManager.copy(text, {
        html: html,
        ops: ops
      });
      return true;
    }
  }]);
  return CopyBlocksAction;
}(Action);

CopyBlocksAction.type = 'copy-blocks';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/addDatabase/templates/withOptions.json
const withOptions_namespaceObject = JSON.parse('{"cols":5,"rows":3,"content":{"columns":[{"type":"column","text":"Text"},{"type":"column","text":"Option","columnType":"singleselect","dbSelect":{"option_id_1":{"name":"Option 1","style":"default","color":"lime"},"option_id_2":{"name":"Option 2","style":"default","color":"amber"},"option_id_3":{"name":"Option 3","style":"default","color":"pink"}}},{"type":"column","text":"Progress","columnType":"progress"},{"type":"column","text":"Checkbox","columnType":"checkbox"},{"type":"column","text":"Date","columnType":"date"}],"rows":[{"type":"row","children":[{"cellType":"text","type":"tableCellText","delta":{"ops":[{"insert":"Some text\\n"}]},"value":"Some text","text":"Some text"},{"cellType":"singleselect","type":"tableCellSelect","selected":["option_id_1"],"value":["option_id_1"],"text":"Option 1"},{"cellType":"progress","type":"tableCellProgress","progress":100,"value":100,"text":"100%"},{"cellType":"checkbox","type":"tableCellCheckbox","checked":true,"value":true,"text":"Да"},{"cellType":"date","type":"tableCellDate","timestamp":"tomorrow","value":"tomorrow","text":"tomorrow"}]},{"type":"row","children":[{"cellType":"text","type":"tableCellText","colspan":1,"rowspan":1,"delta":{"ops":[{"insert":"Some text\\n"}]},"value":"Some text","text":"Some text"},{"cellType":"singleselect","type":"tableCellSelect","selected":["option_id_2"],"value":["option_id_2"],"text":"Option 2"},{"cellType":"progress","type":"tableCellProgress","progress":64,"value":64,"text":"64%"},{"cellType":"checkbox","type":"tableCellCheckbox","checked":false,"value":false,"text":"Нет"},{"cellType":"date","type":"tableCellDate","timestamp":"tomorrow","value":"tomorrow","text":"tomorrow"}]},{"type":"row","children":[{"cellType":"text","type":"tableCellText","colspan":1,"rowspan":1,"delta":{"ops":[{"insert":"Some text\\n"}]},"value":"Some text","text":"Some text"},{"cellType":"singleselect","type":"tableCellSelect","selected":["option_id_3"],"value":["option_id_3"],"text":"Option 3"},{"cellType":"progress","value":0,"text":"0%"},{"cellType":"checkbox","value":false,"text":"Нет"},{"cellType":"date","type":"tableCellDate","timestamp":"tomorrow","value":"tomorrow","text":"tomorrow"}]}]},"lineByLine":true,"captionParams":{"delta":{"ops":[{"insert":"\\n"}]}}}');
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/addDatabase/templates/withColumnTitles.json
const withColumnTitles_namespaceObject = JSON.parse('{"cols":5,"rows":3,"content":{"columns":[{"type":"column","text":"Text"},{"type":"column","text":"Option","columnType":"singleselect"},{"type":"column","text":"Progress","columnType":"progress"},{"type":"column","text":"Checkbox","columnType":"checkbox"},{"type":"column","text":"Date","columnType":"date"}],"rows":[{"type":"row","children":[]},{"type":"row","children":[]},{"type":"row","children":[]}]},"lineByLine":true,"captionParams":{"delta":{"ops":[{"insert":"\\n"}]}}}');
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/addDatabase/templates/index.js



var withOptionsDatabase = Object.assign({}, withOptions_namespaceObject);
var withColumnTitlesDatabase = Object.assign({}, withColumnTitles_namespaceObject);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/addDatabase/index.js
function addDatabase_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { addDatabase_typeof = function _typeof(obj) { return typeof obj; }; } else { addDatabase_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return addDatabase_typeof(obj); }















function addDatabase_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = addDatabase_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function addDatabase_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return addDatabase_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return addDatabase_arrayLikeToArray(o, minLen); }
function addDatabase_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function addDatabase_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function addDatabase_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function addDatabase_createClass(Constructor, protoProps, staticProps) { if (protoProps) addDatabase_defineProperties(Constructor.prototype, protoProps); if (staticProps) addDatabase_defineProperties(Constructor, staticProps); return Constructor; }
function addDatabase_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) addDatabase_setPrototypeOf(subClass, superClass); }
function addDatabase_setPrototypeOf(o, p) { addDatabase_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return addDatabase_setPrototypeOf(o, p); }
function addDatabase_createSuper(Derived) { var hasNativeReflectConstruct = addDatabase_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = addDatabase_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = addDatabase_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return addDatabase_possibleConstructorReturn(this, result); }; }
function addDatabase_possibleConstructorReturn(self, call) { if (call && (addDatabase_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return addDatabase_assertThisInitialized(self); }
function addDatabase_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function addDatabase_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function addDatabase_getPrototypeOf(o) { addDatabase_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return addDatabase_getPrototypeOf(o); }


var addDatabase_TYPE_ASSOC = {
  'with-options': withOptionsDatabase,
  'with-column-titles': withColumnTitlesDatabase
};
var COUNT_DATABASE_CREATED_KEY = 'editor-count-database-created';
var AddDatabaseAction = /*#__PURE__*/function (_Action) {
  addDatabase_inherits(AddDatabaseAction, _Action);
  var _super = addDatabase_createSuper(AddDatabaseAction);
  function AddDatabaseAction(type, params, editor) {
    addDatabase_classCallCheck(this, AddDatabaseAction);
    type = type || AddDatabaseAction.type;
    return _super.call(this, type, params || {}, editor);
  }
  addDatabase_createClass(AddDatabaseAction, [{
    key: "getTimestamp",
    value: function getTimestamp(dateTemplate) {
      var dateNow = new Date();
      switch (dateTemplate) {
        case 'now':
          return dateNow.getTime();
          break;
        case 'tomorrow':
          var tomorrow = dateNow;
          tomorrow.setDate(dateNow.getDate() + 1);
          return tomorrow.getTime();
          break;
        default:
          return dateNow.getTime();
      }
    }
  }, {
    key: "prepareTemplate",
    value: function prepareTemplate(template) {
      var _template$content, _template$content2;
      var optionIds = {};
      var idAddIndex = 0;
      if (template !== null && template !== void 0 && (_template$content = template.content) !== null && _template$content !== void 0 && _template$content.columns) {
        var _iterator = addDatabase_createForOfIteratorHelper(template.content.columns),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var column = _step.value;
            if (column.dbSelect) {
              var optionKeys = Object.keys(column.dbSelect);
              for (var _i = 0, _optionKeys = optionKeys; _i < _optionKeys.length; _i++) {
                var option = _optionKeys[_i];
                var id = String(Date.now() + idAddIndex);
                column.dbSelect[id] = column.dbSelect[option];
                optionIds[option] = id;
                delete column.dbSelect[option];
                idAddIndex++;
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      if (template !== null && template !== void 0 && (_template$content2 = template.content) !== null && _template$content2 !== void 0 && _template$content2.rows) {
        var _iterator2 = addDatabase_createForOfIteratorHelper(template.content.rows),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var row = _step2.value;
            if (row.children) {
              var _iterator3 = addDatabase_createForOfIteratorHelper(row.children),
                _step3;
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var cell = _step3.value;
                  if (cell.cellType === 'singleselect' || cell.cellType === 'multiselect') {
                    if (cell.selected) {
                      cell.selected = cell.selected.map(function (optionKey) {
                        if (optionIds[optionKey]) {
                          return optionIds[optionKey];
                        }
                        return optionKey;
                      });
                    }
                    if (cell.value) {
                      cell.value = cell.value.map(function (optionKey) {
                        if (optionIds[optionKey]) {
                          return optionIds[optionKey];
                        }
                        return optionKey;
                      });
                    }
                  }
                  if (cell.cellType === 'date') {
                    if (cell.timestamp) {
                      cell.timestamp = this.getTimestamp(cell.timestamp);
                    }
                    if (cell.value) {
                      if (cell.timestamp) {
                        cell.value = cell.timestamp;
                      } else {
                        cell.value = this.getTimestamp(cell.value);
                      }
                    }
                    if (cell.text) {
                      var dateTimeFormat = new Intl.DateTimeFormat('default', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit'
                      });
                      if (cell.timestamp) {
                        cell.text = dateTimeFormat.format(new Date(cell.timestamp));
                      } else if (cell.value) {
                        cell.text = dateTimeFormat.format(new Date(cell.value));
                      } else {
                        cell.text = dateTimeFormat.format(this.getTimestamp(cell.text));
                      }
                    }
                  }
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      return template;
    }
  }, {
    key: "getType",
    value: function getType(type) {
      switch (type) {
        case 'with-options':
          var countDatabaseCreated = 0;
          var result = type;
          if (localStorage.hasOwnProperty(COUNT_DATABASE_CREATED_KEY)) {
            countDatabaseCreated = localStorage.getItem(COUNT_DATABASE_CREATED_KEY);
            if (countDatabaseCreated >= 2) {
              result = 'with-column-titles';
            }
          }
          countDatabaseCreated++;
          localStorage.setItem(COUNT_DATABASE_CREATED_KEY, countDatabaseCreated);
          return result;
          break;
        default:
          return type;
      }
    }
  }, {
    key: "exec",
    value: function exec() {
      var type = this.getType(this.params.type);
      if (type && addDatabase_TYPE_ASSOC[type]) {
        var addOp = this.prepareTemplate(Object.assign({}, addDatabase_TYPE_ASSOC[type]));
        var convertBlot = this.selectedBlots && this.selectedBlots.length ? this.selectedBlots[this.selectedBlots.length - 1] : false;
        var container = convertBlot ? convertBlot.container : this.editor.scroll;
        var isEditorEmpty = this.editor.isEmpty();
        container.addBlot('table', Object.assign({
          after: convertBlot && convertBlot.id
        }, addOp));
        if (isEditorEmpty && !convertBlot) {
          container.children.head.remove();
        } else if (convertBlot) {
          if (convertBlot.isEmpty && convertBlot.isEmpty()) {
            convertBlot.remove();
          }
        }
      }
    }
  }]);
  return AddDatabaseAction;
}(Action);

AddDatabaseAction.type = 'add-database';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/actions/registry.js
var _actions;
function registry_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




















var actions = (_actions = {}, registry_defineProperty(_actions, format_FormatAction.type, format_FormatAction), registry_defineProperty(_actions, AddParagraphAction.type, AddParagraphAction), registry_defineProperty(_actions, AddTasksListAction.type, AddTasksListAction), registry_defineProperty(_actions, AddBoardAction.type, AddBoardAction), registry_defineProperty(_actions, ClearFormatAction.type, ClearFormatAction), registry_defineProperty(_actions, actions_addGrid.type, actions_addGrid), registry_defineProperty(_actions, AddFileAction.type, AddFileAction), registry_defineProperty(_actions, AddRemoteFileAction.type, AddRemoteFileAction), registry_defineProperty(_actions, AddImageAction.type, AddImageAction), registry_defineProperty(_actions, MoveBlotOneStep.type, MoveBlotOneStep), registry_defineProperty(_actions, ConvertBlotAction.type, ConvertBlotAction), registry_defineProperty(_actions, ClearSelectionAction.type, ClearSelectionAction), registry_defineProperty(_actions, SetBackgroundAction.type, SetBackgroundAction), registry_defineProperty(_actions, BeginMentionAction.type, BeginMentionAction), registry_defineProperty(_actions, DuplicateAction.type, DuplicateAction), registry_defineProperty(_actions, AddBusinessCardAction.type, AddBusinessCardAction), registry_defineProperty(_actions, CopyAllAction.type, CopyAllAction), registry_defineProperty(_actions, CopyBlocksAction.type, CopyBlocksAction), registry_defineProperty(_actions, AddDatabaseAction.type, AddDatabaseAction), _actions);
function createActionByType(type, params, editor) {
  var klass;
  if (actions[type]) {
    klass = actions[type];
  } else {
    klass = Action;
  }
  return new klass(type, params, editor);
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/api.js
function api_toConsumableArray(arr) { return api_arrayWithoutHoles(arr) || api_iterableToArray(arr) || api_unsupportedIterableToArray(arr) || api_nonIterableSpread(); }
function api_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function api_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function api_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return api_arrayLikeToArray(arr); }
function api_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = api_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }





















function api_slicedToArray(arr, i) { return api_arrayWithHoles(arr) || api_iterableToArrayLimit(arr, i) || api_unsupportedIterableToArray(arr, i) || api_nonIterableRest(); }
function api_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function api_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return api_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return api_arrayLikeToArray(o, minLen); }
function api_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function api_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function api_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function api_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function api_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function api_createClass(Constructor, protoProps, staticProps) { if (protoProps) api_defineProperties(Constructor.prototype, protoProps); if (staticProps) api_defineProperties(Constructor, staticProps); return Constructor; }
function api_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var Api = /*#__PURE__*/function () {
  function Api(editor) {
    var _this = this;
    api_classCallCheck(this, Api);
    api_defineProperty(this, "onSelectionChange", function () {
      var _this$selection$getRa = _this.selection.getRange(),
        _this$selection$getRa2 = api_slicedToArray(_this$selection$getRa, 2),
        _ = _this$selection$getRa2[0],
        nativeRange = _this$selection$getRa2[1];
      _this.toolbarEvents(nativeRange);
    });
    api_defineProperty(this, "onUndoManagerChange", function () {
      var _this$selection$getRa3 = _this.selection.getRange(),
        _this$selection$getRa4 = api_slicedToArray(_this$selection$getRa3, 2),
        _ = _this$selection$getRa4[0],
        nativeRange = _this$selection$getRa4[1];
      _this.toolbarEvents(nativeRange);
    });
    this.editor = editor;
    this.browser = this.editor.browser;
    this.scroll = this.editor.scroll;
    this.selection = this.scroll.selection;
    this.savedNative = false;
    this.allowMerge = false;
    this.allowDivide = false;
    this.timerScrollChecker = false;
    this.timerScroll = false;
    this.editor.on('undo-manager-change', this.onUndoManagerChange);

    // TODO необходимо перенести весь код относящийся в к тулабару в код тулбара, это временное решение
    // для перерендера тулбара при изменении позиции выделения(курсора)
    if (this.editor.mode === this.editor.constructor.MODE_EDIT && this.editor.options.render) {
      window.addEventListener('selectionchange', this.onSelectionChange, false);
    }
  }
  api_createClass(Api, [{
    key: "destroy",
    value: function destroy() {
      window.removeEventListener('selectionchange', this.onSelectionChange, false);
    }
  }, {
    key: "execOnBlots",
    value: function execOnBlots(actionType, params) {
      var action = createActionByType(actionType, params, this.editor);
      console.groupCollapsed('Api: execOnBlots handler');
      var blotsChecked = new Set();
      var searchInChildBlots = function searchInChildBlots(blot) {
        var res = new Set();
        if (blot.getChildBlotsForExec) {
          var childBlots = blot.getChildBlotsForExec();
          var _iterator = api_createForOfIteratorHelper(childBlots),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _childBlot = _step.value;
              if (_childBlot.canExec && _childBlot.canExec(action)) {
                res.add(_childBlot);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          if (!res.size) {
            // ищем в дочерних блотах childBlots
            var _iterator2 = api_createForOfIteratorHelper(childBlots),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var childBlot = _step2.value;
                var childBlots2 = searchInChildBlots(childBlot);
                if (childBlots2.size) {
                  res = new Set([].concat(api_toConsumableArray(res), api_toConsumableArray(childBlots2)));
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        }
        return res;
      };
      var getBlotsForAction = function getBlotsForAction(blotsInRange) {
        var processingBlots = new Set();
        // получаем блоты, которые могут обработать действие
        var _iterator3 = api_createForOfIteratorHelper(blotsInRange),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var blotInRange = _step3.value;
            if (blotInRange.canExec && blotInRange.canExec(action)) {
              processingBlots.add(blotInRange);
            } else {
              // если блот не может обработать действие, то проверяем есть ли у него функция getChildBlotsForExec
              // которая даст дочерние блоты, которые потенциально могут обработать действие
              var childBlots = searchInChildBlots(blotInRange);
              if (!childBlots.size) {
                // проверяем нет ли в родителях других выбранных блотов, #937
                var allow = true;
                var blot = blotInRange.parent;
                while (allow && blot) {
                  var _iterator4 = api_createForOfIteratorHelper(blotsInRange),
                    _step4;
                  try {
                    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                      var checkBlot = _step4.value;
                      if (checkBlot === blotInRange) continue;
                      if (blot === checkBlot) {
                        allow = false;
                        break;
                      }
                    }
                  } catch (err) {
                    _iterator4.e(err);
                  } finally {
                    _iterator4.f();
                  }
                  blot = blot.parent;
                }
                if (!allow) {
                  //console.info('Skip blot', blotInRange)
                  continue;
                }

                // получаем родительские блоты, которые могут обработать действие
                blot = blotInRange.parent;
                while (blot) {
                  if (blotsChecked.has(blot)) {
                    break;
                  }
                  blotsChecked.add(blot);
                  if (blot.canExec && blot.canExec(action)) {
                    processingBlots.add(blot);
                    break;
                  }
                  blot = blot.parent;
                }
              } else {
                var _iterator5 = api_createForOfIteratorHelper(childBlots),
                  _step5;
                try {
                  for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                    var _blot = _step5.value;
                    processingBlots.add(_blot);
                  }
                } catch (err) {
                  _iterator5.e(err);
                } finally {
                  _iterator5.f();
                }
              }
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        return Array.from(processingBlots);
      };

      // пытаемся выполнить действие на текущих активных блотах и их родительских блотах
      var range = this.selection.getNativeRange();
      var blotsInRange = new Set();
      if (range) {
        blotsInRange = new Set([].concat(api_toConsumableArray(blotsInRange), api_toConsumableArray(this.selection.getBlotsInRange(range))));
      }
      var selectedBlots = Array.from(document.querySelectorAll('.selected-block, .focused-block')).map(function (node) {
        return src_parchment.find(node);
      });
      // add focused blots as well
      var focusedNodes = document.querySelectorAll('.focused-block');
      var _iterator6 = api_createForOfIteratorHelper(focusedNodes),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var focusedNode = _step6.value;
          var blot = src_parchment.find(focusedNode);
          if (blot) {
            blotsInRange.add(blot);
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      blotsInRange = Array.from(blotsInRange);
      var processingBlots = getBlotsForAction(blotsInRange);
      processingBlots = processingBlots.filter(function (item) {
        return !item.isBlotLocked;
      });
      action.setSelectedBlots(selectedBlots);
      action.before({
        processingBlots: processingBlots
      });
      var isProcessed = action.exec({
        processingBlots: processingBlots
      });
      action.after({
        processingBlots: processingBlots
      });
      console.groupEnd();
      return {
        isProcessed: isProcessed,
        action: action
      };
    }
  }, {
    key: "exec",
    value: function exec(action, params) {
      try {
        var _this$execOnBlots = this.execOnBlots(action, params),
          isProcessed = _this$execOnBlots.isProcessed,
          actionInst = _this$execOnBlots.action;
        if (isProcessed) {
          return {
            action: actionInst
          };
        }
      } catch (err) {
        console.error(err, err.stack);
        return {
          error: err
        };
      }
      switch (action) {
        case 'insert-block':
          if (params.type === 'table') {
            return this.addTable(params.rows, params.cols);
          } else if (params.type === 'paragraph') {
            return console.log('Inserting "Paragraph" from api not released');
          } else if (params.type === 'image') {
            return this.addImage(params.src);
          } else {
            return false;
          }
          break;
        case 'save-range':
          this.saveNativeRange();
          break;
        case 'undo':
          var undoAction = new UndoAction(UndoAction.type, {}, this.editor);
          undoAction.run();
          break;
        case 'redo':
          var redoAction = new RedoAction(RedoAction.type, {}, this.editor);
          redoAction.run();
          break;
        case 'insert-html':
          this.editor.plugins.pasteManager.paste(params);
          break;
      }
    }
  }, {
    key: "focusScroll",
    value: function focusScroll() {
      this.scroll.domNode.setAttribute('contenteditable', true);
      this.scroll.domNode.focus();
      var focused = [].slice.call(this.scroll.domNode.querySelectorAll('.focused-block'));
      focused.map(function (block) {
        //block.classList.remove('focused-block');
      });
      var selectedCols = [].slice.call(this.scroll.domNode.getElementsByClassName('col-selected'));
      selectedCols.map(function (col) {
        col.classList.remove('col-selected');
      });
      var currentCols = [].slice.call(this.scroll.domNode.getElementsByClassName('current'));
      currentCols.map(function (col) {
        col.classList.remove('current');
      });
      var writeCols = [].slice.call(this.scroll.domNode.getElementsByClassName('write'));
      writeCols.map(function (col) {
        var colBlot = src_parchment.find(col);
        var block = colBlot.children.head;
        block.domNode.removeAttribute('contenteditable');
        col.classList.remove('write');
      });
      var changeCols = [].slice.call(this.scroll.domNode.getElementsByClassName('change'));
      changeCols.map(function (col) {
        var colBlot = src_parchment.find(col);
        var block = colBlot.children.head;
        block.domNode.removeAttribute('contenteditable');
        col.classList.remove('write');
      });
      this.allowMerge = false;
      this.editor.emitter.emit('allow-merge', false);
      this.allowDivide = false;
      this.editor.emitter.emit('allow-divide', false);
    }
  }, {
    key: "getBlock",
    value: function getBlock(node) {
      var findBlock = function findBlock(blot) {
        if (!blot) return false;
        if (blot instanceof paragraph && blot.parent.constructor.blotName != 'tableCell' || blot.constructor.blotName == 'table' || blot.constructor.blotName == 'image') {
          return blot;
        } else {
          return findBlock(blot.parent);
        }
      };
      return findBlock(src_parchment.find(node));
    }
  }, {
    key: "addTable",
    value: function addTable(rows, cols) {
      var formContainer = this.editor.toolbar.tableFormContainer.querySelector('.add-table-form');
      formContainer.style.display = 'none';
      var nativeRange = this.selection.getNativeRange();
      if (nativeRange == null) {
        nativeRange = this.savedNative;
      }
      var index;
      var parent = this.scroll.id;
      if (nativeRange != null && nativeRange != false) {
        var line = this.scroll.getBlock(src_parchment.find(nativeRange.end.node));
        if (line.parent.constructor.blotName == 'grid') {
          parent = line.parent.id;
          index = line.index + 1;
        } else {
          if (nativeRange.end.offset == 0) {
            var blot = src_parchment.find(nativeRange.end.node);
            var offset = line.descendants(src_parchment.Leaf).indexOf(blot);
            if (offset == 0) {
              if (typeof line.prev != 'undefined') {
                index = line.index;
              } else {
                index = 0;
              }
            } else if (offset == -1 && blot.constructor.blotName == 'break') {
              index = line.index;
              line.remove();
            } else {
              index = line.index + 1;
            }
          } else {
            index = line.index + 1;
          }
        }
      } else {
        index = [].slice.call(this.scroll.domNode.childNodes).length;
      }

      //init table on server
      this.scroll.token = true;
      this.scroll.blocks.insert(index, [this.editor.Y.Map]);
      var tableMap = this.scroll.blocks.get(index);
      this.scroll.emitter.emit('add-table', {
        source: 'user',
        index: index,
        parent: parent,
        map: tableMap
      });
      var table = src_parchment.find(document.getElementById(parent)).getByIndex(index).children.head;
      var tableRows = tableMap.get('rows');
      var tableColumns = tableMap.get('columns');
      for (var i = 0; i < cols; i++) {
        table.token = true;
        tableColumns.insert(i, [this.editor.Y.Map]);
        var columnMap = tableColumns.get(i);
        table.emitter.emit('add-column', {
          source: 'user',
          index: i,
          map: columnMap
        });
      }
      for (var _i2 = 0; _i2 < rows; _i2++) {
        table.token = true;
        tableRows.insert(_i2, [this.editor.Y.Map]);
        var rowMap = tableRows.get(_i2);
        table.emitter.emit('add-row', {
          source: 'user',
          index: _i2,
          map: rowMap
        });
        var row = table.getByIndex(_i2);
        var rowCols = rowMap.get('cols');
        for (var j = 0; j < cols; j++) {
          row.token = true;
          rowCols.insert(j, [this.editor.Y.Map]);
          var colMap = rowCols.get(j);
          row.emitter.emit('add-col', {
            source: 'user',
            index: j,
            map: colMap
          });
          var col = row.getByIndex(j);
          var colBlocks = col.map.get('blocks');
          col.token = true;
          colBlocks.insert(0, [this.editor.Y.Map]);
          var blockMap = colBlocks.get(0);
          col.emitter.emit('add-paragraph', {
            source: 'user',
            index: 0,
            map: blockMap
          });
        }
      }
      this.savedNative = false;
      return true;
    }
  }, {
    key: "mergeCols",
    value: function mergeCols() {}
  }, {
    key: "divideCols",
    value: function divideCols() {}
  }, {
    key: "addRow",
    value: function addRow() {}
  }, {
    key: "addColumn",
    value: function addColumn() {}
  }, {
    key: "deleteRow",
    value: function deleteRow() {}
  }, {
    key: "deleteColumn",
    value: function deleteColumn() {}
  }, {
    key: "addImage",
    value: function addImage(src) {
      var _this2 = this;
      return new Promise(function (resolve) {
        var validation = ValidURL(src);
        if (validation == false) {
          resolve({
            error: 'not url'
          });
        }
        validation = checkImage(src);
        if (validation == false) {
          resolve({
            error: 'not image url'
          });
        } else {
          var img = new Image();
          img.onload = function () {
            if (img.width <= 50 || img.height <= 50) {
              resolve({
                error: 'image size need largest 50x50'
              });
            } else {
              var nativeRange = _this2.selection.getNativeRange();
              if (nativeRange == null) {
                nativeRange = _this2.savedNative;
              }
              var index;
              var parent = _this2.scroll.id;
              if (nativeRange != null && nativeRange != false) {
                var line = _this2.scroll.getBlock(src_parchment.find(nativeRange.end.node));
                if (line.parent.constructor.blotName == 'grid') {
                  parent = line.parent.id;
                  index = line.index + 1;
                } else {
                  if (nativeRange.end.offset == 0) {
                    var blot = src_parchment.find(nativeRange.end.node);
                    var offset = line.descendants(src_parchment.Leaf).indexOf(blot);
                    if (offset == 0) {
                      if (typeof line.prev != 'undefined') {
                        index = line.index;
                      } else {
                        index = 0;
                      }
                    } else if (offset == -1 && blot.constructor.blotName == 'break') {
                      index = line.index;
                      line.remove();
                    } else {
                      index = line.index + 1;
                    }
                  } else {
                    index = line.index + 1;
                  }
                }
              } else {
                index = _this2.scroll.blocks._content.length;
              }

              //init table on server
              _this2.scroll.token = true;
              _this2.scroll.blocks.insert(index, [_this2.editor.Y.Map]);
              var imageMap = _this2.scroll.blocks.get(index);
              _this2.scroll.emitter.emit('add-image', {
                source: 'user',
                index: index,
                parent: parent,
                map: imageMap,
                src: src
              });
              _this2.savedNative = false;
              resolve(true);
            }
          };
          img.src = src;
        }
      });
    }
  }, {
    key: "toolbarEvents",
    value: function toolbarEvents(range) {
      var _this3 = this;
      var getUndoState = function getUndoState() {
        return {
          canUndo: _this3.editor.plugins.undoManager.canUndo(),
          canRedo: _this3.editor.plugins.undoManager.canRedo()
        };
      };
      var pressButtons = function pressButtons() {
        var formats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        _this3.editor.emitter.emit('toolbar-status', formats, color, getUndoState());
      };
      var getColor = function getColor(block) {
        if (block.parent.constructor.blotName == 'tableCell') {
          return block.parent.color;
        } else {
          return block.color;
        }
      };
      pressButtons();
    }
  }, {
    key: "saveNativeRange",
    value: function saveNativeRange() {
      this.savedNative = this.selection.getNativeRange();
    }
  }, {
    key: "makeid",
    value: function makeid() {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 8; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text;
    }
  }, {
    key: "getCursorStyle",
    value: function getCursorStyle() {
      var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      switch (style) {
        case 'top-left':
        case 'bottom-right':
          return 'nwse-resize';
          break;
        case 'top':
        case 'bottom':
          return 'ns-resize';
          break;
        case 'top-right':
        case 'bottom-left':
          return 'nesw-resize';
          break;
        case 'right':
        case 'left':
          return 'ew-resize';
          break;
        case 'move':
          return 'move';
          break;
        case 'pointer':
          return 'pointer';
          break;
        case 'text':
          return 'text';
          break;
        default:
          return 'default';
          break;
      }
    }
  }, {
    key: "addBlot",
    value: function addBlot(type, params) {
      var nativeRange = this.selection.getNativeRange();
      if (!nativeRange) {
        nativeRange = this.savedNative;
      }
      var container = this.scroll.getContainerBlot(src_parchment.find(nativeRange.end.node));
      if (!container) {
        return;
      }
      container.addBlot(type, params);
    }
  }, {
    key: "addList",
    value: function addList(value) {
      var nativeRange = this.selection.getNativeRange();
      if (nativeRange == null) {
        nativeRange = this.savedNative;
      }
      var index;
      var parent = this.scroll.id;
      if (nativeRange != null && nativeRange != false) {
        var line = this.scroll.getBlock(src_parchment.find(nativeRange.end.node));
        if (line.parent.constructor.blotName == 'grid') {
          parent = line.parent.id;
          index = line.index + 1;
        } else {
          if (nativeRange.end.offset == 0) {
            var blot = src_parchment.find(nativeRange.end.node);
            var offset = line.descendants(src_parchment.Leaf).indexOf(blot);
            if (offset == 0) {
              if (typeof line.prev != 'undefined') {
                index = line.index;
              } else {
                index = 0;
              }
            } else if (offset == -1 && blot.constructor.blotName == 'break') {
              index = line.index;
              line.remove();
            } else {
              index = line.index + 1;
            }
          } else {
            index = line.index + 1;
          }
        }
      } else {
        index = [].slice.call(this.scroll.domNode.childNodes).length;
      }
      this.scroll.token = true;
      this.scroll.blocks.insert(index, [this.editor.Y.Map]);
      var listMap = this.scroll.blocks.get(index);
      this.scroll.emitter.emit('add-list', {
        source: 'user',
        index: index,
        parent: parent,
        map: listMap,
        type: value
      });
      var list = src_parchment.find(document.getElementById(parent)).getByIndex(index);
      var listItems = listMap.get('items');
      list.token = true;
      listItems.push([this.editor.Y.Map]);
      var listItemMap = listItems.get(0);
      list.emitter.emit('add-item', {
        source: 'user',
        index: 0,
        map: listItemMap,
        type: value
      });
      var listItem = list.getByIndex(0);
      var paragraph = listItemMap.get('blocks');
      listItem.token = true;
      paragraph.push([this.editor.Y.Map]);
      var paragraphMap = paragraph.get(0);
      listItem.emitter.emit('add-paragraph', {
        source: 'user',
        index: 0,
        map: paragraphMap
      });
    }
  }]);
  return Api;
}();
function ValidURL(str) {
  var pattern = new RegExp('^(https?:\\/\\/)' +
  // protocol
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
  // domain name
  '((\\d{1,3}\\.){3}\\d{1,3}))' +
  // OR ip (v4) address
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
  // port and path
  '(\\?[;&a-z\\d%_.~+=-]*)?' +
  // query string
  '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
  var res = pattern.test(str);
  return res;
}
function checkImage(src) {
  return src.match(/\.(jpeg|jpg|gif|png)$/) != null;
}

//helper for preact
function setClasses() {
  var defaultClasses = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var isActiveClasses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  //defaultClasses = ['className']
  //isActiveClasses = { className: 'condition' }
  var classNames = [],
    className = '';
  //handling defaultClasses
  if (defaultClasses) {
    classNames = defaultClasses;
  }
  //handling active classes
  if (isActiveClasses) {
    var _classNames;
    (_classNames = classNames).push.apply(_classNames, api_toConsumableArray(Object.keys(isActiveClasses).map(function (className) {
      return isActiveClasses[className] && className;
    }).filter(function (className) {
      return className;
    })));
  }
  //joining classes
  className = classNames.join(' ');
  return className;
}

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/businessCard/businessCardLinkPanel.js
function businessCardLinkPanel_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { businessCardLinkPanel_typeof = function _typeof(obj) { return typeof obj; }; } else { businessCardLinkPanel_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return businessCardLinkPanel_typeof(obj); }
function businessCardLinkPanel_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function businessCardLinkPanel_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function businessCardLinkPanel_createClass(Constructor, protoProps, staticProps) { if (protoProps) businessCardLinkPanel_defineProperties(Constructor.prototype, protoProps); if (staticProps) businessCardLinkPanel_defineProperties(Constructor, staticProps); return Constructor; }
function businessCardLinkPanel_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) businessCardLinkPanel_setPrototypeOf(subClass, superClass); }
function businessCardLinkPanel_setPrototypeOf(o, p) { businessCardLinkPanel_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return businessCardLinkPanel_setPrototypeOf(o, p); }
function businessCardLinkPanel_createSuper(Derived) { var hasNativeReflectConstruct = businessCardLinkPanel_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = businessCardLinkPanel_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = businessCardLinkPanel_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return businessCardLinkPanel_possibleConstructorReturn(this, result); }; }
function businessCardLinkPanel_possibleConstructorReturn(self, call) { if (call && (businessCardLinkPanel_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return businessCardLinkPanel_assertThisInitialized(self); }
function businessCardLinkPanel_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function businessCardLinkPanel_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function businessCardLinkPanel_getPrototypeOf(o) { businessCardLinkPanel_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return businessCardLinkPanel_getPrototypeOf(o); }
function businessCardLinkPanel_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













var LinkPanel = function LinkPanel(props) {
  return (0,preact_module.h)("span", null, (0,preact_module.h)("div", {
    className: "link-panel-item link-panel-item-link"
  }, (0,preact_module.h)("div", {
    onClick: props.menuItems[0].onClick,
    className: "link-text"
  }, props.title)), (0,preact_module.h)("div", {
    className: "link-panel-buttons"
  }, props.menuItems.map(function (menuItem) {
    return (0,preact_module.h)("div", {
      className: "link-panel-item",
      onClick: function onClick() {
        menuItem.onClick();
      }
    }, props.t("link.".concat(menuItem.title)));
  })));
};
var LinkPanelEdit = /*#__PURE__*/function (_Component) {
  businessCardLinkPanel_inherits(LinkPanelEdit, _Component);
  var _super = businessCardLinkPanel_createSuper(LinkPanelEdit);
  function LinkPanelEdit() {
    var _this;
    businessCardLinkPanel_classCallCheck(this, LinkPanelEdit);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    businessCardLinkPanel_defineProperty(businessCardLinkPanel_assertThisInitialized(_this), "inputNode", false);
    return _this;
  }
  businessCardLinkPanel_createClass(LinkPanelEdit, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.inputNode.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return (0,preact_module.h)("span", null, (0,preact_module.h)("div", {
        className: "link-form-item"
      }, (0,preact_module.h)("label", {
        for: "link-form-adress"
      }, this.props.t('link.url_label')), (0,preact_module.h)("input", {
        ref: function ref(inputNode) {
          _this2.inputNode = inputNode;
        },
        id: "link-form-adress",
        value: this.props.url,
        type: "url",
        placeholder: "http://example.com",
        onKeyUp: this.props.onInputKeyDown,
        autocapitalize: "off"
      })));
    }
  }]);
  return LinkPanelEdit;
}(preact_module/* Component */.wA);
var BusinessCardLinkPanel = /*#__PURE__*/function (_Component2) {
  businessCardLinkPanel_inherits(BusinessCardLinkPanel, _Component2);
  var _super2 = businessCardLinkPanel_createSuper(BusinessCardLinkPanel);
  function BusinessCardLinkPanel() {
    var _this3;
    businessCardLinkPanel_classCallCheck(this, BusinessCardLinkPanel);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this3 = _super2.call.apply(_super2, [this].concat(args));
    businessCardLinkPanel_defineProperty(businessCardLinkPanel_assertThisInitialized(_this3), "t", function (key) {
      var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _this3.props.editor.plugins.i18n.get(key, opt);
    });
    return _this3;
  }
  businessCardLinkPanel_createClass(BusinessCardLinkPanel, [{
    key: "render",
    value: function render() {
      var props = {
        title: this.props.title || this.props.url,
        url: this.props.url,
        t: this.t,
        menuItems: this.props.menuItems,
        onInputKeyDown: this.props.onInputKeyDown,
        setDefaultState: this.props.setDefaultState
      };
      return (0,preact_module.h)("div", {
        className: "link-form-container"
      }, (0,preact_module.h)("div", {
        className: "link-form"
      }, (0,preact_module.h)("div", {
        className: setClasses(['popup-menu'], {
          "link-edit": this.props.isEdit,
          "link-panel no-scroll": !this.state.isEdit
        })
      }, this.props.isEdit ? (0,preact_module.h)(LinkPanelEdit, props) : (0,preact_module.h)(LinkPanel, props))));
    }
  }]);
  return BusinessCardLinkPanel;
}(preact_module/* Component */.wA);
/* harmony default export */ const businessCardLinkPanel = (BusinessCardLinkPanel);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/businessCard/businessCardField.js
function businessCardField_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { businessCardField_typeof = function _typeof(obj) { return typeof obj; }; } else { businessCardField_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return businessCardField_typeof(obj); }










function businessCardField_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function businessCardField_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function businessCardField_createClass(Constructor, protoProps, staticProps) { if (protoProps) businessCardField_defineProperties(Constructor.prototype, protoProps); if (staticProps) businessCardField_defineProperties(Constructor, staticProps); return Constructor; }
function businessCardField_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) businessCardField_setPrototypeOf(subClass, superClass); }
function businessCardField_setPrototypeOf(o, p) { businessCardField_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return businessCardField_setPrototypeOf(o, p); }
function businessCardField_createSuper(Derived) { var hasNativeReflectConstruct = businessCardField_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = businessCardField_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = businessCardField_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return businessCardField_possibleConstructorReturn(this, result); }; }
function businessCardField_possibleConstructorReturn(self, call) { if (call && (businessCardField_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return businessCardField_assertThisInitialized(self); }
function businessCardField_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function businessCardField_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function businessCardField_getPrototypeOf(o) { businessCardField_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return businessCardField_getPrototypeOf(o); }
function businessCardField_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var businessCardField_isEnterKey = (0,lib/* default */.ZP)('enter');
var businessCardField_isEscKey = (0,lib/* default */.ZP)('escape');
var isBackSpace = (0,lib/* default */.ZP)('backspace');
var businessCardField_TRIGGER_DISTANCE = 5;
var LINK_FIELDS = ['URL', 'PHONE', 'EMAIL', 'SKYPE', 'TWITTER', 'INSTAGRAM', 'FACEBOOK', 'LINKEDIN', 'VK'];
function getLinkData(entityClass, value) {
  switch (entityClass) {
    case 'PHONE':
      return {
        href: 'tel:' + value
      };
    case 'EMAIL':
      return {
        href: 'mailto:' + value
      };
    case 'SKYPE':
      return {
        href: 'skype:' + value + '?call'
      };
    case 'FACEBOOK':
      return {
        href: 'https://www.facebook.com/' + value,
        target: '_blank'
      };
    case 'URL':
    default:
      return {
        href: value,
        target: '_blank'
      };
  }
}
var BusinessCardField = /*#__PURE__*/function (_Component) {
  businessCardField_inherits(BusinessCardField, _Component);
  var _super = businessCardField_createSuper(BusinessCardField);
  function BusinessCardField(props) {
    var _this;
    businessCardField_classCallCheck(this, BusinessCardField);
    _this = _super.call(this, props);
    businessCardField_defineProperty(businessCardField_assertThisInitialized(_this), "setComponentRef", function (node) {
      _this.domNode = node;
      _this.props.domRef(_this.props.entityClass, node);
    });
    businessCardField_defineProperty(businessCardField_assertThisInitialized(_this), "setInputRef", function (node) {
      _this.inputNode = node;
    });
    businessCardField_defineProperty(businessCardField_assertThisInitialized(_this), "openLink", function () {
      _this.setDefaultState(function () {
        var data = getLinkData(_this.props.entityClass, _this.props.value),
          a = document.createElement('a');
        a.href = data.href;
        if (data.target) {
          a.target = data.target;
        }
        a.click();
        a.remove();
      });
    });
    businessCardField_defineProperty(businessCardField_assertThisInitialized(_this), "copyValue", function () {
      _this.setDefaultState(function () {
        _this.props.editor.plugins.copyManager.copy(_this.props.value, {
          noToast: true
        });
      });
    });
    businessCardField_defineProperty(businessCardField_assertThisInitialized(_this), "toggleEditLink", function () {
      _this.setState(function (prevState) {
        return {
          isEdit: !prevState.isEdit
        };
      });
    });
    businessCardField_defineProperty(businessCardField_assertThisInitialized(_this), "removeField", function () {
      setTimeout(function () {
        _this.setDefaultState(function () {
          _this.props.removeField(_this.props.entityClass);
        });
      }, 0);
    });
    businessCardField_defineProperty(businessCardField_assertThisInitialized(_this), "onInputKeyDown", function (event) {
      var value = event.target.value;
      if (businessCardField_isEnterKey(event)) {
        if (value === '') {
          _this.props.removeField(_this.props.entityClass);
        } else {
          _this.props.changeField(_this.props.entityClass, value);
        }
        _this.setDefaultState();
      }
      if (isBackSpace(event)) {
        if (value.length === 0) {
          _this.removeField();
        }
      }
      if (businessCardField_isEscKey(event)) {
        _this.setDefaultState();
      }
    });
    businessCardField_defineProperty(businessCardField_assertThisInitialized(_this), "onDocumentMouseDown", function (event) {
      if (!(0,dom/* isNodeEqualOrContain */.nN)(_this.inputNode.parentElement, event.target)) {
        _this.setDefaultState();
      }
    });
    businessCardField_defineProperty(businessCardField_assertThisInitialized(_this), "onMouseDown", function (event) {
      if (!_this.state.editMode) {
        event.preventDefault();
        _this.mouseDownPosition = {
          x: event.clientX,
          y: event.clientY
        };
      }
    });
    businessCardField_defineProperty(businessCardField_assertThisInitialized(_this), "onMouseMove", function (event) {
      if (_this.mouseDownPosition && !_this.state.editMode) {
        var nowPosition = {
          x: event.clientX,
          y: event.clientY
        };
        if (math_distance(nowPosition, _this.mouseDownPosition) >= businessCardField_TRIGGER_DISTANCE) {
          _this.props.businessCardStartDragSession(_this.domNode, _this.props.entityClass, nowPosition);
          _this.dragSessionProcess = true;
          _this.mouseDownPosition = null;
          _this.setDefaultState();
          document.addEventListener('mouseup', _this.onDocumentMouseUp, false);
        }
      }
    });
    businessCardField_defineProperty(businessCardField_assertThisInitialized(_this), "onMouseUp", function (event) {
      _this.mouseDownPosition = null;
    });
    businessCardField_defineProperty(businessCardField_assertThisInitialized(_this), "setDefaultState", function () {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      _this.setState(function () {
        return {
          editMode: false,
          isEdit: false
        };
      }, function () {
        document.body.removeEventListener('mousedown', _this.onDocumentMouseDown, false);
        callback && typeof callback === 'function' && callback();
      });
    });
    businessCardField_defineProperty(businessCardField_assertThisInitialized(_this), "getComponentProps", function () {
      return {
        className: 'businessCardField',
        ref: _this.setComponentRef,
        onMouseDown: _this.onMouseDown,
        onMouseMove: _this.onMouseMove,
        onMouseUp: _this.onMouseUp
      };
    });
    businessCardField_defineProperty(businessCardField_assertThisInitialized(_this), "getInputProps", function () {
      return {
        className: 'businessCardField__inputWrapper__input',
        value: _this.props.value,
        ref: _this.setInputRef,
        type: 'text',
        disabled: _this.isLink() ? true : false,
        onKeyDown: _this.onInputKeyDown
      };
    });
    businessCardField_defineProperty(businessCardField_assertThisInitialized(_this), "onEdit", function (e) {
      if (_this.dragSessionProcess) return;
      if (e.target === _this.onEditBlock) {
        _this.setState(function () {
          return {
            editMode: true
          };
        }, function () {
          _this.inputNode.focus();
          document.body.addEventListener('mousedown', _this.onDocumentMouseDown, false);
        });
      }
    });
    businessCardField_defineProperty(businessCardField_assertThisInitialized(_this), "onDocumentMouseUp", function (event) {
      setTimeout(function () {
        _this.dragSessionProcess = false;
      }, 0);
      document.removeEventListener('mouseup', _this.onDocumentMouseUp, false);
    });
    _this.state = {
      editMode: false,
      isEdit: false
    };
    _this.domNode = false;
    _this.inputNode = false;
    _this.onEditBlock = false;
    _this.dragSessionProcess = false;
    return _this;
  }
  businessCardField_createClass(BusinessCardField, [{
    key: "getMenuItems",
    value: function getMenuItems(entityClass) {
      var items = [{
        title: 'copy',
        onClick: this.copyValue
      }, {
        title: 'edit',
        onClick: this.toggleEditLink
      }, {
        title: 'remove',
        onClick: this.removeField
      }];
      if (entityClass !== 'PHONE') {
        items.unshift({
          title: 'open',
          onClick: this.openLink
        });
      }
      return items;
    }
  }, {
    key: "isLink",
    value: function isLink() {
      return LINK_FIELDS.includes(this.props.entityClass);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return (0,preact_module.h)("div", this.getComponentProps(), (0,preact_module.h)("label", {
        className: "businessCardField__label"
      }, this.props.label || this.props.editor.plugins.i18n.get('businessCard.' + this.props.entityClass)), !this.state.editMode ? (0,preact_module.h)("div", {
        ref: function ref(onEditBlock) {
          _this2.onEditBlock = onEditBlock;
        },
        className: "businessCardField__text" + (this.isLink() ? ' businessCardField__text_link' : '') + (this.props.entityClass === 'PERSON' ? ' businessCardField__text_name' : ''),
        onClick: this.onEdit
      }, this.props.value) : (0,preact_module.h)("div", {
        className: 'businessCardField__inputWrapper' + (this.isLink() ? ' businessCardField__inputWrapper_link' : '') + (this.props.entityClass === 'PERSON' ? ' businessCardField__inputWrapper_name' : '')
      }, (0,preact_module.h)("input", this.getInputProps()), this.isLink() ? (0,preact_module.h)(businessCardLinkPanel, {
        url: this.props.value,
        title: this.props.title,
        editor: this.props.editor,
        menuItems: this.getMenuItems(this.props.entityClass),
        isEdit: this.state.isEdit,
        onInputKeyDown: this.onInputKeyDown,
        setDefaultState: this.setDefaultState
      }) : (0,preact_module.h)(icons/* IconTrash */.IT9, {
        className: "businessCardField__inputWrapper__remove",
        onClick: this.removeField
      })));
    }
  }]);
  return BusinessCardField;
}(preact_module/* Component */.wA);
/* harmony default export */ const businessCardField = (BusinessCardField);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/businessCard/businessCardFields.js
function businessCardFields_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { businessCardFields_typeof = function _typeof(obj) { return typeof obj; }; } else { businessCardFields_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return businessCardFields_typeof(obj); }
function businessCardFields_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = businessCardFields_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function businessCardFields_slicedToArray(arr, i) { return businessCardFields_arrayWithHoles(arr) || businessCardFields_iterableToArrayLimit(arr, i) || businessCardFields_unsupportedIterableToArray(arr, i) || businessCardFields_nonIterableRest(); }
function businessCardFields_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function businessCardFields_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return businessCardFields_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return businessCardFields_arrayLikeToArray(o, minLen); }
function businessCardFields_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function businessCardFields_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function businessCardFields_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

















function businessCardFields_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function businessCardFields_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function businessCardFields_createClass(Constructor, protoProps, staticProps) { if (protoProps) businessCardFields_defineProperties(Constructor.prototype, protoProps); if (staticProps) businessCardFields_defineProperties(Constructor, staticProps); return Constructor; }
function businessCardFields_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) businessCardFields_setPrototypeOf(subClass, superClass); }
function businessCardFields_setPrototypeOf(o, p) { businessCardFields_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return businessCardFields_setPrototypeOf(o, p); }
function businessCardFields_createSuper(Derived) { var hasNativeReflectConstruct = businessCardFields_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = businessCardFields_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = businessCardFields_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return businessCardFields_possibleConstructorReturn(this, result); }; }
function businessCardFields_possibleConstructorReturn(self, call) { if (call && (businessCardFields_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return businessCardFields_assertThisInitialized(self); }
function businessCardFields_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function businessCardFields_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function businessCardFields_getPrototypeOf(o) { businessCardFields_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return businessCardFields_getPrototypeOf(o); }
function businessCardFields_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var ALLOWED_ENTITY_CLASSES = ['PERSON', 'ORGANIZATION', 'TITLE', 'ADDRESS', 'URL', 'PHONE', 'EMAIL', 'SKYPE', 'TWITTER', 'INSTAGRAM', 'FACEBOOK', 'LINKEDIN', 'VK'];
var BusinessCardFields = /*#__PURE__*/function (_Component) {
  businessCardFields_inherits(BusinessCardFields, _Component);
  var _super = businessCardFields_createSuper(BusinessCardFields);
  function BusinessCardFields(props) {
    var _this;
    businessCardFields_classCallCheck(this, BusinessCardFields);
    _this = _super.call(this, props);
    businessCardFields_defineProperty(businessCardFields_assertThisInitialized(_this), "onFieldRef", function (field, node) {
      _this.fields[field] = node;
    });
    businessCardFields_defineProperty(businessCardFields_assertThisInitialized(_this), "onRef", function (node) {
      _this.domNode = node;
    });
    businessCardFields_defineProperty(businessCardFields_assertThisInitialized(_this), "businessCardStartDragSession", function (node, key, coords) {
      _this.dSession = new BusinessCardDragSession({
        container: _this.domNode,
        draggingNode: node,
        nodeKey: key,
        options: {
          draggingClass: 'business-card-dragging-field',
          onDragContainerClass: 'business-card-dragging-process',
          placeholderClass: 'business-card-field-drop-phantom',
          onChange: _this.onDragChange
        }
      });
      _this.dSession.startDragging(coords);
    });
    businessCardFields_defineProperty(businessCardFields_assertThisInitialized(_this), "onDragChange", function (index, entityClass) {
      _this.dSession = null;
      _this.props.onFieldPositionChange(index, entityClass);
    });
    _this.fields = {};
    _this.dSession = null;
    return _this;
  }
  businessCardFields_createClass(BusinessCardFields, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var fields = this.props.fields;
      return (0,preact_module.h)("div", {
        className: "business-card-fields-container",
        ref: this.onRef
      }, fields.map(function (field) {
        return ALLOWED_ENTITY_CLASSES.includes(field.entityClass) ? (0,preact_module.h)(businessCardField, {
          domRef: _this2.onFieldRef,
          label: field.label,
          entityClass: field.entityClass,
          value: field.value,
          editor: _this2.props.editor,
          businessCardStartDragSession: _this2.businessCardStartDragSession,
          removeField: _this2.props.removeField,
          changeField: _this2.props.changeField
        }) : null;
      }));
    }
  }]);
  return BusinessCardFields;
}(preact_module/* Component */.wA);
var BusinessCardDragSession = /*#__PURE__*/function () {
  function BusinessCardDragSession(_ref) {
    var _this3 = this;
    var container = _ref.container,
      draggingNode = _ref.draggingNode,
      nodeKey = _ref.nodeKey,
      options = _ref.options;
    businessCardFields_classCallCheck(this, BusinessCardDragSession);
    businessCardFields_defineProperty(this, "onDragMouseMove", function (event) {
      var x = event.clientX,
        y = event.clientY;
      //перемещение драг-ноды
      var rect = _this3.draggingNode.getBoundingClientRect();
      var segmentX = _this3.cursorPosition.x - rect.x;
      var segmentY = _this3.cursorPosition.y - rect.y;
      _this3.draggingNode.style.top = parseInt(y - segmentY) + 'px';
      _this3.draggingNode.style.left = parseInt(x - segmentX) + 'px';
      _this3.setCursorPosition(x, y);
      //перемещение дроп-фантома внутри контейнера со смещением других полей
      //обрабатываем только если мышь находится над контейнером, получение значения мыши над котейнером сделано не простым эвентом только потому, 
      //что тянем само поле и получается, что мышь всегда находится над контейнорм, находясь над дочерней нодой контейнера - драг-нодой
      if (_this3.isMouseOverContainer({
        x: x,
        y: y
      })) {
        var children = Array.from(_this3.container.childNodes).filter(function (node) {
          return node !== _this3.draggingNode;
        });
        var _children$filter = children.filter(function (node) {
            var rect = node.getBoundingClientRect();
            return y > rect.y && y < rect.y + rect.height;
          }),
          _children$filter2 = businessCardFields_slicedToArray(_children$filter, 1),
          overNode = _children$filter2[0];
        if (overNode && overNode !== _this3.dropPhantom) {
          var overNodeRect = overNode.getBoundingClientRect();
          var index;
          if (children.indexOf(overNode) > children.indexOf(_this3.dropPhantom)) {
            index = y > overNodeRect.y && y <= overNodeRect.y + overNodeRect.height / 2 ? children.indexOf(overNode) - 1 : children.indexOf(overNode);
          } else {
            index = y > overNodeRect.y && y <= overNodeRect.y + overNodeRect.height / 2 ? children.indexOf(overNode) : children.indexOf(overNode) + 1;
          }
          _this3.movePhantomToIndex(index, children);
        }
      }
    });
    businessCardFields_defineProperty(this, "onDragMouseUp", function (event) {
      document.removeEventListener('mousemove', _this3.onDragMouseMove, false);
      document.removeEventListener('mouseup', _this3.onDragMouseUp, false);
      _this3.container.removeChild(_this3.dropPhantom);
      _this3.container.classList.remove(_this3.options.onDragContainerClass);
      _this3.draggingNode.removeAttribute('style');
      _this3.draggingNode.classList.remove(_this3.options.draggingClass);
      var children = Array.from(_this3.container.childNodes);
      for (var _i2 = 0, _children = children; _i2 < _children.length; _i2++) {
        var node = _children[_i2];
        node.style.transform = '';
      }
      if (_this3.dropIndex === children.length - 1) {
        _this3.container.appendChild(_this3.draggingNode);
      } else {
        if (children.indexOf(_this3.draggingNode) > _this3.dropIndex) {
          _this3.container.insertBefore(_this3.draggingNode, children[_this3.dropIndex]);
        } else {
          _this3.container.insertBefore(_this3.draggingNode, children[_this3.dropIndex + 1]);
        }
      }
      if (_this3.options.onChange) {
        _this3.options.onChange(_this3.dropIndex, _this3.draggingNodeKey);
      }
      _this3.container = null;
      _this3.draggingNode = null;
      _this3.draggingNodeKey = null;
      _this3.options = null;
      _this3.cursorPosition = null;
      _this3.dropPhantom = null;
      _this3.dropIndex = null;
    });
    this.container = container;
    this.draggingNode = draggingNode;
    this.draggingNodeKey = nodeKey;
    this.options = Object.assign({
      draggingClass: 'dragging',
      onDragContainerClass: 'dragging-container',
      placeholderClass: 'dragging-phantom'
    }, options);
    this.cursorPosition = null;
    this.dropPhantom = null;
    this.dropIndex = null;
  }
  businessCardFields_createClass(BusinessCardDragSession, [{
    key: "setCursorPosition",
    value: function setCursorPosition(x, y) {
      this.cursorPosition = Object.freeze({
        x: x,
        y: y
      });
    }

    //так как в этой версии d&d мы захватываем саму ноду, то события типа mouseover, mouseleave не будут корректно работать на контейнер d&d,
    //для этого нужно проверять находится ли мышь в пределах координат контейнера
  }, {
    key: "isMouseOverContainer",
    value: function isMouseOverContainer(_ref2) {
      var x = _ref2.x,
        y = _ref2.y;
      var rect = this.container.getBoundingClientRect();
      return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
    }

    //тут отделяем драг-ноду от полотна
  }, {
    key: "prepareForDrag",
    value: function prepareForDrag(coords) {
      var rect = this.draggingNode.getBoundingClientRect();
      var segmentX = coords.x - rect.x;
      var segmentY = coords.y - rect.y;
      this.draggingNode.classList.add(this.options.draggingClass);
      this.draggingNode.style.position = 'fixed';
      this.draggingNode.style.width = rect.width + 'px';
      this.draggingNode.style.height = rect.height + 'px';
      this.draggingNode.style.top = parseInt(coords.y - segmentY) + 'px';
      this.draggingNode.style.left = parseInt(coords.x - segmentX) + 'px';
      this.addDropPhantom(rect.width, rect.height);
      this.container.classList.add(this.options.onDragContainerClass);
    }

    //добавляем плейсхолдер для драг-ноды
  }, {
    key: "addDropPhantom",
    value: function addDropPhantom(width, height) {
      this.dropIndex = Array.from(this.container.childNodes).indexOf(this.draggingNode);
      this.dropPhantom = document.createElement('div');
      this.dropPhantom.classList.add(this.options.placeholderClass);
      this.dropPhantom.style.width = width + 'px';
      this.dropPhantom.style.height = height + 'px';
      this.container.insertBefore(this.dropPhantom, this.draggingNode);
    }
  }, {
    key: "movePhantomToIndex",
    value: function movePhantomToIndex(index) {
      var children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (!children.length) return;
      if (this.dropIndex === index) return;
      var phantomDomIndex = children.indexOf(this.dropPhantom);
      var phantomHeight = this.dropPhantom.getBoundingClientRect().height;
      //транслируем поля
      var _iterator = businessCardFields_createForOfIteratorHelper(children),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var node = _step.value;
          var nodeIndex = children.indexOf(node);
          if (nodeIndex > phantomDomIndex) {
            if (nodeIndex <= index) {
              node.style.transform = 'translateY(-' + phantomHeight + 'px)';
            } else {
              node.style.transform = 'translateY(0px)';
            }
          } else if (nodeIndex < phantomDomIndex) {
            if (nodeIndex >= index) {
              node.style.transform = 'translateY(' + phantomHeight + 'px)';
            } else {
              node.style.transform = 'translateY(0px)';
            }
          }
        }
        //транслируем фантом
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var phantomTranslate = 0;
      if (phantomDomIndex < index) {
        for (var i = phantomDomIndex + 1; i <= index; i++) {
          phantomTranslate += children[i].getBoundingClientRect().height;
        }
      } else {
        for (var _i3 = index; _i3 <= phantomDomIndex - 1; _i3++) {
          phantomTranslate -= children[_i3].getBoundingClientRect().height;
        }
      }
      this.dropPhantom.style.transform = 'translateY(' + phantomTranslate + 'px)';
      this.dropIndex = index;
    }
  }, {
    key: "startDragging",
    value: function startDragging(coords) {
      this.prepareForDrag(coords);
      this.setCursorPosition(coords.x, coords.y);
      document.addEventListener('mousemove', this.onDragMouseMove, false);
      document.addEventListener('mouseup', this.onDragMouseUp, false);
    }
  }]);
  return BusinessCardDragSession;
}();
/* harmony default export */ const businessCardFields = (BusinessCardFields);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/businessCard/businessCard.js
function businessCard_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { businessCard_typeof = function _typeof(obj) { return typeof obj; }; } else { businessCard_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return businessCard_typeof(obj); }
function businessCard_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = businessCard_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function businessCard_slicedToArray(arr, i) { return businessCard_arrayWithHoles(arr) || businessCard_iterableToArrayLimit(arr, i) || businessCard_unsupportedIterableToArray(arr, i) || businessCard_nonIterableRest(); }
function businessCard_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function businessCard_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return businessCard_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return businessCard_arrayLikeToArray(o, minLen); }
function businessCard_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function businessCard_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function businessCard_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




















function businessCard_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function businessCard_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function businessCard_createClass(Constructor, protoProps, staticProps) { if (protoProps) businessCard_defineProperties(Constructor.prototype, protoProps); if (staticProps) businessCard_defineProperties(Constructor, staticProps); return Constructor; }
function businessCard_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { businessCard_get = Reflect.get; } else { businessCard_get = function _get(target, property, receiver) { var base = businessCard_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return businessCard_get(target, property, receiver || target); }
function businessCard_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = businessCard_getPrototypeOf(object); if (object === null) break; } return object; }
function businessCard_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) businessCard_setPrototypeOf(subClass, superClass); }
function businessCard_setPrototypeOf(o, p) { businessCard_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return businessCard_setPrototypeOf(o, p); }
function businessCard_createSuper(Derived) { var hasNativeReflectConstruct = businessCard_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = businessCard_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = businessCard_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return businessCard_possibleConstructorReturn(this, result); }; }
function businessCard_possibleConstructorReturn(self, call) { if (call && (businessCard_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return businessCard_assertThisInitialized(self); }
function businessCard_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function businessCard_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function businessCard_getPrototypeOf(o) { businessCard_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return businessCard_getPrototypeOf(o); }
function businessCard_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
















var businessCard_mixin = mix([embeddable, draggable, dropAcceptor, colorable, selectable, focusable, executable, commentable, basic]);
var CARD_CONTAINER_CLASS = 'business-card-container';
var BusinessCard = /*#__PURE__*/function (_mixin) {
  businessCard_inherits(BusinessCard, _mixin);
  var _super = businessCard_createSuper(BusinessCard);
  function BusinessCard(domNode) {
    var _this;
    businessCard_classCallCheck(this, BusinessCard);
    _this = _super.call(this, domNode);
    businessCard_defineProperty(businessCard_assertThisInitialized(_this), "mapObserver", function () {
      _this.render();
    });
    businessCard_defineProperty(businessCard_assertThisInitialized(_this), "removeField", function (entityClass) {
      //клонируем массив на всякий случай
      var fields = Array.from(_this.map.get('fields')).filter(function (field) {
        return field.entityClass !== entityClass;
      });
      _this.map.set('fields', fields);
    });
    businessCard_defineProperty(businessCard_assertThisInitialized(_this), "changeField", function (entityClass, value) {
      //клонируем массив на всякий случай
      var fields = Array.from(_this.map.get('fields'));
      for (var _i = 0, _fields = fields; _i < _fields.length; _i++) {
        var field = _fields[_i];
        if (field.entityClass === entityClass) {
          field.value = value;
        }
      }
      _this.map.set('fields', fields);
    });
    businessCard_defineProperty(businessCard_assertThisInitialized(_this), "onFieldPositionChange", function (newIndex, entityClass) {
      var fields = Array.from(_this.map.get('fields'));
      var currentFieldindex, fieldValue;
      for (var _i2 = 0, _fields2 = fields; _i2 < _fields2.length; _i2++) {
        var field = _fields2[_i2];
        if (field.entityClass === entityClass) {
          currentFieldindex = fields.indexOf(field);
          fieldValue = field;
        }
      }
      if (typeof currentFieldindex === 'undefined') return;
      fields.splice(currentFieldindex, 1);
      fields.splice(newIndex, 0, fieldValue);
      _this.map.set('fields', fields);
    });
    _this.isSeparableByClickApplicable = true;
    _this.addCanExecActions(['delete', 'backspace']);
    _this.disallowReplace = true;
    return _this;
  }
  businessCard_createClass(BusinessCard, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = businessCard_get(businessCard_getPrototypeOf(BusinessCard.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      this.store.observe(this.map, this.mapObserver);
      this.render();
    }
  }, {
    key: "detach",
    value: function detach() {
      if (businessCard_get(businessCard_getPrototypeOf(BusinessCard.prototype), "detach", this)) {
        var _get3;
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        (_get3 = businessCard_get(businessCard_getPrototypeOf(BusinessCard.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      }
      this.store.unobserve(this.map, this.mapObserver);
    }
  }, {
    key: "hasFrontSideAttachment",
    value: function hasFrontSideAttachment() {
      return Boolean(this.map.get('frontSideAttachmentGlobalId'));
    }
  }, {
    key: "hasBackSideAttachment",
    value: function hasBackSideAttachment() {
      return Boolean(this.map.get('backSideAttachmentGlobalId'));
    }
  }, {
    key: "cloneSelf",
    value: function cloneSelf() {
      var map = this.store.createMap();
      parchment_default().query(this.map.get('type')).initMap(map, this.store, {
        fields: this.map.get('fields'),
        frontSideAttachmentGlobalId: this.map.get('frontSideAttachmentGlobalId'),
        backSideAttachmentGlobalId: this.map.get('backSideAttachmentGlobalId')
      });
      return map.get('id');
    }
  }, {
    key: "render",
    value: function render() {
      if (businessCard_get(businessCard_getPrototypeOf(BusinessCard.prototype), "render", this)) {
        businessCard_get(businessCard_getPrototypeOf(BusinessCard.prototype), "render", this).call(this);
      }
      var cardContainer = this.domNode.querySelector('.' + CARD_CONTAINER_CLASS);
      if (this.hasFrontSideAttachment() && !this.props.frontSideAttachment) {
        this.resolveAttachment(this.map.get('frontSideAttachmentGlobalId'), 'front');
      }
      if (this.hasBackSideAttachment() && !this.props.backSideAttachment) {
        this.resolveAttachment(this.map.get('backSideAttachmentGlobalId'), 'back');
      }
      (0,preact_module/* render */.sY)((0,preact_module.h)("div", {
        className: "business-card-content"
      }, (0,preact_module.h)(businessCardAttachment, {
        frontSideAttachment: this.props.frontSideAttachment,
        backSideAttachment: this.props.backSideAttachment,
        hasFrontSide: this.hasFrontSideAttachment(),
        editor: this.editor,
        hasBackSide: this.hasBackSideAttachment()
      }), (0,preact_module.h)(businessCardFields, {
        fields: this.map.get('fields'),
        removeField: this.removeField,
        changeField: this.changeField,
        editor: this.editor,
        onFieldPositionChange: this.onFieldPositionChange
      })), cardContainer);
    }
  }, {
    key: "resolveAttachment",
    value: function resolveAttachment(attachmentGlobalId, side) {
      var _this2 = this;
      if (this['_' + side + 'AttachmentResolveInProgress']) {
        return;
      }
      this['_' + side + 'AttachmentResolveInProgress'] = true;
      this.editor.plugins.attachmentManager.resolve(attachmentGlobalId, {
        blotName: this.constructor.blotName
      }).then(function (attachment) {
        _this2.setProps(businessCard_defineProperty({}, side + 'SideAttachment', attachment));
        _this2['_' + side + 'AttachmentResolveInProgress'] = false;
      }).catch(function (err) {
        console.error('fail to resolve attachment', err);
        _this2['_' + side + 'AttachmentResolveInProgress'] = false;
        _this2.setProps(businessCard_defineProperty({}, side + 'AttachmentSetError', err));
      });
    }
  }, {
    key: "exec",
    value: function exec(action) {
      var processed = businessCard_get(businessCard_getPrototypeOf(BusinessCard.prototype), "exec", this).call(this, action);
      return processed;
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      var node = this.domNode.cloneNode(true);

      //remove caret trap node
      var trap = node.querySelector('.caret-trap');
      if (trap) {
        trap.parentNode.removeChild(trap);
      }

      // save images
      var _Array$from = Array.from(node.querySelectorAll('.business-card-images img')),
        _Array$from2 = businessCard_slicedToArray(_Array$from, 2),
        oldFrontSideImg = _Array$from2[0],
        oldBackSideImg = _Array$from2[1];
      if (this.props.frontSideAttachment && oldFrontSideImg) {
        context.addAttachment(this.props.frontSideAttachment);
        var frontSideImgPatch = context.getAttachmentPath(this.props.frontSideAttachment);
        var aWrapperFrontSide = document.createElement('a');
        aWrapperFrontSide.setAttribute('href', frontSideImgPatch);
        aWrapperFrontSide.setAttribute('target', '_blank');
        var frontSideImg = oldFrontSideImg.cloneNode();
        frontSideImg.setAttribute('src', frontSideImgPatch);
        aWrapperFrontSide.appendChild(frontSideImg);
        oldFrontSideImg.parentNode.replaceChild(aWrapperFrontSide, oldFrontSideImg);
      }
      if (this.props.backSideAttachment) {
        if (!oldBackSideImg && !this.props.frontSideAttachment && oldFrontSideImg) {
          oldBackSideImg = oldFrontSideImg;
        }
        context.addAttachment(this.props.backSideAttachment);
        var backSideImgPatch = context.getAttachmentPath(this.props.backSideAttachment);
        var aWrapperBackSide = document.createElement('a');
        aWrapperBackSide.setAttribute('href', backSideImgPatch);
        aWrapperBackSide.setAttribute('target', '_blank');
        var backSideImg = oldBackSideImg.cloneNode();
        backSideImg.setAttribute('src', backSideImgPatch);
        aWrapperBackSide.appendChild(backSideImg);
        oldBackSideImg.parentNode.replaceChild(aWrapperBackSide, oldBackSideImg);
      }

      // wrap links
      var fields = this.map.get('fields');
      var fieldNodes = Array.from(node.querySelectorAll('.business-card-fields-container .businessCardField'));
      var _iterator = businessCard_createForOfIteratorHelper(fields),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var field = _step.value;
          if (LINK_FIELDS.includes(field.entityClass)) {
            var oldFieldNode = fieldNodes[fields.indexOf(field)].querySelector('.businessCardField__text');
            if (oldFieldNode) {
              var fieldNode = oldFieldNode.cloneNode();
              var fieldLink = document.createElement('a');
              fieldLink.setAttribute('href', getLinkData(field.entityClass, field.value).href);
              fieldLink.setAttribute('target', '_blank');
              // почему то через innerText не получается и ссылка остается пустой
              var fieldText = document.createTextNode(field.value);
              fieldLink.appendChild(fieldText);
              fieldNode.appendChild(fieldLink);
              oldFieldNode.parentNode.replaceChild(fieldNode, oldFieldNode);
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return node.outerHTML;
    }
  }], [{
    key: "create",
    value: function create(value) {
      var node = businessCard_get(businessCard_getPrototypeOf(BusinessCard), "create", this).call(this);
      node.classList.add('business-card');
      var cardContainer = document.createElement('div');
      cardContainer.setAttribute('contenteditable', false);
      cardContainer.classList.add(CARD_CONTAINER_CLASS);
      node.appendChild(cardContainer);
      return node;
    }
  }, {
    key: "createBlot",
    value: function createBlot(editor) {
      var blot = parchment_default().create('businessCard');
      this.addCaretTrap(editor, blot.domNode);
      return blot;
    }
  }]);
  return BusinessCard;
}(businessCard_mixin(AttachmentsBase));
BusinessCard.blotName = 'businessCard';
BusinessCard.tagName = 'DIV';
BusinessCard.initMap = function (map, store) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  map.set('type', 'businessCard');
  map.set('fields', params.fields);
  if (params.frontSideAttachmentGlobalId) {
    map.set('frontSideAttachmentGlobalId', params.frontSideAttachmentGlobalId);
  }
  if (params.backSideAttachmentGlobalId) {
    map.set('backSideAttachmentGlobalId', params.backSideAttachmentGlobalId);
  }
};
/* harmony default export */ const businessCard = (BusinessCard);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/blotSourceInput.js
function blotSourceInput_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { blotSourceInput_typeof = function _typeof(obj) { return typeof obj; }; } else { blotSourceInput_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return blotSourceInput_typeof(obj); }












function blotSourceInput_extends() { blotSourceInput_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return blotSourceInput_extends.apply(this, arguments); }
function blotSourceInput_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function blotSourceInput_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function blotSourceInput_createClass(Constructor, protoProps, staticProps) { if (protoProps) blotSourceInput_defineProperties(Constructor.prototype, protoProps); if (staticProps) blotSourceInput_defineProperties(Constructor, staticProps); return Constructor; }
function blotSourceInput_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) blotSourceInput_setPrototypeOf(subClass, superClass); }
function blotSourceInput_setPrototypeOf(o, p) { blotSourceInput_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return blotSourceInput_setPrototypeOf(o, p); }
function blotSourceInput_createSuper(Derived) { var hasNativeReflectConstruct = blotSourceInput_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = blotSourceInput_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = blotSourceInput_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return blotSourceInput_possibleConstructorReturn(this, result); }; }
function blotSourceInput_possibleConstructorReturn(self, call) { if (call && (blotSourceInput_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return blotSourceInput_assertThisInitialized(self); }
function blotSourceInput_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function blotSourceInput_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function blotSourceInput_getPrototypeOf(o) { blotSourceInput_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return blotSourceInput_getPrototypeOf(o); }
function blotSourceInput_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var blotSourceInput_isBackspaceKey = (0,lib/* default */.ZP)('backspace');
var blotSourceInput_isEnterKey = (0,lib/* default */.ZP)('enter');
var blotSourceInput_isEscKey = (0,lib/* default */.ZP)('esc');

/*
  Возможные props
  editor - инстанс редактора, нужен для обновления позиции корзины при обновлениях редактора
  classNamePrefix - префикс классов для компонента
  placeholder - строка, которая будет показыватья при пустом значении поля ввода
  bufferString - строка, которую необходимо использовать как начальное значение поля ввода (по умолчанию пустая)
  onComponentRef - функция для получения ссылки на компонент
  onDomRef - функция для получения ссылки на DOM компонента
  onInputRef - функция для получения ссылки на DOM поля ввода
  onBufferRef - функция для получения ссылки на DOM буфера
  onEmptyValueBackspace - функция поведения нажатия Backspace при пустом поле ввода
  onPaste - функция обрабатывающая вставку в поле ввода
  onValidateSource - функция валидации, должна вернуть объект { error, source }
  onApplySource - функция обрабатывающая подтверждение ввода (Enter)
  onSourceInputCancel - функция обрабатыающая отмену ввода (Esc)
  onSourceInputRemove - функция обрабатывающая удаление блота через корзину
*/
var BlotSourceInput = /*#__PURE__*/function (_Component) {
  blotSourceInput_inherits(BlotSourceInput, _Component);
  var _super = blotSourceInput_createSuper(BlotSourceInput);
  function BlotSourceInput(props) {
    var _this;
    blotSourceInput_classCallCheck(this, BlotSourceInput);
    _this = _super.call(this, props);
    blotSourceInput_defineProperty(blotSourceInput_assertThisInitialized(_this), "onRef", function (node) {
      _this.domNode = node;
      if (_this.props.onDomRef) {
        _this.props.onDomRef(node);
      }
    });
    blotSourceInput_defineProperty(blotSourceInput_assertThisInitialized(_this), "onInputRef", function (node) {
      _this.inputDomNode = node;
      if (_this.props.onInputRef) {
        _this.props.onInputRef(node);
      }
    });
    blotSourceInput_defineProperty(blotSourceInput_assertThisInitialized(_this), "onBufferRef", function (node) {
      _this.bufferDomNode = node;
      if (_this.props.onBufferDomRef) {
        _this.props.onBufferDomRef(node);
      }
    });
    blotSourceInput_defineProperty(blotSourceInput_assertThisInitialized(_this), "onTrashRef", function (node) {
      _this.trashDomNode = node;
    });
    blotSourceInput_defineProperty(blotSourceInput_assertThisInitialized(_this), "onMouseDownPreventDefault", function (event) {
      event.stopPropagation();
      event.preventDefault();
    });
    blotSourceInput_defineProperty(blotSourceInput_assertThisInitialized(_this), "onInputKeyDown", function (event) {
      var target = event.target;
      event.stopPropagation();
      if (blotSourceInput_isEscKey(event)) {
        _this.props.onSourceInputCancel();
      }
      if (Boolean(target.value)) {
        if (blotSourceInput_isEnterKey(event)) {
          event.preventDefault();
          _this.onApplySource(target.value);
        }
      } else {
        if (blotSourceInput_isBackspaceKey(event)) {
          if (_this.props.onEmptyValueBackspace) {
            _this.props.onEmptyValueBackspace();
          }
        }
      }
    });
    blotSourceInput_defineProperty(blotSourceInput_assertThisInitialized(_this), "onInputInput", function (event) {
      var target = event.target;
      _this.setState(function (prevState) {
        var error = prevState.error;
        var newState = {
          bufferString: target.value || ''
        };
        if (error) {
          newState.error = false;
        }
        return newState;
      });
    });
    blotSourceInput_defineProperty(blotSourceInput_assertThisInitialized(_this), "onInputPaste", function (event) {
      if (_this.props.onPaste) {
        _this.props.onPaste(event);
      } else {
        event.preventDefault();
        event.stopPropagation();
        var string = event.clipboardData.getData('text/plain');
        // тут без setState для оптимизации, чтобы избежать ненужный рендер
        _this.state.bufferString = string;
        _this.onApplySource(string);
      }
    });
    blotSourceInput_defineProperty(blotSourceInput_assertThisInitialized(_this), "onInputMouseDown", function (event) {
      var target = event.target;
      if (document.activeElement !== target) {
        // так как нажатие мыши обрабатывается еще блотом, нужно подождать пока отработают все события
        setTimeout(function () {
          target.select();
        }, 0);
      } else {
        event.stopPropagation();
      }
    });
    blotSourceInput_defineProperty(blotSourceInput_assertThisInitialized(_this), "onDeleteClick", function () {
      _this.setState(function () {
        return {
          bufferString: '',
          error: ''
        };
      }, function () {
        //setTimeout(() => { this.inputDomNode.focus() }, 0)
        _this.inputDomNode.focus();
      });
    });
    blotSourceInput_defineProperty(blotSourceInput_assertThisInitialized(_this), "onRemoveClick", function (event) {
      event.preventDefault();
      event.stopPropagation();
      _this.props.onSourceInputRemove();
    });
    blotSourceInput_defineProperty(blotSourceInput_assertThisInitialized(_this), "onApplySource", function (string) {
      if (_this.props.onValidateSource) {
        var _this$props$onValidat = _this.props.onValidateSource(string),
          error = _this$props$onValidat.error,
          source = _this$props$onValidat.source;
        if (error) {
          if (typeof error !== 'string') {
            console.error(error);
            error = 'Unknown error';
          }
          _this.setState(function () {
            return {
              error: error
            };
          });
        } else {
          _this.props.onApplySource(source);
        }
      } else {
        _this.props.onApplySource(string);
      }
    });
    blotSourceInput_defineProperty(blotSourceInput_assertThisInitialized(_this), "onEditorUpdate", function () {
      _this.updateTrashPosition();
    });
    _this.state = {
      bufferString: props.bufferString || ''
    };
    return _this;
  }
  blotSourceInput_createClass(BlotSourceInput, [{
    key: "isEmpty",
    value: function isEmpty() {
      return !Boolean(this.state.bufferString);
    }
  }, {
    key: "updateTrashPosition",
    value: function updateTrashPosition() {
      var trashRightOffset = this.inputDomNode.clientWidth - this.bufferDomNode.clientWidth - 30;
      this.trashDomNode.style.right = (trashRightOffset >= 0 ? trashRightOffset : 0) + 'px';
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (this.props.onComponentRef) {
        this.props.onComponentRef(this);
      }
      // ждем все обновления и ставим фокус
      setTimeout(function () {
        _this2.inputDomNode.focus();
      }, 0);
      // нужно для обновления позиции корзинки при ресайзе колонок и т.п.
      if (this.props.editor) {
        this.props.editor.on('editorUpdate', this.onEditorUpdate);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateTrashPosition();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.editor) {
        this.props.editor.off('editorUpdate', this.onEditorUpdate);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classNamePrefix = _this$props.classNamePrefix,
        placeholder = _this$props.placeholder,
        autocapitalize = _this$props.autocapitalize;
      var _this$state = this.state,
        bufferString = _this$state.bufferString,
        error = _this$state.error;
      var inputProps = {
        autocapitalize: autocapitalize,
        placeholder: placeholder
      };
      return (0,preact_module.h)("div", blotSourceInput_extends({
        className: classNamePrefix + '-source-input-wrapper block-source-input-wrapper',
        ref: this.onRef,
        onMouseDown: this.onDomMouseDown
      }, blotSourceInput_defineProperty({
        contenteditable: 'false'
      }, scroll_IGNORE_SELECT_ATTR, 1)), error ? (0,preact_module.h)("div", {
        className: classNamePrefix + '-source-input-error block-source-input-error'
      }, error) : null, (0,preact_module.h)(BlotSourceInputField, blotSourceInput_extends({
        classNamePrefix: classNamePrefix,
        bufferString: bufferString,
        onBufferRef: this.onBufferRef,
        onInputRef: this.onInputRef,
        onTrashRef: this.onTrashRef,
        onInputKeyDown: this.onInputKeyDown,
        onInputInput: this.onInputInput,
        onInputMouseDown: this.onInputMouseDown,
        onInputPaste: this.onInputPaste,
        onDeleteClick: this.onDeleteClick,
        onRemoveClick: this.onRemoveClick,
        onMouseDownPreventDefault: this.onMouseDownPreventDefault,
        isEmpty: this.isEmpty()
      }, inputProps)));
    }
  }]);
  return BlotSourceInput;
}(preact_module/* Component */.wA); // Вынес инпут и его компоненты в отдельный класс, по другому не смог пофиксить null'евые ref при двойных вызовах

var BlotSourceInputField = /*#__PURE__*/function () {
  function BlotSourceInputField() {
    blotSourceInput_classCallCheck(this, BlotSourceInputField);
  }
  blotSourceInput_createClass(BlotSourceInputField, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        classNamePrefix = _this$props2.classNamePrefix,
        bufferString = _this$props2.bufferString,
        onBufferRef = _this$props2.onBufferRef,
        onInputRef = _this$props2.onInputRef,
        onTrashRef = _this$props2.onTrashRef,
        onInputKeyDown = _this$props2.onInputKeyDown,
        onInputInput = _this$props2.onInputInput,
        onInputMouseDown = _this$props2.onInputMouseDown,
        onInputPaste = _this$props2.onInputPaste,
        onRemoveClick = _this$props2.onRemoveClick,
        onDeleteClick = _this$props2.onDeleteClick,
        onMouseDownPreventDefault = _this$props2.onMouseDownPreventDefault,
        isEmpty = _this$props2.isEmpty,
        autocapitalize = _this$props2.autocapitalize,
        placeholder = _this$props2.placeholder;
      var trashOnClickHandler = isEmpty ? onRemoveClick : onDeleteClick;
      return (0,preact_module.h)("div", {
        className: classNamePrefix + '-source-input-container block-source-input-container'
      }, (0,preact_module.h)("div", {
        className: classNamePrefix + '-source-input-buffer block-source-input-buffer',
        ref: onBufferRef,
        dangerouslySetInnerHTML: {
          __html: (bufferString ? bufferString : placeholder).replace(/\s/gm, '&nbsp;')
        }
      }), (0,preact_module.h)("input", {
        className: classNamePrefix + '-source-input-input block-source-input-input',
        type: "text",
        ref: onInputRef,
        onKeyDown: onInputKeyDown,
        onInput: onInputInput,
        onMouseDown: onInputMouseDown,
        onPaste: onInputPaste,
        value: bufferString,
        autocapitalize: autocapitalize,
        placeholder: placeholder
      }), (0,preact_module.h)("div", {
        className: classNamePrefix + '-source-delete block-source-input-delete',
        onClick: trashOnClickHandler,
        onMouseDown: onMouseDownPreventDefault,
        ref: onTrashRef
      }, (0,preact_module.h)(icons/* IconTrash */.IT9, null)));
    }
  }]);
  return BlotSourceInputField;
}();
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/bookmark/component.js
function component_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { component_typeof = function _typeof(obj) { return typeof obj; }; } else { component_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return component_typeof(obj); }










function component_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function component_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function component_createClass(Constructor, protoProps, staticProps) { if (protoProps) component_defineProperties(Constructor.prototype, protoProps); if (staticProps) component_defineProperties(Constructor, staticProps); return Constructor; }
function component_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) component_setPrototypeOf(subClass, superClass); }
function component_setPrototypeOf(o, p) { component_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return component_setPrototypeOf(o, p); }
function component_createSuper(Derived) { var hasNativeReflectConstruct = component_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = component_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = component_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return component_possibleConstructorReturn(this, result); }; }
function component_possibleConstructorReturn(self, call) { if (call && (component_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return component_assertThisInitialized(self); }
function component_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function component_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function component_getPrototypeOf(o) { component_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return component_getPrototypeOf(o); }
function component_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var BookmarkComponent = /*#__PURE__*/function (_Component) {
  component_inherits(BookmarkComponent, _Component);
  var _super = component_createSuper(BookmarkComponent);
  function BookmarkComponent(props) {
    var _this;
    component_classCallCheck(this, BookmarkComponent);
    _this = _super.call(this, props);
    component_defineProperty(component_assertThisInitialized(_this), "onMouseDown", function (event) {
      if (event.which === 3 || event.which === 2) return;
      event.preventDefault();
      _this.processOpenLink = true;
      _this.props.observeStartDragging(_this.onEditorStartDragging);
    });
    component_defineProperty(component_assertThisInitialized(_this), "onMouseUp", function (event) {
      if (event.which === 3 || event.which === 2 || !_this.processOpenLink) return;
      if (_this.props.src) {
        event.preventDefault();
        var editor = _this.props.editor;
        var isInternalLink = false;
        if (editor.options.baseUrl) {
          isInternalLink = getHostFromUrl(editor.options.baseUrl) === getHostFromUrl(_this.props.src);
        }
        if (isInternalLink) {
          if (editor && editor.plugins.linkManager.processNavigation(_this.props.src)) {
            return;
          }
        }
        if (_this.props.openInSameTab) {
          window.location.href = _this.props.src;
        } else {
          if (!editor.plugins.linkManager.processNavigation(_this.props.src)) {
            window.open(_this.props.src, '_blank', 'noopener');
          }
        }
      }
    });
    component_defineProperty(component_assertThisInitialized(_this), "onEditorStartDragging", function () {
      _this.processOpenLink = false;
      _this.props.unobserveStartDragging(_this.onEditorStartDragging);
    });
    component_defineProperty(component_assertThisInitialized(_this), "onLinkClick", function (event) {
      event.preventDefault();
    });
    component_defineProperty(component_assertThisInitialized(_this), "onPreviewLoad", function (event) {
      _this.setState(function () {
        return {
          previewLoaded: true
        };
      });
    });
    component_defineProperty(component_assertThisInitialized(_this), "onPreviewLoadError", function (event) {
      _this.setState(function () {
        return {
          previewError: true
        };
      });
    });
    component_defineProperty(component_assertThisInitialized(_this), "t", function (key) {
      return _this.props.i18n.get(key);
    });
    component_defineProperty(component_assertThisInitialized(_this), "renderLoading", function () {
      var classPrefix = _this.props.classPrefix;
      return (0,preact_module.h)("div", {
        className: classPrefix + '-loading-icon'
      }, (0,preact_module.h)((loader2_default()), null), (0,preact_module.h)("span", {
        className: classPrefix + '-loading-icon-text'
      }, _this.t('bookmark.loading_preview')));
    });
    _this.linkRef = false;
    _this.state = {
      previewLoaded: false,
      previewError: false
    };
    _this.placeholderText = _this.t('bookmark.placeholder');
    if (props.editor.options.keyboardMode === 'mobile') {
      _this.placeholderText = _this.t('bookmark.placeholder_mobile');
    }
    return _this;
  }
  component_createClass(BookmarkComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classPrefix = _this$props.classPrefix,
        name = _this$props.name,
        src = _this$props.src,
        description = _this$props.description,
        icon = _this$props.icon,
        viewMode = _this$props.viewMode,
        attachment = _this$props.attachment,
        setAttachmentError = _this$props.setAttachmentError,
        isAttachmentChangedAndLoading = _this$props.isAttachmentChangedAndLoading,
        isPreviewNotAvailable = _this$props.isPreviewNotAvailable,
        maxWidth = _this$props.maxWidth,
        previewBackgroundColor = _this$props.previewBackgroundColor,
        editor = _this$props.editor;
      var _this$state = this.state,
        previewLoaded = _this$state.previewLoaded,
        previewError = _this$state.previewError;
      var exportMode = editor.mode === editor.constructor.MODE_EXPORT;
      if (!src) {
        return (0,preact_module.h)(BlotSourceInput, {
          classNamePrefix: classPrefix,
          onValidateSource: this.props.onValidateSource,
          onApplySource: this.props.onApplySrc,
          placeholder: this.placeholderText,
          onEmptyValueBackspace: this.props.onPlaceholderEmptyValueBackspace,
          onSourceInputCancel: this.props.onSourceInputCancel,
          onSourceInputRemove: this.props.onSourceInputRemove,
          autocapitalize: "off",
          editor: editor
        });
      } else if (!attachment && !setAttachmentError && !isPreviewNotAvailable) {
        return this.renderLoading();
      }
      var previewNode = null,
        descriptionNode = null,
        iconNode = (0,preact_module.h)("div", {
          className: classPrefix + '__icon'
        }, icon ? (0,preact_module.h)("img", {
          src: icon
        }) : (0,preact_module.h)(icons/* IconBookmark */.BZM, null));
      if (viewMode !== 'tile') {
        descriptionNode = (0,preact_module.h)("div", {
          className: classPrefix + '__info__desc'
        }, description);
        if (attachment && !isAttachmentChangedAndLoading && !previewError) {
          var previewImgStyles = {};
          if (!previewLoaded && !exportMode) {
            previewImgStyles = {
              width: '0px',
              height: '0px',
              opacity: '0'
            };
          }
          previewNode = (0,preact_module.h)("div", {
            className: classPrefix + '__preview' + (!previewLoaded && !exportMode ? ' loading-preview' : '')
          }, !previewLoaded && !exportMode ? (0,preact_module.h)((loader2_default()), null) : null, (0,preact_module.h)("img", {
            style: previewImgStyles,
            src: attachment.url,
            onLoad: this.onPreviewLoad,
            onError: this.onPreviewLoadError
          }));
        } else if (isPreviewNotAvailable || previewError || setAttachmentError) {
          if (viewMode === 'cover') {
            var addPreviewBgClass = previewBackgroundColor ? previewBackgroundColor : null;
            previewNode = (0,preact_module.h)("div", {
              className: classPrefix + '__preview preview-not-available',
              "data-block-background": addPreviewBgClass
            }, (0,preact_module.h)("span", null, getHostFromUrl(src)));
          } else {
            previewNode = (0,preact_module.h)("div", {
              className: classPrefix + '__preview preview-not-available'
            }, (0,preact_module.h)(icons/* IconBookmark */.BZM, null));
          }
        } else {
          previewNode = (0,preact_module.h)("div", {
            className: classPrefix + '__preview loading-preview'
          }, (0,preact_module.h)((loader2_default()), null));
        }
      }
      return (0,preact_module.h)("a", {
        href: src,
        onClick: this.onLinkClick,
        style: {
          display: 'contents'
        }
      }, (0,preact_module.h)("div", {
        className: classPrefix + '-content is-' + viewMode,
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp,
        style: {
          maxWidth: maxWidth + 'px'
        }
      }, viewMode === 'tile' ? iconNode : null, (0,preact_module.h)("div", {
        className: classPrefix + '__info'
      }, viewMode !== 'cover' ? (0,preact_module.h)("div", {
        className: classPrefix + '__info__name'
      }, name) : null, (0,preact_module.h)("a", {
        className: classPrefix + '__info__src',
        href: src,
        onClick: this.onLinkClick
      }, viewMode !== 'tile' ? iconNode : null, (0,preact_module.h)("div", {
        className: classPrefix + '__info__src-text' + (!name ? ' no-title' : '')
      }, viewMode === 'cover' && name ? name : src)), viewMode !== 'cover' ? descriptionNode : null), previewNode));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var isAttachmentChangedAndLoading = props.isAttachmentChangedAndLoading;
      if (isAttachmentChangedAndLoading) {
        return {
          previewLoaded: false,
          previewError: false
        };
      }
      return null;
    }
  }]);
  return BookmarkComponent;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/popupInputItem.js
function popupInputItem_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function popupInputItem_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function popupInputItem_createClass(Constructor, protoProps, staticProps) { if (protoProps) popupInputItem_defineProperties(Constructor.prototype, protoProps); if (staticProps) popupInputItem_defineProperties(Constructor, staticProps); return Constructor; }
function popupInputItem_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PopupInputItem = /*#__PURE__*/function () {
  function PopupInputItem() {
    var _this = this;
    popupInputItem_classCallCheck(this, PopupInputItem);
    popupInputItem_defineProperty(this, "onRef", function (node) {
      _this.domNode = node;
      _this.props.domRef(node);
    });
  }
  popupInputItem_createClass(PopupInputItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        id = _this$props.id,
        type = _this$props.type,
        label = _this$props.label,
        value = _this$props.value,
        placeholder = _this$props.placeholder,
        autocapitalize = _this$props.autocapitalize,
        isError = _this$props.isError;
      var classPrefix = this.props.classPrefix;
      var attributes = {
        id: classPrefix + '-' + id,
        type: type,
        onKeydown: this.props.onKeydown,
        placeholder: placeholder,
        value: value,
        ref: this.onRef,
        onInput: this.props.onInput,
        className: isError ? 'error-field' : ''
      };
      if (autocapitalize) {
        attributes.autocapitalize = autocapitalize;
      }
      return (0,preact_module.h)("div", {
        className: classPrefix + '-item',
        key: id
      }, label ? (0,preact_module.h)("label", {
        for: classPrefix + '-' + id
      }, label) : null, this.props.type === 'textarea' ? (0,preact_module.h)("textarea", attributes, value) : (0,preact_module.h)("input", attributes));
    }
  }]);
  return PopupInputItem;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/bookmark/componentEdit.js
function componentEdit_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { componentEdit_typeof = function _typeof(obj) { return typeof obj; }; } else { componentEdit_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return componentEdit_typeof(obj); }
function componentEdit_extends() { componentEdit_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return componentEdit_extends.apply(this, arguments); }
function componentEdit_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function componentEdit_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { componentEdit_ownKeys(Object(source), true).forEach(function (key) { componentEdit_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { componentEdit_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



















function componentEdit_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function componentEdit_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function componentEdit_createClass(Constructor, protoProps, staticProps) { if (protoProps) componentEdit_defineProperties(Constructor.prototype, protoProps); if (staticProps) componentEdit_defineProperties(Constructor, staticProps); return Constructor; }
function componentEdit_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) componentEdit_setPrototypeOf(subClass, superClass); }
function componentEdit_setPrototypeOf(o, p) { componentEdit_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return componentEdit_setPrototypeOf(o, p); }
function componentEdit_createSuper(Derived) { var hasNativeReflectConstruct = componentEdit_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = componentEdit_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = componentEdit_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return componentEdit_possibleConstructorReturn(this, result); }; }
function componentEdit_possibleConstructorReturn(self, call) { if (call && (componentEdit_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return componentEdit_assertThisInitialized(self); }
function componentEdit_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function componentEdit_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function componentEdit_getPrototypeOf(o) { componentEdit_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return componentEdit_getPrototypeOf(o); }
function componentEdit_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var componentEdit_isEnterKey = (0,lib/* default */.ZP)('enter');
var ComponentEdit = /*#__PURE__*/function (_Component) {
  componentEdit_inherits(ComponentEdit, _Component);
  var _super = componentEdit_createSuper(ComponentEdit);
  function ComponentEdit(props) {
    var _this;
    componentEdit_classCallCheck(this, ComponentEdit);
    _this = _super.call(this, props);
    componentEdit_defineProperty(componentEdit_assertThisInitialized(_this), "t", function (key) {
      return _this.props.editor.plugins.i18n.get(key);
    });
    componentEdit_defineProperty(componentEdit_assertThisInitialized(_this), "onClick", function () {
      if (_this.verifyFields()) {
        var _this$props = _this.props,
          onAction = _this$props.onAction,
          wantsToClose = _this$props.wantsToClose;
        onAction && onAction(_this.state.fields);
        wantsToClose && wantsToClose();
      }
    });
    componentEdit_defineProperty(componentEdit_assertThisInitialized(_this), "getInputs", function () {
      var items = [{
        id: 'name',
        label: _this.t('bookmark.title')
      }, {
        id: 'src',
        label: _this.t('bookmark.address')
      }];
      if (_this.props.viewMode === 'card') {
        items.push({
          id: 'description',
          label: _this.t('bookmark.description'),
          type: 'textarea'
        });
      }
      return items;
    });
    componentEdit_defineProperty(componentEdit_assertThisInitialized(_this), "onInput", function (value, key) {
      _this.setState(function (prevState) {
        var errorFields,
          fields = Object.assign({}, prevState.fields);
        fields[key] = value;
        if (prevState.errorFields && prevState.errorFields.includes(key)) {
          errorFields = prevState.errorFields.filter(function (field) {
            return field !== key;
          });
        }
        return componentEdit_objectSpread({
          fields: fields
        }, errorFields ? {
          errorFields: errorFields
        } : {});
      });
    });
    componentEdit_defineProperty(componentEdit_assertThisInitialized(_this), "onBodyKeyDown", function (event) {
      if (componentEdit_isEnterKey(event)) {
        if (_this.verifyFields()) {
          var onAction = _this.props.onAction;
          onAction && onAction(_this.state.fields);
          _this.props.wantsToClose();
        }
      }
    });
    _this.state = {
      fields: {
        name: '',
        src: '',
        description: ''
      },
      errorFields: []
    };
    _this.nameRef = false;
    _this.srcRef = false;
    _this.descriptionRef = false;
    return _this;
  }
  componentEdit_createClass(ComponentEdit, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.setState(function () {
        return {
          fields: {
            name: _this2.props.name,
            src: _this2.props.src,
            description: _this2.props.description
          }
        };
      });
      this.dispatchEventTimeout = setTimeout(function () {
        // отлавливаем нажатие мыши на теле документа и просим родительский компонент закрыть меню если нужно
        document.body.addEventListener('keydown', _this2.onBodyKeyDown);
      }, 0);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.dispatchEventTimeout) {
        clearTimeout(this.dispatchEventTimeout);
      }
      document.body.removeEventListener('keydown', this.onBodyKeyDown);
    }
  }, {
    key: "verifyFields",
    value: function verifyFields() {
      if (this.props.validate) {
        var fields = Object.keys(this.state.fields);
        var errorFields = [];
        for (var key in this.props.validate) {
          if (fields.includes(key)) {
            var validateRes = this.props.validate[key](this.state.fields[key]);
            if (validateRes && validateRes.error) {
              errorFields.push(key);
            }
          }
        }
        if (errorFields.length) {
          this.setState(function () {
            return {
              errorFields: errorFields
            };
          });
          return false;
        }
      }
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        editor = _this$props2.editor,
        wantsToClose = _this$props2.wantsToClose;
      return (0,preact_module.h)(popupMenu/* default */.Z, {
        wantsToClose: wantsToClose,
        addClassName: "bookmark-edit link-edit no-scroll",
        closeOnEsc: true
      }, (0,preact_module.h)(popupDialog/* default */.Z, {
        wantsToClose: wantsToClose,
        addClassName: 'reduced-padding',
        noCloseButton: true
      }, (0,preact_module.h)(popupDialogTitle/* default */.Z, null, this.t('bookmark.edit')), (0,preact_module.h)(popupDialogBody/* default */.Z, null, this.getInputs().map(function (props) {
        return (0,preact_module.h)(PopupInputItem, componentEdit_extends({
          classPrefix: "link-form",
          type: "text",
          value: _this3.state.fields[props.id],
          placeholder: props.label,
          domRef: function domRef(ref) {
            return _this3[props.id + 'Ref'] = ref;
          },
          onInput: function onInput(e) {
            _this3.onInput(e.target.value, props.id);
          },
          isError: _this3.state.errorFields.includes(props.id)
        }, props));
      })), (0,preact_module.h)(popupDialogButtons/* default */.Z, {
        editor: editor,
        wantsToClose: wantsToClose,
        buttons: {
          cancel: {},
          accept: {
            text: this.t('done'),
            style: 'active',
            onClick: this.onClick
          }
        }
      })));
    }
  }]);
  return ComponentEdit;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/bookmark/componentGallery.js
function componentGallery_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { componentGallery_typeof = function _typeof(obj) { return typeof obj; }; } else { componentGallery_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return componentGallery_typeof(obj); }










function componentGallery_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function componentGallery_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function componentGallery_createClass(Constructor, protoProps, staticProps) { if (protoProps) componentGallery_defineProperties(Constructor.prototype, protoProps); if (staticProps) componentGallery_defineProperties(Constructor, staticProps); return Constructor; }
function componentGallery_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) componentGallery_setPrototypeOf(subClass, superClass); }
function componentGallery_setPrototypeOf(o, p) { componentGallery_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return componentGallery_setPrototypeOf(o, p); }
function componentGallery_createSuper(Derived) { var hasNativeReflectConstruct = componentGallery_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = componentGallery_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = componentGallery_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return componentGallery_possibleConstructorReturn(this, result); }; }
function componentGallery_possibleConstructorReturn(self, call) { if (call && (componentGallery_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return componentGallery_assertThisInitialized(self); }
function componentGallery_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function componentGallery_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function componentGallery_getPrototypeOf(o) { componentGallery_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return componentGallery_getPrototypeOf(o); }
function componentGallery_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var ComponentGallery = /*#__PURE__*/function (_Component) {
  componentGallery_inherits(ComponentGallery, _Component);
  var _super = componentGallery_createSuper(ComponentGallery);
  function ComponentGallery(props) {
    var _this;
    componentGallery_classCallCheck(this, ComponentGallery);
    _this = _super.call(this, props);
    componentGallery_defineProperty(componentGallery_assertThisInitialized(_this), "onClick", function (item) {
      _this.props.onChangePreview(item);
      _this.props.wantsToClose();
    });
    componentGallery_defineProperty(componentGallery_assertThisInitialized(_this), "onUploadClick", function () {
      _this.props.onUploadPreviewClick(_this.onUploadingSuccess, _this.onUploadingProgress, _this.onUploadingError);
    });
    componentGallery_defineProperty(componentGallery_assertThisInitialized(_this), "onUploadingProgress", function (progress) {
      _this.setState(function () {
        return {
          uploadFileProgress: Math.min(Math.round(progress.loaded / progress.total * 100), 100)
        };
      });
    });
    componentGallery_defineProperty(componentGallery_assertThisInitialized(_this), "onUploadingError", function (error) {
      if (error instanceof QuotaError) {
        _this.props.notificationManager.error(_this.props.i18n.get('bookmark.upload.quota_error'));
      } else {
        _this.props.notificationManager.error(_this.props.i18n.get('bookmark.upload.unknown_error'));
      }
    });
    componentGallery_defineProperty(componentGallery_assertThisInitialized(_this), "onUploadingSuccess", function () {
      _this.setState(function () {
        return {
          uploadFileProgress: false
        };
      }, function () {
        _this.props.wantsToClose();
      });
    });
    componentGallery_defineProperty(componentGallery_assertThisInitialized(_this), "isActive", function (item) {
      return item.id === _this.props.currentPreviewId;
    });
    _this.state = {
      previews: []
    };
    return _this;
  }
  componentGallery_createClass(ComponentGallery, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.props.getPreviews().then(function (_ref) {
        var previews = _ref.previews;
        if (previews.length > 0) {
          _this2.setState(function () {
            return {
              previews: previews
            };
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var UploadButton = function UploadButton() {
        var uploadFileProgress = _this3.state.uploadFileProgress;
        return (0,preact_module.h)("div", {
          className: "bookmark-gallery-upload",
          onClick: _this3.onUploadClick
        }, (0,preact_module.h)(icons/* IconUpload */.bCE, null), uploadFileProgress ? (0,preact_module.h)("div", {
          className: "bookmark-gallery-upload-progress"
        }, (0,preact_module.h)("span", {
          style: {
            width: uploadFileProgress + '%'
          }
        })) : (0,preact_module.h)("span", null, _this3.props.i18n.get('bookmark.upload.new_preview')));
      };
      return (0,preact_module.h)(popupMenu/* default */.Z, {
        wantsToClose: this.props.wantsToClose,
        addClassName: 'bookmark-gallery' + (this.state.previews.length > 8 ? ' has-scroll' : ''),
        closeOnEsc: true,
        anchorNode: this.props.blot.domNode,
        anchorOptions: {
          offset: '0, -100%p',
          placement: 'left-start',
          behavior: ['bottom', 'top', 'right-start'],
          priority: ['left', 'right', 'bottom', 'top'],
          boundariesElement: this.props.blot.editor.getScrollingContainer(),
          overflowBoundariesElement: this.props.blot.editor.getScrollingContainer()
        }
      }, (0,preact_module.h)("div", {
        className: "bookmark-gallery__list"
      }, (0,preact_module.h)(UploadButton, null), this.state.previews.map(function (item, key) {
        return (0,preact_module.h)("div", {
          key: key,
          className: "bookmark-gallery__list__item ".concat(_this3.isActive(item) ? 'active' : ''),
          onClick: function onClick() {
            _this3.onClick(item);
          }
        }, (0,preact_module.h)("img", {
          src: item.url
        }));
      })));
    }
  }]);
  return ComponentGallery;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/he/he.js
var he = __webpack_require__(25746);
var he_default = /*#__PURE__*/__webpack_require__.n(he);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/bookmark/bookmark.js
function bookmark_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { bookmark_typeof = function _typeof(obj) { return typeof obj; }; } else { bookmark_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return bookmark_typeof(obj); }

function bookmark_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function bookmark_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { bookmark_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { bookmark_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




















function bookmark_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function bookmark_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function bookmark_createClass(Constructor, protoProps, staticProps) { if (protoProps) bookmark_defineProperties(Constructor.prototype, protoProps); if (staticProps) bookmark_defineProperties(Constructor, staticProps); return Constructor; }
function bookmark_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { bookmark_get = Reflect.get; } else { bookmark_get = function _get(target, property, receiver) { var base = bookmark_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return bookmark_get(target, property, receiver || target); }
function bookmark_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = bookmark_getPrototypeOf(object); if (object === null) break; } return object; }
function bookmark_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) bookmark_setPrototypeOf(subClass, superClass); }
function bookmark_setPrototypeOf(o, p) { bookmark_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return bookmark_setPrototypeOf(o, p); }
function bookmark_createSuper(Derived) { var hasNativeReflectConstruct = bookmark_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = bookmark_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = bookmark_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return bookmark_possibleConstructorReturn(this, result); }; }
function bookmark_possibleConstructorReturn(self, call) { if (call && (bookmark_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return bookmark_assertThisInitialized(self); }
function bookmark_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function bookmark_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function bookmark_getPrototypeOf(o) { bookmark_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return bookmark_getPrototypeOf(o); }
function bookmark_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
























var bookmark_mixin = mix([commentable, blotLock, embeddable, draggable, dropAcceptor, selectable, focusable, executable, basic]);
var bookmark_HTML_CLASS = 'nimbus-bookmark';
var bookmark_HTML_CONTAINER_CLASS = 'nimbus-bookmark-container';
var DEFAULT_BOOKMARK_MAX_WIDTH = 650;
var MIN_WIDTH_FOR_SHOW_PREVIEW = 320;
var COVER_MODE_BOOKMARK_MAX_WIDTH = 320;
var ALLOWED_VIEW_MODES = ['card', 'tile', 'cover'];
var Bookmark = /*#__PURE__*/function (_mixin) {
  bookmark_inherits(Bookmark, _mixin);
  var _super = bookmark_createSuper(Bookmark);
  function Bookmark(domNode) {
    var _this;
    bookmark_classCallCheck(this, Bookmark);
    _this = _super.call(this, domNode);
    bookmark_defineProperty(bookmark_assertThisInitialized(_this), "mapObserver", function () {
      _this.render();
    });
    bookmark_defineProperty(bookmark_assertThisInitialized(_this), "isPreviewNotAvailable", function () {
      var previewId = _this.map.get('previewId');
      return previewId === 'no-preview' || previewId && !_this.hasAttachment() && !_this._resolveInProgress && !_this._uploadingInProgress;
    });
    bookmark_defineProperty(bookmark_assertThisInitialized(_this), "onDomResize", function () {
      if (!_this.map.get('src')) return;
      var _this$domNode$getBoun = _this.domNode.getBoundingClientRect(),
        width = _this$domNode$getBoun.width;
      if (_this.map.get('viewMode') === 'card' && width < MIN_WIDTH_FOR_SHOW_PREVIEW) {
        if (!_this.domNode.classList.contains('hidden-preview')) {
          _this.domNode.classList.add('hidden-preview');
        }
      } else {
        if (_this.domNode.classList.contains('hidden-preview')) {
          _this.domNode.classList.remove('hidden-preview');
        }
      }
    });
    bookmark_defineProperty(bookmark_assertThisInitialized(_this), "observeStartDragging", function (fn) {
      if (fn) {
        _this.editor.emitter.on('start-dragging', fn);
      }
    });
    bookmark_defineProperty(bookmark_assertThisInitialized(_this), "unobserveStartDragging", function (fn) {
      if (fn) {
        _this.editor.emitter.off('start-dragging', fn);
      }
    });
    bookmark_defineProperty(bookmark_assertThisInitialized(_this), "tryGetMeta", /*#__PURE__*/function () {
      var _ref = bookmark_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(src) {
        var hasProptocol, isAppMeta, meta, isPreviewUploadedFromGallery, preview, mainPageMeta;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                hasProptocol = false;
                if (src.match(/(?:(?:[a-z][a-z0-9+.-]*:)(?:.*))/g)) {
                  hasProptocol = true;
                }
                _context.prev = 2;
                isAppMeta = true;
                _context.next = 6;
                return _this.editor.plugins.bookmarkManager.getUrlInfo(src);
              case 6:
                meta = _context.sent;
                if (meta) {
                  _context.next = 14;
                  break;
                }
                isAppMeta = false;
                _context.next = 11;
                return _this.editor.plugins.bookmarkManager.getBookmarkMeta(src);
              case 11:
                meta = _context.sent;
                _context.next = 15;
                break;
              case 14:
                if (_this.map.get('openInSameTab')) {
                  _this.map.set('openInSameTab', true);
                }
              case 15:
                if (!hasProptocol && meta.protocol) {
                  if (_this.map.get('src') !== meta.protocol + src) {
                    _this.map.set('src', meta.protocol + src);
                  }
                }
                if (meta.name !== _this.map.get('name')) {
                  _this.map.set('name', meta.name);
                }
                if (meta.description !== _this.map.get('description')) {
                  _this.map.set('description', meta.description);
                }
                if (meta.favicon !== _this.map.get('icon')) {
                  _this.map.set('icon', meta.favicon);
                }
                if (_this.hasAttachment()) {
                  _context.next = 31;
                  break;
                }
                _context.next = 22;
                return _this.tryGetPreview();
              case 22:
                isPreviewUploadedFromGallery = _context.sent;
                if (isPreviewUploadedFromGallery) {
                  _context.next = 31;
                  break;
                }
                preview = meta.preview && meta.preview.startsWith('http') ? meta.preview : false;
                if (!(!preview && !isAppMeta)) {
                  _context.next = 30;
                  break;
                }
                _context.next = 28;
                return _this.editor.plugins.bookmarkManager.getBookmarkMeta(getHostFromUrl(src));
              case 28:
                mainPageMeta = _context.sent;
                preview = mainPageMeta.preview && mainPageMeta.preview.startsWith('http') ? mainPageMeta.preview : false;
              case 30:
                if (preview) {
                  _this.map.set('previewId', 'origin');
                  _this.map.set('originPreviewUrl', preview);
                  _this.uploadAttachment(preview);
                } else {
                  if (_this.map.get('previewId') !== 'no-preview') {
                    _this.map.set('previewId', 'no-preview');
                  }
                }
              case 31:
                _context.next = 36;
                break;
              case 33:
                _context.prev = 33;
                _context.t0 = _context["catch"](2);
                console.error('Bookmark info error', _context.t0);
              case 36:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 33]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    bookmark_defineProperty(bookmark_assertThisInitialized(_this), "onPlaceholderEmptyValueBackspace", function () {
      if (_this.container.children.head === bookmark_assertThisInitialized(_this)) return;
      _this.selection.setRange({
        index: _this.offset(_this.scroll) - 1,
        length: 0
      });
      _this.getWrapper().parent.removeChildById(_this.id);
    });
    bookmark_defineProperty(bookmark_assertThisInitialized(_this), "onValidateSrc", function (value) {
      var regex = /^(https?:\/\/)?(www\.)?(\S*)\.(\S*)$/g;
      if (Boolean(value)) {
        if (!regex.test(value)) {
          return {
            error: _this.editor.plugins.i18n.get('bookmark.error.unknown_error')
          };
        } else {
          return {
            source: value
          };
        }
      }
      return {
        error: _this.editor.plugins.i18n.get('bookmark.error.unknown_error')
      };
    });
    bookmark_defineProperty(bookmark_assertThisInitialized(_this), "onApplySrc", function (src) {
      var oldSrc = _this.map.get('src');
      if (oldSrc !== src) {
        if (_this.map.has('countGetAttemptsData')) {
          _this.map.delete('countGetAttemptsData');
        }
        _this.map.set('src', src);
        _this.tryGetMeta(src);
      }
      if (_this.container.children.tail === bookmark_assertThisInitialized(_this)) {
        _this.container.addBlot('paragraph', {
          after: _this.id,
          focus: {
            index: 0
          }
        });
      }
    });
    bookmark_defineProperty(bookmark_assertThisInitialized(_this), "onSrcInputCancel", function () {
      _this.putCaretInEmptyParagraphAfterBlot();
      _this.remove();
    });
    bookmark_defineProperty(bookmark_assertThisInitialized(_this), "onSrcInputRemove", function () {
      _this.remove();
    });
    bookmark_defineProperty(bookmark_assertThisInitialized(_this), "uploadAttachment", function (url) {
      if (_this._uploadingInProgress) {
        return;
      }
      _this._uploadingInProgress = true;
      _this.editor.plugins.attachmentManager.chooseFileFromUrl(url).then(function (file) {
        file = _this.editor.plugins.attachmentManager.beforeSaveFile(file);
        _this.editor.plugins.attachmentManager.saveFile(file, {
          blotName: _this.constructor.blotName,
          blotId: _this.id
        }).run().then(function (_ref2) {
          var globalId = _ref2.globalId;
          _this._uploadingInProgress = false;
          _this.map.set('attachmentGlobalId', globalId);
        }).catch(function (err) {
          _this._uploadingInProgress = false;
          _this.onAttachmentError(err);
        });
      }).catch(function (err) {
        _this._uploadingInProgress = false;
        _this.onAttachmentError(err);
      });
    });
    bookmark_defineProperty(bookmark_assertThisInitialized(_this), "resolveAttachment", function () {
      if (_this._resolveInProgress) {
        return;
      }
      _this._resolveInProgress = true;
      _this.editor.plugins.attachmentManager.resolve(_this.map.get('attachmentGlobalId'), {
        blotName: _this.constructor.blotName
      }).then(function (attachment) {
        var attachmentGlobalId = _this.map.get('attachmentGlobalId');
        if (isNaN(attachment.size) && !_this.editor.plugins.attachmentManager.isPseudoAttachment(attachmentGlobalId)) {
          console.warn('attachment', attachmentGlobalId, 'resolved with incorrect size, attachment:', attachment);
        }
        _this.setProps({
          attachment: attachment
        });
        _this._resolveInProgress = false;
      }).catch(function (err) {
        _this.onAttachmentError(err);
        _this._resolveInProgress = false;
      });
    });
    bookmark_defineProperty(bookmark_assertThisInitialized(_this), "changeMode", function (mode) {
      _this.map.set('viewMode', mode);
    });
    bookmark_defineProperty(bookmark_assertThisInitialized(_this), "getPreviews", function () {
      return _this.editor.plugins.bookmarkManager.getPreviews(_this.map.get('src'));
    });
    bookmark_defineProperty(bookmark_assertThisInitialized(_this), "onChangePreview", function (preview) {
      if (preview.id === _this.map.get('previewId')) return;
      _this.clearAttachment();
      _this.map.set('previewId', preview.id);
      _this.uploadAttachment(preview.url);
    });
    bookmark_defineProperty(bookmark_assertThisInitialized(_this), "changePreview", function () {
      // При смене превью закладки если offline показываем сообщение об ошибке
      if (window.navigator && !window.navigator.onLine) {
        return _this.editor.plugins.notificationManager.showError({
          message: 'bookmarkOfflinePreview'
        });
      }
      _this.editor.plugins.popupManager.dialog((0,preact_module.h)(ComponentGallery, {
        notificationManager: _this.editor.plugins.notificationManager,
        getPreviews: _this.getPreviews,
        onChangePreview: _this.onChangePreview,
        currentPreviewId: _this.map.get('previewId'),
        i18n: _this.editor.plugins.i18n,
        blot: bookmark_assertThisInitialized(_this),
        onUploadPreviewClick: _this.onUploadPreviewClick
      }));
    });
    bookmark_defineProperty(bookmark_assertThisInitialized(_this), "resetPreview", function () {
      var originUrl = _this.map.get('originPreviewUrl');
      if (Boolean(originUrl)) {
        _this.onChangePreview({
          id: 'origin',
          url: originUrl
        });
      }
    });
    bookmark_defineProperty(bookmark_assertThisInitialized(_this), "deletePreview", function () {
      _this.map.set('previewId', 'no-preview');
      _this.map.set('attachmentGlobalId', null);
      _this.setProps({
        attachment: null
      });
    });
    bookmark_defineProperty(bookmark_assertThisInitialized(_this), "onApplyEdit", function (fields) {
      var isSrcChanged = fields.src && fields.src !== _this.map.get('src');
      if (isSrcChanged) {
        _this.clearAttachment();
        _this.setProps({
          attachment: null
        });
        _this.onApplySrc(fields.src);
      }
      Object.keys(fields).forEach(function (key) {
        if (key !== 'src') {
          if (_this.map.get(key) !== fields[key]) {
            // не перезаписываем не измененные поля
            _this.map.set(key, fields[key]);
          }
        }
      });
    });
    bookmark_defineProperty(bookmark_assertThisInitialized(_this), "edit", function () {
      _this.editor.plugins.popupManager.dialog((0,preact_module.h)(ComponentEdit, {
        editor: _this.editor,
        onAction: _this.onApplyEdit,
        name: _this.map.get('name'),
        viewMode: _this.map.get('viewMode'),
        description: _this.map.get('description'),
        src: _this.map.get('src'),
        validate: {
          src: _this.onValidateSrc
        }
      }));
    });
    bookmark_defineProperty(bookmark_assertThisInitialized(_this), "onUploadPreviewClick", /*#__PURE__*/function () {
      var _ref3 = bookmark_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(onSuccess, onProgress, onError) {
        var files, file, task;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this._uploadingInProgress) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return");
              case 2:
                _context2.prev = 2;
                _this._uploadingInProgress = true;
                _context2.next = 6;
                return _this.editor.plugins.attachmentManager.chooseFile({
                  accept: 'image/*',
                  multiple: false,
                  blotName: _this.constructor.blotName
                });
              case 6:
                files = _context2.sent;
                if (!files) {
                  _context2.next = 17;
                  break;
                }
                file = files[0];
                if (_this.editor.plugins.attachmentManager.checkFileSize(file.size, {
                  maxFileSize: _this.blotConfig.maxFileSize
                })) {
                  _context2.next = 11;
                  break;
                }
                throw new QuotaError('file is too big', file);
              case 11:
                file = _this.editor.plugins.attachmentManager.beforeSaveFile(file);
                task = _this.editor.plugins.attachmentManager.saveFile(file, {
                  blotName: _this.constructor.blotName,
                  blotId: _this.id
                });
                if (onProgress) {
                  task.onProgress = onProgress;
                }
                task.run().then(function (_ref4) {
                  var globalId = _ref4.globalId;
                  _this.clearAttachment();
                  _this.map.set('previewId', 'custom');
                  _this.map.set('attachmentGlobalId', globalId);
                  if (onSuccess) {
                    onSuccess();
                  }
                  _this._uploadingInProgress = false;
                }).catch(function (err) {
                  throw err;
                });
                _context2.next = 18;
                break;
              case 17:
                _this._uploadingInProgress = false;
              case 18:
                _context2.next = 24;
                break;
              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2["catch"](2);
                if (onError) {
                  onError(_context2.t0);
                } else {
                  _this.onAttachmentError(err);
                }
                _this._uploadingInProgress = false;
              case 24:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 20]]);
      }));
      return function (_x2, _x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }());
    bookmark_defineProperty(bookmark_assertThisInitialized(_this), "changeOpenLinkParams", function () {
      var current = Boolean(_this.map.get('openInSameTab'));
      _this.map.set('openInSameTab', !current);
    });
    _this.isSeparableByClickApplicable = true;
    _this.addCanExecActions(['set-align', 'delete', 'backspace', 'set-background']);
    _this.disallowReplace = true;
    return _this;
  }
  bookmark_createClass(Bookmark, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = bookmark_get(bookmark_getPrototypeOf(Bookmark.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      this.normalizeStoreParamsIfNeed();
      this.editor.store.observe(this.map, this.mapObserver);
      this.observeResize();
      var src = this.map.get('src');
      var countGetAttemptsData = this.map.has('countGetAttemptsData') ? this.map.get('countGetAttemptsData') : 0;
      if (src && countGetAttemptsData < 3) {
        var processGetData = false;
        if (!this.map.get('name') || !this.map.get('description')) {
          this.tryGetMeta(src);
          processGetData = true;
        } else if (!this.map.get('attachmentGlobalId') && !this.map.get('previewId')) {
          // Для мобильных клиентов, они не всегда успевают загрузить превью и букмарк зависает
          this.tryGetPreview();
          processGetData = true;
        }
        if (processGetData) {
          this.map.set('countGetAttemptsData', countGetAttemptsData + 1);
        }
      }
      this.render();
      this.onAttachUploadResoursesIfNeed();
    }
  }, {
    key: "onAttachUploadResoursesIfNeed",
    value: function onAttachUploadResoursesIfNeed() {
      if (this.map.get('originalRoomId')) {
        if (this.editor.room !== this.map.get('originalRoomId')) {
          var previewId = this.map.get('previewId');
          if (previewId) {
            this.setPreviewById(previewId);
          }
        }
        this.map.delete('originalRoomId');
      }
    }

    // нужно для того чтобы не сломались букмарки в старых заметках
  }, {
    key: "normalizeStoreParamsIfNeed",
    value: function normalizeStoreParamsIfNeed() {
      var hasIsCardParam = this.map.has('isCard');
      if (hasIsCardParam) {
        var viewMode = this.map.get('isCard') ? 'card' : 'tile';
        this.map.set('viewMode', viewMode);
        this.map.delete('isCard');
      }
      // фикс для name, иногда в meta.name возвращается массив,
      // фикс сделан на уровне получения данных для букмарка, тут же он нужен для того, чтобы старые сломанные таким поведением заметки, вновь заработали
      // (пока известен только один случай, но мало ли)
      var name = this.map.get('name');
      if (Array.isArray(name)) {
        this.map.set('name', name[0]);
      }
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = bookmark_get(bookmark_getPrototypeOf(Bookmark.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      this.editor.store.unobserve(this.map, this.mapObserver);
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }
  }, {
    key: "observeResize",
    value: function observeResize() {
      if (typeof ResizeObserver === 'function') {
        this.resizeObserver = new ResizeObserver(this.onDomResize);
        this.resizeObserver.observe(this.domNode);
      }
    }
  }, {
    key: "hasAttachment",
    value: function hasAttachment() {
      return Boolean(this.map.get('attachmentGlobalId'));
    }
  }, {
    key: "hasOriginPreviewUrl",
    value: function hasOriginPreviewUrl() {
      return Boolean(this.map.get('originPreviewUrl'));
    }
  }, {
    key: "onAttachmentError",
    value: function onAttachmentError(err) {
      console.error(err); // пока оставлю для дебага
      if (this.map.get('previewId') !== 'no-preview') {
        this.map.set('previewId', 'no-preview');
      }
      this.setProps({
        setAttachmentError: err
      });
    }
  }, {
    key: "clearAttachment",
    value: function clearAttachment() {
      this.map.set('attachmentGlobalId', null);
      this.map.set('previewId', null);
      this.setProps({
        setAttachmentError: null
      });
    }
  }, {
    key: "onBlotMenuUpdatePosition",
    value: function onBlotMenuUpdatePosition(_ref5) {
      var left = _ref5.left,
        top = _ref5.top;
      // не через ref, потому что часто приходит null. Как бороться с этим, способа не придумал
      var bookmarkNode = this.domNode.querySelector('.nimbus-bookmark-content');
      if (bookmarkNode) {
        var x = bookmarkNode.getBoundingClientRect().x;
        left += x - this.domNode.getBoundingClientRect().x;
      }
      return {
        left: left,
        top: top
      };
    }
  }, {
    key: "onGetCommentPosition",
    value: function onGetCommentPosition(_ref6) {
      var left = _ref6.left,
        top = _ref6.top;
      var bookmarkNode = this.domNode.querySelector('.nimbus-bookmark-content');
      if (bookmarkNode) {
        var _getRelRect = (0,dom/* getRelRect */.vk)(bookmarkNode, this.editor.editorBody),
          iLeft = _getRelRect.left,
          width = _getRelRect.width;
        left -= left - (iLeft + width);
      }
      return {
        left: left,
        top: top
      };
    }
  }, {
    key: "canDragWith",
    value: function canDragWith(node) {
      if (this.isBlotLocked) {
        return false;
      } else {
        return this.domNode.contains(node);
      }
    }
  }, {
    key: "render",
    value: function render() {
      bookmark_get(bookmark_getPrototypeOf(Bookmark.prototype), "render", this).call(this);
      var src = this.map.get('src');
      var hasSrc = Boolean(src);
      if (!hasSrc && this.editor.mode !== this.editor.constructor.MODE_EDIT) return;
      if (this.hasAttachment() && !this.props.setAttachmentError && (!this.props.attachment || this.props.attachment.global_id !== this.map.get('attachmentGlobalId'))) {
        this.resolveAttachment();
      }
      var isAttachmentChangedAndLoading = Boolean(this.props.attachment && (!this.hasAttachment() || this.props.attachment.global_id !== this.map.get('attachmentGlobalId')));
      var htmlContainer = this.domNode.querySelector('.' + bookmark_HTML_CONTAINER_CLASS);
      var align = this.map.get('align');
      var contentAlign = null;
      if (align && hasSrc) {
        if (align === 'center') {
          contentAlign = align;
        } else if (align === 'right') {
          contentAlign = 'flex-end';
        }
      }
      htmlContainer.style.justifyContent = contentAlign;
      var maxWidth = this.blotConfig.maxWidth;
      if (!maxWidth) {
        maxWidth = DEFAULT_BOOKMARK_MAX_WIDTH;
      }
      if (this.map.get('viewMode') === 'cover') {
        maxWidth = COVER_MODE_BOOKMARK_MAX_WIDTH;
      }
      (0,preact_module/* render */.sY)((0,preact_module.h)(BookmarkComponent, {
        name: he_default().decode(this.map.get('name') ? String(this.map.get('name')) : ''),
        viewMode: this.map.get('viewMode'),
        icon: this.map.get('icon'),
        description: he_default().decode(this.map.get('description') ? String(this.map.get('description')) : ''),
        src: src,
        classPrefix: bookmark_HTML_CLASS,
        editor: this.editor,
        i18n: this.editor.plugins.i18n,
        attachment: this.props.attachment,
        isAttachmentChangedAndLoading: isAttachmentChangedAndLoading,
        setAttachmentError: this.props.setAttachmentError,
        onApplySrc: this.onApplySrc,
        onPlaceholderEmptyValueBackspace: this.onPlaceholderEmptyValueBackspace,
        onValidateSource: this.onValidateSrc,
        onSourceInputCancel: this.onSrcInputCancel,
        onSourceInputRemove: this.onSrcInputRemove,
        isPreviewNotAvailable: this.isPreviewNotAvailable(),
        maxWidth: maxWidth,
        previewBackgroundColor: this.map.get('color'),
        observeStartDragging: this.observeStartDragging,
        unobserveStartDragging: this.unobserveStartDragging,
        openInSameTab: this.map.get('openInSameTab')
      }), htmlContainer);
    }
  }, {
    key: "tryGetPreview",
    value: function tryGetPreview() {
      var _this2 = this;
      return new Promise(function (resolve) {
        _this2.getPreviews().then(function (_ref7) {
          var previews = _ref7.previews;
          if (previews && previews.length > 0 && previews[0].url) {
            // previewId сохраняем для того, чтобы при действии смены превью мы знали какое превью текущее и могли его выделить
            _this2.uploadAttachment(previews[0].url);
            _this2.map.set('previewId', previews[0].id);
            resolve(true);
          } else {
            resolve(false);
          }
        }).catch(function (err) {
          console.error(err);
          resolve(false);
        });
      });
    }
  }, {
    key: "setPreviewById",
    value: function setPreviewById(id) {
      var _this3 = this;
      this.clearAttachment();
      if (id === 'origin') {
        var originUrl = this.map.get('originPreviewUrl');
        if (Boolean(originUrl)) {
          this.uploadAttachment(originUrl);
          this.map.set('previewId', id);
        } else {
          this.map.set('previewId', 'no-preview');
        }
      } else {
        this.getPreviews().then(function (_ref8) {
          var previews = _ref8.previews;
          var inCollectionPreview = previews.length && previews.find(function (item) {
            return item.id === id;
          });
          if (inCollectionPreview) {
            _this3.uploadAttachment(inCollectionPreview.url);
            _this3.map.set('previewId', id);
          } else {
            _this3.map.set('previewId', 'no-preview');
          }
        }).catch(function (err) {
          return console.error(err);
        });
      }
    }
  }, {
    key: "getTextDelta",
    value: function getTextDelta() {
      var src = this.map.get('src');
      return {
        ops: [{
          insert: src,
          attributes: {
            link: src
          }
        }]
      };
    }
  }, {
    key: "cloneSelf",
    value: function cloneSelf() {
      var map = this.store.createMap();
      parchment_default().query(this.map.get('type')).initMap(map, this.store, {
        viewMode: this.map.get('viewMode'),
        name: this.map.get('name'),
        attachmentGlobalId: this.map.get('attachmentGlobalId'),
        icon: this.map.get('icon'),
        description: this.map.get('description'),
        preview: this.map.get('preview'),
        src: this.map.get('src'),
        previewId: this.map.get('previewId'),
        openInSameTab: this.map.get('openInSameTab')
      });
      return map.get('id');
    }
  }, {
    key: "exec",
    value: function exec(action) {
      var processed = bookmark_get(bookmark_getPrototypeOf(Bookmark.prototype), "exec", this).call(this, action);
      var params = action.params;
      if (action.type === 'backspace') {
        action.dontRestoreSelection();
        processed = true;
      } else if (action.type === 'set-align') {
        if (params === 'center' || params === 'right') {
          this.map.set('align', params);
        } else {
          this.map.set('align', null);
        }
        processed = true;
      } else if (action.type === 'set-background') {
        this.map.set('color', params);
        processed = true;
      }
      return processed;
    }
  }, {
    key: "putCaretInEmptyParagraphAfterBlot",
    value: function putCaretInEmptyParagraphAfterBlot() {
      var next = this.getWrapper().next;
      if (next && next instanceof paragraphAbstract && next.isEmpty()) {
        this.scroll.selection.setRange({
          index: next.offset(this.scroll),
          length: 0
        });
        this.editor.plugins.selectionScroller.ensureSelectionVisible();
        return;
      }
      this.container.addBlot('paragraph', {
        after: this.id,
        focus: {
          index: 0
        }
      });
    }
  }, {
    key: "getColor",
    value: function getColor() {
      return this.map.get('color');
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      var node;
      if (this.props.attachment) {
        context.addAttachment(this.props.attachment);
        node = this.domNode.cloneNode(true);
        var imgPath = context.getAttachmentPath(this.props.attachment);
        var oldImg = node.querySelector('.nimbus-bookmark__preview img');
        if (oldImg) {
          if (context.options.toEmail) {
            oldImg.style.height = '120px';
          }
          var img = oldImg.cloneNode();
          img.setAttribute('src', imgPath);
          oldImg.parentNode.replaceChild(img, oldImg);
        }
        if (context.options.pdf) {
          node.style = "page-break-inside: avoid;";
        }
      } else {
        node = this.domNode;
      }
      if (context.options.toEmail) {
        var content = node.querySelector('.nimbus-bookmark-content');
        content.style.height = "145px";
        content.style.padding = "12px";
        content.style.display = "flex";
        content.style.border = "1px solid #c8c8c8";
        content.style.borderRadius = "4px";
        content.style.boxSizing = "border-box";
        var info = node.querySelector('.nimbus-bookmark__info');
        info.style.minWidth = '50px';
        info.style.flexBasis = '360px';
        var desc = node.querySelector('.nimbus-bookmark__info__desc');
        desc.style.fontSize = '12px';
        var icon0 = node.querySelector('.nimbus-bookmark__icon');
        icon0.style.display = 'inline-block';
        var text = node.querySelector('.nimbus-bookmark__info__src-text');
        text.style.display = 'inline-block';
        var icon = node.querySelector('.nimbus-bookmark__icon img');
        icon.style.width = '16px';
        icon.style.height = '16px';
        var name = node.querySelector('.nimbus-bookmark__info__name');
        name.style.width = '360px';
        name.style.height = '20px';
        name.style.overflow = 'hidden';
      }
      return node.outerHTML;
    }
  }, {
    key: "contextMenu",
    get: function get() {
      var _this4 = this;
      var i18n = this.editor.plugins.i18n;
      var menu = bookmark_get(bookmark_getPrototypeOf(Bookmark.prototype), "contextMenu", this);
      if (this.map.get('src')) {
        menu['turn-into'] = {
          label: i18n.get('block_menu.convert_to.name'),
          index: -11,
          group: 0,
          action: false,
          submenu: {
            turnToLink: {
              label: i18n.get('block_menu.convert_to.link'),
              index: 0,
              group: 0,
              action: 'convert-blot',
              actionParams: {
                type: 'paragraph'
              },
              actionExec: true,
              stackable: false,
              icon: icons/* IconLink */.JHz
            },
            turnToRemoteFrame: {
              label: i18n.get('block_menu.convert_to.remote_frame'),
              index: 1,
              group: 0,
              action: 'convert-blot',
              actionParams: {
                type: 'remote-frame',
                src: this.map.get('src')
              },
              actionExec: true,
              stackable: false,
              icon: icons/* IconEmbed */.g9E
            },
            turnToButton: {
              label: i18n.get('floating_toolbar.button'),
              index: 1,
              group: 0,
              action: 'convert-blot',
              actionParams: {
                type: 'button-single',
                title: this.map.get('name'),
                url: this.map.get('src')
              },
              actionExec: true,
              stackable: false,
              icon: icons/* IconButton */.hU
            }
          }
        };
        var changeModeSubmenu = ALLOWED_VIEW_MODES.map(function (mode, index) {
          return {
            label: i18n.get('bookmark.block_menu.change_mode.mode_' + mode),
            index: index,
            group: 0,
            action: 'changeMode',
            actionParams: mode,
            actionExec: false,
            stackable: false,
            icon: _this4.map.get('viewMode') === mode ? icons/* IconDone */.EZi : false
          };
        }).reduce(function (obj, item, index) {
          obj[ALLOWED_VIEW_MODES[index]] = item;
          return obj;
        }, {});
        menu['change_mode'] = {
          label: i18n.get('bookmark.block_menu.change_mode.menu_name'),
          index: -10,
          group: 0,
          action: false,
          stackable: false,
          submenu: changeModeSubmenu
        };
        if (this.map.get('viewMode') === 'card' || this.map.get('viewMode') === 'cover') {
          menu['change_preview'] = {
            label: i18n.get('bookmark.block_menu.change_preview'),
            index: -9,
            group: 0,
            action: 'changePreview',
            stackable: false
          };
        }

        // Показываем пункт Параметры в зависимости от настроек
        var _this$blotConfig$show = this.blotConfig.showMenuItemParameters,
          showMenuItemParameters = _this$blotConfig$show === void 0 ? true : _this$blotConfig$show;
        if (showMenuItemParameters) {
          menu['options'] = {
            label: i18n.get('bookmark.block_menu.options.menu_name'),
            index: -8,
            group: 0,
            action: false,
            stackable: false,
            submenu: {
              openInSameTab: {
                label: i18n.get('bookmark.block_menu.options.open_in_same_tab'),
                index: 0,
                group: 0,
                action: 'changeOpenLinkParams',
                actionExec: false,
                stackable: false,
                icon: this.map.get('openInSameTab') ? icons/* IconDone */.EZi : false
              }
            }
          };
        }
        if (this.hasAttachment()) {
          menu['delete-preview'] = {
            label: i18n.get('bookmark.block_menu.delete_preview'),
            index: -7,
            group: 0,
            action: 'deletePreview',
            stackable: false
          };
        }
        if (this.map.get('previewId') !== 'origin' && this.hasOriginPreviewUrl()) {
          menu['reset-preview'] = {
            label: i18n.get('bookmark.block_menu.reset_preview'),
            index: -6,
            group: 0,
            action: 'resetPreview',
            stackable: false
          };
        }
        if (this.map.get('viewMode') === 'cover' && this.isPreviewNotAvailable()) {
          menu['change-preview-background'] = {
            label: i18n.get('bookmark.block_menu.change_preview_background'),
            index: -5,
            group: 0,
            action: 'change-color',
            stackable: false,
            submenu: 'ColorPicker'
          };
        }
        menu['edit'] = {
          label: i18n.get('block_menu.edit'),
          index: -4,
          group: 0,
          action: 'edit',
          stackable: false
        };
        menu['align'] = ['left', 'center', 'right'];
      }
      return menu;
    }
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      var params = bookmark_get(bookmark_getPrototypeOf(Bookmark.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
      return (0,util/* mergeDeep */.Ee)(params, {
        initParams: {
          viewMode: this.map.get('viewMode'),
          name: this.map.get('name'),
          attachmentGlobalId: this.map.get('attachmentGlobalId'),
          icon: this.map.get('icon'),
          description: this.map.get('description'),
          preview: this.map.get('preview'),
          src: this.map.get('src'),
          previewId: this.map.get('previewId'),
          openInSameTab: this.map.get('openInSameTab'),
          originPreviewUrl: this.map.get('originPreviewUrl'),
          room: this.editor.options.serverRoom
        }
      });
    }
  }], [{
    key: "createBlot",
    value: function createBlot(editor) {
      var blot = parchment_default().create('bookmark');
      this.addCaretTrap(editor, blot.domNode);
      return blot;
    }
  }, {
    key: "create",
    value: function create() {
      var node = bookmark_get(bookmark_getPrototypeOf(Bookmark), "create", this).call(this);
      node.classList.add(bookmark_HTML_CLASS);
      var htmlContainer = document.createElement('div');
      htmlContainer.setAttribute('contenteditable', false);
      htmlContainer.classList.add(bookmark_HTML_CONTAINER_CLASS);
      node.appendChild(htmlContainer);
      return node;
    }
  }, {
    key: "initMap",
    value: function initMap(map, store) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      map.set('type', 'bookmark');
      map.set('viewMode', params.viewMode || params.hasOwnProperty('isCard') && !params.isCard && ALLOWED_VIEW_MODES[1] || ALLOWED_VIEW_MODES[0]);
      map.set('name', params.name || null);
      map.set('description', params.description || null);
      map.set('attachmentGlobalId', params.attachmentGlobalId || null);
      map.set('icon', params.icon || null);
      map.set('src', params.src || null);
      map.set('color', params.color || this.getRandomPreviewBackground());
      var previewId = null;
      if (params.previewId) {
        previewId = params.previewId;
      } else {
        // закладка добавлена вручную
        var isParamsHasInfo = params.hasOwnProperty('name') || params.hasOwnProperty('attachmentGlobalId') && !params.attachmentGlobalId;
        if (isParamsHasInfo) {
          previewId = 'no-preview';
        }
      }
      map.set('previewId', previewId);
      if (params.openInSameTab) {
        map.set('openInSameTab', true);
      }
      if (params.originPreviewUrl) {
        map.set('originPreviewUrl', params.originPreviewUrl);
      }
      if (params.room) {
        map.set('originalRoomId', params.room);
      }
      bookmark_get(bookmark_getPrototypeOf(Bookmark), "initMap", this) && bookmark_get(bookmark_getPrototypeOf(Bookmark), "initMap", this).call(this, map, store, params);
    }
  }, {
    key: "getRandomPreviewBackground",
    value: function getRandomPreviewBackground() {
      var keys = Object.keys(colors_palette);
      return keys[Math.floor(Math.random() * keys.length)];
    }
  }]);
  return Bookmark;
}(bookmark_mixin(blockEmbed));
Bookmark.blotName = 'bookmark';
Bookmark.tagName = 'div';
Bookmark.allowedChildren = [];
/* harmony default export */ const bookmark = (Bookmark);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/outline.js
function outline_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { outline_typeof = function _typeof(obj) { return typeof obj; }; } else { outline_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return outline_typeof(obj); }
function outline_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = outline_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function outline_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return outline_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return outline_arrayLikeToArray(o, minLen); }
function outline_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

























function outline_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function outline_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function outline_createClass(Constructor, protoProps, staticProps) { if (protoProps) outline_defineProperties(Constructor.prototype, protoProps); if (staticProps) outline_defineProperties(Constructor, staticProps); return Constructor; }
function outline_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { outline_get = Reflect.get; } else { outline_get = function _get(target, property, receiver) { var base = outline_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return outline_get(target, property, receiver || target); }
function outline_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = outline_getPrototypeOf(object); if (object === null) break; } return object; }
function outline_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) outline_setPrototypeOf(subClass, superClass); }
function outline_setPrototypeOf(o, p) { outline_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return outline_setPrototypeOf(o, p); }
function outline_createSuper(Derived) { var hasNativeReflectConstruct = outline_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = outline_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = outline_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return outline_possibleConstructorReturn(this, result); }; }
function outline_possibleConstructorReturn(self, call) { if (call && (outline_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return outline_assertThisInitialized(self); }
function outline_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function outline_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function outline_getPrototypeOf(o) { outline_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return outline_getPrototypeOf(o); }
function outline_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





















var outline_isEnterKey = (0,lib/* default */.ZP)('enter');
var outline_isEscKey = (0,lib/* default */.ZP)('escape');
var outline_mixin = mix([commentable, blotLock, embeddable, draggable, dropAcceptor, selectable, focusable, executable, basic]);
var BORDERLESS_CLASSNAME = 'borderless-outline';
var OUTLINE_CLASS = 'outline';
var OUTLINE_CONTAINER_CLASS = 'outline-container';
var OUTLINE_MENU_CLASS = 'outline-menu';
var BOUNDED_OUTLINE_CONTAINERS = ['toggleContent'];
var Outline = /*#__PURE__*/function (_mixin) {
  outline_inherits(Outline, _mixin);
  var _super = outline_createSuper(Outline);
  function Outline(domNode) {
    var _this;
    outline_classCallCheck(this, Outline);
    _this = _super.call(this, domNode);
    outline_defineProperty(outline_assertThisInitialized(_this), "onOutlineMenuIconRef", function (node) {
      _this.outlineMenuIconNode = node;
    });
    outline_defineProperty(outline_assertThisInitialized(_this), "onRenameInputNodeRef", function (node) {
      _this.renameInputNode = node;
    });
    outline_defineProperty(outline_assertThisInitialized(_this), "onDocumentOutlineMouseDown", function (event) {
      if (event.target !== _this.renameInputNode && _this.props.renaming) {
        _this.onApplyOutlineName();
      }
    });
    outline_defineProperty(outline_assertThisInitialized(_this), "updateOutline", function (data) {
      if (_this.props.renaming) return;
      // Фильтруем список оглавления: если оглавление находится внутри обособленного блока, например тоггл,
      // то оно должно содержать только заголовки, которые внутри этого блока. В свою очередь оглавление, 
      // которое находится в основном теле заметки, не должно содержать в себе заголовки, которые находятся
      // внутри обособленных блоков.
      var boundedContainer = searchUp(outline_assertThisInitialized(_this), function (blot) {
        return BOUNDED_OUTLINE_CONTAINERS.includes(blot.constructor.blotName);
      });
      var boundedData = data.filter(function (_ref) {
        var id = _ref.id;
        var itemBlot = _this.editor.findById(id);
        if (itemBlot) {
          if (boundedContainer) {
            return Boolean(searchUp(itemBlot, function (blot) {
              return blot === boundedContainer;
            }));
          } else {
            return !Boolean(searchUp(itemBlot, function (blot) {
              return BOUNDED_OUTLINE_CONTAINERS.includes(blot.constructor.blotName);
            }));
          }
        }
        return false;
      });
      if (boundedContainer) {
        // recalculate level's for bounded outline items
        var currentItemTag = null;
        var prevLevel = 0;
        boundedData = boundedData.map(function (item) {
          var level = _this.editor.plugins.outlineManager.getListItemLvl(item.tag, currentItemTag, prevLevel);
          currentItemTag = item.tag;
          prevLevel = level;
          return Object.assign(item, {
            level: level
          });
        });
      }
      // записываем данные в props, который в свою очередь вызовет render
      // P.S. у нас есть еще реакция на обновления map, потому записываем в props, а не просто вызываем render с аргументом data
      _this.setProps({
        outlineData: boundedData
      });
    });
    outline_defineProperty(outline_assertThisInitialized(_this), "mapObserver", function () {
      _this.render();
    });
    outline_defineProperty(outline_assertThisInitialized(_this), "onMenuButtonMouseDown", function (event) {
      if (_this.props.menuOpen) {
        _this._swallowMenuClick = true;
        var _restore = function _restore() {
          setTimeout(function () {
            return _this._swallowMenuClick = false;
          });
          document.removeEventListener('mouseup', _restore, false);
        };
        document.addEventListener('mouseup', _restore, false);
      }
    });
    outline_defineProperty(outline_assertThisInitialized(_this), "onMenuButtonClick", function (event) {
      if (_this._swallowMenuClick) {
        _this._swallowMenuClick = false;
        return;
      }
      _this.setProps({
        menuOpen: !_this.props.menuOpen
      });
    });
    outline_defineProperty(outline_assertThisInitialized(_this), "onMenuWantsToClose", function () {
      _this.setProps({
        menuOpen: false
      });
    });
    outline_defineProperty(outline_assertThisInitialized(_this), "onExpandClick", function (event) {
      _this.expandOutline();
    });
    outline_defineProperty(outline_assertThisInitialized(_this), "onOutlineClickMenuExpand", function (event) {
      _this.expandOutline();
      _this.hideOutlineMenu();
    });
    outline_defineProperty(outline_assertThisInitialized(_this), "expandOutline", function () {
      var expanded = _this.map.get('expanded');
      _this.map.set('expanded', !expanded);
    });
    outline_defineProperty(outline_assertThisInitialized(_this), "onOutlineClickMenuRename", function () {
      _this.setProps({
        menuOpen: false,
        renaming: true
      });
      _this.renameInputNode.focus();
      _this.renameInputNode.select();
    });
    outline_defineProperty(outline_assertThisInitialized(_this), "onRenameInputKeyDown", function (event) {
      if (outline_isEnterKey(event)) {
        _this.onApplyOutlineName();
      }
      if (outline_isEscKey(event)) {
        _this.onApplyOutlineName(false);
      }
    });
    outline_defineProperty(outline_assertThisInitialized(_this), "setNumberedListStyle", function () {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (opts.hasOwnProperty('numbered')) {
        _this.map.set('numbered', opts.numbered);
      }
    });
    outline_defineProperty(outline_assertThisInitialized(_this), "toggleBordered", function () {
      _this.map.set('bordered', !_this.map.get('bordered'));
    });
    outline_defineProperty(outline_assertThisInitialized(_this), "getCurrentBorderColor", function () {
      return _this.map.get('borderColor') || 'transparent';
    });
    _this.isSeparableByClickApplicable = true;
    _this.addCanExecActions(['delete', 'backspace']);
    _this.disallowReplace = true;
    _this.addCanExecActions(['set-border-color']);
    return _this;
  }
  outline_createClass(Outline, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = outline_get(outline_getPrototypeOf(Outline.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      this.store.observe(this.map, this.mapObserver);
      document.addEventListener('mousedown', this.onDocumentOutlineMouseDown, false);
      // так как у нас есть менеджер outline в плагинах, подписываемся на его обновления,
      // чтобы не дублировать код и не нагружать редактор двумя сборщиками
      this.editor.emitter.on('update-outline', this.updateOutline);
      this.render();
    }
  }, {
    key: "detach",
    value: function detach() {
      if (outline_get(outline_getPrototypeOf(Outline.prototype), "detach", this)) {
        var _get3;
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        (_get3 = outline_get(outline_getPrototypeOf(Outline.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      }
      this.store.unobserve(this.map, this.mapObserver);
      document.removeEventListener('mousedown', this.onDocumentOutlineMouseDown, false);
      this.editor.emitter.off('update-outline', this.updateOutline);
    }
  }, {
    key: "onFocusableBlur",
    value: function onFocusableBlur() {
      if (outline_get(outline_getPrototypeOf(Outline.prototype), "onFocusableBlur", this)) {
        outline_get(outline_getPrototypeOf(Outline.prototype), "onFocusableBlur", this).call(this);
      }
      this.setProps({
        menuOpen: false,
        renaming: false
      });
    }
  }, {
    key: "hideOutlineMenu",
    value: function hideOutlineMenu() {
      this.setProps({
        menuOpen: false
      });
    }
  }, {
    key: "onApplyOutlineName",
    value: function onApplyOutlineName() {
      var apply = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (apply && this.renameInputNode && this.renameInputNode.value !== '') {
        this.map.set('name', this.renameInputNode.value);
      }
      this.setProps({
        renaming: false
      });
    }
  }, {
    key: "onOutlineListItemClick",
    value: function onOutlineListItemClick(id) {
      this.editor.plugins.scrollSaver.scrollToBlot(id, true, false);
    }
  }, {
    key: "getSpecialBlotMenu",
    value: function getSpecialBlotMenu() {
      var isEmpty = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var expandMenu = {
        expand: {
          label: !this.map.get('expanded') ? (0,preact_module.h)(plugins_i18n/* Text */.xv, {
            id: "outline.menu.expand"
          }) : (0,preact_module.h)(plugins_i18n/* Text */.xv, {
            id: "outline.menu.collapse"
          }),
          index: 0,
          action: 'onOutlineClickMenuExpand'
        }
      };
      var renameMenu = {
        rename: {
          label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
            id: "outline.menu.rename"
          }),
          index: 1,
          action: 'onOutlineClickMenuRename'
        }
      };
      if (this.isBlotLocked) {
        renameMenu = {};
      }
      var menu = Object.assign({}, expandMenu, renameMenu);
      return menu;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      outline_get(outline_getPrototypeOf(Outline.prototype), "render", this).call(this);
      var outlineContainer = this.domNode.querySelector('.' + OUTLINE_CONTAINER_CLASS);
      var editMode = this.editor.mode === this.editor.constructor.MODE_EDIT;
      var exportMode = this.editor.mode === this.editor.constructor.MODE_EXPORT;
      var bordered = this.map.get('bordered');
      if (bordered && outlineContainer.classList.contains(BORDERLESS_CLASSNAME)) outlineContainer.classList.remove(BORDERLESS_CLASSNAME);
      if (!bordered && !outlineContainer.classList.contains(BORDERLESS_CLASSNAME)) outlineContainer.classList.add(BORDERLESS_CLASSNAME);
      var borderColor = this.map.get('borderColor');
      if (borderColor) {
        outlineContainer.setAttribute('data-border-color', borderColor);
      } else {
        outlineContainer.removeAttribute('data-border-color');
      }
      var data = this.props.outlineData;
      var nodeToRender = null;
      if (!data) {
        //до первого обновления показываем loader
        nodeToRender = (0,preact_module.h)("div", {
          className: "outline-content-wrapper"
        }, (0,preact_module.h)("div", {
          className: "outline-header loading"
        }, (0,preact_module.h)((loader2_default()), null)));
      } else {
        var isEmpty = !Boolean(data.length);
        var outlineName = this.map.get('name') || this.editor.plugins.i18n.get('outline.default_name');
        var renaming = this.props.renaming;
        var expanded = this.map.get('expanded');
        // объявление нод для рендера
        var nameNode = null,
          menuNode = null,
          headerNode = null,
          bodyNode = null;
        //нода названия оутлайнера
        if (renaming) {
          nameNode = (0,preact_module.h)("div", {
            className: "outline-name renaming"
          }, (0,preact_module.h)("input", {
            ref: this.onRenameInputNodeRef,
            type: "text",
            onKeyDown: this.onRenameInputKeyDown,
            value: outlineName
          }));
        } else {
          nameNode = (0,preact_module.h)("div", {
            className: "outline-name",
            onClick: this.onExpandClick,
            onMouseDown: function onMouseDown(event) {
              event.preventDefault();
            }
          }, outlineName);
        }
        //нода меню оутлайнера
        if (this.props.menuOpen) {
          var menuRaw = this.getSpecialBlotMenu(isEmpty);
          var menuItems = Object.keys(menuRaw).map(function (key) {
            return Object.assign({}, menuRaw[key], {
              key: key
            });
          }).sort(function (item1, item2) {
            return item1.index - item2.index;
          }).map(function (item) {
            return (0,preact_module.h)(popupMenuItem/* default */.Z, {
              key: item.key,
              id: 'outline-' + item.key,
              onClick: _this2[item.action],
              text: item.label
            });
          });
          menuNode = (0,preact_module.h)(popupMenu/* default */.Z, {
            closeOnEsc: true,
            addClassName: OUTLINE_MENU_CLASS + " position-absolute",
            anchorNode: this.outlineMenuIconNode,
            wantsToClose: this.onMenuWantsToClose,
            anchorOptions: {
              placement: 'left-start'
            }
          }, menuItems);
        }
        //нода заголовка оутлайнера
        headerNode = (0,preact_module.h)("div", {
          className: 'outline-header ' + (renaming ? 'renaming-process' : '')
        }, (0,preact_module.h)("div", {
          className: "outline-left"
        }, (0,preact_module.h)("div", {
          className: 'outline-expand-icon ' + (!exportMode && expanded ? 'expanded' : ''),
          onClick: this.onExpandClick,
          onMouseDown: function onMouseDown(event) {
            event.preventDefault();
          }
        }, !exportMode ? (0,preact_module.h)(icons/* IconArrowRightRounded */.VYF, null) : ' ')), nameNode, !exportMode ? (0,preact_module.h)("div", {
          className: "outline-right"
        }, editMode ? (0,preact_module.h)("div", {
          className: "outline-menu-icon",
          ref: this.onOutlineMenuIconRef,
          onClick: this.onMenuButtonClick,
          onMouseDown: this.onMenuButtonMouseDown
        }, (0,preact_module.h)(icons/* IconMoreVertical */.nqv, null)) : null, (0,preact_module.h)(PopupMenuTransition, null, editMode ? menuNode : null)) : null);
        //нода тела оутлайнера
        if (expanded || exportMode) {
          if (isEmpty) {
            bodyNode = (0,preact_module.h)("div", {
              className: "outline-body"
            }, this.editor.plugins.i18n.get('outline.empty'));
          } else {
            var baseUrl = this.editor.options.baseUrl;
            var list = data.map(function (_ref2) {
              var id = _ref2.id,
                text = _ref2.text,
                level = _ref2.level,
                anchor = _ref2.anchor;
              return (0,preact_module.h)("li", {
                className: 'outline-list-item level-' + level,
                onMouseDown: function onMouseDown(event) {
                  // Для предотвращения лишнего скрытия/показа клавиатуры
                  // В мобильном редакторе
                  event.preventDefault();
                  event.stopPropagation();
                },
                onClick: function onClick() {
                  _this2.onOutlineListItemClick(id);
                }
              }, !exportMode ? (0,preact_module.h)("a", {
                href: (baseUrl ? baseUrl : '') + anchor,
                onClick: function onClick(event) {
                  event.preventDefault();
                }
              }, text) : (0,preact_module.h)("a", {
                href: anchor
              }, text));
            });
            var numbered = this.map.get('numbered');
            bodyNode = (0,preact_module.h)("div", {
              className: "outline-body"
            }, (0,preact_module.h)("ul", {
              className: 'outline-list ' + (numbered ? 'outline-numbered' : '')
            }, list));
          }
        }
        nodeToRender = (0,preact_module.h)("div", {
          className: 'outline-content-wrapper ' + (isEmpty ? 'empty-outline' : '')
        }, headerNode, bodyNode);
      }
      (0,preact_module/* render */.sY)((0,preact_module.h)(plugins_i18n/* IntlProvider */.Pj, null, nodeToRender), outlineContainer);
    }
  }, {
    key: "convertOutlineToText",
    value: function convertOutlineToText() {
      var _this3 = this;
      var limitManager = this.editor.plugins.limitManager;
      var insertContainer = this.container;
      var numbered = this.map.get('numbered');
      var mainIterator = 0;
      var secondIterator = 0;
      var thridIterator = 0;
      limitManager && limitManager.freeze();
      var blotsData = Array.from(this.domNode.querySelector('.' + OUTLINE_CONTAINER_CLASS + ' .outline-list').childNodes).map(function (node, index) {
        //Уровень заголовка
        var lvl = parseInt(Array.from(node.classList).filter(function (cl) {
          return cl.indexOf('level-') === 0;
        }).join('').replace('level-', ''));
        //дельта блота
        var insertText = '';
        //Добавляем нумерацию
        if (numbered) {
          if (lvl === 0) {
            mainIterator += 1;
            secondIterator = 0;
            thridIterator = 0;
          } else if (lvl === 1) {
            secondIterator += 1;
            thridIterator = 0;
          } else if (lvl === 2) {
            thridIterator += 1;
          }
          insertText += mainIterator + (lvl === 0 ? '. ' : '.');
          insertText += lvl === 1 && secondIterator + '. ' || lvl === 2 && secondIterator + '.' + thridIterator + '. ' || '';
        }
        insertText += node.textContent;
        var delta = {
          ops: [{
            insert: insertText + '\n'
          }]
        };
        var params = {
          delta: delta,
          indent: numbered && lvl > 0 && 1 || 0
        };

        // только первому заголовку передаём комментарии
        if (index === 0) {
          commentable(Object).setCommentThreads(_this3, params);
        }
        return {
          type: lvl === 0 && 'hLarge' || lvl === 1 && 'hMedium' || lvl === 2 && 'hSmall' || null,
          textLength: insertText.length,
          params: params
        };
      });
      var afterId = this.id;
      var i = 0;

      //добавляем блоки
      var _iterator = outline_createForOfIteratorHelper(blotsData),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var blotData = _step.value;
          i++;
          if (blotData.type) {
            afterId = insertContainer.addBlot(blotData.type, Object.assign({}, blotData.params, {
              after: afterId,
              focus: i === blotsData.length && {
                index: blotData.textLength
              }
            })).id;
          }
        }
        //удаляем оутлайнер
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      insertContainer.removeChildById(this.id);
      limitManager && limitManager.unfreeze();
    }
  }, {
    key: "contextMenu",
    get: function get() {
      var menu = outline_get(outline_getPrototypeOf(Outline.prototype), "contextMenu", this);
      var i18n = this.editor.plugins.i18n;
      var isEmpty = this.props.outlineData ? !Boolean(this.props.outlineData.length) : true;
      var expanded = this.map.get('expanded');
      if (!isEmpty && expanded) {
        menu['convert_to'] = {
          label: i18n.get('block_menu.convert_to.name'),
          index: -21,
          group: 0,
          action: false,
          submenu: {
            turnToText: {
              label: i18n.get('outline.context_menu.convert_to.text'),
              index: 0,
              group: 0,
              action: 'convertOutlineToText',
              actionExec: false
            }
          }
        };
      }
      if (!this.blotConfig || !this.blotConfig.disableStyleMenuItems) {
        menu['outline_style'] = {
          label: i18n.get('outline.context_menu.style.name'),
          index: 0,
          group: 0,
          action: false,
          submenu: {
            listOnly: {
              label: i18n.get('outline.context_menu.style.list_only'),
              index: 0,
              group: 0,
              action: this.map.get('numbered') && 'setNumberedListStyle' || false,
              actionParams: {
                numbered: false
              },
              actionExec: false,
              icon: !this.map.get('numbered') && icons/* IconCheck */.NOm || null
            },
            numberedList: {
              label: i18n.get('outline.context_menu.style.numbered_list'),
              index: 1,
              group: 0,
              action: !this.map.get('numbered') && 'setNumberedListStyle' || false,
              actionParams: {
                numbered: true
              },
              actionExec: false,
              icon: this.map.get('numbered') && icons/* IconCheck */.NOm || null
            },
            bordered: {
              label: i18n.get('outline.context_menu.style.bordered'),
              index: 0,
              group: 1,
              action: 'toggleBordered',
              actionExec: false,
              icon: this.map.get('bordered') && icons/* IconCheck */.NOm || null
            }
          }
        };
        var bordered = this.map.get('bordered');
        if (bordered) {
          menu['change-border-color'] = {
            label: i18n.get('outline.context_menu.style.border_color'),
            index: 0,
            group: 0,
            action: 'change-color',
            stackable: false,
            submenu: 'ColorPicker',
            colorPickerParams: {
              getSelectedColor: this.getCurrentBorderColor,
              execAction: 'set-border-color',
              defaultColor: 'transparent',
              closeOnChoice: false
            }
          };
        }
      }
      return menu;
    }
  }, {
    key: "cloneSelf",
    value: function cloneSelf() {
      var map = this.store.createMap();
      var options = {
        name: this.map.get('name'),
        numbered: this.map.get('numbered'),
        expanded: this.map.get('expanded'),
        bordered: this.map.get('bordered')
      };
      if (this.map.get('borderColor')) {
        options.borderColor = this.map.get('borderColor');
      }
      parchment_default().query(this.map.get('type')).initMap(map, this.store, options);
      return map.get('id');
    }
  }, {
    key: "exec",
    value: function exec(action) {
      var processed = outline_get(outline_getPrototypeOf(Outline.prototype), "exec", this).call(this, action);
      var params = action.params;
      if (action.type === 'backspace') {
        action.dontRestoreSelection();
        processed = true;
      } else if (action.type === 'set-border-color') {
        if (params) {
          if (params === 'transparent') {
            this.map.set('borderColor', null);
          } else {
            this.map.set('borderColor', params);
          }
          processed = true;
        }
      }
      return processed;
    }
  }, {
    key: "remove",
    value: function remove() {
      var _get4;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      (_get4 = outline_get(outline_getPrototypeOf(Outline.prototype), "remove", this)).call.apply(_get4, [this].concat(args));
    }
  }, {
    key: "toHTML",
    value: function toHTML() {
      return this.domNode.outerHTML;
    }
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      var params = outline_get(outline_getPrototypeOf(Outline.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
      return (0,util/* mergeDeep */.Ee)(params, {
        initParams: {
          name: this.map.get('name'),
          numbered: this.map.get('numbered'),
          expanded: this.map.get('expanded'),
          bordered: this.map.get('bordered'),
          borderColor: this.map.get('borderColor')
        }
      });
    }
  }], [{
    key: "create",
    value: function create(value) {
      var node = outline_get(outline_getPrototypeOf(Outline), "create", this).call(this);
      node.classList.add(OUTLINE_CLASS);
      var outlineContainer = document.createElement('div');
      outlineContainer.setAttribute('contenteditable', false);
      outlineContainer.classList.add(OUTLINE_CONTAINER_CLASS);
      node.appendChild(outlineContainer);
      return node;
    }
  }, {
    key: "createBlot",
    value: function createBlot(editor) {
      var blot = parchment_default().create('outline');
      this.addCaretTrap(editor, blot.domNode);
      return blot;
    }
  }]);
  return Outline;
}(outline_mixin(blockEmbed));

Outline.blotName = 'outline';
Outline.tagName = 'DIV';
Outline.initMap = function (map, store) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  map.set('type', 'outline');
  map.set('name', params.name || null);
  map.set('bordered', params.hasOwnProperty('bordered') ? params.bordered : true);
  map.set('numbered', params.hasOwnProperty('numbered') ? params.numbered : true);
  map.set('expanded', params.hasOwnProperty('expanded') ? params.expanded : true);
  if (params.borderColor) {
    map.set('borderColor', params.borderColor);
  }
};
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/loader.js
function loader_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { loader_typeof = function _typeof(obj) { return typeof obj; }; } else { loader_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return loader_typeof(obj); }









function blots_loader_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function loader_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) loader_setPrototypeOf(subClass, superClass); }
function loader_setPrototypeOf(o, p) { loader_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return loader_setPrototypeOf(o, p); }
function loader_createSuper(Derived) { var hasNativeReflectConstruct = loader_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = loader_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = loader_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return loader_possibleConstructorReturn(this, result); }; }
function loader_possibleConstructorReturn(self, call) { if (call && (loader_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return loader_assertThisInitialized(self); }
function loader_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function loader_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function loader_getPrototypeOf(o) { loader_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return loader_getPrototypeOf(o); }

var Loader = /*#__PURE__*/function (_Parchment$Embed) {
  loader_inherits(Loader, _Parchment$Embed);
  var _super = loader_createSuper(Loader);
  function Loader(domNode) {
    var _this;
    blots_loader_classCallCheck(this, Loader);
    _this = _super.call(this, domNode);
    domNode.className = 'editor-loader-grey';
    domNode.style.width = '100%';
    domNode.style.height = '100px';
    domNode.style.display = 'block';
    domNode.style.backgroundPosition = 'center center';
    return _this;
  }
  return Loader;
}((parchment_default()).Embed);
Loader.blotName = 'loader';
Loader.tagName = 'LOADER';
Loader.notStored = true;
/* harmony default export */ const loader = (Loader);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/html/component.js
function html_component_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { html_component_typeof = function _typeof(obj) { return typeof obj; }; } else { html_component_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return html_component_typeof(obj); }
function component_extends() { component_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return component_extends.apply(this, arguments); }
function component_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = component_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function component_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return component_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return component_arrayLikeToArray(o, minLen); }
function component_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }














function html_component_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function html_component_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function html_component_createClass(Constructor, protoProps, staticProps) { if (protoProps) html_component_defineProperties(Constructor.prototype, protoProps); if (staticProps) html_component_defineProperties(Constructor, staticProps); return Constructor; }
function html_component_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) html_component_setPrototypeOf(subClass, superClass); }
function html_component_setPrototypeOf(o, p) { html_component_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return html_component_setPrototypeOf(o, p); }
function html_component_createSuper(Derived) { var hasNativeReflectConstruct = html_component_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = html_component_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = html_component_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return html_component_possibleConstructorReturn(this, result); }; }
function html_component_possibleConstructorReturn(self, call) { if (call && (html_component_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return html_component_assertThisInitialized(self); }
function html_component_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function html_component_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function html_component_getPrototypeOf(o) { html_component_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return html_component_getPrototypeOf(o); }
function html_component_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var IframeComponent = /*#__PURE__*/function (_Component) {
  html_component_inherits(IframeComponent, _Component);
  var _super = html_component_createSuper(IframeComponent);
  function IframeComponent() {
    var _this;
    html_component_classCallCheck(this, IframeComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    html_component_defineProperty(html_component_assertThisInitialized(_this), "iframeNode", null);
    html_component_defineProperty(html_component_assertThisInitialized(_this), "onImgLoad", function () {
      _this.props.onImageLoad && _this.props.onImageLoad(_this.iframeNode);
    });
    html_component_defineProperty(html_component_assertThisInitialized(_this), "onDomContentLoaded", function () {
      var imgs = _this.iframeNode.contentDocument.querySelectorAll('img');
      var _iterator = component_createForOfIteratorHelper(imgs),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var img = _step.value;
          img.onload = _this.onImgLoad;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      _this.props.onDomLoad && _this.props.onDomLoad(_this.iframeNode);
    });
    html_component_defineProperty(html_component_assertThisInitialized(_this), "onRef", function (node) {
      _this.iframeNode = node;
    });
    return _this;
  }
  html_component_createClass(IframeComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var contentDocument = this.iframeNode.contentDocument;
      var contentWindow = this.iframeNode.contentWindow;
      contentWindow.onDomLoad = this.onDomContentLoaded;
    }
  }, {
    key: "render",
    value: function render() {
      var frameContentHeight = this.props.frameContentHeight;
      var props = Object.assign({}, this.props);
      var srcdoc = "<script>document.addEventListener(\"DOMContentLoaded\", window.onDomLoad)</script>\n<style>img {cursor: pointer}</style>" + props.srcdoc;
      delete props.onDomLoad;
      delete props.srcdoc;
      var style = {};
      if (typeof frameContentHeight === 'number') {
        style.height = frameContentHeight + 'px';
      } else {
        // производим оценку высоты фрейма перед его отображением, чтобы не было резких скачков в контенте
        style.position = 'absolute';
        style.left = '-1000000px';
        style.top = '-1000000px';
        // устанавливаем высоту по умолчанию в 1000px, т.к. некоторый контент подстраивается под высоту страницы
        // и если не устанавливать height по умолчанию, то контент останется узким, равным дефолтной высоте фрейма
        style.height = '1000px';
        style.visibility = 'hidden';
      }
      return (0,preact_module.h)("iframe", component_extends({
        style: style,
        srcdoc: srcdoc,
        ref: this.onRef
      }, props));
    }
  }]);
  return IframeComponent;
}(preact_module/* Component */.wA); // наследование от PureComponent чтобы не вызывался перерендер, иначе если есть изображения в контенте,
// то происходит их постонная перезагрузка, когда вызывается render вышестоящего компонента (blot)
var HTMLComponent = /*#__PURE__*/function (_Component2) {
  html_component_inherits(HTMLComponent, _Component2);
  var _super2 = html_component_createSuper(HTMLComponent);
  function HTMLComponent() {
    var _this2;
    html_component_classCallCheck(this, HTMLComponent);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    html_component_defineProperty(html_component_assertThisInitialized(_this2), "state", {});
    html_component_defineProperty(html_component_assertThisInitialized(_this2), "frameNode", null);
    html_component_defineProperty(html_component_assertThisInitialized(_this2), "onContentClick", function (event) {
      var target = event.target;
      var preventDefault = false;
      if (target.tagName === 'IMG') {
        preventDefault = true;
        _this2.onImageClick(target);
      }
      if (preventDefault) {
        event.preventDefault();
      }
    });
    html_component_defineProperty(html_component_assertThisInitialized(_this2), "onFrameLoad", function (target) {
      _this2.refreshFrameHeight(target);
      target.contentDocument.body.onclick = _this2.onContentClick;
    });
    html_component_defineProperty(html_component_assertThisInitialized(_this2), "onFrameImageLoad", function (frame) {
      _this2.refreshFrameHeight(frame);
    });
    html_component_defineProperty(html_component_assertThisInitialized(_this2), "onFrameFullyLoaded", function (event) {
      _this2.refreshFrameHeight(event.target);
      event.target.contentDocument.body.style.overflowY = 'hidden';
    });
    html_component_defineProperty(html_component_assertThisInitialized(_this2), "onFrameRef", function (frame) {
      _this2.frameNode = frame;
    });
    return _this2;
  }
  html_component_createClass(HTMLComponent, [{
    key: "onImageClick",
    value: function onImageClick(imgNode) {
      var src = imgNode.src;
      if (src) {
        if (!this.props.onImageEnterFullSize || !this.props.onImageEnterFullSize(src)) {
          if (this.props.lightBox) {
            this.props.lightBox.open(src);
          }
        }
      }
    }
  }, {
    key: "refreshFrameHeight",
    value: function refreshFrameHeight(frame) {
      var frameDocument = frame.contentWindow.document;
      this.setState(function () {
        return {
          frameContentHeight: frameDocument.documentElement.scrollHeight
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        content = _this$props.content,
        i18n = _this$props.i18n,
        classPrefix = _this$props.classPrefix;
      var frameContentHeight = this.state.frameContentHeight;
      var nodeToRender = null;
      if (!content) {
        nodeToRender = (0,preact_module.h)("div", {
          className: classPrefix + '-loading'
        }, i18n.get('html.loading'));
      } else {
        nodeToRender = (0,preact_module.h)("div", {
          className: classPrefix + '-content ' + util/* SELF_CONTROLLED_CONTENT_CLASS */.W$
        }, (0,preact_module.h)(IframeComponent, {
          onLoad: this.onFrameFullyLoaded,
          onDomLoad: this.onFrameLoad,
          onImageLoad: this.onFrameImageLoad,
          srcdoc: content,
          ref: this.onFrameRef,
          frameContentHeight: frameContentHeight
        }));
      }
      return nodeToRender;
    }
  }]);
  return HTMLComponent;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/collapsibleContent.js
function collapsibleContent_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { collapsibleContent_typeof = function _typeof(obj) { return typeof obj; }; } else { collapsibleContent_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return collapsibleContent_typeof(obj); }
function collapsibleContent_extends() { collapsibleContent_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return collapsibleContent_extends.apply(this, arguments); }















function collapsibleContent_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function collapsibleContent_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function collapsibleContent_createClass(Constructor, protoProps, staticProps) { if (protoProps) collapsibleContent_defineProperties(Constructor.prototype, protoProps); if (staticProps) collapsibleContent_defineProperties(Constructor, staticProps); return Constructor; }
function collapsibleContent_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) collapsibleContent_setPrototypeOf(subClass, superClass); }
function collapsibleContent_setPrototypeOf(o, p) { collapsibleContent_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return collapsibleContent_setPrototypeOf(o, p); }
function collapsibleContent_createSuper(Derived) { var hasNativeReflectConstruct = collapsibleContent_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = collapsibleContent_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = collapsibleContent_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return collapsibleContent_possibleConstructorReturn(this, result); }; }
function collapsibleContent_possibleConstructorReturn(self, call) { if (call && (collapsibleContent_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return collapsibleContent_assertThisInitialized(self); }
function collapsibleContent_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function collapsibleContent_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function collapsibleContent_getPrototypeOf(o) { collapsibleContent_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return collapsibleContent_getPrototypeOf(o); }
function collapsibleContent_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var collapsibleContent_isEnterKey = (0,lib/* default */.ZP)('enter');
var collapsibleContent_isEscKey = (0,lib/* default */.ZP)('escape');
var CollapsibleContent = /*#__PURE__*/function (_Component) {
  collapsibleContent_inherits(CollapsibleContent, _Component);
  var _super = collapsibleContent_createSuper(CollapsibleContent);
  function CollapsibleContent() {
    var _this;
    collapsibleContent_classCallCheck(this, CollapsibleContent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    collapsibleContent_defineProperty(collapsibleContent_assertThisInitialized(_this), "onMenuIconRef", function (node) {
      _this.menuIconNode = node;
    });
    collapsibleContent_defineProperty(collapsibleContent_assertThisInitialized(_this), "onRenameInputNodeRef", function (node) {
      _this.renameInputNode = node;
    });
    collapsibleContent_defineProperty(collapsibleContent_assertThisInitialized(_this), "onHeaderClick", function (event) {
      _this.onExpandContent();
    });
    collapsibleContent_defineProperty(collapsibleContent_assertThisInitialized(_this), "onMenuButtonMouseDown", function (event) {
      if (_this.state.menuOpen) {
        _this._swallowMenuClick = true;
        var _restore = function _restore() {
          setTimeout(function () {
            return _this._swallowMenuClick = false;
          });
          document.removeEventListener('mouseup', _restore, false);
        };
        document.addEventListener('mouseup', _restore, false);
      }
    });
    collapsibleContent_defineProperty(collapsibleContent_assertThisInitialized(_this), "onMenuButtonClick", function (event) {
      event.stopPropagation();
      if (_this._swallowMenuClick) {
        _this._swallowMenuClick = false;
        return;
      }
      _this.setState(function (prevState) {
        return {
          menuOpen: !prevState.menuOpen
        };
      });
    });
    collapsibleContent_defineProperty(collapsibleContent_assertThisInitialized(_this), "onRenameInputKeyDown", function (event) {
      if (collapsibleContent_isEnterKey(event)) {
        _this.onApplyName();
      }
      if (collapsibleContent_isEscKey(event)) {
        _this.onApplyName(false);
      }
    });
    collapsibleContent_defineProperty(collapsibleContent_assertThisInitialized(_this), "onRenameInputClick", function (event) {
      event.stopPropagation();
    });
    collapsibleContent_defineProperty(collapsibleContent_assertThisInitialized(_this), "onClickMenuExpand", function () {
      _this.onExpandContent();
    });
    collapsibleContent_defineProperty(collapsibleContent_assertThisInitialized(_this), "onClickMenuRename", function () {
      _this.setState(function () {
        return {
          renaming: true
        };
      });
      /*// ждем смену state и существование ноды
      setTimeout(() => {
        this.renameInputNode.focus()
        this.renameInputNode.select()
      }, 0)*/
    });
    collapsibleContent_defineProperty(collapsibleContent_assertThisInitialized(_this), "onBodyMouseDown", function (event) {
      var target = event.target;
      if (_this.state.renaming) {
        if (target === _this.renameInputNode) {
          return;
        } else {
          _this.onApplyName(false);
        }
      }
    });
    collapsibleContent_defineProperty(collapsibleContent_assertThisInitialized(_this), "onExpandContent", function () {
      var expanded = _this.props.blotMap.get('expanded');
      _this.props.blotMap.set('expanded', !expanded);
    });
    collapsibleContent_defineProperty(collapsibleContent_assertThisInitialized(_this), "onMenuWantsToClose", function () {
      _this.setState(function () {
        return {
          menuOpen: false
        };
      });
    });
    return _this;
  }
  collapsibleContent_createClass(CollapsibleContent, [{
    key: "onApplyName",
    value: function onApplyName() {
      var apply = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (apply && this.renameInputNode && this.renameInputNode.value !== '') {
        this.props.blotMap.set('name', this.renameInputNode.value);
      }
      this.setState(function () {
        return {
          renaming: false
        };
      });
    }
  }, {
    key: "getCollapsibleContentMenu",
    value: function getCollapsibleContentMenu() {
      var blotMenu = this.props.getSpecialBlotMenu();
      if (!this.props.isBlotLocked) {
        blotMenu = Object.assign({
          rename: {
            label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
              id: "collapsible_content.menu.rename"
            }),
            index: 10,
            action: 'onClickMenuRename',
            defaultItem: true
          }
        }, blotMenu);
      }
      var menu = Object.assign({
        expand: {
          label: !this.props.blotMap.get('expanded') ? (0,preact_module.h)(plugins_i18n/* Text */.xv, {
            id: "collapsible_content.menu.expand"
          }) : (0,preact_module.h)(plugins_i18n/* Text */.xv, {
            id: "collapsible_content.menu.collapse"
          }),
          index: 0,
          action: 'onClickMenuExpand',
          defaultItem: true
        }
      }, blotMenu);
      return menu;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.addEventListener('mousedown', this.onBodyMouseDown, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeEventListener('mousedown', this.onBodyMouseDown, false);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevState.renaming && this.state.renaming && this.renameInputNode) {
        this.renameInputNode.focus();
        this.renameInputNode.select();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        name = _this$props.name,
        wrapperClassName = _this$props.wrapperClassName,
        headerClassName = _this$props.headerClassName,
        bodyClassName = _this$props.bodyClassName,
        blotMap = _this$props.blotMap,
        editMode = _this$props.editMode,
        exportMode = _this$props.exportMode,
        isHeaderHidden = _this$props.isHeaderHidden,
        isBordersHidden = _this$props.isBordersHidden;
      var _this$state = this.state,
        renaming = _this$state.renaming,
        menuOpen = _this$state.menuOpen;
      var expanded = !exportMode ? blotMap.get('expanded') : true;
      var nameNode = null,
        menuNode = null;
      if (renaming) {
        nameNode = (0,preact_module.h)("div", {
          className: "collapsible-content-name renaming"
        }, (0,preact_module.h)("input", {
          ref: this.onRenameInputNodeRef,
          type: "text",
          onKeyDown: this.onRenameInputKeyDown,
          onClick: this.onRenameInputClick,
          value: name
        }));
      } else {
        nameNode = (0,preact_module.h)("div", {
          className: "collapsible-content-name"
        }, (0,preact_module.h)("span", collapsibleContent_extends({}, collapsibleContent_defineProperty({}, tooltipManager/* TOOLTIP_ATTR */.qZ, name), {
          className: "collapsible-content-name-text"
        }), name));
      }
      if (menuOpen) {
        var menuRaw = this.getCollapsibleContentMenu();
        var menuItems = Object.keys(menuRaw).map(function (key) {
          return Object.assign({}, menuRaw[key], {
            key: key
          });
        }).sort(function (item1, item2) {
          return item1.index - item2.index;
        }).map(function (item) {
          return (0,preact_module.h)(popupMenuItem/* default */.Z, {
            key: item.key,
            id: 'collapsible-content-' + item.key,
            onClick: function onClick(event) {
              event.stopPropagation();
              _this2.onMenuWantsToClose();
              if (item.defaultItem) {
                _this2[item.action]();
              } else {
                _this2.props.onMenuClickAction(item.action);
              }
            },
            text: item.label
          });
        });
        menuNode = (0,preact_module.h)(popupMenu/* default */.Z, {
          addClassName: "collapsible-content-menu position-absolute",
          anchorNode: this.menuIconNode,
          wantsToClose: this.onMenuWantsToClose,
          anchorOptions: {
            placement: 'left-start'
          }
        }, menuItems);
      }
      var headerNode = null;
      if (!isHeaderHidden) {
        headerNode = (0,preact_module.h)("div", {
          className: 'collapsible-content-header ' + (headerClassName || ''),
          onClick: this.onHeaderClick
        }, (0,preact_module.h)("div", {
          className: "collapsible-content-header-left"
        }, (0,preact_module.h)("div", {
          className: 'collapsible-content-expand-icon ' + (expanded ? 'expanded' : '')
        }, !exportMode ? (0,preact_module.h)(icons/* IconArrowRightRounded */.VYF, null) : ' ')), nameNode, editMode ? (0,preact_module.h)("div", {
          className: "collapsible-content-header-right"
        }, (0,preact_module.h)("div", {
          className: "collapsible-content-menu-icon",
          ref: this.onMenuIconRef,
          onClick: this.onMenuButtonClick,
          onMouseDown: this.onMenuButtonMouseDown
        }, (0,preact_module.h)(icons/* IconMoreVertical */.nqv, null)), (0,preact_module.h)(PopupMenuTransition, null, menuNode)) : null);
      }
      var noBorders = '';
      if (isBordersHidden) {
        noBorders = ' no-borders';
      }
      return (0,preact_module.h)(plugins_i18n/* IntlProvider */.Pj, null, (0,preact_module.h)("div", {
        className: 'collapsible-content ' + (wrapperClassName || '') + noBorders
      }, headerNode, expanded ? (0,preact_module.h)("div", {
        className: 'collapsible-content-body ' + (bodyClassName || '')
      }, this.props.children) : null));
    }
  }]);
  return CollapsibleContent;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/html/html.js
function html_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { html_typeof = function _typeof(obj) { return typeof obj; }; } else { html_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return html_typeof(obj); }
function html_slicedToArray(arr, i) { return html_arrayWithHoles(arr) || html_iterableToArrayLimit(arr, i) || html_unsupportedIterableToArray(arr, i) || html_nonIterableRest(); }
function html_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function html_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function html_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function html_toConsumableArray(arr) { return html_arrayWithoutHoles(arr) || html_iterableToArray(arr) || html_unsupportedIterableToArray(arr) || html_nonIterableSpread(); }
function html_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function html_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function html_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return html_arrayLikeToArray(arr); }
function html_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function html_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { html_ownKeys(Object(source), true).forEach(function (key) { html_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { html_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function html_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = html_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function html_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return html_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return html_arrayLikeToArray(o, minLen); }
function html_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function html_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function html_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { html_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { html_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function html_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function html_createClass(Constructor, protoProps, staticProps) { if (protoProps) html_defineProperties(Constructor.prototype, protoProps); if (staticProps) html_defineProperties(Constructor, staticProps); return Constructor; }
function html_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { html_get = Reflect.get; } else { html_get = function _get(target, property, receiver) { var base = html_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return html_get(target, property, receiver || target); }
function html_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = html_getPrototypeOf(object); if (object === null) break; } return object; }
function html_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

























function html_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function html_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) html_setPrototypeOf(subClass, superClass); }
function html_createSuper(Derived) { var hasNativeReflectConstruct = html_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = html_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = html_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return html_possibleConstructorReturn(this, result); }; }
function html_possibleConstructorReturn(self, call) { if (call && (html_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return html_assertThisInitialized(self); }
function html_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function html_wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; html_wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !html_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return html_construct(Class, arguments, html_getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return html_setPrototypeOf(Wrapper, Class); }; return html_wrapNativeSuper(Class); }
function html_construct(Parent, args, Class) { if (html_isNativeReflectConstruct()) { html_construct = Reflect.construct; } else { html_construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) html_setPrototypeOf(instance, Class.prototype); return instance; }; } return html_construct.apply(null, arguments); }
function html_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function html_isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function html_setPrototypeOf(o, p) { html_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return html_setPrototypeOf(o, p); }
function html_getPrototypeOf(o) { html_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return html_getPrototypeOf(o); }




















var html_mixin = mix([commentable, blotLock, fullWidth, embeddable, draggable, dropAcceptor, selectable, focusable, executable, basic]);
var html_HTML_CLASS = 'nimbus-html';
var html_HTML_CONTAINER_CLASS = 'nimbus-html-container';
var HTML_WRAPPER_CLASS = 'nimbus-html-wrapper';
var HTML_HEADER_CLASS = 'nimbus-html-header';
var HTML_BODY_CLASS = 'nimbus-html-body';
var WrongSignatureError = /*#__PURE__*/function (_Error) {
  html_inherits(WrongSignatureError, _Error);
  var _super = html_createSuper(WrongSignatureError);
  function WrongSignatureError() {
    html_classCallCheck(this, WrongSignatureError);
    return _super.apply(this, arguments);
  }
  return WrongSignatureError;
}( /*#__PURE__*/html_wrapNativeSuper(Error));
var HTMLBlot = /*#__PURE__*/function (_mixin) {
  html_inherits(HTMLBlot, _mixin);
  var _super2 = html_createSuper(HTMLBlot);
  function HTMLBlot(domNode) {
    var _this;
    html_classCallCheck(this, HTMLBlot);
    _this = _super2.call(this, domNode);
    html_defineProperty(html_assertThisInitialized(_this), "mapObserver", function () {
      _this.render();
    });
    html_defineProperty(html_assertThisInitialized(_this), "onClickMenuOpenSource", function () {
      var url = _this.map.get('srcLink');
      if (!_this.editor.plugins.linkManager.processNavigation(url)) {
        window.open(url, '_blank', 'noopener');
      }
    });
    html_defineProperty(html_assertThisInitialized(_this), "onImageEnterFullSize", function (url) {
      if (!_this.editor.plugins.imageManager.enterFullSize) return false;
      var attachment = _this.getCachedAttachmentByURL(url);
      if (!attachment) {
        return false;
      }
      if (typeof _this.editor.plugins.imageManager.enterFullSize(attachment.id) === 'undefined') {
        return true;
      }
      return false;
    });
    html_defineProperty(html_assertThisInitialized(_this), "getSpecialBlotMenu", function () {
      var menu = {};
      if (!_this.isBlotLocked) {
        if (_this.hasOriginLink()) {
          menu.openSrc = {
            label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
              id: "html.menu.open_source"
            }),
            index: 1,
            action: 'onClickMenuOpenSource'
          };
        }
        if (_this.blotConfig.exportBlot) {
          menu.exportBlot = {
            label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
              id: "html.menu.export_blot"
            }),
            index: 2,
            action: 'onExportBlot'
          };
        }
      }
      return menu;
    });
    html_defineProperty(html_assertThisInitialized(_this), "onMenuClickAction", function (action) {
      _this[action]();
    });
    html_defineProperty(html_assertThisInitialized(_this), "resolveHtml", /*#__PURE__*/function () {
      var _ref = html_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(html) {
        var attachmentIds, _iterator, _step, id, attachment;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                html = _this.prepareLinks(html);
                attachmentIds = _this.getAttachmentIdsFromHtml(html);
                _iterator = html_createForOfIteratorHelper(attachmentIds);
                _context.prev = 3;
                _iterator.s();
              case 5:
                if ((_step = _iterator.n()).done) {
                  _context.next = 19;
                  break;
                }
                id = _step.value;
                _context.prev = 7;
                _context.next = 10;
                return _this.editor.plugins.attachmentManager.resolve(id, {
                  blotName: 'html'
                });
              case 10:
                attachment = _context.sent;
                _this.cache.attachments[id] = attachment;
                _context.next = 17;
                break;
              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](7);
                console.error('fail to resolve attachment', _context.t0);
              case 17:
                _context.next = 5;
                break;
              case 19:
                _context.next = 24;
                break;
              case 21:
                _context.prev = 21;
                _context.t1 = _context["catch"](3);
                _iterator.e(_context.t1);
              case 24:
                _context.prev = 24;
                _iterator.f();
                return _context.finish(24);
              case 27:
                return _context.abrupt("return", html.replace(/#attacheloc:([\w]+)#/gm, function (match, id) {
                  if (_this.cache.attachments[id]) {
                    return _this.cache.attachments[id].url;
                  } else {
                    return match;
                  }
                }));
              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 21, 24, 27], [7, 14]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    html_defineProperty(html_assertThisInitialized(_this), "resolveContent", /*#__PURE__*/html_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var html, signature, signaturePassed, verifyRes, error, content;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this._contentResolveInProgress) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _this._contentResolveInProgress = true;
              html = _this.map.get('content');
              signature = _this.map.get('signature');
              signaturePassed = false;
              _context2.prev = 6;
              _context2.next = 9;
              return _this.editor.plugins.signature.verifySignature(html, signature);
            case 9:
              verifyRes = _context2.sent;
              if (verifyRes) {
                signaturePassed = true;
              } else {
                error = new WrongSignatureError('signature does not match the content');
                _this.editor.plugins.debugLogger.captureException(error);
                _this.setProps({
                  error: error
                });
              }
              _context2.next = 17;
              break;
            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](6);
              _this.editor.plugins.debugLogger.captureException(_context2.t0);
              _this.setProps({
                error: _context2.t0
              });
            case 17:
              if (signaturePassed) {
                _context2.next = 20;
                break;
              }
              _this._contentResolveInProgress = false;
              return _context2.abrupt("return");
            case 20:
              _context2.next = 22;
              return _this.resolveHtml(html);
            case 22:
              content = _context2.sent;
              _this.setProps({
                content: content
              });
              _this._contentResolveInProgress = false;
            case 25:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[6, 13]]);
    })));
    html_defineProperty(html_assertThisInitialized(_this), "onShowHeader", function () {
      var hidden = Boolean(_this.map.get('isHeaderHidden'));
      _this.map.set('isHeaderHidden', !hidden);
    });
    html_defineProperty(html_assertThisInitialized(_this), "onShowBorders", function () {
      var hidden = Boolean(_this.map.get('isBordersHidden'));
      _this.map.set('isBordersHidden', !hidden);
    });
    _this.cache = {
      attachments: {}
    };
    _this.addCanExecActions(['delete', 'backspace']);
    return _this;
  }
  html_createClass(HTMLBlot, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = html_get(html_getPrototypeOf(HTMLBlot.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      this.editor.store.observe(this.map, this.mapObserver);
      this.fullWidth.default = true;
      if (!this.props.content) {
        this.resolveContent();
      }
      this.render();
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = html_get(html_getPrototypeOf(HTMLBlot.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      this.editor.store.unobserve(this.map, this.mapObserver);
    }
  }, {
    key: "hasOriginLink",
    value: function hasOriginLink() {
      return Boolean(this.map.get('srcLink'));
    }
  }, {
    key: "getCachedAttachmentByURL",
    value: function getCachedAttachmentByURL(url) {
      var result = null;
      for (var attachment in this.cache.attachments) {
        if (attachment.url === url) {
          result = attachment;
          break;
        }
      }
      return result;
    }
  }, {
    key: "prepareLinks",
    value: function prepareLinks(html) {
      var tagRegex = /<a\s+([^>]*?\s+)?href="([^"]*)"(?:\s+)?([^>]*?[\s+]?)?>/gm;
      var targetRegex = /(\s+)?target="[^>]*?(\s+)?"(\s+)?/gm;
      return html.replace(tagRegex, function (match, attrs1, url, attrs2) {
        var attrs = (attrs1 ? attrs1.replace(targetRegex, '') : '') + (attrs2 ? attrs2.replace(targetRegex, '') : '');
        return '<a href="' + url + '" ' + attrs + ' target="_blank noopener">';
      });
    }
  }, {
    key: "getAttachmentIdsFromHtml",
    value: function getAttachmentIdsFromHtml(html) {
      var attachmentIds = [];
      html.replace(/#attacheloc:([\w]+)#/gm, function (match, id) {
        attachmentIds.push(id);
        return match;
      });
      return attachmentIds;
    }
  }, {
    key: "render",
    value: function render() {
      html_get(html_getPrototypeOf(HTMLBlot.prototype), "render", this).call(this);
      var htmlContainer = this.domNode.querySelector('.' + html_HTML_CONTAINER_CLASS);
      var editMode = this.editor.mode === this.editor.constructor.MODE_EDIT;
      var exportMode = this.editor.mode === this.editor.constructor.MODE_EXPORT;
      var name = this.map.get('name');
      if (!name) {
        name = this.editor.plugins.i18n.get('html.default_name');
      }
      var _this$props = this.props,
        content = _this$props.content,
        error = _this$props.error;
      var component;
      if (error) {
        var text = this.editor.plugins.i18n.get('html.unknown_error');
        if (error instanceof CryptoIncompatibleError) {
          text = this.editor.plugins.i18n.get('html.device_cant_display_content');
        } else if (error instanceof WrongSignatureError) {
          text = this.editor.plugins.i18n.get('html.wrong_signature');
        }
        component = (0,preact_module.h)("div", {
          className: "error"
        }, text);
      } else {
        component = (0,preact_module.h)(HTMLComponent, {
          classPrefix: html_HTML_CLASS,
          content: content,
          i18n: this.editor.plugins.i18n,
          lightBox: this.editor.plugins.lightBox,
          onImageEnterFullSize: this.onImageEnterFullSize
        });
      }
      (0,preact_module/* render */.sY)((0,preact_module.h)(CollapsibleContent, {
        name: name,
        wrapperClassName: HTML_WRAPPER_CLASS,
        headerClassName: HTML_HEADER_CLASS,
        bodyClassName: HTML_BODY_CLASS,
        blotMap: this.map,
        getSpecialBlotMenu: this.getSpecialBlotMenu,
        onMenuClickAction: this.onMenuClickAction,
        editMode: editMode,
        exportMode: exportMode,
        isBlotLocked: this.isBlotLocked,
        isHeaderHidden: this.map.get('isHeaderHidden'),
        isBordersHidden: this.map.get('isBordersHidden')
      }, component), htmlContainer);
    }
  }, {
    key: "onExportBlot",
    value: function onExportBlot() {
      if (!this.blotConfig.exportBlot) return;
      this.blotConfig.exportBlot(this.id, 'html');
    }
  }, {
    key: "onBlotMenuUpdatePosition",
    value: function onBlotMenuUpdatePosition(_ref3) {
      var left = _ref3.left,
        top = _ref3.top;
      if (this.fullwidthMenuMargin) {
        var correction = (this.fullwidthMenuMargin < 0 ? -3 : 0) - 25;
        left += this.fullwidthMenuMargin + correction;
      }
      return {
        left: left,
        top: top
      };
    }
  }, {
    key: "cloneSelf",
    value: function cloneSelf() {
      console.log('this.map.get(\'fullwidthMode\')', this.map.get('fullwidthMode'));
      var map = this.store.createMap();
      parchment_default().query(this.map.get('type')).initMap(map, this.store, {
        name: this.map.get('name'),
        content: this.map.get('content'),
        signature: this.map.get('signature'),
        srcLink: this.map.get('srcLink'),
        expanded: this.map.get('expanded'),
        mode: this.map.get('fullwidthMode'),
        isHeaderHidden: this.map.get('isHeaderHidden'),
        isBordersHidden: this.map.get('isBordersHidden')
      });
      return map.get('id');
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      var _this2 = this;
      var html = this.map.get('content');
      var hasCacheAttachments = false;
      if (!context.options || !context.options.noAttachments) {
        for (var id in this.cache.attachments) {
          context.addAttachment(this.cache.attachments[id]);
          hasCacheAttachments = true;
        }
      }
      var _ref4 = context.options || {},
        attachmentsByGlobalId = _ref4.attachmentsByGlobalId;
      if (!hasCacheAttachments && attachmentsByGlobalId) {
        for (var _id in attachmentsByGlobalId) {
          var _attachmentsByGlobalI = attachmentsByGlobalId[_id],
            url = _attachmentsByGlobalI.location,
            global_id = _attachmentsByGlobalI.globalId;
          this.cache.attachments[_id] = html_objectSpread(html_objectSpread({}, attachmentsByGlobalId[_id]), {}, {
            url: url,
            global_id: global_id
          });
          context.addAttachment(this.cache.attachments[_id]);
        }
      }
      var matches = html_toConsumableArray(html.matchAll(/#attacheloc:([\w]+)#/gm));
      matches.forEach(function (_ref5) {
        var _ref6 = html_slicedToArray(_ref5, 2),
          match = _ref6[0],
          id = _ref6[1];
        var url = context && context.getAttachmentPath && context.getAttachmentPath(_this2.cache.attachments[id]);
        if (!url && _this2.cache.attachments[id]) {
          url = _this2.cache.attachments[id].url;
        }
        if (!url) {
          url = match;
        }
        html = html.replace(match, url);
      });
      var node = this.domNode.cloneNode(true);
      var htmlContainer = node.querySelector('.' + HTML_BODY_CLASS);
      if (htmlContainer) {
        htmlContainer.innerHTML = html;
      }
      return node.outerHTML;
    }
  }, {
    key: "contextMenu",
    get: function get() {
      var menu = html_get(html_getPrototypeOf(HTMLBlot.prototype), "contextMenu", this);
      var i18n = this.editor.plugins.i18n;
      delete menu['copyBlocks'];
      menu['layout'] = (0,util/* mergeDeep */.Ee)(menu['layout'], {
        label: i18n.get('block_menu.layout'),
        index: -2,
        group: 0,
        action: false
      });
      if (this.map.get('expanded')) {
        // если сабменю меню стиля не определено миксинами, нужно его определить как объект
        if (!menu['layout'].submenu) {
          menu['layout'].submenu = {};
        }
        menu['layout'].submenu.showHeader = {
          label: i18n.get('block_menu.show_header'),
          index: 1,
          group: 0,
          action: 'onShowHeader',
          actionExec: false,
          icon: !Boolean(this.map.get('isHeaderHidden')) ? icons/* IconDone */.EZi : false,
          style: !Boolean(this.map.get('isHeaderHidden')) ? 'done' : 'undone'
        };
        menu['layout'].submenu.showBorders = {
          label: i18n.get('block_menu.show_borders'),
          index: 1,
          group: 0,
          action: 'onShowBorders',
          actionExec: false,
          icon: !Boolean(this.map.get('isBordersHidden')) ? icons/* IconDone */.EZi : false,
          style: !Boolean(this.map.get('isBordersHidden')) ? 'done' : 'undone'
        };
      }
      return menu;
    }
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      var params = html_get(html_getPrototypeOf(HTMLBlot.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
      var room = this.editor.options.serverRoom;
      return (0,util/* mergeDeep */.Ee)(params, {
        initParams: {
          name: this.map.get('name'),
          content: this.map.get('content'),
          signature: this.map.get('signature'),
          srcLink: this.map.get('srcLink'),
          mode: this.map.get('fullwidthMode'),
          isHeaderHidden: this.map.get('isHeaderHidden'),
          isBordersHidden: this.map.get('isBordersHidden'),
          room: room
        }
      });
    }
  }], [{
    key: "initMap",
    value: function initMap(map, store) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      map.set('type', 'html');
      map.set('name', params.name ? params.name : null);
      map.set('content', params.content ? params.content : '');
      map.set('signature', params.signature ? params.signature : '');
      map.set('srcLink', params.srcLink ? params.srcLink : null);
      map.set('expanded', true);
      map.set('fullwidthMode', params.mode !== false);
      map.set('isHeaderHidden', params.isHeaderHidden ? params.isHeaderHidden : null);
      map.set('isBordersHidden', params.isBordersHidden ? params.isBordersHidden : null);
    }
  }, {
    key: "create",
    value: function create(value) {
      var node = html_get(html_getPrototypeOf(HTMLBlot), "create", this).call(this);
      node.classList.add(html_HTML_CLASS);
      var htmlContainer = document.createElement('div');
      htmlContainer.setAttribute('contenteditable', false);
      htmlContainer.classList.add(html_HTML_CONTAINER_CLASS);
      node.appendChild(htmlContainer);
      return node;
    }
  }, {
    key: "createBlot",
    value: function createBlot(editor) {
      var blot = parchment_default().create('html');
      this.addCaretTrap(editor, blot.domNode);
      return blot;
    }
  }]);
  return HTMLBlot;
}(html_mixin(blockEmbed));
HTMLBlot.blotName = 'html';
HTMLBlot.tagName = 'NIMBUS-HTML';
HTMLBlot.allowedChildren = [];
/* harmony default export */ const html = (HTMLBlot);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim-end.js
var es_string_trim_end = __webpack_require__(48702);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/syntax/syntaxControl.js
function syntaxControl_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { syntaxControl_typeof = function _typeof(obj) { return typeof obj; }; } else { syntaxControl_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return syntaxControl_typeof(obj); }









function syntaxControl_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function syntaxControl_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function syntaxControl_createClass(Constructor, protoProps, staticProps) { if (protoProps) syntaxControl_defineProperties(Constructor.prototype, protoProps); if (staticProps) syntaxControl_defineProperties(Constructor, staticProps); return Constructor; }
function syntaxControl_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) syntaxControl_setPrototypeOf(subClass, superClass); }
function syntaxControl_setPrototypeOf(o, p) { syntaxControl_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return syntaxControl_setPrototypeOf(o, p); }
function syntaxControl_createSuper(Derived) { var hasNativeReflectConstruct = syntaxControl_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = syntaxControl_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = syntaxControl_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return syntaxControl_possibleConstructorReturn(this, result); }; }
function syntaxControl_possibleConstructorReturn(self, call) { if (call && (syntaxControl_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return syntaxControl_assertThisInitialized(self); }
function syntaxControl_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function syntaxControl_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function syntaxControl_getPrototypeOf(o) { syntaxControl_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return syntaxControl_getPrototypeOf(o); }





var SyntaxControl = /*#__PURE__*/function (_Component) {
  syntaxControl_inherits(SyntaxControl, _Component);
  var _super = syntaxControl_createSuper(SyntaxControl);
  function SyntaxControl(props) {
    syntaxControl_classCallCheck(this, SyntaxControl);
    return _super.call(this, props);
  }
  syntaxControl_createClass(SyntaxControl, [{
    key: "onClickItem",
    value: function onClickItem(item, event) {
      var blot = this.props.blot;
      item.action(item.actionParams);
      blot.onMenuWantsToClose();
      event.preventDefault();
      event.stopPropagation();
    }
  }, {
    key: "render",
    value: function render() {
      var blot = this.props.blot;
      var exportMode = blot.editor.mode === MODE_EXPORT;
      var language = blot.getLanguage();
      var menu = '';
      var specMenu = blot.getSpecialBlotMenu();
      var menuItems = getMenuItems(specMenu, {
        thisArg: this,
        onClick: this.onClickItem
      });
      if (blot.state.menuOpen) {
        menu = (0,preact_module.h)(popupMenu/* default */.Z, {
          closeOnEsc: true,
          addClassName: "with-language-submenu",
          anchorNode: blot.syntaxMenuIconNode,
          editor: blot.editor,
          menu: blot.getSpecialBlotMenu(),
          wantsToClose: blot.onMenuWantsToClose.bind(blot),
          anchorOptions: {
            boundariesElement: blot.editor.scrollingContainer
          }
        }, menuItems);
      }
      var menuBtn;
      if (blot.blotConfig.menuVisible !== false && !exportMode) {
        menuBtn = (0,preact_module.h)("span", {
          className: "syntax-control-btn",
          ref: blot.onSyntaxMenuIconRef,
          onMouseDown: blot.setRange.bind(blot),
          onClick: blot.onMenuClick
        }, (0,preact_module.h)(icons/* IconMoreVertical */.nqv, null));
      }
      var loadingSpinner = null;
      if (blot.props.hljsLoading) {
        loadingSpinner = (0,preact_module.h)("div", {
          className: "loading-spinner editor-loader-grey"
        });
      }
      if (blot && blot.isBlotLocked) {
        menuBtn = (0,preact_module.h)("span", {
          className: "syntax-control-btn"
        });
        menu = null;
      }
      var scWrap = 'syntax-control-wrap';
      if (exportMode) {
        scWrap = 'syntax-control-wrap no-margin';
      }
      return (0,preact_module.h)("div", {
        className: "syntax-control-wrapper",
        contentEditable: "false",
        onClick: this.props.onSyntaxControlClick
      }, (0,preact_module.h)("div", {
        className: scWrap,
        contentEditable: "false"
      }, loadingSpinner, (0,preact_module.h)("span", {
        className: "syntax-control-label"
      }, blot.languages[language]), menuBtn, menu));
    }
  }]);
  return SyntaxControl;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/syntax/languages/c-like.js

function Clike(hljs) {
  function optional(s) {
    return '(?:' + s + ')?';
  }
  var DECLTYPE_AUTO_RE = 'decltype\\(auto\\)';
  var NAMESPACE_RE = '[a-zA-Z_]\\w*::';
  var TEMPLATE_ARGUMENT_RE = '<.*?>';
  var FUNCTION_TYPE_RE = '(' + DECLTYPE_AUTO_RE + '|' + optional(NAMESPACE_RE) + '[a-zA-Z_]\\w*' + optional(TEMPLATE_ARGUMENT_RE) + ')';
  var CPP_PRIMITIVE_TYPES = {
    className: 'keyword',
    begin: '\\b[a-z\\d_]*_t\\b'
  };

  // https://en.cppreference.com/w/cpp/language/escape
  // \\ \x \xFF \u2837 \u00323747 \374
  var CHARACTER_ESCAPES = '\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)';
  var STRINGS = {
    className: 'string',
    variants: [{
      begin: '(u8?|U|L)?"',
      end: '"',
      illegal: '\\n',
      contains: [hljs.BACKSLASH_ESCAPE]
    }, {
      begin: '(u8?|U|L)?\'(' + CHARACTER_ESCAPES + "|.)",
      end: '\'',
      illegal: '.'
    }, {
      begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\((?:.|\n)*?\)\1"/
    }]
  };
  var NUMBERS = {
    className: 'number',
    variants: [{
      begin: '\\b(0b[01\']+)'
    }, {
      begin: '(-?)\\b([\\d\']+(\\.[\\d\']*)?|\\.[\\d\']+)(u|U|l|L|ul|UL|f|F|b|B)'
    }, {
      begin: '(-?)(\\b0[xX][a-fA-F0-9\']+|(\\b[\\d\']+(\\.[\\d\']*)?|\\.[\\d\']+)([eE][-+]?[\\d\']+)?)'
    }],
    relevance: 0
  };
  var PREPROCESSOR = {
    className: 'meta',
    begin: /#\s*[a-z]+\b/,
    end: /$/,
    keywords: {
      'meta-keyword': 'if else elif endif define undef warning error line ' + 'pragma _Pragma ifdef ifndef include'
    },
    contains: [{
      begin: /\\\n/,
      relevance: 0
    }, hljs.inherit(STRINGS, {
      className: 'meta-string'
    }), {
      className: 'meta-string',
      begin: /<.*?>/,
      end: /$/,
      illegal: '\\n'
    }, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE]
  };
  var TITLE_MODE = {
    className: 'title',
    begin: optional(NAMESPACE_RE) + hljs.IDENT_RE,
    relevance: 0
  };
  var FUNCTION_TITLE = optional(NAMESPACE_RE) + hljs.IDENT_RE + '\\s*\\(';
  var CPP_KEYWORDS = {
    keyword: 'int float while private char char8_t char16_t char32_t catch import module export virtual operator sizeof ' + 'dynamic_cast|10 typedef const_cast|10 const for static_cast|10 union namespace ' + 'unsigned long volatile static protected bool template mutable if public friend ' + 'do goto auto void enum else break extern using asm case typeid wchar_t ' + 'short reinterpret_cast|10 default double register explicit signed typename try this ' + 'switch continue inline delete alignas alignof constexpr consteval constinit decltype ' + 'concept co_await co_return co_yield requires ' + 'noexcept static_assert thread_local restrict final override ' + 'atomic_bool atomic_char atomic_schar ' + 'atomic_uchar atomic_short atomic_ushort atomic_int atomic_uint atomic_long atomic_ulong atomic_llong ' + 'atomic_ullong new throw return ' + 'and and_eq bitand bitor compl not not_eq or or_eq xor xor_eq',
    built_in: 'std string wstring cin cout cerr clog stdin stdout stderr stringstream istringstream ostringstream ' + 'auto_ptr deque list queue stack vector map set bitset multiset multimap unordered_set ' + 'unordered_map unordered_multiset unordered_multimap array shared_ptr abort terminate abs acos ' + 'asin atan2 atan calloc ceil cosh cos exit exp fabs floor fmod fprintf fputs free frexp ' + 'fscanf future isalnum isalpha iscntrl isdigit isgraph islower isprint ispunct isspace isupper ' + 'isxdigit tolower toupper labs ldexp log10 log malloc realloc memchr memcmp memcpy memset modf pow ' + 'printf putchar puts scanf sinh sin snprintf sprintf sqrt sscanf strcat strchr strcmp ' + 'strcpy strcspn strlen strncat strncmp strncpy strpbrk strrchr strspn strstr tanh tan ' + 'vfprintf vprintf vsprintf endl initializer_list unique_ptr _Bool complex _Complex imaginary _Imaginary',
    literal: 'true false nullptr NULL'
  };
  var EXPRESSION_CONTAINS = [CPP_PRIMITIVE_TYPES, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, NUMBERS, STRINGS];
  var EXPRESSION_CONTEXT = {
    // This mode covers expression context where we can't expect a function
    // definition and shouldn't highlight anything that looks like one:
    // `return some()`, `else if()`, `(x*sum(1, 2))`
    variants: [{
      begin: /=/,
      end: /;/
    }, {
      begin: /\(/,
      end: /\)/
    }, {
      beginKeywords: 'new throw return else',
      end: /;/
    }],
    keywords: CPP_KEYWORDS,
    contains: EXPRESSION_CONTAINS.concat([{
      begin: /\(/,
      end: /\)/,
      keywords: CPP_KEYWORDS,
      contains: EXPRESSION_CONTAINS.concat(['self']),
      relevance: 0
    }]),
    relevance: 0
  };
  var FUNCTION_DECLARATION = {
    className: 'function',
    begin: '(' + FUNCTION_TYPE_RE + '[\\*&\\s]+)+' + FUNCTION_TITLE,
    returnBegin: true,
    end: /[{;=]/,
    excludeEnd: true,
    keywords: CPP_KEYWORDS,
    illegal: /[^\w\s\*&:<>]/,
    contains: [{
      // to prevent it from being confused as the function title
      begin: DECLTYPE_AUTO_RE,
      keywords: CPP_KEYWORDS,
      relevance: 0
    }, {
      begin: FUNCTION_TITLE,
      returnBegin: true,
      contains: [TITLE_MODE],
      relevance: 0
    }, {
      className: 'params',
      begin: /\(/,
      end: /\)/,
      keywords: CPP_KEYWORDS,
      relevance: 0,
      contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, STRINGS, NUMBERS, CPP_PRIMITIVE_TYPES,
      // Count matching parentheses.
      {
        begin: /\(/,
        end: /\)/,
        keywords: CPP_KEYWORDS,
        relevance: 0,
        contains: ['self', hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, STRINGS, NUMBERS, CPP_PRIMITIVE_TYPES]
      }]
    }, CPP_PRIMITIVE_TYPES, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, PREPROCESSOR]
  };
  return {
    aliases: ['c', 'cc', 'h', 'c++', 'h++', 'hpp', 'hh', 'hxx', 'cxx'],
    keywords: CPP_KEYWORDS,
    // the base c-like language will NEVER be auto-detected, rather the
    // derivitives: c, c++, arduino turn auto-detect back on for themselves
    disableAutodetect: true,
    illegal: '</',
    contains: [].concat(EXPRESSION_CONTEXT, FUNCTION_DECLARATION, EXPRESSION_CONTAINS, [PREPROCESSOR, {
      begin: '\\b(deque|list|queue|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array)\\s*<',
      end: '>',
      keywords: CPP_KEYWORDS,
      contains: ['self', CPP_PRIMITIVE_TYPES]
    }, {
      begin: hljs.IDENT_RE + '::',
      keywords: CPP_KEYWORDS
    }, {
      className: 'class',
      beginKeywords: 'class struct',
      end: /[{;:]/,
      contains: [{
        begin: /</,
        end: />/,
        contains: ['self']
      },
      // skip generic stuff
      hljs.TITLE_MODE]
    }]),
    exports: {
      preprocessor: PREPROCESSOR,
      strings: STRINGS,
      keywords: CPP_KEYWORDS
    }
  };
}
// EXTERNAL MODULE: ./node_modules/detect-node/browser.js
var detect_node_browser = __webpack_require__(24787);
var browser_default = /*#__PURE__*/__webpack_require__.n(detect_node_browser);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/syntax/syntaxCM.js
function syntaxCM_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { syntaxCM_typeof = function _typeof(obj) { return typeof obj; }; } else { syntaxCM_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return syntaxCM_typeof(obj); }












function syntaxCM_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function syntaxCM_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function syntaxCM_createClass(Constructor, protoProps, staticProps) { if (protoProps) syntaxCM_defineProperties(Constructor.prototype, protoProps); if (staticProps) syntaxCM_defineProperties(Constructor, staticProps); return Constructor; }
function syntaxCM_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) syntaxCM_setPrototypeOf(subClass, superClass); }
function syntaxCM_setPrototypeOf(o, p) { syntaxCM_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return syntaxCM_setPrototypeOf(o, p); }
function syntaxCM_createSuper(Derived) { var hasNativeReflectConstruct = syntaxCM_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = syntaxCM_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = syntaxCM_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return syntaxCM_possibleConstructorReturn(this, result); }; }
function syntaxCM_possibleConstructorReturn(self, call) { if (call && (syntaxCM_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return syntaxCM_assertThisInitialized(self); }
function syntaxCM_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function syntaxCM_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function syntaxCM_getPrototypeOf(o) { syntaxCM_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return syntaxCM_getPrototypeOf(o); }
function syntaxCM_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function syntaxCM_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function syntaxCM_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { syntaxCM_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { syntaxCM_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




var hljsPromise, hljsModule, cmPromise, cmModule, cmLanguages, CodemirrorBinding, loadScriptsPromise;
function loadHljsModule() {
  return _loadHljsModule.apply(this, arguments);
}
function _loadHljsModule() {
  _loadHljsModule = syntaxCM_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var initial, _yield$hljsPromise, hljs;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            initial = false;
            if (!hljsPromise) {
              initial = true;
              hljsPromise = Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 60311, 23));
            }
            _context.next = 4;
            return hljsPromise;
          case 4:
            _yield$hljsPromise = _context.sent;
            hljs = _yield$hljsPromise.default;
            if (initial) {
              hljsModule = hljs;
              hljsModule.registerLanguage('c', Clike);
            }
            return _context.abrupt("return", hljs);
          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadHljsModule.apply(this, arguments);
}
function loadCmModule() {
  return _loadCmModule.apply(this, arguments);
}
function _loadCmModule() {
  _loadCmModule = syntaxCM_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var initial, _yield$cmPromise, cmLangs, cm_module, cmy_module;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            initial = false;
            if (!cmPromise) {
              if (!(browser_default())) {
                initial = true;
                cmPromise = __webpack_require__.e(/* import() | syntax_codemirror.js */ 928).then(__webpack_require__.bind(__webpack_require__, 14775));
              }
            }
            if (!initial) {
              _context2.next = 13;
              break;
            }
            _context2.next = 5;
            return cmPromise;
          case 5:
            _yield$cmPromise = _context2.sent;
            cmLangs = _yield$cmPromise.cmLangs;
            cm_module = _yield$cmPromise.cm_module;
            cmy_module = _yield$cmPromise.cmy_module;
            cmLanguages = cmLangs;
            cmModule = cm_module;
            CodemirrorBinding = cmy_module;
            return _context2.abrupt("return", cm_module);
          case 13:
            return _context2.abrupt("return", false);
          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _loadCmModule.apply(this, arguments);
}
if ((browser_default())) {
  hljsModule = __webpack_require__(60311);
  hljsModule.registerLanguage('c', Clike);
}
var SyntaxCM = /*#__PURE__*/function (_Component) {
  syntaxCM_inherits(SyntaxCM, _Component);
  var _super = syntaxCM_createSuper(SyntaxCM);
  function SyntaxCM(props) {
    var _this;
    syntaxCM_classCallCheck(this, SyntaxCM);
    _this = _super.call(this, props);
    syntaxCM_defineProperty(syntaxCM_assertThisInitialized(_this), "onStopDragging", function (event) {
      _this.render();
    });
    syntaxCM_defineProperty(syntaxCM_assertThisInitialized(_this), "onTextAreaRef", function (node) {
      _this.textAreaNode = node;
    });
    _this.map = props.map;
    _this.store = props.store;
    _this.domNode = props.domNode;
    _this.floatingToolbarDisabled = true;
    return _this;
  }
  syntaxCM_createClass(SyntaxCM, [{
    key: "afterLoadScripts",
    value: function afterLoadScripts() {
      var blot = this.props.blot;
      var codeBlot = blot.editor.findById(blot.id);
      if (codeBlot) {
        this.render();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var blot = this.props.blot;
      blot.language = blot.getLanguage();
      if (!(browser_default())) {
        if (!hljsModule || !cmModule) {
          if (!loadScriptsPromise) {
            loadScriptsPromise = Promise.all([loadCmModule(), loadHljsModule()]);
          }
          loadScriptsPromise.then(function () {
            _this2.props.onLoadModules(hljsModule);
            _this2.afterLoadScripts();
            _this2.initCM();
          });
        } else {
          this.props.onLoadModules(hljsModule);
          this.initCM();
        }
      } else {
        this.props.onLoadModules(hljsModule);
      }
      blot.editor.on('lockBlot', blot.onLockChange);
      blot.editor.on('unlockBlot', blot.onLockChange);
      blot.editor.on('set-theme', blot.onThemeChange);
      blot.editor.on('grid-resize-end', this.onStopDragging);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var blot = this.props.blot;
      blot.editor.off('lockBlot', blot.onLockChange);
      blot.editor.off('unlockBlot', blot.onLockChange);
      blot.editor.off('set-theme', blot.onThemeChange);
      blot.editor.off('grid-resize-end', this.onStopDragging);
    }
  }, {
    key: "render",
    value: function render() {
      var blot = this.props.blot;
      if ((browser_default()) && blot.editor.mode === MODE_EXPORT) {
        return '{EXPORT_CODE}';
      }
      var taId = "syntax-cm-" + blot.id;
      if (cmModule && hljsModule) {
        if (blot.instanceCM && blot.editor.mode === MODE_EDIT) {
          blot.instanceCM.refresh();
        }
      }
      return (0,preact_module.h)("textarea", {
        className: "syntax-text-anchor",
        key: taId,
        ref: this.onTextAreaRef
      });
    }
  }, {
    key: "getCmTextArea",
    get: function get() {
      return this.textAreaNode;
    }
  }, {
    key: "initCM",
    value: function initCM() {
      var _this3 = this;
      var blot = this.props.blot;
      if (!blot.instanceCM && cmModule && hljsModule) {
        var textArea = this.getCmTextArea;
        if (textArea) {
          var editorTheme = blot.editor.plugins.editorStyle.getTheme();
          var theme = blot.getTheme();
          if (theme === 'default') {
            theme = blot.cmThemes[editorTheme];
          }
          var wordWrap = this.map.get('wrap');
          var lineWrapping = false;
          if (wordWrap) {
            lineWrapping = true;
          }
          var lines = this.map.get('lineNumbers');
          var lineNumbers = false;
          if (lines) {
            lineNumbers = true;
          }
          this.lineNumbers = lineNumbers;
          var readOnly = true;
          if (blot.editor.mode === MODE_EDIT) {
            if (!blot.isBlotLocked) {
              readOnly = false;
            }
          }
          var instanceCM = cmModule.fromTextArea(textArea, {
            mode: blot.mimes[blot.language],
            tabSize: 2,
            theme: theme,
            styleActiveLine: true,
            lineNumbers: lineNumbers,
            lineWrapping: lineWrapping,
            readOnly: readOnly,
            resetSelectionOnContextMenu: false,
            viewportMargin: Infinity,
            autofocus: false,
            // Для десктопных браузеров textarea идет по умолчанию
            // для мобильных браузеров по умолчанию contenteditable, но под него блок кода не оптимизирован,
            // поэтому фиксируем textarea
            inputStyle: 'textarea',
            dragDrop: false // отключаем для того, чтобы корректно работал drag&drop локальных файлов
          });

          this.props.onInitCM(instanceCM);
          var cursor = this.domNode.getElementsByClassName('CodeMirror-cursors')[0];
          if (readOnly) {
            cursor.classList.add('nocursor');
          } else {
            cursor.classList.remove('nocursor');
          }
          var gutters = this.domNode.getElementsByClassName('CodeMirror-gutters')[0];
          gutters.setAttribute('contentEditable', false);
          if (!this.binding) {
            var yText = this.map.get('characters');
            var oldToString = yText.toString;
            // заменяем toString для обратной совместимости с предидущей реализацией syntax блота
            // мы должны преобразовать linebreak -> \n
            yText.toString = function () {
              return blot.getText();
            };
            this.binding = new CodemirrorBinding(yText, instanceCM);
            yText.toString = oldToString;
          }
          if (blot.language === 'auto') {
            var text = blot.getText();
            if (text !== '') {
              blot.autoDetect(text);
            }
          }
          blot.setCursorTo('goDocEnd', {
            focused: true
          });
        }
      }
      if (blot.instanceCM) {
        blot.instanceCM.on("change", function () {
          var text = _this3.binding.cmDoc.getValue();
          blot.autoDetect(text);
        });
        blot.instanceCM.on("copy", function (cm, event) {
          event.codemirrorIgnore = true;
        });
        blot.instanceCM.on("cut", function (cm, event) {
          event.codemirrorIgnore = true;
        });
        blot.instanceCM.on("blur", function (e) {
          var cursor = _this3.binding.cmDoc.getCursor();
          if (e.getSelection()) {
            e.setSelection({
              line: cursor.line,
              ch: cursor.ch
            }, null, {
              scroll: false
            });
          }
        });
      }
    }
  }]);
  return SyntaxCM;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/lodash.escape/index.js
var lodash_escape = __webpack_require__(66213);
var lodash_escape_default = /*#__PURE__*/__webpack_require__.n(lodash_escape);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/syntax/syntax.js
function syntax_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function syntax_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { syntax_ownKeys(Object(source), true).forEach(function (key) { syntax_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { syntax_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function syntax_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = syntax_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function syntax_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { syntax_typeof = function _typeof(obj) { return typeof obj; }; } else { syntax_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return syntax_typeof(obj); }
function syntax_slicedToArray(arr, i) { return syntax_arrayWithHoles(arr) || syntax_iterableToArrayLimit(arr, i) || syntax_unsupportedIterableToArray(arr, i) || syntax_nonIterableRest(); }
function syntax_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function syntax_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function syntax_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function syntax_toConsumableArray(arr) { return syntax_arrayWithoutHoles(arr) || syntax_iterableToArray(arr) || syntax_unsupportedIterableToArray(arr) || syntax_nonIterableSpread(); }
function syntax_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function syntax_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return syntax_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return syntax_arrayLikeToArray(o, minLen); }
function syntax_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function syntax_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return syntax_arrayLikeToArray(arr); }
function syntax_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }





























function syntax_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function syntax_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function syntax_createClass(Constructor, protoProps, staticProps) { if (protoProps) syntax_defineProperties(Constructor.prototype, protoProps); if (staticProps) syntax_defineProperties(Constructor, staticProps); return Constructor; }
function syntax_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { syntax_get = Reflect.get; } else { syntax_get = function _get(target, property, receiver) { var base = syntax_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return syntax_get(target, property, receiver || target); }
function syntax_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = syntax_getPrototypeOf(object); if (object === null) break; } return object; }
function syntax_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) syntax_setPrototypeOf(subClass, superClass); }
function syntax_setPrototypeOf(o, p) { syntax_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return syntax_setPrototypeOf(o, p); }
function syntax_createSuper(Derived) { var hasNativeReflectConstruct = syntax_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = syntax_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = syntax_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return syntax_possibleConstructorReturn(this, result); }; }
function syntax_possibleConstructorReturn(self, call) { if (call && (syntax_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return syntax_assertThisInitialized(self); }
function syntax_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function syntax_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function syntax_getPrototypeOf(o) { syntax_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return syntax_getPrototypeOf(o); }
function syntax_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






























var LANGUAGE_KEY = 'data-language';
var THEME_KEY = 'data-theme';
var SYNTAXCM_CONTAINER_CLASS = 'syntax-cm-container';
var LANGUAGE_HTML_ATTR = 'data-nimbus-language';
var THEME_HTML_ATTR = 'data-nimbus-theme';
var syntax_hljsModule;
var syntax_mixin = mix([commentable, withCaption, blotLock, embeddable, focusable, selectable, dropAcceptor, draggable, executable, basic]);
var Syntax = /*#__PURE__*/function (_mixin) {
  syntax_inherits(Syntax, _mixin);
  var _super = syntax_createSuper(Syntax);
  function Syntax(domNode) {
    var _this;
    syntax_classCallCheck(this, Syntax);
    _this = _super.call(this, domNode);
    syntax_defineProperty(syntax_assertThisInitialized(_this), "onSyntaxMenuIconRef", function (node) {
      _this.syntaxMenuIconNode = node;
    });
    syntax_defineProperty(syntax_assertThisInitialized(_this), "onMenuClick", function (event) {
      event.preventDefault();
      event.stopPropagation();
      _this.state.menuOpen = true;
      _this.render();
    });
    syntax_defineProperty(syntax_assertThisInitialized(_this), "onChooseLanguage", function (_ref) {
      var language = _ref.language;
      _this.setLanguage(language);
    });
    syntax_defineProperty(syntax_assertThisInitialized(_this), "onChooseTheme", function (_ref2) {
      var theme = _ref2.theme;
      _this.setTheme(theme);
    });
    syntax_defineProperty(syntax_assertThisInitialized(_this), "changeWordWrap", function () {
      var currentState = _this.map.get('wrap');
      _this.map.set('wrap', !currentState);
      _this.instanceCM.setOption("lineWrapping", !currentState);
    });
    syntax_defineProperty(syntax_assertThisInitialized(_this), "changeLinesNumbers", function () {
      var currentState = _this.map.get('lineNumbers');
      _this.map.set('lineNumbers', !currentState);
      _this.instanceCM.setOption("lineNumbers", !currentState);
      _this.lineNumbers = !currentState;
    });
    syntax_defineProperty(syntax_assertThisInitialized(_this), "changeTheme", function (theme) {
      _this.map.set('theme', theme);
    });
    syntax_defineProperty(syntax_assertThisInitialized(_this), "onInitCM", function (instanceCM) {
      _this.instanceCM = instanceCM;
    });
    syntax_defineProperty(syntax_assertThisInitialized(_this), "onSyntaxControlClick", function (event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (_this.editor.mode === MODE_EDIT && !_this.blotConfig.dontHandleHeaderCkick) {
        _this.setCursorTo('goDocStart');
      }
    });
    syntax_defineProperty(syntax_assertThisInitialized(_this), "onLoadModules", function (hljs) {
      syntax_hljsModule = hljs;
    });
    syntax_defineProperty(syntax_assertThisInitialized(_this), "onCMFocus", function () {
      if (_this.domNode.classList.contains('syntax-cm-without-focus')) {
        _this.domNode.classList.remove('syntax-cm-without-focus');
      }
    });
    syntax_defineProperty(syntax_assertThisInitialized(_this), "onCMBlur", function () {
      if (_this.props.focused || _this.props.selected) {
        if (!_this.domNode.classList.contains('syntax-cm-without-focus')) {
          _this.domNode.classList.add('syntax-cm-without-focus');
        }
      }
    });
    syntax_defineProperty(syntax_assertThisInitialized(_this), "mapObserver", function (event) {
      _this.render();
    });
    syntax_defineProperty(syntax_assertThisInitialized(_this), "onThemeChange", function (event) {
      var editorTheme = _this.editor.plugins.editorStyle.getTheme();
      var theme = _this.getTheme();
      if (theme === 'default' && _this.cmThemes[editorTheme]) {
        theme = _this.cmThemes[editorTheme];
      }
      if (_this.instanceCM) {
        _this.instanceCM.setOption("theme", theme);
      }
    });
    syntax_defineProperty(syntax_assertThisInitialized(_this), "onLockChange", function (event) {
      var readOnly = true;
      if (_this.editor.mode === MODE_EDIT) {
        if (!_this.isBlotLocked) {
          readOnly = false;
        }
      }
      _this.instanceCM.setOption("readOnly", readOnly);
      var cursor = _this.domNode.getElementsByClassName('CodeMirror-cursors')[0];
      if (readOnly) {
        cursor.classList.add('nocursor');
      } else {
        cursor.classList.remove('nocursor');
      }
    });
    _this.hasCustomSelection = true;
    _this.languages = {
      plaintext: 'Plain Text',
      vbnet: 'Highlight',
      x86asm: 'Assembly (x86)',
      asciidoc: 'AsciiDoc',
      javascript: 'Javascript',
      cpp: 'C++',
      cs: 'C#',
      c: 'C',
      scss: 'CSS/SCSS',
      xml: 'HTML/XML',
      json: 'JSON',
      java: 'Java',
      kotlin: 'Kotlin',
      typescript: 'Typescript',
      markdown: 'Markdown',
      php: 'PHP',
      python: 'Python',
      ruby: 'Ruby',
      sql: 'SQL',
      bash: 'Bash',
      shell: 'Shell',
      powershell: 'PowerShell',
      delphi: 'Pascal',
      swift: 'Swift',
      lua: 'Lua',
      perl: 'Perl',
      vbscript: 'Vbscript',
      yaml: 'YAML',
      apache: 'Apache',
      julia: 'Julia',
      rust: 'Rust',
      go: 'Go',
      dart: 'Dart'
    };
    _this.themes = {
      "default": "Default",
      "darcula": "Darcula",
      "mbo": "MBO",
      "mdn-like": "MDN",
      "monokai": "Monokai",
      "neat": "Neat",
      "neo": "NEO",
      "nord": "Nord",
      "yeti": "Yeti",
      "yonce": "Yonce",
      "zenburn": "Zenburn"
    };
    _this.cmThemes = {
      light: "default",
      dark: "monokai",
      "brand-dark-ios": "monokai"
    };
    _this.mimes = {
      plaintext: null,
      vbnet: 'text/x-vb',
      x86asm: {
        name: "gas",
        architecture: "x86"
      },
      asciidoc: 'asciidoc',
      javascript: 'text/javascript',
      cpp: 'text/x-c++src',
      cs: 'text/x-csharp',
      c: 'text/x-csrc',
      scss: 'text/x-scss',
      xml: 'text/html',
      json: 'application/json',
      java: 'text/x-java',
      kotlin: 'text/x-kotlin',
      typescript: 'text/typescript',
      markdown: 'text/x-markdown',
      php: 'text/x-php',
      python: 'text/x-python',
      ruby: 'text/x-ruby',
      sql: 'text/x-sql',
      bash: 'text/x-sh',
      shell: 'text/x-sh',
      powershell: 'application/x-powershell',
      delphi: 'text/x-pascal',
      swift: 'text/x-swift',
      lua: 'text/x-lua',
      perl: 'text/x-perl',
      vbscript: 'text/vbscript',
      yaml: 'text/x-yaml',
      apache: 'apache',
      julia: 'text/x-julia',
      rust: 'text/x-rustsrc',
      go: 'text/x-go',
      dart: 'application/dart'
    };
    _this.relevance = {
      min: 1,
      max: 5,
      textLength: 60
    };
    _this.relevanceLangs = {
      "scss": 2,
      "lua": 3,
      "powershell": 3,
      "markdown": 1,
      "vbscript": 3,
      'apache': 3,
      'yaml': 3,
      'julia': 3
    };
    _this.language = 'auto';
    _this.domNode.classList.add('editor-syntax');
    _this.domNode.setAttribute('spellcheck', false);
    _this.allowUpdate = true;
    _this.focusOutRange = false;
    _this.floatingToolbarDisabled = true;
    _this.state = {
      menuOpen: false
    };
    _this.syntaxMenuIconNode = null;
    _this.addCanExecActions([].concat(syntax_toConsumableArray(textLine.canExecActions), ['select-all']));
    _this.processCutWithPlugin = true;
    return _this;
  }
  syntax_createClass(Syntax, [{
    key: "isCodeMirrorEnabled",
    get: function get() {
      var res = true;
      if (this.blotConfig && this.blotConfig.highlight === false) {
        res = false;
      }
      return res;
    }
  }, {
    key: "onFocusableFocus",
    value: function onFocusableFocus() {
      if (syntax_get(syntax_getPrototypeOf(Syntax.prototype), "onFocusableFocus", this)) {
        syntax_get(syntax_getPrototypeOf(Syntax.prototype), "onFocusableFocus", this).call(this);
      }
      var range = this.editor.scroll.selection.getRange();
      var reversed = range && range[1] && range[1].reversed;
      if (this.language === 'auto' && !reversed) {
        this.setCursorTo();
      }
    }
  }, {
    key: "setCursorTo",
    value: function setCursorTo() {
      var _this2 = this;
      var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // pos = goDocEnd/goDocStart
      if (this.instanceCM) {
        // установка курсора в код. таймаут как фикс для фаервокса
        setTimeout(function () {
          if (params.focused && !_this2.props.focused) {
            return;
          }
          _this2.instanceCM.focus();
          if (pos) {
            _this2.instanceCM.execCommand(pos);
          }
        }, 50);
      }
    }
  }, {
    key: "setCursorToCM",
    value: function setCursorToCM() {
      var line = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var ch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.instanceCM.focus();
      this.instanceCM.setCursor({
        line: line,
        ch: ch
      });
    }

    /**
     * Проверяем состояние каптиона и ставим фокус в кодмиррор,
     * если каптион перехватывает фокус на себя при создании блота
    */
  }, {
    key: "checkCaptionFocus",
    value: function checkCaptionFocus() {
      var wrapper = this.getWrapper();
      var caption = wrapper.getInnerTextLine();
      if (!caption.props.show && caption.props.hiding) {
        this.onFocusableFocus();
      }
    }
  }, {
    key: "autoDetect",
    value: function autoDetect() {
      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (text.trim() === '') {
        return;
      }
      if (this.language !== 'plaintext') {
        var highlighted;
        var relevance;
        if (this.language === 'auto') {
          if (syntax_hljsModule) {
            highlighted = syntax_hljsModule.highlightAuto(text, Object.keys(this.languages));
            if (text.startsWith('<?php') && highlighted.language !== 'php') {
              highlighted.language = 'php';
            }
            if (text.length <= this.relevance.textLength) {
              relevance = this.relevance.min;
            } else {
              relevance = this.relevance.max;
              if (this.relevanceLangs[highlighted.language]) {
                relevance = this.relevanceLangs[highlighted.language];
              }
            }
            var language = highlighted.language;
            if (highlighted.relevance <= relevance) {
              language = 'plaintext';
            }
            this.setLanguage(language, true);
          }
        }
      }
    }
  }, {
    key: "formatAt",
    value: function formatAt() {
      var _this$getInnerTextLin;
      return (_this$getInnerTextLin = this.getInnerTextLine()).formatAt.apply(_this$getInnerTextLin, arguments);
    }
  }, {
    key: "setRange",
    value: function setRange() {
      if (this.focusOutRange) return;
      var _this$editor$scroll$s = this.editor.scroll.selection.getRange(),
        _this$editor$scroll$s2 = syntax_slicedToArray(_this$editor$scroll$s, 1),
        range = _this$editor$scroll$s2[0];
      this.focusOutRange = range;
    }
  }, {
    key: "restoreRange",
    value: function restoreRange() {
      this.focusableFocus();
      if (syntax_typeof(this.focusOutRange) == "object") {
        this.editor.scroll.selection.setRange(this.focusOutRange);
      }
      this.focusOutRange = false;
    }
  }, {
    key: "onMenuWantsToClose",
    value: function onMenuWantsToClose() {
      this.state.menuOpen = false;
      this.render();
      this.restoreRange();
    }
  }, {
    key: "getSpecialBlotMenu",
    value: function getSpecialBlotMenu() {
      var _this3 = this;
      var i18n = this.editor.plugins.i18n;
      var menu = {
        'copy-code-to-clipboard': {
          label: i18n.get('copy.copy_to_clipboard'),
          index: 1,
          action: this.copyToClipboard.bind(this)
        },
        'syntax-word-wrap': {
          label: i18n.get('syntax.menu.' + (this.map.get('wrap') ? 'unwrap' : 'wrap')),
          index: 2,
          action: this.changeWordWrap
        },
        'syntax-line-numbers': {
          label: i18n.get('syntax.menu.' + (this.map.get('lineNumbers') ? 'lineNumbersOff' : 'lineNumbersOn')),
          index: 2,
          action: this.changeLinesNumbers
        }
      };
      if (this.editor.mode === this.editor.constructor.MODE_EDIT) {
        var currentLanguageKey = this.getLanguage();
        var languagesSubMenu = {};
        Object.keys(this.languages) //get keys
        .sort(function (a, b) {
          return _this3.languages[a].localeCompare(_this3.languages[b]);
        }) //sort alphabeticaly
        .forEach(function (langKey, langIndex) {
          //create langs subMenu
          var langTitle = _this3.languages[langKey];
          languagesSubMenu['lang_' + langKey] = {
            label: langTitle,
            index: langIndex,
            group: 0,
            action: _this3.onChooseLanguage,
            actionParams: {
              language: langKey
            },
            isActive: currentLanguageKey === langKey
          };
        });
        menu.language = {
          label: i18n.get('syntax.menu.language'),
          index: 0,
          submenuOptions: {
            anchorOptions: {
              boundariesElement: this.editor.getScrollingContainer()
            }
          },
          submenu: languagesSubMenu,
          badge: this.languages[currentLanguageKey]
        };
        var currentThemeKey = this.getTheme();
        var themeSubMenu = {};
        Object.keys(this.themes).sort(function (a, b) {
          return _this3.themes[a].localeCompare(_this3.themes[b]);
        }).forEach(function (themeKey, themeIndex) {
          var activeIcon = icons/* IconEmpty */.Zlx;
          if (currentThemeKey === themeKey) {
            activeIcon = icons/* IconDone */.EZi;
          }
          var themeTitle = _this3.themes[themeKey];
          themeSubMenu['theme_' + themeKey] = {
            label: themeTitle,
            index: themeIndex,
            group: 0,
            action: _this3.onChooseTheme,
            actionParams: {
              theme: themeKey
            },
            isActive: currentThemeKey === themeKey,
            icon: activeIcon
          };
        });
        menu.themes = {
          label: i18n.get('syntax.menu.theme'),
          index: 0,
          submenuOptions: {
            anchorOptions: {
              boundariesElement: this.editor.getScrollingContainer()
            }
          },
          submenu: themeSubMenu,
          badge: this.themes[currentThemeKey]
        };
      }
      return menu;
    }
  }, {
    key: "render",
    value: function render() {
      syntax_get(syntax_getPrototypeOf(Syntax.prototype), "render", this).call(this);
      var wrapper = this.getWrapper();
      if (wrapper) {
        wrapper.render();
      }
      if (this.props.focused || this.props.selected) {
        var isCMHasFocus = this.instanceCM && this.instanceCM.hasFocus();
        if (!isCMHasFocus) {
          if (!this.domNode.classList.contains('syntax-cm-without-focus')) {
            this.domNode.classList.add('syntax-cm-without-focus');
          }
        } else {
          if (this.domNode.classList.contains('syntax-cm-without-focus')) {
            this.domNode.classList.remove('syntax-cm-without-focus');
          }
        }
      } else {
        if (this.domNode.classList.contains('syntax-cm-without-focus')) {
          this.domNode.classList.remove('syntax-cm-without-focus');
        }
      }
      if (this.domNode.getAttribute(LANGUAGE_HTML_ATTR) !== this.map.get(LANGUAGE_KEY)) {
        this.domNode.setAttribute(LANGUAGE_HTML_ATTR, this.map.get(LANGUAGE_KEY));
      }
      var theme = this.map.get('data-theme');
      if (theme && this.domNode.getAttribute(THEME_HTML_ATTR) !== theme) {
        this.domNode.setAttribute(THEME_HTML_ATTR, this.map.get('data-theme'));
      }
      var container = this.domNode.querySelector('.' + SYNTAXCM_CONTAINER_CLASS);
      var syntaxControl = (0,preact_module.h)(SyntaxControl, {
        blot: this,
        onSyntaxControlClick: this.onSyntaxControlClick
      });
      var syntaxCmNode = (0,preact_module.h)(SyntaxCM, {
        blot: this,
        map: this.map,
        domNode: this.domNode,
        store: this.store,
        onInitCM: this.onInitCM,
        onLoadModules: this.onLoadModules
      });
      var nodeToRender = (0,preact_module.h)("div", null, syntaxControl, syntaxCmNode);
      (0,preact_module/* render */.sY)((0,preact_module.h)(plugins_i18n/* IntlProvider */.Pj, null, nodeToRender), container);
    }
  }, {
    key: "update",
    value: function update() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = syntax_get(syntax_getPrototypeOf(Syntax.prototype), "update", this)).call.apply(_get2, [this].concat(args));
    }
  }, {
    key: "attach",
    value: function attach() {
      var _get3;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = syntax_get(syntax_getPrototypeOf(Syntax.prototype), "attach", this)).call.apply(_get3, [this].concat(args));
      this.render();
      this.editor.store.observe(this.map, this.mapObserver);
      if (this.isCodeMirrorEnabled && this.instanceCM) {
        this.instanceCM.on('focus', this.onCMFocus);
        this.instanceCM.on('blur', this.onCMBlur);
      }

      // в мобильных клиентах, при создании блота, курсор не всегда встаёт в область редактирования кода для того
      // чтобы это поправить, устанавливаем курсор в область редактирования для нового блота
      if (this.map.get('setCursor') === true) {
        this.onSyntaxControlClick();
        this.map.set('setCursor', false);
      }
    }
  }, {
    key: "optimize",
    value: function optimize(context) {
      syntax_get(syntax_getPrototypeOf(Syntax.prototype), "optimize", this).call(this, context);
    }
  }, {
    key: "beforeCopyContent",
    value: function beforeCopyContent() {
      return false;
    }
  }, {
    key: "getCopyObjectFromText",
    value: function getCopyObjectFromText(text) {
      var html = ['<pre '];
      if (this.map.get('data-language')) {
        html.push(LANGUAGE_HTML_ATTR + '="' + this.map.get('data-language') + '" ');
      }
      if (this.map.get('data-theme')) {
        html.push(THEME_HTML_ATTR + '="' + this.map.get('data-theme') + '" ');
      }
      html.push('>');
      html.push(lodash_escape_default()(text));
      html.push('</pre>');
      return {
        html: html.join(''),
        text: text
      };
    }
  }, {
    key: "getCopyHTML",
    value: function getCopyHTML() {
      var text = this.instanceCM.getSelection();
      if (!text) {
        text = this.instanceCM.getValue();
      }
      return this.getCopyObjectFromText(text);
    }
  }, {
    key: "getCopyParams",
    value: function getCopyParams() {
      var cut = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _ref3 = cut ? this.onCut() : this.getCopyHTML(),
        text = _ref3.text,
        html = _ref3.html;
      return Object.assign({}, {
        text: text,
        html: html
      }, {
        op: (0,util/* mergeDeep */.Ee)(this.getBlotInsertParams(), {
          initParams: {
            delta: new (Delta_default())().insert(text + '\n')
          }
        })
      });
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (!event.ctrlKey && !event.metaKey) {
        event.preventDefault();
        return false;
      }
    }
  }, {
    key: "copyToClipboard",
    value: function copyToClipboard() {
      var noToast = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var text = this.getText();
      var copyObject = this.getCopyObjectFromText(text);
      this.editor.plugins.copyManager.copy(copyObject.text, {
        html: copyObject.html
      });
    }
  }, {
    key: "onCut",
    value: function onCut() {
      var res = this.getCopyHTML();
      if (this.editor.mode === MODE_EDIT) {
        this.instanceCM.replaceSelection('');
      }
      return res;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      var empty = true;
      var text = this.getText().trim();
      if (text !== '') {
        empty = false;
      }
      return empty;
    }
  }, {
    key: "setLanguage",
    value: function setLanguage(language) {
      language = language || 'plaintext';
      this.map.set(LANGUAGE_KEY, language);
      this.format(this.statics.blotName, language);
      this.applyLanguage(language);
    }
  }, {
    key: "applyLanguage",
    value: function applyLanguage(language) {
      this.language = language;
      this.instanceCM.setOption("mode", this.mimes[language]);
      this.render();
    }
  }, {
    key: "getLanguage",
    value: function getLanguage() {
      return this.map.get(LANGUAGE_KEY) || 'auto';
    }
  }, {
    key: "setTheme",
    value: function setTheme(theme) {
      theme = theme || 'default';
      this.map.set(THEME_KEY, theme);
      this.onThemeChange();
    }
  }, {
    key: "getTheme",
    value: function getTheme() {
      return this.map.get(THEME_KEY) || 'default';
    }
  }, {
    key: "format",
    value: function format(name, value) {
      if (name === this.statics.blotName && value) {
        this.domNode.setAttribute(LANGUAGE_KEY, value);
      } else {
        //super.format(name, value);
      }
    }
  }, {
    key: "getTextDelta",
    value: function getTextDelta() {
      var delta = new (Delta_default())();
      var text = this.getText();
      var textArray = text.split('\n');
      textArray.forEach(function (text) {
        delta.ops.push({
          insert: text
        });
        delta.ops.push({
          insert: {
            linebreak: "s"
          }
        });
      });
      delta.ops.pop();
      return delta;
    }
  }, {
    key: "getSyntaxDelta",
    value: function getSyntaxDelta() {
      var delta = new (Delta_default())();
      delta.ops = this.map.get('characters').toDelta();
      return delta;
    }
  }, {
    key: "cloneSelf",
    value: function cloneSelf() {
      var params = {
        'delta': this.getSyntaxDelta()
      };
      params[LANGUAGE_KEY] = this.map.get(LANGUAGE_KEY) || 'plaintext';
      params[THEME_KEY] = this.map.get(THEME_KEY) || 'default';
      if (this.map.get('align')) params.align = this.map.get('align');
      if (this.map.get('wrap')) params.wrap = this.map.get('wrap');
      if (this.map.get('lineNumbers')) params.lineNumbers = this.map.get('lineNumbers');
      if (this.getWrapper().caption) {
        var captionMap = this.store.createMap();
        Caption.initMap(captionMap, this.store, {
          delta: this.getWrapper().caption.delta()
        });
        params.caption = captionMap.get('id');
      }
      var syntaxMap = this.store.createMap();
      parchment_default().query(this.map.get('type')).initMap(syntaxMap, this.store, params);
      return syntaxMap.get('id');
    }
  }, {
    key: "containerConvertBlots",
    value: function containerConvertBlots(blots, params) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var ToBlot = parchment_default().query(params.type);
      return syntax_get(syntax_getPrototypeOf(Syntax.prototype), "containerConvertBlots", this).call(this, blots, params, options);
    }
  }, {
    key: "getBlotMenuHeaderComponent",
    value: function getBlotMenuHeaderComponent() {
      return function () {
        return null;
      };
    }
  }, {
    key: "contextMenu",
    get: function get() {
      var exclude = ['turnToNumberList', 'turnToNumberList', 'turnToBulletList', 'turnToChecklist', 'turnToSyntax', 'turnToButton'];
      var cutMenu = {
        'turn-into': {}
      };
      var textMenuRaw = textMenu(this.editor);
      for (var key in textMenuRaw['turn-into']) {
        if (key === 'submenu') {
          var index = 0;
          cutMenu['turn-into'][key] = {};
          for (var k in textMenuRaw['turn-into'][key]) {
            if (exclude.indexOf(k) === -1) {
              //console.info('Accept', k);
              cutMenu['turn-into'][key][k] = Object.assign({}, textMenuRaw['turn-into'][key][k]);
              cutMenu['turn-into'][key][k].index = index++;
            } else {
              //console.info('Reject', k);
            }
          }
        } else {
          cutMenu['turn-into'][key] = textMenuRaw['turn-into'][key];
        }
      }
      var menu = syntax_get(syntax_getPrototypeOf(Syntax.prototype), "contextMenu", this);
      Object.assign(menu, cutMenu);
      if (this.getWrapper().caption && menu.hasOwnProperty('addCaption')) {
        menu['addCaption'].index = -4;
      } else {
        if (menu.hasOwnProperty('addCaption')) {
          delete menu['addCaption'];
        }
      }
      return menu;
    }
  }, {
    key: "ignoreUpdates",
    value: function ignoreUpdates(fn) {
      this._ignoreUpdates = true;
      var err;
      try {
        fn();
      } catch (fnErr) {
        err = fnErr;
      }
      if (err) {
        throw err;
      }
      this._ignoreUpdates = false;
    }
  }, {
    key: "selectAlltext",
    value: function selectAlltext() {
      this.instanceCM.execCommand('selectAll');
    }
  }, {
    key: "textToLine",
    value: function textToLine(text) {
      var content = text.split('\n');
      var newText = '';
      content.forEach(function (line) {
        newText = newText + line;
      });
      return newText;
    }
  }, {
    key: "setText",
    value: function setText(text) {
      var oldText = this.getText();
      var content = text.split('\n');
      var insertOps = [];
      insertOps.push({
        delete: oldText.length
      });
      content.forEach(function (line) {
        insertOps.push({
          insert: line.trimRight()
        });
        insertOps.push({
          insert: {
            linebreak: 's'
          }
        });
      });
      this.map.get('characters').applyDelta(insertOps);
    }
  }, {
    key: "getText",
    value: function getText() {
      var delta = this.map.get('characters').toDelta();
      var text = '';
      if (delta) {
        delta.forEach(function (line) {
          if (line.insert.linebreak) {
            text = text + '\n';
          } else {
            text = text + line.insert;
          }
        });
      }
      return text.trim();
    }
  }, {
    key: "getMarkdown",
    value: function getMarkdown() {
      var captionOps;
      if (this.map.get('caption')) {
        var _this$editor$store$bl, _this$editor$store$bl2;
        captionOps = (_this$editor$store$bl = this.editor.store.blocks.get(this.map.get('caption'))) === null || _this$editor$store$bl === void 0 ? void 0 : (_this$editor$store$bl2 = _this$editor$store$bl.get('characters')) === null || _this$editor$store$bl2 === void 0 ? void 0 : _this$editor$store$bl2.toDelta();
      }
      var params = {
        delta: this.getSyntaxDelta(),
        captionParams: captionOps ? {
          delta: {
            ops: captionOps
          }
        } : undefined,
        'data-language': this.map.get('data-language')
      };
      return syntaxToMarkdown(params);
    }
  }, {
    key: "getWrapper",
    value: function getWrapper() {
      return this.parent;
    }
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      var _this$getWrapper$capt, _initParams;
      var params = syntax_get(syntax_getPrototypeOf(Syntax.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
      var delta = this.getSyntaxDelta();
      return (0,util/* mergeDeep */.Ee)(params, {
        initParams: (_initParams = {
          delta: delta
        }, syntax_defineProperty(_initParams, LANGUAGE_KEY, this.map.get(LANGUAGE_KEY) || 'plaintext'), syntax_defineProperty(_initParams, THEME_KEY, this.map.get(THEME_KEY) || 'default'), syntax_defineProperty(_initParams, "align", this.map.get('align')), syntax_defineProperty(_initParams, "wrap", this.map.get('wrap')), syntax_defineProperty(_initParams, "lineNumbers", this.map.get('lineNumbers')), syntax_defineProperty(_initParams, "captionParams", (_this$getWrapper$capt = this.getWrapper().caption) === null || _this$getWrapper$capt === void 0 ? void 0 : _this$getWrapper$capt.getBlotInsertParams()), _initParams)
      });
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      var superHtml = this.domNode.outerHTML;
      var code = this.toHighlightHTML();
      var minheight = '';
      if (this.language !== 'auto' && code.trim() === '') {
        minheight = 'min-height: 16px;';
      }
      superHtml = superHtml.replace('{EXPORT_CODE}', "<pre style=\"white-space: pre-wrap; ".concat(minheight, "\">").concat(code, "</pre>"));
      return superHtml;
    }
  }, {
    key: "toHighlightHTML",
    value: function toHighlightHTML() {
      var text = this.getText();
      if (this.language === 'auto') {
        return text;
      } else {
        return syntax_hljsModule.highlight(this.language, text).value;
      }
    }
  }], [{
    key: "initMap",
    value: function initMap(map, store) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      params = this.normalizeParams(params);
      map.set('type', 'syntax');
      map.set('setCursor', true); // установить курсор в поле ввода после создания
      if (params['align']) map.set('align', params['align']);
      if (params[LANGUAGE_KEY]) map.set(LANGUAGE_KEY, params[LANGUAGE_KEY]);
      if (params[THEME_KEY]) map.set(THEME_KEY, params[THEME_KEY]);
      map.set('wrap', params.wrap || false);
      map.set('lineNumbers', params.lineNumbers || true);
      textLine.initMap(map, store, params);
      if (syntax_get(syntax_getPrototypeOf(Syntax), "initMap", this)) {
        syntax_get(syntax_getPrototypeOf(Syntax), "initMap", this).call(this, map, store, params);
      }
      var captionId = params.caption;
      if (!captionId) {
        var captionMap = store.createMap();
        Caption.initMap(captionMap, store, params.captionParams || {});
        captionId = captionMap.get('id');
      }
      map.set('caption', captionId);
    }
  }, {
    key: "create",
    value: function create() {
      var node = syntax_get(syntax_getPrototypeOf(Syntax), "create", this).call(this);
      var container = document.createElement('div');
      container.classList.add(SYNTAXCM_CONTAINER_CLASS);
      node.appendChild(container);
      return node;
    }
  }, {
    key: "createBlot",
    value: function createBlot(editor) {
      var blot = parchment_default().create('syntaxWrapper');
      if (editor.options.keyboardMode !== 'mobile') {
        this.addCaretTrap(editor, blot.domNode);
      }
      return blot;
    }
  }, {
    key: "normalizeParams",
    value: function normalizeParams(params) {
      params = Object.assign({}, params);
      if (Array.isArray(params.items)) {
        params.items = params.items.map(function (item) {
          if (typeof item === 'string') {
            return {
              type: item
            };
          }
          return item;
        });
      }
      return params;
    }
  }, {
    key: "convertBlots",
    value: function convertBlots(ids, store, _ref4) {
      var _this4 = this;
      var params = _ref4.params,
        container = _ref4.container;
      if (!params.items) params.items = [];
      if (!ids.length) {
        return null;
      }
      params = this.normalizeParams(params);

      // проверяем все ли переданные блоки могут быть сконвертированы, сконвертированы могут быть только наследуемые от TextLine
      var blots = ids.map(function (id) {
        var blot = container.editor.findById(id);
        if (!blot) {
          console.warn('blot with id not found', id);
        }
        return blot;
      });
      if (!blots.every(function (blot) {
        return searchUp(blot, function (b) {
          return b.isCollapsibleContainer;
        });
      })) {
        blots = blots.filter(function (blot) {
          return !searchUp(blot, function (b) {
            return b.isCollapsibleContainer;
          });
        });
      }
      var _iterator = syntax_createForOfIteratorHelper(blots),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _blot = _step.value;
          if (!_blot) {
            throw new Error('some of the blots passed in Syntax#convertBlots not found, all ids: ' + ids.join(', '));
          }
          if (!(_blot instanceof textLine) && !(_blot instanceof primary)) {
            return null;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var insertContainer = searchUp(container, function (b) {
        return b.isContainer && b.constructor.allowedChildren.some(function (BlotClass) {
          return BlotClass.blotName === _this4.wrapper;
        });
      });
      var addParagraphAfter = (insertContainer.children.tail.getWrappedBlot ? insertContainer.children.tail.getWrappedBlot().id : insertContainer.children.tail.id) === blots[blots.length - 1].id;
      var paramsItems = params.items;
      while (paramsItems.length < ids.length) {
        var item = Object.assign({}, paramsItems[paramsItems.length - 1]);
        paramsItems.push(item);
      }
      var addSyntax = function addSyntax(afterId, delta, syntaxParams) {
        var _insertContainer$addB = insertContainer.addBlot('syntax', syntax_objectSpread({
            delta: delta,
            after: afterId
          }, syntaxParams)),
          id = _insertContainer$addB.id;
        return id;
      };
      var removeGroups = {};
      var removeBlots = [];
      var delta = new (Delta_default())();
      var withComments = [];
      var index = 1;
      var lastSyntaxId = null;
      var afterBlot = blots[0];
      var _iterator2 = syntax_createForOfIteratorHelper(blots),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _blot2 = _step2.value;
          if (_blot2 instanceof listItem) {
            if (!removeGroups[_blot2.parent.id]) {
              removeGroups[_blot2.parent.id] = [];
            }
            removeGroups[_blot2.parent.id].push(_blot2.id);
          } else {
            removeBlots.push(_blot2.id);
          }
          var paramItem = paramsItems.shift();
          var _params = paramItem.params || {};
          if (!_params.delta) {
            _params.delta = _blot2.delta();
          }
          if (delta.ops.length) {
            delta = delta.insert({
              linebreak: 's'
            });
          }
          if (_blot2.map.has('commentThreads')) {
            withComments.push(_blot2);
          }
          delta = delta.concat(_params.delta);
          if (_blot2.hasChildrenContainer && !_blot2.isCollapsed() && _blot2.map.get('children').toArray().length) {
            var syntaxParams = {};
            // если конвертируется только один текстовый блот с комментарием в код
            // то сохраняем комментарии блота
            if (withComments.length === 1) {
              this.setCommentThreads(withComments[0], syntaxParams);
            }
            delta = toRawTextDelta(delta, {
              removeNewLines: true
            });
            delta = ensureDeltaEndsWithNewLine(delta);
            Object.keys(removeGroups).map(function (listId) {
              var list = container.editor.findById(listId);
              list.splitList(list.getChildIndex(removeGroups[listId][0]), removeGroups[listId].length, {}, null);
            });
            lastSyntaxId = addSyntax(!(afterBlot instanceof listItem) ? afterBlot.id : afterBlot.container.id, delta, syntaxParams);
            var blotChildrenIds = _blot2.map.get('children').toArray();
            var childIndex = insertContainer.getChildIndex(lastSyntaxId) + 1;
            var _iterator3 = syntax_createForOfIteratorHelper(blotChildrenIds),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var childId = _step3.value;
                insertContainer.moveChild(childId, childIndex);
                childIndex++;
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
            afterBlot = {
              id: blotChildrenIds[blotChildrenIds.length - 1]
            };
            delta = new (Delta_default())();
            withComments = [];
            removeGroups = {};
          } else if (index === blots.length) {
            var _syntaxParams = {};
            // если конвертируется только один текстовый блот с комментарием в код
            // то сохраняем комментарии блота
            if (withComments.length === 1) {
              this.setCommentThreads(withComments[0], _syntaxParams);
            }
            delta = toRawTextDelta(delta, {
              removeNewLines: true
            });
            delta = ensureDeltaEndsWithNewLine(delta);
            var afterBlotId = afterBlot.id;
            if (afterBlot instanceof listItem) {
              if (removeGroups[afterBlot.container.id].length === afterBlot.container.children.length) {
                if (afterBlot.container.prev) {
                  afterBlotId = afterBlot.container.prev.id;
                }
              } else {
                afterBlotId = afterBlot.container.id;
              }
            }
            Object.keys(removeGroups).map(function (listId) {
              var list = container.editor.findById(listId);
              list.splitList(list.getChildIndex(removeGroups[listId][0]), removeGroups[listId].length, {}, null);
            });
            lastSyntaxId = addSyntax(afterBlotId, delta, _syntaxParams);
          }
          index++;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      for (var _i2 = 0, _removeBlots = removeBlots; _i2 < _removeBlots.length; _i2++) {
        var id = _removeBlots[_i2];
        var blot = container.editor.findById(id);
        if (blot) {
          blot.container.removeChildById(id);
        }
      }
      if (addParagraphAfter) {
        insertContainer.addBlot('paragraph', {
          after: lastSyntaxId
        });
      }
      return {
        removeBlots: [],
        insertBlots: [],
        focus: {
          id: lastSyntaxId,
          focus: {
            index: 0
          }
        }
      };
    }
  }, {
    key: "normalizeDelta",
    value: function normalizeDelta(delta) {
      return delta.reduce(function (delta, op) {
        if (typeof op.insert === 'string') {
          var text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
          return delta.insert(text, op.attributes);
        } else {
          return delta.insert('\n');
        }
      }, new (Delta_default())());
    }
  }]);
  return Syntax;
}(syntax_mixin(blockEmbed));

Syntax.tagName = ['SYNTAX'];
Syntax.blotName = 'syntax';
Syntax.className = 'syntax-main';
Syntax.wrapper = 'syntaxWrapper';
Syntax.hasInnerTextLine = true;
Syntax.skipDeleteAction = true;
Syntax.scope = (parchment_default()).Scope.BLOCK_BLOT;
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/syntax/syntaxWrapper.js
function syntaxWrapper_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { syntaxWrapper_typeof = function _typeof(obj) { return typeof obj; }; } else { syntaxWrapper_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return syntaxWrapper_typeof(obj); }














function syntaxWrapper_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function syntaxWrapper_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function syntaxWrapper_createClass(Constructor, protoProps, staticProps) { if (protoProps) syntaxWrapper_defineProperties(Constructor.prototype, protoProps); if (staticProps) syntaxWrapper_defineProperties(Constructor, staticProps); return Constructor; }
function syntaxWrapper_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { syntaxWrapper_get = Reflect.get; } else { syntaxWrapper_get = function _get(target, property, receiver) { var base = syntaxWrapper_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return syntaxWrapper_get(target, property, receiver || target); }
function syntaxWrapper_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = syntaxWrapper_getPrototypeOf(object); if (object === null) break; } return object; }
function syntaxWrapper_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) syntaxWrapper_setPrototypeOf(subClass, superClass); }
function syntaxWrapper_setPrototypeOf(o, p) { syntaxWrapper_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return syntaxWrapper_setPrototypeOf(o, p); }
function syntaxWrapper_createSuper(Derived) { var hasNativeReflectConstruct = syntaxWrapper_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = syntaxWrapper_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = syntaxWrapper_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return syntaxWrapper_possibleConstructorReturn(this, result); }; }
function syntaxWrapper_possibleConstructorReturn(self, call) { if (call && (syntaxWrapper_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return syntaxWrapper_assertThisInitialized(self); }
function syntaxWrapper_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function syntaxWrapper_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function syntaxWrapper_getPrototypeOf(o) { syntaxWrapper_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return syntaxWrapper_getPrototypeOf(o); }
function syntaxWrapper_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var SyntaxWrapper = /*#__PURE__*/function (_EmbedWrapper) {
  syntaxWrapper_inherits(SyntaxWrapper, _EmbedWrapper);
  var _super = syntaxWrapper_createSuper(SyntaxWrapper);
  function SyntaxWrapper(domNode) {
    var _this;
    syntaxWrapper_classCallCheck(this, SyntaxWrapper);
    _this = _super.call(this, domNode);
    syntaxWrapper_defineProperty(syntaxWrapper_assertThisInitialized(_this), "onCaptionClick", function (event) {
      var range = _this.editor.scroll.selection.getRange()[0];
      var blotRange = _this.editor.scroll.selection.getRange({
        offsetBlot: _this.caption
      })[0];
      if (blotRange.length + 1 === range.length) {
        _this.editor.scroll.selection.setRange({
          index: range.index,
          length: blotRange.length
        });
      }
    });
    _this.domNode.classList.add('syntax-wrapper');
    _this.caption = null;
    return _this;
  }
  syntaxWrapper_createClass(SyntaxWrapper, [{
    key: "getInnerTextLine",
    value: function getInnerTextLine() {
      return this.caption;
    }
  }, {
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = syntaxWrapper_get(syntaxWrapper_getPrototypeOf(SyntaxWrapper.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      if (!this.caption) {
        var CaptionMap = this.map.get('caption');
        if (CaptionMap) {
          this.caption = parchment_default().create('caption');
          this.caption.map = this.store.getMap(this.map.get('caption'));
          this.caption.embedBlot = this.embed;
          this.appendChild(this.caption);
          this.caption.domNode.addEventListener('click', this.onCaptionClick, false);
        }
      }
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = syntaxWrapper_get(syntaxWrapper_getPrototypeOf(SyntaxWrapper.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      if (this.caption) {
        this.caption.domNode.removeEventListener('click', this.onCaptionClick, false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      syntaxWrapper_get(syntaxWrapper_getPrototypeOf(SyntaxWrapper.prototype), "render", this).call(this);
      if (this.caption) {
        this.caption.render();
      }
    }
  }, {
    key: "getWrappedBlot",
    value: function getWrappedBlot() {
      return this.embed;
    }
  }, {
    key: "getMarkdown",
    value: function getMarkdown() {
      var markdown = '';
      this.children.forEach(function (blot) {
        if (blot.getMarkdown) {
          markdown += blot.getMarkdown();
        }
      });
      return markdown;
    }
  }]);
  return SyntaxWrapper;
}(embedWrapperAbstract);

SyntaxWrapper.allowedChildren = [Syntax, Caption];
SyntaxWrapper.blotName = 'syntaxWrapper';
// EXTERNAL MODULE: ./node_modules/lodash.isequal/index.js
var lodash_isequal = __webpack_require__(37733);
var lodash_isequal_default = /*#__PURE__*/__webpack_require__.n(lodash_isequal);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/tasksList/tasksListComponent.js
function tasksListComponent_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { tasksListComponent_typeof = function _typeof(obj) { return typeof obj; }; } else { tasksListComponent_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return tasksListComponent_typeof(obj); }
function tasksListComponent_extends() { tasksListComponent_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tasksListComponent_extends.apply(this, arguments); }












function tasksListComponent_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function tasksListComponent_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function tasksListComponent_createClass(Constructor, protoProps, staticProps) { if (protoProps) tasksListComponent_defineProperties(Constructor.prototype, protoProps); if (staticProps) tasksListComponent_defineProperties(Constructor, staticProps); return Constructor; }
function tasksListComponent_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) tasksListComponent_setPrototypeOf(subClass, superClass); }
function tasksListComponent_setPrototypeOf(o, p) { tasksListComponent_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return tasksListComponent_setPrototypeOf(o, p); }
function tasksListComponent_createSuper(Derived) { var hasNativeReflectConstruct = tasksListComponent_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = tasksListComponent_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = tasksListComponent_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return tasksListComponent_possibleConstructorReturn(this, result); }; }
function tasksListComponent_possibleConstructorReturn(self, call) { if (call && (tasksListComponent_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return tasksListComponent_assertThisInitialized(self); }
function tasksListComponent_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function tasksListComponent_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function tasksListComponent_getPrototypeOf(o) { tasksListComponent_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return tasksListComponent_getPrototypeOf(o); }
function tasksListComponent_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var TasksListComponent = /*#__PURE__*/function (_Component) {
  tasksListComponent_inherits(TasksListComponent, _Component);
  var _super = tasksListComponent_createSuper(TasksListComponent);
  function TasksListComponent() {
    var _this;
    tasksListComponent_classCallCheck(this, TasksListComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    tasksListComponent_defineProperty(tasksListComponent_assertThisInitialized(_this), "onRef", function (node) {
      if (node && _this.props.outputs) {
        var outputs = _this.props.outputs;
        var eventNames = Object.keys(outputs);
        for (var _i = 0, _eventNames = eventNames; _i < _eventNames.length; _i++) {
          var eventName = _eventNames[_i];
          node.addEventListener(eventName, outputs[eventName]);
        }
      }
    });
    return _this;
  }
  tasksListComponent_createClass(TasksListComponent, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (lodash_isequal_default()(this.props, nextProps)) {
        return false;
      }
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var inputs = this.props.inputs;
      return (0,preact_module.h)("nim-task-list", tasksListComponent_extends({}, inputs, {
        ref: this.onRef
      }));
    }
  }], [{
    key: "isRegisteredTasksComponent",
    value: function isRegisteredTasksComponent(editor) {
      var _editor$plugins;
      if (editor !== null && editor !== void 0 && (_editor$plugins = editor.plugins) !== null && _editor$plugins !== void 0 && _editor$plugins.tasksManager.options.readonly) {
        return false;
      }
      // веб компонент тасков является NgElement конструктором
      return document.createElement('nim-task-list').constructor !== HTMLElement;
    }
  }]);
  return TasksListComponent;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/tasksList/tasksListReadOnlyComponent.js
function tasksListReadOnlyComponent_extends() { tasksListReadOnlyComponent_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tasksListReadOnlyComponent_extends.apply(this, arguments); }
function tasksListReadOnlyComponent_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






function TasksListReadOnlyComponent(_ref) {
  var title = _ref.title,
    tasks = _ref.tasks;
  return (0,preact_module.h)("div", {
    className: "tasks-list-ro"
  }, (0,preact_module.h)("div", {
    className: "tasks-list-ro-title"
  }, title), (0,preact_module.h)("div", {
    className: "tasks-list-ro-tasks-wrapper"
  }, tasks.map(function (task) {
    return (0,preact_module.h)("div", {
      className: 'tasks-list-ro-task' + (task.done ? ' completed' : '')
    }, (0,preact_module.h)("span", {
      className: "tasks-list-ro-task-radio"
    }), (0,preact_module.h)("div", {
      className: "tasks-list-ro-task-details"
    }, (0,preact_module.h)("div", {
      className: "tasks-list-ro-task-info-wrapper"
    }, (0,preact_module.h)("div", {
      className: "tasks-list-ro-task-left"
    }, (0,preact_module.h)("p", {
      className: "tasks-list-ro-task-title"
    }, task.title)), (0,preact_module.h)("div", {
      className: "tasks-list-ro-task-right"
    }, task.deadlineDate ? (0,preact_module.h)("span", {
      className: "tasks-list-ro-task-reminder"
    }, new Date(task.deadlineDate).toLocaleDateString('en')) : null, task.assignees && task.assignees.length ? (0,preact_module.h)("div", {
      className: "tasks-list-ro-task-assignees-wrapper"
    }, task.assignees.map(function (user) {
      var _tooltipAttrs;
      var displayName = user.displayName;
      if (!displayName || typeof displayName === 'undefined') {
        displayName = 'Unknown';
      }
      var tooltipAttrs = (_tooltipAttrs = {}, tasksListReadOnlyComponent_defineProperty(_tooltipAttrs, tooltipManager/* TOOLTIP_ATTR */.qZ, displayName), tasksListReadOnlyComponent_defineProperty(_tooltipAttrs, tooltipManager/* TOOLTIP_ADD_CLASS */.Bg, 'tasks-list-ro-user-tooltip'), _tooltipAttrs);
      if (!user.avatarUrl || typeof user.avatarUrl === 'undefined') {
        var initials = displayName.substr(0, 2);
        var firstLastNames = displayName.split(' ');
        if (firstLastNames.length > 1) {
          initials = firstLastNames[0].at(0) + firstLastNames[1].at(0);
        }
        return (0,preact_module.h)("div", tasksListReadOnlyComponent_extends({
          className: "tasks-list-ro-task-assignee-user"
        }, tooltipAttrs), initials);
      } else {
        return (0,preact_module.h)("div", tasksListReadOnlyComponent_extends({
          className: "tasks-list-ro-task-assignee-user"
        }, tooltipAttrs), (0,preact_module.h)("img", {
          src: user.avatarUrl
        }));
      }
    })) : null)), task.labels && task.labels.length ? (0,preact_module.h)("div", {
      className: "tasks-list-ro-task-labels-wrapper"
    }, task.labels.map(function (label) {
      return (0,preact_module.h)("span", {
        className: 'tasks-list-ro-task-label bg-palette-' + label.color
      }, label.title);
    })) : null));
  })));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/tasksList/tasksListOuterRenderer.js
function tasksListOuterRenderer_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { tasksListOuterRenderer_typeof = function _typeof(obj) { return typeof obj; }; } else { tasksListOuterRenderer_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return tasksListOuterRenderer_typeof(obj); }










function tasksListOuterRenderer_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function tasksListOuterRenderer_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function tasksListOuterRenderer_createClass(Constructor, protoProps, staticProps) { if (protoProps) tasksListOuterRenderer_defineProperties(Constructor.prototype, protoProps); if (staticProps) tasksListOuterRenderer_defineProperties(Constructor, staticProps); return Constructor; }
function tasksListOuterRenderer_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) tasksListOuterRenderer_setPrototypeOf(subClass, superClass); }
function tasksListOuterRenderer_setPrototypeOf(o, p) { tasksListOuterRenderer_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return tasksListOuterRenderer_setPrototypeOf(o, p); }
function tasksListOuterRenderer_createSuper(Derived) { var hasNativeReflectConstruct = tasksListOuterRenderer_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = tasksListOuterRenderer_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = tasksListOuterRenderer_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return tasksListOuterRenderer_possibleConstructorReturn(this, result); }; }
function tasksListOuterRenderer_possibleConstructorReturn(self, call) { if (call && (tasksListOuterRenderer_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return tasksListOuterRenderer_assertThisInitialized(self); }
function tasksListOuterRenderer_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function tasksListOuterRenderer_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function tasksListOuterRenderer_getPrototypeOf(o) { tasksListOuterRenderer_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return tasksListOuterRenderer_getPrototypeOf(o); }
function tasksListOuterRenderer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TasksListOuterRenderer = /*#__PURE__*/function (_Component) {
  tasksListOuterRenderer_inherits(TasksListOuterRenderer, _Component);
  var _super = tasksListOuterRenderer_createSuper(TasksListOuterRenderer);
  function TasksListOuterRenderer() {
    var _this;
    tasksListOuterRenderer_classCallCheck(this, TasksListOuterRenderer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    tasksListOuterRenderer_defineProperty(tasksListOuterRenderer_assertThisInitialized(_this), "onRef", function (node) {
      _this.props.onRef && _this.props.onRef(node, {
        inputs: _this.props.inputs,
        outputs: _this.props.outputs,
        defaultView: _this.props.defaultView
      });
    });
    return _this;
  }
  tasksListOuterRenderer_createClass(TasksListOuterRenderer, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      return (0,preact_module.h)("div", {
        ref: this.onRef
      });
    }
  }]);
  return TasksListOuterRenderer;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/tasksList/tasksList.js
function tasksList_slicedToArray(arr, i) { return tasksList_arrayWithHoles(arr) || tasksList_iterableToArrayLimit(arr, i) || tasksList_unsupportedIterableToArray(arr, i) || tasksList_nonIterableRest(); }
function tasksList_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tasksList_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tasksList_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tasksList_arrayLikeToArray(o, minLen); }
function tasksList_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function tasksList_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function tasksList_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function tasksList_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { tasksList_typeof = function _typeof(obj) { return typeof obj; }; } else { tasksList_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return tasksList_typeof(obj); }
function tasksList_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function tasksList_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { tasksList_ownKeys(Object(source), true).forEach(function (key) { tasksList_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { tasksList_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function tasksList_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function tasksList_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { tasksList_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { tasksList_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




















function tasksList_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function tasksList_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function tasksList_createClass(Constructor, protoProps, staticProps) { if (protoProps) tasksList_defineProperties(Constructor.prototype, protoProps); if (staticProps) tasksList_defineProperties(Constructor, staticProps); return Constructor; }
function tasksList_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { tasksList_get = Reflect.get; } else { tasksList_get = function _get(target, property, receiver) { var base = tasksList_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return tasksList_get(target, property, receiver || target); }
function tasksList_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = tasksList_getPrototypeOf(object); if (object === null) break; } return object; }
function tasksList_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) tasksList_setPrototypeOf(subClass, superClass); }
function tasksList_setPrototypeOf(o, p) { tasksList_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return tasksList_setPrototypeOf(o, p); }
function tasksList_createSuper(Derived) { var hasNativeReflectConstruct = tasksList_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = tasksList_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = tasksList_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return tasksList_possibleConstructorReturn(this, result); }; }
function tasksList_possibleConstructorReturn(self, call) { if (call && (tasksList_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return tasksList_assertThisInitialized(self); }
function tasksList_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function tasksList_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function tasksList_getPrototypeOf(o) { tasksList_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return tasksList_getPrototypeOf(o); }
function tasksList_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


















var tasksList_mixin = mix([commentable, embeddable, draggable, dropAcceptor, selectable, focusable, executable, basic]);
var TASKSLIST_CLASS = 'tasks-list';
var TASKSLIST_CONTAINER_CLASS = 'task-list-container';
var TASKSLIST_CACHE_KEY = 'task-list-from-column';
var TasksList = /*#__PURE__*/function (_mixin) {
  tasksList_inherits(TasksList, _mixin);
  var _super = tasksList_createSuper(TasksList);
  function TasksList(domNode) {
    var _this;
    tasksList_classCallCheck(this, TasksList);
    _this = _super.call(this, domNode);
    tasksList_defineProperty(tasksList_assertThisInitialized(_this), "mapObserver", function (event, _ref) {
      var local = _ref.local;
      // тут отказался от вызова this.render(), так как на перерендер должно повлиять только добавление/изменение tasksListId
      // при этом нам обязательно нужно вызывать setProps, он и вызовет перерендер компонента
      if (event.keysChanged.has('tasksListId')) {
        if (!local) {
          if (Boolean(_this.tasksListId) && typeof _this.tasksListId !== 'undefined') {
            _this.setPropsForTasksList();
          }
        }
      }
      if (event.keysChanged.has('showTitle')) {
        _this.setTitleState();
      }
    });
    tasksList_defineProperty(tasksList_assertThisInitialized(_this), "onOuterRendererRef", function (node) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _this.blotConfig.onTaskListRender && _this.blotConfig.onTaskListRender(node, _this.tasksListId, 'task-list', options);
    });
    tasksList_defineProperty(tasksList_assertThisInitialized(_this), "onShowHideTitle", function () {
      _this.map.set('showTitle', !_this.showTitle);
    });
    tasksList_defineProperty(tasksList_assertThisInitialized(_this), "onDefaultViewChange", function (_ref2) {
      var view = _ref2.view;
      _this.map.set('defaultView', view);
    });
    _this.isSeparableByClickApplicable = true;
    _this.addCanExecActions(['delete', 'backspace']);
    _this.disallowReplace = true;
    _this.dontRemoveWithBackspace = true;
    return _this;
  }
  tasksList_createClass(TasksList, [{
    key: "contentContainer",
    get: function get() {
      return this.domNode.querySelector('.' + TASKSLIST_CONTAINER_CLASS);
    }
  }, {
    key: "tasksListId",
    get: function get() {
      return this.map.get('tasksListId');
    }
  }, {
    key: "attach",
    value: function () {
      var _attach = tasksList_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _get2;
        var _len,
          args,
          _key,
          _this$editor$plugins,
          undoManager,
          tasksManager,
          _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = _args[_key];
                }
                (_get2 = tasksList_get(tasksList_getPrototypeOf(TasksList.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
                this.store.observe(this.map, this.mapObserver);
                _this$editor$plugins = this.editor.plugins, undoManager = _this$editor$plugins.undoManager, tasksManager = _this$editor$plugins.tasksManager;
                if (!((undoManager.isUndoing() || undoManager.isRedoing()) && this.tasksListId)) {
                  _context.next = 8;
                  break;
                }
                this.editor.emitter.emit('tasksList:restore', {
                  tasksListId: this.tasksListId
                });
                _context.next = 8;
                return tasksManager.restoreTaskList(this.tasksListId);
              case 8:
                if (this.map.get('origin')) {
                  if (!TasksList.isProcessedByAnotherUser(this.map, this.store)) {
                    TasksList.setUserMutex(this.map, this.store);
                  }
                  this.tryDuplicateTasksList();
                } else {
                  if (!Boolean(this.tasksListId) || typeof this.tasksListId === 'undefined') {
                    if (!TasksList.isProcessedByAnotherUser(this.map, this.store)) {
                      TasksList.setUserMutex(this.map, this.store);
                    }
                    this.createTasksList();
                  } else {
                    this.setPropsForTasksList();
                  }
                }
                this.setTitleState();
                this.render();
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function attach() {
        return _attach.apply(this, arguments);
      }
      return attach;
    }()
  }, {
    key: "detach",
    value: function detach() {
      // обрабатываем удаления таск-листа через Ctr+Z 
      var _this$scroll$editor$p = this.scroll.editor.plugins,
        undoManager = _this$scroll$editor$p.undoManager,
        tasksManager = _this$scroll$editor$p.tasksManager;
      if (undoManager.isUndoing()) {
        var editor = this.scroll.editor;
        var store = editor.store;
        var cache = store.cache.get(TASKSLIST_CACHE_KEY);
        var taskListId = this.domNode.getAttribute('tasks-list-id');
        var _ref3 = (cache === null || cache === void 0 ? void 0 : cache.get(taskListId)) || {},
          boardId = _ref3.boardId,
          beforeColumnId = _ref3.beforeColumnId;
        // если таск-лист был создан из колонки, то восстанавливаем колонку обратно
        if (boardId) {
          tasksManager.convertToColumn(boardId, taskListId, beforeColumnId);
          cache.delete(taskListId);
        } else {
          tasksManager.taskListRemove(taskListId);
        }
      }
      if (tasksList_get(tasksList_getPrototypeOf(TasksList.prototype), "detach", this)) {
        var _get3;
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        (_get3 = tasksList_get(tasksList_getPrototypeOf(TasksList.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      }
      this.store.unobserve(this.map, this.mapObserver);
    }
  }, {
    key: "setTitleState",
    value: function setTitleState() {
      if (this.blotConfig.onTaskListRender) {
        if (!this.showTitle) {
          if (!this.domNode.classList.contains('hidden-title')) {
            this.domNode.classList.add('hidden-title');
          }
        } else {
          if (this.domNode.classList.contains('hidden-title')) {
            this.domNode.classList.remove('hidden-title');
          }
        }
      }
    }
  }, {
    key: "onBlotMenuUpdatePosition",
    value: function onBlotMenuUpdatePosition(_ref4) {
      var left = _ref4.left,
        top = _ref4.top;
      if (this.blotConfig.onTaskListRender) {
        top += 8;
      }
      return {
        left: left,
        top: top
      };
    }
  }, {
    key: "onGetCommentPosition",
    value: function onGetCommentPosition(_ref5) {
      var left = _ref5.left,
        top = _ref5.top;
      if (this.blotConfig.onTaskListRender) {
        top += 5;
      }
      return {
        left: left,
        top: top
      };
    }
  }, {
    key: "onTasksListCreate",
    value: function onTasksListCreate(id) {
      this.editor.emitter.emit('tasksList:create', {
        tasksListId: id
      });
    }
  }, {
    key: "tryDuplicateTasksList",
    value: function () {
      var _tryDuplicateTasksList = tasksList_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this$map$get, originTasksListId, room, id;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!TasksList.isProcessedByAnotherUser(this.map, this.store)) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return");
              case 2:
                _context2.prev = 2;
                _this$map$get = this.map.get('origin'), originTasksListId = _this$map$get.id, room = _this$map$get.room;
                _context2.next = 6;
                return this.editor.plugins.tasksManager.duplicateTasksList(originTasksListId, room);
              case 6:
                id = _context2.sent;
                if (id) {
                  this.map.set('tasksListId', id);
                  this.onTasksListCreate(id);
                }
              case 8:
                _context2.prev = 8;
                this.map.delete('origin');
                TasksList.removeUserMutex(this.map);
                this.setPropsForTasksList();
                return _context2.finish(8);
              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2,, 8, 13]]);
      }));
      function tryDuplicateTasksList() {
        return _tryDuplicateTasksList.apply(this, arguments);
      }
      return tryDuplicateTasksList;
    }()
  }, {
    key: "createTasksList",
    value: function () {
      var _createTasksList = tasksList_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var id, props;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!TasksList.isProcessedByAnotherUser(this.map, this.store)) {
                  _context3.next = 2;
                  break;
                }
                return _context3.abrupt("return");
              case 2:
                _context3.prev = 2;
                _context3.next = 5;
                return this.editor.plugins.tasksManager.createTasksList();
              case 5:
                id = _context3.sent;
                if (id) {
                  this.map.set('tasksListId', id);
                  this.onTasksListCreate(id);
                }
              case 7:
                _context3.prev = 7;
                TasksList.removeUserMutex(this.map);
                props = tasksList_objectSpread(tasksList_objectSpread({}, this.editor.plugins.tasksManager.featWorkspaceTasksInputs()), {}, {
                  nimStartCreateTaskOnInit: true
                });
                this.setPropsForTasksList(props);
                return _context3.finish(7);
              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2,, 7, 12]]);
      }));
      function createTasksList() {
        return _createTasksList.apply(this, arguments);
      }
      return createTasksList;
    }()
  }, {
    key: "trySetReadOnlyProps",
    value: function () {
      var _trySetReadOnlyProps = tasksList_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var props;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.editor.plugins.tasksManager.getReadOnlyTasksList(this.tasksListId);
              case 2:
                props = _context4.sent;
                if (!props) {
                  _context4.next = 6;
                  break;
                }
                this.setProps({
                  tasksListReadOnlyProps: props
                });
                return _context4.abrupt("return", true);
              case 6:
                return _context4.abrupt("return", false);
              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function trySetReadOnlyProps() {
        return _trySetReadOnlyProps.apply(this, arguments);
      }
      return trySetReadOnlyProps;
    }() /**
         * Функция ждёт пока веб компонент таск-листа зарегистрируется и дальше вызывает коллбек об успешной загрузке
         * Необходим для того чтобы загружать бандл таск-листов только если в заметку добавлены таск-листы
         * @returns {Promise<void>}
         */
  }, {
    key: "waitCustomElements",
    value: function () {
      var _waitCustomElements = tasksList_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this2 = this;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", new Promise(function (resolve) {
                  var TID = setInterval(function () {
                    if (TasksListComponent.isRegisteredTasksComponent(_this2.editor)) {
                      clearInterval(TID);
                      if (_this2.editor.plugins.tasksManager.options.onCustomElementsLoaded) {
                        _this2.editor.plugins.tasksManager.options.onCustomElementsLoaded();
                      }
                      resolve();
                    }
                  }, 1000);
                }));
              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      function waitCustomElements() {
        return _waitCustomElements.apply(this, arguments);
      }
      return waitCustomElements;
    }()
  }, {
    key: "setPropsForTasksList",
    value: function () {
      var _setPropsForTasksList = tasksList_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var rawProps,
          isReadOnlyAvailable,
          props,
          _args6 = arguments;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                rawProps = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : null;
                if (!this.isSettingPropsInProcess) {
                  _context6.next = 3;
                  break;
                }
                return _context6.abrupt("return");
              case 3:
                this.isSettingPropsInProcess = true;

                // ждем пока веб компонент тасков зарегистрируется
                if (!this.editor.plugins.tasksManager.options.waitCustomElements) {
                  _context6.next = 9;
                  break;
                }
                this.editor.plugins.tasksManager.options.waitCustomElements();
                if (TasksListComponent.isRegisteredTasksComponent(this.editor)) {
                  _context6.next = 9;
                  break;
                }
                _context6.next = 9;
                return this.waitCustomElements();
              case 9:
                _context6.prev = 9;
                // убираем ошибку, но не вызываем перерендер, перерендер вызовет последующий setProps ниже
                this.props.tasksListError = false;
                if (!(!Boolean(this.tasksListId) || typeof this.tasksListId === 'undefined')) {
                  _context6.next = 13;
                  break;
                }
                throw new Error("TasksListId for blot ".concat(this.id, " is undefined"));
              case 13:
                if (TasksListComponent.isRegisteredTasksComponent(this.editor)) {
                  _context6.next = 21;
                  break;
                }
                _context6.next = 16;
                return this.trySetReadOnlyProps();
              case 16:
                isReadOnlyAvailable = _context6.sent;
                if (isReadOnlyAvailable) {
                  _context6.next = 19;
                  break;
                }
                throw new Error("Blot ".concat(this.id, ": unable to get data to display TasksList on readonly mode"));
              case 19:
                _context6.next = 27;
                break;
              case 21:
                if (!(!Boolean(rawProps) || tasksList_typeof(rawProps) !== 'object' || Array.isArray(rawProps))) {
                  _context6.next = 25;
                  break;
                }
                rawProps = this.editor.plugins.tasksManager.featWorkspaceTasksInputs();
                if (Boolean(rawProps)) {
                  _context6.next = 25;
                  break;
                }
                throw new Error('Props for tasks list is undefined or false or null: ', rawProps);
              case 25:
                props = tasksList_objectSpread(tasksList_objectSpread({}, rawProps), {}, {
                  nimTaskListId: this.tasksListId
                });
                this.setProps({
                  tasksListProps: props
                });
              case 27:
                _context6.next = 33;
                break;
              case 29:
                _context6.prev = 29;
                _context6.t0 = _context6["catch"](9);
                console.error(_context6.t0);
                this.setProps({
                  tasksListError: true
                });
              case 33:
                _context6.prev = 33;
                if (this.tasksListId) {
                  this.domNode.setAttribute('tasks-list-id', this.tasksListId);
                }
                this.isSettingPropsInProcess = false;
                return _context6.finish(33);
              case 37:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[9, 29, 33, 37]]);
      }));
      function setPropsForTasksList() {
        return _setPropsForTasksList.apply(this, arguments);
      }
      return setPropsForTasksList;
    }()
  }, {
    key: "getDraggingNode",
    value: function getDraggingNode() {
      var _this$domNode$getBoun = this.domNode.getBoundingClientRect(),
        width = _this$domNode$getBoun.width,
        height = _this$domNode$getBoun.height;
      var node = document.createElement('div');
      node.classList.add('dragging-placeholder');
      node.style.width = width + 'px';
      node.style.height = height + 'px';
      return node;
    }
  }, {
    key: "render",
    value: function render() {
      var _get4,
        _this3 = this;
      (_get4 = tasksList_get(tasksList_getPrototypeOf(TasksList.prototype), "render", this)) === null || _get4 === void 0 ? void 0 : _get4.call(this);
      var props = {};
      var ToRenderComponent = (loader2_default());
      if (this.props.tasksListProps) {
        props.inputs = this.props.tasksListProps;
        if (!props.inputs.hasOwnProperty('nimScrollContainerId')) {
          var containerNode = this.editor.getScrollingContainer();
          if (containerNode.id && containerNode.id !== '') {
            props.inputs.nimScrollContainerId = containerNode.id;
          }
        }
        props.outputs = this.editor.plugins.tasksManager.featWorkspaceTasksOutputs();
        if (this.blotConfig.onTaskListRender !== undefined) {
          props.onRef = this.onOuterRendererRef;
          props.defaultView = this.map.get('defaultView') || 'task-list';
          ToRenderComponent = TasksListOuterRenderer;
        } else {
          ToRenderComponent = TasksListComponent;
        }
      } else if (this.props.tasksListReadOnlyProps) {
        props = tasksList_objectSpread({}, this.props.tasksListReadOnlyProps);
        ToRenderComponent = TasksListReadOnlyComponent;
      } else if (this.props.tasksListError) {
        ToRenderComponent = function ToRenderComponent() {
          return (0,preact_module.h)("span", {
            className: "tasks-list-not-supported"
          }, _this3.editor.plugins.i18n.get('tasks_list.not_supported'));
        };
      }
      (0,preact_module/* render */.sY)((0,preact_module.h)(ToRenderComponent, props), this.contentContainer);
    }
  }, {
    key: "toHTML",
    value: function toHTML() {
      return this.domNode.outerHTML;
    }
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      var params = tasksList_get(tasksList_getPrototypeOf(TasksList.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
      return (0,util/* mergeDeep */.Ee)(params, {
        initParams: {
          origin: this.tasksListId,
          room: this.editor.options.serverRoom
        }
      });
    }
  }, {
    key: "cloneSelf",
    value: function cloneSelf() {
      var map = this.store.createMap();
      var options = {
        origin: this.tasksListId
      };
      parchment_default().query(this.map.get('type')).initMap(map, this.store, options);
      return map.get('id');
    }
  }, {
    key: "remove",
    value: function remove() {
      var _get5;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      (_get5 = tasksList_get(tasksList_getPrototypeOf(TasksList.prototype), "remove", this)).call.apply(_get5, [this].concat(args));
    }
  }, {
    key: "deleteBlot",
    value: function deleteBlot() {
      var tasksManager = this.editor.plugins.tasksManager;
      tasksManager.taskListRemove(this.tasksListId);
      tasksList_get(tasksList_getPrototypeOf(TasksList.prototype), "deleteSingeBlot", this).call(this);
    }
  }, {
    key: "showTitle",
    get: function get() {
      if (this.map.get('showTitle') === undefined) {
        return true;
      } else {
        return this.map.get('showTitle');
      }
    }
  }, {
    key: "contextMenu",
    get: function get() {
      var menu = tasksList_get(tasksList_getPrototypeOf(TasksList.prototype), "contextMenu", this);
      menu['delete'].action = 'deleteBlot';
      return menu;
    }
  }, {
    key: "exec",
    value: function exec(action) {
      var processed = false;
      if (action.type === 'backspace') {
        var _this$scroll$selectio = this.scroll.selection.getRange(),
          _this$scroll$selectio2 = tasksList_slicedToArray(_this$scroll$selectio, 1),
          range = _this$scroll$selectio2[0];
        this.scroll.selection.setRange({
          index: range.index - 1,
          length: 0
        });
        action.dontRestoreSelection();
        processed = true;
      }
      return processed;
    }
  }], [{
    key: "create",
    value: function create(value) {
      var node = tasksList_get(tasksList_getPrototypeOf(TasksList), "create", this).call(this, value);
      node.classList.add(TASKSLIST_CLASS);
      var tasksListContainer = document.createElement('div');
      tasksListContainer.setAttribute('contenteditable', false);
      tasksListContainer.classList.add(TASKSLIST_CONTAINER_CLASS);
      node.appendChild(tasksListContainer);
      return node;
    }
  }, {
    key: "createBlot",
    value: function createBlot(editor) {
      var blot = parchment_default().create('tasks-list');
      this.addCaretTrap(editor, blot.domNode);
      return blot;
    }
  }, {
    key: "setUserMutex",
    value: function setUserMutex(map, store) {
      map.set('createByUserId', store.userId);
    }
  }, {
    key: "removeUserMutex",
    value: function removeUserMutex(map) {
      map.delete('createByUserId');
    }
  }, {
    key: "isProcessedByAnotherUser",
    value: function isProcessedByAnotherUser(map, store) {
      return map.get('createByUserId') && map.get('createByUserId') !== store.userId;
    }
  }]);
  return TasksList;
}(tasksList_mixin(blockEmbed));

TasksList.blotName = 'tasks-list';
TasksList.tagName = 'DIV';
TasksList.initMap = function (map, store) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  map.set('type', 'tasks-list');
  if (params.origin) {
    var origin = {
      id: params.origin
    };
    if (params.room) {
      origin.room = params.room;
    }
    map.set('origin', origin);
  }
  if (params.tasksListId) {
    map.set('tasksListId', params.tasksListId);

    // записываем в кэш то что таск-лист добавлен через конвертацию колонки доски
    if (params.fromColumn) {
      if (!store.cache.get(TASKSLIST_CACHE_KEY)) {
        store.cache.set(TASKSLIST_CACHE_KEY, new store.Y.Map());
      }
      store.cache.get(TASKSLIST_CACHE_KEY, store.Y.Map).set(params.tasksListId, {
        boardId: params.boardId,
        beforeColumnId: params.beforeColumnId
      });
    }
  }
};
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/board/boardComponent.js
function boardComponent_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { boardComponent_typeof = function _typeof(obj) { return typeof obj; }; } else { boardComponent_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return boardComponent_typeof(obj); }
function boardComponent_extends() { boardComponent_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return boardComponent_extends.apply(this, arguments); }












function boardComponent_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function boardComponent_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function boardComponent_createClass(Constructor, protoProps, staticProps) { if (protoProps) boardComponent_defineProperties(Constructor.prototype, protoProps); if (staticProps) boardComponent_defineProperties(Constructor, staticProps); return Constructor; }
function boardComponent_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) boardComponent_setPrototypeOf(subClass, superClass); }
function boardComponent_setPrototypeOf(o, p) { boardComponent_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return boardComponent_setPrototypeOf(o, p); }
function boardComponent_createSuper(Derived) { var hasNativeReflectConstruct = boardComponent_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = boardComponent_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = boardComponent_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return boardComponent_possibleConstructorReturn(this, result); }; }
function boardComponent_possibleConstructorReturn(self, call) { if (call && (boardComponent_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return boardComponent_assertThisInitialized(self); }
function boardComponent_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function boardComponent_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function boardComponent_getPrototypeOf(o) { boardComponent_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return boardComponent_getPrototypeOf(o); }
function boardComponent_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var BoardComponent = /*#__PURE__*/function (_Component) {
  boardComponent_inherits(BoardComponent, _Component);
  var _super = boardComponent_createSuper(BoardComponent);
  function BoardComponent() {
    var _this;
    boardComponent_classCallCheck(this, BoardComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    boardComponent_defineProperty(boardComponent_assertThisInitialized(_this), "onRef", function (node) {
      if (node && _this.props.outputs) {
        var outputs = _this.props.outputs;
        var eventNames = Object.keys(outputs);
        for (var _i = 0, _eventNames = eventNames; _i < _eventNames.length; _i++) {
          var eventName = _eventNames[_i];
          node.addEventListener(eventName, outputs[eventName]);
        }
      }
    });
    return _this;
  }
  boardComponent_createClass(BoardComponent, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (lodash_isequal_default()(this.props, nextProps)) {
        return false;
      }
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var inputs = this.props.inputs;
      return (0,preact_module.h)("nim-tasks-board", boardComponent_extends({}, inputs, {
        ref: this.onRef
      }));
    }
  }], [{
    key: "isRegisteredBoardComponent",
    value: function isRegisteredBoardComponent() {
      // веб компонент тасков является NgElement конструктором
      return document.createElement('nim-tasks-board').constructor !== HTMLElement;
    }
  }]);
  return BoardComponent;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/board/boardOuterRenderer.js
function boardOuterRenderer_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { boardOuterRenderer_typeof = function _typeof(obj) { return typeof obj; }; } else { boardOuterRenderer_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return boardOuterRenderer_typeof(obj); }










function boardOuterRenderer_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function boardOuterRenderer_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function boardOuterRenderer_createClass(Constructor, protoProps, staticProps) { if (protoProps) boardOuterRenderer_defineProperties(Constructor.prototype, protoProps); if (staticProps) boardOuterRenderer_defineProperties(Constructor, staticProps); return Constructor; }
function boardOuterRenderer_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) boardOuterRenderer_setPrototypeOf(subClass, superClass); }
function boardOuterRenderer_setPrototypeOf(o, p) { boardOuterRenderer_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return boardOuterRenderer_setPrototypeOf(o, p); }
function boardOuterRenderer_createSuper(Derived) { var hasNativeReflectConstruct = boardOuterRenderer_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = boardOuterRenderer_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = boardOuterRenderer_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return boardOuterRenderer_possibleConstructorReturn(this, result); }; }
function boardOuterRenderer_possibleConstructorReturn(self, call) { if (call && (boardOuterRenderer_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return boardOuterRenderer_assertThisInitialized(self); }
function boardOuterRenderer_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function boardOuterRenderer_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function boardOuterRenderer_getPrototypeOf(o) { boardOuterRenderer_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return boardOuterRenderer_getPrototypeOf(o); }
function boardOuterRenderer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BoardOuterRenderer = /*#__PURE__*/function (_Component) {
  boardOuterRenderer_inherits(BoardOuterRenderer, _Component);
  var _super = boardOuterRenderer_createSuper(BoardOuterRenderer);
  function BoardOuterRenderer() {
    var _this;
    boardOuterRenderer_classCallCheck(this, BoardOuterRenderer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    boardOuterRenderer_defineProperty(boardOuterRenderer_assertThisInitialized(_this), "onRef", function (node) {
      _this.props.onRef && _this.props.onRef(node, {
        inputs: _this.props.inputs,
        outputs: _this.props.outputs,
        defaultView: _this.props.defaultView
      });
    });
    return _this;
  }
  boardOuterRenderer_createClass(BoardOuterRenderer, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      return (0,preact_module.h)("div", {
        ref: this.onRef
      });
    }
  }]);
  return BoardOuterRenderer;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/board/board.js
function board_slicedToArray(arr, i) { return board_arrayWithHoles(arr) || board_iterableToArrayLimit(arr, i) || board_unsupportedIterableToArray(arr, i) || board_nonIterableRest(); }
function board_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function board_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return board_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return board_arrayLikeToArray(o, minLen); }
function board_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function board_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function board_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function board_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function board_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { board_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { board_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function board_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function board_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { board_ownKeys(Object(source), true).forEach(function (key) { board_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { board_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function board_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { board_typeof = function _typeof(obj) { return typeof obj; }; } else { board_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return board_typeof(obj); }





















function board_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function board_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function board_createClass(Constructor, protoProps, staticProps) { if (protoProps) board_defineProperties(Constructor.prototype, protoProps); if (staticProps) board_defineProperties(Constructor, staticProps); return Constructor; }
function board_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { board_get = Reflect.get; } else { board_get = function _get(target, property, receiver) { var base = board_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return board_get(target, property, receiver || target); }
function board_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = board_getPrototypeOf(object); if (object === null) break; } return object; }
function board_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) board_setPrototypeOf(subClass, superClass); }
function board_setPrototypeOf(o, p) { board_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return board_setPrototypeOf(o, p); }
function board_createSuper(Derived) { var hasNativeReflectConstruct = board_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = board_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = board_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return board_possibleConstructorReturn(this, result); }; }
function board_possibleConstructorReturn(self, call) { if (call && (board_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return board_assertThisInitialized(self); }
function board_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function board_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function board_getPrototypeOf(o) { board_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return board_getPrototypeOf(o); }
function board_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


















var board_mixin = mix([commentable, embeddable, draggable, dropAcceptor, selectable, focusable, executable, basic]);
var BOARD_CLASS = 'nimbus-board';
var BOARD_CONTAINER_CLASS = 'nimbus-board-container';
var BOARDS_CACHE_KEY = 'board-from-task-list';
var DEFAULT_LAYOUT = {
  'add-new-column': true
};
var Board = /*#__PURE__*/function (_mixin) {
  board_inherits(Board, _mixin);
  var _super = board_createSuper(Board);
  function Board(domNode) {
    var _this;
    board_classCallCheck(this, Board);
    _this = _super.call(this, domNode);
    board_defineProperty(board_assertThisInitialized(_this), "onEditorUpdate", function () {
      if (_this.parent.constructor.blotName === 'gridCol') {
        if (_this.domNode.hasAttribute('style')) {
          _this.domNode.removeAttribute('style');
        }
        return;
      }
      var scrollable = _this.domNode.querySelector('.task-board-column-list');
      if (scrollable) {
        var maxWidth = _this.editor.scrollingContainer.getBoundingClientRect().width - 110;
        var scrollWidth = scrollable.scrollWidth;
        var _this$domNode$getBoun = _this.domNode.getBoundingClientRect(),
          currentWidth = _this$domNode$getBoun.width;
        var _this$scroll$domNode$ = _this.scroll.domNode.getBoundingClientRect(),
          scrollBlotWidth = _this$scroll$domNode$.width;
        if (maxWidth < scrollBlotWidth || scrollWidth <= scrollBlotWidth) {
          if (_this.domNode.hasAttribute('style')) {
            _this.domNode.removeAttribute('style');
          }
          if (_this.domNode.classList.contains(RESIZEABLE_CLASSES.containerOversize)) {
            _this.domNode.classList.remove(RESIZEABLE_CLASSES.containerOversize);
          }
        } else if (currentWidth < maxWidth && currentWidth < scrollWidth || currentWidth > scrollWidth && scrollWidth > scrollBlotWidth || currentWidth > maxWidth) {
          var availableWidth = Math.min(maxWidth, scrollWidth);
          _this.domNode.style.width = availableWidth + 1 + 'px';
          _this.domNode.style.marginLeft = -((availableWidth - scrollBlotWidth) / 2) + 'px';
          _this.domNode.classList.add(RESIZEABLE_CLASSES.containerOversize);
        }
      }
    });
    board_defineProperty(board_assertThisInitialized(_this), "onBlotMenuUpdatePosition", function (_ref) {
      var left = _ref.left,
        top = _ref.top;
      return {
        left: left + parseInt(_this.domNode.style.marginLeft || 0),
        top: _this.blotConfig.onKanbanRender ? top + 8 : top
      };
    });
    board_defineProperty(board_assertThisInitialized(_this), "mapObserver", function (event, _ref2) {
      var local = _ref2.local;
      // тут отказался от вызова this.render(), так как на перерендер должно повлиять только добавление/изменение kanbanId
      // при этом нам обязательно нужно вызывать setProps, он и вызовет перерендер компонента
      if (event.keysChanged.has('boardId')) {
        if (!local) {
          if (Boolean(_this.boardId) && typeof _this.boardId !== 'undefined') {
            _this.setPropsForBoard();
          }
        }
      }
      if (event.keysChanged.has('layout')) {
        if (_this.blotConfig.onKanbanRender !== undefined && _this.blotConfig.onComponentPropsChanged !== undefined) {
          _this.onOuterRendererPropsChange();
        } else {
          _this.render();
        }
      }
    });
    board_defineProperty(board_assertThisInitialized(_this), "onBoardRename", function () {
      var _this$editor$plugins$, _this$editor$plugins$2;
      (_this$editor$plugins$ = _this.editor.plugins.boardManager) === null || _this$editor$plugins$ === void 0 ? void 0 : (_this$editor$plugins$2 = _this$editor$plugins$.renameBoard) === null || _this$editor$plugins$2 === void 0 ? void 0 : _this$editor$plugins$2.call(_this$editor$plugins$, _this.boardId);
    });
    board_defineProperty(board_assertThisInitialized(_this), "onAddNewColumn", function () {
      var _this$editor$plugins$3, _this$editor$plugins$4;
      (_this$editor$plugins$3 = _this.editor.plugins.boardManager) === null || _this$editor$plugins$3 === void 0 ? void 0 : (_this$editor$plugins$4 = _this$editor$plugins$3.addNewColumn) === null || _this$editor$plugins$4 === void 0 ? void 0 : _this$editor$plugins$4.call(_this$editor$plugins$3, _this.boardId);
    });
    board_defineProperty(board_assertThisInitialized(_this), "onChangeLayout", function (value) {
      var layout = _this.map.get('layout');
      if (board_typeof(layout) === 'object') {
        if (layout.hasOwnProperty(value)) {
          _this.map.set('layout', Object.assign({}, layout, board_defineProperty({}, value, !layout[value])));
        } else {
          _this.map.set('layout', Object.assign({}, layout, board_defineProperty({}, value, !DEFAULT_LAYOUT[value])));
        }
      } else {
        _this.map.set('layout', Object.assign({}, DEFAULT_VALUE, board_defineProperty({}, value, !DEFAULT_LAYOUT[value])));
      }
    });
    board_defineProperty(board_assertThisInitialized(_this), "onOuterRendererRef", function (node) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _this.blotConfig.onKanbanRender && _this.blotConfig.onKanbanRender(node, _this.boardId, 'kanban', options);
    });
    board_defineProperty(board_assertThisInitialized(_this), "onOuterRendererPropsChange", function () {
      var _this$map$get;
      var props = {};
      props.inputs = board_objectSpread(board_objectSpread({}, _this.props.boardProps), {}, {
        nimShowAddColumnButton: board_typeof(_this.map.get('layout')) ? (_this$map$get = _this.map.get('layout')) === null || _this$map$get === void 0 ? void 0 : _this$map$get['add-new-column'] : DEFAULT_LAYOUT['add-new-column']
      });
      if (!props.inputs.hasOwnProperty('nimLanguage')) {
        props.inputs.nimLanguage = _this.editor.options.language || _this.editor.plugins.i18n.language;
      }
      props.outputs = _this.editor.plugins.boardManager.featBoardOutputs();
      _this.blotConfig.onComponentPropsChanged(_this.boardId, props);
    });
    board_defineProperty(board_assertThisInitialized(_this), "onDefaultViewChange", function (_ref3) {
      var view = _ref3.view;
      _this.map.set('defaultView', view);
    });
    _this.isSeparableByClickApplicable = true;
    _this.addCanExecActions(['delete', 'backspace']);
    _this.disallowReplace = true;
    _this.domNode.classList.add(RESIZEABLE_CLASSES.enabled);
    _this.dontRemoveWithBackspace = true;
    return _this;
  }
  board_createClass(Board, [{
    key: "contentContainer",
    get: function get() {
      return this.domNode.querySelector('.' + BOARD_CONTAINER_CLASS);
    }
  }, {
    key: "boardId",
    get: function get() {
      return this.map.get('boardId');
    }
  }, {
    key: "attach",
    value: function () {
      var _attach = board_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _get2;
        var _len,
          args,
          _key,
          _this$editor$plugins,
          undoManager,
          boardManager,
          _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = _args[_key];
                }
                (_get2 = board_get(board_getPrototypeOf(Board.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
                this.store.observe(this.map, this.mapObserver);
                _this$editor$plugins = this.editor.plugins, undoManager = _this$editor$plugins.undoManager, boardManager = _this$editor$plugins.boardManager;
                if (!((undoManager.isUndoing() || undoManager.isRedoing()) && this.boardId)) {
                  _context.next = 8;
                  break;
                }
                this.editor.emitter.emit('board:restore', {
                  boardId: this.boardId
                });
                _context.next = 8;
                return boardManager.restoreBoard(this.boardId);
              case 8:
                if (this.map.get('origin')) {
                  if (!Board.isProcessedByAnotherUser(this.map, this.store)) {
                    Board.setUserMutex(this.map, this.store);
                  }
                  this.tryDuplicateBoard();
                } else {
                  if (!Boolean(this.boardId) || typeof this.boardId === 'undefined') {
                    if (!Board.isProcessedByAnotherUser(this.map, this.store)) {
                      Board.setUserMutex(this.map, this.store);
                    }
                    this.createBoard();
                  } else {
                    this.setPropsForBoard();
                  }
                }
                this.render();
                this.editor.on('editorUpdate', this.onEditorUpdate);
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function attach() {
        return _attach.apply(this, arguments);
      }
      return attach;
    }()
  }, {
    key: "detach",
    value: function detach() {
      // обрабатываем удаления доски через Ctr+Z 
      var _this$scroll$editor$p = this.scroll.editor.plugins,
        undoManager = _this$scroll$editor$p.undoManager,
        boardManager = _this$scroll$editor$p.boardManager;
      if (undoManager.isUndoing()) {
        var editor = this.scroll.editor;
        var store = editor.store;
        var cache = store.cache.get(BOARDS_CACHE_KEY);
        var boardId = this.domNode.getAttribute('board-id');
        var taskListId = cache === null || cache === void 0 ? void 0 : cache.get(boardId);
        // если доска была создана из таск-листа, то восстанавливаем таск-лист
        if (taskListId) {
          boardManager.convertBoardToTaskList(boardId, taskListId);
          cache.delete(boardId);
        } else {
          boardManager.boardRemove(boardId);
        }
      }
      if (board_get(board_getPrototypeOf(Board.prototype), "detach", this)) {
        var _get3;
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        (_get3 = board_get(board_getPrototypeOf(Board.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      }
      this.editor.off('editorUpdate', this.onEditorUpdate);
      this.store.unobserve(this.map, this.mapObserver);
    }
  }, {
    key: "onGetCommentPosition",
    value: function onGetCommentPosition(_ref4) {
      var left = _ref4.left,
        top = _ref4.top;
      if (this.blotConfig.onKanbanRender) {
        top += 5;
      }
      return {
        left: left,
        top: top
      };
    }
  }, {
    key: "onBoardCreate",
    value: function onBoardCreate(id) {
      this.editor.emitter.emit('board:create', {
        boardId: id
      });
    }
  }, {
    key: "tryDuplicateBoard",
    value: function () {
      var _tryDuplicateBoard = board_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this$map$get2, originBoardId, room, id;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!Board.isProcessedByAnotherUser(this.map, this.store)) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return");
              case 2:
                _context2.prev = 2;
                _this$map$get2 = this.map.get('origin'), originBoardId = _this$map$get2.id, room = _this$map$get2.room;
                _context2.next = 6;
                return this.editor.plugins.boardManager.duplicateBoard(originBoardId, room);
              case 6:
                id = _context2.sent;
                if (id) {
                  this.map.set('boardId', id);
                  this.onBoardCreate(id);
                }
              case 8:
                _context2.prev = 8;
                this.map.delete('origin');
                Board.removeUserMutex(this.map);
                this.setPropsForBoard();
                return _context2.finish(8);
              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2,, 8, 13]]);
      }));
      function tryDuplicateBoard() {
        return _tryDuplicateBoard.apply(this, arguments);
      }
      return tryDuplicateBoard;
    }()
  }, {
    key: "createBoard",
    value: function () {
      var _createBoard = board_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var id, props;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!Board.isProcessedByAnotherUser(this.map, this.store)) {
                  _context3.next = 2;
                  break;
                }
                return _context3.abrupt("return");
              case 2:
                _context3.prev = 2;
                _context3.next = 5;
                return this.editor.plugins.boardManager.createBoard();
              case 5:
                id = _context3.sent;
                if (id) {
                  this.map.set('boardId', id);
                  this.onBoardCreate(id);
                }
              case 7:
                _context3.prev = 7;
                Board.removeUserMutex(this.map);
                props = board_objectSpread({}, this.editor.plugins.boardManager.featBoardInputs());
                this.setPropsForBoard(props);
                return _context3.finish(7);
              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2,, 7, 12]]);
      }));
      function createBoard() {
        return _createBoard.apply(this, arguments);
      }
      return createBoard;
    }() /**
         * Функция ждёт пока веб компонент доски зарегистрируется и дальше вызывает коллбек об успешной загрузке
         * Необходим для того чтобы загружать бандл таск-листов только если в заметку добавлены доски
         * @returns {Promise<void>}
         */
  }, {
    key: "waitCustomElements",
    value: function () {
      var _waitCustomElements = board_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this2 = this;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", new Promise(function (resolve) {
                  var TID = setInterval(function () {
                    if (BoardComponent.isRegisteredBoardComponent(_this2.editor)) {
                      clearInterval(TID);
                      if (_this2.editor.plugins.boardManager.options.onCustomElementsLoaded) {
                        _this2.editor.plugins.boardManager.options.onCustomElementsLoaded();
                      }
                      resolve();
                    }
                  }, 1000);
                }));
              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      function waitCustomElements() {
        return _waitCustomElements.apply(this, arguments);
      }
      return waitCustomElements;
    }()
  }, {
    key: "setPropsForBoard",
    value: function () {
      var _setPropsForBoard = board_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var rawProps,
          props,
          _args5 = arguments;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                rawProps = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : null;
                if (!this.isSettingPropsInProcess) {
                  _context5.next = 3;
                  break;
                }
                return _context5.abrupt("return");
              case 3:
                this.isSettingPropsInProcess = true;

                // ждем пока веб компонент доски зарегистрируется
                if (!this.editor.plugins.boardManager.options.waitCustomElements) {
                  _context5.next = 9;
                  break;
                }
                this.editor.plugins.boardManager.options.waitCustomElements();
                if (BoardComponent.isRegisteredBoardComponent(this.editor)) {
                  _context5.next = 9;
                  break;
                }
                _context5.next = 9;
                return this.waitCustomElements();
              case 9:
                _context5.prev = 9;
                // убираем ошибку, но не вызываем перерендер, перерендер вызовет последующий setProps ниже
                this.props.boardError = false;
                if (!(!Boolean(this.boardId) || typeof this.boardId === 'undefined')) {
                  _context5.next = 13;
                  break;
                }
                throw new Error("BoardId for blot ".concat(this.id, " is undefined"));
              case 13:
                if (BoardComponent.isRegisteredBoardComponent()) {
                  _context5.next = 17;
                  break;
                }
                throw new Error("Blot ".concat(this.id, ": unable to get data to display Board"));
              case 17:
                if (!(!Boolean(rawProps) || board_typeof(rawProps) !== 'object' || Array.isArray(rawProps))) {
                  _context5.next = 21;
                  break;
                }
                rawProps = this.editor.plugins.boardManager.featBoardInputs();
                if (Boolean(rawProps)) {
                  _context5.next = 21;
                  break;
                }
                throw new Error('Props for board is undefined or false or null: ', rawProps);
              case 21:
                props = board_objectSpread(board_objectSpread({}, rawProps), {}, {
                  nimBoardId: this.boardId
                });
                this.setProps({
                  boardProps: props
                });
              case 23:
                _context5.next = 29;
                break;
              case 25:
                _context5.prev = 25;
                _context5.t0 = _context5["catch"](9);
                console.error(_context5.t0);
                this.setProps({
                  boardError: true
                });
              case 29:
                _context5.prev = 29;
                if (this.boardId) {
                  this.domNode.setAttribute('board-id', this.boardId);
                }
                this.isSettingPropsInProcess = false;
                return _context5.finish(29);
              case 33:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[9, 25, 29, 33]]);
      }));
      function setPropsForBoard() {
        return _setPropsForBoard.apply(this, arguments);
      }
      return setPropsForBoard;
    }()
  }, {
    key: "getDraggingNode",
    value: function getDraggingNode() {
      var _this$domNode$getBoun2 = this.domNode.getBoundingClientRect(),
        width = _this$domNode$getBoun2.width,
        height = _this$domNode$getBoun2.height;
      var node = document.createElement('div');
      node.classList.add('dragging-placeholder');
      node.style.width = width + 'px';
      node.style.height = height + 'px';
      return node;
    }
  }, {
    key: "render",
    value: function render() {
      var _get4,
        _this3 = this;
      (_get4 = board_get(board_getPrototypeOf(Board.prototype), "render", this)) === null || _get4 === void 0 ? void 0 : _get4.call(this);
      var props = {};
      var ToRenderComponent = (loader2_default());
      if (this.props.boardProps) {
        var _this$map$get3;
        props.inputs = board_objectSpread(board_objectSpread({}, this.props.boardProps), {}, {
          nimShowAddColumnButton: board_typeof(this.map.get('layout')) ? (_this$map$get3 = this.map.get('layout')) === null || _this$map$get3 === void 0 ? void 0 : _this$map$get3['add-new-column'] : DEFAULT_LAYOUT['add-new-column']
        });
        if (!props.inputs.hasOwnProperty('nimLanguage')) {
          props.inputs.nimLanguage = this.editor.options.language || this.editor.plugins.i18n.language;
        }
        if (!props.inputs.hasOwnProperty('nimScrollContainerId')) {
          var containerNode = this.editor.getScrollingContainer();
          if (containerNode.id && containerNode.id !== '') {
            props.inputs.nimScrollContainerId = containerNode.id;
          }
        }
        props.outputs = this.editor.plugins.boardManager.featBoardOutputs();
        if (this.blotConfig.onKanbanRender !== undefined) {
          props.onRef = this.onOuterRendererRef;
          props.defaultView = this.map.get('defaultView') || 'task-list';
          ToRenderComponent = BoardOuterRenderer;
        } else {
          ToRenderComponent = BoardComponent;
        }
      } else if (this.props.boardError) {
        ToRenderComponent = function ToRenderComponent() {
          return (0,preact_module.h)("span", {
            className: "board-not-supported"
          }, _this3.editor.plugins.i18n.get('board.not_supported'));
        };
      }
      (0,preact_module/* render */.sY)((0,preact_module.h)(ToRenderComponent, props), this.contentContainer);
    }
  }, {
    key: "toHTML",
    value: function toHTML() {
      return this.domNode.outerHTML;
    }
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      var params = board_get(board_getPrototypeOf(Board.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
      return (0,util/* mergeDeep */.Ee)(params, {
        initParams: {
          origin: this.boardId,
          room: this.editor.options.serverRoom
        }
      });
    }
  }, {
    key: "cloneSelf",
    value: function cloneSelf() {
      var map = this.store.createMap();
      var options = {
        origin: this.boardId
      };
      parchment_default().query(this.map.get('type')).initMap(map, this.store, options);
      return map.get('id');
    }
  }, {
    key: "deleteBlot",
    value: function deleteBlot() {
      var boardManager = this.editor.plugins.boardManager;
      boardManager.boardRemove(this.boardId);
      board_get(board_getPrototypeOf(Board.prototype), "deleteSingeBlot", this).call(this);
    }
  }, {
    key: "remove",
    value: function remove() {
      var _get5;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      (_get5 = board_get(board_getPrototypeOf(Board.prototype), "remove", this)).call.apply(_get5, [this].concat(args));
    }
  }, {
    key: "contextMenu",
    get: function get() {
      var _this$map$get4;
      var menu = Object.assign({}, board_get(board_getPrototypeOf(Board.prototype), "contextMenu", this));
      /* menu['rename'] = {
        label: this.editor.plugins.i18n.get('block_menu.rename'),
        index: 0,
        group: 0,
        action: 'onBoardRename',
        stackable: false
      } */
      menu['add-new-column'] = {
        label: this.editor.plugins.i18n.get('board.menu.add_new_column'),
        index: 1,
        group: 0,
        action: 'onAddNewColumn',
        stackable: false
      };
      var showAddNewColumn = board_typeof(this.map.get('layout')) ? (_this$map$get4 = this.map.get('layout')) === null || _this$map$get4 === void 0 ? void 0 : _this$map$get4['add-new-column'] : DEFAULT_LAYOUT['add-new-column'];
      menu['layout'] = {
        label: this.editor.plugins.i18n.get('board.menu.board_layout.name'),
        index: 1,
        group: 0,
        stackable: false,
        action: false,
        submenu: board_defineProperty({}, 'show-add-new-column', {
          label: this.editor.plugins.i18n.get('board.menu.board_layout.show_add_new_column'),
          index: 0,
          group: 0,
          action: 'onChangeLayout',
          actionParams: 'add-new-column',
          icon: showAddNewColumn ? icons/* IconDone */.EZi : false,
          style: showAddNewColumn ? 'done' : 'undone'
        })
      };
      menu['delete'].action = 'deleteBlot';
      return menu;
    }
  }, {
    key: "exec",
    value: function exec(action) {
      var processed = false;
      if (action.type === 'backspace') {
        var _this$scroll$selectio = this.scroll.selection.getRange(),
          _this$scroll$selectio2 = board_slicedToArray(_this$scroll$selectio, 1),
          range = _this$scroll$selectio2[0];
        this.scroll.selection.setRange({
          index: range.index - 1,
          length: 0
        });
        action.dontRestoreSelection();
        processed = true;
      }
      return processed;
    }
  }], [{
    key: "create",
    value: function create(value) {
      var node = board_get(board_getPrototypeOf(Board), "create", this).call(this, value);
      node.classList.add(BOARD_CLASS);
      var boardContainer = document.createElement('div');
      boardContainer.setAttribute('contenteditable', false);
      boardContainer.classList.add(BOARD_CONTAINER_CLASS);
      node.appendChild(boardContainer);
      return node;
    }
  }, {
    key: "createBlot",
    value: function createBlot(editor) {
      var blot = parchment_default().create('board');
      this.addCaretTrap(editor, blot.domNode);
      return blot;
    }
  }, {
    key: "setUserMutex",
    value: function setUserMutex(map, store) {
      map.set('createByUserId', store.userId);
    }
  }, {
    key: "removeUserMutex",
    value: function removeUserMutex(map) {
      map.delete('createByUserId');
    }
  }, {
    key: "isProcessedByAnotherUser",
    value: function isProcessedByAnotherUser(map, store) {
      return map.get('createByUserId') && map.get('createByUserId') !== store.userId;
    }
  }]);
  return Board;
}(board_mixin(blockEmbed));

Board.blotName = 'board';
Board.tagName = 'DIV';
Board.initMap = function (map, store) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  map.set('type', 'board');
  if (params.origin) {
    var origin = {
      id: params.origin
    };
    if (params.room) {
      origin.room = params.room;
    }
    map.set('origin', origin);
  }
  if (params.boardId) {
    map.set('boardId', params.boardId);

    // записываем в кэш то что доска добавлен через конвертацию таск-листа в доску
    if (params.fromTasksList) {
      if (!store.cache.get(BOARDS_CACHE_KEY)) {
        store.cache.set(BOARDS_CACHE_KEY, new store.Y.Map());
      }
      store.cache.get(BOARDS_CACHE_KEY, store.Y.Map).set(params.boardId, params.tasksListId);
    }
  }
  var layout = params.layout || {};
  map.set('layout', Object.assign(DEFAULT_LAYOUT, layout));
};
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/uploader/uploaderComponent.js

function uploaderComponent_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function uploaderComponent_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { uploaderComponent_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { uploaderComponent_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }














function uploaderComponent_toConsumableArray(arr) { return uploaderComponent_arrayWithoutHoles(arr) || uploaderComponent_iterableToArray(arr) || uploaderComponent_unsupportedIterableToArray(arr) || uploaderComponent_nonIterableSpread(); }
function uploaderComponent_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function uploaderComponent_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function uploaderComponent_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return uploaderComponent_arrayLikeToArray(arr); }
function uploaderComponent_slicedToArray(arr, i) { return uploaderComponent_arrayWithHoles(arr) || uploaderComponent_iterableToArrayLimit(arr, i) || uploaderComponent_unsupportedIterableToArray(arr, i) || uploaderComponent_nonIterableRest(); }
function uploaderComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function uploaderComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return uploaderComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return uploaderComponent_arrayLikeToArray(o, minLen); }
function uploaderComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function uploaderComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function uploaderComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



var ICONS = {
  image: icons/* IconImage */.Zay,
  video: icons/* IconVideo */.OiJ,
  audio: icons/* IconAudio */.PWQ,
  doc: icons/* IconDocument */.szK,
  file: icons/* IconFileOther */.mrQ
};
function UpoaderComponent(props) {
  var editable = props.editable,
    i18n = props.i18n,
    id = props.id;
  var _useState = (0,hooks_module/* useState */.eJ)([]),
    _useState2 = uploaderComponent_slicedToArray(_useState, 2),
    filesToUpload = _useState2[0],
    setFilesToUpload = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)([]),
    _useState4 = uploaderComponent_slicedToArray(_useState3, 2),
    uploadedFiles = _useState4[0],
    setUploadedFiles = _useState4[1];
  var _useState5 = (0,hooks_module/* useState */.eJ)([]),
    _useState6 = uploaderComponent_slicedToArray(_useState5, 2),
    errorFiles = _useState6[0],
    setErrorFiles = _useState6[1];
  var _useState7 = (0,hooks_module/* useState */.eJ)([]),
    _useState8 = uploaderComponent_slicedToArray(_useState7, 2),
    tooBigFiles = _useState8[0],
    setTooBigFiles = _useState8[1];
  var _useState9 = (0,hooks_module/* useState */.eJ)(0),
    _useState10 = uploaderComponent_slicedToArray(_useState9, 2),
    progress = _useState10[0],
    setProgress = _useState10[1];
  var _useState11 = (0,hooks_module/* useState */.eJ)(null),
    _useState12 = uploaderComponent_slicedToArray(_useState11, 2),
    task = _useState12[0],
    setTask = _useState12[1];
  var filesRef = (0,hooks_module/* useRef */.sO)({
    filesToUpload: filesToUpload,
    uploadedFiles: uploadedFiles,
    errorFiles: errorFiles,
    tooBigFiles: tooBigFiles
  });
  var attachmentManager = props.editor.plugins.attachmentManager;
  var onProgress = function onProgress(value) {
    setProgress(Math.min(Math.round(value.loaded / value.total * 100), 100));
  };
  var processTask = function processTask(saveFileTask, taskResultPromise) {
    saveFileTask.onProgress = onProgress;
    taskResultPromise.then(function (attachment) {
      if (!attachment) {
        return;
      }
      console.log('processTask: file was uploaded successfully, received attachment info', attachment);
      props.onFileUploaded && props.onFileUploaded(attachment.globalId, getType(filesRef.current.filesToUpload[0]));
    }).then(function () {
      setProgress(0);
      setTask(null);
      if (filesRef.current.filesToUpload.length > 1) {
        setUploadedFiles([].concat(uploaderComponent_toConsumableArray(filesRef.current.uploadedFiles), [filesRef.current.filesToUpload.shift()]));
      } else {
        filesRef.current.filesToUpload.shift();
        setUploadedFiles([]);
      }
    }).catch(function (err) {
      setProgress(0);
      setTask(null);
      if (filesRef.current.filesToUpload.length && !saveFileTask.aborted) {
        setErrorFiles([filesRef.current.filesToUpload.shift()].concat(uploaderComponent_toConsumableArray(filesRef.current.errorFiles)));
      } else {
        setErrorFiles(uploaderComponent_toConsumableArray(filesRef.current.errorFiles));
      }
    });
    return saveFileTask;
  };
  var createTask = function createTask(file) {
    file = attachmentManager.beforeSaveFile(file);
    return attachmentManager.saveFile(file, {
      blotName: 'uploader',
      blotId: id
    });
  };
  var getType = function getType(file) {
    if (!file.type || typeof file.type !== 'string') {
      return null;
    }
    if (file.type.indexOf('audio') >= 0) {
      return 'audio';
    } else if (file.type.indexOf('video') >= 0) {
      return 'video';
    } else if (file.type.indexOf('image') >= 0) {
      return 'image';
    } else if (file.type.indexOf('text') >= 0 || file.type.indexOf('pdf') >= 0 || file.type.indexOf('doc') >= 0) {
      return 'doc';
    }
  };
  var getIcon = function getIcon(type) {
    return type && typeof type === 'string' && ICONS.hasOwnProperty(type) ? ICONS[type] : ICONS.file;
  };
  (0,hooks_module/* useEffect */.d4)(function () {
    filesRef.current = {
      filesToUpload: filesToUpload,
      uploadedFiles: uploadedFiles,
      errorFiles: errorFiles,
      tooBigFiles: tooBigFiles
    };
    if (filesToUpload.length && !task) {
      var saveFileTask = createTask(filesToUpload[0]);
      setTask(processTask(saveFileTask, saveFileTask.run()));
    }
  }, [filesToUpload, uploadedFiles, errorFiles, tooBigFiles]);
  var onRemoveFileFromQueue = function onRemoveFileFromQueue(index, type) {
    if (type === 'error') {
      var files = Array.from(errorFiles);
      files.splice(index, 1);
      setErrorFiles(files);
    } else if (type === 'tooBig') {
      var _files = Array.from(tooBigFiles);
      _files.splice(index, 1);
      setTooBigFiles(_files);
    } else {
      var _files2 = Array.from(filesToUpload);
      _files2.splice(index, 1);
      if (index === 0 && task) {
        filesToUpload.shift();
        task.abort();
      } else {
        setFilesToUpload(_files2);
      }
    }
  };
  var addFilesToQueue = /*#__PURE__*/function () {
    var _ref = uploaderComponent_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(files) {
      var filesToQueue, validateRes;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              filesToQueue = files.filter(function (file) {
                if (attachmentManager.checkFileSize(file.size)) {
                  return true;
                } else {
                  tooBigFiles.unshift(file);
                  return false;
                }
              });
              _context.next = 3;
              return attachmentManager.validateFiles(files);
            case 3:
              validateRes = _context.sent;
              if (validateRes) {
                setFilesToUpload([].concat(uploaderComponent_toConsumableArray(filesToUpload), uploaderComponent_toConsumableArray(filesToQueue)));
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function addFilesToQueue(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var onChooseFiles = /*#__PURE__*/function () {
    var _ref2 = uploaderComponent_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(event) {
      var fileParams, files;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (editable) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              fileParams = {
                multiple: true,
                source: 'user',
                blotName: 'uploader'
              };
              _context2.next = 5;
              return attachmentManager.chooseFile(fileParams);
            case 5:
              files = _context2.sent;
              if (files) {
                addFilesToQueue(files);
              }
            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function onChooseFiles(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var onDrop = function onDrop(event) {
    if (!editable) return; // убрать, когда будет поддержка в шарах
    event.target.closest('.uploader-dropzone').classList.remove('active');
    if (event.dataTransfer.files.length) {
      event.preventDefault();
      var files = Array.from(event.dataTransfer.files).map(function (file) {
        return attachmentManager.nFileFromWebFile(file);
      });
      if (files.length) {
        addFilesToQueue(files);
      }
    }
  };
  var onDragEnter = function onDragEnter(event) {
    if (!editable) return;
    event.target.closest('.uploader-dropzone').classList.add('active');
  };
  var onDragLeave = function onDragLeave(event) {
    if (!editable) return;
    event.target.closest('.uploader-dropzone').classList.remove('active');
  };
  var onDragOver = function onDragOver(event) {
    if (!editable) return;
    event.preventDefault();
  };
  var hasQueue = filesToUpload.length || errorFiles.length || tooBigFiles.length;
  return (0,preact_module.h)("div", {
    className: 'uploader-interface' + (hasQueue ? ' has-queue' : '')
  }, filesToUpload.length ? (0,preact_module.h)("div", {
    className: "uploader-progress"
  }, (0,preact_module.h)("div", {
    className: "uploader-progress-bar"
  }, (0,preact_module.h)("div", {
    className: "uploader-progress-bar-fill",
    style: {
      width: progress + '%'
    }
  })), (0,preact_module.h)("div", {
    className: "uploader-progress-counter"
  }, i18n.get('uploader.uploading_files'), " (", i18n.get('uploader.counter', {
    current: uploadedFiles.length + 1,
    total: uploadedFiles.length + filesToUpload.length + errorFiles.length + tooBigFiles.length
  }), ")"), (0,preact_module.h)("div", {
    className: "uploader-progress-timer"
  }, "(", i18n.get('uploader.timer'), ")")) : null, hasQueue ? (0,preact_module.h)("div", {
    className: "uploader-queue"
  }, filesToUpload.length ? filesToUpload.map(function (file, index) {
    var FileIcon = getIcon(getType(file));
    return (0,preact_module.h)("div", {
      className: "uploader-queue-item"
    }, (0,preact_module.h)("div", {
      className: "uploader-queue-item-left"
    }, (0,preact_module.h)("span", {
      className: "file-type-icon"
    }, (0,preact_module.h)(FileIcon, null)), (0,preact_module.h)("span", {
      className: "file-name"
    }, file.name)), (0,preact_module.h)("div", {
      className: "uploader-queue-item-right"
    }, (0,preact_module.h)("span", {
      className: "file-uploading-progress"
    }, i18n.get('uploader.uploading_progress', {
      progress: index === 0 ? progress : 0
    })), (0,preact_module.h)("span", {
      className: "file-uploading-cancel",
      onClick: onRemoveFileFromQueue.bind(undefined, index)
    }, (0,preact_module.h)(icons/* IconClose */.bMz, null))));
  }) : null, errorFiles.length ? errorFiles.map(function (file, index) {
    var FileIcon = getIcon(file.type);
    return (0,preact_module.h)("div", {
      className: "uploader-queue-item"
    }, (0,preact_module.h)("div", {
      className: "uploader-queue-item-left"
    }, (0,preact_module.h)("span", {
      className: "file-type-icon"
    }, (0,preact_module.h)(FileIcon, null)), (0,preact_module.h)("span", {
      className: "file-name"
    }, file.name)), (0,preact_module.h)("div", {
      className: "uploader-queue-item-right"
    }, (0,preact_module.h)("span", {
      className: "file-uploading-progress error-uploading"
    }, i18n.get('uploader.errors.network')), (0,preact_module.h)("span", {
      className: "file-uploading-cancel",
      onClick: onRemoveFileFromQueue.bind(undefined, index, 'error')
    }, (0,preact_module.h)(icons/* IconClose */.bMz, null))));
  }) : null, tooBigFiles.length ? tooBigFiles.map(function (file, index) {
    var FileIcon = getIcon(file.type);
    return (0,preact_module.h)("div", {
      className: "uploader-queue-item"
    }, (0,preact_module.h)("div", {
      className: "uploader-queue-item-left"
    }, (0,preact_module.h)("span", {
      className: "file-type-icon"
    }, (0,preact_module.h)(FileIcon, null)), (0,preact_module.h)("span", {
      className: "file-name"
    }, file.name)), (0,preact_module.h)("div", {
      className: "uploader-queue-item-right"
    }, (0,preact_module.h)("span", {
      className: "file-uploading-progress too-big-file"
    }, i18n.get('uploader.errors.too_big')), (0,preact_module.h)("span", {
      className: "file-uploading-cancel",
      onClick: onRemoveFileFromQueue.bind(undefined, index, 'tooBig')
    }, (0,preact_module.h)(icons/* IconClose */.bMz, null))));
  }) : null) : null, (0,preact_module.h)("div", {
    className: "uploader-dropzone",
    onDrop: onDrop,
    onDragOver: onDragOver,
    onDragEnter: onDragEnter,
    onDragLeave: onDragLeave
  }, (0,preact_module.h)("div", {
    className: "uploader-dropzone-icon"
  }, !hasQueue ? (0,preact_module.h)(icons/* IconDownload */.DjJ, null) : (0,preact_module.h)(icons/* IconPlus */.SC9, null)), (0,preact_module.h)("div", {
    className: "uploader-dropzone-description"
  }, !hasQueue ? (0,preact_module.h)("span", null, i18n.get('uploader.dropzone_full'), " ", (0,preact_module.h)("span", {
    className: "uploader-dropzone-link",
    onClick: onChooseFiles
  }, i18n.get('uploader.browse'))) : (0,preact_module.h)("span", {
    className: "uploader-dropzone-link",
    onClick: onChooseFiles
  }, i18n.get('uploader.dropzone_compact')))));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/uploader/uploader.js
function uploader_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { uploader_typeof = function _typeof(obj) { return typeof obj; }; } else { uploader_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return uploader_typeof(obj); }














function uploader_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function uploader_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function uploader_createClass(Constructor, protoProps, staticProps) { if (protoProps) uploader_defineProperties(Constructor.prototype, protoProps); if (staticProps) uploader_defineProperties(Constructor, staticProps); return Constructor; }
function uploader_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { uploader_get = Reflect.get; } else { uploader_get = function _get(target, property, receiver) { var base = uploader_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return uploader_get(target, property, receiver || target); }
function uploader_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = uploader_getPrototypeOf(object); if (object === null) break; } return object; }
function uploader_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) uploader_setPrototypeOf(subClass, superClass); }
function uploader_setPrototypeOf(o, p) { uploader_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return uploader_setPrototypeOf(o, p); }
function uploader_createSuper(Derived) { var hasNativeReflectConstruct = uploader_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = uploader_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = uploader_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return uploader_possibleConstructorReturn(this, result); }; }
function uploader_possibleConstructorReturn(self, call) { if (call && (uploader_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return uploader_assertThisInitialized(self); }
function uploader_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function uploader_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function uploader_getPrototypeOf(o) { uploader_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return uploader_getPrototypeOf(o); }
function uploader_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }















var uploader_mixin = mix([commentable, blotLock, focusable, selectable, executable, embeddable, basic]);
var UPLOADER_CLASS_NAME = 'nimbus-uploader';
var Uploader = /*#__PURE__*/function (_mixin) {
  uploader_inherits(Uploader, _mixin);
  var _super = uploader_createSuper(Uploader);
  function Uploader(domNode) {
    var _this;
    uploader_classCallCheck(this, Uploader);
    _this = _super.call(this, domNode);
    uploader_defineProperty(uploader_assertThisInitialized(_this), "mapObserver", function () {
      _this.render();
    });
    uploader_defineProperty(uploader_assertThisInitialized(_this), "onFileUploaded", function (attachmentGlobalId, type) {
      _this.scroll.execInBatch(function () {
        _this.containerBlot.addBlot('file', {
          attachmentGlobalId: attachmentGlobalId,
          viewMode: type === 'image' ? 'full' : 'compact',
          disallowNoteDownloading: _this.disallowNote,
          disallowShareDownloading: _this.disallowShare
        });
      });
    });
    uploader_defineProperty(uploader_assertThisInitialized(_this), "onClickMenuConvertToFiles", function () {
      var fileBlots = _this.getAllFileBlots();
      if (fileBlots && fileBlots.length) {
        _this.scroll.execInBatch(function () {
          var index = _this.container.getChildIndex(_this.id) + 1;
          fileBlots.forEach(function (blot) {
            _this.container.moveChild(blot.id, index);
            index++;
          });
          _this.container.removeChildById(_this.id);
        });
      }
    });
    uploader_defineProperty(uploader_assertThisInitialized(_this), "onClickMenuDisallowNote", function () {
      _this.map.set('disallowNoteDownloading', !Boolean(_this.disallowNote));
      var fileBlots = _this.getAllFileBlots();
      if (fileBlots && fileBlots.length) {
        fileBlots.forEach(function (blot) {
          blot.map.set('disallowNoteDownloading', _this.disallowNote);
        });
      }
    });
    uploader_defineProperty(uploader_assertThisInitialized(_this), "onClickMenuDisallowShare", function () {
      _this.map.set('disallowShareDownloading', !Boolean(_this.disallowShare));
      var fileBlots = _this.getAllFileBlots();
      if (fileBlots && fileBlots.length) {
        fileBlots.forEach(function (blot) {
          blot.map.set('disallowShareDownloading', _this.disallowShare);
        });
      }
    });
    uploader_defineProperty(uploader_assertThisInitialized(_this), "onClickEnableInPublicPage", function () {
      _this.map.set('enabledInPublicPage', !Boolean(_this.enabledInPublicPage));
    });
    return _this;
  }
  uploader_createClass(Uploader, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = uploader_get(uploader_getPrototypeOf(Uploader.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      this.store.observe(this.map, this.mapObserver);
      this.render();
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = uploader_get(uploader_getPrototypeOf(Uploader.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      this.store.unobserve(this.map, this.mapObserver);
    }
  }, {
    key: "getWrapper",
    value: function getWrapper() {
      return this.parent;
    }
  }, {
    key: "getCommentsAnchorNode",
    value: function getCommentsAnchorNode() {
      return this.getWrapper().head.domNode;
    }
  }, {
    key: "onBlotMenuUpdatePosition",
    value: function onBlotMenuUpdatePosition(_ref) {
      var left = _ref.left,
        top = _ref.top;
      var offset = getContainerOffset(this.domNode, this.getWrapper().domNode);
      top -= offset.y;
      left -= offset.x;
      return {
        left: left,
        top: top
      };
    }
  }, {
    key: "getCorrectCommentPosition",
    value: function getCorrectCommentPosition(_ref2) {
      var top = _ref2.top,
        left = _ref2.left;
      var wrapperRect = this.getWrapper().domNode.getBoundingClientRect();
      var selfRect = this.domNode.getBoundingClientRect();
      var offsetTop = selfRect.top - wrapperRect.top;
      var offsetLeft = wrapperRect.left - selfRect.left;
      left -= offsetLeft;
      top -= offsetTop;
      return {
        top: top,
        left: left
      };
    }
  }, {
    key: "render",
    value: function render() {
      uploader_get(uploader_getPrototypeOf(Uploader.prototype), "render", this).call(this);
      this.getWrapper().render();
      var editable = this.editor.plugins.attachmentManager.isMethodImplemented('saveFile') && (this.isEditable() || this.editor.mode === this.editor.constructor.MODE_READONLY && !this.isBlotLocked && this.enabledInPublicPage);
      (0,preact_module/* render */.sY)((0,preact_module.h)(UpoaderComponent, {
        editable: editable,
        editor: this.editor,
        onFileUploaded: this.onFileUploaded,
        i18n: this.editor.plugins.i18n,
        id: this.id
      }), this.domNode);
    }
  }, {
    key: "isEditable",
    value: function isEditable() {
      return this.editor.mode === this.editor.constructor.MODE_EDIT && !this.isBlotLocked;
    }
  }, {
    key: "getDraggingNode",
    value: function getDraggingNode() {
      var node = this.getWrapper().domNode.cloneNode(true);
      node.classList.add('dragging-phantom');
      return node;
    }
  }, {
    key: "onDraggingGetPhantomPos",
    value: function onDraggingGetPhantomPos() {
      return this.getWrapper().domNode.getBoundingClientRect();
    }
  }, {
    key: "toHTML",
    value: function toHTML() {
      return this.domNode.outerHTML;
    }
  }, {
    key: "getAllFileBlots",
    value: function getAllFileBlots() {
      return this.containerBlot.descendants(function (blot) {
        return blot.constructor.blotName === 'file';
      });
    }
  }, {
    key: "disallowNote",
    get: function get() {
      return this.map.get('disallowNoteDownloading');
    }
  }, {
    key: "disallowShare",
    get: function get() {
      return this.map.get('disallowShareDownloading');
    }
  }, {
    key: "disallowDownloading",
    get: function get() {
      if ((this.editor.mode === this.editor.constructor.MODE_EDIT || this.editor.mode === this.editor.constructor.MODE_READONLY) && !this.editor.options.isShare) {
        return !!this.disallowNote;
      } else if (this.editor.mode === this.editor.constructor.MODE_READONLY && this.editor.options.isShare) {
        return !!this.disallowShare;
      } else {
        return false;
      }
    }
  }, {
    key: "enabledInPublicPage",
    get: function get() {
      return Boolean(this.map.get('enabledInPublicPage'));
    }
  }, {
    key: "contextMenu",
    get: function get() {
      var _this$blotConfig;
      var i18n = this.editor.plugins.i18n;
      var menu = uploader_get(uploader_getPrototypeOf(Uploader.prototype), "contextMenu", this);
      delete menu['duplicate'];
      delete menu['copyBlocks'];
      var fileBlots = this.getAllFileBlots();
      if (fileBlots && fileBlots.length) {
        menu['convert-to-files'] = {
          label: i18n.get('uploader.menu.convert_to_files'),
          index: 2,
          group: 0,
          action: 'onClickMenuConvertToFiles'
        };
      }
      menu['disallowDownloading'] = {
        label: i18n.get('uploader.menu.disallow_download'),
        index: 3,
        group: 0,
        action: false,
        submenu: {
          'for_note': {
            icon: this.disallowNote ? icons/* IconEmpty */.Zlx : icons/* IconDone */.EZi,
            label: i18n.get('uploader.menu.for_note'),
            index: 1,
            group: 0,
            action: 'onClickMenuDisallowNote'
          },
          'for_share': {
            icon: this.disallowShare ? icons/* IconEmpty */.Zlx : icons/* IconDone */.EZi,
            label: i18n.get('uploader.menu.for_share'),
            index: 2,
            group: 0,
            action: 'onClickMenuDisallowShare'
          }
        }
      };
      if ((_this$blotConfig = this.blotConfig) !== null && _this$blotConfig !== void 0 && _this$blotConfig.allowManage) {
        menu['allowUpload'] = {
          label: i18n.get('uploader.menu.allow_upload'),
          index: 3,
          group: 0,
          action: false,
          submenu: {
            enable: {
              icon: this.enabledInPublicPage ? icons/* IconDone */.EZi : icons/* IconEmpty */.Zlx,
              label: i18n.get('uploader.menu.enable_in_public_page'),
              index: 3,
              group: 0,
              action: 'onClickEnableInPublicPage'
            }
          }
        };
      }
      return menu;
    }
  }], [{
    key: "addUploadedFile",
    value:
    /**
     * Статический метод. Создаёт и добавляет файл-блот в массив children
     * @param {Editor} editor - Редактор, к которому принадлежит блот.
     * @param {YMap} blot - Блот, к которому нужно добавить FileBlot с типом type и attachmentGlobalId.
     * @param {String} type - Тип загруженного файла ('image' или другой).
     * @param {String} attachmentGlobalId - Идентификатор аттача
     * @returns {{id: String; attachmentGlobalId: String}} - Возвращает идентификатор созданного файл-блота и идентификатор аттача
    *
    * @example
    * // Пример использования функции
    * const attachmentGlobalId = 'tzjAEGbLLXjabhKB';
    * const res = Uploader.addUploadedFile(editor, blot, type, attachmentGlobalId);
    * console.log(res.id); // 'b770205335_0'
    */
    function addUploadedFile(editor, blot, type, attachmentGlobalId) {
      var _map;
      var store = editor.store;
      var map;
      store.transaction(function () {
        map = store.createMapForBlot(file, {
          attachmentGlobalId: attachmentGlobalId,
          viewMode: type === 'image' ? 'full' : 'compact',
          disallowNoteDownloading: blot.get('disallowNoteDownloading'),
          disallowShareDownloading: blot.get('disallowShareDownloading')
        });
        blot.get('children').push([map.get('id')]);
      });
      return {
        id: (_map = map) === null || _map === void 0 ? void 0 : _map.get('id'),
        globalId: attachmentGlobalId
      };
    }
  }, {
    key: "createBlot",
    value: function createBlot(editor) {
      var blot = parchment_default().create('uploaderWrapper');
      this.addCaretTrap(editor, blot.domNode);
      return blot;
    }
  }, {
    key: "initMap",
    value: function initMap(map, store) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      map.set('type', Uploader.blotName);
      if (!map.has('children')) {
        var children = new store.types.Array();
        if (Array.isArray(params.children)) {
          children.push(params.children);
        }
        map.set('children', children);
      }
      if (params.header) {
        map.set('header', params.header);
      }
      if (params.description) {
        map.set('description', params.description);
      }
      if (params.disallowNoteDownloading) {
        map.set('disallowNoteDownloading', params.disallowNoteDownloading);
      }
      if (params.disallowShareDownloading) {
        map.set('disallowShareDownloading', params.disallowShareDownloading);
      }
      if (params.hasOwnProperty('enabledInPublicPage')) {
        map.set('enabledInPublicPage', params.enabledInPublicPage);
      } else {
        map.set('enabledInPublicPage', true);
      }
    }
  }]);
  return Uploader;
}(uploader_mixin(blockEmbed));
Uploader.blotName = 'uploader';
Uploader.tagName = 'uploader';
Uploader.className = UPLOADER_CLASS_NAME;
Uploader.wrapper = 'uploaderWrapper';
/* harmony default export */ const uploader = (Uploader);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/uploader/uploaderContent.js
function uploaderContent_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { uploaderContent_typeof = function _typeof(obj) { return typeof obj; }; } else { uploaderContent_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return uploaderContent_typeof(obj); }












function uploaderContent_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function uploaderContent_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function uploaderContent_createClass(Constructor, protoProps, staticProps) { if (protoProps) uploaderContent_defineProperties(Constructor.prototype, protoProps); if (staticProps) uploaderContent_defineProperties(Constructor, staticProps); return Constructor; }
function uploaderContent_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { uploaderContent_get = Reflect.get; } else { uploaderContent_get = function _get(target, property, receiver) { var base = uploaderContent_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return uploaderContent_get(target, property, receiver || target); }
function uploaderContent_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = uploaderContent_getPrototypeOf(object); if (object === null) break; } return object; }
function uploaderContent_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) uploaderContent_setPrototypeOf(subClass, superClass); }
function uploaderContent_setPrototypeOf(o, p) { uploaderContent_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return uploaderContent_setPrototypeOf(o, p); }
function uploaderContent_createSuper(Derived) { var hasNativeReflectConstruct = uploaderContent_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = uploaderContent_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = uploaderContent_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return uploaderContent_possibleConstructorReturn(this, result); }; }
function uploaderContent_possibleConstructorReturn(self, call) { if (call && (uploaderContent_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return uploaderContent_assertThisInitialized(self); }
function uploaderContent_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function uploaderContent_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function uploaderContent_getPrototypeOf(o) { uploaderContent_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return uploaderContent_getPrototypeOf(o); }



/* Import children blots */


/* End import children blots */


var UPLOADER_CONTENT_CLASS_NAME = 'nimbus-uploader-content';
var uploaderContent_mixin = mix([container, basic]);
var UploaderContent = /*#__PURE__*/function (_mixin) {
  uploaderContent_inherits(UploaderContent, _mixin);
  var _super = uploaderContent_createSuper(UploaderContent);
  function UploaderContent(domNode) {
    var _this;
    uploaderContent_classCallCheck(this, UploaderContent);
    _this = _super.call(this, domNode);
    _this.isSubContainer = true;
    _this.disallowInsideSideDrop = true;
    return _this;
  }
  uploaderContent_createClass(UploaderContent, [{
    key: "getWrapper",
    value: function getWrapper() {
      return this.parent;
    }
  }, {
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = uploaderContent_get(uploaderContent_getPrototypeOf(UploaderContent.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
    }
  }, {
    key: "id",
    get: function get() {
      return uploaderContent_get(uploaderContent_getPrototypeOf(UploaderContent.prototype), "id", this) + UploaderContent.idSuffix;
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = uploaderContent_get(uploaderContent_getPrototypeOf(UploaderContent.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
    }
  }, {
    key: "render",
    value: function render() {
      uploaderContent_get(uploaderContent_getPrototypeOf(UploaderContent.prototype), "render", this).call(this);
    }
  }, {
    key: "getSelectableBlot",
    value: function getSelectableBlot() {
      return this.getWrapper().uploader;
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      return '<div class="' + this.domNode.className + '">' + childrenToHTML(this, context, {
        allowRawHTML: true
      }) + '</div>';
    }
  }, {
    key: "optimize",
    value: function optimize() {
      if (!this.children.length) {
        if (!this.domNode.classList.contains('empty')) {
          this.domNode.classList.add('empty');
        }
      } else {
        if (this.domNode.classList.contains('empty')) {
          this.domNode.classList.remove('empty');
        }
      }
    }
  }]);
  return UploaderContent;
}(uploaderContent_mixin(block));
UploaderContent.blotName = 'uploaderContent';
UploaderContent.tagName = 'DIV';
UploaderContent.className = UPLOADER_CONTENT_CLASS_NAME;
UploaderContent.wrapper = 'uploaderWrapper';
UploaderContent.idSuffix = '_files';
UploaderContent.allowedChildren = [ImageWrapper, FileWrapper];
/* harmony default export */ const uploaderContent = (UploaderContent);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/uploader/uploaderHead.js
function uploaderHead_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { uploaderHead_typeof = function _typeof(obj) { return typeof obj; }; } else { uploaderHead_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return uploaderHead_typeof(obj); }
function uploaderHead_extends() { uploaderHead_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return uploaderHead_extends.apply(this, arguments); }
function uploaderHead_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function uploaderHead_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function uploaderHead_createClass(Constructor, protoProps, staticProps) { if (protoProps) uploaderHead_defineProperties(Constructor.prototype, protoProps); if (staticProps) uploaderHead_defineProperties(Constructor, staticProps); return Constructor; }
function uploaderHead_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { uploaderHead_get = Reflect.get; } else { uploaderHead_get = function _get(target, property, receiver) { var base = uploaderHead_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return uploaderHead_get(target, property, receiver || target); }
function uploaderHead_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = uploaderHead_getPrototypeOf(object); if (object === null) break; } return object; }
function uploaderHead_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) uploaderHead_setPrototypeOf(subClass, superClass); }
function uploaderHead_setPrototypeOf(o, p) { uploaderHead_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return uploaderHead_setPrototypeOf(o, p); }
function uploaderHead_createSuper(Derived) { var hasNativeReflectConstruct = uploaderHead_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = uploaderHead_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = uploaderHead_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return uploaderHead_possibleConstructorReturn(this, result); }; }
function uploaderHead_possibleConstructorReturn(self, call) { if (call && (uploaderHead_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return uploaderHead_assertThisInitialized(self); }
function uploaderHead_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function uploaderHead_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function uploaderHead_getPrototypeOf(o) { uploaderHead_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return uploaderHead_getPrototypeOf(o); }
function uploaderHead_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function uploaderHead_slicedToArray(arr, i) { return uploaderHead_arrayWithHoles(arr) || uploaderHead_iterableToArrayLimit(arr, i) || uploaderHead_unsupportedIterableToArray(arr, i) || uploaderHead_nonIterableRest(); }
function uploaderHead_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function uploaderHead_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return uploaderHead_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return uploaderHead_arrayLikeToArray(o, minLen); }
function uploaderHead_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function uploaderHead_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function uploaderHead_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }























var uploaderHead_isEnterKey = (0,lib/* default */.ZP)('enter');
var uploaderHead_isEscKey = (0,lib/* default */.ZP)('esc');
var UPLOADER_HEADER_CLASS_NAME = 'nimbus-uploader-head';
var uploaderHead_mixin = mix([basic]);
var HEADER_MAX_LENGTH = {
  'header': 100,
  'description': 100
};
function UploaderHeadComponent(props) {
  var header = props.header,
    description = props.description,
    onEditEnd = props.onEditEnd,
    editable = props.editable,
    i18n = props.i18n;
  var headerRef = (0,hooks_module/* useRef */.sO)(null);
  var descRef = (0,hooks_module/* useRef */.sO)(null);
  var descChanged = (0,hooks_module/* useRef */.sO)(false);
  var _useState = (0,hooks_module/* useState */.eJ)(null),
    _useState2 = uploaderHead_slicedToArray(_useState, 2),
    activeInput = _useState2[0],
    setActiveInput = _useState2[1];
  var onInputEndEdit = function onInputEndEdit(type, value) {
    if (type === 'description' && !descChanged.current) return;
    onEditEnd && onEditEnd(type, value);
  };
  var onDocumentMouseDown = function onDocumentMouseDown(event) {
    var activeNode = activeInput === 'header' ? headerRef.current : descRef.current;
    if (activeNode === event.target) return;
    onInputEndEdit(activeInput, activeNode.value);
    document.removeEventListener('mousedown', onDocumentMouseDown, false);
    setActiveInput(null);
  };
  var onMouseDown = function onMouseDown(type, event) {
    if (!editable) return;
    setTimeout(function () {
      setActiveInput(type);
    }, 0);
  };
  var onKeyDown = function onKeyDown(type, event) {
    if (uploaderHead_isEnterKey(event) || uploaderHead_isEscKey(event)) {
      event.preventDefault();
      event.stopPropagation();
      document.removeEventListener('mousedown', onDocumentMouseDown, false);
      setActiveInput(null);
      if (uploaderHead_isEnterKey(event)) {
        onInputEndEdit(type, event.target.value);
      }
    }
  };
  var onInput = function onInput(type, event) {
    if (type === 'description' && !descChanged.current) {
      descChanged.current = true;
    }
    if (event.target.value.length >= HEADER_MAX_LENGTH[type]) {
      event.target.value = event.target.value.slice(0, HEADER_MAX_LENGTH[type]);
    }
  };
  (0,hooks_module/* useEffect */.d4)(function () {
    if (activeInput !== null) {
      var activeNode = activeInput === 'header' ? headerRef.current : descRef.current;
      activeNode.select();
      document.addEventListener('mousedown', onDocumentMouseDown, false);
    }
  }, [activeInput]);
  var descriptionNode = !description ? editable ? (0,preact_module.h)("span", {
    className: "uploader-head-edit-icon"
  }, (0,preact_module.h)(icons/* IconEdit */.yl5, null)) : (0,preact_module.h)("br", null) : description;
  return (0,preact_module.h)(preact_module/* Fragment */.HY, null, activeInput === 'header' ? (0,preact_module.h)("input", {
    className: "uploader-header-input",
    ref: headerRef,
    value: header,
    onKeyDown: onKeyDown.bind(undefined, 'header'),
    onInput: onInput.bind(undefined, 'header'),
    placeholder: i18n.get('uploader.header_placeholder', {
      maxChars: HEADER_MAX_LENGTH.header
    })
  }) : (0,preact_module.h)("div", {
    className: "uploader-header",
    onMouseDown: onMouseDown.bind(undefined, 'header')
  }, header, editable ? (0,preact_module.h)("span", {
    className: "uploader-head-edit-icon"
  }, (0,preact_module.h)(icons/* IconEdit */.yl5, null)) : null), activeInput === 'description' ? (0,preact_module.h)("input", {
    className: "uploader-description-input",
    ref: descRef,
    value: description,
    onKeyDown: onKeyDown.bind(undefined, 'description'),
    onInput: onInput.bind(undefined, 'description'),
    placeholder: i18n.get('uploader.description_placeholder', {
      maxChars: HEADER_MAX_LENGTH.description
    })
  }) : (0,preact_module.h)("div", {
    className: "uploader-description",
    onMouseDown: onMouseDown.bind(undefined, 'description')
  }, descriptionNode, editable && description ? (0,preact_module.h)("span", {
    className: "uploader-head-edit-icon"
  }, (0,preact_module.h)(icons/* IconEdit */.yl5, null)) : null));
}
var UploaderHead = /*#__PURE__*/function (_mixin) {
  uploaderHead_inherits(UploaderHead, _mixin);
  var _super = uploaderHead_createSuper(UploaderHead);
  function UploaderHead(domNode) {
    var _this;
    uploaderHead_classCallCheck(this, UploaderHead);
    _this = _super.call(this, domNode);
    uploaderHead_defineProperty(uploaderHead_assertThisInitialized(_this), "onEditEnd", function (type, value) {
      if (!type) return;
      if (_this.map.get(type) === value) return;
      if (!value) {
        value = '';
      }
      _this.map.set(type, value);
    });
    return _this;
  }
  uploaderHead_createClass(UploaderHead, [{
    key: "defaults",
    get: function get() {
      return {
        header: this.editor.plugins.i18n.get('uploader.header'),
        description: this.editor.plugins.i18n.get('uploader.description')
      };
    }
  }, {
    key: "id",
    get: function get() {
      return uploaderHead_get(uploaderHead_getPrototypeOf(UploaderHead.prototype), "id", this) + UploaderHead.idSuffix;
    }
  }, {
    key: "getWrapper",
    value: function getWrapper() {
      return this.parent;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$uploader;
      uploaderHead_get(uploaderHead_getPrototypeOf(UploaderHead.prototype), "render", this) && uploaderHead_get(uploaderHead_getPrototypeOf(UploaderHead.prototype), "render", this).call(this);
      var props = {
        header: this.map.get('header') || this.defaults.header,
        description: typeof this.map.get('description') === 'string' ? this.map.get('description') : this.defaults.description
      };
      var editable = (_this$uploader = this.uploader) === null || _this$uploader === void 0 ? void 0 : _this$uploader.isEditable();
      (0,preact_module/* render */.sY)((0,preact_module.h)(UploaderHeadComponent, uploaderHead_extends({
        editable: editable,
        onEditEnd: this.onEditEnd,
        i18n: this.editor.plugins.i18n
      }, props)), this.domNode);
    }
  }, {
    key: "toHTML",
    value: function toHTML() {
      return this.domNode.outerHTML;
    }
  }]);
  return UploaderHead;
}(uploaderHead_mixin(blockEmbed));

UploaderHead.blotName = 'uploader-head';
UploaderHead.tagName = 'div';
UploaderHead.className = UPLOADER_HEADER_CLASS_NAME;
UploaderHead.wrapper = 'uploaderWrapper';
UploaderHead.idSuffix = '_head';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/uploader/uploaderWrapper.js
function uploaderWrapper_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { uploaderWrapper_typeof = function _typeof(obj) { return typeof obj; }; } else { uploaderWrapper_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return uploaderWrapper_typeof(obj); }















function uploaderWrapper_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function uploaderWrapper_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function uploaderWrapper_createClass(Constructor, protoProps, staticProps) { if (protoProps) uploaderWrapper_defineProperties(Constructor.prototype, protoProps); if (staticProps) uploaderWrapper_defineProperties(Constructor, staticProps); return Constructor; }
function uploaderWrapper_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { uploaderWrapper_get = Reflect.get; } else { uploaderWrapper_get = function _get(target, property, receiver) { var base = uploaderWrapper_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return uploaderWrapper_get(target, property, receiver || target); }
function uploaderWrapper_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = uploaderWrapper_getPrototypeOf(object); if (object === null) break; } return object; }
function uploaderWrapper_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) uploaderWrapper_setPrototypeOf(subClass, superClass); }
function uploaderWrapper_setPrototypeOf(o, p) { uploaderWrapper_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return uploaderWrapper_setPrototypeOf(o, p); }
function uploaderWrapper_createSuper(Derived) { var hasNativeReflectConstruct = uploaderWrapper_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = uploaderWrapper_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = uploaderWrapper_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return uploaderWrapper_possibleConstructorReturn(this, result); }; }
function uploaderWrapper_possibleConstructorReturn(self, call) { if (call && (uploaderWrapper_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return uploaderWrapper_assertThisInitialized(self); }
function uploaderWrapper_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function uploaderWrapper_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function uploaderWrapper_getPrototypeOf(o) { uploaderWrapper_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return uploaderWrapper_getPrototypeOf(o); }







var UPLOADER_WRAPPER_CLASS_NAME = 'nimbus-uploader-wrapper';
var uploaderWrapper_mixin = mix([dropAcceptor, basic]);
var UploaderWrapper = /*#__PURE__*/function (_mixin) {
  uploaderWrapper_inherits(UploaderWrapper, _mixin);
  var _super = uploaderWrapper_createSuper(UploaderWrapper);
  function UploaderWrapper(domNode) {
    uploaderWrapper_classCallCheck(this, UploaderWrapper);
    return _super.call(this, domNode);
  }
  uploaderWrapper_createClass(UploaderWrapper, [{
    key: "buildBlot",
    value: function buildBlot() {
      this.head = parchment_default().create(UploaderHead.blotName);
      this.head.map = this.map;
      this.containerBlot = parchment_default().create(uploaderContent.blotName);
      this.containerBlot.map = this.map;
      this.basicBlot = parchment_default().create(uploader.blotName);
      this.basicBlot.map = this.map;
      this.basicBlot.containerBlot = this.containerBlot;
      this.head.uploader = this.basicBlot;
      this.appendChild(this.head);
      this.appendChild(this.containerBlot);
      this.appendChild(this.basicBlot);
    }
  }, {
    key: "attach",
    value: function attach() {
      var _get2;
      this.buildBlot();
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = uploaderWrapper_get(uploaderWrapper_getPrototypeOf(UploaderWrapper.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      this.domNode.removeAttribute('id');
      this.domNode.setAttribute('contenteditable', false);
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = uploaderWrapper_get(uploaderWrapper_getPrototypeOf(UploaderWrapper.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
    }
  }, {
    key: "render",
    value: function render() {
      uploaderWrapper_get(uploaderWrapper_getPrototypeOf(UploaderWrapper.prototype), "render", this).call(this);
      this.head.render();
      this.containerBlot.render();
    }
  }, {
    key: "getWrappedBlot",
    value: function getWrappedBlot() {
      return this.basicBlot;
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      var html = [];
      this.children.forEach(function (blot) {
        if (blot.toHTML) {
          html.push(blot.toHTML(context));
        }
      });
      return '<div class="' + UPLOADER_WRAPPER_CLASS_NAME + '">' + html.join('') + '</div>';
    }
  }]);
  return UploaderWrapper;
}(uploaderWrapper_mixin((parchment_default()).Container));
UploaderWrapper.blotName = 'uploaderWrapper';
UploaderWrapper.tagName = 'DIV';
UploaderWrapper.scope = (parchment_default()).Scope.BLOCK_BLOT;
UploaderWrapper.className = UPLOADER_WRAPPER_CLASS_NAME;
UploaderWrapper.defaultChild = null;
UploaderWrapper.allowedChildren = [UploaderHead, uploaderContent, uploader];
/* harmony default export */ const uploaderWrapper = (UploaderWrapper);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/toggle/toggleContent.js
function toggleContent_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { toggleContent_typeof = function _typeof(obj) { return typeof obj; }; } else { toggleContent_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return toggleContent_typeof(obj); }













function toggleContent_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function toggleContent_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function toggleContent_createClass(Constructor, protoProps, staticProps) { if (protoProps) toggleContent_defineProperties(Constructor.prototype, protoProps); if (staticProps) toggleContent_defineProperties(Constructor, staticProps); return Constructor; }
function toggleContent_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { toggleContent_get = Reflect.get; } else { toggleContent_get = function _get(target, property, receiver) { var base = toggleContent_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return toggleContent_get(target, property, receiver || target); }
function toggleContent_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = toggleContent_getPrototypeOf(object); if (object === null) break; } return object; }
function toggleContent_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) toggleContent_setPrototypeOf(subClass, superClass); }
function toggleContent_setPrototypeOf(o, p) { toggleContent_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return toggleContent_setPrototypeOf(o, p); }
function toggleContent_createSuper(Derived) { var hasNativeReflectConstruct = toggleContent_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = toggleContent_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = toggleContent_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return toggleContent_possibleConstructorReturn(this, result); }; }
function toggleContent_possibleConstructorReturn(self, call) { if (call && (toggleContent_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return toggleContent_assertThisInitialized(self); }
function toggleContent_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function toggleContent_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function toggleContent_getPrototypeOf(o) { toggleContent_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return toggleContent_getPrototypeOf(o); }
function toggleContent_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





/* Import children blots */


















/* End import children blots */



var TOGGLE_CONTENT_CLASS_NAME = 'nimbus-toggle-content';
var toggleContent_mixin = mix([executable, separableByClick, container, basic]);
var ToggleContent = /*#__PURE__*/function (_mixin) {
  toggleContent_inherits(ToggleContent, _mixin);
  var _super = toggleContent_createSuper(ToggleContent);
  function ToggleContent(domNode) {
    var _this;
    toggleContent_classCallCheck(this, ToggleContent);
    _this = _super.call(this, domNode);
    toggleContent_defineProperty(toggleContent_assertThisInitialized(_this), "addDefaultParagraphIfNeed", function () {
      if (_this.containerChildren && !_this.containerChildren.length) {
        // create default paragraph on first expand
        var pMap = _this.store.createMap();
        src_parchment.query('paragraph').initMap(pMap, _this.store);
        _this.containerChildren.push([pMap.get('id')]);
      }
    });
    toggleContent_defineProperty(toggleContent_assertThisInitialized(_this), "updatePlaceholderState", function () {
      // дожидаемся реакции всех блотов подписанных на selectionchange, чтобы они обновили свои props
      setTimeout(function () {
        var cursorOnFirstChild = _this.children.length && _this.children.head.props.focused;
        if (_this.children.length === 1 && _this.children.head.constructor.blotName === 'paragraph' && _this.children.head.isEmpty() && !cursorOnFirstChild) {
          _this.domNode.classList.add('with-placeholder');
        } else if (_this.domNode.classList.contains('with-placeholder')) {
          _this.domNode.classList.remove('with-placeholder');
        }
      }, 0);
    });
    _this.isSubContainer = true;
    _this.addCanExecActions(container.canExecActions);
    _this.isCollapsibleContainer = true;
    _this.disallowInsideSideDrop = true;
    return _this;
  }
  toggleContent_createClass(ToggleContent, [{
    key: "getWrapper",
    value: function getWrapper() {
      return this.parent;
    }
  }, {
    key: "attach",
    value: function attach() {
      var _get2, _this$getWrapper, _this$getWrapper$getW, _this$getWrapper2, _this$getWrapper2$get;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = toggleContent_get(toggleContent_getPrototypeOf(ToggleContent.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      var placeholder = (_this$getWrapper = this.getWrapper()) !== null && _this$getWrapper !== void 0 && (_this$getWrapper$getW = _this$getWrapper.getWrappedBlot()) !== null && _this$getWrapper$getW !== void 0 && _this$getWrapper$getW.getContentPlaceholder ? (_this$getWrapper2 = this.getWrapper()) === null || _this$getWrapper2 === void 0 ? void 0 : (_this$getWrapper2$get = _this$getWrapper2.getWrappedBlot()) === null || _this$getWrapper2$get === void 0 ? void 0 : _this$getWrapper2$get.getContentPlaceholder() : this.editor.plugins.i18n.get('toggle.placeholder');
      this.domNode.setAttribute('data-placeholder', placeholder);
      this.addDefaultParagraphIfNeed();
      this.editor.on('selectionchange', this.updatePlaceholderState);
    }
  }, {
    key: "id",
    get: function get() {
      return toggleContent_get(toggleContent_getPrototypeOf(ToggleContent.prototype), "id", this) + ToggleContent.idSuffix;
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = toggleContent_get(toggleContent_getPrototypeOf(ToggleContent.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      this.editor.off('selectionchange', this.updatePlaceholderState);
    }
  }, {
    key: "onChildDetached",
    value: function onChildDetached(blot) {
      if (this.map.get('collapsed') || !this.hasBeenAttached || !this.containerChildren) return;
      toggleContent_get(toggleContent_getPrototypeOf(ToggleContent.prototype), "onChildDetached", this).call(this, blot);
      if (!this.children.length) {
        this.addDefaultParagraphIfNeed();
      }
    }
  }, {
    key: "render",
    value: function render() {
      toggleContent_get(toggleContent_getPrototypeOf(ToggleContent.prototype), "render", this).call(this);
      this.updatePlaceholderState();
    }
  }, {
    key: "getSelectableBlot",
    value: function getSelectableBlot() {
      return this.prev;
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      return '<div class="' + this.domNode.className + '">' + childrenToHTML(this, context, {
        allowRawHTML: true
      }) + '</div>';
    }
  }]);
  return ToggleContent;
}(toggleContent_mixin(block));
ToggleContent.blotName = 'toggleContent';
ToggleContent.tagName = 'DIV';
ToggleContent.className = TOGGLE_CONTENT_CLASS_NAME;
ToggleContent.wrapper = 'toggleWrapper';
ToggleContent.idSuffix = '_content';
ToggleContent.allowedChildren = [paragraphAbstract, tableWrapper, ImageWrapper, FileWrapper, RemoteFrameWrapper, RemoteFileWrapper, SyntaxWrapper, list_list, hLine, businessCard, bookmark, Outline, html, ButtonSingle, primary, TasksList, Board, uploaderWrapper];
/* harmony default export */ const toggleContent = (ToggleContent);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/toggle/toggleWrapper.js
function toggleWrapper_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { toggleWrapper_typeof = function _typeof(obj) { return typeof obj; }; } else { toggleWrapper_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return toggleWrapper_typeof(obj); }
















function toggleWrapper_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function toggleWrapper_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function toggleWrapper_createClass(Constructor, protoProps, staticProps) { if (protoProps) toggleWrapper_defineProperties(Constructor.prototype, protoProps); if (staticProps) toggleWrapper_defineProperties(Constructor, staticProps); return Constructor; }
function toggleWrapper_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { toggleWrapper_get = Reflect.get; } else { toggleWrapper_get = function _get(target, property, receiver) { var base = toggleWrapper_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return toggleWrapper_get(target, property, receiver || target); }
function toggleWrapper_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = toggleWrapper_getPrototypeOf(object); if (object === null) break; } return object; }
function toggleWrapper_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) toggleWrapper_setPrototypeOf(subClass, superClass); }
function toggleWrapper_setPrototypeOf(o, p) { toggleWrapper_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return toggleWrapper_setPrototypeOf(o, p); }
function toggleWrapper_createSuper(Derived) { var hasNativeReflectConstruct = toggleWrapper_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = toggleWrapper_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = toggleWrapper_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return toggleWrapper_possibleConstructorReturn(this, result); }; }
function toggleWrapper_possibleConstructorReturn(self, call) { if (call && (toggleWrapper_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return toggleWrapper_assertThisInitialized(self); }
function toggleWrapper_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function toggleWrapper_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function toggleWrapper_getPrototypeOf(o) { toggleWrapper_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return toggleWrapper_getPrototypeOf(o); }
function toggleWrapper_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var TOGGLE_WRAPPER_CLASS_NAME = 'nimbus-toggle';
var toggleWrapper_mixin = mix([dropAcceptor, basic]);
var ToggleWrapper = /*#__PURE__*/function (_mixin) {
  toggleWrapper_inherits(ToggleWrapper, _mixin);
  var _super = toggleWrapper_createSuper(ToggleWrapper);
  function ToggleWrapper(domNode) {
    var _this;
    toggleWrapper_classCallCheck(this, ToggleWrapper);
    _this = _super.call(this, domNode);
    toggleWrapper_defineProperty(toggleWrapper_assertThisInitialized(_this), "onArrowClick", function (event) {
      var collapsed = _this.map.get('collapsed');
      _this.map.set('collapsed', !collapsed);
    });
    toggleWrapper_defineProperty(toggleWrapper_assertThisInitialized(_this), "onArrowMouseDown", function (event) {
      event.preventDefault();
    });
    _this.createArrow();
    _this.isSeparableByClickApplicable = true;
    _this.ignoreWrappedBlotOnSeparableByClick = true;
    return _this;
  }
  toggleWrapper_createClass(ToggleWrapper, [{
    key: "createArrow",
    value: function createArrow() {
      this.arrowNode = document.createElement('div');
      this.arrowNode.classList.add('toggle-arrow');
      this.domNode.appendChild(this.arrowNode);
    }
  }, {
    key: "buildBlot",
    value: function buildBlot() {
      var blot = parchment_default().create(this.map.get('type'));
      blot.map = this.map;
      this.appendChild(blot);
    }

    /**
     * Переберает мапы вложеных блотов
     * @param { Function } cb 
     */
  }, {
    key: "forEachChildren",
    value: function forEachChildren() {
      var _this2 = this;
      var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (childMap) {};
      var _ref = this.map.toJSON() || {},
        _ref$children = _ref.children,
        children = _ref$children === void 0 ? [] : _ref$children;
      children.forEach(function (blotId) {
        var childMap = _this2.editor.store.blocks.get(blotId);
        cb(childMap);
      });
    }
  }, {
    key: "deleteReminderFromDelta",
    value: function deleteReminderFromDelta(delta) {
      var reminderManager = this.editor.plugins.reminderManager;
      delta.forEach(function (_ref2) {
        var insert = _ref2.insert;
        // если в свёрнутом тоггле была дата, то вызываем удаление ремайндеров через reminderManager
        if (insert !== null && insert !== void 0 && insert.date && insert.date.reminders) {
          var _insert$date = insert.date,
            reminders = _insert$date.reminders,
            dateId = _insert$date.dateId;
          reminders = typeof reminders === 'string' ? JSON.parse(reminders) : reminders;
          if (reminders) {
            reminderManager.deleteReminder(dateId, {
              reminders: reminders
            });
          }
        }
      });
    }
  }, {
    key: "setReminderFromDelta",
    value: function setReminderFromDelta(delta) {
      var _this3 = this;
      delta.forEach(function (_ref3) {
        var insert = _ref3.insert;
        // если в свёрнутом тоггле дата с ремайндером, то устанавливаем ремайндер через reminderManager
        if (insert !== null && insert !== void 0 && insert.date && insert.date.reminders) {
          var reminders = insert.date.reminders;
          var _insert$date2 = insert.date,
            dateId = _insert$date2.dateId,
            value = _insert$date2.value,
            timestamp = _insert$date2.timestamp,
            format = _insert$date2.format;
          reminders = typeof reminders === 'string' ? JSON.parse(reminders) : reminders;
          var result = [];
          for (var id in reminders) {
            result.push({
              id: id,
              dateId: dateId,
              timestamp: value || timestamp,
              seconds: reminders[id].seconds,
              format: format
            });
          }
          if (result.length) {
            table_table.setInlineRemindersByArray(_this3.editor, result);
          }
        }
      });
    }
  }, {
    key: "attach",
    value: function attach() {
      var _get2,
        _this4 = this;
      this.buildBlot();
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = toggleWrapper_get(toggleWrapper_getPrototypeOf(ToggleWrapper.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      this.domNode.removeAttribute('id');

      // если тоггл свёрнут
      if (this.map.get('collapsed') && this.editor.plugins.undoManager.isUndoing()) {
        this.forEachChildren(function (map) {
          var _map$get;
          // устанавливаем ремайндеры для таблицы в свёрнутом тоггле
          if ((map === null || map === void 0 ? void 0 : map.get('type')) === 'table') {
            table_table.setReminders(_this4.editor, map.get('rows'));
          }
          if ((map === null || map === void 0 ? void 0 : map.get('type')) === 'list') {
            map.get('children').forEach(function (childBlotId) {
              var child = _this4.editor.store.blocks.get(childBlotId);
              var delta = (child === null || child === void 0 ? void 0 : child.get('characters').toDelta()) || [];
              _this4.setReminderFromDelta(delta);
            });
          }
          var delta = (map === null || map === void 0 ? void 0 : (_map$get = map.get('characters')) === null || _map$get === void 0 ? void 0 : _map$get.toDelta()) || [];
          _this4.setReminderFromDelta(delta);
        });
      }
      this.arrowNode.classList.add(this.map.get('type'));
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3,
        _this5 = this;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = toggleWrapper_get(toggleWrapper_getPrototypeOf(ToggleWrapper.prototype), "detach", this)).call.apply(_get3, [this].concat(args));

      // если тоггл свёрнут
      if (this.map.get('collapsed')) {
        // проходим по всем детям из мапа
        this.forEachChildren(function (map) {
          var _map$get2;
          // если в свёрнутом тогле была табллица, то вызываем удаление её ремайндеров через reminderManager
          if ((map === null || map === void 0 ? void 0 : map.get('type')) === 'table') {
            table_table.removeReminders(_this5.editor, map.get('rows'));
          }
          if ((map === null || map === void 0 ? void 0 : map.get('type')) === 'list') {
            map.get('children').forEach(function (childBlotId) {
              var child = _this5.editor.store.blocks.get(childBlotId);
              var delta = (child === null || child === void 0 ? void 0 : child.get('characters').toDelta()) || [];
              _this5.deleteReminderFromDelta(delta);
            });
          }
          var delta = (map === null || map === void 0 ? void 0 : (_map$get2 = map.get('characters')) === null || _map$get2 === void 0 ? void 0 : _map$get2.toDelta()) || [];
          _this5.deleteReminderFromDelta(delta);
        });
      }
    }
  }, {
    key: "getArrowTooltipText",
    value: function getArrowTooltipText(textType) {
      var blotType = this.map.get('type');
      var BlotClass = parchment_default().query(blotType);
      if (textType === 'expand') {
        if (BlotClass && BlotClass.tooltipPathSuffix) {
          return this.editor.plugins.i18n.get('toggle.expand' + '_' + BlotClass.tooltipPathSuffix);
        }
        return this.editor.plugins.i18n.get('toggle.expand');
      }
      if (textType === 'collapse') {
        if (BlotClass && BlotClass.tooltipPathSuffix) {
          return this.editor.plugins.i18n.get('toggle.collapse' + '_' + BlotClass.tooltipPathSuffix);
        }
        return this.editor.plugins.i18n.get('toggle.collapse');
      }
      return '';
    }
  }, {
    key: "render",
    value: function render() {
      toggleWrapper_get(toggleWrapper_getPrototypeOf(ToggleWrapper.prototype), "render", this).call(this);
      var collapsed = this.editor.mode !== MODE_EXPORT ? this.map.get('collapsed') : false;
      if (collapsed) {
        this.arrowNode.setAttribute(tooltipManager/* TOOLTIP_ATTR */.qZ, this.getArrowTooltipText('expand'));
      } else {
        this.arrowNode.setAttribute(tooltipManager/* TOOLTIP_ATTR */.qZ, this.getArrowTooltipText('collapse'));
      }
      (0,preact_module/* render */.sY)((0,preact_module.h)("div", {
        className: 'toggle-arrow-icon' + (collapsed ? ' collapsed' : ''),
        onClick: this.onArrowClick,
        onMouseDown: this.onArrowMouseDown
      }, (0,preact_module.h)(icons/* IconListCollapse */.J0H, null)), this.arrowNode);
    }
  }, {
    key: "getInnerTextLine",
    value: function getInnerTextLine() {
      return this.children.head;
    }
  }, {
    key: "getWrappedBlot",
    value: function getWrappedBlot() {
      return this.getInnerTextLine();
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      var html = [];
      this.children.forEach(function (blot) {
        if (blot.toHTML) {
          html.push(blot.toHTML(context));
        }
      });
      var arrowHtml = '<div class="toggle-arrow">' + this.arrowNode.innerHTML + '</div>';
      return '<div class="' + TOGGLE_WRAPPER_CLASS_NAME + '">' + arrowHtml + html.join('') + '</div>';
    }
  }, {
    key: "getMarkdown",
    value: function getMarkdown() {
      var markdown = '';
      this.children.forEach(function (blot) {
        if (blot.getMarkdown) {
          markdown += blot.getMarkdown();
        }
      });
      return markdown;
    }
  }]);
  return ToggleWrapper;
}(toggleWrapper_mixin((parchment_default()).Container));
ToggleWrapper.blotName = 'toggleWrapper';
ToggleWrapper.tagName = 'DIV';
ToggleWrapper.scope = (parchment_default()).Scope.BLOCK_BLOT;
ToggleWrapper.className = TOGGLE_WRAPPER_CLASS_NAME;
ToggleWrapper.defaultChild = null;
ToggleWrapper.allowedChildren = [toggle, toggleContent];
/* harmony default export */ const toggleWrapper = (ToggleWrapper);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(54516);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ru/_lib/formatDistance/index.js


function declension(scheme, count) {
  // scheme for count=1 exists
  if (scheme.one !== undefined && count === 1) {
    return scheme.one;
  }
  var rem10 = count % 10;
  var rem100 = count % 100;

  // 1, 21, 31, ...
  if (rem10 === 1 && rem100 !== 11) {
    return scheme.singularNominative.replace('{{count}}', String(count));

    // 2, 3, 4, 22, 23, 24, 32 ...
  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
    return scheme.singularGenitive.replace('{{count}}', String(count));

    // 5, 6, 7, 8, 9, 10, 11, ...
  } else {
    return scheme.pluralGenitive.replace('{{count}}', String(count));
  }
}
function buildLocalizeTokenFn(scheme) {
  return function (count, options) {
    if (options !== null && options !== void 0 && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        if (scheme.future) {
          return declension(scheme.future, count);
        } else {
          return 'через ' + declension(scheme.regular, count);
        }
      } else {
        if (scheme.past) {
          return declension(scheme.past, count);
        } else {
          return declension(scheme.regular, count) + ' назад';
        }
      }
    } else {
      return declension(scheme.regular, count);
    }
  };
}
var formatDistanceLocale = {
  lessThanXSeconds: buildLocalizeTokenFn({
    regular: {
      one: 'меньше секунды',
      singularNominative: 'меньше {{count}} секунды',
      singularGenitive: 'меньше {{count}} секунд',
      pluralGenitive: 'меньше {{count}} секунд'
    },
    future: {
      one: 'меньше, чем через секунду',
      singularNominative: 'меньше, чем через {{count}} секунду',
      singularGenitive: 'меньше, чем через {{count}} секунды',
      pluralGenitive: 'меньше, чем через {{count}} секунд'
    }
  }),
  xSeconds: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} секунда',
      singularGenitive: '{{count}} секунды',
      pluralGenitive: '{{count}} секунд'
    },
    past: {
      singularNominative: '{{count}} секунду назад',
      singularGenitive: '{{count}} секунды назад',
      pluralGenitive: '{{count}} секунд назад'
    },
    future: {
      singularNominative: 'через {{count}} секунду',
      singularGenitive: 'через {{count}} секунды',
      pluralGenitive: 'через {{count}} секунд'
    }
  }),
  halfAMinute: function halfAMinute(_count, options) {
    if (options !== null && options !== void 0 && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        return 'через полминуты';
      } else {
        return 'полминуты назад';
      }
    }
    return 'полминуты';
  },
  lessThanXMinutes: buildLocalizeTokenFn({
    regular: {
      one: 'меньше минуты',
      singularNominative: 'меньше {{count}} минуты',
      singularGenitive: 'меньше {{count}} минут',
      pluralGenitive: 'меньше {{count}} минут'
    },
    future: {
      one: 'меньше, чем через минуту',
      singularNominative: 'меньше, чем через {{count}} минуту',
      singularGenitive: 'меньше, чем через {{count}} минуты',
      pluralGenitive: 'меньше, чем через {{count}} минут'
    }
  }),
  xMinutes: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} минута',
      singularGenitive: '{{count}} минуты',
      pluralGenitive: '{{count}} минут'
    },
    past: {
      singularNominative: '{{count}} минуту назад',
      singularGenitive: '{{count}} минуты назад',
      pluralGenitive: '{{count}} минут назад'
    },
    future: {
      singularNominative: 'через {{count}} минуту',
      singularGenitive: 'через {{count}} минуты',
      pluralGenitive: 'через {{count}} минут'
    }
  }),
  aboutXHours: buildLocalizeTokenFn({
    regular: {
      singularNominative: 'около {{count}} часа',
      singularGenitive: 'около {{count}} часов',
      pluralGenitive: 'около {{count}} часов'
    },
    future: {
      singularNominative: 'приблизительно через {{count}} час',
      singularGenitive: 'приблизительно через {{count}} часа',
      pluralGenitive: 'приблизительно через {{count}} часов'
    }
  }),
  xHours: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} час',
      singularGenitive: '{{count}} часа',
      pluralGenitive: '{{count}} часов'
    }
  }),
  xDays: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} день',
      singularGenitive: '{{count}} дня',
      pluralGenitive: '{{count}} дней'
    }
  }),
  aboutXWeeks: buildLocalizeTokenFn({
    regular: {
      singularNominative: 'около {{count}} недели',
      singularGenitive: 'около {{count}} недель',
      pluralGenitive: 'около {{count}} недель'
    },
    future: {
      singularNominative: 'приблизительно через {{count}} неделю',
      singularGenitive: 'приблизительно через {{count}} недели',
      pluralGenitive: 'приблизительно через {{count}} недель'
    }
  }),
  xWeeks: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} неделя',
      singularGenitive: '{{count}} недели',
      pluralGenitive: '{{count}} недель'
    }
  }),
  aboutXMonths: buildLocalizeTokenFn({
    regular: {
      singularNominative: 'около {{count}} месяца',
      singularGenitive: 'около {{count}} месяцев',
      pluralGenitive: 'около {{count}} месяцев'
    },
    future: {
      singularNominative: 'приблизительно через {{count}} месяц',
      singularGenitive: 'приблизительно через {{count}} месяца',
      pluralGenitive: 'приблизительно через {{count}} месяцев'
    }
  }),
  xMonths: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} месяц',
      singularGenitive: '{{count}} месяца',
      pluralGenitive: '{{count}} месяцев'
    }
  }),
  aboutXYears: buildLocalizeTokenFn({
    regular: {
      singularNominative: 'около {{count}} года',
      singularGenitive: 'около {{count}} лет',
      pluralGenitive: 'около {{count}} лет'
    },
    future: {
      singularNominative: 'приблизительно через {{count}} год',
      singularGenitive: 'приблизительно через {{count}} года',
      pluralGenitive: 'приблизительно через {{count}} лет'
    }
  }),
  xYears: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} год',
      singularGenitive: '{{count}} года',
      pluralGenitive: '{{count}} лет'
    }
  }),
  overXYears: buildLocalizeTokenFn({
    regular: {
      singularNominative: 'больше {{count}} года',
      singularGenitive: 'больше {{count}} лет',
      pluralGenitive: 'больше {{count}} лет'
    },
    future: {
      singularNominative: 'больше, чем через {{count}} год',
      singularGenitive: 'больше, чем через {{count}} года',
      pluralGenitive: 'больше, чем через {{count}} лет'
    }
  }),
  almostXYears: buildLocalizeTokenFn({
    regular: {
      singularNominative: 'почти {{count}} год',
      singularGenitive: 'почти {{count}} года',
      pluralGenitive: 'почти {{count}} лет'
    },
    future: {
      singularNominative: 'почти через {{count}} год',
      singularGenitive: 'почти через {{count}} года',
      pluralGenitive: 'почти через {{count}} лет'
    }
  })
};
var formatDistance = function formatDistance(token, count, options) {
  return formatDistanceLocale[token](count, options);
};
/* harmony default export */ const _lib_formatDistance = (formatDistance);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
var buildFormatLongFn = __webpack_require__(26496);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ru/_lib/formatLong/index.js

var dateFormats = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: 'dd.MM.y'
};
var timeFormats = {
  full: 'H:mm:ss zzzz',
  long: 'H:mm:ss z',
  medium: 'H:mm:ss',
  short: 'H:mm'
};
var dateTimeFormats = {
  any: '{{date}}, {{time}}'
};
var formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: dateTimeFormats,
    defaultWidth: 'any'
  })
};
/* harmony default export */ const _lib_formatLong = (formatLong);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(42362);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
var startOfUTCWeek = __webpack_require__(80941);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/isSameUTCWeek/index.js


function isSameUTCWeek(dirtyDateLeft, dirtyDateRight, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeftStartOfWeek = (0,startOfUTCWeek/* default */.Z)(dirtyDateLeft, options);
  var dateRightStartOfWeek = (0,startOfUTCWeek/* default */.Z)(dirtyDateRight, options);
  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ru/_lib/formatRelative/index.js

var accusativeWeekdays = ['воскресенье', 'понедельник', 'вторник', 'среду', 'четверг', 'пятницу', 'субботу'];
function _lastWeek(day) {
  var weekday = accusativeWeekdays[day];
  switch (day) {
    case 0:
      return "'в прошлое " + weekday + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в прошлый " + weekday + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в прошлую " + weekday + " в' p";
  }
}
function thisWeek(day) {
  var weekday = accusativeWeekdays[day];
  if (day === 2 /* Tue */) {
    return "'во " + weekday + " в' p";
  } else {
    return "'в " + weekday + " в' p";
  }
}
function _nextWeek(day) {
  var weekday = accusativeWeekdays[day];
  switch (day) {
    case 0:
      return "'в следующее " + weekday + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в следующий " + weekday + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в следующую " + weekday + " в' p";
  }
}
var formatRelativeLocale = {
  lastWeek: function lastWeek(date, baseDate, options) {
    var day = date.getUTCDay();
    if (isSameUTCWeek(date, baseDate, options)) {
      return thisWeek(day);
    } else {
      return _lastWeek(day);
    }
  },
  yesterday: "'вчера в' p",
  today: "'сегодня в' p",
  tomorrow: "'завтра в' p",
  nextWeek: function nextWeek(date, baseDate, options) {
    var day = date.getUTCDay();
    if (isSameUTCWeek(date, baseDate, options)) {
      return thisWeek(day);
    } else {
      return _nextWeek(day);
    }
  },
  other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
  var format = formatRelativeLocale[token];
  if (typeof format === 'function') {
    return format(date, baseDate, options);
  }
  return format;
};
/* harmony default export */ const _lib_formatRelative = (formatRelative);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
var buildLocalizeFn = __webpack_require__(38645);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ru/_lib/localize/index.js


var eraValues = {
  narrow: ['до н.э.', 'н.э.'],
  abbreviated: ['до н. э.', 'н. э.'],
  wide: ['до нашей эры', 'нашей эры']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1-й кв.', '2-й кв.', '3-й кв.', '4-й кв.'],
  wide: ['1-й квартал', '2-й квартал', '3-й квартал', '4-й квартал']
};
var monthValues = {
  narrow: ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
  abbreviated: ['янв.', 'фев.', 'март', 'апр.', 'май', 'июнь', 'июль', 'авг.', 'сент.', 'окт.', 'нояб.', 'дек.'],
  wide: ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь']
};
var formattingMonthValues = {
  narrow: ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
  abbreviated: ['янв.', 'фев.', 'мар.', 'апр.', 'мая', 'июн.', 'июл.', 'авг.', 'сент.', 'окт.', 'нояб.', 'дек.'],
  wide: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря']
};
var dayValues = {
  narrow: ['В', 'П', 'В', 'С', 'Ч', 'П', 'С'],
  short: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
  abbreviated: ['вск', 'пнд', 'втр', 'срд', 'чтв', 'птн', 'суб'],
  wide: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота']
};
var dayPeriodValues = {
  narrow: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полн.',
    noon: 'полд.',
    morning: 'утро',
    afternoon: 'день',
    evening: 'веч.',
    night: 'ночь'
  },
  abbreviated: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полн.',
    noon: 'полд.',
    morning: 'утро',
    afternoon: 'день',
    evening: 'веч.',
    night: 'ночь'
  },
  wide: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полночь',
    noon: 'полдень',
    morning: 'утро',
    afternoon: 'день',
    evening: 'вечер',
    night: 'ночь'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полн.',
    noon: 'полд.',
    morning: 'утра',
    afternoon: 'дня',
    evening: 'веч.',
    night: 'ночи'
  },
  abbreviated: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полн.',
    noon: 'полд.',
    morning: 'утра',
    afternoon: 'дня',
    evening: 'веч.',
    night: 'ночи'
  },
  wide: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полночь',
    noon: 'полдень',
    morning: 'утра',
    afternoon: 'дня',
    evening: 'вечера',
    night: 'ночи'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
  var number = Number(dirtyNumber);
  var unit = options === null || options === void 0 ? void 0 : options.unit;
  var suffix;
  if (unit === 'date') {
    suffix = '-е';
  } else if (unit === 'week' || unit === 'minute' || unit === 'second') {
    suffix = '-я';
  } else {
    suffix = '-й';
  }
  return number + suffix;
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: (0,buildLocalizeFn/* default */.Z)({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,buildLocalizeFn/* default */.Z)({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0,buildLocalizeFn/* default */.Z)({
    values: monthValues,
    defaultWidth: 'wide',
    formattingValues: formattingMonthValues,
    defaultFormattingWidth: 'wide'
  }),
  day: (0,buildLocalizeFn/* default */.Z)({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0,buildLocalizeFn/* default */.Z)({
    values: dayPeriodValues,
    defaultWidth: 'any',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ const _lib_localize = (localize);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
var buildMatchFn = __webpack_require__(92395);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
var buildMatchPatternFn = __webpack_require__(70884);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ru/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^((до )?н\.?\s?э\.?)/i,
  abbreviated: /^((до )?н\.?\s?э\.?)/i,
  wide: /^(до нашей эры|нашей эры|наша эра)/i
};
var parseEraPatterns = {
  any: [/^д/i, /^н/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
  wide: /^[1234](-?[ыои]?й?)? квартал/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[яфмаисонд]/i,
  abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
  wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
};
var parseMonthPatterns = {
  narrow: [/^я/i, /^ф/i, /^м/i, /^а/i, /^м/i, /^и/i, /^и/i, /^а/i, /^с/i, /^о/i, /^н/i, /^я/i],
  any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^ав/i, /^с/i, /^о/i, /^н/i, /^д/i]
};
var matchDayPatterns = {
  narrow: /^[впсч]/i,
  short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
  abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
  wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
};
var parseDayPatterns = {
  narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
};
var matchDayPeriodPatterns = {
  narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^полн/i,
    noon: /^полд/i,
    morning: /^у/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i
  }
};
var match = {
  ordinalNumber: (0,buildMatchPatternFn/* default */.Z)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ const _lib_match = (match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ru/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary Russian locale.
 * @language Russian
 * @iso-639-2 rus
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'ru',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ const ru = (locale);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js + 5 modules
var en_US = __webpack_require__(37758);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/timepicker.js












function timepicker_slicedToArray(arr, i) { return timepicker_arrayWithHoles(arr) || timepicker_iterableToArrayLimit(arr, i) || timepicker_unsupportedIterableToArray(arr, i) || timepicker_nonIterableRest(); }
function timepicker_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function timepicker_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return timepicker_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return timepicker_arrayLikeToArray(o, minLen); }
function timepicker_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function timepicker_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function timepicker_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




var TOUCH_SENSITIVITY = 10;
function TimePickerPopup(props) {
  var selected = props.selected,
    _props$use12h = props.use12h,
    use12h = _props$use12h === void 0 ? false : _props$use12h,
    wantsToClose = props.wantsToClose,
    closeOnEsc = props.closeOnEsc,
    offset = props.offset,
    editor = props.editor,
    anchorNode = props.anchorNode,
    onChange = props.onChange;
  var maxHour = use12h ? 12 : 24;
  var _useState = (0,hooks_module/* useState */.eJ)(parseInt(dayjs_min_default()(selected).format(use12h ? 'hh' : 'HH'))),
    _useState2 = timepicker_slicedToArray(_useState, 2),
    hours = _useState2[0],
    setHours = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(parseInt(dayjs_min_default()(selected).format('mm'))),
    _useState4 = timepicker_slicedToArray(_useState3, 2),
    minutes = _useState4[0],
    setMinutes = _useState4[1];
  var _useState5 = (0,hooks_module/* useState */.eJ)(use12h ? dayjs_min_default()(selected).format('A') : false),
    _useState6 = timepicker_slicedToArray(_useState5, 2),
    ampm = _useState6[0],
    setAmpm = _useState6[1];
  var _useState7 = (0,hooks_module/* useState */.eJ)(null),
    _useState8 = timepicker_slicedToArray(_useState7, 2),
    hoursTouchStartEvent = _useState8[0],
    setHoursTouchStartEvent = _useState8[1];
  var _useState9 = (0,hooks_module/* useState */.eJ)(null),
    _useState10 = timepicker_slicedToArray(_useState9, 2),
    minutesTouchStartEvent = _useState10[0],
    setMinutesTouchStartEvent = _useState10[1];
  var onSelect = function onSelect() {
    var hour = ampm === 'PM' && hours < 12 ? 12 + hours : hours;
    if (ampm === 'AM' && hour === 12) {
      hour = 0;
    }
    onChange === null || onChange === void 0 ? void 0 : onChange(dayjs_min_default()(selected).set('hour', hour).set('minute', minutes).toDate());
    wantsToClose();
  };
  var visibleHours = [-3, -2, -1, 0, 1, 2, 3].reduce(function (res, offset) {
    var val = hours - offset;
    if (val < 0) {
      val = maxHour + hours - offset;
    }
    if (val > maxHour) {
      val = val - maxHour;
    }
    if (use12h) {
      if (val === 0) {
        val = 12;
      }
    } else {
      if (val === maxHour) {
        val = 0;
      }
    }
    res.push(val);
    return res;
  }, []);
  var visibleMinutes = [-3, -2, -1, 0, 1, 2, 3].reduce(function (res, offset) {
    var val = minutes - offset;
    if (val < 0) {
      val = 60 + minutes - offset;
    }
    if (val > 60) {
      val = val - 60;
    }
    if (val === 60) {
      val = 0;
    }
    res.push(val);
    return res;
  }, []);
  var onHoursWheel = function onHoursWheel(event) {
    var value;
    if (event.deltaY < 0) {
      value = hours + 1;
      if (use12h) {
        if (value > maxHour) {
          value = 1;
        }
      } else {
        if (value >= maxHour) {
          value = 0;
        }
      }
    } else {
      value = hours - 1;
      if (use12h) {
        if (value === 0) {
          value = 12;
        }
      } else {
        if (value < 0) {
          value = maxHour + value;
        }
      }
    }
    setHours(value);
  };
  var onMinutesWheel = function onMinutesWheel(event) {
    var value;
    if (event.deltaY < 0) {
      value = minutes + 1;
      if (value >= 60) {
        value = 0;
      }
    } else {
      value = minutes - 1;
      if (value < 0) {
        value = 59;
      }
    }
    setMinutes(value);
  };
  var onTimePickerTouchStart = function onTimePickerTouchStart(event) {
    event.stopPropagation();
  };
  var onTimePickerTouchMove = function onTimePickerTouchMove(event) {
    event.preventDefault();
  };
  var onHoursTouchStart = function onHoursTouchStart(event) {
    setHoursTouchStartEvent(event.touches[0]);
  };
  var onHoursTouchMove = function onHoursTouchMove(event) {
    var diffY = hoursTouchStartEvent.clientY - event.touches[0].clientY;
    if (Math.abs(diffY) > TOUCH_SENSITIVITY) {
      onHoursWheel({
        deltaY: diffY > 0 ? 1 : -1
      });
      setHoursTouchStartEvent(event.touches[0]);
    }
  };
  var onHoursTouchEnd = function onHoursTouchEnd(event) {
    setHoursTouchStartEvent(null);
  };
  var onMinutesTouchStart = function onMinutesTouchStart(event) {
    setMinutesTouchStartEvent(event.touches[0]);
  };
  var onMinutesTouchMove = function onMinutesTouchMove(event) {
    var diffY = minutesTouchStartEvent.clientY - event.touches[0].clientY;
    if (Math.abs(diffY) > TOUCH_SENSITIVITY) {
      onMinutesWheel({
        deltaY: diffY > 0 ? 1 : -1
      });
      setMinutesTouchStartEvent(event.touches[0]);
    }
  };
  var onMinutesTouchEnd = function onMinutesTouchEnd(event) {
    setMinutesTouchStartEvent(null);
  };
  var onHourClick = function onHourClick(hour) {
    setHours(hour);
  };
  var onMinuteClick = function onMinuteClick(minute) {
    setMinutes(minute);
  };
  var onAmClick = function onAmClick() {
    if (ampm !== 'AM') {
      setAmpm('AM');
    }
  };
  var onPmClick = function onPmClick() {
    if (ampm !== 'PM') {
      setAmpm('PM');
    }
  };
  return (0,preact_module.h)(popupMenu/* default */.Z, {
    addClassName: "timepicker-popup",
    closeOnEsc: closeOnEsc,
    wantsToClose: wantsToClose,
    anchorNode: anchorNode,
    anchorOptions: {
      positionFixed: true,
      offset: offset || '0px, 0px',
      placement: 'top',
      priority: ['bottom', 'right', 'left'],
      boundariesElement: editor.getScrollingContainer(),
      overflowBoundariesElement: editor.getScrollingContainer()
    }
  }, (0,preact_module.h)("div", {
    className: "editor-timepicker fusebase-theme",
    onTouchStart: onTimePickerTouchStart,
    onTouchMove: onTimePickerTouchMove
  }, (0,preact_module.h)("div", {
    className: "editor-timepicker-head"
  }, "".concat(hours < 10 ? '0' + hours : hours, ":").concat(minutes < 10 ? '0' + minutes : minutes), ampm ? (0,preact_module.h)("span", {
    className: "editor-timepicker-head-ampm"
  }, ampm) : null), (0,preact_module.h)("div", {
    className: "editor-timepicker-body"
  }, use12h ? (0,preact_module.h)("button", {
    className: 'timepicker-ampm-change' + (ampm === 'AM' ? ' active' : ''),
    onClick: onAmClick
  }, "AM") : null, (0,preact_module.h)("div", {
    className: "timepicker-hours-wheel",
    onMouseWheel: onHoursWheel,
    onTouchStart: onHoursTouchStart,
    onTouchMove: onHoursTouchMove,
    onTouchEnd: onHoursTouchEnd
  }, visibleHours.map(function (val) {
    return (0,preact_module.h)("span", {
      className: val === hours ? 'selected' : '',
      onClick: function onClick() {
        return onHourClick(val);
      }
    }, val < 10 ? "0".concat(val) : val);
  })), (0,preact_module.h)("div", {
    className: "timepicker-minutes-wheel",
    onMouseWheel: onMinutesWheel,
    onTouchStart: onMinutesTouchStart,
    onTouchMove: onMinutesTouchMove,
    onTouchEnd: onMinutesTouchEnd
  }, visibleMinutes.map(function (val) {
    return (0,preact_module.h)("span", {
      className: val === minutes ? 'selected' : '',
      onClick: function onClick() {
        return onMinuteClick(val);
      }
    }, val < 10 ? "0".concat(val) : val);
  })), use12h ? (0,preact_module.h)("button", {
    className: 'timepicker-ampm-change' + (ampm === 'PM' ? ' active' : ''),
    onClick: onPmClick
  }, "PM") : null), (0,preact_module.h)("div", {
    className: "editor-timepicker-footer"
  }, (0,preact_module.h)("button", {
    onClick: wantsToClose
  }, "Cancel"), (0,preact_module.h)("button", {
    className: "filled",
    onClick: onSelect
  }, "OK"))));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/datetimepicker.js
function datetimepicker_toConsumableArray(arr) { return datetimepicker_arrayWithoutHoles(arr) || datetimepicker_iterableToArray(arr) || datetimepicker_unsupportedIterableToArray(arr) || datetimepicker_nonIterableSpread(); }
function datetimepicker_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function datetimepicker_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function datetimepicker_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return datetimepicker_arrayLikeToArray(arr); }



















function datetimepicker_slicedToArray(arr, i) { return datetimepicker_arrayWithHoles(arr) || datetimepicker_iterableToArrayLimit(arr, i) || datetimepicker_unsupportedIterableToArray(arr, i) || datetimepicker_nonIterableRest(); }
function datetimepicker_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function datetimepicker_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return datetimepicker_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return datetimepicker_arrayLikeToArray(o, minLen); }
function datetimepicker_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function datetimepicker_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function datetimepicker_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


















(0,react_datepicker_min.registerLocale)('ru-RU', ru);
(0,react_datepicker_min.registerLocale)('en-US', en_US/* default */.Z);
var datetimepicker_DATE_FORMATS = {
  'ddmmyyyy': 'DD/MM/YYYY',
  'mmddyyyy': 'MM/DD/YYYY',
  'yyyyddmm': 'YYYY/MM/DD',
  'monthddyyyy': 'MMMM DD, YYYY'
};
var datetimepicker_REMINDER_VALUES = ['0m', '5m', '10m', '30m', '1h', '1d', '7d', '14d'];
var TIME_BOUND_REMINDERS = ['5m', '10m', '30m'];
function DateTimePicker(props) {
  var _editor$options$blots, _editor$options$blots2, _editor$options$blots3, _editor$options$blots4, _editor$plugins$remin, _editor$plugins$remin2;
  var selected = props.selected,
    onChange = props.onChange,
    _props$locale = props.locale,
    locale = _props$locale === void 0 ? 'en-US' : _props$locale,
    offset = props.offset,
    editor = props.editor,
    anchorNode = props.anchorNode,
    wantsToClose = props.wantsToClose,
    _props$type = props.type,
    type = _props$type === void 0 ? 'default' : _props$type,
    _props$showTime = props.showTime,
    propShowTime = _props$showTime === void 0 ? false : _props$showTime,
    _props$applyOnChange = props.applyOnChange,
    applyOnChange = _props$applyOnChange === void 0 ? false : _props$applyOnChange,
    _props$reminders = props.reminders,
    propReminders = _props$reminders === void 0 ? {} : _props$reminders;
  var i18n = editor.plugins.i18n;
  // если переданы настройки времени в опции блота даты, используем их, если нет, определяем по формату браузера
  var use12h = ((_editor$options$blots = editor.options.blots) === null || _editor$options$blots === void 0 ? void 0 : (_editor$options$blots2 = _editor$options$blots.date) === null || _editor$options$blots2 === void 0 ? void 0 : _editor$options$blots2.timeLocale) === 'en-US' ? true : ((_editor$options$blots3 = editor.options.blots) === null || _editor$options$blots3 === void 0 ? void 0 : (_editor$options$blots4 = _editor$options$blots3.date) === null || _editor$options$blots4 === void 0 ? void 0 : _editor$options$blots4.timeLocale) === 'en-GB' ? false : checkBrowserTimeFormat() === 12;
  // если выключен показ времени по умолчанию, выставляем выбранную дату в 12:00 PM
  var _useState = (0,hooks_module/* useState */.eJ)(selected ? !propShowTime ? dayjs_min_default()(selected).set('hour', 12).set('minute', 0).set('second', 0).toDate() : selected : dayjs_min_default()().set('hour', 12).set('minute', 0).set('second', 0).toDate()),
    _useState2 = datetimepicker_slicedToArray(_useState, 2),
    selectedDate = _useState2[0],
    setSelectedDate = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(!Boolean(selected)),
    _useState4 = datetimepicker_slicedToArray(_useState3, 2),
    clear = _useState4[0],
    setClear = _useState4[1];
  var _useState5 = (0,hooks_module/* useState */.eJ)(propShowTime),
    _useState6 = datetimepicker_slicedToArray(_useState5, 2),
    showTime = _useState6[0],
    setShowTime = _useState6[1];
  var _useState7 = (0,hooks_module/* useState */.eJ)(false),
    _useState8 = datetimepicker_slicedToArray(_useState7, 2),
    showTimePicker = _useState8[0],
    setShowTimePicker = _useState8[1];
  var _useState9 = (0,hooks_module/* useState */.eJ)(propReminders),
    _useState10 = datetimepicker_slicedToArray(_useState9, 2),
    reminders = _useState10[0],
    setReminders = _useState10[1];
  var _useState11 = (0,hooks_module/* useState */.eJ)(false),
    _useState12 = datetimepicker_slicedToArray(_useState11, 2),
    showRemindersMenu = _useState12[0],
    onShowRemindersMenu = _useState12[1];
  var _useState13 = (0,hooks_module/* useState */.eJ)(false),
    _useState14 = datetimepicker_slicedToArray(_useState13, 2),
    showConfirmRemoveTimeBoundReminders = _useState14[0],
    setShowConfirmRemoveTimeBoundReminders = _useState14[1];
  var handleWantsToClose = function handleWantsToClose() {
    if (showTimePicker || showRemindersMenu || showConfirmRemoveTimeBoundReminders) return;
    wantsToClose();
  };
  var onSelectDate = function onSelectDate(date) {
    if (clear) {
      setClear(false);
    }
    if (showTime) {
      var prevSelected = dayjs_min_default()(date);
      var hour = prevSelected.hour();
      var minute = prevSelected.minute();
      date = dayjs_min_default()(date).set('hour', hour).set('minute', minute).toDate();
    } else {
      // если выключен показ времени, выставляем выбранную дату в 12:00 PM
      date = dayjs_min_default()(date).set('hour', 12).set('minute', 0).set('second', 0).toDate();
    }
    setSelectedDate(date);
    applyOnChange && onChange({
      date: date,
      reminders: reminders,
      showTime: showTime,
      timeFormat: use12h ? 12 : 24
    });
  };
  var onSetReminders = function onSetReminders(value) {
    if (clear) {
      setClear(false);
    }
    setReminders(value);
    applyOnChange && onChange({
      date: selectedDate,
      reminders: value,
      showTime: showTime,
      timeFormat: use12h ? 12 : 24
    });
  };
  var hasTimeBoundReminders = function hasTimeBoundReminders() {
    var remindersIds = Object.keys(reminders);
    if (remindersIds.length) {
      var result = remindersIds.find(function (id) {
        return TIME_BOUND_REMINDERS.includes(reminders[id].value);
      });
      if (result) {
        return true;
      }
    }
    return false;
  };
  var removeTimeBoundReminders = function removeTimeBoundReminders() {
    if (Object.keys(reminders).length) {
      var clearedReminders = {};
      for (var id in reminders) {
        if (!TIME_BOUND_REMINDERS.includes(reminders[id].value)) {
          clearedReminders[id] = reminders[id];
        }
      }
      var date = dayjs_min_default()(selectedDate).set('hour', 12).set('minute', 0).set('second', 0).toDate();
      setSelectedDate(date);
      setReminders(clearedReminders);
      applyOnChange && onChange({
        date: date,
        reminders: clearedReminders,
        showTime: showTime,
        timeFormat: use12h ? 12 : 24
      });
    }
    setShowConfirmRemoveTimeBoundReminders(false);
  };
  var cancelRemoveTimeBoundReminders = function cancelRemoveTimeBoundReminders() {
    setShowConfirmRemoveTimeBoundReminders(false);
    setShowTime(true);
  };
  var onShowTimeSwitch = function onShowTimeSwitch(value) {
    if (clear) {
      setClear(false);
    }
    if (!value) {
      if (hasTimeBoundReminders()) {
        setShowConfirmRemoveTimeBoundReminders(true);
      } else {
        // если выключаем показ времени, выставляем выбранную дату в 12:00 PM
        var date = dayjs_min_default()(selectedDate).set('hour', 12).set('minute', 0).set('second', 0).toDate();
        setSelectedDate(date);
        applyOnChange && onChange({
          date: date,
          reminders: reminders,
          showTime: value,
          timeFormat: use12h ? 12 : 24
        });
      }
    } else {
      // если включаем показ времени, выставляем время на текущее время юзера
      var _date = dayjs_min_default()(selectedDate).set('hour', dayjs_min_default()().hour()).set('minute', dayjs_min_default()().minute()).set('second', dayjs_min_default()().second()).toDate();
      setSelectedDate(_date);
      applyOnChange && onChange({
        date: _date,
        reminders: reminders,
        showTime: value,
        timeFormat: use12h ? 12 : 24
      });
    }
    setShowTime(value);
  };
  var onTimeClick = function onTimeClick() {
    setShowTimePicker(true);
  };
  var onClearClick = function onClearClick() {
    setClear(true);
    setSelectedDate(dayjs_min_default()().set('hour', 12).set('minute', 0).set('second', 0).toDate());
    setShowTime(false);
    setReminders({});
    onChange(null);
  };
  var onCancelClick = function onCancelClick() {
    wantsToClose();
  };
  var onDoneClick = function onDoneClick() {
    if (clear) {
      onChange(null);
    } else {
      onChange({
        date: selectedDate,
        reminders: reminders,
        showTime: showTime
      });
    }
    wantsToClose();
  };
  var renderCustomNavigation = function renderCustomNavigation(_ref) {
    var date = _ref.date,
      decreaseMonth = _ref.decreaseMonth,
      increaseMonth = _ref.increaseMonth,
      prevMonthButtonDisabled = _ref.prevMonthButtonDisabled,
      nextMonthButtonDisabled = _ref.nextMonthButtonDisabled;
    return (0,preact_module.h)("div", {
      className: "react-datepicker-nav-header"
    }, (0,preact_module.h)("button", {
      className: "react-datepicker-nav react-datepicker-nav-prev",
      onClick: decreaseMonth,
      disabled: prevMonthButtonDisabled
    }, (0,preact_module.h)(icons/* IconChevronLeft */.ed9, null)), (0,preact_module.h)("div", {
      className: "react-datepicker-month"
    }, date.toLocaleDateString(locale, {
      month: 'long'
    }) + ' ' + date.getFullYear()), (0,preact_module.h)("button", {
      className: "react-datepicker-nav react-datepicker-nav-next",
      onClick: increaseMonth,
      disabled: nextMonthButtonDisabled
    }, (0,preact_module.h)(icons/* IconChevronRight */.VG8, null)));
  };
  return (0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)(popupMenu/* default */.Z, {
    addClassName: "date-picker-popup no-scroll",
    closeOnEsc: true,
    wantsToClose: handleWantsToClose,
    anchorNode: anchorNode,
    anchorOptions: {
      positionFixed: true,
      offset: offset || '0px, 0px',
      placement: 'top',
      priority: ['bottom', 'right', 'left'],
      boundariesElement: editor.getScrollingContainer(),
      overflowBoundariesElement: editor.getScrollingContainer()
    }
  }, (0,preact_module.h)("div", {
    className: "nim-editor-datepicker nimbus-theme fusebase-theme"
  }, (0,preact_module.h)((react_datepicker_min_default()), {
    calendarClassName: "nim-editor-datetimepicker",
    renderCustomHeader: renderCustomNavigation,
    selected: !clear ? selectedDate : null,
    onChange: onSelectDate,
    locale: locale,
    formatWeekDay: function formatWeekDay(nameOfDay) {
      return nameOfDay.substr(0, 1);
    },
    inline: true
  }), (0,preact_module.h)("div", {
    className: "datetimepicker-footer"
  }, (0,preact_module.h)("span", {
    className: "datetimepicker-footer-left bold"
  }, "When"), (0,preact_module.h)("span", {
    className: "datetimepicker-footer-main align-right"
  }, (0,preact_module.h)("span", {
    className: "datetimepicker-date-field"
  }, !datetimepicker_DATE_FORMATS[type] ? selectedDate.toLocaleDateString() : dayjs_min_default()(selectedDate).format(datetimepicker_DATE_FORMATS[type])), showTime ? (0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)("span", {
    className: "datetimepicker-time-field",
    onClick: onTimeClick
  }, dayjs_min_default()(selectedDate).format(use12h ? 'hh:mm A' : 'HH:mm')), showTimePicker ? (0,preact_module.h)(RootPlacement, {
    editor: editor,
    documentRoot: true,
    styled: true,
    transitionName: "popup-menu",
    transitionTimeout: vars.popupAppearDuration,
    useEditorOuterScrollingContainer: true
  }, (0,preact_module.h)("div", {
    className: "timepicker-popup-overlay"
  }, (0,preact_module.h)(TimePickerPopup, {
    selected: selectedDate,
    use12h: use12h,
    closeOnEsc: true,
    wantsToClose: function wantsToClose() {
      return setShowTimePicker(false);
    },
    editor: editor,
    onChange: onSelectDate
  }))) : null) : null)), (0,preact_module.h)("div", {
    className: "datetimepicker-control"
  }, (_editor$plugins$remin = editor.plugins.reminderManager) !== null && _editor$plugins$remin !== void 0 && (_editor$plugins$remin2 = _editor$plugins$remin.options) !== null && _editor$plugins$remin2 !== void 0 && _editor$plugins$remin2.enabled ? (0,preact_module.h)("div", {
    className: "datetimepicker-reminders"
  }, (0,preact_module.h)("div", {
    className: "datetimepicker-control-row"
  }, (0,preact_module.h)("span", {
    className: "datetimepicker-control-left"
  }, i18n.get('calendar.ui.reminder.name')), (0,preact_module.h)("span", {
    className: "datetimepicker-control-right"
  }, (0,preact_module.h)(ReminderOptionsSelect, {
    editor: editor,
    i18n: i18n,
    reminders: reminders,
    showMenu: showRemindersMenu,
    onShowMenu: onShowRemindersMenu,
    showTime: showTime,
    onChange: onSetReminders
  })))) : null, (0,preact_module.h)("div", {
    className: "datetimepicker-control-row"
  }, (0,preact_module.h)("span", {
    className: "datetimepicker-control-left"
  }, "Show time"), (0,preact_module.h)("span", {
    className: "datetimepicker-control-right"
  }, (0,preact_module.h)(components_switch, {
    enabled: showTime,
    onChange: onShowTimeSwitch,
    size: "large"
  }))), (0,preact_module.h)("div", {
    className: "datetimepicker-control-row"
  }, (0,preact_module.h)("span", {
    className: "datetimepicker-control-left"
  }, (0,preact_module.h)("span", {
    className: "datetimepicker-clear",
    onClick: onClearClick
  }, "Clear"))), (0,preact_module.h)("div", {
    className: "datetimepicker-control-row"
  }, (0,preact_module.h)("span", {
    className: "datetimepicker-control-left"
  }), (0,preact_module.h)("span", {
    className: "datetimepicker-control-right"
  }, (0,preact_module.h)("span", {
    className: "datetimepicker-control-buttons"
  }, (0,preact_module.h)("button", {
    onClick: onCancelClick
  }, "Cancel"), (0,preact_module.h)("button", {
    className: "filled",
    onClick: onDoneClick
  }, "Done"))))))), showConfirmRemoveTimeBoundReminders ? (0,preact_module.h)(RootPlacement, {
    editor: editor,
    documentRoot: true,
    styled: true,
    transitionName: "popup-menu",
    transitionTimeout: vars.popupAppearDuration,
    useEditorOuterScrollingContainer: true
  }, (0,preact_module.h)("div", {
    className: "root-placed-confirm-popup"
  }, (0,preact_module.h)(confirmPopup/* default */.Z, {
    onCancel: cancelRemoveTimeBoundReminders,
    onConfirm: removeTimeBoundReminders,
    message: i18n.get('calendar.ui.reminder.remove_confirm_message'),
    confirmText: i18n.get('calendar.ui.reminder.remove_confirm_text'),
    cancelText: i18n.get('calendar.ui.reminder.remove_cancel_text'),
    editor: editor,
    maxWidth: 400,
    revertButtons: true,
    addClassName: "confirm-delete-reminders"
  }))) : null);
}
function ReminderOptionsSelect(props) {
  var propReminders = props.reminders,
    i18n = props.i18n,
    editor = props.editor,
    showTime = props.showTime,
    onChange = props.onChange,
    showMenu = props.showMenu,
    onShowMenu = props.onShowMenu;
  var _useState15 = (0,hooks_module/* useState */.eJ)(Object.keys(propReminders).map(function (reminder) {
      return propReminders[reminder].value;
    }).sort(function (a, b) {
      return datetimepicker_REMINDER_VALUES.indexOf(a) > datetimepicker_REMINDER_VALUES.indexOf(b) ? 1 : -1;
    })),
    _useState16 = datetimepicker_slicedToArray(_useState15, 2),
    reminders = _useState16[0],
    setReminders = _useState16[1];
  var anchorRef = (0,hooks_module/* useRef */.sO)(null);
  (0,hooks_module/* useEffect */.d4)(function () {
    setReminders(Object.keys(propReminders).map(function (reminder) {
      return propReminders[reminder].value;
    }).sort(function (a, b) {
      return datetimepicker_REMINDER_VALUES.indexOf(a) > datetimepicker_REMINDER_VALUES.indexOf(b) ? 1 : -1;
    }));
  }, [propReminders]);
  var onReminderClick = function onReminderClick() {
    onShowMenu(true);
  };
  var wantsToClose = function wantsToClose() {
    onShowMenu(false);
    var toChange = reminders.reduce(function (acc, reminder) {
      var oldReminderId = Object.keys(propReminders).find(function (rem) {
        return propReminders[rem].value === reminder;
      });
      if (oldReminderId) {
        acc[oldReminderId] = propReminders[oldReminderId];
      } else {
        acc[generateId()] = {
          value: reminder,
          text: reminder,
          seconds: strToSeconds(reminder)
        };
      }
      return acc;
    }, {});
    onChange(toChange);
  };
  var onChangeReminder = function onChangeReminder(reminder, value) {
    if (value === true) {
      if (!reminders.includes(reminder)) {
        setReminders([].concat(datetimepicker_toConsumableArray(reminders), [reminder]).sort(function (a, b) {
          return datetimepicker_REMINDER_VALUES.indexOf(a) > datetimepicker_REMINDER_VALUES.indexOf(b) ? 1 : -1;
        }));
      }
    } else if (reminders.includes(reminder)) {
      setReminders(reminders.filter(function (val) {
        return val !== reminder;
      }));
    }
  };
  return (0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)("span", {
    className: 'datetimepicker-reminder' + (!reminders.length ? ' no-value' : ''),
    ref: anchorRef,
    onClick: onReminderClick
  }, reminders.length ? reminders.map(function (reminder) {
    return reminder === '0m' ? i18n.get("calendar.ui.reminder.value.".concat(reminder)) : reminder;
  }).join(',') : 'None', (0,preact_module.h)(icons/* IconArrowDown */.BDo, null)), (0,preact_module.h)(PopupMenuTransition, null, showMenu ? (0,preact_module.h)(popupMenu/* default */.Z, {
    addClassName: "popup-menu-reminders",
    closeOnEsc: true,
    wantsToClose: wantsToClose,
    anchorNode: anchorRef.current,
    anchorOptions: {
      priority: ['bottom'],
      offset: '5px, 17px',
      placement: 'right-end',
      boundariesElement: editor.getScrollingContainer()
    }
  }, datetimepicker_REMINDER_VALUES.map(function (value) {
    // если не показано время, не показываем опции с минутами
    if (!showTime && TIME_BOUND_REMINDERS.includes(value)) return null;
    return (0,preact_module.h)("div", {
      className: "datetimepicker-reminder-item"
    }, (0,preact_module.h)("div", {
      className: "datetimepicker-reminder-checkbox"
    }, (0,preact_module.h)(CheckboxComponent, {
      editable: true,
      checked: reminders.includes(value),
      onChange: function onChange(checked) {
        return onChangeReminder(value, checked);
      },
      useIcon: true
    })), (0,preact_module.h)("div", {
      className: "datetimepicker-reminder-name",
      onMouseDown: function onMouseDown() {
        return onChangeReminder(value, !reminders.includes(value));
      }
    }, i18n.get("calendar.ui.reminder.value.".concat(value))));
  })) : null));
}
function ReminderInlineIcon(_ref2) {
  var _ref2$reminders = _ref2.reminders,
    reminders = _ref2$reminders === void 0 ? {} : _ref2$reminders,
    editor = _ref2.editor,
    date = _ref2.date,
    getDateString = _ref2.getDateString;
  if (!reminders || !Object.keys(reminders).length) return null;
  var i18n = editor.plugins.i18n;
  var domRef = (0,hooks_module/* useRef */.sO)(null);
  var _useState17 = (0,hooks_module/* useState */.eJ)(false),
    _useState18 = datetimepicker_slicedToArray(_useState17, 2),
    showPanel = _useState18[0],
    setShowPanel = _useState18[1];
  var onMouseEnter = function onMouseEnter(event) {
    setShowPanel(true);
  };
  var onMouseLeave = function onMouseLeave(event) {
    setShowPanel(false);
  };
  var reminderTimeToString = function reminderTimeToString(seconds) {
    var str;
    if (seconds < 0) {
      str = i18n.get('calendar.ui.reminder.until.already_been');
    } else if (seconds === 0) {
      str = i18n.get('calendar.ui.reminder.until.now');
    } else if (seconds <= 60) {
      str = i18n.get('calendar.ui.reminder.until.less_minute');
    } else {
      str = i18n.get('calendar.ui.reminder.until.in');
      var oneMin = 60;
      var oneHour = 60 * oneMin;
      var oneDay = 24 * oneHour;
      var days = Math.floor(seconds / oneDay);
      var hours = Math.floor(seconds % oneDay / oneHour);
      var mins = Math.round(seconds % oneHour / oneMin);
      if (days > 0) {
        str += ' ' + days + i18n.get('calendar.ui.reminder.until.d');
      }
      if (hours > 0 || days > 0 && mins > 0) {
        str += ' ' + hours + i18n.get('calendar.ui.reminder.until.h');
      }
      if (mins > 0) {
        str += ' ' + mins + i18n.get('calendar.ui.reminder.until.m');
      }
    }
    return str;
  };
  var getItems = function getItems() {
    return Object.keys(reminders).map(function (reminderId, n) {
      var reminder = reminders[reminderId];
      var name = i18n.get('calendar.ui.reminder.panel_name');
      if (n > 0) {
        name += " ".concat(n + 1);
      }
      var now = Date.now();
      var reminderTime = date.timestamp - 1e3 * reminder.seconds;
      var timeString = getDateString ? getDateString(reminderTime, date.format) : dayjs_min_default()(reminderTime).format("MM/DD/YYYY".concat(date.format.showTime ? ' hh:mm A' : ''));
      var seconds = (reminderTime - now) / 1e3;
      var untilReminder = reminderTimeToString(seconds);
      var text = untilReminder + ' / ' + timeString;
      return (0,preact_module.h)("span", {
        className: "reminder-item"
      }, (0,preact_module.h)(icons/* IconBell */.YK1, null), (0,preact_module.h)("span", null, name, ": ", text));
    });
  };
  var reminderItems = showPanel ? getItems() : null;
  return (0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)("span", {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    ref: domRef
  }, (0,preact_module.h)(icons/* IconBell */.YK1, null)), showPanel ? (0,preact_module.h)(popupMenu/* default */.Z, {
    key: "reminder-panel",
    closeOnEsc: true,
    addClassName: "reminder-panel",
    anchorNode: domRef.current,
    anchorOptions: {
      placement: 'top',
      priority: ['right'],
      positionFixed: true,
      boundariesElement: editor.getScrollingContainer(),
      overflowBoundariesElement: editor.getScrollingContainer()
    }
  }, (0,preact_module.h)("span", {
    className: "reminder-container"
  }, reminderItems)) : null);
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/updateablePositionPopupMenu.js
function updateablePositionPopupMenu_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { updateablePositionPopupMenu_typeof = function _typeof(obj) { return typeof obj; }; } else { updateablePositionPopupMenu_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return updateablePositionPopupMenu_typeof(obj); }









function updateablePositionPopupMenu_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function updateablePositionPopupMenu_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function updateablePositionPopupMenu_createClass(Constructor, protoProps, staticProps) { if (protoProps) updateablePositionPopupMenu_defineProperties(Constructor.prototype, protoProps); if (staticProps) updateablePositionPopupMenu_defineProperties(Constructor, staticProps); return Constructor; }
function updateablePositionPopupMenu_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) updateablePositionPopupMenu_setPrototypeOf(subClass, superClass); }
function updateablePositionPopupMenu_setPrototypeOf(o, p) { updateablePositionPopupMenu_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return updateablePositionPopupMenu_setPrototypeOf(o, p); }
function updateablePositionPopupMenu_createSuper(Derived) { var hasNativeReflectConstruct = updateablePositionPopupMenu_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = updateablePositionPopupMenu_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = updateablePositionPopupMenu_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return updateablePositionPopupMenu_possibleConstructorReturn(this, result); }; }
function updateablePositionPopupMenu_possibleConstructorReturn(self, call) { if (call && (updateablePositionPopupMenu_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return updateablePositionPopupMenu_assertThisInitialized(self); }
function updateablePositionPopupMenu_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function updateablePositionPopupMenu_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function updateablePositionPopupMenu_getPrototypeOf(o) { updateablePositionPopupMenu_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return updateablePositionPopupMenu_getPrototypeOf(o); }


// Кастомный компонент нужен для постоянной реинициализации popper для него,
// так как этот компонент может рендериться вверх относительно anchorNode, и при уменьшении высоты компонента
// popper не перестраивает координаты верхенего края компонента.
var UpdateablePositionPopupMenu = /*#__PURE__*/function (_PopupMenu) {
  updateablePositionPopupMenu_inherits(UpdateablePositionPopupMenu, _PopupMenu);
  var _super = updateablePositionPopupMenu_createSuper(UpdateablePositionPopupMenu);
  function UpdateablePositionPopupMenu(props) {
    updateablePositionPopupMenu_classCallCheck(this, UpdateablePositionPopupMenu);
    return _super.call(this, props);
  }
  updateablePositionPopupMenu_createClass(UpdateablePositionPopupMenu, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this = this;
      // До использования setTimeout, передавался параметр freeze в компонент,
      // для того, чтобы при размонтировании компонента, он не улетал в левый верхний угол, так как popper дестроится.
      // Но меню конвертации - компонент с динамическим содержимым и freeze тут не подошел.
      // По этому тут дожидаемся всех событий обновления компонента и выполняем реинициализацию popper.
      setTimeout(function () {
        if (_this.popper) {
          _this.popper.destroy();
        }
        try {
          _this.createPopper();
        } catch (e) {}
      }, 0);
    }
  }]);
  return UpdateablePositionPopupMenu;
}(popupMenu/* default */.Z);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/usersSelect.js
function usersSelect_toConsumableArray(arr) { return usersSelect_arrayWithoutHoles(arr) || usersSelect_iterableToArray(arr) || usersSelect_unsupportedIterableToArray(arr) || usersSelect_nonIterableSpread(); }
function usersSelect_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function usersSelect_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function usersSelect_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return usersSelect_arrayLikeToArray(arr); }

function usersSelect_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function usersSelect_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { usersSelect_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { usersSelect_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function usersSelect_slicedToArray(arr, i) { return usersSelect_arrayWithHoles(arr) || usersSelect_iterableToArrayLimit(arr, i) || usersSelect_unsupportedIterableToArray(arr, i) || usersSelect_nonIterableRest(); }
function usersSelect_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function usersSelect_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return usersSelect_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return usersSelect_arrayLikeToArray(o, minLen); }
function usersSelect_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function usersSelect_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function usersSelect_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

























var getUserInitials = function getUserInitials() {
  var userName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  // first prepare name by removing extra spaces
  userName = userName.trim().replace(/\s+/g, ' ');
  var initials = userName.slice(0, 2);
  var firstLastNames = userName.split(' ');
  if (firstLastNames.length > 1) {
    initials = firstLastNames[0].at(0) + firstLastNames[1].at(0);
  }
  return initials.toUpperCase();
};
function UsersSelect(_ref) {
  var _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? [] : _ref$selected,
    onChange = _ref.onChange,
    editor = _ref.editor,
    anchorNode = _ref.anchorNode,
    wantsToClose = _ref.wantsToClose,
    offset = _ref.offset,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 3 : _ref$max,
    _ref$overMaxMessage = _ref.overMaxMessage,
    overMaxMessage = _ref$overMaxMessage === void 0 ? 'You can assign up to three members.' : _ref$overMaxMessage;
  var _useState = (0,hooks_module/* useState */.eJ)([]),
    _useState2 = usersSelect_slicedToArray(_useState, 2),
    users = _useState2[0],
    setUsers = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(selected),
    _useState4 = usersSelect_slicedToArray(_useState3, 2),
    selectedUsers = _useState4[0],
    setSelectedUsers = _useState4[1];
  var _useState5 = (0,hooks_module/* useState */.eJ)(true),
    _useState6 = usersSelect_slicedToArray(_useState5, 2),
    loading = _useState6[0],
    setLoading = _useState6[1];
  var sortUsers = function sortUsers(usersArr) {
    return usersArr.sort(function (a, b) {
      return a.name[0].toLowerCase() > b.name[0].toLowerCase() ? 1 : -1;
    });
  };
  var pushNotification = function pushNotification() {
    editor.plugins.notificationManager.toast(overMaxMessage);
  };
  (0,hooks_module/* useEffect */.d4)( /*#__PURE__*/usersSelect_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var result;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!loading) {
              _context.next = 13;
              break;
            }
            if (!editor.plugins.mentionManager) {
              _context.next = 12;
              break;
            }
            _context.prev = 2;
            _context.next = 5;
            return editor.plugins.mentionManager.searchItems('', 'user');
          case 5:
            result = _context.sent;
            if (result.user && result.user.length) {
              setUsers(result.user.map(function (user) {
                var mappedUser = {
                  id: String(user.object_id),
                  name: user.name
                };
                if (user.icon) {
                  mappedUser.icon = user.icon;
                }
                return mappedUser;
              }));
            }
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);
            console.error(_context.t0);
          case 12:
            setLoading(false);
          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 9]]);
  })), []);
  var onUserItemClick = function onUserItemClick(user) {
    var index = selectedUsers.findIndex(function (u) {
      return u.id === user.id;
    });
    if (index < 0) {
      if (selectedUsers.length < max) {
        var toSelect = sortUsers([].concat(usersSelect_toConsumableArray(selectedUsers), [user]));
        setSelectedUsers(toSelect);
        onChange && onChange(toSelect);
      } else {
        pushNotification();
      }
    } else {
      var _toSelect = sortUsers(usersSelect_toConsumableArray(selectedUsers));
      _toSelect.splice(index, 1);
      setSelectedUsers(sortUsers(_toSelect));
      onChange && onChange(sortUsers(_toSelect));
    }
  };
  var notSelectedUsers = sortUsers(users.filter(function (user) {
    return !selectedUsers.find(function (u) {
      return u.id === user.id;
    });
  }));
  return (0,preact_module.h)(UpdateablePositionPopupMenu, {
    addClassName: "user-select-popup",
    closeOnEsc: true,
    wantsToClose: wantsToClose,
    anchorNode: anchorNode,
    anchorOptions: {
      positionFixed: true,
      offset: offset || '0px, 0px',
      placement: 'bottom',
      priority: ['top', 'right', 'left'],
      boundariesElement: editor.getScrollingContainer(),
      overflowBoundariesElement: editor.getScrollingContainer()
    }
  }, users.length ? (0,preact_module.h)(preact_module/* Fragment */.HY, null, selectedUsers && selectedUsers.length ? (0,preact_module.h)("div", {
    className: "users-select-selected"
  }, sortUsers(selectedUsers).map(function (user) {
    return (0,preact_module.h)("span", {
      class: "users-select-item",
      onClick: function onClick() {
        return onUserItemClick(user);
      }
    }, (0,preact_module.h)("span", {
      class: "users-select-item-avatar"
    }, user.icon ? (0,preact_module.h)("img", {
      src: user.icon
    }) : (0,preact_module.h)("span", {
      class: "users-select-item-initials"
    }, getUserInitials(user.name))), (0,preact_module.h)("span", {
      class: "users-select-item-name"
    }, user.name));
  })) : null, notSelectedUsers && notSelectedUsers.length ? (0,preact_module.h)("div", {
    className: "users-select-list"
  }, notSelectedUsers.map(function (user) {
    return (0,preact_module.h)("span", {
      class: "users-select-item",
      onClick: function onClick() {
        return onUserItemClick(user);
      }
    }, (0,preact_module.h)("span", {
      class: "users-select-item-avatar"
    }, user.icon ? (0,preact_module.h)("img", {
      src: user.icon
    }) : (0,preact_module.h)("span", {
      class: "users-select-item-initials"
    }, getUserInitials(user.name))), (0,preact_module.h)("span", {
      class: "users-select-item-name"
    }, user.name));
  })) : null) : loading ? (0,preact_module.h)("span", {
    className: "users-select-loading"
  }, (0,preact_module.h)((loader2_default()), null)) : (0,preact_module.h)("span", {
    className: "users-select-empty"
  }, "No members found"));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/step/stepComponents.js
function stepComponents_extends() { stepComponents_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return stepComponents_extends.apply(this, arguments); }
function stepComponents_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











function StepDateComponent(_ref) {
  var _blot$editor$plugins;
  var blot = _ref.blot;
  var locale = ((_blot$editor$plugins = blot.editor.plugins) === null || _blot$editor$plugins === void 0 ? void 0 : _blot$editor$plugins.i18n.language) === 'ru' ? 'ru-RU' : 'en-US';
  var editMode = blot.editor.mode === MODE_EDIT;
  return editMode || blot.map.get('date') ? (0,preact_module.h)("div", {
    className: "step-date"
  }, (0,preact_module.h)("div", {
    className: "step-date-value ".concat(!blot.map.get('date') ? 'empty' : ''),
    ref: blot.onDateRef,
    onMouseDown: blot.onDateMouseDown
  }, (0,preact_module.h)(icons/* IconCalendar */.jt6, null), blot.map.get('date') ? (0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)("span", {
    className: "step-date-string"
  }, blot.getDateString(blot.map.get('date').timestamp, blot.map.get('date').format)), blot.map.get('reminders') ? (0,preact_module.h)(ReminderInlineIcon, {
    reminders: blot.map.get('reminders'),
    editor: blot.editor,
    date: blot.map.get('date'),
    getDateString: blot.getDateString
  }) : null) : null), blot.props.datepickerOpen ? (0,preact_module.h)(DateTimePicker, {
    selected: blot.map.get('date') ? new Date(blot.map.get('date').timestamp) : false,
    showTime: blot.map.get('date') && blot.map.get('date').format.showTime,
    onChange: blot.onDateChange,
    offset: "0px, 0px",
    editor: blot.editor,
    anchorNode: blot.dateNode,
    wantsToClose: blot.onDateTimePickerWantsToClose,
    locale: locale,
    reminders: blot.map.get('reminders') || {}
  }) : null) : null;
}
function StepAssigneeComponent(_ref2) {
  var blot = _ref2.blot;
  var editMode = blot.editor.mode === MODE_EDIT;
  var allowRender = editMode || blot.map.get('assignee') && blot.map.get('assignee').length;
  return allowRender ? (0,preact_module.h)("div", {
    className: "step-assignee"
  }, (0,preact_module.h)("div", {
    className: "step-assignee-value",
    onMouseDown: blot.onAssigneeMouseDown,
    ref: blot.onAssigneeRef
  }, blot.map.get('assignee') && blot.map.get('assignee').length ? (0,preact_module.h)("div", {
    className: "step-assignees"
  }, blot.map.get('assignee').map(function (user) {
    var displayName = user.name;
    if (!displayName || typeof displayName === 'undefined') {
      displayName = 'Unknown';
    }
    var tooltipAttrs = stepComponents_defineProperty({}, tooltipManager/* TOOLTIP_ATTR */.qZ, displayName);
    var initials = displayName.substr(0, 2);
    var firstLastNames = displayName.split(' ');
    if (firstLastNames.length > 1) {
      initials = firstLastNames[0].at(0) + firstLastNames[1].at(0);
    }
    return (0,preact_module.h)("div", stepComponents_extends({
      className: "step-assignee-avatar"
    }, tooltipAttrs), !user.icon || typeof user.icon === 'undefined' ? initials : (0,preact_module.h)("img", {
      src: user.icon
    }));
  })) : (0,preact_module.h)(icons/* IconUserPlus */.$4n, null)), blot.props.showAssigneeSelect ? (0,preact_module.h)(UsersSelect, {
    editor: blot.editor,
    selected: blot.map.get('assignee') || [],
    onChange: blot.onAssigneeChange,
    anchorNode: blot.assigneeNode,
    wantsToClose: blot.onAssigneeSelectWantsToClose,
    max: 3,
    overMaxMessage: "You can assign up to three members to a step."
  }) : null) : null;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/step/stepAggregator.js
function stepAggregator_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { stepAggregator_typeof = function _typeof(obj) { return typeof obj; }; } else { stepAggregator_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return stepAggregator_typeof(obj); }
function stepAggregator_slicedToArray(arr, i) { return stepAggregator_arrayWithHoles(arr) || stepAggregator_iterableToArrayLimit(arr, i) || stepAggregator_unsupportedIterableToArray(arr, i) || stepAggregator_nonIterableRest(); }
function stepAggregator_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function stepAggregator_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return stepAggregator_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return stepAggregator_arrayLikeToArray(o, minLen); }
function stepAggregator_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function stepAggregator_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function stepAggregator_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



















function stepAggregator_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function stepAggregator_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function stepAggregator_createClass(Constructor, protoProps, staticProps) { if (protoProps) stepAggregator_defineProperties(Constructor.prototype, protoProps); if (staticProps) stepAggregator_defineProperties(Constructor, staticProps); return Constructor; }
function stepAggregator_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { stepAggregator_get = Reflect.get; } else { stepAggregator_get = function _get(target, property, receiver) { var base = stepAggregator_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return stepAggregator_get(target, property, receiver || target); }
function stepAggregator_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = stepAggregator_getPrototypeOf(object); if (object === null) break; } return object; }
function stepAggregator_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) stepAggregator_setPrototypeOf(subClass, superClass); }
function stepAggregator_setPrototypeOf(o, p) { stepAggregator_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return stepAggregator_setPrototypeOf(o, p); }
function stepAggregator_createSuper(Derived) { var hasNativeReflectConstruct = stepAggregator_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = stepAggregator_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = stepAggregator_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return stepAggregator_possibleConstructorReturn(this, result); }; }
function stepAggregator_possibleConstructorReturn(self, call) { if (call && (stepAggregator_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return stepAggregator_assertThisInitialized(self); }
function stepAggregator_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function stepAggregator_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function stepAggregator_getPrototypeOf(o) { stepAggregator_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return stepAggregator_getPrototypeOf(o); }
function stepAggregator_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





















var stepAggregator_mixin = mix([commentable, blotLock, embeddable, draggable, dropAcceptor, selectable, focusable, executable, basic]);
var stepAggregator_isEnterKey = (0,lib/* default */.ZP)('enter');
var stepAggregator_isEscKey = (0,lib/* default */.ZP)('escape');
var STEP_AGGREGATOR_MAX_TITLE_LENGTH = 100;
var StepAggregator = /*#__PURE__*/function (_mixin) {
  stepAggregator_inherits(StepAggregator, _mixin);
  var _super = stepAggregator_createSuper(StepAggregator);
  function StepAggregator(domNode) {
    var _this;
    stepAggregator_classCallCheck(this, StepAggregator);
    _this = _super.call(this, domNode);
    stepAggregator_defineProperty(stepAggregator_assertThisInitialized(_this), "onDateRef", function (node) {
      _this.dateNode = node;
    });
    stepAggregator_defineProperty(stepAggregator_assertThisInitialized(_this), "onAssigneeRef", function (node) {
      _this.assigneeNode = node;
    });
    stepAggregator_defineProperty(stepAggregator_assertThisInitialized(_this), "onDocumentMouseDown", function (event) {
      if (event.target !== _this.renameInputNode && _this.props.renaming) {
        _this.onApplyName();
      }
    });
    stepAggregator_defineProperty(stepAggregator_assertThisInitialized(_this), "updateStepsCount", function () {
      var count = _this.allSteps.length;
      _this.stepsCountNode.setAttribute('data-steps-count', count);
    });
    stepAggregator_defineProperty(stepAggregator_assertThisInitialized(_this), "mapObserver", function () {
      _this.render();
    });
    stepAggregator_defineProperty(stepAggregator_assertThisInitialized(_this), "onRenameInputNodeRef", function (node) {
      _this.renameInputNode = node;
    });
    stepAggregator_defineProperty(stepAggregator_assertThisInitialized(_this), "onStepsCountRef", function (node) {
      _this.stepsCountNode = node;
    });
    stepAggregator_defineProperty(stepAggregator_assertThisInitialized(_this), "onRenameInputKeyDown", function (event) {
      if (stepAggregator_isEnterKey(event)) {
        _this.onApplyName();
      }
      if (stepAggregator_isEscKey(event)) {
        _this.onApplyName(false);
      }
    });
    stepAggregator_defineProperty(stepAggregator_assertThisInitialized(_this), "onRenameInput", function (event) {
      if (event.target.value.length >= STEP_AGGREGATOR_MAX_TITLE_LENGTH) {
        event.target.value = event.target.value.slice(0, STEP_AGGREGATOR_MAX_TITLE_LENGTH);
      }
    });
    stepAggregator_defineProperty(stepAggregator_assertThisInitialized(_this), "onNameClick", function () {
      if (_this.editor.mode === MODE_EDIT) {
        _this.setProps({
          renaming: true
        });
        _this.renameInputNode.focus();
        _this.renameInputNode.select();
      }
    });
    stepAggregator_defineProperty(stepAggregator_assertThisInitialized(_this), "onStepsCounterClick", function (event) {
      event.preventDefault();
      var _this$allSteps = stepAggregator_slicedToArray(_this.allSteps, 1),
        firstStep = _this$allSteps[0];
      if (firstStep && _this.editor.plugins.scrollSaver) {
        _this.editor.plugins.scrollSaver.scrollToBlot(firstStep.id, true, false);
      }
    });
    stepAggregator_defineProperty(stepAggregator_assertThisInitialized(_this), "onDateMouseDown", function (event) {
      if (_this.editor.mode === MODE_EDIT) {
        event.preventDefault();
        _this.setProps({
          datepickerOpen: true
        });
      }
    });
    stepAggregator_defineProperty(stepAggregator_assertThisInitialized(_this), "onDateTimePickerWantsToClose", function () {
      _this.setProps({
        datepickerOpen: false
      });
    });
    stepAggregator_defineProperty(stepAggregator_assertThisInitialized(_this), "onDateChange", function (value) {
      if (!value) {
        _this.map.delete('date');
        _this.map.delete('reminders');
      } else {
        var date = value.date,
          _value$reminders = value.reminders,
          reminders = _value$reminders === void 0 ? {} : _value$reminders,
          _value$showTime = value.showTime,
          showTime = _value$showTime === void 0 ? false : _value$showTime,
          _value$timeFormat = value.timeFormat,
          timeFormat = _value$timeFormat === void 0 ? 12 : _value$timeFormat;
        _this.map.set('date', {
          timestamp: date.getTime(),
          format: {
            showTime: showTime,
            timeFormat: timeFormat
          }
        });
        if (Object.keys(reminders).length) {
          _this.map.set('reminders', reminders);
        } else if (_this.map.get('reminders')) {
          _this.map.delete('reminders');
        }
      }
    });
    stepAggregator_defineProperty(stepAggregator_assertThisInitialized(_this), "getDateString", function (timestamp, format) {
      var _this$editor$plugins, _this$editor$options$, _this$editor$options$2;
      var locale = (_this$editor$plugins = _this.editor.plugins) === null || _this$editor$plugins === void 0 ? void 0 : _this$editor$plugins.i18n.language;
      var timeLocale = (_this$editor$options$ = _this.editor.options.blots) === null || _this$editor$options$ === void 0 ? void 0 : (_this$editor$options$2 = _this$editor$options$.date) === null || _this$editor$options$2 === void 0 ? void 0 : _this$editor$options$2.timeLocale;
      var use12hFormat = timeLocale === 'en-US' ? true : timeLocale === 'en-GB' ? false : checkBrowserTimeFormat() === 12;
      return "".concat(dayjs_min_default()(timestamp).locale(locale === 'ru' ? locale : 'en').format('DD MMM'), "\n      ").concat(format.showTime ? dayjs_min_default()(timestamp).locale('en').format(use12hFormat ? ' hh:mm A' : ' HH:mm') : '');
    });
    stepAggregator_defineProperty(stepAggregator_assertThisInitialized(_this), "onAssigneeMouseDown", function (event) {
      if (_this.editor.mode === MODE_EDIT) {
        _this.setProps({
          showAssigneeSelect: true
        });
      }
    });
    stepAggregator_defineProperty(stepAggregator_assertThisInitialized(_this), "onAssigneeSelectWantsToClose", function () {
      _this.setProps({
        showAssigneeSelect: false
      });
    });
    stepAggregator_defineProperty(stepAggregator_assertThisInitialized(_this), "onAssigneeChange", function (value) {
      _this.map.set('assignee', value);
    });
    _this.isSeparableByClickApplicable = true;
    _this.addCanExecActions(['delete', 'backspace']);
    _this.disallowReplace = true;
    _this.debouncedUpdateStepsCount = lodash_debounce_default()(_this.updateStepsCount, 1000, {
      trailing: true
    });
    return _this;
  }
  stepAggregator_createClass(StepAggregator, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = stepAggregator_get(stepAggregator_getPrototypeOf(StepAggregator.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      this.store.observe(this.map, this.mapObserver);
      document.addEventListener('mousedown', this.onDocumentMouseDown, false);
      this.editor.on('SCROLL_UPDATE', this.debouncedUpdateStepsCount);
      this.render();
    }
  }, {
    key: "detach",
    value: function detach() {
      if (stepAggregator_get(stepAggregator_getPrototypeOf(StepAggregator.prototype), "detach", this)) {
        var _get3;
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        (_get3 = stepAggregator_get(stepAggregator_getPrototypeOf(StepAggregator.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      }
      this.store.unobserve(this.map, this.mapObserver);
      document.removeEventListener('mousedown', this.onDocumentMouseDown, false);
      this.editor.off('SCROLL_UPDATE', this.debouncedUpdateStepsCount);
    }
  }, {
    key: "allAggregators",
    get: function get() {
      return this.editor.scroll.descendants(function (blot) {
        return blot.constructor.blotName === 'step-aggregator';
      });
    }
  }, {
    key: "allSteps",
    get: function get() {
      return this.editor.scroll.descendants(function (blot) {
        return blot.constructor.blotName === 'step';
      });
    }
  }, {
    key: "applyForAllAggregatorsMap",
    value: function applyForAllAggregatorsMap(key, value) {
      this.allAggregators.forEach(function (blot) {
        blot.map.set(key, value);
      });
    }
  }, {
    key: "onApplyName",
    value: function onApplyName() {
      var apply = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (this.renameInputNode) {
        var value = this.renameInputNode.value.trim();
        if (apply && value !== '') {
          this.applyForAllAggregatorsMap('name', value);
        }
      }
      this.setProps({
        renaming: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      stepAggregator_get(stepAggregator_getPrototypeOf(StepAggregator.prototype), "render", this).call(this);
      var container = this.domNode.querySelector('.' + this.statics.containerClassName);
      //const editMode = this.editor.mode === this.editor.constructor.MODE_EDIT
      var renaming = this.props.renaming;
      var name = this.map.get('name') || 'About steps';
      var i18n = this.editor.plugins.i18n;
      (0,preact_module/* render */.sY)((0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)("div", {
        className: "step-aggregator-top"
      }, renaming ? (0,preact_module.h)("div", {
        className: "step-aggregator-name renaming"
      }, (0,preact_module.h)("input", {
        ref: this.onRenameInputNodeRef,
        type: "text",
        onKeyDown: this.onRenameInputKeyDown,
        value: name,
        onInput: this.onRenameInput,
        placeholder: i18n.get('step.aggregator_placeholder')
      })) : (0,preact_module.h)("div", {
        className: "step-aggregator-name",
        onClick: this.onNameClick,
        onMouseDown: function onMouseDown(event) {
          event.preventDefault();
        }
      }, (0,preact_module.h)("span", stepAggregator_defineProperty({}, tooltipManager/* TOOLTIP_ATTR */.qZ, name), name))), (0,preact_module.h)("div", {
        className: "step-aggregator-bottom"
      }, (0,preact_module.h)("div", {
        className: "step-aggregator-left"
      }, (0,preact_module.h)("span", {
        className: "steps-count",
        ref: this.onStepsCountRef,
        onClick: this.onStepsCounterClick
      }, "Total Steps:")), (0,preact_module.h)("div", {
        className: "step-aggregator-right"
      }, (0,preact_module.h)(StepDateComponent, {
        blot: this
      }), (0,preact_module.h)(StepAssigneeComponent, {
        blot: this
      })))), container);
    }
  }, {
    key: "remove",
    value: function remove() {
      var _get4;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      (_get4 = stepAggregator_get(stepAggregator_getPrototypeOf(StepAggregator.prototype), "remove", this)).call.apply(_get4, [this].concat(args));
    }
  }, {
    key: "cloneSelf",
    value: function cloneSelf() {
      var map = this.store.createMap();
      var options = this.getMapParams();
      parchment_default().query(this.map.get('type')).initMap(map, this.store, options);
      return map.get('id');
    }
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      var params = stepAggregator_get(stepAggregator_getPrototypeOf(StepAggregator.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
      return (0,util/* mergeDeep */.Ee)(params, {
        initParams: this.getMapParams()
      });
    }
  }, {
    key: "getMapParams",
    value: function getMapParams() {
      return {
        name: this.map.get('name')
      };
    }
  }, {
    key: "onDraggingGetPhantomPos",
    value: function onDraggingGetPhantomPos() {
      return this.domNode.getBoundingClientRect();
    }
  }, {
    key: "toHTML",
    value: function toHTML() {
      return this.domNode.outerHTML;
    }
  }], [{
    key: "create",
    value: function create(value) {
      var node = stepAggregator_get(stepAggregator_getPrototypeOf(StepAggregator), "create", this).call(this);
      var container = document.createElement('div');
      container.setAttribute('contenteditable', false);
      container.classList.add(this.containerClassName);
      node.appendChild(container);
      return node;
    }
  }, {
    key: "createBlot",
    value: function createBlot(editor) {
      var blot = parchment_default().create('step-aggregator');
      this.addCaretTrap(editor, blot.domNode);
      return blot;
    }
  }]);
  return StepAggregator;
}(stepAggregator_mixin(blockEmbed));

StepAggregator.blotName = 'step-aggregator';
StepAggregator.tagName = 'DIV';
StepAggregator.className = 'step-aggregator';
StepAggregator.containerClassName = 'step-aggregator-container';
StepAggregator.initMap = function (map, store) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  map.set('type', StepAggregator.blotName);
  if (params.name) {
    map.set('name', params.name);
  }
};
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/gridCol.js
function gridCol_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { gridCol_typeof = function _typeof(obj) { return typeof obj; }; } else { gridCol_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return gridCol_typeof(obj); }
function gridCol_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = gridCol_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function gridCol_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return gridCol_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return gridCol_arrayLikeToArray(o, minLen); }
function gridCol_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function gridCol_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function gridCol_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function gridCol_createClass(Constructor, protoProps, staticProps) { if (protoProps) gridCol_defineProperties(Constructor.prototype, protoProps); if (staticProps) gridCol_defineProperties(Constructor, staticProps); return Constructor; }
function gridCol_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { gridCol_get = Reflect.get; } else { gridCol_get = function _get(target, property, receiver) { var base = gridCol_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return gridCol_get(target, property, receiver || target); }
function gridCol_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = gridCol_getPrototypeOf(object); if (object === null) break; } return object; }
function gridCol_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) gridCol_setPrototypeOf(subClass, superClass); }
function gridCol_setPrototypeOf(o, p) { gridCol_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return gridCol_setPrototypeOf(o, p); }
function gridCol_createSuper(Derived) { var hasNativeReflectConstruct = gridCol_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = gridCol_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = gridCol_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return gridCol_possibleConstructorReturn(this, result); }; }
function gridCol_possibleConstructorReturn(self, call) { if (call && (gridCol_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return gridCol_assertThisInitialized(self); }
function gridCol_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function gridCol_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function gridCol_getPrototypeOf(o) { gridCol_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return gridCol_getPrototypeOf(o); }
function gridCol_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






















































//min size for grid-col
// меньше чем 120 лучше не ставить иначе файлы не влазят
var MIN_COL_SIZE = 120;
var LIST_MARGIN = 70;
var GRID_PADDING = 35;
var GRID_COL_RESIZE_ZONE = 15;
var PAGE_WIDTH = parseInt(vars.pageWidth.replace('px', ''));
var GRID_COL_CLASS = 'grid';
var GridCol = /*#__PURE__*/function (_ContainerMixin) {
  gridCol_inherits(GridCol, _ContainerMixin);
  var _super = gridCol_createSuper(GridCol);
  function GridCol(domNode) {
    var _this;
    gridCol_classCallCheck(this, GridCol);
    _this = _super.call(this, domNode);
    gridCol_defineProperty(gridCol_assertThisInitialized(_this), "getMaxWidth", function () {
      var containerWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var contWidth = containerWidth;
      if (!containerWidth) {
        var _this$container$domNo = _this.container.domNode.getBoundingClientRect();
        contWidth = _this$container$domNo.width;
      }
      var width = _this.props.width; // ширина колонки в %
      // коэффициент определен методом подбора, предназначен для расчета значения паддингов для колонки
      var k = 2.75;
      // для левой и правой колонки коэффициент уменьшается на 1 т.к. нет падннига слева и справа соответственно
      if (_this.parent.children.head === gridCol_assertThisInitialized(_this) || _this.parent.children.tail === gridCol_assertThisInitialized(_this)) {
        k -= 1;
      }
      return Math.floor(contWidth * width / 100) - k * GRID_PADDING;
    });
    gridCol_defineProperty(gridCol_assertThisInitialized(_this), "mapObserver", function () {
      _this.render();
    });
    gridCol_defineProperty(gridCol_assertThisInitialized(_this), "onMouseMove", function (event) {
      if (_this.scroll.props.dragSession) return;
      var target = event.target;
      if (target !== _this.domNode) {
        if (_this.scroll.domNode.style.cursor !== 'text') {
          _this.scroll.domNode.style.cursor = _this.editor.api.getCursorStyle('text');
        }
        if (_this.parent.domNode.classList.contains('bordered-grid')) {
          _this.parent.domNode.classList.remove('bordered-grid');
        }
        return;
      }
      var rowGrids = _this.container.getCols();
      var rect = _this.domNode.getBoundingClientRect();
      var x = event.clientX;
      var y = event.clientY;
      if (rect.y < y && rect.y + rect.height > y) {
        var zone = 15;
        if (rect.x <= x && rect.x + zone >= x && gridCol_assertThisInitialized(_this) != rowGrids[0]) {
          _this.scroll.domNode.style.cursor = _this.editor.api.getCursorStyle('left');
          if (!_this.parent.domNode.classList.contains('bordered-grid')) {
            _this.parent.domNode.classList.add('bordered-grid');
          }
        }
        if (rect.x + rect.width - zone <= x && rect.x + rect.width >= x && gridCol_assertThisInitialized(_this) != rowGrids[rowGrids.length - 1]) {
          _this.scroll.domNode.style.cursor = _this.editor.api.getCursorStyle('right');
          if (!_this.parent.domNode.classList.contains('bordered-grid')) {
            _this.parent.domNode.classList.add('bordered-grid');
          }
        }
        if (rect.x + zone < x && rect.x + rect.width - zone > x) {
          _this.scroll.domNode.style.cursor = _this.editor.api.getCursorStyle('text');
          if (_this.parent.domNode.classList.contains('bordered-grid')) {
            _this.parent.domNode.classList.remove('bordered-grid');
          }
        }
      }
    });
    gridCol_defineProperty(gridCol_assertThisInitialized(_this), "onMouseLeave", function (event) {
      if (event.relatedTarget != null) {
        if (parchment_default().find(event.relatedTarget) != null) {
          if (!(parchment_default().find(event.relatedTarget).constructor.blotName == 'grid' || parchment_default().find(event.relatedTarget).parent != null && parchment_default().find(event.relatedTarget).parent.constructor.blotName == 'grid')) {
            _this.scroll.domNode.style.cursor = _this.editor.api.getCursorStyle('text');
          }
        }
      }
    });
    _this.width;
    _this.map;
    _this.token = false;
    _this.domNode.setAttribute('data-type', 'grid');
    _this.domNode.setAttribute('data-border', null);
    _this.domNode.classList.add(GRID_COL_CLASS);
    _this.resize = false;
    _this.addCanExecActions(container.canExecActions);
    // this.isSubContainer = true
    return _this;
  }
  gridCol_createClass(GridCol, [{
    key: "needFlatten",
    value: function needFlatten() {
      var config = this.editor.blotsConfig.grid || {};
      return config.flatten;
    }
  }, {
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = gridCol_get(gridCol_getPrototypeOf(GridCol.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      if (this._attached) {
        return;
      }
      this._attached = true;
      if (!this.needFlatten()) {
        this.store.observe(this.map, this.mapObserver);
        this.width = this.map.get('width');
        if (this.editor.mode === this.editor.constructor.MODE_EDIT) {
          this.resizeHandler();
        }
      }
    }
  }, {
    key: "detach",
    value: function detach() {
      this.domNode.removeEventListener('mousemove', this.onMouseMove);
      this.domNode.removeEventListener('mouseleave', this.onMouseLeave);
      this.scroll.domNode.style.cursor = this.editor.api.getCursorStyle('text');
      gridCol_get(gridCol_getPrototypeOf(GridCol.prototype), "detach", this).call(this);
    }
  }, {
    key: "blotDidUpdate",
    value: function blotDidUpdate(oldProps) {
      // если колонка меняет ширину или меняет
      // свою позицию в гриде(т.к. у центральных колонок больше паддинг и меньше места для контента),
      // то надо обновить sizeaware блоты
      if (oldProps.width !== this.props.width || oldProps.index !== this.props.index) {
        this.updateSizeAwareBlots();
      }
    }

    /**
     * Возвращает максимальную ширину колонки
     * @param containerWidth ширина контейнера (для того чтобы в случае экспорта в HTML/PDF передать константу)
     * @returns {number}
     */
  }, {
    key: "render",
    value: function render() {
      gridCol_get(gridCol_getPrototypeOf(GridCol.prototype), "render", this).call(this);
      if (!this.needFlatten()) {
        var style = ["--current-width: ".concat(this.props.width, "%;"), "--max-width: ".concat(this.getMaxWidth(), "px;")];
        // используется setAttribute так как запись кастомного свойства в style (style['--current-width'] на прямую не работает
        this.domNode.setAttribute('style', style.join(''));
        if (this.props.width <= 50) {
          this.domNode.classList.add('grid_50');
        } else {
          this.domNode.classList.remove('grid_50');
        }
      }
      if (this.gridColOnceRendered) {
        this.gridColOnceRendered();
        this.gridColOnceRendered = null;
      }
    }
  }, {
    key: "updateSizeAwareBlots",
    value: function updateSizeAwareBlots() {
      var child = this.children.head;
      var maxAvailableWidth = this.domNode.offsetWidth;
      var paddings = (0,dom/* getComputedStyles */.AH)(this.domNode, ['padding-left', 'padding-right'], 'px');
      paddings = paddings['padding-left'] + paddings['padding-right'];
      maxAvailableWidth -= paddings;
      while (child) {
        if (child.isSizeAware) {
          child.sizeAwareUpdateSize(maxAvailableWidth);
        }
        child = child.next;
      }
    }
  }, {
    key: "resizeHandler",
    value: function resizeHandler() {
      var _this2 = this;
      var self = this;
      var previous = false;
      var hasList = function hasList(grid) {
        var list = false;
        grid.children.map(function (child) {
          if (child instanceof list_list) {
            list = true;
          }
        });
        return list;
      };
      var resize = function resize(event) {
        //Сложные расчеты для вычисления ширины гридов,
        //в дальнейшем требует оптимизации и скорее всего смены логики ресайза
        if (_this2.resize == true) {
          var el = previous ? _this2.prev : _this2;
          var rect = el.domNode.getBoundingClientRect();
          var nextRect = el.next.domNode.getBoundingClientRect();
          var parentRect = el.parent.domNode.getBoundingClientRect();
          var x = event.clientX;
          var elWidth = rect.width * 100 / parentRect.width;
          var nextWidth = nextRect.width * 100 / parentRect.width;
          var padding = el.prev !== null ? GRID_PADDING * 100 / parentRect.width : false;
          var paddingNext = el.next.next !== null ? GRID_PADDING * 100 / parentRect.width : false;
          var minSize = MIN_COL_SIZE * 100 / parentRect.width;
          var listSize = LIST_MARGIN * 100 / parentRect.width;
          var zoneWidth = elWidth + nextWidth;
          el.domNode.style.flexGrow = 0;
          el.next.domNode.style.flexGrow = 0;
          var width,
            width2,
            minElSize = minSize,
            minElNextSize = minSize;
          if (padding) {
            minElSize += padding;
          }
          if (hasList(el)) {
            minElSize += listSize;
          }
          if (paddingNext) {
            minElNextSize += paddingNext;
          }
          if (hasList(el.next)) {
            minElNextSize += listSize;
          }
          width = 100 * (x - rect.x) / parentRect.width;
          if (zoneWidth - width < minElNextSize) {
            width = zoneWidth - minElNextSize;
          }
          if (width < minElSize) {
            width = minElSize;
          }
          width2 = zoneWidth - width;
          _this2.container.onColResizing(_this2, previous ? width2 : width);
        }
      };
      var stopResize = function stopResize(event) {
        document.removeEventListener('mousemove', resize);
        document.removeEventListener('mouseup', stopResize);
        self.resize = false;
        self.editor.emitter.emit('grid-resize-end', {});
        self.parent.domNode.classList.remove('resize-grid');
        var el = previous ? _this2.prev : _this2;
        var rect = el.domNode.getBoundingClientRect();
        var nextRect = el.next.domNode.getBoundingClientRect();
        var parentRect = el.parent.domNode.getBoundingClientRect();
        var x = event.clientX;
        var elWidth = rect.width * 100 / parentRect.width;
        var nextWidth = nextRect.width * 100 / parentRect.width;
        _this2.container.onColResized(_this2, previous ? nextWidth : elWidth);
        previous = false;
      };
      var startResize = function startResize(event) {
        var rowGrids = self.container.getCols();
        var rect = self.domNode.getBoundingClientRect();
        var x = event.clientX;
        var y = event.clientY;
        if (rect.y < y && rect.y + rect.height > y) {
          var resizeStarted = false;
          if (rect.x <= x + 1 && rect.x + GRID_COL_RESIZE_ZONE >= x && self != rowGrids[0]) {
            event.preventDefault();
            event.stopPropagation();
            self.resize = true;
            self.editor.emitter.emit('grid-resize-start', {});
            self.parent.domNode.classList.add('resize-grid');
            previous = true;
            document.addEventListener('mousemove', resize);
            document.addEventListener('mouseup', stopResize);
            resizeStarted = true;
          } else if (rect.x + rect.width - GRID_COL_RESIZE_ZONE <= x && rect.x + rect.width >= x && self != rowGrids[rowGrids.length - 1]) {
            event.preventDefault();
            event.stopPropagation();
            self.resize = true;
            self.editor.emitter.emit('grid-resize-start', {});
            self.parent.domNode.classList.add('resize-grid');
            previous = false;
            document.addEventListener('mousemove', resize);
            document.addEventListener('mouseup', stopResize);
            resizeStarted = true;
          }
          if (resizeStarted) {
            _this2.container.onColStartResize(_this2, previous);
          }
        }
      };
      this.domNode.addEventListener('mousemove', this.onMouseMove);
      this.domNode.addEventListener('mouseleave', this.onMouseLeave);
      this.domNode.addEventListener('mousedown', startResize);
    }
  }, {
    key: "removeChildById",
    value: function removeChildById() {
      var _this3 = this,
        _get3;
      // отлаживаем установку признака что дочерний блот был удален до окончания рендера
      // т.к. optimize может вызыватся при еще присутствующем дочернем блоте в DOM и тогда колонка никогда не удалится
      this.gridColOnceRendered = function () {
        _this3._childHasRemoved = true;
      };
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get3 = gridCol_get(gridCol_getPrototypeOf(GridCol.prototype), "removeChildById", this)).call.apply(_get3, [this].concat(args));
    }
  }, {
    key: "optimize",
    value: function optimize() {
      var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (this.children.length == 0) {
        // в колонке нет больше элементов
        // для избежания состояния гонки с другими клиентами выполняем оптимизацию грид колонки только на клиенте где удалился
        // последний элемент
        if (this._childHasRemoved) {
          console.log('removing gridCol');
          this.remove();
        }
      }
      this._childHasRemoved = false;
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      var style = ['flex-basis: 50%;', 'max-width: 50%;'];
      var grid50 = 'grid_50';
      if (this.props.width) {
        style = ["--current-width: ".concat(this.props.width, "%;"), "--max-width: ".concat(this.getMaxWidth(PAGE_WIDTH), "px;")];
        if (this.props.width > 50) {
          grid50 = '';
        }
      }
      return '<' + GridCol.tagName + ' data-type="grid" class="grid ' + grid50 + '" style="' + style.join('') + '" nedit-fix-column-selection="true">' + childrenToHTML(this, context, {
        allowRawHTML: true
      }) + '</' + GridCol.tagName + '>';
    }
  }, {
    key: "getMarkdown",
    value: function getMarkdown() {
      var markdown = '';
      this.children.forEach(function (blot) {
        if (blot.getMarkdown) {
          markdown += blot.getMarkdown();
        } else if (blot.getText) {
          markdown += blot.getText();
        }
      });
      return markdown;
    }
  }]);
  return GridCol;
}(container(clickParagraph(separableByClick(executable(basic(block))))));
GridCol.blotName = 'gridCol';
GridCol.tagName = 'DIV';
GridCol.defaultChild = null;
// GridCol.initMap = (map, store, params = {}) => {
//   const subDoc = store.createSubDocument()
//   map.set('subDoc', subDoc.guid)

//   ContainerMixin.initMap(map, store)
//   map.set('type', 'gridCol')
//   map.set('width', 'auto')

//   const subStore = store.getSubStore(subDoc)

//   if (Array.isArray(params.items)) {
//     for (let item of params.items) {
//       let type = item.type
//       if (type === 'textLine') {
//         type = item.textLineType || 'paragraph'
//       }
//       const itemMap = subStore.createMap()
//       const itemParams = Object.assign({ type }, item.initParams ? item.initParams : item)
//       Parchment.query(type).initMap(itemMap, subStore, itemParams)
//       subDoc.getArray('children').push([itemMap.get('id')])
//     }
//   }
// }

GridCol.initMap = function (map, store) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  container.initMap(map, store);
  map.set('type', 'gridCol');
  map.set('width', 'auto');
  if (Array.isArray(params.items)) {
    var _iterator = gridCol_createForOfIteratorHelper(params.items),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        var type = item.type;
        if (type === 'textLine') {
          type = item.textLineType || 'paragraph';
        }
        var itemMap = store.createMap();
        var itemParams = Object.assign({
          type: type
        }, item.initParams ? item.initParams : item);
        parchment_default().query(type).initMap(itemMap, store, itemParams);
        map.get('children').push([itemMap.get('id')]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
};
GridCol.allowedChildren = [paragraphAbstract, ImageWrapper, FileWrapper, RemoteFrameWrapper, RemoteFileWrapper, SyntaxWrapper, tableWrapper, list_list, hLine, businessCard, bookmark, Outline, html, ButtonSingle, toggleWrapper, TasksList, primary, Board, uploaderWrapper, StepAggregator];
/* harmony default export */ const blots_gridCol = (GridCol);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/scss/grid.scss
var grid = __webpack_require__(32806);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/grid.js
function grid_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { grid_typeof = function _typeof(obj) { return typeof obj; }; } else { grid_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return grid_typeof(obj); }
function grid_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = grid_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function grid_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return grid_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return grid_arrayLikeToArray(o, minLen); }
function grid_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


















function grid_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function grid_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function grid_createClass(Constructor, protoProps, staticProps) { if (protoProps) grid_defineProperties(Constructor.prototype, protoProps); if (staticProps) grid_defineProperties(Constructor, staticProps); return Constructor; }
function grid_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { grid_get = Reflect.get; } else { grid_get = function _get(target, property, receiver) { var base = grid_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return grid_get(target, property, receiver || target); }
function grid_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = grid_getPrototypeOf(object); if (object === null) break; } return object; }
function grid_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) grid_setPrototypeOf(subClass, superClass); }
function grid_setPrototypeOf(o, p) { grid_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return grid_setPrototypeOf(o, p); }
function grid_createSuper(Derived) { var hasNativeReflectConstruct = grid_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = grid_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = grid_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return grid_possibleConstructorReturn(this, result); }; }
function grid_possibleConstructorReturn(self, call) { if (call && (grid_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return grid_assertThisInitialized(self); }
function grid_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function grid_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function grid_getPrototypeOf(o) { grid_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return grid_getPrototypeOf(o); }
function grid_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var READY_MUTEX_KEY = '_rdmx';
var GRID_WRAPPER_CLASS = 'grid-wrapper';

// эту функцию пока вынес отдельно
function calcAutoColsWidth(pxFullWidth, remainPercent, cntAutoCols, cntSideAutoCols) {
  // % занимаемый паддингом от общей ширины
  var paddingWidth = grid.gridColSidePadding / pxFullWidth * 100;
  // количество пикселей для размещения коронок имеющих автоширину
  var pxRemainWidth = pxFullWidth * remainPercent / 100;
  // количество пикселей области редактирования всех колонок с автошириной
  var pxAvialableWidth = pxRemainWidth - grid.gridColSidePadding * 2 * cntAutoCols + grid.gridColSidePadding * cntSideAutoCols;
  // % области редактирования занимаемый одной колонкой с автошириной
  var averageWidth = pxAvialableWidth / pxFullWidth * 100 / cntAutoCols;
  return {
    sideAutoColsWidth: averageWidth + paddingWidth,
    // автоширина для боковой колонки
    autoColsWidth: averageWidth + paddingWidth * 2 // автоширина колонки
  };
}
var Grid = /*#__PURE__*/function (_ContainerMixin) {
  grid_inherits(Grid, _ContainerMixin);
  var _super = grid_createSuper(Grid);
  function Grid(domNode) {
    var _this;
    grid_classCallCheck(this, Grid);
    _this = _super.call(this, domNode);
    grid_defineProperty(grid_assertThisInitialized(_this), "mapObserver", function () {
      _this.render();
    });
    grid_defineProperty(grid_assertThisInitialized(_this), "onFocus", function () {
      _this.domNode.classList.add('focused-grid');
    });
    grid_defineProperty(grid_assertThisInitialized(_this), "onBlur", function () {
      _this.domNode.classList.remove('focused-grid');
    });
    grid_defineProperty(grid_assertThisInitialized(_this), "onMouseLeave", function (event) {
      if (_this.domNode.classList.contains('bordered-grid')) {
        _this.domNode.classList.remove('bordered-grid');
      }
    });
    _this.scroll;
    _this.domNode.classList.add(GRID_WRAPPER_CLASS);
    return _this;
  }
  grid_createClass(Grid, [{
    key: "getColMaxAutoWidth",
    value: function getColMaxAutoWidth() {
      return 100 / this.children.length;
    }
  }, {
    key: "getGridColWidth",
    value: function getGridColWidth(gridCol) {
      return this.map.get('widths').get(gridCol.id);
    }
  }, {
    key: "setGridColWidth",
    value: function setGridColWidth(gridCol, width) {
      return this.map.get('widths').set(gridCol.id, width);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      grid_get(grid_getPrototypeOf(Grid.prototype), "render", this).call(this);
      var resizeWidths = this.props.resizeWidths;
      var sizes = resizeWidths || [];
      var remainSpace = 100;
      var cntAutoCols = 0; // кол-во всех (включая боковые) колонок с автошириной
      var cntSideAutoCols = 2; // кол-во боковых колонок с автошириной
      llForEach(this.children, function (col, i) {
        var width = sizes[i] || _this2.getGridColWidth(col);
        if (width && width !== 'auto') {
          sizes[i] = width;
          remainSpace -= width;
          // если боковая колонка имеет ширину заданную пользователем, исключаем ее из пула боковых колонок с автошириной
          if (i === 0 || i === _this2.children.length - 1) {
            cntSideAutoCols--;
          }
        } else {
          cntAutoCols++;
        }
      });
      // если есть колонки с автошириной, нужно посчитать ширину для каждой колонки исходя из свободного пространства
      if (cntAutoCols) {
        // получаем ширину боковой и внутренней колонки
        var _calcAutoColsWidth = calcAutoColsWidth(this.domNode.getBoundingClientRect().width, remainSpace, cntAutoCols, cntSideAutoCols),
          sideAutoColsWidth = _calcAutoColsWidth.sideAutoColsWidth,
          autoColsWidth = _calcAutoColsWidth.autoColsWidth;
        llForEach(this.children, function (col, i) {
          if (!sizes[i]) {
            if (i === 0 || i === _this2.children.length - 1) {
              sizes[i] = sideAutoColsWidth; // запоминаем ширину для боковой колонки
            } else {
              sizes[i] = autoColsWidth; // запоминаем ширину для внутренней колонки
            }
          }
        });
        // считаем оставшееся место после применения автоширины
        remainSpace -= sideAutoColsWidth * cntSideAutoCols + autoColsWidth * (cntAutoCols - cntSideAutoCols);
        // если ширина боковой колонки или ширина внутренней колонки меньше 0.5% сбрасываем ширину всех колонок
        if (sideAutoColsWidth < 0.5 || autoColsWidth < 0.5) {
          return this.resetColsWidths();
        }
      }
      // применяем ширину для колонок
      llForEach(this.children, function (col, i) {
        col.setProps({
          width: sizes[i],
          index: i
        });
        col = col.next;
      });
      // если оставшееся место больше или равно 1%, нужно его распределить между колонками, которые отресайзил пользователь
      if (Math.abs(remainSpace) >= 1) {
        this.fixColsWidth(remainSpace);
      }
    }
  }, {
    key: "fixColsWidth",
    value: function fixColsWidth(remainSpace) {
      var _this3 = this;
      console.info('run fixing grid cols widths');
      // ситуация когда остающийся размер отрицательный или положительный и надо равномерно
      // уменьшить или увеличить размер колонок у которых стоит неавтоматическая ширина
      var cntColsWithWidth = 0;
      llForEach(this.children, function (col, i) {
        var width = _this3.getGridColWidth(col);
        if (width) {
          cntColsWithWidth++;
        }
      });
      if (!cntColsWithWidth) {
        return console.warn('Grid.fixColsWidth was called, but there were no cols with width to fix');
      }
      var fixDelta = remainSpace / cntColsWithWidth;
      this.store.transaction(function () {
        llForEach(_this3.children, function (col, i) {
          var width = _this3.getGridColWidth(col);
          if (width) {
            _this3.setGridColWidth(col, width + fixDelta);
          }
        });
      });
    }
  }, {
    key: "resetColsWidths",
    value: function resetColsWidths() {
      var _this4 = this;
      this.store.transaction(function () {
        llForEach(_this4.children, function (col) {
          var width = _this4.getGridColWidth(col);
          if (width) {
            _this4.setGridColWidth(col, null);
          }
        });
      });
    }
  }, {
    key: "onColStartResize",
    value: function onColStartResize(gridCol, relPrevious) {
      var origWidth = gridCol.props.width;
      var relBlot = relPrevious ? gridCol.prev : gridCol.next;
      if (!relBlot) {
        return;
      }
      var origRelWidth = relBlot.props.width;
      var index = 0;
      this.setProps({
        resize: {
          gridCol: gridCol,
          origWidth: origWidth,
          origRelWidth: origRelWidth,
          relPrevious: relPrevious,
          index: getChildIndex(this, gridCol),
          relIndex: getChildIndex(this, relBlot)
        }
      });
    }
  }, {
    key: "onColResizing",
    value: function onColResizing(gridCol, width) {
      var _this$props$resize = this.props.resize,
        index = _this$props$resize.index,
        relIndex = _this$props$resize.relIndex,
        origWidth = _this$props$resize.origWidth,
        origRelWidth = _this$props$resize.origRelWidth;
      var resizeWidths = [];
      resizeWidths[index] = width;
      resizeWidths[relIndex] = origWidth - width + origRelWidth;
      this.setProps({
        resizeWidths: resizeWidths
      });
    }
  }, {
    key: "onColResized",
    value: function onColResized(gridCol, width) {
      var _this5 = this;
      var _this$props$resize2 = this.props.resize,
        relPrevious = _this$props$resize2.relPrevious,
        origWidth = _this$props$resize2.origWidth,
        origRelWidth = _this$props$resize2.origRelWidth;
      var relWidth = origWidth - width + origRelWidth;
      var relBlot = relPrevious ? gridCol.prev : gridCol.next;
      this.store.transaction(function () {
        _this5.setGridColWidth(gridCol, width);
        _this5.setGridColWidth(relBlot, relWidth);
      });
      this.setProps({
        resize: null,
        resizeWidths: null
      });
    }
  }, {
    key: "attach",
    value: function attach() {
      grid_get(grid_getPrototypeOf(Grid.prototype), "attach", this).call(this);
      if (this._gridInitialized) {
        return;
      }
      this._gridInitialized = true;
      if (!this.blotConfig.flatten) {
        this.store.observeDeep(this.map, this.mapObserver);
        if (this.editor.mode === this.editor.constructor.MODE_EDIT) {
          this.handleDragging();
          this.domNode.addEventListener('mouseleave', this.onMouseLeave);
          this.domNode.addEventListener('focusable-focus', this.onFocus);
          this.domNode.addEventListener('focusable-blur', this.onBlur);
        }
      } else {
        this.domNode.classList.add('flat-grid');
        // extra run for flat grid because we just made it flat and its cols size has changed
        this.updateSizeAwareBlots();
      }
    }
  }, {
    key: "updateSizeAwareBlots",
    value: function updateSizeAwareBlots(cols) {
      if (!cols) {
        cols = this.getCols();
      }
      var _iterator = grid_createForOfIteratorHelper(cols),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var col = _step.value;
          col.updateSizeAwareBlots();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "toSelect",
    value: function toSelect() {
      this.children.head.toSelect();
    }
  }, {
    key: "handleDragging",
    value: function handleDragging() {
      var _this6 = this;
      var removeDraggingStyles = function removeDraggingStyles(exclude) {
        var hoverBlocks = [].slice.call(_this6.scroll.domNode.querySelectorAll('.hover-block'));
        hoverBlocks.map(function (block) {
          if (block != exclude.domNode) {
            block.classList.remove('hover-block');
          }
          block.classList.remove('hover-top');
          block.classList.remove('hover-bottom');
          block.classList.remove('hover-left');
          block.classList.remove('hover-right');
        });
      };
      var startEvent = function startEvent(event) {
        var zone = 10;
        var rect = _this6.domNode.getBoundingClientRect();
        if (rect.y <= event.y && rect.y + zone > event.y && rect.x < event.x && rect.x + rect.width > event.x) {
          removeDraggingStyles(_this6);
          if (!_this6.domNode.classList.contains('hover-block')) {
            _this6.domNode.classList.add('hover-block');
          }
          if (!_this6.domNode.classList.contains('hover-top')) {
            _this6.domNode.classList.add('hover-top');
          }
        }
        if (rect.y + rect.height - zone < event.y && rect.y + rect.height > event.y && rect.x < event.x && rect.x + rect.width > event.x) {
          removeDraggingStyles(_this6);
          if (!_this6.domNode.classList.contains('hover-block')) {
            _this6.domNode.classList.add('hover-block');
          }
          if (!_this6.domNode.classList.contains('hover-bottom')) {
            _this6.domNode.classList.add('hover-bottom');
          }
        }
        if (_this6.parent.children.tail == _this6 && rect.y + rect.height < event.y) {
          removeDraggingStyles(_this6);
          if (!_this6.domNode.classList.contains('hover-block')) {
            _this6.domNode.classList.add('hover-block');
          }
          if (!_this6.domNode.classList.contains('hover-bottom')) {
            _this6.domNode.classList.add('hover-bottom');
          }
        }
      };
      this.scroll.emitter.on('dragging', startEvent.bind(this));
    }
  }, {
    key: "getCols",
    value: function getCols() {
      var grids = [];
      this.children.map(function (grid) {
        grids.push(grid);
      });
      return grids;
    }
  }, {
    key: "indexOf",
    value: function indexOf(target) {
      return [].slice.call(this.domNode.childNodes).indexOf(target.domNode);
    }
  }, {
    key: "removeChildById",
    value: function removeChildById() {
      var _get2;
      this._childHasRemoved = true;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = grid_get(grid_getPrototypeOf(Grid.prototype), "removeChildById", this)).call.apply(_get2, [this].concat(args));
    }
  }, {
    key: "optimize",
    value: function optimize(context) {
      var _this7 = this;
      grid_get(grid_getPrototypeOf(Grid.prototype), "optimize", this).call(this, context);
      // если остается одна колонка в гриде, то надо перенести все элементы из грида в его родительский контейнер
      // на место грида
      // для избежания состояния гонки с другими клиентами выполняем оптимизацию грида только на клиенте где удалился
      // последний элемент
      if (this.children.length === 1 && this._childHasRemoved) {
        this._childHasRemoved = false;
        this.store.transaction(function () {
          var index = _this7.index;
          var child = _this7.children.head.children.head;
          var newContainer = _this7.container;
          console.log('moving gridCol content to scroll');
          while (child) {
            newContainer.moveChild(child.id, index);
            index++;
            child = child.next;
          }
        });
      }
      this._childHasRemoved = false;
    }
  }, {
    key: "detach",
    value: function detach() {
      grid_get(grid_getPrototypeOf(Grid.prototype), "detach", this).call(this);
      this.map.unobserveDeep(this.mapObserver);
      this.domNode.removeEventListener('mouseleave', this.onMouseLeave);
      this.domNode.removeEventListener('focusable-focus', this.onFocus);
      this.domNode.removeEventListener('focusable-blur', this.onBlur);
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      var html = [];
      this.children.forEach(function (blot) {
        if (blot.toHTML) {
          html.push(blot.toHTML(context));
        }
      });
      return '<' + Grid.tagName + ' class="' + GRID_WRAPPER_CLASS + '">' + html.join('') + '</' + Grid.tagName + '>';
    }
  }, {
    key: "getMarkdown",
    value: function getMarkdown() {
      var markdown = '';
      this.children.forEach(function (blot) {
        markdown += blot.getMarkdown();
      });
      return markdown;
    }
  }]);
  return Grid;
}(container(basic(container_Container)));
Grid.allowedChildren = [blots_gridCol];
Grid.blotName = 'grid';
Grid.tagName = 'SECTION';
Grid.scope = (parchment_default()).Scope.BLOCK_BLOT;
Grid.initMap = function (map, store) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  container.initMap(map, store);
  map.set('type', 'grid');
  map.set('widths', new store.types.Map());
  if (Array.isArray(params.items)) {
    var _iterator2 = grid_createForOfIteratorHelper(params.items),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var item = _step2.value;
        if (item.type === 'gridCol') {
          var colMap = store.createMap();
          blots_gridCol.initMap(colMap, store, item);
          map.get('children').push([colMap.get('id')]);
        } else {
          continue; // не обрабатываем операцию, если тип не gridCol
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  } else {
    // initially create two gridCols
    for (var i = 0; i != 2; i++) {
      var _colMap = store.createMap();
      blots_gridCol.initMap(_colMap, store, params);
      map.get('children').push([_colMap.get('id')]);
    }
  }
};
/* harmony default export */ const blots_grid = (Grid);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/paragraphV2.js
function paragraphV2_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { paragraphV2_typeof = function _typeof(obj) { return typeof obj; }; } else { paragraphV2_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return paragraphV2_typeof(obj); }
function paragraphV2_extends() { paragraphV2_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return paragraphV2_extends.apply(this, arguments); }
function paragraphV2_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = paragraphV2_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function paragraphV2_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return paragraphV2_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return paragraphV2_arrayLikeToArray(o, minLen); }
function paragraphV2_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

















function paragraphV2_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function paragraphV2_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function paragraphV2_createClass(Constructor, protoProps, staticProps) { if (protoProps) paragraphV2_defineProperties(Constructor.prototype, protoProps); if (staticProps) paragraphV2_defineProperties(Constructor, staticProps); return Constructor; }
function paragraphV2_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { paragraphV2_get = Reflect.get; } else { paragraphV2_get = function _get(target, property, receiver) { var base = paragraphV2_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return paragraphV2_get(target, property, receiver || target); }
function paragraphV2_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = paragraphV2_getPrototypeOf(object); if (object === null) break; } return object; }
function paragraphV2_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) paragraphV2_setPrototypeOf(subClass, superClass); }
function paragraphV2_setPrototypeOf(o, p) { paragraphV2_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return paragraphV2_setPrototypeOf(o, p); }
function paragraphV2_createSuper(Derived) { var hasNativeReflectConstruct = paragraphV2_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = paragraphV2_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = paragraphV2_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return paragraphV2_possibleConstructorReturn(this, result); }; }
function paragraphV2_possibleConstructorReturn(self, call) { if (call && (paragraphV2_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return paragraphV2_assertThisInitialized(self); }
function paragraphV2_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function paragraphV2_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function paragraphV2_getPrototypeOf(o) { paragraphV2_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return paragraphV2_getPrototypeOf(o); }











var paragraphV2_mixin = mix([alignable, indentable, executable, focusable, selectable, basic]);
var ParagraphV2 = /*#__PURE__*/function (_mixin) {
  paragraphV2_inherits(ParagraphV2, _mixin);
  var _super = paragraphV2_createSuper(ParagraphV2);
  function ParagraphV2(domNode) {
    var _this;
    paragraphV2_classCallCheck(this, ParagraphV2);
    _this = _super.call(this, domNode);
    _this.domNode.classList.add('text-blot');
    _this.addCanExecActions(['format', 'clear-formatting', 'delete']);
    return _this;
  }
  paragraphV2_createClass(ParagraphV2, [{
    key: "addNextBlot",
    value: function addNextBlot() {
      var initParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.statics.blotName;
      var indent = this.map.get('indent');
      var params = Object.assign(initParams, {
        indent: initParams.hasOwnProperty('indent') ? initParams.indent : indent,
        after: this.id
      });
      return this.parent.addBlot(type, params);
    }
  }, {
    key: "contextMenu",
    get: function get() {
      var menu = paragraphV2_get(paragraphV2_getPrototypeOf(ParagraphV2.prototype), "contextMenu", this);
      Object.assign(menu, {
        indent: true
      });
      return menu;
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      var processed = false;
      var children = this.getChildrenForAction();
      var _iterator = paragraphV2_createForOfIteratorHelper(children),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var blot = _step.value;
          // если хотя бы один блот из дочерних вернул true, считаем action выполненным
          if (blot.handleKeyDown && blot.handleKeyDown(event)) {
            processed = true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return processed;
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var props = {
        align: this.align
      };
      // тут сразу возвращаем jsx, абстракт Primary его обработает для рендера в preact сам
      return (0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)("div", {
        className: "uneditable-container",
        contenteditable: "false"
      }, "\uD83D\uDE42"), (0,preact_module.h)(NimbusText, paragraphV2_extends({
        parent: this,
        characters: this.map.get('characters')
      }, props)));
    }
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var params = (_get2 = paragraphV2_get(paragraphV2_getPrototypeOf(ParagraphV2.prototype), "getBlotInsertParams", this)).call.apply(_get2, [this].concat(args));
      var result = Object.assign(params, {
        textLineType: this.constructor.blotName
      });
      return result;
    }
  }]);
  return ParagraphV2;
}(paragraphV2_mixin(primary));
ParagraphV2.blotName = 'paragraph-v2';
ParagraphV2.tagName = 'DIV';
ParagraphV2.initMap = function (map, store) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  map.set('type', ParagraphV2.blotName);
  newTextLine.initMap(map, store, params);
  alignable.initMap(map, store, params);
  indentable.initMap(map, store, params);
};
ParagraphV2.allowedChildren = [newTextLine];
// этот флаг указывает на то, что блот выступает только в качестве текстового,
// все элементы, не являющиеся текстовыми блотами внутри данного блота, являются юзеринтерфейсами
ParagraphV2.isTextBlot = true;
/* harmony default export */ const paragraphV2 = (ParagraphV2);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/scroll.js
function scroll_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { scroll_typeof = function _typeof(obj) { return typeof obj; }; } else { scroll_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return scroll_typeof(obj); }
function scroll_slicedToArray(arr, i) { return scroll_arrayWithHoles(arr) || scroll_iterableToArrayLimit(arr, i) || scroll_unsupportedIterableToArray(arr, i) || scroll_nonIterableRest(); }
function scroll_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function scroll_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function scroll_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function scroll_toConsumableArray(arr) { return scroll_arrayWithoutHoles(arr) || scroll_iterableToArray(arr) || scroll_unsupportedIterableToArray(arr) || scroll_nonIterableSpread(); }
function scroll_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function scroll_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function scroll_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return scroll_arrayLikeToArray(arr); }





























function scroll_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = scroll_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function scroll_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return scroll_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return scroll_arrayLikeToArray(o, minLen); }
function scroll_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function scroll_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function scroll_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function scroll_createClass(Constructor, protoProps, staticProps) { if (protoProps) scroll_defineProperties(Constructor.prototype, protoProps); if (staticProps) scroll_defineProperties(Constructor, staticProps); return Constructor; }
function scroll_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { scroll_get = Reflect.get; } else { scroll_get = function _get(target, property, receiver) { var base = scroll_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return scroll_get(target, property, receiver || target); }
function scroll_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = scroll_getPrototypeOf(object); if (object === null) break; } return object; }
function scroll_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) scroll_setPrototypeOf(subClass, superClass); }
function scroll_setPrototypeOf(o, p) { scroll_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return scroll_setPrototypeOf(o, p); }
function scroll_createSuper(Derived) { var hasNativeReflectConstruct = scroll_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = scroll_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = scroll_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return scroll_possibleConstructorReturn(this, result); }; }
function scroll_possibleConstructorReturn(self, call) { if (call && (scroll_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return scroll_assertThisInitialized(self); }
function scroll_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function scroll_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function scroll_getPrototypeOf(o) { scroll_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return scroll_getPrototypeOf(o); }
function scroll_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










































var scroll_IGNORE_SELECT_ATTR = 'data-editor-ignore-select';
function isLine(blot) {
  return blot instanceof block || blot instanceof blockEmbed;
}
var scroll_mixin = mix([container, clickParagraph, separableByClick, executable, props]);
var Scroll = /*#__PURE__*/function (_mixin) {
  scroll_inherits(Scroll, _mixin);
  var _super = scroll_createSuper(Scroll);
  function Scroll(domNode, options) {
    var _this;
    scroll_classCallCheck(this, Scroll);
    _this = _super.call(this, domNode, options);
    scroll_defineProperty(scroll_assertThisInitialized(_this), "onScrollKeydown", function (event) {
      if (!_this.handlingKeydown) {
        return;
      }
      if (document.body.contains && !document.body.contains(_this.domNode.parentNode)) {
        return console.warn('prevent the onScrollKeydown listener to execute on a detached editor');
      }
      var handled = false;
      if (event && event.target && (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA')) {
        // пользовательский ввод в форму, игнорируем
        return;
      }
      if (keyboard.process(event, _this.editor)) {
        handled = true;
      }
      if (!handled) {
        var _iterator = scroll_createForOfIteratorHelper(_this.selectedBlocks),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var blot = _step.value;
            if (blot.handleKeyDown && blot.handleKeyDown(event)) {
              handled = true;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      if (handled) {
        //тут предлагаю добавить в Keyboard объект {keyCode: keyName},
        //чтобы по названию клавиш обрабатывать нажатия в компонентах
        _this.emitter.emit('keydown-processed', {
          key: event.keyCode
        });
        return;
      }
    });
    scroll_defineProperty(scroll_assertThisInitialized(_this), "onScrollInput", function (event) {
      var _iterator2 = scroll_createForOfIteratorHelper(_this.selectedBlocks),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var blot = _step2.value;
          if (blot.handleInput) {
            blot.handleInput(event);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    });
    scroll_defineProperty(scroll_assertThisInitialized(_this), "onScrollMousedown", function (event) {
      if (_this.editor && _this.editor.options && _this.editor.options.focusMode && _this.editor.isEditable()) {
        var focusMode = _this.editor.scroll.domNode.querySelector('.focus-mode');
        if (!focusMode) {
          _this.editor.scroll.domNode.classList.add("focus-mode");
        }
      }
    });
    scroll_defineProperty(scroll_assertThisInitialized(_this), "onScrollDragStart", function (event) {
      event.preventDefault();
    });
    scroll_defineProperty(scroll_assertThisInitialized(_this), "onSelectionChange", function (range, oldRange, source, misc) {
      var nativeRange = _this.selection.getRange()[1];
      if (nativeRange) {
        var blots = _this.selection.getBlotsInRange(nativeRange, {
          filterLastBlotHalfSelection: !misc.isUserSelecting
        });
        blots = blots.map(function (blot) {
          if (blot.getWrappedBlot) {
            return blot.getWrappedBlot();
          }
          return blot;
        });
        _this.setSelectedBlots(blots);
        if (!_this.focused) {
          _this.focused = true;
          _this.editor.emit('focus');
        }

        //fix для курсора в конце ссылок
        if (range.length === 0 && (!oldRange || range.index !== oldRange.index)) {
          var blot = normalizeToStoredBlot(getBlotForNode(nativeRange.start.node));
          if (blot && blot instanceof textLine) {
            var blotRange = _this.selection.getRange({
              offsetBlot: blot
            })[0];
            if (blotRange.index === blot.length() - 1) {
              var formats = blot.getFormat(blotRange.index - 1, 1);
              if (formats.hasOwnProperty('link')) {
                _this.selection.format('link', false);
              }
            }
          }
        }
      } else {
        var selection = window.getSelection();
        var allowClearSelectedBlots = true;
        if (selection.anchorNode && selection.anchorNode === selection.focusNode) {
          try {
            var selectedNode = (0,dom/* getElementNode */.B8)(selection.anchorNode);
            if (selectedNode.closest && (selectedNode.closest('[' + scroll_IGNORE_SELECT_ATTR + '="1"]') || selectedNode.closest('.' + util/* SELF_CONTROLLED_CONTENT_CLASS */.W$))) {
              allowClearSelectedBlots = false;
            }
          } catch (err) {
            console.warn('got error while checking closest:', err);
            allowClearSelectedBlots = false;
          }
        }
        if (allowClearSelectedBlots) {
          _this.setSelectedBlots([]);
          if (_this.focused) {
            _this.focused = false;
            _this.editor.emit('blur');
          }
        }
      }
    });
    scroll_defineProperty(scroll_assertThisInitialized(_this), "mapObserver", function (event) {
      _this.render();
    });
    _this.selectedBlocks = [];
    _this.oldSelected = [];
    _this.focusedBlot = null;
    _this.store = options.store;
    // compatibility with basic mixin
    _this.rootStore = options.store;
    _this.parentStore = options.store;
    _this.map = options.map;
    _this.scrolledOld = 0;
    _this.findWord = _this.findWord.bind(scroll_assertThisInitialized(_this));
    _this.enterFunctionAddEnter = _this.enterFunctionAddEnter.bind(scroll_assertThisInitialized(_this));
    _this.enterFunction = _this.enterFunction.bind(scroll_assertThisInitialized(_this));
    _this.enterFunctionAdd = _this.enterFunctionAdd.bind(scroll_assertThisInitialized(_this));
    _this.focused = false;
    _this.editor = options.editor;
    _this.emitter = options.emitter;
    _this.selection = new Selection(scroll_assertThisInitialized(_this), _this.emitter);
    _this.id = domNode.id;
    _this.timerFocus = false;
    _this.startDragDrop = false;
    _this.token = false;
    _this.batch = false;
    _this.batchMutations = [];
    // для того чтобы вложенные батчи не отменяли вышестоящие вводится счетчик, и только если он становится равен 0
    // то батч отменяется
    _this.batchCnt = 0;
    _this.loaded = false;
    _this.handlingKeydown = true;
    _this.willBeFocused = null;
    // признак что скролл находится в состоянии игнорирования мутаций вызванных взаимодействием пользователя с редактором
    // т.е. изменения текста не применяются на внутреннюю модель документа
    _this.ignoringUpdates = false;
    _this.addCanExecActions([].concat(scroll_toConsumableArray(container.canExecActions), ['move-blot-one-step']));
    _this.setChildrenListener(_this.map);
    return _this;
  }
  scroll_createClass(Scroll, [{
    key: "blocks",
    get: function get() {
      console.warn('this.scroll.blocks is deprecated, use this.store.blocks instead');
      return this.store.blocks;
    }
  }, {
    key: "fontSize",
    get: function get() {
      return Array.from(this.domNode.classList).map(function (item) {
        if (item.indexOf('font-size-') !== -1) {
          return item.replace('font-size-', '');
        } else return '';
      }).join('');
    }
  }, {
    key: "containerChildren",
    get: function get() {
      return this.editor.store.rootChildren;
    }
  }, {
    key: "isEditable",
    get: function get() {
      return this.domNode.getAttribute('contenteditable') === 'true';
    }

    // тоже самое что вызов batchStart и batchEnd, только с обработкой ошибок между этими вызовами, чтобы убедится
    // что батч режим выключается
  }, {
    key: "execInBatch",
    value: function execInBatch(fn) {
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'user';
      this.batchStart();
      var err;
      try {
        fn();
      } catch (fnErr) {
        err = fnErr;
      }
      this.batchEnd(source);
      if (err) {
        throw err;
      }
    }
  }, {
    key: "batchStart",
    value: function batchStart() {
      //console.log('start batch', new Error().stack)
      if (this.batchCnt === 0) {
        this.batchMutations = [];
      }
      this.batchCnt++;
      this.batch = true;
    }
  }, {
    key: "batchEnd",
    value: function batchEnd() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'user';
      this.batchCnt--;
      if (this.batchCnt < 0) {
        this.batchCnt = 0;
      }
      if (this.batchCnt === 0) {
        this.batch = false;
        this.batchMutations = this.batchMutations.concat(this.observer.takeRecords());
        var mutations = this.batchMutations;
        this.batchMutations = [];
        this.update(mutations, null, source);
      }
    }
  }, {
    key: "ignoreUpdates",
    value: function ignoreUpdates() {
      this.ignoringUpdates = true;
    }
  }, {
    key: "resumeUpdates",
    value: function resumeUpdates() {
      // удостоверяемся что никакие мутации накопившиеся в обсервере не будут переданы в обсервер-функцию
      this.observer.takeRecords();
      this.ignoringUpdates = false;
    }
  }, {
    key: "unsetEditable",
    value: function unsetEditable() {
      if (!this.editor.isEditable()) {
        return console.warn('#unsetEditable works only in the edit mode');
      }
      this.domNode.setAttribute('contenteditable', false);
    }
  }, {
    key: "setEditable",
    value: function setEditable() {
      if (!this.editor.isEditable()) {
        return console.warn('#setEditable works only in the edit mode');
      }
      this.domNode.setAttribute('contenteditable', true);
    }
  }, {
    key: "stopHandlingKeydown",
    value: function stopHandlingKeydown() {
      this.handlingKeydown = false;
    }
  }, {
    key: "resumeHandlingKeydown",
    value: function resumeHandlingKeydown() {
      this.handlingKeydown = true;
    }
  }, {
    key: "init",
    value: function init() {
      var _this2 = this;
      console.time('initial content render');
      this.domNode.setAttribute('spellcheck', this.editor.options && this.editor.options.spellcheck === false ? false : true);
      if (this.editor.options.autocapitalize) {
        this.domNode.setAttribute('autocapitalize', 'on');
      }
      this.store.observe(this.store.root, this.mapObserver);
      //Обработчики клавиш
      if (this.editor.isEditable()) {
        document.addEventListener('keydown', this.onScrollKeydown, false);
        // слушаем событие input только для мобильной версии
        if (this.editor.options.keyboardMode === 'mobile') {
          document.addEventListener('input', this.onScrollInput, false);
        }
      }
      if (this.editor && this.editor.options && this.editor.options.focusMode && this.editor.isEditable()) {
        document.addEventListener('mousedown', this.onScrollMousedown, false);
      }
      this.domNode.addEventListener('dragstart', this.onScrollDragStart);
      this.emitter.on('BLOCK_ADDED', function (block) {
        _this2.update();
        _this2.selection.setNativeRange(block.children.head.domNode, 0);
      });
      this.emitter.on('start-dragging', function (event) {
        _this2.setProps({
          dragSession: true
        });
      });
      this.emitter.on('stop-dragging', function (event) {
        _this2.setProps({
          dragSession: false
        });
      });
      this.editor.emitter.on('set-focus-mode', function (event) {
        if (_this2.editor && _this2.editor.options && _this2.editor.isEditable()) {
          var range = _this2.editor.scroll.selection.getRange()[0];
          if (range) {
            _this2.setProps({
              focusMode: event.mode
            });
            if (event.mode) {
              _this2.editor.scroll.domNode.classList.add("focus-mode");
              document.addEventListener('mousedown', _this2.onScrollMousedown, false);
            } else {
              _this2.editor.scroll.domNode.classList.remove("focus-mode");
              document.removeEventListener('mousedown', _this2.onScrollMousedown, false);
            }
          }
        }
      });
      this.enable();
      this.editor.emitter.emit('scroll-init');
      console.timeEnd('initial content render');
    }
  }, {
    key: "enable",
    value: function enable() {
      if (this.containerChildren.length == 0) {
        this.addBlot('paragraph');
        this.loaded = true;
      } else {
        this.batchStart();
        this.render();
        this.batchEnd();
      }
      this.selection.emitter.on('selectionchange', this.onSelectionChange);
    }
  }, {
    key: "detach",
    value: function detach() {
      scroll_get(scroll_getPrototypeOf(Scroll.prototype), "detach", this).call(this);
      document.removeEventListener('keydown', this.onScrollKeydown, false);
      this.domNode.removeEventListener('dragstart', this.onScrollDragStart);
      if (this.editor && this.editor.options && this.editor.options.focusMode && this.editor.isEditable()) {
        document.removeEventListener('mousedown', this.onScrollMousedown, false);
      }
    }

    /**
     * Задает список выделенных на данный момент блотов, этим блотам будет задано свойство
     * selected = true. Также этот метод определяет какой блот имеет фокус на данный момент,
     * если выделено несколько блотов, то фокус имеет первый блот с isFocusable = true
     * @param {Array} blots - массив блотов которые будут выделены
     */
  }, {
    key: "setSelectedBlots",
    value: function setSelectedBlots(blots) {
      var currentSelectedBlots = this.selectedBlocks;
      this.oldSelected = this.selectedBlocks;
      this.selectedBlocks = [];
      var focusedBlot;
      if (blots.length) {
        focusedBlot = searchUp(blots[0], function (blot) {
          return blot.isSelectable;
        });
        this.willBeFocused = focusedBlot;
      }
      if (this.focusedBlot && this.focusedBlot !== focusedBlot && this.focusedBlot.setProps) {
        this.focusedBlot.setProps({
          focused: false
        });
      }
      var blotsSet = new Set();
      blots.forEach(function (blot) {
        blot = searchUp(blot, function (blot) {
          return blot.isSelectable;
        });
        if (!blot) {
          return;
        }
        blotsSet.add(blot);
      });
      blots = Array.from(blotsSet);
      this.selectedBlocks = blots.slice();
      // перенес фокус ниже, после того как сформируется массив выделенных блоков, так как фокус вызывает рендер блота,
      // какие то блоки в рендере используют scroll.selectedBlocks переменную, которая обнуляется в этой функции
      if (focusedBlot && focusedBlot.setProps) {
        focusedBlot.setProps({
          focused: true
        });
      }
      this.focusedBlot = focusedBlot;
      this.willBeFocused = null;
      var unselectedBlots;
      if (blots.length > 1) {
        unselectedBlots = scroll_toConsumableArray(currentSelectedBlots).filter(function (blot) {
          return !blotsSet.has(blot);
        });
        var _iterator3 = scroll_createForOfIteratorHelper(blots),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var blot = _step3.value;
            blot.setProps({
              selected: true
            });
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      } else {
        unselectedBlots = currentSelectedBlots;
      }
      var _iterator4 = scroll_createForOfIteratorHelper(unselectedBlots),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _blot = _step4.value;
          if (_blot.setProps) {
            _blot.setProps({
              selected: false
            });
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "getSelectedBlocks",
    value: function getSelectedBlocks() {
      return this.selectedBlocks;
    }
  }, {
    key: "findWord",
    value: function findWord(text, offset) {
      if (text[offset - 1] === ' ') {
        return new Promise(function (resolve, reject) {
          resolve(offset);
        });
      }
      var word = '';
      var check = false;
      var keyd;
      text = text.substr(0, offset);
      return new Promise(function (resolve, reject) {
        var textar = text.split("").reverse();
        var promisis = textar.map(function (item, key) {
          if (item === ' ' || item === ',' || item === '.' || item === ':' || item === ';' || item === '|' || item === '\\' || item === '/') {
            check = true;
          }
          if (!check) {
            keyd = key;
            word = word + item;
            keyd = text.length - word.length;
          }
          return new Promise(function (res, rej) {
            res(item);
          });
        });
        Promise.all(promisis).then(function (resp) {
          resolve(keyd);
        });
      });
    }
  }, {
    key: "handleTab",
    value: function handleTab(event, shift) {}
  }, {
    key: "enterFunctionAddEnter",
    value: function enterFunctionAddEnter(range, index, line, setCursor, cursor, content) {
      var _this3 = this;
      this.blocks.insert(index, [this.store.types.Map]);
      var block = this.blocks.get(index);
      this.emitter.emit('add-paragraph', {
        source: 'user',
        index: index,
        map: block,
        content: content,
        cursor: setCursor,
        parent: line.parent.id
      });
      this.updatePositions();
      clearTimeout(this.timerFocus);
      this.timerFocus = setTimeout(function () {
        var focused = document.querySelector('.focused-block');
        var rect = focused.getBoundingClientRect();
        var rectRoot = _this3.domNode.getBoundingClientRect();
        if (rect.top > rectRoot.top + rectRoot.height - 10) {
          focused.scrollIntoView(false);
        }
      }, 100);
    }
  }, {
    key: "enterFunctionAdd",
    value: function enterFunctionAdd(range, blot, index, line, setCursor, cursor, content) {
      this.selection.cursor.attach();
      line.children.forEachAt(cursor.start, line.length() - cursor.start, function (child) {
        content.push(child);
      });
      this.enterFunctionAddEnter(range, index, line, setCursor, cursor, content);
    }
  }, {
    key: "enterFunction",
    value: function enterFunction(range, blot, index, line, setCursor, cursor, content) {
      var _this4 = this;
      if (blot instanceof (parchment_default()).Leaf) {
        this.findWord(blot.text, range.start.offset).then(function (resp) {
          var after = blot.split(range.start.offset);
          //let after = blot.split(resp); if need word-wrap:false
          blot.parent.insertBefore(_this4.selection.cursor, after);
          _this4.enterFunctionAdd(range, blot, index, line, setCursor, cursor, content);
        });
      } else {
        blot.insertBefore(this.selection.cursor, range.start.node); // Should never happen
        this.enterFunctionAdd(range, blot, index, line, setCursor, cursor, content);
      }
    }
  }, {
    key: "handleLinebreak",
    value: function handleLinebreak() {
      var _this5 = this;
      var range = this.selection.getNativeRange();
      if (range.start.node != range.end.node) return;
      if (range.start.offset != range.end.offset) return;
      var line = this.getBlock(parchment_default().find(range.start.node));
      if (line.parent.constructor.blotName == 'tableCell') return;
      var blot = parchment_default().find(range.start.node, false);
      if (blot == null) return;
      if (blot instanceof (parchment_default()).Leaf) {
        var after = blot.split(range.start.offset);
        blot.parent.insertBefore(this.selection.cursor, after);
      } else {
        blot.insertBefore(this.selection.cursor, range.start.node);
      }
      this.selection.cursor.attach();
      var formats = this.selection.cursor.getFormat();
      new Promise(function (resolve, reject) {
        Object.keys(formats).map(function (format) {
          _this5.selection.cursor.format(format, false);
        });
        resolve(_this5.selection.cursor);
      }).then(function (cursor) {
        if (cursor.next == null) {
          var br = parchment_default().create('linebreak');
          line.appendChild(br);
          br = parchment_default().create('linebreak');
          line.appendChild(br);
          _this5.update('user');
          _this5.selection.setNativeRange(br.domNode, 0);
        } else {
          var _br = parchment_default().create('linebreak');
          line.insertBefore(_br, cursor.next);
          _this5.update('user');
          _this5.selection.setNativeRange(_br.next.domNode, 0);
        }
      });
    }
  }, {
    key: "setContents",
    value: function setContents() {
      var content = [];
      var grids = {};
      for (var i = 0; i < this.blocks.length; i++) {
        var block = this.blocks.get(i);
        if (block.get('parent_id') == this.id) {
          content.push(block);
        } else {
          var parent_id = block.get('parent_id');
          if (typeof grids[parent_id] == 'undefined') {
            grids[parent_id] = [];
          }
          grids[parent_id].push(block);
        }
      }

      //sort first level scroll content
      content.sort(function (a, b) {
        var indexA = a.get('index');
        var indexB = b.get('index');
        return indexA - indexB;
      });

      //sort grids coontent
      Object.keys(grids).map(function (key) {
        grids[key].sort(function (a, b) {
          var indexA = a.get('index');
          var indexB = b.get('index');
          return indexA - indexB;
        });
      });
      for (var _i = 0; _i < content.length; _i++) {
        var _block = content[_i];
        var type = _block.get('type');
        var blot = void 0;
        if (type == 'paragraph') {
          blot = parchment_default().create('block');
        } else if (type == 'table') {
          blot = parchment_default().create('table');
        } else if (type == 'image') {
          blot = parchment_default().create('image', _block.get('src'));
        } else if (type == 'grid') {
          blot = parchment_default().create('grid');
        } else if (type == 'list') {
          blot = parchment_default().create('list', _block.get('listType'));
        }
        blot.index = _block.get('index');
        blot.parent_id = this.id;
        blot.map = _block;
        blot.editor = this.editor;
        blot.scroll = this;
        blot.enable();
        if (type == 'grid') {
          blot.setContents(grids[_block.get('id')]);
        }
      }
      this.loaded = true;
      this.updatePositions();
      this.update('user');
    }
  }, {
    key: "getSelection",
    value: function getSelection() {
      this.update();
      return this.selection.getRange()[0];
    }
  }, {
    key: "setSelection",
    value: function setSelection(index, length, source) {
      if (index == null) {
        this.selection.setRange(null, length || 'api');
      } else {
        var range = new selection_Range(index, length);
        this.selection.setRange(range, source);
        if (source !== 'silent') {
          //        this.selection.scrollIntoView(this.domNode);
        }
      }
    }
  }, {
    key: "path",
    value: function path(index) {
      return scroll_get(scroll_getPrototypeOf(Scroll.prototype), "path", this).call(this, index).slice(1); // Exclude self
    }
  }, {
    key: "leaf",
    value: function leaf(index) {
      return this.path(index).pop() || [null, -1];
    }
  }, {
    key: "line",
    value: function line(index) {
      if (index === this.length()) {
        return this.line(index - 1);
      }
      return this.descendant(isLine, index);
    }
  }, {
    key: "lines",
    value: function lines() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
      var getLines = function getLines(blot, index, length) {
        var lines = [],
          lengthLeft = length;
        blot.children.forEachAt(index, length, function (child, index, length) {
          if (isLine(child)) {
            lines.push(child);
          } else if (child instanceof (parchment_default()).Container) {
            lines = lines.concat(getLines(child, index, lengthLeft));
          }
          lengthLeft -= length;
        });
        return lines;
      };
      return getLines(this, index, length);
    }
  }, {
    key: "formatTextBlots",
    value: function formatTextBlots(blotParams, formats) {
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'user';
      if (!Array.isArray(blotParams)) {
        blotParams = [blotParams];
      }
      if (!Array.isArray(formats)) {
        formats = [formats];
      }
      var _iterator5 = scroll_createForOfIteratorHelper(blotParams),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _step5$value = _step5.value,
            blot = _step5$value.blot,
            range = _step5$value.range;
          var _iterator6 = scroll_createForOfIteratorHelper(formats),
            _step6;
          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var _step6$value = _step6.value,
                format = _step6$value.format,
                value = _step6$value.value;
              blot.formatText(range.index, range.length, format, value, source);
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      this.optimize();
    }
  }, {
    key: "getByIndex",
    value: function getByIndex(index) {
      var childs = [].slice.call(this.domNode.childNodes);
      if (childs.length < index + 1) return false;
      var blot = parchment_default().find(childs[index]);
      return blot;
    }
  }, {
    key: "indexOf",
    value: function indexOf(target) {
      return [].slice.call(this.domNode.childNodes).indexOf(target.domNode);
    }
  }, {
    key: "getBlock",
    value: function getBlock() {
      var blot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (blot == null) {
        return null;
      }
      if (blot instanceof paragraph) return blot;
      return this.getBlock(blot.parent);
    }
  }, {
    key: "getContainerBlot",
    value: function getContainerBlot(blot) {
      if (!blot) {
        return null;
      }
      if (blot.isContainer) {
        return blot;
      }
      return this.getContainerBlot(blot.parent);
    }
  }, {
    key: "updatePositions",
    value: function updatePositions() {
      if (this.loaded == true) {
        this.children.forEach(function (block) {
          block.domNode.classList.remove('first-block');
          block.domNode.classList.remove('last-block');
        });
        if (this.children.head != null) {
          this.children.head.domNode.classList.add('first-block');
        }
        if (this.children.tail != null) {
          this.children.tail.domNode.classList.add('last-block');
        }
      }
    }
  }, {
    key: "addDefaultParagraph",
    value: function addDefaultParagraph() {
      if (this.scroll.children.length) {
        console.warn('Scroll#addDefaultParagraph was called on not an empty scroll');
        return;
      }
      var paragraphOpts = {};
      var range = this.selection.getNativeRange();
      if (range && range.native && range.native.startContainer === range.native.endContainer && range.native.startContainer === this.domNode) {
        paragraphOpts = {
          focus: {
            index: 0
          }
        };
      }
      console.info('all content was removed from the editor, add paragraph with opts', paragraphOpts);
      this.addBlot('paragraph', paragraphOpts);
    }
  }, {
    key: "optimize",
    value: function optimize() {
      var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      try {
        scroll_get(scroll_getPrototypeOf(Scroll.prototype), "optimize", this).call(this, mutations, context);
      } catch (err) {
        console.warn(err);
      }
      if (this.children.length === 0 && this.containerChildren.length === 0) {
        this.addDefaultParagraph();
      }
      if (mutations.length > 0) {
        this.emitter.emit('SCROLL_OPTIMIZE', mutations, context);
      }
    }
  }, {
    key: "remove",
    value: function remove(destroy) {
      if (destroy) {
        return scroll_get(scroll_getPrototypeOf(Scroll.prototype), "remove", this).call(this);
      }
      // скролл нельзя удалить(за исключением дестроя всего редактора), пробуем добавить дефолтный параграф, т.к. возможно
      // скролл пытается удалится из-за того что стал пустым
      this.addDefaultParagraph();
    }
  }, {
    key: "update",
    value: function update() {
      var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'user';
      if (this.editor.destroyed) {
        return;
      }
      if (this.editor.options.scrollUpdate === false) {
        return;
      }
      if (this.transaction == false) return;
      if (this.batch === true) {
        if (Array.isArray(mutations)) {
          this.batchMutations = this.batchMutations.concat(mutations);
        }
        return;
      }
      if (this.ignoringUpdates) {
        return;
      }
      var type = 'attributes';
      if (typeof mutations === 'string') {
        source = mutations;
      }
      if (!Array.isArray(mutations)) {
        mutations = this.observer.takeRecords();
      }
      if (typeof mutations !== 'string') {
        mutations.map(function (record) {
          if (record.type != 'attributes') type = record.type;
        });
      }
      if (typeof mutations != 'string' && mutations.length != 0 && type == 'attributes') return;
      if (mutations.length > 0 || source) {
        this.emitter.emit('SCROLL_BEFORE_UPDATE', source, mutations);
      }
      // filter mutations for self-controlled nodes
      mutations = mutations.filter(function (mutation) {
        if (!mutation.target) {
          return true;
        }
        var noTextTarget = mutation.target.nodeType === Node.TEXT_NODE ? mutation.target.parentNode : mutation.target;
        if (noTextTarget && noTextTarget.closest && noTextTarget.closest('.' + util/* SELF_CONTROLLED_CONTENT_CLASS */.W$)) {
          return false;
        }
        return true;
      });
      var mutationsForUpdate = mutations.concat([]); // pass copy
      scroll_get(scroll_getPrototypeOf(Scroll.prototype), "update", this).call(this, mutationsForUpdate, {
        mutations: mutationsForUpdate,
        source: source
      });
      if (mutations.length > 0 || source) {
        var updatedBlots = new Set();
        var storedBlotsCache = new Map();
        var _iterator7 = scroll_createForOfIteratorHelper(mutations),
          _step7;
        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var mutation = _step7.value;
            if (!mutation.target) {
              continue;
            }
            var blot = storedBlotsCache.get(mutation.target);
            if (!blot) {
              blot = getBlotForNode(mutation.target);
              if (blot) {
                blot = normalizeToStoredBlot(blot);
              }
            }
            if (!blot) {
              continue;
            }
            updatedBlots.add(blot);
            storedBlotsCache.set(mutation.target, blot);
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
        this.emitter.emit('SCROLL_UPDATE', source, mutations, updatedBlots);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.editor.options.render) {
        return;
      }
      scroll_get(scroll_getPrototypeOf(Scroll.prototype), "render", this).call(this);
      if (this.props.dragSession) {
        this.domNode.classList.add('drag-session');
      } else {
        this.domNode.classList.remove('drag-session');
      }
      if (this.editor && this.editor.options && this.editor.options.focusMode && this.editor.isEditable()) {
        var range = this.editor.scroll.selection.getRange()[0];
        if (range) {
          this.editor.scroll.domNode.classList.add("focus-mode");
        }
      }
      this.emitter.emit('SCROLL_RENDER', {});
    }
  }, {
    key: "exec",
    value: function exec(action) {
      return scroll_get(scroll_getPrototypeOf(Scroll.prototype), "exec", this).call(this, action);
    }
  }, {
    key: "setMouseCursor",
    value: function setMouseCursor(style) {
      this.domNode.setAttribute('data-force-cursor', style);
    }
  }, {
    key: "resetMouseCursor",
    value: function resetMouseCursor() {
      this.domNode.removeAttribute('data-force-cursor');
    }
  }, {
    key: "setOverlay",
    value: function setOverlay() {
      var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var overlay = document.createElement('div');
      overlay.classList.add('editor-overlay');
      for (var k in style) {
        overlay.style[k] = style[k];
      }
      var container = this.editor.scrollingContainer;
      overlay.style.height = container.scrollHeight + 'px';
      container.appendChild(overlay);
    }
  }, {
    key: "resetOverlay",
    value: function resetOverlay() {
      var overlay = this.editor.scrollingContainer.querySelector('.editor-overlay');
      if (overlay) {
        overlay.parentNode.removeChild(overlay);
      }
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      var html = childrenToHTML(this, context, {
        allowRawHTML: true
      });
      return '<div class="' + this.domNode.className + '" id="' + this.domNode.getAttribute('id') + '">' + html + '</div>';
    }
  }, {
    key: "getSelectedContents",
    value: function getSelectedContents() {
      var skipContainers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var allContent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      // возможно пригодится в мобилах возвращение с параметром skipContainers, где нужно указать массив из названий блотов колонок ['grid', 'gridCol'],
      // так как там гриды не отображаются и можно просто вернуть контент без учета разбивки на гриды
      var blots = (allContent ? this.descendants(function (blot) {
        return blot.isSelectable;
      }) : this.selectedBlocks).filter(function (blot, index) {
        // например, капшен является дочерним блотом разных аттачей,
        // если он не является первым блотом в массиве выделенных, нужно его отсеять
        // аттач сам сгенерирует для него набор операций для вставки
        if (blot.isSelectableBlotChild && index > 0) {
          return false;
        }
        // отсеиваем содержимое выделяемых блоков являющимися также "контейнерами" для других
        var collapsibleContainer = searchUp(blot, function (b) {
          return b.isCollapsibleContainer;
        });
        if (collapsibleContainer && collapsibleContainer.getSelectableBlot && collapsibleContainer.getSelectableBlot().props.selected) {
          return false;
        }
        return true;
      });
      // если выделены блоки только в коллапсируемом контейнере, игнорим его при составлении контекста
      if (blots.every(function (blot) {
        return searchUp(blot, function (b) {
          return b.isCollapsibleContainer;
        });
      })) {
        skipContainers.push(searchUp(blots[0], function (b) {
          return b.isCollapsibleContainer;
        }).constructor.blotName);
      }
      var contextHelper = new ContentContextHelper(this, {
        skipContainers: skipContainers
      });
      var ops = [];
      var _iterator8 = scroll_createForOfIteratorHelper(blots),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var blot = _step8.value;
          if (blot.getBlotInsertParams) {
            var _this$scroll$selectio = this.scroll.selection.getRange({
                offsetBlot: blot
              }),
              _this$scroll$selectio2 = scroll_slicedToArray(_this$scroll$selectio, 1),
              blotRange = _this$scroll$selectio2[0];
            var op = blot.getBlotInsertParams(blotRange, contextHelper);
            // блот может вернуть набор операций, например свернутый список возвращает операции элементов подсписка
            if (Array.isArray(op)) {
              ops.push.apply(ops, scroll_toConsumableArray(op));
            } else {
              ops.push(op);
            }
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      return contextHelper.normalizeOps(ops);
    }
  }, {
    key: "getSelectedContentsAsMarkdown",
    value: function getSelectedContentsAsMarkdown() {
      var skipContainers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var markdown = '';
      this.getSelectedContents(skipContainers).forEach(function (content) {
        markdown += contentToMarkdown(content);
      });
      return markdown;
    }
  }, {
    key: "getMarkdown",
    value: function getMarkdown() {
      var markdown = '';
      this.children.forEach(function (child) {
        var childMarkdown = '';
        if (child.getMarkdown) {
          childMarkdown = child.getMarkdown();
        } else if (child.getText) {
          childMarkdown = child.getText();
        }
        if (childMarkdown.trim()) {
          markdown += childMarkdown.trim() + '\n\n';
        }
      });
      return markdown;
    }
  }]);
  return Scroll;
}(scroll_mixin((parchment_default()).Scroll));
Scroll.blotName = 'scroll';
Scroll.className = vars.scrollBlotClass;
Scroll.tagName = 'DIV';
// чтобы parchment не пытался создать свой block блот если редактор становится пустым
Scroll.defaultChild = null;
Scroll.allowedChildren = [blots_grid, paragraphAbstract, tableWrapper, ImageWrapper, FileWrapper, RemoteFrameWrapper, RemoteFileWrapper, SyntaxWrapper, list_list, hLine, businessCard, bookmark, Outline, html, ButtonSingle, toggleWrapper, primary, paragraphV2, TasksList, Board, uploaderWrapper, StepAggregator];
Scroll.initMap = function (map, store) {
  container.initMap(map, store);
};
/* harmony default export */ const blots_scroll = (Scroll);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/formats/bold.js
function bold_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { bold_typeof = function _typeof(obj) { return typeof obj; }; } else { bold_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return bold_typeof(obj); }











function bold_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function bold_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function bold_createClass(Constructor, protoProps, staticProps) { if (protoProps) bold_defineProperties(Constructor.prototype, protoProps); if (staticProps) bold_defineProperties(Constructor, staticProps); return Constructor; }
function bold_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { bold_get = Reflect.get; } else { bold_get = function _get(target, property, receiver) { var base = bold_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return bold_get(target, property, receiver || target); }
function bold_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = bold_getPrototypeOf(object); if (object === null) break; } return object; }
function bold_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) bold_setPrototypeOf(subClass, superClass); }
function bold_setPrototypeOf(o, p) { bold_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return bold_setPrototypeOf(o, p); }
function bold_createSuper(Derived) { var hasNativeReflectConstruct = bold_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = bold_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = bold_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return bold_possibleConstructorReturn(this, result); }; }
function bold_possibleConstructorReturn(self, call) { if (call && (bold_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return bold_assertThisInitialized(self); }
function bold_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function bold_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function bold_getPrototypeOf(o) { bold_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return bold_getPrototypeOf(o); }


var Bold = /*#__PURE__*/function (_Inline) {
  bold_inherits(Bold, _Inline);
  var _super = bold_createSuper(Bold);
  function Bold() {
    bold_classCallCheck(this, Bold);
    return _super.apply(this, arguments);
  }
  bold_createClass(Bold, [{
    key: "optimize",
    value: function optimize(context) {
      bold_get(bold_getPrototypeOf(Bold.prototype), "optimize", this).call(this, context);
      if (this.domNode.tagName !== this.statics.tagName[0]) {
        this.replaceWith(this.statics.blotName);
      }
    }
  }], [{
    key: "create",
    value: function create() {
      return bold_get(bold_getPrototypeOf(Bold), "create", this).call(this);
    }
  }, {
    key: "formats",
    value: function formats() {
      return true;
    }
  }]);
  return Bold;
}(inline);
Bold.blotName = 'bold';
Bold.tagName = ['STRONG', 'B'];
/* harmony default export */ const bold = (Bold);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/formats/italic.js
function italic_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { italic_typeof = function _typeof(obj) { return typeof obj; }; } else { italic_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return italic_typeof(obj); }









function italic_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function italic_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) italic_setPrototypeOf(subClass, superClass); }
function italic_setPrototypeOf(o, p) { italic_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return italic_setPrototypeOf(o, p); }
function italic_createSuper(Derived) { var hasNativeReflectConstruct = italic_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = italic_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = italic_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return italic_possibleConstructorReturn(this, result); }; }
function italic_possibleConstructorReturn(self, call) { if (call && (italic_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return italic_assertThisInitialized(self); }
function italic_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function italic_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function italic_getPrototypeOf(o) { italic_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return italic_getPrototypeOf(o); }

var Italic = /*#__PURE__*/function (_Bold) {
  italic_inherits(Italic, _Bold);
  var _super = italic_createSuper(Italic);
  function Italic() {
    italic_classCallCheck(this, Italic);
    return _super.apply(this, arguments);
  }
  return Italic;
}(bold);
Italic.blotName = 'italic';
Italic.tagName = ['EM', 'I'];
/* harmony default export */ const italic = (Italic);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/formats/underline.js
function underline_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { underline_typeof = function _typeof(obj) { return typeof obj; }; } else { underline_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return underline_typeof(obj); }









function underline_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function underline_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) underline_setPrototypeOf(subClass, superClass); }
function underline_setPrototypeOf(o, p) { underline_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return underline_setPrototypeOf(o, p); }
function underline_createSuper(Derived) { var hasNativeReflectConstruct = underline_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = underline_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = underline_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return underline_possibleConstructorReturn(this, result); }; }
function underline_possibleConstructorReturn(self, call) { if (call && (underline_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return underline_assertThisInitialized(self); }
function underline_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function underline_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function underline_getPrototypeOf(o) { underline_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return underline_getPrototypeOf(o); }

var Underline = /*#__PURE__*/function (_Bold) {
  underline_inherits(Underline, _Bold);
  var _super = underline_createSuper(Underline);
  function Underline() {
    underline_classCallCheck(this, Underline);
    return _super.apply(this, arguments);
  }
  return Underline;
}(bold);
Underline.blotName = 'underline';
Underline.tagName = ['u'];
/* harmony default export */ const underline = (Underline);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/formats/strikethrough.js
function strikethrough_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { strikethrough_typeof = function _typeof(obj) { return typeof obj; }; } else { strikethrough_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return strikethrough_typeof(obj); }









function strikethrough_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function strikethrough_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) strikethrough_setPrototypeOf(subClass, superClass); }
function strikethrough_setPrototypeOf(o, p) { strikethrough_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return strikethrough_setPrototypeOf(o, p); }
function strikethrough_createSuper(Derived) { var hasNativeReflectConstruct = strikethrough_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = strikethrough_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = strikethrough_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return strikethrough_possibleConstructorReturn(this, result); }; }
function strikethrough_possibleConstructorReturn(self, call) { if (call && (strikethrough_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return strikethrough_assertThisInitialized(self); }
function strikethrough_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function strikethrough_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function strikethrough_getPrototypeOf(o) { strikethrough_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return strikethrough_getPrototypeOf(o); }

var Strikethrough = /*#__PURE__*/function (_Bold) {
  strikethrough_inherits(Strikethrough, _Bold);
  var _super = strikethrough_createSuper(Strikethrough);
  function Strikethrough() {
    strikethrough_classCallCheck(this, Strikethrough);
    return _super.apply(this, arguments);
  }
  return Strikethrough;
}(bold);
Strikethrough.blotName = 'strikethrough';
Strikethrough.tagName = ['del', 's'];
/* harmony default export */ const strikethrough = (Strikethrough);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/scss/palette-common.scss
var palette_common = __webpack_require__(22492);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/formats/color.js
function color_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { color_typeof = function _typeof(obj) { return typeof obj; }; } else { color_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return color_typeof(obj); }



















function color_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function color_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function color_createClass(Constructor, protoProps, staticProps) { if (protoProps) color_defineProperties(Constructor.prototype, protoProps); if (staticProps) color_defineProperties(Constructor, staticProps); return Constructor; }
function color_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { color_get = Reflect.get; } else { color_get = function _get(target, property, receiver) { var base = color_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return color_get(target, property, receiver || target); }
function color_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = color_getPrototypeOf(object); if (object === null) break; } return object; }
function color_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) color_setPrototypeOf(subClass, superClass); }
function color_setPrototypeOf(o, p) { color_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return color_setPrototypeOf(o, p); }
function color_createSuper(Derived) { var hasNativeReflectConstruct = color_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = color_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = color_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return color_possibleConstructorReturn(this, result); }; }
function color_possibleConstructorReturn(self, call) { if (call && (color_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return color_assertThisInitialized(self); }
function color_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function color_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function color_getPrototypeOf(o) { color_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return color_getPrototypeOf(o); }


var Color = /*#__PURE__*/function (_Inline) {
  color_inherits(Color, _Inline);
  var _super = color_createSuper(Color);
  function Color() {
    color_classCallCheck(this, Color);
    return _super.apply(this, arguments);
  }
  color_createClass(Color, null, [{
    key: "create",
    value: function create(value) {
      var node = color_get(color_getPrototypeOf(Color), "create", this).call(this, value);
      if (value) {
        if (value.startsWith('#') || value.startsWith('rgb')) {
          node.style.color = value;
          node.removeAttribute(palette_common.PALETTE_ATTR_FONT);
        } else {
          node.style.color = '';
          node.setAttribute(palette_common.PALETTE_ATTR_FONT, value);
        }
      } else {
        node.removeAttribute(palette_common.PALETTE_ATTR_FONT);
      }
      return node;
    }
  }, {
    key: "formats",
    value: function formats(domNode) {
      var value = domNode.style.color || domNode.getAttribute(palette_common.PALETTE_ATTR_FONT);
      if (!value.startsWith('rgb(')) return value;
      value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
      return '#' + value.split(',').map(function (component) {
        return ('00' + parseInt(component).toString(16)).slice(-2);
      }).join('');
    }
  }]);
  return Color;
}(inline);

Color.blotName = 'color';
Color.className = 'font-color';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/formats/background.js
function background_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { background_typeof = function _typeof(obj) { return typeof obj; }; } else { background_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return background_typeof(obj); }
function background_toConsumableArray(arr) { return background_arrayWithoutHoles(arr) || background_iterableToArray(arr) || background_unsupportedIterableToArray(arr) || background_nonIterableSpread(); }
function background_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function background_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return background_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return background_arrayLikeToArray(o, minLen); }
function background_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function background_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return background_arrayLikeToArray(arr); }
function background_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }




















function background_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function background_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function background_createClass(Constructor, protoProps, staticProps) { if (protoProps) background_defineProperties(Constructor.prototype, protoProps); if (staticProps) background_defineProperties(Constructor, staticProps); return Constructor; }
function background_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { background_get = Reflect.get; } else { background_get = function _get(target, property, receiver) { var base = background_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return background_get(target, property, receiver || target); }
function background_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = background_getPrototypeOf(object); if (object === null) break; } return object; }
function background_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) background_setPrototypeOf(subClass, superClass); }
function background_setPrototypeOf(o, p) { background_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return background_setPrototypeOf(o, p); }
function background_createSuper(Derived) { var hasNativeReflectConstruct = background_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = background_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = background_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return background_possibleConstructorReturn(this, result); }; }
function background_possibleConstructorReturn(self, call) { if (call && (background_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return background_assertThisInitialized(self); }
function background_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function background_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function background_getPrototypeOf(o) { background_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return background_getPrototypeOf(o); }


var Background = /*#__PURE__*/function (_Inline) {
  background_inherits(Background, _Inline);
  var _super = background_createSuper(Background);
  function Background() {
    background_classCallCheck(this, Background);
    return _super.apply(this, arguments);
  }
  background_createClass(Background, [{
    key: "optimize",
    value: function optimize() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = background_get(background_getPrototypeOf(Background.prototype), "optimize", this)).call.apply(_get2, [this].concat(args));
      var highlightName = this.domNode.getAttribute('data-highlight');
      var possibleNames = [].concat(background_toConsumableArray(matHighlightNames), background_toConsumableArray(Object.keys(matHighlightNamesAssoc)));
      var isExtraHighlight = possibleNames.includes(highlightName);
      if (!isExtraHighlight) return;
      var hasNextSiblingHighlight = false;
      var isNextSiblingInCurrentWord = false;
      if (this.next instanceof Background && possibleNames.includes(highlightName)) {
        hasNextSiblingHighlight = true;
        if (this.domNode.innerText && !this.domNode.innerText.endsWith(' ') && this.next.domNode.innerText && !this.next.domNode.innerText.startsWith(' ')) {
          isNextSiblingInCurrentWord = true;
        }
      }
      if (hasNextSiblingHighlight) {
        if (!this.domNode.classList.contains('has-next-highlight')) {
          this.domNode.classList.add('has-next-highlight');
        }
      } else {
        if (this.domNode.classList.contains('has-next-highlight')) {
          this.domNode.classList.remove('has-next-highlight');
        }
      }
      if (isNextSiblingInCurrentWord) {
        if (!this.domNode.classList.contains('next-highlight-in-current-word')) {
          this.domNode.classList.add('next-highlight-in-current-word');
        }
      } else {
        if (this.domNode.classList.contains('next-highlight-in-current-word')) {
          this.domNode.classList.remove('next-highlight-in-current-word');
        }
      }
    }
  }], [{
    key: "create",
    value: function create(value) {
      var node = background_get(background_getPrototypeOf(Background), "create", this).call(this, value);
      var highlightName = value;
      var isExtraHighlight = false;
      var support = false;
      if (matColorNames.includes(value)) {
        support = true;
      } else if (matHighlightNames.includes(value)) {
        isExtraHighlight = true;
        support = true;
      } else if (Object.keys(matColorNamesAssoc).includes(value)) {
        highlightName = matColorNamesAssoc[value];
        support = true;
      } else if (Object.keys(matHighlightNamesAssoc).includes(value)) {
        highlightName = matHighlightNamesAssoc[value];
        isExtraHighlight = true;
        support = true;
      }
      node.setAttribute('data-highlight', highlightName);
      if (isExtraHighlight) {
        node.classList.add('extra-highlight');
      }
      if (!support) {
        console.warn("Highlight name \"".concat(value, "\" is not supported by editor"));
      }
      return node;
    }
  }, {
    key: "formats",
    value: function formats(domNode) {
      var highlight = domNode.getAttribute('data-highlight');
      return highlight;
    }
  }]);
  return Background;
}(inline);

Background.blotName = 'background';
Background.className = 'background-color';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/formats/code.js
function code_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { code_typeof = function _typeof(obj) { return typeof obj; }; } else { code_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return code_typeof(obj); }









function code_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function code_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) code_setPrototypeOf(subClass, superClass); }
function code_setPrototypeOf(o, p) { code_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return code_setPrototypeOf(o, p); }
function code_createSuper(Derived) { var hasNativeReflectConstruct = code_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = code_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = code_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return code_possibleConstructorReturn(this, result); }; }
function code_possibleConstructorReturn(self, call) { if (call && (code_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return code_assertThisInitialized(self); }
function code_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function code_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function code_getPrototypeOf(o) { code_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return code_getPrototypeOf(o); }

var Code = /*#__PURE__*/function (_Bold) {
  code_inherits(Code, _Bold);
  var _super = code_createSuper(Code);
  function Code() {
    code_classCallCheck(this, Code);
    return _super.apply(this, arguments);
  }
  return Code;
}(bold);
Code.blotName = 'code';
Code.className = 'inline-code';
Code.tagName = ['CODE'];
/* harmony default export */ const code = (Code);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/formats/placeholder.js
function formats_placeholder_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { formats_placeholder_typeof = function _typeof(obj) { return typeof obj; }; } else { formats_placeholder_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return formats_placeholder_typeof(obj); }












function formats_placeholder_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function formats_placeholder_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function formats_placeholder_createClass(Constructor, protoProps, staticProps) { if (protoProps) formats_placeholder_defineProperties(Constructor.prototype, protoProps); if (staticProps) formats_placeholder_defineProperties(Constructor, staticProps); return Constructor; }
function placeholder_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { placeholder_get = Reflect.get; } else { placeholder_get = function _get(target, property, receiver) { var base = placeholder_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return placeholder_get(target, property, receiver || target); }
function placeholder_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = formats_placeholder_getPrototypeOf(object); if (object === null) break; } return object; }
function formats_placeholder_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) formats_placeholder_setPrototypeOf(subClass, superClass); }
function formats_placeholder_setPrototypeOf(o, p) { formats_placeholder_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return formats_placeholder_setPrototypeOf(o, p); }
function formats_placeholder_createSuper(Derived) { var hasNativeReflectConstruct = formats_placeholder_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = formats_placeholder_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = formats_placeholder_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return formats_placeholder_possibleConstructorReturn(this, result); }; }
function formats_placeholder_possibleConstructorReturn(self, call) { if (call && (formats_placeholder_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return formats_placeholder_assertThisInitialized(self); }
function formats_placeholder_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function formats_placeholder_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function formats_placeholder_getPrototypeOf(o) { formats_placeholder_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return formats_placeholder_getPrototypeOf(o); }
function formats_placeholder_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var MOUSE_EVENTS_DISTANCE = 5;
var Placeholder = /*#__PURE__*/function (_Inline) {
  formats_placeholder_inherits(Placeholder, _Inline);
  var _super = formats_placeholder_createSuper(Placeholder);
  function Placeholder() {
    var _this;
    formats_placeholder_classCallCheck(this, Placeholder);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    formats_placeholder_defineProperty(formats_placeholder_assertThisInitialized(_this), "onMouseDown", function (event) {
      _this.mouseDownPosition = {
        x: event.clientX,
        y: event.clientY
      };
    });
    formats_placeholder_defineProperty(formats_placeholder_assertThisInitialized(_this), "onClick", function (event) {
      var nowPosition = {
        x: event.clientX,
        y: event.clientY
      };
      if (math_distance(nowPosition, _this.mouseDownPosition) >= MOUSE_EVENTS_DISTANCE) {
        _this.mouseDownPosition = null;
        return;
      }
      _this.mouseDownPosition = null;
      event.preventDefault();
      event.stopPropagation();
      // получаем необходимые инстансы
      var textBlot = normalizeToStoredBlot(formats_placeholder_assertThisInitialized(_this));
      if (!textBlot.isText) {
        textBlot = normalizeToTextBlot(formats_placeholder_assertThisInitialized(_this));
      }
      var editor = textBlot.editor;
      if (textBlot.constructor.blotName === 'tableText' && textBlot.parent.beginWrite) {
        textBlot.parent.beginWrite();
      }
      // выставляем каретку в начало плейсхолдера
      editor.scroll.selection.setRange({
        index: textBlot.offset(editor.scroll) + _this.offset(textBlot),
        length: 0
      });
    });
    return _this;
  }
  formats_placeholder_createClass(Placeholder, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get2 = placeholder_get(formats_placeholder_getPrototypeOf(Placeholder.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      if (this.scroll.editor.mode === this.scroll.editor.constructor.MODE_EDIT) {
        this.domNode.addEventListener('mousedown', this.onMouseDown, false);
        this.domNode.addEventListener('click', this.onClick, false);
      }
    }
    //запоминаем позицию мыши при нажатии, чтобы потом сравнить с позицией клика, возможно пользователь хочет произвести выделение текста
  }, {
    key: "onTextChange",
    value: function onTextChange(blotRange, insertedSymbol, blot) {
      var quillRange = blot.scroll.selection.getRange()[0];
      var formats = blot.getFormat(blotRange.index, 1);
      var offset = this.offset(blot);
      var length = this.length();
      formats.placeholder = null;
      formats.underline = null;
      var ops = [];
      var rangeAfter = quillRange;
      if (offset < blotRange.index) {
        ops.push.apply(ops, [{
          retain: offset
        }, {
          delete: length
        }, {
          insert: insertedSymbol,
          attributes: formats
        }]);
        rangeAfter.index = blot.offset(blot.scroll) + offset + 1;
        rangeAfter.length = 0;
      } else {
        ops.push.apply(ops, [{
          retain: blotRange.index - 1
        }, {
          retain: 1,
          attributes: formats
        }, {
          delete: length
        }]);
      }
      blot.applyForCharacters(ops);
      blot.scroll.selection.setRange(rangeAfter);
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      (_get3 = placeholder_get(formats_placeholder_getPrototypeOf(Placeholder.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      this.domNode.removeEventListener('mousedown', this.onMouseDown, false);
      this.domNode.removeEventListener('click', this.onClick, false);
    }
  }], [{
    key: "create",
    value: function create() {
      return placeholder_get(formats_placeholder_getPrototypeOf(Placeholder), "create", this).call(this);
    }
  }, {
    key: "formats",
    value: function formats() {
      return true;
    }
  }]);
  return Placeholder;
}(inline);

Placeholder.blotName = 'placeholder';
Placeholder.tagName = 'placeholder';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/formats/comment.js
function comment_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { comment_typeof = function _typeof(obj) { return typeof obj; }; } else { comment_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return comment_typeof(obj); }
function comment_slicedToArray(arr, i) { return comment_arrayWithHoles(arr) || comment_iterableToArrayLimit(arr, i) || comment_unsupportedIterableToArray(arr, i) || comment_nonIterableRest(); }
function comment_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function comment_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function comment_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function comment_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = comment_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function comment_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return comment_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return comment_arrayLikeToArray(o, minLen); }
function comment_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }






















function comment_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function comment_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function comment_createClass(Constructor, protoProps, staticProps) { if (protoProps) comment_defineProperties(Constructor.prototype, protoProps); if (staticProps) comment_defineProperties(Constructor, staticProps); return Constructor; }
function comment_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { comment_get = Reflect.get; } else { comment_get = function _get(target, property, receiver) { var base = comment_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return comment_get(target, property, receiver || target); }
function comment_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = comment_getPrototypeOf(object); if (object === null) break; } return object; }
function comment_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) comment_setPrototypeOf(subClass, superClass); }
function comment_setPrototypeOf(o, p) { comment_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return comment_setPrototypeOf(o, p); }
function comment_createSuper(Derived) { var hasNativeReflectConstruct = comment_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = comment_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = comment_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return comment_possibleConstructorReturn(this, result); }; }
function comment_possibleConstructorReturn(self, call) { if (call && (comment_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return comment_assertThisInitialized(self); }
function comment_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function comment_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function comment_getPrototypeOf(o) { comment_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return comment_getPrototypeOf(o); }
function comment_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var comment_Comment = /*#__PURE__*/function (_Inline) {
  comment_inherits(Comment, _Inline);
  var _super = comment_createSuper(Comment);
  function Comment() {
    var _this;
    comment_classCallCheck(this, Comment);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    comment_defineProperty(comment_assertThisInitialized(_this), "getCommentOffset", function () {
      var parent = _this.parent;
      var el = [parent];
      while (parent && !parent.map) {
        parent = parent.parent;
        el.push(parent);
      }
      el = el.reverse();
      if (el[0] === _this.textBlot) {
        if (el.length >= 1) {
          var offset = _this.offset();
          el.forEach(function (item) {
            offset += item.offset();
          });
          return offset;
        }
      }
      return _this.offset();
    });
    comment_defineProperty(comment_assertThisInitialized(_this), "removeComment", function () {
      _this.editor.plugins.undoManager.skip(function () {
        var offset = _this.getCommentOffset();
        _this.textBlot.formatText(offset, _this.length(), "comment-".concat(_this.threadId, "-").concat(_this.commentColor), false, 'user');
      });
    });
    comment_defineProperty(comment_assertThisInitialized(_this), "onSetComments", function () {
      var status = _this.editor.plugins.commentManager.getThreadStatus(_this.threadId);
      var isHide = ['resolved', 'none'].includes(status);
      var attrValue = isHide ? 'true' : '';
      if (_this.domNode.getAttribute('data-comment-hide') !== attrValue) {
        _this.domNode.setAttribute('data-comment-hide', attrValue);
      }
    });
    comment_defineProperty(comment_assertThisInitialized(_this), "onMouseMove", function (event) {
      if (!_this.commentHide && !_this.isMobile) {
        event.stopPropagation();
        var forClearStateNodes = document.querySelectorAll('comment.force-hover');
        var _iterator = comment_createForOfIteratorHelper(forClearStateNodes),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var node = _step.value;
            node.classList.remove('force-hover');
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var threadNodes = document.querySelectorAll('comment[data-comment-threadId="' + _this.threadId + '"]');
        var _iterator2 = comment_createForOfIteratorHelper(threadNodes),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _node = _step2.value;
            _node.classList.add('force-hover');
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    });
    comment_defineProperty(comment_assertThisInitialized(_this), "onMouseLeave", function () {
      if (!_this.commentHide && !_this.isMobile) {
        var forClearStateNodes = document.querySelectorAll('comment.force-hover');
        var _iterator3 = comment_createForOfIteratorHelper(forClearStateNodes),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var node = _step3.value;
            node.classList.remove('force-hover');
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    });
    comment_defineProperty(comment_assertThisInitialized(_this), "onClick", function (event) {
      // если текст выделен то не показываем диалог комментариев
      var _this$editor$scroll$s = _this.editor.scroll.selection.getRange(),
        _this$editor$scroll$s2 = comment_slicedToArray(_this$editor$scroll$s, 1),
        range = _this$editor$scroll$s2[0];
      var _ref = range || {},
        _ref$length = _ref.length,
        length = _ref$length === void 0 ? 0 : _ref$length;
      if (!_this.commentHide && !length && !_this.isMobile) {
        // необходимо найти первый комментарий и по нему определить родительский blot
        // сделано для того, что если для примера комментарий находтся в двух блотах, то при клике на комментарий во втором
        // блоте всё равно вернулся первый
        var _document$querySelect = document.querySelectorAll("comment[data-comment-threadId='".concat(_this.threadId, "']")),
          _document$querySelect2 = comment_slicedToArray(_document$querySelect, 1),
          el = _document$querySelect2[0];
        if (el) {
          var blot = el.__blot.blot.textBlot;
          if (blot instanceof NewTextBase) {
            blot = blot.parent;
          }
          blot.editor.plugins.commentManager.openComments(blot.id, {
            threadId: _this.threadId,
            target: 'text'
          });
        }
      }
    });
    comment_defineProperty(comment_assertThisInitialized(_this), "onMouseClickDebounce", lodash_debounce_default()(_this.onClick, 100, {
      trailing: true
    }));
    comment_defineProperty(comment_assertThisInitialized(_this), "onMouseClick", function (event) {
      event.stopPropagation(); // в случае если кликаем на комментарий под которым есть другой комментарий
      _this.onMouseClickDebounce(event);
    });
    return _this;
  }
  comment_createClass(Comment, [{
    key: "threadId",
    get: function get() {
      return this.domNode.getAttribute('data-comment-threadId');
    }
  }, {
    key: "commentColor",
    get: function get() {
      return this.domNode.getAttribute('data-comment-color');
    }
  }, {
    key: "commentHide",
    get: function get() {
      return this.domNode.getAttribute('data-comment-hide') === 'true';
    }
  }, {
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get2 = comment_get(comment_getPrototypeOf(Comment.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      this.domNode.addEventListener('mousemove', this.onMouseMove, false);
      this.domNode.addEventListener('mouseleave', this.onMouseLeave, false);
      this.domNode.addEventListener('click', this.onMouseClick, false);
      this.textBlot = getParentTextBlot(this);
      this.editor = this.textBlot.editor;
      this.isMobile = this.editor.options.keyboardMode === 'mobile';
      this.editor.emitter.on('set-comments', this.onSetComments);
      this.editor.on('SCROLL_UPDATE', this.onSetComments);
    }
  }, {
    key: "detach",
    value: function detach() {
      var _get3;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      (_get3 = comment_get(comment_getPrototypeOf(Comment.prototype), "detach", this)).call.apply(_get3, [this].concat(args));
      this.domNode.removeEventListener('mousemove', this.onMouseMove, false);
      this.domNode.removeEventListener('mouseleave', this.onMouseLeave, false);
      this.domNode.removeEventListener('click', this.onMouseClick, false);
      this.onMouseClickDebounce.cancel();
      this.editor.emitter.off('set-comments', this.onSetComments);
      this.editor.off('SCROLL_UPDATE', this.onSetComments);
    }

    /**
     * Возвращает offset комментария
     * так как комментарий может быть вложен в формат (bold, underline...), а также может быть вложен в другой
     * комментарий, необходим корректно рассчитать его offset
     * @returns {number}
     */
  }, {
    key: "formats",
    value: function formats() {
      // Возвращаем кастомный формат комментария для хранения в дельте и возможности пересечения комментариев
      // 'comment-threadId-color': true
      var key = 'comment-' + this.threadId + '-' + this.commentColor;
      return comment_defineProperty({}, key, true);
    }
  }, {
    key: "formatAt",
    value: function formatAt(index, length, name, value) {
      var processed = false;
      if (name === 'comment' && value) {
        var textBlot = getParentTextBlot(this);
        var threadData = JSON.parse(value);
        if (index === 0 && length === this.length()) {
          // нет смысла форматировать текущий блот если айди тредов равны
          if (threadData.threadId !== this.threadId) {
            var isNested = Boolean(textBlot.descendants(function (blot) {
              return blot instanceof Comment && blot.threadId === threadData.threadId;
            }, 0, this.offset(textBlot)).length);
            if (isNested) {
              var blot = this.isolate(index, length);
              blot.wrap(name, value);
              processed = true;
            }
          } else {
            processed = true;
          }
        } else {
          // при печати текста, если пришла remote дельта с этого же клиента, редактор попытается отформатировать новый симовол этим же threadId
          // если форматирование применяется внутри комментария и threadId совпадают, пропускаем процесс форматирования
          var offset = this.offset(textBlot);
          if (this.length() - offset < index && this.length() + offset >= index + length) {
            if (threadData.threadId === this.threadId) {
              processed = true;
            }
          }
        }
      } else if (name.startsWith('comment-') && !value) {
        var _name$split = name.split('-'),
          _name$split2 = comment_slicedToArray(_name$split, 2),
          threadId = _name$split2[1]; // конструкция берет элемент массива по индексу 1
        if (this.threadId === threadId) {
          var _blot = this.isolate(index, length);
          _blot.format('comment', value);
          processed = true;
        }
      }
      if (!processed) {
        comment_get(comment_getPrototypeOf(Comment.prototype), "formatAt", this).call(this, index, length, name, value);
      }
    }
  }, {
    key: "optimize",
    value: function optimize(context) {
      if (this.parent instanceof Comment && this.parent.length() === this.length() && Comment.compareDeep(this, this.parent) > 0) {
        var parent = this.parent.isolate(this.offset(), this.length());
        this.moveChildren(parent);
        parent.wrap(this);
      }
      comment_get(comment_getPrototypeOf(Comment.prototype), "optimize", this).call(this, context);
    }
  }], [{
    key: "create",
    value: function create(value) {
      var node = comment_get(comment_getPrototypeOf(Comment), "create", this).call(this, value);
      var _JSON$parse = JSON.parse(value),
        color = _JSON$parse.color,
        threadId = _JSON$parse.threadId;
      if (inlineCommentColors.indexOf(color) !== -1) {
        node.setAttribute('data-comment-color', color);
      }
      node.setAttribute('data-comment-threadId', threadId);
      node.setAttribute('data-comment-hide', 'true');
      return node;
    }
  }, {
    key: "compareDeep",
    value: function compareDeep(self, other) {
      var textBlot = getParentTextBlot(self);
      var getDeep = function getDeep(comment) {
        var result = 0;
        var blot = comment.parent;
        while (blot.parent instanceof Comment) {
          result++;
          blot = blot.parent;
        }
        return result;
      };
      var beforeComments = textBlot.descendants(function (blot) {
        return blot instanceof Comment && blot !== self && blot !== other && (blot.threadId === self.threadId || blot.threadId === other.threadId);
      }, 0, self.offset(textBlot));
      if (!beforeComments.length) {
        return 0;
      } else {
        var selfFragment = beforeComments.filter(function (blot) {
          return blot.threadId === self.threadId;
        })[0];
        var otherFragment = beforeComments.filter(function (blot) {
          return blot.threadId === other.threadId;
        })[0];
        if (selfFragment && !otherFragment) {
          return 1;
        } else if (!selfFragment && otherFragment) {
          return -1;
        } else {
          return getDeep(otherFragment) - getDeep(selfFragment);
        }
      }
    }

    /**
     * Проверка можно ли конвертировать выделенную строку в комментарий
     * @param editor
     * @returns {boolean}
     */
  }, {
    key: "isAllowToConvert",
    value: function isAllowToConvert(editor) {
      return !(editor.scroll.getSelectedBlocks()[0] instanceof table_table);
    }
  }]);
  return Comment;
}(inline);
comment_Comment.blotName = 'comment';
comment_Comment.tagName = 'COMMENT';
function getParentTextBlot(comment) {
  var textBlot = normalizeToStoredBlot(comment);
  if (!textBlot.isText) {
    textBlot = comment.parent;
    while (textBlot && !textBlot.isText) {
      textBlot = textBlot.parent;
    }
  }
  return textBlot;
}
/* harmony default export */ const comment = (comment_Comment);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/heading/hLarge.js
function hLarge_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { hLarge_typeof = function _typeof(obj) { return typeof obj; }; } else { hLarge_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return hLarge_typeof(obj); }
















function hLarge_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = hLarge_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function hLarge_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return hLarge_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return hLarge_arrayLikeToArray(o, minLen); }
function hLarge_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function hLarge_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function hLarge_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function hLarge_createClass(Constructor, protoProps, staticProps) { if (protoProps) hLarge_defineProperties(Constructor.prototype, protoProps); if (staticProps) hLarge_defineProperties(Constructor, staticProps); return Constructor; }
function hLarge_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) hLarge_setPrototypeOf(subClass, superClass); }
function hLarge_setPrototypeOf(o, p) { hLarge_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return hLarge_setPrototypeOf(o, p); }
function hLarge_createSuper(Derived) { var hasNativeReflectConstruct = hLarge_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = hLarge_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = hLarge_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return hLarge_possibleConstructorReturn(this, result); }; }
function hLarge_possibleConstructorReturn(self, call) { if (call && (hLarge_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return hLarge_assertThisInitialized(self); }
function hLarge_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function hLarge_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function hLarge_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { hLarge_get = Reflect.get; } else { hLarge_get = function _get(target, property, receiver) { var base = hLarge_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return hLarge_get(target, property, receiver || target); }
function hLarge_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = hLarge_getPrototypeOf(object); if (object === null) break; } return object; }
function hLarge_getPrototypeOf(o) { hLarge_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return hLarge_getPrototypeOf(o); }



var hLarge_FORMAT_STYLES = ['italic', 'underline', 'strikethrough', 'link', 'button', 'background', 'color', 'comment'];
var HLarge = /*#__PURE__*/function (_ParagraphAbstract) {
  hLarge_inherits(HLarge, _ParagraphAbstract);
  var _super = hLarge_createSuper(HLarge);
  function HLarge(domNode) {
    var _this;
    hLarge_classCallCheck(this, HLarge);
    _this = _super.call(this, domNode);
    _this.isHeading = true;
    return _this;
  }
  hLarge_createClass(HLarge, [{
    key: "getAllowedStyles",
    value: function getAllowedStyles() {
      return hLarge_FORMAT_STYLES;
    }
  }, {
    key: "toHTML",
    value: function toHTML(options) {
      var dataAttrs = '';
      var _iterator = hLarge_createForOfIteratorHelper(this.domNode.attributes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var attr = _step.value;
          if (attr.name.startsWith('data-')) {
            dataAttrs += ' ' + attr.name + '="' + attr.value + '"';
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return '<h1 class="' + this.domNode.className + '"' + dataAttrs + ' id="' + this.id + '" style="text-align:' + this.map.get('align') + ';">' + hLarge_get(hLarge_getPrototypeOf(HLarge.prototype), "toHTML", this).call(this, options) + '</h1>';
    }
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      var params = hLarge_get(hLarge_getPrototypeOf(HLarge.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
      return (0,util/* mergeDeep */.Ee)(params, {
        textLineType: 'hLarge'
      });
    }
  }, {
    key: "getMarkdown",
    value: function getMarkdown() {
      var _this$map, _this$map$get, _this$map2;
      var ops = ((_this$map = this.map) === null || _this$map === void 0 ? void 0 : (_this$map$get = _this$map.get('characters')) === null || _this$map$get === void 0 ? void 0 : _this$map$get.toDelta()) || [];
      return textLineToMarkdown({
        delta: {
          ops: ops
        },
        textLineType: (_this$map2 = this.map) === null || _this$map2 === void 0 ? void 0 : _this$map2.get('type')
      });
    }
  }], [{
    key: "initMap",
    value: function initMap(map, store) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      map.set('type', 'hLarge');
      hLarge_get(hLarge_getPrototypeOf(HLarge), "initMap", this).call(this, map, store, params);
    }
  }]);
  return HLarge;
}(paragraphAbstract);
HLarge.blotName = 'hLarge';
HLarge.tagName = 'H1';
HLarge.className = 'nedit-heading';
/* harmony default export */ const hLarge = (HLarge);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/heading/hMedium.js
function hMedium_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { hMedium_typeof = function _typeof(obj) { return typeof obj; }; } else { hMedium_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return hMedium_typeof(obj); }
















function hMedium_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = hMedium_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function hMedium_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return hMedium_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return hMedium_arrayLikeToArray(o, minLen); }
function hMedium_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function hMedium_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function hMedium_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function hMedium_createClass(Constructor, protoProps, staticProps) { if (protoProps) hMedium_defineProperties(Constructor.prototype, protoProps); if (staticProps) hMedium_defineProperties(Constructor, staticProps); return Constructor; }
function hMedium_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) hMedium_setPrototypeOf(subClass, superClass); }
function hMedium_setPrototypeOf(o, p) { hMedium_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return hMedium_setPrototypeOf(o, p); }
function hMedium_createSuper(Derived) { var hasNativeReflectConstruct = hMedium_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = hMedium_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = hMedium_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return hMedium_possibleConstructorReturn(this, result); }; }
function hMedium_possibleConstructorReturn(self, call) { if (call && (hMedium_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return hMedium_assertThisInitialized(self); }
function hMedium_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function hMedium_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function hMedium_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { hMedium_get = Reflect.get; } else { hMedium_get = function _get(target, property, receiver) { var base = hMedium_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return hMedium_get(target, property, receiver || target); }
function hMedium_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = hMedium_getPrototypeOf(object); if (object === null) break; } return object; }
function hMedium_getPrototypeOf(o) { hMedium_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return hMedium_getPrototypeOf(o); }



var hMedium_FORMAT_STYLES = ['italic', 'underline', 'strikethrough', 'link', 'button', 'background', 'color', 'comment'];
var HMedium = /*#__PURE__*/function (_ParagraphAbstract) {
  hMedium_inherits(HMedium, _ParagraphAbstract);
  var _super = hMedium_createSuper(HMedium);
  function HMedium(domNode) {
    var _this;
    hMedium_classCallCheck(this, HMedium);
    _this = _super.call(this, domNode);
    _this.isHeading = true;
    return _this;
  }
  hMedium_createClass(HMedium, [{
    key: "getAllowedStyles",
    value: function getAllowedStyles() {
      return hMedium_FORMAT_STYLES;
    }
  }, {
    key: "toHTML",
    value: function toHTML(options) {
      var dataAttrs = '';
      var _iterator = hMedium_createForOfIteratorHelper(this.domNode.attributes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var attr = _step.value;
          if (attr.name.startsWith('data-')) {
            dataAttrs += ' ' + attr.name + '="' + attr.value + '"';
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return '<h2 class="' + this.domNode.className + '"' + dataAttrs + ' id="' + this.id + '" style="text-align:' + this.map.get('align') + ';">' + hMedium_get(hMedium_getPrototypeOf(HMedium.prototype), "toHTML", this).call(this, options) + '</h2>';
    }
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      var params = hMedium_get(hMedium_getPrototypeOf(HMedium.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
      return (0,util/* mergeDeep */.Ee)(params, {
        textLineType: 'hMedium'
      });
    }
  }, {
    key: "getMarkdown",
    value: function getMarkdown() {
      var _this$map, _this$map$get, _this$map2;
      var ops = ((_this$map = this.map) === null || _this$map === void 0 ? void 0 : (_this$map$get = _this$map.get('characters')) === null || _this$map$get === void 0 ? void 0 : _this$map$get.toDelta()) || [];
      return textLineToMarkdown({
        delta: {
          ops: ops
        },
        textLineType: (_this$map2 = this.map) === null || _this$map2 === void 0 ? void 0 : _this$map2.get('type')
      });
    }
  }], [{
    key: "initMap",
    value: function initMap(map, store) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      map.set('type', 'hMedium');
      hMedium_get(hMedium_getPrototypeOf(HMedium), "initMap", this).call(this, map, store, params);
    }
  }]);
  return HMedium;
}(paragraphAbstract);
HMedium.blotName = 'hMedium';
HMedium.tagName = 'H2';
HMedium.className = 'nedit-heading';
/* harmony default export */ const hMedium = (HMedium);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/heading/hSmall.js
function hSmall_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { hSmall_typeof = function _typeof(obj) { return typeof obj; }; } else { hSmall_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return hSmall_typeof(obj); }
















function hSmall_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = hSmall_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function hSmall_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return hSmall_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return hSmall_arrayLikeToArray(o, minLen); }
function hSmall_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function hSmall_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function hSmall_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function hSmall_createClass(Constructor, protoProps, staticProps) { if (protoProps) hSmall_defineProperties(Constructor.prototype, protoProps); if (staticProps) hSmall_defineProperties(Constructor, staticProps); return Constructor; }
function hSmall_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) hSmall_setPrototypeOf(subClass, superClass); }
function hSmall_setPrototypeOf(o, p) { hSmall_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return hSmall_setPrototypeOf(o, p); }
function hSmall_createSuper(Derived) { var hasNativeReflectConstruct = hSmall_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = hSmall_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = hSmall_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return hSmall_possibleConstructorReturn(this, result); }; }
function hSmall_possibleConstructorReturn(self, call) { if (call && (hSmall_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return hSmall_assertThisInitialized(self); }
function hSmall_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function hSmall_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function hSmall_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { hSmall_get = Reflect.get; } else { hSmall_get = function _get(target, property, receiver) { var base = hSmall_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return hSmall_get(target, property, receiver || target); }
function hSmall_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = hSmall_getPrototypeOf(object); if (object === null) break; } return object; }
function hSmall_getPrototypeOf(o) { hSmall_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return hSmall_getPrototypeOf(o); }



var hSmall_FORMAT_STYLES = ['italic', 'underline', 'strikethrough', 'link', 'button', 'background', 'color', 'comment'];
var HSmall = /*#__PURE__*/function (_ParagraphAbstract) {
  hSmall_inherits(HSmall, _ParagraphAbstract);
  var _super = hSmall_createSuper(HSmall);
  function HSmall(domNode) {
    var _this;
    hSmall_classCallCheck(this, HSmall);
    _this = _super.call(this, domNode);
    _this.isHeading = true;
    return _this;
  }
  hSmall_createClass(HSmall, [{
    key: "getAllowedStyles",
    value: function getAllowedStyles() {
      return hSmall_FORMAT_STYLES;
    }
  }, {
    key: "toHTML",
    value: function toHTML(options) {
      var dataAttrs = '';
      var _iterator = hSmall_createForOfIteratorHelper(this.domNode.attributes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var attr = _step.value;
          if (attr.name.startsWith('data-')) {
            dataAttrs += ' ' + attr.name + '="' + attr.value + '"';
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return '<h3 class="' + this.domNode.className + '"' + dataAttrs + ' id="' + this.id + '" style="text-align:' + this.map.get('align') + ';">' + hSmall_get(hSmall_getPrototypeOf(HSmall.prototype), "toHTML", this).call(this, options) + '</h3>';
    }
  }, {
    key: "getBlotInsertParams",
    value: function getBlotInsertParams(blotRange, contextHelper) {
      var params = hSmall_get(hSmall_getPrototypeOf(HSmall.prototype), "getBlotInsertParams", this).call(this, blotRange, contextHelper);
      return (0,util/* mergeDeep */.Ee)(params, {
        textLineType: 'hSmall'
      });
    }
  }, {
    key: "getMarkdown",
    value: function getMarkdown() {
      var _this$map, _this$map$get, _this$map2;
      var ops = ((_this$map = this.map) === null || _this$map === void 0 ? void 0 : (_this$map$get = _this$map.get('characters')) === null || _this$map$get === void 0 ? void 0 : _this$map$get.toDelta()) || [];
      return textLineToMarkdown({
        delta: {
          ops: ops
        },
        textLineType: (_this$map2 = this.map) === null || _this$map2 === void 0 ? void 0 : _this$map2.get('type')
      });
    }
  }], [{
    key: "initMap",
    value: function initMap(map, store) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      map.set('type', 'hSmall');
      hSmall_get(hSmall_getPrototypeOf(HSmall), "initMap", this).call(this, map, store, params);
    }
  }]);
  return HSmall;
}(paragraphAbstract);
HSmall.blotName = 'hSmall';
HSmall.tagName = 'H3';
HSmall.className = 'nedit-heading';
/* harmony default export */ const hSmall = (HSmall);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/list/listText.js
function listText_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { listText_typeof = function _typeof(obj) { return typeof obj; }; } else { listText_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return listText_typeof(obj); }












function listText_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function listText_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function listText_createClass(Constructor, protoProps, staticProps) { if (protoProps) listText_defineProperties(Constructor.prototype, protoProps); if (staticProps) listText_defineProperties(Constructor, staticProps); return Constructor; }
function listText_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { listText_get = Reflect.get; } else { listText_get = function _get(target, property, receiver) { var base = listText_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return listText_get(target, property, receiver || target); }
function listText_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = listText_getPrototypeOf(object); if (object === null) break; } return object; }
function listText_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) listText_setPrototypeOf(subClass, superClass); }
function listText_setPrototypeOf(o, p) { listText_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return listText_setPrototypeOf(o, p); }
function listText_createSuper(Derived) { var hasNativeReflectConstruct = listText_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = listText_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = listText_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return listText_possibleConstructorReturn(this, result); }; }
function listText_possibleConstructorReturn(self, call) { if (call && (listText_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return listText_assertThisInitialized(self); }
function listText_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function listText_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function listText_getPrototypeOf(o) { listText_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return listText_getPrototypeOf(o); }

var ListText = /*#__PURE__*/function (_Paragraph) {
  listText_inherits(ListText, _Paragraph);
  var _super = listText_createSuper(ListText);
  function ListText() {
    listText_classCallCheck(this, ListText);
    return _super.apply(this, arguments);
  }
  listText_createClass(ListText, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = listText_get(listText_getPrototypeOf(ListText.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
    }
  }], [{
    key: "create",
    value: function create() {
      var node = listText_get(listText_getPrototypeOf(ListText), "create", this).call(this);
      return node;
    }
  }, {
    key: "initMap",
    value: function initMap(map, store) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      listText_get(listText_getPrototypeOf(ListText), "initMap", this).call(this, map, store, params);
    }
  }]);
  return ListText;
}(paragraph);

ListText.blotName = 'listText';
ListText.tagName = paragraph.tagName;
ListText.allowedChildren = paragraph.allowedChildren;
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/heading/hLargeToggle.js
function hLargeToggle_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { hLargeToggle_typeof = function _typeof(obj) { return typeof obj; }; } else { hLargeToggle_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return hLargeToggle_typeof(obj); }












function hLargeToggle_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function hLargeToggle_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function hLargeToggle_createClass(Constructor, protoProps, staticProps) { if (protoProps) hLargeToggle_defineProperties(Constructor.prototype, protoProps); if (staticProps) hLargeToggle_defineProperties(Constructor, staticProps); return Constructor; }
function hLargeToggle_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { hLargeToggle_get = Reflect.get; } else { hLargeToggle_get = function _get(target, property, receiver) { var base = hLargeToggle_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return hLargeToggle_get(target, property, receiver || target); }
function hLargeToggle_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = hLargeToggle_getPrototypeOf(object); if (object === null) break; } return object; }
function hLargeToggle_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) hLargeToggle_setPrototypeOf(subClass, superClass); }
function hLargeToggle_setPrototypeOf(o, p) { hLargeToggle_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return hLargeToggle_setPrototypeOf(o, p); }
function hLargeToggle_createSuper(Derived) { var hasNativeReflectConstruct = hLargeToggle_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = hLargeToggle_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = hLargeToggle_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return hLargeToggle_possibleConstructorReturn(this, result); }; }
function hLargeToggle_possibleConstructorReturn(self, call) { if (call && (hLargeToggle_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return hLargeToggle_assertThisInitialized(self); }
function hLargeToggle_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function hLargeToggle_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function hLargeToggle_getPrototypeOf(o) { hLargeToggle_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return hLargeToggle_getPrototypeOf(o); }

var HLargeToggle = /*#__PURE__*/function (_Toggle) {
  hLargeToggle_inherits(HLargeToggle, _Toggle);
  var _super = hLargeToggle_createSuper(HLargeToggle);
  function HLargeToggle() {
    hLargeToggle_classCallCheck(this, HLargeToggle);
    return _super.apply(this, arguments);
  }
  hLargeToggle_createClass(HLargeToggle, [{
    key: "attach",
    value: function attach() {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_get2 = hLargeToggle_get(hLargeToggle_getPrototypeOf(HLargeToggle.prototype), "attach", this)).call.apply(_get2, [this].concat(args));
      this.domNode.classList.add('nedit-heading');
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      return "<".concat(this.constructor.tagName.toLowerCase(), " class=\"").concat(this.domNode.className, "\">").concat(hLargeToggle_get(hLargeToggle_getPrototypeOf(HLargeToggle.prototype), "toHTML", this).call(this, context), "</").concat(this.constructor.tagName.toLowerCase(), ">");
    }
  }], [{
    key: "initMap",
    value: function initMap(map, store) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      hLargeToggle_get(hLargeToggle_getPrototypeOf(HLargeToggle), "initMap", this).call(this, map, store, params);
      map.set('type', this.blotName);
    }
  }]);
  return HLargeToggle;
}(toggle);

HLargeToggle.blotName = 'hLarge-toggle';
HLargeToggle.tagName = 'H1';
HLargeToggle.tooltipPathSuffix = 'heading';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/heading/hMediumToggle.js
function hMediumToggle_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { hMediumToggle_typeof = function _typeof(obj) { return typeof obj; }; } else { hMediumToggle_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return hMediumToggle_typeof(obj); }









function hMediumToggle_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function hMediumToggle_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) hMediumToggle_setPrototypeOf(subClass, superClass); }
function hMediumToggle_setPrototypeOf(o, p) { hMediumToggle_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return hMediumToggle_setPrototypeOf(o, p); }
function hMediumToggle_createSuper(Derived) { var hasNativeReflectConstruct = hMediumToggle_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = hMediumToggle_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = hMediumToggle_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return hMediumToggle_possibleConstructorReturn(this, result); }; }
function hMediumToggle_possibleConstructorReturn(self, call) { if (call && (hMediumToggle_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return hMediumToggle_assertThisInitialized(self); }
function hMediumToggle_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function hMediumToggle_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function hMediumToggle_getPrototypeOf(o) { hMediumToggle_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return hMediumToggle_getPrototypeOf(o); }

var HMediumToggle = /*#__PURE__*/function (_HLargeToggle) {
  hMediumToggle_inherits(HMediumToggle, _HLargeToggle);
  var _super = hMediumToggle_createSuper(HMediumToggle);
  function HMediumToggle() {
    hMediumToggle_classCallCheck(this, HMediumToggle);
    return _super.apply(this, arguments);
  }
  return HMediumToggle;
}(HLargeToggle);

HMediumToggle.blotName = 'hMedium-toggle';
HMediumToggle.tagName = 'H2';
HMediumToggle.tooltipPathSuffix = HLargeToggle.tooltipPathSuffix;
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/heading/hSmallToggle.js
function hSmallToggle_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { hSmallToggle_typeof = function _typeof(obj) { return typeof obj; }; } else { hSmallToggle_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return hSmallToggle_typeof(obj); }









function hSmallToggle_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function hSmallToggle_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) hSmallToggle_setPrototypeOf(subClass, superClass); }
function hSmallToggle_setPrototypeOf(o, p) { hSmallToggle_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return hSmallToggle_setPrototypeOf(o, p); }
function hSmallToggle_createSuper(Derived) { var hasNativeReflectConstruct = hSmallToggle_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = hSmallToggle_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = hSmallToggle_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return hSmallToggle_possibleConstructorReturn(this, result); }; }
function hSmallToggle_possibleConstructorReturn(self, call) { if (call && (hSmallToggle_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return hSmallToggle_assertThisInitialized(self); }
function hSmallToggle_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function hSmallToggle_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function hSmallToggle_getPrototypeOf(o) { hSmallToggle_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return hSmallToggle_getPrototypeOf(o); }

var HSmallToggle = /*#__PURE__*/function (_HLargeToggle) {
  hSmallToggle_inherits(HSmallToggle, _HLargeToggle);
  var _super = hSmallToggle_createSuper(HSmallToggle);
  function HSmallToggle() {
    hSmallToggle_classCallCheck(this, HSmallToggle);
    return _super.apply(this, arguments);
  }
  return HSmallToggle;
}(HLargeToggle);

HSmallToggle.blotName = 'hSmall-toggle';
HSmallToggle.tagName = 'H3';
HSmallToggle.tooltipPathSuffix = HLargeToggle.tooltipPathSuffix;
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/step/step.js
function step_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { step_typeof = function _typeof(obj) { return typeof obj; }; } else { step_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return step_typeof(obj); }














function step_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function step_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function step_createClass(Constructor, protoProps, staticProps) { if (protoProps) step_defineProperties(Constructor.prototype, protoProps); if (staticProps) step_defineProperties(Constructor, staticProps); return Constructor; }
function step_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { step_get = Reflect.get; } else { step_get = function _get(target, property, receiver) { var base = step_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return step_get(target, property, receiver || target); }
function step_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = step_getPrototypeOf(object); if (object === null) break; } return object; }
function step_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) step_setPrototypeOf(subClass, superClass); }
function step_setPrototypeOf(o, p) { step_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return step_setPrototypeOf(o, p); }
function step_createSuper(Derived) { var hasNativeReflectConstruct = step_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = step_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = step_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return step_possibleConstructorReturn(this, result); }; }
function step_possibleConstructorReturn(self, call) { if (call && (step_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return step_assertThisInitialized(self); }
function step_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function step_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function step_getPrototypeOf(o) { step_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return step_getPrototypeOf(o); }
function step_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var Step = /*#__PURE__*/function (_HLargeToggle) {
  step_inherits(Step, _HLargeToggle);
  var _super = step_createSuper(Step);
  function Step() {
    var _this;
    step_classCallCheck(this, Step);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    step_defineProperty(step_assertThisInitialized(_this), "onChangeLayout", function (param) {
      var currentValue = _this.map.get(param);
      _this.map.set(param, !currentValue);
      if (param === 'show-arrow' && currentValue === true && _this.isCollapsed()) {
        _this.map.set('collapsed', false);
      }
    });
    return _this;
  }
  step_createClass(Step, [{
    key: "hasArrow",
    get: function get() {
      return this.map.get('show-arrow');
    }
  }, {
    key: "onRemoveBlot",
    value: function onRemoveBlot() {
      this.getWrapper().onRemoveBlot();
      step_get(step_getPrototypeOf(Step.prototype), "onRemoveBlot", this).call(this);
    }
  }, {
    key: "onBlotMenuUpdatePosition",
    value: function onBlotMenuUpdatePosition(_ref) {
      var left = _ref.left,
        top = _ref.top;
      var wrapper = this.getWrapper();
      if (wrapper) {
        left -= wrapper.getInnerLeftPadding();
        top -= this.domNode.getBoundingClientRect().top - wrapper.domNode.getBoundingClientRect().top;
      }
      return {
        left: left,
        top: top
      };
    }
  }, {
    key: "onGetCommentPosition",
    value: function onGetCommentPosition(_ref2) {
      var left = _ref2.left,
        top = _ref2.top;
      var wrapper = this.getWrapper();
      if (wrapper) {
        left += wrapper.getInnerRightPadding();
        top -= this.domNode.getBoundingClientRect().top - wrapper.domNode.getBoundingClientRect().top;
      }
      return {
        left: left,
        top: top
      };
    }
  }, {
    key: "getTitlePlaceholder",
    value: function getTitlePlaceholder() {
      return this.editor.plugins.i18n.get('step.title_placeholder');
    }
  }, {
    key: "getContentPlaceholder",
    value: function getContentPlaceholder() {
      return this.editor.plugins.i18n.get('step.content_placeholder');
    }
  }, {
    key: "contextMenu",
    get: function get() {
      var menu = Object.assign({}, step_get(step_getPrototypeOf(Step.prototype), "contextMenu", this));
      menu['layout'] = {
        label: this.editor.plugins.i18n.get('step.menu.step_layout.name'),
        index: 1,
        group: 0,
        stackable: false,
        action: false,
        submenu: step_defineProperty({}, 'show-arrow', {
          label: this.editor.plugins.i18n.get('step.menu.step_layout.show_arrow'),
          index: 1,
          group: 0,
          action: 'onChangeLayout',
          actionParams: 'show-arrow',
          icon: this.map.get('show-arrow') === true ? icons/* IconDone */.EZi : false,
          style: this.map.get('show-arrow') === true ? 'done' : 'undone'
        })
      };
      return menu;
    }
  }, {
    key: "onDraggingGetPhantomPos",
    value: function onDraggingGetPhantomPos() {
      return this.getWrapper().domNode.getBoundingClientRect();
    }
  }], [{
    key: "createBlot",
    value: function createBlot(editor) {
      var blot = parchment_default().create('stepWrapper');
      return blot;
    }
  }, {
    key: "initMap",
    value: function initMap(map, store) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      step_get(step_getPrototypeOf(Step), "initMap", this).call(this, map, store, params);
      map.set('show-arrow', true);
    }
  }]);
  return Step;
}(HLargeToggle);

Step.blotName = 'step';
Step.tagName = 'H3';
Step.tooltipPathSuffix = 'step';
// EXTERNAL MODULE: ./node_modules/dayjs/locale/ru.js
var locale_ru = __webpack_require__(96011);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/blots/step/stepWrapper.js
function stepWrapper_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { stepWrapper_typeof = function _typeof(obj) { return typeof obj; }; } else { stepWrapper_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return stepWrapper_typeof(obj); }




















function stepWrapper_slicedToArray(arr, i) { return stepWrapper_arrayWithHoles(arr) || stepWrapper_iterableToArrayLimit(arr, i) || stepWrapper_unsupportedIterableToArray(arr, i) || stepWrapper_nonIterableRest(); }
function stepWrapper_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function stepWrapper_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return stepWrapper_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return stepWrapper_arrayLikeToArray(o, minLen); }
function stepWrapper_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function stepWrapper_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function stepWrapper_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function stepWrapper_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function stepWrapper_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function stepWrapper_createClass(Constructor, protoProps, staticProps) { if (protoProps) stepWrapper_defineProperties(Constructor.prototype, protoProps); if (staticProps) stepWrapper_defineProperties(Constructor, staticProps); return Constructor; }
function stepWrapper_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { stepWrapper_get = Reflect.get; } else { stepWrapper_get = function _get(target, property, receiver) { var base = stepWrapper_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return stepWrapper_get(target, property, receiver || target); }
function stepWrapper_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = stepWrapper_getPrototypeOf(object); if (object === null) break; } return object; }
function stepWrapper_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) stepWrapper_setPrototypeOf(subClass, superClass); }
function stepWrapper_setPrototypeOf(o, p) { stepWrapper_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return stepWrapper_setPrototypeOf(o, p); }
function stepWrapper_createSuper(Derived) { var hasNativeReflectConstruct = stepWrapper_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = stepWrapper_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = stepWrapper_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return stepWrapper_possibleConstructorReturn(this, result); }; }
function stepWrapper_possibleConstructorReturn(self, call) { if (call && (stepWrapper_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return stepWrapper_assertThisInitialized(self); }
function stepWrapper_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function stepWrapper_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function stepWrapper_getPrototypeOf(o) { stepWrapper_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return stepWrapper_getPrototypeOf(o); }
function stepWrapper_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













var stepWrapper_mixin = mix([sizeaware]);
var StepWrapper = /*#__PURE__*/function (_mixin) {
  stepWrapper_inherits(StepWrapper, _mixin);
  var _super = stepWrapper_createSuper(StepWrapper);
  function StepWrapper(domNode) {
    var _this;
    stepWrapper_classCallCheck(this, StepWrapper);
    _this = _super.call(this, domNode);
    stepWrapper_defineProperty(stepWrapper_assertThisInitialized(_this), "onDocumentMouseDown", function (event) {
      // close embedded menu conditions
      if (_this.plusNode.contains(event.target)) return;
      if (_this.props.showEmbeddableMenu) {
        if (_this.editor.plugins.embeddedMenu && _this.editor.plugins.embeddedMenu.container) {
          if (event.target !== _this.editor.plugins.embeddedMenu.container && !_this.editor.plugins.embeddedMenu.container.contains(event.target)) {
            _this.setProps({
              showEmbeddableMenu: false
            });
          }
        }
      }
    });
    stepWrapper_defineProperty(stepWrapper_assertThisInitialized(_this), "onDateRef", function (node) {
      _this.dateNode = node;
    });
    stepWrapper_defineProperty(stepWrapper_assertThisInitialized(_this), "onAssigneeRef", function (node) {
      _this.assigneeNode = node;
    });
    stepWrapper_defineProperty(stepWrapper_assertThisInitialized(_this), "updateState", function () {
      if (!_this.getWrappedBlot() || !_this.getWrappedBlot().scroll.domNode.contains(_this.domNode) || !_this.stepNode) return;
      var number = _this.getStepNumber();
      _this.stepNode.setAttribute('data-step', number + 1);
    });
    stepWrapper_defineProperty(stepWrapper_assertThisInitialized(_this), "onEditorSelectionChange", function () {
      var _this$selection$getRa = _this.selection.getRange(),
        _this$selection$getRa2 = stepWrapper_slicedToArray(_this$selection$getRa, 1),
        range = _this$selection$getRa2[0];
      var currentIndex = _this.offset(_this.scroll);
      var currentLength = _this.length() - 1;
      if (range && range.index >= currentIndex && range.index + range.length <= currentIndex + currentLength) {
        if (!_this.domNode.classList.contains('step-active')) {
          _this.domNode.classList.add('step-active');
        }
      } else {
        if (_this.domNode.classList.contains('step-active')) {
          _this.domNode.classList.remove('step-active');
        }
      }
    });
    stepWrapper_defineProperty(stepWrapper_assertThisInitialized(_this), "onAddButtonClick", function () {
      var _this$editor$plugins$;
      if ((_this$editor$plugins$ = _this.editor.plugins.embeddedMenu) !== null && _this$editor$plugins$ !== void 0 && _this$editor$plugins$.enabled) {
        var showEmbeddableMenu = _this.props.showEmbeddableMenu;
        _this.setProps({
          showEmbeddableMenu: !showEmbeddableMenu
        });
      } else {
        _this.container.addBlot('step', {
          after: _this.id,
          focus: {
            index: 0
          },
          collapsed: false
        });
      }
    });
    stepWrapper_defineProperty(stepWrapper_assertThisInitialized(_this), "onAddButtonMouseDown", function (event) {
      event.preventDefault();
    });
    stepWrapper_defineProperty(stepWrapper_assertThisInitialized(_this), "onEmbeddedMenuHide", function () {
      _this.setProps({
        showEmbeddableMenu: false
      });
    });
    stepWrapper_defineProperty(stepWrapper_assertThisInitialized(_this), "onStepNumberRef", function (node) {
      _this.stepNode = node;
    });
    stepWrapper_defineProperty(stepWrapper_assertThisInitialized(_this), "onDateMouseDown", function (event) {
      if (_this.editor.mode === MODE_EDIT) {
        _this.setProps({
          datepickerOpen: true
        });
      }
    });
    stepWrapper_defineProperty(stepWrapper_assertThisInitialized(_this), "onDateTimePickerWantsToClose", function () {
      _this.setProps({
        datepickerOpen: false
      });
    });
    stepWrapper_defineProperty(stepWrapper_assertThisInitialized(_this), "onDateChange", function (value) {
      if (!value) {
        _this.map.delete('date');
        _this.map.delete('reminders');
      } else {
        var date = value.date,
          _value$reminders = value.reminders,
          reminders = _value$reminders === void 0 ? {} : _value$reminders,
          _value$showTime = value.showTime,
          showTime = _value$showTime === void 0 ? false : _value$showTime,
          _value$timeFormat = value.timeFormat,
          timeFormat = _value$timeFormat === void 0 ? 12 : _value$timeFormat;
        _this.map.set('date', {
          timestamp: date.getTime(),
          format: {
            showTime: showTime,
            timeFormat: timeFormat
          }
        });
        if (Object.keys(reminders).length) {
          _this.map.set('reminders', reminders);
        } else if (_this.map.get('reminders')) {
          _this.map.delete('reminders');
        }
      }
    });
    stepWrapper_defineProperty(stepWrapper_assertThisInitialized(_this), "getCorrectEmbeddedPos", function (_ref) {
      var top = _ref.top,
        left = _ref.left,
        width = _ref.width,
        height = _ref.height;
      var _this$embeddedMenuOff = _this.embeddedMenuOffset(),
        menuTop = _this$embeddedMenuOff.top;
      top += menuTop;
      height = 36;
      return {
        top: top,
        left: left,
        width: width,
        height: height
      };
    });
    stepWrapper_defineProperty(stepWrapper_assertThisInitialized(_this), "getDateString", function (timestamp, format) {
      var _this$editor$plugins, _this$editor$options$, _this$editor$options$2;
      var locale = (_this$editor$plugins = _this.editor.plugins) === null || _this$editor$plugins === void 0 ? void 0 : _this$editor$plugins.i18n.language;
      var timeLocale = (_this$editor$options$ = _this.editor.options.blots) === null || _this$editor$options$ === void 0 ? void 0 : (_this$editor$options$2 = _this$editor$options$.date) === null || _this$editor$options$2 === void 0 ? void 0 : _this$editor$options$2.timeLocale;
      var use12hFormat = timeLocale === 'en-US' ? true : timeLocale === 'en-GB' ? false : checkBrowserTimeFormat() === 12;
      return "".concat(dayjs_min_default()(timestamp).locale(locale === 'ru' ? locale : 'en').format('DD MMM'), "\n      ").concat(format.showTime ? dayjs_min_default()(timestamp).locale('en').format(use12hFormat ? ' hh:mm A' : ' HH:mm') : '');
    });
    stepWrapper_defineProperty(stepWrapper_assertThisInitialized(_this), "onAssigneeMouseDown", function (event) {
      if (_this.editor.mode === MODE_EDIT) {
        _this.setProps({
          showAssigneeSelect: true
        });
      }
    });
    stepWrapper_defineProperty(stepWrapper_assertThisInitialized(_this), "onAssigneeSelectWantsToClose", function () {
      _this.setProps({
        showAssigneeSelect: false
      });
    });
    stepWrapper_defineProperty(stepWrapper_assertThisInitialized(_this), "onAssigneeChange", function (value) {
      _this.map.set('assignee', value);
    });
    _this.domNode.classList.add('nimbus-step');
    _this.createInterface();
    _this.debouncedUpdateState = lodash_debounce_default()(_this.updateState, 1000, {
      trailing: true
    });
    _this.additionalEmbeddedMenu = true;
    return _this;
  }
  stepWrapper_createClass(StepWrapper, [{
    key: "createInterface",
    value: function createInterface() {
      this.stepHeader = document.createElement('div');
      this.stepHeader.classList.add('step-header');
      this.stepHeader.classList.add(util/* SELF_CONTROLLED_CONTENT_CLASS */.W$);
      this.stepHeader.setAttribute('contenteditable', false);
      this.domNode.appendChild(this.stepHeader);
      this.plusNode = document.createElement('div');
      this.plusNode.classList.add('toggle-plus');
      this.plusNode.classList.add(util/* SELF_CONTROLLED_CONTENT_CLASS */.W$);
      this.domNode.appendChild(this.plusNode);
    }
  }, {
    key: "buildBlot",
    value: function buildBlot() {
      var blot = parchment_default().create(this.map.get('type'));
      blot.map = this.map;
      this.appendChild(blot);
      this.updateState();
      this.editor.on('SCROLL_UPDATE', this.debouncedUpdateState);
      this.editor.on('updated-step-blot', this.updateState);
      this.editor.on('selectionchange', this.onEditorSelectionChange);
      if (this.map.get('collapsed') === true && this.map.get('show-arrow') === false) {
        this.map.set('collapsed', false);
      }
      document.addEventListener('mousedown', this.onDocumentMouseDown, false);
    }
  }, {
    key: "onRemoveBlot",
    value: function onRemoveBlot() {
      this.editor.off('SCROLL_UPDATE', this.debouncedUpdateState);
      this.editor.off('updated-step-blot', this.updateState);
      this.editor.off('selectionchange', this.onEditorSelectionChange);
      document.removeEventListener('mousedown', this.onDocumentMouseDown, false);
    }
  }, {
    key: "getStepNumber",
    value: function getStepNumber() {
      var _this2 = this;
      return this.editor.scroll.descendants(function (blot) {
        return blot.constructor.blotName === 'step';
      }).map(function (blot) {
        return blot.id;
      }).findIndex(function (id) {
        return id === _this2.id;
      });
    }
  }, {
    key: "onGetContentCommentPos",
    value: function onGetContentCommentPos(_ref2) {
      var left = _ref2.left,
        top = _ref2.top;
      left += 27;
      return {
        top: top,
        left: left
      };
    }
  }, {
    key: "getInnerLeftPadding",
    value: function getInnerLeftPadding() {
      var _this$domNode$getBoun = this.domNode.getBoundingClientRect(),
        wrapperX = _this$domNode$getBoun.left;
      var _this$getWrappedBlot$ = this.getWrappedBlot().domNode.getBoundingClientRect(),
        contentX = _this$getWrappedBlot$.left;
      return contentX - wrapperX;
    }
  }, {
    key: "getInnerRightPadding",
    value: function getInnerRightPadding() {
      var _this$domNode$getBoun2 = this.domNode.getBoundingClientRect(),
        wrapperX = _this$domNode$getBoun2.right;
      var _this$getWrappedBlot$2 = this.getWrappedBlot().domNode.getBoundingClientRect(),
        contentX = _this$getWrappedBlot$2.right;
      return wrapperX - contentX;
    }
  }, {
    key: "embeddedMenuOffset",
    value: function embeddedMenuOffset() {
      return {
        top: this.domNode.getBoundingClientRect().bottom - this.domNode.getBoundingClientRect().top + 19,
        left: 0
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$maxAvaila;
      stepWrapper_get(stepWrapper_getPrototypeOf(StepWrapper.prototype), "render", this).call(this);
      var isEditMode = this.editor.mode === MODE_EDIT;
      if (this.map.get('show-arrow') === true) {
        if (!this.domNode.classList.contains('collapsible')) {
          this.domNode.classList.add('collapsible');
        }
      } else {
        if (this.domNode.classList.contains('collapsible')) {
          this.domNode.classList.remove('collapsible');
        }
      }
      if (this.map.get('collapsed') === true) {
        if (!this.domNode.classList.contains('is-collapsed')) {
          this.domNode.classList.add('is-collapsed');
        }
      } else {
        if (this.domNode.classList.contains('is-collapsed')) {
          this.domNode.classList.remove('is-collapsed');
        }
      }
      if (this.props.showEmbeddableMenu) {
        if (!this.domNode.classList.contains('show-embedded-menu')) {
          this.domNode.classList.add('show-embedded-menu');
        }
      } else {
        if (this.domNode.classList.contains('show-embedded-menu')) {
          this.domNode.classList.remove('show-embedded-menu');
        }
      }
      if (isEditMode) {
        if (this.props.showEmbeddableMenu) {
          this.editor.plugins.embeddedMenu.show(this, {
            maxWidth: 446,
            containerAddClassName: 'step-embedded-menu',
            addFullViewMenuItems: ['add-step']
          });
        } else {
          this.editor.plugins.embeddedMenu.hide(this);
        }
      }
      var width = (_this$props$maxAvaila = this.props.maxAvailableWidth) !== null && _this$props$maxAvaila !== void 0 ? _this$props$maxAvaila : this.domNode.offsetWidth;
      if (width < 230) {
        if (!this.stepHeader.classList.contains('no-padding')) {
          this.stepHeader.classList.add('no-padding');
        }
      } else {
        if (this.stepHeader.classList.contains('no-padding')) {
          this.stepHeader.classList.remove('no-padding');
        }
      }
      var renderDateAndAssignee = isEditMode || this.map.get('date') || this.map.get('assignee') && this.map.get('assignee').length;
      (0,preact_module/* render */.sY)((0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)("div", {
        className: "step-header-left"
      }, (0,preact_module.h)("div", {
        className: "step-number toggle-step",
        ref: this.onStepNumberRef
      })), renderDateAndAssignee ? (0,preact_module.h)("div", {
        className: 'step-header-right' + (width < 480 ? ' right-full-width' : '')
      }, (0,preact_module.h)(StepDateComponent, {
        blot: this
      }), (0,preact_module.h)(StepAssigneeComponent, {
        blot: this
      })) : null), this.stepHeader);
      (0,preact_module/* render */.sY)((0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)("span", {
        className: "toggle-plus-icon",
        onClick: this.onAddButtonClick,
        onMouseDown: this.onAddButtonMouseDown
      }, (0,preact_module.h)(icons/* IconPlus */.SC9, null))), this.plusNode);
    }
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      var html = [];
      this.children.forEach(function (blot) {
        if (blot.toHTML) {
          html.push(blot.toHTML(context));
        }
      });
      var arrowHtml = this.map.get('show-arrow') === true ? '<div class="toggle-arrow step">' + this.arrowNode.innerHTML + '</div>' : '';
      var classNames = [TOGGLE_WRAPPER_CLASS_NAME, 'nimbus-step'];
      if (this.map.get('show-arrow') === true) {
        classNames.push('collapsible');
      }
      if (this.map.get('show-border') === true) {
        classNames.push('is-bordered');
      }
      var stepHtml = this.map.get('show-number') === true ? '<div class="toggle-step" data-step="' + (this.getStepNumber() + 1) + '"></div>' : '';
      return '<div class="' + classNames.join(' ') + '">' + arrowHtml + stepHtml + html.join('') + '</div>';
    }
  }]);
  return StepWrapper;
}(stepWrapper_mixin(toggleWrapper));

StepWrapper.blotName = 'stepWrapper';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/parchment.js













































































parchment_default().register(blots_scroll);
parchment_default().register(paragraph);
parchment_default().register(hLarge);
parchment_default().register(hMedium);
parchment_default().register(hSmall);
parchment_default().register(blockquote);
parchment_default().register(hint);
parchment_default().register(blots_break);
parchment_default().register(linebreak);
parchment_default().register(text_Text);
parchment_default().register(cursor);
parchment_default().register(inline);
parchment_default().register(bold);
parchment_default().register(italic);
parchment_default().register(underline);
parchment_default().register(strikethrough);
parchment_default().register(Color);
parchment_default().register(Background);
parchment_default().register(ButtonSingle);
parchment_default().register(Link);
parchment_default().register(code);
parchment_default().register(Placeholder);
parchment_default().register(comment);
parchment_default().register(tableWrapper);
parchment_default().register(table_table);
parchment_default().register(TableBodyEmbed);
parchment_default().register(tableBlotEditCell);
parchment_default().register(TableBlotEditText);
parchment_default().register(attachment_image);
parchment_default().register(ImageWrapper);
parchment_default().register(file);
parchment_default().register(FileWrapper);
parchment_default().register(Caption);
parchment_default().register(RemoteFrame);
parchment_default().register(RemoteFrameWrapper);
parchment_default().register(RemoteFile);
parchment_default().register(RemoteFileWrapper);
parchment_default().register(blots_grid);
parchment_default().register(blots_gridCol);
parchment_default().register(list_list);
parchment_default().register(ListText);
parchment_default().register(listItemBullet);
parchment_default().register(listItemNumber);
parchment_default().register(listItemCheckbox);
parchment_default().register(hLine);
parchment_default().register(SyntaxWrapper);
parchment_default().register(Syntax);
parchment_default().register(date_Date);
parchment_default().register(Mention);
parchment_default().register(Button);
parchment_default().register(Progress);
parchment_default().register(DropdownList);
parchment_default().register(businessCard);
parchment_default().register(bookmark);
parchment_default().register(Outline);
parchment_default().register(html);
parchment_default().register(loader);
parchment_default().register(toggle);
parchment_default().register(toggleWrapper);
parchment_default().register(toggleContent);
parchment_default().register(primary);
parchment_default().register(paragraphV2);
parchment_default().register(newTextLine);
parchment_default().register(TasksList);
parchment_default().register(Board);
parchment_default().register(HLargeToggle);
parchment_default().register(HMediumToggle);
parchment_default().register(HSmallToggle);
parchment_default().register(uploader);
parchment_default().register(UploaderHead);
parchment_default().register(uploaderWrapper);
parchment_default().register(uploaderContent);
parchment_default().register(Step);
parchment_default().register(StepWrapper);
parchment_default().register(StepAggregator);
(parchment_default()).findById = function (id) {
  var el = document.getElementById(id);
  return parchment_default().find(el);
};
parchment_default().setFindByTagFn(function (tag) {
  if (tag === 'DIV') {
    return paragraph;
  }
  return null;
});
/* harmony default export */ const src_parchment = ((parchment_default()));
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.string.replace-all.js
var esnext_string_replace_all = __webpack_require__(27207);
// EXTERNAL MODULE: ./node_modules/simple-color-picker/src/index.js
var simple_color_picker_src = __webpack_require__(88692);
// EXTERNAL MODULE: ./node_modules/lodash.chunk/index.js
var lodash_chunk = __webpack_require__(60764);
var lodash_chunk_default = /*#__PURE__*/__webpack_require__.n(lodash_chunk);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/dev-page/server.js

function request(method, url) {
  var content = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open(method, url);
    xhr.onload = function () {
      var content;
      try {
        content = JSON.parse(xhr.responseText);
      } catch (err) {
        return reject(err);
      }
      resolve(content);
    };
    xhr.onerror = function (err) {
      reject(err);
    };
    if (typeof content === 'string') {
      xhr.setRequestHeader('Content-Type', 'application/json');
    }
    xhr.send(content);
  });
}
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/dev-page/util.js
var dev_page_util = __webpack_require__(2049);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/dev-page/toolbar/cta/cta.css
var cta = __webpack_require__(76922);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/dev-page/toolbar/cta/index.js
function cta_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { cta_typeof = function _typeof(obj) { return typeof obj; }; } else { cta_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return cta_typeof(obj); }
function cta_slicedToArray(arr, i) { return cta_arrayWithHoles(arr) || cta_iterableToArrayLimit(arr, i) || cta_unsupportedIterableToArray(arr, i) || cta_nonIterableRest(); }
function cta_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function cta_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return cta_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return cta_arrayLikeToArray(o, minLen); }
function cta_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function cta_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function cta_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function cta_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function cta_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { cta_ownKeys(Object(source), true).forEach(function (key) { cta_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { cta_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function cta_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function cta_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { cta_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { cta_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
























function cta_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function cta_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function cta_createClass(Constructor, protoProps, staticProps) { if (protoProps) cta_defineProperties(Constructor.prototype, protoProps); if (staticProps) cta_defineProperties(Constructor, staticProps); return Constructor; }
function cta_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) cta_setPrototypeOf(subClass, superClass); }
function cta_setPrototypeOf(o, p) { cta_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return cta_setPrototypeOf(o, p); }
function cta_createSuper(Derived) { var hasNativeReflectConstruct = cta_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = cta_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = cta_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return cta_possibleConstructorReturn(this, result); }; }
function cta_possibleConstructorReturn(self, call) { if (call && (cta_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return cta_assertThisInitialized(self); }
function cta_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function cta_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function cta_getPrototypeOf(o) { cta_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return cta_getPrototypeOf(o); }
function cta_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var params = {
  buttonNode: null,
  formNode: null,
  show: false
};
var bgColors = ['bondi-blue', 'bleu-de-france', 'neon-carrot', 'sunglow', 'carmine-pink', 'dollar-bill', 'light-pastel-purple'];
var cta_Button = function Button() {
  return (0,preact_module.h)("button", {
    onClick: function onClick() {
      return showCtaForm(true);
    }
  }, "Add CTA");
};
var showCtaForm = function showCtaForm(show) {
  (0,preact_module/* render */.sY)((0,preact_module.h)(CtaForm, {
    show: show
  }), params.formNode);
};
var addCtaButton = function addCtaButton(_ref) {
  var appendItem = _ref.appendItem;
  params.buttonNode = document.createElement('div');
  params.formNode = document.createElement('div');
  (0,preact_module/* render */.sY)((0,preact_module.h)(cta_Button, null), params.buttonNode);
  appendItem(params.buttonNode);
  document.body.appendChild(params.formNode);
};
var CtaForm = /*#__PURE__*/function (_Component) {
  cta_inherits(CtaForm, _Component);
  var _super = cta_createSuper(CtaForm);
  function CtaForm() {
    var _this;
    cta_classCallCheck(this, CtaForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    cta_defineProperty(cta_assertThisInitialized(_this), "state", {
      whenToShow: 'pause',
      type: 'button',
      title: 'Try it for free for 2 weeks!',
      buttonId: 'ctabutton_bac1c8da',
      address: 'https://nimbusweb.me',
      background: bgColors[0],
      buttonShape: 'rounded',
      buttonSize: 'small',
      description: "You don't have to specify the card right away \uD83D\uDE09\nSome text after!",
      imageUrl: 'https://media.springernature.com/full/springer-cms/rest/v1/img/18893370/v1/height/700',
      imageName: '',
      showPlayAgain: false
    });
    cta_defineProperty(cta_assertThisInitialized(_this), "onSave", /*#__PURE__*/cta_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var editor, blocks, items, blotId, blot, b, svState, confirm, props;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              editor = window.gEditor;
              blocks = editor.store.blocks.toJSON();
              items = [];
              _context.t0 = regeneratorRuntime.keys(blocks);
            case 4:
              if ((_context.t1 = _context.t0()).done) {
                _context.next = 26;
                break;
              }
              blotId = _context.t1.value;
              blot = editor.store.blocks.get(blotId);
              if (!(blot.get('type') === 'file')) {
                _context.next = 24;
                break;
              }
              b = editor.findById(blotId);
              if (!(b !== null && b !== void 0 && b.isVideoFile())) {
                _context.next = 24;
                break;
              }
              svState = b.map.get('syncedViewerState');
              if (!(svState.get('motionVideo') || svState.get('loop'))) {
                _context.next = 23;
                break;
              }
              showCtaForm(false);
              _context.next = 15;
              return _this.processToShowDialog(editor, {
                title: "Motion/Loop (".concat(blotId, ")"),
                message: 'Для видео включен режим Motion/Loop. CTA не будет работать при таком режиме. Отключите опцию, чтобы активировать CTA.'
              });
            case 15:
              confirm = _context.sent;
              if (!confirm) {
                _context.next = 22;
                break;
              }
              props = {
                motionVideo: false,
                loop: false,
                autoplay: false,
                hideControls: false,
                videoShadow: false
              };
              b.setViewerSyncedState(props);
              b.props.attachment = cta_objectSpread(cta_objectSpread({}, b.props.attachment), props);
              _context.next = 23;
              break;
            case 22:
              return _context.abrupt("continue", 4);
            case 23:
              items.push(cta_objectSpread({
                blotId: blotId,
                attachmentGlobalId: blot.get('attachmentGlobalId')
              }, _this.state));
            case 24:
              _context.next = 4;
              break;
            case 26:
              editor.plugins.ctaManager.setCta(items);
              showCtaForm(false);
            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    cta_defineProperty(cta_assertThisInitialized(_this), "processToShowDialog", /*#__PURE__*/function () {
      var _ref4 = cta_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(editor, _ref3) {
        var title, message, _editor$plugins, popupManager, i18n, confirm, result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                title = _ref3.title, message = _ref3.message;
                _editor$plugins = editor.plugins, popupManager = _editor$plugins.popupManager, i18n = _editor$plugins.i18n;
                confirm = null;
                _context2.next = 5;
                return new Promise(function (resolve) {
                  var onCancel = function onCancel() {
                    resolve(false);
                  };
                  var onConfirm = function onConfirm() {
                    resolve(true);
                  };
                  confirm = (0,preact_module.h)(confirmPopup/* default */.Z, {
                    onCancel: onCancel,
                    onConfirm: onConfirm,
                    title: title,
                    message: message,
                    confirmText: "\u041E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C Motion/Loop",
                    cancelText: 'Отмена',
                    editor: editor
                  });
                  popupManager.dialog(confirm);
                });
              case 5:
                result = _context2.sent;
                confirm = null;
                popupManager.dialog(null);
                return _context2.abrupt("return", result);
              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return function (_x, _x2) {
        return _ref4.apply(this, arguments);
      };
    }());
    cta_defineProperty(cta_assertThisInitialized(_this), "onFieldChange", function (name) {
      return function (e) {
        _this.setState(cta_defineProperty({}, name, e.target.value));
      };
    });
    cta_defineProperty(cta_assertThisInitialized(_this), "getRadio", function (name, items, active) {
      return items.map(function (_ref5) {
        var title = _ref5.title,
          value = _ref5.value;
        return (0,preact_module.h)("label", null, (0,preact_module.h)("input", {
          type: "radio",
          name: name,
          value: value,
          onChange: _this.onFieldChange(name),
          checked: value === active
        }), " ", title);
      });
    });
    cta_defineProperty(cta_assertThisInitialized(_this), "getBackground", function (background) {
      return bgColors.map(function (color) {
        var cls = ['toolbar-cta-form__bg'];
        if (color === background) cls.push('toolbar-cta-form__bg_active');
        return (0,preact_module.h)("div", {
          className: cls.join(' '),
          onClick: function onClick() {
            return _this.onFieldChange('background')({
              target: {
                value: color
              }
            });
          },
          style: {
            backgroundColor: "var(--".concat(color, ")")
          }
        });
      });
    });
    cta_defineProperty(cta_assertThisInitialized(_this), "onFileChange", function (e) {
      var reader = new FileReader();
      reader.onloadend = function () {
        var _e$target$files$ = e.target.files[0],
          size = _e$target$files$.size,
          name = _e$target$files$.name;
        var _name$split = name.split(/\.([^.]+)$/i),
          _name$split2 = cta_slicedToArray(_name$split, 2),
          ext = _name$split2[1];
        var allowExt = ['png', 'jpeg', 'jpg'];
        var maxFileSizeKb = 5000;
        if (size / 1024 > maxFileSizeKb || !allowExt.includes(ext)) {
          alert('Max file size 5M');
          _this.setState({
            imageName: '',
            imageUrl: ''
          });
          return false;
        } else {
          _this.setState({
            imageUrl: reader.result,
            imageName: e.target.files[0].name
          });
        }
      };
      if (e.target.files.length) {
        reader.readAsDataURL(e.target.files[0]);
      } else {
        _this.setState({
          imageUrl: '',
          imageName: '',
          imageBase64: null
        });
      }
    });
    return _this;
  }
  cta_createClass(CtaForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var show = this.props.show;
      if (!show) return null;
      var _this$state = this.state,
        whenToShow = _this$state.whenToShow,
        type = _this$state.type,
        title = _this$state.title,
        background = _this$state.background,
        buttonShape = _this$state.buttonShape,
        buttonSize = _this$state.buttonSize,
        description = _this$state.description,
        address = _this$state.address,
        imageUrl = _this$state.imageUrl,
        showPlayAgain = _this$state.showPlayAgain;
      return (0,preact_module.h)("div", {
        className: "toolbar-cta-form"
      }, (0,preact_module.h)("div", {
        className: "toolbar-cta-form__form toolbar-cta-form__body_".concat(type)
      }, (0,preact_module.h)("div", {
        className: "toolbar-cta-form-title"
      }, "Call to Action"), (0,preact_module.h)("div", {
        className: "toolbar-cta-form__row"
      }, (0,preact_module.h)("div", {
        className: "toolbar-cta-form__row-title"
      }, "Time"), this.getRadio('whenToShow', [{
        title: 'During a pause',
        value: 'pause'
      }, {
        title: 'At the end',
        value: 'end'
      }], whenToShow)), (0,preact_module.h)("div", {
        className: "toolbar-cta-form__row"
      }, (0,preact_module.h)("div", {
        className: "toolbar-cta-form__row-title"
      }, "Type"), this.getRadio('type', [{
        title: 'Button',
        value: 'button'
      }, {
        title: 'Image',
        value: 'image'
      }], type)), (0,preact_module.h)("div", {
        className: "toolbar-cta-form__type toolbar-cta-form__type_button"
      }, (0,preact_module.h)("div", {
        className: "toolbar-cta-form__row"
      }, (0,preact_module.h)("div", {
        className: "toolbar-cta-form__row-title"
      }, "Title"), (0,preact_module.h)("input", {
        type: "text",
        name: "title",
        onInput: this.onFieldChange('title'),
        value: title,
        className: "toolbar-cta-form__input"
      })), (0,preact_module.h)("div", {
        className: "toolbar-cta-form__row"
      }, (0,preact_module.h)("div", {
        className: "toolbar-cta-form__row-title"
      }, "Link"), (0,preact_module.h)("input", {
        type: "text",
        name: "address",
        onInput: this.onFieldChange('address'),
        value: address,
        className: "toolbar-cta-form__input"
      })), (0,preact_module.h)("div", {
        className: "toolbar-cta-form__row"
      }, (0,preact_module.h)("div", {
        className: "toolbar-cta-form__row-title"
      }, "Shape"), this.getRadio('buttonShape', [{
        title: 'Rouded',
        value: 'rounded'
      }, {
        title: 'Square',
        value: 'square'
      }], buttonShape)), (0,preact_module.h)("div", {
        className: "toolbar-cta-form__row"
      }, (0,preact_module.h)("div", {
        className: "toolbar-cta-form__row-title"
      }, "Background"), (0,preact_module.h)("div", null, this.getBackground(background))), (0,preact_module.h)("div", {
        className: "toolbar-cta-form__row"
      }, (0,preact_module.h)("div", {
        className: "toolbar-cta-form__row-title"
      }, "Size"), this.getRadio('buttonSize', [{
        title: 'Small',
        value: 'small'
      }, {
        title: 'Medium',
        value: 'medium'
      }, {
        title: 'Big',
        value: 'big'
      }], buttonSize)), (0,preact_module.h)("div", {
        className: "toolbar-cta-form__row"
      }, (0,preact_module.h)("div", {
        className: "toolbar-cta-form__row-title"
      }, "Description"), (0,preact_module.h)("textarea", {
        rows: "6",
        name: "description",
        onInput: this.onFieldChange('description'),
        value: description,
        className: "toolbar-cta-form__input"
      }))), (0,preact_module.h)("div", {
        className: "toolbar-cta-form__type toolbar-cta-form__type_image"
      }, (0,preact_module.h)("div", {
        className: "toolbar-cta-form__row"
      }, (0,preact_module.h)("input", {
        type: "file",
        onChange: this.onFileChange,
        name: "image"
      })), (0,preact_module.h)("div", {
        className: "toolbar-cta-form__row"
      }, (0,preact_module.h)("img", {
        src: imageUrl,
        className: "toolbar-cta-form__image"
      })), (0,preact_module.h)("div", {
        className: "toolbar-cta-form__row"
      }, (0,preact_module.h)("div", {
        className: "toolbar-cta-form__row-title"
      }, "Link"), (0,preact_module.h)("input", {
        type: "text",
        name: "link",
        onInput: this.onFieldChange('address'),
        value: address,
        className: "toolbar-cta-form__input"
      }))), whenToShow === 'end' ? (0,preact_module.h)("div", {
        className: "toolbar-cta-form__row"
      }, (0,preact_module.h)("label", null, (0,preact_module.h)("input", {
        type: "checkbox",
        onChange: function onChange(e) {
          _this2.onFieldChange('showPlayAgain')({
            target: {
              value: e.target.checked
            }
          });
        },
        checked: showPlayAgain
      }), " Show \"Play again\" button")) : null, (0,preact_module.h)("div", {
        className: "toolbar-cta-form__row toolbar-cta-form__buttons"
      }, (0,preact_module.h)("button", {
        onClick: function onClick() {
          return showCtaForm(false);
        }
      }, "Cancel"), (0,preact_module.h)("button", {
        onClick: this.onSave
      }, "Save Call-to-Action"))));
    }
  }]);
  return CtaForm;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/featureAvailabilityIcon.js
function featureAvailabilityIcon_extends() { featureAvailabilityIcon_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return featureAvailabilityIcon_extends.apply(this, arguments); }
function featureAvailabilityIcon_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












function featureAvailabilityIcon_slicedToArray(arr, i) { return featureAvailabilityIcon_arrayWithHoles(arr) || featureAvailabilityIcon_iterableToArrayLimit(arr, i) || featureAvailabilityIcon_unsupportedIterableToArray(arr, i) || featureAvailabilityIcon_nonIterableRest(); }
function featureAvailabilityIcon_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function featureAvailabilityIcon_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return featureAvailabilityIcon_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return featureAvailabilityIcon_arrayLikeToArray(o, minLen); }
function featureAvailabilityIcon_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function featureAvailabilityIcon_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function featureAvailabilityIcon_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




var FeatureAvailabilityIcon = function FeatureAvailabilityIcon(props) {
  var availability = props.availability,
    type = props.type,
    editor = props.editor,
    emitter = props.emitter;
  var lottieRef = (0,hooks_module/* useRef */.sO)(null);
  var _useState = (0,hooks_module/* useState */.eJ)(null),
    _useState2 = featureAvailabilityIcon_slicedToArray(_useState, 2),
    animation = _useState2[0],
    setAnimation = _useState2[1];
  (0,hooks_module/* useEffect */.d4)(function () {
    var container = lottieRef.current;
    var lottieInstance = lottie.loadAnimation({
      container: container,
      autoplay: false,
      loop: false,
      renderer: 'svg',
      path: editor.plugins.featuresAvailabilityPlugin.options.animationPath[type],
      rendererSettings: {
        viewBoxOnly: true
      }
    });
    setAnimation(lottieInstance);
    if (availability === AVAILABILITY_STATUS.trial) {
      lottieInstance.addEventListener('data_ready', function () {
        lottieInstance.goToAndStop(6, true);
      });
    }
    return function () {
      emitter.off('enter', onEnter);
      emitter.off('leave', onLeave);
    };
  }, []);
  var onEnter = (0,hooks_module/* useCallback */.I4)(function () {
    if (!animation) return;
    if (availability === AVAILABILITY_STATUS.notAvailable) {
      animation.playSegments([0, 6], true);
    }
    if (availability === AVAILABILITY_STATUS.trial) {
      animation.playSegments([0, 6], true);
    }
  }, [animation]);
  var onLeave = (0,hooks_module/* useCallback */.I4)(function () {
    if (!animation) return;
    if (availability === AVAILABILITY_STATUS.notAvailable) {
      animation.playSegments([6, 0], false);
    }
  }, [animation]);
  (0,hooks_module/* useEffect */.d4)(function () {
    if (emitter && animation) {
      emitter.on('enter', onEnter);
      emitter.on('leave', onLeave);
    }
  }, [emitter, animation]);
  return (0,preact_module.h)("div", featureAvailabilityIcon_extends({
    className: "feature-availability-icon"
  }, featureAvailabilityIcon_defineProperty({}, tooltipManager/* TOOLTIP_ATTR */.qZ, editor.plugins.i18n.get("feature_availability.".concat(type, ".").concat(availability)))), (0,preact_module.h)("div", {
    className: "feature-availability-icon__icon",
    ref: lottieRef
  }));
};
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/featuresAvailabilityPlugin/index.js






function featuresAvailabilityPlugin_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function featuresAvailabilityPlugin_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { featuresAvailabilityPlugin_ownKeys(Object(source), true).forEach(function (key) { featuresAvailabilityPlugin_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { featuresAvailabilityPlugin_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function featuresAvailabilityPlugin_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function featuresAvailabilityPlugin_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function featuresAvailabilityPlugin_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function featuresAvailabilityPlugin_createClass(Constructor, protoProps, staticProps) { if (protoProps) featuresAvailabilityPlugin_defineProperties(Constructor.prototype, protoProps); if (staticProps) featuresAvailabilityPlugin_defineProperties(Constructor, staticProps); return Constructor; }


var AVAILABILITY_STATUS = {
  available: 'available',
  notAvailable: 'not-available',
  trial: 'trial'
};
var AVAILABILITY_TYPE = {
  plus: 'plus',
  team: 'team',
  business2023: 'business2023'
};

/**
 * Плагин для получения доступности фич
 */
var FeaturesAvailabilityPlugin = /*#__PURE__*/function () {
  /**
   * Конструктор класса FeaturesAvailabilityPlugin
   * @param {Object} params
   * @param {Object} params.scroll
   * @param {Object} params.editor
   * @param {Object} paarms.options
   * @param {Object} params.options.features
   */
  function FeaturesAvailabilityPlugin(_ref) {
    var scroll = _ref.scroll,
      editor = _ref.editor,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;
    featuresAvailabilityPlugin_classCallCheck(this, FeaturesAvailabilityPlugin);
    this.editor = editor;
    this.scroll = scroll;
    this.options = featuresAvailabilityPlugin_objectSpread({
      enabled: false,
      animationPath: {
        plus: 'https://nimbus-upload.s3.amazonaws.com/diamond-animation/animation-blue.json',
        team: 'https://nimbus-upload.s3.amazonaws.com/diamond-animation/animation-yellow.json',
        business2023: 'https://nimbus-upload.s3.amazonaws.com/diamond-animation/animation-yellow.json'
      }
    }, options);
    this.features = options.features || {};
  }

  /**
   * Установить доступность фич
   * @param {Object} features 
   */
  featuresAvailabilityPlugin_createClass(FeaturesAvailabilityPlugin, [{
    key: "setFeatures",
    value: function setFeatures() {
      var features = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.features = features;
    }

    /**
     * Возвращает доступность фичи
     * @param {String} key 
     * @returns 'available' | 'trial' | 'not-available'
     */
  }, {
    key: "getFeature",
    value: function getFeature(key) {
      return this.features[key];
    }
  }, {
    key: "getFeatureIcon",
    value: function getFeatureIcon(key, emitter) {
      if (!this.options.enabled) return false;
      var availability = this.getFeature(key);
      var featureIcon = null;
      if (availability && availability.status && availability.status !== AVAILABILITY_STATUS.available) {
        featureIcon = (0,preact_module.h)(FeatureAvailabilityIcon, {
          type: availability.type,
          availability: availability.status,
          editor: this.editor,
          emitter: emitter
        });
      }
      return featureIcon;
    }
  }]);
  return FeaturesAvailabilityPlugin;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/dev-page/toolbar/featuresAvailability/index.js
function featuresAvailability_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { featuresAvailability_typeof = function _typeof(obj) { return typeof obj; }; } else { featuresAvailability_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return featuresAvailability_typeof(obj); }
function featuresAvailability_toConsumableArray(arr) { return featuresAvailability_arrayWithoutHoles(arr) || featuresAvailability_iterableToArray(arr) || featuresAvailability_unsupportedIterableToArray(arr) || featuresAvailability_nonIterableSpread(); }
function featuresAvailability_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function featuresAvailability_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return featuresAvailability_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return featuresAvailability_arrayLikeToArray(o, minLen); }
function featuresAvailability_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function featuresAvailability_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return featuresAvailability_arrayLikeToArray(arr); }
function featuresAvailability_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }




















function featuresAvailability_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function featuresAvailability_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function featuresAvailability_createClass(Constructor, protoProps, staticProps) { if (protoProps) featuresAvailability_defineProperties(Constructor.prototype, protoProps); if (staticProps) featuresAvailability_defineProperties(Constructor, staticProps); return Constructor; }
function featuresAvailability_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) featuresAvailability_setPrototypeOf(subClass, superClass); }
function featuresAvailability_setPrototypeOf(o, p) { featuresAvailability_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return featuresAvailability_setPrototypeOf(o, p); }
function featuresAvailability_createSuper(Derived) { var hasNativeReflectConstruct = featuresAvailability_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = featuresAvailability_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = featuresAvailability_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return featuresAvailability_possibleConstructorReturn(this, result); }; }
function featuresAvailability_possibleConstructorReturn(self, call) { if (call && (featuresAvailability_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return featuresAvailability_assertThisInitialized(self); }
function featuresAvailability_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function featuresAvailability_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function featuresAvailability_getPrototypeOf(o) { featuresAvailability_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return featuresAvailability_getPrototypeOf(o); }
function featuresAvailability_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function featuresAvailability_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { featuresAvailability_ownKeys(Object(source), true).forEach(function (key) { featuresAvailability_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { featuresAvailability_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function featuresAvailability_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var featuresAvailability_params = {
  buttonNode: null,
  formNode: null,
  show: false
};
var featuresAvailability_Button = function Button() {
  return (0,preact_module.h)("button", {
    onClick: showFeaturesForm(true)
  }, "Features Availability");
};
var showFeaturesForm = function showFeaturesForm(show) {
  return function (event) {
    var position = {
      top: event.clientY + 'px',
      left: event.clientX + 'px'
    };
    (0,preact_module/* render */.sY)((0,preact_module.h)(FeaturesAvailability, {
      show: show,
      position: position
    }), featuresAvailability_params.formNode);
  };
};
var storageKey = 'dev-toolbar-features-availability';
var initialFeatures = {
  'get-text-from-image': {
    status: AVAILABILITY_STATUS.available,
    type: AVAILABILITY_TYPE.plus,
    privilege: 'canOCR'
  },
  'blocks-lock': {
    status: AVAILABILITY_STATUS.available,
    type: AVAILABILITY_TYPE.team,
    privilege: 'canAccessBlotLocking'
  },
  'preview-video': {
    status: AVAILABILITY_STATUS.available,
    type: AVAILABILITY_TYPE.plus,
    privilege: 'canGenerateVideoPreview'
  }
};
var getFeaturesFromStorage = function getFeaturesFromStorage() {
  var storage = window.localStorage.getItem(storageKey) || null;
  var features = initialFeatures;
  if (storage) {
    features = featuresAvailability_objectSpread(featuresAvailability_objectSpread({}, initialFeatures), JSON.parse(storage));
  }
  return features;
};
var addFeaturesAvailabilityButton = function addFeaturesAvailabilityButton(_ref) {
  var appendItem = _ref.appendItem;
  featuresAvailability_params.buttonNode = document.createElement('div');
  featuresAvailability_params.formNode = document.createElement('div');
  (0,preact_module/* render */.sY)((0,preact_module.h)(featuresAvailability_Button, null), featuresAvailability_params.buttonNode);
  appendItem(featuresAvailability_params.buttonNode);
  document.body.appendChild(featuresAvailability_params.formNode);
};
var FeaturesAvailability = /*#__PURE__*/function (_Component) {
  featuresAvailability_inherits(FeaturesAvailability, _Component);
  var _super = featuresAvailability_createSuper(FeaturesAvailability);
  function FeaturesAvailability(props) {
    var _this;
    featuresAvailability_classCallCheck(this, FeaturesAvailability);
    _this = _super.call(this, props);
    featuresAvailability_defineProperty(featuresAvailability_assertThisInitialized(_this), "formRef", null);
    featuresAvailability_defineProperty(featuresAvailability_assertThisInitialized(_this), "onRef", function (ref) {
      _this.formRef = ref;
    });
    featuresAvailability_defineProperty(featuresAvailability_assertThisInitialized(_this), "onDocumentClick", function (event) {
      if (_this.props.show && _this.formRef && !_this.formRef.contains(event.target)) {
        showFeaturesForm(false)({});
      }
    });
    featuresAvailability_defineProperty(featuresAvailability_assertThisInitialized(_this), "componentDidMount", function () {
      document.addEventListener('mousedown', _this.onDocumentClick);
    });
    featuresAvailability_defineProperty(featuresAvailability_assertThisInitialized(_this), "onCloseClick", function () {
      showFeaturesForm(false)({});
    });
    featuresAvailability_defineProperty(featuresAvailability_assertThisInitialized(_this), "loadFeatures", function () {
      var features = getFeaturesFromStorage();
      _this.setState({
        features: features
      });
      window.gEditor.plugins.featuresAvailabilityPlugin.setFeatures(features);
    });
    featuresAvailability_defineProperty(featuresAvailability_assertThisInitialized(_this), "onChange", function (code, prop) {
      return function (event) {
        var value = event.target.value;
        var feature = featuresAvailability_objectSpread(featuresAvailability_objectSpread({}, _this.state.features[code]), {}, featuresAvailability_defineProperty({}, prop, value !== 'null' ? value : null));
        _this.setState({
          features: featuresAvailability_objectSpread(featuresAvailability_objectSpread({}, _this.state.features), {}, featuresAvailability_defineProperty({}, code, feature))
        }, function () {
          _this.onSave(false)();
        });
      };
    });
    featuresAvailability_defineProperty(featuresAvailability_assertThisInitialized(_this), "onSave", function () {
      var close = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return function () {
        var features = featuresAvailability_objectSpread(featuresAvailability_objectSpread({}, initialFeatures), _this.state.features);
        window.localStorage.setItem(storageKey, JSON.stringify(features));
        window.gEditor.plugins.featuresAvailabilityPlugin.setFeatures(features);
        if (close) {
          _this.onCloseClick();
        }
      };
    });
    featuresAvailability_defineProperty(featuresAvailability_assertThisInitialized(_this), "getFeatures", function () {
      var items = [{
        title: 'Get text from image',
        code: 'get-text-from-image'
      }, {
        title: 'Lock block',
        code: 'blocks-lock'
      }, {
        title: 'Preview video',
        code: 'preview-video'
      }];
      return items.map(function (feature) {
        var values = [].concat(featuresAvailability_toConsumableArray(Object.values(AVAILABILITY_STATUS)), ['null']).map(function (value) {
          return {
            value: value,
            selected: _this.state.features[feature.code].status === (value === 'null' ? null : value)
          };
        });
        var types = featuresAvailability_toConsumableArray(Object.values(AVAILABILITY_TYPE)).map(function (value) {
          return {
            value: value,
            selected: _this.state.features[feature.code].type === value
          };
        });
        return (0,preact_module.h)("div", {
          className: "dev-toolbar-form__row",
          key: feature.code
        }, (0,preact_module.h)("span", {
          className: "dev-toolbar-form__row-title"
        }, feature.title, ": "), (0,preact_module.h)("select", {
          name: "dev-toolbal-".concat(feature.code, "-status"),
          onChange: _this.onChange(feature.code, 'status')
        }, values.map(function (value) {
          return (0,preact_module.h)("option", {
            value: value.value,
            selected: value.selected
          }, value.value);
        })), (0,preact_module.h)("select", {
          name: "dev-toolbal-".concat(feature.code, "-type"),
          onChange: _this.onChange(feature.code, 'type')
        }, types.map(function (value) {
          return (0,preact_module.h)("option", {
            value: value.value,
            selected: value.selected
          }, value.value);
        })));
      });
    });
    _this.loadFeatures();
    return _this;
  }
  featuresAvailability_createClass(FeaturesAvailability, [{
    key: "render",
    value: function render() {
      if (!this.props.show) return null;
      return (0,preact_module.h)("div", {
        className: "dev-toolbar-form",
        style: this.props.position,
        ref: this.onRef
      }, (0,preact_module.h)("div", {
        className: "dev-toolbar-form__wrapper"
      }, (0,preact_module.h)("button", {
        className: "dev-toolbar-form__close",
        onClick: this.onCloseClick
      }, (0,preact_module.h)("span", null, "x")), (0,preact_module.h)("div", {
        className: "dev-toolbar-form__form"
      }, this.getFeatures(), (0,preact_module.h)("div", {
        className: "dev-toolbar-form__footer"
      }, (0,preact_module.h)("button", {
        onClick: this.onSave(true)
      }, "Ok")))));
    }
  }]);
  return FeaturesAvailability;
}(preact_module/* Component */.wA);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/toolbar.js
function toolbar_toConsumableArray(arr) { return toolbar_arrayWithoutHoles(arr) || toolbar_iterableToArray(arr) || toolbar_unsupportedIterableToArray(arr) || toolbar_nonIterableSpread(); }
function toolbar_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function toolbar_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function toolbar_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return toolbar_arrayLikeToArray(arr); }
function toolbar_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = toolbar_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function toolbar_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return toolbar_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return toolbar_arrayLikeToArray(o, minLen); }
function toolbar_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function toolbar_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function toolbar_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { toolbar_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { toolbar_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }





















function toolbar_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { toolbar_typeof = function _typeof(obj) { return typeof obj; }; } else { toolbar_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return toolbar_typeof(obj); }
function toolbar_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function toolbar_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function toolbar_createClass(Constructor, protoProps, staticProps) { if (protoProps) toolbar_defineProperties(Constructor.prototype, protoProps); if (staticProps) toolbar_defineProperties(Constructor, staticProps); return Constructor; }
function toolbar_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// Новый html элемент добавляется в тулбар через this.appendItem(elem)











var toolbar_COLORS = (/* unused pure expression or super */ null && (['#FAC92F', '#B39DDB', '#5573A7', '#42A5F5', '#8BC34A', '#ED5454', '#FDA639']));
var Toolbar = /*#__PURE__*/function () {
  function Toolbar(editor) {
    var _this = this;
    toolbar_classCallCheck(this, Toolbar);
    toolbar_defineProperty(this, "appendItem", function (item) {
      var itemContainer = document.createElement('div');
      itemContainer.classList.add('toolbar-item');
      itemContainer.append(item);
      _this.toolbarContainer.appendChild(itemContainer);
    });
    this.editor = editor;
    this.scroll = this.editor.scroll;
    this.selection = this.scroll.selection;
    this.container = document.createElement('div');
    this.toolbarContainer = document.createElement('div');
    this.tableFormContainer = document.createElement('div');
    this.toolbarContainer.classList.add('toolbar-container');
    this.toolbarContainer.setAttribute('collapsed', true);
    this.container.appendChild(this.toolbarContainer);

    //this.toolbarContainer.innerHTML = '<span style="color: #333">Dev controls:</span> '

    this.init();

    // TODO временное решение. надо сделать рефакторинг тулбара, чтобы он сам получал свое состояние из редактора, а не редактор
    // ему передавал.
    // делаем обновление статуса undo/redo после каждого клика мыши
    if (this.editor.isEditable()) {
      document.addEventListener('click', function () {
        _this.setUndoState({
          canUndo: _this.editor.plugins.undoManager.canUndo(),
          canRedo: _this.editor.plugins.undoManager.canRedo()
        });
      }, false);
    }
    this.editor.on('toolbar-status', function (formats, color, undoState) {
      if (undoState) {
        _this.setUndoState(undoState);
      }
    });
  }
  toolbar_createClass(Toolbar, [{
    key: "setUndoState",
    value: function setUndoState(undoState) {
      var undoButton = document.querySelector('a[data-button="undo"]');
      var redoButton = document.querySelector('a[data-button="redo"]');
      if (!undoButton || !redoButton) {
        return;
      }
      if (undoState.canUndo) {
        undoButton.classList.remove('disabled');
      } else {
        undoButton.classList.add('disabled');
      }
      if (undoState.canRedo) {
        redoButton.classList.remove('disabled');
      } else {
        redoButton.classList.add('disabled');
      }
    }
  }, {
    key: "init",
    value: function init() {
      this.container.classList.add('toolbar');
      this.editor.container.insertBefore(this.container, this.editor.scrollingContainer);
      this.addCollapsedButton();
      this.addFontSize();
      this.addFontFamily();
      this.addEditorTheme();
      this.addEditorLanguage();
      if (this.editor.isEditable()) {
        this.addUndoRedoButtons();
      }
      this.addModeSelect();
      this.addModeSelectSize();
      //this.addTableVersion()
      this.addCreateTableButton();
      this.addLazyTableMode();
      this.addBlotLimiter();
      this.addFocusMode();
      this.addAdminMode();
      this.addMarkdownOption();
      this.addGlobalSearch();
      this.addBusinessCard();
      this.addHtmlObject();
      this.addSetTestComments();
      this.addCopyAllButton();
      this.addListCollapsibleMode();
      this.addDownloadHTML();
      this.addDownloadPDF();
      this.addImportEnex();
      this.addLoadDump();
      addCtaButton(this);
      addFeaturesAvailabilityButton(this);
      this.addTestTextBlot();
      this.addTaskList();
      this.setTimeDateFormat();
      this.addDumpLoadInterface();
      this.addGrammarlySwitch();
      this.addUseAi();
      this.addShowRateEditor();
    }
  }, {
    key: "addCollapsedButton",
    value: function addCollapsedButton() {
      var _this2 = this;
      var button = document.createElement('div');
      button.classList.add('toolbar-collapse-button');
      button.innerHTML = '&#8681';
      this.container.appendChild(button);
      button.addEventListener('click', function (event) {
        if (_this2.toolbarContainer.hasAttribute('collapsed')) {
          _this2.toolbarContainer.removeAttribute('collapsed');
          button.innerHTML = '&#8679';
        } else {
          _this2.toolbarContainer.setAttribute('collapsed', true);
          button.innerHTML = '&#8681';
        }
      });
    }
  }, {
    key: "addTableVersion",
    value: function addTableVersion() {
      // Временно для сравнения старой и новой версии таблиц
      var currentVersion = (typeof localStorage === "undefined" ? "undefined" : toolbar_typeof(localStorage)) === 'object' && localStorage.getItem('table-version') || 'v2';
      var select = document.createElement('select');
      select.id = 'editor-table-version';
      select.style.width = '80px';
      var versions = ['v1', 'v2'];
      versions.map(function (version) {
        var opt = document.createElement('option');
        opt.value = version;
        opt.innerText = 'Table ' + version;
        if (currentVersion === version) {
          opt.selected = 'selected';
        }
        select.appendChild(opt);
      });
      this.appendItem(select);
      select.addEventListener('change', this.tableVersionHandler.bind(this));
    }
  }, {
    key: "tableVersionHandler",
    value: function tableVersionHandler(event) {
      event.preventDefault();
      if (event.isTrusted) {
        var version = event.target.value;
        localStorage.setItem('table-version', version);
        document.body.remove();
        document.location.reload();
      }
    }
  }, {
    key: "addCreateTableButton",
    value: function addCreateTableButton() {
      var div = document.createElement('div');
      var button = document.createElement('input');
      button.setAttribute('type', 'button');
      button.value = "Table";
      var select = document.createElement('select');
      select.style.marginRight = '0px';
      select.style.width = '80px';
      select.style.height = '22px';
      var sizes = ['4x5', '10x30', '10x100', '10x500', '10x1000', '10x2000', '30x50', '5x500', '5x1000', '5x2000', '5x3000', '20x1000', '20x2000']; //, '10x10000']
      sizes.map(function (size) {
        var opt = document.createElement('option');
        opt.value = size;
        opt.innerText = size;
        select.appendChild(opt);
      });
      div.appendChild(button);
      div.appendChild(select);
      this.appendItem(div);
      button.addEventListener('click', function () {
        var value = select.value.split('x');
        var params = {
          cols: parseInt(value[0]),
          rows: parseInt(value[1])
        };
        var version = 'v2'; //document.getElementById('editor-table-version').value

        /*
        const cells = params.cols * params.rows
        if (document.getElementById('editor-table-version').value !== 'v2') {
          let message
          if (cells > 2000) {
            message = `Таблица v1 (старая), ${cells} ячеек.\nВремя создания: несколько минут`
          } else if (cells > 1000) {
            message = `Таблица v1 (старая), ${cells} ячеек.\nВремя создания: около минуты`
          } else if (cells > 500) {
            message = `Таблица v1 (старая), ${cells} ячеек.\nВремя создания: 15-30 сек`
          }
          if (message && !confirm(message)) {
            return
          }
        }
        */
        if (confirm('Заполнить таблицу?')) {
          var words = JSON.parse(__webpack_require__(46673));
          params.content = {
            columns: [],
            rows: []
          };
          var max = words.length - 1;
          for (var row = 0; row < params.rows; row++) {
            var children = [];
            for (var col = 0; col < params.cols; col++) {
              var delta = new (Delta_default())();
              delta.insert(words[Math.ceil(max * Math.random())]);
              children.push({
                cellType: 'text',
                delta: delta
              });
            }
            params.content.rows.push({
              type: 'row',
              children: children
            });
          }
        }
        button.setAttribute('disabled', true);
        var start = performance.now();
        gEditor.scroll.addBlot('table', params);
        var time = performance.now() - start;
        button.removeAttribute('disabled');
        var message = "\u0422\u0430\u0431\u043B\u0438\u0446\u0430 ".concat(version, " ").concat(select.value, ", ") + Math.round(time) / 1000 + " \u0441.";
        gEditor.plugins.notificationManager.toast(message);
        console.info(message);
      });
    }
  }, {
    key: "addLazyTableMode",
    value: function addLazyTableMode() {
      return;
      var inputWrapper = document.createElement('div');
      var input = document.createElement('input');
      var label = document.createElement('label');
      inputWrapper.classList.add('editor-lazy-table-mode');
      input.setAttribute('type', 'checkbox');
      input.id = 'editor-lazy-table-mode';
      input.style.cursor = 'pointer';
      input.style.marginLeft = '0';
      input.checked = this.editor.options.hasOwnProperty('lazyTableRows') ? this.editor.options.lazyTableRows : false;
      label.setAttribute('for', 'editor-lazy-table-mode');
      label.innerText = 'Lazy';
      inputWrapper.appendChild(input);
      inputWrapper.appendChild(label);
      this.appendItem(inputWrapper);
      input.addEventListener('change', function (event) {
        var mode = Boolean(input.checked);
        setCustomSettingsItem('lazyTableRows', mode);
        document.location.reload();
      });
    }
  }, {
    key: "addBlotLimiter",
    value: function addBlotLimiter() {
      var limitManager = this.editor.plugins.limitManager;
      var span = document.createElement('span');
      span.classList.add('toolbar-blot-limiter');
      span.innerText = 'Limit:';
      var count = document.createElement('span');
      count.setAttribute('name', 'blot-count');
      count.innerText = '0/';
      count.style.display = 'none';
      var input = document.createElement('input');
      input.setAttribute('name', 'blot-limit');
      input.setAttribute('type', 'number');
      input.setAttribute('min', 0);
      input.value = 0;
      input.style.display = 'none';
      var testBtn = document.createElement('input');
      testBtn.setAttribute('type', 'button');
      testBtn.value = ' Test ';
      span.appendChild(testBtn);
      span.appendChild(count);
      span.appendChild(input);
      this.appendItem(span);
      var setLimit = function setLimit(limit) {
        limitManager.options.enabled = true;
        limitManager.options.limit = limit;
      };
      testBtn.onclick = function (event) {
        var cnt = 1,
          limit = 10;
        testBtn.style.display = 'none';
        count.style.display = 'inline';
        input.style.display = 'inline';
        count.innerText = cnt + '/';
        input.value = limit;
        setLimit(limit);
        limitManager.options.count = cnt;
        limitManager.listeners();
      };
      input.onchange = function (event) {
        setLimit(input.value);
        console.info(limitManager.options);
      };
    }
  }, {
    key: "addImportEnex",
    value: function addImportEnex() {
      var button = document.createElement('button');
      button.innerHTML = 'Import .enex';
      button.addEventListener('click', function (event) {
        fileInput.click();
      });
      this.appendItem(button);
      var fileInput = document.createElement('input');
      fileInput.setAttribute('type', 'file');
      this.appendItem(fileInput);
      fileInput.style.display = 'none';
      var display = document.createElement('span');
      this.appendItem(display);
      fileInput.onchange = /*#__PURE__*/toolbar_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var file, formData, data, event;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                file = fileInput.files[0];
                formData = new FormData();
                formData.append("file", file);
                _context.next = 5;
                return fetch('/import-enex', {
                  method: 'POST',
                  body: formData
                }).then(function (response) {
                  return response.json();
                });
              case 5:
                data = _context.sent;
                event = new CustomEvent('enex-import-done', {
                  detail: data
                });
                window.dispatchEvent(event);
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }, {
    key: "addLoadDump",
    value: function addLoadDump() {
      var button = document.createElement('button');
      button.innerHTML = 'load dump';
      button.addEventListener('click', function (event) {
        fileInput.click();
      });
      this.appendItem(button);
      var fileInput = document.createElement('input');
      fileInput.setAttribute('type', 'file');
      this.appendItem(fileInput);
      fileInput.style.display = 'none';
      var playCb = document.createElement('input');
      playCb.setAttribute('type', 'checkbox');
      var playLabel = document.createElement('label');
      playLabel.appendChild(playCb);
      playLabel.appendChild(document.createTextNode(' Play'));
      this.appendItem(playLabel);
      var display = document.createElement('span');
      this.appendItem(display);
      var maxStepsInput = document.createElement('input');
      maxStepsInput.setAttribute('placeholder', 'Max steps (60 default)');
      maxStepsInput.setAttribute('hidden', 'true');
      this.appendItem(maxStepsInput);
      var stepTimeoutInput = document.createElement('input');
      stepTimeoutInput.setAttribute('placeholder', 'Step timeout (1000 default)');
      stepTimeoutInput.setAttribute('hidden', 'true');
      this.appendItem(stepTimeoutInput);
      var goToAndThenOneByOneInput = document.createElement('input');
      goToAndThenOneByOneInput.setAttribute('placeholder', 'Go to step and the by one operation');
      goToAndThenOneByOneInput.setAttribute('hidden', 'true');
      this.appendItem(goToAndThenOneByOneInput);
      var maxSteps = 60;
      var stepTimeout = 1000;
      var goToAndThenOneByOne = false;
      playCb.onchange = function () {
        if (playCb.checked) {
          maxStepsInput.removeAttribute('hidden');
          stepTimeoutInput.removeAttribute('hidden');
          goToAndThenOneByOneInput.removeAttribute('hidden');
        } else {
          maxStepsInput.setAttribute('hidden', 'true');
          stepTimeoutInput.setAttribute('hidden', 'true');
          goToAndThenOneByOneInput.setAttribute('hidden', 'true');
        }
      };
      fileInput.onchange = function () {
        var file = fileInput.files[0];
        var reader = new FileReader();
        var isCsv = String(file.name).split('.').pop().toLowerCase() === 'csv';
        reader.onload = function (e) {
          var manual = false;
          var nextButton;
          if (maxStepsInput.value) {
            maxSteps = parseInt(maxStepsInput.value) || maxSteps;
          }
          if (stepTimeoutInput.value) {
            stepTimeout = parseInt(stepTimeoutInput.value) || stepTimeout;
          }
          if (goToAndThenOneByOneInput.value) {
            goToAndThenOneByOne = parseInt(goToAndThenOneByOneInput.value) || goToAndThenOneByOne;
          }
          var stopButton = document.createElement('button');
          stopButton.textContent = 'Stop';
          stopButton.addEventListener('click', function () {
            manual = true;
            nextButton = document.createElement('button');
            nextButton.textContent = 'Next';
            nextButton.addEventListener('click', function () {
              processPart();
            });
            stopButton.parentNode.replaceChild(nextButton, stopButton);
          });
          display.parentNode.insertBefore(stopButton, display);
          var parts = reader.result.split('\n');
          if (playCb.checked) {
            parts = lodash_chunk_default()(parts, Math.ceil(parts.length / maxSteps));
          } else {
            parts = [parts];
          }
          console.log('processing parts', parts.length);
          var progress = 1;
          function processPart() {
            if (playCb.checked) {
              display.textContent = 'Playing ' + progress + '/' + maxSteps;
            }
            if (goToAndThenOneByOne == progress) {
              manual = true;
              stopButton.click();
              var remainParts = [];
              var _iterator = toolbar_createForOfIteratorHelper(parts),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var _part2 = _step.value;
                  var _iterator2 = toolbar_createForOfIteratorHelper(_part2),
                    _step2;
                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      var part = _step2.value;
                      remainParts.push(part);
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              parts = lodash_chunk_default()(remainParts, 1);
              progress = 0;
              maxSteps = parts.length;
              return;
            }
            progress++;
            var _part = parts.shift();
            //if (progress > 485) alert(progress)

            var data = [];
            try {
              gEditor.store.transaction(function () {
                var _iterator3 = toolbar_createForOfIteratorHelper(_part),
                  _step3;
                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var _part3 = _step3.value;
                    if (isCsv) {
                      data = _part3.replaceAll('\"', '').split(',');
                      if (data[0].indexOf('docName') !== -1 || !data[2]) {
                        continue;
                      }
                      _part3 = data[2];
                      console.info(new Date(parseInt(data[1].split('#')[0])).toUTCString());
                    }
                    _part3 = _part3.trim();
                    if (!_part3) {
                      continue;
                    }
                    console.log('PART', _part3);
                    var buf = (0,dev_page_util.base64ToArrayBuffer)(_part3);
                    try {
                      console.log('reading...');
                      gEditor.store.y.readBuffer(buf);
                    } catch (ex) {
                      console.error('failed to import', _part3);
                      throw ex;
                    }
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
              }, 'remote');
            } catch (err) {
              console.error('transaction has failed:', err.message, err.stack);
            }
            //console.log('imported', _part.length, 'items')
            if (!parts.length) {
              console.log('import end');
              display.textContent = '';
              if (stopButton.parentNode) {
                stopButton.parentNode.removeChild(stopButton);
                if (nextButton) {
                  nextButton.parentNode.removeChild(nextButton);
                }
              }
              return;
            }
            var timeout = stepTimeout;
            /*
            if (data.length && parseInt(data[1].split('#')[0]) >= 1613588600000) {
              timeout = 1e3
            }
            */
            if (!manual) {
              setTimeout(processPart, timeout);
            }
          }
          processPart();
        };
        reader.readAsText(file);
      };
    }
  }, {
    key: "addBusinessCard",
    value: function addBusinessCard() {
      var _this3 = this;
      //init toolbar button
      var button = document.createElement('button');
      button.innerHTML = 'businessCard';
      button.addEventListener('click', function (event) {
        var focusedBlot = _this3.scroll.focusedBlot || false,
          data = {
            focus: {
              index: 0
            },
            frontSideAttachmentGlobalId: false,
            backSideAttachmentGlobalId: false
          };

        //init modal wrapper
        var modalWrapper = document.createElement('div');
        modalWrapper.id = 'businesscardmodal';
        modalWrapper.classList = 'business-cardModalWrapper';
        function atFile(name) {
          gEditor.plugins.attachmentManager.chooseFile().then(function (files) {
            var file = files[0];
            if (file) {
              modal.classList.add('business-cardModalWrapper__modal_loading');
              var task = gEditor.plugins.attachmentManager.saveFile(file);
              task.run().then(function (attachment) {
                data[name] = attachment.globalId;
                modal.classList.remove('business-cardModalWrapper__modal_loading');
              });
            }
          });
        }

        //init modal
        var modal = document.createElement('div');
        modal.classList = 'business-cardModalWrapper__modal';

        //init button frontSideAttachmentGlobalId
        var button = document.createElement('button');
        button.innerHTML = 'frontSideAttachmentGlobalId';
        button.style.marginBottom = '5px';
        button.addEventListener("click", function () {
          atFile('frontSideAttachmentGlobalId');
        });
        modal.appendChild(button);

        //init button backSideAttachmentGlobalId
        button = document.createElement('button');
        button.innerHTML = 'backSideAttachmentGlobalId';
        button.style.marginBottom = '5px';
        button.addEventListener("click", function () {
          atFile('backSideAttachmentGlobalId');
        });
        modal.appendChild(button);

        //init inputs
        var inputs = [{
          type: 'text',
          name: 'Name',
          entityClass: 'PERSON',
          default: 'John Smith'
        }, {
          type: 'text',
          name: 'Position',
          entityClass: 'ADDRESS',
          default: 'Marketing Expert'
        }, {
          type: 'text',
          name: 'Company',
          entityClass: 'ORGANIZATION',
          default: 'E-commerce'
        }, {
          type: 'text',
          name: 'Phone',
          entityClass: 'PHONE',
          default: '+55 555-555-555'
        }, {
          type: 'text',
          name: 'Email',
          entityClass: 'EMAIL',
          default: 'johnsmith@example.com'
        }, {
          type: 'text',
          name: 'Facebook',
          entityClass: 'FACEBOOK',
          default: 'j.smith'
        }];
        inputs.forEach(function (input) {
          var inputEl = document.createElement('input');
          inputEl.name = input.name;
          inputEl.type = input.type;
          inputEl.setAttribute('data-entity', input.entityClass);
          if (input.default) {
            inputEl.value = input.default;
          }
          modal.appendChild(inputEl);
        });

        //init apply
        button = document.createElement('button');
        button.innerHTML = 'apply';
        button.style.marginBottom = '5px';
        button.addEventListener("click", function () {
          var fields = [];
          var modalWrapper = document.querySelector('#businesscardmodal');
          inputs.forEach(function (input) {
            console.log(input);
            var inputEl = modalWrapper.querySelector('input[name="' + input.name + '"]');
            fields.push({
              value: inputEl.value,
              entityClass: input.entityClass
            });
          });
          data['fields'] = fields;
          if (focusedBlot) {
            data['after'] = focusedBlot.id;
          }
          gEditor.scroll.addBlot('businessCard', data);
          document.querySelector('#businesscardmodal').remove();
          focusedBlot = false;
        });
        modal.appendChild(button);

        //init cancel
        button = document.createElement('button');
        button.innerHTML = 'cancel';
        button.style.marginBottom = '5px';
        button.addEventListener("click", function () {
          document.querySelector('#businesscardmodal').remove();
        });
        modal.appendChild(button);
        modalWrapper.appendChild(modal);
        document.body.appendChild(modalWrapper);
      });
      this.appendItem(button);
    }
  }, {
    key: "addFontSize",
    value: function addFontSize() {
      var _this4 = this;
      var select = document.createElement('select');
      select.id = 'font-size-change';
      select.style.cursor = 'pointer';
      select.style.marginRight = '5px';
      var sizes = ['small', 'normal', 'large'];
      sizes.map(function (size) {
        var opt = document.createElement('option');
        opt.value = size;
        if (size === _this4.editor.plugins.editorStyle._getCurrentStyles().size) opt.setAttribute('selected', 'selected');
        opt.innerText = size.split('').map(function (letter, index) {
          if (index === 0) return letter.toUpperCase();
          return letter;
        }).join('');
        opt.style.cursor = 'pointer';
        select.appendChild(opt);
      });
      this.appendItem(select);
      select.addEventListener('change', this.sizeEventHandler.bind(this));
    }
  }, {
    key: "sizeEventHandler",
    value: function sizeEventHandler(event) {
      event.preventDefault();
      if (event.isTrusted) {
        var size = event.target.value;
        this.editor.plugins.editorStyle.setStyle({
          size: size
        }, true);
        this.scroll.selection.focus();
        setCustomSettingsItem('size', size);
      }
    }
  }, {
    key: "addFontFamily",
    value: function addFontFamily() {
      var _this5 = this;
      var select = document.createElement('select');
      select.id = 'font-family-change';
      select.style.cursor = 'pointer';
      select.style.marginRight = '5px';
      select.style.width = '68px';
      var fonts = ['normal', 'serif', 'handwritten', 'mono'];
      fonts.map(function (font) {
        var opt = document.createElement('option');
        opt.value = font;
        if (font === _this5.editor.plugins.editorStyle._getCurrentStyles().style) opt.setAttribute('selected', 'selected');
        opt.innerText = font.split('').map(function (letter, index) {
          if (index === 0) return letter.toUpperCase();
          return letter;
        }).join('');
        opt.style.cursor = 'pointer';
        select.appendChild(opt);
      });
      this.appendItem(select);
      select.addEventListener('change', this.familyEventHandler.bind(this));
    }
  }, {
    key: "familyEventHandler",
    value: function familyEventHandler(event) {
      event.preventDefault();
      if (event.isTrusted) {
        var style = event.target.value;
        this.editor.plugins.editorStyle.setStyle({
          style: style
        }, true);
        this.scroll.selection.focus();
        setCustomSettingsItem('style', style);
      }
    }
  }, {
    key: "addEditorTheme",
    value: function addEditorTheme() {
      var _this6 = this;
      var select = document.createElement('select');
      select.id = 'editor-theme-change';
      select.style.cursor = 'pointer';
      select.style.marginRight = '5px';
      select.style.width = '60px';
      var themes = ['light', 'dark', 'brand-dark-ios'];
      themes.map(function (theme) {
        var opt = document.createElement('option');
        opt.value = theme;
        if (_this6.editor.container.classList.contains('theme-' + theme)) {
          opt.setAttribute('selected', 'selected');
          document.body.classList.add('nim-theme-' + theme);
        }
        opt.innerText = theme.split('').map(function (letter, index) {
          if (index === 0) return letter.toUpperCase();
          return letter;
        }).join('');
        opt.style.cursor = 'pointer';
        select.appendChild(opt);
      });
      this.appendItem(select);
      select.addEventListener('change', this.themeEventHandler.bind(this));
    }
  }, {
    key: "themeEventHandler",
    value: function themeEventHandler(event) {
      event.preventDefault();
      if (event.isTrusted) {
        var theme = event.target.value;
        this.editor.plugins.editorStyle.setTheme(theme);
        this.editor.container.style.backgroundColor = String(theme).indexOf('dark') !== -1 ? '#323232' : 'transparent';
        this.scroll.selection.focus();
        setCustomSettingsItem('theme', theme);
        document.body.classList.remove('nim-theme-light');
        document.body.classList.remove('nim-theme-dark');
        document.body.classList.add('nim-theme-' + theme);
      }
    }
  }, {
    key: "addEditorLanguage",
    value: function addEditorLanguage() {
      var _this7 = this;
      var select = document.createElement('select');
      select.id = 'editor-language-change';
      select.style.cursor = 'pointer';
      select.style.marginRight = '5px';
      select.style.width = '50px';
      var languages = ['ua', 'en', 'ru', 'de', 'it', 'es', 'tr'];
      languages.map(function (lang) {
        var opt = document.createElement('option');
        opt.value = lang;
        if (_this7.editor.plugins.i18n.language === lang) {
          opt.setAttribute('selected', 'selected');
        }
        opt.innerText = lang.split('').map(function (letter, index) {
          if (index === 0) {
            return letter.toUpperCase();
          }
          return letter;
        }).join('');
        opt.style.cursor = 'pointer';
        select.appendChild(opt);
      });
      this.appendItem(select);
      select.addEventListener('change', this.languageEventHandler.bind(this));
    }
  }, {
    key: "languageEventHandler",
    value: function languageEventHandler(event) {
      event.preventDefault();
      if (event.isTrusted) {
        var language = event.target.value;
        setCustomSettingsItem('language', language);
        this.editor.emitter.emit('reinit-editor', {
          language: language
        });
      }
    }
  }, {
    key: "addUndoRedoButtons",
    value: function addUndoRedoButtons() {
      var _this8 = this;
      var getButton = function getButton(target) {
        if (target.tagName == 'I') {
          return target.parentNode;
        }
        return target;
      };
      var button = document.createElement('a');
      button.setAttribute('href', '#');
      button.setAttribute('data-button', 'undo');
      button.classList.add('disabled');
      button.style.cursor = 'pointer';
      var icon = document.createElement('i');
      icon.classList.add('fa', 'fa-undo');
      button.appendChild(icon);
      this.appendItem(button);
      button.addEventListener('click', function (event) {
        event.preventDefault();
        if (!getButton(event.target).classList.contains('disabled')) {
          _this8.editor.exec('undo');
        }
      });
      button = document.createElement('a');
      button.setAttribute('href', '#');
      button.setAttribute('data-button', 'redo');
      button.classList.add('disabled');
      button.style.cursor = 'pointer';
      icon = document.createElement('i');
      icon.classList.add('fa', 'fa-repeat');
      button.appendChild(icon);
      this.appendItem(button);
      button.addEventListener('click', function (event) {
        event.preventDefault();
        if (!getButton(event.target).classList.contains('disabled')) {
          _this8.editor.exec('redo');
        }
      });
    }
  }, {
    key: "addModeSelect",
    value: function addModeSelect() {
      var _this9 = this;
      var select = document.createElement('select');
      select.id = 'editor-mode-change';
      select.style.cursor = 'pointer';
      var mode = [MODE_EDIT, MODE_PREVIEW, MODE_READONLY, MODE_EXPORT, "share", MODE_LITE];
      mode.map(function (el) {
        var opt = document.createElement('option');
        opt.value = el;
        if (el === _this9.editor.mode && !_this9.editor.options.isShare) {
          opt.setAttribute('selected', 'selected');
        } else if (el === "share" && _this9.editor.options.isShare) {
          opt.setAttribute('selected', 'selected');
        }
        opt.innerText = el;
        opt.style.cursor = 'pointer';
        select.appendChild(opt);
      });
      this.appendItem(select);
      select.addEventListener('change', function (event) {
        if (event.target.value === 'share') {
          setCustomSettingsItem('mode', 'readonly');
          setCustomSettingsItem('isShare', true);
        } else {
          setCustomSettingsItem('mode', event.target.value);
          setCustomSettingsItem('isShare', false);
        }
        _this9.editor.emitter.emit('reinit-editor', {
          mode: event.target.value
        });
      });
    }
  }, {
    key: "addGlobalSearch",
    value: function addGlobalSearch() {
      var _this10 = this;
      var button = document.createElement('button');
      var container = document.createElement('div');
      container.classList.add('dev-global-search-container');
      button.textContent = 'Start global search';
      button.onclick = function () {
        var queries = prompt('Enter queries comma separated').split(',').map(function (q) {
          return q.trim();
        });
        _this10.editor.plugins.globalSearch.start(queries);
      };
      var hotkeyMessage = document.createElement('div');
      hotkeyMessage.classList.add('dev-global-search-hk-message');
      hotkeyMessage.textContent = 'Alt+← or Alt+→ to navigate between matches';
      hotkeyMessage.style.display = 'none';
      this.appendItem(button);
      this.appendItem(container);
      this.appendItem(hotkeyMessage);
    }
  }, {
    key: "addListCollapsibleMode",
    value: function addListCollapsibleMode() {
      var _this11 = this;
      var inputWrapper = document.createElement('div');
      inputWrapper.classList.add('editor-list-collapsible');
      var input = document.createElement('input');
      input.setAttribute('type', 'checkbox');
      input.id = 'editor-list-collapsible-mode';
      input.style.cursor = 'pointer';
      input.checked = this.editor.blotsConfig.list ? this.editor.blotsConfig.list.collapsible : false;
      var label = document.createElement('label');
      label.setAttribute('for', 'editor-list-collapsible-mode');
      label.innerText = 'Collapsible list';
      inputWrapper.appendChild(input);
      inputWrapper.appendChild(label);
      this.appendItem(inputWrapper);
      input.addEventListener('change', function (event) {
        setCustomSettingsItem('collapsibleList', Boolean(input.checked));
        var adminInput = document.getElementById('editor-admin');
        _this11.editor.emitter.emit('reinit-editor', {
          list: {
            collapsible: Boolean(input.checked)
            /*
            listItemNumber: {
              manageBlotsLock: Boolean(adminInput.checked)
            },
            listItemCheckbox: {
              manageBlotsLock: Boolean(adminInput.checked)
            },
            listItemBullet: {
              manageBlotsLock: Boolean(adminInput.checked)
            }
            */
          }
        });
      });
    }
  }, {
    key: "addDownloadHTML",
    value: function addDownloadHTML() {
      var _this12 = this;
      // пришлось сделать динамический экшен формы, так как на энве не могут протестить нормально экспорт шрифтов и тд
      var form = document.createElement('form');
      form.setAttribute('method', 'POST');
      form.setAttribute('target', '_blank');
      var button = document.createElement('button');
      button.innerText = 'Download HTML';
      form.appendChild(button);
      var div = document.createElement('div');
      div.appendChild(form);
      this.appendItem(div);
      var inputWrapper = document.createElement('div');
      inputWrapper.classList.add('editor-list-collapsible');
      var input = document.createElement('input');
      input.setAttribute('type', 'checkbox');
      input.id = 'editor-to-email';
      input.style.cursor = 'pointer';
      input.checked = false;
      var label = document.createElement('label');
      label.setAttribute('for', 'editor-to-email');
      label.innerText = 'To Email';
      inputWrapper.appendChild(input);
      inputWrapper.appendChild(label);
      var input2 = document.createElement('input');
      input2.setAttribute('type', 'checkbox');
      input2.id = 'editor-no-attach';
      input2.style.cursor = 'pointer';
      input2.checked = false;
      var label2 = document.createElement('label');
      label2.setAttribute('for', 'editor-no-attach');
      label2.innerText = 'No Attaches';
      inputWrapper.appendChild(input2);
      inputWrapper.appendChild(label2);
      this.appendItem(inputWrapper);
      button.addEventListener('click', function (event) {
        event.preventDefault();
        var room = document.location.pathname.substring(1);
        var language = _this12.editor.plugins.i18n.language;
        var timezone = new Date().getTimezoneOffset();
        var _this12$editor$plugin = _this12.editor.plugins.editorStyle.getStyle(),
          size = _this12$editor$plugin.size,
          style = _this12$editor$plugin.style;
        var toEmail = input.checked;
        var hideAttaches = input2.checked;
        var emailParam = '';
        var hideParam = '';
        if (toEmail) {
          emailParam = '&to_email=1';
        }
        if (hideAttaches) {
          hideParam = '&no_attaches=1';
        }
        form.setAttribute('action', "/export-to-html/?room=".concat(room, "&ln=").concat(language, "&size=").concat(size, "&style=").concat(style, "&timezone=").concat(timezone).concat(emailParam).concat(hideParam));
        form.submit();
        form.removeAttribute('action');
      });
    }
  }, {
    key: "addDownloadPDF",
    value: function addDownloadPDF() {
      var _this13 = this;
      // create button for toolbar
      var button = document.createElement('button');
      button.innerText = 'Download PDF';
      var div = document.createElement('div');
      div.classList.add('pdf-export');
      div.appendChild(button);
      // create Popup nodes
      var exportOptionsPopup = document.createElement('div');
      var formatWrapper = document.createElement('div');
      var landscapeWrapper = document.createElement('div');
      var formWrapper = document.createElement('div');
      exportOptionsPopup.classList.add('pdf-export-options');
      var formatLabel = document.createElement('label');
      formatLabel.classList.add('pdf-export-format-label');
      formatLabel.innerText = 'Select papper format';
      var formatSelect = document.createElement('select');
      formatSelect.classList.add('pdf-export-format');
      formatSelect.innerHTML = ['A1', 'A2', 'A3', 'A4', 'A5'].map(function (f) {
        return '<option value=' + f + (f === 'A4' ? ' selected' : '') + '>' + f + '</option>';
      }).join('\n');
      var landscapeCheckbox = document.createElement('input');
      landscapeCheckbox.classList.add('pdf-export-landscape');
      landscapeCheckbox.type = 'checkbox';
      var landscapeLabel = document.createElement('label');
      landscapeLabel.classList.add('pdf-export-landscape-label');
      landscapeLabel.innerText = 'Landscape';
      var form = document.createElement('form');
      form.setAttribute('method', 'POST');
      form.setAttribute('target', '_blank');
      var submitButton = document.createElement('button');
      submitButton.innerText = 'Download';
      // build Popup
      formatWrapper.appendChild(formatLabel);
      formatWrapper.appendChild(formatSelect);
      landscapeWrapper.appendChild(landscapeCheckbox);
      landscapeWrapper.appendChild(landscapeLabel);
      formWrapper.appendChild(form);
      formWrapper.appendChild(submitButton);
      exportOptionsPopup.appendChild(formatWrapper);
      exportOptionsPopup.appendChild(landscapeWrapper);
      exportOptionsPopup.appendChild(formWrapper);
      // append builded Popup to div
      div.appendChild(exportOptionsPopup);
      // append div to toolbar
      this.appendItem(div);
      // events
      button.addEventListener('click', function (event) {
        event.preventDefault();
        if (exportOptionsPopup.classList.contains('open')) {
          exportOptionsPopup.classList.remove('open');
        } else {
          exportOptionsPopup.classList.add('open');
        }
      });
      submitButton.addEventListener('click', function (event) {
        event.preventDefault();
        var room = document.location.pathname.substring(1);
        var language = _this13.editor.plugins.i18n.language;
        var timezone = new Date().getTimezoneOffset();
        var _this13$editor$plugin = _this13.editor.plugins.editorStyle.getStyle(),
          size = _this13$editor$plugin.size,
          style = _this13$editor$plugin.style;
        var format = formatSelect.value;
        var landscape = Boolean(landscapeCheckbox.checked);
        form.setAttribute('action', "/export-to-pdf/?room=".concat(room, "&ln=").concat(language, "&size=").concat(size, "&style=").concat(style, "&timezone=").concat(timezone, "&papperFormat=").concat(format, "&landscape=").concat(landscape));
        form.submit();
        form.removeAttribute('action');
      });
    }
  }, {
    key: "addMarkdownOption",
    value: function addMarkdownOption() {
      var _this14 = this;
      var inputWrapper = document.createElement('div');
      inputWrapper.classList.add('editor-allow-markdown');
      var input = document.createElement('input');
      input.setAttribute('type', 'checkbox');
      input.id = 'editor-allow-markdown-mode';
      input.style.cursor = 'pointer';
      input.checked = Object.keys(this.editor.options).includes('markdown') ? this.editor.options.markdown : true;
      var label = document.createElement('label');
      label.setAttribute('for', 'editor-allow-markdown-mode');
      label.innerText = 'Markdown';
      inputWrapper.appendChild(input);
      inputWrapper.appendChild(label);
      this.appendItem(inputWrapper);
      input.addEventListener('change', function (event) {
        setCustomSettingsItem('markdown', Boolean(input.checked));
        _this14.editor.emitter.emit('reinit-editor', {
          markdown: Boolean(input.checked)
        });
      });
    }
  }, {
    key: "addFocusMode",
    value: function addFocusMode() {
      var _this15 = this;
      var inputWrapper = document.createElement('div');
      inputWrapper.classList.add('editor-allow-focus-mode');
      var input = document.createElement('input');
      input.setAttribute('type', 'checkbox');
      input.id = 'editor-allow-focus-mode';
      input.style.cursor = 'pointer';
      input.checked = Object.keys(this.editor.options).includes('focusMode') ? this.editor.options.focusMode : false;
      var label = document.createElement('label');
      label.setAttribute('for', 'editor-allow-focus-mode');
      label.innerText = 'Focus';
      inputWrapper.appendChild(input);
      inputWrapper.appendChild(label);
      this.appendItem(inputWrapper);
      input.addEventListener('change', function (event) {
        var mode = Boolean(input.checked);
        setCustomSettingsItem('focusMode', mode);
        _this15.editor.emitter.emit('set-focus-mode', {
          mode: mode
        });
      });
    }
  }, {
    key: "addAdminMode",
    value: function addAdminMode() {
      var _this16 = this;
      var inputWrapper = document.createElement('div');
      inputWrapper.classList.add('editor-admin');
      var input = document.createElement('input');
      input.setAttribute('type', 'checkbox');
      input.id = 'editor-admin';
      input.style.cursor = 'pointer';
      input.checked = this.editor.options && this.editor.options.user ? this.editor.options.user.manage : false;
      var label = document.createElement('label');
      label.setAttribute('for', 'editor-admin');
      label.innerText = 'Admin';
      inputWrapper.appendChild(input);
      inputWrapper.appendChild(label);
      this.appendItem(inputWrapper);
      input.addEventListener('change', function (event) {
        setCustomSettingsItem('manage', Boolean(input.checked));
        _this16.editor.emitter.emit('reinit-editor', {
          user: {
            manage: Boolean(input.checked)
          }
        });
      });
    }
  }, {
    key: "addModeSelectSize",
    value: function addModeSelectSize() {
      var _this17 = this;
      var select = document.createElement('select');
      select.id = 'editor-size-change';
      select.style.cursor = 'pointer';
      var mode = ["1000px", "900px", "800px", "700px", "100%"];
      mode.map(function (el) {
        var opt = document.createElement('option');
        opt.value = el;
        opt.innerText = el;
        opt.style.cursor = 'pointer';
        if (el === '1000px') {
          opt.setAttribute('selected', 'selected');
        }
        select.appendChild(opt);
      });
      this.appendItem(select);
      select.addEventListener('change', function (event) {
        document.getElementById(_this17.editor.root.id).style.maxWidth = event.target.value;
      });
    }
  }, {
    key: "addCopyAllButton",
    value: function addCopyAllButton() {
      var _this18 = this;
      var button = document.createElement('button');
      button.innerHTML = 'Copy All';
      button.addEventListener('click', function (event) {
        _this18.editor.exec('copy-all');
      });
      this.appendItem(button);
    }
  }, {
    key: "addHtmlObject",
    value: function addHtmlObject() {
      //init toolbar button
      var button = document.createElement('button');
      button.innerHTML = 'HTML Object';
      button.addEventListener('click', function (event) {
        //init modal wrapper
        var modalWrapper = document.createElement('div');
        modalWrapper.id = 'businesscardmodal';
        modalWrapper.classList = 'business-cardModalWrapper';

        //init modal
        var modal = document.createElement('div');
        modal.classList = 'business-cardModalWrapper__modal';

        //itit src input
        var labelForInput = document.createElement('label');
        labelForInput.innerText = 'Url to origin';
        modal.appendChild(labelForInput);
        var input = document.createElement('input');
        input.type = 'url';
        modal.appendChild(input);

        //itit textarea
        var labelForText = document.createElement('label');
        labelForText.innerText = 'HTML';
        modal.appendChild(labelForText);
        var textarea = document.createElement('textarea');
        textarea.style.width = '100%';
        textarea.style.height = '500px';
        modal.appendChild(textarea);

        //init apply
        var apply = document.createElement('button');
        apply.innerHTML = 'Apply';
        apply.style.marginBottom = '5px';
        apply.addEventListener("click", /*#__PURE__*/toolbar_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var content, signRes, signature;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  content = textarea.value;
                  _context2.next = 3;
                  return request('POST', '/sign-html', JSON.stringify({
                    content: content
                  }));
                case 3:
                  signRes = _context2.sent;
                  signature = signRes.signature;
                  gEditor.scroll.addBlot('html', {
                    content: content,
                    srcLink: input.value,
                    signature: signature
                  });
                  document.querySelector('#businesscardmodal').remove();
                case 7:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        })));
        modal.appendChild(apply);

        //init cancel
        var cancel = document.createElement('button');
        cancel.innerHTML = 'Cancel';
        cancel.style.marginBottom = '5px';
        cancel.addEventListener("click", function () {
          document.querySelector('#businesscardmodal').remove();
        });
        modal.appendChild(cancel);
        modalWrapper.appendChild(modal);
        document.body.appendChild(modalWrapper);
      });
      this.appendItem(button);
    }
  }, {
    key: "addSetTestComments",
    value: function addSetTestComments() {
      var _this19 = this;
      // рекурсивно собираем id всех блотов заметки, которые не являются контейнерами
      function getContainerBlotIds(container) {
        var ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        return container.children.reduce(function (array, blot) {
          return blot.isContainer ? [].concat(toolbar_toConsumableArray(array), toolbar_toConsumableArray(getContainerBlotIds(blot))) : [].concat(toolbar_toConsumableArray(array), [blot.getWrappedBlot().id]);
        }, ids);
      }
      function getRandom(max) {
        return Math.floor(Math.random() * Math.floor(max));
      }
      var button = document.createElement('button');
      button.innerHTML = 'Comments';
      button.addEventListener('click', function (event) {
        var ids = getContainerBlotIds(_this19.scroll);
        var length = getRandom(ids.length);
        var testComments = [];
        for (var i = 0; i < length; i++) {
          testComments.push({
            target: 'blot',
            blotId: ids.splice(getRandom(ids.length - 1), 1)[0],
            count: getRandom(150)
          });
        }
        _this19.editor.plugins.commentManager && _this19.editor.plugins.commentManager.setThreads(testComments);
        _this19.testComments = testComments;
      });
      this.appendItem(button);
    }
  }, {
    key: "openPicker",
    value: function openPicker(event) {
      event.preventDefault();
      return;
    }
  }, {
    key: "addTestTextBlot",
    value: function addTestTextBlot() {
      var _this20 = this;
      var button = document.createElement('button');
      button.innerHTML = 'Add test text';
      button.addEventListener('click', function (event) {
        _this20.editor.scroll.addBlot('paragraph-v2');
      });
      this.appendItem(button);
    }
  }, {
    key: "addTaskList",
    value: function addTaskList() {
      var _this21 = this;
      var button = document.createElement('button');
      button.innerHTML = 'Add Tasks list';
      button.addEventListener('click', function (event) {
        _this21.editor.scroll.addBlot('tasks-list');
      });
      this.appendItem(button);
    }
  }, {
    key: "setTimeDateFormat",
    value: function setTimeDateFormat() {
      var _this22 = this;
      var select = document.createElement('select');
      select.id = 'editor-datetime-format-change';
      select.style.cursor = 'pointer';
      select.style.marginRight = '5px';
      select.style.width = '100px';
      var formats = {
        'Автоопределение': false,
        'Американский М/Д/Г (12-часовой)': 'en-US',
        'Британский Д/М/Г (24-часовой)': 'en-GB'
      };
      Object.keys(formats).map(function (format) {
        var _this22$editor$option, _this22$editor$option2, _this22$editor$option3;
        var opt = document.createElement('option');
        opt.value = formats[format];
        if (((_this22$editor$option = _this22.editor.options) === null || _this22$editor$option === void 0 ? void 0 : (_this22$editor$option2 = _this22$editor$option.blots) === null || _this22$editor$option2 === void 0 ? void 0 : (_this22$editor$option3 = _this22$editor$option2.date) === null || _this22$editor$option3 === void 0 ? void 0 : _this22$editor$option3.timeLocale) === formats[format]) {
          opt.setAttribute('selected', 'selected');
        }
        opt.innerText = format;
        opt.style.cursor = 'pointer';
        select.appendChild(opt);
      });
      this.appendItem(select);
      select.addEventListener('change', function (event) {
        event.preventDefault();
        if (event.isTrusted) {
          var format = event.target.value;
          setCustomSettingsItem('datetime-format', format);
          _this22.editor.emitter.emit('reinit-editor', {
            'datetime-format': format
          });
        }
      });
    }
  }, {
    key: "addDumpLoadInterface",
    value: function addDumpLoadInterface() {
      function getLoadDumpState() {
        var state = {};
        if (localStorage) {
          if (localStorage.hasOwnProperty('editor-load-from-dump')) {
            state = JSON.parse(localStorage.getItem('editor-load-from-dump'));
          }
        }
        return state;
      }
      function setLoadDumpPropState(prop, value) {
        var state = {};
        if (localStorage) {
          if (localStorage.hasOwnProperty('editor-load-from-dump')) {
            state = JSON.parse(localStorage.getItem('editor-load-from-dump'));
          }
          state[prop] = value;
          localStorage.setItem('editor-load-from-dump', JSON.stringify(state));
        }
      }
      var defaultState = getLoadDumpState();
      var inputWrapper = document.createElement('div');
      inputWrapper.classList.add('load-with-remote-dump');
      var socketInput = document.createElement('input');
      socketInput.setAttribute('type', 'checkbox');
      socketInput.id = 'connect-to-socket';
      socketInput.style.cursor = 'pointer';
      socketInput.checked = defaultState.hasOwnProperty('connect-to-socket') ? defaultState['connect-to-socket'] : true;
      var socketLabel = document.createElement('label');
      socketLabel.setAttribute('for', 'connect-to-socket');
      socketLabel.innerText = 'Connect to socket';
      inputWrapper.appendChild(socketInput);
      inputWrapper.appendChild(socketLabel);
      var loadDumpInput = document.createElement('input');
      loadDumpInput.setAttribute('type', 'checkbox');
      loadDumpInput.id = 'load-editor-from-dump';
      loadDumpInput.style.cursor = 'pointer';
      loadDumpInput.checked = defaultState['load-dump'];
      var loadDumpLabel = document.createElement('label');
      loadDumpLabel.setAttribute('for', 'load-editor-from-dump');
      loadDumpLabel.innerText = 'Load from dump';
      inputWrapper.appendChild(loadDumpInput);
      inputWrapper.appendChild(loadDumpLabel);
      var urlInput = document.createElement('input');
      urlInput.setAttribute('type', 'url');
      urlInput.id = 'load-dump-url';
      urlInput.placeholder = 'Paste dump URL';
      var ehSessionIdInput = document.createElement('input');
      ehSessionIdInput.setAttribute('type', 'text');
      ehSessionIdInput.placeholder = 'everhelper-session-id';
      if (defaultState['load-dump']) {
        inputWrapper.appendChild(urlInput);
        inputWrapper.appendChild(ehSessionIdInput);
      }
      if (defaultState.url) {
        urlInput.value = defaultState.url;
      }
      if (defaultState.everhelperSessionId) {
        ehSessionIdInput.value = defaultState.everhelperSessionId;
      }
      socketInput.addEventListener('change', function () {
        setLoadDumpPropState('connect-to-socket', Boolean(socketInput.checked));
      });
      loadDumpInput.addEventListener('change', function () {
        if (loadDumpInput.checked) {
          inputWrapper.appendChild(urlInput);
          setLoadDumpPropState('load-dump', true);
        } else {
          if (inputWrapper.contains(urlInput)) {
            inputWrapper.removeChild(urlInput);
          }
          setLoadDumpPropState('load-dump', false);
          setLoadDumpPropState('url', null);
        }
      });
      urlInput.addEventListener('input', function () {
        setLoadDumpPropState('url', urlInput.value || null);
      });
      ehSessionIdInput.addEventListener('input', function () {
        setLoadDumpPropState('everhelperSessionId', ehSessionIdInput.value || null);
      });
      this.appendItem(inputWrapper);
    }
  }, {
    key: "addGrammarlySwitch",
    value: function addGrammarlySwitch() {
      var _this23 = this;
      var button = document.createElement('button');
      var isGrammarlyEnabled = function isGrammarlyEnabled() {
        return _this23.editor.scroll.domNode.parentElement !== _this23.editor.editorBody;
      };
      setTimeout(function () {
        var text = isGrammarlyEnabled() ? 'Disable grammarly' : 'Enable grammarly';
        button.innerText = text;
      }, 500);
      button.addEventListener('click', function (event) {
        if (isGrammarlyEnabled()) {
          _this23.editor.plugins.grammarlyManager.disconnect();
          button.innerText = 'Enable grammarly';
        } else {
          _this23.editor.plugins.grammarlyManager.connect();
          button.innerText = 'Disable grammarly';
        }
      });
      this.appendItem(button);
    }
  }, {
    key: "addUseAi",
    value: function addUseAi() {
      var _this24 = this;
      var button = document.createElement('button');
      button.innerHTML = 'Use AI for page';
      button.addEventListener('click', function (event) {
        _this24.editor.plugins.aiManager && _this24.editor.plugins.aiManager.promptForPage();
      });
      this.appendItem(button);
    }
  }, {
    key: "addShowRateEditor",
    value: function addShowRateEditor() {
      var select = document.createElement('select');
      select.id = 'rate-editor-show';
      select.style.cursor = 'pointer';
      select.style.marginRight = '5px';
      var options = ['hide rate editor', 'show rate editor'];
      var isCurrentRateEnabled = this.editor.plugins.editorRate.isEnabled();
      options.map(function (optVal) {
        var opt = document.createElement('option');
        opt.value = optVal;
        if (isCurrentRateEnabled && optVal === 'show rate editor') {
          opt.setAttribute('selected', 'selected');
        } else if (!isCurrentRateEnabled && optVal === 'hide rate editor') {
          opt.setAttribute('selected', 'selected');
        }
        opt.innerText = optVal;
        opt.style.cursor = 'pointer';
        select.appendChild(opt);
      });
      this.appendItem(select);
      select.addEventListener('change', this.showRateEditorEventHandler.bind(this));
    }
  }, {
    key: "showRateEditorEventHandler",
    value: function showRateEditorEventHandler(event) {
      event.preventDefault();
      if (event.isTrusted) {
        setCustomSettingsItem('rate-editor-show', event.target.value);
        document.location.reload();
      }
    }
  }]);
  return Toolbar;
}();
function toolbar_ValidURL(str) {
  var pattern = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
  return pattern.test(str);
}
var customSettingsKey = 'editor-custom-settings';
function setCustomSettingsItem(prop, value) {
  var customSettings = {};
  if (localStorage) {
    if (localStorage.hasOwnProperty(customSettingsKey)) {
      customSettings = JSON.parse(localStorage.getItem(customSettingsKey));
    }
    customSettings[prop] = value;
    localStorage.setItem(customSettingsKey, JSON.stringify(customSettings));
  }
}
function getCustomSettings() {
  var customSettings = {};
  if (localStorage && localStorage.hasOwnProperty(customSettingsKey)) {
    customSettings = JSON.parse(localStorage.getItem(customSettingsKey));
  }
  return customSettings;
}
/* harmony default export */ const toolbar = (Toolbar);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/util/y.js
var util_y = __webpack_require__(64467);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/store/store.js
function store_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = store_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function store_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return store_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return store_arrayLikeToArray(o, minLen); }
function store_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }











function store_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { store_typeof = function _typeof(obj) { return typeof obj; }; } else { store_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return store_typeof(obj); }
function store_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function store_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function store_createClass(Constructor, protoProps, staticProps) { if (protoProps) store_defineProperties(Constructor.prototype, protoProps); if (staticProps) store_defineProperties(Constructor, staticProps); return Constructor; }





var Store = /*#__PURE__*/function () {
  function Store(params) {
    store_classCallCheck(this, Store);
    this.y = params.y;
    this.Y = params.Y;
    this.types = {
      Map: this.Y.Map,
      Array: this.Y.Array,
      Text: this.Y.Text
    };
    this.QuillBinding = QuillBinding;
    this.root = this.y.get('root', this.types.Map);
    this.rootChildren = this.y.get('rootChildren', this.types.Array);
    this.blocks = this.y.get('blocks', this.types.Map);
    this.subDocs = this.y.get('subDocs', this.types.Map);
    this.cache = this.y.get('cache', this.types.Map);
  }
  store_createClass(Store, [{
    key: "destroy",
    value: function destroy() {
      this.y.destroy();
    }
  }, {
    key: "getSubStore",
    value: function getSubStore(subDoc) {
      return new Store({
        Y: this.Y,
        y: subDoc
      });
    }
  }, {
    key: "createSubDocument",
    value: function createSubDocument() {
      var subDoc = new this.Y.Doc();
      // mark it as already loaded
      subDoc.loaded = true;
      subDoc.load();
      this.subDocs.set(subDoc.guid, subDoc);
      return subDoc;
    }
    /*
      get root() {
        if(!this.blocks.get('root')) {
          let map = new this.types.Map()
          this.blocks.set('root', map)
        }
        return this.blocks.get('root')
      }
    */
  }, {
    key: "userId",
    get: function get() {
      return this.y.clientID;
    }
  }, {
    key: "getExceptionSafeObserver",
    value: function getExceptionSafeObserver(fn) {
      return function () {
        try {
          fn.apply(void 0, arguments);
        } catch (err) {
          setTimeout(function () {
            throw new Error('got an exception in yjs observer, that was handled gracefully, original stack trace: ' + err.stack);
          }, 0);
        }
      };
    }
  }, {
    key: "observe",
    value: function observe(typeInst, fn) {
      if (fn._exceptionSafeObserver) {
        throw new Error('editor internal error: fn already has _exceptionSafeObserver, consider making observers dynamically created functions');
      }
      // оборачиваем функцию-обсервер в другую функцию, которая отлавливает эксепшены внутри fn
      // это сделано, чтобы не нарушить внутреннее состояние yjs документа эксепшеном, возникшим после транзакции, на этапе
      // ее завершения
      fn._exceptionSafeObserver = this.getExceptionSafeObserver(fn);
      return typeInst.observe.call(typeInst, fn._exceptionSafeObserver);
    }
  }, {
    key: "unobserve",
    value: function unobserve(typeInst, fn) {
      var fnToUnobserve = fn;
      if (fn._exceptionSafeObserver) {
        fnToUnobserve = fn._exceptionSafeObserver;
        delete fn._exceptionSafeObserver;
      }
      return typeInst.unobserve.call(typeInst, fnToUnobserve);
    }
  }, {
    key: "observeDeep",
    value: function observeDeep(typeInst, fn) {
      fn._exceptionSafeObserver = this.getExceptionSafeObserver(fn);
      return typeInst.observeDeep.call(typeInst, fn._exceptionSafeObserver);
    }
  }, {
    key: "unobserveDeep",
    value: function unobserveDeep(typeInst, fn) {
      var fnToUnobserve = fn;
      if (fn._exceptionSafeObserver) {
        fnToUnobserve = fn._exceptionSafeObserver;
      }
      return typeInst.unobserveDeep.call(typeInst, fnToUnobserve);
    }

    /**
     * Создание map
     * @param { string } id?
     * @param { object } props?: значения, которые устанавливаются в map при создании
     * @returns { Ymap }
     */
  }, {
    key: "createMap",
    value: function createMap(id) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var map = new this.types.Map();
      // создаем айди сами, т.к. yjs делает создание айди при интеграции структуры, но мы не можем интегрировать
      // структуру в Map не зная ее айди(т.к. айди это ключ в Map-e)
      id = id || 'b' + this.y.clientID + '_' + (0,yjs.getState)(this.y.store, this.y.clientID);
      map.set('id', id);
      if (store_typeof(props) === 'object') {
        for (var key in props) {
          map.set(key, props[key]);
        }
      }
      this.blocks.set(id, map);
      return map;
    }
  }, {
    key: "createMapForBlot",
    value: function createMapForBlot(Blot) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var map = this.createMap();
      Blot.initMap(map, this, params);
      return map;
    }
  }, {
    key: "transaction",
    value: function transaction(fn, origin) {
      return this.y.transact(fn, origin);
    }
  }, {
    key: "getMap",
    value: function getMap(id) {
      return this.blocks.get(id);
    }
  }, {
    key: "pauseExternalUpdates",
    value: function pauseExternalUpdates() {
      this.y.pauseExternalUpdates();
    }
  }, {
    key: "resumeExternalUpdates",
    value: function resumeExternalUpdates() {
      this.y.resumeExternalUpdates();
    }
  }, {
    key: "copyBlotMap",
    value: function copyBlotMap(map, sourceStore) {
      var childrenKeys = ['children', 'caption'];
      console.log('Copy map', childrenKeys, map.toJSON());
      var Blot = src_parchment.query(map.get('type'));
      if (Blot && Blot.getChildrenKeys) {
        childrenKeys = Blot.getChildrenKeys();
      }
      var newMap = this.createMap(map.get('id'));
      try {
        (0,util_y.copyMap)(map, newMap, this);
      } catch (err) {
        throw err;
      }
      var _iterator = store_createForOfIteratorHelper(childrenKeys),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var childrenKey = _step.value;
          if (!map.has(childrenKey)) {
            continue;
          }
          var children = map.get(childrenKey);
          if (!(children instanceof this.types.Array)) {
            children = [children];
          }
          var _iterator2 = store_createForOfIteratorHelper(children),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var childID = _step2.value;
              var childMap = sourceStore.getMap(childID);
              this.copyBlotMap(childMap, sourceStore);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);
  return Store;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/dragAndDrop/dragSession.js
function dragSession_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = dragSession_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function dragSession_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return dragSession_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return dragSession_arrayLikeToArray(o, minLen); }
function dragSession_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }













function dragSession_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function dragSession_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function dragSession_createClass(Constructor, protoProps, staticProps) { if (protoProps) dragSession_defineProperties(Constructor.prototype, protoProps); if (staticProps) dragSession_defineProperties(Constructor, staticProps); return Constructor; }



var DND_BORDER_CLASS = 'dnd-border';
var TOP_BOTTOM_BORDER_DISTANCE = 0;
var BLOT_DROP_CLASS = 'on-blot-drop';
var DragSession = /*#__PURE__*/function () {
  function DragSession(params) {
    dragSession_classCallCheck(this, DragSession);
    this.blots = params.blots;
    this.hoverBlots = null;
    this.scroll = params.scroll;
    this.editor = params.editor;
    this.action = null;
    this.touch = params.touch;
    this.disablePhantoms = params.disablePhantoms;
    this.cursorPosition = null;
    // позиция курсора при начале d&d
    this.initCursorPosition = null;
    this.minSideDropDistance = params.minSideDropDistance;
    // признак контроллируемости, т.е. d&d плагин не будет устанавливать листенеры для сессии
    // а будет полагатся на вызовы его методов контроллером
    this.isControlled = params.isControlled || false;
    // сдесь хранятся элементы которые следуют за курсором при перемещении
    this.phantoms = null;
    this._scrollRect = null;
    this._gridColPaddingFirst = null;
    this._gridColPaddingLast = null;
    this._nodesRects = new Map();
    this._wholeContainersDragging = null;
    if (this.blots) {
      var _iterator = dragSession_createForOfIteratorHelper(this.blots),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var blot = _step.value;
          blot.setProps({
            dragging: true
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }
  dragSession_createClass(DragSession, [{
    key: "getEventsNames",
    value: function getEventsNames() {
      if (this.touch) {
        return {
          pointermove: 'touchmove',
          pointerup: 'touchend'
        };
      } else {
        return {
          pointermove: 'mousemove',
          pointerup: 'mouseup'
        };
      }
    }

    // вызывается только если isControlled = true
    // для других случаев надо передавать блоты в конструкторе
  }, {
    key: "setBlots",
    value: function setBlots(blots) {
      if (!this.isControlled) {
        throw new Error('DragSession#setBlots can only be called within a controlled session');
      }
      this.blots = blots;
    }
  }, {
    key: "setCursorPosition",
    value: function setCursorPosition(x, y) {
      this.cursorPosition = Object.freeze({
        x: x,
        y: y
      });
    }
  }, {
    key: "setInitCursorPosition",
    value: function setInitCursorPosition(x, y) {
      this.initCursorPosition = Object.freeze({
        x: x,
        y: y
      });
    }
  }, {
    key: "setPhantoms",
    value: function setPhantoms(phantoms) {
      this.phantoms = phantoms;
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      this.clearAction();
      var _iterator2 = dragSession_createForOfIteratorHelper(this.blots),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _this$editor, _this$editor$emitter;
          var blot = _step2.value;
          blot.setProps({
            dragging: false
          });
          (_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : (_this$editor$emitter = _this$editor.emitter) === null || _this$editor$emitter === void 0 ? void 0 : _this$editor$emitter.emit('drop', blot);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "clearAction",
    value: function clearAction() {
      if (!this.action) {
        return;
      }
      /*
      for(let blot of this.hoverBlots) {
        blot.setProps({
          dragAndDropHover: null
        })
      }*/
      this.action = null;
      this.hoverBlots = null;
      this.clearDrawBorders();
    }
  }, {
    key: "clearDrawBorders",
    value: function clearDrawBorders() {
      var borders = document.querySelectorAll('.' + DND_BORDER_CLASS);
      var _iterator3 = dragSession_createForOfIteratorHelper(borders),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var border = _step3.value;
          border.parentNode.removeChild(border);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      var withDropClassNodes = document.querySelectorAll('.' + BLOT_DROP_CLASS);
      var _iterator4 = dragSession_createForOfIteratorHelper(withDropClassNodes),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var node = _step4.value;
          node.classList.remove(BLOT_DROP_CLASS);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "getLeftDropBorder",
    value: function getLeftDropBorder(blot, scrollRect) {
      var gridCol = searchUp(blot, function (b) {
        return b instanceof blots_gridCol;
      });
      var left, top, height;
      if (gridCol) {
        var colPadding = this.getGridColPadding(gridCol);
        var gridColRect = gridCol.domNode.getBoundingClientRect();
        left = gridColRect.x + colPadding.left - this.minSideDropDistance;
        height = gridColRect.height - colPadding.bottom - colPadding.top;
        top = gridCol.children.head.domNode.getBoundingClientRect().y;
      } else {
        left = scrollRect.x - this.minSideDropDistance;
        var rect = blot.domNode.getBoundingClientRect();
        top = rect.y;
        height = rect.height;
        blot.domNode.classList.add(BLOT_DROP_CLASS);
      }
      return [left, top, 0, height];
    }
  }, {
    key: "getRightDropBorder",
    value: function getRightDropBorder(blot, scrollRect) {
      var left, top, height;
      var blotRect;
      var gridCol = searchUp(blot, function (b) {
        return b instanceof blots_gridCol;
      });
      if (gridCol) {
        var gridColRect = gridCol.domNode.getBoundingClientRect();
        blotRect = gridCol.children.head.domNode.getBoundingClientRect();
        top = blotRect.y;
        var colPadding = this.getGridColPadding(gridCol);
        height = gridColRect.height - colPadding.bottom - colPadding.top;
      } else {
        blotRect = blot.domNode.getBoundingClientRect();
        top = blotRect.y;
        height = blotRect.height;
        blot.domNode.classList.add(BLOT_DROP_CLASS);
      }
      left = blotRect.x + blotRect.width + this.minSideDropDistance;
      return [left, top, 0, height];
    }
  }, {
    key: "drawDropBorders",
    value: function drawDropBorders(action, blot) {
      var scrollRect = this.getScrollRect();
      var borderProps;
      var borderPosClass = '';
      if (action === 'left') {
        borderProps = this.getLeftDropBorder(blot, scrollRect);
        borderPosClass = 'vertical';
      } else if (action === 'right') {
        borderProps = this.getRightDropBorder(blot, scrollRect);
        borderPosClass = 'vertical';
      } else if (action === 'top') {
        var rect = blot.domNode.getBoundingClientRect();
        var _left = rect.x;
        var top = rect.y - TOP_BOTTOM_BORDER_DISTANCE;
        borderProps = [_left, top, rect.width, 0];
        borderPosClass = 'horizontal';
      } else if (action === 'bottom') {
        var _rect = blot.domNode.getBoundingClientRect();
        var _left2 = _rect.x;
        var _top = _rect.y + _rect.height + TOP_BOTTOM_BORDER_DISTANCE;
        borderProps = [_left2, _top, _rect.width, 0];
        borderPosClass = 'horizontal';
      } else if (action === 'inside') {
        var _rect2;
        var highlightNode = blot.domNode.getElementsByClassName('dnd-highlight');
        if (highlightNode.length) {
          _rect2 = highlightNode[0].getBoundingClientRect();
        } else {
          _rect2 = blot.domNode.getBoundingClientRect();
        }
        var _left3 = _rect2.x - 1;
        var _top2 = _rect2.y - 1;
        borderProps = [_left3, _top2, _rect2.width - 2, _rect2.height - 2];
        borderPosClass = 'inside';
      }
      var borderPropsString = borderProps.join('.');
      var currentBorder = document.querySelector('.' + DND_BORDER_CLASS);
      if (currentBorder) {
        if (currentBorder.getAttribute('data-props') === borderPropsString) {
          // не надо создавать новый бордер, т.к. старый имеет такие же свойства(позицию и размер)
          return;
        }
        currentBorder.parentNode.removeChild(currentBorder);
      }
      var border = document.createElement('div');
      var left;
      if (action === 'top' || action === 'bottom') {
        left = Math.max(borderProps[0], scrollRect.left);
      } else {
        left = borderProps[0];
      }
      var width = Math.min(scrollRect.width + scrollRect.left - left, borderProps[2]);
      border.setAttribute('data-props', borderPropsString);
      var scrollingContainerRect = this.editor.scrollingContainer.getBoundingClientRect();
      border.style.position = 'absolute';
      border.style.left = this.editor.scrollingContainer.scrollLeft + left - scrollingContainerRect.x + 'px';
      border.style.top = this.editor.scrollingContainer.scrollTop + borderProps[1] - scrollingContainerRect.y + 'px';
      border.style.width = width + 'px';
      border.style.height = borderProps[3] + 'px';
      border.classList.add(DND_BORDER_CLASS);
      border.classList.add(borderPosClass);
      this.editor.scrollingContainer.appendChild(border);
    }
  }, {
    key: "setAction",
    value: function setAction(action, blot) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.action = {
        action: action,
        blot: blot
      };
      this.drawDropBorders(action, blot, options.parentGridCol);
    }
  }, {
    key: "getAction",
    value: function getAction() {
      return this.action;
    }
  }, {
    key: "getScrollRect",
    value: function getScrollRect() {
      if (this._scrollRect) {
        return this._scrollRect;
      }
      return this.scroll.domNode.getBoundingClientRect();
    }
  }, {
    key: "getGridColPadding",
    value: function getGridColPadding(gridCol) {
      var key = '_gridColPaddingFirst';
      if (gridCol.prev) {
        key = '_gridColPaddingLast';
      }
      if (this[key] === null) {
        var p = (0,dom/* getComputedStyles */.AH)(gridCol.domNode, ['paddingLeft', 'paddingTop', 'paddingBottom', 'paddingRight'], 'px');
        this[key] = {
          left: p.paddingLeft,
          top: p.paddingTop,
          right: p.paddingRight,
          bottom: p.paddingBottom
        };
      }
      return this[key];
    }
  }, {
    key: "getNodeRect",
    value: function getNodeRect(node) {
      if (!this._nodesRects.has(node)) {
        this._nodesRects.set(node, node.getBoundingClientRect());
      }
      return this._nodesRects.get(node);
    }
  }, {
    key: "getInGridColPosition",
    value: function getInGridColPosition(gridCol, x) {
      var padding = this.getGridColPadding(gridCol).left;
      var rect = this.getNodeRect(gridCol.domNode);
      var relX = x - rect.x;
      var position = null;
      if (relX <= padding) {
        position = 'paddingLeft';
      } else if (relX >= rect.width - padding) {
        position = 'paddingRight';
      } else {
        position = 'body';
      }
      return position;
    }
  }, {
    key: "getWholeContainersDragging",
    value: function getWholeContainersDragging() {
      if (this._wholeContainersDragging) {
        return this._wholeContainersDragging;
      }
      this._wholeContainersDragging = [];
      var containersById = {};
      var containersBlotsCount = {};
      var _iterator5 = dragSession_createForOfIteratorHelper(this.blots),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var blot = _step5.value;
          var _container = blot.container;
          var _id = _container.id;
          if (!containersById[_id]) {
            containersById[_id] = _container;
          }
          if (!containersBlotsCount[_id]) {
            containersBlotsCount[_id] = 0;
          }
          containersBlotsCount[_id]++;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      var res = [];
      for (var id in containersById) {
        var container = containersById[id];
        var count = containersBlotsCount[id];
        if (count === container.children.length) {
          res.push(container);
        }
      }
      this._wholeContainersDragging = res;
      return this._wholeContainersDragging;
    }
  }, {
    key: "getMoveContext",
    value: function getMoveContext() {
      // контент для перемещения блотов, блоты могут записывать в него информацию о перемещении для совместного использования
      // сейчас используется listItem для перемещения нескольких элементов списка, чтобы после перемещения формировать целый список
      var context = {};
      return context;
    }
  }]);
  return DragSession;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/blockMenu/util.js
function blockMenu_util_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = blockMenu_util_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function blockMenu_util_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return blockMenu_util_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return blockMenu_util_arrayLikeToArray(o, minLen); }
function blockMenu_util_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function blockMenu_util_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { blockMenu_util_typeof = function _typeof(obj) { return typeof obj; }; } else { blockMenu_util_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return blockMenu_util_typeof(obj); }

























function buildMenuRecursively(items, blotsNames, blots) {
  var grouppedItems = groupMenuItems(items);
  var res = {};
  var align = items.align,
    indent = items.indent;
  for (var groupId in grouppedItems) {
    var itemsInGroup = grouppedItems[groupId];
    for (var itemId in itemsInGroup) {
      var item = Object.assign({}, itemsInGroup[itemId]);
      if (!isMenuItemAllowed(item, blotsNames, blots)) {
        continue;
      }
      if (!res[groupId]) {
        res[groupId] = {};
      }
      if (item.submenu) {
        item.submenu = buildMenuRecursively(item.submenu, blotsNames, blots);
      }
      res[groupId][itemId] = item;
    }
  }
  if (align || indent) {
    res.special = {};
    if (align) {
      res.special.align = true;
    }
    if (indent) {
      res.special.indent = true;
    }
  }
  return res;
}
function getBlotsNames(blots) {
  var names = [];
  blots.map(function (block) {
    if (names.indexOf(block.constructor.blotName == -1)) names.push(block.constructor.blotName);
  });
  return names;
}
//возвращает false если типы выделенных блотов разные и true если все выделенные блоты одного типа
function isOneTypeBlots(blots) {
  var blotsInProcess = Array.from(blots);
  var type = blotsInProcess[0] && blotsInProcess[0].constructor.blotName;
  blotsInProcess.shift();
  for (var _i = 0, _blotsInProcess = blotsInProcess; _i < _blotsInProcess.length; _i++) {
    var blot = _blotsInProcess[_i];
    if (blot.constructor.blotName !== type) {
      return false;
    }
  }
  return true;
}
function getMenuForBlots(blots) {
  var items = getAllMenuItemsForBlots(blots);
  var blotsNames = getBlotsNames(blots);
  return buildMenuRecursively(items, blotsNames, blots);
}
function getAllMenuItemsForBlots(blots) {
  //Получаем пункты меню со всех выделенных блоков
  var menu = {};
  //Переменные для временного отключения "Turn Into" и "Dublicate" пункта меню если выделен контент в нескольких колонках
  var turnInto = true;
  var duplicate = true;
  var currentCol = null;
  var hasBlockedBlock = false;
  blots.map(function (block) {
    var blockMenu = block.contextMenu;

    //Проверка для временного отключения "Turn Into" и "Dublicate" пункта меню если выделен контент в нескольких колонках
    if (currentCol !== null && currentCol !== findWithClass(block, blots_gridCol)) {
      turnInto = false;
      duplicate = false;
    }
    currentCol = findWithClass(block, blots_gridCol);
    if (block.isBlotLocked) {
      hasBlockedBlock = true;
    }
    Object.keys(blockMenu).map(function (item) {
      if (!menu[item]) menu[item] = blockMenu[item];
    });
  });
  if (hasBlockedBlock) {
    var allPargs = 0;
    var allLists = 0;
    var mix = 0;
    blots.map(function (block) {
      if (block instanceof paragraph || block instanceof hLarge || block instanceof hMedium || block instanceof hSmall || block instanceof blockquote || block instanceof hint) {
        allPargs++;
      } else if (block instanceof listItemBullet || block instanceof listItemNumber || block instanceof listItemCheckbox) {
        allLists++;
      } else {
        console.log('block', block);
        mix++;
      }
    });
    if (blots.length === allPargs) {
      if (menu['turn-into']) {
        menu['turn-into'].submenu.turnToChecklist = false;
        menu['turn-into'].submenu.turnToNumberList = false;
        menu['turn-into'].submenu.turnToBulletList = false;
        menu['turn-into'].submenu.turnToSyntax = false;
      }
    } else if (blots.length === allLists) {
      if (menu['turn-into']) {
        menu['turn-into'].submenu.turnToParagraph = false;
        menu['turn-into'].submenu.turnToLarge = false;
        menu['turn-into'].submenu.turnToMedium = false;
        menu['turn-into'].submenu.turnToSmall = false;
        menu['turn-into'].submenu.turnToBlockquote = false;
        menu['turn-into'].submenu.turnToHint = false;
        menu['turn-into'].submenu.turnToSyntax = false;
      }
    } else if (allPargs > 0 && allLists > 0 || mix > 0) {
      delete menu['turn-into'];
    }
  }

  //Если в меню есть пункт "Turn Into" и контент выделен в нескольких гридах то временно отключаем этот пункт до версии 2.0
  if (!turnInto && menu['turn-into']) {
    delete menu['turn-into'];
  }

  //Если в меню есть пункт "Dublicate" и контент выделен в нескольких гридах то временно отключаем этот пункт до версии 2.0
  if (!duplicate && menu['duplicate']) {
    delete menu['duplicate'];
  }
  return menu;
}
function groupMenuItems(items) {
  var groups = {};
  Object.keys(items).map(function (item) {
    if (blockMenu_util_typeof(items[item]) === 'object' && !Array.isArray(items[item])) {
      // только объекты, массивы исключаем
      items[item].id = item;
      if (!groups[items[item].group]) groups[items[item].group] = [];
      groups[items[item].group].push(items[item]);
    }
  });

  //сортируем пункты меню по индексам
  for (var group in groups) {
    groups[group] = groups[group].sort(function (a, b) {
      return a.index - b.index;
    });
  }
  return groups;
}
function isMenuItemAllowed(item, blotsNames) {
  var blots = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (blots && blots.length === 1) {
    return true;
  }
  var allow = true;
  if (item.stackable) {
    if (Array.isArray(item.stackable)) {
      blotsNames.map(function (name) {
        if (item.stackable.indexOf(name) == -1) allow = false;
      });
    }
  } else {
    allow = false;
  }
  return allow;
}
function getBlotsAlign(blots) {
  var align = false;
  var _iterator = blockMenu_util_createForOfIteratorHelper(blots),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var blot = _step.value;
      if (!align) {
        align = blot.map.get('align');
      } else {
        if (align !== blot.map.get('align')) {
          align = 'left';
          break;
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (!align) {
    align = 'left';
  }
  return align;
}
function getBlotsIndent(blots) {
  var indent = 0;
  var maxIndent = 0;
  var _iterator2 = blockMenu_util_createForOfIteratorHelper(blots),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var blot = _step2.value;
      if (blots.length === 1 && !blot.getIndent) {
        break;
      }
      if (!blot.getIndent) continue;
      if (indent < blot.getIndent()) {
        indent = blot.getIndent();
      }
      var blockMaxIndent = blot.constructor.getMaxIndent();
      if (maxIndent < blockMaxIndent) {
        maxIndent = blockMaxIndent;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return {
    current: indent,
    max: maxIndent
  };
}
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(33141);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/blockMenu/blockMenuColorPicker.js
function blockMenuColorPicker_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { blockMenuColorPicker_typeof = function _typeof(obj) { return typeof obj; }; } else { blockMenuColorPicker_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return blockMenuColorPicker_typeof(obj); }













function blockMenuColorPicker_toConsumableArray(arr) { return blockMenuColorPicker_arrayWithoutHoles(arr) || blockMenuColorPicker_iterableToArray(arr) || blockMenuColorPicker_unsupportedIterableToArray(arr) || blockMenuColorPicker_nonIterableSpread(); }
function blockMenuColorPicker_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function blockMenuColorPicker_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return blockMenuColorPicker_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return blockMenuColorPicker_arrayLikeToArray(o, minLen); }
function blockMenuColorPicker_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function blockMenuColorPicker_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return blockMenuColorPicker_arrayLikeToArray(arr); }
function blockMenuColorPicker_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function blockMenuColorPicker_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function blockMenuColorPicker_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function blockMenuColorPicker_createClass(Constructor, protoProps, staticProps) { if (protoProps) blockMenuColorPicker_defineProperties(Constructor.prototype, protoProps); if (staticProps) blockMenuColorPicker_defineProperties(Constructor, staticProps); return Constructor; }
function blockMenuColorPicker_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) blockMenuColorPicker_setPrototypeOf(subClass, superClass); }
function blockMenuColorPicker_setPrototypeOf(o, p) { blockMenuColorPicker_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return blockMenuColorPicker_setPrototypeOf(o, p); }
function blockMenuColorPicker_createSuper(Derived) { var hasNativeReflectConstruct = blockMenuColorPicker_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = blockMenuColorPicker_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = blockMenuColorPicker_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return blockMenuColorPicker_possibleConstructorReturn(this, result); }; }
function blockMenuColorPicker_possibleConstructorReturn(self, call) { if (call && (blockMenuColorPicker_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return blockMenuColorPicker_assertThisInitialized(self); }
function blockMenuColorPicker_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function blockMenuColorPicker_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function blockMenuColorPicker_getPrototypeOf(o) { blockMenuColorPicker_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return blockMenuColorPicker_getPrototypeOf(o); }



var blockMenuColorPicker_COLOR_ATTR = 'data-color-name';







var themesBackgroundOpacity = {
  'light': palette.opacityLight,
  'dark': palette.opacityDark,
  'brand-dark-ios': palette.opacityDark
};
var BlockMenuColorPicker = /*#__PURE__*/function (_Component) {
  blockMenuColorPicker_inherits(BlockMenuColorPicker, _Component);
  var _super = blockMenuColorPicker_createSuper(BlockMenuColorPicker);
  function BlockMenuColorPicker(props) {
    var _this;
    blockMenuColorPicker_classCallCheck(this, BlockMenuColorPicker);
    _this = _super.call(this, props);
    _this.state = {
      selectedColor: props.defaultColor
    };
    return _this;
  }
  blockMenuColorPicker_createClass(BlockMenuColorPicker, [{
    key: "onClickColor",
    value: function onClickColor(color, event) {
      var _this$props = this.props,
        execAction = _this$props.execAction,
        closeOnChoice = _this$props.closeOnChoice,
        onMenuItemExec = _this$props.onMenuItemExec;
      var execOptions = {};
      if (closeOnChoice === false) {
        execOptions.close = false;
      }
      event.preventDefault();
      onMenuItemExec(execAction, color, execOptions);
      if (!execOptions.close) {
        this.setState(function () {
          return {
            selectedColor: color
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var selectedColor = getMaterialColorName(this.state.selectedColor);
      var _this$props2 = this.props,
        onMouseDown = _this$props2.onMouseDown,
        onSubmenuRef = _this$props2.onSubmenuRef,
        noColor = _this$props2.noColor;
      var usePalette = lodash_default().clone(matColorNames);
      usePalette.push.apply(usePalette, blockMenuColorPicker_toConsumableArray(additionalColorNames));
      var noColorIcon = (0,preact_module.h)("div", {
        onClick: this.onClickColor.bind(this, noColor),
        className: 'color-menu-item'
      }, (0,preact_module.h)("div", {
        className: "color-icon"
      }, (0,preact_module.h)(icons/* IconNoColor */.voX, null)));
      return (0,preact_module.h)(popupMenu/* default */.Z, {
        addClassName: "block-menu-color-picker",
        key: "block-menu-color-picker",
        domRef: onSubmenuRef
      }, usePalette.map(function (colorName) {
        return (0,preact_module.h)(PopupColorItem, {
          idAttr: blockMenuColorPicker_COLOR_ATTR,
          key: colorName,
          onClick: _this2.onClickColor.bind(_this2, colorName),
          onMouseDown: onMouseDown,
          colorName: colorName,
          selected: selectedColor === colorName
        });
      }), noColorIcon);
    }
  }]);
  return BlockMenuColorPicker;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/blockMenu/blockMenuItem.js
function blockMenuItem_extends() { blockMenuItem_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return blockMenuItem_extends.apply(this, arguments); }

function blockMenuItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function blockMenuItem_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { blockMenuItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { blockMenuItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function blockMenuItem_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { blockMenuItem_typeof = function _typeof(obj) { return typeof obj; }; } else { blockMenuItem_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return blockMenuItem_typeof(obj); }
function blockMenuItem_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = blockMenuItem_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function blockMenuItem_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return blockMenuItem_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return blockMenuItem_arrayLikeToArray(o, minLen); }
function blockMenuItem_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


















function blockMenuItem_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function blockMenuItem_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function blockMenuItem_createClass(Constructor, protoProps, staticProps) { if (protoProps) blockMenuItem_defineProperties(Constructor.prototype, protoProps); if (staticProps) blockMenuItem_defineProperties(Constructor, staticProps); return Constructor; }
function blockMenuItem_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) blockMenuItem_setPrototypeOf(subClass, superClass); }
function blockMenuItem_setPrototypeOf(o, p) { blockMenuItem_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return blockMenuItem_setPrototypeOf(o, p); }
function blockMenuItem_createSuper(Derived) { var hasNativeReflectConstruct = blockMenuItem_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = blockMenuItem_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = blockMenuItem_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return blockMenuItem_possibleConstructorReturn(this, result); }; }
function blockMenuItem_possibleConstructorReturn(self, call) { if (call && (blockMenuItem_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return blockMenuItem_assertThisInitialized(self); }
function blockMenuItem_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function blockMenuItem_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function blockMenuItem_getPrototypeOf(o) { blockMenuItem_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return blockMenuItem_getPrototypeOf(o); }
function blockMenuItem_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var blockMenuItem_isEscKey = (0,lib/* default */.ZP)('esc');
var blockMenuListAppearDuration = (block_menu_default()).blockMenuListAppearDuration;
function singleMenuState() {
  var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var available = ['submenuVisible'];
  var state = {};
  for (var _i = 0, _available = available; _i < _available.length; _i++) {
    var item = _available[_i];
    if (item === active) {
      state[item] = true;
    } else {
      state[item] = false;
    }
  }
  return state;
}
var BlockMenuItem = /*#__PURE__*/function (_Component) {
  blockMenuItem_inherits(BlockMenuItem, _Component);
  var _super = blockMenuItem_createSuper(BlockMenuItem);
  function BlockMenuItem() {
    var _this;
    blockMenuItem_classCallCheck(this, BlockMenuItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    blockMenuItem_defineProperty(blockMenuItem_assertThisInitialized(_this), "onMouseDown", function (event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
    });
    blockMenuItem_defineProperty(blockMenuItem_assertThisInitialized(_this), "onRef", function (node) {
      _this.domNode = node;
    });
    blockMenuItem_defineProperty(blockMenuItem_assertThisInitialized(_this), "onSubmenuRef", function (node) {
      _this.submenuNode = node;
      if (!node) {
        if (_this.submenuPopper) {
          _this.submenuPopper.destroy();
          _this.submenuPopper = null;
        }
      } else {
        var allowFlip = true;
        var storeState = {};
        _this.submenuPopper = new popper/* default */.Z(_this.domNode, node, {
          placement: 'right-start',
          removeOnDestroy: true,
          onCreate: function onCreate() {
            // позволяем перевернутся меню только при начальном рендере
            allowFlip = false;
          },
          modifiers: {
            flip: {
              behavior: ['right', 'left', 'right'],
              fn: function fn(data, options) {
                if (!allowFlip) {
                  return Object.assign(data, storeState);
                }
                data = popper/* default.Defaults.modifiers.flip.fn */.Z.Defaults.modifiers.flip.fn(data, options);
                storeState = {
                  flipped: data.flipped,
                  placement: data.placement,
                  offsets: data.offsets
                };
                return data;
              },
              boundariesElement: _this.props.scrollingContainer
            },
            offset: {
              offset: '-11px, 0'
            },
            preventOverflow: {
              priority: ['bottom', 'top']
            }
          }
        });
      }
    });
    blockMenuItem_defineProperty(blockMenuItem_assertThisInitialized(_this), "renderItem", function (id, item) {
      var onClick = false;
      if (item.action && !item.submenu) {
        if (item.actionExec) {
          onClick = function onClick(event) {
            event.preventDefault();
            event.stopPropagation();
            _this.onMenuItemExec(item.action, item.actionParams);
          };
        } else {
          onClick = function onClick(event) {
            event.preventDefault();
            event.stopPropagation();
            _this.onMenuItemAction(item.action, item.actionParams);
          };
        }
      }

      //TODO:
      //Эту штуку хотел сделать в функции renderGroup в подфункции prepareGroup, где назначал item'y active = false, но почему то назначалось на глобальном уровне
      //и после конвертации, например, из параграфа в элемент списка, обратно в параграф уже не работало и пункт был отключен,
      //не понимаю с чем это связано потому что объекты клонировал, но не помогло потому перенес сюда.
      //Там эта функция вызывалась бы всего раз, когда пункт turn-into вызывает рендер своего подменю и готовит элементы к рендеру,
      //здесь же это обрабатывается столько, сколько имеется пунктов подменю.
      //Возможно я что то упустил и ошибку с глобальной заменой active можно поправить и оптимизировать этим обработку вызывая её всего один раз
      var disabledInConvert = false;
      //обработка пунктов меню конвертации: если выделенные блоки имеют один тип, то в меню конвертации пункт с этим типом нужно отключить
      /** processing turn-into item */
      if (_this.props.id === 'turn-into') {
        var blots = _this.props.getSelectedBlocks();
        var type = blots.length === 1 && _this.props.blot.constructor.blotName || isOneTypeBlots(blots) && _this.props.blot.constructor.blotName || false;
        if (type) {
          if (item.actionParams.type === type || item.actionParams.type === 'list' && item.actionParams.items[0] === type) {
            disabledInConvert = true;
          }
        }
      }
      /** end processing turn-into item */

      return (0,preact_module.h)(popupMenuItem/* default */.Z, {
        idAttr: _this.props.idAttr,
        id: id,
        disabled: item.active === false || disabledInConvert ? true : false,
        menuStyle: item.style || null,
        onClick: item.active !== false && !disabledInConvert && onClick,
        onMouseDown: _this.onMouseDown,
        icon: item.icon || null,
        text: item.label,
        hint: item.hint || null
      });
    });
    blockMenuItem_defineProperty(blockMenuItem_assertThisInitialized(_this), "renderColorPicker", function () {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0,preact_module.h)(BlockMenuColorPicker, {
        execAction: params.execAction || 'set-background',
        defaultColor: params.getSelectedColor ? params.getSelectedColor() : _this.getCurrentBackground(),
        noColor: params.hasOwnProperty('defaultColor') ? params.defaultColor : colorable.defaultBgColor,
        closeOnChoice: params.closeOnChoice,
        onMenuItemExec: _this.onMenuItemExec,
        onMouseDown: _this.onMouseDown,
        onSubmenuRef: _this.onSubmenuRef,
        theme: _this.props.theme,
        blot: _this.props.blot
      });
    });
    blockMenuItem_defineProperty(blockMenuItem_assertThisInitialized(_this), "getCurrentBackground", function () {
      var color = false;
      var _iterator = blockMenuItem_createForOfIteratorHelper(_this.props.selectedBlocks),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var block = _step.value;
          if (!block.getColor) continue;
          if (!color) {
            color = block.getColor();
          } else {
            if (color !== block.getColor()) {
              color = false;
              break;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return color !== colorable.defaultBgColor && color;
    });
    blockMenuItem_defineProperty(blockMenuItem_assertThisInitialized(_this), "renderGroup", function (group) {
      var prepareGroup = function prepareGroup(group) {
        return group.filter(function (item) {
          return _this.props.singleBlock ? true : _this.props.verifyItem(item);
        });
      };
      var items = prepareGroup(group);
      return (0,preact_module.h)("div", {
        className: "block-menu-group"
      }, items.map(function (item) {
        return _this.renderItem(item.id, item);
      }));
    });
    blockMenuItem_defineProperty(blockMenuItem_assertThisInitialized(_this), "groupItems", function (items) {
      var groups = {};
      Object.keys(items).map(function (item) {
        if (blockMenuItem_typeof(items[item]) === 'object') {
          items[item].id = item;
          if (!groups[items[item].group]) groups[items[item].group] = [];
          groups[items[item].group].push(items[item]);
        }
      });

      //сортируем пункты меню по индексам
      for (var group in groups) {
        groups[group] = groups[group].sort(function (a, b) {
          return a.index - b.index;
        });
      }
      return groups;
    });
    blockMenuItem_defineProperty(blockMenuItem_assertThisInitialized(_this), "onMouseEnter", function (event) {
      _this.setState(function (prevState) {
        var submenuVisible = prevState.submenuVisible;
        return singleMenuState(!submenuVisible && 'submenuVisible');
      });
    });
    blockMenuItem_defineProperty(blockMenuItem_assertThisInitialized(_this), "onMouseLeave", function (event) {
      _this.setState(function () {
        return singleMenuState();
      });
    });
    blockMenuItem_defineProperty(blockMenuItem_assertThisInitialized(_this), "onBodyKeyDown", function (event) {
      if (blockMenuItem_isEscKey(event) && _this.props.submenu) {
        event.stopPropagation();
        _this.setState(function (prevState) {
          var submenuVisible = prevState.submenuVisible;
          if (submenuVisible) {
            var currentSubmenu = _this.domNode.lastChild && _this.domNode.lastChild.firstChild && _this.domNode.lastChild.firstChild.className;
            var menues = _this.domNode.getElementsByClassName('popup-menu');
            if (menues.length === 1 || menues.length > 1 && currentSubmenu === 'popup-menu') {
              return {
                submenuVisible: false
              };
            }
          }
          return null;
        });
      }
    });
    blockMenuItem_defineProperty(blockMenuItem_assertThisInitialized(_this), "onMenuItemExec", /*#__PURE__*/function () {
      var _ref = blockMenuItem_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(action) {
        var params,
          options,
          skip,
          _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
                options = Object.assign({
                  close: true
                }, options);

                // При конвертации блота в bookmark если offline показываем сообщение об ошибке
                if (!(action === 'convert-blot' && params)) {
                  _context.next = 13;
                  break;
                }
                if (!(params.type === 'bookmark')) {
                  _context.next = 7;
                  break;
                }
                if (!(window.navigator && !window.navigator.onLine)) {
                  _context.next = 7;
                  break;
                }
                return _context.abrupt("return", editor.plugins.notificationManager.showError({
                  message: 'bookmarkOfflineAdd'
                }));
              case 7:
                if (!(params.type === 'syntax' || params.type === 'button-single')) {
                  _context.next = 13;
                  break;
                }
                _context.next = 10;
                return (0,util/* processConvertBlotWithComments */.Wv)(_this.props.blot.editor, _this.props.wantsToClose, params.type);
              case 10:
                skip = _context.sent;
                if (!skip) {
                  _context.next = 13;
                  break;
                }
                return _context.abrupt("return", false);
              case 13:
                _this.props.onExec(action, params);
                if (options.close) {
                  _this.props.wantsToClose();
                }
              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    blockMenuItem_defineProperty(blockMenuItem_assertThisInitialized(_this), "onMenuItemAction", function (action) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _this.props.onAction(action, params);
      _this.props.wantsToClose();
    });
    return _this;
  }
  blockMenuItem_createClass(BlockMenuItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (this.props.submenu) {
        this.dispatchEventTimeout = setTimeout(function () {
          document.body.addEventListener('keydown', _this2.onBodyKeyDown);
        }, 0);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.dispatchEventTimeout) {
        clearTimeout(this.dispatchEventTimeout);
      }
      if (this.props.submenu) {
        document.body.removeEventListener('keydown', this.onBodyKeyDown);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        id = _this$props.id,
        idAttr = _this$props.idAttr,
        menuStyle = _this$props.menuStyle,
        disabled = _this$props.disabled,
        submenu = _this$props.submenu,
        colorPickerParams = _this$props.colorPickerParams;
      var Icon = this.props.icon;
      var attrs = blockMenuItem_defineProperty({}, idAttr, id);
      var menuStyleClass = menuStyle ? ' menu-item-' + menuStyle : '';
      if (disabled) {
        menuStyleClass += ' disabled';
      }
      var child = null;
      var submenuVisible = this.state.submenuVisible;
      if (submenuVisible) {
        if (submenu) {
          if (blockMenuItem_typeof(submenu) === 'object') {
            var menu = this.groupItems(submenu);
            child = (0,preact_module.h)(popupMenu/* default */.Z, {
              addClassName: "block-menu-submenu",
              key: "block-menu-submenu",
              domRef: this.onSubmenuRef
            }, Object.keys(menu).map(function (group) {
              return _this3.renderGroup(menu[group]);
            }));
          } else {
            if (submenu === 'ColorPicker') {
              child = this['render' + submenu](colorPickerParams);
            } else {
              child = this['render' + submenu]();
            }
          }
        }
      }
      return (0,preact_module.h)("div", blockMenuItem_extends({}, attrs, {
        "data-menu-id": id,
        onClick: this.props.onClick,
        onMouseDown: this.onMouseDown,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        className: 'menu-item' + menuStyleClass,
        ref: this.onRef
      }), Icon ? (0,preact_module.h)("div", {
        className: "icon"
      }, (0,preact_module.h)(Icon, null)) : null, (0,preact_module.h)("div", {
        className: "text"
      }, this.props.text), this.props.hint ? (0,preact_module.h)("div", {
        className: "hint"
      }, this.props.hint) : null, (0,preact_module.h)(preact_transition_group/* default */.Z, {
        transitionName: "block-menu",
        transitionEnterTimeout: blockMenuListAppearDuration,
        transitionLeaveTimeout: blockMenuListAppearDuration
      }, child));
    }
  }]);
  return BlockMenuItem;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/scss/embedded-menu.scss
var embedded_menu = __webpack_require__(36372);
var embedded_menu_default = /*#__PURE__*/__webpack_require__.n(embedded_menu);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/popupMenuGroupHeader.js











function popupMenuGroupHeader_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { popupMenuGroupHeader_typeof = function _typeof(obj) { return typeof obj; }; } else { popupMenuGroupHeader_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return popupMenuGroupHeader_typeof(obj); }
function popupMenuGroupHeader_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function popupMenuGroupHeader_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function popupMenuGroupHeader_createClass(Constructor, protoProps, staticProps) { if (protoProps) popupMenuGroupHeader_defineProperties(Constructor.prototype, protoProps); if (staticProps) popupMenuGroupHeader_defineProperties(Constructor, staticProps); return Constructor; }
function popupMenuGroupHeader_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) popupMenuGroupHeader_setPrototypeOf(subClass, superClass); }
function popupMenuGroupHeader_setPrototypeOf(o, p) { popupMenuGroupHeader_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return popupMenuGroupHeader_setPrototypeOf(o, p); }
function popupMenuGroupHeader_createSuper(Derived) { var hasNativeReflectConstruct = popupMenuGroupHeader_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = popupMenuGroupHeader_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = popupMenuGroupHeader_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return popupMenuGroupHeader_possibleConstructorReturn(this, result); }; }
function popupMenuGroupHeader_possibleConstructorReturn(self, call) { if (call && (popupMenuGroupHeader_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return popupMenuGroupHeader_assertThisInitialized(self); }
function popupMenuGroupHeader_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function popupMenuGroupHeader_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function popupMenuGroupHeader_getPrototypeOf(o) { popupMenuGroupHeader_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return popupMenuGroupHeader_getPrototypeOf(o); }
function popupMenuGroupHeader_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var HEADER_MENU_CLASS = 'header-menu';
var PopupMenuGroupHeader = /*#__PURE__*/function (_Component) {
  popupMenuGroupHeader_inherits(PopupMenuGroupHeader, _Component);
  var _super = popupMenuGroupHeader_createSuper(PopupMenuGroupHeader);
  function PopupMenuGroupHeader(props) {
    var _this;
    popupMenuGroupHeader_classCallCheck(this, PopupMenuGroupHeader);
    _this = _super.call(this, props);
    popupMenuGroupHeader_defineProperty(popupMenuGroupHeader_assertThisInitialized(_this), "onRef", function (node) {
      _this.domNode = node;
    });
    popupMenuGroupHeader_defineProperty(popupMenuGroupHeader_assertThisInitialized(_this), "onArrowClick", function (event) {
      event.preventDefault();
      event.stopPropagation();
      var collapsible = _this.props.collapsible;
      var collapsed = collapsible && popupMenuGroupHeader_typeof(collapsible) === 'object' && !Array.isArray(collapsible) && collapsible.collapsed;
      if (_this.props.onExpandCollapse) {
        var nameArg = _this.props.name || _this.domRef;
        _this.props.onExpandCollapse(nameArg, !collapsed);
      }
    });
    popupMenuGroupHeader_defineProperty(popupMenuGroupHeader_assertThisInitialized(_this), "onArrowMouseDown", function (event) {
      event.preventDefault();
      event.stopPropagation();
    });
    var _collapsible = props.collapsible;
    _this.state = {
      collapsed: _collapsible && popupMenuGroupHeader_typeof(_collapsible) === 'object' && !Array.isArray(_collapsible) && _collapsible.collapsed
    };
    return _this;
  }
  popupMenuGroupHeader_createClass(PopupMenuGroupHeader, [{
    key: "render",
    value: function render() {
      var collapsible = this.props.collapsible;
      var collapsed = collapsible && popupMenuGroupHeader_typeof(collapsible) === 'object' && !Array.isArray(collapsible) && collapsible.collapsed;
      var classNames = [HEADER_MENU_CLASS];
      var collapseArrow = null;
      if (collapsible) {
        if (collapsed) {
          classNames.push('collapsed');
        }
        collapseArrow = (0,preact_module.h)("span", {
          className: "header-menu-arrow",
          onClick: this.onArrowClick,
          onMouseDown: this.onArrowMouseDown
        }, (0,preact_module.h)(icons/* IconMenuMoreDown */.v92, null));
      }
      if (this.props.className) {
        classNames.push(this.props.className);
      }
      return (0,preact_module.h)("div", {
        className: classNames.join(' '),
        ref: this.onRef
      }, (0,preact_module.h)("span", {
        className: "header-menu-title"
      }, this.props.children), collapseArrow);
    }
  }]);
  return PopupMenuGroupHeader;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/components/popupMenuLink.js
function popupMenuLink_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { popupMenuLink_typeof = function _typeof(obj) { return typeof obj; }; } else { popupMenuLink_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return popupMenuLink_typeof(obj); }










function popupMenuLink_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function popupMenuLink_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function popupMenuLink_createClass(Constructor, protoProps, staticProps) { if (protoProps) popupMenuLink_defineProperties(Constructor.prototype, protoProps); if (staticProps) popupMenuLink_defineProperties(Constructor, staticProps); return Constructor; }
function popupMenuLink_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) popupMenuLink_setPrototypeOf(subClass, superClass); }
function popupMenuLink_setPrototypeOf(o, p) { popupMenuLink_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return popupMenuLink_setPrototypeOf(o, p); }
function popupMenuLink_createSuper(Derived) { var hasNativeReflectConstruct = popupMenuLink_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = popupMenuLink_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = popupMenuLink_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return popupMenuLink_possibleConstructorReturn(this, result); }; }
function popupMenuLink_possibleConstructorReturn(self, call) { if (call && (popupMenuLink_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return popupMenuLink_assertThisInitialized(self); }
function popupMenuLink_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function popupMenuLink_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function popupMenuLink_getPrototypeOf(o) { popupMenuLink_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return popupMenuLink_getPrototypeOf(o); }
function popupMenuLink_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PopupMenuLink = /*#__PURE__*/function (_Component) {
  popupMenuLink_inherits(PopupMenuLink, _Component);
  var _super = popupMenuLink_createSuper(PopupMenuLink);
  function PopupMenuLink() {
    var _this;
    popupMenuLink_classCallCheck(this, PopupMenuLink);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    popupMenuLink_defineProperty(popupMenuLink_assertThisInitialized(_this), "onClick", function (event) {
      event.preventDefault();
      event.stopPropagation();
      var _this$props = _this.props,
        targetBlank = _this$props.targetBlank,
        url = _this$props.url;
      if (targetBlank) {
        window.open(url, '_blank');
      } else {
        window.open(url);
      }
    });
    popupMenuLink_defineProperty(popupMenuLink_assertThisInitialized(_this), "onMouseDown", function (event) {
      event.preventDefault();
      event.stopPropagation();
    });
    return _this;
  }
  popupMenuLink_createClass(PopupMenuLink, [{
    key: "render",
    value: function render() {
      return (0,preact_module.h)("div", {
        onClick: this.onClick,
        onMouseDown: this.onMouseDown,
        className: "link-menu-item"
      }, this.props.children);
    }
  }]);
  return PopupMenuLink;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/embeddedMenu/tooltips.json
const tooltips_namespaceObject = JSON.parse('{"paragraph":{"preview":"","url":""},"todo":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Checkbox_list.gif","url":"","for":"management"},"numberedlist":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Number_list.gif","url":"","for":"management"},"bulletlist":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Bullet_list.gif","url":"","for":"management"},"table":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Table.gif","url":"","for":"management"},"image":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Image.gif","url":"","for":"management"},"file":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Files.gif","url":"","for":"management"},"largeheading":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_heading_large.gif","url":"","for":"management"},"mediumheading":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_heading_medium.gif","url":"","for":"management"},"smallheading":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_heading_small.gif","url":"","for":"management"},"tasks-list":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Task_list.gif","url":"","for":"collaboration"},"hline":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Section_Break.gif","url":"","for":"management"},"link":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Link.gif","url":"","for":"management"},"syntax":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Code.gif","url":"","for":"collaboration"},"link-page":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Link_page.gif","url":"","for":"management"},"date":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Date.gif","url":"","for":"management"},"mention":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Member.gif","url":"","for":"collaboration"},"blockquote":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Quote.gif","url":"","for":"management"},"hint":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Hint.gif","url":"","for":"management"},"toggle":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Toggle_list.gif","url":"","for":"management"},"outline":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Outline.gif","url":"","for":"management"},"lock-blot":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Lock_Block.gif","url":"","for":"collaboration"},"embed":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Embed.gif","url":""},"figma":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Figma.gif","url":""},"miro":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_two_column.gif","url":""},"columns":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Miro.gif","url":""},"meeting-notes":{"preview":"","url":""},"marketing-brief":{"preview":"","url":""},"content-plan":{"preview":"","url":""},"integrations":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Embed.gif","url":""},"google-drive":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Google_drive.gif","url":""},"google-sheets":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Google_sheet.gif","url":""},"bookmark":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Bookmark.gif","url":"","for":"collaboration"},"audioRec":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Audio_Record.gif","url":"","for":"collaboration"},"videoRec":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Video_Record.gif","url":"","for":"collaboration"},"button":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Button.gif","url":"","for":"collaboration"},"largeheading-toggle":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_CollHead_Large.gif","url":"","for":"management"},"mediumheading-toggle":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_CollHead_Middle.gif","url":"","for":"management"},"smallheading-toggle":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_CollHead_Small.gif","url":"","for":"management"},"database-with-options":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Table.gif","url":""},"board":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Task_Board.gif","url":"","for":"collaboration"},"progress":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Progress.gif","url":"","for":"collaboration"},"uploader":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_File_Uploader.gif","url":"","for":"management"},"dropdown-list":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Dropdown_List.gif","url":"","for":"collaboration"},"use-ai":{"preview":"https://nimbusweb.me/editor-tips/238x138px_pm_4106_Use_Ai_new.gif","url":"","for":"collaboration"}}');
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/embeddedMenu/tooltipComponent.js





var ANCHOR_OPTIONS = {
  placement: 'left',
  behavior: ['left', 'right'],
  priority: ['left', 'right', 'bottom', 'top'],
  positionFixed: true,
  offset: '0, 12px'
};
var ARROW_CLASS = 'convert-menu-tooltip-arrow';
function TooltipComponent(props) {
  var editor = props.editor,
    id = props.id,
    onRef = props.onRef,
    anchorNode = props.anchorNode,
    _props$anchorOptions = props.anchorOptions,
    anchorOptions = _props$anchorOptions === void 0 ? {} : _props$anchorOptions,
    i18n = props.i18n;
  if (!id) return null;
  var title = i18n.get('convert_menu_tooltips.' + id + '.title');
  var description = i18n.get('convert_menu_tooltips.' + id + '.description');
  if (!tooltips_namespaceObject[id] && !title && !description) return null;
  var domNodeRef = (0,hooks_module/* useRef */.sO)(null);
  var forLabel = tooltips_namespaceObject[id] && tooltips_namespaceObject[id].for && i18n.get('convert_menu_tooltips.labels.' + tooltips_namespaceObject[id].for);
  var previewURL = tooltips_namespaceObject[id] && Boolean(tooltips_namespaceObject[id].preview) ? tooltips_namespaceObject[id].preview : false;
  var onLabelClick = function onLabelClick() {
    if (tooltips_namespaceObject[id] && tooltips_namespaceObject[id].url) {
      window.open(tooltips_namespaceObject[id].url, '_blank', 'noopener');
    }
  };
  var onMouseDown = function onMouseDown(event) {
    event.stopPropagation();
  };
  var arrow = document.createElement('div');
  arrow.classList.add(ARROW_CLASS);
  (0,hooks_module/* useEffect */.d4)(function () {
    if (domNodeRef.current && domNodeRef.current.domNode) {
      var currentArrowNode = domNodeRef.current.domNode.querySelector('.' + ARROW_CLASS);
      if (currentArrowNode) {
        domNodeRef.current.domNode.removeChild(currentArrowNode);
      }
      domNodeRef.current.domNode.appendChild(arrow);
      var domRect = domNodeRef.current.domNode.getBoundingClientRect();
      var anchorRect = anchorNode.getBoundingClientRect();
      var top = anchorRect.top - domRect.top;
      arrow.style.top = top + 8 + 'px';
    }
  }, [domNodeRef.current]);
  var anchOpts = Object.assign({
    boundariesElement: editor.getScrollingContainer(),
    overflowBoundariesElement: editor.getScrollingContainer(),
    arrow: {
      element: arrow
    }
  }, ANCHOR_OPTIONS, anchorOptions);
  return (0,preact_module.h)(popupMenu/* default */.Z, {
    ref: domNodeRef,
    domRef: onRef,
    anchorNode: anchorNode,
    anchorOptions: anchOpts,
    addClassName: "convert-menu-tooltip",
    onMouseDown: onMouseDown,
    onMouseEnter: this.props.onMouseEnter,
    onMouseLeave: this.props.onMouseLeave
  }, title ? (0,preact_module.h)("div", {
    className: "convert-menu-tooltip-title"
  }, title) : null, description ? (0,preact_module.h)("div", {
    className: "convert-menu-tooltip-description"
  }, description) : null, forLabel ? (0,preact_module.h)("div", {
    className: 'convert-menu-tooltip-label' + (tooltips_namespaceObject[id] && tooltips_namespaceObject[id].url ? ' link-label' : ''),
    onClick: onLabelClick
  }, forLabel) : null, previewURL ? (0,preact_module.h)("div", {
    className: "convert-menu-tooltip-preview"
  }, (0,preact_module.h)("img", {
    loading: "lazy",
    src: previewURL
  })) : null);
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/embeddedMenu/util.js
function util_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MENU_STATE_KEY = 'editor_menu_header_state';
function getMenuHeaderState(name) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var result = {
    collapsible: props.collapsible ? {
      collapsed: false
    } : false
  };
  if (localStorage.hasOwnProperty(MENU_STATE_KEY)) {
    try {
      var menuState = JSON.parse(localStorage.getItem(MENU_STATE_KEY));
      if (menuState[name] && menuState[name].collapsed) {
        result.collapsible = {
          collapsed: true
        };
      }
    } catch (err) {}
  }
  return result;
}
function setMenuHeaderState(name) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (localStorage.hasOwnProperty(MENU_STATE_KEY)) {
    try {
      var currentState = JSON.parse(localStorage.getItem(MENU_STATE_KEY));
      var newState = Object.assign({}, currentState, util_defineProperty({}, name, currentState[name] ? Object.assign({}, currentState[name], props) : props));
      localStorage.setItem(MENU_STATE_KEY, JSON.stringify(newState));
    } catch (err) {}
  } else {
    localStorage.setItem(MENU_STATE_KEY, JSON.stringify(util_defineProperty({}, name, props)));
  }
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/embeddedMenu/convertMenuComponent.js
function convertMenuComponent_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { convertMenuComponent_typeof = function _typeof(obj) { return typeof obj; }; } else { convertMenuComponent_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return convertMenuComponent_typeof(obj); }
function convertMenuComponent_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = convertMenuComponent_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function convertMenuComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return convertMenuComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return convertMenuComponent_arrayLikeToArray(o, minLen); }
function convertMenuComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


















function convertMenuComponent_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function convertMenuComponent_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function convertMenuComponent_createClass(Constructor, protoProps, staticProps) { if (protoProps) convertMenuComponent_defineProperties(Constructor.prototype, protoProps); if (staticProps) convertMenuComponent_defineProperties(Constructor, staticProps); return Constructor; }
function convertMenuComponent_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) convertMenuComponent_setPrototypeOf(subClass, superClass); }
function convertMenuComponent_setPrototypeOf(o, p) { convertMenuComponent_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return convertMenuComponent_setPrototypeOf(o, p); }
function convertMenuComponent_createSuper(Derived) { var hasNativeReflectConstruct = convertMenuComponent_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = convertMenuComponent_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = convertMenuComponent_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return convertMenuComponent_possibleConstructorReturn(this, result); }; }
function convertMenuComponent_possibleConstructorReturn(self, call) { if (call && (convertMenuComponent_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return convertMenuComponent_assertThisInitialized(self); }
function convertMenuComponent_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function convertMenuComponent_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function convertMenuComponent_getPrototypeOf(o) { convertMenuComponent_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return convertMenuComponent_getPrototypeOf(o); }
function convertMenuComponent_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/**
  Компонент меню конвертации/добавления блока.
  props:
    - wantsToClose - <Function> функция вызываемая при закрытии меню
    - menuMaxHeight - <Number> максимальная высота для меню
    - domRef - <Function> функция вызываемая при монтировании компонента в DOM
    - styles - <Object> дополнительные стили, которые нужно применить к меню
    - items - <Array> массив элементов меню, параметры элемента указаны ниже
    - onChooseItem - <Function> функция вызываемая при клике/выборе элемента

  Элемент массива items должен быть объектом содержащим следующие значения:
    - id - <String> идентификатор элемента
    - Icon - <Component> компонент иконки элемента (svg или React.Component)
    - hint - <String> описание хоткея
    - title - <String> название элемента
    - fn - <Function> функция передаваемая в onChooseItem
    - menuStyle - <String> стиль элемента (bold, bolder), по умолчанию undefined
*/











var CONVERT_MENU_MAX_HEIGHT = 340;
var ID_ATTR = 'data-menu-id';
var DEFAULT_ANCHOR_OPTIONS = {
  placement: 'bottom-start',
  behavior: ['bottom', 'top', 'bottom'],
  offset: '0, 0',
  priority: ['left', 'right'],
  boundariesElement: 'viewport'
};
var DISABLED_TOOLTIPS = [];
function RateEditor(_ref) {
  var onClick = _ref.onClick,
    onClose = _ref.onClose;
  return (0,preact_module.h)("div", {
    className: "rate-editor-in-menu",
    onClick: onClick,
    onMouseDown: function onMouseDown(event) {
      return event.preventDefault();
    }
  }, (0,preact_module.h)(icons/* IconStar */.GK, {
    className: "icon-star"
  }), (0,preact_module.h)("div", {
    className: "rate-editor-title"
  }, "Rate the Page Editor"), (0,preact_module.h)(icons/* IconChevronRight */.VG8, {
    className: "icon-chevron-right"
  }), (0,preact_module.h)(icons/* IconClose */.bMz, {
    className: "icon-close",
    onClick: onClose
  }));
}
var ConvertMenuComponent = /*#__PURE__*/function (_Component) {
  convertMenuComponent_inherits(ConvertMenuComponent, _Component);
  var _super = convertMenuComponent_createSuper(ConvertMenuComponent);
  function ConvertMenuComponent(props) {
    var _this;
    convertMenuComponent_classCallCheck(this, ConvertMenuComponent);
    _this = _super.call(this, props);
    convertMenuComponent_defineProperty(convertMenuComponent_assertThisInitialized(_this), "onRef", function (node) {
      _this.domNode = node;
      if (_this.props.domRef) {
        _this.props.domRef(node);
      }
    });
    convertMenuComponent_defineProperty(convertMenuComponent_assertThisInitialized(_this), "onTooltipRef", function (node) {
      _this.tooltipNode = node;
    });
    convertMenuComponent_defineProperty(convertMenuComponent_assertThisInitialized(_this), "onEnterAction", function (event, node) {
      event.preventDefault();
      var id = node.getAttribute('data-menu-id');
      var item = _this.props.items.find(function (el) {
        return el.id === id;
      });
      if (item) {
        _this.props.onChooseItem(item.fn);
      }
    });
    convertMenuComponent_defineProperty(convertMenuComponent_assertThisInitialized(_this), "onMenuItemMouseMove", function (event) {
      var target = event.target;
      var item = target.closest('.menu-item');
      if (!item) return;
      if (item.classList.contains('menu-item-selected')) return;
      Array.from(item.closest('.popup-menu').querySelectorAll('.menu-item')).forEach(function (node) {
        node.classList.remove('menu-item-selected');
      });
      item.classList.add('menu-item-selected');
    });
    convertMenuComponent_defineProperty(convertMenuComponent_assertThisInitialized(_this), "onMenuItemMouseEnter", function (event) {
      clearTimeout(_this.tooltipShowTimeout);
      clearTimeout(_this.tooltipHideTimeout);
      if (_this.state.tooltip) {
        _this.setState(function () {
          return {
            tooltip: null
          };
        });
      }
      var target = event.target;
      var itemNode = target.closest('.menu-item');
      if (itemNode) {
        var id = itemNode.getAttribute('data-menu-id');
        _this.tooltipShowTimeout = setTimeout(function () {
          _this.setState(function () {
            return {
              tooltip: {
                id: id,
                anchor: itemNode
              }
            };
          });
        }, 1000);
      }
    });
    convertMenuComponent_defineProperty(convertMenuComponent_assertThisInitialized(_this), "onMenuMouseLeave", function (event) {
      clearTimeout(_this.tooltipShowTimeout);
      if (_this.state.tooltip) {
        _this.tooltipHideTimeout = setTimeout(function () {
          _this.setState(function () {
            return {
              tooltip: null
            };
          });
        }, 1000);
      }
    });
    convertMenuComponent_defineProperty(convertMenuComponent_assertThisInitialized(_this), "onTooltipMouseEnter", function (event) {
      clearTimeout(_this.tooltipHideTimeout);
    });
    convertMenuComponent_defineProperty(convertMenuComponent_assertThisInitialized(_this), "onTooltipMouseLeave", function (event) {
      clearTimeout(_this.tooltipShowTimeout);
      if (_this.state.tooltip) {
        _this.tooltipHideTimeout = setTimeout(function () {
          _this.setState(function () {
            return {
              tooltip: null
            };
          });
        }, 1000);
      }
    });
    convertMenuComponent_defineProperty(convertMenuComponent_assertThisInitialized(_this), "onExpandCollapse", function (name, collapsed) {
      _this.setState(function () {
        return convertMenuComponent_defineProperty({}, name, {
          collapsed: collapsed
        });
      });
      setMenuHeaderState(name, {
        collapsed: collapsed
      });
    });
    convertMenuComponent_defineProperty(convertMenuComponent_assertThisInitialized(_this), "onRateEditorClick", function (event) {
      event.stopPropagation();
      _this.setState({
        rateEditorVisible: false
      });
      _this.props.onRateEditorClick();
    });
    convertMenuComponent_defineProperty(convertMenuComponent_assertThisInitialized(_this), "onRateEditorCloseClick", function (event) {
      event.stopPropagation();
      _this.setState({
        rateEditorVisible: false
      });
      _this.props.onRateEditorCloseClick();
    });
    var state = {};
    var items = _this.props.items;
    var _iterator = convertMenuComponent_createForOfIteratorHelper(items),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        if (item.type === 'header' && item.collapsible) {
          state[item.name] = {
            collapsed: item.collapsible.collapsed
          };
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    state.rateEditorVisible = true;
    _this.state = state;
    return _this;
  }
  convertMenuComponent_createClass(ConvertMenuComponent, [{
    key: "selectFirstItem",
    value: function selectFirstItem() {
      var container = this.domNode;
      if (this.props.containerNode) {
        container = this.props.containerNode;
      }
      if (container) {
        var items = Array.from(container.querySelectorAll('.menu-item'));
        if (items.length) {
          items.forEach(function (node) {
            return node.classList.remove('menu-item-selected');
          });
          items[0].classList.add('menu-item-selected');
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.selectFirstItem();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.items.length !== this.props.items.length) {
        this.selectFirstItem();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        wantsToClose = _this$props.wantsToClose,
        menuMaxHeight = _this$props.menuMaxHeight,
        styles = _this$props.styles,
        items = _this$props.items,
        onChooseItem = _this$props.onChooseItem,
        anchorNode = _this$props.anchorNode,
        anchorOptions = _this$props.anchorOptions,
        updatePosition = _this$props.updatePosition,
        i18n = _this$props.i18n;
      var tooltip = this.state.tooltip;
      var maxHeight = menuMaxHeight;
      if (!maxHeight || maxHeight < 0) {
        maxHeight = CONVERT_MENU_MAX_HEIGHT;
      }
      var PopupMenuComponent = updatePosition ? UpdateablePositionPopupMenu : popupMenu/* default */.Z;
      /* Блок с текстом и ссылкой обратной связи внизу меню, !!! пока отключаем его в компоненте */
      var footer = (0,preact_module.h)("div", {
        className: "convert-menu-footer"
      }, (0,preact_module.h)("div", {
        className: "convert-menu-footer-top"
      }, i18n.get('embedded_menu.footer_top')), (0,preact_module.h)("div", {
        className: "convert-menu-footer-bottom"
      }, i18n.get('embedded_menu.footer_bottom'), (0,preact_module.h)("a", {
        href: "https://support.nimbusweb.co/portal/en/newticket",
        target: "_blank"
      }, i18n.get('embedded_menu.footer_link'))));
      var skipItems = false;
      var headerI = 0;
      var rateEditorComponent = null;
      if (this.props.showEditorRate) {
        rateEditorComponent = this.state.rateEditorVisible && (0,preact_module.h)(RateEditor, {
          key: "rate-editor",
          onClick: this.onRateEditorClick,
          onClose: this.onRateEditorCloseClick
        });
      }
      return (0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)(PopupMenuComponent, {
        wantsToClose: wantsToClose,
        closeOnEsc: true,
        maxHeight: maxHeight,
        domRef: this.onRef,
        customStyles: styles,
        anchorNode: anchorNode,
        anchorOptions: Object.assign({}, DEFAULT_ANCHOR_OPTIONS, anchorOptions),
        keyNavigation: true,
        keyNavigationParams: {
          stickyHeader: true,
          headerHeight: 48
        },
        onEnterAction: this.onEnterAction,
        onMouseLeave: this.onMenuMouseLeave
      }, rateEditorComponent, items.map(function (item) {
        if (item.type) {
          if (item.type === 'header') {
            if (_this2.state[item.name] && _this2.state[item.name].collapsed) {
              skipItems = true;
            } else {
              skipItems = false;
            }
            return (0,preact_module.h)(PopupMenuGroupHeader, {
              className: headerI++ === 0 ? 'first-header' : '',
              name: item.name,
              collapsible: _this2.state[item.name] || false,
              onExpandCollapse: _this2.onExpandCollapse
            }, item.title);
          } else if (item.type === 'link') {
            if (skipItems) return null;
            var title = item.title,
              url = item.url,
              targetBlank = item.targetBlank;
            return (0,preact_module.h)(PopupMenuLink, {
              targetBlank: targetBlank,
              url: url
            }, title);
          }
        } else {
          if (skipItems) return null;
          var id = item.id,
            Icon = item.Icon,
            hint = item.hint,
            _title = item.title,
            fn = item.fn,
            menuStyle = item.menuStyle,
            isNew = item.isNew;
          return (0,preact_module.h)(popupMenuItem/* default */.Z, {
            idAttr: ID_ATTR,
            id: id,
            menuStyle: menuStyle,
            key: id,
            onClick: onChooseItem.bind(null, fn),
            icon: Icon,
            text: _title,
            hint: hint,
            isNew: isNew,
            onMenuItemMouseMove: _this2.onMenuItemMouseMove,
            onMenuItemEnter: _this2.onMenuItemMouseEnter,
            onMenuItemLeave: _this2.onMenuItemMouseLeave
          });
        }
      })), tooltip && !DISABLED_TOOLTIPS.includes(tooltip.id) ? (0,preact_module.h)(TooltipComponent, {
        id: tooltip.id,
        anchorNode: tooltip.anchor,
        onRef: this.onTooltipRef,
        i18n: i18n,
        editor: this.props.editor,
        onMouseEnter: this.onTooltipMouseEnter,
        onMouseLeave: this.onTooltipMouseLeave
      }) : null);
    }
  }]);
  return ConvertMenuComponent;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/embeddedMenu/groups.js
function groups_toConsumableArray(arr) { return groups_arrayWithoutHoles(arr) || groups_iterableToArray(arr) || groups_unsupportedIterableToArray(arr) || groups_nonIterableSpread(); }
function groups_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function groups_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return groups_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return groups_arrayLikeToArray(o, minLen); }
function groups_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function groups_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return groups_arrayLikeToArray(arr); }
function groups_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

















var groups = {
  'suggestions': {
    collapsible: true,
    items: ['board', 'tasks-list', 'step', 'step-aggregator', 'uploader', 'use-ai', 'mediumheading-toggle', 'link-page', 'audioRec', 'videoRec', 'integrations']
  },
  'basic': {
    items: ['largeheading', 'mediumheading', 'smallheading', 'paragraph', 'table', 'numberedlist', 'bulletlist', 'todo', 'toggle', 'link', 'hline', 'file', 'outline', 'lock-blot']
  },
  'advanced': {
    items: ['syntax', 'tasks-list', 'step', 'board', 'hint', 'progress', 'dropdown-list', 'blockquote', 'link-page', 'date', 'mention', 'button', 'largeheading-toggle', 'mediumheading-toggle', 'smallheading-toggle']
  },
  'media': {
    items: ['image', 'audioRec', 'videoRec', 'bookmark', 'unsplash']
  },
  'embed': {
    items: ['embed', 'google-drive', 'google-sheets', 'figma', 'miro', 'more-integrations']
  },
  'views': {
    items: ['columns', 'database-with-options']
  },
  'templates': {
    items: ['meeting-notes', 'marketing-brief', 'content-plan', 'more-templates']
  },
  'helpful_links': {
    items: ['get-feedback', 'contact-support', 'learn-nimbus']
  }
};
function groups_groupMenuItems(items, editor) {
  var groupItems = Object.keys(groups).reduce(function (result, key) {
    result[key] = items.filter(function (item) {
      return groups[key].items.includes(item.id);
    }).sort(function (a, b) {
      if (groups[key].items.indexOf(a.id) > groups[key].items.indexOf(b.id)) {
        return 1;
      } else if (groups[key].items.indexOf(a.id) < groups[key].items.indexOf(b.id)) {
        return -1;
      }
      return 0;
    });
    return result;
  }, {});
  return Object.keys(groupItems).reduce(function (result, key) {
    if (groupItems[key].length) {
      result.push(Object.assign({
        type: 'header',
        title: editor.plugins.i18n.get('convert_menu_groups.' + key),
        name: key
      }, getMenuHeaderState(key, groups[key])));
      result.push.apply(result, groups_toConsumableArray(groupItems[key]));
    }
    return result;
  }, []);
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/embeddedMenu/convertMenuItems.js
function convertMenuItems_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { convertMenuItems_typeof = function _typeof(obj) { return typeof obj; }; } else { convertMenuItems_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return convertMenuItems_typeof(obj); }
function convertMenuItems_toConsumableArray(arr) { return convertMenuItems_arrayWithoutHoles(arr) || convertMenuItems_iterableToArray(arr) || convertMenuItems_unsupportedIterableToArray(arr) || convertMenuItems_nonIterableSpread(); }
function convertMenuItems_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function convertMenuItems_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return convertMenuItems_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return convertMenuItems_arrayLikeToArray(o, minLen); }
function convertMenuItems_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function convertMenuItems_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return convertMenuItems_arrayLikeToArray(arr); }
function convertMenuItems_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
















function convertMenuItems_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function convertMenuItems_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function convertMenuItems_createClass(Constructor, protoProps, staticProps) { if (protoProps) convertMenuItems_defineProperties(Constructor.prototype, protoProps); if (staticProps) convertMenuItems_defineProperties(Constructor, staticProps); return Constructor; }
function convertMenuItems_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) convertMenuItems_setPrototypeOf(subClass, superClass); }
function convertMenuItems_setPrototypeOf(o, p) { convertMenuItems_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return convertMenuItems_setPrototypeOf(o, p); }
function convertMenuItems_createSuper(Derived) { var hasNativeReflectConstruct = convertMenuItems_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = convertMenuItems_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = convertMenuItems_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return convertMenuItems_possibleConstructorReturn(this, result); }; }
function convertMenuItems_possibleConstructorReturn(self, call) { if (call && (convertMenuItems_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return convertMenuItems_assertThisInitialized(self); }
function convertMenuItems_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function convertMenuItems_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function convertMenuItems_getPrototypeOf(o) { convertMenuItems_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return convertMenuItems_getPrototypeOf(o); }
function convertMenuItems_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








/*
  При добавлении новых элементов меню, нужно добвить их в соответствующие группы в ./group.js,
  а так же алиасы для них в ../convertMenuManager/alias.json
*/
var ConvertMenuItems = /*#__PURE__*/function (_Component) {
  convertMenuItems_inherits(ConvertMenuItems, _Component);
  var _super = convertMenuItems_createSuper(ConvertMenuItems);
  function ConvertMenuItems() {
    var _this;
    convertMenuItems_classCallCheck(this, ConvertMenuItems);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onRef", function (node) {
      _this.domRef = node;
      if (_this.props.onDomRef) {
        _this.props.onDomRef(node);
      }
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "convertBlot", function (params) {
      _this.props.convertBlot(params);
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickUseAi", function () {
      _this.props.onUseAi();
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickParagraph", function () {
      _this.convertBlot({
        type: 'paragraph'
      });
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickCheckboxList", function () {
      _this.convertBlot({
        type: 'list',
        items: ['listItemCheckbox']
      });
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickNumberList", function () {
      _this.convertBlot({
        type: 'list',
        items: ['listItemNumber']
      });
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickBulletList", function () {
      _this.convertBlot({
        type: 'list',
        items: ['listItemBullet']
      });
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickTable", function () {
      _this.convertBlot({
        type: 'table',
        rows: 2,
        cols: 3,
        batch: true
      });
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickImage", function () {
      _this.props.addImage();
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickFile", function () {
      _this.props.addFile();
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickTasksList", function () {
      _this.convertBlot({
        type: 'tasks-list'
      });
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickAudioRec", function () {
      var isExist = _this.props.editor.plugins.webRTCPlugin.isExistsRecords;
      if (!isExist.audio) {
        _this.convertBlot({
          type: 'file',
          audioRecord: true
        });
      } else {
        _this.props.editor.plugins.notificationManager.toast(_this.props.i18n.get('embedded_menu.recordExist'));
      }
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickVideoRec", function () {
      var isExist = _this.props.editor.plugins.webRTCPlugin.isExistsRecords;
      if (!isExist.media) {
        if (_this.props.wantsToClose) {
          _this.props.wantsToClose();
        }
        _this.props.editor.plugins.webRTCPlugin.prepareMediaRecord();
      } else {
        _this.props.editor.plugins.notificationManager.toast(_this.props.i18n.get('embedded_menu.recordExist'));
      }
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickLargeHeading", function () {
      _this.convertBlot({
        type: 'hLarge'
      });
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickMediumHeading", function () {
      _this.convertBlot({
        type: 'hMedium'
      });
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickSmallHeading", function () {
      _this.convertBlot({
        type: 'hSmall'
      });
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickBlockquote", function () {
      _this.convertBlot({
        type: 'blockquote'
      });
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickHint", function () {
      _this.convertBlot({
        type: 'hint'
      });
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickSyntax", function () {
      _this.convertBlot({
        type: 'syntax'
      });
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickHLine", function () {
      _this.convertBlot({
        type: 'hLine'
      });
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickLink", function (event) {
      _this.props.addLink(event);
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickMention", function (event) {
      _this.props.addMention();
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickProgress", function (event) {
      _this.props.addProgress();
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickDropdownList", function (event) {
      _this.props.addDropdownList();
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickOutline", function () {
      _this.convertBlot({
        type: 'outline'
      });
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickEmbed", function () {
      _this.convertBlot({
        type: 'remote-frame'
      });
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickBookmark", function () {
      // В десктоп режиме при конвертации блота в закладуку, показываем сообщение об ошибке
      if (window.navigator && !window.navigator.onLine) {
        return _this.props.editor.plugins.notificationManager.showError({
          message: 'bookmarkOfflineAdd'
        });
      }
      _this.convertBlot({
        type: 'bookmark'
      });
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickUnsplash", function () {
      _this.props.addUnsplashImage();
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickButton", function () {
      _this.convertBlot({
        type: 'button-single'
      });
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickGoogleDrive", function () {
      _this.props.addRemoteFile('google-drive');
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickToggle", function () {
      _this.convertBlot({
        type: 'toggle'
      });
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickStep", function () {
      _this.convertBlot({
        type: 'step'
      });
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickStepAggregator", function () {
      _this.props.addStepsAggregator();
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickLargeHeadingToggle", function () {
      _this.convertBlot({
        type: 'hLarge-toggle'
      });
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickMediumHeadingToggle", function () {
      _this.convertBlot({
        type: 'hMedium-toggle'
      });
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickSmallHeadingToggle", function () {
      _this.convertBlot({
        type: 'hSmall-toggle'
      });
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickLockBlot", function () {
      _this.props.lockBlot();
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickColumns", function () {
      _this.props.addColumns();
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickUrlItem", function (url) {
      window.open(url, '_blank');
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickDataBase", function () {
      _this.props.addDatabase('with-options');
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickMoreTemplates", function (event) {
      var _this$props$editor, _this$props$editor$pl;
      var emptyFeatures = (_this$props$editor = _this.props.editor) === null || _this$props$editor === void 0 ? void 0 : (_this$props$editor$pl = _this$props$editor.plugins) === null || _this$props$editor$pl === void 0 ? void 0 : _this$props$editor$pl.emptyFeatures;
      if (emptyFeatures && emptyFeatures.isMethodImplemented('useTemplate')) {
        emptyFeatures.options.useTemplate(event);
      }
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickBoard", function (event) {
      _this.convertBlot({
        type: 'board'
      });
    });
    convertMenuItems_defineProperty(convertMenuItems_assertThisInitialized(_this), "onClickUploader", function (event) {
      _this.convertBlot({
        type: 'uploader'
      });
    });
    return _this;
  }
  convertMenuItems_createClass(ConvertMenuItems, [{
    key: "getItems",
    value: function getItems() {
      var _this2 = this,
        _menu2,
        _this$props$editor$pl2,
        _this$props$editor$pl3,
        _editorOptions$user;
      var _this$props$editor2 = this.props.editor,
        _this$props$editor2$b = _this$props$editor2.blotsConfig,
        blotsConfig = _this$props$editor2$b === void 0 ? {
          hint: {},
          button: {},
          uploader: {}
        } : _this$props$editor2$b,
        plugins = _this$props$editor2.plugins,
        editorOptions = _this$props$editor2.options;
      var _ref = blotsConfig.hint || {},
        _ref$showMenuItem = _ref.showMenuItem,
        showHintMenuItem = _ref$showMenuItem === void 0 ? true : _ref$showMenuItem;
      var _ref2 = blotsConfig.uploader || {},
        _ref2$showMenuItem = _ref2.showMenuItem,
        showUploaderMenuItem = _ref2$showMenuItem === void 0 ? true : _ref2$showMenuItem;
      var _ref3 = blotsConfig.button || {},
        _ref3$showButtonForma = _ref3.showButtonFormat,
        showButtonFormat = _ref3$showButtonForma === void 0 ? true : _ref3$showButtonForma;
      var menu = [{
        id: 'paragraph',
        fn: this.onClickParagraph,
        title: this.props.i18n.get('embedded_menu.paragraph'),
        hint: false,
        Icon: icons/* IconParagraph2 */.LU4
      }, {
        id: 'todo',
        fn: this.onClickCheckboxList,
        title: this.props.i18n.get('embedded_menu.todo'),
        hint: browser/* modKey */.CF + '+shift+c',
        Icon: icons/* IconCheckbox */.bM7
      }, {
        id: 'numberedlist',
        fn: this.onClickNumberList,
        title: this.props.i18n.get('embedded_menu.numbered_list'),
        hint: browser/* modKey */.CF + '+shift+7',
        Icon: icons/* IconListNumber */.UcJ
      }, {
        id: 'bulletlist',
        fn: this.onClickBulletList,
        title: this.props.i18n.get('embedded_menu.bullet_list'),
        hint: browser/* modKey */.CF + '+shift+8',
        Icon: icons/* IconListBullet */.pfx
      }, {
        id: 'table',
        fn: this.onClickTable,
        title: this.props.i18n.get('embedded_menu.table'),
        hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+t',
        Icon: icons/* IconTable */.fqO
      }, this.props.editor.plugins.attachmentManager.isMethodImplemented('chooseFile') ? {
        id: 'image',
        fn: this.onClickImage,
        title: this.props.i18n.get('embedded_menu.image'),
        hint: browser/* modKey */.CF + '+shift+i',
        Icon: icons/* IconImage */.Zay
      } : null, this.props.editor.plugins.attachmentManager.isMethodImplemented('chooseFile') ? {
        id: 'file',
        fn: this.onClickFile,
        title: this.props.i18n.get('embedded_menu.file'),
        hint: browser/* modKey */.CF + '+shift+f',
        Icon: icons/* IconFileIcon */.F2P
      } : null, {
        id: 'largeheading',
        fn: this.onClickLargeHeading,
        title: this.props.i18n.get('embedded_menu.large_heading'),
        hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+1',
        Icon: icons/* IconHeaderLarge */.oIo
      }, {
        id: 'mediumheading',
        fn: this.onClickMediumHeading,
        title: this.props.i18n.get('embedded_menu.medium_heading'),
        hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+2',
        Icon: icons/* IconHeaderMedium */.L9t
      }, {
        id: 'smallheading',
        fn: this.onClickSmallHeading,
        title: this.props.i18n.get('embedded_menu.small_heading'),
        hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+3',
        Icon: icons/* IconHeaderSmall */.Q2d
      }, {
        id: 'tasks-list',
        fn: this.onClickTasksList,
        title: this.props.i18n.get('embedded_menu.tasks_list'),
        hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+d',
        Icon: icons/* IconChecklist */.$Nx
      }, {
        id: 'hline',
        fn: this.onClickHLine,
        title: this.props.i18n.get('embedded_menu.section_break'),
        hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+l',
        Icon: icons/* IconHLine */.uVN
      }, {
        id: 'link',
        fn: this.onClickLink,
        title: this.props.i18n.get('embedded_menu.link'),
        hint: browser/* modKey */.CF + '+k',
        Icon: icons/* IconLinkDiag */.n4p
      }, {
        id: 'syntax',
        fn: this.onClickSyntax,
        title: this.props.i18n.get('embedded_menu.code'),
        hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+c',
        Icon: icons/* IconSyntax */.UUr
      }, {
        id: 'link-page',
        fn: this.onClickMention,
        title: this.props.i18n.get('embedded_menu.link_page'),
        Icon: icons/* IconLinkDiag */.n4p
      }, {
        id: 'date',
        fn: this.onClickMention,
        title: this.props.i18n.get('embedded_menu.date'),
        Icon: icons/* IconCalendar */.jt6
      }, {
        id: 'mention',
        fn: this.onClickMention,
        title: this.props.i18n.get('embedded_menu.mention'),
        hint: '@',
        Icon: icons/* IconMention */.fan
      }, {
        id: 'blockquote',
        fn: this.onClickBlockquote,
        title: this.props.i18n.get('embedded_menu.quote'),
        hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+y',
        Icon: icons/* IconQuote */.kVp
      }].concat(convertMenuItems_toConsumableArray(showHintMenuItem ? [{
        id: 'hint',
        fn: this.onClickHint,
        title: this.props.i18n.get('embedded_menu.hint'),
        hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+u',
        Icon: icons/* IconHint */.qE2
      }] : []), [{
        id: 'toggle',
        fn: this.onClickToggle,
        title: this.props.i18n.get('embedded_menu.toggle'),
        hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+6',
        Icon: icons/* IconToggle */.oe4
      }, {
        id: 'outline',
        fn: this.onClickOutline,
        title: this.props.i18n.get('embedded_menu.outline'),
        hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+o',
        Icon: icons/* IconOutline */.RS2
      }, {
        id: 'embed',
        fn: this.onClickEmbed,
        title: this.props.i18n.get('embedded_menu.remote_frame'),
        hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+m',
        Icon: icons/* IconEmbed */.g9E
      }, {
        id: 'figma',
        fn: this.onClickEmbed,
        title: 'Figma',
        // тут не стал делать перевод, так как сервисы на всех языках вроде одинаково называются
        hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+m',
        Icon: icons/* IconFigma */.JCH
      }, {
        id: 'miro',
        fn: this.onClickEmbed,
        title: 'Miro',
        hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+m',
        Icon: icons/* IconMiro */.k8B
      }, {
        id: 'more-integrations',
        type: 'link',
        title: this.props.i18n.get('embedded_menu.more_integrations'),
        url: 'https://nimbusweb.me/share/4194126/vnl68c44bszs9pqiwpip'
      }, {
        id: 'columns',
        fn: this.onClickColumns,
        title: this.props.i18n.get('embedded_menu.two_columns'),
        Icon: icons/* IconColumns */.eYc
      }, {
        id: 'meeting-notes',
        fn: function fn() {
          _this2.onClickUrlItem('https://nimbusweb.me/note-templates/detail.php?id=6HHaR2aS7r0WbNxV');
        },
        title: this.props.i18n.get('embedded_menu.meeting_notes'),
        Icon: icons/* IconTemplate */._9F
      }, {
        id: 'marketing-brief',
        fn: function fn() {
          _this2.onClickUrlItem('https://nimbusweb.me/note-templates/detail.php?id=FgNTM4G6sUvELk4c');
        },
        title: this.props.i18n.get('embedded_menu.marketing_brief'),
        Icon: icons/* IconTemplate */._9F
      }, {
        id: 'content-plan',
        fn: function fn() {
          _this2.onClickUrlItem('https://nimbusweb.me/note-templates/detail.php?id=yql2nKLoxs4AQazr');
        },
        title: this.props.i18n.get('embedded_menu.content_plan'),
        Icon: icons/* IconTemplate */._9F
      }, {
        id: 'more-templates',
        title: this.props.i18n.get('embedded_menu.more_templates'),
        fn: this.onClickMoreTemplates,
        menuStyle: 'link'
      }, {
        id: 'get-feedback',
        fn: function fn() {
          _this2.onClickUrlItem('https://support.nimbusweb.co/portal/en/newticket');
        },
        title: this.props.i18n.get('embedded_menu.get_feedback'),
        Icon: icons/* IconFeedback */.Rz4
      }, {
        id: 'contact-support',
        fn: function fn() {
          _this2.onClickUrlItem('https://support.nimbusweb.co/portal/en/newticket');
        },
        title: this.props.i18n.get('embedded_menu.contact_support'),
        Icon: icons/* IconSupport */.M64
      }, {
        id: 'learn-nimbus',
        fn: function fn() {
          _this2.onClickUrlItem('https://nimbusweb.me/s/share/4196282/063i1t5kiqlf3gcgm5ny');
        },
        title: this.props.i18n.get('embedded_menu.learn_nimbus'),
        Icon: icons/* IconLearn */.jhZ
      }, {
        id: 'integrations',
        fn: this.onClickEmbed,
        title: this.props.i18n.get('embedded_menu.integrations'),
        hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+m',
        Icon: icons/* IconEmbed */.g9E
      }, {
        id: 'database-with-options',
        fn: this.onClickDataBase,
        title: this.props.i18n.get('embedded_menu.database_with_options'),
        Icon: icons/* IconDatabase */.OQ8
      }]);
      if (this.props.editor.plugins.remoteFileManager.isServiceSupported('google-drive')) {
        var _menu;
        (_menu = menu).push.apply(_menu, [{
          id: 'google-drive',
          fn: this.onClickGoogleDrive,
          title: this.props.i18n.get('embedded_menu.google_drive'),
          hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+g',
          Icon: icons/* IconGoogleDrive */.dhu
        }, {
          id: 'google-sheets',
          fn: this.onClickGoogleDrive,
          title: this.props.i18n.get('embedded_menu.google_sheets'),
          hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+g',
          Icon: icons/* IconGoogleDrive */.dhu
        }]);
      }
      menu.push({
        id: 'bookmark',
        fn: this.onClickBookmark,
        title: this.props.i18n.get('bookmark.name'),
        hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+b',
        Icon: icons/* IconBookmark */.BZM
      });
      if (this.props.editor.plugins.unsplashManager.enabled) {
        menu.push({
          id: 'unsplash',
          fn: this.onClickUnsplash,
          title: 'Unsplash',
          hint: false,
          Icon: icons/* IconImage */.Zay,
          isNew: true
        });
      }
      if (this.props.editor.plugins.attachmentManager.isMethodImplemented('chooseFile')) {
        menu.push({
          id: 'audioRec',
          fn: this.onClickAudioRec,
          title: this.props.i18n.get('embedded_menu.audioRec'),
          hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+8',
          Icon: icons/* IconAudioRec */.kFg
        });
        if ((0,browser/* detectBrowser */.Ao)() !== 'Safari') {
          menu.push({
            id: 'videoRec',
            fn: this.onClickVideoRec,
            title: this.props.i18n.get('embedded_menu.videoRec'),
            hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+9',
            Icon: icons/* IconVideoRec */.cx1
          });
        }
      }
      if (showButtonFormat) {
        menu.push({
          id: 'button',
          fn: this.onClickButton,
          title: this.props.i18n.get('floating_toolbar.button'),
          hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+5',
          Icon: icons/* IconButton */.hU
        });
      }
      (_menu2 = menu).push.apply(_menu2, [{
        id: 'largeheading-toggle',
        fn: this.onClickLargeHeadingToggle,
        title: this.props.i18n.get('embedded_menu.large_heading_toggle'),
        hint: false,
        Icon: icons/* IconLargeHeaderToggle */.THL
      }, {
        id: 'mediumheading-toggle',
        fn: this.onClickMediumHeadingToggle,
        title: this.props.i18n.get('embedded_menu.medium_heading_toggle'),
        hint: false,
        Icon: icons/* IconMediumHeaderToggle */.V6h
      }, {
        id: 'smallheading-toggle',
        fn: this.onClickSmallHeadingToggle,
        title: this.props.i18n.get('embedded_menu.small_heading_toggle'),
        hint: false,
        Icon: icons/* IconSmallHeaderToggle */.gM0
      }]);
      if ((_this$props$editor$pl2 = this.props.editor.plugins.boardManager) !== null && _this$props$editor$pl2 !== void 0 && (_this$props$editor$pl3 = _this$props$editor$pl2.options) !== null && _this$props$editor$pl3 !== void 0 && _this$props$editor$pl3.enabled) {
        menu.push({
          id: 'board',
          fn: this.onClickBoard,
          title: this.props.i18n.get('embedded_menu.board'),
          hint: false,
          Icon: icons/* IconBoard */.ve2,
          isNew: true
        });
      }
      menu.push({
        id: 'progress',
        fn: this.onClickProgress,
        title: this.props.i18n.get('embedded_menu.progress'),
        hint: false,
        Icon: icons/* IconProgress */.Gw5,
        isNew: true
      }, {
        id: 'dropdown-list',
        fn: this.onClickDropdownList,
        title: this.props.i18n.get('embedded_menu.dropdown_list'),
        hint: false,
        Icon: icons/* IconTypeSingleselect */.Rd8,
        isNew: true
      });
      if (showUploaderMenuItem) {
        menu.push({
          id: 'uploader',
          fn: this.onClickUploader,
          title: this.props.i18n.get('embedded_menu.uploader'),
          hint: false,
          Icon: icons/* IconDownload */.DjJ,
          isNew: true
        });
      }
      if (this.props.editor.plugins.aiManager.enabled) {
        menu.push({
          id: 'use-ai',
          fn: this.onClickUseAi,
          title: this.props.i18n.get('embedded_menu.use_ai'),
          hint: false,
          Icon: icons/* IconPromtIcon */.nST,
          isNew: true
        });
      }
      menu.push({
        id: 'step',
        fn: this.onClickStep,
        title: this.props.i18n.get('embedded_menu.step'),
        hint: false,
        Icon: icons/* IconStep */.tuc,
        isNew: true
      }, {
        id: 'step-aggregator',
        fn: this.onClickStepAggregator,
        title: 'Step outliner',
        hint: false,
        Icon: icons/* IconStep */.tuc,
        isNew: true
      });

      // show lock-blot menu item if user has access blot locking or plugin featuresAvailabilityPlugin is avaliable
      var showBlotLockItem = editorOptions.manageBlotsLock && ((_editorOptions$user = editorOptions.user) === null || _editorOptions$user === void 0 ? void 0 : _editorOptions$user.manage) === 'full' || plugins.featuresAvailabilityPlugin && plugins.featuresAvailabilityPlugin.enabled;
      if (showBlotLockItem) {
        var blocksLockEe = new (events_default())();
        var onLockBlotMouseEnter = function onLockBlotMouseEnter() {
          blocksLockEe.emit('enter', {});
        };
        var onLockBlotMouseLeave = function onLockBlotMouseLeave() {
          blocksLockEe.emit('leave', {});
        };
        var lockBlotAvailabilityIcon = plugins.featuresAvailabilityPlugin.getFeatureIcon('blocks-lock', blocksLockEe);
        menu.push({
          id: 'lock-blot',
          fn: this.onClickLockBlot,
          title: (0,preact_module.h)("div", {
            onMouseEnter: onLockBlotMouseEnter,
            onMouseLeave: onLockBlotMouseLeave
          }, this.props.i18n.get('embedded_menu.lock_blot'), lockBlotAvailabilityIcon),
          Icon: icons/* IconLock */._V1
        });
      }
      if (this.props.excludeItems && this.props.excludeItems.length) {
        menu = menu.filter(function (item) {
          return !_this2.props.excludeItems.includes(item.id);
        });
      }
      return groups_groupMenuItems(menu, this.props.editor);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        wantsToClose = _this$props.wantsToClose,
        menuKey = _this$props.menuKey,
        onChooseMenuItem = _this$props.onChooseMenuItem,
        anchorNode = _this$props.anchorNode,
        anchorOptions = _this$props.anchorOptions,
        getStyles = _this$props.getStyles,
        updatePosition = _this$props.updatePosition,
        containerNode = _this$props.containerNode,
        i18n = _this$props.i18n;
      var items = this.getItems();
      var _getStyles = getStyles(items.length),
        menuMaxHeight = _getStyles.menuMaxHeight,
        overflowY = _getStyles.overflowY,
        offset = _getStyles.offset;
      if (offset) {
        anchorOptions.offset = offset;
      }
      return (0,preact_module.h)(ConvertMenuComponent, {
        wantsToClose: wantsToClose,
        menuMaxHeight: menuMaxHeight,
        key: menuKey,
        domRef: this.onRef,
        styles: {
          overflowY: overflowY
        },
        items: items,
        onChooseItem: onChooseMenuItem,
        anchorNode: anchorNode,
        anchorOptions: anchorOptions,
        updatePosition: updatePosition,
        containerNode: containerNode,
        i18n: i18n,
        editor: this.props.editor,
        onRateEditorClick: this.props.onRateEditorClick,
        onRateEditorCloseClick: this.props.onRateEditorCloseClick,
        showEditorRate: this.props.showEditorRate
      });
    }
  }]);
  return ConvertMenuItems;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/attachmentManager/index.js
function attachmentManager_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = attachmentManager_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function attachmentManager_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return attachmentManager_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return attachmentManager_arrayLikeToArray(o, minLen); }
function attachmentManager_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }












function attachmentManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function attachmentManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function attachmentManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) attachmentManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) attachmentManager_defineProperties(Constructor, staticProps); return Constructor; }
function attachmentManager_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PSEUDO_IMG_ATTACHMENT_PREFIX = 'psimg:';
function getPseudoImageAttachmentId(url) {
  return PSEUDO_IMG_ATTACHMENT_PREFIX + url;
}
function _isPseudoAttachment(globalId) {
  return globalId.indexOf(PSEUDO_IMG_ATTACHMENT_PREFIX) === 0;
}

var AttachmentManager = /*#__PURE__*/function () {
  function AttachmentManager(_ref) {
    var _this = this;
    var scroll = _ref.scroll,
      editor = _ref.editor,
      options = _ref.options;
    attachmentManager_classCallCheck(this, AttachmentManager);
    attachmentManager_defineProperty(this, "rotateImage", function (globalId) {
      return _this.options.rotateImage(globalId);
    });
    attachmentManager_defineProperty(this, "allowRotateImage", function (globalId) {
      if (_this.isMethodImplemented('allowRotateImage')) {
        return _this.options.allowRotateImage(globalId);
      }
      return true;
    });
    attachmentManager_defineProperty(this, "editImage", function (globalId) {
      if (_this.options.editImage) {
        return _this.options.editImage(globalId);
      } else {
        return false;
      }
    });
    this.editor = editor;
    this.scroll = scroll;
    this.options = options || {};
  }
  attachmentManager_createClass(AttachmentManager, [{
    key: "isPseudoAttachment",
    value: function isPseudoAttachment(globalId) {
      return _isPseudoAttachment(globalId);
    }
  }, {
    key: "getMaxFileSize",
    value: function getMaxFileSize() {
      return this.options.maxFileSize;
    }
  }, {
    key: "checkFileSize",
    value: function checkFileSize(size) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (opts.maxFileSize) {
        return size < opts.maxFileSize;
      }
      if (!this.options.maxFileSize) {
        return true;
      }
      if (size > this.options.maxFileSize) {
        return false;
      }
      return true;
    }
  }, {
    key: "nFileFromWebFile",
    value: function nFileFromWebFile(webFile) {
      return {
        instance: webFile,
        name: webFile.name,
        size: webFile.size,
        type: webFile.type
      };
    }
  }, {
    key: "isMethodImplemented",
    value: function isMethodImplemented(method) {
      return Boolean(this.options[method]);
    }

    /**
     * возвращает http адресс аттача по globalId
     * @param  {string} globalId
     * @param  {object} [options]
     * @param  {object} [options.blotName]
     * @return {Promise<Attachment>}
     */
  }, {
    key: "resolve",
    value: function resolve(globalId) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (globalId.indexOf && this.isPseudoAttachment(globalId)) {
        var url = globalId.substring(PSEUDO_IMG_ATTACHMENT_PREFIX.length);
        return Promise.resolve({
          global_id: globalId,
          url: url,
          type: 'image'
        });
      }
      return this.options.resolve(globalId, options);
    }

    /**
     * открывает окно для выбора файла
     * @param {Object} options - опции выбора файлов
     *                 options.multiple - выбор нескольких файлов за один раз
     *                 options.accept - ограничить выбор пользователю по типу файла, больше информации о формате этого поле
     *                                  можно увидеть тут https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-accept
     *                 options.source - источник файла, это опция сообщает приложению откуда должен быть получен файл
     * @return {Promise} промис резолвится в объект NFile, или в null если пользователь отменил выбор
     */
  }, {
    key: "chooseFile",
    value: function chooseFile() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.options.chooseFile(options);
    }

    /**
     * закачивает файл по URL
     * @param {string} URL файла
     * @return {Promise} промис резолвится в объект NFile
     */
  }, {
    key: "chooseFileFromUrl",
    value: function chooseFileFromUrl(url) {
      if (this.options.chooseFileFromUrl) {
        return this.options.chooseFileFromUrl(url);
      } else {
        // проверяем корректность урл и пробуем загрузить изображение,
        // если урл не является ссылкой или изображение не возможно загрузить возвращаем ошибку
        return new Promise(function (resolve, reject) {
          var image = new Image();
          image.onload = function () {
            // создаем псевдо-аттач для клиентов, которые не поддреживают загрузку по урлу
            resolve({
              attachmentGlobalId: getPseudoImageAttachmentId(url),
              type: 'image/unknown'
            });
          };
          image.onerror = function () {
            reject(new Error('Couldn\'t load the link content'));
          };
          image.src = url;
        });
      }
    }
  }, {
    key: "resolvePseudoAttachment",
    value: function resolvePseudoAttachment(url) {
      return new Promise(function (resolve, reject) {
        resolve({
          attachmentGlobalId: getPseudoImageAttachmentId(url),
          type: 'image/unknown'
        });
      });
    }

    /**
     * вызывается перед saveFile, позволяет приложению прописать нужные данные в объект файла
     * полезно при drag and drop файла в редактор, когда приложение не может сообщить данные файла перед saveFile
     * @param  {NmbFile} file файл, который надо сохранить
     * @return {NmbFile} обновленный файл, может быть тем же файлом что и на входе
     */
  }, {
    key: "beforeSaveFile",
    value: function beforeSaveFile(file) {
      if (!this.options.beforeSaveFile) {
        return file;
      }
      var fileRes = this.options.beforeSaveFile(file);
      if (!fileRes) {
        fileRes = file;
      }
      return fileRes;
    }

    /**
     * сохраняет файл и создает аттач
     * @param  {NmbFile} file файл, который надо сохранить
     * @return {Promise}      промис резолвится в информацию об аттаче
     */
  }, {
    key: "saveFile",
    value: function saveFile(file) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.options.saveFile(file, options);
    }

    /**
     * переименовывает аттач
     * @param  {globalId} айди аттача
     * @param  {name} новое имя для аттача
     * @return {boolean} возвращает false если имя не может быть изменено и true если изменено успешно
     */
  }, {
    key: "renameAttachment",
    value: function renameAttachment(file) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.options.renameAttachment(file, options);
    }

    /**
     * запускает скачивание аттача
     * @param {attachment} инстант аттача
     * @return {boolean}
     */
  }, {
    key: "download",
    value: function download(attachment) {
      var processed = false;
      if (this.options.download) {
        if (this.options.download(attachment) !== false) {
          processed = true;
        }
      }
      return processed;
    }

    /**
     * устанавливает картинку как превью заметки
     * @param {attachment} инстант аттача
     * @return {boolean}
     */
  }, {
    key: "setAsPreview",
    value: function setAsPreview(attachment) {
      if (this.options.download) {
        return this.options.setAsPreview(attachment);
      } else {
        return false;
      }
    }

    /**
     * запускает скачивание аттача на локальный клиент, используется на клиентах, поддверживающих оффлайн работу, которым
     * нужно наличие файла аттача локально
     * @param {attachment} инстант аттача
     * @return {boolean}
     */
  }, {
    key: "fetch",
    value: function fetch(attachment) {
      var processed = false;
      if (this.options.fetch) {
        if (this.options.fetch(attachment) !== false) {
          processed = true;
        }
      }
      return processed;
    }

    /**
     * отмена скачки аттача
     * @param  {attachment} аттач для которого надо прекратить скачку
     */
  }, {
    key: "abortFetch",
    value: function abortFetch(attachment) {
      var processed = false;
      if (this.options.abortFetch) {
        if (this.options.abortFetch(attachment) !== false) {
          processed = true;
        }
      }
      return processed;
    }

    /*
     * запускает процесс поворота изображения
     * @param  {globalId} айди аттача
     * @return {Promise<string>} айди перевернутого аттача
     */
  }, {
    key: "validateFiles",
    value:
    /**
     * валидация файлов на стороне приложения
     * @param  {NmbFile} files
     * @return {Boolean}
     */
    function validateFiles(files) {
      if (!this.options.validateFiles) {
        return Promise.resolve(true);
      }
      return this.options.validateFiles(files);
    }
  }, {
    key: "setAttachmentForBlot",
    value: function setAttachmentForBlot(blotId, globalId) {
      var blot = this.editor.findById(blotId);
      if (blot && blot.replaceAttachment) {
        return blot.replaceAttachment(globalId);
      }
      return false;
    }
  }, {
    key: "editAttachment",
    value: function editAttachment(blotId, globalId) {
      if (this.options.editAttachment) {
        return this.options.editAttachment(blotId, globalId);
      } else {
        return false;
      }
    }
  }, {
    key: "setAttachment",
    value: function setAttachment(attachment) {
      var blots = this.findBlotsWithAttachment(attachment.global_id);
      if (!blots.length) {
        console.warn('no blots with attachment', attachment.global_id);
      }
      var _iterator = attachmentManager_createForOfIteratorHelper(blots),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var blot = _step.value.blot;
          var blotToSet = blot;
          // так как блоты могут быть скрыты (например контент внутри тоггла) поэтому возвращается не сам блот
          // а его map
          if (blot.map) {
            // проверяем виден ли блот в редакторе
            var b = gEditor.findById(blot.map.get('id'));
            if (b) {
              blotToSet = b;
            } else {
              // если не виден, пропускаем его
              continue;
            }
          }
          if (blotToSet.getWrappedBlot && blotToSet.getWrappedBlot() !== blotToSet) {
            blotToSet = blot.getWrappedBlot();
          }
          blotToSet.setProps({
            attachment: attachment
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "findBlotsWithAttachment",
    value: function findBlotsWithAttachment() {
      var _this2 = this;
      var attachmentGlobalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var blots = [];
      var attachmentsGlobalIdAssoc = {};
      if (attachmentGlobalId) {
        var attachmentsArr = attachmentGlobalId;
        if (!Array.isArray(attachmentsArr)) {
          attachmentsArr = [attachmentsArr];
        }
        var _iterator2 = attachmentManager_createForOfIteratorHelper(attachmentsArr),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var globalId = _step2.value;
            attachmentsGlobalIdAssoc[globalId] = true;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      var blotsAlreadyProcessed = new Set();
      this.scroll.descendants(function (blot) {
        if (blot.map) {
          var _blot$constructor, _blot$map;
          if (blotsAlreadyProcessed.has(blot.map.get('id'))) {
            return;
          }
          blotsAlreadyProcessed.add(blot.map.get('id'));
          if (blot.map.get('type') === 'table') {
            var table = blot.getWrappedBlot();
            var tableAttachmentsIds = table.getAttachments();
            var _iterator3 = attachmentManager_createForOfIteratorHelper(tableAttachmentsIds),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var attachId = _step3.value;
                var map = _this2.editor.store.getMap(attachId);
                if (map) {
                  blots.push({
                    blot: null,
                    // return null for tables, because files inside them are rendered on demand
                    blotName: map.get('type'),
                    attachmentGlobalId: map.get('attachmentGlobalId')
                  });
                }
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
          var blotAttachmentGlobalId = blot.map.get('attachmentGlobalId');
          if (!blotAttachmentGlobalId) {
            return;
          }
          if (attachmentGlobalId && !attachmentsGlobalIdAssoc[blotAttachmentGlobalId]) {
            return;
          }
          blot = blot.getWrappedBlot && blot.getWrappedBlot() || blot;
          blots.push({
            blot: blot,
            blotName: ((_blot$constructor = blot.constructor) === null || _blot$constructor === void 0 ? void 0 : _blot$constructor.blotName) || ((_blot$map = blot.map) === null || _blot$map === void 0 ? void 0 : _blot$map.get('type')) || '',
            attachmentGlobalId: blotAttachmentGlobalId
          });
        }
      });
      return blots;
    }
  }]);
  return AttachmentManager;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/embeddedMenu/index.js
function embeddedMenu_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { embeddedMenu_typeof = function _typeof(obj) { return typeof obj; }; } else { embeddedMenu_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return embeddedMenu_typeof(obj); }
function embeddedMenu_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function embeddedMenu_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { embeddedMenu_ownKeys(Object(source), true).forEach(function (key) { embeddedMenu_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { embeddedMenu_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function embeddedMenu_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function embeddedMenu_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { embeddedMenu_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { embeddedMenu_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function embeddedMenu_extends() { embeddedMenu_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return embeddedMenu_extends.apply(this, arguments); }
function embeddedMenu_toConsumableArray(arr) { return embeddedMenu_arrayWithoutHoles(arr) || embeddedMenu_iterableToArray(arr) || embeddedMenu_unsupportedIterableToArray(arr) || embeddedMenu_nonIterableSpread(); }
function embeddedMenu_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function embeddedMenu_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return embeddedMenu_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return embeddedMenu_arrayLikeToArray(o, minLen); }
function embeddedMenu_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function embeddedMenu_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return embeddedMenu_arrayLikeToArray(arr); }
function embeddedMenu_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
























function embeddedMenu_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function embeddedMenu_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function embeddedMenu_createClass(Constructor, protoProps, staticProps) { if (protoProps) embeddedMenu_defineProperties(Constructor.prototype, protoProps); if (staticProps) embeddedMenu_defineProperties(Constructor, staticProps); return Constructor; }
function embeddedMenu_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) embeddedMenu_setPrototypeOf(subClass, superClass); }
function embeddedMenu_setPrototypeOf(o, p) { embeddedMenu_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return embeddedMenu_setPrototypeOf(o, p); }
function embeddedMenu_createSuper(Derived) { var hasNativeReflectConstruct = embeddedMenu_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = embeddedMenu_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = embeddedMenu_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return embeddedMenu_possibleConstructorReturn(this, result); }; }
function embeddedMenu_possibleConstructorReturn(self, call) { if (call && (embeddedMenu_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return embeddedMenu_assertThisInitialized(self); }
function embeddedMenu_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function embeddedMenu_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function embeddedMenu_getPrototypeOf(o) { embeddedMenu_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return embeddedMenu_getPrototypeOf(o); }
function embeddedMenu_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }














var moreItemsMenuAppearDuration = (embedded_menu_default()).moreItemsMenuAppearDuration,
  embeddedMenuAppearDuration = (embedded_menu_default()).embeddedMenuAppearDuration;
var BLOT_ID_ATTR = 'data-embedded-menu-for-id';
var embeddedMenu_ID_ATTR = 'data-menu-id';
var MORE_ITEMS_MENU_MAX_HEIGHT = 340;
// этот пункт изменить если измениться высота одного элемента
var MORE_ITEMS_MENU_ELEMENT_HEIGHT = 34;
function embeddedMenu_singleMenuState() {
  var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var available = ['moreItemsVisible'];
  var state = {};
  for (var _i = 0, _available = available; _i < _available.length; _i++) {
    var item = _available[_i];
    if (item === active) {
      state[item] = true;
    } else {
      state[item] = false;
    }
  }
  return state;
}
var EmbeddedMenuComponent = /*#__PURE__*/function (_Component) {
  embeddedMenu_inherits(EmbeddedMenuComponent, _Component);
  var _super = embeddedMenu_createSuper(EmbeddedMenuComponent);
  function EmbeddedMenuComponent() {
    var _this;
    embeddedMenu_classCallCheck(this, EmbeddedMenuComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    embeddedMenu_defineProperty(embeddedMenu_assertThisInitialized(_this), "onMouseDown", function (event) {
      var preventDefault = true;
      if ((0,dom/* isNodeEqualOrContain */.nN)(_this.moreItemsBtnNode, event.target)) {
        _this.setState(function (prevState) {
          return embeddedMenu_singleMenuState(!prevState.moreItemsVisible && 'moreItemsVisible');
        });
        _this.props.onMoreItemsBtnClick();
      } else if (_this.moreItemsMenuNode && (0,dom/* isNodeEqualOrContain */.nN)(_this.moreItemsMenuNode, event.target)) {} else {
        _this.setState(function () {
          return embeddedMenu_singleMenuState();
        }, function () {
          _this.props.onMouseDown && _this.props.onMouseDown();
        });
      }
      if (preventDefault) {
        // не позволяем фокусироватся на меню и убирать каретку с элемента
        event.preventDefault();
      }
    });
    embeddedMenu_defineProperty(embeddedMenu_assertThisInitialized(_this), "onMoreItemsMenuWantsToClose", function () {
      _this.setState(function () {
        return embeddedMenu_singleMenuState();
      });
    });
    embeddedMenu_defineProperty(embeddedMenu_assertThisInitialized(_this), "inputText", function (text) {
      _this.props.inputText(text);
    });
    embeddedMenu_defineProperty(embeddedMenu_assertThisInitialized(_this), "onMoreItemsBtnRef", function (node) {
      _this.moreItemsBtnNode = node;
    });
    embeddedMenu_defineProperty(embeddedMenu_assertThisInitialized(_this), "onMoreItemsMenuRef", function (node) {
      _this.moreItemsMenuNode = node;
    });
    embeddedMenu_defineProperty(embeddedMenu_assertThisInitialized(_this), "onInputPromptRef", function (node) {
      _this.inputPromptRef = node;
    });
    embeddedMenu_defineProperty(embeddedMenu_assertThisInitialized(_this), "convertBlot", function (params) {
      _this.props.convertBlot(params);
    });
    embeddedMenu_defineProperty(embeddedMenu_assertThisInitialized(_this), "onClickUseAi", function (params) {
      _this.props.onUseAi();
    });
    embeddedMenu_defineProperty(embeddedMenu_assertThisInitialized(_this), "onClickCheckboxList", function () {
      _this.convertBlot({
        type: 'list',
        items: ['listItemCheckbox']
      });
    });
    embeddedMenu_defineProperty(embeddedMenu_assertThisInitialized(_this), "onClickNumberList", function () {
      _this.convertBlot({
        type: 'list',
        items: ['listItemNumber']
      });
    });
    embeddedMenu_defineProperty(embeddedMenu_assertThisInitialized(_this), "onClickBulletList", function () {
      _this.convertBlot({
        type: 'list',
        items: ['listItemBullet']
      });
    });
    embeddedMenu_defineProperty(embeddedMenu_assertThisInitialized(_this), "onClickTable", function () {
      _this.convertBlot({
        type: 'table',
        rows: 2,
        cols: 3,
        batch: true
      });
    });
    embeddedMenu_defineProperty(embeddedMenu_assertThisInitialized(_this), "onClickImage", function () {
      _this.props.addImage();
    });
    embeddedMenu_defineProperty(embeddedMenu_assertThisInitialized(_this), "onClickFile", function () {
      _this.props.addFile();
    });
    embeddedMenu_defineProperty(embeddedMenu_assertThisInitialized(_this), "onClickAddNote", function () {
      _this.props.addNote();
    });
    embeddedMenu_defineProperty(embeddedMenu_assertThisInitialized(_this), "onClickMediumHeading", function () {
      _this.convertBlot({
        type: 'hMedium'
      });
    });
    embeddedMenu_defineProperty(embeddedMenu_assertThisInitialized(_this), "onClickAddStep", function () {
      _this.convertBlot({
        type: 'step'
      });
    });
    embeddedMenu_defineProperty(embeddedMenu_assertThisInitialized(_this), "addLink", function (event) {
      // закрываем все меню
      _this.setState(function () {
        return embeddedMenu_singleMenuState();
      }, function () {
        _this.props.addLink(event);
      });
    });
    embeddedMenu_defineProperty(embeddedMenu_assertThisInitialized(_this), "onMouseEnter", function () {
      _this.props.onMouseEnter();
    });
    embeddedMenu_defineProperty(embeddedMenu_assertThisInitialized(_this), "onMouseLeave", function () {
      _this.props.onMouseLeave();
    });
    embeddedMenu_defineProperty(embeddedMenu_assertThisInitialized(_this), "onRateEditorClick", function () {
      _this.setEditorRated();
      _this.props.editor.plugins.editorRate.onRateEditorClick();
    });
    embeddedMenu_defineProperty(embeddedMenu_assertThisInitialized(_this), "onRateEditorCloseClick", function () {
      _this.setEditorRated();
    });
    return _this;
  }
  embeddedMenu_createClass(EmbeddedMenuComponent, [{
    key: "getItems",
    value: function getItems() {
      var menu = [this.props.addFullViewMenuItems && this.props.addFullViewMenuItems.includes('add-step') ? {
        id: 'add-step',
        fn: this.onClickAddStep,
        title: 'Add step',
        Icon: function Icon() {
          return (0,preact_module.h)("div", {
            className: "add-step-button",
            style: {
              pointerEvents: 'none'
            }
          }, (0,preact_module.h)("span", null, "+"), "Add step");
        }
      } : null, this.props.isUseAiSupported && !this.props.editor.plugins.aiManager.isRequestActive ? {
        id: 'use-ai',
        fn: this.onClickUseAi,
        title: this.props.i18n.get('embedded_menu.use_ai'),
        hint: false,
        Icon: icons/* IconPromtIcon */.nST
      } : null, {
        id: 'todo',
        fn: this.onClickCheckboxList,
        title: this.props.i18n.get('embedded_menu.todo'),
        hint: browser/* modKey */.CF + '+shift+c',
        Icon: this.props.viewType === 'full' && icons/* IconCheckbox */.bM7 || icons/* IconChecklist */.$Nx
      }, {
        id: 'numberedlist',
        fn: this.onClickNumberList,
        title: this.props.i18n.get('embedded_menu.numbered_list'),
        hint: browser/* modKey */.CF + '+shift+7',
        Icon: icons/* IconListNumber */.UcJ
      }, {
        id: 'bulletlist',
        fn: this.onClickBulletList,
        title: this.props.i18n.get('embedded_menu.bullet_list'),
        hint: browser/* modKey */.CF + '+shift+8',
        Icon: icons/* IconListBullet */.pfx
      }, {
        id: 'table',
        fn: this.onClickTable,
        title: this.props.i18n.get('embedded_menu.table'),
        hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+t',
        Icon: icons/* IconTable */.fqO
      }, this.props.isImageSupported ? {
        id: 'image',
        fn: this.onClickImage,
        title: this.props.i18n.get('embedded_menu.image'),
        hint: browser/* modKey */.CF + '+shift+i',
        Icon: icons/* IconImage */.Zay
      } : null, this.props.isFileSupported ? {
        id: 'file',
        fn: this.onClickFile,
        title: this.props.i18n.get('embedded_menu.file'),
        hint: browser/* modKey */.CF + '+shift+f',
        Icon: icons/* IconFile */.XhR
      } : null, this.props.isAddNoteSupported ? {
        id: 'add-note',
        fn: this.onClickAddNote,
        title: this.props.i18n.get('embedded_menu.add_note'),
        Icon: icons/* IconCreateNote */.uyk
      } : null, {
        id: 'mediumheading',
        fn: this.onClickMediumHeading,
        title: this.props.i18n.get('embedded_menu.medium_heading'),
        hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+2',
        Icon: icons/* IconHeaderMedium */.L9t,
        menuStyle: 'bold'
      }];
      return menu.filter(function (item) {
        return item !== null;
      });
    }
  }, {
    key: "checkInputPromptOverflow",
    value: function checkInputPromptOverflow() {
      var inputPromptRef = this.inputPromptRef;
      var maxWidth = this.props.maxWidth;
      this.setState(function (prevState) {
        var overflowingWidth = prevState.overflowingWidth;
        if (inputPromptRef) {
          if (inputPromptRef.scrollWidth > inputPromptRef.clientWidth) {
            return {
              isInputPrompOverflowing: true,
              overflowingWidth: maxWidth
            };
          } else if (overflowingWidth && maxWidth > overflowingWidth) {
            return {
              isInputPrompOverflowing: false,
              overflowingWidth: null
            };
          }
        }
        return null;
      });
    }
  }, {
    key: "setEditorRated",
    value: function setEditorRated() {
      return this.props.editor.plugins.editorRate.setEditorRated();
    }
  }, {
    key: "isEditorRated",
    value: function isEditorRated() {
      return this.props.editor.plugins.editorRate.isEditorRated();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkInputPromptOverflow();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      if (oldProps.maxWidth !== this.props.maxWidth) {
        this.checkInputPromptOverflow();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        moreItemsVisible = _this$state.moreItemsVisible,
        isInputPrompOverflowing = _this$state.isInputPrompOverflowing;
      var _this$props = this.props,
        viewType = _this$props.viewType,
        i18n = _this$props.i18n;
      var moreItemsMenu = null;
      var MoreItemsIcon = icons/* IconMenuMoreDown */.v92;
      var activeItems = {};
      var fullItems = [];
      var text;
      if (viewType === 'full') {
        fullItems = this.getItems();
        if (!this.props.editor.testMode) {
          text = i18n.get('embedded_menu.start_typing_full');
        } else {
          text = 'Type';
        }
      } else {
        text = i18n.get('embedded_menu.start_typing');
        MoreItemsIcon = icons/* IconPlus */.SC9;
      }
      if (moreItemsVisible) {
        var excludeItems = ['paragraph', 'lock-blot'].concat(embeddedMenu_toConsumableArray(this.props.excludeItems));
        var moreMenuAnchorOptions = this.props.moreMenuAnchorOptions ? this.props.moreMenuAnchorOptions : {
          // flip the popup first to top, then to bottom when the container is overflowed
          behavior: ['top', 'bottom', 'top']
        };
        if (this.props.addMoreMenuAnchorOptions) {
          moreMenuAnchorOptions = Object.assign({}, moreMenuAnchorOptions, this.props.addMoreMenuAnchorOptions);
        }
        moreItemsMenu = (0,preact_module.h)(ConvertMenuItems, {
          editor: this.props.editor,
          i18n: this.props.i18n,
          onDomRef: this.onMoreItemsMenuRef,
          wantsToClose: this.onMoreItemsMenuWantsToClose,
          menuKey: "more-items-menu",
          getStyles: this.props.getMoreItemsMenuMaxHeightAndOverflow,
          onChooseMenuItem: this.props.onChooseMenuItem,
          anchorNode: this.moreItemsBtnNode,
          scrollingContainer: this.props.scrollingContainer,
          convertBlot: this.props.convertBlot,
          onUseAi: this.props.onUseAi,
          addImage: this.props.addImage,
          addFile: this.props.addFile,
          addLink: this.addLink,
          addMention: this.props.addMention,
          addProgress: this.props.addProgress,
          addDropdownList: this.props.addDropdownList,
          addRemoteFile: this.props.addRemoteFile,
          addColumns: this.props.addColumns,
          addDatabase: this.props.addDatabase,
          lockBlot: this.props.lockBlot,
          addUnsplashImage: this.props.addUnsplashImage,
          excludeItems: excludeItems,
          anchorOptions: moreMenuAnchorOptions,
          onRateEditorClick: this.onRateEditorClick,
          onRateEditorCloseClick: this.onRateEditorCloseClick,
          showEditorRate: !this.isEditorRated() && this.props.editor.plugins.editorRate.isEnabled(),
          addStepsAggregator: this.props.addStepsAggregator
        });
      }
      var style = {
        maxWidth: this.props.maxWidth + 'px'
      };
      var inputPrompStyle = {};
      if (isInputPrompOverflowing) {
        inputPrompStyle = {
          display: 'none'
        };
      }
      var moreItemsBtnAttrs = {};
      if (!moreItemsVisible) {
        moreItemsBtnAttrs[tooltipManager/* TOOLTIP_ATTR */.qZ] = viewType === 'full' ? i18n.get('embedded_menu.more_items') : i18n.get('embedded_menu.add_an_element');
      }
      return (0,preact_module.h)("div", {
        style: style,
        className: 'embedded-menu ' + ('embedded-menu-' + viewType),
        onMouseDown: this.onMouseDown,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave
      }, (0,preact_module.h)("div", {
        ref: this.onInputPromptRef,
        className: "input-prompt overlay-text",
        style: inputPrompStyle
      }, text), (0,preact_module.h)("div", {
        className: "right-content"
      }, fullItems.length ? (0,preact_module.h)("div", {
        className: "inline-icons"
      }, fullItems.map(function (_ref) {
        var _attrs;
        var id = _ref.id,
          Icon = _ref.Icon,
          hint = _ref.hint,
          title = _ref.title,
          fn = _ref.fn;
        var attrs = (_attrs = {}, embeddedMenu_defineProperty(_attrs, embeddedMenu_ID_ATTR, id), embeddedMenu_defineProperty(_attrs, tooltipManager/* TOOLTIP_ATTR */.qZ, title), embeddedMenu_defineProperty(_attrs, tooltipManager/* TOOLTIP_SMALL_ATTR */.BY, hint), _attrs);
        return (0,preact_module.h)("div", embeddedMenu_extends({}, attrs, {
          className: 'icon ' + (activeItems[id] ? 'active' : ''),
          onClick: _this2.props.onChooseMenuItem.bind(null, fn)
        }), (0,preact_module.h)(Icon, null));
      })) : null, (0,preact_module.h)("div", {
        className: 'more-items ' + (moreItemsVisible ? 'active' : '')
      }, (0,preact_module.h)("div", embeddedMenu_extends({}, moreItemsBtnAttrs, {
        ref: this.onMoreItemsBtnRef,
        className: 'more-items-btn' + (viewType === 'full' ? ' view-full' : '')
      }), (0,preact_module.h)(MoreItemsIcon, null)), (0,preact_module.h)(preact_transition_group/* default */.Z, {
        transitionName: "menu",
        transitionEnterTimeout: moreItemsMenuAppearDuration,
        transitionLeaveTimeout: moreItemsMenuAppearDuration
      }, moreItemsMenu))));
    }
  }]);
  return EmbeddedMenuComponent;
}(preact_module/* Component */.wA);
var EmbeddedMenu = /*#__PURE__*/function () {
  function EmbeddedMenu(_ref2) {
    var _this3 = this;
    var scroll = _ref2.scroll,
      editor = _ref2.editor,
      options = _ref2.options;
    embeddedMenu_classCallCheck(this, EmbeddedMenu);
    embeddedMenu_defineProperty(this, "convertBlot", function (params) {
      // если блот не позволяет себя сконвертировать при помощи embeddedMenu, добавляем ниже него пустой параграф и ставим в него каретку,
      // таким образом будет сконвертирован пустой параграф
      if (_this3.anchorBlot.additionalEmbeddedMenu) {
        _this3.anchorBlot.container.addBlot('paragraph', {
          after: _this3.anchorBlot.id,
          focus: {
            index: 0
          }
        });
      }
      // сначала нужно вызвать хайд для текщуего анчора, потому что после конвертации может назначиться новый анчор,
      // и хайд уже вызовется для нового и скроет меню, когда не нужно
      _this3.hide(_this3.anchorBlot);
      _this3.editor.exec('convert-blot', params);
    });
    embeddedMenu_defineProperty(this, "onUseAi", function () {
      var blot = _this3.anchorBlot;
      if (_this3.anchorBlot.additionalEmbeddedMenu) {
        var _this3$anchorBlot$con = _this3.anchorBlot.container.addBlot('paragraph', {
            after: _this3.anchorBlot.id,
            focus: {
              index: 0
            }
          }),
          id = _this3$anchorBlot$con.id;
        blot = _this3.editor.findById(id);
      }
      _this3.editor.plugins.aiManager.show(blot);
      _this3.hide(_this3.anchorBlot);
    });
    embeddedMenu_defineProperty(this, "inputText", function (text) {
      if (!_this3.anchorBlot) {
        return;
      }
      var blot = _this3.anchorBlot;
      if (_this3.anchorBlot.additionalEmbeddedMenu) {
        var _this3$anchorBlot$con2 = _this3.anchorBlot.container.addBlot('paragraph', {
            after: _this3.anchorBlot.id,
            focus: {
              index: 0
            }
          }),
          id = _this3$anchorBlot$con2.id;
        blot = _this3.editor.findById(id);
      }
      var range = {
        index: blot.offset(_this3.scroll),
        length: 0
      };
      _this3.scroll.selection.setRange(range);
      _this3.editor.exec('insert-html', {
        html: text
      });
      range.index += text.length;
      _this3.scroll.selection.setRange(range);
    });
    embeddedMenu_defineProperty(this, "addLink", function (event) {
      if (_this3.anchorBlot.additionalEmbeddedMenu) {
        _this3.anchorBlot.container.addBlot('paragraph', {
          after: _this3.anchorBlot.id,
          focus: {
            index: 0
          }
        });
        _this3.hide(_this3.anchorBlot);
      }
      addLinkAction(_this3.editor);
    });
    embeddedMenu_defineProperty(this, "addMention", function () {
      var blot = _this3.anchorBlot;
      if (_this3.anchorBlot.additionalEmbeddedMenu) {
        var _this3$anchorBlot$con3 = _this3.anchorBlot.container.addBlot('paragraph', {
            after: _this3.anchorBlot.id,
            focus: {
              index: 0
            }
          }),
          id = _this3$anchorBlot$con3.id;
        blot = _this3.editor.findById(id);
        _this3.hide(_this3.anchorBlot);
      }
      blot.insertAt(0, '@');
      _this3.scroll.selection.setRange({
        index: blot.offset(_this3.scroll) + 1,
        length: 0
      });
    });
    embeddedMenu_defineProperty(this, "addProgress", function () {
      var blot = _this3.anchorBlot;
      if (_this3.anchorBlot.additionalEmbeddedMenu) {
        var _this3$anchorBlot$con4 = _this3.anchorBlot.container.addBlot('paragraph', {
            after: _this3.anchorBlot.id,
            focus: {
              index: 0
            }
          }),
          id = _this3$anchorBlot$con4.id;
        blot = _this3.editor.findById(id);
        _this3.hide(_this3.anchorBlot);
      }
      blot.applyForCharacters([{
        insert: {
          progress: 0
        }
      }, {
        insert: ' '
      }]);
      _this3.scroll.selection.setRange({
        index: blot.offset(_this3.scroll) + 2,
        length: 0
      });
    });
    embeddedMenu_defineProperty(this, "addDropdownList", function () {
      var blot = _this3.anchorBlot;
      if (_this3.anchorBlot.additionalEmbeddedMenu) {
        var _this3$anchorBlot$con5 = _this3.anchorBlot.container.addBlot('paragraph', {
            after: _this3.anchorBlot.id,
            focus: {
              index: 0
            }
          }),
          id = _this3$anchorBlot$con5.id;
        blot = _this3.editor.findById(id);
        _this3.hide(_this3.anchorBlot);
      }
      blot.applyForCharacters([{
        insert: embeddedMenu_defineProperty({}, 'dropdown-list', {
          ownerId: _this3.editor.store.userId
        })
      }, {
        insert: ' '
      }]);
      _this3.scroll.selection.setRange({
        index: blot.offset(_this3.scroll) + 2,
        length: 0
      });
    });
    embeddedMenu_defineProperty(this, "addFile", function (event) {
      if (_this3.anchorBlot.additionalEmbeddedMenu) {
        _this3.anchorBlot.container.addBlot('paragraph', {
          after: _this3.anchorBlot.id,
          focus: {
            index: 0
          }
        });
        _this3.hide(_this3.anchorBlot);
      }
      _this3.editor.exec('add-file');
    });
    embeddedMenu_defineProperty(this, "addImage", function (event) {
      _this3.convertBlot({
        type: 'image'
      });
    });
    embeddedMenu_defineProperty(this, "addRemoteFile", function (service) {
      var blot = _this3.anchorBlot;
      if (_this3.anchorBlot.additionalEmbeddedMenu) {
        var _this3$anchorBlot$con6 = _this3.anchorBlot.container.addBlot('paragraph', {
            after: _this3.anchorBlot.id,
            focus: {
              index: 0
            }
          }),
          id = _this3$anchorBlot$con6.id;
        blot = _this3.editor.findById(id);
        _this3.hide(_this3.anchorBlot);
      }
      _this3.hide(_this3.anchorBlot);
      _this3.editor.exec('add-remote-file', {
        service: service,
        blot: blot
      });
    });
    embeddedMenu_defineProperty(this, "addNote", /*#__PURE__*/embeddedMenu_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var blot, _this3$anchorBlot$con7, id, name, mentionData, insertOp;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              blot = _this3.anchorBlot;
              if (_this3.anchorBlot.additionalEmbeddedMenu) {
                _this3$anchorBlot$con7 = _this3.anchorBlot.container.addBlot('paragraph', {
                  after: _this3.anchorBlot.id,
                  focus: {
                    index: 0
                  }
                }), id = _this3$anchorBlot$con7.id;
                blot = _this3.editor.findById(id);
                _this3.hide(_this3.anchorBlot);
              }
              name = _this3.editor.plugins.i18n.get('embedded_menu.add_note') || 'New page';
              _context.next = 5;
              return _this3.editor.plugins.mentionManager.createAndResolveNote(name);
            case 5:
              mentionData = _context.sent;
              if (mentionData) {
                _context.next = 9;
                break;
              }
              // error should have been handled on the client side
              _this3.scroll.selection.setRange({
                index: blot.offset(_this3.scroll),
                length: 0
              });
              return _context.abrupt("return");
            case 9:
              insertOp = {
                insert: {
                  mention: {
                    type: 'note',
                    object_id: mentionData.object_id,
                    name: mentionData.name || name,
                    id: generateMentionId()
                  }
                }
              };
              if (mentionData.workspace_id) {
                insertOp.insert.mention.workspace_id = mentionData.workspace_id;
              }
              blot.applyForCharacters([insertOp, {
                insert: ' '
              }]);
              _this3.scroll.selection.setRange({
                index: blot.offset(_this3.scroll) + 2,
                length: 0
              });
            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    embeddedMenu_defineProperty(this, "lockBlot", function () {
      if (_this3.anchorBlot) {
        if (_this3.anchorBlot.isBlotLocked) {
          if (_this3.anchorBlot.lockBlotAction) {
            _this3.anchorBlot.lockBlotAction();
          }
        } else {
          if (_this3.anchorBlot.unlockBlotAction) {
            _this3.anchorBlot.unlockBlotAction();
          }
        }
      }
      _this3.hide(_this3.anchorBlot);
    });
    embeddedMenu_defineProperty(this, "addColumns", function () {
      if (_this3.anchorBlot.additionalEmbeddedMenu) {
        _this3.anchorBlot.container.addBlot('paragraph', {
          after: _this3.anchorBlot.id,
          focus: {
            index: 0
          }
        });
        _this3.hide(_this3.anchorBlot);
      }
      _this3.editor.exec('add-grid', {
        position: 'left'
      });
    });
    embeddedMenu_defineProperty(this, "addDatabase", function (type) {
      if (_this3.anchorBlot.additionalEmbeddedMenu) {
        _this3.anchorBlot.container.addBlot('paragraph', {
          after: _this3.anchorBlot.id,
          focus: {
            index: 0
          }
        });
      }
      _this3.hide(_this3.anchorBlot);
      _this3.editor.exec('add-database', {
        type: type
      });
    });
    embeddedMenu_defineProperty(this, "addUnsplashImage", function () {
      var blot = _this3.anchorBlot;
      if (_this3.anchorBlot.additionalEmbeddedMenu) {
        var _this3$anchorBlot$con8 = _this3.anchorBlot.container.addBlot('paragraph', {
            after: _this3.anchorBlot.id,
            focus: {
              index: 0
            }
          }),
          id = _this3$anchorBlot$con8.id;
        blot = _this3.editor.findById(id);
      }
      _this3.hide(_this3.anchorBlot);
      _this3.editor.plugins.unsplashManager.openPicker(blot, function (img) {
        var url = img && (img.urls.regular || img.urls.full || img.urls.raw);
        if (!url) {
          console.error('Unsplash image has no correct url');
        } else {
          var _img$user, _img$user2, _img$user2$links;
          var attachmentGlobalId = getPseudoImageAttachmentId(url);
          var authorParams = {
            name: (_img$user = img.user) === null || _img$user === void 0 ? void 0 : _img$user.name,
            link: (_img$user2 = img.user) === null || _img$user2 === void 0 ? void 0 : (_img$user2$links = _img$user2.links) === null || _img$user2$links === void 0 ? void 0 : _img$user2$links.html
          };
          var captionOps = null;
          if (authorParams.name || authorParams.link) {
            var _this3$editor, _this3$editor$plugins, _this3$editor$plugins2;
            var linkAttrs = authorParams.link ? {
              link: authorParams.link
            } : null;
            var preffix = (((_this3$editor = _this3.editor) === null || _this3$editor === void 0 ? void 0 : (_this3$editor$plugins = _this3$editor.plugins) === null || _this3$editor$plugins === void 0 ? void 0 : (_this3$editor$plugins2 = _this3$editor$plugins.i18n) === null || _this3$editor$plugins2 === void 0 ? void 0 : _this3$editor$plugins2.get('image.unsplash.caption_preffix')) || 'Photo by') + ' ';
            captionOps = {
              ops: [{
                insert: preffix
              }, {
                insert: authorParams.name || authorParams.link,
                attributes: linkAttrs
              }]
            };
          }
          blot.container.addBlot('image', {
            after: blot.id,
            unsplash: true,
            attachmentGlobalId: attachmentGlobalId,
            captionParams: {
              delta: captionOps
            }
          });
          blot.container.removeChildById(blot.id);
        }
      });
    });
    embeddedMenu_defineProperty(this, "addStepsAggregator", function () {
      var stepBlots = _this3.scroll.descendants(function (blot) {
        return blot.constructor.blotName === 'step';
      });
      var beforeBlot = stepBlots.length ? stepBlots[0] : _this3.scroll.children.head;
      var existsAggregators = _this3.scroll.descendants(function (blot) {
        return blot.constructor.blotName === 'step-aggregator';
      });
      var params = {
        before: beforeBlot.id,
        focus: {
          index: 0
        }
      };
      if (existsAggregators.length) {
        params = embeddedMenu_objectSpread(embeddedMenu_objectSpread({}, existsAggregators[0].getMapParams()), params);
      }
      beforeBlot.container.addBlot('step-aggregator', params);
      _this3.hide(_this3.anchorBlot);
    });
    embeddedMenu_defineProperty(this, "onMouseDown", function () {
      // при нажатии на меню(его пустое место или текст предложения ввода) делаем фокус на перекрываемом блоте
      if (_this3.anchorBlot) {
        _this3.scroll.selection.setRange({
          index: _this3.anchorBlot.offset(_this3.scroll),
          length: 0
        });
      }
    });
    embeddedMenu_defineProperty(this, "onMouseEnter", function () {});
    embeddedMenu_defineProperty(this, "onMouseLeave", function () {});
    embeddedMenu_defineProperty(this, "onMoreItemsBtnClick", function () {
      _this3.editor.plugins.tooltipManager.hide();
      if (!_this3.anchorBlot.additionalEmbeddedMenu) {
        if (!_this3.scroll.selection.hasFocus()) {
          _this3.scroll.selection.setRange({
            index: _this3.anchorBlot.offset(_this3.scroll),
            length: 0
          });
        }
      }
    });
    embeddedMenu_defineProperty(this, "onChooseMenuItem", function (fn) {
      fn();
      _this3.editor.plugins.selectionScroller.ensureSelectionVisible();
    });
    embeddedMenu_defineProperty(this, "getMoreItemsMenuMaxHeightAndOverflow", function (itemsCount) {
      if (!_this3.anchorBlot) {
        return {
          menuMaxHeight: MORE_ITEMS_MENU_ELEMENT_HEIGHT,
          overflowY: 'scroll'
        };
      }
      var fullWidth = !_this3.anchorBlot.additionalEmbeddedMenu && searchUp(_this3.anchorBlot, function (blot) {
        return blot instanceof blots_gridCol;
      }) ? false : true;
      var blotRect = _this3.anchorBlot.domNode.getBoundingClientRect();
      var scrollingContainerRect = _this3.editor.getScrollingContainer().getBoundingClientRect();
      var menuHeight = _this3.container.offsetHeight;
      var result = {};
      var menuOffset = _this3.anchorBlot.embeddedMenuOffset ? _this3.anchorBlot.embeddedMenuOffset() : {
        top: 0,
        left: 0
      };
      if (blotRect.y + menuOffset.top - scrollingContainerRect.y > scrollingContainerRect.y + scrollingContainerRect.height - (blotRect.y + menuOffset.top + menuHeight)) {
        // если сверху больше места, возвращаем расстояние между верхней границей редактора и верхней границей блока
        result.menuMaxHeight = blotRect.y + menuOffset.top - scrollingContainerRect.y;
      } else {
        // если снизу места больше, возвращаем расстояние между нижней границе редактора и нижней границей блока
        result.menuMaxHeight = scrollingContainerRect.y + scrollingContainerRect.height - (blotRect.y + menuOffset.top + menuHeight);
      }
      // если блок в колонке и для рендера меню хватает места, возвращаем стандартное значение
      if (!fullWidth && result.menuMaxHeight > MORE_ITEMS_MENU_MAX_HEIGHT) {
        result.menuMaxHeight = MORE_ITEMS_MENU_MAX_HEIGHT;
        result.overflowY = 'scroll';
      } else {
        // получаем значение наличия скролла у меню
        if (fullWidth) {
          result.overflowY = result.menuMaxHeight > MORE_ITEMS_MENU_ELEMENT_HEIGHT * itemsCount ? 'visible' : 'scroll';
        } else {
          result.overflowY = 'scroll';
        }
      }
      return result;
    });
    this.options = Object.assign({
      enabled: true
    }, options);
    this.scroll = scroll;
    this.editor = editor;
    this.anchorBlot = null;
    this.container = null;
    this.allowAppearAnimation = true;
    this.enabled = this.options.enabled;
    this.preloadTooltipPreviews();
  }
  embeddedMenu_createClass(EmbeddedMenu, [{
    key: "preloadTooltipPreviews",
    value: function preloadTooltipPreviews() {
      var preloadContainer = document.createElement('div');
      preloadContainer.classList.add('editor-menu-tooltips');
      var tooltipIds = Object.keys(tooltips_namespaceObject);
      for (var _i2 = 0, _tooltipIds = tooltipIds; _i2 < _tooltipIds.length; _i2++) {
        var id = _tooltipIds[_i2];
        if (Boolean(tooltips_namespaceObject[id].preview)) {
          var preview = document.createElement('img');
          preview.setAttribute('loading', 'lazy');
          preview.setAttribute('src', tooltips_namespaceObject[id].preview);
          preloadContainer.appendChild(preview);
        }
      }
      this.editor.editorBody.appendChild(preloadContainer);
    }
  }, {
    key: "adjustPositionContinuously",
    value: function adjustPositionContinuously() {
      var _this4 = this;
      var adjust = function adjust() {
        if (!_this4.anchorBlot) {
          return;
        }
        if (!_this4.anchorBlot.domNode.parentNode) {
          return;
        }
        _this4.adjustPosition();
        requestAnimationFrame(adjust);
      };
      adjust();
    }
  }, {
    key: "adjustPosition",
    value: function adjustPosition() {
      var domNode = this.anchorBlot.domNode;
      var rect = domNode.getBoundingClientRect();
      var scrollRect = this.editor.scrollingContainer.getBoundingClientRect();
      this.container.style.position = 'absolute';
      var top = rect.top + this.scroll.editor.scrollingContainer.scrollTop - scrollRect.top;
      var left = rect.left - scrollRect.left;
      var width = rect.width;
      var height = rect.height;
      if (this.anchorBlot.getCorrectEmbeddedPos) {
        var _this$anchorBlot$getC = this.anchorBlot.getCorrectEmbeddedPos({
          top: top,
          left: left,
          width: width,
          height: height
        });
        top = _this$anchorBlot$getC.top;
        left = _this$anchorBlot$getC.left;
        width = _this$anchorBlot$getC.width;
        height = _this$anchorBlot$getC.height;
      }
      this.container.style.top = top + 'px';
      this.container.style.left = left + 'px';
      this.container.style.width = width + 'px';
      this.container.style.height = height + 'px';
    }
  }, {
    key: "render",
    value: function render(container) {
      var withMenu = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var props = arguments.length > 2 ? arguments[2] : undefined;
      (0,preact_module/* render */.sY)((0,preact_module.h)(preact_transition_group/* default */.Z, {
        transitionName: "embedded-menu",
        transitionEnterTimeout: embeddedMenuAppearDuration,
        transitionLeave: false,
        transitionEnter: this.allowAppearAnimation
      }, withMenu ? (0,preact_module.h)(EmbeddedMenuComponent, embeddedMenu_extends({
        onMouseDown: this.onMouseDown,
        onMoreItemsBtnClick: this.onMoreItemsBtnClick,
        convertBlot: this.convertBlot,
        onUseAi: this.onUseAi,
        addLink: this.addLink,
        addMention: this.addMention,
        addProgress: this.addProgress,
        addDropdownList: this.addDropdownList,
        addFile: this.addFile,
        addImage: this.addImage,
        addRemoteFile: this.addRemoteFile,
        addColumns: this.addColumns,
        addDatabase: this.addDatabase,
        addNote: this.addNote,
        lockBlot: this.lockBlot,
        addUnsplashImage: this.addUnsplashImage,
        inputText: this.inputText,
        viewportSize: this.editor.getViewportSize(),
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        onChooseMenuItem: this.onChooseMenuItem,
        i18n: this.editor.plugins.i18n,
        isFileSupported: this.editor.plugins.attachmentManager.isMethodImplemented('chooseFile'),
        isImageSupported: this.editor.plugins.attachmentManager.isMethodImplemented('chooseFile'),
        isAddNoteSupported: !Boolean(this.editor.options.disableAddNote),
        scrollingContainer: this.editor.getScrollingContainer(),
        getMoreItemsMenuMaxHeightAndOverflow: this.getMoreItemsMenuMaxHeightAndOverflow,
        editor: this.editor,
        isUseAiSupported: this.editor.plugins.aiManager.enabled,
        moreMenuAnchorOptions: this.options.moreMenuAnchorOptions,
        addStepsAggregator: this.addStepsAggregator
      }, props)) : null), container);
    }
  }, {
    key: "show",
    value: function show(anchor) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this.enabled) {
        return;
      }
      props = Object.assign(props);
      if (this.anchorBlot) {
        if (this.anchorBlot !== anchor) {
          this.hide(this.anchorBlot);
        }
      }
      props.viewType = 'full';
      var parentGirdCol = searchUp(anchor, function (blot) {
        return blot instanceof blots_gridCol;
      });
      if (!anchor.additionalEmbeddedMenu) {
        if (parentGirdCol) {
          props.viewType = 'short';
        }
      }
      var excludeItems = [];
      if (anchor.container.constructor.blotName === 'toggleContent') {
        excludeItems.push.apply(excludeItems, ['toggle', 'largeheading-toggle', 'mediumheading-toggle', 'smallheading-toggle', 'columns', 'step', 'step-aggregator']);
      }
      if (parentGirdCol) {
        if (!excludeItems.includes('columns')) {
          excludeItems.push('columns');
        }
        if (!excludeItems.includes('use-ai')) {
          excludeItems.push('use-ai');
        }
      }
      if (this.editor.plugins.aiManager.isRequestActive) {
        excludeItems.push('use-ai');
      }
      props.excludeItems = excludeItems;
      props.emojiManager = this.editor.plugins.emojiManager;
      if (anchor.additionalEmbeddedMenu) {
        props.addMoreMenuAnchorOptions = {
          offset: '0, 10px'
        };
      }
      if (!this.container) {
        this.anchorBlot = anchor;
        this.container = document.createElement('div');
        this.container.classList.add('embedded-menu-container');
        if (this.anchorBlot.additionalEmbeddedMenu) {
          this.container.classList.add('additional-embedded-menu');
        }
        if (props.containerAddClassName) {
          this.container.classList.add(props.containerAddClassName);
        }
        this.editor.scrollingContainer.appendChild(this.container);
        // т.к. preact-transition-group не поддерживает appear элементов, то надо имитировать их enter
        this.render(this.container);
        this.adjustPositionContinuously();
        this.container.setAttribute(BLOT_ID_ATTR, anchor.id);
      }
      var container = this.container;
      if (this.allowAppearAnimation) {
        setTimeout(this.render.bind(this, container, true, props), 0);
      } else {
        this.render(container, true, props);
      }
    }
  }, {
    key: "hide",
    value: function hide(anchor) {
      var _this5 = this;
      if (!this.anchorBlot) {
        return;
      }
      if (this.anchorBlot !== anchor) {
        return;
      }
      if (this.anchorBlot.additionalEmbeddedMenu && this.anchorBlot.onEmbeddedMenuHide) {
        this.anchorBlot.onEmbeddedMenuHide();
      }
      var container = this.container;
      var anchorBlot = this.anchorBlot;
      this.anchorBlot = null;
      this.container = null;
      this.render(container);
      container.parentNode.removeChild(container);
      if (this.hideNoAnimTimeout) {
        clearTimeout(this.hideNoAnimTimeout);
      }
      this.allowAppearAnimation = false;
      this.hideNoAnimTimeout = setTimeout(function () {
        _this5.allowAppearAnimation = true;
      }, embeddedMenuAppearDuration);
    }
  }]);
  return EmbeddedMenu;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/blockMenu/index.js
function blockMenu_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { blockMenu_typeof = function _typeof(obj) { return typeof obj; }; } else { blockMenu_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return blockMenu_typeof(obj); }
function blockMenu_toConsumableArray(arr) { return blockMenu_arrayWithoutHoles(arr) || blockMenu_iterableToArray(arr) || blockMenu_unsupportedIterableToArray(arr) || blockMenu_nonIterableSpread(); }
function blockMenu_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function blockMenu_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function blockMenu_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return blockMenu_arrayLikeToArray(arr); }
function blockMenu_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = blockMenu_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function blockMenu_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return blockMenu_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return blockMenu_arrayLikeToArray(o, minLen); }
function blockMenu_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function blockMenu_extends() { blockMenu_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return blockMenu_extends.apply(this, arguments); }


















function blockMenu_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function blockMenu_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function blockMenu_createClass(Constructor, protoProps, staticProps) { if (protoProps) blockMenu_defineProperties(Constructor.prototype, protoProps); if (staticProps) blockMenu_defineProperties(Constructor, staticProps); return Constructor; }
function blockMenu_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) blockMenu_setPrototypeOf(subClass, superClass); }
function blockMenu_setPrototypeOf(o, p) { blockMenu_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return blockMenu_setPrototypeOf(o, p); }
function blockMenu_createSuper(Derived) { var hasNativeReflectConstruct = blockMenu_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = blockMenu_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = blockMenu_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return blockMenu_possibleConstructorReturn(this, result); }; }
function blockMenu_possibleConstructorReturn(self, call) { if (call && (blockMenu_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return blockMenu_assertThisInitialized(self); }
function blockMenu_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function blockMenu_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function blockMenu_getPrototypeOf(o) { blockMenu_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return blockMenu_getPrototypeOf(o); }
function blockMenu_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




















var blockMenuPinAppearDuration = (block_menu_default()).blockMenuPinAppearDuration,
  blockMenu_blockMenuListAppearDuration = (block_menu_default()).blockMenuListAppearDuration;
var DISTANCE_TO_BLOCK = 150;
var DISTANCE_IN_GRID = 35;
// отступ справа для поиска блота по позиции мыши
var SEARCH_BLOT_X_OFFSET = 5;
// максимальная дистанция для поиска блота влево если есть подозрение что в elementFromPoint передаются координаты скроллбара,
// который перекрывает страницу(так работает на тач падах)
var SEARCH_BLOT_SCROLLBAR_MAX_X_DELTA = 20;
var BLOCK_ID_ATTR = 'data-block-menu-for-id';
var blockMenu_ID_ATTR = 'data-menu-id';
var blockMenu_ALIGNS = {
  'left': icons/* IconAlignLeft */.hID,
  'center': icons/* IconAlignCenter */.k5Z,
  'right': icons/* IconAlignRight */.Qz9,
  'justify': icons/* IconAlignJustify */.ypk
};
var ALIGN_HOTKEYS = {
  'left': browser/* modKey */.CF + '+shift+1',
  'center': browser/* modKey */.CF + '+shift+2',
  'right': browser/* modKey */.CF + '+shift+3'
};
var INDENTS = {
  'indent': icons/* IconIndent */._Og,
  'outdent': icons/* IconOutdent */.lC3
};
var OVERSIZE_CLASSES = [FULLWIDTH_CLASSES.enabled, RESIZEABLE_CLASSES.enabled];
function blockMenu_singleMenuState() {
  var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var available = ['menuVisible'];
  var state = {};
  for (var _i = 0, _available = available; _i < _available.length; _i++) {
    var item = _available[_i];
    if (item === active) {
      state[item] = true;
    } else {
      state[item] = false;
    }
  }
  return state;
}
var WithoutAnimationWrapperComponent = function WithoutAnimationWrapperComponent(props) {
  return (0,preact_module.h)("span", null, props.children);
};
var BlockMenuComponent = /*#__PURE__*/function (_Component) {
  blockMenu_inherits(BlockMenuComponent, _Component);
  var _super = blockMenu_createSuper(BlockMenuComponent);
  function BlockMenuComponent() {
    var _this;
    blockMenu_classCallCheck(this, BlockMenuComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    blockMenu_defineProperty(blockMenu_assertThisInitialized(_this), "onMouseDown", function (event) {
      //this.props.menu?.anchorBlot?.endEdit?.(event)
    });
    blockMenu_defineProperty(blockMenu_assertThisInitialized(_this), "onClick", function (event) {
      // не позволяем фокусироватся на меню и убирать каретку с элемента
      event.preventDefault();
      if (!_this.props.menu.anchorBlot) return;
      _this.setState(function (prevState) {
        var menuVisible = prevState.menuVisible;
        if ((0,dom/* isNodeEqualOrContain */.nN)(_this.buttonNode, event.target)) {
          if (!menuVisible) {
            _this.props.onMenuOpen();
            _this.props.setSelectedBlock(_this.props.blot);
            _this.selectedBlocks = _this.props.getSelectedBlocks();
            if (!_this.selectedBlocks.length) {
              _this.selectedBlocks.push(_this.props.blot);
            }
          } else {
            _this.props.onButtonClickClose();
            _this.selectedBlocks = [];
          }
          return blockMenu_singleMenuState(!menuVisible && 'menuVisible');
        }
        return null;
      });
    });
    blockMenu_defineProperty(blockMenu_assertThisInitialized(_this), "onCopyLinkButtonClick", function (event) {
      event.preventDefault();
      if (!_this.props.menu.anchorBlot) return;
      if ((0,dom/* isNodeEqualOrContain */.nN)(_this.buttonNode, event.target)) {
        _this.props.onCopyLinkButtonClick();
      }
    });
    blockMenu_defineProperty(blockMenu_assertThisInitialized(_this), "onUnlockBlockButtonClick", function (event) {
      event.preventDefault();
      if (!_this.props.menu.anchorBlot) return;
      if ((0,dom/* isNodeEqualOrContain */.nN)(_this.buttonNode, event.target)) {
        var blots = _this.props.blot.editor.scroll.selectedBlocks;
        if (blots.length > 1) {
          var blotsToUnlock = blots.filter(function (item) {
            return item.isBlotLocked;
          });
          blotsToUnlock.map(function (blot) {
            blot.unlockBlotAction();
          });
        } else {
          _this.props.blot.unlockBlotAction();
        }
      }
      _this.closeMenu();
    });
    blockMenu_defineProperty(blockMenu_assertThisInitialized(_this), "onButtonRef", function (node) {
      _this.buttonNode = node;
    });
    blockMenu_defineProperty(blockMenu_assertThisInitialized(_this), "onMenuRef", function (node) {
      if (!node) {
        if (_this.mainMenuPopper) {
          _this.mainMenuPopper.destroy();
          _this.mainMenuPopper = null;
        }
      } else {
        _this.mainMenuNode = node;
        var allowFlip = true;
        var storeState = {};
        var popperOpts = {
          placement: 'bottom-end',
          onCreate: function onCreate() {
            // позволяем перевернутся меню только при начальном рендере
            allowFlip = false;
          },
          modifiers: {
            flip: {
              behavior: ['bottom', 'top', 'right-start'],
              fn: function fn(data, options) {
                if (!allowFlip) {
                  return Object.assign(data, storeState);
                }
                data = popper/* default.Defaults.modifiers.flip.fn */.Z.Defaults.modifiers.flip.fn(data, options);
                storeState = {
                  flipped: data.flipped,
                  placement: data.placement,
                  offsets: data.offsets
                };
                return data;
              },
              boundariesElement: _this.props.scrollingContainer
            },
            preventOverflow: {
              priority: ['left', 'right', 'bottom', 'top']
            }
          }
        };
        if (_this.props.dontRenderOutOfEditorBody) {
          popperOpts.modifiers.flip.boundariesElement = _this.props.editor.editorBody;
          popperOpts.modifiers.preventOverflow.boundariesElement = _this.props.editor.editorBody;
        }
        _this.mainMenuPopper = new popper/* default */.Z(_this.buttonNode, node, popperOpts);
      }
    });
    blockMenu_defineProperty(blockMenu_assertThisInitialized(_this), "onMenuWantsToClose", function () {
      _this.closeMenu();
    });
    blockMenu_defineProperty(blockMenu_assertThisInitialized(_this), "onMenuItemExec", function (action) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _this.props.onExec(action, params);
      _this.onMenuWantsToClose();
    });
    blockMenu_defineProperty(blockMenu_assertThisInitialized(_this), "onMenuItemAction", function (action) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _this.props.onAction(action, params);
      _this.onMenuWantsToClose();
    });
    blockMenu_defineProperty(blockMenu_assertThisInitialized(_this), "onHeaderMenuItemExec", function (action) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _this.props.onExec(action, params);
      _this.onMenuWantsToClose();
    });
    blockMenu_defineProperty(blockMenu_assertThisInitialized(_this), "groupItems", function (items) {
      return groupMenuItems(items);
    });
    blockMenu_defineProperty(blockMenu_assertThisInitialized(_this), "renderItem", function (id, item) {
      var onClick = false;
      if (item.action && !item.submenu) {
        if (item.actionExec) {
          onClick = function onClick(event) {
            event.preventDefault();
            event.stopPropagation();
            _this.onMenuItemExec(item.action, item.actionParams);
          };
        } else {
          onClick = function onClick(event) {
            event.preventDefault();
            event.stopPropagation();
            _this.onMenuItemAction(item.action, item.actionParams);
          };
        }
      }
      var props = _this.props;
      return (0,preact_module.h)(plugins_i18n/* IntlProvider */.Pj, null, (0,preact_module.h)(BlockMenuItem, blockMenu_extends({
        id: id,
        idAttr: blockMenu_ID_ATTR,
        menuStyle: item.style || null,
        disabled: item.active === false ? true : false,
        onClick: onClick,
        text: item.label,
        hint: item.submenu && (0,preact_module.h)(icons/* IconArrowRight */.Ec8, null) || item.hint || null,
        icon: item.icon || null,
        verifyItem: _this.verifyItem,
        submenu: item.submenu,
        colorPickerParams: item.colorPickerParams || {},
        wantsToClose: _this.onMenuWantsToClose,
        singleBlock: _this.selectedBlocks.length === 1 ? true : false,
        selectedBlocks: _this.selectedBlocks
      }, props)));
    });
    blockMenu_defineProperty(blockMenu_assertThisInitialized(_this), "renderGroup", function (group) {
      var single = _this.selectedBlocks.length === 1 ? true : false;
      var prepareGroup = function prepareGroup(group) {
        return group.filter(function (item) {
          return single ? true : _this.verifyItem(item);
        });
      };
      var items = prepareGroup(group);
      return items.length ? (0,preact_module.h)("div", {
        className: "block-menu-group"
      }, items.map(function (item) {
        return _this.renderItem(item.id, item);
      })) : null;
    });
    blockMenu_defineProperty(blockMenu_assertThisInitialized(_this), "verifyItem", function (item) {
      return isMenuItemAllowed(item, _this.getSelectedBlocksNames(_this.selectedBlocks));
    });
    return _this;
  }
  blockMenu_createClass(BlockMenuComponent, [{
    key: "closeMenu",
    value: function closeMenu() {
      var _this2 = this;
      this.setState(function (prevState) {
        return blockMenu_singleMenuState(prevState);
      }, function () {
        _this2.props.onMenuClose();
      });
    }
  }, {
    key: "getSelectedBlocksNames",
    value:
    //получаем названия конструкторов классов выделенных блоков
    function getSelectedBlocksNames(blocks) {
      return getBlotsNames(blocks);
    }
  }, {
    key: "getCurrentBlocksAlign",
    value: function getCurrentBlocksAlign() {
      return getBlotsAlign(this.selectedBlocks);
    }
  }, {
    key: "getBlocksIndent",
    value: function getBlocksIndent() {
      return getBlotsIndent(this.selectedBlocks);
    }

    //получаем список пунков меню
  }, {
    key: "getItems",
    value: function getItems() {
      if (this.selectedBlocks.indexOf(this.props.blot) < 0) {
        this.selectedBlocks = [this.props.blot];
        return this.props.blot.contextMenu;
      }
      var menu = getAllMenuItemsForBlots(this.selectedBlocks);
      return menu;
    }
  }, {
    key: "getHeaderMenu",
    value: function getHeaderMenu(_ref) {
      var _this3 = this;
      var align = _ref.align,
        indent = _ref.indent,
        currentIndents = _ref.currentIndents;
      var _this$props = this.props,
        blot = _this$props.blot,
        menu = _this$props.menu;
      var i18n = this.props.menu.editor.plugins.i18n;
      if (this.selectedBlocks.length === 1 && blot.getBlotMenuHeaderComponent) {
        var MenuHeaderComponent = blot.getBlotMenuHeaderComponent();
        return MenuHeaderComponent ? (0,preact_module.h)(MenuHeaderComponent, {
          blot: blot,
          menu: menu
        }) : null;
      } else if (align || indent) {
        var aligns = blockMenu_ALIGNS;
        if (Array.isArray(align)) {
          aligns = {};
          var _iterator = blockMenu_createForOfIteratorHelper(align),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              aligns[item] = blockMenu_ALIGNS[item];
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        return (0,preact_module.h)("div", {
          className: "block-menu-group block-menu-header-menu"
        }, align ? Object.keys(aligns).map(function (align) {
          var _iconAttrs;
          var Icon = aligns[align];
          var id = 'align-' + align;
          var iconAttrs = (_iconAttrs = {}, blockMenu_defineProperty(_iconAttrs, tooltipManager/* TOOLTIP_ATTR */.qZ, i18n.get('block_menu.align.' + align) + (ALIGN_HOTKEYS[align] ? '\n' + ALIGN_HOTKEYS[align] : '')), blockMenu_defineProperty(_iconAttrs, tooltipManager/* TOOLTIP_ADD_CLASS */.Bg, 'text-align-tooltip'), _iconAttrs);
          return (0,preact_module.h)("div", {
            className: "block-menu-header-item",
            onClick: function onClick(event) {
              event.preventDefault();
              event.stopPropagation();
              _this3.onHeaderMenuItemExec('set-align', align);
            },
            "data-menu-id": id
          }, (0,preact_module.h)("div", blockMenu_extends({}, iconAttrs, {
            className: 'icon ' + (_this3.getCurrentBlocksAlign() === align ? 'active' : '')
          }), (0,preact_module.h)(Icon, null)));
        }) : null, indent ? Object.keys(INDENTS).map(function (indent) {
          var Icon = INDENTS[indent];
          var disabled = indent === 'indent' && currentIndents.current === currentIndents.max || indent === 'outdent' && currentIndents.current === 0;
          var iconAttrs = blockMenu_defineProperty({}, tooltipManager/* TOOLTIP_ATTR */.qZ, i18n.get('block_menu.indent.' + indent));
          return (0,preact_module.h)("div", {
            className: "block-menu-header-item",
            onClick: !disabled && function (event) {
              event.preventDefault();
              event.stopPropagation();
              _this3.onHeaderMenuItemExec(indent);
            },
            "data-menu-id": indent
          }, (0,preact_module.h)("div", blockMenu_extends({}, iconAttrs, {
            className: 'icon ' + (disabled ? 'disabled' : '')
          }), (0,preact_module.h)(Icon, null)));
        }) : null);
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var buttonAttrs = {};
      var blotLocked = false;
      if (this.props.blot && this.props.blot.isBlotLocked) {
        blotLocked = true;
      }
      // если не режим редактирования и плагин активен, возвращаем кнопку копирования ссылки на заметку
      if (!this.props.editMode && this.props.showCopyBlotButton) {
        buttonAttrs[tooltipManager/* TOOLTIP_ATTR */.qZ] = this.props.tooltip;
        return (0,preact_module.h)("div", {
          className: "block-menu",
          onClick: this.onCopyLinkButtonClick
        }, (0,preact_module.h)("div", blockMenu_extends({
          className: "block-menu-copy-pin",
          ref: this.onButtonRef
        }, buttonAttrs), (0,preact_module.h)(icons/* IconLink */.JHz, null)));
      } else if (blotLocked) {
        var i18n = this.props.menu.editor.plugins.i18n;
        if (this.props.blot && this.props.blot.canUnlock) {
          var unlockName = i18n.get('block_menu.blot_locked_admin');
          var blots = this.props.blot.editor.scroll.selectedBlocks;
          if (blots.length > 1) {
            unlockName = i18n.get('block_menu.blot_locked_admins');
          }
          buttonAttrs[tooltipManager/* TOOLTIP_ATTR */.qZ] = unlockName;
          return (0,preact_module.h)("div", {
            className: "block-menu",
            onClick: this.onUnlockBlockButtonClick
          }, (0,preact_module.h)("div", blockMenu_extends({
            className: "block-menu-locked-pin",
            ref: this.onButtonRef
          }, buttonAttrs), (0,preact_module.h)(icons/* IconLockHover */.TSJ, null)));
        } else {
          buttonAttrs[tooltipManager/* TOOLTIP_ATTR */.qZ] = i18n.get('block_menu.blot_locked_user');
          return (0,preact_module.h)("div", {
            className: "block-menu"
          }, (0,preact_module.h)("div", blockMenu_extends({
            className: "block-menu-locked-pin"
          }, buttonAttrs), (0,preact_module.h)(icons/* IconLockHover */.TSJ, null)));
        }
      }
      var blockMenu = (0,preact_module.h)("span", {
        key: "block-menu-main"
      });
      var menuVisible = this.state.menuVisible;
      if (menuVisible) {
        var menuItems = this.getItems();
        var menu = this.groupItems(menuItems);
        var headerMenu = null;
        var align = menuItems.align,
          indent = menuItems.indent;
        var currentIndents = this.getBlocksIndent();
        headerMenu = this.getHeaderMenu({
          align: align,
          indent: indent,
          currentIndents: currentIndents
        });
        blockMenu = (0,preact_module.h)(popupMenu/* default */.Z, {
          wantsToClose: this.onMenuWantsToClose,
          closeOnEsc: true,
          addClassName: "block-menu-list block-menu-main",
          key: "block-menu-main",
          domRef: this.onMenuRef
        }, headerMenu, Object.keys(menu).map(function (group) {
          return _this4.renderGroup(menu[group]);
        }));
      } else {
        buttonAttrs[tooltipManager/* TOOLTIP_ATTR */.qZ] = this.props.tooltip;
        buttonAttrs[tooltipManager/* TOOLTIP_ATTR_ALLOW_UNSAFE_HTML */.aP] = 1;
        buttonAttrs[tooltipManager/* TOOLTIP_TIMEOUT_ATTR */.xQ] = 300;
      }
      return (0,preact_module.h)("div", {
        className: "block-menu",
        onClick: this.onClick,
        onMouseDown: this.onMouseDown
      }, (0,preact_module.h)("div", blockMenu_extends({
        className: BlockMenu.BUTTON_CLASS + (menuVisible ? ' active' : ''),
        ref: this.onButtonRef
      }, buttonAttrs), (0,preact_module.h)(icons/* IconPinBtn */.aXx, null)), (0,preact_module.h)(preact_transition_group/* default */.Z, {
        transitionName: "block-menu",
        transitionEnterTimeout: blockMenu_blockMenuListAppearDuration,
        transitionLeaveTimeout: blockMenu_blockMenuListAppearDuration
      }, blockMenu));
    }
  }]);
  return BlockMenuComponent;
}(preact_module/* Component */.wA);
var BlockMenu = /*#__PURE__*/function () {
  function BlockMenu(_ref2) {
    var _this5 = this;
    var scroll = _ref2.scroll,
      editor = _ref2.editor,
      options = _ref2.options;
    blockMenu_classCallCheck(this, BlockMenu);
    blockMenu_defineProperty(this, "onStartDragging", function (event) {
      _this5.dragging = true;
      _this5.open = false;
      if (_this5.anchorBlot) {
        _this5.anchorBlot.domNode.classList.remove('block-menu-open');
      }
      _this5.hide(true);
    });
    blockMenu_defineProperty(this, "onStopDragging", function (event) {
      _this5.dragging = false;
    });
    blockMenu_defineProperty(this, "onMouseMove", function (event) {
      if ((0,dom/* isNodeEqualOrContain */.nN)(_this5.container, event.target)) {
        clearTimeout(_this5.timer);
        return;
      }
      if (_this5.open || _this5.dragging) return;
      var x = event.clientX;
      var y = event.clientY;
      _this5.savedMousePos = {
        x: x,
        y: y
      };
      var scrollRect = _this5.scroll.domNode.getBoundingClientRect();
      //переменная возвращает - ведем ли мы мышь по редактируемой области или же вне ее
      var onBlot = event.target == _this5.editor.scrollingContainer ? false : true;
      //скрываем меню если ведем по левую сторону от редактируемой облости на дистанции больше допустимой (DISTANCE_TO_BLOCK)
      if (x <= scrollRect.x - DISTANCE_TO_BLOCK) {
        var hide = true;
        var fullWidthNodes = OVERSIZE_CLASSES.reduce(function (nodes, className) {
          return [].concat(blockMenu_toConsumableArray(nodes), blockMenu_toConsumableArray(Array.from(_this5.scroll.domNode.getElementsByClassName(className))));
        }, []);
        if (fullWidthNodes) {
          var _iterator2 = blockMenu_createForOfIteratorHelper(fullWidthNodes),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var node = _step2.value;
              var rect = node.getBoundingClientRect();
              if (y >= rect.top && y <= rect.top + rect.height) {
                if (x >= rect.x - DISTANCE_TO_BLOCK) {
                  hide = false;
                }
                break;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
        if (hide) {
          _this5.hide();
          return;
        }
      }
      //скрываем меню если ведем по правую сторону от редактируемой области
      if (x >= scrollRect.x + scrollRect.width) {
        _this5.hide();
        return;
      }

      //получаем блок по оси Y, так как все первичные блоки имеют ширину 100% и правый X блока (надо протестить все блоки чтобы в этом убедиться) вегда равен правому X scroll'а,
      //потому ищем блоки с конца редактора
      var pointX = scrollRect.x + scrollRect.width - SEARCH_BLOT_X_OFFSET;
      var nodeFromPoint = document.elementFromPoint(pointX, y);
      nodeFromPoint = _this5.getCorrectNodeIfOverlayingScroll(nodeFromPoint, pointX, y);
      var blot = getBlotForNode(nodeFromPoint);
      // Корректировка поиска блота по правой стороне если найденный блот является враппером и имеет внутренний паддинг, который мы можем получить
      if (blot && blot.getInnerRightPadding && blot.getInnerRightPadding() !== 0) {
        pointX -= blot.getInnerRightPadding();
        nodeFromPoint = document.elementFromPoint(pointX, y);
        nodeFromPoint = _this5.getCorrectNodeIfOverlayingScroll(nodeFromPoint, pointX, y);
        blot = getBlotForNode(nodeFromPoint);
      }
      if (!blot) {
        blot = _this5.findBlotForEmbeddedMenu(nodeFromPoint);
      }
      //скрываем если ведем по Y между блоками либо ниже последнего блока в редакторе
      if (blot === _this5.scroll || !blot) {
        _this5.hide();
        return;
      }
      blot = searchUp(blot, function (b) {
        return b.isFocusable;
      }) || blot;

      // проверка нахождения блота в колонке
      if (searchUp(blot, function (blot) {
        return blot instanceof blots_gridCol;
      })) {
        var gridWrapper = findWithClass(blot, blots_grid),
          overGrid;
        //так как выше отсеяли ведение по правой стороне от редактируемой области, тут проверяем не ведем ли по левой стороне,
        //и в этом случае нужно получить прямоугольник первого грида
        if (!onBlot && gridWrapper) {
          overGrid = gridWrapper.children.head;
        } else {
          var blotForNode = getBlotForNode(event.target);
          if (!blotForNode) {
            blotForNode = _this5.findBlotForEmbeddedMenu(event.target);
          }
          overGrid = findWithClass(blotForNode, blots_gridCol);
        }
        if (overGrid) {
          //получаем прямоугольник грида
          var overGridRect = overGrid.domNode.getBoundingClientRect();
          //получаем элемент по координатам гриде учитывая паддинг грида, так же учитываем что у последнего грида паддинга справа нет
          var pX = overGridRect.x + overGridRect.width - (gridWrapper.children.tail !== overGrid ? DISTANCE_IN_GRID : 0) - SEARCH_BLOT_X_OFFSET;
          var pY = y;
          var element = document.elementFromPoint(pX, pY);
          element = _this5.getCorrectNodeIfOverlayingScroll(element, pX, pY);
          blot = getBlotForNode(element);
          // Корректировка поиска блота по правой стороне если найденный блот является враппером и имеет внутренний паддинг, который мы можем получить
          if (blot && blot.getInnerRightPadding && blot.getInnerRightPadding() !== 0) {
            element = document.elementFromPoint(pX - blot.getInnerRightPadding(), pY);
            element = _this5.getCorrectNodeIfOverlayingScroll(element, pX, pY);
            blot = getBlotForNode(element);
          }
          if (!blot) {
            blot = _this5.findBlotForEmbeddedMenu(element);
          } else {
            // если возвращается inline блот, то ищем focusable блот выше
            // или tableWrapper (иначе для таблицы в гриде не будет отображаться меню)
            // или uploaderWrapper (так как целевой блот uploader находится ниже координат)
            blot = searchUp(blot, function (b) {
              return b.isFocusable || b.constructor.blotName === 'tableWrapper' || b.constructor.blotName === 'uploaderWrapper';
            });
          }
          if (blot === overGrid) {
            _this5.hide();
            return;
          }
        } else {
          _this5.hide();
          return;
        }
      }
      var wrappedBlot = blot && blot.getWrappedBlot ? blot.getWrappedBlot() : blot;
      if (wrappedBlot && !wrappedBlot.isFocusable) {
        return;
      }
      // не показываем меню для блота в процессе анимации
      if (wrappedBlot && wrappedBlot.inTransition) {
        return;
      }
      // если блот находится в таблице, значит целевой блот должен быть таблицей
      if (blot && blot.isTableCell && blot.isTableCell()) {
        try {
          var tableBlot = searchUp(getBlotForNode(blot.domNode.parentNode), function (b) {
            return b.constructor.blotName === 'table';
          });
          if (tableBlot) {
            blot = tableBlot;
          }
        } catch (err) {}
      }
      //условие для оптимизации, чтобы не происходил постоянный рендер меню при mousemove
      if (blot && blot !== _this5.anchorBlot) {
        //дополнительная проверка является ли полученный блот враппером для функционального блота, например случай с таблицей
        if (blot.getWrappedBlot) {
          blot = blot.getWrappedBlot();
        }
        //доп. проверка является ли блок вспомогательным, например Caption для Attachment
        if (blot.getBlotForMenu) {
          blot = blot.getBlotForMenu();
        }
        _this5.show(blot, {
          blot: blot
        });
      }
    });
    blockMenu_defineProperty(this, "onEmbedLoaded", function (event) {
      if (!_this5.anchorBlot) {
        return console.warn('no anchorBlot for menu');
      }
      if (event.id === _this5.anchorBlot.id) {
        _this5.show(_this5.anchorBlot, {
          blot: _this5.anchorBlot
        });
      }
    });
    blockMenu_defineProperty(this, "onKeyDown", function (event) {
      var allowedKeys = [9, 16, 17, 18, 91, 27];
      if (allowedKeys.indexOf(event.keyCode) !== -1) return;
      _this5.onMenuClose();
    });
    blockMenu_defineProperty(this, "onMenuOpen", function () {
      if (!_this5.anchorBlot) return;
      _this5.open = true;
      _this5.anchorBlot.domNode.classList.add('block-menu-open');
      _this5.editor.plugins.tooltipManager.hide();
      _this5.editor.emitter.emit('block-menu-open');
    });
    blockMenu_defineProperty(this, "onMenuClose", function () {
      if (_this5.anchorBlot) {
        _this5.anchorBlot.domNode.classList.remove('block-menu-open');
      }
      _this5.hide(true);
      setTimeout(function () {
        _this5.open = false;
        _this5.editor.emitter.emit('block-menu-close');
      }, blockMenu_blockMenuListAppearDuration);
    });
    blockMenu_defineProperty(this, "onButtonClickClose", function () {
      if (_this5.anchorBlot) {
        _this5.anchorBlot.domNode.classList.remove('block-menu-open');
      }
      setTimeout(function () {
        _this5.open = false;
        _this5.editor.emitter.emit('block-menu-close');
      }, blockMenu_blockMenuListAppearDuration);
    });
    blockMenu_defineProperty(this, "onCopyLinkButtonClick", function () {
      var copyManager = _this5.editor.plugins.copyManager;
      var baseUrl = _this5.editor.options.baseUrl || String(window.location.origin + window.location.pathname);
      var link = String(baseUrl + '#' + _this5.anchorBlot.id);
      copyManager.copy(link);
    });
    blockMenu_defineProperty(this, "onExec", function (action, params) {
      _this5.editor.exec(action, params);
    });
    blockMenu_defineProperty(this, "onAction", function (action, params) {
      _this5.scroll.selectedBlocks.map(function (block) {
        block[action](params);
      });
    });
    blockMenu_defineProperty(this, "setSelectedBlock", function (block) {
      var singleSelected = false;
      if (_this5.scroll.selectedBlocks.indexOf(block) < 0) {
        if (block.isFocusable) {
          block.focusableFocus();
        } else {
          _this5.scroll.selection.setRange({
            index: block.offset(_this5.scroll),
            length: 0
          });
        }
        singleSelected = true;
      } else if (_this5.scroll.selectedBlocks.length === 1) {
        singleSelected = true;
      }
      if (singleSelected) {
        setTimeout(function () {
          block.setProps({
            selected: true
          });
        }, 100);
      }
    });
    blockMenu_defineProperty(this, "getSelectedBlocks", function () {
      return _this5.scroll.selectedBlocks;
    });
    blockMenu_defineProperty(this, "updatePosition", function () {
      var anchorRect = _this5.anchorBlot.domNode.getBoundingClientRect();
      var anchorNode = _this5.anchorBlot.domNode;
      // даем блоту вернуть DOM элемент, к которому надо привязывать значек блот меню
      // getBlotMenuAnchorNode
      if (_this5.anchorBlot.getBlotMenuAnchorNode) {
        anchorNode = _this5.anchorBlot.getBlotMenuAnchorNode();
      }
      var offset = getContainerOffset(anchorNode, _this5.editor.scrollingContainer);
      var top, left;
      if (_this5.anchorBlot instanceof textBase) {
        var lineHeight = parseInt(window.getComputedStyle(_this5.anchorBlot.domNode).lineHeight);
        top = offset.y + (lineHeight / 2 - 12);
      } else {
        top = offset.y - 1;
      }
      //переменная для фикса позиции, когда якорем является враппер с горизонтальным скроллом
      var offsetScrollLeft = _this5.anchorBlot.domNode.scrollLeft || 0;
      //Фикс для картинки
      if (_this5.anchorBlot instanceof attachment_image && (_this5.anchorBlot.hasAttachment() || _this5.anchorBlot.image.src && _this5.anchorBlot.image.src !== '') && _this5.anchorBlot.wrapper && !_this5.anchorBlot.domNode.classList.contains('loading')) {
        offset = getContainerOffset(_this5.anchorBlot.wrapper, _this5.editor.scrollingContainer);
        _this5.container.style.left = offset.x - 26 + 'px';
      } else {
        //Фикс для врапперов блоков, которые имеют отрицательный margin
        if (offset.x < _this5.scroll.domNode.offsetLeft) {
          offset.x = _this5.scroll.domNode.offsetLeft;
          offsetScrollLeft = 0;
        }
        left = offset.x - 26 + offsetScrollLeft;
      }

      // даем блоту скорректировать позицию меню через onBlotMenuUpdatePosition
      if (_this5.anchorBlot.onBlotMenuUpdatePosition) {
        var _this5$anchorBlot$onB = _this5.anchorBlot.onBlotMenuUpdatePosition({
          left: left,
          top: top
        });
        left = _this5$anchorBlot$onB.left;
        top = _this5$anchorBlot$onB.top;
      }
      _this5.container.style.top = top + 'px';
      _this5.container.style.left = left + 'px';
    });
    options = Object.assign({
      enabled: true
    }, options);
    this.scroll = scroll;
    this.editor = editor;
    this.anchorBlot = null;
    this.container = null;
    this.open = false;
    this.dragging = false;
    this.hidden = true;
    this.enabled = options.enabled;
    this.options = options;
    this.init();
  }
  blockMenu_createClass(BlockMenu, [{
    key: "init",
    value: function init() {
      if (!this.enabled) {
        return;
      }
      this.container = document.createElement('div');
      this.container.classList.add('block-menu-container');
      this.editor.scrollingContainer.appendChild(this.container);
      this.render(this.container);
      this.editor.scrollingContainer.addEventListener('mousemove', this.onMouseMove);
      this.editor.scrollingContainer.addEventListener('keydown', this.onKeyDown);
      this.editor.emitter.on('embed-loaded', this.onEmbedLoaded);
      this.editor.emitter.on('start-dragging', this.onStartDragging);
      this.editor.emitter.on('stop-dragging', this.onStopDragging);
      this.editor.emitter.on('grid-resize-start', this.onStartDragging);
      this.editor.emitter.on('grid-resize-end', this.onStopDragging);
      this.editor.emitter.on('embed-resize-start', this.onStartDragging);
      this.editor.emitter.on('embed-resize-end', this.onStopDragging);
      this.editor.emitter.on('start-nedit-selection', this.onStartDragging);
      this.editor.emitter.on('end-nedit-selection', this.onStopDragging);
    }
  }, {
    key: "getCorrectNodeIfOverlayingScroll",
    value: function getCorrectNodeIfOverlayingScroll(nodeFromPoint, x, y) {
      var _this6 = this;
      if (nodeFromPoint === this.editor.scrollingContainer) {
        // преположительно присутствует перекрывающий скроллбар(используется тач пад)
        // ищем влево
        nodeFromPoint = (0,dom/* searchByCoordinates */.Fp)({
          x: x,
          y: y
        }, 'x', -1, x - SEARCH_BLOT_SCROLLBAR_MAX_X_DELTA, function (node) {
          return node !== _this6.editor.scrollingContainer;
        });
      }
      //если область редактирования скрывается за скроллом по оси X, берем X от ширины окна - 1
      else if (!nodeFromPoint && x > window.innerWidth) {
        var correctX = window.innerWidth - 1;
        var node = document.elementFromPoint(correctX, y);
        return this.getCorrectNodeIfOverlayingScroll(node, correctX, y);
      }
      return nodeFromPoint;
    }
  }, {
    key: "findBlotForEmbeddedMenu",
    value: function findBlotForEmbeddedMenu(node) {
      if (node) {
        // курсор может быть наведен на встроенное меню
        var embeddedMenuNode = node.closest && node.closest('[' + BLOT_ID_ATTR + ']');
        if (embeddedMenuNode) {
          var blotId = embeddedMenuNode.getAttribute(BLOT_ID_ATTR);
          return this.editor.findById(blotId);
        }
      }
      return null;
    }
  }, {
    key: "tryUpdateAnchorBlot",
    value: function tryUpdateAnchorBlot() {
      if (!this.savedMousePos) return;
      var nodeFromPoint = document.elementFromPoint(this.savedMousePos.x, this.savedMousePos.y);
      this.onMouseMove({
        clientX: this.savedMousePos.x,
        clientY: this.savedMousePos.y,
        target: nodeFromPoint
      });
    }
  }, {
    key: "adjustPositionContinuously",
    value: function adjustPositionContinuously() {
      var _this7 = this;
      var clear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var adjust = function adjust() {
        if (!_this7.anchorBlot) {
          return;
        }
        if (!(0,dom/* isNodeConnected */.S5)(_this7.anchorBlot.domNode)) {
          _this7.tryUpdateAnchorBlot();
          return;
        }
        if (!_this7.container) {
          return;
        }
        _this7.updatePosition();
        requestAnimationFrame(adjust);
      };
      if (clear) {
        cancelAnimationFrame(adjust);
      } else {
        adjust();
      }
    }
  }, {
    key: "render",
    value: function render(container) {
      var withMenu = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var props = arguments.length > 2 ? arguments[2] : undefined;
      var AddToRenderComponent = null;
      // сначала пробуем получить дополнительный компонент для рендера
      if (withMenu && this.anchorBlot) {
        if (this.anchorBlot.blockMenuAddComponent) {
          AddToRenderComponent = this.anchorBlot.blockMenuAddComponent();
        }
      }
      var WrapperComponent = preact_transition_group/* default */.Z;
      // если не выставлен режим редактирования отключаем рендер пина и меню блока
      var renderWithoutMenu = this.editor.mode !== this.editor.constructor.MODE_EDIT;
      if (renderWithoutMenu && this.options.showCopyBlotButton) {
        if (this.anchorBlot instanceof textBase && this.anchorBlot.isEmpty()) {
          renderWithoutMenu = true;
        } else {
          renderWithoutMenu = false;
        }
      }
      if (renderWithoutMenu) {
        withMenu = false;
        // выключаем анимацию, потому что если рендерится доп компонент его поведение не очень с анимацией
        WrapperComponent = WithoutAnimationWrapperComponent;
      }
      var pinTooltip = null;
      if (this.editor.plugins.i18n) {
        if (this.editor.mode === this.editor.constructor.MODE_EDIT) {
          pinTooltip = this.editor.plugins.i18n.get('block_menu.tooltip');
        } else {
          pinTooltip = this.editor.plugins.i18n.get('block_menu.copy_tooltip');
        }
      }
      (0,preact_module/* render */.sY)((0,preact_module.h)(WrapperComponent, {
        transitionName: "block-menu",
        transitionEnterTimeout: blockMenuPinAppearDuration,
        transitionLeaveTimeout: blockMenuPinAppearDuration
      }, withMenu ? (0,preact_module.h)(BlockMenuComponent, blockMenu_extends({
        tooltip: pinTooltip,
        onMenuOpen: this.onMenuOpen,
        onMenuClose: this.onMenuClose,
        onButtonClickClose: this.onButtonClickClose,
        onCopyLinkButtonClick: this.onCopyLinkButtonClick,
        onExec: this.onExec,
        onAction: this.onAction,
        setSelectedBlock: this.setSelectedBlock,
        updatePosition: this.updatePosition,
        menu: this,
        getSelectedBlocks: this.getSelectedBlocks,
        scrollingContainer: this.editor.getScrollingContainer ? this.editor.getScrollingContainer() : document.body,
        theme: this.editor.plugins.editorStyle ? this.editor.plugins.editorStyle.getTheme() : 'light',
        editMode: this.editor.mode === this.editor.constructor.MODE_EDIT,
        showCopyBlotButton: this.options.showCopyBlotButton,
        dontRenderOutOfEditorBody: this.editor.options.disallowInterfacesOutOfEditor,
        editor: this.editor
      }, props)) : null, AddToRenderComponent ? (0,preact_module.h)(AddToRenderComponent, {
        blot: this.anchorBlot
      }) : null), container);
    }

    // эту функцию нельзя вызывать в requestAnimationFrame или каком либо цикле (много раз) c параметром force = true
  }, {
    key: "updateBlockMenu",
    value: function updateBlockMenu() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!force) {
        this.tryUpdateAnchorBlot();
      } else {
        this.show(this.anchorBlot, {
          blot: this.anchorBlot
        });
      }
    }
  }, {
    key: "show",
    value: function show(anchor, props) {
      clearTimeout(this.timer);
      this.adjustPositionContinuously(true);
      this.hidden = false;
      this.anchorBlot = anchor;
      this.container.setAttribute(BLOCK_ID_ATTR, props.blot.id);
      this.adjustPositionContinuously();
      setTimeout(this.render(this.container, true, props), 0);
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this8 = this;
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      clearTimeout(this.timer);
      if (force) {
        this.adjustPositionContinuously(true);
        this.hidden = true;
        this.anchorBlot = null;
        this.render(this.container);
      } else {
        this.timer = setTimeout(function () {
          //this.adjustPositionContinuously(true)
          _this8.hidden = true;
          _this8.anchorBlot = null;
          _this8.render(_this8.container);
        }, blockMenuPinAppearDuration);
      }
    }
  }]);
  return BlockMenu;
}();

BlockMenu.BUTTON_CLASS = 'block-menu-pin-button';
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/dragAndDrop/index.js
function dragAndDrop_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = dragAndDrop_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function dragAndDrop_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return dragAndDrop_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return dragAndDrop_arrayLikeToArray(o, minLen); }
function dragAndDrop_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



















function dragAndDrop_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function dragAndDrop_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function dragAndDrop_createClass(Constructor, protoProps, staticProps) { if (protoProps) dragAndDrop_defineProperties(Constructor.prototype, protoProps); if (staticProps) dragAndDrop_defineProperties(Constructor, staticProps); return Constructor; }
function dragAndDrop_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var dragAndDrop_isEscKey = (0,lib/* default */.ZP)('escape');
var TOP_BOTTOM_DROP_MAX_DISTANCE = 20;
var MIN_SIDE_DROP_DISTANCE = 20;
var MAX_SIDE_DROP_DISTANCE = 1000;
var SEARCH_BLOT_STEP = 5;
var MAX_AUTOSCROLL_DISTANCE = 20;
var SEARCH_IN_GRIDCOL_MAX_DISTANCE_BOTTOM = 20;
// пользователь должен сдвинуть мышку на 5 пикселей после нажатия чтобы запустить процесс перемещения блотов
var dragAndDrop_TRIGGER_DISTANCE = 5;
var DragAndDrop = /*#__PURE__*/function () {
  function DragAndDrop(_ref) {
    var _this = this;
    var scroll = _ref.scroll,
      editor = _ref.editor,
      doc = _ref.doc,
      _options = _ref.options;
    dragAndDrop_classCallCheck(this, DragAndDrop);
    dragAndDrop_defineProperty(this, "onEditorMouseDown", function (event) {
      //не выполняем если нажатие было правой кнопкой мыши
      if (event.which === 3) return;
      var node = event.target;
      var blot = getBlotForNode(node);

      //реализация d&d за любой выделенный блок при мультивыделении
      if (_this.options.allowDragOnMultiSelect && _this.isMouseInSelectedArea(event)) {
        _this.mouseDownPosition = {
          x: event.clientX,
          y: event.clientY
        };
        return;
      }
      if (blot && blot.canDragWith && blot.canDragWith(node)) {
        _this.mouseDownPosition = {
          x: event.clientX,
          y: event.clientY
        };
        if (blot.onlySingleDragging && blot.onlySingleDragging()) {
          _this.mouseDownTargetBlot = blot;
        }
        return;
      }
      if (!node.closest('.' + BlockMenu.BUTTON_CLASS)) {
        return;
      }
      _this.mouseDownPosition = {
        x: event.clientX,
        y: event.clientY
      };
    });
    dragAndDrop_defineProperty(this, "onEditorMouseMove", function (event) {
      if (!_this.mouseDownPosition) {
        return;
      }
      var nowPosition = {
        x: event.clientX,
        y: event.clientY
      };
      if (math_distance(nowPosition, _this.mouseDownPosition) >= dragAndDrop_TRIGGER_DISTANCE) {
        var params = {};
        if (_this.blotsToDradOnMultiSelect && _this.blotsToDradOnMultiSelect.length > 2) {
          params.blots = Array.from(_this.blotsToDradOnMultiSelect);
        }
        if (_this.mouseDownTargetBlot) {
          params.targetBlot = _this.mouseDownTargetBlot;
          params.blots = [_this.mouseDownTargetBlot];
        }
        _this.startDragSession(params);
        _this.mouseDownPosition = null;
        _this.blotsToDradOnMultiSelect = null;
        _this.mouseDownTargetBlot = null;
      }
    });
    dragAndDrop_defineProperty(this, "onEditorMouseUp", function (event) {
      if (!_this.mouseDownPosition) {
        return;
      }
      _this.mouseDownTargetBlot = null;
      _this.mouseDownPosition = null;
      _this.blotsToDradOnMultiSelect = null;
    });
    dragAndDrop_defineProperty(this, "onEditorKeyDown", function (event) {
      if (!_this.session) {
        return;
      }
      if (dragAndDrop_isEscKey(event)) {
        var eventNames = _this.session.getEventsNames();
        if (!_this.session.isControlled) {
          _this.document.removeEventListener(eventNames.pointermove, _this.onDragMouseMove);
          _this.document.removeEventListener(eventNames.pointerup, _this.onDragMouseUp);
        }
        if (!_this.session.disablePhantoms) {
          _this.editor.clipboard.innerHTML = '';
        }
        _this.editor.scrollingContainer.classList.remove('drag-session');
        _this.clearTimerScroll();
        _this.session.clearAction();
        _this.session.cleanup();
        _this.session = null;
        _this.editor.emitter.emit('stop-dragging');
      }
    });
    dragAndDrop_defineProperty(this, "findBlotByDomNode", function (node) {
      var blot = src_parchment.find(node);
      while (!blot && node) {
        node = node.parentNode;
        blot = src_parchment.find(node);
      }
      return blot;
    });
    dragAndDrop_defineProperty(this, "onDragMove", function (event) {
      var blotTarget = _this.findBlotByDomNode(event.target);
      var blot = blotTarget;
      blot = _this.getBlotFromEventTargetBlot(blot, event);
      if (!blot) {
        // не смогли найти блот поддерживающий дроп в родительских блотах таргета,
        // смотрим позицию курсора относительно scroll блота
        var scrollRect = _this.session.getScrollRect();
        if (event.x < scrollRect.x) {
          // курсор находится слева от скролл блота, надо выполнить поиск ближайшего блота справа от курсора
          // блот должен поддерживать боковой дроп
          blot = _this.searchBlot(scrollRect.x, event.y, SEARCH_BLOT_STEP, scrollRect.x + Math.min(scrollRect.width, MAX_SIDE_DROP_DISTANCE));
          if (blot instanceof blots_gridCol) {
            // проверяем чтобы с первым блотом в гриде можно было сделать лефт дроп
            // во избежание появления полосы переноса снизу/сверху от первого блота, когда курсор находится
            // заведомо не для этого переноса
            var firstGridColChild = blot.children.head;
            var _rect = firstGridColChild.domNode.getBoundingClientRect();
            if (_this.leftDropCondition(event.x - _rect.x, _rect)) {
              blot = firstGridColChild;
            }
          }
          blot = searchUp(blot, function (b) {
            return b.isDropAcceptor && !b.disallowSideDrop;
          });
        } else if (event.x > scrollRect.x + scrollRect.width) {
          // курсор справа от скролл блота
          // выполняем поиск блота слева
          blot = _this.searchBlot(scrollRect.x + scrollRect.width, event.y, -SEARCH_BLOT_STEP, scrollRect.x);
          if (blot instanceof blots_gridCol) {
            // проверяем чтобы с первым блотом в гриде можно было сделать райт дроп
            // во избежание появления полосы переноса снизу/сверху от первого блота, когда курсор находится
            // заведомо не для этого переноса
            var _firstGridColChild = blot.children.head;
            var _rect2 = _firstGridColChild.domNode.getBoundingClientRect();
            if (_this.rightDropCondition(event.x - _rect2.x, _rect2)) {
              blot = _firstGridColChild;
            }
          }
          blot = searchUp(blot, function (b) {
            return b.isDropAcceptor && !b.disallowSideDrop;
          });
        }
        if (!blot) {
          //возможно курсор находится на скролл блоте, ниже последнего блока
          if (_this.scroll.children) {
            var lastBlotRect = _this.scroll.children.tail.domNode.getBoundingClientRect();
            if (event.y > lastBlotRect.y + lastBlotRect.height) {
              blot = _this.scroll.children.tail;
            }
          }
        }
      }
      if (!blot) {
        _this.session.clearAction();
        return;
      }
      var parentGridCol = _this.getGridColForBlot(blot);
      var isMoveRelToSelf = _this.session.blots.indexOf(blot.getWrapper()) >= 0 || _this.session.blots.indexOf(blot.getWrappedBlot()) >= 0;
      if (!parentGridCol && isMoveRelToSelf) {
        _this.session.clearAction();
        return;
      }
      // если в массиве перетаскиваемых блотов есть toggle блоты, нельзя дропать в toggleContent
      if (searchUp(blot, function (b) {
        return b.isCollapsibleContainer;
      }) && _this.session.blots.some(function (dragBlot) {
        return dragBlot.constructor.blotName.indexOf('toggle') !== -1 || dragBlot.constructor.blotName.indexOf('step') !== -1;
      })) {
        _this.session.clearAction();
        return;
      }
      var rect = blot.domNode.getBoundingClientRect();
      // мы должны запретить левый перенос если блот это не позволяет, но только если блот не в колонке
      var leftDropAllowed = blot.container && blot.container.disallowInsideSideDrop ? false : !blot.disallowSideDrop || Boolean(parentGridCol);
      var rightDropAllowed = blot.container && blot.container.disallowInsideSideDrop ? false : !blot.disallowSideDrop;
      var upDropAllowed = !blot.disallowUpAndDownDrop;
      var downDropAllowed = !blot.disallowUpAndDownDrop;
      var insideDropAllowed = blot.allowInsideDrop ? true : false;

      // координаты курсора относительно блота
      var relX = event.x - rect.x;
      var relY = event.y - rect.y;
      var action = null;
      if (leftDropAllowed && _this.leftDropCondition(relX, rect)) {
        // слева
        action = 'left';
      } else if (rightDropAllowed && _this.rightDropCondition(relX, rect, parentGridCol)) {
        // справа
        action = 'right';
      } else if (upDropAllowed && relY <= Math.min(rect.height / 2, TOP_BOTTOM_DROP_MAX_DISTANCE)) {
        // сверху
        action = 'top';
      } else if (downDropAllowed && relY >= rect.height - Math.min(TOP_BOTTOM_DROP_MAX_DISTANCE, rect.height / 2)) {
        // снизу
        action = 'bottom';
      } else if (insideDropAllowed) {
        // внутри
        action = 'inside';
      }
      if (isMoveRelToSelf && ['top', 'bottom'].indexOf(action) >= 0) {
        action = null;
      }
      if (parentGridCol && ['left', 'right'].indexOf(action) >= 0) {
        // если ховер-блот находится в грид-колонке и выполняется боковой перенос,
        // то надо подсветить все дочерние элементы этой грид-колонки
        if (isMoveRelToSelf && parentGridCol.children.length === 1) {
          // если блот единственный в колонке и выполняется перенос справа или слева от самого себя, то это сделать нельзя
          action = null;
        }
      }
      if (action && !_this.willPositionChange(action, blot, parentGridCol)) {
        // действие не вызовет изменение позиции блота, отменяем установку действия в сессию
        action = null;
      }
      if (action) {
        _this.session.setAction(action, blot);
      } else {
        _this.session.clearAction();
      }
    });
    dragAndDrop_defineProperty(this, "dropForTop", function (blots, hover, index, context) {
      if (blots.length) {
        var prev = blots[blots.length - 1].getWrapper();
        var hoverIndex = hover.index;
        if (prev !== hover.prev) {
          blots.forEach(function (blot) {
            var blotIndex = blot.index;
            var changedParent = blot.getWrapper().parent_id != hover.parent_id ? true : false;
            var updateBlockRes = _this.updateBlock(blot, hover.parent_id, index, context);
            if (updateBlockRes && (changedParent || hoverIndex < blotIndex)) {
              index++;
            }
          });
        }
      }
    });
    dragAndDrop_defineProperty(this, "dropForBottom", function (blots, hover, index, context) {
      if (blots.length) {
        var next = blots[0].getWrapper();
        if (next !== hover.next) {
          index++;
          blots.forEach(function (blot) {
            var blotIndex = blot.index;
            var changedParent = blot.getWrapper().parent_id != hover.parent_id ? true : false;
            if (_this.updateBlock(blot, hover.parent_id, index, context)) {
              if (blotIndex > hover.index || changedParent) {
                index++;
              }
            }
          });
        }
      }
    });
    dragAndDrop_defineProperty(this, "duplicate", function (blots, hover, index, context) {
      var callback = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
      if (blots.length) {
        var duplicateAction = new DuplicateAction(DuplicateAction.type, {}, _this.editor);
        var processingBlots = blots.map(function (blot) {
          return {
            blot: blot,
            index: blot.index
          };
        }).filter(function (_ref2) {
          var blot = _ref2.blot;
          if (blot.isListItem) {
            return !blot.props.hidden;
          }
          return blot;
        });
        duplicateAction.exec({
          processingBlots: processingBlots.map(function (_ref3) {
            var blot = _ref3.blot;
            return blot;
          })
        });
        var duplicatedBlots = duplicateAction.getDuplicatedBlots();
        if (processingBlots[0].index < index) {
          index += duplicatedBlots.length;
        }
        callback(duplicatedBlots, hover, index, context);
      }
    });
    dragAndDrop_defineProperty(this, "onDragMouseMove", function (originalEvent) {
      event = _this.formatPointerEvent(originalEvent);
      if (!_this.session.touch) {
        event.preventDefault();
      }
      if (_this.session.phantoms) {
        _this.session.phantoms.forEach(function (el, idx) {
          var initLeft = parseFloat(el.getAttribute('data-init-left'));
          var initTop = parseFloat(el.getAttribute('data-init-top'));
          var deltaX = event.clientX - _this.session.initCursorPosition.x;
          var deltaY = event.clientY - _this.session.initCursorPosition.y;
          var x = initLeft + deltaX;
          var y = initTop + deltaY;
          el.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
        });
      }
      _this.session.setCursorPosition(event.clientX, event.clientY);
      if (!_this.session.isControlled) {
        // скролл выключен для контроллируемой сессии
        _this.scrollIfNeed(event.clientX, event.clientY);
      }
      _this.onDragMove(event);
    });
    dragAndDrop_defineProperty(this, "onDragMouseUp", function (event) {
      if (!_this.session) {
        return;
      }
      var eventNames = _this.session.getEventsNames();
      if (!_this.session.isControlled) {
        event.preventDefault();
        event.stopPropagation();
        _this.document.removeEventListener(eventNames.pointermove, _this.onDragMouseMove);
        _this.document.removeEventListener(eventNames.pointerup, _this.onDragMouseUp);
      }
      _this.scroll.batchStart();
      try {
        _this.editor.clipboard.innerHTML = '';
        var options = {};
        if (isOptionKeyPressed(event)) {
          options.duplicateOnDrop = true;
        }
        _this.onDrop(options);
        _this.scroll.selection.clearSelection();
      } catch (ex) {
        throw ex;
      } finally {
        _this.scroll.batchEnd();
        _this.scroll.update('user');
        _this.editor.scrollingContainer.classList.remove('drag-session');
        _this.clearTimerScroll();
        _this.editor.emitter.emit('stop-dragging');
      }
    });
    this.scroll = scroll;
    this.editor = editor;
    this.options = _options || {};
    this.document = doc || document;
    this.session = null;
    // позиция относительно клиентской области где пользовател нажал на значек контекстного меню
    // если = null значит левая кнопка не нажата, либо пользователь нажал в другом месте, либо drag and drop уже запущен
    this.mouseDownPosition = null;
    this.editor.container.addEventListener('mousedown', this.onEditorMouseDown, false);
    this.editor.container.addEventListener('mousemove', this.onEditorMouseMove, false);
    this.editor.container.addEventListener('mouseup', this.onEditorMouseUp, false);
    document.addEventListener('keydown', this.onEditorKeyDown, false);
  }
  dragAndDrop_createClass(DragAndDrop, [{
    key: "destroy",
    value: function destroy() {
      this.editor.container.removeEventListener('mousedown', this.onEditorMouseDown, false);
      this.editor.container.removeEventListener('mousemove', this.onEditorMouseMove, false);
      this.editor.container.removeEventListener('mouseup', this.onEditorMouseUp, false);
      document.removeEventListener('keydown', this.onEditorKeyDown, false);
    }
  }, {
    key: "getGridColForBlot",
    value: function getGridColForBlot(blot) {
      while (blot) {
        if (blot instanceof blots_gridCol) {
          return blot;
        }
        blot = blot.parent;
      }
      return null;
    }
  }, {
    key: "isMouseInSelectedArea",
    value: function isMouseInSelectedArea(event) {
      if (this.scroll.selectedBlocks.length < 2) {
        return false;
      }
      var mouseX = event.clientX,
        mouseY = event.clientY;
      var allowDrag = false;
      var _iterator = dragAndDrop_createForOfIteratorHelper(this.scroll.selectedBlocks),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var blot = _step.value;
          var _blot$domNode$getBoun = blot.domNode.getBoundingClientRect(),
            x = _blot$domNode$getBoun.x,
            y = _blot$domNode$getBoun.y,
            width = _blot$domNode$getBoun.width,
            height = _blot$domNode$getBoun.height;
          if (mouseX > x && mouseX < x + width && mouseY > y && mouseY < y + height) {
            allowDrag = true;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (allowDrag) {
        // эта переменная нужна для сохранения массива выделенных блоков, потому что зачастую в массиве scroll.selectedBlocks остается один целевой блок,
        // пока не знаю с чем это связано
        this.blotsToDradOnMultiSelect = Array.from(this.scroll.selectedBlocks);
      }
      return allowDrag;
    }
  }, {
    key: "addSubListItemsToDrag",
    value: function addSubListItemsToDrag() {
      var blotsToDrag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var blots = [];
      var _iterator2 = dragAndDrop_createForOfIteratorHelper(blotsToDrag),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var blot = _step2.value;
          // при добавлении блота в массив, он уже может существовать в нем, если это был список с сабсписками,
          // так как добавление сабсписков происходит при добавлении родительского элемента итерацией раньше
          if (blots.indexOf(blot) !== -1) {
            continue;
          }
          if (!blot.isListItem) {
            blots.push(blot);
          } else {
            blots.push(blot);
            if (blot.getSubItems) {
              var subItems = blot.getSubItems();
              var _iterator3 = dragAndDrop_createForOfIteratorHelper(subItems),
                _step3;
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var item = _step3.value;
                  blots.push(item);
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return blots;
    }
  }, {
    key: "startDragSession",
    value: function startDragSession() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var targetBlot = params.targetBlot || this.editor.plugins.blockMenu.anchorBlot;
      var blotsToDrag = params.blots || (this.scroll.selectedBlocks.indexOf(targetBlot) < 0 ? [targetBlot] : this.scroll.selectedBlocks);
      blotsToDrag = blotsToDrag.filter(function (item) {
        return item && !item.isBlotLocked;
      });
      blotsToDrag = this.addSubListItemsToDrag(blotsToDrag);
      blotsToDrag = blotsToDrag.filter(function (blot) {
        return blot && !blot.dontProcessDragAndDrop;
      });
      this.session = new DragSession({
        blots: blotsToDrag,
        scroll: this.scroll,
        editor: this.editor,
        minSideDropDistance: MIN_SIDE_DROP_DISTANCE,
        isControlled: params.isControlled,
        touch: params.touch,
        disablePhantoms: params.disablePhantoms
      });
      this.startDragging(params.mousePosition || this.mouseDownPosition);
      this.editor.emitter.emit('start-dragging');
      return this.session;
    }
  }, {
    key: "searchBlotAxis",
    value: function searchBlotAxis(startX, startY, axis, increment, limit, fn) {
      var cond = function () {
        if (increment > 0) {
          if (axis === 'x') {
            return function (x, y) {
              return x < limit;
            };
          } else if (axis === 'y') {
            return function (x, y) {
              return y < limit;
            };
          }
        } else {
          if (axis === 'x') {
            return function (x, y) {
              return x > limit;
            };
          } else if (axis === 'y') {
            return function (x, y) {
              return y > limit;
            };
          }
        }
      }();
      for (var y = startY, x = startX; cond(x, y); axis === 'x' ? x += increment : y += increment) {
        var node = this.document.elementFromPoint(x, y);
        var blot = normalizeToStoredBlot(getBlotForNode(node));
        if (!blot) {
          continue;
        }
        if (fn(blot)) {
          return {
            blot: blot,
            x: x,
            y: y
          };
        }
      }
    }
  }, {
    key: "searchBlot",
    value: function searchBlot(startX, y, increment, limit) {
      var cond = function () {
        if (increment > 0) {
          return function (x) {
            return x < limit;
          };
        } else {
          return function (x) {
            return x > limit;
          };
        }
      }();
      for (var x = startX; cond(x); x += increment) {
        var node = this.document.elementFromPoint(x, y);
        var blot = getBlotForNode(node);
        if (!blot) {
          continue;
        }
        blot = searchUp(blot, function (b) {
          return b.isDropAcceptor || b instanceof blots_gridCol;
        });
        if (blot) {
          return blot;
        }
      }
      return null;
    }

    // проверяет изменится ли позиция переносимых блотов после выполнения действия
  }, {
    key: "willPositionChange",
    value: function willPositionChange(action, blot, parentGridCol) {
      if (action === 'left' || action === 'right') {
        // если переносятся все дочерние блоты контейнера и находимся вне грида, то перенос надо запретить
        if (this.session.getWholeContainersDragging().includes(blot) && !parentGridCol) {
          return false;
        }
        return true;
      }
      if (action === 'top') {
        var movingRelBlot = this.session.blots[this.session.blots.length - 1];
        if (movingRelBlot && movingRelBlot.getWrapper && blot.getWrapper().prev === movingRelBlot.getWrapper()) {
          return false;
        }
      } else if (action === 'bottom') {
        var _movingRelBlot = this.session.blots[0];
        if (_movingRelBlot && _movingRelBlot.getWrapper && blot.getWrapper().next === _movingRelBlot.getWrapper()) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "searchBlotForGridCol",
    value: function searchBlotForGridCol(event, gridCol) {
      var gridPos = (0,dom/* getElementPosition */._z)(gridCol.domNode);
      var fn = function fn(blot) {
        return !(blot instanceof blots_gridCol) && searchUp(blot.container, function (b) {
          return b === gridCol;
        });
      };
      var topBlot = this.searchBlotAxis(event.clientX, event.clientY, 'y', -SEARCH_BLOT_STEP, gridPos.top, fn);
      var bottomBlot = this.searchBlotAxis(event.clientX, event.clientY, 'y', SEARCH_BLOT_STEP, event.clientY + SEARCH_IN_GRIDCOL_MAX_DISTANCE_BOTTOM, fn);
      var getBestBlot = function getBestBlot(blots) {
        return blots.map(function (blotInf) {
          if (!blotInf) {
            return {
              dist: Number.POSITIVE_INFINITY
            };
          }
          return {
            dist: Math.abs(event.clientY - blotInf.y),
            blot: blotInf.blot
          };
        }).sort(function (b1, b2) {
          return b1.dist - b2.dist;
        })[0].blot;
      };
      var blotY = getBestBlot([topBlot, bottomBlot]);
      if (blotY) {
        return blotY;
      }
      var leftBlot = this.searchBlotAxis(event.clientX, event.clientY, 'x', -SEARCH_BLOT_STEP, gridPos.left, fn);
      var rightBlot = this.searchBlotAxis(event.clientX, event.clientY, 'x', SEARCH_BLOT_STEP, gridPos.left + gridPos.width, fn);
      var blotX = getBestBlot([leftBlot, rightBlot]);
      if (blotX) {
        return blotX;
      }
      return null;
    }
  }, {
    key: "normalizeToDropAcceptor",
    value: function normalizeToDropAcceptor(blot) {
      if (blot && this.session.blots.indexOf(blot) >= 0) {
        blot = searchUp(blot.parent, function (b) {
          return b.isDropAcceptor;
        });
      }
      if (blot) {
        blot = searchUp(blot, function (b) {
          return b.isDropAcceptor;
        });
      }
      return blot;
    }

    /**
     * finds the drop acceptor
     */
  }, {
    key: "findDropAcceptorForDraggingBlots",
    value: function findDropAcceptorForDraggingBlots(blot) {
      var dropAcceptor = this.normalizeToDropAcceptor(blot);
      return dropAcceptor;
    }
  }, {
    key: "getBlotFromEventTargetBlot",
    value: function getBlotFromEventTargetBlot(blot, event) {
      if (blot instanceof blots_gridCol) {
        // надо сделать поиск ближайшего к курсору блота, находящегося в гриде
        var blotInGrid = this.searchBlotForGridCol(event, blot);
        if (blotInGrid) {
          blot = blotInGrid;
          blot = this.normalizeToDropAcceptor(blot);
        } else {
          var firstGridColChild = blot.children.head;
          firstGridColChild = this.normalizeToDropAcceptor(firstGridColChild);
          var rect = firstGridColChild && firstGridColChild.domNode && firstGridColChild.domNode.getBoundingClientRect() || 0;
          var relX = event.x - rect.x;
          if (this.leftDropCondition(relX, rect) || this.rightDropCondition(relX, rect, blot)) {
            blot = firstGridColChild;
          }
        }
      } else {
        blot = this.findDropAcceptorForDraggingBlots(blot);
      }
      return blot;
    }
  }, {
    key: "leftDropCondition",
    value: function leftDropCondition(relX, rect) {
      return relX <= -MIN_SIDE_DROP_DISTANCE;
    }
  }, {
    key: "rightDropCondition",
    value: function rightDropCondition(relX, rect, parentGridCol) {
      if (parentGridCol) {
        // если текущий блот находится в гриде, то не разрешаем перенос справа от него, кроме случая если он находится в последней
        // колонке грида
        if (parentGridCol.parent.children.tail !== parentGridCol) {
          return false;
        }
      }
      return relX > rect.width && relX - rect.width >= MIN_SIDE_DROP_DISTANCE;
    }
  }, {
    key: "updateBlock",
    value: function updateBlock(block, parent_id, index) {
      var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      block = block.getWrappedBlot();
      if (context.relBlot && context.relBlot.id === parent_id) {
        parent_id = context.relBlot.getWrapper().parent_id;
      }
      var parentBlot = this.editor.findById(parent_id);
      if (parentBlot && parentBlot.moveChild) {
        var result = parentBlot.moveChild(block, index, context);
        this.editor.emitter.emit(EVENT_BLOT_DRAG_STOPPED);
        return result;
      } else {
        console.warn('parentBlot is not node-root or gridCol');
        return false;
      }
    }
  }, {
    key: "onDrop",
    value: function onDrop() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var sessionAction = this.session.getAction();
      var context = this.session.getMoveContext();
      // надо очистить hover состояние у блотов
      this.session.clearAction();
      this.session.cleanup();
      if (!sessionAction) {
        return;
      }
      var action = sessionAction.action,
        blot = sessionAction.blot;
      var hover = blot;
      var duplicateOnDrop = options.duplicateOnDrop;

      // нормализуем hover для дропа на gridCol
      if (hover && hover instanceof blots_gridCol) {
        if (action === 'top') {
          hover = this.normalizeToDropAcceptor(hover.children.head);
        } else if (action === 'bottom') {
          hover = this.normalizeToDropAcceptor(hover.children.tail);
        }
      }

      // при дропе справа и слева Grid не может быть целевым блоком, но иногда возникает такая ситуация
      // при быстрых d&d (скрипт не успевает адекватно обработать действие), потому нужно нормализовать
      // целевой блот до DropAcceptor справа или слева
      if (hover && hover.constructor.blotName === 'grid') {
        if (action === 'left') {
          hover = this.normalizeToDropAcceptor(hover.children.head.children.head);
        } else if (action === 'right') {
          hover = this.normalizeToDropAcceptor(hover.children.tail.children.head);
        }
      }
      if (doBlotsHaveSameConstructor(this.session.blots)) {
        var Constr = this.session.blots[0].constructor;
        if (Constr.getDropTarget) {
          var _Constr$getDropTarget = Constr.getDropTarget(action, this.session.blots, hover, context);
          hover = _Constr$getDropTarget.target;
        }
      }
      var index = hover.index;
      context.relBlot = hover;
      if (action === 'top') {
        if (duplicateOnDrop) {
          this.duplicate(this.session.blots, hover, index, context, this.dropForTop);
        } else {
          this.dropForTop(this.session.blots, hover, index, context);
        }
      }
      if (action === 'bottom') {
        if (duplicateOnDrop) {
          this.duplicate(this.session.blots, hover, index, context, this.dropForBottom);
        } else {
          this.dropForBottom(this.session.blots, hover, index, context);
        }
      }
      if (action === 'left' || action === 'right') {
        var addGrid = new actions_addGrid(actions_addGrid.type, action, this.editor);
        if (duplicateOnDrop) {
          var duplicateAction = new DuplicateAction(DuplicateAction.type, {}, this.editor);
          duplicateAction.exec({
            processingBlots: this.session.blots
          });
          var duplicatedBlots = duplicateAction.getDuplicatedBlots();
          addGrid.run({
            processingBlots: hover,
            moveBlocks: duplicatedBlots,
            context: context
          });
        } else {
          addGrid.run({
            processingBlots: hover,
            moveBlocks: this.session.blots,
            context: context
          });
        }
      }
      this.session = null;
    }
  }, {
    key: "addBlotsToClipboard",
    value: function addBlotsToClipboard() {
      var _this2 = this;
      var phantoms = [];
      this.session.blots.forEach(function (blot) {
        var rect = blot.domNode.getBoundingClientRect();
        if (blot.onDraggingGetPhantomPos) {
          rect = blot.onDraggingGetPhantomPos();
        }
        var el;
        if (blot.getDraggingNode) {
          el = blot.getDraggingNode();
        } else {
          el = blot.domNode.cloneNode(true);
        }
        el.id = '';
        var _iterator4 = dragAndDrop_createForOfIteratorHelper(el.querySelectorAll('*')),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var elem = _step4.value;
            elem.id = '';
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        el.style.left = '0px';
        el.style.top = '0px';
        el.style.transform = 'translate(' + rect.x + 'px, ' + rect.y + 'px)';
        el.setAttribute('data-init-left', rect.x);
        el.setAttribute('data-init-top', rect.y);
        el.style.width = parseInt(rect.width) + 'px';
        el.style.textAlign = blot.map.get('align') || 'left';
        if (blot.props && blot.props.hidden) {
          el.style.display = 'none';
        }
        _this2.editor.clipboard.appendChild(el);
        phantoms.push(el);
      });
      return phantoms;
    }
  }, {
    key: "formatPointerEvent",
    value: function formatPointerEvent(event) {
      var res;
      if (!event.touches) {
        return event;
      }
      return {
        target: document.elementFromPoint(event.touches[0].clientX, event.touches[0].clientY),
        clientX: event.touches[0].clientX,
        clientY: event.touches[0].clientY,
        x: event.touches[0].clientX,
        y: event.touches[0].clientY
      };
    }
  }, {
    key: "scrollIfNeed",
    value: function scrollIfNeed(clientX, clientY) {
      var maxAutoScrollDistanceTop = this.options.maxAutoScrollTopDistance || MAX_AUTOSCROLL_DISTANCE;
      var maxAutoScrollDistanceBottom = this.options.maxAutoScrollBottomDistance || MAX_AUTOSCROLL_DISTANCE;
      // TODO make scrollingContainer an editor option not a plugin's one
      var scrollingContainer = this.editor.plugins.selectionScroller.getScrollingContainer();
      var scrollingContainerRect = (0,dom/* getFixedBoundingClientRect */.qL)(scrollingContainer);
      var editorHeight = scrollingContainer.offsetHeight;
      var rectTop = scrollingContainerRect.top;
      var up = clientY < rectTop + maxAutoScrollDistanceTop;
      var down = clientY > editorHeight + rectTop - maxAutoScrollDistanceBottom;
      var step = up ? -5 : down ? 5 : 0;
      //start scroll
      if (up || down) {
        if (!this.timerScroll) {
          this.timerScroll = setInterval(function () {
            scrollingContainer.scrollBy(0, step);
          }, 10);
        }
      }
      //working zone
      else {
        this.clearTimerScroll();
      }
    }
  }, {
    key: "clearTimerScroll",
    value: function clearTimerScroll() {
      if (this.timerScroll) {
        clearInterval(this.timerScroll);
        this.timerScroll = null;
      }
    }
  }, {
    key: "startDragging",
    value: function startDragging(coords) {
      var eventNames = this.session.getEventsNames();
      this.session.setCursorPosition(coords.x, coords.y);
      this.session.setInitCursorPosition(coords.x, coords.y);
      var blocksCoords = [];
      if (!this.session.disablePhantoms) {
        this.session.setPhantoms(this.addBlotsToClipboard());
      }
      if (!this.session.isControlled) {
        this.document.addEventListener(eventNames.pointermove, this.onDragMouseMove);
        this.document.addEventListener(eventNames.pointerup, this.onDragMouseUp);
      }
      this.editor.scrollingContainer.classList.add('drag-session');
    }
  }]);
  return DragAndDrop;
}();

DragAndDrop.TOP_BOTTOM_DROP_MAX_DISTANCE = TOP_BOTTOM_DROP_MAX_DISTANCE;
DragAndDrop.TRIGGER_DISTANCE = dragAndDrop_TRIGGER_DISTANCE;
DragAndDrop.MIN_SIDE_DROP_DISTANCE = MIN_SIDE_DROP_DISTANCE;
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/undoManager/index.js
function undoManager_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { undoManager_typeof = function _typeof(obj) { return typeof obj; }; } else { undoManager_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return undoManager_typeof(obj); }
function undoManager_slicedToArray(arr, i) { return undoManager_arrayWithHoles(arr) || undoManager_iterableToArrayLimit(arr, i) || undoManager_unsupportedIterableToArray(arr, i) || undoManager_nonIterableRest(); }
function undoManager_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function undoManager_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return undoManager_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return undoManager_arrayLikeToArray(o, minLen); }
function undoManager_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function undoManager_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function undoManager_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }














function undoManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function undoManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function undoManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) undoManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) undoManager_defineProperties(Constructor, staticProps); return Constructor; }
function undoManager_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) undoManager_setPrototypeOf(subClass, superClass); }
function undoManager_setPrototypeOf(o, p) { undoManager_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return undoManager_setPrototypeOf(o, p); }
function undoManager_createSuper(Derived) { var hasNativeReflectConstruct = undoManager_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = undoManager_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = undoManager_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return undoManager_possibleConstructorReturn(this, result); }; }
function undoManager_possibleConstructorReturn(self, call) { if (call && (undoManager_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return undoManager_assertThisInitialized(self); }
function undoManager_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function undoManager_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function undoManager_getPrototypeOf(o) { undoManager_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return undoManager_getPrototypeOf(o); }
function undoManager_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var STORED_RANGE_KEY = '_nmbEditorRange';
var UndoManager = /*#__PURE__*/function (_EventEmitter) {
  undoManager_inherits(UndoManager, _EventEmitter);
  var _super = undoManager_createSuper(UndoManager);
  function UndoManager(_ref) {
    var _this;
    var editor = _ref.editor,
      _options = _ref.options;
    undoManager_classCallCheck(this, UndoManager);
    _this = _super.call(this);
    undoManager_defineProperty(undoManager_assertThisInitialized(_this), "init", function () {
      var store = _this.editor.store;
      var options = Object.assign({
        captureTimeout: 400,
        trackedOrigins: new Set([null])
      }, _this.options);
      _this.yUndoManager = new yjs.UndoManager([store.blocks, store.rootChildren], options);
      _this.rangeToRestore = null;
      _this.lastRanges = [];
      _this.mouseDown = false;
      _this.selectionChangedWhenMouseDown = false;
      if (_this.editor.mode === _this.editor.constructor.MODE_EDIT) {
        _this.yUndoManager.on('stack-item-added', _this.onUndoBufferPush);
        _this.yUndoManager.on('stack-item-popped', _this.onUndoRedoBufferPop);
        document.addEventListener('selectionchange', _this.onSelectionChange, false);
        document.addEventListener('mousedown', _this.onMouseDown, false);
        document.addEventListener('mouseup', _this.onMouseUp, false);
      }
    });
    undoManager_defineProperty(undoManager_assertThisInitialized(_this), "onUndoBufferPush", function (_ref2) {
      var stackItem = _ref2.stackItem,
        type = _ref2.type,
        origin = _ref2.origin;
      //console.log('PUSH undo action', this.yUndoManager._undoBuffer)
      // setTimeout здесь используется для того, чтобы selectionchange после ввода символа был сохранен в onSelectionChange
      // т.к. onUndoBufferPush вызывается раньше чем onSelectionChange в случае ввода текста с клавиатуры
      //setTimeout(() => {
      var rangeToStore;
      if (_this.lastRanges.length) {
        rangeToStore = _this.lastRanges[_this.lastRanges.length - 1];
      }
      if (rangeToStore) {
        if (!stackItem.meta.has(STORED_RANGE_KEY)) {
          stackItem.meta.set(STORED_RANGE_KEY, rangeToStore);
        }
        //console.log('store range', rangeToStore, 'from', JSON.stringify(this.lastRanges, null, 2))
        //this.storedRanges.push(rangeToStore)
      }
      //}, 0)
      _this.editor.emitter.emit('undo-manager-change');
    });
    undoManager_defineProperty(undoManager_assertThisInitialized(_this), "onUndoRedoBufferPop", function (_ref3) {
      var stackItem = _ref3.stackItem,
        type = _ref3.type;
      if (stackItem) {
        // undo/redo не выполнилось по какой-то причине
        _this.rangeToRestore = stackItem.meta.get(STORED_RANGE_KEY);
      }
      _this.editor.emitter.emit('undo-manager-change');
    });
    undoManager_defineProperty(undoManager_assertThisInitialized(_this), "onMouseDown", function () {
      _this.mouseDown = true;
      _this.selectionChangedWhenMouseDown = false;
    });
    undoManager_defineProperty(undoManager_assertThisInitialized(_this), "onMouseUp", function () {
      _this.mouseDown = false;
      if (_this.selectionChangedWhenMouseDown) {
        _this.onSelectionChange();
      }
    });
    undoManager_defineProperty(undoManager_assertThisInitialized(_this), "onSelectionChange", function (event) {
      if (_this.mouseDown) {
        _this.selectionChangedWhenMouseDown = true;
        return;
      }
      var _this$editor$scroll$s = _this.editor.scroll.selection.getRange(),
        _this$editor$scroll$s2 = undoManager_slicedToArray(_this$editor$scroll$s, 1),
        lastRange = _this$editor$scroll$s2[0];
      //console.log('Change SEL:', lastRange)
      _this.lastRanges.push(lastRange);
      if (_this.lastRanges.length > 2) {
        _this.lastRanges.shift();
      }
    });
    _this.editor = editor;
    _this.options = _options;

    // инициализируем undo manager только после инициализации скролл блота, т.к. скролл блот может
    // добавлять блоты при инициализации и они не должны быть оменены через undo
    _this.editor.emitter.once('scroll-init', _this.init);
    return _this;
  }
  undoManager_createClass(UndoManager, [{
    key: "destroy",
    value: function destroy() {
      if (this.editor.mode === this.editor.constructor.MODE_EDIT) {
        document.removeEventListener('selectionchange', this.onSelectionChange, false);
        document.removeEventListener('mousedown', this.onMouseDown, false);
        document.removeEventListener('mouseup', this.onMouseUp, false);
      }
    }
  }, {
    key: "stopCapturing",
    value: function stopCapturing() {
      this.yUndoManager.stopCapturing();
    }
  }, {
    key: "captureRange",
    value: function captureRange() {
      var _this$editor$scroll$s3 = this.editor.scroll.selection.getRange(),
        _this$editor$scroll$s4 = undoManager_slicedToArray(_this$editor$scroll$s3, 1),
        lastRange = _this$editor$scroll$s4[0];
      if (lastRange) {
        this.lastRanges.push(lastRange);
      }
    }
  }, {
    key: "canUndo",
    value: function canUndo() {
      return this.yUndoManager.undoStack.length > 0;
    }
  }, {
    key: "canRedo",
    value: function canRedo() {
      return this.yUndoManager.redoStack.length > 0;
    }
  }, {
    key: "restoreRange",
    value: function restoreRange() {
      this.editor.scroll.selection.setRange(this.rangeToRestore);
      this.rangeToRestore = null;
    }
  }, {
    key: "undo",
    value: function undo() {
      var _this2 = this;
      if (!this.canUndo()) {
        return;
      }
      this._undoing = true;
      var err;
      try {
        var currentRange = this.editor.scroll.selection.getRange()[0];
        this.yUndoManager.once('redo-push', function (item) {
          item[STORED_RANGE_KEY] = currentRange;
        });
        this.editor.scroll.execInBatch(function () {
          return _this2.yUndoManager.undo();
        });
        this.restoreRange();
        this.captureRange();
      } catch (_err) {
        err = _err;
      }
      this._undoing = false;
      // выкидываем исключение об ошибке в зависимости от настроек
      var _ref4 = this.options || {},
        _ref4$throwExceptionW = _ref4.throwExceptionWhenError,
        throwExceptionWhenError = _ref4$throwExceptionW === void 0 ? true : _ref4$throwExceptionW;
      if (throwExceptionWhenError) {
        if (err) {
          throw err;
        }
      }
      this.editor.emitter.emit('undo-manager-change');
      this.editor.emitter.emit('undo');
    }
  }, {
    key: "redo",
    value: function redo() {
      var _this3 = this;
      if (!this.canRedo()) {
        return;
      }
      this._redoing = true;
      var err;
      try {
        this.editor.scroll.execInBatch(function () {
          return _this3.yUndoManager.redo();
        });
        this.restoreRange();
        this.captureRange();
      } catch (_err) {
        err = _err;
      }
      this._redoing = false;
      if (err) {
        throw err;
      }
      this.editor.emitter.emit('undo-manager-change');
      this.editor.emitter.emit('redo');
    }
  }, {
    key: "isUndoingOrRedoing",
    value: function isUndoingOrRedoing() {
      return this._undoing || this._redoing;
    }
  }, {
    key: "skip",
    value: function skip(fn) {
      this.editor.store.transaction(function () {
        fn();
      }, 'undo-skip');
    }
  }, {
    key: "clear",
    value: function clear() {
      this.yUndoManager._undoBuffer = [];
      this.yUndoManager._redoBuffer = [];
      this.yUndoManager._lastTransactionWasUndo = false;
    }
  }, {
    key: "undoState",
    get: function get() {
      return {
        canUndo: this.canUndo(),
        canRedo: this.canRedo()
      };
    }

    /**
     * Проверяем является ли источник апдеита UndoManager'ом
     * @param { object } origin
     * @returns { boolean }
     */
  }, {
    key: "isYUndoManager",
    value: function isYUndoManager(origin) {
      if (origin !== null && undoManager_typeof(origin) === 'object') {
        return origin === this.yUndoManager;
      }
      return false;
    }
  }, {
    key: "isUndoing",
    value: function isUndoing() {
      return this._undoing;
    }
  }, {
    key: "isRedoing",
    value: function isRedoing() {
      return this._redoing;
    }
  }]);
  return UndoManager;
}((events_default()));

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/pasteManager/deserializers/textLine.js
function deserializers_textLine_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { deserializers_textLine_typeof = function _typeof(obj) { return typeof obj; }; } else { deserializers_textLine_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return deserializers_textLine_typeof(obj); }
function deserializers_textLine_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = deserializers_textLine_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function textLine_toConsumableArray(arr) { return textLine_arrayWithoutHoles(arr) || textLine_iterableToArray(arr) || deserializers_textLine_unsupportedIterableToArray(arr) || textLine_nonIterableSpread(); }
function textLine_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function deserializers_textLine_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return deserializers_textLine_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return deserializers_textLine_arrayLikeToArray(o, minLen); }
function textLine_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function textLine_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return deserializers_textLine_arrayLikeToArray(arr); }
function deserializers_textLine_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



























var SKIP_BACKGROUND_COLORS = ['#161616', '#f5f5f5'];
var backgroundColors = textLine_toConsumableArray(Object.values(colors_palette)).filter(function (color) {
  return !SKIP_BACKGROUND_COLORS.includes(color);
});
var textLine_TAGS = {
  'P': true,
  'DIV': true,
  //'PRE': true,
  'DD': true,
  'DT': true,
  'DL': true
};
textLine_TAGS['H1'] = {
  textLineType: 'hLarge'
};
textLine_TAGS['H2'] = {
  textLineType: 'hMedium'
};
textLine_TAGS['H3'] = {
  textLineType: 'hSmall'
};
textLine_TAGS['H4'] = {
  textLineType: 'hSmall'
};
textLine_TAGS['H5'] = {
  textLineType: 'hSmall'
};
textLine_TAGS['H6'] = {
  textLineType: 'hSmall'
};
textLine_TAGS['BLOCKQUOTE'] = {
  textLineType: 'blockquote'
};
var TAGS_IMPORTANCE = ['BLOCKQUOTE', 'P', 'DIV', 'DD', 'DT', 'DL', 'DFN'];
function preparePre(node) {
  node.innerHTML = node.innerHTML.replace(/\n/g, '<BR>');
}

// если дельта содержит только linebreak, то он должен быть удален
// модифицирует дельту
function deleteOnlyBreak(delta) {
  if (delta.ops.length === 2 && delta.ops[0].insert.linebreak && delta.ops[1].insert === '\n') {
    delta.ops.shift();
  }
  return delta;
}
function getIndentFromClassName(className) {
  var match = className.match(/\bindent-([0-9]+)/, className);
  if (!match) {
    return null;
  }
  return parseInt(match[1]);
}
function deserializeTextLine(node, body) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var tagName = node.tagName;
  if (!textLine_TAGS.hasOwnProperty(tagName)) {
    return null;
  }
  if (node.tagName === 'PRE') {
    preparePre(node);
  }

  // разворачиваем теги, которые ниже по важности
  var importanceIdx = TAGS_IMPORTANCE.indexOf(node.tagName);
  if (importanceIdx >= 0) {
    var unwrapTags = TAGS_IMPORTANCE.slice(importanceIdx + 1);
    if (unwrapTags.length > 0) {
      var nodesToUnwrap = node.querySelectorAll(unwrapTags.join(','));
      var _iterator = deserializers_textLine_createForOfIteratorHelper(nodesToUnwrap),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var nodeToUnwrap = _step.value;
          var nextSibling = (0,dom/* getNextSibling */.d9)(nodeToUnwrap, function (node) {
            if (node.nodeType === Node.TEXT_NODE) {
              if (!params.raw) {
                return node.textContent.trim();
              }
              return node.textContent;
            }
            return true;
          });
          if (nextSibling) {
            var br = document.createElement('br');
            nodeToUnwrap.parentNode.insertBefore(br, nodeToUnwrap.nextSibling);
          }
          (0,dom/* unwrapNode */.XL)(nodeToUnwrap);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }
  var items = deserializeText(node, body, {});
  var containsOtherTextLines = false;
  var hasNonEmptyText = false;
  var _iterator2 = deserializers_textLine_createForOfIteratorHelper(items),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var item = _step2.value;
      if (!(item instanceof Element)) {
        item.type = 'textLine';
        var delta = void 0;
        if (!params.keepIndents && !params.raw) {
          delta = trimSpaces(item.initParams.delta);
        } else {
          delta = trimSpacesWin(item.initParams.delta);
        }
        if (!hasNonEmptyText && !isEmptyDelta(delta)) {
          hasNonEmptyText = true;
        }
        delta = deleteOnlyBreak(delta);
        item.initParams.delta = delta;
        if (deserializers_textLine_typeof(textLine_TAGS[tagName]) === 'object') {
          if (textLine_TAGS[tagName].initParams) {
            Object.assign(item.initParams, textLine_TAGS[tagName].initParams);
          }
          if (textLine_TAGS[tagName].textLineType) {
            item.textLineType = textLine_TAGS[tagName].textLineType;
            if (['hSmall', 'hMedium', 'hLarge'].indexOf(item.textLineType) >= 0) {
              item.initParams.delta = removeEndingLinebreaks(item.initParams.delta);
              item.initParams.delta = ensureDeltaEndsWithNewLine(item.initParams.delta);
            }
          }
        }
      } else if (textLine_TAGS[item.tagName]) {
        containsOtherTextLines = true;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  if (!hasNonEmptyText && containsOtherTextLines) {
    // удаляем все текстовые дельты, т.к. элемент содержит другие текстовые строки, но сам содержит пустой текст
    items = items.filter(function (item) {
      return item instanceof Element;
    });
  } else if (items.length && items[0].initParams) {
    var indent = getIndentFromClassName(node.className);
    var inlineStyles = getNodeStyles(node);
    if (node.hasAttribute('data-block-background')) {
      // при копипасте внутри редактора атрибут ноды указываюйщий на ее бэкграунд в приоритете
      items[0].initParams.color = node.getAttribute('data-block-background');
    } else if (inlineStyles['background-color'] && isRealColor(inlineStyles['background-color']) && !SKIP_HIGHLIGHT_COLORS[inlineStyles['background-color']]) {
      var backgroundColor = getClosestColor(inlineStyles['background-color'], backgroundColors, null);
      if (backgroundColor) {
        var backgroundColorName = Object.keys(colors_palette).filter(function (key) {
          return colors_palette[key] === backgroundColor;
        })[0];
        if (backgroundColorName) {
          items[0].initParams.color = backgroundColorName;
        }
      }
    }
    if (inlineStyles['text-align'] && ['left', 'right', 'center', 'justify'].indexOf(inlineStyles['text-align']) !== -1) {
      items[0].initParams.align = inlineStyles['text-align'];
    }
    // детектим что это Хинт блот через класс т.к. хинт это по сути параграф и отличается только наличием класса hintblock
    if (node.classList.contains('hintblock')) {
      items[0].textLineType = 'hint';
      if (node.hasAttribute('data-icon')) {
        items[0].initParams.icon = node.getAttribute('data-icon');
      }
    }
    items[0].initParams.indent = indent;
  }
  return items;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/pasteManager/deserializers/list.js
function deserializers_list_toConsumableArray(arr) { return deserializers_list_arrayWithoutHoles(arr) || deserializers_list_iterableToArray(arr) || deserializers_list_unsupportedIterableToArray(arr) || deserializers_list_nonIterableSpread(); }
function deserializers_list_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function deserializers_list_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function deserializers_list_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return deserializers_list_arrayLikeToArray(arr); }














function deserializers_list_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = deserializers_list_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function deserializers_list_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return deserializers_list_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return deserializers_list_arrayLikeToArray(o, minLen); }
function deserializers_list_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



var list_TAGS = {
  'UL': true,
  'OL': true
};
var NUMBER_ELEM_CLASS = 'list-item-number';
var OLD_EDITOR_CHECKBOX_LIST_CLASS = 'nn-checkbox-list';
var OLD_EDITOR_CHECKBOX_CHECKED_CLASS = 'nn-checked';
function isCheckboxList(node) {
  if (node.classList.contains(OLD_EDITOR_CHECKBOX_LIST_CLASS)) return true;
  var isCheckbox = false;
  var _iterator = deserializers_list_createForOfIteratorHelper(node.childNodes),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      if (item.classList && item.classList.contains(OLD_EDITOR_CHECKBOX_CHECKED_CLASS)) {
        isCheckbox = true;
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return isCheckbox;
}
function list_mergeDeltas(deltas) {
  if (!deltas.length) {
    return [];
  }
  var result = [];
  for (var i = 0; i < deltas.length - 1; i++) {
    var delta = deltas[i];
    var lastIndex = delta.ops.length - 1;
    if (lastIndex < 0) {
      continue;
    }
    if (delta.ops[lastIndex] === '\n') {
      delta.ops.pop();
    } else {
      delta.ops[lastIndex].insert = delta.ops[lastIndex].insert.replace(/\n$/, '');
    }
    result.push.apply(result, deserializers_list_toConsumableArray(delta.ops));
  }
  result.push.apply(result, deserializers_list_toConsumableArray(deltas[deltas.length - 1].ops));
  return {
    ops: result
  };
}
function list_getIndentFromClassName(className) {
  var match = className.match(/\bindent-([0-9]+)/, className);
  if (!match) {
    return null;
  }
  return parseInt(match[1]);
}
function processList(node, body) {
  var indent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var resItems = [];
  var checkboxList = isCheckboxList(node);
  var unparsedItems = [];
  var _iterator2 = deserializers_list_createForOfIteratorHelper(node.childNodes),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var item = _step2.value;
      var listItemType = node.tagName === 'UL' ? 'listItemBullet' : 'listItemNumber';
      var listItemIndent = indent;
      var listItemBackground = null;
      if (item.tagName === 'LI') {
        // временное решение пока не реализован #280, обрабатываем классы элементов, чтобы определить тип элемента списка
        if (item.classList.contains(CHECKBOX_ELEM_CLASS) || checkboxList) {
          listItemType = 'listItemCheckbox';
        } else if (item.classList.contains(NUMBER_ELEM_CLASS)) {
          listItemType = 'listItemNumber';
        }
        var indentFromClass = list_getIndentFromClassName(item.className);
        if (indentFromClass) {
          listItemIndent = indentFromClass;
        }
        if (item.hasAttribute('data-block-background')) {
          listItemBackground = item.getAttribute('data-block-background');
        }
        var textRes = deserializeText(item, body, {
          allowInnerTags: {
            '*BLOCK': function BLOCK(node, context) {
              if (context.nonEmptyStringOpMade) {
                return {
                  insert: {
                    linebreak: 's'
                  }
                };
              }
              return true;
            }
          }
        });
        var deltas = [];
        var subLists = [];
        var _iterator3 = deserializers_list_createForOfIteratorHelper(textRes),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var textResItem = _step3.value;
            if (textResItem instanceof Element) {
              if (list_TAGS[textResItem.tagName]) {
                subLists.push(textResItem);
              } else {
                unparsedItems.push(textResItem);
              }
            } else {
              deltas.push(textResItem.initParams.delta);
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        var params = {
          indent: listItemIndent
        };
        if (listItemBackground) {
          params.color = listItemBackground;
        }
        if (listItemType === 'listItemCheckbox' && (item.classList.contains(OLD_EDITOR_CHECKBOX_CHECKED_CLASS) || item.getAttribute('data-checked') === 'true')) {
          params.checked = true;
        }
        if (deltas.length) {
          params.delta = trimSpaces(list_mergeDeltas(deltas));
          resItems.push({
            params: params,
            type: listItemType
          });
        }
        for (var _i = 0, _subLists = subLists; _i < _subLists.length; _i++) {
          var subList = _subLists[_i];
          var _processList = processList(subList, body, indent + 1),
            sublistItems = _processList.resItems,
            unparsedSublistItems = _processList.unparsedItems;
          resItems.push.apply(resItems, deserializers_list_toConsumableArray(sublistItems));
          unparsedItems.push.apply(unparsedItems, deserializers_list_toConsumableArray(unparsedSublistItems));
        }
      } else if (list_TAGS[item.tagName]) {
        var _processList2 = processList(item, body, indent + 1),
          _sublistItems = _processList2.resItems,
          _unparsedSublistItems = _processList2.unparsedItems;
        resItems.push.apply(resItems, deserializers_list_toConsumableArray(_sublistItems));
        unparsedItems.push.apply(unparsedItems, deserializers_list_toConsumableArray(_unparsedSublistItems));
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return {
    resItems: resItems,
    unparsedItems: unparsedItems
  };
}
function deserializeList(node, body) {
  var tagName = node.tagName;
  if (!list_TAGS.hasOwnProperty(tagName)) {
    return null;
  }
  var _processList3 = processList(node, body),
    listItems = _processList3.resItems,
    unparsedItems = _processList3.unparsedItems;
  return [{
    type: 'list',
    initParams: {
      items: listItems
    }
  }].concat(deserializers_list_toConsumableArray(unparsedItems));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/pasteManager/deserializers/image.js


var image_TAGS = {
  'IMG': true
};
var SRC_REGEXP = /^https?:\/\//i;
function deserializeImage(node, body) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var tagName = node.tagName;
  if (!image_TAGS.hasOwnProperty(tagName)) {
    return null;
  }
  var src = node.getAttribute('src');
  if ((!src || !SRC_REGEXP.test(src)) && !node.hasAttribute(ATTACH_GLOBAL_ID_HTML_ATTR)) {
    return null;
  }
  var align = 'center';
  var attachmentGlobalId;
  var styles = bubbleStyles(node);
  var width, height;
  if (styles['text-align'] === 'left' || styles['text-align'] === 'right') {
    align = styles['text-align'];
  }
  if (node.hasAttribute(ATTACH_GLOBAL_ID_HTML_ATTR)) {
    if (node.hasAttribute(ATTACH_ROOM_HTML_ATTR)) {
      if (params.editorRoom && node.getAttribute(ATTACH_ROOM_HTML_ATTR) === params.editorRoom) {
        attachmentGlobalId = node.getAttribute(ATTACH_GLOBAL_ID_HTML_ATTR);
      }
    } else {
      attachmentGlobalId = node.getAttribute(ATTACH_GLOBAL_ID_HTML_ATTR);
    }
  }
  if (node.hasAttribute(IMAGE_ORIGINAL_WIDTH_ATTR)) {
    width = node.getAttribute(IMAGE_ORIGINAL_WIDTH_ATTR);
  } else if (styles['width']) {
    var widthFromStyles = parseInt(styles['width']);
    if (!isNaN(widthFromStyles)) {
      width = widthFromStyles;
    }
  }
  if (node.hasAttribute(IMAGE_ORIGINAL_HEIGHT_ATTR)) {
    height = node.getAttribute(IMAGE_ORIGINAL_HEIGHT_ATTR);
  } else if (styles['height']) {
    var heightFromStyles = parseInt(styles['height']);
    if (!isNaN(heightFromStyles)) {
      height = heightFromStyles;
    }
  }
  var initParams = {
    align: align
  };
  if (width) {
    initParams.width = width;
  }
  if (height) {
    initParams.height = height;
  }
  if (attachmentGlobalId) {
    initParams.attachmentGlobalId = attachmentGlobalId;
  }
  var res = {
    type: 'image',
    initParams: initParams
  };
  if (!attachmentGlobalId) {
    if (!src) {
      return null;
    }
    res.onBlot = function (blot) {
      blot.embedAttachmentUrl(src, 'api');
    };
  }
  return [res];
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/pasteManager/deserializers/file.js
function deserializers_file_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var TAG_NAME = 'NIMBUS-FILE';

var file_TAGS = deserializers_file_defineProperty({}, TAG_NAME, true);
function file_deserializeImage(node, body) {
  var tagName = node.tagName;
  if (!file_TAGS.hasOwnProperty(tagName)) {
    return null;
  }
  var attachmentGlobalId;
  if (node.hasAttribute(ATTACH_GLOBAL_ID_HTML_ATTR)) {
    attachmentGlobalId = node.getAttribute(ATTACH_GLOBAL_ID_HTML_ATTR);
  } else {
    return null;
  }
  var initParams = {
    attachmentGlobalId: attachmentGlobalId
  };
  var res = {
    type: 'file',
    initParams: initParams
  };
  return [res];
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/pasteManager/deserializers/hLine.js


var hLine_TAGS = {
  'HR': true
};
function deserializeHLine(node, body) {
  var tagName = node.tagName;
  if (!hLine_TAGS.hasOwnProperty(tagName)) {
    return null;
  }
  var color = LINE_COLOR;
  var styles = bubbleStyles(node);
  if (styles['background-color'] !== color || styles['background-color'] !== 'rgb(199, 199, 199)') {
    color = styles['background-color'];
  }
  return [{
    type: 'hLine',
    initParams: {
      color: color
    }
  }];
}
// EXTERNAL MODULE: ./node_modules/escape-html/index.js
var escape_html = __webpack_require__(34111);
var escape_html_default = /*#__PURE__*/__webpack_require__.n(escape_html);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/pasteManager/deserializers/syntax.js












function deserializers_syntax_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = deserializers_syntax_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function deserializers_syntax_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return deserializers_syntax_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return deserializers_syntax_arrayLikeToArray(o, minLen); }
function deserializers_syntax_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }






var syntax_TAGS = {
  'PRE': true,
  'TABLE': {
    acceptClass: 'highlight'
  }
};
var TAGS_TO_NEWLINE = 'div,p';
var syntax_UNWRAP_TAGS = 'code';
function syntax_preparePre(node) {
  var _iterator = deserializers_syntax_createForOfIteratorHelper(node.querySelectorAll(syntax_UNWRAP_TAGS)),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var n = _step.value;
      (0,dom/* unwrapNode */.XL)(n);
    }
    // убираем исходное форматирование
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var nodesToNewLine = node.querySelectorAll(TAGS_TO_NEWLINE);
  var _iterator2 = deserializers_syntax_createForOfIteratorHelper(nodesToNewLine),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var nodeToNewLine = _step2.value;
      nodeToNewLine.parentNode.insertBefore(document.createElement('br'), nodeToNewLine.nextSibling);
      (0,dom/* unwrapNode */.XL)(nodeToNewLine);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  node.innerHTML = node.innerHTML.replace(/<br[^>]*>/ig, '\n').replace(/<\/tr>/ig, '\n').replace(/\n$/, '');
  var preNode = document.createElement('PRE');
  var copyAttrs = [LANGUAGE_HTML_ATTR, THEME_HTML_ATTR];
  for (var _i = 0, _copyAttrs = copyAttrs; _i < _copyAttrs.length; _i++) {
    var attr = _copyAttrs[_i];
    if (node.getAttribute(attr)) {
      preNode.setAttribute(attr, node.getAttribute(attr));
    }
  }
  preNode.innerHTML = escape_html_default()(node.textContent).replace(/(\n)+/g, '<BR>');
  return preNode;
}

// если дельта содержит только linebreak, то он должен быть удален
// модифицирует дельту
function syntax_deleteOnlyBreak(delta) {
  if (delta.ops.length === 2 && delta.ops[0].insert.linebreak && delta.ops[1].insert === '\n') {
    delta.ops.shift();
  }
  return delta;
}
function deserializeSyntax(node, body) {
  var tagName = node.tagName;
  if (!syntax_TAGS.hasOwnProperty(tagName)) {
    return null;
  }
  if (tagName == "TABLE" && !node.classList.contains(syntax_TAGS.TABLE.acceptClass)) {
    return null;
  }
  node = syntax_preparePre(node);
  var items = deserializeText(node, body, {});
  var delta = {
    ops: []
  };
  if (items.length) {
    var item = items[0];
    delta = syntax_deleteOnlyBreak(item.initParams.delta);
  }
  var language = node.getAttribute(LANGUAGE_HTML_ATTR);
  var theme = node.getAttribute(THEME_HTML_ATTR);
  return [{
    type: Syntax.blotName,
    initParams: {
      delta: delta,
      'data-language': language,
      'data-theme': theme
    }
  }];
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/pasteManager/deserializers/remoteFrame.js
function remoteFrame_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = deserializers_remoteFrame_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function deserializers_remoteFrame_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return deserializers_remoteFrame_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return deserializers_remoteFrame_arrayLikeToArray(o, minLen); }
function deserializers_remoteFrame_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }














var remoteFrame_TAGS = {
  'IFRAME': true
};
var allowedFrames = ['youtube', 'googleCalendar'];
function parseAllowedFrame(string) {
  var framePattern = /^<iframe.*?><\/iframe>/;
  var isAllowedFrame = false;
  if (string.match(framePattern)) {
    var src = deserializeEmbedString(string);
    var _iterator = remoteFrame_createForOfIteratorHelper(allowedFrames),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        if (remoteFrameOptions_frames[key] && remoteFrameOptions_frames[key].pattern && remoteFrameOptions_frames[key].pattern.test(src)) {
          isAllowedFrame = true;
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  if (isAllowedFrame) {
    return string;
  } else {
    return false;
  }
}
function deserializeFrame(node, body) {
  var tagName = node.tagName;
  if (!remoteFrame_TAGS.hasOwnProperty(tagName)) {
    return null;
  }
  if (!node.getAttribute('src')) {
    return null;
  }
  var src = node.getAttribute('src');
  var allowed = false;
  var _iterator2 = remoteFrame_createForOfIteratorHelper(allowedFrames),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var key = _step2.value;
      if (remoteFrameOptions_frames[key] && remoteFrameOptions_frames[key].pattern && remoteFrameOptions_frames[key].pattern.test(src)) {
        allowed = true;
        break;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  if (!allowed) {
    return null;
  }
  var initParams = {
    src: src
  };
  var res = {
    type: 'remote-frame',
    initParams: initParams
  };
  return [res];
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/pasteManager/googleDocsPlugin/index.js
function googleDocsPlugin_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = googleDocsPlugin_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function googleDocsPlugin_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return googleDocsPlugin_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return googleDocsPlugin_arrayLikeToArray(o, minLen); }
function googleDocsPlugin_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }














var docsId = /id="docs\-internal\-guid/;
var GOOGLE_TAB_TAG_NAME = 'SPAN';
var GOOGLE_TAB_CLASS = 'Apple-tab-span';
var GOOGLE_TAB_CONTENT = "\xA0\xA0\xA0 ";
var BLOCKS = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'P'];
var DEFAULT_GD_TEXT_COLORS = ['434343', '67, 67, 67'];
function processNode(node, doc) {
  var indent = 0;
  var onStartIndent = true;
  //в гугл доке один таб является span'ом заключенным в span и имеющим класс Apple-tab-span,
  //в случае с firefox, таб является span'ом с текстом: 3 неразрывных пробела и 1 простой пробел
  var children = Array.from(node.childNodes);
  for (var _i = 0, _children = children; _i < _children.length; _i++) {
    var child = _children[_i];
    if (child.childNodes.length && (child.firstChild.tagName === GOOGLE_TAB_TAG_NAME && child.firstChild.classList.contains(GOOGLE_TAB_CLASS) || child.innerText === GOOGLE_TAB_CONTENT)) {
      if (onStartIndent) {
        indent += 1;
        node.removeChild(child);
      } else {
        var tabNode = doc.createTextNode('\t');
        child.replaceWith(tabNode);
      }
    } else if (onStartIndent) {
      onStartIndent = false;
    }
  }
  node.classList.add('indent-' + indent);
}
function detectTabsInDocument(node, doc) {
  var children = Array.from(node.childNodes);
  for (var _i2 = 0, _children2 = children; _i2 < _children2.length; _i2++) {
    var child = _children2[_i2];
    if (!child.tagName) continue;
    if (BLOCKS.indexOf(child.tagName) >= 0) {
      processNode(child, doc);
    } else {
      detectTabsInDocument(child, doc);
    }
  }
}
function removeDefaultTextColors(node, doc) {
  if (!node.childNodes) return;
  var children = Array.from(node.childNodes);
  for (var _i3 = 0, _children3 = children; _i3 < _children3.length; _i3++) {
    var child = _children3[_i3];
    if (child.style && child.style['color']) {
      var _iterator = googleDocsPlugin_createForOfIteratorHelper(DEFAULT_GD_TEXT_COLORS),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var color = _step.value;
          if (child.style['color'].includes(color)) {
            child.style.removeProperty('color');
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    removeDefaultTextColors(child, doc);
  }
}
function prepareTitleHeaders(node, doc) {
  if (!node.childNodes) return;
  var children = Array.from(node.childNodes);
  for (var _i4 = 0, _children4 = children; _i4 < _children4.length; _i4++) {
    var child = _children4[_i4];
    if (node.tagName === 'SPAN' && node.style) {
      if (node.style['font-size'] === '26pt') {
        var parent = node.parentNode;
        if (parent && parent.tagName === 'P' && parent.style) {
          if (parent.style['margin-bottom'] === '3pt') {
            var header = doc.createElement('h1');
            header.appendChild(node);
            parent.parentNode.insertBefore(header, parent);
            parent.parentNode.removeChild(parent);
          }
        }
      }
    }
    prepareTitleHeaders(child, doc);
  }
}
function isGoogleDocsContent(html) {
  return Boolean(html.match(docsId));
}
function prepareGoogleDocument(doc) {
  if (!isGoogleDocsContent(doc.body.innerHTML)) return;
  detectTabsInDocument(doc.body, doc);
  removeDefaultTextColors(doc.body, doc);
  prepareTitleHeaders(doc.body, doc);
}
/* harmony default export */ const googleDocsPlugin = ({
  prepareDocument: prepareGoogleDocument
});
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/pasteManager/msOfficePlugin/index.js
function msOfficePlugin_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = msOfficePlugin_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function msOfficePlugin_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return msOfficePlugin_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return msOfficePlugin_arrayLikeToArray(o, minLen); }
function msOfficePlugin_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }











var msoListItemClass = 'MsoListParagraph';
var msoIgnoreListStyleAttr = 'mso-list:Ignore';
function getMsoListItem(doc, node) {
  var children = Array.from(node.childNodes);
  var listItemNode = doc.createElement('li');
  for (var _i = 0, _children = children; _i < _children.length; _i++) {
    var child = _children[_i];
    listItemNode.appendChild(child);
  }
  return listItemNode;
}
function isMsoListParagraph(node) {
  var classes = Array.from(node.classList);
  var result = false;
  for (var _i2 = 0, _classes = classes; _i2 < _classes.length; _i2++) {
    var item = _classes[_i2];
    if (item.indexOf(msoListItemClass) !== -1) {
      result = true;
      break;
    }
  }
  return result;
}
function isMsoDocument(doc) {
  // сюда добавлять условия для определения является ли содержимое body документом mso
  return /MsoListParagraph/gm.test(doc.body.innerHTML);
}
function prepareMsOfficeDocumentNode(doc, node) {
  // удаляем все текстовые '\n' в body чтобы корректно обработать списки
  if (node.parentNode === doc.body && node.nodeType === 3 && node.textContent.trim() === '') {
    node.parentNode.removeChild(node);
  }
  if (node.nodeType !== 3 && isMsoListParagraph(node)) {
    // пробуем получить тип списка из нод с Ignore стилем mso и сразу удаляем их
    var tag = 'UL';
    var ignoreItems = Array.from(node.querySelectorAll('[style="' + msoIgnoreListStyleAttr + '"]'));
    if (ignoreItems && ignoreItems.length) {
      var _iterator = msOfficePlugin_createForOfIteratorHelper(ignoreItems),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (/\d+[.)]/.test(node.textContent)) {
            tag = 'OL';
          }
          item.parentNode.removeChild(item);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    // тут фикс для нумерованных списков, внутри которых находится не текст, например изображение
    if (!node.textContent) {
      if (node.previousSibling.tagName === 'OL') {
        tag = 'OL';
      }
    }
    var listItemNode = getMsoListItem(doc, node);
    // проверяем есть ли перед элементом списка mso, html список с нужным тегом, если есть то аппендим новый элемент в него, если нет, создаем новый список
    if (node.previousSibling && node.previousSibling.tagName === tag) {
      node.previousSibling.appendChild(listItemNode);
    } else {
      var listNode = doc.createElement(tag);
      listNode.appendChild(listItemNode);
      node.parentNode.insertBefore(listNode, node);
    }
    // удаляем старый элемент
    node.parentNode.removeChild(node);
  } else {
    var children = Array.from(node.childNodes);
    for (var _i3 = 0, _children2 = children; _i3 < _children2.length; _i3++) {
      var child = _children2[_i3];
      prepareMsOfficeDocumentNode(doc, child);
    }
  }
}
function prepareMsOfficeDocument(doc) {
  if (!isMsoDocument(doc)) return;
  prepareMsOfficeDocumentNode(doc, doc.body);
}
function isMsoHtml(html) {
  return /schemas-microsoft-com:office/gm.test(html);
}
/* harmony default export */ const msOfficePlugin = ({
  prepareDocument: prepareMsOfficeDocument
});
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/pasteManager/youtubePlugin/index.js












function youtubePlugin_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = youtubePlugin_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function youtubePlugin_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return youtubePlugin_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return youtubePlugin_arrayLikeToArray(o, minLen); }
function youtubePlugin_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function prepareYoutubeTextNodes(doc) {
  var node = doc.body;
  var ytNodes = node.querySelectorAll('.yt-formatted-string');
  var _iterator = youtubePlugin_createForOfIteratorHelper(ytNodes),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var ytNode = _step.value;
      var wrapper = document.createElement('div');
      if (ytNode.hasAttribute('style')) {
        wrapper.setAttribute('style', ytNode.getAttribute('style'));
        ytNode.removeAttribute('style');
        ytNode.innerHTML = ytNode.innerHTML.replace(/(?:\r\n|\r|\n)/g, '<br>');
      }
      (0,dom/* wrapNode */.PB)(ytNode, wrapper);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
/* harmony default export */ const youtubePlugin = ({
  prepareDocument: prepareYoutubeTextNodes
});
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/pasteManager/gmailPlugin/index.js
function gmailPlugin_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = gmailPlugin_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function gmailPlugin_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return gmailPlugin_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return gmailPlugin_arrayLikeToArray(o, minLen); }
function gmailPlugin_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }










function mergeSiblingBlockquotes(doc, node) {
  var children = Array.from(node.childNodes);
  for (var _i = 0, _children = children; _i < _children.length; _i++) {
    var child = _children[_i];
    if (child.tagName && child.tagName === 'BLOCKQUOTE') {
      if (child.previousSibling && child.previousSibling.tagName === 'BLOCKQUOTE') {
        var breakNode = doc.createElement('br');
        child.previousSibling.appendChild(breakNode);
        var childChildren = Array.from(child.childNodes);
        for (var _i2 = 0, _childChildren = childChildren; _i2 < _childChildren.length; _i2++) {
          var childNode = _childChildren[_i2];
          child.previousSibling.appendChild(childNode);
        }
        child.parentNode.removeChild(child);
      }
    }
    if (child) {
      var childNodes = Array.from(child.childNodes);
      if (childNodes.length) {
        var _iterator = gmailPlugin_createForOfIteratorHelper(childNodes),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _childNode = _step.value;
            mergeSiblingBlockquotes(doc, _childNode);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }
}
function prepareGmailDocument(doc) {
  if (!hasBlockquotes(doc)) return;
  mergeSiblingBlockquotes(doc, doc.body);
}
function hasBlockquotes(doc) {
  if (doc.body.querySelectorAll('blockquote.gmail_quote').length) return true;
  return false;
}
/* harmony default export */ const gmailPlugin = ({
  prepareDocument: prepareGmailDocument
});
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/pasteManager/slackPlugin/index.js
function slackPlugin_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = slackPlugin_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function slackPlugin_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return slackPlugin_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return slackPlugin_arrayLikeToArray(o, minLen); }
function slackPlugin_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }














function isSlackDocument(doc) {
  return Array.from(doc.body.querySelectorAll('*')).some(function (node) {
    return node.style && node.style.getPropertyValue('font-family').includes('Slack');
  });
}
function isSlackExtendedDoc(doc) {
  return Boolean(doc.body.querySelector('div.c-message_kit__blocks') || doc.body.querySelector('.c-message__sender') || doc.body.querySelector('span.c-mrkdwn__br'));
}
function removeBackground(node) {
  if (node.style) {
    node.style.removeProperty('background-color');
  }
  if (node.childNodes && node.childNodes.length) {
    var _iterator = slackPlugin_createForOfIteratorHelper(node.childNodes),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var child = _step.value;
        removeBackground(child);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
}
function prepareSlackSimpleDocumentNode(node, doc) {
  // удаляем пустые узлы с пробелом или пробельным символом, пробелы добавим ниже
  if (node.textContent && node.textContent.replace(/\s|&nbsp;/, '') === '') {
    node.parentNode.removeChild(node);
    return;
  }
  // удаляем ноды комментариев
  if (node instanceof Comment) {
    node.parentNode.removeChild(node);
    return;
  }
  // оборачиваем отдельные строки слака в div для нашего десериалайзера
  if (!node.previousSibling || node.tagName === 'SPAN' && node.previousSibling.classList.contains('slack-paragraph-wrapper') && node.previousSibling.lastChild.tagName === 'SPAN') {
    var wrapper = doc.createElement('div');
    wrapper.classList.add('slack-paragraph-wrapper');
    node.parentNode.insertBefore(wrapper, node);
    wrapper.appendChild(node);
  } else {
    // добавляем пробел после последнего тега, чтобы слова не слипались
    if (node.previousSibling.lastChild.tagName !== 'BR') {
      var space = doc.createTextNode(' ');
      node.previousSibling.appendChild(space);
    }
    node.previousSibling.appendChild(node);
  }
  removeBackground(node);
}
function prepareSlackExtendedDocumentNode(node, doc) {
  if (node.classList && node.classList.contains('c-mrkdwn__br')) return;
  var needWrap = false;
  if (!node.previousSibling) {
    needWrap = true;
  } else if (node.previousSibling.classList && node.previousSibling.classList.contains('c-mrkdwn__br')) {
    needWrap = true;
    node.parentNode.removeChild(node.previousSibling);
  }
  if (needWrap) {
    var wrapper = doc.createElement('div');
    node.parentNode.insertBefore(wrapper, node);
    wrapper.appendChild(node);
  } else {
    node.previousSibling.appendChild(node);
  }
}
function prepareSlackDocument(doc) {
  if (!isSlackDocument(doc)) return;
  if (isSlackExtendedDoc(doc)) {
    var toPrepareNode = doc.body.querySelector('.c-message__message_blocks .p-rich_text_section');
    if (toPrepareNode) {
      var children = Array.from(toPrepareNode.childNodes);
      for (var _i = 0, _children = children; _i < _children.length; _i++) {
        var node = _children[_i];
        prepareSlackExtendedDocumentNode(node, doc);
      }
    }
  } else {
    var _children2 = Array.from(doc.body.childNodes);
    for (var _i2 = 0, _children3 = _children2; _i2 < _children3.length; _i2++) {
      var _node = _children3[_i2];
      prepareSlackSimpleDocumentNode(_node, doc);
    }
  }
}
/* harmony default export */ const slackPlugin = ({
  prepareDocument: prepareSlackDocument
});
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/pasteManager/nimbusOpsPlugin/index.js
function nimbusOpsPlugin_toConsumableArray(arr) { return nimbusOpsPlugin_arrayWithoutHoles(arr) || nimbusOpsPlugin_iterableToArray(arr) || nimbusOpsPlugin_unsupportedIterableToArray(arr) || nimbusOpsPlugin_nonIterableSpread(); }
function nimbusOpsPlugin_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function nimbusOpsPlugin_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function nimbusOpsPlugin_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return nimbusOpsPlugin_arrayLikeToArray(arr); }











function nimbusOpsPlugin_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = nimbusOpsPlugin_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function nimbusOpsPlugin_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return nimbusOpsPlugin_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return nimbusOpsPlugin_arrayLikeToArray(o, minLen); }
function nimbusOpsPlugin_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



var ATTACHMENT_TYPES = ['file', 'image', 'bookmark'];
function prepareTableAttachmentOps(op, params) {
  if (!op.initParams || !op.initParams.content) return;
  if (!params.editorRoom || !op.initParams.room || op.initParams.room !== params.editorRoom) {
    var rows = op.initParams.content.rows;
    if (!Array.isArray(rows) || !rows.length) return;
    var _iterator = nimbusOpsPlugin_createForOfIteratorHelper(rows),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var row = _step.value;
        var children = row.children;
        if (!children || !children.length) continue;
        var _iterator2 = nimbusOpsPlugin_createForOfIteratorHelper(children),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var cell = _step2.value;
            if (cell.cellType === 'attachment') {
              delete cell.attachmentGlobalIds;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
}
// Функция подготавливает операции вставки аттачей,
// если в операции есть информация об инстансе редаткора, откуда происходит вставка
// и инстансы не совпадают, а операция имеет attachmentGlobalId, нужно удалить эту инфу,
// чтобы редактор загрузил аттачи на сервер по новой.
// Если инстасы совпадают, мы удаляем информацию об инстансе редактора из операции,
// чтобы не создавать лишних записей в map'e аттача, и не загружать аттач по новой.
function prepareAttachmentOps(ops) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _iterator3 = nimbusOpsPlugin_createForOfIteratorHelper(ops),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var op = _step3.value;
      if (ATTACHMENT_TYPES.includes(op.type)) {
        if ((!params.editorRoom || !op.initParams.room || op.initParams.room !== params.editorRoom) && op.initParams.attachmentGlobalId && !_isPseudoAttachment(op.initParams.attachmentGlobalId)) {
          delete op.initParams.attachmentGlobalId;
        } else if (op.initParams.attachmentGlobalId && op.initParams.room) {
          delete op.initParams.room;
        }
      }
      if (op.items && Array.isArray(op.items)) {
        prepareAttachmentOps(op.items, params);
      } else if (op.initParams && op.initParams.items) {
        prepareAttachmentOps(op.initParams.items, params);
      } else if (op.type === 'table') {
        prepareTableAttachmentOps(op, params);
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
}

/**
 * Проверяет дельту и если есть кнопка изменяет её id
 * @param ops
 * @param params
 */
function prepareButtonOps(ops) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _iterator4 = nimbusOpsPlugin_createForOfIteratorHelper(ops),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var op = _step4.value;
      var initParams = op.initParams;
      var _ref = initParams || {},
        delta = _ref.delta;
      if (delta && delta.ops) {
        var _iterator5 = nimbusOpsPlugin_createForOfIteratorHelper(delta.ops),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var o = _step5.value;
            if (o.insert && o.insert.button) {
              var json = JSON.parse(o.insert.button);
              json.id = generateButtonId();
              o.insert.button = JSON.stringify(json);
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
}
function removeGridOps(ops) {
  var result = [];
  while (ops.length) {
    var op = ops.shift();
    if (op.type === 'grid') {
      var _iterator6 = nimbusOpsPlugin_createForOfIteratorHelper(op.items),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var gridColOp = _step6.value;
          result.push.apply(result, nimbusOpsPlugin_toConsumableArray(gridColOp.items));
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    } else {
      result.push(op);
    }
  }
  return result;
}

// функция разворачивает операции вставки колонок, если в операции меньше двух колонок
function prepareGridOps(ops) {
  var result = [];
  while (ops.length) {
    var op = ops.shift();
    if (op.type === 'grid' && op.items.length < 2) {
      var _iterator7 = nimbusOpsPlugin_createForOfIteratorHelper(op.items),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var gridColOp = _step7.value;
          result.push.apply(result, nimbusOpsPlugin_toConsumableArray(gridColOp.items));
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    } else {
      result.push(op);
    }
  }
  return result;
}
function prepareNimbusOps(ops) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  ops = prepareGridOps(ops);
  var focusedBlot = params.focusedBlot,
    scrollBlot = params.scrollBlot;
  var containerRes = focusedBlot ? focusedBlot.container : scrollBlot;
  if (containerRes instanceof list_list) {
    containerRes = containerRes.container;
  }
  if (containerRes !== scrollBlot) {
    ops = removeGridOps(ops);
  }
  prepareAttachmentOps(ops, params);
  prepareButtonOps(ops, params);
  return ops;
}
function processBlotsInContainer(editor, container) {
  var items = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if (!items || !items.length) return;
  for (var i = 0; i < items.length; i++) {
    var id = container.containerChildren.get(i);
    var blot = editor.findById(id);
    var op = items[i];
    if (op.onBlot) {
      op.onBlot(blot);
    }
    if (blot.isContainer && op.items && op.items.length) {
      processBlotsInContainer(editor, blot, op.items);
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/pasteManager/index.js
function pasteManager_slicedToArray(arr, i) { return pasteManager_arrayWithHoles(arr) || pasteManager_iterableToArrayLimit(arr, i) || pasteManager_unsupportedIterableToArray(arr, i) || pasteManager_nonIterableRest(); }
function pasteManager_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function pasteManager_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function pasteManager_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function pasteManager_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function pasteManager_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { pasteManager_ownKeys(Object(source), true).forEach(function (key) { pasteManager_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { pasteManager_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function pasteManager_toConsumableArray(arr) { return pasteManager_arrayWithoutHoles(arr) || pasteManager_iterableToArray(arr) || pasteManager_unsupportedIterableToArray(arr) || pasteManager_nonIterableSpread(); }
function pasteManager_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function pasteManager_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function pasteManager_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return pasteManager_arrayLikeToArray(arr); }
function pasteManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function pasteManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function pasteManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) pasteManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) pasteManager_defineProperties(Constructor, staticProps); return Constructor; }





























function pasteManager_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = pasteManager_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function pasteManager_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return pasteManager_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return pasteManager_arrayLikeToArray(o, minLen); }
function pasteManager_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function pasteManager_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



































var pasteManager_UNWRAP_TAGS = {
  'ARTICLE': true,
  'HEADER': true,
  'FIGURE': true,
  'SECTION': true,
  'FONT': true,
  'MAIN': true
};
var LIST_TAGS = {
  UL: true,
  LI: true
};
// некоторые сайты и приложения используют кастомные теги, их нужно добавить сюда
var REPLACE_CUSTOM_TAGS = {
  'EN-TABLE': true
};
// кастомные теги редактора
var EDITOR_CUSTOM_TAGS = pasteManager_defineProperty({}, TAG_NAME, true);
var REMOVE_CHILD_TAGS = [{
  parent: 'A',
  tag: 'WBR'
}, {
  parent: 'DIV',
  className: 'table-toolbar'
}];
var SPAN_ALLOWED_ATTRIBUTES = ['style', 'class'];
var deserializers = {
  text: deserializeTextLine,
  list: deserializeList,
  image: deserializeImage,
  file: file_deserializeImage,
  syntax: deserializeSyntax,
  table: deserializeTable,
  hLine: deserializeHLine,
  frame: deserializeFrame
};
var prepareDocumentPlugins = {
  googleDocs: googleDocsPlugin,
  gmail: gmailPlugin,
  mso: msOfficePlugin,
  youtube: youtubePlugin,
  slack: slackPlugin
};
function wrap(doc, nodes) {
  var containerTag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'div';
  var body = doc.body;
  var hasNonEmptyTextNodes = false;
  var _iterator = pasteManager_createForOfIteratorHelper(nodes),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var node = _step.value;
      if (node.nodeType !== Node.TEXT_NODE || node.textContent.trim()) {
        hasNonEmptyTextNodes = true;
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (!hasNonEmptyTextNodes) {
    // не оборачиваем, т.к. все элементы содержат пустой текст, либо пробелы
    return;
  }
  // оборачиваем в container
  var container = doc.createElement(containerTag);
  nodes[0].parentNode.insertBefore(container, nodes[0]);
  var _iterator2 = pasteManager_createForOfIteratorHelper(nodes),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _node = _step2.value;
      container.appendChild(_node);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}
var pasteManager_ATTACHMENT_TYPES = (/* unused pure expression or super */ null && (['file', 'image']));
var PasteManager = /*#__PURE__*/function () {
  function PasteManager(_ref) {
    var _this = this;
    var scroll = _ref.scroll,
      editor = _ref.editor,
      options = _ref.options;
    pasteManager_classCallCheck(this, PasteManager);
    pasteManager_defineProperty(this, "onPaste", function (event) {
      var _this$editor, _this$editor$options;
      if (!_this.editor.hasFocus()) return;
      var limitManager = _this.editor.plugins.limitManager;
      if (event.target && event.target.matches && event.target.matches('textarea, input')) {
        // не обрабатываем вставку в поля формы
        return;
      }
      if ((0,util/* isNodeSelfControlled */.SP)(event.target)) {
        // не обрабатываем само-контроллирующие элементы
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      if (_this.editor.mode === 'lite') {
        _this.paste({
          text: event.clipboardData.getData('text/plain')
        });
        return;
      }
      if (limitManager && !limitManager.canAddBlot({
        type: 'any',
        amount: 1,
        freeze: true,
        alert: true,
        checkForce: true
      })) {
        return false;
      }
      var nimbusOps = event.clipboardData.getData('nimbus/ops');
      if (nimbusOps) {
        nimbusOps = JSON.parse(nimbusOps);
      }
      _this.paste({
        files: event.clipboardData.files,
        html: event.clipboardData.getData('text/html'),
        text: event.clipboardData.getData('text/plain'),
        nimbusOps: nimbusOps,
        event: event,
        delaySetSelection: _this.options.delaySetSelection,
        dontParseMarkdowns: !Boolean((_this$editor = _this.editor) === null || _this$editor === void 0 ? void 0 : (_this$editor$options = _this$editor.options) === null || _this$editor$options === void 0 ? void 0 : _this$editor$options.markdown)
      });
      limitManager && limitManager.unfreeze();
    });
    this.editor = editor;
    this.scroll = scroll;
    this.options = options || {};
    document.addEventListener('paste', this.onPaste);
  }
  pasteManager_createClass(PasteManager, [{
    key: "destroy",
    value: function destroy() {
      document.removeEventListener('paste', this.onPaste, false);
    }
  }, {
    key: "prepareDocumentNodeUnwrapAndRemove",
    value: function prepareDocumentNodeUnwrapAndRemove(doc, node) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var tagName = node.tagName;
      var _iterator3 = pasteManager_createForOfIteratorHelper(REMOVE_CHILD_TAGS),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var rule = _step3.value;
          if (node.parentNode && node.parentNode.tagName === rule.parent) {
            if (rule.tag && tagName === rule.tag) {
              node.parentNode.removeChild(node);
              break;
            }
            if (rule.className && node.classList && node.classList.contains(rule.className)) {
              node.parentNode.removeChild(node);
              break;
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      if (!node.childNodes) {
        return;
      }
      if (node instanceof Comment) {
        node.parentNode.removeChild(node);
        return;
      }
      var children = Array.from(node.childNodes);
      var childNodes = Array.from(node.childNodes); // массив дочерних нод до модификации, для их дальнейшей обработки
      // разворачиваем определенные теги или неопознанные теги на 0-ой глубине
      if (pasteManager_UNWRAP_TAGS[tagName] || (0,dom/* nodeIsWebComponent */.Jl)(node) && !REPLACE_CUSTOM_TAGS[tagName] && !EDITOR_CUSTOM_TAGS[tagName] || depth === 1 && node instanceof HTMLUnknownElement) {
        var _iterator4 = pasteManager_createForOfIteratorHelper(children),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var child = _step4.value;
            node.parentNode.insertBefore(child, node);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        node.parentNode.removeChild(node);
      }
      // заменяем кастомные теги на обычный DIV
      if (REPLACE_CUSTOM_TAGS[tagName]) {
        var replaceNode = doc.createElement('div');
        var _iterator5 = pasteManager_createForOfIteratorHelper(children),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _child = _step5.value;
            replaceNode.appendChild(_child);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        node.parentNode.insertBefore(replaceNode, node);
        node.parentNode.removeChild(node);
      }

      // удаляем пустые текста между <br>
      for (var i = 0; i < children.length - 1; i++) {
        var _child2 = children[i];
        if (_child2.tagName === 'BR') {
          if (children[i + 1].nodeType === Node.TEXT_NODE && !children[i + 1].textContent.trim()) {
            var childToRemove = children[i + 1];
            if (childToRemove.parentNode) {
              childToRemove.parentNode.removeChild(childToRemove);
            }
            i++;
          }
        }
      }
      for (var _i = 0, _childNodes = childNodes; _i < _childNodes.length; _i++) {
        var _child3 = _childNodes[_i];
        this.prepareDocumentNodeUnwrapAndRemove(doc, _child3, depth + 1);
      }
    }
  }, {
    key: "prepareDocumentNodeWrapInline",
    value: function prepareDocumentNodeWrapInline(doc, node) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var getVisibleSibling = function getVisibleSibling(node) {
        var prev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var sibling = prev ? node.previousSibling : node.nextSibling;
        if (!sibling) {
          return null;
        }
        if (sibling.nodeType === Node.TEXT_NODE) {
          if (!sibling.textContent.trim()) {
            return getVisibleSibling(sibling, prev);
          }
        }
        return sibling;
      };
      var children = Array.from(node.childNodes);
      var hasBlock = children.find(function (child) {
        return child.tagName && blockElements[child.tagName];
      });
      if (hasBlock || depth === 0) {
        var inlineElemsArr = [];
        var wrapInlineElements = function wrapInlineElements() {
          if (inlineElemsArr.length) {
            wrap(doc, inlineElemsArr, 'div');
            inlineElemsArr = [];
          }
        };
        for (var i = 0; i < children.length; i++) {
          var child = children[i];
          var prev = void 0;
          var next = void 0;
          if (wrapInContainerElements[child.tagName]) {
            prev = getVisibleSibling(child, true);
            next = getVisibleSibling(child, false);
          }
          if (wrapInContainerElements[child.tagName] && (!prev || prev.tagName === 'BR') && (!next || next.tagName === 'BR')) {
            wrapInlineElements();
            wrap(doc, [child], 'div');
          } else if (inlineElements[child.tagName] || child.nodeType === Node.TEXT_NODE) {
            inlineElemsArr.push(child);
          } else {
            wrapInlineElements();
          }
        }
        wrapInlineElements();
      }
      for (var _i2 = 0, _children = children; _i2 < _children.length; _i2++) {
        var _child4 = _children[_i2];
        this.prepareDocumentNodeWrapInline(doc, _child4, depth + 1);
      }
    }

    //надстройка для частных случаев когда нумерованый список состоит из отдельных OL списков с атрибутом 'start'
  }, {
    key: "prepareDocumentNumberedListNodeMergeSiblings",
    value: function prepareDocumentNumberedListNodeMergeSiblings(doc, node) {
      var children = Array.from(node.childNodes);
      if (node.tagName === 'OL' && node.nextElementSibling && node.nextElementSibling.tagName === 'OL' && node.nextElementSibling.getAttribute('start')) {
        var i = node.getAttribute('start') && parseInt(node.getAttribute('start')) || 1;
        while (node.nextElementSibling && node.nextElementSibling.tagName === 'OL' && parseInt(node.nextElementSibling.getAttribute('start')) - 1 === i) {
          var siblingChildren = Array.from(node.nextElementSibling.childNodes);
          for (var _i3 = 0, _siblingChildren = siblingChildren; _i3 < _siblingChildren.length; _i3++) {
            var child = _siblingChildren[_i3];
            if (child.nodeType === 3 && child.nodeValue === '\n') continue;
            node.appendChild(child);
            i++;
          }
          node.nextElementSibling.parentNode.removeChild(node.nextElementSibling);
        }
      }
      for (var _i4 = 0, _children2 = children; _i4 < _children2.length; _i4++) {
        var _child5 = _children2[_i4];
        this.prepareDocumentNumberedListNodeMergeSiblings(doc, _child5);
      }
    }
    //обработка сторонних тегов внутри списков
  }, {
    key: "prepareDocumentNodeOtherTagsInList",
    value: function prepareDocumentNodeOtherTagsInList(doc, node) {
      // разрешаем в списке вложенные списки или LI
      if (node.tagName === 'LI' || node.nodeType === 3) return;
      var children = Array.from(node.childNodes);
      if (LIST_TAGS[node.parentNode.tagName] && !LIST_TAGS[node.tagName] && node.parentNode.parentNode) {
        var list = node.parentNode;
        var listBefore = list.cloneNode();
        var listAfter = list.cloneNode();
        var isListBeforeFilled = false;
        for (var _i5 = 0, _Array$from = Array.from(list.childNodes); _i5 < _Array$from.length; _i5++) {
          var el = _Array$from[_i5];
          if (el !== node) {
            if (!isListBeforeFilled) {
              listBefore.appendChild(el);
            } else {
              listAfter.appendChild(el);
            }
          } else {
            isListBeforeFilled = true;
          }
        }
        if (listBefore.childNodes.length) {
          list.parentNode.insertBefore(listBefore, list);
        }
        // нода может быть неопознанным элементом
        if (node instanceof HTMLUnknownElement) {
          var _wrap = doc.createElement('div');
          var _iterator6 = pasteManager_createForOfIteratorHelper(children),
            _step6;
          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var child = _step6.value;
              _wrap.appendChild(child);
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
          list.parentNode.insertBefore(_wrap, list);
        } else {
          list.parentNode.insertBefore(node, list);
        }
        if (listAfter.childNodes.length) {
          list.parentNode.insertBefore(listAfter, list);
        }
        list.remove();
      }
      for (var _i6 = 0, _children3 = children; _i6 < _children3.length; _i6++) {
        var _child6 = _children3[_i6];
        this.prepareDocumentNodeOtherTagsInList(doc, _child6);
      }
    }
  }, {
    key: "putSpansToTextNodes",
    value: function putSpansToTextNodes(doc, node) {
      var spans = node.querySelectorAll('span');
      var _iterator7 = pasteManager_createForOfIteratorHelper(spans),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var span = _step7.value;
          var textNodes = (0,dom/* getTextNodesIn */.Nj)(span);
          (0,dom/* unwrapNode */.XL)(span);
          var attrs = new Map();
          var _iterator8 = pasteManager_createForOfIteratorHelper(SPAN_ALLOWED_ATTRIBUTES),
            _step8;
          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var attr = _step8.value;
              if (span.hasAttribute(attr)) {
                attrs.set(attr, span.getAttribute(attr));
              }
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
          var length = span.attributes.length;
          for (var i = 0; i < length; i++) {
            if (span.attributes[i].name.indexOf('data') === 0) {
              attrs.set(span.attributes[i].name, span.attributes[i].value);
            }
          }
          var _iterator9 = pasteManager_createForOfIteratorHelper(textNodes),
            _step9;
          try {
            var _loop = function _loop() {
              var textNode = _step9.value;
              var newSpan = document.createElement('span');
              attrs.forEach(function (value, key) {
                newSpan.setAttribute(key, value);
              });
              (0,dom/* wrapNode */.PB)(textNode, newSpan);
            };
            for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator9.e(err);
          } finally {
            _iterator9.f();
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  }, {
    key: "prepareSyntaxNodes",
    value: function prepareSyntaxNodes(doc, node) {
      var syntaxNodes = Array.from(node.querySelectorAll('.editor-syntax'));
      if (syntaxNodes.length) {
        var _iterator10 = pasteManager_createForOfIteratorHelper(syntaxNodes),
          _step10;
        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var syntaxNode = _step10.value;
            var language = syntaxNode.getAttribute(LANGUAGE_HTML_ATTR);
            var theme = syntaxNode.getAttribute(THEME_HTML_ATTR);
            var preparedNode = document.createElement('pre');
            if (language) preparedNode.setAttribute(LANGUAGE_HTML_ATTR, language);
            if (theme) preparedNode.setAttribute(THEME_HTML_ATTR, theme);
            var lines = Array.from(syntaxNode.querySelectorAll('pre'));
            if (lines.length) {
              preparedNode.innerText = lines.map(function (line) {
                return line.innerText;
              }).join('\n');
            }
            var wrapper = document.createElement('div');
            wrapper.appendChild(preparedNode);
            syntaxNode.parentNode.replaceChild(wrapper, syntaxNode);
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      }
    }
  }, {
    key: "prepareDocumentNode",
    value: function prepareDocumentNode(doc, node) {
      this.prepareSyntaxNodes(doc, node);
      this.prepareDocumentNodeUnwrapAndRemove(doc, node);
      this.putSpansToTextNodes(doc, node);
      this.prepareDocumentNodeWrapInline(doc, node);
      this.prepareDocumentNumberedListNodeMergeSiblings(doc, node);
      this.prepareDocumentNodeOtherTagsInList(doc, node);
    }
  }, {
    key: "prepareDocument",
    value: function prepareDocument(doc) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var body = doc.body;
      // оборачиваем LI элементы на первом уровне в UL
      var listItemsArr = [];
      var children = Array.from(body.childNodes);
      for (var _i7 = 0, _children4 = children; _i7 < _children4.length; _i7++) {
        var child = _children4[_i7];
        if (params.disallowDeleteEmptyStrings) {
          if (child.innerHTML === '' && child.childNodes.length === 0) {
            child.innerHTML = '\n';
            continue;
          }
        } else {
          if (isEmptyContainer(child)) {
            child.parentNode.removeChild(child);
            continue;
          }
        }
        if (child.tagName === 'LI') {
          listItemsArr.push(child);
        } else {
          if (listItemsArr.length) {
            wrap(doc, listItemsArr, 'ul');
            listItemsArr = [];
          }
        }
      }
      if (listItemsArr.length) {
        wrap(doc, listItemsArr, 'ul');
      }
      for (var key in prepareDocumentPlugins) {
        if (prepareDocumentPlugins[key].prepareDocument) {
          prepareDocumentPlugins[key].prepareDocument(doc);
        }
      }
      this.prepareDocumentNode(doc, doc.body);
      return doc;
    }
  }, {
    key: "deserializeNode",
    value: function deserializeNode(node, doc) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var res = [];
      params.editorRoom = this.editor && this.editor.options && this.editor.options.serverRoom;
      for (var key in deserializers) {
        if (params.deserializer && params.deserializer != key) {
          continue;
        }
        var deserializer = deserializers[key];
        var deserializerRes = deserializer(node, doc.body, params);
        if (!deserializerRes) {
          continue;
        }
        var _iterator11 = pasteManager_createForOfIteratorHelper(deserializerRes),
          _step11;
        try {
          for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
            var item = _step11.value;
            if (item instanceof Element) {
              res.push.apply(res, pasteManager_toConsumableArray(this.deserializeNode(item, doc, params)));
            } else {
              res.push(item);
            }
          }
        } catch (err) {
          _iterator11.e(err);
        } finally {
          _iterator11.f();
        }
      }
      return res;
    }
  }, {
    key: "processCurrentTextLine",
    value: function processCurrentTextLine(blot, pasteBlotData) {
      if (blot && blot.textLineAddNextBlot && pasteBlotData.type === 'textLine' && (!pasteBlotData.textLineType || !(blot instanceof paragraph)) && !blot.isCollapsibleContainerTextLine) {
        var id = blot.textLineAddNextBlot(pasteBlotData.initParams, pasteBlotData.textLineType).id;
        return {
          addedBlots: [this.editor.findById(id)],
          lastTextLineBlotId: id,
          lastTextLineBlotLength: new (Delta_default())(pasteBlotData.initParams.delta).length()
        };
      }
    }
  }, {
    key: "processInsertListInListItem",
    value: function processInsertListInListItem(blot, pasteBlotData) {
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'html';
      if (blot instanceof listItem && pasteBlotData.type === 'list') {
        var items = source === 'html' ? pasteBlotData.initParams.items : pasteBlotData.items;
        var currentBlot = blot;
        // добавляем элементы списка в текущий список
        var lastBlotId,
          lastBlotLength,
          addedBlots = [];
        var _iterator12 = pasteManager_createForOfIteratorHelper(items),
          _step12;
        try {
          for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
            var item = _step12.value;
            var id = currentBlot.textLineAddNextBlot(item.params, item.type).id;
            lastBlotId = id;
            lastBlotLength = new (Delta_default())(item.params.delta).length();
            var addedBlot = this.editor.findById(id);
            currentBlot = addedBlot;
            addedBlots.push(addedBlot);
          }
        } catch (err) {
          _iterator12.e(err);
        } finally {
          _iterator12.f();
        }
        return {
          addedBlots: addedBlots,
          lastTextLineBlotId: lastBlotId,
          lastTextLineBlotLength: lastBlotLength
        };
      }
    }
  }, {
    key: "findContainerForAdd",
    value: function findContainerForAdd(BlotClass, blot) {
      if (!blot.container) {
        return null;
      }
      if (BlotClass.wrapper) {
        if (typeof BlotClass.wrapper === 'string') {
          BlotClass = src_parchment.query(BlotClass.wrapper);
        } else {
          BlotClass = BlotClass.wrapper;
        }
      }
      var container = blot.container;
      var ContainerClass = container.constructor;
      var blotClassPrototypes = (0,util/* getAllPrototypes */.yG)(BlotClass);
      if (ContainerClass.allowedChildren.indexOf(BlotClass) >= 0 || ContainerClass.allowedChildren.indexOf(BlotClass.parent) >= 0 || ContainerClass.allowedChildren.some(function (ChildClass) {
        return blotClassPrototypes.includes(ChildClass);
      })) {
        return {
          container: container,
          after: blot
        };
      }
      return this.findContainerForAdd(BlotClass, container);
    }
  }, {
    key: "processAddContainer",
    value: function processAddContainer(blot, pasteBlotData) {
      var type = pasteBlotData.type;
      var findContainerRes = this.findContainerForAdd(src_parchment.query(type), blot);
      if (!findContainerRes) {
        throw new Error('Fail process addition of a blot during paste: ' + type + ', target blot: ' + blot.id);
      }
      var container = findContainerRes.container,
        after = findContainerRes.after;
      var id = container.addBlot(type, {
        after: after.id,
        items: pasteBlotData.items
      }).id;
      var addedBlot = this.editor.findById(id);
      processBlotsInContainer(this.editor, addedBlot, pasteBlotData.items);
      var lastTextLineBlot = addedBlot;
      while (!lastTextLineBlot.isSelectable) {
        lastTextLineBlot = lastTextLineBlot.children.tail;
      }
      return {
        addedBlots: [addedBlot],
        lastTextLineBlotId: lastTextLineBlot.id,
        lastTextLineBlotLength: lastTextLineBlot.length()
      };
    }
  }, {
    key: "processAddBlot",
    value: function processAddBlot(blot, pasteBlotData) {
      var type = pasteBlotData.type;
      if (type === 'textLine') {
        // десериалайзеры возвращают textLine для совместимости со списками и другими текстовыми строками
        // но если идет вставка текстовой строки, то надо вставлять параграф или другой заданный тип текстовой строки
        type = pasteBlotData.textLineType || 'paragraph';
      }
      var findContainerRes = this.findContainerForAdd(src_parchment.query(type), blot);
      if (!findContainerRes) {
        throw new Error('Fail process addition of a blot during paste: ' + type + ', target blot: ' + blot.id);
      }
      var container = findContainerRes.container,
        after = findContainerRes.after;
      if (pasteBlotData.items && pasteBlotData.items.length) {
        return this.processAddContainer(blot, pasteBlotData);
      }
      var id = container.addBlot(type, Object.assign({
        after: after.id
      }, pasteBlotData.initParams)).id;
      var addedBlot = this.editor.findById(id);
      if (pasteBlotData.onBlot) {
        pasteBlotData.onBlot(addedBlot);
      }
      return {
        addedBlots: [addedBlot],
        lastTextLineBlotId: addedBlot.id,
        lastTextLineBlotLength: addedBlot.length()
      };
    }
  }, {
    key: "parseHTML",
    value: function parseHTML(html) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, "text/html");
      this.prepareDocument(doc, params);
      var blotsData = [];
      var _iterator13 = pasteManager_createForOfIteratorHelper(doc.body.childNodes),
        _step13;
      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var node = _step13.value;
          blotsData.push.apply(blotsData, pasteManager_toConsumableArray(this.deserializeNode(node, doc, params)));
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
      return blotsData;
    }
  }, {
    key: "getBlotNameForFile",
    value: function getBlotNameForFile(file) {
      if (SUPPORTED_TYPES.indexOf(file.type) >= 0) {
        return 'image';
      }
      return 'file';
    }
  }, {
    key: "pasteFiles",
    value: function pasteFiles(files, afterBlot) {
      var lastBlot = afterBlot || this.scroll.focusedBlot;
      var targetBlot = lastBlot;
      if (lastBlot.container && !lastBlot.container.constructor.allowedChildren.includes(FileWrapper)) {
        lastBlot = searchUp(lastBlot, function (blot) {
          return blot.container.constructor.allowedChildren.includes(FileWrapper);
        });
      }
      var container = lastBlot.container;
      var added = false;
      var textBlotCursor = null;
      var _iterator14 = pasteManager_createForOfIteratorHelper(files),
        _step14;
      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var file = _step14.value;
          var blotName = this.getBlotNameForFile(file);
          added = true;
          var _container$addBlot = container.addBlot(blotName, {
              after: lastBlot.id
            }),
            id = _container$addBlot.id;
          var blot = this.editor.findById(id);
          if (blot) {
            blot.uploadFile(this.editor.plugins.attachmentManager.nFileFromWebFile(file));
            lastBlot = blot;
          }
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
      if (added) {
        if (targetBlot && targetBlot.isEmpty && targetBlot.isEmpty()) {
          targetBlot.remove();
        }
        textBlotCursor = {
          blotId: lastBlot.id
        };
      }
      return textBlotCursor;
    }
  }, {
    key: "pasteHTML",
    value: function pasteHTML(html) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (typeof params.keepIndents === 'undefined') {
        params.keepIndents = true;
      }

      // keepIndents:true не удаляем пробелы из текста при вставке
      var blotsData = this.parseHTML(html, pasteManager_objectSpread(pasteManager_objectSpread({}, params), {}, {
        keepIndents: params.keepIndents
      }));
      //console.log('Parsed blots data: ', Array.from(blotsData))
      return this.blotsDataHandler(blotsData);
    }
  }, {
    key: "filterHtmlBlot",
    value: function filterHtmlBlot(blot) {
      var room = this.editor.options.serverRoom;
      return !(blot.type === 'html' && (!blot.initParams.room || blot.initParams.room !== room));
    }
  }, {
    key: "filterHtml",
    value: function filterHtml(ops) {
      var _this2 = this;
      ops = ops.filter(function (blot) {
        if (blot.type === 'grid') {
          blot.items = blot.items.filter(function (gridCol) {
            gridCol.items = gridCol.items.filter(function (item) {
              return _this2.filterHtmlBlot(item);
            });
            return gridCol;
          });
          return blot;
        } else {
          return _this2.filterHtmlBlot(blot);
        }
      });
      ops = this.filterEmptyGrid(ops);
      return ops;
    }
  }, {
    key: "filterEmptyGrid",
    value: function filterEmptyGrid(ops) {
      ops = ops.filter(function (blot) {
        if (blot.type === 'grid') {
          blot.items = blot.items.filter(function (gridCol) {
            if (gridCol.items.length > 0) {
              return gridCol;
            } else {
              return false;
            }
          });
          if (blot.items.length > 0) {
            return blot;
          } else {
            return false;
          }
        } else {
          return blot;
        }
      });
      return ops;
    }
  }, {
    key: "pasteNimbusOps",
    value: function pasteNimbusOps(ops) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      ops = this.filterHtml(ops);
      return this.blotsDataHandler(ops, 'nimbus');
    }
  }, {
    key: "addTextFormatsIfNeed",
    value: function addTextFormatsIfNeed(blotsData) {
      if (this.scroll.selectedBlocks.length === 1 && this.scroll.focusedBlot instanceof textLine) {
        var rangeFormats = {};
        var getFormatRange = Object.assign({}, this.scroll.selection.getRange({
          offsetBlot: this.scroll.focusedBlot
        })[0]);
        getFormatRange = {
          index: getFormatRange.index !== 0 ? getFormatRange.index - 1 : 0,
          length: 1
        };
        rangeFormats = this.scroll.focusedBlot.getFormat(getFormatRange.index, getFormatRange.length);
        if (rangeFormats.link) {
          delete rangeFormats.link;
        }
        // Если символ перед курсором/выделением, отформатирован, и вставляемый контент является неформатированной строкой,
        // в дельту вставляемой строки нужно применить форматирование
        if (Object.keys(rangeFormats).length && blotsData.length === 1 && blotsData[0].type === 'textLine') {
          if (blotsData[0].initParams.delta.ops.length === 1 && !blotsData[0].initParams.delta.ops[0].hasOwnProperty('attributes')) {
            blotsData[0].initParams.delta.ops[0].attributes = rangeFormats;
          }
        }
      }
    }
  }, {
    key: "blotsDataHandler",
    value: function blotsDataHandler(blotsData) {
      var _firstBlot$initParams, _firstBlot$initParams2, _firstBlot$initParams3;
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'html';
      if (!blotsData.length) {
        return;
      }
      // если удалось обработать данные как URL, дальше не выполняем
      if (this.tryPasteUrlIntoText(blotsData)) return;
      var currentBlot = this.scroll.focusedBlot;
      if (!currentBlot && this.editor.mode !== MODE_EDIT) {
        currentBlot = this.scroll.children.tail;
        if (!(currentBlot instanceof textLine) || !currentBlot.isEmpty()) {
          var newEmptyBlotId = this.scroll.addBlot('paragraph', {
            after: currentBlot.id
          }).id;
          currentBlot = this.editor.findById(newEmptyBlotId);
        }
      }
      if (source === 'nimbus') {
        // если вставляется набор операций nimbus, некоторые операции требуют подготовки
        blotsData = prepareNimbusOps(blotsData, {
          focusedBlot: currentBlot,
          editorRoom: this.editor.room,
          scrollBlot: this.scroll
        });
      }
      // Если в выделении только один блок, который является текстовым и вставляемый контент является не форматированной строкой,
      // нужно получить формат символа перед курсором/выделением и применить к вставляемому контенту
      this.addTextFormatsIfNeed(blotsData);
      var _this$editor$scroll$s = this.editor.scroll.selection.getRange(),
        _this$editor$scroll$s2 = pasteManager_slicedToArray(_this$editor$scroll$s, 1),
        range = _this$editor$scroll$s2[0];
      if (range && range.length > 0) {
        // если выделен какой-то контент, то надо сначало запустить delete действие в редакторе
        var deleteAction = new DeleteAction(DeleteAction.type, {}, this.editor);
        var processingBlots = this.editor.scroll.selectedBlocks;
        deleteAction.run({
          processingBlots: processingBlots
        });
      }
      var firstBlot = blotsData[0];
      var textBlotCursor = null;
      // не выполняем обработку вставки, если вставляется единственный пустой параграф
      if (blotsData.length === 1 && firstBlot.type === 'textLine' && ((_firstBlot$initParams = firstBlot.initParams) === null || _firstBlot$initParams === void 0 ? void 0 : (_firstBlot$initParams2 = _firstBlot$initParams.delta) === null || _firstBlot$initParams2 === void 0 ? void 0 : (_firstBlot$initParams3 = _firstBlot$initParams2.ops[0]) === null || _firstBlot$initParams3 === void 0 ? void 0 : _firstBlot$initParams3.insert) === '\n') {
        return null;
      }
      if (currentBlot && (currentBlot instanceof textLine || currentBlot.allowInlinePaste) && (!currentBlot.isEmpty() || !firstBlot.textLineType)) {
        var _this$scroll$selectio = this.scroll.selection.getRange({
            offsetBlot: currentBlot
          }),
          _this$scroll$selectio2 = pasteManager_slicedToArray(_this$scroll$selectio, 1),
          blotRange = _this$scroll$selectio2[0];
        if (!blotRange) {
          blotRange = {
            index: currentBlot.offset(this.scroll) + currentBlot.length() - 1,
            length: 0
          };
        }
        if (['textLine', paragraphV2.blotName].includes(firstBlot.type)) {
          blotsData.shift();
          // применяем дельту первого блота к текущему блоту
          var delta = [{
            retain: blotRange.index
          }];
          var ops = firstBlot.initParams.delta.ops.map(function (op) {
            return Object.assign({}, op);
          });
          // если текущий блок пустой, применяем цвет и отступ если они есть в firstBlot
          if (currentBlot.isEmpty()) {
            if (firstBlot.initParams.color) {
              currentBlot.map.set('color', firstBlot.initParams.color);
            }
            if (firstBlot.initParams.indent && firstBlot.initParams.indent > currentBlot.getIndent()) {
              currentBlot.map.set('indent', firstBlot.initParams.indent);
            }
          }
          if (blotRange.index === currentBlot.length() - 1) {
            // удаляем символ \n из целевого блота
            delta.push({
              delete: 1
            });
          } else {
            // удаляем символ \n из вставляемой дельты
            if (ops[ops.length - 1].insert === '\n') {
              ops.pop();
            } else {
              ops[ops.length - 1].insert = ops[ops.length - 1].insert.replace(/\n$/, '');
            }
          }
          delta.push.apply(delta, pasteManager_toConsumableArray(ops));
          currentBlot.map.get('characters').applyDelta(delta);
          blotRange.index += new (Delta_default())(firstBlot.initParams.delta).length() - 1;
          textBlotCursor = {
            blotId: currentBlot.id,
            index: blotRange.index
          };
        }
        // если курсор находится в середине/начале текстлайна и еще остались блоты на вставку, то надо разбить текстовый блот
        if (blotRange.index < currentBlot.length() - 1 && blotsData.length) {
          // блот надо разбить только если текущий блот это параграф или следующий вставляемый блот это textLine
          var allowSplit = false;
          if (currentBlot instanceof paragraph) {
            allowSplit = true;
          } else if (blotsData[0].type === 'textLine') {
            allowSplit = true;
          }
          if (allowSplit) {
            var _currentBlot$textLine, _currentBlot;
            (_currentBlot$textLine = (_currentBlot = currentBlot).textLineSplit) === null || _currentBlot$textLine === void 0 ? void 0 : _currentBlot$textLine.call(_currentBlot, blotRange.index);
          }
        }
      }
      var lastBlot = currentBlot;
      var _iterator15 = pasteManager_createForOfIteratorHelper(blotsData),
        _step15;
      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var blotData = _step15.value;
          var id = void 0;
          var processRes = this.processCurrentTextLine(lastBlot, blotData);
          if (!processRes) {
            processRes = this.processInsertListInListItem(lastBlot, blotData, source);
          }
          if (!processRes) {
            processRes = this.processAddBlot(lastBlot, blotData);
          }
          if (processRes) {
            textBlotCursor = {
              blotId: processRes.lastTextLineBlotId,
              index: processRes.lastTextLineBlotLength - 1
            };
            lastBlot = processRes.addedBlots[processRes.addedBlots.length - 1];
          }
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
      if (currentBlot.isEmpty && currentBlot.isEmpty()) {
        currentBlot.remove();
      }
      return textBlotCursor;
    }
  }, {
    key: "getHTMLFromParams",
    value: function getHTMLFromParams(params) {
      var content = params.html;
      if (!content) {
        content = parseAllowedFrame(params.text);
      }
      if (!content) {
        content = escapeHtml(params.text);
        if (content) {
          content = content.replace(urlRegex.emailStrong, function (match, text) {
            return (match.startsWith(' ') ? ' ' : '') + '<a href="mailto:' + text + '">' + text + '</a>' + (match.endsWith(' ') ? ' ' : '');
          });
          if (params.dontParseMarkdowns) {
            content = content.replace(urlRegex.url, function (text) {
              return '<a href="' + text + '">' + text + '</a>';
            });
            content = '<div>' + content.trim().replace(/\n/g, '</div><div>') + '</div>';
          } else {
            content = '<div>' + parseMarkdowns(content).trim().replace(/\n/g, '</div><div>') + '</div>';
          }
        }
      }
      return content;
    }
  }, {
    key: "tryPasteUrlIntoText",
    value: function tryPasteUrlIntoText(blotsData) {
      if (this.scroll.selectedBlocks.length === 1) {
        var isLink = pastedContentIsLink(blotsData);
        var blot = this.scroll.focusedBlot;
        if (isLink) {
          if (blot.hasTextLine) {
            blot = blot.getTextBlot();
          }
          if (!(blot instanceof textLine) && !(blot instanceof newTextLine)) {
            var id = this.editor.scroll.addBlot('paragraph').id;
            blot = this.editor.scroll.getBlotById(id);
          }
          var _this$scroll$selectio3 = this.scroll.selection.getRange({
              offsetBlot: blot
            }),
            _this$scroll$selectio4 = pasteManager_slicedToArray(_this$scroll$selectio3, 1),
            blotRange = _this$scroll$selectio4[0];
          this.pasteUrlIntoText(blot, blotRange, isLink);
          return true;
        }
      }
      return false;
    }
  }, {
    key: "pasteUrlIntoText",
    value: function pasteUrlIntoText(blot, blotRange, url) {
      if (blotRange.length > 0) {
        blot.formatText(blotRange.index, blotRange.length, 'link', url);
        this.scroll.selection.setRange({
          index: blot.offset(this.editor.scroll) + blotRange.index + blotRange.length,
          length: 0
        });
        this.editor.emitter.emit('paste');
      } else {
        var beforeFormats = blot.getFormat(blotRange.index - 1, 1);
        var afterFormats = blot.getFormat(blotRange.index, 1);
        var isLinkAfterLink = beforeFormats.link && !afterFormats.link;
        var isLinkInText = !beforeFormats.link && !afterFormats.link;
        if (isLinkAfterLink || isLinkInText) {
          var blotRangeAfter = {
            index: blotRange.index + url.length,
            length: 0
          };
          var rangeAfter = {
            index: blot.offset(this.editor.scroll) + blotRange.index + url.length,
            length: 0
          };
          var ops = [];
          if (isLinkAfterLink) {
            ops.push.apply(ops, [{
              retain: blotRange.index
            }, {
              insert: ' '
            }, {
              insert: url,
              attributes: {
                link: url
              }
            }]);
            blotRangeAfter.index += 1;
            rangeAfter.index += 1;
          } else {
            ops.push.apply(ops, [{
              retain: blotRange.index
            }, {
              insert: url,
              attributes: {
                link: url
              }
            }]);
          }
          blot.applyForCharacters(ops);
          this.scroll.selection.setRange(rangeAfter);
          if (!this.editor.blotsConfig.link || !this.editor.blotsConfig.link.disallowConvertLink) {
            this.editor.plugins.convertLinkManager.onPasteLink(blot, blotRangeAfter, url);
          }
          this.editor.emitter.emit('paste');
        }
      }
    }

    /**
     * Вставляет html/text в редактор
     * @param  {object} params
     * @param  {string} params.text
     * @param  {string} params.html
     * @param  {boolean} [params.keepIndents = true] - сохранять или нет пробелы в начале и конце текста
     */
  }, {
    key: "paste",
    value: function paste(params) {
      var _this3 = this;
      // если нет выделения или каретки в редакторе, а так же нет ни одного блока в массиве выделенных блоков редактора, не обрабатываем вставку.
      if (!this.scroll.selection.getRange()[0] && !this.scroll.selectedBlocks.length) {
        return;
      }
      var limitManager = this.editor.plugins.limitManager;
      if (limitManager && !limitManager.canAddBlot({
        type: 'any',
        amount: 1,
        freeze: true,
        alert: true,
        checkForce: true
      })) {
        return false;
      }
      // нормализуем входные строки, чтобы привести их к нормальнуму unicode виду
      // если этого не делать, то в map.characters будет хранится ненормализованная строка,
      // а в TextBase.cache.delta нормализованная(parchment неявно нормализует строки) и это
      // вызывает проблемы при редактировании описанные тут NIM-11093
      if (params.text && typeof params.text === 'string' && params.text.normalize) {
        params.text = params.text.normalize();
      }
      if (params.html && typeof params.html === 'string' && params.html.normalize) {
        params.html = params.html.normalize();
      }
      if (typeof params.keepIndents === 'undefined') {
        params.keepIndents = true;
      }
      if (this.editor.scroll.selectedBlocks.length === 1) {
        var blot = this.editor.scroll.selectedBlocks[0];
        if (blot.onPaste && blot.onPaste(params)) {
          // событие paste было обработано блотом
          this.editor.emitter.emit('paste');
          return;
        }
      }
      if (!isMsoHtml(params.html) && params.files && params.files.length) {
        var _textBlotCursor = this.pasteFiles(params.files);
        if (_textBlotCursor) {
          this.setCursorToLastElement(_textBlotCursor.blotId);
          return;
        }
      }
      var nimbusOps = params.nimbusOps || null;
      var content = this.getHTMLFromParams(params);
      if (params && params.text && params.text.match(/\|\|code/g)) {
        content = params.text;
      }
      var options = {
        raw: params.raw,
        keepIndents: params.keepIndents
      };
      var runPasteHTML = function runPasteHTML() {
        textBlotCursor = _this3.pasteHTML(content, options);
      };
      var runPasteNimbusOps = function runPasteNimbusOps() {
        textBlotCursor = _this3.pasteNimbusOps(nimbusOps, options);
      };
      var runHandler = nimbusOps ? runPasteNimbusOps : runPasteHTML;
      var textBlotCursor;
      if (params.delaySetSelection) {
        this.editor.scroll.selection.ignoreScrollUpdates(runHandler);
      } else {
        runHandler();
      }
      if (textBlotCursor) {
        var setSelectionFn = function setSelectionFn() {
          if (params.setCursorToLastElement !== false) {
            _this3.setCursorToLastElement(textBlotCursor.blotId, textBlotCursor.index || 0);
          }
          // чтобы не пыталось проскроллить на selectionchange при использовании хот кея Ctrl + V
          // очищаем таймер пользовательского взаимодействия
          _this3.editor.plugins.selectionScroller.clearLastInteractionTime();
          _this3.editor.plugins.selectionScroller.scheduleEnsureSelectionVisible({
            behavior: 'auto'
          });
        };
        if (params.delaySetSelection) {
          setTimeout(function () {
            return setSelectionFn();
          }, 0);
        } else {
          setSelectionFn();
        }
      }
      this.editor.emitter.emit('paste');
      limitManager && limitManager.unfreeze();
    }
  }, {
    key: "setCursorToLastElement",
    value: function setCursorToLastElement(blotId) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var blot = this.editor.findById(blotId);
      if (!blot) return;
      var blotOffset = blot.offset(this.scroll);
      if (!blot.isEmbeddable) {
        this.scroll.selection.setRange({
          index: blotOffset + index,
          length: 0
        });
      } else if (blot instanceof attachment_image && blot.container.children.tail !== blot.getWrapper()) {
        this.scroll.selection.setRange({
          index: blotOffset,
          length: 0
        });
      } else {
        blot.container.addBlot('paragraph', {
          after: blotId,
          focus: {
            index: 0
          }
        });
      }
    }
  }]);
  return PasteManager;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/selectionScroller/index.js










function selectionScroller_slicedToArray(arr, i) { return selectionScroller_arrayWithHoles(arr) || selectionScroller_iterableToArrayLimit(arr, i) || selectionScroller_unsupportedIterableToArray(arr, i) || selectionScroller_nonIterableRest(); }
function selectionScroller_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function selectionScroller_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return selectionScroller_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return selectionScroller_arrayLikeToArray(o, minLen); }
function selectionScroller_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function selectionScroller_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function selectionScroller_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function selectionScroller_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function selectionScroller_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function selectionScroller_createClass(Constructor, protoProps, staticProps) { if (protoProps) selectionScroller_defineProperties(Constructor.prototype, protoProps); if (staticProps) selectionScroller_defineProperties(Constructor, staticProps); return Constructor; }
function selectionScroller_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var LINES_ADDITIONAL_VISIBLE = 4;
var MAX_MOUSEDOWN_INACTIVE_INTERVAL = 300;
// максимальное время с момента пользовательского взаимодействия в течении которого можем делать скролл
var MAX_USER_INTERACTION_EFFECTIVE_TIME = 500;
// через какое время будет запускатся ensureSelectionVisible если оно запланировано через scheduleEnsureSelectionVisible
var SCHEDULE_ENSURE_SELECTION_VISIBLE_TIMEOUT = 100;
var SelectionScroller = /*#__PURE__*/function () {
  function SelectionScroller(_ref) {
    var _this = this;
    var scroll = _ref.scroll,
      editor = _ref.editor,
      options = _ref.options;
    selectionScroller_classCallCheck(this, SelectionScroller);
    selectionScroller_defineProperty(this, "onScrollMouseDown", function () {
      _this.lastMouseDownTime = new Date().getTime();
    });
    selectionScroller_defineProperty(this, "onScrollKeyDown", function () {
      _this.lastMouseDownTime = 0;
      _this.lastUserInteractionTime = new Date().getTime();
    });
    selectionScroller_defineProperty(this, "onSelectionChange", function () {
      if (_this.isIgnoreSelectionChangeNeeded()) {
        return;
      }
      _this.ensureSelectionVisible();
    });
    this.editor = editor;
    this.scroll = scroll;
    this.options = options || {};
    this.scheduleEnsureSelectionVisibleTimeout = null;
    this.bottomMargin = this.options.bottomMargin || 0;
    this.lastMouseDownTime = 0;
    this.lastUserInteractionTime = 0;
    this.isSmoothScrollingDisabled = false;
    this.ignoreSelectionChangeOnce = false;
    this.onSelectionChangeDebounced = lodash_debounce_default()(this.onSelectionChange, 10, {
      trailing: true
    });
    if (this.options.enabled !== false) {
      if (this.editor.options.render) {
        this.scroll.domNode.addEventListener('mousedown', this.onScrollMouseDown, false);
        this.scroll.domNode.addEventListener('keydown', this.onScrollKeyDown, false);
      }
      this.scroll.selection.emitter.on('selectionchange', this.onSelectionChangeDebounced);
    }
  }
  selectionScroller_createClass(SelectionScroller, [{
    key: "disableSmoothScrolling",
    value: function disableSmoothScrolling() {
      this.isSmoothScrollingDisabled = true;
    }
  }, {
    key: "clearLastInteractionTime",
    value: function clearLastInteractionTime() {
      this.lastUserInteractionTime = 0;
    }

    // этот метод вызывается из-вне блотами, которые имеют собственное выделение, или хотят контроллировать поведение скролла
  }, {
    key: "triggerSelectionChange",
    value: function triggerSelectionChange() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (force) {
        this.ensureSelectionVisible();
      } else {
        this.onSelectionChange();
      }
    }
  }, {
    key: "isNodeInEditor",
    value: function isNodeInEditor(node) {
      return node === this.scroll.domNode || this.scroll.domNode.contains(node);
    }
  }, {
    key: "isRangeInEditor",
    value: function isRangeInEditor(range) {
      return this.isNodeInEditor(range.startContainer) && this.isNodeInEditor(range.endContainer);
    }
  }, {
    key: "getCaretRect",
    value: function getCaretRect() {
      var scrollingContainer = this.getScrollingContainer();
      var selection = window.getSelection();
      if (!selection.rangeCount) {
        return;
      }
      var range = selection.getRangeAt(0);
      if (!this.isRangeInEditor(range)) {
        return;
      }
      if (!this.options.allowScrollToNonZeroSelection) {
        if (range.startContainer !== range.endContainer || range.startOffset !== range.endOffset) {
          return;
        }
      }
      var rects = range.getClientRects();
      var rect;
      var width = 0;
      if (!rects.length) {
        // браузер не всегда отдает rects, это не баг и связано со спецификацией. надо попытатся получить rect каретки,
        // для каретки стоящей в конце параграфа после <br>, это можно сделать получив rect этого <br>
        if (range.startContainer === this.editor.scroll.domNode) {
          return;
        }
        if (range.startContainer.childNodes.length === 0 && range.startContainer.getBoundingClientRect) {
          rect = range.startContainer.getBoundingClientRect();
        } else {
          var node = range.startContainer.childNodes[range.startOffset];
          if (node && node.tagName === 'BR') {
            rect = node.getBoundingClientRect();
          }
        }
      } else {
        rect = rects[0];
        width = rect.width;
      }
      if (!rect) {
        return;
      }
      var relY = rect.y - this.getScrollingContainerBoundingClientRect().y;
      return {
        x: rect.x,
        y: relY,
        width: width,
        height: rect.height
      };
    }
  }, {
    key: "scrollTo",
    value: function scrollTo(newScrollTop) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var scrollingContainer = this.getScrollingContainer();
      var scrollToOptions = {
        top: newScrollTop
      };
      var behavior = opts.behavior || this.options.behavior || this.isSmoothScrollingDisabled ? 'auto' : 'smooth';
      if (behavior) {
        scrollToOptions.behavior = behavior;
      }
      scrollingContainer.scrollTo(scrollToOptions);
      // TODO найти лучшее решение
      // фикс для фаерфокса, т.к. если двигать каретку с помощью стрелок вниз/вверх то он сам пытается скролится контейнер
      // надо подождать пока он его проскролит и затем установить свой скрол
      // это решение выглядит не очень красиво т.к. сначало происходит резкий скролл фаерфокса и затем наш плавный скролл
      if (!this.options.disableDoubleScroll) {
        setTimeout(function () {
          scrollingContainer.scrollTo(scrollToOptions);
        }, 50);
      }
    }
  }, {
    key: "getSingleFocusedBlot",
    value: function getSingleFocusedBlot() {
      if (this.scroll.selectedBlocks.length === 1) {
        return this.scroll.selectedBlocks[0];
      }
    }
  }, {
    key: "isCaretInTrap",
    value: function isCaretInTrap() {
      var _this$scroll$selectio = this.scroll.selection.getRange(),
        _this$scroll$selectio2 = selectionScroller_slicedToArray(_this$scroll$selectio, 2),
        range = _this$scroll$selectio2[1];
      if (!range) {
        return false;
      }
      var inTrap = (0,dom/* searchUp */.qn)(range.native.commonAncestorContainer, 3, function (n) {
        return n.classList && n.classList.contains(CARET_TRAP_CLASS);
      });
      return Boolean(inTrap);
    }
  }, {
    key: "ignoreNextSelectionChange",
    value: function ignoreNextSelectionChange() {
      this.ignoreSelectionChangeOnce = true;
    }
  }, {
    key: "isIgnoreSelectionChangeNeeded",
    value: function isIgnoreSelectionChangeNeeded() {
      if (this.ignoreSelectionChangeOnce) {
        this.ignoreSelectionChangeOnce = false;
        return true;
      }
      var now = new Date().getTime();
      if (this.isCaretInTrap()) {
        var timeDelta = now - this.lastMouseDownTime;
        if (timeDelta < MAX_MOUSEDOWN_INACTIVE_INTERVAL) {
          return true;
        }
      }
      var userInteractionDelta = now - this.lastUserInteractionTime;
      if (userInteractionDelta > MAX_USER_INTERACTION_EFFECTIVE_TIME) {
        return true;
      }
      return false;
    }
  }, {
    key: "getScrollingContainer",
    value: function getScrollingContainer() {
      return this.editor.getScrollingContainer();
    }
  }, {
    key: "getScrollingContainerBoundingClientRect",
    value: function getScrollingContainerBoundingClientRect() {
      var scrollingContainer = this.getScrollingContainer();
      var rect;
      if (scrollingContainer.tagName === 'BODY' || scrollingContainer.tagName === 'HTML') {
        // просто возвращаем размеры вьюпорта
        var width = window.innerWidth;
        var height = window.innerHeight;
        rect = {
          left: 0,
          right: width,
          top: 0,
          bottom: height,
          x: 0,
          y: 0,
          width: width,
          height: height
        };
      } else {
        var boundingClientRect = scrollingContainer.getBoundingClientRect();
        rect = {
          left: boundingClientRect.left,
          right: boundingClientRect.right,
          top: boundingClientRect.top,
          bottom: boundingClientRect.bottom,
          x: boundingClientRect.x,
          y: boundingClientRect.y,
          width: boundingClientRect.width,
          height: boundingClientRect.height
        };
      }
      if (this.bottomMargin) {
        // уменьшаем размер скроллинг области, чтоб имитировать отступ
        rect.bottom -= this.bottomMargin;
        rect.height -= this.bottomMargin;
      }
      return rect;
    }
  }, {
    key: "scheduleEnsureSelectionVisible",
    value: function scheduleEnsureSelectionVisible() {
      var _this2 = this;
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.scheduleEnsureSelectionVisibleTimeout = setTimeout(function () {
        _this2.scheduleEnsureSelectionVisibleTimeout = null;
        _this2.ensureSelectionVisible(opts);
      }, SCHEDULE_ENSURE_SELECTION_VISIBLE_TIMEOUT);
    }
  }, {
    key: "getCaretOcclusionDetails",
    value: function getCaretOcclusionDetails() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var scrollingContainer = this.getScrollingContainer();
      var scrollingContainerRect = this.getScrollingContainerBoundingClientRect();
      var focusedBlot = this.getSingleFocusedBlot();
      var caretRect = null;
      if (focusedBlot && focusedBlot.hasCustomSelection) {
        if (focusedBlot.getSelectionRect) {
          caretRect = focusedBlot.getSelectionRect();
          if (caretRect) {
            caretRect.y -= scrollingContainerRect.y;
          }
        }
      } else if (opts.node) {
        caretRect = opts.node.getBoundingClientRect();
      } else {
        caretRect = this.getCaretRect();
      }
      if (!caretRect) {
        return;
      }
      var scrollTop = opts.hasOwnProperty('scrollTop') ? opts.scrollTop : scrollingContainer.scrollTop;
      var maxY = scrollingContainerRect.height;
      var absY = caretRect.y + scrollTop;
      var bottom = caretRect.y + caretRect.height;
      var isOccludedTop = caretRect.y < 0;
      var isOccludedBottom = caretRect.y > maxY || bottom > maxY;
      var isOccluded = isOccludedTop || isOccludedBottom;
      return {
        caretRect: caretRect,
        maxY: maxY,
        absY: absY,
        bottom: bottom,
        scrollingContainerRect: scrollingContainerRect,
        isOccludedTop: isOccludedTop,
        isOccludedBottom: isOccludedBottom,
        isOccluded: isOccluded
      };
    }
  }, {
    key: "ensureSelectionVisible",
    value: function ensureSelectionVisible() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (this.options.enabled === false) {
        return;
      }
      if (this.scheduleEnsureSelectionVisibleTimeout) {
        clearTimeout(this.scheduleEnsureSelectionVisibleTimeout);
        this.scheduleEnsureSelectionVisibleTimeout = null;
      }
      var occlusionDetails = this.getCaretOcclusionDetails(opts);
      if (!occlusionDetails) {
        return;
      }
      var isOccludedTop = occlusionDetails.isOccludedTop,
        isOccludedBottom = occlusionDetails.isOccludedBottom,
        caretRect = occlusionDetails.caretRect,
        maxY = occlusionDetails.maxY,
        absY = occlusionDetails.absY,
        bottom = occlusionDetails.bottom,
        scrollingContainerRect = occlusionDetails.scrollingContainerRect;
      if (isOccludedBottom) {
        var visibleHeight = caretRect.height + caretRect.height * LINES_ADDITIONAL_VISIBLE;
        var newScrollTop = absY - scrollingContainerRect.height + visibleHeight;
        this.scrollTo(newScrollTop, opts);
        return newScrollTop;
      } else if (isOccludedTop) {
        var _visibleHeight = caretRect.height + caretRect.height * LINES_ADDITIONAL_VISIBLE;
        var _newScrollTop = absY - _visibleHeight;
        this.scrollTo(_newScrollTop, opts);
        return _newScrollTop;
      } else {
        return null;
      }
    }

    /*
    * Прокручивает scrollingContainer так, чтобы переданная нода была в зоне видимости
    * @param { node } node
    * @param { object } options?
    * @param { number } options.offset?: отступ зоны видимости сверху и снизу
    * @param { number } options.behavior?: тип прокрутки auto, smooth
    * @return { boolean | number } false если прокрутки небыло или новое значение скролла
    */
  }, {
    key: "ensureNodeVisible",
    value: function ensureNodeVisible(node) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!node) {
        return;
      }
      var _options$offset = options.offset,
        offset = _options$offset === void 0 ? 100 : _options$offset,
        _options$behavior = options.behavior,
        behavior = _options$behavior === void 0 ? 'auto' : _options$behavior;
      var scrollingContainer = this.getScrollingContainer();
      var _getElementPosition = (0,dom/* getElementPosition */._z)(node, scrollingContainer),
        top = _getElementPosition.top;
      var offsetHeight = scrollingContainer.offsetHeight;
      var scrollHeight = scrollingContainer.scrollHeight;
      var visibleTop = scrollingContainer.scrollTop;
      var visibleBottom = visibleTop + offsetHeight;
      var scroll = false;
      if (top - offset < visibleTop) {
        scroll = Math.max(top - offset, 0);
      } else if (top + offset > visibleBottom) {
        scroll = Math.min(top + offset - offsetHeight, scrollHeight - offsetHeight);
      }
      if (scroll !== false) {
        this.scrollTo(scroll, {
          behavior: behavior
        });
      }
      return scroll;
    }
  }]);
  return SelectionScroller;
}();

// EXTERNAL MODULE: ./node_modules/async/dist/async.js
var dist_async = __webpack_require__(65449);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/bookmarkManager/index.js
function bookmarkManager_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = bookmarkManager_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function bookmarkManager_toConsumableArray(arr) { return bookmarkManager_arrayWithoutHoles(arr) || bookmarkManager_iterableToArray(arr) || bookmarkManager_unsupportedIterableToArray(arr) || bookmarkManager_nonIterableSpread(); }
function bookmarkManager_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function bookmarkManager_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return bookmarkManager_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return bookmarkManager_arrayLikeToArray(o, minLen); }
function bookmarkManager_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function bookmarkManager_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return bookmarkManager_arrayLikeToArray(arr); }
function bookmarkManager_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function bookmarkManager_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { bookmarkManager_typeof = function _typeof(obj) { return typeof obj; }; } else { bookmarkManager_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return bookmarkManager_typeof(obj); }

function bookmarkManager_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function bookmarkManager_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { bookmarkManager_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { bookmarkManager_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

















function bookmarkManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function bookmarkManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function bookmarkManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) bookmarkManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) bookmarkManager_defineProperties(Constructor, staticProps); return Constructor; }
function bookmarkManager_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MIN_FAVICON_SIZE = 16;
var ALLOW_EXTENDED_IFRAMELY_REQUEST = true;
var BookmarkManager = /*#__PURE__*/function () {
  function BookmarkManager(_ref) {
    var _this = this;
    var scroll = _ref.scroll,
      editor = _ref.editor,
      options = _ref.options;
    bookmarkManager_classCallCheck(this, BookmarkManager);
    bookmarkManager_defineProperty(this, "getPreviews", function (url) {
      if (_this.isMethodImplemented('getPreviews')) {
        return _this.options.getPreviews(url);
      }
      return false;
    });
    bookmarkManager_defineProperty(this, "getBookmarkMeta", function (url) {
      var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!_this.options.iframelyHost || !url) return false;
      return new Promise(function (resolve, reject) {
        if (timeout) {
          var abortConnection = setTimeout(function () {
            reject(new Error('Connection timed out'));
          }, timeout);
        }
        fetch(_this.options.iframelyHost + (_this.options.iframelyPort ? ':' + _this.options.iframelyPort : '') + '/iframely?url=' + decodeURI(url) + (_this.allowExtendedRequest ? '&meta=true' : '')).then( /*#__PURE__*/function () {
          var _ref2 = bookmarkManager_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
            var meta;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return response.json();
                  case 2:
                    meta = _context.sent;
                    resolve(_this.prepareBookmarkMeta(meta));
                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }()).catch(function (err) {
          reject(err);
        }).finally(function () {
          if (timeout && abortConnection) {
            clearTimeout(abortConnection);
          }
        });
      });
    });
    this.editor = editor;
    this.scroll = scroll;
    this.options = options || {};
    this.allowExtendedRequest = Object.keys(this.options).includes('extendedMetaRequest') ? this.options.extendedMetaRequest : ALLOW_EXTENDED_IFRAMELY_REQUEST;
  }
  bookmarkManager_createClass(BookmarkManager, [{
    key: "isMethodImplemented",
    value: function isMethodImplemented(method) {
      return Boolean(this.options[method]);
    }

    /**
     * запрашивает превью по URL
     * @param {string} URL сайта
     * @return {Promise}
     */
  }, {
    key: "getUrlInfo",
    value: function getUrlInfo(url) {
      if (this.isMethodImplemented('getUrlInfo')) {
        return this.options.getUrlInfo(url);
      }
      return false;
    }
  }, {
    key: "prepareBookmarkMeta",
    value: function prepareBookmarkMeta(data) {
      var rawLinks = data.links,
        meta = data.meta,
        context = data.context;
      // при обновлении iframely поменялась структура массива links теперь это объект и нужно нормализовать данные, чтобы не переписывать логику поиска
      var links = rawLinks;
      if (!Array.isArray(links)) {
        if (bookmarkManager_typeof(links) === 'object') {
          links = Object.keys(links).reduce(function (arr, key) {
            if (Array.isArray(links[key])) {
              return [].concat(bookmarkManager_toConsumableArray(arr), bookmarkManager_toConsumableArray(links[key]));
            }
            return arr;
          }, []);
        }
      }
      // получение протокола возможно придется дополнять
      var isSsl = function isSsl() {
        var res = false;
        if (meta && meta.canonical && meta.canonical.startsWith('https://')) {
          res = true;
        } else if (context) {
          var contextMeta = context.meta;
          if (contextMeta && contextMeta.og) {
            if (contextMeta.og.url && contextMeta.og.url.startsWith('https://')) {
              res = true;
            } else if (contextMeta.og.image_src && contextMeta.og.image_src.startsWith('https://')) {
              res = true;
            }
          }
        } else if (links && links.length) {
          if (links[0].href && links[0].href.startsWith('https://')) {
            res = true;
          }
        }
        return res;
      };
      var result = {};
      // подготовка аттачей
      if (links && links.length) {
        // ищем превью
        var _iterator = bookmarkManager_createForOfIteratorHelper(links),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var link = _step.value;
            if (link.rel && link.rel.includes('thumbnail')) {
              result.preview = link.href;
              break;
            }
          }

          // ищем favicon
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var index = 1;
        var _iterator2 = bookmarkManager_createForOfIteratorHelper(links),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _link = _step2.value;
            if (_link.rel && _link.rel.includes('icon')) {
              if (links[index] && links[index].rel && links[index].rel.includes('icon') && _link.media && _link.media.width && links[index].media && links[index].media.width && _link.media.width > links[index].media.width && links[index].media.width >= MIN_FAVICON_SIZE) {
                index++;
                continue;
              } else {
                result.favicon = _link.href;
                break;
              }
            }
            index++;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      // подготовка названия и описания
      // сначала пробуем взять title из тега <title>
      if (context && context.meta && context.meta['html-title']) {
        result.name = context.meta['html-title'];
      }

      // если нет title, iframely предоставляет тайтл из og или подбирает его по первой фразе в <body>
      if (!result.name && meta) {
        if (meta.title) {
          result.name = meta.title;
        } else if (meta.site) {
          result.name = meta.site;
        }
      }
      if (result.name) {
        if (Array.isArray(result.name)) {
          result.name = result.name[0];
        } else {
          result.name = result.name.trim();
        }
      }
      if (meta && meta.description) {
        result.description = meta.description;
      }
      result.protocol = isSsl() ? 'https://' : 'http://';
      return result;
    }
  }]);
  return BookmarkManager;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/notificationManager/index.js
function notificationManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function notificationManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function notificationManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) notificationManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) notificationManager_defineProperties(Constructor, staticProps); return Constructor; }
var NotificationManager = /*#__PURE__*/function () {
  function NotificationManager(_ref) {
    var options = _ref.options;
    notificationManager_classCallCheck(this, NotificationManager);
    this.options = options || {};
  }
  notificationManager_createClass(NotificationManager, [{
    key: "toast",
    value: function toast(message, params) {
      if (this.options.toast) {
        this.options.toast(message, params);
      } else {
        alert(message);
      }
    }
  }, {
    key: "error",
    value: function error(message) {
      if (this.options.error) {
        this.options.error(message);
      } else {
        alert(message);
      }
    }
  }, {
    key: "showError",
    value: function showError(params) {
      if (this.options.showError) {
        this.options.showError(params);
      } else {
        alert(params.message);
      }
    }
  }]);
  return NotificationManager;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/popupManager/form.js




function form_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function form_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function form_createClass(Constructor, protoProps, staticProps) { if (protoProps) form_defineProperties(Constructor.prototype, protoProps); if (staticProps) form_defineProperties(Constructor, staticProps); return Constructor; }
function form_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var form_isEscKey = (0,lib/* default */.ZP)('escape');
var form_isEnterKey = (0,lib/* default */.ZP)('enter');
var PopupForm = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  function PopupForm(_ref) {
    var _this = this;
    var editor = _ref.editor,
      id = _ref.id,
      name = _ref.name;
    form_classCallCheck(this, PopupForm);
    form_defineProperty(this, "hotKeyHandler", function (event) {
      var hotKey = false;
      if (_this.editor.scroll.selection.hasFocus()) {
        _this.elements[0].focus();
        hotKey = true;
      }
      if (form_isEnterKey(event)) {
        _this.onFormSubmit();
        hotKey = true;
      } else if (form_isEscKey(event)) {
        _this.destroy();
        hotKey = true;
      }
      if (hotKey == true) {
        event.preventDefault();
      }
    });
    form_defineProperty(this, "onClose", function (event) {
      event.preventDefault();
      _this.destroy(true);
    });
    this.editor = editor;
    this.range = this.editor.scroll.selection.getRange()[0];
    this.id = id;
    this.name = name;
    this.emitter = new Emitter();
    this.overlay = this.createOverlay();
    this.wrapper = this.createWrapper();
    this.header = this.createHeader();
    this.container = this.createContainer();
    this.elements = [];
    this.buildWindow();
    window.addEventListener('keydown', this.hotKeyHandler);
  }
  form_createClass(PopupForm, [{
    key: "add",
    value: function add(el) {
      var element = PopupForm[el.type](el.params, this);
      return this.container.appendChild(element);
    }
  }, {
    key: "buildWindow",
    value: function buildWindow() {
      this.wrapper.appendChild(this.header);
      this.wrapper.appendChild(this.container);
      this.overlay.appendChild(this.wrapper);
      this.editor.scrollingContainer.appendChild(this.overlay);
    }
  }, {
    key: "createOverlay",
    value: function createOverlay() {
      var _this2 = this;
      var node = document.createElement('div');
      node.classList.add('note-popup-overlay');
      node.setAttribute(IGNORE_SELECT_ATTR, '1');
      node.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        _this2.destroy();
      });
      node.addEventListener('keydown', function (event) {
        event.stopPropagation();
      });
      return node;
    }
  }, {
    key: "createWrapper",
    value: function createWrapper() {
      var wrapper = document.createElement('div');
      wrapper.id = this.id;
      wrapper.classList.add('note-popup-wrapper');
      wrapper.addEventListener('click', function (event) {
        event.stopPropagation();
      });
      return wrapper;
    }
  }, {
    key: "createHeader",
    value: function createHeader() {
      var header = document.createElement('div');
      header.classList.add('note-popup-header');
      var title = document.createElement('h3');
      title.innerText = this.name;
      var close = document.createElement('button');
      close.classList.add('close-popup');
      close.innerText = 'x';
      close.addEventListener('click', this.onClose);
      header.appendChild(title);
      header.appendChild(close);
      return header;
    }
  }, {
    key: "createContainer",
    value: function createContainer() {
      var container = document.createElement('div');
      container.classList.add('note-popup-content');
      return container;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var restoreSelection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      window.removeEventListener('keydown', this.hotKeyHandler);
      this.overlay.remove();
      if (restoreSelection) {
        this.editor.scroll.selection.setRange(this.range);
      }
    }
  }, {
    key: "error",
    value: function error(item) {
      if (typeof item === 'string') {
        PopupForm.createError(this.container.querySelector('[name="' + item + '"]'));
      }
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(f) {
      var _this3 = this;
      this.emitter.on('submit', function (result) {
        var execute = f(result);
        if (execute) {
          _this3.destroy();
        }
      });
    }
  }, {
    key: "onFormSubmit",
    value: function onFormSubmit() {
      var result = {};
      this.elements.map(function (el) {
        if (el.getAttribute('name')) {
          result[el.getAttribute('name')] = el.value;
        }
      });
      Array.from(this.container.querySelectorAll('.error')).map(function (el) {
        el.classList.remove('error');
        el.querySelector('.note-popup-error').remove();
      });
      this.emitter.emit('submit', result);
    }
  }], [{
    key: "wrapFormItems",
    value: function wrapFormItems() {
      var els = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var node = document.createElement('div');
      node.classList.add('note-popup-element');
      els.map(function (el) {
        node.appendChild(el);
      });
      return node;
    }
  }, {
    key: "input",
    value: function input(params, form) {
      var label = document.createElement('label');
      var input = document.createElement('input');
      input.addEventListener('keydown', form.hotKeyHandler);
      if (params.type) {
        input.setAttribute('type', params.type);
      } else {
        input.setAttribute('type', 'text');
      }
      if (params.type === 'submit') {
        input.addEventListener('click', function (event) {
          event.preventDefault();
          form.onFormSubmit();
        });
      }
      if (params.name) {
        input.setAttribute('name', params.name);
      }
      if (params.placeholder) {
        input.setAttribute('placeholder', params.placeholder);
      }
      if (params.onError) {
        input.onError = params.onError;
      }
      if (params.value) {
        input.value = params.value;
      }
      form.elements.push(input);
      if (params.label) {
        label.innerText = params.label;
      } else {
        label.classList.add('empty');
      }
      return PopupForm.wrapFormItems([label, input]);
    }
  }, {
    key: "createError",
    value: function createError(el) {
      var text = el.onError ? el.onError : 'Invalid value';
      var error = document.createElement('div');
      error.classList.add('note-popup-error');
      error.innerText = text;
      el.parentNode.classList.add('error');
      el.parentNode.appendChild(error);
    }
  }]);
  return PopupForm;
}()));

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/popupManager/helpForm.js

function helpForm_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function helpForm_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function helpForm_createClass(Constructor, protoProps, staticProps) { if (protoProps) helpForm_defineProperties(Constructor.prototype, protoProps); if (staticProps) helpForm_defineProperties(Constructor, staticProps); return Constructor; }
function helpForm_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var HelpForm = /*#__PURE__*/function () {
  function HelpForm(_ref) {
    var _this = this;
    var editor = _ref.editor,
      name = _ref.name,
      params = _ref.params;
    helpForm_classCallCheck(this, HelpForm);
    helpForm_defineProperty(this, "onClose", function (event) {
      event.preventDefault();
      _this.destroy(true);
    });
    this.editor = editor;
    this.range = this.editor.scroll.selection.getRange()[0];
    this.name = name;
    this.params = params;
    this.overlay = this.createOverlay();
    this.wrapper = this.createWrapper();
    this.header = this.createHeader();
    this.container = this.createContainer();
    this.buildWindow();
  }
  helpForm_createClass(HelpForm, [{
    key: "buildWindow",
    value: function buildWindow() {
      this.wrapper.appendChild(this.header);
      this.wrapper.appendChild(this.container);
      this.overlay.appendChild(this.wrapper);
      this.editor.scrollingContainer.appendChild(this.overlay);
    }
  }, {
    key: "createOverlay",
    value: function createOverlay() {
      var _this2 = this;
      var node = document.createElement('div');
      node.classList.add('note-popup-overlay');
      node.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        _this2.destroy();
      });
      node.addEventListener('keydown', function (event) {
        event.stopPropagation();
      });
      return node;
    }
  }, {
    key: "createWrapper",
    value: function createWrapper() {
      var wrapper = document.createElement('div');
      wrapper.id = this.id;
      wrapper.classList.add('note-popup-wrapper');
      wrapper.addEventListener('click', function (event) {
        event.stopPropagation();
      });
      return wrapper;
    }
  }, {
    key: "createHeader",
    value: function createHeader() {
      var header = document.createElement('div');
      header.classList.add('note-popup-header');
      var title = document.createElement('h3');
      title.innerText = this.name;
      var close = document.createElement('button');
      close.classList.add('close-popup');
      close.innerText = 'x';
      close.addEventListener('click', this.onClose);
      header.appendChild(title);
      header.appendChild(close);
      return header;
    }
  }, {
    key: "createContainer",
    value: function createContainer() {
      var container = document.createElement('div');
      container.classList.add('note-popup-content');
      return container;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var restoreSelection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.overlay.remove();
      if (restoreSelection) {
        this.editor.scroll.selection.setRange(this.range);
      }
    }
  }]);
  return HelpForm;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/popupManager/clipboardHotkeys.js
function clipboardHotkeys_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { clipboardHotkeys_typeof = function _typeof(obj) { return typeof obj; }; } else { clipboardHotkeys_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return clipboardHotkeys_typeof(obj); }











function clipboardHotkeys_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function clipboardHotkeys_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function clipboardHotkeys_createClass(Constructor, protoProps, staticProps) { if (protoProps) clipboardHotkeys_defineProperties(Constructor.prototype, protoProps); if (staticProps) clipboardHotkeys_defineProperties(Constructor, staticProps); return Constructor; }
function clipboardHotkeys_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) clipboardHotkeys_setPrototypeOf(subClass, superClass); }
function clipboardHotkeys_setPrototypeOf(o, p) { clipboardHotkeys_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return clipboardHotkeys_setPrototypeOf(o, p); }
function clipboardHotkeys_createSuper(Derived) { var hasNativeReflectConstruct = clipboardHotkeys_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = clipboardHotkeys_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = clipboardHotkeys_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return clipboardHotkeys_possibleConstructorReturn(this, result); }; }
function clipboardHotkeys_possibleConstructorReturn(self, call) { if (call && (clipboardHotkeys_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return clipboardHotkeys_assertThisInitialized(self); }
function clipboardHotkeys_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function clipboardHotkeys_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function clipboardHotkeys_getPrototypeOf(o) { clipboardHotkeys_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return clipboardHotkeys_getPrototypeOf(o); }

var buttons = [{
  key: 'C',
  text: 'for copy'
}, {
  key: 'X',
  text: 'for cut'
}, {
  key: 'V',
  text: 'for paste'
}];
var ClipboardHotkeys = /*#__PURE__*/function (_HelpForm) {
  clipboardHotkeys_inherits(ClipboardHotkeys, _HelpForm);
  var _super = clipboardHotkeys_createSuper(ClipboardHotkeys);
  function ClipboardHotkeys(_ref) {
    var _this;
    var editor = _ref.editor,
      name = _ref.name,
      params = _ref.params;
    clipboardHotkeys_classCallCheck(this, ClipboardHotkeys);
    _this = _super.call(this, {
      editor: editor,
      name: name,
      params: params
    });
    _this.platform = _this.editor.platform;
    _this.addContent();
    return _this;
  }
  clipboardHotkeys_createClass(ClipboardHotkeys, [{
    key: "addContent",
    value: function addContent() {
      var _this2 = this;
      var commandKey = '';
      if (this.platform == 'Mac OS') {
        commandKey = '⌘';
      } else if (this.platform == 'Windows' || this.platform == 'Linux') {
        commandKey = 'Ctrl';
      }
      var helpText = document.createElement('div');
      helpText.innerText = 'These actions are unaviable via the Edit menu, but you can still use:';
      helpText.classList.add('clipboard-hotkeys-head');
      this.container.appendChild(helpText);
      var commandContainer = document.createElement('div');
      commandContainer.classList.add('clipboard-help-content');
      if (this.params.format === false) {
        commandContainer.classList.add('without-formats');
      }
      buttons.map(function (button) {
        var el = document.createElement('div');
        el.classList.add('clipboard-help-item');
        var elTop = document.createElement('div');
        elTop.classList.add('clipboard-help-item-combination');
        elTop.innerText = commandKey + ' + ' + (button.key == 'V' && _this2.params.format == false ? 'Shift + ' : '') + button.key;
        var elBottom = document.createElement('div');
        elBottom.classList.add('clipboard-help-item-label');
        elBottom.innerText = button.key == 'V' && _this2.params.format == false ? 'for paste without formatting' : button.text;
        el.appendChild(elTop);
        el.appendChild(elBottom);
        commandContainer.appendChild(el);
      });
      this.container.appendChild(commandContainer);
      this.addCloseButton();
    }
  }, {
    key: "addCloseButton",
    value: function addCloseButton() {
      var close = document.createElement('button');
      close.classList.add('clipboard-help-close');
      close.innerText = 'Close';
      close.addEventListener('click', this.onClose);
      this.container.appendChild(close);
    }
  }]);
  return ClipboardHotkeys;
}(HelpForm);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/popupManager/linkForm.js
function linkForm_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { linkForm_typeof = function _typeof(obj) { return typeof obj; }; } else { linkForm_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return linkForm_typeof(obj); }
function linkForm_extends() { linkForm_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return linkForm_extends.apply(this, arguments); }




















function linkForm_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function linkForm_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function linkForm_createClass(Constructor, protoProps, staticProps) { if (protoProps) linkForm_defineProperties(Constructor.prototype, protoProps); if (staticProps) linkForm_defineProperties(Constructor, staticProps); return Constructor; }
function linkForm_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) linkForm_setPrototypeOf(subClass, superClass); }
function linkForm_setPrototypeOf(o, p) { linkForm_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return linkForm_setPrototypeOf(o, p); }
function linkForm_createSuper(Derived) { var hasNativeReflectConstruct = linkForm_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = linkForm_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = linkForm_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return linkForm_possibleConstructorReturn(this, result); }; }
function linkForm_possibleConstructorReturn(self, call) { if (call && (linkForm_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return linkForm_assertThisInitialized(self); }
function linkForm_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function linkForm_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function linkForm_getPrototypeOf(o) { linkForm_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return linkForm_getPrototypeOf(o); }
function linkForm_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var linkForm_isEscKey = (0,lib/* default */.ZP)('esc');
var linkForm_linkFormAppearDuration = (link_form_default()).linkFormAppearDuration;
var LinkFormComponent = /*#__PURE__*/function (_Component) {
  linkForm_inherits(LinkFormComponent, _Component);
  var _super = linkForm_createSuper(LinkFormComponent);
  function LinkFormComponent() {
    var _this;
    linkForm_classCallCheck(this, LinkFormComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    linkForm_defineProperty(linkForm_assertThisInitialized(_this), "onMouseDown", function (event) {
      event.stopPropagation();
      var preventDefault = true;
      if ((0,dom/* isNodeEqualOrContain */.nN)(_this.displayInputNode, event.target) || (0,dom/* isNodeEqualOrContain */.nN)(_this.adressInputNode, event.target)) {
        preventDefault = false;
      }
      if (preventDefault) {
        event.preventDefault();
      }
    });
    linkForm_defineProperty(linkForm_assertThisInitialized(_this), "onLinkFormRef", function (node) {
      _this.linkFormNode = node;
    });
    linkForm_defineProperty(linkForm_assertThisInitialized(_this), "onDisplayInputRef", function (node) {
      _this.displayInputNode = node;
    });
    linkForm_defineProperty(linkForm_assertThisInitialized(_this), "onAdressInputRef", function (node) {
      _this.adressInputNode = node;
    });
    linkForm_defineProperty(linkForm_assertThisInitialized(_this), "onClickOpen", function (event) {
      event.stopPropagation();
      _this.props.openLink(_this.props.url);
    });
    linkForm_defineProperty(linkForm_assertThisInitialized(_this), "onClickCopy", function (event) {
      var emailStart = 'mailto:';
      var isEmail = _this.props.url.startsWith(emailStart);
      var urlToCopy = isEmail ? _this.props.url.slice(emailStart.length) : _this.props.url;
      _this.props.copyLinkUrl(urlToCopy);
    });
    linkForm_defineProperty(linkForm_assertThisInitialized(_this), "onClickEdit", function (event) {
      event.stopPropagation();
      _this.props.showEditForm();
    });
    linkForm_defineProperty(linkForm_assertThisInitialized(_this), "onClickDelete", function (event) {
      _this.props.deleteLink(true);
    });
    linkForm_defineProperty(linkForm_assertThisInitialized(_this), "onClickCancel", function (event) {
      event.preventDefault();
      event.stopPropagation();
      _this.props.cancel();
    });
    linkForm_defineProperty(linkForm_assertThisInitialized(_this), "onClickDone", function (event) {
      _this.props.hideForm();
    });
    linkForm_defineProperty(linkForm_assertThisInitialized(_this), "onInputKeydown", function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        event.stopPropagation();
        _this.props.hideForm();
      }
    });
    linkForm_defineProperty(linkForm_assertThisInitialized(_this), "onAdressInput", function (event) {
      if (_this.changedDisplay) return;
      if (_this.displayInputNode && _this.props.text === '') {
        _this.displayInputNode.value = _this.adressInputNode.value;
      }
    });
    linkForm_defineProperty(linkForm_assertThisInitialized(_this), "onDisplayInput", function (event) {
      if (event.target.value !== '') {
        if (!_this.changedDisplay) {
          _this.changedDisplay = true;
        }
      } else {
        _this.changedDisplay = false;
      }
    });
    return _this;
  }
  linkForm_createClass(LinkFormComponent, [{
    key: "applyLink",
    value: function applyLink() {
      var text = this.displayInputNode && this.displayInputNode.value || '';
      var url = this.adressInputNode.value;
      if (url !== '') {
        var hasProtokol = url.match(/(?:(?:[a-z][a-z0-9+.-]*:)(?:.*))/gm);
        if (!hasProtokol) {
          url = 'http://' + url;
        }
        if (text === '') {
          text = url;
        }
        if (this.props.singleBlock) {
          this.props.changeLink(text, url);
        } else {
          this.props.formatMoreBlots(url);
        }
      } else {
        this.props.deleteLink();
      }
    }
  }, {
    key: "parentTable",
    get: function get() {
      var textBlot = this.props.textBlot;
      if (textBlot && textBlot.getBlotName && textBlot.getBlotName() === 'tableLink') {
        return textBlot.parentTable;
      } else {
        return false;
      }
    }
  }, {
    key: "isBlotLocked",
    get: function get() {
      return !!(this.parentTable && this.parentTable.isBlotLocked);
    }
  }, {
    key: "getPanelItems",
    value: function getPanelItems() {
      var items = {
        link: {
          fn: this.onClickOpen,
          url: this.props.url,
          tooltip: this.props.url
        },
        buttons: [{
          id: 'open',
          fn: this.onClickOpen,
          title: this.props.getIntlText(this.props.isEmail ? 'link.send' : 'link.open')
        }, {
          id: 'copy',
          fn: this.onClickCopy,
          title: this.props.getIntlText('link.copy')
        }]
      };
      var hideEditButtons = false;
      if (this.isBlotLocked) {
        hideEditButtons = true;
      }
      if (this.props.editor.mode === this.props.editor.constructor.MODE_EDIT && (!this.props.link || !this.props.link.disableEditing) && !hideEditButtons) {
        items.buttons.push({
          id: 'edit',
          fn: this.onClickEdit,
          title: this.props.getIntlText('link.edit')
        });
        items.buttons.push({
          id: 'remove',
          fn: this.onClickDelete,
          title: this.props.getIntlText('link.remove')
        });
      }
      return items;
    }
  }, {
    key: "getFormItems",
    value: function getFormItems() {
      return {
        fields: [{
          id: 'display',
          type: 'text',
          label: this.props.getIntlText('link.text_label'),
          value: this.props.text,
          placeholder: 'Link',
          fn: this.onInputKeydown,
          ref: this.onDisplayInputRef,
          onInput: this.onDisplayInput,
          active: this.props.singleBlock
        }, {
          id: 'adress',
          type: 'url',
          label: this.props.getIntlText(this.props.isEmail ? 'link.email_label' : 'link.url_label'),
          value: this.props.url,
          placeholder: 'http://example.com',
          fn: this.onInputKeydown,
          ref: this.onAdressInputRef,
          onInput: this.onAdressInput,
          active: true,
          autocapitalize: 'off'
        }],
        buttons: [{
          id: 'cancel',
          fn: this.onClickCancel,
          title: this.props.getIntlText('link.cancel')
        }, {
          id: 'done',
          fn: this.onClickDone,
          title: this.props.getIntlText('link.done')
        }]
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.formComponentRef(this);
      this.props.adjustPositionContinuously();
      var formVisible = this.props.form;
      if (formVisible) {
        this.adressInputNode.focus();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.formComponentRef(null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var formVisible = this.props.form;
      var items = formVisible ? this.getFormItems() : this.getPanelItems();
      var form = null;
      if (formVisible) {
        form = (0,preact_module.h)(popupMenu/* default */.Z, {
          wantsToClose: this.props.hideForm,
          closeOnEsc: true,
          addClassName: 'link-edit no-scroll ' + util/* SELF_CONTROLLED_CONTENT_CLASS */.W$,
          key: "link-form-edit",
          domRef: this.onLinkFormRef
        }, items.fields.map(function (_ref) {
          var id = _ref.id,
            type = _ref.type,
            label = _ref.label,
            value = _ref.value,
            placeholder = _ref.placeholder,
            fn = _ref.fn,
            ref = _ref.ref,
            onInput = _ref.onInput,
            active = _ref.active,
            autocapitalize = _ref.autocapitalize;
          return active ? (0,preact_module.h)(PopupInputItem, {
            classPrefix: "link-form",
            id: id,
            type: type,
            label: label,
            value: value,
            placeholder: placeholder,
            onKeydown: fn,
            autocapitalize: autocapitalize,
            domRef: ref,
            onInput: onInput
          }) : null;
        }), (0,preact_module.h)("div", {
          className: "link-form-buttons"
        }, items.buttons.map(function (_ref2) {
          var id = _ref2.id,
            title = _ref2.title,
            fn = _ref2.fn;
          var buttonAttrs = {
            'data-button-key': id
          };
          return (0,preact_module.h)("div", linkForm_extends({
            className: 'link-form-button',
            key: id,
            onClick: fn,
            onMouseDown: _this2.onMouseDown
          }, buttonAttrs), title);
        })));
      } else {
        var _linkAttrs;
        var linkAttrs = (_linkAttrs = {}, linkForm_defineProperty(_linkAttrs, tooltipManager/* TOOLTIP_ATTR */.qZ, items.link.tooltip), linkForm_defineProperty(_linkAttrs, tooltipManager/* TOOLTIP_ADD_CLASS */.Bg, 'link-tooltip'), _linkAttrs);
        form = (0,preact_module.h)(popupMenu/* default */.Z, {
          wantsToClose: this.props.hideForm,
          closeOnEsc: true,
          addClassName: "link-panel no-scroll",
          key: "link-form-panel",
          domRef: this.onLinkFormRef
        }, (0,preact_module.h)("div", linkForm_extends({}, linkAttrs, {
          className: "link-panel-item link-panel-item-link",
          key: "link",
          onClick: items.link.fn,
          onMouseDown: this.onMouseDown
        }), (0,preact_module.h)("a", {
          href: items.link.url,
          className: "link-text",
          onClick: function onClick(e) {
            e.preventDefault();
          }
        }, items.link.url)), (0,preact_module.h)("div", {
          className: "link-panel-buttons"
        }, items.buttons.map(function (_ref3) {
          var id = _ref3.id,
            title = _ref3.title,
            fn = _ref3.fn;
          var buttonAttrs = {
            'data-button-key': id
          };
          return (0,preact_module.h)("div", linkForm_extends({
            className: 'link-panel-item',
            key: id,
            onClick: fn,
            onMouseDown: _this2.onMouseDown
          }, buttonAttrs), title);
        })));
      }
      return (0,preact_module.h)("div", {
        className: "link-form",
        onMouseDown: this.onMouseDown
      }, (0,preact_module.h)(preact_transition_group/* default */.Z, {
        transitionName: "link-menu",
        transitionEnterTimeout: linkForm_linkFormAppearDuration,
        transitionLeaveTimeout: linkForm_linkFormAppearDuration
      }, form));
    }
  }]);
  return LinkFormComponent;
}(preact_module/* Component */.wA);
var LinkForm = /*#__PURE__*/function () {
  function LinkForm(_ref4) {
    var _this3 = this;
    var editor = _ref4.editor,
      scroll = _ref4.scroll,
      link = _ref4.link,
      params = _ref4.params;
    linkForm_classCallCheck(this, LinkForm);
    linkForm_defineProperty(this, "formComponentRef", function (component) {
      _this3.formComponent = component;
    });
    linkForm_defineProperty(this, "onEditorTextChange", function () {
      _this3.hide();
    });
    linkForm_defineProperty(this, "changeLink", function (text, url) {
      var needHideCall = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (_this3.link) {
        _this3.link.changeUrl(url);
        _this3.link.changeText(text);
        _this3.editor.emitter.emit('edit-link', {
          text: text,
          url: url
        });
      } else if (_this3.params.setLink) {
        // В таблице V2 ссылка созадается без блота, передаем параметры напрямую
        _this3.params.setLink({
          text: text,
          url: url
        });
      } else {
        var blot = _this3.params.id ? _this3.editor.findById(_this3.params.id) : _this3.textBlot;
        if (_this3.params.text !== text) {
          var delta;
          if (_this3.textBlot.parentTable) {
            delta = [{
              retain: _this3.params.blotRange && _this3.params.blotRange.index ? _this3.params.blotRange.index : 0
            }];
          } else {
            delta = [{
              retain: _this3.params.blotRange.index
            }];
          }
          delta.push({
            insert: text,
            attributes: {
              link: url
            }
          });
          if (_this3.params.blotRange.length !== 0) {
            blot.deleteText(_this3.params.blotRange.index, _this3.params.blotRange.length);
          }
          blot.map.get('characters').applyDelta(delta);
          _this3.scroll.formatTextBlots({
            blot: blot,
            range: {
              index: _this3.params.blotRange.index,
              length: _this3.params.blotRange.index + text.length
            }
          }, Object.keys(_this3.params.formats).map(function (format) {
            return {
              format: format,
              value: _this3.params.formats[format]
            };
          }), 'user');
        } else {
          _this3.scroll.formatTextBlots({
            blot: blot,
            range: _this3.params.blotRange
          }, {
            format: 'link',
            value: url
          }, 'user');
        }
        if (_this3.textBlot.parentTable) {
          var _this3$textBlot$paren;
          var pos = (_this3$textBlot$paren = _this3.textBlot.parent.options) === null || _this3$textBlot$paren === void 0 ? void 0 : _this3$textBlot$paren.pos;
          if (pos) {
            _this3.textBlot.parentTable.selectCells(pos);
            //this.textBlot.parentTable.startEditCell(pos)
          }
        }

        _this3.scroll.selection.setRange({
          index: _this3.textBlot.offset(_this3.scroll) + _this3.params.blotRange.index + text.length,
          length: 0
        });
        _this3.editor.emitter.emit('add-link', {
          text: text,
          url: url
        });
      }
      if (needHideCall) {
        _this3.hide();
      }
    });
    linkForm_defineProperty(this, "formatMoreBlots", function (url) {
      var needHideCall = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (_this3.params.linkUrl !== url) {
        _this3.scroll.formatTextBlots(_this3.params.execBlots.map(function (blot) {
          return {
            blot: blot,
            range: _this3.params.cache.blotRange[blot.id]
          };
        }), {
          format: 'link',
          value: url
        }, 'user');
        _this3.scroll.selection.setRange(_this3.params.range);
      }
      if (needHideCall) {
        _this3.hide();
      }
    });
    linkForm_defineProperty(this, "openLink", function (url) {
      if (!_this3.editor.plugins.linkManager.processNavigation(url)) {
        window.open(url, '_blank', 'noopener');
      }
      _this3.hide();
    });
    linkForm_defineProperty(this, "copyLinkUrl", function (url) {
      _this3.editor.plugins.copyManager.copy(url);
      _this3.hide();
    });
    linkForm_defineProperty(this, "showEditForm", function () {
      _this3.editor.off('delta', _this3.onEditorTextChange);
      _this3.render(_this3.container);
      _this3.adjustPositionContinuously(true);
      setTimeout(function () {
        _this3.show();
      }, linkForm_linkFormAppearDuration);
    });
    linkForm_defineProperty(this, "hideForm", function (event) {
      var isEsc = false;
      if (typeof event !== 'undefined' && linkForm_isEscKey(event)) isEsc = true;
      _this3.hide(isEsc);
    });
    linkForm_defineProperty(this, "deleteLink", function () {
      var needHideCall = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      _this3.editor.off('delta', _this3.onEditorTextChange);
      if (_this3.link) {
        if (_this3.link.onEmpty) {
          // В таблице V2 возможно редактирование ссылки без создания блота, поэтому передаем link.onEmpty
          _this3.link.onEmpty();
        } else if (_this3.textBlot.onEmpty) {
          _this3.textBlot.onEmpty();
        } else {
          var blot = normalizeToStoredBlot(_this3.link);
          if (!blot.isText) {
            blot = normalizeToTextBlot(_this3.link);
          }
          var index = _this3.link.offset(blot);
          var length = _this3.link.domNode.innerText.length;
          blot.formatText(index, length, 'link', false, 'user');
          _this3.scroll.selection.setRange({
            index: blot.offset(_this3.scroll) + index + length,
            length: 0
          });
        }
      }
      if (needHideCall) {
        _this3.hide();
      }
    });
    linkForm_defineProperty(this, "getIntlText", function (key) {
      var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _this3.editor.plugins.i18n.get(key, opt);
    });
    linkForm_defineProperty(this, "adjustPositionContinuously", function () {
      var clear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var adjust = function adjust() {
        if (!_this3.container) {
          return;
        }
        if (!_this3.link) {
          _this3.setRangedPosition();
        } else {
          _this3.setLinkedPosition();
        }
        _this3.adjustPositionAnimationFrameRequest = requestAnimationFrame(adjust);
      };
      if (clear) {
        if (_this3.adjustPositionAnimationFrameRequest) {
          cancelAnimationFrame(_this3.adjustPositionAnimationFrameRequest);
          _this3.direction = null;
          _this3.correctLeft = null;
        }
      } else {
        adjust();
      }
    });
    linkForm_defineProperty(this, "setLinkedPosition", function () {
      var rect = _this3.container.getBoundingClientRect();
      var offset = getContainerOffset(_this3.link.domNode, _this3.scrollingContainer);
      var scrollingContainerRect = _this3.scrollingContainer.getBoundingClientRect();
      var linkRect = _this3.link.domNode.getBoundingClientRect();
      if (linkRect.y - rect.height < scrollingContainerRect.y && !_this3.direction) {
        _this3.direction = 'bottom';
      } else if (!_this3.direction) {
        _this3.direction = 'top';
      }
      var x = offset.x,
        y;
      if (_this3.direction === 'bottom') {
        y = offset.y + _this3.link.domNode.offsetHeight;
      } else {
        y = offset.y - rect.height;
      }
      var _this3$normalizePosit = _this3.normalizePosition(x, y),
        top = _this3$normalizePosit.top,
        left = _this3$normalizePosit.left;
      _this3.container.style.top = top + 'px';
      _this3.container.style.left = left + 'px';
    });
    linkForm_defineProperty(this, "setRangedPosition", function () {
      var scrollingContainerRect = _this3.scrollingContainer.getBoundingClientRect();
      var scrollingContainerScrollTop = _this3.scrollingContainer.scrollTop;
      var scrollingContainerScrollLeft = _this3.scrollingContainer.scrollLeft;
      //тут на всякий случай добавил позиционирование относительно блота если по каким то причинам отсутствует rangeParams,
      //чтобы панель хоть как то позиционировалась в случае такой ошибки
      if (_this3.params.anchorNode || !_this3.rangeParams) {
        var anchorRect = _this3.params.anchorNode.getBoundingClientRect() || _this3.textBlot.domNode.getBoundingClientRect();
        _this3.container.style.top = anchorRect.top - scrollingContainerRect.top + scrollingContainerScrollTop + 'px';
        var leftPosition = anchorRect.left - scrollingContainerRect.left + scrollingContainerScrollLeft;
        // what does 30 mean and why we need Min function?
        _this3.container.style.left = Math.min(leftPosition, scrollingContainerRect.right - scrollingContainerRect.left - _this3.container.offsetWidth - 30) + 'px';
        return;
      }
      var rect = _this3.container.getBoundingClientRect();
      var blotRect = _this3.textBlot.domNode.getBoundingClientRect();
      var offset = getContainerOffset(_this3.textBlot.domNode, _this3.scrollingContainer);
      offset.x += _this3.rangeParams.offsetX;
      offset.y += _this3.rangeParams.offsetY;
      if (blotRect.y - rect.height < scrollingContainerRect.y && !_this3.direction) {
        _this3.direction = 'bottom';
      } else if (!_this3.direction) {
        _this3.direction = 'top';
      }
      var x = offset.x,
        y;
      if (_this3.direction === 'bottom') {
        y = offset.y + _this3.rangeParams.height;
      } else {
        y = offset.y - rect.height;
      }
      var _this3$normalizePosit2 = _this3.normalizePosition(x, y),
        top = _this3$normalizePosit2.top,
        left = _this3$normalizePosit2.left;
      _this3.container.style.top = top + 'px';
      _this3.container.style.left = left + 'px';
    });
    this.editor = editor;
    this.scroll = scroll;
    this.params = params || null;
    this.link = link || null;
    this.textBlot = this.params && this.params.id && this.editor.findById(this.params.id) || this.link && normalizeToStoredBlot(this.link) || this.params.execBlots && this.params.execBlots[0];
    if (this.textBlot && !this.textBlot.isText) {
      if (this.link) {
        this.textBlot = normalizeToTextBlot(this.link);
      }
    }
    this.direction = null;
    this.scrollingContainer = this.editor.scrollingContainer;
  }
  linkForm_createClass(LinkForm, [{
    key: "render",
    value: function render(container) {
      var _this4 = this;
      var withMenu = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      props = Object.assign({}, props);
      var ActiveComponent = LinkFormComponent;
      if (props.form) {
        var blotsOptions = this.editor.options.blots;
        var linkBlotOptions = blotsOptions && blotsOptions.link;
        if (linkBlotOptions && linkBlotOptions.linkFormComponent) {
          // позволяем пользователю редактора задать свой компонент для формы ссылки
          ActiveComponent = linkBlotOptions.linkFormComponent;
          props.LinkFormComponent = LinkFormComponent;
        }
      }
      (0,preact_module/* render */.sY)((0,preact_module.h)(preact_transition_group/* default */.Z, {
        transitionName: "link-form",
        transitionEnterTimeout: linkForm_linkFormAppearDuration,
        transitionLeaveTimeout: linkForm_linkFormAppearDuration
      }, withMenu ? (0,preact_module.h)(ActiveComponent, linkForm_extends({
        changeLink: this.changeLink,
        formatMoreBlots: this.formatMoreBlots,
        openLink: this.openLink,
        copyLinkUrl: this.copyLinkUrl,
        showEditForm: this.showEditForm,
        deleteLink: this.deleteLink,
        key: "link-form",
        hideForm: this.hideForm,
        getIntlText: this.getIntlText,
        adjustPositionContinuously: this.adjustPositionContinuously,
        editor: this.editor,
        link: this.link,
        formComponentRef: this.formComponentRef,
        textBlot: this.textBlot,
        cancel: function cancel() {
          _this4.hide(true);
        }
      }, props)) : null), container);
    }
  }, {
    key: "normalizePosition",
    value: function normalizePosition(x, y) {
      //тут рассмотрены не все возможные варианты расположения редактора на странице, в дальнейшем возможно нужны доработки
      var top = y,
        left = x;
      var rect = this.container.getBoundingClientRect();
      var offsetBetweenEditorAndScroll = this.scrollingContainer !== this.editor.scrollingContainer && getContainerOffset(this.editor.scrollingContainer, this.scrollingContainer) || false;
      var scrollingContainerRect = this.scrollingContainer.getBoundingClientRect();
      // корректируем учитывая оффсеты между редактором и скроллинг контейнером если есть кастомный, так как позиционирование идет в контейнере редактора
      if (offsetBetweenEditorAndScroll) {
        top -= offsetBetweenEditorAndScroll.y;
        left -= offsetBetweenEditorAndScroll.x;
      }
      // корректируем left если часть редактора справа перекрывается окном (сдвигаем левее)
      if (document.body.offsetWidth < scrollingContainerRect.x + scrollingContainerRect.width) {
        left -= scrollingContainerRect.x + scrollingContainerRect.width - document.body.offsetWidth;
      }
      // нужна переменная которая запомнит, что позиция left была откорректирована
      // корректируем left если часть панели справа перекрывается скроллинг контейнером (сдвигаем левее)
      var offset = 15;
      if (scrollingContainerRect.x + left + rect.width > scrollingContainerRect.x + scrollingContainerRect.width - offset && !this.correctLeft) {
        this.correctLeft = scrollingContainerRect.x + left + rect.width - (scrollingContainerRect.x + scrollingContainerRect.width - offset) + this.editor.scrollbarWidth;
      }
      if (this.correctLeft) {
        left -= this.correctLeft;
      }
      if (this.editor.isMobileDevice() && this.formComponent.props.form) {
        left = (scrollingContainerRect.width - rect.width) / 2;
      }
      return {
        top: top,
        left: left
      };
    }
  }, {
    key: "show",
    value: function show() {
      var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (!form) {
        this.editor.on('delta', this.onEditorTextChange);
      }
      var props = {};
      if (!this.link) {
        if (this.params.singleBlock) {
          props.text = this.params.text;
        }
        props.url = this.params.linkUrl || '';

        //после того как функцию #setRangedPosition засунули в requestAnimationFrame все поломалось, range берется из window.getSelection(),
        //соответственно, когда фокус падает на сам попап, координаты range изменяются и это происходит постоянно если скролить редактор,
        //поэтому берем координаты при первом вызове (т.е. которые берутся, когда выделен текст в textBlot) и запоминаем их в переменную,
        //чтобы при обновлении использовать их же
        if (!this.rangeParams && this.textBlot) {
          var blotRect = this.textBlot.domNode.getBoundingClientRect();
          var selection = window.getSelection();
          if (!selection.rangeCount) {
            return;
          }
          var range = selection.getRangeAt(0);
          var rangeRects = Array.from(range.getClientRects());
          var rangeRect = rangeRects.length === 0 ? blotRect : rangeRects.shift();
          while (blotRect.y > rangeRect.y && rangeRects.length !== 0) {
            rangeRect = rangeRects.shift();
          }
          this.rangeParams = {
            offsetX: rangeRect.x - blotRect.x,
            offsetY: rangeRect.y - blotRect.y,
            height: rangeRect.height
          };
        }
      } else {
        props.text = this.link.domNode.innerText;
        props.url = this.link.domNode.getAttribute('href');
      }
      props.form = form;
      props.singleBlock = this.link ? true : this.params.singleBlock;
      // проверка регуляркой email'а почему то выдавала через раз true или false, при том что значение props.url не менялось,
      // потому сделал через startsWith
      props.isEmail = props.url.startsWith('mailto:');
      if (!this.container) {
        this.container = document.createElement('div');
        this.container.classList.add('link-form-container');
        this.editor.scrollingContainer.appendChild(this.container);
        this.render(this.container);
      }
      var container = this.container;
      container.removeAttribute('style');
      setTimeout(this.render.bind(this, container, true, props), 0);
    }
  }, {
    key: "onHideApplyLink",
    value: function onHideApplyLink() {
      var text = this.formComponent.displayInputNode && this.formComponent.displayInputNode.value || '';
      var url = this.formComponent.adressInputNode.value.replace(/\s/g, '');
      if (url !== '') {
        url = url.replace(/^(payload:)?(javascript){1,}/g, '');
        var hasProtocol = url.match(/(?:(?:[a-z][a-z0-9+.-]*:)(?:.*))/gm);
        var internalUrlPattern = /^\/[a-zA-Z0-9/_-]*$/;
        if (!hasProtocol && !internalUrlPattern.test(url)) {
          url = 'https://' + url;
        }
        if (text === '') {
          text = url;
        }
        var singleBlock = this.link ? true : this.params.singleBlock;
        if (singleBlock) {
          this.changeLink(text, url, false);
        } else {
          this.formatMoreBlots(url, false);
        }
      } else {
        this.deleteLink();
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      var isEsc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!isEsc) {
        if (this.formComponent.adressInputNode) {
          this.onHideApplyLink();
        }
      } else {
        var range = this.params.range;
        if (range) {
          this.editor.scroll.selection.setRange(range);
        } else if (this.link && this.link.onCancelEditSetCaretAfter) {
          this.link.onCancelEditSetCaretAfter();
        }
      }
      this.editor.off('delta', this.onEditorTextChange);
      var container = this.container;
      this.container = null;
      this.link = null;
      this.params = null;
      this.direction = null;
      this.correctLeft = null;
      this.rangeParams = null;
      this.render(container);
      setTimeout(function () {
        if (container.parentNode)
          //так же временное условие из за дубликата
          container.parentNode.removeChild(container);
      }, linkForm_linkFormAppearDuration);
    }
  }]);
  return LinkForm;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/popupManager/index.js
function popupManager_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { popupManager_typeof = function _typeof(obj) { return typeof obj; }; } else { popupManager_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return popupManager_typeof(obj); }
function popupManager_slicedToArray(arr, i) { return popupManager_arrayWithHoles(arr) || popupManager_iterableToArrayLimit(arr, i) || popupManager_unsupportedIterableToArray(arr, i) || popupManager_nonIterableRest(); }
function popupManager_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function popupManager_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return popupManager_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return popupManager_arrayLikeToArray(o, minLen); }
function popupManager_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function popupManager_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function popupManager_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function popupManager_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













function popupManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function popupManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function popupManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) popupManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) popupManager_defineProperties(Constructor, staticProps); return Constructor; }
function popupManager_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) popupManager_setPrototypeOf(subClass, superClass); }
function popupManager_setPrototypeOf(o, p) { popupManager_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return popupManager_setPrototypeOf(o, p); }
function popupManager_createSuper(Derived) { var hasNativeReflectConstruct = popupManager_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = popupManager_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = popupManager_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return popupManager_possibleConstructorReturn(this, result); }; }
function popupManager_possibleConstructorReturn(self, call) { if (call && (popupManager_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return popupManager_assertThisInitialized(self); }
function popupManager_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function popupManager_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function popupManager_getPrototypeOf(o) { popupManager_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return popupManager_getPrototypeOf(o); }







var helpForms = {
  'clipboard-hotkeys': function clipboardHotkeys(editor) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new ClipboardHotkeys({
      editor: editor,
      name: 'Copying and pasting',
      params: params
    });
  }
};
var RootDialogComponent = /*#__PURE__*/function (_Component) {
  popupManager_inherits(RootDialogComponent, _Component);
  var _super = popupManager_createSuper(RootDialogComponent);
  function RootDialogComponent() {
    popupManager_classCallCheck(this, RootDialogComponent);
    return _super.apply(this, arguments);
  }
  popupManager_createClass(RootDialogComponent, [{
    key: "render",
    value: function render() {
      return (0,preact_module.h)("div", null, "Root dialog");
    }
  }]);
  return RootDialogComponent;
}(preact_module/* Component */.wA);
var PopupManager = /*#__PURE__*/function () {
  function PopupManager(_ref) {
    var _this = this;
    var editor = _ref.editor,
      scroll = _ref.scroll,
      options = _ref.options;
    popupManager_classCallCheck(this, PopupManager);
    popupManager_defineProperty(this, "onClickButton", function (button) {
      new ButtonForm({
        editor: _this.editor,
        scroll: _this.scroll,
        button: button,
        params: {}
      }).show(false);
    });
    popupManager_defineProperty(this, "editButton", function (button) {
      new ButtonForm({
        editor: _this.editor,
        scroll: _this.scroll,
        button: button,
        params: {}
      }).show();
    });
    popupManager_defineProperty(this, "addButton", function (params) {
      params.title = params.text;
      new ButtonForm({
        editor: _this.editor,
        scroll: _this.scroll,
        params: params
      }).show();
    });
    popupManager_defineProperty(this, "onClickLink", function (link) {
      var _this$scroll$selectio = _this.scroll.selection.getRange(),
        _this$scroll$selectio2 = popupManager_slicedToArray(_this$scroll$selectio, 1),
        range = _this$scroll$selectio2[0];
      if (link.withoutRange || !range && _this.editor.mode !== _this.editor.constructor.MODE_EDIT || range && range.length === 0) {
        new LinkForm({
          editor: _this.editor,
          scroll: _this.scroll,
          link: link,
          params: {}
        }).show(false);
      }
    });
    popupManager_defineProperty(this, "editLink", function (link) {
      new LinkForm({
        editor: _this.editor,
        scroll: _this.scroll,
        link: link,
        params: {}
      }).show();
    });
    popupManager_defineProperty(this, "addLink", function (params) {
      new LinkForm({
        editor: _this.editor,
        scroll: _this.scroll,
        params: params
      }).show();
    });
    popupManager_defineProperty(this, "onHelp", function (event) {
      helpForms[event.form](_this.editor, event.params);
    });
    popupManager_defineProperty(this, "_dialogComponentWantsToClose", function () {
      _this.rootDialogComponent = null;
      _this._renderDialog();
    });
    this.editor = editor;
    this.scroll = scroll;
    this.emitter = this.editor.emitter;
    this.options = options || {};
    this.rootDialogComponent = null;
    if (this.editor.options.render) {
      this.rootDialogContainer = document.createElement('div');
      this.rootDialogContainer.classList.add('editor-root-dialog');
      this.rootDialogContainer.classList.add('theme-' + this.editor.options.theme);
      document.body.appendChild(this.rootDialogContainer);
    }
    this.emitter.on('click-link', this.onClickLink);
    this.emitter.on('click-button', this.onClickButton);
    this.emitter.on('help', this.onHelp);
  }
  popupManager_createClass(PopupManager, [{
    key: "alert",
    value: function (_alert) {
      function alert(_x, _x2) {
        return _alert.apply(this, arguments);
      }
      alert.toString = function () {
        return _alert.toString();
      };
      return alert;
    }(function (title, text) {
      if (this.options.alert) {
        return this.options.alert(title, text);
      }
      alert('Title: ' + title + '\nText: ' + text);
    })
  }, {
    key: "customAlert",
    value: function customAlert(params) {
      if (this.options.customAlert) {
        return this.options.customAlert(params);
      } else {
        console.warn('the customAlert method is not implemented by popupManager, skipping showing the message with params:', params);
      }
    }
  }, {
    key: "_renderDialog",
    value: function _renderDialog() {
      var component = this.rootDialogComponent;
      if (component) {
        component.props.wantsToClose = this._dialogComponentWantsToClose;
        this.rootDialogContainer.classList.add('open');
        this.options.onPopupShow && this.options.onPopupShow();
      } else {
        this.rootDialogContainer.classList.remove('open');
        this.options.onPopupHide && this.options.onPopupHide();
      }
      (0,preact_module/* render */.sY)((0,preact_module.h)("div", null, (0,preact_module.h)(plugins_i18n/* IntlProvider */.Pj, null, component)), this.rootDialogContainer);
    }
  }, {
    key: "dialog",
    value: function dialog(component) {
      this.rootDialogComponent = component;
      this._renderDialog();
    }
  }]);
  return PopupManager;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/dropManager/index.js

function dropManager_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = dropManager_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function dropManager_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return dropManager_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return dropManager_arrayLikeToArray(o, minLen); }
function dropManager_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }















function dropManager_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function dropManager_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { dropManager_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { dropManager_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function dropManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function dropManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function dropManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) dropManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) dropManager_defineProperties(Constructor, staticProps); return Constructor; }
function dropManager_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var DropManager = /*#__PURE__*/function () {
  function DropManager(_ref) {
    var _this = this;
    var _scroll = _ref.scroll,
      editor = _ref.editor,
      options = _ref.options;
    dropManager_classCallCheck(this, DropManager);
    dropManager_defineProperty(this, "onDrop", /*#__PURE__*/function () {
      var _ref2 = dropManager_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
        var scroll, _this$editor$plugins, pasteManager, dragAndDrop, attachmentManager, action, files, validateRes, blots, filesBlots, store, storedBlot, _iterator, _step, file, blot, blotName, Blot, map, _iterator2, _step2, _step2$value, _file, _blot, effectiveBlot;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                scroll = _this.editor.scroll;
                _this$editor$plugins = _this.editor.plugins, pasteManager = _this$editor$plugins.pasteManager, dragAndDrop = _this$editor$plugins.dragAndDrop, attachmentManager = _this$editor$plugins.attachmentManager;
                if (_this.dragSession) {
                  _context.next = 5;
                  break;
                }
                event.preventDefault();
                return _context.abrupt("return", null);
              case 5:
                // files pasted
                action = _this.dragSession.action;
                if (!event.dataTransfer.files.length) {
                  _context.next = 43;
                  break;
                }
                files = event.dataTransfer.files;
                event.preventDefault();
                _context.next = 11;
                return attachmentManager.validateFiles(Array.from(files).map(function (file) {
                  return attachmentManager.nFileFromWebFile(file);
                }));
              case 11:
                validateRes = _context.sent;
                if (!validateRes) {
                  _context.next = 41;
                  break;
                }
                blots = [];
                filesBlots = []; // даже если нет действия, мы все равно должны вызывать #onDragMouseUp, т.к. это переводит редактор из состояния
                // d&d в нормальное
                if (action) {
                  // подготавливаем (конвертируем) блот к аттачу
                  if (action.blot.prepareToDropAttach) {
                    action.blot = action.blot.prepareToDropAttach();
                  }
                  // создаем блоты
                  store = action.blot.store;
                  if (!store) {
                    storedBlot = normalizeToStoredBlot(action.blot);
                    if (storedBlot) {
                      store = storedBlot.store;
                    }
                  }
                  if (!store) {
                    store = _this.editor.store;
                  }
                  _iterator = dropManager_createForOfIteratorHelper(files);
                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      file = _step.value;
                      blot = void 0;
                      if (action.blot.createFileBlot) {
                        blot = action.blot.createFileBlot();
                      } else {
                        blotName = pasteManager.getBlotNameForFile(file);
                        Blot = src_parchment.query(blotName);
                        map = store.createMapForBlot(Blot);
                        blot = Blot.createBlot ? Blot.createBlot(_this.editor) : src_parchment.create(blotName);
                        blot.map = map;
                        blot.scroll = scroll;
                        if (blot.buildBlot) {
                          blot.buildBlot();
                        }
                      }
                      blots.push(blot);
                      filesBlots.push({
                        file: file,
                        blot: blot
                      });
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                  _this.dragSession.setBlots(blots);
                }
                dragAndDrop.onDragMouseUp();
                if (!action) {
                  _context.next = 39;
                  break;
                }
                // в этот момент блоты файлов должны быть уже срендерены, устанавливаем в них файлы
                _iterator2 = dropManager_createForOfIteratorHelper(filesBlots);
                _context.prev = 19;
                _iterator2.s();
              case 21:
                if ((_step2 = _iterator2.n()).done) {
                  _context.next = 31;
                  break;
                }
                _step2$value = _step2.value, _file = _step2$value.file, _blot = _step2$value.blot;
                effectiveBlot = void 0;
                if (_blot.dontDetachWhenDND) {
                  effectiveBlot = _blot;
                } else {
                  _blot.detach();
                  // находим действительный блот который сейчас активен для map, т.к. он может сменится при переносе
                  // например в колонку
                  effectiveBlot = _this.editor.findById(_blot.id);
                }
                if (effectiveBlot) {
                  _context.next = 28;
                  break;
                }
                console.error('could not find the file blot that should be rendered already', _blot);
                return _context.abrupt("continue", 29);
              case 28:
                effectiveBlot.setHTMLFileForUpload(attachmentManager.nFileFromWebFile(_file));
              case 29:
                _context.next = 21;
                break;
              case 31:
                _context.next = 36;
                break;
              case 33:
                _context.prev = 33;
                _context.t0 = _context["catch"](19);
                _iterator2.e(_context.t0);
              case 36:
                _context.prev = 36;
                _iterator2.f();
                return _context.finish(36);
              case 39:
                _context.next = 43;
                break;
              case 41:
                _this.dragSession.cleanup();
                dragAndDrop.onDragMouseUp();
              case 43:
                _this.endDragSession();
              case 44:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[19, 33, 36, 39]]);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    dropManager_defineProperty(this, "onDragOver", function (event) {
      var dragAndDrop = _this.editor.plugins.dragAndDrop;
      if (!event.dataTransfer.types.includes('Files')) {
        return;
      }
      var blot = src_parchment.find(event.target, true);
      if (_this.dragSession) {
        dragAndDrop.onDragMouseMove(event);
      }
      if (_this.dragSession && _this.dragSession.action) {
        // дроп разрешен
        event.preventDefault();
      } else {
        // дроп запрещен
      }
    });
    dropManager_defineProperty(this, "onDragEnter", function (event) {
      _this.cntElementsActive++;
      if (!event.dataTransfer.types.includes('Files')) {
        return;
      }
      if (!_this.dragSession) {
        _this.dragSession = _this.editor.plugins.dragAndDrop.startDragSession({
          targetBlot: {},
          blots: [],
          mousePosition: {
            x: event.clientX,
            y: event.clientY
          },
          isControlled: true
        });
      }
    });
    dropManager_defineProperty(this, "onDragLeave", function (event) {
      var dragAndDrop = _this.editor.plugins.dragAndDrop;
      _this.cntElementsActive--;
      if (_this.cntElementsActive <= 0) {
        _this.cntElementsActive = 0;
        _this.endDragSession();
        dragAndDrop.onDragMouseUp();
      }
    });
    this.editor = editor;
    this.scroll = _scroll;
    options = Object.assign({
      enabled: true
    }, options);
    this.enabled = options.enabled;
    if (!this.enabled) {
      return;
    }
    this.cntElementsActive = 0;
    this.dragSession = null;
    this.scroll.domNode.addEventListener('drop', this.onDrop, false);
    this.scroll.domNode.addEventListener('dragover', this.onDragOver, false);
    this.scroll.domNode.addEventListener('dragenter', this.onDragEnter, false);
    this.scroll.domNode.addEventListener('dragleave', this.onDragLeave, false);
  }
  dropManager_createClass(DropManager, [{
    key: "destroy",
    value: function destroy() {
      if (!this.enabled) {
        return;
      }
      this.scroll.domNode.removeEventListener('drop', this.onDrop, false);
      this.scroll.domNode.removeEventListener('dragover', this.onDragOver, false);
      this.scroll.domNode.removeEventListener('dragenter', this.onDragEnter, false);
      this.scroll.domNode.removeEventListener('dragleave', this.onDragLeave, false);
    }
  }, {
    key: "endDragSession",
    value: function endDragSession() {
      if (!this.dragSession) {
        return;
      }
      this.dragSession = null;
    }
  }]);
  return DropManager;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/copyManager/util.js
function copyManager_util_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = copyManager_util_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function copyManager_util_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return copyManager_util_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return copyManager_util_arrayLikeToArray(o, minLen); }
function copyManager_util_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }















function prepareList(node) {
  var listItems = Array.from(node.childNodes);
  var toCloneNode = listItems.some(function (listItem) {
    return listItem.classList.contains('list-item-number');
  }) ? document.createElement('ol') : node.cloneNode();
  var prepared = toCloneNode;
  var wrapper = prepared;
  var index = 0;
  for (var _i = 0, _listItems = listItems; _i < _listItems.length; _i++) {
    var listItem = _listItems[_i];
    var lvl = Number(Array.from(listItem.classList).find(function (cls) {
      return cls.startsWith('indent-');
    }).replace('indent-', ''));
    if (lvl > index) {
      while (index !== lvl) {
        index++;
        var nextWrapper = toCloneNode.cloneNode();
        wrapper.appendChild(nextWrapper);
        wrapper = nextWrapper;
      }
    } else if (lvl < index) {
      while (index !== lvl) {
        index--;
        if (wrapper.parentNode) {
          wrapper = wrapper.parentNode;
        }
      }
    }
    wrapper.appendChild(listItem);
  }
  node.parentNode.replaceChild(prepared, node);
}
function prepareCopyHTML(node) {
  var listNodes = Array.from(node.querySelectorAll('ul'));
  if (listNodes.length) {
    var _iterator = copyManager_util_createForOfIteratorHelper(listNodes),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var listNode = _step.value;
        prepareList(listNode);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else {
    var listItemNodes = Array.from(node.querySelectorAll('li'));
    if (listItemNodes.length) {
      var lists = [document.createElement('ul')];
      var index = 0;
      for (var i = 0; i < listItemNodes.length; i++) {
        var list = lists[index];
        if (i === listItemNodes.length - 1) {
          listItemNodes[i].parentNode.insertBefore(list, listItemNodes[i]);
        } else if (listItemNodes[i].nextElementSibling && listItemNodes[i].nextElementSibling.tagName !== 'LI') {
          listItemNodes[i].parentNode.insertBefore(list, listItemNodes[i]);
          lists.push(document.createElement('ul'));
          index++;
        }
        list.appendChild(listItemNodes[i]);
      }
      for (var _i2 = 0, _lists = lists; _i2 < _lists.length; _i2++) {
        var _list = _lists[_i2];
        prepareList(_list);
      }
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/copyManager/index.js














function copyManager_slicedToArray(arr, i) { return copyManager_arrayWithHoles(arr) || copyManager_iterableToArrayLimit(arr, i) || copyManager_unsupportedIterableToArray(arr, i) || copyManager_nonIterableRest(); }
function copyManager_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function copyManager_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return copyManager_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return copyManager_arrayLikeToArray(o, minLen); }
function copyManager_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function copyManager_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function copyManager_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function copyManager_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { copyManager_typeof = function _typeof(obj) { return typeof obj; }; } else { copyManager_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return copyManager_typeof(obj); }
function copyManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function copyManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function copyManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) copyManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) copyManager_defineProperties(Constructor, staticProps); return Constructor; }
function copyManager_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var copyManager_DEFAULT_OPTIONS = {
  nimbusOpsEnabled: false
};
var CopyManager = /*#__PURE__*/function () {
  function CopyManager(_ref) {
    var _this = this;
    var scroll = _ref.scroll,
      editor = _ref.editor,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;
    copyManager_classCallCheck(this, CopyManager);
    copyManager_defineProperty(this, "onCopy", function (event) {
      if (!_this.editor.hasFocus()) return;
      if (_this.copyText) {
        if (copyManager_typeof(_this.copyText) === 'object') {
          if (_this.copyText.text) {
            event.clipboardData.setData('text/plain', _this.copyText.text);
          }
          if (_this.copyText.html) {
            event.clipboardData.setData('text/html', _this.copyText.html);
          }
          if (_this.copyText.ops) {
            event.clipboardData.setData('nimbus/ops', JSON.stringify(_this.copyText.ops));
          }
          event.preventDefault();
        }
        return;
      }
      var processed = false;
      var _this$scroll$selectio = _this.scroll.selection.getRange(),
        _this$scroll$selectio2 = copyManager_slicedToArray(_this$scroll$selectio, 2),
        range = _this$scroll$selectio2[0],
        nativeRange = _this$scroll$selectio2[1];
      var blots = _this.scroll.selectedBlocks;
      if (blots.length !== 1 || !blots[0].nimbusOpsForbidden) {
        if (_this.options.nimbusOpsEnabled) {
          processed = _this.processWriteClipborad(event, blots, {
            nativeRange: nativeRange
          });
        }
        if (!processed) {
          if (range && range.length === 0) {
            if (blots.length === 1 && (blots[0].isEmbeddable || blots[0].getCopyHTML)) {
              processed = true;
              _this._setBlotHtmlToEvent(event, blots[0]);
            }
          }
        }
      }
      if (processed) {
        event.preventDefault();
      }
    });
    copyManager_defineProperty(this, "onCut", function (event) {
      if (!_this.editor.hasFocus()) return;
      var processed = false;
      var _this$scroll$selectio3 = _this.scroll.selection.getRange(),
        _this$scroll$selectio4 = copyManager_slicedToArray(_this$scroll$selectio3, 2),
        range = _this$scroll$selectio4[0],
        nativeRange = _this$scroll$selectio4[1];
      var blots = _this.scroll.selectedBlocks;
      if (_this.options.nimbusOpsEnabled) {
        processed = _this.processWriteClipborad(event, blots, {
          nativeRange: nativeRange,
          cut: true
        });
        if (processed) {
          // если мультивыделение или выделен один блот не имеющий функцию onCut, нужно вызвать DeleteAction,
          // удаление вырезанного контента в блоте имеющем функцию onCut должно происходить в этой функции
          if (blots.length !== 1 || !blots[0].onCut) {
            _this.useDeleteAction(blots, range);
          }
        }
      }
      if (!processed) {
        if (range && range.length === 0) {
          if (blots.length === 1 && blots[0].isEmbeddable) {
            processed = true;
            var res = _this._setBlotHtmlToEvent(event, blots[0], true);
            if (!res.cutProcessedByBlot) {
              // если блот не обработал cut, то удаляем его
              _this.scroll.selectedBlocks[0].remove();
            }
          }
        } else if (blots.find(function (blot) {
          return blot.processCutWithPlugin;
        })) {
          // если в массиве выделения есть syntax, нужно выполнить вырезание програмно
          processed = _this.processWriteClipborad(event, blots, {
            nativeRange: nativeRange,
            cut: true,
            withoutOps: true
          });
          _this.useDeleteAction(blots, range);
        }
      }
      if (processed) {
        event.preventDefault();
      }
    });
    this.editor = editor;
    this.scroll = scroll;
    this.sandbox = false;
    this.copyText = false;
    this.options = Object.assign({}, copyManager_DEFAULT_OPTIONS, options);

    //events
    document.addEventListener('copy', this.onCopy, false);
    document.addEventListener('cut', this.onCut, false);
  }
  copyManager_createClass(CopyManager, [{
    key: "destroy",
    value: function destroy() {
      document.removeEventListener('copy', this.onCopy, false);
      document.removeEventListener('cut', this.onCut, false);
    }
  }, {
    key: "_setBlotHtmlToEvent",
    value: function _setBlotHtmlToEvent(event, blot) {
      var cut = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var html;
      var text;
      var res = {};
      if (cut && blot.onCut) {
        html = blot.onCut();
        res.cutProcessedByBlot = true;
      } else if (blot.getCopyHTML) {
        html = blot.getCopyHTML();
      } else {
        html = this.scroll.selectedBlocks[0].domNode.outerHTML;
      }
      if (copyManager_typeof(html) === 'object') {
        // клиент возвращает и html и text
        var _html = html;
        html = _html.html;
        text = _html.text;
      }
      event.clipboardData.setData('text/html', html);
      if (text) {
        event.clipboardData.setData('text/plain', text);
      }
      return res;
    }
  }, {
    key: "_setBlotCopyParamsToEvent",
    value: function _setBlotCopyParamsToEvent(event, blot) {
      var cut = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var _blot$getCopyParams = blot.getCopyParams(cut),
        html = _blot$getCopyParams.html,
        text = _blot$getCopyParams.text,
        op = _blot$getCopyParams.op;
      if (html) {
        event.clipboardData.setData('text/html', html);
      }
      if (text) {
        event.clipboardData.setData('text/plain', text);
      }
      if (op) {
        event.clipboardData.setData('nimbus/ops', JSON.stringify([op]));
      }
    }
  }, {
    key: "processWriteClipborad",
    value: function processWriteClipborad(event) {
      var blots = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var nativeRange = params.nativeRange,
        cut = params.cut,
        withoutOps = params.withoutOps;
      if (nativeRange && blots.length) {
        if (blots.length === 1 && blots[0].getCopyParams) {
          this._setBlotCopyParamsToEvent(event, blots[0], cut);
        } else {
          var _this$getNativeCopyDa = this.getNativeCopyData(),
            html = _this$getNativeCopyDa.html,
            text = _this$getNativeCopyDa.text;
          event.clipboardData.setData('text/html', html);
          event.clipboardData.setData('text/plain', text);
          if (!withoutOps) {
            var ops = JSON.stringify(this.scroll.getSelectedContents());
            event.clipboardData.setData('nimbus/ops', ops);
          }
        }
        return true;
      }
      return false;
    }
  }, {
    key: "getNativeCopyData",
    value: function getNativeCopyData() {
      var nativeRange = this.scroll.selection.getRange()[1];
      var htmlFragment = document.createElement('div');
      htmlFragment.appendChild(nativeRange.native.cloneContents());
      prepareCopyHTML(htmlFragment);
      var html = htmlFragment.innerHTML;
      // тут не знаю на счет полифилов, возможно через проверки надо писать, либо текст возвращать для каждого блота
      var text = window.getSelection().toString(); // возвращает разделенный на строки текст

      return {
        html: html,
        text: text
      };
    }
  }, {
    key: "useDeleteAction",
    value: function useDeleteAction(blots, range) {
      if (this.editor.mode !== MODE_EDIT) return;
      var setRangeAfterAction = range.index === 0 && range.length === this.scroll.length() - 1 ? false : true;
      var deleteAction = new DeleteAction(DeleteAction.type, {}, this.editor);
      deleteAction.before({
        processingBlots: blots
      });
      deleteAction.exec({
        processingBlots: blots
      });
      if (setRangeAfterAction) {
        this.scroll.selection.setRange({
          index: range.index,
          length: 0
        });
      }
    }
  }, {
    key: "copy",
    value: function copy(text) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var i18n = this.editor.plugins.i18n;
      this.copyText = true;
      if (params.html) {
        this.copyText = {
          text: text,
          html: params.html
        };
        if (params.ops) {
          this.copyText.ops = params.ops;
        }
      }
      var success = false;
      try {
        var el = document.createElement('textarea');
        el.value = text;
        el.setAttribute('readonly', '');
        el.style.contain = 'strict';
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        var selection = document.getSelection();
        var originalRange = false;
        if (selection.rangeCount > 0) {
          originalRange = selection.getRangeAt(0);
        }
        document.body.appendChild(el);
        el.select();
        el.selectionStart = 0;
        el.selectionEnd = text.length;
        try {
          success = document.execCommand('copy');
        } catch (err) {
          console.error('Error in CopyManager, #copy() (execCommand): ', err);
        }
        document.body.removeChild(el);
        if (originalRange) {
          selection.removeAllRanges();
          selection.addRange(originalRange);
        }
        if (!params.noToast) {
          this.editor.plugins.notificationManager.toast(i18n.get('copy.copied'));
        }
        //console.log('Link copied to clipboard: ', success, ', text: ', text)
      } catch (err) {
        console.error('Error in CopyManager, #copy(): ', err);
      } finally {
        this.copyText = false;
      }
      return success;
    }
  }]);
  return CopyManager;
}();
/* harmony default export */ const copyManager = (CopyManager);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/lightBox/index.js











function lightBox_slicedToArray(arr, i) { return lightBox_arrayWithHoles(arr) || lightBox_iterableToArrayLimit(arr, i) || lightBox_unsupportedIterableToArray(arr, i) || lightBox_nonIterableRest(); }
function lightBox_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function lightBox_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return lightBox_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return lightBox_arrayLikeToArray(o, minLen); }
function lightBox_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function lightBox_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function lightBox_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function lightBox_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function lightBox_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function lightBox_createClass(Constructor, protoProps, staticProps) { if (protoProps) lightBox_defineProperties(Constructor.prototype, protoProps); if (staticProps) lightBox_defineProperties(Constructor, staticProps); return Constructor; }
function lightBox_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var MAX_ZOOM_IN = 500;
var MAX_ZOOM_OUT = (/* unused pure expression or super */ null && (-500));
var lightBox_isEscKey = (0,lib/* default */.ZP)('esc');
var LightBox = /*#__PURE__*/function () {
  function LightBox(_ref) {
    var _this = this;
    var editor = _ref.editor,
      scroll = _ref.scroll,
      options = _ref.options;
    lightBox_classCallCheck(this, LightBox);
    lightBox_defineProperty(this, "onContainerClick", function (event) {
      _this.onClose(event);
    });
    lightBox_defineProperty(this, "onImageBoxClick", function (event) {
      event.stopPropagation();
    });
    lightBox_defineProperty(this, "onBodyKeyDown", function (event) {
      if (lightBox_isEscKey(event)) {
        _this.onClose(event);
      }
    });
    lightBox_defineProperty(this, "onThemeChange", function (event) {
      if (_this.wrapper) {
        var _Array$from$filter = Array.from(_this.wrapper.classList).filter(function (cls) {
            return cls.indexOf('theme-') === 0;
          }),
          _Array$from$filter2 = lightBox_slicedToArray(_Array$from$filter, 1),
          currentThemeClass = _Array$from$filter2[0];
        _this.wrapper.classList.remove(currentThemeClass);
        _this.wrapper.classList.add('theme-' + event.theme);
      }
    });
    lightBox_defineProperty(this, "onClose", function (event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      //remove listeners
      document.body.removeEventListener('keydown', _this.onBodyKeyDown, false);
      //remove image
      var image = _this.image;
      _this.image = null;
      image.parentNode.removeChild(image);
      //hide
      _this.wrapper.classList.remove('open');
      _this.wrapper.classList.remove('visible');
      _this.wrapper.classList.remove('horizontal-scroll');
      _this.wrapper.classList.remove('vertical-scroll');
      //фикс - когда закрывался лайтбокс, правый клик по той же картинке,
      //что была до открытия лайтбокса в фокусе, вызывал контекстное меню браузера
      //this.scroll.selection.setRange(this.scroll.selection.savedRange)
      if (_this.onlyForAttachments) {
        _this.onlyForAttachments = null;
      }
    });
    lightBox_defineProperty(this, "onClickNext", function (event) {
      event.preventDefault();
      event.stopPropagation();
      var attachment = _this.editor.plugins.imageManager.getNextImageAttachment(_this.image.getAttribute('src'), _this.onlyForAttachments);
      if (attachment) {
        _this.image.setAttribute('src', attachment.url);
        _this.fetchScrolls();
      }
    });
    lightBox_defineProperty(this, "onClickPrev", function (event) {
      event.preventDefault();
      event.stopPropagation();
      var attachment = _this.editor.plugins.imageManager.getPrevImageAttachment(_this.image.getAttribute('src'), _this.onlyForAttachments);
      if (attachment) {
        _this.image.setAttribute('src', attachment.url);
        _this.fetchScrolls();
      }
    });
    this.editor = editor;
    this.scroll = scroll;
    this.options = options || {};
    this.editor.emitter.on('set-theme', this.onThemeChange);
    this.init();
  }
  lightBox_createClass(LightBox, [{
    key: "init",
    value: function init() {
      this.wrapper = this.createWrapper();
      this.wrapper.classList.add('theme-' + this.editor.plugins.editorStyle.getTheme());
      this.container = this.createContainer();
      this.imageBox = this.createImageBox();
      this.container.addEventListener('click', this.onContainerClick, false);
      this.imageBox.addEventListener('click', this.onImageBoxClick, false);
    }
  }, {
    key: "createWrapper",
    value: function createWrapper() {
      var node = document.createElement('div');
      node.id = 'note-lightbox';
      node.classList.add('note-lightbox');
      if (this.options.container) {
        if (this.options.container instanceof HTMLElement) {
          this.options.container.appendChild(node);
        } else {
          var container = document.getElementById(this.options.container);
          if (container) {
            container.appendChild(node);
          } else {
            console.warn('failed to get container ' + this.options.container + ', lightbox placed into body');
            document.body.appendChild(node);
          }
        }
      } else {
        document.body.appendChild(node);
      }
      return node;
    }
  }, {
    key: "createContainer",
    value: function createContainer() {
      var node = document.createElement('div');
      node.classList.add('note-lightbox-content');
      this.wrapper.appendChild(node);
      var closeButton = document.createElement('button');
      closeButton.classList.add('note-lightbox-close');
      var icon = document.createElement('div');
      icon.classList.add('lightbox-close-icon');
      var line1 = document.createElement('span');
      var line2 = document.createElement('span');
      icon.appendChild(line1);
      icon.appendChild(line2);
      closeButton.appendChild(icon);
      closeButton.addEventListener('click', this.onClose);
      node.appendChild(closeButton);
      var nextButton = document.createElement('button');
      (0,preact_module/* render */.sY)((0,preact_module.h)(icons/* IconChevronRight */.VG8, null), nextButton);
      nextButton.classList.add('note-lightbox-next');
      nextButton.addEventListener('click', this.onClickNext);
      var prevButton = document.createElement('button');
      (0,preact_module/* render */.sY)((0,preact_module.h)(icons/* IconChevronLeft */.ed9, null), prevButton);
      prevButton.classList.add('note-lightbox-prev');
      prevButton.addEventListener('click', this.onClickPrev);
      node.appendChild(nextButton);
      node.appendChild(prevButton);
      return node;
    }
  }, {
    key: "createImageBox",
    value: function createImageBox() {
      var node = document.createElement('div');
      node.classList.add('note-lightbox-image');
      this.container.appendChild(node);
      return node;
    }
  }, {
    key: "getImageSize",
    value: function getImageSize() {
      if (!this.image) {
        throw new Error('Unable to get image');
      }
      return {
        width: this.image.width,
        height: this.image.height
      };
    }
  }, {
    key: "fetchScrolls",
    value: function fetchScrolls() {
      var size = this.getImageSize();
      var viewport = (0,browser/* getBrowserViewport */.S5)();
      //тут получаем проценты, на сколько изображение больше окна по ширине и высоте
      var widthPercent = size.width * 100 / viewport.width;
      var heightPercent = size.height * 100 / viewport.height;
      if (widthPercent > 100 || heightPercent > 100) {
        if (widthPercent > 100) {
          this.wrapper.classList.add('horizontal-scroll');
        } else if (this.wrapper.classList.contains('horizontal-scroll')) {
          this.wrapper.classList.remove('horizontal-scroll');
        }
        if (heightPercent > 100) {
          this.wrapper.classList.add('vertical-scroll');
        } else if (this.wrapper.classList.contains('vertical-scroll')) {
          this.wrapper.classList.remove('vertical-scroll');
        }
      } else {
        if (this.wrapper.classList.contains('vertical-scroll')) {
          this.wrapper.classList.remove('vertical-scroll');
        }
        if (this.wrapper.classList.contains('horizontal-scroll')) {
          this.wrapper.classList.remove('horizontal-scroll');
        }
      }
    }
  }, {
    key: "open",
    value:
    /**
     * открывает лайтбокс
     * @param {string} src Url картинки
     * @param {object} info Объект с информацией о картинке
     */
    function open(src) {
      var _this2 = this;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!src) return;
      this.image = document.createElement('img');
      this.image.setAttribute('src', src);
      this.imageBox.appendChild(this.image);
      this.fetchScrolls();
      this.wrapper.classList.add('open');
      //for animation
      setTimeout(function () {
        _this2.wrapper.classList.add('visible');
      }, 100);
      document.body.addEventListener('keydown', this.onBodyKeyDown, false);
      if (params.onlyForAttachments) {
        this.onlyForAttachments = params.onlyForAttachments;
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.editor.emitter.off('set-theme', this.onThemeChange);
      this.container.removeEventListener('click', this.onContainerClick, false);
      this.imageBox.removeEventListener('click', this.onImageBoxClick, false);
      var wrapper = this.wrapper;
      if (this.image) {
        this.onClose();
      }
      this.wrapper = null;
      this.container = null;
      this.imageBox = null;
      this.editor = null;
      this.scroll = null;
      wrapper.parentNode.removeChild(wrapper);
    }
  }]);
  return LightBox;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/emojiManager/index.js

function emojiManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function emojiManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function emojiManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) emojiManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) emojiManager_defineProperties(Constructor, staticProps); return Constructor; }
function emojiManager_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var EmojiManager = /*#__PURE__*/function () {
  function EmojiManager(_ref) {
    var _this = this;
    var editor = _ref.editor,
      scroll = _ref.scroll;
    emojiManager_classCallCheck(this, EmojiManager);
    emojiManager_defineProperty(this, "addEmoji", function (smile) {
      var range = _this.scroll.selection.savedRange;
      _this.scroll.selection.setRange(range);
      _this.editor.exec('insert-html', {
        html: smile.native
      });
      range.index += smile.native.length;
      _this.scroll.selection.setRange(range);
      _this.close();
    });
    this.editor = editor;
    this.scroll = scroll;
    this.container = document.createElement('div');
  }
  emojiManager_createClass(EmojiManager, [{
    key: "init",
    value: function init() {
      this.container.classList = ['emoji-picker hidden'];
      this.render();
    }
  }, {
    key: "state",
    get: function get() {
      return {
        open: !this.container.classList.contains('hidden')
      };
    }
  }, {
    key: "wrapper",
    set: function set(node) {
      node.appendChild(this.container);
      this.init();
    }
  }, {
    key: "render",
    value: function render() {
      /*
      pRender(
        <Picker
          set='google'
          onSelect={this.addEmoji}
          native='true'
          title='Pick your emoji…' emoji='point_up'
          i18n={{ search: 'Search', categories: { search: 'Searching results', recent: 'Recent' } }}
        />,
        this.container
      )*/
    }
  }, {
    key: "getComponent",
    value: function getComponent(selectFn) {
      /*
      return <Picker
        set='google'
        onSelect={selectFn}
        native='true'
        title='Pick your emoji…' emoji='point_up'
        i18n={{ search: 'Search', categories: { search: 'Searching results', recent: 'Recent' } }}
      />
      */
    }
  }, {
    key: "show",
    value: function show() {
      this.container.classList.remove('hidden');
    }
  }, {
    key: "close",
    value: function close() {
      this.container.classList.add('hidden');
    }
  }]);
  return EmojiManager;
}();

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/scss/floating-toolbar.scss
var floating_toolbar = __webpack_require__(84806);
var floating_toolbar_default = /*#__PURE__*/__webpack_require__.n(floating_toolbar);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/floatingToolbar/FloatingAIMenuComponent.js
function FloatingAIMenuComponent_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { FloatingAIMenuComponent_typeof = function _typeof(obj) { return typeof obj; }; } else { FloatingAIMenuComponent_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return FloatingAIMenuComponent_typeof(obj); }











function FloatingAIMenuComponent_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function FloatingAIMenuComponent_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function FloatingAIMenuComponent_createClass(Constructor, protoProps, staticProps) { if (protoProps) FloatingAIMenuComponent_defineProperties(Constructor.prototype, protoProps); if (staticProps) FloatingAIMenuComponent_defineProperties(Constructor, staticProps); return Constructor; }
function FloatingAIMenuComponent_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) FloatingAIMenuComponent_setPrototypeOf(subClass, superClass); }
function FloatingAIMenuComponent_setPrototypeOf(o, p) { FloatingAIMenuComponent_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return FloatingAIMenuComponent_setPrototypeOf(o, p); }
function FloatingAIMenuComponent_createSuper(Derived) { var hasNativeReflectConstruct = FloatingAIMenuComponent_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = FloatingAIMenuComponent_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = FloatingAIMenuComponent_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return FloatingAIMenuComponent_possibleConstructorReturn(this, result); }; }
function FloatingAIMenuComponent_possibleConstructorReturn(self, call) { if (call && (FloatingAIMenuComponent_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return FloatingAIMenuComponent_assertThisInitialized(self); }
function FloatingAIMenuComponent_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function FloatingAIMenuComponent_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function FloatingAIMenuComponent_getPrototypeOf(o) { FloatingAIMenuComponent_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return FloatingAIMenuComponent_getPrototypeOf(o); }
function FloatingAIMenuComponent_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var FloatingAIMenuComponent = /*#__PURE__*/function (_Component) {
  FloatingAIMenuComponent_inherits(FloatingAIMenuComponent, _Component);
  var _super = FloatingAIMenuComponent_createSuper(FloatingAIMenuComponent);
  function FloatingAIMenuComponent(props) {
    var _this;
    FloatingAIMenuComponent_classCallCheck(this, FloatingAIMenuComponent);
    _this = _super.call(this, props);
    FloatingAIMenuComponent_defineProperty(FloatingAIMenuComponent_assertThisInitialized(_this), "onMouseDown", function (event) {
      var preventDefault = true;
      if (preventDefault) {
        event.preventDefault();
      }
    });
    FloatingAIMenuComponent_defineProperty(FloatingAIMenuComponent_assertThisInitialized(_this), "onClickHandler", function (action) {
      _this.props.onClickHandler(action);
    });
    _this.props.onCreateToolbar(FloatingAIMenuComponent_assertThisInitialized(_this));
    return _this;
  }
  FloatingAIMenuComponent_createClass(FloatingAIMenuComponent, [{
    key: "getItems",
    value: function getItems() {
      var i18n = this.props.i18n;
      return [{
        name: i18n.get('embedded_menu.helper'),
        fn: this.onClickHandler.bind(undefined, 'custom'),
        Icon: icons/* IconPromtIcon */.nST
      }, {
        name: i18n.get('embedded_menu.summarize'),
        fn: this.onClickHandler.bind(undefined, 'summarize'),
        Icon: icons/* IconAiSummarize */.vO
      }, {
        name: i18n.get('embedded_menu.explain'),
        fn: this.onClickHandler.bind(undefined, 'explain'),
        Icon: icons/* IconAiExplain */.j0X
      }, {
        name: i18n.get('embedded_menu.improve'),
        fn: this.onClickHandler.bind(undefined, 'improve'),
        Icon: icons/* IconAiImprove */.F6w
      }, {
        name: i18n.get('embedded_menu.spelling'),
        fn: this.onClickHandler.bind(undefined, 'fix'),
        Icon: icons/* IconAiSpelling */.Lan
      }, {
        name: i18n.get('embedded_menu.cta'),
        fn: this.onClickHandler.bind(undefined, 'tasks'),
        Icon: icons/* IconAiCta */.qHO
      }, {
        name: i18n.get('embedded_menu.shorter'),
        fn: this.onClickHandler.bind(undefined, 'shorter'),
        Icon: icons/* IconAiShorter */.rXf
      }, {
        name: i18n.get('embedded_menu.longer'),
        fn: this.onClickHandler.bind(undefined, 'longer'),
        Icon: icons/* IconAiLonger */.Z8B
      }];
    }
  }, {
    key: "render",
    value: function render() {
      var items = this.getItems();
      return (0,preact_module.h)(popupMenu/* default */.Z, {
        key: "floating-toolbar-ai-menu",
        domRef: this.onFloatingToolbarRef,
        onMouseDown: this.onMouseDown,
        addClassName: 'floating-toolbar-ai-menu',
        wantsToClose: this.props.wantsToClose,
        closeOnEsc: true
      }, items.map(function (_ref) {
        var name = _ref.name,
          fn = _ref.fn,
          Icon = _ref.Icon;
        return (0,preact_module.h)("div", {
          className: 'ai-menu-item',
          onClick: fn
        }, (0,preact_module.h)("div", null, (0,preact_module.h)(Icon, null), (0,preact_module.h)("div", {
          className: 'title'
        }, name)));
      }));
    }
  }]);
  return FloatingAIMenuComponent;
}(preact_module/* Component */.wA);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/floatingToolbar/index.js
function floatingToolbar_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { floatingToolbar_typeof = function _typeof(obj) { return typeof obj; }; } else { floatingToolbar_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return floatingToolbar_typeof(obj); }

function floatingToolbar_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function floatingToolbar_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { floatingToolbar_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { floatingToolbar_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function floatingToolbar_extends() { floatingToolbar_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return floatingToolbar_extends.apply(this, arguments); }
function floatingToolbar_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function floatingToolbar_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function floatingToolbar_createClass(Constructor, protoProps, staticProps) { if (protoProps) floatingToolbar_defineProperties(Constructor.prototype, protoProps); if (staticProps) floatingToolbar_defineProperties(Constructor, staticProps); return Constructor; }
function floatingToolbar_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) floatingToolbar_setPrototypeOf(subClass, superClass); }
function floatingToolbar_setPrototypeOf(o, p) { floatingToolbar_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return floatingToolbar_setPrototypeOf(o, p); }
function floatingToolbar_createSuper(Derived) { var hasNativeReflectConstruct = floatingToolbar_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = floatingToolbar_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = floatingToolbar_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return floatingToolbar_possibleConstructorReturn(this, result); }; }
function floatingToolbar_possibleConstructorReturn(self, call) { if (call && (floatingToolbar_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return floatingToolbar_assertThisInitialized(self); }
function floatingToolbar_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function floatingToolbar_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function floatingToolbar_getPrototypeOf(o) { floatingToolbar_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return floatingToolbar_getPrototypeOf(o); }
function floatingToolbar_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function floatingToolbar_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = floatingToolbar_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function floatingToolbar_slicedToArray(arr, i) { return floatingToolbar_arrayWithHoles(arr) || floatingToolbar_iterableToArrayLimit(arr, i) || floatingToolbar_unsupportedIterableToArray(arr, i) || floatingToolbar_nonIterableRest(); }
function floatingToolbar_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function floatingToolbar_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function floatingToolbar_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function floatingToolbar_toConsumableArray(arr) { return floatingToolbar_arrayWithoutHoles(arr) || floatingToolbar_iterableToArray(arr) || floatingToolbar_unsupportedIterableToArray(arr) || floatingToolbar_nonIterableSpread(); }
function floatingToolbar_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function floatingToolbar_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return floatingToolbar_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return floatingToolbar_arrayLikeToArray(o, minLen); }
function floatingToolbar_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function floatingToolbar_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return floatingToolbar_arrayLikeToArray(arr); }
function floatingToolbar_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }























































var floatingToolbarHeight = (floating_toolbar_default()).floatingToolbarHeight,
  floatingToolbarAppearDuration = (floating_toolbar_default()).floatingToolbarAppearDuration,
  colorPickerAppearDuration = (floating_toolbar_default()).colorPickerAppearDuration;
var DEFAULT_COLOR = false;
var DEFAULT_HIGHLIGHT = 'yellow';
var floatingToolbar_textColors = Array.from(matColorNames);
floatingToolbar_textColors.push.apply(floatingToolbar_textColors, floatingToolbar_toConsumableArray(additionalColorNames));
floatingToolbar_textColors.push.apply(floatingToolbar_textColors, floatingToolbar_toConsumableArray(blackAndWhite));
var floatingToolbar_ID_ATTR = 'data-menu-id';
var floatingToolbar_COLOR_ATTR = 'data-color-name';
var floatingToolbar_FORMAT_STYLES = ['bold', 'italic', 'underline', 'strikethrough', 'code', 'button', 'comment', 'link', 'background', 'color', 'placeholder'];
var DISABLE_COMMENT_FOR_FORMATS = ['placeholder'];
var MOUSE_DRAGGING_TRIGGER_DISTANCE = 5;
function floatingToolbar_singleMenuState() {
  var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var available = ['colorPicker'];
  var state = {};
  for (var _i = 0, _available = available; _i < _available.length; _i++) {
    var item = _available[_i];
    if (item === active) {
      state[item] = true;
    } else {
      state[item] = false;
    }
  }
  return state;
}

// экспортируем функцию так как она также будет использоваться в клиентах
var onClickComment = function onClickComment(editor) {
  // т.к. выделенныей текст может быть изменён через каллаборацию, сохраняем относительную позицию выделенного текста
  var relativePosition = getRelativePosition(editor, true);
  var _editor$scroll$getSel = editor.scroll.getSelectedBlocks(),
    _editor$scroll$getSel2 = floatingToolbar_slicedToArray(_editor$scroll$getSel, 1),
    id = _editor$scroll$getSel2[0].id;
  var commentManager = editor.plugins.commentManager;
  commentManager.onCreateInlineComment(id).then(function (result) {
    var threadId = result.threadId;
    var color = editor.plugins.commentManager.onCreateInlineCommentGetColor();
    // конвертируем относительную позицию в абсолютную
    var _getAbsolutePosition = getAbsolutePosition(relativePosition),
      index = _getAbsolutePosition.index,
      length = _getAbsolutePosition.length;
    // Форматируем текстовые блоки не применяя editor.exec так как exec требует выделения в редакторе, а нам нельзя его выставлять
    var blots = editor.scroll.descendants(function (blot) {
      return blot instanceof textBase || blot instanceof NewTextBase;
    }, index, length);
    // получаем range каждого текстового блота, на основе абсолютной позиции
    var blotsRange = new Map();
    var _iterator = floatingToolbar_createForOfIteratorHelper(blots),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var blot = _step.value;
        // надо вычислить позицию выделения относительного заданного блота
        var blotOffset = blot.offset(editor.scroll);
        var blotLength = blot.length();
        // позиция выделения внутри blot'a
        var blotRangeIndex = Math.max(index - blotOffset, 0);
        // длина выделения внутри blota (предварительная т.к. не учитывается длина самого blota)
        var blotRangeLength = Math.min(index - blotOffset + length, length);
        blotsRange.set(blot, {
          index: blotRangeIndex,
          length: Math.min(blotRangeLength, blotLength - blotRangeIndex - 1)
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    editor.plugins.undoManager.skip(function () {
      var blotsFormat = [];
      // применяем форматирование к текстовым блотам
      var _iterator2 = floatingToolbar_createForOfIteratorHelper(blotsRange.entries()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = floatingToolbar_slicedToArray(_step2.value, 2),
            blot = _step2$value[0],
            blotRange = _step2$value[1];
          blot.formatText(blotRange.index, blotRange.length, 'comment', JSON.stringify({
            threadId: threadId,
            color: color
          }), 'user');
          blotsFormat.push({
            blotId: blot.id,
            params: [blotRange.index, blotRange.length, floatingToolbar_defineProperty({}, "comment-".concat(threadId, "-").concat(color), true)]
          });
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      commentManager.onFormatToCommentThread(blotsFormat);
    });
  });
};
var FloatingToolbarComponent = /*#__PURE__*/function (_Component) {
  floatingToolbar_inherits(FloatingToolbarComponent, _Component);
  var _super = floatingToolbar_createSuper(FloatingToolbarComponent);
  function FloatingToolbarComponent(props) {
    var _this;
    floatingToolbar_classCallCheck(this, FloatingToolbarComponent);
    _this = _super.call(this, props);
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onMouseDown", function (event) {
      var preventDefault = true;
      _this.setState(function (prevState) {
        var colorPicker = prevState.colorPicker;
        if ((0,dom/* isNodeEqualOrContain */.nN)(_this.colorIconNode, event.target)) {
          return floatingToolbar_singleMenuState(!colorPicker && 'colorPicker');
        }
        return null;
      });
      if (preventDefault) {
        event.preventDefault();
      }
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "formatText", function (params) {
      _this.props.formatText(params);
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onFloatingToolbarRef", function (node) {
      _this.floatingToolbarNode = node;
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onColorPickerRef", function (node) {
      _this.colorPickerNode = node;
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onBoldIconRef", function (node) {
      _this.boldIconNode = node;
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onItalicIconRef", function (node) {
      _this.italicIconNode = node;
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onUnderlineIconRef", function (node) {
      _this.underlineIconNode = node;
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onStrikethroughIconRef", function (node) {
      _this.strikethroughIconNode = node;
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onClearFormattingRef", function (node) {
      _this.clearFormattingIconNode = node;
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onCommentIconRef", function (node) {
      _this.commentIconNode = node;
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onPlaceholderIconRef", function (node) {
      _this.placeholderIconNode = node;
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onCodeIconRef", function (node) {
      _this.codeIconNode = node;
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onButtonIconRef", function (node) {
      _this.buttonIconNode = node;
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onLinkIconRef", function (node) {
      _this.linkIconNode = node;
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onHighlightIconRef", function (node) {
      _this.highlightIconNode = node;
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onColorIconRef", function (node) {
      _this.colorIconNode = node;
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onCreateNoteRef", function (node) {
      _this.createNoteNode = node;
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onAIIconRef", function (node) {
      _this.createNoteNode = node;
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onColorPickerWantsToClose", function () {
      _this.setState(function () {
        return floatingToolbar_singleMenuState();
      });
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onClickBold", function () {
      _this.formatText('bold');
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onClickItalic", function () {
      _this.formatText('italic');
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onClickUnderline", function () {
      _this.formatText('underline');
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onClickStrikethrough", function () {
      _this.formatText('strikethrough');
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onClickPlaceholder", function () {
      _this.formatText('placeholder');
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onClickCode", function () {
      _this.formatText('code');
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onClickButton", function (event) {
      var editor = _this.props.editor;
      var _editor$plugins = editor.plugins,
        notificationManager = _editor$plugins.notificationManager,
        i18n = _editor$plugins.i18n;
      var _getSelectedText = (0,util/* getSelectedText */.ZT)(editor),
        text = _getSelectedText.text;
      if (text.length > ButtonFormComponent.maxTitleSize) {
        notificationManager.toast(i18n.get('button.length_error'));
      } else {
        _this.props.addButton(event);
      }
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onClickLink", function (event) {
      _this.props.addLink(event);
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onClickHighlight", function () {
      if (_this.props.formats && _this.props.formats['background']) {
        _this.props.clearHighlight();
      } else {
        if (_this.props.formats && _this.props.formats['color']) {
          _this.props.saveColor(false);
          _this.formatText({
            style: 'color',
            value: false
          });
        }
        _this.props.applyHighlight();
      }
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onClickColor", function () {});
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onColorChoosen", function (color) {
      if (color && _this.props.formats && _this.props.formats['background']) {
        _this.props.saveHighlight(false);
        _this.formatText({
          style: 'background',
          value: false
        });
      }
      _this.props.saveColor(color);
      _this.formatText({
        style: 'color',
        value: color
      });
      _this.onColorPickerWantsToClose && _this.onColorPickerWantsToClose();
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onHighlightChoosen", function (colorName) {
      if (colorName && _this.props.formats && _this.props.formats['color']) {
        _this.props.saveColor(false);
        _this.formatText({
          style: 'color',
          value: false
        });
      }
      _this.props.saveHighlight(colorName);
      _this.formatText({
        style: 'background',
        value: colorName
      });
      _this.onColorPickerWantsToClose && _this.onColorPickerWantsToClose();
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onClearAllChoosen", function () {
      _this.props.saveColor(false);
      _this.props.saveHighlight(false);
      _this.formatText({
        style: 'color',
        value: false
      });
      _this.formatText({
        style: 'background',
        value: false
      });
      _this.onColorPickerWantsToClose && _this.onColorPickerWantsToClose();
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onClearFormats", function () {
      _this.props.clearFormats();
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onClickCreateNote", function () {
      _this.props.createNoteMention();
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onClickComment", function () {
      _this.props.onClickComment();
    });
    floatingToolbar_defineProperty(floatingToolbar_assertThisInitialized(_this), "onClickUseAI", function () {
      _this.props.onClickUseAI();
    });
    _this.props.onCreateToolbar(floatingToolbar_assertThisInitialized(_this));
    return _this;
  }
  floatingToolbar_createClass(FloatingToolbarComponent, [{
    key: "getItems",
    value: function getItems() {
      var _selectedBlock$0$map;
      var i18n = this.props.i18n;
      var color = this.props.formats && this.props.formats['color'];
      var highlight = this.props.formats && this.props.formats['background'];
      if (typeof color !== 'string') {
        color = false;
      }
      if (typeof highlight !== 'string') {
        highlight = false;
      }
      var _ref2 = this.props.editor || {},
        options = _ref2.options;
      var _ref3 = options && options.blots && options.blots.button || {},
        _ref3$showButtonForma = _ref3.showButtonFormat,
        showButtonFormat = _ref3$showButtonForma === void 0 ? true : _ref3$showButtonForma;
      var selectedBlock = this.props.editor.scroll.getSelectedBlocks();
      var isTable = selectedBlock.length === 1 && ((_selectedBlock$0$map = selectedBlock[0].map) === null || _selectedBlock$0$map === void 0 ? void 0 : _selectedBlock$0$map.get('type')) === 'table';
      var menuItems = [{
        id: 'bold',
        fn: this.onClickBold,
        title: i18n.get('floating_toolbar.bold'),
        selected: this.props.formats && this.props.formats['bold'] ? true : false,
        hint: browser/* modKey */.CF + '+b',
        Icon: icons/* IconBold */.lM8,
        ref: this.onBoldIconRef,
        disabled: this.props.allowedStyles.indexOf('bold') < 0,
        tooltip: true
      }, {
        id: 'italic',
        fn: this.onClickItalic,
        title: i18n.get('floating_toolbar.italic'),
        selected: this.props.formats && this.props.formats['italic'] ? true : false,
        hint: browser/* modKey */.CF + '+i',
        Icon: icons/* IconItalic */.C9_,
        ref: this.onItalicIconRef,
        disabled: this.props.allowedStyles.indexOf('italic') < 0,
        tooltip: true
      }, {
        id: 'underline',
        fn: this.onClickUnderline,
        title: i18n.get('floating_toolbar.underline'),
        selected: this.props.formats && this.props.formats['underline'] ? true : false,
        hint: browser/* modKey */.CF + '+u',
        Icon: icons/* IconUnderline */.xxo,
        ref: this.onUnderlineIconRef,
        disabled: this.props.allowedStyles.indexOf('underline') < 0,
        tooltip: true
      }, {
        id: 'strikethrough',
        fn: this.onClickStrikethrough,
        title: i18n.get('floating_toolbar.strikethrough'),
        selected: this.props.formats && this.props.formats['strikethrough'] ? true : false,
        hint: browser/* modKey */.CF + '+shift' + '+s',
        Icon: icons/* IconStrikethrough */.dZu,
        ref: this.onStrikethroughIconRef,
        disabled: this.props.allowedStyles.indexOf('strikethrough') < 0,
        tooltip: true
      }, {
        id: 'clear-formatting',
        fn: this.onClearFormats,
        title: i18n.get('floating_toolbar.clear'),
        selected: false,
        hint: browser/* modKey */.CF + '+/',
        Icon: icons/* IconClearFormatting */.SnY,
        ref: this.onClearFormattingRef,
        tooltip: true
      }];
      if (this.props.showAIBtn && !isTable) {
        menuItems.unshift({
          id: 'nimbusAi',
          fn: this.onClickUseAI,
          title: i18n.get('empty_features.use_ai'),
          selected: false,
          hint: false,
          Icon: function Icon() {
            return (0,preact_module.h)("div", null, (0,preact_module.h)(icons/* IconPromtIcon */.nST, null), " ", (0,preact_module.h)("span", null, "Use AI"));
          },
          ref: this.onAIIconRef,
          disabled: !this.props.isUseAiSupported,
          tooltip: true
        });
      }
      var formatKeysInRange = this.props.getFormatKeysInRange();
      if (formatKeysInRange.every(function (f) {
        return !f.startsWith('comment-');
      })) {
        menuItems.push({
          id: 'placeholder',
          fn: this.onClickPlaceholder,
          title: i18n.get('floating_toolbar.placeholder'),
          selected: this.props.formats && this.props.formats['placeholder'] ? true : false,
          hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+p',
          Icon: icons/* IconPlaceholder */.bzs,
          ref: this.onPlaceholderIconRef,
          disabled: this.props.allowedStyles.indexOf('placeholder') < 0,
          tooltip: true
        });
      }
      menuItems.push.apply(menuItems, [{
        id: 'code',
        fn: this.onClickCode,
        title: i18n.get('floating_toolbar.code'),
        selected: this.props.formats && this.props.formats['code'] ? true : false,
        hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+e',
        Icon: icons/* IconCode */.seM,
        ref: this.onCodeIconRef,
        disabled: this.props.allowedStyles.indexOf('code') < 0,
        tooltip: true
      }].concat(floatingToolbar_toConsumableArray(showButtonFormat ? [{
        id: 'button',
        fn: this.onClickButton,
        title: i18n.get('floating_toolbar.button'),
        selected: this.props.formats && this.props.formats['button'] ? true : false,
        hint: false,
        Icon: icons/* IconButton */.hU,
        ref: this.onButtonIconRef,
        disabled: this.props.allowedStyles.indexOf('button') < 0,
        tooltip: true
      }] : []), [{
        id: 'link',
        fn: this.onClickLink,
        title: i18n.get('floating_toolbar.link'),
        selected: this.props.formats && this.props.formats['link'] ? true : false,
        hint: browser/* modKey */.CF + '+k',
        Icon: icons/* IconLink */.JHz,
        ref: this.onLinkIconRef,
        disabled: this.props.allowedStyles.indexOf('link') < 0,
        tooltip: true
      }, {
        id: 'highlight',
        fn: this.onClickHighlight,
        title: i18n.get('floating_toolbar.highlight'),
        selected: this.props.formats && this.props.formats['background'] ? true : false,
        hint: browser/* modKey */.CF + '+' + browser/* optionKey */.$d + '+h',
        Icon: icons/* IconHighlight */.NDg,
        ref: this.onHighlightIconRef,
        disabled: this.props.allowedStyles.indexOf('background') < 0,
        tooltip: true
      }, {
        id: 'color',
        fn: this.onClickColor,
        title: i18n.get('floating_toolbar.color'),
        selected: this.props.formats && this.props.formats['color'] ? true : false,
        hint: false,
        Icon: function Icon() {
          var backgroundClass = '';
          var defaultColor = false;
          var labelStyles = {};
          var styles = {};
          if (color) {
            if (stringIsColor(color)) {
              labelStyles.color = color;
            } else {
              backgroundClass = color + '-color';
              backgroundClass += ' bg-material-font-color-' + color;
            }
          } else if (highlight) {
            if (stringIsColor(highlight)) {
              styles.backgroundColor = highlight;
            } else {
              backgroundClass = highlight + '-highlight';
            }
          } else {
            backgroundClass = 'default-theme-color';
            defaultColor = true;
          }
          return (0,preact_module.h)("div", {
            className: 'floating-toolbar-color-icon ' + backgroundClass,
            "data-block-background": highlight,
            style: styles
          }, defaultColor ? (0,preact_module.h)(icons/* IconDefaultColor */.eOv, null) : (0,preact_module.h)("span", {
            className: "color-icon-label",
            style: labelStyles
          }, "A"));
        },
        ref: this.onColorIconRef,
        disabled: this.props.allowedStyles.indexOf('color') < 0,
        tooltip: true
      }]));
      if (this.props.inlineCommentsEnabled && formatKeysInRange.every(function (f) {
        return !DISABLE_COMMENT_FOR_FORMATS.includes(f);
      }) && this.props.allowedStyles.indexOf('comment') > 0) {
        menuItems.push({
          id: 'comment',
          fn: this.onClickComment,
          title: i18n.get('floating_toolbar.add_comment'),
          selected: false,
          hint: false,
          Icon: icons/* IconAddComment */.CZw,
          ref: this.onCommentIconRef,
          tooltip: true
        });
      }
      if (this.props.getCreateNoteMentionDetails && this.props.getCreateNoteMentionDetails()) {
        // показываем кнопку Создать закладку в зависимости от настроек
        if (!this.props.editor.options.disableAddNote) {
          menuItems.push({
            id: 'create-note',
            fn: this.onClickCreateNote,
            title: i18n.get('floating_toolbar.create_note'),
            selected: false,
            hint: false,
            Icon: icons/* IconCreateNote */.uyk,
            ref: this.onCreateNoteRef,
            tooltip: true
          });
        }
      }
      return this.props.filterMenuItems(menuItems);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var items = this.getItems();
      if (!items.length) return;
      var colorPicker = this.state.colorPicker;
      var _this$props = this.props,
        editor = _this$props.editor,
        i18n = _this$props.i18n,
        theme = _this$props.theme;
      var picker = null;
      var selectedColor = null;
      //если нет в форматах цвета текста то выделен в пикере должен быть черный,
      //если есть и цвет текста один и тот же то выделен цвет, если цветов несколько то ничего не должно быть выделено
      if (this.props.formats) {
        if (this.props.formats['color']) {
          if (typeof this.props.formats['color'] == 'string') {
            selectedColor = getMaterialColorName(this.props.formats['color']);
          }
        } else {
          selectedColor = this.props.defaultTextColor;
        }
      }
      //тоже самое с хайлайтами, только если нет бэкграунда то ничего не должно быть выделено так же как и с несколькими бэкграундами
      var selectedHighlight = null;
      if (this.props.formats) {
        if (this.props.formats['background']) {
          if (typeof this.props.formats['background'] == 'string') {
            selectedHighlight = getMaterialColorName(this.props.formats['background']);
          }
        } else {
          selectedHighlight = false;
        }
      }
      if (colorPicker) {
        var noFontColorIcon = (0,preact_module.h)("div", {
          onClick: function onClick(event) {
            _this2.onColorChoosen(false);
          },
          className: 'color-menu-item default-color-item' + (!selectedColor ? ' active' : '')
        }, (0,preact_module.h)("div", {
          className: "color-icon"
        }, (0,preact_module.h)(icons/* IconDefaultColor */.eOv, null)));
        var textColorItems = floatingToolbar_textColors.map(function (colorName) {
          return (0,preact_module.h)(PopupColorItem, {
            idAttr: floatingToolbar_COLOR_ATTR,
            key: colorName,
            onClick: function onClick() {
              _this2.onColorChoosen(colorName !== _this2.props.defaultTextColor ? colorName : false);
            },
            colorName: colorName,
            mode: 'mat-font-color',
            selected: selectedColor === colorName,
            useNewIcons: true
          });
        });
        textColorItems.splice(textColorItems.length - 1, 0, noFontColorIcon);
        picker = (0,preact_module.h)(popupMenu/* default */.Z, {
          addClassName: 'floating-toolbar-color-picker with-highlights ' + 'theme-' + theme,
          wantsToClose: this.onColorPickerWantsToClose,
          anchorNode: this.floatingToolbarNode,
          anchorOptions: {
            offset: '0, 3px',
            behavior: ['right', 'bottom', 'top'],
            priority: ['bottom', 'top', 'right', 'left']
          },
          key: "color-picker",
          domRef: this.onColorPickerRef
        }, (0,preact_module.h)("div", {
          className: "floating-toolbar-color-picker-label no-margin-top"
        }, (0,preact_module.h)("span", null, i18n.get('floating_toolbar.text')), (0,preact_module.h)("span", {
          className: "clear-all",
          onClick: this.onClearAllChoosen
        }, i18n.get('floating_toolbar.clear_all'))), textColorItems, (0,preact_module.h)("div", {
          className: "floating-toolbar-color-picker-label"
        }, i18n.get('floating_toolbar.highlight')), [].concat(floatingToolbar_toConsumableArray(matColorNames), floatingToolbar_toConsumableArray(additionalColorNames)).map(function (colorName) {
          return (0,preact_module.h)(PopupColorItem, {
            idAttr: floatingToolbar_COLOR_ATTR,
            key: colorName + '-highlight',
            onClick: function onClick() {
              _this2.onHighlightChoosen(colorName);
            },
            colorName: colorName,
            selected: selectedHighlight === colorName,
            mode: 'highlight',
            useNewIcons: true
          });
        }), (0,preact_module.h)("div", {
          className: "floating-toolbar-color-picker-label"
        }, i18n.get('floating_toolbar.extraHighlight')), matHighlightNames.map(function (hlName) {
          return (0,preact_module.h)(PopupColorItem, {
            idAttr: floatingToolbar_COLOR_ATTR,
            key: hlName + '-highlight',
            onClick: function onClick() {
              _this2.onHighlightChoosen(hlName);
            },
            colorValue: hlName,
            colorName: hlName,
            selected: selectedHighlight === hlName,
            mode: 'highlight',
            useNewIcons: true
          });
        }));
      }
      return (0,preact_module.h)(popupMenu/* default */.Z, {
        key: "floating-toolbar",
        domRef: this.onFloatingToolbarRef,
        onMouseDown: this.onMouseDown,
        addClassName: 'floating-toolbar',
        wantsToClose: this.props.wantsToClose,
        closeOnEsc: true
      }, items.map(function (_ref4) {
        var id = _ref4.id,
          Icon = _ref4.Icon,
          hint = _ref4.hint,
          title = _ref4.title,
          fn = _ref4.fn,
          selected = _ref4.selected,
          ref = _ref4.ref,
          disabled = _ref4.disabled,
          tooltip = _ref4.tooltip;
        var attrs = floatingToolbar_defineProperty({}, floatingToolbar_ID_ATTR, id);
        if (tooltip) {
          attrs[tooltipManager/* TOOLTIP_ATTR */.qZ] = title, attrs[tooltipManager/* TOOLTIP_SMALL_ATTR */.BY] = hint;
        }
        return (0,preact_module.h)("div", floatingToolbar_extends({}, attrs, {
          className: 'icon ' + (selected && !disabled ? 'active' : '') + (disabled ? 'disabled' : ''),
          onClick: disabled ? function () {} : fn,
          ref: ref
        }), (0,preact_module.h)(Icon, null));
      }), (0,preact_module.h)(preact_transition_group/* default */.Z, {
        transitionName: "color-picker",
        transitionEnterTimeout: colorPickerAppearDuration,
        transitionLeaveTimeout: colorPickerAppearDuration
      }, picker));
    }
  }]);
  return FloatingToolbarComponent;
}(preact_module/* Component */.wA);
var FloatingToolbar = /*#__PURE__*/function () {
  function FloatingToolbar(_ref5) {
    var _this3 = this;
    var scroll = _ref5.scroll,
      editor = _ref5.editor,
      options = _ref5.options;
    floatingToolbar_classCallCheck(this, FloatingToolbar);
    floatingToolbar_defineProperty(this, "onCreateToolbar", function (toolbarComponent) {
      _this3.toolbarComponent = toolbarComponent;
    });
    floatingToolbar_defineProperty(this, "onSelectionChangeDebounce", lodash_debounce_default()(function () {
      _this3.onSelectionChange();
    }, 10, {
      trailing: true
    }));
    floatingToolbar_defineProperty(this, "onDocumentMouseDown", function (_ref6) {
      var clientX = _ref6.clientX,
        clientY = _ref6.clientY,
        target = _ref6.target;
      if (target === _this3.container) return;
      _this3.mouseDownPosition = {
        x: clientX,
        y: clientY
      };
    });
    floatingToolbar_defineProperty(this, "onDocumentMouseMove", function (_ref7) {
      var clientX = _ref7.clientX,
        clientY = _ref7.clientY;
      if (!_this3.mouseDownPosition) {
        return;
      }
      var nowPosition = {
        x: clientX,
        y: clientY
      };
      if (math_distance(nowPosition, _this3.mouseDownPosition) >= MOUSE_DRAGGING_TRIGGER_DISTANCE) {
        _this3.ignoreSelectionChangeUpdates = true;
        _this3.hide();
        _this3.mouseDownPosition = null;
      }
    });
    floatingToolbar_defineProperty(this, "onDocumentMouseUp", function () {
      if (_this3.ignoreSelectionChangeUpdates) {
        _this3.ignoreSelectionChangeUpdates = false;
        _this3.onSelectionChange();
      } else {
        _this3.mouseDownPosition = null;
      }
    });
    floatingToolbar_defineProperty(this, "onCreateToolbar", function (toolbarComponent) {
      _this3.toolbarComponent = toolbarComponent;
    });
    floatingToolbar_defineProperty(this, "onSelectionChange", function () {
      if (_this3.ignoreSelectionChangeUpdates) return;
      if (_this3.editor.plugins.aiManager && _this3.editor.plugins.aiManager.isVisible) return;
      _this3.adjustPositionContinuously(true);
      var _this3$scroll$selecti = _this3.scroll.selection.getRange(),
        _this3$scroll$selecti2 = floatingToolbar_slicedToArray(_this3$scroll$selecti, 2),
        range = _this3$scroll$selecti2[0],
        native = _this3$scroll$selecti2[1];
      _this3.lastNativeRange = native && native.native;
      if (_this3.range !== range) {
        var oldRange = _this3.range;
        _this3.range = range;
        if (range && range.length > 0) {
          var formatDetails = _this3.getSelectionFormatsDetails();
          if (formatDetails) {
            var textBlotsInRange = formatDetails.textBlotsInRange,
              formats = formatDetails.formats,
              allowedStyles = formatDetails.allowedStyles,
              defaultTextColor = formatDetails.defaultTextColor;
            //присваиваем первый текстовый блот, для дальнейшего его использования в позиционировании тулбара
            _this3.anchorBlot = textBlotsInRange[0];
            //нужно так же присвоить последний выделенный блок для позиционирования если контейнер тулбара не влазит в границы редактора
            _this3.lastTextBlot = textBlotsInRange[textBlotsInRange.length - 1];
            _this3.show({
              formats: formats,
              allowedStyles: allowedStyles,
              defaultTextColor: defaultTextColor
            });
          }
        } else {
          _this3.hide();
        }
      } else {
        _this3.hide();
      }
    });
    floatingToolbar_defineProperty(this, "onHandlerHide", function () {
      _this3.hide();
    });
    floatingToolbar_defineProperty(this, "formatText", function (params) {
      _this3.editor.exec('format', params);
    });
    floatingToolbar_defineProperty(this, "onClickComment", function () {
      onClickComment(_this3.editor);
    });
    floatingToolbar_defineProperty(this, "onClickUseAI", function () {
      _this3.showAIMenu = true;
      if (_this3.showTimer) {
        clearTimeout(_this3.showTimer);
      }
      var container = _this3.container;
      _this3.toolbarComponent = null;
      _this3.adjustPositionContinuously(true);
      _this3.render(container);
    });
    floatingToolbar_defineProperty(this, "showAIPrompt", function (action) {
      var params = {
        action: action,
        context: '',
        offset: _this3.promtOffset,
        blots: [],
        range: _this3.scroll.selection.getRange()[0]
      };
      params.context = _this3.scroll.getSelectedContentsAsMarkdown();
      var blotsInRange = _this3.scroll.getSelectedBlocks();
      var _iterator3 = floatingToolbar_createForOfIteratorHelper(blotsInRange),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var blot = _step3.value;
          var _this3$scroll$selecti3 = _this3.scroll.selection.getRange({
              offsetBlot: blot
            })[0],
            index = _this3$scroll$selecti3.index,
            length = _this3$scroll$selecti3.length;
          var item = {};
          item[blot.id] = {
            index: index,
            length: length
          };
          params.blots.push(item);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      _this3.editor.plugins.aiManager.show(_this3.lastTextBlot || blotsInRange[0], {
        type: 'range',
        options: params
      });
      _this3.hide();
    });
    floatingToolbar_defineProperty(this, "getFormatKeysInRange", function () {
      var _this3$scroll$selecti4 = _this3.scroll.selection.getRange(),
        _this3$scroll$selecti5 = floatingToolbar_slicedToArray(_this3$scroll$selecti4, 1),
        range = _this3$scroll$selecti5[0];
      if (!range) return [];
      return _this3.scroll.descendants((parchment_default()).Inline, range.index, range.length).reduce(function (formats, blot) {
        return [].concat(floatingToolbar_toConsumableArray(formats), floatingToolbar_toConsumableArray(Object.keys(blot.formats())));
      }, []);
    });
    floatingToolbar_defineProperty(this, "clearFormats", function () {
      _this3.editor.exec('clear-formatting');
    });
    floatingToolbar_defineProperty(this, "addButton", function () {
      addLinkAction(_this3.editor, {}, 'addButton', 'editButton');
    });
    floatingToolbar_defineProperty(this, "addLink", function (event) {
      addLinkAction(_this3.editor);
    });
    floatingToolbar_defineProperty(this, "saveColor", function (color) {
      if (!color) {
        _this3.savedColor = DEFAULT_COLOR;
      } else {
        _this3.savedColor = color;
      }
    });
    floatingToolbar_defineProperty(this, "saveHighlight", function (colorName) {
      if (!colorName) {
        _this3.savedHighlight = DEFAULT_HIGHLIGHT;
      } else {
        _this3.savedHighlight = colorName;
      }
    });
    floatingToolbar_defineProperty(this, "clearHighlight", function () {
      _this3.editor.exec('format', {
        style: 'background',
        value: false
      });
    });
    floatingToolbar_defineProperty(this, "applyHighlight", function () {
      _this3.editor.exec('format', {
        style: 'background',
        value: _this3.savedHighlight
      });
    });
    floatingToolbar_defineProperty(this, "getCreateNoteMentionDetails", function () {
      var formatDetails = _this3.getSelectionFormatsDetails();
      if (!formatDetails) return null;
      var blots = formatDetails.textBlotsInRange;
      if (blots.length !== 1) return null;
      var _iterator4 = floatingToolbar_createForOfIteratorHelper(blots),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _blot = _step4.value;
          if (_blot && _blot.disableAddNote) {
            return null;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      var _blots = floatingToolbar_slicedToArray(blots, 1),
        blot = _blots[0];
      var _this3$scroll$selecti6 = _this3.scroll.selection.getRange({
          offsetBlot: blot
        }),
        _this3$scroll$selecti7 = floatingToolbar_slicedToArray(_this3$scroll$selecti6, 1),
        blotRange = _this3$scroll$selecti7[0];
      // тут чекаем есть ли ментионы в выделени, возможно передаваемое условие нужно будет поменять в будущем,
      // но сейчас от Parchment.Embed в тексте наследуются только Mention и Date
      var embedsInRange = blot.descendants((parchment_default()).Embed, blotRange.index, blotRange.length).length;
      if (embedsInRange) return null;
      return {
        blot: blot,
        index: blotRange.index,
        length: blotRange.length
      };
    });
    floatingToolbar_defineProperty(this, "createNoteMention", /*#__PURE__*/floatingToolbar_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var onErrorMessage, params, blot, index, length, name, mentionData, insertOp;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              onErrorMessage = function onErrorMessage() {
                console.error('Failed to create note mention.');
              };
              params = _this3.getCreateNoteMentionDetails();
              if (params) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return", onErrorMessage());
            case 4:
              blot = params.blot, index = params.index, length = params.length;
              name = blot.getText(index, length);
              _context.next = 8;
              return _this3.editor.plugins.mentionManager.createAndResolveNote(name);
            case 8:
              mentionData = _context.sent;
              if (mentionData) {
                _context.next = 12;
                break;
              }
              // error should have been handled on the client side
              // set caret to the end of the text
              _this3.scroll.selection.setRange({
                index: blot.offset(_this3.scroll) + index + length,
                length: 0
              });
              return _context.abrupt("return", onErrorMessage());
            case 12:
              insertOp = {
                insert: {
                  mention: {
                    type: 'note',
                    object_id: mentionData.object_id,
                    name: mentionData.name || name,
                    id: generateMentionId()
                  }
                }
              };
              if (mentionData.workspace_id) {
                insertOp.insert.mention.workspace_id = mentionData.workspace_id;
              }
              blot.applyForCharacters([{
                retain: index
              }, {
                delete: length
              }, insertOp]);
              _this3.scroll.selection.setRange({
                index: blot.offset(_this3.scroll) + index + 1,
                length: 0
              });
            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    floatingToolbar_defineProperty(this, "filterMenuItems", function (items) {
      if (_this3.editor.mode !== MODE_EDIT && _this3.options.hasOwnProperty('showItems') && _this3.options.showItems.length) {
        return items.filter(function (item) {
          return _this3.options.showItems.includes(item.id);
        });
      }
      return items;
    });
    options = Object.assign({
      enabled: editor.mode !== MODE_EDIT ? Boolean(options && options.hasOwnProperty('enabled') && options.enabled) : true
    }, options);
    this.enabled = options.enabled;
    this.scroll = scroll;
    this.editor = editor;
    this.container = null;
    this.anchorBlot = null;
    this.emitter = this.editor.emitter;
    this.range = null;
    this.showTimer = null;
    this.visible = false;
    this.allowFlip = true;
    this.adjustPositionAnimationFrameRequest = null;
    this.lastNativeRange = null;
    this.savedColor = DEFAULT_COLOR;
    this.savedHighlight = DEFAULT_HIGHLIGHT;
    this.scrollingContainer = this.editor.scrollingContainer;
    this.options = options;
    this.showAIMenu = false;
    this.init();
  }
  floatingToolbar_createClass(FloatingToolbar, [{
    key: "promtOffset",
    get: function get() {
      var selectionRects = Array.from(this.lastNativeRange.getClientRects());
      var endSelectionRect = selectionRects.pop();
      if (this.lastTextBlot && endSelectionRect) {
        var lastBlotRect = this.lastTextBlot.domNode.getBoundingClientRect();
        var offsetTop = endSelectionRect.y + endSelectionRect.height - lastBlotRect.y;
        var offsetLeft = endSelectionRect.x + endSelectionRect.width - lastBlotRect.x;
        return {
          left: offsetLeft,
          top: offsetTop
        };
      }
      return null;
    }
  }, {
    key: "init",
    value: function init() {
      var _this4 = this;
      if (!this.enabled) {
        return;
      }
      this.emitter.on('selectionchange', this.onSelectionChangeDebounce);
      this.emitter.on('start-dragging', this.onHandlerHide);
      this.emitter.on('block-menu-open', function () {
        _this4.hide();
      });
      this.emitter.on('block-menu-close', function () {
        _this4.onSelectionChange();
      });
      this.emitter.on('set-theme', function () {
        _this4.onSelectionChange();
      });
      // вынес из show сюда, чтобы сразу повесить слушатель драггинга,
      // иначе при первом рендере возникал баг
      this.container = document.createElement('div');
      this.container.classList.add('floating-toolbar-container');
      this.editor.scrollingContainer.appendChild(this.container);
      this.render(this.container);
      document.addEventListener('mousedown', this.onDocumentMouseDown, false);
      document.addEventListener('mousemove', this.onDocumentMouseMove, false);
      document.addEventListener('mouseup', this.onDocumentMouseUp, false);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.emitter.off('selectionchange', this.onSelectionChangeDebounce);
      this.emitter.off('start-dragging', this.onHandlerHide);
      document.removeEventListener('mousedown', this.onDocumentMouseDown, false);
      document.removeEventListener('mousemove', this.onDocumentMouseMove, false);
      document.removeEventListener('mouseup', this.onDocumentMouseUp, false);
    }
  }, {
    key: "adjustPositionContinuously",
    value: function adjustPositionContinuously() {
      var _this5 = this;
      var clear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var adjust = function adjust() {
        if (!_this5.anchorBlot) {
          _this5.hide();
          return;
        }
        if (!_this5.anchorBlot.domNode.parentNode) {
          _this5.hide();
          return;
        }
        if (!_this5.container) {
          _this5.hide();
          return;
        }
        //проверяем есть ли на данный момент выделение в редакторе, из за бага, при котором иногда тулбар не прячется после снятия выделения
        var _this5$scroll$selecti = _this5.scroll.selection.getRange(),
          _this5$scroll$selecti2 = floatingToolbar_slicedToArray(_this5$scroll$selecti, 1),
          range = _this5$scroll$selecti2[0];
        if ((!range || range.length === 0) && _this5.visible) {
          _this5.hide();
          return;
        }
        _this5.adjustPosition();
        _this5.adjustPositionAnimationFrameRequest = requestAnimationFrame(adjust);
      };
      if (clear) {
        if (this.adjustPositionAnimationFrameRequest) {
          cancelAnimationFrame(this.adjustPositionAnimationFrameRequest);
        }
      } else {
        adjust();
      }
    }
  }, {
    key: "adjustPosition",
    value: function adjustPosition() {
      if (!this.lastNativeRange) {
        return;
      }
      //получаем необходимые координаты и размеры для позиционирования тулбара
      var blotRect = this.anchorBlot.domNode.getBoundingClientRect();
      var blotScroll = {
        y: this.anchorBlot.domNode.scrollTop
        //x: this.anchorBlot.domNode.scrollLeft,
      };

      var scrollingContainerRect = this.scrollingContainer.getBoundingClientRect();
      var _this$container$getBo = this.container.getBoundingClientRect(),
        width = _this$container$getBo.width;
      //тут получаем массив координат выделения в блоках
      var selectionRects = Array.from(this.lastNativeRange.getClientRects());
      //получаем первое значение из массива координат
      var startSelectionRect = selectionRects.shift();
      var endSelectionRect = selectionRects.pop() || startSelectionRect;
      if (!startSelectionRect) {
        return;
      }
      //
      var offsetBetweenEditorAndScroll = this.scrollingContainer !== this.editor.scrollingContainer && getContainerOffset(this.editor.scrollingContainer, this.scrollingContainer) || {
        x: 0,
        y: 0
      };
      //если возникла ситуация когда начало выделения находится выше чем реальное выеделение текста,
      //нужно получить начало видимого выделения текста, для которого используем координаты this.anchorBlot'a
      while (blotRect.y > startSelectionRect.y && selectionRects.length !== 0) {
        startSelectionRect = selectionRects.shift();
      }
      var offsetX = startSelectionRect.x - blotRect.x;
      var offsetY = startSelectionRect.y - blotRect.y;
      var blotOffset = getContainerOffset(this.anchorBlot.domNode, this.scrollingContainer);
      var additionalOffsetY = 15;
      //нужно вычислить, будет ли влазить отрендерный тулбар в границы редактора
      //(пока не учитываем нижнюю границу, даже если выделить весь контент, когда под последним блоком нет места и тулбар отрендерится снизу, редактор добавит скролл и тулбар будет доступен)
      var topPos = Math.ceil(blotOffset.y + offsetY + blotScroll.y - offsetBetweenEditorAndScroll.y - floatingToolbarHeight - additionalOffsetY);
      var leftPos = blotOffset.x + offsetX;
      //получаем позицию сверху с учетом скролла, если она меньше нуля, тулбар нужно рендерить снизу
      var renderOnBottom = false;
      if (topPos - this.scrollingContainer.scrollTop < 0) {
        if (this.lastTextBlot) {
          renderOnBottom = true;
          var lastBlotRect = this.lastTextBlot.domNode.getBoundingClientRect();
          var lastBlotOffset = getContainerOffset(this.lastTextBlot.domNode, this.editor.scrollingContainer);
          offsetY = endSelectionRect.y - lastBlotRect.y;
          topPos = Math.ceil(lastBlotOffset.y + offsetY + endSelectionRect.height + additionalOffsetY);
          leftPos = lastBlotOffset.x + endSelectionRect.x - lastBlotRect.x;
          if (endSelectionRect.width > width) {
            leftPos += endSelectionRect.width - width;
          }
        }
      }
      if (renderOnBottom) {
        if (scrollingContainerRect.x + scrollingContainerRect.width - endSelectionRect.x < width) {
          leftPos -= width - (scrollingContainerRect.x + scrollingContainerRect.width - endSelectionRect.x) + this.editor.scrollbarWidth;
        }
      } else {
        if (scrollingContainerRect.x + scrollingContainerRect.width - startSelectionRect.x < width) {
          leftPos -= width - (scrollingContainerRect.x + scrollingContainerRect.width - startSelectionRect.x) + this.editor.scrollbarWidth;
        }
      }
      var editorScale = this.editor.options.scale;
      var correctedLeftPos = editorScale !== undefined && editorScale !== 0 ? leftPos / editorScale : leftPos;
      this.container.style.top = topPos + 'px';
      this.container.style.left = correctedLeftPos + 'px';
    }
  }, {
    key: "getRangeFormats",
    value: function getRangeFormats(textBlotsInRange) {
      var _this6 = this;
      var formats = {};
      textBlotsInRange.map(function (blot, index) {
        var _this6$scroll$selecti = _this6.scroll.selection.getRange({
            offsetBlot: blot
          }),
          _this6$scroll$selecti2 = floatingToolbar_slicedToArray(_this6$scroll$selecti, 1),
          blotRange = _this6$scroll$selecti2[0];
        var blotFormats = blot.getFormat(blotRange.index, blotRange.length);
        if (index === 0) {
          formats = blotFormats;
        } else {
          Object.keys(formats).map(function (format) {
            if (!blotFormats[format]) {
              delete formats[format];
            }
          });
        }
      });
      return formats;
    }

    // TODO вынести эту функцию в более общее место, т.к. она используется и мобильным редактором
    // для опеределения активных форматов
  }, {
    key: "getSelectionFormatsDetails",
    value: function getSelectionFormatsDetails() {
      var _this7 = this;
      var _this$scroll$selectio = this.scroll.selection.getRange(),
        _this$scroll$selectio2 = floatingToolbar_slicedToArray(_this$scroll$selectio, 2),
        range = _this$scroll$selectio2[0],
        native = _this$scroll$selectio2[1];
      if (!range || range.length === 0) {
        return null;
      }
      var blotsInRange = this.scroll.selection.getBlotsInRange(native);
      // не отображаем тулбар для выделенных InlineEmbed блотов
      if (blotsInRange.filter(function (b) {
        return INLINE_EMBED_BLOTS.includes(b.constructor.blotName) && !SHOW_TOOLBAR_FOR_SELECTED_EMBED.includes(b.constructor.blotName);
      }).length) {
        return null;
      }
      var textBlotsInRange = blotsInRange.map(function (blot) {
        //получаем родительские текстовые блоки
        var textBaseBlot = findWithClass(blot, textBase);
        var textBlotBlot = findWithClass(blot, newTextLine);
        if (textBaseBlot) {
          return textBaseBlot;
        } else if (textBlotBlot) {
          return textBlotBlot;
        }
      }).filter(function (blot) {
        //отсеиваем null из массива
        return blot !== null && typeof blot !== 'undefined';
      }).filter(function (blot, index, array) {
        //получаем только уникальные значения
        return array.indexOf(blot) === index;
      }).filter(function (blot) {
        //фильтр служит для того чтобы отсеять текстовые блоки в которых ничего не выделено,
        //такое может быть когда даблкликнуть справа от блока, в таком случае length у range будет 1,
        //из за того что каретка одновременно "как бы" находится в конце текущего блока и в начале следующего,
        //но по факту выделения текста нет. Так же это отсеет блоки когда мы начинаем выделять текст
        //поставив каретку в конец блока и либо клавишами либо мышью выделяем текст следующего блока,
        //в таком случае блок в конце которого стояла каретка так же попадает в массив выделения,
        //но по факту там ничего не выделено
        var _this7$scroll$selecti = _this7.scroll.selection.getRange({
            offsetBlot: blot
          }),
          _this7$scroll$selecti2 = floatingToolbar_slicedToArray(_this7$scroll$selecti, 1),
          blotRange = _this7$scroll$selecti2[0];
        return blotRange.length !== 0;
      });
      var disabled = textBlotsInRange.some(function (blot) {
        var targetBlot = blot.isNotIndependent ? blot.parent : blot;
        return targetBlot.floatingToolbarDisabled ? true : false;
      });
      if (disabled) textBlotsInRange = [];
      if (textBlotsInRange.length === 0) {
        return null;
      }
      var formats = this.getRangeFormats(textBlotsInRange);
      var allowedStyles = floatingToolbar_FORMAT_STYLES;
      var defaultTextColor = false;
      if (textBlotsInRange.length === 1) {
        if (textBlotsInRange[0].getAllowedStyles) {
          allowedStyles = textBlotsInRange[0].getAllowedStyles();
        }
        if (textBlotsInRange[0].getDefaultTextColor) {
          defaultTextColor = textBlotsInRange[0].getDefaultTextColor();
        }
      }
      if (formats['link']) {
        allowedStyles = allowedStyles.filter(function (style) {
          return style !== 'underline';
        });
      }
      if (!Button.isAbleToConvert(this.editor)) {
        allowedStyles = allowedStyles.filter(function (style) {
          return style !== 'button';
        });
      }
      if (!comment.isAllowToConvert(this.editor)) {
        allowedStyles = allowedStyles.filter(function (style) {
          return style !== 'comment';
        });
      }
      return {
        formats: formats,
        allowedStyles: allowedStyles,
        defaultTextColor: defaultTextColor,
        textBlotsInRange: textBlotsInRange
      };
    }
  }, {
    key: "render",
    value: function render(container) {
      var _this$editor$plugins$, _this$editor$plugins$2;
      var withMenu = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var props = arguments.length > 2 ? arguments[2] : undefined;
      var theme = this.editor.plugins.editorStyle.getTheme();
      var inlineCommentsEnabled = false;
      if (this.editor.plugins.commentManager) {
        inlineCommentsEnabled = this.editor.plugins.commentManager.options.inlineComments;
      }
      if (!container) return;
      (0,preact_module/* render */.sY)((0,preact_module.h)(preact_transition_group/* default */.Z, {
        transitionName: "floating-toolbar",
        transitionEnterTimeout: floatingToolbarAppearDuration,
        transitionLeaveTimeout: floatingToolbarAppearDuration
      }, this.showAIMenu ? (0,preact_module.h)(FloatingAIMenuComponent, {
        onCreateToolbar: this.onCreateToolbar,
        onClickHandler: this.showAIPrompt,
        theme: theme,
        i18n: this.editor.plugins.i18n,
        key: "ai-menu"
      }) : withMenu ? (0,preact_module.h)(FloatingToolbarComponent, floatingToolbar_extends({
        editor: this.editor,
        formatText: this.formatText,
        addButton: this.addButton,
        addLink: this.addLink,
        clearFormats: this.clearFormats,
        saveColor: this.saveColor,
        saveHighlight: this.saveHighlight,
        applyHighlight: this.applyHighlight,
        clearHighlight: this.clearHighlight,
        onCreateToolbar: this.onCreateToolbar,
        noColorTextColor: theme === 'light' && '#161616' || 'rgba(255, 255, 255, 0.87)',
        getCreateNoteMentionDetails: this.getCreateNoteMentionDetails,
        createNoteMention: this.createNoteMention,
        onClickComment: this.onClickComment,
        theme: theme,
        i18n: this.editor.plugins.i18n,
        key: "menu",
        options: this.options,
        wantsToClose: this.onHandlerHide,
        inlineCommentsEnabled: inlineCommentsEnabled,
        getFormatKeysInRange: this.getFormatKeysInRange,
        isUseAiSupported: ((_this$editor$plugins$ = this.editor.plugins.aiManager) === null || _this$editor$plugins$ === void 0 ? void 0 : _this$editor$plugins$.enabled) && !this.editor.plugins.aiManager.isRequestActive,
        showAIBtn: (_this$editor$plugins$2 = this.editor.plugins.aiManager) === null || _this$editor$plugins$2 === void 0 ? void 0 : _this$editor$plugins$2.enabled,
        onClickUseAI: this.onClickUseAI,
        filterMenuItems: this.filterMenuItems
      }, props)) : (0,preact_module.h)("span", {
        key: "menu"
      })), container);
    }
  }, {
    key: "show",
    value: function show() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      props = Object.assign(props);
      if (props.formats.color && this.savedColor !== props.formats.color) {
        this.saveColor(props.formats.color);
      }
      if (props.formats.background && this.savedHighlight !== props.formats.background) {
        this.saveHighlight(props.formats.background);
      }
      props.savedColor = this.savedColor;
      props.savedHighlight = this.savedHighlight;
      var container = this.container;
      this.showTimer = setTimeout(this.render.bind(this, container, true, props), 0);
      this.adjustPositionContinuously();
      this.visible = true;
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this.showTimer) {
        clearTimeout(this.showTimer);
      }
      var container = this.container;
      this.anchorBlot = null;
      this.lastTextBlot = null;
      this.toolbarComponent = null;
      this.adjustPositionContinuously(true);
      this.showAIMenu = false;
      this.render(container);
      this.visible = false;
    }
  }]);
  return FloatingToolbar;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/scrollSaver/index.js

function scrollSaver_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function scrollSaver_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function scrollSaver_createClass(Constructor, protoProps, staticProps) { if (protoProps) scrollSaver_defineProperties(Constructor.prototype, protoProps); if (staticProps) scrollSaver_defineProperties(Constructor, staticProps); return Constructor; }
function scrollSaver_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var SEARCH_OFFSET = 10;
var SAVE_TIMEOUT = 500;
var STORAGE_PREFIX = '_editor_scroll_saver:';
function getKey(key) {
  return STORAGE_PREFIX + key;
}
var ScrollSaver = /*#__PURE__*/function () {
  function ScrollSaver(_ref) {
    var _this = this;
    var scroll = _ref.scroll,
      editor = _ref.editor,
      options = _ref.options;
    scrollSaver_classCallCheck(this, ScrollSaver);
    scrollSaver_defineProperty(this, "onScroll", function (event) {
      var scrollingContainer = _this.getScrollingContainer();
      if (scrollingContainer.scrollTop === 0) {
        _this.removeId();
      } else {
        var _this$scroll$domNode$ = _this.scroll.domNode.getBoundingClientRect(),
          x = _this$scroll$domNode$.x;
        var _this$getScrollingCon = _this.getScrollingContainerBoundingClientRect(),
          y = _this$getScrollingCon.y;
        x += SEARCH_OFFSET;
        y += SEARCH_OFFSET;
        var node = document.elementFromPoint(x, y);
        while (node === _this.scroll.domNode) {
          y += 1;
          node = document.elementFromPoint(x, y);
        }
        var blot = getBlotForNode(node);
        if (blot instanceof list_list) {
          // если blot является списком, то находим первый видимый li
          var firstVisibleLi = null;
          node.querySelectorAll('li').forEach(function (li) {
            if (!firstVisibleLi) {
              if (li.offsetTop + node.offsetTop >= scrollingContainer.scrollTop) {
                firstVisibleLi = li;
              }
            }
          });
          if (firstVisibleLi) {
            blot = getBlotForNode(firstVisibleLi);
            _this.setId(blot.id);
          }
        } else {
          var upLvlBlot = searchUp(blot, function (blot) {
            return blot.parent === _this.scroll;
          });
          if (upLvlBlot) {
            _this.setId(upLvlBlot.id);
          }
        }
      }
    });
    scrollSaver_defineProperty(this, "onHighlightedNodeDocumentClick", function (event) {
      if (_this.highlightTimeout) {
        clearTimeout(_this.highlightTimeout);
        _this.highlightTimeout = null;
        var highlightedNode = _this.scroll.domNode.querySelector('.highlighted-block');
        if (highlightedNode) {
          highlightedNode.classList.remove('highlighted-block');
        }
      }
      document.removeEventListener('click', _this.onHighlightedNodeDocumentClick, false);
    });
    this.editor = editor;
    this.scroll = scroll;
    this.storage = localStorage;
    this.room = this.editor.room;
    this.options = options || {};
    this.onScrollDebounced = lodash_debounce_default()(this.onScroll, SAVE_TIMEOUT, {
      trailing: true
    });
    this.init();
  }
  scrollSaver_createClass(ScrollSaver, [{
    key: "init",
    value: function init() {
      var savedId = this.storage.getItem(getKey(this.room));
      if (savedId) {
        this.scrollToSavedId(savedId);
      }
      var listenScrollOn = this.getScrollingContainer();
      if (listenScrollOn === document.body || listenScrollOn === document.documentElement) {
        listenScrollOn = window;
      }
      listenScrollOn.addEventListener('scroll', this.onScrollDebounced);
    }
  }, {
    key: "getScrollingContainer",
    value: function getScrollingContainer() {
      return this.editor.getScrollingContainer();
    }
  }, {
    key: "getScrollingContainerBoundingClientRect",
    value: function getScrollingContainerBoundingClientRect() {
      var scrollingContainer = this.getScrollingContainer();
      var rect;
      if (scrollingContainer.tagName === 'BODY' || scrollingContainer.tagName === 'HTML') {
        // просто возвращаем размеры вьюпорта
        var width = window.innerWidth;
        var height = window.innerHeight;
        rect = {
          left: 0,
          right: width,
          top: 0,
          bottom: height,
          x: 0,
          y: 0,
          width: width,
          height: height
        };
      } else {
        rect = scrollingContainer.getBoundingClientRect();
      }
      return rect;
    }
  }, {
    key: "setId",
    value: function setId(id) {
      this.storage.setItem(getKey(this.room), id);
    }
  }, {
    key: "removeId",
    value: function removeId() {
      this.storage.removeItem(getKey(this.room));
    }
  }, {
    key: "scrollToSavedId",
    value: function scrollToSavedId(id) {
      var _this2 = this;
      this.editor.emitter.once('editor-ready', function () {
        _this2.scrollToBlot(id);
      });
    }
  }, {
    key: "scrollToBlot",
    value: function scrollToBlot(id) {
      var highlight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var smooth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var scrollingContainer = this.getScrollingContainer();
      var node = document.getElementById(id) || this.editor.scroll.domNode.querySelector(id);
      if (node) {
        var blot = getBlotForNode(node);
        if (blot.props.hidden && blot.onMustSetVisible) {
          blot.onMustSetVisible();
        }
        var blotWrapper = blot.getWrapper();
        var offset = this.options.addOffsetTop;
        (0,dom/* scrollToNode */.dp)(scrollingContainer, blotWrapper.domNode, highlight && {
          node: blotWrapper.domNode,
          highlightClass: 'highlighted-block',
          timeout: 3000
        } || false, smooth, offset);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var listenScrollOn = this.getScrollingContainer();
      if (listenScrollOn === document.body || listenScrollOn === document.documentElement) {
        listenScrollOn = window;
      }
      listenScrollOn.removeEventListener('scroll', this.onScrollDebounced);
    }
  }]);
  return ScrollSaver;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/linkManager/index.js
function linkManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function linkManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function linkManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) linkManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) linkManager_defineProperties(Constructor, staticProps); return Constructor; }
var LinkManager = /*#__PURE__*/function () {
  function LinkManager(_ref) {
    var editor = _ref.editor,
      scroll = _ref.scroll,
      options = _ref.options;
    linkManager_classCallCheck(this, LinkManager);
    this.editor = editor;
    this.scroll = scroll;
    this.options = options || {};
  }
  linkManager_createClass(LinkManager, [{
    key: "processNavigation",
    value: function processNavigation(url) {
      if (this.options.processNavigation) {
        return this.options.processNavigation(url);
      }
      return false;
    }
  }]);
  return LinkManager;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/search/searchPanel.js
function searchPanel_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { searchPanel_typeof = function _typeof(obj) { return typeof obj; }; } else { searchPanel_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return searchPanel_typeof(obj); }









function searchPanel_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function searchPanel_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function searchPanel_createClass(Constructor, protoProps, staticProps) { if (protoProps) searchPanel_defineProperties(Constructor.prototype, protoProps); if (staticProps) searchPanel_defineProperties(Constructor, staticProps); return Constructor; }
function searchPanel_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) searchPanel_setPrototypeOf(subClass, superClass); }
function searchPanel_setPrototypeOf(o, p) { searchPanel_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return searchPanel_setPrototypeOf(o, p); }
function searchPanel_createSuper(Derived) { var hasNativeReflectConstruct = searchPanel_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = searchPanel_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = searchPanel_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return searchPanel_possibleConstructorReturn(this, result); }; }
function searchPanel_possibleConstructorReturn(self, call) { if (call && (searchPanel_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return searchPanel_assertThisInitialized(self); }
function searchPanel_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function searchPanel_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function searchPanel_getPrototypeOf(o) { searchPanel_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return searchPanel_getPrototypeOf(o); }
function searchPanel_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var searchPanel_isEsc = (0,lib/* default */.ZP)('Esc');
var searchPanel_isEnter = (0,lib/* default */.ZP)('Enter');
function getInitState(props) {
  return {
    query: props.session.queryUninitialized || '',
    activeMatchIndex: -1,
    totalMatches: 0
  };
}
var SearchPanel = /*#__PURE__*/function (_Component) {
  searchPanel_inherits(SearchPanel, _Component);
  var _super = searchPanel_createSuper(SearchPanel);
  function SearchPanel(props) {
    var _this;
    searchPanel_classCallCheck(this, SearchPanel);
    _this = _super.call(this, props);
    searchPanel_defineProperty(searchPanel_assertThisInitialized(_this), "onSessionMark", function () {
      var session = _this.props.session;
      _this.setState(function () {
        return {
          totalMatches: session.markers.length
        };
      });
    });
    searchPanel_defineProperty(searchPanel_assertThisInitialized(_this), "onSessionHighlight", function (index) {
      _this.setState(function () {
        return {
          activeMatchIndex: index
        };
      });
    });
    searchPanel_defineProperty(searchPanel_assertThisInitialized(_this), "onInputDomNodeRef", function (node) {
      _this.inputDomNode = node;
    });
    searchPanel_defineProperty(searchPanel_assertThisInitialized(_this), "onChangeQuery", function (event) {
      var query = event.target.value;
      _this.setState(function () {
        return {
          query: query
        };
      }, function () {
        _this.props.onQueryChange(query);
      });
    });
    searchPanel_defineProperty(searchPanel_assertThisInitialized(_this), "onKeyDown", function (event) {
      if (searchPanel_isEsc(event)) {
        _this.props.wantsToClose();
      } else if (searchPanel_isEnter(event)) {
        if (_this.searchInitQuery()) {
          return;
        }
        _this.props.session.goToNextMarker();
      }
    });
    searchPanel_defineProperty(searchPanel_assertThisInitialized(_this), "onPrevMatchClick", function (event) {
      event.preventDefault();
      if (_this.searchInitQuery()) {
        return;
      }
      _this.props.session.goToPrevMarker();
    });
    searchPanel_defineProperty(searchPanel_assertThisInitialized(_this), "onNextMatchClick", function (event) {
      event.preventDefault();
      if (_this.searchInitQuery()) {
        return;
      }
      _this.props.session.goToNextMarker();
    });
    searchPanel_defineProperty(searchPanel_assertThisInitialized(_this), "onCloseClick", function () {
      _this.props.wantsToClose();
    });
    _this.inputDomNode = null;
    _this.state = getInitState(props);
    _this.attachSessionListeners(props);
    return _this;
  }
  searchPanel_createClass(SearchPanel, [{
    key: "attachSessionListeners",
    value: function attachSessionListeners(props, oldProps) {
      props.session.on('mark', this.onSessionMark);
      props.session.on('highlight', this.onSessionHighlight);
      if (oldProps) {
        oldProps.session.removeListener('mark', this.onSessionMark);
        oldProps.session.removeListener('highlight', this.onSessionHighlight);
      }
    }
  }, {
    key: "searchInitQuery",
    value: function searchInitQuery() {
      if (this.props.session.queryUninitialized) {
        this.props.onQueryChange(this.props.session.queryUninitialized);
        return true;
      }
      return false;
    }
  }, {
    key: "focusOnInput",
    value: function focusOnInput() {
      var _this2 = this;
      // таймаут для случая если в момент рендера панели контейнер был с display:none
      // т.к. апп может прятать контейнер когда поиск не активен
      setTimeout(function () {
        _this2.inputDomNode.focus();
        if (_this2.props.session.queryUninitialized) {
          _this2.inputDomNode.select();
        }
      }, 0);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.focusOnInput();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      var _this3 = this;
      if (this.props.session !== oldProps.session) {
        this.attachSessionListeners(this.props, oldProps);
        this.setState(function () {
          return getInitState(_this3.props);
        }, function () {
          _this3.focusOnInput();
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        query = _this$state.query,
        activeMatchIndex = _this$state.activeMatchIndex,
        totalMatches = _this$state.totalMatches;
      return (0,preact_module.h)(popupMenu/* default */.Z, {
        addClassName: "editor-search-panel"
      }, (0,preact_module.h)(icons/* IconSearch */.jVj, {
        class: "search-icon"
      }), (0,preact_module.h)("div", {
        className: "editor-search-input"
      }, (0,preact_module.h)(plugins_i18n/* Localizer */.Cf, null, (0,preact_module.h)("input", {
        onKeyDown: this.onKeyDown,
        value: query,
        onInput: this.onChangeQuery,
        placeholder: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
          id: "search.placeholder"
        }),
        type: "text",
        ref: this.onInputDomNodeRef
      }))), (0,preact_module.h)("div", {
        className: "matches-switch"
      }, (0,preact_module.h)(icons/* IconChevronLeft */.ed9, {
        onClick: this.onPrevMatchClick,
        className: "hl-icon search-panel-btn"
      }), (0,preact_module.h)("div", {
        className: "matches-numbers"
      }, activeMatchIndex + 1, "/", totalMatches), (0,preact_module.h)(icons/* IconChevronRight */.VG8, {
        onClick: this.onNextMatchClick,
        className: "hl-icon search-panel-btn"
      })), (0,preact_module.h)(icons/* IconClose */.bMz, {
        onClick: this.onCloseClick,
        className: "hl-icon search-panel-btn"
      }));
    }
  }]);
  return SearchPanel;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/mark.js/dist/mark.js
var mark = __webpack_require__(57115);
var mark_default = /*#__PURE__*/__webpack_require__.n(mark);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/search/searchSession.js
function searchSession_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { searchSession_typeof = function _typeof(obj) { return typeof obj; }; } else { searchSession_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return searchSession_typeof(obj); }
function searchSession_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = searchSession_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function searchSession_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return searchSession_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return searchSession_arrayLikeToArray(o, minLen); }
function searchSession_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


















function searchSession_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function searchSession_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function searchSession_createClass(Constructor, protoProps, staticProps) { if (protoProps) searchSession_defineProperties(Constructor.prototype, protoProps); if (staticProps) searchSession_defineProperties(Constructor, staticProps); return Constructor; }
function searchSession_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) searchSession_setPrototypeOf(subClass, superClass); }
function searchSession_setPrototypeOf(o, p) { searchSession_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return searchSession_setPrototypeOf(o, p); }
function searchSession_createSuper(Derived) { var hasNativeReflectConstruct = searchSession_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = searchSession_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = searchSession_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return searchSession_possibleConstructorReturn(this, result); }; }
function searchSession_possibleConstructorReturn(self, call) { if (call && (searchSession_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return searchSession_assertThisInitialized(self); }
function searchSession_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function searchSession_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function searchSession_getPrototypeOf(o) { searchSession_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return searchSession_getPrototypeOf(o); }





var SEARCH_TERM_HIGHLIGH_CLASS = 'editor-search-term';
var SEARCH_TERM_HIGHLIGH_CLASS_ACTIVE = 'editor-search-term-active';
var SearchSession = /*#__PURE__*/function (_EventEmitter) {
  searchSession_inherits(SearchSession, _EventEmitter);
  var _super = searchSession_createSuper(SearchSession);
  function SearchSession(_ref) {
    var _this;
    var editor = _ref.editor,
      relRange = _ref.relRange,
      queryUninitialized = _ref.queryUninitialized,
      cantEndByAction = _ref.cantEndByAction;
    searchSession_classCallCheck(this, SearchSession);
    _this = _super.call(this);
    _this.editor = editor;
    _this.scroll = editor.scroll;
    _this.relRange = relRange;
    _this.cantEndByAction = cantEndByAction;
    var scrollId = _this.scroll.domNode.getAttribute('id');
    var classes = ['editable-text', 'searchable', 'table-text-common'];
    _this.marker = new (mark_default())(classes.reduce(function (acc, item) {
      acc.push("#".concat(scrollId, " .").concat(item));
      return acc;
    }, []).join(', '));
    _this.scroll.ignoreUpdates();
    _this.editor.store.pauseExternalUpdates();
    // список маркеров по которым идет навигация
    _this.markers = [];
    // индекс текущего активного маркера
    _this.currentMarkerIdx = -1;
    _this.queryUninitialized = queryUninitialized;
    return _this;
  }
  searchSession_createClass(SearchSession, [{
    key: "mark",
    value: function mark(query) {
      var goToFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.queryUninitialized = false;
      this.unmark();
      if (query) {
        var markers = [];
        this.marker.mark(query, {
          className: SEARCH_TERM_HIGHLIGH_CLASS,
          acrossElements: true,
          separateWordSearch: false,
          each: function each(node) {
            return markers.push(node);
          }
        });
        this.markers = markers;
        // сортируем маркеры, т.к. mark.js может отдавать их не в порядке нахождения в DOM если в query массив с несколькими
        // строками
        this.markers.sort(function (a, b) {
          var compareMask = a.compareDocumentPosition(b);
          if (compareMask & Node.DOCUMENT_POSITION_PRECEDING) {
            return 1;
          }
          // это условие всегда должно выполнятся если первое не выполнено
          else if (compareMask & Node.DOCUMENT_POSITION_FOLLOWING) {
            return -1;
          }
          return 0;
        });
        this.markers.forEach(function (node) {
          var blot = normalizeToStoredBlot(getBlotForNode(node));
          if (blot && blot.onMustSetVisible) {
            blot.onMustSetVisible();
          }
        });
        this.currentMarkerIdx = -1;
        if (goToFirst) {
          this.goToMarker();
        }
      } else {
        this.emit('highlight', -1);
      }
      this.emit('mark');
    }
  }, {
    key: "unmark",
    value: function unmark() {
      var getBuildableBlot = function getBuildableBlot(node) {
        if (!node) {
          return null;
        }
        var blot = parchment_default().find(node);
        if (!blot) {
          return getBuildableBlot(node.parentNode);
        }
        if (!blot.build) {
          return getBuildableBlot(node.parentNode);
        }
        return blot;
      };
      var marksBlots = new Set();
      var _iterator = searchSession_createForOfIteratorHelper(this.markers),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var marker = _step.value;
          var blot = getBuildableBlot(marker);
          if (!blot) {
            console.warn("node", marker, marker.parentNode, "does not have a buildable blot, this may lead to saving content issues");
            continue;
          }
          marksBlots.add(blot);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.marker.unmark();
      // исправляем блоты, т.к. mark.js разбивает текстовые элементы, создавая новые и удаляя старые
      // и в итоге блоты имеют в children не существующие элементы. надо перебилдить текстовые блоты, которые были затронуты
      // mark.js
      var _iterator2 = searchSession_createForOfIteratorHelper(marksBlots),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _blot = _step2.value;
          _blot.build();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.markers = [];
    }
  }, {
    key: "_getFirstMarkerAfterRange",
    value: function _getFirstMarkerAfterRange(range) {
      var _iterator3 = searchSession_createForOfIteratorHelper(this.markers),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var marker = _step3.value;
          var markerRange = new Range();
          markerRange.selectNode(marker);
          var compare = markerRange.compareBoundaryPoints(Range.START_TO_START, range);
          if (compare === 0 || compare === 1) {
            return marker;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return null;
    }
  }, {
    key: "goToMarker",
    value: function goToMarker() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (!this.markers.length) {
        return;
      }
      var prevMarkerIdx = this.currentMarkerIdx;
      // если index == null, то надо надо найти подходящий маркер после relRange
      if (index === null) {
        if (this.relRange) {
          var relRangeNative = this.relRange.native;
          // ищем первый маркер, который находится после relRangeNative
          var marker = this._getFirstMarkerAfterRange(relRangeNative);
          if (!marker) {
            index = 0;
          } else {
            index = this.markers.indexOf(marker);
          }
        } else {
          index = 0;
        }
      }
      if (prevMarkerIdx >= 0) {
        this.markers[prevMarkerIdx].classList.remove(SEARCH_TERM_HIGHLIGH_CLASS_ACTIVE);
      }
      if (index >= 0) {
        this.markers[index].classList.add(SEARCH_TERM_HIGHLIGH_CLASS_ACTIVE);
        this.markers[index].scrollIntoView({
          block: 'center',
          behavior: 'auto'
        });
      }
      this.currentMarkerIdx = index;
      this.emit('highlight', index);
    }
  }, {
    key: "goToNextMarker",
    value: function goToNextMarker() {
      var nextIndex = this.currentMarkerIdx + 1;
      if (nextIndex >= this.markers.length) {
        nextIndex = 0;
      }
      this.goToMarker(nextIndex);
    }
  }, {
    key: "goToPrevMarker",
    value: function goToPrevMarker() {
      var prevIndex = this.currentMarkerIdx - 1;
      if (prevIndex < 0) {
        prevIndex = this.markers.length - 1;
      }
      this.goToMarker(prevIndex);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.unmark();
      this.scroll.resumeUpdates();
      this.editor.store.resumeExternalUpdates();
    }
  }]);
  return SearchSession;
}((events_default()));

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/search/index.js













function search_slicedToArray(arr, i) { return search_arrayWithHoles(arr) || search_iterableToArrayLimit(arr, i) || search_unsupportedIterableToArray(arr, i) || search_nonIterableRest(); }
function search_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function search_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return search_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return search_arrayLikeToArray(o, minLen); }
function search_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function search_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function search_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function search_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function search_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function search_createClass(Constructor, protoProps, staticProps) { if (protoProps) search_defineProperties(Constructor.prototype, protoProps); if (staticProps) search_defineProperties(Constructor, staticProps); return Constructor; }
function search_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var DEBOUNCE_TIMEOUT = 300;
var Search = /*#__PURE__*/function () {
  function Search(_ref) {
    var _this = this;
    var scroll = _ref.scroll,
      editor = _ref.editor,
      options = _ref.options;
    search_classCallCheck(this, Search);
    search_defineProperty(this, "onThemeChange", function (event) {
      if (_this.searchContainer) {
        var _Array$from$filter = Array.from(_this.searchContainer.classList).filter(function (cls) {
            return cls.indexOf('theme-') === 0;
          }),
          _Array$from$filter2 = search_slicedToArray(_Array$from$filter, 1),
          currentThemeClass = _Array$from$filter2[0];
        _this.searchContainer.classList.remove(currentThemeClass);
        _this.searchContainer.classList.add('theme-' + event.theme);
      }
    });
    search_defineProperty(this, "onQueryChange", function (query) {
      _this.query = query;
      _this.markQueryDebounced(query);
    });
    search_defineProperty(this, "markQuery", function (query) {
      _this.session.mark(query);
    });
    search_defineProperty(this, "markQueryDebounced", lodash_debounce_default()(this.markQuery, DEBOUNCE_TIMEOUT, {
      trailing: true
    }));
    search_defineProperty(this, "onSearchPanelWantsToClose", function () {
      _this.end('user');
    });
    search_defineProperty(this, "onEditorFocus", function () {
      _this.end('user');
    });
    search_defineProperty(this, "onEditorMouseDown", function () {
      _this.end('user');
    });
    this.editor = editor;
    this.scroll = scroll;
    this.options = options || {};
    this.session = null;
    this.query = '';
    this.scroll.domNode.addEventListener('focus', this.onEditorFocus, false);
    this.scroll.domNode.addEventListener('mousedown', this.onEditorMouseDown, false);
    this.editor.emitter.on('set-theme', this.onThemeChange);
    this.render();
  }
  search_createClass(Search, [{
    key: "destroy",
    value: function destroy() {
      if (!this.options.container) {
        this.render();
        this.searchContainer.parentNode.removeChild(this.searchContainer);
      }
    }
  }, {
    key: "getSearchContainerNode",
    value: function getSearchContainerNode() {
      if (!this.searchContainer) {
        if (this.options.hasOwnProperty('container')) {
          this.searchContainer = this.options.container;
          if (typeof this.searchContainer === 'function') {
            this.searchContainer = this.searchContainer();
          }
        } else {
          this.searchContainer = document.createElement('div');
          this.searchContainer.classList.add('editor-search-container');
          this.editor.scrollingContainer.appendChild(this.searchContainer);
        }
      }
      if (this.searchContainer) {
        this.searchContainer.classList.add('theme-' + this.editor.plugins.editorStyle.getTheme());
      }
      return this.searchContainer;
    }
  }, {
    key: "render",
    value: function render() {
      var panelVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var container = this.getSearchContainerNode();
      if (!container) {
        return;
      }
      var panel = null;
      if (panelVisible) {
        panel = (0,preact_module.h)(SearchPanel, {
          onQueryChange: this.onQueryChange,
          wantsToClose: this.onSearchPanelWantsToClose,
          session: this.session
        });
      }
      (0,preact_module/* render */.sY)((0,preact_module.h)(plugins_i18n/* IntlProvider */.Pj, null, panel), container);
    }
  }, {
    key: "end",
    value: function end() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'api';
      if (!this.session) {
        return;
      }
      this.session.destroy();
      this.session = null;
      this.options.onSearchEnd && this.options.onSearchEnd(this, source);
    }
  }, {
    key: "start",
    value: function start() {
      var _this$scroll$selectio = this.scroll.selection.getRange(),
        _this$scroll$selectio2 = search_slicedToArray(_this$scroll$selectio, 2),
        range = _this$scroll$selectio2[1];
      if (range && range.native) {
        var nativeRange = range.native;
        if (!nativeRange.collapsed) {
          var textFromRange = nativeRange.toString().trim();
          if (textFromRange) {
            this.query = textFromRange;
          }
        }
      }
      this.session = new SearchSession({
        editor: this.editor,
        relRange: range,
        queryUninitialized: this.query
      });
      this.editor.blur();
      this.render(true);
      this.options.onSearchStart && this.options.onSearchStart(this);
    }
  }]);
  return Search;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/globalSearch/searchNavigationPanel.js
function searchNavigationPanel_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { searchNavigationPanel_typeof = function _typeof(obj) { return typeof obj; }; } else { searchNavigationPanel_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return searchNavigationPanel_typeof(obj); }









function searchNavigationPanel_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function searchNavigationPanel_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function searchNavigationPanel_createClass(Constructor, protoProps, staticProps) { if (protoProps) searchNavigationPanel_defineProperties(Constructor.prototype, protoProps); if (staticProps) searchNavigationPanel_defineProperties(Constructor, staticProps); return Constructor; }
function searchNavigationPanel_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) searchNavigationPanel_setPrototypeOf(subClass, superClass); }
function searchNavigationPanel_setPrototypeOf(o, p) { searchNavigationPanel_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return searchNavigationPanel_setPrototypeOf(o, p); }
function searchNavigationPanel_createSuper(Derived) { var hasNativeReflectConstruct = searchNavigationPanel_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = searchNavigationPanel_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = searchNavigationPanel_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return searchNavigationPanel_possibleConstructorReturn(this, result); }; }
function searchNavigationPanel_possibleConstructorReturn(self, call) { if (call && (searchNavigationPanel_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return searchNavigationPanel_assertThisInitialized(self); }
function searchNavigationPanel_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function searchNavigationPanel_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function searchNavigationPanel_getPrototypeOf(o) { searchNavigationPanel_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return searchNavigationPanel_getPrototypeOf(o); }
function searchNavigationPanel_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var SearchNavigationPanel = /*#__PURE__*/function (_Component) {
  searchNavigationPanel_inherits(SearchNavigationPanel, _Component);
  var _super = searchNavigationPanel_createSuper(SearchNavigationPanel);
  function SearchNavigationPanel(props) {
    var _this;
    searchNavigationPanel_classCallCheck(this, SearchNavigationPanel);
    _this = _super.call(this, props);
    searchNavigationPanel_defineProperty(searchNavigationPanel_assertThisInitialized(_this), "onSessionMark", function () {
      var session = _this.props.session;
      _this.setState(function () {
        return {
          totalMatches: session.markers.length
        };
      });
    });
    searchNavigationPanel_defineProperty(searchNavigationPanel_assertThisInitialized(_this), "onSessionHighlight", function (index) {
      _this.setState(function () {
        return {
          activeMatchIndex: index
        };
      });
    });
    searchNavigationPanel_defineProperty(searchNavigationPanel_assertThisInitialized(_this), "onPrevMatchClick", function (event) {
      event.preventDefault();
      _this.props.session.goToPrevMarker();
    });
    searchNavigationPanel_defineProperty(searchNavigationPanel_assertThisInitialized(_this), "onNextMatchClick", function (event) {
      event.preventDefault();
      _this.props.session.goToNextMarker();
    });
    _this.state = {
      activeMatchIndex: -1,
      totalMatches: 0
    };
    _this.attachSessionListeners(props);
    return _this;
  }
  searchNavigationPanel_createClass(SearchNavigationPanel, [{
    key: "attachSessionListeners",
    value: function attachSessionListeners(props, oldProps) {
      props.session.on('mark', this.onSessionMark);
      props.session.on('highlight', this.onSessionHighlight);
      if (oldProps) {
        oldProps.session.removeListener('mark', this.onSessionMark);
        oldProps.session.removeListener('highlight', this.onSessionHighlight);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      if (this.props.session !== oldProps.session) {
        this.attachSessionListeners(this.props, oldProps);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        query = _this$state.query,
        activeMatchIndex = _this$state.activeMatchIndex,
        totalMatches = _this$state.totalMatches;
      return (0,preact_module.h)(popupMenu/* default */.Z, {
        addClassName: "editor-search-navigation-panel"
      }, (0,preact_module.h)(plugins_i18n/* Text */.xv, {
        id: "search.matches"
      }), (0,preact_module.h)("div", {
        className: "matches-switch"
      }, (0,preact_module.h)(icons/* IconChevronLeft */.ed9, {
        onClick: this.onPrevMatchClick,
        className: "hl-icon search-panel-btn"
      }), (0,preact_module.h)("div", {
        className: "matches-numbers"
      }, activeMatchIndex + 1, "/", totalMatches), (0,preact_module.h)(icons/* IconChevronRight */.VG8, {
        onClick: this.onNextMatchClick,
        className: "hl-icon search-panel-btn"
      })));
    }
  }]);
  return SearchNavigationPanel;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/globalSearch/index.js











function globalSearch_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = globalSearch_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function globalSearch_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return globalSearch_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return globalSearch_arrayLikeToArray(o, minLen); }
function globalSearch_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function globalSearch_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function globalSearch_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function globalSearch_createClass(Constructor, protoProps, staticProps) { if (protoProps) globalSearch_defineProperties(Constructor.prototype, protoProps); if (staticProps) globalSearch_defineProperties(Constructor, staticProps); return Constructor; }
function globalSearch_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var GlobalSearch = /*#__PURE__*/function () {
  function GlobalSearch(_ref) {
    var _this = this;
    var scroll = _ref.scroll,
      editor = _ref.editor,
      options = _ref.options;
    globalSearch_classCallCheck(this, GlobalSearch);
    globalSearch_defineProperty(this, "onEndByAction", function () {
      if (!_this.session) {
        return;
      }
      if (_this.session.cantEndByAction) {
        return;
      }
      _this.end();
    });
    globalSearch_defineProperty(this, "onEditorFocus", function () {
      _this.onEndByAction();
    });
    globalSearch_defineProperty(this, "onEditorMouseDown", function () {
      _this.onEndByAction();
    });
    this.editor = editor;
    this.scroll = scroll;
    this.options = options || {};
    this.session = null;
    this.query = '';
    this.searchContainer = null;
    this.scroll.domNode.addEventListener('focus', this.onEditorFocus, false);
    this.scroll.domNode.addEventListener('mousedown', this.onEditorMouseDown, false);
  }
  globalSearch_createClass(GlobalSearch, [{
    key: "getContainerNode",
    value: function getContainerNode() {
      if (!this.searchContainer) {
        this.searchContainer = this.options.container;
        if (typeof this.searchContainer === 'function') {
          this.searchContainer = this.searchContainer();
        }
        if (!this.searchContainer) {
          this.searchContainer = document.createElement('div');
          this.searchContainer.classList.add('editor-global-search-container');
          this.editor.scrollingContainer.appendChild(this.searchContainer);
        }
      }
      return this.searchContainer;
    }
  }, {
    key: "render",
    value: function render() {
      var panelVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var container = this.getContainerNode();
      var panel = null;
      if (panelVisible) {
        panel = (0,preact_module.h)(SearchNavigationPanel, {
          onQueryChange: this.onQueryChange,
          wantsToClose: this.onSearchPanelWantsToClose,
          session: this.session
        });
      }
      var toRender = null;
      if (panelVisible) {
        toRender = (0,preact_module.h)(plugins_i18n/* IntlProvider */.Pj, null, panel);
      } else {
        var NullComp = function NullComp() {};
        toRender = (0,preact_module.h)(NullComp, null);
      }
      (0,preact_module/* render */.sY)(toRender, container);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (!this.options.container && this.searchContainer && this.searchContainer.parentNode) {
        this.searchContainer.parentNode.removeChild(this.searchContainer);
      }
    }
  }, {
    key: "nextMatch",
    value: function nextMatch() {
      if (!this.session) {
        return;
      }
      this.session.goToNextMarker();
    }
  }, {
    key: "prevMatch",
    value: function prevMatch() {
      if (!this.session) {
        return;
      }
      this.session.goToPrevMarker();
    }
  }, {
    key: "searchInAnnotation",
    value: function searchInAnnotation(textDetailed, matches) {
      var polygons = [];
      var _iterator = globalSearch_createForOfIteratorHelper(textDetailed),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _step.value,
            description = _step$value.description,
            poly = _step$value.poly;
          if (description === '<fulltext>') {
            continue;
          }
          if (matchAny(description, matches)) {
            polygons.push(poly);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return polygons;
    }
  }, {
    key: "start",
    value: function start(matches) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.end();
      this.session = new SearchSession({
        editor: this.editor,
        cantEndByAction: opts.cantEndByAction
      });
      this.render(opts.showSearchPanel !== false);
      this.session.mark(matches, opts.disableNavigation === true ? false : true);
      if (opts.dontStartIfNoMarkers) {
        if (!this.session.markers.length) {
          return;
        }
      }
      if (opts.images) {
        var imagesToHighlight = {};
        for (var attachmentGlobalId in opts.images) {
          var textDetailed = opts.images[attachmentGlobalId].textDetailed;
          var polygons = this.searchInAnnotation(textDetailed, matches);
          if (polygons.length) {
            imagesToHighlight[attachmentGlobalId] = polygons;
          }
        }
        var attachmentGlobalIds = Object.keys(imagesToHighlight);
        if (attachmentGlobalIds.length) {
          var blots = this.editor.findBlotsWithAttachment(attachmentGlobalIds);
          var _iterator2 = globalSearch_createForOfIteratorHelper(blots),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _step2$value = _step2.value,
                blot = _step2$value.blot,
                _attachmentGlobalId = _step2$value.attachmentGlobalId;
              blot.setProps({
                highlights: imagesToHighlight[_attachmentGlobalId]
              });
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          this.highlightedBlots = blots;
        }
      }
      this.options.onSearchStart && this.options.onSearchStart(this);
    }
  }, {
    key: "end",
    value: function end() {
      if (!this.session) {
        return;
      }
      if (this.highlightedBlots) {
        var _iterator3 = globalSearch_createForOfIteratorHelper(this.highlightedBlots),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var blot = _step3.value.blot;
            blot.setProps({
              highlights: null
            });
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      this.highlightedBlots = null;
      this.session.destroy();
      this.session = null;
      this.options.onSearchEnd && this.options.onSearchEnd(this);
    }
  }]);
  return GlobalSearch;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/mentionManager/mentionSession.js
function mentionSession_slicedToArray(arr, i) { return mentionSession_arrayWithHoles(arr) || mentionSession_iterableToArrayLimit(arr, i) || mentionSession_unsupportedIterableToArray(arr, i) || mentionSession_nonIterableRest(); }
function mentionSession_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function mentionSession_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function mentionSession_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function mentionSession_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { mentionSession_typeof = function _typeof(obj) { return typeof obj; }; } else { mentionSession_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return mentionSession_typeof(obj); }
function mentionSession_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = mentionSession_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function mentionSession_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return mentionSession_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return mentionSession_arrayLikeToArray(o, minLen); }
function mentionSession_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }












function mentionSession_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function mentionSession_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function mentionSession_createClass(Constructor, protoProps, staticProps) { if (protoProps) mentionSession_defineProperties(Constructor.prototype, protoProps); if (staticProps) mentionSession_defineProperties(Constructor, staticProps); return Constructor; }
function mentionSession_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var MAX_WAIT_TIME = 1000;
var MentionSession = /*#__PURE__*/function () {
  function MentionSession(_ref) {
    var _this = this;
    var anchor = _ref.anchor,
      queryStartIndex = _ref.queryStartIndex,
      manager = _ref.manager;
    mentionSession_classCallCheck(this, MentionSession);
    mentionSession_defineProperty(this, "onBlotTextChange", function (delta) {
      //тут нужна дополнительная проверка: если вставка происходит в начале строки, то первым символом в строке будет "@",
      //если после него вставить еще одну "@" то при Delta.diff на сервере, в массив новый символ вставляется по индексу 0,
      //потому retain в delta не приходит и при вставке после первого "@" любого количества "@" приведет к закрытию сессии
      if (_this.queryStartIndex === 1 && delta.length() === 1 && delta.ops[0].insert === '@' || _this.queryStartIndex === 1 && _this.anchorBlot.getText() === '@\n' || getDeltaRetainOp(delta) >= _this.queryStartIndex && getDeltaRetainOp(delta) <= _this.queryStartIndex + _this.queryLength) {
        var _iterator = mentionSession_createForOfIteratorHelper(delta.ops),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var op = _step.value;
            if (op.insert) {
              if (mentionSession_typeof(op.insert) === 'object' || op.insert === ' ') {
                _this.manager.end();
                return;
              } else {
                _this.queryLength += op.insert.length;
              }
            } else if (op.delete) {
              _this.queryLength -= op.delete;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        _this.queryString = _this.anchorBlot.getText(_this.queryStartIndex, _this.queryLength) || '';
        var query = _this.queryString.toLowerCase();
        _this.onMentionQueryDebounced(query, _this.viewAll);
        _this.renderPlaceholderIfNeed();
      } else {
        _this.manager.end();
      }
    });
    this.anchorBlot = anchor;
    this.manager = manager;
    this.queryStartIndex = queryStartIndex;
    this.queryLength = 0;
    this.queryString = '';
    this.viewAll = null;
    this.onMentionQueryDebounced = lodash_debounce_default()(this.manager.onMentionQuery, 500, {
      trailing: true,
      maxWait: MAX_WAIT_TIME
    });
    this.anchorBlot.on('text-change', this.onBlotTextChange);
    this.renderPlaceholderIfNeed();
  }
  mentionSession_createClass(MentionSession, [{
    key: "renderPlaceholderIfNeed",
    value: function renderPlaceholderIfNeed() {
      if (searchUp(this.anchorBlot, function (blot) {
        return blot instanceof blots_gridCol;
      })) return;
      var _this$manager$scroll$ = this.manager.scroll.selection.getRange(),
        _this$manager$scroll$2 = mentionSession_slicedToArray(_this$manager$scroll$, 2),
        range = _this$manager$scroll$2[0],
        native = _this$manager$scroll$2[1];
      if (this.anchorBlot.length() - 1 === 1 && this.queryLength === 0 && range.index === this.anchorBlot.offset(this.manager.scroll) + 1 && range.length === 0) {
        this.attachPlaceholder(native);
      } else {
        this.detachPlaceholder();
      }
    }
  }, {
    key: "attachPlaceholder",
    value: function attachPlaceholder(nativeRange) {
      var container = this.manager.editor.scrollingContainer;
      var style = {
        position: 'absolute'
      };
      var blotRect = this.anchorBlot.domNode.getBoundingClientRect();
      var blotOffset = getContainerOffset(this.anchorBlot.domNode, container);
      var cursorRect = Array.from(nativeRange.native.getClientRects())[0];
      style.top = blotOffset.y + 'px';
      style.left = blotOffset.x + (cursorRect.x - blotRect.x) + 2 + 'px';
      style.height = blotRect.height + 'px';
      var placeholderText = this.manager.params.customPlaceholder || this.manager.editor.plugins.i18n.get('mention.placeholder');
      pRenderInContainer((0,preact_module.h)("div", {
        className: "mention-search-placeholder",
        style: style
      }, placeholderText), this.manager.editor.scrollingContainer, 'mention-search-placeholder-wrapper');
    }
  }, {
    key: "detachPlaceholder",
    value: function detachPlaceholder() {
      pRenderInContainer(null, this.manager.editor.scrollingContainer, 'mention-search-placeholder-wrapper');
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.anchorBlot.off('text-change', this.onBlotTextChange);
      this.detachPlaceholder();
    }
  }]);
  return MentionSession;
}();

function getDeltaRetainOp(delta) {
  var index = delta.filter(function (op) {
    return op.retain;
  })[0];
  return index && index.retain || -1;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/mentionManager/mentionCache.js
function mentionCache_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = mentionCache_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function mentionCache_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return mentionCache_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return mentionCache_arrayLikeToArray(o, minLen); }
function mentionCache_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function mentionCache_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function mentionCache_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function mentionCache_createClass(Constructor, protoProps, staticProps) { if (protoProps) mentionCache_defineProperties(Constructor.prototype, protoProps); if (staticProps) mentionCache_defineProperties(Constructor, staticProps); return Constructor; }

















var CACHE_PREFIX = 'mention-';
var CACHE_ID_REGEX = new RegExp("^".concat(CACHE_PREFIX));

// субплагин упоминаний для кэширования тайтлов
var MentionCache = /*#__PURE__*/function () {
  function MentionCache(editor) {
    mentionCache_classCallCheck(this, MentionCache);
    this.editor = editor;
    this.store = this.editor.store.cache;
    this.editor.once('editor-ready', this.clear.bind(this));
  }
  mentionCache_createClass(MentionCache, [{
    key: "save",
    value: function save(id, value) {
      var oldValue = this.get(CACHE_PREFIX + id);
      if (!oldValue || !lodash_isequal_default()(oldValue, value)) {
        this.store.set(CACHE_PREFIX + id, value);
      }
    }
  }, {
    key: "get",
    value: function get(id) {
      return this.store.get(CACHE_PREFIX + id);
    }
  }, {
    key: "remove",
    value: function remove(id) {
      this.store.delete(CACHE_PREFIX + id);
    }
  }, {
    key: "getAll",
    value: function getAll() {
      var result = {};
      var _iterator = mentionCache_createForOfIteratorHelper(this.store),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var row = _step.value;
          if (row[0].startsWith(CACHE_PREFIX)) {
            result[row[0].replace(CACHE_ID_REGEX, '')] = row[1];
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return result;
    }
  }, {
    key: "update",
    value: function update() {
      var _this = this;
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!Object.keys(data).length) return;
      this.editor.store.transaction(function () {
        for (var id in data) {
          _this.save(id, data[id]);
        }
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this2 = this;
      this.editor.store.transaction(function () {
        var cache = _this2.getAll();
        for (var id in cache) {
          var mention = _this2.editor.scroll.domNode.querySelector("[data-mention-object_id=\"".concat(id, "\"]"));
          if (!mention) {
            _this2.remove(id);
          }
        }
      });
    }
  }]);
  return MentionCache;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/errors/clientOfflineError.js
function clientOfflineError_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { clientOfflineError_typeof = function _typeof(obj) { return typeof obj; }; } else { clientOfflineError_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return clientOfflineError_typeof(obj); }











function clientOfflineError_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function clientOfflineError_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) clientOfflineError_setPrototypeOf(subClass, superClass); }
function clientOfflineError_createSuper(Derived) { var hasNativeReflectConstruct = clientOfflineError_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = clientOfflineError_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = clientOfflineError_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return clientOfflineError_possibleConstructorReturn(this, result); }; }
function clientOfflineError_possibleConstructorReturn(self, call) { if (call && (clientOfflineError_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return clientOfflineError_assertThisInitialized(self); }
function clientOfflineError_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function clientOfflineError_wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; clientOfflineError_wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !clientOfflineError_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return clientOfflineError_construct(Class, arguments, clientOfflineError_getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return clientOfflineError_setPrototypeOf(Wrapper, Class); }; return clientOfflineError_wrapNativeSuper(Class); }
function clientOfflineError_construct(Parent, args, Class) { if (clientOfflineError_isNativeReflectConstruct()) { clientOfflineError_construct = Reflect.construct; } else { clientOfflineError_construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) clientOfflineError_setPrototypeOf(instance, Class.prototype); return instance; }; } return clientOfflineError_construct.apply(null, arguments); }
function clientOfflineError_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function clientOfflineError_isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function clientOfflineError_setPrototypeOf(o, p) { clientOfflineError_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return clientOfflineError_setPrototypeOf(o, p); }
function clientOfflineError_getPrototypeOf(o) { clientOfflineError_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return clientOfflineError_getPrototypeOf(o); }
var ClientOfflineError = /*#__PURE__*/function (_Error) {
  clientOfflineError_inherits(ClientOfflineError, _Error);
  var _super = clientOfflineError_createSuper(ClientOfflineError);
  function ClientOfflineError() {
    clientOfflineError_classCallCheck(this, ClientOfflineError);
    return _super.apply(this, arguments);
  }
  return ClientOfflineError;
}( /*#__PURE__*/clientOfflineError_wrapNativeSuper(Error));

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/scss/mention-manager.scss
var mention_manager = __webpack_require__(9281);
var mention_manager_default = /*#__PURE__*/__webpack_require__.n(mention_manager);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/mentionManager/mentionList.js
function mentionList_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { mentionList_typeof = function _typeof(obj) { return typeof obj; }; } else { mentionList_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return mentionList_typeof(obj); }
function mentionList_extends() { mentionList_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mentionList_extends.apply(this, arguments); }
function mentionList_toConsumableArray(arr) { return mentionList_arrayWithoutHoles(arr) || mentionList_iterableToArray(arr) || mentionList_unsupportedIterableToArray(arr) || mentionList_nonIterableSpread(); }
function mentionList_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function mentionList_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function mentionList_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return mentionList_arrayLikeToArray(arr); }
function mentionList_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = mentionList_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function mentionList_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return mentionList_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return mentionList_arrayLikeToArray(o, minLen); }
function mentionList_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }





















function mentionList_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function mentionList_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function mentionList_createClass(Constructor, protoProps, staticProps) { if (protoProps) mentionList_defineProperties(Constructor.prototype, protoProps); if (staticProps) mentionList_defineProperties(Constructor, staticProps); return Constructor; }
function mentionList_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) mentionList_setPrototypeOf(subClass, superClass); }
function mentionList_setPrototypeOf(o, p) { mentionList_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return mentionList_setPrototypeOf(o, p); }
function mentionList_createSuper(Derived) { var hasNativeReflectConstruct = mentionList_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = mentionList_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = mentionList_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return mentionList_possibleConstructorReturn(this, result); }; }
function mentionList_possibleConstructorReturn(self, call) { if (call && (mentionList_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return mentionList_assertThisInitialized(self); }
function mentionList_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function mentionList_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function mentionList_getPrototypeOf(o) { mentionList_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return mentionList_getPrototypeOf(o); }
function mentionList_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var mentionList_isEscKey = (0,lib/* default */.ZP)('esc');
var isUpKey = (0,lib/* default */.ZP)('up');
var isShiftUpKey = (0,lib/* default */.ZP)('shift+up');
var isDownKey = (0,lib/* default */.ZP)('down');
var isShiftDownKey = (0,lib/* default */.ZP)('shift+down');
var mentionList_isEnterKey = (0,lib/* default */.ZP)('enter');
var mentionListMaxHeight = (mention_manager_default()).mentionListMaxHeight,
  mentionListPadding = (mention_manager_default()).mentionListPadding;
var DEFAULT_CATEGORIES_ORDER = ['user', 'folder', 'workspace', 'note'];
var START_LOADING_ON_SCROLL_DELTA = 10;
function getMentionTypeIcon(type) {
  switch (type) {
    case 'user':
      return (0,preact_module.h)(icons/* IconPeople */.GPC, null);
      break;
    case 'workspace':
      return (0,preact_module.h)(icons/* IconWorkspace */.FOt, null);
      break;
    case 'folder':
      return (0,preact_module.h)(icons/* IconFolder */.PUC, null);
      break;
    case 'note':
      return (0,preact_module.h)(icons/* IconNotes */.F1B, null);
      break;
  }
}
var MentionList = /*#__PURE__*/function (_Component) {
  mentionList_inherits(MentionList, _Component);
  var _super = mentionList_createSuper(MentionList);
  function MentionList(props) {
    var _this;
    mentionList_classCallCheck(this, MentionList);
    _this = _super.call(this, props);
    mentionList_defineProperty(mentionList_assertThisInitialized(_this), "disableRecycling", function () {
      _this.nextBase = null;
    });
    mentionList_defineProperty(mentionList_assertThisInitialized(_this), "onDomRef", function (node) {
      _this.domNode = node;
    });
    mentionList_defineProperty(mentionList_assertThisInitialized(_this), "onScrollNodeRef", function (node) {
      _this.scrollNode = node;
    });
    mentionList_defineProperty(mentionList_assertThisInitialized(_this), "onContainerNodeRef", function (node) {
      _this.containerNode = node;
    });
    mentionList_defineProperty(mentionList_assertThisInitialized(_this), "onMentionRef", function (node, category, item) {
      if (node) {
        node.mentionType = category;
        node.mentionId = item.object_id;
        node.mentionName = item.name;
        if (item.workspace_id) {
          node.mentionWorkspaceId = item.workspace_id;
        }
      }
    });
    mentionList_defineProperty(mentionList_assertThisInitialized(_this), "onMouseDown", function (event) {
      event.preventDefault();
      event.stopPropagation();
    });
    mentionList_defineProperty(mentionList_assertThisInitialized(_this), "onItemMouseClick", function (event) {
      var item = event.target.closest('.mention-item');
      if (_this.props.platform === 'Mac OS' && event.metaKey || _this.props.platform !== 'Mac OS' && event.ctrlKey) {
        if (item.querySelector('.mention-item-name') && item.querySelector('.mention-item-name').getAttribute('data-mention-object_id') !== 'custom') {
          _this.selectItem(item, true);
        }
      } else {
        var toPaste = [];
        if (_this.selectedItems.includes(item)) {
          var _iterator = mentionList_createForOfIteratorHelper(_this.selectedItems),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var node = _step.value;
              var data = {
                type: node.mentionType,
                object_id: node.mentionId,
                name: node.mentionName
              };
              if (node.mentionWorkspaceId) {
                data.workspace_id = node.mentionWorkspaceId;
              }
              toPaste.push(data);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } else {
          var _data = {
            type: item.mentionType,
            object_id: item.mentionId,
            name: item.mentionName
          };
          if (item.mentionWorkspaceId) {
            _data.workspace_id = item.mentionWorkspaceId;
          }
          toPaste = [_data];
        }
        _this.props.pasteMention(toPaste);
      }
    });
    mentionList_defineProperty(mentionList_assertThisInitialized(_this), "onItemMouseMove", function (event) {
      if (event.shiftKey && _this.selectedItems.length > 1) return;
      if (_this.props.platform === 'Mac OS' && event.metaKey || _this.props.platform !== 'Mac OS' && event.ctrlKey) return;
      if (_this.selectedItems.includes(event.target.closest('.mention-item'))) return;
      _this.selectItem(event.target.closest('.mention-item'));
    });
    mentionList_defineProperty(mentionList_assertThisInitialized(_this), "onBodyMouseDown", function (event) {
      var target = event.target;
      if (target === _this.domNode || _this.domNode.contains(target)) {
        return;
      }
      _this.props.wantsToClose();
    });
    mentionList_defineProperty(mentionList_assertThisInitialized(_this), "onBodyKeyDown", function (event) {
      var preventDefault = false;
      if (mentionList_isEscKey(event)) {
        event.stopPropagation();
        _this.props.wantsToClose();
      }
      if (!_this.isLoading() && !_this.isOffline()) {
        if (isUpKey(event) || isShiftUpKey(event)) {
          preventDefault = true;
          var prevNode = null;
          if (_this.selectedItems.length > 1 && event.shiftKey && _this.selectKeyDirection === 'bottom') {
            _this.selectItem(_this.selectedItems[_this.selectedItems.length - 1], true, true);
          } else {
            _this.selectKeyDirection = 'up';
            var firstSelectedNode = _this.selectedItems.length && _this.selectedItems[0];
            var _prevNode = false;
            if (firstSelectedNode) {
              _prevNode = _this.getPrevItemToSelect(firstSelectedNode, event.shiftKey);
            }
            if (_prevNode) {
              var add = false;
              if (event.shiftKey && firstSelectedNode && !firstSelectedNode.classList.contains('no-multiselect')) {
                add = true;
              }
              _this.selectItem(_prevNode, add, true);
            }
          }
        }
        if (isDownKey(event) || isShiftDownKey(event)) {
          preventDefault = true;
          var nextNode = null;
          if (_this.selectedItems.length > 1 && event.shiftKey && _this.selectKeyDirection === 'up') {
            _this.selectItem(_this.selectedItems[0], true, true);
          } else {
            _this.selectKeyDirection = 'bottom';
            var lastSelectedNode = _this.selectedItems.length && _this.selectedItems[_this.selectedItems.length - 1];
            var _nextNode = false;
            if (lastSelectedNode) {
              _nextNode = _this.getNextItemToSelect(lastSelectedNode, event.shiftKey);
            }
            if (_nextNode) {
              var _add = false;
              if (event.shiftKey && lastSelectedNode && !lastSelectedNode.classList.contains('no-multiselect')) {
                _add = true;
              }
              _this.selectItem(_nextNode, _add, true);
            }
          }
        }
        if (mentionList_isEnterKey(event)) {
          if (_this.selectedItems.length > 0) {
            preventDefault = true;
            var query = _this.props.query;
            if (_this.selectedItems.length === 1 && _this.selectedItems[0].classList.contains('mention-view-all-items-button')) {
              var category = _this.selectedItems[0].getAttribute('data-category') || null;
              _this.props.onViewAll(query, category);
            } else if (_this.selectedItems[0].classList.contains('create-note-button')) {
              _this.props.onCreateAndPasteMention('note', query);
            } else if (_this.selectedItems[0].classList.contains('create-folder-button')) {
              _this.props.onCreateAndPasteMention('folder', query);
            } else {
              var toPaste = [];
              var _iterator2 = mentionList_createForOfIteratorHelper(_this.selectedItems),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var node = _step2.value;
                  var data = {
                    type: node.mentionType,
                    object_id: node.mentionId,
                    name: node.mentionName
                  };
                  if (node.mentionWorkspaceId) {
                    data.workspace_id = node.mentionWorkspaceId;
                  }
                  toPaste.push(data);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              _this.props.pasteMention(toPaste);
            }
          } else {
            //так как нажатие по Enter при добавлении нового параграфа тоже preventDefault, выполняем в отдельном потоке
            setTimeout(function () {
              _this.props.wantsToClose();
            }, 0);
          }
        }
      }
      if (preventDefault) {
        event.stopPropagation();
        event.preventDefault();
      }
    });
    mentionList_defineProperty(mentionList_assertThisInitialized(_this), "onListScroll", function (event) {
      if (_this.isLoading() || _this.isOffline() || _this.props.recent || _this.state.loadingNotes || _this.state.allNotesLoaded) return; //если загрузка или офлайн или показаны последние - не выполняем
      var _this$props = _this.props,
        items = _this$props.items,
        query = _this$props.query;
      if (!items.note || items.note.length < _this.props.maxNotesPerQuery) return; //если нет заметок или их изначально было полученно меньше максимума - не выполняем
      var delta = _this.domNode.clientHeight - (_this.domNode.scrollHeight - _this.domNode.scrollTop);
      if (delta >= 0 && delta < START_LOADING_ON_SCROLL_DELTA) {
        //указываем компоненту что начался запрос на nextNotes, нужно показать юзеру что идет загрузка
        var currentNotesCount = items.note.length + _this.state.nextNotes.length;
        _this.setState(function () {
          return {
            loadingNotes: true
          };
        }, function () {
          _this.props.getNextNotes(query, currentNotesCount, _this.props.maxNotesPerQuery).then(function (notes) {
            if (notes.length === 0) {
              _this.setState(function (prevState) {
                return {
                  nextNotes: [].concat(mentionList_toConsumableArray(prevState.nextNotes), mentionList_toConsumableArray(notes)),
                  loadingNotes: false,
                  allNotesLoaded: true
                };
              });
            } else {
              _this.setState(function (prevState) {
                return {
                  nextNotes: [].concat(mentionList_toConsumableArray(prevState.nextNotes), mentionList_toConsumableArray(notes)),
                  loadingNotes: false
                };
              });
            }
          }).catch(function (err) {
            console.log(err);
          });
        });
      }
    });
    mentionList_defineProperty(mentionList_assertThisInitialized(_this), "onListMouseWheel", function (event) {
      //предотвращаем скроллинг редактора/документа если мышь находится поверх списка и список имеет скроллбар
      if ((0,dom/* isNodeHasScrollbar */.AI)(_this.domNode) && (_this.domNode.scrollHeight - _this.domNode.scrollTop === _this.domNode.clientHeight && event.deltaY > 0 || _this.domNode.scrollTop === 0 && event.deltaY < 0)) {
        event.preventDefault();
        event.stopPropagation();
      }
    });
    mentionList_defineProperty(mentionList_assertThisInitialized(_this), "onListMouseDown", function (event) {
      event.preventDefault();
    });
    mentionList_defineProperty(mentionList_assertThisInitialized(_this), "onCreateNoteMouseClick", function (event) {
      var _this$props2 = _this.props,
        query = _this$props2.query,
        queryString = _this$props2.queryString;
      _this.props.onCreateAndPasteMention('note', queryString || query);
    });
    mentionList_defineProperty(mentionList_assertThisInitialized(_this), "onCreateFolderMouseClick", function (event) {
      var _this$props3 = _this.props,
        query = _this$props3.query,
        queryString = _this$props3.queryString;
      _this.props.onCreateAndPasteMention('folder', queryString || query);
    });
    _this.selectedItems = [];
    _this.selectKeyDirection = null;
    _this.lastQuery = _this.props.query;
    //query в state нужен для того чтобы в getDerivedStateFromProps отслеживать изменился ли запрос,
    //если он измениться нужно будет выставить state в default
    _this.state = {
      query: _this.props.query,
      nextNotes: [],
      loadingNotes: false,
      allNotesLoaded: false
    };
    return _this;
  }
  mentionList_createClass(MentionList, [{
    key: "isLoading",
    value: function isLoading() {
      return this.props.loading && !this.props.items;
    }
  }, {
    key: "isOffline",
    value: function isOffline() {
      return this.props.items instanceof ClientOfflineError;
    }
  }, {
    key: "getUserAvatar",
    value: function getUserAvatar(object_id) {
      return this.props.getUserAvatar(object_id);
    }
  }, {
    key: "getMentionIcon",
    value: function getMentionIcon(category, name, object_id) {
      switch (category) {
        case 'note':
          return (0,preact_module.h)(icons/* IconNotes */.F1B, null);
          break;
        case 'folder':
          return (0,preact_module.h)(icons/* IconFolder */.PUC, null);
          break;
        case 'workspace':
          return (0,preact_module.h)("div", {
            className: "workspace-mention-icon"
          }, name.split('')[0]);
          break;
        case 'user':
          return (0,preact_module.h)("div", {
            className: "user-mention-avatar"
          }, this.getUserAvatar(object_id) || name.split('')[0]);
          break;
        default:
          return (0,preact_module.h)("div", null);
      }
    }
  }, {
    key: "highlightQueryInName",
    value: function highlightQueryInName(name, query) {
      var result = [];
      var string = name.toLowerCase();
      var index = 0;
      while (string) {
        var queryIndex = string.indexOf(query);
        if (queryIndex > -1) {
          if (queryIndex !== 0) {
            result.push({
              h: false,
              string: name.slice(index, index + queryIndex)
            });
          }
          result.push({
            h: true,
            string: name.slice(index + queryIndex, index + queryIndex + query.length)
          });
          index += queryIndex + query.length;
          string = name.toLowerCase().slice(index, name.length);
        } else {
          result.push({
            h: false,
            string: name.slice(index, name.length)
          });
          string = false;
        }
      }
      return (0,preact_module.h)("span", null, result.map(function (el) {
        return el.h ? (0,preact_module.h)("span", {
          className: "mention-highlight"
        }, el.string) : el.string;
      }));
    }
  }, {
    key: "selectItem",
    value: function selectItem() {
      var node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var add = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var scrollNeed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      // снимаем все выделения
      if (!add) {
        if (this.selectedItems.length > 0) {
          var _iterator3 = mentionList_createForOfIteratorHelper(this.selectedItems),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var item = _step3.value;
              item.classList.remove('selected-mention');
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } else {
        // если началось мультивыделение, проверяем нет ли сейчас в выделении элементов, которые не должны попасть в мультивыделение
        if (this.selectedItems.length) {
          var _iterator4 = mentionList_createForOfIteratorHelper(this.selectedItems),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _item = _step4.value;
              if (_item.classList.contains('no-multiselect')) {
                _item.classList.remove('selected-mention');
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      }
      if (node) {
        // если параметр add = true, добавляем элемент в массив выделения
        if (add) {
          // проверяем, если нода уже находится в массиве выделения, снимаем с нее выделение,
          // предполагается что юзер повторно нажал на элемент с нажатой клавишей ctrl и хочет снять с нее выделение
          if (this.selectedItems.includes(node)) {
            node.classList.remove('selected-mention');
          } else {
            node.classList.add('selected-mention');
          }
        } else {
          node.classList.add('selected-mention');
        }
      }
      // эту переменную решил генерировать отдельно из всех выделенных упоминаний, чтоб последовательность их вставки в заметку была такой же как в листе
      this.selectedItems = Array.from(this.domNode.querySelectorAll('.mention-item.selected-mention'));
      //тут проверка: если выделение произошло с помощью мыши - не скроллим, иначе выглядит как будто баг, когда лист начинает скроллится до элемента
      if (scrollNeed) {
        this.onSelectItemScrollIfNeed(node);
      }
    }
  }, {
    key: "sortMentionCategories",
    value: function sortMentionCategories() {
      var categories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (categories.length) {
        var result = Array.from(categories);
        result.sort(function (a, b) {
          if (DEFAULT_CATEGORIES_ORDER.indexOf(a) < DEFAULT_CATEGORIES_ORDER.indexOf(b)) {
            return -1;
          }
          if (DEFAULT_CATEGORIES_ORDER.indexOf(a) > DEFAULT_CATEGORIES_ORDER.indexOf(b)) {
            return 1;
          }
          return 0;
        });
        return result;
      }
      return categories;
    }
  }, {
    key: "onViewAllClick",
    value: function onViewAllClick(event) {
      var category = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (this.props.platform === 'Mac OS' && event.metaKey || this.props.platform !== 'Mac OS' && event.ctrlKey) return;
      var query = this.props.query;
      this.props.onViewAll(query, category);
    }
  }, {
    key: "onSelectItemScrollIfNeed",
    value: function onSelectItemScrollIfNeed(node) {
      var isFirstItemInList = !node.previousSibling && node.closest('.mention-category') === this.containerNode.getElementsByClassName('mention-category')[0];
      var nodeOffset = getContainerOffset(node, this.domNode);
      var nodeHeight = node.getBoundingClientRect().height;
      if (isFirstItemInList) {
        this.domNode.scrollTop = 0;
      } else if (nodeOffset.y + nodeHeight > this.domNode.clientHeight + this.domNode.scrollTop) {
        this.domNode.scrollTop += nodeOffset.y + nodeHeight * 2 - (this.domNode.clientHeight + this.domNode.scrollTop);
      } else if (nodeOffset.y < this.domNode.scrollTop) {
        this.domNode.scrollTop -= this.domNode.scrollTop - nodeOffset.y + nodeHeight;
      }
    }

    /*** START: обработчики событий мыши на упоминании ***/
    // при клике по элементу, который находится в массиве выделенных элементов,
    // функция вставит несколько элементов, при клике вне массива только текущий
  }, {
    key: "getNextItemToSelect",
    value: function getNextItemToSelect() {
      var current = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var shiftKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var allItems = Array.from(this.containerNode.querySelectorAll('.mention-item'));
      if (!current) {
        return allItems[0];
      }
      var index = allItems.indexOf(current) + 1;
      var nextItem = allItems[index];
      if (shiftKey) {
        while (nextItem && nextItem.classList.contains('no-multiselect')) {
          index++;
          nextItem = allItems[index];
        }
      }
      return nextItem;
    }
  }, {
    key: "getPrevItemToSelect",
    value: function getPrevItemToSelect() {
      var current = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var shiftKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var allItems = Array.from(this.containerNode.querySelectorAll('.mention-item'));
      if (!current) {
        return allItems[0];
      }
      var index = allItems.indexOf(current) - 1;
      var prevItem = allItems[index];
      if (shiftKey) {
        while (prevItem && prevItem.classList.contains('no-multiselect')) {
          index = index - 1;
          prevItem = allItems[index];
        }
      }
      return prevItem;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.dispatchEventTimeout) {
        clearTimeout(this.dispatchEventTimeout);
      }
      document.body.removeEventListener('mousedown', this.onBodyMouseDown, false);
      document.body.removeEventListener('keydown', this.onBodyKeyDown, false);
      setTimeout(this.disableRecycling);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var wantsToClose = this.props.wantsToClose;
      if (wantsToClose) {
        this.dispatchEventTimeout = setTimeout(function () {
          document.body.addEventListener('mousedown', _this2.onBodyMouseDown, false);
          document.body.addEventListener('keydown', _this2.onBodyKeyDown, false);
        }, 0);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!this.isLoading() && !this.isOffline()) {
        if (this.lastQuery !== this.props.query || this.selectedItems.length === 0) {
          this.lastQuery = this.props.query;
          this.selectItem(Array.from(Array.from(this.domNode.childNodes)[0].querySelectorAll('.mention-item'))[0]);
        }
      } else {
        this.selectItem();
      }
      this.scrollToLoadingViewIfNeed();
      this.normalizeScrollHeight();
      this.selectKeyDirection = null;
    }

    //функция скроллит лист в самый низ, чтоб был виден загрузчик, когда компоненту сообщается что началась загрузка nextNotes,
    //иначе не совсем понятно что происходит
  }, {
    key: "scrollToLoadingViewIfNeed",
    value: function scrollToLoadingViewIfNeed() {
      if (this.state.loadingNotes) {
        this.domNode.scrollTop = this.domNode.scrollHeight;
      }
    }
  }, {
    key: "normalizeScrollHeight",
    value: function normalizeScrollHeight() {
      if (this.props.normalizeHeight === false) {
        return;
      }
      var listHeight = this.domNode.scrollHeight;
      if (listHeight < mentionListMaxHeight) {
        //тут добавляем к высоте 2, чтоб не появлялся скроллбар, цифра подобрана путем подбора при дебаге, по другому решить не смог
        var correctHeight = 2;
        this.scrollNode.style.height = listHeight + correctHeight + 'px';
      } else {
        this.scrollNode.style.height = '';
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props4 = this.props,
        editor = _this$props4.editor,
        loading = _this$props4.loading,
        query = _this$props4.query,
        viewAll = _this$props4.viewAll,
        totalAmount = _this$props4.totalAmount,
        queryString = _this$props4.queryString;
      var _this$state = this.state,
        nextNotes = _this$state.nextNotes,
        loadingNotes = _this$state.loadingNotes;
      var list = null;
      var addClassName = '';
      if (loading) {
        list = (0,preact_module.h)("span", {
          className: "mention-no-result"
        }, (0,preact_module.h)((loader2_default()), null));
        addClassName = 'loading';
      } else if (this.props.items instanceof ClientOfflineError) {
        list = (0,preact_module.h)("span", {
          className: "mention-no-result"
        }, this.props.i18n.get('mention.offline_message'));
        addClassName = 'message';
      } else {
        var items = Object.assign({}, this.props.items);
        if (!items.note && !viewAll) {
          items.note = [];
        }
        if (!items.folder && !viewAll) {
          items.folder = [];
        }
        var dateCategory;
        if (!query && !viewAll) {
          var category = 'date';
          var dateItems = [{
            object_id: 'now',
            name: this.props.i18n.get('calendar.insert.now')
          }, {
            object_id: 'today',
            name: this.props.i18n.get('calendar.insert.today')
          }, {
            object_id: 'tomorrow',
            name: this.props.i18n.get('calendar.insert.tomorrow')
          }];
          if (!editor.blotsConfig.date || !editor.blotsConfig.date.readOnly) {
            dateItems.push({
              object_id: 'custom',
              name: this.props.i18n.get('calendar.insert.custom')
            });
          }
          dateCategory = (0,preact_module.h)("div", {
            className: "mention-category"
          }, (0,preact_module.h)("div", {
            className: "mention-category-header"
          }, (0,preact_module.h)("label", {
            className: "mention-category-label"
          }, this.props.i18n.get('calendar.insert.category_name'))), (0,preact_module.h)("div", {
            className: "mention-category-list"
          }, dateItems.map(function (item) {
            return (0,preact_module.h)("div", {
              className: 'mention-item' + (item.object_id === 'custom' ? ' no-multiselect' : ''),
              ref: function ref(node) {
                _this3.onMentionRef(node, category, item);
              },
              onClick: _this3.onItemMouseClick,
              onMouseMove: _this3.onItemMouseMove
            }, (0,preact_module.h)("div", {
              className: "mention-item-icon"
            }, (0,preact_module.h)(icons/* IconCalendar */.jt6, null)), (0,preact_module.h)("div", {
              className: "mention-item-name",
              "data-mention-object_id": item.object_id
            }, item.name));
          })));
        }
        var backButton;
        if (viewAll) {
          backButton = (0,preact_module.h)("div", {
            className: "mention-category mention-back-button"
          }, (0,preact_module.h)("div", {
            className: "mention-item mention-view-all-items-button no-multiselect",
            onClick: function onClick(event) {
              event.preventDefault();
              _this3.onViewAllClick(event);
            },
            onMouseMove: this.onItemMouseMove
          }, (0,preact_module.h)("div", {
            className: "mention-item-icon"
          }, (0,preact_module.h)(icons/* IconBackButton */.$fB, null)), (0,preact_module.h)("div", {
            className: "mention-item-name"
          }, this.props.i18n.get('mention.back_button'))));
        }
        var addNoteItem = (0,preact_module.h)("div", {
          className: "mention-item no-multiselect create-note-button",
          onClick: this.onCreateNoteMouseClick,
          onMouseMove: this.onItemMouseMove
        }, (0,preact_module.h)("div", {
          className: "mention-item-icon"
        }, (0,preact_module.h)(icons/* IconCreateNote */.uyk, null)), (0,preact_module.h)("div", {
          className: "mention-item-name"
        }, this.props.i18n.get('mention.create_note_for') + ' ', (0,preact_module.h)("strong", null, queryString || query)));
        var addFolderItem = (0,preact_module.h)("div", {
          className: "mention-item no-multiselect create-folder-button",
          onClick: this.onCreateFolderMouseClick,
          onMouseMove: this.onItemMouseMove
        }, (0,preact_module.h)("div", {
          className: "mention-item-icon"
        }, (0,preact_module.h)(icons/* IconCreateFolder */.e4s, null)), (0,preact_module.h)("div", {
          className: "mention-item-name"
        }, this.props.i18n.get('mention.create_folder_for') + ' ', (0,preact_module.h)("strong", null, queryString || query)));
        var addButtons = false;
        if (query && editor && !editor.options.disableAddNote) {
          addButtons = true;
        }
        list = (0,preact_module.h)("div", {
          className: "mention-list-container",
          ref: this.onContainerNodeRef
        }, backButton, dateCategory, this.sortMentionCategories(Object.keys(items)).map(function (category) {
          return (0,preact_module.h)("div", {
            className: "mention-category"
          }, !viewAll ? (0,preact_module.h)("div", {
            className: "mention-category-header"
          }, (0,preact_module.h)("label", {
            className: "mention-category-label"
          }, _this3.props.i18n.get('mention.' + category))) : null, (0,preact_module.h)("div", {
            className: "mention-category-list"
          }, items[category].map(function (item) {
            var nAttrs = category === 'note' && item.path ? mentionList_defineProperty({}, tooltipManager/* TOOLTIP_ATTR */.qZ, item.path) : {};
            var iconAttrs = {
              className: 'mention-item-icon'
            };
            if (item.color) {
              iconAttrs.style = {
                backgroundColor: '#' + item.color
              };
              if (item.color.toLowerCase() !== 'fac92f') {
                iconAttrs.className += ' colored-mention-icon';
              }
            }
            return (0,preact_module.h)("div", mentionList_extends({}, nAttrs, {
              className: "mention-item",
              ref: function ref(node) {
                _this3.onMentionRef(node, category, item);
              },
              onClick: _this3.onItemMouseClick,
              onMouseMove: _this3.onItemMouseMove
            }), (0,preact_module.h)("div", iconAttrs, item.icon ? (0,preact_module.h)("img", {
              className: "mention-item-icon-image",
              src: item.icon
            }) : _this3.getMentionIcon(category.toLowerCase(), item.name, item.object_id)), (0,preact_module.h)("div", {
              className: "mention-item-name",
              "data-mention-object_id": item.object_id
            }, item.name));
          }), category === 'note' && nextNotes.length > 0 ? nextNotes.map(function (item) {
            var nAttrs = item.path ? mentionList_defineProperty({}, tooltipManager/* TOOLTIP_ATTR */.qZ, item.path) : {};
            return (0,preact_module.h)("div", mentionList_extends({}, nAttrs, {
              className: "mention-item",
              ref: function ref(node) {
                _this3.onMentionRef(node, category, item);
              },
              onClick: _this3.onItemMouseClick,
              onMouseMove: _this3.onItemMouseMove
            }), (0,preact_module.h)("div", {
              className: "mention-item-icon"
            }, _this3.getMentionIcon(category.toLowerCase(), item.name, item.object_id)), (0,preact_module.h)("div", {
              className: "mention-item-name",
              "data-mention-object_id": item.object_id
            }, item.name));
          }) : null, addButtons && category === 'note' ? addNoteItem : null, addButtons && category === 'folder' ? addFolderItem : null), query === '' && viewAll !== category && (!totalAmount[category] || totalAmount[category] > items[category].length) ? (0,preact_module.h)("div", {
            className: "mention-item mention-view-all-items-button no-multiselect",
            "data-category": category,
            onClick: function onClick(event) {
              event.preventDefault();
              _this3.onViewAllClick(event, category);
            },
            onMouseMove: _this3.onItemMouseMove
          }, (0,preact_module.h)("div", {
            className: "mention-item-icon"
          }, getMentionTypeIcon(category.toLowerCase())), (0,preact_module.h)("div", {
            className: "mention-item-name"
          }, _this3.props.i18n.get(category === 'user' && 'mention.show_all_users' || 'mention.show_all'))) : null);
        }), loadingNotes ? (0,preact_module.h)("span", {
          className: "next-notes-loader"
        }, (0,preact_module.h)((loader2_default()), null)) : null);
        addClassName = 'list';
      }
      return (0,preact_module.h)("div", {
        className: 'mention-search-scroll ' + addClassName,
        ref: this.onScrollNodeRef
      }, (0,preact_module.h)("div", {
        className: "mention-list",
        ref: this.onDomRef,
        onScroll: this.onListScroll,
        onMouseDown: this.onListMouseDown,
        onMouseWheel: this.onListMouseWheel
      }, list));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      //если поисковая строка была изменена, нужно обнулить nextNotes в state, чтоб рендер их не подхватил
      if (typeof props.query !== 'undefined' && props.query !== state.query || !props.query && !props.viewAll) {
        return {
          nextNotes: [],
          query: props.query,
          loadingNotes: false,
          allNotesLoaded: false
        };
      }
      return null;
    }
  }]);
  return MentionList;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/mentionManager/index.js
function mentionManager_extends() { mentionManager_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mentionManager_extends.apply(this, arguments); }
function mentionManager_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function mentionManager_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { mentionManager_ownKeys(Object(source), true).forEach(function (key) { mentionManager_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { mentionManager_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function mentionManager_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = mentionManager_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function mentionManager_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return mentionManager_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return mentionManager_arrayLikeToArray(o, minLen); }
function mentionManager_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

















function mentionManager_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function mentionManager_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { mentionManager_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { mentionManager_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function mentionManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function mentionManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function mentionManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) mentionManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) mentionManager_defineProperties(Constructor, staticProps); return Constructor; }
function mentionManager_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var MAX_NOTES_PER_QUERY = 20;
var MAX_FAILED_QUERY = 2;
function deleteEmptyCategories(sourceItemCollection) {
  var itemCollection = {};
  for (var c in sourceItemCollection) {
    var items = sourceItemCollection[c];
    if (items.length > 0) {
      itemCollection[c] = items;
    }
  }
  return itemCollection;
}
var MentionManager = /*#__PURE__*/function () {
  function MentionManager(_ref) {
    var _this = this;
    var scroll = _ref.scroll,
      editor = _ref.editor,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;
    mentionManager_classCallCheck(this, MentionManager);
    mentionManager_defineProperty(this, "getLastItems", /*#__PURE__*/mentionManager_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var itemCollection, totalAmount;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.options.getLastItems();
            case 2:
              itemCollection = _context.sent;
              totalAmount = {};
              if (itemCollection.totalAmount) {
                totalAmount = Object.assign({}, itemCollection.totalAmount);
                delete itemCollection.totalAmount;
              }
              return _context.abrupt("return", {
                items: deleteEmptyCategories(itemCollection),
                totalAmount: totalAmount
              });
            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    mentionManager_defineProperty(this, "searchItems", /*#__PURE__*/function () {
      var _ref3 = mentionManager_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(query) {
        var viewAll,
          maxNotes,
          itemCollection,
          _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                viewAll = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : null;
                maxNotes = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : _this.maxNotesPerQuery;
                if (_this.options.searchItems) {
                  _context2.next = 4;
                  break;
                }
                return _context2.abrupt("return", {});
              case 4:
                _context2.next = 6;
                return _this.options.searchItems(query, viewAll, maxNotes);
              case 6:
                itemCollection = _context2.sent;
                return _context2.abrupt("return", deleteEmptyCategories(itemCollection));
              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    mentionManager_defineProperty(this, "getNextNotes", function (query, offset, count) {
      return _this.options.getNextNotes(query, offset, count);
    });
    mentionManager_defineProperty(this, "getUserAvatar", function (object_id) {
      return null;
    });
    mentionManager_defineProperty(this, "onMentionClick", function (objectType, objectId) {
      var workspaceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      if (_this.isMethodImplemented('onMentionClick')) {
        _this.options.onMentionClick(objectType, objectId, workspaceId);
      }
    });
    mentionManager_defineProperty(this, "onViewAll", function (query, category) {
      var container = _this.container;
      _this.render(container, true, {
        loading: true
      });
      _this.session.viewAll = category;
      if (!query && !category) {
        _this.getLastItems().then(function (result) {
          _this.render(container, true, {
            items: result.items,
            query: query,
            recent: true,
            totalAmount: result.totalAmount
          });
          _this.onMentionsResolve(result.items);
        }).catch(function (err) {
          if (err instanceof ClientOfflineError) {
            _this.render(container, true, {
              items: err
            });
            _this.onMentionsResolve(err);
          } else {
            console.log(err);
          }
        });
      } else {
        _this.searchItems(query.toLowerCase(), category).then(function (items) {
          _this.render(container, true, {
            items: items,
            query: query,
            viewAll: category
          });
        }).catch(function (err) {
          if (err instanceof ClientOfflineError) {
            _this.render(container, true, {
              items: err
            });
          } else {
            console.log(err);
          }
        });
      }
    });
    mentionManager_defineProperty(this, "onMentionQuery", function (query, viewAll) {
      if (!_this.session) return; //так как функция отложенна на 500ms, нужно проверить существует ли еще сессия
      var container = _this.container;
      _this.render(container, true, {
        loading: true
      });
      if (query !== '' || viewAll) {
        _this.searchItems(query.toLowerCase(), viewAll).then(function (items) {
          _this.render(container, true, {
            items: items,
            query: query,
            viewAll: viewAll
          });
          _this.onMentionsResolve(items);
        }).catch(function (err) {
          if (err instanceof ClientOfflineError) {
            _this.render(container, true, {
              items: err
            });
            _this.onMentionsResolve(err);
          } else {
            console.log(err);
          }
        });
      } else {
        _this.getLastItems().then(function (result) {
          _this.render(container, true, {
            items: result.items,
            query: query,
            recent: true,
            totalAmount: result.totalAmount
          });
          _this.onMentionsResolve(result.items);
        }).catch(function (err) {
          if (err instanceof ClientOfflineError) {
            _this.render(container, true, {
              items: err
            });
            _this.onMentionsResolve(err);
          } else {
            console.log(err);
          }
        });
      }
    });
    mentionManager_defineProperty(this, "pasteMention", function () {
      var mentions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var blot = _this.session.anchorBlot;
      var index = _this.session.queryStartIndex - 1;
      var length = _this.session.queryLength + 1;
      var ops = [{
        retain: index
      }, {
        delete: length
      }];
      var insertOpts = [];
      var inserted = [];
      var mentionCache = {};
      var _iterator = mentionManager_createForOfIteratorHelper(mentions),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mention = _step.value;
          if (mention.object_id) {
            if (inserted.indexOf(mention.object_id) === -1) {
              inserted.push(mention.object_id);
            } else {
              continue;
            }
          }
          if (mention.type === 'date') {
            if (mention.object_id === 'custom' && _this.editor.plugins.dateManager && _this.editor.plugins.dateManager.openDatePicker()) {
              console.info('Use native date picker');
            } else {
              window.customDateId = generateId();
              insertOpts.push({
                insert: {
                  date: {
                    dateId: window.customDateId,
                    value: _this.getDateTimestamp(mention.object_id),
                    format: mention.object_id === 'now' ? {
                      showTime: true
                    } : null,
                    // для now в дате показываем время
                    name: mention.name
                  }
                }
              });
            }
          } else {
            var mentionParams = {
              type: mention.type,
              object_id: mention.object_id,
              id: generateMentionId(),
              name: mention.name
            };
            // записываем данные для кэша
            mentionCache[mention.object_id] = {
              type: mention.type,
              name: mention.name
            };
            if (mention.workspace_id) {
              mentionParams.workspace_id = mention.workspace_id;
              mentionCache[mention.object_id].workspace_id = mention.workspace_id;
            }
            // формируем операцию вставки
            var op = {
              insert: {
                mention: mentionParams
              }
            };
            insertOpts.push(op);
          }
          if (!_this.params.mentionMode || _this.params.mentionMode !== 'table') {
            insertOpts.push({
              insert: ' '
            });
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      ops.push.apply(ops, insertOpts);
      _this.cache.update(mentionCache);
      blot.applyForCharacters(ops);
      if (!_this.params.mentionMode || _this.params.mentionMode !== 'table') {
        var afterRange = {
          index: blot.offset(_this.scroll) + index + mentions.length * 2,
          length: 0
        };
        _this.scroll.selection.setRange(afterRange);
      }
      _this.end(mentions);
    });
    mentionManager_defineProperty(this, "scrollToMention", function (id) {
      var highlight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var container = _this.scrollingContainer;
      var node = _this.scroll.domNode.querySelector('[data-mention-id="' + id + '"]');
      if (!node) {
        return console.warn('Could not find mention with id', id);
      }
      var blot = getBlotForNode(node);
      if (!blot) {
        return console.warn('Could not find blot for node', node);
      }
      blot = normalizeToStoredBlot(blot);
      var blockNode = blot.getWrapper().domNode;
      var highlightParams = {
        node: blockNode,
        highlightClass: 'highlighted-block',
        timeout: 3000
      };
      (0,dom/* scrollToNode */.dp)(container, node, highlight && highlightParams || false, true);
    });
    mentionManager_defineProperty(this, "onCreateAndPasteMention", /*#__PURE__*/function () {
      var _ref4 = mentionManager_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(type, name) {
        var dataFn, mentionData;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dataFn = type === 'note' ? 'createAndResolveNote' : 'createAndResolveFolder';
                _context3.next = 3;
                return _this[dataFn](name);
              case 3:
                mentionData = _context3.sent;
                if (!mentionData) {
                  // reset selection to hide mention list
                  _this.end();
                } else {
                  _this.pasteMention([{
                    type: type,
                    object_id: mentionData.object_id,
                    name: mentionData.name || name
                  }]);
                }
              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return function (_x2, _x3) {
        return _ref4.apply(this, arguments);
      };
    }());
    mentionManager_defineProperty(this, "end", function (mentions) {
      if (_this.session) {
        _this.session.destroy();
      }
      _this.session = null;
      _this.failedQuery = 0;
      _this.renderListCoords = null;
      var container = _this.container;
      _this.render(container);
      _this.directionOfFirstRender = null;
      if (typeof _this.params.onMentionEnd == "function") {
        _this.params.onMentionEnd(mentions);
      }
      setTimeout(function () {
        container.removeAttribute('style');
      }, 200);
    });
    mentionManager_defineProperty(this, "start", /*#__PURE__*/function () {
      var _ref5 = mentionManager_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(blot, blotRange) {
        var params,
          native,
          blotRect,
          rangeRect,
          offsetX,
          offsetY,
          blockOffset,
          container,
          _args4 = arguments;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                params = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
                if (_this.options.enabled) {
                  _context4.next = 3;
                  break;
                }
                return _context4.abrupt("return");
              case 3:
                native = _this.scroll.selection.getRange()[1].native;
                _this.params = params;
                _this.session = new MentionSession({
                  anchor: blot,
                  queryStartIndex: blotRange.index,
                  manager: _this
                });
                if (native) {
                  blotRect = blot.domNode.getBoundingClientRect();
                  rangeRect = Array.from(native.getClientRects())[0];
                  if (rangeRect && blotRect) {
                    offsetX = rangeRect.x - blotRect.x;
                    offsetY = rangeRect.y - blotRect.y;
                    blockOffset = getContainerOffset(blot.domNode, _this.scrollingContainer);
                    _this.renderListCoords = {
                      x: blockOffset.x + offsetX,
                      y: blockOffset.y + offsetY,
                      lineHeight: rangeRect.height
                    };
                    _this.adjustPositionContinuously();
                  }
                  container = _this.container;
                  _this.render(container, true, {
                    loading: true
                  });
                  _this.getLastItems().then(function (result) {
                    _this.render(container, true, {
                      items: result.items,
                      query: '',
                      recent: true,
                      totalAmount: result.totalAmount
                    });
                  }).catch(function (err) {
                    if (err instanceof ClientOfflineError) {
                      _this.render(container, true, {
                        items: err
                      });
                    } else {
                      console.log(err);
                    }
                  });
                }
              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return function (_x4, _x5) {
        return _ref5.apply(this, arguments);
      };
    }());
    mentionManager_defineProperty(this, "updateCache", /*#__PURE__*/mentionManager_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var cache, data, toUpdate, id;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              cache = _this.cache.getAll();
              console.log('Cached mentions: ', cache);
              if (!_this.isMethodImplemented('updateMentionTitles')) {
                _context5.next = 7;
                break;
              }
              _context5.next = 5;
              return _this.options.updateMentionTitles(cache);
            case 5:
              data = _context5.sent;
              if (data && Object.keys(data).length) {
                toUpdate = {};
                for (id in cache) {
                  if (data[id]) {
                    toUpdate[id] = mentionManager_objectSpread(mentionManager_objectSpread({}, cache[id]), {}, {
                      name: data[id]
                    });
                  }
                }
                _this.cache.update(toUpdate);
              }
            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })));
    this.editor = editor;
    this.scroll = scroll;
    this.options = options;
    this.cache = new MentionCache(this.editor);
    // не используем Object.assign, т.к. options могут быть экземпляром класса и функции не скопируются в новый объект
    if (typeof this.options.enabled === 'undefined') {
      this.options.enabled = true;
    }
    this.MentionListComponent = this.options.MentionListComponent || MentionList;
    this.session = null;
    this.failedQuery = 0;
    this.initContainer();
    this.maxNotesPerQuery = MAX_NOTES_PER_QUERY;
    this.renderListCoords = null;
    this.scrollingContainer = this.editor.getScrollingContainer();
    this.updateCache();
  }
  mentionManager_createClass(MentionManager, [{
    key: "initContainer",
    value: function initContainer() {
      if (!this.container) {
        this.container = document.createElement('div');
        this.container.id = 'mentions-search-container';
        this.editor.scrollingContainer.appendChild(this.container);
        this.render(this.container);
      }
    }
  }, {
    key: "isMethodImplemented",
    value: function isMethodImplemented(method) {
      return Boolean(this.options[method]);
    }

    //геттеры получения краткой информации о ментионе в mentionInfoComponent
  }, {
    key: "getUserInfo",
    value: function getUserInfo(userId, workspaceId) {
      if (this.isMethodImplemented('getUserInfo')) {
        return this.options.getUserInfo(userId, workspaceId);
      }
      return null;
    }
  }, {
    key: "getFolderInfo",
    value: function getFolderInfo(folderId, workspaceId) {
      if (this.isMethodImplemented('getFolderInfo')) {
        return this.options.getFolderInfo(folderId, workspaceId);
      }
      return null;
    }
  }, {
    key: "getNoteTeaser",
    value: function getNoteTeaser(noteId, workspaceId) {
      if (this.isMethodImplemented('getNoteTeaser')) {
        return this.options.getNoteTeaser(noteId, workspaceId);
      }
      return null;
    }
  }, {
    key: "getWorkspaceInfo",
    value: function getWorkspaceInfo(workspaceId) {
      if (this.isMethodImplemented('getWorkspaceInfo')) {
        return this.options.getWorkspaceInfo(workspaceId);
      }
      return null;
    }
  }, {
    key: "createAndResolveNote",
    value: function createAndResolveNote(name) {
      if (this.isMethodImplemented('createNote')) {
        return this.options.createNote(name);
      }
      return null;
    }
  }, {
    key: "createAndResolveFolder",
    value: function createAndResolveFolder(name) {
      if (this.isMethodImplemented('createFolder')) {
        return this.options.createFolder(name);
      }
      return null;
    }
  }, {
    key: "onMentionsResolve",
    value: function onMentionsResolve(items) {
      if (items instanceof ClientOfflineError && this.failedQuery >= 0) {
        this.end();
        return;
      }
      if (!Object.keys(items).length) {
        if (this.failedQuery >= MAX_FAILED_QUERY) {
          this.end();
          return;
        }
        this.failedQuery++;
      }
    }
  }, {
    key: "getDateTimestamp",
    value:
    /**
     * По значению object_id возвращает правильный timestamp для даты
     * @param object_id
     * @returns {number}
     */
    function getDateTimestamp(object_id) {
      var now = Date.now();
      var nowWithoutTime = getTimestampWithZeroTime(now);
      if (object_id === 'now') {
        return now;
      }
      if (object_id === 'today') {
        return nowWithoutTime;
      }
      if (object_id === 'tomorrow') {
        return nowWithoutTime + 86400 * 1000;
      }
      return object_id;
    }
  }, {
    key: "getMentionTitle",
    value: function getMentionTitle(objectType, objectId) {
      var workspaceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      if (this.isMethodImplemented('getMentionTitle')) {
        return this.options.getMentionTitle(objectType, objectId, workspaceId);
      }
      return false;
    }
  }, {
    key: "render",
    value: function render(container) {
      var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var MentionListComponent = this.MentionListComponent;
      (0,preact_module/* render */.sY)((0,preact_module.h)(preact_transition_group/* default */.Z, {
        transitionName: "mention-list",
        transitionEnterTimeout: 200,
        transitionLeaveTimeout: 200
      }, show && this.session ? (0,preact_module.h)(MentionListComponent, mentionManager_extends({
        queryString: this.session.queryString,
        getUserAvatar: this.getUserAvatar,
        pasteMention: this.pasteMention,
        maxNotesPerQuery: this.maxNotesPerQuery,
        searchItems: this.searchItems,
        wantsToClose: this.end,
        editor: this.editor,
        i18n: this.editor.plugins.i18n,
        platform: this.editor.platform,
        onViewAll: this.onViewAll,
        session: this.session,
        getNextNotes: this.getNextNotes,
        onCreateAndPasteMention: this.onCreateAndPasteMention
      }, props, {
        options: this.options
      })) : null), container);
    }
  }, {
    key: "adjustPositionContinuously",
    value: function adjustPositionContinuously() {
      var _this2 = this;
      var clear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var adjust = function adjust() {
        if (!_this2.renderListCoords) {
          return;
        }
        if (!_this2.container) {
          return;
        }
        _this2.updatePosition();
        requestAnimationFrame(adjust);
      };
      if (clear) {
        cancelAnimationFrame(adjust);
      } else {
        adjust();
      }
    }
  }, {
    key: "updatePosition",
    value: function updatePosition() {
      var offsetBetweenEditorAndScroll = this.scrollingContainer !== this.editor.scrollingContainer && getContainerOffset(this.editor.scrollingContainer, this.scrollingContainer) || {
        x: 0,
        y: 0
      };
      var _this$renderListCoord = this.renderListCoords,
        x = _this$renderListCoord.x,
        y = _this$renderListCoord.y,
        lineHeight = _this$renderListCoord.lineHeight;
      x -= offsetBetweenEditorAndScroll.x;
      y -= offsetBetweenEditorAndScroll.y;
      var _this$container$getBo = this.container.getBoundingClientRect(),
        width = _this$container$getBo.width,
        height = _this$container$getBo.height;
      var containerRect = this.scrollingContainer.getBoundingClientRect();
      var toBottomDistance = containerRect.height + this.scrollingContainer.scrollTop - offsetBetweenEditorAndScroll.y - y - lineHeight;
      var toTopDistance = y - this.scrollingContainer.scrollTop;
      toTopDistance += this.scrollingContainer.scrollTop >= offsetBetweenEditorAndScroll.y && offsetBetweenEditorAndScroll.y || 0;
      var toRightDistance = containerRect.width - x;
      var listNode = this.container.querySelector('.mention-search-scroll');
      //рендер сверху, если сверху больше места
      if (this.directionOfFirstRender === 'top' || toTopDistance > toBottomDistance && !this.directionOfFirstRender) {
        //устанавливаем max-height если контейнер не влазит в область видимости сверху
        if (toTopDistance < height) {
          if (listNode && !listNode.style.maxHeight) {
            listNode.style.maxHeight = toTopDistance + 'px';
            this.container.style.top = y - toTopDistance + 'px';
          }
        } else {
          this.container.style.top = y - height + 'px';
        }
        this.directionOfFirstRender = 'top';
      }
      //рендер снизу, если снизу места больше
      else {
        //устанавливаем max-height если контейнер не влазит в область видимости снизу
        if (toBottomDistance < height) {
          if (listNode && !listNode.style.maxHeight) {
            listNode.style.maxHeight = toBottomDistance + 'px';
          }
        }
        this.container.style.top = y + lineHeight + 'px';
        this.directionOfFirstRender = 'bottom';
      }
      if (x > toRightDistance && x > width && toRightDistance < width) {
        this.container.style.left = x - width + 'px';
      } else {
        this.container.style.left = x + 'px';
      }
    }

    /**
     * @param  {Blot} blot
     * @param  {Range} blotRange
     * @param  {Object} params {
     *  onMentionEnd: Функция, которая будет вызвана после end()
     *  customPlaceholder: Альтернативный текст плейсхолдера (для таблиц)
     *  mentionMode: 'table' для таблиц
     * }
     */
  }]);
  return MentionManager;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/attachmentWatcher/index.js
function attachmentWatcher_toConsumableArray(arr) { return attachmentWatcher_arrayWithoutHoles(arr) || attachmentWatcher_iterableToArray(arr) || attachmentWatcher_unsupportedIterableToArray(arr) || attachmentWatcher_nonIterableSpread(); }
function attachmentWatcher_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function attachmentWatcher_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function attachmentWatcher_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return attachmentWatcher_arrayLikeToArray(arr); }














function attachmentWatcher_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = attachmentWatcher_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function attachmentWatcher_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return attachmentWatcher_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return attachmentWatcher_arrayLikeToArray(o, minLen); }
function attachmentWatcher_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function attachmentWatcher_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function attachmentWatcher_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function attachmentWatcher_createClass(Constructor, protoProps, staticProps) { if (protoProps) attachmentWatcher_defineProperties(Constructor.prototype, protoProps); if (staticProps) attachmentWatcher_defineProperties(Constructor, staticProps); return Constructor; }
function attachmentWatcher_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var watcherInstance = null;

/**
 * Watches attachments deletions and restores in order to make them removed on the server
 */
var AttachmentWatcher = /*#__PURE__*/function () {
  function AttachmentWatcher(_ref) {
    var _this = this;
    var scroll = _ref.scroll,
      editor = _ref.editor,
      options = _ref.options;
    attachmentWatcher_classCallCheck(this, AttachmentWatcher);
    attachmentWatcher_defineProperty(this, "yjsMapsObserver", function (changeSets) {
      var _iterator = attachmentWatcher_createForOfIteratorHelper(changeSets),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var changeSet = _step.value;
          if (changeSet.keysChanged && changeSet.keysChanged.has('attachmentGlobalId')) {
            var target = changeSet.target;
            if (target && target.get) {
              var attachmentGlobalId = target.get('attachmentGlobalId');
              if (attachmentGlobalId) {
                _this.addedIds.add(attachmentGlobalId);
              }
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    attachmentWatcher_defineProperty(this, "onBlotRemoved", function (_ref2) {
      var id = _ref2.id;
      try {
        var map = _this.editor.store.getMap(id);
        if (!map) {
          // возможно было выполнено UNDO и мапа блота теперь нету вообще
          return;
        }
        var attachmentGlobalIds = [];
        if (map.get('type') === 'table') {
          // need to mark all the table attachments as removed
          var Table = _this.editor.parchment.query('table');
          var blotsIds = Table.getAttachments(_this.editor, map);
          var _iterator2 = attachmentWatcher_createForOfIteratorHelper(blotsIds),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var blotId = _step2.value;
              var _map = _this.editor.store.getMap(blotId);
              if (_map) {
                var _attachmentGlobalId = _map.get('attachmentGlobalId');
                if (_attachmentGlobalId) {
                  attachmentGlobalIds.push(_attachmentGlobalId);
                  _this.removedIds.add(_attachmentGlobalId);
                }
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
        var attachmentGlobalId = map.get('attachmentGlobalId');
        if (attachmentGlobalId) {
          _this.removedIds.add(attachmentGlobalId);
          attachmentGlobalIds.push(attachmentGlobalId);
        }
        if (attachmentGlobalIds.length) {
          _this.emitAttachmentsUpdates([attachmentGlobalId], {
            emitRestore: false
          });
        }
      } catch (err) {
        console.error('Error in AttachmentWatcher.onBlotRemoved: ', err);
      }
    });
    attachmentWatcher_defineProperty(this, "onEditorExec", function (_ref3) {
      var action = _ref3.action,
        params = _ref3.params;
      if (action !== 'convert-blot') {
        return;
      }
      if (params.attachmentGlobalId) {
        _this.changedIds.set(params.attachmentGlobalId, params.type);
        _this.emitAttachmentsUpdates();
      }
    });
    attachmentWatcher_defineProperty(this, "onEditorUndoRedo", function () {
      var attachmentsToCheck = Array.from(new Set([].concat(attachmentWatcher_toConsumableArray(_this.removedIds), attachmentWatcher_toConsumableArray(_this.changedIds), attachmentWatcher_toConsumableArray(_this.addedIds))));
      var blotsWithAttachments = _this.editor.findBlotsWithAttachment(attachmentsToCheck);

      // check whether blots in addedIds have been removed
      var foundAttachmentsIds = new Set();
      var _iterator3 = attachmentWatcher_createForOfIteratorHelper(blotsWithAttachments),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var attachmentGlobalId = _step3.value.attachmentGlobalId;
          foundAttachmentsIds.add(attachmentGlobalId);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      var _iterator4 = attachmentWatcher_createForOfIteratorHelper(_this.addedIds),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _attachmentGlobalId2 = _step4.value;
          if (!foundAttachmentsIds.has(_attachmentGlobalId2)) {
            _this.removedIds.add(_attachmentGlobalId2);
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      _this.emitAttachmentsUpdates(undefined, {
        blotsWithAttachments: blotsWithAttachments
      });
    });
    attachmentWatcher_defineProperty(this, "onAttachmentCleared", function (_ref4) {
      var attachmentGlobalId = _ref4.attachmentGlobalId;
      _this.removedIds.add(attachmentGlobalId);
    });
    this.editor = editor;
    // potentially removed attachments
    this.removedIds = new Set();
    // attachments that have been used in other blots by converting previous blots
    this.changedIds = new Map();
    // attachments that were added
    this.addedIds = new Set();
    this.editor.on(EVENT_BLOT_REMOVED, this.onBlotRemoved);
    this.editor.on(EVENT_ATTACHMENT_CLEARED, this.onAttachmentCleared);
    this.editor.on('exec', this.onEditorExec);
    this.editor.on('undo', this.onEditorUndoRedo);
    this.editor.on('redo', this.onEditorUndoRedo);
    this.editor.store.blocks.observeDeep(this.yjsMapsObserver);
  }
  attachmentWatcher_createClass(AttachmentWatcher, [{
    key: "emitAttachmentsUpdates",
    value: function emitAttachmentsUpdates(attachmentsToCheck) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this.editor.emitter.listenerCount(EVENT_ATTACHMENTS_UPDATE)) {
        return;
      }
      var changes = this.getAttachmentsUpdates(attachmentsToCheck, opts);
      if (Object.keys(changes).length > 0) {
        this.editor.emitter.emit(EVENT_ATTACHMENTS_UPDATE, changes);
      }
    }

    /**
     * Get updates for attachments, updates can have types:
     * - restore - if attachment was removed and then added again(by undo/redo)
     * - blotChange - if attachment was converted to another blot type
     * - delete - if attachment was removed
     * @param {*} attachmentsToCheck
     * @param {*} opts
     * @returns
     */
  }, {
    key: "getAttachmentsUpdates",
    value: function getAttachmentsUpdates(attachmentsToCheck) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // attachments to emit delete for
      var toEmitDeleteAttachments = new Set(this.removedIds);
      var updates = {};
      attachmentsToCheck = attachmentsToCheck || Array.from(new Set([].concat(attachmentWatcher_toConsumableArray(this.removedIds), attachmentWatcher_toConsumableArray(this.changedIds))));
      var blotsWithAttachments = opts.blotsWithAttachments || this.editor.findBlotsWithAttachment(attachmentsToCheck);
      var _iterator5 = attachmentWatcher_createForOfIteratorHelper(blotsWithAttachments),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _step5$value = _step5.value,
            attachmentGlobalId = _step5$value.attachmentGlobalId,
            blotName = _step5$value.blotName;
          toEmitDeleteAttachments.delete(attachmentGlobalId);
          if (this.removedIds.has(attachmentGlobalId) && opts.emitRestore !== false) {
            updates[attachmentGlobalId] = {
              type: 'restore'
            };
          }
          if (this.changedIds.has(attachmentGlobalId)) {
            updates[attachmentGlobalId] = {
              type: 'blotChange',
              blotName: blotName
            };
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      var _iterator6 = attachmentWatcher_createForOfIteratorHelper(toEmitDeleteAttachments.values()),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _attachmentGlobalId3 = _step6.value;
          updates[_attachmentGlobalId3] = {
            type: 'delete'
          };
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      return updates;
    }
  }]);
  return AttachmentWatcher;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/editorStyle/index.js
function editorStyle_slicedToArray(arr, i) { return editorStyle_arrayWithHoles(arr) || editorStyle_iterableToArrayLimit(arr, i) || editorStyle_unsupportedIterableToArray(arr, i) || editorStyle_nonIterableRest(); }
function editorStyle_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function editorStyle_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return editorStyle_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return editorStyle_arrayLikeToArray(o, minLen); }
function editorStyle_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function editorStyle_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function editorStyle_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }















function editorStyle_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function editorStyle_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function editorStyle_createClass(Constructor, protoProps, staticProps) { if (protoProps) editorStyle_defineProperties(Constructor.prototype, protoProps); if (staticProps) editorStyle_defineProperties(Constructor, staticProps); return Constructor; }
function editorStyle_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ALLOWED_THEMES = ['light', 'dark', 'brand-dark-ios'];
var EditorStyle = /*#__PURE__*/function () {
  function EditorStyle(_ref) {
    var _this = this;
    var scroll = _ref.scroll,
      editor = _ref.editor,
      options = _ref.options;
    editorStyle_classCallCheck(this, EditorStyle);
    editorStyle_defineProperty(this, "scrollMapObserver", function () {
      if (_this._localSaved) return;
      var current = _this._getCurrentStyles();
      var style = _this.scroll.map.get('style');
      var size = _this.scroll.map.get('size');
      if (style !== current.style || size !== current.size) {
        _this._applyStyles({
          size: size || current.size,
          style: style || current.style
        });
      }
    });
    this.editor = editor;
    this.scroll = scroll;
    this.options = options || {};
    this._localSaved = false;
    this.init();
  }
  editorStyle_createClass(EditorStyle, [{
    key: "init",
    value: function init() {
      var style = this.options.style || this.scroll.map.get('style') || 'normal';
      var size = this.options.size || this.scroll.map.get('size') || 'normal';
      this._applyStyles({
        size: size,
        style: style
      });
      this.editor.store.observe(this.scroll.map, this.scrollMapObserver);
    }
  }, {
    key: "_getCurrentStyles",
    value: function _getCurrentStyles() {
      var classList = Array.from(this.scroll.domNode.classList);
      var size, style;
      for (var _i = 0, _classList = classList; _i < _classList.length; _i++) {
        var item = _classList[_i];
        if (item.indexOf('size-') === 0) {
          size = item.replace('size-', '');
        }
        if (item.indexOf('style-') === 0) {
          style = item.replace('style-', '');
        }
      }
      return {
        size: size,
        style: style
      };
    }
  }, {
    key: "_applyStyles",
    value: function _applyStyles(_ref2) {
      var size = _ref2.size,
        style = _ref2.style;
      var current = this._getCurrentStyles();
      if (current.size) {
        this.scroll.domNode.classList.remove('size-' + current.size);
      }
      if (current.style) {
        this.scroll.domNode.classList.remove('style-' + current.style);
      }
      this.scroll.domNode.classList.add('size-' + size);
      this.scroll.domNode.classList.add('style-' + style);
      this.editor.emit(EVENT_STYLE_CHANGED, {
        size: size,
        style: style
      });
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      return this._getCurrentStyles();
    }
  }, {
    key: "setStyle",
    value: function setStyle(_ref3) {
      var _this2 = this;
      var size = _ref3.size,
        style = _ref3.style;
      var persistent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this._applyStyles({
        size: size && size.toLowerCase() || this._getCurrentStyles().size || 'normal',
        style: style && style.toLowerCase() || this._getCurrentStyles().style || 'normal'
      });
      if (persistent) {
        this.editor.store.transaction(function () {
          if (size && _this2.scroll.map.get('size') !== size) {
            _this2.scroll.map.set('size', size);
          }
          if (style && _this2.scroll.map.get('style') !== style) {
            _this2.scroll.map.set('style', style);
          }
        }, {
          action: 'setStyle'
        });
      } else {
        this._localSaved = true;
      }
    }
  }, {
    key: "setTheme",
    value: function setTheme() {
      var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
      if (ALLOWED_THEMES.includes(theme)) {
        var dialogRoot = document.body.getElementsByClassName('editor-root-dialog')[0];
        var _Array$from$filter = Array.from(this.editor.container.classList).filter(function (cls) {
            return cls.indexOf('theme-') === 0;
          }),
          _Array$from$filter2 = editorStyle_slicedToArray(_Array$from$filter, 1),
          currentThemeClass = _Array$from$filter2[0];
        if (currentThemeClass) {
          this.editor.container.classList.remove(currentThemeClass);
          dialogRoot && dialogRoot.classList.remove(currentThemeClass);
        }
        this.editor.container.classList.add('theme-' + theme);
        dialogRoot && dialogRoot.classList.add('theme-' + theme);
        this.editor.emitter.emit('set-theme', {
          theme: theme
        });
      } else {
        console.error('Theme "' + theme + '" is not supported with editor');
      }
    }
  }, {
    key: "getTheme",
    value: function getTheme() {
      var _Array$from$filter3 = Array.from(this.editor.container.classList).filter(function (cls) {
          return cls.indexOf('theme-') === 0;
        }),
        _Array$from$filter4 = editorStyle_slicedToArray(_Array$from$filter3, 1),
        currentThemeClass = _Array$from$filter4[0];
      var theme = currentThemeClass && currentThemeClass.replace('theme-', '') || null;
      if (!theme || theme === 'undefined' || typeof theme === 'undefined') {
        theme = document.body.children[0] && document.body.children[0].classList[1] && document.body.children[0].classList[1].replace('theme-', '') || 'light';
      }
      return theme;
    }
  }, {
    key: "setFocusMode",
    value: function setFocusMode() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      console.log('Focus mode: ', mode);
      this.editor.emitter.emit('set-focus-mode', {
        mode: mode
      });
    }
  }, {
    key: "getFocusMode",
    value: function getFocusMode() {
      var mode = this.editor.scroll.props.focusMode;
      if (typeof mode === 'undefined') {
        mode = false;
      }
      return mode;
    }
  }]);
  return EditorStyle;
}();

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/scss/profession-ask.scss
var profession_ask = __webpack_require__(14016);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/professionAsk/index.js
function professionAsk_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { professionAsk_typeof = function _typeof(obj) { return typeof obj; }; } else { professionAsk_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return professionAsk_typeof(obj); }










function professionAsk_extends() { professionAsk_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return professionAsk_extends.apply(this, arguments); }
function professionAsk_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function professionAsk_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function professionAsk_createClass(Constructor, protoProps, staticProps) { if (protoProps) professionAsk_defineProperties(Constructor.prototype, protoProps); if (staticProps) professionAsk_defineProperties(Constructor, staticProps); return Constructor; }
function professionAsk_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) professionAsk_setPrototypeOf(subClass, superClass); }
function professionAsk_setPrototypeOf(o, p) { professionAsk_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return professionAsk_setPrototypeOf(o, p); }
function professionAsk_createSuper(Derived) { var hasNativeReflectConstruct = professionAsk_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = professionAsk_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = professionAsk_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return professionAsk_possibleConstructorReturn(this, result); }; }
function professionAsk_possibleConstructorReturn(self, call) { if (call && (professionAsk_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return professionAsk_assertThisInitialized(self); }
function professionAsk_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function professionAsk_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function professionAsk_getPrototypeOf(o) { professionAsk_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return professionAsk_getPrototypeOf(o); }
function professionAsk_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var CONTAINER_CLASS = 'profession-ask-container';
var LEFT_CORRECTION = 16;
var professionTransitionDuration = parseInt(profession_ask.professionTransitionDuration);
var ProfessionAskComponent = /*#__PURE__*/function (_Component) {
  professionAsk_inherits(ProfessionAskComponent, _Component);
  var _super = professionAsk_createSuper(ProfessionAskComponent);
  function ProfessionAskComponent() {
    var _this;
    professionAsk_classCallCheck(this, ProfessionAskComponent);
    _this = _super.call(this);
    professionAsk_defineProperty(professionAsk_assertThisInitialized(_this), "onProfessionChange", function (event) {
      _this.setState(function () {
        return {
          profession: event.target.value
        };
      });
    });
    professionAsk_defineProperty(professionAsk_assertThisInitialized(_this), "onSubmit", function () {
      _this.props.onSubmit(_this.state.profession);
    });
    professionAsk_defineProperty(professionAsk_assertThisInitialized(_this), "onCancel", function () {
      _this.props.onCancel();
    });
    professionAsk_defineProperty(professionAsk_assertThisInitialized(_this), "preventDefault", function (event) {
      event.preventDefault;
    });
    _this.state = {
      profession: ''
    };
    return _this;
  }
  professionAsk_createClass(ProfessionAskComponent, [{
    key: "render",
    value: function render() {
      var i18n = this.props.i18n;
      var profession = this.state.profession;
      var buttonAttributes = {};
      if (!profession) {
        buttonAttributes.disabled = true;
      }
      return (0,preact_module.h)(plugins_i18n/* IntlProvider */.Pj, null, (0,preact_module.h)("div", {
        className: "profession-ask"
      }, (0,preact_module.h)("div", {
        className: "close",
        onMouseDown: this.preventDefault,
        onClick: this.onCancel
      }, (0,preact_module.h)(icons/* IconCross */.WcQ, null)), (0,preact_module.h)("div", {
        className: "left-part"
      }, (0,preact_module.h)("div", {
        className: "icon-templates"
      }, (0,preact_module.h)(icons/* IconTemplates */.guv, null))), (0,preact_module.h)("div", {
        className: "right-part"
      }, (0,preact_module.h)("div", {
        className: "title"
      }, (0,preact_module.h)(plugins_i18n/* Text */.xv, {
        id: "profession_ask.title"
      })), (0,preact_module.h)("div", {
        className: "text"
      }, (0,preact_module.h)(plugins_i18n/* Text */.xv, {
        id: "profession_ask.text"
      })), (0,preact_module.h)("div", {
        className: "input"
      }, (0,preact_module.h)("div", {
        className: "pre-text"
      }, (0,preact_module.h)(plugins_i18n/* Text */.xv, {
        id: "profession_ask.i_am_a"
      })), (0,preact_module.h)("input", {
        onInput: this.onProfessionChange,
        value: profession,
        className: "dialog-input",
        type: "text",
        placeholder: i18n.get('profession_ask.placeholder')
      })), (0,preact_module.h)("div", {
        className: "button-container"
      }, (0,preact_module.h)("button", professionAsk_extends({
        className: "button button-primary"
      }, buttonAttributes, {
        onClick: this.onSubmit
      }), (0,preact_module.h)(plugins_i18n/* Text */.xv, {
        id: "profession_ask.request_template"
      }))))));
    }
  }]);
  return ProfessionAskComponent;
}(preact_module/* Component */.wA);
var ProfessionAsk = /*#__PURE__*/function () {
  function ProfessionAsk(_ref) {
    var _this2 = this;
    var scroll = _ref.scroll,
      editor = _ref.editor,
      options = _ref.options;
    professionAsk_classCallCheck(this, ProfessionAsk);
    professionAsk_defineProperty(this, "onScrollUpdate", function () {
      if (!_this2.container) {
        return;
      }
      if (!_this2.editor.isEmpty()) {
        _this2.hide();
      }
    });
    professionAsk_defineProperty(this, "onSubmit", function (profession) {
      _this2.hide();
      if (!_this2.options.onSubmit) {
        return console.warn('professionAsk.onSubmit is not set, skipping');
      }
      _this2.options.onSubmit(profession);
      _this2.editor.plugins.notificationManager.toast(_this2.editor.plugins.i18n.get('profession_ask.sucess_message'));
    });
    professionAsk_defineProperty(this, "onCancel", function () {
      _this2.hide();
      if (!_this2.options.onCancel) {
        return console.warn('professionAsk.onCancel is not set, skipping');
      }
      _this2.options.onCancel();
    });
    this.editor = editor;
    this.scroll = scroll;
    this.options = options || {};
    this.container = null;
    this.animationFrameRequest = null;
    if (this.options.enable !== true) {
      return;
    }
    this.editor.emitter.once('editor-ready', function () {
      _this2.show();
    });
    this.editor.on('SCROLL_UPDATE', this.onScrollUpdate);
  }
  professionAsk_createClass(ProfessionAsk, [{
    key: "adjustPosition",
    value: function adjustPosition() {
      var scrollRect = this.editor.scroll.domNode.getBoundingClientRect();
      var editorContainerRect = this.editor.container.getBoundingClientRect();
      this.container.style.left = scrollRect.left - editorContainerRect.left - LEFT_CORRECTION + 'px';
    }
  }, {
    key: "adjustPositionContinuously",
    value: function adjustPositionContinuously() {
      var _this3 = this;
      var adjust = function adjust() {
        if (!_this3.container) {
          return;
        }
        _this3.adjustPosition();
        _this3.animationFrameRequest = requestAnimationFrame(adjust);
      };
      this.animationFrameRequest = requestAnimationFrame(adjust);
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this4 = this;
      this.editor.off('SCROLL_UPDATE', this.onScrollUpdate);
      this.container.classList.add('hidden');
      setTimeout(function () {
        _this4.container.parentNode.removeChild(_this4.container);
        _this4.container = null;
      }, professionTransitionDuration);
    }
  }, {
    key: "show",
    value: function show() {
      if (!this.editor.isEmpty()) {
        return;
      }
      this.container = document.createElement('div');
      this.container.classList.add(CONTAINER_CLASS);
      this.editor.editorBody.appendChild(this.container);
      (0,preact_module/* render */.sY)((0,preact_module.h)(ProfessionAskComponent, {
        i18n: this.editor.plugins.i18n,
        onSubmit: this.onSubmit,
        onCancel: this.onCancel
      }), this.container);
      this.adjustPositionContinuously();
    }
  }, {
    key: "destroy",
    value: function destroy() {}
  }]);
  return ProfessionAsk;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/reminderManager/index.js
function reminderManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function reminderManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function reminderManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) reminderManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) reminderManager_defineProperties(Constructor, staticProps); return Constructor; }
var ReminderManager = /*#__PURE__*/function () {
  function ReminderManager(_ref) {
    var editor = _ref.editor,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;
    reminderManager_classCallCheck(this, ReminderManager);
    this.editor = editor;
    this.options = options || {};
  }
  reminderManager_createClass(ReminderManager, [{
    key: "setReminder",
    value: function setReminder(id) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this.options.setReminder) {
        this.options.setReminder(id, params);
      } else {
        console.warn('has no setReminder function', id, params);
      }
    }
  }, {
    key: "onSetReminder",
    value: function onSetReminder(value) {
      if (this.options.onSetReminder) {
        this.options.onSetReminder(value);
      } else {
        console.warn('has no onSetReminder function', value);
      }
    }
  }, {
    key: "deleteReminder",
    value: function deleteReminder(id, params) {
      if (this.editor.destroyed !== true) {
        if (this.options.deleteReminder) {
          this.options.deleteReminder(id, params);
        } else {
          console.warn('has no deleteReminder function', id);
        }
      }
    }
  }]);
  return ReminderManager;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/imageManager/index.js
function imageManager_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { imageManager_typeof = function _typeof(obj) { return typeof obj; }; } else { imageManager_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return imageManager_typeof(obj); }
function imageManager_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = imageManager_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function imageManager_toConsumableArray(arr) { return imageManager_arrayWithoutHoles(arr) || imageManager_iterableToArray(arr) || imageManager_unsupportedIterableToArray(arr) || imageManager_nonIterableSpread(); }
function imageManager_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function imageManager_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return imageManager_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return imageManager_arrayLikeToArray(o, minLen); }
function imageManager_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function imageManager_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return imageManager_arrayLikeToArray(arr); }
function imageManager_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
















function imageManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function imageManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function imageManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) imageManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) imageManager_defineProperties(Constructor, staticProps); return Constructor; }





var IMAGE_BLOT_TYPES = {
  image: 'ImageBlot',
  file: 'FileBlot',
  html: 'HTMLBlot',
  table: 'TableAttachment'
};
var ImageManager = /*#__PURE__*/function () {
  function ImageManager(_ref) {
    var editor = _ref.editor,
      scroll = _ref.scroll,
      options = _ref.options;
    imageManager_classCallCheck(this, ImageManager);
    this.editor = editor;
    this.scroll = scroll;
    this.options = options || {};
  }
  imageManager_createClass(ImageManager, [{
    key: "getAllImageAttachmnets",
    value: function getAllImageAttachmnets() {
      var _this = this;
      // тут сразу игнорируем не загруженные, битые и т.д., чтобы не возникало ошибок
      return this.scroll.descendants(function (blot) {
        return blot instanceof attachment_image || blot instanceof html || blot instanceof file || blot instanceof table_table;
      }).reduce(function (attachments, blot) {
        if (blot instanceof attachment_image && blot.props && blot.props.attachment) {
          var attachment = Object.assign({}, blot.props.attachment);
          attachment.blotType = IMAGE_BLOT_TYPES.image;
          var caption = blot.getWrapper().caption;
          if (caption.props.show) {
            attachment.caption = caption.getText();
          }
          if (blot.disallowDownloading) {
            attachment.disallowDownloading = true;
          }
          if (blot.map.get('unsplash')) {
            attachment.isPseudoImg = true;
            var originalSize = blot.map.get('originalSize');
            if (originalSize) {
              attachment.width = originalSize.width;
              attachment.height = originalSize.height;
            }
          }
          attachments.push(attachment);
        }
        if (blot instanceof file && blot.props && blot.props.attachment && blot.props.attachment.type === 'image') {
          var _attachment = Object.assign({}, blot.props.attachment);
          _attachment.blotType = IMAGE_BLOT_TYPES.file;
          var _caption = blot.getWrapper().caption;
          if (_caption.props.show) {
            _attachment.caption = _caption.getText();
          }
          if (blot.disallowDownloading) {
            _attachment.disallowDownloading = true;
          }
          attachments.push(_attachment);
        }
        if (blot instanceof table_table) {
          var tableImageAttachments = ImageManager.getTableImageAttachments(blot, _this.editor);
          if (tableImageAttachments && tableImageAttachments.length) {
            attachments.push.apply(attachments, imageManager_toConsumableArray(tableImageAttachments));
          }
        }
        if (blot instanceof html) {
          // у HTML блота в конструкторе сразу объявлен кэш, поэтому можно не проверять на существование
          var htmlAttachments = Object.values(blot.cache.attachments);
          for (var _i = 0, _htmlAttachments = htmlAttachments; _i < _htmlAttachments.length; _i++) {
            var _attachment2 = _htmlAttachments[_i];
            _attachment2.blotType = IMAGE_BLOT_TYPES.html;
          }
          attachments.push.apply(attachments, htmlAttachments);
        }
        return attachments;
      }, []);
    }
  }, {
    key: "getNextImageAttachment",
    value: function getNextImageAttachment(attachmentGlobalId) {
      var onlyForAttachments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var attachments = onlyForAttachments && onlyForAttachments.length ? onlyForAttachments : this.getAllImageAttachmnets();
      var globalId = ImageManager.normalize(attachmentGlobalId, attachments);
      if (!globalId) return;
      var currentIndex = attachments.findIndex(function (attachment) {
        return attachment.global_id === globalId;
      });
      if (currentIndex < 0) {
        console.error("ImageManager error: attachment with global_id \"".concat(globalId, "\" not found"));
        return;
      }
      var index = currentIndex === attachments.length - 1 ? 0 : currentIndex + 1;
      return attachments[index];
    }
  }, {
    key: "getPrevImageAttachment",
    value: function getPrevImageAttachment(attachmentGlobalId) {
      var onlyForAttachments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var attachments = onlyForAttachments && onlyForAttachments.length ? onlyForAttachments : this.getAllImageAttachmnets();
      var globalId = ImageManager.normalize(attachmentGlobalId, attachments);
      if (!globalId) return;
      var currentIndex = attachments.findIndex(function (attachment) {
        return attachment.global_id === globalId;
      });
      if (currentIndex < 0) {
        console.error("ImageManager error: attachment with global_id \"".concat(globalId, "\" not found"));
        return;
      }
      var index = currentIndex === 0 ? attachments.length - 1 : currentIndex - 1;
      return attachments[index];
    }
  }, {
    key: "enterFullSize",
    value: function enterFullSize(attachmentGlobalId) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var processed = false;
      if (this.options.enterFullSize) {
        processed = this.options.enterFullSize(attachmentGlobalId, params);
        if (typeof processed === 'undefined') {
          processed = true;
        }
      }
      return processed;
    }
  }], [{
    key: "getTableImageAttachments",
    value: function getTableImageAttachments(blot, editor) {
      var _blot$getContent;
      var content = (_blot$getContent = blot.getContent()) === null || _blot$getContent === void 0 ? void 0 : _blot$getContent.content;
      var attachments = [];
      if (content) {
        var rows = content.rows;
        if (rows && rows.length) {
          var _iterator = imageManager_createForOfIteratorHelper(rows),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var row = _step.value;
              var children = row.children;
              if (children && children.length) {
                var _iterator2 = imageManager_createForOfIteratorHelper(children),
                  _step2;
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    var cell = _step2.value;
                    if (cell.cellType === 'attachment' && cell.attachments && cell.attachments.length) {
                      var _iterator3 = imageManager_createForOfIteratorHelper(cell.attachments),
                        _step3;
                      try {
                        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                          var _attachmentBlot$props, _attachmentBlot$props2;
                          var attachmentBlotId = _step3.value;
                          var attachmentBlot = editor.findById(attachmentBlotId);
                          if (attachmentBlot && (attachmentBlot === null || attachmentBlot === void 0 ? void 0 : (_attachmentBlot$props = attachmentBlot.props) === null || _attachmentBlot$props === void 0 ? void 0 : (_attachmentBlot$props2 = _attachmentBlot$props.attachment) === null || _attachmentBlot$props2 === void 0 ? void 0 : _attachmentBlot$props2.type) === 'image') {
                            var attachment = Object.assign({}, attachmentBlot.props.attachment);
                            attachment.blotType = IMAGE_BLOT_TYPES.table;
                            if (attachmentBlot.disallowDownloading) {
                              attachment.disallowDownloading = true;
                            }
                            attachments.push(attachment);
                          }
                        }
                      } catch (err) {
                        _iterator3.e(err);
                      } finally {
                        _iterator3.f();
                      }
                    }
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }
      return attachments;
    }
  }, {
    key: "normalize",
    value: function normalize(attachmentGlobalId, attachments) {
      var result = null;
      if (imageManager_typeof(attachmentGlobalId) === 'object' && !Array.isArray(attachmentGlobalId)) {
        if (attachmentGlobalId.global_id) {
          result = attachmentGlobalId.global_id;
        } else {
          console.error('ImageManager error: attachment object has no value with key "global_id"');
        }
      }
      if (typeof attachmentGlobalId !== 'string') {
        console.error('ImageManager error: attachmentGlobalId must be a string');
      } else if (stringIsUrl(attachmentGlobalId) || attachmentGlobalId.startsWith('/box/attachment/')) {
        var attachment = attachments.find(function (attach) {
          return attach.url === attachmentGlobalId;
        });
        if (attachment) {
          result = attachment.global_id;
        } else {
          console.error("ImageManager error: attachment with url \"".concat(attachmentGlobalId, "\" not found"));
          return;
        }
      } else {
        result = attachmentGlobalId;
      }
      if (!result) {
        console.error('ImageManager error: first argument must be an attachment object or attachmentGlobalId string or image url');
      }
      return result;
    }
  }]);
  return ImageManager;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/remoteFileManager/index.js


function remoteFileManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function remoteFileManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function remoteFileManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) remoteFileManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) remoteFileManager_defineProperties(Constructor, staticProps); return Constructor; }
function remoteFileManager_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var RemoteFileManager = /*#__PURE__*/function () {
  function RemoteFileManager(_ref) {
    var _this = this;
    var scroll = _ref.scroll,
      editor = _ref.editor,
      options = _ref.options;
    remoteFileManager_classCallCheck(this, RemoteFileManager);
    remoteFileManager_defineProperty(this, "isServiceSupported", function (service) {
      if (_this.options.supportedServices && _this.options.supportedServices instanceof Array) {
        return _this.options.supportedServices.includes(service);
      } else {
        return false;
      }
    });
    this.editor = editor;
    this.scroll = scroll;
    this.options = options || {};
  }
  remoteFileManager_createClass(RemoteFileManager, [{
    key: "chooseFile",
    value: function chooseFile() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.service) {
        console.error('#RemoteFileManager.chooseFile: sevice parameter in options required');
        return false;
      }
      if (!this.isServiceSupported(options.service)) {
        console.error('Service "' + options.service + '" is not supported');
        return false;
      }
      return this.options.chooseFile(options);
    }
  }]);
  return RemoteFileManager;
}();

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/util/popupMenuItemsNav.js
var popupMenuItemsNav = __webpack_require__(28480);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/convertLinkManager/index.js
function convertLinkManager_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = convertLinkManager_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function convertLinkManager_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { convertLinkManager_typeof = function _typeof(obj) { return typeof obj; }; } else { convertLinkManager_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return convertLinkManager_typeof(obj); }
function convertLinkManager_slicedToArray(arr, i) { return convertLinkManager_arrayWithHoles(arr) || convertLinkManager_iterableToArrayLimit(arr, i) || convertLinkManager_unsupportedIterableToArray(arr, i) || convertLinkManager_nonIterableRest(); }
function convertLinkManager_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function convertLinkManager_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return convertLinkManager_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return convertLinkManager_arrayLikeToArray(o, minLen); }
function convertLinkManager_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function convertLinkManager_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function convertLinkManager_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function convertLinkManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function convertLinkManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function convertLinkManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) convertLinkManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) convertLinkManager_defineProperties(Constructor, staticProps); return Constructor; }
function convertLinkManager_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
































var convertLinkManager_linkFormAppearDuration = (link_form_default()).linkFormAppearDuration;
var i18nMentionTypeKeys = {
  'note': 'link_to_note',
  'folder': 'link_to_folder',
  'workspace': 'link_to_workspace'
};
var Services = Object.assign({}, remoteFrameOptions_frames, widgets, skipIframelyEmbeds);
var ConvertLinkManager = /*#__PURE__*/function () {
  function ConvertLinkManager(_ref) {
    var _this = this;
    var editor = _ref.editor,
      scroll = _ref.scroll,
      options = _ref.options;
    convertLinkManager_classCallCheck(this, ConvertLinkManager);
    convertLinkManager_defineProperty(this, "onEditorDeltaChange", function (event) {
      if (event.source === 'user') {
        _this.hide();
      }
    });
    convertLinkManager_defineProperty(this, "onUndo", function () {
      _this.hide();
    });
    convertLinkManager_defineProperty(this, "onChooseUrl", function () {
      var _this$props = _this.props,
        blot = _this$props.blot,
        linkBlot = _this$props.linkBlot,
        blotRange = _this$props.blotRange,
        url = _this$props.url;
      var props = _this.props;
      _this.hide();
      if (!urlHasProtocol(url)) {
        _this.setLoading(props);
        _this.editor.plugins.bookmarkManager.getBookmarkMeta(url, 5000).then(function (data) {
          var urlWithProtocol = data.protocol ? data.protocol + url : 'http://' + url;
          _this.changeLinkWithCorrectRange(blot, linkBlot, urlWithProtocol, urlWithProtocol, true);
        }).catch(function (err) {
          _this.editor.plugins.notificationManager.toast(_this.editor.plugins.i18n.get('convert_link.convert_error'));
          console.error(err);
        }).finally(function () {
          _this.setLoading(props, false);
        });
      } else {
        var ops = [{
          retain: blotRange.index
        }, {
          insert: ' '
        }];
        blot.applyForCharacters(ops);
        _this.scroll.selection.setRange({
          index: blot.offset(_this.scroll) + blotRange.index + 1,
          length: 0
        });
      }
    });
    convertLinkManager_defineProperty(this, "onChooseTitle", function () {
      var _this$props2 = _this.props,
        blot = _this$props2.blot,
        linkBlot = _this$props2.linkBlot,
        url = _this$props2.url;
      var props = _this.props;
      _this.hide();
      _this.setLoading(props);
      if (_this.editor.plugins.bookmarkManager) {
        _this.editor.plugins.bookmarkManager.getBookmarkMeta(url, 5000).then(function (data) {
          if (data.name && data.name !== url) {
            var title = data.name;
            _this.changeLinkWithCorrectRange(blot, linkBlot, title, url, true);
          }
        }).catch(function (err) {
          _this.editor.plugins.notificationManager.toast(_this.editor.plugins.i18n.get('convert_link.convert_error'));
          console.error(err);
        }).finally(function () {
          _this.setLoading(props, false);
        });
      }
    });
    convertLinkManager_defineProperty(this, "onChooseMention", function () {
      var _this$props3 = _this.props,
        blot = _this$props3.blot,
        linkBlot = _this$props3.linkBlot,
        url = _this$props3.url,
        convertMentionParams = _this$props3.convertMentionParams;
      var convertType = convertMentionParams && convertMentionParams.type ? convertMentionParams.type : 'mention';
      var props = _this.props;
      _this.hide();
      if (_this.isMethodImplemented('convertUrl')) {
        _this.setLoading(props);
        _this.options.convertUrl(url, convertType).then(function (mention) {
          var linkBlotOffsetScroll = linkBlot.offset(_this.scroll);
          var linkBlotOffsetBlot = linkBlot.offset(blot);
          var currentLinkText = linkBlot.domNode.innerText;
          var _this$scroll$selectio = _this.scroll.selection.getRange(),
            _this$scroll$selectio2 = convertLinkManager_slicedToArray(_this$scroll$selectio, 1),
            quillRange = _this$scroll$selectio2[0];
          if (quillRange.index && quillRange.index > linkBlotOffsetScroll) {
            quillRange.index -= currentLinkText.length - 2;
          }
          var insertOp = {
            insert: {
              mention: {
                type: mention.type,
                object_id: mention.object_id,
                name: mention.name,
                id: generateMentionId()
              }
            }
          };
          if (mention.workspace_id) {
            insertOp.insert.mention.workspace_id = mention.workspace_id;
          }
          var changeDelta = [{
            retain: linkBlotOffsetBlot
          }, {
            delete: currentLinkText.length
          }, insertOp, {
            insert: ' '
          }];
          blot.map.get('characters').applyDelta(changeDelta);
          _this.scroll.selection.setRange(quillRange);
        }).catch(function (err) {
          _this.editor.plugins.notificationManager.toast(_this.editor.plugins.i18n.get('convert_link.convert_error'));
          console.error(err);
        }).finally(function () {
          _this.setLoading(props, false);
        });
      }
    });
    convertLinkManager_defineProperty(this, "onChooseEmbed", function () {
      _this.convertLinkTo('remote-frame');
      _this.hide();
    });
    convertLinkManager_defineProperty(this, "onChooseBookmark", function () {
      _this.convertLinkTo('bookmark');
      _this.hide();
    });
    convertLinkManager_defineProperty(this, "onChooseButton", function () {
      var _this$props4 = _this.props,
        blot = _this$props4.blot,
        linkBlot = _this$props4.linkBlot,
        url = _this$props4.url;
      var offset = linkBlot.offset(blot);
      var text = _this.editor.plugins.i18n.get('convert_link.button');
      // конвертируем ссылку в дефолтный текст кнопки
      var ops1 = [{
        retain: offset
      }, {
        delete: linkBlot.length()
      }];
      var ops2 = [{
        retain: offset
      }, {
        insert: text,
        attributes: {
          link: url
        }
      }];
      // конвертация в 2 операции иначе с одной опрецией не применяются атрибуты
      // TODO: в будущем надо перевести на методы NewTextBase, а не работать на прямую с дельтой,
      // так как методы нового блота, сами напрямую работают с дельтой, а последовательность действий
      // при работе с методами более понятная для поддержки
      blot.applyForCharacters(ops1);
      blot.applyForCharacters(ops2);
      _this.scroll.selection.setRange({
        index: blot.offset(_this.scroll) + offset,
        length: text.length
      });
      addLinkAction(_this.editor, {
        focusField: 'title'
      }, 'addButton', 'editButton');
      _this.hide();
    });
    convertLinkManager_defineProperty(this, "onMenuItemEnter", function (event) {
      if (!_this.container) return;
      var el = event.target;
      var menuItem = el.closest('.menu-item');
      var popup = {
        domNode: _this.container
      };
      new popupMenuItemsNav/* default */.Z({
        popup: popup,
        selector: '.menu-item',
        selectedClass: 'menu-item-selected'
      }).selectItems(menuItem);
    });
    convertLinkManager_defineProperty(this, "onEnterKeyAction", function (event, item) {
      event.preventDefault();
      if (item && item.hasAttribute('data-convert-to')) {
        _this.getItems()[item.getAttribute('data-convert-to')].action();
      }
    });
    convertLinkManager_defineProperty(this, "wantsToClose", function () {
      _this.hide();
    });
    this.editor = editor;
    this.scroll = scroll;
    this.options = options || {};
  }
  convertLinkManager_createClass(ConvertLinkManager, [{
    key: "isMethodImplemented",
    value: function isMethodImplemented(method) {
      return Boolean(this.options[method]);
    }
  }, {
    key: "onPasteLink",
    value: function onPasteLink(blot, blotRange, url) {
      if ((0,browser/* isOffline */.s9)()) return;
      var _blot$descendant = blot.descendant(Link, blotRange.index - 1),
        _blot$descendant2 = convertLinkManager_slicedToArray(_blot$descendant, 1),
        link = _blot$descendant2[0];
      if (link) {
        var linkNode = link.domNode;
        var service = false;
        for (var key in Services) {
          if (Services[key].pattern && Services[key].pattern.test(url)) {
            service = key;
            break;
          }
        }
        this.props = {
          blot: blot,
          blotRange: blotRange,
          url: url,
          linkNode: linkNode,
          linkBlot: link,
          service: service
        };
        this.show();
      }
    }
  }, {
    key: "changeLinkWithCorrectRange",
    value: function changeLinkWithCorrectRange(textBlot, linkBlot, text, url) {
      var addSpace = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var linkBlotOffsetScroll = linkBlot.offset(this.scroll);
      var linkBlotOffsetBlot = linkBlot.offset(textBlot);
      var currentLinkText = linkBlot.domNode.innerText;
      var _this$scroll$selectio3 = this.scroll.selection.getRange(),
        _this$scroll$selectio4 = convertLinkManager_slicedToArray(_this$scroll$selectio3, 1),
        quillRange = _this$scroll$selectio4[0];
      if (quillRange.index && quillRange.index > linkBlotOffsetScroll) {
        var diff = currentLinkText.length - text.length;
        quillRange.index -= diff;
        if (addSpace) {
          quillRange.index += 1;
        }
      }
      var changeDelta = [{
        retain: linkBlotOffsetBlot
      }, {
        insert: text,
        attributes: {
          link: url
        }
      }];
      if (addSpace) {
        changeDelta.push({
          insert: ' '
        });
      }
      if (textBlot.statics.isTextBlot) {
        textBlot.deleteText(linkBlotOffsetBlot, currentLinkText.length);
      } else {
        textBlot.deleteAt(linkBlotOffsetBlot, currentLinkText.length);
      }
      textBlot.applyForCharacters(changeDelta);
      this.scroll.selection.setRange(quillRange);
    }
  }, {
    key: "convertLinkTo",
    value: function convertLinkTo(type) {
      if (!type) return;
      var limitManager = this.editor.plugins.limitManager;
      var _this$props5 = this.props,
        blot = _this$props5.blot,
        blotRange = _this$props5.blotRange,
        url = _this$props5.url,
        service = _this$props5.service;
      var convert = blot.length() - 1 === url.length;
      limitManager && limitManager.freeze();
      if (!convert) {
        var ops = [{
          retain: blotRange.index - url.length
        }, {
          delete: url.length
        }];
        blot.applyForCharacters(ops);
      }
      // так как букмарк и фрейм используют входой параметр src одинаково, метод добавления блота одинаковый, за исключением параметра embedType, который букмарк проигнорирует
      var addBlotId;
      if (blot instanceof listItem) {
        addBlotId = blot.container.splitWithBlot(blot.index, type, {
          src: url,
          embedType: service && !skipIframelyEmbeds[service] ? service : null
        }).id;
      } else {
        addBlotId = blot.container.addBlot(type, {
          src: url,
          embedType: service && !skipIframelyEmbeds[service] ? service : null,
          after: blot.id
        }).id;
      }
      if (convert) {
        if (blot.parent.getTextBlot && blot.parent.getTextBlot() === blot) {
          blot.parent.remove();
        } else {
          blot.remove();
        }
      }
      var addedBlot = this.editor.findById(addBlotId).getWrapper();
      var setCursorBlot = addedBlot.next;
      if (setCursorBlot instanceof list_list) {
        setCursorBlot = setCursorBlot.children.head;
      }
      if (!setCursorBlot || !(setCursorBlot instanceof textLine)) {
        var paragraphId = addedBlot.container.addBlot('paragraph', {
          after: addBlotId
        }).id;
        setCursorBlot = this.editor.findById(paragraphId);
      }
      this.scroll.selection.setRange({
        index: setCursorBlot.offset(this.scroll),
        length: 0
      });
      limitManager && limitManager.unfreeze();
    }
  }, {
    key: "getMenuItemParams",
    value: function getMenuItemParams() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var i18n = this.editor.plugins.i18n;
      // проверяем есть все необходимые данные
      if (!(convertLinkManager_typeof(item) === 'object') || !item.type || !item.params || !item.params.type) return false;
      switch (item.type) {
        case 'mention':
          this.props.convertMentionParams = item.params;
          return {
            title: i18n.get('convert_link.' + i18nMentionTypeKeys[item.params.type]),
            action: this.onChooseMention,
            icon: icons/* IconNimbus */.ooQ
          };
        default:
          return false;
      }
    }
  }, {
    key: "getItems",
    value: function getItems() {
      var _this$props6,
        _this2 = this;
      var appItems = this.isMethodImplemented('getConvertOptionsForUrl') && (_this$props6 = this.props) !== null && _this$props6 !== void 0 && _this$props6.url ? this.options.getConvertOptionsForUrl(this.props.url) : false;
      var i18n = this.editor.plugins.i18n;
      var getIcon = function getIcon() {
        var _this2$props;
        if ((_this2$props = _this2.props) !== null && _this2$props !== void 0 && _this2$props.service) {
          if (Services[_this2.props.service].icon) {
            return Services[_this2.props.service].icon;
          }
        }
        return icons/* IconEmbedB */.JVE;
      };
      var items = {
        url: {
          title: i18n.get('convert_link.url'),
          action: this.onChooseUrl,
          icon: icons/* IconUrl */.j4Y
        },
        title: {
          title: i18n.get('convert_link.title'),
          action: this.onChooseTitle,
          icon: icons/* IconTitle */.Rwf
        },
        embed: {
          title: i18n.get('convert_link.embed'),
          action: this.onChooseEmbed,
          icon: getIcon()
        },
        bookmark: {
          title: i18n.get('convert_link.bookmark'),
          action: this.onChooseBookmark,
          icon: icons/* IconBookmark */.BZM
        },
        button: {
          title: i18n.get('convert_link.button'),
          action: this.onChooseButton,
          icon: icons/* IconButton */.hU
        }
      };
      if (appItems) {
        var _iterator = convertLinkManager_createForOfIteratorHelper(appItems),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            var params = this.getMenuItemParams(item);
            if (params) {
              items[item.type] = params;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      // тут добавил опциональную поддержку конвертации в некоторые блоки типа Caption,
      // в которых можно конвертировать только в текстовые объекты типа url и title.
      // Если у блота, в который вставляем ссылку есть массив названий объектов, в которые можно конвертировать ссылку,
      // возвращаем отфильтрованный по этому массиву объект
      if (Array.isArray(this.props.blot.constructor.convertLinkOpts)) {
        return Object.keys(items).reduce(function (result, key) {
          if (_this2.props.blot.constructor.convertLinkOpts.includes(key)) {
            result[key] = items[key];
          }
          return result;
        }, {});
      }
      return items;
    }
  }, {
    key: "createContainer",
    value: function createContainer() {
      var node = document.createElement('div');
      node.classList.add('convert-link-container');
      this.editor.scrollingContainer.appendChild(node);
      return node;
    }
  }, {
    key: "setLoading",
    value: function setLoading(props) {
      var loading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var node = props.linkNode;
      if (loading) {
        node.classList.add('convert-loading');
      } else if (node) {
        console.log(node);
        node.classList.remove('convert-loading');
      }
    }
  }, {
    key: "show",
    value: function show() {
      if (!this.container) {
        this.container = this.createContainer();
        this.render(this.container);
      }
      var container = this.container;
      setTimeout(this.render.bind(this, container, true), 0);
      this.editor.on('delta', this.onEditorDeltaChange);
      this.editor.on('undo', this.onUndo);
    }
  }, {
    key: "hide",
    value: function hide() {
      this.editor.off('delta', this.onEditorDeltaChange);
      this.editor.off('undo', this.onUndo);
      if (!this.container) return;
      var container = this.container;
      this.container = null;
      this.render(container);
      this.props = null;
      setTimeout(function () {
        container.parentNode.removeChild(container);
      }, convertLinkManager_linkFormAppearDuration);
    }
  }, {
    key: "render",
    value: function render(container) {
      var _this3 = this;
      var withMenu = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!container) return;
      var items = this.getItems();
      if (!Object.keys(items).length) return this.hide();
      (0,preact_module/* render */.sY)((0,preact_module.h)(preact_transition_group/* default */.Z, {
        transitionName: "link-form",
        transitionEnterTimeout: convertLinkManager_linkFormAppearDuration,
        transitionLeaveTimeout: convertLinkManager_linkFormAppearDuration
      }, withMenu ? (0,preact_module.h)(popupMenu/* default */.Z, {
        wantsToClose: this.wantsToClose,
        closeOnEsc: true,
        addClassName: "convert-link",
        anchorNode: this.props.linkNode,
        anchorOptions: {
          offset: '1px, 10px',
          placement: 'right-start',
          behavior: ['bottom', 'top', 'right-start'],
          priority: ['right', 'left', 'bottom', 'top'],
          boundariesElement: this.editor.getScrollingContainer(),
          overflowBoundariesElement: this.editor.getScrollingContainer()
        },
        removeOnPopperDestroy: true,
        keyNavigation: true,
        onEnterAction: this.onEnterKeyAction
      }, Object.keys(items).map(function (key) {
        return (0,preact_module.h)(popupMenuItem/* default */.Z, {
          id: key,
          idAttr: 'data-convert-to',
          icon: items[key].icon,
          text: items[key].title,
          menuStyle: key === 'url' ? 'selected' : '',
          onMouseDown: items[key].action,
          onMenuItemEnter: _this3.onMenuItemEnter
        });
      })) : null), container);
    }
  }]);
  return ConvertLinkManager;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/dateManager/index.js
function dateManager_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = dateManager_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function dateManager_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function dateManager_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { dateManager_ownKeys(Object(source), true).forEach(function (key) { dateManager_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { dateManager_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function dateManager_slicedToArray(arr, i) { return dateManager_arrayWithHoles(arr) || dateManager_iterableToArrayLimit(arr, i) || dateManager_unsupportedIterableToArray(arr, i) || dateManager_nonIterableRest(); }
function dateManager_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function dateManager_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return dateManager_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return dateManager_arrayLikeToArray(o, minLen); }
function dateManager_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function dateManager_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function dateManager_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




















function dateManager_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { dateManager_typeof = function _typeof(obj) { return typeof obj; }; } else { dateManager_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return dateManager_typeof(obj); }
function dateManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function dateManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function dateManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) dateManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) dateManager_defineProperties(Constructor, staticProps); return Constructor; }
function dateManager_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var DateManager = /*#__PURE__*/function () {
  function DateManager(_ref) {
    var editor = _ref.editor,
      scroll = _ref.scroll,
      options = _ref.options;
    dateManager_classCallCheck(this, DateManager);
    dateManager_defineProperty(this, "getDateFormat", function (format, params) {
      if (params.hasOwnProperty('showTime')) {
        if (typeof format === 'string') {
          format = JSON.parse('format');
        }
        format.showTime = !!params.showTime;
      }
      return format;
    });
    this.editor = editor;
    this.scroll = scroll;
    this.options = options || {};
    this.savedPosition = null;
  }

  /**
   * Открывает датапиккер
   * @param { Object } params - параметры
   * @param { String } params.dateId - идентификатора даты
   * @param { Number } params.value - timestamp
   * @param { Object } params.format - формат даты
   * @param { Boolean } params.format.showTime - показывать время
   * @param { String } params.name - название даты
   * 
   * @example 
   * ```
  gEditor.plugins.dateManager.openDatePicker({
  "dateId": "b10b6b",
  "value": 1645074420000,
  "format": {
      "showTime": true
  },
  "name": "Сейчас"
  })
   * ```
   * @returns 
   */
  dateManager_createClass(DateManager, [{
    key: "openDatePicker",
    value: function openDatePicker() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (this.options.openDatePicker) {
        this.savedPosition = {
          blot: this.editor.scroll.focusedBlot,
          range: this.editor.scroll.selection.getRange()[0],
          blotRange: this.editor.scroll.focusedBlot ? this.editor.scroll.selection.getRange({
            offsetBlot: this.editor.scroll.focusedBlot
          })[0] : null
        };
        return this.options.openDatePicker(params);
      }
      return false;
    }

    /**
     * Получает форматированне ремайндеры и алерты
     * @param params
     * @return {{reminders: {}, alerts: []}}
     */
  }, {
    key: "getReminders",
    value: function getReminders(params) {
      var _params$type = params.type,
        type = _params$type === void 0 ? '' : _params$type;
      var stringify = type !== 'table'; // для таблицы не нужно переводить ремайндеры и алерты в JSON

      var reminders = {};
      var alerts = [];
      if (params.hasOwnProperty('reminders')) {
        for (var key in params.reminders) {
          var seconds = params.reminders[key].seconds;
          var value = seconds / 60 + 'm';
          var text = value;
          if (seconds >= 3600) {
            value = seconds / 3600 + 'h';
            text = value;
          }
          if (seconds >= 24 * 3600) {
            value = seconds / (24 * 3600) + 'd';
            text = value;
          }
          alerts.push(seconds);
          reminders[key] = {
            value: value,
            text: text,
            seconds: seconds
          };
        }
      }
      return {
        reminders: alerts.length ? stringify ? JSON.stringify(reminders) : reminders : '',
        alerts: alerts.length ? stringify ? JSON.stringify(alerts) : alerts : ''
      };
    }
  }, {
    key: "insertDate",
    value: function insertDate() {
      var _this = this;
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      console.info('insertDate', params);
      var allowToInsertBlots = ['paragraph', 'listItemBullet', 'listItemNumber', 'listItemCheckbox'];
      var editor = this.editor;
      // получаем форматированные ремайндеры и алекты из параметров
      var _this$getReminders = this.getReminders(params),
        reminders = _this$getReminders.reminders,
        alerts = _this$getReminders.alerts;
      params.reminders = reminders;
      params.alerts = alerts;
      if (!params.timestamp || !parseInt(params.timestamp)) {
        console.info('params.timestamp is required', params);
        return false;
      }
      if (params.dateId) {
        var blot = this.getDateBlot(params.dateId);
        var map = this.editor.store.getMap(params.dateId);
        if (blot && blot.setValue && !blot._isMap) {
          blot.setValue(parseInt(params.timestamp));
          if (blot.updateDateFormat) {
            blot.updateDateFormat(params);
          } else {
            if (params.hasOwnProperty('showTime')) {
              blot.updateFormat({
                showTime: !!params.showTime
              });
            }
          }
          if (blot.setItem) {
            // устанавливаем ремайндеры и алерты если они есть
            if (typeof params.reminders === 'string' || dateManager_typeof(params.reminders) === 'object') {
              // сбрасываем ремайндеры и алерты для того чтобы при установки ремайндеры корректно записались в map
              blot.setItem('reminders', '{}');
              blot.setItem('alerts', '[]');
              // устанавливаем ремайндеры и алерты
              blot.setItem('reminders', params.reminders || {});
              blot.setItem('alerts', params.alerts || {});
            }
          }
        } else if (blot._isMap) {
          if (typeof params.reminders === 'string') {
            params.reminders = JSON.parse(params.reminders || '{}');
          }
          this.editor.store.transaction(function () {
            if (blot.map) {
              blot.map.set('timestamp', params.timestamp);
              if (params.reminders) {
                blot.map.set('reminders', params.reminders);
              }
              var format = _this.getDateFormat(blot.map.get('format') || {}, params);
              blot.map.set('format', format);
            }
            if (blot.ytext) {
              var _blot$ytext$toDelta = blot.ytext.toDelta(),
                _blot$ytext$toDelta2 = dateManager_slicedToArray(_blot$ytext$toDelta, 1),
                op = _blot$ytext$toDelta2[0];
              var _format = _this.getDateFormat(op.insert.date.format || {}, params);
              blot.ytext.applyDelta([{
                delete: 1
              }, {
                insert: {
                  date: dateManager_objectSpread(dateManager_objectSpread({}, op.insert.date), {}, {
                    format: _format,
                    timestamp: params.timestamp,
                    value: params.timestamp,
                    reminders: params.reminders
                  })
                }
              }]);
            }
          }, 'client');
        } else {
          return false;
        }
      } else {
        var _blot = this.savedPosition && this.savedPosition.blot || editor.scroll.focusedBlot;
        // в случае если вставка в таблицу как меншен
        if (_blot instanceof table_table) {
          var pos = _blot.getSelectionCache.current;
          var cellId = editor.findById(_blot.id).cellMapByPos(pos).get('id');
          var ytext = _blot.childMapByPos(pos).get('characters');
          var dateId = generateId();
          ytext.applyDelta([{
            delete: 1
          }, {
            insert: {
              date: {
                dateId: dateId,
                format: {
                  showTime: params.hasOwnProperty('showTime') ? !!params.showTime : false
                },
                timestamp: parseInt(params.timestamp),
                value: parseInt(params.timestamp),
                alerts: params.alerts || [],
                reminders: typeof params.reminders === 'string' ? JSON.parse(params.reminders || '{}') : params.reminders || {}
              }
            }
          }]);
          _blot.focusableFocus();
          _blot.tableBodyEmbed.fillCellData(pos, cellId, {
            render: true
          });
          _blot.componentOnAction({
            type: 'scroll-to-cell',
            blotId: cellId,
            select: true
          });
          return true;
        }
        if (!_blot) {
          console.info('No blot focused');
          return false;
        } else if (!allowToInsertBlots.includes(_blot.constructor.blotName)) {
          console.info("Focused blot is not in ".concat(allowToInsertBlots.join(', '), ":"), _blot.constructor.blotName);
          return false;
        } else {
          var range = this.savedPosition && this.savedPosition.range || this.editor.scroll.selection.getRange()[0];
          var blotRange = this.savedPosition && this.savedPosition.blotRange || this.editor.scroll.selection.getRange({
            offsetBlot: _blot
          })[0];
          var delta = [];
          if (blotRange.index > 1) {
            delta.push({
              retain: blotRange.index - 1
            });
          }
          var _dateId = generateId();
          window.customDateId = _dateId;
          delta.push({
            insert: {
              date: {
                dateId: _dateId,
                timestamp: parseInt(params.timestamp),
                format: {
                  showTime: params.hasOwnProperty('showTime') ? !!params.showTime : false
                },
                alerts: params.alerts,
                reminders: params.reminders
              }
            }
          });
          _blot.applyDelta(delta);
          range.index += 2;
          this.editor.scroll.selection.setRange(range);
          this.savedPosition = null;
        }
      }
      return true;
    }
  }, {
    key: "deleteDate",
    value: function deleteDate() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (params.dateId) {
        var blot = this.getDateBlot(params.dateId);
        if (blot && blot.removeDate) {
          blot.removeDate();
          return true;
        } else {
          var map = this.editor.store.getMap(params.dateId);
          console.info('map', map);
          if (map) {
            this.editor.store.transaction(function () {
              map.delete('timestamp');
              map.delete('reminders');
            }, 'client');
          }
        }
      } else {
        console.info('params.dateId is required', params);
      }
      this.savedPosition = null;
      return false;
    }
  }, {
    key: "getDateBlot",
    value: function getDateBlot(dateId) {
      var editor = this.editor;
      var blot;
      if (dateId) {
        blot = editor.findById(dateId);
        if (!blot) {
          var dateNodes = editor.scroll.domNode.getElementsByClassName('date-content');
          if (dateNodes.length) {
            var found = false;
            var _iterator = dateManager_createForOfIteratorHelper(dateNodes),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var node = _step.value;
                if (!found && node.getAttribute('data-date-dateid') === dateId) {
                  found = true;
                  blot = node.__blot && node.__blot.blot;
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
          if (!blot) {
            var map = editor.store.blocks.get(dateId);
            if (map) {
              var reminders = map.get('reminders') || {};
              var alerts = [];
              for (var key in reminders) {
                alerts.push(reminders[key].seconds);
              }
              blot = dateManager_objectSpread(dateManager_objectSpread({}, map.toJSON()), {}, {
                map: map,
                getReminders: function getReminders() {
                  return reminders;
                },
                getAlerts: function getAlerts() {
                  return alerts.sort();
                },
                _isMap: true
              });
            }
          }
          if (!blot) {
            (function () {
              // пробуем найти дату в меншенах ячеек таблицы
              var tables = editor.scroll.children.map(function (item) {
                return item;
              }).filter(function (item) {
                return item instanceof tableWrapper;
              });
              // пробуем найти таблицы в тоглах
              var toggles = editor.scroll.children.map(function (item) {
                return item;
              }).filter(function (item) {
                return item instanceof toggleWrapper;
              });
              toggles.forEach(function (item) {
                item.map.get('children').toArray().forEach(function (itemId) {
                  var blot = editor.findById(itemId);
                  if (editor.findById(itemId) instanceof table_table) {
                    tables.push(blot);
                  }
                });
              });
              var cells = [];
              var _loop = function _loop(_key) {
                var tableId = tables[_key].id;
                var rows = editor.store.blocks.get(tableId).get('rows').toArray();
                rows.forEach(function (rowId) {
                  editor.store.blocks.get(rowId).get('children').toArray().forEach(function (item) {
                    return item && cells.push({
                      cellId: item,
                      tableId: tableId
                    });
                  });
                });
              };
              for (var _key in tables) {
                _loop(_key);
              }
              var characters = [];
              cells.forEach(function (_ref2) {
                var cellId = _ref2.cellId,
                  tableId = _ref2.tableId;
                var item = editor.store.blocks.get(cellId);
                if (item.get('type') === 'tableCellMention' && item.get('cellType') === 'mention') {
                  item.get('children').toArray().forEach(function (id) {
                    characters.push({
                      ytext: editor.store.blocks.get(id).get('characters'),
                      cellId: cellId,
                      tableId: tableId
                    });
                  });
                }
              });
              characters.forEach(function (_ref3) {
                var ytext = _ref3.ytext,
                  cellId = _ref3.cellId,
                  tableId = _ref3.tableId;
                var pos = editor.findById(tableId).tableBodyEmbed.index.cell[cellId];
                var _ref4 = ytext.toDelta() || [],
                  _ref5 = dateManager_slicedToArray(_ref4, 1),
                  _ref5$ = _ref5[0];
                _ref5$ = _ref5$ === void 0 ? {} : _ref5$;
                var insert = _ref5$.insert;
                if (!blot && insert && insert.date && insert.date.dateId === dateId) {
                  var _reminders = insert.date.reminders || {};
                  var _alerts = [];
                  for (var _key2 in _reminders) {
                    _alerts.push(_reminders[_key2].seconds);
                  }
                  blot = dateManager_objectSpread(dateManager_objectSpread({}, insert.date), {}, {
                    getReminders: function getReminders() {
                      return insert.date.reminders || {};
                    },
                    getAlerts: function getAlerts() {
                      return _alerts.sort();
                    },
                    _isMap: true,
                    ytext: ytext,
                    cellId: cellId,
                    removeDate: function removeDate() {
                      var _editor$findById;
                      ytext.applyDelta([{
                        retain: 1
                      }, {
                        delete: 1
                      }]);
                      (_editor$findById = editor.findById(tableId)) === null || _editor$findById === void 0 ? void 0 : _editor$findById.clearCells(pos, {}, {
                        render: true
                      });
                    }
                  });
                }
              });
            })();
          }
        }
      }
      if (!blot) {
        console.info('Date blot not found, dateId:', dateId);
      }
      return blot;
    }

    /**
     * Скроллит к блоту даты
     * Возвращает id блота к которому идёт скролл
     * @param { string } dateId 
     * @returns { string } 
     */
  }, {
    key: "scrollToDate",
    value: function scrollToDate(dateId) {
      var blot = this.getDateBlot(dateId) || {};
      var _ref6 = (blot === null || blot === void 0 ? void 0 : blot.parent) || {},
        id = _ref6.id;
      if (id && !blot._isMap) {
        this.editor.plugins.scrollSaver.scrollToBlot(id);
        var _blot2 = this.editor.findById(id);
        _blot2.props.selected = true;
        _blot2.render();
      } else if (blot._isMap) {
        var tables = this.editor.scroll.children.map(function (item) {
          return item;
        }).filter(function (item) {
          return item instanceof tableWrapper;
        });
        for (var key in tables) {
          var _this$editor$findById;
          var blotId = blot.ytext ? blot.cellId : dateId; // в случае если дата как меншен берётся родительская ячейка
          if ((_this$editor$findById = this.editor.findById(tables[key].id)) !== null && _this$editor$findById !== void 0 && _this$editor$findById.componentOnAction({
            type: 'scroll-to-cell',
            blotId: blotId,
            select: true
          })) {
            id = tables[key].id;
            break;
          }
        }
      }
      if (!id) {
        console.info("Cant find blot for dateId ".concat(dateId));
      }
      return id;
    }
  }]);
  return DateManager;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/commentManager/comments.js
function comments_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { comments_typeof = function _typeof(obj) { return typeof obj; }; } else { comments_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return comments_typeof(obj); }
















function comments_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function comments_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function comments_createClass(Constructor, protoProps, staticProps) { if (protoProps) comments_defineProperties(Constructor.prototype, protoProps); if (staticProps) comments_defineProperties(Constructor, staticProps); return Constructor; }
function comments_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) comments_setPrototypeOf(subClass, superClass); }
function comments_setPrototypeOf(o, p) { comments_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return comments_setPrototypeOf(o, p); }
function comments_createSuper(Derived) { var hasNativeReflectConstruct = comments_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = comments_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = comments_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return comments_possibleConstructorReturn(this, result); }; }
function comments_possibleConstructorReturn(self, call) { if (call && (comments_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return comments_assertThisInitialized(self); }
function comments_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function comments_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function comments_getPrototypeOf(o) { comments_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return comments_getPrototypeOf(o); }
function comments_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var COMMENT_OFFSET_BLOT_TOP = 4;
var COMMENT_OFFSET_BLOT_LEFT = 5;
var Comments = /*#__PURE__*/function (_Component) {
  comments_inherits(Comments, _Component);
  var _super = comments_createSuper(Comments);
  function Comments() {
    var _this;
    comments_classCallCheck(this, Comments);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    comments_defineProperty(comments_assertThisInitialized(_this), "state", {
      comments: []
    });
    return _this;
  }
  comments_createClass(Comments, [{
    key: "groupCommentsById",
    value: function groupCommentsById() {
      var _this$props = this.props,
        comments = _this$props.comments,
        tableComments = _this$props.tableComments;
      var group = {};
      var groupedComments = [];

      // группируем комментарии по блотам
      comments.filter(function (c) {
        return c.target !== 'cell';
      }).forEach(function (_ref) {
        var blotId = _ref.blotId,
          threadId = _ref.threadId,
          target = _ref.target,
          count = _ref.count,
          resolved = _ref.resolved,
          _ref$notFound = _ref.notFound,
          notFound = _ref$notFound === void 0 ? false : _ref$notFound,
          _ref$unreadComments = _ref.unreadComments,
          unreadComments = _ref$unreadComments === void 0 ? 0 : _ref$unreadComments;
        if (resolved || notFound) {
          return;
        }
        if (!group[blotId]) {
          group[blotId] = {
            count: 0,
            treads: [],
            hasUnread: false
          };
        }
        if (target === 'blot') {
          group[blotId].threadId = threadId;
        }
        group[blotId].count += count;
        group[blotId].treads.push(threadId);
        if (unreadComments > 0 && !group[blotId].hasUnread) {
          group[blotId].hasUnread = true;
        }
      });
      for (var blotId in group) {
        var threadId = group[blotId].threadId;
        if (!group[blotId].threadId) {
          // если у группы не задан threadId, то устанавливаем threadId
          // первого комментария в тексте
          threadId = group[blotId].treads[0];
        }
        groupedComments.push({
          blotId: blotId,
          count: group[blotId].count,
          threadId: threadId,
          hasUnread: group[blotId].hasUnread
        });
      }
      var _loop = function _loop(tableId) {
        if (!tableComments[tableId].length) return "continue";
        var tableCellsInfo = tableComments[tableId].reduce(function (result, cellComment) {
          result.count += cellComment.count;
          if (!result.hasUnread && cellComment.unreadComments > 0) {
            result.hasUnread = true;
          }
          return result;
        }, {
          count: 0,
          hasUnread: false
        });
        var inGroup = groupedComments.find(function (c) {
          return c.blotId === tableId;
        });
        if (inGroup) {
          inGroup.count += tableCellsInfo.count;
          if (!inGroup.hasUnread) {
            inGroup.hasUnread = tableCellsInfo.hasUnread;
          }
        } else {
          groupedComments.push({
            blotId: tableId,
            count: tableCellsInfo.count,
            threadId: tableComments[tableId][0]['threadId'],
            hasUnread: tableCellsInfo.hasUnread
          });
        }
      };
      for (var tableId in tableComments) {
        var _ret = _loop(tableId);
        if (_ret === "continue") continue;
      }
      this.setState({
        comments: groupedComments
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.groupCommentsById();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps, previousState, snapshot) {
      if (previousProps.comments !== this.props.comments) {
        this.groupCommentsById();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        editor = _this$props2.editor,
        onCommentClick = _this$props2.onCommentClick,
        countersStyle = _this$props2.countersStyle;
      var comments = this.state.comments;
      return (0,preact_module.h)("div", {
        className: "comments-counters"
      }, comments.map(function (comment) {
        return (0,preact_module.h)(CommentCounter, Object.assign({}, comment, {
          editor: editor,
          onCommentClick: onCommentClick,
          countersStyle: countersStyle
        }));
      }));
    }
  }]);
  return Comments;
}(preact_module/* Component */.wA);

var CommentCounter = /*#__PURE__*/function (_Component2) {
  comments_inherits(CommentCounter, _Component2);
  var _super2 = comments_createSuper(CommentCounter);
  function CommentCounter(props) {
    var _this2;
    comments_classCallCheck(this, CommentCounter);
    _this2 = _super2.call(this, props);
    comments_defineProperty(comments_assertThisInitialized(_this2), "disableRecycling", function () {
      _this2.nextBase = null;
    });
    comments_defineProperty(comments_assertThisInitialized(_this2), "onRef", function (node) {
      _this2.domNode = node;
    });
    comments_defineProperty(comments_assertThisInitialized(_this2), "onMouseEnter", function () {
      if (!_this2.editor.editorBody.classList.contains('drag-session')) {
        var blot = _this2.editor.findById(_this2.props.blotId);
        if (!blot.domNode.classList.contains('highlighted-block')) {
          blot.domNode.classList.add('highlighted-block');
        }
      }
    });
    comments_defineProperty(comments_assertThisInitialized(_this2), "onMouseLeave", function () {
      var blot = _this2.editor.findById(_this2.props.blotId);
      if (blot.domNode.classList.contains('highlighted-block')) {
        blot.domNode.classList.remove('highlighted-block');
      }
    });
    comments_defineProperty(comments_assertThisInitialized(_this2), "setCommentPosition", function () {
      var blot = _this2.editor.findById(_this2.props.blotId);
      if (!blot) {
        return console.warn("No blot found with identifier ".concat(_this2.props.blotId, " to update comments counter position"));
      }
      var pos = _this2.getCommentPosition(blot);
      if (!pos.top || !pos.left) {
        return console.error("Failed to set the correct position for comment counter of blot ".concat(_this2.props.blotId));
      }
      var editorScale = _this2.editor.options.scale;
      var topPos = editorScale !== undefined && editorScale !== 0 ? pos.top / editorScale : pos.top;
      var leftPos = editorScale !== undefined && editorScale !== 0 ? pos.left / editorScale : pos.left;
      _this2.domNode.style.top = topPos + 'px';
      _this2.domNode.style.left = leftPos + 'px';
    });
    _this2.editor = props.editor;
    return _this2;
  }
  comments_createClass(CommentCounter, [{
    key: "onCommentClick",
    value: function onCommentClick(id) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.props.onCommentClick(id, params);
    }
  }, {
    key: "getCommentPosition",
    value: function getCommentPosition(blot) {
      var blotDomNode = blot.getWrapper().domNode;
      var _getRelRect = (0,dom/* getRelRect */.vk)(blotDomNode, this.editor.editorBody),
        y = _getRelRect.top,
        x = _getRelRect.left,
        width = _getRelRect.width;
      var top = y;
      var left = x + width;
      if (blot.onGetCommentPosition) {
        var _blot$onGetCommentPos = blot.onGetCommentPosition({
          top: top,
          left: left
        });
        top = _blot$onGetCommentPos.top;
        left = _blot$onGetCommentPos.left;
      }
      if (blot.container instanceof toggleContent && blot.container.getWrapper() && blot.container.getWrapper().onGetContentCommentPos) {
        var _blot$container$getWr = blot.container.getWrapper().onGetContentCommentPos({
          top: top,
          left: left
        });
        top = _blot$container$getWr.top;
        left = _blot$container$getWr.left;
      }
      top += COMMENT_OFFSET_BLOT_TOP;
      left += COMMENT_OFFSET_BLOT_LEFT;
      return {
        top: top,
        left: left
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setCommentPosition();
      var blot = this.editor.findById(this.props.blotId);
      if (blot && blot.onUpdateCommentsCount) {
        blot.onUpdateCommentsCount(this.props.count);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setCommentPosition();
      var blot = this.editor.findById(this.props.blotId);
      if (blot && blot.onUpdateCommentsCount) {
        blot.onUpdateCommentsCount(this.props.count);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      setTimeout(this.disableRecycling);
      var blot = this.editor.findById(this.props.blotId);
      if (blot && blot.onRemoveCommentsCount) {
        blot.onRemoveCommentsCount();
      }
    }
  }, {
    key: "getIcon",
    value: function getIcon() {
      var _this$props3 = this.props,
        count = _this$props3.count,
        hasUnread = _this$props3.hasUnread;
      var className = ['comments-count'];
      if (count >= 10 && count < 100) {
        className.push('over-ten');
      }
      if (count >= 100) {
        className.push('over-hundred');
      }
      return (0,preact_module.h)("div", {
        className: 'comment-counter-icon' + (hasUnread ? ' has-unread-comments' : '')
      }, (0,preact_module.h)(icons/* IconCommentNew */.zxW, null), (0,preact_module.h)("span", {
        className: className.join(' ')
      }, count < 100 ? count : '99'));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props4 = this.props,
        blotId = _this$props4.blotId,
        threadId = _this$props4.threadId,
        countersStyle = _this$props4.countersStyle;
      if (!this.editor.findById(blotId)) {
        return null;
      }
      var icon = this.getIcon();
      var className = ['comment-counter'];
      if (countersStyle === 'mobile') {
        className.push('comment-counter-mobile');
      }
      return (0,preact_module.h)("div", {
        ref: this.onRef,
        className: className.join(' '),
        "data-comments-for-blot": blotId,
        onClick: function onClick() {
          _this3.onCommentClick(blotId, {
            threadId: threadId
          });
        },
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave
      }, icon);
    }
  }]);
  return CommentCounter;
}(preact_module/* Component */.wA);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/commentManager/index.js
function commentManager_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = commentManager_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function commentManager_extends() { commentManager_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return commentManager_extends.apply(this, arguments); }
function commentManager_slicedToArray(arr, i) { return commentManager_arrayWithHoles(arr) || commentManager_iterableToArrayLimit(arr, i) || commentManager_unsupportedIterableToArray(arr, i) || commentManager_nonIterableRest(); }
function commentManager_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function commentManager_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function commentManager_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function commentManager_toConsumableArray(arr) { return commentManager_arrayWithoutHoles(arr) || commentManager_iterableToArray(arr) || commentManager_unsupportedIterableToArray(arr) || commentManager_nonIterableSpread(); }
function commentManager_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function commentManager_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return commentManager_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return commentManager_arrayLikeToArray(o, minLen); }
function commentManager_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function commentManager_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return commentManager_arrayLikeToArray(arr); }
function commentManager_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
























function commentManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function commentManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function commentManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) commentManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) commentManager_defineProperties(Constructor, staticProps); return Constructor; }
function commentManager_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var defaultOptions = {
  renderCounters: true,
  countersStyle: 'default',
  enabled: false,
  inlineComments: false,
  tableCellComments: false
};
var commentManager_DISTANCE_IN_GRID = 35;
var CommentManager = /*#__PURE__*/function () {
  function CommentManager(_ref) {
    var _this = this;
    var scroll = _ref.scroll,
      editor = _ref.editor,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;
    commentManager_classCallCheck(this, CommentManager);
    commentManager_defineProperty(this, "onEditorUpdate", function () {
      if (!_this.ignoreUpdatesRender) {
        _this.comments = _this.sortThreads(_this.setBlotsForComments(_this.comments));
        _this.render();
      }
    });
    commentManager_defineProperty(this, "onEditorProcessResize", function () {
      _this.ignoreUpdatesRender = true;
      _this.relIconContainer.classList.add('hidden-rel-icon');
      _this.render(false);
    });
    commentManager_defineProperty(this, "onEditorProcessResizeEnd", function () {
      _this.ignoreUpdatesRender = false;
      _this.relIconContainer.classList.remove('hidden-rel-icon');
      _this.render();
    });
    commentManager_defineProperty(this, "getBlotInlineComments", function (blot) {
      return blot.descendants ? blot.descendants(comment) : [];
    });
    commentManager_defineProperty(this, "getBlotsWithComments", function () {
      var withComments = [];
      var isContainer = function isContainer(blot) {
        return blot instanceof list_list || blot.constructor.blotName === 'toggleWrapper' || blot.constructor.blotName === 'toggleContent' || blot.constructor.blotName === 'grid' || blot.constructor.blotName === 'gridCol';
      };
      var getComments = function getComments(children) {
        children.forEach(function (blot) {
          if (blot.map && blot.map.has('commentThreads')) {
            withComments.push({
              blotId: blot.id,
              threadId: blot.map.get('commentThreads')
            });
          }
          // блот является контейнером (условия описаны в функции выше isContainer), выполняем функцию для дочерних
          if (isContainer(blot)) {
            getComments(blot.children);
          } else {
            // получаем инлайн комментарии если блот не является дочерним какого либо контейнера,
            // иначе контейнер будет содержать инлайн комментарии вместо целевых блотов
            var inlineComments = _this.getBlotInlineComments(blot).map(function (comment) {
              return {
                blotId: blot.id,
                threadId: comment.threadId
              };
            });
            withComments = [].concat(commentManager_toConsumableArray(withComments), commentManager_toConsumableArray(inlineComments));
          }
        });
      };
      getComments(_this.editor.scroll.children);
      return withComments;
    });
    commentManager_defineProperty(this, "setBlotsForComments", function (comments) {
      var withComments = _this.getBlotsWithComments();
      var imageBlots = _this.scroll.descendants(function (b) {
        return b.constructor.blotName === 'image' || b.constructor.blotName === 'file' && b.isImageFile();
      });
      // получаем все треды из таблиц
      var cellsComments = Object.values(_this.getAllTablesComments(comments)).reduce(function (result, cArr) {
        result.push.apply(result, commentManager_toConsumableArray(cArr));
        return result;
      }, []);
      return comments.map(function (c) {
        var blot = withComments.find(function (_ref2) {
          var threadId = _ref2.threadId;
          return threadId === c.threadId;
        });
        if (!blot && c.target === 'image-point' && c.attachmentId) {
          var _imageBlots$filter = imageBlots.filter(function (b) {
              return b.props && b.props.attachment && b.props.attachment.global_id === c.attachmentId;
            }),
            _imageBlots$filter2 = commentManager_slicedToArray(_imageBlots$filter, 1),
            imageBlot = _imageBlots$filter2[0];
          if (imageBlot) blot = {
            blotId: imageBlot.id
          };
        }
        if (blot) {
          c.blotId = blot.blotId;
          c.notFound = false;
        } else if (c.target === 'cell' && cellsComments.some(function (cellComment) {
          return cellComment.threadId === c.threadId;
        })) {
          c.notFound = false;
        } else {
          // условие для обратной совместимости
          // если блот не найден, то помечаем комментарий как notFound
          // все notFound комментарии не будет отрисовываться
          if (!_this.editor.findById(c.blotId)) {
            c.notFound = true;
          } else if (c.target === 'text' || c.target === 'cell') {
            // если блот найден и это инлайн коммент или коммент к ячейке
            c.notFound = true;
          }
        }
        return c;
      });
    });
    commentManager_defineProperty(this, "onEditorMouseMove", function (event) {
      var x = event.clientX,
        y = event.clientY;
      var _this$scroll$domNode$ = _this.scroll.domNode.getBoundingClientRect(),
        contentLeft = _this$scroll$domNode$.left,
        contentRight = _this$scroll$domNode$.right;
      x = contentRight <= x ? contentRight - 1 : x;
      var targetNode = document.elementFromPoint(x, y);
      if (targetNode === _this.scroll.domNode || x < contentLeft && !_this.scroll.domNode.contains(targetNode)) {
        _this.renderCommentIcon(null);
      } else {
        var blot = getBlotForNode(targetNode);
        if (blot) {
          blot = normalizeToStoredBlot(blot);
          if (blot.parentTable) {
            blot = blot.parentTable;
          }
          if (blot && blot.getInnerRightPadding && blot.getInnerRightPadding() !== 0) {
            var targetCorrectedNode = document.elementFromPoint(x - blot.getInnerRightPadding(), y);
            blot = getBlotForNode(targetCorrectedNode);
            if (blot) {
              blot = normalizeToStoredBlot(blot);
            }
          }
          if (blot && blot.constructor.blotName === 'gridCol') {
            blot = getBlotForNode(document.elementFromPoint(x - commentManager_DISTANCE_IN_GRID, y));
            if (blot && blot.getInnerRightPadding && blot.getInnerRightPadding() !== 0) {
              blot = getBlotForNode(document.elementFromPoint(x - commentManager_DISTANCE_IN_GRID - blot.getInnerRightPadding(), y));
            }
          }
          if (blot) {
            if (blot.getWrapper && blot.getWrapper()) {
              blot = blot.getWrapper().getWrappedBlot();
            }
            var renderForBlot = true;
            if (blot.isContainer) {
              renderForBlot = false;
            }
            if (blot.map && blot.map.get('type') === 'image') {
              if (blot.hasAttachment()) {
                var imageWidth = blot.map.get('width') || blot.image.clientWidth;
                var imageHeight = blot.map.get('ratio') ? imageWidth / blot.map.get('ratio') : blot.image.clientHeight;
                if (imageWidth >= 100 && imageHeight >= 100) {
                  renderForBlot = false;
                }
              } else {
                renderForBlot = false;
              }
            }
            if (blot.isEmpty && blot.isEmpty()) {
              renderForBlot = false;
            }
            if (!renderForBlot) {
              _this.renderCommentIcon(null);
            } else {
              if (blot.map && blot.map.get('type') === 'table') {
                blot = searchUp(blot, function (b) {
                  return b.constructor.blotName === 'table';
                });
              }
              if (_this.comments.length && _this.comments.find(function (c) {
                return c.blotId === blot.map.get('id') && c.notFound !== true;
              })) {
                _this.renderCommentIcon(null);
              } else if (blot.map && blot.map.get('type') === 'table' && _this.getTableComments(blot.map.get('id')).length) {
                _this.renderCommentIcon(null);
              } else {
                var _getContainerOffset = getContainerOffset(blot.domNode, _this.editor.scrollingContainer),
                  rawX = _getContainerOffset.x,
                  rawY = _getContainerOffset.y;
                var blotWidth = blot.domNode.getBoundingClientRect().width;
                var rawPos = {
                  left: rawX + blotWidth,
                  top: rawY
                };
                var _ref3 = blot.onGetCommentPosition ? blot.onGetCommentPosition(rawPos) : blot.getCorrectCommentPosition ? blot.getCorrectCommentPosition(rawPos) : rawPos,
                  renderX = _ref3.left,
                  renderY = _ref3.top;
                var blotContentContainer = blot.container.constructor.blotName === 'list' ? blot.container.container : blot.container;
                if (blotContentContainer instanceof toggleContent && blotContentContainer.getWrapper() && blotContentContainer.getWrapper().onGetContentCommentPos) {
                  var _blotContentContainer = blotContentContainer.getWrapper().onGetContentCommentPos({
                    left: renderX,
                    top: renderY
                  });
                  renderX = _blotContentContainer.left;
                  renderY = _blotContentContainer.top;
                }
                var editorScale = _this.editor.options.scale;
                var leftPos = editorScale !== undefined && editorScale !== 0 ? renderX / editorScale : renderX;
                var styles = {
                  top: renderY + 'px',
                  left: leftPos + 'px'
                };
                var attrs = editorScale === undefined || editorScale === 0 ? commentManager_defineProperty({}, tooltipManager/* TOOLTIP_ATTR */.qZ, _this.editor.plugins.i18n.get('floating_toolbar.add_comment')) : {};
                var onIconClick = function onIconClick(event) {
                  event.preventDefault();
                  if (!_this.scroll.selectedBlocks.includes(blot)) {
                    _this.scroll.selection.setRange({
                      index: blot.offset(_this.scroll),
                      length: 0
                    });
                  }
                  if (blot.map.get('type') === 'image' || blot.map.get('type') === 'file' && blot.isImageFile()) {
                    blot.commentImageBlot();
                  } else {
                    blot.commentBlock();
                  }
                  _this.renderCommentIcon(null);
                };
                _this.renderCommentIcon((0,preact_module.h)("span", commentManager_extends({
                  key: "comment-rel-icon",
                  onClick: onIconClick,
                  className: "rel-comment-icon",
                  style: styles
                }, attrs), (0,preact_module.h)(icons/* IconComment */.ge4, null)));
              }
            }
          }
        }
      }
    });
    this.editor = editor;
    this.scroll = scroll;
    this.options = Object.assign({}, defaultOptions, options);
    this.enabled = this.options.enabled;
    this.comments = [];
    this.nextInlineCommentColor = inlineCommentColors[0];
    if (this.options.enabled) {
      this.initRelIcon();
    }
  }
  commentManager_createClass(CommentManager, [{
    key: "initRelIcon",
    value: function initRelIcon() {
      this.relIconContainer = document.createElement('div');
      this.relIconContainer.id = 'nedit-comments-rel-container';
      this.editor.editorBody.appendChild(this.relIconContainer);
      this.editor.scrollingContainer.addEventListener('mousemove', this.onEditorMouseMove, false);
    }
  }, {
    key: "initContainer",
    value: function initContainer() {
      if (!this.container) {
        this.container = document.createElement('div');
        this.container.id = 'nedit-comments-container';
        this.editor.editorBody.appendChild(this.container);
        this.initObservers();
      }
      return this.container;
    }
  }, {
    key: "initObservers",
    value: function initObservers() {
      this.editor.on('editorUpdate', this.onEditorUpdate);
      this.editor.on('start-dragging', this.onEditorProcessResize);
      this.editor.on('stop-dragging', this.onEditorProcessResizeEnd);
      this.editor.on('grid-resize-start', this.onEditorProcessResize);
      this.editor.on('grid-resize-end', this.onEditorProcessResizeEnd);
      this.editor.on('blot-resize-start', this.onEditorProcessResize);
      this.editor.on('blot-resize-end', this.onEditorProcessResizeEnd);
    }
  }, {
    key: "isMethodImplemented",
    value: function isMethodImplemented(method) {
      return Boolean(this.options[method]);
    }
  }, {
    key: "onCreateInlineComment",
    value: function onCreateInlineComment(blotId) {
      if (this.isMethodImplemented('createInlineComment')) {
        var _getSelectedText = (0,util/* getSelectedText */.ZT)(this.editor),
          text = _getSelectedText.text;
        return this.options.createInlineComment(blotId, {
          text: text
        });
      }
    }
  }, {
    key: "onCreateInlineCommentGetColor",
    value: function onCreateInlineCommentGetColor() {
      var color = this.nextInlineCommentColor;
      var currentIndex = inlineCommentColors.indexOf(color);
      var nextIndex = currentIndex !== -1 ? currentIndex < inlineCommentColors.length - 1 ? currentIndex + 1 : 0 : 0;
      this.nextInlineCommentColor = inlineCommentColors[nextIndex];
      return color;
    }
  }, {
    key: "onCommentOpenThread",
    value: function onCommentOpenThread(threadId) {
      console.log('Open thread: ' + threadId);
      return false;
    }
  }, {
    key: "getBlotTextPreview",
    value: function getBlotTextPreview(blotId) {
      var result;
      var blot = this.editor && this.editor.findById(blotId);
      var text = blot && blot.getText && blot.getText();
      if (text) {
        result = text.length <= 50 ? text : text.substr(0, 50) + '...';
      } else {
        result = '';
      }
      return result;
    }

    /**
     * Отркытие/добавление комментария
     * @param blotId
     * @param params
     * @returns {Promise<{threadId}>}
     */
  }, {
    key: "openComments",
    value: function openComments(blotId) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var blot = this.editor.findById(blotId);
      if (blot && (blot.constructor.blotName === 'image' || blot.constructor.blotName === 'file' && blot.isImageFile())) {
        var processed = false;
        if (!processed) {
          if (this.editor.plugins.imageManager.enterFullSize(blot.props.attachment.global_id, {
            commentMode: true
          }) !== false) {
            processed = true;
          }
        }
        if (!processed) {
          this.editor.plugins.lightBox.open(blot.props.attachment.url);
        }
      } else if (this.isMethodImplemented('openComments')) {
        if (!params.text) {
          if (params.threadId) {
            var _this$getThreadPrevie = this.getThreadPreview(params.threadId),
              text = _this$getThreadPrevie.text;
            params.text = text;
          } else {
            params.text = this.getBlotTextPreview(blotId);
          }
        }
        return this.options.openComments(blotId, params);
      }
    }

    /**
     * Возвращает массив инлайн комментариев блота
     * @param blot
     * @returns {any[] | Blot[]}
     */
  }, {
    key: "setThreads",
    value: function setThreads() {
      var _this2 = this;
      var comments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (!Array.isArray(comments)) {
        return console.error('#setThreads first argument must be an array');
      }
      this.comments = this.sortThreads(comments);
      this.render(!!comments.length);
      setTimeout(function () {
        // дожидаемся всех обновлений и событий редактора, так как некторые компоненты
        // могут реагировать на событие, но в данные самого компонента могут быть не актуальны
        _this2.editor.emitter.emit('set-comments');
      }, 100);
      if (!comments.length) {
        return;
      }

      // собираем не найденные коментарии
      var notFoundBlotsComments = this.comments.filter(function (c) {
        return c.notFound === true;
      });
      return {
        notFoundBlots: notFoundBlotsComments
      };
    }

    /**
     * Сортирует массив из blotId
     * @param blotsId: []
     * @returns []
     */
  }, {
    key: "sortBlots",
    value: function sortBlots(blotsId) {
      var blots = [];
      // функция собирает id всех блотов в документе
      var getChildren = function getChildren(parent) {
        parent.forEach(function (b) {
          blots.push(b.id);
          if (b instanceof list_list) {
            getChildren(b.children);
          }
        });
      };
      getChildren(this.editor.scroll.children);
      return blots.filter(function (b) {
        return blotsId.includes(b);
      });
    }

    /**
     * Функция сортирует комментарии в зависимости от их положения в документе
     * @param comments
     * @returns {*}
     */
  }, {
    key: "sortThreads",
    value: function sortThreads(comments) {
      var threadsId = [];

      // выбираем только комментарии для существующих блотов
      var comm = this.setBlotsForComments(comments).filter(function (c) {
        return c.notFound !== true;
      });
      var tableComments = this.getAllTablesComments(comments);
      var withCommentsTableIds = Object.keys(tableComments).filter(function (tableId) {
        return tableComments[tableId].length;
      });
      // получаем отсортированные блоты без дублей
      var forSortBlotsId = comm.map(function (_ref5) {
        var blotId = _ref5.blotId;
        return blotId;
      }).filter(function (value, index, self) {
        return self.indexOf(value) === index;
      });
      forSortBlotsId.push.apply(forSortBlotsId, commentManager_toConsumableArray(withCommentsTableIds));
      forSortBlotsId.filter(function (value, index, self) {
        return self.indexOf(value) === index;
      });
      var blotsId = this.sortBlots(forSortBlotsId);
      // получаем все треды из комментариев
      document.querySelectorAll("comment").forEach(function (item) {
        return threadsId.push(item.__blot.blot.threadId);
      });
      // удаляем дубли из массива
      threadsId = threadsId.filter(function (value, index, self) {
        return self.indexOf(value) === index;
      });

      // расчитываем индекс сортировки по умолчанию
      var defSort = blotsId.length + threadsId.length + 10;
      // устанавливаем индексы сортировки для тредов
      blotsId.forEach(function (blotId, blotIndex) {
        comm.forEach(function (_ref6, index) {
          var id = _ref6.blotId;
          if (id === blotId) {
            // если комментарий к блоту, то его индекс сортировки должен быть минимальным
            // поэтому для всех по умолчанию устанавливаем минимальный индекс
            comm[index].sort = defSort * (blotIndex + 1);
          }
        });
        threadsId.forEach(function (threadId, sortIndex) {
          var index = comm.findIndex(function (c) {
            return c.threadId === threadId && c.blotId === blotId;
          });
          if (index >= 0) {
            comm[index].sort = defSort * (blotIndex + 1) + sortIndex + 1;
          }
        });
        if (withCommentsTableIds.includes(blotId)) {
          tableComments[blotId].forEach(function (cellComment, sortIndex) {
            var index = comm.findIndex(function (c) {
              return c.threadId === cellComment.threadId;
            });
            if (index >= 0) {
              comm[index].sort = defSort * (blotIndex + 1) + sortIndex + 1;
            }
          });
        }
      });

      // так как comm содержит ссылки на объекты comments, можно сделать сортировку массива comments
      // сортируем массив по индесу сортировки
      comments.sort(function (a, b) {
        if (a.sort === b.sort || !a.sort || !b.sort) return 0;
        return a.sort > b.sort ? 1 : -1;
      });
      return comments;
    }
  }, {
    key: "getTableComments",
    value: function getTableComments(blotId) {
      var _this3 = this;
      var comments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (!comments || !comments.length) {
        comments = this.comments;
      }
      var result = [];
      var tMap = this.editor.store.getMap(blotId);
      if (tMap) {
        var rows = tMap.get('rows');
        if (rows.length) {
          var _iterator = commentManager_createForOfIteratorHelper(rows),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var rId = _step.value;
              var rMap = this.editor.store.getMap(rId);
              if (rMap) {
                var cells = rMap.get('children');
                if (cells.length) {
                  var _iterator2 = commentManager_createForOfIteratorHelper(cells),
                    _step2;
                  try {
                    var _loop = function _loop() {
                      var cId = _step2.value;
                      var cMap = _this3.editor.store.getMap(cId);
                      if (cMap && cMap.has('commentThreads')) {
                        var inCommentsComment = comments.find(function (c) {
                          return c.threadId === cMap.get('commentThreads');
                        });
                        if (inCommentsComment) {
                          result.push(inCommentsComment);
                        }
                      }
                    };
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      _loop();
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }
                }
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }
      return result;
    }
  }, {
    key: "getAllTablesComments",
    value: function getAllTablesComments() {
      var _this4 = this;
      var comments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return this.scroll.descendants(function (blot) {
        return blot.constructor.blotName === 'table';
      }).reduce(function (result, blot) {
        result[blot.id] = _this4.getTableComments(blot.id, comments);
        return result;
      }, {});
    }
  }, {
    key: "getTableCellNodeByThreadId",
    value: function getTableCellNodeByThreadId(threadId) {
      var _this5 = this;
      var tableBlots = this.editor.scroll.descendants(function (blot) {
        return blot.constructor.blotName === 'table';
      });
      return tableBlots.reduce(function (result, blot) {
        if (result) return result;
        var currentTableComments = _this5.getTableComments(blot.id);
        var rows = blot.map.get('rows').toJSON();
        if (rows.length) {
          for (var i = 0; i < rows.length; i++) {
            if (rows[i]) {
              var rowMap = _this5.editor.store.getMap(rows[i]);
              if (rowMap && rowMap.has('children')) {
                var children = rowMap.get('children').toJSON();
                if (children.length) {
                  for (var j = 0; j < children.length; j++) {
                    if (children[j]) {
                      var cellMap = _this5.editor.store.getMap(children[j]);
                      if (cellMap) {
                        if (currentTableComments && currentTableComments.length) {
                          var _blot$getMergedCellsC = blot.getMergedCellsComments(cellMap, {
                              row: i,
                              col: j
                            }, currentTableComments),
                            mergedThreads = _blot$getMergedCellsC.mergedThreads;
                          if (mergedThreads.includes(threadId)) {
                            var cellRef = blot.getCellLink({
                              row: i,
                              col: j
                            });
                            if (cellRef) {
                              return cellRef;
                            }
                          }
                        }
                        if (cellMap.has('commentThreads') && cellMap.get('commentThreads') === threadId) {
                          var _cellRef = blot.getCellLink({
                            row: i,
                            col: j
                          });
                          if (_cellRef) {
                            return _cellRef;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        return result;
      }, null);
    }

    /**
     * Возвращает текст для треда
     * @param threadId
     * @returns {{text: string, type: 'string'}}
     */
  }, {
    key: "getThreadPreview",
    value: function getThreadPreview(threadId) {
      var blots = {};
      var texts = [];
      var thread = this.comments.find(function (thread) {
        return thread.threadId === threadId;
      });
      if (thread.target === 'blot') {
        var text = this.getBlotTextPreview(thread.blotId);
        var blot = this.editor.findById(thread.blotId);
        if (!blot) {
          return {
            text: text,
            type: ''
          };
        }
        var blotName = blot.constructor.blotName;
        // возвращаем склееный текст блотов
        return {
          text: text,
          type: blotName
        };
      } else {
        // собираем комментарии треда сгруппированные по блотам
        document.querySelectorAll("comment[data-comment-threadId=\"".concat(threadId, "\"]")).forEach(function (_ref7) {
          var blot = _ref7.__blot.blot;
          var blotId = blot.textBlot.id;
          if (!blots[blotId]) {
            blots[blotId] = [];
          }
          blots[blotId].push(blot);
        });

        // проходим по всем блотам и собираем текст
        for (var blotId in blots) {
          var comments = blots[blotId];
          var first = comments[0];
          var last = comments[comments.length - 1];
          var offset = first.getCommentOffset() - first.textBlot.offset();
          var index = offset < 0 ? first.getCommentOffset() : offset;
          var length = last.getCommentOffset() - first.getCommentOffset() + last.length();
          texts.push(first.textBlot.getText(index, length));
        }

        // возвращаем склееный текст блотов
        return {
          text: texts.join(' '),
          type: 'text'
        };
      }
    }
  }, {
    key: "getThreadStatus",
    value: function getThreadStatus(threadId) {
      var thread = this.comments.find(function (c) {
        return c.threadId === threadId;
      });
      var status = 'none';
      if (thread) {
        if (thread.resolved) {
          status = 'resolved';
        } else {
          status = 'active';
        }
      }
      return status;
    }
  }, {
    key: "removeThread",
    value: function removeThread(threadId) {
      document.querySelectorAll("comment[data-comment-threadid=\"".concat(threadId, "\"]")).forEach(function (el) {
        if (el.__blot) {
          el.__blot.blot.removeComment();
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;
      var withComments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (!this.options.renderCounters) {
        return;
      }
      var container = this.initContainer();
      var nodeToRender = null;
      if (withComments) {
        nodeToRender = (0,preact_module.h)(Comments, {
          editor: this.editor,
          onCommentClick: function onCommentClick(id, params) {
            return _this6.openComments(id, params);
          },
          comments: this.comments,
          tableComments: this.getAllTablesComments(),
          countersStyle: this.options.countersStyle
        });
      }
      (0,preact_module/* render */.sY)(nodeToRender, container);
    }
  }, {
    key: "renderCommentIcon",
    value: function renderCommentIcon(icon) {
      var _this7 = this;
      if (!icon) {
        if (!this.hideTimout) {
          this.hideTimout = setTimeout(function () {
            (0,preact_module/* render */.sY)((0,preact_module.h)(preact_module/* Fragment */.HY, null, icon), _this7.relIconContainer);
          }, 500);
        }
      } else {
        if (this.hideTimout) {
          clearTimeout(this.hideTimout);
          this.hideTimout = null;
        }
        (0,preact_module/* render */.sY)((0,preact_module.h)(preact_module/* Fragment */.HY, null, icon), this.relIconContainer);
      }
    }
  }, {
    key: "correctStepContentBlotPos",
    value: function correctStepContentBlotPos(blot) {
      return;
    }
  }, {
    key: "onFormatToCommentThread",
    value: function onFormatToCommentThread(params) {
      if (this.isMethodImplemented('formatToCommentThread')) {
        return this.options.formatToCommentThread(params);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.editor.off('editorUpdate', this.onEditorUpdate);
      this.editor.off('start-dragging', this.onEditorProcessResize);
      this.editor.off('stop-dragging', this.onEditorProcessResizeEnd);
      this.editor.off('grid-resize-start', this.onEditorProcessResize);
      this.editor.off('grid-resize-end', this.onEditorProcessResizeEnd);
      this.editor.off('blot-resize-start', this.onEditorProcessResize);
      this.editor.off('blot-resize-end', this.onEditorProcessResizeEnd);
      this.editor.scrollingContainer.removeEventListener('mousemove', this.onEditorMouseMove, false);
      if (this.isMethodImplemented('destroy')) {
        this.options.destroy();
      }
    }

    /**
     * Сохраняет идентификатор треда в блот
     * @param blot
     * @param threadId
     */
  }], [{
    key: "addThreadToBlot",
    value: function addThreadToBlot(blot, threadId) {
      blot.map.set('commentThreads', threadId);
    }
  }]);
  return CommentManager;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/debugLogger/index.js

function debugLogger_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function debugLogger_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function debugLogger_createClass(Constructor, protoProps, staticProps) { if (protoProps) debugLogger_defineProperties(Constructor.prototype, protoProps); if (staticProps) debugLogger_defineProperties(Constructor, staticProps); return Constructor; }
function debugLogger_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/**
 * Плагин DebugLogger
 */var DebugLogger = /*#__PURE__*/function () {
  function DebugLogger(_ref) {
    var _this = this;
    var scroll = _ref.scroll,
      editor = _ref.editor,
      doc = _ref.doc,
      options = _ref.options;
    debugLogger_classCallCheck(this, DebugLogger);
    debugLogger_defineProperty(this, "onDelta", function (delta) {
      var deltaStr = '';
      try {
        deltaStr = JSON.stringify(delta);
      } catch (ex) {
        // не смогли преобразовать дельту в строку, ни кидая ошибок выходим
        return;
      }
      _this.captureBreadcrumb({
        message: 'Input delta',
        category: 'editor',
        data: {
          delta: deltaStr
        }
      });
    });
    debugLogger_defineProperty(this, "onExec", function (params) {
      _this.captureBreadcrumb({
        message: 'Editor exec',
        category: 'editor',
        data: {
          action: params.action
        }
      });
    });
    this.options = options || {};
    this.editor = editor;
    editor.on('delta', this.onDelta);
    editor.on('exec', this.onExec);
  }
  debugLogger_createClass(DebugLogger, [{
    key: "callMethod",
    value: function callMethod(method) {
      var _window$Raven;
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      if (this.options[method]) {
        var _this$options;
        return (_this$options = this.options)[method].apply(_this$options, args);
      }
      if (!window.Raven) {
        return;
      }
      (_window$Raven = window.Raven)[method].apply(_window$Raven, args);
    }
  }, {
    key: "captureBreadcrumb",
    value: function captureBreadcrumb() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      this.callMethod.apply(this, ['captureBreadcrumb'].concat(args));
    }
  }, {
    key: "captureException",
    value: function captureException() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      this.callMethod.apply(this, ['captureException'].concat(args));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.editor.off('delta', this.onDelta);
      this.editor.off('exec', this.onExec);
    }
  }]);
  return DebugLogger;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/outlineManager/index.js





function outlineManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function outlineManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function outlineManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) outlineManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) outlineManager_defineProperties(Constructor, staticProps); return Constructor; }
function outlineManager_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var OutlineManager = /*#__PURE__*/function () {
  function OutlineManager(_ref) {
    var _this = this;
    var scroll = _ref.scroll,
      editor = _ref.editor,
      options = _ref.options;
    outlineManager_classCallCheck(this, OutlineManager);
    outlineManager_defineProperty(this, "onEditorReady", function () {
      // при загрузке редактора, сразу вызываем обновление,
      // так как SCROLL_UPDATE отработает только после изменений в редакторе
      if (_this.editor.mode !== MODE_EXPORT) {
        // render outline right away after editor is ready
        _this.updateOutlineData();
        _this.debouncedUpdateOutline();
      } else {
        _this.updateOutlineData();
      }
      _this.editor.emitter.on('SCROLL_UPDATE', _this.debouncedUpdateOutline);
    });
    outlineManager_defineProperty(this, "updateOutlineData", function () {
      var data = _this.getOutlineData();
      _this.editor.emitter.emit('update-outline', data);
      if (_this.options.updateOutlineData) {
        _this.options.updateOutlineData(data);
      }
    });
    this.editor = editor;
    this.scroll = scroll;
    this.options = options || {};
    this.outline_heading_priority = ['H1', 'H2', 'H3'];
    this.update_timeout = 1000;
    this.debouncedUpdateOutline = lodash_debounce_default()(this.updateOutlineData, this.update_timeout, {
      trailing: true
    });
    this.editor.emitter.once('editor-ready', this.onEditorReady);
  }
  outlineManager_createClass(OutlineManager, [{
    key: "getOutlineRawList",
    value: function getOutlineRawList() {
      var headers = Array.from(this.scroll.domNode.querySelectorAll('.nedit-heading')).filter(function (node) {
        return node.textContent !== '';
      });
      return headers.length && headers.map(function (node) {
        return {
          id: node.id,
          tag: node.tagName,
          text: node.textContent
        };
      }) || {};
    }
  }, {
    key: "getListItemLvl",
    value: function getListItemLvl(tag, prevTag, prevLvl) {
      if (!prevTag) return 0;
      var arr = this.outline_heading_priority;
      if (arr.indexOf(tag) === 0) return 0;
      var result = prevLvl;
      if (arr.indexOf(tag) > arr.indexOf(prevTag)) {
        result += 1;
      } else if (arr.indexOf(tag) < arr.indexOf(prevTag)) {
        result -= 1;
      }
      return result >= 0 && result || 0;
    }
  }, {
    key: "getOutlineData",
    value: function getOutlineData() {
      var _this2 = this;
      var rawList = this.getOutlineRawList();
      if (rawList && Object.keys(rawList).length !== 0) {
        var currentItemTag = null;
        var prevLevel = 0;
        return rawList.map(function (item) {
          var level = _this2.getListItemLvl(item.tag, currentItemTag, prevLevel);
          currentItemTag = item.tag;
          prevLevel = level;
          return {
            id: item.id,
            tag: item.tag,
            text: item.text,
            level: level,
            anchor: '#' + item.id
          };
        });
      }
      return [];
    }
  }]);
  return OutlineManager;
}();

// EXTERNAL MODULE: ./node_modules/fix-webm-duration/fix-webm-duration.js
var fix_webm_duration = __webpack_require__(81999);
var fix_webm_duration_default = /*#__PURE__*/__webpack_require__.n(fix_webm_duration);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/webRTC/webRTC.js

function webRTC_toConsumableArray(arr) { return webRTC_arrayWithoutHoles(arr) || webRTC_iterableToArray(arr) || webRTC_unsupportedIterableToArray(arr) || webRTC_nonIterableSpread(); }
function webRTC_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function webRTC_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return webRTC_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return webRTC_arrayLikeToArray(o, minLen); }
function webRTC_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function webRTC_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return webRTC_arrayLikeToArray(arr); }
function webRTC_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function webRTC_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function webRTC_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function webRTC_createClass(Constructor, protoProps, staticProps) { if (protoProps) webRTC_defineProperties(Constructor.prototype, protoProps); if (staticProps) webRTC_defineProperties(Constructor, staticProps); return Constructor; }
function webRTC_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

















function webRTC_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function webRTC_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { webRTC_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { webRTC_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



var fsWebPromise, fsWeb, EBML;
function loadFsWeb() {
  return _loadFsWeb.apply(this, arguments);
}
function _loadFsWeb() {
  _loadFsWeb = webRTC_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
    var initial, _yield$fsWebPromise, fsjs, ebmljs;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            initial = false;
            if (!fsWebPromise) {
              initial = true;
              fsWebPromise = __webpack_require__.e(/* import() | fs_web.js */ 997).then(__webpack_require__.bind(__webpack_require__, 54519));
            }
            _context5.next = 4;
            return fsWebPromise;
          case 4:
            _yield$fsWebPromise = _context5.sent;
            fsjs = _yield$fsWebPromise.fsjs;
            ebmljs = _yield$fsWebPromise.ebmljs;
            if (initial) {
              fsWeb = fsjs;
              EBML = ebmljs;
            }
            return _context5.abrupt("return", fsjs);
          case 9:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _loadFsWeb.apply(this, arguments);
}
var webRTC_loadScriptsPromise;
if ((browser_default())) {
  webRTC_loadScriptsPromise = new Promise(function (resolve) {
    return resolve();
  });
} else {
  webRTC_loadScriptsPromise = Promise.all([loadFsWeb()]);
}
var WebRTC = /*#__PURE__*/function () {
  function WebRTC() {
    var _this = this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    webRTC_classCallCheck(this, WebRTC);
    webRTC_defineProperty(this, "launchStream", function (callback) {
      if (_this.stream) {
        if (_this.additionalWrtc && _this.additionalWrtc.stream && _this.additionalWrtc.chooseMicro === true) {
          _this.combinedStream = new MediaStream([].concat(webRTC_toConsumableArray(_this.stream.getVideoTracks()), webRTC_toConsumableArray(_this.additionalWrtc.stream.getAudioTracks())));
        }
        if (_this.combinedStream) {
          _this.connectStream(_this.combinedStream, callback);
        } else {
          _this.connectStream(_this.stream, callback);
        }
      }
    });
    this.constraints = options.constraints || {
      video: {
        cursor: "always"
      },
      // motion, never
      audio: {
        echoCancellation: true,
        noiseSuppression: true,
        sampleRate: 44100
      }
    };
    this.stream = null;
    this.error = null;
    this.mediaElem = null;
    this.mediaElemId = options.mediaElemId || null;
    this.recordInstance = null;
    this.AudioRecordFileName = 'Audio_Record';
    this.MediaRecordFileName = 'Media_Record';
    this.removeRecord = false;
  }
  webRTC_createClass(WebRTC, [{
    key: "init",
    value: function () {
      var _init = webRTC_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(type) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.type = type;
                _context.next = 3;
                return this.initStream();
              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function init(_x) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "initStream",
    value: function () {
      var _initStream = webRTC_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;
        var recordUserId, currentUserId, _recordUserId, _currentUserId;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(navigator && navigator.mediaDevices)) {
                  _context2.next = 28;
                  break;
                }
                _context2.prev = 1;
                if (!(this.type === 'media')) {
                  _context2.next = 12;
                  break;
                }
                recordUserId = this.blot.map.get('recordUserId');
                currentUserId = this.blot.store.userId;
                if (!(recordUserId === currentUserId)) {
                  _context2.next = 10;
                  break;
                }
                _context2.next = 8;
                return navigator.mediaDevices.getDisplayMedia(this.constraints);
              case 8:
                this.stream = _context2.sent;
                this.stream.getVideoTracks()[0].onended = function () {
                  if (_this2.recorder && _this2.recorder.state !== 'inactive') {
                    _this2.stopMediaRecord();
                  } else if (!_this2.recorder) {
                    if (_this2.blot) {
                      _this2.blot.remove();
                    }
                  }
                };
              case 10:
                _context2.next = 20;
                break;
              case 12:
                if (typeof this.chooseMicro !== 'undefined' && this.chooseMicro === false) {
                  this.constraints.audio = false;
                }
                _recordUserId = this.blot.map.get('recordUserId');
                _currentUserId = this.blot.store.userId;
                if (!(_recordUserId === _currentUserId)) {
                  _context2.next = 20;
                  break;
                }
                _context2.next = 18;
                return navigator.mediaDevices.getUserMedia(this.constraints);
              case 18:
                this.stream = _context2.sent;
                this.granted = true;
              case 20:
                this.error = null;
                if (this.additionalWrtc && this.additionalWrtc.error) {
                  if (this.stream) {
                    this.stream.getTracks().forEach(function (track) {
                      return track.stop();
                    });
                    this.stream = null;
                  }
                } else {
                  this.initCapture();
                }
                _context2.next = 28;
                break;
              case 24:
                _context2.prev = 24;
                _context2.t0 = _context2["catch"](1);
                if (_context2.t0.message.toLowerCase() === 'the object can not be found here.' || _context2.t0.message.toLowerCase() === 'permission denied by system') {
                  this.error = 'macSystemError';
                } else {
                  this.error = _context2.t0.message;
                }
                console.warn(this.error);
              case 28:
                if (this.blot) {
                  this.blot.render();
                }
              case 29:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 24]]);
      }));
      function initStream() {
        return _initStream.apply(this, arguments);
      }
      return initStream;
    }()
  }, {
    key: "initCapture",
    value: function initCapture() {
      if (this.mediaElemId) {
        var mediaElem = document.getElementById(this.mediaElemId);
        mediaElem.srcObject = this.stream;
        this.mediaElem = mediaElem;
      }
    }
  }, {
    key: "startMediaRecord",
    value: function startMediaRecord(callback) {
      var _this3 = this;
      if ((0,browser/* detectBrowser */.Ao)() === 'Firefox') {
        // Фикс для Фаерфокса т.к. он видимо в рекордер записывает часть стрима с захватом предыдущего кадра
        setTimeout(function () {
          return _this3.launchStream(callback);
        }, 100);
      } else {
        this.launchStream(callback);
      }
    }
  }, {
    key: "connectStream",
    value: function connectStream(stream, callback) {
      var _this4 = this;
      var chunks = [];
      var options = {
        mimeType: 'video/webm;codecs=vp9'
      };
      if ((0,browser/* detectBrowser */.Ao)() === 'Firefox') {
        options = {
          mimeType: 'video/webm;codecs:vp9'
        };
      }
      this.recorder = new MediaRecorder(stream, options);
      var startTime = Date.now();
      this.recorder.ondataavailable = function (event) {
        if (event.data && event.data.size > 0) {
          chunks.push(event.data);
        }
        _this4.chunks = chunks;
      };
      this.recorder.onstop = function (event) {
        var duration = Date.now() - startTime;
        var opts = {
          type: "video/webm;codecs=vp9"
        };
        _this4.getSeekableBlob(new Blob(chunks, opts), opts, function (seekableBlob) {
          fix_webm_duration_default()(seekableBlob, duration, function (fixedBlob) {
            _this4.blob = fixedBlob;
            if (_this4.blot) {
              _this4.uploadFile(seekableBlob, 'video');
            }
            if (callback) {
              callback(_this4.blob);
            }
          });
        });
      };
      if (!stream.active) {
        this.stopMediaRecord();
      } else {
        this.recorder.start();
      }
    }
  }, {
    key: "restartMediaRecord",
    value: function () {
      var _restartMediaRecord = webRTC_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this5 = this;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.initStream().then(function () {
                  if (!_this5.error) {
                    _this5.startMediaRecord();
                  } else {
                    if (_this5.blot) {
                      _this5.stream = null;
                      _this5.blot.render();
                    }
                  }
                });
              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function restartMediaRecord() {
        return _restartMediaRecord.apply(this, arguments);
      }
      return restartMediaRecord;
    }()
  }, {
    key: "stopMediaRecord",
    value: function stopMediaRecord() {
      if (this.recorder) {
        if (this.recorder.state !== 'inactive') {
          this.recorder.stop();
        }
        this.recorder = undefined;
        this.chunks = undefined;
      }
      if (this.stream) {
        this.stream.getTracks().forEach(function (track) {
          return track.stop();
        });
      }
      if (this.combinedStream) {
        this.combinedStream.getTracks().forEach(function (track) {
          return track.stop();
        });
      }
      if (this.additionalWrtc && this.additionalWrtc.stream) {
        this.additionalWrtc.stream.getTracks().forEach(function (track) {
          return track.stop();
        });
      }
      if (this.mediaElem && this.mediaElem.srcObject) {
        var tracks = this.mediaElem.srcObject.getTracks();
        tracks.forEach(function (track) {
          return track.stop();
        });
        this.mediaElem.srcObject = null;
      }
      if (this.removeRecord) {
        this.removeFileFromCache();
      }
    }
  }, {
    key: "startAudioRecord",
    value: function startAudioRecord(callback) {
      var _this6 = this;
      if (this.stream) {
        var chunks = [];
        var options = {
          mimeType: 'audio/webm'
        };
        if ((0,browser/* detectBrowser */.Ao)() === 'Safari') {
          options = {
            mimeType: 'audio/mp4'
          };
        }
        this.recorder = new MediaRecorder(this.stream, options);
        this.recorder.ondataavailable = function (event) {
          if (event.data && event.data.size > 0) {
            chunks.push(event.data);
          }
          _this6.chunks = chunks;
        };
        this.recorder.onstop = function (event) {
          var opts = {
            type: "audio/mpeg"
          };
          if ((0,browser/* detectBrowser */.Ao)() === 'Safari') {
            opts = {
              mimeType: 'audio/mp4'
            };
            _this6.blob = new Blob(chunks, opts);
            if (_this6.blot) {
              _this6.uploadFile(_this6.blob, 'audio');
            }
            if (callback) {
              callback(_this6.blob);
            }
          } else {
            _this6.getSeekableBlob(new Blob(chunks, opts), opts, function (seekableBlob) {
              _this6.blob = seekableBlob;
              if (_this6.blot) {
                _this6.uploadFile(seekableBlob, 'audio');
              }
              if (callback) {
                callback(_this6.blob);
              }
            });
          }
        };
        this.recorder.start();
      }
    }
  }, {
    key: "stopAudioRecord",
    value: function stopAudioRecord() {
      if (this.recorder) {
        this.recorder.stop();
        this.recorder = undefined;
        this.chunks = undefined;
      }
      if (this.stream) {
        this.stream.getTracks().forEach(function (track) {
          return track.stop();
        });
      }
      if (this.removeRecord) {
        this.removeFileFromCache();
      }
    }
  }, {
    key: "pauseRecord",
    value: function pauseRecord() {
      if (this.recorder) {
        this.recorder.pause();
      }
    }
  }, {
    key: "resumeRecord",
    value: function resumeRecord() {
      if (this.recorder) {
        this.recorder.resume();
      }
    }
  }, {
    key: "restoreRecord",
    value: function restoreRecord(blot) {
      var _this7 = this;
      this.blot = blot;
      if (fsWeb && this.blot) {
        fsWeb.readString(this.blot.id).then(function (file) {
          var type = null;
          if (file.type.startsWith('video')) {
            type = 'video';
          } else if (file.type.startsWith('audio')) {
            type = 'audio';
          }
          _this7.uploadFile(file, type);
        });
      }
    }
  }, {
    key: "checkTmpRecord",
    value: function () {
      var _checkTmpRecord = webRTC_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (fsWeb) {
                  _context4.next = 3;
                  break;
                }
                _context4.next = 3;
                return webRTC_loadScriptsPromise();
              case 3:
                if (!(fsWeb && this.blot)) {
                  _context4.next = 9;
                  break;
                }
                _context4.next = 6;
                return fsWeb.readString(this.blot.id).then(function (file) {
                  return file;
                }, function (reason) {
                  return false;
                });
              case 6:
                return _context4.abrupt("return", _context4.sent);
              case 9:
                return _context4.abrupt("return", false);
              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function checkTmpRecord() {
        return _checkTmpRecord.apply(this, arguments);
      }
      return checkTmpRecord;
    }()
  }, {
    key: "getRecordData",
    value: function getRecordData(totalTime) {
      var _this8 = this;
      if (this.recorder && this.recorder.state !== 'inactive') {
        var recordData = this.recorder.requestData();
        // Пишем данные файла в indexeddb
        if (fsWeb && this.blot && this.chunks && this.chunks.length > 0) {
          var opts = {
            type: null
          };
          if (this.type === 'audio') {
            opts = {
              type: "audio/mpeg"
            };
          } else if (this.type === 'media' || this.type === 'camera' || this.type === 'mediaCam') {
            opts = {
              type: "video/webm;codecs=vp9"
            };
          }
          if (opts.type) {
            if (this.blot) {
              //const maxFileSize = this.blot.editor.plugins.attachmentManager.getMaxFileSize()
              var limitRecord = this.blot.editor.plugins.webRTCPlugin.getLimitRecord();
              if (limitRecord > 0 && totalTime >= limitRecord) {
                if (this.type === 'audio') {
                  this.stopAudioRecord();
                } else if (this.type === 'media' || this.type === 'camera' || this.type === 'mediaCam') {
                  this.stopMediaRecord();
                }
                this.blot.editor.plugins.webRTCPlugin.maxRecordTimeExceeded(limitRecord);
              } else {
                if ((0,browser/* detectBrowser */.Ao)() === 'Safari') {
                  opts = {
                    mimeType: 'audio/mp4'
                  };
                  fsWeb.writeFile(this.blot.id, new Blob(this.chunks, opts));
                } else {
                  this.getSeekableBlob(new Blob(this.chunks, opts), opts, function (seekableBlob) {
                    fsWeb.writeFile(_this8.blot.id, seekableBlob);
                  });
                }
              }
              /*if (blob.size < maxFileSize) {
                fsWeb.writeFile(this.blot.id, blob)
              } else {
                if (this.type === 'audio') {
                  this.stopAudioRecord()
                } else if (this.type === 'media' || this.type === 'camera' || this.type === 'mediaCam') {
                  this.stopMediaRecord()
                }
                this.blot.editor.plugins.webRTCPlugin.maxFileSizeExceeded(maxFileSize)
              }*/
            }
          }
        }

        return recordData;
      }
    }
  }, {
    key: "getRecordSize",
    value: function getRecordSize() {
      var totalSize = 0;
      if (this.chunks && this.chunks.length > 0) {
        this.chunks.forEach(function (chunk) {
          totalSize = totalSize + chunk.size;
        });
      }
      return totalSize;
    }
  }, {
    key: "renderTime",
    value: function renderTime(time) {
      var totalSeconds = time;
      var hours = Math.floor(totalSeconds / 3600);
      totalSeconds %= 3600;
      var minutes = Math.floor(totalSeconds / 60);
      var seconds = totalSeconds % 60;
      minutes = String(minutes).padStart(2, "0");
      hours = String(hours).padStart(2, "0");
      seconds = String(seconds).padStart(2, "0");
      return hours + ":" + minutes + ":" + seconds;
    }
  }, {
    key: "getTimeStamp",
    value: function getTimeStamp() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1;
      var curr_year = date.getFullYear();
      var cur_hours = date.getHours();
      var cur_minutes = date.getMinutes();
      return curr_year + "_" + curr_month + "_" + curr_date + '_' + cur_hours + '_' + cur_minutes;
    }
  }, {
    key: "uploadFile",
    value: function uploadFile(file, type) {
      if (file) {
        var recordInstance = null;
        if (type === 'audio') {
          var fileName = this.AudioRecordFileName + '_' + this.getTimeStamp() + '.mp3';
          file.name = fileName;
          recordInstance = {
            name: fileName,
            size: file.size,
            type: file.type,
            instance: file
          };
        } else if (type === 'video') {
          var _fileName = this.MediaRecordFileName + '_' + this.getTimeStamp() + '.webm';
          file.name = _fileName;
          recordInstance = {
            name: _fileName,
            size: file.size,
            type: file.type,
            instance: file
          };
        }
        if (recordInstance) {
          if (this.blot) {
            var uploadRecordEvent = new CustomEvent('uploadRecordEvent', {
              detail: recordInstance
            });
            this.blot.domNode.dispatchEvent(uploadRecordEvent);
          } else {
            this.recordInstance = recordInstance;
          }
        }
      }
    }
  }, {
    key: "removeFileFromCache",
    value: function removeFileFromCache() {
      if (this.blot && fsWeb) {
        fsWeb.removeFile(this.blot.id);
      }
    }
  }, {
    key: "getSeekableBlob",
    value: function getSeekableBlob(inputBlob, opts, callback) {
      var reader = new EBML.Reader();
      var decoder = new EBML.Decoder();
      var tools = EBML.tools;
      var fileReader = new FileReader();
      fileReader.onload = function (e) {
        var ebmlElms = decoder.decode(this.result);
        ebmlElms.forEach(function (element) {
          if (element.type !== 'unknown') {
            reader.read(element);
          }
        });
        reader.stop();
        var refinedMetadataBuf = tools.makeMetadataSeekable(reader.metadatas, reader.duration, reader.cues);
        var body = this.result.slice(reader.metadataSize);
        var newBlob = new Blob([refinedMetadataBuf, body], opts);
        callback(newBlob);
      };
      fileReader.readAsArrayBuffer(inputBlob);
    }
  }, {
    key: "download",
    value: function download() {
      var _this9 = this;
      if (this.blob && this.chunks && this.chunks.length > 0) {
        if ((0,browser/* detectBrowser */.Ao)() === 'Safari') {
          this.buildDownloadUrl(new Blob(this.chunks, {
            type: this.blob.type
          }));
        } else {
          this.getSeekableBlob(new Blob(this.chunks, {
            type: this.blob.type
          }), {
            type: this.blob.type
          }, function (seekableBlob) {
            _this9.buildDownloadUrl(seekableBlob);
          }, true);
        }
      } else {
        this.checkTmpRecord().then(function (file) {
          if (file) {
            _this9.buildDownloadUrl(file);
          }
        });
      }
    }
  }, {
    key: "buildDownloadUrl",
    value: function buildDownloadUrl(blob) {
      var filename;
      if (this.blob) {
        filename = this.blob.name;
      } else {
        if (blob.type === "video/webm;codecs=vp9") {
          filename = this.MediaRecordFileName + '_' + this.getTimeStamp() + '.webm';
        } else {
          filename = this.AudioRecordFileName + '_' + this.getTimeStamp() + '.mp3';
        }
      }
      var url = URL.createObjectURL(blob);
      var elem = window.document.createElement('a');
      elem.href = url;
      elem.download = filename;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    }
  }]);
  return WebRTC;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/webRTC/index.js


function plugins_webRTC_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function plugins_webRTC_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { plugins_webRTC_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { plugins_webRTC_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function plugins_webRTC_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function plugins_webRTC_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function plugins_webRTC_createClass(Constructor, protoProps, staticProps) { if (protoProps) plugins_webRTC_defineProperties(Constructor.prototype, protoProps); if (staticProps) plugins_webRTC_defineProperties(Constructor, staticProps); return Constructor; }



var WebRTCPlugin = /*#__PURE__*/function () {
  function WebRTCPlugin(_ref) {
    var scroll = _ref.scroll,
      editor = _ref.editor,
      options = _ref.options;
    plugins_webRTC_classCallCheck(this, WebRTCPlugin);
    this.editor = editor;
    this.scroll = scroll;
    this.options = options || {};
    this.isPlugin = true;
  }
  plugins_webRTC_createClass(WebRTCPlugin, [{
    key: "prepareMediaRecord",
    value: function prepareMediaRecord() {
      WrtcRecord.prepareMediaRecord(this.editor);
    }
  }, {
    key: "setMediaOptions",
    value: function setMediaOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.options.mediaOptions = options;
    }
  }, {
    key: "isInit",
    get: function get() {
      if (this.wrtc) {
        if (this.wrtc.error) {
          return this.wrtc.error;
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  }, {
    key: "initAudio",
    value: function () {
      var _initAudio = plugins_webRTC_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(blot) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.init('audio', blot, true);
              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function initAudio(_x) {
        return _initAudio.apply(this, arguments);
      }
      return initAudio;
    }()
  }, {
    key: "initMedia",
    value: function () {
      var _initMedia = plugins_webRTC_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(blot) {
        var chooseMicro,
          _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                chooseMicro = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : true;
                _context2.next = 3;
                return this.init('media', blot, chooseMicro);
              case 3:
                return _context2.abrupt("return", true);
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function initMedia(_x2) {
        return _initMedia.apply(this, arguments);
      }
      return initMedia;
    }()
  }, {
    key: "initCamera",
    value: function () {
      var _initCamera = plugins_webRTC_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(blot) {
        var chooseMicro,
          _args3 = arguments;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                chooseMicro = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : true;
                _context3.next = 3;
                return this.init('camera', blot, chooseMicro);
              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function initCamera(_x3) {
        return _initCamera.apply(this, arguments);
      }
      return initCamera;
    }()
  }, {
    key: "initMediaCam",
    value: function () {
      var _initMediaCam = plugins_webRTC_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(blot) {
        var chooseMicro,
          _args4 = arguments;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                chooseMicro = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : true;
                _context4.next = 3;
                return this.init('mediaCam', blot, chooseMicro);
              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function initMediaCam(_x4) {
        return _initMediaCam.apply(this, arguments);
      }
      return initMediaCam;
    }()
  }, {
    key: "init",
    value: function () {
      var _init = plugins_webRTC_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var type,
          blot,
          chooseMicro,
          _args5 = arguments;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                type = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : null;
                blot = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : null;
                chooseMicro = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : true;
                if (!(type === 'audio')) {
                  _context5.next = 11;
                  break;
                }
                this.wrtc = new WebRTC(this.options.mediaOptions);
                this.wrtc.constraints.video = false;
                if (blot) {
                  this.wrtc.blot = blot;
                }
                _context5.next = 9;
                return this.wrtc.init(type);
              case 9:
                _context5.next = 39;
                break;
              case 11:
                if (!(type === 'media' || type === 'camera')) {
                  _context5.next = 28;
                  break;
                }
                this.wrtc = new WebRTC(this.options.mediaOptions);
                if (!blot) {
                  _context5.next = 24;
                  break;
                }
                this.wrtc.blot = blot;
                if (type === 'camera') {
                  if (!chooseMicro) {
                    this.wrtc.constraints.audio = false;
                  }
                }
                if (!(type === 'media' && chooseMicro)) {
                  _context5.next = 24;
                  break;
                }
                this.wrtc.additionalWrtc = new WebRTC();
                this.wrtc.additionalWrtc.constraints.video = false;
                this.wrtc.chooseMicro = chooseMicro;
                this.wrtc.additionalWrtc.blot = blot;
                this.wrtc.additionalWrtc.chooseMicro = chooseMicro;
                _context5.next = 24;
                return this.wrtc.additionalWrtc.init('camera');
              case 24:
                _context5.next = 26;
                return this.wrtc.init(type);
              case 26:
                _context5.next = 39;
                break;
              case 28:
                if (!(type === 'mediaCam')) {
                  _context5.next = 38;
                  break;
                }
                this.wrtc = new WebRTC(this.options.mediaOptions);
                this.wrtc.additionalWrtc = new WebRTC();
                if (blot) {
                  this.wrtc.blot = blot;
                  this.wrtc.chooseMicro = chooseMicro;
                  this.wrtc.additionalWrtc.blot = blot;
                  this.wrtc.additionalWrtc.chooseMicro = chooseMicro;
                }
                _context5.next = 34;
                return this.wrtc.additionalWrtc.init('camera');
              case 34:
                _context5.next = 36;
                return this.wrtc.init('media');
              case 36:
                _context5.next = 39;
                break;
              case 38:
                return _context5.abrupt("return", false);
              case 39:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "startAudioRecord",
    value: function startAudioRecord(callback) {
      if (this.wrtc && this.wrtc.type) {
        this.wrtc.startAudioRecord(callback);
      }
    }
  }, {
    key: "stopAudioRecord",
    value: function stopAudioRecord() {
      if (this.wrtc && this.wrtc.type) {
        wrtc.removeRecord = true;
        this.wrtc.stopAudioRecord();
      }
    }
  }, {
    key: "startMediaRecord",
    value: function startMediaRecord(callback) {
      if (this.wrtc && this.wrtc.type) {
        this.wrtc.startMediaRecord(callback);
      }
    }
  }, {
    key: "stopMediaRecord",
    value: function stopMediaRecord() {
      if (this.wrtc && this.wrtc.type) {
        wrtc.removeRecord = true;
        this.wrtc.stopMediaRecord();
      }
    }
  }, {
    key: "pauseRecord",
    value: function pauseRecord() {
      if (this.wrtc && this.wrtc.type) {
        this.wrtc.pauseRecord();
      }
    }
  }, {
    key: "resumeRecord",
    value: function resumeRecord() {
      if (this.wrtc && this.wrtc.type) {
        this.wrtc.resumeRecord();
      }
    }
  }, {
    key: "isExistsRecords",
    get: function get() {
      var isExistAudio = false;
      var isExistMedia = false;
      eachBlot(this.scroll, function (blot) {
        if (blot.embed && blot.embed.mediaRecord) {
          isExistMedia = true;
        } else if (blot.embed && blot.embed.audioRecord) {
          isExistAudio = true;
        }
      }, {
        inTables: false
      });
      if (!isExistMedia) {
        var popup = this.editor.container.querySelector('#mediaRecordPopup');
        if (popup) {
          isExistMedia = true;
        }
      }
      return {
        audio: isExistAudio,
        media: isExistMedia
      };
    }
  }, {
    key: "checkTmpRecord",
    value: function () {
      var _checkTmpRecord = plugins_webRTC_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(blot) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.wrtc = new WebRTC();
                if (blot) {
                  this.wrtc.blot = blot;
                }
                _context6.next = 4;
                return this.wrtc.checkTmpRecord();
              case 4:
                return _context6.abrupt("return", _context6.sent);
              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
      function checkTmpRecord(_x5) {
        return _checkTmpRecord.apply(this, arguments);
      }
      return checkTmpRecord;
    }()
  }, {
    key: "isMethodImplemented",
    value: function isMethodImplemented(method) {
      return Boolean(this.options[method]);
    }
  }, {
    key: "maxFileSizeExceeded",
    value: function maxFileSizeExceeded(maxFileSize) {
      if (this.isMethodImplemented('maxFileSizeExceeded') && maxFileSize) {
        this.options.maxFileSizeExceeded(maxFileSize);
      }
    }
  }, {
    key: "maxRecordTimeExceeded",
    value: function maxRecordTimeExceeded(limitRecord) {
      if (this.isMethodImplemented('maxRecordTimeExceeded') && limitRecord) {
        this.options.maxRecordTimeExceeded(limitRecord);
      }
    }
  }, {
    key: "getLimitRecord",
    value: function getLimitRecord() {
      if (this.options.limitRecord) {
        return parseInt(this.options.limitRecord);
      } else {
        return 0;
      }
    }
  }]);
  return WebRTCPlugin;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/limitManager/index.js
function limitManager_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function limitManager_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { limitManager_ownKeys(Object(source), true).forEach(function (key) { limitManager_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { limitManager_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function limitManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function limitManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function limitManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) limitManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) limitManager_defineProperties(Constructor, staticProps); return Constructor; }
function limitManager_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













var LIMIT_TYPES = ['paragraph', 'blockquote', 'hint', 'outline', 'hLarge', 'hMedium', 'hSmall', 'hLine', 'listItemBullet', 'listItemNumber', 'listItemCheckbox', 'image', 'syntax', 'remote-frame', 'bookmark', 'tableRow', 'row', 'button-single', 'toggle'];

// Экспорт для сервера редактора:
var BLOT_COUNT_TYPES = {
  // Лимитируемые типы блотов, есть в blots_count заметки и org_usage
  limit: [].concat(LIMIT_TYPES, ['file']),
  // Подсчитываемые типы блотов (есть в событиях аналитики и инфо о заметке, но нет в blots_count заметки)
  count: [].concat(LIMIT_TYPES, ['file', 'list', 'table', 'uploader']),
  // Исключаем из лимита блоты, находящиеся внутри блотов этого списка, допустим файлы в таблицах
  skip_inner: ['tableRow', 'row']
};
var limitManager_DEFAULT_OPTIONS = {
  count: 0,
  inited: false,
  limitTypes: ['any'].concat(LIMIT_TYPES),
  limitFunc: {
    'table': function table() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var result = {
        allow: false,
        amount: 0
      };
      if (params.map && params.map.has('rows')) {
        params.map.get('rows').forEach(function (childId) {
          if (!params.ignoreIds || !params.ignoreIds.includes(childId)) {
            result.allow = true;
            result.amount++;
          }
        });
      }
      return result;
    },
    'list': function list() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var result = {
        allow: true,
        amount: 1
      };
      if (params.map && params.map.has('children')) {
        result.amount = params.map.get('children').length;
      }
      return result;
    },
    'file': function file() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var result = {
        allow: true,
        amount: 1
      };
      if (params.map && params.map.get('mode') === 'tableCell') {
        result.allow = false;
        result.amount = 0;
      }
      return result;
    }
  }
};
var LimitManagerPlugin = /*#__PURE__*/function () {
  function LimitManagerPlugin(_ref) {
    var _this = this;
    var editor = _ref.editor,
      options = _ref.options;
    limitManager_classCallCheck(this, LimitManagerPlugin);
    limitManager_defineProperty(this, "listeners", function () {
      if (_this.listen) {
        return;
      }
      _this.listen = true;
      _this.editor.on(EVENT_BLOT_ADDED, _this.onBlotAdded);
      _this.editor.on(EVENT_BLOT_REMOVED, _this.onBlotRemoved);
    });
    limitManager_defineProperty(this, "onBlotAdded", function (_ref2) {
      var id = _ref2.id;
      try {
        var map = _this.editor.store.getMap(id);
        if (map && map.has('type')) {
          //console.info('EVENT_BLOT_ADDED', id, map)
          _this.increase({
            id: id,
            map: map,
            type: map.get('type')
          });
        }
      } catch (err) {
        console.warn('Error in LimitManager.onBlotAdded: ', err);
      }
    });
    limitManager_defineProperty(this, "onBlotRemoved", function (_ref3) {
      var id = _ref3.id;
      try {
        var params = {
          id: id
        };
        var map = _this.editor.store.getMap(id);
        //console.info('EVENT_BLOT_REMOVED', id, map)
        if (map) {
          params.map = map;
          if (map.has('type')) {
            params.type = map.get('type');
          }
        }
        _this.decrease(params);
      } catch (err) {
        console.warn('Error in LimitManager.onBlotRemoved: ', err);
      }
    });
    this.editor = editor;
    this.options = Object.assign({}, limitManager_DEFAULT_OPTIONS, options);
    this.cache = {
      'allowed': {},
      'removed': []
    };
    if (this.options.enabled) {
      this.listeners();
    }
  }
  limitManager_createClass(LimitManagerPlugin, [{
    key: "inited",
    get:
    /**
     * Limit Manager активируется после создания стартового блота
     */
    function get() {
      if (!this.options.inited && this.editor && this.editor.scroll.children.length > 0) {
        this.options.inited = true;
      }
      return this.options.inited;
    }

    /**
     * Событие при добавлении блота
     * @param {object} event
     * @param {string} event.id - id блота
     */
  }, {
    key: "isTypeAllowed",
    value:
    /**
     * Разрешение на подсчет данного блота по его типу или id
     * @param {object} params
     * @param {string} params.type - тип добавляемого блота
     * @param {string} params.id? - id добавляемого блота
     * @param {boolean} params.cache? - использовать значения кэша по id добавляемого блока
     * @param {boolean} params.useFunc? - использовать расширенные функции для типов из limitFunc
     * @param {array} params.ignoreIds? - игнорировать блоты с данными id
     * @return {object} result
     * @return {boolean} result.allow - разрешить подсчет данного типа блота
     * @return {integer} result.amount - число добавляемых блоков (может быть больше 1, напр. таблица)
     */
    function isTypeAllowed() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$options = this.options,
        limitTypes = _this$options.limitTypes,
        limitFunc = _this$options.limitFunc;
      var result = {
        allow: false
      };
      if (params.type) {
        if (limitTypes.includes(params.type)) {
          result.allow = true;
        } else if (params.useFunc && limitFunc[params.type]) {
          var res = limitFunc[params.type](params);
          if (res.allow) {
            result.allow = res.allow;
            if (res.amount) {
              result.amount = res.amount;
            }
          }
        }
        if (params.id && params.cache && result.allow) {
          this.cache.allowed[params.id] = result.amount || 1;
        }
      } else if (params.id && this.cache.allowed[params.id]) {
        result = {
          allow: true,
          amount: this.cache.allowed[params.id]
        };
      }
      return result;
    }

    /**
     * Проверяет возможность добавления нового блота(ов) в редактор
     * Может вызывать сообщение о превышении лимита
     * @param {object} params
     * @param {string} params.type - тип добавляемого блота
     * @param {integer} params.amount? - число добавляемых блотов
     * @param {boolean} params.alert? - вызывать сообщение о превышении лимита
     * @param {boolean} params.freeze? - приостановить последующую проверку лимитов, если добавление разрешено
     * @param {boolean} params.checkForce? - выполнить проверку, даже если лимит менеджер еще не инициализирован
     * @return {boolean}
     */
  }, {
    key: "canAddBlot",
    value: function canAddBlot() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = this.options;
      if (options.enabled && !this.frozen && (this.inited || params.checkForce)) {
        if (this.isTypeAllowed(params).allow) {
          var total = options.count + (params.hasOwnProperty('amount') ? params.amount : 1);
          if (total > options.limit) {
            console.warn('Limit:', total, '/', options.limit);
            if (params.alert) {
              options.alert && options.alert({
                limit: options.limit,
                count: total
              });
            }
            return false;
          }
        }
        if (params.freeze) {
          this.freeze();
        }
      }
      return true;
    }

    /**
     * Приостановить проверку лимитов (напр. при вставке произвольного числа блотов)
     * После этого canAddBlot будет возвращать true
     * Счетчик при этом продолжает работать
     */
  }, {
    key: "freeze",
    value: function freeze() {
      if (this.options.enabled) {
        this.frozen = true;
      }
    }

    /**
     * Возобновить проверку лимитов
     */
  }, {
    key: "unfreeze",
    value: function unfreeze() {
      if (this.options.enabled) {
        this.frozen = false;
      }
    }

    /**
     * Увеличить значение счетчика
     * @param {object} params
     * @param {string} params.type - тип добавляемого блота
     * @param {string} params.id? - id добавляемого блота
     * @param {integer} params.amount? - число добавляемых блотов
     * @return {boolean}
     */
  }, {
    key: "increase",
    value: function increase() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var result = this.isTypeAllowed(limitManager_objectSpread({
        cache: true,
        useFunc: true
      }, params));
      if (this.inited && result.allow) {
        this.options.count += params.amount || result.amount || 1;
        if (params.id) {
          var index = this.cache.removed.indexOf(params.id);
          if (index !== -1) {
            this.cache.removed.splice(index, 1);
          }
        }
        this.onChange();
      }
    }

    /**
     * Уменьшить значение счетчика
     * @param {object} params
     * @param {string} params.type - тип удаляемого блота
     * @param {string} params.id? - id удаляемого блота
     * @param {integer} params.amount? - число удаляемых блотов
     * @return {boolean}
     */
  }, {
    key: "decrease",
    value: function decrease() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var result = this.isTypeAllowed(limitManager_objectSpread({
        ignoreIds: this.cache.removed,
        useFunc: true
      }, params));
      if (this.inited && result.allow) {
        this.options.count -= params.amount || result.amount || 1;
        if (params.id) {
          this.cache.removed.push(params.id);
        }
        this.onChange();
      }
    }

    /**
     * Событие, вызываемое при изменении счетчика
     */
  }, {
    key: "onChange",
    value: function onChange() {
      this.options.onChange && this.options.onChange(this.options.count);
    }
  }]);
  return LimitManagerPlugin;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/convertBlotManager/convertBlotSession.js












function convertBlotSession_slicedToArray(arr, i) { return convertBlotSession_arrayWithHoles(arr) || convertBlotSession_iterableToArrayLimit(arr, i) || convertBlotSession_unsupportedIterableToArray(arr, i) || convertBlotSession_nonIterableRest(); }
function convertBlotSession_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function convertBlotSession_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function convertBlotSession_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function convertBlotSession_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { convertBlotSession_typeof = function _typeof(obj) { return typeof obj; }; } else { convertBlotSession_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return convertBlotSession_typeof(obj); }
function convertBlotSession_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = convertBlotSession_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function convertBlotSession_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return convertBlotSession_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return convertBlotSession_arrayLikeToArray(o, minLen); }
function convertBlotSession_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function convertBlotSession_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function convertBlotSession_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function convertBlotSession_createClass(Constructor, protoProps, staticProps) { if (protoProps) convertBlotSession_defineProperties(Constructor.prototype, protoProps); if (staticProps) convertBlotSession_defineProperties(Constructor, staticProps); return Constructor; }
function convertBlotSession_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var ConvertBlotSession = /*#__PURE__*/function () {
  function ConvertBlotSession(manager, blot, index, startRangePos) {
    var _this = this;
    convertBlotSession_classCallCheck(this, ConvertBlotSession);
    convertBlotSession_defineProperty(this, "onBlotTextChange", function (delta) {
      if (_this.index === 1 && delta.length() === 1 && delta.ops[0].insert === '/' || _this.index === 1 && _this.blot.getText() === '/\n' || convertBlotSession_getDeltaRetainOp(delta) >= _this.index && convertBlotSession_getDeltaRetainOp(delta) <= _this.index + _this.length) {
        var _iterator = convertBlotSession_createForOfIteratorHelper(delta.ops),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var op = _step.value;
            if (op.insert) {
              if (convertBlotSession_typeof(op.insert) === 'object') {
                _this.manager.end();
                return;
              } else {
                _this.length += op.insert.length;
              }
            } else if (op.delete) {
              _this.length -= op.delete;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        _this.query = _this.blot.getText(_this.index, _this.length) || '';
        var query = _this.query.toLowerCase();
        _this.onQuery(query);
      } else {
        _this.manager.end();
      }
    });
    convertBlotSession_defineProperty(this, "onEditorSelectionChange", function () {
      var _this$manager$scroll$ = _this.manager.scroll.selection.getRange({
          offsetBlot: _this.blot
        }),
        _this$manager$scroll$2 = convertBlotSession_slicedToArray(_this$manager$scroll$, 1),
        blotRange = _this$manager$scroll$2[0];
      if (!blotRange || blotRange.index < _this.index || blotRange.index > _this.index + _this.length) {
        _this.manager.end();
      }
    });
    this.manager = manager;
    this.blot = blot;
    this.index = index;
    this.startRangePos = startRangePos;
    this.length = 0;
    this.query = '';
    this.blot.on('text-change', this.onBlotTextChange);
    this.manager.editor.on('selectionchange', this.onEditorSelectionChange);
  }
  convertBlotSession_createClass(ConvertBlotSession, [{
    key: "onQuery",
    value: function onQuery(query) {
      this.manager.onQuery(query);
    }
  }, {
    key: "clearQuery",
    value: function clearQuery() {
      this.blot.map.get('characters').applyDelta([{
        retain: this.index - 1
      }, {
        delete: this.length + 1
      }]);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.blot.off('text-change', this.onBlotTextChange);
      this.manager.editor.off('selectionchange', this.onEditorSelectionChange);
    }
  }]);
  return ConvertBlotSession;
}();

function convertBlotSession_getDeltaRetainOp(delta) {
  var index = delta.filter(function (op) {
    return op.retain;
  })[0];
  return index && index.retain || -1;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/convertBlotManager/alias.json
const alias_namespaceObject = JSON.parse('{"paragraph":["paragraph","text","параграф","текст"],"tasks-list":["task","list","task list","todo","задачи","задача","список задач"],"todo":["checklist","checkbox","checkboxes","чеклист","список"],"numberedlist":["number list","numbers","lists","цифрованный список","список"],"bulletlist":["bullet list","bullet","lists","маркированный список","список"],"table":["table","database","excel","таблица","база данных"],"image":["image","picture","картинка","изображение"],"file":["file","attachment","video","audio","archive","файл","вложение","видео","аудио","архив"],"largeheading":["large","large heading","headers","большой","большой заголовок","заголовки"],"mediumheading":["medium","medium heading","headers","средний","средний заголовок","заголовки"],"smallheading":["small","small heading","headers","маленький","маленький заголовок","заголовки"],"hline":["line","section","break","линия","разделитель"],"link":["link","url","ссылка"],"syntax":["code","код","js","php","python"],"link-page":["mention","note","ссылка","страница"],"date":["mention","date","дата"],"mention":["mention","date","person","user","note","folder","workspace","упоминание","дата","юзер","участник","заметка","папка","проект"],"blockquote":["quote","цитата"],"hint":["hint","tip","callout","примечание","совет"],"outline":["outline","table of contents","оглавление","содержание"],"lock-blot":["lock","block","запретить","редактирование","блок"],"embed":["embed","vimeo","figma","github","объект","интеграция","ютуб","вставка"],"figma":["embed","figma","объект","интеграция","вставка"],"miro":["embed","miro","объект","интеграция","вставка"],"more-integrations":["embed","объект","интеграция","вставка"],"google-drive":["google drive","google","drive","гугл диск","гугл","диск"],"google-sheets":["google drive","google","drive","таблица","гугл диск","гугл","диск","таблица"],"bookmark":["bookmark","link","url","закладка","букмарк","ссылка"],"button":["button","link","url","кнопка","ссылка"],"audioRec":["webrtc","audio","record","аудио","запись"],"videoRec":["webrtc","video","record","видео","запись"],"toggle":["collapsible","toggle","spoiler","lists","тоггл","cпойлер","список","сворачиваемый список"],"largeheading-toggle":["collapsible","toggle","spoiler","тоггл","cпойлер","large","large heading","headers","большой","большой заголовок","заголовки","сворачиваемый заголовок"],"mediumheading-toggle":["collapsible","toggle","spoiler","тоггл","cпойлер","medium","medium heading","headers","средний","средний заголовок","заголовки","сворачиваемый заголовок"],"smallheading-toggle":["collapsible","toggle","spoiler","тоггл","cпойлер","small","small heading","headers","маленький","маленький заголовок","заголовки","сворачиваемый заголовок"],"columns":["2","2 columns","columns","two","колонки"],"meeting-notes":["template","note","page","шаблон","заметка","страница"],"marketing-brief":["template","note","page","шаблон","заметка","страница"],"content-plan":["template","note","page","шаблон","заметка","страница"],"more-templates":["template","note","page","шаблон","заметка","страница"],"get-feedback":["link","help","помощь","ссылка"],"contact-support":["link","help","помощь","ссылка"],"learn-nimbus":["link","help","помощь","ссылка"],"integrations":["integrations","embed","vimeo","figma","github","объект","интеграция","ютуб","вставка"],"database-with-options":["table","database","excel","таблица","база данных"],"board":["board","tasks","tasks list","tasks board","todo","kanban","задачи","доска","канбан","доска задач"],"progress":["progress","percent","прогресс","процент"],"dropdown-list":["dropdown list","labels","дропдаун","лейблы","выпадающий список"],"uploader":["uploader","files","загрузчик","файлы","загрузка"],"unsplash":["image","picture","картинка","изображение","unsplash"],"use-ai":["fusebase ai","use ai","use fusebase ai","использовать fusebase ai","искуственный интелект"],"step":["collapsible","toggle","spoiler","lists","step","тоггл","cпойлер","список","сворачиваемый список","шаг"],"step-aggregator":["step","aggregator","outline","шаг","агрегатор","оглавление"]}');
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/convertBlotManager/index.js
function convertBlotManager_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = convertBlotManager_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function convertBlotManager_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return convertBlotManager_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return convertBlotManager_arrayLikeToArray(o, minLen); }
function convertBlotManager_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function convertBlotManager_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function convertBlotManager_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { convertBlotManager_ownKeys(Object(source), true).forEach(function (key) { convertBlotManager_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { convertBlotManager_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






















function convertBlotManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function convertBlotManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function convertBlotManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) convertBlotManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) convertBlotManager_defineProperties(Constructor, staticProps); return Constructor; }
function convertBlotManager_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var CONVERT_BLOCK_MENU_MAX_HEIGHT = 340;
var CONVERT_BLOCK_MENU_ELEMENT_HEIGHT = 34;
var convertBlotManager_moreItemsMenuAppearDuration = (embedded_menu_default()).moreItemsMenuAppearDuration;
var TEXT_BLOTS = ['paragraph', 'listItemCheckbox', 'listItemNumber', 'listItemBullet', 'hLarge', 'hMedium', 'hSmall', 'blockquote', 'hint', 'syntax', 'toggle', 'hLarge-toggle', 'hMedium-toggle', 'hSmall-toggle', 'step'];
var ConvertBlotManager = /*#__PURE__*/function () {
  function ConvertBlotManager(_ref) {
    var _this = this;
    var scroll = _ref.scroll,
      editor = _ref.editor,
      options = _ref.options;
    convertBlotManager_classCallCheck(this, ConvertBlotManager);
    convertBlotManager_defineProperty(this, "convertBlot", function (params) {
      var _this$session = _this.session,
        blot = _this$session.blot,
        index = _this$session.index;
      var blotName = params.type === 'list' ? params.items[0] : params.type;
      if (blot.constructor.blotName !== blotName) {
        var rangeAfter = TEXT_BLOTS.includes(blotName) ? {
          index: blot.offset(_this.scroll) + index - 1,
          length: 0
        } : {
          index: blot.offset(_this.scroll) + index,
          length: 0
        };
        _this.session.clearQuery();
        _this.editor.exec('convert-blot', params);
        _this.scroll.selection.setRange(rangeAfter);
      }
      _this.end();
    });
    convertBlotManager_defineProperty(this, "onUseAi", function () {
      _this.session.clearQuery();
      var blot = _this.session.blot;
      var targetBlot = blot;
      if (targetBlot.isListItem) {
        var index = targetBlot.index;
        if (targetBlot.isEmpty()) {
          var _targetBlot$parent$sp = targetBlot.parent.splitList(index),
            id = _targetBlot$parent$sp.id;
          targetBlot = _this.editor.findById(id);
        } else {
          var _targetBlot$parent$sp2 = targetBlot.parent.splitWithBlot(index),
            _id = _targetBlot$parent$sp2.id;
          targetBlot = _this.editor.findById(_id);
        }
      } else {
        if (!targetBlot.isEmpty()) {
          var _blot$container$addBl = blot.container.addBlot('paragraph', {
              after: blot.id
            }),
            _id2 = _blot$container$addBl.id;
          targetBlot = _this.editor.findById(_id2);
        }
      }
      _this.editor.plugins.aiManager.show(targetBlot);
      _this.end();
    });
    convertBlotManager_defineProperty(this, "addFile", function () {
      _this.session.clearQuery();
      _this.editor.exec('add-file');
      _this.end();
    });
    convertBlotManager_defineProperty(this, "addLink", function () {
      _this.session.clearQuery();
      var _this$session2 = _this.session,
        blot = _this$session2.blot,
        index = _this$session2.index;
      _this.scroll.selection.setRange({
        index: blot.offset(_this.scroll) + index - 1,
        length: 0
      });
      addLinkAction(_this.editor);
      _this.end();
    });
    convertBlotManager_defineProperty(this, "addMention", function () {
      _this.session.clearQuery();
      var _this$session3 = _this.session,
        blot = _this$session3.blot,
        index = _this$session3.index;
      blot.map.get('characters').applyDelta([{
        retain: index - 1
      }, {
        insert: '@'
      }]);
      _this.scroll.selection.setRange({
        index: blot.offset(_this.scroll) + index,
        length: 0
      });
      _this.editor.plugins.mentionManager.start(blot, {
        index: index,
        length: 0
      });
      _this.end();
    });
    convertBlotManager_defineProperty(this, "addProgress", function () {
      _this.session.clearQuery();
      var _this$session4 = _this.session,
        blot = _this$session4.blot,
        index = _this$session4.index;
      blot.map.get('characters').applyDelta([{
        retain: index - 1
      }, {
        insert: {
          progress: 0
        }
      }, {
        insert: ' '
      }]);
      _this.scroll.selection.setRange({
        index: blot.offset(_this.scroll) + index + 1,
        length: 0
      });
      _this.end();
    });
    convertBlotManager_defineProperty(this, "addDropdownList", function () {
      _this.session.clearQuery();
      var _this$session5 = _this.session,
        blot = _this$session5.blot,
        index = _this$session5.index;
      blot.map.get('characters').applyDelta([{
        retain: index - 1
      }, {
        insert: convertBlotManager_defineProperty({}, 'dropdown-list', {
          ownerId: _this.editor.store.userId
        })
      }, {
        insert: ' '
      }]);
      _this.scroll.selection.setRange({
        index: blot.offset(_this.scroll) + index + 1,
        length: 0
      });
      _this.end();
    });
    convertBlotManager_defineProperty(this, "addRemoteFile", function (service) {
      var blot = _this.session.blot;
      _this.editor.exec('add-remote-file', {
        service: service,
        blot: blot
      });
      _this.end();
    });
    convertBlotManager_defineProperty(this, "addImage", function () {
      _this.convertBlot({
        type: 'image'
      });
    });
    convertBlotManager_defineProperty(this, "lockBlot", function () {
      if (!_this.session) return;
      var blot = _this.session.blot;
      _this.session.clearQuery();
      _this.editor.scroll.selection.setRange(null);
      if (blot && blot.lockBlotAction) {
        blot.lockBlotAction();
      }
      _this.end();
    });
    convertBlotManager_defineProperty(this, "addColumns", function () {
      if (!_this.session) return;
      var blot = _this.session.blot;
      _this.session.clearQuery();
      if (!blot.isEmpty()) {
        var _blot$container$addBl2 = blot.container.addBlot('paragraph', {
            after: blot.id
          }),
          id = _blot$container$addBl2.id;
        var addedBlot = _this.editor.findById(id);
        _this.scroll.selection.setRange({
          index: addedBlot.offset(_this.scroll),
          length: 0
        });
      }
      _this.editor.exec('add-grid', {
        position: 'left'
      });
    });
    convertBlotManager_defineProperty(this, "addDatabase", function (type) {
      _this.session.clearQuery();
      _this.editor.exec('add-database', {
        type: type
      });
      _this.editor.scroll.selection.setRange(null);
      _this.end();
    });
    convertBlotManager_defineProperty(this, "addUnsplashImage", function () {
      if (!_this.session) return;
      var blot = _this.session.blot;
      _this.session.clearQuery();
      _this.editor.plugins.unsplashManager.openPicker(blot, function (img) {
        var url = img && (img.urls.regular || img.urls.full || img.urls.raw);
        if (!url) {
          console.error('Unsplash image has no correct url');
        } else {
          var _img$user, _img$user2, _img$user2$links;
          var attachmentGlobalId = getPseudoImageAttachmentId(url);
          var authorParams = {
            name: (_img$user = img.user) === null || _img$user === void 0 ? void 0 : _img$user.name,
            link: (_img$user2 = img.user) === null || _img$user2 === void 0 ? void 0 : (_img$user2$links = _img$user2.links) === null || _img$user2$links === void 0 ? void 0 : _img$user2$links.html
          };
          var captionOps = null;
          if (authorParams.name || authorParams.link) {
            var _this$editor, _this$editor$plugins, _this$editor$plugins$;
            var linkAttrs = authorParams.link ? {
              link: authorParams.link
            } : null;
            var preffix = (((_this$editor = _this.editor) === null || _this$editor === void 0 ? void 0 : (_this$editor$plugins = _this$editor.plugins) === null || _this$editor$plugins === void 0 ? void 0 : (_this$editor$plugins$ = _this$editor$plugins.i18n) === null || _this$editor$plugins$ === void 0 ? void 0 : _this$editor$plugins$.get('image.unsplash.caption_preffix')) || 'Photo by') + ' ';
            captionOps = {
              ops: [{
                insert: preffix
              }, {
                insert: authorParams.name || authorParams.link,
                attributes: linkAttrs
              }]
            };
          }
          blot.container.addBlot('image', {
            after: blot.id,
            unsplash: true,
            attachmentGlobalId: attachmentGlobalId,
            captionParams: {
              delta: captionOps
            }
          });
          if (blot.isEmpty()) {
            blot.container.removeChildById(blot.id);
          }
        }
      });
    });
    convertBlotManager_defineProperty(this, "addStepsAggregator", function () {
      _this.session.clearQuery();
      var stepBlots = _this.scroll.descendants(function (blot) {
        return blot.constructor.blotName === 'step';
      });
      var beforeBlot = stepBlots.length ? stepBlots[0] : _this.scroll.children.head;
      var existsAggregators = _this.scroll.descendants(function (blot) {
        return blot.constructor.blotName === 'step-aggregator';
      });
      var params = {
        before: beforeBlot.id,
        focus: {
          index: 0
        }
      };
      if (existsAggregators.length) {
        params = convertBlotManager_objectSpread(convertBlotManager_objectSpread({}, existsAggregators[0].getMapParams()), params);
      }
      beforeBlot.container.addBlot('step-aggregator', params);
      _this.end();
    });
    convertBlotManager_defineProperty(this, "onChooseMenuItem", function (fn) {
      fn();
      _this.editor.plugins.selectionScroller.ensureSelectionVisible();
    });
    convertBlotManager_defineProperty(this, "onMenuWantsToClose", function () {
      _this.end();
    });
    convertBlotManager_defineProperty(this, "onRateEditorClick", function () {
      _this.setEditorRated();
      _this.editor.plugins.editorRate.onRateEditorClick();
      _this.end();
    });
    convertBlotManager_defineProperty(this, "onRateEditorCloseClick", function () {
      _this.setEditorRated();
    });
    convertBlotManager_defineProperty(this, "getMenuPositionParams", function (itemsCount) {
      var _this$session6 = _this.session,
        blot = _this$session6.blot,
        rangeRect = _this$session6.startRangePos;
      var blotRect = blot.domNode.getBoundingClientRect();
      var scrollingContainerRect = _this.editor.getScrollingContainer().getBoundingClientRect();
      var result = {
        offset: rangeRect.x - blotRect.x + 'px, '
      };
      if (!_this.menuPlacement) {
        _this.menuPlacement = _this.calcMenuDirection(rangeRect);
      }
      if (_this.menuPlacement === 'top-start') {
        // если сверху больше места, возвращаем расстояние между верхней границей редактора и верхней границей блока
        result.menuMaxHeight = rangeRect.y - scrollingContainerRect.y;
        result.offset += blotRect.y - rangeRect.y + 'px';
      } else {
        // если снизу места больше, возвращаем расстояние между нижней границе редактора и нижней границей блока
        result.menuMaxHeight = scrollingContainerRect.y + scrollingContainerRect.height - (rangeRect.y + rangeRect.height);
        result.offset += rangeRect.y + rangeRect.height - (blotRect.y + blotRect.height) + 'px';
      }
      // если блок в колонке и для рендера меню хватает места, возвращаем стандартное значение
      if (result.menuMaxHeight > CONVERT_BLOCK_MENU_MAX_HEIGHT) {
        result.menuMaxHeight = CONVERT_BLOCK_MENU_MAX_HEIGHT;
        result.overflowY = result.menuMaxHeight > CONVERT_BLOCK_MENU_ELEMENT_HEIGHT * itemsCount ? 'visible' : 'scroll';
      } else {
        result.overflowY = 'scroll';
      }
      return result;
    });
    this.options = Object.assign({
      enabled: true
    }, options);
    this.scroll = scroll;
    this.editor = editor;
    this.initContainer();
    this.scrollingContainer = this.editor.getScrollingContainer();
  }
  convertBlotManager_createClass(ConvertBlotManager, [{
    key: "initContainer",
    value: function initContainer() {
      if (!this.container) {
        this.container = document.createElement('div');
        this.container.id = 'convert-blot-manager';
        this.editor.scrollingContainer.appendChild(this.container);
        this.render(this.container);
      }
    }
  }, {
    key: "onQuery",
    value: function onQuery(query) {
      var excludeItems = Object.keys(alias_namespaceObject).filter(function (id) {
        return alias_namespaceObject[id].every(function (word) {
          return !word.startsWith(query);
        });
      });
      var excludeToggle = this.excludeToggleItemsIfNeed();
      var _iterator = convertBlotManager_createForOfIteratorHelper(excludeToggle),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var toggleItem = _step.value;
          if (!excludeItems.includes(toggleItem)) {
            excludeItems.push(toggleItem);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (this.editor.plugins.aiManager.isRequestActive) {
        excludeItems.push('use-ai');
      }
      if (excludeItems.length === Object.keys(alias_namespaceObject).length) {
        this.end();
      } else {
        this.render(this.container, true, {
          excludeItems: excludeItems
        });
      }
    }
  }, {
    key: "setEditorRated",
    value: function setEditorRated() {
      return this.editor.plugins.editorRate.setEditorRated();
    }
  }, {
    key: "isEditorRated",
    value: function isEditorRated() {
      return this.editor.plugins.editorRate.isEditorRated();
    }
  }, {
    key: "calcMenuDirection",
    value: function calcMenuDirection(rangeRect) {
      var scrollingContainerRect = this.editor.getScrollingContainer().getBoundingClientRect();
      if (rangeRect.y - scrollingContainerRect.y > scrollingContainerRect.y + scrollingContainerRect.height - (rangeRect.y + rangeRect.height)) {
        return 'top-start';
      } else {
        return 'bottom-start';
      }
    }
  }, {
    key: "excludeToggleItemsIfNeed",
    value: function excludeToggleItemsIfNeed() {
      if (searchUp(this.session.blot, function (b) {
        return b.constructor.blotName === 'toggleContent';
      })) {
        return ['toggle', 'largeheading-toggle', 'mediumheading-toggle', 'smallheading-toggle', 'columns', 'step', 'step-aggregator'];
      }
      return [];
    }
  }, {
    key: "render",
    value: function render(container) {
      var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var menu = null;
      if (show && this.session) {
        var behavior = this.menuPlacement === 'top-start' ? ['top', 'bottom', 'top'] : ['bottom', 'top', 'bottom'];
        var excludeItems = props.excludeItems && props.excludeItems.length ? props.excludeItems : this.excludeToggleItemsIfNeed();
        // если блот находится в колонке исключаем пункт добавления колонки
        if (searchUp(this.session.blot, function (b) {
          return b.constructor.blotName === 'gridCol';
        })) {
          excludeItems.push('columns');
        }
        if (this.editor.plugins.aiManager.isRequestActive) {
          excludeItems.push('use-ai');
        }
        menu = (0,preact_module.h)(ConvertMenuItems, {
          editor: this.editor,
          i18n: this.editor.plugins.i18n,
          wantsToClose: this.onMenuWantsToClose,
          menuKey: "convert-block-menu",
          getStyles: this.getMenuPositionParams,
          onChooseMenuItem: this.onChooseMenuItem,
          anchorNode: this.session.blot.domNode,
          convertBlot: this.convertBlot,
          onUseAi: this.onUseAi,
          addImage: this.addImage,
          addFile: this.addFile,
          addLink: this.addLink,
          addMention: this.addMention,
          addProgress: this.addProgress,
          addDropdownList: this.addDropdownList,
          addRemoteFile: this.addRemoteFile,
          addColumns: this.addColumns,
          addDatabase: this.addDatabase,
          lockBlot: this.lockBlot,
          addUnsplashImage: this.addUnsplashImage,
          excludeItems: excludeItems,
          anchorOptions: {
            placement: this.menuPlacement,
            boundariesElement: this.scrollingContainer,
            behavior: behavior
          },
          containerNode: this.container,
          updatePosition: true,
          onRateEditorClick: this.onRateEditorClick,
          onRateEditorCloseClick: this.onRateEditorCloseClick,
          showEditorRate: !this.isEditorRated() && this.editor.plugins.editorRate.isEnabled(),
          addStepsAggregator: this.addStepsAggregator
        });
      }
      (0,preact_module/* render */.sY)((0,preact_module.h)(preact_transition_group/* default */.Z, {
        transitionName: "menu",
        transitionEnterTimeout: convertBlotManager_moreItemsMenuAppearDuration,
        transitionLeaveTimeout: convertBlotManager_moreItemsMenuAppearDuration
      }, menu), container);
    }
  }, {
    key: "start",
    value: function start(blot, blotRange) {
      if (!this.options.enabled) return;
      var rangeRect = this.scroll.selection.getRange()[1].native.getBoundingClientRect();
      this.menuPlacement = this.calcMenuDirection(rangeRect);
      this.session = new ConvertBlotSession(this, blot, blotRange.index, rangeRect);
      this.render(this.container, true);
    }
  }, {
    key: "end",
    value: function end() {
      if (!this.session) return;
      var container = this.container;
      this.render(container);
      this.session.destroy();
      this.session = null;
      this.menuPlacement = null;
    }
  }]);
  return ConvertBlotManager;
}();

// EXTERNAL MODULE: ./node_modules/tinycolor2/tinycolor.js
var tinycolor = __webpack_require__(60119);
var tinycolor_default = /*#__PURE__*/__webpack_require__.n(tinycolor);
// EXTERNAL MODULE: ./node_modules/rangefix/rangefix.js
var rangefix = __webpack_require__(88131);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/awareness.js











function awareness_slicedToArray(arr, i) { return awareness_arrayWithHoles(arr) || awareness_iterableToArrayLimit(arr, i) || awareness_unsupportedIterableToArray(arr, i) || awareness_nonIterableRest(); }
function awareness_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function awareness_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return awareness_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return awareness_arrayLikeToArray(o, minLen); }
function awareness_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function awareness_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function awareness_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function awareness_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function awareness_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function awareness_createClass(Constructor, protoProps, staticProps) { if (protoProps) awareness_defineProperties(Constructor.prototype, protoProps); if (staticProps) awareness_defineProperties(Constructor, staticProps); return Constructor; }
function awareness_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var AwarenessBinding = /*#__PURE__*/function () {
  /**
   * @param {editor} editor
   * @param {awareness} awareness
   */
  function AwarenessBinding(_editor, awareness) {
    var _this = this;
    awareness_classCallCheck(this, AwarenessBinding);
    awareness_defineProperty(this, "updateCursor", function (aw, clientId, doc, editor) {
      if (aw && aw.cursor && clientId !== doc.clientID) {
        editor.plugins.awarenessPlugin.moveCursor(aw, clientId, doc);
      } else {
        editor.plugins.awarenessPlugin.removeCursor(aw, clientId, doc);
      }
    });
    awareness_defineProperty(this, "_awarenessObserver", function (eventType, blotId) {
      if (_this.awareness) {
        var scroll = _this.scroll;
        var _scroll$selection$get = scroll.selection.getRange(),
          _scroll$selection$get2 = awareness_slicedToArray(_scroll$selection$get, 2),
          sel = _scroll$selection$get2[0],
          native = _scroll$selection$get2[1];
        if (sel && sel.index !== null) {
          var relPos = getRelativePosition(_this.editor);
          if (relPos) {
            var relLeft = _this.editor.store.Y.relativePositionToJSON(relPos.relLeft);
            var relRight = _this.editor.store.Y.relativePositionToJSON(relPos.relRight);
            sel.relLeft = relLeft;
            sel.relRight = relRight;
            sel.firstBlot = relPos.firstBlot.id;
            sel.lastBlot = relPos.lastBlot.id;
          }
          sel.reversed = native && native.reversed;
          if (eventType) {
            sel.eventType = eventType;
            if (blotId) {
              sel.blotId = blotId;
            }
          }
          _this.awareness.setLocalStateField('cursor', {
            sel: sel
          });
        } else {
          if (_this.awareness.getLocalState() !== null) {
            _this.awareness.setLocalStateField('cursor', null);
          }
        }
        _this.updateRemoteCursors(eventType, blotId);
      }
    });
    awareness_defineProperty(this, "_awarenessChange", function (_ref) {
      var added = _ref.added,
        removed = _ref.removed,
        updated = _ref.updated;
      var states = _this.awareness.getStates();
      added.forEach(function (id) {
        _this.updateCursor(states.get(id), id, _this.awdoc, _this.editor);
      });
      updated.forEach(function (id) {
        var aw = states.get(id);
        if (aw.cursor && aw.cursor.sel && (aw.cursor.sel.typing || aw.cursor.sel.blotId)) {
          aw.cursor.sel.remote = true;
        }
        _this.updateCursor(states.get(id), id, _this.awdoc, _this.editor);
      });
      removed.forEach(function (id) {
        _this.editor.plugins.awarenessPlugin.removeCursor(states.get(id), id, _this.awdoc);
      });
    });
    awareness_defineProperty(this, "onTypeObserverDebounce", lodash_debounce_default()(function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var backspace = args && args[0];
      _this._awarenessObserver('typeObserver', null, backspace);
    }, 0, {
      trailing: true
    }));
    awareness_defineProperty(this, "onCursorChangeDebounce", lodash_debounce_default()(function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      var backspace = args && args[0];
      _this._awarenessObserver('selectionchange', null, backspace);
    }, 0, {
      trailing: true
    }));
    awareness_defineProperty(this, "onDragChangeDebounce", lodash_debounce_default()(function () {
      _this._awarenessObserver(EVENT_BLOT_DRAG_STOPPED);
    }, 0, {
      trailing: true
    }));
    awareness_defineProperty(this, "onBlotAddDebounce", lodash_debounce_default()(function () {
      var blotId = null;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      if (args && args[0] && args[0].id) {
        blotId = args[0].id;
      }
      _this._awarenessObserver(EVENT_BLOT_ADDED, blotId);
    }, 0, {
      trailing: true
    }));
    awareness_defineProperty(this, "onBlotRemoveDebounce", lodash_debounce_default()(function () {
      _this._awarenessObserver(EVENT_BLOT_REMOVED);
    }, 0, {
      trailing: true
    }));
    this.editor = _editor;
    this.scroll = _editor.scroll;
    this.awdoc = awareness && awareness.doc;
    this.awareness = awareness;
  }

  /**
   * @param {object} aw Awareness state {cursor, user}
   * @param {number} clientId
   * @param {object} doc
   * @param {object} editor
   */
  awareness_createClass(AwarenessBinding, [{
    key: "updateRemoteCursors",
    value:
    /**
     * @param {object} eventType
     * @param {string} blotId
     * @param {int} backspace
     * @param {bool} typing
     */
    function updateRemoteCursors(eventType, blotId) {
      var _this2 = this;
      // update all remote cursor locations
      this.awareness.getStates().forEach(function (aw, clientId) {
        if (eventType) {
          if (aw && aw.cursor && aw.cursor.sel) {
            aw.cursor.sel.eventType = eventType;
          }
        }
        _this2.updateCursor(aw, clientId, _this2.awdoc, _this2.editor);
      });
    }
  }]);
  return AwarenessBinding;
}();
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/awareness/index.js




















function plugins_awareness_slicedToArray(arr, i) { return plugins_awareness_arrayWithHoles(arr) || plugins_awareness_iterableToArrayLimit(arr, i) || plugins_awareness_unsupportedIterableToArray(arr, i) || plugins_awareness_nonIterableRest(); }
function plugins_awareness_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function plugins_awareness_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return plugins_awareness_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return plugins_awareness_arrayLikeToArray(o, minLen); }
function plugins_awareness_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function plugins_awareness_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function plugins_awareness_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function plugins_awareness_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function plugins_awareness_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function plugins_awareness_createClass(Constructor, protoProps, staticProps) { if (protoProps) plugins_awareness_defineProperties(Constructor.prototype, protoProps); if (staticProps) plugins_awareness_defineProperties(Constructor, staticProps); return Constructor; }
function plugins_awareness_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var CLASSES_TO_IGNORE = [table_table.className];
var AwarenessPlugin = /*#__PURE__*/function () {
  function AwarenessPlugin(_ref) {
    var _this = this;
    var scroll = _ref.scroll,
      editor = _ref.editor,
      options = _ref.options;
    plugins_awareness_classCallCheck(this, AwarenessPlugin);
    plugins_awareness_defineProperty(this, "onEditorBodyResize", function () {
      var _this$neditRoot$getBo = _this.neditRoot.getBoundingClientRect(),
        width = _this$neditRoot$getBo.width;
      _this.cursorsContainer.setAttribute('style', "--editor-max-width:".concat(width, "px;"));
    });
    this.editor = editor;
    this.scroll = scroll;
    this.options = options || {};
    this._awBinding = null;
    this.neditRoot = null;
    this.initBinding();
  }
  plugins_awareness_createClass(AwarenessPlugin, [{
    key: "initBinding",
    value: function initBinding() {
      var editMode = this.scroll.editor.mode === MODE_EDIT;
      this.neditRoot = this.editor.getScrollingContainer().querySelector('.nedit-root');
      if (editMode && this.isEnabled) {
        var awareness = this.editor.store.y.awareness;
        var awState = awareness && awareness.getLocalState();
        if (awState && !awState.user) {
          var currentUser = this.getCurrentUser();
          awareness.setLocalStateField('user', currentUser);
          this._awBinding = new AwarenessBinding(this.editor, awareness);
        }
        this.initEvents();
      }
    }
  }, {
    key: "initEvents",
    value: function initEvents() {
      var _this2 = this;
      if (this._awBinding) {
        this.editor.on(EVENT_BLOT_REMOVED, function () {
          _this2._awBinding.onBlotRemoveDebounce();
        });
        this.editor.on(EVENT_BLOT_ADDED, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          _this2._awBinding.onBlotAddDebounce(args);
        });
        this.editor.on('selectionchange', function () {
          _this2._awBinding.onCursorChangeDebounce();
        });
        this.editor.on(EVENT_BLOT_DRAG_STOPPED, function () {
          _this2._awBinding.onDragChangeDebounce();
        });
        this._awBinding.awareness.on('change', this._awBinding._awarenessChange);
      }
      this.editor.emitter.on('editorBodyResize', this.onEditorBodyResize);
    }
  }, {
    key: "isEnabled",
    get: function get() {
      return this.options.enabled;
    }

    /**
     * @param {string} method
     */
  }, {
    key: "isMethodImplemented",
    value: function isMethodImplemented(method) {
      return Boolean(this.options[method]);
    }
  }, {
    key: "getCurrentUser",
    value: function getCurrentUser() {
      if (this.isMethodImplemented('getCurrentUser')) {
        return this.options.getCurrentUser();
      }
      return null;
    }
  }, {
    key: "cursorsContainer",
    get: function get() {
      return this.editor.scrollingContainer.querySelector('#editor-cursors');
    }

    /**
     * @param {number} clientId
     */
  }, {
    key: "userCursorContainer",
    value: function userCursorContainer(clientId) {
      var containerId = this.getContainerId(clientId);
      var cursorsContainer = this.cursorsContainer;
      return cursorsContainer.querySelector("#" + containerId);
    }

    /**
     * @param {number} clientId
     */
  }, {
    key: "getContainerId",
    value: function getContainerId(clientId) {
      return 'ed-cursor-' + clientId;
    }

    /**
     * @param {number} index
     * @param {number} length
     */
  }, {
    key: "selectionGetBounds",
    value: function selectionGetBounds(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var scrollLength = this.scroll.length();
      index = Math.min(index, scrollLength - 1);
      length = Math.min(index + length, scrollLength - 1) - index;
      var node;
      var _this$scroll$leaf = this.scroll.leaf(index),
        _this$scroll$leaf2 = plugins_awareness_slicedToArray(_this$scroll$leaf, 2),
        leaf = _this$scroll$leaf2[0],
        offset = _this$scroll$leaf2[1];
      if (!leaf || typeof leaf === 'undefined') return null;
      if (typeof leaf.position === 'function') {
        var _leaf$position = leaf.position(offset, true);
        var _leaf$position2 = plugins_awareness_slicedToArray(_leaf$position, 2);
        node = _leaf$position2[0];
        offset = _leaf$position2[1];
      }
      var range = document.createRange();
      if (length > 0) {
        range.setStart(node, offset)[(leaf, offset)] = this.scroll.leaf(index + length);
        if (!leaf || typeof leaf === 'undefined') return null;
        if (typeof leaf.position === 'function') {
          var _leaf$position3 = leaf.position(offset, true);
          var _leaf$position4 = plugins_awareness_slicedToArray(_leaf$position3, 2);
          node = _leaf$position4[0];
          offset = _leaf$position4[1];
        } else if (!node) {
          // если не получили ноду ни в первом ни во втором случае, возвращаем null
          return null;
        }
        range.setEnd(node, offset);
        return range.getBoundingClientRect();
      }
      var side = 'left';
      var rect;
      if (leaf.isEmbeddable) {
        rect = leaf.domNode.getBoundingClientRect();
        rect.height = 0;
        if (offset > 0) side = 'right';
      } else if (node instanceof Text) {
        if (offset < node.data.length) {
          range.setStart(node, offset);
          range.setEnd(node, offset + 1);
        } else {
          range.setStart(node, offset - 1);
          range.setEnd(node, offset);
          side = 'right';
        }
        rect = range.getBoundingClientRect();
      } else {
        rect = leaf.domNode.getBoundingClientRect();
        if (offset > 0) side = 'right';
      }
      return {
        bottom: rect.top + rect.height,
        height: rect.height,
        left: rect[side],
        right: rect[side],
        top: rect.top,
        width: 0
      };
    }

    /**
     * @param {number} index
     * @param {number} length
     */
  }, {
    key: "getBounds",
    value: function getBounds(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var bounds = null;
      if (typeof index === 'number') {
        bounds = this.selectionGetBounds(index, length);
      } else {
        bounds = this.selectionGetBounds(index.index, index.length);
      }
      if (!bounds) return null;
      var containerBounds = this.editor.scroll.domNode.getBoundingClientRect();
      return {
        bottom: bounds.bottom - containerBounds.top,
        height: bounds.height,
        left: bounds.left - containerBounds.left,
        right: bounds.right - containerBounds.left,
        top: bounds.top - containerBounds.top,
        width: bounds.width
      };
    }
  }, {
    key: "updateRemoteCursors",
    value: function updateRemoteCursors(eventType) {
      this._awBinding.updateRemoteCursors(eventType);
    }

    /**
     * Проверка, стоит ли игнорировать курсор
     * @param { object } aw Awareness state {cursor, user}
     * @returns { boolean }
     */
  }, {
    key: "ignoreCursor",
    value: function ignoreCursor() {
      var _aw$cursor, _aw$cursor$sel;
      var aw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var skip = false;
      if ((_aw$cursor = aw.cursor) !== null && _aw$cursor !== void 0 && (_aw$cursor$sel = _aw$cursor.sel) !== null && _aw$cursor$sel !== void 0 && _aw$cursor$sel.hasOwnProperty('index')) {
        var _this$scroll$leaf3 = this.scroll.leaf(aw.cursor.sel.index),
          _this$scroll$leaf4 = plugins_awareness_slicedToArray(_this$scroll$leaf3, 2),
          leaf = _this$scroll$leaf4[0],
          offset = _this$scroll$leaf4[1];
        if (leaf) {
          var _leaf$position5 = leaf.position(offset, true),
            _leaf$position6 = plugins_awareness_slicedToArray(_leaf$position5, 1),
            node = _leaf$position6[0];
          if (node !== null && node !== void 0 && node.classList) {
            node.classList.forEach(function (className) {
              if (CLASSES_TO_IGNORE.includes(className)) {
                skip = true;
              }
            });
          }
        }
      }
      return skip;
    }

    /**
     * @param {object} aw Awareness state {cursor, user}
     * @param {number} clientId
     * @param {object} doc
     */
  }, {
    key: "moveCursor",
    value: function moveCursor(aw, clientId, doc) {
      // Игнорируем курсор при выделении неподдерживаемых блоков
      if (this.ignoreCursor(aw)) {
        this.removeCursor(aw, clientId);
        return;
      }
      var userCursorContainer = this.userCursorContainer(clientId);
      if (aw.cursor.sel.relLeft) {
        var relPos = {
          firstBlot: this.editor.findById(aw.cursor.sel.firstBlot),
          lastBlot: this.editor.findById(aw.cursor.sel.lastBlot),
          doc: doc,
          relLeft: this.editor.store.Y.createRelativePositionFromJSON(aw.cursor.sel.relLeft),
          relRight: this.editor.store.Y.createRelativePositionFromJSON(aw.cursor.sel.relRight)
        };
        try {
          var absPos = getAbsolutePosition(relPos);
          aw.cursor.sel.index = absPos.index;
        } catch (e) {}
      }
      if (userCursorContainer) {
        var dataIndex = parseInt(userCursorContainer.getAttribute('data-index'));
        var remote = aw.cursor.sel.remote;
        var index = this.getSelIndex(aw);
        var eventType = aw.cursor.sel.eventType;
        var blotId = aw.cursor.sel.blotId;
        if (remote && eventType === 'selectionchange') {
          aw.cursor.sel.index = dataIndex;
          aw.cursor.sel.remote = false;
        }
        var skip = false;
        if (eventType && eventType === 'selectionchange') {
          skip = true;
        }
        if (eventType && eventType === 'blot-added' && blotId) {
          var blot = this.editor.findById(blotId);
          if (blot && blot.isEmbeddable) {
            userCursorContainer.remove();
            return false;
          }
        }
        if (aw.cursor.sel.index === dataIndex && skip) {
          return false;
        }
        userCursorContainer.remove();
      }
      this.createCursor(aw, clientId);
    }

    /**
     * @param {object} aw Awareness state {cursor, user}
     * @param {number} clientId
     * @param {object} doc
     */
  }, {
    key: "removeCursor",
    value: function removeCursor(aw, clientId, doc) {
      var containerId = this.getContainerId(clientId);
      var cursorsContainer = this.cursorsContainer;
      var userCursorContainer = cursorsContainer.querySelector("#" + containerId);
      if (userCursorContainer) {
        userCursorContainer.remove();
      }
    }

    /**
     * @param {object} aw Awareness state {cursor, user}
     * @param {number} clientId
     */
  }, {
    key: "createCursor",
    value: function createCursor(aw, clientId) {
      var user = aw.user || {};
      var _ref2 = user.color || {},
        _ref2$background = _ref2.background,
        background = _ref2$background === void 0 ? '#ffa500' : _ref2$background,
        _ref2$font = _ref2.font,
        font = _ref2$font === void 0 ? '#fff' : _ref2$font;
      var name = user.name || "User: ".concat(clientId);
      var containerId = this.getContainerId(clientId);
      var cursorsContainer = this.cursorsContainer;
      var index = this.getSelIndex(aw);
      var scrollLength = this.scroll.length();
      // Получаем позицию курсора из ренджа
      var endBounds = this.getBounds(index);
      if (!endBounds || endBounds.height === 0) {
        return false;
      }
      // Создаем контейнер для юзера
      var userCursorContainer = document.createElement('div');
      userCursorContainer.id = containerId;
      userCursorContainer.classList.add('ed-cursor');
      userCursorContainer.setAttribute('data-index', index);
      userCursorContainer.setAttribute('data-scrollLength', scrollLength);
      // создаем каретку курсора
      var cursorCaretContainer = document.createElement('span');
      cursorCaretContainer.classList.add('ed-cursor-caret-container');
      cursorCaretContainer.style.top = endBounds.top + 'px';
      cursorCaretContainer.style.left = endBounds.left + 'px';
      cursorCaretContainer.style.height = endBounds.height + 'px';
      // создаем курсор
      var cursorCaret = document.createElement('span');
      cursorCaret.classList.add('ed-cursor-caret');
      cursorCaret.style.backgroundColor = background;
      cursorCaretContainer.append(cursorCaret);
      // создаем контейнер флага
      var cursorsFlag = document.createElement('div');
      cursorsFlag.classList.add('ed-cursor-flag');
      cursorsFlag.style.backgroundColor = background;
      // создаем small
      var cursorSmall = document.createElement('small');
      cursorSmall.textContent = name;
      cursorSmall.style.color = font;
      cursorsFlag.append(cursorSmall);
      cursorsFlag.style.top = endBounds.top + 'px';
      cursorsFlag.style.left = endBounds.left + 'px';
      // создаем контейнер Выделения
      /* Пока выключил выделение, но не удаляю т.к. может понадобится в будущем
      const cursorSelectionContainer = document.createElement('span')
      cursorSelectionContainer.classList.add('ed-cursor-selections')*/

      //userCursorContainer.append(cursorSelectionContainer) // Добавляем контейнер выделения в юзер контейнер
      userCursorContainer.append(cursorCaretContainer); // Добавляем каретку курсора в юзер контейнер
      userCursorContainer.append(cursorsFlag); // Добавляем флаг в юзер контейнер
      cursorsContainer.append(userCursorContainer); // Добавляем юзер контейнер в курсор-контейнер

      // Создаем выделение
      //this.createSelection(aw, clientId, cursorSelectionContainer)
    }

    /**
     * @param {object} aw Awareness state {cursor, user}
     */
  }, {
    key: "getSelIndex",
    value: function getSelIndex(aw) {
      var index = aw.cursor.sel.index;
      if (!aw.cursor.sel.reversed) {
        index = aw.cursor.sel.index + aw.cursor.sel.length;
      }
      if (index < 0) index = 0;
      return index;
    }

    /**
     * @param {object} aw Awareness state {cursor, user}
     */
  }, {
    key: "_getLeaf",
    value: function _getLeaf(aw) {
      var startIndex = aw.cursor.sel.index;
      var endIndex = aw.cursor.sel.index + aw.cursor.sel.length;
      var startLeaf = this.getLeaf(startIndex);
      var endLeaf = this.getLeaf(endIndex);
      return {
        startLeaf: startLeaf,
        endLeaf: endLeaf
      };
    }

    /**
     * @param {object} aw Awareness state {cursor, user}
     * @param {number} clientId
     * @param {object} cursorSelectionContainer
     */
  }, {
    key: "createSelection",
    value: function createSelection(aw, clientId, cursorSelectionContainer) {
      var leaf = this._getLeaf(aw);
      var ranges = this._lineRanges(aw, leaf.startLeaf, leaf.endLeaf);
      if (ranges && ranges[0] && ranges[0].endContainer.classList && ranges[0].endContainer.classList[1] === 'attachment-caption') {
        aw.cursor.sel.index = aw.cursor.sel.index - 2;
        aw.cursor.sel.length = aw.cursor.sel.length + 2;
        leaf = this._getLeaf(aw);
        ranges = this._lineRanges(aw, leaf.startLeaf, leaf.endLeaf);
      }
      var selectionRectangles = ranges.reduce(function (rectangles, range) {
        return rectangles.concat(Array.from(rangefix.getClientRects(range)));
      }, []);
      var containerRectangle = this.editor.scroll.domNode.getBoundingClientRect();
      this.updateSelection(aw, selectionRectangles, containerRectangle, cursorSelectionContainer);
    }

    /**
     * @param {object} aw Awareness state {cursor, user}
     * @param {array} selectionRectangles
     * @param {object} containerRectangle
     * @param {object} cursorSelectionContainer
     */
  }, {
    key: "updateSelection",
    value: function updateSelection(aw, selectionRectangles, containerRectangle, cursorSelectionContainer) {
      var _this3 = this;
      var selections = selectionRectangles || [];
      selections = Array.from(selections);
      selections = this._sanitize(selections);
      selections = this._sortByDomPosition(selections);
      selections.forEach(function (selection) {
        return _this3._addSelection(aw, selection, containerRectangle, cursorSelectionContainer);
      });
    }

    /**
     * @param {object} aw Awareness state {cursor, user}
     * @param {array} selection
     * @param {object} containerRectangle
     * @param {object} cursorSelectionContainer
     */
  }, {
    key: "_addSelection",
    value: function _addSelection(aw, selection, containerRectangle, cursorSelectionContainer) {
      var selectionBlock = this._selectionBlock(aw, selection, containerRectangle);
      cursorSelectionContainer.appendChild(selectionBlock);
    }

    /**
     * @param {object} aw Awareness state {cursor, user}
     * @param {object} selection
     * @param {object} containerRectangle
     */
  }, {
    key: "_selectionBlock",
    value: function _selectionBlock(aw, selection, containerRectangle) {
      var user = aw.user || {};
      var color = user.color || '#ffa500';
      var selectionBlock = document.createElement('span');
      selectionBlock.classList.add("ed-cursor-selection-block");
      selectionBlock.style.top = "".concat(selection.top - containerRectangle.top, "px");
      selectionBlock.style.left = "".concat(selection.left - containerRectangle.left, "px");
      selectionBlock.style.width = "".concat(selection.width, "px");
      selectionBlock.style.height = "".concat(selection.height, "px");
      selectionBlock.style.backgroundColor = tinycolor_default()(color).setAlpha(0.1).toString();
      return selectionBlock;
    }

    /**
     * @param {array} selections
     */
  }, {
    key: "_sanitize",
    value: function _sanitize(selections) {
      var _this4 = this;
      var serializedSelections = new Set();
      return selections.filter(function (selection) {
        if (!selection.width || !selection.height) {
          return false;
        }
        var serialized = _this4._serialize(selection);
        if (serializedSelections.has(serialized)) {
          return false;
        }
        serializedSelections.add(serialized);
        return true;
      });
    }

    /**
     * @param {array} selection
     */
  }, {
    key: "_serialize",
    value: function _serialize(selection) {
      return ["top:".concat(selection.top), "right:".concat(selection.right), "bottom:".concat(selection.bottom), "left:".concat(selection.left)].join(';');
    }

    /**
     * @param {array} selections
     */
  }, {
    key: "_sortByDomPosition",
    value: function _sortByDomPosition(selections) {
      return selections.sort(function (a, b) {
        if (a.top === b.top) {
          return a.left - b.left;
        }
        return a.top - b.top;
      });
    }

    /**
     * @param {object} aw Awareness state {cursor, user}
     * @param {number} startLeaf
     * @param {number} endLeaf
     */
  }, {
    key: "_lineRanges",
    value: function _lineRanges(aw, startLeaf, endLeaf) {
      var lines = this._getLines(aw.cursor.sel);
      return lines.reduce(function (ranges, line, index) {
        if (!line.children) {
          var singleElementRange = document.createRange();
          singleElementRange.selectNode(line.domNode);
          return ranges.concat(singleElementRange);
        }
        var _ref3 = index === 0 ? startLeaf : line.path(0).pop(),
          _ref4 = plugins_awareness_slicedToArray(_ref3, 2),
          rangeStart = _ref4[0],
          startOffset = _ref4[1];
        var _ref5 = index === lines.length - 1 ? endLeaf : line.path(line.length() - 1).pop(),
          _ref6 = plugins_awareness_slicedToArray(_ref5, 2),
          rangeEnd = _ref6[0],
          endOffset = _ref6[1];
        var range = document.createRange();
        if (rangeStart.domNode.nodeType === Node.TEXT_NODE) {
          range.setStart(rangeStart.domNode, startOffset);
        } else {
          range.setStartBefore(rangeStart.domNode);
        }
        if (rangeEnd.domNode.nodeType === Node.TEXT_NODE) {
          range.setEnd(rangeEnd.domNode, endOffset);
        } else {
          range.setEndAfter(rangeEnd.domNode);
        }
        return ranges.concat(range);
      }, []);
    }

    /**
     * @param {number} index
     * @param {number} length
     */
  }, {
    key: "_getLines",
    value: function _getLines() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
      if (typeof index !== 'number') {
        return this.scroll.lines(index.index, index.length);
      }
      return this.scroll.lines(index, length);
    }

    /**
     * @param {number} index
     */
  }, {
    key: "getLeaf",
    value: function getLeaf(index) {
      return this.scroll.leaf(index);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.editor.emitter.off('editorBodyResize', this.onEditorBodyResize);
    }
  }]);
  return AwarenessPlugin;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/ctaManager/index.js






function ctaManager_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function ctaManager_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ctaManager_ownKeys(Object(source), true).forEach(function (key) { ctaManager_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ctaManager_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function ctaManager_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function ctaManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function ctaManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function ctaManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) ctaManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) ctaManager_defineProperties(Constructor, staticProps); return Constructor; }
/**
 * Плагин для работы с CTA
 */var CtaManager = /*#__PURE__*/function () {
  /**
   * Конструктор класса CtaManager
   * @param params - \{ scroll, editor, options \}
   */
  function CtaManager(_ref) {
    var scroll = _ref.scroll,
      editor = _ref.editor,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;
    ctaManager_classCallCheck(this, CtaManager);
    this.editor = editor;
    this.scroll = scroll;
    this.options = ctaManager_objectSpread({
      enabled: false
    }, options);
    this.items = {};
  }

  /**
   * Устанавливает CTA
   * @param items - массив объектов cta
   * 
   * @example
   * ```
  gEditor.plugins.ctaManager.setCta([
  {
    blotId: 'b1647626357_9',
    attachmentGlobalId: 'z75dsrurm7ymzzem',
    whenToShow: 'pause',
    type: 'button',
    title: 'Button',
    buttonId: 'ctabutton_bac1c8da',
    address: 'https://nimbusweb.me',
    buttonShape: 'rounded',
    background: 'bondi-blue',
    buttonSize: 'small',
    description: 'TSDoc is a proposal to standardize the doc comments used in TypeScript code, so that different tools can extract content without getting confused by each other’s markup. The TSDoc notation looks pretty familiar:',
    imageUrl: 'https://media.springernature.com/full/springer-cms/rest/v1/img/18893370/v1/height/700',
    showPlayAgain: true
  }
  ])
   * ```
   */
  ctaManager_createClass(CtaManager, [{
    key: "setCta",
    value: function setCta() {
      var _this = this;
      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.items = {};
      items.forEach(function (item) {
        _this.items[item.blotId + '_' + item.attachmentGlobalId] = item;
      });
      this.editor.emitter.emit('set-cta');
    }

    /**
     * Получает CTA для блота и аттача
     * @param blotId - идентификатор блота
     * @param attachmentGlobalId - идентификатор аттача
     * @returns CTA объект. Если для блота с аттачем нет CTA — вернёт null
     */
  }, {
    key: "getCta",
    value: function getCta(blotId, attachmentGlobalId) {
      return this.options.enabled && this.items[blotId + '_' + attachmentGlobalId] || null;
    }
  }]);
  return CtaManager;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/tasksManager/index.js
















function tasksManager_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function tasksManager_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { tasksManager_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { tasksManager_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function tasksManager_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = tasksManager_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function tasksManager_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tasksManager_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tasksManager_arrayLikeToArray(o, minLen); }
function tasksManager_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function tasksManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function tasksManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function tasksManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) tasksManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) tasksManager_defineProperties(Constructor, staticProps); return Constructor; }


var TasksManager = /*#__PURE__*/function () {
  function TasksManager(_ref) {
    var _this = this;
    var scroll = _ref.scroll,
      editor = _ref.editor,
      options = _ref.options;
    tasksManager_classCallCheck(this, TasksManager);
    this.editor = editor;
    this.scroll = scroll;
    this.options = options || {};
    this.options.editor = this.editor;
    this.editor.on(EVENT_BLOT_REMOVED, function (_ref2) {
      var id = _ref2.id;
      var map = _this.editor.store.getMap(id);
      if (map && typeof map !== 'undefined' && map.get('type') === 'tasks-list' && map.has('tasksListId')) {
        var tasksListId = map.get('tasksListId');
        // дожидаемся всех событий и проверяем заатачен ли таск лист после манипуляций со стором, если нет значит он удален
        setTimeout(function () {
          if (!_this.editor.findById(id)) {
            _this.editor.emitter.emit('tasksList:remove', {
              tasksListId: tasksListId
            });
          }
        });
      }
    });
  }
  tasksManager_createClass(TasksManager, [{
    key: "isMethodImplemented",
    value: function isMethodImplemented(method) {
      return Boolean(this.options[method]);
    }
  }, {
    key: "createTasksList",
    value: function createTasksList() {
      if (this.isMethodImplemented('createTasksList')) {
        return this.options.createTasksList();
      }
      return false;
    }
  }, {
    key: "duplicateTasksList",
    value: function duplicateTasksList(tasksListId) {
      var editorRoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      if (this.isMethodImplemented('duplicateTasksList')) {
        return this.options.duplicateTasksList(tasksListId, editorRoom);
      }
      return false;
    }
  }, {
    key: "getReadOnlyTasksList",
    value: function getReadOnlyTasksList(tasksListId) {
      if (this.isMethodImplemented('getReadOnlyTasksList')) {
        return this.options.getReadOnlyTasksList(tasksListId);
      }
      return false;
    }
  }, {
    key: "featWorkspaceTasksInputs",
    value: function featWorkspaceTasksInputs() {
      return this.options.featWorkspaceTasksInputs;
    }
  }, {
    key: "featWorkspaceTasksOutputs",
    value: function featWorkspaceTasksOutputs() {
      return this.options.featWorkspaceTasksOutputs;
    }
  }, {
    key: "syncFeatWorkspaceTasksInputs",
    value: function syncFeatWorkspaceTasksInputs() {
      var tasksLists = this.scroll.descendants(TasksList);
      var props = this.featWorkspaceTasksInputs();
      var _iterator = tasksManager_createForOfIteratorHelper(tasksLists),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var blot = _step.value;
          blot.setPropsForTasksList(props);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * Возвращает стейс таск-листов для заметки
     * @returns {Object}
     */
  }, {
    key: "getState",
    value: function getState(taskListId, taskId) {
      if (this.options.getState) {
        return this.options.getState(taskListId, taskId);
      } else {
        console.info('has no TasksManager.getState function');
      }
    }
  }, {
    key: "sendEvent",
    value: function sendEvent(eventName, eventPayload) {
      if (this.options.sendEvent) {
        return this.options.sendEvent(eventName, eventPayload);
      } else {
        console.info('has no TasksManager.sendEvent function');
      }
    }
  }, {
    key: "emitEvent",
    value: function emitEvent(eventName, eventPayload) {
      if (this.options.emitEvent) {
        return this.options.emitEvent(eventName, eventPayload);
      } else {
        console.info('has no TasksManager.emitEvent function');
      }
    }
  }, {
    key: "listenEvents",
    value: function listenEvents(callback) {
      if (this.options.listenEvents) {
        this.options.listenEvents(callback);
      } else {
        console.info('has no TasksManager.listenEvents function');
      }
    }
  }, {
    key: "deleteTaskList",
    value: function deleteTaskList(taskListId) {
      if (this.options.deleteTaskList) {
        return this.options.deleteTaskList(taskListId);
      } else {
        console.info('has no TasksManager.deleteTaskList function');
      }
    }
  }, {
    key: "restoreTaskList",
    value: function () {
      var _restoreTaskList = tasksManager_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(taskListId) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.options.restoreTaskList) {
                  _context.next = 4;
                  break;
                }
                return _context.abrupt("return", this.options.restoreTaskList(taskListId));
              case 4:
                console.info('has no TasksManager.restoreTaskList function');
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function restoreTaskList(_x) {
        return _restoreTaskList.apply(this, arguments);
      }
      return restoreTaskList;
    }()
  }, {
    key: "findBlot",
    value: function findBlot(tasksListId) {
      var editor = this.editor;
      var tasksList = Object.values(editor.store.blocks.toJSON()).find(function (item) {
        return item.type === 'tasks-list' && item.tasksListId === tasksListId && editor.findById(item.id);
      });
      if (tasksList) {
        return editor.findById(tasksList.id);
      }
      return null;
    }
  }, {
    key: "convertToBoard",
    value: function convertToBoard(boardId, tasksListId) {
      var blot = this.findBlot(tasksListId);
      if (blot) {
        blot.focusableFocus();
        this.editor.exec('add-board', {
          position: 'below',
          boardId: boardId,
          extra: {
            fromTasksList: true,
            tasksListId: tasksListId
          }
        });
        blot.map.set('tskip', true); // пропускаем транзакцию, для того чтобы он не удалялся на стороне сервера
        blot.remove();
      }
    }
  }, {
    key: "convertToColumn",
    value: function convertToColumn(boardId, taskListId, beforeColumnId) {
      if (this.isMethodImplemented('convertToColumn')) {
        return this.options.convertToColumn(boardId, taskListId, beforeColumnId);
      }
      return false;
    }

    /**
     * Редактор вызывает когда просит заметки удалить таск лист
     * @param {String} tasksListId 
     * @returns 
     */
  }, {
    key: "taskListRemove",
    value: function taskListRemove(tasksListId) {
      if (this.isMethodImplemented('taskListRemove')) {
        var blot = this.findBlot(tasksListId);
        // для того чтобы сервер-редактора не отправлял событие об удалении таск-листа
        // удаление будет происходить на стороне клиента
        blot === null || blot === void 0 ? void 0 : blot.map.set('tskip', true);
        return this.options.taskListRemove(tasksListId);
      }
    }

    /**
     * Вызывают заметки у таск менеджера, когда оповещают об удаленном таск листе
     * @param {*} tasksListId 
     */
  }, {
    key: "taskListRemoved",
    value: function taskListRemoved(tasksListId) {
      var blot = this.findBlot(tasksListId);
      if (blot) {
        blot === null || blot === void 0 ? void 0 : blot.map.set('tskip', true);
        blot.remove();
      }
    }
  }, {
    key: "undoTaskList",
    value: function undoTaskList(taskListId) {
      if (this.isMethodImplemented('undoTaskList')) {
        this.options.undoTaskList(taskListId);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.isMethodImplemented('destroy')) {
        this.options.destroy();
      }
    }
  }]);
  return TasksManager;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/videoPreview/index.js

function videoPreview_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function videoPreview_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function videoPreview_createClass(Constructor, protoProps, staticProps) { if (protoProps) videoPreview_defineProperties(Constructor.prototype, protoProps); if (staticProps) videoPreview_defineProperties(Constructor, staticProps); return Constructor; }
var VideoPreviewPlugin = /*#__PURE__*/function () {
  function VideoPreviewPlugin(_ref) {
    var scroll = _ref.scroll,
      editor = _ref.editor,
      options = _ref.options;
    videoPreview_classCallCheck(this, VideoPreviewPlugin);
    this.editor = editor;
    this.scroll = scroll;
    this.options = options || {};
  }

  /* TODO add description */
  videoPreview_createClass(VideoPreviewPlugin, [{
    key: "onEditPreview",
    value: function onEditPreview(currentPreviewSettings) {
      // показ Component-а с текущими настройками currentPreviewSettings
      // после редактирования промис резолвится с null, если юзер нажал
      // cancel, или с новыми настройками для превью
      console.log('onEditPreview', currentPreviewSettings);
      if (this.options.onEditPreview) {
        return this.options.onEditPreview(currentPreviewSettings);
      }
      return Promise.resolve(null);
    }
    /* TODO add description */
  }, {
    key: "isEditAvailable",
    value: function isEditAvailable() {
      if (this.options.onEditPreview) {
        return true;
      }
      return false;
    }
  }]);
  return VideoPreviewPlugin;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/emptyFeatures/index.js

function emptyFeatures_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function emptyFeatures_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function emptyFeatures_createClass(Constructor, protoProps, staticProps) { if (protoProps) emptyFeatures_defineProperties(Constructor.prototype, protoProps); if (staticProps) emptyFeatures_defineProperties(Constructor, staticProps); return Constructor; }
function emptyFeatures_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var FEATURES_OFFSET_TOP = 90;
var FEATURES_OFFSET_LEFT = 2;
var EmptyFeaturesPlugin = /*#__PURE__*/function () {
  function EmptyFeaturesPlugin(_ref) {
    var _this = this;
    var scroll = _ref.scroll,
      editor = _ref.editor,
      options = _ref.options;
    emptyFeatures_classCallCheck(this, EmptyFeaturesPlugin);
    emptyFeatures_defineProperty(this, "onEditorUpdate", function () {
      if (_this.editor.isEmpty() && !_this.editor.plugins.aiManager.session) {
        _this.render(true);
      } else {
        if (_this.container.childNodes.length) {
          _this.render();
        }
      }
    });
    emptyFeatures_defineProperty(this, "onMouseDown", function (event) {
      event.preventDefault();
      event.stopPropagation();
    });
    emptyFeatures_defineProperty(this, "onUseTemplateClick", function (event) {
      _this.options.useTemplate(event);
    });
    emptyFeatures_defineProperty(this, "onImportClick", function (event) {
      _this.options.import(event);
    });
    emptyFeatures_defineProperty(this, "onAddDatabaseClick", function (event) {
      _this.editor.exec('add-database', {
        type: 'with-options'
      });
    });
    emptyFeatures_defineProperty(this, "onAddBoardClick", function (event) {
      _this.editor.scroll.selection.setRange({
        index: 0,
        length: 0
      });
      _this.editor.exec('convert-blot', {
        type: 'board'
      });
    });
    emptyFeatures_defineProperty(this, "onUseAiClick", function (event) {
      _this.editor.plugins.aiManager.show(_this.editor.scroll.children.head);
    });
    this.editor = editor;
    this.scroll = scroll;
    this.options = options || {};
    this.enabled = this.options.enabled;
    this.init();
  }
  emptyFeatures_createClass(EmptyFeaturesPlugin, [{
    key: "init",
    value: function init() {
      if (!this.enabled) {
        return;
      }
      this.container = document.createElement('div');
      this.container.classList.add('empty-editor-features');
      this.editor.scrollingContainer.appendChild(this.container);
      this.editor.on('editorUpdate', this.onEditorUpdate);
    }
  }, {
    key: "isMethodImplemented",
    value: function isMethodImplemented(method) {
      return Boolean(this.options[method]);
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      var _getContainerOffset = getContainerOffset(this.scroll.domNode, this.editor.editorBody),
        x = _getContainerOffset.x,
        y = _getContainerOffset.y;
      return {
        top: y + FEATURES_OFFSET_TOP + 'px',
        left: x + FEATURES_OFFSET_LEFT + 'px'
      };
    }
  }, {
    key: "renderFeature",
    value: function renderFeature(title, Icon, onClick) {
      return (0,preact_module.h)("div", {
        classList: "empty-feature-item",
        onClick: onClick
      }, (0,preact_module.h)("span", {
        className: "empty-feature-icon"
      }, (0,preact_module.h)(Icon, null)), (0,preact_module.h)("span", {
        className: "empty-feature-title"
      }, title));
    }
  }, {
    key: "render",
    value: function render() {
      var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var toRender = null;
      if (show) {
        var useTemplateNode = null;
        var importNode = null;
        if (this.isMethodImplemented('useTemplate')) {
          useTemplateNode = this.renderFeature(this.editor.plugins.i18n.get('empty_features.use_template'), icons/* IconTemplate */._9F, this.onUseTemplateClick);
        }
        if (this.isMethodImplemented('import')) {
          importNode = this.renderFeature(this.editor.plugins.i18n.get('empty_features.import'), icons/* IconPlayerDownload */.hoH, this.onImportClick);
        }
        var databaseKey = 'add_database_with_options';
        if (localStorage.hasOwnProperty(COUNT_DATABASE_CREATED_KEY) && localStorage.getItem(COUNT_DATABASE_CREATED_KEY) >= 2) {
          databaseKey = 'add_database';
        }
        var addDatabaseNode = this.renderFeature(this.editor.plugins.i18n.get('empty_features.' + databaseKey), icons/* IconDatabase */.OQ8, this.onAddDatabaseClick);
        var addBoardNode = this.renderFeature(this.editor.plugins.i18n.get('empty_features.add_board'), icons/* IconBoard */.ve2, this.onAddBoardClick);
        var useAiNode = this.editor.plugins.aiManager.enabled ? this.renderFeature(this.editor.plugins.i18n.get('empty_features.use_ai'), icons/* IconPromtIcon */.nST, this.onUseAiClick) : null;
        toRender = (0,preact_module.h)("div", {
          className: "empty-features",
          onMouseDown: this.onMouseDown,
          style: this.getPosition()
        }, useTemplateNode, importNode, addDatabaseNode, addBoardNode, useAiNode ? (0,preact_module.h)("span", {
          className: "empty-features-divider"
        }) : null, useAiNode);
      }
      (0,preact_module/* render */.sY)(toRender, this.container);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.editor.off('editorUpdate', this.onEditorUpdate);
      if (!this.enabled) {
        return;
      }
      var container = this.container;
      this.container = null;
      container.parentNode.removeChild(container);
    }
  }]);
  return EmptyFeaturesPlugin;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/boardManager/index.js
















function boardManager_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function boardManager_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { boardManager_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { boardManager_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function boardManager_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = boardManager_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function boardManager_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return boardManager_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return boardManager_arrayLikeToArray(o, minLen); }
function boardManager_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function boardManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function boardManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function boardManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) boardManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) boardManager_defineProperties(Constructor, staticProps); return Constructor; }


var DEFAULT_ENABLED = false;
var BoardManager = /*#__PURE__*/function () {
  function BoardManager(_ref) {
    var _this = this;
    var scroll = _ref.scroll,
      editor = _ref.editor,
      options = _ref.options;
    boardManager_classCallCheck(this, BoardManager);
    this.editor = editor;
    this.scroll = scroll;
    this.options = options || {};
    if (!this.options.hasOwnProperty('enabled')) {
      this.options.enabled = DEFAULT_ENABLED;
    }
    this.options.editor = this.editor;
    this.editor.on(EVENT_BLOT_REMOVED, function (_ref2) {
      var id = _ref2.id;
      var map = _this.editor.store.getMap(id);
      if (map && typeof map !== 'undefined' && map.get('type') === 'board' && map.has('boardId')) {
        var boardId = map.get('boardId');
        // дожидаемся всех событий и проверяем заатачен ли board после манипуляций со стором, если нет значит он удален
        setTimeout(function () {
          if (!_this.editor.findById(id)) {
            _this.editor.emitter.emit('board:remove', {
              boardId: boardId
            });
          }
        });
      }
    });
  }
  boardManager_createClass(BoardManager, [{
    key: "isMethodImplemented",
    value: function isMethodImplemented(method) {
      var res = Boolean(this.options[method]);
      if (!res) {
        console.info('has no BoardManager.' + method + ' function');
      }
      return res;
    }
  }, {
    key: "createBoard",
    value: function createBoard() {
      if (this.isMethodImplemented('createBoard')) {
        return this.options.createBoard();
      }
      return false;
    }
  }, {
    key: "duplicateBoard",
    value: function duplicateBoard(boardId) {
      var editorRoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      if (this.isMethodImplemented('duplicateBoard')) {
        return this.options.duplicateBoard(boardId, editorRoom);
      }
      return false;
    }
  }, {
    key: "renameBoard",
    value: function renameBoard(boardId) {
      if (this.isMethodImplemented('renameBoard')) {
        this.options.renameBoard(boardId);
      }
    }
  }, {
    key: "addNewColumn",
    value: function addNewColumn(boardId) {
      if (this.isMethodImplemented('addNewColumn')) {
        this.options.addNewColumn(boardId);
      }
    }
  }, {
    key: "featBoardInputs",
    value: function featBoardInputs() {
      return this.options.featBoardInputs;
    }
  }, {
    key: "featBoardOutputs",
    value: function featBoardOutputs() {
      return this.options.featBoardOutputs;
    }
  }, {
    key: "syncFeatBoardInputs",
    value: function syncFeatBoardInputs() {
      var boards = this.scroll.descendants(Board);
      var props = this.featBoardInputs();
      var _iterator = boardManager_createForOfIteratorHelper(boards),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var blot = _step.value;
          blot.setPropsForBoard(props);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "deleteBoard",
    value: function deleteBoard(boardId) {
      if (this.isMethodImplemented('deleteBoard')) {
        return this.options.deleteBoard(boardId);
      }
      return false;
    }
  }, {
    key: "restoreBoard",
    value: function () {
      var _restoreBoard = boardManager_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(boardId) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.isMethodImplemented('restoreBoard')) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", this.options.restoreBoard(boardId));
              case 2:
                return _context.abrupt("return", false);
              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function restoreBoard(_x) {
        return _restoreBoard.apply(this, arguments);
      }
      return restoreBoard;
    }()
  }, {
    key: "findBlot",
    value: function findBlot(boardId) {
      var editor = this.editor;
      var board = Object.values(editor.store.blocks.toJSON()).find(function (item) {
        return item.type === 'board' && item.boardId === boardId && editor.findById(item.id);
      });
      if (board) {
        return editor.findById(board.id);
      }
      return null;
    }
  }, {
    key: "convertColumnToTaskList",
    value: function convertColumnToTaskList(boardId, tasksListId, beforeColumnId) {
      var editor = this.editor;
      var blot = this.findBlot(boardId);
      if (blot) {
        editor.findById(blot.id).focusableFocus();
        editor.exec('add-tasks-list', {
          position: 'below',
          tasksListId: tasksListId,
          extra: {
            fromColumn: true,
            boardId: boardId,
            beforeColumnId: beforeColumnId
          }
        });
      }
    }
  }, {
    key: "convertBoardToTaskList",
    value: function convertBoardToTaskList(boardId, taskListId) {
      if (this.isMethodImplemented('convertBoardToTaskList')) {
        this.options.convertBoardToTaskList(boardId, taskListId);
      }
    }
  }, {
    key: "boardRemove",
    value: function boardRemove(boardId) {
      if (this.isMethodImplemented('boardRemove')) {
        var blot = this.findBlot(boardId);
        // для того чтобы сервер-редактора не отправлял событие об удалении доски
        // удаление будет происходить на стороне клиента
        blot === null || blot === void 0 ? void 0 : blot.map.set('tskip', true);
        this.options.boardRemove(boardId);
      }
    }
  }, {
    key: "undoBoard",
    value: function undoBoard(boardId) {
      if (this.isMethodImplemented('undoBoard')) {
        this.options.undoBoard(boardId);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.isMethodImplemented('destroy')) {
        this.options.destroy();
      }
    }
  }]);
  return BoardManager;
}();

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.is-integer.js
var es_number_is_integer = __webpack_require__(33161);
// EXTERNAL MODULE: ./node_modules/unsplash-js/node_modules/content-type/index.js
var content_type = __webpack_require__(13650);
;// CONCATENATED MODULE: ./node_modules/unsplash-js/dist/unsplash-js.esm.js
function unsplash_js_esm_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { unsplash_js_esm_typeof = function _typeof(obj) { return typeof obj; }; } else { unsplash_js_esm_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return unsplash_js_esm_typeof(obj); }

















function unsplash_js_esm_extends() {
  unsplash_js_esm_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return unsplash_js_esm_extends.apply(this, arguments);
}
function unsplash_js_esm_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var checkIsString = /*#__PURE__*/getRefinement(function (value) {
  return typeof value === 'string' ? value : null;
});
var isDefined = function isDefined(x) {
  return x !== null && x !== undefined;
};
function getRefinement(getB) {
  return function (a) {
    return isDefined(getB(a));
  };
}
var checkIsNonEmptyArray = function checkIsNonEmptyArray(a) {
  return a.length > 0;
};

/** Takes a dictionary containing nullish values and returns a dictionary of all the defined
 * (non-nullish) values.
 */

var compactDefined = function compactDefined(obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    var _ref;
    var value = obj[key];
    return unsplash_js_esm_extends({}, acc, isDefined(value) ? (_ref = {}, _ref[key] = value, _ref) : {});
  }, {});
};
function flow() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  var len = fns.length - 1;
  return function () {
    for (var _len2 = arguments.length, x = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      x[_key2] = arguments[_key2];
    }
    var y = fns[0].apply(this, x);
    for (var i = 1; i <= len; i++) {
      y = fns[i].call(this, y);
    }
    return y;
  };
}
var checkIsObject = /*#__PURE__*/getRefinement(function (response) {
  return isDefined(response) && unsplash_js_esm_typeof(response) === 'object' && !Array.isArray(response) ? response : null;
});
var checkIsErrors = /*#__PURE__*/getRefinement(function (errors) {
  return Array.isArray(errors) && errors.every(checkIsString) && checkIsNonEmptyArray(errors) ? errors : null;
});
var checkIsApiError = /*#__PURE__*/getRefinement(function (response) {
  return checkIsObject(response) && 'errors' in response && checkIsErrors(response.errors) ? {
    errors: response.errors
  } : null;
});
var getErrorForBadStatusCode = function getErrorForBadStatusCode(jsonResponse) {
  if (checkIsApiError(jsonResponse)) {
    return {
      errors: jsonResponse.errors,
      source: 'api'
    };
  } else {
    return {
      errors: ['Responded with a status code outside the 2xx range, and the response body is not recognisable.'],
      source: 'decoding'
    };
  }
};
var DecodingError = function DecodingError(message) {
  this.message = message;
};
var CONTENT_TYPE_RESPONSE_HEADER = 'content-type';
var CONTENT_TYPE_JSON = 'application/json';
var checkIsJsonResponse = function checkIsJsonResponse(response) {
  var contentTypeHeader = response.headers.get(CONTENT_TYPE_RESPONSE_HEADER);
  return isDefined(contentTypeHeader) && (0,content_type/* parse */.Q)(contentTypeHeader).type === CONTENT_TYPE_JSON;
};
/**
 * Note: restrict the type of JSON to `AnyJson` so that `any` doesn't leak downstream.
 */

var getJsonResponse = function getJsonResponse(response) {
  if (checkIsJsonResponse(response)) {
    return response.json()["catch"](function (_err) {
      throw new DecodingError('unable to parse JSON response.');
    });
  } else {
    throw new DecodingError('expected JSON response from server.');
  }
};
var handleFetchResponse = function handleFetchResponse(handleResponse) {
  return function (response) {
    return (response.ok ? handleResponse({
      response: response
    }).then(function (handledResponse) {
      return {
        type: 'success',
        status: response.status,
        response: handledResponse,
        originalResponse: response
      };
    }) : getJsonResponse(response).then(function (jsonResponse) {
      return unsplash_js_esm_extends({
        type: 'error',
        status: response.status
      }, getErrorForBadStatusCode(jsonResponse), {
        originalResponse: response
      });
    }))["catch"](function (error) {
      /**
       * We want to separate expected decoding errors from unknown ones. We do so by throwing a custom
       * `DecodingError` whenever we encounter one within `handleFetchResponse` and catch them all
       * here. This allows us to easily handle all of these errors at once. Unexpected errors are not
       * caught, so that they bubble up and fail loudly.
       *
       * Note: Ideally we'd use an Either type, but this does the job without introducing dependencies
       * like `fp-ts`.
       */
      if (error instanceof DecodingError) {
        return {
          type: 'error',
          source: 'decoding',
          status: response.status,
          originalResponse: response,
          errors: [error.message]
        };
      } else {
        throw error;
      }
    });
  };
};
var castResponse = function castResponse() {
  return function (_ref) {
    var response = _ref.response;
    return getJsonResponse(response);
  };
};
var addQueryToUrl = function addQueryToUrl(query) {
  return function (url) {
    Object.keys(query).forEach(function (queryKey) {
      return url.searchParams.set(queryKey, query[queryKey].toString());
    });
  };
};
var addPathnameToUrl = function addPathnameToUrl(pathname) {
  return function (url) {
    // When there is no existing pathname, the value is `/`. Appending would give us a URL with two
    // forward slashes. This is why we replace the value in that scenario.
    if (url.pathname === '/') {
      url.pathname = pathname;
    } else {
      url.pathname += pathname;
    }
  };
};
var buildUrl = function buildUrl(_ref) {
  var pathname = _ref.pathname,
    query = _ref.query;
  return function (apiUrl) {
    var url = new URL(apiUrl);
    addPathnameToUrl(pathname)(url);
    addQueryToUrl(query)(url);
    return url.toString();
  };
};
var getQueryFromSearchParams = function getQueryFromSearchParams(searchParams) {
  var query = {};
  searchParams.forEach(function (value, key) {
    query[key] = value;
  });
  return query;
};
var parseQueryAndPathname = function parseQueryAndPathname(url) {
  var _URL = new URL(url),
    pathname = _URL.pathname,
    searchParams = _URL.searchParams;
  var query = getQueryFromSearchParams(searchParams);
  return {
    query: query,
    pathname: pathname === '/' ? undefined : pathname
  };
};

/**
 * helper used to type-check the arguments, and add default params for all requests
 */

var createRequestHandler = function createRequestHandler(fn) {
  return function (a, additionalFetchOptions) {
    if (additionalFetchOptions === void 0) {
      additionalFetchOptions = {};
    }
    var _fn = fn(a),
      headers = _fn.headers,
      query = _fn.query,
      baseReqParams = unsplash_js_esm_objectWithoutPropertiesLoose(_fn, ["headers", "query"]);
    return unsplash_js_esm_extends({}, baseReqParams, additionalFetchOptions, {
      query: query,
      headers: unsplash_js_esm_extends({}, headers, additionalFetchOptions.headers)
    });
  };
};
var makeEndpoint = function makeEndpoint(endpoint) {
  return endpoint;
};
var initMakeRequest = function initMakeRequest(_ref) {
  var accessKey = _ref.accessKey,
    _ref$apiVersion = _ref.apiVersion,
    apiVersion = _ref$apiVersion === void 0 ? 'v1' : _ref$apiVersion,
    _ref$apiUrl = _ref.apiUrl,
    apiUrl = _ref$apiUrl === void 0 ? 'https://api.unsplash.com' : _ref$apiUrl,
    generalHeaders = _ref.headers,
    providedFetch = _ref.fetch,
    generalFetchOptions = unsplash_js_esm_objectWithoutPropertiesLoose(_ref, ["accessKey", "apiVersion", "apiUrl", "headers", "fetch"]);
  return function (_ref2) {
    var handleResponse = _ref2.handleResponse,
      handleRequest = _ref2.handleRequest;
    return flow(handleRequest, function (_ref3) {
      var pathname = _ref3.pathname,
        query = _ref3.query,
        _ref3$method = _ref3.method,
        method = _ref3$method === void 0 ? 'GET' : _ref3$method,
        endpointHeaders = _ref3.headers,
        body = _ref3.body,
        signal = _ref3.signal;
      var url = buildUrl({
        pathname: pathname,
        query: query
      })(apiUrl);
      var fetchOptions = unsplash_js_esm_extends({
        method: method,
        headers: unsplash_js_esm_extends({}, generalHeaders, endpointHeaders, {
          'Accept-Version': apiVersion
        }, isDefined(accessKey) ? {
          Authorization: "Client-ID " + accessKey
        } : {}),
        body: body,
        signal: signal
      }, generalFetchOptions);
      var fetchToUse = providedFetch != null ? providedFetch : fetch;
      return fetchToUse(url, fetchOptions).then(handleFetchResponse(handleResponse));
    });
  };
};
var TOTAL_RESPONSE_HEADER = 'x-total';
var getTotalFromApiFeedResponse = function getTotalFromApiFeedResponse(response) {
  var totalsStr = response.headers.get(TOTAL_RESPONSE_HEADER);
  if (isDefined(totalsStr)) {
    var total = parseInt(totalsStr);
    if (Number.isInteger(total)) {
      return total;
    } else {
      throw new DecodingError("expected " + TOTAL_RESPONSE_HEADER + " header to be valid integer.");
    }
  } else {
    throw new DecodingError("expected " + TOTAL_RESPONSE_HEADER + " header to exist.");
  }
};
var handleFeedResponse = function handleFeedResponse() {
  return function (_ref) {
    var response = _ref.response;
    return castResponse()({
      response: response
    }).then(function (results) {
      return {
        results: results,
        total: getTotalFromApiFeedResponse(response)
      };
    });
  };
};
var getCollections = function getCollections(collectionIds) {
  return isDefined(collectionIds) ? {
    collections: collectionIds.join()
  } : {};
};
var getTopics = function getTopics(topicIds) {
  return isDefined(topicIds) ? {
    topics: topicIds.join()
  } : {};
};
var getFeedParams = function getFeedParams(_ref) {
  var page = _ref.page,
    perPage = _ref.perPage,
    orderBy = _ref.orderBy;
  return compactDefined({
    per_page: perPage,
    order_by: orderBy,
    page: page
  });
};
var COLLECTIONS_PATH_PREFIX = '/collections';
var getPhotos = /*#__PURE__*/function () {
  var getPathname = function getPathname(_ref) {
    var collectionId = _ref.collectionId;
    return COLLECTIONS_PATH_PREFIX + "/" + collectionId + "/photos";
  };
  return makeEndpoint({
    getPathname: getPathname,
    handleRequest: createRequestHandler(function (_ref2) {
      var collectionId = _ref2.collectionId,
        orientation = _ref2.orientation,
        paginationParams = unsplash_js_esm_objectWithoutPropertiesLoose(_ref2, ["collectionId", "orientation"]);
      return {
        pathname: getPathname({
          collectionId: collectionId
        }),
        query: compactDefined(unsplash_js_esm_extends({}, getFeedParams(paginationParams), {
          orientation: orientation
        }))
      };
    }),
    handleResponse: handleFeedResponse()
  });
}();
var get = /*#__PURE__*/function () {
  var getPathname = function getPathname(_ref3) {
    var collectionId = _ref3.collectionId;
    return COLLECTIONS_PATH_PREFIX + "/" + collectionId;
  };
  return makeEndpoint({
    getPathname: getPathname,
    handleRequest: createRequestHandler(function (_ref4) {
      var collectionId = _ref4.collectionId;
      return {
        pathname: getPathname({
          collectionId: collectionId
        }),
        query: {}
      };
    }),
    handleResponse: castResponse()
  });
}();
var unsplash_js_esm_list = /*#__PURE__*/function () {
  var getPathname = function getPathname() {
    return COLLECTIONS_PATH_PREFIX;
  };
  return makeEndpoint({
    getPathname: getPathname,
    handleRequest: createRequestHandler(function (paginationParams) {
      if (paginationParams === void 0) {
        paginationParams = {};
      }
      return {
        pathname: getPathname(),
        query: getFeedParams(paginationParams)
      };
    }),
    handleResponse: handleFeedResponse()
  });
}();
var getRelated = /*#__PURE__*/function () {
  var getPathname = function getPathname(_ref5) {
    var collectionId = _ref5.collectionId;
    return COLLECTIONS_PATH_PREFIX + "/" + collectionId + "/related";
  };
  return makeEndpoint({
    getPathname: getPathname,
    handleRequest: createRequestHandler(function (_ref6) {
      var collectionId = _ref6.collectionId;
      return {
        pathname: getPathname({
          collectionId: collectionId
        }),
        query: {}
      };
    }),
    handleResponse: castResponse()
  });
}();
var index = {
  __proto__: null,
  getPhotos: getPhotos,
  get: get,
  list: unsplash_js_esm_list,
  getRelated: getRelated
};
var PHOTOS_PATH_PREFIX = '/photos';
var list$1 = /*#__PURE__*/function () {
  var _getPathname = function getPathname() {
    return PHOTOS_PATH_PREFIX;
  };
  return makeEndpoint({
    // Wrapper uses type trick to allow 0 args
    getPathname: function getPathname(_params) {
      return _getPathname();
    },
    handleRequest: createRequestHandler(function (feedParams) {
      if (feedParams === void 0) {
        feedParams = {};
      }
      return {
        pathname: PHOTOS_PATH_PREFIX,
        query: compactDefined(getFeedParams(feedParams))
      };
    }),
    handleResponse: handleFeedResponse()
  });
}();
var get$1 = /*#__PURE__*/function () {
  var getPathname = function getPathname(_ref) {
    var photoId = _ref.photoId;
    return PHOTOS_PATH_PREFIX + "/" + photoId;
  };
  return makeEndpoint({
    getPathname: getPathname,
    handleRequest: createRequestHandler(function (_ref2) {
      var photoId = _ref2.photoId;
      return {
        pathname: getPathname({
          photoId: photoId
        }),
        query: {}
      };
    }),
    handleResponse: castResponse()
  });
}();
var getStats = /*#__PURE__*/function () {
  var getPathname = function getPathname(_ref3) {
    var photoId = _ref3.photoId;
    return PHOTOS_PATH_PREFIX + "/" + photoId + "/statistics";
  };
  return makeEndpoint({
    getPathname: getPathname,
    handleRequest: createRequestHandler(function (_ref4) {
      var photoId = _ref4.photoId;
      return {
        pathname: getPathname({
          photoId: photoId
        }),
        query: {}
      };
    }),
    handleResponse: castResponse()
  });
}();
var getRandom = /*#__PURE__*/function () {
  var getPathname = function getPathname() {
    return PHOTOS_PATH_PREFIX + "/random";
  };
  return makeEndpoint({
    getPathname: getPathname,
    handleRequest: createRequestHandler(function (_temp) {
      var _ref5 = _temp === void 0 ? {} : _temp,
        collectionIds = _ref5.collectionIds,
        contentFilter = _ref5.contentFilter,
        topicIds = _ref5.topicIds,
        queryParams = unsplash_js_esm_objectWithoutPropertiesLoose(_ref5, ["collectionIds", "contentFilter", "topicIds"]);
      return {
        pathname: getPathname(),
        query: compactDefined(unsplash_js_esm_extends({}, queryParams, {
          content_filter: contentFilter
        }, getCollections(collectionIds), getTopics(topicIds))),
        headers: {
          /**
           * Avoid response caching
           */
          'cache-control': 'no-cache'
        }
      };
    }),
    handleResponse: castResponse()
  });
}();
var trackDownload = {
  handleRequest: /*#__PURE__*/createRequestHandler(function (_ref6) {
    var downloadLocation = _ref6.downloadLocation;
    var _parseQueryAndPathnam = parseQueryAndPathname(downloadLocation),
      pathname = _parseQueryAndPathnam.pathname,
      query = _parseQueryAndPathnam.query;
    if (!isDefined(pathname)) {
      throw new Error('Could not parse pathname from url.');
    }
    return {
      pathname: pathname,
      query: compactDefined(query)
    };
  }),
  handleResponse: /*#__PURE__*/castResponse()
};
var index$1 = {
  __proto__: null,
  list: list$1,
  get: get$1,
  getStats: getStats,
  getRandom: getRandom,
  trackDownload: trackDownload
};
var SEARCH_PATH_PREFIX = "/search";
var getPhotos$1 = /*#__PURE__*/function () {
  var _getPathname = function getPathname() {
    return SEARCH_PATH_PREFIX + "/photos";
  };
  return makeEndpoint({
    // Wrapper uses type trick to allow 0 args
    getPathname: function getPathname(_params) {
      return _getPathname();
    },
    handleRequest: createRequestHandler(function (_ref) {
      var query = _ref.query,
        page = _ref.page,
        perPage = _ref.perPage,
        orderBy = _ref.orderBy,
        collectionIds = _ref.collectionIds,
        lang = _ref.lang,
        contentFilter = _ref.contentFilter,
        filters = unsplash_js_esm_objectWithoutPropertiesLoose(_ref, ["query", "page", "perPage", "orderBy", "collectionIds", "lang", "contentFilter"]);
      return {
        pathname: _getPathname(),
        query: compactDefined(unsplash_js_esm_extends({
          query: query,
          content_filter: contentFilter,
          lang: lang,
          order_by: orderBy
        }, getFeedParams({
          page: page,
          perPage: perPage
        }), getCollections(collectionIds), filters))
      };
    }),
    handleResponse: castResponse()
  });
}();
var getCollections$1 = /*#__PURE__*/function () {
  var _getPathname2 = function getPathname() {
    return SEARCH_PATH_PREFIX + "/collections";
  };
  return makeEndpoint({
    // Wrapper uses type trick to allow 0 args
    getPathname: function getPathname(_params) {
      return _getPathname2();
    },
    handleRequest: createRequestHandler(function (_ref2) {
      var query = _ref2.query,
        paginationParams = unsplash_js_esm_objectWithoutPropertiesLoose(_ref2, ["query"]);
      return {
        pathname: _getPathname2(),
        query: unsplash_js_esm_extends({
          query: query
        }, getFeedParams(paginationParams))
      };
    }),
    handleResponse: castResponse()
  });
}();
var getUsers = /*#__PURE__*/function () {
  var _getPathname3 = function getPathname() {
    return SEARCH_PATH_PREFIX + "/users";
  };
  return makeEndpoint({
    // Wrapper uses type trick to allow 0 args
    getPathname: function getPathname(_params) {
      return _getPathname3();
    },
    handleRequest: createRequestHandler(function (_ref3) {
      var query = _ref3.query,
        paginationParams = unsplash_js_esm_objectWithoutPropertiesLoose(_ref3, ["query"]);
      return {
        pathname: _getPathname3(),
        query: unsplash_js_esm_extends({
          query: query
        }, getFeedParams(paginationParams))
      };
    }),
    handleResponse: castResponse()
  });
}();
var index$2 = {
  __proto__: null,
  getPhotos: getPhotos$1,
  getCollections: getCollections$1,
  getUsers: getUsers
};
var USERS_PATH_PREFIX = '/users';
var get$2 = /*#__PURE__*/function () {
  var getPathname = function getPathname(_ref) {
    var username = _ref.username;
    return USERS_PATH_PREFIX + "/" + username;
  };
  return makeEndpoint({
    getPathname: getPathname,
    handleRequest: createRequestHandler(function (_ref2) {
      var username = _ref2.username;
      return {
        pathname: getPathname({
          username: username
        }),
        query: {}
      };
    }),
    handleResponse: castResponse()
  });
}();
var getPhotos$2 = /*#__PURE__*/function () {
  var getPathname = function getPathname(_ref3) {
    var username = _ref3.username;
    return USERS_PATH_PREFIX + "/" + username + "/photos";
  };
  return makeEndpoint({
    getPathname: getPathname,
    handleRequest: createRequestHandler(function (_ref4) {
      var username = _ref4.username,
        stats = _ref4.stats,
        orientation = _ref4.orientation,
        paginationParams = unsplash_js_esm_objectWithoutPropertiesLoose(_ref4, ["username", "stats", "orientation"]);
      return {
        pathname: getPathname({
          username: username
        }),
        query: compactDefined(unsplash_js_esm_extends({}, getFeedParams(paginationParams), {
          orientation: orientation,
          stats: stats
        }))
      };
    }),
    handleResponse: handleFeedResponse()
  });
}();
var getLikes = /*#__PURE__*/function () {
  var getPathname = function getPathname(_ref5) {
    var username = _ref5.username;
    return USERS_PATH_PREFIX + "/" + username + "/likes";
  };
  return makeEndpoint({
    getPathname: getPathname,
    handleRequest: createRequestHandler(function (_ref6) {
      var username = _ref6.username,
        orientation = _ref6.orientation,
        paginationParams = unsplash_js_esm_objectWithoutPropertiesLoose(_ref6, ["username", "orientation"]);
      return {
        pathname: getPathname({
          username: username
        }),
        query: compactDefined(unsplash_js_esm_extends({}, getFeedParams(paginationParams), {
          orientation: orientation
        }))
      };
    }),
    handleResponse: handleFeedResponse()
  });
}();
var getCollections$2 = /*#__PURE__*/function () {
  var getPathname = function getPathname(_ref7) {
    var username = _ref7.username;
    return USERS_PATH_PREFIX + "/" + username + "/collections";
  };
  return makeEndpoint({
    getPathname: getPathname,
    handleRequest: createRequestHandler(function (_ref8) {
      var username = _ref8.username,
        paginationParams = unsplash_js_esm_objectWithoutPropertiesLoose(_ref8, ["username"]);
      return {
        pathname: getPathname({
          username: username
        }),
        query: getFeedParams(paginationParams)
      };
    }),
    handleResponse: handleFeedResponse()
  });
}();
var index$3 = {
  __proto__: null,
  get: get$2,
  getPhotos: getPhotos$2,
  getLikes: getLikes,
  getCollections: getCollections$2
};
var BASE_TOPIC_PATH = '/topics';
var getTopicPath = function getTopicPath(_ref) {
  var topicIdOrSlug = _ref.topicIdOrSlug;
  return BASE_TOPIC_PATH + "/" + topicIdOrSlug;
};
var list$2 = /*#__PURE__*/makeEndpoint({
  getPathname: getTopicPath,
  handleRequest: function handleRequest(_ref2) {
    var page = _ref2.page,
      perPage = _ref2.perPage,
      orderBy = _ref2.orderBy,
      topicIdsOrSlugs = _ref2.topicIdsOrSlugs;
    return {
      pathname: BASE_TOPIC_PATH,
      query: compactDefined(unsplash_js_esm_extends({}, getFeedParams({
        page: page,
        perPage: perPage
      }), {
        ids: topicIdsOrSlugs == null ? void 0 : topicIdsOrSlugs.join(','),
        order_by: orderBy
      }))
    };
  },
  handleResponse: /*#__PURE__*/handleFeedResponse()
});
var get$3 = /*#__PURE__*/makeEndpoint({
  getPathname: getTopicPath,
  handleRequest: function handleRequest(_ref3) {
    var topicIdOrSlug = _ref3.topicIdOrSlug;
    return {
      pathname: getTopicPath({
        topicIdOrSlug: topicIdOrSlug
      }),
      query: {}
    };
  },
  handleResponse: /*#__PURE__*/castResponse()
});
var getPhotos$3 = /*#__PURE__*/function () {
  var getPathname = /*#__PURE__*/flow(getTopicPath, function (topicPath) {
    return topicPath + "/photos";
  });
  return makeEndpoint({
    getPathname: getPathname,
    handleRequest: function handleRequest(_ref4) {
      var topicIdOrSlug = _ref4.topicIdOrSlug,
        orientation = _ref4.orientation,
        feedParams = unsplash_js_esm_objectWithoutPropertiesLoose(_ref4, ["topicIdOrSlug", "orientation"]);
      return {
        pathname: getPathname({
          topicIdOrSlug: topicIdOrSlug
        }),
        query: compactDefined(unsplash_js_esm_extends({}, getFeedParams(feedParams), {
          orientation: orientation
        }))
      };
    },
    handleResponse: handleFeedResponse()
  });
}();
var index$4 = {
  __proto__: null,
  list: list$2,
  get: get$3,
  getPhotos: getPhotos$3
};
var trackNonHotLinkedPhotoView = function trackNonHotLinkedPhotoView(_ref) {
  var appId = _ref.appId;
  return function (_ref2) {
    var photoId = _ref2.photoId;
    var ids = !Array.isArray(photoId) ? [photoId] : photoId;
    if (ids.length > 20) {
      throw new Error('You cannot track more than 20 photos at once. Please try again with fewer photos.');
    }
    return fetch("views.unsplash.com/v?photo_id=" + ids.join() + "&app_id=" + appId);
  };
};
var internals = {
  __proto__: null,
  collections: index,
  photos: index$1,
  search: index$2,
  users: index$3,
  topics: index$4,
  trackNonHotLinkedPhotoView: trackNonHotLinkedPhotoView
};
var Language;
(function (Language) {
  Language["Afrikaans"] = "af";
  Language["Amharic"] = "am";
  Language["Arabic"] = "ar";
  Language["Azerbaijani"] = "az";
  Language["Belarusian"] = "be";
  Language["Bulgarian"] = "bg";
  Language["Bengali"] = "bn";
  Language["Bosnian"] = "bs";
  Language["Catalan"] = "ca";
  Language["Cebuano"] = "ceb";
  Language["Corsican"] = "co";
  Language["Czech"] = "cs";
  Language["Welsh"] = "cy";
  Language["Danish"] = "da";
  Language["German"] = "de";
  Language["Greek"] = "el";
  Language["English"] = "en";
  Language["Esperanto"] = "eo";
  Language["Spanish"] = "es";
  Language["Estonian"] = "et";
  Language["Basque"] = "eu";
  Language["Persian"] = "fa";
  Language["Finnish"] = "fi";
  Language["French"] = "fr";
  Language["Frisian"] = "fy";
  Language["Irish"] = "ga";
  Language["ScotsGaelic"] = "gd";
  Language["Galician"] = "gl";
  Language["Gujarati"] = "gu";
  Language["Hausa"] = "ha";
  Language["Hawaiian"] = "haw";
  Language["Hindi"] = "hi";
  Language["Hmong"] = "hmn";
  Language["Croatian"] = "hr";
  Language["HaitianCreole"] = "ht";
  Language["Hungarian"] = "hu";
  Language["Armenian"] = "hy";
  Language["Indonesian"] = "id";
  Language["Igbo"] = "ig";
  Language["Icelandic"] = "is";
  Language["Italian"] = "it";
  Language["Hebrew"] = "iw";
  Language["Japanese"] = "ja";
  Language["Javanese"] = "jw";
  Language["Georgian"] = "ka";
  Language["Kazakh"] = "kk";
  Language["Khmer"] = "km";
  Language["Kannada"] = "kn";
  Language["Korean"] = "ko";
  Language["Kurdish"] = "ku";
  Language["Kyrgyz"] = "ky";
  Language["Latin"] = "la";
  Language["Luxembourgish"] = "lb";
  Language["Lao"] = "lo";
  Language["Lithuanian"] = "lt";
  Language["Latvian"] = "lv";
  Language["Malagasy"] = "mg";
  Language["Maori"] = "mi";
  Language["Macedonian"] = "mk";
  Language["Malayalam"] = "ml";
  Language["Mongolian"] = "mn";
  Language["Marathi"] = "mr";
  Language["Malay"] = "ms";
  Language["Maltese"] = "mt";
  Language["Myanmar"] = "my";
  Language["Nepali"] = "ne";
  Language["Dutch"] = "nl";
  Language["Norwegian"] = "no";
  Language["Nyanja"] = "ny";
  Language["Oriya"] = "or";
  Language["Punjabi"] = "pa";
  Language["Polish"] = "pl";
  Language["Pashto"] = "ps";
  Language["Portuguese"] = "pt";
  Language["Romanian"] = "ro";
  Language["Russian"] = "ru";
  Language["Kinyarwanda"] = "rw";
  Language["Sindhi"] = "sd";
  Language["Sinhala"] = "si";
  Language["Slovak"] = "sk";
  Language["Slovenian"] = "sl";
  Language["Samoan"] = "sm";
  Language["Shona"] = "sn";
  Language["Somali"] = "so";
  Language["Albanian"] = "sq";
  Language["Serbian"] = "sr";
  Language["Sesotho"] = "st";
  Language["Sundanese"] = "su";
  Language["Swedish"] = "sv";
  Language["Swahili"] = "sw";
  Language["Tamil"] = "ta";
  Language["Telugu"] = "te";
  Language["Tajik"] = "tg";
  Language["Thai"] = "th";
  Language["Turkmen"] = "tk";
  Language["Filipino"] = "tl";
  Language["Turkish"] = "tr";
  Language["Tatar"] = "tt";
  Language["Uighur"] = "ug";
  Language["Ukrainian"] = "uk";
  Language["Urdu"] = "ur";
  Language["Uzbek"] = "uz";
  Language["Vietnamese"] = "vi";
  Language["Xhosa"] = "xh";
  Language["Yiddish"] = "yi";
  Language["Yoruba"] = "yo";
  Language["ChineseSimplified"] = "zh";
  Language["ChineseTraditional"] = "zh-TW";
  Language["Zulu"] = "zu";
})(Language || (Language = {}));
var OrderBy;
(function (OrderBy) {
  OrderBy["LATEST"] = "latest";
  OrderBy["POPULAR"] = "popular";
  OrderBy["VIEWS"] = "views";
  OrderBy["DOWNLOADS"] = "downloads";
  OrderBy["OLDEST"] = "oldest";
})(OrderBy || (OrderBy = {}));
var createApi = /*#__PURE__*/flow(initMakeRequest, function (makeRequest) {
  return {
    photos: {
      get: makeRequest(get$1),
      list: makeRequest(list$1),
      getStats: makeRequest(getStats),
      getRandom: makeRequest(getRandom),
      trackDownload: makeRequest(trackDownload)
    },
    users: {
      getPhotos: makeRequest(getPhotos$2),
      getCollections: makeRequest(getCollections$2),
      getLikes: makeRequest(getLikes),
      get: makeRequest(get$2)
    },
    search: {
      getCollections: makeRequest(getCollections$1),
      getPhotos: makeRequest(getPhotos$1),
      getUsers: makeRequest(getUsers)
    },
    collections: {
      getPhotos: makeRequest(getPhotos),
      get: makeRequest(get),
      list: makeRequest(unsplash_js_esm_list),
      getRelated: makeRequest(getRelated)
    },
    topics: {
      list: makeRequest(list$2),
      get: makeRequest(get$3),
      getPhotos: makeRequest(getPhotos$3)
    }
  };
});

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/unsplashManager/unsplashPicker/searchForm.js


function searchForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function searchForm_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { searchForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { searchForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }


function SearchForm(_ref) {
  var setQuery = _ref.setQuery,
    query = _ref.query,
    onSearch = _ref.onSearch,
    i18n = _ref.i18n;
  var inputRef = (0,hooks_module/* useRef */.sO)(null);
  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = searchForm_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              onSearch(query);
            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var onInput = function onInput(event) {
    setQuery(event.target.value);
  };
  (0,hooks_module/* useEffect */.d4)(function () {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  return (0,preact_module.h)("form", {
    onSubmit: onSubmit
  }, (0,preact_module.h)("input", {
    className: "unsplash-image-picker-input",
    placeholder: i18n.get('image.unsplash.placeholder'),
    type: "text",
    name: "search",
    value: query,
    onInput: onInput,
    ref: inputRef
  }), (0,preact_module.h)("button", {
    type: "submit"
  }, i18n.get('image.unsplash.search')));
}
;// CONCATENATED MODULE: ./node_modules/react-responsive-masonry/es/Masonry/index.js





function Masonry_extends() {
  Masonry_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return Masonry_extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Masonry_setPrototypeOf(subClass, superClass);
}
function Masonry_setPrototypeOf(o, p) {
  Masonry_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return Masonry_setPrototypeOf(o, p);
}


var Masonry = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Masonry, _React$Component);
  function Masonry() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = Masonry.prototype;
  _proto.getColumns = function getColumns() {
    var _this$props = this.props,
      children = _this$props.children,
      columnsCount = _this$props.columnsCount;
    var columns = Array.from({
      length: columnsCount
    }, function () {
      return [];
    });
    compat_module["default"].Children.forEach(children, function (child, index) {
      if (child && compat_module["default"].isValidElement(child)) {
        columns[index % columnsCount].push(child);
      }
    });
    return columns;
  };
  _proto.renderColumns = function renderColumns() {
    var gutter = this.props.gutter;
    return this.getColumns().map(function (column, i) {
      return /*#__PURE__*/compat_module["default"].createElement("div", {
        key: i,
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignContent: "stretch",
          flex: 1,
          width: 0,
          gap: gutter
        }
      }, column.map(function (item) {
        return item;
      }));
    });
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      gutter = _this$props2.gutter,
      className = _this$props2.className,
      style = _this$props2.style;
    return /*#__PURE__*/compat_module["default"].createElement("div", {
      style: Masonry_extends({
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignContent: "stretch",
        boxSizing: "border-box",
        width: "100%",
        gap: gutter
      }, style),
      className: className
    }, this.renderColumns());
  };
  return Masonry;
}(compat_module["default"].Component);
Masonry.propTypes =  false ? 0 : {};
Masonry.defaultProps = {
  columnsCount: 3,
  gutter: "0",
  className: null,
  style: {}
};
/* harmony default export */ const es_Masonry = (Masonry);
;// CONCATENATED MODULE: ./node_modules/react-responsive-masonry/es/ResponsiveMasonry/index.js






var DEFAULT_COLUMNS_COUNT = 1;
var useIsomorphicLayoutEffect = typeof window !== "undefined" ? compat_module.useLayoutEffect : compat_module.useEffect;
var useHasMounted = function useHasMounted() {
  var _useState = (0,compat_module.useState)(false),
    hasMounted = _useState[0],
    setHasMounted = _useState[1];
  useIsomorphicLayoutEffect(function () {
    setHasMounted(true);
  }, []);
  return hasMounted;
};
var useWindowWidth = function useWindowWidth() {
  var hasMounted = useHasMounted();
  var _useState2 = (0,compat_module.useState)(0),
    width = _useState2[0],
    setWidth = _useState2[1];
  var handleResize = (0,compat_module.useCallback)(function () {
    if (!hasMounted) return;
    setWidth(window.innerWidth);
  }, [hasMounted]);
  useIsomorphicLayoutEffect(function () {
    if (hasMounted) {
      window.addEventListener("resize", handleResize);
      handleResize();
      return function () {
        return window.removeEventListener("resize", handleResize);
      };
    }
  }, [hasMounted, handleResize]);
  return width;
};
var MasonryResponsive = function MasonryResponsive(_ref) {
  var _ref$columnsCountBrea = _ref.columnsCountBreakPoints,
    columnsCountBreakPoints = _ref$columnsCountBrea === void 0 ? {
      350: 1,
      750: 2,
      900: 3
    } : _ref$columnsCountBrea,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? null : _ref$style;
  var windowWidth = useWindowWidth();
  var columnsCount = (0,compat_module.useMemo)(function () {
    var breakPoints = Object.keys(columnsCountBreakPoints).sort(function (a, b) {
      return a - b;
    });
    var count = breakPoints.length > 0 ? columnsCountBreakPoints[breakPoints[0]] : DEFAULT_COLUMNS_COUNT;
    breakPoints.forEach(function (breakPoint) {
      if (breakPoint < windowWidth) {
        count = columnsCountBreakPoints[breakPoint];
      }
    });
    return count;
  }, [windowWidth, columnsCountBreakPoints]);
  return /*#__PURE__*/compat_module["default"].createElement("div", {
    className: className,
    style: style
  }, compat_module["default"].Children.map(children, function (child, index) {
    return compat_module["default"].cloneElement(child, {
      key: index,
      columnsCount: columnsCount
    });
  }));
};
MasonryResponsive.propTypes =  false ? 0 : {};
/* harmony default export */ const ResponsiveMasonry = ((/* unused pure expression or super */ null && (MasonryResponsive)));
;// CONCATENATED MODULE: ./node_modules/react-responsive-masonry/es/index.js


/* harmony default export */ const es = (es_Masonry);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.small.js
var es_string_small = __webpack_require__(37268);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/unsplashManager/unsplashPicker/imageComponent.js



function ImageComponent(_ref) {
  var image = _ref.image,
    _ref$onSelect = _ref.onSelect,
    onSelect = _ref$onSelect === void 0 ? function () {} : _ref$onSelect;
  var onClick = function onClick() {
    onSelect(image);
  };
  return (0,preact_module.h)("div", {
    className: "unsplash-image-picker-image",
    key: image.id,
    onClick: onClick
  }, (0,preact_module.h)("img", {
    src: image.urls.thumb,
    alt: image.alt_description
  }), (0,preact_module.h)("div", {
    className: "unsplash-image-picker-overlay"
  }, (0,preact_module.h)("div", {
    className: "unsplash-image-picker-author"
  }, (0,preact_module.h)("img", {
    className: "unsplash-image-picker-author-avatar",
    src: image.user.profile_image.small,
    alt: image.user.username
  }), (0,preact_module.h)("span", {
    className: "unsplash-image-picker-author-name"
  }, image.user.name))));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/unsplashManager/unsplashPicker/imageList.js






function ImageList(_ref) {
  var _ref$isRandom = _ref.isRandom,
    isRandom = _ref$isRandom === void 0 ? false : _ref$isRandom,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$isLoadingMore = _ref.isLoadingMore,
    isLoadingMore = _ref$isLoadingMore === void 0 ? false : _ref$isLoadingMore,
    images = _ref.images,
    total = _ref.total,
    onSelect = _ref.onSelect,
    onLoadMore = _ref.onLoadMore,
    i18n = _ref.i18n;
  var listHeight = '350px';
  var ref = (0,hooks_module/* useMemo */.Ye)(function () {
    return (0,preact_module/* createRef */.Vf)();
  }, []);
  var onScroll = function onScroll() {
    if (isRandom) return;
    if (ref.current) {
      var _ref$current = ref.current,
        scrollTop = _ref$current.scrollTop,
        scrollHeight = _ref$current.scrollHeight,
        clientHeight = _ref$current.clientHeight;
      if (scrollHeight - (scrollTop + clientHeight) < 20) {
        onLoadMore();
      }
    }
  };
  var hasImages = Array.isArray(images) && images.length > 0;
  var listStyle = {
    minHeight: listHeight
  };
  if (isLoading) {
    listStyle.height = listHeight;
  }
  return (0,preact_module.h)("div", {
    className: "unsplash-image-picker-list",
    style: listStyle
  }, isLoading ? (0,preact_module.h)("div", {
    className: "unsplash-image-picker-loading"
  }, (0,preact_module.h)((loader2_default()), null)) : (0,preact_module.h)(preact_module/* Fragment */.HY, null, hasImages && (0,preact_module.h)("div", {
    className: "unsplash-image-picker-grid",
    style: {
      maxHeight: listHeight
    },
    ref: ref,
    onScroll: onScroll
  }, (0,preact_module.h)(es, {
    columnsCount: 4,
    gutter: "10px"
  }, images.map(function (img) {
    return (0,preact_module.h)(ImageComponent, {
      key: img.id,
      image: img,
      onSelect: onSelect
    });
  })), isLoadingMore && (0,preact_module.h)("div", {
    className: "unsplash-image-picker-loading-more"
  }, (0,preact_module.h)((loader2_default()), null)), isRandom && (0,preact_module.h)("div", {
    className: "unsplash-image-picker-bottom-description"
  }, i18n.get('image.unsplash.description'))), !hasImages && total === 0 && (0,preact_module.h)("div", {
    className: "unsplash-image-picker-no-result"
  }, i18n.get('image.unsplash.no_result'))));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/unsplashManager/unsplashPicker/index.js

function unsplashPicker_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function unsplashPicker_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { unsplashPicker_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { unsplashPicker_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function unsplashPicker_toConsumableArray(arr) { return unsplashPicker_arrayWithoutHoles(arr) || unsplashPicker_iterableToArray(arr) || unsplashPicker_unsupportedIterableToArray(arr) || unsplashPicker_nonIterableSpread(); }
function unsplashPicker_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function unsplashPicker_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function unsplashPicker_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return unsplashPicker_arrayLikeToArray(arr); }













function unsplashPicker_slicedToArray(arr, i) { return unsplashPicker_arrayWithHoles(arr) || unsplashPicker_iterableToArrayLimit(arr, i) || unsplashPicker_unsupportedIterableToArray(arr, i) || unsplashPicker_nonIterableRest(); }
function unsplashPicker_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function unsplashPicker_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return unsplashPicker_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return unsplashPicker_arrayLikeToArray(o, minLen); }
function unsplashPicker_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function unsplashPicker_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function unsplashPicker_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }





function ImagePicker(props) {
  var unsplashAccessKey = props.unsplashAccessKey,
    _props$initialQuery = props.initialQuery,
    initialQuery = _props$initialQuery === void 0 ? '' : _props$initialQuery,
    onImageSelect = props.onImageSelect,
    onClose = props.onClose,
    i18n = props.i18n;
  var _useState = (0,hooks_module/* useState */.eJ)([]),
    _useState2 = unsplashPicker_slicedToArray(_useState, 2),
    images = _useState2[0],
    setImages = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(),
    _useState4 = unsplashPicker_slicedToArray(_useState3, 2),
    total = _useState4[0],
    setTotal = _useState4[1];
  var _useState5 = (0,hooks_module/* useState */.eJ)(''),
    _useState6 = unsplashPicker_slicedToArray(_useState5, 2),
    query = _useState6[0],
    setQuery = _useState6[1];
  var _useState7 = (0,hooks_module/* useState */.eJ)(false),
    _useState8 = unsplashPicker_slicedToArray(_useState7, 2),
    isLoading = _useState8[0],
    setIsLoading = _useState8[1];
  var _useState9 = (0,hooks_module/* useState */.eJ)(false),
    _useState10 = unsplashPicker_slicedToArray(_useState9, 2),
    isLoadingMore = _useState10[0],
    setIsLoadingMore = _useState10[1];
  var _useState11 = (0,hooks_module/* useState */.eJ)(1),
    _useState12 = unsplashPicker_slicedToArray(_useState11, 2),
    page = _useState12[0],
    setPage = _useState12[1];
  var containerRef = (0,hooks_module/* useRef */.sO)(null);
  var unsplash = createApi({
    accessKey: unsplashAccessKey
  });
  (0,hooks_module/* useEffect */.d4)(function () {
    if (initialQuery !== '') {
      setQuery(initialQuery);
      fetchImages(1, initialQuery);
    } else {
      fetchRandom();
    }
  }, []);
  var fetchImages = (0,hooks_module/* useCallback */.I4)(function (page, text) {
    var reset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (isLoading || isLoadingMore) {
      return;
    }
    if (page === 1) {
      setIsLoading(true);
    } else {
      setIsLoadingMore(true);
    }
    setPage(page);
    unsplash.search.getPhotos({
      page: page,
      perPage: 30,
      query: text
    }).then(function (response) {
      var _response$response;
      var newImages = response === null || response === void 0 ? void 0 : (_response$response = response.response) === null || _response$response === void 0 ? void 0 : _response$response.results;
      if (newImages) {
        var merged = newImages;
        if (!reset) {
          merged = [].concat(unsplashPicker_toConsumableArray(images), unsplashPicker_toConsumableArray(newImages));
        }
        setImages(merged);
        setTotal(response.response.total);
      }
      setIsLoading(false);
      setIsLoadingMore(false);
    });
  });
  var fetchRandom = (0,hooks_module/* useCallback */.I4)(function () {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    unsplash.photos.getRandom({
      count: 30
    }).then(function (response) {
      var newImages = response === null || response === void 0 ? void 0 : response.response;
      if (newImages) {
        setImages(newImages);
      }
      setIsLoading(false);
    });
  });
  var onSearch = (0,hooks_module/* useCallback */.I4)(function () {
    setImages([]);
    if (query) {
      fetchImages(1, query, true);
    } else {
      fetchRandom();
    }
  });
  var onLoadMore = function onLoadMore() {
    fetchImages(page + 1, query);
  };
  var onSelect = /*#__PURE__*/function () {
    var _ref = unsplashPicker_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(img) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              onImageSelect(img);
              onClose();
            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function onSelect(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return (0,preact_module.h)("div", {
    className: "unsplash-image-picker-container",
    ref: containerRef
  }, (0,preact_module.h)("div", {
    className: "unsplash-image-picker"
  }, (0,preact_module.h)("div", {
    className: "unsplash-image-picker-header"
  }, i18n.get('image.unsplash.header')), (0,preact_module.h)("div", {
    className: "unsplash-image-picker-search"
  }, (0,preact_module.h)(SearchForm, {
    query: query,
    setQuery: setQuery,
    onSearch: onSearch,
    i18n: i18n
  })), (0,preact_module.h)(ImageList, {
    isRandom: !query,
    total: total,
    images: images,
    isLoading: isLoading,
    isLoadingMore: isLoadingMore,
    onLoadMore: onLoadMore,
    onSelect: onSelect,
    i18n: i18n
  })));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/unsplashManager/index.js

function unsplashManager_extends() { unsplashManager_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return unsplashManager_extends.apply(this, arguments); }
function unsplashManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function unsplashManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function unsplashManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) unsplashManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) unsplashManager_defineProperties(Constructor, staticProps); return Constructor; }
function unsplashManager_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var UNSPLASH_CONTAINER_ID = 'unsplash-manager-container';
var UnsplashManager = /*#__PURE__*/function () {
  function UnsplashManager(_ref) {
    var _this = this;
    var editor = _ref.editor,
      scroll = _ref.scroll,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;
    unsplashManager_classCallCheck(this, UnsplashManager);
    unsplashManager_defineProperty(this, "onMenuWantsToClose", function () {
      _this.hidePicker();
    });
    unsplashManager_defineProperty(this, "hidePicker", function () {
      _this.render();
    });
    this.editor = editor;
    this.scroll = scroll;
    this.options = options;
    this.container = this.renderContainer();
    this.enabled = this.options.enabled;
    this.render();
  }
  unsplashManager_createClass(UnsplashManager, [{
    key: "renderContainer",
    value: function renderContainer() {
      var node = document.createElement('div');
      node.id = UNSPLASH_CONTAINER_ID;
      this.editor.editorBody.appendChild(node);
      return node;
    }
  }, {
    key: "render",
    value: function render() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      (0,preact_module/* render */.sY)(show ? (0,preact_module.h)(popupMenu/* default */.Z, {
        addClassName: "unsplash-image-picker-popup",
        wantsToClose: this.onMenuWantsToClose,
        closeOnEsc: true,
        anchorNode: props.blot.domNode,
        anchorOptions: {
          positionFixed: true,
          offset: '0px, 0px',
          placement: 'bottom-start',
          priority: ['top', 'left', 'right'],
          overflowBoundariesElement: props.blot.editor.getScrollingContainer(),
          boundariesElement: props.blot.editor.getScrollingContainer()
        }
      }, (0,preact_module.h)(ImagePicker, unsplashManager_extends({}, props, {
        unsplashAccessKey: "W3etiemiYh2fPKvdya7JAqliRY2LnqpLEAr7GUpCQZM",
        initialQuery: "",
        onClose: this.hidePicker,
        i18n: this.editor.plugins.i18n
      }))) : null, this.container);
    }
  }, {
    key: "openPicker",
    value: function openPicker(blot, onImageSelect) {
      var props = {
        blot: blot,
        onImageSelect: onImageSelect
      };
      this.render(props, true);
    }
  }]);
  return UnsplashManager;
}();

// EXTERNAL MODULE: ./node_modules/react-autosize-textarea/lib/index.js
var react_autosize_textarea_lib = __webpack_require__(15806);
// EXTERNAL MODULE: ./node_modules/highlight.js/lib/index.js
var highlight_js_lib = __webpack_require__(60311);
var lib_default = /*#__PURE__*/__webpack_require__.n(highlight_js_lib);
// EXTERNAL MODULE: ./node_modules/markdown-it/index.js
var markdown_it = __webpack_require__(8707);
var markdown_it_default = /*#__PURE__*/__webpack_require__.n(markdown_it);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/aiManager/util.js


var md = new (markdown_it_default())({
  breaks: true,
  highlight: function highlight(str, lang) {
    if (lang && lib_default().getLanguage(lang)) {
      try {
        return '<pre class="hljs"><code class="language-' + lang + ' hljs-code">' + lib_default().highlight(str, {
          language: lang,
          ignoreIllegals: true
        }).value + '</code></pre>';
      } catch (__) {}
    }
    return '<pre class="hljs"><code class="language-' + lang + ' hljs-code">' + md.utils.escapeHtml(str) + '</code></pre>';
  }
});
function parseMarkdownToHtml(markdown) {
  return md.render(markdown);
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/aiManager/menu/customMenu.js











function customMenu_slicedToArray(arr, i) { return customMenu_arrayWithHoles(arr) || customMenu_iterableToArrayLimit(arr, i) || customMenu_unsupportedIterableToArray(arr, i) || customMenu_nonIterableRest(); }
function customMenu_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function customMenu_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return customMenu_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return customMenu_arrayLikeToArray(o, minLen); }
function customMenu_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function customMenu_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function customMenu_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




var DRAFTS = [{
  name: 'Sales email',
  preffix: 'Write sales email about'
}, {
  name: 'Proposal',
  preffix: 'Write proposal about'
}, {
  name: 'Newsletter',
  preffix: 'Write newsletter about'
}, {
  name: 'Blog post',
  preffix: 'Create a Blog post about'
}, {
  name: 'Brainstorm ideas',
  preffix: 'Write brainstorm ideas about'
}, {
  name: 'Social media post',
  preffix: 'Create a social media post about'
}, {
  name: 'Content Calendar',
  preffix: 'Generate a content calendar about'
}, {
  name: 'Step by Step Guide',
  preffix: 'Write a step by step guide to instruct how to'
}, {
  name: 'Follow up email',
  preffix: 'Create a follow up about'
}];
var OUTPUT_LENGTH = ['s', 'm', 'l'];
function CustomMenu(props) {
  var _useState = (0,hooks_module/* useState */.eJ)(0),
    _useState2 = customMenu_slicedToArray(_useState, 2),
    toneCharCount = _useState2[0],
    setToneCharCount = _useState2[1];
  var toneInputRef = (0,hooks_module/* useRef */.sO)(null);
  var _props$draftsEnabled = props.draftsEnabled,
    draftsEnabled = _props$draftsEnabled === void 0 ? true : _props$draftsEnabled,
    _props$activeDraft = props.activeDraft,
    activeDraft = _props$activeDraft === void 0 ? null : _props$activeDraft,
    onDraftClick = props.onDraftClick,
    outputLength = props.outputLength,
    onOutputLengthClick = props.onOutputLengthClick,
    onToneInputRef = props.onToneInputRef,
    contextEnabled = props.contextEnabled,
    onContextEnabledChange = props.onContextEnabledChange;
  var _useState3 = (0,hooks_module/* useState */.eJ)(contextEnabled),
    _useState4 = customMenu_slicedToArray(_useState3, 2),
    pageContextEnabled = _useState4[0],
    setPageContextEnabled = _useState4[1];
  var onToneInput = function onToneInput(event) {
    var value = toneInputRef.current.value;
    if (value.length > 60) {
      toneInputRef.current.value = value.substring(0, 60);
    }
    setToneCharCount(toneInputRef.current.value.length);
  };
  (0,hooks_module/* useEffect */.d4)(function () {
    if (onToneInputRef) {
      onToneInputRef(toneInputRef.current);
    }
    if (toneInputRef.current) {
      setToneCharCount(toneInputRef.current.value.length);
    } else {
      setToneCharCount(0);
    }
  }, [toneInputRef.current]);
  var onUsePageContextChange = function onUsePageContextChange() {
    var enabled = !pageContextEnabled;
    setPageContextEnabled(enabled);
    onContextEnabledChange && onContextEnabledChange(enabled);
  };

  // решили пока отключить опцию с длиной вывода так как AI не всегда возвращает нужное количество символов
  var showOutputLength = false;
  return (0,preact_module.h)("div", {
    className: "ai-promt-options"
  }, (0,preact_module.h)("div", {
    className: "ai-promt-options-header ai-promt-options__use-page-context"
  }, (0,preact_module.h)("span", null, "Use page context"), (0,preact_module.h)(components_switch, {
    onChange: onUsePageContextChange,
    enabled: pageContextEnabled,
    size: "large"
  })), draftsEnabled ? (0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)("div", {
    className: "ai-promt-options-header"
  }, "Draft with Fusebase AI"), DRAFTS.map(function (draft) {
    return (0,preact_module.h)("span", {
      className: 'ai-promt-options-item' + (activeDraft === draft.preffix ? ' active' : ''),
      onClick: onDraftClick.bind(undefined, draft.preffix)
    }, (0,preact_module.h)("span", {
      className: "ai-promt-options-item-icon"
    }, (0,preact_module.h)(icons/* IconEditVideo */.pj0, null)), draft.name);
  })) : null, showOutputLength ? (0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)("div", {
    className: "ai-promt-options-header"
  }, "Output length"), (0,preact_module.h)("div", {
    className: "ai-promt-options-output-length"
  }, OUTPUT_LENGTH.map(function (item) {
    return (0,preact_module.h)("span", {
      className: 'ai-promt-options-output-length-option' + (outputLength === item ? ' active' : ''),
      onClick: onOutputLengthClick.bind(undefined, item)
    }, item);
  }))) : null, (0,preact_module.h)("div", {
    className: "ai-promt-options-header"
  }, "Tone of voice"), (0,preact_module.h)("div", {
    className: "ai-promt-options-tone"
  }, (0,preact_module.h)("input", {
    type: "text",
    className: "ai-promt-options-tone-input",
    onInput: onToneInput,
    ref: toneInputRef,
    placeholder: "Witty, serious, etc."
  }), (0,preact_module.h)("span", {
    className: "ai-promt-options-tone-count"
  }, toneCharCount, "/60")));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/aiManager/menu/manageMenu.js
function manageMenu_toConsumableArray(arr) { return manageMenu_arrayWithoutHoles(arr) || manageMenu_iterableToArray(arr) || manageMenu_unsupportedIterableToArray(arr) || manageMenu_nonIterableSpread(); }
function manageMenu_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function manageMenu_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return manageMenu_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return manageMenu_arrayLikeToArray(o, minLen); }
function manageMenu_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function manageMenu_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return manageMenu_arrayLikeToArray(arr); }
function manageMenu_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }















function ManageMenu(props) {
  var _session$options;
  var session = props.session,
    i18n = props.i18n,
    onActionClick = props.onActionClick,
    onTryAgainClick = props.onTryAgainClick,
    onDiscardClick = props.onDiscardClick,
    onApplyContent = props.onApplyContent,
    onCopyClick = props.onCopyClick;
  var onReplace = function onReplace() {
    session.applyContent && session.applyContent('replace');
    onApplyContent();
  };
  var onInsertAbove = function onInsertAbove() {
    session.applyContent && session.applyContent('before');
    onApplyContent();
  };
  var onInsertBelow = function onInsertBelow() {
    session.applyContent && session.applyContent('after');
    onApplyContent();
  };
  var onInsertTaskList = function onInsertTaskList() {
    session.insertTaskList();
    onApplyContent();
  };
  var onInsertCheckboxList = function onInsertCheckboxList() {
    session.insertCheckboxList();
    onApplyContent();
  };
  var ITEMS = [];
  if (((_session$options = session.options) === null || _session$options === void 0 ? void 0 : _session$options.action) !== 'tasks') {
    if (session.type === 'range' || session.type === 'page') {
      if (['range'].includes(session.type)) {
        ITEMS.push({
          key: 'replace',
          name: i18n.get('ai_manager.manage.replace') || 'Replace',
          Icon: icons/* IconReplace */.hFX,
          callback: onReplace,
          group: 0
        });
      }
      if (!['page'].includes(session.type)) {
        ITEMS.push.apply(ITEMS, [{
          key: 'above',
          name: i18n.get('ai_manager.manage.insert_above') || 'Insert above',
          Icon: icons/* IconArrowUpIcon */.WLL,
          callback: onInsertAbove,
          group: 0
        }, {
          key: 'below',
          name: i18n.get('ai_manager.manage.insert_below') || 'Insert below',
          Icon: icons/* IconArrowDownIcon */.DKw,
          callback: onInsertBelow,
          group: 0
        }]);
      }
      if (['page'].includes(session.type)) {
        ITEMS.push.apply(ITEMS, [{
          key: 'done',
          name: i18n.get('ai_manager.manage.done') || 'Done',
          Icon: icons/* IconDoneThemed */.QPj,
          callback: onInsertBelow,
          group: 0
        }]);
      }
    } else {
      ITEMS.push({
        key: 'done',
        name: i18n.get('ai_manager.manage.done') || 'Done',
        Icon: icons/* IconDoneThemed */.QPj,
        callback: onInsertAbove,
        group: 1
      });
    }
    ITEMS.push.apply(ITEMS, [{
      key: 'continue',
      name: i18n.get('ai_manager.manage.continue') || 'Continue writing',
      Icon: icons/* IconEditVideo */.pj0,
      callback: onActionClick.bind(undefined, 'continue'),
      group: 1
    }, {
      key: 'shorter',
      name: i18n.get('ai_manager.manage.shorter') || 'Make shorter',
      Icon: icons/* IconAiShorter */.rXf,
      callback: onActionClick.bind(undefined, 'shorter'),
      group: 1
    }, {
      key: 'longer',
      name: i18n.get('ai_manager.manage.longer') || 'Make longer',
      Icon: icons/* IconAiLonger */.Z8B,
      callback: onActionClick.bind(undefined, 'longer'),
      group: 1
    } /* {
      key: 'translate',
      name: i18n.get('ai_manager.manage.translate') || 'Translate',
      Icon: IconTranslate,
      callback: () => {},
      group: 1
      } */]);
  } else {
    var _session$tasks;
    ITEMS.push.apply(ITEMS, [{
      key: 'insertText',
      name: i18n.get('ai_manager.manage.insert_as_text') || 'Insert as text',
      Icon: icons/* IconArrowDownIcon */.DKw,
      callback: onInsertBelow,
      group: 1
    }].concat(manageMenu_toConsumableArray((_session$tasks = session.tasks) !== null && _session$tasks !== void 0 && _session$tasks.length ? [{
      key: 'insertTaskList',
      name: i18n.get('ai_manager.manage.insert_as_task_list') || 'Insert as task list',
      Icon: icons/* IconArrowDownIcon */.DKw,
      callback: onInsertTaskList,
      group: 1
    }, {
      key: 'insertCheckboxList',
      name: i18n.get('ai_manager.manage.insert_as_checkbox_list') || 'Insert as checkbox list',
      Icon: icons/* IconArrowDownIcon */.DKw,
      callback: onInsertCheckboxList,
      group: 1
    }] : [])));
  }
  ITEMS.push.apply(ITEMS, [{
    key: 'copy',
    name: i18n.get('ai_manager.manage.copy') || 'Copy',
    Icon: icons/* IconCopy */.vUr,
    callback: onCopyClick,
    group: 2
  }, {
    key: 'try-again',
    name: i18n.get('ai_manager.manage.try_again') || 'Try again',
    Icon: icons/* IconSync */.JKM,
    callback: onTryAgainClick,
    group: 2
  }, {
    key: 'discard',
    name: i18n.get('ai_manager.manage.discard') || 'Discard',
    Icon: icons/* IconTrash */.IT9,
    callback: onDiscardClick,
    group: 2
  }]);
  return (0,preact_module.h)("div", {
    className: "ai-promt-options ai-promt-moderate"
  }, ITEMS.map(function (item, index) {
    var Icon = item.Icon;
    return (0,preact_module.h)(preact_module/* Fragment */.HY, null, ITEMS[index - 1] && item.group > ITEMS[index - 1].group ? (0,preact_module.h)("span", {
      className: "ai-promt-options-divider"
    }) : null, (0,preact_module.h)("span", {
      className: "ai-promt-options-item",
      onClick: item.callback
    }, (0,preact_module.h)("span", {
      className: "ai-promt-options-item-icon"
    }, Icon ? (0,preact_module.h)(Icon, null) : ''), item.name));
  }));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/aiManager/menu/actionMenu.js





function ActionMenu(props) {
  var onAiHelperClick = props.onAiHelperClick,
    onActionClick = props.onActionClick,
    i18n = props.i18n;
  var actions = props.actions;
  var ACTIONS = [{
    key: 'custom',
    name: i18n.get('ai_manager.actions.custom') || 'Ai helper',
    Icon: icons/* IconPromtIcon */.nST
  }, {
    key: 'summarize',
    name: i18n.get('ai_manager.actions.summarize') || 'Summarize',
    Icon: icons/* IconAiSummarize */.vO
  }, {
    key: 'explain',
    name: i18n.get('ai_manager.actions.explain') || 'Explain',
    Icon: icons/* IconAiExplain */.j0X
  }, {
    key: 'improve',
    name: i18n.get('ai_manager.actions.improve') || 'Improve',
    Icon: icons/* IconAiImprove */.F6w
  }, {
    key: 'fix',
    name: i18n.get('ai_manager.actions.fix') || 'Fix spelling and grammar',
    Icon: icons/* IconAiSpelling */.Lan
  }, {
    key: 'tasks',
    name: i18n.get('ai_manager.actions.tasks') || 'Call to actions',
    Icon: icons/* IconAiCta */.qHO
  }, {
    key: 'shorter',
    name: i18n.get('ai_manager.actions.shorter') || 'Make shorter',
    Icon: icons/* IconAiShorter */.rXf
  }, {
    key: 'longer',
    name: i18n.get('ai_manager.actions.longer') || 'Make longer',
    Icon: icons/* IconAiLonger */.Z8B
  }];
  if (!actions || !actions.length) {
    actions = ACTIONS.map(function (action) {
      return action.key;
    });
  }
  return (0,preact_module.h)("div", {
    className: "ai-promt-options ai-promt-actions"
  }, actions.map(function (key) {
    var action = ACTIONS.find(function (item) {
      return item.key === key;
    });
    if (action) {
      var Icon = action.Icon;
      var fn = key === 'custom' ? onAiHelperClick : onActionClick;
      return (0,preact_module.h)("span", {
        className: "ai-promt-options-item",
        onClick: fn.bind(undefined, action.key)
      }, (0,preact_module.h)("span", {
        className: "ai-promt-options-item-icon"
      }, (0,preact_module.h)(Icon, null)), action.name);
    }
    return null;
  }));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/aiManager/aiPluginComponent.js















function aiPluginComponent_slicedToArray(arr, i) { return aiPluginComponent_arrayWithHoles(arr) || aiPluginComponent_iterableToArrayLimit(arr, i) || aiPluginComponent_unsupportedIterableToArray(arr, i) || aiPluginComponent_nonIterableRest(); }
function aiPluginComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function aiPluginComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return aiPluginComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return aiPluginComponent_arrayLikeToArray(o, minLen); }
function aiPluginComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function aiPluginComponent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function aiPluginComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }









var aiPluginComponent_isEnterKey = (0,lib/* default */.ZP)('Enter');
function AiPluginComponent(props) {
  var manager = props.manager,
    session = props.session,
    pos = props.pos,
    _props$draftsEnabled = props.draftsEnabled,
    draftsEnabled = _props$draftsEnabled === void 0 ? false : _props$draftsEnabled,
    _props$contextEnabled = props.contextEnabled,
    contextEnabled = _props$contextEnabled === void 0 ? true : _props$contextEnabled,
    onContextEnabledChange = props.onContextEnabledChange,
    onPromtContainerRef = props.onPromtContainerRef,
    onPromtInputRef = props.onPromtInputRef,
    onRendered = props.onRendered;
  var containerRef = (0,hooks_module/* useRef */.sO)(null);
  var promtRef = (0,hooks_module/* useRef */.sO)(null);
  var printContentRef = (0,hooks_module/* useRef */.sO)(null);
  var toneInputRef = (0,hooks_module/* useRef */.sO)(null);
  var _useState = (0,hooks_module/* useState */.eJ)(false),
    _useState2 = aiPluginComponent_slicedToArray(_useState, 2),
    allowEnter = _useState2[0],
    setAllowEnter = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(OUTPUT_LENGTH[0]),
    _useState4 = aiPluginComponent_slicedToArray(_useState3, 2),
    outputLength = _useState4[0],
    setOutputLength = _useState4[1];
  var _useState5 = (0,hooks_module/* useState */.eJ)(false),
    _useState6 = aiPluginComponent_slicedToArray(_useState5, 2),
    loading = _useState6[0],
    setLoading = _useState6[1];
  var _useState7 = (0,hooks_module/* useState */.eJ)(false),
    _useState8 = aiPluginComponent_slicedToArray(_useState7, 2),
    manageContent = _useState8[0],
    setManageContent = _useState8[1];
  var _useState9 = (0,hooks_module/* useState */.eJ)(null),
    _useState10 = aiPluginComponent_slicedToArray(_useState9, 2),
    activeDraft = _useState10[0],
    setActiveDraft = _useState10[1];
  var _useState11 = (0,hooks_module/* useState */.eJ)(false),
    _useState12 = aiPluginComponent_slicedToArray(_useState11, 2),
    isContinue = _useState12[0],
    setIsContinue = _useState12[1];
  var isMouseWheelUsed = (0,hooks_module/* useRef */.sO)(false);
  var i18n = manager.editor.plugins.i18n;
  (0,hooks_module/* useEffect */.d4)(function () {
    if (session.type === 'range' && session.options.action !== 'custom') {
      generateContent({}, session.options.action);
    }
    if (promtRef.current) {
      promtRef.current.focus();
    }
    scrollIntoView();
    onRendered && onRendered();
  }, []);
  (0,hooks_module/* useEffect */.d4)(function () {
    onPromtInputRef && onPromtInputRef(promtRef.current);
    onPromtContainerRef && onPromtContainerRef(containerRef.current);
  }, [promtRef.current, containerRef.current]);
  (0,hooks_module/* useEffect */.d4)(function () {
    if (loading) {
      var scrollingContainer = manager.editor.getScrollingContainer();
      addEventListener('beforeunload', onWindowBeforeUnload, {
        capture: true
      });
      scrollingContainer.addEventListener('wheel', onEditorMouseWheel, false);
      return function () {
        removeEventListener('beforeunload', onWindowBeforeUnload, {
          capture: true
        });
        scrollingContainer.removeEventListener('wheel', onEditorMouseWheel, false);
        isMouseWheelUsed.current = false;
      };
    }
  }, [loading]);
  var onWindowBeforeUnload = function onWindowBeforeUnload(event) {
    event.preventDefault();
    return event.returnValue = i18n.get('ai_manager.unload_message');
  };
  var onEditorMouseWheel = function onEditorMouseWheel(event) {
    if (!isMouseWheelUsed.current) {
      isMouseWheelUsed.current = true;
    }
  };
  var styles = {
    top: pos.top + 'px',
    left: pos.left + 'px',
    width: pos.width + 'px'
  };
  var history = manager.getUserHistory();
  var onChange = function onChange() {
    if (promtRef.current.value) {
      if (activeDraft) {
        if (!promtRef.current.value.startsWith(activeDraft)) {
          setActiveDraft(null);
          if (!allowEnter) {
            setAllowEnter(true);
          }
        } else {
          if (promtRef.current.value.trim() === activeDraft) {
            if (allowEnter) {
              setAllowEnter(false);
            }
          } else {
            if (!allowEnter) {
              setAllowEnter(true);
            }
          }
        }
      } else {
        if (promtRef.current.value.trim() !== '') {
          if (!allowEnter) {
            setAllowEnter(true);
          }
        } else {
          if (allowEnter) {
            setAllowEnter(false);
          }
        }
      }
    } else {
      if (allowEnter) {
        setAllowEnter(false);
      }
    }
  };
  var onKeyDown = function onKeyDown(event) {
    if (aiPluginComponent_isEnterKey(event)) {
      event.preventDefault();
      if (allowEnter) {
        onEnter();
      }
    }
  };
  var onEnterClick = function onEnterClick(event) {
    if (allowEnter) {
      onEnter();
    }
  };
  var changePrintContainerState = function changePrintContainerState() {
    var hasContent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (printContentRef.current) {
      if (hasContent) {
        if (!printContentRef.current.classList.contains('has-content')) {
          printContentRef.current.classList.add('has-content');
        }
      } else {
        printContentRef.current.innerHTML = '';
        if (printContentRef.current.classList.contains('has-content')) {
          printContentRef.current.classList.remove('has-content');
        }
      }
    }
  };
  var onAiMessage = function onAiMessage(markdown) {
    changePrintContainerState(true);
    printContentRef.current.innerHTML = parseMarkdownToHtml(markdown);
    if (!isMouseWheelUsed.current) {
      scrollIntoView();
    }
  };
  var scrollIntoView = function scrollIntoView() {
    if (containerRef.current) {
      var scrollRect = manager.editor.scroll.domNode.getBoundingClientRect();
      var rect = containerRef.current.getBoundingClientRect();
      var distance = rect.bottom - (scrollRect.bottom - 30);
      if (distance > 0) {
        manager.editor.getScrollingContainer().scrollTop += distance;
      }
    }
  };
  var generateContent = function generateContent(params) {
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'custom';
    if (session.isRequestActive) return;
    setLoading(true);
    setAllowEnter(false);
    setActiveDraft(null);
    if (!session.options) {
      session.options = {};
    }
    // after Discard and change action have to change session's action
    session.options.action = action !== 'continue' ? action : 'custom';
    if (action !== 'continue') {
      changePrintContainerState();
    } else {
      setIsContinue(false);
    }
    session.generate(params, action, onAiMessage).finally(function () {
      if (session.content) {
        if (session.content.ops && session.content.ops.length) {
          setManageContent(true);
          setLoading(false);
        } else {
          if (session.content.markdown) {
            session.saveContent().then(function () {
              setManageContent(true);
            }).finally(function () {
              setLoading(false);
            });
          } else {
            setLoading(false);
          }
        }
      }
      if (session.type === 'range' || session.type === 'page') {
        session.restoreRange();
      }
      setTimeout(function () {
        scrollIntoView();
      }, 0);
    });
  };
  var onEnter = function onEnter() {
    var _toneInputRef$current;
    var value = promtRef.current.value;
    if (!manager.options.getUserHistory) {
      if (value) {
        manager.addUserHistoryLocal(value);
      }
    }
    var params = {
      promt: value,
      outputLength: outputLength,
      voiceTone: (toneInputRef === null || toneInputRef === void 0 ? void 0 : (_toneInputRef$current = toneInputRef.current) === null || _toneInputRef$current === void 0 ? void 0 : _toneInputRef$current.value) || ''
    };
    generateContent(params, isContinue ? 'continue' : 'custom');
  };
  var onStopClick = function onStopClick() {
    session.stopGenerate();
    // дожидаемся обновлений состояний компонента и выполняем сохранение
    setTimeout(function () {
      setLoading(true);
      session.saveContent().then(function () {
        setManageContent(true);
      }).finally(function () {
        setLoading(false);
      });
    });
  };
  var onHistoryItemClick = function onHistoryItemClick(value) {
    promtRef.current.value = value;
    promtRef.current.focus();
    setAllowEnter(true);
  };
  var onDraftClick = function onDraftClick(value) {
    promtRef.current.value = value + ' ';
    promtRef.current.focus();
    setActiveDraft(value);
    setAllowEnter(false);
  };
  var onOutputLengthClick = function onOutputLengthClick(value) {
    setOutputLength(value);
  };
  var onToneInputRef = function onToneInputRef(node) {
    toneInputRef.current = node;
  };
  var onApplyContent = function onApplyContent() {
    changePrintContainerState();
    setManageContent(false);
  };
  var onCopyClick = function onCopyClick() {
    var text = printContentRef.current.textContent;
    var html = printContentRef.current.innerHTML;
    var ops = session.content && session.content.ops && session.content.ops.length ? session.content.ops : false;
    manager.editor.plugins.copyManager.copy(text, {
      html: html,
      ops: ops
    });
  };
  var onTryAgainClick = function onTryAgainClick() {
    var _session$options;
    var params = session.content && session.content.params ? Object.assign({}, session.content.params) : {};
    var action = (session === null || session === void 0 ? void 0 : (_session$options = session.options) === null || _session$options === void 0 ? void 0 : _session$options.action) || 'custom';
    generateContent(params, action);
  };
  var onDiscardClick = function onDiscardClick() {
    changePrintContainerState();
    setManageContent(false);
  };
  var onLearnMoreClick = function onLearnMoreClick() {
    manager.onLearnMoreClick && manager.onLearnMoreClick();
  };
  var onIdeaClick = function onIdeaClick() {
    manager.onIdeaClick && manager.onIdeaClick();
  };
  var onWritingTryAgainClick = function onWritingTryAgainClick() {
    var params = session.content && session.content.params ? Object.assign({}, session.content.params) : {};
    var action = session.content && session.content.action || 'custom';
    session.stopGenerate(true);
    // дожидаемся обновления состояний компонента после аборта запроса и выполняем новый
    setTimeout(function () {
      generateContent(params, action);
    }, 0);
  };
  var onActionClick = function onActionClick(action) {
    if (action === 'continue') {
      setIsContinue(true);
      setTimeout(function () {
        promtRef.current && promtRef.current.focus();
      }, 0);
    } else {
      generateContent({}, action);
    }
  };
  var onAiHelperClick = function onAiHelperClick() {
    promtRef.current && promtRef.current.focus();
  };
  var menuNode = null;
  if (!loading) {
    if (!manageContent) {
      if (session.type === 'page') {
        menuNode = (0,preact_module.h)(ActionMenu, {
          onActionClick: onActionClick,
          onAiHelperClick: onAiHelperClick,
          actions: ['custom', 'summarize', 'fix', 'tasks'],
          i18n: manager.editor.plugins.i18n
        });
      } else if (session.type === 'range') {
        menuNode = (0,preact_module.h)(ActionMenu, {
          onActionClick: onActionClick,
          onAiHelperClick: onAiHelperClick,
          i18n: manager.editor.plugins.i18n
        });
      } else {
        menuNode = (0,preact_module.h)(CustomMenu, {
          draftsEnabled: draftsEnabled,
          activeDraft: activeDraft,
          onDraftClick: onDraftClick,
          outputLength: outputLength,
          contextEnabled: contextEnabled,
          onOutputLengthClick: onOutputLengthClick,
          onToneInputRef: onToneInputRef,
          onContextEnabledChange: onContextEnabledChange
        });
      }
    } else {
      menuNode = (0,preact_module.h)(ManageMenu, {
        session: session,
        i18n: manager.editor.plugins.i18n,
        onActionClick: onActionClick,
        onCopyClick: onCopyClick,
        onTryAgainClick: onTryAgainClick,
        onDiscardClick: onDiscardClick,
        onApplyContent: onApplyContent
      });
    }
  }
  var inputPlaceholder = 'Ask Fusebase AI to edit or generate...';
  if (isContinue) {
    inputPlaceholder = 'Tell Fusebase AI what to do next...';
  } else if (contextEnabled) {
    inputPlaceholder = 'Ask Fusebase AI to edit or generate with page context…';
  }
  return (0,preact_module.h)("div", {
    className: "ai-prompt-container",
    style: styles,
    ref: containerRef
  }, (0,preact_module.h)("div", {
    className: "ai-print-content",
    ref: printContentRef
  }), (0,preact_module.h)("div", {
    className: "ai-promt"
  }, (0,preact_module.h)("span", {
    className: 'ai-promt-icon' + (loading ? ' ai-writing' : '')
  }, !loading ? (0,preact_module.h)(icons/* IconPromtIcon */.nST, null) : null), !loading ? (0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)("div", {
    className: "ai-promt-input"
  }, (0,preact_module.h)(react_autosize_textarea_lib/* default */.Z, {
    ref: promtRef,
    onChange: onChange,
    placeholder: inputPlaceholder,
    onKeyDown: onKeyDown
  })), (0,preact_module.h)("button", {
    className: 'ai-promt-enter' + (allowEnter ? ' active' : ''),
    onClick: onEnterClick
  }, (0,preact_module.h)(icons/* IconBackButton */.$fB, null))) : (0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)("div", {
    className: "ai-promt-input"
  }, (0,preact_module.h)("span", {
    className: "ai-promt-input-preffix"
  }, "AI is writing...")), (0,preact_module.h)("button", {
    className: "ai-promt-try-again",
    onClick: onWritingTryAgainClick
  }, "Try again"), (0,preact_module.h)("button", {
    className: "ai-promt-stop",
    onClick: onStopClick
  }, "Stop"))), history && history.length && !loading && !manageContent && session.type === 'custom' ? (0,preact_module.h)("div", {
    className: "ai-user-history"
  }, history.map(function (item) {
    return (0,preact_module.h)("span", {
      className: "ai-history-item",
      onClick: onHistoryItemClick.bind(undefined, item)
    }, item.length > 25 ? item.substring(0, 25) + '...' : item);
  })) : null, !loading && manageContent ? (0,preact_module.h)("div", {
    className: "ai-learn-more"
  }, (0,preact_module.h)(icons/* IconAiHelp */.c3b, null), (0,preact_module.h)("span", {
    className: "ai-learn-more-desc"
  }, "AI responses can be inaccurate or misleading"), (0,preact_module.h)("div", {
    className: "ai-learn-more-links"
  }, (0,preact_module.h)("span", {
    onClick: onLearnMoreClick
  }, "Learn more"), (0,preact_module.h)("span", {
    onClick: onIdeaClick
  }, "Have an idea?"))) : null, menuNode);
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/aiManager/aiSession.js
function aiSession_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function aiSession_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { aiSession_ownKeys(Object(source), true).forEach(function (key) { aiSession_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { aiSession_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function aiSession_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function aiSession_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = aiSession_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function aiSession_toConsumableArray(arr) { return aiSession_arrayWithoutHoles(arr) || aiSession_iterableToArray(arr) || aiSession_unsupportedIterableToArray(arr) || aiSession_nonIterableSpread(); }
function aiSession_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function aiSession_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return aiSession_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return aiSession_arrayLikeToArray(o, minLen); }
function aiSession_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function aiSession_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return aiSession_arrayLikeToArray(arr); }
function aiSession_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function aiSession_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function aiSession_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { aiSession_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { aiSession_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



















function aiSession_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function aiSession_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function aiSession_createClass(Constructor, protoProps, staticProps) { if (protoProps) aiSession_defineProperties(Constructor.prototype, protoProps); if (staticProps) aiSession_defineProperties(Constructor, staticProps); return Constructor; }




/* 
  AiSession types:
  `custom` - рендерится стартовый промт с выбором предустановленных драфтов и историей ввода. Должен монтироваться на пустой блок.
  `range` - с этим типом должны передаваться опции для запроса, рендерится промт и сразу выполняется запрос, согласно переданым опциям.
            Монтируется на последний текстовый блок в выделении со смещением относительно его координат если передана переменная `options.offset`
  `page` - рендерится промт с меню, где будут предлагаться варианты выбора действия Ai для всего контента заметки.
          Должен монтироваться на пустой блок в конце заметки
  `code` - рендерится промт с меню, где будут предлагаться вырианты выбеора действия Ai для блока кода. Должен монтироваться на пустой блок после блока кода
*/
var AiSession = /*#__PURE__*/function () {
  /**
   * AiSession Constructor
   * @param {} params
   * @param {Blot} params.blot
   * @param {Editor} params.editor
   * @param {AiManager} params.manager
   * @param {Object} params.context
   * @param {Object} params.params
   * @param {'custom'|'range'|'page'|'code'} params.params.type
   * @param {Object} params.params.options
   * @param {Object} params.params.options.offset
   * @param {Number} params.params.options.offset.top
   * @param {Number} params.params.options.offset.left
   * @param {String} params.params.options.context
   * @param {String} params.params.options.range
   * @param {Blot[]} params.params.options.blots
   */
  function AiSession(_ref) {
    var blot = _ref.blot,
      editor = _ref.editor,
      manager = _ref.manager,
      context = _ref.context,
      _ref$params = _ref.params,
      params = _ref$params === void 0 ? {} : _ref$params;
    aiSession_classCallCheck(this, AiSession);
    this.blot = blot;
    this.editor = editor;
    this.manager = manager;
    this.content = null;
    this.sessionId = generateId();
    this.context = context || '';
    this.type = params.type || 'custom';
    this.options = params.options || {};
    this.tasks = [];
  }
  aiSession_createClass(AiSession, [{
    key: "getPromtPos",
    value: function getPromtPos() {
      var _getContainerOffset = getContainerOffset(this.blot.domNode, this.editor.editorBody),
        top = _getContainerOffset.y,
        left = _getContainerOffset.x;
      var _this$blot$domNode$ge = this.blot.domNode.getBoundingClientRect(),
        width = _this$blot$domNode$ge.width;
      if (this.options.offset) {
        top += this.options.offset.top;
      }
      top -= 2;
      return {
        top: top,
        left: left,
        width: width
      };
    }
  }, {
    key: "generate",
    value: function generate(_ref2) {
      var _this = this;
      var _ref2$promt = _ref2.promt,
        promt = _ref2$promt === void 0 ? '' : _ref2$promt,
        _ref2$outputLength = _ref2.outputLength,
        outputLength = _ref2$outputLength === void 0 ? 's' : _ref2$outputLength,
        _ref2$voiceTone = _ref2.voiceTone,
        voiceTone = _ref2$voiceTone === void 0 ? '' : _ref2$voiceTone;
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'custom';
      var onMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
      if (this.isRequestActive) {
        return;
      }
      this.isRequestActive = true;
      this.tasks = [];
      var onMessageCb = function onMessageCb(markdown) {
        _this.content.markdown += markdown;
        onMessage(_this.content.markdown);
      };
      return new Promise( /*#__PURE__*/function () {
        var _ref3 = aiSession_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve) {
          var saveContent, _yield$_this$getMessa, ops, tasks, _this$content$ops;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  saveContent = _this.content !== null && action === 'continue';
                  if (saveContent) {
                    _this.content = Object.assign({}, _this.content, {
                      action: action,
                      markdown: _this.content.markdown + '\n'
                    });
                  } else {
                    _this.content = {
                      params: {
                        promt: promt,
                        outputLength: outputLength,
                        voiceTone: voiceTone
                      },
                      action: action === 'continue' ? 'custom' : action,
                      markdown: ''
                    };
                  }
                  _this.getMessageTask = _this.manager.getMessage({
                    sessionId: _this.sessionId,
                    action: action === 'continue' ? 'custom' : action,
                    promt: promt,
                    outputLength: outputLength,
                    voiceTone: voiceTone,
                    onMessage: onMessageCb,
                    context: _this.options.context || _this.context
                  });
                  _context.next = 6;
                  return _this.getMessageTask.run();
                case 6:
                  _yield$_this$getMessa = _context.sent;
                  ops = _yield$_this$getMessa.content;
                  tasks = _yield$_this$getMessa.tasks;
                  _this.tasks = tasks;
                  if (saveContent) {
                    (_this$content$ops = _this.content.ops).push.apply(_this$content$ops, aiSession_toConsumableArray(ops));
                  } else {
                    _this.content.ops = ops;
                  }
                  // дожидаемся рендера и скроллим к целевому блоту, чтобы панель AI была видна вместе с меню
                  setTimeout(function () {
                    _this.editor.plugins.scrollSaver.scrollToBlot(_this.blot.id);
                  }, 0);
                  resolve(true);
                  _this.isRequestActive = false;
                  _context.next = 23;
                  break;
                case 16:
                  _context.prev = 16;
                  _context.t0 = _context["catch"](0);
                  console.error(_context.t0);
                  if (!['AbortError', 'LimitError'].includes(_context.t0.name)) {
                    _this.editor.plugins.notificationManager.toast(_this.editor.plugins.i18n.get('ai_manager.generate_error'));
                  }
                  resolve(true);
                  _this.isRequestActive = false;
                  _this.getMessageTask = null;
                case 23:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 16]]);
        }));
        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "saveContent",
    value: function saveContent() {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        var markdown = _this2.content.markdown;
        if (markdown && markdown.length) {
          _this2.manager.addMessage({
            sessionId: _this2.sessionId,
            markdown: markdown
          }).then(function (ops) {
            _this2.content.ops = ops;
            resolve(true);
          }).catch(function (err) {
            console.error(err);
            reject(err);
          });
        } else {
          reject(new Error('No saved markdown'));
        }
      });
    }
  }, {
    key: "stopGenerate",
    value: function stopGenerate() {
      var clearContent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.getMessageTask) {
        this.getMessageTask.abort();
      }
      if (clearContent) {
        this.content = null;
      }
    }

    /**
     * Get blot id when insert in list
     * @param {Object} params
     * @param {Blot} params.blot
     * @param {'before'|'after'} params.pos
     * @returns 
     */
  }, {
    key: "getBlotIdOnInsertInList",
    value: function getBlotIdOnInsertInList(_ref4) {
      var blot = _ref4.blot,
        pos = _ref4.pos;
      var blotId;
      if (!blot.next && pos === 'after' || !blot.prev && pos === 'before') {
        blotId = blot.container.id;
      } else {
        var index = pos === 'before' ? blot.index - 1 : blot.index;
        var _blot$container$split = blot.container.splitWithBlot(index),
          addedBlotId = _blot$container$split.id;
        blotId = addedBlotId;
      }
      return blotId;
    }
  }, {
    key: "applyContent",
    value: function applyContent() {
      var _this3 = this;
      var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'before';
      var ops = this.content.ops;
      if (pos === 'replace' && this.options.range) {
        this.restoreRange();
        if (ops[0].type === 'paragraph') {
          ops[0].type = 'textLine';
        }
        this.manager.editor.plugins.pasteManager.pasteNimbusOps(ops);
      } else {
        var pasteParams = {
          pos: pos
        };
        var blotId = this.blot.id;
        if (this.type === 'range' && this.options.blots.length) {
          if (pos === 'before') {
            blotId = Object.keys(this.options.blots[0])[0];
          }
        } else if (this.type === 'page') {
          if (pos === 'before') {
            blotId = this.manager.editor.scroll.children.head.id;
          }
        }
        var blot = this.manager.editor.findById(blotId);
        if (blot.isListItem) {
          blotId = this.getBlotIdOnInsertInList({
            blot: blot,
            pos: pos
          });
        }
        var container = this.manager.editor.findById(blotId).container;
        pasteParams.id = blotId;
        var _iterator = aiSession_createForOfIteratorHelper(ops),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var op = _step.value;
            if (op.initParams) {
              var _container$addBlot = container.addBlot(op.type, Object.assign({}, op.initParams, aiSession_defineProperty({}, pasteParams.pos, pasteParams.id))),
                id = _container$addBlot.id;
              if (pasteParams.pos === 'after') {
                pasteParams.id = id;
              }
            } else {
              var _container$addBlot2 = container.addBlot(op.type, Object.assign({}, op, aiSession_defineProperty({}, pasteParams.pos, pasteParams.id))),
                _id = _container$addBlot2.id;
              if (pasteParams.pos === 'after') {
                pasteParams.id = _id;
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      if (this.type === 'page' || this.type === 'range') {
        this.manager.hide();
      } else {
        this.content = null;
        setTimeout(function () {
          _this3.manager.render(true);
        }, 0);
      }
    }

    /**
     * Insert a task list below the current blot
     * @returns 
     */
  }, {
    key: "insertTaskList",
    value: function () {
      var _insertTaskList = aiSession_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var blotId, container, aiManager, list, _yield$aiManager$opti, taskListId;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.manager.options.createTasks) {
                  _context2.next = 3;
                  break;
                }
                console.log('createTasks method is not defined');
                return _context2.abrupt("return");
              case 3:
                if (this.tasks.length) {
                  _context2.next = 6;
                  break;
                }
                console.log('tasks is empty');
                return _context2.abrupt("return");
              case 6:
                blotId = this.blot.id;
                if (this.blot.isListItem) {
                  blotId = this.getBlotIdOnInsertInList({
                    blot: this.blot,
                    pos: 'after'
                  });
                }
                container = this.manager.editor.findById(blotId).container;
                aiManager = this.manager;
                aiManager.hide();
                _context2.prev = 11;
                list = this.tasks.map(function (item) {
                  return deltaToString(item.params.delta);
                }).filter(function (item) {
                  return item.trim();
                });
                if (!list.length) {
                  _context2.next = 19;
                  break;
                }
                _context2.next = 16;
                return aiManager.options.createTasks(list);
              case 16:
                _yield$aiManager$opti = _context2.sent;
                taskListId = _yield$aiManager$opti.taskListId;
                container.addBlot('tasks-list', {
                  tasksListId: taskListId,
                  after: blotId
                });
              case 19:
                _context2.next = 24;
                break;
              case 21:
                _context2.prev = 21;
                _context2.t0 = _context2["catch"](11);
                console.log("can't insert task list", _context2.t0);
              case 24:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[11, 21]]);
      }));
      function insertTaskList() {
        return _insertTaskList.apply(this, arguments);
      }
      return insertTaskList;
    }() /**
         * Insert a checkbox list below the current blot
         */
  }, {
    key: "insertCheckboxList",
    value: function insertCheckboxList() {
      var blotId = this.blot.id;
      if (this.blot.isListItem) {
        blotId = this.getBlotIdOnInsertInList({
          blot: this.blot,
          pos: 'after'
        });
      }
      var container = this.manager.editor.findById(blotId).container;
      container.addBlot('list', {
        items: this.tasks.map(function (item) {
          return aiSession_objectSpread(aiSession_objectSpread({}, item), {}, {
            type: 'listItemCheckbox'
          });
        }),
        after: blotId
      });
      this.manager.hide();
    }
  }, {
    key: "restoreRange",
    value: function restoreRange() {
      if (this.type === 'page') {
        this.manager.editor.scroll.selection.setRange({
          index: 0,
          length: this.manager.editor.scroll.length() - 1
        }, true);
      } else if (this.type === 'range' && this.options.range) {
        this.manager.editor.scroll.selection.setRange(this.options.range, true);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.stopGenerate();
      this.blot = null;
      this.editor = null;
      this.manager = null;
      this.content = null;
    }
  }]);
  return AiSession;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/aiManager/aiHideDialog.js






function AiHideDialog(props) {
  var editor = props.editor,
    wantsToClose = props.wantsToClose;
  var i18n = editor.plugins.i18n;
  var onAccept = function onAccept(event) {
    event.preventDefault();
    event.stopPropagation();
    var onAction = props.onAction,
      wantsToClose = props.wantsToClose;
    onAction && onAction();
    wantsToClose && wantsToClose();
  };
  var onCancel = function onCancel() {
    var onCancel = props.onCancel;
    onCancel && onCancel();
  };
  return (0,preact_module.h)(popupMenu/* default */.Z, {
    wantsToClose: wantsToClose,
    addClassName: "hide-ai-popup",
    closeOnEsc: true
  }, (0,preact_module.h)(popupDialog/* default */.Z, {
    wantsToClose: wantsToClose,
    addClassName: 'reduced-padding',
    noCloseButton: true
  }, (0,preact_module.h)(popupDialogTitle/* default */.Z, null, i18n.get('ai_manager.dialog.title')), (0,preact_module.h)(popupDialogBody/* default */.Z, {
    style: {
      'max-width': '520px'
    }
  }, (0,preact_module.h)("p", null, (0,preact_module.h)("span", null, i18n.get('ai_manager.dialog.body')))), (0,preact_module.h)(popupDialogButtons/* default */.Z, {
    editor: editor,
    wantsToClose: wantsToClose,
    buttons: {
      cancel: {
        onClick: onCancel
      },
      accept: {
        text: i18n.get('ai_manager.dialog.accept'),
        style: 'active',
        onClick: onAccept
      }
    }
  })));
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/aiManager/index.js
function aiManager_slicedToArray(arr, i) { return aiManager_arrayWithHoles(arr) || aiManager_iterableToArrayLimit(arr, i) || aiManager_unsupportedIterableToArray(arr, i) || aiManager_nonIterableRest(); }
function aiManager_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function aiManager_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return aiManager_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return aiManager_arrayLikeToArray(o, minLen); }
function aiManager_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function aiManager_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function aiManager_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



















function aiManager_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function aiManager_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { aiManager_ownKeys(Object(source), true).forEach(function (key) { aiManager_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { aiManager_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function aiManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function aiManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function aiManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) aiManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) aiManager_defineProperties(Constructor, staticProps); return Constructor; }
function aiManager_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var aiManager_isEscKey = (0,lib/* default */.ZP)('Esc');
var LOCAL_STORAGE_KEY = 'nimbus-ai';
var aiManagerDefaultSettings = {
  contextEnabled: true
};
var AiManager = /*#__PURE__*/function () {
  function AiManager(_ref) {
    var _this = this;
    var editor = _ref.editor,
      scroll = _ref.scroll,
      _ref$options = _ref.options,
      _options = _ref$options === void 0 ? {} : _ref$options;
    aiManager_classCallCheck(this, AiManager);
    aiManager_defineProperty(this, "onEditorUpdate", function () {
      if (_this.session && !_this.scroll.domNode.contains(_this.session.blot.domNode)) {
        _this.hide();
      } else {
        _this.render(true);
      }
    });
    aiManager_defineProperty(this, "onDocumentKeyDown", function (event) {
      if (aiManager_isEscKey(event)) {
        _this.onWantsToClose(true);
      }
    });
    aiManager_defineProperty(this, "onDocumentMouseDown", function (event) {
      if (_this.isRequestActive) return;
      if (_this.promtContainerRef) {
        if (!_this.promtContainerRef.contains(event.target)) {
          if (!_this.scroll.domNode.contains(event.target)) {
            _this.onWantsToClose(true);
          } else {
            _this.onWantsToClose();
          }
        } else if (event.target === _this.promtContainerRef) {
          event.preventDefault();
          event.stopPropagation();
          _this.onWantsToClose(true);
        }
      } else {
        if (!_this.container.contains(event.target)) {
          _this.onWantsToClose();
        }
      }
    });
    aiManager_defineProperty(this, "onLearnMoreClick", function () {
      try {
        if (_this.options.learnMoreUrl) {
          window.open(_this.options.learnMoreUrl, '_blank', 'noopener');
        } else {
          throw new Error();
        }
      } catch (err) {
        _this.editor.plugins.notificationManager.toast(_this.editor.plugins.i18n.get('ai_manager.unknown_error'));
      }
    });
    aiManager_defineProperty(this, "onIdeaClick", function () {
      try {
        if (_this.options.haveAnIdeaUrl) {
          window.open(_this.options.haveAnIdeaUrl, '_blank', 'noopener');
        } else {
          throw new Error();
        }
      } catch (err) {
        _this.editor.plugins.notificationManager.toast(_this.editor.plugins.i18n.get('ai_manager.unknown_error'));
      }
    });
    aiManager_defineProperty(this, "onPromtContainerRef", function (node) {
      _this.promtContainerRef = node;
    });
    aiManager_defineProperty(this, "onPromtInputRef", function (node) {
      _this.promtInputRef = node;
    });
    aiManager_defineProperty(this, "onContextEnabledChange", function (enabled) {
      _this.aiManagerSettings.contextEnabled = enabled;
      var blot = _this.session.blot;
      var context = enabled ? _this.editor.scroll.getMarkdown() : '';
      var params = {
        type: _this.session.type || 'custom'
      };
      var options = aiManager_objectSpread(aiManager_objectSpread({}, _this.session.options || {}), {}, {
        context: context
      });
      var content = _this.session.content;

      // When contextEnabled was changed, we need to reinit session because ai-service remember context
      // even if we send empty context
      _this.session = new AiSession({
        blot: blot,
        editor: _this.editor,
        manager: _this,
        params: params
      });
      _this.session.context = context;
      _this.session.options = options;
      _this.session.content = content;
      _this.render(true); // have to rerender AiPluginComponent
      _this.saveLocalStorage();
    });
    this.editor = editor;
    this.scroll = scroll;
    this.options = _options;
    this.enabled = this.options.enabled;
    this.aiManagerSettings = aiManagerDefaultSettings;
    this.loadLocalStorage();
  }
  aiManager_createClass(AiManager, [{
    key: "initContainer",
    value: function initContainer() {
      var node = document.createElement('div');
      node.id = 'nedit-ai-plugin-container';
      this.editor.editorBody.appendChild(node);
      return node;
    }
  }, {
    key: "isRequestActive",
    get: function get() {
      return Boolean(this.session) && this.session.isRequestActive;
    }
  }, {
    key: "isVisible",
    get: function get() {
      return Boolean(this.session);
    }
  }, {
    key: "addUserHistoryLocal",
    value: function addUserHistoryLocal(value) {
      var localSaved = localStorage.getItem('nimbus-ai-history');
      if (localSaved) {
        var history = JSON.parse(localSaved);
        if (history.includes(value)) {
          var index = history.indexOf(value);
          if (index !== 0) {
            history.splice(index, 1);
            history.unshift(value);
          }
        } else {
          if (history.length >= 5) {
            history.pop();
          }
          history.unshift(value);
        }
        localStorage.setItem('nimbus-ai-history', JSON.stringify(history));
      } else {
        var _history = [value];
        localStorage.setItem('nimbus-ai-history', JSON.stringify(_history));
      }
    }
  }, {
    key: "getUserHistory",
    value: function getUserHistory() {
      if (this.options.getUserHistory) {
        return this.options.getUserHistory();
      }
      var localSaved = localStorage.getItem('nimbus-ai-history');
      if (localSaved) {
        return JSON.parse(localSaved);
      }
    }
  }, {
    key: "onWantsToClose",
    value: function onWantsToClose() {
      var _this2 = this;
      var focusTarget = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _this$scroll$selectio = this.scroll.selection.getRange(),
        _this$scroll$selectio2 = aiManager_slicedToArray(_this$scroll$selectio, 1),
        range = _this$scroll$selectio2[0];
      if (this.promtInputRef && this.promtInputRef.value) {
        var onAction = function onAction() {
          _this2.hide(focusTarget);
          if (!focusTarget) {
            setTimeout(function () {
              _this2.scroll.selection.setRange(range);
            }, 0);
          }
        };
        this.editor.plugins.popupManager.dialog((0,preact_module.h)(AiHideDialog, {
          editor: this.editor,
          onAction: onAction,
          onCancel: function onCancel() {
            _this2.promtInputRef.focus();
          }
        }));
      } else if (this.session && this.session.content && this.session.content.ops) {
        var _onAction = function _onAction() {
          _this2.hide(focusTarget);
        };
        this.editor.plugins.popupManager.dialog((0,preact_module.h)(AiHideDialog, {
          editor: this.editor,
          onAction: _onAction
        }));
      } else {
        this.hide(focusTarget);
      }
    }
  }, {
    key: "getMessage",
    value: function getMessage(params) {
      if (this.options.getMessage) {
        return this.options.getMessage(params);
      }
    }
  }, {
    key: "addMessage",
    value: function addMessage(params) {
      if (this.options.addMessage) {
        return this.options.addMessage(params);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var onRendered = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      var component = null;
      if (show && this.session) {
        var pos = this.session.getPromtPos();
        component = (0,preact_module.h)(AiPluginComponent, {
          manager: this,
          session: this.session,
          pos: pos,
          draftsEnabled: true,
          contextEnabled: this.aiManagerSettings.contextEnabled,
          onPromtContainerRef: this.onPromtContainerRef,
          onPromtInputRef: this.onPromtInputRef,
          onRendered: onRendered,
          onContextEnabledChange: this.onContextEnabledChange
        });
      }
      (0,preact_module/* render */.sY)(component, this.container);
    }
  }, {
    key: "show",
    value: function show(blot) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.session = new AiSession({
        blot: blot,
        editor: this.editor,
        manager: this,
        params: params
      });
      if (this.aiManagerSettings.contextEnabled || this.session.type !== 'custom') {
        this.session.context = this.editor.scroll.getMarkdown();
      }
      if (!this.container) {
        this.container = this.initContainer();
      }
      this.editor.emit('editorUpdate');
      this.render(true, params.onRendered);
      this.editor.on('editorUpdate', this.onEditorUpdate);
      document.addEventListener('keydown', this.onDocumentKeyDown, false);
      document.addEventListener('mousedown', this.onDocumentMouseDown, false);
    }
  }, {
    key: "hide",
    value: function hide() {
      var focusTarget = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var blot = this.session.blot;
      this.session.clear();
      this.session = null;
      this.editor.off('editorUpdate', this.onEditorUpdate);
      document.removeEventListener('keydown', this.onDocumentKeyDown, false);
      document.removeEventListener('mousedown', this.onDocumentMouseDown, false);
      this.editor.emit('editorUpdate');
      this.render();
      if (focusTarget) {
        this.editor.scroll.selection.setRange({
          index: blot.offset(this.scroll),
          length: 0
        });
      }
    }

    /**
     * Show the prompt for the current page
     */
  }, {
    key: "promptForPage",
    value: function promptForPage() {
      var _this3 = this;
      var scroll = this.editor.scroll;
      var tail = scroll.children.tail;
      var blot;
      if (tail && tail.getBlotName() === 'paragraph' && tail.isEmpty()) {
        blot = tail;
      } else {
        scroll.addBlot('paragraph', {
          after: tail === null || tail === void 0 ? void 0 : tail.id
        });
        blot = scroll.children.tail;
      }
      this.show(blot, {
        type: this.editor.scroll.getMarkdown().trim() ? 'page' : 'custom',
        onRendered: function onRendered() {
          _this3.editor.plugins.floatingToolbar.ignoreSelectionChangeUpdates = true; // ignore show floating toolbar
          //scroll.selection.setRange({index: 0, length: scroll.length() - 1}, true)
          setTimeout(function () {
            _this3.editor.plugins.scrollSaver.scrollToBlot(blot.id);
            _this3.promtInputRef && _this3.promtInputRef.focus();
          }, 0);
        }
      });
    }

    /**
     * Load plugin setting from local storage
     */
  }, {
    key: "loadLocalStorage",
    value: function loadLocalStorage() {
      var _localStorage;
      var localSaved = (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem(LOCAL_STORAGE_KEY);
      if (localSaved) {
        this.aiManagerSettings = JSON.parse(localSaved || '{}');
      }
    }

    /**
     * Save plugin setting to local storage
     */
  }, {
    key: "saveLocalStorage",
    value: function saveLocalStorage() {
      var _localStorage2;
      (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.setItem(LOCAL_STORAGE_KEY, JSON.stringify(this.aiManagerSettings));
    }
  }]);
  return AiManager;
}();

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.weak-map.js
var es_weak_map = __webpack_require__(4129);
;// CONCATENATED MODULE: ./node_modules/@grammarly/editor-sdk/lib/index.esm.js

function index_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function index_esm_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { index_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { index_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function index_esm_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { index_esm_typeof = function _typeof(obj) { return typeof obj; }; } else { index_esm_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return index_esm_typeof(obj); }
function index_esm_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function index_esm_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function index_esm_createClass(Constructor, protoProps, staticProps) { if (protoProps) index_esm_defineProperties(Constructor.prototype, protoProps); if (staticProps) index_esm_defineProperties(Constructor, staticProps); return Constructor; }
function index_esm_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) index_esm_setPrototypeOf(subClass, superClass); }
function index_esm_createSuper(Derived) { var hasNativeReflectConstruct = index_esm_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = index_esm_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = index_esm_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return index_esm_possibleConstructorReturn(this, result); }; }
function index_esm_possibleConstructorReturn(self, call) { if (call && (index_esm_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return index_esm_assertThisInitialized(self); }
function index_esm_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function index_esm_wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; index_esm_wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !index_esm_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return index_esm_construct(Class, arguments, index_esm_getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return index_esm_setPrototypeOf(Wrapper, Class); }; return index_esm_wrapNativeSuper(Class); }
function index_esm_construct(Parent, args, Class) { if (index_esm_isNativeReflectConstruct()) { index_esm_construct = Reflect.construct; } else { index_esm_construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) index_esm_setPrototypeOf(instance, Class.prototype); return instance; }; } return index_esm_construct.apply(null, arguments); }
function index_esm_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function index_esm_isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function index_esm_setPrototypeOf(o, p) { index_esm_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return index_esm_setPrototypeOf(o, p); }
function index_esm_getPrototypeOf(o) { index_esm_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return index_esm_getPrototypeOf(o); }





















/**
 * @license
 * (c) Copyright 2023 Grammarly, Inc.
 * 
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * 
 *     http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function t(t, n, r) {
  return n in t ? Object.defineProperty(t, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[n] = r, t;
}
var n = new Map();
var r = /*#__PURE__*/function (_Error) {
  index_esm_inherits(r, _Error);
  var _super = index_esm_createSuper(r);
  function r(n, _r) {
    var _this;
    index_esm_classCallCheck(this, r);
    _this = _super.call(this), t(index_esm_assertThisInitialized(_this), "args", void 0), t(index_esm_assertThisInitialized(_this), "code", void 0), t(index_esm_assertThisInitialized(_this), "url", void 0), t(index_esm_assertThisInitialized(_this), "_c", void 0);
    var e = new URL("https://developer.grammarly.com/docs/error-explainer");
    e.searchParams.set("code", n.toString()), _r.forEach(function (t) {
      return e.searchParams.append("args", function (t) {
        if (t instanceof Error) return t.message + "\n" + String(t.stack);
        if (null == t) return "null";
        if ("object" == index_esm_typeof(t)) try {
          return Object.prototype.toString.call(t);
        } catch (t) {}
        return String(t);
      }(t));
    }), null != _this.stack && e.searchParams.set("trace", _this.stack), _this.message = "Minified error #".concat(n, ": See ").concat(e.toString(), " for details."), _this.args = _r, _this.code = n, _this.url = e.toString();
    return _this;
  }
  index_esm_createClass(r, [{
    key: "toUserMessage",
    value: function toUserMessage() {
      var t = n.get("".concat(this.code));
      if (null == t) return [this];
      var _r2 = new Map(this.args.map(function (t, n) {
          return ["${".concat(n, "}"), t];
        })),
        e = t.split(/(\${\d+})/).filter(function (t) {
          return "" !== t;
        });
      return e.map(function (t) {
        var n;
        return null !== (n = _r2.get(t)) && void 0 !== n ? n : t;
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        name: "InvariantError",
        message: this.message,
        description: this._m,
        code: this.code,
        args: this.args,
        stack: this.stack
      };
    }
  }], [{
    key: "setMessages",
    value: function setMessages(t) {
      n = t;
    }
  }, {
    key: "create",
    value: function create(t, n, e, a) {
      null != a && n.push(a);
      var o = new r(t, n, e);
      return o.stack = null == a ? void 0 : a.stack, o._m = e, o;
    }
  }]);
  return r;
}( /*#__PURE__*/index_esm_wrapNativeSuper(Error));
var e = new WeakMap();
function a(_x, _x2) {
  return _a.apply(this, arguments);
}
function _a() {
  _a = index_esm_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(t, n) {
    var a, o;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            a = e.get(t);
            if (!(null != a)) {
              _context.next = 5;
              break;
            }
            _context.next = 4;
            return a;
          case 4:
            return _context.abrupt("return", _context.sent);
          case 5:
            !function (t) {
              null == t.Grammarly && (t.Grammarly = {});
            }(t);
            o = new Promise(function (e, a) {
              try {
                var _e = function (t, n) {
                  return t.document.querySelectorAll("script[src^=\"".concat(n.replace(/\?.*$/, ""), "\"]"))[0];
                }(t, n);
                null != _e ? o() : (_e = function (t, n) {
                  var r = t.document.createElement("script");
                  return r.src = n, t.document.head.appendChild(r), r;
                }(t, n), _e.addEventListener("load", o), _e.addEventListener("error", function () {
                  try {
                    throw new r(23, []);
                  } catch (t) {
                    a(t);
                  }
                }));
              } catch (t) {
                return a(t);
              }
              function o() {
                try {
                  if (null == t.Grammarly || "function" != typeof t.Grammarly.EditorSDK) throw new r(22, []);
                  e(t.Grammarly);
                } catch (t) {
                  a(t);
                }
              }
            });
            e.set(t, o);
            _context.next = 10;
            return o;
          case 10:
            return _context.abrupt("return", _context.sent);
          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _a.apply(this, arguments);
}
function o(_x3, _x4, _x5) {
  return _o.apply(this, arguments);
}
function _o() {
  _o = index_esm_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(t, n, r) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return s("@grammarly/editor-sdk", t, n, r);
          case 2:
            return _context2.abrupt("return", _context2.sent);
          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _o.apply(this, arguments);
}
function s(_x6, _x7, _x8, _x9) {
  return _s.apply(this, arguments);
}
function _s() {
  _s = index_esm_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(t, n, e, o) {
    var s, i, c;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!("undefined" == typeof window && void 0 === o)) {
              _context3.next = 2;
              break;
            }
            throw new r(21, []);
          case 2:
            s = function (t) {
              return "null" !== t.location.origin ? t.location.origin : "null" !== t.origin ? t.origin : "null";
            }(null != o ? o : window);
            "null" === s && (null != o ? o : window).top !== (null != o ? o : window) && console.warn("Grammarly is not supported in IFrames with `null` origin. Consider adding `sandbox='allow-same-origin allow-scripts'` to <iframe> element.");
            i = new URL("https://js.grammarly.com/grammarly-editor-sdk@2.4", s);
            null != n && i.searchParams.set("clientId", n), i.searchParams.set("packageName", t);
            _context3.next = 8;
            return a(null != o ? o : window, i.toString());
          case 8:
            c = _context3.sent;
            if (!(null != n)) {
              _context3.next = 11;
              break;
            }
            return _context3.abrupt("return", new c.EditorSDK(n, e));
          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _s.apply(this, arguments);
}
var i = {
  onBeforeSuggestionCardOpen: "before-suggestion-card-open",
  onSuggestionCardOpen: "suggestion-card-open",
  onSuggestionCardClose: "suggestion-card-close",
  onSuggestionCardAction: "suggestion-card-action",
  onPluginTurnedOff: "plugin-turned-off",
  onPluginError: "plugin-error",
  onDocumentStats: "document-stats",
  onSessionStats: "session-stats"
};

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/grammarlyManager/index.js

function grammarlyManager_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function grammarlyManager_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { grammarlyManager_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { grammarlyManager_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }


function grammarlyManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function grammarlyManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function grammarlyManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) grammarlyManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) grammarlyManager_defineProperties(Constructor, staticProps); return Constructor; }

var grammarlyManager_DEFAULT_OPTIONS = {
  enabled: false
};
var GrammarlyManager = /*#__PURE__*/function () {
  function GrammarlyManager(_ref) {
    var _this = this;
    var editor = _ref.editor,
      scroll = _ref.scroll,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;
    grammarlyManager_classCallCheck(this, GrammarlyManager);
    this.editor = editor;
    this.scroll = scroll;
    this.options = Object.assign({}, grammarlyManager_DEFAULT_OPTIONS, options);
    this.enabled = this.options.enabled && this.options.apiKey;
    if (this.options.connectOnDefault) {
      this.editor.once('editor-ready', /*#__PURE__*/grammarlyManager_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.initPlugin();
              case 2:
                _this.instance = _context.sent;
                if (_this.instance) {
                  _this.connect();
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
  grammarlyManager_createClass(GrammarlyManager, [{
    key: "isConnected",
    get: function get() {
      return Boolean(this.pluginElement);
    }
  }, {
    key: "initPlugin",
    value: function initPlugin() {
      var _this2 = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref3 = grammarlyManager_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(resolve) {
          var instance;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!_this2.enabled) {
                    _context2.next = 14;
                    break;
                  }
                  _context2.prev = 1;
                  _context2.next = 4;
                  return o(_this2.options.apiKey);
                case 4:
                  instance = _context2.sent;
                  resolve(instance);
                  _context2.next = 12;
                  break;
                case 8:
                  _context2.prev = 8;
                  _context2.t0 = _context2["catch"](1);
                  console.error(_context2.t0);
                  resolve(false);
                case 12:
                  _context2.next = 15;
                  break;
                case 14:
                  resolve(false);
                case 15:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[1, 8]]);
        }));
        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "connect",
    value: function () {
      var _connect = grammarlyManager_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.instance) {
                  _context3.next = 4;
                  break;
                }
                _context3.next = 3;
                return this.initPlugin();
              case 3:
                this.instance = _context3.sent;
              case 4:
                if (this.instance) {
                  this.pluginElement = this.instance.addPlugin(this.scroll.domNode, {
                    documentDialect: 'british'
                  });
                }
              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function connect() {
        return _connect.apply(this, arguments);
      }
      return connect;
    }()
  }, {
    key: "disconnect",
    value: function disconnect() {
      this.pluginElement && this.pluginElement.disconnect();
      this.pluginElement = null;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.disconnect();
    }
  }]);
  return GrammarlyManager;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/editorRate/index.js

function editorRate_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function editorRate_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function editorRate_createClass(Constructor, protoProps, staticProps) { if (protoProps) editorRate_defineProperties(Constructor.prototype, protoProps); if (staticProps) editorRate_defineProperties(Constructor, staticProps); return Constructor; }
var RATE_EDITOR_LOCALSTORAGE_KEY = 'editor_rate_editor';
var EditorRate = /*#__PURE__*/function () {
  function EditorRate(_ref) {
    var scroll = _ref.scroll,
      editor = _ref.editor,
      options = _ref.options;
    editorRate_classCallCheck(this, EditorRate);
    this.options = Object.assign({
      enabled: false
    }, options);
    this.scroll = scroll;
    this.editor = editor;
  }
  editorRate_createClass(EditorRate, [{
    key: "isEnabled",
    value: function isEnabled() {
      return this.options.enabled;
    }
  }, {
    key: "setEditorRated",
    value: function setEditorRated() {
      localStorage.setItem(RATE_EDITOR_LOCALSTORAGE_KEY, 'true');
    }
  }, {
    key: "isEditorRated",
    value: function isEditorRated() {
      return localStorage.getItem(RATE_EDITOR_LOCALSTORAGE_KEY) === 'true';
    }
  }, {
    key: "onRateEditorClick",
    value: function onRateEditorClick() {
      this.options.onRateEditorClick();
    }
  }]);
  return EditorRate;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/changeButton/index.js


function changeButton_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function changeButton_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function changeButton_createClass(Constructor, protoProps, staticProps) { if (protoProps) changeButton_defineProperties(Constructor.prototype, protoProps); if (staticProps) changeButton_defineProperties(Constructor, staticProps); return Constructor; }
function changeButton_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var changeButton_DEFAULT_OPTIONS = {
  enabled: false,
  panelClassNames: 'change-button-panel',
  undoClassNames: 'change-panel-undo',
  redoClassNames: 'change-panel-redo',
  editClassNames: 'change-edit-button',
  eyeClassNames: 'change-button-eye',
  editButtonText: 'Enable client’s editing'
};
var ChangeButton = /*#__PURE__*/function () {
  function ChangeButton(_ref) {
    var _this = this;
    var editor = _ref.editor,
      scroll = _ref.scroll,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;
    changeButton_classCallCheck(this, ChangeButton);
    changeButton_defineProperty(this, "onUndoClick", function (event) {
      _this.editor.exec('undo');
    });
    changeButton_defineProperty(this, "onRedoClick", function (event) {
      _this.editor.exec('redo');
    });
    changeButton_defineProperty(this, "onEditClick", function (event) {
      if (_this.options.onEditClick && _this.options.onEditClick(_this.editor)) return;
      var editMode = _this.editor.mode === MODE_EDIT;
      _this.editor.emit('reinit-editor', {
        mode: editMode ? 'readonly' : 'edit'
      });
    });
    this.editor = editor;
    this.scroll = scroll;
    this.options = Object.assign({}, changeButton_DEFAULT_OPTIONS, options);
    this.container = this.init();
    this.render();
  }
  changeButton_createClass(ChangeButton, [{
    key: "init",
    value: function init() {
      var container = document.createElement('div');
      container.id = 'editor-change-button';
      this.editor.editorBody.appendChild(container);
      return container;
    }
  }, {
    key: "setOption",
    value: function setOption(key, value) {
      this.options = Object.assign({}, this.options, changeButton_defineProperty({}, key, value));
      this.render();
    }
  }, {
    key: "setOptions",
    value: function setOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.options = Object.assign({}, this.options, options);
      this.render();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$options = this.options,
        enabled = _this$options.enabled,
        panelClassNames = _this$options.panelClassNames,
        undoClassNames = _this$options.undoClassNames,
        redoClassNames = _this$options.redoClassNames,
        editClassNames = _this$options.editClassNames,
        _this$options$showEye = _this$options.showEyeIcon,
        showEyeIcon = _this$options$showEye === void 0 ? false : _this$options$showEye,
        _this$options$eyeIcon = _this$options.eyeIconClosed,
        eyeIconClosed = _this$options$eyeIcon === void 0 ? true : _this$options$eyeIcon,
        eyeClassNames = _this$options.eyeClassNames,
        editButtonText = _this$options.editButtonText;
      var editMode = this.editor.mode === MODE_EDIT;
      (0,preact_module/* render */.sY)(enabled ? (0,preact_module.h)("div", {
        className: 'change-button-panel-sticky ' + panelClassNames
      }, editMode ? (0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)("button", {
        className: undoClassNames,
        onClick: this.onUndoClick
      }, (0,preact_module.h)(icons/* IconUndo */.WL1, null)), (0,preact_module.h)("button", {
        className: 'change-panel-button-reversed ' + redoClassNames,
        onClick: this.onRedoClick
      }, (0,preact_module.h)(icons/* IconRedo */.M1S, null))) : null, showEyeIcon ? (0,preact_module.h)("span", {
        className: eyeClassNames,
        onClick: this.onEditClick
      }, eyeIconClosed ? (0,preact_module.h)(icons/* IconEyeClosed */.SMA, null) : (0,preact_module.h)(icons/* IconEyeOpen */.kyG, null)) : null, (0,preact_module.h)("button", {
        className: editClassNames,
        onClick: this.onEditClick
      }, !editMode ? (0,preact_module.h)(preact_module/* Fragment */.HY, null, (0,preact_module.h)(icons/* IconPencil */.TRY, null), " ", editButtonText) : 'Done')) : null, this.container);
    }
  }]);
  return ChangeButton;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/selectionManager/selectionSession.js

function selectionSession_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function selectionSession_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function selectionSession_createClass(Constructor, protoProps, staticProps) { if (protoProps) selectionSession_defineProperties(Constructor.prototype, protoProps); if (staticProps) selectionSession_defineProperties(Constructor, staticProps); return Constructor; }
var OVERLAY_STYLES = {
  overlay: {
    willChange: 'top, left, bottom, right, width, height',
    top: 0,
    left: 0,
    position: 'absolute',
    backgroundColor: '#00A1B7',
    // цвета в палитре нет
    opacity: '0.15'
  },
  overlayContainer: {
    overflow: 'hidden',
    position: 'fixed',
    pointerEvents: 'none',
    transform: 'translate3d(0, 0, 0)',
    zIndex: '1'
  }
};
function applyStyles(node) {
  var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  for (var key in styles) {
    if (typeof styles[key] === 'number') {
      node.style[key] = styles[key] + 'px';
    } else {
      node.style[key] = styles[key];
    }
  }
}
var SelectionSession = /*#__PURE__*/function () {
  function SelectionSession(params) {
    selectionSession_classCallCheck(this, SelectionSession);
    this.scroll = params.scroll;
    this.editor = params.editor;
    this.scrollingContainer = params.scrollingContainer || this.editor.getScrollingContainer();
    this.initCursorPosition = null;
    this.cursorPosition = null;
    this.scrollPosition = null;
  }
  selectionSession_createClass(SelectionSession, [{
    key: "setCursorPosition",
    value: function setCursorPosition(x, y) {
      this.cursorPosition = Object.freeze({
        x: x,
        y: y
      });
      this._drawOverlay();
    }
  }, {
    key: "setInitCursorPosition",
    value: function setInitCursorPosition(x, y) {
      this.initCursorPosition = Object.freeze({
        x: x,
        y: y
      });
    }
  }, {
    key: "setScrollPosition",
    value: function setScrollPosition(left, top) {
      this.scrollPosition = Object.freeze({
        left: left,
        top: top
      });
      this._drawOverlay();
    }
  }, {
    key: "_createOverlay",
    value: function _createOverlay() {
      var node = document.createElement('div');
      node.classList.add('nedit-selection-overlay');
      this._overlay = document.createElement('div');
      node.appendChild(this._overlay);
      return node;
    }
  }, {
    key: "_drawOverlay",
    value: function _drawOverlay() {
      if (!this._overlayContainer) {
        this._overlayContainer = this._createOverlay();
        // initial styles for overlay nodes
        applyStyles(this._overlayContainer, OVERLAY_STYLES.overlayContainer);
        applyStyles(this._overlay, OVERLAY_STYLES.overlay);
        var containerRect = this.scrollingContainer.getBoundingClientRect();
        // дополнительные стили контейнера для оверлея
        var cStyles = {
          top: containerRect.top,
          left: containerRect.left,
          width: containerRect.width,
          height: containerRect.height
        };
        applyStyles(this._overlayContainer, cStyles);
        // дополнительные стили оверлея
        var oStyles = {
          marginTop: -containerRect.top,
          marginLeft: -containerRect.left
        };
        applyStyles(this._overlay, oStyles);
        this.editor.container.appendChild(this._overlayContainer);
      }
      // redraw overlay
      var styles = {
        top: Math.min(this.initCursorPosition.y, this.cursorPosition.y),
        left: Math.min(this.initCursorPosition.x, this.cursorPosition.x),
        width: Math.max(this.initCursorPosition.x, this.cursorPosition.x) - Math.min(this.initCursorPosition.x, this.cursorPosition.x),
        height: Math.max(this.initCursorPosition.y, this.cursorPosition.y) - Math.min(this.initCursorPosition.y, this.cursorPosition.y)
      };
      applyStyles(this._overlay, styles);
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      if (this._overlayContainer) {
        var container = this._overlayContainer;
        this._overlayContainer = null;
        this._overlay = null;
        container.parentNode.removeChild(container);
      }
    }
  }]);
  return SelectionSession;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/selectionManager/index.js



function selectionManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function selectionManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function selectionManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) selectionManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) selectionManager_defineProperties(Constructor, staticProps); return Constructor; }
function selectionManager_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var COLUMN_SELECTION_FIX_ATTR = 'nedit-fix-column-selection';
var selectionManager_DEFAULT_OPTIONS = {
  enabled: true,
  webkitEnableFixColumnSelection: true
};
var SelectionManager = /*#__PURE__*/function () {
  function SelectionManager(_ref) {
    var _this = this;
    var editor = _ref.editor,
      scroll = _ref.scroll,
      options = _ref.options,
      doc = _ref.doc;
    selectionManager_classCallCheck(this, SelectionManager);
    selectionManager_defineProperty(this, "onEditorMouseDown", function (_ref2) {
      var clientX = _ref2.clientX,
        clientY = _ref2.clientY,
        target = _ref2.target;
      if (!_this.options.enabled) return;
      var allowSession = target === _this.editor.editorBody;
      if (!allowSession && _this.options.webkitEnableFixColumnSelection) {
        if (target.hasAttribute(COLUMN_SELECTION_FIX_ATTR)) {
          var _target$getBoundingCl = target.getBoundingClientRect(),
            targetX = _target$getBoundingCl.left;
          if (clientX < targetX) {
            allowSession = true;
          }
        }
      }
      if (allowSession) {
        _this.startSelectionSession(clientX, clientY);
      }
    });
    selectionManager_defineProperty(this, "onEditorDragStart", function (event) {
      if (!_this.options.enabled) return;
      // нативный драггинг элементов ломает этот плагин, 
      // так как у редактора есть свой обработчик d&d, запрещаем нативный драггинг
      if (event.target === _this.editor.editorBody) {
        event.preventDefault();
      }
    });
    selectionManager_defineProperty(this, "onDocumentMouseMove", function (_ref3) {
      var clientX = _ref3.clientX,
        clientY = _ref3.clientY;
      _this.session.setCursorPosition(clientX, clientY);
    });
    selectionManager_defineProperty(this, "onDocumentMouseUp", function () {
      _this.endSelectionSession();
    });
    selectionManager_defineProperty(this, "onScrollingContainerScroll", function () {
      var _this$scrollingContai = _this.scrollingContainer,
        scrollTop = _this$scrollingContai.scrollTop,
        scrollLeft = _this$scrollingContai.scrollLeft;
      var _this$session$scrollP = _this.session.scrollPosition,
        left = _this$session$scrollP.left,
        top = _this$session$scrollP.top;
      var deltaX = scrollLeft - left;
      var deltaY = scrollTop - top;
      var _this$session$initCur = _this.session.initCursorPosition,
        x = _this$session$initCur.x,
        y = _this$session$initCur.y;
      x -= deltaX;
      y -= deltaY;
      _this.session.setInitCursorPosition(x, y);
      _this.session.setScrollPosition(scrollLeft, scrollTop);
    });
    selectionManager_defineProperty(this, "onEditorUpdate", function () {
      if (_this.options.enabled && _this.options.webkitEnableFixColumnSelection) {
        // тут повесил без дебаунса, думаю простой цикл перебирающий массив не будет сильно грузить браузер при каждом апдейте
        _this.fixWebkitColumnSelection();
      }
    });
    this.editor = editor;
    this.scroll = scroll;
    this.options = Object.assign({}, selectionManager_DEFAULT_OPTIONS, options);
    this.document = doc || document;
    this.scrollingContainer = this.editor.getScrollingContainer();
    this.session = null;
    this.editor.editorBody.addEventListener('mousedown', this.onEditorMouseDown, false);
    this.editor.editorBody.addEventListener('dragstart', this.onEditorDragStart, false);
    this.editor.on('editorUpdate', this.onEditorUpdate);
  }
  selectionManager_createClass(SelectionManager, [{
    key: "destroy",
    value: function destroy() {
      this.editor.editorBody.removeEventListener('mousedown', this.onEditorMouseDown, false);
      this.editor.editorBody.removeEventListener('dragstart', this.onEditorDragStart, false);
      this.editor.on('editorUpdate', this.onEditorUpdate);
    }
  }, {
    key: "startSelectionSession",
    value: function startSelectionSession(clientX, clientY) {
      /* Fix for WebKit browsers selection out of contenteditable */
      if (this.editor.browser !== 'Firefox' && this.editor.mode === MODE_EDIT) {
        this.scroll.domNode.setAttribute('contenteditable', false);
      }
      // старт сессии
      this.session = new SelectionSession({
        scroll: this.scroll,
        editor: this.editor,
        scrollingContainer: this.scrollingContainer
      });
      // начальные значения
      var _this$scrollingContai2 = this.scrollingContainer,
        scrollLeft = _this$scrollingContai2.scrollLeft,
        scrollTop = _this$scrollingContai2.scrollTop;
      this.session.setInitCursorPosition(clientX, clientY);
      this.session.setCursorPosition(clientX, clientY);
      this.session.setScrollPosition(scrollLeft, scrollTop);
      // слушатели событий при выделении
      this.document.addEventListener('mousemove', this.onDocumentMouseMove, false);
      this.document.addEventListener('mouseup', this.onDocumentMouseUp, false);
      this.scrollingContainer.addEventListener('scroll', this.onScrollingContainerScroll, false);
      this.editor.emit('start-nedit-selection');
    }
  }, {
    key: "endSelectionSession",
    value: function endSelectionSession() {
      /* Fix for WebKit browsers selection out of contenteditable */
      if (this.editor.browser !== 'Firefox' && this.editor.mode === MODE_EDIT) {
        this.scroll.domNode.setAttribute('contenteditable', true);
      }
      // обнуляем сессию
      this.session.cleanup();
      this.session = null;
      // снимаем слушатели событий при выделении
      this.document.removeEventListener('mousemove', this.onDocumentMouseMove, false);
      this.document.removeEventListener('mouseup', this.onDocumentMouseUp, false);
      this.scrollingContainer.removeEventListener('scroll', this.onScrollingContainerScroll, false);
      this.editor.emit('end-nedit-selection');
    }
  }, {
    key: "fixWebkitColumnSelection",
    value: function fixWebkitColumnSelection() {
      if (this.editor.browser === 'Firefox') return;
      var notFixedGridSelector = '.grid[data-type="grid"]:first-child:not([' + COLUMN_SELECTION_FIX_ATTR + '="true"])';
      var notFixedGrids = Array.from(this.scroll.domNode.querySelectorAll(notFixedGridSelector));
      if (!notFixedGrids.length) return;
      for (var _i = 0, _notFixedGrids = notFixedGrids; _i < _notFixedGrids.length; _i++) {
        var node = _notFixedGrids[_i];
        node.setAttribute(COLUMN_SELECTION_FIX_ATTR, true);
      }
    }
  }]);
  return SelectionManager;
}();

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/util/encoding.js + 2 modules
var encoding = __webpack_require__(59150);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/changeObserver.js
function changeObserver_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function changeObserver_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function changeObserver_createClass(Constructor, protoProps, staticProps) { if (protoProps) changeObserver_defineProperties(Constructor.prototype, protoProps); if (staticProps) changeObserver_defineProperties(Constructor, staticProps); return Constructor; }
// Обсервер для наблюдения за изменениями редактора,
// нужен для отслеживания позиционирования блоков редактора.
// Если контент какого либо плагина зависит от позиции блоков редактора,
// при выставлении позиции контенту нужно подписаться на событие редактора editorUpdate
var ChangeObserver = /*#__PURE__*/function () {
  function ChangeObserver(editor, callback) {
    changeObserver_classCallCheck(this, ChangeObserver);
    this.editor = editor;
    this.contentNode = this.editor.scroll.domNode;
    this.onUpdateCallback = callback;
    this.mutationObserver = new MutationObserver(this.onUpdate.bind(this, 'mutation'));
    this.mutationObserver.observe(this.contentNode, {
      childList: true,
      subtree: true
    });
    if (typeof ResizeObserver === 'function') {
      this.resizeObserver = new ResizeObserver(this.onUpdate.bind(this, 'resize'));
      this.resizeObserver.observe(this.editor.editorBody);
      this.resizeObserver.observe(this.contentNode);
    }
  }
  changeObserver_createClass(ChangeObserver, [{
    key: "onUpdate",
    value: function onUpdate(type, records) {
      if (typeof this.onUpdateCallback === 'function') {
        this.onUpdateCallback(type, records);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.mutationObserver.disconnect();
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }
  }]);
  return ChangeObserver;
}();
// EXTERNAL MODULE: ./node_modules/y-protocols/sync.js
var sync = __webpack_require__(53665);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/core.js

















function core_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function core_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function core_createClass(Constructor, protoProps, staticProps) { if (protoProps) core_defineProperties(Constructor.prototype, protoProps); if (staticProps) core_defineProperties(Constructor, staticProps); return Constructor; }
function core_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function core_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { core_typeof = function _typeof(obj) { return typeof obj; }; } else { core_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return core_typeof(obj); }




//import RightMenu from './menu/rightMenu';
































































var EVENTS = ['selectionchange', 'mousedown', 'mouseup', 'click'];
var PLUGINS = {
  'editorStyle': EditorStyle,
  'dragAndDrop': DragAndDrop,
  'undoManager': UndoManager,
  'pasteManager': PasteManager,
  'selectionScroller': SelectionScroller,
  'attachmentManager': AttachmentManager,
  'bookmarkManager': BookmarkManager,
  'notificationManager': NotificationManager,
  'popupManager': PopupManager,
  'dropManager': DropManager,
  'copyManager': copyManager,
  'lightBox': LightBox,
  'embeddedMenu': EmbeddedMenu,
  'emojiManager': EmojiManager,
  'tooltipManager': tooltipManager/* default */.ZP,
  'floatingToolbar': FloatingToolbar,
  'scrollSaver': ScrollSaver,
  'blockMenu': BlockMenu,
  'linkManager': LinkManager,
  'i18n': plugins_i18n/* default */.ZP,
  'search': Search,
  'globalSearch': GlobalSearch,
  'mentionManager': MentionManager,
  'attachmentWatcher': AttachmentWatcher,
  'professionAsk': ProfessionAsk,
  'reminderManager': ReminderManager,
  'remoteFileManager': RemoteFileManager,
  'imageManager': ImageManager,
  'convertLinkManager': ConvertLinkManager,
  'debugLogger': DebugLogger,
  'dateManager': DateManager,
  'commentManager': CommentManager,
  'outlineManager': OutlineManager,
  'webRTCPlugin': WebRTCPlugin,
  'selectionManager': SelectionManager,
  'signature': Signature,
  'limitManager': LimitManagerPlugin,
  'convertBlotManager': ConvertBlotManager,
  'awarenessPlugin': AwarenessPlugin,
  'ctaManager': CtaManager,
  'tasksManager': TasksManager,
  'videoPreview': VideoPreviewPlugin,
  'emptyFeatures': EmptyFeaturesPlugin,
  'featuresAvailabilityPlugin': FeaturesAvailabilityPlugin,
  'boardManager': BoardManager,
  'unsplashManager': UnsplashManager,
  'aiManager': AiManager,
  'grammarlyManager': GrammarlyManager,
  'editorRate': EditorRate,
  'changeButton': ChangeButton
};
var PLUGINS_ONLY_EDIT = {
  'dragAndDrop': true,
  'pasteManager': false,
  'selectionScroller': false,
  'attachmentManager': false,
  'bookmarkManager': false,
  'popupManager': false,
  'dropManager': true,
  'copyManager': false,
  'lightBox': false,
  'embeddedMenu': true,
  'emojiManager': true,
  'tooltipManager': false,
  /* 'floatingToolbar': true, */
  'scrollSaver': false,
  'blockMenu': false,
  'i18n': false,
  'editorStyle': false,
  'professionAsk': true,
  'outlineManager': false,
  'webRTCPlugin': false,
  'awarenessPlugin': true,
  'emptyFeatures': true,
  'unsplashManager': true,
  'aiManager': true
};
var core_DEFAULT_OPTIONS = {
  showLinkPanel: true,
  theme: 'light',
  focusMode: false,
  baseUrl: (typeof window === "undefined" ? "undefined" : core_typeof(window)) === 'object' && core_typeof(window.location) === 'object' ? window.location.origin + window.location.pathname : ''
};
var NOT_SUPPORTED_CONTENT_MESSAGE_CLASS = 'content-not-supported-message';
var NOTE_CONTAINER_CLASS = 'note-container';
var forceEnablePlugin = function forceEnablePlugin(plugin, options) {
  var conditions = {
    'blockMenu': function blockMenu() {
      if (options.blots && options.blots.list && options.blots.list.collapsible) {
        return true;
      }
      return false;
    }
  };
  if (conditions.hasOwnProperty(plugin)) {
    return conditions[plugin]();
  } else {
    return false;
  }
};
var Editor = /*#__PURE__*/function () {
  function Editor(options) {
    var _this = this;
    core_classCallCheck(this, Editor);
    core_defineProperty(this, "onBlotNotSupported", function (data) {
      if (_this.scroll && _this.scroll.domNode.parentNode) {
        _this.scroll.observer.disconnect();
        _this.scroll.domNode.parentNode.removeChild(_this.scroll.domNode);
        var contentNotSupportedMessage = document.createElement('div');
        contentNotSupportedMessage.classList.add(NOT_SUPPORTED_CONTENT_MESSAGE_CLASS);
        contentNotSupportedMessage.textContent = _this.plugins.i18n.get('content_not_supported');
        _this.scrollingContainer.appendChild(contentNotSupportedMessage);
      }
    });
    core_defineProperty(this, "domEventsListener", function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      [].slice.call(document.querySelectorAll('.note-container')).forEach(function (node) {
        if (node.__note && node.__note.emitter) {
          var _node$__note$emitter;
          (_node$__note$emitter = node.__note.emitter).handleDOM.apply(_node$__note$emitter, args);
        }
      });
    });
    core_defineProperty(this, "onStoreUpdate", function (unit8Array, source, provider, transaction) {
      _this.emitter.emit('contentUpdate', {
        source: source,
        transaction: transaction
      });
    });
    core_defineProperty(this, "onBodyResize", function () {
      _this.emitter.emit('editorBodyResize');
    });
    core_defineProperty(this, "onEditorChange", function (type, records) {
      _this.emitter.emit('editorUpdate', {
        type: type,
        records: records
      });
    });
    console.info("[".concat(options.editorId, "] initializing new Editor instance, elem: \"").concat(options.elem, "\""));
    if (typeof window !== 'undefined') {
      if (window.gEditor && !window.gEditor.destroyed) {
        console.warn('there is a not destroyed editor available, consider calling destroy on every editor you do not need anymore');
      }
    }
    this.options = Object.assign({}, core_DEFAULT_OPTIONS, options);
    this.browser = this.browser();
    this.destroyed = false;
    this.store = new Store({
      y: options.y,
      Y: options.yjs
    });
    this.blotsConfig = options.blots || {};
    this.room = options.serverRoom;
    this.mode = options.mode || Editor.MODE_EDIT;

    // unique editor identificator within current page
    this.editorId = options.editorId;
    this.scrollbarWidth = options.render ? (0,dom/* getScrollbarWidth */.np)() : null;
    this.editorBody = null;
    this.persistedBlotsProps = {};
    if (typeof window === 'undefined') {
      __webpack_require__.g.MutationObserver = dom/* PseudoMutationObserver */.Mn;
      __webpack_require__.g.Node = dom/* PseudoDomNode */.Ct;
    }
    if (typeof options.caretTrapContentEditable !== 'undefined') {
      setDefaultCaretTrapContentEditable(options.caretTrapContentEditable);
    }
    if (options.render) {
      if (!this.initElements(options)) {
        return;
      }
    }
    this.emitter = new emitter();
    this.emitter.setMaxListeners(999999);
    this.emitter.on(EVENT_BLOT_NOT_SUPPORTED, this.onBlotNotSupported);
    var Scroll = src_parchment.query('scroll');
    Scroll.initMap(this.store.root, this.store);
    var scrollOptions = {
      editor: this,
      emitter: this.emitter,
      store: this.store,
      map: this.store.root
    };
    if (options.render) {
      this.scroll = src_parchment.create(this.root, scrollOptions);
    } else {
      var node = new dom/* PseudoDomNode */.Ct();
      if (typeof document !== 'undefined' && document.hasOwnProperty('createElement')) {
        node = document.createElement('div');
      }
      this.scroll = new Scroll(node, scrollOptions);
    }
    this.api = new Api(this);
    if (options.render) {
      EVENTS.forEach(function (eventName) {
        return document.addEventListener(eventName, _this.domEventsListener, false);
      });
    }
    if (options.render) {
      this.initPlugins(options);
    } else {
      // задаем plugins т.к. в некоторых местах плагин limitManager пробуем достать из plugins
      this.plugins = {};
    }
    if (options.toolbar == true) {
      this.toolbar = new toolbar(this);
    }
    if (options.mode !== MODE_EDIT && options.mode !== MODE_LITE) {
      // игнорируем изменения DOM в нередактируемом редакторе, это нужно для избежания конфликтов
      // с google translate и другими подобными расширениями
      this.scroll.ignoreUpdates();
    }

    // запускаем инициализацию скролл блота когда все плагины инициализированы
    if (options.render) {
      this.scroll.init();
    }

    // диспатчим в редактор событие обновления yjs
    this.store.y.on('update', this.onStoreUpdate);
    if (options.render && typeof ResizeObserver === 'function') {
      // инициируем и диспатчим наблюдатель за ресайзом тела редактора
      this._bodyObserver = new ResizeObserver(this.onBodyResize);
      this._bodyObserver.observe(this.editorBody);
      this._bodyObserver.observe(this.scroll.domNode);
      this.changeObserver = new ChangeObserver(this, this.onEditorChange);
    }
    this.emitter.emit('editor-ready');
    this.ready = true;
    if (options.applyTemplate && typeof options.applyTemplate === 'function') {
      options.applyTemplate(this);
    }
    /* fix out of editor custom elements interfaces mousedown */
    document.addEventListener('mousedown', fixOutOfEditorInterfacesMouseDownListeners, false);
  }
  core_createClass(Editor, [{
    key: "hasFocus",
    value: function hasFocus() {
      if (this.mode === MODE_EDIT) {
        return this.scroll.selection.hasFocus() && this.scroll.selection.getRange()[0] !== null;
      } else {
        return this.scroll.selection.getRange()[0] !== null;
      }
    }
  }, {
    key: "initPlugins",
    value: function initPlugins(options) {
      var pluginsOptions = options.plugins || {};
      this.plugins = {};
      for (var key in PLUGINS) {
        if (options.mode === MODE_LITE && !Editor.LITE_MODE_PLUGINS.includes(PLUGINS[key])) continue;
        if (options.mode !== MODE_EDIT && options.mode !== MODE_LITE && PLUGINS_ONLY_EDIT[key] && !forceEnablePlugin(key, options)) continue;
        this.plugins[key] = new PLUGINS[key]({
          scroll: this.scroll,
          editor: this,
          options: pluginsOptions[key]
        });
      }
    }
  }, {
    key: "initElements",
    value: function initElements(options) {
      if (options.elem instanceof Node) {
        this.container = options.elem;
      } else if (typeof options.elem === 'string') {
        this.container = document.querySelector(options.elem);
      }
      if (!this.container) {
        // если не можем получить контейнер для инициации, не продолжаем инициацию
        console.warn("Get impossible container for editor initiation, option 'elem': " + options.elem);
        return false;
      }
      this.container.classList.add(NOTE_CONTAINER_CLASS);
      this.container.classList.add('theme-' + this.options.theme);
      this.assignEnvInfo();
      this.container.style.position = 'relative';
      if (this.isMobileDevice()) {
        this.container.classList.add('is-mobile-device');
      }
      this.container.__note = this;
      this.scrollingContainer = document.createElement('div');
      this.editorBody = this.scrollingContainer;
      this.scrollingContainer.classList.add('editor-body');
      if (this.getScrollingContainer() !== this.scrollingContainer) {
        this.scrollingContainer.classList.add('no-vertical-scroll');
      }
      this.container.appendChild(this.scrollingContainer);
      this.root = document.createElement('div');
      this.root.classList.add(this.mode + '-mode');
      this.scrollingContainer.appendChild(this.root);
      this.root.classList.add(vars.scrollBlotClass);
      // говорим грамматическим чекером чтобы игнорировали редактор, т.к. они вызывают пропажу контента NIM-6722
      //this.root.setAttribute('data-gramm', 'false');
      // отключение google translate
      this.root.classList.add('notranslate');
      this.root.setAttribute('translate', 'no');
      var noteUniqueId = 'note-' + generateId();
      this.root.id = options.idPrefix ? options.idPrefix + noteUniqueId : noteUniqueId;
      if (this.isEditable()) {
        this.root.setAttribute('contenteditable', true);
      }
      this.clipboard = document.createElement('div');
      this.clipboard.classList.add('clipboard');
      this.container.appendChild(this.clipboard);
      this.contextMenu = document.createElement('div');
      this.contextMenu.classList.add('context-menu', 'hidden');
      this.container.appendChild(this.contextMenu);
      var cursorsBlock = document.createElement('div');
      cursorsBlock.id = 'editor-cursors';
      cursorsBlock.classList.add('editor-cursors');
      this.scrollingContainer.prepend(cursorsBlock);

      //добавляем класс для кастомного scrollingContainer если он передан в опциях, для класса в стилях определена position: relative,
      //релатив нужен для корректоного позиционирования попапов редактора
      if (options.scrollingContainer) {
        var container;
        if (typeof options.scrollingContainer === 'string') {
          container = document.getElementById(options.scrollingContainer);
        } else {
          container = options.scrollingContainer;
        }
        if (container) {
          container.classList.add('nedit-scrolling-container');
          if (!container.id || container.id === '') {
            container.id = 'nedit-scrolling-container';
          }
        }
      }
      return true;
    }
  }, {
    key: "assignEnvInfo",
    value: function assignEnvInfo() {
      var browser = this.browser;
      if (browser === 'Firefox') {
        this.container.classList.add('is-ff');
      } else if (browser === 'Chrome') {
        this.container.classList.add('is-chrome');
      } else if (browser === 'Safari') {
        this.container.classList.add('is-safari');
      }
      var os = this.platform;
      if (os) {
        this.container.classList.add('os-' + os.replace(' ', '').toLowerCase());
      }
    }
  }, {
    key: "getViewportSize",
    value: function getViewportSize() {
      return {
        width: this.scrollingContainer.offsetWidth,
        height: this.scrollingContainer.offsetHeight
      };
    }
  }, {
    key: "getScrollingContainer",
    value: function getScrollingContainer() {
      var scrollingContainer;
      if (this.options.scrollingContainer) {
        if (typeof this.options.scrollingContainer === 'string') {
          scrollingContainer = document.getElementById(this.options.scrollingContainer);
        } else {
          scrollingContainer = this.options.scrollingContainer;
        }
      }
      if (!scrollingContainer) {
        scrollingContainer = this.scrollingContainer;
      }
      return scrollingContainer;
    }
  }, {
    key: "off",
    value: function off() {
      return this.emitter.off.apply(this.emitter, arguments);
    }
  }, {
    key: "on",
    value: function on() {
      return this.emitter.on.apply(this.emitter, arguments);
    }
  }, {
    key: "once",
    value: function once() {
      return this.emitter.once.apply(this.emitter, arguments);
    }
  }, {
    key: "emit",
    value: function emit() {
      var _this$emitter;
      return (_this$emitter = this.emitter).emit.apply(_this$emitter, arguments);
    }
  }, {
    key: "exec",
    value: function exec(action) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var onexec = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var result = this.api.exec(action, params);
      if (params != null && onexec == null && typeof params == 'function') {
        onexec = params;
      }
      if (onexec != null) {
        onexec(result);
      }
      this.emit('exec', {
        action: action,
        params: params
      });
      return result;
    }
  }, {
    key: "browser",
    value: function browser() {
      return checkBrowser();
    }

    /**
     * отдает текст в редакторе без формативания
     * @param {int} [maxLength] - максимальная длина возвращаемого текста, если текст более это длины то он обрежется
     * и в конце добавится ...
     * @return {string}
     */
  }, {
    key: "getRawText",
    value: function getRawText(maxLength) {
      var text = '';
      var nodes = this.scroll.domNode.querySelectorAll('.editable-text');
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (text) {
          text += ' ';
        }
        var formatText = node.innerText.replace(/(\s?\n)/gi, ' ');
        text += formatText;
        if (text.length >= maxLength) {
          if (nodes[i + 1]) {
            var _formatText = nodes[i + 1].innerText.replace(/(\s?\n)/gi, ' ');
            text += ' ' + _formatText;
          }
        }
      }
      if (maxLength && text.length > maxLength) {
        text = text.substring(0, maxLength) + '...';
      }
      return text;
    }
  }, {
    key: "arrayHandler",
    value: function arrayHandler(array) {
      return array.get('content').toString();
    }
  }, {
    key: "textHandler",
    value: function textHandler(array) {
      return array.toString();
    }
  }, {
    key: "platform",
    get: function get() {
      return checkPlatform();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this2 = this;
      if (this.destroyed) {
        return console.warn('[' + this.editorId + ']', 'Editor has already been destroyed');
      }
      console.info('[' + this.editorId + ']', 'destroying Editor instance');
      this.destroyed = true;
      EVENTS.forEach(function (eventName) {
        return document.removeEventListener(eventName, _this2.domEventsListener, false);
      });
      // plugins
      for (var k in this.plugins) {
        var plugin = this.plugins[k];
        if (plugin.destroy) {
          plugin.destroy();
        }
      }
      // отсоединяем scroll блот
      this.scroll.detach();
      // some destruction actions must be here
      while (this.container.firstChild) {
        this.container.removeChild(this.container.firstChild);
      }

      // дестрой апдейтов yjs
      this.store.y.off('update', this.onStoreUpdate);
      this.store.destroy();
      this.api.destroy();

      // дестрой наблюдателя за ресайзом тела редактора
      if (this._bodyObserver) {
        this._bodyObserver.disconnect();
      }
      if (this.changeObserver) {
        this.changeObserver.destroy();
      }
      document.removeEventListener('mousedown', fixOutOfEditorInterfacesMouseDownListeners, false);
    }
  }, {
    key: "focus",
    value: function focus() {
      var range = this.scroll.selection.getNativeRange();
      if (range) {
        if (this.container.contains(range.start.node) && this.container.contains(range.end.node)) {
          // выделение уже стоит в редакторе
          return;
        }
      }
      this.scroll.domNode.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.scroll.domNode.blur();
    }
  }, {
    key: "findById",
    value: function findById(id) {
      if (this.options.idPrefix) {
        id = this.options.idPrefix + id;
      }
      return src_parchment.findById(id);
    }
  }, {
    key: "findBlotsWithAttachment",
    value: function findBlotsWithAttachment() {
      var attachmentGlobalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return this.plugins.attachmentManager.findBlotsWithAttachment(attachmentGlobalId);
    }
  }, {
    key: "setAttachmentUploadTask",
    value: function setAttachmentUploadTask(task) {
      eachBlot(this.scroll, function (blot) {
        if (!blot.getWrappedBlot) {
          return;
        }
        blot = blot.getWrappedBlot();
        if (!blot.getUploadTaskId) {
          return;
        }
        if (blot.getUploadTaskId() !== task.id) {
          return;
        }
        blot.setUploadTask(task);
        return false;
      });
    }
  }, {
    key: "setAttachment",
    value: function setAttachment(attachment) {
      return this.plugins.attachmentManager.setAttachment(attachment);
    }

    /**
     * Создаёт пустой декодированный буфер
     * @returns {Uint8Array}
     */
  }, {
    key: "getEmptyEncodedStateVector",
    value: function getEmptyEncodedStateVector() {
      var encoder = encoding.createEncoder();
      encoding.writeVarUint(encoder, 0);
      return encoding.toUint8Array(encoder);
    }

    /**
     * Возвращает буфер документа
     * @returns {Uint8Array}
     */
  }, {
    key: "createSnapshot",
    value: function createSnapshot() {
      var encoder = encoding.createEncoder();
      sync.writeSyncStep2(encoder, this.store.y, this.getEmptyEncodedStateVector());
      return encoding.toBuffer(encoder);
    }

    /**
     * Записывает буфер в документ
     * @param buffer {Uint8Array}
     */
  }, {
    key: "restoreSnapshot",
    value: function restoreSnapshot(buffer) {
      (0,util_y.restoreDump)({
        doc: this.store.y,
        Y: this.store.Y,
        buffer: buffer
      });
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      if (this.scroll.children.length !== 1) {
        return false;
      }
      if (this.scroll.children.head.constructor.blotName !== 'paragraph') {
        return false;
      }
      if (!this.scroll.children.head.isEmpty()) {
        return false;
      }
      return true;
    }
  }, {
    key: "isEditable",
    value: function isEditable() {
      return this.mode === MODE_EDIT || this.mode === MODE_LITE;
    }
  }, {
    key: "isExport",
    value: function isExport() {
      return this.mode === MODE_EXPORT;
    }
  }, {
    key: "isMobileDevice",
    value: function isMobileDevice() {
      return this.options.isMobileDevice;
    }

    /**
     * данная функция возвращает HTML представление редактора в виде строки
     * в передаваемый context блоты сообщают нужную для сохранения HTML информацию,
     * например, файлы/изображения сохраняют в контекст информацию об аттачах которые надо сохранить
     * @param  {ToHTMLContext} context - обязательный параметр
     * @return {string}  HTML контент редактора
     */
  }, {
    key: "toHTML",
    value: function toHTML(context) {
      var html = [];
      if (context.options.pdf) {
        this.scrollingContainer.classList.add('e-body-pdf');
      }
      html.push('<div ' + (0,dom/* getAttributesString */.No)(this.container) + '>');
      html.push('<div ' + (0,dom/* getAttributesString */.No)(this.scrollingContainer) + '>');
      html.push(this.scroll.toHTML(context));
      html.push('</div>');
      html.push('</div>');
      return html.join('\n');
    }
  }, {
    key: "parchment",
    get: function get() {
      return src_parchment;
    }

    /**
     * Данный метод позволяет получить весь набор операций редактора.
     * @return {array} контент редактора в виде набор операций
     */
  }, {
    key: "getContents",
    value: function getContents() {
      return this.scroll.getSelectedContents([], true);
    }

    /**
     * Данный метод позволяет применить набор операций вставки контента к редактору.
     * Если опции не были переданы, вставка произойдет в конец.
     * @param ops - обязательный параметр, набор операций
     * @param { start: boolean } options - не обязательный параметр, определяет вставку контента в начало
     * @param { end: boolean } options - не обязательный параметр, определяет вставку контента в конец
     * @param { before: string } options - не обязательный параметр, определяет вставку перед блоком с id `before`
     * @param { after: string } options - не обязательный параметр, определяет вставку после блока с id `after`
     * @return
     */
  }, {
    key: "applyContents",
    value: function applyContents(ops) {
      var _this$plugins;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this.scroll || !((_this$plugins = this.plugins) !== null && _this$plugins !== void 0 && _this$plugins.pasteManager)) return;
      var selection = this.scroll.selection;
      if (!options.start && !options.end || options.end) {
        selection.setRange({
          index: this.scroll.length() - 1,
          length: 0
        });
      } else if (options.start) {
        selection.setRange({
          index: 0,
          length: 0
        });
      } else if (options.before || options.after) {
        var id = options.before || options.after;
        var blot = this.findById(id);
        if (blot) {
          if (options.before) {
            selection.setRange({
              index: blot.offset(this.scroll),
              length: 0
            });
          } else {
            selection.setRange({
              index: blot.offset(this.scroll) + blot.length() - 1,
              length: 0
            });
          }
        } else {
          console.error('Could not find a blot with id: ', id);
          selection.setRange({
            index: this.scroll.length() - 1,
            length: 0
          });
        }
      }
      this.plugins.pasteManager.pasteNimbusOps(ops);
    }
  }]);
  return Editor;
}();

var MODE_EDIT = 'edit';
var MODE_PREVIEW = 'preview';
var MODE_READONLY = 'readonly';
var MODE_EXPORT = 'export';
var MODE_LITE = 'lite';
var EVENT_BLOT_REMOVED = 'blot-removed';
var EVENT_BLOT_ADDED = 'blot-added';
var EVENT_ATTACHMENT_CLEARED = 'attachment-cleared';
var EVENT_ATTACHMENTS_UPDATE = 'attachments-update';
var EVENT_BLOT_NOT_SUPPORTED = 'blot-not-supported';
var EVENT_STYLE_CHANGED = 'style-changed';
var EVENT_BLOT_DRAG_STOPPED = 'blot-drag-stopped';
Editor.MODE_EDIT = MODE_EDIT;
Editor.MODE_PREVIEW = MODE_PREVIEW;
Editor.MODE_READONLY = MODE_READONLY;
Editor.MODE_EXPORT = MODE_EXPORT;
Editor.MODE_LITE = MODE_LITE;
Editor.LITE_MODE_BLOTS = ['paragraph'];
Editor.LITE_MODE_PLUGINS = [PasteManager, MentionManager, EditorStyle, plugins_i18n/* default */.ZP, UndoManager, SelectionScroller];
function checkBrowser() {
  return (0,browser/* detectBrowser */.Ao)();
}
function checkPlatform() {
  return (0,browser/* detectPlatform */.tz)();
}
function fixOutOfEditorInterfacesMouseDownListeners(event) {
  var _event$target$classLi;
  if (event.target.closest('nim-tasks-reminder-dialog') || (_event$target$classLi = event.target.classList) !== null && _event$target$classLi !== void 0 && _event$target$classLi.contains('cdk-overlay-backdrop')) {
    event.preventDefault();
    event.stopPropagation();
  }
}
// EXTERNAL MODULE: ./node_modules/@lib/editor/node_modules/p-cancelable/index.js
var p_cancelable = __webpack_require__(95148);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/logger.js
var levels = ['error', 'warn', 'log', 'info'];
var level = 'info';
function debug(method) {
  if (levels.indexOf(method) <= levels.indexOf(level)) {
    var _console;
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
  }
}

function namespace(ns) {
  return levels.reduce(function (logger, method) {
    logger[method] = debug.bind(console, method, ns);
    return logger;
  }, {});
}
debug.level = namespace.level = function (newLevel) {
  level = newLevel;
};
/* harmony default export */ const src_logger = (namespace);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/errors/editorInitCancelled.js
var editorInitCancelled = __webpack_require__(56289);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/ToHTMLContext.js



function ToHTMLContext_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function ToHTMLContext_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function ToHTMLContext_createClass(Constructor, protoProps, staticProps) { if (protoProps) ToHTMLContext_defineProperties(Constructor.prototype, protoProps); if (staticProps) ToHTMLContext_defineProperties(Constructor, staticProps); return Constructor; }
function ToHTMLContext_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MIME_EXTENSIONS = {
  // Сервер редактора экспортирует 'image/jpeg' как .jpeg
  // Если расширение будет указано явно в display_name то сервер это учтет, как и getAttachmentPath
  'image/jpeg': 'jpeg',
  'image/png': 'png',
  'image/gif': 'gif'
};
var ToHTMLContext = /*#__PURE__*/function () {
  function ToHTMLContext(options) {
    ToHTMLContext_classCallCheck(this, ToHTMLContext);
    ToHTMLContext_defineProperty(this, "attachments", {});
    ToHTMLContext_defineProperty(this, "assetsDir", './assets');
    this.options = options;
  }
  ToHTMLContext_createClass(ToHTMLContext, [{
    key: "getAttachmentPath",
    value: function getAttachmentPath(attachment) {
      if (_isPseudoAttachment(attachment.global_id)) {
        return attachment.url;
      }
      if (!attachment || !this.attachments[attachment.global_id]) {
        return '';
      }
      var fileName = String(attachment.display_name).split('.');
      var fileExt;
      if (fileName.length > 1) {
        fileExt = fileName.pop();
      }
      var mimeExt = attachment.mime && MIME_EXTENSIONS[attachment.mime.toLowerCase()];
      if (!fileExt && mimeExt) {
        fileExt = mimeExt;
      }
      return this.assetsDir + '/' + attachment.global_id + '.' + fileExt;
    }
  }, {
    key: "addAttachment",
    value: function addAttachment(attachment) {
      if (this.attachments[attachment.global_id]) {
        return;
      }
      this.attachments[attachment.global_id] = attachment;
    }
  }, {
    key: "getMentionUrl",
    value: function getMentionUrl(mentionType, mentionId) {
      var mentionUrlTemplates = this.options.mentionUrlTemplates;
      if (!mentionUrlTemplates || !mentionUrlTemplates[mentionType]) {
        return false;
      }
      return mentionUrlTemplates[mentionType].replace(/\{id\}/g, mentionId);
    }
  }]);
  return ToHTMLContext;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/editor.js







































// exports from other modules





var packageInfo = __webpack_require__(83285);
console.info('Editor', packageInfo.version);

var lastEditorId = 0;
function initEditor(config) {
  var isInit = false; // для того чтобы предотвратить дублирование редактора при повторном вызове onYReady
  var editorId = ++lastEditorId;
  var promise;
  var logger = src_logger('[' + editorId + ']');
  logger.log("Initializing new editor, room: \"".concat(config.serverRoom, "\", elem: \"").concat(config.elem, "\""));
  promise = new p_cancelable(function (resolve, reject, onCancel) {
    var yReadyTimeout;
    onCancel(function () {
      logger.info('editor initialization is cancelling');
      if (typeof y !== 'undefined') {
        logger.info('destroy y for non initialized yet editor');
        y.destroy();
      }
      if (config.y) {
        config.y.destroy();
      }
      if (yReadyTimeout) {
        logger.info('destroy yReadyTimeout for non initialized yet editor');
        clearTimeout(yReadyTimeout);
      }
      reject(new editorInitCancelled["default"]('editor initialization has been canceled'));
    });
    function onYReady(y, Y) {
      if (isInit) {
        return logger.log('cancel editor init, because the editor already initialized');
      }
      if (typeof promise !== 'undefined' && promise.isCanceled) {
        return logger.log('skipping onYReady because initEditor was canceled');
      }
      var options = Object.assign({
        elem: config.elem,
        render: true,
        editorId: editorId
      }, config, {
        y: y,
        yjs: Y
      });
      var editor = new Editor(options);
      if (typeof window !== 'undefined') {
        window.gEditor = editor;
      }
      logger.info('editor successfully initialized');
      isInit = true;
      resolve(editor);
    }
    if (config.y) {
      if (!config.Y) {
        throw new Error('If you set y you also have to set Y');
      }
      return onYReady(config.y, config.Y);
    }
    var url = config.url,
      room = config.room;
    var createDocument = config.createDocument || websocket.createDocument;
    var y = createDocument(yjs, {
      editorId: editorId,
      url: url,
      room: room,
      userID: config.cid,
      providerConfig: config.providerConfig
    });
    y.on('synced', function () {
      yReadyTimeout = setTimeout(function () {
        onYReady(y, yjs);
      }, 0);
    });
    if (config.dump || config.providerConfig && config.providerConfig.hasOwnProperty('connectToSocket') && !config.providerConfig.connectToSocket) {
      // оборачиваем в try/cache для того чтобы в случае ошибки рестора дампа, 
      // продолжить подгрузку заметки через соккет
      try {
        if (config.dump && !y._initialSyncComplete) {
          // делаем рестор дампа, если он передан
          (0,util_y.restoreDump)({
            doc: y,
            buffer: new Uint8Array(Object.values(config.dump)),
            Y: yjs
          });
          y._dumpInited = true;
          console.log("[".concat(editorId, "] restored by dump"));
        }
        // эмитим событие 'synced' для отображения редактора
        y.emit('synced', []);
      } catch (err) {
        var _config$plugins, _config$plugins$metri, _config$plugins2, _config$plugins2$erro;
        (_config$plugins = config.plugins) === null || _config$plugins === void 0 ? void 0 : (_config$plugins$metri = _config$plugins.metricsManager) === null || _config$plugins$metri === void 0 ? void 0 : _config$plugins$metri.measureSet('editor_init_dump_error', 1);
        (_config$plugins2 = config.plugins) === null || _config$plugins2 === void 0 ? void 0 : (_config$plugins2$erro = _config$plugins2.errorsManager) === null || _config$plugins2$erro === void 0 ? void 0 : _config$plugins2$erro.captureException(err);
        console.error("[".concat(editorId, "] can't restore dump"), err);
      }
    }
  });
  promise.editorId = editorId;
  return promise;
}
if (typeof window !== 'undefined') {
  window.initEditor = initEditor;
}

/***/ }),

/***/ 45405:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ AttachmentNotFoundError)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30489);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12419);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51532);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_10__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }











function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var AttachmentNotFoundError = /*#__PURE__*/function (_Error) {
  _inherits(AttachmentNotFoundError, _Error);
  var _super = _createSuper(AttachmentNotFoundError);
  function AttachmentNotFoundError() {
    _classCallCheck(this, AttachmentNotFoundError);
    return _super.apply(this, arguments);
  }
  return AttachmentNotFoundError;
}( /*#__PURE__*/_wrapNativeSuper(Error));


/***/ }),

/***/ 41552:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CustomDisplayableError)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30489);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12419);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51532);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_11__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }












function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var CustomDisplayableError = /*#__PURE__*/function (_Error) {
  _inherits(CustomDisplayableError, _Error);
  var _super = _createSuper(CustomDisplayableError);
  function CustomDisplayableError() {
    var _this;
    _classCallCheck(this, CustomDisplayableError);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "name", 'CustomDisplayableError');
    return _this;
  }
  return CustomDisplayableError;
}( /*#__PURE__*/_wrapNativeSuper(Error));


/***/ }),

/***/ 56289:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditorInitCancelled)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30489);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12419);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51532);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_10__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }











function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var EditorInitCancelled = /*#__PURE__*/function (_Error) {
  _inherits(EditorInitCancelled, _Error);
  var _super = _createSuper(EditorInitCancelled);
  function EditorInitCancelled() {
    _classCallCheck(this, EditorInitCancelled);
    return _super.apply(this, arguments);
  }
  return EditorInitCancelled;
}( /*#__PURE__*/_wrapNativeSuper(Error));


/***/ }),

/***/ 407:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Pj": () => (/* binding */ IntlProvider),
  "Cf": () => (/* reexport */ Localizer),
  "xv": () => (/* reexport */ Text),
  "ZP": () => (/* binding */ I18n)
});

// UNUSED EXPORTS: withText

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(30489);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__(12419);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/preact/dist/preact.module.js
var preact_module = __webpack_require__(79758);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__(23123);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(69600);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__(73210);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(4723);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(15306);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.splice.js
var es_array_splice = __webpack_require__(40561);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(21249);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(19601);
// EXTERNAL MODULE: ./node_modules/preact/hooks/dist/hooks.module.js
var hooks_module = __webpack_require__(8065);
// EXTERNAL MODULE: ./node_modules/dlv/dist/dlv.umd.js
var dlv_umd = __webpack_require__(50172);
var dlv_umd_default = /*#__PURE__*/__webpack_require__.n(dlv_umd);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(57327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
;// CONCATENATED MODULE: ./node_modules/preact-markup/dist/preact-markup.module.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

















var e,
  o = {};
function n(r, t, e) {
  if (3 === r.nodeType) {
    var o = "textContent" in r ? r.textContent : r.nodeValue || "";
    if (!1 !== n.options.trim) {
      var a = 0 === t || t === e.length - 1;
      if ((!(o = o.match(/^[\s\n]+$/g) && "all" !== n.options.trim ? " " : o.replace(/(^[\s\n]+|[\s\n]+$)/g, "all" === n.options.trim || a ? "" : " ")) || " " === o) && e.length > 1 && a) return null;
    }
    return o;
  }
  if (1 !== r.nodeType) return null;
  var p = String(r.nodeName).toLowerCase();
  if ("script" === p && !n.options.allowScripts) return null;
  var l,
    s,
    u = n.h(p, function (r) {
      var t = r && r.length;
      if (!t) return null;
      for (var e = {}, o = 0; o < t; o++) {
        var a = r[o],
          i = a.name,
          p = a.value;
        "on" === i.substring(0, 2) && n.options.allowEvents && (p = new Function(p)), e[i] = p;
      }
      return e;
    }(r.attributes), (s = (l = r.childNodes) && Array.prototype.map.call(l, n).filter(i)) && s.length ? s : null);
  return n.visitor && n.visitor(u), u;
}
var a,
  i = function i(r) {
    return r;
  },
  p = {};
function l(r) {
  var t = (r.type || "").toLowerCase(),
    e = l.map;
  e && e.hasOwnProperty(t) ? (r.type = e[t], r.props = Object.keys(r.props || {}).reduce(function (t, e) {
    var o;
    return t[(o = e, o.replace(/-(.)/g, function (r, t) {
      return t.toUpperCase();
    }))] = r.props[e], t;
  }, {})) : r.type = t.replace(/[^a-z0-9-]/i, "");
}
/* harmony default export */ const preact_markup_module = ((function (t) {
  function i() {
    t.apply(this, arguments);
  }
  return t && (i.__proto__ = t), (i.prototype = Object.create(t && t.prototype)).constructor = i, i.setReviver = function (r) {
    a = r;
  }, i.prototype.shouldComponentUpdate = function (r) {
    var t = this.props;
    return r.wrap !== t.wrap || r.type !== t.type || r.markup !== t.markup;
  }, i.prototype.setComponents = function (r) {
    if (this.map = {}, r) for (var t in r) {
      if (r.hasOwnProperty(t)) {
        var e = t.replace(/([A-Z]+)([A-Z][a-z0-9])|([a-z0-9]+)([A-Z])/g, "$1$3-$2$4").toLowerCase();
        this.map[e] = r[t];
      }
    }
  }, i.prototype.render = function (t) {
    var i = t.wrap;
    void 0 === i && (i = !0);
    var s,
      u = t.type,
      c = t.markup,
      m = t.components,
      v = t.reviver,
      f = t.onError,
      d = t["allow-scripts"],
      h = t["allow-events"],
      y = t.trim,
      w = function (r, t) {
        var e = {};
        for (var o in r) {
          Object.prototype.hasOwnProperty.call(r, o) && -1 === t.indexOf(o) && (e[o] = r[o]);
        }
        return e;
      }(t, ["wrap", "type", "markup", "components", "reviver", "onError", "allow-scripts", "allow-events", "trim"]),
      C = v || this.reviver || this.constructor.prototype.reviver || a || preact_module.h;
    this.setComponents(m);
    var g = {
      allowScripts: d,
      allowEvents: h,
      trim: y
    };
    try {
      s = function (r, t, a, i, s) {
        var u = function (r, t) {
          var o,
            n,
            a,
            i,
            p = "html" === t ? "text/html" : "application/xml";
          "html" === t ? (i = "body", a = "<!DOCTYPE html>\n<html><body>" + r + "</body></html>") : (i = "xml", a = '<?xml version="1.0" encoding="UTF-8"?>\n<xml>' + r + "</xml>");
          try {
            o = new DOMParser().parseFromString(a, p);
          } catch (r) {
            n = r;
          }
          if (o || "html" !== t || ((o = e || (e = function () {
            if (document.implementation && document.implementation.createHTMLDocument) return document.implementation.createHTMLDocument("");
            var r = document.createElement("iframe");
            return r.style.cssText = "position:absolute; left:0; top:-999em; width:1px; height:1px; overflow:hidden;", r.setAttribute("sandbox", "allow-forms"), document.body.appendChild(r), r.contentWindow.document;
          }())).open(), o.write(a), o.close()), o) {
            var l = o.getElementsByTagName(i)[0],
              s = l.firstChild;
            return r && !s && (l.error = "Document parse failed."), s && "parsererror" === String(s.nodeName).toLowerCase() && (s.removeChild(s.firstChild), s.removeChild(s.lastChild), l.error = s.textContent || s.nodeValue || n || "Unknown error", l.removeChild(s)), l;
          }
        }(r, t);
        if (u && u.error) throw new Error(u.error);
        var c = u && u.body || u;
        l.map = i || p;
        var m = c && function (r, t, e, a) {
          return n.visitor = t, n.h = e, n.options = a || o, n(r);
        }(c, l, a, s);
        return l.map = null, m && m.props && m.props.children || null;
      }(c, u, C, this.map, g);
    } catch (r) {
      f ? f({
        error: r
      }) : "undefined" != typeof console && console.error && console.error("preact-markup: " + r);
    }
    if (!1 === i) return s || null;
    var x = w.hasOwnProperty("className") ? "className" : "class",
      b = w[x];
    return b ? b.splice ? b.splice(0, 0, "markup") : "string" == typeof b ? w[x] += " markup" : "object" == _typeof(b) && (b.markup = !0) : w[x] = "markup", C("div", w, s || null);
  }, i;
})(preact_module/* Component */.wA));
;// CONCATENATED MODULE: ./node_modules/preact-i18n/dist/preact-i18n.esm.js
















function preact_i18n_esm_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { preact_i18n_esm_typeof = function _typeof(obj) { return typeof obj; }; } else { preact_i18n_esm_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return preact_i18n_esm_typeof(obj); }




var IntlContext = (0,preact_module/* createContext */.kr)({
  intl: {}
});

/** Check if an object is not null or undefined
 *	@private
 */
function defined(obj) {
  return obj !== null && obj !== undefined;
}

/** A simpler Object.assign
 *  @private
 */
function preact_i18n_esm_assign(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }
  return obj;
}

/** Recursively copy keys from `source` to `target`, skipping truthy values already in `target`.
 *	@private
 */
function deepAssign(target, source) {
  var out = preact_i18n_esm_assign({}, target);
  for (var i in source) {
    if (source.hasOwnProperty(i)) {
      if (target[i] && source[i] && preact_i18n_esm_typeof(target[i]) === 'object' && preact_i18n_esm_typeof(source[i]) === 'object') {
        out[i] = deepAssign(target[i], source[i]);
      } else {
        out[i] = target[i] || source[i];
      }
    }
  }
  return out;
}

/** select('foo,bar') creates a mapping: `{ foo, bar }`
 *	@private
 */
function preact_i18n_esm_select(properties) {
  properties = properties || {};
  if (typeof properties === 'string') {
    properties = properties.split(',');
  }
  if ('join' in properties) {
    var selected = {};
    for (var i = 0; i < properties.length; i++) {
      var val = properties[i].trim();
      if (val) {
        selected[val.split('.').pop()] = val;
      }
    }
    return selected;
  }
  return properties;
}
function objectWithoutProperties(obj, exclude) {
  var target = {};
  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }
  return target;
}
var URL_FLAG = /[?&#]intl=show/;

/** `<IntlProvider>` is a nestable internationalization definition provider.
 *	It exposes an Intl scope & definition into the tree,
 *	making them available to descendant components.
 *
 *	> **Note:** When nested, gives precedence to keys higher up the tree!
 *	> This means lower-level components can set their defaults by wrapping themselves
 *	> in an `<IntlProvider>`, but still remain localizable by their parent components.
 *
 *	@name IntlProvider
 *	@param props
 *	@param {String} [props.scope]			Nest `definition` under a root key, and set the active scope for the tree (essentially prefixing all `<Text />` keys).
 *	@param {Boolean} [props.mark=false]		If `true`, all `<Text>` elements will be shown with a red/green background indicating whether they have valid Intl keys.
 *	@param {Object} [props.definition={}]	Merge the given definition into the current intl definition, giving the *current* definition precedence (i.e., only adding keys, acting as defaults)
 *
 *	@example
 *	// generally imported from a JSON file:
 *	let definition = {
 *		foo: 'Le Feux'
 *	};
 *
 *	<IntlProvider scope="weather" definition={definition}>
 *		<Text key="foo">The Foo</Text>
 *	</IntlProvider>
 *
 *	// This will render the text:
 *	"Le Feux"
 */

function preact_i18n_esm_IntlProvider(ref) {
  var scope = ref.scope;
  var mark = ref.mark;
  var definition = ref.definition;
  var rest = objectWithoutProperties(ref, ["scope", "mark", "definition"]);
  var props = rest;
  var ref$1 = (0,hooks_module/* useContext */.qp)(IntlContext);
  var parentIntl = ref$1.intl;
  var intl = preact_i18n_esm_assign({}, parentIntl || {});

  // set active scope for the tree if given
  if (scope) {
    intl.scope = scope;
  }

  // merge definition into current with lower precedence
  if (definition) {
    intl.dictionary = deepAssign(intl.dictionary || {}, definition);
  }
  if (mark || typeof location !== 'undefined' && String(location).match(URL_FLAG)) {
    intl.mark = true;
  }
  return (0,preact_module.h)(IntlContext.Provider, {
    value: {
      intl: intl
    }
  }, props.children);
}

/**
 * Higher-order function that creates an `<IntlProvider />` wrapper component for the given component.  It
 * takes two forms depending on how many arguments it's given:
 * It can take a functional form like:
 * intl(ComponentToWrap, options)
 *
 * or it can take an annotation form like:
 * @intl(options)
 * class ComponentToWrap extends Component {}
 *
 *	@param {Component or Object} args[0] If there are two arguments, the first argument is the Component to wrap in `<IntlProvider/>`. If there is just one argument, this is the options object to pass as `props` to `<IntlProvider/>`. See the definition of the options param below for details.
 *	@param {Object} options If there are two arguments, the second argument is Passed as `props` to `<IntlProvider />`
 *	@param [options.scope]			Nest `definition` under a root key, and set the active scope for the tree (essentially prefixing all `<Text />` keys).
 *	@param [options.definition={}]	Merge the given definition into the current intl definition, giving the *current* definition precedence (i.e., only adding keys, acting as defaults)
 */
function intl(Child, options) {
  if (arguments.length < 2) {
    options = Child;
    return function (Child) {
      return intl(Child, options);
    };
  }
  function IntlProviderWrapper(props) {
    return (0,preact_module.h)(preact_i18n_esm_IntlProvider, options || {}, (0,preact_module.h)(Child, props));
  }
  IntlProviderWrapper.getWrappedComponent = Child && Child.getWrappedComponent || function () {
    return Child;
  };
  return IntlProviderWrapper;
}
var EMPTY = {};

/** Populate {{template.fields}} within a given string.
 *
 *	@private
 *	@param {String} template	The string containing fields to be resolved
 *	@param {Object} [fields={}]	Optionally nested object of fields, referencable from `template`.
 *	@example
 *		template('foo{{bar}}', { bar:'baz' }) === 'foobaz'
 */
function template(template, fields, scope, dictionary) {
  return template && template.replace(/\{\{([\w.-]+)\}\}/g, replacer.bind(null, fields || EMPTY, scope, dictionary));
}

/** Replacement callback for injecting fields into a String
 *	@private
 */
function replacer(currentFields, scope, dictionary, s, field) {
  var parts = field.split('.'),
    v = currentFields;
  for (var i = 0; i < parts.length; i++) {
    v = v[parts[i]];
    if (v == null) {
      return '';
    } // eslint-disable-line eqeqeq

    //allow field values to be <Text /> nodes
    if (v && v.type === Text) {
      return translate(v.props.id, scope, dictionary, v.props.fields, v.props.plural, v.props.fallback);
    }
  }
  // allow for recursive {{config.xx}} references:
  if (typeof v === 'string' && v.match(/\{\{/)) {
    v = template(v, currentFields);
  }
  return v;
}

/** Attempts to look up a translated value from a given dictionary.
 *  Also supports json templating using the format: {{variable}}
 *  Falls back to default text.
 *
 *  @param {String} id  			Intl field name/id (subject to scope)
 *  @param {String} [scope='']		Scope, which prefixes `id` with `${scope}.`
 *  @param {Object} dictionary		A nested object containing translations
 *  @param {Object} [fields={}]		Template fields for use by translated strings
 *  @param {Number} [plural]		Indicates a quantity, used to trigger pluralization
 *  @param {String|Array} [fallback]	Text to return if no translation is found
 *  @returns {String} translated
 */
function translate(id, scope, dictionary, fields, plural, fallback) {
  if (scope) {
    id = scope + '.' + id;
  }
  var value = dictionary && dlv_umd_default()(dictionary, id);

  // plural forms:
  // key: ['plural', 'singular']
  // key: { none, one, many }
  // key: { zero, one, other }
  // key: { singular, plural }
  if ((plural || plural === 0) && value && preact_i18n_esm_typeof(value) === 'object') {
    if (value.splice) {
      value = value[plural] || value[0];
    } else if (plural === 0 && defined(value.none || value.zero)) {
      value = value.none || value.zero;
    } else if (plural === 1 && defined(value.one || value.singular)) {
      value = value.one || value.singular;
    } else {
      value = value.some || value.many || value.plural || value.other || value;
    }
  }
  return value && template(value, fields, scope, dictionary) || fallback || null;
}

/** Highlight/colorize the i18n'd node if `mark` is set on `intl` in context.  If not, just returns `value`
 *
 *	@private
 *	@param {String|VNode} value	The l10n'd text/vnode to highlight or pass through
 *	@param {string} id	The key used to lookup the value in the intl dictionary
 */
function HighlightI18N(ref) {
  var value = ref.value;
  var id = ref.id;
  var ref$1 = (0,hooks_module/* useContext */.qp)(IntlContext);
  var intl = ref$1.intl;
  if (intl && intl.mark) {
    var dictionaryKey = "dictionary" + (intl && intl.scope ? "." + intl.scope : '') + "." + id;
    return (0,preact_module.h)('mark', {
      style: {
        background: value ? dlv_umd_default()(intl, dictionaryKey) ? 'rgba(119,231,117,.5)' : 'rgba(229,226,41,.5)' : 'rgba(228,147,51,.5)'
      },
      title: id
    }, value);
  }
  return value;
}

/** `<Text>` renders internationalized text.
 *	It attempts to look up translated values from a dictionary in context.
 *
 *	Template strings can contain `{{field}}` placeholders,
 *	which injects values from the `fields` prop.
 *
 *	When string lookup fails, renders its children as fallback text.
 *
 *	@param {Object}       props               props
 *	@param {String}       props.id            Key to look up in intl dictionary, within any parent scopes (`$scope1.$scope2.$id`)
 *	@param {ReactElement} [props.children]    Fallback text if no definition is found
 *	@param {Object}       [props.fields={}]   Values to inject into template `{{fields}}`. Values in the `fields` object will be coerced to strings, with the exception of `<Text/>` nodes which will be resolved to their translated value
 *	@param {Number}       [props.plural]      Integer "count", used to select plural forms
 *
 *	@example
 *	// If there is no dictionary in context..
 *	<Text id="foo">The Foo</Text>
 *	// ..produces the text:
 *	"The Foo"
 *
 *	@example
 *	// Given a dictionary and some fields..
 *	<IntlProvider definition={{ foo:'Le Feux {{bar}}' }}>
 *		<Text id="foo" fields={{ bar: 'BEAR' }}>The Foo</Text>
 *	</IntlProvider>
 *	// ..produces the text:
 *	"Le Feux BEAR"
 *
 *	@example
 *	// Within a scope, both `id` and the definition are namespaced..
 *	<IntlProvider scope="weather" definition={{ foo:'Le Feux' }}>
 *		<Text id="foo">The Foo</Text>
 *	</IntlProvider>
 *	// ..produces the text:
 *	"Le Feux"
 */
function Text(ref) {
  var id = ref.id;
  var fallback = ref.children;
  var plural = ref.plural;
  var fields = ref.fields;
  var ref$1 = (0,hooks_module/* useContext */.qp)(IntlContext);
  var intl = ref$1.intl;
  var value = translate(id, intl && intl.scope, intl && intl.dictionary, fields, plural, fallback);
  return (0,preact_module.h)(HighlightI18N, {
    id: id,
    value: value
  });
}

/** Translates the property values in an Object, returning a copy.
 *	**Note:** By default, `String` keys will be treated as Intl ID's.
 *	Pass `true` to return an Object containing *only* translated
 *	values where the prop is a <Text /> node.
 *
 *	@private
 *	@param {Object} props	An object with values to translate
 *	@param {Object} intl	An intl context object (eg: `context.intl`)
 *	@param {Boolean} [onlyTextNodes=false]	Only process `<Text />` values
 *	@returns {Object} translatedProps
 */
function translateMapping(props, intl, onlyTextNodes) {
  var out = {};
  intl = intl || {};
  props = preact_i18n_esm_select(props);
  for (var name in props) {
    if (props.hasOwnProperty(name) && props[name]) {
      var def = props[name];

      // if onlyTextNodes=true, skip any props that aren't <Text /> vnodes
      if (!onlyTextNodes && typeof def === 'string') {
        out[name] = translate(def, intl.scope, intl.dictionary);
      } else if (def.type === Text) {
        // it's a <Text />, just grab its props:
        def = preact_i18n_esm_assign({
          // use children as fallback content
          fallback: def.props.children
        }, def.props);
        out[name] = translate(def.id, intl.scope, intl.dictionary, def.fields, def.plural, def.fallback);
      }
    }
  }
  return out;
}

/** `<Localizer />` is a Compositional Component.
 *	It "renders" out any `<Text />` values in its child's props.
 *
 *	@name Localizer
 *	@param {Object} props
 *	@param {Object} props.children	Child components with props to localize.
 *	@param {Object} context
 *	@param {Object} context.intl		[internal] dictionary and scope info
 *	@example
 *	<Localizer>
 *		<input placeholder={<Text id="username.placeholder" />} />
 *	</Localizer>
 *	// produces:
 *	<input placeholder="foo" />
 *
 *	@example
 *	<Localizer>
 *		<abbr title={<Text id="oss-title">Open Source Software</Text>}>
 *			<Text id="oss">OSS</Text>
 *		</abbr>
 *	</Localizer>
 *	// produces:
 *	<abbr title="Open Source Software">OSS</abbr>
 */
function Localizer(ref) {
  var children = ref.children;
  var ref$1 = (0,hooks_module/* useContext */.qp)(IntlContext);
  var intl = ref$1.intl;
  return children && children.length ? children.map(function (child) {
    return (0,preact_module/* cloneElement */.Tm)(child, translateMapping(child.props, intl, true));
  }) : children && (0,preact_module/* cloneElement */.Tm)(children, translateMapping(children.props, intl, true));
}
function objectWithoutProperties$1(obj, exclude) {
  var target = {};
  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }
  return target;
}

/* eslint-disable react/no-danger */

/** `<MarkupText>` is just like {@link Text} but it can also contain html markup in rendered strings.  It wraps its contents in a `<span>` tag.
 *
 *	@param {Object} props				props
 *	@param {String} props.id			Key to look up in intl dictionary, within any parent scopes (`$scope1.$scope2.$id`)
 *	@param {Object} [props.fields={}]	Values to inject into template `{{fields}}`.  Values in the `fields` object will be coerced to strings, with the exception of `<Text/>` nodes which will be resolved to their translated value
 *	@param {Number} [props.plural]		Integer "count", used to select plural forms
 *
 *	@example
 *	// If there is no dictionary in context..
 *	<MarkupText id="foo"><b>The Foo</b></MarkupText>
 *	// ..produces the vnode:
 *	<span><b>The Foo</b></span>
 *
 *	@example
 *	// Given a dictionary and some fields..
 *	<IntlProvider definition={{ foo:'Le Feux <b>{{bar}}</b>' }}>
 *		<MarkupText id="foo" fields={{ bar: 'BEAR' }}>The Foo</MarkupText>
 *	</IntlProvider>
 *	// ..produces the vnode:
 *	<span>Le Feux <b>BEAR</b></span>
 *
 *	@example
 *	// Within a scope, both `id` and the definition are namespaced..
 *	<IntlProvider scope="weather" definition={{ foo:'Le <a href="http://foo.com">Feux</a>' }}>
 *		<MarkupText id="foo">The Foo</MarkupText>
 *	</IntlProvider>
 *	// ..produces the vnode:
 *	<span>Le <a href="http://foo.com">Feux</a></span>
 *
 *	@example
 *	// renders nothing if there is no key match and no fallback
 *	<div><MarkupText /></div>
 *	// ..produces the vnode:
 *	<div/>
 */
function MarkupText(ref) {
  var id = ref.id;
  var fields = ref.fields;
  var plural = ref.plural;
  var children = ref.children;
  var rest = objectWithoutProperties$1(ref, ["id", "fields", "plural", "children"]);
  var props = rest;
  return (0,preact_module.h)(Localizer, null, (0,preact_module.h)(Html, Object.assign({}, {
    html: (0,preact_module.h)(Text, {
      id: id,
      fields: fields,
      plural: plural,
      children: children
    }),
    id: id
  }, props)));
}
function Html(ref) {
  var html = ref.html;
  var id = ref.id;
  var rest = objectWithoutProperties$1(ref, ["html", "id"]);
  var props = rest;
  return (0,preact_module.h)(HighlightI18N, {
    id: id,
    value: !html ? html : typeof html === 'string' ? (0,preact_module.h)(preact_markup_module, Object.assign({}, {
      type: "html",
      trim: false
    }, props, {
      markup: html
    })) : (0,preact_module.h)('span', null, html)
  });
}

/** `@withText()` is a Higher Order Component, often used as a decorator.
 *
 *	It wraps a child component and passes it translations
 *	based on a mapping to the dictionary & scope in context.
 *
 *	@param {Object|Function|String} mapping		Maps prop names to intl keys (or `<Text>` nodes).
 *
 *	@example @withText({
 *		placeholder: 'user.placeholder'
 *	})
 *	class Foo {
 *		// now the `placeholder` prop is our localized String:
 *		render({ placeholder }) {
 *			return <input placeholder={placeholder} />
 *		}
 *	}
 *
 *	@example @withText({
 *		placeholder: <Text id="user.placeholder">fallback text</Text>
 *	})
 *	class Foo {
 *		render({ placeholder }) {
 *			return <input placeholder={placeholder} />
 *		}
 *	}
 *
 *	@example @withText('user.placeholder')
 *	class Foo {
 *		// for Strings/Arrays, the last path segment becomes the prop name:
 *		render({ placeholder }) {
 *			return <input placeholder={placeholder} />
 *		}
 *	}
 *
 *	@example <caption>Works with functional components, too</caption>
 *	const Foo = withText('user.placeholder')( props =>
 *		<input placeholder={props.placeholder} />
 *	)
 *
 * 	@example <caption>getWrappedComponent() returns wrapped child Component</caption>
 *	const Foo = () => <div/>;
 *	const WrappedFoo = withText('user.placeholer')(Foo);
 *	WrappedFoo.getWrappedComponent() === Foo; // true
 */
function withText(mapping) {
  return function withTextWrapper(Child) {
    function WithTextWrapper(props, context) {
      var ref = (0,hooks_module/* useContext */.qp)(IntlContext);
      var intl = ref.intl;
      var map = typeof mapping === 'function' ? mapping(props, {
        intl: intl
      }) : mapping;
      var translations = translateMapping(map, intl);
      return (0,preact_module.h)(Child, preact_i18n_esm_assign(preact_i18n_esm_assign({}, props), translations));
    }
    WithTextWrapper.getWrappedComponent = Child && Child.getWrappedComponent || function () {
      return Child;
    };
    return WithTextWrapper;
  };
}

/** `useText` is the hook version of {@link withText}
 *
 *	@param {Object|Function|String} mapping		Maps prop names to intl keys (or `<Text>` nodes).
 *
 *	@example function MyComponent() {
 *		const { placeholder } = useText({
 *			placeholder: 'user.placeholder'
 *		});
 *		return <input placeholder={placeholder} />
 *	}
 *
 *	@example function MyComponent() {
 *		const { placeholder } = useText({
 *			placeholder: <Text id="user.placeholder">fallback text</Text>
 *		});
 *		return <input placeholder={placeholder} />
 *	}
 *
 *	@example function MyComponent() {
 *		// for Strings/Arrays, the last path segment becomes the prop name:
 *		const { placeholder } = useText('user.placeholder');
 *
 *		return <input placeholder={placeholder} />
 *	}
 */
function useText(mapping) {
  var ref = (0,hooks_module/* useContext */.qp)(IntlContext);
  var intl = ref.intl;
  return translateMapping(typeof mapping === 'function' ? mapping({
    intl: intl
  }) : mapping, intl);
}
intl.intl = intl;
intl.IntlContext = IntlContext;
intl.IntlProvider = preact_i18n_esm_IntlProvider;
intl.Text = Text;
intl.MarkupText = MarkupText;
intl.Localizer = Localizer;
intl.withText = withText;
intl.useText = useText;
intl.translate = translate;
/* harmony default export */ const preact_i18n_esm = ((/* unused pure expression or super */ null && (intl)));

;// CONCATENATED MODULE: ./node_modules/preact-i18n/src/lib/util.js











function util_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { util_typeof = function _typeof(obj) { return typeof obj; }; } else { util_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return util_typeof(obj); }
/** Check if an object is not null or undefined
 *	@private
 */
function util_defined(obj) {
  return obj !== null && obj !== undefined;
}

/** A simpler Object.assign
 *  @private
 */
function util_assign(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }
  return obj;
}

/** Recursively copy keys from `source` to `target`, skipping truthy values already in `target`.
 *	@private
 */
function util_deepAssign(target, source) {
  var out = util_assign({}, target);
  for (var i in source) {
    if (source.hasOwnProperty(i)) {
      if (target[i] && source[i] && util_typeof(target[i]) === 'object' && util_typeof(source[i]) === 'object') {
        out[i] = util_deepAssign(target[i], source[i]);
      } else {
        out[i] = target[i] || source[i];
      }
    }
  }
  return out;
}

/** select('foo,bar') creates a mapping: `{ foo, bar }`
 *	@private
 */
function util_select(properties) {
  properties = properties || {};
  if (typeof properties === 'string') {
    properties = properties.split(',');
  }
  if ('join' in properties) {
    var selected = {};
    for (var i = 0; i < properties.length; i++) {
      var val = properties[i].trim();
      if (val) selected[val.split('.').pop()] = val;
    }
    return selected;
  }
  return properties;
}
;// CONCATENATED MODULE: ./node_modules/preact-i18n/src/contexts/intl-context.js

var intl_context_IntlContext = (0,preact_module/* createContext */.kr)({
  intl: {}
});
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
;// CONCATENATED MODULE: ./node_modules/preact-i18n/src/components/highlight-i18n.js






/** Highlight/colorize the i18n'd node if `mark` is set on `intl` in context.  If not, just returns `value`
 *
 *	@private
 *	@param {String|VNode} value	The l10n'd text/vnode to highlight or pass through
 *	@param {string} id	The key used to lookup the value in the intl dictionary
 */
function highlight_i18n_HighlightI18N(_ref) {
  var value = _ref.value,
    id = _ref.id;
  var _useContext = (0,hooks_module/* useContext */.qp)(intl_context_IntlContext),
    intl = _useContext.intl;
  if (intl && intl.mark) {
    var dictionaryKey = "dictionary".concat(intl && intl.scope ? ".".concat(intl.scope) : '', ".").concat(id);
    return (0,preact_module.h)("mark", {
      style: {
        background: value ? dlv_umd_default()(intl, dictionaryKey) ? 'rgba(119,231,117,.5)' : 'rgba(229,226,41,.5)' : 'rgba(228,147,51,.5)'
      },
      title: id
    }, value);
  }
  return value;
}
;// CONCATENATED MODULE: ./node_modules/preact-i18n/src/components/text.js






/** `<Text>` renders internationalized text.
 *	It attempts to look up translated values from a dictionary in context.
 *
 *	Template strings can contain `{{field}}` placeholders,
 *	which injects values from the `fields` prop.
 *
 *	When string lookup fails, renders its children as fallback text.
 *
 *	@param {Object}       props               props
 *	@param {String}       props.id            Key to look up in intl dictionary, within any parent scopes (`$scope1.$scope2.$id`)
 *	@param {ReactElement} [props.children]    Fallback text if no definition is found
 *	@param {Object}       [props.fields={}]   Values to inject into template `{{fields}}`. Values in the `fields` object will be coerced to strings, with the exception of `<Text/>` nodes which will be resolved to their translated value
 *	@param {Number}       [props.plural]      Integer "count", used to select plural forms
 *
 *	@example
 *	// If there is no dictionary in context..
 *	<Text id="foo">The Foo</Text>
 *	// ..produces the text:
 *	"The Foo"
 *
 *	@example
 *	// Given a dictionary and some fields..
 *	<IntlProvider definition={{ foo:'Le Feux {{bar}}' }}>
 *		<Text id="foo" fields={{ bar: 'BEAR' }}>The Foo</Text>
 *	</IntlProvider>
 *	// ..produces the text:
 *	"Le Feux BEAR"
 *
 *	@example
 *	// Within a scope, both `id` and the definition are namespaced..
 *	<IntlProvider scope="weather" definition={{ foo:'Le Feux' }}>
 *		<Text id="foo">The Foo</Text>
 *	</IntlProvider>
 *	// ..produces the text:
 *	"Le Feux"
 */
function text_Text(_ref) {
  var id = _ref.id,
    fallback = _ref.children,
    plural = _ref.plural,
    fields = _ref.fields;
  var _useContext = (0,hooks_module/* useContext */.qp)(intl_context_IntlContext),
    intl = _useContext.intl;
  var value = translate_translate(id, intl && intl.scope, intl && intl.dictionary, fields, plural, fallback);
  return (0,preact_module.h)(highlight_i18n_HighlightI18N, {
    id: id,
    value: value
  });
}
;// CONCATENATED MODULE: ./node_modules/preact-i18n/src/lib/template.js






var template_EMPTY = {};

/** Populate {{template.fields}} within a given string.
 *
 *	@private
 *	@param {String} template	The string containing fields to be resolved
 *	@param {Object} [fields={}]	Optionally nested object of fields, referencable from `template`.
 *	@example
 *		template('foo{{bar}}', { bar:'baz' }) === 'foobaz'
 */
function template_template(template, fields, scope, dictionary) {
  return template && template.replace(/\{\{([\w.-]+)\}\}/g, template_replacer.bind(null, fields || template_EMPTY, scope, dictionary));
}

/** Replacement callback for injecting fields into a String
 *	@private
 */
function template_replacer(currentFields, scope, dictionary, s, field) {
  var parts = field.split('.'),
    v = currentFields;
  for (var i = 0; i < parts.length; i++) {
    v = v[parts[i]];
    if (v == null) return ''; // eslint-disable-line eqeqeq

    //allow field values to be <Text /> nodes
    if (v && v.type === text_Text) {
      return translate_translate(v.props.id, scope, dictionary, v.props.fields, v.props.plural, v.props.fallback);
    }
  }
  // allow for recursive {{config.xx}} references:
  if (typeof v === 'string' && v.match(/\{\{/)) {
    v = template_template(v, currentFields);
  }
  return v;
}
;// CONCATENATED MODULE: ./node_modules/preact-i18n/src/lib/translate.js








function translate_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { translate_typeof = function _typeof(obj) { return typeof obj; }; } else { translate_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return translate_typeof(obj); }




/** Attempts to look up a translated value from a given dictionary.
 *  Also supports json templating using the format: {{variable}}
 *  Falls back to default text.
 *
 *  @param {String} id  			Intl field name/id (subject to scope)
 *  @param {String} [scope='']		Scope, which prefixes `id` with `${scope}.`
 *  @param {Object} dictionary		A nested object containing translations
 *  @param {Object} [fields={}]		Template fields for use by translated strings
 *  @param {Number} [plural]		Indicates a quantity, used to trigger pluralization
 *  @param {String|Array} [fallback]	Text to return if no translation is found
 *  @returns {String} translated
 */
function translate_translate(id, scope, dictionary, fields, plural, fallback) {
  if (scope) id = scope + '.' + id;
  var value = dictionary && dlv_umd_default()(dictionary, id);

  // plural forms:
  // key: ['plural', 'singular']
  // key: { none, one, many }
  // key: { zero, one, other }
  // key: { singular, plural }
  if ((plural || plural === 0) && value && translate_typeof(value) === 'object') {
    if (value.splice) {
      value = value[plural] || value[0];
    } else if (plural === 0 && util_defined(value.none || value.zero)) {
      value = value.none || value.zero;
    } else if (plural === 1 && util_defined(value.one || value.singular)) {
      value = value.one || value.singular;
    } else {
      value = value.some || value.many || value.plural || value.other || value;
    }
  }
  return value && template_template(value, fields, scope, dictionary) || fallback || null;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/i18n/messages/en.json
const en_namespaceObject = JSON.parse('{"table":{"common":{"column":"Column"},"move_column_cant_split_merged_cells":{"title":"Unable to move column","text":"Cannot move a column into a merged cell. Unmerge then try again."},"move_column_cant_move_part_of_merged_cells":{"title":"Unable to move column","text":"The column you\'re trying to move contains part of a merged cell. If you want to move the column, unmerge the cells first."},"move_column_failed":{"title":"Unable to move column","text":"An unexpected error has occured while moving a column, plese try again."},"move_row_cant_split_merged_cells":{"title":"Unable to move row","text":"Cannot move a row into a merged cell. Unmerge then try again."},"move_row_cant_move_part_of_merged_cells":{"title":"Unable to move row","text":"The row you\'re trying to move contains part of a merged cell. If you want to move the row, unmerge the cells first."},"move_row_cant_move_in_sortable_table":{"title":"Unable to move row","text":"Cannot move a row in a sortable table. Cancel sorting then try again."},"move_row_cant_move_in_filtered_table":{"title":"Unable to move row","text":"Cannot move a row in a filtered table. Cancel filter then try again."},"move_row_failed":{"title":"Unable to move row","text":"An unexpected error has occured while moving a row, plese try again."},"first_move_column_or_row_message":"You can select multiple rows or columns by holding down the CTRL button and clicking on the desired rows or columns.","menu":{"delete":"Delete","help":"Help","delete_column":{"one":"Delete column","many":"Delete {{count}} columns"},"delete_row":{"one":"Delete row","many":"Delete {{count}} rows"},"add":"Add","add_row_before":{"one":"Row above","many":"{{count}} rows above"},"add_row_after":{"one":"Row below","many":"{{count}} rows below"},"add_col_before":{"one":"Column left","many":"{{count}} columns left"},"add_col_after":{"one":"Column right","many":"{{count}} columns right"},"copy_cell":{"one":"Copy cell","many":"Copy cells"},"copy_table":"Copy table","table_layout":{"name":"Table layout","column_headings":"Column headings","row_headings":"Row headings"},"import_csv":"Import from CSV","merge_cells":"Merge cells","insert_checkbox":"Insert checkbox","background_color":"Background color","formatting":"Formatting","clear":"Clear","reset":"Reset","divide_cells":"Unmerge cells","type":{"name_cell":"Cell type","name_cells":"Cells type","name_column":"Column type","name_columns":"Columns type","type_cell":{"one":"Cell type","many":"Cells type"},"type_col":{"one":"Column type","many":"Columns type"},"same_as_column":"Same as column","reset_cells":"Reset cells to default","none":"Multi type","text":"Text","textline":"Text","number":"Number","attachment":"Files","checkbox":"Checkbox","multiselect":"Multiple select","singleselect":"Single select","collaborator":"Collaborator","currency":"Currency","date":"Date","link":"Link","rating":"Rating","progress":"Progress","mention":"Mention"},"number_format":{"name":"Number format","number":"Number","commas":"Number with commas","percent":"Percent"},"currency_format":{"name":"Currency type","dollar":"Dollar","euro":"Euro","yen":"Yen","yuan":"Yuan","rouble":"Rouble","pound":"Pound","rupee":"Rupee","hryvnia":"Hryvnia","won":"Won","frank":"Frank","real":"Real","other":"Other","stick":"Show symbol","before":"Before","after":"After"},"decimal_format":{"name":"Decimal separator","comma":"Comma","point":"Point","hint":"The separator is used for decimal places. Comma decimal separators will look like 1.000,99, and point separators look like 1,000.99"},"progress_format":{"name":"Progress options","simple":"Simple","colored":"Colored","start_from":"Start from (0-100)","default_amount":"Default amount (0-100)"},"rating_format":{"name":"Rating options","star":"Star","flag":"Flag","heart":"Heart","amount":"Amount (1-10)"},"date_format":{"name":"Date/Time format"},"mention_panel":{"open":"Open","edit":"Edit","clear":"Clear"},"color_numbers":{"name":"Color numbers","enable":"Enable color numbers"},"filter":"Filter","comment":"Comment"},"formatting_menu":{"align_left":"Left","align_center":"Center","align_right":"Right","valign_top":"Top","valign_center":"Middle","valign_bottom":"Bottom","text":"Text","text_align":"Text align","text_color":"Text color","bold":"Bold","italic":"Italic","strikethrough":"Strikethrough","underline":"Underline"},"col_menu":{"add_column_after":{"one":"Add column right","many":"Add {{count}} columns right"},"add_column_before":{"one":"Add column left","many":"Add {{count}} columns left"},"duplicate_column":{"one":"Duplicate column","many":"Duplicate columns"},"rename":"Rename"},"row_menu":{"add_row_after":{"one":"Add row below","many":"Add {{count}} rows below"},"add_row_before":{"one":"Add row above","many":"Add {{count}} rows above"}},"warning":{"merge_different":"Can\'t merge different types of objects","convert_merged":"Can\'t convert merged cells"},"select":{"create_list":"Type to create a list","create_item":"Type to create an item","create_option":"Type to create option","create_label":"Type to create label","create":"Create","delete":"Delete"},"attachment":{"upload_more":"Upload file(s)","downloading":"Downloading"},"collaborator":{"placeholder":"Type to add people","no_result":"No results","loading":"Loading...","unknown":"Unknown Person"},"checkbox":{"checked":"Yes","not_checked":"No"},"sorting":{"name":"Sorting","sort":"Sort","disable":"Remove sort","change":"Click for change","asc":{"common":"Ascending","text":"Sort A-Z","number":"Sort 1-9","checkbox":"Unselected first"},"desc":{"common":"Descending","text":"Sort Z-A","number":"Sort 9-1","checkbox":"Selected first"},"warning":{"column_merged":{"title":"Unable to sort column","text":"Can\'t sort column with merged cells"},"table_rowspan":{"title":"Unable to sort column","text":"Can\'t sort table with merged rows"},"merge":{"title":"Cells cannot be merged","text":"Cells cannot be merged while column sorting is active. Disable sorting and try again."},"different_currencies":{"title":"Sort warning","text":"You\'re using different currencies in one column. Sorting may be incorrect."}},"exit_dialog":{"title":"Remove sort","toggle":"Keep sorted","text_keep":"Keep sorted","text_no_keep":"Column order will be restored to its initial order before sorting was applied","apply":"Apply"}},"filter":{"by_field":"Filter by this field","empty_table":"All records are filtered","popup_title":"In this table, show records","empty_filters":"No conditions are applied to this database","where":"Where","or":"Or","and":"And","add_condition":"Add condition","clear_all":"Clear all","contains":"contains","is":"is","is_not":"is not","contains_not":"contains not","has_any_of":"has any of","has_none_of":"has none of","empty":"empty","not_empty":"not empty","filetype":"filetype","select_users_placeholder":"Select users","type_text_placeholder":"Type text","type_text_or_select_placeholder":"Type text or select","type_number_placeholder":"Type number","select_type_placeholder":"Select type","select_date_placeholder":"Select date","date":{"today":"Today","yesterday":"Yesterday","tomorrow":"Tomorrow","custom":"Custom"},"filetypes":{"images":"Images","documents":"Documents","media":"Media","other":"Other"},"warning":{"cells_merged":{"title":"Unable to filter table","text":"Can\'t filter column with merged cells"},"merge":{"title":"Cells cannot be merged","text":"Cells cannot be merged while table filter is active. Disable filter and try again."},"column_multitype":{"title":"Unable to filter table","text":"There is no such possibility to filter columns with Multi type. Please, try to convert to another type and try again."},"table_not_have_typed_columns":{"title":"Unable to filter table","text":"No columns available for filtering."}},"enable_filter":"Enable filter","disable_filter":"Disable filter"},"wrap_cells":{"layout_menu":"Wrap cells","warnings":{"merge":{"title":"Unable to merge cells","text":"Unable to merge cells in nowrap mode"},"toggle":{"title":"Unable to switch option","text":"The table contains merged cells"}}},"duplicate_column":{"title":"Duplicate column","text_1":"Duplicate column content","text_2":"You can duplicate the whole column containing data or leave duplicated column empty","accept":"Duplicate","copy":"copy"},"convert_column":{"title":"Change column type","text_before":"This column contains values. Changing the column type will erase some of the values. Use","text_cmd":"undo","text_after":"command to reverse changes if needed.","accept":"Change type"},"merge_cells_with_comments":{"title":"Merging cells","text":"The cells will be merged from left to right and the new cell will show a comment from the left cell.","accept":"Merge"},"summary":{"layout_menu":"Show calculation bar","name":{"none":"None","all":"All","empty":"Empty","fill":"Filled","unique":"Unique","empty_percent":"Percent empty","fill_percent":"Percent filled","unique_percent":"Percent unique","sum":"Sum","average":"Average","min":"Min","max":"Max","median":"Median","min_date":"Earliest date","max_date":"Latest date","range_days":"Date range (days)","range_month":"Date range (month)","checked":"Checked","unchecked":"Unchecked","checked_percent":"Percent checked","unchecked_percent":"Percent unchecked","filter_rating":"With rating:","filter_progress":"With progress:","filesize_min":"Min size","filesize_max":"Max size"},"item":{"none":"Calculate","min_date":"Earliest","max_date":"Latest","range_days":"Range (days)","range_month":"Range (month)","checked_percent":"Checked","unchecked_percent":"Unchecked","filter_rating":"With rating","filter_progress":"With progress"}},"comments":{"tooltip":{"one":"Comment","more":"Comments"}}},"file":{"image_viewer":{"could_not_load_image":"Couldn\'t load the image"},"download_file":"Download {{name}}","listen_file":"Play {{name}}","stop_file":"Stop {{name}}","uploading":"Uploading","wrtc":{"how_to_fix":"How to fix it?","how_to_url":"https://nimbusweb.me/s/share/5441210/4qccr41slk6wsw61h5fb","how_to_url2":"https://nimbusweb.me/s/share/5607239/l55bgak2ivs9bfptruka#b1995924032_670","rec_err_au":"Recording error. No microphone access.","rec_err_vi":"Recording error. No access to microphone/webcam. ","allow_micro":"Allow Access to microphone","allow_media":"Select the window you want to record","select_opt":"What will be recorded","screenonly":"Screen only","camonly":"Cam only","screencam":"Screen + Cam","enable_micro":"Enable microphone","startRecording":"Start recording","stopRecording":"Stop recording","pauseRecording":"Pause recording","resumeRecording":"Resume recording","cancelRecording":"Сancel recording","confirmCancel":"Are you sure you want to cancel the video recording?","cancel":"Сancel","prepareUpload":"Please wait, preparing to upload record","hasTmpRecord":"The recording was interrupted but not lost","restore":"Restore","delete":"Delete","recordOnAnotherDevice":"Recording is in progress on another device ..."},"menu":{"enabled":"Enabled","disabled":"Disabled","open_in_new_tab":"Open in new tab","copy_link":"Copy link to file","expand_in_full_window":"Expand in Full Window","autoplay":"Autoplay","sound_default":"Sound by default","sound_loop":"Loop","sound_hideControls":"Hide controls","sound_showPanel":"Show top panel","shadow_video":"Shadow for video","video_params":"Video settings","disallow_download":"Downloading","for_note":"For workspaces users","for_share":"Public page","motion_video":"Motion video","preview_video":"Change preview","preview_video_btn":"Preview","print":"Print","convert_to_image":"Convert to image","convert_to_file":"Convert to file","style":"Style","shadow_image":"Shadow for image","rename":"Rename","replace":"Replace","delete":"Delete","download":"Download","get_text_from_image":"Get text from image","view_as":"View as","single_page":"Single page","all_pages":"All pages","cta_motion_video_message":"CTA is enabled for videos. You cannot use CTA and Motion video at the same time. Disable CTA and try enabling Motion video again.","cta_loop_message":"CTA is enabled for videos. You cannot use CTA and Loop at the same time. Disable CTA and try enabling Loop again.","grid":"Grid","cta_drop_in_grid":"CTA is enabled for videos. We recommend checking the correctness of the CTA display after transferring the video into a grid column.","cta_exists_in_grid":"The grid column has a video with an active CTA. Please check if it is correct after the transfer."},"downloading":"Downloading","attachment_not_found_error":"Error while uploading","pdf_viewer":{"initializing_full_window_view":"Initializing Full Window view","preparing_document_for_printing":"Preparing document for printing...","printing_initialization":"Printing initialization...","abort":"abort","set_page_as_default":"Set page as default","unset_page_as_default":"Default page. Click to make the page normal."},"video_just_uploaded_codec_error":"You are trying to upload a video that has been encoded with the {codec} codec. We do not guarantee the correct playback of this video on all browsers. We recommend converting the video to another format and uploading it again.","video_codec_error":"This video is encoded with {codec} codec, which is not supported in your browser.","safari_webm_not_support":"Currently, Safari browsers do not support WEBM format. Try to open the page in another browser, such as Google Chrome or Mozilla Firefox.","video_transcribe":"Transcribe","video_summary":"Summary","video_meeting_notes":"Meeting Notes","video_ask_ai":"Ask AI"},"image":{"text_from_image_popup":{"title":"Text from image","no_text":"There is no text","copy":"Copy all text"},"unknown_error":"The link is wrong","add_image":"Paste link or ","add_image_or":"or","add_image_small":"Paste or ","browse":"browse","browse_image":"Browse image","too_large_error":"The image size is too large","image_info_dialog":{"title":"Image info","type":"Type","size":"Size","location":"Location","copy_link":"Copy link"},"rotate_wait":{"full":"Please wait","medium":"Wait"},"attachment_not_found_error":"An unexpected error has occured with the image","readonly_placeholder":"Empty image","unsplash":{"name":"Unsplash","header":"Search image","placeholder":"Search for an image","search":"Search","description":"Search to find more results.","no_result":"No images found.","caption_preffix":"Photo by"},"comments":"Comments"},"attachment":{"unknown_error":"Something went wrong, try choosing another file","attachment_is_being_uploaded":"A file is being uploaded on another device...","attachment_will_be_downloaded_online":"The file will be downloaded when you are online.","attachment_preview_is_not_available":"Preview is not available.","choose_a_file":"Choose files","wait_resolving_without_info":"Please wait..."},"video":{"player":{"play":"Play","pause":"Pause","volume":"Volume","fullscreen_on":"Fullscreen","fullscreen_off":"Exit Fullscreen","watch_again":"Watch again"}},"search":{"placeholder":"Find in page","matches":"Matches:"},"copy":{"copied":"Copied!","copy_to_clipboard":"Copy to clipboard"},"apply":"Apply","done":"Done","block_menu":{"align":{"left":"Left align","center":"Center align","right":"Right align","justify":"Justify"},"indent":{"indent":"Increase indent","outdent":"Decrease indent"},"tooltip":"Drag to move\\n<span>Click to open menu</span>","copy_tooltip":"Copy link","color":{"background_color":"Background color","color":"Color","line_color":"Line color","line_type":"Line type","player_color":"Player\'s color"},"line_type":{"default":"Standart line","dotted":"Dots"},"add":{"name":"Add block","above":"Above","below":"Below","left":"Left","right":"Right","above_column":"Above column","below_column":"Under column"},"convert_to":{"name":"Convert to","to_do_list":"Checklist","number_list":"Number List","bullet_list":"Bullet List","paragraph":"Paragraph","large_heading":"Large Heading","medium_heading":"Medium Heading","small_heading":"Small Heading","large_heading_toggle":"Collapsible Large Heading","medium_heading_toggle":"Collapsible Medium Heading","small_heading_toggle":"Collapsible Small Heading","code":"Code","quote":"Quote","hint":"Hint","image":"Image","file":"File","remote_frame":"Embed","link":"Link","bookmark":"Bookmark","button":"Button","toggle":"Toggle Block","step":"Steps"},"comment_block":"Comment","edit":"Edit","duplicate":"Duplicate","copy_block":"Copy block","copy_blocks":"Copy blocks","copy_link":"Copy Link","delete":"Delete","replace":"Replace","blot_lock":"Lock block","blot_unlock":"Unlock block","set_as_preview":"Set as preview","get_text_from_image":"Get text from image","edit_image":"Edit image","download":"Download","view_full_size":"View full size","open_in_new_tab":"Open in new tab","image_info":"Image info","rotate_image":"Rotate","add_sub_task":"Add subtask","add_sub_text":"Add subtext","layout":"Layout","embed_align":{"left":"Left align","center":"Center align","right":"Right align","default":"Default size","full_width":"Full width"},"expand_all":"Expand all","collapse_all":"Collapse all","add_caption":"Add caption","blot_locked_admin":"Editing of the block is denied. Click to unlock it.","blot_locked_admins":"Editing of the blocks is denied. Click to unlock it.","blot_locked_user":"You don’t have permission to edit this bock. Contact your organization admin.","show_header":"Show top bar","show_borders":"Show borders","rename":"Rename"},"convert_menu_groups":{"suggestions":"Suggestions","basic":"Basic","advanced":"Advanced","media":"Media","embed":"Integrations","views":"Views","templates":"Templates","helpful_links":"Helpful links"},"embedded_menu":{"start_typing":"Type \\"/\\" or add","start_typing_full":"Start writing or type \\"/\\", \\"@\\"","more_items":"More items...","add_an_element":"Add an element","paragraph":"Paragraph","todo":"Checkbox list","numbered_list":"Numbered list","bullet_list":"Bullet list","table":"Table","image":"Image","file":"File","audioRec":"Audio Record","videoRec":"Video Record","recordExist":"You cannot start a new recording until the previous one is completed. End or delete the previous record to start a new one.","large_heading":"Heading 1","medium_heading":"Heading 2","small_heading":"Heading 3","large_heading_toggle":"Collapsible Large Heading","medium_heading_toggle":"Collapsible Medium Heading","small_heading_toggle":"Collapsible Small Heading","section_break":"Line","link":"Link","code":"Code","quote":"Quote","hint":"Hint","hint_placeholder":"Type something","mention":"Mention member","outline":"Outline","remote_frame":"Embed: Link, iFrame, JS Code","integrations":"Integrations","google_drive":"Google Drive","google_sheets":"Google sheets","html":"HTML","toggle":"Toggle block","tasks_list":"Task list","lock_blot":"Lock block","link_page":"Link page / Create","date":"Date","more_integrations":"more integrations","two_columns":"2 columns","meeting_notes":"Marketing Strategy","marketing_brief":"Marketing Quarterly Planning ","content_plan":"Content plan","more_templates":"more templates","get_feedback":"Get a feedback","contact_support":"Contact support","learn_nimbus":"Learn Nimbus","footer_top":"Did you know? You can start typing to search the list","footer_bottom":"Can’t find smth you want?","footer_link":"Tell us","add_note":"New page","database_with_options":"Database","board":"Kanban / Task Board","progress":"Progress","dropdown_list":"Dropdown list","uploader":"File uploader","use_ai":"Use Fusebase AI","helper":"AI helper","summarize":"Summarize","explain":"Explain","improve":"Improve","spelling":"Fix spelling and grammar","cta":"Call to actions","shorter":"Make shorter","longer":"Make longer","step":"Steps"},"button":{"title":"Title","id_info_tooltip":"This ID can be used in the future when editing the CSS file.","address":"URL or Email","open_in_new_tab":"Open in new tab","shape":"Button shape","background":"Background","size":"Button size","small":"Small","medium":"Medium","big":"Big","cancel":"Cancel","done":"Done","length_error":"The text is too large for the button. Try selecting less text (no more than 50 characters).","type":"Button type","default":"Default","withShadow":"Button with shadow","3d":"3d button","convert":{"popup_title":"Convert to button"}},"link":{"open":"Open","send":"Send","copy":"Copy","edit":"Edit","remove":"Remove","text_label":"Text","url_label":"Link","email_label":"Address","copied":"Link copied to clipboard","cancel":"Cancel","done":"Done"},"syntax":{"menu":{"language":"Language","theme":"Theme","wrap":"Enable wrap","unwrap":"Disable wrap","lineNumbersOn":"Show line numbers","lineNumbersOff":"Hide line numbers"},"convert":{"popup_title":"Convert to code","blots_have_comments":"There are comments in the text that will be deleted during conversion.","text_has_inline_comments":"There are comments inside the text that will be deleted during conversion.","confirm":"Convert"}},"list":{"list_style":"List style","type_default":"Default","type_rectangle":"Rectangle","type_star":"Star","type_dart":"Dart","type_rounded":"Rounded","type_arrow":"Arrow","type_diamond":"Diamond"},"caption":{"placeholder":"Add caption"},"mention":{"show_all":"Show all","show_all_users":"Show all","placeholder":"Showing recent or type to search","user":"People","workspace":"Workspaces","folder":"Folders","note":"Pages","no_results":"No results","offline_message":"Mention only works with active connection. Turn on the Internet and try again.","info":{"note":{"one":"page","some":"pages","many":"pages"},"subfolder":{"one":"subfolder","some":"subfolders","many":"subfolders"},"member":{"one":"member","some":"members","many":"members"},"owner":"owner","loading":"Loading preview...","loading_failed":"Loading failed","not_loaded":"Page has not been loaded yet"},"back_button":"Back","create_note_for":"Create Page:","create_folder_for":"Create Folder:"},"calendar":{"ui":{"date":"Date","am":"AM","pm":"PM","date_format":"Date format","show_time":"Show time","time_format":"Time format","time_12":"12H","time_24":"24H","first_week_day":"First day of the week","time_zone":"Time zone","use_gmt":"Use GMT for all members","use_gmt_hint":"Use the same time zone (GMT) for all collaborators","table":{"clear":"Clear"},"inline":{"clear":"Delete"},"reminder":{"name":"Alert","panel_name":"Alert","push_name":"Reminder of the event","remove_confirm_message":"You have set reminders that are tied to the time. Do you want to delete these reminders?","remove_confirm_text":"Delete","remove_cancel_text":"Do not delete","before_period":"","after_period":"before","period":{"m":{"one":"minute","many":"minutes"},"h":{"one":"hour","many":"hours"},"d":{"one":"day","many":"days"},"w":{"one":"week","many":"weeks"}},"value":{"none":"None","0m":"On start","1m":"1 minute before","5m":"5 min before","10m":"10 minutes before","15m":"15 minutes before","30m":"30 minutes before","1h":"Hour before","2h":"2 hours before","1d":"Day before","2d":"2 days before","7d":"Week before","10d":"10 days before","14d":"2 weeks before","custom":"Custom"},"until":{"in":"In","d":"d","h":"h","m":"min","already_been":"Already been","less_minute":"Less than a minute","now":"Now"}},"postfix":{"day":"d","month":"m"}},"insert":{"category_name":"Date","custom":"Custom","now":"Now","today":"Today","tomorrow":"Tomorrow"},"date_format":{"ddmmyyyy":"dd/mm/yyyy","mmddyyyy":"mm/dd/yyyy","yyyyddmm":"yyyy/mm/dd","monthddyyyy":"Month dd, yyyy","default":"Match browser format"},"months":{"0":"January","1":"February","2":"March","3":"April","4":"May","5":"June","6":"July","7":"August","8":"September","9":"October","10":"November","11":"December"},"days":{"short":{"0":"Su","1":"Mo","2":"Tu","3":"We","4":"Th","5":"Fr","6":"Sa"},"full":{"0":"Sunday","1":"Monday","2":"Tuesday","3":"Wednesday","4":"Thursday","5":"Friday","6":"Saturday"}}},"content_not_supported":"This page is not supported on your version of the FuseBase app. Try updating it or use another client with the latest version.","profession_ask":{"title":"Save time by using templates to create new pages","text":"Type in your occupation and our team will create templates for you. It’s free, with no hidden charges","i_am_a":"I am a","placeholder":"e.g. designer, teacher, sales agent, etc.","request_template":"Request template","sucess_message":"Thank you! Your occupation will be added into our queue."},"bookmark":{"name":"Bookmark","edit":"Edit bookmark","title":"Title","address":"Address","description":"Description","placeholder":"Paste or write link with https://...","placeholder_mobile":"Paste or write link","loading_preview":"Loading preview…","block_menu":{"change_mode":{"menu_name":"View as","mode_tile":"Tile","mode_card":"Card","mode_cover":"Cover"},"change_preview":"Change preview","delete_preview":"Delete preview","reset_preview":"Reset preview","change_preview_background":"Preview background","options":{"menu_name":"Options","open_in_same_tab":"Open in same tab"}},"error":{"unknown_error":"Something went wrong, try enter another URL","preview_notfound":"Previews not found"},"upload":{"new_preview":"Upload New","quota_error":"The file is larger than the 3MB allowed. Try another file.","unknown_error":"Unknown error. Try another file."}},"businessCard":{"PERSON":"Name","ORGANIZATION":"Company","TITLE":"Title","ADDRESS":"Position","URL":"Site","PHONE":"Phone","EMAIL":"Email","SKYPE":"Skype","TWITTER":"Twitter","INSTAGRAM":"Instagram","FACEBOOK":"Facebook","LINKEDIN":"LinkedIn","VK":"Vk"},"dialog_common":{"button":{"ok":"Ok","cancel":"Cancel"}},"outline":{"default_name":"Outline","menu":{"expand":"Expand","collapse":"Collapse","rename":"Rename"},"context_menu":{"convert_to":{"text":"Text"},"style":{"name":"Outline style","list_only":"List only","numbered_list":"Numbered list","bordered":"Show border","border_color":"Border color"}},"empty":"Add Headlines to your page and they will appear as links here"},"floating_toolbar":{"bold":"Bold","italic":"Italic","underline":"Underline","strikethrough":"Strikethrough","clear":"Clear Formatting","code":"Code","button":"Button","link":"Link","highlight":"Highlight","extraHighlight":"Text labels","color":"Color and highlight","text":"Text","clear_all":"Clear all","placeholder":"Placeholder","adapts":{"dark":"Adapts to a dark theme","light":"Adapts to a light theme"},"create_note":"Create page","add_comment":"Add comment"},"remote_frame":{"placeholder_small":"Embed URL","placeholder_full":"Embed any URL, like YouTube, Github, Maps, Twitter, etc.","loading":"Loading...","context_menu":{"change_link":"Change link","full_size":"Full screen","reset_size":"Reset size","open_origin":"Open original","layout":"Layout","show_toolbar":"Show editing toolbar","copy_original":"Copy link to original"},"error":{"is_not_link":"Link or code is incorrect","content_error":"This URL is not supported or invalid. <a href=\\"https://nimbusweb.me/contact-us.php\\" target=\\"_blank\\">Contact us</a> if you think that this URL can be embedded.","unknown_error":"Something went wrong, try enter another URL","wrong_signature":"This content is corrupted and cannot be displayed","google_docs_auth_error":"Most likely you can\'t embed Google Docs/Sheets/Slide file because you don\'t have access to it. <a href=\\"http://nimb.ws/EkX87M\\" target=\\"_blank\\">Please read our guide.</a>","internal_link_error":"{{serviceName}} has forbidden following internal links. Click on Back to return to the previous page."},"convert_bookmark":"Convert to bookmark","convert_link":"Convert to link","back_button":"Back"},"google_drive":{"block_name":"Google Drive","loading":"Loading...","menu":{"expand":"Expand","collapse":"Collapse","open_origin":"Open in Google Drive","download":"Download","change_account":"Change account","choose_another_file":"Choose another file"},"last_modified":"Last modified by {{userName}} {{time}} ago","browse":"Browse file","login":"Sign in with Google","login_text":"Browse files and add from Google Drive"},"html":{"default_name":"HTML","loading":"Loading...","menu":{"open_source":"Open source link","export_blot":"Save HTML"},"unknown_error":"Unknown error","device_cant_display_content":"Your device can\'t display this content","wrong_signature":"This content is corrupted and cannot be displayed"},"relative_time":{"seconds":{"one":"{{count}} second","some":"{{count}} seconds","many":"{{count}} seconds"},"minutes":{"one":"{{count}} minute","some":"{{count}} minutes","many":"{{count}} minutes"},"hours":{"one":"{{count}} hour","some":"{{count}} hours","many":"{{count}} hours"},"days":{"one":"{{count}} day","some":"{{count}} days","many":"{{count}} days"},"months":{"one":"{{count}} month","some":"{{count}} months","many":"{{count}} months"},"years":{"one":"{{count}} year","some":"{{count}} years","many":"{{count}} years"}},"collapsible_content":{"menu":{"expand":"Expand","collapse":"Collapse","rename":"Rename"}},"convert_link":{"url":"URL","title":"Title","embed":"Embed","bookmark":"Bookmark","button":"Button","link_to_note":"Link to page","link_to_folder":"Link to folder","link_to_workspace":"Link to workspace","convert_error":"Error occurred while converting the URL"},"fullwidth":{"menu_item":"Full width"},"resizeable":{"point_tooltip":{"default":"Resize","bottom-right":"Resize\\n(press and hold the {{altKey}} button for free resize)"}},"toggle":{"placeholder":"Click here to create or move a block","expand":"Expand toggle","collapse":"Collapse toggle","expand_heading":"Expand heading","collapse_heading":"Collapse heading","expand_step":"Expand step","collapse_step":"Collapse step"},"step":{"content_placeholder":"Click here to create description to the step","title_placeholder":"Enter a short title to describe this step","aggregator_placeholder":"Enter a short descriptive title","menu":{"step_layout":{"name":"Layout","show_number":"Show number","show_arrow":"Show arrow","show_border":"Show border"}}},"tasks_list":{"not_supported":"Currently, we cannot display the task list as it is not supported in this type of pages.","menu":{"show_title":"Show task list name","view":"Default view","task_list_view":"Task list","calendar_view":"Calendar","kanban_view":"Kanban"}},"board":{"not_supported":"Currently, we cannot display the task board as it is not supported in this type of pages.","menu":{"add_new_column":"New column","board_layout":{"name":"Layout","show_add_new_column":"Show Add column"}}},"empty_features":{"use_template":"Use a template","import":"Import","add_database":"Add database","add_database_with_options":"Add database with options","add_board":"Kanban / Task Board","use_ai":"Use Fusebase AI"},"ai_manager":{"generate_error":"Unfortunately, there are no results for your request. Please try another request.","unload_message":"Fusebase AI content is being generated. Are you sure you want to exit?","unknown_error":"Unknown error. Try again later or contact support.","dialog":{"title":"Discard draft","body":"Do you want to discard draft?","accept":"Yes, discard"}},"uploader":{"header":"Upload files","description":"Here, you can add some helpful information about file uploading","dropzone_full":"Drag file(s) here or","browse":"click to upload","dropzone_compact":"Add more files","uploading_progress":"Uploading {{progress}}%","uploading_files":"Uploading files","counter":"{{current}} of {{total}}","timer":"less than 1 minute remaining","header_placeholder":"Write a title, max {{maxChars}} characters","description_placeholder":"Write a description, max {{maxChars}} characters","errors":{"network":"Failed uploading file","too_big":"File is too big"},"menu":{"disallow_download":"Downloading","for_note":"For workspaces users","for_share":"Public page","convert_to_files":"Convert to files","allow_upload":"Uploading","enable_in_public_page":"Enable in public page"}},"convert_menu_tooltips":{"labels":{"management":"Great for knowledge management","collaboration":"Great for collaboration"},"paragraph":{"title":"Best for main content","description":"This is the main block for writing page content."},"todo":{"title":"A List For Small Tasks? Check!","description":"Write down small errands and routine tasks that need to be done."},"numberedlist":{"title":"Let\'s Line Up: One, Two, Three!","description":"Make your content easy-to-read and display it in a series."},"bulletlist":{"title":"Points Make Everything Clearer","description":"You can create a list that will stand out from other content."},"table":{"title":"Rejoice the Formatting","description":"Organize your information in a table to get a holistic view on your work."},"image":{"title":"We Need To See It — Add An Image","description":"Make your pages more attractive by adding pictures of any file type, moving them and resizing."},"file":{"title":"Files Here, Files There, Files Everywhere!","description":"Create a database for your project by adding files with different types of extensions to your page."},"largeheading":{"title":"Best for Primary Sections of Page","description":"This is the biggest heading you can add. Attract attention to the most vital part of your page and ease up your navigation."},"mediumheading":{"title":"Best for Secondary Section of Page","description":"This is a middle-size heading you can add. Divide your page into sections with it and easily find what you need."},"smallheading":{"title":"Best For Great Ideas In Subsections","description":"This is a small-size heading you can add, but still it stands out. Use it to divide your page into subsections."},"tasks-list":{"title":"Organize Your Work With Nimbus Tasks","description":"Here you can group your tasks in task lists. Assign tasks to your team members, set deadlines and add statuses for easy tracking."},"hline":{"title":"Let\'s Make A Break","description":"Separate different parts of a project or divide your examples and ideas for it."},"link":{"title":"Pave A Path with Links","description":"Whenever you\'ve got an idea for your project, add a link to it and name it."},"syntax":{"title":"Don\'t Forget About Code","description":"You can add code right on your page, switching between themes, languages and more!"},"link-page":{"title":"Your Next Stop Is Another Page","description":"Link another page connected to this project and easily access it right away."},"date":{"title":"Just Say When","description":"Set a deadline for your project or mark the precise time when you started to work on a page."},"mention":{"title":"Get Your Team Involved","description":"Your team members will get email notifications to open a particular page and collaborate there."},"blockquote":{"title":"And I Quote","description":"You can highlight important words from your clients or single out a motivational phrase."},"hint":{"title":"Let\'s Drop A Hint","description":"Choose an emoji and background color to highlight warnings, disclaimers or notifications on your page."},"toggle":{"title":"Hide & Seek Expand Text Block","description":"Sort and hide additional information on your pages for easier navigation and access."},"outline":{"title":"See What Awaits You On The Page","description":"Create a table of contents for easy navigation on long pages or wikis."},"lock-blot":{"title":"No One Can Edit It","description":"You can leave a particular information block on your page untouched and read-only."},"embed":{"title":"Add More Than Just A Link","description":"You can integrate other tools on your page to keep them all in one place and automatically updated."},"figma":{"title":"Keep Your Visuals Even Closer","description":"Add Figma to see how project visuals are designed in real time."},"miro":{"title":"Your Miro Board Is In A Safe Space","description":"Check a layout strategy or a road map for your project and work further on your page."},"columns":{"title":"Two columns are better than one","description":"Divide your page in two columns to add more content there and make your page look neater."},"meeting-notes":{"title":"Set Goals And Move Forward","description":"Use this template to build a marketing strategy and keep all details in one place."},"marketing-brief":{"title":"Dream Big, Plan Quarter By Quarter","description":"Use this template to build a marketing plan by quarters."},"content-plan":{"title":"Control And Lead Your Work","description":"Use this template to take everything inside your head to a table where you can visualize all parts and manage tasks."},"integrations":{"title":"Add More Than Just A Link","description":"You can integrate other tools on your page to keep them all in one place and automatically updated."},"google-drive":{"title":"Drive Your Files From Google Drive","description":"You can connect your Google Drive account and insert links to your drive files for quick access."},"google-sheets":{"title":"Minus Google Sheet Tab","description":"Keep your data in one place with other project details to draw conclusions more easily."},"bookmark":{"title":"Mark Your Link With A New Look","description":"Use a bookmark to show the title of your link, a small description and a preview picture of the website."},"audioRec":{"title":"Say It, Don\'t Write it","description":"Add a human touch to your collaboration, recording voice feedback to the content on your page."},"videoRec":{"title":"Show it, Don\'t Write It","description":"Record a visual explanation of what should be done or give explicit feedback with a video example."},"button":{"title":"Came, Saw, Clicked","description":"Add a CTA element that will drag attention to important links on your pages."},"largeheading-toggle":{"title":"Hide More In A Large-Sized Collapsible Heading","description":"Define the most vital part of your page and hide information there for easy access."},"mediumheading-toggle":{"title":"Make Your Sections Shorter","description":"Create sections with a middle-sized collapsible heading and hide part of your content there."},"smallheading-toggle":{"title":"Make Your Subsections Shorter","description":"Create subsections with a small-sized collapsible heading on your pages and hide additional information there."},"database-with-options":{"title":"Oh How The Tables Have Turned","description":"Create a database for your project and customize it by selecting different types of columns and rows, changing background color and more."},"board":{"title":"Welcome Your Tasks On a Board","description":"Display tasks as cards on a Kanban board to get a bird’s eye view."},"progress":{"title":"See How Far You\'ve Come!","description":"Choose your value and estimate it. Rate and comment on your added content, tasks or other activities."},"uploader":{"title":"Say Goodbye to the File Mess!","description":"Clarify what files your clients and/or team need to send. With the file uploader, you can get what you want and keep it all in one place."},"dropdown-list":{"title":"Drop Your Options","description":"Place answer options anywhere in the text & let others give instant feedback."},"use-ai":{"title":"Work Smart, Not Hard","description":"Use AI to create and improve your content, get new ideas, and make personalized recommendations. Work with an AI assistant in your workspace."}},"feature_availability":{"plus":{"not-available":"Available for Plus & Team & Business plans","trial":"This is open as a trial Plus feature for you"},"team":{"not-available":"Available for Team & Business plans","trial":"This is open as a trial Team feature for you"},"business2023":{"not-available":"Available for Business plan","trial":"This is open as a trial Business feature for you"}}}');
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/i18n/messages/ru.json
const ru_namespaceObject = JSON.parse('{"table":{"common":{"column":"Колонка"},"move_column_cant_split_merged_cells":{"title":"Невозможно перенести колонку","text":"Невозможно перенести колонку в ячейки, которые были объединены. Сначала, уберите объединение."},"move_column_cant_move_part_of_merged_cells":{"title":"Невозможно перенести колонку","text":"В колонке, которую вы хотите перенести есть объедененные ячейки. Сначала, вам нужно убрать объеденение."},"move_column_failed":{"title":"Невозможно перенести колонку","text":"Ошибка при переносе колонки. Попробуйте снова."},"move_row_cant_split_merged_cells":{"title":"Невозможно перенести строку","text":"Невозможно перенести строку в ячейки, которые были объединены. Сначала, уберите объединение."},"move_row_cant_move_part_of_merged_cells":{"title":"Невозможно перенести строку","text":"В строке, которую вы хотите перенести есть объедененные ячейки. Сначала, вам нужно убрать объеденение."},"move_row_cant_move_in_sortable_table":{"title":"Невозможно перенести строку","text":"Невозможно перенести строку, если есть активная сортировка. Отключите сортировку и попробуйте снова."},"move_row_cant_move_in_filtered_table":{"title":"Невозможно перенести строку","text":"Невозможно перенести строку, если есть активные фильтры. Отключите фильтры и попробуйте снова."},"move_row_failed":{"title":"Невозможно перенести строку","text":"Ошибка при переносе строки. Попробуйте снова"},"first_move_column_or_row_message":"Вы можете выделить несколько строк или колонок, если зажмёте CTRL и будете кликать на нужные строки или колонки.","menu":{"delete":"Удалить","help":"Инструкция","delete_column":{"one":"Удалить колонку","many":"Удалить {{count}} колонки"},"delete_row":{"one":"Удалить строку","many":"Удалить {{count}} строки"},"add":"Добавить","add_row_before":{"one":"Добавить строку выше","many":"Добавить {{count}} строки выше"},"add_row_after":{"one":"Добавить строку ниже","many":"Добавить {{count}} строки ниже"},"add_col_before":{"one":"Добавить колонку слева","many":"Добавить {{count}} колонки слева"},"add_col_after":{"one":"Добавить колонку справа","many":"Добавить {{count}} колонки справа"},"copy_cell":{"one":"Копировать ячейку","many":"Копировать ячейки"},"copy_table":"Копировать таблицу","table_layout":{"name":"Стиль таблицы","column_headings":"Показывать колонтитул колонки","row_headings":"Показывать колонтитул строки"},"import_csv":"Импорт из CSV","merge_cells":"Объединить ячейки","insert_checkbox":"Вставить чекбокс","background_color":"Цвет фона","formatting":"Форматирование","clear":"Очистить","reset":"Сбросить значения","divide_cells":"Разъединить ячейки","type":{"name_cell":"Тип ячейки","name_cells":"Тип ячеек","name_column":"Тип колонки","name_columns":"Тип колонок","type_cell":{"one":"Тип ячейки","many":"Тип ячеек"},"type_col":{"one":"Тип колонки","many":"Тип колонок"},"same_as_column":"Как колонка","reset_cells":"Сбросить формат ячеек","none":"Общий тип","text":"Текст","textline":"Текст","number":"Числа","attachment":"Файлы","checkbox":"Чекбоксы","multiselect":"Много опций","singleselect":"Одна опция","collaborator":"Участники","currency":"Валюта","date":"Дата","link":"Ссылки","rating":"Рейтинг","progress":"Прогресс","mention":"Упоминание"},"number_format":{"name":"Формат числа","number":"Число","commas":"С разделителями","percent":"Проценты"},"currency_format":{"name":"Валюта","dollar":"Доллар","euro":"Евро","yen":"Иена","yuan":"Юань","rouble":"Рубль","pound":"Фунт","rupee":"Рупия","hryvnia":"Гривна","won":"Вона","frank":"Франк","real":"Риал","other":"Другая","stick":"Символ валюты","before":"До","after":"После"},"decimal_format":{"name":"Десятичный разделитель","comma":"Запятая","point":"Точка","hint":"Разделитель используется для десятичных разрядов. Например, если запятая, то будет такой вид: 1.000,99, а если точка, то: 1,000.99"},"progress_format":{"name":"Настройки прогресса","simple":"Простой","colored":"Цветной","start_from":"Начать с (0-100)","default_amount":"По умолчанию (0-100)"},"rating_format":{"name":"Настройки рейтинга","star":"Звезда","flag":"Флаг","heart":"Сердце","amount":"Число (1-10)"},"date_format":{"name":"Настройки даты и времени"},"mention_panel":{"open":"Открыть","edit":"Изменить","clear":"Удалить"},"color_numbers":{"name":"Цветные цифры","enable":"Включить цветные цифры"},"filter":"Фильтрация","comment":"Комментарий"},"formatting_menu":{"align_left":"Лево","align_center":"Центр","align_right":"Право","valign_top":"Верх","valign_center":"Середина","valign_bottom":"Низ","text":"Текст","text_align":"Выравнивание текста","text_color":"Цвет текста","bold":"Жирный","italic":"Наклонный","strikethrough":"Перечеркнутый","underline":"Подчеркнутый"},"col_menu":{"add_column_after":{"one":"Добавить колонку справа","many":"Добавить {{count}} колонки справа"},"add_column_before":{"one":"Добавить колонку слева","many":"Добавить {{count}} колонки слева"},"duplicate_column":{"one":"Дублировать колонку","many":"Дублировать колонки"},"rename":"Переименовать"},"row_menu":{"add_row_after":{"one":"Добавить строку снизу","many":"Добавить {{count}} строки снизу"},"add_row_before":{"one":"Добавить строку сверху","many":"Добавить {{count}} строки сверху"}},"warning":{"merge_different":"Невозможно объединить разные типы объектов","convert_merged":"Невозможно конвертировать объединенные ячейки"},"select":{"create_list":"Напишите, чтобы создать список","create_item":"Напишите, чтобы создать опцию","create_option":"Напишите, чтобы создать опцию","create_label":"Напишите лейбл","create":"Создать","delete":"Удалить"},"attachment":{"upload_more":"Загрузить файлы","downloading":"Загрузка"},"collaborator":{"placeholder":"Введите имя","no_result":"Не найдено","loading":"Загрузка...","unknown":"Неизвестный"},"checkbox":{"checked":"Да","not_checked":"Нет"},"sorting":{"name":"Сортировка","sort":"Сортировка","disable":"Отключить сортировку","change":"Клик, чтобы поменять","asc":{"common":"По возрастанию","text":"От А до Я","number":"От 1 до 9","checkbox":"Сначала неотмеченные"},"desc":{"common":"По убыванию","text":"От Я до А","number":"От 9 до 1","checkbox":"Сначала отмеченные"},"warning":{"column_merged":{"title":"Не удалось отсортировать колонку","text":"Невозможно отсортировать колонку с объединенными ячейками"},"table_rowspan":{"title":"Не удалось отсортировать колонку","text":"Невозможно отсортировать таблицу с объединенными строками"},"merge":{"title":"Нельзя объединять ячейки","text":"Нельзя объединять ячейки при активной сортировке колонки. Отключите сортировку и попробуйте снова."},"different_currencies":{"title":"Предупреждение","text":"Вы используете разные валюты в ячейках, в связи с этим данные сортировки могут быть некорректными."}},"exit_dialog":{"title":"Отключение сортировки","toggle":"Сохранить текущий порядок строк","text_keep":"Будет сохранен порядок строк, который получился при сортировке.","text_no_keep":"Будет возвращен порядок строк, который был ДО включения сортировки.","apply":"Готово"}},"filter":{"by_field":"Фильтрация по колонке","empty_table":"Все записи отфильтрованы","popup_title":"Показать строки","empty_filters":"Нет применённых фильтров для базы данных","where":"Где","or":"Или","and":"И","add_condition":"Добавить условие","clear_all":"Очистить всё","contains":"содержит","is":"совпадает","is_not":"не совпадает","contains_not":"не содержит","has_any_of":"один из","has_none_of":"не содержит ни одного из","empty":"пустая","not_empty":"не пустая","filetype":"тип файлов","select_users_placeholder":"Выберите пользователей","type_text_placeholder":"Введите текст","type_text_or_select_placeholder":"Введите текст или выберите","type_number_placeholder":"Введите число","select_type_placeholder":"Выберите тип","select_date_placeholder":"Выберите дату","date":{"today":"Сегодня","yesterday":"Вчера","tomorrow":"Завтра","custom":"Другая"},"filetypes":{"images":"Изображения","documents":"Документы","media":"Медиа","other":"Другие"},"warning":{"cells_merged":{"title":"Не удалось применить фильтры","text":"Невозможно отфильтровать таблицу с объединенными ячейками"},"merge":{"title":"Нельзя объединять ячейки","text":"Нельзя объединять ячейки при активном фильтре колонки. Отключите фильтры и попробуйте снова."},"column_multitype":{"title":"Не удалось применить фильтры","text":"Нельзя фильтровать колонки с типом Общий тип. Сконвертируйте в другой тип и попробуйте снова."},"table_not_have_typed_columns":{"title":"Не удалось применить фильтры","text":"Нет доступных колонок для фильтрации."}},"enable_filter":"Включить фильтр","disable_filter":"Выключить фильтр"},"wrap_cells":{"layout_menu":"Разбиение ячеек","warnings":{"merge":{"title":"Объединение невозможно","text":"Невозможно объединить ячейки в режиме \'без разбиения\'"},"toggle":{"title":"Невозможно использовать опцию","text":"Таблица содержит объединенные ячейки"}}},"duplicate_column":{"title":"Дублировать колонку","text_1":"Дублировать содержимое ячеек","text_2":"В ячейке колонки есть данные. Вы можете их дублировать тоже или дублировать пустую колонку.","accept":"Дублировать","copy":"копия"},"convert_column":{"title":"Смена типа колонки","text_before":"Колонка содержит данные. При смене типа колонки данные будут удалены. Используйте клавиши","text_cmd":"ctrl+z","text_after":"чтобы отменить изменения.","accept":"Изменить тип"},"merge_cells_with_comments":{"title":"Объединение ячеек","text":"Ячейки будут объединены слева направо и к новой ячейке будет показан комментарий от левой ячейки.","accept":"Объединить"},"summary":{"layout_menu":"Показать панель подсчёта","name":{"none":"Без подсчёта","all":"Всего","empty":"Пустые ячейки","fill":"Заполненные ячейки","unique":"Уникальные ячейки","empty_percent":"Пустые в процентах","fill_percent":"Заполненные в процентах","unique_percent":"Уникальные в процентах","sum":"Сумма","average":"Среднее","min":"Минимальное","max":"Максимальное","median":"Медиана","min_date":"Самая ранняя","max_date":"Самая поздняя","range_days":"Промежуток в днях","range_month":"Промежуток в месяцах","checked":"Отмеченные","unchecked":"Неотмеченные","checked_percent":"Отмеченные в процентах","unchecked_percent":"Неотмеченные в процентах","filter_rating":"С рейтингом:","filter_progress":"С прогрессом:","filesize_min":"Минимальный размер","filesize_max":"Максимальный размер"},"item":{"none":"Подсчёт","empty":"Пустые","fill":"Заполненные","unique":"Уникальные","empty_percent":"Пустые","fill_percent":"Заполненные","unique_percent":"Уникальные","min_date":"Ранняя","max_date":"Поздняя","range_days":"Промежуток","range_month":"Промежуток","checked_percent":"Отмеченные","unchecked_percent":"Неотмеченные","filter_rating":"С рейтингом","filter_progress":"С прогрессом","filesize_min":"Мин. размер","filesize_max":"Макс. размер","min":"Мин","max":"Макс"}},"comments":{"tooltip":{"one":"Комментарий","more":"Комментарии"}}},"file":{"image_viewer":{"could_not_load_image":"Не получилось загрузить картинку"},"download_file":"Скачать {{name}}","listen_file":"Прослушать {{name}}","stop_file":"Остановить {{name}}","uploading":"Загружаем","wrtc":{"how_to_fix":"Как это исправить?","how_to_url":"https://nimbusweb.me/s/share/5441213/cwwryo2477pssn2sgkww","how_to_url2":"https://nimbusweb.me/s/share/5607239/l55bgak2ivs9bfptruka#b1995924032_670","rec_err_au":"Ошибка записи. Нет доступа к микрофону","rec_err_vi":"Ошибка записи. Нет доступа к микрофону/вебкамере ","allow_micro":"Разрешите доступ к микрофону","allow_media":"Выберите окно, которое надо записать","select_opt":"Что будем записывать","screenonly":"Только экран","camonly":"Только камера","screencam":"Экран + Камера","enable_micro":"Запись с микрофона","startRecording":"Начать запись","stopRecording":"Остановить запись","pauseRecording":"Приостановить запись","resumeRecording":"Возобновить запись","cancelRecording":"Отменить запись","confirmCancel":"Вы действительно хотите отменить запись видео?","cancel":"Отмена","prepareUpload":"Подождите, идет подготовка к загрузке записи","hasTmpRecord":"Запись была прервана, но не потеряна","restore":"Восстановить","delete":"Удалить","recordOnAnotherDevice":"Идет запись на другом устройстве..."},"menu":{"enabled":"Включено","disabled":"Выключено","open_in_new_tab":"Открыть в новой вкладке","copy_link":"Копировать ссылку на файл","expand_in_full_window":"Просмотр на весь экран","autoplay":"Автопроигрывание","sound_default":"Звук по умолчанию","sound_loop":"Зацикливание","sound_hideControls":"Скрыть управление","sound_showPanel":"Показывать верхнюю панель","shadow_video":"Тень для видео","video_params":"Настройки видео","disallow_download":"Скачивание","for_note":"Участники проекта","for_share":"Публичная страница","motion_video":"Motion видео","preview_video":"Сменить превью","preview_video_btn":"Превью","print":"Печать","convert_to_image":"Конвертировать в изображение","convert_to_file":"Конвертировать в файл","style":"Стиль","shadow_image":"Тень для картинки","rename":"Переименовать","replace":"Заменить","delete":"Удалить","download":"Скачать","get_text_from_image":"Получить текст изображения","view_as":"Отображать как","single_page":"Одна страница","all_pages":"Все страницы","cta_motion_video_message":"Для видео включен CTA. Невозможно одновременно использовать CTA и Motion видео. Отключите CTA и попробуйте снова включить Motion видео.","cta_loop_message":"Для видео включен CTA. Невозможно одновременно использовать CTA и Зацикливание. Отключите CTA и попробуйте снова включить Зацикливание.","grid":"Колонка","cta_drop_in_grid":"В видео включен CTA. Мы рекомендуем проверить правильность отображения CTA после переноса в колонку.","cta_exists_in_grid":"В колонке есть видео с активным CTA. Проверьте его правильность после переноса."},"downloading":"Скачивание...","attachment_not_found_error":"Ошибка загрузки файла","pdf_viewer":{"initializing_full_window_view":"Инициализация полного окна","preparing_document_for_printing":"Подготовка документа для печати...","printing_initialization":"Инициализация печати...","abort":"отменить","set_page_as_default":"Показывать страницу по умолчанию","unset_page_as_default":"Страница по умолчанию. Кликните, чтобы сделать страницу обычной."},"video_just_uploaded_codec_error":"Вы пытаетесь загрузить видео, которое было закодировано кодеком {codec} Мы не гарантируем корректное воспроизведение данного видео на всех браузерах. Рекомендуем конвертировать видео в другой формат и загрузить снова.","video_codec_error":"Данное видео закодировано кодеком {codec}, который не поддерживается в вашем браузере.","safari_webm_not_support":"На данный момент, браузер Safari не поддерживает формат WEBM. Попробуйте открыть страницу в другом браузере, например Google Chrome или Mozilla Firefox.","video_transcribe":"Транскрипт","video_summary":"Сводка","video_meeting_notes":"Заметки с встречи","video_ask_ai":"Спросить AI"},"image":{"text_from_image_popup":{"title":"Получить текст с картинки","no_text":"Не удалось получить текст","copy":"Копировать текст"},"unknown_error":"Не верная ссылка","add_image":"Вставьте ссылку или выберите ","add_image_or":"или","add_image_small":"Вставьте или выберите ","browse":"с диска","browse_image":"Выбрать изображение","too_large_error":"Изображение слишком большое","image_info_dialog":{"title":"Информация об изображении","type":"Тип","size":"Размер","location":"Адрес","copy_link":"Копировать"},"rotate_wait":{"full":"Немного терпения","medium":"Подождите"},"attachment_not_found_error":"Произошла ошибка при загрузке изображения","readonly_placeholder":"Пустое изображение","unsplash":{"name":"Unsplash","header":"Выберите картинку","placeholder":"Поиск изображения","search":"Поиск","description":"Выполните поиск, чтобы найти больше результатов.","no_result":"Изображения не найдены.","caption_preffix":"Автор"},"comments":"Комментарии"},"attachment":{"unknown_error":"Что-то пошло не так, попробуйте выбрать другой файл","attachment_is_being_uploaded":"Идет загрузка на другом устройстве...","attachment_will_be_downloaded_online":"Файл будет загружен когда вы будете онлайн.","attachment_preview_is_not_available":"Предпросмотр недоступен.","choose_a_file":"Выберите файлы","wait_resolving_without_info":"Немного терпения..."},"video":{"player":{"play":"Играть видео","pause":"Пауза","volume":"Громкость","fullscreen_on":"Во весь экран","fullscreen_off":"Выйти из режима Весь экран","watch_again":"Воспроизвести повторно"}},"search":{"placeholder":"Поиск на странице","matches":"Совпадений:"},"copy":{"copied":"Скопировано!","copy_to_clipboard":"Копировать в буфер обмена"},"apply":"Готово","done":"Готово","block_menu":{"align":{"left":"Выровнять по левому краю","center":"Выровнять по центру","right":"Выровнять по правому краю","justify":"Выровнять по ширине"},"indent":{"indent":"Увеличить отступ","outdent":"Уменьшить отступ"},"tooltip":"Потяните для перемещения\\n<span>Кликните для открытия меню</span>","copy_tooltip":"Скопировать ссылку","color":{"background_color":"Цвет фона","color":"Цвет","line_color":"Цвет линии","line_type":"Тип линии","player_color":"Цвет плеера"},"line_type":{"default":"Обычная линия","dotted":"Точки"},"add":{"name":"Добавить блок","above":"Сверху","below":"Снизу","left":"Слева","right":"Справа","above_column":"Над колонкой","below_column":"Под колонкой"},"convert_to":{"name":"Конвертировать в","to_do_list":"Чеклист","number_list":"Нумерованный список","bullet_list":"Маркированный список","paragraph":"Параграф","large_heading":"Большой заголовок","medium_heading":"Средний заголовок","small_heading":"Малый заголовок","large_heading_toggle":"Сворачиваемый заголовок 1","medium_heading_toggle":"Сворачиваемый заголовок 2","small_heading_toggle":"Сворачиваемый заголовок 3","code":"Код","quote":"Цитата","hint":"Примечание","image":"Изображение","file":"Файл","remote_frame":"Объект/Embed","link":"Ссылка","bookmark":"Закладка","button":"Кнопка","toggle":"Сворачиваемый блок","step":"Steps"},"comment_block":"Комментарий","edit":"Редактировать","duplicate":"Дублировать","copy_block":"Копировать содержимое блока","copy_blocks":"Копировать содержимое блоков","copy_link":"Копировать ссылку","delete":"Удалить","replace":"Заменить","blot_lock":"Запретить редактирование","blot_unlock":"Разрешить редактирование","set_as_preview":"Установить как превью","get_text_from_image":"Получить текст изображения","edit_image":"Редактировать изображение","download":"Скачать","view_full_size":"Открыть в полный размер","open_in_new_tab":"Открыть в новой вкладке","image_info":"Информация об изображении","rotate_image":"Повернуть","add_sub_task":"Добавить подзадачу","add_sub_text":"Добавить подтекст","layout":"Стиль","embed_align":{"left":"Выравнивание слева","center":"Выравнивание по центру","right":"Выравнивание справа","default":"Исходный размер","full_width":"На всю ширину"},"expand_all":"Развернуть все","collapse_all":"Свернуть все","add_caption":"Добавить подпись","blot_locked_admin":"Блок запрещён для редактирования. Кликните, чтобы разблокировать.","blot_locked_admins":"Блоки запрещены для редактирования. Кликните, чтобы разблокировать.","blot_locked_user":"У Вас нет прав на редактирование данного блока. Обратитесь к вашему администратору.","show_header":"Показывать верхнюю панель","show_borders":"Показывать рамки","rename":"Переименовать"},"convert_menu_groups":{"suggestions":"Рекомендуем","basic":"Базовые","advanced":"Продвинутые","media":"Медиа","embed":"Embed","views":"Сложные объекты","templates":"Шаблоны","helpful_links":"Полезные ссылки"},"embedded_menu":{"start_typing":"Напишите \\"/\\" или добавьте","start_typing_full":"Напишите \\"/\\", \\"@\\" или добавьте","more_items":"Больше элементов...","add_an_element":"Добавить элемент","paragraph":"Параграф","todo":"Чеклист","numbered_list":"Нумерованный список","bullet_list":"Маркированный список","table":"Таблица","image":"Изображение","file":"Файл","audioRec":"Аудиозапись","videoRec":"Видеозапись","recordExist":"Вы не можете начать новую запись пока не завершена предыдущая. Завершите или удалите предыдущую запись, чтобы начать новую.","large_heading":"Заголовок 1","medium_heading":"Заголовок 2","small_heading":"Заголовок 3","large_heading_toggle":"Сворачиваемый заголовок H1","medium_heading_toggle":"Сворачиваемый заголовок H2","small_heading_toggle":"Сворачиваемый заголовок H3","section_break":"Линия","link":"Ссылка","code":"Код","quote":"Цитата","hint":"Примечание","hint_placeholder":"Напишите желаемый текст","mention":"Упоминание","outline":"Содержание","remote_frame":"Объект/Embed","integrations":"Интеграции","google_drive":"Google Drive","google_sheets":"Google sheets","html":"HTML","toggle":"Сворачиваемый блок","tasks_list":"Список задач","lock_blot":"Запретить редактирование","link_page":"Ссылка на страницу","date":"Дата","more_integrations":"другие интеграции","two_columns":"2 колонки","meeting_notes":"Meeting notes","marketing_brief":"Marketing Brief","content_plan":"Content plan","more_templates":"другие шаблоны","get_feedback":"Обратная связь","contact_support":"Служба поддержки","learn_nimbus":"Инструкция","footer_top":"Введите текст, чтобы искать объекты.","footer_bottom":"Есть вопросы? Мы с удовольствием на них","footer_link":"ответим!","add_note":"Новая страница","database_with_options":"База данных","board":"Канбан / Доска задач","progress":"Прогресс","dropdown_list":"Выпадающий список","uploader":"Загрузчик файлов","use_ai":"Использовать Fusebase AI","helper":"AI помощник","summarize":"Резюмировать","explain":"Объяснить","improve":"Улучшить","spelling":"Исправить орфографию и грамматику","cta":"Призывы к действию","shorter":"Сделать короче","longer":"Сделать длиннее","step":"Steps"},"button":{"title":"Заголовок","id_info_tooltip":"Данный ID в будущем можно будет использовать при редактировании CSS файла.","address":"Адрес или Email","open_in_new_tab":"Открывать в новой вкладке","shape":"Форма кнопки","background":"Задний фон","size":"Размер","small":"Малый","medium":"Средний","big":"Большой","cancel":"Отмена","done":"Готово","length_error":"Слишком большой текст для кнопки. Попробуйте выделить меньшее количество текста (до 50 символов).","type":"Тип кнопки","default":"Обычная","withShadow":"Кнопка с тенью","3d":"3D кнопка","convert":{"popup_title":"Конвертировать в кнопку"}},"link":{"open":"Открыть","send":"Отправить","copy":"Копировать","edit":"Изменить","remove":"Удалить","text_label":"Текст","url_label":"Ссылка","email_label":"Адрес","copied":"Ссылка скопирована в буфер обмена","cancel":"Отмена","done":"Готово"},"syntax":{"menu":{"language":"Язык","theme":"Тема","wrap":"Включить перенос строк","unwrap":"Выключить перенос строк","lineNumbersOn":"Показать нумерацию строк","lineNumbersOff":"Скрыть нумерацию строк"},"convert":{"popup_title":"Ковертировать в код","blots_have_comments":"В тексте есть комментарии, которые будут удалены при конвертации.","text_has_inline_comments":"Внутри текста есть комментарии, которые будут удалены при конвертации.","confirm":"Конвертировать"}},"list":{"list_style":"Стиль списка","type_default":"По умолчанию","type_rectangle":"Квадрат","type_star":"Звезда","type_dart":"Дротик","type_rounded":"Круг","type_arrow":"Стрела","type_diamond":"Ромб"},"caption":{"placeholder":"Добавить описание"},"mention":{"show_all":"Показать все","show_all_users":"Показать всех","placeholder":"Напишите или выберите из списка","user":"Участники","workspace":"Проекты","folder":"Папки","note":"Страницы","no_results":"Нет результатов","offline_message":"Упоминания работают только при активном соединении. Включите Интернет и попробуйте снова.","info":{"note":{"one":"страница","some":"страницы","many":"страниц"},"subfolder":{"one":"подпапка","some":"подпапки","many":"подпапок"},"member":{"one":"участник","some":"участника","many":"участников"},"owner":"владелец","loading":"Загрузка превью...","loading_failed":"Ошибка загрузки","not_loaded":"Страница ещё не загрузилась"},"back_button":"Назад","create_note_for":"Создать страницу:","create_folder_for":"Создать папку:"},"calendar":{"ui":{"date":"Дата","am":"AM","pm":"PM","date_format":"Формат даты","show_time":"Показывать время","time_format":"Формат времени","time_12":"12ч","time_24":"24ч","first_week_day":"Первый день недели","time_zone":"Часовой пояс","use_gmt":"Время по Гринвичу","use_gmt_hint":"Один часовой пояс для всех участников","table":{"clear":"Очистить"},"inline":{"clear":"Удалить"},"reminder":{"name":"Напоминание","panel_name":"Напоминание","push_name":"Напоминание о событии","remove_confirm_message":"У вас установлены алерты, которые привязаны ко времени. Вы хотите удалить эти напоминания?","remove_confirm_text":"Удалить","remove_cancel_text":"Не удалять напоминания","before_period":"за","after_period":"","period":{"m":{"one":"минуту","many":"минуты"},"h":{"one":"час","many":"часа"},"d":{"one":"день","many":"дня"},"w":{"one":"неделю","many":"недели"}},"value":{"none":"Нет","0m":"При наступлении","1m":"за 1 минуту","5m":"за 5 минут","10m":"за 10 минут","15m":"за 15 минут","30m":"за 30 минут","1h":"за 1 час","2h":"за 2 часа","1d":"за 1 день","2d":"за 2 дня","7d":"за 7 дней","10d":"за 10 дней","14d":"за 14 дней","custom":"Другое"},"until":{"in":"Через","d":"д.","h":"ч.","m":"мин.","already_been":"Уже было","less_minute":"Меньше минуты","now":"Сейчас"}},"postfix":{"day":"д","month":"мес"}},"insert":{"category_name":"Дата","custom":"Другая","now":"Сейчас","today":"Сегодня","tomorrow":"Завтра"},"date_format":{"ddmmyyyy":"дд/мм/гггг","mmddyyyy":"мм/дд/гггг","yyyyddmm":"гггг/мм/дд","monthddyyyy":"Месяц дд, гггг","default":"Формат браузера"},"months":{"0":"Январь","1":"Февраль","2":"Март","3":"Апрель","4":"Май","5":"Июнь","6":"Июль","7":"Август","8":"Сентябрь","9":"Октябрь","10":"Ноябрь","11":"Декабрь"},"days":{"short":{"0":"Вс","1":"Пн","2":"Вт","3":"Ср","4":"Чт","5":"Пт","6":"Сб"},"full":{"0":"Воскресенье","1":"Понедельник","2":"Вторник","3":"Среда","4":"Четверг","5":"Пятница","6":"Суббота"}}},"content_not_supported":"На странице есть контент, который не поддерживается версией редактора на вашем клиенте. Обновите клиент для полноценной работы.","profession_ask":{"title":"Сохраните время, используя шаблоны при создании новых страниц","text":"Введите вашу должность и наша комманда создаст шаблон для вас. Это бесплатно, никаких скрытых платежей.","i_am_a":"Моя должность - ","placeholder":"например дизайнер, учитель, агент, и т.д.","request_template":"Запросить шаблон","sucess_message":"Спасибо! Ваша должность добавлена в обработку."},"bookmark":{"name":"Закладка","edit":"Редактировать закладку","title":"Заголовок","address":"Ссылка","description":"Описание","placeholder":"Вставьте, или напишите ссылку с https://...","placeholder_mobile":"Вставьте, или напишите ссылку","loading_preview":"Загрузка превью…","block_menu":{"change_mode":{"menu_name":"Отобразить как","mode_tile":"Плитка","mode_card":"Карточка","mode_cover":"Обложка"},"change_preview":"Изменить превью","delete_preview":"Удалить превью","reset_preview":"Сбросить превью","change_preview_background":"Фон превью","options":{"menu_name":"Параметры","open_in_same_tab":"Открывать в текущей вкладке"}},"error":{"unknown_error":"Что-то пошло не так, попробуйте ввести другой URL","preview_notfound":"Превью не найдены"},"upload":{"new_preview":"Загрузить картинку","quota_error":"Размер файла превышает допустимый размер в 3MB. Попробуйте другой файл.","unknown_error":"Неизвестная ошибка. Попробуйте другой файл."}},"businessCard":{"PERSON":"Имя","ORGANIZATION":"Организация","TITLE":"Описание","ADDRESS":"Адрес","URL":"Сайт","PHONE":"Телефон","EMAIL":"Электронная почта","SKYPE":"Скайп","TWITTER":"Твиттер","INSTAGRAM":"Инстаграм","FACEBOOK":"Фейсбук","LINKEDIN":"LinkedIn","VK":"ВКонтакте"},"dialog_common":{"button":{"ok":"Да","cancel":"Отмена"}},"outline":{"default_name":"Содержание","menu":{"expand":"Развернуть","collapse":"Свернуть","rename":"Переименовать"},"context_menu":{"convert_to":{"text":"Текст"},"style":{"name":"Стиль содержания","list_only":"Список","numbered_list":"Нумерованный список","bordered":"Показать рамку","border_color":"Цвет рамки"}},"empty":"Добавьте Заголовки к своей странице, и они будут отображаться здесь как ссылки"},"floating_toolbar":{"bold":"Жирный","italic":"Курсив","underline":"Подчеркнутый","strikethrough":"Перечеркнутый","clear":"Очистить форматирование","code":"Код","button":"Кнопка","link":"Ссылка","highlight":"Маркер","extraHighlight":"Маркеры с рамкой","color":"Цвет и выделение текста","text":"Текст","clear_all":"Очистить всё","placeholder":"Заполнитель","adapts":{"dark":"Адаптировать к темной теме","light":"Адаптировать к светлой теме"},"create_note":"Создать страницу","add_comment":"Добавить комментарий"},"remote_frame":{"placeholder_small":"Вставьте URL","placeholder_full":"Вставьте ссылку с YouTube, Github, Maps, Twitter и т.д.","loading":"Загрузка...","context_menu":{"change_link":"Сменить ссылку","full_size":"На весь экран","reset_size":"Сбросить размер","open_origin":"Перейти к источнику","layout":"Стиль","show_toolbar":"Показать тулбар","copy_original":"Копировать ссылку на оригинал"},"error":{"is_not_link":"Ссылка или код неверные","content_error":"Данная ссылка не поддерживается или является некорректной. Напишите в <a href=\\"https://nimbusweb.me/contact-us.php\\" target=\\"_blank\\">нашу службу поддержки</a>, если вы считаете, что произошла ошибка.","unknown_error":"Что-то пошло не так, попробуйте ввести другой URL","wrong_signature":"Неверная ссылка или контент эмбеда повреждён","google_docs_auth_error":"Скорее всего нет прав доступа к этому документу. У нас есть небольшая <a href=\\"https://nimbusweb.me/s/share/4246032/x9umr2emrgvf4xxa45vy\\" target=\\"_blank\\">инструкция</a>, которая подскажет, как поменять права на документ.","internal_link_error":"{{serviceName}} запретил переход по внутренним ссылкам. Нажмите на Назад, чтобы вернуться на предыдущую страницу."},"convert_bookmark":"Конвертировать в закладку","convert_link":"Конвертировать в ссылку","back_button":"Назад"},"google_drive":{"block_name":"Google Drive","loading":"Загрузка...","menu":{"expand":"Развернуть","collapse":"Свернуть","open_origin":"Открыть в Google Drive","download":"Скачать","change_account":"Сменить аккаунт","choose_another_file":"Выбрать другой файл"},"last_modified":"Последнее изменение {{userName}} {{time}} назад","browse":"Выбрать файл","login":"Sign in with Google","login_text":"Выберите и добавьте файл из Google Drive"},"html":{"default_name":"HTML","loading":"Загрузка...","menu":{"open_source":"Открыть оригинал","export_blot":"Сохранить HTML"},"unknown_error":"Неизвестная ошибка","device_cant_display_content":"Данное содержимое не может быть отображено на вашем устройстве","wrong_signature":"Данное содержимое повреждено и не может быть показано"},"relative_time":{"seconds":{"one":"{{count}} секунду","some":"{{count}} секунды","many":"{{count}} секунд"},"minutes":{"one":"{{count}} минуту","some":"{{count}} минуты","many":"{{count}} минут"},"hours":{"one":"{{count}} час","some":"{{count}} часа","many":"{{count}} часов"},"days":{"one":"{{count}} день","some":"{{count}} дня","many":"{{count}} дней"},"months":{"one":"{{count}} месяц","some":"{{count}} месяца","many":"{{count}} месяцев"},"years":{"one":"{{count}} год","some":"{{count}} года","many":"{{count}} лет"}},"collapsible_content":{"menu":{"expand":"Развернуть","collapse":"Свернуть","rename":"Переименовать"}},"convert_link":{"url":"URL","title":"Ссылка+Имя","embed":"Объект/Embed","bookmark":"Закладка","button":"Кнопка","link_to_note":"Ссылка на страницу","link_to_folder":"Ссылка на папку","link_to_workspace":"Ссылка на проект","convert_error":"Возникла ошибка конвертации URL"},"fullwidth":{"menu_item":"На всю ширину"},"resizeable":{"point_tooltip":{"default":"Изменить размер","bottom-right":"Изменить размер\\n(зажмите {{altKey}} для свободного изменения)"}},"toggle":{"placeholder":"Кликните сюда или перенесите блок","expand":"Развернуть блок","collapse":"Свернуть блок","expand_heading":"Развернуть заголовок","collapse_heading":"Свернуть заголовок","expand_step":"Expand step","collapse_step":"Collapse step"},"step":{"content_placeholder":"Click here to create description to the step","title_placeholder":"Enter a short title to describe this step","aggregator_placeholder":"Enter a short descriptive title","menu":{"step_layout":{"name":"Layout","show_number":"Show number","show_arrow":"Show arrow","show_border":"Show border"}}},"tasks_list":{"not_supported":"Мы не можем в данный момент отобразить список задач, так как он не поддерживается в данном типе страниц.","menu":{"show_title":"Show task list name","view":"Default view","task_list_view":"Task list","calendar_view":"Calendar","kanban_view":"Kanban"}},"board":{"not_supported":"Мы не можем в данный момент отобразить канбан, так как он не поддерживается в данном типе страниц.","menu":{"add_new_column":"Новая колонка","board_layout":{"name":"Стиль","show_add_new_column":"Показывать Новая колонка"}}},"empty_features":{"use_template":"Использовать шаблон","import":"Импорт","add_database":"База данных","add_database_with_options":"База данных","add_board":"Канбан / Доска задач","use_ai":"Использовать Fusebase AI"},"ai_manager":{"generate_error":"К сожалению, нет результата по вашему запросу. Попробуйте другой запрос.","unload_message":"Идет генерация контента Fusebase AI, вы действительно хотите выйти?","unknown_error":"Неизвестная ошибка. Попробуйте позже или обратитесь в службу поддержки.","dialog":{"title":"Удалить черновик","body":"Вы действительно хотите удалить черновик?","accept":"Да, удалить"},"manage":{"insert_as_text":"Вставить как текст","insert_as_task_list":"Вставить как список задач","insert_as_checkbox_list":"Вставить как чеклист","try_again":"Попробовать еще раз","discard":"Удалить черновик","done":"Вставить","insert_above":"Вставить выше","insert_below":"Вставить ниже","continue":"Продолжить","shorter":"Короче","longer":"Длиннее","translate":"Перевести","replace":"Заменить","copy":"Копировать"}},"uploader":{"header":"Загрузка файлов","description":"Здесь вы можете добавить полезную информацию о загрузке файлов","dropzone_full":"Перетащите файл(ы) сюда или","browse":"нажмите для загрузки","dropzone_compact":"Добавить файлы","uploading":"Загрузка {{progress}}%","uploading_files":"Загрузка файлов","counter":"{{current}} из {{total}}","timer":"осталось менее 1 минуты","header_placeholder":"Введите заголовок не более {{maxChars}} символов","description_placeholder":"Введите описание не более {{maxChars}} символов","errors":{"network":"Не удалось загрузить файл","too_big":"Файл слишком большой"},"menu":{"disallow_download":"Скачивание","for_note":"Участники проекта","for_share":"Публичная страница","convert_to_files":"Конвертировать в файлы","allow_upload":"Загрузка","enable_in_public_page":"Разрешить в публичной странице"}},"convert_menu_tooltips":{"labels":{"management":"Подходит для базы знаний","collaboration":"Групповая работа"},"paragraph":{"title":"Идеально для основного контента","description":"Это основной блок для наполнения страницы контентом."},"todo":{"title":"Идеально для простых задач","description":"Создается пустой пункт чеклиста, который можно заполнить, а потом закрыть."},"numberedlist":{"title":"Раз, два, три!","description":"Cписок, в котором каждый пункт стоит по порядковым номерам."},"bulletlist":{"title":"Маркеры, которые помогают","description":"Список, в котором каждый пункт отмечен специальным маркером (вид маркера можно менять)."},"table":{"title":"Расширьте возможности страницы","description":"Структурируйте и организуйте вашу информацию через таблицу."},"image":{"title":"Разбавим серые будни!","description":"Добавьте на страницу картинки, чтобы добавить больше контекста. Картинкам можно менять размер, можно их комментировать и т.д."},"file":{"title":"Файлы здесь, файлы там, файлы везде!","description":"Загружайте с компьютера файлы разных типов: документы, медиа, архивы и т.д."},"largeheading":{"title":"Идеально для больших разделов","description":"На странице есть несколько больших секций? Выделите их с помощью больших заголовков!"},"mediumheading":{"title":"Для второстепенных разделов","description":"Добавьте саб-секции на страницу с помощью средних заголовков."},"smallheading":{"title":"Идеально для небольших разделов","description":"Привлеките внимание к нужному блоку страницы с помощью маленьких заголовков!"},"tasks-list":{"title":"Задачи, с которыми удобно работать","description":"Создавайте задачи, назначайте ответственных и устанавливайте дедлайны, чтобы отслеживать прогресс."},"hline":{"title":"Давайте, поставим... линию!","description":"Горизонтальная линия, разделяющая части страницы."},"link":{"title":"Ссылки... просто ссылки","description":"Добавьте ссылку на внешний сайт или внутреннюю страницу."},"syntax":{"title":"Кода много не бывает ;)","description":"Добавьте на страницу сниппет с кодом. Мы распознаём большинство популярных языков программирования."},"link-page":{"title":"Создайте свою структуру","description":"Добавьте ссылку на любую страницу или папку в текущем проекте."},"date":{"title":"Просто укажите дату и время","description":"Добавьте дату и время прямо в текст страницы. При желании, можно добавить напоминание к выбранной дате."},"mention":{"title":"Вам важно об этом знать!","description":"Упомяните нужного участника или участницу проекта, чтобы привлечь их внимание к странице."},"blockquote":{"title":"Слова, которые важны","description":"Подчеркните важность ваших слов с помощью оформленной цитаты."},"hint":{"title":"Обратите внимание!","description":"Выделите важный для вас текст в специальном блоке с иконкой, которую вы можете выбрать сами."},"toggle":{"title":"Скройте лишнее!","description":"Сворачивает и разворачивает выбранное содержимое страницы (текст, картинки и т.д)."},"outline":{"title":"Достаточно одного взгляда!","description":"На странице много секций с заголовками? Оглавление позволит лучше ориентироваться в таком разнообразии!"},"lock-blot":{"title":"Здесь правила устанавливаю Я!","description":"Запретите редактировать и никто не сможет изменить содержимое блока!"},"embed":{"title":"Больше, чем просто ссылка","description":"Отобразит содержимое с других сервисов. Поддерживаем тысячи сервисов!"},"figma":{"title":"Держите дизайн рядом!","description":"Обсуждайте макеты и дизайнерские решения из Figma прямо на странице Nimbus Note."},"miro":{"title":"Новая вершина командной работы!","description":"Делаете проект? Создайте его прототип в Miro и обсуждайте прямо на странице Nimbus Note!"},"columns":{"title":"Одна хорошо, но две лучше ;)","description":"Разделите вашу страницу или блок на странице на колонки в один клик!"},"meeting-notes":{"title":"Зафиксируйте цели и двигайтесь дальше!","description":"Обсудили с командой важные моменты? Зафиксируйте результаты в нашем шаблоне."},"marketing-brief":{"title":"Воплощайте фантазии в жизнь","description":"Используйте данный шаблон для быстрого создания дизайнерского брифа."},"content-plan":{"title":"Создайте план и контролируйте его","description":"Мы подготовили для вас прототип контент плана. Вам осталось только его заполнить ;)"},"integrations":{"title":"Больше, чем просто ссылка","description":"Отобразит содержимое с других сервисов. Поддерживаем тысячи сервисов!"},"google-drive":{"title":"Далеко ходить не надо","description":"Подключите свой аккаунт Google Drive и добавьте с него файлы прямо на вашу страницу Nimbus Note."},"google-sheets":{"title":"Минус одна вкладка в браузере","description":"Отобразите содержимое ваших Google таблиц прямо на странице Nimbus Note!"},"bookmark":{"title":"Прочь, скучные ссылки!","description":"Вставьте ссылку и мы её покажем в красивом блоке с названием страницы, её описанием и логотипом."},"audioRec":{"title":"Вам нужно это услышать!","description":"Запишите аудио сообщение прямо со страницы."},"videoRec":{"title":"Вам нужно это увидеть!","description":"Запишите видео с вебкамеры или запишите происходящее на странице не выходя с Nimbus Note."},"button":{"title":"Пришли, увидели и нажали :)","description":"Не подходят обычные ссылки? Добавьте кнопку, которая украсит вашу страницу и позволит открывать нужные ссылки."},"largeheading-toggle":{"title":"Идеально для больших разделов","description":"Спрячьте лишнее и упростите внешний вид вашей страницы с помощью больших сворачиваемых заголовков."},"mediumheading-toggle":{"title":"Упростите внешний вид страницы","description":"Добавьте саб-секции на страницу и спрячьте в них содержимое с помощью средних сворачиваемых заголовков."},"smallheading-toggle":{"title":"Идеально для второстепенных разделов","description":"Скрывайте контент страницы с помощью маленьких сворачиваемых заголовков."},"database-with-options":{"title":"Таблица превращается... в базу данных","description":"Оцените всю мощь наших таблиц в специально подготовленном для Вас шаблоне базы данных!"},"board":{"title":"Наглядное управление вашими задачами!","description":"Создавайте и редактируйте карточки задач на доске Канбан."},"progress":{"title":"Оцените ваш прогресс!","description":"Выберите цель и двигайтесь к ней! Используйте прогресс бар для оценки выполненных задач и других активностей."},"uploader":{"title":"Скажите \\"НЕТ\\" файловому беспорядку!","description":"Собирайте файлы с клиентов и агрегируйте их по одной теме, чтобы ничего не упустить!"},"dropdown-list":{"title":"Выберите нужную опцию","description":"Составьте список и позвольте участникам команды выбрать нужную опцию."},"use-ai":{"title":"Добавьте волшебства!","description":"Наш AI помощник напишет вам текст любой сложности и по любой теме, проанализует содержимое страницы и на ее основе создаст саммари или список задач и даже укажет грамматические ошибки (если они конечно есть 😉)."}},"feature_availability":{"plus":{"not-available":"Доступно для Plus, Team и Business плана","trial":"Премиум функционал доступный на время триала"},"team":{"not-available":"Доступно для Team и Business плана","trial":"Бизнес функционал доступный на время триала"},"business2023":{"not-available":"Доступно для Business плана","trial":"Бизнес функционал доступный на время триала"}}}');
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/i18n/messages/de.json
const de_namespaceObject = JSON.parse('{"table":{"common":{"column":"Spalte"},"move_column_cant_split_merged_cells":{"title":"Spalte kann nicht verschoben werden","text":"Eine Spalte kann nicht in eine verbundene Zelle verschoben werden. Bitte Verbindung aufheben und dann erneut versuchen."},"move_column_cant_move_part_of_merged_cells":{"title":"Spalte kann nicht verschoben werden","text":"Die Spalte, die verschoben werden soll, enthält einen Teil einer verbundenen Zelle. Wenn die Spalte verschoben werden soll, bitte zuerst die Zellen voneinander trennen."},"move_column_failed":{"title":"Spalte kann nicht verschoben werden","text":"Beim Verschieben einer Spalte ist ein unerwarteter Fehler aufgetreten, bitte erneut versuchen."},"move_row_cant_split_merged_cells":{"title":"Zeile kann nicht verschoben werden","text":"Eine Zeile kann nicht in eine verbundene Zelle verschoben werden. Bitte Verbindung aufheben und dann erneut versuchen."},"move_row_cant_move_part_of_merged_cells":{"title":"Zeile kann nicht verschoben werden","text":"Die Zeile, die verschoben werden soll, enthält einen Teil einer verbundenen Zelle. Wenn die Spalte verschoben werden soll, bitte zuerst die Zellen voneinander trennen."},"move_row_cant_move_in_sortable_table":{"title":"Zeile kann nicht verschoben werden","text":"Eine Zeile kann nicht in einer sortierbaren Tabelle verschoben werden. Bitte Sortierung aufheben und erneut versuchen."},"move_row_cant_move_in_filtered_table":{"title":"Unable to move row","text":"Cannot move a row in a filtered table. Cancel filter then try again."},"move_row_failed":{"title":"Zeile kann nicht verschoben werden","text":"Beim Verschieben einer Zeile ist ein unerwarteter Fehler aufgetreten, bitte erneut versuchen."},"first_move_column_or_row_message":"You can select multiple rows or columns by holding down the CTRL button and clicking on the desired rows or columns.","menu":{"delete":"Löschen","help":"Hilfe","delete_column":{"one":"Spalte löschen","many":"{{count}} Spalten löschen"},"delete_row":{"one":"Zeile löschen","many":"Delete {{count}} Zeilen löschen"},"add":"Hinzufügen","add_row_before":{"one":"Zeile nach oben","many":"{{count}} Zeilen nach oben"},"add_row_after":{"one":"Zeile nach unten","many":"{{count}} Zeilen nach unten"},"add_col_before":{"one":"Spalte nach links","many":"{{count}} Spalten nach links"},"add_col_after":{"one":"Spalte nach rechts","many":"{{count}} Spalten nach rechts"},"copy_cell":{"one":"Zelle kopieren","many":"Zellen kopieren"},"copy_table":"Tabelle kopieren","table_layout":{"name":"Tabellen Layout","column_headings":"Spaltenüberschriften","row_headings":"Zeilenüberschriften"},"import_csv":"Import from CSV","merge_cells":"Zellen verbinden","insert_checkbox":"Markierungsfeld einfügen","background_color":"Hintergrundfarbe","formatting":"Formatierung","clear":"Entfernen","reset":"Zurücksetzen","divide_cells":"Zellenverbindung entfernen","type":{"name_cell":"Zellentyp","name_cells":"Zellentyp","name_column":"Spaltentyp","name_columns":"Spaltentyp","type_cell":{"one":"Zellentyp","many":"Zellentyp"},"type_col":{"one":"Spaltentyp","many":"Spaltentyp"},"same_as_column":"Gleich wie Spalte","reset_cells":"Zellen auf Standard zurücksetzen","none":"Mehrfachtyp","text":"Text","textline":"Text","number":"Zahl","attachment":"Anhang","checkbox":"Markierungsfeld","multiselect":"Mehrfachauswahl","singleselect":"Einzelauswahl","collaborator":"Mitarbeiter","currency":"Währung","date":"Datum","link":"Link","rating":"Bewertung","progress":"Fortschritt","mention":"Erwähnung"},"number_format":{"name":"Zahlenformat","number":"Zahl","commas":"Zahl mit Kommas","percent":"Prozent"},"currency_format":{"name":"Währungstyp","dollar":"Dollar","euro":"Euro","yen":"Yen","yuan":"Yuan","rouble":"Rubel","pound":"Pfund","rupee":"Rupie","hryvnia":"Hryvnia","won":"Won","frank":"Franken","real":"Real","other":"Sonstiges","stick":"Symbol anzeigen","before":"Vorher","after":"Nachher"},"decimal_format":{"name":"Decimal separator","comma":"Comma","point":"Point","hint":"The separator is used for decimal places. Comma decimal separators will look like 1.000,99, and point separators look like 1,000.99"},"progress_format":{"name":"Fortschrittsoptionen","simple":"Einfach","colored":"Farbig","start_from":"Beginnt von (0-100)","default_amount":"Standardbetrag  (0-100)"},"rating_format":{"name":"Bewertungsoptionen","star":"Stern","flag":"Fahne","heart":"HERZ","amount":"Betrag (1-10)"},"date_format":{"name":"Datum Uhrzeit Format"},"mention_panel":{"open":"Öffnen","edit":"Bearbeiten","clear":"Entfernen"},"color_numbers":{"name":"Color numbers","enable":"Enable color numbers"},"filter":"Filter","comment":"Kommentar"},"formatting_menu":{"align_left":"Links","align_center":"Zentriert","align_right":"Rechts","valign_top":"Oben","valign_center":"Mitte","valign_bottom":"Unten","text":"Text","text_align":"Text ausrichten","text_color":"Textfarbe","bold":"Fett","italic":"Kursiv","strikethrough":"Durchgestrichen","underline":"Untergestrichen"},"col_menu":{"add_column_after":{"one":"Spalte rechts hinzufügen","many":"{{count}} Spalten rechts hinzufügen"},"add_column_before":{"one":"Spalte links hinzufügen","many":"Add {{count}} Spalten links hinzufügen"},"duplicate_column":{"one":"Spalte duplizieren","many":"Spalten duplizieren"},"rename":"Umbenennen"},"row_menu":{"add_row_after":{"one":"Zeile unten hinzufügen","many":"{{count}} Zeilen unten hinzufügen"},"add_row_before":{"one":"Zeile oben hinzufügen","many":"{{count}} Zeilen oben hinzufügen"}},"warning":{"merge_different":"Unterschiedliche Objekttypen können nicht verbunden werden","convert_merged":"Verbundene Zellen können nicht konvertiert werden"},"select":{"create_list":"Tippe zum Erstellen einer Liste","create_item":"Tippe zum Erstellen eines Eintrags","create_option":"Tippe zum Erstellen einer Option","create_label":"Tippe zum Erstellen einer Beschriftung","create":"Erstellen","delete":"Löschen"},"attachment":{"upload_more":"Datei(en) hochladen","downloading":"Herunterladen"},"collaborator":{"placeholder":"Typ zum Hinzufügen von Personen","no_result":"Keine Ergebnisse","loading":"Wird geladen...","unknown":"Unbekannte Person"},"checkbox":{"checked":"Ja","not_checked":"Nein"},"sorting":{"name":"Sortierung","sort":"Sortieren","disable":"Sortierung entfernen","change":"Zum Ändern anklicken","asc":{"common":"Aufsteigend","text":"Sortieren nach A-Z","number":"Sortieren nach 1-9","checkbox":"Nicht ausgewählte zuerst"},"desc":{"common":"Absteigend","text":"Sortieren nach Z-A","number":"Sortieren nach 9-1","checkbox":"Ausgewählte zuerst"},"warning":{"column_merged":{"title":"Spalte kann nicht sortiert werden","text":"Spalte mit verbundenen Zellen kann nicht sortiert werden"},"table_rowspan":{"title":"Spalte konnte nicht sortiert werden","text":"Tabelle mit verbundenen Zeilen kann nicht sortiert werden"},"merge":{"title":"Cells cannot be merged","text":"Cells cannot be merged while column sorting is active. Disable sorting and try again."},"different_currencies":{"title":"Sortierwarnung","text":"Es gibt verschiedene Währungen in einer Spalte. Die Sortierung ist möglicherweise falsch."}},"exit_dialog":{"title":"Sortierung entfernen","toggle":"Sortierung beibehalten","text_keep":"Sortierung beibehalten","text_no_keep":"Spaltenreihenfolge wird in der ursprünglichen Reihenfolge wiederhergestellt, in der sie vor Anwendung der Sortierung bestand","apply":"Anwenden"}},"filter":{"by_field":"Filter by this field","empty_table":"All records are filtered","popup_title":"In this table, show records","empty_filters":"No conditions are applied to this database","where":"Where","or":"Or","and":"And","add_condition":"Add condition","clear_all":"Clear all","contains":"contains","is":"is","is_not":"is not","contains_not":"contains not","has_any_of":"has any of","has_none_of":"has none of","empty":"empty","not_empty":"not empty","filetype":"filetype","select_users_placeholder":"Select users","type_text_placeholder":"Type text","type_text_or_select_placeholder":"Type text or select","type_number_placeholder":"Type number","select_type_placeholder":"Select type","select_date_placeholder":"Select date","date":{"today":"Today","yesterday":"Yesterday","tomorrow":"Tomorrow","custom":"Custom"},"filetypes":{"images":"Images","documents":"Documents","media":"Media","other":"Other"},"warning":{"cells_merged":{"title":"Unable to filter table","text":"Can\'t filter column with merged cells"},"merge":{"title":"Cells cannot be merged","text":"Cells cannot be merged while table filter is active. Disable filter and try again."},"column_multitype":{"title":"Unable to filter table","text":"There is no such possibility to filter columns with Multi type. Please, try to convert to another type and try again."},"table_not_have_typed_columns":{"title":"Unable to filter table","text":"No columns available for filtering."}},"enable_filter":"Enable filter","disable_filter":"Disable filter"},"wrap_cells":{"layout_menu":"Zeilenumbruch","warnings":{"merge":{"title":"Zellen können nicht verbunden werden","text":"Zellen können nur im Zeilenumbruch Modus zusammengeführt werden"},"toggle":{"title":"Option kann nicht geändert werden","text":"Tabelle enthält verbundene Zellen"}}},"duplicate_column":{"title":"Spalte duplizieren","text_1":"Spalteninhalt duplizieren","text_2":"Sie können die gesamte Spalte inklusive Daten duplizieren oder die duplizerte Spalte leer lassen","accept":"Duplizieren","copy":"Kopieren"},"convert_column":{"title":"Spaltentyp ändern","text_before":"Diese Spalte enthält Werte. Wenn der Spaltentyp geändert wird, werden einige der Werte gelöscht. Anwenden","text_cmd":"Rückgängig machen","text_after":"Befehl, um Änderungen bei Bedarf rückgängig zu machen.","accept":"Typ ändern"},"merge_cells_with_comments":{"title":"Merging cells","text":"The cells will be merged from left to right and the new cell will show a comment from the left cell.","accept":"Merge"},"summary":{"layout_menu":"Berechnungsleiste anzeigen","name":{"none":"Keine","all":"Alle","empty":"Leer","fill":"Nicht leer","unique":"Einmalig","empty_percent":"Prozent leer","fill_percent":"Prozent nicht leer","unique_percent":"Prozent einmalig","sum":"Summe","average":"Durchschnitt","min":"Min","max":"Max","median":"Mittelwert","min_date":"Frühestes Datum","max_date":"Spätestes Datum","range_days":"Datumsbereich (Tage)","range_month":"Datumsbereich (Monat)","checked":"Geprüft","unchecked":"Nicht geprüft","checked_percent":"Prozent geprüft","unchecked_percent":"Prozent nicht geprüft","filter_rating":"Mit Bewertung:","filter_progress":"Mit Fortschritt:","filesize_min":"Minimale Größe","filesize_max":"Maximale Größe"},"item":{"none":"Berechnen","min_date":"Frühestens","max_date":"Spätestens","range_days":"Bereich (Tage)","range_month":"Bereich (Monat)","checked_percent":"Geprüft","unchecked_percent":"Nicht geprüft","filter_rating":"Mit Bewertung","filter_progress":"Mit Fortschritt"}},"comments":{"tooltip":{"one":"Comment","more":"Comments"}}},"file":{"image_viewer":{"could_not_load_image":"Bild konnte nicht geladen werden"},"download_file":"{{name}} herunterladen","listen_file":"{{name}} abspielen","stop_file":"{{name}} aufhören","uploading":"Hochladen","wrtc":{"how_to_fix":"Wie lässt sich das beheben?","how_to_url":"https://nimbusweb.me/s/share/5441210/4qccr41slk6wsw61h5fb","how_to_url2":"https://nimbusweb.me/s/share/5607239/l55bgak2ivs9bfptruka#b1995924032_670","rec_err_au":"Fehler bei der Aufnahme. Kein Zugriff auf das Mikrofon.","rec_err_vi":"Fehler bei der Aufnahme. Kein Zugriff auf Mikrofon/Webcam.","allow_micro":"Zugriff auf das Mikrofon erlauben","allow_media":"Wählen Sie das Fenster aus, das Sie aufnehmen möchten","select_opt":"Was wird aufgenommen","screenonly":"Nur Bildschirm","camonly":"Nur Kamera","screencam":"Bildschirm + Kamera","enable_micro":"Mikrofon einschalten","startRecording":"Aufnahme starten","stopRecording":"Aufnahme beenden","pauseRecording":"Aufnahme anhalten","resumeRecording":"Aufnahme fortsetzen","cancelRecording":"Aufnahme abbrechen","confirmCancel":"Sind Sie sicher, dass Sie die Videoaufzeichnung abbrechen möchten?","cancel":"Abbrechen","prepareUpload":"Bitte warten, das Hochladen der Aufnahme wird vorbereitet","hasTmpRecord":"Die Aufnahme wurde unterbrochen, ging aber nicht verloren","restore":"Wiederherstellen","delete":"Löschen","recordOnAnotherDevice":"Die Aufnahme läuft auf einem anderen Gerät ..."},"menu":{"enabled":"Aktiviert","disabled":"Deaktiviert","open_in_new_tab":"In neuem Tab öffnen","copy_link":"Link in Datei kopieren","expand_in_full_window":"Vollfenster anzeigen","autoplay":"Autoplay","sound_default":"Sound standardmäßig","sound_loop":"Schleifen","sound_hideControls":"Steuerelemente ausblenden","sound_showPanel":"Show top panel","shadow_video":"Schatten für video","video_params":"Video-Parameter","disallow_download":"Herunterladbar für","for_note":"Arbeitsbereich-Benutzer","for_share":"Öffentlichen Seiten","motion_video":"Motion video","preview_video":"Change preview","preview_video_btn":"Preview","print":"Drucken","convert_to_image":"In Bild umwandeln","convert_to_file":"Convert to file","style":"Stil","shadow_image":"Schatten für Bild","rename":"Umbenennen","replace":"Ersetzen","delete":"Löschen","download":"Herunterladen","get_text_from_image":"Text vom Bild holen","view_as":"Ansicht als","single_page":"Einzelseite","all_pages":"Alle Seiten","cta_motion_video_message":"CTA is enabled for videos. You cannot use CTA and Motion video at the same time. Disable CTA and try enabling Motion video again.","cta_loop_message":"CTA is enabled for videos. You cannot use CTA and Loop at the same time. Disable CTA and try enabling Loop again.","grid":"Grid","cta_drop_in_grid":"CTA is enabled for videos. We recommend checking the correctness of the CTA display after transferring the video into a grid column.","cta_exists_in_grid":"The grid column has a video with an active CTA. Please check if it is correct after the transfer."},"downloading":"Herunterladen","attachment_not_found_error":"Fehler beim Hochladen","pdf_viewer":{"initializing_full_window_view":"Vollfensteransicht einstellen","preparing_document_for_printing":"Dokument für den Druck vorbereiten...","printing_initialization":"Druckeinstellung...","abort":"Abbrechen","set_page_as_default":"Seite als Standard festlegen","unset_page_as_default":"Standardseite. Klicken Sie, um die Seite zu normalisieren."},"video_just_uploaded_codec_error":"Sie versuchen, ein Video hochzuladen, das mit dem Codec {codec} kodiert wurde. Wir können nicht garantieren, dass dieses Video auf allen Browsern korrekt wiedergegeben wird. Wir empfehlen, das Video in ein anderes Format zu konvertieren und es erneut hochzuladen.","video_codec_error":"Dieses Video ist mit dem Codec {codec} kodiert, der in Ihrem Browser nicht unterstützt wird.","safari_webm_not_support":"Zurzeit unterstützt der Safari-Browser das WEBM-Format nicht. Versuchen Sie, die Notiz in einem anderen Browser zu öffnen, z. B. in Google Chrome oder Mozilla Firefox.","video_transcribe":"Transcribe","video_summary":"Summary","video_meeting_notes":"Meeting Notes","video_ask_ai":"Ask AI"},"image":{"text_from_image_popup":{"title":"Text aus Bild","no_text":"Es gibt keinen Text","copy":"Gesamten Text kopieren"},"unknown_error":"Der Link ist falsch","add_image":"Bildlink einfügen oder ","add_image_or":"oder","add_image_small":"Einfügen oder ","browse":"durchblättern","browse_image":"Bild durchsuchen","too_large_error":"Bildgröße ist zu groß","image_info_dialog":{"title":"Bildinfo","type":"Typ","size":"Größe","location":"Standort","copy_link":"Link kopieren"},"rotate_wait":{"full":"Bitte warten","medium":"Warten"},"attachment_not_found_error":"Ein unerwarteter Fehler ist beim Bild aufgetreten","readonly_placeholder":"Leeres Bild","unsplash":{"name":"Unsplash","header":"Search image","placeholder":"Search for an image","search":"Search","description":"Search to find more results.","no_result":"No images found.","caption_preffix":"Photo by"},"comments":"Comments"},"attachment":{"unknown_error":"Etwas ist schief gelaufen, bitte versuchen, eine andere Datei auszuwählen","attachment_is_being_uploaded":"Datei wird hochgeladen...","attachment_will_be_downloaded_online":"Datei wird heruntergeladen, sobald Sie online sind.","attachment_preview_is_not_available":"Vorschau ist nicht verfügbar.","choose_a_file":"Dateien auswählen","wait_resolving_without_info":"Please wait..."},"video":{"player":{"play":"Abspielen","pause":"Pause","volume":"Lautstärke","fullscreen_on":"Vollbild","fullscreen_off":"Vollbild beenden","watch_again":"Nochmals ansehen."}},"search":{"placeholder":"In der Notiz finden","matches":"Treffer:"},"copy":{"copied":"Kopiert!","copy_to_clipboard":"In die Zwischenablage kopieren"},"apply":"Anwenden","done":"Erledigt","block_menu":{"align":{"left":"Links ausrichten","center":"Mittig ausrichten","right":"Rechts ausrichten","justify":"Blocksatz"},"indent":{"indent":"Einzug vergrößern","outdent":"Einzug verkleinern"},"tooltip":"Ziehen um zu Verschieben\\n<span>Zum Öffnen des Menüs klicken</span>","copy_tooltip":"Link kopieren","color":{"background_color":"Hintergrundfarbe","color":"Farbe","line_color":"Linienfarbe","line_type":"Zeilentyp","player_color":"Farbe des Players"},"line_type":{"default":"Standardlinie","dotted":"Punkte"},"add":{"name":"Block hinzufügen","above":"Oben","below":"Unten","left":"Links","right":"Rechts","above_column":"Above column","below_column":"Under column"},"convert_to":{"name":"Konvertieren zu","to_do_list":"Checklist","number_list":"Nummerierte Liste","bullet_list":"Aufzählungsliste","paragraph":"Absatz","large_heading":"Große Überschrift","medium_heading":"Mittlere Überschrift","small_heading":"Kleine Überschrift","large_heading_toggle":"Collapsible Large Heading","medium_heading_toggle":"Collapsible Medium Heading","small_heading_toggle":"Collapsible Small Heading","code":"Code","quote":"Zitat","hint":"Hinweis","image":"Bild","file":"Datei","remote_frame":"Einbetten","link":"Link","bookmark":"Lesezeichen","button":"Button","toggle":"Toggle Block","step":"Steps"},"comment_block":"Kommentar","edit":"Bearbeiten","duplicate":"Duplizieren","copy_block":"Block kopieren","copy_blocks":"Blöcke kopieren","copy_link":"Link kopieren","delete":"Löschen","replace":"Ersetzen","blot_lock":"Block sperren","blot_unlock":"Block entsperren","set_as_preview":"Als Vorschau festlegen","get_text_from_image":"Text vom Bild holen","edit_image":"Edit image","download":"Herunterladen","view_full_size":"Ansicht in voller Größe","open_in_new_tab":"In neuem Tab öffnen","image_info":"Bildinfo","rotate_image":"Drehen","add_sub_task":"Unteraufgabe hinzufügen","add_sub_text":"Untertext hinzufügen","layout":"Layout","embed_align":{"left":"Links ausrichten","center":"Mittig ausrichten","right":"Rechts ausrichten","default":"Standardgröße","full_width":"Volle Breite"},"expand_all":"Alle ausklappen","collapse_all":"Alle einklappen","add_caption":"Titelzeile hinzufügen","blot_locked_admin":"Die Bearbeitung des Blocks ist gesperrt. Klicken Sie, um die Sperre aufzuheben.","blot_locked_admins":"Die Bearbeitung der Blöcke ist gesperrt. Klicken Sie, um die Sperre aufzuheben.","blot_locked_user":"Sie haben keine Berechtigung, diesen Bock zu bearbeiten. Wenden Sie sich an den Administrator Ihrer Organisation.","show_header":"Obere Leiste anzeigen","show_borders":"Rahmen anzeigen","rename":"Umbenennen"},"convert_menu_groups":{"suggestions":"Vorgeschlagen","basic":"Grundlegendes","advanced":"Erweitert","media":"Medien","embed":"Integrationen","views":"Ansichten","templates":"Vorlagen","helpful_links":"Hilfreiche Links"},"embedded_menu":{"start_typing":"Type \\"/\\" or add","start_typing_full":"Start writing or type \\"/\\", \\"@\\"","more_items":"Mehr Einträge...","add_an_element":"Element hinzufügen","paragraph":"Absatz","todo":"Checkbox-Liste","numbered_list":"Nummerierte Liste","bullet_list":"Aufzählungsliste","table":"Tabelle","image":"Bild","file":"Datei","audioRec":"Audio Aufnahme","videoRec":"Video Aufnahme","recordExist":"Sie können eine neue Aufnahme erst beginnen, wenn die vorherige abgeschlossen ist. Beenden oder löschen Sie die vorherige Aufnahme, um eine neue zu beginnen.","large_heading":"Überschrift 1","medium_heading":"Überschrift 2","small_heading":"Überschrift 3","large_heading_toggle":"Einklappbare Überschrift 1","medium_heading_toggle":"Einklappbare Überschrift 2","small_heading_toggle":"Einklappbare Überschrift 3","section_break":"Abschnittsumbruch","link":"Link","code":"Code","quote":"Zitat","hint":"Hinweis","hint_placeholder":"Schreibe etwas","mention":"Mitglieder erwähnen","outline":"Inhaltsübersicht","remote_frame":"Einbetten: Link, iFrame, JS Code","integrations":"Integrationen","google_drive":"Google Drive","google_sheets":"Google-Tabellen","html":"HTML","toggle":"Umschalter","tasks_list":"Aufgabenliste","lock_blot":"Block sperren","link_page":"Seiten-Link","date":"Datum","more_integrations":"weitere Integrationen","two_columns":"Zwei Spalten","meeting_notes":"Marketing-Strategie","marketing_brief":"Marketing-Quartalsplanung","content_plan":"Inhaltliche Planung","more_templates":"weitere Vorlagen","get_feedback":"Feedback einholen","contact_support":"Kontakt zum Support","learn_nimbus":"Nimbus kennenlernen","footer_top":"Did you know? You can start typing to search the list","footer_bottom":"Can’t find smth you want?","footer_link":"Tell us","add_note":"New page","database_with_options":"Datenbank","board":"Aufgabentafel","progress":"Progress","dropdown_list":"Dropdown list","uploader":"File uploader","use_ai":"Use Fusebase AI","helper":"AI helper","summarize":"Summarize","explain":"Explain","improve":"Improve","spelling":"Fix spelling and grammar","cta":"Call to actions","shorter":"Make shorter","longer":"Make longer","step":"Steps"},"button":{"title":"Title","id_info_tooltip":"Diese ID kann in Zukunft bei der Bearbeitung der CSS-Datei verwendet werden.","address":"URL oder E-Mail","open_in_new_tab":"In neuem Tab öffnen","shape":"Form des Buttons","background":"Hintergrund","size":"Größe des Buttons","small":"Klein","medium":"Mittel","big":"Groß","cancel":"Abbrechen","done":"Fertig","length_error":"Der Text ist zu groß für den Button. Versuchen Sie, weniger Text auszuwählen (nicht mehr als 50 Zeichen).","type":"Button-Typ","default":"Standard","withShadow":"Button mit Schatten","3d":"3d Button","convert":{"popup_title":"Convert to button"}},"link":{"open":"Öffnen","send":"Senden","copy":"Kopieren","edit":"Bearbeiten","remove":"Entfernen","text_label":"Text","url_label":"Link-Adresse","email_label":"E-Mail-Adresse","copied":"Link in die Zwischenablage kopiert","cancel":"Abbrechen","done":"Fertig"},"syntax":{"menu":{"language":"Sprache","theme":"Theme","wrap":"Zeilenumbruch aktivieren","unwrap":"Zeilenumbruch deaktivieren","lineNumbersOn":"Zeilennummern anzeigen","lineNumbersOff":"Zeilennummern verbergen"},"convert":{"popup_title":"Convert to code","blots_have_comments":"There are comments in the text that will be deleted during conversion.","text_has_inline_comments":"There are comments inside the text that will be deleted during conversion.","confirm":"Convert"}},"list":{"list_style":"Listenstil","type_default":"Voreinstellung","type_rectangle":"Rechteck","type_star":"Stern","type_dart":"Dart","type_rounded":"Abgerundet","type_arrow":"Pfeil","type_diamond":"Diamant"},"caption":{"placeholder":"Titelzeile hinzufügen"},"mention":{"show_all":"Alle anzeigen","show_all_users":"Alle anzeigen","placeholder":"Letzten anzeigen oder Typ zu suchen","user":"Personen","workspace":"Arbeitsbereiche","folder":"Ordner","note":"Notizen","no_results":"Keine Ergebnisse","offline_message":"Erwähnung funktioniert nur bei aktiver Verbindung. Bitte Internet einschalten und erneut versuchen.","info":{"note":{"one":"Notiz","some":"Notizen","many":"Notizen"},"subfolder":{"one":"Unterordner","some":"Unterordner","many":"Unterordner"},"member":{"one":"Mitglied","some":"Mitglieder","many":"Mitglieder"},"owner":"Besitzer","loading":"Vorschau wird geladen...","loading_failed":"Laden fehlgeschlagen","not_loaded":"Notiz wurde noch nicht geladen"},"back_button":"Zurück","create_note_for":"Notiz erstellen","create_folder_for":"Ordner erstellen"},"calendar":{"ui":{"date":"Datum","am":"AM","pm":"PM","date_format":"Datumsformat","show_time":"Uhrzeit anzeigen","time_format":"Zeitformat","time_12":"12H","time_24":"24H","first_week_day":"Erster Tag der Woche","time_zone":"Zeitzone","use_gmt":"GMT für alle Mitglieder verwenden","use_gmt_hint":"Dieselbe Zeitzone (GMT) für alle Mitarbeiter verwenden","table":{"clear":"Entfernen"},"inline":{"clear":"Löschen"},"reminder":{"name":"Warnung","panel_name":"Warnung","push_name":"Event Erinnerung","remove_confirm_message":"You have alerts that are time-bound. Do you want to delete these reminders?","remove_confirm_text":"Delete","remove_cancel_text":"Don\'t delete reminders","before_period":"","after_period":"vorher","period":{"m":{"one":"Minute","many":"Minuten"},"h":{"one":"Stunde","many":"Stunden"},"d":{"one":"Tag","many":"Tage"},"w":{"one":"Woche","many":"Wochen"}},"value":{"none":"Keine","0m":"Beim Start","1m":"1 Minute vorher","5m":"5 Minuten vorher","10m":"10 Minuten vorher","15m":"15 Minuten vorher","30m":"30 Minuten vorher","1h":"1 Stunde vorher","2h":"2 Stunden vorher","1d":"1 Tag vorher","2d":"2 Tage vorher","7d":"7 Tage vorher","10d":"10 Tage vorher","14d":"14 Tage vorher","custom":"Benutzerdefiniert"},"until":{"in":"In","d":"T","h":"S","m":"Min","already_been":"Schon gewesen","less_minute":"Weniger als eine Minute","now":"Jetzt"}},"postfix":{"day":"T","month":"M"}},"insert":{"category_name":"Datum","custom":"Benutzerdefiniert","now":"Jetzt","today":"Heute","tomorrow":"Morgen"},"date_format":{"ddmmyyyy":"dd/mm/yyyy","mmddyyyy":"mm/dd/yyyy","yyyyddmm":"yyyy/mm/dd","monthddyyyy":"Monat dd, yyyy","default":"Browser Format anpassen"},"months":{"0":"Januar","1":"Februar","2":"März","3":"April","4":"Mai","5":"Juni","6":"Juli","7":"August","8":"September","9":"Oktober","10":"November","11":"Dezember"},"days":{"short":{"0":"So","1":"Mo","2":"Di","3":"Mi","4":"Do","5":"Fr","6":"Sa"},"full":{"0":"Sonntag","1":"Montag","2":"Dienstag","3":"Mittwoch","4":"Donnerstag","5":"Freitag","6":"Samstag"}}},"content_not_supported":"Diese Notiz wird von Ihrer Version der FuseBase App nicht unterstützt. Versuchen Sie, sie zu aktualisieren oder verwenden Sie einen anderen Client in der neuesten Version.","profession_ask":{"title":"Zeit sparen durch die Verwendung von Vorlagen zur Erstellung neuer Notizen","text":"Geben Sie Ihren Beruf ein, und unser Team erstellt Vorlagen für Sie. Es ist kostenlos, ohne versteckte Kosten","i_am_a":"Ich bin","placeholder":"e.g. Designer, Lehrer, Verkäufer, usw.","request_template":"Template anfordern","sucess_message":"Vielen Dank! Dieser Beruf wird in unsere Warteliste aufgenommen."},"bookmark":{"name":"Lesezeichen","edit":"Lesezeichen bearbeiten","title":"Titel","address":"Adresse","description":"Beschreibung","placeholder":"Link mit https:// einfügen oder schreiben...","placeholder_mobile":"Paste or write link","loading_preview":"Vorschau wird geladen...","block_menu":{"change_mode":{"menu_name":"Ansicht als","mode_tile":"Kachel","mode_card":"Karte","mode_cover":"Einband"},"change_preview":"Vorschau ändern","delete_preview":"Vorschau löschen","reset_preview":"Vorschau zurücksetzen","change_preview_background":"Preview background","options":{"menu_name":"Optionen","open_in_same_tab":"Im gleichen Tab öffnen"}},"error":{"unknown_error":"Etwas ist schief gelaufen, bitte eine andere URL einzugeben","preview_notfound":"Vorschau nicht gefunden"},"upload":{"new_preview":"Upload New","quota_error":"The file is larger than the 3MB allowed. Try another file.","unknown_error":"Unknown error. Try another file."}},"businessCard":{"PERSON":"Name","ORGANIZATION":"Unternehmen","TITLE":"Titel","ADDRESS":"Standort","URL":"Webseite","PHONE":"Telefon","EMAIL":"E-Mail","SKYPE":"Skype","TWITTER":"Twitter","INSTAGRAM":"Instagram","FACEBOOK":"Facebook","LINKEDIN":"LinkedIn","VK":"Vk"},"dialog_common":{"button":{"ok":"Ok","cancel":"Abbrechen"}},"outline":{"default_name":"Inhaltsübersicht","menu":{"expand":"Ausklappen","collapse":"Einklappen","rename":"Umbenennen"},"context_menu":{"convert_to":{"text":"Text"},"style":{"name":"Stil der Inhaltsübersicht","list_only":"Einfache Liste","numbered_list":"Nummerierte Liste","bordered":"Rahmen anzeigen","border_color":"Border color"}},"empty":"Fügen Sie Ihrer Notiz Überschriften hinzu, dann erscheinen diese hier als Links"},"floating_toolbar":{"bold":"Fett","italic":"Kursiv","underline":"Unterstrichen","strikethrough":"Durchgestrichen","clear":"Formatierung entfernen","code":"Code","button":"Button","link":"Link","highlight":"Hervorhebung","extraHighlight":"Kontrastreiche Hervorhebung","color":"Farbe für Text und Hervorhebung","text":"Textfarbe","clear_all":"Alle zurücksetzen","placeholder":"Platzhalter","adapts":{"dark":"Passt sich einem dunklen Thema an","light":"Passt sich einem hellen Thema an"},"create_note":"Notiz erstellen","add_comment":"Kommentar hinzufügen"},"remote_frame":{"placeholder_small":"URL einbinden","placeholder_full":"Jede URL einbinden, wie YouTube, Github, Maps, Twitter usw.","loading":"Wird geladen...","context_menu":{"change_link":"Link ändern","full_size":"Vollbild","reset_size":"Größe zurücksetzen","open_origin":"Original öffnen","layout":"Layout","show_toolbar":"Bearbeitungsleiste anzeigen","copy_original":"Copy link to original"},"error":{"is_not_link":"Link ist nicht korrekt","content_error":"Die folgende Domain wird nicht unterstützt oder die URL ist falsch. Bitte <a href=\\"https://nimbusweb.me/contact-us.php\\" target=\\"_blank\\">unseren Support kontaktieren</a> und wir werden den Link bearbeiten.","unknown_error":"Etwas ist schief gelaufen, bitte eine andere URL eingeben","wrong_signature":"Dieser Inhalt ist fehlerhaft und kann nicht angezeigt werde","google_docs_auth_error":"Höchstwahrscheinlich kann die Google Dokumenten/Tabellen/Präsentations Datei nicht eingebettet werden, weil kein Zugriff darauf möglich ist.  <a href=\\"http://nimb.ws/EkX87M\\" target=\\"_blank\\">Bitte unsere Anleitung lesen.</a>","internal_link_error":"{{serviceName}} has forbidden following internal links. Click on Back to return to the previous page."},"convert_bookmark":"In Lesezeichen umwandeln","convert_link":"In Link umwandeln","back_button":"Back"},"google_drive":{"block_name":"Google Drive","loading":"Wird geladen...","menu":{"expand":"Ausklappen","collapse":"Einklappen","open_origin":"In Google Drive öffnen","download":"Herunterladen","change_account":"Konto ändern","choose_another_file":"Andere Datei auswählen"},"last_modified":"Zuletzt geändert von {{userName}} vor {{time}}","browse":"Datei durchsuchen","login":"Bei Google anmelden","login_text":"Dateien durchsuchen und von Google Drive hinzufügen"},"html":{"default_name":"HTML","loading":"Wird geladen...","menu":{"open_source":"Quell-Link öffnen","export_blot":"HTML speichern"},"unknown_error":"Unbekannter Fehler","device_cant_display_content":"Gerät kann diesen Inhalt nicht anzeigen","wrong_signature":"Dieser Inhalt ist fehlerhaft und kann nicht angezeigt werden"},"relative_time":{"seconds":{"one":"{{count}} Sekunde","some":"{{count}} Sekunden","many":"{{count}} Sekunden"},"minutes":{"one":"{{count}} Minute","some":"{{count}} Minuten","many":"{{count}} Minuten"},"hours":{"one":"{{count}} Stunde","some":"{{count}} Stunden","many":"{{count}} Stunden"},"days":{"one":"{{count}} Tag","some":"{{count}} Tage","many":"{{count}} Tage"},"months":{"one":"{{count}} Monat","some":"{{count}} Monate","many":"{{count}} Monate"},"years":{"one":"{{count}} Jahr","some":"{{count}} Jahre","many":"{{count}} Jahre"}},"collapsible_content":{"menu":{"expand":"Aufklappen","collapse":"Einklappen","rename":"Umbenennen"}},"convert_link":{"url":"URL","title":"Titel","embed":"Einbinden","bookmark":"Lesezeichen","button":"Button","link_to_note":"Link zur Notiz","link_to_folder":"Link zum Ordner","link_to_workspace":"Link to workspace","convert_error":"Bei der Konvertierung der URL ist ein Fehler aufgetreten"},"fullwidth":{"menu_item":"Volle Breite"},"resizeable":{"point_tooltip":{"default":"Größe ändern","bottom-right":"Größe ändern\\n(halten Sie die Taste {{altKey}} gedrückt, um die Größe frei zu ändern)"}},"toggle":{"placeholder":"Click here to create or move a block","expand":"Expand toggle","collapse":"Collapse toggle","expand_heading":"Expand heading","collapse_heading":"Collapse heading","expand_step":"Expand step","collapse_step":"Collapse step"},"step":{"content_placeholder":"Click here to create description to the step","title_placeholder":"Enter a short title to describe this step","aggregator_placeholder":"Enter a short descriptive title","menu":{"step_layout":{"name":"Layout","show_number":"Show number","show_arrow":"Show arrow","show_border":"Show border"}}},"tasks_list":{"not_supported":"Currently, we cannot display the task list as it is not supported in this type of pages.","menu":{"show_title":"Show task list name","view":"Default view","task_list_view":"Task list","calendar_view":"Calendar","kanban_view":"Kanban"}},"board":{"not_supported":"Currently, we cannot display the task board as it is not supported in this type of pages.","menu":{"add_new_column":"New column","board_layout":{"name":"Layout","show_add_new_column":"Show Add column"}}},"empty_features":{"use_template":"Use a template","import":"Import","add_database":"Add database","add_database_with_options":"Add database with options","add_board":"Aufgabentafel","use_ai":"Use Fusebase AI"},"ai_manager":{"generate_error":"Unfortunately, there are no results for your request. Please try another request.","unload_message":"Fusebase AI content is being generated. Are you sure you want to exit?","unknown_error":"Unknown error. Try again later or contact support.","dialog":{"title":"Discard draft","body":"Do you want to discard draft?","accept":"Yes, discard"}},"uploader":{"header":"Upload files","description":"Here, you can add some helpful information about file uploading","dropzone_full":"Drag file(s) here or","browse":"click to upload","dropzone_compact":"Add more files","uploading_progress":"Uploading {{progress}}%","uploading_files":"Uploading files","counter":"{{current}} of {{total}}","timer":"less than 1 minute remaining","header_placeholder":"Write a title, max {{maxChars}} characters","description_placeholder":"Write a description, max {{maxChars}} characters","errors":{"network":"Failed uploading file","too_big":"File is too big"},"menu":{"disallow_download":"Downloading","for_note":"For workspaces users","for_share":"Public page","convert_to_files":"Convert to files","allow_upload":"Uploading","enable_in_public_page":"Enable in public page"}},"convert_menu_tooltips":{"labels":{"management":"Gut geeignet für Wissensmanagement","collaboration":"Perfekt für die Zusammenarbeit"},"paragraph":{"title":"Am besten für den Hauptinhalt","description":"Dies ist der Hauptblock zum Schreiben von Seiteninhalten."},"todo":{"title":"Eine Liste für kleine Aufgaben? Einfach abhaken!","description":"Schreib kleine Besorgungen und Routineaufgaben auf, die zu erledigen sind."},"numberedlist":{"title":"In einer Reihe aufstellen: Eins, zwei, drei!","description":"Erhöhe die Lesbarkeit Deiner Inhalte und zeige sie in einer Reihefolge an."},"bulletlist":{"title":"Aufzählungspunkte machen alles klarer","description":"Du kannst eine Liste erstellen, die sich von anderen Inhalten abhebt."},"table":{"title":"Erfreue Dich an der Strukturierung","description":"Organisiere Deine Informationen in einer Tabelle, um einen ganzheitlichen Blick auf Deine Arbeit zu erhalten."},"image":{"title":"Wir müssen es sehen - füge ein Bild hinzu","description":"Gestalte Deine Seiten attraktiver, indem Du Bilder eines beliebigen Dateityps hinzufügst, verschiebst oder in der Größe veränderst."},"file":{"title":"Dateien hier, Dateien dort, Dateien überall!","description":"Erstelle eine Datenbank für Dein Projekt, indem Du Dateien mit verschiedenen Erweiterungen zu Deiner Seite hinzufügst."},"largeheading":{"title":"Am besten geeignet für die Hauptabschnitte der Seite","description":"Dies ist die größte Überschrift, die Du hinzufügen kannst. Du lenkst damit die Aufmerksamkeit auf den wichtigsten Teil Deiner Seite und erleichterst die Navigation."},"mediumheading":{"title":"Am besten geeignet für die sekundären Abschnitte der Seite","description":"Dies ist eine mittelgroße Überschrift, die Du hinzufügen kannst. Unterteile damit Deine Seite in Abschnitte um alles, was Du brauchst, leicht zu finden."},"smallheading":{"title":"Am besten geeignet für starke Ideen in Unterabschnitten","description":"Dies ist eine kleine Überschrift, die Du hinzufügen kannst, die aber dennoch hervorsticht. Verwende sie, um Deine Seite in Unterabschnitte zu unterteilen."},"tasks-list":{"title":"Organisiere Deine Arbeit mit Nimbus Tasks","description":"Hier kannst Du Deine Aufgaben in Aufgabenlisten gruppieren. Weise Deinen Teammitgliedern Aufgaben zu, setze Fristen und füge den Status für eine einfache Verfolgung hinzu."},"hline":{"title":"Lass uns die Inhalte trennen","description":"Trenne verschiedene Teile eines Projekts oder unterteile Deine Beispiele und Ideen für das Projekt."},"link":{"title":"Pflastere den Weg mit Links","description":"Wann immer Du eine Idee für Dein Projekt hast, füge einen Link hinzu und benenne ihn."},"syntax":{"title":"Vergiss den Code nicht","description":"Du kannst Code direkt auf Deiner Seite hinzufügen und dabei zwischen Themen, Sprachen und mehr wechseln!"},"link-page":{"title":"Dein nächster Halt ist eine andere Seite","description":"Verlinke eine andere Seite, die mit diesem Projekt verbunden ist, um sofort darauf zuzugreifen."},"date":{"title":"Sag einfach, wann","description":"Lege eine Frist für Dein Projekt fest oder markiere den genauen Zeitpunkt, an dem Du mit der Arbeit an einer Seite begonnen hast."},"mention":{"title":"Beziehe Dein Team mit ein","description":"Deine Teammitglieder erhalten E-Mail-Benachrichtigungen, um eine bestimmte Seite zu öffnen und dort mitzuarbeiten."},"blockquote":{"title":"Und ich zitiere","description":"Du kannst wichtige Worte Deiner Kunden hervorheben oder eine motivierende Phrase herausstellen."},"hint":{"title":"Lass uns einen Hinweis geben","description":"Wähle ein Emoji und eine Hintergrundfarbe, um Warnungen, Haftungsausschlüsse oder Benachrichtigungen auf Deiner Seite hervorzuheben."},"toggle":{"title":"Textblöcke zusammenklappen und ausklappen","description":"Sortiere und verberge zusätzliche Informationen auf Deinen Seiten, um die Navigation und den Zugriff zu erleichtern."},"outline":{"title":"Sehen, was Dich auf der Seite erwartet","description":"Erstelle ein Inhaltsverzeichnis für eine einfache Navigation auf langen Seiten oder Wikis."},"lock-blot":{"title":"Keiner kann ihn bearbeiten","description":"Du kannst einen bestimmten Informationsblock auf Deiner Seite unangetastet und schreibgeschützt lassen."},"embed":{"title":"Weniger Tabs mit Google-Tabellen","description":"Halte Deine Daten mit anderen Projektdetails an einem Ort, um leichter Ergebnisse erzielen zu können."},"figma":{"title":"Bleibe an Deinem Bildmaterial noch näher dran","description":"Füge Figma hinzu, um die Entwicklung von Projektvisualisierungen in Echtzeit zu verfolgen."},"miro":{"title":"Dein Miro-Board befindet sich an einem sicheren Ort","description":"Entwickle eine Layout-Strategie oder einen Fahrplan für Dein Projekt und setze dann die Arbeit an Deiner Seite fort."},"columns":{"title":"Zwei Spalten sind besser als eine","description":"Unterteile Deine Seite in zwei Spalten, um dort mehr Inhalt hinzuzufügen und Deine Seite übersichtlicher zu gestalten."},"meeting-notes":{"title":"Ziele setzen und vorankommen","description":"Verwende diese Vorlage, um eine Marketingstrategie zu erstellen und alle Details an einem Ort zu speichern."},"marketing-brief":{"title":"Groß träumen, vierteljährlich planen","description":"Verwende diese Vorlage, um einen Marketingplan nach Quartalen zu erstellen."},"content-plan":{"title":"Kontrolliere und führe Deine Arbeit","description":"Verwende diese Vorlage, um alles, was Dir durch den Kopf geht, auf einen Tisch zu legen, wo Du alle Teile visualisieren und Aufgaben verwalten kannst."},"integrations":{"title":"Weniger Tabs mit Google-Tabellen","description":"Halte Deine Daten mit anderen Projektdetails an einem Ort, um leichter Ergebnisse erzielen zu können."},"google-drive":{"title":"Lade Deine Dateien von Google Drive","description":"Du kannst Dein Google Drive-Konto einbinden und Links zu Deinen Drive-Dateien für einen schnellen Zugriff einfügen."},"google-sheets":{"title":"Google Sheet Registerkarte","description":"Halte Deine Daten zusammen mit anderen Projektdetails an einem Ort, um leichter Schlüsse ziehen zu können."},"bookmark":{"title":"Kennzeichne Deinen Link durch einen neuen Look","description":"Verwende Lesezeichen, um den Titel Deines Links, eine kleine Beschreibung und ein Vorschaubild der Website anzuzeigen."},"audioRec":{"title":"Sprechen statt schreiben","description":"Verleihe der Zusammenarbeit eine menschliche Note, indem Du Sprachfeedback zu den Inhalten auf Deiner Seite aufnimmst."},"videoRec":{"title":"Zeigen statt schreiben","description":"Nimm eine visuelle Erklärung auf, was zu tun ist, oder gib explizites Feedback anhand eines Videobeispiels."},"button":{"title":"Gekommen, gesehen, geklickt","description":"Füge ein CTA-Element hinzu, das die Aufmerksamkeit auf wichtige Links auf Deinen Seiten lenkt."},"largeheading-toggle":{"title":"Verstecke zusätzlichen Inhalt in einer großformatigen einklappbaren Überschrift","description":"Definiere den wichtigsten Teil Deiner Seite und verbirg dort Informationen, um einfach darauf zuzugreifen."},"mediumheading-toggle":{"title":"Verkürze Deine Abschnitte","description":"Erstelle Abschnitte mit einer mittelgroßen einklappbaren Überschrift und verstecke dort einen Teil Deines Inhalts."},"smallheading-toggle":{"title":"Verkürze Deine Unterabschnitte","description":"Erstelle auf Deinen Seiten Unterabschnitte mit einer kleinen einklappbaren Überschrift, um dort zusätzliche Informationen zu verbergen."},"database-with-options":{"title":"Von der Tabelle zur Datenbank","description":"Erstelle eine Datenbank für Dein Projekt und passe sie an, indem Du verschiedene Arten von Spalten und Zeilen auswählst, die Hintergrundfarbe änderst und vieles mehr."},"board":{"title":"Sag Hallo zu Deinen Aufgaben auf einer Tafel","description":"Zeige Deine Aufgaben als Karten auf einem Kanban-Board an. Damit hast Du immer einen Gesamtüberblick."},"progress":{"title":"Sieh, wie weit Du gekommen bist!","description":"Wähle Deinen Wert und schätze ihn. Bewerte und kommentiere Deine hinzugefügten Inhalte, Aufgaben oder anderen Aktivitäten."},"uploader":{"title":"Sage Auf Wiedersehen zum Dateichaos!","description":"Kläre, welche Dateien deine Kunden und/oder dein Team senden müssen. Mit dem Datei-Uploader kannst du genau das bekommen, was du benötigst und alles an einem Ort aufbewahren."},"dropdown-list":{"title":"Gib uns Optionen","description":"Platziere Antwortoptionen an beliebiger Stelle im Text und lass andere sofort Feedback geben."},"use-ai":{"title":"Arbeite intelligent, nicht hart","description":"Nutze KI, um deine Inhalte zu erstellen und zu verbessern, neue Ideen zu bekommen und personalisierte Empfehlungen zu erhalten. Arbeite mit einem KI-Assistenten in deinem Arbeitsbereich."}},"feature_availability":{"plus":{"not-available":"Available for Plus & Team & Business plans","trial":"This is open as a trial Plus feature for you"},"team":{"not-available":"Available for Team & Business plans","trial":"This is open as a trial Team feature for you"},"business2023":{"not-available":"Available for Business plan","trial":"This is open as a trial Business feature for you"}}}');
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/i18n/messages/it.json
const it_namespaceObject = JSON.parse('{"table":{"common":{"column":"Colonna"},"move_column_cant_split_merged_cells":{"title":"Impossibile spostare la colonna","text":"Impossibile spostare una colonna in una cella unita. Separale e riprova."},"move_column_cant_move_part_of_merged_cells":{"title":"Impossibile spostare la colonna","text":"La colonna che stai tentando di spostare contiene parte di una cella unita. Se vuoi spostare la colonna, separa prima le celle."},"move_column_failed":{"title":"Impossibile spostare la colonna","text":"Si è verificato un errore imprevisto durante lo spostamento di una colonna, riprova."},"move_row_cant_split_merged_cells":{"title":"Impossibile spostare la riga","text":"Impossibile spostare una riga in una cella unita. Separale e riprova."},"move_row_cant_move_part_of_merged_cells":{"title":"Impossibile spostare la riga","text":"La riga che stai tentando di spostare contiene parte di una cella unita. Se desideri spostare la riga, separa prima le celle."},"move_row_cant_move_in_sortable_table":{"title":"Impossibile spostare la riga","text":"Impossibile spostare una riga in una tabella ordinabile. Annulla l\'ordinamento e riprova."},"move_row_cant_move_in_filtered_table":{"title":"Unable to move row","text":"Cannot move a row in a filtered table. Cancel filter then try again."},"move_row_failed":{"title":"Impossibile spostare la riga","text":"Si è verificato un errore imprevisto durante lo spostamento di una riga, riprova."},"first_move_column_or_row_message":"You can select multiple rows or columns by holding down the CTRL button and clicking on the desired rows or columns.","menu":{"delete":"Elimina","help":"Aiuto","delete_column":{"one":"Elimina colonna","many":"Elimina {{count}} colonne"},"delete_row":{"one":"Elimina riga","many":"Elimina {{count}} righe"},"add":"Inserisci","add_row_before":{"one":"Riga sopra","many":"{{count}} righe sopra"},"add_row_after":{"one":"Riga sotto","many":"{{count}} righe sotto"},"add_col_before":{"one":"Colonna a sinistra","many":"{{count}} colonne a sinistra"},"add_col_after":{"one":"Colonna a destra","many":"{{count}} colonne a destra"},"copy_cell":{"one":"Copia cella","many":"Copia celle"},"copy_table":"Copia tabella","table_layout":{"name":"Layout della tabella","column_headings":"Intestazioni di colonna","row_headings":"Intestazioni di riga"},"import_csv":"Import from CSV","merge_cells":"Unisci celle","insert_checkbox":"Inserisci casella di controllo","background_color":"Colore di sfondo","formatting":"Formattazione","clear":"Cancella","reset":"Ripristina","divide_cells":"Dividi le celle","type":{"name_cell":"Tipo di cella","name_cells":"Tipo di celle","name_column":"Tipo di colonna","name_columns":"Tipo di colonne","type_cell":{"one":"Tipo di cella","many":"Tipo di celle"},"type_col":{"one":"Tipo di colonna","many":"Tipo di colonne"},"same_as_column":"Uguale alla colonna","reset_cells":"Ripristina le celle ai valori predefiniti","none":"Multi tipo","text":"Testo","textline":"Testo","number":"Numero","attachment":"Allegato","checkbox":"Casella di controllo","multiselect":"Selezione multipla","singleselect":"Selezione singola","collaborator":"Collaboratore","currency":"Valuta","date":"Data","link":"Link","rating":"Valutazione","progress":"Progresso","mention":"Citazione"},"number_format":{"name":"Formato numero","number":"Numero","commas":"Numero con virgole","percent":"Percentuale"},"currency_format":{"name":"Tipo di valuta","dollar":"Dollaro","euro":"Euro","yen":"Yen","yuan":"Yuan","rouble":"Rublo","pound":"Sterlina","rupee":"Rupia","hryvnia":"Grivnia","won":"Won","frank":"Franco","real":"Real","other":"Altro","stick":"Mostra il simbolo","before":"Prima","after":"Dopo"},"decimal_format":{"name":"Decimal separator","comma":"Comma","point":"Point","hint":"The separator is used for decimal places. Comma decimal separators will look like 1.000,99, and point separators look like 1,000.99"},"progress_format":{"name":"Opzioni di avanzamento","simple":"Semplice","colored":"Colorato","start_from":"Inizia da (0-100)","default_amount":"Quantità predefinita (0-100)"},"rating_format":{"name":"Opzioni di valutazione","star":"Stella","flag":"Bandiera","heart":"Cuore","amount":"Quantità (1-10)"},"date_format":{"name":"Formato Data/Ora"},"mention_panel":{"open":"Apri","edit":"Modifica","clear":"Cancella"},"color_numbers":{"name":"Color numbers","enable":"Enable color numbers"},"filter":"Filter","comment":"Comment"},"formatting_menu":{"align_left":"Sinistra","align_center":"Centro","align_right":"Destra","valign_top":"Superiore","valign_center":"Medio","valign_bottom":"Inferiore","text":"Testo","text_align":"Allineamento del testo","text_color":"Colore del testo","bold":"Grassetto","italic":"Corsivo","strikethrough":"Barrato","underline":"Sottolineato"},"col_menu":{"add_column_after":{"one":"Aggiungi colonna a destra","many":"Aggiungi {{count}} colonne a destra"},"add_column_before":{"one":"Aggiungi colonna a sinistra","many":"Aggiungi {{count}} colonne a sinistra"},"duplicate_column":{"one":"Duplica colonna","many":"Duplica colonne"},"rename":"Rinomina"},"row_menu":{"add_row_after":{"one":"Aggiungi riga sotto","many":"Aggiungi {{count}} righe sotto"},"add_row_before":{"one":"Aggiungi riga sopra","many":"Aggiungi {{count}} righe sopra"}},"warning":{"merge_different":"Non è possibile unire diversi tipi di oggetti","convert_merged":"Non è possibile convertire celle unite"},"select":{"create_list":"Digita per creare un elenco","create_item":"Digita per creare un elemento","create_option":"Digita per creare un\'opzione","create_label":"Digita per creare un\'etichetta","create":"Crea","delete":"Elimina"},"attachment":{"upload_more":"Carica file","downloading":"Download in corso"},"collaborator":{"placeholder":"Digita per aggiungere persone","no_result":"Nessun risultato","loading":"Caricamento in corso...","unknown":"Persona sconosciuta"},"checkbox":{"checked":"Sì","not_checked":"No"},"sorting":{"name":"Ordinamento","sort":"Ordina","disable":"Rimuovi ordinamento","change":"Fai clic per modificare","asc":{"common":"Ascendente","text":"Ordina A-Z","number":"Ordina 1-9","checkbox":"Prima non selezionato"},"desc":{"common":"Discendente","text":"Ordina Z-A","number":"Ordina 9-1","checkbox":"Prima selezionato"},"warning":{"column_merged":{"title":"Impossibile ordinare la colonna","text":"Impossibile ordinare la colonna con celle unite"},"table_rowspan":{"title":"Impossibile ordinare la colonna","text":"Impossibile ordinare la tabella con righe unite"},"merge":{"title":"Cells cannot be merged","text":"Cells cannot be merged while column sorting is active. Disable sorting and try again."},"different_currencies":{"title":"Avviso di ordinamento","text":"Stai utilizzando diverse valute in una colonna. L\'ordinamento potrebbe non essere corretto."}},"exit_dialog":{"title":"Rimuovi ordinamento","toggle":"Mantieni ordinato","text_keep":"Mantieni ordinato","text_no_keep":"L\'ordine delle colonne verrà ripristinato al suo ordine iniziale prima dell\'applicazione dell\'ordinamento","apply":"Applica"}},"filter":{"by_field":"Filter by this field","empty_table":"All records are filtered","popup_title":"In this table, show records","empty_filters":"No conditions are applied to this database","where":"Where","or":"Or","and":"And","add_condition":"Add condition","clear_all":"Clear all","contains":"contains","is":"is","is_not":"is not","contains_not":"contains not","has_any_of":"has any of","has_none_of":"has none of","empty":"empty","not_empty":"not empty","filetype":"filetype","select_users_placeholder":"Select users","type_text_placeholder":"Type text","type_text_or_select_placeholder":"Type text or select","type_number_placeholder":"Type number","select_type_placeholder":"Select type","select_date_placeholder":"Select date","date":{"today":"Today","yesterday":"Yesterday","tomorrow":"Tomorrow","custom":"Custom"},"filetypes":{"images":"Images","documents":"Documents","media":"Media","other":"Other"},"warning":{"cells_merged":{"title":"Unable to filter table","text":"Can\'t filter column with merged cells"},"merge":{"title":"Cells cannot be merged","text":"Cells cannot be merged while table filter is active. Disable filter and try again."},"column_multitype":{"title":"Unable to filter table","text":"There is no such possibility to filter columns with Multi type. Please, try to convert to another type and try again."},"table_not_have_typed_columns":{"title":"Unable to filter table","text":"No columns available for filtering."}},"enable_filter":"Enable filter","disable_filter":"Disable filter"},"wrap_cells":{"layout_menu":"A capo automatico","warnings":{"merge":{"title":"Impossibile unire le celle","text":"Impossibile unire le celle in modalità non a capo"},"toggle":{"title":"Impossibile cambiare opzione","text":"La tabella contiene celle unite"}}},"duplicate_column":{"title":"Duplica colonna","text_1":"Duplica il contenuto della colonna","text_2":"Puoi duplicare l\'intera colonna contenente i dati o lasciare vuota la colonna duplicata","accept":"Duplica","copy":"copia"},"convert_column":{"title":"Cambia il tipo di colonna","text_before":"Questa colonna contiene valori. Cambiare il tipo di colonna cancellerà alcuni valori. Usa il comando","text_cmd":"annulla","text_after":"per annullare le modifiche se necessario.","accept":"Cambia tipo"},"merge_cells_with_comments":{"title":"Merging cells","text":"The cells will be merged from left to right and the new cell will show a comment from the left cell.","accept":"Merge"},"summary":{"layout_menu":"Mostra la barra di calcolo","name":{"none":"Nessuna","all":"Tutte","empty":"Vuote","fill":"Riempite","unique":"Uniche","empty_percent":"Percentuale vuote","fill_percent":"Percentuale riempite","unique_percent":"Percentuale uniche","sum":"Somma","average":"Media","min":"Min","max":"Max","median":"Mediana","min_date":"Prima data","max_date":"Ultima data","range_days":"Intervallo di date (giorni)","range_month":"Intervallo di date (mese)","checked":"Selezionate","unchecked":"Deselezionate","checked_percent":"Percentuale selezionate","unchecked_percent":"Percentuale deselezionate","filter_rating":"Con valutazione:","filter_progress":"Con progresso:","filesize_min":"Dimensione minima","filesize_max":"Dimensione massima"},"item":{"none":"Calcola","min_date":"Prima","max_date":"Ultima","range_days":"Intervallo (giorni)","range_month":"Intervallo (mese)","checked_percent":"Selezionate","unchecked_percent":"Deselezionate","filter_rating":"Con valutazione","filter_progress":"Con progresso"}},"comments":{"tooltip":{"one":"Comment","more":"Comments"}}},"file":{"image_viewer":{"could_not_load_image":"Impossibile caricare l\'immagine"},"download_file":"Scarica {{name}}","listen_file":"Play {{name}}","stop_file":"Stop {{name}}","uploading":"Caricamento in corso","wrtc":{"how_to_fix":"How to fix it?","how_to_url":"https://nimbusweb.me/s/share/5441210/4qccr41slk6wsw61h5fb","how_to_url2":"https://nimbusweb.me/s/share/5607239/l55bgak2ivs9bfptruka#b1995924032_670","rec_err_au":"Recording error. No microphone access.","rec_err_vi":"Recording error. No access to microphone/webcam. ","allow_micro":"Allow Access to microphone","allow_media":"Select the window you want to record","select_opt":"What will be recorded","screenonly":"Screen only","camonly":"Cam only","screencam":"Screen + Cam","enable_micro":"Enable microphone","startRecording":"Start recording","stopRecording":"Stop recording","pauseRecording":"Pause recording","resumeRecording":"Resume recording","cancelRecording":"Сancel recording","confirmCancel":"Are you sure you want to cancel the video recording?","cancel":"Сancel","prepareUpload":"Please wait, preparing to upload record","hasTmpRecord":"The recording was interrupted but not lost","restore":"Restore","delete":"Delete","recordOnAnotherDevice":"Recording is in progress on another device ..."},"menu":{"enabled":"Abilitato","disabled":"Disabilitato","open_in_new_tab":"Apri in una nuova scheda","copy_link":"Copia il collegamento al file","expand_in_full_window":"Espandi a finestra intera","autoplay":"Riproduzione automatica","sound_default":"Suono per impostazione predefinita","sound_loop":"Ciclo","sound_hideControls":"Nascondi controlli","sound_showPanel":"Show top panel","shadow_video":"Ombra per il video","video_params":"Parametri video","disallow_download":"Download in corso","for_note":"For workspaces users","for_share":"Public page","motion_video":"Motion video","preview_video":"Change preview","preview_video_btn":"Preview","print":"Stampa","convert_to_image":"Converti in immagine","convert_to_file":"Convert to file","style":"Stile","shadow_image":"Ombra per l\'immagine","rename":"Rinomina","replace":"Sostituisci","delete":"Elimina","download":"Scarica","get_text_from_image":"Ottieni testo dall\'immagine","view_as":"View as","single_page":"Single page","all_pages":"All pages","cta_motion_video_message":"CTA is enabled for videos. You cannot use CTA and Motion video at the same time. Disable CTA and try enabling Motion video again.","cta_loop_message":"CTA is enabled for videos. You cannot use CTA and Loop at the same time. Disable CTA and try enabling Loop again.","grid":"Grid","cta_drop_in_grid":"CTA is enabled for videos. We recommend checking the correctness of the CTA display after transferring the video into a grid column.","cta_exists_in_grid":"The grid column has a video with an active CTA. Please check if it is correct after the transfer."},"downloading":"Download in corso","attachment_not_found_error":"Errore durante il caricamento","pdf_viewer":{"initializing_full_window_view":"Inizializzazione della visualizzazione a finestra intera","preparing_document_for_printing":"Preparazione del documento per la stampa ...","printing_initialization":"Inizializzazione della stampa ...","abort":"abortire","set_page_as_default":"Set page as default","unset_page_as_default":"Default page. Click to make the page normal."},"video_just_uploaded_codec_error":"You are trying to upload a video that has been encoded with the {codec} codec. We do not guarantee the correct playback of this video on all browsers. We recommend converting the video to another format and uploading it again.","video_codec_error":"This video is encoded with {codec} codec, which is not supported in your browser.","safari_webm_not_support":"Currently, Safari browsers do not support WEBM format. Try to open the note in another browser, such as Google Chrome or Mozilla Firefox.","video_transcribe":"Transcribe","video_summary":"Summary","video_meeting_notes":"Meeting Notes","video_ask_ai":"Ask AI"},"image":{"text_from_image_popup":{"title":"Testo da immagine","no_text":"Non c\'è testo","copy":"Copia tutto il testo"},"unknown_error":"Il collegamento è errato","add_image":"Incolla il link dell\'immagine o ","add_image_or":"o","add_image_small":"Incolla o ","browse":"sfoglia","browse_image":"Sfoglia immagine","too_large_error":"La dimensione dell\'immagine è troppo grande","image_info_dialog":{"title":"Informazioni sull\'immagine","type":"Tipo","size":"Dimensione","location":"Posizione","copy_link":"Copia link"},"rotate_wait":{"full":"Attendere prego","medium":"Aspetta"},"attachment_not_found_error":"Si è verificato un errore imprevisto con l\'immagine","readonly_placeholder":"Immagine vuota","unsplash":{"name":"Unsplash","header":"Search image","placeholder":"Search for an image","search":"Search","description":"Search to find more results.","no_result":"No images found.","caption_preffix":"Photo by"},"comments":"Comments"},"attachment":{"unknown_error":"Qualcosa è andato storto, prova a scegliere un altro file","attachment_is_being_uploaded":"A file is being uploaded on another device...","attachment_will_be_downloaded_online":"Il file verrà scaricato quando sarai online.","attachment_preview_is_not_available":"L\'anteprima non è disponibile.","choose_a_file":"Scegliere i file","wait_resolving_without_info":"Please wait..."},"video":{"player":{"play":"Riproduci","pause":"Pausa","volume":"Volume","fullscreen_on":"A schermo intero","fullscreen_off":"Esci dalla modalità schermo intero","watch_again":"Watch again"}},"search":{"placeholder":"Trova nella nota","matches":"Risultati:"},"copy":{"copied":"Copiato!","copy_to_clipboard":"Copia negli appunti"},"apply":"Applica","done":"Fatto","block_menu":{"align":{"left":"Allinea a sinistra","center":"Allinea al centro","right":"Allinea a destra","justify":"Giustifica"},"indent":{"indent":"Aumenta il rientro","outdent":"Riduci il rientro"},"tooltip":"Trascina per spostare\\n<span>Fai clic per aprire il menu</span>","copy_tooltip":"Copy link","color":{"background_color":"Colore di sfondo","color":"Colore","line_color":"Colore della linea","line_type":"Tipo di linea","player_color":"Player\'s color"},"line_type":{"default":"Linea standard","dotted":"Punti"},"add":{"name":"Aggiungi blocco","above":"Sopra","below":"Sotto","left":"Sinistra","right":"Destra","above_column":"Above column","below_column":"Under column"},"convert_to":{"name":"Convertire in","to_do_list":"Checklist","number_list":"Elenco numerato","bullet_list":"Elenco puntato","paragraph":"Paragrafo","large_heading":"Intestazione grande","medium_heading":"Intestazione media","small_heading":"Intestazione piccola","large_heading_toggle":"Collapsible Large Heading","medium_heading_toggle":"Collapsible Medium Heading","small_heading_toggle":"Collapsible Small Heading","code":"Codice","quote":"Citazione","hint":"Hint","image":"Immagine","file":"File","remote_frame":"Incorporamento","link":"Link","bookmark":"Segnalibro","button":"Button","toggle":"Toggle Block","step":"Steps"},"comment_block":"Comment","edit":"Modifica","duplicate":"Duplica","copy_block":"Copy block","copy_blocks":"Copy blocks","copy_link":"Copia link","delete":"Elimina","replace":"Sostituisci","blot_lock":"Lock block","blot_unlock":"Unlock block","set_as_preview":"Imposta come anteprima","get_text_from_image":"Ottieni testo dall\'immagine","edit_image":"Edit image","download":"Scarica","view_full_size":"Visualizza a grandezza naturale","open_in_new_tab":"Apri in una nuova scheda","image_info":"Informazioni sull\'immagine","rotate_image":"Ruota","add_sub_task":"Aggiungi attività secondaria","add_sub_text":"Aggiungi sottotesto","layout":"Disposizione","embed_align":{"left":"Left align","center":"Center align","right":"Right align","default":"Default size","full_width":"Full width"},"expand_all":"Expand all","collapse_all":"Collapse all","add_caption":"Aggiungi didascalia","blot_locked_admin":"Editing of the block is denied. Click to unlock it.","blot_locked_admins":"Editing of the blocks is denied. Click to unlock it.","blot_locked_user":"You don’t have permission to edit this bock. Contact your organization admin.","show_header":"Show top bar","show_borders":"Show borders","rename":"Rinomina"},"convert_menu_groups":{"suggestions":"Suggestions","basic":"Basic","advanced":"Advanced","media":"Media","embed":"Embed","views":"Views","templates":"Templates","helpful_links":"Helpful links"},"embedded_menu":{"start_typing":"Type \\"/\\" or add","start_typing_full":"Start writing or type \\"/\\", \\"@\\"","more_items":"Altri elementi ...","add_an_element":"Aggiungi un elemento","paragraph":"Paragraph","todo":"Checklist","numbered_list":"Elenco numerato","bullet_list":"Elenco puntato","table":"Tabella","image":"Immagine","file":"File","audioRec":"Audio Record","videoRec":"Video Record","recordExist":"You cannot start a new recording until the previous one is completed. End or delete the previous record to start a new one.","large_heading":"Intestazione 1","medium_heading":"Intestazione 2","small_heading":"Intestazione 3","large_heading_toggle":"Collapsible Large Heading","medium_heading_toggle":"Collapsible Medium Heading","small_heading_toggle":"Collapsible Small Heading","section_break":"Interruzione di sezione","link":"Link","code":"Codice","quote":"Citazione","hint":"Hint","hint_placeholder":"Type something","mention":"Mention member","outline":"Scaletta","remote_frame":"Incorporamento","integrations":"Integrations","google_drive":"Google Drive","google_sheets":"Google sheets","html":"HTML","toggle":"Toggle block","tasks_list":"Task list","lock_blot":"Lock block","link_page":"Link page / Create","date":"Date","more_integrations":"more integrations","two_columns":"2 columns","meeting_notes":"Meeting notes","marketing_brief":"Marketing Brief","content_plan":"Content plan","more_templates":"more templates","get_feedback":"Get a feedback","contact_support":"Contact support","learn_nimbus":"Learn Nimbus","footer_top":"Did you know? You can start typing to search the list","footer_bottom":"Can’t find smth you want?","footer_link":"Tell us","add_note":"New page","database_with_options":"Database","board":"Kanban / Task Board","progress":"Progress","dropdown_list":"Dropdown list","uploader":"File uploader","use_ai":"Use Fusebase AI","helper":"AI helper","summarize":"Summarize","explain":"Explain","improve":"Improve","spelling":"Fix spelling and grammar","cta":"Call to actions","shorter":"Make shorter","longer":"Make longer","step":"Steps"},"button":{"title":"Title","id_info_tooltip":"This ID can be used in the future when editing the CSS file.","address":"URL or Email","open_in_new_tab":"Open in new tab","shape":"Button shape","background":"Background","size":"Button size","small":"Small","medium":"Medium","big":"Big","cancel":"Cancel","done":"Done","length_error":"The text is too large for the button. Try selecting less text (no more than 50 characters).","type":"Button type","default":"Default","withShadow":"Button with shadow","3d":"3d button","convert":{"popup_title":"Convert to button"}},"link":{"open":"Apri","send":"Invia","copy":"Copia","edit":"Modifica","remove":"Rimuovi","text_label":"Testo","url_label":"Link","email_label":"Indirizzo","copied":"Link copiato negli appunti","cancel":"Cancel","done":"Done"},"syntax":{"menu":{"language":"Lingua","theme":"Theme","wrap":"Abilita a capo","unwrap":"Disabilita a capo","lineNumbersOn":"Show line numbers","lineNumbersOff":"Hide line numbers"},"convert":{"popup_title":"Convert to code","blots_have_comments":"There are comments in the text that will be deleted during conversion.","text_has_inline_comments":"There are comments inside the text that will be deleted during conversion.","confirm":"Convert"}},"list":{"list_style":"Stile elenco","type_default":"Predefinito","type_rectangle":"Rettangolo","type_star":"Stella","type_dart":"Dardo","type_rounded":"Arrotondato","type_arrow":"Freccia","type_diamond":"Losanga"},"caption":{"placeholder":"Aggiungi didascalia"},"mention":{"show_all":"Mostra tutto","show_all_users":"Mostra tutti","placeholder":"Mostra recenti o digita per cercare","user":"Persone","workspace":"Spazi di lavoro","folder":"Cartelle","note":"Appunti","no_results":"Nessun risultato","offline_message":"La menzione funziona solo con connessione attiva. Accendi Internet e riprova.","info":{"note":{"one":"nota","some":"note","many":"note"},"subfolder":{"one":"sottocartella","some":"sottocartelle","many":"sottocartelle"},"member":{"one":"membro","some":"membri","many":"membri"},"owner":"proprietario","loading":"Caricamento anteprima ...","loading_failed":"Caricamento fallito","not_loaded":"Note has not been loaded yet"},"back_button":"Indietro","create_note_for":"Create Note","create_folder_for":"Create Folder"},"calendar":{"ui":{"date":"Data","am":"AM","pm":"PM","date_format":"Formato data","show_time":"Mostra orario","time_format":"Formato orario","time_12":"12 ore","time_24":"24 ore","first_week_day":"Primo giorno della settimana","time_zone":"Fuso orario","use_gmt":"Usa GMT per tutti i membri","use_gmt_hint":"Utilizza lo stesso fuso orario (GMT) per tutti i collaboratori","table":{"clear":"Cancella"},"inline":{"clear":"Elimina"},"reminder":{"name":"Avviso","panel_name":"Avviso","push_name":"Promemoria dell\'evento","remove_confirm_message":"You have alerts that are time-bound. Do you want to delete these reminders?","remove_confirm_text":"Delete","remove_cancel_text":"Don\'t delete reminders","before_period":"","after_period":"prima","period":{"m":{"one":"minuto","many":"minuti"},"h":{"one":"ora","many":"ore"},"d":{"one":"giorno","many":"giorni"},"w":{"one":"settimana","many":"settimane"}},"value":{"none":"Nessuno","0m":"All\'inizio","1m":"1 minuto prima","5m":"5 minuti prima","10m":"10 minuti prima","15m":"15 minuti prima","30m":"30 minuti prima","1h":"1 ora prima","2h":"2 ore prima","1d":"1 giorno prima","2d":"2 giorni prima","7d":"7 giorni prima","10d":"10 giorni prima","14d":"14 giorni prima","custom":"Personalizzato"},"until":{"in":"Tra","d":"g","h":"o","m":"min","already_been":"Già stato","less_minute":"Meno di un minuto","now":"Adesso"}},"postfix":{"day":"g","month":"m"}},"insert":{"category_name":"Data","custom":"Personalizzato","now":"Now","today":"Oggi","tomorrow":"Domani"},"date_format":{"ddmmyyyy":"gg/mm/aaaa","mmddyyyy":"mm/gg/aaaa","yyyyddmm":"aaaa/mm/gg","monthddyyyy":"Mese gg, aaaa","default":"Adatta al formato del browser"},"months":{"0":"Gennaio","1":"Febbraio","2":"Marzo","3":"Aprile","4":"Maggio","5":"Giugno","6":"Luglio","7":"Agosto","8":"Settembre","9":"Ottobre","10":"Novembre","11":"Dicembre"},"days":{"short":{"0":"Do","1":"Lu","2":"Ma","3":"Me","4":"Gi","5":"Ve","6":"Sa"},"full":{"0":"Domenica","1":"Lunedì","2":"Martedì","3":"Mercoledì","4":"Giovedì","5":"Venerdì","6":"Sabato"}}},"content_not_supported":"Questa nota non è supportata sulla tua versione dell\'app FuseBase. Prova ad aggiornarla o utilizza un altro client con l\'ultima versione.","profession_ask":{"title":"Risparmia tempo utilizzando i modelli per creare nuove note","text":"Inserisci la tua occupazione e il nostro team creerà dei modelli per te. È gratuito, senza costi nascosti","i_am_a":"Sono un","placeholder":"per esempio. designer, insegnante, agente di vendita, ecc.","request_template":"Richiedi modello","sucess_message":"Grazie! La tua occupazione verrà aggiunta alla nostra coda di attesa."},"bookmark":{"name":"Segnalibro","edit":"Modifica segnalibro","title":"Titolo","address":"Indirizzo","description":"Descrizione","placeholder":"Incolla o scrivi il link con https://...","placeholder_mobile":"Paste or write link","loading_preview":"Caricamento anteprima ...","block_menu":{"change_mode":{"menu_name":"Visualizza come","mode_tile":"Tessera","mode_card":"Cartolina","mode_cover":"Cover"},"change_preview":"Cambia anteprima","delete_preview":"Elimina anteprima","reset_preview":"Reimposta anteprima","change_preview_background":"Preview background","options":{"menu_name":"Options","open_in_same_tab":"Open in same tab"}},"error":{"unknown_error":"Qualcosa è andato storto, prova a inserire un altro URL","preview_notfound":"Anteprime non trovate"},"upload":{"new_preview":"Upload New","quota_error":"The file is larger than the 3MB allowed. Try another file.","unknown_error":"Unknown error. Try another file."}},"businessCard":{"PERSON":"Nome","ORGANIZATION":"Azienda","TITLE":"Titolo","ADDRESS":"Posizione","URL":"Sito","PHONE":"Telefono","EMAIL":"E-mail","SKYPE":"Skype","TWITTER":"Twitter","INSTAGRAM":"Instagram","FACEBOOK":"Facebook","LINKEDIN":"LinkedIn","VK":"Vk"},"dialog_common":{"button":{"ok":"Ok","cancel":"Annulla"}},"outline":{"default_name":"Scaletta","menu":{"expand":"Espandi","collapse":"Collassa","rename":"Rinomina"},"context_menu":{"convert_to":{"text":"Testo"},"style":{"name":"Stile scaletta","list_only":"Solo elenco","numbered_list":"Elenco numerato","bordered":"Mostra bordo","border_color":"Border color"}},"empty":"Aggiungi Intestazioni alla tua nota e appariranno come link qui"},"floating_toolbar":{"bold":"Grassetto","italic":"Corsivo","underline":"Sottolineato","strikethrough":"Barrato","clear":"Cancella Formattazione","code":"Codice","button":"Button","link":"Link","highlight":"Evidenzia","extraHighlight":"High contrast highlights","color":"Colore","text":"Testo","clear_all":"Clear all","placeholder":"Segnaposto","adapts":{"dark":"Adatta a un tema scuro","light":"Adatta a un tema chiaro"},"create_note":"Create note","add_comment":"Add comment"},"remote_frame":{"placeholder_small":"Incorpora URL","placeholder_full":"Incorpora qualsiasi URL, come YouTube, Github, Maps, Twitter, ecc.","loading":"Caricamento in corso...","context_menu":{"change_link":"Cambia link","full_size":"Dimensione originale","reset_size":"Reset size","open_origin":"Apri originale","layout":"Disposizione","show_toolbar":"Mostra barra di modifica","copy_original":"Copy link to original"},"error":{"is_not_link":"Il collegamento non è corretto","content_error":"Il seguente dominio non è supportato o l\'URL non è corretto. Contatta il <a href=\\"https://nimbusweb.me/contact-us.php\\" target=\\"_blank\\">nostro supporto</a> ed elaboreremo il tuo collegamento.","unknown_error":"Qualcosa è andato storto, prova a inserire un altro URL","wrong_signature":"Questo contenuto è danneggiato e non può essere visualizzato","google_docs_auth_error":"Molto probabilmente non puoi incorporare il Documento/Foglio/Presentazione Google perché non hai accesso ad esso.<a href=\\"http://nimb.ws/EkX87M\\" target=\\"_blank\\">Leggi la nostra guida.</a>","internal_link_error":"{{serviceName}} has forbidden following internal links. Click on Back to return to the previous page."},"convert_bookmark":"Converti in segnalibro","convert_link":"Converti in link","back_button":"Back"},"google_drive":{"block_name":"Google Drive","loading":"Caricamento in corso...","menu":{"expand":"Espandi","collapse":"Collassa","open_origin":"Apri in Google Drive","download":"Scarica","change_account":"Cambia account","choose_another_file":"Scegli un altro file"},"last_modified":"Ultima modifica di {{userName}} {{time}} fa","browse":"Sfoglia file","login":"Accedi con Google","login_text":"Sfoglia i file e aggiungi da Google Drive"},"html":{"default_name":"HTML","loading":"Caricamento in corso...","menu":{"open_source":"Collegamento open source","export_blot":"Save HTML"},"unknown_error":"Errore sconosciuto","device_cant_display_content":"Il tuo dispositivo non può visualizzare questo contenuto","wrong_signature":"Questo contenuto è danneggiato e non può essere visualizzato"},"relative_time":{"seconds":{"one":"{{count}} secondo","some":"{{count}} secondi","many":"{{count}} secondi"},"minutes":{"one":"{{count}} minuto","some":"{{count}} minuti","many":"{{count}} minuti"},"hours":{"one":"{{count}} ora","some":"{{count}} ore","many":"{{count}} ore"},"days":{"one":"{{count}} giorno","some":"{{count}} giorni","many":"{{count}} giorni"},"months":{"one":"{{count}} mese","some":"{{count}} mesi","many":"{{count}} mesi"},"years":{"one":"{{count}} anno","some":"{{count}} anni","many":"{{count}} anni"}},"collapsible_content":{"menu":{"expand":"Espandi","collapse":"Collassa","rename":"Rinomina"}},"convert_link":{"url":"URL","title":"Titolo","embed":"Incorpora","bookmark":"Segnalibro","button":"Button","link_to_note":"Link alla nota","link_to_folder":"Collegamento alla cartella","link_to_workspace":"Link to workspace","convert_error":"Si è verificato un errore durante la conversione dell\'URL"},"fullwidth":{"menu_item":"Larghezza intera"},"resizeable":{"point_tooltip":{"default":"Resize","bottom-right":"Resize\\n(press and hold the {{altKey}} button for free resize)"}},"toggle":{"placeholder":"Click here to create or move a block","expand":"Expand toggle","collapse":"Collapse toggle","expand_heading":"Expand heading","collapse_heading":"Collapse heading","expand_step":"Expand step","collapse_step":"Collapse step"},"step":{"content_placeholder":"Click here to create description to the step","title_placeholder":"Enter a short title to describe this step","aggregator_placeholder":"Enter a short descriptive title","menu":{"step_layout":{"name":"Layout","show_number":"Show number","show_arrow":"Show arrow","show_border":"Show border"}}},"tasks_list":{"not_supported":"Currently, we cannot display the task list as it is not supported in this type of pages.","menu":{"show_title":"Show task list name","view":"Default view","task_list_view":"Task list","calendar_view":"Calendar","kanban_view":"Kanban"}},"board":{"not_supported":"Currently, we cannot display the task board as it is not supported in this type of pages.","menu":{"add_new_column":"New column","board_layout":{"name":"Layout","show_add_new_column":"Show Add column"}}},"empty_features":{"use_template":"Use a template","import":"Import","add_database":"Add database","add_database_with_options":"Add database with options","add_board":"Kanban / Task Board","use_ai":"Use Fusebase AI"},"ai_manager":{"generate_error":"Unfortunately, there are no results for your request. Please try another request.","unload_message":"Fusebase AI content is being generated. Are you sure you want to exit?","unknown_error":"Unknown error. Try again later or contact support.","dialog":{"title":"Discard draft","body":"Do you want to discard draft?","accept":"Yes, discard"}},"uploader":{"header":"Upload files","description":"Here, you can add some helpful information about file uploading","dropzone_full":"Drag file(s) here or","browse":"click to upload","dropzone_compact":"Add more files","uploading_progress":"Uploading {{progress}}%","uploading_files":"Uploading files","counter":"{{current}} of {{total}}","timer":"less than 1 minute remaining","header_placeholder":"Write a title, max {{maxChars}} characters","description_placeholder":"Write a description, max {{maxChars}} characters","errors":{"network":"Failed uploading file","too_big":"File is too big"},"menu":{"disallow_download":"Downloading","for_note":"For workspaces users","for_share":"Public page","convert_to_files":"Convert to files","allow_upload":"Uploading","enable_in_public_page":"Enable in public page"}},"convert_menu_tooltips":{"labels":{"management":"Great for knowledge management","collaboration":"Great for collaboration"},"paragraph":{"title":"Best for main content","description":"This is the main block for writing page content."},"todo":{"title":"A List For Small Tasks? Check!","description":"Write down small errands and routine tasks that need to be done."},"numberedlist":{"title":"Let\'s Line Up: One, Two, Three!","description":"Make your content easy-to-read and display it in a series."},"bulletlist":{"title":"Points Make Everything Clearer","description":"You can create a list that will stand out from other content."},"table":{"title":"Rejoice the Formatting","description":"Organize your information in a table to get a holistic view on your work."},"image":{"title":"We Need To See It — Add An Image","description":"Make your pages more attractive by adding pictures of any file type, moving them and resizing."},"file":{"title":"Files Here, Files There, Files Everywhere!","description":"Create a database for your project by adding files with different types of extensions to your page."},"largeheading":{"title":"Best for Primary Sections of Page","description":"This is the biggest heading you can add. Attract attention to the most vital part of your page and ease up your navigation."},"mediumheading":{"title":"Best for Secondary Section of Page","description":"This is a middle-size heading you can add. Divide your page into sections with it and easily find what you need."},"smallheading":{"title":"Best For Great Ideas In Subsections","description":"This is a small-size heading you can add, but still it stands out. Use it to divide your page into subsections."},"tasks-list":{"title":"Organize Your Work With Nimbus Tasks","description":"Here you can group your tasks in task lists. Assign tasks to your team members, set deadlines and add statuses for easy tracking."},"hline":{"title":"Let\'s Make A Break","description":"Separate different parts of a project or divide your examples and ideas for it."},"link":{"title":"Pave A Path with Links","description":"Whenever you\'ve got an idea for your project, add a link to it and name it."},"syntax":{"title":"Don\'t Forget About Code","description":"You can add code right on your page, switching between themes, languages and more!"},"link-page":{"title":"Your Next Stop Is Another Page","description":"Link another page connected to this project and easily access it right away."},"date":{"title":"Just Say When","description":"Set a deadline for your project or mark the precise time when you started to work on a page."},"mention":{"title":"Get Your Team Involved","description":"Your team members will get email notifications to open a particular page and collaborate there."},"blockquote":{"title":"And I Quote","description":"You can highlight important words from your clients or single out a motivational phrase."},"hint":{"title":"Let\'s Drop A Hint","description":"Choose an emoji and background color to highlight warnings, disclaimers or notifications on your page."},"toggle":{"title":"Hide & Seek Expand Text Block","description":"Sort and hide additional information on your pages for easier navigation and access."},"outline":{"title":"See What Awaits You On The Page","description":"Create a table of contents for easy navigation on long pages or wikis."},"lock-blot":{"title":"No One Can Edit It","description":"You can leave a particular information block on your page untouched and read-only."},"embed":{"title":"Add More Than Just A Link","description":"You can integrate other tools on your page to keep them all in one place and automatically updated."},"figma":{"title":"Keep Your Visuals Even Closer","description":"Add Figma to see how project visuals are designed in real time."},"miro":{"title":"Your Miro Board Is In A Safe Space","description":"Check a layout strategy or a road map for your project and work further on your page."},"columns":{"title":"Two columns are better than one","description":"Divide your page in two columns to add more content there and make your page look neater."},"meeting-notes":{"title":"Set Goals And Move Forward","description":"Use this template to build a marketing strategy and keep all details in one place."},"marketing-brief":{"title":"Dream Big, Plan Quarter By Quarter","description":"Use this template to build a marketing plan by quarters."},"content-plan":{"title":"Control And Lead Your Work","description":"Use this template to take everything inside your head to a table where you can visualize all parts and manage tasks."},"integrations":{"title":"Add More Than Just A Link","description":"You can integrate other tools on your page to keep them all in one place and automatically updated."},"google-drive":{"title":"Drive Your Files From Google Drive","description":"You can connect your Google Drive account and insert links to your drive files for quick access."},"google-sheets":{"title":"Minus Google Sheet Tab","description":"Keep your data in one place with other project details to draw conclusions more easily."},"bookmark":{"title":"Mark Your Link With A New Look","description":"Use a bookmark to show the title of your link, a small description and a preview picture of the website."},"audioRec":{"title":"Say It, Don\'t Write it","description":"Add a human touch to your collaboration, recording voice feedback to the content on your page."},"videoRec":{"title":"Show it, Don\'t Write It","description":"Record a visual explanation of what should be done or give explicit feedback with a video example."},"button":{"title":"Came, Saw, Clicked","description":"Add a CTA element that will drag attention to important links on your pages."},"largeheading-toggle":{"title":"Hide More In A Large-Sized Collapsible Heading","description":"Define the most vital part of your page and hide information there for easy access."},"mediumheading-toggle":{"title":"Make Your Sections Shorter","description":"Create sections with a middle-sized collapsible heading and hide part of your content there."},"smallheading-toggle":{"title":"Make Your Subsections Shorter","description":"Create subsections with a small-sized collapsible heading on your pages and hide additional information there."},"database-with-options":{"title":"Oh How The Tables Have Turned","description":"Create a database for your project and customize it by selecting different types of columns and rows, changing background color and more."},"board":{"title":"Welcome Your Tasks On a Board","description":"Display tasks as cards on a Kanban board to get a bird’s eye view."},"progress":{"title":"See How Far You\'ve Come!","description":"Choose your value and estimate it. Rate and comment on your added content, tasks or other activities."},"uploader":{"title":"Say Goodbye to the File Mess!","description":"Clarify what files your clients and/or team need to send. With the file uploader, you can get what you want and keep it all in one place."},"dropdown-list":{"title":"Drop Your Options","description":"Place answer options anywhere in the text & let others give instant feedback."},"use-ai":{"title":"Work Smart, Not Hard","description":"Use AI to create and improve your content, get new ideas, and make personalized recommendations. Work with an AI assistant in your workspace."}},"feature_availability":{"plus":{"not-available":"Available for Plus & Team & Business plans","trial":"This is open as a trial Plus feature for you"},"team":{"not-available":"Available for Team & Business plans","trial":"This is open as a trial Team feature for you"},"business2023":{"not-available":"Available for Business plan","trial":"This is open as a trial Business feature for you"}}}');
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/i18n/messages/es.json
const es_namespaceObject = JSON.parse('{"table":{"common":{"column":"Columna"},"move_column_cant_split_merged_cells":{"title":"No se puede mover la columna","text":"No se puede mover la columna a una celda combinada. Primero divídela e inténtalo de nuevo."},"move_column_cant_move_part_of_merged_cells":{"title":"No se puede mover la columna","text":"La columna que estás intentando mover contiene parte de una celda combinada. Si quieres mover la columna, divide las celdas primero."},"move_column_failed":{"title":"No se puede mover la columna","text":"Ha ocurrido un error inesperado al mover una columna. Por favor, inténtalo de nuevo."},"move_row_cant_split_merged_cells":{"title":"No se puede mover la fila","text":"No se puede mover la fila a una celda combinada. Primero divídela e inténtalo de nuevo."},"move_row_cant_move_part_of_merged_cells":{"title":"No se puede mover la fila","text":"TLa fila que estás intentado mover contiene parte de una celda combinada. Si quieres mover la fila, divide las celdas primero."},"move_row_cant_move_in_sortable_table":{"title":"No se puede mover la fila","text":"No se pueden mover fila en una tabla ordenada. Borra los ajustes de ordenación primero e inténtalo de nuevo."},"move_row_cant_move_in_filtered_table":{"title":"Unable to move row","text":"Cannot move a row in a filtered table. Cancel filter then try again."},"move_row_failed":{"title":"No se puede mover la fila","text":"Ha ocurrido un error inesperado al mover una fila. Por favor, inténtalo de nuevo."},"first_move_column_or_row_message":"You can select multiple rows or columns by holding down the CTRL button and clicking on the desired rows or columns.","menu":{"delete":"Eliminar","help":"Ayuda","delete_column":{"one":"Eliminar columna","many":"Eliminar {{count}} columnas"},"delete_row":{"one":"Eliminar fila","many":"Eliminar {{count}} filas"},"add":"Añadir","add_row_before":{"one":"Fila arriba","many":"{{count}} filas arriba"},"add_row_after":{"one":"Fila debajo","many":"{{count}} Filas debajo"},"add_col_before":{"one":"Columna a la izquierda","many":"{{count}} columnas a la izquierda"},"add_col_after":{"one":"Columna a la derecha","many":"{{count}} columnas a la derecha"},"copy_cell":{"one":"Copiar celda","many":"Copiar celdas"},"copy_table":"Copiar tabla","table_layout":{"name":"Diseño de tablat","column_headings":"Encabezados de columnas","row_headings":"Encabezados de filas"},"import_csv":"Import from CSV","merge_cells":"Combinar celdas","insert_checkbox":"Insertar casilla de verificación","background_color":"Color de fondo","formatting":"Formato","clear":"Borrar","reset":"Restaurar","divide_cells":"Dividir celdas","type":{"name_cell":"Tipo de celda","name_cells":"Tipo de celdas","name_column":"Tipo de columna","name_columns":"Tipo de columnas","type_cell":{"one":"Tipo de celda","many":"Tipo de celdas"},"type_col":{"one":"Tipo de columna","many":"Tipo de columnas"},"same_as_column":"Igual que la columna","reset_cells":"Restaurar celdas a los ajustes por defecto","none":"Mútiple","text":"Texto","textline":"Texto","number":"Número","attachment":"Adjunto","checkbox":"Casilla de verificación","multiselect":"Selección múltiple","singleselect":"Selección única","collaborator":"Persona","currency":"Moneda","date":"Fecha","link":"Enlace","rating":"Valoración","progress":"Progreso","mention":"Mención"},"number_format":{"name":"Formato de número","number":"Número","commas":"Número con comas","percent":"Porcentaje"},"currency_format":{"name":"Tipo de moneda","dollar":"Dólar","euro":"Euro","yen":"Yen","yuan":"Yuan","rouble":"Rublo","pound":"Libra","rupee":"Rupia","hryvnia":"Grivna","won":"Won","frank":"Franco","real":"Real","other":"Otra","stick":"Mostrar símbolo","before":"Antes","after":"Después"},"decimal_format":{"name":"Decimal separator","comma":"Comma","point":"Point","hint":"The separator is used for decimal places. Comma decimal separators will look like 1.000,99, and point separators look like 1,000.99"},"progress_format":{"name":"Opciones de progreso","simple":"Simple","colored":"A color","start_from":"Empezar desde (0-100)","default_amount":"Cantidad por defecto (0-100)"},"rating_format":{"name":"Opciones de valoración","star":"Estrellas","flag":"Banderas","heart":"Corazones","amount":"Cantidad (1-10)"},"date_format":{"name":"Formato de fecha y hora"},"mention_panel":{"open":"Abrir","edit":"Editar","clear":"Borrar"},"color_numbers":{"name":"Color numbers","enable":"Enable color numbers"},"filter":"Filter","comment":"Comment"},"formatting_menu":{"align_left":"Izquierda","align_center":"Centrar","align_right":"Derecha","valign_top":"Arriba","valign_center":"Centro","valign_bottom":"Abajo","text":"Texto","text_align":"Alineación del texto","text_color":"Color del texto","bold":"Negrita","italic":"Cursiva","strikethrough":"Tachado","underline":"Subrayado"},"col_menu":{"add_column_after":{"one":"Añadir columna a la derecha","many":"Añadir {{count}} columnas a la derecha"},"add_column_before":{"one":"Añadir columna a la izquierda","many":"Añadir {{count}} columnas a la izquierda"},"duplicate_column":{"one":"Duplicar columna","many":"Duplicar columnas"},"rename":"Renombrar"},"row_menu":{"add_row_after":{"one":"Añadir fila debajo","many":"Añadir {{count}} filas debajo"},"add_row_before":{"one":"Añadir fila arriba","many":"Añadir {{count}} filas arriba"}},"warning":{"merge_different":"No se pueden combinar diferentes tipos de objetos","convert_merged":"No se pueden convertir las celdas combinadas"},"select":{"create_list":"Escribe para crear una lista","create_item":"Escribe para crear un elemento","create_option":"Escribe para crear una opción","create_label":"Escribe para crear una etiqueta","create":"Crear","delete":"Eliminar"},"attachment":{"upload_more":"Subir archivo(s)","downloading":"Descargando"},"collaborator":{"placeholder":"Escribe para añadir personas","no_result":"Sin resultados","loading":"Cargando...","unknown":"Persona desconocida"},"checkbox":{"checked":"Sí","not_checked":"No"},"sorting":{"name":"Ordenar","sort":"Ordenar","disable":"Eliminar orden","change":"Haz click para cambiar","asc":{"common":"Ascendente","text":"Ordenar de la A-Z","number":"Ordenar del 1-9","checkbox":"No seleccionados primero"},"desc":{"common":"Descendente","text":"Ordenar de la Z-A","number":"Ordenar del 9-1","checkbox":"Seleccionados primero"},"warning":{"column_merged":{"title":"No se pueden ordenar la columna","text":"No se puede ordenar columnas con celdas combinadas"},"table_rowspan":{"title":"No se puede ordenar la columna","text":"No se puede ordenar columnas con filas combinadas"},"merge":{"title":"Cells cannot be merged","text":"Cells cannot be merged while column sorting is active. Disable sorting and try again."},"different_currencies":{"title":"Advertencia de ordenación","text":"Estás utilizando diferentes monedas en una misma columna. El orden puede no aplicarse correctamente."}},"exit_dialog":{"title":"Eliminar orden","toggle":"Mantener ordenado","text_keep":"Mantener ordenado","text_no_keep":"El orden de la columna se restaurará a sus ajustes por defecto","apply":"Aplicar"}},"filter":{"by_field":"Filter by this field","empty_table":"All records are filtered","popup_title":"In this table, show records","empty_filters":"No conditions are applied to this database","where":"Where","or":"Or","and":"And","add_condition":"Add condition","clear_all":"Clear all","contains":"contains","is":"is","is_not":"is not","contains_not":"contains not","has_any_of":"has any of","has_none_of":"has none of","empty":"empty","not_empty":"not empty","filetype":"filetype","select_users_placeholder":"Select users","type_text_placeholder":"Type text","type_text_or_select_placeholder":"Type text or select","type_number_placeholder":"Type number","select_type_placeholder":"Select type","select_date_placeholder":"Select date","date":{"today":"Today","yesterday":"Yesterday","tomorrow":"Tomorrow","custom":"Custom"},"filetypes":{"images":"Images","documents":"Documents","media":"Media","other":"Other"},"warning":{"cells_merged":{"title":"Unable to filter table","text":"Can\'t filter column with merged cells"},"merge":{"title":"Cells cannot be merged","text":"Cells cannot be merged while table filter is active. Disable filter and try again."},"column_multitype":{"title":"Unable to filter table","text":"There is no such possibility to filter columns with Multi type. Please, try to convert to another type and try again."},"table_not_have_typed_columns":{"title":"Unable to filter table","text":"No columns available for filtering."}},"enable_filter":"Enable filter","disable_filter":"Disable filter"},"wrap_cells":{"layout_menu":"Ajustar celdas","warnings":{"merge":{"title":"No se pueden combinar las celdas","text":"No se puede combinar celdas que estén en el modo \\"no ajustar\\""},"toggle":{"title":"No se puede cambiar el ajuste","text":"La tabla contiene celdas combinadas"}}},"duplicate_column":{"title":"Duplicar columna","text_1":"Duplicar el contenido de la columna","text_2":"Puedes duplicar la columna al completo, incluyendo su contenido o duplicar la columna sin contenido","accept":"Duplicar","copy":"copiar"},"convert_column":{"title":"Cambiar el tipo de columna","text_before":"Esta columna contiene valores. Cambiar el tipo de columna eliminará alguno de esos valores. Usa","text_cmd":"deshacer","text_after":"para revertir los cambios si fuese necesario.","accept":"Cambiar tipo"},"merge_cells_with_comments":{"title":"Merging cells","text":"The cells will be merged from left to right and the new cell will show a comment from the left cell.","accept":"Merge"},"summary":{"layout_menu":"Mostrar barra de cálculos","name":{"none":"Nada","all":"Todo","empty":"Las vacías","fill":"Las que tienen datos","unique":"Las que son diferentes","empty_percent":"Sin porcentaje","fill_percent":"Con porcentaje","unique_percent":"Con porcentajes diferentes","sum":"Suma","average":"Media","min":"Mín.","max":"Máx.","median":"Mediana","min_date":"La fecha más antigua","max_date":"La fecha más reciente","range_days":"Rango de fechas (días)","range_month":"Rango de fechas (mes)","checked":"Marcadas","unchecked":"Sin marcar","checked_percent":"Porcentaje completado","unchecked_percent":"Porcentaje sin completar","filter_rating":"Con valoración:","filter_progress":"Con progreso:","filesize_min":"Tamaño mín.","filesize_max":"Tamaño máx."},"item":{"none":"Calcular","min_date":"La más antigua","max_date":"La más reciente","range_days":"Rango (días)","range_month":"Rango (mes)","checked_percent":"Marcadas","unchecked_percent":"Sin marcar","filter_rating":"Con valoración","filter_progress":"Con progreso"}},"comments":{"tooltip":{"one":"Comment","more":"Comments"}}},"file":{"image_viewer":{"could_not_load_image":"No se pudo cargar la imagen"},"download_file":"Descargar {{name}}","listen_file":"Play {{name}}","stop_file":"Stop {{name}}","uploading":"Subiendo","wrtc":{"how_to_fix":"How to fix it?","how_to_url":"https://nimbusweb.me/s/share/5441210/4qccr41slk6wsw61h5fb","how_to_url2":"https://nimbusweb.me/s/share/5607239/l55bgak2ivs9bfptruka#b1995924032_670","rec_err_au":"Recording error. No microphone access.","rec_err_vi":"Recording error. No access to microphone/webcam. ","allow_micro":"Allow Access to microphone","allow_media":"Select the window you want to record","select_opt":"What will be recorded","screenonly":"Screen only","camonly":"Cam only","screencam":"Screen + Cam","enable_micro":"Enable microphone","startRecording":"Start recording","stopRecording":"Stop recording","pauseRecording":"Pause recording","resumeRecording":"Resume recording","cancelRecording":"Сancel recording","confirmCancel":"Are you sure you want to cancel the video recording?","cancel":"Сancel","prepareUpload":"Please wait, preparing to upload record","hasTmpRecord":"The recording was interrupted but not lost","restore":"Restore","delete":"Delete","recordOnAnotherDevice":"Recording is in progress on another device ..."},"menu":{"enabled":"Enabled","disabled":"Disabled","open_in_new_tab":"Abrir en una pestaña nueva","copy_link":"Copiar enlace al archivo","expand_in_full_window":"Abrir en pantalla completa","autoplay":"Autoplay","sound_default":"Sound by default","sound_loop":"Loop","sound_hideControls":"Hide controls","sound_showPanel":"Show top panel","shadow_video":"Shadow for video","video_params":"Video settings","disallow_download":"Downloading","for_note":"For workspaces users","for_share":"Public page","motion_video":"Motion video","preview_video":"Change preview","preview_video_btn":"Preview","print":"Imprimir","convert_to_image":"Convertir en imagen","convert_to_file":"Convert to file","style":"Style","shadow_image":"Shadow for image","rename":"Renombrar","replace":"Reemplazar","delete":"Eliminar","download":"Descargar","get_text_from_image":"Extraer texto de imagen","view_as":"View as","single_page":"Single page","all_pages":"All pages","cta_motion_video_message":"CTA is enabled for videos. You cannot use CTA and Motion video at the same time. Disable CTA and try enabling Motion video again.","cta_loop_message":"CTA is enabled for videos. You cannot use CTA and Loop at the same time. Disable CTA and try enabling Loop again.","grid":"Grid","cta_drop_in_grid":"CTA is enabled for videos. We recommend checking the correctness of the CTA display after transferring the video into a grid column.","cta_exists_in_grid":"The grid column has a video with an active CTA. Please check if it is correct after the transfer."},"downloading":"Descargando","attachment_not_found_error":"Error al subir","pdf_viewer":{"initializing_full_window_view":"Iniciando la vista a pantalla completa","preparing_document_for_printing":"Preparando el documento para la impresión...","printing_initialization":"Iniciando la impresión...","abort":"abortar","set_page_as_default":"Set page as default","unset_page_as_default":"Default page. Click to make the page normal."},"video_just_uploaded_codec_error":"You are trying to upload a video that has been encoded with the {codec} codec. We do not guarantee the correct playback of this video on all browsers. We recommend converting the video to another format and uploading it again.","video_codec_error":"This video is encoded with {codec} codec, which is not supported in your browser.","safari_webm_not_support":"Currently, Safari browsers do not support WEBM format. Try to open the note in another browser, such as Google Chrome or Mozilla Firefox.","video_transcribe":"Transcribe","video_summary":"Summary","video_meeting_notes":"Meeting Notes","video_ask_ai":"Ask AI"},"image":{"text_from_image_popup":{"title":"Texto de imagen","no_text":"No hay texto","copy":"Copiar todo el texto"},"unknown_error":"El enlace no es correcto","add_image":"Pegar el enlace de la imagen o ","add_image_or":"o","add_image_small":"Pegar o ","browse":"explorar","browse_image":"Explorar imagen","too_large_error":"El tamaño de la imagen es demasiado grande","image_info_dialog":{"title":"Información de la imagen","type":"Tipo","size":"Tamaño","location":"Ubicación","copy_link":"Copiar enlace"},"rotate_wait":{"full":"Por favor, espera","medium":"Espera"},"attachment_not_found_error":"Ha ocurrido un error inesperado con la imagen","readonly_placeholder":"Imagen vacía","unsplash":{"name":"Unsplash","header":"Search image","placeholder":"Search for an image","search":"Search","description":"Search to find more results.","no_result":"No images found.","caption_preffix":"Photo by"},"comments":"Comments"},"attachment":{"unknown_error":"Algo ha ido mal. Prueba eligiendo otro archivo","attachment_is_being_uploaded":"A file is being uploaded on another device...","attachment_will_be_downloaded_online":"El archivo se descargará cuando estés conectado.","attachment_preview_is_not_available":"La vista previa no está disponible.","choose_a_file":"Elegir archivos","wait_resolving_without_info":"Please wait..."},"video":{"player":{"play":"Reproducir","pause":"Pausar","volume":"Volumen","fullscreen_on":"Pantalla completa","fullscreen_off":"Salir de pantalla completa","watch_again":"Watch again"}},"search":{"placeholder":"Buscar en la nota","matches":"Coincidencias:"},"copy":{"copied":"¡Copiado!","copy_to_clipboard":"Copiar al portapapeles"},"apply":"Aplicar","done":"Hecho","block_menu":{"align":{"left":"Alinear a la izquierda","center":"Centrar","right":"Alinear a la derecha","justify":"Justificar"},"indent":{"indent":"Aumentar sangría","outdent":"Reducir sangría"},"tooltip":"Arrastra para mover\\n<span>Haz click para abrir el menú</span>","copy_tooltip":"Copy link","color":{"background_color":"Color de fondo","color":"Color","line_color":"Color de la línea","line_type":"Tipo de línea","player_color":"Player\'s color"},"line_type":{"default":"Línea estándar","dotted":"Puntos"},"add":{"name":"Añadir bloque","above":"Arriba","below":"Abajo","left":"A la izquierda","right":"A la derecha","above_column":"Above column","below_column":"Under column"},"convert_to":{"name":"Convertir en","to_do_list":"Checklist","number_list":"Lista numerada","bullet_list":"Lista con viñetas","paragraph":"Párrafo","large_heading":"Título grande","medium_heading":"Título mediano","small_heading":"Título pequeño","large_heading_toggle":"Collapsible Large Heading","medium_heading_toggle":"Collapsible Medium Heading","small_heading_toggle":"Collapsible Small Heading","code":"Código","quote":"Cita","hint":"Hint","image":"Imagen","file":"Archivo","remote_frame":"Insertar","link":"Enlace","bookmark":"Marcador","button":"Button","toggle":"Toggle Block","step":"Steps"},"comment_block":"Comment","edit":"Editar","duplicate":"Duplicar","copy_block":"Copy block","copy_blocks":"Copy blocks","copy_link":"Copiar enlace","delete":"Eliminar","replace":"Reemplazar","blot_lock":"Lock block","blot_unlock":"Unlock block","set_as_preview":"Establecer como miniatura","get_text_from_image":"Extraer texto de imagen","edit_image":"Edit image","download":"Descargar","view_full_size":"Ver a tamaño completo","open_in_new_tab":"Abrir en una pestaña nueva","image_info":"Información de la imagen","rotate_image":"Rotar","add_sub_task":"Añadir subtarea","add_sub_text":"Añadir subtexto","layout":"Layout","embed_align":{"left":"Left align","center":"Center align","right":"Right align","default":"Default size","full_width":"Full width"},"expand_all":"Expand all","collapse_all":"Collapse all","add_caption":"Añadir pie","blot_locked_admin":"Editing of the block is denied. Click to unlock it.","blot_locked_admins":"Editing of the blocks is denied. Click to unlock it.","blot_locked_user":"You don’t have permission to edit this bock. Contact your organization admin.","show_header":"Show top bar","show_borders":"Show borders","rename":"Renombrar"},"convert_menu_groups":{"suggestions":"Suggestions","basic":"Basic","advanced":"Advanced","media":"Media","embed":"Embed","views":"Views","templates":"Templates","helpful_links":"Helpful links"},"embedded_menu":{"start_typing":"Type \\"/\\" or add","start_typing_full":"Start writing or type \\"/\\", \\"@\\"","more_items":"Más elementos...","add_an_element":"Añadir un elemento","paragraph":"Paragraph","todo":"Checklist","numbered_list":"Lista numerada","bullet_list":"Lista con viñetas","table":"Tabla","image":"Imagen","file":"Archivo","audioRec":"Audio Record","videoRec":"Video Record","recordExist":"You cannot start a new recording until the previous one is completed. End or delete the previous record to start a new one.","large_heading":"Título 1","medium_heading":"Título 2","small_heading":"Título 3","large_heading_toggle":"Collapsible Large Heading","medium_heading_toggle":"Collapsible Medium Heading","small_heading_toggle":"Collapsible Small Heading","section_break":"Separador","link":"Enlace","code":"Código","quote":"Cita","hint":"Hint","hint_placeholder":"Type something","mention":"Mention member","outline":"Tabla de contenido","remote_frame":"Insertar","integrations":"Integrations","google_drive":"Google Drive","google_sheets":"Google sheets","html":"HTML","toggle":"Toggle block","tasks_list":"Task list","lock_blot":"Lock block","link_page":"Link page / Create","date":"Date","more_integrations":"more integrations","two_columns":"2 columns","meeting_notes":"Meeting notes","marketing_brief":"Marketing Brief","content_plan":"Content plan","more_templates":"more templates","get_feedback":"Get a feedback","contact_support":"Contact support","learn_nimbus":"Learn Nimbus","footer_top":"Did you know? You can start typing to search the list","footer_bottom":"Can’t find smth you want?","footer_link":"Tell us","add_note":"New page","database_with_options":"Database","board":"Kanban / Task Board","progress":"Progress","dropdown_list":"Dropdown list","uploader":"File uploader","use_ai":"Use Fusebase AI","helper":"AI helper","summarize":"Summarize","explain":"Explain","improve":"Improve","spelling":"Fix spelling and grammar","cta":"Call to actions","shorter":"Make shorter","longer":"Make longer","step":"Steps"},"button":{"title":"Title","id_info_tooltip":"This ID can be used in the future when editing the CSS file.","address":"URL or Email","open_in_new_tab":"Open in new tab","shape":"Button shape","background":"Background","size":"Button size","small":"Small","medium":"Medium","big":"Big","cancel":"Cancel","done":"Done","length_error":"The text is too large for the button. Try selecting less text (no more than 50 characters).","type":"Button type","default":"Default","withShadow":"Button with shadow","3d":"3d button","convert":{"popup_title":"Convert to button"}},"link":{"open":"Abrir","send":"Enviar","copy":"Copiar","edit":"Editar","remove":"Eliminar","text_label":"Texto","url_label":"Enlace","email_label":"Correo electrónico","copied":"Enlace copiado al portapapeles","cancel":"Cancel","done":"Done"},"syntax":{"menu":{"language":"Idioma","theme":"Theme","wrap":"Activar ajustar","unwrap":"Desactivar ajustar","lineNumbersOn":"Show line numbers","lineNumbersOff":"Hide line numbers"},"convert":{"popup_title":"Convert to code","blots_have_comments":"There are comments in the text that will be deleted during conversion.","text_has_inline_comments":"There are comments inside the text that will be deleted during conversion.","confirm":"Convert"}},"list":{"list_style":"Estilo de lista","type_default":"Por defecto","type_rectangle":"Rectángulos","type_star":"Estrellas","type_dart":"Dardos","type_rounded":"Círculos","type_arrow":"Flechas","type_diamond":"Diamantes"},"caption":{"placeholder":"Añadir pie"},"mention":{"show_all":"Mostrar todo","show_all_users":"Mostrar todo","placeholder":"Mostrando los recientes o escribe para buscar","user":"Personas","workspace":"Espacios de trabajo","folder":"Carpetas","note":"Notas","no_results":"Sin resultados","offline_message":"Las menciones solo funcionan con una conexión a internet activa. Conéctate a internet e inténtalo de nuevo.","info":{"note":{"one":"nota","some":"notas","many":"notas"},"subfolder":{"one":"subcarpeta","some":"subcarpetas","many":"subcarpetas"},"member":{"one":"miembro","some":"miembros","many":"miembros"},"owner":"propietario","loading":"Cargando previsualización...","loading_failed":"La carga ha fallado","not_loaded":"Note has not been loaded yet"},"back_button":"Volver","create_note_for":"Create Note","create_folder_for":"Create Folder"},"calendar":{"ui":{"date":"Fecha","am":"AM","pm":"PM","date_format":"Formato de fecha","show_time":"Mostrar hora","time_format":"Formato de hora","time_12":"12H","time_24":"24H","first_week_day":"Primer día de la semana","time_zone":"Zona horaria","use_gmt":"Usar GMT para todos los miembros","use_gmt_hint":"Usa la misma zona horaria (GMT) para todos los colaboradores","table":{"clear":"Borrar"},"inline":{"clear":"Eliminar"},"reminder":{"name":"Alerta","panel_name":"Alerta","push_name":"Recordatorio del evento","remove_confirm_message":"You have alerts that are time-bound. Do you want to delete these reminders?","remove_confirm_text":"Delete","remove_cancel_text":"Don\'t delete reminders","before_period":"","after_period":"antes","period":{"m":{"one":"minuto","many":"minutos"},"h":{"one":"hora","many":"horas"},"d":{"one":"día","many":"días"},"w":{"one":"semana","many":"semanas"}},"value":{"none":"Ninguno","0m":"A la hora de inicio","1m":"1 minuto antes","5m":"5 minutos antes","10m":"10 minutos antes","15m":"15 minutos antes","30m":"30 minutos antes","1h":"1 hora antes","2h":"2 horas antes","1d":"1 día antes","2d":"2 días antes","7d":"7 días antes","10d":"10 días antes","14d":"14 días antes","custom":"Personalizado"},"until":{"in":"En","d":"d","h":"h","m":"min","already_been":"Ya ha sido","less_minute":"Menos de un minuto","now":"Ahora"}},"postfix":{"day":"d","month":"m"}},"insert":{"category_name":"Fecha","custom":"Personalizado","now":"Now","today":"Hoy","tomorrow":"Mañana"},"date_format":{"ddmmyyyy":"dd/mm/aaaa","mmddyyyy":"mm/dd/aaaa","yyyyddmm":"aaaa/mm/dd","monthddyyyy":"Mes dd, aaaa","default":"Coincidir con el formato del navegador"},"months":{"0":"Enero","1":"Febrero","2":"Marzo","3":"Abril","4":"Mayo","5":"Junio","6":"Julio","7":"Agosto","8":"Septiembre","9":"Octubre","10":"Noviembre","11":"Diciembre"},"days":{"short":{"0":"Do","1":"Lu","2":"Ma","3":"Mi","4":"Ju","5":"Vi","6":"Sá"},"full":{"0":"Domingo","1":"Lunes","2":"Martes","3":"Miércoles","4":"Jueves","5":"Viernes","6":"Sábado"}}},"content_not_supported":"Esta nota no es compatible con la versión de tu aplicación FuseBase. Prueba actualizándola o usa otro cliente con la última versión.","profession_ask":{"title":"Ahorra tiempo usando plantillas para crear notas nuevas","text":"Escribe tu ocupación y nuestro equipo creará plantillas para ti. Es totalmente gratis, sin ningún tipo de coste","i_am_a":"Soy","placeholder":"por ejemplo, diseñador, profesores, agente de ventas, etc.","request_template":"Solicitar plantilla","sucess_message":"¡Gracias! Tu solicitud se añadirá a la cola."},"bookmark":{"name":"Marcador","edit":"Editar marcador","title":"Título","address":"Dirección","description":"Descripción","placeholder":"Pega o escribe el enlace con https://...","placeholder_mobile":"Paste or write link","loading_preview":"Cargando previsualización…","block_menu":{"change_mode":{"menu_name":"Ver como","mode_tile":"Mosaico","mode_card":"Tarjeta","mode_cover":"Cover"},"change_preview":"Cambiar miniatura","delete_preview":"Eliminar miniatura","reset_preview":"Restaurar miniatura","change_preview_background":"Preview background","options":{"menu_name":"Options","open_in_same_tab":"Open in same tab"}},"error":{"unknown_error":"Algo ha ido mal. Prueba introduciendo otra URL","preview_notfound":"No se han encontrado miniaturas"},"upload":{"new_preview":"Upload New","quota_error":"The file is larger than the 3MB allowed. Try another file.","unknown_error":"Unknown error. Try another file."}},"businessCard":{"PERSON":"Nombre","ORGANIZATION":"Empresa","TITLE":"Título","ADDRESS":"Posición","URL":"Sitio web","PHONE":"Teléfono","EMAIL":"Correo electrónico","SKYPE":"Skype","TWITTER":"Twitter","INSTAGRAM":"Instagram","FACEBOOK":"Facebook","LINKEDIN":"LinkedIn","VK":"Vk"},"dialog_common":{"button":{"ok":"Aceptar","cancel":"Cancelar"}},"outline":{"default_name":"Tabla de contenido","menu":{"expand":"Expandir","collapse":"Contraer","rename":"Renombrar"},"context_menu":{"convert_to":{"text":"Texto"},"style":{"name":"Estilo de la tabla de contenido","list_only":"Solo lista","numbered_list":"Lista numerada","bordered":"Mostrar borde","border_color":"Border color"}},"empty":"Añade títulos a tu nota y aparecerán aquí automáticamente como enlaces"},"floating_toolbar":{"bold":"Negrita","italic":"Cursiva","underline":"Subrayado","strikethrough":"Tachado","clear":"Limpiar formato","code":"Código","button":"Button","link":"Enlace","highlight":"Resaltar","extraHighlight":"High contrast highlights","color":"Color","text":"Texto","clear_all":"Clear all","placeholder":"Marcador","adapts":{"dark":"Se adapta al modo oscuro","light":"Se adapta al modo claro"},"create_note":"Create note","add_comment":"Add comment"},"remote_frame":{"placeholder_small":"Insertar URL","placeholder_full":"Inserta cualquier URL como YouTube, Github, Maps, Twitter, etc.","loading":"Cargando...","context_menu":{"change_link":"Cambiar enlace","full_size":"Tamaño completo","reset_size":"Reset size","open_origin":"Abrir original","layout":"Diseño","show_toolbar":"Mostrar barra de edición","copy_original":"Copy link to original"},"error":{"is_not_link":"El enlace no es correcto","content_error":"El dominio no se soporta o la URL no es correcta. Por favor, escribe a nuestro <a href=\\"https://nimbusweb.me/contact-us.php\\" target=\\"_blank\\">equipo de soporte</a> y nosotros procesaremos tu enlace.","unknown_error":"Algo ha ido mal. Intenta insertar otra URL","wrong_signature":"Este contenido está corrupto o no se puede mostrar","google_docs_auth_error":"Probablemente no puedas insertar documentos, presentaciones u hojas de cálculo de Google porque no tienes acceso a ellos. <a href=\\"http://nimb.ws/EkX87M\\" target=\\"_blank\\">Por favor, lee nuestra guía.</a>","internal_link_error":"{{serviceName}} has forbidden following internal links. Click on Back to return to the previous page."},"convert_bookmark":"Convertir en marcador","convert_link":"Convertir en enlace","back_button":"Back"},"google_drive":{"block_name":"Google Drive","loading":"Cargando...","menu":{"expand":"Expandir","collapse":"Contraer","open_origin":"Abrir en Google Drive","download":"Descargar","change_account":"Cambiar cuenta","choose_another_file":"Elegir otro archivo"},"last_modified":"Modificado por última vez por {{userName}}, hace {{time}}","browse":"Seleccionar archivo","login":"Iniciar sesión con Google","login_text":"Selecciona archivos y añádelos desde Google Drive"},"html":{"default_name":"HTML","loading":"Cargando...","menu":{"open_source":"Abrir origen del enlace","export_blot":"Save HTML"},"unknown_error":"Error desconocido","device_cant_display_content":"Tu dispositivo no puede mostrar este contenido","wrong_signature":"Este contenido está corrupto y no puede mostrarse"},"relative_time":{"seconds":{"one":"{{count}} segundo","some":"{{count}} segundos","many":"{{count}} segundos"},"minutes":{"one":"{{count}} minuto","some":"{{count}} minutos","many":"{{count}} minutos"},"hours":{"one":"{{count}} hora","some":"{{count}} horas","many":"{{count}} horas"},"days":{"one":"{{count}} día","some":"{{count}} días","many":"{{count}} días"},"months":{"one":"{{count}} mes","some":"{{count}} meses","many":"{{count}} meses"},"years":{"one":"{{count}} año","some":"{{count}} años","many":"{{count}} años"}},"collapsible_content":{"menu":{"expand":"Expandir","collapse":"Contraer","rename":"Renombrar"}},"convert_link":{"url":"URL","title":"Título","embed":"Insertar","bookmark":"Marcador","button":"Button","link_to_note":"Enlace a nota","link_to_folder":"Enlace a carpeta","link_to_workspace":"Link to workspace","convert_error":"Ha ocurrido un error al convertir la URL"},"fullwidth":{"menu_item":"Ancho completo"},"resizeable":{"point_tooltip":{"default":"Resize","bottom-right":"Resize\\n(press and hold the {{altKey}} button for free resize)"}},"toggle":{"placeholder":"Click here to create or move a block","expand":"Expand toggle","collapse":"Collapse toggle","expand_heading":"Expand heading","collapse_heading":"Collapse heading","expand_step":"Expand step","collapse_step":"Collapse step"},"step":{"content_placeholder":"Click here to create description to the step","title_placeholder":"Enter a short title to describe this step","aggregator_placeholder":"Enter a short descriptive title","menu":{"step_layout":{"name":"Layout","show_number":"Show number","show_arrow":"Show arrow","show_border":"Show border"}}},"tasks_list":{"not_supported":"Currently, we cannot display the task list as it is not supported in this type of pages.","menu":{"show_title":"Show task list name","view":"Default view","task_list_view":"Task list","calendar_view":"Calendar","kanban_view":"Kanban"}},"board":{"not_supported":"Currently, we cannot display the task board as it is not supported in this type of pages.","menu":{"add_new_column":"New column","board_layout":{"name":"Layout","show_add_new_column":"Show Add column"}}},"empty_features":{"use_template":"Use a template","import":"Import","add_database":"Add database","add_database_with_options":"Add database with options","add_board":"Kanban / Task Board","use_ai":"Use Fusebase AI"},"ai_manager":{"generate_error":"Unfortunately, there are no results for your request. Please try another request.","unload_message":"Fusebase AI content is being generated. Are you sure you want to exit?","unknown_error":"Unknown error. Try again later or contact support.","dialog":{"title":"Discard draft","body":"Do you want to discard draft?","accept":"Yes, discard"}},"uploader":{"header":"Upload files","description":"Here, you can add some helpful information about file uploading","dropzone_full":"Drag file(s) here or","browse":"click to upload","dropzone_compact":"Add more files","uploading_progress":"Uploading {{progress}}%","uploading_files":"Uploading files","counter":"{{current}} of {{total}}","timer":"less than 1 minute remaining","header_placeholder":"Write a title, max {{maxChars}} characters","description_placeholder":"Write a description, max {{maxChars}} characters","errors":{"network":"Failed uploading file","too_big":"File is too big"},"menu":{"disallow_download":"Downloading","for_note":"For workspaces users","for_share":"Public page","convert_to_files":"Convert to files","allow_upload":"Uploading","enable_in_public_page":"Enable in public page"}},"convert_menu_tooltips":{"labels":{"management":"Great for knowledge management","collaboration":"Great for collaboration"},"paragraph":{"title":"Best for main content","description":"This is the main block for writing page content."},"todo":{"title":"A List For Small Tasks? Check!","description":"Write down small errands and routine tasks that need to be done."},"numberedlist":{"title":"Let\'s Line Up: One, Two, Three!","description":"Make your content easy-to-read and display it in a series."},"bulletlist":{"title":"Points Make Everything Clearer","description":"You can create a list that will stand out from other content."},"table":{"title":"Rejoice the Formatting","description":"Organize your information in a table to get a holistic view on your work."},"image":{"title":"We Need To See It — Add An Image","description":"Make your pages more attractive by adding pictures of any file type, moving them and resizing."},"file":{"title":"Files Here, Files There, Files Everywhere!","description":"Create a database for your project by adding files with different types of extensions to your page."},"largeheading":{"title":"Best for Primary Sections of Page","description":"This is the biggest heading you can add. Attract attention to the most vital part of your page and ease up your navigation."},"mediumheading":{"title":"Best for Secondary Section of Page","description":"This is a middle-size heading you can add. Divide your page into sections with it and easily find what you need."},"smallheading":{"title":"Best For Great Ideas In Subsections","description":"This is a small-size heading you can add, but still it stands out. Use it to divide your page into subsections."},"tasks-list":{"title":"Organize Your Work With Nimbus Tasks","description":"Here you can group your tasks in task lists. Assign tasks to your team members, set deadlines and add statuses for easy tracking."},"hline":{"title":"Let\'s Make A Break","description":"Separate different parts of a project or divide your examples and ideas for it."},"link":{"title":"Pave A Path with Links","description":"Whenever you\'ve got an idea for your project, add a link to it and name it."},"syntax":{"title":"Don\'t Forget About Code","description":"You can add code right on your page, switching between themes, languages and more!"},"link-page":{"title":"Your Next Stop Is Another Page","description":"Link another page connected to this project and easily access it right away."},"date":{"title":"Just Say When","description":"Set a deadline for your project or mark the precise time when you started to work on a page."},"mention":{"title":"Get Your Team Involved","description":"Your team members will get email notifications to open a particular page and collaborate there."},"blockquote":{"title":"And I Quote","description":"You can highlight important words from your clients or single out a motivational phrase."},"hint":{"title":"Let\'s Drop A Hint","description":"Choose an emoji and background color to highlight warnings, disclaimers or notifications on your page."},"toggle":{"title":"Hide & Seek Expand Text Block","description":"Sort and hide additional information on your pages for easier navigation and access."},"outline":{"title":"See What Awaits You On The Page","description":"Create a table of contents for easy navigation on long pages or wikis."},"lock-blot":{"title":"No One Can Edit It","description":"You can leave a particular information block on your page untouched and read-only."},"embed":{"title":"Add More Than Just A Link","description":"You can integrate other tools on your page to keep them all in one place and automatically updated."},"figma":{"title":"Keep Your Visuals Even Closer","description":"Add Figma to see how project visuals are designed in real time."},"miro":{"title":"Your Miro Board Is In A Safe Space","description":"Check a layout strategy or a road map for your project and work further on your page."},"columns":{"title":"Two columns are better than one","description":"Divide your page in two columns to add more content there and make your page look neater."},"meeting-notes":{"title":"Set Goals And Move Forward","description":"Use this template to build a marketing strategy and keep all details in one place."},"marketing-brief":{"title":"Dream Big, Plan Quarter By Quarter","description":"Use this template to build a marketing plan by quarters."},"content-plan":{"title":"Control And Lead Your Work","description":"Use this template to take everything inside your head to a table where you can visualize all parts and manage tasks."},"integrations":{"title":"Add More Than Just A Link","description":"You can integrate other tools on your page to keep them all in one place and automatically updated."},"google-drive":{"title":"Drive Your Files From Google Drive","description":"You can connect your Google Drive account and insert links to your drive files for quick access."},"google-sheets":{"title":"Minus Google Sheet Tab","description":"Keep your data in one place with other project details to draw conclusions more easily."},"bookmark":{"title":"Mark Your Link With A New Look","description":"Use a bookmark to show the title of your link, a small description and a preview picture of the website."},"audioRec":{"title":"Say It, Don\'t Write it","description":"Add a human touch to your collaboration, recording voice feedback to the content on your page."},"videoRec":{"title":"Show it, Don\'t Write It","description":"Record a visual explanation of what should be done or give explicit feedback with a video example."},"button":{"title":"Came, Saw, Clicked","description":"Add a CTA element that will drag attention to important links on your pages."},"largeheading-toggle":{"title":"Hide More In A Large-Sized Collapsible Heading","description":"Define the most vital part of your page and hide information there for easy access."},"mediumheading-toggle":{"title":"Make Your Sections Shorter","description":"Create sections with a middle-sized collapsible heading and hide part of your content there."},"smallheading-toggle":{"title":"Make Your Subsections Shorter","description":"Create subsections with a small-sized collapsible heading on your pages and hide additional information there."},"database-with-options":{"title":"Oh How The Tables Have Turned","description":"Create a database for your project and customize it by selecting different types of columns and rows, changing background color and more."},"board":{"title":"Welcome Your Tasks On a Board","description":"Display tasks as cards on a Kanban board to get a bird’s eye view."},"progress":{"title":"See How Far You\'ve Come!","description":"Choose your value and estimate it. Rate and comment on your added content, tasks or other activities."},"uploader":{"title":"Say Goodbye to the File Mess!","description":"Clarify what files your clients and/or team need to send. With the file uploader, you can get what you want and keep it all in one place."},"dropdown-list":{"title":"Drop Your Options","description":"Place answer options anywhere in the text & let others give instant feedback."},"use-ai":{"title":"Work Smart, Not Hard","description":"Use AI to create and improve your content, get new ideas, and make personalized recommendations. Work with an AI assistant in your workspace."}},"feature_availability":{"plus":{"not-available":"Available for Plus & Team & Business plans","trial":"This is open as a trial Plus feature for you"},"team":{"not-available":"Available for Team & Business plans","trial":"This is open as a trial Team feature for you"},"business2023":{"not-available":"Available for Business plan","trial":"This is open as a trial Business feature for you"}}}');
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/i18n/messages/tr.json
const tr_namespaceObject = JSON.parse('{"table":{"common":{"column":"Sütun"},"move_column_cant_split_merged_cells":{"title":"Sütun taşınamıyor.","text":"Sütunlar Birleştirilmiş bir hücre içine taşınamaz. Birleştirmeyi iptal edip tekrar deneyiniz."},"move_column_cant_move_part_of_merged_cells":{"title":"Sütun taşınamıyor.","text":"Sütun birleştirilmiş bir hücrenin parçasını içermekte. Sütun\'u taşımak için hücreden ayırın."},"move_column_failed":{"title":"Sütun taşınamıyor.","text":"Sütun taşınırken beklenmeyen bir hata oluştu. Lütfen tekrar deneyiniz."},"move_row_cant_split_merged_cells":{"title":"Satır Taşınamıyor!","text":"Satırlar Birleştirilmiş bir hücre içine taşınamaz. Birleştirmeyi iptal edip tekrar deneyiniz."},"move_row_cant_move_part_of_merged_cells":{"title":"Satır Taşınamıyor!","text":"Satırlar birleştirilmiş bir hücrenin parçasını içermekte. Satırı taşımak için hücreden ayırın."},"move_row_cant_move_in_sortable_table":{"title":"Satır Taşınamıyor!","text":"Sıralanabilir bir tablodaki satır taşınamaz. Sıralamayı İptal Edip Tekrar Deneyiniz"},"move_row_cant_move_in_filtered_table":{"title":"Unable to move row","text":"Cannot move a row in a filtered table. Cancel filter then try again."},"move_row_failed":{"title":"Satır Taşınamıyor!","text":"Satır taşınırken beklenmeyen bir hata oluştu. Lütfen tekrar deneyiniz."},"first_move_column_or_row_message":"You can select multiple rows or columns by holding down the CTRL button and clicking on the desired rows or columns.","menu":{"delete":"Sil","help":"Yardım","delete_column":{"one":"Sütunu Sil","many":"{{count}} Sütunu Sil"},"delete_row":{"one":"Satırı Sil","many":"{{count}} Satırı Sil"},"add":"Ekle","add_row_before":{"one":"Yukarı Satır","many":"{{count}} Yukarı Satır"},"add_row_after":{"one":"Aşağı Satır","many":"{{count}} Aşağı Satır"},"add_col_before":{"one":"Sol Sutun","many":"{{count}} Sol Sütun"},"add_col_after":{"one":"Sağ Sütun","many":"{{count}} Sağ Sütun"},"copy_cell":{"one":"Hücreyi Kopyala","many":"Hücreleri Kopyala"},"copy_table":"Tabloyu Kopyala","table_layout":{"name":"Tablo Düzeni","column_headings":"Sütun Başlıkları","row_headings":"Satır Başlıkları"},"import_csv":"Import from CSV","merge_cells":"Hücreleri Birleştir","insert_checkbox":"Onay Kutusu Ekle","background_color":"Arkaplan Rengi","formatting":"Biçimlendir","clear":"Açık","reset":"Sıfırla","divide_cells":"Birleştirilmiş Hücreleri Ayır","type":{"name_cell":"Hücre Tipi","name_cells":"Hücrelerin Tipi","name_column":"Sütun Tipi","name_columns":"Sütunların Tipi","type_cell":{"one":"Hücre Tipi","many":"Hücrelerin Tipi"},"type_col":{"one":"Sutun Tipi","many":"Sutunların Tipi"},"same_as_column":"Sütunlar Aynı","reset_cells":"Hücreleri Varsayılana Döndür","none":"Çoklu Tip","text":"Metin","textline":"Metin","number":"Numara","attachment":"Ek Dosya","checkbox":"Onay Kutusu","multiselect":"Çoklu Seçim","singleselect":"Tek Seçim","collaborator":"Ortak Alan","currency":"Para Birimi","date":"Tarih","link":"Link","rating":"Değerlendirme","progress":"İlerleme","mention":"Bahsetme"},"number_format":{"name":"Sayı Formatları","number":"Sayılar","commas":"Virgül İçeren Sayılar","percent":"Yüzde"},"currency_format":{"name":"Para Tipleri","dollar":"Dollar","euro":"Euro","yen":"Yen","yuan":"Yuan","rouble":"Rouble","pound":"Pound","rupee":"Rupee","hryvnia":"Hryvnia","won":"Won","frank":"Frank","real":"Gerçek","other":"Diğer","stick":"Sembol göster","before":"Önce","after":"Sonra"},"decimal_format":{"name":"Decimal separator","comma":"Comma","point":"Point","hint":"The separator is used for decimal places. Comma decimal separators will look like 1.000,99, and point separators look like 1,000.99"},"progress_format":{"name":"İlerleme Seçenekleri","simple":"Basit","colored":"Renk","start_from":"Şuradan Başla(0-100)","default_amount":"Varsayılan Miktar (0-100)"},"rating_format":{"name":"Değerlendirme Seçenekleri","star":"Yıldız","flag":"Bayrak","heart":"Kalp","amount":"Tutar (1-10)"},"date_format":{"name":"Tarih / Saat Biçimi"},"mention_panel":{"open":"Aç","edit":"Düzenle","clear":"Temizle"},"color_numbers":{"name":"Color numbers","enable":"Enable color numbers"},"filter":"Filter","comment":"Yorum"},"formatting_menu":{"align_left":"Sol","align_center":"Orta","align_right":"Alt","valign_top":"Üst","valign_center":"Orta","valign_bottom":"Alt","text":"Metin","text_align":"Metni Hizala","text_color":"Metin Rengi","bold":"Kalın","italic":"İtalik","strikethrough":"Üstü Çizili","underline":"Altı Çizili"},"col_menu":{"add_column_after":{"one":"Sağa sütun ekle","many":"Sağa {{count}} Sütun Ekle"},"add_column_before":{"one":"Sola sütun ekle","many":"Sola {{count}} Sütun Ekle"},"duplicate_column":{"one":"Sutunu Kopyala","many":"Sutunları Kopyala"},"rename":"Adını Değiştir"},"row_menu":{"add_row_after":{"one":"Aşağı satır ekle","many":"Aşağıya {{count}} satır ekle"},"add_row_before":{"one":"Yukarıya satır ekle","many":"Yukarıya {{count}} satır ekle"}},"warning":{"merge_different":"Farklı nesne türleri birleştirilemez","convert_merged":"Birleştirilmiş hücreler dönüştürülemiyor"},"select":{"create_list":"Liste oluşturmak için tıkla","create_item":"Bir öğe oluştur","create_option":"Bir seçenek oluştur","create_label":"Etiket oluşturmak için yazın","create":"Oluştur","delete":"Sil"},"attachment":{"upload_more":"Dosya(lar) yükleniyor","downloading":"Yükleniyor"},"collaborator":{"placeholder":"kişi eklemek için tıkla","no_result":"Sonuç yok","loading":"Yükleniyor...","unknown":"bilinmeyen kişi"},"checkbox":{"checked":"Evet","not_checked":"Hayır"},"sorting":{"name":"Sıralama","sort":"Sırala","disable":"Sıralamayı sil","change":"Değiştirmek için tıkla","asc":{"common":"Artan","text":"Sırala A-Z","number":"Sırala 1-9","checkbox":"Önce seçilmemiş"},"desc":{"common":"Azalan","text":"Sırala Z-A","number":"Sırala 9-1","checkbox":"Önce seçilmiş"},"warning":{"column_merged":{"title":"Sütunu sıralayamıyor","text":"Birleştirilmiş satırlara sahip tablo sıralanamıyor"},"table_rowspan":{"title":"Sütunu sıralayamıyor","text":"Birleştirilmiş satırlara sahip tablo sıralanamıyor"},"merge":{"title":"Cells cannot be merged","text":"Cells cannot be merged while column sorting is active. Disable sorting and try again."},"different_currencies":{"title":"Sıralama uyarısı","text":"Bir sütunda farklı para birimleri kullanıyorsunuz. Sıralama yanlış olabilir."}},"exit_dialog":{"title":"Sıralamayı kaldır","toggle":"Sıralamayı bırak","text_keep":"Sıralama kalsın","text_no_keep":"Sütun sırası, sıralama uygulanmadan önce baştaki sırasına geri yüklenecektir","apply":"Uygula"}},"filter":{"by_field":"Filter by this field","empty_table":"All records are filtered","popup_title":"In this table, show records","empty_filters":"No conditions are applied to this database","where":"Where","or":"Or","and":"And","add_condition":"Add condition","clear_all":"Clear all","contains":"contains","is":"is","is_not":"is not","contains_not":"contains not","has_any_of":"has any of","has_none_of":"has none of","empty":"empty","not_empty":"not empty","filetype":"filetype","select_users_placeholder":"Select users","type_text_placeholder":"Type text","type_text_or_select_placeholder":"Type text or select","type_number_placeholder":"Type number","select_type_placeholder":"Select type","select_date_placeholder":"Select date","date":{"today":"Today","yesterday":"Yesterday","tomorrow":"Tomorrow","custom":"Custom"},"filetypes":{"images":"Images","documents":"Documents","media":"Media","other":"Other"},"warning":{"cells_merged":{"title":"Unable to filter table","text":"Can\'t filter column with merged cells"},"merge":{"title":"Cells cannot be merged","text":"Cells cannot be merged while table filter is active. Disable filter and try again."},"column_multitype":{"title":"Unable to filter table","text":"There is no such possibility to filter columns with Multi type. Please, try to convert to another type and try again."},"table_not_have_typed_columns":{"title":"Unable to filter table","text":"No columns available for filtering."}},"enable_filter":"Enable filter","disable_filter":"Disable filter"},"wrap_cells":{"layout_menu":"Hücreleri birleştir","warnings":{"merge":{"title":"Satırları birleştiremiyor","text":"Nowrap modunda hücreler birleştirilemiyor"},"toggle":{"title":"Seçenek değiştirilemiyor","text":"Tablo birleştirilmiş hücreler içeriyor"}}},"duplicate_column":{"title":"Sütunu çoğalt","text_1":"Sütunun içeriğini çoğalt","text_2":"Veri içeren sütunun tamamını çoğaltabilir veya çoğaltılan sütunu boş bırakabilirsiniz","accept":"Çoğalt","copy":"Kopyala"},"convert_column":{"title":"Sütün türünü diğiştir","text_before":"Bu sütun değerler içerir. Sütun türünü değiştirmek bazı değerleri silecektir","text_cmd":"Geri al","text_after":"Gerekirse değişiklikleri geri alma emrini verebilirsiniz","accept":"Türü değiştir"},"merge_cells_with_comments":{"title":"Merging cells","text":"The cells will be merged from left to right and the new cell will show a comment from the left cell.","accept":"Merge"},"summary":{"layout_menu":"Hesaplama çubuğunu göster","name":{"none":"Hiçbiri","all":"Tümü","empty":"Boşalt","fill":"Dolu","unique":"Benzersiz","empty_percent":"Boş yüzde","fill_percent":"Yüzde doldur","unique_percent":"Benzersiz yüzde","sum":"Toplam","average":"Ortalama","min":"Minimum","max":"Maksimum","median":"Orta değer","min_date":"En erken tarih","max_date":"En geç tarih","range_days":"Tarih Aralığı (gün)","range_month":"Tarih aralıgı (ay)","checked":"Kontrol edilmiş","unchecked":"Kontrol edilmemiş","checked_percent":"İşaretlenmiş yüzde","unchecked_percent":"İşaretlenmemiş yüzde","filter_rating":"Derecelendirme ile:","filter_progress":"İlerleme ile:","filesize_min":"Minimum hacim","filesize_max":"Maksimum hacim"},"item":{"none":"Hesapla","min_date":"En erken","max_date":"En geç","range_days":"Aralık (gün)","range_month":"Mesafe (ay)","checked_percent":"Kontrol edildi","unchecked_percent":"Kontrol edilmedi","filter_rating":"Aralıkta","filter_progress":"Gelişmekte"}},"comments":{"tooltip":{"one":"Comment","more":"Comments"}}},"file":{"image_viewer":{"could_not_load_image":"Fotoğraf yüklenemiyor"},"download_file":"Yükle {{isim}}","listen_file":"Oynat {{name}}","stop_file":"Durdur {{name}}","uploading":"Yükleniyor","wrtc":{"how_to_fix":"Nasıl düzeltilir?","how_to_url":"https://nimbusweb.me/s/share/5441210/4qccr41slk6wsw61h5fb","how_to_url2":"https://nimbusweb.me/s/share/5607239/l55bgak2ivs9bfptruka#b1995924032_670","rec_err_au":"Kayıt hatası. Mikrofon erişimi yok.","rec_err_vi":"Kayıt hatası. Mikrofona/web kamerasına erişim yok. ","allow_micro":"Mikrofona Erişim İzni Ver","allow_media":"Kaydetmek istediğiniz pencereyi seçin","select_opt":"Ne kaydedilecek","screenonly":"Yalnızca ekran","camonly":"Yalnızca kamera","screencam":"Ekran + Kamera","enable_micro":"Mikrofonu etkinleştir","startRecording":"Kaydı başlat","stopRecording":"Kaydı durdur","pauseRecording":"Kaydı duraklat","resumeRecording":"Kaydı devam ettir","cancelRecording":"Kaydı iptal et","confirmCancel":"Video kaydını iptal etmek istediğinizden emin misiniz?","cancel":"İptal","prepareUpload":"Lütfen bekleyin, kayıt yüklemeye hazırlanıyor","hasTmpRecord":"Kayıt kesintiye uğradı ancak kaybolmadı","restore":"Geri yükle","delete":"Sil","recordOnAnotherDevice":"Başka bir cihazda kayıt yapılıyor ..."},"menu":{"enabled":"Etkin","disabled":"Devre dışı","open_in_new_tab":"Yeni sekmede aç","copy_link":"Linki dosyaya kopyala","expand_in_full_window":"Tüm ekrenda göster","autoplay":"Otomatik oynat","sound_default":"Varsayılan olarak ses","sound_loop":"Döngü","sound_hideControls":"Kontrolleri gizle","sound_showPanel":"Show top panel","shadow_video":"Video için gölge","video_params":"Video ayarları","disallow_download":"İndiriliyor","for_note":"Çalışma alanları kullanıcıları için","for_share":"Herkese açık sayfa","motion_video":"Hareketli video","preview_video":"Change preview","preview_video_btn":"Preview","print":"Yazdır","convert_to_image":"Fotoğrafa dönüştür","convert_to_file":"Convert to file","style":"Stil","shadow_image":"Resim için gölge","rename":"Yeniden adlandır","replace":"Yerine koy","delete":"Sil","download":"Yükle","get_text_from_image":"Fotoğraftan yazı çıkar","view_as":"Farklı görüntüle","single_page":"Tek sayfa","all_pages":"Tüm sayfalar","cta_motion_video_message":"CTA is enabled for videos. You cannot use CTA and Motion video at the same time. Disable CTA and try enabling Motion video again.","cta_loop_message":"CTA is enabled for videos. You cannot use CTA and Loop at the same time. Disable CTA and try enabling Loop again.","grid":"Grid","cta_drop_in_grid":"CTA is enabled for videos. We recommend checking the correctness of the CTA display after transferring the video into a grid column.","cta_exists_in_grid":"The grid column has a video with an active CTA. Please check if it is correct after the transfer."},"downloading":"yükleniyor","attachment_not_found_error":"Yüklenirken bir hata oluştu","pdf_viewer":{"initializing_full_window_view":"Tam Pencere görünümünü başlatma","preparing_document_for_printing":"Dosya yazdırılımak için hazırlanıyor...","printing_initialization":"Baskı başlatma...","abort":"iptal et","set_page_as_default":"Sayfayı varsayılan olarak ayarla","unset_page_as_default":"Varsayılan sayfa. Sayfayı normal yapmak için tıklayın."},"video_just_uploaded_codec_error":"{codec} codec bileşeniyle kodlanmış bir video yüklemeye çalışıyorsunuz. Bu videonun tüm tarayıcılarda doğru oynatılacağını garanti etmiyoruz. Videoyu başka bir biçime dönüştürmenizi ve yeniden yüklemenizi öneririz.","video_codec_error":"Bu video, tarayıcınızda desteklenmeyen {codec} codec bileşeniyle kodlanmıştır.","safari_webm_not_support":"Şu anda Safari tarayıcıları WEBM biçimini desteklememektedir. Notu Google Chrome veya Mozilla Firefox gibi başka bir tarayıcıda açmayı deneyin.","video_transcribe":"Transcribe","video_summary":"Summary","video_meeting_notes":"Meeting Notes","video_ask_ai":"Ask AI"},"image":{"text_from_image_popup":{"title":"Fotoğraftan yazı","no_text":"Yazı yok","copy":"Tüm metni kopyala"},"unknown_error":"Hatalı link","add_image":"Fotoğraf linkini yapıştır ya da ","add_image_or":"ya da","add_image_small":"Yapıştır ya da ","browse":"Göz at","browse_image":"Resme göz atın","too_large_error":"Görüntü boyutu çok büyük","image_info_dialog":{"title":"Resim bilgisi","type":"Tür","size":"Hacim","location":"Konum","copy_link":"Link kopyala"},"rotate_wait":{"full":"Lütfen bekleyin","medium":"Bekleyin"},"attachment_not_found_error":"Görüntüde beklenmeyen bir hata oluştu","readonly_placeholder":"Boş fotoğraf","unsplash":{"name":"Unsplash","header":"Search image","placeholder":"Search for an image","search":"Search","description":"Search to find more results.","no_result":"No images found.","caption_preffix":"Photo by"},"comments":"Comments"},"attachment":{"unknown_error":"Yanlış giden bir şey var, başka dosya seçmeyi dene","attachment_is_being_uploaded":"dosya yüleniyor...","attachment_will_be_downloaded_online":"Çeivirimiçi olduğunda bu dosya yüklenecek.","attachment_preview_is_not_available":"Önizleme mevcut değil.","choose_a_file":"Dosyaları seç","wait_resolving_without_info":"Please wait..."},"video":{"player":{"play":"Oynat","pause":"Durdur","volume":"Ses","fullscreen_on":"Tam ekren","fullscreen_off":"Tam ekrenden çık","watch_again":"Tekrar izle"}},"search":{"placeholder":"Notta bul","matches":"Eşleşmeler:"},"copy":{"copied":"Kopyalandı!","copy_to_clipboard":"Panoya kopyala"},"apply":"Uygula","done":"Tamam","block_menu":{"align":{"left":"Sola hizala","center":"Ortaya hizala","right":"Sağa hizala","justify":"Doğrula"},"indent":{"indent":"Girintiyi artır","outdent":"Girintiyi azalt"},"tooltip":"Taşımak için sürükleyin\\n<span>Menude açmak için tıkla</span>","copy_tooltip":"Linki kopyala","color":{"background_color":"Arkaplan rengi","color":"Renk","line_color":"Satır rengi","line_type":"Satır türü","player_color":"Oyuncunun rengi"},"line_type":{"default":"Standart Satır","dotted":"Nokta"},"add":{"name":"Engel ekle","above":"Üst","below":"Alt","left":"Sol","right":"Sağ","above_column":"Above column","below_column":"Under column"},"convert_to":{"name":"\'ya dönüştür","to_do_list":"Checklist","number_list":"Numara listesi","bullet_list":"Bullet List","paragraph":"Paragraf","large_heading":"Büyük Başlık","medium_heading":"Orta Başlık","small_heading":"Küçük başlık","large_heading_toggle":"Collapsible Large Heading","medium_heading_toggle":"Collapsible Medium Heading","small_heading_toggle":"Collapsible Small Heading","code":"Kod","quote":"Alıntı","hint":"İpucu","image":"Fotoğraf","file":"Dosya","remote_frame":"Yerleştir","link":"Link","bookmark":"Yer imi","button":"Buton","toggle":"Geçiş Bloğu","step":"Steps"},"comment_block":"Yorum","edit":"Düzenle","duplicate":"Çiftle","copy_block":"Bloğu kopyala","copy_blocks":"Blokları kopyala","copy_link":"Linki kopyala","delete":"Sil","replace":"Yerine yerleştir","blot_lock":"Bloğu kilitle","blot_unlock":"Blok kilidini aç","set_as_preview":"Önizleme olarak ayarla","get_text_from_image":"Fotoğraftan yazıyı çıkar","edit_image":"Fotoğrafı düzenle","download":"İndir","view_full_size":"Tam boyutu gör","open_in_new_tab":"Yeni sekmede aç","image_info":"Fotoğraf bilgileri","rotate_image":"Dönüştür","add_sub_task":"Alt görev ekle","add_sub_text":"Alt metin ekle","layout":"Düzen","embed_align":{"left":"Sola hizala","center":"Ortaya hizala","right":"Sağa hizala","default":"Varsayılan boyut","full_width":"Tam genişlik"},"expand_all":"Tümünü genişlet","collapse_all":"Tümünü daralt","add_caption":"Alt yazı ekle","blot_locked_admin":"Bloğun düzenlenmesi reddedildi. Kilidi açmak için tıklayın.","blot_locked_admins":"Blokların düzenlenmesi reddedildi. Kilidi açmak için tıklayın.","blot_locked_user":"Bu bloğu düzenleme izniniz yok. Kuruluş yöneticinizle iletişime geçin.","show_header":"Üst çubuğu göster","show_borders":"Kenarlıkları göster","rename":"Yeniden adlandır"},"convert_menu_groups":{"suggestions":"Suggestions","basic":"Basic","advanced":"Advanced","media":"Media","embed":"Embed","views":"Views","templates":"Templates","helpful_links":"Helpful links"},"embedded_menu":{"start_typing":"\\"/\\" yaz yada ekle","start_typing_full":"Start writing or type \\"/\\", \\"@\\"","more_items":"Daha fazla öğe...","add_an_element":"Öğe ekle","paragraph":"Paragraf","todo":"Checklist","numbered_list":"Numara listesi","bullet_list":"Madde listesi","table":"Ta,ü","image":"fotoğraf","file":"Dosya","audioRec":"Ses Kaydı","videoRec":"Video Kaydı","recordExist":"Bir önceki kayıt tamamlanana kadar yeni bir kayıt başlatamazsınız. Yeni bir kayıt başlatmak için önceki kaydı sonlandırın veya silin.","large_heading":"Büyük Başlık","medium_heading":"Orta Başlık","small_heading":"Küçük başlık","large_heading_toggle":"Collapsible Large Heading","medium_heading_toggle":"Collapsible Medium Heading","small_heading_toggle":"Collapsible Small Heading","section_break":"Bölüm ayırıcı","link":"Link","code":"Kod","quote":"Alıntı","hint":"İpucu","hint_placeholder":"Birşeyler yaz","mention":"Mention member","outline":"Anahat","remote_frame":"Yerleştir","integrations":"Integrations","google_drive":"Google Drive","google_sheets":"Google sheets","html":"HTML","toggle":"Aç/Kapat Bloğu","tasks_list":"Task list","lock_blot":"Lock block","link_page":"Link page / Create","date":"Date","more_integrations":"more integrations","two_columns":"2 columns","meeting_notes":"Meeting notes","marketing_brief":"Marketing Brief","content_plan":"Content plan","more_templates":"more templates","get_feedback":"Get a feedback","contact_support":"Contact support","learn_nimbus":"Learn Nimbus","footer_top":"Did you know? You can start typing to search the list","footer_bottom":"Can’t find smth you want?","footer_link":"Tell us","add_note":"New page","database_with_options":"Database","board":"Kanban / Task Board","progress":"Progress","dropdown_list":"Dropdown list","uploader":"File uploader","use_ai":"Use Fusebase AI","helper":"AI helper","summarize":"Summarize","explain":"Explain","improve":"Improve","spelling":"Fix spelling and grammar","cta":"Call to actions","shorter":"Make shorter","longer":"Make longer","step":"Steps"},"button":{"title":"Başlık","id_info_tooltip":"Bu kimlik gelecekte CSS dosyasını düzenlerken kullanılabilir.","address":"URL yada E-posta","open_in_new_tab":"Yeni sekmede aç","shape":"Buton şekli","background":"Arkaplan","size":"Buton boyutu","small":"Küçük","medium":"Orta","big":"Büyük","cancel":"İptal et","done":"Tamamlandı","length_error":"Metin, düğme için çok büyük. Daha az metin seçmeyi deneyin (en fazla 50 karakter).","type":"Buton tipi","default":"Varsayılan","withShadow":"Gölgeli Buton","3d":"3d buton","convert":{"popup_title":"Butona dönüştür"}},"link":{"open":"Aç","send":"Gönder","copy":"Kopyala","edit":"Değiştir","remove":"Kaldır","text_label":"Metin","url_label":"Link","email_label":"Adres","copied":"Link panoya kopyalandı","cancel":"İptal et","done":"Tamamlandı"},"syntax":{"menu":{"language":"Dil","theme":"Theme","wrap":"Sarmayı etkinleştir","unwrap":"Sarmayı iptal et","lineNumbersOn":"Satır numaralarını göster","lineNumbersOff":"Satır numaralarını gizle"},"convert":{"popup_title":"Koda Dönüştür","blots_have_comments":"Metin içerisinde dönüştürme sırasında silinecek yorumlar var.","text_has_inline_comments":"Metnin içerisinde dönüştürme sırasında silinecek yorumlar var.","confirm":"Dönüştür"}},"list":{"list_style":"Liste stili","type_default":"Varsayılan","type_rectangle":"Dikdörtgen","type_star":"Başlat","type_dart":"Dart","type_rounded":"Yuvarlak","type_arrow":"Ok","type_diamond":"Elmas"},"caption":{"placeholder":"Altyazı ekle"},"mention":{"show_all":"Tümünü göster","show_all_users":"Tümünü göster","placeholder":"En son oluşturulanlar gösteriliyor yada aramak için birşeyler yazın","user":"Kişiler","workspace":"Çalışma alanı","folder":"Klasörler","note":"Nolar","no_results":"Sonuç yok","offline_message":"Bahsetme yalnızca aktif bağlantı ile çalışır. İnterneti açın ve tekrar deneyin.","info":{"note":{"one":"not","some":"not","many":"not"},"subfolder":{"one":"Alt dosya","some":"Alt dosya","many":"Alt dosya"},"member":{"one":"Üye","some":"Üye","many":"Üye"},"owner":"sahip","loading":"Önizleme yükleniyor...","loading_failed":"Yükleme başarısız oldu","not_loaded":"Not henüz yüklenmedi"},"back_button":"Geri dön","create_note_for":"Not Oluştur:","create_folder_for":"Klasör oluştur:"},"calendar":{"ui":{"date":"Tarih","am":"sabah","pm":"öğleden sonra","date_format":"Tarih formatı","show_time":"Zamanı göster","time_format":"Zaman formatı","time_12":"12S","time_24":"24S","first_week_day":"Haftanın ilk günü","time_zone":"Saat dilimi","use_gmt":"Bütün üyeler için GMT kullan","use_gmt_hint":"Tüm ortak çalışanlar için aynı saat dilimini (GMT) kullanın","table":{"clear":"Temizle"},"inline":{"clear":"Temizle"},"reminder":{"name":"Uyarı","panel_name":"Uyarı","push_name":"Olay için hatırlatıcı","remove_confirm_message":"Zamana bağlı uyarılarınız var. Bu hatırlatıcıları silmek istiyor musunuz?","remove_confirm_text":"Sil","remove_cancel_text":"Hatırlatıcıları silme","before_period":"","after_period":"Önce","period":{"m":{"one":"dakika","many":"dakika"},"h":{"one":"saat","many":"saat"},"d":{"one":"gün","many":"gün"},"w":{"one":"hafta","many":"hafta"}},"value":{"none":"Hiçbiri","0m":"Başlangıçta","1m":"1 dakika önce","5m":"5 dakika önce","10m":"10 dakika önce","15m":"15 dakika önce","30m":"30 dakika önc","1h":"1 saat öcce","2h":"2 saat öcce","1d":"1 gün önce","2d":"2 gün önce","7d":"7 gün önce","10d":"10 gün önce","14d":"14 gün önce","custom":"Özel"},"until":{"in":"--","d":"g","h":"s","m":"dk","already_been":"oldu","less_minute":"Bir dakikadan az","now":"Şimdi"}},"postfix":{"day":"g","month":"a"}},"insert":{"category_name":"Tarih","custom":"Özel","now":"Şimdi","today":"Bugün","tomorrow":"Yarın"},"date_format":{"ddmmyyyy":"gg/aa/yyyy","mmddyyyy":"aa/gg/yyyy","yyyyddmm":"yyyy/aa/gg","monthddyyyy":"Ay gg, yyyy","default":"Tarayıcı formatını eşleştir"},"months":{"0":"Ocak","1":"Şubat","2":"Mart","3":"Nisan","4":"Mayıs","5":"Haziran","6":"Temmuz","7":"Ağustos","8":"Eylül","9":"Ekim","10":"Kasım","11":"Aralık"},"days":{"short":{"0":"Pa","1":"Pt","2":"Sa","3":"Ça","4":"Pe","5":"Cu","6":"Ct"},"full":{"0":"Pazar","1":"Pazartesi","2":"Salı","3":"Çarşamba","4":"Perşembe","5":"Cuma","6":"Cumartesi"}}},"content_not_supported":"FuseBase uygulaması sürümünüzde desteklenmiyor. Güncellemeyi deneyin veya en son sürüme sahip başka bir istemci kullanın.","profession_ask":{"title":"Yeni notlar oluşturmak için şablonları kullanarak zaman kazanın","text":"Mesleğinizi yazın, ekibimiz sizin için şablonlar oluştursun. Ücretsizdir ve hiçbir gizli ücreti yoktur","i_am_a":"Ben bir:","placeholder":"Ör. tasarımcı, öğretmen, satış temsilcisi vb.","request_template":"Şablon iste","sucess_message":"Teşekkürler! Mesleğiniz kuyruğumuza eklenecek."},"bookmark":{"name":"Yer imi","edit":"Yer imini düzenle","title":"Başlık","address":"Adres","description":"Açıklama","placeholder":" https://... ile bir link yaz veya yapıştır","placeholder_mobile":"Bağlantıyı yapıştırın veya yazın","loading_preview":"Önizleme yükleniyor…","block_menu":{"change_mode":{"menu_name":"Görüntüle","mode_tile":"Tuğla","mode_card":"Kart","mode_cover":"Kapak"},"change_preview":"Önizlemeyi değiştir","delete_preview":"Önizlemeyi sil","reset_preview":"Önizlemeyi sıfırla","change_preview_background":"Önizleme için arka planı değiştir","options":{"menu_name":"Seçenekler","open_in_same_tab":"Aynı sekmede aç"}},"error":{"unknown_error":"Bir hata oluştu, lütfen başka bir URL girmeyi deneyin","preview_notfound":"Önizlemeler bulunamadı"},"upload":{"new_preview":"Yeni Yükle","quota_error":"Dosya izin verilen 3MB\'den daha büyük. Başka bir dosya deneyin.","unknown_error":"Bilinmeyen hata. Başka bir dosya deneyin."}},"businessCard":{"PERSON":"İsim","ORGANIZATION":"Şirket","TITLE":"Başlık","ADDRESS":"Adres","URL":"Site","PHONE":"Telefon","EMAIL":"Email","SKYPE":"Skype","TWITTER":"Twitter","INSTAGRAM":"Instagram","FACEBOOK":"Facebook","LINKEDIN":"LinkedIn","VK":"VK"},"dialog_common":{"button":{"ok":"Tamam","cancel":"İptal et"}},"outline":{"default_name":"Anahat","menu":{"expand":"Genişlet","collapse":"Daralt","rename":"Yeniden adlandır"},"context_menu":{"convert_to":{"text":"Yazı"},"style":{"name":"Anahat türü","list_only":"Sadece liste","numbered_list":"Numaralanmış liste","bordered":"Kenarlığı göster","border_color":"Kenar rengi"}},"empty":"Notunuza Başlıklar ekleyin, burada bağlantılar olarak görünecektir"},"floating_toolbar":{"bold":"Kalın","italic":"İtalik","underline":"Altı çizgili","strikethrough":"Üstü çizili","clear":"Formatı temizle","code":"Kod","button":"Buton","link":"Link","highlight":"Vurgulama","extraHighlight":"Metin etiketleri","color":"Renk","text":"Yazı","clear_all":"Hepsini temizle","placeholder":"Yer tutucu","adapts":{"dark":"Karanlık temaya uyumla","light":"Aydınlık temaya uyumla"},"create_note":"Not oluştur","add_comment":"Yorum ekle"},"remote_frame":{"placeholder_small":"URL yerleştir","placeholder_full":"YouTube, Github, Haritalar, Twitter vb. Gibi herhangi bir URL\'yi yerleştirin.","loading":"Yükleniyor...","context_menu":{"change_link":"Linki değiştir","full_size":"Tam hacim","reset_size":"Boyutu sıfırla","open_origin":"Orjinali aç","layout":"Düzen","show_toolbar":"Düzenleme araç çubuğunu göster","copy_original":"Copy link to original"},"error":{"is_not_link":"Yanlış link","content_error":"Aşağıdaki alan desteklenmiyor veya URL yanlış. Lütfen <a href=\\"https://nimbusweb.me/contact-us.php\\" target=\\"_blank\\">destek ekibimiz ile</a> iletişime geçin.","unknown_error":"Yanlışlık var, Başka URL gir","wrong_signature":"Bu içerik bozuk ve gosterilemez","google_docs_auth_error":"Erişiminiz olmadığı için büyük olasılıkla Google Dokümanlar / E-Tablolar / Slayt dosyasını yerleştiremezsiniz. <a href=\\"http://nimb.ws/EkX87M\\" target=\\"_blank\\">Lütfen kılavuzumuzu okuyun.</a>","internal_link_error":"{{serviceName}} has forbidden following internal links. Click on Back to return to the previous page."},"convert_bookmark":"Yer imine dönüştür","convert_link":"Linke dönüştür","back_button":"Geri dön"},"google_drive":{"block_name":"Google Drive","loading":"Yükleniyor...","menu":{"expand":"Genişlet","collapse":"Daralt","open_origin":"Google Drive\'da aç","download":"Yükle","change_account":"Hesabı değiştir","choose_another_file":"Başka dosya seç"},"last_modified":"En son {{userName}} tarafından {{time}} önce değiştirildi","browse":"Dosyada ara","login":"Google ile giriş yap","login_text":"Dosyalara göz atın ve Google Drive\'dan ekleyin"},"html":{"default_name":"HTML","loading":"Yükleniyor...","menu":{"open_source":"Ana linki aç","export_blot":"HTML\'i kaydet"},"unknown_error":"Bilinmeyen hata","device_cant_display_content":"Cihazınız bu içeriği gösteremiyor","wrong_signature":"Bu içerik bozuk ve gösterilemez"},"relative_time":{"seconds":{"one":"{{count}} saniye","some":"{{count}} saniye","many":"{{count}} saniye"},"minutes":{"one":"{{count}} Dakika","some":"{{count}} Dakika","many":"{{count}} Dakika"},"hours":{"one":"{{count}} Saat","some":"{{count}} Saat","many":"{{count}} Saat"},"days":{"one":"{{count}} Gün","some":"{{count}} Gün","many":"{{count}} Gün"},"months":{"one":"{{count}} Ay","some":"{{count}} Ay","many":"{{count}} Ay"},"years":{"one":"{{count}} Yıl","some":"{{count}} Yıl","many":"{{count}} Yıl"}},"collapsible_content":{"menu":{"expand":"Genişlet","collapse":"Daralt","rename":"Yeniden adlandır"}},"convert_link":{"url":"URL","title":"Başlık","embed":"Yerleştir","bookmark":"Yer imi","button":"Button","link_to_note":"Nota bağla","link_to_folder":"Dosyaya bağla","link_to_workspace":"Çalışma alanına bağla","convert_error":"URL dönüştürürken bir yanlışlık oldu"},"fullwidth":{"menu_item":"Tam genişlik"},"resizeable":{"point_tooltip":{"default":"Yeniden boyutlandır","bottom-right":"Yeniden boyutlandır\\n(ücretsiz yeniden boyutlandırma için {{altKey}} düğmesini basılı tutun)"}},"toggle":{"placeholder":"Bir blok oluşturmak veya taşımak için buraya tıklayın","expand":"Geçişi genişlet","collapse":"Geçişi daralt","expand_heading":"Expand heading","collapse_heading":"Collapse heading","expand_step":"Expand step","collapse_step":"Collapse step"},"step":{"content_placeholder":"Click here to create description to the step","title_placeholder":"Enter a short title to describe this step","aggregator_placeholder":"Enter a short descriptive title","menu":{"step_layout":{"name":"Layout","show_number":"Show number","show_arrow":"Show arrow","show_border":"Show border"}}},"tasks_list":{"not_supported":"Currently, we cannot display the task list as it is not supported in this type of pages.","menu":{"show_title":"Show task list name","view":"Default view","task_list_view":"Task list","calendar_view":"Calendar","kanban_view":"Kanban"}},"board":{"not_supported":"Currently, we cannot display the task board as it is not supported in this type of pages.","menu":{"add_new_column":"New column","board_layout":{"name":"Layout","show_add_new_column":"Show Add column"}}},"empty_features":{"use_template":"Use a template","import":"Import","add_database":"Add database","add_database_with_options":"Add database with options","add_board":"Kanban / Task Board","use_ai":"Use Fusebase AI"},"ai_manager":{"generate_error":"Unfortunately, there are no results for your request. Please try another request.","unload_message":"Fusebase AI content is being generated. Are you sure you want to exit?","unknown_error":"Unknown error. Try again later or contact support.","dialog":{"title":"Discard draft","body":"Do you want to discard draft?","accept":"Yes, discard"}},"uploader":{"header":"Upload files","description":"Here, you can add some helpful information about file uploading","dropzone_full":"Drag file(s) here or","browse":"click to upload","dropzone_compact":"Add more files","uploading_progress":"Uploading {{progress}}%","uploading_files":"Uploading files","counter":"{{current}} of {{total}}","timer":"less than 1 minute remaining","header_placeholder":"Write a title, max {{maxChars}} characters","description_placeholder":"Write a description, max {{maxChars}} characters","errors":{"network":"Failed uploading file","too_big":"File is too big"},"menu":{"disallow_download":"Downloading","for_note":"For workspaces users","for_share":"Public page","convert_to_files":"Convert to files","allow_upload":"Uploading","enable_in_public_page":"Enable in public page"}},"convert_menu_tooltips":{"labels":{"management":"Great for knowledge management","collaboration":"Great for collaboration"},"paragraph":{"title":"Best for main content","description":"This is the main block for writing page content."},"todo":{"title":"A List For Small Tasks? Check!","description":"Write down small errands and routine tasks that need to be done."},"numberedlist":{"title":"Let\'s Line Up: One, Two, Three!","description":"Make your content easy-to-read and display it in a series."},"bulletlist":{"title":"Points Make Everything Clearer","description":"You can create a list that will stand out from other content."},"table":{"title":"Rejoice the Formatting","description":"Organize your information in a table to get a holistic view on your work."},"image":{"title":"We Need To See It — Add An Image","description":"Make your pages more attractive by adding pictures of any file type, moving them and resizing."},"file":{"title":"Files Here, Files There, Files Everywhere!","description":"Create a database for your project by adding files with different types of extensions to your page."},"largeheading":{"title":"Best for Primary Sections of Page","description":"This is the biggest heading you can add. Attract attention to the most vital part of your page and ease up your navigation."},"mediumheading":{"title":"Best for Secondary Section of Page","description":"This is a middle-size heading you can add. Divide your page into sections with it and easily find what you need."},"smallheading":{"title":"Best For Great Ideas In Subsections","description":"This is a small-size heading you can add, but still it stands out. Use it to divide your page into subsections."},"tasks-list":{"title":"Organize Your Work With Nimbus Tasks","description":"Here you can group your tasks in task lists. Assign tasks to your team members, set deadlines and add statuses for easy tracking."},"hline":{"title":"Let\'s Make A Break","description":"Separate different parts of a project or divide your examples and ideas for it."},"link":{"title":"Pave A Path with Links","description":"Whenever you\'ve got an idea for your project, add a link to it and name it."},"syntax":{"title":"Don\'t Forget About Code","description":"You can add code right on your page, switching between themes, languages and more!"},"link-page":{"title":"Your Next Stop Is Another Page","description":"Link another page connected to this project and easily access it right away."},"date":{"title":"Just Say When","description":"Set a deadline for your project or mark the precise time when you started to work on a page."},"mention":{"title":"Get Your Team Involved","description":"Your team members will get email notifications to open a particular page and collaborate there."},"blockquote":{"title":"And I Quote","description":"You can highlight important words from your clients or single out a motivational phrase."},"hint":{"title":"Let\'s Drop A Hint","description":"Choose an emoji and background color to highlight warnings, disclaimers or notifications on your page."},"toggle":{"title":"Hide & Seek Expand Text Block","description":"Sort and hide additional information on your pages for easier navigation and access."},"outline":{"title":"See What Awaits You On The Page","description":"Create a table of contents for easy navigation on long pages or wikis."},"lock-blot":{"title":"No One Can Edit It","description":"You can leave a particular information block on your page untouched and read-only."},"embed":{"title":"Add More Than Just A Link","description":"You can integrate other tools on your page to keep them all in one place and automatically updated."},"figma":{"title":"Keep Your Visuals Even Closer","description":"Add Figma to see how project visuals are designed in real time."},"miro":{"title":"Your Miro Board Is In A Safe Space","description":"Check a layout strategy or a road map for your project and work further on your page."},"columns":{"title":"Two columns are better than one","description":"Divide your page in two columns to add more content there and make your page look neater."},"meeting-notes":{"title":"Set Goals And Move Forward","description":"Use this template to build a marketing strategy and keep all details in one place."},"marketing-brief":{"title":"Dream Big, Plan Quarter By Quarter","description":"Use this template to build a marketing plan by quarters."},"content-plan":{"title":"Control And Lead Your Work","description":"Use this template to take everything inside your head to a table where you can visualize all parts and manage tasks."},"integrations":{"title":"Add More Than Just A Link","description":"You can integrate other tools on your page to keep them all in one place and automatically updated."},"google-drive":{"title":"Drive Your Files From Google Drive","description":"You can connect your Google Drive account and insert links to your drive files for quick access."},"google-sheets":{"title":"Minus Google Sheet Tab","description":"Keep your data in one place with other project details to draw conclusions more easily."},"bookmark":{"title":"Mark Your Link With A New Look","description":"Use a bookmark to show the title of your link, a small description and a preview picture of the website."},"audioRec":{"title":"Say It, Don\'t Write it","description":"Add a human touch to your collaboration, recording voice feedback to the content on your page."},"videoRec":{"title":"Show it, Don\'t Write It","description":"Record a visual explanation of what should be done or give explicit feedback with a video example."},"button":{"title":"Came, Saw, Clicked","description":"Add a CTA element that will drag attention to important links on your pages."},"largeheading-toggle":{"title":"Hide More In A Large-Sized Collapsible Heading","description":"Define the most vital part of your page and hide information there for easy access."},"mediumheading-toggle":{"title":"Make Your Sections Shorter","description":"Create sections with a middle-sized collapsible heading and hide part of your content there."},"smallheading-toggle":{"title":"Make Your Subsections Shorter","description":"Create subsections with a small-sized collapsible heading on your pages and hide additional information there."},"database-with-options":{"title":"Oh How The Tables Have Turned","description":"Create a database for your project and customize it by selecting different types of columns and rows, changing background color and more."},"board":{"title":"Welcome Your Tasks On a Board","description":"Display tasks as cards on a Kanban board to get a bird’s eye view."},"progress":{"title":"See How Far You\'ve Come!","description":"Choose your value and estimate it. Rate and comment on your added content, tasks or other activities."},"uploader":{"title":"Say Goodbye to the File Mess!","description":"Clarify what files your clients and/or team need to send. With the file uploader, you can get what you want and keep it all in one place."},"dropdown-list":{"title":"Drop Your Options","description":"Place answer options anywhere in the text & let others give instant feedback."},"use-ai":{"title":"Work Smart, Not Hard","description":"Use AI to create and improve your content, get new ideas, and make personalized recommendations. Work with an AI assistant in your workspace."}},"feature_availability":{"plus":{"not-available":"Available for Plus & Team & Business plans","trial":"This is open as a trial Plus feature for you"},"team":{"not-available":"Available for Team & Business plans","trial":"This is open as a trial Team feature for you"},"business2023":{"not-available":"Available for Business plan","trial":"This is open as a trial Business feature for you"}}}');
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/i18n/messages/ua.json
const ua_namespaceObject = JSON.parse('{"table":{"common":{"column":"Колонка"},"move_column_cant_split_merged_cells":{"title":"Неможливо перемістити колонку","text":"Не вдається перемістити колонку в об\'єднану клітинку. Від\'єднайте і спробуйте ще раз."},"move_column_cant_move_part_of_merged_cells":{"title":"Неможливо перемістити колонку","text":"Колонка, яку ви намагаєтеся перемістити, містить частину об\'єднаної клітинки. Якщо ви хочете перемістити колонку, спочатку роз\'єднайте клітинки."},"move_column_failed":{"title":"Неможливо перемістити колонку","text":"Виникла несподівана помилка під час переміщення колонки, будь ласка, спробуйте ще раз."},"move_row_cant_split_merged_cells":{"title":"Неможливо перемістити рядок","text":"Не вдається перемістити рядок в об\'єднану клітинку. Від\'єднайте і спробуйте ще раз."},"move_row_cant_move_part_of_merged_cells":{"title":"Неможливо перемістити рядок","text":"Рядок, який ви намагаєтеся перемістити, містить частину об\'єднаної клітинки. Якщо ви хочете перемістити рядок, спочатку роз\'єднайте клітинки."},"move_row_cant_move_in_sortable_table":{"title":"Неможливо перемістити рядок","text":"Не вдається перемістити рядок у відсортованій таблиці. Скасуйте сортування і повторіть спробу."},"move_row_cant_move_in_filtered_table":{"title":"Неможливо перемістити рядок","text":"Неможливо перемістити рядок у відфільтрованій таблиці. Скасуйте фільтр і повторіть спробу."},"move_row_failed":{"title":"Неможливо перемістити рядок","text":"Під час переміщення рядка сталася несподівана помилка, будь ласка, спробуйте ще раз."},"first_move_column_or_row_message":"Ви можете вибрати кілька рядків або колонок, утримуючи кнопку CTRL і клікаючи на потрібні рядки або колонки","menu":{"delete":"Видалити","help":"Допомогти","delete_column":{"one":"Видалити колонку","many":"Видалити {{count}} колонки"},"delete_row":{"one":"Видалити рядок","many":"Видалити {{count}} рядки"},"add":"Додати","add_row_before":{"one":"Рядок вище","many":"{{count}} Рядки вище"},"add_row_after":{"one":"Рядок нижче","many":"{{count}} рядки нижче"},"add_col_before":{"one":"Колонка зліва","many":"{{count}} колонки зліва"},"add_col_after":{"one":"Колонка справа","many":"{{count}} колонки справа"},"copy_cell":{"one":"Скопіювати клітинку","many":"Скопіювати клітинки"},"copy_table":"Скопіювати таблицю","table_layout":{"name":"Розмітка таблиці","column_headings":"Заголовки колонки","row_headings":"Заголовки рядків"},"import_csv":"Імпорт із CSV","merge_cells":"Об\'єднати клітинки","insert_checkbox":"Вставити вибіркове поле","background_color":"Фоновий колір","formatting":"Форматування","clear":"Очистити","reset":"Скинути","divide_cells":"Роз\'єднати клітинки","type":{"name_cell":"Тип клітинки","name_cells":"Тип клітинок","name_column":"Тип колонки","name_columns":"Тип колонок","type_cell":{"one":"Тип клітинки","many":"Тип клітинок"},"type_col":{"one":"Тип колонки","many":"Тип колонок"},"same_as_column":"Те саме, що колонка","reset_cells":"Скинути клітинки до значень за замовчуванням","none":"Багатофункціональний тип","text":"Текст","textline":"Текст","number":"Число","attachment":"Файли","checkbox":"Вибіркове поле","multiselect":"Кілька варіантів вибору","singleselect":"Один вибір","collaborator":"Відповідальний","currency":"Валюта","date":"Дата","link":"Посилання","rating":"Оцінка","progress":"Прогрес","mention":"Згадка"},"number_format":{"name":"Формат числа","number":"Число","commas":"Число з комами","percent":"Відсоток"},"currency_format":{"name":"Тип валюти","dollar":"Долар","euro":"Євро","yen":"Єна","yuan":"Юань","rouble":"Рубль","pound":"Фунт","rupee":"Рупія","hryvnia":"Гривня","won":"Вон","frank":"Франк","real":"Реал","other":"Інша","stick":"Показати символ","before":"До","after":"Після"},"decimal_format":{"name":"Роздільник десяткової частини","comma":"Кома","point":"Крапка","hint":"Роздільник використовується для десяткових знаків. Роздільники десяткових частин з комою виглядатимуть ось так 1000,99, а крапкові роздільники так 1000.99"},"progress_format":{"name":"Варіанти прогресу","simple":"Простий","colored":"Кольоровий","start_from":"Почати із(0-100)","default_amount":"Кількість за замовчуванням(0-100)"},"rating_format":{"name":"Варіанти оцінки","star":"Зірка","flag":"Прапорець","heart":"Сердечко","amount":"Кількість(1-10)"},"date_format":{"name":"Формат Дата/Час"},"mention_panel":{"open":"Відкрити","edit":"Редагувати","clear":"Очистити"},"color_numbers":{"name":"Кольорові номери","enable":"Увімкнути кольорові номери"},"filter":"Фільтр","comment":"Коментар"},"formatting_menu":{"align_left":"Зліва","align_center":"По центру","align_right":"Справа","valign_top":"Зверху","valign_center":"Посередині","valign_bottom":"Внизу","text":"Текст","text_align":"Вирівнювання тексту","text_color":"Колір тексту","bold":"Жирний","italic":"Курсив","strikethrough":"Закреслити","underline":"Підкреслити"},"col_menu":{"add_column_after":{"one":"Додати колонку справа","many":"Додати{{count}} колонок справа"},"add_column_before":{"one":"Додати колонку зліва","many":"Додати {{count}} колонок зліва"},"duplicate_column":{"one":"Дублювати колонку","many":"Дублювати колонки"},"rename":"Перейменувати"},"row_menu":{"add_row_after":{"one":"Додати рядок знизу","many":"Додати{{count}} рядки знизу"},"add_row_before":{"one":"Додати рядок зверху","many":"Додати {{count}} рядки зверху"}},"warning":{"merge_different":"Неможливо об\'єднати різні типи об\'єктів","convert_merged":"Не вдається перетворити об\'єднані клітинки"},"select":{"create_list":"Введіть текст, щоб створити список","create_item":"Введіть текст, щоб створити об\'єкт","create_option":"Введіть текст, щоб створити варіант","create_label":"Введіть текст","create":"Створити","delete":"Видалити"},"attachment":{"upload_more":"Завантажити файл(и)","downloading":"Скачати"},"collaborator":{"placeholder":"Введіть текст, щоб додати людей","no_result":"Немає результатів","loading":"Завантаження...","unknown":"Невідома особа"},"checkbox":{"checked":"Так","not_checked":"Ні"},"sorting":{"name":"Сортування","sort":"Сортувати","disable":"Прибрати сортування","change":"Клікніть, щоб змінити","asc":{"common":"За зростанням","text":"Сортувати від А до Я","number":"Сортувати від 1 до 9","checkbox":"Невибране спершу"},"desc":{"common":"За спаданням","text":"Сортувати від Я до А","number":"Сортувати від 9 до 1","checkbox":"Вибране спершу"},"warning":{"column_merged":{"title":"Неможливо відсортувати колонку","text":"Неможливо відсортувати колонку з об\'єднаними клітинками"},"table_rowspan":{"title":"Неможливо відсортувати колонку","text":"Не вдається відсортувати таблицю з об\'єднаними рядками"},"merge":{"title":"Клітинки не можна об\'єднати","text":"Неможливо об\'єднати клітинки, коли активне сортування у колонках. Вимкніть сортування і спробуйте ще раз."},"different_currencies":{"title":"Важливо!","text":"Ви використовуєте різні валюти в одній колонці. Сортування може бути некоректним."}},"exit_dialog":{"title":"Прибрати сортування","toggle":"Залишити сортування","text_keep":"Залишити сортування","text_no_keep":"Перед сортуванням порядок колонок буде відновлено до початкового","apply":"Застосувати"}},"filter":{"by_field":"Фільтрувати за цим полем","empty_table":"Всі записи відфільтровано","popup_title":"У цій таблиці показувати записи","empty_filters":"До цієї бази даних не застосовуються жодні умови","where":"Де","or":"Або","and":"І","add_condition":"Додати умову","clear_all":"Очистити все","contains":"містить","is":"є","is_not":"не є","contains_not":"містить не","has_any_of":"має деякі","has_none_of":"немає жодних","empty":"пустий","not_empty":"не пустий","filetype":"тип файлу","select_users_placeholder":"Вибрати користувачів","type_text_placeholder":"Ввести текст","type_text_or_select_placeholder":"Ввести текст або вибрати","type_number_placeholder":"Тип цифри","select_type_placeholder":"Вибрати тип","select_date_placeholder":"Вибрати дату","date":{"today":"Сьогодні","yesterday":"Вчора","tomorrow":"Завтра","custom":"Індивідуальний"},"filetypes":{"images":"Зображення","documents":"Документи","media":"Медіа","other":"Інше"},"warning":{"cells_merged":{"title":"Неможливо відфільтрувати таблицю","text":"Неможливо відфільтрувати колонку з об\'єднаними клітинками"},"merge":{"title":"Клітинки не можна об\'єднати","text":"Клітинки не можна об\'єднати, поки активний фільтр таблиці. Вимкніть фільтр і спробуйте ще раз."},"column_multitype":{"title":"Неможливо відфільтрувати таблицю","text":"Немає можливості фільтрувати стовпці з багатофункціональним типом. Будь ласка, спробуйте перетворити в інший тип і спробуйте ще раз."},"table_not_have_typed_columns":{"title":"Неможливо відфільтрувати таблицю","text":"Немає колонок для фільтрації."}},"enable_filter":"Увімкнути фільтр","disable_filter":"Вимкнути фільтр"},"wrap_cells":{"layout_menu":"Згорнути клітинки","warnings":{"merge":{"title":"Неможливо об\'єднати клітинки","text":"Неможливо об\'єднати клітинки в режимі незгортання"},"toggle":{"title":"Не вдається переключити опцію","text":"Таблиця містить об\'єднані клітинки"}}},"duplicate_column":{"title":"Дублювати колонку","text_1":"Дублювати вміст колонки","text_2":"Ви можете продублювати всю колонку з даними або залишити дублікат пустим","accept":"Дублювати","copy":"копіювати"},"convert_column":{"title":"Змінити тип колонки","text_before":"Ця колонка містить значення. Зміна типу колонки призведе до видалення деяких значень. Застосувати","text_cmd":"Скасувати","text_after":"команда для відміни змін, якщо потрібно.","accept":"Змінити тип"},"merge_cells_with_comments":{"title":"Merging cells","text":"The cells will be merged from left to right and the new cell will show a comment from the left cell.","accept":"Merge"},"summary":{"layout_menu":"Показати панель розрахунків","name":{"none":"Жодної","all":"Всі","empty":"Пусті","fill":"Заповнені","unique":"Унікальні","empty_percent":"Відсоток пустих","fill_percent":"Відсоток заповнених","unique_percent":"Відсоток унікальних","sum":"Сума","average":"Середнє","min":"Мін","max":"Макс","median":"Медіанне значення","min_date":"Найдавніша дата","max_date":"Найновіша дата","range_days":"Діапазон дат (дні)","range_month":"Діапазон дат (місяці)","checked":"Відмічено","unchecked":"Невідмічено","checked_percent":"Відсоток відмічених","unchecked_percent":"Відсоток невідмічених","filter_rating":"Із оцінкою:","filter_progress":"Із прогресом:","filesize_min":"Мін розмір","filesize_max":"Макс розмір"},"item":{"none":"Порахувати","min_date":"Найдавніша","max_date":"Найновіша","range_days":"Діапазон(день)","range_month":"Діапазон (місяць)","checked_percent":"Відмічено","unchecked_percent":"Невідмічено","filter_rating":"Із оцінкою","filter_progress":"Із прогресом"}},"comments":{"tooltip":{"one":"Comment","more":"Comments"}}},"file":{"image_viewer":{"could_not_load_image":"Неможливо завантажити зображення"},"download_file":"Скачати {{name}}","listen_file":"Грати {{name}}","stop_file":"Зупинити {{name}}","uploading":"Завантажити","wrtc":{"how_to_fix":"Як це виправити?","how_to_url":"https://nimbusweb.me/s/share/5441210/4qccr41slk6wsw61h5fb","how_to_url2":"https://nimbusweb.me/s/share/5607239/l55bgak2ivs9bfptruka#b1995924032_670","rec_err_au":"Помилка запису. Немає доступу до мікрофона.","rec_err_vi":"Помилка запису. Немає доступу до мікрофона/вебкамери. ","allow_micro":"Дозволити доступ до мікрофона","allow_media":"Виберіть вікно, яке хочете записати","select_opt":"Що буде записано","screenonly":"Тільки екран","camonly":"Тільки камера","screencam":"Екран + Камера","enable_micro":"Увімкнути мікрофон","startRecording":"Почати запис","stopRecording":"Зупинити запис","pauseRecording":"Призупинити запис","resumeRecording":"Продовжити запис","cancelRecording":"Скасувати запис","confirmCancel":"Ви впевнені, що хочете скасувати відеозапис?","cancel":"Скасувати","prepareUpload":"Будь ласка, зачекайте, запис готується до завантаження","hasTmpRecord":"Запис було перервано, але не втрачено","restore":"Відновити","delete":"Видалити","recordOnAnotherDevice":"Йде запис на іншому пристрої ..."},"menu":{"enabled":"Увімкнути","disabled":"Вимкнути","open_in_new_tab":"Відкрити у новій вкладці","copy_link":"Скопіювати посилання до файлу","expand_in_full_window":"Розгорнути у повному вікні","autoplay":"Автовідтворення","sound_default":"Звук за замовчуванням","sound_loop":"Цикл","sound_hideControls":"Сховати елементи керування","sound_showPanel":"Показати верхню панель","shadow_video":"Тінь для відео","video_params":"Налаштування відео","disallow_download":"Скачування","for_note":"Для користувачів просторів","for_share":"Зовнішня сторінка","motion_video":"Моушн відео","preview_video":"Змінити попередній перегляд","preview_video_btn":"Попередній перегляд","print":"Роздрукувати","convert_to_image":"Перетворити на зображення","convert_to_file":"Перетворити на файл","style":"Стиль","shadow_image":"Тінь для зображення","rename":"Перейменувати","replace":"Замінити","delete":"Видалити","download":"Скачати","get_text_from_image":"Отримати текст із зображення","view_as":"Переглянути як","single_page":"Одна сторінка","all_pages":"Всі сторінки","cta_motion_video_message":"Заклик до дії ввімкнено для відео. Ви не можете використовувати заклик до дії та моушн відео одночасно. Вимкніть заклик до дії і спробуйте ввімкнути моушн відео знову.","cta_loop_message":"Заклик до дії ввімкнено для відео. Ви не можете використовувати заклик до дії та цикл одночасно. Вимкніть заклик до дії і спробуйте ввімкнути цикл знову.","grid":"Сітка","cta_drop_in_grid":"Заклик до дії ввімкнено для відео. Рекомендуємо перевірити коректність відображення заклика до дії після перенесення відео в колонку сітки.","cta_exists_in_grid":"У колонці сітки є відео з активним закликом до дії. Будь ласка, перевірте його коректність після переходу."},"downloading":"Скачування","attachment_not_found_error":"Помилка під час завантаження","pdf_viewer":{"initializing_full_window_view":"Ініціалізація повноекранного перегляду","preparing_document_for_printing":"Підготовка документа до друку...","printing_initialization":"Ініціалізація друку...","abort":"перервати","set_page_as_default":"Установити сторінку за замовчуванням","unset_page_as_default":"Сторінка за замовчуванням. Натисніть, щоб зробити сторінку звичайною."},"video_just_uploaded_codec_error":"Ви намагаєтеся завантажити відео, яке було закодовано кодеком {codec}. Ми не гарантуємо коректне відтворення цього відео у всіх браузерах. Ми рекомендуємо конвертувати відео в інший формат і завантажити його знову.","video_codec_error":"Це відео закодовано кодеком {codec}, який не підтримується вашим браузером.","safari_webm_not_support":"Наразі браузери Safari не підтримують формат WEBM. Спробуйте відкрити сторінку в іншому браузері, наприклад, Google Chrome або Mozilla Firefox.","video_transcribe":"Транскрипт","video_summary":"Сводка","video_meeting_notes":"Заметки с встречи","video_ask_ai":"Спросить AI"},"image":{"text_from_image_popup":{"title":"Текст із зображення","no_text":"Немає тексту","copy":"Скопіювати ввесь текст"},"unknown_error":"Посилання неправильне","add_image":"Вставте посилання на зображення або ","add_image_or":"або","add_image_small":"Вставте або ","browse":"шукати","browse_image":"Шукати зображення","too_large_error":"Завеликий розмір зображення","image_info_dialog":{"title":"Інформація про зображення","type":"Тип","size":"Розмір","location":"Розташування","copy_link":"Скопіювати посилання"},"rotate_wait":{"full":"Будь ласка, зачекайте","medium":"Зачекайте"},"attachment_not_found_error":"Виникла несподівана помилка із зображенням","readonly_placeholder":"Пусте зображення","unsplash":{"name":"Unsplash","header":"Виберіть картинку","placeholder":"Пошук зображення","search":"Пошук","description":"Виконайте пошук, щоб знайти більше результатів.","no_result":"Зображення не знайдено.","caption_preffix":"Автор"},"comments":"Comments"},"attachment":{"unknown_error":"Щось пішло не так, спробуйте вибрати інший файл","attachment_is_being_uploaded":"Файл завантажується на інший пристрій...","attachment_will_be_downloaded_online":"Файл завантажиться, коли ви будете онлайн.","attachment_preview_is_not_available":"Попередній перегляд недоступний.","choose_a_file":"Вибрати файли","wait_resolving_without_info":"Будь ласка, зачекайте..."},"video":{"player":{"play":"Відтворити","pause":"Зупинити","volume":"Звук","fullscreen_on":"На увесь екран","fullscreen_off":"Вийти із повноекранного режиму","watch_again":"Переглянути знову"}},"search":{"placeholder":"Знайти у сторінці","matches":"Відповідає:"},"copy":{"copied":"Скопійовано!","copy_to_clipboard":"Скопіювати в буфер обміну"},"apply":"Застосувати","done":"Готово","block_menu":{"align":{"left":"Вирівняти по лівому краю","center":"Вирівняти по центру","right":"Вирівняти по правому краю","justify":"Виправдати"},"indent":{"indent":"Збільшити відступ","outdent":"Зменшити відступ"},"tooltip":"Перетягніть, щоб перемістити\\n<span>Клікніть, щоб відкрити меню</span>","copy_tooltip":"Скопіювати посилання","color":{"background_color":"Фоновий колір","color":"Колір","line_color":"Колір лінії","line_type":"Тип лінії","player_color":"Колір програвача"},"line_type":{"default":"Звичайна лінія","dotted":"Пунктирна"},"add":{"name":"Додати блок","above":"Зверху","below":"Знизу","left":"Зліва","right":"Справа","above_column":"Вище колонки","below_column":"Нижче колонки"},"convert_to":{"name":"Конвертувати до","to_do_list":"Чек-лист","number_list":"Пронумерований список","bullet_list":"Маркований список","paragraph":"Абзац","large_heading":"Заголовок H1","medium_heading":"Заголовок H2","small_heading":"Заголовок H3","large_heading_toggle":"Заголовок, що згортається H1","medium_heading_toggle":"Заголовок, що згортається H2","small_heading_toggle":"Заголовок, що згортається H3","code":"Код","quote":"Цитата","hint":"Підказка","image":"Зображення","file":"Файл","remote_frame":"Вставка","link":"Посилання","bookmark":"Закладка","button":"Кнопка","toggle":"Блок, що згортається","step":"Steps"},"comment_block":"Коментар","edit":"Редагувати","duplicate":"Дублювати","copy_block":"Копіювати блок","copy_blocks":"Копіювати блоки","copy_link":"Копіювати посилання","delete":"Видалити","replace":"Замінити","blot_lock":"Замкнути блок","blot_unlock":"Відкрити блок","set_as_preview":"Встановити для попереднього перегляду","get_text_from_image":"Отримати текст із зображення","edit_image":"Редагувати зображення","download":"Скачати","view_full_size":"Переглянути в повному розмірі","open_in_new_tab":"Відкрити в новій вкладці","image_info":"Інформацію про зображення","rotate_image":"Покрутити","add_sub_task":"Додати підзадачу","add_sub_text":"Додати підтекст","layout":"Розмітка","embed_align":{"left":"Вирівняти по лівому краю","center":"Вирівняти по центру","right":"Вирівняти по правому краю","default":"Розмір за замовчуванням","full_width":"На всю ширину"},"expand_all":"Розгорнути повністю","collapse_all":"Згорнути повністю","add_caption":"Додати підпис","blot_locked_admin":"Редагування блоку заборонено. Натисніть, щоб дозволити.","blot_locked_admins":"Редагування блоків заборонено. Натисніть, щоб дозволити.","blot_locked_user":"Ви не маєте права редагувати цей блок. Зверніться до адміністратора вашої організації.","show_header":"Показати верхню панель","show_borders":"Показати межі","rename":"Перейменувати"},"convert_menu_groups":{"suggestions":"Рекомендації","basic":"Основні","advanced":"Просунуті","media":"Медіа","embed":"Інтерграції","views":"Види","templates":"Шаблони","helpful_links":"Корисні посилання"},"embedded_menu":{"start_typing":"Введіть \\"/\\" або додайте","start_typing_full":"Почніть писати або введіть \\"/\\", \\"@\\"","more_items":"Більше позицій...","add_an_element":"Додати елемент","paragraph":"Абзац","todo":"Список чек-лист","numbered_list":" Нумерований список","bullet_list":"Маркований список","table":"Таблиця","image":"Зображення","file":"Файл","audioRec":"Запис аудіо","videoRec":"Запис відео","recordExist":" Ви не можете почати новий запис, поки не завершиться попередній. Завершіть або видаліть попередній запис, щоб почати новий.","large_heading":"Заголовок H1","medium_heading":"Заголовок H2","small_heading":"Заголовок H3","large_heading_toggle":"Заголовок, що згортається H1","medium_heading_toggle":"Заголовок, що згортається H2","small_heading_toggle":"Заголовок, що згортається H3","section_break":"Лінія","link":"Посилання","code":"Код","quote":"Цитата","hint":"Підказка","hint_placeholder":"Напишіть щось","mention":"Згадати учасника","outline":"Зміст","remote_frame":"Вставка: Посилання, iFrame, JS-код","integrations":"Інтеграції","google_drive":"Google Drive","google_sheets":"Google sheets","html":"HTML","toggle":"Блок, що згортається","tasks_list":"Список задач","lock_blot":"Замкнути блок","link_page":"Перелінкувати сторінки / Створити","date":"Дата","more_integrations":"більше інтеграцій","two_columns":"2 колонки","meeting_notes":"Marketing Strategy","marketing_brief":"Marketing Quarterly PlanningВ ","content_plan":"Content plan","more_templates":"більше шаблонів","get_feedback":"Отримати відгук","contact_support":"Зв’язатися із підтримкою","learn_nimbus":"Дізнатися про Nimbus","footer_top":" А ви знали, що можете почати вводити текст, щоб здійснити пошук у списку","footer_bottom":"Не можете знайти що шукаєте?","footer_link":"Поділіться з нами","add_note":"Нова сторінка","database_with_options":"База даних","board":"Kanban / Дошка задач","progress":"Прогрес","dropdown_list":"Список, що випадає","uploader":"File uploader","use_ai":"Use Fusebase AI","helper":"AI помічник","summarize":"Підсумувати","explain":"Пояснити","improve":"Поліпшити","spelling":"Виправити правопис і граматику","cta":"Заклик до дії","shorter":"Зробити коротше","longer":"Зробити довше","step":"Steps"},"button":{"title":"Назва","id_info_tooltip":" Цей ідентифікатор можна використовувати в майбутньому при редагуванні CSS-файлу.","address":"URL-адреса або електронна пошта","open_in_new_tab":"Відкрити у новій вкладці","shape":" Форма кнопки","background":"Фон","size":"Розмір кнопки","small":"Малий","medium":"Середній","big":"Великий","cancel":"Скасувати","done":"Готово","length_error":" Текст завеликий для кнопки. Спробуйте вибрати менший (не більше 50 символів).","type":"Вид кнопки","default":"За завмовчуванням","withShadow":"Кнопка з тінню","3d":"3D кнопка","convert":{"popup_title":"Перетворити у кнопку"}},"link":{"open":"Відкрити","send":"Надіслати","copy":"Скопіювати","edit":"Редагувати","remove":"Прибрати","text_label":"Текст","url_label":"Посилання","email_label":"Адреса електронної пошти","copied":" Посилання скопійовано в буфер обміну","cancel":"Скасувати","done":"Готово"},"syntax":{"menu":{"language":"Мова","theme":"Тема","wrap":"Увімкнути згортання","unwrap":"Вимкнути згортання","lineNumbersOn":" Показати номери рядків","lineNumbersOff":" Сховати номери рядків"},"convert":{"popup_title":"Перетворити у код","blots_have_comments":"У тексті є коментарі, які будуть видалені під час конвертації.","text_has_inline_comments":"Всередині тексту є коментарі, які будуть видалені під час конвертації.","confirm":"Конвертувати"}},"list":{"list_style":"Стиль списку","type_default":"За завмовчуванням","type_rectangle":"Прямокутник","type_star":"Зірка","type_dart":"Дротик","type_rounded":"Заокруглення","type_arrow":"Стрілка","type_diamond":"Діамант"},"caption":{"placeholder":"Додати підпис"},"mention":{"show_all":"Показати все","show_all_users":"Показати все","placeholder":" Показати нещодавні або ввести для пошуку","user":"Люди","workspace":"Простори","folder":"Папки","note":"Сторінки","no_results":"Немає результатів","offline_message":" Згадка працює лише при активному з\'єднанні. Увімкніть Інтернет і спробуйте ще раз.","info":{"note":{"one":"сторінка","some":"сторінок","many":"сторінок"},"subfolder":{"one":"підпапка","some":"підпапок","many":"підпапок"},"member":{"one":"учасник","some":"учасників","many":"учасників"},"owner":"власник","loading":"Завантаження попереднього перегляду...","loading_failed":"Не вдалося завантажити","not_loaded":"Сторінка ще не завантажилася"},"back_button":"Назад","create_note_for":"Створити сторінку:","create_folder_for":"Створити папку:"},"calendar":{"ui":{"date":"Дата","am":"AM","pm":"PM","date_format":"Формат дати","show_time":"Показати час","time_format":"Формат часу","time_12":"12год","time_24":"24год","first_week_day":"Перший день тижня","time_zone":"Часовий пояс","use_gmt":"Застосувати GMT для всіх учасників","use_gmt_hint":"Застосувати однаковий часовий пояс (GMT) для всіх учасників","table":{"clear":"Очистити"},"inline":{"clear":"Видалити"},"reminder":{"name":"Нагадування","panel_name":" Нагадування","push_name":" Нагадування про подію","remove_confirm_message":" У вас є нагадування з прив\'язкою до часу. Ви хочете видалити ці нагадування?","remove_confirm_text":"Видалити","remove_cancel_text":"Не видаляти нагадування","before_period":"До","after_period":"Після","period":{"m":{"one":"хвилина","many":"хвилин"},"h":{"one":"година","many":"годин"},"d":{"one":"день","many":"днів"},"w":{"one":"тиждень","many":"тижнів"}},"value":{"none":"Жодного","0m":"На початку","1m":"За 1 хвилину до","5m":"За 5 хвилин до","10m":"За 10 хвилин до","15m":"За 15 хвилин до","30m":"За 30 хвилин до","1h":"За 1 годину до","2h":"За 2 години до","1d":"За 1 день до","2d":"За 2 дні до","7d":"За 7 днів до","10d":"За 10 днів до","14d":"За 14 днів до","custom":"Індивідуально"},"until":{"in":"в","d":"д","h":"г","m":"хв","already_been":"Вже було","less_minute":"Менш ніж за хвилину","now":"Зараз"}},"postfix":{"day":"д","month":"м"}},"insert":{"category_name":"Дата","custom":"Інша","now":"Зараз","today":"Сьогодні","tomorrow":"Завтра"},"date_format":{"ddmmyyyy":"дд/мм/рік","mmddyyyy":"мм/дд/рік","yyyyddmm":"рік/мм/дд","monthddyyyy":"Місяць дд, рік","default":"Згідно з форматом браузера"},"months":{"0":"Січень","1":"Лютий","2":"Березень","3":"Квітень","4":"Травень","5":"Червень","6":"Липень","7":"Серпень","8":"Вересень","9":"Жовтень","10":"Листопад","11":"Грудень"},"days":{"short":{"0":"Нд","1":"Пн","2":"Вт","3":"Ср","4":"Чт","5":"Пт","6":"Сб"},"full":{"0":"неділя","1":"понеділок","2":"вівторок","3":"середа","4":"четвер","5":"п’ятниця","6":"субота"}}},"content_not_supported":" Ця сторінка не підтримується у вашій версії програми FuseBase. Спробуйте оновити її або використайте інший клієнт з останньою версією.","profession_ask":{"title":" Збережіть час, використовуйте шаблони для створення нових сторінок ","text":"Введіть свою професію, і наша команда створить для вас шаблони. Це безкоштовно, без жодних прихованих платежів","i_am_a":"Я","placeholder":" наприклад, дизайнер, вчитель, торговий агент тощо","request_template":"Створити запит на шаблон","sucess_message":" Дякую! Ваш запит буде додано до черги."},"bookmark":{"name":"Закладка","edit":"Редагувати закладку","title":"Назва","address":"Адреса","description":"Опис","placeholder":"Вставте або напишіть посилання з https://...","placeholder_mobile":" Вставте або напишіть посилання","loading_preview":"Завантаження попереднього перегляду¦","block_menu":{"change_mode":{"menu_name":"Переглянути як","mode_tile":"Назва","mode_card":"Картка","mode_cover":"Обкладинка"},"change_preview":"Змінити попередній перегляд","delete_preview":"Видалити попередній перегляд","reset_preview":"Перевстановити попередній перегляд","change_preview_background":"Попереднього переглянути фон","options":{"menu_name":"Варіанти","open_in_same_tab":" Відкрити в тій самій вкладці"}},"error":{"unknown_error":" Щось пішло не так, спробуйте ввести іншу URL-адресу","preview_notfound":" Попередній перегляд не знайдено"},"upload":{"new_preview":"Завантажити нове","quota_error":"Розмір файлу перевищує дозволені 3 МБ. Спробуйте інший файл.","unknown_error":"Невідома помилка. Спробуйте інший файл."}},"businessCard":{"PERSON":"Ім’я","ORGANIZATION":"Компанія","TITLE":"Назва","ADDRESS":"Посада","URL":"Вебсайт","PHONE":"Номер телефону","EMAIL":"Електронна адреса","SKYPE":"Skype","TWITTER":"Twitter","INSTAGRAM":"Instagram","FACEBOOK":"Facebook","LINKEDIN":"LinkedIn","VK":"Vk"},"dialog_common":{"button":{"ok":"Ok","cancel":"Відмінити"}},"outline":{"default_name":"Зміст","menu":{"expand":"Розгорнути","collapse":"Згорнути","rename":"Перейменувати"},"context_menu":{"convert_to":{"text":"Текст"},"style":{"name":"Стиль змісту","list_only":"Тільки список","numbered_list":"Нумерований список","bordered":"Показати межу","border_color":"Колір межі"}},"empty":"Додайте заголовки на свою сторінку, і вони з\'являться тут у вигляді посилань"},"floating_toolbar":{"bold":"Жирний","italic":"Курсив","underline":"Підкреслити","strikethrough":"Закреслити","clear":"Прибрати форматування","code":"Код","button":"Кнопка","link":"Посилання","highlight":"Виділити","extraHighlight":"Мітки для текстів","color":"Розфарбувати та виділити","text":"Текст","clear_all":"Очистити все","placeholder":"Заповнювач","adapts":{"dark":" Адаптується до темної теми","light":" Адаптується до світлої теми"},"create_note":"Створити сторінку","add_comment":"Додати коментар"},"remote_frame":{"placeholder_small":"Вкласти URL-адресу","placeholder_full":"Вставте будь-яку URL-адресу, наприклад, YouTube, Github, Maps, Twitter, тощо","loading":"Завантаження...","context_menu":{"change_link":"Змінити посилання","full_size":" На весь екран","reset_size":"Скинути розмір","open_origin":"Відкрити оригінал","layout":"Розмітка","show_toolbar":"Показати панель інструментів редагування","copy_original":"Copy link to original"},"error":{"is_not_link":"Посилання або код неправильні","content_error":" Ця URL-адреса не підтримується або недійсна. <a href=\\"https://nimbusweb.me/contact-us.php\\" target=\\"_blank\\">Зв’яжіться з нами </a> якщо ви вважаєте, що цю URL-адресу можна вкласти.","unknown_error":" Щось пішло не так, спробуйте ввести іншу URL-адресу","wrong_signature":" Цей вміст пошкоджений і не може бути відображений","google_docs_auth_error":" Швидше за все, ви не можете вставити файл Google Docs/Sheets/Slides, тому що у вас немає до нього доступу. <a href=\\"http://nimb.ws/EkX87M\\" target=\\"_blank\\"> Будь ласка, прочитайте наш гайд.</a>","internal_link_error":"{{serviceName}} заборонив переходити за внутрішніми посиланнями. Натисніть на кнопку Назад, щоб повернутися на попередню сторінку."},"convert_bookmark":"Перетворити у закладку","convert_link":"Перетворити у посилання","back_button":"Назад"},"google_drive":{"block_name":"Google Drive","loading":"Завантаження...","menu":{"expand":"Розгорнути","collapse":"Згорнути","open_origin":"Відкрити в Google Drive","download":"Скачати","change_account":"Змінити обліковий запис","choose_another_file":"Вибрати інший файл"},"last_modified":"Востаннє змінено {{userName}} {{time}} тому","browse":"Шукати файл","login":"Увійдіть за допомогою Google","login_text":"Переглядайте та додавайте файли з Google Диску"},"html":{"default_name":"HTML","loading":"Завантаження...","menu":{"open_source":"Відкрити посилання на джерело","export_blot":"Зберегти HTML"},"unknown_error":"Невідома помилка","device_cant_display_content":"Ваш пристрій не може відобразити цей вміст","wrong_signature":"Цей вміст пошкоджений і не відображається"},"relative_time":{"seconds":{"one":"{{count}} секунда","some":"{{count}} секунд","many":"{{count}} секунд"},"minutes":{"one":"{{count}} хвилина","some":"{{count}} хвилин","many":"{{count}} хвилин"},"hours":{"one":"{{count}} година","some":"{{count}} годин","many":"{{count}} годин"},"days":{"one":"{{count}} день","some":"{{count}} днів","many":"{{count}} днів"},"months":{"one":"{{count}} місяць","some":"{{count}} місяців","many":"{{count}} місяців"},"years":{"one":"{{count}} рік","some":"{{count}} років","many":"{{count}} років"}},"collapsible_content":{"menu":{"expand":"Розгорнути","collapse":"Згорнути","rename":"Перейменувати"}},"convert_link":{"url":"URL-адреса","title":"Назва","embed":"Вкладка","bookmark":"Закладка","button":"Кнопка","link_to_note":"Посилання на сторінку","link_to_folder":"Посилання на папку","link_to_workspace":"Посилання на простір","convert_error":"Виникла помилка при перетворенні URL-адреси"},"fullwidth":{"menu_item":"На всю ширину"},"resizeable":{"point_tooltip":{"default":"Змінити розмір","bottom-right":" Змінити розмір\\n(натисніть і утримуйте клавішу {{altKey}} для зміни розміру)"}},"toggle":{"placeholder":"Натисніть тут, щоб створити або перемістити блок","expand":"Розгорнути блок","collapse":"Згорнути блок","expand_heading":"Розгорнути заголовок","collapse_heading":"Згорнути заголовок","expand_step":"Expand step","collapse_step":"Collapse step"},"step":{"content_placeholder":"Click here to create description to the step","title_placeholder":"Enter a short title to describe this step","aggregator_placeholder":"Enter a short descriptive title","menu":{"step_layout":{"name":"Layout","show_number":"Show number","show_arrow":"Show arrow","show_border":"Show border"}}},"tasks_list":{"not_supported":"Наразі ми не можемо відобразити список задач, оскільки він не підтримується в цьому типі сторінок.","menu":{"show_title":"Show task list name","view":"Default view","task_list_view":"Task list","calendar_view":"Calendar","kanban_view":"Kanban"}},"board":{"not_supported":"Наразі ми не можемо відобразити дошку задач, оскільки вона не підтримується в цьому типі сторінок.","menu":{"add_new_column":"Нова колонка","board_layout":{"name":"Розмітка","show_add_new_column":"Показати Додати колонку"}}},"empty_features":{"use_template":"Використати шаблон","import":"Імпортувати","add_database":"Додати базу даних","add_database_with_options":"Додати базу даних із опціями","add_board":"Kanban / Дошка задач","use_ai":"Use Fusebase AI"},"ai_manager":{"generate_error":"Unfortunately, there are no results for your request. Please try another request.","unload_message":"Fusebase AI content is being generated. Are you sure you want to exit?","unknown_error":"Unknown error. Try again later or contact support.","dialog":{"title":"Discard draft","body":"Do you want to discard draft?","accept":"Yes, discard"}},"uploader":{"header":"Upload files","description":"Here, you can add some helpful information about file uploading","dropzone_full":"Drag file(s) here or","browse":"click to upload","dropzone_compact":"Add more files","uploading_progress":"Uploading {{progress}}%","uploading_files":"Uploading files","counter":"{{current}} of {{total}}","timer":"less than 1 minute remaining","header_placeholder":"Write a title, max {{maxChars}} characters","description_placeholder":"Write a description, max {{maxChars}} characters","errors":{"network":"Failed uploading file","too_big":"File is too big"},"menu":{"disallow_download":"Downloading","for_note":"For workspaces users","for_share":"Public page","convert_to_files":"Convert to files","allow_upload":"Uploading","enable_in_public_page":"Enable in public page"}},"convert_menu_tooltips":{"labels":{"management":" Підходить для управління знаннями","collaboration":"Підходить для взаємодії"},"paragraph":{"title":"Найкраще для найважливішого","description":" Це основний блок для написання контенту сторінки."},"todo":{"title":"Список для дрібних задач? Сюди!","description":"Записуйте невеликі доручення та рутинні завдання, які потрібно виконати."},"numberedlist":{"title":" Шикуймося: раз, два, три!","description":" Зробіть свій контент зручним для читання та показуйте його у вигляді списку."},"bulletlist":{"title":"Зробіть все зрозумілішим","description":"Ви можете створити список, який буде виділятися серед іншого контенту."},"table":{"title":"Форматуйте з радістю","description":" Організуйте інформацію в таблицю, щоб отримати цілісне уявлення про роботу."},"image":{"title":"Нам потрібно це побачити!Додайте зображення","description":" Зробіть свої сторінки привабливішими. Додавайте зображення будь-якого типу, переміщуйте їх і змінюйте розмір."},"file":{"title":" Файли тут, файли там, файли всюди!","description":" Створіть базу даних для вашого проєкту. Додайте на сторінку файли з різними типами розширень."},"largeheading":{"title":"Найкраще для основних розділів сторінки","description":" Це найбільший заголовок, який ви можете додати. Приверніть увагу до найважливої частини вашої сторінки та полегшіть навігацію."},"mediumheading":{"title":"Найкраще для другорядної інформації","description":"Це заголовок середнього розміру, який ви можете додати. За допомогою нього ви можете розділити сторінку на розділи і легко знайти те, що вам потрібно."},"smallheading":{"title":" Найкраще для чудових ідей у підсекціях","description":" Це найменший за розміром заголовок, який ви можете додати, але він все одно виділяється. Використовуйте його, щоб розділити сторінку на підсекції."},"tasks-list":{"title":"Організуйте свою роботу із задачами","description":"Тут ви можете групувати задачі в списки задач. Призначайте задачі учасникам, встановлюйте дедлайни та додавайте статуси для легкого відстеження."},"hline":{"title":"Проведімо лінію","description":"Відокремлюйте різні частини проєкту або розмежовуйте приклади та ідеї для нього."},"link":{"title":"Залиште посилання","description":"Щоразу, коли у вас з\'являється ідея для проєкту, додайте посилання на неї і дайте їй назву."},"syntax":{"title":"Не забувайте про код","description":"Ви можете додавати код прямо на своїй сторінці, перемикатися між темами, мовами тощо!"},"link-page":{"title":"Наступна зупинка - інша сторінка","description":"Посилайтесь на іншу сторінку, пов\'язану з проєктом, і легко переходьте на неї."},"date":{"title":"Просто скажіть коли","description":"Встановіть дедлайн для проєкту або позначте точний час, коли ви почали працювати над сторінкою."},"mention":{"title":"Залучайте свою команду","description":"Учасники вашої команди отримуватимуть сповіщення на електронну пошту, щоб відкрити певну сторінку та працювати на ній."},"blockquote":{"title":"І я цитую","description":"Ви можете виділити важливі слова ваших клієнтів або позначити мотиваційну фразу."},"hint":{"title":"Дайте підказку","description":"Виберіть емодзі та колір фону, щоб виділити попередження, застереження або сповіщення на сторінці."},"toggle":{"title":"Заховайте ваші блоки","description":"Сортуйте та приховуйте додаткову інформацію на сторінках для легшої навігації та доступу."},"outline":{"title":"Перегляньте, що чекає на вас","description":"Створіть зміст для зручної навігації на довгих сторінках або вікі."},"lock-blot":{"title":"Не для редагування","description":"Ви можете залишити певні інформаційні блоки на своїй сторінці лише для читання."},"embed":{"title":"Більше, ніж просто посилання","description":"Ви можете інтегрувати різні інструменти на сторінку. Зберігайте все в одному місці з автоматичним оновленням."},"figma":{"title":"Ваші дизайни на одній сторінці","description":"Додайте Figma на сторінку. Дивіться як створюються дизайни для проєкту в реальному часі."},"miro":{"title":"Ваша Miro Board у безпечному місці","description":"Ознайомтеся із довгостроковою стратегією вашого проєкту і враховуйте її у створенні сторінки."},"columns":{"title":"Одна колонка – добре, дві – краще!","description":"Розділіть сторінку на дві колонки, щоб додати туди більше контенту і зробити сторінку охайнішою."},"meeting-notes":{"title":"Ставте цілі та рухайтеся вперед","description":"Використовуйте цей шаблон, щоб побудувати маркетингову стратегію і тримати всі деталі в одному місці."},"marketing-brief":{"title":" Мрійте про велике, плануйте квартал за кварталом","description":"Використовуйте цей шаблон для побудови маркетингового плану по кварталах."},"content-plan":{"title":"Контролюйте та керуйте своєю роботою","description":"Використовуйте цей шаблон, щоб відтворити свої плани у таблиці. Візуалізуйте процес і керуйте задачами."},"integrations":{"title":"Більше, ніж просто посилання","description":"Ви можете інтегрувати різні інструменти на сторінку. Зберігайте все в одному місці з автоматичним оновленням."},"google-drive":{"title":"Зберіть всі файли з Google Drive","description":"Ви можете підключити свій обліковий запис Google Drive і вставити посилання на файли на диску для швидкого доступу до них."},"google-sheets":{"title":"Мінус одна вкладка з Google Sheet","description":"Зберігайте дані в одному місці з іншими деталями проекту, щоб легше проводити аналіз."},"bookmark":{"title":"Новий вид посилання тут","description":"Використовуйте закладку, щоб показати назву вашого посилання, невеликий опис і зображення сайту із попереднім переглядом."},"audioRec":{"title":"Не пишіть, краще скажіть","description":"Персоналізуйте вашу роботу. Запишіть голосовий відгук до матеріалів на сторінці."},"videoRec":{"title":"Не пишіть, краще покажіть","description":" Запишіть відео пояснення того, що потрібно зробити, або надайте чіткий зворотній зв\'язок."},"button":{"title":"Прийшов, побачив, клікнув","description":"Додайте елемент заклику до дії, який привертатиме увагу до важливих посилань на ваших сторінках."},"largeheading-toggle":{"title":"Заховайте більше у заголовку, що згортається H1","description":"Визначте найбільш важливу частину вашої сторінки та сховайте там інформацію для легкого доступу."},"mediumheading-toggle":{"title":"Зробіть ваші розділи ще коротшими","description":"Створюйте розділи із заголовком, що згортається H2 і ховайте в них частину контенту."},"smallheading-toggle":{"title":"Зробіть ваші підрозділи ще коротшими","description":"Створюйте розділи із заголовком, що згортається H3 і ховайте в них додаткову інформацію."},"database-with-options":{"title":"Оце так таблиці!","description":" Створіть базу даних для проєкту та налаштуйте її. Вибирайте різні типи колонок і рядків, змінюйте колір фону, тощо."},"board":{"title":"До дошки!","description":"Відображайте задачі у вигляді карток на дошці Kanban, щоб мати цілісне уявлення."},"progress":{"title":"Оцініть ваш прогрес!","description":"Виберіть мету і рухайтеся до неї! Використовуйте прогрес бар для оцінки виконаних завдань та інших активностей."},"uploader":{"title":"Say Goodbye to the File Mess!","description":"Clarify what files your clients and/or team need to send. With the file uploader, you can get what you want and keep it all in one place."},"dropdown-list":{"title":"Drop Your Options","description":"Place answer options anywhere in the text & let others give instant feedback."},"use-ai":{"title":"Work Smart, Not Hard","description":"Use AI to create and improve your content, get new ideas, and make personalized recommendations. Work with an AI assistant in your workspace."}},"feature_availability":{"plus":{"not-available":"Доступно для Plus, Team та Business планів","trial":"Вам доступний функціонал на час пробного періоду"},"team":{"not-available":"Доступно для Team та Business планів","trial":"Вам доступний функціонал на час пробного періоду плану Team"},"business2023":{"not-available":"Доступно для Business плану","trial":"Вам доступний функціонал на час пробного періоду плану Business"}}}');
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/i18n/index.js
function i18n_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { i18n_typeof = function _typeof(obj) { return typeof obj; }; } else { i18n_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return i18n_typeof(obj); }









function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (i18n_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }










var messages = {
  ru: ru_namespaceObject,
  en: en_namespaceObject,
  de: de_namespaceObject,
  it: it_namespaceObject,
  es: es_namespaceObject,
  tr: tr_namespaceObject,
  ua: ua_namespaceObject
};
var i18nPluginInstance;
var IntlProvider = /*#__PURE__*/function (_Component) {
  _inherits(IntlProvider, _Component);
  var _super = _createSuper(IntlProvider);
  function IntlProvider() {
    _classCallCheck(this, IntlProvider);
    return _super.apply(this, arguments);
  }
  _createClass(IntlProvider, [{
    key: "render",
    value: function render() {
      if (!i18nPluginInstance) {
        throw new Error('i18n plugin must be initialized prior to any usage of IntlProvider');
      }
      return (0,preact_module.h)(preact_i18n_esm_IntlProvider, {
        definition: i18nPluginInstance.getCurrentDefinition()
      }, this.props.children);
    }
  }]);
  return IntlProvider;
}(preact_module/* Component */.wA);

var I18n = /*#__PURE__*/function () {
  function I18n(_ref) {
    var editor = _ref.editor,
      scroll = _ref.scroll,
      options = _ref.options;
    _classCallCheck(this, I18n);
    this.options = options || {};
    this.language = 'en';
    if (this.options.language && messages.hasOwnProperty(this.options.language)) {
      this.language = this.options.language;
    }
    // сохраняем глобально, для использования в провайдере
    i18nPluginInstance = this;
  }
  _createClass(I18n, [{
    key: "getCurrentDefinition",
    value: function getCurrentDefinition() {
      return messages[this.language];
    }
  }, {
    key: "get",
    value: function get(id, fields, plural, fallback) {
      return translate_translate(id, '', this.getCurrentDefinition(), fields, plural, fallback);
    }
  }]);
  return I18n;
}();


/***/ }),

/***/ 23497:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79758);
/* harmony import */ var _components_popupMenu__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10856);
/* harmony import */ var _components_popupDialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49096);
/* harmony import */ var _components_popupDialogTitle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83483);
/* harmony import */ var _components_popupDialogBody__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19617);
/* harmony import */ var _components_popupDialogButtons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25251);






var ConfirmPopup = function ConfirmPopup(props) {
  var onCancel = props.onCancel,
    onConfirm = props.onConfirm,
    title = props.title,
    message = props.message,
    confirmText = props.confirmText,
    cancelText = props.cancelText,
    editor = props.editor,
    _props$maxWidth = props.maxWidth,
    maxWidth = _props$maxWidth === void 0 ? 520 : _props$maxWidth,
    _props$revertButtons = props.revertButtons,
    revertButtons = _props$revertButtons === void 0 ? false : _props$revertButtons,
    _props$addClassName = props.addClassName,
    addClassName = _props$addClassName === void 0 ? 'column-convert-popup' : _props$addClassName;
  var buttons = {};
  if (cancelText) {
    buttons.cancel = {
      text: cancelText
    };
  }
  if (confirmText) {
    buttons.accept = {
      text: confirmText,
      style: 'active',
      onClick: onConfirm
    };
  }
  return (0,preact__WEBPACK_IMPORTED_MODULE_0__.h)(_components_popupMenu__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    wantsToClose: onCancel,
    addClassName: addClassName,
    closeOnEsc: true
  }, (0,preact__WEBPACK_IMPORTED_MODULE_0__.h)(_components_popupDialog__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    wantsToClose: onCancel,
    addClassName: 'reduced-padding',
    noCloseButton: true
  }, (0,preact__WEBPACK_IMPORTED_MODULE_0__.h)(_components_popupDialogTitle__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, null, title), (0,preact__WEBPACK_IMPORTED_MODULE_0__.h)(_components_popupDialogBody__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    style: {
      'max-width': maxWidth + 'px'
    }
  }, (0,preact__WEBPACK_IMPORTED_MODULE_0__.h)("p", null, (0,preact__WEBPACK_IMPORTED_MODULE_0__.h)("span", null, message))), (0,preact__WEBPACK_IMPORTED_MODULE_0__.h)(_components_popupDialogButtons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    editor: editor,
    wantsToClose: onCancel,
    buttons: buttons,
    revertButtons: revertButtons
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ConfirmPopup);

/***/ }),

/***/ 95174:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qZ": () => (/* binding */ TOOLTIP_ATTR),
/* harmony export */   "aP": () => (/* binding */ TOOLTIP_ATTR_ALLOW_UNSAFE_HTML),
/* harmony export */   "BY": () => (/* binding */ TOOLTIP_SMALL_ATTR),
/* harmony export */   "xQ": () => (/* binding */ TOOLTIP_TIMEOUT_ATTR),
/* harmony export */   "Bg": () => (/* binding */ TOOLTIP_ADD_CLASS),
/* harmony export */   "cD": () => (/* binding */ TOOLTIP_ADD_OPTIONS),
/* harmony export */   "ZP": () => (/* binding */ TooltipManager)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var popper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12212);
/* harmony import */ var _theme_scss_tooltip_vars_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29650);
/* harmony import */ var _theme_scss_tooltip_vars_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_theme_scss_tooltip_vars_scss__WEBPACK_IMPORTED_MODULE_1__);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var TOOLTIP_ATTR = 'data-editor-toolip';
var TOOLTIP_ATTR_ALLOW_UNSAFE_HTML = 'data-editor-tooltip-html';
var TOOLTIP_SMALL_ATTR = 'data-editor-toolip-small';
var TOOLTIP_TIMEOUT_ATTR = 'data-editor-tooltip-delay';
var TOOLTIP_ADD_CLASS = 'data-editor-tooltip-class';
var TOOLTIP_ADD_OPTIONS = 'data-editor-tooltip-options';


var TOOLTIP_NODE_CLASS = 'editor-tooltip';
var TOOLTIP_ARROW_CLASS = 'editor-tooltip-arrow';
var DEFAULT_TOOLTIP_SHOW_TIMEOUT = 200;
var transitionDuration = parseInt(_theme_scss_tooltip_vars_scss__WEBPACK_IMPORTED_MODULE_1__.transitionDuration);
var Tooltip = /*#__PURE__*/function () {
  function Tooltip(node, opts) {
    var _this = this;
    _classCallCheck(this, Tooltip);
    _defineProperty(this, "onMouseOver", function (event) {
      if (event.target === _this.node || _this.node.contains(event.target)) {
        return;
      }
      clearTimeout(_this.timer);
      if (!_this.isShown) {
        _this.removeMouseOverListener();
      } else {
        _this.destroy();
      }
    });
    _defineProperty(this, "removeMouseOverListener", function () {
      document.body.removeEventListener('mouseover', _this.onMouseOver, false);
    });
    _defineProperty(this, "onBodyMouseDown", function (event) {
      _this.destroy();
    });
    this.opts = opts;
    this.node = node;
    this.tooltipNode = null;
    this.container = opts.container || document.body;
    this.popper = null;
    this.isShown = false;
    this.destroyed = false;
    document.body.addEventListener('mouseover', this.onMouseOver, false);
    this.timer = setTimeout(function () {
      _this.show();
    }, this.opts.timeout);
  }
  _createClass(Tooltip, [{
    key: "runTransition",
    value: function runTransition(node, duration, type) {
      node.classList.add(TOOLTIP_NODE_CLASS + '-' + type);
      setTimeout(function () {
        node.classList.add(TOOLTIP_NODE_CLASS + '-' + type + '-active');
      }, 100);
      setTimeout(function () {
        node.classList.remove(TOOLTIP_NODE_CLASS + '-' + type);
      }, duration);
    }
  }, {
    key: "show",
    value: function show() {
      var _this2 = this;
      this.isShown = true;
      var node = document.createElement('div');
      node.classList.add(TOOLTIP_NODE_CLASS);
      this.tooltipNode = node;
      if (this.opts.addClass) {
        this.tooltipNode.classList.add(this.opts.addClass);
      }
      var textNode = document.createElement('span');
      var textAttr = this.opts.html ? 'innerHTML' : 'textContent';
      textNode[textAttr] = this.opts.text;
      var smallTextNode = null;
      if (this.opts.textSmall) {
        smallTextNode = document.createElement('small');
        smallTextNode[textAttr] = this.opts.textSmall;
      }
      var arrow = document.createElement('div');
      arrow.classList.add(TOOLTIP_ARROW_CLASS);
      node.appendChild(textNode);
      if (smallTextNode) {
        node.appendChild(smallTextNode);
      }
      node.appendChild(arrow);
      var popperOptions = Object.assign({}, {
        placement: 'top',
        positionFixed: true,
        modifiers: {
          offset: {
            offset: '0,10'
          },
          arrow: {
            element: arrow
          },
          preventOverflow: {
            boundariesElement: this.opts.scrollingContainer
          },
          flip: {
            boundariesElement: this.opts.scrollingContainer
          }
        }
      }, this.opts.options ? JSON.parse(this.opts.options) : {});
      popperOptions.onCreate = function () {
        _this2.runTransition(node, transitionDuration, 'enter');
      };
      this.container.appendChild(node);
      this.popper = new popper_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z(this.node, this.tooltipNode, popperOptions);
      document.addEventListener('mousedown', this.onBodyMouseDown);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.destroyed) {
        return;
      }
      // для случая если тултип еще не успел показатся очищаем таймер
      clearTimeout(this.timer);
      document.removeEventListener('mousedown', this.onBodyMouseDown);
      this.destroyed = true;
      if (this.popper) {
        // поппер может быть еще не создан из-за таймаута показа
        this.popper.destroy();
      }
      if (this.tooltipNode) {
        // tooltipNode может быть еще не создана из-за таймаута показа
        this.tooltipNode.parentNode.removeChild(this.tooltipNode);
      }
      this.removeMouseOverListener();
    }
  }]);
  return Tooltip;
}();
var TooltipManager = /*#__PURE__*/function () {
  function TooltipManager(_ref) {
    var _this3 = this;
    var scroll = _ref.scroll,
      editor = _ref.editor,
      options = _ref.options;
    _classCallCheck(this, TooltipManager);
    _defineProperty(this, "onMouseOver", function (event) {
      // пока отключил показ тултипов для редактора, если к нему применен css scale,
      // так как тултипы показываются совсем не там где нужно, скейл ломает позиционирование поппера
      if (_this3.editor.options.scale !== undefined && _this3.editor.options.scale !== 0) {
        return;
      }
      if (!event.target.closest) {
        return;
      }
      var tooltipNode = event.target.closest('[' + TOOLTIP_ATTR + ']');
      if (!tooltipNode) {
        return;
      }
      if (_this3.tooltip) {
        _this3.tooltip.destroy();
      }
      var tooltip = new Tooltip(tooltipNode, {
        text: tooltipNode.getAttribute(TOOLTIP_ATTR),
        textSmall: tooltipNode.getAttribute(TOOLTIP_SMALL_ATTR),
        container: _this3.editor.scrollingContainer,
        timeout: tooltipNode.getAttribute(TOOLTIP_TIMEOUT_ATTR) || DEFAULT_TOOLTIP_SHOW_TIMEOUT,
        addClass: tooltipNode.getAttribute(TOOLTIP_ADD_CLASS),
        options: tooltipNode.getAttribute(TOOLTIP_ADD_OPTIONS),
        html: tooltipNode.getAttribute(TOOLTIP_ATTR_ALLOW_UNSAFE_HTML) === '1',
        scrollingContainer: _this3.editor.getScrollingContainer()
      });
      _this3.tooltip = tooltip;
    });
    options = Object.assign({
      enabled: true
    }, options);
    this.editor = editor;
    this.scroll = scroll;
    this.tooltip = null;
    this.enabled = options.enabled;
    this.init();
  }
  _createClass(TooltipManager, [{
    key: "init",
    value: function init() {
      if (!this.enabled) {
        return;
      }
      this.editor.container.addEventListener('mouseover', this.onMouseOver, false);
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this.tooltip) {
        this.tooltip.destroy();
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.editor.container.removeEventListener('mouseover', this.onMouseOver, false);
    }
  }]);
  return TooltipManager;
}();


/***/ }),

/***/ 49190:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zlx": () => (/* reexport default from dynamic */ _images_icons_empty_svg__WEBPACK_IMPORTED_MODULE_174___default.a),
/* harmony export */   "bM7": () => (/* reexport default from dynamic */ _images_icons_checkbox_svg__WEBPACK_IMPORTED_MODULE_1___default.a),
/* harmony export */   "UcJ": () => (/* reexport default from dynamic */ _images_icons_list_number_svg__WEBPACK_IMPORTED_MODULE_2___default.a),
/* harmony export */   "pfx": () => (/* reexport default from dynamic */ _images_icons_list_bullet_svg__WEBPACK_IMPORTED_MODULE_3___default.a),
/* harmony export */   "fqO": () => (/* reexport default from dynamic */ _images_icons_table_svg__WEBPACK_IMPORTED_MODULE_4___default.a),
/* harmony export */   "Zay": () => (/* reexport default from dynamic */ _images_icons_image_svg__WEBPACK_IMPORTED_MODULE_6___default.a),
/* harmony export */   "I19": () => (/* reexport default from dynamic */ _images_icons_empty_image_svg__WEBPACK_IMPORTED_MODULE_7___default.a),
/* harmony export */   "XhR": () => (/* reexport default from dynamic */ _images_icons_file_svg__WEBPACK_IMPORTED_MODULE_8___default.a),
/* harmony export */   "aXx": () => (/* reexport default from dynamic */ _images_icons_pin_btn_svg__WEBPACK_IMPORTED_MODULE_9___default.a),
/* harmony export */   "Q2d": () => (/* reexport default from dynamic */ _images_icons_header_small_svg__WEBPACK_IMPORTED_MODULE_10___default.a),
/* harmony export */   "L9t": () => (/* reexport default from dynamic */ _images_icons_header_medium_svg__WEBPACK_IMPORTED_MODULE_11___default.a),
/* harmony export */   "oIo": () => (/* reexport default from dynamic */ _images_icons_header_large_svg__WEBPACK_IMPORTED_MODULE_12___default.a),
/* harmony export */   "uVN": () => (/* reexport default from dynamic */ _images_icons_hline_svg__WEBPACK_IMPORTED_MODULE_13___default.a),
/* harmony export */   "JHz": () => (/* reexport default from dynamic */ _images_icons_link_svg__WEBPACK_IMPORTED_MODULE_14___default.a),
/* harmony export */   "SC9": () => (/* reexport default from dynamic */ _images_icons_plus_svg__WEBPACK_IMPORTED_MODULE_15___default.a),
/* harmony export */   "UrD": () => (/* reexport default from dynamic */ _images_icons_minus_svg__WEBPACK_IMPORTED_MODULE_16___default.a),
/* harmony export */   "lM8": () => (/* reexport default from dynamic */ _images_icons_bold_svg__WEBPACK_IMPORTED_MODULE_17___default.a),
/* harmony export */   "C9_": () => (/* reexport default from dynamic */ _images_icons_italic_svg__WEBPACK_IMPORTED_MODULE_18___default.a),
/* harmony export */   "xxo": () => (/* reexport default from dynamic */ _images_icons_underline_svg__WEBPACK_IMPORTED_MODULE_19___default.a),
/* harmony export */   "dZu": () => (/* reexport default from dynamic */ _images_icons_strikethrough_svg__WEBPACK_IMPORTED_MODULE_20___default.a),
/* harmony export */   "NDg": () => (/* reexport default from dynamic */ _images_icons_highlight_svg__WEBPACK_IMPORTED_MODULE_21___default.a),
/* harmony export */   "IT9": () => (/* reexport default from dynamic */ _images_icons_trash_svg__WEBPACK_IMPORTED_MODULE_22___default.a),
/* harmony export */   "yl5": () => (/* reexport default from dynamic */ _images_icons_edit_svg__WEBPACK_IMPORTED_MODULE_23___default.a),
/* harmony export */   "D6v": () => (/* reexport default from dynamic */ _images_icons_arrow_left_svg__WEBPACK_IMPORTED_MODULE_24___default.a),
/* harmony export */   "Ec8": () => (/* reexport default from dynamic */ _images_icons_arrow_right_svg__WEBPACK_IMPORTED_MODULE_25___default.a),
/* harmony export */   "BDo": () => (/* reexport default from dynamic */ _images_icons_arrow_down_svg__WEBPACK_IMPORTED_MODULE_26___default.a),
/* harmony export */   "V_f": () => (/* reexport default from dynamic */ _images_icons_paragraph_svg__WEBPACK_IMPORTED_MODULE_27___default.a),
/* harmony export */   "voX": () => (/* reexport default from dynamic */ _images_icons_no_color_svg__WEBPACK_IMPORTED_MODULE_28___default.a),
/* harmony export */   "hID": () => (/* reexport default from dynamic */ _images_icons_align_left_svg__WEBPACK_IMPORTED_MODULE_31___default.a),
/* harmony export */   "k5Z": () => (/* reexport default from dynamic */ _images_icons_align_center_svg__WEBPACK_IMPORTED_MODULE_32___default.a),
/* harmony export */   "Qz9": () => (/* reexport default from dynamic */ _images_icons_align_right_svg__WEBPACK_IMPORTED_MODULE_33___default.a),
/* harmony export */   "ypk": () => (/* reexport default from dynamic */ _images_icons_align_justify_svg__WEBPACK_IMPORTED_MODULE_34___default.a),
/* harmony export */   "LO$": () => (/* reexport default from dynamic */ _images_icons_valign_top_svg__WEBPACK_IMPORTED_MODULE_35___default.a),
/* harmony export */   "_oX": () => (/* reexport default from dynamic */ _images_icons_valign_center_svg__WEBPACK_IMPORTED_MODULE_36___default.a),
/* harmony export */   "PKJ": () => (/* reexport default from dynamic */ _images_icons_valign_bottom_svg__WEBPACK_IMPORTED_MODULE_37___default.a),
/* harmony export */   "_Og": () => (/* reexport default from dynamic */ _images_icons_indent_svg__WEBPACK_IMPORTED_MODULE_38___default.a),
/* harmony export */   "lC3": () => (/* reexport default from dynamic */ _images_icons_outdent_svg__WEBPACK_IMPORTED_MODULE_39___default.a),
/* harmony export */   "SnY": () => (/* reexport default from dynamic */ _images_icons_clear_formatting_svg__WEBPACK_IMPORTED_MODULE_40___default.a),
/* harmony export */   "J59": () => (/* reexport default from dynamic */ _images_icons_list_circle_svg__WEBPACK_IMPORTED_MODULE_41___default.a),
/* harmony export */   "wE3": () => (/* reexport default from dynamic */ _images_icons_list_rectangle_svg__WEBPACK_IMPORTED_MODULE_42___default.a),
/* harmony export */   "m7c": () => (/* reexport default from dynamic */ _images_icons_list_star_svg__WEBPACK_IMPORTED_MODULE_43___default.a),
/* harmony export */   "gDF": () => (/* reexport default from dynamic */ _images_icons_list_dart_svg__WEBPACK_IMPORTED_MODULE_44___default.a),
/* harmony export */   "yDK": () => (/* reexport default from dynamic */ _images_icons_list_rounded_svg__WEBPACK_IMPORTED_MODULE_45___default.a),
/* harmony export */   "Oa8": () => (/* reexport default from dynamic */ _images_icons_list_arrow_svg__WEBPACK_IMPORTED_MODULE_46___default.a),
/* harmony export */   "gEd": () => (/* reexport default from dynamic */ _images_icons_list_diamond_svg__WEBPACK_IMPORTED_MODULE_47___default.a),
/* harmony export */   "sws": () => (/* reexport default from dynamic */ _images_icons_embed_align_left_svg__WEBPACK_IMPORTED_MODULE_48___default.a),
/* harmony export */   "fm": () => (/* reexport default from dynamic */ _images_icons_embed_align_center_svg__WEBPACK_IMPORTED_MODULE_49___default.a),
/* harmony export */   "vSI": () => (/* reexport default from dynamic */ _images_icons_embed_align_right_svg__WEBPACK_IMPORTED_MODULE_50___default.a),
/* harmony export */   "pV3": () => (/* reexport default from dynamic */ _images_icons_embed_align_fullwidth_svg__WEBPACK_IMPORTED_MODULE_51___default.a),
/* harmony export */   "cpC": () => (/* reexport default from dynamic */ _images_icons_add_row_svg__WEBPACK_IMPORTED_MODULE_52___default.a),
/* harmony export */   "InV": () => (/* reexport default from dynamic */ _images_icons_add_column_svg__WEBPACK_IMPORTED_MODULE_53___default.a),
/* harmony export */   "bMz": () => (/* reexport default from dynamic */ _images_icons_icon_close_svg__WEBPACK_IMPORTED_MODULE_55___default.a),
/* harmony export */   "kVp": () => (/* reexport default from dynamic */ _images_icons_quote_svg__WEBPACK_IMPORTED_MODULE_56___default.a),
/* harmony export */   "PWQ": () => (/* reexport default from dynamic */ _images_icons_audio_svg__WEBPACK_IMPORTED_MODULE_57___default.a),
/* harmony export */   "szK": () => (/* reexport default from dynamic */ _images_icons_document_svg__WEBPACK_IMPORTED_MODULE_58___default.a),
/* harmony export */   "OiJ": () => (/* reexport default from dynamic */ _images_icons_video_svg__WEBPACK_IMPORTED_MODULE_60___default.a),
/* harmony export */   "nqv": () => (/* reexport default from dynamic */ _images_icons_more_vertical_svg__WEBPACK_IMPORTED_MODULE_61___default.a),
/* harmony export */   "mrQ": () => (/* reexport default from dynamic */ _images_icons_file_other_svg__WEBPACK_IMPORTED_MODULE_62___default.a),
/* harmony export */   "seM": () => (/* reexport default from dynamic */ _images_icons_code_format_svg__WEBPACK_IMPORTED_MODULE_63___default.a),
/* harmony export */   "ed9": () => (/* reexport default from dynamic */ _images_icons_chevron_left_svg__WEBPACK_IMPORTED_MODULE_64___default.a),
/* harmony export */   "VG8": () => (/* reexport default from dynamic */ _images_icons_chevron_right_svg__WEBPACK_IMPORTED_MODULE_65___default.a),
/* harmony export */   "jVj": () => (/* reexport default from dynamic */ _images_icons_search2_svg__WEBPACK_IMPORTED_MODULE_66___default.a),
/* harmony export */   "kFg": () => (/* reexport default from dynamic */ _images_icons_audioRec_svg__WEBPACK_IMPORTED_MODULE_71___default.a),
/* harmony export */   "cx1": () => (/* reexport default from dynamic */ _images_icons_videoRec_svg__WEBPACK_IMPORTED_MODULE_72___default.a),
/* harmony export */   "EZi": () => (/* reexport default from dynamic */ _images_icons_done_color_svg__WEBPACK_IMPORTED_MODULE_78___default.a),
/* harmony export */   "STX": () => (/* reexport default from dynamic */ _images_icons_type_checkbox_svg__WEBPACK_IMPORTED_MODULE_79___default.a),
/* harmony export */   "SCs": () => (/* reexport default from dynamic */ _images_icons_type_currency_svg__WEBPACK_IMPORTED_MODULE_80___default.a),
/* harmony export */   "zLI": () => (/* reexport default from dynamic */ _images_icons_type_multiselect_svg__WEBPACK_IMPORTED_MODULE_81___default.a),
/* harmony export */   "uJ$": () => (/* reexport default from dynamic */ _images_icons_type_number_svg__WEBPACK_IMPORTED_MODULE_82___default.a),
/* harmony export */   "qlW": () => (/* reexport default from dynamic */ _images_icons_type_progress_svg__WEBPACK_IMPORTED_MODULE_83___default.a),
/* harmony export */   "Rd8": () => (/* reexport default from dynamic */ _images_icons_type_singleselect_svg__WEBPACK_IMPORTED_MODULE_84___default.a),
/* harmony export */   "JpT": () => (/* reexport default from dynamic */ _images_icons_type_text_svg__WEBPACK_IMPORTED_MODULE_85___default.a),
/* harmony export */   "UhQ": () => (/* reexport default from dynamic */ _images_icons_type_collaborator_svg__WEBPACK_IMPORTED_MODULE_87___default.a),
/* harmony export */   "vGU": () => (/* reexport default from dynamic */ _images_icons_type_mention_svg__WEBPACK_IMPORTED_MODULE_86___default.a),
/* harmony export */   "Yy4": () => (/* reexport default from dynamic */ _images_icons_type_date_svg__WEBPACK_IMPORTED_MODULE_88___default.a),
/* harmony export */   "eI7": () => (/* reexport default from dynamic */ _images_icons_type_attachment_svg__WEBPACK_IMPORTED_MODULE_89___default.a),
/* harmony export */   "$nO": () => (/* reexport default from dynamic */ _images_icons_type_link_svg__WEBPACK_IMPORTED_MODULE_90___default.a),
/* harmony export */   "_rK": () => (/* reexport default from dynamic */ _images_icons_type_rating_svg__WEBPACK_IMPORTED_MODULE_91___default.a),
/* harmony export */   "iLV": () => (/* reexport default from dynamic */ _images_icons_progress_simple_svg__WEBPACK_IMPORTED_MODULE_92___default.a),
/* harmony export */   "puQ": () => (/* reexport default from dynamic */ _images_icons_progress_colored_svg__WEBPACK_IMPORTED_MODULE_93___default.a),
/* harmony export */   "tZi": () => (/* reexport default from dynamic */ _images_icons_rating_star_light_svg__WEBPACK_IMPORTED_MODULE_94___default.a),
/* harmony export */   "xnp": () => (/* reexport default from dynamic */ _images_icons_rating_star_gray_svg__WEBPACK_IMPORTED_MODULE_95___default.a),
/* harmony export */   "l_R": () => (/* reexport default from dynamic */ _images_icons_rating_star_red_svg__WEBPACK_IMPORTED_MODULE_96___default.a),
/* harmony export */   "_rD": () => (/* reexport default from dynamic */ _images_icons_rating_star_blue_svg__WEBPACK_IMPORTED_MODULE_97___default.a),
/* harmony export */   "$Eb": () => (/* reexport default from dynamic */ _images_icons_rating_flag_light_svg__WEBPACK_IMPORTED_MODULE_98___default.a),
/* harmony export */   "ffD": () => (/* reexport default from dynamic */ _images_icons_rating_flag_gray_svg__WEBPACK_IMPORTED_MODULE_99___default.a),
/* harmony export */   "SVd": () => (/* reexport default from dynamic */ _images_icons_rating_flag_red_svg__WEBPACK_IMPORTED_MODULE_100___default.a),
/* harmony export */   "Ec4": () => (/* reexport default from dynamic */ _images_icons_rating_flag_blue_svg__WEBPACK_IMPORTED_MODULE_101___default.a),
/* harmony export */   "VRy": () => (/* reexport default from dynamic */ _images_icons_rating_heart_light_svg__WEBPACK_IMPORTED_MODULE_102___default.a),
/* harmony export */   "CSG": () => (/* reexport default from dynamic */ _images_icons_rating_heart_gray_svg__WEBPACK_IMPORTED_MODULE_103___default.a),
/* harmony export */   "hjt": () => (/* reexport default from dynamic */ _images_icons_rating_heart_red_svg__WEBPACK_IMPORTED_MODULE_104___default.a),
/* harmony export */   "OYV": () => (/* reexport default from dynamic */ _images_icons_rating_heart_blue_svg__WEBPACK_IMPORTED_MODULE_105___default.a),
/* harmony export */   "WcQ": () => (/* reexport default from dynamic */ _images_icons_cross_svg__WEBPACK_IMPORTED_MODULE_106___default.a),
/* harmony export */   "az_": () => (/* reexport default from dynamic */ _images_icons_alert_svg__WEBPACK_IMPORTED_MODULE_107___default.a),
/* harmony export */   "DjJ": () => (/* reexport default from dynamic */ _images_icons_download2_svg__WEBPACK_IMPORTED_MODULE_108___default.a),
/* harmony export */   "F1B": () => (/* reexport default from dynamic */ _images_icons_note_svg__WEBPACK_IMPORTED_MODULE_109___default.a),
/* harmony export */   "PUC": () => (/* reexport default from dynamic */ _images_icons_folder_svg__WEBPACK_IMPORTED_MODULE_110___default.a),
/* harmony export */   "FOt": () => (/* reexport default from dynamic */ _images_icons_workspace_svg__WEBPACK_IMPORTED_MODULE_111___default.a),
/* harmony export */   "LQ1": () => (/* reexport default from dynamic */ _images_icons_shared_svg__WEBPACK_IMPORTED_MODULE_112___default.a),
/* harmony export */   "dUh": () => (/* reexport default from dynamic */ _images_icons_favorites_svg__WEBPACK_IMPORTED_MODULE_113___default.a),
/* harmony export */   "ws": () => (/* reexport default from dynamic */ _images_icons_todo_svg__WEBPACK_IMPORTED_MODULE_114___default.a),
/* harmony export */   "UUr": () => (/* reexport default from dynamic */ _images_icons_syntax_svg__WEBPACK_IMPORTED_MODULE_115___default.a),
/* harmony export */   "guv": () => (/* reexport default from dynamic */ _images_icons_templates_svg__WEBPACK_IMPORTED_MODULE_116___default.a),
/* harmony export */   "BS3": () => (/* reexport default from dynamic */ _images_icons_question_svg__WEBPACK_IMPORTED_MODULE_117___default.a),
/* harmony export */   "HzO": () => (/* reexport default from dynamic */ _images_icons_sort_ascending_svg__WEBPACK_IMPORTED_MODULE_118___default.a),
/* harmony export */   "tXd": () => (/* reexport default from dynamic */ _images_icons_sort_descending_svg__WEBPACK_IMPORTED_MODULE_119___default.a),
/* harmony export */   "fan": () => (/* reexport default from dynamic */ _images_icons_mention_svg__WEBPACK_IMPORTED_MODULE_120___default.a),
/* harmony export */   "G40": () => (/* reexport default from dynamic */ _images_icons_tasks_svg__WEBPACK_IMPORTED_MODULE_121___default.a),
/* harmony export */   "RS2": () => (/* reexport default from dynamic */ _images_icons_outline_svg__WEBPACK_IMPORTED_MODULE_122___default.a),
/* harmony export */   "NOm": () => (/* reexport default from dynamic */ _images_icons_check_svg__WEBPACK_IMPORTED_MODULE_123___default.a),
/* harmony export */   "VYF": () => (/* reexport default from dynamic */ _images_icons_arrow_right_rounded_svg__WEBPACK_IMPORTED_MODULE_124___default.a),
/* harmony export */   "YK1": () => (/* reexport default from dynamic */ _images_icons_bell_svg__WEBPACK_IMPORTED_MODULE_125___default.a),
/* harmony export */   "jt6": () => (/* reexport default from dynamic */ _images_icons_calendar_svg__WEBPACK_IMPORTED_MODULE_126___default.a),
/* harmony export */   "CYl": () => (/* reexport default from dynamic */ _images_icons_cloud_error_svg__WEBPACK_IMPORTED_MODULE_127___default.a),
/* harmony export */   "g9E": () => (/* reexport default from dynamic */ _images_icons_embed_svg__WEBPACK_IMPORTED_MODULE_128___default.a),
/* harmony export */   "dhu": () => (/* reexport default from dynamic */ _images_icons_google_drive_svg__WEBPACK_IMPORTED_MODULE_129___default.a),
/* harmony export */   "GPC": () => (/* reexport default from dynamic */ _images_icons_people_svg__WEBPACK_IMPORTED_MODULE_130___default.a),
/* harmony export */   "$fB": () => (/* reexport default from dynamic */ _images_icons_back_button_svg__WEBPACK_IMPORTED_MODULE_131___default.a),
/* harmony export */   "v92": () => (/* reexport default from dynamic */ _images_icons_menu_more_down_svg__WEBPACK_IMPORTED_MODULE_132___default.a),
/* harmony export */   "J0H": () => (/* reexport default from dynamic */ _images_icons_list_collapse_svg__WEBPACK_IMPORTED_MODULE_133___default.a),
/* harmony export */   "bzs": () => (/* reexport default from dynamic */ _images_icons_placeholder_icon_svg__WEBPACK_IMPORTED_MODULE_134___default.a),
/* harmony export */   "BZM": () => (/* reexport default from dynamic */ _images_icons_bookmark_svg__WEBPACK_IMPORTED_MODULE_135___default.a),
/* harmony export */   "j4Y": () => (/* reexport default from dynamic */ _images_icons_url_svg__WEBPACK_IMPORTED_MODULE_136___default.a),
/* harmony export */   "Rwf": () => (/* reexport default from dynamic */ _images_icons_title_svg__WEBPACK_IMPORTED_MODULE_137___default.a),
/* harmony export */   "JVE": () => (/* reexport default from dynamic */ _images_icons_embed_b_svg__WEBPACK_IMPORTED_MODULE_138___default.a),
/* harmony export */   "zA_": () => (/* reexport default from dynamic */ _images_icons_youtube_svg__WEBPACK_IMPORTED_MODULE_139___default.a),
/* harmony export */   "kXu": () => (/* reexport default from dynamic */ _images_icons_google_maps_svg__WEBPACK_IMPORTED_MODULE_140___default.a),
/* harmony export */   "uSR": () => (/* reexport default from dynamic */ _images_icons_airtable_svg__WEBPACK_IMPORTED_MODULE_141___default.a),
/* harmony export */   "i2f": () => (/* reexport default from dynamic */ _images_icons_invision_svg__WEBPACK_IMPORTED_MODULE_142___default.a),
/* harmony export */   "JCH": () => (/* reexport default from dynamic */ _images_icons_figma_svg__WEBPACK_IMPORTED_MODULE_143___default.a),
/* harmony export */   "LC9": () => (/* reexport default from dynamic */ _images_icons_github_gist_svg__WEBPACK_IMPORTED_MODULE_144___default.a),
/* harmony export */   "JDv": () => (/* reexport default from dynamic */ _images_icons_twitter_svg__WEBPACK_IMPORTED_MODULE_145___default.a),
/* harmony export */   "qdP": () => (/* reexport default from dynamic */ _images_icons_typeform_svg__WEBPACK_IMPORTED_MODULE_146___default.a),
/* harmony export */   "Tz3": () => (/* reexport default from dynamic */ _images_icons_vimeo_svg__WEBPACK_IMPORTED_MODULE_147___default.a),
/* harmony export */   "ooQ": () => (/* reexport default from dynamic */ _images_icons_nimbus_svg__WEBPACK_IMPORTED_MODULE_148___default.a),
/* harmony export */   "bCE": () => (/* reexport default from dynamic */ _images_icons_upload_svg__WEBPACK_IMPORTED_MODULE_149___default.a),
/* harmony export */   "YIl": () => (/* reexport default from dynamic */ _images_icons_play_icon_svg__WEBPACK_IMPORTED_MODULE_150___default.a),
/* harmony export */   "qV0": () => (/* reexport default from dynamic */ _images_icons_pause_icon_svg__WEBPACK_IMPORTED_MODULE_151___default.a),
/* harmony export */   "ETU": () => (/* reexport default from dynamic */ _images_icons_record_icon_svg__WEBPACK_IMPORTED_MODULE_152___default.a),
/* harmony export */   "Sui": () => (/* reexport default from dynamic */ _images_icons_stop_icon_svg__WEBPACK_IMPORTED_MODULE_154___default.a),
/* harmony export */   "Jl4": () => (/* reexport default from dynamic */ _images_icons_remove_record_svg__WEBPACK_IMPORTED_MODULE_153___default.a),
/* harmony export */   "Y0K": () => (/* reexport default from dynamic */ _images_icons_screen_only_svg__WEBPACK_IMPORTED_MODULE_155___default.a),
/* harmony export */   "LEv": () => (/* reexport default from dynamic */ _images_icons_screen_cam_svg__WEBPACK_IMPORTED_MODULE_157___default.a),
/* harmony export */   "vw4": () => (/* reexport default from dynamic */ _images_icons_cam_only_svg__WEBPACK_IMPORTED_MODULE_156___default.a),
/* harmony export */   "R4$": () => (/* reexport default from dynamic */ _images_icons_screen_only_active_svg__WEBPACK_IMPORTED_MODULE_158___default.a),
/* harmony export */   "RGc": () => (/* reexport default from dynamic */ _images_icons_screen_cam_active_svg__WEBPACK_IMPORTED_MODULE_160___default.a),
/* harmony export */   "ShA": () => (/* reexport default from dynamic */ _images_icons_cam_only_active_svg__WEBPACK_IMPORTED_MODULE_159___default.a),
/* harmony export */   "BKE": () => (/* reexport default from dynamic */ _images_icons_soundOn_svg__WEBPACK_IMPORTED_MODULE_161___default.a),
/* harmony export */   "JfY": () => (/* reexport default from dynamic */ _images_icons_soundOff_svg__WEBPACK_IMPORTED_MODULE_162___default.a),
/* harmony export */   "_CN": () => (/* reexport default from dynamic */ _images_icons_full_width_mode_svg__WEBPACK_IMPORTED_MODULE_163___default.a),
/* harmony export */   "DgX": () => (/* reexport default from dynamic */ _images_icons_pin_button_svg__WEBPACK_IMPORTED_MODULE_164___default.a),
/* harmony export */   "uII": () => (/* reexport default from dynamic */ _images_icons_unpin_button_svg__WEBPACK_IMPORTED_MODULE_165___default.a),
/* harmony export */   "TSJ": () => (/* reexport default from dynamic */ _images_icons_lock_hover_svg__WEBPACK_IMPORTED_MODULE_167___default.a),
/* harmony export */   "_V1": () => (/* reexport default from dynamic */ _images_icons_lock_svg__WEBPACK_IMPORTED_MODULE_166___default.a),
/* harmony export */   "uyk": () => (/* reexport default from dynamic */ _images_icons_create_note_svg__WEBPACK_IMPORTED_MODULE_168___default.a),
/* harmony export */   "e4s": () => (/* reexport default from dynamic */ _images_icons_create_folder_svg__WEBPACK_IMPORTED_MODULE_169___default.a),
/* harmony export */   "ge4": () => (/* reexport default from dynamic */ _images_icons_comment_svg__WEBPACK_IMPORTED_MODULE_170___default.a),
/* harmony export */   "qE2": () => (/* reexport default from dynamic */ _images_icons_hint_svg__WEBPACK_IMPORTED_MODULE_171___default.a),
/* harmony export */   "hU": () => (/* reexport default from dynamic */ _images_icons_button_svg__WEBPACK_IMPORTED_MODULE_173___default.a),
/* harmony export */   "pj0": () => (/* reexport default from dynamic */ _images_icons_edit_video_svg__WEBPACK_IMPORTED_MODULE_175___default.a),
/* harmony export */   "LU4": () => (/* reexport default from dynamic */ _images_icons_paragraph_2_svg__WEBPACK_IMPORTED_MODULE_176___default.a),
/* harmony export */   "CZw": () => (/* reexport default from dynamic */ _images_icons_add_comment_svg__WEBPACK_IMPORTED_MODULE_177___default.a),
/* harmony export */   "_Ts": () => (/* reexport default from dynamic */ _images_icons_watch_again_svg__WEBPACK_IMPORTED_MODULE_178___default.a),
/* harmony export */   "oe4": () => (/* reexport default from dynamic */ _images_icons_toggle_svg__WEBPACK_IMPORTED_MODULE_179___default.a),
/* harmony export */   "$Nx": () => (/* reexport default from dynamic */ _images_icons_checklist_svg__WEBPACK_IMPORTED_MODULE_180___default.a),
/* harmony export */   "hoH": () => (/* reexport default from dynamic */ _images_icons_player_download_svg__WEBPACK_IMPORTED_MODULE_181___default.a),
/* harmony export */   "THL": () => (/* reexport default from dynamic */ _images_icons_large_header_toggle_svg__WEBPACK_IMPORTED_MODULE_182___default.a),
/* harmony export */   "V6h": () => (/* reexport default from dynamic */ _images_icons_medium_header_toggle_svg__WEBPACK_IMPORTED_MODULE_183___default.a),
/* harmony export */   "gM0": () => (/* reexport default from dynamic */ _images_icons_small_header_toggle_svg__WEBPACK_IMPORTED_MODULE_184___default.a),
/* harmony export */   "eYc": () => (/* reexport default from dynamic */ _images_icons_columns_svg__WEBPACK_IMPORTED_MODULE_186___default.a),
/* harmony export */   "eOv": () => (/* reexport default from dynamic */ _images_icons_default_color_icon_svg__WEBPACK_IMPORTED_MODULE_187___default.a),
/* harmony export */   "_9F": () => (/* reexport default from dynamic */ _images_icons_template_icon_svg__WEBPACK_IMPORTED_MODULE_188___default.a),
/* harmony export */   "F2P": () => (/* reexport default from dynamic */ _images_icons_file_icon_svg__WEBPACK_IMPORTED_MODULE_190___default.a),
/* harmony export */   "n4p": () => (/* reexport default from dynamic */ _images_icons_link_diag_svg__WEBPACK_IMPORTED_MODULE_191___default.a),
/* harmony export */   "Rz4": () => (/* reexport default from dynamic */ _images_icons_feedback_svg__WEBPACK_IMPORTED_MODULE_192___default.a),
/* harmony export */   "M64": () => (/* reexport default from dynamic */ _images_icons_support_svg__WEBPACK_IMPORTED_MODULE_193___default.a),
/* harmony export */   "jhZ": () => (/* reexport default from dynamic */ _images_icons_learn_svg__WEBPACK_IMPORTED_MODULE_194___default.a),
/* harmony export */   "k8B": () => (/* reexport default from dynamic */ _images_icons_miro_svg__WEBPACK_IMPORTED_MODULE_195___default.a),
/* harmony export */   "OQ8": () => (/* reexport default from dynamic */ _images_icons_database_svg__WEBPACK_IMPORTED_MODULE_196___default.a),
/* harmony export */   "wHY": () => (/* reexport default from dynamic */ _images_icons_filter_svg__WEBPACK_IMPORTED_MODULE_197___default.a),
/* harmony export */   "ve2": () => (/* reexport default from dynamic */ _images_icons_board_svg__WEBPACK_IMPORTED_MODULE_198___default.a),
/* harmony export */   "Gw5": () => (/* reexport default from dynamic */ _images_icons_progress_svg__WEBPACK_IMPORTED_MODULE_199___default.a),
/* harmony export */   "zxW": () => (/* reexport default from dynamic */ _images_icons_comment_new_svg__WEBPACK_IMPORTED_MODULE_200___default.a),
/* harmony export */   "nST": () => (/* reexport default from dynamic */ _images_icons_promt_icon_svg__WEBPACK_IMPORTED_MODULE_201___default.a),
/* harmony export */   "JKM": () => (/* reexport default from dynamic */ _images_icons_sync_svg__WEBPACK_IMPORTED_MODULE_202___default.a),
/* harmony export */   "QPj": () => (/* reexport default from dynamic */ _images_icons_done_svg__WEBPACK_IMPORTED_MODULE_203___default.a),
/* harmony export */   "c3b": () => (/* reexport default from dynamic */ _images_icons_ai_help_svg__WEBPACK_IMPORTED_MODULE_204___default.a),
/* harmony export */   "qHO": () => (/* reexport default from dynamic */ _images_icons_ai_cta_svg__WEBPACK_IMPORTED_MODULE_205___default.a),
/* harmony export */   "j0X": () => (/* reexport default from dynamic */ _images_icons_ai_explain_svg__WEBPACK_IMPORTED_MODULE_206___default.a),
/* harmony export */   "F6w": () => (/* reexport default from dynamic */ _images_icons_ai_improve_svg__WEBPACK_IMPORTED_MODULE_207___default.a),
/* harmony export */   "Z8B": () => (/* reexport default from dynamic */ _images_icons_ai_longer_svg__WEBPACK_IMPORTED_MODULE_208___default.a),
/* harmony export */   "rXf": () => (/* reexport default from dynamic */ _images_icons_ai_shorter_svg__WEBPACK_IMPORTED_MODULE_209___default.a),
/* harmony export */   "Lan": () => (/* reexport default from dynamic */ _images_icons_ai_spelling_svg__WEBPACK_IMPORTED_MODULE_210___default.a),
/* harmony export */   "vO": () => (/* reexport default from dynamic */ _images_icons_ai_summarize_svg__WEBPACK_IMPORTED_MODULE_211___default.a),
/* harmony export */   "hFX": () => (/* reexport default from dynamic */ _images_icons_replace_svg__WEBPACK_IMPORTED_MODULE_212___default.a),
/* harmony export */   "WLL": () => (/* reexport default from dynamic */ _images_icons_icon_arrow_up_svg__WEBPACK_IMPORTED_MODULE_213___default.a),
/* harmony export */   "DKw": () => (/* reexport default from dynamic */ _images_icons_icon_arrow_down_svg__WEBPACK_IMPORTED_MODULE_214___default.a),
/* harmony export */   "vUr": () => (/* reexport default from dynamic */ _images_icons_copy_svg__WEBPACK_IMPORTED_MODULE_216___default.a),
/* harmony export */   "tuc": () => (/* reexport default from dynamic */ _images_icons_step_svg__WEBPACK_IMPORTED_MODULE_218___default.a),
/* harmony export */   "aJY": () => (/* reexport default from dynamic */ _images_icons_player_transcript_svg__WEBPACK_IMPORTED_MODULE_219___default.a),
/* harmony export */   "KLP": () => (/* reexport default from dynamic */ _images_icons_file_check_alt_svg__WEBPACK_IMPORTED_MODULE_220___default.a),
/* harmony export */   "S1t": () => (/* reexport default from dynamic */ _images_icons_user_pen_alt_svg__WEBPACK_IMPORTED_MODULE_221___default.a),
/* harmony export */   "GK": () => (/* reexport default from dynamic */ _images_icons_star_svg__WEBPACK_IMPORTED_MODULE_222___default.a),
/* harmony export */   "WL1": () => (/* reexport default from dynamic */ _images_icons_undo_svg__WEBPACK_IMPORTED_MODULE_223___default.a),
/* harmony export */   "M1S": () => (/* reexport default from dynamic */ _images_icons_redo_svg__WEBPACK_IMPORTED_MODULE_224___default.a),
/* harmony export */   "TRY": () => (/* reexport default from dynamic */ _images_icons_pencil_svg__WEBPACK_IMPORTED_MODULE_225___default.a),
/* harmony export */   "kyG": () => (/* reexport default from dynamic */ _images_icons_eye_open_svg__WEBPACK_IMPORTED_MODULE_226___default.a),
/* harmony export */   "SMA": () => (/* reexport default from dynamic */ _images_icons_eye_closed_svg__WEBPACK_IMPORTED_MODULE_227___default.a),
/* harmony export */   "$4n": () => (/* reexport default from dynamic */ _images_icons_user_plus_svg__WEBPACK_IMPORTED_MODULE_228___default.a),
/* harmony export */   "ry0": () => (/* reexport default from dynamic */ _images_icons_checkbox_checked_svg__WEBPACK_IMPORTED_MODULE_229___default.a)
/* harmony export */ });
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79758);
/* harmony import */ var _images_icons_checkbox_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98892);
/* harmony import */ var _images_icons_checkbox_svg__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_images_icons_checkbox_svg__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _images_icons_list_number_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47238);
/* harmony import */ var _images_icons_list_number_svg__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_number_svg__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _images_icons_list_bullet_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95161);
/* harmony import */ var _images_icons_list_bullet_svg__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_bullet_svg__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _images_icons_table_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20913);
/* harmony import */ var _images_icons_table_svg__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_images_icons_table_svg__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _images_icons_smile_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37620);
/* harmony import */ var _images_icons_smile_svg__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_images_icons_smile_svg__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _images_icons_image_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50375);
/* harmony import */ var _images_icons_image_svg__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_images_icons_image_svg__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _images_icons_empty_image_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80648);
/* harmony import */ var _images_icons_empty_image_svg__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_images_icons_empty_image_svg__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _images_icons_file_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7086);
/* harmony import */ var _images_icons_file_svg__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_images_icons_file_svg__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _images_icons_pin_btn_svg__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4421);
/* harmony import */ var _images_icons_pin_btn_svg__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_images_icons_pin_btn_svg__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _images_icons_header_small_svg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70191);
/* harmony import */ var _images_icons_header_small_svg__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_images_icons_header_small_svg__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _images_icons_header_medium_svg__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(41701);
/* harmony import */ var _images_icons_header_medium_svg__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_images_icons_header_medium_svg__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _images_icons_header_large_svg__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1305);
/* harmony import */ var _images_icons_header_large_svg__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_images_icons_header_large_svg__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _images_icons_hline_svg__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(28444);
/* harmony import */ var _images_icons_hline_svg__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_images_icons_hline_svg__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _images_icons_link_svg__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(60623);
/* harmony import */ var _images_icons_link_svg__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_images_icons_link_svg__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _images_icons_plus_svg__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(36520);
/* harmony import */ var _images_icons_plus_svg__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_images_icons_plus_svg__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _images_icons_minus_svg__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(31958);
/* harmony import */ var _images_icons_minus_svg__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_images_icons_minus_svg__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _images_icons_bold_svg__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(69425);
/* harmony import */ var _images_icons_bold_svg__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_images_icons_bold_svg__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _images_icons_italic_svg__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(34061);
/* harmony import */ var _images_icons_italic_svg__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_images_icons_italic_svg__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _images_icons_underline_svg__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(78555);
/* harmony import */ var _images_icons_underline_svg__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_images_icons_underline_svg__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _images_icons_strikethrough_svg__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(27501);
/* harmony import */ var _images_icons_strikethrough_svg__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_images_icons_strikethrough_svg__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _images_icons_highlight_svg__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(81740);
/* harmony import */ var _images_icons_highlight_svg__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_images_icons_highlight_svg__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _images_icons_trash_svg__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(77242);
/* harmony import */ var _images_icons_trash_svg__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_images_icons_trash_svg__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _images_icons_edit_svg__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(13783);
/* harmony import */ var _images_icons_edit_svg__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_images_icons_edit_svg__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _images_icons_arrow_left_svg__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(61177);
/* harmony import */ var _images_icons_arrow_left_svg__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_images_icons_arrow_left_svg__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _images_icons_arrow_right_svg__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(83675);
/* harmony import */ var _images_icons_arrow_right_svg__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_images_icons_arrow_right_svg__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _images_icons_arrow_down_svg__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(19379);
/* harmony import */ var _images_icons_arrow_down_svg__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_images_icons_arrow_down_svg__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _images_icons_paragraph_svg__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(36419);
/* harmony import */ var _images_icons_paragraph_svg__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_images_icons_paragraph_svg__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _images_icons_no_color_svg__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(42477);
/* harmony import */ var _images_icons_no_color_svg__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_images_icons_no_color_svg__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _images_icons_no_color_light_svg__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(99562);
/* harmony import */ var _images_icons_no_color_light_svg__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_images_icons_no_color_light_svg__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _images_icons_no_color_dark_svg__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(36771);
/* harmony import */ var _images_icons_no_color_dark_svg__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_images_icons_no_color_dark_svg__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _images_icons_align_left_svg__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(35596);
/* harmony import */ var _images_icons_align_left_svg__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_images_icons_align_left_svg__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _images_icons_align_center_svg__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(87163);
/* harmony import */ var _images_icons_align_center_svg__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_images_icons_align_center_svg__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _images_icons_align_right_svg__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(4802);
/* harmony import */ var _images_icons_align_right_svg__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_images_icons_align_right_svg__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _images_icons_align_justify_svg__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(36842);
/* harmony import */ var _images_icons_align_justify_svg__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_images_icons_align_justify_svg__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _images_icons_valign_top_svg__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(10226);
/* harmony import */ var _images_icons_valign_top_svg__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_images_icons_valign_top_svg__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _images_icons_valign_center_svg__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(52725);
/* harmony import */ var _images_icons_valign_center_svg__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(_images_icons_valign_center_svg__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var _images_icons_valign_bottom_svg__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(59146);
/* harmony import */ var _images_icons_valign_bottom_svg__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(_images_icons_valign_bottom_svg__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var _images_icons_indent_svg__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(11894);
/* harmony import */ var _images_icons_indent_svg__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(_images_icons_indent_svg__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var _images_icons_outdent_svg__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(7306);
/* harmony import */ var _images_icons_outdent_svg__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(_images_icons_outdent_svg__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var _images_icons_clear_formatting_svg__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(57872);
/* harmony import */ var _images_icons_clear_formatting_svg__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(_images_icons_clear_formatting_svg__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var _images_icons_list_circle_svg__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(30350);
/* harmony import */ var _images_icons_list_circle_svg__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_circle_svg__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var _images_icons_list_rectangle_svg__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(56987);
/* harmony import */ var _images_icons_list_rectangle_svg__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_rectangle_svg__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var _images_icons_list_star_svg__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(60965);
/* harmony import */ var _images_icons_list_star_svg__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_star_svg__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var _images_icons_list_dart_svg__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(35235);
/* harmony import */ var _images_icons_list_dart_svg__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_dart_svg__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var _images_icons_list_rounded_svg__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(74107);
/* harmony import */ var _images_icons_list_rounded_svg__WEBPACK_IMPORTED_MODULE_45___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_rounded_svg__WEBPACK_IMPORTED_MODULE_45__);
/* harmony import */ var _images_icons_list_arrow_svg__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(12479);
/* harmony import */ var _images_icons_list_arrow_svg__WEBPACK_IMPORTED_MODULE_46___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_arrow_svg__WEBPACK_IMPORTED_MODULE_46__);
/* harmony import */ var _images_icons_list_diamond_svg__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(59481);
/* harmony import */ var _images_icons_list_diamond_svg__WEBPACK_IMPORTED_MODULE_47___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_diamond_svg__WEBPACK_IMPORTED_MODULE_47__);
/* harmony import */ var _images_icons_embed_align_left_svg__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(54970);
/* harmony import */ var _images_icons_embed_align_left_svg__WEBPACK_IMPORTED_MODULE_48___default = /*#__PURE__*/__webpack_require__.n(_images_icons_embed_align_left_svg__WEBPACK_IMPORTED_MODULE_48__);
/* harmony import */ var _images_icons_embed_align_center_svg__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(55782);
/* harmony import */ var _images_icons_embed_align_center_svg__WEBPACK_IMPORTED_MODULE_49___default = /*#__PURE__*/__webpack_require__.n(_images_icons_embed_align_center_svg__WEBPACK_IMPORTED_MODULE_49__);
/* harmony import */ var _images_icons_embed_align_right_svg__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(51093);
/* harmony import */ var _images_icons_embed_align_right_svg__WEBPACK_IMPORTED_MODULE_50___default = /*#__PURE__*/__webpack_require__.n(_images_icons_embed_align_right_svg__WEBPACK_IMPORTED_MODULE_50__);
/* harmony import */ var _images_icons_embed_align_fullwidth_svg__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(47529);
/* harmony import */ var _images_icons_embed_align_fullwidth_svg__WEBPACK_IMPORTED_MODULE_51___default = /*#__PURE__*/__webpack_require__.n(_images_icons_embed_align_fullwidth_svg__WEBPACK_IMPORTED_MODULE_51__);
/* harmony import */ var _images_icons_add_row_svg__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(30245);
/* harmony import */ var _images_icons_add_row_svg__WEBPACK_IMPORTED_MODULE_52___default = /*#__PURE__*/__webpack_require__.n(_images_icons_add_row_svg__WEBPACK_IMPORTED_MODULE_52__);
/* harmony import */ var _images_icons_add_column_svg__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(22032);
/* harmony import */ var _images_icons_add_column_svg__WEBPACK_IMPORTED_MODULE_53___default = /*#__PURE__*/__webpack_require__.n(_images_icons_add_column_svg__WEBPACK_IMPORTED_MODULE_53__);
/* harmony import */ var _images_icons_resize_svg__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(91323);
/* harmony import */ var _images_icons_resize_svg__WEBPACK_IMPORTED_MODULE_54___default = /*#__PURE__*/__webpack_require__.n(_images_icons_resize_svg__WEBPACK_IMPORTED_MODULE_54__);
/* harmony import */ var _images_icons_icon_close_svg__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(66995);
/* harmony import */ var _images_icons_icon_close_svg__WEBPACK_IMPORTED_MODULE_55___default = /*#__PURE__*/__webpack_require__.n(_images_icons_icon_close_svg__WEBPACK_IMPORTED_MODULE_55__);
/* harmony import */ var _images_icons_quote_svg__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(67308);
/* harmony import */ var _images_icons_quote_svg__WEBPACK_IMPORTED_MODULE_56___default = /*#__PURE__*/__webpack_require__.n(_images_icons_quote_svg__WEBPACK_IMPORTED_MODULE_56__);
/* harmony import */ var _images_icons_audio_svg__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(4817);
/* harmony import */ var _images_icons_audio_svg__WEBPACK_IMPORTED_MODULE_57___default = /*#__PURE__*/__webpack_require__.n(_images_icons_audio_svg__WEBPACK_IMPORTED_MODULE_57__);
/* harmony import */ var _images_icons_document_svg__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(41286);
/* harmony import */ var _images_icons_document_svg__WEBPACK_IMPORTED_MODULE_58___default = /*#__PURE__*/__webpack_require__.n(_images_icons_document_svg__WEBPACK_IMPORTED_MODULE_58__);
/* harmony import */ var _images_icons_image2_svg__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(93034);
/* harmony import */ var _images_icons_image2_svg__WEBPACK_IMPORTED_MODULE_59___default = /*#__PURE__*/__webpack_require__.n(_images_icons_image2_svg__WEBPACK_IMPORTED_MODULE_59__);
/* harmony import */ var _images_icons_video_svg__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(22220);
/* harmony import */ var _images_icons_video_svg__WEBPACK_IMPORTED_MODULE_60___default = /*#__PURE__*/__webpack_require__.n(_images_icons_video_svg__WEBPACK_IMPORTED_MODULE_60__);
/* harmony import */ var _images_icons_more_vertical_svg__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(46605);
/* harmony import */ var _images_icons_more_vertical_svg__WEBPACK_IMPORTED_MODULE_61___default = /*#__PURE__*/__webpack_require__.n(_images_icons_more_vertical_svg__WEBPACK_IMPORTED_MODULE_61__);
/* harmony import */ var _images_icons_file_other_svg__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(51392);
/* harmony import */ var _images_icons_file_other_svg__WEBPACK_IMPORTED_MODULE_62___default = /*#__PURE__*/__webpack_require__.n(_images_icons_file_other_svg__WEBPACK_IMPORTED_MODULE_62__);
/* harmony import */ var _images_icons_code_format_svg__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(47778);
/* harmony import */ var _images_icons_code_format_svg__WEBPACK_IMPORTED_MODULE_63___default = /*#__PURE__*/__webpack_require__.n(_images_icons_code_format_svg__WEBPACK_IMPORTED_MODULE_63__);
/* harmony import */ var _images_icons_chevron_left_svg__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(47904);
/* harmony import */ var _images_icons_chevron_left_svg__WEBPACK_IMPORTED_MODULE_64___default = /*#__PURE__*/__webpack_require__.n(_images_icons_chevron_left_svg__WEBPACK_IMPORTED_MODULE_64__);
/* harmony import */ var _images_icons_chevron_right_svg__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(16186);
/* harmony import */ var _images_icons_chevron_right_svg__WEBPACK_IMPORTED_MODULE_65___default = /*#__PURE__*/__webpack_require__.n(_images_icons_chevron_right_svg__WEBPACK_IMPORTED_MODULE_65__);
/* harmony import */ var _images_icons_search2_svg__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(26350);
/* harmony import */ var _images_icons_search2_svg__WEBPACK_IMPORTED_MODULE_66___default = /*#__PURE__*/__webpack_require__.n(_images_icons_search2_svg__WEBPACK_IMPORTED_MODULE_66__);
/* harmony import */ var _images_icons_maximize_svg__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(29828);
/* harmony import */ var _images_icons_maximize_svg__WEBPACK_IMPORTED_MODULE_67___default = /*#__PURE__*/__webpack_require__.n(_images_icons_maximize_svg__WEBPACK_IMPORTED_MODULE_67__);
/* harmony import */ var _images_icons_minimize_svg__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(63821);
/* harmony import */ var _images_icons_minimize_svg__WEBPACK_IMPORTED_MODULE_68___default = /*#__PURE__*/__webpack_require__.n(_images_icons_minimize_svg__WEBPACK_IMPORTED_MODULE_68__);
/* harmony import */ var _images_icons_pause_svg__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(26143);
/* harmony import */ var _images_icons_pause_svg__WEBPACK_IMPORTED_MODULE_69___default = /*#__PURE__*/__webpack_require__.n(_images_icons_pause_svg__WEBPACK_IMPORTED_MODULE_69__);
/* harmony import */ var _images_icons_play_svg__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(1250);
/* harmony import */ var _images_icons_play_svg__WEBPACK_IMPORTED_MODULE_70___default = /*#__PURE__*/__webpack_require__.n(_images_icons_play_svg__WEBPACK_IMPORTED_MODULE_70__);
/* harmony import */ var _images_icons_audioRec_svg__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(69710);
/* harmony import */ var _images_icons_audioRec_svg__WEBPACK_IMPORTED_MODULE_71___default = /*#__PURE__*/__webpack_require__.n(_images_icons_audioRec_svg__WEBPACK_IMPORTED_MODULE_71__);
/* harmony import */ var _images_icons_videoRec_svg__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(27237);
/* harmony import */ var _images_icons_videoRec_svg__WEBPACK_IMPORTED_MODULE_72___default = /*#__PURE__*/__webpack_require__.n(_images_icons_videoRec_svg__WEBPACK_IMPORTED_MODULE_72__);
/* harmony import */ var _images_icons_pause_big_svg__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(46015);
/* harmony import */ var _images_icons_pause_big_svg__WEBPACK_IMPORTED_MODULE_73___default = /*#__PURE__*/__webpack_require__.n(_images_icons_pause_big_svg__WEBPACK_IMPORTED_MODULE_73__);
/* harmony import */ var _images_icons_play_big_svg__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(69499);
/* harmony import */ var _images_icons_play_big_svg__WEBPACK_IMPORTED_MODULE_74___default = /*#__PURE__*/__webpack_require__.n(_images_icons_play_big_svg__WEBPACK_IMPORTED_MODULE_74__);
/* harmony import */ var _images_icons_volume_1_svg__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(4311);
/* harmony import */ var _images_icons_volume_1_svg__WEBPACK_IMPORTED_MODULE_75___default = /*#__PURE__*/__webpack_require__.n(_images_icons_volume_1_svg__WEBPACK_IMPORTED_MODULE_75__);
/* harmony import */ var _images_icons_volume_2_svg__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(84005);
/* harmony import */ var _images_icons_volume_2_svg__WEBPACK_IMPORTED_MODULE_76___default = /*#__PURE__*/__webpack_require__.n(_images_icons_volume_2_svg__WEBPACK_IMPORTED_MODULE_76__);
/* harmony import */ var _images_icons_volume_x_svg__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(80347);
/* harmony import */ var _images_icons_volume_x_svg__WEBPACK_IMPORTED_MODULE_77___default = /*#__PURE__*/__webpack_require__.n(_images_icons_volume_x_svg__WEBPACK_IMPORTED_MODULE_77__);
/* harmony import */ var _images_icons_done_color_svg__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(91177);
/* harmony import */ var _images_icons_done_color_svg__WEBPACK_IMPORTED_MODULE_78___default = /*#__PURE__*/__webpack_require__.n(_images_icons_done_color_svg__WEBPACK_IMPORTED_MODULE_78__);
/* harmony import */ var _images_icons_type_checkbox_svg__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(64631);
/* harmony import */ var _images_icons_type_checkbox_svg__WEBPACK_IMPORTED_MODULE_79___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_checkbox_svg__WEBPACK_IMPORTED_MODULE_79__);
/* harmony import */ var _images_icons_type_currency_svg__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(325);
/* harmony import */ var _images_icons_type_currency_svg__WEBPACK_IMPORTED_MODULE_80___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_currency_svg__WEBPACK_IMPORTED_MODULE_80__);
/* harmony import */ var _images_icons_type_multiselect_svg__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(12154);
/* harmony import */ var _images_icons_type_multiselect_svg__WEBPACK_IMPORTED_MODULE_81___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_multiselect_svg__WEBPACK_IMPORTED_MODULE_81__);
/* harmony import */ var _images_icons_type_number_svg__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(39046);
/* harmony import */ var _images_icons_type_number_svg__WEBPACK_IMPORTED_MODULE_82___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_number_svg__WEBPACK_IMPORTED_MODULE_82__);
/* harmony import */ var _images_icons_type_progress_svg__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(92702);
/* harmony import */ var _images_icons_type_progress_svg__WEBPACK_IMPORTED_MODULE_83___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_progress_svg__WEBPACK_IMPORTED_MODULE_83__);
/* harmony import */ var _images_icons_type_singleselect_svg__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(56486);
/* harmony import */ var _images_icons_type_singleselect_svg__WEBPACK_IMPORTED_MODULE_84___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_singleselect_svg__WEBPACK_IMPORTED_MODULE_84__);
/* harmony import */ var _images_icons_type_text_svg__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(85265);
/* harmony import */ var _images_icons_type_text_svg__WEBPACK_IMPORTED_MODULE_85___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_text_svg__WEBPACK_IMPORTED_MODULE_85__);
/* harmony import */ var _images_icons_type_mention_svg__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(66339);
/* harmony import */ var _images_icons_type_mention_svg__WEBPACK_IMPORTED_MODULE_86___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_mention_svg__WEBPACK_IMPORTED_MODULE_86__);
/* harmony import */ var _images_icons_type_collaborator_svg__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(33753);
/* harmony import */ var _images_icons_type_collaborator_svg__WEBPACK_IMPORTED_MODULE_87___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_collaborator_svg__WEBPACK_IMPORTED_MODULE_87__);
/* harmony import */ var _images_icons_type_date_svg__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(24655);
/* harmony import */ var _images_icons_type_date_svg__WEBPACK_IMPORTED_MODULE_88___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_date_svg__WEBPACK_IMPORTED_MODULE_88__);
/* harmony import */ var _images_icons_type_attachment_svg__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(93858);
/* harmony import */ var _images_icons_type_attachment_svg__WEBPACK_IMPORTED_MODULE_89___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_attachment_svg__WEBPACK_IMPORTED_MODULE_89__);
/* harmony import */ var _images_icons_type_link_svg__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(52124);
/* harmony import */ var _images_icons_type_link_svg__WEBPACK_IMPORTED_MODULE_90___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_link_svg__WEBPACK_IMPORTED_MODULE_90__);
/* harmony import */ var _images_icons_type_rating_svg__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__(21685);
/* harmony import */ var _images_icons_type_rating_svg__WEBPACK_IMPORTED_MODULE_91___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_rating_svg__WEBPACK_IMPORTED_MODULE_91__);
/* harmony import */ var _images_icons_progress_simple_svg__WEBPACK_IMPORTED_MODULE_92__ = __webpack_require__(49962);
/* harmony import */ var _images_icons_progress_simple_svg__WEBPACK_IMPORTED_MODULE_92___default = /*#__PURE__*/__webpack_require__.n(_images_icons_progress_simple_svg__WEBPACK_IMPORTED_MODULE_92__);
/* harmony import */ var _images_icons_progress_colored_svg__WEBPACK_IMPORTED_MODULE_93__ = __webpack_require__(14211);
/* harmony import */ var _images_icons_progress_colored_svg__WEBPACK_IMPORTED_MODULE_93___default = /*#__PURE__*/__webpack_require__.n(_images_icons_progress_colored_svg__WEBPACK_IMPORTED_MODULE_93__);
/* harmony import */ var _images_icons_rating_star_light_svg__WEBPACK_IMPORTED_MODULE_94__ = __webpack_require__(4735);
/* harmony import */ var _images_icons_rating_star_light_svg__WEBPACK_IMPORTED_MODULE_94___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_star_light_svg__WEBPACK_IMPORTED_MODULE_94__);
/* harmony import */ var _images_icons_rating_star_gray_svg__WEBPACK_IMPORTED_MODULE_95__ = __webpack_require__(75851);
/* harmony import */ var _images_icons_rating_star_gray_svg__WEBPACK_IMPORTED_MODULE_95___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_star_gray_svg__WEBPACK_IMPORTED_MODULE_95__);
/* harmony import */ var _images_icons_rating_star_red_svg__WEBPACK_IMPORTED_MODULE_96__ = __webpack_require__(76936);
/* harmony import */ var _images_icons_rating_star_red_svg__WEBPACK_IMPORTED_MODULE_96___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_star_red_svg__WEBPACK_IMPORTED_MODULE_96__);
/* harmony import */ var _images_icons_rating_star_blue_svg__WEBPACK_IMPORTED_MODULE_97__ = __webpack_require__(37322);
/* harmony import */ var _images_icons_rating_star_blue_svg__WEBPACK_IMPORTED_MODULE_97___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_star_blue_svg__WEBPACK_IMPORTED_MODULE_97__);
/* harmony import */ var _images_icons_rating_flag_light_svg__WEBPACK_IMPORTED_MODULE_98__ = __webpack_require__(98763);
/* harmony import */ var _images_icons_rating_flag_light_svg__WEBPACK_IMPORTED_MODULE_98___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_flag_light_svg__WEBPACK_IMPORTED_MODULE_98__);
/* harmony import */ var _images_icons_rating_flag_gray_svg__WEBPACK_IMPORTED_MODULE_99__ = __webpack_require__(80764);
/* harmony import */ var _images_icons_rating_flag_gray_svg__WEBPACK_IMPORTED_MODULE_99___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_flag_gray_svg__WEBPACK_IMPORTED_MODULE_99__);
/* harmony import */ var _images_icons_rating_flag_red_svg__WEBPACK_IMPORTED_MODULE_100__ = __webpack_require__(55009);
/* harmony import */ var _images_icons_rating_flag_red_svg__WEBPACK_IMPORTED_MODULE_100___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_flag_red_svg__WEBPACK_IMPORTED_MODULE_100__);
/* harmony import */ var _images_icons_rating_flag_blue_svg__WEBPACK_IMPORTED_MODULE_101__ = __webpack_require__(8507);
/* harmony import */ var _images_icons_rating_flag_blue_svg__WEBPACK_IMPORTED_MODULE_101___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_flag_blue_svg__WEBPACK_IMPORTED_MODULE_101__);
/* harmony import */ var _images_icons_rating_heart_light_svg__WEBPACK_IMPORTED_MODULE_102__ = __webpack_require__(16030);
/* harmony import */ var _images_icons_rating_heart_light_svg__WEBPACK_IMPORTED_MODULE_102___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_heart_light_svg__WEBPACK_IMPORTED_MODULE_102__);
/* harmony import */ var _images_icons_rating_heart_gray_svg__WEBPACK_IMPORTED_MODULE_103__ = __webpack_require__(85625);
/* harmony import */ var _images_icons_rating_heart_gray_svg__WEBPACK_IMPORTED_MODULE_103___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_heart_gray_svg__WEBPACK_IMPORTED_MODULE_103__);
/* harmony import */ var _images_icons_rating_heart_red_svg__WEBPACK_IMPORTED_MODULE_104__ = __webpack_require__(61335);
/* harmony import */ var _images_icons_rating_heart_red_svg__WEBPACK_IMPORTED_MODULE_104___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_heart_red_svg__WEBPACK_IMPORTED_MODULE_104__);
/* harmony import */ var _images_icons_rating_heart_blue_svg__WEBPACK_IMPORTED_MODULE_105__ = __webpack_require__(71138);
/* harmony import */ var _images_icons_rating_heart_blue_svg__WEBPACK_IMPORTED_MODULE_105___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_heart_blue_svg__WEBPACK_IMPORTED_MODULE_105__);
/* harmony import */ var _images_icons_cross_svg__WEBPACK_IMPORTED_MODULE_106__ = __webpack_require__(33597);
/* harmony import */ var _images_icons_cross_svg__WEBPACK_IMPORTED_MODULE_106___default = /*#__PURE__*/__webpack_require__.n(_images_icons_cross_svg__WEBPACK_IMPORTED_MODULE_106__);
/* harmony import */ var _images_icons_alert_svg__WEBPACK_IMPORTED_MODULE_107__ = __webpack_require__(32577);
/* harmony import */ var _images_icons_alert_svg__WEBPACK_IMPORTED_MODULE_107___default = /*#__PURE__*/__webpack_require__.n(_images_icons_alert_svg__WEBPACK_IMPORTED_MODULE_107__);
/* harmony import */ var _images_icons_download2_svg__WEBPACK_IMPORTED_MODULE_108__ = __webpack_require__(27317);
/* harmony import */ var _images_icons_download2_svg__WEBPACK_IMPORTED_MODULE_108___default = /*#__PURE__*/__webpack_require__.n(_images_icons_download2_svg__WEBPACK_IMPORTED_MODULE_108__);
/* harmony import */ var _images_icons_note_svg__WEBPACK_IMPORTED_MODULE_109__ = __webpack_require__(8386);
/* harmony import */ var _images_icons_note_svg__WEBPACK_IMPORTED_MODULE_109___default = /*#__PURE__*/__webpack_require__.n(_images_icons_note_svg__WEBPACK_IMPORTED_MODULE_109__);
/* harmony import */ var _images_icons_folder_svg__WEBPACK_IMPORTED_MODULE_110__ = __webpack_require__(32472);
/* harmony import */ var _images_icons_folder_svg__WEBPACK_IMPORTED_MODULE_110___default = /*#__PURE__*/__webpack_require__.n(_images_icons_folder_svg__WEBPACK_IMPORTED_MODULE_110__);
/* harmony import */ var _images_icons_workspace_svg__WEBPACK_IMPORTED_MODULE_111__ = __webpack_require__(7294);
/* harmony import */ var _images_icons_workspace_svg__WEBPACK_IMPORTED_MODULE_111___default = /*#__PURE__*/__webpack_require__.n(_images_icons_workspace_svg__WEBPACK_IMPORTED_MODULE_111__);
/* harmony import */ var _images_icons_shared_svg__WEBPACK_IMPORTED_MODULE_112__ = __webpack_require__(31665);
/* harmony import */ var _images_icons_shared_svg__WEBPACK_IMPORTED_MODULE_112___default = /*#__PURE__*/__webpack_require__.n(_images_icons_shared_svg__WEBPACK_IMPORTED_MODULE_112__);
/* harmony import */ var _images_icons_favorites_svg__WEBPACK_IMPORTED_MODULE_113__ = __webpack_require__(84581);
/* harmony import */ var _images_icons_favorites_svg__WEBPACK_IMPORTED_MODULE_113___default = /*#__PURE__*/__webpack_require__.n(_images_icons_favorites_svg__WEBPACK_IMPORTED_MODULE_113__);
/* harmony import */ var _images_icons_todo_svg__WEBPACK_IMPORTED_MODULE_114__ = __webpack_require__(88536);
/* harmony import */ var _images_icons_todo_svg__WEBPACK_IMPORTED_MODULE_114___default = /*#__PURE__*/__webpack_require__.n(_images_icons_todo_svg__WEBPACK_IMPORTED_MODULE_114__);
/* harmony import */ var _images_icons_syntax_svg__WEBPACK_IMPORTED_MODULE_115__ = __webpack_require__(18294);
/* harmony import */ var _images_icons_syntax_svg__WEBPACK_IMPORTED_MODULE_115___default = /*#__PURE__*/__webpack_require__.n(_images_icons_syntax_svg__WEBPACK_IMPORTED_MODULE_115__);
/* harmony import */ var _images_icons_templates_svg__WEBPACK_IMPORTED_MODULE_116__ = __webpack_require__(62171);
/* harmony import */ var _images_icons_templates_svg__WEBPACK_IMPORTED_MODULE_116___default = /*#__PURE__*/__webpack_require__.n(_images_icons_templates_svg__WEBPACK_IMPORTED_MODULE_116__);
/* harmony import */ var _images_icons_question_svg__WEBPACK_IMPORTED_MODULE_117__ = __webpack_require__(40286);
/* harmony import */ var _images_icons_question_svg__WEBPACK_IMPORTED_MODULE_117___default = /*#__PURE__*/__webpack_require__.n(_images_icons_question_svg__WEBPACK_IMPORTED_MODULE_117__);
/* harmony import */ var _images_icons_sort_ascending_svg__WEBPACK_IMPORTED_MODULE_118__ = __webpack_require__(17884);
/* harmony import */ var _images_icons_sort_ascending_svg__WEBPACK_IMPORTED_MODULE_118___default = /*#__PURE__*/__webpack_require__.n(_images_icons_sort_ascending_svg__WEBPACK_IMPORTED_MODULE_118__);
/* harmony import */ var _images_icons_sort_descending_svg__WEBPACK_IMPORTED_MODULE_119__ = __webpack_require__(59681);
/* harmony import */ var _images_icons_sort_descending_svg__WEBPACK_IMPORTED_MODULE_119___default = /*#__PURE__*/__webpack_require__.n(_images_icons_sort_descending_svg__WEBPACK_IMPORTED_MODULE_119__);
/* harmony import */ var _images_icons_mention_svg__WEBPACK_IMPORTED_MODULE_120__ = __webpack_require__(94384);
/* harmony import */ var _images_icons_mention_svg__WEBPACK_IMPORTED_MODULE_120___default = /*#__PURE__*/__webpack_require__.n(_images_icons_mention_svg__WEBPACK_IMPORTED_MODULE_120__);
/* harmony import */ var _images_icons_tasks_svg__WEBPACK_IMPORTED_MODULE_121__ = __webpack_require__(12216);
/* harmony import */ var _images_icons_tasks_svg__WEBPACK_IMPORTED_MODULE_121___default = /*#__PURE__*/__webpack_require__.n(_images_icons_tasks_svg__WEBPACK_IMPORTED_MODULE_121__);
/* harmony import */ var _images_icons_outline_svg__WEBPACK_IMPORTED_MODULE_122__ = __webpack_require__(68234);
/* harmony import */ var _images_icons_outline_svg__WEBPACK_IMPORTED_MODULE_122___default = /*#__PURE__*/__webpack_require__.n(_images_icons_outline_svg__WEBPACK_IMPORTED_MODULE_122__);
/* harmony import */ var _images_icons_check_svg__WEBPACK_IMPORTED_MODULE_123__ = __webpack_require__(21855);
/* harmony import */ var _images_icons_check_svg__WEBPACK_IMPORTED_MODULE_123___default = /*#__PURE__*/__webpack_require__.n(_images_icons_check_svg__WEBPACK_IMPORTED_MODULE_123__);
/* harmony import */ var _images_icons_arrow_right_rounded_svg__WEBPACK_IMPORTED_MODULE_124__ = __webpack_require__(61093);
/* harmony import */ var _images_icons_arrow_right_rounded_svg__WEBPACK_IMPORTED_MODULE_124___default = /*#__PURE__*/__webpack_require__.n(_images_icons_arrow_right_rounded_svg__WEBPACK_IMPORTED_MODULE_124__);
/* harmony import */ var _images_icons_bell_svg__WEBPACK_IMPORTED_MODULE_125__ = __webpack_require__(11803);
/* harmony import */ var _images_icons_bell_svg__WEBPACK_IMPORTED_MODULE_125___default = /*#__PURE__*/__webpack_require__.n(_images_icons_bell_svg__WEBPACK_IMPORTED_MODULE_125__);
/* harmony import */ var _images_icons_calendar_svg__WEBPACK_IMPORTED_MODULE_126__ = __webpack_require__(74985);
/* harmony import */ var _images_icons_calendar_svg__WEBPACK_IMPORTED_MODULE_126___default = /*#__PURE__*/__webpack_require__.n(_images_icons_calendar_svg__WEBPACK_IMPORTED_MODULE_126__);
/* harmony import */ var _images_icons_cloud_error_svg__WEBPACK_IMPORTED_MODULE_127__ = __webpack_require__(71185);
/* harmony import */ var _images_icons_cloud_error_svg__WEBPACK_IMPORTED_MODULE_127___default = /*#__PURE__*/__webpack_require__.n(_images_icons_cloud_error_svg__WEBPACK_IMPORTED_MODULE_127__);
/* harmony import */ var _images_icons_embed_svg__WEBPACK_IMPORTED_MODULE_128__ = __webpack_require__(26258);
/* harmony import */ var _images_icons_embed_svg__WEBPACK_IMPORTED_MODULE_128___default = /*#__PURE__*/__webpack_require__.n(_images_icons_embed_svg__WEBPACK_IMPORTED_MODULE_128__);
/* harmony import */ var _images_icons_google_drive_svg__WEBPACK_IMPORTED_MODULE_129__ = __webpack_require__(55551);
/* harmony import */ var _images_icons_google_drive_svg__WEBPACK_IMPORTED_MODULE_129___default = /*#__PURE__*/__webpack_require__.n(_images_icons_google_drive_svg__WEBPACK_IMPORTED_MODULE_129__);
/* harmony import */ var _images_icons_people_svg__WEBPACK_IMPORTED_MODULE_130__ = __webpack_require__(53686);
/* harmony import */ var _images_icons_people_svg__WEBPACK_IMPORTED_MODULE_130___default = /*#__PURE__*/__webpack_require__.n(_images_icons_people_svg__WEBPACK_IMPORTED_MODULE_130__);
/* harmony import */ var _images_icons_back_button_svg__WEBPACK_IMPORTED_MODULE_131__ = __webpack_require__(86306);
/* harmony import */ var _images_icons_back_button_svg__WEBPACK_IMPORTED_MODULE_131___default = /*#__PURE__*/__webpack_require__.n(_images_icons_back_button_svg__WEBPACK_IMPORTED_MODULE_131__);
/* harmony import */ var _images_icons_menu_more_down_svg__WEBPACK_IMPORTED_MODULE_132__ = __webpack_require__(16357);
/* harmony import */ var _images_icons_menu_more_down_svg__WEBPACK_IMPORTED_MODULE_132___default = /*#__PURE__*/__webpack_require__.n(_images_icons_menu_more_down_svg__WEBPACK_IMPORTED_MODULE_132__);
/* harmony import */ var _images_icons_list_collapse_svg__WEBPACK_IMPORTED_MODULE_133__ = __webpack_require__(98854);
/* harmony import */ var _images_icons_list_collapse_svg__WEBPACK_IMPORTED_MODULE_133___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_collapse_svg__WEBPACK_IMPORTED_MODULE_133__);
/* harmony import */ var _images_icons_placeholder_icon_svg__WEBPACK_IMPORTED_MODULE_134__ = __webpack_require__(7393);
/* harmony import */ var _images_icons_placeholder_icon_svg__WEBPACK_IMPORTED_MODULE_134___default = /*#__PURE__*/__webpack_require__.n(_images_icons_placeholder_icon_svg__WEBPACK_IMPORTED_MODULE_134__);
/* harmony import */ var _images_icons_bookmark_svg__WEBPACK_IMPORTED_MODULE_135__ = __webpack_require__(22793);
/* harmony import */ var _images_icons_bookmark_svg__WEBPACK_IMPORTED_MODULE_135___default = /*#__PURE__*/__webpack_require__.n(_images_icons_bookmark_svg__WEBPACK_IMPORTED_MODULE_135__);
/* harmony import */ var _images_icons_url_svg__WEBPACK_IMPORTED_MODULE_136__ = __webpack_require__(29672);
/* harmony import */ var _images_icons_url_svg__WEBPACK_IMPORTED_MODULE_136___default = /*#__PURE__*/__webpack_require__.n(_images_icons_url_svg__WEBPACK_IMPORTED_MODULE_136__);
/* harmony import */ var _images_icons_title_svg__WEBPACK_IMPORTED_MODULE_137__ = __webpack_require__(76094);
/* harmony import */ var _images_icons_title_svg__WEBPACK_IMPORTED_MODULE_137___default = /*#__PURE__*/__webpack_require__.n(_images_icons_title_svg__WEBPACK_IMPORTED_MODULE_137__);
/* harmony import */ var _images_icons_embed_b_svg__WEBPACK_IMPORTED_MODULE_138__ = __webpack_require__(99474);
/* harmony import */ var _images_icons_embed_b_svg__WEBPACK_IMPORTED_MODULE_138___default = /*#__PURE__*/__webpack_require__.n(_images_icons_embed_b_svg__WEBPACK_IMPORTED_MODULE_138__);
/* harmony import */ var _images_icons_youtube_svg__WEBPACK_IMPORTED_MODULE_139__ = __webpack_require__(46921);
/* harmony import */ var _images_icons_youtube_svg__WEBPACK_IMPORTED_MODULE_139___default = /*#__PURE__*/__webpack_require__.n(_images_icons_youtube_svg__WEBPACK_IMPORTED_MODULE_139__);
/* harmony import */ var _images_icons_google_maps_svg__WEBPACK_IMPORTED_MODULE_140__ = __webpack_require__(517);
/* harmony import */ var _images_icons_google_maps_svg__WEBPACK_IMPORTED_MODULE_140___default = /*#__PURE__*/__webpack_require__.n(_images_icons_google_maps_svg__WEBPACK_IMPORTED_MODULE_140__);
/* harmony import */ var _images_icons_airtable_svg__WEBPACK_IMPORTED_MODULE_141__ = __webpack_require__(88098);
/* harmony import */ var _images_icons_airtable_svg__WEBPACK_IMPORTED_MODULE_141___default = /*#__PURE__*/__webpack_require__.n(_images_icons_airtable_svg__WEBPACK_IMPORTED_MODULE_141__);
/* harmony import */ var _images_icons_invision_svg__WEBPACK_IMPORTED_MODULE_142__ = __webpack_require__(13669);
/* harmony import */ var _images_icons_invision_svg__WEBPACK_IMPORTED_MODULE_142___default = /*#__PURE__*/__webpack_require__.n(_images_icons_invision_svg__WEBPACK_IMPORTED_MODULE_142__);
/* harmony import */ var _images_icons_figma_svg__WEBPACK_IMPORTED_MODULE_143__ = __webpack_require__(83763);
/* harmony import */ var _images_icons_figma_svg__WEBPACK_IMPORTED_MODULE_143___default = /*#__PURE__*/__webpack_require__.n(_images_icons_figma_svg__WEBPACK_IMPORTED_MODULE_143__);
/* harmony import */ var _images_icons_github_gist_svg__WEBPACK_IMPORTED_MODULE_144__ = __webpack_require__(71492);
/* harmony import */ var _images_icons_github_gist_svg__WEBPACK_IMPORTED_MODULE_144___default = /*#__PURE__*/__webpack_require__.n(_images_icons_github_gist_svg__WEBPACK_IMPORTED_MODULE_144__);
/* harmony import */ var _images_icons_twitter_svg__WEBPACK_IMPORTED_MODULE_145__ = __webpack_require__(35783);
/* harmony import */ var _images_icons_twitter_svg__WEBPACK_IMPORTED_MODULE_145___default = /*#__PURE__*/__webpack_require__.n(_images_icons_twitter_svg__WEBPACK_IMPORTED_MODULE_145__);
/* harmony import */ var _images_icons_typeform_svg__WEBPACK_IMPORTED_MODULE_146__ = __webpack_require__(61615);
/* harmony import */ var _images_icons_typeform_svg__WEBPACK_IMPORTED_MODULE_146___default = /*#__PURE__*/__webpack_require__.n(_images_icons_typeform_svg__WEBPACK_IMPORTED_MODULE_146__);
/* harmony import */ var _images_icons_vimeo_svg__WEBPACK_IMPORTED_MODULE_147__ = __webpack_require__(89713);
/* harmony import */ var _images_icons_vimeo_svg__WEBPACK_IMPORTED_MODULE_147___default = /*#__PURE__*/__webpack_require__.n(_images_icons_vimeo_svg__WEBPACK_IMPORTED_MODULE_147__);
/* harmony import */ var _images_icons_nimbus_svg__WEBPACK_IMPORTED_MODULE_148__ = __webpack_require__(92688);
/* harmony import */ var _images_icons_nimbus_svg__WEBPACK_IMPORTED_MODULE_148___default = /*#__PURE__*/__webpack_require__.n(_images_icons_nimbus_svg__WEBPACK_IMPORTED_MODULE_148__);
/* harmony import */ var _images_icons_upload_svg__WEBPACK_IMPORTED_MODULE_149__ = __webpack_require__(26798);
/* harmony import */ var _images_icons_upload_svg__WEBPACK_IMPORTED_MODULE_149___default = /*#__PURE__*/__webpack_require__.n(_images_icons_upload_svg__WEBPACK_IMPORTED_MODULE_149__);
/* harmony import */ var _images_icons_play_icon_svg__WEBPACK_IMPORTED_MODULE_150__ = __webpack_require__(51195);
/* harmony import */ var _images_icons_play_icon_svg__WEBPACK_IMPORTED_MODULE_150___default = /*#__PURE__*/__webpack_require__.n(_images_icons_play_icon_svg__WEBPACK_IMPORTED_MODULE_150__);
/* harmony import */ var _images_icons_pause_icon_svg__WEBPACK_IMPORTED_MODULE_151__ = __webpack_require__(10231);
/* harmony import */ var _images_icons_pause_icon_svg__WEBPACK_IMPORTED_MODULE_151___default = /*#__PURE__*/__webpack_require__.n(_images_icons_pause_icon_svg__WEBPACK_IMPORTED_MODULE_151__);
/* harmony import */ var _images_icons_record_icon_svg__WEBPACK_IMPORTED_MODULE_152__ = __webpack_require__(14698);
/* harmony import */ var _images_icons_record_icon_svg__WEBPACK_IMPORTED_MODULE_152___default = /*#__PURE__*/__webpack_require__.n(_images_icons_record_icon_svg__WEBPACK_IMPORTED_MODULE_152__);
/* harmony import */ var _images_icons_remove_record_svg__WEBPACK_IMPORTED_MODULE_153__ = __webpack_require__(88170);
/* harmony import */ var _images_icons_remove_record_svg__WEBPACK_IMPORTED_MODULE_153___default = /*#__PURE__*/__webpack_require__.n(_images_icons_remove_record_svg__WEBPACK_IMPORTED_MODULE_153__);
/* harmony import */ var _images_icons_stop_icon_svg__WEBPACK_IMPORTED_MODULE_154__ = __webpack_require__(14345);
/* harmony import */ var _images_icons_stop_icon_svg__WEBPACK_IMPORTED_MODULE_154___default = /*#__PURE__*/__webpack_require__.n(_images_icons_stop_icon_svg__WEBPACK_IMPORTED_MODULE_154__);
/* harmony import */ var _images_icons_screen_only_svg__WEBPACK_IMPORTED_MODULE_155__ = __webpack_require__(30315);
/* harmony import */ var _images_icons_screen_only_svg__WEBPACK_IMPORTED_MODULE_155___default = /*#__PURE__*/__webpack_require__.n(_images_icons_screen_only_svg__WEBPACK_IMPORTED_MODULE_155__);
/* harmony import */ var _images_icons_cam_only_svg__WEBPACK_IMPORTED_MODULE_156__ = __webpack_require__(21088);
/* harmony import */ var _images_icons_cam_only_svg__WEBPACK_IMPORTED_MODULE_156___default = /*#__PURE__*/__webpack_require__.n(_images_icons_cam_only_svg__WEBPACK_IMPORTED_MODULE_156__);
/* harmony import */ var _images_icons_screen_cam_svg__WEBPACK_IMPORTED_MODULE_157__ = __webpack_require__(80562);
/* harmony import */ var _images_icons_screen_cam_svg__WEBPACK_IMPORTED_MODULE_157___default = /*#__PURE__*/__webpack_require__.n(_images_icons_screen_cam_svg__WEBPACK_IMPORTED_MODULE_157__);
/* harmony import */ var _images_icons_screen_only_active_svg__WEBPACK_IMPORTED_MODULE_158__ = __webpack_require__(77142);
/* harmony import */ var _images_icons_screen_only_active_svg__WEBPACK_IMPORTED_MODULE_158___default = /*#__PURE__*/__webpack_require__.n(_images_icons_screen_only_active_svg__WEBPACK_IMPORTED_MODULE_158__);
/* harmony import */ var _images_icons_cam_only_active_svg__WEBPACK_IMPORTED_MODULE_159__ = __webpack_require__(31887);
/* harmony import */ var _images_icons_cam_only_active_svg__WEBPACK_IMPORTED_MODULE_159___default = /*#__PURE__*/__webpack_require__.n(_images_icons_cam_only_active_svg__WEBPACK_IMPORTED_MODULE_159__);
/* harmony import */ var _images_icons_screen_cam_active_svg__WEBPACK_IMPORTED_MODULE_160__ = __webpack_require__(61762);
/* harmony import */ var _images_icons_screen_cam_active_svg__WEBPACK_IMPORTED_MODULE_160___default = /*#__PURE__*/__webpack_require__.n(_images_icons_screen_cam_active_svg__WEBPACK_IMPORTED_MODULE_160__);
/* harmony import */ var _images_icons_soundOn_svg__WEBPACK_IMPORTED_MODULE_161__ = __webpack_require__(10653);
/* harmony import */ var _images_icons_soundOn_svg__WEBPACK_IMPORTED_MODULE_161___default = /*#__PURE__*/__webpack_require__.n(_images_icons_soundOn_svg__WEBPACK_IMPORTED_MODULE_161__);
/* harmony import */ var _images_icons_soundOff_svg__WEBPACK_IMPORTED_MODULE_162__ = __webpack_require__(24570);
/* harmony import */ var _images_icons_soundOff_svg__WEBPACK_IMPORTED_MODULE_162___default = /*#__PURE__*/__webpack_require__.n(_images_icons_soundOff_svg__WEBPACK_IMPORTED_MODULE_162__);
/* harmony import */ var _images_icons_full_width_mode_svg__WEBPACK_IMPORTED_MODULE_163__ = __webpack_require__(89129);
/* harmony import */ var _images_icons_full_width_mode_svg__WEBPACK_IMPORTED_MODULE_163___default = /*#__PURE__*/__webpack_require__.n(_images_icons_full_width_mode_svg__WEBPACK_IMPORTED_MODULE_163__);
/* harmony import */ var _images_icons_pin_button_svg__WEBPACK_IMPORTED_MODULE_164__ = __webpack_require__(88398);
/* harmony import */ var _images_icons_pin_button_svg__WEBPACK_IMPORTED_MODULE_164___default = /*#__PURE__*/__webpack_require__.n(_images_icons_pin_button_svg__WEBPACK_IMPORTED_MODULE_164__);
/* harmony import */ var _images_icons_unpin_button_svg__WEBPACK_IMPORTED_MODULE_165__ = __webpack_require__(29300);
/* harmony import */ var _images_icons_unpin_button_svg__WEBPACK_IMPORTED_MODULE_165___default = /*#__PURE__*/__webpack_require__.n(_images_icons_unpin_button_svg__WEBPACK_IMPORTED_MODULE_165__);
/* harmony import */ var _images_icons_lock_svg__WEBPACK_IMPORTED_MODULE_166__ = __webpack_require__(72102);
/* harmony import */ var _images_icons_lock_svg__WEBPACK_IMPORTED_MODULE_166___default = /*#__PURE__*/__webpack_require__.n(_images_icons_lock_svg__WEBPACK_IMPORTED_MODULE_166__);
/* harmony import */ var _images_icons_lock_hover_svg__WEBPACK_IMPORTED_MODULE_167__ = __webpack_require__(8941);
/* harmony import */ var _images_icons_lock_hover_svg__WEBPACK_IMPORTED_MODULE_167___default = /*#__PURE__*/__webpack_require__.n(_images_icons_lock_hover_svg__WEBPACK_IMPORTED_MODULE_167__);
/* harmony import */ var _images_icons_create_note_svg__WEBPACK_IMPORTED_MODULE_168__ = __webpack_require__(44744);
/* harmony import */ var _images_icons_create_note_svg__WEBPACK_IMPORTED_MODULE_168___default = /*#__PURE__*/__webpack_require__.n(_images_icons_create_note_svg__WEBPACK_IMPORTED_MODULE_168__);
/* harmony import */ var _images_icons_create_folder_svg__WEBPACK_IMPORTED_MODULE_169__ = __webpack_require__(13532);
/* harmony import */ var _images_icons_create_folder_svg__WEBPACK_IMPORTED_MODULE_169___default = /*#__PURE__*/__webpack_require__.n(_images_icons_create_folder_svg__WEBPACK_IMPORTED_MODULE_169__);
/* harmony import */ var _images_icons_comment_svg__WEBPACK_IMPORTED_MODULE_170__ = __webpack_require__(3641);
/* harmony import */ var _images_icons_comment_svg__WEBPACK_IMPORTED_MODULE_170___default = /*#__PURE__*/__webpack_require__.n(_images_icons_comment_svg__WEBPACK_IMPORTED_MODULE_170__);
/* harmony import */ var _images_icons_hint_svg__WEBPACK_IMPORTED_MODULE_171__ = __webpack_require__(82052);
/* harmony import */ var _images_icons_hint_svg__WEBPACK_IMPORTED_MODULE_171___default = /*#__PURE__*/__webpack_require__.n(_images_icons_hint_svg__WEBPACK_IMPORTED_MODULE_171__);
/* harmony import */ var _images_icons_comment_mobile_svg__WEBPACK_IMPORTED_MODULE_172__ = __webpack_require__(58191);
/* harmony import */ var _images_icons_comment_mobile_svg__WEBPACK_IMPORTED_MODULE_172___default = /*#__PURE__*/__webpack_require__.n(_images_icons_comment_mobile_svg__WEBPACK_IMPORTED_MODULE_172__);
/* harmony import */ var _images_icons_button_svg__WEBPACK_IMPORTED_MODULE_173__ = __webpack_require__(60681);
/* harmony import */ var _images_icons_button_svg__WEBPACK_IMPORTED_MODULE_173___default = /*#__PURE__*/__webpack_require__.n(_images_icons_button_svg__WEBPACK_IMPORTED_MODULE_173__);
/* harmony import */ var _images_icons_empty_svg__WEBPACK_IMPORTED_MODULE_174__ = __webpack_require__(91027);
/* harmony import */ var _images_icons_empty_svg__WEBPACK_IMPORTED_MODULE_174___default = /*#__PURE__*/__webpack_require__.n(_images_icons_empty_svg__WEBPACK_IMPORTED_MODULE_174__);
/* harmony import */ var _images_icons_edit_video_svg__WEBPACK_IMPORTED_MODULE_175__ = __webpack_require__(97393);
/* harmony import */ var _images_icons_edit_video_svg__WEBPACK_IMPORTED_MODULE_175___default = /*#__PURE__*/__webpack_require__.n(_images_icons_edit_video_svg__WEBPACK_IMPORTED_MODULE_175__);
/* harmony import */ var _images_icons_paragraph_2_svg__WEBPACK_IMPORTED_MODULE_176__ = __webpack_require__(69435);
/* harmony import */ var _images_icons_paragraph_2_svg__WEBPACK_IMPORTED_MODULE_176___default = /*#__PURE__*/__webpack_require__.n(_images_icons_paragraph_2_svg__WEBPACK_IMPORTED_MODULE_176__);
/* harmony import */ var _images_icons_add_comment_svg__WEBPACK_IMPORTED_MODULE_177__ = __webpack_require__(44859);
/* harmony import */ var _images_icons_add_comment_svg__WEBPACK_IMPORTED_MODULE_177___default = /*#__PURE__*/__webpack_require__.n(_images_icons_add_comment_svg__WEBPACK_IMPORTED_MODULE_177__);
/* harmony import */ var _images_icons_watch_again_svg__WEBPACK_IMPORTED_MODULE_178__ = __webpack_require__(77445);
/* harmony import */ var _images_icons_watch_again_svg__WEBPACK_IMPORTED_MODULE_178___default = /*#__PURE__*/__webpack_require__.n(_images_icons_watch_again_svg__WEBPACK_IMPORTED_MODULE_178__);
/* harmony import */ var _images_icons_toggle_svg__WEBPACK_IMPORTED_MODULE_179__ = __webpack_require__(33277);
/* harmony import */ var _images_icons_toggle_svg__WEBPACK_IMPORTED_MODULE_179___default = /*#__PURE__*/__webpack_require__.n(_images_icons_toggle_svg__WEBPACK_IMPORTED_MODULE_179__);
/* harmony import */ var _images_icons_checklist_svg__WEBPACK_IMPORTED_MODULE_180__ = __webpack_require__(36598);
/* harmony import */ var _images_icons_checklist_svg__WEBPACK_IMPORTED_MODULE_180___default = /*#__PURE__*/__webpack_require__.n(_images_icons_checklist_svg__WEBPACK_IMPORTED_MODULE_180__);
/* harmony import */ var _images_icons_player_download_svg__WEBPACK_IMPORTED_MODULE_181__ = __webpack_require__(25637);
/* harmony import */ var _images_icons_player_download_svg__WEBPACK_IMPORTED_MODULE_181___default = /*#__PURE__*/__webpack_require__.n(_images_icons_player_download_svg__WEBPACK_IMPORTED_MODULE_181__);
/* harmony import */ var _images_icons_large_header_toggle_svg__WEBPACK_IMPORTED_MODULE_182__ = __webpack_require__(78018);
/* harmony import */ var _images_icons_large_header_toggle_svg__WEBPACK_IMPORTED_MODULE_182___default = /*#__PURE__*/__webpack_require__.n(_images_icons_large_header_toggle_svg__WEBPACK_IMPORTED_MODULE_182__);
/* harmony import */ var _images_icons_medium_header_toggle_svg__WEBPACK_IMPORTED_MODULE_183__ = __webpack_require__(37871);
/* harmony import */ var _images_icons_medium_header_toggle_svg__WEBPACK_IMPORTED_MODULE_183___default = /*#__PURE__*/__webpack_require__.n(_images_icons_medium_header_toggle_svg__WEBPACK_IMPORTED_MODULE_183__);
/* harmony import */ var _images_icons_small_header_toggle_svg__WEBPACK_IMPORTED_MODULE_184__ = __webpack_require__(71571);
/* harmony import */ var _images_icons_small_header_toggle_svg__WEBPACK_IMPORTED_MODULE_184___default = /*#__PURE__*/__webpack_require__.n(_images_icons_small_header_toggle_svg__WEBPACK_IMPORTED_MODULE_184__);
/* harmony import */ var _images_icons_custom_link_svg__WEBPACK_IMPORTED_MODULE_185__ = __webpack_require__(89883);
/* harmony import */ var _images_icons_custom_link_svg__WEBPACK_IMPORTED_MODULE_185___default = /*#__PURE__*/__webpack_require__.n(_images_icons_custom_link_svg__WEBPACK_IMPORTED_MODULE_185__);
/* harmony import */ var _images_icons_columns_svg__WEBPACK_IMPORTED_MODULE_186__ = __webpack_require__(97368);
/* harmony import */ var _images_icons_columns_svg__WEBPACK_IMPORTED_MODULE_186___default = /*#__PURE__*/__webpack_require__.n(_images_icons_columns_svg__WEBPACK_IMPORTED_MODULE_186__);
/* harmony import */ var _images_icons_default_color_icon_svg__WEBPACK_IMPORTED_MODULE_187__ = __webpack_require__(28824);
/* harmony import */ var _images_icons_default_color_icon_svg__WEBPACK_IMPORTED_MODULE_187___default = /*#__PURE__*/__webpack_require__.n(_images_icons_default_color_icon_svg__WEBPACK_IMPORTED_MODULE_187__);
/* harmony import */ var _images_icons_template_icon_svg__WEBPACK_IMPORTED_MODULE_188__ = __webpack_require__(64268);
/* harmony import */ var _images_icons_template_icon_svg__WEBPACK_IMPORTED_MODULE_188___default = /*#__PURE__*/__webpack_require__.n(_images_icons_template_icon_svg__WEBPACK_IMPORTED_MODULE_188__);
/* harmony import */ var _images_icons_invite_svg__WEBPACK_IMPORTED_MODULE_189__ = __webpack_require__(44819);
/* harmony import */ var _images_icons_invite_svg__WEBPACK_IMPORTED_MODULE_189___default = /*#__PURE__*/__webpack_require__.n(_images_icons_invite_svg__WEBPACK_IMPORTED_MODULE_189__);
/* harmony import */ var _images_icons_file_icon_svg__WEBPACK_IMPORTED_MODULE_190__ = __webpack_require__(62012);
/* harmony import */ var _images_icons_file_icon_svg__WEBPACK_IMPORTED_MODULE_190___default = /*#__PURE__*/__webpack_require__.n(_images_icons_file_icon_svg__WEBPACK_IMPORTED_MODULE_190__);
/* harmony import */ var _images_icons_link_diag_svg__WEBPACK_IMPORTED_MODULE_191__ = __webpack_require__(4718);
/* harmony import */ var _images_icons_link_diag_svg__WEBPACK_IMPORTED_MODULE_191___default = /*#__PURE__*/__webpack_require__.n(_images_icons_link_diag_svg__WEBPACK_IMPORTED_MODULE_191__);
/* harmony import */ var _images_icons_feedback_svg__WEBPACK_IMPORTED_MODULE_192__ = __webpack_require__(23953);
/* harmony import */ var _images_icons_feedback_svg__WEBPACK_IMPORTED_MODULE_192___default = /*#__PURE__*/__webpack_require__.n(_images_icons_feedback_svg__WEBPACK_IMPORTED_MODULE_192__);
/* harmony import */ var _images_icons_support_svg__WEBPACK_IMPORTED_MODULE_193__ = __webpack_require__(62428);
/* harmony import */ var _images_icons_support_svg__WEBPACK_IMPORTED_MODULE_193___default = /*#__PURE__*/__webpack_require__.n(_images_icons_support_svg__WEBPACK_IMPORTED_MODULE_193__);
/* harmony import */ var _images_icons_learn_svg__WEBPACK_IMPORTED_MODULE_194__ = __webpack_require__(76767);
/* harmony import */ var _images_icons_learn_svg__WEBPACK_IMPORTED_MODULE_194___default = /*#__PURE__*/__webpack_require__.n(_images_icons_learn_svg__WEBPACK_IMPORTED_MODULE_194__);
/* harmony import */ var _images_icons_miro_svg__WEBPACK_IMPORTED_MODULE_195__ = __webpack_require__(26934);
/* harmony import */ var _images_icons_miro_svg__WEBPACK_IMPORTED_MODULE_195___default = /*#__PURE__*/__webpack_require__.n(_images_icons_miro_svg__WEBPACK_IMPORTED_MODULE_195__);
/* harmony import */ var _images_icons_database_svg__WEBPACK_IMPORTED_MODULE_196__ = __webpack_require__(23996);
/* harmony import */ var _images_icons_database_svg__WEBPACK_IMPORTED_MODULE_196___default = /*#__PURE__*/__webpack_require__.n(_images_icons_database_svg__WEBPACK_IMPORTED_MODULE_196__);
/* harmony import */ var _images_icons_filter_svg__WEBPACK_IMPORTED_MODULE_197__ = __webpack_require__(80124);
/* harmony import */ var _images_icons_filter_svg__WEBPACK_IMPORTED_MODULE_197___default = /*#__PURE__*/__webpack_require__.n(_images_icons_filter_svg__WEBPACK_IMPORTED_MODULE_197__);
/* harmony import */ var _images_icons_board_svg__WEBPACK_IMPORTED_MODULE_198__ = __webpack_require__(38096);
/* harmony import */ var _images_icons_board_svg__WEBPACK_IMPORTED_MODULE_198___default = /*#__PURE__*/__webpack_require__.n(_images_icons_board_svg__WEBPACK_IMPORTED_MODULE_198__);
/* harmony import */ var _images_icons_progress_svg__WEBPACK_IMPORTED_MODULE_199__ = __webpack_require__(54958);
/* harmony import */ var _images_icons_progress_svg__WEBPACK_IMPORTED_MODULE_199___default = /*#__PURE__*/__webpack_require__.n(_images_icons_progress_svg__WEBPACK_IMPORTED_MODULE_199__);
/* harmony import */ var _images_icons_comment_new_svg__WEBPACK_IMPORTED_MODULE_200__ = __webpack_require__(7688);
/* harmony import */ var _images_icons_comment_new_svg__WEBPACK_IMPORTED_MODULE_200___default = /*#__PURE__*/__webpack_require__.n(_images_icons_comment_new_svg__WEBPACK_IMPORTED_MODULE_200__);
/* harmony import */ var _images_icons_promt_icon_svg__WEBPACK_IMPORTED_MODULE_201__ = __webpack_require__(38312);
/* harmony import */ var _images_icons_promt_icon_svg__WEBPACK_IMPORTED_MODULE_201___default = /*#__PURE__*/__webpack_require__.n(_images_icons_promt_icon_svg__WEBPACK_IMPORTED_MODULE_201__);
/* harmony import */ var _images_icons_sync_svg__WEBPACK_IMPORTED_MODULE_202__ = __webpack_require__(82481);
/* harmony import */ var _images_icons_sync_svg__WEBPACK_IMPORTED_MODULE_202___default = /*#__PURE__*/__webpack_require__.n(_images_icons_sync_svg__WEBPACK_IMPORTED_MODULE_202__);
/* harmony import */ var _images_icons_done_svg__WEBPACK_IMPORTED_MODULE_203__ = __webpack_require__(99635);
/* harmony import */ var _images_icons_done_svg__WEBPACK_IMPORTED_MODULE_203___default = /*#__PURE__*/__webpack_require__.n(_images_icons_done_svg__WEBPACK_IMPORTED_MODULE_203__);
/* harmony import */ var _images_icons_ai_help_svg__WEBPACK_IMPORTED_MODULE_204__ = __webpack_require__(60251);
/* harmony import */ var _images_icons_ai_help_svg__WEBPACK_IMPORTED_MODULE_204___default = /*#__PURE__*/__webpack_require__.n(_images_icons_ai_help_svg__WEBPACK_IMPORTED_MODULE_204__);
/* harmony import */ var _images_icons_ai_cta_svg__WEBPACK_IMPORTED_MODULE_205__ = __webpack_require__(86766);
/* harmony import */ var _images_icons_ai_cta_svg__WEBPACK_IMPORTED_MODULE_205___default = /*#__PURE__*/__webpack_require__.n(_images_icons_ai_cta_svg__WEBPACK_IMPORTED_MODULE_205__);
/* harmony import */ var _images_icons_ai_explain_svg__WEBPACK_IMPORTED_MODULE_206__ = __webpack_require__(44461);
/* harmony import */ var _images_icons_ai_explain_svg__WEBPACK_IMPORTED_MODULE_206___default = /*#__PURE__*/__webpack_require__.n(_images_icons_ai_explain_svg__WEBPACK_IMPORTED_MODULE_206__);
/* harmony import */ var _images_icons_ai_improve_svg__WEBPACK_IMPORTED_MODULE_207__ = __webpack_require__(79058);
/* harmony import */ var _images_icons_ai_improve_svg__WEBPACK_IMPORTED_MODULE_207___default = /*#__PURE__*/__webpack_require__.n(_images_icons_ai_improve_svg__WEBPACK_IMPORTED_MODULE_207__);
/* harmony import */ var _images_icons_ai_longer_svg__WEBPACK_IMPORTED_MODULE_208__ = __webpack_require__(10812);
/* harmony import */ var _images_icons_ai_longer_svg__WEBPACK_IMPORTED_MODULE_208___default = /*#__PURE__*/__webpack_require__.n(_images_icons_ai_longer_svg__WEBPACK_IMPORTED_MODULE_208__);
/* harmony import */ var _images_icons_ai_shorter_svg__WEBPACK_IMPORTED_MODULE_209__ = __webpack_require__(67906);
/* harmony import */ var _images_icons_ai_shorter_svg__WEBPACK_IMPORTED_MODULE_209___default = /*#__PURE__*/__webpack_require__.n(_images_icons_ai_shorter_svg__WEBPACK_IMPORTED_MODULE_209__);
/* harmony import */ var _images_icons_ai_spelling_svg__WEBPACK_IMPORTED_MODULE_210__ = __webpack_require__(89959);
/* harmony import */ var _images_icons_ai_spelling_svg__WEBPACK_IMPORTED_MODULE_210___default = /*#__PURE__*/__webpack_require__.n(_images_icons_ai_spelling_svg__WEBPACK_IMPORTED_MODULE_210__);
/* harmony import */ var _images_icons_ai_summarize_svg__WEBPACK_IMPORTED_MODULE_211__ = __webpack_require__(65216);
/* harmony import */ var _images_icons_ai_summarize_svg__WEBPACK_IMPORTED_MODULE_211___default = /*#__PURE__*/__webpack_require__.n(_images_icons_ai_summarize_svg__WEBPACK_IMPORTED_MODULE_211__);
/* harmony import */ var _images_icons_replace_svg__WEBPACK_IMPORTED_MODULE_212__ = __webpack_require__(36039);
/* harmony import */ var _images_icons_replace_svg__WEBPACK_IMPORTED_MODULE_212___default = /*#__PURE__*/__webpack_require__.n(_images_icons_replace_svg__WEBPACK_IMPORTED_MODULE_212__);
/* harmony import */ var _images_icons_icon_arrow_up_svg__WEBPACK_IMPORTED_MODULE_213__ = __webpack_require__(79611);
/* harmony import */ var _images_icons_icon_arrow_up_svg__WEBPACK_IMPORTED_MODULE_213___default = /*#__PURE__*/__webpack_require__.n(_images_icons_icon_arrow_up_svg__WEBPACK_IMPORTED_MODULE_213__);
/* harmony import */ var _images_icons_icon_arrow_down_svg__WEBPACK_IMPORTED_MODULE_214__ = __webpack_require__(91527);
/* harmony import */ var _images_icons_icon_arrow_down_svg__WEBPACK_IMPORTED_MODULE_214___default = /*#__PURE__*/__webpack_require__.n(_images_icons_icon_arrow_down_svg__WEBPACK_IMPORTED_MODULE_214__);
/* harmony import */ var _images_icons_translate_svg__WEBPACK_IMPORTED_MODULE_215__ = __webpack_require__(60302);
/* harmony import */ var _images_icons_translate_svg__WEBPACK_IMPORTED_MODULE_215___default = /*#__PURE__*/__webpack_require__.n(_images_icons_translate_svg__WEBPACK_IMPORTED_MODULE_215__);
/* harmony import */ var _images_icons_copy_svg__WEBPACK_IMPORTED_MODULE_216__ = __webpack_require__(67012);
/* harmony import */ var _images_icons_copy_svg__WEBPACK_IMPORTED_MODULE_216___default = /*#__PURE__*/__webpack_require__.n(_images_icons_copy_svg__WEBPACK_IMPORTED_MODULE_216__);
/* harmony import */ var _images_icons_icon_cog_svg__WEBPACK_IMPORTED_MODULE_217__ = __webpack_require__(5952);
/* harmony import */ var _images_icons_icon_cog_svg__WEBPACK_IMPORTED_MODULE_217___default = /*#__PURE__*/__webpack_require__.n(_images_icons_icon_cog_svg__WEBPACK_IMPORTED_MODULE_217__);
/* harmony import */ var _images_icons_step_svg__WEBPACK_IMPORTED_MODULE_218__ = __webpack_require__(57551);
/* harmony import */ var _images_icons_step_svg__WEBPACK_IMPORTED_MODULE_218___default = /*#__PURE__*/__webpack_require__.n(_images_icons_step_svg__WEBPACK_IMPORTED_MODULE_218__);
/* harmony import */ var _images_icons_player_transcript_svg__WEBPACK_IMPORTED_MODULE_219__ = __webpack_require__(47137);
/* harmony import */ var _images_icons_player_transcript_svg__WEBPACK_IMPORTED_MODULE_219___default = /*#__PURE__*/__webpack_require__.n(_images_icons_player_transcript_svg__WEBPACK_IMPORTED_MODULE_219__);
/* harmony import */ var _images_icons_file_check_alt_svg__WEBPACK_IMPORTED_MODULE_220__ = __webpack_require__(42020);
/* harmony import */ var _images_icons_file_check_alt_svg__WEBPACK_IMPORTED_MODULE_220___default = /*#__PURE__*/__webpack_require__.n(_images_icons_file_check_alt_svg__WEBPACK_IMPORTED_MODULE_220__);
/* harmony import */ var _images_icons_user_pen_alt_svg__WEBPACK_IMPORTED_MODULE_221__ = __webpack_require__(77586);
/* harmony import */ var _images_icons_user_pen_alt_svg__WEBPACK_IMPORTED_MODULE_221___default = /*#__PURE__*/__webpack_require__.n(_images_icons_user_pen_alt_svg__WEBPACK_IMPORTED_MODULE_221__);
/* harmony import */ var _images_icons_star_svg__WEBPACK_IMPORTED_MODULE_222__ = __webpack_require__(42941);
/* harmony import */ var _images_icons_star_svg__WEBPACK_IMPORTED_MODULE_222___default = /*#__PURE__*/__webpack_require__.n(_images_icons_star_svg__WEBPACK_IMPORTED_MODULE_222__);
/* harmony import */ var _images_icons_undo_svg__WEBPACK_IMPORTED_MODULE_223__ = __webpack_require__(69206);
/* harmony import */ var _images_icons_undo_svg__WEBPACK_IMPORTED_MODULE_223___default = /*#__PURE__*/__webpack_require__.n(_images_icons_undo_svg__WEBPACK_IMPORTED_MODULE_223__);
/* harmony import */ var _images_icons_redo_svg__WEBPACK_IMPORTED_MODULE_224__ = __webpack_require__(20065);
/* harmony import */ var _images_icons_redo_svg__WEBPACK_IMPORTED_MODULE_224___default = /*#__PURE__*/__webpack_require__.n(_images_icons_redo_svg__WEBPACK_IMPORTED_MODULE_224__);
/* harmony import */ var _images_icons_pencil_svg__WEBPACK_IMPORTED_MODULE_225__ = __webpack_require__(68278);
/* harmony import */ var _images_icons_pencil_svg__WEBPACK_IMPORTED_MODULE_225___default = /*#__PURE__*/__webpack_require__.n(_images_icons_pencil_svg__WEBPACK_IMPORTED_MODULE_225__);
/* harmony import */ var _images_icons_eye_open_svg__WEBPACK_IMPORTED_MODULE_226__ = __webpack_require__(75259);
/* harmony import */ var _images_icons_eye_open_svg__WEBPACK_IMPORTED_MODULE_226___default = /*#__PURE__*/__webpack_require__.n(_images_icons_eye_open_svg__WEBPACK_IMPORTED_MODULE_226__);
/* harmony import */ var _images_icons_eye_closed_svg__WEBPACK_IMPORTED_MODULE_227__ = __webpack_require__(47346);
/* harmony import */ var _images_icons_eye_closed_svg__WEBPACK_IMPORTED_MODULE_227___default = /*#__PURE__*/__webpack_require__.n(_images_icons_eye_closed_svg__WEBPACK_IMPORTED_MODULE_227__);
/* harmony import */ var _images_icons_user_plus_svg__WEBPACK_IMPORTED_MODULE_228__ = __webpack_require__(24327);
/* harmony import */ var _images_icons_user_plus_svg__WEBPACK_IMPORTED_MODULE_228___default = /*#__PURE__*/__webpack_require__.n(_images_icons_user_plus_svg__WEBPACK_IMPORTED_MODULE_228__);
/* harmony import */ var _images_icons_checkbox_checked_svg__WEBPACK_IMPORTED_MODULE_229__ = __webpack_require__(41614);
/* harmony import */ var _images_icons_checkbox_checked_svg__WEBPACK_IMPORTED_MODULE_229___default = /*#__PURE__*/__webpack_require__.n(_images_icons_checkbox_checked_svg__WEBPACK_IMPORTED_MODULE_229__);








































































































































































































































/***/ }),

/***/ 33103:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W$": () => (/* binding */ SELF_CONTROLLED_CONTENT_CLASS),
/* harmony export */   "SP": () => (/* binding */ isNodeSelfControlled),
/* harmony export */   "Dc": () => (/* binding */ wait),
/* harmony export */   "qN": () => (/* binding */ copyHtmlToClipboard),
/* harmony export */   "Ee": () => (/* binding */ mergeDeep),
/* harmony export */   "Xy": () => (/* binding */ isEqual),
/* harmony export */   "ZT": () => (/* binding */ getSelectedText),
/* harmony export */   "yG": () => (/* binding */ getAllPrototypes),
/* harmony export */   "Wv": () => (/* binding */ processConvertBlotWithComments),
/* harmony export */   "L6": () => (/* binding */ filterProps),
/* harmony export */   "J8": () => (/* binding */ arrayTrimEnd),
/* harmony export */   "Jj": () => (/* binding */ getWindow)
/* harmony export */ });
/* unused harmony exports getID, waitFor, isRendered, getDeletedYMapAttr, objDiff, getParsed, isObject, objUniques */
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87751);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_get_own_property_names_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36210);
/* harmony import */ var core_js_modules_es_object_get_own_property_names_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_names_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70189);
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69600);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(30489);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(26699);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(32023);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(40561);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(21249);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(91038);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(79758);
/* harmony import */ var _util_dom__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(67546);
/* harmony import */ var _plugins_popupManager_confirmPopup__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(23497);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }































// надо найти лучшее место для этой константы
var SELF_CONTROLLED_CONTENT_CLASS = 'self-controlled-content';
function isNodeSelfControlled(node) {
  node = (0,_util_dom__WEBPACK_IMPORTED_MODULE_28__/* .getElementNode */ .B8)(node);
  if (!node) {
    return false;
  }
  return Boolean(node.closest('.' + SELF_CONTROLLED_CONTENT_CLASS));
}
function getID(typeInst) {
  if (typeof typeInst.get === 'function' && typeInst.get('id')) {
    return typeInst.get('id');
  }
  return typeInst._id.user + '_' + typeInst._id.clock;
}

/**
 * waiting for YMap element to have status=true
 * once status is true cb is called
 * @param {YMap} el
 * @param {Function} cb
 */
function waitFor(el, cb) {
  if (el.get('status') === true) {
    return process.nextTick(cb);
  }
  el.observe(function observer() {
    if (el.get('status') !== true) {
      return;
    }
    el.unobserve(observer);
    cb();
  });
}
function wait(timeout) {
  return new Promise(function (resolve) {
    setTimeout(resolve, timeout);
  });
}

/**
 * checks if a node that uses yMap is renderered
 * @param {Boolean}
 */
function isRendered(yMap) {
  var id = getID(yMap);
  return Boolean(document.getElementById(id));
}
function getDeletedYMapAttr(yMap, key) {
  var v = yMap._map.get(key);
  if (v === undefined) {
    return undefined;
  }
  if (!v || !v._content) {
    return v;
  } else {
    return v._content[v._content.length - 1];
  }
}

// obj1 - obj2
function objDiff(obj1, obj2) {
  var diff = {};
  for (var k in obj2) {
    if (obj1[k] !== obj2[k]) {
      diff[k] = obj2[k];
    }
  }
  return diff;
}
function copyHtmlToClipboard(html) {
  if (_typeof(html) == "object") {
    html = html.outerHTML;
  }
  var container = document.createElement('div');
  container.innerHTML = html;
  container.style.position = 'fixed';
  container.style.pointerEvents = 'none';
  container.style.opacity = 0;
  var activeSheets = Array.prototype.slice.call(document.styleSheets).filter(function (sheet) {
    return !sheet.disabled;
  });
  document.body.appendChild(container);
  window.getSelection().removeAllRanges();
  var range = document.createRange();
  range.selectNode(container);
  window.getSelection().addRange(range);
  document.execCommand('copy');
  document.body.removeChild(container);
  return true;
}
if (typeof window !== 'undefined') {
  window.EPRFL = {
    _times: {},
    _starts: {},
    _callTimes: {},
    start: function start(name) {
      this._starts[name] = new Date().getTime();
    },
    end: function end(name) {
      if (!this._times[name]) {
        this._times[name] = 0;
        this._callTimes[name] = 0;
      }
      this._times[name] += new Date().getTime() - this._starts[name];
      this._callTimes[name]++;
    },
    show: function show() {
      for (var k in this._times) {
        console.info(k, this._times[k] / 1000, ', called', this._callTimes[k], 'times');
      }
    }
  };
}
function getParsed(value) {
  var str = String(value);
  var float = parseFloat(str.replace(',', '.'));
  if (!isNaN(float) && float.toString() === str) {
    return float;
  } else {
    return value;
  }
}
function mergeDeep(target) {
  if (!target) {
    target = {};
  }
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }
  if (!sources.length) {
    return target;
  }
  var source = sources.shift();
  if (isObject(target) && isObject(source)) {
    for (var key in source) {
      if (isObject(source[key])) {
        if (!target[key]) {
          Object.assign(target, _defineProperty({}, key, {}));
        }
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, _defineProperty({}, key, source[key]));
      }
    }
  }
  return mergeDeep.apply(void 0, [target].concat(sources));
}
function isObject(item) {
  return item && _typeof(item) === 'object' && !Array.isArray(item);
}
function isEqual(a, b) {
  if (_typeof(a) !== 'object' || _typeof(b) !== 'object') {
    return a === b;
  }
  if (a === null || b === null || typeof a === 'undefined' || typeof b === 'undefined') {
    return a === b;
  }
  var aProps = Object.getOwnPropertyNames(a);
  var bProps = Object.getOwnPropertyNames(b);
  if (aProps.length !== bProps.length) {
    return false;
  }
  var _iterator = _createForOfIteratorHelper(aProps),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var prop = _step.value;
      if (!isEqual(a[prop], b[prop])) {
        return false;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return true;
}
function objUniques(main, second) {
  var diff = {};
  var props = [].concat(Object.getOwnPropertyNames(main)).concat(Object.getOwnPropertyNames(second));
  var propsSet = new Set(props);
  propsSet.forEach(function (prop) {
    if (second.hasOwnProperty(prop)) {
      if (_typeof(main[prop]) === 'object' && _typeof(second[prop]) === 'object') {
        var propDiff = objUniques(main[prop], second[prop]);
        if (Object.keys(propDiff).length !== 0) {
          diff[prop] = propDiff;
        }
      } else if (main[prop] !== second[prop]) {
        diff[prop] = second[prop];
      }
    }
  });
  return diff;
}

/**
 * Функция возвращает выделенный текст и дельту
 * @param editor
 * @returns {{delta: [{}], text: string}}
 */
function getSelectedText(editor) {
  var blots = editor.scroll.getSelectedBlocks().reduce(function (blots, blot) {
    if (blot.hasTextLine) {
      return [].concat(_toConsumableArray(blots), _toConsumableArray(blot.getChildrenForAction()));
    } else {
      return [].concat(_toConsumableArray(blots), [blot]);
    }
  }, []);
  var texts = [];
  var deltas = [{
    ops: []
  }];
  blots.forEach(function (blot) {
    var _editor$scroll$select = editor.scroll.selection.getRange({
        offsetBlot: blot
      }),
      _editor$scroll$select2 = _slicedToArray(_editor$scroll$select, 1),
      blotRange = _editor$scroll$select2[0];
    var text = '';
    var delta = {
      ops: []
    };
    if (blotRange && blot && blot.getText && blot.getContents) {
      text = blot.getText(blotRange.index, blotRange.length);
      delta = blot.getContents(blotRange.index, blotRange.length);
      texts.push(text);
      deltas.push(delta);
    }
  });
  return {
    text: texts.join("\n"),
    delta: deltas
  };
}

/**
 * Функция возвращает массив всех прототипов сущьности
 * @param {any} entity
 * @returns {array}
 */
function getAllPrototypes(entity) {
  var prototypes = [];
  var prototype = Object.getPrototypeOf(entity);
  while (prototype !== null) {
    if (prototype) {
      prototypes.push(prototype);
    }
    prototype = Object.getPrototypeOf(prototype);
  }
  return prototypes;
}

/**
 * Показывает диалог для подтвержения конвертации если в параграфах есть более одного блота с комментариями
 * @param editor
 * @param wantsToClose
 * @param type
 * @returns {Promise<boolean>}
 */
function processConvertBlotWithComments(_x, _x2, _x3) {
  return _processConvertBlotWithComments.apply(this, arguments);
}

/*
 * Фильтрует объект по допустимому списку ключей
 * @param { objec t} props: объект
 * @param { array } filter: допустимые ключи
 * @param { array } types: типы значений
 * @returns {object} отфильтрованный объект
 */
function _processConvertBlotWithComments() {
  _processConvertBlotWithComments = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(editor, wantsToClose, type) {
    var selected, withBlotComments, withInlineComments, _editor$plugins, popupManager, commentManager, i18n, isSyntax, isButton, title, message, cancel;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            selected = [];
            withBlotComments = [];
            withInlineComments = [];
            _editor$plugins = editor.plugins, popupManager = _editor$plugins.popupManager, commentManager = _editor$plugins.commentManager, i18n = _editor$plugins.i18n;
            editor.scroll.getSelectedBlocks().forEach(function (blot) {
              // сохраняем болоты с комментариями
              if (blot.map.has('commentThreads')) {
                withBlotComments.push(blot);
              }
              if (commentManager.getBlotInlineComments(blot).length) {
                withInlineComments.push(blot);
              }
              // сохраняем выделенные блоты
              selected.push(blot);
            });
            isSyntax = (withBlotComments.length > 1 || withInlineComments.length) && type === 'syntax';
            isButton = withInlineComments.length && type === 'button-single';
            if (!(isSyntax || isButton)) {
              _context.next = 19;
              break;
            }
            title = i18n.get('syntax.convert.popup_title');
            message = withInlineComments.length ? i18n.get('syntax.convert.text_has_inline_comments') : i18n.get('syntax.convert.blots_have_comments');
            if (isButton) {
              title = i18n.get('button.convert.popup_title');
            }

            // закрываем меню
            wantsToClose && wantsToClose();
            // ожидаем когда пользователь нажмент на подтврерждение или отмену
            _context.next = 14;
            return new Promise(function (resolve) {
              var confirm;
              var onCancel = function onCancel() {
                resolve(true);
              };
              var onConfirm = function onConfirm() {
                // так как при клике на кнопку пропадает фокус с блотов то переустанавливаем выделение
                editor.scroll.setSelectedBlots(selected);
                resolve(false);
              };
              confirm = (0,preact__WEBPACK_IMPORTED_MODULE_27__.h)(_plugins_popupManager_confirmPopup__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                onCancel: onCancel,
                onConfirm: onConfirm,
                title: title,
                message: message,
                confirmText: i18n.get('syntax.convert.confirm'),
                editor: editor
              });
              popupManager.dialog(confirm);
            });
          case 14:
            cancel = _context.sent;
            // закрываем диалог
            confirm = null;
            popupManager.dialog(null);
            if (!cancel) {
              _context.next = 19;
              break;
            }
            return _context.abrupt("return", true);
          case 19:
            return _context.abrupt("return", false);
          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _processConvertBlotWithComments.apply(this, arguments);
}
function filterProps(props, filter) {
  var types = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var result = {};
  var _iterator2 = _createForOfIteratorHelper(filter),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var key = _step2.value;
      if (props.hasOwnProperty(key)) {
        if (types[key] === 'number') {
          result[key] = parseInt(props[key]);
        } else if (types[key] === 'boolean' || props[key] === 'true' || props[key] === 'false') {
          if (props[key] === 'false') {
            result[key] = false;
          } else {
            result[key] = props[key] ? true : false;
          }
        } else {
          result[key] = props[key];
        }
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return result;
}

/**
 * Удаляет элементы с конца массива
 * По умолчанию: false, undefined
 * @param {array} arr: массив
 * @param {array} clear: удаляемые значения, напр: false
 * @returns {array} очищенный массив
 */
function arrayTrimEnd() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var clear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [false, 'undefined'];
  for (var i = arr.length - 1; i >= 0; i--) {
    var type = _typeof(arr[i]);
    if (clear.includes(type) || clear.includes(arr[i])) {
      arr.splice(i, 1);
    } else {
      break;
    }
  }
  return arr;
}

/**
 * Возвращает заглушку на глобальный объект window если он не найден
 * @return {{removeEventListener: removeEventListener, addEventListener: addEventListener}|Window}
 */
var getWindow = function getWindow() {
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object') {
    return window;
  }
  console.log('window was not found');
  return {
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {}
  };
};

/***/ }),

/***/ 12650:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ao": () => (/* binding */ detectBrowser),
/* harmony export */   "tz": () => (/* binding */ detectPlatform),
/* harmony export */   "S5": () => (/* binding */ getBrowserViewport),
/* harmony export */   "s9": () => (/* binding */ isOffline),
/* harmony export */   "CF": () => (/* binding */ modKey),
/* harmony export */   "$d": () => (/* binding */ optionKey)
/* harmony export */ });
/* unused harmony export getMouseWheelEventName */
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_1__);


function detectBrowser() {
  if (typeof window === 'undefined') {
    return 'NodeJS';
  }
  var isOpera = !!window.opr && !!opr.addons || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
  var isFirefox = typeof InstallTrigger !== 'undefined';
  var isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
    return p.toString() === "[object SafariRemoteNotification]";
  }(!window['safari'] || typeof safari !== 'undefined' && safari.pushNotification);
  var isIE = /*@cc_on!@*/ false || !!document.documentMode;
  var isEdge = !isIE && !!window.StyleMedia;
  var isChrome = !!window.chrome;
  if (isOpera) {
    return 'Opera';
  }
  if (isFirefox) {
    return 'Firefox';
  }
  if (isSafari) {
    return 'Safari';
  }
  if (isIE) {
    return 'IE';
  }
  if (isEdge) {
    return 'Edge';
  }
  if (isChrome) {
    return 'Chrome';
  }
  return 'Unkown Browser';
}
function detectPlatform() {
  if (typeof window === 'undefined') {
    return 'NodeJS';
  }
  var userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
    windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
    iosPlatforms = ['iPhone', 'iPad', 'iPod'],
    os = null;
  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (!os && /Linux/.test(platform)) {
    os = 'Linux';
  }
  return os;
}
function getBrowserViewport() {
  return {
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight
  };
}
function getMouseWheelEventName() {
  return /Firefox/i.test(navigator.userAgent) ? "DOMMouseScroll" : "mousewheel";
}
function isOffline() {
  return navigator && !navigator.onLine;
}
var modKey = detectPlatform() === 'Mac OS' ? '⌘' : 'ctrl';
var optionKey = detectPlatform() === 'Mac OS' ? '⌥' : 'alt';

/***/ }),

/***/ 67546:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qL": () => (/* binding */ getFixedBoundingClientRect),
/* harmony export */   "_z": () => (/* binding */ getElementPosition),
/* harmony export */   "Dx": () => (/* binding */ getComputedStyle),
/* harmony export */   "AH": () => (/* binding */ getComputedStyles),
/* harmony export */   "qn": () => (/* binding */ searchUp),
/* harmony export */   "gx": () => (/* binding */ isNodeInViewport),
/* harmony export */   "S5": () => (/* binding */ isNodeConnected),
/* harmony export */   "nN": () => (/* binding */ isNodeEqualOrContain),
/* harmony export */   "vk": () => (/* binding */ getRelRect),
/* harmony export */   "B8": () => (/* binding */ getElementNode),
/* harmony export */   "Fp": () => (/* binding */ searchByCoordinates),
/* harmony export */   "np": () => (/* binding */ getScrollbarWidth),
/* harmony export */   "AI": () => (/* binding */ isNodeHasScrollbar),
/* harmony export */   "Im": () => (/* binding */ querySelectorAllDirectChildren),
/* harmony export */   "Jl": () => (/* binding */ nodeIsWebComponent),
/* harmony export */   "Ct": () => (/* binding */ PseudoDomNode),
/* harmony export */   "Mn": () => (/* binding */ PseudoMutationObserver),
/* harmony export */   "dp": () => (/* binding */ scrollToNode),
/* harmony export */   "Nj": () => (/* binding */ getTextNodesIn),
/* harmony export */   "XL": () => (/* binding */ unwrapNode),
/* harmony export */   "PB": () => (/* binding */ wrapNode),
/* harmony export */   "d9": () => (/* binding */ getNextSibling),
/* harmony export */   "No": () => (/* binding */ getAttributesString),
/* harmony export */   "FU": () => (/* binding */ contenteditableCursorToEnd)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26699);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32023);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69600);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91038);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var lodash_escape__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(66213);
/* harmony import */ var lodash_escape__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(lodash_escape__WEBPACK_IMPORTED_MODULE_17__);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



















// отличается от node.getBoundingClientRect() тем, что для элементов BODY и HTML возвращает фиксированный rect,
// начинающийся в начале viewport и заканчивающийся в его конце
function getFixedBoundingClientRect(node) {
  var rect;
  if (node.tagName === 'BODY' || node.tagName === 'HTML') {
    // просто возвращаем размеры вьюпорта
    var width = window.innerWidth;
    var height = window.innerHeight;
    rect = {
      left: 0,
      right: width,
      top: 0,
      bottom: height,
      x: 0,
      y: 0,
      width: width,
      height: height
    };
  } else {
    rect = node.getBoundingClientRect();
  }
  return rect;
}

/**
 * Получить положение и размеры элемента
 * @param {HTMLElement} node
 * @param {HTMLElement} parent если не null положение будет расчитано относительно этого элемента
 * @returns {{top: *, left: *, width: number, height: number}}
 */
function getElementPosition(node) {
  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var rect = node.getBoundingClientRect();
  var item = node;
  var top = rect.top + window.scrollY;
  var left = rect.left + window.scrollX;
  if (parent) {
    top = 0;
    left = 0;
    do {
      top += item.offsetTop || 0;
      left += item.offsetLeft || 0;
      item = item.offsetParent;
      if (item === parent) {
        item = null;
      }
    } while (item);
  }
  return {
    left: left,
    top: top,
    width: rect.width,
    height: rect.height
  };
}
function getComputedStyle(node, style) {
  var postfix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var val = window.getComputedStyle(node)[style];
  if (typeof val === 'string' && postfix) {
    val = parseFloat(val.replace(postfix, ''));
  }
  return val;
}
function getComputedStyles(node, styles) {
  var postfix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var computedStyles = window.getComputedStyle(node);
  var res = {};
  var _iterator = _createForOfIteratorHelper(styles),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var style = _step.value;
      var val = computedStyles[style];
      if (typeof val === 'string' && postfix) {
        val = parseFloat(val.replace(postfix, ''));
      }
      res[style] = val;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return res;
}
function searchUp(node, max, fn) {
  if (typeof max === 'function') {
    fn = max;
    max = Number.POSITIVE_INFINITY;
  }
  var iter = 0;
  while (node) {
    if (fn(node)) {
      return node;
    }
    node = node.parentNode;
    iter++;
    if (iter > max) {
      return null;
    }
  }
  return null;
}
function isNodeInViewport(node) {
  var rect = node.getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}
function isNodeConnected(node) {
  if (typeof node.isConnected !== 'undefined') {
    return node.isConnected;
  }
  return document.body.contains(node);
}
function isNodeEqualOrContain(node, target) {
  if (node === target) {
    return true;
  }
  if (!node) {
    return false;
  }
  if (!node.contains) {
    return false;
  }
  return node.contains(target);
}
function getRelRect(node, relNode) {
  var rect = node.getBoundingClientRect();
  var relRect = relNode.getBoundingClientRect();
  var result = {
    left: rect.left - relRect.left,
    top: rect.top + relNode.scrollTop - relRect.top,
    width: rect.width,
    height: rect.height
  };
  result.right = result.left + result.width;
  result.bottom = result.top + result.height;
  return result;
}
function getElementNode(node) {
  if (node.nodeType === Node.TEXT_NODE) {
    return node.parentNode;
  }
  return node;
}
function searchByCoordinates(start, dir, increment, end, fn) {
  var point = Object.assign({}, start);
  var checkEnd = function checkEnd() {
    if (increment > 0) {
      return point[dir] < end;
    } else {
      return point[dir] > end;
    }
  };
  for (; checkEnd(); point[dir] += increment) {
    var node = document.elementFromPoint(point.x, point.y);
    if (fn(node)) {
      return node;
    }
  }
  return null;
}
function getScrollbarWidth() {
  var outer = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.width = "100px";
  outer.style.msOverflowStyle = "scrollbar";
  document.body.appendChild(outer);
  var widthNoScroll = outer.offsetWidth;
  outer.style.overflow = "scroll";
  var inner = document.createElement("div");
  inner.style.width = "100%";
  outer.appendChild(inner);
  var widthWithScroll = inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  return widthNoScroll - widthWithScroll;
}
function isNodeHasScrollbar(node) {
  if (node.clientHeight < node.scrollHeight) {
    return true;
  }
  return false;
}
function querySelectorAllDirectChildren(node, selector) {
  var res = [];
  var _iterator2 = _createForOfIteratorHelper(node.childNodes),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var child = _step2.value;
      if (child.matches && child.matches(selector)) {
        res.push(child);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return res;
}
function nodeIsWebComponent(node) {
  return node.tagName && node.tagName.includes("-");
}
var PseudoDomNode = /*#__PURE__*/function () {
  function PseudoDomNode() {
    _classCallCheck(this, PseudoDomNode);
    this.childNodes = [];
  }
  _createClass(PseudoDomNode, [{
    key: "appendChild",
    value: function appendChild() {}
  }, {
    key: "insertBefore",
    value: function insertBefore() {}
  }, {
    key: "setAttribute",
    value: function setAttribute() {}
  }, {
    key: "getAttribute",
    value: function getAttribute() {}
  }]);
  return PseudoDomNode;
}();
var PseudoMutationObserver = /*#__PURE__*/function () {
  function PseudoMutationObserver() {
    _classCallCheck(this, PseudoMutationObserver);
  }
  _createClass(PseudoMutationObserver, [{
    key: "observe",
    value: function observe() {}
  }]);
  return PseudoMutationObserver;
}();
/**
 * Скроллит container до node, добавляет node класс highlighedClass
 *
 * @param {Node} container Контейнер, который нужно проскроллить
 * @param {Node} node Элемент до которого нужно проскроллить
 * @param {Object=} highlight Параметры подсветки ноды, можно передать null|false тогда блок не будет подсвечен
 * @param {Node=} highlight.node Нода, которой нужно присвоить класс подсветки
 * @param {String=} highlight.highlightClass Класс, который нужно добавить подсвечиваемой ноде
 * @param {Number=} highlight.timeout Таймаут подсветки ноды
 * @param {Boolean} smooth Плавная прокрутка
 */
function scrollToNode(container, node) {
  var highlight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    node: node,
    highlightClass: 'highlighted-block',
    timeout: 3000
  };
  var smooth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var initialSmooth = window.getComputedStyle(container).scrollBehavior;
  var highlightTimeout = null;
  //тут пришлось скопировать функцию из util/blot, при ее импорте ломается редактор
  var getContainerOffset = function getContainerOffset(node, container) {
    var x = 0;
    var y = 0;
    var el = node;
    while (el !== container && el !== null) {
      x += el.offsetLeft - el.scrollLeft;
      y += el.offsetTop - el.scrollTop;
      el = el.offsetParent;
    }
    return {
      x: x,
      y: y
    };
  };
  var onHighlightedNodeDocumentClick = function onHighlightedNodeDocumentClick(event) {
    if (highlightTimeout) {
      clearTimeout(highlightTimeout);
      highlightTimeout = null;
      highlight.node.classList.remove(highlight.highlightClass);
    }
    document.removeEventListener('click', onHighlightedNodeDocumentClick, false);
  };
  var nodeOffset = getContainerOffset(node, container);
  if (!smooth) {
    container.style.scrollBehavior = 'auto';
  }
  container.scrollTop = nodeOffset.y - 10 - offset;
  container.style.scrollBehavior = initialSmooth;
  if (highlight) {
    if (highlightTimeout) {
      try {
        clearTimeout(highlightTimeout);
      } catch (err) {}
    }
    highlight.node.classList.add(highlight.highlightClass);
    highlightTimeout = setTimeout(function () {
      highlight.node.classList.remove(highlight.highlightClass);
      document.removeEventListener('click', onHighlightedNodeDocumentClick, false);
    }, highlight.timeout);
    setTimeout(function () {
      document.addEventListener('click', onHighlightedNodeDocumentClick, false);
    }, 0);
  }
}

/**
 * Gets an array of the matching text nodes contained by the specified element.
 * @param  {!Element} elem
 *     The DOM element which will be traversed.
 * @param  {function(!Node,!Element):boolean} opt_fnFilter
 *     Optional function that if a true-ish value is returned will cause the
 *     text node in question to be added to the array to be returned from
 *     getTextNodesIn().  The first argument passed will be the text node in
 *     question while the second will be the parent of the text node.
 * @return {!Array.<!Node>}
 *     Array of the matching text nodes contained by the specified element.
 */
function getTextNodesIn(elem, opt_fnFilter) {
  var textNodes = [];
  if (elem) {
    for (var nodes = elem.childNodes, i = nodes.length; i--;) {
      var node = nodes[i],
        nodeType = node.nodeType;
      if (nodeType == 3) {
        if (!opt_fnFilter || opt_fnFilter(node, elem)) {
          textNodes.push(node);
        }
      } else if (nodeType == 1 || nodeType == 9 || nodeType == 11) {
        textNodes.push.apply(textNodes, _toConsumableArray(getTextNodesIn(node, opt_fnFilter)));
      }
    }
  }
  return textNodes;
}

/**
 * копирует дочерние элементы из node в родителя на место node и удаляет сам node
 * @param  {Node} node
 */
function unwrapNode(node) {
  var parent = node.parentNode;
  while (node.firstChild) {
    parent.insertBefore(node.firstChild, node);
  }
  parent.removeChild(node);
}

/**
 * оборачивает node во wrapper
 * @param  {Node} node
 * @param  {Node} wrapper
 */
function wrapNode(node, wrapper) {
  node.parentNode.insertBefore(wrapper, node);
  wrapper.appendChild(node);
}
function getNextSibling(node, fn) {
  if (!fn) {
    return node.nextSibling;
  }
  var sibling = node.nextSibling;
  while (sibling) {
    if (fn(sibling)) {
      break;
    }
    sibling = sibling.nextSibling;
  }
  return sibling;
}
function getAttributesString(node) {
  var skip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var attributes = [];
  var _iterator3 = _createForOfIteratorHelper(node.getAttributeNames()),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var attribute = _step3.value;
      if (skip.indexOf(attribute) >= 0) {
        continue;
      }
      attributes.push(attribute + '="' + lodash_escape__WEBPACK_IMPORTED_MODULE_17___default()(node.getAttribute(attribute)) + '"');
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return attributes.join(' ');
}

/**
 * Устанавливает курсор в конец contenteditable элемента
 * @param {Node} domNode
 */
function contenteditableCursorToEnd(domNode) {
  if (domNode) {
    domNode.focus();
    var selection = window.getSelection();
    var range = new Range();
    range.selectNodeContents(domNode);
    range.collapse();
    selection.removeAllRanges();
    selection.addRange(range);
  }
}

/***/ }),

/***/ 59150:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Encoder": () => (/* reexport */ Encoder),
  "IncUintOptRleEncoder": () => (/* reexport */ IncUintOptRleEncoder),
  "IntDiffEncoder": () => (/* reexport */ IntDiffEncoder),
  "IntDiffOptRleEncoder": () => (/* reexport */ IntDiffOptRleEncoder),
  "RleEncoder": () => (/* reexport */ RleEncoder),
  "RleIntDiffEncoder": () => (/* reexport */ RleIntDiffEncoder),
  "StringEncoder": () => (/* reexport */ StringEncoder),
  "UintOptRleEncoder": () => (/* reexport */ UintOptRleEncoder),
  "ab2str": () => (/* binding */ ab2str),
  "createEncoder": () => (/* reexport */ createEncoder),
  "length": () => (/* reexport */ encoding_length),
  "set": () => (/* reexport */ set),
  "setUint16": () => (/* reexport */ setUint16),
  "setUint32": () => (/* reexport */ setUint32),
  "setUint8": () => (/* reexport */ setUint8),
  "str2ab": () => (/* binding */ str2ab),
  "toBuffer": () => (/* binding */ toBuffer),
  "toUint8Array": () => (/* reexport */ _toUint8Array),
  "write": () => (/* reexport */ write),
  "writeAny": () => (/* reexport */ writeAny),
  "writeBigInt64": () => (/* reexport */ writeBigInt64),
  "writeBigUint64": () => (/* reexport */ writeBigUint64),
  "writeBinaryEncoder": () => (/* reexport */ writeBinaryEncoder),
  "writeFloat32": () => (/* reexport */ writeFloat32),
  "writeFloat64": () => (/* reexport */ writeFloat64),
  "writeOnDataView": () => (/* reexport */ writeOnDataView),
  "writeUint16": () => (/* reexport */ writeUint16),
  "writeUint32": () => (/* reexport */ writeUint32),
  "writeUint32BigEndian": () => (/* reexport */ writeUint32BigEndian),
  "writeUint8": () => (/* reexport */ writeUint8),
  "writeUint8Array": () => (/* reexport */ writeUint8Array),
  "writeVarInt": () => (/* reexport */ writeVarInt),
  "writeVarString": () => (/* reexport */ writeVarString),
  "writeVarUint": () => (/* reexport */ writeVarUint),
  "writeVarUint8Array": () => (/* reexport */ writeVarUint8Array)
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.uint8-array.js
var es_typed_array_uint8_array = __webpack_require__(82472);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.copy-within.js
var es_typed_array_copy_within = __webpack_require__(92990);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.every.js
var es_typed_array_every = __webpack_require__(18927);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.fill.js
var es_typed_array_fill = __webpack_require__(33105);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.filter.js
var es_typed_array_filter = __webpack_require__(35035);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.find.js
var es_typed_array_find = __webpack_require__(74345);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.find-index.js
var es_typed_array_find_index = __webpack_require__(7174);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.for-each.js
var es_typed_array_for_each = __webpack_require__(32846);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.includes.js
var es_typed_array_includes = __webpack_require__(44731);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.index-of.js
var es_typed_array_index_of = __webpack_require__(77209);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.iterator.js
var es_typed_array_iterator = __webpack_require__(96319);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.join.js
var es_typed_array_join = __webpack_require__(58867);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.last-index-of.js
var es_typed_array_last_index_of = __webpack_require__(37789);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.map.js
var es_typed_array_map = __webpack_require__(33739);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reduce.js
var es_typed_array_reduce = __webpack_require__(29368);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reduce-right.js
var es_typed_array_reduce_right = __webpack_require__(14483);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reverse.js
var es_typed_array_reverse = __webpack_require__(12056);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.set.js
var es_typed_array_set = __webpack_require__(3462);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.slice.js
var es_typed_array_slice = __webpack_require__(30678);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.some.js
var es_typed_array_some = __webpack_require__(27462);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.sort.js
var es_typed_array_sort = __webpack_require__(33824);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.subarray.js
var es_typed_array_subarray = __webpack_require__(55021);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.to-locale-string.js
var es_typed_array_to_locale_string = __webpack_require__(12974);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.to-string.js
var es_typed_array_to_string = __webpack_require__(15016);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array-buffer.constructor.js
var es_array_buffer_constructor = __webpack_require__(18264);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.code-point-at.js
var es_string_code_point_at = __webpack_require__(79841);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(69600);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(30489);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__(12419);
// EXTERNAL MODULE: ./node_modules/@lib/editor/node_modules/lib0/buffer.js + 5 modules
var buffer = __webpack_require__(83322);
// EXTERNAL MODULE: ./node_modules/@lib/editor/node_modules/lib0/math.js
var math = __webpack_require__(23862);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.max-safe-integer.js
var es_number_max_safe_integer = __webpack_require__(44363);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(9653);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.min-safe-integer.js
var es_number_min_safe_integer = __webpack_require__(55994);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.is-integer.js
var es_number_is_integer = __webpack_require__(33161);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.is-nan.js
var es_number_is_nan = __webpack_require__(44048);
// EXTERNAL MODULE: ./node_modules/@lib/editor/node_modules/lib0/binary.js
var binary = __webpack_require__(6686);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/node_modules/lib0/number.js





/**
 * Utility helpers for working with numbers.
 *
 * @module number
 */



var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER;
var MIN_SAFE_INTEGER = Number.MIN_SAFE_INTEGER;
var LOWEST_INT32 = (/* unused pure expression or super */ null && (1 << 31));
/**
 * @type {number}
 */
var HIGHEST_INT32 = binary/* BITS31 */.RP;

/**
 * @module number
 */

/* istanbul ignore next */
var isInteger = Number.isInteger || function (num) {
  return typeof num === 'number' && isFinite(num) && math/* floor */.GW(num) === num;
};
var number_isNaN = Number.isNaN;
;// CONCATENATED MODULE: ./node_modules/@lib/editor/node_modules/lib0/encoding.js
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }





































function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
/**
 * Efficient schema-less binary encoding with support for variable length encoding.
 *
 * Use [lib0/encoding] with [lib0/decoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = new encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = new decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module encoding
 */






/**
 * A BinaryEncoder handles the encoding to an Uint8Array.
 */
var Encoder = function Encoder() {
  _classCallCheck(this, Encoder);
  this.cpos = 0;
  this.cbuf = new Uint8Array(100);
  /**
   * @type {Array<Uint8Array>}
   */
  this.bufs = [];
};

/**
 * @function
 * @return {Encoder}
 */
var createEncoder = function createEncoder() {
  return new Encoder();
};

/**
 * The current length of the encoded data.
 *
 * @function
 * @param {Encoder} encoder
 * @return {number}
 */
var encoding_length = function length(encoder) {
  var len = encoder.cpos;
  for (var i = 0; i < encoder.bufs.length; i++) {
    len += encoder.bufs[i].length;
  }
  return len;
};

/**
 * Transform to Uint8Array.
 *
 * @function
 * @param {Encoder} encoder
 * @return {Uint8Array} The created ArrayBuffer.
 */
var _toUint8Array = function toUint8Array(encoder) {
  var uint8arr = new Uint8Array(encoding_length(encoder));
  var curPos = 0;
  for (var i = 0; i < encoder.bufs.length; i++) {
    var d = encoder.bufs[i];
    uint8arr.set(d, curPos);
    curPos += d.length;
  }
  uint8arr.set(buffer/* createUint8ArrayViewFromArrayBuffer */.Te(encoder.cbuf.buffer, 0, encoder.cpos), curPos);
  return uint8arr;
};

/**
 * Verify that it is possible to write `len` bytes wtihout checking. If
 * necessary, a new Buffer with the required length is attached.
 *
 * @param {Encoder} encoder
 * @param {number} len
 */

var verifyLen = function verifyLen(encoder, len) {
  var bufferLen = encoder.cbuf.length;
  if (bufferLen - encoder.cpos < len) {
    encoder.bufs.push(buffer/* createUint8ArrayViewFromArrayBuffer */.Te(encoder.cbuf.buffer, 0, encoder.cpos));
    encoder.cbuf = new Uint8Array(math/* max */.Fp(bufferLen, len) * 2);
    encoder.cpos = 0;
  }
};

/**
 * Write one byte to the encoder.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The byte that is to be encoded.
 */
var write = function write(encoder, num) {
  var bufferLen = encoder.cbuf.length;
  if (encoder.cpos === bufferLen) {
    encoder.bufs.push(encoder.cbuf);
    encoder.cbuf = new Uint8Array(bufferLen * 2);
    encoder.cpos = 0;
  }
  encoder.cbuf[encoder.cpos++] = num;
};

/**
 * Write one byte at a specific position.
 * Position must already be written (i.e. encoder.length > pos)
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} pos Position to which to write data
 * @param {number} num Unsigned 8-bit integer
 */
var set = function set(encoder, pos, num) {
  var buffer = null;
  // iterate all buffers and adjust position
  for (var i = 0; i < encoder.bufs.length && buffer === null; i++) {
    var b = encoder.bufs[i];
    if (pos < b.length) {
      buffer = b; // found buffer
    } else {
      pos -= b.length;
    }
  }
  if (buffer === null) {
    // use current buffer
    buffer = encoder.cbuf;
  }
  buffer[pos] = num;
};

/**
 * Write one byte as an unsigned integer.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
var writeUint8 = write;

/**
 * Write one byte as an unsigned Integer at a specific location.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} pos The location where the data will be written.
 * @param {number} num The number that is to be encoded.
 */
var setUint8 = set;

/**
 * Write two bytes as an unsigned integer.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
var writeUint16 = function writeUint16(encoder, num) {
  write(encoder, num & binary/* BITS8 */.x);
  write(encoder, num >>> 8 & binary/* BITS8 */.x);
};
/**
 * Write two bytes as an unsigned integer at a specific location.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} pos The location where the data will be written.
 * @param {number} num The number that is to be encoded.
 */
var setUint16 = function setUint16(encoder, pos, num) {
  set(encoder, pos, num & binary/* BITS8 */.x);
  set(encoder, pos + 1, num >>> 8 & binary/* BITS8 */.x);
};

/**
 * Write two bytes as an unsigned integer
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
var writeUint32 = function writeUint32(encoder, num) {
  for (var i = 0; i < 4; i++) {
    write(encoder, num & binary/* BITS8 */.x);
    num >>>= 8;
  }
};

/**
 * Write two bytes as an unsigned integer in big endian order.
 * (most significant byte first)
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
var writeUint32BigEndian = function writeUint32BigEndian(encoder, num) {
  for (var i = 3; i >= 0; i--) {
    write(encoder, num >>> 8 * i & binary/* BITS8 */.x);
  }
};

/**
 * Write two bytes as an unsigned integer at a specific location.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} pos The location where the data will be written.
 * @param {number} num The number that is to be encoded.
 */
var setUint32 = function setUint32(encoder, pos, num) {
  for (var i = 0; i < 4; i++) {
    set(encoder, pos + i, num & binary/* BITS8 */.x);
    num >>>= 8;
  }
};

/**
 * Write a variable length unsigned integer.
 *
 * Encodes integers in the range from [0, 4294967295] / [0, 0xffffffff]. (max 32 bit unsigned integer)
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
var writeVarUint = function writeVarUint(encoder, num) {
  while (num > binary/* BITS7 */.jS) {
    write(encoder, binary/* BIT8 */.x1 | binary/* BITS7 */.jS & num);
    num >>>= 7;
  }
  write(encoder, binary/* BITS7 */.jS & num);
};

/**
 * Write a variable length integer.
 *
 * Encodes integers in the range from [-2147483648, -2147483647].
 *
 * We don't use zig-zag encoding because we want to keep the option open
 * to use the same function for BigInt and 53bit integers (doubles).
 *
 * We use the 7th bit instead for signaling that this is a negative number.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
var writeVarInt = function writeVarInt(encoder, num) {
  var isNegative = math/* isNegativeZero */.GR(num);
  if (isNegative) {
    num = -num;
  }
  //             |- whether to continue reading         |- whether is negative     |- number
  write(encoder, (num > binary/* BITS6 */.$2 ? binary/* BIT8 */.x1 : 0) | (isNegative ? binary/* BIT7 */.rc : 0) | binary/* BITS6 */.$2 & num);
  num >>>= 6;
  // We don't need to consider the case of num === 0 so we can use a different
  // pattern here than above.
  while (num > 0) {
    write(encoder, (num > binary/* BITS7 */.jS ? binary/* BIT8 */.x1 : 0) | binary/* BITS7 */.jS & num);
    num >>>= 7;
  }
};

/**
 * Write a variable length string.
 *
 * @function
 * @param {Encoder} encoder
 * @param {String} str The string that is to be encoded.
 */
var writeVarString = function writeVarString(encoder, str) {
  var encodedString = unescape(encodeURIComponent(str));
  var len = encodedString.length;
  writeVarUint(encoder, len);
  for (var i = 0; i < len; i++) {
    write(encoder, encodedString.codePointAt(i));
  }
};

/**
 * Write the content of another Encoder.
 *
 * @TODO: can be improved!
 *        - Note: Should consider that when appending a lot of small Encoders, we should rather clone than referencing the old structure.
 *                Encoders start with a rather big initial buffer.
 *
 * @function
 * @param {Encoder} encoder The enUint8Arr
 * @param {Encoder} append The BinaryEncoder to be written.
 */
var writeBinaryEncoder = function writeBinaryEncoder(encoder, append) {
  return writeUint8Array(encoder, _toUint8Array(append));
};

/**
 * Append fixed-length Uint8Array to the encoder.
 *
 * @function
 * @param {Encoder} encoder
 * @param {Uint8Array} uint8Array
 */
var writeUint8Array = function writeUint8Array(encoder, uint8Array) {
  var bufferLen = encoder.cbuf.length;
  var cpos = encoder.cpos;
  var leftCopyLen = math/* min */.VV(bufferLen - cpos, uint8Array.length);
  var rightCopyLen = uint8Array.length - leftCopyLen;
  encoder.cbuf.set(uint8Array.subarray(0, leftCopyLen), cpos);
  encoder.cpos += leftCopyLen;
  if (rightCopyLen > 0) {
    // Still something to write, write right half..
    // Append new buffer
    encoder.bufs.push(encoder.cbuf);
    // must have at least size of remaining buffer
    encoder.cbuf = new Uint8Array(math/* max */.Fp(bufferLen * 2, rightCopyLen));
    // copy array
    encoder.cbuf.set(uint8Array.subarray(leftCopyLen));
    encoder.cpos = rightCopyLen;
  }
};

/**
 * Append an Uint8Array to Encoder.
 *
 * @function
 * @param {Encoder} encoder
 * @param {Uint8Array} uint8Array
 */
var writeVarUint8Array = function writeVarUint8Array(encoder, uint8Array) {
  writeVarUint(encoder, uint8Array.byteLength);
  writeUint8Array(encoder, uint8Array);
};

/**
 * Create an DataView of the next `len` bytes. Use it to write data after
 * calling this function.
 *
 * ```js
 * // write float32 using DataView
 * const dv = writeOnDataView(encoder, 4)
 * dv.setFloat32(0, 1.1)
 * // read float32 using DataView
 * const dv = readFromDataView(encoder, 4)
 * dv.getFloat32(0) // => 1.100000023841858 (leaving it to the reader to find out why this is the correct result)
 * ```
 *
 * @param {Encoder} encoder
 * @param {number} len
 * @return {DataView}
 */
var writeOnDataView = function writeOnDataView(encoder, len) {
  verifyLen(encoder, len);
  var dview = new DataView(encoder.cbuf.buffer, encoder.cpos, len);
  encoder.cpos += len;
  return dview;
};

/**
 * @param {Encoder} encoder
 * @param {number} num
 */
var writeFloat32 = function writeFloat32(encoder, num) {
  return writeOnDataView(encoder, 4).setFloat32(0, num, false);
};

/**
 * @param {Encoder} encoder
 * @param {number} num
 */
var writeFloat64 = function writeFloat64(encoder, num) {
  return writeOnDataView(encoder, 8).setFloat64(0, num, false);
};

/**
 * @param {Encoder} encoder
 * @param {bigint} num
 */
var writeBigInt64 = function writeBigInt64(encoder, num) {
  return (/** @type {any} */writeOnDataView(encoder, 8).setBigInt64(0, num, false)
  );
};

/**
 * @param {Encoder} encoder
 * @param {bigint} num
 */
var writeBigUint64 = function writeBigUint64(encoder, num) {
  return (/** @type {any} */writeOnDataView(encoder, 8).setBigUint64(0, num, false)
  );
};
var floatTestBed = new DataView(new ArrayBuffer(4));
/**
 * Check if a number can be encoded as a 32 bit float.
 *
 * @param {number} num
 * @return {boolean}
 */
var isFloat32 = function isFloat32(num) {
  floatTestBed.setFloat32(0, num);
  return floatTestBed.getFloat32(0) === num;
};

/**
 * Encode data with efficient binary format.
 *
 * Differences to JSON:
 * • Transforms data to a binary format (not to a string)
 * • Encodes undefined, NaN, and ArrayBuffer (these can't be represented in JSON)
 * • Numbers are efficiently encoded either as a variable length integer, as a
 *   32 bit float, as a 64 bit float, or as a 64 bit bigint.
 *
 * Encoding table:
 *
 * | Data Type           | Prefix   | Encoding Method    | Comment |
 * | ------------------- | -------- | ------------------ | ------- |
 * | undefined           | 127      |                    | Functions, symbol, and everything that cannot be identified is encoded as undefined |
 * | null                | 126      |                    | |
 * | integer             | 125      | writeVarInt        | Only encodes 32 bit signed integers |
 * | float32             | 124      | writeFloat32       | |
 * | float64             | 123      | writeFloat64       | |
 * | bigint              | 122      | writeBigInt64      | |
 * | boolean (false)     | 121      |                    | True and false are different data types so we save the following byte |
 * | boolean (true)      | 120      |                    | - 0b01111000 so the last bit determines whether true or false |
 * | string              | 119      | writeVarString     | |
 * | object<string,any>  | 118      | custom             | Writes {length} then {length} key-value pairs |
 * | array<any>          | 117      | custom             | Writes {length} then {length} json values |
 * | Uint8Array          | 116      | writeVarUint8Array | We use Uint8Array for any kind of binary data |
 *
 * Reasons for the decreasing prefix:
 * We need the first bit for extendability (later we may want to encode the
 * prefix with writeVarUint). The remaining 7 bits are divided as follows:
 * [0-30]   the beginning of the data range is used for custom purposes
 *          (defined by the function that uses this library)
 * [31-127] the end of the data range is used for data encoding by
 *          lib0/encoding.js
 *
 * @param {Encoder} encoder
 * @param {undefined|null|number|bigint|boolean|string|Object<string,any>|Array<any>|Uint8Array} data
 */
var writeAny = function writeAny(encoder, data) {
  switch (_typeof(data)) {
    case 'string':
      // TYPE 119: STRING
      write(encoder, 119);
      writeVarString(encoder, data);
      break;
    case 'number':
      if (isInteger(data) && data <= binary/* BITS31 */.RP) {
        // TYPE 125: INTEGER
        write(encoder, 125);
        writeVarInt(encoder, data);
      } else if (isFloat32(data)) {
        // TYPE 124: FLOAT32
        write(encoder, 124);
        writeFloat32(encoder, data);
      } else {
        // TYPE 123: FLOAT64
        write(encoder, 123);
        writeFloat64(encoder, data);
      }
      break;
    case 'bigint':
      // TYPE 122: BigInt
      write(encoder, 122);
      writeBigInt64(encoder, data);
      break;
    case 'object':
      if (data === null) {
        // TYPE 126: null
        write(encoder, 126);
      } else if (data instanceof Array) {
        // TYPE 117: Array
        write(encoder, 117);
        writeVarUint(encoder, data.length);
        for (var i = 0; i < data.length; i++) {
          writeAny(encoder, data[i]);
        }
      } else if (data instanceof Uint8Array) {
        // TYPE 116: ArrayBuffer
        write(encoder, 116);
        writeVarUint8Array(encoder, data);
      } else {
        // TYPE 118: Object
        write(encoder, 118);
        var keys = Object.keys(data);
        writeVarUint(encoder, keys.length);
        for (var _i = 0; _i < keys.length; _i++) {
          var key = keys[_i];
          writeVarString(encoder, key);
          writeAny(encoder, data[key]);
        }
      }
      break;
    case 'boolean':
      // TYPE 120/121: boolean (true/false)
      write(encoder, data ? 120 : 121);
      break;
    default:
      // TYPE 127: undefined
      write(encoder, 127);
  }
};

/**
 * Now come a few stateful encoder that have their own classes.
 */

/**
 * Basic Run Length Encoder - a basic compression implementation.
 *
 * Encodes [1,1,1,7] to [1,3,7,1] (3 times 1, 1 time 7). This encoder might do more harm than good if there are a lot of values that are not repeated.
 *
 * It was originally used for image compression. Cool .. article http://csbruce.com/cbm/transactor/pdfs/trans_v7_i06.pdf
 *
 * @note T must not be null!
 *
 * @template T
 */
var RleEncoder = /*#__PURE__*/function (_Encoder) {
  _inherits(RleEncoder, _Encoder);
  var _super = _createSuper(RleEncoder);
  /**
   * @param {function(Encoder, T):void} writer
   */
  function RleEncoder(writer) {
    var _this;
    _classCallCheck(this, RleEncoder);
    _this = _super.call(this);
    /**
     * The writer
     */
    _this.w = writer;
    /**
     * Current state
     * @type {T|null}
     */
    _this.s = null;
    _this.count = 0;
    return _this;
  }

  /**
   * @param {T} v
   */
  _createClass(RleEncoder, [{
    key: "write",
    value: function write(v) {
      if (this.s === v) {
        this.count++;
      } else {
        if (this.count > 0) {
          // flush counter, unless this is the first value (count = 0)
          writeVarUint(this, this.count - 1); // since count is always > 0, we can decrement by one. non-standard encoding ftw
        }

        this.count = 1;
        // write first value
        this.w(this, v);
        this.s = v;
      }
    }
  }]);
  return RleEncoder;
}(Encoder);

/**
 * Basic diff decoder using variable length encoding.
 *
 * Encodes the values [3, 1100, 1101, 1050, 0] to [3, 1097, 1, -51, -1050] using writeVarInt.
 */
var IntDiffEncoder = /*#__PURE__*/function (_Encoder2) {
  _inherits(IntDiffEncoder, _Encoder2);
  var _super2 = _createSuper(IntDiffEncoder);
  /**
   * @param {number} start
   */
  function IntDiffEncoder(start) {
    var _this2;
    _classCallCheck(this, IntDiffEncoder);
    _this2 = _super2.call(this);
    /**
     * Current state
     * @type {number}
     */
    _this2.s = start;
    return _this2;
  }

  /**
   * @param {number} v
   */
  _createClass(IntDiffEncoder, [{
    key: "write",
    value: function write(v) {
      writeVarInt(this, v - this.s);
      this.s = v;
    }
  }]);
  return IntDiffEncoder;
}(Encoder);

/**
 * A combination of IntDiffEncoder and RleEncoder.
 *
 * Basically first writes the IntDiffEncoder and then counts duplicate diffs using RleEncoding.
 *
 * Encodes the values [1,1,1,2,3,4,5,6] as [1,1,0,2,1,5] (RLE([1,0,0,1,1,1,1,1]) ⇒ RleIntDiff[1,1,0,2,1,5])
 */
var RleIntDiffEncoder = /*#__PURE__*/function (_Encoder3) {
  _inherits(RleIntDiffEncoder, _Encoder3);
  var _super3 = _createSuper(RleIntDiffEncoder);
  /**
   * @param {number} start
   */
  function RleIntDiffEncoder(start) {
    var _this3;
    _classCallCheck(this, RleIntDiffEncoder);
    _this3 = _super3.call(this);
    /**
     * Current state
     * @type {number}
     */
    _this3.s = start;
    _this3.count = 0;
    return _this3;
  }

  /**
   * @param {number} v
   */
  _createClass(RleIntDiffEncoder, [{
    key: "write",
    value: function write(v) {
      if (this.s === v && this.count > 0) {
        this.count++;
      } else {
        if (this.count > 0) {
          // flush counter, unless this is the first value (count = 0)
          writeVarUint(this, this.count - 1); // since count is always > 0, we can decrement by one. non-standard encoding ftw
        }

        this.count = 1;
        // write first value
        writeVarInt(this, v - this.s);
        this.s = v;
      }
    }
  }]);
  return RleIntDiffEncoder;
}(Encoder);

/**
 * @param {UintOptRleEncoder} encoder
 */
var flushUintOptRleEncoder = function flushUintOptRleEncoder(encoder) {
  /* istanbul ignore else */
  if (encoder.count > 0) {
    // flush counter, unless this is the first value (count = 0)
    // case 1: just a single value. set sign to positive
    // case 2: write several values. set sign to negative to indicate that there is a length coming
    writeVarInt(encoder.encoder, encoder.count === 1 ? encoder.s : -encoder.s);
    if (encoder.count > 1) {
      writeVarUint(encoder.encoder, encoder.count - 2); // since count is always > 1, we can decrement by one. non-standard encoding ftw
    }
  }
};

/**
 * Optimized Rle encoder that does not suffer from the mentioned problem of the basic Rle encoder.
 *
 * Internally uses VarInt encoder to write unsigned integers. If the input occurs multiple times, we write
 * write it as a negative number. The UintOptRleDecoder then understands that it needs to read a count.
 *
 * Encodes [1,2,3,3,3] as [1,2,-3,3] (once 1, once 2, three times 3)
 */
var UintOptRleEncoder = /*#__PURE__*/function () {
  function UintOptRleEncoder() {
    _classCallCheck(this, UintOptRleEncoder);
    this.encoder = new Encoder();
    /**
     * @type {number}
     */
    this.s = 0;
    this.count = 0;
  }

  /**
   * @param {number} v
   */
  _createClass(UintOptRleEncoder, [{
    key: "write",
    value: function write(v) {
      if (this.s === v) {
        this.count++;
      } else {
        flushUintOptRleEncoder(this);
        this.count = 1;
        this.s = v;
      }
    }
  }, {
    key: "toUint8Array",
    value: function toUint8Array() {
      flushUintOptRleEncoder(this);
      return _toUint8Array(this.encoder);
    }
  }]);
  return UintOptRleEncoder;
}();

/**
 * Increasing Uint Optimized RLE Encoder
 *
 * The RLE encoder counts the number of same occurences of the same value.
 * The IncUintOptRle encoder counts if the value increases.
 * I.e. 7, 8, 9, 10 will be encoded as [-7, 4]. 1, 3, 5 will be encoded
 * as [1, 3, 5].
 */
var IncUintOptRleEncoder = /*#__PURE__*/function () {
  function IncUintOptRleEncoder() {
    _classCallCheck(this, IncUintOptRleEncoder);
    this.encoder = new Encoder();
    /**
     * @type {number}
     */
    this.s = 0;
    this.count = 0;
  }

  /**
   * @param {number} v
   */
  _createClass(IncUintOptRleEncoder, [{
    key: "write",
    value: function write(v) {
      if (this.s + this.count === v) {
        this.count++;
      } else {
        flushUintOptRleEncoder(this);
        this.count = 1;
        this.s = v;
      }
    }
  }, {
    key: "toUint8Array",
    value: function toUint8Array() {
      flushUintOptRleEncoder(this);
      return _toUint8Array(this.encoder);
    }
  }]);
  return IncUintOptRleEncoder;
}();

/**
 * @param {IntDiffOptRleEncoder} encoder
 */
var flushIntDiffOptRleEncoder = function flushIntDiffOptRleEncoder(encoder) {
  if (encoder.count > 0) {
    //          31 bit making up the diff | wether to write the counter
    var encodedDiff = encoder.diff << 1 | (encoder.count === 1 ? 0 : 1);
    // flush counter, unless this is the first value (count = 0)
    // case 1: just a single value. set first bit to positive
    // case 2: write several values. set first bit to negative to indicate that there is a length coming
    writeVarInt(encoder.encoder, encodedDiff);
    if (encoder.count > 1) {
      writeVarUint(encoder.encoder, encoder.count - 2); // since count is always > 1, we can decrement by one. non-standard encoding ftw
    }
  }
};

/**
 * A combination of the IntDiffEncoder and the UintOptRleEncoder.
 *
 * The count approach is similar to the UintDiffOptRleEncoder, but instead of using the negative bitflag, it encodes
 * in the LSB whether a count is to be read. Therefore this Encoder only supports 31 bit integers!
 *
 * Encodes [1, 2, 3, 2] as [3, 1, 6, -1] (more specifically [(1 << 1) | 1, (3 << 0) | 0, -1])
 *
 * Internally uses variable length encoding. Contrary to normal UintVar encoding, the first byte contains:
 * * 1 bit that denotes whether the next value is a count (LSB)
 * * 1 bit that denotes whether this value is negative (MSB - 1)
 * * 1 bit that denotes whether to continue reading the variable length integer (MSB)
 *
 * Therefore, only five bits remain to encode diff ranges.
 *
 * Use this Encoder only when appropriate. In most cases, this is probably a bad idea.
 */
var IntDiffOptRleEncoder = /*#__PURE__*/function () {
  function IntDiffOptRleEncoder() {
    _classCallCheck(this, IntDiffOptRleEncoder);
    this.encoder = new Encoder();
    /**
     * @type {number}
     */
    this.s = 0;
    this.count = 0;
    this.diff = 0;
  }

  /**
   * @param {number} v
   */
  _createClass(IntDiffOptRleEncoder, [{
    key: "write",
    value: function write(v) {
      if (this.diff === v - this.s) {
        this.s = v;
        this.count++;
      } else {
        flushIntDiffOptRleEncoder(this);
        this.count = 1;
        this.diff = v - this.s;
        this.s = v;
      }
    }
  }, {
    key: "toUint8Array",
    value: function toUint8Array() {
      flushIntDiffOptRleEncoder(this);
      return _toUint8Array(this.encoder);
    }
  }]);
  return IntDiffOptRleEncoder;
}();

/**
 * Optimized String Encoder.
 *
 * Encoding many small strings in a simple Encoder is not very efficient. The function call to decode a string takes some time and creates references that must be eventually deleted.
 * In practice, when decoding several million small strings, the GC will kick in more and more often to collect orphaned string objects (or maybe there is another reason?).
 *
 * This string encoder solves the above problem. All strings are concatenated and written as a single string using a single encoding call.
 *
 * The lengths are encoded using a UintOptRleEncoder.
 */
var StringEncoder = /*#__PURE__*/function () {
  function StringEncoder() {
    _classCallCheck(this, StringEncoder);
    /**
     * @type {Array<string>}
     */
    this.sarr = [];
    this.s = '';
    this.lensE = new UintOptRleEncoder();
  }

  /**
   * @param {string} string
   */
  _createClass(StringEncoder, [{
    key: "write",
    value: function write(string) {
      this.s += string;
      if (this.s.length > 19) {
        this.sarr.push(this.s);
        this.s = '';
      }
      this.lensE.write(string.length);
    }
  }, {
    key: "toUint8Array",
    value: function toUint8Array() {
      var encoder = new Encoder();
      this.sarr.push(this.s);
      this.s = '';
      writeVarString(encoder, this.sarr.join(''));
      writeUint8Array(encoder, this.lensE.toUint8Array());
      return _toUint8Array(encoder);
    }
  }]);
  return StringEncoder;
}();
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/util/encoding.js





























function toBuffer(encoding) {
  return _toUint8Array(encoding);
}
function ab2str(buf) {
  return String.fromCharCode.apply(null, new Uint8Array(buf));
}
function str2ab(str) {
  var buf = new ArrayBuffer(str.length * 2);
  var bufView = new Uint8Array(buf);
  for (var i = 0, strLen = str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
}

/***/ }),

/***/ 92143:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": () => (/* binding */ createPopper)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var popper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12212);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








function createPopper(anchor, popup) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var allowFlip = true;
  var storeState = {};
  options = Object.assign({
    placement: 'right-start',
    preservePosition: true,
    removeOnDestroy: true,
    behavior: 'flip',
    priority: ['bottom', 'top'],
    offset: '-11px, 0',
    boundariesElement: 'viewport'
  }, options);
  var fn = null;
  if (options.preservePosition) {
    fn = function fn(data, options) {
      if (!allowFlip) {
        return Object.assign(data, storeState);
      }
      data = popper_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Defaults.modifiers.flip.fn */ .Z.Defaults.modifiers.flip.fn(data, options);
      storeState = {
        flipped: data.flipped,
        placement: data.placement,
        offsets: data.offsets
      };
      return data;
    };
  }
  return new popper_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z(anchor, popup, {
    positionFixed: options.positionFixed,
    placement: options.placement,
    removeOnDestroy: options.removeOnDestroy,
    onCreate: function onCreate() {
      // позволяем перевернутся меню только при начальном рендере
      allowFlip = false;
    },
    modifiers: _objectSpread({
      flip: {
        behavior: options.behavior,
        fn: fn,
        boundariesElement: options.boundariesElement
      },
      offset: {
        offset: options.offset
      },
      preventOverflow: _objectSpread({
        priority: options.priority
      }, options.overflowBoundariesElement ? {
        boundariesElement: options.overflowBoundariesElement
      } : {})
    }, options.arrow ? options.arrow : {})
  });
}

/***/ }),

/***/ 28480:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ PopupMenuItemsNav)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91038);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var is_hotkey__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(28199);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }











function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var isArrowDownKey = (0,is_hotkey__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)('down');
var isArrowUpKey = (0,is_hotkey__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)('up');
var isCtrlDownKey = (0,is_hotkey__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)('mod+down');
var isCtrlUpKey = (0,is_hotkey__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)('mod+up');
var PopupMenuItemsNav = /*#__PURE__*/function () {
  function PopupMenuItemsNav(props) {
    _classCallCheck(this, PopupMenuItemsNav);
    this.props = props;
    this.popup = props.popup;
    this.selector = props.selector;
    this.selectedClass = props.selectedClass;
    this.allowMultipleSelect = props.hasOwnProperty('allowMultipleSelect') ? props.allowMultipleSelect : false;
  }
  _createClass(PopupMenuItemsNav, [{
    key: "items",
    get: function get() {
      if (!this.popup.domNode) return [];
      return Array.from(this.popup.domNode.querySelectorAll(this.selector)).filter(function (node) {
        return !node.classList.contains('hidden');
      });
    }
  }, {
    key: "getSelected",
    value: function getSelected() {
      var _this = this;
      var item = null;
      var selectedItems = this.items.filter(function (i) {
        return i.classList.contains(_this.selectedClass);
      });
      if (this.allowMultipleSelect) {
        return selectedItems;
      }
      if (selectedItems.length === 1) {
        item = selectedItems[0];
      }
      return item;
    }
  }, {
    key: "selectNext",
    value: function selectNext() {
      var selected = this.getSelected();
      if (selected) {
        var isMultiple = Array.isArray(selected);
        var current = isMultiple ? selected[selected.length - 1] : selected;
        var currentIndex = this.items.indexOf(current);
        var toSelect = currentIndex === this.items.length - 1 ? this.items[0] : this.items[currentIndex + 1];
        toSelect.classList.add(this.selectedClass);
        this.scrollIntoView(toSelect);
        current.classList.remove(this.selectedClass);
      } else {
        this.items[0].classList.add(this.selectedClass);
      }
    }
  }, {
    key: "selectPrev",
    value: function selectPrev() {
      var selected = this.getSelected();
      if (selected) {
        var isMultiple = Array.isArray(selected);
        var current = isMultiple ? selected[0] : selected;
        var currentIndex = this.items.indexOf(current);
        var toSelect = currentIndex === 0 ? this.items[this.items.length - 1] : this.items[currentIndex - 1];
        toSelect.classList.add(this.selectedClass);
        this.scrollIntoView(toSelect);
        current.classList.remove(this.selectedClass);
      } else {
        this.items[this.items.length - 1].classList.add(this.selectedClass);
      }
    }
  }, {
    key: "selectFirst",
    value: function selectFirst() {
      var selected = this.getSelected();
      if (selected) {
        var isMultiple = Array.isArray(selected);
        var current = isMultiple ? selected[0] : selected;
        if (this.items.indexOf(current) === 0) return;
        var toSelect = this.items[0];
        toSelect.classList.add(this.selectedClass);
        this.scrollIntoView(toSelect);
        current.classList.remove(this.selectedClass);
      } else {
        this.items[0].classList.add(this.selectedClass);
      }
    }
  }, {
    key: "selectLast",
    value: function selectLast() {
      var selected = this.getSelected();
      if (selected) {
        var isMultiple = Array.isArray(selected);
        var current = isMultiple ? selected[0] : selected;
        if (this.items.indexOf(current) === this.items.length - 1) return;
        var toSelect = this.items[this.items.length - 1];
        toSelect.classList.add(this.selectedClass);
        this.scrollIntoView(toSelect);
        current.classList.remove(this.selectedClass);
      } else {
        this.items[this.items.length - 1].classList.add(this.selectedClass);
      }
    }
  }, {
    key: "scrollIntoView",
    value: function scrollIntoView(node) {
      var container = this.popup.domNode;
      if (!container) return;
      var _node$getBoundingClie = node.getBoundingClientRect(),
        itemHeight = _node$getBoundingClie.height;
      var _container$getBoundin = container.getBoundingClientRect(),
        containerHeight = _container$getBoundin.height;
      var scrollTop = null;
      if (node.offsetTop + itemHeight > containerHeight + container.scrollTop) {
        scrollTop = node.offsetTop + itemHeight - containerHeight;
      } else if (node.offsetTop < container.scrollTop) {
        scrollTop = node.offsetTop;
      }
      if (this.props.stickyHeader && this.props.headerHeight) {
        if (scrollTop !== null) {
          if (node.offsetTop - scrollTop < this.props.headerHeight) {
            scrollTop = node.offsetTop - scrollTop;
          }
        } else {
          if (node.offsetTop - container.scrollTop < this.props.headerHeight) {
            scrollTop = container.scrollTop - this.props.headerHeight;
          }
        }
      }
      if (scrollTop !== null) {
        container.scrollTop = scrollTop;
      }
    }
  }, {
    key: "selectItems",
    value: function selectItems() {
      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var selected = this.getSelected();
      var isMultiple = Array.isArray(selected);
      if (isMultiple) {
        var _iterator = _createForOfIteratorHelper(selected),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            item.classList.remove(this.selectedClass);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        selected.classList.remove(this.selectedClass);
      }
      if (items) {
        if (Array.isArray(items) && items.length) {
          if (items.length === 1) {
            items[0].classList.add(this.selectedClass);
          } else if (this.allowMultipleSelect) {
            var _iterator2 = _createForOfIteratorHelper(items),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _item = _step2.value;
                _item.classList.add(this.selectedClass);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          } else {
            console.error('Multiple select items is not allowed');
          }
        } else if (items.classList) {
          items.classList.add(this.selectedClass);
        }
      }
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(event) {
      var processed = false;
      if (isArrowDownKey(event)) {
        processed = true;
        this.selectNext();
      } else if (isArrowUpKey(event)) {
        processed = true;
        this.selectPrev();
      } else if (isCtrlDownKey(event)) {
        processed = true;
        this.selectLast();
      } else if (isCtrlUpKey(event)) {
        processed = true;
        this.selectFirst();
      }
      if (processed) {
        event.preventDefault();
        event.stopPropagation();
      }
      return processed;
    }
  }]);
  return PopupMenuItemsNav;
}();


/***/ }),

/***/ 64467:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "createMutex": () => (/* reexport safe */ lib0_mutex__WEBPACK_IMPORTED_MODULE_16__.M),
/* harmony export */   "AbsolutePosition": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.AbsolutePosition),
/* harmony export */   "AbstractConnector": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.AbstractConnector),
/* harmony export */   "AbstractStruct": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.AbstractStruct),
/* harmony export */   "AbstractType": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.AbstractType),
/* harmony export */   "Array": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.Array),
/* harmony export */   "ContentAny": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.ContentAny),
/* harmony export */   "ContentBinary": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.ContentBinary),
/* harmony export */   "ContentDeleted": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.ContentDeleted),
/* harmony export */   "ContentEmbed": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.ContentEmbed),
/* harmony export */   "ContentFormat": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.ContentFormat),
/* harmony export */   "ContentJSON": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.ContentJSON),
/* harmony export */   "ContentString": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.ContentString),
/* harmony export */   "ContentType": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.ContentType),
/* harmony export */   "Doc": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.Doc),
/* harmony export */   "GC": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.GC),
/* harmony export */   "ID": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.ID),
/* harmony export */   "Item": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.Item),
/* harmony export */   "Map": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.Map),
/* harmony export */   "PermanentUserData": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.PermanentUserData),
/* harmony export */   "RelativePosition": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.RelativePosition),
/* harmony export */   "Snapshot": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.Snapshot),
/* harmony export */   "Text": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.Text),
/* harmony export */   "Transaction": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.Transaction),
/* harmony export */   "UndoManager": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.UndoManager),
/* harmony export */   "XmlElement": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.XmlElement),
/* harmony export */   "XmlFragment": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.XmlFragment),
/* harmony export */   "XmlHook": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.XmlHook),
/* harmony export */   "XmlText": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.XmlText),
/* harmony export */   "YArrayEvent": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.YArrayEvent),
/* harmony export */   "YEvent": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.YEvent),
/* harmony export */   "YMapEvent": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.YMapEvent),
/* harmony export */   "YTextEvent": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.YTextEvent),
/* harmony export */   "YXmlEvent": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.YXmlEvent),
/* harmony export */   "applyUpdate": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.applyUpdate),
/* harmony export */   "applyUpdateV2": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.applyUpdateV2),
/* harmony export */   "cleanupYTextFormatting": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.cleanupYTextFormatting),
/* harmony export */   "compareIDs": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.compareIDs),
/* harmony export */   "compareRelativePositions": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.compareRelativePositions),
/* harmony export */   "convertUpdateFormatV1ToV2": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.convertUpdateFormatV1ToV2),
/* harmony export */   "convertUpdateFormatV2ToV1": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.convertUpdateFormatV2ToV1),
/* harmony export */   "createAbsolutePositionFromRelativePosition": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.createAbsolutePositionFromRelativePosition),
/* harmony export */   "createDeleteSet": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.createDeleteSet),
/* harmony export */   "createDocFromSnapshot": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.createDocFromSnapshot),
/* harmony export */   "createID": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.createID),
/* harmony export */   "createRelativePositionFromJSON": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.createRelativePositionFromJSON),
/* harmony export */   "createRelativePositionFromTypeIndex": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.createRelativePositionFromTypeIndex),
/* harmony export */   "createSnapshot": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.createSnapshot),
/* harmony export */   "decodeRelativePosition": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.decodeRelativePosition),
/* harmony export */   "decodeSnapshot": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.decodeSnapshot),
/* harmony export */   "decodeSnapshotV2": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.decodeSnapshotV2),
/* harmony export */   "decodeStateVector": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.decodeStateVector),
/* harmony export */   "decodeUpdate": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.decodeUpdate),
/* harmony export */   "decodeUpdateV2": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.decodeUpdateV2),
/* harmony export */   "diffUpdate": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.diffUpdate),
/* harmony export */   "diffUpdateV2": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.diffUpdateV2),
/* harmony export */   "emptySnapshot": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.emptySnapshot),
/* harmony export */   "encodeRelativePosition": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.encodeRelativePosition),
/* harmony export */   "encodeSnapshot": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.encodeSnapshot),
/* harmony export */   "encodeSnapshotV2": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.encodeSnapshotV2),
/* harmony export */   "encodeStateAsUpdate": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.encodeStateAsUpdate),
/* harmony export */   "encodeStateAsUpdateV2": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.encodeStateAsUpdateV2),
/* harmony export */   "encodeStateVector": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.encodeStateVector),
/* harmony export */   "encodeStateVectorFromUpdate": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.encodeStateVectorFromUpdate),
/* harmony export */   "encodeStateVectorFromUpdateV2": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.encodeStateVectorFromUpdateV2),
/* harmony export */   "equalSnapshots": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.equalSnapshots),
/* harmony export */   "findIndexSS": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.findIndexSS),
/* harmony export */   "findRootTypeKey": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.findRootTypeKey),
/* harmony export */   "getItem": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.getItem),
/* harmony export */   "getState": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.getState),
/* harmony export */   "getTypeChildren": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.getTypeChildren),
/* harmony export */   "isDeleted": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.isDeleted),
/* harmony export */   "isParentOf": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.isParentOf),
/* harmony export */   "iterateDeletedStructs": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.iterateDeletedStructs),
/* harmony export */   "logType": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.logType),
/* harmony export */   "logUpdate": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.logUpdate),
/* harmony export */   "logUpdateV2": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.logUpdateV2),
/* harmony export */   "mergeUpdates": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.mergeUpdates),
/* harmony export */   "mergeUpdatesV2": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.mergeUpdatesV2),
/* harmony export */   "parseUpdateMeta": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.parseUpdateMeta),
/* harmony export */   "parseUpdateMetaV2": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.parseUpdateMetaV2),
/* harmony export */   "readUpdate": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.readUpdate),
/* harmony export */   "readUpdateV2": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.readUpdateV2),
/* harmony export */   "relativePositionToJSON": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.relativePositionToJSON),
/* harmony export */   "snapshot": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.snapshot),
/* harmony export */   "transact": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.transact),
/* harmony export */   "tryGc": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.tryGc),
/* harmony export */   "typeListToArraySnapshot": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.typeListToArraySnapshot),
/* harmony export */   "typeMapGetSnapshot": () => (/* reexport safe */ yjs__WEBPACK_IMPORTED_MODULE_17__.typeMapGetSnapshot),
/* harmony export */   "syncProtocol": () => (/* reexport module object */ y_protocols_sync__WEBPACK_IMPORTED_MODULE_18__),
/* harmony export */   "awarenessProtocol": () => (/* reexport module object */ y_protocols_awareness__WEBPACK_IMPORTED_MODULE_14__),
/* harmony export */   "messageSync": () => (/* binding */ messageSync),
/* harmony export */   "messageAwareness": () => (/* binding */ messageAwareness),
/* harmony export */   "messageAuth": () => (/* binding */ messageAuth),
/* harmony export */   "getEmptyStateSet": () => (/* binding */ getEmptyStateSet),
/* harmony export */   "getStateVector": () => (/* binding */ getStateVector),
/* harmony export */   "createDeleteSetFromStructStore": () => (/* binding */ createDeleteSetFromStructStore),
/* harmony export */   "copyMap": () => (/* binding */ copyMap),
/* harmony export */   "copyArray": () => (/* binding */ copyArray),
/* harmony export */   "copyText": () => (/* binding */ copyText),
/* harmony export */   "restoreDump": () => (/* binding */ restoreDump)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51532);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26699);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_url_to_json_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83753);
/* harmony import */ var core_js_modules_web_url_to_json_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_to_json_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91038);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var y_protocols_sync__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(53665);
/* harmony import */ var y_protocols_awareness__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(15264);
/* harmony import */ var lib0_decoding_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(29693);
/* harmony import */ var _util_encoding__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(59150);
/* harmony import */ var lib0_mutex__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(70494);
/* harmony import */ var yjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(51718);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }






















var messageSync = 0;
var messageAwareness = 1;
var messageAuth = 2;
var getEmptyStateSet = function getEmptyStateSet() {
  var encoder = _util_encoding__WEBPACK_IMPORTED_MODULE_15__.createEncoder();
  _util_encoding__WEBPACK_IMPORTED_MODULE_15__.writeVarUint(encoder, messageSync);
  y_protocols_sync__WEBPACK_IMPORTED_MODULE_18__.writeSyncStep1(encoder, {
    store: {
      clients: new Map()
    }
  });
  var buff = _util_encoding__WEBPACK_IMPORTED_MODULE_15__.toUint8Array(encoder);
  return buff;
};
var getStateVector = function getStateVector(store) {
  var sm = new Map();
  store.clients.forEach(function (structs, client) {
    var struct = structs[structs.length - 1];
    sm.set(client, struct.id.clock + struct.length);
  });
  return sm;
};
var createDeleteSetFromStructStore = function createDeleteSetFromStructStore(ss) {
  var items = [];
  ss.clients.forEach(function (structs, client) {
    /**
     * @type {Array<DeleteItem>}
     */
    for (var i = 0; i < structs.length; i++) {
      var struct = structs[i];
      if (struct.deleted) {
        var clock = struct.id.clock;
        var len = struct.length;
        if (i + 1 < structs.length) {
          for (var next = structs[i + 1]; i + 1 < structs.length && next.id.clock === clock + len && next.deleted; next = structs[++i + 1]) {
            len += next.length;
          }
        }
        items.push([client, clock, len]);
      }
    }
  });
  return items;
};
function copyMap(source, target, store) {
  source.forEach(function (value, key) {
    if (value instanceof store.types.Map) {
      var map = new store.types.Map();
      copyMap(value, map, store);
      target.set(key, map);
    } else if (value instanceof store.types.Array) {
      var arr = new store.types.Array();
      copyArray(value, arr, store);
      target.set(key, arr);
    } else if (value instanceof store.types.Text) {
      var text = new store.types.Text();
      copyText(value, text, store);
      target.set(key, text);
    } else {
      target.set(key, value);
    }
  });
}
function copyArray(source, target, store) {
  var _iterator = _createForOfIteratorHelper(source),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var value = _step.value;
      if (value instanceof store.types.Map) {
        var map = new store.types.Map();
        copyMap(value, map, store);
        target.push([map]);
      } else if (value instanceof store.types.Array) {
        var arr = new store.types.Array();
        copyArray(value, arr, store);
        target.push([arr]);
      } else if (value instanceof store.types.Text) {
        var text = new store.types.Text();
        copyText(value, text, store);
        target.push([text]);
      } else {
        target.push([value]);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
function copyText(source, target, store) {
  target.applyDelta(source.toDelta());
}

/**
 * Восстанавливает дамп в документ
 * @param {Object} params
 * @param {Y.Doc} params.doc
 * @param {Uint8Array[]} params.buffer
 * @param {Y} params.Y
 */
function restoreDump(_ref) {
  var doc = _ref.doc,
    buffer = _ref.buffer,
    Y = _ref.Y;
  var decoder = lib0_decoding_js__WEBPACK_IMPORTED_MODULE_19__.createDecoder(buffer);
  var encoder = _util_encoding__WEBPACK_IMPORTED_MODULE_15__.createEncoder();
  var blots = _toConsumableArray(doc.get('rootChildren', Y.Array) || []);
  var isDocEmpty = blots.length === 0;
  if (blots.length === 1) {
    var _doc$get, _doc$get$get, _doc$get$get$get;
    if (["\n", ""].includes((_doc$get = doc.get('blocks')) === null || _doc$get === void 0 ? void 0 : (_doc$get$get = _doc$get.get(blots[0])) === null || _doc$get$get === void 0 ? void 0 : (_doc$get$get$get = _doc$get$get.get('characters')) === null || _doc$get$get$get === void 0 ? void 0 : _doc$get$get$get.toJSON())) {
      isDocEmpty = true;
    }
  }
  if (!isDocEmpty) {
    console.log('blots', blots);
    throw new Error("can't restoreDump doc is not empty");
  }
  y_protocols_sync__WEBPACK_IMPORTED_MODULE_18__.readSyncMessage(decoder, encoder, doc);
}

/***/ }),

/***/ 5371:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ImageViewer)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30489);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12419);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79758);
/* harmony import */ var _style_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29197);
/* harmony import */ var _style_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_style_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _components_infiniteLoader__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(77510);
/* harmony import */ var _plugins_i18n__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(407);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }









function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




function fileInfoKey(uuid) {
  return 'file_info:' + uuid;
}
var ImageViewer = /*#__PURE__*/function (_Component) {
  _inherits(ImageViewer, _Component);
  var _super = _createSuper(ImageViewer);
  function ImageViewer(props) {
    var _this;
    _classCallCheck(this, ImageViewer);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onImgLoad", function (event) {
      var _this$props = _this.props,
        syncedState = _this$props.syncedState,
        setSyncedState = _this$props.setSyncedState,
        attachment = _this$props.attachment;
      var storedFileInfo = _this.getStoredFileInfo();
      if (!storedFileInfo) {
        setSyncedState(_defineProperty({}, fileInfoKey(attachment.file_uuid), {
          width: event.target.width,
          height: event.target.height
        }));
      }
      _this.setState(function () {
        return {
          imgLoaded: true
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onImgClick", function (event) {
      var _this$props2 = _this.props,
        editor = _this$props2.editor,
        attachment = _this$props2.attachment,
        blot = _this$props2.blot;
      event.preventDefault();
      var params = {};
      if (blot && blot.disallowDownloading) {
        params.disallowDownloading = true;
      }
      var processed = false;
      if (editor.plugins.imageManager.enterFullSize(attachment.global_id, params) !== false) {
        processed = true;
      }
      if (!processed) {
        editor.plugins.lightBox.open(attachment.url);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onImgError", function (event) {
      _this.setState(function () {
        return {
          imgError: true
        };
      });
    });
    _this.state = {
      imgLoaded: false,
      imgError: false
    };
    return _this;
  }
  _createClass(ImageViewer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var attachment = this.props.attachment;
      var img = new Image();
      img.onload = this.onImgLoad;
      img.onerror = this.onImgError;
      img.src = attachment.url;
    }
  }, {
    key: "getStoredFileInfo",
    value: function getStoredFileInfo() {
      var _this$props3 = this.props,
        syncedState = _this$props3.syncedState,
        attachment = _this$props3.attachment;
      return syncedState[fileInfoKey(attachment.file_uuid)];
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        attachment = _this$props4.attachment,
        maxWidth = _this$props4.maxWidth,
        maxHeight = _this$props4.maxHeight,
        syncedState = _this$props4.syncedState;
      var _this$state = this.state,
        imgLoaded = _this$state.imgLoaded,
        imgError = _this$state.imgError;
      var style = {
        maxWidth: maxWidth + 'px',
        maxHeight: maxHeight + 'px'
      };
      var content;
      var storedFileInfo = this.getStoredFileInfo();
      var effectiveWidth, effectiveHeight;
      if (storedFileInfo) {
        var width = storedFileInfo.width,
          height = storedFileInfo.height;
        if (width > maxWidth || height > maxHeight) {
          var ratio = Math.max(width / maxWidth, height / maxHeight);
          effectiveWidth = width / ratio;
          effectiveHeight = height / ratio;
        } else {
          effectiveWidth = width;
          effectiveHeight = height;
        }
      }
      if (imgLoaded) {
        style.width = effectiveWidth + 'px';
        style.height = effectiveHeight + 'px';
        content = (0,preact__WEBPACK_IMPORTED_MODULE_9__.h)("img", {
          style: style,
          src: attachment.url,
          onLoad: this.onImgLoad,
          onClick: this.onImgClick.bind(this)
        });
      } else if (imgError) {
        content = (0,preact__WEBPACK_IMPORTED_MODULE_9__.h)("div", {
          className: "img-error"
        }, (0,preact__WEBPACK_IMPORTED_MODULE_9__.h)(_plugins_i18n__WEBPACK_IMPORTED_MODULE_12__/* .Text */ .xv, {
          id: "file.image_viewer.could_not_load_image"
        }));
      } else {
        var loaderProps = {};
        if (effectiveHeight) {
          loaderProps.height = effectiveHeight;
        }
        content = (0,preact__WEBPACK_IMPORTED_MODULE_9__.h)(_components_infiniteLoader__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, loaderProps);
      }
      return (0,preact__WEBPACK_IMPORTED_MODULE_9__.h)("div", {
        className: "image-viewer"
      }, content);
    }
  }]);
  return ImageViewer;
}(preact__WEBPACK_IMPORTED_MODULE_9__/* .Component */ .wA);

ImageViewer.viewerName = 'ImageViewer';

/***/ }),

/***/ 71372:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ PDFViewerComponent)
});

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(87751);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.is-integer.js
var es_number_is_integer = __webpack_require__(33161);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(9653);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(69600);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(21249);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(30489);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__(12419);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(57327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__(38880);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(54747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__(49337);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(19601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/preact/dist/preact.module.js
var preact_module = __webpack_require__(79758);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__(73210);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/pdfPageView.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }





















function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CSS_UNITS = 96.0 / 72.0;
var SEARCH_HIGHLIGHT_CLASS = 'highlight';
var PDFPageView = /*#__PURE__*/function (_Component) {
  _inherits(PDFPageView, _Component);
  var _super = _createSuper(PDFPageView);
  function PDFPageView(props) {
    var _this;
    _classCallCheck(this, PDFPageView);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onCanvasRef", function (canvas) {
      _this.canvas = canvas;
    });
    _defineProperty(_assertThisInitialized(_this), "onCanvasWrapperRef", function (wrapper) {
      _this.canvasWrapper = wrapper;
    });
    _defineProperty(_assertThisInitialized(_this), "onTextContentDivRef", function (container) {
      _this.textContainer = container;
    });
    _defineProperty(_assertThisInitialized(_this), "onAnnotationContentDivRef", function (container) {
      _this.annotationContainer = container;
      _this.renderPage();
    });
    _this.state = {
      isRendered: false,
      isRendering: false,
      pageSizeHeight: 0
    };
    _this.textDivs = [];
    _this.textContentItemsStr = [];
    _this.renderTask;
    _this.textLayerRenderTask;
    _this.renderCounter = 0;
    return _this;
  }
  _createClass(PDFPageView, [{
    key: "getPageSize",
    value: function getPageSize() {
      if (!this.props.pdfPage) {
        return {
          width: this.props.defaultWidth * this.props.scale * CSS_UNITS,
          height: this.props.defaultHeight * this.props.scale * CSS_UNITS
        };
      }
      var view = this.props.pdfPage.view;
      return {
        width: view[2] * this.props.scale * CSS_UNITS,
        height: view[3] * this.props.scale * CSS_UNITS
      };
    }
  }, {
    key: "clearSearchMatches",
    value: function clearSearchMatches() {
      var textDivs = this.textDivs;
      if (textDivs && textDivs.length) {
        var _iterator = _createForOfIteratorHelper(textDivs),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var div = _step.value;
            var highlights = div.querySelectorAll('.' + SEARCH_HIGHLIGHT_CLASS);
            var _iterator2 = _createForOfIteratorHelper(highlights),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var highlight = _step2.value;
                var _iterator3 = _createForOfIteratorHelper(highlight.childNodes),
                  _step3;
                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var child = _step3.value;
                    highlight.parentNode.insertBefore(child, highlight);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
                highlight.parentNode.removeChild(highlight);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }, {
    key: "renderMatches",
    value: function renderMatches( /*{ matches, matchesLength, query, selectedMatchIdx }*/preparedMatches, activeMatch) {
      //console.log('REnder matches', matches)
      // Early exit if there is nothing to render.
      this.clearSearchMatches();
      if (!preparedMatches || preparedMatches.length === 0) {
        return;
      }
      var query = preparedMatches.query,
        matches = preparedMatches.matches,
        matchesLength = preparedMatches.matchesLength;
      var textContentItemsStr = this.textContentItemsStr,
        textDivs = this.textDivs;

      //console.log('CONVERTING!', matches, matchesLength, textContentItemsStr, query)

      matches = this._convertMatches(matches, matchesLength, textContentItemsStr, query);

      //const selectedMatchIdx = findController.selected.matchIdx;
      // const highlightAll = findController.state.highlightAll;
      var highlightAll = true;
      var prevEnd = null;
      var infinity = {
        divIdx: -1,
        offset: undefined
      };
      function beginText(begin, className) {
        var divIdx = begin.divIdx;
        textDivs[divIdx].textContent = '';
        appendTextToDiv(divIdx, 0, begin.offset, className);
      }
      function appendTextToDiv(divIdx, fromOffset, toOffset, className) {
        var div = textDivs[divIdx];
        var content = textContentItemsStr[divIdx].substring(fromOffset, toOffset);
        var node = document.createTextNode(content);
        if (className) {
          var span = document.createElement('span');
          span.className = className;
          span.appendChild(node);
          div.appendChild(span);
          return;
        }
        div.appendChild(node);
      }
      var selectedMatchIdx = 0;
      if (activeMatch) {
        selectedMatchIdx = activeMatch.selectedMatchIdx;
      }
      var i0 = selectedMatchIdx,
        i1 = i0 + 1;
      if (highlightAll) {
        i0 = 0;
        i1 = matches.length;
      }
      var updatedDivs = [];
      var activeMatchDiv = null;
      for (var i = i0; i < i1; i++) {
        var match = matches[i];
        var begin = match.begin;
        var end = match.end;
        var isSelected = activeMatch && i === selectedMatchIdx;
        var highlightSuffix = isSelected ? ' selected' : '';
        if (isSelected) {
          activeMatchDiv = textDivs[begin.divIdx];
        }
        updatedDivs.push(textDivs[begin.divIdx]);

        /*
              if (isSelected) { // Attempt to scroll the selected match into view.
                findController.scrollMatchIntoView({
                  element: textDivs[begin.divIdx],
                  pageIndex: pageIdx,
                  matchIndex: selectedMatchIdx,
                });
              }
        */

        // Match inside new div.
        if (!prevEnd || begin.divIdx !== prevEnd.divIdx) {
          // If there was a previous div, then add the text at the end.
          if (prevEnd !== null) {
            appendTextToDiv(prevEnd.divIdx, prevEnd.offset, infinity.offset);
          }
          // Clear the divs and set the content until the starting point.
          beginText(begin);
        } else {
          appendTextToDiv(prevEnd.divIdx, prevEnd.offset, begin.offset);
        }
        if (begin.divIdx === end.divIdx) {
          appendTextToDiv(begin.divIdx, begin.offset, end.offset, SEARCH_HIGHLIGHT_CLASS + highlightSuffix);
        } else {
          appendTextToDiv(begin.divIdx, begin.offset, infinity.offset, SEARCH_HIGHLIGHT_CLASS + ' begin' + highlightSuffix);
          for (var n0 = begin.divIdx + 1, n1 = end.divIdx; n0 < n1; n0++) {
            textDivs[n0].className = SEARCH_HIGHLIGHT_CLASS + ' middle' + highlightSuffix;
          }
          beginText(end, SEARCH_HIGHLIGHT_CLASS + ' end' + highlightSuffix);
        }
        prevEnd = end;
      }
      if (prevEnd) {
        appendTextToDiv(prevEnd.divIdx, prevEnd.offset, infinity.offset);
      }
      if (activeMatchDiv) {
        this.props.onActiveMatchRender(activeMatchDiv);
      }
    }

    /**
     * Отрисовка страницы
     * @param {Boolean} skipVisible учитывать видимость при рендринге
     * @returns {Promise<void>}
     */
  }, {
    key: "renderPage",
    value: function () {
      var _renderPage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;
        var skipVisible,
          _this$props,
          pdfPage,
          scale,
          num,
          pdfjsLib,
          stateUpdate,
          counter,
          canvas,
          vpScale,
          viewport,
          pageSize,
          pageSizeHeight,
          textScale,
          textViewport,
          ctx,
          renderTask,
          renderTextPromise,
          renderAnnotationsTask,
          _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                skipVisible = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
                if (this.canvas) {
                  _context.next = 3;
                  break;
                }
                return _context.abrupt("return");
              case 3:
                _this$props = this.props, pdfPage = _this$props.pdfPage, scale = _this$props.scale, num = _this$props.num, pdfjsLib = _this$props.pdfjsLib;
                if (pdfPage) {
                  _context.next = 6;
                  break;
                }
                return _context.abrupt("return");
              case 6:
                if (!(!this.props.visible && !skipVisible)) {
                  _context.next = 8;
                  break;
                }
                return _context.abrupt("return");
              case 8:
                stateUpdate = {
                  isRendering: false
                };
                counter = ++this.renderCounter;
                this.setState(function () {
                  return {
                    isRendering: true
                  };
                });
                if (this.renderTask) {
                  try {
                    this.renderTask.cancel();
                  } catch (err) {
                    console.warn('fail to cancel render task', num, err);
                  }
                }
                if (this.textLayerRenderTask) {
                  try {
                    this.textLayerRenderTask.cancel();
                  } catch (err) {
                    console.warn('fail to cancel text render task', num, err);
                  }
                }
                // предотвращаем ошибку если this.textContainer === undefined | null
                if (this.textContainer) {
                  while (this.textContainer.firstChild) {
                    this.textContainer.removeChild(this.textContainer.firstChild);
                  }
                }
                canvas = this.canvas;
                vpScale = window.devicePixelRatio * scale * CSS_UNITS;
                viewport = pdfPage.getViewport({
                  scale: vpScale
                }); // иногда this.getPageSize() отдаёт не верную высоту страницы, поэтому нужно расчитывать
                // высоту в зависимости от вьюпорта и ширины которую выозвращает this.getPageSize()
                pageSize = this.getPageSize();
                pageSizeHeight = pageSize.width * viewport.height / viewport.width;
                stateUpdate = _objectSpread(_objectSpread({}, stateUpdate), {}, {
                  pageSizeHeight: pageSizeHeight
                });
                textScale = scale * CSS_UNITS;
                textViewport = pdfPage.getViewport({
                  scale: textScale
                });
                canvas.width = Math.round(viewport.width);
                canvas.height = Math.round(viewport.height);
                canvas.style = "width: ".concat(pageSize.width, "px; height: ").concat(pageSizeHeight, "px;");
                this.canvasWrapper.style = "width: ".concat(pageSize.width, "px; height: ").concat(pageSizeHeight, "px;");
                ctx = canvas.getContext('2d');
                renderTask = pdfPage.render({
                  canvasContext: ctx,
                  viewport: viewport
                });
                this.renderTask = renderTask;
                this.textDivs = [];
                renderTextPromise = pdfPage.getTextContent().then(function (textContent) {
                  if (renderTask._canceled || counter !== _this2.renderCounter) {
                    throw new Error('render task was canceled');
                  }
                  _this2.textContainer.style = "width: ".concat(canvas.width, "px; height: ").concat(canvas.height, "px;");
                  _this2.textLayerRenderTask = pdfjsLib.renderTextLayer({
                    textContent: textContent,
                    container: _this2.textContainer,
                    viewport: textViewport,
                    textDivs: _this2.textDivs,
                    textContentItemsStr: _this2.textContentItemsStr,
                    enhanceTextSelection: true
                  });
                  return _this2.textLayerRenderTask.promise;
                });
                renderAnnotationsTask = pdfPage.getAnnotations().then(function (annotationData) {
                  if (renderTask._canceled || counter !== _this2.renderCounter) {
                    throw new Error('render task was canceled');
                  }
                  var params = {
                    viewport: viewport.clone({
                      dontFlip: true
                    }),
                    div: _this2.annotationContainer,
                    annotations: annotationData,
                    page: pdfPage,
                    linkService: {
                      externalLinkTarget: pdfjsLib.LinkTarget.BLANK
                    }
                  };
                  if (_this2.annotationContainer.innerHTML.trim() !== '') {
                    return pdfjsLib.AnnotationLayer.update(params);
                  } else {
                    params.linkService.getDestinationHash = function () {
                      return null;
                    };
                    return pdfjsLib.AnnotationLayer.render(params);
                  }
                });
                _context.prev = 32;
                _context.next = 35;
                return Promise.all([renderTask.promise, renderTextPromise, renderAnnotationsTask.promise]);
              case 35:
                if (this.props.searchMatches) {
                  this.renderMatches(this.props.searchMatches, this.props.activeSearchMatch);
                }
                stateUpdate.isRendered = true;
                _context.next = 42;
                break;
              case 39:
                _context.prev = 39;
                _context.t0 = _context["catch"](32);
                console.warn('fail to render page', num, _context.t0);
              case 42:
                this.setState(function () {
                  return stateUpdate;
                });
              case 43:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[32, 39]]);
      }));
      function renderPage() {
        return _renderPage.apply(this, arguments);
      }
      return renderPage;
    }()
  }, {
    key: "_convertMatches",
    value: function _convertMatches(matches, matchesLength, textContentItemsStr, query) {
      // Early exit if there is nothing to convert.
      if (!matches) {
        return [];
      }

      //console.log('Convert matches', matches, textContentItemsStr)

      var i = 0,
        iIndex = 0;
      var end = textContentItemsStr.length - 1;
      var queryLen = query.length;
      var result = [];
      for (var m = 0, mm = matches.length; m < mm; m++) {
        // Calculate the start position.
        var matchIdx = matches[m];

        // Loop over the divIdxs.
        while (i !== end && matchIdx >= iIndex + textContentItemsStr[i].length) {
          iIndex += textContentItemsStr[i].length;
          i++;
        }
        if (i === textContentItemsStr.length) {
          console.error('Could not find a matching mapping');
        }
        var match = {
          begin: {
            divIdx: i,
            offset: matchIdx - iIndex
          }
        };

        // Calculate the end position.
        if (matchesLength) {
          // Multiterm search.
          matchIdx += matchesLength[m];
        } else {
          // Phrase search.
          matchIdx += queryLen;
        }

        // Somewhat the same array as above, but use > instead of >= to get
        // the end position right.
        while (i !== end && matchIdx > iIndex + textContentItemsStr[i].length) {
          iIndex += textContentItemsStr[i].length;
          i++;
        }
        match.end = {
          divIdx: i,
          offset: matchIdx - iIndex
        };
        result.push(match);
      }
      return result;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      if (oldProps.pdfPage !== this.props.pdfPage || this.props.visible && this.props.visible !== oldProps.visible && !this.state.isRendered && !this.state.isRendering) {
        this.renderPage();
      } else if (this.state.isRendered && this.props.scale !== oldProps.scale) {
        // при смене масштаба перерисовываем уже отрисованные страницы,
        // для того чтобы избежать артефактов
        this.renderPage(true);
      }
      if (oldProps.activeSearchMatch !== this.props.activeSearchMatch && this.state.isRendered) {
        this.renderMatches(this.props.searchMatches, this.props.activeSearchMatch);
      }
      if (oldProps.searchMatches !== this.props.searchMatches && this.state.isRendered) {
        this.renderMatches(this.props.searchMatches, this.props.activeSearchMatch);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getPageSize = this.getPageSize(),
        width = _this$getPageSize.width,
        height = _this$getPageSize.height;
      var classes = ['pdf-page'];
      if (this.props.active) classes.push('pdf-page-active'); // для тестирования активности страницы
      if (!this.props.pdfPage) classes.push('editor-loader2-grey editor-loader-cc');
      return (0,preact_module.h)("div", {
        className: classes.join(' '),
        style: {
          width: width + 'px',
          height: (this.state.pageSizeHeight || height) + 'px'
        }
      }, (0,preact_module.h)("div", {
        className: "canvasWrapper",
        ref: this.onCanvasWrapperRef
      }, (0,preact_module.h)("canvas", {
        ref: this.onCanvasRef
      })), (0,preact_module.h)("div", {
        className: "textLayer",
        ref: this.onTextContentDivRef
      }), (0,preact_module.h)("div", {
        className: "annotationLayer",
        ref: this.onAnnotationContentDivRef
      }));
    }
  }]);
  return PDFPageView;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/lodash.throttle/index.js
var lodash_throttle = __webpack_require__(47983);
var lodash_throttle_default = /*#__PURE__*/__webpack_require__.n(lodash_throttle);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/pdf/style.scss
var style = __webpack_require__(12934);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/util/dom.js
var dom = __webpack_require__(67546);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/pdfview.js
function pdfview_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { pdfview_typeof = function _typeof(obj) { return typeof obj; }; } else { pdfview_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return pdfview_typeof(obj); }










function pdfview_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function pdfview_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function pdfview_createClass(Constructor, protoProps, staticProps) { if (protoProps) pdfview_defineProperties(Constructor.prototype, protoProps); if (staticProps) pdfview_defineProperties(Constructor, staticProps); return Constructor; }
function pdfview_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) pdfview_setPrototypeOf(subClass, superClass); }
function pdfview_setPrototypeOf(o, p) { pdfview_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return pdfview_setPrototypeOf(o, p); }
function pdfview_createSuper(Derived) { var hasNativeReflectConstruct = pdfview_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = pdfview_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = pdfview_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return pdfview_possibleConstructorReturn(this, result); }; }
function pdfview_possibleConstructorReturn(self, call) { if (call && (pdfview_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return pdfview_assertThisInitialized(self); }
function pdfview_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function pdfview_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function pdfview_getPrototypeOf(o) { pdfview_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return pdfview_getPrototypeOf(o); }
function pdfview_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var PRELOAD_PAGES = 1;
var PAGE_BOTTOM_MARGIN = parseInt((style_default()).fullScreenViewerPagesMargin);
var FIRST_PAGE_TOP_MARGIN = parseInt((style_default()).fullScreenViewerFirstPageTopMargin);
var SCROLL_TO_PAGE_TOP_SPACE = 3;
var PDFView = /*#__PURE__*/function (_Component) {
  pdfview_inherits(PDFView, _Component);
  var _super = pdfview_createSuper(PDFView);
  function PDFView(props) {
    var _this;
    pdfview_classCallCheck(this, PDFView);
    _this = _super.call(this, props);
    pdfview_defineProperty(pdfview_assertThisInitialized(_this), "scrollTop", 0);
    pdfview_defineProperty(pdfview_assertThisInitialized(_this), "onSearchActiveMatchesRender", function (scrollToDiv) {
      if (!scrollToDiv) {
        return;
      }
      if ((0,dom/* isNodeInViewport */.gx)(scrollToDiv)) {
        return;
      }
      requestAnimationFrame(function () {
        scrollToDiv.scrollIntoView({
          block: 'center',
          inline: 'center'
        });
      });
    });
    pdfview_defineProperty(pdfview_assertThisInitialized(_this), "onRef", function (node) {
      if (!node) {
        return;
      }
      _this.rootNode = node;
      _this.rootNode.scrollTop = 0;
    });
    var pdfDocument = props.pdfDocument,
      pagesOverview = props.pagesOverview,
      scale = props.scale,
      defaultPageHeight = props.defaultPageHeight;
    _this.state = Object.assign({}, _this.getActivePage(0, pdfDocument, pagesOverview, scale, defaultPageHeight));
    _this.onScroll = lodash_throttle_default()(function (event) {
      var _this$props = _this.props,
        pdfDocument = _this$props.pdfDocument,
        pagesOverview = _this$props.pagesOverview,
        scale = _this$props.scale,
        defaultPageHeight = _this$props.defaultPageHeight;
      var _event$target = event.target,
        scrollHeight = _event$target.scrollHeight,
        scrollTop = _event$target.scrollTop,
        offsetHeight = _event$target.offsetHeight;
      var newState = _this.getActivePage(scrollTop, pdfDocument, pagesOverview, scale, defaultPageHeight);

      // Если проскроллили в конец то должна быть выделена последняя страница
      // нужно для масштаба 50%
      if (scrollTop + offsetHeight >= scrollHeight - PAGE_BOTTOM_MARGIN) {
        newState.pageActive = pdfDocument.numPages;
      }
      _this.setState(function () {
        return newState;
      }, function () {
        _this.scrollTop = scrollTop;
      });
    }, 300, {
      trailing: true
    });
    return _this;
  }
  pdfview_createClass(PDFView, [{
    key: "getActivePage",
    value: function getActivePage(scrollTop, pdfDocument, pagesOverview, scale, defaultPageHeight) {
      var y = FIRST_PAGE_TOP_MARGIN;
      var activePageNum = 1;
      for (var num = 1; num <= pdfDocument.numPages; num++) {
        var pageOverview = pagesOverview[num];
        var pageHeight = this.getPageHeight(pageOverview && pageOverview.height || defaultPageHeight, scale);
        if (scrollTop >= y - PAGE_BOTTOM_MARGIN && scrollTop <= y + pageHeight) {
          activePageNum = num;
          break;
        }
        y += pageHeight + PAGE_BOTTOM_MARGIN;
      }
      return {
        pageActive: activePageNum,
        pageVisibleStart: Math.max(0, activePageNum - PRELOAD_PAGES),
        pageVisibleEnd: Math.min(pdfDocument.numPages, activePageNum + PRELOAD_PAGES)
      };
    }
  }, {
    key: "getPageHeight",
    value: function getPageHeight(pdfHeight, scale) {
      return pdfHeight * scale * CSS_UNITS;
    }
  }, {
    key: "getPageBox",
    value: function getPageBox(pageNum, scale, pagesOverview) {
      var y = FIRST_PAGE_TOP_MARGIN;
      for (var num = 1; num < pageNum; num++) {
        // pagesOverview[pageNum] — для того чтобы сразу отобразить активную страницу
        // иначе если pagesOverview[num] выдаст ошибку пока другие странице не подгружены
        var pageOverview = pagesOverview[pageNum];
        if (!pagesOverview) {
          return null;
        }
        var _height = this.getPageHeight(pageOverview.height, scale);
        y += _height + PAGE_BOTTOM_MARGIN;
      }
      if (!pagesOverview[pageNum]) {
        return null;
      }
      var height = pagesOverview[pageNum].height;
      return {
        top: y,
        height: height
      };
    }
  }, {
    key: "scrollToActivePage",
    value: function scrollToActivePage(pageNum) {
      var _this$props2 = this.props,
        pagesOverview = _this$props2.pagesOverview,
        scale = _this$props2.scale;
      var box = this.getPageBox(pageNum, scale, pagesOverview);
      this.rootNode.scrollTop = box.top - SCROLL_TO_PAGE_TOP_SPACE;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.scale !== this.props.scale) {
        // при изменении масшатаба скроллим к текущей странице
        this.scrollToActivePage(this.state.pageActive);
      }
      if (prevState.pageActive !== this.state.pageActive) {
        this.props.onActivePageChange(this.state.pageActive);
      }
      if (prevProps.activatePage !== this.props.activatePage) {
        this.scrollToActivePage(this.props.activatePage.num);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        pdfDocument = _this$props3.pdfDocument,
        scale = _this$props3.scale,
        defaultPageWidth = _this$props3.defaultPageWidth,
        defaultPageHeight = _this$props3.defaultPageHeight,
        pagesOverview = _this$props3.pagesOverview,
        searchMatch = _this$props3.searchMatch,
        searchMatches = _this$props3.searchMatches,
        pdfjsLib = _this$props3.pdfjsLib;
      var _this$state = this.state,
        pages = _this$state.pages,
        scrollTop = _this$state.scrollTop,
        pageVisibleStart = _this$state.pageVisibleStart,
        pageVisibleEnd = _this$state.pageVisibleEnd;
      var pagesInstances = [];
      for (var num = 1; num <= pdfDocument.numPages; num++) {
        var pageOverview = pagesOverview[num];
        var visible = num >= pageVisibleStart && num <= pageVisibleEnd;
        var pageActiveSearchMatch = searchMatch && searchMatch.pageNum === num ? searchMatch : null;
        var pageSearchMatches = searchMatches[num - 1];
        pagesInstances.push((0,preact_module.h)(PDFPageView, {
          defaultWidth: defaultPageWidth,
          defaultHeight: defaultPageHeight,
          visible: visible,
          scale: scale,
          pdfPage: pageOverview && pageOverview.page,
          num: num,
          activeSearchMatch: pageActiveSearchMatch,
          searchMatches: pageSearchMatches,
          onActiveMatchRender: this.onSearchActiveMatchesRender,
          pdfjsLib: pdfjsLib,
          active: num === this.props.activePage
        }));
      }
      return (0,preact_module.h)("div", {
        className: "pdf-viewer-pages",
        ref: this.onRef,
        onScroll: this.onScroll
      }, pagesInstances);
    }
  }]);
  return PDFView;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/icons.js
var icons = __webpack_require__(49190);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/fullscreen/zoom.js
function zoom_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { zoom_typeof = function _typeof(obj) { return typeof obj; }; } else { zoom_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return zoom_typeof(obj); }











function zoom_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function zoom_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function zoom_createClass(Constructor, protoProps, staticProps) { if (protoProps) zoom_defineProperties(Constructor.prototype, protoProps); if (staticProps) zoom_defineProperties(Constructor, staticProps); return Constructor; }
function zoom_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) zoom_setPrototypeOf(subClass, superClass); }
function zoom_setPrototypeOf(o, p) { zoom_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return zoom_setPrototypeOf(o, p); }
function zoom_createSuper(Derived) { var hasNativeReflectConstruct = zoom_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = zoom_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = zoom_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return zoom_possibleConstructorReturn(this, result); }; }
function zoom_possibleConstructorReturn(self, call) { if (call && (zoom_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return zoom_assertThisInitialized(self); }
function zoom_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function zoom_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function zoom_getPrototypeOf(o) { zoom_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return zoom_getPrototypeOf(o); }
function zoom_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var ZOOM_LEVELS = [0.5, 0.75, 1, 1.25, 1.5, 2, 3, 4];
var Zoom = /*#__PURE__*/function (_Component) {
  zoom_inherits(Zoom, _Component);
  var _super = zoom_createSuper(Zoom);
  function Zoom() {
    var _this;
    zoom_classCallCheck(this, Zoom);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    zoom_defineProperty(zoom_assertThisInitialized(_this), "onSelect", function (event) {
      _this.scaleChanged(event.target.value);
    });
    zoom_defineProperty(zoom_assertThisInitialized(_this), "onDecreaseScale", function () {
      var prevIndex = ZOOM_LEVELS.indexOf(_this.props.scale) - 1;
      if (prevIndex < 0) {
        return;
      }
      _this.scaleChanged(ZOOM_LEVELS[prevIndex]);
    });
    zoom_defineProperty(zoom_assertThisInitialized(_this), "onIncreaseScale", function () {
      var nextIndex = ZOOM_LEVELS.indexOf(_this.props.scale) + 1;
      if (ZOOM_LEVELS.length <= nextIndex) {
        return;
      }
      _this.scaleChanged(ZOOM_LEVELS[nextIndex]);
    });
    return _this;
  }
  zoom_createClass(Zoom, [{
    key: "scaleChanged",
    value: function scaleChanged(newScale) {
      this.props.onScaleChange(newScale);
    }
  }, {
    key: "render",
    value: function render() {
      var scale = this.props.scale;
      var options = ZOOM_LEVELS.map(function (level) {
        return (0,preact_module.h)("option", {
          value: level
        }, Math.round(level * 100), "%");
      });
      return (0,preact_module.h)("div", {
        className: "pdf-viewer-zoom"
      }, (0,preact_module.h)("div", {
        className: "pdf-viewer-button",
        onClick: this.onIncreaseScale
      }, (0,preact_module.h)(icons/* IconPlus */.SC9, null)), (0,preact_module.h)("select", {
        onChange: this.onSelect,
        value: scale
      }, options), (0,preact_module.h)("div", {
        className: "pdf-viewer-button",
        onClick: this.onDecreaseScale
      }, (0,preact_module.h)(icons/* IconMinus */.UrD, null)));
    }
  }]);
  return Zoom;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url.js
var web_url = __webpack_require__(60285);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.js
var web_url_search_params = __webpack_require__(41637);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/fullscreen/printPage.js
function printPage_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { printPage_typeof = function _typeof(obj) { return typeof obj; }; } else { printPage_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return printPage_typeof(obj); }

function printPage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function printPage_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { printPage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { printPage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }











function printPage_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function printPage_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function printPage_createClass(Constructor, protoProps, staticProps) { if (protoProps) printPage_defineProperties(Constructor.prototype, protoProps); if (staticProps) printPage_defineProperties(Constructor, staticProps); return Constructor; }
function printPage_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) printPage_setPrototypeOf(subClass, superClass); }
function printPage_setPrototypeOf(o, p) { printPage_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return printPage_setPrototypeOf(o, p); }
function printPage_createSuper(Derived) { var hasNativeReflectConstruct = printPage_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = printPage_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = printPage_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return printPage_possibleConstructorReturn(this, result); }; }
function printPage_possibleConstructorReturn(self, call) { if (call && (printPage_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return printPage_assertThisInitialized(self); }
function printPage_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function printPage_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function printPage_getPrototypeOf(o) { printPage_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return printPage_getPrototypeOf(o); }
function printPage_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var PRINT_RESOLUTION = 150;
var PRINT_UNITS = PRINT_RESOLUTION / 72.0;

// страница, которая будет выводится на печать
var PrintPage = /*#__PURE__*/function (_Component) {
  printPage_inherits(PrintPage, _Component);
  var _super = printPage_createSuper(PrintPage);
  function PrintPage(props) {
    var _this;
    printPage_classCallCheck(this, PrintPage);
    _this = _super.call(this, props);
    printPage_defineProperty(printPage_assertThisInitialized(_this), "onCanvasRef", function (canvas) {
      _this.canvas = canvas;
    });
    printPage_defineProperty(printPage_assertThisInitialized(_this), "onImgRef", function (img) {
      _this.img = img;
    });
    _this.state = {
      objectUrl: null
    };
    return _this;
  }
  printPage_createClass(PrintPage, [{
    key: "loadCanvasIntoImg",
    value: function loadCanvasIntoImg(canvas) {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        var img = _this2.img;
        if (!img) {
          return reject(new Error('no img was loaded'));
        }
        img.onload = resolve;
        img.onerror = reject;
        canvas.toBlob(function (blob) {
          var objectUrl = URL.createObjectURL(blob);
          img.src = objectUrl;
          _this2.setState(function () {
            return {
              objectUrl: objectUrl
            };
          });
        });
      });
    }
  }, {
    key: "renderPage",
    value: function () {
      var _renderPage = printPage_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this3 = this;
        var _this$props, num, pdfDocument, pdfPage, canvas, viewport, ctx, renderTask;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, num = _this$props.num, pdfDocument = _this$props.pdfDocument;
                _context.next = 3;
                return pdfDocument.getPage(num);
              case 3:
                pdfPage = _context.sent;
                canvas = document.createElement('canvas');
                viewport = pdfPage.getViewport({
                  scale: 1
                });
                canvas.width = Math.floor(viewport.width * PRINT_UNITS);
                canvas.height = Math.floor(viewport.height * PRINT_UNITS);
                ctx = canvas.getContext('2d');
                renderTask = pdfPage.render({
                  canvasContext: ctx,
                  viewport: viewport,
                  transform: [PRINT_UNITS, 0, 0, PRINT_UNITS, 0, 0],
                  intent: 'print'
                });
                this.renderTask = renderTask;
                _context.prev = 11;
                _context.next = 14;
                return renderTask.promise;
              case 14:
                _context.next = 16;
                return this.loadCanvasIntoImg(canvas);
              case 16:
                _context.next = 21;
                break;
              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](11);
                return _context.abrupt("return", console.warn('rendering of a print page failed with', _context.t0));
              case 21:
                this.setState(function () {
                  return {
                    viewport: pdfPage.getViewport({
                      scale: 1
                    }),
                    width: Math.floor(viewport.width * CSS_UNITS),
                    height: Math.floor(viewport.height * CSS_UNITS)
                  };
                }, function () {
                  requestAnimationFrame(function () {
                    _this3.props.onLoad(pdfPage, num);
                  });
                  // удаляем ссылку на таск рендера, чтобы освободить память
                  _this3.renderTask = null;
                });
              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[11, 18]]);
      }));
      function renderPage() {
        return _renderPage.apply(this, arguments);
      }
      return renderPage;
    }()
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.canLoad) {
        this.renderPage();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.canLoad && prevProps.canLoad !== this.props.canLoad && !this.state.viewport) {
        this.renderPage();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.renderTask && !this.state.viewport) {
        this.renderTask.cancel();
      }
      if (this.state.objectUrl) {
        URL.revokeObjectURL(this.state.objectUrl);
      }

      // т.к. компоненты ресайклятся, то необходимо очистить ссылки
      this.renderTask = null;
      this.canvas = null;
      this.img = null;
      this.props = {};
    }
  }, {
    key: "render",
    value: function render() {
      var width = 1,
        height = 1;
      var viewport = this.state.viewport;
      if (viewport) {
        width = this.state.width;
        height = this.state.height;
      }
      return (0,preact_module.h)("div", {
        className: "pdf-viewer-printing-page"
      }, (0,preact_module.h)("img", {
        style: {
          width: width + 'px',
          height: height + 'px'
        },
        ref: this.onImgRef
      }));
    }
  }]);
  return PrintPage;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/pdf/fullscreen/print.css.txt
var print_css = __webpack_require__(2769);
var print_css_default = /*#__PURE__*/__webpack_require__.n(print_css);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/plugins/i18n/index.js + 15 modules
var plugins_i18n = __webpack_require__(407);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/fullscreen/printingOverlay.js
function printingOverlay_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { printingOverlay_typeof = function _typeof(obj) { return typeof obj; }; } else { printingOverlay_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return printingOverlay_typeof(obj); }









function printingOverlay_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function printingOverlay_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function printingOverlay_createClass(Constructor, protoProps, staticProps) { if (protoProps) printingOverlay_defineProperties(Constructor.prototype, protoProps); if (staticProps) printingOverlay_defineProperties(Constructor, staticProps); return Constructor; }
function printingOverlay_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) printingOverlay_setPrototypeOf(subClass, superClass); }
function printingOverlay_setPrototypeOf(o, p) { printingOverlay_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return printingOverlay_setPrototypeOf(o, p); }
function printingOverlay_createSuper(Derived) { var hasNativeReflectConstruct = printingOverlay_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = printingOverlay_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = printingOverlay_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return printingOverlay_possibleConstructorReturn(this, result); }; }
function printingOverlay_possibleConstructorReturn(self, call) { if (call && (printingOverlay_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return printingOverlay_assertThisInitialized(self); }
function printingOverlay_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function printingOverlay_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function printingOverlay_getPrototypeOf(o) { printingOverlay_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return printingOverlay_getPrototypeOf(o); }
function printingOverlay_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





// не грузим все страницы сразу, а частями, иначе на больших пдф сильно грузится процессор
var MAX_SIM_PAGE_RENDERS = 30;
var PDFPagesContainer = /*#__PURE__*/function (_Component) {
  printingOverlay_inherits(PDFPagesContainer, _Component);
  var _super = printingOverlay_createSuper(PDFPagesContainer);
  function PDFPagesContainer(props) {
    var _this;
    printingOverlay_classCallCheck(this, PDFPagesContainer);
    _this = _super.call(this, props);
    printingOverlay_defineProperty(printingOverlay_assertThisInitialized(_this), "onPageLoad", function (page, num) {
      _this.props.onPageLoad(page, num);
      var _assertThisInitialize = printingOverlay_assertThisInitialized(_this),
        pagesState = _assertThisInitialize.pagesState;
      pagesState[num] = 'loaded';
      _this.loadingCnt--;
      var pagesLoaded = _this.state.pagesLoaded + 1;
      _this.setState(function () {
        return {
          pagesLoaded: pagesLoaded
        };
      }, function () {
        if (pagesLoaded >= _this.props.pdfDocument.numPages) {
          requestAnimationFrame(function () {
            _this.props.onPagesBuild();
          });
        }
        page.cleanup();
      });
    });
    _this.state = {
      pagesLoaded: 0
    };
    _this.loadingCnt = 0;
    _this.pagesState = {};
    for (var i = 1; i <= props.pdfDocument.numPages; i++) {
      _this.pagesState[i] = '';
    }
    return _this;
  }
  printingOverlay_createClass(PDFPagesContainer, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props = {};
    }
  }, {
    key: "render",
    value: function render() {
      var pdfDocument = this.props.pdfDocument;
      var pagesState = this.pagesState;
      var pages = [];
      for (var i = 1; i <= pdfDocument.numPages; i++) {
        var canLoad = false;
        if (this.loadingCnt < MAX_SIM_PAGE_RENDERS && pagesState[i] === '') {
          this.loadingCnt++;
          pagesState[i] = 'loading';
          canLoad = true;
        }
        pages.push((0,preact_module.h)(PrintPage, {
          num: i,
          pdfDocument: pdfDocument,
          canLoad: canLoad,
          onLoad: this.onPageLoad
        }));
      }
      return (0,preact_module.h)("div", {
        className: "pdf-viewer-printing-pages"
      }, pages);
    }
  }]);
  return PDFPagesContainer;
}(preact_module/* Component */.wA);
var PrintingOverlay = /*#__PURE__*/function (_Component2) {
  printingOverlay_inherits(PrintingOverlay, _Component2);
  var _super2 = printingOverlay_createSuper(PrintingOverlay);
  function PrintingOverlay(props) {
    var _this2;
    printingOverlay_classCallCheck(this, PrintingOverlay);
    _this2 = _super2.call(this, props);
    printingOverlay_defineProperty(printingOverlay_assertThisInitialized(_this2), "onPagesBuild", function () {
      window.print();
      _this2.props.onPrinted();
    });
    printingOverlay_defineProperty(printingOverlay_assertThisInitialized(_this2), "onPageLoad", function (page, num) {
      if (!_this2.pageStyleSheet) {
        var width = page.view[2];
        var height = page.view[3];
        _this2.pageStyleSheet = document.createElement('style');
        _this2.pageStyleSheet.textContent =
        // "size:<width> <height>" is what we need. But also add "A4" because
        // Firefox incorrectly reports support for the other value.
        '@supports ((size:A4) and (size:1pt 1pt)) {' + '@page { size: ' + width + 'pt ' + height + 'pt; margin: 0;}' + '}';
        document.body.appendChild(_this2.pageStyleSheet);
      }
      _this2.setState(function (prevState) {
        return {
          pagesLoaded: prevState.pagesLoaded + 1
        };
      });
    });
    printingOverlay_defineProperty(printingOverlay_assertThisInitialized(_this2), "onAbort", function () {
      _this2.props.onAbort();
    });
    _this2.state = {
      pagesLoaded: 0
    };
    // тут создается нода, вместо которой будет рендерится контент для печати
    var replaceableNode = document.createElement('div');
    document.body.insertBefore(replaceableNode, document.body.firstChild);
    return _this2;
  }
  printingOverlay_createClass(PrintingOverlay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var pdfDocument = this.props.pdfDocument;
      this.pRenderPages((0,preact_module.h)(PDFPagesContainer, {
        pdfDocument: pdfDocument,
        onPageLoad: this.onPageLoad,
        onPagesBuild: this.onPagesBuild
      }));
      this.printStyleSheet = document.createElement('style');
      this.printStyleSheet.textContent = (print_css_default());
      document.body.appendChild(this.printStyleSheet);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.pageStyleSheet) {
        this.pageStyleSheet.parentNode.removeChild(this.pageStyleSheet);
      }
      this.pRenderPages(null);
      this.printStyleSheet.parentNode.removeChild(this.printStyleSheet);
      this.props = {};
    }
  }, {
    key: "pRenderPages",
    value: function pRenderPages(component) {
      (0,preact_module/* render */.sY)(component, document.body);
    }
  }, {
    key: "render",
    value: function render() {
      var pdfDocument = this.props.pdfDocument;
      var percent = Math.round(this.state.pagesLoaded / pdfDocument.numPages * 100);
      return (0,preact_module.h)("div", {
        className: "pdf-viewer-printing-overlay"
      }, (0,preact_module.h)("div", {
        className: "pdf-viewer-printing-message"
      }, (0,preact_module.h)(plugins_i18n/* Text */.xv, {
        id: "file.pdf_viewer.preparing_document_for_printing"
      }), ' ' + percent + '%', (0,preact_module.h)("br", null), (0,preact_module.h)("a", {
        onClick: this.onAbort
      }, (0,preact_module.h)(plugins_i18n/* Text */.xv, {
        id: "file.pdf_viewer.abort"
      }))));
    }
  }]);
  return PrintingOverlay;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/fullscreen/pagePreview.js
function pagePreview_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { pagePreview_typeof = function _typeof(obj) { return typeof obj; }; } else { pagePreview_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return pagePreview_typeof(obj); }

function pagePreview_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function pagePreview_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { pagePreview_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { pagePreview_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }










function pagePreview_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function pagePreview_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function pagePreview_createClass(Constructor, protoProps, staticProps) { if (protoProps) pagePreview_defineProperties(Constructor.prototype, protoProps); if (staticProps) pagePreview_defineProperties(Constructor, staticProps); return Constructor; }
function pagePreview_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) pagePreview_setPrototypeOf(subClass, superClass); }
function pagePreview_setPrototypeOf(o, p) { pagePreview_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return pagePreview_setPrototypeOf(o, p); }
function pagePreview_createSuper(Derived) { var hasNativeReflectConstruct = pagePreview_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = pagePreview_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = pagePreview_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return pagePreview_possibleConstructorReturn(this, result); }; }
function pagePreview_possibleConstructorReturn(self, call) { if (call && (pagePreview_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return pagePreview_assertThisInitialized(self); }
function pagePreview_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function pagePreview_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function pagePreview_getPrototypeOf(o) { pagePreview_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return pagePreview_getPrototypeOf(o); }
function pagePreview_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var PagePreview = /*#__PURE__*/function (_Component) {
  pagePreview_inherits(PagePreview, _Component);
  var _super = pagePreview_createSuper(PagePreview);
  function PagePreview() {
    var _this;
    pagePreview_classCallCheck(this, PagePreview);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    pagePreview_defineProperty(pagePreview_assertThisInitialized(_this), "onCanvasRef", function (canvas) {
      _this.canvas = canvas;
      _this.state = {
        isRendered: false
      };
    });
    return _this;
  }
  pagePreview_createClass(PagePreview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        pageOverview = _this$props.pageOverview,
        visible = _this$props.visible;
      if (pageOverview && visible) {
        this.renderPage();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!this.state.isRendered) {
        var _this$props2 = this.props,
          pageOverview = _this$props2.pageOverview,
          visible = _this$props2.visible;
        if (pageOverview && visible && (pageOverview !== prevProps.pageOverview || visible !== prevProps.visible)) {
          this.renderPage();
        }
      }
    }
  }, {
    key: "getScale",
    value: function getScale() {
      var _this$props3 = this.props,
        pageOverview = _this$props3.pageOverview,
        width = _this$props3.width;
      var viewport = pageOverview.page.getViewport({
        scale: 1
      });
      return width / viewport.width;
    }
  }, {
    key: "renderPage",
    value: function () {
      var _renderPage = pagePreview_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var pageOverview, page, canvas, scale, vpScale, viewport, ctx, renderTask;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                pageOverview = this.props.pageOverview;
                page = pageOverview.page;
                canvas = this.canvas;
                scale = this.getScale();
                vpScale = window.devicePixelRatio * scale * CSS_UNITS;
                viewport = page.getViewport({
                  scale: vpScale
                });
                canvas.width = Math.round(viewport.width);
                canvas.height = Math.round(viewport.height);
                ctx = canvas.getContext('2d');
                renderTask = page.render({
                  canvasContext: ctx,
                  viewport: viewport
                });
                this.setState(function () {
                  return {
                    isRendered: true
                  };
                }, /*#__PURE__*/pagePreview_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return renderTask.promise;
                        case 2:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })));
              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function renderPage() {
        return _renderPage.apply(this, arguments);
      }
      return renderPage;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        width = _this$props4.width,
        height = _this$props4.height;
      return (0,preact_module.h)("div", {
        className: 'pdf-viewer-page-preview ' + (this.props.active ? 'pdf-viewer-active-preview' : ''),
        style: {
          width: width + 'px',
          height: height + 'px'
        },
        onClick: this.props.onClick
      }, (0,preact_module.h)("canvas", {
        ref: this.onCanvasRef
      }));
    }
  }]);
  return PagePreview;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/fullscreen/sidebar.js
function sidebar_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { sidebar_typeof = function _typeof(obj) { return typeof obj; }; } else { sidebar_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return sidebar_typeof(obj); }









function sidebar_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function sidebar_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function sidebar_createClass(Constructor, protoProps, staticProps) { if (protoProps) sidebar_defineProperties(Constructor.prototype, protoProps); if (staticProps) sidebar_defineProperties(Constructor, staticProps); return Constructor; }
function sidebar_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) sidebar_setPrototypeOf(subClass, superClass); }
function sidebar_setPrototypeOf(o, p) { sidebar_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return sidebar_setPrototypeOf(o, p); }
function sidebar_createSuper(Derived) { var hasNativeReflectConstruct = sidebar_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = sidebar_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = sidebar_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return sidebar_possibleConstructorReturn(this, result); }; }
function sidebar_possibleConstructorReturn(self, call) { if (call && (sidebar_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return sidebar_assertThisInitialized(self); }
function sidebar_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function sidebar_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function sidebar_getPrototypeOf(o) { sidebar_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return sidebar_getPrototypeOf(o); }
function sidebar_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var MAX_PREVIEW_WIDTH = 100;
var PRELOAD_PREVIEWS = 10;
var PREVIEWS_TOP_MARGIN = parseInt((style_default()).fullScreenViewerPreviewsTopMargin);
var PREVIEW_BOTTOM_MARGIN = parseInt((style_default()).fullScreenViewerPreviewsMargin);
var SCROLL_TO_PREVIEW_TOP_SPACE = 3;
var Sidebar = /*#__PURE__*/function (_Component) {
  sidebar_inherits(Sidebar, _Component);
  var _super = sidebar_createSuper(Sidebar);
  function Sidebar(props) {
    var _this;
    sidebar_classCallCheck(this, Sidebar);
    _this = _super.call(this, props);
    sidebar_defineProperty(sidebar_assertThisInitialized(_this), "onRef", function (node) {
      if (!node) {
        return;
      }
      _this.rootNode = node;
      _this.rootNode.scrollTop = 0;
    });
    _this.state = {
      scrollTop: 0
    };
    _this.onScroll = lodash_throttle_default()(function (event) {
      _this.setState(function () {
        return {
          scrollTop: event.target.scrollTop
        };
      });
    }, 300, {
      trailing: true
    });
    return _this;
  }
  sidebar_createClass(Sidebar, [{
    key: "getPreviewSize",
    value: function getPreviewSize(pageOverview, defaultPageWidth, defaultPageHeight) {
      var pageWidth = defaultPageWidth;
      var pageHeight = defaultPageHeight;
      if (pageOverview) {
        pageWidth = pageOverview.width;
        pageHeight = pageOverview.height;
      }
      var pageRatio = pageWidth / pageHeight;
      var width = MAX_PREVIEW_WIDTH;
      var height = width / pageRatio;
      return {
        width: width,
        height: height
      };
    }
  }, {
    key: "getPreviewBox",
    value: function getPreviewBox(pageNum, pagesOverview, defaultPageWidth, defaultPageHeight) {
      var y = PREVIEWS_TOP_MARGIN;
      for (var num = 1; num < pageNum; num++) {
        var pageOverview = pagesOverview[num];
        var _this$getPreviewSize = this.getPreviewSize(pagesOverview[num], defaultPageWidth, defaultPageHeight),
          _height = _this$getPreviewSize.height;
        y += _height + PREVIEW_BOTTOM_MARGIN;
      }
      var _this$getPreviewSize2 = this.getPreviewSize(pagesOverview[pageNum], defaultPageWidth, defaultPageHeight),
        height = _this$getPreviewSize2.height;
      return {
        top: y,
        height: height
      };
    }

    // Скролл до текущей активной странице
  }, {
    key: "scrollTopActivePage",
    value: function scrollTopActivePage() {
      var _this$props = this.props,
        pagesOverview = _this$props.pagesOverview,
        defaultPageWidth = _this$props.defaultPageWidth,
        defaultPageHeight = _this$props.defaultPageHeight;
      // проверяем чтобы активная страница была видимой
      var box = this.getPreviewBox(this.props.activePage, pagesOverview, defaultPageWidth, defaultPageHeight);
      var viewTop = this.rootNode.scrollTop;
      var viewBottom = this.rootNode.offsetHeight + viewTop;
      if (viewTop <= box.top && viewBottom >= box.top + box.height) {} else {
        this.rootNode.scrollTop = box.top - SCROLL_TO_PREVIEW_TOP_SPACE;
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.scrollTopActivePage();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.activePage !== this.props.activePage) {
        this.scrollTopActivePage();
      }
    }
  }, {
    key: "onPageClick",
    value: function onPageClick(num) {
      this.props.onActivatePage(num);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        pdfDocument = _this$props2.pdfDocument,
        defaultPageWidth = _this$props2.defaultPageWidth,
        defaultPageHeight = _this$props2.defaultPageHeight,
        pagesOverview = _this$props2.pagesOverview;
      var scrollTop = this.state.scrollTop;
      var startVisibleNum, endVisibleNum;
      var y = PREVIEWS_TOP_MARGIN;
      for (var num = 1; num <= pdfDocument.numPages; num++) {
        var pageOverview = pagesOverview[num];
        var _this$getPreviewSize3 = this.getPreviewSize(pagesOverview[num], defaultPageWidth, defaultPageHeight),
          height = _this$getPreviewSize3.height;
        if (scrollTop >= y - PREVIEW_BOTTOM_MARGIN && scrollTop <= y + height + PREVIEW_BOTTOM_MARGIN) {
          startVisibleNum = Math.max(0, num - PRELOAD_PREVIEWS);
          endVisibleNum = Math.min(pdfDocument.numPages, num + PRELOAD_PREVIEWS);
          break;
        }
        y += height + PREVIEW_BOTTOM_MARGIN;
      }
      var previews = [];
      for (var _num = 1; _num <= pdfDocument.numPages; _num++) {
        var _pageOverview = pagesOverview[_num];
        var visible = _num >= startVisibleNum && _num <= endVisibleNum;
        var _this$getPreviewSize4 = this.getPreviewSize(_pageOverview, defaultPageWidth, defaultPageHeight),
          width = _this$getPreviewSize4.width,
          _height2 = _this$getPreviewSize4.height;
        previews.push((0,preact_module.h)(PagePreview, {
          width: width,
          height: _height2,
          pageOverview: _pageOverview,
          visible: visible,
          active: this.props.activePage === _num,
          onClick: this.onPageClick.bind(this, _num)
        }));
      }
      return (0,preact_module.h)("div", {
        ref: this.onRef,
        className: "pdf-viewer-sidebar",
        onScroll: this.onScroll
      }, (0,preact_module.h)("div", {
        className: "pdf-viewer-previews"
      }, previews));
    }
  }]);
  return Sidebar;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(21791);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./node_modules/is-hotkey/lib/index.js
var lib = __webpack_require__(28199);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/fullscreen/search.js
function search_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { search_typeof = function _typeof(obj) { return typeof obj; }; } else { search_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return search_typeof(obj); }









function search_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function search_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function search_createClass(Constructor, protoProps, staticProps) { if (protoProps) search_defineProperties(Constructor.prototype, protoProps); if (staticProps) search_defineProperties(Constructor, staticProps); return Constructor; }
function search_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) search_setPrototypeOf(subClass, superClass); }
function search_setPrototypeOf(o, p) { search_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return search_setPrototypeOf(o, p); }
function search_createSuper(Derived) { var hasNativeReflectConstruct = search_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = search_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = search_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return search_possibleConstructorReturn(this, result); }; }
function search_possibleConstructorReturn(self, call) { if (call && (search_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return search_assertThisInitialized(self); }
function search_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function search_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function search_getPrototypeOf(o) { search_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return search_getPrototypeOf(o); }
function search_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var isEscKey = (0,lib/* default */.ZP)('escape');
var isEnterKey = (0,lib/* default */.ZP)('enter');
var SearchResult = /*#__PURE__*/function (_Component) {
  search_inherits(SearchResult, _Component);
  var _super = search_createSuper(SearchResult);
  function SearchResult(props) {
    var _this;
    search_classCallCheck(this, SearchResult);
    _this = _super.call(this, props);
    search_defineProperty(search_assertThisInitialized(_this), "onFoundMatches", function (_ref) {
      var pageNum = _ref.pageNum;
      //console.log('Found matches in', pageNum, 'total matches', this.props.finder.totalMatches, this.props.finder.query)
      var finder = _this.props.finder;
      _this.props.onTotalMatchesChange(finder.totalMatches);
    });
    _this.state = {};
    var _finder = props.finder;
    _finder.init();
    return _this;
  }
  search_createClass(SearchResult, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.finder.on('found-matches', this.onFoundMatches);
      this.doLookup();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.query !== this.props.query) {
        this.doLookup();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.finder.removeListener('found-matches', this.onFoundMatches);
    }
  }, {
    key: "doLookup",
    value: function doLookup() {
      var _this$props = this.props,
        finder = _this$props.finder,
        query = _this$props.query;
      finder.setQuery(query);
      finder.lookForMatches();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        totalMatches = _this$props2.totalMatches,
        selectedMatchIdx = _this$props2.selectedMatchIdx,
        notFound = _this$props2.notFound;
      var matchesText;
      if (notFound) {
        matchesText = (0,preact_module.h)("div", null, "Phrase not found");
      } else {
        if (totalMatches > 1000) {
          matchesText = (0,preact_module.h)("div", null, "Found More than 1000 matches");
        } else if (totalMatches === 0) {
          matchesText = (0,preact_module.h)("div", null, "Searching...");
        } else {
          matchesText = (0,preact_module.h)("div", null, selectedMatchIdx + 1, " of ", totalMatches, " match", totalMatches > 1 ? 'es' : '');
        }
      }
      return (0,preact_module.h)("div", {
        className: "pdf-viewer-search-result"
      }, matchesText, !notFound ? (0,preact_module.h)("div", null, (0,preact_module.h)("button", {
        onClick: this.props.onPrevMatch
      }, "Prev"), (0,preact_module.h)("button", {
        onClick: this.props.onNextMatch
      }, "Next")) : null, (0,preact_module.h)("div", {
        className: "close",
        onClick: this.props.onClose
      }, "\xD7"));
    }
  }]);
  return SearchResult;
}(preact_module/* Component */.wA);
var Search = /*#__PURE__*/function (_Component2) {
  search_inherits(Search, _Component2);
  var _super2 = search_createSuper(Search);
  function Search(props) {
    var _this2;
    search_classCallCheck(this, Search);
    _this2 = _super2.call(this, props);
    search_defineProperty(search_assertThisInitialized(_this2), "onChange", function (event) {
      _this2.props.finder.abort();
      _this2.setState(function () {
        return {
          query: event.target.value,
          scrollToFirstMatch: true,
          notFound: false
        };
      });
    });
    search_defineProperty(search_assertThisInitialized(_this2), "onInputKeyDown", function (event) {
      if (isEscKey(event)) {
        _this2.clearSearch();
      } else if (isEnterKey(event)) {
        _this2.onNextMatch();
      }
    });
    search_defineProperty(search_assertThisInitialized(_this2), "onFoundMatches", function () {
      var _this2$props = _this2.props,
        finder = _this2$props.finder,
        pdfDocument = _this2$props.pdfDocument;
      var matches = finder.rawMatches;
      if (_this2.state.scrollToFirstMatch) {
        var foundMatches;
        // ищем первую страницу, в которой найдено совпадение, чтобы проскроллить на него
        for (var i = 0; i !== pdfDocument.numPages; i++) {
          if (!matches[i]) {
            // совпадения еще не готовы, надо подождать, т.к. нам надо проскролить именно на первую страницу с совпадением,
            // а finder может искать в них не по порядку
            break;
          }
          if (!matches[i].length) {
            continue;
          }
          foundMatches = {
            pageNum: i + 1,
            matches: matches[i],
            matchesLength: finder.getPageMatchesLength(i),
            selectedMatchIdx: 0,
            query: _this2.state.query
          };
          break;
        }
        if (foundMatches) {
          _this2.setState(function () {
            return {
              scrollToFirstMatch: false,
              matchIdx: 0
            };
          }, function () {
            _this2.activateMatch(foundMatches);
          });
        }
      }
      _this2.foundMatchesDebounced(finder.matches);
    });
    search_defineProperty(search_assertThisInitialized(_this2), "onFinderSearchEnd", function () {
      var finder = _this2.props.finder;
      if (!finder.totalMatches) {
        _this2.setState(function () {
          return {
            notFound: true
          };
        }, function () {
          // говорим выше что матчи надо почистить
          _this2.activateMatch(null);
          _this2.foundMatches([]);
        });
      }
    });
    search_defineProperty(search_assertThisInitialized(_this2), "onPrevMatch", function () {
      if (_this2.state.matchIdx <= 0) {
        return;
      }
      var matchIdx = _this2.state.matchIdx - 1;
      _this2.setState(function () {
        return {
          matchIdx: matchIdx
        };
      }, function () {
        _this2.activateMatchByIdx(matchIdx);
      });
    });
    search_defineProperty(search_assertThisInitialized(_this2), "onNextMatch", function () {
      var totalMatches = _this2.state.totalMatches;
      var matchIdx = _this2.state.matchIdx + 1;
      if (matchIdx >= totalMatches) {
        return;
      }
      _this2.setState(function () {
        return {
          matchIdx: matchIdx
        };
      }, function () {
        _this2.activateMatchByIdx(matchIdx);
      });
    });
    search_defineProperty(search_assertThisInitialized(_this2), "onTotalMatchesChange", function (totalMatches) {
      _this2.setState(function () {
        return {
          totalMatches: totalMatches
        };
      });
    });
    search_defineProperty(search_assertThisInitialized(_this2), "onSearchResultClose", function () {
      _this2.clearSearch();
    });
    _this2.state = {
      query: '',
      scrollToFirstMatch: true,
      totalMatches: 0,
      matchIdx: 0,
      notFound: false
    };
    _this2.foundMatchesDebounced = lodash_debounce_default()(_this2.foundMatches, 200, {
      trailing: true
    });
    return _this2;
  }
  search_createClass(Search, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var finder = this.props.finder;
      finder.on('found-matches', this.onFoundMatches);
      finder.on('search-end', this.onFinderSearchEnd);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var finder = this.props.finder;
      finder.removeListener('found-matches', this.onFoundMatches);
      finder.removeListener('search-end', this.onFinderSearchEnd);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.query !== this.state.query && this.state.query === '') {
        // говорим выше что матчи надо почистить
        this.activateMatch(null);
        this.foundMatches([]);
      }
    }
  }, {
    key: "clearSearch",
    value: function clearSearch() {
      this.setState(function () {
        return {
          query: '',
          notFound: false
        };
      });
    }
  }, {
    key: "activateMatchByIdx",
    value: function activateMatchByIdx(idx) {
      var finder = this.props.finder;
      var pagesMatches = finder.rawMatches;
      var curIdx = 0;
      var matchIdx;
      var matches;
      var pageIdx;
      for (var i = 0; i != pagesMatches.length; i++) {
        if (curIdx + pagesMatches[i].length <= idx) {
          curIdx += pagesMatches[i].length;
        } else {
          matches = pagesMatches[i];
          matchIdx = idx - curIdx;
          pageIdx = i;
          break;
        }
      }
      if (matches) {
        var searchMatch = {
          pageNum: pageIdx + 1,
          matches: matches,
          matchesLength: finder.getPageMatchesLength(pageIdx),
          selectedMatchIdx: matchIdx,
          query: this.state.query
        };
        this.activateMatch(searchMatch);
      }
    }
  }, {
    key: "activateMatch",
    value: function activateMatch(searchMatch) {
      this.props.onActivateMatch(searchMatch);
    }
  }, {
    key: "foundMatches",
    value: function foundMatches(matches) {
      this.props.onMatches(matches);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        query = _this$state.query,
        totalMatches = _this$state.totalMatches,
        matchIdx = _this$state.matchIdx,
        notFound = _this$state.notFound;
      var searchResult = null;
      if (query.length > 0) {
        searchResult = (0,preact_module.h)(SearchResult, {
          query: query,
          finder: this.props.finder,
          onPrevMatch: this.onPrevMatch,
          onNextMatch: this.onNextMatch,
          totalMatches: totalMatches,
          selectedMatchIdx: matchIdx,
          onTotalMatchesChange: this.onTotalMatchesChange,
          notFound: notFound,
          onClose: this.onSearchResultClose
        });
      }
      return (0,preact_module.h)("div", {
        className: 'pdf-viewer-search ' + (notFound ? 'pdf-viewer-search-not-found' : '')
      }, (0,preact_module.h)("div", {
        className: "pdf-viewer-search-bar"
      }, (0,preact_module.h)("input", {
        value: query,
        type: "text",
        placeholder: "Search",
        onInput: this.onChange,
        onKeyDown: this.onInputKeyDown
      }), (0,preact_module.h)("div", {
        className: "pdf-viewer-search-icon"
      })), searchResult);
    }
  }]);
  return Search;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/lodash.chunk/index.js
var lodash_chunk = __webpack_require__(60764);
var lodash_chunk_default = /*#__PURE__*/__webpack_require__.n(lodash_chunk);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__(24603);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(15306);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(4723);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__(2707);
// EXTERNAL MODULE: ./node_modules/events/events.js
var events = __webpack_require__(94092);
var events_default = /*#__PURE__*/__webpack_require__.n(events);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/fullscreen/finder.js
function finder_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { finder_typeof = function _typeof(obj) { return typeof obj; }; } else { finder_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return finder_typeof(obj); }

function finder_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function finder_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { finder_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { finder_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function finder_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function finder_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function finder_createClass(Constructor, protoProps, staticProps) { if (protoProps) finder_defineProperties(Constructor.prototype, protoProps); if (staticProps) finder_defineProperties(Constructor, staticProps); return Constructor; }
function finder_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) finder_setPrototypeOf(subClass, superClass); }
function finder_setPrototypeOf(o, p) { finder_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return finder_setPrototypeOf(o, p); }
function finder_createSuper(Derived) { var hasNativeReflectConstruct = finder_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = finder_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = finder_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return finder_possibleConstructorReturn(this, result); }; }
function finder_possibleConstructorReturn(self, call) { if (call && (finder_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return finder_assertThisInitialized(self); }
function finder_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function finder_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function finder_getPrototypeOf(o) { finder_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return finder_getPrototypeOf(o); }


















var CHARACTERS_TO_NORMALIZE = {
  "\u2018": '\'',
  // Left single quotation mark
  "\u2019": '\'',
  // Right single quotation mark
  "\u201A": '\'',
  // Single low-9 quotation mark
  "\u201B": '\'',
  // Single high-reversed-9 quotation mark
  "\u201C": '"',
  // Left double quotation mark
  "\u201D": '"',
  // Right double quotation mark
  "\u201E": '"',
  // Double low-9 quotation mark
  "\u201F": '"',
  // Double high-reversed-9 quotation mark
  "\xBC": '1/4',
  // Vulgar fraction one quarter
  "\xBD": '1/2',
  // Vulgar fraction one half
  "\xBE": '3/4' // Vulgar fraction three quarters
};

var normalizationRegex = null;
function normalize(text) {
  if (!normalizationRegex) {
    // Compile the regular expression for text normalization once.
    var replace = Object.keys(CHARACTERS_TO_NORMALIZE).join('');
    normalizationRegex = new RegExp("[".concat(replace, "]"), 'g');
  }
  return text.replace(normalizationRegex, function (ch) {
    return CHARACTERS_TO_NORMALIZE[ch];
  });
}
var Finder = /*#__PURE__*/function (_EventEmitter) {
  finder_inherits(Finder, _EventEmitter);
  var _super = finder_createSuper(Finder);
  function Finder(pdfDocument) {
    var _this;
    finder_classCallCheck(this, Finder);
    _this = _super.call(this);
    _this._extractTextPromises = [];
    _this._pageContents = [];
    _this._pageContentsItems = [];
    _this._pendingFindMatches = [];
    _this._pageMatches = [];
    // содержит подготовленные метчи, с информацией о запросе
    _this._pageMatchesPrepared = [];
    _this._pageMatchesLength = [];
    _this._initialized = false;
    _this._initialization = false;
    _this._query = null;
    _this._matchesCountTotal = 0;
    _this._lookingForMatches = false;
    _this.pdfDocument = pdfDocument;
    _this.caseSensitive = false;
    _this.entireWord = false;
    _this.phraseSearch = true;
    _this.taskId = 0;
    return _this;
  }
  finder_createClass(Finder, [{
    key: "init",
    value: function () {
      var _init = finder_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this._initialized || this._initialization)) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                this._initialization = true;
                _context.next = 5;
                return this._extractText();
              case 5:
                this._initialization = false;
                this._initialized = true;
                this.emit('initialized');
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "totalMatches",
    get: function get() {
      return this._matchesCountTotal;
    }
  }, {
    key: "matches",
    get: function get() {
      return this._pageMatchesPrepared;
    }
  }, {
    key: "rawMatches",
    get: function get() {
      return this._pageMatches;
    }
  }, {
    key: "getPageMatchesLength",
    value: function getPageMatchesLength(num) {
      var pageIdx = num - 1;
      return this._pageMatchesLength[pageIdx];
    }
  }, {
    key: "setQuery",
    value: function setQuery(query) {
      this._query = query;
    }
  }, {
    key: "abort",
    value: function abort() {
      this._pendingFindMatches = [];
      this._pageMatches = [];
      this._pageMatchesPrepared = [];
      this._pageMatchesLength = [];
      this._query = null;
      this._matchesCountTotal = 0;
      this._lookingForMatches = false;
      this.taskId++;
    }
  }, {
    key: "lookForMatches",
    value: function () {
      var _lookForMatches = finder_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;
        var currentTaskId, promises, i;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.taskId++;
                currentTaskId = this.taskId;
                this._lookingForMatches = true;
                promises = [];
                i = 0;
              case 5:
                if (!(i < this.pdfDocument.numPages)) {
                  _context2.next = 16;
                  break;
                }
                if (!(currentTaskId !== this.taskId)) {
                  _context2.next = 9;
                  break;
                }
                // таск поиска был отменен
                this._lookingForMatches = false;
                return _context2.abrupt("return");
              case 9:
                if (!(this._pendingFindMatches[i] === true)) {
                  _context2.next = 11;
                  break;
                }
                return _context2.abrupt("continue", 13);
              case 11:
                this._pendingFindMatches[i] = true;
                promises.push(this._extractTextPromises[i].then(function (pageIdx) {
                  if (currentTaskId !== _this2.taskId) {
                    // таск поиска был отменен
                    _this2._lookingForMatches = false;
                    return;
                  }
                  delete _this2._pendingFindMatches[pageIdx];
                  _this2._calculateMatch(pageIdx);
                }));
              case 13:
                i++;
                _context2.next = 5;
                break;
              case 16:
                if (!(currentTaskId !== this.taskId)) {
                  _context2.next = 19;
                  break;
                }
                // таск поиска был отменен
                this._lookingForMatches = false;
                return _context2.abrupt("return");
              case 19:
                _context2.next = 21;
                return Promise.all(promises);
              case 21:
                this._lookingForMatches = false;
                this.emit('search-end');
              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function lookForMatches() {
        return _lookForMatches.apply(this, arguments);
      }
      return lookForMatches;
    }()
  }, {
    key: "_calculateMatch",
    value: function _calculateMatch(pageIndex) {
      var pageContent = this._pageContents[pageIndex];
      var query = this._query;
      var caseSensitive = this.caseSensitive,
        entireWord = this.entireWord,
        phraseSearch = this.phraseSearch;
      if (query.length === 0) {
        return;
      }
      if (!caseSensitive) {
        pageContent = pageContent.toLowerCase();
        query = query.toLowerCase();
      }
      if (phraseSearch) {
        this._calculatePhraseMatch(query, pageIndex, pageContent, entireWord);
      } else {
        this._calculateWordMatch(query, pageIndex, pageContent, entireWord);
      }
      this._pageMatchesPrepared[pageIndex] = {
        matches: this._pageMatches[pageIndex],
        matchesLength: this._pageMatchesLength[pageIndex],
        query: this._query
      };

      // Update the match count.
      var pageMatchesCount = this._pageMatches[pageIndex].length;
      if (pageMatchesCount > 0) {
        this._matchesCountTotal += pageMatchesCount;
        this.emit('found-matches', {
          pageNum: pageIndex + 1
        });
      }
    }
  }, {
    key: "_calculatePhraseMatch",
    value: function _calculatePhraseMatch(query, pageIndex, pageContent, entireWord) {
      var matches = [];
      var queryLen = query.length;
      var matchIdx = -queryLen;
      while (true) {
        matchIdx = pageContent.indexOf(query, matchIdx + queryLen);
        if (matchIdx === -1) {
          break;
        }
        if (entireWord && !this._isEntireWord(pageContent, matchIdx, queryLen)) {
          continue;
        }
        matches.push(matchIdx);
      }
      if (matches.length) {
        console.info('Found matches', matches, 'For page', pageIndex);
      }
      this._pageMatches[pageIndex] = matches;
    }
  }, {
    key: "_calculateWordMatch",
    value: function _calculateWordMatch(query, pageIndex, pageContent, entireWord) {
      var matchesWithLength = [];

      // Divide the query into pieces and search for text in each piece.
      var queryArray = query.match(/\S+/g);
      for (var i = 0, len = queryArray.length; i < len; i++) {
        var subquery = queryArray[i];
        var subqueryLen = subquery.length;
        var matchIdx = -subqueryLen;
        while (true) {
          matchIdx = pageContent.indexOf(subquery, matchIdx + subqueryLen);
          if (matchIdx === -1) {
            break;
          }
          if (entireWord && !this._isEntireWord(pageContent, matchIdx, subqueryLen)) {
            continue;
          }
          // Other searches do not, so we store the length.
          matchesWithLength.push({
            match: matchIdx,
            matchLength: subqueryLen,
            skipped: false
          });
        }
      }

      // Prepare arrays for storing the matches.
      this._pageMatchesLength[pageIndex] = [];
      this._pageMatches[pageIndex] = [];

      // Sort `matchesWithLength`, remove intersecting terms and put the result
      // into the two arrays.
      this._prepareMatches(matchesWithLength, this._pageMatches[pageIndex], this._pageMatchesLength[pageIndex]);
    }

    /**
     * Helper for multi-term search that fills the `matchesWithLength` array
     * and handles cases where one search term includes another search term (for
     * example, "tamed tame" or "this is"). It looks for intersecting terms in
     * the `matches` and keeps elements with a longer match length.
     */
  }, {
    key: "_prepareMatches",
    value: function _prepareMatches(matchesWithLength, matches, matchesLength) {
      function isSubTerm(matchesWithLength, currentIndex) {
        var currentElem = matchesWithLength[currentIndex];
        var nextElem = matchesWithLength[currentIndex + 1];

        // Check for cases like "TAMEd TAME".
        if (currentIndex < matchesWithLength.length - 1 && currentElem.match === nextElem.match) {
          currentElem.skipped = true;
          return true;
        }

        // Check for cases like "thIS IS".
        for (var i = currentIndex - 1; i >= 0; i--) {
          var prevElem = matchesWithLength[i];
          if (prevElem.skipped) {
            continue;
          }
          if (prevElem.match + prevElem.matchLength < currentElem.match) {
            break;
          }
          if (prevElem.match + prevElem.matchLength >= currentElem.match + currentElem.matchLength) {
            currentElem.skipped = true;
            return true;
          }
        }
        return false;
      }

      // Sort the array of `{ match: <match>, matchLength: <matchLength> }`
      // objects on increasing index first and on the length otherwise.
      matchesWithLength.sort(function (a, b) {
        return a.match === b.match ? a.matchLength - b.matchLength : a.match - b.match;
      });
      for (var i = 0, len = matchesWithLength.length; i < len; i++) {
        if (isSubTerm(matchesWithLength, i)) {
          continue;
        }
        matches.push(matchesWithLength[i].match);
        matchesLength.push(matchesWithLength[i].matchLength);
      }
    }

    /**
     * Determine if the search query constitutes a "whole word", by comparing the
     * first/last character type with the preceding/following character type.
     */
  }, {
    key: "_isEntireWord",
    value: function _isEntireWord(content, startIdx, length) {
      if (startIdx > 0) {
        var first = content.charCodeAt(startIdx);
        var limit = content.charCodeAt(startIdx - 1);
        if (getCharacterType(first) === getCharacterType(limit)) {
          return false;
        }
      }
      var endIdx = startIdx + length - 1;
      if (endIdx < content.length - 1) {
        var last = content.charCodeAt(endIdx);
        var _limit = content.charCodeAt(endIdx + 1);
        if (getCharacterType(last) === getCharacterType(_limit)) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "_extractPageText",
    value: function () {
      var _extractPageText2 = finder_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(i) {
        var pdfPage, textContent, textItems, strBuf, j, jj;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.pdfDocument.getPage(i + 1);
              case 3:
                pdfPage = _context3.sent;
                _context3.next = 6;
                return pdfPage.getTextContent({
                  normalizeWhitespace: true
                });
              case 6:
                textContent = _context3.sent;
                textItems = textContent.items;
                strBuf = [];
                for (j = 0, jj = textItems.length; j < jj; j++) {
                  strBuf.push(textItems[j].str);
                }

                // Store the normalized page content (text items) as one string.
                this._pageContents[i] = normalize(strBuf.join(''));
                _context3.next = 17;
                break;
              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](0);
                console.error("Unable to get text content for page ".concat(i + 1), _context3.t0);
                // Page error -- assuming no text content.
                this._pageContents[i] = '';
              case 17:
                return _context3.abrupt("return", i);
              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 13]]);
      }));
      function _extractPageText(_x) {
        return _extractPageText2.apply(this, arguments);
      }
      return _extractPageText;
    }()
  }, {
    key: "_extractText",
    value: function _extractText() {
      if (this._extractTextPromises.length) {
        return;
      }
      for (var i = 0; i < this.pdfDocument.numPages; i++) {
        this._extractTextPromises[i] = this._extractPageText(i);
      }
      return Promise.all(this._extractTextPromises);
    }
  }]);
  return Finder;
}((events_default()));

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/util.js
var util = __webpack_require__(33103);
// EXTERNAL MODULE: ./node_modules/downloadjs/download.js
var download = __webpack_require__(27266);
var download_default = /*#__PURE__*/__webpack_require__.n(download);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/fullscreen/navigation.js
function navigation_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { navigation_typeof = function _typeof(obj) { return typeof obj; }; } else { navigation_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return navigation_typeof(obj); }









function navigation_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function navigation_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function navigation_createClass(Constructor, protoProps, staticProps) { if (protoProps) navigation_defineProperties(Constructor.prototype, protoProps); if (staticProps) navigation_defineProperties(Constructor, staticProps); return Constructor; }
function navigation_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) navigation_setPrototypeOf(subClass, superClass); }
function navigation_setPrototypeOf(o, p) { navigation_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return navigation_setPrototypeOf(o, p); }
function navigation_createSuper(Derived) { var hasNativeReflectConstruct = navigation_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = navigation_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = navigation_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return navigation_possibleConstructorReturn(this, result); }; }
function navigation_possibleConstructorReturn(self, call) { if (call && (navigation_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return navigation_assertThisInitialized(self); }
function navigation_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function navigation_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function navigation_getPrototypeOf(o) { navigation_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return navigation_getPrototypeOf(o); }
function navigation_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var navigation_isEnterKey = (0,lib/* default */.ZP)('enter');

var PdfPageNavigation = /*#__PURE__*/function (_Component) {
  navigation_inherits(PdfPageNavigation, _Component);
  var _super = navigation_createSuper(PdfPageNavigation);
  function PdfPageNavigation(props) {
    var _this;
    navigation_classCallCheck(this, PdfPageNavigation);
    _this = _super.call(this, props);
    navigation_defineProperty(navigation_assertThisInitialized(_this), "onRefInput", function (node) {
      _this.inputText = node;
    });
    navigation_defineProperty(navigation_assertThisInitialized(_this), "onChange", function (event) {
      var _this$props = _this.props,
        activePage = _this$props.activePage,
        pdfDocument = _this$props.pdfDocument;
      if (navigation_isEnterKey(event)) {
        var page = _this.inputText.value;
        if (!page) {
          return false;
        }
        page = parseInt(page) || 0;
        if (page > pdfDocument.numPages || page === 0) {
          _this.inputText.value = activePage;
        } else if (page === activePage) {
          return false;
        } else {
          _this.props.onActivatePage(page);
        }
      }
    });
    navigation_defineProperty(navigation_assertThisInitialized(_this), "onInput", function (event) {
      if (!event.data) {
        return false;
      }
      var page = parseInt(event.data);
      if (isNaN(page)) {
        _this.inputText.value = '';
      }
    });
    navigation_defineProperty(navigation_assertThisInitialized(_this), "onNextPageClick", function (event) {
      var _this$props2 = _this.props,
        activePage = _this$props2.activePage,
        pdfDocument = _this$props2.pdfDocument;
      if (activePage === pdfDocument.numPages) {
        return false;
      } else {
        _this.props.onActivatePage(activePage + 1);
      }
    });
    navigation_defineProperty(navigation_assertThisInitialized(_this), "onPrevPageClick", function (event) {
      var activePage = _this.props.activePage;
      if (activePage === 1) {
        return false;
      } else {
        _this.props.onActivatePage(activePage - 1);
      }
    });
    return _this;
  }
  navigation_createClass(PdfPageNavigation, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        activePage = _this$props3.activePage,
        pdfDocument = _this$props3.pdfDocument;
      var inputText = (0,preact_module.h)("input", {
        type: "text",
        id: "page-navigation",
        className: "current-page",
        value: activePage,
        maxLength: "4",
        onKeyDown: this.onChange,
        onInput: this.onInput,
        ref: this.onRefInput
      });
      return (0,preact_module.h)("div", {
        className: "pdf-viewer-navigation"
      }, (0,preact_module.h)("div", {
        className: "pdf-viewer-button to-prev",
        style: {
          transform: 'rotate(90deg)'
        },
        onClick: this.onPrevPageClick
      }, (0,preact_module.h)(icons/* IconChevronLeft */.ed9, null)), (0,preact_module.h)("div", {
        className: "pdf-viewer-button to-next",
        style: {
          transform: 'rotate(-90deg)'
        },
        onClick: this.onNextPageClick
      }, (0,preact_module.h)(icons/* IconChevronLeft */.ed9, null)), inputText, " / ", pdfDocument.numPages);
    }
  }]);
  return PdfPageNavigation;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/fullscreen.js
function fullscreen_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { fullscreen_typeof = function _typeof(obj) { return typeof obj; }; } else { fullscreen_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return fullscreen_typeof(obj); }
function fullscreen_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = fullscreen_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function fullscreen_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return fullscreen_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return fullscreen_arrayLikeToArray(o, minLen); }
function fullscreen_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function fullscreen_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function fullscreen_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { fullscreen_ownKeys(Object(source), true).forEach(function (key) { fullscreen_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { fullscreen_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



















function fullscreen_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function fullscreen_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { fullscreen_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { fullscreen_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function fullscreen_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function fullscreen_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function fullscreen_createClass(Constructor, protoProps, staticProps) { if (protoProps) fullscreen_defineProperties(Constructor.prototype, protoProps); if (staticProps) fullscreen_defineProperties(Constructor, staticProps); return Constructor; }
function fullscreen_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) fullscreen_setPrototypeOf(subClass, superClass); }
function fullscreen_setPrototypeOf(o, p) { fullscreen_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return fullscreen_setPrototypeOf(o, p); }
function fullscreen_createSuper(Derived) { var hasNativeReflectConstruct = fullscreen_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = fullscreen_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = fullscreen_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return fullscreen_possibleConstructorReturn(this, result); }; }
function fullscreen_possibleConstructorReturn(self, call) { if (call && (fullscreen_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return fullscreen_assertThisInitialized(self); }
function fullscreen_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function fullscreen_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function fullscreen_getPrototypeOf(o) { fullscreen_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return fullscreen_getPrototypeOf(o); }
function fullscreen_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }














var fullscreen_isEscKey = (0,lib/* default */.ZP)('escape');
var PDFFullScreenViewer = /*#__PURE__*/function (_Component) {
  fullscreen_inherits(PDFFullScreenViewer, _Component);
  var _super = fullscreen_createSuper(PDFFullScreenViewer);
  function PDFFullScreenViewer(props) {
    var _this;
    fullscreen_classCallCheck(this, PDFFullScreenViewer);
    _this = _super.call(this, props);
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onPageLoaded", /*#__PURE__*/function () {
      var _ref = fullscreen_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(num, promise, stateUpdate) {
        var page, viewport, countLoadedPages, state;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return promise;
              case 2:
                page = _context.sent;
                viewport = page.getViewport({
                  scale: 1
                });
                countLoadedPages = _this.state.countLoadedPages + 1;
                state = {
                  countLoadedPages: countLoadedPages,
                  isLoadingPages: countLoadedPages < _this.props.pdfDocument.numPages
                };
                if (stateUpdate) {
                  Object.assign(state, stateUpdate);
                }
                if (num === _this.props.page) {
                  state = fullscreen_objectSpread(fullscreen_objectSpread({}, state), {}, {
                    activePage: num,
                    activatePage: {
                      num: _this.props.page
                    }
                  });
                }
                _this.setState(function (prev) {
                  return fullscreen_objectSpread(fullscreen_objectSpread({}, state), {}, {
                    pagesOverview: fullscreen_objectSpread(fullscreen_objectSpread({}, prev.pagesOverview), {}, fullscreen_defineProperty({}, num, {
                      width: viewport.width,
                      height: viewport.height,
                      page: page
                    }))
                  });
                });
              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }());
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onDocumentKeydown", function (event) {
      if (event.target && (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA')) {
        return;
      }
      if (fullscreen_isEscKey(event)) {
        // останавливаем пропагацию, чтобы событие не уходило в редактор
        _this.callOnClose();
      }
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "handleWindowResize", function () {
      // Обработчик изменения размера окна
      _this.checkScreenWidth();
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onClose", function () {
      // передаём номер текущий страницы из полноэкранного режима
      _this.props.onPageChange(_this.state.activePage);
      _this.callOnClose();
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onScaleChange", function (scale) {
      _this.props.onScaleChange(scale);
      _this.setState(function () {
        return {
          scale: scale
        };
      });
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "getDefaultScale", function (size) {
      // рассчитываем уровень зума при открытии PDF
      // адаптируемся под размер экрана, считаем что максимальный размер страницы это половина экрана
      var screenWidth = window.screen.width;
      var availableWidth = screenWidth / 2;
      var availableScale = availableWidth / size.width;
      var delta = Number.POSITIVE_INFINITY;
      var scale = 0;
      var _iterator = fullscreen_createForOfIteratorHelper(ZOOM_LEVELS),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var s = _step.value;
          var d = Math.abs(s - availableScale);
          if (d < delta) {
            delta = d;
            scale = s;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return scale;
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onPrint", function () {
      if (_this.props.options && _this.props.options.onPrint) {
        if (_this.props.options.onPrint({
          attachment: _this.props.attachment
        }) === true) {
          return;
        }
      }
      _this.setState(function () {
        return {
          isPrinting: true
        };
      });
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onPrinted", function () {
      _this.setState(function () {
        return {
          isPrinting: false
        };
      });
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onPrintAbort", function () {
      _this.setState(function () {
        return {
          isPrinting: false
        };
      });
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onActivePageChange", function (num) {
      _this.setState(function () {
        return {
          activePage: num
        };
      });
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onActivatePage", function (num) {
      _this.setState(function () {
        return {
          activatePage: {
            num: num
          }
        };
      });
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onToggleSidebar", function () {
      _this.setState(function (prevState) {
        return {
          isSidebarVisible: !prevState.isSidebarVisible
        };
      });
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onDownload", function () {
      var _this$props = _this.props,
        attachment = _this$props.attachment,
        editor = _this$props.editor;
      if (!editor.plugins.attachmentManager.download(attachment)) {
        download_default()(attachment.url);
      }
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onActivateSearchMatch", function (searchMatch) {
      _this.setState(function (prevState) {
        var newState = {
          searchMatch: searchMatch
        };
        if (searchMatch && searchMatch.pageNum !== prevState.activatePage.num) {
          newState.activatePage = {
            num: searchMatch.pageNum
          };
        }
        return newState;
      });
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onSearchMatches", function (matches) {
      // делаем копию массива чтобы изменить состояние, т.к. в matches всегда приходит один и тотже массив в рамках одного поиска
      _this.setState(function () {
        return {
          searchMatches: matches.slice()
        };
      });
    });
    var _scale = _this.props.scale ? _this.props.scale : _this.getDefaultScale(props.pageSize);
    _this.state = {
      scale: _scale,
      isPrinting: false,
      isInitialLoadComplete: false,
      isLoadingPages: true,
      countLoadedPages: 0,
      pagesOverview: props.pagesOverview,
      activePage: 1,
      activatePage: {
        num: 1
      },
      isSidebarVisible: true,
      searchMatch: null,
      searchMatches: []
    };
    var pdfDocument = props.pdfDocument;
    _this.finder = new Finder(pdfDocument);
    return _this;
  }
  fullscreen_createClass(PDFFullScreenViewer, [{
    key: "loadPages",
    value: function () {
      var _loadPages = fullscreen_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(numbers) {
        var _this2 = this;
        var pdfDocument, chunks, loadChunk, _iterator2, _step2, chunk;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // грузим страницы постепенно, используются цифры количество загружаемых страниц и таймаута,
                // которые позволяют не грузить сильно браузер
                pdfDocument = this.props.pdfDocument;
                chunks = lodash_chunk_default()(numbers, 20);
                loadChunk = function loadChunk(chunk) {
                  chunk.forEach(function (num) {
                    _this2.onPageLoaded(num, pdfDocument.getPage(num));
                  });
                };
                _iterator2 = fullscreen_createForOfIteratorHelper(chunks);
                _context2.prev = 4;
                _iterator2.s();
              case 6:
                if ((_step2 = _iterator2.n()).done) {
                  _context2.next = 13;
                  break;
                }
                chunk = _step2.value;
                loadChunk(chunk);
                _context2.next = 11;
                return (0,util/* wait */.Dc)(500);
              case 11:
                _context2.next = 6;
                break;
              case 13:
                _context2.next = 18;
                break;
              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](4);
                _iterator2.e(_context2.t0);
              case 18:
                _context2.prev = 18;
                _iterator2.f();
                return _context2.finish(18);
              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 15, 18, 21]]);
      }));
      function loadPages(_x4) {
        return _loadPages.apply(this, arguments);
      }
      return loadPages;
    }()
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;
      var editor = this.props.editor;
      document.addEventListener('keydown', this.onDocumentKeydown, false);
      editor.scroll.stopHandlingKeydown();

      // устанавливаем текущую страницу
      this.setState(function () {
        return {
          activePage: _this3.props.page,
          activatePage: {
            num: _this3.props.page
          },
          isInitialLoadComplete: true
        };
      });
      window.addEventListener('resize', this.handleWindowResize);
      // Проверяем ширину экрана при монтировании компонента
      this.checkScreenWidth();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var editor = this.props.editor;
      document.removeEventListener('keydown', this.onDocumentKeydown, false);
      editor.scroll.resumeHandlingKeydown();
      window.removeEventListener('resize', this.handleWindowResize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.isInitialLoadComplete && prevState.isInitialLoadComplete !== this.state.isInitialLoadComplete) {
        var pagesOverview = this.state.pagesOverview;
        var _pdfDocument = this.props.pdfDocument;
        // подгружаем информацию об остальных страницах
        var toLoad = [];
        for (var num = 1; num <= _pdfDocument.numPages; num++) {
          if (!pagesOverview[num]) {
            toLoad.push(num);
          }
        }
        this.loadPages(toLoad);
      }
    }
  }, {
    key: "checkScreenWidth",
    value: function checkScreenWidth() {
      // Проверяем ширину экрана и скрываем сайдбар, если необходимо
      var screenWidth = window.innerWidth;
      var isSidebarVisible = this.state.isSidebarVisible;
      if (screenWidth <= 1100 && isSidebarVisible) {
        this.onToggleSidebar();
      } else if (screenWidth > 1100 && !isSidebarVisible) {
        // Если ширина экрана стала больше 1100, и сайдбар был скрыт, показываем его
        this.onToggleSidebar();
      }
    }
  }, {
    key: "callOnClose",
    value: function callOnClose() {
      this.props.onClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        pageSize = _this$props2.pageSize,
        pdfDocument = _this$props2.pdfDocument,
        pdfjsLib = _this$props2.pdfjsLib,
        attachment = _this$props2.attachment,
        blot = _this$props2.blot;
      var _this$state = this.state,
        isPrinting = _this$state.isPrinting,
        pagesOverview = _this$state.pagesOverview,
        activePage = _this$state.activePage,
        isSidebarVisible = _this$state.isSidebarVisible,
        searchMatch = _this$state.searchMatch,
        searchMatches = _this$state.searchMatches;
      var printingOverlay = null;
      if (isPrinting) {
        printingOverlay = (0,preact_module.h)(PrintingOverlay, {
          onAbort: this.onPrintAbort,
          onPrinted: this.onPrinted,
          pdfDocument: pdfDocument
        });
      }
      var downloading = null;
      var printing = null;
      if (blot && !blot.disallowDownloading) {
        downloading = (0,preact_module.h)("div", {
          className: "pdf-viewer-button pdf-viewer-download",
          onClick: this.onDownload
        }, (0,preact_module.h)("i", null));
        printing = (0,preact_module.h)("div", {
          className: "pdf-viewer-button pdf-viewer-print",
          onClick: this.onPrint
        }, (0,preact_module.h)("i", null));
      }
      return (0,preact_module.h)(plugins_i18n/* IntlProvider */.Pj, null, (0,preact_module.h)("div", null, printingOverlay, (0,preact_module.h)("div", {
        className: "pdf-viewer-top"
      }, (0,preact_module.h)("div", {
        className: "pdf-viewer-top-left"
      }, (0,preact_module.h)("div", {
        className: "pdf-viewer-button pdf-viewer-exit",
        onClick: this.onClose
      }, (0,preact_module.h)("i", null)), (0,preact_module.h)("div", {
        className: 'pdf-viewer-button pdf-viewer-sidebar ' + (isSidebarVisible ? 'pdf-viewer-button-pressed' : ''),
        onClick: this.onToggleSidebar
      }, (0,preact_module.h)("i", null))), (0,preact_module.h)(PdfPageNavigation, {
        activePage: activePage,
        pdfDocument: pdfDocument,
        onActivatePage: this.onActivatePage
      }), window.innerWidth > 620 && (0,preact_module.h)(Zoom, {
        onScaleChange: this.onScaleChange,
        scale: this.state.scale
      }), (0,preact_module.h)("div", {
        className: "pdf-viewer-top-right"
      }, (0,preact_module.h)(Search, {
        finder: this.finder,
        pdfDocument: pdfDocument,
        onActivateMatch: this.onActivateSearchMatch,
        onMatches: this.onSearchMatches
      }), printing, downloading)), (0,preact_module.h)("div", {
        className: 'pdf-viewer-body ' + (isSidebarVisible ? 'pdf-viewer-with-sidebar' : null)
      }, (0,preact_module.h)(Sidebar, {
        defaultPageWidth: pageSize.width,
        defaultPageHeight: pageSize.height,
        pdfDocument: pdfDocument,
        pagesOverview: pagesOverview,
        activePage: activePage,
        onActivatePage: this.onActivatePage
      }), (0,preact_module.h)(PDFView, {
        defaultPageWidth: pageSize.width,
        defaultPageHeight: pageSize.height,
        scale: this.state.scale,
        pagesOverview: pagesOverview,
        activePage: activePage,
        pdfDocument: pdfDocument,
        onActivePageChange: this.onActivePageChange,
        activatePage: this.state.activatePage,
        searchMatch: searchMatch,
        searchMatches: searchMatches,
        pdfjsLib: pdfjsLib
      }))));
    }
  }]);
  return PDFFullScreenViewer;
}(preact_module/* Component */.wA);
var PDFFullWrapper = /*#__PURE__*/function (_Component2) {
  fullscreen_inherits(PDFFullWrapper, _Component2);
  var _super2 = fullscreen_createSuper(PDFFullWrapper);
  function PDFFullWrapper() {
    fullscreen_classCallCheck(this, PDFFullWrapper);
    return _super2.apply(this, arguments);
  }
  fullscreen_createClass(PDFFullWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.container = document.createElement('div');
      this.container.classList.add('pdf-viewer-full-screen');
      document.body.appendChild(this.container);
      this.renderFullScreenViewer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.renderFullScreenViewer();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var Nothing = function Nothing() {
        return null;
      };
      (0,preact_module/* render */.sY)((0,preact_module.h)(Nothing, null), this.container, this.container.firstChild);
      this.container.parentNode.removeChild(this.container);
    }
  }, {
    key: "renderFullScreenViewer",
    value: function renderFullScreenViewer() {
      (0,preact_module/* render */.sY)((0,preact_module.h)(PDFFullScreenViewer, this.props), this.container);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return PDFFullWrapper;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/pdfjsloader.js





function pdfjsloader_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function pdfjsloader_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { pdfjsloader_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { pdfjsloader_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function pdfjsloader_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function pdfjsloader_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function pdfjsloader_createClass(Constructor, protoProps, staticProps) { if (protoProps) pdfjsloader_defineProperties(Constructor.prototype, protoProps); if (staticProps) pdfjsloader_defineProperties(Constructor, staticProps); return Constructor; }
var pdfjsDist = null;
var promise = null;
var PDFJSLoader = /*#__PURE__*/function () {
  function PDFJSLoader(workerPath) {
    pdfjsloader_classCallCheck(this, PDFJSLoader);
    this.workerPath = workerPath;
  }
  pdfjsloader_createClass(PDFJSLoader, [{
    key: "load",
    value: function () {
      var _load = pdfjsloader_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!promise) {
                  _context.next = 4;
                  break;
                }
                _context.next = 3;
                return promise;
              case 3:
                return _context.abrupt("return", _context.sent);
              case 4:
                promise = Promise.all(/* import() | pdfjs-dist.js */[__webpack_require__.e(744), __webpack_require__.e(157)]).then(__webpack_require__.t.bind(__webpack_require__, 56744, 23));
                _context.next = 7;
                return promise;
              case 7:
                pdfjsDist = _context.sent;
                if (!pdfjsDist.GlobalWorkerOptions.workerSrc) {
                  pdfjsDist.GlobalWorkerOptions.workerSrc = this.workerPath;
                }
                return _context.abrupt("return", pdfjsDist);
              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function load() {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "get",
    value: function get() {
      return pdfjsDist;
    }
  }]);
  return PDFJSLoader;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/print.js
function print_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { print_typeof = function _typeof(obj) { return typeof obj; }; } else { print_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return print_typeof(obj); }










function print_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function print_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { print_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { print_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function print_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function print_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function print_createClass(Constructor, protoProps, staticProps) { if (protoProps) print_defineProperties(Constructor.prototype, protoProps); if (staticProps) print_defineProperties(Constructor, staticProps); return Constructor; }
function print_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) print_setPrototypeOf(subClass, superClass); }
function print_setPrototypeOf(o, p) { print_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return print_setPrototypeOf(o, p); }
function print_createSuper(Derived) { var hasNativeReflectConstruct = print_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = print_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = print_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return print_possibleConstructorReturn(this, result); }; }
function print_possibleConstructorReturn(self, call) { if (call && (print_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return print_assertThisInitialized(self); }
function print_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function print_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function print_getPrototypeOf(o) { print_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return print_getPrototypeOf(o); }




var PrintComponent = /*#__PURE__*/function (_Component) {
  print_inherits(PrintComponent, _Component);
  var _super = print_createSuper(PrintComponent);
  function PrintComponent(props) {
    var _this;
    print_classCallCheck(this, PrintComponent);
    _this = _super.call(this, props);
    _this.pdfJsLoader = new PDFJSLoader(props.options.workerPath);
    _this.state = {
      pdfDocument: null,
      pdfDocumentLoadTask: null,
      documentLoading: true,
      // ставим по умолчанию в true(печать выполняется на стороне приложения), для того чтобы избежать промаргивания окна с
      // прогрессом печати
      printDelegated: true
    };
    return _this;
  }
  print_createClass(PrintComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var onPrint = this.getOnPrintFunction();
      if (onPrint) {
        if (onPrint({
          attachment: this.props.attachment
        }) === true) {
          setTimeout(function () {
            _this2.props.onPrinted();
          }, 0);
          return;
        }
      }
      this.setState(function () {
        return {
          printDelegated: false
        };
      }, function () {
        _this2.loadDocument();
      });
    }
  }, {
    key: "loadDocument",
    value: function () {
      var _loadDocument = print_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var pdfjsLib, pdfDocumentLoadTask, pdfDocument;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.pdfJsLoader.load();
              case 2:
                pdfjsLib = _context.sent;
                pdfDocumentLoadTask = pdfjsLib.getDocument(this.props.attachment.url);
                _context.next = 6;
                return pdfDocumentLoadTask.promise;
              case 6:
                pdfDocument = _context.sent;
                this.setState(function () {
                  return {
                    documentLoading: false,
                    pdfDocument: pdfDocument,
                    pdfDocumentLoadTask: pdfDocumentLoadTask
                  };
                });
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function loadDocument() {
        return _loadDocument.apply(this, arguments);
      }
      return loadDocument;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.documentLoading !== this.state.documentLoading) {
        if (this.props.onSizeUpdate) {
          this.props.onSizeUpdate();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.pdfDocument) {
        this.state.pdfDocumentLoadTask.destroy();
        this.state.pdfDocument.cleanup();
        this.state.pdfDocument.destroy();
      }
    }
  }, {
    key: "getOnPrintFunction",
    value: function getOnPrintFunction() {
      if (this.props.options && this.props.options.onPrint) {
        return this.props.options.onPrint;
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.printDelegated) {
        return null;
      }
      var content;
      if (this.state.documentLoading) {
        content = (0,preact_module.h)("div", null, (0,preact_module.h)(plugins_i18n/* Text */.xv, {
          id: "file.pdf_viewer.printing_initialization"
        }));
      } else {
        content = (0,preact_module.h)(PrintingOverlay, {
          onPrinted: this.props.onPrinted,
          onAbort: this.props.onAbort,
          pdfDocument: this.state.pdfDocument
        });
      }
      return (0,preact_module.h)(plugins_i18n/* IntlProvider */.Pj, null, (0,preact_module.h)("div", null, content));
    }
  }]);
  return PrintComponent;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/fullscreenAction.js
function fullscreenAction_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { fullscreenAction_typeof = function _typeof(obj) { return typeof obj; }; } else { fullscreenAction_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return fullscreenAction_typeof(obj); }










function fullscreenAction_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function fullscreenAction_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { fullscreenAction_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { fullscreenAction_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function fullscreenAction_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function fullscreenAction_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function fullscreenAction_createClass(Constructor, protoProps, staticProps) { if (protoProps) fullscreenAction_defineProperties(Constructor.prototype, protoProps); if (staticProps) fullscreenAction_defineProperties(Constructor, staticProps); return Constructor; }
function fullscreenAction_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) fullscreenAction_setPrototypeOf(subClass, superClass); }
function fullscreenAction_setPrototypeOf(o, p) { fullscreenAction_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return fullscreenAction_setPrototypeOf(o, p); }
function fullscreenAction_createSuper(Derived) { var hasNativeReflectConstruct = fullscreenAction_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = fullscreenAction_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = fullscreenAction_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return fullscreenAction_possibleConstructorReturn(this, result); }; }
function fullscreenAction_possibleConstructorReturn(self, call) { if (call && (fullscreenAction_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return fullscreenAction_assertThisInitialized(self); }
function fullscreenAction_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function fullscreenAction_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function fullscreenAction_getPrototypeOf(o) { fullscreenAction_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return fullscreenAction_getPrototypeOf(o); }
function fullscreenAction_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var FullScreenAction = /*#__PURE__*/function (_Component) {
  fullscreenAction_inherits(FullScreenAction, _Component);
  var _super = fullscreenAction_createSuper(FullScreenAction);
  function FullScreenAction(props) {
    var _this;
    fullscreenAction_classCallCheck(this, FullScreenAction);
    _this = _super.call(this, props);
    fullscreenAction_defineProperty(fullscreenAction_assertThisInitialized(_this), "pdfJsLoader", null);
    _this.state = {
      pdfDocument: null,
      pdfPage: null
    };
    _this.pdfJsLoader = new PDFJSLoader(props.options.workerPath);
    return _this;
  }
  fullscreenAction_createClass(FullScreenAction, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadDocument();
    }
  }, {
    key: "loadDocument",
    value: function () {
      var _loadDocument = fullscreenAction_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var pdfjsLib, pdfDocument, pdfPage, pdfPageViewport;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.pdfJsLoader.load();
              case 2:
                pdfjsLib = _context.sent;
                _context.next = 5;
                return pdfjsLib.getDocument(this.props.attachment.url).promise;
              case 5:
                pdfDocument = _context.sent;
                _context.next = 8;
                return pdfDocument.getPage(1);
              case 8:
                pdfPage = _context.sent;
                pdfPageViewport = pdfPage.getViewport({
                  scale: 1
                });
                this.setState(function () {
                  return {
                    pdfDocument: pdfDocument,
                    pdfPage: pdfPage,
                    pageWidth: pdfPageViewport.width,
                    pageHeight: pdfPageViewport.height
                  };
                });
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function loadDocument() {
        return _loadDocument.apply(this, arguments);
      }
      return loadDocument;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        pdfDocument = _this$state.pdfDocument,
        pdfPage = _this$state.pdfPage,
        pageWidth = _this$state.pageWidth,
        pageHeight = _this$state.pageHeight;
      if (!pdfDocument || !pdfPage) {
        return (0,preact_module.h)("div", null, (0,preact_module.h)(plugins_i18n/* Text */.xv, {
          id: "file.pdf_viewer.initializing_full_window_view"
        }));
      }
      return (0,preact_module.h)(PDFFullWrapper, {
        pdfDocument: pdfDocument,
        pageSize: {
          width: pageWidth,
          height: pageHeight
        },
        onClose: this.props.onClose,
        attachment: this.props.attachment,
        editor: this.props.editor,
        options: this.props.options,
        pdfjsLib: this.pdfJsLoader.get()
      });
    }
  }]);
  return FullScreenAction;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/scss/file-vars.scss
var file_vars = __webpack_require__(26158);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/pdfSinglePage.js
function pdfSinglePage_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { pdfSinglePage_typeof = function _typeof(obj) { return typeof obj; }; } else { pdfSinglePage_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return pdfSinglePage_typeof(obj); }













function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || pdfSinglePage_unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function pdfSinglePage_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return pdfSinglePage_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return pdfSinglePage_arrayLikeToArray(o, minLen); }
function pdfSinglePage_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function pdfSinglePage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function pdfSinglePage_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { pdfSinglePage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { pdfSinglePage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function pdfSinglePage_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function pdfSinglePage_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function pdfSinglePage_createClass(Constructor, protoProps, staticProps) { if (protoProps) pdfSinglePage_defineProperties(Constructor.prototype, protoProps); if (staticProps) pdfSinglePage_defineProperties(Constructor, staticProps); return Constructor; }
function pdfSinglePage_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) pdfSinglePage_setPrototypeOf(subClass, superClass); }
function pdfSinglePage_setPrototypeOf(o, p) { pdfSinglePage_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return pdfSinglePage_setPrototypeOf(o, p); }
function pdfSinglePage_createSuper(Derived) { var hasNativeReflectConstruct = pdfSinglePage_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = pdfSinglePage_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = pdfSinglePage_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return pdfSinglePage_possibleConstructorReturn(this, result); }; }
function pdfSinglePage_possibleConstructorReturn(self, call) { if (call && (pdfSinglePage_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return pdfSinglePage_assertThisInitialized(self); }
function pdfSinglePage_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function pdfSinglePage_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function pdfSinglePage_getPrototypeOf(o) { pdfSinglePage_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return pdfSinglePage_getPrototypeOf(o); }
function pdfSinglePage_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var PdfSinglePage = /*#__PURE__*/function (_Component) {
  pdfSinglePage_inherits(PdfSinglePage, _Component);
  var _super = pdfSinglePage_createSuper(PdfSinglePage);
  function PdfSinglePage(props) {
    var _this;
    pdfSinglePage_classCallCheck(this, PdfSinglePage);
    _this = _super.call(this, props);
    pdfSinglePage_defineProperty(pdfSinglePage_assertThisInitialized(_this), "onIntersectionObserver", function (entries) {
      // страница не в зоне видимости
      if (entries[0].intersectionRatio <= 0) {
        _this.setState(function () {
          return {
            visible: false
          };
        });
        return false;
      }

      // страница в зоне видимости
      var renderPdf = false;
      _this.setState(function (prevState) {
        if (!prevState.visible) {
          renderPdf = true;
          return {
            visible: true
          };
        }
        return null;
      }, function () {
        if (renderPdf) {
          _this.renderPdfPage();
        }
      });
    });
    pdfSinglePage_defineProperty(pdfSinglePage_assertThisInitialized(_this), "onPageMouseDown", function () {
      _this.props.onPageMouseDown();
    });
    pdfSinglePage_defineProperty(pdfSinglePage_assertThisInitialized(_this), "onMouseOver", function () {
      _this.props.onPageMouseOver();
    });
    pdfSinglePage_defineProperty(pdfSinglePage_assertThisInitialized(_this), "onMouseOut", function () {
      _this.props.onPageMouseOut();
    });
    pdfSinglePage_defineProperty(pdfSinglePage_assertThisInitialized(_this), "onPageClick", function () {
      _this.props.setPage(_this.props.num);
      _this.props.onPageClick();
    });
    pdfSinglePage_defineProperty(pdfSinglePage_assertThisInitialized(_this), "onCanvasRef", /*#__PURE__*/function () {
      var _ref = pdfSinglePage_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ref) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.canvas = ref;
                _context.next = 3;
                return _this.renderPdfPage();
              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    pdfSinglePage_defineProperty(pdfSinglePage_assertThisInitialized(_this), "onPageRef", function (ref) {
      if (ref) {
        // начать наблюдение
        _this.intersectionObserver.observe(ref);
      }
    });
    pdfSinglePage_defineProperty(pdfSinglePage_assertThisInitialized(_this), "renderPdfPage", /*#__PURE__*/pdfSinglePage_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var rendered, pageOverview, canvas, _pageOverview$page$vi, origWidth, origHeight, renderRatio, viewport, bufferCanvas, ctx, renderTask;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              rendered = false;
              pageOverview = _this.state.pageOverview;
              canvas = _this.canvas;
              if (!(!canvas || !pageOverview)) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return");
            case 5:
              // рендер через двойной буфер
              _pageOverview$page$vi = _slicedToArray(pageOverview.page.view, 4), origWidth = _pageOverview$page$vi[2], origHeight = _pageOverview$page$vi[3];
              renderRatio = _this.getPageRenderRatio(origWidth, origHeight);
              viewport = pageOverview.page.getViewport({
                scale: window.devicePixelRatio * renderRatio
              });
              if (!_this.state.visible) {
                _context2.next = 21;
                break;
              }
              bufferCanvas = document.createElement('canvas');
              bufferCanvas.width = viewport.width;
              bufferCanvas.height = viewport.height;
              ctx = bufferCanvas.getContext('2d');
              renderTask = pageOverview.page.render({
                canvasContext: ctx,
                viewport: viewport
              });
              _context2.next = 16;
              return renderTask.promise;
            case 16:
              canvas.width = viewport.width;
              canvas.height = viewport.height;
              canvas.getContext('2d').drawImage(bufferCanvas, 0, 0);
              _this.props.setViewport(viewport);
              rendered = true;
            case 21:
              _this.setState(function () {
                return {
                  viewport: viewport,
                  rendered: rendered
                };
              });
            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    pdfSinglePage_defineProperty(pdfSinglePage_assertThisInitialized(_this), "getPageSize", function () {
      var viewport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _viewport$width = viewport.width,
        width = _viewport$width === void 0 ? 800 : _viewport$width,
        _viewport$height = viewport.height,
        height = _viewport$height === void 0 ? 600 : _viewport$height;
      width /= window.devicePixelRatio;
      height /= window.devicePixelRatio;
      return {
        width: width,
        height: height
      };
    });
    var _pageOverview = props.pageOverview;
    _this.state = {
      pageOverview: _pageOverview,
      maxWidth: props.maxWidth,
      viewport: _pageOverview && _pageOverview.viewport,
      visible: _this.props.visible,
      rendered: false
    };
    _this.TID = 0;
    _this.pageBottomMargin = parseInt((style_default()).fullScreenViewerPagesMargin);
    _this.fileHorizontalPadding = parseInt(file_vars.fileHorizontalPadding);

    // Используем IntersectionObserver для определения видимости страниц
    // для оптимизации рендеренга, если страница в зоне видимости то мы её отрисовываем
    // если нет то ничего не делаем
    _this.intersectionObserver = new IntersectionObserver(_this.onIntersectionObserver);
    return _this;
  }
  pdfSinglePage_createClass(PdfSinglePage, [{
    key: "getPageRenderRatio",
    value: function getPageRenderRatio(width) {
      // пдф должен быть растянут на всю ширину элемента, высота автоматическая
      var maxWidth = this.props.maxWidth - this.fileHorizontalPadding * 2;
      var ratio = maxWidth / width;
      return ratio;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps, previousState, previousContext) {
      var _this2 = this;
      // после изменения размера окна браузера, перерисовывать страницы
      if (previousProps.maxWidth !== this.props.maxWidth) {
        clearTimeout(this.TID);
        this.TID = setTimeout(this.renderPdfPage, 100);
      }
      if (previousProps.pageOverview !== this.state.pageOverview && this.props.pageOverview) {
        this.setState(function () {
          return {
            pageOverview: _this2.props.pageOverview,
            viewport: _this2.props.pageOverview.viewport
          };
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.TID);
      this.intersectionObserver.disconnect();
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.pageOverview) {
        var _this$getPageSize = this.getPageSize(this.props.viewport),
          _width = _this$getPageSize.width,
          _height = _this$getPageSize.height;
        return (0,preact_module.h)("div", {
          className: "pdf-page editor-loader2-grey editor-loader-cc",
          style: {
            width: _width + 'px',
            height: _height + 'px',
            marginBottom: this.props.isLastPage ? 0 : this.pageBottomMargin + 'px'
          }
        });
      }
      var _this$getPageSize2 = this.getPageSize(this.state.viewport),
        width = _this$getPageSize2.width,
        height = _this$getPageSize2.height;
      var style = {
        width: width + 'px',
        height: height + 'px',
        marginBottom: this.props.isLastPage ? 0 : this.pageBottomMargin + 'px'
      };
      var rendered = this.state.rendered;
      var className = ['pdf-page'];
      if (!this.props.options.openFullScreenByTwoClicks || this.props.options.allowOpenOnMouseOver) {
        className.push('open-on-mouse-over');
      }
      if (!rendered) {
        className.push('editor-loader2-grey editor-loader-cc');
      }
      return (0,preact_module.h)("div", {
        ref: this.onPageRef,
        onMouseDown: this.onPageMouseDown,
        onMouseOver: this.onMouseOver,
        onMouseOut: this.onMouseOut,
        onClick: this.onPageClick,
        className: className.join(' '),
        style: style
      }, (0,preact_module.h)("canvas", {
        ref: this.onCanvasRef
      }), (0,preact_module.h)("div", {
        className: "pdf-page-number"
      }, this.props.num));
    }
  }]);
  return PdfSinglePage;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/pdfViewAsAllPages.js
function pdfViewAsAllPages_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { pdfViewAsAllPages_typeof = function _typeof(obj) { return typeof obj; }; } else { pdfViewAsAllPages_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return pdfViewAsAllPages_typeof(obj); }
function pdfViewAsAllPages_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = pdfViewAsAllPages_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }


















function pdfViewAsAllPages_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function pdfViewAsAllPages_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { pdfViewAsAllPages_ownKeys(Object(source), true).forEach(function (key) { pdfViewAsAllPages_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { pdfViewAsAllPages_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function pdfViewAsAllPages_slicedToArray(arr, i) { return pdfViewAsAllPages_arrayWithHoles(arr) || pdfViewAsAllPages_iterableToArrayLimit(arr, i) || pdfViewAsAllPages_unsupportedIterableToArray(arr, i) || pdfViewAsAllPages_nonIterableRest(); }
function pdfViewAsAllPages_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function pdfViewAsAllPages_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return pdfViewAsAllPages_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return pdfViewAsAllPages_arrayLikeToArray(o, minLen); }
function pdfViewAsAllPages_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function pdfViewAsAllPages_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function pdfViewAsAllPages_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function pdfViewAsAllPages_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function pdfViewAsAllPages_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { pdfViewAsAllPages_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { pdfViewAsAllPages_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function pdfViewAsAllPages_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function pdfViewAsAllPages_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function pdfViewAsAllPages_createClass(Constructor, protoProps, staticProps) { if (protoProps) pdfViewAsAllPages_defineProperties(Constructor.prototype, protoProps); if (staticProps) pdfViewAsAllPages_defineProperties(Constructor, staticProps); return Constructor; }
function pdfViewAsAllPages_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) pdfViewAsAllPages_setPrototypeOf(subClass, superClass); }
function pdfViewAsAllPages_setPrototypeOf(o, p) { pdfViewAsAllPages_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return pdfViewAsAllPages_setPrototypeOf(o, p); }
function pdfViewAsAllPages_createSuper(Derived) { var hasNativeReflectConstruct = pdfViewAsAllPages_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = pdfViewAsAllPages_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = pdfViewAsAllPages_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return pdfViewAsAllPages_possibleConstructorReturn(this, result); }; }
function pdfViewAsAllPages_possibleConstructorReturn(self, call) { if (call && (pdfViewAsAllPages_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return pdfViewAsAllPages_assertThisInitialized(self); }
function pdfViewAsAllPages_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function pdfViewAsAllPages_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function pdfViewAsAllPages_getPrototypeOf(o) { pdfViewAsAllPages_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return pdfViewAsAllPages_getPrototypeOf(o); }
function pdfViewAsAllPages_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var PdfViewAsAllPages = /*#__PURE__*/function (_Component) {
  pdfViewAsAllPages_inherits(PdfViewAsAllPages, _Component);
  var _super = pdfViewAsAllPages_createSuper(PdfViewAsAllPages);
  function PdfViewAsAllPages(props) {
    var _this;
    pdfViewAsAllPages_classCallCheck(this, PdfViewAsAllPages);
    _this = _super.call(this, props);
    pdfViewAsAllPages_defineProperty(pdfViewAsAllPages_assertThisInitialized(_this), "onPageLoaded", /*#__PURE__*/function () {
      var _ref = pdfViewAsAllPages_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(num, pagePromise) {
        var page, countLoadedPages, _page$view, origWidth, origHeight, renderRatio, vpScale, viewport, _page$getViewport, width, height;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return pagePromise;
              case 2:
                page = _context.sent;
                countLoadedPages = _this.state.countLoadedPages + 1; // инциализация viewport для первоначальной отрисовки страниц
                _page$view = pdfViewAsAllPages_slicedToArray(page.view, 4), origWidth = _page$view[2], origHeight = _page$view[3];
                renderRatio = _this.getPageRenderRatio(origWidth, origHeight);
                vpScale = window.devicePixelRatio * renderRatio;
                viewport = page.getViewport({
                  scale: vpScale
                }); // Для передачи страниц в полноэкранный режим
                _page$getViewport = page.getViewport({
                  scale: 1
                }), width = _page$getViewport.width, height = _page$getViewport.height;
                _this.props.updatePagesOverview(pdfViewAsAllPages_defineProperty({}, num, {
                  width: width,
                  height: height,
                  page: page,
                  viewport: viewport
                }));
                _this.setState(function (prev) {
                  return {
                    countLoadedPages: countLoadedPages,
                    isLoadingPages: countLoadedPages <= 1,
                    // после загрузки сразу 1-ю страницу
                    pagesOverview: pdfViewAsAllPages_objectSpread(pdfViewAsAllPages_objectSpread({}, prev.pagesOverview), {}, pdfViewAsAllPages_defineProperty({}, num, {
                      page: page,
                      viewport: viewport
                    }))
                  };
                });
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    pdfViewAsAllPages_defineProperty(pdfViewAsAllPages_assertThisInitialized(_this), "setViewport", function (viewport) {
      _this.setState(function () {
        return {
          viewport: viewport
        };
      });
    });
    _this.state = {
      isLoadingPages: true,
      pagesOverview: props.pagesOverview,
      countLoadedPages: _this.getPagesOverviewLength(props.pagesOverview)
    };
    _this.fileHorizontalPadding = parseInt(file_vars.fileHorizontalPadding);
    return _this;
  }
  pdfViewAsAllPages_createClass(PdfViewAsAllPages, [{
    key: "getPagesOverviewLength",
    value: function getPagesOverviewLength(obj) {
      var len = 0;
      for (var key in obj) {
        len++;
      }
      return len;
    }
  }, {
    key: "getPageRenderRatio",
    value: function getPageRenderRatio(width) {
      // пдф должен быть растянут на всю ширину элемента, высота автоматическая
      var maxWidth = this.props.maxWidth - this.fileHorizontalPadding * 2;
      var ratio = maxWidth / width;
      return ratio;
    }

    /**
     * Событие при загрузке страницы
     * @param {Number} num
     * @param {Promise<>} pagePromise
     * @returns {Promise<void>}
     */
  }, {
    key: "loadPages",
    value: function () {
      var _loadPages = pdfViewAsAllPages_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(numbers) {
        var _this2 = this;
        var pdfDocument, chunks, loadChunk, _iterator, _step, chunk;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // грузим страницы постепенно, используются цифры количество загружаемых страниц и таймаута,
                // которые позволяют не грузить сильно браузер
                pdfDocument = this.props.pdfDocument;
                chunks = lodash_chunk_default()(numbers, 20);
                loadChunk = function loadChunk(chunk) {
                  chunk.forEach(function (num) {
                    _this2.onPageLoaded(num, pdfDocument.getPage(num));
                  });
                };
                _iterator = pdfViewAsAllPages_createForOfIteratorHelper(chunks);
                _context2.prev = 4;
                _iterator.s();
              case 6:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 13;
                  break;
                }
                chunk = _step.value;
                loadChunk(chunk);
                _context2.next = 11;
                return (0,util/* wait */.Dc)(500);
              case 11:
                _context2.next = 6;
                break;
              case 13:
                _context2.next = 18;
                break;
              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](4);
                _iterator.e(_context2.t0);
              case 18:
                _context2.prev = 18;
                _iterator.f();
                return _context2.finish(18);
              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 15, 18, 21]]);
      }));
      function loadPages(_x3) {
        return _loadPages.apply(this, arguments);
      }
      return loadPages;
    }() // Для того чтобы передать размеры для неподгруженных страниц
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var pagesOverview = this.state.pagesOverview;
      var pdfDocument = this.props.pdfDocument;
      // подгружаем информацию об остальных страницах
      var toLoad = [];
      for (var num = 1; num <= pdfDocument.numPages; num++) {
        if (!pagesOverview[num]) {
          toLoad.push(num);
        }
      }
      if (toLoad.length) {
        // если есть страницы для загрузки то загружаем
        this.loadPages(toLoad);
      } else {
        // иначе сразу показываем страницы
        this.setState(function () {
          return {
            isLoadingPages: false
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        pdfDocument = _this$props.pdfDocument,
        _onPageClick = _this$props.onPageClick,
        onPageMouseDown = _this$props.onPageMouseDown,
        onPageMouseOver = _this$props.onPageMouseOver,
        onPageMouseOut = _this$props.onPageMouseOut,
        setPage = _this$props.setPage,
        maxWidth = _this$props.maxWidth;
      var _this$state = this.state,
        pagesOverview = _this$state.pagesOverview,
        isLoadingPages = _this$state.isLoadingPages;
      if (isLoadingPages) return (0,preact_module.h)("div", {
        className: "pdf-loading-document"
      }, (0,preact_module.h)("div", {
        className: "editor-loader2-grey editor-loader-cc"
      }), (0,preact_module.h)("div", {
        className: "pdf-loading-message"
      }, "Loading pages ...please wait..."));
      var pdfPages = [];
      var _loop = function _loop(i) {
        pdfPages.push((0,preact_module.h)(PdfSinglePage, {
          num: i,
          viewport: _this3.state.viewport,
          pageOverview: pagesOverview[i],
          isLastPage: i === pdfDocument.numPages,
          onPageClick: function onPageClick() {
            _onPageClick(i);
          },
          onPageMouseDown: onPageMouseDown,
          onPageMouseOver: onPageMouseOver,
          onPageMouseOut: onPageMouseOut,
          setPage: setPage,
          setViewport: _this3.setViewport,
          maxWidth: maxWidth,
          visible: i === 1 // первая страница всегда видимая
          ,
          options: _this3.props.options
        }));
      };
      for (var i = 1; i <= pdfDocument.numPages; i++) {
        _loop(i);
      }
      return (0,preact_module.h)("div", {
        className: "pdf-all-pages"
      }, pdfPages);
    }
  }]);
  return PdfViewAsAllPages;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/components/popupMenu.js
var popupMenu = __webpack_require__(10856);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/components/popupMenuItem.js
var popupMenuItem = __webpack_require__(28411);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/plugins/tooltipManager/index.js
var tooltipManager = __webpack_require__(95174);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/index.js
function pdf_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { pdf_typeof = function _typeof(obj) { return typeof obj; }; } else { pdf_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return pdf_typeof(obj); }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function pdf_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function pdf_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { pdf_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { pdf_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function pdf_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function pdf_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { pdf_ownKeys(Object(source), true).forEach(function (key) { pdf_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { pdf_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



















function pdf_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function pdf_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function pdf_createClass(Constructor, protoProps, staticProps) { if (protoProps) pdf_defineProperties(Constructor.prototype, protoProps); if (staticProps) pdf_defineProperties(Constructor, staticProps); return Constructor; }
function pdf_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) pdf_setPrototypeOf(subClass, superClass); }
function pdf_setPrototypeOf(o, p) { pdf_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return pdf_setPrototypeOf(o, p); }
function pdf_createSuper(Derived) { var hasNativeReflectConstruct = pdf_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = pdf_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = pdf_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return pdf_possibleConstructorReturn(this, result); }; }
function pdf_possibleConstructorReturn(self, call) { if (call && (pdf_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return pdf_assertThisInitialized(self); }
function pdf_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function pdf_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function pdf_getPrototypeOf(o) { pdf_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return pdf_getPrototypeOf(o); }
function pdf_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var fileHorizontalPadding = parseInt(file_vars.fileHorizontalPadding);
var PDFViewerComponent = /*#__PURE__*/function (_Component) {
  pdf_inherits(PDFViewerComponent, _Component);
  var _super = pdf_createSuper(PDFViewerComponent);
  function PDFViewerComponent(props) {
    var _this;
    pdf_classCallCheck(this, PDFViewerComponent);
    _this = _super.call(this, props);
    pdf_defineProperty(pdf_assertThisInitialized(_this), "pdfJsLoader", null);
    pdf_defineProperty(pdf_assertThisInitialized(_this), "onCanvasRef", function (canvas) {
      _this.canvas = canvas;
      _this.renderPdfPage();
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "incPage", function () {
      var page = Math.min(_this.getCurrentPageNumber() + 1, _this.state.pdfDocument.numPages);
      _this.props.setSyncedState({
        page: page
      });
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "decPage", function () {
      var page = Math.max(_this.getCurrentPageNumber() - 1, 1);
      _this.props.setSyncedState({
        page: page
      });
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "setPage", function (page) {
      _this.props.setSyncedState({
        page: page
      });
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "pinPage", function () {
      var page = _this.getCurrentPageNumber();
      _this.props.setSyncedState({
        pinned: page
      });
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "unpinPage", function () {
      _this.props.setSyncedState({
        pinned: false
      });
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "onPageClick", function () {
      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var allow = _this.pageMouseDownOnFocused;
      if (_this.props.options && _this.props.options.allowOpenOnMouseOver && _this.state.isMouseOver) {
        allow = true;
      }
      if (allow) {
        if (_this.props.options && _this.props.options.onClick) {
          _this.props.options.onClick({
            attachment: _this.props.attachment,
            params: {
              disallowDownloading: _this.props.blot && _this.props.blot.disallowDownloading
            }
          });
        } else {
          var newState = {
            fullscreen: true
          };
          if (pageNumber && Number.isInteger(parseInt(pageNumber))) {
            newState.page = parseInt(pageNumber);
          } else {
            newState.page = _this.getCurrentPageNumber();
          }
          _this.setState(function () {
            return newState;
          });
        }
      }
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "onPageMouseDown", function () {
      // если в настройках разрешено отркывать по двум кликикам то проверяем фокус
      _this.pageMouseDownOnFocused = _this.props.options.openFullScreenByTwoClicks ? _this.props.focused : true;
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "onPageChange", function (page) {
      _this.props.setSyncedState({
        page: page
      });
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "onMouseOver", function () {
      setTimeout(function () {
        _this.setState(function () {
          return {
            isMouseOver: true
          };
        });
      }, 0);
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "onMouseOut", function () {
      _this.setState(function () {
        return {
          isMouseOver: false
        };
      });
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "onFullScreenClose", function () {
      _this.setState(function () {
        return {
          fullscreen: false
        };
      });
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "onScaleChange", function (scale) {
      _this.setState(function () {
        return {
          scale: scale
        };
      });
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "updatePagesOverview", function (pagesOverview) {
      _this.setState(function (prev) {
        return {
          pagesOverview: pdf_objectSpread(pdf_objectSpread({}, prev.pagesOverview), pagesOverview)
        };
      });
    });
    _this.pdfJsLoader = new PDFJSLoader(props.options.workerPath);
    _this.state = {
      pdfDocument: null,
      pdfPage: null,
      pdfPageViewport: null,
      documentLoading: false,
      pageLoading: false,
      pageRendering: false,
      page: _this.getCurrentPageNumber(),
      renderRatio: null,
      fullscreen: false,
      isMouseOver: false,
      pdfJsLoaded: Boolean(_this.pdfJsLoader.get()),
      pagesOverview: {},
      scale: null,
      viewAs: props.blot.getViewAs(),
      init: true
    };

    // для того, чтобы сразу по клику открывать фулскрин
    _this.pageMouseDownOnFocused = true;
    return _this;
  }
  pdf_createClass(PDFViewerComponent, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.pdfDocument) {
        this.state.pdfDocument.destroy();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (!this.pdfJsLoader.get()) {
        this.pdfJsLoader.load().then(function () {
          _this2.setState(function () {
            return {
              pdfJsLoaded: true
            };
          });
        });
      }
    }
  }, {
    key: "loadPdfDocument",
    value: function () {
      var _loadPdfDocument = pdf_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState(function () {
                  return {
                    documentLoading: true
                  };
                }, /*#__PURE__*/pdf_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  var pdfjsLib, options, pdfDocument;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return _this3.pdfJsLoader.load();
                        case 2:
                          pdfjsLib = _context.sent;
                          options = {
                            url: _this3.props.attachment.url,
                            cMapUrl: _this3.props.options.cMapUrl,
                            cMapPacked: true
                          };
                          _context.next = 6;
                          return pdfjsLib.getDocument(options).promise;
                        case 6:
                          pdfDocument = _context.sent;
                          _this3.setState(function () {
                            return {
                              documentLoading: false,
                              pdfDocument: pdfDocument
                            };
                          });
                        case 8:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })));
              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function loadPdfDocument() {
        return _loadPdfDocument.apply(this, arguments);
      }
      return loadPdfDocument;
    }()
  }, {
    key: "getPageRenderRatio",
    value: function getPageRenderRatio(width, height, pdfPage) {
      // rotate -90/90 указывает на то, что пдф развернута,
      // по этому при расчете скейла решение брать ширину будет не верным и пдф не влезет в границы вьюпорта
      var useHeight = (pdfPage === null || pdfPage === void 0 ? void 0 : pdfPage.rotate) === 90 || (pdfPage === null || pdfPage === void 0 ? void 0 : pdfPage.rotate) === -90;
      // пдф должен быть растянут на всю ширину элемента, высота автоматическая
      var maxWidth = this.props.maxWidth - fileHorizontalPadding * 2;
      var ratio = useHeight ? maxWidth / height : maxWidth / width;
      return ratio;
    }
  }, {
    key: "loadPdfPage",
    value: function () {
      var _loadPdfPage = pdf_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this4 = this;
        var init, page;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.setState(function (prevState) {
                  page = _this4.getCurrentPageNumber();
                  init = false;
                  if (prevState.init) {
                    if (_this4.props.syncedState.pinned) {
                      page = _this4.props.syncedState.pinned;
                      init = true;
                    }
                  }
                  return {
                    pageLoading: true,
                    init: false,
                    page: page
                  };
                }, /*#__PURE__*/pdf_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                  var pdfPage, origWidth, origHeight, renderRatio, scale, pdfPageViewport, isCanvasAvailable;
                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return _this4.state.pdfDocument.getPage(page);
                        case 2:
                          pdfPage = _context3.sent;
                          origWidth = pdfPage.view[2];
                          origHeight = pdfPage.view[3];
                          renderRatio = _this4.getPageRenderRatio(origWidth, origHeight, pdfPage);
                          scale = window.devicePixelRatio * renderRatio;
                          pdfPageViewport = pdfPage.getViewport({
                            scale: scale
                          });
                          if (!(!init && page !== _this4.getCurrentPageNumber())) {
                            _context3.next = 10;
                            break;
                          }
                          return _context3.abrupt("return");
                        case 10:
                          isCanvasAvailable = Boolean(_this4.canvas);
                          _this4.setState(function (prev) {
                            var _pdfPage$getViewport = pdfPage.getViewport({
                                scale: 1
                              }),
                              width = _pdfPage$getViewport.width,
                              height = _pdfPage$getViewport.height;
                            return {
                              pageLoading: false,
                              pdfPage: pdfPage,
                              pdfPageViewport: pdfPageViewport,
                              renderRatio: renderRatio,
                              pagesOverview: pdf_objectSpread(pdf_objectSpread({}, prev.pagesOverview), {}, pdf_defineProperty({}, page, {
                                width: width,
                                height: height,
                                page: pdfPage,
                                viewport: pdfPageViewport
                              }))
                            };
                          }, function () {
                            var opts = {
                              pageWidth: pdfPage.view[2],
                              pageHeight: pdfPage.view[3]
                            };
                            if (init) {
                              opts.page = page;
                            }
                            _this4.props.setSyncedState(opts);
                            if (isCanvasAvailable) {
                              _this4.renderPdfPage();
                            }
                          });
                        case 12:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                })));
              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function loadPdfPage() {
        return _loadPdfPage.apply(this, arguments);
      }
      return loadPdfPage;
    }()
  }, {
    key: "getCurrentPageSize",
    value: function getCurrentPageSize() {
      if (!this.state.pdfPage) {
        return null;
      }
      var pdfPage = this.state.pdfPage;
      var width = pdfPage.view[2];
      var height = pdfPage.view[3];
      return {
        width: width,
        height: height
      };
    }
  }, {
    key: "renderPdfPage",
    value: function () {
      var _renderPdfPage = pdf_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var canvas, viewport, bufferCanvas, ctx, renderTask;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                canvas = this.canvas;
                if (canvas) {
                  _context5.next = 3;
                  break;
                }
                return _context5.abrupt("return");
              case 3:
                // рендер через двойной буфер
                viewport = this.state.pdfPageViewport;
                bufferCanvas = document.createElement('canvas');
                bufferCanvas.width = viewport.width;
                bufferCanvas.height = viewport.height;
                ctx = bufferCanvas.getContext('2d');
                renderTask = this.state.pdfPage.render({
                  canvasContext: ctx,
                  viewport: viewport
                });
                _context5.next = 11;
                return renderTask.promise;
              case 11:
                canvas.width = viewport.width;
                canvas.height = viewport.height;
                canvas.getContext('2d').drawImage(bufferCanvas, 0, 0);
              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
      function renderPdfPage() {
        return _renderPdfPage.apply(this, arguments);
      }
      return renderPdfPage;
    }()
  }, {
    key: "getCurrentViewAs",
    value: function getCurrentViewAs() {
      return this.props.blot.getViewAs();
    }
  }, {
    key: "getCurrentPageNumber",
    value: function getCurrentPageNumber() {
      return this.props.syncedState.page || 1;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this5 = this;
      // Устанавливаем режим просмотра Одна страница / Все страницы
      this.setState(function (prev) {
        if (_this5.getCurrentViewAs() !== prev.viewAs) {
          return {
            viewAs: _this5.getCurrentViewAs()
          };
        }
        return null;
      });
      if (prevProps.fullscreen !== this.props.fullscreen && this.props.fullscreen && this.props.fullscreen.enable) {
        this.setState(function () {
          return {
            fullscreen: true
          };
        });
      }
      if (prevState.fullscreen !== this.state.fullscreen && !this.state.fullscreen) {
        // фуллскрин закрывается, сообщаем об этом выше
        this.props.onFullScreenClose && this.props.onFullScreenClose();
      }
      if (prevState.pdfDocument !== this.state.pdfDocument) {
        // установить количество pdf страниц у блота
        // влияет на отображение пункта меню "Отображать как"
        this.props.blot.setPdfNumPages(this.state.pdfDocument.numPages);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.pdfDocument) {
        if (!this.state.documentLoading) {
          this.loadPdfDocument();
        }
      } else if (!this.state.pdfPage) {
        if (!this.state.pageLoading) {
          this.loadPdfPage();
        }
      }
      if (this.state.page !== this.getCurrentPageNumber()) {
        this.loadPdfPage();
      }
      if (this.state.pdfPage && !this.state.pageLoading) {
        var _this$getCurrentPageS = this.getCurrentPageSize(),
          width = _this$getCurrentPageS.width,
          height = _this$getCurrentPageS.height;
        var neededRatio = this.getPageRenderRatio(width, height, this.state.pdfPage);
        if (!isNaN(neededRatio) && neededRatio !== this.state.renderRatio) {
          this.loadPdfPage();
        }
      }
      var pdfPageNode;
      var pdfControlsNode;
      var _this$props = this.props,
        editor = _this$props.editor,
        blot = _this$props.blot;
      if (!this.state.pdfPageViewport) {
        var _this$props$syncedSta = this.props.syncedState,
          pageWidth = _this$props$syncedSta.pageWidth,
          pageHeight = _this$props$syncedSta.pageHeight;
        if (pageWidth && pageHeight) {
          var ratio = this.getPageRenderRatio(pageWidth, pageHeight, this.state.pdfPage);
          var _width = pageWidth * ratio;
          var _height = pageHeight * ratio;
          pdfPageNode = (0,preact_module.h)("div", {
            className: "pdf-page",
            style: {
              width: _width + 'px',
              height: _height + 'px'
            }
          }, (0,preact_module.h)("div", {
            className: "pdf-page-loading editor-loader2-grey editor-loader-cc"
          }));
        } else {
          pdfPageNode = (0,preact_module.h)("div", {
            className: "pdf-loading-document"
          }, (0,preact_module.h)("div", {
            className: "editor-loader2-grey editor-loader-cc"
          }), (0,preact_module.h)("div", {
            className: "pdf-loading-message"
          }, "Loading PDF file...please wait..."));
        }
      } else {
        var _this$state$pdfPageVi = this.state.pdfPageViewport,
          _width2 = _this$state$pdfPageVi.width,
          _height2 = _this$state$pdfPageVi.height;
        _width2 /= window.devicePixelRatio;
        _height2 /= window.devicePixelRatio;
        var currentPage = this.getCurrentPageNumber();
        var numPages = this.state.pdfDocument.numPages;
        var className = ['pdf-page'];
        if (!this.props.options.openFullScreenByTwoClicks || this.props.options.allowOpenOnMouseOver) {
          className.push('open-on-mouse-over');
        }
        if (this.state.viewAs === 'single') {
          pdfPageNode = (0,preact_module.h)("div", {
            onMouseDown: this.onPageMouseDown,
            onMouseOver: this.onMouseOver,
            onMouseOut: this.onMouseOut,
            onClick: this.onPageClick,
            className: className.join(' '),
            style: {
              width: _width2 + 'px',
              height: _height2 + 'px'
            }
          }, (0,preact_module.h)("canvas", {
            ref: this.onCanvasRef
          }));
          var pinContainer = null;
          if (editor.mode === editor.constructor.MODE_EDIT && !blot.isBlotLocked) {
            var _ref3;
            var i18n = editor.plugins.i18n;
            var pinText = i18n.get('file.pdf_viewer.set_page_as_default');
            var iconPin = (0,preact_module.h)("div", _extends({
              className: "pin-button",
              onClick: this.pinPage
            }, (_ref3 = {}, pdf_defineProperty(_ref3, tooltipManager/* TOOLTIP_ATTR */.qZ, pinText), pdf_defineProperty(_ref3, tooltipManager/* TOOLTIP_ADD_OPTIONS */.cD, JSON.stringify({
              positionFixed: true
            })), _ref3)), (0,preact_module.h)(icons/* IconPin */.DgX, null));
            var pinned = this.props.syncedState.pinned;
            if (pinned && pinned === currentPage) {
              var _ref4;
              pinText = i18n.get('file.pdf_viewer.unset_page_as_default');
              iconPin = (0,preact_module.h)("div", _extends({
                className: "pin-button",
                onClick: this.unpinPage
              }, (_ref4 = {}, pdf_defineProperty(_ref4, tooltipManager/* TOOLTIP_ATTR */.qZ, pinText), pdf_defineProperty(_ref4, tooltipManager/* TOOLTIP_ADD_OPTIONS */.cD, JSON.stringify({
                positionFixed: true
              })), _ref4)), (0,preact_module.h)(icons/* IconUnpin */.uII, null));
            }
            pinContainer = (0,preact_module.h)("div", {
              className: "pdf-controls pin-buttons"
            }, iconPin);
          }
          pdfControlsNode = (0,preact_module.h)("div", {
            className: "pdf-controls-container"
          }, (0,preact_module.h)("div", {
            className: "pdf-controls"
          }, (0,preact_module.h)("div", {
            onClick: this.decPage,
            className: 'pdf-control-arrow pdf-control-arrow-left ' + (currentPage > 1 ? 'pdf-control-arrow-active' : '')
          }, "\u2039"), currentPage, " of ", numPages, (0,preact_module.h)("div", {
            onClick: this.incPage,
            className: 'pdf-control-arrow pdf-control-arrow-right ' + (currentPage < numPages ? 'pdf-control-arrow-active' : '')
          }, "\u203A")), pinContainer);
        } else {
          var view = this.state.pdfPage.view;
          pdfPageNode = (0,preact_module.h)(PdfViewAsAllPages, {
            pdfDocument: this.state.pdfDocument,
            pdfjsLib: this.pdfJsLoader.get(),
            pagesOverview: this.state.pagesOverview,
            maxWidth: this.props.maxWidth,
            onPageMouseDown: this.onPageMouseDown,
            onPageMouseOver: this.onMouseOver,
            onPageMouseOut: this.onMouseOut,
            onPageClick: this.onPageClick,
            updatePagesOverview: this.updatePagesOverview,
            setPage: this.setPage,
            options: this.props.options
          });
        }
      }
      var fullScreenViewer = null;
      if (this.state.fullscreen) {
        var _view = this.state.pdfPage.view;
        fullScreenViewer = (0,preact_module.h)(PDFFullWrapper, {
          pdfDocument: this.state.pdfDocument,
          pageSize: {
            width: _view[2],
            height: _view[3]
          },
          onClose: this.onFullScreenClose,
          attachment: this.props.attachment,
          editor: this.props.editor,
          options: this.props.options,
          pdfjsLib: this.pdfJsLoader.get(),
          page: this.state.page,
          onPageChange: this.onPageChange,
          pagesOverview: this.state.pagesOverview,
          scale: this.state.scale,
          onScaleChange: this.onScaleChange,
          blot: this.props.blot
        });
      }
      return (0,preact_module.h)(plugins_i18n/* IntlProvider */.Pj, null, (0,preact_module.h)("div", {
        className: "pdf-viewer"
      }, fullScreenViewer, pdfPageNode, pdfControlsNode));
    }
  }]);
  return PDFViewerComponent;
}(preact_module/* Component */.wA); /**
               *  Возвращает дополнительные пункты меню для pdf блота
               * @param blot
               * @param viewerOption
               * @returns {{submenu: JSX.Element, index: number, action: boolean, label: JSX.Element}} | {}
               */

var getMenuItems = function getMenuItems(blot) {
  var viewerOption = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var viewAsSubMenuItems = [{
    id: 'file-view_pdf_as-single',
    code: 'single',
    text: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
      id: "file.menu.single_page"
    }),
    action: 'onViewPdfAsChange'
  }, {
    id: 'file-view_pdf_as-all_pages',
    code: 'all_pages',
    text: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
      id: "file.menu.all_pages"
    }),
    action: 'onViewPdfAsChange'
  }];
  var ViewAsSubMenu = (0,preact_module.h)(popupMenu/* default */.Z, {
    anchorOptions: {
      boundariesElement: blot.editor.scrollingContainer
    }
  }, viewAsSubMenuItems.map(function (_ref5) {
    var id = _ref5.id,
      code = _ref5.code,
      text = _ref5.text,
      action = _ref5.action;
    var viewAs = blot.getViewAs();
    var icon = code === viewAs ? icons/* IconDone */.EZi : null;
    var style = icon ? 'done' : 'undone';
    return (0,preact_module.h)(popupMenuItem/* default */.Z, {
      key: id,
      id: id,
      text: text,
      icon: icon,
      menuStyle: [style],
      onClick: blot.onViewPdfAsChange(code)
    });
  }));
  var menu = {};

  // Проверка можно ли отображать пункт "Отображать как"
  var _viewerOption$showAsP = viewerOption.showAsPagesLimit,
    showAsPagesLimit = _viewerOption$showAsP === void 0 ? 0 : _viewerOption$showAsP;
  var isShowViewAsItem = blot.pdfNumPages <= showAsPagesLimit || !showAsPagesLimit;
  if (isShowViewAsItem && blot.getFileViewMode() === 'full') {
    menu = pdf_objectSpread(pdf_objectSpread({}, menu), {}, {
      view_pdf_as: {
        label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
          id: "file.menu.view_as"
        }),
        index: 2,
        action: false,
        submenu: ViewAsSubMenu
      }
    });
  }
  return menu;
};
PDFViewerComponent.printable = true;
PDFViewerComponent.supportsFullscreen = true;
PDFViewerComponent.hasAdditionMenuItems = true;
PDFViewerComponent.PrintAction = PrintComponent;
PDFViewerComponent.FullScreenAction = FullScreenAction;
PDFViewerComponent.getMenuItems = getMenuItems;
PDFViewerComponent.viewerName = 'PDFViewer';

/***/ }),

/***/ 11526:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ VideoViewer),
  "getVideoTypes": () => (/* binding */ getVideoTypes)
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(15306);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(69600);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__(23123);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(19601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(4723);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__(73210);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(30489);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__(12419);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(57327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__(38880);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(54747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__(49337);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(87751);
// EXTERNAL MODULE: ./node_modules/preact/dist/preact.module.js
var preact_module = __webpack_require__(79758);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/util/browser.js
var browser = __webpack_require__(12650);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.splice.js
var es_array_splice = __webpack_require__(40561);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(21249);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__(24603);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.freeze.js
var es_object_freeze = __webpack_require__(43371);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-names.js
var es_object_get_own_property_names = __webpack_require__(36210);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(9653);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.weak-map.js
var es_weak_map = __webpack_require__(4129);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.map.js
var es_map = __webpack_require__(51532);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__(43290);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__(70189);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.to-fixed.js
var es_number_to_fixed = __webpack_require__(56977);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__(2707);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url.to-json.js
var web_url_to_json = __webpack_require__(83753);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.uint8-array.js
var es_typed_array_uint8_array = __webpack_require__(82472);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.copy-within.js
var es_typed_array_copy_within = __webpack_require__(92990);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.every.js
var es_typed_array_every = __webpack_require__(18927);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.fill.js
var es_typed_array_fill = __webpack_require__(33105);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.filter.js
var es_typed_array_filter = __webpack_require__(35035);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.find.js
var es_typed_array_find = __webpack_require__(74345);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.find-index.js
var es_typed_array_find_index = __webpack_require__(7174);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.for-each.js
var es_typed_array_for_each = __webpack_require__(32846);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.includes.js
var es_typed_array_includes = __webpack_require__(44731);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.index-of.js
var es_typed_array_index_of = __webpack_require__(77209);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.iterator.js
var es_typed_array_iterator = __webpack_require__(96319);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.join.js
var es_typed_array_join = __webpack_require__(58867);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.last-index-of.js
var es_typed_array_last_index_of = __webpack_require__(37789);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.map.js
var es_typed_array_map = __webpack_require__(33739);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reduce.js
var es_typed_array_reduce = __webpack_require__(29368);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reduce-right.js
var es_typed_array_reduce_right = __webpack_require__(14483);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reverse.js
var es_typed_array_reverse = __webpack_require__(12056);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.set.js
var es_typed_array_set = __webpack_require__(3462);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.slice.js
var es_typed_array_slice = __webpack_require__(30678);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.some.js
var es_typed_array_some = __webpack_require__(27462);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.sort.js
var es_typed_array_sort = __webpack_require__(33824);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.subarray.js
var es_typed_array_subarray = __webpack_require__(55021);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.to-locale-string.js
var es_typed_array_to_locale_string = __webpack_require__(12974);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.to-string.js
var es_typed_array_to_string = __webpack_require__(15016);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array-buffer.constructor.js
var es_array_buffer_constructor = __webpack_require__(18264);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url.js
var web_url = __webpack_require__(60285);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.js
var web_url_search_params = __webpack_require__(41637);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.max-safe-integer.js
var es_number_max_safe_integer = __webpack_require__(44363);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.flags.js
var es_regexp_flags = __webpack_require__(92087);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.global-this.js
var esnext_global_this = __webpack_require__(65743);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.uint32-array.js
var es_typed_array_uint32_array = __webpack_require__(29135);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.int32-array.js
var es_typed_array_int32_array = __webpack_require__(65125);
// EXTERNAL MODULE: ./node_modules/global/window.js
var global_window = __webpack_require__(95732);
var window_default = /*#__PURE__*/__webpack_require__.n(global_window);
// EXTERNAL MODULE: ./node_modules/global/document.js
var global_document = __webpack_require__(56374);
var document_default = /*#__PURE__*/__webpack_require__.n(global_document);
;// CONCATENATED MODULE: ./node_modules/video.js/node_modules/@babel/runtime/helpers/esm/extends.js

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) {
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
    }
    return n;
  }, _extends.apply(null, arguments);
}

// EXTERNAL MODULE: ./node_modules/keycode/index.js
var keycode = __webpack_require__(19820);
var keycode_default = /*#__PURE__*/__webpack_require__.n(keycode);
;// CONCATENATED MODULE: ./node_modules/video.js/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

;// CONCATENATED MODULE: ./node_modules/video.js/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

;// CONCATENATED MODULE: ./node_modules/video.js/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}

// EXTERNAL MODULE: ./node_modules/safe-json-parse/tuple.js
var tuple = __webpack_require__(48119);
var tuple_default = /*#__PURE__*/__webpack_require__.n(tuple);
// EXTERNAL MODULE: ./node_modules/@videojs/xhr/lib/index.js
var lib = __webpack_require__(3173);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/videojs-vtt.js/lib/browser-index.js
var browser_index = __webpack_require__(99227);
var browser_index_default = /*#__PURE__*/__webpack_require__.n(browser_index);
;// CONCATENATED MODULE: ./node_modules/video.js/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js

function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

;// CONCATENATED MODULE: ./node_modules/video.js/node_modules/@babel/runtime/helpers/esm/construct.js



function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}

;// CONCATENATED MODULE: ./node_modules/video.js/node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

// EXTERNAL MODULE: ./node_modules/url-toolkit/src/url-toolkit.js
var url_toolkit = __webpack_require__(39724);
var url_toolkit_default = /*#__PURE__*/__webpack_require__.n(url_toolkit);
;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/resolve-url.js









var DEFAULT_LOCATION = 'http://example.com';
var resolveUrl = function resolveUrl(baseUrl, relativeUrl) {
  // return early if we don't need to resolve
  if (/^[a-z]+:/i.test(relativeUrl)) {
    return relativeUrl;
  } // if baseUrl is a data URI, ignore it and resolve everything relative to window.location

  if (/^data:/.test(baseUrl)) {
    baseUrl = (window_default()).location && (window_default()).location.href || '';
  } // IE11 supports URL but not the URL constructor
  // feature detect the behavior we want

  var nativeURL = typeof (window_default()).URL === 'function';
  var protocolLess = /^\/\//.test(baseUrl); // remove location if window.location isn't available (i.e. we're in node)
  // and if baseUrl isn't an absolute url

  var removeLocation = !(window_default()).location && !/\/\//i.test(baseUrl); // if the base URL is relative then combine with the current location

  if (nativeURL) {
    baseUrl = new (window_default()).URL(baseUrl, (window_default()).location || DEFAULT_LOCATION);
  } else if (!/\/\//i.test(baseUrl)) {
    baseUrl = url_toolkit_default().buildAbsoluteURL((window_default()).location && (window_default()).location.href || '', baseUrl);
  }
  if (nativeURL) {
    var newUrl = new URL(relativeUrl, baseUrl); // if we're a protocol-less url, remove the protocol
    // and if we're location-less, remove the location
    // otherwise, return the url unmodified

    if (removeLocation) {
      return newUrl.href.slice(DEFAULT_LOCATION.length);
    } else if (protocolLess) {
      return newUrl.href.slice(newUrl.protocol.length);
    }
    return newUrl.href;
  }
  return url_toolkit_default().buildAbsoluteURL(baseUrl, relativeUrl);
};
/* harmony default export */ const resolve_url = (resolveUrl);
;// CONCATENATED MODULE: ./node_modules/m3u8-parser/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function setPrototypeOf_setPrototypeOf(t, e) {
  return setPrototypeOf_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, setPrototypeOf_setPrototypeOf(t, e);
}

;// CONCATENATED MODULE: ./node_modules/m3u8-parser/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function inheritsLoose_inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, setPrototypeOf_setPrototypeOf(t, o);
}

;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/stream.js


/**
 * @file stream.js
 */

/**
 * A lightweight readable stream implemention that handles event dispatching.
 *
 * @class Stream
 */
var Stream = /*#__PURE__*/function () {
  function Stream() {
    this.listeners = {};
  }
  /**
   * Add a listener for a specified event type.
   *
   * @param {string} type the event name
   * @param {Function} listener the callback to be invoked when an event of
   * the specified type occurs
   */

  var _proto = Stream.prototype;
  _proto.on = function on(type, listener) {
    if (!this.listeners[type]) {
      this.listeners[type] = [];
    }
    this.listeners[type].push(listener);
  }
  /**
   * Remove a listener for a specified event type.
   *
   * @param {string} type the event name
   * @param {Function} listener  a function previously registered for this
   * type of event through `on`
   * @return {boolean} if we could turn it off or not
   */;

  _proto.off = function off(type, listener) {
    if (!this.listeners[type]) {
      return false;
    }
    var index = this.listeners[type].indexOf(listener); // TODO: which is better?
    // In Video.js we slice listener functions
    // on trigger so that it does not mess up the order
    // while we loop through.
    //
    // Here we slice on off so that the loop in trigger
    // can continue using it's old reference to loop without
    // messing up the order.

    this.listeners[type] = this.listeners[type].slice(0);
    this.listeners[type].splice(index, 1);
    return index > -1;
  }
  /**
   * Trigger an event of the specified type on this stream. Any additional
   * arguments to this function are passed as parameters to event listeners.
   *
   * @param {string} type the event name
   */;

  _proto.trigger = function trigger(type) {
    var callbacks = this.listeners[type];
    if (!callbacks) {
      return;
    } // Slicing the arguments on every invocation of this method
    // can add a significant amount of overhead. Avoid the
    // intermediate object creation for the common case of a
    // single callback argument

    if (arguments.length === 2) {
      var length = callbacks.length;
      for (var i = 0; i < length; ++i) {
        callbacks[i].call(this, arguments[1]);
      }
    } else {
      var args = Array.prototype.slice.call(arguments, 1);
      var _length = callbacks.length;
      for (var _i = 0; _i < _length; ++_i) {
        callbacks[_i].apply(this, args);
      }
    }
  }
  /**
   * Destroys the stream and cleans up.
   */;

  _proto.dispose = function dispose() {
    this.listeners = {};
  }
  /**
   * Forwards all `data` events on this stream to the destination stream. The
   * destination stream should provide a method `push` to receive the data
   * events as they arrive.
   *
   * @param {Stream} destination the stream that will receive all `data` events
   * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
   */;

  _proto.pipe = function pipe(destination) {
    this.on('data', function (data) {
      destination.push(data);
    });
  };
  return Stream;
}();

;// CONCATENATED MODULE: ./node_modules/m3u8-parser/node_modules/@babel/runtime/helpers/esm/extends.js

function extends_extends() {
  return extends_extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) {
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
    }
    return n;
  }, extends_extends.apply(null, arguments);
}

;// CONCATENATED MODULE: ./node_modules/m3u8-parser/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function assertThisInitialized_assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/decode-b64-to-uint8-array.js
/* provided dependency */ var Buffer = __webpack_require__(13423)["Buffer"];




























var atob = function atob(s) {
  return (window_default()).atob ? window_default().atob(s) : Buffer.from(s, 'base64').toString('binary');
};
function decodeB64ToUint8Array(b64Text) {
  var decodedString = atob(b64Text);
  var array = new Uint8Array(decodedString.length);
  for (var i = 0; i < decodedString.length; i++) {
    array[i] = decodedString.charCodeAt(i);
  }
  return array;
}
;// CONCATENATED MODULE: ./node_modules/m3u8-parser/dist/m3u8-parser.es.js







































/*! @name m3u8-parser @version 4.8.0 @license Apache-2.0 */






/**
 * A stream that buffers string input and generates a `data` event for each
 * line.
 *
 * @class LineStream
 * @extends Stream
 */

var LineStream = /*#__PURE__*/function (_Stream) {
  inheritsLoose_inheritsLoose(LineStream, _Stream);
  function LineStream() {
    var _this;
    _this = _Stream.call(this) || this;
    _this.buffer = '';
    return _this;
  }
  /**
   * Add new data to be parsed.
   *
   * @param {string} data the text to process
   */

  var _proto = LineStream.prototype;
  _proto.push = function push(data) {
    var nextNewline;
    this.buffer += data;
    nextNewline = this.buffer.indexOf('\n');
    for (; nextNewline > -1; nextNewline = this.buffer.indexOf('\n')) {
      this.trigger('data', this.buffer.substring(0, nextNewline));
      this.buffer = this.buffer.substring(nextNewline + 1);
    }
  };
  return LineStream;
}(Stream);
var TAB = String.fromCharCode(0x09);
var parseByterange = function parseByterange(byterangeString) {
  // optionally match and capture 0+ digits before `@`
  // optionally match and capture 0+ digits after `@`
  var match = /([0-9.]*)?@?([0-9.]*)?/.exec(byterangeString || '');
  var result = {};
  if (match[1]) {
    result.length = parseInt(match[1], 10);
  }
  if (match[2]) {
    result.offset = parseInt(match[2], 10);
  }
  return result;
};
/**
 * "forgiving" attribute list psuedo-grammar:
 * attributes -> keyvalue (',' keyvalue)*
 * keyvalue   -> key '=' value
 * key        -> [^=]*
 * value      -> '"' [^"]* '"' | [^,]*
 */

var attributeSeparator = function attributeSeparator() {
  var key = '[^=]*';
  var value = '"[^"]*"|[^,]*';
  var keyvalue = '(?:' + key + ')=(?:' + value + ')';
  return new RegExp('(?:^|,)(' + keyvalue + ')');
};
/**
 * Parse attributes from a line given the separator
 *
 * @param {string} attributes the attribute line to parse
 */

var parseAttributes = function parseAttributes(attributes) {
  // split the string using attributes as the separator
  var attrs = attributes.split(attributeSeparator());
  var result = {};
  var i = attrs.length;
  var attr;
  while (i--) {
    // filter out unmatched portions of the string
    if (attrs[i] === '') {
      continue;
    } // split the key and value

    attr = /([^=]*)=(.*)/.exec(attrs[i]).slice(1); // trim whitespace and remove optional quotes around the value

    attr[0] = attr[0].replace(/^\s+|\s+$/g, '');
    attr[1] = attr[1].replace(/^\s+|\s+$/g, '');
    attr[1] = attr[1].replace(/^['"](.*)['"]$/g, '$1');
    result[attr[0]] = attr[1];
  }
  return result;
};
/**
 * A line-level M3U8 parser event stream. It expects to receive input one
 * line at a time and performs a context-free parse of its contents. A stream
 * interpretation of a manifest can be useful if the manifest is expected to
 * be too large to fit comfortably into memory or the entirety of the input
 * is not immediately available. Otherwise, it's probably much easier to work
 * with a regular `Parser` object.
 *
 * Produces `data` events with an object that captures the parser's
 * interpretation of the input. That object has a property `tag` that is one
 * of `uri`, `comment`, or `tag`. URIs only have a single additional
 * property, `line`, which captures the entirety of the input without
 * interpretation. Comments similarly have a single additional property
 * `text` which is the input without the leading `#`.
 *
 * Tags always have a property `tagType` which is the lower-cased version of
 * the M3U8 directive without the `#EXT` or `#EXT-X-` prefix. For instance,
 * `#EXT-X-MEDIA-SEQUENCE` becomes `media-sequence` when parsed. Unrecognized
 * tags are given the tag type `unknown` and a single additional property
 * `data` with the remainder of the input.
 *
 * @class ParseStream
 * @extends Stream
 */

var ParseStream = /*#__PURE__*/function (_Stream) {
  inheritsLoose_inheritsLoose(ParseStream, _Stream);
  function ParseStream() {
    var _this;
    _this = _Stream.call(this) || this;
    _this.customParsers = [];
    _this.tagMappers = [];
    return _this;
  }
  /**
   * Parses an additional line of input.
   *
   * @param {string} line a single line of an M3U8 file to parse
   */

  var _proto = ParseStream.prototype;
  _proto.push = function push(line) {
    var _this2 = this;
    var match;
    var event; // strip whitespace

    line = line.trim();
    if (line.length === 0) {
      // ignore empty lines
      return;
    } // URIs

    if (line[0] !== '#') {
      this.trigger('data', {
        type: 'uri',
        uri: line
      });
      return;
    } // map tags

    var newLines = this.tagMappers.reduce(function (acc, mapper) {
      var mappedLine = mapper(line); // skip if unchanged

      if (mappedLine === line) {
        return acc;
      }
      return acc.concat([mappedLine]);
    }, [line]);
    newLines.forEach(function (newLine) {
      for (var i = 0; i < _this2.customParsers.length; i++) {
        if (_this2.customParsers[i].call(_this2, newLine)) {
          return;
        }
      } // Comments

      if (newLine.indexOf('#EXT') !== 0) {
        _this2.trigger('data', {
          type: 'comment',
          text: newLine.slice(1)
        });
        return;
      } // strip off any carriage returns here so the regex matching
      // doesn't have to account for them.

      newLine = newLine.replace('\r', ''); // Tags

      match = /^#EXTM3U/.exec(newLine);
      if (match) {
        _this2.trigger('data', {
          type: 'tag',
          tagType: 'm3u'
        });
        return;
      }
      match = /^#EXTINF:?([0-9\.]*)?,?(.*)?$/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'inf'
        };
        if (match[1]) {
          event.duration = parseFloat(match[1]);
        }
        if (match[2]) {
          event.title = match[2];
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-TARGETDURATION:?([0-9.]*)?/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'targetduration'
        };
        if (match[1]) {
          event.duration = parseInt(match[1], 10);
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-VERSION:?([0-9.]*)?/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'version'
        };
        if (match[1]) {
          event.version = parseInt(match[1], 10);
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-MEDIA-SEQUENCE:?(\-?[0-9.]*)?/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'media-sequence'
        };
        if (match[1]) {
          event.number = parseInt(match[1], 10);
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-DISCONTINUITY-SEQUENCE:?(\-?[0-9.]*)?/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'discontinuity-sequence'
        };
        if (match[1]) {
          event.number = parseInt(match[1], 10);
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-PLAYLIST-TYPE:?(.*)?$/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'playlist-type'
        };
        if (match[1]) {
          event.playlistType = match[1];
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-BYTERANGE:?(.*)?$/.exec(newLine);
      if (match) {
        event = extends_extends(parseByterange(match[1]), {
          type: 'tag',
          tagType: 'byterange'
        });
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-ALLOW-CACHE:?(YES|NO)?/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'allow-cache'
        };
        if (match[1]) {
          event.allowed = !/NO/.test(match[1]);
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-MAP:?(.*)$/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'map'
        };
        if (match[1]) {
          var attributes = parseAttributes(match[1]);
          if (attributes.URI) {
            event.uri = attributes.URI;
          }
          if (attributes.BYTERANGE) {
            event.byterange = parseByterange(attributes.BYTERANGE);
          }
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-STREAM-INF:?(.*)$/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'stream-inf'
        };
        if (match[1]) {
          event.attributes = parseAttributes(match[1]);
          if (event.attributes.RESOLUTION) {
            var split = event.attributes.RESOLUTION.split('x');
            var resolution = {};
            if (split[0]) {
              resolution.width = parseInt(split[0], 10);
            }
            if (split[1]) {
              resolution.height = parseInt(split[1], 10);
            }
            event.attributes.RESOLUTION = resolution;
          }
          if (event.attributes.BANDWIDTH) {
            event.attributes.BANDWIDTH = parseInt(event.attributes.BANDWIDTH, 10);
          }
          if (event.attributes['FRAME-RATE']) {
            event.attributes['FRAME-RATE'] = parseFloat(event.attributes['FRAME-RATE']);
          }
          if (event.attributes['PROGRAM-ID']) {
            event.attributes['PROGRAM-ID'] = parseInt(event.attributes['PROGRAM-ID'], 10);
          }
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-MEDIA:?(.*)$/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'media'
        };
        if (match[1]) {
          event.attributes = parseAttributes(match[1]);
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-ENDLIST/.exec(newLine);
      if (match) {
        _this2.trigger('data', {
          type: 'tag',
          tagType: 'endlist'
        });
        return;
      }
      match = /^#EXT-X-DISCONTINUITY/.exec(newLine);
      if (match) {
        _this2.trigger('data', {
          type: 'tag',
          tagType: 'discontinuity'
        });
        return;
      }
      match = /^#EXT-X-PROGRAM-DATE-TIME:?(.*)$/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'program-date-time'
        };
        if (match[1]) {
          event.dateTimeString = match[1];
          event.dateTimeObject = new Date(match[1]);
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-KEY:?(.*)$/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'key'
        };
        if (match[1]) {
          event.attributes = parseAttributes(match[1]); // parse the IV string into a Uint32Array

          if (event.attributes.IV) {
            if (event.attributes.IV.substring(0, 2).toLowerCase() === '0x') {
              event.attributes.IV = event.attributes.IV.substring(2);
            }
            event.attributes.IV = event.attributes.IV.match(/.{8}/g);
            event.attributes.IV[0] = parseInt(event.attributes.IV[0], 16);
            event.attributes.IV[1] = parseInt(event.attributes.IV[1], 16);
            event.attributes.IV[2] = parseInt(event.attributes.IV[2], 16);
            event.attributes.IV[3] = parseInt(event.attributes.IV[3], 16);
            event.attributes.IV = new Uint32Array(event.attributes.IV);
          }
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-START:?(.*)$/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'start'
        };
        if (match[1]) {
          event.attributes = parseAttributes(match[1]);
          event.attributes['TIME-OFFSET'] = parseFloat(event.attributes['TIME-OFFSET']);
          event.attributes.PRECISE = /YES/.test(event.attributes.PRECISE);
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-CUE-OUT-CONT:?(.*)?$/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'cue-out-cont'
        };
        if (match[1]) {
          event.data = match[1];
        } else {
          event.data = '';
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-CUE-OUT:?(.*)?$/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'cue-out'
        };
        if (match[1]) {
          event.data = match[1];
        } else {
          event.data = '';
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-CUE-IN:?(.*)?$/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'cue-in'
        };
        if (match[1]) {
          event.data = match[1];
        } else {
          event.data = '';
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-SKIP:(.*)$/.exec(newLine);
      if (match && match[1]) {
        event = {
          type: 'tag',
          tagType: 'skip'
        };
        event.attributes = parseAttributes(match[1]);
        if (event.attributes.hasOwnProperty('SKIPPED-SEGMENTS')) {
          event.attributes['SKIPPED-SEGMENTS'] = parseInt(event.attributes['SKIPPED-SEGMENTS'], 10);
        }
        if (event.attributes.hasOwnProperty('RECENTLY-REMOVED-DATERANGES')) {
          event.attributes['RECENTLY-REMOVED-DATERANGES'] = event.attributes['RECENTLY-REMOVED-DATERANGES'].split(TAB);
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-PART:(.*)$/.exec(newLine);
      if (match && match[1]) {
        event = {
          type: 'tag',
          tagType: 'part'
        };
        event.attributes = parseAttributes(match[1]);
        ['DURATION'].forEach(function (key) {
          if (event.attributes.hasOwnProperty(key)) {
            event.attributes[key] = parseFloat(event.attributes[key]);
          }
        });
        ['INDEPENDENT', 'GAP'].forEach(function (key) {
          if (event.attributes.hasOwnProperty(key)) {
            event.attributes[key] = /YES/.test(event.attributes[key]);
          }
        });
        if (event.attributes.hasOwnProperty('BYTERANGE')) {
          event.attributes.byterange = parseByterange(event.attributes.BYTERANGE);
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-SERVER-CONTROL:(.*)$/.exec(newLine);
      if (match && match[1]) {
        event = {
          type: 'tag',
          tagType: 'server-control'
        };
        event.attributes = parseAttributes(match[1]);
        ['CAN-SKIP-UNTIL', 'PART-HOLD-BACK', 'HOLD-BACK'].forEach(function (key) {
          if (event.attributes.hasOwnProperty(key)) {
            event.attributes[key] = parseFloat(event.attributes[key]);
          }
        });
        ['CAN-SKIP-DATERANGES', 'CAN-BLOCK-RELOAD'].forEach(function (key) {
          if (event.attributes.hasOwnProperty(key)) {
            event.attributes[key] = /YES/.test(event.attributes[key]);
          }
        });
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-PART-INF:(.*)$/.exec(newLine);
      if (match && match[1]) {
        event = {
          type: 'tag',
          tagType: 'part-inf'
        };
        event.attributes = parseAttributes(match[1]);
        ['PART-TARGET'].forEach(function (key) {
          if (event.attributes.hasOwnProperty(key)) {
            event.attributes[key] = parseFloat(event.attributes[key]);
          }
        });
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-PRELOAD-HINT:(.*)$/.exec(newLine);
      if (match && match[1]) {
        event = {
          type: 'tag',
          tagType: 'preload-hint'
        };
        event.attributes = parseAttributes(match[1]);
        ['BYTERANGE-START', 'BYTERANGE-LENGTH'].forEach(function (key) {
          if (event.attributes.hasOwnProperty(key)) {
            event.attributes[key] = parseInt(event.attributes[key], 10);
            var subkey = key === 'BYTERANGE-LENGTH' ? 'length' : 'offset';
            event.attributes.byterange = event.attributes.byterange || {};
            event.attributes.byterange[subkey] = event.attributes[key]; // only keep the parsed byterange object.

            delete event.attributes[key];
          }
        });
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-RENDITION-REPORT:(.*)$/.exec(newLine);
      if (match && match[1]) {
        event = {
          type: 'tag',
          tagType: 'rendition-report'
        };
        event.attributes = parseAttributes(match[1]);
        ['LAST-MSN', 'LAST-PART'].forEach(function (key) {
          if (event.attributes.hasOwnProperty(key)) {
            event.attributes[key] = parseInt(event.attributes[key], 10);
          }
        });
        _this2.trigger('data', event);
        return;
      } // unknown tag type

      _this2.trigger('data', {
        type: 'tag',
        data: newLine.slice(4)
      });
    });
  }
  /**
   * Add a parser for custom headers
   *
   * @param {Object}   options              a map of options for the added parser
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {string}   options.customType   the custom type to register to the output
   * @param {Function} [options.dataParser] function to parse the line into an object
   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
   */;

  _proto.addParser = function addParser(_ref) {
    var _this3 = this;
    var expression = _ref.expression,
      customType = _ref.customType,
      dataParser = _ref.dataParser,
      segment = _ref.segment;
    if (typeof dataParser !== 'function') {
      dataParser = function dataParser(line) {
        return line;
      };
    }
    this.customParsers.push(function (line) {
      var match = expression.exec(line);
      if (match) {
        _this3.trigger('data', {
          type: 'custom',
          data: dataParser(line),
          customType: customType,
          segment: segment
        });
        return true;
      }
    });
  }
  /**
   * Add a custom header mapper
   *
   * @param {Object}   options
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {Function} options.map          function to translate tag into a different tag
   */;

  _proto.addTagMapper = function addTagMapper(_ref2) {
    var expression = _ref2.expression,
      map = _ref2.map;
    var mapFn = function mapFn(line) {
      if (expression.test(line)) {
        return map(line);
      }
      return line;
    };
    this.tagMappers.push(mapFn);
  };
  return ParseStream;
}(Stream);
var camelCase = function camelCase(str) {
  return str.toLowerCase().replace(/-(\w)/g, function (a) {
    return a[1].toUpperCase();
  });
};
var camelCaseKeys = function camelCaseKeys(attributes) {
  var result = {};
  Object.keys(attributes).forEach(function (key) {
    result[camelCase(key)] = attributes[key];
  });
  return result;
}; // set SERVER-CONTROL hold back based upon targetDuration and partTargetDuration
// we need this helper because defaults are based upon targetDuration and
// partTargetDuration being set, but they may not be if SERVER-CONTROL appears before
// target durations are set.

var setHoldBack = function setHoldBack(manifest) {
  var serverControl = manifest.serverControl,
    targetDuration = manifest.targetDuration,
    partTargetDuration = manifest.partTargetDuration;
  if (!serverControl) {
    return;
  }
  var tag = '#EXT-X-SERVER-CONTROL';
  var hb = 'holdBack';
  var phb = 'partHoldBack';
  var minTargetDuration = targetDuration && targetDuration * 3;
  var minPartDuration = partTargetDuration && partTargetDuration * 2;
  if (targetDuration && !serverControl.hasOwnProperty(hb)) {
    serverControl[hb] = minTargetDuration;
    this.trigger('info', {
      message: tag + " defaulting HOLD-BACK to targetDuration * 3 (" + minTargetDuration + ")."
    });
  }
  if (minTargetDuration && serverControl[hb] < minTargetDuration) {
    this.trigger('warn', {
      message: tag + " clamping HOLD-BACK (" + serverControl[hb] + ") to targetDuration * 3 (" + minTargetDuration + ")"
    });
    serverControl[hb] = minTargetDuration;
  } // default no part hold back to part target duration * 3

  if (partTargetDuration && !serverControl.hasOwnProperty(phb)) {
    serverControl[phb] = partTargetDuration * 3;
    this.trigger('info', {
      message: tag + " defaulting PART-HOLD-BACK to partTargetDuration * 3 (" + serverControl[phb] + ")."
    });
  } // if part hold back is too small default it to part target duration * 2

  if (partTargetDuration && serverControl[phb] < minPartDuration) {
    this.trigger('warn', {
      message: tag + " clamping PART-HOLD-BACK (" + serverControl[phb] + ") to partTargetDuration * 2 (" + minPartDuration + ")."
    });
    serverControl[phb] = minPartDuration;
  }
};
/**
 * A parser for M3U8 files. The current interpretation of the input is
 * exposed as a property `manifest` on parser objects. It's just two lines to
 * create and parse a manifest once you have the contents available as a string:
 *
 * ```js
 * var parser = new m3u8.Parser();
 * parser.push(xhr.responseText);
 * ```
 *
 * New input can later be applied to update the manifest object by calling
 * `push` again.
 *
 * The parser attempts to create a usable manifest object even if the
 * underlying input is somewhat nonsensical. It emits `info` and `warning`
 * events during the parse if it encounters input that seems invalid or
 * requires some property of the manifest object to be defaulted.
 *
 * @class Parser
 * @extends Stream
 */

var Parser = /*#__PURE__*/function (_Stream) {
  inheritsLoose_inheritsLoose(Parser, _Stream);
  function Parser() {
    var _this;
    _this = _Stream.call(this) || this;
    _this.lineStream = new LineStream();
    _this.parseStream = new ParseStream();
    _this.lineStream.pipe(_this.parseStream);
    /* eslint-disable consistent-this */

    var self = assertThisInitialized_assertThisInitialized(_this);
    /* eslint-enable consistent-this */

    var uris = [];
    var currentUri = {}; // if specified, the active EXT-X-MAP definition

    var currentMap; // if specified, the active decryption key

    var _key;
    var hasParts = false;
    var noop = function noop() {};
    var defaultMediaGroups = {
      'AUDIO': {},
      'VIDEO': {},
      'CLOSED-CAPTIONS': {},
      'SUBTITLES': {}
    }; // This is the Widevine UUID from DASH IF IOP. The same exact string is
    // used in MPDs with Widevine encrypted streams.

    var widevineUuid = 'urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed'; // group segments into numbered timelines delineated by discontinuities

    var currentTimeline = 0; // the manifest is empty until the parse stream begins delivering data

    _this.manifest = {
      allowCache: true,
      discontinuityStarts: [],
      segments: []
    }; // keep track of the last seen segment's byte range end, as segments are not required
    // to provide the offset, in which case it defaults to the next byte after the
    // previous segment

    var lastByterangeEnd = 0; // keep track of the last seen part's byte range end.

    var lastPartByterangeEnd = 0;
    _this.on('end', function () {
      // only add preloadSegment if we don't yet have a uri for it.
      // and we actually have parts/preloadHints
      if (currentUri.uri || !currentUri.parts && !currentUri.preloadHints) {
        return;
      }
      if (!currentUri.map && currentMap) {
        currentUri.map = currentMap;
      }
      if (!currentUri.key && _key) {
        currentUri.key = _key;
      }
      if (!currentUri.timeline && typeof currentTimeline === 'number') {
        currentUri.timeline = currentTimeline;
      }
      _this.manifest.preloadSegment = currentUri;
    }); // update the manifest with the m3u8 entry from the parse stream

    _this.parseStream.on('data', function (entry) {
      var mediaGroup;
      var rendition;
      ({
        tag: function tag() {
          // switch based on the tag type
          (({
            version: function version() {
              if (entry.version) {
                this.manifest.version = entry.version;
              }
            },
            'allow-cache': function allowCache() {
              this.manifest.allowCache = entry.allowed;
              if (!('allowed' in entry)) {
                this.trigger('info', {
                  message: 'defaulting allowCache to YES'
                });
                this.manifest.allowCache = true;
              }
            },
            byterange: function byterange() {
              var byterange = {};
              if ('length' in entry) {
                currentUri.byterange = byterange;
                byterange.length = entry.length;
                if (!('offset' in entry)) {
                  /*
                   * From the latest spec (as of this writing):
                   * https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.2.2
                   *
                   * Same text since EXT-X-BYTERANGE's introduction in draft 7:
                   * https://tools.ietf.org/html/draft-pantos-http-live-streaming-07#section-3.3.1)
                   *
                   * "If o [offset] is not present, the sub-range begins at the next byte
                   * following the sub-range of the previous media segment."
                   */
                  entry.offset = lastByterangeEnd;
                }
              }
              if ('offset' in entry) {
                currentUri.byterange = byterange;
                byterange.offset = entry.offset;
              }
              lastByterangeEnd = byterange.offset + byterange.length;
            },
            endlist: function endlist() {
              this.manifest.endList = true;
            },
            inf: function inf() {
              if (!('mediaSequence' in this.manifest)) {
                this.manifest.mediaSequence = 0;
                this.trigger('info', {
                  message: 'defaulting media sequence to zero'
                });
              }
              if (!('discontinuitySequence' in this.manifest)) {
                this.manifest.discontinuitySequence = 0;
                this.trigger('info', {
                  message: 'defaulting discontinuity sequence to zero'
                });
              }
              if (entry.duration > 0) {
                currentUri.duration = entry.duration;
              }
              if (entry.duration === 0) {
                currentUri.duration = 0.01;
                this.trigger('info', {
                  message: 'updating zero segment duration to a small value'
                });
              }
              this.manifest.segments = uris;
            },
            key: function key() {
              if (!entry.attributes) {
                this.trigger('warn', {
                  message: 'ignoring key declaration without attribute list'
                });
                return;
              } // clear the active encryption key

              if (entry.attributes.METHOD === 'NONE') {
                _key = null;
                return;
              }
              if (!entry.attributes.URI) {
                this.trigger('warn', {
                  message: 'ignoring key declaration without URI'
                });
                return;
              }
              if (entry.attributes.KEYFORMAT === 'com.apple.streamingkeydelivery') {
                this.manifest.contentProtection = this.manifest.contentProtection || {}; // TODO: add full support for this.

                this.manifest.contentProtection['com.apple.fps.1_0'] = {
                  attributes: entry.attributes
                };
                return;
              }
              if (entry.attributes.KEYFORMAT === 'com.microsoft.playready') {
                this.manifest.contentProtection = this.manifest.contentProtection || {}; // TODO: add full support for this.

                this.manifest.contentProtection['com.microsoft.playready'] = {
                  uri: entry.attributes.URI
                };
                return;
              } // check if the content is encrypted for Widevine
              // Widevine/HLS spec: https://storage.googleapis.com/wvdocs/Widevine_DRM_HLS.pdf

              if (entry.attributes.KEYFORMAT === widevineUuid) {
                var VALID_METHODS = ['SAMPLE-AES', 'SAMPLE-AES-CTR', 'SAMPLE-AES-CENC'];
                if (VALID_METHODS.indexOf(entry.attributes.METHOD) === -1) {
                  this.trigger('warn', {
                    message: 'invalid key method provided for Widevine'
                  });
                  return;
                }
                if (entry.attributes.METHOD === 'SAMPLE-AES-CENC') {
                  this.trigger('warn', {
                    message: 'SAMPLE-AES-CENC is deprecated, please use SAMPLE-AES-CTR instead'
                  });
                }
                if (entry.attributes.URI.substring(0, 23) !== 'data:text/plain;base64,') {
                  this.trigger('warn', {
                    message: 'invalid key URI provided for Widevine'
                  });
                  return;
                }
                if (!(entry.attributes.KEYID && entry.attributes.KEYID.substring(0, 2) === '0x')) {
                  this.trigger('warn', {
                    message: 'invalid key ID provided for Widevine'
                  });
                  return;
                } // if Widevine key attributes are valid, store them as `contentProtection`
                // on the manifest to emulate Widevine tag structure in a DASH mpd

                this.manifest.contentProtection = this.manifest.contentProtection || {};
                this.manifest.contentProtection['com.widevine.alpha'] = {
                  attributes: {
                    schemeIdUri: entry.attributes.KEYFORMAT,
                    // remove '0x' from the key id string
                    keyId: entry.attributes.KEYID.substring(2)
                  },
                  // decode the base64-encoded PSSH box
                  pssh: decodeB64ToUint8Array(entry.attributes.URI.split(',')[1])
                };
                return;
              }
              if (!entry.attributes.METHOD) {
                this.trigger('warn', {
                  message: 'defaulting key method to AES-128'
                });
              } // setup an encryption key for upcoming segments

              _key = {
                method: entry.attributes.METHOD || 'AES-128',
                uri: entry.attributes.URI
              };
              if (typeof entry.attributes.IV !== 'undefined') {
                _key.iv = entry.attributes.IV;
              }
            },
            'media-sequence': function mediaSequence() {
              if (!isFinite(entry.number)) {
                this.trigger('warn', {
                  message: 'ignoring invalid media sequence: ' + entry.number
                });
                return;
              }
              this.manifest.mediaSequence = entry.number;
            },
            'discontinuity-sequence': function discontinuitySequence() {
              if (!isFinite(entry.number)) {
                this.trigger('warn', {
                  message: 'ignoring invalid discontinuity sequence: ' + entry.number
                });
                return;
              }
              this.manifest.discontinuitySequence = entry.number;
              currentTimeline = entry.number;
            },
            'playlist-type': function playlistType() {
              if (!/VOD|EVENT/.test(entry.playlistType)) {
                this.trigger('warn', {
                  message: 'ignoring unknown playlist type: ' + entry.playlist
                });
                return;
              }
              this.manifest.playlistType = entry.playlistType;
            },
            map: function map() {
              currentMap = {};
              if (entry.uri) {
                currentMap.uri = entry.uri;
              }
              if (entry.byterange) {
                currentMap.byterange = entry.byterange;
              }
              if (_key) {
                currentMap.key = _key;
              }
            },
            'stream-inf': function streamInf() {
              this.manifest.playlists = uris;
              this.manifest.mediaGroups = this.manifest.mediaGroups || defaultMediaGroups;
              if (!entry.attributes) {
                this.trigger('warn', {
                  message: 'ignoring empty stream-inf attributes'
                });
                return;
              }
              if (!currentUri.attributes) {
                currentUri.attributes = {};
              }
              extends_extends(currentUri.attributes, entry.attributes);
            },
            media: function media() {
              this.manifest.mediaGroups = this.manifest.mediaGroups || defaultMediaGroups;
              if (!(entry.attributes && entry.attributes.TYPE && entry.attributes['GROUP-ID'] && entry.attributes.NAME)) {
                this.trigger('warn', {
                  message: 'ignoring incomplete or missing media group'
                });
                return;
              } // find the media group, creating defaults as necessary

              var mediaGroupType = this.manifest.mediaGroups[entry.attributes.TYPE];
              mediaGroupType[entry.attributes['GROUP-ID']] = mediaGroupType[entry.attributes['GROUP-ID']] || {};
              mediaGroup = mediaGroupType[entry.attributes['GROUP-ID']]; // collect the rendition metadata

              rendition = {
                default: /yes/i.test(entry.attributes.DEFAULT)
              };
              if (rendition.default) {
                rendition.autoselect = true;
              } else {
                rendition.autoselect = /yes/i.test(entry.attributes.AUTOSELECT);
              }
              if (entry.attributes.LANGUAGE) {
                rendition.language = entry.attributes.LANGUAGE;
              }
              if (entry.attributes.URI) {
                rendition.uri = entry.attributes.URI;
              }
              if (entry.attributes['INSTREAM-ID']) {
                rendition.instreamId = entry.attributes['INSTREAM-ID'];
              }
              if (entry.attributes.CHARACTERISTICS) {
                rendition.characteristics = entry.attributes.CHARACTERISTICS;
              }
              if (entry.attributes.FORCED) {
                rendition.forced = /yes/i.test(entry.attributes.FORCED);
              } // insert the new rendition

              mediaGroup[entry.attributes.NAME] = rendition;
            },
            discontinuity: function discontinuity() {
              currentTimeline += 1;
              currentUri.discontinuity = true;
              this.manifest.discontinuityStarts.push(uris.length);
            },
            'program-date-time': function programDateTime() {
              if (typeof this.manifest.dateTimeString === 'undefined') {
                // PROGRAM-DATE-TIME is a media-segment tag, but for backwards
                // compatibility, we add the first occurence of the PROGRAM-DATE-TIME tag
                // to the manifest object
                // TODO: Consider removing this in future major version
                this.manifest.dateTimeString = entry.dateTimeString;
                this.manifest.dateTimeObject = entry.dateTimeObject;
              }
              currentUri.dateTimeString = entry.dateTimeString;
              currentUri.dateTimeObject = entry.dateTimeObject;
            },
            targetduration: function targetduration() {
              if (!isFinite(entry.duration) || entry.duration < 0) {
                this.trigger('warn', {
                  message: 'ignoring invalid target duration: ' + entry.duration
                });
                return;
              }
              this.manifest.targetDuration = entry.duration;
              setHoldBack.call(this, this.manifest);
            },
            start: function start() {
              if (!entry.attributes || isNaN(entry.attributes['TIME-OFFSET'])) {
                this.trigger('warn', {
                  message: 'ignoring start declaration without appropriate attribute list'
                });
                return;
              }
              this.manifest.start = {
                timeOffset: entry.attributes['TIME-OFFSET'],
                precise: entry.attributes.PRECISE
              };
            },
            'cue-out': function cueOut() {
              currentUri.cueOut = entry.data;
            },
            'cue-out-cont': function cueOutCont() {
              currentUri.cueOutCont = entry.data;
            },
            'cue-in': function cueIn() {
              currentUri.cueIn = entry.data;
            },
            'skip': function skip() {
              this.manifest.skip = camelCaseKeys(entry.attributes);
              this.warnOnMissingAttributes_('#EXT-X-SKIP', entry.attributes, ['SKIPPED-SEGMENTS']);
            },
            'part': function part() {
              var _this2 = this;
              hasParts = true; // parts are always specifed before a segment

              var segmentIndex = this.manifest.segments.length;
              var part = camelCaseKeys(entry.attributes);
              currentUri.parts = currentUri.parts || [];
              currentUri.parts.push(part);
              if (part.byterange) {
                if (!part.byterange.hasOwnProperty('offset')) {
                  part.byterange.offset = lastPartByterangeEnd;
                }
                lastPartByterangeEnd = part.byterange.offset + part.byterange.length;
              }
              var partIndex = currentUri.parts.length - 1;
              this.warnOnMissingAttributes_("#EXT-X-PART #" + partIndex + " for segment #" + segmentIndex, entry.attributes, ['URI', 'DURATION']);
              if (this.manifest.renditionReports) {
                this.manifest.renditionReports.forEach(function (r, i) {
                  if (!r.hasOwnProperty('lastPart')) {
                    _this2.trigger('warn', {
                      message: "#EXT-X-RENDITION-REPORT #" + i + " lacks required attribute(s): LAST-PART"
                    });
                  }
                });
              }
            },
            'server-control': function serverControl() {
              var attrs = this.manifest.serverControl = camelCaseKeys(entry.attributes);
              if (!attrs.hasOwnProperty('canBlockReload')) {
                attrs.canBlockReload = false;
                this.trigger('info', {
                  message: '#EXT-X-SERVER-CONTROL defaulting CAN-BLOCK-RELOAD to false'
                });
              }
              setHoldBack.call(this, this.manifest);
              if (attrs.canSkipDateranges && !attrs.hasOwnProperty('canSkipUntil')) {
                this.trigger('warn', {
                  message: '#EXT-X-SERVER-CONTROL lacks required attribute CAN-SKIP-UNTIL which is required when CAN-SKIP-DATERANGES is set'
                });
              }
            },
            'preload-hint': function preloadHint() {
              // parts are always specifed before a segment
              var segmentIndex = this.manifest.segments.length;
              var hint = camelCaseKeys(entry.attributes);
              var isPart = hint.type && hint.type === 'PART';
              currentUri.preloadHints = currentUri.preloadHints || [];
              currentUri.preloadHints.push(hint);
              if (hint.byterange) {
                if (!hint.byterange.hasOwnProperty('offset')) {
                  // use last part byterange end or zero if not a part.
                  hint.byterange.offset = isPart ? lastPartByterangeEnd : 0;
                  if (isPart) {
                    lastPartByterangeEnd = hint.byterange.offset + hint.byterange.length;
                  }
                }
              }
              var index = currentUri.preloadHints.length - 1;
              this.warnOnMissingAttributes_("#EXT-X-PRELOAD-HINT #" + index + " for segment #" + segmentIndex, entry.attributes, ['TYPE', 'URI']);
              if (!hint.type) {
                return;
              } // search through all preload hints except for the current one for
              // a duplicate type.

              for (var i = 0; i < currentUri.preloadHints.length - 1; i++) {
                var otherHint = currentUri.preloadHints[i];
                if (!otherHint.type) {
                  continue;
                }
                if (otherHint.type === hint.type) {
                  this.trigger('warn', {
                    message: "#EXT-X-PRELOAD-HINT #" + index + " for segment #" + segmentIndex + " has the same TYPE " + hint.type + " as preload hint #" + i
                  });
                }
              }
            },
            'rendition-report': function renditionReport() {
              var report = camelCaseKeys(entry.attributes);
              this.manifest.renditionReports = this.manifest.renditionReports || [];
              this.manifest.renditionReports.push(report);
              var index = this.manifest.renditionReports.length - 1;
              var required = ['LAST-MSN', 'URI'];
              if (hasParts) {
                required.push('LAST-PART');
              }
              this.warnOnMissingAttributes_("#EXT-X-RENDITION-REPORT #" + index, entry.attributes, required);
            },
            'part-inf': function partInf() {
              this.manifest.partInf = camelCaseKeys(entry.attributes);
              this.warnOnMissingAttributes_('#EXT-X-PART-INF', entry.attributes, ['PART-TARGET']);
              if (this.manifest.partInf.partTarget) {
                this.manifest.partTargetDuration = this.manifest.partInf.partTarget;
              }
              setHoldBack.call(this, this.manifest);
            }
          })[entry.tagType] || noop).call(self);
        },
        uri: function uri() {
          currentUri.uri = entry.uri;
          uris.push(currentUri); // if no explicit duration was declared, use the target duration

          if (this.manifest.targetDuration && !('duration' in currentUri)) {
            this.trigger('warn', {
              message: 'defaulting segment duration to the target duration'
            });
            currentUri.duration = this.manifest.targetDuration;
          } // annotate with encryption information, if necessary

          if (_key) {
            currentUri.key = _key;
          }
          currentUri.timeline = currentTimeline; // annotate with initialization segment information, if necessary

          if (currentMap) {
            currentUri.map = currentMap;
          } // reset the last byterange end as it needs to be 0 between parts

          lastPartByterangeEnd = 0; // prepare for the next URI

          currentUri = {};
        },
        comment: function comment() {// comments are not important for playback
        },
        custom: function custom() {
          // if this is segment-level data attach the output to the segment
          if (entry.segment) {
            currentUri.custom = currentUri.custom || {};
            currentUri.custom[entry.customType] = entry.data; // if this is manifest-level data attach to the top level manifest object
          } else {
            this.manifest.custom = this.manifest.custom || {};
            this.manifest.custom[entry.customType] = entry.data;
          }
        }
      })[entry.type].call(self);
    });
    return _this;
  }
  var _proto = Parser.prototype;
  _proto.warnOnMissingAttributes_ = function warnOnMissingAttributes_(identifier, attributes, required) {
    var missing = [];
    required.forEach(function (key) {
      if (!attributes.hasOwnProperty(key)) {
        missing.push(key);
      }
    });
    if (missing.length) {
      this.trigger('warn', {
        message: identifier + " lacks required attribute(s): " + missing.join(', ')
      });
    }
  }
  /**
   * Parse the input string and update the manifest object.
   *
   * @param {string} chunk a potentially incomplete portion of the manifest
   */;

  _proto.push = function push(chunk) {
    this.lineStream.push(chunk);
  }
  /**
   * Flush any remaining input. This can be handy if the last line of an M3U8
   * manifest did not contain a trailing newline but the file has been
   * completely received.
   */;

  _proto.end = function end() {
    // flush any buffered input
    this.lineStream.push('\n');
    this.trigger('end');
  }
  /**
   * Add an additional parser for non-standard tags
   *
   * @param {Object}   options              a map of options for the added parser
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {string}   options.type         the type to register to the output
   * @param {Function} [options.dataParser] function to parse the line into an object
   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
   */;

  _proto.addParser = function addParser(options) {
    this.parseStream.addParser(options);
  }
  /**
   * Add a custom header mapper
   *
   * @param {Object}   options
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {Function} options.map          function to translate tag into a different tag
   */;

  _proto.addTagMapper = function addTagMapper(options) {
    this.parseStream.addTagMapper(options);
  };
  return Parser;
}(Stream);

;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/codecs.js











var regexs = {
  // to determine mime types
  mp4: /^(av0?1|avc0?[1234]|vp0?9|flac|opus|mp3|mp4a|mp4v|stpp.ttml.im1t)/,
  webm: /^(vp0?[89]|av0?1|opus|vorbis)/,
  ogg: /^(vp0?[89]|theora|flac|opus|vorbis)/,
  // to determine if a codec is audio or video
  video: /^(av0?1|avc0?[1234]|vp0?[89]|hvc1|hev1|theora|mp4v)/,
  audio: /^(mp4a|flac|vorbis|opus|ac-[34]|ec-3|alac|mp3|speex|aac)/,
  text: /^(stpp.ttml.im1t)/,
  // mux.js support regex
  muxerVideo: /^(avc0?1)/,
  muxerAudio: /^(mp4a)/,
  // match nothing as muxer does not support text right now.
  // there cannot never be a character before the start of a string
  // so this matches nothing.
  muxerText: /a^/
};
var mediaTypes = ['video', 'audio', 'text'];
var upperMediaTypes = ['Video', 'Audio', 'Text'];
/**
 * Replace the old apple-style `avc1.<dd>.<dd>` codec string with the standard
 * `avc1.<hhhhhh>`
 *
 * @param {string} codec
 *        Codec string to translate
 * @return {string}
 *         The translated codec string
 */

var translateLegacyCodec = function translateLegacyCodec(codec) {
  if (!codec) {
    return codec;
  }
  return codec.replace(/avc1\.(\d+)\.(\d+)/i, function (orig, profile, avcLevel) {
    var profileHex = ('00' + Number(profile).toString(16)).slice(-2);
    var avcLevelHex = ('00' + Number(avcLevel).toString(16)).slice(-2);
    return 'avc1.' + profileHex + '00' + avcLevelHex;
  });
};
/**
 * Replace the old apple-style `avc1.<dd>.<dd>` codec strings with the standard
 * `avc1.<hhhhhh>`
 *
 * @param {string[]} codecs
 *        An array of codec strings to translate
 * @return {string[]}
 *         The translated array of codec strings
 */

var translateLegacyCodecs = function translateLegacyCodecs(codecs) {
  return codecs.map(translateLegacyCodec);
};
/**
 * Replace codecs in the codec string with the old apple-style `avc1.<dd>.<dd>` to the
 * standard `avc1.<hhhhhh>`.
 *
 * @param {string} codecString
 *        The codec string
 * @return {string}
 *         The codec string with old apple-style codecs replaced
 *
 * @private
 */

var mapLegacyAvcCodecs = function mapLegacyAvcCodecs(codecString) {
  return codecString.replace(/avc1\.(\d+)\.(\d+)/i, function (match) {
    return translateLegacyCodecs([match])[0];
  });
};
/**
 * @typedef {Object} ParsedCodecInfo
 * @property {number} codecCount
 *           Number of codecs parsed
 * @property {string} [videoCodec]
 *           Parsed video codec (if found)
 * @property {string} [videoObjectTypeIndicator]
 *           Video object type indicator (if found)
 * @property {string|null} audioProfile
 *           Audio profile
 */

/**
 * Parses a codec string to retrieve the number of codecs specified, the video codec and
 * object type indicator, and the audio profile.
 *
 * @param {string} [codecString]
 *        The codec string to parse
 * @return {ParsedCodecInfo}
 *         Parsed codec info
 */

var parseCodecs = function parseCodecs(codecString) {
  if (codecString === void 0) {
    codecString = '';
  }
  var codecs = codecString.split(',');
  var result = [];
  codecs.forEach(function (codec) {
    codec = codec.trim();
    var codecType;
    mediaTypes.forEach(function (name) {
      var match = regexs[name].exec(codec.toLowerCase());
      if (!match || match.length <= 1) {
        return;
      }
      codecType = name; // maintain codec case

      var type = codec.substring(0, match[1].length);
      var details = codec.replace(type, '');
      result.push({
        type: type,
        details: details,
        mediaType: name
      });
    });
    if (!codecType) {
      result.push({
        type: codec,
        details: '',
        mediaType: 'unknown'
      });
    }
  });
  return result;
};
/**
 * Returns a ParsedCodecInfo object for the default alternate audio playlist if there is
 * a default alternate audio playlist for the provided audio group.
 *
 * @param {Object} master
 *        The master playlist
 * @param {string} audioGroupId
 *        ID of the audio group for which to find the default codec info
 * @return {ParsedCodecInfo}
 *         Parsed codec info
 */

var codecsFromDefault = function codecsFromDefault(master, audioGroupId) {
  if (!master.mediaGroups.AUDIO || !audioGroupId) {
    return null;
  }
  var audioGroup = master.mediaGroups.AUDIO[audioGroupId];
  if (!audioGroup) {
    return null;
  }
  for (var name in audioGroup) {
    var audioType = audioGroup[name];
    if (audioType.default && audioType.playlists) {
      // codec should be the same for all playlists within the audio type
      return parseCodecs(audioType.playlists[0].attributes.CODECS);
    }
  }
  return null;
};
var isVideoCodec = function isVideoCodec(codec) {
  if (codec === void 0) {
    codec = '';
  }
  return regexs.video.test(codec.trim().toLowerCase());
};
var isAudioCodec = function isAudioCodec(codec) {
  if (codec === void 0) {
    codec = '';
  }
  return regexs.audio.test(codec.trim().toLowerCase());
};
var isTextCodec = function isTextCodec(codec) {
  if (codec === void 0) {
    codec = '';
  }
  return regexs.text.test(codec.trim().toLowerCase());
};
var getMimeForCodec = function getMimeForCodec(codecString) {
  if (!codecString || typeof codecString !== 'string') {
    return;
  }
  var codecs = codecString.toLowerCase().split(',').map(function (c) {
    return translateLegacyCodec(c.trim());
  }); // default to video type

  var type = 'video'; // only change to audio type if the only codec we have is
  // audio

  if (codecs.length === 1 && isAudioCodec(codecs[0])) {
    type = 'audio';
  } else if (codecs.length === 1 && isTextCodec(codecs[0])) {
    // text uses application/<container> for now
    type = 'application';
  } // default the container to mp4

  var container = 'mp4'; // every codec must be able to go into the container
  // for that container to be the correct one

  if (codecs.every(function (c) {
    return regexs.mp4.test(c);
  })) {
    container = 'mp4';
  } else if (codecs.every(function (c) {
    return regexs.webm.test(c);
  })) {
    container = 'webm';
  } else if (codecs.every(function (c) {
    return regexs.ogg.test(c);
  })) {
    container = 'ogg';
  }
  return type + "/" + container + ";codecs=\"" + codecString + "\"";
};
var browserSupportsCodec = function browserSupportsCodec(codecString) {
  if (codecString === void 0) {
    codecString = '';
  }
  return (window_default()).MediaSource && (window_default()).MediaSource.isTypeSupported && window_default().MediaSource.isTypeSupported(getMimeForCodec(codecString)) || false;
};
var muxerSupportsCodec = function muxerSupportsCodec(codecString) {
  if (codecString === void 0) {
    codecString = '';
  }
  return codecString.toLowerCase().split(',').every(function (codec) {
    codec = codec.trim(); // any match is supported.

    for (var i = 0; i < upperMediaTypes.length; i++) {
      var type = upperMediaTypes[i];
      if (regexs["muxer" + type].test(codec)) {
        return true;
      }
    }
    return false;
  });
};
var DEFAULT_AUDIO_CODEC = 'mp4a.40.2';
var DEFAULT_VIDEO_CODEC = 'avc1.4d400d';
;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/media-types.js
var MPEGURL_REGEX = /^(audio|video|application)\/(x-|vnd\.apple\.)?mpegurl/i;
var DASH_REGEX = /^application\/dash\+xml/i;
/**
 * Returns a string that describes the type of source based on a video source object's
 * media type.
 *
 * @see {@link https://dev.w3.org/html5/pf-summary/video.html#dom-source-type|Source Type}
 *
 * @param {string} type
 *        Video source object media type
 * @return {('hls'|'dash'|'vhs-json'|null)}
 *         VHS source type string
 */

var simpleTypeFromSourceType = function simpleTypeFromSourceType(type) {
  if (MPEGURL_REGEX.test(type)) {
    return 'hls';
  }
  if (DASH_REGEX.test(type)) {
    return 'dash';
  } // Denotes the special case of a manifest object passed to http-streaming instead of a
  // source URL.
  //
  // See https://en.wikipedia.org/wiki/Media_type for details on specifying media types.
  //
  // In this case, vnd stands for vendor, video.js for the organization, VHS for this
  // project, and the +json suffix identifies the structure of the media type.

  if (type === 'application/vnd.videojs.vhs+json') {
    return 'vhs-json';
  }
  return null;
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.uint16-array.js
var es_typed_array_uint16_array = __webpack_require__(8255);
;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/byte-helpers.js

































 // const log2 = Math.log2 ? Math.log2 : (x) => (Math.log(x) / Math.log(2));

var repeat = function repeat(str, len) {
  var acc = '';
  while (len--) {
    acc += str;
  }
  return acc;
}; // count the number of bits it would take to represent a number
// we used to do this with log2 but BigInt does not support builtin math
// Math.ceil(log2(x));

var countBits = function countBits(x) {
  return x.toString(2).length;
}; // count the number of whole bytes it would take to represent a number

var countBytes = function countBytes(x) {
  return Math.ceil(countBits(x) / 8);
};
var byte_helpers_padStart = function padStart(b, len, str) {
  if (str === void 0) {
    str = ' ';
  }
  return (repeat(str, len) + b.toString()).slice(-len);
};
var isArrayBufferView = function isArrayBufferView(obj) {
  if (ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(obj);
  }
  return obj && obj.buffer instanceof ArrayBuffer;
};
var isTypedArray = function isTypedArray(obj) {
  return isArrayBufferView(obj);
};
var byte_helpers_toUint8 = function toUint8(bytes) {
  if (bytes instanceof Uint8Array) {
    return bytes;
  }
  if (!Array.isArray(bytes) && !isTypedArray(bytes) && !(bytes instanceof ArrayBuffer)) {
    // any non-number or NaN leads to empty uint8array
    // eslint-disable-next-line
    if (typeof bytes !== 'number' || typeof bytes === 'number' && bytes !== bytes) {
      bytes = 0;
    } else {
      bytes = [bytes];
    }
  }
  return new Uint8Array(bytes && bytes.buffer || bytes, bytes && bytes.byteOffset || 0, bytes && bytes.byteLength || 0);
};
var byte_helpers_toHexString = function toHexString(bytes) {
  bytes = byte_helpers_toUint8(bytes);
  var str = '';
  for (var i = 0; i < bytes.length; i++) {
    str += byte_helpers_padStart(bytes[i].toString(16), 2, '0');
  }
  return str;
};
var byte_helpers_toBinaryString = function toBinaryString(bytes) {
  bytes = byte_helpers_toUint8(bytes);
  var str = '';
  for (var i = 0; i < bytes.length; i++) {
    str += byte_helpers_padStart(bytes[i].toString(2), 8, '0');
  }
  return str;
};
var BigInt = (window_default()).BigInt || Number;
var BYTE_TABLE = [BigInt('0x1'), BigInt('0x100'), BigInt('0x10000'), BigInt('0x1000000'), BigInt('0x100000000'), BigInt('0x10000000000'), BigInt('0x1000000000000'), BigInt('0x100000000000000'), BigInt('0x10000000000000000')];
var ENDIANNESS = function () {
  var a = new Uint16Array([0xFFCC]);
  var b = new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
  if (b[0] === 0xFF) {
    return 'big';
  }
  if (b[0] === 0xCC) {
    return 'little';
  }
  return 'unknown';
}();
var IS_BIG_ENDIAN = ENDIANNESS === 'big';
var IS_LITTLE_ENDIAN = ENDIANNESS === 'little';
var byte_helpers_bytesToNumber = function bytesToNumber(bytes, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$signed = _ref.signed,
    signed = _ref$signed === void 0 ? false : _ref$signed,
    _ref$le = _ref.le,
    le = _ref$le === void 0 ? false : _ref$le;
  bytes = byte_helpers_toUint8(bytes);
  var fn = le ? 'reduce' : 'reduceRight';
  var obj = bytes[fn] ? bytes[fn] : Array.prototype[fn];
  var number = obj.call(bytes, function (total, byte, i) {
    var exponent = le ? i : Math.abs(i + 1 - bytes.length);
    return total + BigInt(byte) * BYTE_TABLE[exponent];
  }, BigInt(0));
  if (signed) {
    var max = BYTE_TABLE[bytes.length] / BigInt(2) - BigInt(1);
    number = BigInt(number);
    if (number > max) {
      number -= max;
      number -= max;
      number -= BigInt(2);
    }
  }
  return Number(number);
};
var numberToBytes = function numberToBytes(number, _temp2) {
  var _ref2 = _temp2 === void 0 ? {} : _temp2,
    _ref2$le = _ref2.le,
    le = _ref2$le === void 0 ? false : _ref2$le;

  // eslint-disable-next-line
  if (typeof number !== 'bigint' && typeof number !== 'number' || typeof number === 'number' && number !== number) {
    number = 0;
  }
  number = BigInt(number);
  var byteCount = countBytes(number);
  var bytes = new Uint8Array(new ArrayBuffer(byteCount));
  for (var i = 0; i < byteCount; i++) {
    var byteIndex = le ? i : Math.abs(i + 1 - bytes.length);
    bytes[byteIndex] = Number(number / BYTE_TABLE[i] & BigInt(0xFF));
    if (number < 0) {
      bytes[byteIndex] = Math.abs(~bytes[byteIndex]);
      bytes[byteIndex] -= i === 0 ? 1 : 2;
    }
  }
  return bytes;
};
var byte_helpers_bytesToString = function bytesToString(bytes) {
  if (!bytes) {
    return '';
  } // TODO: should toUint8 handle cases where we only have 8 bytes
  // but report more since this is a Uint16+ Array?

  bytes = Array.prototype.slice.call(bytes);
  var string = String.fromCharCode.apply(null, byte_helpers_toUint8(bytes));
  try {
    return decodeURIComponent(escape(string));
  } catch (e) {// if decodeURIComponent/escape fails, we are dealing with partial
    // or full non string data. Just return the potentially garbled string.
  }
  return string;
};
var stringToBytes = function stringToBytes(string, stringIsBytes) {
  if (typeof string !== 'string' && string && typeof string.toString === 'function') {
    string = string.toString();
  }
  if (typeof string !== 'string') {
    return new Uint8Array();
  } // If the string already is bytes, we don't have to do this
  // otherwise we do this so that we split multi length characters
  // into individual bytes

  if (!stringIsBytes) {
    string = unescape(encodeURIComponent(string));
  }
  var view = new Uint8Array(string.length);
  for (var i = 0; i < string.length; i++) {
    view[i] = string.charCodeAt(i);
  }
  return view;
};
var concatTypedArrays = function concatTypedArrays() {
  for (var _len = arguments.length, buffers = new Array(_len), _key = 0; _key < _len; _key++) {
    buffers[_key] = arguments[_key];
  }
  buffers = buffers.filter(function (b) {
    return b && (b.byteLength || b.length) && typeof b !== 'string';
  });
  if (buffers.length <= 1) {
    // for 0 length we will return empty uint8
    // for 1 length we return the first uint8
    return byte_helpers_toUint8(buffers[0]);
  }
  var totalLen = buffers.reduce(function (total, buf, i) {
    return total + (buf.byteLength || buf.length);
  }, 0);
  var tempBuffer = new Uint8Array(totalLen);
  var offset = 0;
  buffers.forEach(function (buf) {
    buf = byte_helpers_toUint8(buf);
    tempBuffer.set(buf, offset);
    offset += buf.byteLength;
  });
  return tempBuffer;
};
/**
 * Check if the bytes "b" are contained within bytes "a".
 *
 * @param {Uint8Array|Array} a
 *        Bytes to check in
 *
 * @param {Uint8Array|Array} b
 *        Bytes to check for
 *
 * @param {Object} options
 *        options
 *
 * @param {Array|Uint8Array} [offset=0]
 *        offset to use when looking at bytes in a
 *
 * @param {Array|Uint8Array} [mask=[]]
 *        mask to use on bytes before comparison.
 *
 * @return {boolean}
 *         If all bytes in b are inside of a, taking into account
 *         bit masks.
 */

var byte_helpers_bytesMatch = function bytesMatch(a, b, _temp3) {
  var _ref3 = _temp3 === void 0 ? {} : _temp3,
    _ref3$offset = _ref3.offset,
    offset = _ref3$offset === void 0 ? 0 : _ref3$offset,
    _ref3$mask = _ref3.mask,
    mask = _ref3$mask === void 0 ? [] : _ref3$mask;
  a = byte_helpers_toUint8(a);
  b = byte_helpers_toUint8(b); // ie 11 does not support uint8 every

  var fn = b.every ? b.every : Array.prototype.every;
  return b.length && a.length - offset >= b.length &&
  // ie 11 doesn't support every on uin8
  fn.call(b, function (bByte, i) {
    var aByte = mask[i] ? mask[i] & a[offset + i] : a[offset + i];
    return bByte === aByte;
  });
};
var sliceBytes = function sliceBytes(src, start, end) {
  if (Uint8Array.prototype.slice) {
    return Uint8Array.prototype.slice.call(src, start, end);
  }
  return new Uint8Array(Array.prototype.slice.call(src, start, end));
};
var reverseBytes = function reverseBytes(src) {
  if (src.reverse) {
    return src.reverse();
  }
  return Array.prototype.reverse.call(src);
};
;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/media-groups.js

/**
 * Loops through all supported media groups in master and calls the provided
 * callback for each group
 *
 * @param {Object} master
 *        The parsed master manifest object
 * @param {string[]} groups
 *        The media groups to call the callback for
 * @param {Function} callback
 *        Callback to call for each media group
 */
var forEachMediaGroup = function forEachMediaGroup(master, groups, callback) {
  groups.forEach(function (mediaType) {
    for (var groupKey in master.mediaGroups[mediaType]) {
      for (var labelKey in master.mediaGroups[mediaType][groupKey]) {
        var mediaProperties = master.mediaGroups[mediaType][groupKey][labelKey];
        callback(mediaProperties, mediaType, groupKey, labelKey);
      }
    }
  });
};
// EXTERNAL MODULE: ./node_modules/@xmldom/xmldom/lib/index.js
var xmldom_lib = __webpack_require__(23399);
;// CONCATENATED MODULE: ./node_modules/mpd-parser/dist/mpd-parser.es.js






















function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
/*! @name mpd-parser @version 0.22.1 @license Apache-2.0 */





var version = "0.22.1";
var isObject = function isObject(obj) {
  return !!obj && _typeof(obj) === 'object';
};
var merge = function merge() {
  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }
  return objects.reduce(function (result, source) {
    if (_typeof(source) !== 'object') {
      return result;
    }
    Object.keys(source).forEach(function (key) {
      if (Array.isArray(result[key]) && Array.isArray(source[key])) {
        result[key] = result[key].concat(source[key]);
      } else if (isObject(result[key]) && isObject(source[key])) {
        result[key] = merge(result[key], source[key]);
      } else {
        result[key] = source[key];
      }
    });
    return result;
  }, {});
};
var values = function values(o) {
  return Object.keys(o).map(function (k) {
    return o[k];
  });
};
var range = function range(start, end) {
  var result = [];
  for (var i = start; i < end; i++) {
    result.push(i);
  }
  return result;
};
var flatten = function flatten(lists) {
  return lists.reduce(function (x, y) {
    return x.concat(y);
  }, []);
};
var from = function from(list) {
  if (!list.length) {
    return [];
  }
  var result = [];
  for (var i = 0; i < list.length; i++) {
    result.push(list[i]);
  }
  return result;
};
var findIndexes = function findIndexes(l, key) {
  return l.reduce(function (a, e, i) {
    if (e[key]) {
      a.push(i);
    }
    return a;
  }, []);
};
/**
 * Returns the first index that satisfies the matching function, or -1 if not found.
 *
 * Only necessary because of IE11 support.
 *
 * @param {Array} list - the list to search through
 * @param {Function} matchingFunction - the matching function
 *
 * @return {number} the matching index or -1 if not found
 */

var findIndex = function findIndex(list, matchingFunction) {
  for (var i = 0; i < list.length; i++) {
    if (matchingFunction(list[i])) {
      return i;
    }
  }
  return -1;
};
/**
 * Returns a union of the included lists provided each element can be identified by a key.
 *
 * @param {Array} list - list of lists to get the union of
 * @param {Function} keyFunction - the function to use as a key for each element
 *
 * @return {Array} the union of the arrays
 */

var union = function union(lists, keyFunction) {
  return values(lists.reduce(function (acc, list) {
    list.forEach(function (el) {
      acc[keyFunction(el)] = el;
    });
    return acc;
  }, {}));
};
var errors = {
  INVALID_NUMBER_OF_PERIOD: 'INVALID_NUMBER_OF_PERIOD',
  DASH_EMPTY_MANIFEST: 'DASH_EMPTY_MANIFEST',
  DASH_INVALID_XML: 'DASH_INVALID_XML',
  NO_BASE_URL: 'NO_BASE_URL',
  MISSING_SEGMENT_INFORMATION: 'MISSING_SEGMENT_INFORMATION',
  SEGMENT_TIME_UNSPECIFIED: 'SEGMENT_TIME_UNSPECIFIED',
  UNSUPPORTED_UTC_TIMING_SCHEME: 'UNSUPPORTED_UTC_TIMING_SCHEME'
};

/**
 * @typedef {Object} SingleUri
 * @property {string} uri - relative location of segment
 * @property {string} resolvedUri - resolved location of segment
 * @property {Object} byterange - Object containing information on how to make byte range
 *   requests following byte-range-spec per RFC2616.
 * @property {String} byterange.length - length of range request
 * @property {String} byterange.offset - byte offset of range request
 *
 * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec14.html#sec14.35.1
 */

/**
 * Converts a URLType node (5.3.9.2.3 Table 13) to a segment object
 * that conforms to how m3u8-parser is structured
 *
 * @see https://github.com/videojs/m3u8-parser
 *
 * @param {string} baseUrl - baseUrl provided by <BaseUrl> nodes
 * @param {string} source - source url for segment
 * @param {string} range - optional range used for range calls,
 *   follows  RFC 2616, Clause 14.35.1
 * @return {SingleUri} full segment information transformed into a format similar
 *   to m3u8-parser
 */

var urlTypeToSegment = function urlTypeToSegment(_ref) {
  var _ref$baseUrl = _ref.baseUrl,
    baseUrl = _ref$baseUrl === void 0 ? '' : _ref$baseUrl,
    _ref$source = _ref.source,
    source = _ref$source === void 0 ? '' : _ref$source,
    _ref$range = _ref.range,
    range = _ref$range === void 0 ? '' : _ref$range,
    _ref$indexRange = _ref.indexRange,
    indexRange = _ref$indexRange === void 0 ? '' : _ref$indexRange;
  var segment = {
    uri: source,
    resolvedUri: resolve_url(baseUrl || '', source)
  };
  if (range || indexRange) {
    var rangeStr = range ? range : indexRange;
    var ranges = rangeStr.split('-'); // default to parsing this as a BigInt if possible

    var startRange = (window_default()).BigInt ? window_default().BigInt(ranges[0]) : parseInt(ranges[0], 10);
    var endRange = (window_default()).BigInt ? window_default().BigInt(ranges[1]) : parseInt(ranges[1], 10); // convert back to a number if less than MAX_SAFE_INTEGER

    if (startRange < Number.MAX_SAFE_INTEGER && typeof startRange === 'bigint') {
      startRange = Number(startRange);
    }
    if (endRange < Number.MAX_SAFE_INTEGER && typeof endRange === 'bigint') {
      endRange = Number(endRange);
    }
    var length;
    if (typeof endRange === 'bigint' || typeof startRange === 'bigint') {
      length = window_default().BigInt(endRange) - window_default().BigInt(startRange) + window_default().BigInt(1);
    } else {
      length = endRange - startRange + 1;
    }
    if (typeof length === 'bigint' && length < Number.MAX_SAFE_INTEGER) {
      length = Number(length);
    } // byterange should be inclusive according to
    // RFC 2616, Clause 14.35.1

    segment.byterange = {
      length: length,
      offset: startRange
    };
  }
  return segment;
};
var byteRangeToString = function byteRangeToString(byterange) {
  // `endRange` is one less than `offset + length` because the HTTP range
  // header uses inclusive ranges
  var endRange;
  if (typeof byterange.offset === 'bigint' || typeof byterange.length === 'bigint') {
    endRange = window_default().BigInt(byterange.offset) + window_default().BigInt(byterange.length) - window_default().BigInt(1);
  } else {
    endRange = byterange.offset + byterange.length - 1;
  }
  return byterange.offset + "-" + endRange;
};

/**
 * parse the end number attribue that can be a string
 * number, or undefined.
 *
 * @param {string|number|undefined} endNumber
 *        The end number attribute.
 *
 * @return {number|null}
 *          The result of parsing the end number.
 */

var parseEndNumber = function parseEndNumber(endNumber) {
  if (endNumber && typeof endNumber !== 'number') {
    endNumber = parseInt(endNumber, 10);
  }
  if (isNaN(endNumber)) {
    return null;
  }
  return endNumber;
};
/**
 * Functions for calculating the range of available segments in static and dynamic
 * manifests.
 */

var segmentRange = {
  /**
   * Returns the entire range of available segments for a static MPD
   *
   * @param {Object} attributes
   *        Inheritied MPD attributes
   * @return {{ start: number, end: number }}
   *         The start and end numbers for available segments
   */
  static: function _static(attributes) {
    var duration = attributes.duration,
      _attributes$timescale = attributes.timescale,
      timescale = _attributes$timescale === void 0 ? 1 : _attributes$timescale,
      sourceDuration = attributes.sourceDuration,
      periodDuration = attributes.periodDuration;
    var endNumber = parseEndNumber(attributes.endNumber);
    var segmentDuration = duration / timescale;
    if (typeof endNumber === 'number') {
      return {
        start: 0,
        end: endNumber
      };
    }
    if (typeof periodDuration === 'number') {
      return {
        start: 0,
        end: periodDuration / segmentDuration
      };
    }
    return {
      start: 0,
      end: sourceDuration / segmentDuration
    };
  },
  /**
   * Returns the current live window range of available segments for a dynamic MPD
   *
   * @param {Object} attributes
   *        Inheritied MPD attributes
   * @return {{ start: number, end: number }}
   *         The start and end numbers for available segments
   */
  dynamic: function dynamic(attributes) {
    var NOW = attributes.NOW,
      clientOffset = attributes.clientOffset,
      availabilityStartTime = attributes.availabilityStartTime,
      _attributes$timescale2 = attributes.timescale,
      timescale = _attributes$timescale2 === void 0 ? 1 : _attributes$timescale2,
      duration = attributes.duration,
      _attributes$periodSta = attributes.periodStart,
      periodStart = _attributes$periodSta === void 0 ? 0 : _attributes$periodSta,
      _attributes$minimumUp = attributes.minimumUpdatePeriod,
      minimumUpdatePeriod = _attributes$minimumUp === void 0 ? 0 : _attributes$minimumUp,
      _attributes$timeShift = attributes.timeShiftBufferDepth,
      timeShiftBufferDepth = _attributes$timeShift === void 0 ? Infinity : _attributes$timeShift;
    var endNumber = parseEndNumber(attributes.endNumber); // clientOffset is passed in at the top level of mpd-parser and is an offset calculated
    // after retrieving UTC server time.

    var now = (NOW + clientOffset) / 1000; // WC stands for Wall Clock.
    // Convert the period start time to EPOCH.

    var periodStartWC = availabilityStartTime + periodStart; // Period end in EPOCH is manifest's retrieval time + time until next update.

    var periodEndWC = now + minimumUpdatePeriod;
    var periodDuration = periodEndWC - periodStartWC;
    var segmentCount = Math.ceil(periodDuration * timescale / duration);
    var availableStart = Math.floor((now - periodStartWC - timeShiftBufferDepth) * timescale / duration);
    var availableEnd = Math.floor((now - periodStartWC) * timescale / duration);
    return {
      start: Math.max(0, availableStart),
      end: typeof endNumber === 'number' ? endNumber : Math.min(segmentCount, availableEnd)
    };
  }
};
/**
 * Maps a range of numbers to objects with information needed to build the corresponding
 * segment list
 *
 * @name toSegmentsCallback
 * @function
 * @param {number} number
 *        Number of the segment
 * @param {number} index
 *        Index of the number in the range list
 * @return {{ number: Number, duration: Number, timeline: Number, time: Number }}
 *         Object with segment timing and duration info
 */

/**
 * Returns a callback for Array.prototype.map for mapping a range of numbers to
 * information needed to build the segment list.
 *
 * @param {Object} attributes
 *        Inherited MPD attributes
 * @return {toSegmentsCallback}
 *         Callback map function
 */

var toSegments = function toSegments(attributes) {
  return function (number) {
    var duration = attributes.duration,
      _attributes$timescale3 = attributes.timescale,
      timescale = _attributes$timescale3 === void 0 ? 1 : _attributes$timescale3,
      periodStart = attributes.periodStart,
      _attributes$startNumb = attributes.startNumber,
      startNumber = _attributes$startNumb === void 0 ? 1 : _attributes$startNumb;
    return {
      number: startNumber + number,
      duration: duration / timescale,
      timeline: periodStart,
      time: number * duration
    };
  };
};
/**
 * Returns a list of objects containing segment timing and duration info used for
 * building the list of segments. This uses the @duration attribute specified
 * in the MPD manifest to derive the range of segments.
 *
 * @param {Object} attributes
 *        Inherited MPD attributes
 * @return {{number: number, duration: number, time: number, timeline: number}[]}
 *         List of Objects with segment timing and duration info
 */

var parseByDuration = function parseByDuration(attributes) {
  var type = attributes.type,
    duration = attributes.duration,
    _attributes$timescale4 = attributes.timescale,
    timescale = _attributes$timescale4 === void 0 ? 1 : _attributes$timescale4,
    periodDuration = attributes.periodDuration,
    sourceDuration = attributes.sourceDuration;
  var _segmentRange$type = segmentRange[type](attributes),
    start = _segmentRange$type.start,
    end = _segmentRange$type.end;
  var segments = range(start, end).map(toSegments(attributes));
  if (type === 'static') {
    var index = segments.length - 1; // section is either a period or the full source

    var sectionDuration = typeof periodDuration === 'number' ? periodDuration : sourceDuration; // final segment may be less than full segment duration

    segments[index].duration = sectionDuration - duration / timescale * index;
  }
  return segments;
};

/**
 * Translates SegmentBase into a set of segments.
 * (DASH SPEC Section 5.3.9.3.2) contains a set of <SegmentURL> nodes.  Each
 * node should be translated into segment.
 *
 * @param {Object} attributes
 *   Object containing all inherited attributes from parent elements with attribute
 *   names as keys
 * @return {Object.<Array>} list of segments
 */

var segmentsFromBase = function segmentsFromBase(attributes) {
  var baseUrl = attributes.baseUrl,
    _attributes$initializ = attributes.initialization,
    initialization = _attributes$initializ === void 0 ? {} : _attributes$initializ,
    sourceDuration = attributes.sourceDuration,
    _attributes$indexRang = attributes.indexRange,
    indexRange = _attributes$indexRang === void 0 ? '' : _attributes$indexRang,
    periodStart = attributes.periodStart,
    presentationTime = attributes.presentationTime,
    _attributes$number = attributes.number,
    number = _attributes$number === void 0 ? 0 : _attributes$number,
    duration = attributes.duration; // base url is required for SegmentBase to work, per spec (Section 5.3.9.2.1)

  if (!baseUrl) {
    throw new Error(errors.NO_BASE_URL);
  }
  var initSegment = urlTypeToSegment({
    baseUrl: baseUrl,
    source: initialization.sourceURL,
    range: initialization.range
  });
  var segment = urlTypeToSegment({
    baseUrl: baseUrl,
    source: baseUrl,
    indexRange: indexRange
  });
  segment.map = initSegment; // If there is a duration, use it, otherwise use the given duration of the source
  // (since SegmentBase is only for one total segment)

  if (duration) {
    var segmentTimeInfo = parseByDuration(attributes);
    if (segmentTimeInfo.length) {
      segment.duration = segmentTimeInfo[0].duration;
      segment.timeline = segmentTimeInfo[0].timeline;
    }
  } else if (sourceDuration) {
    segment.duration = sourceDuration;
    segment.timeline = periodStart;
  } // If presentation time is provided, these segments are being generated by SIDX
  // references, and should use the time provided. For the general case of SegmentBase,
  // there should only be one segment in the period, so its presentation time is the same
  // as its period start.

  segment.presentationTime = presentationTime || periodStart;
  segment.number = number;
  return [segment];
};
/**
 * Given a playlist, a sidx box, and a baseUrl, update the segment list of the playlist
 * according to the sidx information given.
 *
 * playlist.sidx has metadadata about the sidx where-as the sidx param
 * is the parsed sidx box itself.
 *
 * @param {Object} playlist the playlist to update the sidx information for
 * @param {Object} sidx the parsed sidx box
 * @return {Object} the playlist object with the updated sidx information
 */

var addSidxSegmentsToPlaylist$1 = function addSidxSegmentsToPlaylist(playlist, sidx, baseUrl) {
  // Retain init segment information
  var initSegment = playlist.sidx.map ? playlist.sidx.map : null; // Retain source duration from initial main manifest parsing

  var sourceDuration = playlist.sidx.duration; // Retain source timeline

  var timeline = playlist.timeline || 0;
  var sidxByteRange = playlist.sidx.byterange;
  var sidxEnd = sidxByteRange.offset + sidxByteRange.length; // Retain timescale of the parsed sidx

  var timescale = sidx.timescale; // referenceType 1 refers to other sidx boxes

  var mediaReferences = sidx.references.filter(function (r) {
    return r.referenceType !== 1;
  });
  var segments = [];
  var type = playlist.endList ? 'static' : 'dynamic';
  var periodStart = playlist.sidx.timeline;
  var presentationTime = periodStart;
  var number = playlist.mediaSequence || 0; // firstOffset is the offset from the end of the sidx box

  var startIndex; // eslint-disable-next-line

  if (typeof sidx.firstOffset === 'bigint') {
    startIndex = window_default().BigInt(sidxEnd) + sidx.firstOffset;
  } else {
    startIndex = sidxEnd + sidx.firstOffset;
  }
  for (var i = 0; i < mediaReferences.length; i++) {
    var reference = sidx.references[i]; // size of the referenced (sub)segment

    var size = reference.referencedSize; // duration of the referenced (sub)segment, in  the  timescale
    // this will be converted to seconds when generating segments

    var duration = reference.subsegmentDuration; // should be an inclusive range

    var endIndex = void 0; // eslint-disable-next-line

    if (typeof startIndex === 'bigint') {
      endIndex = startIndex + window_default().BigInt(size) - window_default().BigInt(1);
    } else {
      endIndex = startIndex + size - 1;
    }
    var indexRange = startIndex + "-" + endIndex;
    var attributes = {
      baseUrl: baseUrl,
      timescale: timescale,
      timeline: timeline,
      periodStart: periodStart,
      presentationTime: presentationTime,
      number: number,
      duration: duration,
      sourceDuration: sourceDuration,
      indexRange: indexRange,
      type: type
    };
    var segment = segmentsFromBase(attributes)[0];
    if (initSegment) {
      segment.map = initSegment;
    }
    segments.push(segment);
    if (typeof startIndex === 'bigint') {
      startIndex += window_default().BigInt(size);
    } else {
      startIndex += size;
    }
    presentationTime += duration / timescale;
    number++;
  }
  playlist.segments = segments;
  return playlist;
};
var SUPPORTED_MEDIA_TYPES = ['AUDIO', 'SUBTITLES']; // allow one 60fps frame as leniency (arbitrarily chosen)

var TIME_FUDGE = 1 / 60;
/**
 * Given a list of timelineStarts, combines, dedupes, and sorts them.
 *
 * @param {TimelineStart[]} timelineStarts - list of timeline starts
 *
 * @return {TimelineStart[]} the combined and deduped timeline starts
 */

var getUniqueTimelineStarts = function getUniqueTimelineStarts(timelineStarts) {
  return union(timelineStarts, function (_ref) {
    var timeline = _ref.timeline;
    return timeline;
  }).sort(function (a, b) {
    return a.timeline > b.timeline ? 1 : -1;
  });
};
/**
 * Finds the playlist with the matching NAME attribute.
 *
 * @param {Array} playlists - playlists to search through
 * @param {string} name - the NAME attribute to search for
 *
 * @return {Object|null} the matching playlist object, or null
 */

var findPlaylistWithName = function findPlaylistWithName(playlists, name) {
  for (var i = 0; i < playlists.length; i++) {
    if (playlists[i].attributes.NAME === name) {
      return playlists[i];
    }
  }
  return null;
};
/**
 * Gets a flattened array of media group playlists.
 *
 * @param {Object} manifest - the main manifest object
 *
 * @return {Array} the media group playlists
 */

var getMediaGroupPlaylists = function getMediaGroupPlaylists(manifest) {
  var mediaGroupPlaylists = [];
  forEachMediaGroup(manifest, SUPPORTED_MEDIA_TYPES, function (properties, type, group, label) {
    mediaGroupPlaylists = mediaGroupPlaylists.concat(properties.playlists || []);
  });
  return mediaGroupPlaylists;
};
/**
 * Updates the playlist's media sequence numbers.
 *
 * @param {Object} config - options object
 * @param {Object} config.playlist - the playlist to update
 * @param {number} config.mediaSequence - the mediaSequence number to start with
 */

var updateMediaSequenceForPlaylist = function updateMediaSequenceForPlaylist(_ref2) {
  var playlist = _ref2.playlist,
    mediaSequence = _ref2.mediaSequence;
  playlist.mediaSequence = mediaSequence;
  playlist.segments.forEach(function (segment, index) {
    segment.number = playlist.mediaSequence + index;
  });
};
/**
 * Updates the media and discontinuity sequence numbers of newPlaylists given oldPlaylists
 * and a complete list of timeline starts.
 *
 * If no matching playlist is found, only the discontinuity sequence number of the playlist
 * will be updated.
 *
 * Since early available timelines are not supported, at least one segment must be present.
 *
 * @param {Object} config - options object
 * @param {Object[]} oldPlaylists - the old playlists to use as a reference
 * @param {Object[]} newPlaylists - the new playlists to update
 * @param {Object} timelineStarts - all timelineStarts seen in the stream to this point
 */

var updateSequenceNumbers = function updateSequenceNumbers(_ref3) {
  var oldPlaylists = _ref3.oldPlaylists,
    newPlaylists = _ref3.newPlaylists,
    timelineStarts = _ref3.timelineStarts;
  newPlaylists.forEach(function (playlist) {
    playlist.discontinuitySequence = findIndex(timelineStarts, function (_ref4) {
      var timeline = _ref4.timeline;
      return timeline === playlist.timeline;
    }); // Playlists NAMEs come from DASH Representation IDs, which are mandatory
    // (see ISO_23009-1-2012 5.3.5.2).
    //
    // If the same Representation existed in a prior Period, it will retain the same NAME.

    var oldPlaylist = findPlaylistWithName(oldPlaylists, playlist.attributes.NAME);
    if (!oldPlaylist) {
      // Since this is a new playlist, the media sequence values can start from 0 without
      // consequence.
      return;
    } // TODO better support for live SIDX
    //
    // As of this writing, mpd-parser does not support multiperiod SIDX (in live or VOD).
    // This is evident by a playlist only having a single SIDX reference. In a multiperiod
    // playlist there would need to be multiple SIDX references. In addition, live SIDX is
    // not supported when the SIDX properties change on refreshes.
    //
    // In the future, if support needs to be added, the merging logic here can be called
    // after SIDX references are resolved. For now, exit early to prevent exceptions being
    // thrown due to undefined references.

    if (playlist.sidx) {
      return;
    } // Since we don't yet support early available timelines, we don't need to support
    // playlists with no segments.

    var firstNewSegment = playlist.segments[0];
    var oldMatchingSegmentIndex = findIndex(oldPlaylist.segments, function (oldSegment) {
      return Math.abs(oldSegment.presentationTime - firstNewSegment.presentationTime) < TIME_FUDGE;
    }); // No matching segment from the old playlist means the entire playlist was refreshed.
    // In this case the media sequence should account for this update, and the new segments
    // should be marked as discontinuous from the prior content, since the last prior
    // timeline was removed.

    if (oldMatchingSegmentIndex === -1) {
      updateMediaSequenceForPlaylist({
        playlist: playlist,
        mediaSequence: oldPlaylist.mediaSequence + oldPlaylist.segments.length
      });
      playlist.segments[0].discontinuity = true;
      playlist.discontinuityStarts.unshift(0); // No matching segment does not necessarily mean there's missing content.
      //
      // If the new playlist's timeline is the same as the last seen segment's timeline,
      // then a discontinuity can be added to identify that there's potentially missing
      // content. If there's no missing content, the discontinuity should still be rather
      // harmless. It's possible that if segment durations are accurate enough, that the
      // existence of a gap can be determined using the presentation times and durations,
      // but if the segment timing info is off, it may introduce more problems than simply
      // adding the discontinuity.
      //
      // If the new playlist's timeline is different from the last seen segment's timeline,
      // then a discontinuity can be added to identify that this is the first seen segment
      // of a new timeline. However, the logic at the start of this function that
      // determined the disconinuity sequence by timeline index is now off by one (the
      // discontinuity of the newest timeline hasn't yet fallen off the manifest...since
      // we added it), so the disconinuity sequence must be decremented.
      //
      // A period may also have a duration of zero, so the case of no segments is handled
      // here even though we don't yet support early available periods.

      if (!oldPlaylist.segments.length && playlist.timeline > oldPlaylist.timeline || oldPlaylist.segments.length && playlist.timeline > oldPlaylist.segments[oldPlaylist.segments.length - 1].timeline) {
        playlist.discontinuitySequence--;
      }
      return;
    } // If the first segment matched with a prior segment on a discontinuity (it's matching
    // on the first segment of a period), then the discontinuitySequence shouldn't be the
    // timeline's matching one, but instead should be the one prior, and the first segment
    // of the new manifest should be marked with a discontinuity.
    //
    // The reason for this special case is that discontinuity sequence shows how many
    // discontinuities have fallen off of the playlist, and discontinuities are marked on
    // the first segment of a new "timeline." Because of this, while DASH will retain that
    // Period while the "timeline" exists, HLS keeps track of it via the discontinuity
    // sequence, and that first segment is an indicator, but can be removed before that
    // timeline is gone.

    var oldMatchingSegment = oldPlaylist.segments[oldMatchingSegmentIndex];
    if (oldMatchingSegment.discontinuity && !firstNewSegment.discontinuity) {
      firstNewSegment.discontinuity = true;
      playlist.discontinuityStarts.unshift(0);
      playlist.discontinuitySequence--;
    }
    updateMediaSequenceForPlaylist({
      playlist: playlist,
      mediaSequence: oldPlaylist.segments[oldMatchingSegmentIndex].number
    });
  });
};
/**
 * Given an old parsed manifest object and a new parsed manifest object, updates the
 * sequence and timing values within the new manifest to ensure that it lines up with the
 * old.
 *
 * @param {Array} oldManifest - the old main manifest object
 * @param {Array} newManifest - the new main manifest object
 *
 * @return {Object} the updated new manifest object
 */

var positionManifestOnTimeline = function positionManifestOnTimeline(_ref5) {
  var oldManifest = _ref5.oldManifest,
    newManifest = _ref5.newManifest;
  // Starting from v4.1.2 of the IOP, section 4.4.3.3 states:
  //
  // "MPD@availabilityStartTime and Period@start shall not be changed over MPD updates."
  //
  // This was added from https://github.com/Dash-Industry-Forum/DASH-IF-IOP/issues/160
  //
  // Because of this change, and the difficulty of supporting periods with changing start
  // times, periods with changing start times are not supported. This makes the logic much
  // simpler, since periods with the same start time can be considerred the same period
  // across refreshes.
  //
  // To give an example as to the difficulty of handling periods where the start time may
  // change, if a single period manifest is refreshed with another manifest with a single
  // period, and both the start and end times are increased, then the only way to determine
  // if it's a new period or an old one that has changed is to look through the segments of
  // each playlist and determine the presentation time bounds to find a match. In addition,
  // if the period start changed to exceed the old period end, then there would be no
  // match, and it would not be possible to determine whether the refreshed period is a new
  // one or the old one.
  var oldPlaylists = oldManifest.playlists.concat(getMediaGroupPlaylists(oldManifest));
  var newPlaylists = newManifest.playlists.concat(getMediaGroupPlaylists(newManifest)); // Save all seen timelineStarts to the new manifest. Although this potentially means that
  // there's a "memory leak" in that it will never stop growing, in reality, only a couple
  // of properties are saved for each seen Period. Even long running live streams won't
  // generate too many Periods, unless the stream is watched for decades. In the future,
  // this can be optimized by mapping to discontinuity sequence numbers for each timeline,
  // but it may not become an issue, and the additional info can be useful for debugging.

  newManifest.timelineStarts = getUniqueTimelineStarts([oldManifest.timelineStarts, newManifest.timelineStarts]);
  updateSequenceNumbers({
    oldPlaylists: oldPlaylists,
    newPlaylists: newPlaylists,
    timelineStarts: newManifest.timelineStarts
  });
  return newManifest;
};
var generateSidxKey = function generateSidxKey(sidx) {
  return sidx && sidx.uri + '-' + byteRangeToString(sidx.byterange);
};
var mergeDiscontiguousPlaylists = function mergeDiscontiguousPlaylists(playlists) {
  var mergedPlaylists = values(playlists.reduce(function (acc, playlist) {
    // assuming playlist IDs are the same across periods
    // TODO: handle multiperiod where representation sets are not the same
    // across periods
    var name = playlist.attributes.id + (playlist.attributes.lang || '');
    if (!acc[name]) {
      // First Period
      acc[name] = playlist;
      acc[name].attributes.timelineStarts = [];
    } else {
      // Subsequent Periods
      if (playlist.segments) {
        var _acc$name$segments;

        // first segment of subsequent periods signal a discontinuity
        if (playlist.segments[0]) {
          playlist.segments[0].discontinuity = true;
        }
        (_acc$name$segments = acc[name].segments).push.apply(_acc$name$segments, playlist.segments);
      } // bubble up contentProtection, this assumes all DRM content
      // has the same contentProtection

      if (playlist.attributes.contentProtection) {
        acc[name].attributes.contentProtection = playlist.attributes.contentProtection;
      }
    }
    acc[name].attributes.timelineStarts.push({
      // Although they represent the same number, it's important to have both to make it
      // compatible with HLS potentially having a similar attribute.
      start: playlist.attributes.periodStart,
      timeline: playlist.attributes.periodStart
    });
    return acc;
  }, {}));
  return mergedPlaylists.map(function (playlist) {
    playlist.discontinuityStarts = findIndexes(playlist.segments || [], 'discontinuity');
    return playlist;
  });
};
var addSidxSegmentsToPlaylist = function addSidxSegmentsToPlaylist(playlist, sidxMapping) {
  var sidxKey = generateSidxKey(playlist.sidx);
  var sidxMatch = sidxKey && sidxMapping[sidxKey] && sidxMapping[sidxKey].sidx;
  if (sidxMatch) {
    addSidxSegmentsToPlaylist$1(playlist, sidxMatch, playlist.sidx.resolvedUri);
  }
  return playlist;
};
var addSidxSegmentsToPlaylists = function addSidxSegmentsToPlaylists(playlists, sidxMapping) {
  if (sidxMapping === void 0) {
    sidxMapping = {};
  }
  if (!Object.keys(sidxMapping).length) {
    return playlists;
  }
  for (var i in playlists) {
    playlists[i] = addSidxSegmentsToPlaylist(playlists[i], sidxMapping);
  }
  return playlists;
};
var formatAudioPlaylist = function formatAudioPlaylist(_ref, isAudioOnly) {
  var _attributes;
  var attributes = _ref.attributes,
    segments = _ref.segments,
    sidx = _ref.sidx,
    mediaSequence = _ref.mediaSequence,
    discontinuitySequence = _ref.discontinuitySequence,
    discontinuityStarts = _ref.discontinuityStarts;
  var playlist = {
    attributes: (_attributes = {
      NAME: attributes.id,
      BANDWIDTH: attributes.bandwidth,
      CODECS: attributes.codecs
    }, _attributes['PROGRAM-ID'] = 1, _attributes),
    uri: '',
    endList: attributes.type === 'static',
    timeline: attributes.periodStart,
    resolvedUri: '',
    targetDuration: attributes.duration,
    discontinuitySequence: discontinuitySequence,
    discontinuityStarts: discontinuityStarts,
    timelineStarts: attributes.timelineStarts,
    mediaSequence: mediaSequence,
    segments: segments
  };
  if (attributes.contentProtection) {
    playlist.contentProtection = attributes.contentProtection;
  }
  if (sidx) {
    playlist.sidx = sidx;
  }
  if (isAudioOnly) {
    playlist.attributes.AUDIO = 'audio';
    playlist.attributes.SUBTITLES = 'subs';
  }
  return playlist;
};
var formatVttPlaylist = function formatVttPlaylist(_ref2) {
  var _m3u8Attributes;
  var attributes = _ref2.attributes,
    segments = _ref2.segments,
    mediaSequence = _ref2.mediaSequence,
    discontinuityStarts = _ref2.discontinuityStarts,
    discontinuitySequence = _ref2.discontinuitySequence;
  if (typeof segments === 'undefined') {
    // vtt tracks may use single file in BaseURL
    segments = [{
      uri: attributes.baseUrl,
      timeline: attributes.periodStart,
      resolvedUri: attributes.baseUrl || '',
      duration: attributes.sourceDuration,
      number: 0
    }]; // targetDuration should be the same duration as the only segment

    attributes.duration = attributes.sourceDuration;
  }
  var m3u8Attributes = (_m3u8Attributes = {
    NAME: attributes.id,
    BANDWIDTH: attributes.bandwidth
  }, _m3u8Attributes['PROGRAM-ID'] = 1, _m3u8Attributes);
  if (attributes.codecs) {
    m3u8Attributes.CODECS = attributes.codecs;
  }
  return {
    attributes: m3u8Attributes,
    uri: '',
    endList: attributes.type === 'static',
    timeline: attributes.periodStart,
    resolvedUri: attributes.baseUrl || '',
    targetDuration: attributes.duration,
    timelineStarts: attributes.timelineStarts,
    discontinuityStarts: discontinuityStarts,
    discontinuitySequence: discontinuitySequence,
    mediaSequence: mediaSequence,
    segments: segments
  };
};
var organizeAudioPlaylists = function organizeAudioPlaylists(playlists, sidxMapping, isAudioOnly) {
  if (sidxMapping === void 0) {
    sidxMapping = {};
  }
  if (isAudioOnly === void 0) {
    isAudioOnly = false;
  }
  var mainPlaylist;
  var formattedPlaylists = playlists.reduce(function (a, playlist) {
    var role = playlist.attributes.role && playlist.attributes.role.value || '';
    var language = playlist.attributes.lang || '';
    var label = playlist.attributes.label || 'main';
    if (language && !playlist.attributes.label) {
      var roleLabel = role ? " (" + role + ")" : '';
      label = "" + playlist.attributes.lang + roleLabel;
    }
    if (!a[label]) {
      a[label] = {
        language: language,
        autoselect: true,
        default: role === 'main',
        playlists: [],
        uri: ''
      };
    }
    var formatted = addSidxSegmentsToPlaylist(formatAudioPlaylist(playlist, isAudioOnly), sidxMapping);
    a[label].playlists.push(formatted);
    if (typeof mainPlaylist === 'undefined' && role === 'main') {
      mainPlaylist = playlist;
      mainPlaylist.default = true;
    }
    return a;
  }, {}); // if no playlists have role "main", mark the first as main

  if (!mainPlaylist) {
    var firstLabel = Object.keys(formattedPlaylists)[0];
    formattedPlaylists[firstLabel].default = true;
  }
  return formattedPlaylists;
};
var organizeVttPlaylists = function organizeVttPlaylists(playlists, sidxMapping) {
  if (sidxMapping === void 0) {
    sidxMapping = {};
  }
  return playlists.reduce(function (a, playlist) {
    var label = playlist.attributes.lang || 'text';
    if (!a[label]) {
      a[label] = {
        language: label,
        default: false,
        autoselect: false,
        playlists: [],
        uri: ''
      };
    }
    a[label].playlists.push(addSidxSegmentsToPlaylist(formatVttPlaylist(playlist), sidxMapping));
    return a;
  }, {});
};
var organizeCaptionServices = function organizeCaptionServices(captionServices) {
  return captionServices.reduce(function (svcObj, svc) {
    if (!svc) {
      return svcObj;
    }
    svc.forEach(function (service) {
      var channel = service.channel,
        language = service.language;
      svcObj[language] = {
        autoselect: false,
        default: false,
        instreamId: channel,
        language: language
      };
      if (service.hasOwnProperty('aspectRatio')) {
        svcObj[language].aspectRatio = service.aspectRatio;
      }
      if (service.hasOwnProperty('easyReader')) {
        svcObj[language].easyReader = service.easyReader;
      }
      if (service.hasOwnProperty('3D')) {
        svcObj[language]['3D'] = service['3D'];
      }
    });
    return svcObj;
  }, {});
};
var formatVideoPlaylist = function formatVideoPlaylist(_ref3) {
  var _attributes2;
  var attributes = _ref3.attributes,
    segments = _ref3.segments,
    sidx = _ref3.sidx,
    discontinuityStarts = _ref3.discontinuityStarts;
  var playlist = {
    attributes: (_attributes2 = {
      NAME: attributes.id,
      AUDIO: 'audio',
      SUBTITLES: 'subs',
      RESOLUTION: {
        width: attributes.width,
        height: attributes.height
      },
      CODECS: attributes.codecs,
      BANDWIDTH: attributes.bandwidth
    }, _attributes2['PROGRAM-ID'] = 1, _attributes2),
    uri: '',
    endList: attributes.type === 'static',
    timeline: attributes.periodStart,
    resolvedUri: '',
    targetDuration: attributes.duration,
    discontinuityStarts: discontinuityStarts,
    timelineStarts: attributes.timelineStarts,
    segments: segments
  };
  if (attributes.frameRate) {
    playlist.attributes['FRAME-RATE'] = attributes.frameRate;
  }
  if (attributes.contentProtection) {
    playlist.contentProtection = attributes.contentProtection;
  }
  if (sidx) {
    playlist.sidx = sidx;
  }
  return playlist;
};
var videoOnly = function videoOnly(_ref4) {
  var attributes = _ref4.attributes;
  return attributes.mimeType === 'video/mp4' || attributes.mimeType === 'video/webm' || attributes.contentType === 'video';
};
var audioOnly = function audioOnly(_ref5) {
  var attributes = _ref5.attributes;
  return attributes.mimeType === 'audio/mp4' || attributes.mimeType === 'audio/webm' || attributes.contentType === 'audio';
};
var vttOnly = function vttOnly(_ref6) {
  var attributes = _ref6.attributes;
  return attributes.mimeType === 'text/vtt' || attributes.contentType === 'text';
};
/**
 * Contains start and timeline properties denoting a timeline start. For DASH, these will
 * be the same number.
 *
 * @typedef {Object} TimelineStart
 * @property {number} start - the start time of the timeline
 * @property {number} timeline - the timeline number
 */

/**
 * Adds appropriate media and discontinuity sequence values to the segments and playlists.
 *
 * Throughout mpd-parser, the `number` attribute is used in relation to `startNumber`, a
 * DASH specific attribute used in constructing segment URI's from templates. However, from
 * an HLS perspective, the `number` attribute on a segment would be its `mediaSequence`
 * value, which should start at the original media sequence value (or 0) and increment by 1
 * for each segment thereafter. Since DASH's `startNumber` values are independent per
 * period, it doesn't make sense to use it for `number`. Instead, assume everything starts
 * from a 0 mediaSequence value and increment from there.
 *
 * Note that VHS currently doesn't use the `number` property, but it can be helpful for
 * debugging and making sense of the manifest.
 *
 * For live playlists, to account for values increasing in manifests when periods are
 * removed on refreshes, merging logic should be used to update the numbers to their
 * appropriate values (to ensure they're sequential and increasing).
 *
 * @param {Object[]} playlists - the playlists to update
 * @param {TimelineStart[]} timelineStarts - the timeline starts for the manifest
 */

var addMediaSequenceValues = function addMediaSequenceValues(playlists, timelineStarts) {
  // increment all segments sequentially
  playlists.forEach(function (playlist) {
    playlist.mediaSequence = 0;
    playlist.discontinuitySequence = findIndex(timelineStarts, function (_ref7) {
      var timeline = _ref7.timeline;
      return timeline === playlist.timeline;
    });
    if (!playlist.segments) {
      return;
    }
    playlist.segments.forEach(function (segment, index) {
      segment.number = index;
    });
  });
};
/**
 * Given a media group object, flattens all playlists within the media group into a single
 * array.
 *
 * @param {Object} mediaGroupObject - the media group object
 *
 * @return {Object[]}
 *         The media group playlists
 */

var flattenMediaGroupPlaylists = function flattenMediaGroupPlaylists(mediaGroupObject) {
  if (!mediaGroupObject) {
    return [];
  }
  return Object.keys(mediaGroupObject).reduce(function (acc, label) {
    var labelContents = mediaGroupObject[label];
    return acc.concat(labelContents.playlists);
  }, []);
};
var toM3u8 = function toM3u8(_ref8) {
  var _mediaGroups;
  var dashPlaylists = _ref8.dashPlaylists,
    locations = _ref8.locations,
    _ref8$sidxMapping = _ref8.sidxMapping,
    sidxMapping = _ref8$sidxMapping === void 0 ? {} : _ref8$sidxMapping,
    previousManifest = _ref8.previousManifest;
  if (!dashPlaylists.length) {
    return {};
  } // grab all main manifest attributes

  var _dashPlaylists$0$attr = dashPlaylists[0].attributes,
    duration = _dashPlaylists$0$attr.sourceDuration,
    type = _dashPlaylists$0$attr.type,
    suggestedPresentationDelay = _dashPlaylists$0$attr.suggestedPresentationDelay,
    minimumUpdatePeriod = _dashPlaylists$0$attr.minimumUpdatePeriod;
  var videoPlaylists = mergeDiscontiguousPlaylists(dashPlaylists.filter(videoOnly)).map(formatVideoPlaylist);
  var audioPlaylists = mergeDiscontiguousPlaylists(dashPlaylists.filter(audioOnly));
  var vttPlaylists = mergeDiscontiguousPlaylists(dashPlaylists.filter(vttOnly));
  var captions = dashPlaylists.map(function (playlist) {
    return playlist.attributes.captionServices;
  }).filter(Boolean);
  var manifest = {
    allowCache: true,
    discontinuityStarts: [],
    segments: [],
    endList: true,
    mediaGroups: (_mediaGroups = {
      AUDIO: {},
      VIDEO: {}
    }, _mediaGroups['CLOSED-CAPTIONS'] = {}, _mediaGroups.SUBTITLES = {}, _mediaGroups),
    uri: '',
    duration: duration,
    playlists: addSidxSegmentsToPlaylists(videoPlaylists, sidxMapping)
  };
  if (minimumUpdatePeriod >= 0) {
    manifest.minimumUpdatePeriod = minimumUpdatePeriod * 1000;
  }
  if (locations) {
    manifest.locations = locations;
  }
  if (type === 'dynamic') {
    manifest.suggestedPresentationDelay = suggestedPresentationDelay;
  }
  var isAudioOnly = manifest.playlists.length === 0;
  var organizedAudioGroup = audioPlaylists.length ? organizeAudioPlaylists(audioPlaylists, sidxMapping, isAudioOnly) : null;
  var organizedVttGroup = vttPlaylists.length ? organizeVttPlaylists(vttPlaylists, sidxMapping) : null;
  var formattedPlaylists = videoPlaylists.concat(flattenMediaGroupPlaylists(organizedAudioGroup), flattenMediaGroupPlaylists(organizedVttGroup));
  var playlistTimelineStarts = formattedPlaylists.map(function (_ref9) {
    var timelineStarts = _ref9.timelineStarts;
    return timelineStarts;
  });
  manifest.timelineStarts = getUniqueTimelineStarts(playlistTimelineStarts);
  addMediaSequenceValues(formattedPlaylists, manifest.timelineStarts);
  if (organizedAudioGroup) {
    manifest.mediaGroups.AUDIO.audio = organizedAudioGroup;
  }
  if (organizedVttGroup) {
    manifest.mediaGroups.SUBTITLES.subs = organizedVttGroup;
  }
  if (captions.length) {
    manifest.mediaGroups['CLOSED-CAPTIONS'].cc = organizeCaptionServices(captions);
  }
  if (previousManifest) {
    return positionManifestOnTimeline({
      oldManifest: previousManifest,
      newManifest: manifest
    });
  }
  return manifest;
};

/**
 * Calculates the R (repetition) value for a live stream (for the final segment
 * in a manifest where the r value is negative 1)
 *
 * @param {Object} attributes
 *        Object containing all inherited attributes from parent elements with attribute
 *        names as keys
 * @param {number} time
 *        current time (typically the total time up until the final segment)
 * @param {number} duration
 *        duration property for the given <S />
 *
 * @return {number}
 *        R value to reach the end of the given period
 */
var getLiveRValue = function getLiveRValue(attributes, time, duration) {
  var NOW = attributes.NOW,
    clientOffset = attributes.clientOffset,
    availabilityStartTime = attributes.availabilityStartTime,
    _attributes$timescale = attributes.timescale,
    timescale = _attributes$timescale === void 0 ? 1 : _attributes$timescale,
    _attributes$periodSta = attributes.periodStart,
    periodStart = _attributes$periodSta === void 0 ? 0 : _attributes$periodSta,
    _attributes$minimumUp = attributes.minimumUpdatePeriod,
    minimumUpdatePeriod = _attributes$minimumUp === void 0 ? 0 : _attributes$minimumUp;
  var now = (NOW + clientOffset) / 1000;
  var periodStartWC = availabilityStartTime + periodStart;
  var periodEndWC = now + minimumUpdatePeriod;
  var periodDuration = periodEndWC - periodStartWC;
  return Math.ceil((periodDuration * timescale - time) / duration);
};
/**
 * Uses information provided by SegmentTemplate.SegmentTimeline to determine segment
 * timing and duration
 *
 * @param {Object} attributes
 *        Object containing all inherited attributes from parent elements with attribute
 *        names as keys
 * @param {Object[]} segmentTimeline
 *        List of objects representing the attributes of each S element contained within
 *
 * @return {{number: number, duration: number, time: number, timeline: number}[]}
 *         List of Objects with segment timing and duration info
 */

var parseByTimeline = function parseByTimeline(attributes, segmentTimeline) {
  var type = attributes.type,
    _attributes$minimumUp2 = attributes.minimumUpdatePeriod,
    minimumUpdatePeriod = _attributes$minimumUp2 === void 0 ? 0 : _attributes$minimumUp2,
    _attributes$media = attributes.media,
    media = _attributes$media === void 0 ? '' : _attributes$media,
    sourceDuration = attributes.sourceDuration,
    _attributes$timescale2 = attributes.timescale,
    timescale = _attributes$timescale2 === void 0 ? 1 : _attributes$timescale2,
    _attributes$startNumb = attributes.startNumber,
    startNumber = _attributes$startNumb === void 0 ? 1 : _attributes$startNumb,
    timeline = attributes.periodStart;
  var segments = [];
  var time = -1;
  for (var sIndex = 0; sIndex < segmentTimeline.length; sIndex++) {
    var S = segmentTimeline[sIndex];
    var duration = S.d;
    var repeat = S.r || 0;
    var segmentTime = S.t || 0;
    if (time < 0) {
      // first segment
      time = segmentTime;
    }
    if (segmentTime && segmentTime > time) {
      // discontinuity
      // TODO: How to handle this type of discontinuity
      // timeline++ here would treat it like HLS discontuity and content would
      // get appended without gap
      // E.G.
      //  <S t="0" d="1" />
      //  <S d="1" />
      //  <S d="1" />
      //  <S t="5" d="1" />
      // would have $Time$ values of [0, 1, 2, 5]
      // should this be appened at time positions [0, 1, 2, 3],(#EXT-X-DISCONTINUITY)
      // or [0, 1, 2, gap, gap, 5]? (#EXT-X-GAP)
      // does the value of sourceDuration consider this when calculating arbitrary
      // negative @r repeat value?
      // E.G. Same elements as above with this added at the end
      //  <S d="1" r="-1" />
      //  with a sourceDuration of 10
      // Would the 2 gaps be included in the time duration calculations resulting in
      // 8 segments with $Time$ values of [0, 1, 2, 5, 6, 7, 8, 9] or 10 segments
      // with $Time$ values of [0, 1, 2, 5, 6, 7, 8, 9, 10, 11] ?
      time = segmentTime;
    }
    var count = void 0;
    if (repeat < 0) {
      var nextS = sIndex + 1;
      if (nextS === segmentTimeline.length) {
        // last segment
        if (type === 'dynamic' && minimumUpdatePeriod > 0 && media.indexOf('$Number$') > 0) {
          count = getLiveRValue(attributes, time, duration);
        } else {
          // TODO: This may be incorrect depending on conclusion of TODO above
          count = (sourceDuration * timescale - time) / duration;
        }
      } else {
        count = (segmentTimeline[nextS].t - time) / duration;
      }
    } else {
      count = repeat + 1;
    }
    var end = startNumber + segments.length + count;
    var number = startNumber + segments.length;
    while (number < end) {
      segments.push({
        number: number,
        duration: duration / timescale,
        time: time,
        timeline: timeline
      });
      time += duration;
      number++;
    }
  }
  return segments;
};
var identifierPattern = /\$([A-z]*)(?:(%0)([0-9]+)d)?\$/g;
/**
 * Replaces template identifiers with corresponding values. To be used as the callback
 * for String.prototype.replace
 *
 * @name replaceCallback
 * @function
 * @param {string} match
 *        Entire match of identifier
 * @param {string} identifier
 *        Name of matched identifier
 * @param {string} format
 *        Format tag string. Its presence indicates that padding is expected
 * @param {string} width
 *        Desired length of the replaced value. Values less than this width shall be left
 *        zero padded
 * @return {string}
 *         Replacement for the matched identifier
 */

/**
 * Returns a function to be used as a callback for String.prototype.replace to replace
 * template identifiers
 *
 * @param {Obect} values
 *        Object containing values that shall be used to replace known identifiers
 * @param {number} values.RepresentationID
 *        Value of the Representation@id attribute
 * @param {number} values.Number
 *        Number of the corresponding segment
 * @param {number} values.Bandwidth
 *        Value of the Representation@bandwidth attribute.
 * @param {number} values.Time
 *        Timestamp value of the corresponding segment
 * @return {replaceCallback}
 *         Callback to be used with String.prototype.replace to replace identifiers
 */

var identifierReplacement = function identifierReplacement(values) {
  return function (match, identifier, format, width) {
    if (match === '$$') {
      // escape sequence
      return '$';
    }
    if (typeof values[identifier] === 'undefined') {
      return match;
    }
    var value = '' + values[identifier];
    if (identifier === 'RepresentationID') {
      // Format tag shall not be present with RepresentationID
      return value;
    }
    if (!format) {
      width = 1;
    } else {
      width = parseInt(width, 10);
    }
    if (value.length >= width) {
      return value;
    }
    return "" + new Array(width - value.length + 1).join('0') + value;
  };
};
/**
 * Constructs a segment url from a template string
 *
 * @param {string} url
 *        Template string to construct url from
 * @param {Obect} values
 *        Object containing values that shall be used to replace known identifiers
 * @param {number} values.RepresentationID
 *        Value of the Representation@id attribute
 * @param {number} values.Number
 *        Number of the corresponding segment
 * @param {number} values.Bandwidth
 *        Value of the Representation@bandwidth attribute.
 * @param {number} values.Time
 *        Timestamp value of the corresponding segment
 * @return {string}
 *         Segment url with identifiers replaced
 */

var constructTemplateUrl = function constructTemplateUrl(url, values) {
  return url.replace(identifierPattern, identifierReplacement(values));
};
/**
 * Generates a list of objects containing timing and duration information about each
 * segment needed to generate segment uris and the complete segment object
 *
 * @param {Object} attributes
 *        Object containing all inherited attributes from parent elements with attribute
 *        names as keys
 * @param {Object[]|undefined} segmentTimeline
 *        List of objects representing the attributes of each S element contained within
 *        the SegmentTimeline element
 * @return {{number: number, duration: number, time: number, timeline: number}[]}
 *         List of Objects with segment timing and duration info
 */

var parseTemplateInfo = function parseTemplateInfo(attributes, segmentTimeline) {
  if (!attributes.duration && !segmentTimeline) {
    // if neither @duration or SegmentTimeline are present, then there shall be exactly
    // one media segment
    return [{
      number: attributes.startNumber || 1,
      duration: attributes.sourceDuration,
      time: 0,
      timeline: attributes.periodStart
    }];
  }
  if (attributes.duration) {
    return parseByDuration(attributes);
  }
  return parseByTimeline(attributes, segmentTimeline);
};
/**
 * Generates a list of segments using information provided by the SegmentTemplate element
 *
 * @param {Object} attributes
 *        Object containing all inherited attributes from parent elements with attribute
 *        names as keys
 * @param {Object[]|undefined} segmentTimeline
 *        List of objects representing the attributes of each S element contained within
 *        the SegmentTimeline element
 * @return {Object[]}
 *         List of segment objects
 */

var segmentsFromTemplate = function segmentsFromTemplate(attributes, segmentTimeline) {
  var templateValues = {
    RepresentationID: attributes.id,
    Bandwidth: attributes.bandwidth || 0
  };
  var _attributes$initializ = attributes.initialization,
    initialization = _attributes$initializ === void 0 ? {
      sourceURL: '',
      range: ''
    } : _attributes$initializ;
  var mapSegment = urlTypeToSegment({
    baseUrl: attributes.baseUrl,
    source: constructTemplateUrl(initialization.sourceURL, templateValues),
    range: initialization.range
  });
  var segments = parseTemplateInfo(attributes, segmentTimeline);
  return segments.map(function (segment) {
    templateValues.Number = segment.number;
    templateValues.Time = segment.time;
    var uri = constructTemplateUrl(attributes.media || '', templateValues); // See DASH spec section 5.3.9.2.2
    // - if timescale isn't present on any level, default to 1.

    var timescale = attributes.timescale || 1; // - if presentationTimeOffset isn't present on any level, default to 0

    var presentationTimeOffset = attributes.presentationTimeOffset || 0;
    var presentationTime =
    // Even if the @t attribute is not specified for the segment, segment.time is
    // calculated in mpd-parser prior to this, so it's assumed to be available.
    attributes.periodStart + (segment.time - presentationTimeOffset) / timescale;
    var map = {
      uri: uri,
      timeline: segment.timeline,
      duration: segment.duration,
      resolvedUri: resolve_url(attributes.baseUrl || '', uri),
      map: mapSegment,
      number: segment.number,
      presentationTime: presentationTime
    };
    return map;
  });
};

/**
 * Converts a <SegmentUrl> (of type URLType from the DASH spec 5.3.9.2 Table 14)
 * to an object that matches the output of a segment in videojs/mpd-parser
 *
 * @param {Object} attributes
 *   Object containing all inherited attributes from parent elements with attribute
 *   names as keys
 * @param {Object} segmentUrl
 *   <SegmentURL> node to translate into a segment object
 * @return {Object} translated segment object
 */

var SegmentURLToSegmentObject = function SegmentURLToSegmentObject(attributes, segmentUrl) {
  var baseUrl = attributes.baseUrl,
    _attributes$initializ = attributes.initialization,
    initialization = _attributes$initializ === void 0 ? {} : _attributes$initializ;
  var initSegment = urlTypeToSegment({
    baseUrl: baseUrl,
    source: initialization.sourceURL,
    range: initialization.range
  });
  var segment = urlTypeToSegment({
    baseUrl: baseUrl,
    source: segmentUrl.media,
    range: segmentUrl.mediaRange
  });
  segment.map = initSegment;
  return segment;
};
/**
 * Generates a list of segments using information provided by the SegmentList element
 * SegmentList (DASH SPEC Section 5.3.9.3.2) contains a set of <SegmentURL> nodes.  Each
 * node should be translated into segment.
 *
 * @param {Object} attributes
 *   Object containing all inherited attributes from parent elements with attribute
 *   names as keys
 * @param {Object[]|undefined} segmentTimeline
 *        List of objects representing the attributes of each S element contained within
 *        the SegmentTimeline element
 * @return {Object.<Array>} list of segments
 */

var segmentsFromList = function segmentsFromList(attributes, segmentTimeline) {
  var duration = attributes.duration,
    _attributes$segmentUr = attributes.segmentUrls,
    segmentUrls = _attributes$segmentUr === void 0 ? [] : _attributes$segmentUr,
    periodStart = attributes.periodStart; // Per spec (5.3.9.2.1) no way to determine segment duration OR
  // if both SegmentTimeline and @duration are defined, it is outside of spec.

  if (!duration && !segmentTimeline || duration && segmentTimeline) {
    throw new Error(errors.SEGMENT_TIME_UNSPECIFIED);
  }
  var segmentUrlMap = segmentUrls.map(function (segmentUrlObject) {
    return SegmentURLToSegmentObject(attributes, segmentUrlObject);
  });
  var segmentTimeInfo;
  if (duration) {
    segmentTimeInfo = parseByDuration(attributes);
  }
  if (segmentTimeline) {
    segmentTimeInfo = parseByTimeline(attributes, segmentTimeline);
  }
  var segments = segmentTimeInfo.map(function (segmentTime, index) {
    if (segmentUrlMap[index]) {
      var segment = segmentUrlMap[index]; // See DASH spec section 5.3.9.2.2
      // - if timescale isn't present on any level, default to 1.

      var timescale = attributes.timescale || 1; // - if presentationTimeOffset isn't present on any level, default to 0

      var presentationTimeOffset = attributes.presentationTimeOffset || 0;
      segment.timeline = segmentTime.timeline;
      segment.duration = segmentTime.duration;
      segment.number = segmentTime.number;
      segment.presentationTime = periodStart + (segmentTime.time - presentationTimeOffset) / timescale;
      return segment;
    } // Since we're mapping we should get rid of any blank segments (in case
    // the given SegmentTimeline is handling for more elements than we have
    // SegmentURLs for).
  }).filter(function (segment) {
    return segment;
  });
  return segments;
};
var generateSegments = function generateSegments(_ref) {
  var attributes = _ref.attributes,
    segmentInfo = _ref.segmentInfo;
  var segmentAttributes;
  var segmentsFn;
  if (segmentInfo.template) {
    segmentsFn = segmentsFromTemplate;
    segmentAttributes = merge(attributes, segmentInfo.template);
  } else if (segmentInfo.base) {
    segmentsFn = segmentsFromBase;
    segmentAttributes = merge(attributes, segmentInfo.base);
  } else if (segmentInfo.list) {
    segmentsFn = segmentsFromList;
    segmentAttributes = merge(attributes, segmentInfo.list);
  }
  var segmentsInfo = {
    attributes: attributes
  };
  if (!segmentsFn) {
    return segmentsInfo;
  }
  var segments = segmentsFn(segmentAttributes, segmentInfo.segmentTimeline); // The @duration attribute will be used to determin the playlist's targetDuration which
  // must be in seconds. Since we've generated the segment list, we no longer need
  // @duration to be in @timescale units, so we can convert it here.

  if (segmentAttributes.duration) {
    var _segmentAttributes = segmentAttributes,
      duration = _segmentAttributes.duration,
      _segmentAttributes$ti = _segmentAttributes.timescale,
      timescale = _segmentAttributes$ti === void 0 ? 1 : _segmentAttributes$ti;
    segmentAttributes.duration = duration / timescale;
  } else if (segments.length) {
    // if there is no @duration attribute, use the largest segment duration as
    // as target duration
    segmentAttributes.duration = segments.reduce(function (max, segment) {
      return Math.max(max, Math.ceil(segment.duration));
    }, 0);
  } else {
    segmentAttributes.duration = 0;
  }
  segmentsInfo.attributes = segmentAttributes;
  segmentsInfo.segments = segments; // This is a sidx box without actual segment information

  if (segmentInfo.base && segmentAttributes.indexRange) {
    segmentsInfo.sidx = segments[0];
    segmentsInfo.segments = [];
  }
  return segmentsInfo;
};
var toPlaylists = function toPlaylists(representations) {
  return representations.map(generateSegments);
};
var findChildren = function findChildren(element, name) {
  return from(element.childNodes).filter(function (_ref) {
    var tagName = _ref.tagName;
    return tagName === name;
  });
};
var getContent = function getContent(element) {
  return element.textContent.trim();
};

/**
 * Converts the provided string that may contain a division operation to a number.
 *
 * @param {string} value - the provided string value
 *
 * @return {number} the parsed string value
 */
var parseDivisionValue = function parseDivisionValue(value) {
  return parseFloat(value.split('/').reduce(function (prev, current) {
    return prev / current;
  }));
};
var parseDuration = function parseDuration(str) {
  var SECONDS_IN_YEAR = 365 * 24 * 60 * 60;
  var SECONDS_IN_MONTH = 30 * 24 * 60 * 60;
  var SECONDS_IN_DAY = 24 * 60 * 60;
  var SECONDS_IN_HOUR = 60 * 60;
  var SECONDS_IN_MIN = 60; // P10Y10M10DT10H10M10.1S

  var durationRegex = /P(?:(\d*)Y)?(?:(\d*)M)?(?:(\d*)D)?(?:T(?:(\d*)H)?(?:(\d*)M)?(?:([\d.]*)S)?)?/;
  var match = durationRegex.exec(str);
  if (!match) {
    return 0;
  }
  var _match$slice = match.slice(1),
    year = _match$slice[0],
    month = _match$slice[1],
    day = _match$slice[2],
    hour = _match$slice[3],
    minute = _match$slice[4],
    second = _match$slice[5];
  return parseFloat(year || 0) * SECONDS_IN_YEAR + parseFloat(month || 0) * SECONDS_IN_MONTH + parseFloat(day || 0) * SECONDS_IN_DAY + parseFloat(hour || 0) * SECONDS_IN_HOUR + parseFloat(minute || 0) * SECONDS_IN_MIN + parseFloat(second || 0);
};
var parseDate = function parseDate(str) {
  // Date format without timezone according to ISO 8601
  // YYY-MM-DDThh:mm:ss.ssssss
  var dateRegex = /^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/; // If the date string does not specifiy a timezone, we must specifiy UTC. This is
  // expressed by ending with 'Z'

  if (dateRegex.test(str)) {
    str += 'Z';
  }
  return Date.parse(str);
};
var parsers = {
  /**
   * Specifies the duration of the entire Media Presentation. Format is a duration string
   * as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  mediaPresentationDuration: function mediaPresentationDuration(value) {
    return parseDuration(value);
  },
  /**
   * Specifies the Segment availability start time for all Segments referred to in this
   * MPD. For a dynamic manifest, it specifies the anchor for the earliest availability
   * time. Format is a date string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The date as seconds from unix epoch
   */
  availabilityStartTime: function availabilityStartTime(value) {
    return parseDate(value) / 1000;
  },
  /**
   * Specifies the smallest period between potential changes to the MPD. Format is a
   * duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  minimumUpdatePeriod: function minimumUpdatePeriod(value) {
    return parseDuration(value);
  },
  /**
   * Specifies the suggested presentation delay. Format is a
   * duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  suggestedPresentationDelay: function suggestedPresentationDelay(value) {
    return parseDuration(value);
  },
  /**
   * specifices the type of mpd. Can be either "static" or "dynamic"
   *
   * @param {string} value
   *        value of attribute as a string
   *
   * @return {string}
   *         The type as a string
   */
  type: function type(value) {
    return value;
  },
  /**
   * Specifies the duration of the smallest time shifting buffer for any Representation
   * in the MPD. Format is a duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  timeShiftBufferDepth: function timeShiftBufferDepth(value) {
    return parseDuration(value);
  },
  /**
   * Specifies the PeriodStart time of the Period relative to the availabilityStarttime.
   * Format is a duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  start: function start(value) {
    return parseDuration(value);
  },
  /**
   * Specifies the width of the visual presentation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed width
   */
  width: function width(value) {
    return parseInt(value, 10);
  },
  /**
   * Specifies the height of the visual presentation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed height
   */
  height: function height(value) {
    return parseInt(value, 10);
  },
  /**
   * Specifies the bitrate of the representation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed bandwidth
   */
  bandwidth: function bandwidth(value) {
    return parseInt(value, 10);
  },
  /**
   * Specifies the frame rate of the representation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed frame rate
   */
  frameRate: function frameRate(value) {
    return parseDivisionValue(value);
  },
  /**
   * Specifies the number of the first Media Segment in this Representation in the Period
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed number
   */
  startNumber: function startNumber(value) {
    return parseInt(value, 10);
  },
  /**
   * Specifies the timescale in units per seconds
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed timescale
   */
  timescale: function timescale(value) {
    return parseInt(value, 10);
  },
  /**
   * Specifies the presentationTimeOffset.
   *
   * @param {string} value
   *        value of the attribute as a string
   *
   * @return {number}
   *         The parsed presentationTimeOffset
   */
  presentationTimeOffset: function presentationTimeOffset(value) {
    return parseInt(value, 10);
  },
  /**
   * Specifies the constant approximate Segment duration
   * NOTE: The <Period> element also contains an @duration attribute. This duration
   *       specifies the duration of the Period. This attribute is currently not
   *       supported by the rest of the parser, however we still check for it to prevent
   *       errors.
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed duration
   */
  duration: function duration(value) {
    var parsedValue = parseInt(value, 10);
    if (isNaN(parsedValue)) {
      return parseDuration(value);
    }
    return parsedValue;
  },
  /**
   * Specifies the Segment duration, in units of the value of the @timescale.
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed duration
   */
  d: function d(value) {
    return parseInt(value, 10);
  },
  /**
   * Specifies the MPD start time, in @timescale units, the first Segment in the series
   * starts relative to the beginning of the Period
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed time
   */
  t: function t(value) {
    return parseInt(value, 10);
  },
  /**
   * Specifies the repeat count of the number of following contiguous Segments with the
   * same duration expressed by the value of @d
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed number
   */
  r: function r(value) {
    return parseInt(value, 10);
  },
  /**
   * Default parser for all other attributes. Acts as a no-op and just returns the value
   * as a string
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {string}
   *         Unparsed value
   */
  DEFAULT: function DEFAULT(value) {
    return value;
  }
};
/**
 * Gets all the attributes and values of the provided node, parses attributes with known
 * types, and returns an object with attribute names mapped to values.
 *
 * @param {Node} el
 *        The node to parse attributes from
 * @return {Object}
 *         Object with all attributes of el parsed
 */

var mpd_parser_es_parseAttributes = function parseAttributes(el) {
  if (!(el && el.attributes)) {
    return {};
  }
  return from(el.attributes).reduce(function (a, e) {
    var parseFn = parsers[e.name] || parsers.DEFAULT;
    a[e.name] = parseFn(e.value);
    return a;
  }, {});
};
var keySystemsMap = {
  'urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b': 'org.w3.clearkey',
  'urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed': 'com.widevine.alpha',
  'urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95': 'com.microsoft.playready',
  'urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb': 'com.adobe.primetime'
};
/**
 * Builds a list of urls that is the product of the reference urls and BaseURL values
 *
 * @param {string[]} referenceUrls
 *        List of reference urls to resolve to
 * @param {Node[]} baseUrlElements
 *        List of BaseURL nodes from the mpd
 * @return {string[]}
 *         List of resolved urls
 */

var buildBaseUrls = function buildBaseUrls(referenceUrls, baseUrlElements) {
  if (!baseUrlElements.length) {
    return referenceUrls;
  }
  return flatten(referenceUrls.map(function (reference) {
    return baseUrlElements.map(function (baseUrlElement) {
      return resolve_url(reference, getContent(baseUrlElement));
    });
  }));
};
/**
 * Contains all Segment information for its containing AdaptationSet
 *
 * @typedef {Object} SegmentInformation
 * @property {Object|undefined} template
 *           Contains the attributes for the SegmentTemplate node
 * @property {Object[]|undefined} segmentTimeline
 *           Contains a list of atrributes for each S node within the SegmentTimeline node
 * @property {Object|undefined} list
 *           Contains the attributes for the SegmentList node
 * @property {Object|undefined} base
 *           Contains the attributes for the SegmentBase node
 */

/**
 * Returns all available Segment information contained within the AdaptationSet node
 *
 * @param {Node} adaptationSet
 *        The AdaptationSet node to get Segment information from
 * @return {SegmentInformation}
 *         The Segment information contained within the provided AdaptationSet
 */

var getSegmentInformation = function getSegmentInformation(adaptationSet) {
  var segmentTemplate = findChildren(adaptationSet, 'SegmentTemplate')[0];
  var segmentList = findChildren(adaptationSet, 'SegmentList')[0];
  var segmentUrls = segmentList && findChildren(segmentList, 'SegmentURL').map(function (s) {
    return merge({
      tag: 'SegmentURL'
    }, mpd_parser_es_parseAttributes(s));
  });
  var segmentBase = findChildren(adaptationSet, 'SegmentBase')[0];
  var segmentTimelineParentNode = segmentList || segmentTemplate;
  var segmentTimeline = segmentTimelineParentNode && findChildren(segmentTimelineParentNode, 'SegmentTimeline')[0];
  var segmentInitializationParentNode = segmentList || segmentBase || segmentTemplate;
  var segmentInitialization = segmentInitializationParentNode && findChildren(segmentInitializationParentNode, 'Initialization')[0]; // SegmentTemplate is handled slightly differently, since it can have both
  // @initialization and an <Initialization> node.  @initialization can be templated,
  // while the node can have a url and range specified.  If the <SegmentTemplate> has
  // both @initialization and an <Initialization> subelement we opt to override with
  // the node, as this interaction is not defined in the spec.

  var template = segmentTemplate && mpd_parser_es_parseAttributes(segmentTemplate);
  if (template && segmentInitialization) {
    template.initialization = segmentInitialization && mpd_parser_es_parseAttributes(segmentInitialization);
  } else if (template && template.initialization) {
    // If it is @initialization we convert it to an object since this is the format that
    // later functions will rely on for the initialization segment.  This is only valid
    // for <SegmentTemplate>
    template.initialization = {
      sourceURL: template.initialization
    };
  }
  var segmentInfo = {
    template: template,
    segmentTimeline: segmentTimeline && findChildren(segmentTimeline, 'S').map(function (s) {
      return mpd_parser_es_parseAttributes(s);
    }),
    list: segmentList && merge(mpd_parser_es_parseAttributes(segmentList), {
      segmentUrls: segmentUrls,
      initialization: mpd_parser_es_parseAttributes(segmentInitialization)
    }),
    base: segmentBase && merge(mpd_parser_es_parseAttributes(segmentBase), {
      initialization: mpd_parser_es_parseAttributes(segmentInitialization)
    })
  };
  Object.keys(segmentInfo).forEach(function (key) {
    if (!segmentInfo[key]) {
      delete segmentInfo[key];
    }
  });
  return segmentInfo;
};
/**
 * Contains Segment information and attributes needed to construct a Playlist object
 * from a Representation
 *
 * @typedef {Object} RepresentationInformation
 * @property {SegmentInformation} segmentInfo
 *           Segment information for this Representation
 * @property {Object} attributes
 *           Inherited attributes for this Representation
 */

/**
 * Maps a Representation node to an object containing Segment information and attributes
 *
 * @name inheritBaseUrlsCallback
 * @function
 * @param {Node} representation
 *        Representation node from the mpd
 * @return {RepresentationInformation}
 *         Representation information needed to construct a Playlist object
 */

/**
 * Returns a callback for Array.prototype.map for mapping Representation nodes to
 * Segment information and attributes using inherited BaseURL nodes.
 *
 * @param {Object} adaptationSetAttributes
 *        Contains attributes inherited by the AdaptationSet
 * @param {string[]} adaptationSetBaseUrls
 *        Contains list of resolved base urls inherited by the AdaptationSet
 * @param {SegmentInformation} adaptationSetSegmentInfo
 *        Contains Segment information for the AdaptationSet
 * @return {inheritBaseUrlsCallback}
 *         Callback map function
 */

var inheritBaseUrls = function inheritBaseUrls(adaptationSetAttributes, adaptationSetBaseUrls, adaptationSetSegmentInfo) {
  return function (representation) {
    var repBaseUrlElements = findChildren(representation, 'BaseURL');
    var repBaseUrls = buildBaseUrls(adaptationSetBaseUrls, repBaseUrlElements);
    var attributes = merge(adaptationSetAttributes, mpd_parser_es_parseAttributes(representation));
    var representationSegmentInfo = getSegmentInformation(representation);
    return repBaseUrls.map(function (baseUrl) {
      return {
        segmentInfo: merge(adaptationSetSegmentInfo, representationSegmentInfo),
        attributes: merge(attributes, {
          baseUrl: baseUrl
        })
      };
    });
  };
};
/**
 * Tranforms a series of content protection nodes to
 * an object containing pssh data by key system
 *
 * @param {Node[]} contentProtectionNodes
 *        Content protection nodes
 * @return {Object}
 *        Object containing pssh data by key system
 */

var generateKeySystemInformation = function generateKeySystemInformation(contentProtectionNodes) {
  return contentProtectionNodes.reduce(function (acc, node) {
    var attributes = mpd_parser_es_parseAttributes(node); // Although it could be argued that according to the UUID RFC spec the UUID string (a-f chars) should be generated
    // as a lowercase string it also mentions it should be treated as case-insensitive on input. Since the key system
    // UUIDs in the keySystemsMap are hardcoded as lowercase in the codebase there isn't any reason not to do
    // .toLowerCase() on the input UUID string from the manifest (at least I could not think of one).

    if (attributes.schemeIdUri) {
      attributes.schemeIdUri = attributes.schemeIdUri.toLowerCase();
    }
    var keySystem = keySystemsMap[attributes.schemeIdUri];
    if (keySystem) {
      acc[keySystem] = {
        attributes: attributes
      };
      var psshNode = findChildren(node, 'cenc:pssh')[0];
      if (psshNode) {
        var pssh = getContent(psshNode);
        acc[keySystem].pssh = pssh && decodeB64ToUint8Array(pssh);
      }
    }
    return acc;
  }, {});
}; // defined in ANSI_SCTE 214-1 2016

var parseCaptionServiceMetadata = function parseCaptionServiceMetadata(service) {
  // 608 captions
  if (service.schemeIdUri === 'urn:scte:dash:cc:cea-608:2015') {
    var values = typeof service.value !== 'string' ? [] : service.value.split(';');
    return values.map(function (value) {
      var channel;
      var language; // default language to value

      language = value;
      if (/^CC\d=/.test(value)) {
        var _value$split = value.split('=');
        channel = _value$split[0];
        language = _value$split[1];
      } else if (/^CC\d$/.test(value)) {
        channel = value;
      }
      return {
        channel: channel,
        language: language
      };
    });
  } else if (service.schemeIdUri === 'urn:scte:dash:cc:cea-708:2015') {
    var _values = typeof service.value !== 'string' ? [] : service.value.split(';');
    return _values.map(function (value) {
      var flags = {
        // service or channel number 1-63
        'channel': undefined,
        // language is a 3ALPHA per ISO 639.2/B
        // field is required
        'language': undefined,
        // BIT 1/0 or ?
        // default value is 1, meaning 16:9 aspect ratio, 0 is 4:3, ? is unknown
        'aspectRatio': 1,
        // BIT 1/0
        // easy reader flag indicated the text is tailed to the needs of beginning readers
        // default 0, or off
        'easyReader': 0,
        // BIT 1/0
        // If 3d metadata is present (CEA-708.1) then 1
        // default 0
        '3D': 0
      };
      if (/=/.test(value)) {
        var _value$split2 = value.split('='),
          channel = _value$split2[0],
          _value$split2$ = _value$split2[1],
          opts = _value$split2$ === void 0 ? '' : _value$split2$;
        flags.channel = channel;
        flags.language = value;
        opts.split(',').forEach(function (opt) {
          var _opt$split = opt.split(':'),
            name = _opt$split[0],
            val = _opt$split[1];
          if (name === 'lang') {
            flags.language = val; // er for easyReadery
          } else if (name === 'er') {
            flags.easyReader = Number(val); // war for wide aspect ratio
          } else if (name === 'war') {
            flags.aspectRatio = Number(val);
          } else if (name === '3D') {
            flags['3D'] = Number(val);
          }
        });
      } else {
        flags.language = value;
      }
      if (flags.channel) {
        flags.channel = 'SERVICE' + flags.channel;
      }
      return flags;
    });
  }
};
/**
 * Maps an AdaptationSet node to a list of Representation information objects
 *
 * @name toRepresentationsCallback
 * @function
 * @param {Node} adaptationSet
 *        AdaptationSet node from the mpd
 * @return {RepresentationInformation[]}
 *         List of objects containing Representaion information
 */

/**
 * Returns a callback for Array.prototype.map for mapping AdaptationSet nodes to a list of
 * Representation information objects
 *
 * @param {Object} periodAttributes
 *        Contains attributes inherited by the Period
 * @param {string[]} periodBaseUrls
 *        Contains list of resolved base urls inherited by the Period
 * @param {string[]} periodSegmentInfo
 *        Contains Segment Information at the period level
 * @return {toRepresentationsCallback}
 *         Callback map function
 */

var toRepresentations = function toRepresentations(periodAttributes, periodBaseUrls, periodSegmentInfo) {
  return function (adaptationSet) {
    var adaptationSetAttributes = mpd_parser_es_parseAttributes(adaptationSet);
    var adaptationSetBaseUrls = buildBaseUrls(periodBaseUrls, findChildren(adaptationSet, 'BaseURL'));
    var role = findChildren(adaptationSet, 'Role')[0];
    var roleAttributes = {
      role: mpd_parser_es_parseAttributes(role)
    };
    var attrs = merge(periodAttributes, adaptationSetAttributes, roleAttributes);
    var accessibility = findChildren(adaptationSet, 'Accessibility')[0];
    var captionServices = parseCaptionServiceMetadata(mpd_parser_es_parseAttributes(accessibility));
    if (captionServices) {
      attrs = merge(attrs, {
        captionServices: captionServices
      });
    }
    var label = findChildren(adaptationSet, 'Label')[0];
    if (label && label.childNodes.length) {
      var labelVal = label.childNodes[0].nodeValue.trim();
      attrs = merge(attrs, {
        label: labelVal
      });
    }
    var contentProtection = generateKeySystemInformation(findChildren(adaptationSet, 'ContentProtection'));
    if (Object.keys(contentProtection).length) {
      attrs = merge(attrs, {
        contentProtection: contentProtection
      });
    }
    var segmentInfo = getSegmentInformation(adaptationSet);
    var representations = findChildren(adaptationSet, 'Representation');
    var adaptationSetSegmentInfo = merge(periodSegmentInfo, segmentInfo);
    return flatten(representations.map(inheritBaseUrls(attrs, adaptationSetBaseUrls, adaptationSetSegmentInfo)));
  };
};
/**
 * Contains all period information for mapping nodes onto adaptation sets.
 *
 * @typedef {Object} PeriodInformation
 * @property {Node} period.node
 *           Period node from the mpd
 * @property {Object} period.attributes
 *           Parsed period attributes from node plus any added
 */

/**
 * Maps a PeriodInformation object to a list of Representation information objects for all
 * AdaptationSet nodes contained within the Period.
 *
 * @name toAdaptationSetsCallback
 * @function
 * @param {PeriodInformation} period
 *        Period object containing necessary period information
 * @param {number} periodStart
 *        Start time of the Period within the mpd
 * @return {RepresentationInformation[]}
 *         List of objects containing Representaion information
 */

/**
 * Returns a callback for Array.prototype.map for mapping Period nodes to a list of
 * Representation information objects
 *
 * @param {Object} mpdAttributes
 *        Contains attributes inherited by the mpd
 * @param {string[]} mpdBaseUrls
 *        Contains list of resolved base urls inherited by the mpd
 * @return {toAdaptationSetsCallback}
 *         Callback map function
 */

var toAdaptationSets = function toAdaptationSets(mpdAttributes, mpdBaseUrls) {
  return function (period, index) {
    var periodBaseUrls = buildBaseUrls(mpdBaseUrls, findChildren(period.node, 'BaseURL'));
    var periodAttributes = merge(mpdAttributes, {
      periodStart: period.attributes.start
    });
    if (typeof period.attributes.duration === 'number') {
      periodAttributes.periodDuration = period.attributes.duration;
    }
    var adaptationSets = findChildren(period.node, 'AdaptationSet');
    var periodSegmentInfo = getSegmentInformation(period.node);
    return flatten(adaptationSets.map(toRepresentations(periodAttributes, periodBaseUrls, periodSegmentInfo)));
  };
};
/**
 * Gets Period@start property for a given period.
 *
 * @param {Object} options
 *        Options object
 * @param {Object} options.attributes
 *        Period attributes
 * @param {Object} [options.priorPeriodAttributes]
 *        Prior period attributes (if prior period is available)
 * @param {string} options.mpdType
 *        The MPD@type these periods came from
 * @return {number|null}
 *         The period start, or null if it's an early available period or error
 */

var getPeriodStart = function getPeriodStart(_ref) {
  var attributes = _ref.attributes,
    priorPeriodAttributes = _ref.priorPeriodAttributes,
    mpdType = _ref.mpdType;

  // Summary of period start time calculation from DASH spec section 5.3.2.1
  //
  // A period's start is the first period's start + time elapsed after playing all
  // prior periods to this one. Periods continue one after the other in time (without
  // gaps) until the end of the presentation.
  //
  // The value of Period@start should be:
  // 1. if Period@start is present: value of Period@start
  // 2. if previous period exists and it has @duration: previous Period@start +
  //    previous Period@duration
  // 3. if this is first period and MPD@type is 'static': 0
  // 4. in all other cases, consider the period an "early available period" (note: not
  //    currently supported)
  // (1)
  if (typeof attributes.start === 'number') {
    return attributes.start;
  } // (2)

  if (priorPeriodAttributes && typeof priorPeriodAttributes.start === 'number' && typeof priorPeriodAttributes.duration === 'number') {
    return priorPeriodAttributes.start + priorPeriodAttributes.duration;
  } // (3)

  if (!priorPeriodAttributes && mpdType === 'static') {
    return 0;
  } // (4)
  // There is currently no logic for calculating the Period@start value if there is
  // no Period@start or prior Period@start and Period@duration available. This is not made
  // explicit by the DASH interop guidelines or the DASH spec, however, since there's
  // nothing about any other resolution strategies, it's implied. Thus, this case should
  // be considered an early available period, or error, and null should suffice for both
  // of those cases.

  return null;
};
/**
 * Traverses the mpd xml tree to generate a list of Representation information objects
 * that have inherited attributes from parent nodes
 *
 * @param {Node} mpd
 *        The root node of the mpd
 * @param {Object} options
 *        Available options for inheritAttributes
 * @param {string} options.manifestUri
 *        The uri source of the mpd
 * @param {number} options.NOW
 *        Current time per DASH IOP.  Default is current time in ms since epoch
 * @param {number} options.clientOffset
 *        Client time difference from NOW (in milliseconds)
 * @return {RepresentationInformation[]}
 *         List of objects containing Representation information
 */

var inheritAttributes = function inheritAttributes(mpd, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    _options$manifestUri = _options.manifestUri,
    manifestUri = _options$manifestUri === void 0 ? '' : _options$manifestUri,
    _options$NOW = _options.NOW,
    NOW = _options$NOW === void 0 ? Date.now() : _options$NOW,
    _options$clientOffset = _options.clientOffset,
    clientOffset = _options$clientOffset === void 0 ? 0 : _options$clientOffset;
  var periodNodes = findChildren(mpd, 'Period');
  if (!periodNodes.length) {
    throw new Error(errors.INVALID_NUMBER_OF_PERIOD);
  }
  var locations = findChildren(mpd, 'Location');
  var mpdAttributes = mpd_parser_es_parseAttributes(mpd);
  var mpdBaseUrls = buildBaseUrls([manifestUri], findChildren(mpd, 'BaseURL')); // See DASH spec section 5.3.1.2, Semantics of MPD element. Default type to 'static'.

  mpdAttributes.type = mpdAttributes.type || 'static';
  mpdAttributes.sourceDuration = mpdAttributes.mediaPresentationDuration || 0;
  mpdAttributes.NOW = NOW;
  mpdAttributes.clientOffset = clientOffset;
  if (locations.length) {
    mpdAttributes.locations = locations.map(getContent);
  }
  var periods = []; // Since toAdaptationSets acts on individual periods right now, the simplest approach to
  // adding properties that require looking at prior periods is to parse attributes and add
  // missing ones before toAdaptationSets is called. If more such properties are added, it
  // may be better to refactor toAdaptationSets.

  periodNodes.forEach(function (node, index) {
    var attributes = mpd_parser_es_parseAttributes(node); // Use the last modified prior period, as it may contain added information necessary
    // for this period.

    var priorPeriod = periods[index - 1];
    attributes.start = getPeriodStart({
      attributes: attributes,
      priorPeriodAttributes: priorPeriod ? priorPeriod.attributes : null,
      mpdType: mpdAttributes.type
    });
    periods.push({
      node: node,
      attributes: attributes
    });
  });
  return {
    locations: mpdAttributes.locations,
    representationInfo: flatten(periods.map(toAdaptationSets(mpdAttributes, mpdBaseUrls)))
  };
};
var stringToMpdXml = function stringToMpdXml(manifestString) {
  if (manifestString === '') {
    throw new Error(errors.DASH_EMPTY_MANIFEST);
  }
  var parser = new xmldom_lib.DOMParser();
  var xml;
  var mpd;
  try {
    xml = parser.parseFromString(manifestString, 'application/xml');
    mpd = xml && xml.documentElement.tagName === 'MPD' ? xml.documentElement : null;
  } catch (e) {// ie 11 throwsw on invalid xml
  }
  if (!mpd || mpd && mpd.getElementsByTagName('parsererror').length > 0) {
    throw new Error(errors.DASH_INVALID_XML);
  }
  return mpd;
};

/**
 * Parses the manifest for a UTCTiming node, returning the nodes attributes if found
 *
 * @param {string} mpd
 *        XML string of the MPD manifest
 * @return {Object|null}
 *         Attributes of UTCTiming node specified in the manifest. Null if none found
 */

var parseUTCTimingScheme = function parseUTCTimingScheme(mpd) {
  var UTCTimingNode = findChildren(mpd, 'UTCTiming')[0];
  if (!UTCTimingNode) {
    return null;
  }
  var attributes = mpd_parser_es_parseAttributes(UTCTimingNode);
  switch (attributes.schemeIdUri) {
    case 'urn:mpeg:dash:utc:http-head:2014':
    case 'urn:mpeg:dash:utc:http-head:2012':
      attributes.method = 'HEAD';
      break;
    case 'urn:mpeg:dash:utc:http-xsdate:2014':
    case 'urn:mpeg:dash:utc:http-iso:2014':
    case 'urn:mpeg:dash:utc:http-xsdate:2012':
    case 'urn:mpeg:dash:utc:http-iso:2012':
      attributes.method = 'GET';
      break;
    case 'urn:mpeg:dash:utc:direct:2014':
    case 'urn:mpeg:dash:utc:direct:2012':
      attributes.method = 'DIRECT';
      attributes.value = Date.parse(attributes.value);
      break;
    case 'urn:mpeg:dash:utc:http-ntp:2014':
    case 'urn:mpeg:dash:utc:ntp:2014':
    case 'urn:mpeg:dash:utc:sntp:2014':
    default:
      throw new Error(errors.UNSUPPORTED_UTC_TIMING_SCHEME);
  }
  return attributes;
};
var VERSION = (/* unused pure expression or super */ null && (version));
/*
 * Given a DASH manifest string and options, parses the DASH manifest into an object in the
 * form outputed by m3u8-parser and accepted by videojs/http-streaming.
 *
 * For live DASH manifests, if `previousManifest` is provided in options, then the newly
 * parsed DASH manifest will have its media sequence and discontinuity sequence values
 * updated to reflect its position relative to the prior manifest.
 *
 * @param {string} manifestString - the DASH manifest as a string
 * @param {options} [options] - any options
 *
 * @return {Object} the manifest object
 */

var parse = function parse(manifestString, options) {
  if (options === void 0) {
    options = {};
  }
  var parsedManifestInfo = inheritAttributes(stringToMpdXml(manifestString), options);
  var playlists = toPlaylists(parsedManifestInfo.representationInfo);
  return toM3u8({
    dashPlaylists: playlists,
    locations: parsedManifestInfo.locations,
    sidxMapping: options.sidxMapping,
    previousManifest: options.previousManifest
  });
};
/**
 * Parses the manifest for a UTCTiming node, returning the nodes attributes if found
 *
 * @param {string} manifestString
 *        XML string of the MPD manifest
 * @return {Object|null}
 *         Attributes of UTCTiming node specified in the manifest. Null if none found
 */

var parseUTCTiming = function parseUTCTiming(manifestString) {
  return parseUTCTimingScheme(stringToMpdXml(manifestString));
};

// EXTERNAL MODULE: ./node_modules/mux.js/lib/tools/parse-sidx.js
var parse_sidx = __webpack_require__(47376);
var parse_sidx_default = /*#__PURE__*/__webpack_require__.n(parse_sidx);
;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/id3-helpers.js

var ID3 = byte_helpers_toUint8([0x49, 0x44, 0x33]);
var getId3Size = function getId3Size(bytes, offset) {
  if (offset === void 0) {
    offset = 0;
  }
  bytes = byte_helpers_toUint8(bytes);
  var flags = bytes[offset + 5];
  var returnSize = bytes[offset + 6] << 21 | bytes[offset + 7] << 14 | bytes[offset + 8] << 7 | bytes[offset + 9];
  var footerPresent = (flags & 16) >> 4;
  if (footerPresent) {
    return returnSize + 20;
  }
  return returnSize + 10;
};
var getId3Offset = function getId3Offset(bytes, offset) {
  if (offset === void 0) {
    offset = 0;
  }
  bytes = byte_helpers_toUint8(bytes);
  if (bytes.length - offset < 10 || !byte_helpers_bytesMatch(bytes, ID3, {
    offset: offset
  })) {
    return offset;
  }
  offset += getId3Size(bytes, offset); // recursive check for id3 tags as some files
  // have multiple ID3 tag sections even though
  // they should not.

  return getId3Offset(bytes, offset);
};
;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/codec-helpers.js





 // https://aomediacodec.github.io/av1-isobmff/#av1codecconfigurationbox-syntax
// https://developer.mozilla.org/en-US/docs/Web/Media/Formats/codecs_parameter#AV1

var codec_helpers_getAv1Codec = function getAv1Codec(bytes) {
  var codec = '';
  var profile = bytes[1] >>> 3;
  var level = bytes[1] & 0x1F;
  var tier = bytes[2] >>> 7;
  var highBitDepth = (bytes[2] & 0x40) >> 6;
  var twelveBit = (bytes[2] & 0x20) >> 5;
  var monochrome = (bytes[2] & 0x10) >> 4;
  var chromaSubsamplingX = (bytes[2] & 0x08) >> 3;
  var chromaSubsamplingY = (bytes[2] & 0x04) >> 2;
  var chromaSamplePosition = bytes[2] & 0x03;
  codec += profile + "." + padStart(level, 2, '0');
  if (tier === 0) {
    codec += 'M';
  } else if (tier === 1) {
    codec += 'H';
  }
  var bitDepth;
  if (profile === 2 && highBitDepth) {
    bitDepth = twelveBit ? 12 : 10;
  } else {
    bitDepth = highBitDepth ? 10 : 8;
  }
  codec += "." + padStart(bitDepth, 2, '0'); // TODO: can we parse color range??

  codec += "." + monochrome;
  codec += "." + chromaSubsamplingX + chromaSubsamplingY + chromaSamplePosition;
  return codec;
};
var codec_helpers_getAvcCodec = function getAvcCodec(bytes) {
  var profileId = toHexString(bytes[1]);
  var constraintFlags = toHexString(bytes[2] & 0xFC);
  var levelId = toHexString(bytes[3]);
  return "" + profileId + constraintFlags + levelId;
};
var codec_helpers_getHvcCodec = function getHvcCodec(bytes) {
  var codec = '';
  var profileSpace = bytes[1] >> 6;
  var profileId = bytes[1] & 0x1F;
  var tierFlag = (bytes[1] & 0x20) >> 5;
  var profileCompat = bytes.subarray(2, 6);
  var constraintIds = bytes.subarray(6, 12);
  var levelId = bytes[12];
  if (profileSpace === 1) {
    codec += 'A';
  } else if (profileSpace === 2) {
    codec += 'B';
  } else if (profileSpace === 3) {
    codec += 'C';
  }
  codec += profileId + "."; // ffmpeg does this in big endian

  var profileCompatVal = parseInt(toBinaryString(profileCompat).split('').reverse().join(''), 2); // apple does this in little endian...

  if (profileCompatVal > 255) {
    profileCompatVal = parseInt(toBinaryString(profileCompat), 2);
  }
  codec += profileCompatVal.toString(16) + ".";
  if (tierFlag === 0) {
    codec += 'L';
  } else {
    codec += 'H';
  }
  codec += levelId;
  var constraints = '';
  for (var i = 0; i < constraintIds.length; i++) {
    var v = constraintIds[i];
    if (v) {
      if (constraints) {
        constraints += '.';
      }
      constraints += v.toString(16);
    }
  }
  if (constraints) {
    codec += "." + constraints;
  }
  return codec;
};
;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/opus-helpers.js



























var OPUS_HEAD = new Uint8Array([
// O, p, u, s
0x4f, 0x70, 0x75, 0x73,
// H, e, a, d
0x48, 0x65, 0x61, 0x64]); // https://wiki.xiph.org/OggOpus
// https://vfrmaniac.fushizen.eu/contents/opus_in_isobmff.html
// https://opus-codec.org/docs/opusfile_api-0.7/structOpusHead.html

var opus_helpers_parseOpusHead = function parseOpusHead(bytes) {
  var view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
  var version = view.getUint8(0); // version 0, from mp4, does not use littleEndian.

  var littleEndian = version !== 0;
  var config = {
    version: version,
    channels: view.getUint8(1),
    preSkip: view.getUint16(2, littleEndian),
    sampleRate: view.getUint32(4, littleEndian),
    outputGain: view.getUint16(8, littleEndian),
    channelMappingFamily: view.getUint8(10)
  };
  if (config.channelMappingFamily > 0 && bytes.length > 10) {
    config.streamCount = view.getUint8(11);
    config.twoChannelStreamCount = view.getUint8(12);
    config.channelMapping = [];
    for (var c = 0; c < config.channels; c++) {
      config.channelMapping.push(view.getUint8(13 + c));
    }
  }
  return config;
};
var setOpusHead = function setOpusHead(config) {
  var size = config.channelMappingFamily <= 0 ? 11 : 12 + config.channels;
  var view = new DataView(new ArrayBuffer(size));
  var littleEndian = config.version !== 0;
  view.setUint8(0, config.version);
  view.setUint8(1, config.channels);
  view.setUint16(2, config.preSkip, littleEndian);
  view.setUint32(4, config.sampleRate, littleEndian);
  view.setUint16(8, config.outputGain, littleEndian);
  view.setUint8(10, config.channelMappingFamily);
  if (config.channelMappingFamily > 0) {
    view.setUint8(11, config.streamCount);
    config.channelMapping.foreach(function (cm, i) {
      view.setUint8(12 + i, cm);
    });
  }
  return new Uint8Array(view.buffer);
};
;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/mp4-helpers.js










var normalizePath = function normalizePath(path) {
  if (typeof path === 'string') {
    return stringToBytes(path);
  }
  if (typeof path === 'number') {
    return path;
  }
  return path;
};
var normalizePaths = function normalizePaths(paths) {
  if (!Array.isArray(paths)) {
    return [normalizePath(paths)];
  }
  return paths.map(function (p) {
    return normalizePath(p);
  });
};
var DESCRIPTORS;
var parseDescriptors = function parseDescriptors(bytes) {
  bytes = byte_helpers_toUint8(bytes);
  var results = [];
  var i = 0;
  while (bytes.length > i) {
    var tag = bytes[i];
    var size = 0;
    var headerSize = 0; // tag

    headerSize++;
    var byte = bytes[headerSize]; // first byte

    headerSize++;
    while (byte & 0x80) {
      size = (byte & 0x7F) << 7;
      byte = bytes[headerSize];
      headerSize++;
    }
    size += byte & 0x7F;
    for (var z = 0; z < DESCRIPTORS.length; z++) {
      var _DESCRIPTORS$z = DESCRIPTORS[z],
        id = _DESCRIPTORS$z.id,
        parser = _DESCRIPTORS$z.parser;
      if (tag === id) {
        results.push(parser(bytes.subarray(headerSize, headerSize + size)));
        break;
      }
    }
    i += size + headerSize;
  }
  return results;
};
DESCRIPTORS = [{
  id: 0x03,
  parser: function parser(bytes) {
    var desc = {
      tag: 0x03,
      id: bytes[0] << 8 | bytes[1],
      flags: bytes[2],
      size: 3,
      dependsOnEsId: 0,
      ocrEsId: 0,
      descriptors: [],
      url: ''
    }; // depends on es id

    if (desc.flags & 0x80) {
      desc.dependsOnEsId = bytes[desc.size] << 8 | bytes[desc.size + 1];
      desc.size += 2;
    } // url

    if (desc.flags & 0x40) {
      var len = bytes[desc.size];
      desc.url = byte_helpers_bytesToString(bytes.subarray(desc.size + 1, desc.size + 1 + len));
      desc.size += len;
    } // ocr es id

    if (desc.flags & 0x20) {
      desc.ocrEsId = bytes[desc.size] << 8 | bytes[desc.size + 1];
      desc.size += 2;
    }
    desc.descriptors = parseDescriptors(bytes.subarray(desc.size)) || [];
    return desc;
  }
}, {
  id: 0x04,
  parser: function parser(bytes) {
    // DecoderConfigDescriptor
    var desc = {
      tag: 0x04,
      oti: bytes[0],
      streamType: bytes[1],
      bufferSize: bytes[2] << 16 | bytes[3] << 8 | bytes[4],
      maxBitrate: bytes[5] << 24 | bytes[6] << 16 | bytes[7] << 8 | bytes[8],
      avgBitrate: bytes[9] << 24 | bytes[10] << 16 | bytes[11] << 8 | bytes[12],
      descriptors: parseDescriptors(bytes.subarray(13))
    };
    return desc;
  }
}, {
  id: 0x05,
  parser: function parser(bytes) {
    // DecoderSpecificInfo
    return {
      tag: 0x05,
      bytes: bytes
    };
  }
}, {
  id: 0x06,
  parser: function parser(bytes) {
    // SLConfigDescriptor
    return {
      tag: 0x06,
      bytes: bytes
    };
  }
}];
/**
 * find any number of boxes by name given a path to it in an iso bmff
 * such as mp4.
 *
 * @param {TypedArray} bytes
 *        bytes for the iso bmff to search for boxes in
 *
 * @param {Uint8Array[]|string[]|string|Uint8Array} name
 *        An array of paths or a single path representing the name
 *        of boxes to search through in bytes. Paths may be
 *        uint8 (character codes) or strings.
 *
 * @param {boolean} [complete=false]
 *        Should we search only for complete boxes on the final path.
 *        This is very useful when you do not want to get back partial boxes
 *        in the case of streaming files.
 *
 * @return {Uint8Array[]}
 *         An array of the end paths that we found.
 */

var findBox = function findBox(bytes, paths, complete) {
  if (complete === void 0) {
    complete = false;
  }
  paths = normalizePaths(paths);
  bytes = byte_helpers_toUint8(bytes);
  var results = [];
  if (!paths.length) {
    // short-circuit the search for empty paths
    return results;
  }
  var i = 0;
  while (i < bytes.length) {
    var size = (bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]) >>> 0;
    var type = bytes.subarray(i + 4, i + 8); // invalid box format.

    if (size === 0) {
      break;
    }
    var end = i + size;
    if (end > bytes.length) {
      // this box is bigger than the number of bytes we have
      // and complete is set, we cannot find any more boxes.
      if (complete) {
        break;
      }
      end = bytes.length;
    }
    var data = bytes.subarray(i + 8, end);
    if (byte_helpers_bytesMatch(type, paths[0])) {
      if (paths.length === 1) {
        // this is the end of the path and we've found the box we were
        // looking for
        results.push(data);
      } else {
        // recursively search for the next box along the path
        results.push.apply(results, findBox(data, paths.slice(1), complete));
      }
    }
    i = end;
  } // we've finished searching all of bytes

  return results;
};
/**
 * Search for a single matching box by name in an iso bmff format like
 * mp4. This function is useful for finding codec boxes which
 * can be placed arbitrarily in sample descriptions depending
 * on the version of the file or file type.
 *
 * @param {TypedArray} bytes
 *        bytes for the iso bmff to search for boxes in
 *
 * @param {string|Uint8Array} name
 *        The name of the box to find.
 *
 * @return {Uint8Array[]}
 *         a subarray of bytes representing the name boxed we found.
 */

var findNamedBox = function findNamedBox(bytes, name) {
  name = normalizePath(name);
  if (!name.length) {
    // short-circuit the search for empty paths
    return bytes.subarray(bytes.length);
  }
  var i = 0;
  while (i < bytes.length) {
    if (bytesMatch(bytes.subarray(i, i + name.length), name)) {
      var size = (bytes[i - 4] << 24 | bytes[i - 3] << 16 | bytes[i - 2] << 8 | bytes[i - 1]) >>> 0;
      var end = size > 1 ? i + size : bytes.byteLength;
      return bytes.subarray(i + 4, end);
    }
    i++;
  } // we've finished searching all of bytes

  return bytes.subarray(bytes.length);
};
var parseSamples = function parseSamples(data, entrySize, parseEntry) {
  if (entrySize === void 0) {
    entrySize = 4;
  }
  if (parseEntry === void 0) {
    parseEntry = function parseEntry(d) {
      return bytesToNumber(d);
    };
  }
  var entries = [];
  if (!data || !data.length) {
    return entries;
  }
  var entryCount = bytesToNumber(data.subarray(4, 8));
  for (var i = 8; entryCount; i += entrySize, entryCount--) {
    entries.push(parseEntry(data.subarray(i, i + entrySize)));
  }
  return entries;
};
var buildFrameTable = function buildFrameTable(stbl, timescale) {
  var keySamples = parseSamples(findBox(stbl, ['stss'])[0]);
  var chunkOffsets = parseSamples(findBox(stbl, ['stco'])[0]);
  var timeToSamples = parseSamples(findBox(stbl, ['stts'])[0], 8, function (entry) {
    return {
      sampleCount: bytesToNumber(entry.subarray(0, 4)),
      sampleDelta: bytesToNumber(entry.subarray(4, 8))
    };
  });
  var samplesToChunks = parseSamples(findBox(stbl, ['stsc'])[0], 12, function (entry) {
    return {
      firstChunk: bytesToNumber(entry.subarray(0, 4)),
      samplesPerChunk: bytesToNumber(entry.subarray(4, 8)),
      sampleDescriptionIndex: bytesToNumber(entry.subarray(8, 12))
    };
  });
  var stsz = findBox(stbl, ['stsz'])[0]; // stsz starts with a 4 byte sampleSize which we don't need

  var sampleSizes = parseSamples(stsz && stsz.length && stsz.subarray(4) || null);
  var frames = [];
  for (var chunkIndex = 0; chunkIndex < chunkOffsets.length; chunkIndex++) {
    var samplesInChunk = void 0;
    for (var i = 0; i < samplesToChunks.length; i++) {
      var sampleToChunk = samplesToChunks[i];
      var isThisOne = chunkIndex + 1 >= sampleToChunk.firstChunk && (i + 1 >= samplesToChunks.length || chunkIndex + 1 < samplesToChunks[i + 1].firstChunk);
      if (isThisOne) {
        samplesInChunk = sampleToChunk.samplesPerChunk;
        break;
      }
    }
    var chunkOffset = chunkOffsets[chunkIndex];
    for (var _i = 0; _i < samplesInChunk; _i++) {
      var frameEnd = sampleSizes[frames.length]; // if we don't have key samples every frame is a keyframe

      var keyframe = !keySamples.length;
      if (keySamples.length && keySamples.indexOf(frames.length + 1) !== -1) {
        keyframe = true;
      }
      var frame = {
        keyframe: keyframe,
        start: chunkOffset,
        end: chunkOffset + frameEnd
      };
      for (var k = 0; k < timeToSamples.length; k++) {
        var _timeToSamples$k = timeToSamples[k],
          sampleCount = _timeToSamples$k.sampleCount,
          sampleDelta = _timeToSamples$k.sampleDelta;
        if (frames.length <= sampleCount) {
          // ms to ns
          var lastTimestamp = frames.length ? frames[frames.length - 1].timestamp : 0;
          frame.timestamp = lastTimestamp + sampleDelta / timescale * 1000;
          frame.duration = sampleDelta;
          break;
        }
      }
      frames.push(frame);
      chunkOffset += frameEnd;
    }
  }
  return frames;
};
var addSampleDescription = function addSampleDescription(track, bytes) {
  var codec = bytesToString(bytes.subarray(0, 4));
  if (track.type === 'video') {
    track.info = track.info || {};
    track.info.width = bytes[28] << 8 | bytes[29];
    track.info.height = bytes[30] << 8 | bytes[31];
  } else if (track.type === 'audio') {
    track.info = track.info || {};
    track.info.channels = bytes[20] << 8 | bytes[21];
    track.info.bitDepth = bytes[22] << 8 | bytes[23];
    track.info.sampleRate = bytes[28] << 8 | bytes[29];
  }
  if (codec === 'avc1') {
    var avcC = findNamedBox(bytes, 'avcC'); // AVCDecoderConfigurationRecord

    codec += "." + getAvcCodec(avcC);
    track.info.avcC = avcC; // TODO: do we need to parse all this?

    /* {
      configurationVersion: avcC[0],
      profile: avcC[1],
      profileCompatibility: avcC[2],
      level: avcC[3],
      lengthSizeMinusOne: avcC[4] & 0x3
    };
     let spsNalUnitCount = avcC[5] & 0x1F;
    const spsNalUnits = track.info.avc.spsNalUnits = [];
     // past spsNalUnitCount
    let offset = 6;
     while (spsNalUnitCount--) {
      const nalLen = avcC[offset] << 8 | avcC[offset + 1];
       spsNalUnits.push(avcC.subarray(offset + 2, offset + 2 + nalLen));
       offset += nalLen + 2;
    }
    let ppsNalUnitCount = avcC[offset];
    const ppsNalUnits = track.info.avc.ppsNalUnits = [];
     // past ppsNalUnitCount
    offset += 1;
     while (ppsNalUnitCount--) {
      const nalLen = avcC[offset] << 8 | avcC[offset + 1];
       ppsNalUnits.push(avcC.subarray(offset + 2, offset + 2 + nalLen));
       offset += nalLen + 2;
    }*/
    // HEVCDecoderConfigurationRecord
  } else if (codec === 'hvc1' || codec === 'hev1') {
    codec += "." + getHvcCodec(findNamedBox(bytes, 'hvcC'));
  } else if (codec === 'mp4a' || codec === 'mp4v') {
    var esds = findNamedBox(bytes, 'esds');
    var esDescriptor = parseDescriptors(esds.subarray(4))[0];
    var decoderConfig = esDescriptor && esDescriptor.descriptors.filter(function (_ref) {
      var tag = _ref.tag;
      return tag === 0x04;
    })[0];
    if (decoderConfig) {
      // most codecs do not have a further '.'
      // such as 0xa5 for ac-3 and 0xa6 for e-ac-3
      codec += '.' + toHexString(decoderConfig.oti);
      if (decoderConfig.oti === 0x40) {
        codec += '.' + (decoderConfig.descriptors[0].bytes[0] >> 3).toString();
      } else if (decoderConfig.oti === 0x20) {
        codec += '.' + decoderConfig.descriptors[0].bytes[4].toString();
      } else if (decoderConfig.oti === 0xdd) {
        codec = 'vorbis';
      }
    } else if (track.type === 'audio') {
      codec += '.40.2';
    } else {
      codec += '.20.9';
    }
  } else if (codec === 'av01') {
    // AV1DecoderConfigurationRecord
    codec += "." + getAv1Codec(findNamedBox(bytes, 'av1C'));
  } else if (codec === 'vp09') {
    // VPCodecConfigurationRecord
    var vpcC = findNamedBox(bytes, 'vpcC'); // https://www.webmproject.org/vp9/mp4/

    var profile = vpcC[0];
    var level = vpcC[1];
    var bitDepth = vpcC[2] >> 4;
    var chromaSubsampling = (vpcC[2] & 0x0F) >> 1;
    var videoFullRangeFlag = (vpcC[2] & 0x0F) >> 3;
    var colourPrimaries = vpcC[3];
    var transferCharacteristics = vpcC[4];
    var matrixCoefficients = vpcC[5];
    codec += "." + padStart(profile, 2, '0');
    codec += "." + padStart(level, 2, '0');
    codec += "." + padStart(bitDepth, 2, '0');
    codec += "." + padStart(chromaSubsampling, 2, '0');
    codec += "." + padStart(colourPrimaries, 2, '0');
    codec += "." + padStart(transferCharacteristics, 2, '0');
    codec += "." + padStart(matrixCoefficients, 2, '0');
    codec += "." + padStart(videoFullRangeFlag, 2, '0');
  } else if (codec === 'theo') {
    codec = 'theora';
  } else if (codec === 'spex') {
    codec = 'speex';
  } else if (codec === '.mp3') {
    codec = 'mp4a.40.34';
  } else if (codec === 'msVo') {
    codec = 'vorbis';
  } else if (codec === 'Opus') {
    codec = 'opus';
    var dOps = findNamedBox(bytes, 'dOps');
    track.info.opus = parseOpusHead(dOps); // TODO: should this go into the webm code??
    // Firefox requires a codecDelay for opus playback
    // see https://bugzilla.mozilla.org/show_bug.cgi?id=1276238

    track.info.codecDelay = 6500000;
  } else {
    codec = codec.toLowerCase();
  }
  /* eslint-enable */
  // flac, ac-3, ec-3, opus

  track.codec = codec;
};
var parseTracks = function parseTracks(bytes, frameTable) {
  if (frameTable === void 0) {
    frameTable = true;
  }
  bytes = toUint8(bytes);
  var traks = findBox(bytes, ['moov', 'trak'], true);
  var tracks = [];
  traks.forEach(function (trak) {
    var track = {
      bytes: trak
    };
    var mdia = findBox(trak, ['mdia'])[0];
    var hdlr = findBox(mdia, ['hdlr'])[0];
    var trakType = bytesToString(hdlr.subarray(8, 12));
    if (trakType === 'soun') {
      track.type = 'audio';
    } else if (trakType === 'vide') {
      track.type = 'video';
    } else {
      track.type = trakType;
    }
    var tkhd = findBox(trak, ['tkhd'])[0];
    if (tkhd) {
      var view = new DataView(tkhd.buffer, tkhd.byteOffset, tkhd.byteLength);
      var tkhdVersion = view.getUint8(0);
      track.number = tkhdVersion === 0 ? view.getUint32(12) : view.getUint32(20);
    }
    var mdhd = findBox(mdia, ['mdhd'])[0];
    if (mdhd) {
      // mdhd is a FullBox, meaning it will have its own version as the first byte
      var version = mdhd[0];
      var index = version === 0 ? 12 : 20;
      track.timescale = (mdhd[index] << 24 | mdhd[index + 1] << 16 | mdhd[index + 2] << 8 | mdhd[index + 3]) >>> 0;
    }
    var stbl = findBox(mdia, ['minf', 'stbl'])[0];
    var stsd = findBox(stbl, ['stsd'])[0];
    var descriptionCount = bytesToNumber(stsd.subarray(4, 8));
    var offset = 8; // add codec and codec info

    while (descriptionCount--) {
      var len = bytesToNumber(stsd.subarray(offset, offset + 4));
      var sampleDescriptor = stsd.subarray(offset + 4, offset + 4 + len);
      addSampleDescription(track, sampleDescriptor);
      offset += 4 + len;
    }
    if (frameTable) {
      track.frameTable = buildFrameTable(stbl, track.timescale);
    } // codec has no sub parameters

    tracks.push(track);
  });
  return tracks;
};
var parseMediaInfo = function parseMediaInfo(bytes) {
  var mvhd = findBox(bytes, ['moov', 'mvhd'], true)[0];
  if (!mvhd || !mvhd.length) {
    return;
  }
  var info = {}; // ms to ns
  // mvhd v1 has 8 byte duration and other fields too

  if (mvhd[0] === 1) {
    info.timestampScale = bytesToNumber(mvhd.subarray(20, 24));
    info.duration = bytesToNumber(mvhd.subarray(24, 32));
  } else {
    info.timestampScale = bytesToNumber(mvhd.subarray(12, 16));
    info.duration = bytesToNumber(mvhd.subarray(16, 20));
  }
  info.bytes = mvhd;
  return info;
};
;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/ebml-helpers.js










 // relevant specs for this parser:
// https://matroska-org.github.io/libebml/specs.html
// https://www.matroska.org/technical/elements.html
// https://www.webmproject.org/docs/container/

var EBML_TAGS = {
  EBML: byte_helpers_toUint8([0x1A, 0x45, 0xDF, 0xA3]),
  DocType: byte_helpers_toUint8([0x42, 0x82]),
  Segment: byte_helpers_toUint8([0x18, 0x53, 0x80, 0x67]),
  SegmentInfo: byte_helpers_toUint8([0x15, 0x49, 0xA9, 0x66]),
  Tracks: byte_helpers_toUint8([0x16, 0x54, 0xAE, 0x6B]),
  Track: byte_helpers_toUint8([0xAE]),
  TrackNumber: byte_helpers_toUint8([0xd7]),
  DefaultDuration: byte_helpers_toUint8([0x23, 0xe3, 0x83]),
  TrackEntry: byte_helpers_toUint8([0xAE]),
  TrackType: byte_helpers_toUint8([0x83]),
  FlagDefault: byte_helpers_toUint8([0x88]),
  CodecID: byte_helpers_toUint8([0x86]),
  CodecPrivate: byte_helpers_toUint8([0x63, 0xA2]),
  VideoTrack: byte_helpers_toUint8([0xe0]),
  AudioTrack: byte_helpers_toUint8([0xe1]),
  // Not used yet, but will be used for live webm/mkv
  // see https://www.matroska.org/technical/basics.html#block-structure
  // see https://www.matroska.org/technical/basics.html#simpleblock-structure
  Cluster: byte_helpers_toUint8([0x1F, 0x43, 0xB6, 0x75]),
  Timestamp: byte_helpers_toUint8([0xE7]),
  TimestampScale: byte_helpers_toUint8([0x2A, 0xD7, 0xB1]),
  BlockGroup: byte_helpers_toUint8([0xA0]),
  BlockDuration: byte_helpers_toUint8([0x9B]),
  Block: byte_helpers_toUint8([0xA1]),
  SimpleBlock: byte_helpers_toUint8([0xA3])
};
/**
 * This is a simple table to determine the length
 * of things in ebml. The length is one based (starts at 1,
 * rather than zero) and for every zero bit before a one bit
 * we add one to length. We also need this table because in some
 * case we have to xor all the length bits from another value.
 */

var LENGTH_TABLE = [128, 64, 32, 16, 8, 4, 2, 1];
var getLength = function getLength(byte) {
  var len = 1;
  for (var i = 0; i < LENGTH_TABLE.length; i++) {
    if (byte & LENGTH_TABLE[i]) {
      break;
    }
    len++;
  }
  return len;
}; // length in ebml is stored in the first 4 to 8 bits
// of the first byte. 4 for the id length and 8 for the
// data size length. Length is measured by converting the number to binary
// then 1 + the number of zeros before a 1 is encountered starting
// from the left.

var getvint = function getvint(bytes, offset, removeLength, signed) {
  if (removeLength === void 0) {
    removeLength = true;
  }
  if (signed === void 0) {
    signed = false;
  }
  var length = getLength(bytes[offset]);
  var valueBytes = bytes.subarray(offset, offset + length); // NOTE that we do **not** subarray here because we need to copy these bytes
  // as they will be modified below to remove the dataSizeLen bits and we do not
  // want to modify the original data. normally we could just call slice on
  // uint8array but ie 11 does not support that...

  if (removeLength) {
    valueBytes = Array.prototype.slice.call(bytes, offset, offset + length);
    valueBytes[0] ^= LENGTH_TABLE[length - 1];
  }
  return {
    length: length,
    value: byte_helpers_bytesToNumber(valueBytes, {
      signed: signed
    }),
    bytes: valueBytes
  };
};
var ebml_helpers_normalizePath = function normalizePath(path) {
  if (typeof path === 'string') {
    return path.match(/.{1,2}/g).map(function (p) {
      return normalizePath(p);
    });
  }
  if (typeof path === 'number') {
    return numberToBytes(path);
  }
  return path;
};
var ebml_helpers_normalizePaths = function normalizePaths(paths) {
  if (!Array.isArray(paths)) {
    return [ebml_helpers_normalizePath(paths)];
  }
  return paths.map(function (p) {
    return ebml_helpers_normalizePath(p);
  });
};
var getInfinityDataSize = function getInfinityDataSize(id, bytes, offset) {
  if (offset >= bytes.length) {
    return bytes.length;
  }
  var innerid = getvint(bytes, offset, false);
  if (byte_helpers_bytesMatch(id.bytes, innerid.bytes)) {
    return offset;
  }
  var dataHeader = getvint(bytes, offset + innerid.length);
  return getInfinityDataSize(id, bytes, offset + dataHeader.length + dataHeader.value + innerid.length);
};
/**
 * Notes on the EBLM format.
 *
 * EBLM uses "vints" tags. Every vint tag contains
 * two parts
 *
 * 1. The length from the first byte. You get this by
 *    converting the byte to binary and counting the zeros
 *    before a 1. Then you add 1 to that. Examples
 *    00011111 = length 4 because there are 3 zeros before a 1.
 *    00100000 = length 3 because there are 2 zeros before a 1.
 *    00000011 = length 7 because there are 6 zeros before a 1.
 *
 * 2. The bits used for length are removed from the first byte
 *    Then all the bytes are merged into a value. NOTE: this
 *    is not the case for id ebml tags as there id includes
 *    length bits.
 *
 */

var findEbml = function findEbml(bytes, paths) {
  paths = ebml_helpers_normalizePaths(paths);
  bytes = byte_helpers_toUint8(bytes);
  var results = [];
  if (!paths.length) {
    return results;
  }
  var i = 0;
  while (i < bytes.length) {
    var id = getvint(bytes, i, false);
    var dataHeader = getvint(bytes, i + id.length);
    var dataStart = i + id.length + dataHeader.length; // dataSize is unknown or this is a live stream

    if (dataHeader.value === 0x7f) {
      dataHeader.value = getInfinityDataSize(id, bytes, dataStart);
      if (dataHeader.value !== bytes.length) {
        dataHeader.value -= dataStart;
      }
    }
    var dataEnd = dataStart + dataHeader.value > bytes.length ? bytes.length : dataStart + dataHeader.value;
    var data = bytes.subarray(dataStart, dataEnd);
    if (byte_helpers_bytesMatch(paths[0], id.bytes)) {
      if (paths.length === 1) {
        // this is the end of the paths and we've found the tag we were
        // looking for
        results.push(data);
      } else {
        // recursively search for the next tag inside of the data
        // of this one
        results = results.concat(findEbml(data, paths.slice(1)));
      }
    }
    var totalLength = id.length + dataHeader.length + data.length; // move past this tag entirely, we are not looking for it

    i += totalLength;
  }
  return results;
}; // see https://www.matroska.org/technical/basics.html#block-structure

var decodeBlock = function decodeBlock(block, type, timestampScale, clusterTimestamp) {
  var duration;
  if (type === 'group') {
    duration = findEbml(block, [EBML_TAGS.BlockDuration])[0];
    if (duration) {
      duration = bytesToNumber(duration);
      duration = 1 / timestampScale * duration * timestampScale / 1000;
    }
    block = findEbml(block, [EBML_TAGS.Block])[0];
    type = 'block'; // treat data as a block after this point
  }

  var dv = new DataView(block.buffer, block.byteOffset, block.byteLength);
  var trackNumber = getvint(block, 0);
  var timestamp = dv.getInt16(trackNumber.length, false);
  var flags = block[trackNumber.length + 2];
  var data = block.subarray(trackNumber.length + 3); // pts/dts in seconds

  var ptsdts = 1 / timestampScale * (clusterTimestamp + timestamp) * timestampScale / 1000; // return the frame

  var parsed = {
    duration: duration,
    trackNumber: trackNumber.value,
    keyframe: type === 'simple' && flags >> 7 === 1,
    invisible: (flags & 0x08) >> 3 === 1,
    lacing: (flags & 0x06) >> 1,
    discardable: type === 'simple' && (flags & 0x01) === 1,
    frames: [],
    pts: ptsdts,
    dts: ptsdts,
    timestamp: timestamp
  };
  if (!parsed.lacing) {
    parsed.frames.push(data);
    return parsed;
  }
  var numberOfFrames = data[0] + 1;
  var frameSizes = [];
  var offset = 1; // Fixed

  if (parsed.lacing === 2) {
    var sizeOfFrame = (data.length - offset) / numberOfFrames;
    for (var i = 0; i < numberOfFrames; i++) {
      frameSizes.push(sizeOfFrame);
    }
  } // xiph

  if (parsed.lacing === 1) {
    for (var _i = 0; _i < numberOfFrames - 1; _i++) {
      var size = 0;
      do {
        size += data[offset];
        offset++;
      } while (data[offset - 1] === 0xFF);
      frameSizes.push(size);
    }
  } // ebml

  if (parsed.lacing === 3) {
    // first vint is unsinged
    // after that vints are singed and
    // based on a compounding size
    var _size = 0;
    for (var _i2 = 0; _i2 < numberOfFrames - 1; _i2++) {
      var vint = _i2 === 0 ? getvint(data, offset) : getvint(data, offset, true, true);
      _size += vint.value;
      frameSizes.push(_size);
      offset += vint.length;
    }
  }
  frameSizes.forEach(function (size) {
    parsed.frames.push(data.subarray(offset, offset + size));
    offset += size;
  });
  return parsed;
}; // VP9 Codec Feature Metadata (CodecPrivate)
// https://www.webmproject.org/docs/container/

var parseVp9Private = function parseVp9Private(bytes) {
  var i = 0;
  var params = {};
  while (i < bytes.length) {
    var id = bytes[i] & 0x7f;
    var len = bytes[i + 1];
    var val = void 0;
    if (len === 1) {
      val = bytes[i + 2];
    } else {
      val = bytes.subarray(i + 2, i + 2 + len);
    }
    if (id === 1) {
      params.profile = val;
    } else if (id === 2) {
      params.level = val;
    } else if (id === 3) {
      params.bitDepth = val;
    } else if (id === 4) {
      params.chromaSubsampling = val;
    } else {
      params[id] = val;
    }
    i += 2 + len;
  }
  return params;
};
var ebml_helpers_parseTracks = function parseTracks(bytes) {
  bytes = toUint8(bytes);
  var decodedTracks = [];
  var tracks = findEbml(bytes, [EBML_TAGS.Segment, EBML_TAGS.Tracks, EBML_TAGS.Track]);
  if (!tracks.length) {
    tracks = findEbml(bytes, [EBML_TAGS.Tracks, EBML_TAGS.Track]);
  }
  if (!tracks.length) {
    tracks = findEbml(bytes, [EBML_TAGS.Track]);
  }
  if (!tracks.length) {
    return decodedTracks;
  }
  tracks.forEach(function (track) {
    var trackType = findEbml(track, EBML_TAGS.TrackType)[0];
    if (!trackType || !trackType.length) {
      return;
    } // 1 is video, 2 is audio, 17 is subtitle
    // other values are unimportant in this context

    if (trackType[0] === 1) {
      trackType = 'video';
    } else if (trackType[0] === 2) {
      trackType = 'audio';
    } else if (trackType[0] === 17) {
      trackType = 'subtitle';
    } else {
      return;
    } // todo parse language

    var decodedTrack = {
      rawCodec: bytesToString(findEbml(track, [EBML_TAGS.CodecID])[0]),
      type: trackType,
      codecPrivate: findEbml(track, [EBML_TAGS.CodecPrivate])[0],
      number: bytesToNumber(findEbml(track, [EBML_TAGS.TrackNumber])[0]),
      defaultDuration: bytesToNumber(findEbml(track, [EBML_TAGS.DefaultDuration])[0]),
      default: findEbml(track, [EBML_TAGS.FlagDefault])[0],
      rawData: track
    };
    var codec = '';
    if (/V_MPEG4\/ISO\/AVC/.test(decodedTrack.rawCodec)) {
      codec = "avc1." + getAvcCodec(decodedTrack.codecPrivate);
    } else if (/V_MPEGH\/ISO\/HEVC/.test(decodedTrack.rawCodec)) {
      codec = "hev1." + getHvcCodec(decodedTrack.codecPrivate);
    } else if (/V_MPEG4\/ISO\/ASP/.test(decodedTrack.rawCodec)) {
      if (decodedTrack.codecPrivate) {
        codec = 'mp4v.20.' + decodedTrack.codecPrivate[4].toString();
      } else {
        codec = 'mp4v.20.9';
      }
    } else if (/^V_THEORA/.test(decodedTrack.rawCodec)) {
      codec = 'theora';
    } else if (/^V_VP8/.test(decodedTrack.rawCodec)) {
      codec = 'vp8';
    } else if (/^V_VP9/.test(decodedTrack.rawCodec)) {
      if (decodedTrack.codecPrivate) {
        var _parseVp9Private = parseVp9Private(decodedTrack.codecPrivate),
          profile = _parseVp9Private.profile,
          level = _parseVp9Private.level,
          bitDepth = _parseVp9Private.bitDepth,
          chromaSubsampling = _parseVp9Private.chromaSubsampling;
        codec = 'vp09.';
        codec += padStart(profile, 2, '0') + ".";
        codec += padStart(level, 2, '0') + ".";
        codec += padStart(bitDepth, 2, '0') + ".";
        codec += "" + padStart(chromaSubsampling, 2, '0'); // Video -> Colour -> Ebml name

        var matrixCoefficients = findEbml(track, [0xE0, [0x55, 0xB0], [0x55, 0xB1]])[0] || [];
        var videoFullRangeFlag = findEbml(track, [0xE0, [0x55, 0xB0], [0x55, 0xB9]])[0] || [];
        var transferCharacteristics = findEbml(track, [0xE0, [0x55, 0xB0], [0x55, 0xBA]])[0] || [];
        var colourPrimaries = findEbml(track, [0xE0, [0x55, 0xB0], [0x55, 0xBB]])[0] || []; // if we find any optional codec parameter specify them all.

        if (matrixCoefficients.length || videoFullRangeFlag.length || transferCharacteristics.length || colourPrimaries.length) {
          codec += "." + padStart(colourPrimaries[0], 2, '0');
          codec += "." + padStart(transferCharacteristics[0], 2, '0');
          codec += "." + padStart(matrixCoefficients[0], 2, '0');
          codec += "." + padStart(videoFullRangeFlag[0], 2, '0');
        }
      } else {
        codec = 'vp9';
      }
    } else if (/^V_AV1/.test(decodedTrack.rawCodec)) {
      codec = "av01." + getAv1Codec(decodedTrack.codecPrivate);
    } else if (/A_ALAC/.test(decodedTrack.rawCodec)) {
      codec = 'alac';
    } else if (/A_MPEG\/L2/.test(decodedTrack.rawCodec)) {
      codec = 'mp2';
    } else if (/A_MPEG\/L3/.test(decodedTrack.rawCodec)) {
      codec = 'mp3';
    } else if (/^A_AAC/.test(decodedTrack.rawCodec)) {
      if (decodedTrack.codecPrivate) {
        codec = 'mp4a.40.' + (decodedTrack.codecPrivate[0] >>> 3).toString();
      } else {
        codec = 'mp4a.40.2';
      }
    } else if (/^A_AC3/.test(decodedTrack.rawCodec)) {
      codec = 'ac-3';
    } else if (/^A_PCM/.test(decodedTrack.rawCodec)) {
      codec = 'pcm';
    } else if (/^A_MS\/ACM/.test(decodedTrack.rawCodec)) {
      codec = 'speex';
    } else if (/^A_EAC3/.test(decodedTrack.rawCodec)) {
      codec = 'ec-3';
    } else if (/^A_VORBIS/.test(decodedTrack.rawCodec)) {
      codec = 'vorbis';
    } else if (/^A_FLAC/.test(decodedTrack.rawCodec)) {
      codec = 'flac';
    } else if (/^A_OPUS/.test(decodedTrack.rawCodec)) {
      codec = 'opus';
    }
    decodedTrack.codec = codec;
    decodedTracks.push(decodedTrack);
  });
  return decodedTracks.sort(function (a, b) {
    return a.number - b.number;
  });
};
var parseData = function parseData(data, tracks) {
  var allBlocks = [];
  var segment = findEbml(data, [EBML_TAGS.Segment])[0];
  var timestampScale = findEbml(segment, [EBML_TAGS.SegmentInfo, EBML_TAGS.TimestampScale])[0]; // in nanoseconds, defaults to 1ms

  if (timestampScale && timestampScale.length) {
    timestampScale = bytesToNumber(timestampScale);
  } else {
    timestampScale = 1000000;
  }
  var clusters = findEbml(segment, [EBML_TAGS.Cluster]);
  if (!tracks) {
    tracks = ebml_helpers_parseTracks(segment);
  }
  clusters.forEach(function (cluster, ci) {
    var simpleBlocks = findEbml(cluster, [EBML_TAGS.SimpleBlock]).map(function (b) {
      return {
        type: 'simple',
        data: b
      };
    });
    var blockGroups = findEbml(cluster, [EBML_TAGS.BlockGroup]).map(function (b) {
      return {
        type: 'group',
        data: b
      };
    });
    var timestamp = findEbml(cluster, [EBML_TAGS.Timestamp])[0] || 0;
    if (timestamp && timestamp.length) {
      timestamp = bytesToNumber(timestamp);
    } // get all blocks then sort them into the correct order

    var blocks = simpleBlocks.concat(blockGroups).sort(function (a, b) {
      return a.data.byteOffset - b.data.byteOffset;
    });
    blocks.forEach(function (block, bi) {
      var decoded = decodeBlock(block.data, block.type, timestampScale, timestamp);
      allBlocks.push(decoded);
    });
  });
  return {
    tracks: tracks,
    blocks: allBlocks
  };
};
;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/nal-helpers.js




























var NAL_TYPE_ONE = byte_helpers_toUint8([0x00, 0x00, 0x00, 0x01]);
var NAL_TYPE_TWO = byte_helpers_toUint8([0x00, 0x00, 0x01]);
var EMULATION_PREVENTION = byte_helpers_toUint8([0x00, 0x00, 0x03]);
/**
 * Expunge any "Emulation Prevention" bytes from a "Raw Byte
 * Sequence Payload"
 *
 * @param data {Uint8Array} the bytes of a RBSP from a NAL
 * unit
 * @return {Uint8Array} the RBSP without any Emulation
 * Prevention Bytes
 */

var discardEmulationPreventionBytes = function discardEmulationPreventionBytes(bytes) {
  var positions = [];
  var i = 1; // Find all `Emulation Prevention Bytes`

  while (i < bytes.length - 2) {
    if (byte_helpers_bytesMatch(bytes.subarray(i, i + 3), EMULATION_PREVENTION)) {
      positions.push(i + 2);
      i++;
    }
    i++;
  } // If no Emulation Prevention Bytes were found just return the original
  // array

  if (positions.length === 0) {
    return bytes;
  } // Create a new array to hold the NAL unit data

  var newLength = bytes.length - positions.length;
  var newData = new Uint8Array(newLength);
  var sourceIndex = 0;
  for (i = 0; i < newLength; sourceIndex++, i++) {
    if (sourceIndex === positions[0]) {
      // Skip this byte
      sourceIndex++; // Remove this position index

      positions.shift();
    }
    newData[i] = bytes[sourceIndex];
  }
  return newData;
};
var findNal = function findNal(bytes, dataType, types, nalLimit) {
  if (nalLimit === void 0) {
    nalLimit = Infinity;
  }
  bytes = byte_helpers_toUint8(bytes);
  types = [].concat(types);
  var i = 0;
  var nalStart;
  var nalsFound = 0; // keep searching until:
  // we reach the end of bytes
  // we reach the maximum number of nals they want to seach
  // NOTE: that we disregard nalLimit when we have found the start
  // of the nal we want so that we can find the end of the nal we want.

  while (i < bytes.length && (nalsFound < nalLimit || nalStart)) {
    var nalOffset = void 0;
    if (byte_helpers_bytesMatch(bytes.subarray(i), NAL_TYPE_ONE)) {
      nalOffset = 4;
    } else if (byte_helpers_bytesMatch(bytes.subarray(i), NAL_TYPE_TWO)) {
      nalOffset = 3;
    } // we are unsynced,
    // find the next nal unit

    if (!nalOffset) {
      i++;
      continue;
    }
    nalsFound++;
    if (nalStart) {
      return discardEmulationPreventionBytes(bytes.subarray(nalStart, i));
    }
    var nalType = void 0;
    if (dataType === 'h264') {
      nalType = bytes[i + nalOffset] & 0x1f;
    } else if (dataType === 'h265') {
      nalType = bytes[i + nalOffset] >> 1 & 0x3f;
    }
    if (types.indexOf(nalType) !== -1) {
      nalStart = i + nalOffset;
    } // nal header is 1 length for h264, and 2 for h265

    i += nalOffset + (dataType === 'h264' ? 1 : 2);
  }
  return bytes.subarray(0, 0);
};
var findH264Nal = function findH264Nal(bytes, type, nalLimit) {
  return findNal(bytes, 'h264', type, nalLimit);
};
var findH265Nal = function findH265Nal(bytes, type, nalLimit) {
  return findNal(bytes, 'h265', type, nalLimit);
};
;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/containers.js









var CONSTANTS = {
  // "webm" string literal in hex
  'webm': byte_helpers_toUint8([0x77, 0x65, 0x62, 0x6d]),
  // "matroska" string literal in hex
  'matroska': byte_helpers_toUint8([0x6d, 0x61, 0x74, 0x72, 0x6f, 0x73, 0x6b, 0x61]),
  // "fLaC" string literal in hex
  'flac': byte_helpers_toUint8([0x66, 0x4c, 0x61, 0x43]),
  // "OggS" string literal in hex
  'ogg': byte_helpers_toUint8([0x4f, 0x67, 0x67, 0x53]),
  // ac-3 sync byte, also works for ec-3 as that is simply a codec
  // of ac-3
  'ac3': byte_helpers_toUint8([0x0b, 0x77]),
  // "RIFF" string literal in hex used for wav and avi
  'riff': byte_helpers_toUint8([0x52, 0x49, 0x46, 0x46]),
  // "AVI" string literal in hex
  'avi': byte_helpers_toUint8([0x41, 0x56, 0x49]),
  // "WAVE" string literal in hex
  'wav': byte_helpers_toUint8([0x57, 0x41, 0x56, 0x45]),
  // "ftyp3g" string literal in hex
  '3gp': byte_helpers_toUint8([0x66, 0x74, 0x79, 0x70, 0x33, 0x67]),
  // "ftyp" string literal in hex
  'mp4': byte_helpers_toUint8([0x66, 0x74, 0x79, 0x70]),
  // "styp" string literal in hex
  'fmp4': byte_helpers_toUint8([0x73, 0x74, 0x79, 0x70]),
  // "ftypqt" string literal in hex
  'mov': byte_helpers_toUint8([0x66, 0x74, 0x79, 0x70, 0x71, 0x74]),
  // moov string literal in hex
  'moov': byte_helpers_toUint8([0x6D, 0x6F, 0x6F, 0x76]),
  // moof string literal in hex
  'moof': byte_helpers_toUint8([0x6D, 0x6F, 0x6F, 0x66])
};
var _isLikely = {
  aac: function aac(bytes) {
    var offset = getId3Offset(bytes);
    return byte_helpers_bytesMatch(bytes, [0xFF, 0x10], {
      offset: offset,
      mask: [0xFF, 0x16]
    });
  },
  mp3: function mp3(bytes) {
    var offset = getId3Offset(bytes);
    return byte_helpers_bytesMatch(bytes, [0xFF, 0x02], {
      offset: offset,
      mask: [0xFF, 0x06]
    });
  },
  webm: function webm(bytes) {
    var docType = findEbml(bytes, [EBML_TAGS.EBML, EBML_TAGS.DocType])[0]; // check if DocType EBML tag is webm

    return byte_helpers_bytesMatch(docType, CONSTANTS.webm);
  },
  mkv: function mkv(bytes) {
    var docType = findEbml(bytes, [EBML_TAGS.EBML, EBML_TAGS.DocType])[0]; // check if DocType EBML tag is matroska

    return byte_helpers_bytesMatch(docType, CONSTANTS.matroska);
  },
  mp4: function mp4(bytes) {
    // if this file is another base media file format, it is not mp4
    if (_isLikely['3gp'](bytes) || _isLikely.mov(bytes)) {
      return false;
    } // if this file starts with a ftyp or styp box its mp4

    if (byte_helpers_bytesMatch(bytes, CONSTANTS.mp4, {
      offset: 4
    }) || byte_helpers_bytesMatch(bytes, CONSTANTS.fmp4, {
      offset: 4
    })) {
      return true;
    } // if this file starts with a moof/moov box its mp4

    if (byte_helpers_bytesMatch(bytes, CONSTANTS.moof, {
      offset: 4
    }) || byte_helpers_bytesMatch(bytes, CONSTANTS.moov, {
      offset: 4
    })) {
      return true;
    }
  },
  mov: function mov(bytes) {
    return byte_helpers_bytesMatch(bytes, CONSTANTS.mov, {
      offset: 4
    });
  },
  '3gp': function gp(bytes) {
    return byte_helpers_bytesMatch(bytes, CONSTANTS['3gp'], {
      offset: 4
    });
  },
  ac3: function ac3(bytes) {
    var offset = getId3Offset(bytes);
    return byte_helpers_bytesMatch(bytes, CONSTANTS.ac3, {
      offset: offset
    });
  },
  ts: function ts(bytes) {
    if (bytes.length < 189 && bytes.length >= 1) {
      return bytes[0] === 0x47;
    }
    var i = 0; // check the first 376 bytes for two matching sync bytes

    while (i + 188 < bytes.length && i < 188) {
      if (bytes[i] === 0x47 && bytes[i + 188] === 0x47) {
        return true;
      }
      i += 1;
    }
    return false;
  },
  flac: function flac(bytes) {
    var offset = getId3Offset(bytes);
    return byte_helpers_bytesMatch(bytes, CONSTANTS.flac, {
      offset: offset
    });
  },
  ogg: function ogg(bytes) {
    return byte_helpers_bytesMatch(bytes, CONSTANTS.ogg);
  },
  avi: function avi(bytes) {
    return byte_helpers_bytesMatch(bytes, CONSTANTS.riff) && byte_helpers_bytesMatch(bytes, CONSTANTS.avi, {
      offset: 8
    });
  },
  wav: function wav(bytes) {
    return byte_helpers_bytesMatch(bytes, CONSTANTS.riff) && byte_helpers_bytesMatch(bytes, CONSTANTS.wav, {
      offset: 8
    });
  },
  'h264': function h264(bytes) {
    // find seq_parameter_set_rbsp
    return findH264Nal(bytes, 7, 3).length;
  },
  'h265': function h265(bytes) {
    // find video_parameter_set_rbsp or seq_parameter_set_rbsp
    return findH265Nal(bytes, [32, 33], 3).length;
  }
}; // get all the isLikely functions
// but make sure 'ts' is above h264 and h265
// but below everything else as it is the least specific

var isLikelyTypes = Object.keys(_isLikely) // remove ts, h264, h265
.filter(function (t) {
  return t !== 'ts' && t !== 'h264' && t !== 'h265';
}) // add it back to the bottom
.concat(['ts', 'h264', 'h265']); // make sure we are dealing with uint8 data.

isLikelyTypes.forEach(function (type) {
  var isLikelyFn = _isLikely[type];
  _isLikely[type] = function (bytes) {
    return isLikelyFn(byte_helpers_toUint8(bytes));
  };
}); // export after wrapping

var isLikely = _isLikely; // A useful list of file signatures can be found here
// https://en.wikipedia.org/wiki/List_of_file_signatures

var detectContainerForBytes = function detectContainerForBytes(bytes) {
  bytes = byte_helpers_toUint8(bytes);
  for (var i = 0; i < isLikelyTypes.length; i++) {
    var type = isLikelyTypes[i];
    if (isLikely[type](bytes)) {
      return type;
    }
  }
  return '';
}; // fmp4 is not a container

var isLikelyFmp4MediaSegment = function isLikelyFmp4MediaSegment(bytes) {
  return findBox(bytes, ['moof']).length > 0;
};
// EXTERNAL MODULE: ./node_modules/mux.js/lib/utils/clock.js
var clock = __webpack_require__(52953);
;// CONCATENATED MODULE: ./node_modules/video.js/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js

function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

;// CONCATENATED MODULE: ./node_modules/video.js/node_modules/@babel/runtime/helpers/esm/isNativeFunction.js


function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}

;// CONCATENATED MODULE: ./node_modules/video.js/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js









function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}

;// CONCATENATED MODULE: ./node_modules/video.js/dist/video.es.js
function video_es_typeof(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){video_es_typeof=function _typeof(obj){return typeof obj;};}else{video_es_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return video_es_typeof(obj);}/**
 * @license
 * Video.js 7.21.6 <http://videojs.com/>
 * Copyright Brightcove, Inc. <https://www.brightcove.com/>
 * Available under Apache License Version 2.0
 * <https://github.com/videojs/video.js/blob/main/LICENSE>
 *
 * Includes vtt.js <https://github.com/mozilla/vtt.js>
 * Available under Apache License Version 2.0
 * <https://github.com/mozilla/vtt.js/blob/main/LICENSE>
 */var version$5="7.21.6";/**
 * An Object that contains lifecycle hooks as keys which point to an array
 * of functions that are run when a lifecycle is triggered
 *
 * @private
 */var hooks_={};/**
 * Get a list of hooks for a specific lifecycle
 *
 * @param  {string} type
 *         the lifecyle to get hooks from
 *
 * @param  {Function|Function[]} [fn]
 *         Optionally add a hook (or hooks) to the lifecycle that your are getting.
 *
 * @return {Array}
 *         an array of hooks, or an empty array if there are none.
 */var hooks=function hooks(type,fn){hooks_[type]=hooks_[type]||[];if(fn){hooks_[type]=hooks_[type].concat(fn);}return hooks_[type];};/**
 * Add a function hook to a specific videojs lifecycle.
 *
 * @param {string} type
 *        the lifecycle to hook the function to.
 *
 * @param {Function|Function[]}
 *        The function or array of functions to attach.
 */var hook=function hook(type,fn){hooks(type,fn);};/**
 * Remove a hook from a specific videojs lifecycle.
 *
 * @param  {string} type
 *         the lifecycle that the function hooked to
 *
 * @param  {Function} fn
 *         The hooked function to remove
 *
 * @return {boolean}
 *         The function that was removed or undef
 */var removeHook=function removeHook(type,fn){var index=hooks(type).indexOf(fn);if(index<=-1){return false;}hooks_[type]=hooks_[type].slice();hooks_[type].splice(index,1);return true;};/**
 * Add a function hook that will only run once to a specific videojs lifecycle.
 *
 * @param {string} type
 *        the lifecycle to hook the function to.
 *
 * @param {Function|Function[]}
 *        The function or array of functions to attach.
 */var hookOnce=function hookOnce(type,fn){hooks(type,[].concat(fn).map(function(original){var wrapper=function wrapper(){removeHook(type,wrapper);return original.apply(void 0,arguments);};return wrapper;}));};/**
 * @file fullscreen-api.js
 * @module fullscreen-api
 * @private
 */ /**
 * Store the browser-specific methods for the fullscreen API.
 *
 * @type {Object}
 * @see [Specification]{@link https://fullscreen.spec.whatwg.org}
 * @see [Map Approach From Screenfull.js]{@link https://github.com/sindresorhus/screenfull.js}
 */var FullscreenApi={prefixed:true};// browser API methods
var apiMap=[['requestFullscreen','exitFullscreen','fullscreenElement','fullscreenEnabled','fullscreenchange','fullscreenerror','fullscreen'],// WebKit
['webkitRequestFullscreen','webkitExitFullscreen','webkitFullscreenElement','webkitFullscreenEnabled','webkitfullscreenchange','webkitfullscreenerror','-webkit-full-screen'],// Mozilla
['mozRequestFullScreen','mozCancelFullScreen','mozFullScreenElement','mozFullScreenEnabled','mozfullscreenchange','mozfullscreenerror','-moz-full-screen'],// Microsoft
['msRequestFullscreen','msExitFullscreen','msFullscreenElement','msFullscreenEnabled','MSFullscreenChange','MSFullscreenError','-ms-fullscreen']];var specApi=apiMap[0];var browserApi;// determine the supported set of functions
for(var i=0;i<apiMap.length;i++){// check for exitFullscreen function
if(apiMap[i][1]in (document_default())){browserApi=apiMap[i];break;}}// map the browser API names to the spec API names
if(browserApi){for(var _i=0;_i<browserApi.length;_i++){FullscreenApi[specApi[_i]]=browserApi[_i];}FullscreenApi.prefixed=browserApi[0]!==specApi[0];}/**
 * @file create-logger.js
 * @module create-logger
 */var video_es_history=[];/**
 * Log messages to the console and history based on the type of message
 *
 * @private
 * @param  {string} type
 *         The name of the console method to use.
 *
 * @param  {Array} args
 *         The arguments to be passed to the matching console method.
 */var LogByTypeFactory=function LogByTypeFactory(name,log){return function(type,level,args){var lvl=log.levels[level];var lvlRegExp=new RegExp("^("+lvl+")$");if(type!=='log'){// Add the type to the front of the message when it's not "log".
args.unshift(type.toUpperCase()+':');}// Add console prefix after adding to history.
args.unshift(name+':');// Add a clone of the args at this point to history.
if(video_es_history){video_es_history.push([].concat(args));// only store 1000 history entries
var splice=video_es_history.length-1000;video_es_history.splice(0,splice>0?splice:0);}// If there's no console then don't try to output messages, but they will
// still be stored in history.
if(!(window_default()).console){return;}// Was setting these once outside of this function, but containing them
// in the function makes it easier to test cases where console doesn't exist
// when the module is executed.
var fn=(window_default()).console[type];if(!fn&&type==='debug'){// Certain browsers don't have support for console.debug. For those, we
// should default to the closest comparable log.
fn=(window_default()).console.info||(window_default()).console.log;}// Bail out if there's no console or if this type is not allowed by the
// current logging level.
if(!fn||!lvl||!lvlRegExp.test(type)){return;}fn[Array.isArray(args)?'apply':'call']((window_default()).console,args);};};function createLogger$1(name){// This is the private tracking variable for logging level.
var level='info';// the curried logByType bound to the specific log and history
var logByType;/**
   * Logs plain debug messages. Similar to `console.log`.
   *
   * Due to [limitations](https://github.com/jsdoc3/jsdoc/issues/955#issuecomment-313829149)
   * of our JSDoc template, we cannot properly document this as both a function
   * and a namespace, so its function signature is documented here.
   *
   * #### Arguments
   * ##### *args
   * Mixed[]
   *
   * Any combination of values that could be passed to `console.log()`.
   *
   * #### Return Value
   *
   * `undefined`
   *
   * @namespace
   * @param    {Mixed[]} args
   *           One or more messages or objects that should be logged.
   */var log=function log(){for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}logByType('log',level,args);};// This is the logByType helper that the logging methods below use
logByType=LogByTypeFactory(name,log);/**
   * Create a new sublogger which chains the old name to the new name.
   *
   * For example, doing `videojs.log.createLogger('player')` and then using that logger will log the following:
   * ```js
   *  mylogger('foo');
   *  // > VIDEOJS: player: foo
   * ```
   *
   * @param {string} name
   *        The name to add call the new logger
   * @return {Object}
   */log.createLogger=function(subname){return createLogger$1(name+': '+subname);};/**
   * Enumeration of available logging levels, where the keys are the level names
   * and the values are `|`-separated strings containing logging methods allowed
   * in that logging level. These strings are used to create a regular expression
   * matching the function name being called.
   *
   * Levels provided by Video.js are:
   *
   * - `off`: Matches no calls. Any value that can be cast to `false` will have
   *   this effect. The most restrictive.
   * - `all`: Matches only Video.js-provided functions (`debug`, `log`,
   *   `log.warn`, and `log.error`).
   * - `debug`: Matches `log.debug`, `log`, `log.warn`, and `log.error` calls.
   * - `info` (default): Matches `log`, `log.warn`, and `log.error` calls.
   * - `warn`: Matches `log.warn` and `log.error` calls.
   * - `error`: Matches only `log.error` calls.
   *
   * @type {Object}
   */log.levels={all:'debug|log|warn|error',off:'',debug:'debug|log|warn|error',info:'log|warn|error',warn:'warn|error',error:'error',DEFAULT:level};/**
   * Get or set the current logging level.
   *
   * If a string matching a key from {@link module:log.levels} is provided, acts
   * as a setter.
   *
   * @param  {string} [lvl]
   *         Pass a valid level to set a new logging level.
   *
   * @return {string}
   *         The current logging level.
   */log.level=function(lvl){if(typeof lvl==='string'){if(!log.levels.hasOwnProperty(lvl)){throw new Error("\""+lvl+"\" in not a valid log level");}level=lvl;}return level;};/**
   * Returns an array containing everything that has been logged to the history.
   *
   * This array is a shallow clone of the internal history record. However, its
   * contents are _not_ cloned; so, mutating objects inside this array will
   * mutate them in history.
   *
   * @return {Array}
   */log.history=function(){return video_es_history?[].concat(video_es_history):[];};/**
   * Allows you to filter the history by the given logger name
   *
   * @param {string} fname
   *        The name to filter by
   *
   * @return {Array}
   *         The filtered list to return
   */log.history.filter=function(fname){return(video_es_history||[]).filter(function(historyItem){// if the first item in each historyItem includes `fname`, then it's a match
return new RegExp(".*"+fname+".*").test(historyItem[0]);});};/**
   * Clears the internal history tracking, but does not prevent further history
   * tracking.
   */log.history.clear=function(){if(video_es_history){video_es_history.length=0;}};/**
   * Disable history tracking if it is currently enabled.
   */log.history.disable=function(){if(video_es_history!==null){video_es_history.length=0;video_es_history=null;}};/**
   * Enable history tracking if it is currently disabled.
   */log.history.enable=function(){if(video_es_history===null){video_es_history=[];}};/**
   * Logs error messages. Similar to `console.error`.
   *
   * @param {Mixed[]} args
   *        One or more messages or objects that should be logged as an error
   */log.error=function(){for(var _len2=arguments.length,args=new Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return logByType('error',level,args);};/**
   * Logs warning messages. Similar to `console.warn`.
   *
   * @param {Mixed[]} args
   *        One or more messages or objects that should be logged as a warning.
   */log.warn=function(){for(var _len3=arguments.length,args=new Array(_len3),_key3=0;_key3<_len3;_key3++){args[_key3]=arguments[_key3];}return logByType('warn',level,args);};/**
   * Logs debug messages. Similar to `console.debug`, but may also act as a comparable
   * log if `console.debug` is not available
   *
   * @param {Mixed[]} args
   *        One or more messages or objects that should be logged as debug.
   */log.debug=function(){for(var _len4=arguments.length,args=new Array(_len4),_key4=0;_key4<_len4;_key4++){args[_key4]=arguments[_key4];}return logByType('debug',level,args);};return log;}/**
 * @file log.js
 * @module log
 */var log$1=createLogger$1('VIDEOJS');var createLogger=log$1.createLogger;/**
 * @file obj.js
 * @module obj
 */ /**
 * @callback obj:EachCallback
 *
 * @param {Mixed} value
 *        The current key for the object that is being iterated over.
 *
 * @param {string} key
 *        The current key-value for object that is being iterated over
 */ /**
 * @callback obj:ReduceCallback
 *
 * @param {Mixed} accum
 *        The value that is accumulating over the reduce loop.
 *
 * @param {Mixed} value
 *        The current key for the object that is being iterated over.
 *
 * @param {string} key
 *        The current key-value for object that is being iterated over
 *
 * @return {Mixed}
 *         The new accumulated value.
 */var video_es_toString=Object.prototype.toString;/**
 * Get the keys of an Object
 *
 * @param {Object}
 *        The Object to get the keys from
 *
 * @return {string[]}
 *         An array of the keys from the object. Returns an empty array if the
 *         object passed in was invalid or had no keys.
 *
 * @private
 */var keys=function keys(object){return video_es_isObject(object)?Object.keys(object):[];};/**
 * Array-like iteration for objects.
 *
 * @param {Object} object
 *        The object to iterate over
 *
 * @param {obj:EachCallback} fn
 *        The callback function which is called for each key in the object.
 */function each(object,fn){keys(object).forEach(function(key){return fn(object[key],key);});}/**
 * Array-like reduce for objects.
 *
 * @param {Object} object
 *        The Object that you want to reduce.
 *
 * @param {Function} fn
 *         A callback function which is called for each key in the object. It
 *         receives the accumulated value and the per-iteration value and key
 *         as arguments.
 *
 * @param {Mixed} [initial = 0]
 *        Starting value
 *
 * @return {Mixed}
 *         The final accumulated value.
 */function reduce(object,fn,initial){if(initial===void 0){initial=0;}return keys(object).reduce(function(accum,key){return fn(accum,object[key],key);},initial);}/**
 * Object.assign-style object shallow merge/extend.
 *
 * @param  {Object} target
 * @param  {Object} ...sources
 * @return {Object}
 */function video_es_assign(target){for(var _len=arguments.length,sources=new Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){sources[_key-1]=arguments[_key];}if(Object.assign){return _extends.apply(void 0,[target].concat(sources));}sources.forEach(function(source){if(!source){return;}each(source,function(value,key){target[key]=value;});});return target;}/**
 * Returns whether a value is an object of any kind - including DOM nodes,
 * arrays, regular expressions, etc. Not functions, though.
 *
 * This avoids the gotcha where using `typeof` on a `null` value
 * results in `'object'`.
 *
 * @param  {Object} value
 * @return {boolean}
 */function video_es_isObject(value){return!!value&&video_es_typeof(value)==='object';}/**
 * Returns whether an object appears to be a "plain" object - that is, a
 * direct instance of `Object`.
 *
 * @param  {Object} value
 * @return {boolean}
 */function isPlain(value){return video_es_isObject(value)&&video_es_toString.call(value)==='[object Object]'&&value.constructor===Object;}/**
 * @file computed-style.js
 * @module computed-style
 */ /**
 * A safe getComputedStyle.
 *
 * This is needed because in Firefox, if the player is loaded in an iframe with
 * `display:none`, then `getComputedStyle` returns `null`, so, we do a
 * null-check to make sure that the player doesn't break in these cases.
 *
 * @function
 * @param    {Element} el
 *           The element you want the computed style of
 *
 * @param    {string} prop
 *           The property name you want
 *
 * @see      https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */function computedStyle(el,prop){if(!el||!prop){return'';}if(typeof (window_default()).getComputedStyle==='function'){var computedStyleValue;try{computedStyleValue=window_default().getComputedStyle(el);}catch(e){return'';}return computedStyleValue?computedStyleValue.getPropertyValue(prop)||computedStyleValue[prop]:'';}return'';}/**
 * @file browser.js
 * @module browser
 */var USER_AGENT=(window_default()).navigator&&(window_default()).navigator.userAgent||'';var webkitVersionMap=/AppleWebKit\/([\d.]+)/i.exec(USER_AGENT);var appleWebkitVersion=webkitVersionMap?parseFloat(webkitVersionMap.pop()):null;/**
 * Whether or not this device is an iPod.
 *
 * @static
 * @const
 * @type {Boolean}
 */var IS_IPOD=/iPod/i.test(USER_AGENT);/**
 * The detected iOS version - or `null`.
 *
 * @static
 * @const
 * @type {string|null}
 */var IOS_VERSION=function(){var match=USER_AGENT.match(/OS (\d+)_/i);if(match&&match[1]){return match[1];}return null;}();/**
 * Whether or not this is an Android device.
 *
 * @static
 * @const
 * @type {Boolean}
 */var IS_ANDROID=/Android/i.test(USER_AGENT);/**
 * The detected Android version - or `null`.
 *
 * @static
 * @const
 * @type {number|string|null}
 */var ANDROID_VERSION=function(){// This matches Android Major.Minor.Patch versions
// ANDROID_VERSION is Major.Minor as a Number, if Minor isn't available, then only Major is returned
var match=USER_AGENT.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);if(!match){return null;}var major=match[1]&&parseFloat(match[1]);var minor=match[2]&&parseFloat(match[2]);if(major&&minor){return parseFloat(match[1]+'.'+match[2]);}else if(major){return major;}return null;}();/**
 * Whether or not this is a native Android browser.
 *
 * @static
 * @const
 * @type {Boolean}
 */var IS_NATIVE_ANDROID=IS_ANDROID&&ANDROID_VERSION<5&&appleWebkitVersion<537;/**
 * Whether or not this is Mozilla Firefox.
 *
 * @static
 * @const
 * @type {Boolean}
 */var IS_FIREFOX=/Firefox/i.test(USER_AGENT);/**
 * Whether or not this is Microsoft Edge.
 *
 * @static
 * @const
 * @type {Boolean}
 */var IS_EDGE=/Edg/i.test(USER_AGENT);/**
 * Whether or not this is Google Chrome.
 *
 * This will also be `true` for Chrome on iOS, which will have different support
 * as it is actually Safari under the hood.
 *
 * @static
 * @const
 * @type {Boolean}
 */var IS_CHROME=!IS_EDGE&&(/Chrome/i.test(USER_AGENT)||/CriOS/i.test(USER_AGENT));/**
 * The detected Google Chrome version - or `null`.
 *
 * @static
 * @const
 * @type {number|null}
 */var CHROME_VERSION=function(){var match=USER_AGENT.match(/(Chrome|CriOS)\/(\d+)/);if(match&&match[2]){return parseFloat(match[2]);}return null;}();/**
 * The detected Internet Explorer version - or `null`.
 *
 * @static
 * @const
 * @type {number|null}
 */var IE_VERSION=function(){var result=/MSIE\s(\d+)\.\d/.exec(USER_AGENT);var version=result&&parseFloat(result[1]);if(!version&&/Trident\/7.0/i.test(USER_AGENT)&&/rv:11.0/.test(USER_AGENT)){// IE 11 has a different user agent string than other IE versions
version=11.0;}return version;}();/**
 * Whether or not this is desktop Safari.
 *
 * @static
 * @const
 * @type {Boolean}
 */var IS_SAFARI=/Safari/i.test(USER_AGENT)&&!IS_CHROME&&!IS_ANDROID&&!IS_EDGE;/**
 * Whether or not this is a Windows machine.
 *
 * @static
 * @const
 * @type {Boolean}
 */var IS_WINDOWS=/Windows/i.test(USER_AGENT);/**
 * Whether or not this device is touch-enabled.
 *
 * @static
 * @const
 * @type {Boolean}
 */var TOUCH_ENABLED=Boolean(isReal()&&('ontouchstart'in (window_default())||(window_default()).navigator.maxTouchPoints||(window_default()).DocumentTouch&&(window_default()).document instanceof (window_default()).DocumentTouch));/**
 * Whether or not this device is an iPad.
 *
 * @static
 * @const
 * @type {Boolean}
 */var IS_IPAD=/iPad/i.test(USER_AGENT)||IS_SAFARI&&TOUCH_ENABLED&&!/iPhone/i.test(USER_AGENT);/**
 * Whether or not this device is an iPhone.
 *
 * @static
 * @const
 * @type {Boolean}
 */ // The Facebook app's UIWebView identifies as both an iPhone and iPad, so
// to identify iPhones, we need to exclude iPads.
// http://artsy.github.io/blog/2012/10/18/the-perils-of-ios-user-agent-sniffing/
var IS_IPHONE=/iPhone/i.test(USER_AGENT)&&!IS_IPAD;/**
 * Whether or not this is an iOS device.
 *
 * @static
 * @const
 * @type {Boolean}
 */var IS_IOS=IS_IPHONE||IS_IPAD||IS_IPOD;/**
 * Whether or not this is any flavor of Safari - including iOS.
 *
 * @static
 * @const
 * @type {Boolean}
 */var IS_ANY_SAFARI=(IS_SAFARI||IS_IOS)&&!IS_CHROME;var video_es_browser=/*#__PURE__*/Object.freeze({__proto__:null,IS_IPOD:IS_IPOD,IOS_VERSION:IOS_VERSION,IS_ANDROID:IS_ANDROID,ANDROID_VERSION:ANDROID_VERSION,IS_NATIVE_ANDROID:IS_NATIVE_ANDROID,IS_FIREFOX:IS_FIREFOX,IS_EDGE:IS_EDGE,IS_CHROME:IS_CHROME,CHROME_VERSION:CHROME_VERSION,IE_VERSION:IE_VERSION,IS_SAFARI:IS_SAFARI,IS_WINDOWS:IS_WINDOWS,TOUCH_ENABLED:TOUCH_ENABLED,IS_IPAD:IS_IPAD,IS_IPHONE:IS_IPHONE,IS_IOS:IS_IOS,IS_ANY_SAFARI:IS_ANY_SAFARI});/**
 * @file dom.js
 * @module dom
 */ /**
 * Detect if a value is a string with any non-whitespace characters.
 *
 * @private
 * @param  {string} str
 *         The string to check
 *
 * @return {boolean}
 *         Will be `true` if the string is non-blank, `false` otherwise.
 *
 */function isNonBlankString(str){// we use str.trim as it will trim any whitespace characters
// from the front or back of non-whitespace characters. aka
// Any string that contains non-whitespace characters will
// still contain them after `trim` but whitespace only strings
// will have a length of 0, failing this check.
return typeof str==='string'&&Boolean(str.trim());}/**
 * Throws an error if the passed string has whitespace. This is used by
 * class methods to be relatively consistent with the classList API.
 *
 * @private
 * @param  {string} str
 *         The string to check for whitespace.
 *
 * @throws {Error}
 *         Throws an error if there is whitespace in the string.
 */function throwIfWhitespace(str){// str.indexOf instead of regex because str.indexOf is faster performance wise.
if(str.indexOf(' ')>=0){throw new Error('class has illegal whitespace characters');}}/**
 * Produce a regular expression for matching a className within an elements className.
 *
 * @private
 * @param  {string} className
 *         The className to generate the RegExp for.
 *
 * @return {RegExp}
 *         The RegExp that will check for a specific `className` in an elements
 *         className.
 */function classRegExp(className){return new RegExp('(^|\\s)'+className+'($|\\s)');}/**
 * Whether the current DOM interface appears to be real (i.e. not simulated).
 *
 * @return {boolean}
 *         Will be `true` if the DOM appears to be real, `false` otherwise.
 */function isReal(){// Both document and window will never be undefined thanks to `global`.
return (document_default())===(window_default()).document;}/**
 * Determines, via duck typing, whether or not a value is a DOM element.
 *
 * @param  {Mixed} value
 *         The value to check.
 *
 * @return {boolean}
 *         Will be `true` if the value is a DOM element, `false` otherwise.
 */function isEl(value){return video_es_isObject(value)&&value.nodeType===1;}/**
 * Determines if the current DOM is embedded in an iframe.
 *
 * @return {boolean}
 *         Will be `true` if the DOM is embedded in an iframe, `false`
 *         otherwise.
 */function isInFrame(){// We need a try/catch here because Safari will throw errors when attempting
// to get either `parent` or `self`
try{return (window_default()).parent!==(window_default()).self;}catch(x){return true;}}/**
 * Creates functions to query the DOM using a given method.
 *
 * @private
 * @param   {string} method
 *          The method to create the query with.
 *
 * @return  {Function}
 *          The query method
 */function createQuerier(method){return function(selector,context){if(!isNonBlankString(selector)){return (document_default())[method](null);}if(isNonBlankString(context)){context=document_default().querySelector(context);}var ctx=isEl(context)?context:(document_default());return ctx[method]&&ctx[method](selector);};}/**
 * Creates an element and applies properties, attributes, and inserts content.
 *
 * @param  {string} [tagName='div']
 *         Name of tag to be created.
 *
 * @param  {Object} [properties={}]
 *         Element properties to be applied.
 *
 * @param  {Object} [attributes={}]
 *         Element attributes to be applied.
 *
 * @param {module:dom~ContentDescriptor} content
 *        A content descriptor object.
 *
 * @return {Element}
 *         The element that was created.
 */function createEl(tagName,properties,attributes,content){if(tagName===void 0){tagName='div';}if(properties===void 0){properties={};}if(attributes===void 0){attributes={};}var el=document_default().createElement(tagName);Object.getOwnPropertyNames(properties).forEach(function(propName){var val=properties[propName];// See #2176
// We originally were accepting both properties and attributes in the
// same object, but that doesn't work so well.
if(propName.indexOf('aria-')!==-1||propName==='role'||propName==='type'){log$1.warn('Setting attributes in the second argument of createEl()\n'+'has been deprecated. Use the third argument instead.\n'+("createEl(type, properties, attributes). Attempting to set "+propName+" to "+val+"."));el.setAttribute(propName,val);// Handle textContent since it's not supported everywhere and we have a
// method for it.
}else if(propName==='textContent'){textContent(el,val);}else if(el[propName]!==val||propName==='tabIndex'){el[propName]=val;}});Object.getOwnPropertyNames(attributes).forEach(function(attrName){el.setAttribute(attrName,attributes[attrName]);});if(content){appendContent(el,content);}return el;}/**
 * Injects text into an element, replacing any existing contents entirely.
 *
 * @param  {Element} el
 *         The element to add text content into
 *
 * @param  {string} text
 *         The text content to add.
 *
 * @return {Element}
 *         The element with added text content.
 */function textContent(el,text){if(typeof el.textContent==='undefined'){el.innerText=text;}else{el.textContent=text;}return el;}/**
 * Insert an element as the first child node of another
 *
 * @param {Element} child
 *        Element to insert
 *
 * @param {Element} parent
 *        Element to insert child into
 */function prependTo(child,parent){if(parent.firstChild){parent.insertBefore(child,parent.firstChild);}else{parent.appendChild(child);}}/**
 * Check if an element has a class name.
 *
 * @param  {Element} element
 *         Element to check
 *
 * @param  {string} classToCheck
 *         Class name to check for
 *
 * @return {boolean}
 *         Will be `true` if the element has a class, `false` otherwise.
 *
 * @throws {Error}
 *         Throws an error if `classToCheck` has white space.
 */function hasClass(element,classToCheck){throwIfWhitespace(classToCheck);if(element.classList){return element.classList.contains(classToCheck);}return classRegExp(classToCheck).test(element.className);}/**
 * Add a class name to an element.
 *
 * @param  {Element} element
 *         Element to add class name to.
 *
 * @param  {string} classToAdd
 *         Class name to add.
 *
 * @return {Element}
 *         The DOM element with the added class name.
 */function addClass(element,classToAdd){if(element.classList){element.classList.add(classToAdd);// Don't need to `throwIfWhitespace` here because `hasElClass` will do it
// in the case of classList not being supported.
}else if(!hasClass(element,classToAdd)){element.className=(element.className+' '+classToAdd).trim();}return element;}/**
 * Remove a class name from an element.
 *
 * @param  {Element} element
 *         Element to remove a class name from.
 *
 * @param  {string} classToRemove
 *         Class name to remove
 *
 * @return {Element}
 *         The DOM element with class name removed.
 */function removeClass(element,classToRemove){// Protect in case the player gets disposed
if(!element){log$1.warn("removeClass was called with an element that doesn't exist");return null;}if(element.classList){element.classList.remove(classToRemove);}else{throwIfWhitespace(classToRemove);element.className=element.className.split(/\s+/).filter(function(c){return c!==classToRemove;}).join(' ');}return element;}/**
 * The callback definition for toggleClass.
 *
 * @callback module:dom~PredicateCallback
 * @param    {Element} element
 *           The DOM element of the Component.
 *
 * @param    {string} classToToggle
 *           The `className` that wants to be toggled
 *
 * @return   {boolean|undefined}
 *           If `true` is returned, the `classToToggle` will be added to the
 *           `element`. If `false`, the `classToToggle` will be removed from
 *           the `element`. If `undefined`, the callback will be ignored.
 */ /**
 * Adds or removes a class name to/from an element depending on an optional
 * condition or the presence/absence of the class name.
 *
 * @param  {Element} element
 *         The element to toggle a class name on.
 *
 * @param  {string} classToToggle
 *         The class that should be toggled.
 *
 * @param  {boolean|module:dom~PredicateCallback} [predicate]
 *         See the return value for {@link module:dom~PredicateCallback}
 *
 * @return {Element}
 *         The element with a class that has been toggled.
 */function toggleClass(element,classToToggle,predicate){// This CANNOT use `classList` internally because IE11 does not support the
// second parameter to the `classList.toggle()` method! Which is fine because
// `classList` will be used by the add/remove functions.
var has=hasClass(element,classToToggle);if(typeof predicate==='function'){predicate=predicate(element,classToToggle);}if(typeof predicate!=='boolean'){predicate=!has;}// If the necessary class operation matches the current state of the
// element, no action is required.
if(predicate===has){return;}if(predicate){addClass(element,classToToggle);}else{removeClass(element,classToToggle);}return element;}/**
 * Apply attributes to an HTML element.
 *
 * @param {Element} el
 *        Element to add attributes to.
 *
 * @param {Object} [attributes]
 *        Attributes to be applied.
 */function setAttributes(el,attributes){Object.getOwnPropertyNames(attributes).forEach(function(attrName){var attrValue=attributes[attrName];if(attrValue===null||typeof attrValue==='undefined'||attrValue===false){el.removeAttribute(attrName);}else{el.setAttribute(attrName,attrValue===true?'':attrValue);}});}/**
 * Get an element's attribute values, as defined on the HTML tag.
 *
 * Attributes are not the same as properties. They're defined on the tag
 * or with setAttribute.
 *
 * @param  {Element} tag
 *         Element from which to get tag attributes.
 *
 * @return {Object}
 *         All attributes of the element. Boolean attributes will be `true` or
 *         `false`, others will be strings.
 */function getAttributes(tag){var obj={};// known boolean attributes
// we can check for matching boolean properties, but not all browsers
// and not all tags know about these attributes, so, we still want to check them manually
var knownBooleans=','+'autoplay,controls,playsinline,loop,muted,default,defaultMuted'+',';if(tag&&tag.attributes&&tag.attributes.length>0){var attrs=tag.attributes;for(var i=attrs.length-1;i>=0;i--){var attrName=attrs[i].name;var attrVal=attrs[i].value;// check for known booleans
// the matching element property will return a value for typeof
if(typeof tag[attrName]==='boolean'||knownBooleans.indexOf(','+attrName+',')!==-1){// the value of an included boolean attribute is typically an empty
// string ('') which would equal false if we just check for a false value.
// we also don't want support bad code like autoplay='false'
attrVal=attrVal!==null?true:false;}obj[attrName]=attrVal;}}return obj;}/**
 * Get the value of an element's attribute.
 *
 * @param {Element} el
 *        A DOM element.
 *
 * @param {string} attribute
 *        Attribute to get the value of.
 *
 * @return {string}
 *         The value of the attribute.
 */function getAttribute(el,attribute){return el.getAttribute(attribute);}/**
 * Set the value of an element's attribute.
 *
 * @param {Element} el
 *        A DOM element.
 *
 * @param {string} attribute
 *        Attribute to set.
 *
 * @param {string} value
 *        Value to set the attribute to.
 */function setAttribute(el,attribute,value){el.setAttribute(attribute,value);}/**
 * Remove an element's attribute.
 *
 * @param {Element} el
 *        A DOM element.
 *
 * @param {string} attribute
 *        Attribute to remove.
 */function removeAttribute(el,attribute){el.removeAttribute(attribute);}/**
 * Attempt to block the ability to select text.
 */function blockTextSelection(){document_default().body.focus();(document_default()).onselectstart=function(){return false;};}/**
 * Turn off text selection blocking.
 */function unblockTextSelection(){(document_default()).onselectstart=function(){return true;};}/**
 * Identical to the native `getBoundingClientRect` function, but ensures that
 * the method is supported at all (it is in all browsers we claim to support)
 * and that the element is in the DOM before continuing.
 *
 * This wrapper function also shims properties which are not provided by some
 * older browsers (namely, IE8).
 *
 * Additionally, some browsers do not support adding properties to a
 * `ClientRect`/`DOMRect` object; so, we shallow-copy it with the standard
 * properties (except `x` and `y` which are not widely supported). This helps
 * avoid implementations where keys are non-enumerable.
 *
 * @param  {Element} el
 *         Element whose `ClientRect` we want to calculate.
 *
 * @return {Object|undefined}
 *         Always returns a plain object - or `undefined` if it cannot.
 */function getBoundingClientRect(el){if(el&&el.getBoundingClientRect&&el.parentNode){var rect=el.getBoundingClientRect();var result={};['bottom','height','left','right','top','width'].forEach(function(k){if(rect[k]!==undefined){result[k]=rect[k];}});if(!result.height){result.height=parseFloat(computedStyle(el,'height'));}if(!result.width){result.width=parseFloat(computedStyle(el,'width'));}return result;}}/**
 * Represents the position of a DOM element on the page.
 *
 * @typedef  {Object} module:dom~Position
 *
 * @property {number} left
 *           Pixels to the left.
 *
 * @property {number} top
 *           Pixels from the top.
 */ /**
 * Get the position of an element in the DOM.
 *
 * Uses `getBoundingClientRect` technique from John Resig.
 *
 * @see http://ejohn.org/blog/getboundingclientrect-is-awesome/
 *
 * @param  {Element} el
 *         Element from which to get offset.
 *
 * @return {module:dom~Position}
 *         The position of the element that was passed in.
 */function findPosition(el){if(!el||el&&!el.offsetParent){return{left:0,top:0,width:0,height:0};}var width=el.offsetWidth;var height=el.offsetHeight;var left=0;var top=0;while(el.offsetParent&&el!==(document_default())[FullscreenApi.fullscreenElement]){left+=el.offsetLeft;top+=el.offsetTop;el=el.offsetParent;}return{left:left,top:top,width:width,height:height};}/**
 * Represents x and y coordinates for a DOM element or mouse pointer.
 *
 * @typedef  {Object} module:dom~Coordinates
 *
 * @property {number} x
 *           x coordinate in pixels
 *
 * @property {number} y
 *           y coordinate in pixels
 */ /**
 * Get the pointer position within an element.
 *
 * The base on the coordinates are the bottom left of the element.
 *
 * @param  {Element} el
 *         Element on which to get the pointer position on.
 *
 * @param  {EventTarget~Event} event
 *         Event object.
 *
 * @return {module:dom~Coordinates}
 *         A coordinates object corresponding to the mouse position.
 *
 */function getPointerPosition(el,event){var translated={x:0,y:0};if(IS_IOS){var item=el;while(item&&item.nodeName.toLowerCase()!=='html'){var transform=computedStyle(item,'transform');if(/^matrix/.test(transform)){var values=transform.slice(7,-1).split(/,\s/).map(Number);translated.x+=values[4];translated.y+=values[5];}else if(/^matrix3d/.test(transform)){var _values=transform.slice(9,-1).split(/,\s/).map(Number);translated.x+=_values[12];translated.y+=_values[13];}item=item.parentNode;}}var position={};var boxTarget=findPosition(event.target);var box=findPosition(el);var boxW=box.width;var boxH=box.height;var offsetY=event.offsetY-(box.top-boxTarget.top);var offsetX=event.offsetX-(box.left-boxTarget.left);if(event.changedTouches){offsetX=event.changedTouches[0].pageX-box.left;offsetY=event.changedTouches[0].pageY+box.top;if(IS_IOS){offsetX-=translated.x;offsetY-=translated.y;}}position.y=1-Math.max(0,Math.min(1,offsetY/boxH));position.x=Math.max(0,Math.min(1,offsetX/boxW));return position;}/**
 * Determines, via duck typing, whether or not a value is a text node.
 *
 * @param  {Mixed} value
 *         Check if this value is a text node.
 *
 * @return {boolean}
 *         Will be `true` if the value is a text node, `false` otherwise.
 */function isTextNode(value){return video_es_isObject(value)&&value.nodeType===3;}/**
 * Empties the contents of an element.
 *
 * @param  {Element} el
 *         The element to empty children from
 *
 * @return {Element}
 *         The element with no children
 */function emptyEl(el){while(el.firstChild){el.removeChild(el.firstChild);}return el;}/**
 * This is a mixed value that describes content to be injected into the DOM
 * via some method. It can be of the following types:
 *
 * Type       | Description
 * -----------|-------------
 * `string`   | The value will be normalized into a text node.
 * `Element`  | The value will be accepted as-is.
 * `TextNode` | The value will be accepted as-is.
 * `Array`    | A one-dimensional array of strings, elements, text nodes, or functions. These functions should return a string, element, or text node (any other return value, like an array, will be ignored).
 * `Function` | A function, which is expected to return a string, element, text node, or array - any of the other possible values described above. This means that a content descriptor could be a function that returns an array of functions, but those second-level functions must return strings, elements, or text nodes.
 *
 * @typedef {string|Element|TextNode|Array|Function} module:dom~ContentDescriptor
 */ /**
 * Normalizes content for eventual insertion into the DOM.
 *
 * This allows a wide range of content definition methods, but helps protect
 * from falling into the trap of simply writing to `innerHTML`, which could
 * be an XSS concern.
 *
 * The content for an element can be passed in multiple types and
 * combinations, whose behavior is as follows:
 *
 * @param {module:dom~ContentDescriptor} content
 *        A content descriptor value.
 *
 * @return {Array}
 *         All of the content that was passed in, normalized to an array of
 *         elements or text nodes.
 */function normalizeContent(content){// First, invoke content if it is a function. If it produces an array,
// that needs to happen before normalization.
if(typeof content==='function'){content=content();}// Next up, normalize to an array, so one or many items can be normalized,
// filtered, and returned.
return(Array.isArray(content)?content:[content]).map(function(value){// First, invoke value if it is a function to produce a new value,
// which will be subsequently normalized to a Node of some kind.
if(typeof value==='function'){value=value();}if(isEl(value)||isTextNode(value)){return value;}if(typeof value==='string'&&/\S/.test(value)){return document_default().createTextNode(value);}}).filter(function(value){return value;});}/**
 * Normalizes and appends content to an element.
 *
 * @param  {Element} el
 *         Element to append normalized content to.
 *
 * @param {module:dom~ContentDescriptor} content
 *        A content descriptor value.
 *
 * @return {Element}
 *         The element with appended normalized content.
 */function appendContent(el,content){normalizeContent(content).forEach(function(node){return el.appendChild(node);});return el;}/**
 * Normalizes and inserts content into an element; this is identical to
 * `appendContent()`, except it empties the element first.
 *
 * @param {Element} el
 *        Element to insert normalized content into.
 *
 * @param {module:dom~ContentDescriptor} content
 *        A content descriptor value.
 *
 * @return {Element}
 *         The element with inserted normalized content.
 */function insertContent(el,content){return appendContent(emptyEl(el),content);}/**
 * Check if an event was a single left click.
 *
 * @param  {EventTarget~Event} event
 *         Event object.
 *
 * @return {boolean}
 *         Will be `true` if a single left click, `false` otherwise.
 */function isSingleLeftClick(event){// Note: if you create something draggable, be sure to
// call it on both `mousedown` and `mousemove` event,
// otherwise `mousedown` should be enough for a button
if(event.button===undefined&&event.buttons===undefined){// Why do we need `buttons` ?
// Because, middle mouse sometimes have this:
// e.button === 0 and e.buttons === 4
// Furthermore, we want to prevent combination click, something like
// HOLD middlemouse then left click, that would be
// e.button === 0, e.buttons === 5
// just `button` is not gonna work
// Alright, then what this block does ?
// this is for chrome `simulate mobile devices`
// I want to support this as well
return true;}if(event.button===0&&event.buttons===undefined){// Touch screen, sometimes on some specific device, `buttons`
// doesn't have anything (safari on ios, blackberry...)
return true;}// `mouseup` event on a single left click has
// `button` and `buttons` equal to 0
if(event.type==='mouseup'&&event.button===0&&event.buttons===0){return true;}if(event.button!==0||event.buttons!==1){// This is the reason we have those if else block above
// if any special case we can catch and let it slide
// we do it above, when get to here, this definitely
// is-not-left-click
return false;}return true;}/**
 * Finds a single DOM element matching `selector` within the optional
 * `context` of another DOM element (defaulting to `document`).
 *
 * @param  {string} selector
 *         A valid CSS selector, which will be passed to `querySelector`.
 *
 * @param  {Element|String} [context=document]
 *         A DOM element within which to query. Can also be a selector
 *         string in which case the first matching element will be used
 *         as context. If missing (or no element matches selector), falls
 *         back to `document`.
 *
 * @return {Element|null}
 *         The element that was found or null.
 */var $=createQuerier('querySelector');/**
 * Finds a all DOM elements matching `selector` within the optional
 * `context` of another DOM element (defaulting to `document`).
 *
 * @param  {string} selector
 *         A valid CSS selector, which will be passed to `querySelectorAll`.
 *
 * @param  {Element|String} [context=document]
 *         A DOM element within which to query. Can also be a selector
 *         string in which case the first matching element will be used
 *         as context. If missing (or no element matches selector), falls
 *         back to `document`.
 *
 * @return {NodeList}
 *         A element list of elements that were found. Will be empty if none
 *         were found.
 *
 */var $$=createQuerier('querySelectorAll');var Dom=/*#__PURE__*/Object.freeze({__proto__:null,isReal:isReal,isEl:isEl,isInFrame:isInFrame,createEl:createEl,textContent:textContent,prependTo:prependTo,hasClass:hasClass,addClass:addClass,removeClass:removeClass,toggleClass:toggleClass,setAttributes:setAttributes,getAttributes:getAttributes,getAttribute:getAttribute,setAttribute:setAttribute,removeAttribute:removeAttribute,blockTextSelection:blockTextSelection,unblockTextSelection:unblockTextSelection,getBoundingClientRect:getBoundingClientRect,findPosition:findPosition,getPointerPosition:getPointerPosition,isTextNode:isTextNode,emptyEl:emptyEl,normalizeContent:normalizeContent,appendContent:appendContent,insertContent:insertContent,isSingleLeftClick:isSingleLeftClick,$:$,$$:$$});/**
 * @file setup.js - Functions for setting up a player without
 * user interaction based on the data-setup `attribute` of the video tag.
 *
 * @module setup
 */var _windowLoaded=false;var videojs$1;/**
 * Set up any tags that have a data-setup `attribute` when the player is started.
 */var autoSetup=function autoSetup(){if(videojs$1.options.autoSetup===false){return;}var vids=Array.prototype.slice.call(document_default().getElementsByTagName('video'));var audios=Array.prototype.slice.call(document_default().getElementsByTagName('audio'));var divs=Array.prototype.slice.call(document_default().getElementsByTagName('video-js'));var mediaEls=vids.concat(audios,divs);// Check if any media elements exist
if(mediaEls&&mediaEls.length>0){for(var i=0,e=mediaEls.length;i<e;i++){var mediaEl=mediaEls[i];// Check if element exists, has getAttribute func.
if(mediaEl&&mediaEl.getAttribute){// Make sure this player hasn't already been set up.
if(mediaEl.player===undefined){var options=mediaEl.getAttribute('data-setup');// Check if data-setup attr exists.
// We only auto-setup if they've added the data-setup attr.
if(options!==null){// Create new video.js instance.
videojs$1(mediaEl);}}// If getAttribute isn't defined, we need to wait for the DOM.
}else{autoSetupTimeout(1);break;}}// No videos were found, so keep looping unless page is finished loading.
}else if(!_windowLoaded){autoSetupTimeout(1);}};/**
 * Wait until the page is loaded before running autoSetup. This will be called in
 * autoSetup if `hasLoaded` returns false.
 *
 * @param {number} wait
 *        How long to wait in ms
 *
 * @param {module:videojs} [vjs]
 *        The videojs library function
 */function autoSetupTimeout(wait,vjs){// Protect against breakage in non-browser environments
if(!isReal()){return;}if(vjs){videojs$1=vjs;}window_default().setTimeout(autoSetup,wait);}/**
 * Used to set the internal tracking of window loaded state to true.
 *
 * @private
 */function setWindowLoaded(){_windowLoaded=true;window_default().removeEventListener('load',setWindowLoaded);}if(isReal()){if((document_default()).readyState==='complete'){setWindowLoaded();}else{/**
     * Listen for the load event on window, and set _windowLoaded to true.
     *
     * We use a standard event listener here to avoid incrementing the GUID
     * before any players are created.
     *
     * @listens load
     */window_default().addEventListener('load',setWindowLoaded);}}/**
 * @file stylesheet.js
 * @module stylesheet
 */ /**
 * Create a DOM syle element given a className for it.
 *
 * @param {string} className
 *        The className to add to the created style element.
 *
 * @return {Element}
 *         The element that was created.
 */var createStyleElement=function createStyleElement(className){var style=document_default().createElement('style');style.className=className;return style;};/**
 * Add text to a DOM element.
 *
 * @param {Element} el
 *        The Element to add text content to.
 *
 * @param {string} content
 *        The text to add to the element.
 */var setTextContent=function setTextContent(el,content){if(el.styleSheet){el.styleSheet.cssText=content;}else{el.textContent=content;}};/**
 * @file guid.js
 * @module guid
 */ // Default value for GUIDs. This allows us to reset the GUID counter in tests.
//
// The initial GUID is 3 because some users have come to rely on the first
// default player ID ending up as `vjs_video_3`.
//
// See: https://github.com/videojs/video.js/pull/6216
var _initialGuid=3;/**
 * Unique ID for an element or function
 *
 * @type {Number}
 */var _guid=_initialGuid;/**
 * Get a unique auto-incrementing ID by number that has not been returned before.
 *
 * @return {number}
 *         A new unique ID.
 */function newGUID(){return _guid++;}/**
 * @file dom-data.js
 * @module dom-data
 */var FakeWeakMap;if(!(window_default()).WeakMap){FakeWeakMap=/*#__PURE__*/function(){function FakeWeakMap(){this.vdata='vdata'+Math.floor((window_default()).performance&&window_default().performance.now()||Date.now());this.data={};}var _proto=FakeWeakMap.prototype;_proto.set=function set(key,value){var access=key[this.vdata]||newGUID();if(!key[this.vdata]){key[this.vdata]=access;}this.data[access]=value;return this;};_proto.get=function get(key){var access=key[this.vdata];// we have data, return it
if(access){return this.data[access];}// we don't have data, return nothing.
// return undefined explicitly as that's the contract for this method
log$1('We have no data for this element',key);return undefined;};_proto.has=function has(key){var access=key[this.vdata];return access in this.data;};_proto["delete"]=function _delete(key){var access=key[this.vdata];if(access){delete this.data[access];delete key[this.vdata];}};return FakeWeakMap;}();}/**
 * Element Data Store.
 *
 * Allows for binding data to an element without putting it directly on the
 * element. Ex. Event listeners are stored here.
 * (also from jsninja.com, slightly modified and updated for closure compiler)
 *
 * @type {Object}
 * @private
 */var DomData=(window_default()).WeakMap?new WeakMap():new FakeWeakMap();/**
 * @file events.js. An Event System (John Resig - Secrets of a JS Ninja http://jsninja.com/)
 * (Original book version wasn't completely usable, so fixed some things and made Closure Compiler compatible)
 * This should work very similarly to jQuery's events, however it's based off the book version which isn't as
 * robust as jquery's, so there's probably some differences.
 *
 * @file events.js
 * @module events
 */ /**
 * Clean up the listener cache and dispatchers
 *
 * @param {Element|Object} elem
 *        Element to clean up
 *
 * @param {string} type
 *        Type of event to clean up
 */function _cleanUpEvents(elem,type){if(!DomData.has(elem)){return;}var data=DomData.get(elem);// Remove the events of a particular type if there are none left
if(data.handlers[type].length===0){delete data.handlers[type];// data.handlers[type] = null;
// Setting to null was causing an error with data.handlers
// Remove the meta-handler from the element
if(elem.removeEventListener){elem.removeEventListener(type,data.dispatcher,false);}else if(elem.detachEvent){elem.detachEvent('on'+type,data.dispatcher);}}// Remove the events object if there are no types left
if(Object.getOwnPropertyNames(data.handlers).length<=0){delete data.handlers;delete data.dispatcher;delete data.disabled;}// Finally remove the element data if there is no data left
if(Object.getOwnPropertyNames(data).length===0){DomData["delete"](elem);}}/**
 * Loops through an array of event types and calls the requested method for each type.
 *
 * @param {Function} fn
 *        The event method we want to use.
 *
 * @param {Element|Object} elem
 *        Element or object to bind listeners to
 *
 * @param {string} type
 *        Type of event to bind to.
 *
 * @param {EventTarget~EventListener} callback
 *        Event listener.
 */function _handleMultipleEvents(fn,elem,types,callback){types.forEach(function(type){// Call the event method for each one of the types
fn(elem,type,callback);});}/**
 * Fix a native event to have standard property values
 *
 * @param {Object} event
 *        Event object to fix.
 *
 * @return {Object}
 *         Fixed event object.
 */function fixEvent(event){if(event.fixed_){return event;}function returnTrue(){return true;}function returnFalse(){return false;}// Test if fixing up is needed
// Used to check if !event.stopPropagation instead of isPropagationStopped
// But native events return true for stopPropagation, but don't have
// other expected methods like isPropagationStopped. Seems to be a problem
// with the Javascript Ninja code. So we're just overriding all events now.
if(!event||!event.isPropagationStopped||!event.isImmediatePropagationStopped){var old=event||(window_default()).event;event={};// Clone the old object so that we can modify the values event = {};
// IE8 Doesn't like when you mess with native event properties
// Firefox returns false for event.hasOwnProperty('type') and other props
//  which makes copying more difficult.
// TODO: Probably best to create a whitelist of event props
for(var key in old){// Safari 6.0.3 warns you if you try to copy deprecated layerX/Y
// Chrome warns you if you try to copy deprecated keyboardEvent.keyLocation
// and webkitMovementX/Y
// Lighthouse complains if Event.path is copied
if(key!=='layerX'&&key!=='layerY'&&key!=='keyLocation'&&key!=='webkitMovementX'&&key!=='webkitMovementY'&&key!=='path'){// Chrome 32+ warns if you try to copy deprecated returnValue, but
// we still want to if preventDefault isn't supported (IE8).
if(!(key==='returnValue'&&old.preventDefault)){event[key]=old[key];}}}// The event occurred on this element
if(!event.target){event.target=event.srcElement||(document_default());}// Handle which other element the event is related to
if(!event.relatedTarget){event.relatedTarget=event.fromElement===event.target?event.toElement:event.fromElement;}// Stop the default browser action
event.preventDefault=function(){if(old.preventDefault){old.preventDefault();}event.returnValue=false;old.returnValue=false;event.defaultPrevented=true;};event.defaultPrevented=false;// Stop the event from bubbling
event.stopPropagation=function(){if(old.stopPropagation){old.stopPropagation();}event.cancelBubble=true;old.cancelBubble=true;event.isPropagationStopped=returnTrue;};event.isPropagationStopped=returnFalse;// Stop the event from bubbling and executing other handlers
event.stopImmediatePropagation=function(){if(old.stopImmediatePropagation){old.stopImmediatePropagation();}event.isImmediatePropagationStopped=returnTrue;event.stopPropagation();};event.isImmediatePropagationStopped=returnFalse;// Handle mouse position
if(event.clientX!==null&&event.clientX!==undefined){var doc=(document_default()).documentElement;var body=(document_default()).body;event.pageX=event.clientX+(doc&&doc.scrollLeft||body&&body.scrollLeft||0)-(doc&&doc.clientLeft||body&&body.clientLeft||0);event.pageY=event.clientY+(doc&&doc.scrollTop||body&&body.scrollTop||0)-(doc&&doc.clientTop||body&&body.clientTop||0);}// Handle key presses
event.which=event.charCode||event.keyCode;// Fix button for mouse clicks:
// 0 == left; 1 == middle; 2 == right
if(event.button!==null&&event.button!==undefined){// The following is disabled because it does not pass videojs-standard
// and... yikes.
/* eslint-disable */event.button=event.button&1?0:event.button&4?1:event.button&2?2:0;/* eslint-enable */}}event.fixed_=true;// Returns fixed-up instance
return event;}/**
 * Whether passive event listeners are supported
 */var _supportsPassive;var supportsPassive=function supportsPassive(){if(typeof _supportsPassive!=='boolean'){_supportsPassive=false;try{var opts=Object.defineProperty({},'passive',{get:function get(){_supportsPassive=true;}});window_default().addEventListener('test',null,opts);window_default().removeEventListener('test',null,opts);}catch(e){// disregard
}}return _supportsPassive;};/**
 * Touch events Chrome expects to be passive
 */var passiveEvents=['touchstart','touchmove'];/**
 * Add an event listener to element
 * It stores the handler function in a separate cache object
 * and adds a generic handler to the element's event,
 * along with a unique id (guid) to the element.
 *
 * @param {Element|Object} elem
 *        Element or object to bind listeners to
 *
 * @param {string|string[]} type
 *        Type of event to bind to.
 *
 * @param {EventTarget~EventListener} fn
 *        Event listener.
 */function on(elem,type,fn){if(Array.isArray(type)){return _handleMultipleEvents(on,elem,type,fn);}if(!DomData.has(elem)){DomData.set(elem,{});}var data=DomData.get(elem);// We need a place to store all our handler data
if(!data.handlers){data.handlers={};}if(!data.handlers[type]){data.handlers[type]=[];}if(!fn.guid){fn.guid=newGUID();}data.handlers[type].push(fn);if(!data.dispatcher){data.disabled=false;data.dispatcher=function(event,hash){if(data.disabled){return;}event=fixEvent(event);var handlers=data.handlers[event.type];if(handlers){// Copy handlers so if handlers are added/removed during the process it doesn't throw everything off.
var handlersCopy=handlers.slice(0);for(var m=0,n=handlersCopy.length;m<n;m++){if(event.isImmediatePropagationStopped()){break;}else{try{handlersCopy[m].call(elem,event,hash);}catch(e){log$1.error(e);}}}}};}if(data.handlers[type].length===1){if(elem.addEventListener){var options=false;if(supportsPassive()&&passiveEvents.indexOf(type)>-1){options={passive:true};}elem.addEventListener(type,data.dispatcher,options);}else if(elem.attachEvent){elem.attachEvent('on'+type,data.dispatcher);}}}/**
 * Removes event listeners from an element
 *
 * @param {Element|Object} elem
 *        Object to remove listeners from.
 *
 * @param {string|string[]} [type]
 *        Type of listener to remove. Don't include to remove all events from element.
 *
 * @param {EventTarget~EventListener} [fn]
 *        Specific listener to remove. Don't include to remove listeners for an event
 *        type.
 */function off(elem,type,fn){// Don't want to add a cache object through getElData if not needed
if(!DomData.has(elem)){return;}var data=DomData.get(elem);// If no events exist, nothing to unbind
if(!data.handlers){return;}if(Array.isArray(type)){return _handleMultipleEvents(off,elem,type,fn);}// Utility function
var removeType=function removeType(el,t){data.handlers[t]=[];_cleanUpEvents(el,t);};// Are we removing all bound events?
if(type===undefined){for(var t in data.handlers){if(Object.prototype.hasOwnProperty.call(data.handlers||{},t)){removeType(elem,t);}}return;}var handlers=data.handlers[type];// If no handlers exist, nothing to unbind
if(!handlers){return;}// If no listener was provided, remove all listeners for type
if(!fn){removeType(elem,type);return;}// We're only removing a single handler
if(fn.guid){for(var n=0;n<handlers.length;n++){if(handlers[n].guid===fn.guid){handlers.splice(n--,1);}}}_cleanUpEvents(elem,type);}/**
 * Trigger an event for an element
 *
 * @param {Element|Object} elem
 *        Element to trigger an event on
 *
 * @param {EventTarget~Event|string} event
 *        A string (the type) or an event object with a type attribute
 *
 * @param {Object} [hash]
 *        data hash to pass along with the event
 *
 * @return {boolean|undefined}
 *         Returns the opposite of `defaultPrevented` if default was
 *         prevented. Otherwise, returns `undefined`
 */function trigger(elem,event,hash){// Fetches element data and a reference to the parent (for bubbling).
// Don't want to add a data object to cache for every parent,
// so checking hasElData first.
var elemData=DomData.has(elem)?DomData.get(elem):{};var parent=elem.parentNode||elem.ownerDocument;// type = event.type || event,
// handler;
// If an event name was passed as a string, creates an event out of it
if(typeof event==='string'){event={type:event,target:elem};}else if(!event.target){event.target=elem;}// Normalizes the event properties.
event=fixEvent(event);// If the passed element has a dispatcher, executes the established handlers.
if(elemData.dispatcher){elemData.dispatcher.call(elem,event,hash);}// Unless explicitly stopped or the event does not bubble (e.g. media events)
// recursively calls this function to bubble the event up the DOM.
if(parent&&!event.isPropagationStopped()&&event.bubbles===true){trigger.call(null,parent,event,hash);// If at the top of the DOM, triggers the default action unless disabled.
}else if(!parent&&!event.defaultPrevented&&event.target&&event.target[event.type]){if(!DomData.has(event.target)){DomData.set(event.target,{});}var targetData=DomData.get(event.target);// Checks if the target has a default action for this event.
if(event.target[event.type]){// Temporarily disables event dispatching on the target as we have already executed the handler.
targetData.disabled=true;// Executes the default action.
if(typeof event.target[event.type]==='function'){event.target[event.type]();}// Re-enables event dispatching.
targetData.disabled=false;}}// Inform the triggerer if the default was prevented by returning false
return!event.defaultPrevented;}/**
 * Trigger a listener only once for an event.
 *
 * @param {Element|Object} elem
 *        Element or object to bind to.
 *
 * @param {string|string[]} type
 *        Name/type of event
 *
 * @param {Event~EventListener} fn
 *        Event listener function
 */function one(elem,type,fn){if(Array.isArray(type)){return _handleMultipleEvents(one,elem,type,fn);}var func=function func(){off(elem,type,func);fn.apply(this,arguments);};// copy the guid to the new function so it can removed using the original function's ID
func.guid=fn.guid=fn.guid||newGUID();on(elem,type,func);}/**
 * Trigger a listener only once and then turn if off for all
 * configured events
 *
 * @param {Element|Object} elem
 *        Element or object to bind to.
 *
 * @param {string|string[]} type
 *        Name/type of event
 *
 * @param {Event~EventListener} fn
 *        Event listener function
 */function any(elem,type,fn){var func=function func(){off(elem,type,func);fn.apply(this,arguments);};// copy the guid to the new function so it can removed using the original function's ID
func.guid=fn.guid=fn.guid||newGUID();// multiple ons, but one off for everything
on(elem,type,func);}var Events=/*#__PURE__*/Object.freeze({__proto__:null,fixEvent:fixEvent,on:on,off:off,trigger:trigger,one:one,any:any});/**
 * @file fn.js
 * @module fn
 */var UPDATE_REFRESH_INTERVAL=30;/**
 * Bind (a.k.a proxy or context). A simple method for changing the context of
 * a function.
 *
 * It also stores a unique id on the function so it can be easily removed from
 * events.
 *
 * @function
 * @param    {Mixed} context
 *           The object to bind as scope.
 *
 * @param    {Function} fn
 *           The function to be bound to a scope.
 *
 * @param    {number} [uid]
 *           An optional unique ID for the function to be set
 *
 * @return   {Function}
 *           The new function that will be bound into the context given
 */var bind=function bind(context,fn,uid){// Make sure the function has a unique ID
if(!fn.guid){fn.guid=newGUID();}// Create the new function that changes the context
var bound=fn.bind(context);// Allow for the ability to individualize this function
// Needed in the case where multiple objects might share the same prototype
// IF both items add an event listener with the same function, then you try to remove just one
// it will remove both because they both have the same guid.
// when using this, you need to use the bind method when you remove the listener as well.
// currently used in text tracks
bound.guid=uid?uid+'_'+fn.guid:fn.guid;return bound;};/**
 * Wraps the given function, `fn`, with a new function that only invokes `fn`
 * at most once per every `wait` milliseconds.
 *
 * @function
 * @param    {Function} fn
 *           The function to be throttled.
 *
 * @param    {number}   wait
 *           The number of milliseconds by which to throttle.
 *
 * @return   {Function}
 */var throttle=function throttle(fn,wait){var last=window_default().performance.now();var throttled=function throttled(){var now=window_default().performance.now();if(now-last>=wait){fn.apply(void 0,arguments);last=now;}};return throttled;};/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked.
 *
 * Inspired by lodash and underscore implementations.
 *
 * @function
 * @param    {Function} func
 *           The function to wrap with debounce behavior.
 *
 * @param    {number} wait
 *           The number of milliseconds to wait after the last invocation.
 *
 * @param    {boolean} [immediate]
 *           Whether or not to invoke the function immediately upon creation.
 *
 * @param    {Object} [context=window]
 *           The "context" in which the debounced function should debounce. For
 *           example, if this function should be tied to a Video.js player,
 *           the player can be passed here. Alternatively, defaults to the
 *           global `window` object.
 *
 * @return   {Function}
 *           A debounced function.
 */var debounce=function debounce(func,wait,immediate,context){if(context===void 0){context=(window_default());}var timeout;var cancel=function cancel(){context.clearTimeout(timeout);timeout=null;};/* eslint-disable consistent-this */var debounced=function debounced(){var self=this;var args=arguments;var _later=function later(){timeout=null;_later=null;if(!immediate){func.apply(self,args);}};if(!timeout&&immediate){func.apply(self,args);}context.clearTimeout(timeout);timeout=context.setTimeout(_later,wait);};/* eslint-enable consistent-this */debounced.cancel=cancel;return debounced;};/**
 * @file src/js/event-target.js
 */ /**
 * `EventTarget` is a class that can have the same API as the DOM `EventTarget`. It
 * adds shorthand functions that wrap around lengthy functions. For example:
 * the `on` function is a wrapper around `addEventListener`.
 *
 * @see [EventTarget Spec]{@link https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-EventTarget}
 * @class EventTarget
 */var EventTarget$2=function EventTarget(){};/**
 * A Custom DOM event.
 *
 * @typedef {Object} EventTarget~Event
 * @see [Properties]{@link https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent}
 */ /**
 * All event listeners should follow the following format.
 *
 * @callback EventTarget~EventListener
 * @this {EventTarget}
 *
 * @param {EventTarget~Event} event
 *        the event that triggered this function
 *
 * @param {Object} [hash]
 *        hash of data sent during the event
 */ /**
 * An object containing event names as keys and booleans as values.
 *
 * > NOTE: If an event name is set to a true value here {@link EventTarget#trigger}
 *         will have extra functionality. See that function for more information.
 *
 * @property EventTarget.prototype.allowedEvents_
 * @private
 */EventTarget$2.prototype.allowedEvents_={};/**
 * Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
 * function that will get called when an event with a certain name gets triggered.
 *
 * @param {string|string[]} type
 *        An event name or an array of event names.
 *
 * @param {EventTarget~EventListener} fn
 *        The function to call with `EventTarget`s
 */EventTarget$2.prototype.on=function(type,fn){// Remove the addEventListener alias before calling Events.on
// so we don't get into an infinite type loop
var ael=this.addEventListener;this.addEventListener=function(){};on(this,type,fn);this.addEventListener=ael;};/**
 * An alias of {@link EventTarget#on}. Allows `EventTarget` to mimic
 * the standard DOM API.
 *
 * @function
 * @see {@link EventTarget#on}
 */EventTarget$2.prototype.addEventListener=EventTarget$2.prototype.on;/**
 * Removes an `event listener` for a specific event from an instance of `EventTarget`.
 * This makes it so that the `event listener` will no longer get called when the
 * named event happens.
 *
 * @param {string|string[]} type
 *        An event name or an array of event names.
 *
 * @param {EventTarget~EventListener} fn
 *        The function to remove.
 */EventTarget$2.prototype.off=function(type,fn){off(this,type,fn);};/**
 * An alias of {@link EventTarget#off}. Allows `EventTarget` to mimic
 * the standard DOM API.
 *
 * @function
 * @see {@link EventTarget#off}
 */EventTarget$2.prototype.removeEventListener=EventTarget$2.prototype.off;/**
 * This function will add an `event listener` that gets triggered only once. After the
 * first trigger it will get removed. This is like adding an `event listener`
 * with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
 *
 * @param {string|string[]} type
 *        An event name or an array of event names.
 *
 * @param {EventTarget~EventListener} fn
 *        The function to be called once for each event name.
 */EventTarget$2.prototype.one=function(type,fn){// Remove the addEventListener aliasing Events.on
// so we don't get into an infinite type loop
var ael=this.addEventListener;this.addEventListener=function(){};one(this,type,fn);this.addEventListener=ael;};EventTarget$2.prototype.any=function(type,fn){// Remove the addEventListener aliasing Events.on
// so we don't get into an infinite type loop
var ael=this.addEventListener;this.addEventListener=function(){};any(this,type,fn);this.addEventListener=ael;};/**
 * This function causes an event to happen. This will then cause any `event listeners`
 * that are waiting for that event, to get called. If there are no `event listeners`
 * for an event then nothing will happen.
 *
 * If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
 * Trigger will also call the `on` + `uppercaseEventName` function.
 *
 * Example:
 * 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
 * `onClick` if it exists.
 *
 * @param {string|EventTarget~Event|Object} event
 *        The name of the event, an `Event`, or an object with a key of type set to
 *        an event name.
 */EventTarget$2.prototype.trigger=function(event){var type=event.type||event;// deprecation
// In a future version we should default target to `this`
// similar to how we default the target to `elem` in
// `Events.trigger`. Right now the default `target` will be
// `document` due to the `Event.fixEvent` call.
if(typeof event==='string'){event={type:type};}event=fixEvent(event);if(this.allowedEvents_[type]&&this['on'+type]){this['on'+type](event);}trigger(this,event);};/**
 * An alias of {@link EventTarget#trigger}. Allows `EventTarget` to mimic
 * the standard DOM API.
 *
 * @function
 * @see {@link EventTarget#trigger}
 */EventTarget$2.prototype.dispatchEvent=EventTarget$2.prototype.trigger;var EVENT_MAP;EventTarget$2.prototype.queueTrigger=function(event){var _this=this;// only set up EVENT_MAP if it'll be used
if(!EVENT_MAP){EVENT_MAP=new Map();}var type=event.type||event;var map=EVENT_MAP.get(this);if(!map){map=new Map();EVENT_MAP.set(this,map);}var oldTimeout=map.get(type);map["delete"](type);window_default().clearTimeout(oldTimeout);var timeout=window_default().setTimeout(function(){map["delete"](type);// if we cleared out all timeouts for the current target, delete its map
if(map.size===0){map=null;EVENT_MAP["delete"](_this);}_this.trigger(event);},0);map.set(type,timeout);};/**
 * @file mixins/evented.js
 * @module evented
 */var objName=function objName(obj){if(typeof obj.name==='function'){return obj.name();}if(typeof obj.name==='string'){return obj.name;}if(obj.name_){return obj.name_;}if(obj.constructor&&obj.constructor.name){return obj.constructor.name;}return video_es_typeof(obj);};/**
 * Returns whether or not an object has had the evented mixin applied.
 *
 * @param  {Object} object
 *         An object to test.
 *
 * @return {boolean}
 *         Whether or not the object appears to be evented.
 */var isEvented=function isEvented(object){return object instanceof EventTarget$2||!!object.eventBusEl_&&['on','one','off','trigger'].every(function(k){return typeof object[k]==='function';});};/**
 * Adds a callback to run after the evented mixin applied.
 *
 * @param  {Object} object
 *         An object to Add
 * @param  {Function} callback
 *         The callback to run.
 */var addEventedCallback=function addEventedCallback(target,callback){if(isEvented(target)){callback();}else{if(!target.eventedCallbacks){target.eventedCallbacks=[];}target.eventedCallbacks.push(callback);}};/**
 * Whether a value is a valid event type - non-empty string or array.
 *
 * @private
 * @param  {string|Array} type
 *         The type value to test.
 *
 * @return {boolean}
 *         Whether or not the type is a valid event type.
 */var isValidEventType=function isValidEventType(type){return(// The regex here verifies that the `type` contains at least one non-
// whitespace character.
typeof type==='string'&&/\S/.test(type)||Array.isArray(type)&&!!type.length);};/**
 * Validates a value to determine if it is a valid event target. Throws if not.
 *
 * @private
 * @throws {Error}
 *         If the target does not appear to be a valid event target.
 *
 * @param  {Object} target
 *         The object to test.
 *
 * @param  {Object} obj
 *         The evented object we are validating for
 *
 * @param  {string} fnName
 *         The name of the evented mixin function that called this.
 */var validateTarget=function validateTarget(target,obj,fnName){if(!target||!target.nodeName&&!isEvented(target)){throw new Error("Invalid target for "+objName(obj)+"#"+fnName+"; must be a DOM node or evented object.");}};/**
 * Validates a value to determine if it is a valid event target. Throws if not.
 *
 * @private
 * @throws {Error}
 *         If the type does not appear to be a valid event type.
 *
 * @param  {string|Array} type
 *         The type to test.
 *
 * @param  {Object} obj
*         The evented object we are validating for
 *
 * @param  {string} fnName
 *         The name of the evented mixin function that called this.
 */var validateEventType=function validateEventType(type,obj,fnName){if(!isValidEventType(type)){throw new Error("Invalid event type for "+objName(obj)+"#"+fnName+"; must be a non-empty string or array.");}};/**
 * Validates a value to determine if it is a valid listener. Throws if not.
 *
 * @private
 * @throws {Error}
 *         If the listener is not a function.
 *
 * @param  {Function} listener
 *         The listener to test.
 *
 * @param  {Object} obj
 *         The evented object we are validating for
 *
 * @param  {string} fnName
 *         The name of the evented mixin function that called this.
 */var validateListener=function validateListener(listener,obj,fnName){if(typeof listener!=='function'){throw new Error("Invalid listener for "+objName(obj)+"#"+fnName+"; must be a function.");}};/**
 * Takes an array of arguments given to `on()` or `one()`, validates them, and
 * normalizes them into an object.
 *
 * @private
 * @param  {Object} self
 *         The evented object on which `on()` or `one()` was called. This
 *         object will be bound as the `this` value for the listener.
 *
 * @param  {Array} args
 *         An array of arguments passed to `on()` or `one()`.
 *
 * @param  {string} fnName
 *         The name of the evented mixin function that called this.
 *
 * @return {Object}
 *         An object containing useful values for `on()` or `one()` calls.
 */var normalizeListenArgs=function normalizeListenArgs(self,args,fnName){// If the number of arguments is less than 3, the target is always the
// evented object itself.
var isTargetingSelf=args.length<3||args[0]===self||args[0]===self.eventBusEl_;var target;var type;var listener;if(isTargetingSelf){target=self.eventBusEl_;// Deal with cases where we got 3 arguments, but we are still listening to
// the evented object itself.
if(args.length>=3){args.shift();}type=args[0];listener=args[1];}else{target=args[0];type=args[1];listener=args[2];}validateTarget(target,self,fnName);validateEventType(type,self,fnName);validateListener(listener,self,fnName);listener=bind(self,listener);return{isTargetingSelf:isTargetingSelf,target:target,type:type,listener:listener};};/**
 * Adds the listener to the event type(s) on the target, normalizing for
 * the type of target.
 *
 * @private
 * @param  {Element|Object} target
 *         A DOM node or evented object.
 *
 * @param  {string} method
 *         The event binding method to use ("on" or "one").
 *
 * @param  {string|Array} type
 *         One or more event type(s).
 *
 * @param  {Function} listener
 *         A listener function.
 */var listen=function listen(target,method,type,listener){validateTarget(target,target,method);if(target.nodeName){Events[method](target,type,listener);}else{target[method](type,listener);}};/**
 * Contains methods that provide event capabilities to an object which is passed
 * to {@link module:evented|evented}.
 *
 * @mixin EventedMixin
 */var EventedMixin={/**
   * Add a listener to an event (or events) on this object or another evented
   * object.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */on:function on(){var _this=this;for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}var _normalizeListenArgs=normalizeListenArgs(this,args,'on'),isTargetingSelf=_normalizeListenArgs.isTargetingSelf,target=_normalizeListenArgs.target,type=_normalizeListenArgs.type,listener=_normalizeListenArgs.listener;listen(target,'on',type,listener);// If this object is listening to another evented object.
if(!isTargetingSelf){// If this object is disposed, remove the listener.
var removeListenerOnDispose=function removeListenerOnDispose(){return _this.off(target,type,listener);};// Use the same function ID as the listener so we can remove it later it
// using the ID of the original listener.
removeListenerOnDispose.guid=listener.guid;// Add a listener to the target's dispose event as well. This ensures
// that if the target is disposed BEFORE this object, we remove the
// removal listener that was just added. Otherwise, we create a memory leak.
var removeRemoverOnTargetDispose=function removeRemoverOnTargetDispose(){return _this.off('dispose',removeListenerOnDispose);};// Use the same function ID as the listener so we can remove it later
// it using the ID of the original listener.
removeRemoverOnTargetDispose.guid=listener.guid;listen(this,'on','dispose',removeListenerOnDispose);listen(target,'on','dispose',removeRemoverOnTargetDispose);}},/**
   * Add a listener to an event (or events) on this object or another evented
   * object. The listener will be called once per event and then removed.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */one:function one(){var _this2=this;for(var _len2=arguments.length,args=new Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}var _normalizeListenArgs2=normalizeListenArgs(this,args,'one'),isTargetingSelf=_normalizeListenArgs2.isTargetingSelf,target=_normalizeListenArgs2.target,type=_normalizeListenArgs2.type,listener=_normalizeListenArgs2.listener;// Targeting this evented object.
if(isTargetingSelf){listen(target,'one',type,listener);// Targeting another evented object.
}else{// TODO: This wrapper is incorrect! It should only
//       remove the wrapper for the event type that called it.
//       Instead all listners are removed on the first trigger!
//       see https://github.com/videojs/video.js/issues/5962
var wrapper=function wrapper(){_this2.off(target,type,wrapper);for(var _len3=arguments.length,largs=new Array(_len3),_key3=0;_key3<_len3;_key3++){largs[_key3]=arguments[_key3];}listener.apply(null,largs);};// Use the same function ID as the listener so we can remove it later
// it using the ID of the original listener.
wrapper.guid=listener.guid;listen(target,'one',type,wrapper);}},/**
   * Add a listener to an event (or events) on this object or another evented
   * object. The listener will only be called once for the first event that is triggered
   * then removed.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */any:function any(){var _this3=this;for(var _len4=arguments.length,args=new Array(_len4),_key4=0;_key4<_len4;_key4++){args[_key4]=arguments[_key4];}var _normalizeListenArgs3=normalizeListenArgs(this,args,'any'),isTargetingSelf=_normalizeListenArgs3.isTargetingSelf,target=_normalizeListenArgs3.target,type=_normalizeListenArgs3.type,listener=_normalizeListenArgs3.listener;// Targeting this evented object.
if(isTargetingSelf){listen(target,'any',type,listener);// Targeting another evented object.
}else{var wrapper=function wrapper(){_this3.off(target,type,wrapper);for(var _len5=arguments.length,largs=new Array(_len5),_key5=0;_key5<_len5;_key5++){largs[_key5]=arguments[_key5];}listener.apply(null,largs);};// Use the same function ID as the listener so we can remove it later
// it using the ID of the original listener.
wrapper.guid=listener.guid;listen(target,'any',type,wrapper);}},/**
   * Removes listener(s) from event(s) on an evented object.
   *
   * @param  {string|Array|Element|Object} [targetOrType]
   *         If this is a string or array, it represents the event type(s).
   *
   *         Another evented object can be passed here instead, in which case
   *         ALL 3 arguments are _required_.
   *
   * @param  {string|Array|Function} [typeOrListener]
   *         If the first argument was a string or array, this may be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function; otherwise, _all_ listeners bound to the
   *         event type(s) will be removed.
   */off:function off$1(targetOrType,typeOrListener,listener){// Targeting this evented object.
if(!targetOrType||isValidEventType(targetOrType)){off(this.eventBusEl_,targetOrType,typeOrListener);// Targeting another evented object.
}else{var target=targetOrType;var type=typeOrListener;// Fail fast and in a meaningful way!
validateTarget(target,this,'off');validateEventType(type,this,'off');validateListener(listener,this,'off');// Ensure there's at least a guid, even if the function hasn't been used
listener=bind(this,listener);// Remove the dispose listener on this evented object, which was given
// the same guid as the event listener in on().
this.off('dispose',listener);if(target.nodeName){off(target,type,listener);off(target,'dispose',listener);}else if(isEvented(target)){target.off(type,listener);target.off('dispose',listener);}}},/**
   * Fire an event on this evented object, causing its listeners to be called.
   *
   * @param   {string|Object} event
   *          An event type or an object with a type property.
   *
   * @param   {Object} [hash]
   *          An additional object to pass along to listeners.
   *
   * @return {boolean}
   *          Whether or not the default behavior was prevented.
   */trigger:function trigger$1(event,hash){validateTarget(this.eventBusEl_,this,'trigger');var type=event&&typeof event!=='string'?event.type:event;if(!isValidEventType(type)){var error="Invalid event type for "+objName(this)+"#trigger; "+'must be a non-empty string or object with a type key that has a non-empty value.';if(event){(this.log||log$1).error(error);}else{throw new Error(error);}}return trigger(this.eventBusEl_,event,hash);}};/**
 * Applies {@link module:evented~EventedMixin|EventedMixin} to a target object.
 *
 * @param  {Object} target
 *         The object to which to add event methods.
 *
 * @param  {Object} [options={}]
 *         Options for customizing the mixin behavior.
 *
 * @param  {string} [options.eventBusKey]
 *         By default, adds a `eventBusEl_` DOM element to the target object,
 *         which is used as an event bus. If the target object already has a
 *         DOM element that should be used, pass its key here.
 *
 * @return {Object}
 *         The target object.
 */function evented(target,options){if(options===void 0){options={};}var _options=options,eventBusKey=_options.eventBusKey;// Set or create the eventBusEl_.
if(eventBusKey){if(!target[eventBusKey].nodeName){throw new Error("The eventBusKey \""+eventBusKey+"\" does not refer to an element.");}target.eventBusEl_=target[eventBusKey];}else{target.eventBusEl_=createEl('span',{className:'vjs-event-bus'});}video_es_assign(target,EventedMixin);if(target.eventedCallbacks){target.eventedCallbacks.forEach(function(callback){callback();});}// When any evented object is disposed, it removes all its listeners.
target.on('dispose',function(){target.off();[target,target.el_,target.eventBusEl_].forEach(function(val){if(val&&DomData.has(val)){DomData["delete"](val);}});window_default().setTimeout(function(){target.eventBusEl_=null;},0);});return target;}/**
 * @file mixins/stateful.js
 * @module stateful
 */ /**
 * Contains methods that provide statefulness to an object which is passed
 * to {@link module:stateful}.
 *
 * @mixin StatefulMixin
 */var StatefulMixin={/**
   * A hash containing arbitrary keys and values representing the state of
   * the object.
   *
   * @type {Object}
   */state:{},/**
   * Set the state of an object by mutating its
   * {@link module:stateful~StatefulMixin.state|state} object in place.
   *
   * @fires   module:stateful~StatefulMixin#statechanged
   * @param   {Object|Function} stateUpdates
   *          A new set of properties to shallow-merge into the plugin state.
   *          Can be a plain object or a function returning a plain object.
   *
   * @return {Object|undefined}
   *          An object containing changes that occurred. If no changes
   *          occurred, returns `undefined`.
   */setState:function setState(stateUpdates){var _this=this;// Support providing the `stateUpdates` state as a function.
if(typeof stateUpdates==='function'){stateUpdates=stateUpdates();}var changes;each(stateUpdates,function(value,key){// Record the change if the value is different from what's in the
// current state.
if(_this.state[key]!==value){changes=changes||{};changes[key]={from:_this.state[key],to:value};}_this.state[key]=value;});// Only trigger "statechange" if there were changes AND we have a trigger
// function. This allows us to not require that the target object be an
// evented object.
if(changes&&isEvented(this)){/**
       * An event triggered on an object that is both
       * {@link module:stateful|stateful} and {@link module:evented|evented}
       * indicating that its state has changed.
       *
       * @event    module:stateful~StatefulMixin#statechanged
       * @type     {Object}
       * @property {Object} changes
       *           A hash containing the properties that were changed and
       *           the values they were changed `from` and `to`.
       */this.trigger({changes:changes,type:'statechanged'});}return changes;}};/**
 * Applies {@link module:stateful~StatefulMixin|StatefulMixin} to a target
 * object.
 *
 * If the target object is {@link module:evented|evented} and has a
 * `handleStateChanged` method, that method will be automatically bound to the
 * `statechanged` event on itself.
 *
 * @param   {Object} target
 *          The object to be made stateful.
 *
 * @param   {Object} [defaultState]
 *          A default set of properties to populate the newly-stateful object's
 *          `state` property.
 *
 * @return {Object}
 *          Returns the `target`.
 */function stateful(target,defaultState){video_es_assign(target,StatefulMixin);// This happens after the mixing-in because we need to replace the `state`
// added in that step.
target.state=video_es_assign({},target.state,defaultState);// Auto-bind the `handleStateChanged` method of the target object if it exists.
if(typeof target.handleStateChanged==='function'&&isEvented(target)){target.on('statechanged',target.handleStateChanged);}return target;}/**
 * @file string-cases.js
 * @module to-lower-case
 */ /**
 * Lowercase the first letter of a string.
 *
 * @param {string} string
 *        String to be lowercased
 *
 * @return {string}
 *         The string with a lowercased first letter
 */var toLowerCase=function toLowerCase(string){if(typeof string!=='string'){return string;}return string.replace(/./,function(w){return w.toLowerCase();});};/**
 * Uppercase the first letter of a string.
 *
 * @param {string} string
 *        String to be uppercased
 *
 * @return {string}
 *         The string with an uppercased first letter
 */var toTitleCase$1=function toTitleCase(string){if(typeof string!=='string'){return string;}return string.replace(/./,function(w){return w.toUpperCase();});};/**
 * Compares the TitleCase versions of the two strings for equality.
 *
 * @param {string} str1
 *        The first string to compare
 *
 * @param {string} str2
 *        The second string to compare
 *
 * @return {boolean}
 *         Whether the TitleCase versions of the strings are equal
 */var titleCaseEquals=function titleCaseEquals(str1,str2){return toTitleCase$1(str1)===toTitleCase$1(str2);};/**
 * @file merge-options.js
 * @module merge-options
 */ /**
 * Merge two objects recursively.
 *
 * Performs a deep merge like
 * {@link https://lodash.com/docs/4.17.10#merge|lodash.merge}, but only merges
 * plain objects (not arrays, elements, or anything else).
 *
 * Non-plain object values will be copied directly from the right-most
 * argument.
 *
 * @static
 * @param   {Object[]} sources
 *          One or more objects to merge into a new object.
 *
 * @return {Object}
 *          A new object that is the merged result of all sources.
 */function mergeOptions$3(){var result={};for(var _len=arguments.length,sources=new Array(_len),_key=0;_key<_len;_key++){sources[_key]=arguments[_key];}sources.forEach(function(source){if(!source){return;}each(source,function(value,key){if(!isPlain(value)){result[key]=value;return;}if(!isPlain(result[key])){result[key]={};}result[key]=mergeOptions$3(result[key],value);});});return result;}var MapSham=/*#__PURE__*/function(){function MapSham(){this.map_={};}var _proto=MapSham.prototype;_proto.has=function has(key){return key in this.map_;};_proto["delete"]=function _delete(key){var has=this.has(key);delete this.map_[key];return has;};_proto.set=function set(key,value){this.map_[key]=value;return this;};_proto.forEach=function forEach(callback,thisArg){for(var key in this.map_){callback.call(thisArg,this.map_[key],key,this);}};return MapSham;}();var Map$1=(window_default()).Map?(window_default()).Map:MapSham;var SetSham=/*#__PURE__*/function(){function SetSham(){this.set_={};}var _proto=SetSham.prototype;_proto.has=function has(key){return key in this.set_;};_proto["delete"]=function _delete(key){var has=this.has(key);delete this.set_[key];return has;};_proto.add=function add(key){this.set_[key]=1;return this;};_proto.forEach=function forEach(callback,thisArg){for(var key in this.set_){callback.call(thisArg,key,key,this);}};return SetSham;}();var Set$1=(window_default()).Set?(window_default()).Set:SetSham;/**
 * Player Component - Base class for all UI objects
 *
 * @file component.js
 */ /**
 * Base class for all UI Components.
 * Components are UI objects which represent both a javascript object and an element
 * in the DOM. They can be children of other components, and can have
 * children themselves.
 *
 * Components can also use methods from {@link EventTarget}
 */var Component$1=/*#__PURE__*/function(){/**
   * A callback that is called when a component is ready. Does not have any
   * paramters and any callback value will be ignored.
   *
   * @callback Component~ReadyCallback
   * @this Component
   */ /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of component options.
   *
   * @param {Object[]} [options.children]
   *        An array of children objects to intialize this component with. Children objects have
   *        a name property that will be used if more than one component of the same type needs to be
   *        added.
   *
   * @param  {string} [options.className]
   *         A class or space separated list of classes to add the component
   *
   * @param {Component~ReadyCallback} [ready]
   *        Function that gets called when the `Component` is ready.
   */function Component(player,options,ready){var _this=this;// The component might be the player itself and we can't pass `this` to super
if(!player&&this.play){this.player_=player=this;// eslint-disable-line
}else{this.player_=player;}this.isDisposed_=false;// Hold the reference to the parent component via `addChild` method
this.parentComponent_=null;// Make a copy of prototype.options_ to protect against overriding defaults
this.options_=mergeOptions$3({},this.options_);// Updated options with supplied options
options=this.options_=mergeOptions$3(this.options_,options);// Get ID from options or options element if one is supplied
this.id_=options.id||options.el&&options.el.id;// If there was no ID from the options, generate one
if(!this.id_){// Don't require the player ID function in the case of mock players
var id=player&&player.id&&player.id()||'no_player';this.id_=id+"_component_"+newGUID();}this.name_=options.name||null;// Create element if one wasn't provided in options
if(options.el){this.el_=options.el;}else if(options.createEl!==false){this.el_=this.createEl();}if(options.className&&this.el_){options.className.split(' ').forEach(function(c){return _this.addClass(c);});}// if evented is anything except false, we want to mixin in evented
if(options.evented!==false){// Make this an evented object and use `el_`, if available, as its event bus
evented(this,{eventBusKey:this.el_?'el_':null});this.handleLanguagechange=this.handleLanguagechange.bind(this);this.on(this.player_,'languagechange',this.handleLanguagechange);}stateful(this,this.constructor.defaultState);this.children_=[];this.childIndex_={};this.childNameIndex_={};this.setTimeoutIds_=new Set$1();this.setIntervalIds_=new Set$1();this.rafIds_=new Set$1();this.namedRafs_=new Map$1();this.clearingTimersOnDispose_=false;// Add any child components in options
if(options.initChildren!==false){this.initChildren();}// Don't want to trigger ready here or it will go before init is actually
// finished for all children that run this constructor
this.ready(ready);if(options.reportTouchActivity!==false){this.enableTouchActivity();}}/**
   * Dispose of the `Component` and all child components.
   *
   * @fires Component#dispose
   *
   * @param {Object} options
   * @param {Element} options.originalEl element with which to replace player element
   */var _proto=Component.prototype;_proto.dispose=function dispose(options){if(options===void 0){options={};}// Bail out if the component has already been disposed.
if(this.isDisposed_){return;}if(this.readyQueue_){this.readyQueue_.length=0;}/**
     * Triggered when a `Component` is disposed.
     *
     * @event Component#dispose
     * @type {EventTarget~Event}
     *
     * @property {boolean} [bubbles=false]
     *           set to false so that the dispose event does not
     *           bubble up
     */this.trigger({type:'dispose',bubbles:false});this.isDisposed_=true;// Dispose all children.
if(this.children_){for(var i=this.children_.length-1;i>=0;i--){if(this.children_[i].dispose){this.children_[i].dispose();}}}// Delete child references
this.children_=null;this.childIndex_=null;this.childNameIndex_=null;this.parentComponent_=null;if(this.el_){// Remove element from DOM
if(this.el_.parentNode){if(options.restoreEl){this.el_.parentNode.replaceChild(options.restoreEl,this.el_);}else{this.el_.parentNode.removeChild(this.el_);}}this.el_=null;}// remove reference to the player after disposing of the element
this.player_=null;}/**
   * Determine whether or not this component has been disposed.
   *
   * @return {boolean}
   *         If the component has been disposed, will be `true`. Otherwise, `false`.
   */;_proto.isDisposed=function isDisposed(){return Boolean(this.isDisposed_);}/**
   * Return the {@link Player} that the `Component` has attached to.
   *
   * @return {Player}
   *         The player that this `Component` has attached to.
   */;_proto.player=function player(){return this.player_;}/**
   * Deep merge of options objects with new options.
   * > Note: When both `obj` and `options` contain properties whose values are objects.
   *         The two properties get merged using {@link module:mergeOptions}
   *
   * @param {Object} obj
   *        The object that contains new options.
   *
   * @return {Object}
   *         A new object of `this.options_` and `obj` merged together.
   */;_proto.options=function options(obj){if(!obj){return this.options_;}this.options_=mergeOptions$3(this.options_,obj);return this.options_;}/**
   * Get the `Component`s DOM element
   *
   * @return {Element}
   *         The DOM element for this `Component`.
   */;_proto.el=function el(){return this.el_;}/**
   * Create the `Component`s DOM element.
   *
   * @param {string} [tagName]
   *        Element's DOM node type. e.g. 'div'
   *
   * @param {Object} [properties]
   *        An object of properties that should be set.
   *
   * @param {Object} [attributes]
   *        An object of attributes that should be set.
   *
   * @return {Element}
   *         The element that gets created.
   */;_proto.createEl=function createEl$1(tagName,properties,attributes){return createEl(tagName,properties,attributes);}/**
   * Localize a string given the string in english.
   *
   * If tokens are provided, it'll try and run a simple token replacement on the provided string.
   * The tokens it looks for look like `{1}` with the index being 1-indexed into the tokens array.
   *
   * If a `defaultValue` is provided, it'll use that over `string`,
   * if a value isn't found in provided language files.
   * This is useful if you want to have a descriptive key for token replacement
   * but have a succinct localized string and not require `en.json` to be included.
   *
   * Currently, it is used for the progress bar timing.
   * ```js
   * {
   *   "progress bar timing: currentTime={1} duration={2}": "{1} of {2}"
   * }
   * ```
   * It is then used like so:
   * ```js
   * this.localize('progress bar timing: currentTime={1} duration{2}',
   *               [this.player_.currentTime(), this.player_.duration()],
   *               '{1} of {2}');
   * ```
   *
   * Which outputs something like: `01:23 of 24:56`.
   *
   *
   * @param {string} string
   *        The string to localize and the key to lookup in the language files.
   * @param {string[]} [tokens]
   *        If the current item has token replacements, provide the tokens here.
   * @param {string} [defaultValue]
   *        Defaults to `string`. Can be a default value to use for token replacement
   *        if the lookup key is needed to be separate.
   *
   * @return {string}
   *         The localized string or if no localization exists the english string.
   */;_proto.localize=function localize(string,tokens,defaultValue){if(defaultValue===void 0){defaultValue=string;}var code=this.player_.language&&this.player_.language();var languages=this.player_.languages&&this.player_.languages();var language=languages&&languages[code];var primaryCode=code&&code.split('-')[0];var primaryLang=languages&&languages[primaryCode];var localizedString=defaultValue;if(language&&language[string]){localizedString=language[string];}else if(primaryLang&&primaryLang[string]){localizedString=primaryLang[string];}if(tokens){localizedString=localizedString.replace(/\{(\d+)\}/g,function(match,index){var value=tokens[index-1];var ret=value;if(typeof value==='undefined'){ret=match;}return ret;});}return localizedString;}/**
   * Handles language change for the player in components. Should be overriden by sub-components.
   *
   * @abstract
   */;_proto.handleLanguagechange=function handleLanguagechange(){}/**
   * Return the `Component`s DOM element. This is where children get inserted.
   * This will usually be the the same as the element returned in {@link Component#el}.
   *
   * @return {Element}
   *         The content element for this `Component`.
   */;_proto.contentEl=function contentEl(){return this.contentEl_||this.el_;}/**
   * Get this `Component`s ID
   *
   * @return {string}
   *         The id of this `Component`
   */;_proto.id=function id(){return this.id_;}/**
   * Get the `Component`s name. The name gets used to reference the `Component`
   * and is set during registration.
   *
   * @return {string}
   *         The name of this `Component`.
   */;_proto.name=function name(){return this.name_;}/**
   * Get an array of all child components
   *
   * @return {Array}
   *         The children
   */;_proto.children=function children(){return this.children_;}/**
   * Returns the child `Component` with the given `id`.
   *
   * @param {string} id
   *        The id of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The child `Component` with the given `id` or undefined.
   */;_proto.getChildById=function getChildById(id){return this.childIndex_[id];}/**
   * Returns the child `Component` with the given `name`.
   *
   * @param {string} name
   *        The name of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The child `Component` with the given `name` or undefined.
   */;_proto.getChild=function getChild(name){if(!name){return;}return this.childNameIndex_[name];}/**
   * Returns the descendant `Component` following the givent
   * descendant `names`. For instance ['foo', 'bar', 'baz'] would
   * try to get 'foo' on the current component, 'bar' on the 'foo'
   * component and 'baz' on the 'bar' component and return undefined
   * if any of those don't exist.
   *
   * @param {...string[]|...string} names
   *        The name of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The descendant `Component` following the given descendant
   *         `names` or undefined.
   */;_proto.getDescendant=function getDescendant(){for(var _len=arguments.length,names=new Array(_len),_key=0;_key<_len;_key++){names[_key]=arguments[_key];}// flatten array argument into the main array
names=names.reduce(function(acc,n){return acc.concat(n);},[]);var currentChild=this;for(var i=0;i<names.length;i++){currentChild=currentChild.getChild(names[i]);if(!currentChild||!currentChild.getChild){return;}}return currentChild;}/**
   * Add a child `Component` inside the current `Component`.
   *
   *
   * @param {string|Component} child
   *        The name or instance of a child to add.
   *
   * @param {Object} [options={}]
   *        The key/value store of options that will get passed to children of
   *        the child.
   *
   * @param {number} [index=this.children_.length]
   *        The index to attempt to add a child into.
   *
   * @return {Component}
   *         The `Component` that gets added as a child. When using a string the
   *         `Component` will get created by this process.
   */;_proto.addChild=function addChild(child,options,index){if(options===void 0){options={};}if(index===void 0){index=this.children_.length;}var component;var componentName;// If child is a string, create component with options
if(typeof child==='string'){componentName=toTitleCase$1(child);var componentClassName=options.componentClass||componentName;// Set name through options
options.name=componentName;// Create a new object & element for this controls set
// If there's no .player_, this is a player
var ComponentClass=Component.getComponent(componentClassName);if(!ComponentClass){throw new Error("Component "+componentClassName+" does not exist");}// data stored directly on the videojs object may be
// misidentified as a component to retain
// backwards-compatibility with 4.x. check to make sure the
// component class can be instantiated.
if(typeof ComponentClass!=='function'){return null;}component=new ComponentClass(this.player_||this,options);// child is a component instance
}else{component=child;}if(component.parentComponent_){component.parentComponent_.removeChild(component);}this.children_.splice(index,0,component);component.parentComponent_=this;if(typeof component.id==='function'){this.childIndex_[component.id()]=component;}// If a name wasn't used to create the component, check if we can use the
// name function of the component
componentName=componentName||component.name&&toTitleCase$1(component.name());if(componentName){this.childNameIndex_[componentName]=component;this.childNameIndex_[toLowerCase(componentName)]=component;}// Add the UI object's element to the container div (box)
// Having an element is not required
if(typeof component.el==='function'&&component.el()){// If inserting before a component, insert before that component's element
var refNode=null;if(this.children_[index+1]){// Most children are components, but the video tech is an HTML element
if(this.children_[index+1].el_){refNode=this.children_[index+1].el_;}else if(isEl(this.children_[index+1])){refNode=this.children_[index+1];}}this.contentEl().insertBefore(component.el(),refNode);}// Return so it can stored on parent object if desired.
return component;}/**
   * Remove a child `Component` from this `Component`s list of children. Also removes
   * the child `Component`s element from this `Component`s element.
   *
   * @param {Component} component
   *        The child `Component` to remove.
   */;_proto.removeChild=function removeChild(component){if(typeof component==='string'){component=this.getChild(component);}if(!component||!this.children_){return;}var childFound=false;for(var i=this.children_.length-1;i>=0;i--){if(this.children_[i]===component){childFound=true;this.children_.splice(i,1);break;}}if(!childFound){return;}component.parentComponent_=null;this.childIndex_[component.id()]=null;this.childNameIndex_[toTitleCase$1(component.name())]=null;this.childNameIndex_[toLowerCase(component.name())]=null;var compEl=component.el();if(compEl&&compEl.parentNode===this.contentEl()){this.contentEl().removeChild(component.el());}}/**
   * Add and initialize default child `Component`s based upon options.
   */;_proto.initChildren=function initChildren(){var _this2=this;var children=this.options_.children;if(children){// `this` is `parent`
var parentOptions=this.options_;var handleAdd=function handleAdd(child){var name=child.name;var opts=child.opts;// Allow options for children to be set at the parent options
// e.g. videojs(id, { controlBar: false });
// instead of videojs(id, { children: { controlBar: false });
if(parentOptions[name]!==undefined){opts=parentOptions[name];}// Allow for disabling default components
// e.g. options['children']['posterImage'] = false
if(opts===false){return;}// Allow options to be passed as a simple boolean if no configuration
// is necessary.
if(opts===true){opts={};}// We also want to pass the original player options
// to each component as well so they don't need to
// reach back into the player for options later.
opts.playerOptions=_this2.options_.playerOptions;// Create and add the child component.
// Add a direct reference to the child by name on the parent instance.
// If two of the same component are used, different names should be supplied
// for each
var newChild=_this2.addChild(name,opts);if(newChild){_this2[name]=newChild;}};// Allow for an array of children details to passed in the options
var workingChildren;var Tech=Component.getComponent('Tech');if(Array.isArray(children)){workingChildren=children;}else{workingChildren=Object.keys(children);}workingChildren// children that are in this.options_ but also in workingChildren  would
// give us extra children we do not want. So, we want to filter them out.
.concat(Object.keys(this.options_).filter(function(child){return!workingChildren.some(function(wchild){if(typeof wchild==='string'){return child===wchild;}return child===wchild.name;});})).map(function(child){var name;var opts;if(typeof child==='string'){name=child;opts=children[name]||_this2.options_[name]||{};}else{name=child.name;opts=child;}return{name:name,opts:opts};}).filter(function(child){// we have to make sure that child.name isn't in the techOrder since
// techs are registerd as Components but can't aren't compatible
// See https://github.com/videojs/video.js/issues/2772
var c=Component.getComponent(child.opts.componentClass||toTitleCase$1(child.name));return c&&!Tech.isTech(c);}).forEach(handleAdd);}}/**
   * Builds the default DOM class name. Should be overriden by sub-components.
   *
   * @return {string}
   *         The DOM class name for this object.
   *
   * @abstract
   */;_proto.buildCSSClass=function buildCSSClass(){// Child classes can include a function that does:
// return 'CLASS NAME' + this._super();
return'';}/**
   * Bind a listener to the component's ready state.
   * Different from event listeners in that if the ready event has already happened
   * it will trigger the function immediately.
   *
   * @return {Component}
   *         Returns itself; method can be chained.
   */;_proto.ready=function ready(fn,sync){if(sync===void 0){sync=false;}if(!fn){return;}if(!this.isReady_){this.readyQueue_=this.readyQueue_||[];this.readyQueue_.push(fn);return;}if(sync){fn.call(this);}else{// Call the function asynchronously by default for consistency
this.setTimeout(fn,1);}}/**
   * Trigger all the ready listeners for this `Component`.
   *
   * @fires Component#ready
   */;_proto.triggerReady=function triggerReady(){this.isReady_=true;// Ensure ready is triggered asynchronously
this.setTimeout(function(){var readyQueue=this.readyQueue_;// Reset Ready Queue
this.readyQueue_=[];if(readyQueue&&readyQueue.length>0){readyQueue.forEach(function(fn){fn.call(this);},this);}// Allow for using event listeners also
/**
       * Triggered when a `Component` is ready.
       *
       * @event Component#ready
       * @type {EventTarget~Event}
       */this.trigger('ready');},1);}/**
   * Find a single DOM element matching a `selector`. This can be within the `Component`s
   * `contentEl()` or another custom context.
   *
   * @param {string} selector
   *        A valid CSS selector, which will be passed to `querySelector`.
   *
   * @param {Element|string} [context=this.contentEl()]
   *        A DOM element within which to query. Can also be a selector string in
   *        which case the first matching element will get used as context. If
   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
   *        nothing it falls back to `document`.
   *
   * @return {Element|null}
   *         the dom element that was found, or null
   *
   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
   */;_proto.$=function $$1(selector,context){return $(selector,context||this.contentEl());}/**
   * Finds all DOM element matching a `selector`. This can be within the `Component`s
   * `contentEl()` or another custom context.
   *
   * @param {string} selector
   *        A valid CSS selector, which will be passed to `querySelectorAll`.
   *
   * @param {Element|string} [context=this.contentEl()]
   *        A DOM element within which to query. Can also be a selector string in
   *        which case the first matching element will get used as context. If
   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
   *        nothing it falls back to `document`.
   *
   * @return {NodeList}
   *         a list of dom elements that were found
   *
   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
   */;_proto.$$=function $$$1(selector,context){return $$(selector,context||this.contentEl());}/**
   * Check if a component's element has a CSS class name.
   *
   * @param {string} classToCheck
   *        CSS class name to check.
   *
   * @return {boolean}
   *         - True if the `Component` has the class.
   *         - False if the `Component` does not have the class`
   */;_proto.hasClass=function hasClass$1(classToCheck){return hasClass(this.el_,classToCheck);}/**
   * Add a CSS class name to the `Component`s element.
   *
   * @param {string} classToAdd
   *        CSS class name to add
   */;_proto.addClass=function addClass$1(classToAdd){addClass(this.el_,classToAdd);}/**
   * Remove a CSS class name from the `Component`s element.
   *
   * @param {string} classToRemove
   *        CSS class name to remove
   */;_proto.removeClass=function removeClass$1(classToRemove){removeClass(this.el_,classToRemove);}/**
   * Add or remove a CSS class name from the component's element.
   * - `classToToggle` gets added when {@link Component#hasClass} would return false.
   * - `classToToggle` gets removed when {@link Component#hasClass} would return true.
   *
   * @param  {string} classToToggle
   *         The class to add or remove based on (@link Component#hasClass}
   *
   * @param  {boolean|Dom~predicate} [predicate]
   *         An {@link Dom~predicate} function or a boolean
   */;_proto.toggleClass=function toggleClass$1(classToToggle,predicate){toggleClass(this.el_,classToToggle,predicate);}/**
   * Show the `Component`s element if it is hidden by removing the
   * 'vjs-hidden' class name from it.
   */;_proto.show=function show(){this.removeClass('vjs-hidden');}/**
   * Hide the `Component`s element if it is currently showing by adding the
   * 'vjs-hidden` class name to it.
   */;_proto.hide=function hide(){this.addClass('vjs-hidden');}/**
   * Lock a `Component`s element in its visible state by adding the 'vjs-lock-showing'
   * class name to it. Used during fadeIn/fadeOut.
   *
   * @private
   */;_proto.lockShowing=function lockShowing(){this.addClass('vjs-lock-showing');}/**
   * Unlock a `Component`s element from its visible state by removing the 'vjs-lock-showing'
   * class name from it. Used during fadeIn/fadeOut.
   *
   * @private
   */;_proto.unlockShowing=function unlockShowing(){this.removeClass('vjs-lock-showing');}/**
   * Get the value of an attribute on the `Component`s element.
   *
   * @param {string} attribute
   *        Name of the attribute to get the value from.
   *
   * @return {string|null}
   *         - The value of the attribute that was asked for.
   *         - Can be an empty string on some browsers if the attribute does not exist
   *           or has no value
   *         - Most browsers will return null if the attibute does not exist or has
   *           no value.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttribute}
   */;_proto.getAttribute=function getAttribute$1(attribute){return getAttribute(this.el_,attribute);}/**
   * Set the value of an attribute on the `Component`'s element
   *
   * @param {string} attribute
   *        Name of the attribute to set.
   *
   * @param {string} value
   *        Value to set the attribute to.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttribute}
   */;_proto.setAttribute=function setAttribute$1(attribute,value){setAttribute(this.el_,attribute,value);}/**
   * Remove an attribute from the `Component`s element.
   *
   * @param {string} attribute
   *        Name of the attribute to remove.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/removeAttribute}
   */;_proto.removeAttribute=function removeAttribute$1(attribute){removeAttribute(this.el_,attribute);}/**
   * Get or set the width of the component based upon the CSS styles.
   * See {@link Component#dimension} for more detailed information.
   *
   * @param {number|string} [num]
   *        The width that you want to set postfixed with '%', 'px' or nothing.
   *
   * @param {boolean} [skipListeners]
   *        Skip the componentresize event trigger
   *
   * @return {number|string}
   *         The width when getting, zero if there is no width. Can be a string
   *           postpixed with '%' or 'px'.
   */;_proto.width=function width(num,skipListeners){return this.dimension('width',num,skipListeners);}/**
   * Get or set the height of the component based upon the CSS styles.
   * See {@link Component#dimension} for more detailed information.
   *
   * @param {number|string} [num]
   *        The height that you want to set postfixed with '%', 'px' or nothing.
   *
   * @param {boolean} [skipListeners]
   *        Skip the componentresize event trigger
   *
   * @return {number|string}
   *         The width when getting, zero if there is no width. Can be a string
   *         postpixed with '%' or 'px'.
   */;_proto.height=function height(num,skipListeners){return this.dimension('height',num,skipListeners);}/**
   * Set both the width and height of the `Component` element at the same time.
   *
   * @param  {number|string} width
   *         Width to set the `Component`s element to.
   *
   * @param  {number|string} height
   *         Height to set the `Component`s element to.
   */;_proto.dimensions=function dimensions(width,height){// Skip componentresize listeners on width for optimization
this.width(width,true);this.height(height);}/**
   * Get or set width or height of the `Component` element. This is the shared code
   * for the {@link Component#width} and {@link Component#height}.
   *
   * Things to know:
   * - If the width or height in an number this will return the number postfixed with 'px'.
   * - If the width/height is a percent this will return the percent postfixed with '%'
   * - Hidden elements have a width of 0 with `window.getComputedStyle`. This function
   *   defaults to the `Component`s `style.width` and falls back to `window.getComputedStyle`.
   *   See [this]{@link http://www.foliotek.com/devblog/getting-the-width-of-a-hidden-element-with-jquery-using-width/}
   *   for more information
   * - If you want the computed style of the component, use {@link Component#currentWidth}
   *   and {@link {Component#currentHeight}
   *
   * @fires Component#componentresize
   *
   * @param {string} widthOrHeight
   8        'width' or 'height'
   *
   * @param  {number|string} [num]
   8         New dimension
   *
   * @param  {boolean} [skipListeners]
   *         Skip componentresize event trigger
   *
   * @return {number}
   *         The dimension when getting or 0 if unset
   */;_proto.dimension=function dimension(widthOrHeight,num,skipListeners){if(num!==undefined){// Set to zero if null or literally NaN (NaN !== NaN)
if(num===null||num!==num){num=0;}// Check if using css width/height (% or px) and adjust
if((''+num).indexOf('%')!==-1||(''+num).indexOf('px')!==-1){this.el_.style[widthOrHeight]=num;}else if(num==='auto'){this.el_.style[widthOrHeight]='';}else{this.el_.style[widthOrHeight]=num+'px';}// skipListeners allows us to avoid triggering the resize event when setting both width and height
if(!skipListeners){/**
         * Triggered when a component is resized.
         *
         * @event Component#componentresize
         * @type {EventTarget~Event}
         */this.trigger('componentresize');}return;}// Not setting a value, so getting it
// Make sure element exists
if(!this.el_){return 0;}// Get dimension value from style
var val=this.el_.style[widthOrHeight];var pxIndex=val.indexOf('px');if(pxIndex!==-1){// Return the pixel value with no 'px'
return parseInt(val.slice(0,pxIndex),10);}// No px so using % or no style was set, so falling back to offsetWidth/height
// If component has display:none, offset will return 0
// TODO: handle display:none and no dimension style using px
return parseInt(this.el_['offset'+toTitleCase$1(widthOrHeight)],10);}/**
   * Get the computed width or the height of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @param {string} widthOrHeight
   *        A string containing 'width' or 'height'. Whichever one you want to get.
   *
   * @return {number}
   *         The dimension that gets asked for or 0 if nothing was set
   *         for that dimension.
   */;_proto.currentDimension=function currentDimension(widthOrHeight){var computedWidthOrHeight=0;if(widthOrHeight!=='width'&&widthOrHeight!=='height'){throw new Error('currentDimension only accepts width or height value');}computedWidthOrHeight=computedStyle(this.el_,widthOrHeight);// remove 'px' from variable and parse as integer
computedWidthOrHeight=parseFloat(computedWidthOrHeight);// if the computed value is still 0, it's possible that the browser is lying
// and we want to check the offset values.
// This code also runs wherever getComputedStyle doesn't exist.
if(computedWidthOrHeight===0||isNaN(computedWidthOrHeight)){var rule="offset"+toTitleCase$1(widthOrHeight);computedWidthOrHeight=this.el_[rule];}return computedWidthOrHeight;}/**
   * An object that contains width and height values of the `Component`s
   * computed style. Uses `window.getComputedStyle`.
   *
   * @typedef {Object} Component~DimensionObject
   *
   * @property {number} width
   *           The width of the `Component`s computed style.
   *
   * @property {number} height
   *           The height of the `Component`s computed style.
   */ /**
   * Get an object that contains computed width and height values of the
   * component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {Component~DimensionObject}
   *         The computed dimensions of the component's element.
   */;_proto.currentDimensions=function currentDimensions(){return{width:this.currentDimension('width'),height:this.currentDimension('height')};}/**
   * Get the computed width of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {number}
   *         The computed width of the component's element.
   */;_proto.currentWidth=function currentWidth(){return this.currentDimension('width');}/**
   * Get the computed height of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {number}
   *         The computed height of the component's element.
   */;_proto.currentHeight=function currentHeight(){return this.currentDimension('height');}/**
   * Set the focus to this component
   */;_proto.focus=function focus(){this.el_.focus();}/**
   * Remove the focus from this component
   */;_proto.blur=function blur(){this.el_.blur();}/**
   * When this Component receives a `keydown` event which it does not process,
   *  it passes the event to the Player for handling.
   *
   * @param {EventTarget~Event} event
   *        The `keydown` event that caused this function to be called.
   */;_proto.handleKeyDown=function handleKeyDown(event){if(this.player_){// We only stop propagation here because we want unhandled events to fall
// back to the browser. Exclude Tab for focus trapping.
if(!keycode_default().isEventKey(event,'Tab')){event.stopPropagation();}this.player_.handleKeyDown(event);}}/**
   * Many components used to have a `handleKeyPress` method, which was poorly
   * named because it listened to a `keydown` event. This method name now
   * delegates to `handleKeyDown`. This means anyone calling `handleKeyPress`
   * will not see their method calls stop working.
   *
   * @param {EventTarget~Event} event
   *        The event that caused this function to be called.
   */;_proto.handleKeyPress=function handleKeyPress(event){this.handleKeyDown(event);}/**
   * Emit a 'tap' events when touch event support gets detected. This gets used to
   * support toggling the controls through a tap on the video. They get enabled
   * because every sub-component would have extra overhead otherwise.
   *
   * @private
   * @fires Component#tap
   * @listens Component#touchstart
   * @listens Component#touchmove
   * @listens Component#touchleave
   * @listens Component#touchcancel
   * @listens Component#touchend
    */;_proto.emitTapEvents=function emitTapEvents(){// Track the start time so we can determine how long the touch lasted
var touchStart=0;var firstTouch=null;// Maximum movement allowed during a touch event to still be considered a tap
// Other popular libs use anywhere from 2 (hammer.js) to 15,
// so 10 seems like a nice, round number.
var tapMovementThreshold=10;// The maximum length a touch can be while still being considered a tap
var touchTimeThreshold=200;var couldBeTap;this.on('touchstart',function(event){// If more than one finger, don't consider treating this as a click
if(event.touches.length===1){// Copy pageX/pageY from the object
firstTouch={pageX:event.touches[0].pageX,pageY:event.touches[0].pageY};// Record start time so we can detect a tap vs. "touch and hold"
touchStart=window_default().performance.now();// Reset couldBeTap tracking
couldBeTap=true;}});this.on('touchmove',function(event){// If more than one finger, don't consider treating this as a click
if(event.touches.length>1){couldBeTap=false;}else if(firstTouch){// Some devices will throw touchmoves for all but the slightest of taps.
// So, if we moved only a small distance, this could still be a tap
var xdiff=event.touches[0].pageX-firstTouch.pageX;var ydiff=event.touches[0].pageY-firstTouch.pageY;var touchDistance=Math.sqrt(xdiff*xdiff+ydiff*ydiff);if(touchDistance>tapMovementThreshold){couldBeTap=false;}}});var noTap=function noTap(){couldBeTap=false;};// TODO: Listen to the original target. http://youtu.be/DujfpXOKUp8?t=13m8s
this.on('touchleave',noTap);this.on('touchcancel',noTap);// When the touch ends, measure how long it took and trigger the appropriate
// event
this.on('touchend',function(event){firstTouch=null;// Proceed only if the touchmove/leave/cancel event didn't happen
if(couldBeTap===true){// Measure how long the touch lasted
var touchTime=window_default().performance.now()-touchStart;// Make sure the touch was less than the threshold to be considered a tap
if(touchTime<touchTimeThreshold){// Don't let browser turn this into a click
event.preventDefault();/**
           * Triggered when a `Component` is tapped.
           *
           * @event Component#tap
           * @type {EventTarget~Event}
           */this.trigger('tap');// It may be good to copy the touchend event object and change the
// type to tap, if the other event properties aren't exact after
// Events.fixEvent runs (e.g. event.target)
}}});}/**
   * This function reports user activity whenever touch events happen. This can get
   * turned off by any sub-components that wants touch events to act another way.
   *
   * Report user touch activity when touch events occur. User activity gets used to
   * determine when controls should show/hide. It is simple when it comes to mouse
   * events, because any mouse event should show the controls. So we capture mouse
   * events that bubble up to the player and report activity when that happens.
   * With touch events it isn't as easy as `touchstart` and `touchend` toggle player
   * controls. So touch events can't help us at the player level either.
   *
   * User activity gets checked asynchronously. So what could happen is a tap event
   * on the video turns the controls off. Then the `touchend` event bubbles up to
   * the player. Which, if it reported user activity, would turn the controls right
   * back on. We also don't want to completely block touch events from bubbling up.
   * Furthermore a `touchmove` event and anything other than a tap, should not turn
   * controls back on.
   *
   * @listens Component#touchstart
   * @listens Component#touchmove
   * @listens Component#touchend
   * @listens Component#touchcancel
   */;_proto.enableTouchActivity=function enableTouchActivity(){// Don't continue if the root player doesn't support reporting user activity
if(!this.player()||!this.player().reportUserActivity){return;}// listener for reporting that the user is active
var report=bind(this.player(),this.player().reportUserActivity);var touchHolding;this.on('touchstart',function(){report();// For as long as the they are touching the device or have their mouse down,
// we consider them active even if they're not moving their finger or mouse.
// So we want to continue to update that they are active
this.clearInterval(touchHolding);// report at the same interval as activityCheck
touchHolding=this.setInterval(report,250);});var touchEnd=function touchEnd(event){report();// stop the interval that maintains activity if the touch is holding
this.clearInterval(touchHolding);};this.on('touchmove',report);this.on('touchend',touchEnd);this.on('touchcancel',touchEnd);}/**
   * A callback that has no parameters and is bound into `Component`s context.
   *
   * @callback Component~GenericCallback
   * @this Component
   */ /**
   * Creates a function that runs after an `x` millisecond timeout. This function is a
   * wrapper around `window.setTimeout`. There are a few reasons to use this one
   * instead though:
   * 1. It gets cleared via  {@link Component#clearTimeout} when
   *    {@link Component#dispose} gets called.
   * 2. The function callback will gets turned into a {@link Component~GenericCallback}
   *
   * > Note: You can't use `window.clearTimeout` on the id returned by this function. This
   *         will cause its dispose listener not to get cleaned up! Please use
   *         {@link Component#clearTimeout} or {@link Component#dispose} instead.
   *
   * @param {Component~GenericCallback} fn
   *        The function that will be run after `timeout`.
   *
   * @param {number} timeout
   *        Timeout in milliseconds to delay before executing the specified function.
   *
   * @return {number}
   *         Returns a timeout ID that gets used to identify the timeout. It can also
   *         get used in {@link Component#clearTimeout} to clear the timeout that
   *         was set.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setTimeout}
   */;_proto.setTimeout=function setTimeout(fn,timeout){var _this3=this;// declare as variables so they are properly available in timeout function
// eslint-disable-next-line
var timeoutId;fn=bind(this,fn);this.clearTimersOnDispose_();timeoutId=window_default().setTimeout(function(){if(_this3.setTimeoutIds_.has(timeoutId)){_this3.setTimeoutIds_["delete"](timeoutId);}fn();},timeout);this.setTimeoutIds_.add(timeoutId);return timeoutId;}/**
   * Clears a timeout that gets created via `window.setTimeout` or
   * {@link Component#setTimeout}. If you set a timeout via {@link Component#setTimeout}
   * use this function instead of `window.clearTimout`. If you don't your dispose
   * listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} timeoutId
   *        The id of the timeout to clear. The return value of
   *        {@link Component#setTimeout} or `window.setTimeout`.
   *
   * @return {number}
   *         Returns the timeout id that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearTimeout}
   */;_proto.clearTimeout=function clearTimeout(timeoutId){if(this.setTimeoutIds_.has(timeoutId)){this.setTimeoutIds_["delete"](timeoutId);window_default().clearTimeout(timeoutId);}return timeoutId;}/**
   * Creates a function that gets run every `x` milliseconds. This function is a wrapper
   * around `window.setInterval`. There are a few reasons to use this one instead though.
   * 1. It gets cleared via  {@link Component#clearInterval} when
   *    {@link Component#dispose} gets called.
   * 2. The function callback will be a {@link Component~GenericCallback}
   *
   * @param {Component~GenericCallback} fn
   *        The function to run every `x` seconds.
   *
   * @param {number} interval
   *        Execute the specified function every `x` milliseconds.
   *
   * @return {number}
   *         Returns an id that can be used to identify the interval. It can also be be used in
   *         {@link Component#clearInterval} to clear the interval.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setInterval}
   */;_proto.setInterval=function setInterval(fn,interval){fn=bind(this,fn);this.clearTimersOnDispose_();var intervalId=window_default().setInterval(fn,interval);this.setIntervalIds_.add(intervalId);return intervalId;}/**
   * Clears an interval that gets created via `window.setInterval` or
   * {@link Component#setInterval}. If you set an inteval via {@link Component#setInterval}
   * use this function instead of `window.clearInterval`. If you don't your dispose
   * listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} intervalId
   *        The id of the interval to clear. The return value of
   *        {@link Component#setInterval} or `window.setInterval`.
   *
   * @return {number}
   *         Returns the interval id that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearInterval}
   */;_proto.clearInterval=function clearInterval(intervalId){if(this.setIntervalIds_.has(intervalId)){this.setIntervalIds_["delete"](intervalId);window_default().clearInterval(intervalId);}return intervalId;}/**
   * Queues up a callback to be passed to requestAnimationFrame (rAF), but
   * with a few extra bonuses:
   *
   * - Supports browsers that do not support rAF by falling back to
   *   {@link Component#setTimeout}.
   *
   * - The callback is turned into a {@link Component~GenericCallback} (i.e.
   *   bound to the component).
   *
   * - Automatic cancellation of the rAF callback is handled if the component
   *   is disposed before it is called.
   *
   * @param  {Component~GenericCallback} fn
   *         A function that will be bound to this component and executed just
   *         before the browser's next repaint.
   *
   * @return {number}
   *         Returns an rAF ID that gets used to identify the timeout. It can
   *         also be used in {@link Component#cancelAnimationFrame} to cancel
   *         the animation frame callback.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame}
   */;_proto.requestAnimationFrame=function requestAnimationFrame(fn){var _this4=this;// Fall back to using a timer.
if(!this.supportsRaf_){return this.setTimeout(fn,1000/60);}this.clearTimersOnDispose_();// declare as variables so they are properly available in rAF function
// eslint-disable-next-line
var id;fn=bind(this,fn);id=window_default().requestAnimationFrame(function(){if(_this4.rafIds_.has(id)){_this4.rafIds_["delete"](id);}fn();});this.rafIds_.add(id);return id;}/**
   * Request an animation frame, but only one named animation
   * frame will be queued. Another will never be added until
   * the previous one finishes.
   *
   * @param {string} name
   *        The name to give this requestAnimationFrame
   *
   * @param  {Component~GenericCallback} fn
   *         A function that will be bound to this component and executed just
   *         before the browser's next repaint.
   */;_proto.requestNamedAnimationFrame=function requestNamedAnimationFrame(name,fn){var _this5=this;if(this.namedRafs_.has(name)){return;}this.clearTimersOnDispose_();fn=bind(this,fn);var id=this.requestAnimationFrame(function(){fn();if(_this5.namedRafs_.has(name)){_this5.namedRafs_["delete"](name);}});this.namedRafs_.set(name,id);return name;}/**
   * Cancels a current named animation frame if it exists.
   *
   * @param {string} name
   *        The name of the requestAnimationFrame to cancel.
   */;_proto.cancelNamedAnimationFrame=function cancelNamedAnimationFrame(name){if(!this.namedRafs_.has(name)){return;}this.cancelAnimationFrame(this.namedRafs_.get(name));this.namedRafs_["delete"](name);}/**
   * Cancels a queued callback passed to {@link Component#requestAnimationFrame}
   * (rAF).
   *
   * If you queue an rAF callback via {@link Component#requestAnimationFrame},
   * use this function instead of `window.cancelAnimationFrame`. If you don't,
   * your dispose listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} id
   *        The rAF ID to clear. The return value of {@link Component#requestAnimationFrame}.
   *
   * @return {number}
   *         Returns the rAF ID that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/cancelAnimationFrame}
   */;_proto.cancelAnimationFrame=function cancelAnimationFrame(id){// Fall back to using a timer.
if(!this.supportsRaf_){return this.clearTimeout(id);}if(this.rafIds_.has(id)){this.rafIds_["delete"](id);window_default().cancelAnimationFrame(id);}return id;}/**
   * A function to setup `requestAnimationFrame`, `setTimeout`,
   * and `setInterval`, clearing on dispose.
   *
   * > Previously each timer added and removed dispose listeners on it's own.
   * For better performance it was decided to batch them all, and use `Set`s
   * to track outstanding timer ids.
   *
   * @private
   */;_proto.clearTimersOnDispose_=function clearTimersOnDispose_(){var _this6=this;if(this.clearingTimersOnDispose_){return;}this.clearingTimersOnDispose_=true;this.one('dispose',function(){[['namedRafs_','cancelNamedAnimationFrame'],['rafIds_','cancelAnimationFrame'],['setTimeoutIds_','clearTimeout'],['setIntervalIds_','clearInterval']].forEach(function(_ref){var idName=_ref[0],cancelName=_ref[1];// for a `Set` key will actually be the value again
// so forEach((val, val) =>` but for maps we want to use
// the key.
_this6[idName].forEach(function(val,key){return _this6[cancelName](key);});});_this6.clearingTimersOnDispose_=false;});}/**
   * Register a `Component` with `videojs` given the name and the component.
   *
   * > NOTE: {@link Tech}s should not be registered as a `Component`. {@link Tech}s
   *         should be registered using {@link Tech.registerTech} or
   *         {@link videojs:videojs.registerTech}.
   *
   * > NOTE: This function can also be seen on videojs as
   *         {@link videojs:videojs.registerComponent}.
   *
   * @param {string} name
   *        The name of the `Component` to register.
   *
   * @param {Component} ComponentToRegister
   *        The `Component` class to register.
   *
   * @return {Component}
   *         The `Component` that was registered.
   */;Component.registerComponent=function registerComponent(name,ComponentToRegister){if(typeof name!=='string'||!name){throw new Error("Illegal component name, \""+name+"\"; must be a non-empty string.");}var Tech=Component.getComponent('Tech');// We need to make sure this check is only done if Tech has been registered.
var isTech=Tech&&Tech.isTech(ComponentToRegister);var isComp=Component===ComponentToRegister||Component.prototype.isPrototypeOf(ComponentToRegister.prototype);if(isTech||!isComp){var reason;if(isTech){reason='techs must be registered using Tech.registerTech()';}else{reason='must be a Component subclass';}throw new Error("Illegal component, \""+name+"\"; "+reason+".");}name=toTitleCase$1(name);if(!Component.components_){Component.components_={};}var Player=Component.getComponent('Player');if(name==='Player'&&Player&&Player.players){var players=Player.players;var playerNames=Object.keys(players);// If we have players that were disposed, then their name will still be
// in Players.players. So, we must loop through and verify that the value
// for each item is not null. This allows registration of the Player component
// after all players have been disposed or before any were created.
if(players&&playerNames.length>0&&playerNames.map(function(pname){return players[pname];}).every(Boolean)){throw new Error('Can not register Player component after player has been created.');}}Component.components_[name]=ComponentToRegister;Component.components_[toLowerCase(name)]=ComponentToRegister;return ComponentToRegister;}/**
   * Get a `Component` based on the name it was registered with.
   *
   * @param {string} name
   *        The Name of the component to get.
   *
   * @return {Component}
   *         The `Component` that got registered under the given name.
   */;Component.getComponent=function getComponent(name){if(!name||!Component.components_){return;}return Component.components_[name];};return Component;}();/**
 * Whether or not this component supports `requestAnimationFrame`.
 *
 * This is exposed primarily for testing purposes.
 *
 * @private
 * @type {Boolean}
 */Component$1.prototype.supportsRaf_=typeof (window_default()).requestAnimationFrame==='function'&&typeof (window_default()).cancelAnimationFrame==='function';Component$1.registerComponent('Component',Component$1);/**
 * @file time-ranges.js
 * @module time-ranges
 */ /**
 * Returns the time for the specified index at the start or end
 * of a TimeRange object.
 *
 * @typedef    {Function} TimeRangeIndex
 *
 * @param      {number} [index=0]
 *             The range number to return the time for.
 *
 * @return     {number}
 *             The time offset at the specified index.
 *
 * @deprecated The index argument must be provided.
 *             In the future, leaving it out will throw an error.
 */ /**
 * An object that contains ranges of time.
 *
 * @typedef  {Object} TimeRange
 *
 * @property {number} length
 *           The number of time ranges represented by this object.
 *
 * @property {module:time-ranges~TimeRangeIndex} start
 *           Returns the time offset at which a specified time range begins.
 *
 * @property {module:time-ranges~TimeRangeIndex} end
 *           Returns the time offset at which a specified time range ends.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges
 */ /**
 * Check if any of the time ranges are over the maximum index.
 *
 * @private
 * @param   {string} fnName
 *          The function name to use for logging
 *
 * @param   {number} index
 *          The index to check
 *
 * @param   {number} maxIndex
 *          The maximum possible index
 *
 * @throws  {Error} if the timeRanges provided are over the maxIndex
 */function rangeCheck(fnName,index,maxIndex){if(typeof index!=='number'||index<0||index>maxIndex){throw new Error("Failed to execute '"+fnName+"' on 'TimeRanges': The index provided ("+index+") is non-numeric or out of bounds (0-"+maxIndex+").");}}/**
 * Get the time for the specified index at the start or end
 * of a TimeRange object.
 *
 * @private
 * @param      {string} fnName
 *             The function name to use for logging
 *
 * @param      {string} valueIndex
 *             The property that should be used to get the time. should be
 *             'start' or 'end'
 *
 * @param      {Array} ranges
 *             An array of time ranges
 *
 * @param      {Array} [rangeIndex=0]
 *             The index to start the search at
 *
 * @return     {number}
 *             The time that offset at the specified index.
 *
 * @deprecated rangeIndex must be set to a value, in the future this will throw an error.
 * @throws     {Error} if rangeIndex is more than the length of ranges
 */function getRange(fnName,valueIndex,ranges,rangeIndex){rangeCheck(fnName,rangeIndex,ranges.length-1);return ranges[rangeIndex][valueIndex];}/**
 * Create a time range object given ranges of time.
 *
 * @private
 * @param   {Array} [ranges]
 *          An array of time ranges.
 */function createTimeRangesObj(ranges){var timeRangesObj;if(ranges===undefined||ranges.length===0){timeRangesObj={length:0,start:function start(){throw new Error('This TimeRanges object is empty');},end:function end(){throw new Error('This TimeRanges object is empty');}};}else{timeRangesObj={length:ranges.length,start:getRange.bind(null,'start',0,ranges),end:getRange.bind(null,'end',1,ranges)};}if((window_default()).Symbol&&(window_default()).Symbol.iterator){timeRangesObj[(window_default()).Symbol.iterator]=function(){return(ranges||[]).values();};}return timeRangesObj;}/**
 * Create a `TimeRange` object which mimics an
 * {@link https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges|HTML5 TimeRanges instance}.
 *
 * @param {number|Array[]} start
 *        The start of a single range (a number) or an array of ranges (an
 *        array of arrays of two numbers each).
 *
 * @param {number} end
 *        The end of a single range. Cannot be used with the array form of
 *        the `start` argument.
 */function createTimeRanges(start,end){if(Array.isArray(start)){return createTimeRangesObj(start);}else if(start===undefined||end===undefined){return createTimeRangesObj();}return createTimeRangesObj([[start,end]]);}/**
 * @file buffer.js
 * @module buffer
 */ /**
 * Compute the percentage of the media that has been buffered.
 *
 * @param {TimeRange} buffered
 *        The current `TimeRange` object representing buffered time ranges
 *
 * @param {number} duration
 *        Total duration of the media
 *
 * @return {number}
 *         Percent buffered of the total duration in decimal form.
 */function bufferedPercent(buffered,duration){var bufferedDuration=0;var start;var end;if(!duration){return 0;}if(!buffered||!buffered.length){buffered=createTimeRanges(0,0);}for(var i=0;i<buffered.length;i++){start=buffered.start(i);end=buffered.end(i);// buffered end can be bigger than duration by a very small fraction
if(end>duration){end=duration;}bufferedDuration+=end-start;}return bufferedDuration/duration;}/**
 * @file media-error.js
 */ /**
 * A Custom `MediaError` class which mimics the standard HTML5 `MediaError` class.
 *
 * @param {number|string|Object|MediaError} value
 *        This can be of multiple types:
 *        - number: should be a standard error code
 *        - string: an error message (the code will be 0)
 *        - Object: arbitrary properties
 *        - `MediaError` (native): used to populate a video.js `MediaError` object
 *        - `MediaError` (video.js): will return itself if it's already a
 *          video.js `MediaError` object.
 *
 * @see [MediaError Spec]{@link https://dev.w3.org/html5/spec-author-view/video.html#mediaerror}
 * @see [Encrypted MediaError Spec]{@link https://www.w3.org/TR/2013/WD-encrypted-media-20130510/#error-codes}
 *
 * @class MediaError
 */function MediaError(value){// Allow redundant calls to this constructor to avoid having `instanceof`
// checks peppered around the code.
if(value instanceof MediaError){return value;}if(typeof value==='number'){this.code=value;}else if(typeof value==='string'){// default code is zero, so this is a custom error
this.message=value;}else if(video_es_isObject(value)){// We assign the `code` property manually because native `MediaError` objects
// do not expose it as an own/enumerable property of the object.
if(typeof value.code==='number'){this.code=value.code;}video_es_assign(this,value);}if(!this.message){this.message=MediaError.defaultMessages[this.code]||'';}}/**
 * The error code that refers two one of the defined `MediaError` types
 *
 * @type {Number}
 */MediaError.prototype.code=0;/**
 * An optional message that to show with the error. Message is not part of the HTML5
 * video spec but allows for more informative custom errors.
 *
 * @type {String}
 */MediaError.prototype.message='';/**
 * An optional status code that can be set by plugins to allow even more detail about
 * the error. For example a plugin might provide a specific HTTP status code and an
 * error message for that code. Then when the plugin gets that error this class will
 * know how to display an error message for it. This allows a custom message to show
 * up on the `Player` error overlay.
 *
 * @type {Array}
 */MediaError.prototype.status=null;/**
 * Errors indexed by the W3C standard. The order **CANNOT CHANGE**! See the
 * specification listed under {@link MediaError} for more information.
 *
 * @enum {array}
 * @readonly
 * @property {string} 0 - MEDIA_ERR_CUSTOM
 * @property {string} 1 - MEDIA_ERR_ABORTED
 * @property {string} 2 - MEDIA_ERR_NETWORK
 * @property {string} 3 - MEDIA_ERR_DECODE
 * @property {string} 4 - MEDIA_ERR_SRC_NOT_SUPPORTED
 * @property {string} 5 - MEDIA_ERR_ENCRYPTED
 */MediaError.errorTypes=['MEDIA_ERR_CUSTOM','MEDIA_ERR_ABORTED','MEDIA_ERR_NETWORK','MEDIA_ERR_DECODE','MEDIA_ERR_SRC_NOT_SUPPORTED','MEDIA_ERR_ENCRYPTED'];/**
 * The default `MediaError` messages based on the {@link MediaError.errorTypes}.
 *
 * @type {Array}
 * @constant
 */MediaError.defaultMessages={1:'You aborted the media playback',2:'A network error caused the media download to fail part-way.',3:'The media playback was aborted due to a corruption problem or because the media used features your browser did not support.',4:'The media could not be loaded, either because the server or network failed or because the format is not supported.',5:'The media is encrypted and we do not have the keys to decrypt it.'};// Add types as properties on MediaError
// e.g. MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
for(var errNum=0;errNum<MediaError.errorTypes.length;errNum++){MediaError[MediaError.errorTypes[errNum]]=errNum;// values should be accessible on both the class and instance
MediaError.prototype[MediaError.errorTypes[errNum]]=errNum;}// jsdocs for instance/static members added above
/**
 * Returns whether an object is `Promise`-like (i.e. has a `then` method).
 *
 * @param  {Object}  value
 *         An object that may or may not be `Promise`-like.
 *
 * @return {boolean}
 *         Whether or not the object is `Promise`-like.
 */function isPromise(value){return value!==undefined&&value!==null&&typeof value.then==='function';}/**
 * Silence a Promise-like object.
 *
 * This is useful for avoiding non-harmful, but potentially confusing "uncaught
 * play promise" rejection error messages.
 *
 * @param  {Object} value
 *         An object that may or may not be `Promise`-like.
 */function silencePromise(value){if(isPromise(value)){value.then(null,function(e){});}}/**
 * @file text-track-list-converter.js Utilities for capturing text track state and
 * re-creating tracks based on a capture.
 *
 * @module text-track-list-converter
 */ /**
 * Examine a single {@link TextTrack} and return a JSON-compatible javascript object that
 * represents the {@link TextTrack}'s state.
 *
 * @param {TextTrack} track
 *        The text track to query.
 *
 * @return {Object}
 *         A serializable javascript representation of the TextTrack.
 * @private
 */var trackToJson_=function trackToJson_(track){var ret=['kind','label','language','id','inBandMetadataTrackDispatchType','mode','src'].reduce(function(acc,prop,i){if(track[prop]){acc[prop]=track[prop];}return acc;},{cues:track.cues&&Array.prototype.map.call(track.cues,function(cue){return{startTime:cue.startTime,endTime:cue.endTime,text:cue.text,id:cue.id};})});return ret;};/**
 * Examine a {@link Tech} and return a JSON-compatible javascript array that represents the
 * state of all {@link TextTrack}s currently configured. The return array is compatible with
 * {@link text-track-list-converter:jsonToTextTracks}.
 *
 * @param {Tech} tech
 *        The tech object to query
 *
 * @return {Array}
 *         A serializable javascript representation of the {@link Tech}s
 *         {@link TextTrackList}.
 */var textTracksToJson=function textTracksToJson(tech){var trackEls=tech.$$('track');var trackObjs=Array.prototype.map.call(trackEls,function(t){return t.track;});var tracks=Array.prototype.map.call(trackEls,function(trackEl){var json=trackToJson_(trackEl.track);if(trackEl.src){json.src=trackEl.src;}return json;});return tracks.concat(Array.prototype.filter.call(tech.textTracks(),function(track){return trackObjs.indexOf(track)===-1;}).map(trackToJson_));};/**
 * Create a set of remote {@link TextTrack}s on a {@link Tech} based on an array of javascript
 * object {@link TextTrack} representations.
 *
 * @param {Array} json
 *        An array of `TextTrack` representation objects, like those that would be
 *        produced by `textTracksToJson`.
 *
 * @param {Tech} tech
 *        The `Tech` to create the `TextTrack`s on.
 */var jsonToTextTracks=function jsonToTextTracks(json,tech){json.forEach(function(track){var addedTrack=tech.addRemoteTextTrack(track).track;if(!track.src&&track.cues){track.cues.forEach(function(cue){return addedTrack.addCue(cue);});}});return tech.textTracks();};var textTrackConverter={textTracksToJson:textTracksToJson,jsonToTextTracks:jsonToTextTracks,trackToJson_:trackToJson_};var MODAL_CLASS_NAME='vjs-modal-dialog';/**
 * The `ModalDialog` displays over the video and its controls, which blocks
 * interaction with the player until it is closed.
 *
 * Modal dialogs include a "Close" button and will close when that button
 * is activated - or when ESC is pressed anywhere.
 *
 * @extends Component
 */var ModalDialog=/*#__PURE__*/function(_Component){_inheritsLoose(ModalDialog,_Component);/**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Mixed} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.description]
   *        A text description for the modal, primarily for accessibility.
   *
   * @param {boolean} [options.fillAlways=false]
   *        Normally, modals are automatically filled only the first time
   *        they open. This tells the modal to refresh its content
   *        every time it opens.
   *
   * @param {string} [options.label]
   *        A text label for the modal, primarily for accessibility.
   *
   * @param {boolean} [options.pauseOnOpen=true]
   *        If `true`, playback will will be paused if playing when
   *        the modal opens, and resumed when it closes.
   *
   * @param {boolean} [options.temporary=true]
   *        If `true`, the modal can only be opened once; it will be
   *        disposed as soon as it's closed.
   *
   * @param {boolean} [options.uncloseable=false]
   *        If `true`, the user will not be able to close the modal
   *        through the UI in the normal ways. Programmatic closing is
   *        still possible.
   */function ModalDialog(player,options){var _this;_this=_Component.call(this,player,options)||this;_this.handleKeyDown_=function(e){return _this.handleKeyDown(e);};_this.close_=function(e){return _this.close(e);};_this.opened_=_this.hasBeenOpened_=_this.hasBeenFilled_=false;_this.closeable(!_this.options_.uncloseable);_this.content(_this.options_.content);// Make sure the contentEl is defined AFTER any children are initialized
// because we only want the contents of the modal in the contentEl
// (not the UI elements like the close button).
_this.contentEl_=createEl('div',{className:MODAL_CLASS_NAME+"-content"},{role:'document'});_this.descEl_=createEl('p',{className:MODAL_CLASS_NAME+"-description vjs-control-text",id:_this.el().getAttribute('aria-describedby')});textContent(_this.descEl_,_this.description());_this.el_.appendChild(_this.descEl_);_this.el_.appendChild(_this.contentEl_);return _this;}/**
   * Create the `ModalDialog`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */var _proto=ModalDialog.prototype;_proto.createEl=function createEl(){return _Component.prototype.createEl.call(this,'div',{className:this.buildCSSClass(),tabIndex:-1},{'aria-describedby':this.id()+"_description",'aria-hidden':'true','aria-label':this.label(),'role':'dialog'});};_proto.dispose=function dispose(){this.contentEl_=null;this.descEl_=null;this.previouslyActiveEl_=null;_Component.prototype.dispose.call(this);}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */;_proto.buildCSSClass=function buildCSSClass(){return MODAL_CLASS_NAME+" vjs-hidden "+_Component.prototype.buildCSSClass.call(this);}/**
   * Returns the label string for this modal. Primarily used for accessibility.
   *
   * @return {string}
   *         the localized or raw label of this modal.
   */;_proto.label=function label(){return this.localize(this.options_.label||'Modal Window');}/**
   * Returns the description string for this modal. Primarily used for
   * accessibility.
   *
   * @return {string}
   *         The localized or raw description of this modal.
   */;_proto.description=function description(){var desc=this.options_.description||this.localize('This is a modal window.');// Append a universal closeability message if the modal is closeable.
if(this.closeable()){desc+=' '+this.localize('This modal can be closed by pressing the Escape key or activating the close button.');}return desc;}/**
   * Opens the modal.
   *
   * @fires ModalDialog#beforemodalopen
   * @fires ModalDialog#modalopen
   */;_proto.open=function open(){if(!this.opened_){var player=this.player();/**
        * Fired just before a `ModalDialog` is opened.
        *
        * @event ModalDialog#beforemodalopen
        * @type {EventTarget~Event}
        */this.trigger('beforemodalopen');this.opened_=true;// Fill content if the modal has never opened before and
// never been filled.
if(this.options_.fillAlways||!this.hasBeenOpened_&&!this.hasBeenFilled_){this.fill();}// If the player was playing, pause it and take note of its previously
// playing state.
this.wasPlaying_=!player.paused();if(this.options_.pauseOnOpen&&this.wasPlaying_){player.pause();}this.on('keydown',this.handleKeyDown_);// Hide controls and note if they were enabled.
this.hadControls_=player.controls();player.controls(false);this.show();this.conditionalFocus_();this.el().setAttribute('aria-hidden','false');/**
        * Fired just after a `ModalDialog` is opened.
        *
        * @event ModalDialog#modalopen
        * @type {EventTarget~Event}
        */this.trigger('modalopen');this.hasBeenOpened_=true;}}/**
   * If the `ModalDialog` is currently open or closed.
   *
   * @param  {boolean} [value]
   *         If given, it will open (`true`) or close (`false`) the modal.
   *
   * @return {boolean}
   *         the current open state of the modaldialog
   */;_proto.opened=function opened(value){if(typeof value==='boolean'){this[value?'open':'close']();}return this.opened_;}/**
   * Closes the modal, does nothing if the `ModalDialog` is
   * not open.
   *
   * @fires ModalDialog#beforemodalclose
   * @fires ModalDialog#modalclose
   */;_proto.close=function close(){if(!this.opened_){return;}var player=this.player();/**
      * Fired just before a `ModalDialog` is closed.
      *
      * @event ModalDialog#beforemodalclose
      * @type {EventTarget~Event}
      */this.trigger('beforemodalclose');this.opened_=false;if(this.wasPlaying_&&this.options_.pauseOnOpen){player.play();}this.off('keydown',this.handleKeyDown_);if(this.hadControls_){player.controls(true);}this.hide();this.el().setAttribute('aria-hidden','true');/**
      * Fired just after a `ModalDialog` is closed.
      *
      * @event ModalDialog#modalclose
      * @type {EventTarget~Event}
      */this.trigger('modalclose');this.conditionalBlur_();if(this.options_.temporary){this.dispose();}}/**
   * Check to see if the `ModalDialog` is closeable via the UI.
   *
   * @param  {boolean} [value]
   *         If given as a boolean, it will set the `closeable` option.
   *
   * @return {boolean}
   *         Returns the final value of the closable option.
   */;_proto.closeable=function closeable(value){if(typeof value==='boolean'){var closeable=this.closeable_=!!value;var close=this.getChild('closeButton');// If this is being made closeable and has no close button, add one.
if(closeable&&!close){// The close button should be a child of the modal - not its
// content element, so temporarily change the content element.
var temp=this.contentEl_;this.contentEl_=this.el_;close=this.addChild('closeButton',{controlText:'Close Modal Dialog'});this.contentEl_=temp;this.on(close,'close',this.close_);}// If this is being made uncloseable and has a close button, remove it.
if(!closeable&&close){this.off(close,'close',this.close_);this.removeChild(close);close.dispose();}}return this.closeable_;}/**
   * Fill the modal's content element with the modal's "content" option.
   * The content element will be emptied before this change takes place.
   */;_proto.fill=function fill(){this.fillWith(this.content());}/**
   * Fill the modal's content element with arbitrary content.
   * The content element will be emptied before this change takes place.
   *
   * @fires ModalDialog#beforemodalfill
   * @fires ModalDialog#modalfill
   *
   * @param {Mixed} [content]
   *        The same rules apply to this as apply to the `content` option.
   */;_proto.fillWith=function fillWith(content){var contentEl=this.contentEl();var parentEl=contentEl.parentNode;var nextSiblingEl=contentEl.nextSibling;/**
      * Fired just before a `ModalDialog` is filled with content.
      *
      * @event ModalDialog#beforemodalfill
      * @type {EventTarget~Event}
      */this.trigger('beforemodalfill');this.hasBeenFilled_=true;// Detach the content element from the DOM before performing
// manipulation to avoid modifying the live DOM multiple times.
parentEl.removeChild(contentEl);this.empty();insertContent(contentEl,content);/**
     * Fired just after a `ModalDialog` is filled with content.
     *
     * @event ModalDialog#modalfill
     * @type {EventTarget~Event}
     */this.trigger('modalfill');// Re-inject the re-filled content element.
if(nextSiblingEl){parentEl.insertBefore(contentEl,nextSiblingEl);}else{parentEl.appendChild(contentEl);}// make sure that the close button is last in the dialog DOM
var closeButton=this.getChild('closeButton');if(closeButton){parentEl.appendChild(closeButton.el_);}}/**
   * Empties the content element. This happens anytime the modal is filled.
   *
   * @fires ModalDialog#beforemodalempty
   * @fires ModalDialog#modalempty
   */;_proto.empty=function empty(){/**
    * Fired just before a `ModalDialog` is emptied.
    *
    * @event ModalDialog#beforemodalempty
    * @type {EventTarget~Event}
    */this.trigger('beforemodalempty');emptyEl(this.contentEl());/**
    * Fired just after a `ModalDialog` is emptied.
    *
    * @event ModalDialog#modalempty
    * @type {EventTarget~Event}
    */this.trigger('modalempty');}/**
   * Gets or sets the modal content, which gets normalized before being
   * rendered into the DOM.
   *
   * This does not update the DOM or fill the modal, but it is called during
   * that process.
   *
   * @param  {Mixed} [value]
   *         If defined, sets the internal content value to be used on the
   *         next call(s) to `fill`. This value is normalized before being
   *         inserted. To "clear" the internal content value, pass `null`.
   *
   * @return {Mixed}
   *         The current content of the modal dialog
   */;_proto.content=function content(value){if(typeof value!=='undefined'){this.content_=value;}return this.content_;}/**
   * conditionally focus the modal dialog if focus was previously on the player.
   *
   * @private
   */;_proto.conditionalFocus_=function conditionalFocus_(){var activeEl=(document_default()).activeElement;var playerEl=this.player_.el_;this.previouslyActiveEl_=null;if(playerEl.contains(activeEl)||playerEl===activeEl){this.previouslyActiveEl_=activeEl;this.focus();}}/**
   * conditionally blur the element and refocus the last focused element
   *
   * @private
   */;_proto.conditionalBlur_=function conditionalBlur_(){if(this.previouslyActiveEl_){this.previouslyActiveEl_.focus();this.previouslyActiveEl_=null;}}/**
   * Keydown handler. Attached when modal is focused.
   *
   * @listens keydown
   */;_proto.handleKeyDown=function handleKeyDown(event){// Do not allow keydowns to reach out of the modal dialog.
event.stopPropagation();if(keycode_default().isEventKey(event,'Escape')&&this.closeable()){event.preventDefault();this.close();return;}// exit early if it isn't a tab key
if(!keycode_default().isEventKey(event,'Tab')){return;}var focusableEls=this.focusableEls_();var activeEl=this.el_.querySelector(':focus');var focusIndex;for(var i=0;i<focusableEls.length;i++){if(activeEl===focusableEls[i]){focusIndex=i;break;}}if((document_default()).activeElement===this.el_){focusIndex=0;}if(event.shiftKey&&focusIndex===0){focusableEls[focusableEls.length-1].focus();event.preventDefault();}else if(!event.shiftKey&&focusIndex===focusableEls.length-1){focusableEls[0].focus();event.preventDefault();}}/**
   * get all focusable elements
   *
   * @private
   */;_proto.focusableEls_=function focusableEls_(){var allChildren=this.el_.querySelectorAll('*');return Array.prototype.filter.call(allChildren,function(child){return(child instanceof (window_default()).HTMLAnchorElement||child instanceof (window_default()).HTMLAreaElement)&&child.hasAttribute('href')||(child instanceof (window_default()).HTMLInputElement||child instanceof (window_default()).HTMLSelectElement||child instanceof (window_default()).HTMLTextAreaElement||child instanceof (window_default()).HTMLButtonElement)&&!child.hasAttribute('disabled')||child instanceof (window_default()).HTMLIFrameElement||child instanceof (window_default()).HTMLObjectElement||child instanceof (window_default()).HTMLEmbedElement||child.hasAttribute('tabindex')&&child.getAttribute('tabindex')!==-1||child.hasAttribute('contenteditable');});};return ModalDialog;}(Component$1);/**
 * Default options for `ModalDialog` default options.
 *
 * @type {Object}
 * @private
 */ModalDialog.prototype.options_={pauseOnOpen:true,temporary:true};Component$1.registerComponent('ModalDialog',ModalDialog);/**
 * Common functionaliy between {@link TextTrackList}, {@link AudioTrackList}, and
 * {@link VideoTrackList}
 *
 * @extends EventTarget
 */var TrackList=/*#__PURE__*/function(_EventTarget){_inheritsLoose(TrackList,_EventTarget);/**
   * Create an instance of this class
   *
   * @param {Track[]} tracks
   *        A list of tracks to initialize the list with.
   *
   * @abstract
   */function TrackList(tracks){var _this;if(tracks===void 0){tracks=[];}_this=_EventTarget.call(this)||this;_this.tracks_=[];/**
     * @memberof TrackList
     * @member {number} length
     *         The current number of `Track`s in the this Trackist.
     * @instance
     */Object.defineProperty(_assertThisInitialized(_this),'length',{get:function get(){return this.tracks_.length;}});for(var i=0;i<tracks.length;i++){_this.addTrack(tracks[i]);}return _this;}/**
   * Add a {@link Track} to the `TrackList`
   *
   * @param {Track} track
   *        The audio, video, or text track to add to the list.
   *
   * @fires TrackList#addtrack
   */var _proto=TrackList.prototype;_proto.addTrack=function addTrack(track){var _this2=this;var index=this.tracks_.length;if(!(''+index in this)){Object.defineProperty(this,index,{get:function get(){return this.tracks_[index];}});}// Do not add duplicate tracks
if(this.tracks_.indexOf(track)===-1){this.tracks_.push(track);/**
       * Triggered when a track is added to a track list.
       *
       * @event TrackList#addtrack
       * @type {EventTarget~Event}
       * @property {Track} track
       *           A reference to track that was added.
       */this.trigger({track:track,type:'addtrack',target:this});}/**
     * Triggered when a track label is changed.
     *
     * @event TrackList#addtrack
     * @type {EventTarget~Event}
     * @property {Track} track
     *           A reference to track that was added.
     */track.labelchange_=function(){_this2.trigger({track:track,type:'labelchange',target:_this2});};if(isEvented(track)){track.addEventListener('labelchange',track.labelchange_);}}/**
   * Remove a {@link Track} from the `TrackList`
   *
   * @param {Track} rtrack
   *        The audio, video, or text track to remove from the list.
   *
   * @fires TrackList#removetrack
   */;_proto.removeTrack=function removeTrack(rtrack){var track;for(var i=0,l=this.length;i<l;i++){if(this[i]===rtrack){track=this[i];if(track.off){track.off();}this.tracks_.splice(i,1);break;}}if(!track){return;}/**
     * Triggered when a track is removed from track list.
     *
     * @event TrackList#removetrack
     * @type {EventTarget~Event}
     * @property {Track} track
     *           A reference to track that was removed.
     */this.trigger({track:track,type:'removetrack',target:this});}/**
   * Get a Track from the TrackList by a tracks id
   *
   * @param {string} id - the id of the track to get
   * @method getTrackById
   * @return {Track}
   * @private
   */;_proto.getTrackById=function getTrackById(id){var result=null;for(var i=0,l=this.length;i<l;i++){var track=this[i];if(track.id===id){result=track;break;}}return result;};return TrackList;}(EventTarget$2);/**
 * Triggered when a different track is selected/enabled.
 *
 * @event TrackList#change
 * @type {EventTarget~Event}
 */ /**
 * Events that can be called with on + eventName. See {@link EventHandler}.
 *
 * @property {Object} TrackList#allowedEvents_
 * @private
 */TrackList.prototype.allowedEvents_={change:'change',addtrack:'addtrack',removetrack:'removetrack',labelchange:'labelchange'};// emulate attribute EventHandler support to allow for feature detection
for(var video_es_event in TrackList.prototype.allowedEvents_){TrackList.prototype['on'+video_es_event]=null;}/**
 * Anywhere we call this function we diverge from the spec
 * as we only support one enabled audiotrack at a time
 *
 * @param {AudioTrackList} list
 *        list to work on
 *
 * @param {AudioTrack} track
 *        The track to skip
 *
 * @private
 */var disableOthers$1=function disableOthers(list,track){for(var i=0;i<list.length;i++){if(!Object.keys(list[i]).length||track.id===list[i].id){continue;}// another audio track is enabled, disable it
list[i].enabled=false;}};/**
 * The current list of {@link AudioTrack} for a media file.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist}
 * @extends TrackList
 */var AudioTrackList=/*#__PURE__*/function(_TrackList){_inheritsLoose(AudioTrackList,_TrackList);/**
   * Create an instance of this class.
   *
   * @param {AudioTrack[]} [tracks=[]]
   *        A list of `AudioTrack` to instantiate the list with.
   */function AudioTrackList(tracks){var _this;if(tracks===void 0){tracks=[];}// make sure only 1 track is enabled
// sorted from last index to first index
for(var i=tracks.length-1;i>=0;i--){if(tracks[i].enabled){disableOthers$1(tracks,tracks[i]);break;}}_this=_TrackList.call(this,tracks)||this;_this.changing_=false;return _this;}/**
   * Add an {@link AudioTrack} to the `AudioTrackList`.
   *
   * @param {AudioTrack} track
   *        The AudioTrack to add to the list
   *
   * @fires TrackList#addtrack
   */var _proto=AudioTrackList.prototype;_proto.addTrack=function addTrack(track){var _this2=this;if(track.enabled){disableOthers$1(this,track);}_TrackList.prototype.addTrack.call(this,track);// native tracks don't have this
if(!track.addEventListener){return;}track.enabledChange_=function(){// when we are disabling other tracks (since we don't support
// more than one track at a time) we will set changing_
// to true so that we don't trigger additional change events
if(_this2.changing_){return;}_this2.changing_=true;disableOthers$1(_this2,track);_this2.changing_=false;_this2.trigger('change');};/**
     * @listens AudioTrack#enabledchange
     * @fires TrackList#change
     */track.addEventListener('enabledchange',track.enabledChange_);};_proto.removeTrack=function removeTrack(rtrack){_TrackList.prototype.removeTrack.call(this,rtrack);if(rtrack.removeEventListener&&rtrack.enabledChange_){rtrack.removeEventListener('enabledchange',rtrack.enabledChange_);rtrack.enabledChange_=null;}};return AudioTrackList;}(TrackList);/**
 * Un-select all other {@link VideoTrack}s that are selected.
 *
 * @param {VideoTrackList} list
 *        list to work on
 *
 * @param {VideoTrack} track
 *        The track to skip
 *
 * @private
 */var disableOthers=function disableOthers(list,track){for(var i=0;i<list.length;i++){if(!Object.keys(list[i]).length||track.id===list[i].id){continue;}// another video track is enabled, disable it
list[i].selected=false;}};/**
 * The current list of {@link VideoTrack} for a video.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist}
 * @extends TrackList
 */var VideoTrackList=/*#__PURE__*/function(_TrackList){_inheritsLoose(VideoTrackList,_TrackList);/**
   * Create an instance of this class.
   *
   * @param {VideoTrack[]} [tracks=[]]
   *        A list of `VideoTrack` to instantiate the list with.
   */function VideoTrackList(tracks){var _this;if(tracks===void 0){tracks=[];}// make sure only 1 track is enabled
// sorted from last index to first index
for(var i=tracks.length-1;i>=0;i--){if(tracks[i].selected){disableOthers(tracks,tracks[i]);break;}}_this=_TrackList.call(this,tracks)||this;_this.changing_=false;/**
     * @member {number} VideoTrackList#selectedIndex
     *         The current index of the selected {@link VideoTrack`}.
     */Object.defineProperty(_assertThisInitialized(_this),'selectedIndex',{get:function get(){for(var _i=0;_i<this.length;_i++){if(this[_i].selected){return _i;}}return-1;},set:function set(){}});return _this;}/**
   * Add a {@link VideoTrack} to the `VideoTrackList`.
   *
   * @param {VideoTrack} track
   *        The VideoTrack to add to the list
   *
   * @fires TrackList#addtrack
   */var _proto=VideoTrackList.prototype;_proto.addTrack=function addTrack(track){var _this2=this;if(track.selected){disableOthers(this,track);}_TrackList.prototype.addTrack.call(this,track);// native tracks don't have this
if(!track.addEventListener){return;}track.selectedChange_=function(){if(_this2.changing_){return;}_this2.changing_=true;disableOthers(_this2,track);_this2.changing_=false;_this2.trigger('change');};/**
     * @listens VideoTrack#selectedchange
     * @fires TrackList#change
     */track.addEventListener('selectedchange',track.selectedChange_);};_proto.removeTrack=function removeTrack(rtrack){_TrackList.prototype.removeTrack.call(this,rtrack);if(rtrack.removeEventListener&&rtrack.selectedChange_){rtrack.removeEventListener('selectedchange',rtrack.selectedChange_);rtrack.selectedChange_=null;}};return VideoTrackList;}(TrackList);/**
 * The current list of {@link TextTrack} for a media file.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttracklist}
 * @extends TrackList
 */var TextTrackList=/*#__PURE__*/function(_TrackList){_inheritsLoose(TextTrackList,_TrackList);function TextTrackList(){return _TrackList.apply(this,arguments)||this;}var _proto=TextTrackList.prototype;/**
   * Add a {@link TextTrack} to the `TextTrackList`
   *
   * @param {TextTrack} track
   *        The text track to add to the list.
   *
   * @fires TrackList#addtrack
   */_proto.addTrack=function addTrack(track){var _this=this;_TrackList.prototype.addTrack.call(this,track);if(!this.queueChange_){this.queueChange_=function(){return _this.queueTrigger('change');};}if(!this.triggerSelectedlanguagechange){this.triggerSelectedlanguagechange_=function(){return _this.trigger('selectedlanguagechange');};}/**
     * @listens TextTrack#modechange
     * @fires TrackList#change
     */track.addEventListener('modechange',this.queueChange_);var nonLanguageTextTrackKind=['metadata','chapters'];if(nonLanguageTextTrackKind.indexOf(track.kind)===-1){track.addEventListener('modechange',this.triggerSelectedlanguagechange_);}};_proto.removeTrack=function removeTrack(rtrack){_TrackList.prototype.removeTrack.call(this,rtrack);// manually remove the event handlers we added
if(rtrack.removeEventListener){if(this.queueChange_){rtrack.removeEventListener('modechange',this.queueChange_);}if(this.selectedlanguagechange_){rtrack.removeEventListener('modechange',this.triggerSelectedlanguagechange_);}}};return TextTrackList;}(TrackList);/**
 * @file html-track-element-list.js
 */ /**
 * The current list of {@link HtmlTrackElement}s.
 */var HtmlTrackElementList=/*#__PURE__*/function(){/**
   * Create an instance of this class.
   *
   * @param {HtmlTrackElement[]} [tracks=[]]
   *        A list of `HtmlTrackElement` to instantiate the list with.
   */function HtmlTrackElementList(trackElements){if(trackElements===void 0){trackElements=[];}this.trackElements_=[];/**
     * @memberof HtmlTrackElementList
     * @member {number} length
     *         The current number of `Track`s in the this Trackist.
     * @instance
     */Object.defineProperty(this,'length',{get:function get(){return this.trackElements_.length;}});for(var i=0,length=trackElements.length;i<length;i++){this.addTrackElement_(trackElements[i]);}}/**
   * Add an {@link HtmlTrackElement} to the `HtmlTrackElementList`
   *
   * @param {HtmlTrackElement} trackElement
   *        The track element to add to the list.
   *
   * @private
   */var _proto=HtmlTrackElementList.prototype;_proto.addTrackElement_=function addTrackElement_(trackElement){var index=this.trackElements_.length;if(!(''+index in this)){Object.defineProperty(this,index,{get:function get(){return this.trackElements_[index];}});}// Do not add duplicate elements
if(this.trackElements_.indexOf(trackElement)===-1){this.trackElements_.push(trackElement);}}/**
   * Get an {@link HtmlTrackElement} from the `HtmlTrackElementList` given an
   * {@link TextTrack}.
   *
   * @param {TextTrack} track
   *        The track associated with a track element.
   *
   * @return {HtmlTrackElement|undefined}
   *         The track element that was found or undefined.
   *
   * @private
   */;_proto.getTrackElementByTrack_=function getTrackElementByTrack_(track){var trackElement_;for(var i=0,length=this.trackElements_.length;i<length;i++){if(track===this.trackElements_[i].track){trackElement_=this.trackElements_[i];break;}}return trackElement_;}/**
   * Remove a {@link HtmlTrackElement} from the `HtmlTrackElementList`
   *
   * @param {HtmlTrackElement} trackElement
   *        The track element to remove from the list.
   *
   * @private
   */;_proto.removeTrackElement_=function removeTrackElement_(trackElement){for(var i=0,length=this.trackElements_.length;i<length;i++){if(trackElement===this.trackElements_[i]){if(this.trackElements_[i].track&&typeof this.trackElements_[i].track.off==='function'){this.trackElements_[i].track.off();}if(typeof this.trackElements_[i].off==='function'){this.trackElements_[i].off();}this.trackElements_.splice(i,1);break;}}};return HtmlTrackElementList;}();/**
 * @file text-track-cue-list.js
 */ /**
 * @typedef {Object} TextTrackCueList~TextTrackCue
 *
 * @property {string} id
 *           The unique id for this text track cue
 *
 * @property {number} startTime
 *           The start time for this text track cue
 *
 * @property {number} endTime
 *           The end time for this text track cue
 *
 * @property {boolean} pauseOnExit
 *           Pause when the end time is reached if true.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackcue}
 */ /**
 * A List of TextTrackCues.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackcuelist}
 */var TextTrackCueList=/*#__PURE__*/function(){/**
   * Create an instance of this class..
   *
   * @param {Array} cues
   *        A list of cues to be initialized with
   */function TextTrackCueList(cues){TextTrackCueList.prototype.setCues_.call(this,cues);/**
     * @memberof TextTrackCueList
     * @member {number} length
     *         The current number of `TextTrackCue`s in the TextTrackCueList.
     * @instance
     */Object.defineProperty(this,'length',{get:function get(){return this.length_;}});}/**
   * A setter for cues in this list. Creates getters
   * an an index for the cues.
   *
   * @param {Array} cues
   *        An array of cues to set
   *
   * @private
   */var _proto=TextTrackCueList.prototype;_proto.setCues_=function setCues_(cues){var oldLength=this.length||0;var i=0;var l=cues.length;this.cues_=cues;this.length_=cues.length;var defineProp=function defineProp(index){if(!(''+index in this)){Object.defineProperty(this,''+index,{get:function get(){return this.cues_[index];}});}};if(oldLength<l){i=oldLength;for(;i<l;i++){defineProp.call(this,i);}}}/**
   * Get a `TextTrackCue` that is currently in the `TextTrackCueList` by id.
   *
   * @param {string} id
   *        The id of the cue that should be searched for.
   *
   * @return {TextTrackCueList~TextTrackCue|null}
   *         A single cue or null if none was found.
   */;_proto.getCueById=function getCueById(id){var result=null;for(var i=0,l=this.length;i<l;i++){var cue=this[i];if(cue.id===id){result=cue;break;}}return result;};return TextTrackCueList;}();/**
 * @file track-kinds.js
 */ /**
 * All possible `VideoTrackKind`s
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-videotrack-kind
 * @typedef VideoTrack~Kind
 * @enum
 */var VideoTrackKind={alternative:'alternative',captions:'captions',main:'main',sign:'sign',subtitles:'subtitles',commentary:'commentary'};/**
 * All possible `AudioTrackKind`s
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-audiotrack-kind
 * @typedef AudioTrack~Kind
 * @enum
 */var AudioTrackKind={'alternative':'alternative','descriptions':'descriptions','main':'main','main-desc':'main-desc','translation':'translation','commentary':'commentary'};/**
 * All possible `TextTrackKind`s
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-texttrack-kind
 * @typedef TextTrack~Kind
 * @enum
 */var TextTrackKind={subtitles:'subtitles',captions:'captions',descriptions:'descriptions',chapters:'chapters',metadata:'metadata'};/**
 * All possible `TextTrackMode`s
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackmode
 * @typedef TextTrack~Mode
 * @enum
 */var TextTrackMode={disabled:'disabled',hidden:'hidden',showing:'showing'};/**
 * A Track class that contains all of the common functionality for {@link AudioTrack},
 * {@link VideoTrack}, and {@link TextTrack}.
 *
 * > Note: This class should not be used directly
 *
 * @see {@link https://html.spec.whatwg.org/multipage/embedded-content.html}
 * @extends EventTarget
 * @abstract
 */var Track=/*#__PURE__*/function(_EventTarget){_inheritsLoose(Track,_EventTarget);/**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {string} [options.kind='']
   *        A valid kind for the track type you are creating.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @abstract
   */function Track(options){var _this;if(options===void 0){options={};}_this=_EventTarget.call(this)||this;var trackProps={id:options.id||'vjs_track_'+newGUID(),kind:options.kind||'',language:options.language||''};var label=options.label||'';/**
     * @memberof Track
     * @member {string} id
     *         The id of this track. Cannot be changed after creation.
     * @instance
     *
     * @readonly
     */ /**
     * @memberof Track
     * @member {string} kind
     *         The kind of track that this is. Cannot be changed after creation.
     * @instance
     *
     * @readonly
     */ /**
     * @memberof Track
     * @member {string} language
     *         The two letter language code for this track. Cannot be changed after
     *         creation.
     * @instance
     *
     * @readonly
     */var _loop=function _loop(key){Object.defineProperty(_assertThisInitialized(_this),key,{get:function get(){return trackProps[key];},set:function set(){}});};for(var key in trackProps){_loop(key);}/**
     * @memberof Track
     * @member {string} label
     *         The label of this track. Cannot be changed after creation.
     * @instance
     *
     * @fires Track#labelchange
     */Object.defineProperty(_assertThisInitialized(_this),'label',{get:function get(){return label;},set:function set(newLabel){if(newLabel!==label){label=newLabel;/**
           * An event that fires when label changes on this track.
           *
           * > Note: This is not part of the spec!
           *
           * @event Track#labelchange
           * @type {EventTarget~Event}
           */this.trigger('labelchange');}}});return _this;}return Track;}(EventTarget$2);/**
 * @file url.js
 * @module url
 */ /**
 * @typedef {Object} url:URLObject
 *
 * @property {string} protocol
 *           The protocol of the url that was parsed.
 *
 * @property {string} hostname
 *           The hostname of the url that was parsed.
 *
 * @property {string} port
 *           The port of the url that was parsed.
 *
 * @property {string} pathname
 *           The pathname of the url that was parsed.
 *
 * @property {string} search
 *           The search query of the url that was parsed.
 *
 * @property {string} hash
 *           The hash of the url that was parsed.
 *
 * @property {string} host
 *           The host of the url that was parsed.
 */ /**
 * Resolve and parse the elements of a URL.
 *
 * @function
 * @param    {String} url
 *           The url to parse
 *
 * @return   {url:URLObject}
 *           An object of url details
 */var parseUrl=function parseUrl(url){// This entire method can be replace with URL once we are able to drop IE11
var props=['protocol','hostname','port','pathname','search','hash','host'];// add the url to an anchor and let the browser parse the URL
var a=document_default().createElement('a');a.href=url;// Copy the specific URL properties to a new object
// This is also needed for IE because the anchor loses its
// properties when it's removed from the dom
var details={};for(var i=0;i<props.length;i++){details[props[i]]=a[props[i]];}// IE adds the port to the host property unlike everyone else. If
// a port identifier is added for standard ports, strip it.
if(details.protocol==='http:'){details.host=details.host.replace(/:80$/,'');}if(details.protocol==='https:'){details.host=details.host.replace(/:443$/,'');}if(!details.protocol){details.protocol=(window_default()).location.protocol;}/* istanbul ignore if */if(!details.host){details.host=(window_default()).location.host;}return details;};/**
 * Get absolute version of relative URL. Used to tell Flash the correct URL.
 *
 * @function
 * @param    {string} url
 *           URL to make absolute
 *
 * @return   {string}
 *           Absolute URL
 *
 * @see      http://stackoverflow.com/questions/470832/getting-an-absolute-url-from-a-relative-one-ie6-issue
 */var getAbsoluteURL=function getAbsoluteURL(url){// Check if absolute URL
if(!url.match(/^https?:\/\//)){// Convert to absolute URL. Flash hosted off-site needs an absolute URL.
// add the url to an anchor and let the browser parse the URL
var a=document_default().createElement('a');a.href=url;url=a.href;}return url;};/**
 * Returns the extension of the passed file name. It will return an empty string
 * if passed an invalid path.
 *
 * @function
 * @param    {string} path
 *           The fileName path like '/path/to/file.mp4'
 *
 * @return  {string}
 *           The extension in lower case or an empty string if no
 *           extension could be found.
 */var getFileExtension=function getFileExtension(path){if(typeof path==='string'){var splitPathRe=/^(\/?)([\s\S]*?)((?:\.{1,2}|[^\/]+?)(\.([^\.\/\?]+)))(?:[\/]*|[\?].*)$/;var pathParts=splitPathRe.exec(path);if(pathParts){return pathParts.pop().toLowerCase();}}return'';};/**
 * Returns whether the url passed is a cross domain request or not.
 *
 * @function
 * @param    {string} url
 *           The url to check.
 *
 * @param    {Object} [winLoc]
 *           the domain to check the url against, defaults to window.location
 *
 * @param    {string} [winLoc.protocol]
 *           The window location protocol defaults to window.location.protocol
 *
 * @param    {string} [winLoc.host]
 *           The window location host defaults to window.location.host
 *
 * @return   {boolean}
 *           Whether it is a cross domain request or not.
 */var isCrossOrigin=function isCrossOrigin(url,winLoc){if(winLoc===void 0){winLoc=(window_default()).location;}var urlInfo=parseUrl(url);// IE8 protocol relative urls will return ':' for protocol
var srcProtocol=urlInfo.protocol===':'?winLoc.protocol:urlInfo.protocol;// Check if url is for another domain/origin
// IE8 doesn't know location.origin, so we won't rely on it here
var crossOrigin=srcProtocol+urlInfo.host!==winLoc.protocol+winLoc.host;return crossOrigin;};var Url=/*#__PURE__*/Object.freeze({__proto__:null,parseUrl:parseUrl,getAbsoluteURL:getAbsoluteURL,getFileExtension:getFileExtension,isCrossOrigin:isCrossOrigin});/**
 * Takes a webvtt file contents and parses it into cues
 *
 * @param {string} srcContent
 *        webVTT file contents
 *
 * @param {TextTrack} track
 *        TextTrack to add cues to. Cues come from the srcContent.
 *
 * @private
 */var parseCues=function parseCues(srcContent,track){var parser=new (window_default()).WebVTT.Parser((window_default()),(window_default()).vttjs,window_default().WebVTT.StringDecoder());var errors=[];parser.oncue=function(cue){track.addCue(cue);};parser.onparsingerror=function(error){errors.push(error);};parser.onflush=function(){track.trigger({type:'loadeddata',target:track});};parser.parse(srcContent);if(errors.length>0){if((window_default()).console&&(window_default()).console.groupCollapsed){window_default().console.groupCollapsed("Text Track parsing errors for "+track.src);}errors.forEach(function(error){return log$1.error(error);});if((window_default()).console&&(window_default()).console.groupEnd){window_default().console.groupEnd();}}parser.flush();};/**
 * Load a `TextTrack` from a specified url.
 *
 * @param {string} src
 *        Url to load track from.
 *
 * @param {TextTrack} track
 *        Track to add cues to. Comes from the content at the end of `url`.
 *
 * @private
 */var loadTrack=function loadTrack(src,track){var opts={uri:src};var crossOrigin=isCrossOrigin(src);if(crossOrigin){opts.cors=crossOrigin;}var withCredentials=track.tech_.crossOrigin()==='use-credentials';if(withCredentials){opts.withCredentials=withCredentials;}lib_default()(opts,bind(this,function(err,response,responseBody){if(err){return log$1.error(err,response);}track.loaded_=true;// Make sure that vttjs has loaded, otherwise, wait till it finished loading
// NOTE: this is only used for the alt/video.novtt.js build
if(typeof (window_default()).WebVTT!=='function'){if(track.tech_){// to prevent use before define eslint error, we define loadHandler
// as a let here
track.tech_.any(['vttjsloaded','vttjserror'],function(event){if(event.type==='vttjserror'){log$1.error("vttjs failed to load, stopping trying to process "+track.src);return;}return parseCues(responseBody,track);});}}else{parseCues(responseBody,track);}}));};/**
 * A representation of a single `TextTrack`.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrack}
 * @extends Track
 */var TextTrack=/*#__PURE__*/function(_Track){_inheritsLoose(TextTrack,_Track);/**
   * Create an instance of this class.
   *
   * @param {Object} options={}
   *        Object of option names and values
   *
   * @param {Tech} options.tech
   *        A reference to the tech that owns this TextTrack.
   *
   * @param {TextTrack~Kind} [options.kind='subtitles']
   *        A valid text track kind.
   *
   * @param {TextTrack~Mode} [options.mode='disabled']
   *        A valid text track mode.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this TextTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {string} [options.srclang='']
   *        A valid two character language code. An alternative, but deprioritized
   *        version of `options.language`
   *
   * @param {string} [options.src]
   *        A url to TextTrack cues.
   *
   * @param {boolean} [options.default]
   *        If this track should default to on or off.
   */function TextTrack(options){var _this;if(options===void 0){options={};}if(!options.tech){throw new Error('A tech was not provided.');}var settings=mergeOptions$3(options,{kind:TextTrackKind[options.kind]||'subtitles',language:options.language||options.srclang||''});var mode=TextTrackMode[settings.mode]||'disabled';var default_=settings["default"];if(settings.kind==='metadata'||settings.kind==='chapters'){mode='hidden';}_this=_Track.call(this,settings)||this;_this.tech_=settings.tech;_this.cues_=[];_this.activeCues_=[];_this.preload_=_this.tech_.preloadTextTracks!==false;var cues=new TextTrackCueList(_this.cues_);var activeCues=new TextTrackCueList(_this.activeCues_);var changed=false;_this.timeupdateHandler=bind(_assertThisInitialized(_this),function(event){if(event===void 0){event={};}if(this.tech_.isDisposed()){return;}if(!this.tech_.isReady_){if(event.type!=='timeupdate'){this.rvf_=this.tech_.requestVideoFrameCallback(this.timeupdateHandler);}return;}// Accessing this.activeCues for the side-effects of updating itself
// due to its nature as a getter function. Do not remove or cues will
// stop updating!
// Use the setter to prevent deletion from uglify (pure_getters rule)
this.activeCues=this.activeCues;if(changed){this.trigger('cuechange');changed=false;}if(event.type!=='timeupdate'){this.rvf_=this.tech_.requestVideoFrameCallback(this.timeupdateHandler);}});var disposeHandler=function disposeHandler(){_this.stopTracking();};_this.tech_.one('dispose',disposeHandler);if(mode!=='disabled'){_this.startTracking();}Object.defineProperties(_assertThisInitialized(_this),{/**
       * @memberof TextTrack
       * @member {boolean} default
       *         If this track was set to be on or off by default. Cannot be changed after
       *         creation.
       * @instance
       *
       * @readonly
       */"default":{get:function get(){return default_;},set:function set(){}},/**
       * @memberof TextTrack
       * @member {string} mode
       *         Set the mode of this TextTrack to a valid {@link TextTrack~Mode}. Will
       *         not be set if setting to an invalid mode.
       * @instance
       *
       * @fires TextTrack#modechange
       */mode:{get:function get(){return mode;},set:function set(newMode){if(!TextTrackMode[newMode]){return;}if(mode===newMode){return;}mode=newMode;if(!this.preload_&&mode!=='disabled'&&this.cues.length===0){// On-demand load.
loadTrack(this.src,this);}this.stopTracking();if(mode!=='disabled'){this.startTracking();}/**
           * An event that fires when mode changes on this track. This allows
           * the TextTrackList that holds this track to act accordingly.
           *
           * > Note: This is not part of the spec!
           *
           * @event TextTrack#modechange
           * @type {EventTarget~Event}
           */this.trigger('modechange');}},/**
       * @memberof TextTrack
       * @member {TextTrackCueList} cues
       *         The text track cue list for this TextTrack.
       * @instance
       */cues:{get:function get(){if(!this.loaded_){return null;}return cues;},set:function set(){}},/**
       * @memberof TextTrack
       * @member {TextTrackCueList} activeCues
       *         The list text track cues that are currently active for this TextTrack.
       * @instance
       */activeCues:{get:function get(){if(!this.loaded_){return null;}// nothing to do
if(this.cues.length===0){return activeCues;}var ct=this.tech_.currentTime();var active=[];for(var i=0,l=this.cues.length;i<l;i++){var cue=this.cues[i];if(cue.startTime<=ct&&cue.endTime>=ct){active.push(cue);}else if(cue.startTime===cue.endTime&&cue.startTime<=ct&&cue.startTime+0.5>=ct){active.push(cue);}}changed=false;if(active.length!==this.activeCues_.length){changed=true;}else{for(var _i=0;_i<active.length;_i++){if(this.activeCues_.indexOf(active[_i])===-1){changed=true;}}}this.activeCues_=active;activeCues.setCues_(this.activeCues_);return activeCues;},// /!\ Keep this setter empty (see the timeupdate handler above)
set:function set(){}}});if(settings.src){_this.src=settings.src;if(!_this.preload_){// Tracks will load on-demand.
// Act like we're loaded for other purposes.
_this.loaded_=true;}if(_this.preload_||settings.kind!=='subtitles'&&settings.kind!=='captions'){loadTrack(_this.src,_assertThisInitialized(_this));}}else{_this.loaded_=true;}return _this;}var _proto=TextTrack.prototype;_proto.startTracking=function startTracking(){// More precise cues based on requestVideoFrameCallback with a requestAnimationFram fallback
this.rvf_=this.tech_.requestVideoFrameCallback(this.timeupdateHandler);// Also listen to timeupdate in case rVFC/rAF stops (window in background, audio in video el)
this.tech_.on('timeupdate',this.timeupdateHandler);};_proto.stopTracking=function stopTracking(){if(this.rvf_){this.tech_.cancelVideoFrameCallback(this.rvf_);this.rvf_=undefined;}this.tech_.off('timeupdate',this.timeupdateHandler);}/**
   * Add a cue to the internal list of cues.
   *
   * @param {TextTrack~Cue} cue
   *        The cue to add to our internal list
   */;_proto.addCue=function addCue(originalCue){var cue=originalCue;if(cue.constructor&&cue.constructor.name!=='VTTCue'){cue=new (window_default()).vttjs.VTTCue(originalCue.startTime,originalCue.endTime,originalCue.text);for(var prop in originalCue){if(!(prop in cue)){cue[prop]=originalCue[prop];}}// make sure that `id` is copied over
cue.id=originalCue.id;cue.originalCue_=originalCue;}var tracks=this.tech_.textTracks();for(var i=0;i<tracks.length;i++){if(tracks[i]!==this){tracks[i].removeCue(cue);}}this.cues_.push(cue);this.cues.setCues_(this.cues_);}/**
   * Remove a cue from our internal list
   *
   * @param {TextTrack~Cue} removeCue
   *        The cue to remove from our internal list
   */;_proto.removeCue=function removeCue(_removeCue){var i=this.cues_.length;while(i--){var cue=this.cues_[i];if(cue===_removeCue||cue.originalCue_&&cue.originalCue_===_removeCue){this.cues_.splice(i,1);this.cues.setCues_(this.cues_);break;}}};return TextTrack;}(Track);/**
 * cuechange - One or more cues in the track have become active or stopped being active.
 */TextTrack.prototype.allowedEvents_={cuechange:'cuechange'};/**
 * A representation of a single `AudioTrack`. If it is part of an {@link AudioTrackList}
 * only one `AudioTrack` in the list will be enabled at a time.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotrack}
 * @extends Track
 */var AudioTrack=/*#__PURE__*/function(_Track){_inheritsLoose(AudioTrack,_Track);/**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {AudioTrack~Kind} [options.kind='']
   *        A valid audio track kind
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {boolean} [options.enabled]
   *        If this track is the one that is currently playing. If this track is part of
   *        an {@link AudioTrackList}, only one {@link AudioTrack} will be enabled.
   */function AudioTrack(options){var _this;if(options===void 0){options={};}var settings=mergeOptions$3(options,{kind:AudioTrackKind[options.kind]||''});_this=_Track.call(this,settings)||this;var enabled=false;/**
     * @memberof AudioTrack
     * @member {boolean} enabled
     *         If this `AudioTrack` is enabled or not. When setting this will
     *         fire {@link AudioTrack#enabledchange} if the state of enabled is changed.
     * @instance
     *
     * @fires VideoTrack#selectedchange
     */Object.defineProperty(_assertThisInitialized(_this),'enabled',{get:function get(){return enabled;},set:function set(newEnabled){// an invalid or unchanged value
if(typeof newEnabled!=='boolean'||newEnabled===enabled){return;}enabled=newEnabled;/**
         * An event that fires when enabled changes on this track. This allows
         * the AudioTrackList that holds this track to act accordingly.
         *
         * > Note: This is not part of the spec! Native tracks will do
         *         this internally without an event.
         *
         * @event AudioTrack#enabledchange
         * @type {EventTarget~Event}
         */this.trigger('enabledchange');}});// if the user sets this track to selected then
// set selected to that true value otherwise
// we keep it false
if(settings.enabled){_this.enabled=settings.enabled;}_this.loaded_=true;return _this;}return AudioTrack;}(Track);/**
 * A representation of a single `VideoTrack`.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#videotrack}
 * @extends Track
 */var VideoTrack=/*#__PURE__*/function(_Track){_inheritsLoose(VideoTrack,_Track);/**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {string} [options.kind='']
   *        A valid {@link VideoTrack~Kind}
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {boolean} [options.selected]
   *        If this track is the one that is currently playing.
   */function VideoTrack(options){var _this;if(options===void 0){options={};}var settings=mergeOptions$3(options,{kind:VideoTrackKind[options.kind]||''});_this=_Track.call(this,settings)||this;var selected=false;/**
     * @memberof VideoTrack
     * @member {boolean} selected
     *         If this `VideoTrack` is selected or not. When setting this will
     *         fire {@link VideoTrack#selectedchange} if the state of selected changed.
     * @instance
     *
     * @fires VideoTrack#selectedchange
     */Object.defineProperty(_assertThisInitialized(_this),'selected',{get:function get(){return selected;},set:function set(newSelected){// an invalid or unchanged value
if(typeof newSelected!=='boolean'||newSelected===selected){return;}selected=newSelected;/**
         * An event that fires when selected changes on this track. This allows
         * the VideoTrackList that holds this track to act accordingly.
         *
         * > Note: This is not part of the spec! Native tracks will do
         *         this internally without an event.
         *
         * @event VideoTrack#selectedchange
         * @type {EventTarget~Event}
         */this.trigger('selectedchange');}});// if the user sets this track to selected then
// set selected to that true value otherwise
// we keep it false
if(settings.selected){_this.selected=settings.selected;}return _this;}return VideoTrack;}(Track);/**
 * @memberof HTMLTrackElement
 * @typedef {HTMLTrackElement~ReadyState}
 * @enum {number}
 */var NONE=0;var LOADING=1;var LOADED=2;var ERROR=3;/**
 * A single track represented in the DOM.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#htmltrackelement}
 * @extends EventTarget
 */var HTMLTrackElement=/*#__PURE__*/function(_EventTarget){_inheritsLoose(HTMLTrackElement,_EventTarget);/**
   * Create an instance of this class.
   *
   * @param {Object} options={}
   *        Object of option names and values
   *
   * @param {Tech} options.tech
   *        A reference to the tech that owns this HTMLTrackElement.
   *
   * @param {TextTrack~Kind} [options.kind='subtitles']
   *        A valid text track kind.
   *
   * @param {TextTrack~Mode} [options.mode='disabled']
   *        A valid text track mode.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this TextTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {string} [options.srclang='']
   *        A valid two character language code. An alternative, but deprioritized
   *        version of `options.language`
   *
   * @param {string} [options.src]
   *        A url to TextTrack cues.
   *
   * @param {boolean} [options.default]
   *        If this track should default to on or off.
   */function HTMLTrackElement(options){var _this;if(options===void 0){options={};}_this=_EventTarget.call(this)||this;var readyState;var track=new TextTrack(options);_this.kind=track.kind;_this.src=track.src;_this.srclang=track.language;_this.label=track.label;_this["default"]=track["default"];Object.defineProperties(_assertThisInitialized(_this),{/**
       * @memberof HTMLTrackElement
       * @member {HTMLTrackElement~ReadyState} readyState
       *         The current ready state of the track element.
       * @instance
       */readyState:{get:function get(){return readyState;}},/**
       * @memberof HTMLTrackElement
       * @member {TextTrack} track
       *         The underlying TextTrack object.
       * @instance
       *
       */track:{get:function get(){return track;}}});readyState=NONE;/**
     * @listens TextTrack#loadeddata
     * @fires HTMLTrackElement#load
     */track.addEventListener('loadeddata',function(){readyState=LOADED;_this.trigger({type:'load',target:_assertThisInitialized(_this)});});return _this;}return HTMLTrackElement;}(EventTarget$2);HTMLTrackElement.prototype.allowedEvents_={load:'load'};HTMLTrackElement.NONE=NONE;HTMLTrackElement.LOADING=LOADING;HTMLTrackElement.LOADED=LOADED;HTMLTrackElement.ERROR=ERROR;/*
 * This file contains all track properties that are used in
 * player.js, tech.js, html5.js and possibly other techs in the future.
 */var NORMAL={audio:{ListClass:AudioTrackList,TrackClass:AudioTrack,capitalName:'Audio'},video:{ListClass:VideoTrackList,TrackClass:VideoTrack,capitalName:'Video'},text:{ListClass:TextTrackList,TrackClass:TextTrack,capitalName:'Text'}};Object.keys(NORMAL).forEach(function(type){NORMAL[type].getterName=type+"Tracks";NORMAL[type].privateName=type+"Tracks_";});var REMOTE={remoteText:{ListClass:TextTrackList,TrackClass:TextTrack,capitalName:'RemoteText',getterName:'remoteTextTracks',privateName:'remoteTextTracks_'},remoteTextEl:{ListClass:HtmlTrackElementList,TrackClass:HTMLTrackElement,capitalName:'RemoteTextTrackEls',getterName:'remoteTextTrackEls',privateName:'remoteTextTrackEls_'}};var ALL=_extends({},NORMAL,REMOTE);REMOTE.names=Object.keys(REMOTE);NORMAL.names=Object.keys(NORMAL);ALL.names=[].concat(REMOTE.names).concat(NORMAL.names);/**
 * An Object containing a structure like: `{src: 'url', type: 'mimetype'}` or string
 * that just contains the src url alone.
 * * `var SourceObject = {src: 'http://ex.com/video.mp4', type: 'video/mp4'};`
   * `var SourceString = 'http://example.com/some-video.mp4';`
 *
 * @typedef {Object|string} Tech~SourceObject
 *
 * @property {string} src
 *           The url to the source
 *
 * @property {string} type
 *           The mime type of the source
 */ /**
 * A function used by {@link Tech} to create a new {@link TextTrack}.
 *
 * @private
 *
 * @param {Tech} self
 *        An instance of the Tech class.
 *
 * @param {string} kind
 *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
 *
 * @param {string} [label]
 *        Label to identify the text track
 *
 * @param {string} [language]
 *        Two letter language abbreviation
 *
 * @param {Object} [options={}]
 *        An object with additional text track options
 *
 * @return {TextTrack}
 *          The text track that was created.
 */function createTrackHelper(self,kind,label,language,options){if(options===void 0){options={};}var tracks=self.textTracks();options.kind=kind;if(label){options.label=label;}if(language){options.language=language;}options.tech=self;var track=new ALL.text.TrackClass(options);tracks.addTrack(track);return track;}/**
 * This is the base class for media playback technology controllers, such as
 * {@link HTML5}
 *
 * @extends Component
 */var Tech=/*#__PURE__*/function(_Component){_inheritsLoose(Tech,_Component);/**
  * Create an instance of this Tech.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  *
  * @param {Component~ReadyCallback} ready
  *        Callback function to call when the `HTML5` Tech is ready.
  */function Tech(options,ready){var _this;if(options===void 0){options={};}if(ready===void 0){ready=function ready(){};}// we don't want the tech to report user activity automatically.
// This is done manually in addControlsListeners
options.reportTouchActivity=false;_this=_Component.call(this,null,options,ready)||this;_this.onDurationChange_=function(e){return _this.onDurationChange(e);};_this.trackProgress_=function(e){return _this.trackProgress(e);};_this.trackCurrentTime_=function(e){return _this.trackCurrentTime(e);};_this.stopTrackingCurrentTime_=function(e){return _this.stopTrackingCurrentTime(e);};_this.disposeSourceHandler_=function(e){return _this.disposeSourceHandler(e);};_this.queuedHanders_=new Set();// keep track of whether the current source has played at all to
// implement a very limited played()
_this.hasStarted_=false;_this.on('playing',function(){this.hasStarted_=true;});_this.on('loadstart',function(){this.hasStarted_=false;});ALL.names.forEach(function(name){var props=ALL[name];if(options&&options[props.getterName]){_this[props.privateName]=options[props.getterName];}});// Manually track progress in cases where the browser/tech doesn't report it.
if(!_this.featuresProgressEvents){_this.manualProgressOn();}// Manually track timeupdates in cases where the browser/tech doesn't report it.
if(!_this.featuresTimeupdateEvents){_this.manualTimeUpdatesOn();}['Text','Audio','Video'].forEach(function(track){if(options["native"+track+"Tracks"]===false){_this["featuresNative"+track+"Tracks"]=false;}});if(options.nativeCaptions===false||options.nativeTextTracks===false){_this.featuresNativeTextTracks=false;}else if(options.nativeCaptions===true||options.nativeTextTracks===true){_this.featuresNativeTextTracks=true;}if(!_this.featuresNativeTextTracks){_this.emulateTextTracks();}_this.preloadTextTracks=options.preloadTextTracks!==false;_this.autoRemoteTextTracks_=new ALL.text.ListClass();_this.initTrackListeners();// Turn on component tap events only if not using native controls
if(!options.nativeControlsForTouch){_this.emitTapEvents();}if(_this.constructor){_this.name_=_this.constructor.name||'Unknown Tech';}return _this;}/**
   * A special function to trigger source set in a way that will allow player
   * to re-trigger if the player or tech are not ready yet.
   *
   * @fires Tech#sourceset
   * @param {string} src The source string at the time of the source changing.
   */var _proto=Tech.prototype;_proto.triggerSourceset=function triggerSourceset(src){var _this2=this;if(!this.isReady_){// on initial ready we have to trigger source set
// 1ms after ready so that player can watch for it.
this.one('ready',function(){return _this2.setTimeout(function(){return _this2.triggerSourceset(src);},1);});}/**
     * Fired when the source is set on the tech causing the media element
     * to reload.
     *
     * @see {@link Player#event:sourceset}
     * @event Tech#sourceset
     * @type {EventTarget~Event}
     */this.trigger({src:src,type:'sourceset'});}/* Fallbacks for unsupported event types
  ================================================================================ */ /**
   * Polyfill the `progress` event for browsers that don't support it natively.
   *
   * @see {@link Tech#trackProgress}
   */;_proto.manualProgressOn=function manualProgressOn(){this.on('durationchange',this.onDurationChange_);this.manualProgress=true;// Trigger progress watching when a source begins loading
this.one('ready',this.trackProgress_);}/**
   * Turn off the polyfill for `progress` events that was created in
   * {@link Tech#manualProgressOn}
   */;_proto.manualProgressOff=function manualProgressOff(){this.manualProgress=false;this.stopTrackingProgress();this.off('durationchange',this.onDurationChange_);}/**
   * This is used to trigger a `progress` event when the buffered percent changes. It
   * sets an interval function that will be called every 500 milliseconds to check if the
   * buffer end percent has changed.
   *
   * > This function is called by {@link Tech#manualProgressOn}
   *
   * @param {EventTarget~Event} event
   *        The `ready` event that caused this to run.
   *
   * @listens Tech#ready
   * @fires Tech#progress
   */;_proto.trackProgress=function trackProgress(event){this.stopTrackingProgress();this.progressInterval=this.setInterval(bind(this,function(){// Don't trigger unless buffered amount is greater than last time
var numBufferedPercent=this.bufferedPercent();if(this.bufferedPercent_!==numBufferedPercent){/**
         * See {@link Player#progress}
         *
         * @event Tech#progress
         * @type {EventTarget~Event}
         */this.trigger('progress');}this.bufferedPercent_=numBufferedPercent;if(numBufferedPercent===1){this.stopTrackingProgress();}}),500);}/**
   * Update our internal duration on a `durationchange` event by calling
   * {@link Tech#duration}.
   *
   * @param {EventTarget~Event} event
   *        The `durationchange` event that caused this to run.
   *
   * @listens Tech#durationchange
   */;_proto.onDurationChange=function onDurationChange(event){this.duration_=this.duration();}/**
   * Get and create a `TimeRange` object for buffering.
   *
   * @return {TimeRange}
   *         The time range object that was created.
   */;_proto.buffered=function buffered(){return createTimeRanges(0,0);}/**
   * Get the percentage of the current video that is currently buffered.
   *
   * @return {number}
   *         A number from 0 to 1 that represents the decimal percentage of the
   *         video that is buffered.
   *
   */;_proto.bufferedPercent=function bufferedPercent$1(){return bufferedPercent(this.buffered(),this.duration_);}/**
   * Turn off the polyfill for `progress` events that was created in
   * {@link Tech#manualProgressOn}
   * Stop manually tracking progress events by clearing the interval that was set in
   * {@link Tech#trackProgress}.
   */;_proto.stopTrackingProgress=function stopTrackingProgress(){this.clearInterval(this.progressInterval);}/**
   * Polyfill the `timeupdate` event for browsers that don't support it.
   *
   * @see {@link Tech#trackCurrentTime}
   */;_proto.manualTimeUpdatesOn=function manualTimeUpdatesOn(){this.manualTimeUpdates=true;this.on('play',this.trackCurrentTime_);this.on('pause',this.stopTrackingCurrentTime_);}/**
   * Turn off the polyfill for `timeupdate` events that was created in
   * {@link Tech#manualTimeUpdatesOn}
   */;_proto.manualTimeUpdatesOff=function manualTimeUpdatesOff(){this.manualTimeUpdates=false;this.stopTrackingCurrentTime();this.off('play',this.trackCurrentTime_);this.off('pause',this.stopTrackingCurrentTime_);}/**
   * Sets up an interval function to track current time and trigger `timeupdate` every
   * 250 milliseconds.
   *
   * @listens Tech#play
   * @triggers Tech#timeupdate
   */;_proto.trackCurrentTime=function trackCurrentTime(){if(this.currentTimeInterval){this.stopTrackingCurrentTime();}this.currentTimeInterval=this.setInterval(function(){/**
       * Triggered at an interval of 250ms to indicated that time is passing in the video.
       *
       * @event Tech#timeupdate
       * @type {EventTarget~Event}
       */this.trigger({type:'timeupdate',target:this,manuallyTriggered:true});// 42 = 24 fps // 250 is what Webkit uses // FF uses 15
},250);}/**
   * Stop the interval function created in {@link Tech#trackCurrentTime} so that the
   * `timeupdate` event is no longer triggered.
   *
   * @listens {Tech#pause}
   */;_proto.stopTrackingCurrentTime=function stopTrackingCurrentTime(){this.clearInterval(this.currentTimeInterval);// #1002 - if the video ends right before the next timeupdate would happen,
// the progress bar won't make it all the way to the end
this.trigger({type:'timeupdate',target:this,manuallyTriggered:true});}/**
   * Turn off all event polyfills, clear the `Tech`s {@link AudioTrackList},
   * {@link VideoTrackList}, and {@link TextTrackList}, and dispose of this Tech.
   *
   * @fires Component#dispose
   */;_proto.dispose=function dispose(){// clear out all tracks because we can't reuse them between techs
this.clearTracks(NORMAL.names);// Turn off any manual progress or timeupdate tracking
if(this.manualProgress){this.manualProgressOff();}if(this.manualTimeUpdates){this.manualTimeUpdatesOff();}_Component.prototype.dispose.call(this);}/**
   * Clear out a single `TrackList` or an array of `TrackLists` given their names.
   *
   * > Note: Techs without source handlers should call this between sources for `video`
   *         & `audio` tracks. You don't want to use them between tracks!
   *
   * @param {string[]|string} types
   *        TrackList names to clear, valid names are `video`, `audio`, and
   *        `text`.
   */;_proto.clearTracks=function clearTracks(types){var _this3=this;types=[].concat(types);// clear out all tracks because we can't reuse them between techs
types.forEach(function(type){var list=_this3[type+"Tracks"]()||[];var i=list.length;while(i--){var track=list[i];if(type==='text'){_this3.removeRemoteTextTrack(track);}list.removeTrack(track);}});}/**
   * Remove any TextTracks added via addRemoteTextTrack that are
   * flagged for automatic garbage collection
   */;_proto.cleanupAutoTextTracks=function cleanupAutoTextTracks(){var list=this.autoRemoteTextTracks_||[];var i=list.length;while(i--){var track=list[i];this.removeRemoteTextTrack(track);}}/**
   * Reset the tech, which will removes all sources and reset the internal readyState.
   *
   * @abstract
   */;_proto.reset=function reset(){}/**
   * Get the value of `crossOrigin` from the tech.
   *
   * @abstract
   *
   * @see {Html5#crossOrigin}
   */;_proto.crossOrigin=function crossOrigin(){}/**
   * Set the value of `crossOrigin` on the tech.
   *
   * @abstract
   *
   * @param {string} crossOrigin the crossOrigin value
   * @see {Html5#setCrossOrigin}
   */;_proto.setCrossOrigin=function setCrossOrigin(){}/**
   * Get or set an error on the Tech.
   *
   * @param {MediaError} [err]
   *        Error to set on the Tech
   *
   * @return {MediaError|null}
   *         The current error object on the tech, or null if there isn't one.
   */;_proto.error=function error(err){if(err!==undefined){this.error_=new MediaError(err);this.trigger('error');}return this.error_;}/**
   * Returns the `TimeRange`s that have been played through for the current source.
   *
   * > NOTE: This implementation is incomplete. It does not track the played `TimeRange`.
   *         It only checks whether the source has played at all or not.
   *
   * @return {TimeRange}
   *         - A single time range if this video has played
   *         - An empty set of ranges if not.
   */;_proto.played=function played(){if(this.hasStarted_){return createTimeRanges(0,0);}return createTimeRanges();}/**
   * Start playback
   *
   * @abstract
   *
   * @see {Html5#play}
   */;_proto.play=function play(){}/**
   * Set whether we are scrubbing or not
   *
   * @abstract
   *
   * @see {Html5#setScrubbing}
   */;_proto.setScrubbing=function setScrubbing(){}/**
   * Get whether we are scrubbing or not
   *
   * @abstract
   *
   * @see {Html5#scrubbing}
   */;_proto.scrubbing=function scrubbing(){}/**
   * Causes a manual time update to occur if {@link Tech#manualTimeUpdatesOn} was
   * previously called.
   *
   * @fires Tech#timeupdate
   */;_proto.setCurrentTime=function setCurrentTime(){// improve the accuracy of manual timeupdates
if(this.manualTimeUpdates){/**
       * A manual `timeupdate` event.
       *
       * @event Tech#timeupdate
       * @type {EventTarget~Event}
       */this.trigger({type:'timeupdate',target:this,manuallyTriggered:true});}}/**
   * Turn on listeners for {@link VideoTrackList}, {@link {AudioTrackList}, and
   * {@link TextTrackList} events.
   *
   * This adds {@link EventTarget~EventListeners} for `addtrack`, and  `removetrack`.
   *
   * @fires Tech#audiotrackchange
   * @fires Tech#videotrackchange
   * @fires Tech#texttrackchange
   */;_proto.initTrackListeners=function initTrackListeners(){var _this4=this;/**
      * Triggered when tracks are added or removed on the Tech {@link AudioTrackList}
      *
      * @event Tech#audiotrackchange
      * @type {EventTarget~Event}
      */ /**
      * Triggered when tracks are added or removed on the Tech {@link VideoTrackList}
      *
      * @event Tech#videotrackchange
      * @type {EventTarget~Event}
      */ /**
      * Triggered when tracks are added or removed on the Tech {@link TextTrackList}
      *
      * @event Tech#texttrackchange
      * @type {EventTarget~Event}
      */NORMAL.names.forEach(function(name){var props=NORMAL[name];var trackListChanges=function trackListChanges(){_this4.trigger(name+"trackchange");};var tracks=_this4[props.getterName]();tracks.addEventListener('removetrack',trackListChanges);tracks.addEventListener('addtrack',trackListChanges);_this4.on('dispose',function(){tracks.removeEventListener('removetrack',trackListChanges);tracks.removeEventListener('addtrack',trackListChanges);});});}/**
   * Emulate TextTracks using vtt.js if necessary
   *
   * @fires Tech#vttjsloaded
   * @fires Tech#vttjserror
   */;_proto.addWebVttScript_=function addWebVttScript_(){var _this5=this;if((window_default()).WebVTT){return;}// Initially, Tech.el_ is a child of a dummy-div wait until the Component system
// signals that the Tech is ready at which point Tech.el_ is part of the DOM
// before inserting the WebVTT script
if(document_default().body.contains(this.el())){// load via require if available and vtt.js script location was not passed in
// as an option. novtt builds will turn the above require call into an empty object
// which will cause this if check to always fail.
if(!this.options_['vtt.js']&&isPlain((browser_index_default()))&&Object.keys((browser_index_default())).length>0){this.trigger('vttjsloaded');return;}// load vtt.js via the script location option or the cdn of no location was
// passed in
var script=document_default().createElement('script');script.src=this.options_['vtt.js']||'https://vjs.zencdn.net/vttjs/0.14.1/vtt.min.js';script.onload=function(){/**
         * Fired when vtt.js is loaded.
         *
         * @event Tech#vttjsloaded
         * @type {EventTarget~Event}
         */_this5.trigger('vttjsloaded');};script.onerror=function(){/**
         * Fired when vtt.js was not loaded due to an error
         *
         * @event Tech#vttjsloaded
         * @type {EventTarget~Event}
         */_this5.trigger('vttjserror');};this.on('dispose',function(){script.onload=null;script.onerror=null;});// but have not loaded yet and we set it to true before the inject so that
// we don't overwrite the injected window.WebVTT if it loads right away
(window_default()).WebVTT=true;this.el().parentNode.appendChild(script);}else{this.ready(this.addWebVttScript_);}}/**
   * Emulate texttracks
   *
   */;_proto.emulateTextTracks=function emulateTextTracks(){var _this6=this;var tracks=this.textTracks();var remoteTracks=this.remoteTextTracks();var handleAddTrack=function handleAddTrack(e){return tracks.addTrack(e.track);};var handleRemoveTrack=function handleRemoveTrack(e){return tracks.removeTrack(e.track);};remoteTracks.on('addtrack',handleAddTrack);remoteTracks.on('removetrack',handleRemoveTrack);this.addWebVttScript_();var updateDisplay=function updateDisplay(){return _this6.trigger('texttrackchange');};var textTracksChanges=function textTracksChanges(){updateDisplay();for(var i=0;i<tracks.length;i++){var track=tracks[i];track.removeEventListener('cuechange',updateDisplay);if(track.mode==='showing'){track.addEventListener('cuechange',updateDisplay);}}};textTracksChanges();tracks.addEventListener('change',textTracksChanges);tracks.addEventListener('addtrack',textTracksChanges);tracks.addEventListener('removetrack',textTracksChanges);this.on('dispose',function(){remoteTracks.off('addtrack',handleAddTrack);remoteTracks.off('removetrack',handleRemoveTrack);tracks.removeEventListener('change',textTracksChanges);tracks.removeEventListener('addtrack',textTracksChanges);tracks.removeEventListener('removetrack',textTracksChanges);for(var i=0;i<tracks.length;i++){var track=tracks[i];track.removeEventListener('cuechange',updateDisplay);}});}/**
   * Create and returns a remote {@link TextTrack} object.
   *
   * @param {string} kind
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
   *
   * @param {string} [label]
   *        Label to identify the text track
   *
   * @param {string} [language]
   *        Two letter language abbreviation
   *
   * @return {TextTrack}
   *         The TextTrack that gets created.
   */;_proto.addTextTrack=function addTextTrack(kind,label,language){if(!kind){throw new Error('TextTrack kind is required but was not provided');}return createTrackHelper(this,kind,label,language);}/**
   * Create an emulated TextTrack for use by addRemoteTextTrack
   *
   * This is intended to be overridden by classes that inherit from
   * Tech in order to create native or custom TextTracks.
   *
   * @param {Object} options
   *        The object should contain the options to initialize the TextTrack with.
   *
   * @param {string} [options.kind]
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
   *
   * @param {string} [options.label].
   *        Label to identify the text track
   *
   * @param {string} [options.language]
   *        Two letter language abbreviation.
   *
   * @return {HTMLTrackElement}
   *         The track element that gets created.
   */;_proto.createRemoteTextTrack=function createRemoteTextTrack(options){var track=mergeOptions$3(options,{tech:this});return new REMOTE.remoteTextEl.TrackClass(track);}/**
   * Creates a remote text track object and returns an html track element.
   *
   * > Note: This can be an emulated {@link HTMLTrackElement} or a native one.
   *
   * @param {Object} options
   *        See {@link Tech#createRemoteTextTrack} for more detailed properties.
   *
   * @param {boolean} [manualCleanup=true]
   *        - When false: the TextTrack will be automatically removed from the video
   *          element whenever the source changes
   *        - When True: The TextTrack will have to be cleaned up manually
   *
   * @return {HTMLTrackElement}
   *         An Html Track Element.
   *
   * @deprecated The default functionality for this function will be equivalent
   *             to "manualCleanup=false" in the future. The manualCleanup parameter will
   *             also be removed.
   */;_proto.addRemoteTextTrack=function addRemoteTextTrack(options,manualCleanup){var _this7=this;if(options===void 0){options={};}var htmlTrackElement=this.createRemoteTextTrack(options);if(manualCleanup!==true&&manualCleanup!==false){// deprecation warning
log$1.warn('Calling addRemoteTextTrack without explicitly setting the "manualCleanup" parameter to `true` is deprecated and default to `false` in future version of video.js');manualCleanup=true;}// store HTMLTrackElement and TextTrack to remote list
this.remoteTextTrackEls().addTrackElement_(htmlTrackElement);this.remoteTextTracks().addTrack(htmlTrackElement.track);if(manualCleanup!==true){// create the TextTrackList if it doesn't exist
this.ready(function(){return _this7.autoRemoteTextTracks_.addTrack(htmlTrackElement.track);});}return htmlTrackElement;}/**
   * Remove a remote text track from the remote `TextTrackList`.
   *
   * @param {TextTrack} track
   *        `TextTrack` to remove from the `TextTrackList`
   */;_proto.removeRemoteTextTrack=function removeRemoteTextTrack(track){var trackElement=this.remoteTextTrackEls().getTrackElementByTrack_(track);// remove HTMLTrackElement and TextTrack from remote list
this.remoteTextTrackEls().removeTrackElement_(trackElement);this.remoteTextTracks().removeTrack(track);this.autoRemoteTextTracks_.removeTrack(track);}/**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object}
   *         An object with supported media playback quality metrics
   *
   * @abstract
   */;_proto.getVideoPlaybackQuality=function getVideoPlaybackQuality(){return{};}/**
   * Attempt to create a floating video window always on top of other windows
   * so that users may continue consuming media while they interact with other
   * content sites, or applications on their device.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @return {Promise|undefined}
   *         A promise with a Picture-in-Picture window if the browser supports
   *         Promises (or one was passed in as an option). It returns undefined
   *         otherwise.
   *
   * @abstract
   */;_proto.requestPictureInPicture=function requestPictureInPicture(){var PromiseClass=this.options_.Promise||(window_default()).Promise;if(PromiseClass){return PromiseClass.reject();}}/**
   * A method to check for the value of the 'disablePictureInPicture' <video> property.
   * Defaults to true, as it should be considered disabled if the tech does not support pip
   *
   * @abstract
   */;_proto.disablePictureInPicture=function disablePictureInPicture(){return true;}/**
   * A method to set or unset the 'disablePictureInPicture' <video> property.
   *
   * @abstract
   */;_proto.setDisablePictureInPicture=function setDisablePictureInPicture(){}/**
   * A fallback implementation of requestVideoFrameCallback using requestAnimationFrame
   *
   * @param {function} cb
   * @return {number} request id
   */;_proto.requestVideoFrameCallback=function requestVideoFrameCallback(cb){var _this8=this;var id=newGUID();if(!this.isReady_||this.paused()){this.queuedHanders_.add(id);this.one('playing',function(){if(_this8.queuedHanders_.has(id)){_this8.queuedHanders_["delete"](id);cb();}});}else{this.requestNamedAnimationFrame(id,cb);}return id;}/**
   * A fallback implementation of cancelVideoFrameCallback
   *
   * @param {number} id id of callback to be cancelled
   */;_proto.cancelVideoFrameCallback=function cancelVideoFrameCallback(id){if(this.queuedHanders_.has(id)){this.queuedHanders_["delete"](id);}else{this.cancelNamedAnimationFrame(id);}}/**
   * A method to set a poster from a `Tech`.
   *
   * @abstract
   */;_proto.setPoster=function setPoster(){}/**
   * A method to check for the presence of the 'playsinline' <video> attribute.
   *
   * @abstract
   */;_proto.playsinline=function playsinline(){}/**
   * A method to set or unset the 'playsinline' <video> attribute.
   *
   * @abstract
   */;_proto.setPlaysinline=function setPlaysinline(){}/**
   * Attempt to force override of native audio tracks.
   *
   * @param {boolean} override - If set to true native audio will be overridden,
   * otherwise native audio will potentially be used.
   *
   * @abstract
   */;_proto.overrideNativeAudioTracks=function overrideNativeAudioTracks(){}/**
   * Attempt to force override of native video tracks.
   *
   * @param {boolean} override - If set to true native video will be overridden,
   * otherwise native video will potentially be used.
   *
   * @abstract
   */;_proto.overrideNativeVideoTracks=function overrideNativeVideoTracks(){}/*
   * Check if the tech can support the given mime-type.
   *
   * The base tech does not support any type, but source handlers might
   * overwrite this.
   *
   * @param  {string} type
   *         The mimetype to check for support
   *
   * @return {string}
   *         'probably', 'maybe', or empty string
   *
   * @see [Spec]{@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/canPlayType}
   *
   * @abstract
   */;_proto.canPlayType=function canPlayType(){return'';}/**
   * Check if the type is supported by this tech.
   *
   * The base tech does not support any type, but source handlers might
   * overwrite this.
   *
   * @param {string} type
   *        The media type to check
   * @return {string} Returns the native video element's response
   */;Tech.canPlayType=function canPlayType(){return'';}/**
   * Check if the tech can support the given source
   *
   * @param {Object} srcObj
   *        The source object
   * @param {Object} options
   *        The options passed to the tech
   * @return {string} 'probably', 'maybe', or '' (empty string)
   */;Tech.canPlaySource=function canPlaySource(srcObj,options){return Tech.canPlayType(srcObj.type);}/*
   * Return whether the argument is a Tech or not.
   * Can be passed either a Class like `Html5` or a instance like `player.tech_`
   *
   * @param {Object} component
   *        The item to check
   *
   * @return {boolean}
   *         Whether it is a tech or not
   *         - True if it is a tech
   *         - False if it is not
   */;Tech.isTech=function isTech(component){return component.prototype instanceof Tech||component instanceof Tech||component===Tech;}/**
   * Registers a `Tech` into a shared list for videojs.
   *
   * @param {string} name
   *        Name of the `Tech` to register.
   *
   * @param {Object} tech
   *        The `Tech` class to register.
   */;Tech.registerTech=function registerTech(name,tech){if(!Tech.techs_){Tech.techs_={};}if(!Tech.isTech(tech)){throw new Error("Tech "+name+" must be a Tech");}if(!Tech.canPlayType){throw new Error('Techs must have a static canPlayType method on them');}if(!Tech.canPlaySource){throw new Error('Techs must have a static canPlaySource method on them');}name=toTitleCase$1(name);Tech.techs_[name]=tech;Tech.techs_[toLowerCase(name)]=tech;if(name!=='Tech'){// camel case the techName for use in techOrder
Tech.defaultTechOrder_.push(name);}return tech;}/**
   * Get a `Tech` from the shared list by name.
   *
   * @param {string} name
   *        `camelCase` or `TitleCase` name of the Tech to get
   *
   * @return {Tech|undefined}
   *         The `Tech` or undefined if there was no tech with the name requested.
   */;Tech.getTech=function getTech(name){if(!name){return;}if(Tech.techs_&&Tech.techs_[name]){return Tech.techs_[name];}name=toTitleCase$1(name);if((window_default())&&(window_default()).videojs&&(window_default()).videojs[name]){log$1.warn("The "+name+" tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)");return (window_default()).videojs[name];}};return Tech;}(Component$1);/**
 * Get the {@link VideoTrackList}
 *
 * @returns {VideoTrackList}
 * @method Tech.prototype.videoTracks
 */ /**
 * Get the {@link AudioTrackList}
 *
 * @returns {AudioTrackList}
 * @method Tech.prototype.audioTracks
 */ /**
 * Get the {@link TextTrackList}
 *
 * @returns {TextTrackList}
 * @method Tech.prototype.textTracks
 */ /**
 * Get the remote element {@link TextTrackList}
 *
 * @returns {TextTrackList}
 * @method Tech.prototype.remoteTextTracks
 */ /**
 * Get the remote element {@link HtmlTrackElementList}
 *
 * @returns {HtmlTrackElementList}
 * @method Tech.prototype.remoteTextTrackEls
 */ALL.names.forEach(function(name){var props=ALL[name];Tech.prototype[props.getterName]=function(){this[props.privateName]=this[props.privateName]||new props.ListClass();return this[props.privateName];};});/**
 * List of associated text tracks
 *
 * @type {TextTrackList}
 * @private
 * @property Tech#textTracks_
 */ /**
 * List of associated audio tracks.
 *
 * @type {AudioTrackList}
 * @private
 * @property Tech#audioTracks_
 */ /**
 * List of associated video tracks.
 *
 * @type {VideoTrackList}
 * @private
 * @property Tech#videoTracks_
 */ /**
 * Boolean indicating whether the `Tech` supports volume control.
 *
 * @type {boolean}
 * @default
 */Tech.prototype.featuresVolumeControl=true;/**
 * Boolean indicating whether the `Tech` supports muting volume.
 *
 * @type {bolean}
 * @default
 */Tech.prototype.featuresMuteControl=true;/**
 * Boolean indicating whether the `Tech` supports fullscreen resize control.
 * Resizing plugins using request fullscreen reloads the plugin
 *
 * @type {boolean}
 * @default
 */Tech.prototype.featuresFullscreenResize=false;/**
 * Boolean indicating whether the `Tech` supports changing the speed at which the video
 * plays. Examples:
 *   - Set player to play 2x (twice) as fast
 *   - Set player to play 0.5x (half) as fast
 *
 * @type {boolean}
 * @default
 */Tech.prototype.featuresPlaybackRate=false;/**
 * Boolean indicating whether the `Tech` supports the `progress` event. This is currently
 * not triggered by video-js-swf. This will be used to determine if
 * {@link Tech#manualProgressOn} should be called.
 *
 * @type {boolean}
 * @default
 */Tech.prototype.featuresProgressEvents=false;/**
 * Boolean indicating whether the `Tech` supports the `sourceset` event.
 *
 * A tech should set this to `true` and then use {@link Tech#triggerSourceset}
 * to trigger a {@link Tech#event:sourceset} at the earliest time after getting
 * a new source.
 *
 * @type {boolean}
 * @default
 */Tech.prototype.featuresSourceset=false;/**
 * Boolean indicating whether the `Tech` supports the `timeupdate` event. This is currently
 * not triggered by video-js-swf. This will be used to determine if
 * {@link Tech#manualTimeUpdates} should be called.
 *
 * @type {boolean}
 * @default
 */Tech.prototype.featuresTimeupdateEvents=false;/**
 * Boolean indicating whether the `Tech` supports the native `TextTrack`s.
 * This will help us integrate with native `TextTrack`s if the browser supports them.
 *
 * @type {boolean}
 * @default
 */Tech.prototype.featuresNativeTextTracks=false;/**
 * Boolean indicating whether the `Tech` supports `requestVideoFrameCallback`.
 *
 * @type {boolean}
 * @default
 */Tech.prototype.featuresVideoFrameCallback=false;/**
 * A functional mixin for techs that want to use the Source Handler pattern.
 * Source handlers are scripts for handling specific formats.
 * The source handler pattern is used for adaptive formats (HLS, DASH) that
 * manually load video data and feed it into a Source Buffer (Media Source Extensions)
 * Example: `Tech.withSourceHandlers.call(MyTech);`
 *
 * @param {Tech} _Tech
 *        The tech to add source handler functions to.
 *
 * @mixes Tech~SourceHandlerAdditions
 */Tech.withSourceHandlers=function(_Tech){/**
   * Register a source handler
   *
   * @param {Function} handler
   *        The source handler class
   *
   * @param {number} [index]
   *        Register it at the following index
   */_Tech.registerSourceHandler=function(handler,index){var handlers=_Tech.sourceHandlers;if(!handlers){handlers=_Tech.sourceHandlers=[];}if(index===undefined){// add to the end of the list
index=handlers.length;}handlers.splice(index,0,handler);};/**
   * Check if the tech can support the given type. Also checks the
   * Techs sourceHandlers.
   *
   * @param {string} type
   *         The mimetype to check.
   *
   * @return {string}
   *         'probably', 'maybe', or '' (empty string)
   */_Tech.canPlayType=function(type){var handlers=_Tech.sourceHandlers||[];var can;for(var i=0;i<handlers.length;i++){can=handlers[i].canPlayType(type);if(can){return can;}}return'';};/**
   * Returns the first source handler that supports the source.
   *
   * TODO: Answer question: should 'probably' be prioritized over 'maybe'
   *
   * @param {Tech~SourceObject} source
   *        The source object
   *
   * @param {Object} options
   *        The options passed to the tech
   *
   * @return {SourceHandler|null}
   *          The first source handler that supports the source or null if
   *          no SourceHandler supports the source
   */_Tech.selectSourceHandler=function(source,options){var handlers=_Tech.sourceHandlers||[];var can;for(var i=0;i<handlers.length;i++){can=handlers[i].canHandleSource(source,options);if(can){return handlers[i];}}return null;};/**
   * Check if the tech can support the given source.
   *
   * @param {Tech~SourceObject} srcObj
   *        The source object
   *
   * @param {Object} options
   *        The options passed to the tech
   *
   * @return {string}
   *         'probably', 'maybe', or '' (empty string)
   */_Tech.canPlaySource=function(srcObj,options){var sh=_Tech.selectSourceHandler(srcObj,options);if(sh){return sh.canHandleSource(srcObj,options);}return'';};/**
   * When using a source handler, prefer its implementation of
   * any function normally provided by the tech.
   */var deferrable=['seekable','seeking','duration'];/**
   * A wrapper around {@link Tech#seekable} that will call a `SourceHandler`s seekable
   * function if it exists, with a fallback to the Techs seekable function.
   *
   * @method _Tech.seekable
   */ /**
   * A wrapper around {@link Tech#duration} that will call a `SourceHandler`s duration
   * function if it exists, otherwise it will fallback to the techs duration function.
   *
   * @method _Tech.duration
   */deferrable.forEach(function(fnName){var originalFn=this[fnName];if(typeof originalFn!=='function'){return;}this[fnName]=function(){if(this.sourceHandler_&&this.sourceHandler_[fnName]){return this.sourceHandler_[fnName].apply(this.sourceHandler_,arguments);}return originalFn.apply(this,arguments);};},_Tech.prototype);/**
   * Create a function for setting the source using a source object
   * and source handlers.
   * Should never be called unless a source handler was found.
   *
   * @param {Tech~SourceObject} source
   *        A source object with src and type keys
   */_Tech.prototype.setSource=function(source){var sh=_Tech.selectSourceHandler(source,this.options_);if(!sh){// Fall back to a native source hander when unsupported sources are
// deliberately set
if(_Tech.nativeSourceHandler){sh=_Tech.nativeSourceHandler;}else{log$1.error('No source handler found for the current source.');}}// Dispose any existing source handler
this.disposeSourceHandler();this.off('dispose',this.disposeSourceHandler_);if(sh!==_Tech.nativeSourceHandler){this.currentSource_=source;}this.sourceHandler_=sh.handleSource(source,this,this.options_);this.one('dispose',this.disposeSourceHandler_);};/**
   * Clean up any existing SourceHandlers and listeners when the Tech is disposed.
   *
   * @listens Tech#dispose
   */_Tech.prototype.disposeSourceHandler=function(){// if we have a source and get another one
// then we are loading something new
// than clear all of our current tracks
if(this.currentSource_){this.clearTracks(['audio','video']);this.currentSource_=null;}// always clean up auto-text tracks
this.cleanupAutoTextTracks();if(this.sourceHandler_){if(this.sourceHandler_.dispose){this.sourceHandler_.dispose();}this.sourceHandler_=null;}};};// The base Tech class needs to be registered as a Component. It is the only
// Tech that can be registered as a Component.
Component$1.registerComponent('Tech',Tech);Tech.registerTech('Tech',Tech);/**
 * A list of techs that should be added to techOrder on Players
 *
 * @private
 */Tech.defaultTechOrder_=[];/**
 * @file middleware.js
 * @module middleware
 */var middlewares={};var middlewareInstances={};var TERMINATOR={};/**
 * A middleware object is a plain JavaScript object that has methods that
 * match the {@link Tech} methods found in the lists of allowed
 * {@link module:middleware.allowedGetters|getters},
 * {@link module:middleware.allowedSetters|setters}, and
 * {@link module:middleware.allowedMediators|mediators}.
 *
 * @typedef {Object} MiddlewareObject
 */ /**
 * A middleware factory function that should return a
 * {@link module:middleware~MiddlewareObject|MiddlewareObject}.
 *
 * This factory will be called for each player when needed, with the player
 * passed in as an argument.
 *
 * @callback MiddlewareFactory
 * @param {Player} player
 *        A Video.js player.
 */ /**
 * Define a middleware that the player should use by way of a factory function
 * that returns a middleware object.
 *
 * @param  {string} type
 *         The MIME type to match or `"*"` for all MIME types.
 *
 * @param  {MiddlewareFactory} middleware
 *         A middleware factory function that will be executed for
 *         matching types.
 */function use(type,middleware){middlewares[type]=middlewares[type]||[];middlewares[type].push(middleware);}/**
 * Asynchronously sets a source using middleware by recursing through any
 * matching middlewares and calling `setSource` on each, passing along the
 * previous returned value each time.
 *
 * @param  {Player} player
 *         A {@link Player} instance.
 *
 * @param  {Tech~SourceObject} src
 *         A source object.
 *
 * @param  {Function}
 *         The next middleware to run.
 */function setSource(player,src,next){player.setTimeout(function(){return setSourceHelper(src,middlewares[src.type],next,player);},1);}/**
 * When the tech is set, passes the tech to each middleware's `setTech` method.
 *
 * @param {Object[]} middleware
 *        An array of middleware instances.
 *
 * @param {Tech} tech
 *        A Video.js tech.
 */function setTech(middleware,tech){middleware.forEach(function(mw){return mw.setTech&&mw.setTech(tech);});}/**
 * Calls a getter on the tech first, through each middleware
 * from right to left to the player.
 *
 * @param  {Object[]} middleware
 *         An array of middleware instances.
 *
 * @param  {Tech} tech
 *         The current tech.
 *
 * @param  {string} method
 *         A method name.
 *
 * @return {Mixed}
 *         The final value from the tech after middleware has intercepted it.
 */function get(middleware,tech,method){return middleware.reduceRight(middlewareIterator(method),tech[method]());}/**
 * Takes the argument given to the player and calls the setter method on each
 * middleware from left to right to the tech.
 *
 * @param  {Object[]} middleware
 *         An array of middleware instances.
 *
 * @param  {Tech} tech
 *         The current tech.
 *
 * @param  {string} method
 *         A method name.
 *
 * @param  {Mixed} arg
 *         The value to set on the tech.
 *
 * @return {Mixed}
 *         The return value of the `method` of the `tech`.
 */function set(middleware,tech,method,arg){return tech[method](middleware.reduce(middlewareIterator(method),arg));}/**
 * Takes the argument given to the player and calls the `call` version of the
 * method on each middleware from left to right.
 *
 * Then, call the passed in method on the tech and return the result unchanged
 * back to the player, through middleware, this time from right to left.
 *
 * @param  {Object[]} middleware
 *         An array of middleware instances.
 *
 * @param  {Tech} tech
 *         The current tech.
 *
 * @param  {string} method
 *         A method name.
 *
 * @param  {Mixed} arg
 *         The value to set on the tech.
 *
 * @return {Mixed}
 *         The return value of the `method` of the `tech`, regardless of the
 *         return values of middlewares.
 */function mediate(middleware,tech,method,arg){if(arg===void 0){arg=null;}var callMethod='call'+toTitleCase$1(method);var middlewareValue=middleware.reduce(middlewareIterator(callMethod),arg);var terminated=middlewareValue===TERMINATOR;// deprecated. The `null` return value should instead return TERMINATOR to
// prevent confusion if a techs method actually returns null.
var returnValue=terminated?null:tech[method](middlewareValue);executeRight(middleware,method,returnValue,terminated);return returnValue;}/**
 * Enumeration of allowed getters where the keys are method names.
 *
 * @type {Object}
 */var allowedGetters={buffered:1,currentTime:1,duration:1,muted:1,played:1,paused:1,seekable:1,volume:1,ended:1};/**
 * Enumeration of allowed setters where the keys are method names.
 *
 * @type {Object}
 */var allowedSetters={setCurrentTime:1,setMuted:1,setVolume:1};/**
 * Enumeration of allowed mediators where the keys are method names.
 *
 * @type {Object}
 */var allowedMediators={play:1,pause:1};function middlewareIterator(method){return function(value,mw){// if the previous middleware terminated, pass along the termination
if(value===TERMINATOR){return TERMINATOR;}if(mw[method]){return mw[method](value);}return value;};}function executeRight(mws,method,value,terminated){for(var i=mws.length-1;i>=0;i--){var mw=mws[i];if(mw[method]){mw[method](terminated,value);}}}/**
 * Clear the middleware cache for a player.
 *
 * @param  {Player} player
 *         A {@link Player} instance.
 */function clearCacheForPlayer(player){middlewareInstances[player.id()]=null;}/**
 * {
 *  [playerId]: [[mwFactory, mwInstance], ...]
 * }
 *
 * @private
 */function getOrCreateFactory(player,mwFactory){var mws=middlewareInstances[player.id()];var mw=null;if(mws===undefined||mws===null){mw=mwFactory(player);middlewareInstances[player.id()]=[[mwFactory,mw]];return mw;}for(var i=0;i<mws.length;i++){var _mws$i=mws[i],mwf=_mws$i[0],mwi=_mws$i[1];if(mwf!==mwFactory){continue;}mw=mwi;}if(mw===null){mw=mwFactory(player);mws.push([mwFactory,mw]);}return mw;}function setSourceHelper(src,middleware,next,player,acc,lastRun){if(src===void 0){src={};}if(middleware===void 0){middleware=[];}if(acc===void 0){acc=[];}if(lastRun===void 0){lastRun=false;}var _middleware=middleware,mwFactory=_middleware[0],mwrest=_middleware.slice(1);// if mwFactory is a string, then we're at a fork in the road
if(typeof mwFactory==='string'){setSourceHelper(src,middlewares[mwFactory],next,player,acc,lastRun);// if we have an mwFactory, call it with the player to get the mw,
// then call the mw's setSource method
}else if(mwFactory){var mw=getOrCreateFactory(player,mwFactory);// if setSource isn't present, implicitly select this middleware
if(!mw.setSource){acc.push(mw);return setSourceHelper(src,mwrest,next,player,acc,lastRun);}mw.setSource(video_es_assign({},src),function(err,_src){// something happened, try the next middleware on the current level
// make sure to use the old src
if(err){return setSourceHelper(src,mwrest,next,player,acc,lastRun);}// we've succeeded, now we need to go deeper
acc.push(mw);// if it's the same type, continue down the current chain
// otherwise, we want to go down the new chain
setSourceHelper(_src,src.type===_src.type?mwrest:middlewares[_src.type],next,player,acc,lastRun);});}else if(mwrest.length){setSourceHelper(src,mwrest,next,player,acc,lastRun);}else if(lastRun){next(src,acc);}else{setSourceHelper(src,middlewares['*'],next,player,acc,true);}}/**
 * Mimetypes
 *
 * @see https://www.iana.org/assignments/media-types/media-types.xhtml
 * @typedef Mimetypes~Kind
 * @enum
 */var MimetypesKind={opus:'video/ogg',ogv:'video/ogg',mp4:'video/mp4',mov:'video/mp4',m4v:'video/mp4',mkv:'video/x-matroska',m4a:'audio/mp4',mp3:'audio/mpeg',aac:'audio/aac',caf:'audio/x-caf',flac:'audio/flac',oga:'audio/ogg',wav:'audio/wav',m3u8:'application/x-mpegURL',mpd:'application/dash+xml',jpg:'image/jpeg',jpeg:'image/jpeg',gif:'image/gif',png:'image/png',svg:'image/svg+xml',webp:'image/webp'};/**
 * Get the mimetype of a given src url if possible
 *
 * @param {string} src
 *        The url to the src
 *
 * @return {string}
 *         return the mimetype if it was known or empty string otherwise
 */var getMimetype=function getMimetype(src){if(src===void 0){src='';}var ext=getFileExtension(src);var mimetype=MimetypesKind[ext.toLowerCase()];return mimetype||'';};/**
 * Find the mime type of a given source string if possible. Uses the player
 * source cache.
 *
 * @param {Player} player
 *        The player object
 *
 * @param {string} src
 *        The source string
 *
 * @return {string}
 *         The type that was found
 */var findMimetype=function findMimetype(player,src){if(!src){return'';}// 1. check for the type in the `source` cache
if(player.cache_.source.src===src&&player.cache_.source.type){return player.cache_.source.type;}// 2. see if we have this source in our `currentSources` cache
var matchingSources=player.cache_.sources.filter(function(s){return s.src===src;});if(matchingSources.length){return matchingSources[0].type;}// 3. look for the src url in source elements and use the type there
var sources=player.$$('source');for(var i=0;i<sources.length;i++){var s=sources[i];if(s.type&&s.src&&s.src===src){return s.type;}}// 4. finally fallback to our list of mime types based on src url extension
return getMimetype(src);};/**
 * @module filter-source
 */ /**
 * Filter out single bad source objects or multiple source objects in an
 * array. Also flattens nested source object arrays into a 1 dimensional
 * array of source objects.
 *
 * @param {Tech~SourceObject|Tech~SourceObject[]} src
 *        The src object to filter
 *
 * @return {Tech~SourceObject[]}
 *         An array of sourceobjects containing only valid sources
 *
 * @private
 */var filterSource=function filterSource(src){// traverse array
if(Array.isArray(src)){var newsrc=[];src.forEach(function(srcobj){srcobj=filterSource(srcobj);if(Array.isArray(srcobj)){newsrc=newsrc.concat(srcobj);}else if(video_es_isObject(srcobj)){newsrc.push(srcobj);}});src=newsrc;}else if(typeof src==='string'&&src.trim()){// convert string into object
src=[fixSource({src:src})];}else if(video_es_isObject(src)&&typeof src.src==='string'&&src.src&&src.src.trim()){// src is already valid
src=[fixSource(src)];}else{// invalid source, turn it into an empty array
src=[];}return src;};/**
 * Checks src mimetype, adding it when possible
 *
 * @param {Tech~SourceObject} src
 *        The src object to check
 * @return {Tech~SourceObject}
 *        src Object with known type
 */function fixSource(src){if(!src.type){var mimetype=getMimetype(src.src);if(mimetype){src.type=mimetype;}}return src;}/**
 * The `MediaLoader` is the `Component` that decides which playback technology to load
 * when a player is initialized.
 *
 * @extends Component
 */var MediaLoader=/*#__PURE__*/function(_Component){_inheritsLoose(MediaLoader,_Component);/**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should attach to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Component~ReadyCallback} [ready]
   *        The function that is run when this component is ready.
   */function MediaLoader(player,options,ready){var _this;// MediaLoader has no element
var options_=mergeOptions$3({createEl:false},options);_this=_Component.call(this,player,options_,ready)||this;// If there are no sources when the player is initialized,
// load the first supported playback technology.
if(!options.playerOptions.sources||options.playerOptions.sources.length===0){for(var i=0,j=options.playerOptions.techOrder;i<j.length;i++){var techName=toTitleCase$1(j[i]);var tech=Tech.getTech(techName);// Support old behavior of techs being registered as components.
// Remove once that deprecated behavior is removed.
if(!techName){tech=Component$1.getComponent(techName);}// Check if the browser supports this technology
if(tech&&tech.isSupported()){player.loadTech_(techName);break;}}}else{// Loop through playback technologies (e.g. HTML5) and check for support.
// Then load the best source.
// A few assumptions here:
//   All playback technologies respect preload false.
player.src(options.playerOptions.sources);}return _this;}return MediaLoader;}(Component$1);Component$1.registerComponent('MediaLoader',MediaLoader);/**
 * Component which is clickable or keyboard actionable, but is not a
 * native HTML button.
 *
 * @extends Component
 */var ClickableComponent=/*#__PURE__*/function(_Component){_inheritsLoose(ClickableComponent,_Component);/**
   * Creates an instance of this class.
   *
   * @param  {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param  {Object} [options]
   *         The key/value store of component options.
   *
   * @param  {function} [options.clickHandler]
   *         The function to call when the button is clicked / activated
   *
   * @param  {string} [options.controlText]
   *         The text to set on the button
   *
   * @param  {string} [options.className]
   *         A class or space separated list of classes to add the component
   *
   */function ClickableComponent(player,options){var _this;_this=_Component.call(this,player,options)||this;if(_this.options_.controlText){_this.controlText(_this.options_.controlText);}_this.handleMouseOver_=function(e){return _this.handleMouseOver(e);};_this.handleMouseOut_=function(e){return _this.handleMouseOut(e);};_this.handleClick_=function(e){return _this.handleClick(e);};_this.handleKeyDown_=function(e){return _this.handleKeyDown(e);};_this.emitTapEvents();_this.enable();return _this;}/**
   * Create the `ClickableComponent`s DOM element.
   *
   * @param {string} [tag=div]
   *        The element's node type.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element.
   *
   * @param {Object} [attributes={}]
   *        An object of attributes that should be set on the element.
   *
   * @return {Element}
   *         The element that gets created.
   */var _proto=ClickableComponent.prototype;_proto.createEl=function createEl$1(tag,props,attributes){if(tag===void 0){tag='div';}if(props===void 0){props={};}if(attributes===void 0){attributes={};}props=video_es_assign({className:this.buildCSSClass(),tabIndex:0},props);if(tag==='button'){log$1.error("Creating a ClickableComponent with an HTML element of "+tag+" is not supported; use a Button instead.");}// Add ARIA attributes for clickable element which is not a native HTML button
attributes=video_es_assign({role:'button'},attributes);this.tabIndex_=props.tabIndex;var el=createEl(tag,props,attributes);el.appendChild(createEl('span',{className:'vjs-icon-placeholder'},{'aria-hidden':true}));this.createControlTextEl(el);return el;};_proto.dispose=function dispose(){// remove controlTextEl_ on dispose
this.controlTextEl_=null;_Component.prototype.dispose.call(this);}/**
   * Create a control text element on this `ClickableComponent`
   *
   * @param {Element} [el]
   *        Parent element for the control text.
   *
   * @return {Element}
   *         The control text element that gets created.
   */;_proto.createControlTextEl=function createControlTextEl(el){this.controlTextEl_=createEl('span',{className:'vjs-control-text'},{// let the screen reader user know that the text of the element may change
'aria-live':'polite'});if(el){el.appendChild(this.controlTextEl_);}this.controlText(this.controlText_,el);return this.controlTextEl_;}/**
   * Get or set the localize text to use for the controls on the `ClickableComponent`.
   *
   * @param {string} [text]
   *        Control text for element.
   *
   * @param {Element} [el=this.el()]
   *        Element to set the title on.
   *
   * @return {string}
   *         - The control text when getting
   */;_proto.controlText=function controlText(text,el){if(el===void 0){el=this.el();}if(text===undefined){return this.controlText_||'Need Text';}var localizedText=this.localize(text);this.controlText_=text;textContent(this.controlTextEl_,localizedText);if(!this.nonIconControl&&!this.player_.options_.noUITitleAttributes){// Set title attribute if only an icon is shown
el.setAttribute('title',localizedText);}}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */;_proto.buildCSSClass=function buildCSSClass(){return"vjs-control vjs-button "+_Component.prototype.buildCSSClass.call(this);}/**
   * Enable this `ClickableComponent`
   */;_proto.enable=function enable(){if(!this.enabled_){this.enabled_=true;this.removeClass('vjs-disabled');this.el_.setAttribute('aria-disabled','false');if(typeof this.tabIndex_!=='undefined'){this.el_.setAttribute('tabIndex',this.tabIndex_);}this.on(['tap','click'],this.handleClick_);this.on('keydown',this.handleKeyDown_);}}/**
   * Disable this `ClickableComponent`
   */;_proto.disable=function disable(){this.enabled_=false;this.addClass('vjs-disabled');this.el_.setAttribute('aria-disabled','true');if(typeof this.tabIndex_!=='undefined'){this.el_.removeAttribute('tabIndex');}this.off('mouseover',this.handleMouseOver_);this.off('mouseout',this.handleMouseOut_);this.off(['tap','click'],this.handleClick_);this.off('keydown',this.handleKeyDown_);}/**
   * Handles language change in ClickableComponent for the player in components
   *
   *
   */;_proto.handleLanguagechange=function handleLanguagechange(){this.controlText(this.controlText_);}/**
   * Event handler that is called when a `ClickableComponent` receives a
   * `click` or `tap` event.
   *
   * @param {EventTarget~Event} event
   *        The `tap` or `click` event that caused this function to be called.
   *
   * @listens tap
   * @listens click
   * @abstract
   */;_proto.handleClick=function handleClick(event){if(this.options_.clickHandler){this.options_.clickHandler.call(this,arguments);}}/**
   * Event handler that is called when a `ClickableComponent` receives a
   * `keydown` event.
   *
   * By default, if the key is Space or Enter, it will trigger a `click` event.
   *
   * @param {EventTarget~Event} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */;_proto.handleKeyDown=function handleKeyDown(event){// Support Space or Enter key operation to fire a click event. Also,
// prevent the event from propagating through the DOM and triggering
// Player hotkeys.
if(keycode_default().isEventKey(event,'Space')||keycode_default().isEventKey(event,'Enter')){event.preventDefault();event.stopPropagation();this.trigger('click');}else{// Pass keypress handling up for unsupported keys
_Component.prototype.handleKeyDown.call(this,event);}};return ClickableComponent;}(Component$1);Component$1.registerComponent('ClickableComponent',ClickableComponent);/**
 * A `ClickableComponent` that handles showing the poster image for the player.
 *
 * @extends ClickableComponent
 */var PosterImage=/*#__PURE__*/function(_ClickableComponent){_inheritsLoose(PosterImage,_ClickableComponent);/**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should attach to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function PosterImage(player,options){var _this;_this=_ClickableComponent.call(this,player,options)||this;_this.update();_this.update_=function(e){return _this.update(e);};player.on('posterchange',_this.update_);return _this;}/**
   * Clean up and dispose of the `PosterImage`.
   */var _proto=PosterImage.prototype;_proto.dispose=function dispose(){this.player().off('posterchange',this.update_);_ClickableComponent.prototype.dispose.call(this);}/**
   * Create the `PosterImage`s DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */;_proto.createEl=function createEl$1(){var el=createEl('div',{className:'vjs-poster',// Don't want poster to be tabbable.
tabIndex:-1});return el;}/**
   * An {@link EventTarget~EventListener} for {@link Player#posterchange} events.
   *
   * @listens Player#posterchange
   *
   * @param {EventTarget~Event} [event]
   *        The `Player#posterchange` event that triggered this function.
   */;_proto.update=function update(event){var url=this.player().poster();this.setSrc(url);// If there's no poster source we should display:none on this component
// so it's not still clickable or right-clickable
if(url){this.show();}else{this.hide();}}/**
   * Set the source of the `PosterImage` depending on the display method.
   *
   * @param {string} url
   *        The URL to the source for the `PosterImage`.
   */;_proto.setSrc=function setSrc(url){var backgroundImage='';// Any falsy value should stay as an empty string, otherwise
// this will throw an extra error
if(url){backgroundImage="url(\""+url+"\")";}this.el_.style.backgroundImage=backgroundImage;}/**
   * An {@link EventTarget~EventListener} for clicks on the `PosterImage`. See
   * {@link ClickableComponent#handleClick} for instances where this will be triggered.
   *
   * @listens tap
   * @listens click
   * @listens keydown
   *
   * @param {EventTarget~Event} event
   +        The `click`, `tap` or `keydown` event that caused this function to be called.
   */;_proto.handleClick=function handleClick(event){// We don't want a click to trigger playback when controls are disabled
if(!this.player_.controls()){return;}var sourceIsEncrypted=this.player_.usingPlugin('eme')&&this.player_.eme.sessions&&this.player_.eme.sessions.length>0;if(this.player_.tech(true)&&// We've observed a bug in IE and Edge when playing back DRM content where
// calling .focus() on the video element causes the video to go black,
// so we avoid it in that specific case
!((IE_VERSION||IS_EDGE)&&sourceIsEncrypted)){this.player_.tech(true).focus();}if(this.player_.paused()){silencePromise(this.player_.play());}else{this.player_.pause();}};return PosterImage;}(ClickableComponent);Component$1.registerComponent('PosterImage',PosterImage);var darkGray='#222';var lightGray='#ccc';var fontMap={monospace:'monospace',sansSerif:'sans-serif',serif:'serif',monospaceSansSerif:'"Andale Mono", "Lucida Console", monospace',monospaceSerif:'"Courier New", monospace',proportionalSansSerif:'sans-serif',proportionalSerif:'serif',casual:'"Comic Sans MS", Impact, fantasy',script:'"Monotype Corsiva", cursive',smallcaps:'"Andale Mono", "Lucida Console", monospace, sans-serif'};/**
 * Construct an rgba color from a given hex color code.
 *
 * @param {number} color
 *        Hex number for color, like #f0e or #f604e2.
 *
 * @param {number} opacity
 *        Value for opacity, 0.0 - 1.0.
 *
 * @return {string}
 *         The rgba color that was created, like 'rgba(255, 0, 0, 0.3)'.
 */function constructColor(color,opacity){var hex;if(color.length===4){// color looks like "#f0e"
hex=color[1]+color[1]+color[2]+color[2]+color[3]+color[3];}else if(color.length===7){// color looks like "#f604e2"
hex=color.slice(1);}else{throw new Error('Invalid color code provided, '+color+'; must be formatted as e.g. #f0e or #f604e2.');}return'rgba('+parseInt(hex.slice(0,2),16)+','+parseInt(hex.slice(2,4),16)+','+parseInt(hex.slice(4,6),16)+','+opacity+')';}/**
 * Try to update the style of a DOM element. Some style changes will throw an error,
 * particularly in IE8. Those should be noops.
 *
 * @param {Element} el
 *        The DOM element to be styled.
 *
 * @param {string} style
 *        The CSS property on the element that should be styled.
 *
 * @param {string} rule
 *        The style rule that should be applied to the property.
 *
 * @private
 */function tryUpdateStyle(el,style,rule){try{el.style[style]=rule;}catch(e){// Satisfies linter.
return;}}/**
 * The component for displaying text track cues.
 *
 * @extends Component
 */var TextTrackDisplay=/*#__PURE__*/function(_Component){_inheritsLoose(TextTrackDisplay,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Component~ReadyCallback} [ready]
   *        The function to call when `TextTrackDisplay` is ready.
   */function TextTrackDisplay(player,options,ready){var _this;_this=_Component.call(this,player,options,ready)||this;var updateDisplayHandler=function updateDisplayHandler(e){return _this.updateDisplay(e);};player.on('loadstart',function(e){return _this.toggleDisplay(e);});player.on('texttrackchange',updateDisplayHandler);player.on('loadedmetadata',function(e){return _this.preselectTrack(e);});// This used to be called during player init, but was causing an error
// if a track should show by default and the display hadn't loaded yet.
// Should probably be moved to an external track loader when we support
// tracks that don't need a display.
player.ready(bind(_assertThisInitialized(_this),function(){if(player.tech_&&player.tech_.featuresNativeTextTracks){this.hide();return;}player.on('fullscreenchange',updateDisplayHandler);player.on('playerresize',updateDisplayHandler);window_default().addEventListener('orientationchange',updateDisplayHandler);player.on('dispose',function(){return window_default().removeEventListener('orientationchange',updateDisplayHandler);});var tracks=this.options_.playerOptions.tracks||[];for(var i=0;i<tracks.length;i++){this.player_.addRemoteTextTrack(tracks[i],true);}this.preselectTrack();}));return _this;}/**
  * Preselect a track following this precedence:
  * - matches the previously selected {@link TextTrack}'s language and kind
  * - matches the previously selected {@link TextTrack}'s language only
  * - is the first default captions track
  * - is the first default descriptions track
  *
  * @listens Player#loadstart
  */var _proto=TextTrackDisplay.prototype;_proto.preselectTrack=function preselectTrack(){var modes={captions:1,subtitles:1};var trackList=this.player_.textTracks();var userPref=this.player_.cache_.selectedLanguage;var firstDesc;var firstCaptions;var preferredTrack;for(var i=0;i<trackList.length;i++){var track=trackList[i];if(userPref&&userPref.enabled&&userPref.language&&userPref.language===track.language&&track.kind in modes){// Always choose the track that matches both language and kind
if(track.kind===userPref.kind){preferredTrack=track;// or choose the first track that matches language
}else if(!preferredTrack){preferredTrack=track;}// clear everything if offTextTrackMenuItem was clicked
}else if(userPref&&!userPref.enabled){preferredTrack=null;firstDesc=null;firstCaptions=null;}else if(track["default"]){if(track.kind==='descriptions'&&!firstDesc){firstDesc=track;}else if(track.kind in modes&&!firstCaptions){firstCaptions=track;}}}// The preferredTrack matches the user preference and takes
// precedence over all the other tracks.
// So, display the preferredTrack before the first default track
// and the subtitles/captions track before the descriptions track
if(preferredTrack){preferredTrack.mode='showing';}else if(firstCaptions){firstCaptions.mode='showing';}else if(firstDesc){firstDesc.mode='showing';}}/**
   * Turn display of {@link TextTrack}'s from the current state into the other state.
   * There are only two states:
   * - 'shown'
   * - 'hidden'
   *
   * @listens Player#loadstart
   */;_proto.toggleDisplay=function toggleDisplay(){if(this.player_.tech_&&this.player_.tech_.featuresNativeTextTracks){this.hide();}else{this.show();}}/**
   * Create the {@link Component}'s DOM element.
   *
   * @return {Element}
   *         The element that was created.
   */;_proto.createEl=function createEl(){return _Component.prototype.createEl.call(this,'div',{className:'vjs-text-track-display'},{'translate':'yes','aria-live':'off','aria-atomic':'true'});}/**
   * Clear all displayed {@link TextTrack}s.
   */;_proto.clearDisplay=function clearDisplay(){if(typeof (window_default()).WebVTT==='function'){window_default().WebVTT.processCues((window_default()),[],this.el_);}}/**
   * Update the displayed TextTrack when a either a {@link Player#texttrackchange} or
   * a {@link Player#fullscreenchange} is fired.
   *
   * @listens Player#texttrackchange
   * @listens Player#fullscreenchange
   */;_proto.updateDisplay=function updateDisplay(){var tracks=this.player_.textTracks();var allowMultipleShowingTracks=this.options_.allowMultipleShowingTracks;this.clearDisplay();if(allowMultipleShowingTracks){var showingTracks=[];for(var _i=0;_i<tracks.length;++_i){var track=tracks[_i];if(track.mode!=='showing'){continue;}showingTracks.push(track);}this.updateForTrack(showingTracks);return;}//  Track display prioritization model: if multiple tracks are 'showing',
//  display the first 'subtitles' or 'captions' track which is 'showing',
//  otherwise display the first 'descriptions' track which is 'showing'
var descriptionsTrack=null;var captionsSubtitlesTrack=null;var i=tracks.length;while(i--){var _track=tracks[i];if(_track.mode==='showing'){if(_track.kind==='descriptions'){descriptionsTrack=_track;}else{captionsSubtitlesTrack=_track;}}}if(captionsSubtitlesTrack){if(this.getAttribute('aria-live')!=='off'){this.setAttribute('aria-live','off');}this.updateForTrack(captionsSubtitlesTrack);}else if(descriptionsTrack){if(this.getAttribute('aria-live')!=='assertive'){this.setAttribute('aria-live','assertive');}this.updateForTrack(descriptionsTrack);}}/**
   * Style {@Link TextTrack} activeCues according to {@Link TextTrackSettings}.
   *
   * @param {TextTrack} track
   *        Text track object containing active cues to style.
   */;_proto.updateDisplayState=function updateDisplayState(track){var overrides=this.player_.textTrackSettings.getValues();var cues=track.activeCues;var i=cues.length;while(i--){var cue=cues[i];if(!cue){continue;}var cueDiv=cue.displayState;if(overrides.color){cueDiv.firstChild.style.color=overrides.color;}if(overrides.textOpacity){tryUpdateStyle(cueDiv.firstChild,'color',constructColor(overrides.color||'#fff',overrides.textOpacity));}if(overrides.backgroundColor){cueDiv.firstChild.style.backgroundColor=overrides.backgroundColor;}if(overrides.backgroundOpacity){tryUpdateStyle(cueDiv.firstChild,'backgroundColor',constructColor(overrides.backgroundColor||'#000',overrides.backgroundOpacity));}if(overrides.windowColor){if(overrides.windowOpacity){tryUpdateStyle(cueDiv,'backgroundColor',constructColor(overrides.windowColor,overrides.windowOpacity));}else{cueDiv.style.backgroundColor=overrides.windowColor;}}if(overrides.edgeStyle){if(overrides.edgeStyle==='dropshadow'){cueDiv.firstChild.style.textShadow="2px 2px 3px "+darkGray+", 2px 2px 4px "+darkGray+", 2px 2px 5px "+darkGray;}else if(overrides.edgeStyle==='raised'){cueDiv.firstChild.style.textShadow="1px 1px "+darkGray+", 2px 2px "+darkGray+", 3px 3px "+darkGray;}else if(overrides.edgeStyle==='depressed'){cueDiv.firstChild.style.textShadow="1px 1px "+lightGray+", 0 1px "+lightGray+", -1px -1px "+darkGray+", 0 -1px "+darkGray;}else if(overrides.edgeStyle==='uniform'){cueDiv.firstChild.style.textShadow="0 0 4px "+darkGray+", 0 0 4px "+darkGray+", 0 0 4px "+darkGray+", 0 0 4px "+darkGray;}}if(overrides.fontPercent&&overrides.fontPercent!==1){var fontSize=window_default().parseFloat(cueDiv.style.fontSize);cueDiv.style.fontSize=fontSize*overrides.fontPercent+'px';cueDiv.style.height='auto';cueDiv.style.top='auto';}if(overrides.fontFamily&&overrides.fontFamily!=='default'){if(overrides.fontFamily==='small-caps'){cueDiv.firstChild.style.fontVariant='small-caps';}else{cueDiv.firstChild.style.fontFamily=fontMap[overrides.fontFamily];}}}}/**
   * Add an {@link TextTrack} to to the {@link Tech}s {@link TextTrackList}.
   *
   * @param {TextTrack|TextTrack[]} tracks
   *        Text track object or text track array to be added to the list.
   */;_proto.updateForTrack=function updateForTrack(tracks){if(!Array.isArray(tracks)){tracks=[tracks];}if(typeof (window_default()).WebVTT!=='function'||tracks.every(function(track){return!track.activeCues;})){return;}var cues=[];// push all active track cues
for(var i=0;i<tracks.length;++i){var track=tracks[i];for(var j=0;j<track.activeCues.length;++j){cues.push(track.activeCues[j]);}}// removes all cues before it processes new ones
window_default().WebVTT.processCues((window_default()),cues,this.el_);// add unique class to each language text track & add settings styling if necessary
for(var _i2=0;_i2<tracks.length;++_i2){var _track2=tracks[_i2];for(var _j=0;_j<_track2.activeCues.length;++_j){var cueEl=_track2.activeCues[_j].displayState;addClass(cueEl,'vjs-text-track-cue');addClass(cueEl,'vjs-text-track-cue-'+(_track2.language?_track2.language:_i2));if(_track2.language){setAttribute(cueEl,'lang',_track2.language);}}if(this.player_.textTrackSettings){this.updateDisplayState(_track2);}}};return TextTrackDisplay;}(Component$1);Component$1.registerComponent('TextTrackDisplay',TextTrackDisplay);/**
 * A loading spinner for use during waiting/loading events.
 *
 * @extends Component
 */var LoadingSpinner=/*#__PURE__*/function(_Component){_inheritsLoose(LoadingSpinner,_Component);function LoadingSpinner(){return _Component.apply(this,arguments)||this;}var _proto=LoadingSpinner.prototype;/**
   * Create the `LoadingSpinner`s DOM element.
   *
   * @return {Element}
   *         The dom element that gets created.
   */_proto.createEl=function createEl$1(){var isAudio=this.player_.isAudio();var playerType=this.localize(isAudio?'Audio Player':'Video Player');var controlText=createEl('span',{className:'vjs-control-text',textContent:this.localize('{1} is loading.',[playerType])});var el=_Component.prototype.createEl.call(this,'div',{className:'vjs-loading-spinner',dir:'ltr'});el.appendChild(controlText);return el;};return LoadingSpinner;}(Component$1);Component$1.registerComponent('LoadingSpinner',LoadingSpinner);/**
 * Base class for all buttons.
 *
 * @extends ClickableComponent
 */var Button=/*#__PURE__*/function(_ClickableComponent){_inheritsLoose(Button,_ClickableComponent);function Button(){return _ClickableComponent.apply(this,arguments)||this;}var _proto=Button.prototype;/**
   * Create the `Button`s DOM element.
   *
   * @param {string} [tag="button"]
   *        The element's node type. This argument is IGNORED: no matter what
   *        is passed, it will always create a `button` element.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element.
   *
   * @param {Object} [attributes={}]
   *        An object of attributes that should be set on the element.
   *
   * @return {Element}
   *         The element that gets created.
   */_proto.createEl=function createEl$1(tag,props,attributes){if(props===void 0){props={};}if(attributes===void 0){attributes={};}tag='button';props=video_es_assign({className:this.buildCSSClass()},props);// Add attributes for button element
attributes=video_es_assign({// Necessary since the default button type is "submit"
type:'button'},attributes);var el=createEl(tag,props,attributes);el.appendChild(createEl('span',{className:'vjs-icon-placeholder'},{'aria-hidden':true}));this.createControlTextEl(el);return el;}/**
   * Add a child `Component` inside of this `Button`.
   *
   * @param {string|Component} child
   *        The name or instance of a child to add.
   *
   * @param {Object} [options={}]
   *        The key/value store of options that will get passed to children of
   *        the child.
   *
   * @return {Component}
   *         The `Component` that gets added as a child. When using a string the
   *         `Component` will get created by this process.
   *
   * @deprecated since version 5
   */;_proto.addChild=function addChild(child,options){if(options===void 0){options={};}var className=this.constructor.name;log$1.warn("Adding an actionable (user controllable) child to a Button ("+className+") is not supported; use a ClickableComponent instead.");// Avoid the error message generated by ClickableComponent's addChild method
return Component$1.prototype.addChild.call(this,child,options);}/**
   * Enable the `Button` element so that it can be activated or clicked. Use this with
   * {@link Button#disable}.
   */;_proto.enable=function enable(){_ClickableComponent.prototype.enable.call(this);this.el_.removeAttribute('disabled');}/**
   * Disable the `Button` element so that it cannot be activated or clicked. Use this with
   * {@link Button#enable}.
   */;_proto.disable=function disable(){_ClickableComponent.prototype.disable.call(this);this.el_.setAttribute('disabled','disabled');}/**
   * This gets called when a `Button` has focus and `keydown` is triggered via a key
   * press.
   *
   * @param {EventTarget~Event} event
   *        The event that caused this function to get called.
   *
   * @listens keydown
   */;_proto.handleKeyDown=function handleKeyDown(event){// Ignore Space or Enter key operation, which is handled by the browser for
// a button - though not for its super class, ClickableComponent. Also,
// prevent the event from propagating through the DOM and triggering Player
// hotkeys. We do not preventDefault here because we _want_ the browser to
// handle it.
if(keycode_default().isEventKey(event,'Space')||keycode_default().isEventKey(event,'Enter')){event.stopPropagation();return;}// Pass keypress handling up for unsupported keys
_ClickableComponent.prototype.handleKeyDown.call(this,event);};return Button;}(ClickableComponent);Component$1.registerComponent('Button',Button);/**
 * The initial play button that shows before the video has played. The hiding of the
 * `BigPlayButton` get done via CSS and `Player` states.
 *
 * @extends Button
 */var BigPlayButton=/*#__PURE__*/function(_Button){_inheritsLoose(BigPlayButton,_Button);function BigPlayButton(player,options){var _this;_this=_Button.call(this,player,options)||this;_this.mouseused_=false;_this.on('mousedown',function(e){return _this.handleMouseDown(e);});return _this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object. Always returns 'vjs-big-play-button'.
   */var _proto=BigPlayButton.prototype;_proto.buildCSSClass=function buildCSSClass(){return'vjs-big-play-button';}/**
   * This gets called when a `BigPlayButton` "clicked". See {@link ClickableComponent}
   * for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */;_proto.handleClick=function handleClick(event){var playPromise=this.player_.play();// exit early if clicked via the mouse
if(this.mouseused_&&event.clientX&&event.clientY){var sourceIsEncrypted=this.player_.usingPlugin('eme')&&this.player_.eme.sessions&&this.player_.eme.sessions.length>0;silencePromise(playPromise);if(this.player_.tech(true)&&// We've observed a bug in IE and Edge when playing back DRM content where
// calling .focus() on the video element causes the video to go black,
// so we avoid it in that specific case
!((IE_VERSION||IS_EDGE)&&sourceIsEncrypted)){this.player_.tech(true).focus();}return;}var cb=this.player_.getChild('controlBar');var playToggle=cb&&cb.getChild('playToggle');if(!playToggle){this.player_.tech(true).focus();return;}var playFocus=function playFocus(){return playToggle.focus();};if(isPromise(playPromise)){playPromise.then(playFocus,function(){});}else{this.setTimeout(playFocus,1);}};_proto.handleKeyDown=function handleKeyDown(event){this.mouseused_=false;_Button.prototype.handleKeyDown.call(this,event);};_proto.handleMouseDown=function handleMouseDown(event){this.mouseused_=true;};return BigPlayButton;}(Button);/**
 * The text that should display over the `BigPlayButton`s controls. Added to for localization.
 *
 * @type {string}
 * @private
 */BigPlayButton.prototype.controlText_='Play Video';Component$1.registerComponent('BigPlayButton',BigPlayButton);/**
 * The `CloseButton` is a `{@link Button}` that fires a `close` event when
 * it gets clicked.
 *
 * @extends Button
 */var CloseButton=/*#__PURE__*/function(_Button){_inheritsLoose(CloseButton,_Button);/**
  * Creates an instance of the this class.
  *
  * @param  {Player} player
  *         The `Player` that this class should be attached to.
  *
  * @param  {Object} [options]
  *         The key/value store of player options.
  */function CloseButton(player,options){var _this;_this=_Button.call(this,player,options)||this;_this.controlText(options&&options.controlText||_this.localize('Close'));return _this;}/**
  * Builds the default DOM `className`.
  *
  * @return {string}
  *         The DOM `className` for this object.
  */var _proto=CloseButton.prototype;_proto.buildCSSClass=function buildCSSClass(){return"vjs-close-button "+_Button.prototype.buildCSSClass.call(this);}/**
   * This gets called when a `CloseButton` gets clicked. See
   * {@link ClickableComponent#handleClick} for more information on when
   * this will be triggered
   *
   * @param {EventTarget~Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   * @fires CloseButton#close
   */;_proto.handleClick=function handleClick(event){/**
     * Triggered when the a `CloseButton` is clicked.
     *
     * @event CloseButton#close
     * @type {EventTarget~Event}
     *
     * @property {boolean} [bubbles=false]
     *           set to false so that the close event does not
     *           bubble up to parents if there is no listener
     */this.trigger({type:'close',bubbles:false});}/**
   * Event handler that is called when a `CloseButton` receives a
   * `keydown` event.
   *
   * By default, if the key is Esc, it will trigger a `click` event.
   *
   * @param {EventTarget~Event} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */;_proto.handleKeyDown=function handleKeyDown(event){// Esc button will trigger `click` event
if(keycode_default().isEventKey(event,'Esc')){event.preventDefault();event.stopPropagation();this.trigger('click');}else{// Pass keypress handling up for unsupported keys
_Button.prototype.handleKeyDown.call(this,event);}};return CloseButton;}(Button);Component$1.registerComponent('CloseButton',CloseButton);/**
 * Button to toggle between play and pause.
 *
 * @extends Button
 */var PlayToggle=/*#__PURE__*/function(_Button){_inheritsLoose(PlayToggle,_Button);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */function PlayToggle(player,options){var _this;if(options===void 0){options={};}_this=_Button.call(this,player,options)||this;// show or hide replay icon
options.replay=options.replay===undefined||options.replay;_this.on(player,'play',function(e){return _this.handlePlay(e);});_this.on(player,'pause',function(e){return _this.handlePause(e);});if(options.replay){_this.on(player,'ended',function(e){return _this.handleEnded(e);});}return _this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */var _proto=PlayToggle.prototype;_proto.buildCSSClass=function buildCSSClass(){return"vjs-play-control "+_Button.prototype.buildCSSClass.call(this);}/**
   * This gets called when an `PlayToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */;_proto.handleClick=function handleClick(event){if(this.player_.paused()){silencePromise(this.player_.play());}else{this.player_.pause();}}/**
   * This gets called once after the video has ended and the user seeks so that
   * we can change the replay button back to a play button.
   *
   * @param {EventTarget~Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#seeked
   */;_proto.handleSeeked=function handleSeeked(event){this.removeClass('vjs-ended');if(this.player_.paused()){this.handlePause(event);}else{this.handlePlay(event);}}/**
   * Add the vjs-playing class to the element so it can change appearance.
   *
   * @param {EventTarget~Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#play
   */;_proto.handlePlay=function handlePlay(event){this.removeClass('vjs-ended');this.removeClass('vjs-paused');this.addClass('vjs-playing');// change the button text to "Pause"
this.controlText('Pause');}/**
   * Add the vjs-paused class to the element so it can change appearance.
   *
   * @param {EventTarget~Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#pause
   */;_proto.handlePause=function handlePause(event){this.removeClass('vjs-playing');this.addClass('vjs-paused');// change the button text to "Play"
this.controlText('Play');}/**
   * Add the vjs-ended class to the element so it can change appearance
   *
   * @param {EventTarget~Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#ended
   */;_proto.handleEnded=function handleEnded(event){var _this2=this;this.removeClass('vjs-playing');this.addClass('vjs-ended');// change the button text to "Replay"
this.controlText('Replay');// on the next seek remove the replay button
this.one(this.player_,'seeked',function(e){return _this2.handleSeeked(e);});};return PlayToggle;}(Button);/**
 * The text that should display over the `PlayToggle`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */PlayToggle.prototype.controlText_='Play';Component$1.registerComponent('PlayToggle',PlayToggle);/**
 * @file format-time.js
 * @module format-time
 */ /**
 * Format seconds as a time string, H:MM:SS or M:SS. Supplying a guide (in
 * seconds) will force a number of leading zeros to cover the length of the
 * guide.
 *
 * @private
 * @param  {number} seconds
 *         Number of seconds to be turned into a string
 *
 * @param  {number} guide
 *         Number (in seconds) to model the string after
 *
 * @return {string}
 *         Time formatted as H:MM:SS or M:SS
 */var defaultImplementation=function defaultImplementation(seconds,guide){seconds=seconds<0?0:seconds;var s=Math.floor(seconds%60);var m=Math.floor(seconds/60%60);var h=Math.floor(seconds/3600);var gm=Math.floor(guide/60%60);var gh=Math.floor(guide/3600);// handle invalid times
if(isNaN(seconds)||seconds===Infinity){// '-' is false for all relational operators (e.g. <, >=) so this setting
// will add the minimum number of fields specified by the guide
h=m=s='-';}// Check if we need to show hours
h=h>0||gh>0?h+':':'';// If hours are showing, we may need to add a leading zero.
// Always show at least one digit of minutes.
m=((h||gm>=10)&&m<10?'0'+m:m)+':';// Check if leading zero is need for seconds
s=s<10?'0'+s:s;return h+m+s;};// Internal pointer to the current implementation.
var implementation=defaultImplementation;/**
 * Replaces the default formatTime implementation with a custom implementation.
 *
 * @param {Function} customImplementation
 *        A function which will be used in place of the default formatTime
 *        implementation. Will receive the current time in seconds and the
 *        guide (in seconds) as arguments.
 */function setFormatTime(customImplementation){implementation=customImplementation;}/**
 * Resets formatTime to the default implementation.
 */function resetFormatTime(){implementation=defaultImplementation;}/**
 * Delegates to either the default time formatting function or a custom
 * function supplied via `setFormatTime`.
 *
 * Formats seconds as a time string (H:MM:SS or M:SS). Supplying a
 * guide (in seconds) will force a number of leading zeros to cover the
 * length of the guide.
 *
 * @static
 * @example  formatTime(125, 600) === "02:05"
 * @param    {number} seconds
 *           Number of seconds to be turned into a string
 *
 * @param    {number} guide
 *           Number (in seconds) to model the string after
 *
 * @return   {string}
 *           Time formatted as H:MM:SS or M:SS
 */function formatTime(seconds,guide){if(guide===void 0){guide=seconds;}return implementation(seconds,guide);}/**
 * Displays time information about the video
 *
 * @extends Component
 */var TimeDisplay=/*#__PURE__*/function(_Component){_inheritsLoose(TimeDisplay,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function TimeDisplay(player,options){var _this;_this=_Component.call(this,player,options)||this;_this.on(player,['timeupdate','ended'],function(e){return _this.updateContent(e);});_this.updateTextNode_();return _this;}/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=TimeDisplay.prototype;_proto.createEl=function createEl$1(){var className=this.buildCSSClass();var el=_Component.prototype.createEl.call(this,'div',{className:className+" vjs-time-control vjs-control"});var span=createEl('span',{className:'vjs-control-text',textContent:this.localize(this.labelText_)+"\xA0"},{role:'presentation'});el.appendChild(span);this.contentEl_=createEl('span',{className:className+"-display"},{// tell screen readers not to automatically read the time as it changes
'aria-live':'off',// span elements have no implicit role, but some screen readers (notably VoiceOver)
// treat them as a break between items in the DOM when using arrow keys
// (or left-to-right swipes on iOS) to read contents of a page. Using
// role='presentation' causes VoiceOver to NOT treat this span as a break.
'role':'presentation'});el.appendChild(this.contentEl_);return el;};_proto.dispose=function dispose(){this.contentEl_=null;this.textNode_=null;_Component.prototype.dispose.call(this);}/**
   * Updates the time display text node with a new time
   *
   * @param {number} [time=0] the time to update to
   *
   * @private
   */;_proto.updateTextNode_=function updateTextNode_(time){var _this2=this;if(time===void 0){time=0;}time=formatTime(time);if(this.formattedTime_===time){return;}this.formattedTime_=time;this.requestNamedAnimationFrame('TimeDisplay#updateTextNode_',function(){if(!_this2.contentEl_){return;}var oldNode=_this2.textNode_;if(oldNode&&_this2.contentEl_.firstChild!==oldNode){oldNode=null;log$1.warn('TimeDisplay#updateTextnode_: Prevented replacement of text node element since it was no longer a child of this node. Appending a new node instead.');}_this2.textNode_=document_default().createTextNode(_this2.formattedTime_);if(!_this2.textNode_){return;}if(oldNode){_this2.contentEl_.replaceChild(_this2.textNode_,oldNode);}else{_this2.contentEl_.appendChild(_this2.textNode_);}});}/**
   * To be filled out in the child class, should update the displayed time
   * in accordance with the fact that the current time has changed.
   *
   * @param {EventTarget~Event} [event]
   *        The `timeupdate`  event that caused this to run.
   *
   * @listens Player#timeupdate
   */;_proto.updateContent=function updateContent(event){};return TimeDisplay;}(Component$1);/**
 * The text that is added to the `TimeDisplay` for screen reader users.
 *
 * @type {string}
 * @private
 */TimeDisplay.prototype.labelText_='Time';/**
 * The text that should display over the `TimeDisplay`s controls. Added to for localization.
 *
 * @type {string}
 * @private
 *
 * @deprecated in v7; controlText_ is not used in non-active display Components
 */TimeDisplay.prototype.controlText_='Time';Component$1.registerComponent('TimeDisplay',TimeDisplay);/**
 * Displays the current time
 *
 * @extends Component
 */var CurrentTimeDisplay=/*#__PURE__*/function(_TimeDisplay){_inheritsLoose(CurrentTimeDisplay,_TimeDisplay);function CurrentTimeDisplay(){return _TimeDisplay.apply(this,arguments)||this;}var _proto=CurrentTimeDisplay.prototype;/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */_proto.buildCSSClass=function buildCSSClass(){return'vjs-current-time';}/**
   * Update current time display
   *
   * @param {EventTarget~Event} [event]
   *        The `timeupdate` event that caused this function to run.
   *
   * @listens Player#timeupdate
   */;_proto.updateContent=function updateContent(event){// Allows for smooth scrubbing, when player can't keep up.
var time;if(this.player_.ended()){time=this.player_.duration();}else{time=this.player_.scrubbing()?this.player_.getCache().currentTime:this.player_.currentTime();}this.updateTextNode_(time);};return CurrentTimeDisplay;}(TimeDisplay);/**
 * The text that is added to the `CurrentTimeDisplay` for screen reader users.
 *
 * @type {string}
 * @private
 */CurrentTimeDisplay.prototype.labelText_='Current Time';/**
 * The text that should display over the `CurrentTimeDisplay`s controls. Added to for localization.
 *
 * @type {string}
 * @private
 *
 * @deprecated in v7; controlText_ is not used in non-active display Components
 */CurrentTimeDisplay.prototype.controlText_='Current Time';Component$1.registerComponent('CurrentTimeDisplay',CurrentTimeDisplay);/**
 * Displays the duration
 *
 * @extends Component
 */var DurationDisplay=/*#__PURE__*/function(_TimeDisplay){_inheritsLoose(DurationDisplay,_TimeDisplay);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function DurationDisplay(player,options){var _this;_this=_TimeDisplay.call(this,player,options)||this;var updateContent=function updateContent(e){return _this.updateContent(e);};// we do not want to/need to throttle duration changes,
// as they should always display the changed duration as
// it has changed
_this.on(player,'durationchange',updateContent);// Listen to loadstart because the player duration is reset when a new media element is loaded,
// but the durationchange on the user agent will not fire.
// @see [Spec]{@link https://www.w3.org/TR/2011/WD-html5-20110113/video.html#media-element-load-algorithm}
_this.on(player,'loadstart',updateContent);// Also listen for timeupdate (in the parent) and loadedmetadata because removing those
// listeners could have broken dependent applications/libraries. These
// can likely be removed for 7.0.
_this.on(player,'loadedmetadata',updateContent);return _this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */var _proto=DurationDisplay.prototype;_proto.buildCSSClass=function buildCSSClass(){return'vjs-duration';}/**
   * Update duration time display.
   *
   * @param {EventTarget~Event} [event]
   *        The `durationchange`, `timeupdate`, or `loadedmetadata` event that caused
   *        this function to be called.
   *
   * @listens Player#durationchange
   * @listens Player#timeupdate
   * @listens Player#loadedmetadata
   */;_proto.updateContent=function updateContent(event){var duration=this.player_.duration();this.updateTextNode_(duration);};return DurationDisplay;}(TimeDisplay);/**
 * The text that is added to the `DurationDisplay` for screen reader users.
 *
 * @type {string}
 * @private
 */DurationDisplay.prototype.labelText_='Duration';/**
 * The text that should display over the `DurationDisplay`s controls. Added to for localization.
 *
 * @type {string}
 * @private
 *
 * @deprecated in v7; controlText_ is not used in non-active display Components
 */DurationDisplay.prototype.controlText_='Duration';Component$1.registerComponent('DurationDisplay',DurationDisplay);/**
 * The separator between the current time and duration.
 * Can be hidden if it's not needed in the design.
 *
 * @extends Component
 */var TimeDivider=/*#__PURE__*/function(_Component){_inheritsLoose(TimeDivider,_Component);function TimeDivider(){return _Component.apply(this,arguments)||this;}var _proto=TimeDivider.prototype;/**
   * Create the component's DOM element
   *
   * @return {Element}
   *         The element that was created.
   */_proto.createEl=function createEl(){var el=_Component.prototype.createEl.call(this,'div',{className:'vjs-time-control vjs-time-divider'},{// this element and its contents can be hidden from assistive techs since
// it is made extraneous by the announcement of the control text
// for the current time and duration displays
'aria-hidden':true});var div=_Component.prototype.createEl.call(this,'div');var span=_Component.prototype.createEl.call(this,'span',{textContent:'/'});div.appendChild(span);el.appendChild(div);return el;};return TimeDivider;}(Component$1);Component$1.registerComponent('TimeDivider',TimeDivider);/**
 * Displays the time left in the video
 *
 * @extends Component
 */var RemainingTimeDisplay=/*#__PURE__*/function(_TimeDisplay){_inheritsLoose(RemainingTimeDisplay,_TimeDisplay);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function RemainingTimeDisplay(player,options){var _this;_this=_TimeDisplay.call(this,player,options)||this;_this.on(player,'durationchange',function(e){return _this.updateContent(e);});return _this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */var _proto=RemainingTimeDisplay.prototype;_proto.buildCSSClass=function buildCSSClass(){return'vjs-remaining-time';}/**
   * Create the `Component`'s DOM element with the "minus" characted prepend to the time
   *
   * @return {Element}
   *         The element that was created.
   */;_proto.createEl=function createEl$1(){var el=_TimeDisplay.prototype.createEl.call(this);if(this.options_.displayNegative!==false){el.insertBefore(createEl('span',{},{'aria-hidden':true},'-'),this.contentEl_);}return el;}/**
   * Update remaining time display.
   *
   * @param {EventTarget~Event} [event]
   *        The `timeupdate` or `durationchange` event that caused this to run.
   *
   * @listens Player#timeupdate
   * @listens Player#durationchange
   */;_proto.updateContent=function updateContent(event){if(typeof this.player_.duration()!=='number'){return;}var time;// @deprecated We should only use remainingTimeDisplay
// as of video.js 7
if(this.player_.ended()){time=0;}else if(this.player_.remainingTimeDisplay){time=this.player_.remainingTimeDisplay();}else{time=this.player_.remainingTime();}this.updateTextNode_(time);};return RemainingTimeDisplay;}(TimeDisplay);/**
 * The text that is added to the `RemainingTimeDisplay` for screen reader users.
 *
 * @type {string}
 * @private
 */RemainingTimeDisplay.prototype.labelText_='Remaining Time';/**
 * The text that should display over the `RemainingTimeDisplay`s controls. Added to for localization.
 *
 * @type {string}
 * @private
 *
 * @deprecated in v7; controlText_ is not used in non-active display Components
 */RemainingTimeDisplay.prototype.controlText_='Remaining Time';Component$1.registerComponent('RemainingTimeDisplay',RemainingTimeDisplay);/**
 * Displays the live indicator when duration is Infinity.
 *
 * @extends Component
 */var LiveDisplay=/*#__PURE__*/function(_Component){_inheritsLoose(LiveDisplay,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function LiveDisplay(player,options){var _this;_this=_Component.call(this,player,options)||this;_this.updateShowing();_this.on(_this.player(),'durationchange',function(e){return _this.updateShowing(e);});return _this;}/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=LiveDisplay.prototype;_proto.createEl=function createEl$1(){var el=_Component.prototype.createEl.call(this,'div',{className:'vjs-live-control vjs-control'});this.contentEl_=createEl('div',{className:'vjs-live-display'},{'aria-live':'off'});this.contentEl_.appendChild(createEl('span',{className:'vjs-control-text',textContent:this.localize('Stream Type')+"\xA0"}));this.contentEl_.appendChild(document_default().createTextNode(this.localize('LIVE')));el.appendChild(this.contentEl_);return el;};_proto.dispose=function dispose(){this.contentEl_=null;_Component.prototype.dispose.call(this);}/**
   * Check the duration to see if the LiveDisplay should be showing or not. Then show/hide
   * it accordingly
   *
   * @param {EventTarget~Event} [event]
   *        The {@link Player#durationchange} event that caused this function to run.
   *
   * @listens Player#durationchange
   */;_proto.updateShowing=function updateShowing(event){if(this.player().duration()===Infinity){this.show();}else{this.hide();}};return LiveDisplay;}(Component$1);Component$1.registerComponent('LiveDisplay',LiveDisplay);/**
 * Displays the live indicator when duration is Infinity.
 *
 * @extends Component
 */var SeekToLive=/*#__PURE__*/function(_Button){_inheritsLoose(SeekToLive,_Button);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function SeekToLive(player,options){var _this;_this=_Button.call(this,player,options)||this;_this.updateLiveEdgeStatus();if(_this.player_.liveTracker){_this.updateLiveEdgeStatusHandler_=function(e){return _this.updateLiveEdgeStatus(e);};_this.on(_this.player_.liveTracker,'liveedgechange',_this.updateLiveEdgeStatusHandler_);}return _this;}/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=SeekToLive.prototype;_proto.createEl=function createEl$1(){var el=_Button.prototype.createEl.call(this,'button',{className:'vjs-seek-to-live-control vjs-control'});this.textEl_=createEl('span',{className:'vjs-seek-to-live-text',textContent:this.localize('LIVE')},{'aria-hidden':'true'});el.appendChild(this.textEl_);return el;}/**
   * Update the state of this button if we are at the live edge
   * or not
   */;_proto.updateLiveEdgeStatus=function updateLiveEdgeStatus(){// default to live edge
if(!this.player_.liveTracker||this.player_.liveTracker.atLiveEdge()){this.setAttribute('aria-disabled',true);this.addClass('vjs-at-live-edge');this.controlText('Seek to live, currently playing live');}else{this.setAttribute('aria-disabled',false);this.removeClass('vjs-at-live-edge');this.controlText('Seek to live, currently behind live');}}/**
   * On click bring us as near to the live point as possible.
   * This requires that we wait for the next `live-seekable-change`
   * event which will happen every segment length seconds.
   */;_proto.handleClick=function handleClick(){this.player_.liveTracker.seekToLiveEdge();}/**
   * Dispose of the element and stop tracking
   */;_proto.dispose=function dispose(){if(this.player_.liveTracker){this.off(this.player_.liveTracker,'liveedgechange',this.updateLiveEdgeStatusHandler_);}this.textEl_=null;_Button.prototype.dispose.call(this);};return SeekToLive;}(Button);SeekToLive.prototype.controlText_='Seek to live, currently playing live';Component$1.registerComponent('SeekToLive',SeekToLive);/**
 * Keep a number between a min and a max value
 *
 * @param {number} number
 *        The number to clamp
 *
 * @param {number} min
 *        The minimum value
 * @param {number} max
 *        The maximum value
 *
 * @return {number}
 *         the clamped number
 */var clamp=function clamp(number,min,max){number=Number(number);return Math.min(max,Math.max(min,isNaN(number)?min:number));};/**
 * The base functionality for a slider. Can be vertical or horizontal.
 * For instance the volume bar or the seek bar on a video is a slider.
 *
 * @extends Component
 */var Slider=/*#__PURE__*/function(_Component){_inheritsLoose(Slider,_Component);/**
  * Create an instance of this class
  *
  * @param {Player} player
  *        The `Player` that this class should be attached to.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  */function Slider(player,options){var _this;_this=_Component.call(this,player,options)||this;_this.handleMouseDown_=function(e){return _this.handleMouseDown(e);};_this.handleMouseUp_=function(e){return _this.handleMouseUp(e);};_this.handleKeyDown_=function(e){return _this.handleKeyDown(e);};_this.handleClick_=function(e){return _this.handleClick(e);};_this.handleMouseMove_=function(e){return _this.handleMouseMove(e);};_this.update_=function(e){return _this.update(e);};// Set property names to bar to match with the child Slider class is looking for
_this.bar=_this.getChild(_this.options_.barName);// Set a horizontal or vertical class on the slider depending on the slider type
_this.vertical(!!_this.options_.vertical);_this.enable();return _this;}/**
   * Are controls are currently enabled for this slider or not.
   *
   * @return {boolean}
   *         true if controls are enabled, false otherwise
   */var _proto=Slider.prototype;_proto.enabled=function enabled(){return this.enabled_;}/**
   * Enable controls for this slider if they are disabled
   */;_proto.enable=function enable(){if(this.enabled()){return;}this.on('mousedown',this.handleMouseDown_);this.on('touchstart',this.handleMouseDown_);this.on('keydown',this.handleKeyDown_);this.on('click',this.handleClick_);// TODO: deprecated, controlsvisible does not seem to be fired
this.on(this.player_,'controlsvisible',this.update);if(this.playerEvent){this.on(this.player_,this.playerEvent,this.update);}this.removeClass('disabled');this.setAttribute('tabindex',0);this.enabled_=true;}/**
   * Disable controls for this slider if they are enabled
   */;_proto.disable=function disable(){if(!this.enabled()){return;}var doc=this.bar.el_.ownerDocument;this.off('mousedown',this.handleMouseDown_);this.off('touchstart',this.handleMouseDown_);this.off('keydown',this.handleKeyDown_);this.off('click',this.handleClick_);this.off(this.player_,'controlsvisible',this.update_);this.off(doc,'mousemove',this.handleMouseMove_);this.off(doc,'mouseup',this.handleMouseUp_);this.off(doc,'touchmove',this.handleMouseMove_);this.off(doc,'touchend',this.handleMouseUp_);this.removeAttribute('tabindex');this.addClass('disabled');if(this.playerEvent){this.off(this.player_,this.playerEvent,this.update);}this.enabled_=false;}/**
   * Create the `Slider`s DOM element.
   *
   * @param {string} type
   *        Type of element to create.
   *
   * @param {Object} [props={}]
   *        List of properties in Object form.
   *
   * @param {Object} [attributes={}]
   *        list of attributes in Object form.
   *
   * @return {Element}
   *         The element that gets created.
   */;_proto.createEl=function createEl(type,props,attributes){if(props===void 0){props={};}if(attributes===void 0){attributes={};}// Add the slider element class to all sub classes
props.className=props.className+' vjs-slider';props=video_es_assign({tabIndex:0},props);attributes=video_es_assign({'role':'slider','aria-valuenow':0,'aria-valuemin':0,'aria-valuemax':100,'tabIndex':0},attributes);return _Component.prototype.createEl.call(this,type,props,attributes);}/**
   * Handle `mousedown` or `touchstart` events on the `Slider`.
   *
   * @param {EventTarget~Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   * @fires Slider#slideractive
   */;_proto.handleMouseDown=function handleMouseDown(event){var doc=this.bar.el_.ownerDocument;if(event.type==='mousedown'){event.preventDefault();}// Do not call preventDefault() on touchstart in Chrome
// to avoid console warnings. Use a 'touch-action: none' style
// instead to prevent unintented scrolling.
// https://developers.google.com/web/updates/2017/01/scrolling-intervention
if(event.type==='touchstart'&&!IS_CHROME){event.preventDefault();}blockTextSelection();this.addClass('vjs-sliding');/**
     * Triggered when the slider is in an active state
     *
     * @event Slider#slideractive
     * @type {EventTarget~Event}
     */this.trigger('slideractive');this.on(doc,'mousemove',this.handleMouseMove_);this.on(doc,'mouseup',this.handleMouseUp_);this.on(doc,'touchmove',this.handleMouseMove_);this.on(doc,'touchend',this.handleMouseUp_);this.handleMouseMove(event,true);}/**
   * Handle the `mousemove`, `touchmove`, and `mousedown` events on this `Slider`.
   * The `mousemove` and `touchmove` events will only only trigger this function during
   * `mousedown` and `touchstart`. This is due to {@link Slider#handleMouseDown} and
   * {@link Slider#handleMouseUp}.
   *
   * @param {EventTarget~Event} event
   *        `mousedown`, `mousemove`, `touchstart`, or `touchmove` event that triggered
   *        this function
   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false.
   *
   * @listens mousemove
   * @listens touchmove
   */;_proto.handleMouseMove=function handleMouseMove(event){}/**
   * Handle `mouseup` or `touchend` events on the `Slider`.
   *
   * @param {EventTarget~Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   * @fires Slider#sliderinactive
   */;_proto.handleMouseUp=function handleMouseUp(){var doc=this.bar.el_.ownerDocument;unblockTextSelection();this.removeClass('vjs-sliding');/**
     * Triggered when the slider is no longer in an active state.
     *
     * @event Slider#sliderinactive
     * @type {EventTarget~Event}
     */this.trigger('sliderinactive');this.off(doc,'mousemove',this.handleMouseMove_);this.off(doc,'mouseup',this.handleMouseUp_);this.off(doc,'touchmove',this.handleMouseMove_);this.off(doc,'touchend',this.handleMouseUp_);this.update();}/**
   * Update the progress bar of the `Slider`.
   *
   * @return {number}
   *          The percentage of progress the progress bar represents as a
   *          number from 0 to 1.
   */;_proto.update=function update(){var _this2=this;// In VolumeBar init we have a setTimeout for update that pops and update
// to the end of the execution stack. The player is destroyed before then
// update will cause an error
// If there's no bar...
if(!this.el_||!this.bar){return;}// clamp progress between 0 and 1
// and only round to four decimal places, as we round to two below
var progress=this.getProgress();if(progress===this.progress_){return progress;}this.progress_=progress;this.requestNamedAnimationFrame('Slider#update',function(){// Set the new bar width or height
var sizeKey=_this2.vertical()?'height':'width';// Convert to a percentage for css value
_this2.bar.el().style[sizeKey]=(progress*100).toFixed(2)+'%';});return progress;}/**
   * Get the percentage of the bar that should be filled
   * but clamped and rounded.
   *
   * @return {number}
   *         percentage filled that the slider is
   */;_proto.getProgress=function getProgress(){return Number(clamp(this.getPercent(),0,1).toFixed(4));}/**
   * Calculate distance for slider
   *
   * @param {EventTarget~Event} event
   *        The event that caused this function to run.
   *
   * @return {number}
   *         The current position of the Slider.
   *         - position.x for vertical `Slider`s
   *         - position.y for horizontal `Slider`s
   */;_proto.calculateDistance=function calculateDistance(event){var position=getPointerPosition(this.el_,event);if(this.vertical()){return position.y;}return position.x;}/**
   * Handle a `keydown` event on the `Slider`. Watches for left, rigth, up, and down
   * arrow keys. This function will only be called when the slider has focus. See
   * {@link Slider#handleFocus} and {@link Slider#handleBlur}.
   *
   * @param {EventTarget~Event} event
   *        the `keydown` event that caused this function to run.
   *
   * @listens keydown
   */;_proto.handleKeyDown=function handleKeyDown(event){// Left and Down Arrows
if(keycode_default().isEventKey(event,'Left')||keycode_default().isEventKey(event,'Down')){event.preventDefault();event.stopPropagation();this.stepBack();// Up and Right Arrows
}else if(keycode_default().isEventKey(event,'Right')||keycode_default().isEventKey(event,'Up')){event.preventDefault();event.stopPropagation();this.stepForward();}else{// Pass keydown handling up for unsupported keys
_Component.prototype.handleKeyDown.call(this,event);}}/**
   * Listener for click events on slider, used to prevent clicks
   *   from bubbling up to parent elements like button menus.
   *
   * @param {Object} event
   *        Event that caused this object to run
   */;_proto.handleClick=function handleClick(event){event.stopPropagation();event.preventDefault();}/**
   * Get/set if slider is horizontal for vertical
   *
   * @param {boolean} [bool]
   *        - true if slider is vertical,
   *        - false is horizontal
   *
   * @return {boolean}
   *         - true if slider is vertical, and getting
   *         - false if the slider is horizontal, and getting
   */;_proto.vertical=function vertical(bool){if(bool===undefined){return this.vertical_||false;}this.vertical_=!!bool;if(this.vertical_){this.addClass('vjs-slider-vertical');}else{this.addClass('vjs-slider-horizontal');}};return Slider;}(Component$1);Component$1.registerComponent('Slider',Slider);var percentify=function percentify(time,end){return clamp(time/end*100,0,100).toFixed(2)+'%';};/**
 * Shows loading progress
 *
 * @extends Component
 */var LoadProgressBar=/*#__PURE__*/function(_Component){_inheritsLoose(LoadProgressBar,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function LoadProgressBar(player,options){var _this;_this=_Component.call(this,player,options)||this;_this.partEls_=[];_this.on(player,'progress',function(e){return _this.update(e);});return _this;}/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=LoadProgressBar.prototype;_proto.createEl=function createEl$1(){var el=_Component.prototype.createEl.call(this,'div',{className:'vjs-load-progress'});var wrapper=createEl('span',{className:'vjs-control-text'});var loadedText=createEl('span',{textContent:this.localize('Loaded')});var separator=document_default().createTextNode(': ');this.percentageEl_=createEl('span',{className:'vjs-control-text-loaded-percentage',textContent:'0%'});el.appendChild(wrapper);wrapper.appendChild(loadedText);wrapper.appendChild(separator);wrapper.appendChild(this.percentageEl_);return el;};_proto.dispose=function dispose(){this.partEls_=null;this.percentageEl_=null;_Component.prototype.dispose.call(this);}/**
   * Update progress bar
   *
   * @param {EventTarget~Event} [event]
   *        The `progress` event that caused this function to run.
   *
   * @listens Player#progress
   */;_proto.update=function update(event){var _this2=this;this.requestNamedAnimationFrame('LoadProgressBar#update',function(){var liveTracker=_this2.player_.liveTracker;var buffered=_this2.player_.buffered();var duration=liveTracker&&liveTracker.isLive()?liveTracker.seekableEnd():_this2.player_.duration();var bufferedEnd=_this2.player_.bufferedEnd();var children=_this2.partEls_;var percent=percentify(bufferedEnd,duration);if(_this2.percent_!==percent){// update the width of the progress bar
_this2.el_.style.width=percent;// update the control-text
textContent(_this2.percentageEl_,percent);_this2.percent_=percent;}// add child elements to represent the individual buffered time ranges
for(var i=0;i<buffered.length;i++){var start=buffered.start(i);var end=buffered.end(i);var part=children[i];if(!part){part=_this2.el_.appendChild(createEl());children[i]=part;}//  only update if changed
if(part.dataset.start===start&&part.dataset.end===end){continue;}part.dataset.start=start;part.dataset.end=end;// set the percent based on the width of the progress bar (bufferedEnd)
part.style.left=percentify(start,bufferedEnd);part.style.width=percentify(end-start,bufferedEnd);}// remove unused buffered range elements
for(var _i=children.length;_i>buffered.length;_i--){_this2.el_.removeChild(children[_i-1]);}children.length=buffered.length;});};return LoadProgressBar;}(Component$1);Component$1.registerComponent('LoadProgressBar',LoadProgressBar);/**
 * Time tooltips display a time above the progress bar.
 *
 * @extends Component
 */var TimeTooltip=/*#__PURE__*/function(_Component){_inheritsLoose(TimeTooltip,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function TimeTooltip(player,options){var _this;_this=_Component.call(this,player,options)||this;_this.update=throttle(bind(_assertThisInitialized(_this),_this.update),UPDATE_REFRESH_INTERVAL);return _this;}/**
   * Create the time tooltip DOM element
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=TimeTooltip.prototype;_proto.createEl=function createEl(){return _Component.prototype.createEl.call(this,'div',{className:'vjs-time-tooltip'},{'aria-hidden':'true'});}/**
   * Updates the position of the time tooltip relative to the `SeekBar`.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */;_proto.update=function update(seekBarRect,seekBarPoint,content){var tooltipRect=findPosition(this.el_);var playerRect=getBoundingClientRect(this.player_.el());var seekBarPointPx=seekBarRect.width*seekBarPoint;// do nothing if either rect isn't available
// for example, if the player isn't in the DOM for testing
if(!playerRect||!tooltipRect){return;}// This is the space left of the `seekBarPoint` available within the bounds
// of the player. We calculate any gap between the left edge of the player
// and the left edge of the `SeekBar` and add the number of pixels in the
// `SeekBar` before hitting the `seekBarPoint`
var spaceLeftOfPoint=seekBarRect.left-playerRect.left+seekBarPointPx;// This is the space right of the `seekBarPoint` available within the bounds
// of the player. We calculate the number of pixels from the `seekBarPoint`
// to the right edge of the `SeekBar` and add to that any gap between the
// right edge of the `SeekBar` and the player.
var spaceRightOfPoint=seekBarRect.width-seekBarPointPx+(playerRect.right-seekBarRect.right);// This is the number of pixels by which the tooltip will need to be pulled
// further to the right to center it over the `seekBarPoint`.
var pullTooltipBy=tooltipRect.width/2;// Adjust the `pullTooltipBy` distance to the left or right depending on
// the results of the space calculations above.
if(spaceLeftOfPoint<pullTooltipBy){pullTooltipBy+=pullTooltipBy-spaceLeftOfPoint;}else if(spaceRightOfPoint<pullTooltipBy){pullTooltipBy=spaceRightOfPoint;}// Due to the imprecision of decimal/ratio based calculations and varying
// rounding behaviors, there are cases where the spacing adjustment is off
// by a pixel or two. This adds insurance to these calculations.
if(pullTooltipBy<0){pullTooltipBy=0;}else if(pullTooltipBy>tooltipRect.width){pullTooltipBy=tooltipRect.width;}// prevent small width fluctuations within 0.4px from
// changing the value below.
// This really helps for live to prevent the play
// progress time tooltip from jittering
pullTooltipBy=Math.round(pullTooltipBy);this.el_.style.right="-"+pullTooltipBy+"px";this.write(content);}/**
   * Write the time to the tooltip DOM element.
   *
   * @param {string} content
   *        The formatted time for the tooltip.
   */;_proto.write=function write(content){textContent(this.el_,content);}/**
   * Updates the position of the time tooltip relative to the `SeekBar`.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   *
   * @param {number} time
   *        The time to update the tooltip to, not used during live playback
   *
   * @param {Function} cb
   *        A function that will be called during the request animation frame
   *        for tooltips that need to do additional animations from the default
   */;_proto.updateTime=function updateTime(seekBarRect,seekBarPoint,time,cb){var _this2=this;this.requestNamedAnimationFrame('TimeTooltip#updateTime',function(){var content;var duration=_this2.player_.duration();if(_this2.player_.liveTracker&&_this2.player_.liveTracker.isLive()){var liveWindow=_this2.player_.liveTracker.liveWindow();var secondsBehind=liveWindow-seekBarPoint*liveWindow;content=(secondsBehind<1?'':'-')+formatTime(secondsBehind,liveWindow);}else{content=formatTime(time,duration);}_this2.update(seekBarRect,seekBarPoint,content);if(cb){cb();}});};return TimeTooltip;}(Component$1);Component$1.registerComponent('TimeTooltip',TimeTooltip);/**
 * Used by {@link SeekBar} to display media playback progress as part of the
 * {@link ProgressControl}.
 *
 * @extends Component
 */var PlayProgressBar=/*#__PURE__*/function(_Component){_inheritsLoose(PlayProgressBar,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function PlayProgressBar(player,options){var _this;_this=_Component.call(this,player,options)||this;_this.update=throttle(bind(_assertThisInitialized(_this),_this.update),UPDATE_REFRESH_INTERVAL);return _this;}/**
   * Create the the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=PlayProgressBar.prototype;_proto.createEl=function createEl(){return _Component.prototype.createEl.call(this,'div',{className:'vjs-play-progress vjs-slider-bar'},{'aria-hidden':'true'});}/**
   * Enqueues updates to its own DOM as well as the DOM of its
   * {@link TimeTooltip} child.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */;_proto.update=function update(seekBarRect,seekBarPoint){var timeTooltip=this.getChild('timeTooltip');if(!timeTooltip){return;}var time=this.player_.scrubbing()?this.player_.getCache().currentTime:this.player_.currentTime();timeTooltip.updateTime(seekBarRect,seekBarPoint,time);};return PlayProgressBar;}(Component$1);/**
 * Default options for {@link PlayProgressBar}.
 *
 * @type {Object}
 * @private
 */PlayProgressBar.prototype.options_={children:[]};// Time tooltips should not be added to a player on mobile devices
if(!IS_IOS&&!IS_ANDROID){PlayProgressBar.prototype.options_.children.push('timeTooltip');}Component$1.registerComponent('PlayProgressBar',PlayProgressBar);/**
 * The {@link MouseTimeDisplay} component tracks mouse movement over the
 * {@link ProgressControl}. It displays an indicator and a {@link TimeTooltip}
 * indicating the time which is represented by a given point in the
 * {@link ProgressControl}.
 *
 * @extends Component
 */var MouseTimeDisplay=/*#__PURE__*/function(_Component){_inheritsLoose(MouseTimeDisplay,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function MouseTimeDisplay(player,options){var _this;_this=_Component.call(this,player,options)||this;_this.update=throttle(bind(_assertThisInitialized(_this),_this.update),UPDATE_REFRESH_INTERVAL);return _this;}/**
   * Create the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=MouseTimeDisplay.prototype;_proto.createEl=function createEl(){return _Component.prototype.createEl.call(this,'div',{className:'vjs-mouse-display'});}/**
   * Enqueues updates to its own DOM as well as the DOM of its
   * {@link TimeTooltip} child.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */;_proto.update=function update(seekBarRect,seekBarPoint){var _this2=this;var time=seekBarPoint*this.player_.duration();this.getChild('timeTooltip').updateTime(seekBarRect,seekBarPoint,time,function(){_this2.el_.style.left=seekBarRect.width*seekBarPoint+"px";});};return MouseTimeDisplay;}(Component$1);/**
 * Default options for `MouseTimeDisplay`
 *
 * @type {Object}
 * @private
 */MouseTimeDisplay.prototype.options_={children:['timeTooltip']};Component$1.registerComponent('MouseTimeDisplay',MouseTimeDisplay);var STEP_SECONDS=5;// The multiplier of STEP_SECONDS that PgUp/PgDown move the timeline.
var PAGE_KEY_MULTIPLIER=12;/**
 * Seek bar and container for the progress bars. Uses {@link PlayProgressBar}
 * as its `bar`.
 *
 * @extends Slider
 */var SeekBar=/*#__PURE__*/function(_Slider){_inheritsLoose(SeekBar,_Slider);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function SeekBar(player,options){var _this;_this=_Slider.call(this,player,options)||this;_this.setEventHandlers_();return _this;}/**
   * Sets the event handlers
   *
   * @private
   */var _proto=SeekBar.prototype;_proto.setEventHandlers_=function setEventHandlers_(){var _this2=this;this.update_=bind(this,this.update);this.update=throttle(this.update_,UPDATE_REFRESH_INTERVAL);this.on(this.player_,['ended','durationchange','timeupdate'],this.update);if(this.player_.liveTracker){this.on(this.player_.liveTracker,'liveedgechange',this.update);}// when playing, let's ensure we smoothly update the play progress bar
// via an interval
this.updateInterval=null;this.enableIntervalHandler_=function(e){return _this2.enableInterval_(e);};this.disableIntervalHandler_=function(e){return _this2.disableInterval_(e);};this.on(this.player_,['playing'],this.enableIntervalHandler_);this.on(this.player_,['ended','pause','waiting'],this.disableIntervalHandler_);// we don't need to update the play progress if the document is hidden,
// also, this causes the CPU to spike and eventually crash the page on IE11.
if('hidden'in (document_default())&&'visibilityState'in (document_default())){this.on((document_default()),'visibilitychange',this.toggleVisibility_);}};_proto.toggleVisibility_=function toggleVisibility_(e){if((document_default()).visibilityState==='hidden'){this.cancelNamedAnimationFrame('SeekBar#update');this.cancelNamedAnimationFrame('Slider#update');this.disableInterval_(e);}else{if(!this.player_.ended()&&!this.player_.paused()){this.enableInterval_();}// we just switched back to the page and someone may be looking, so, update ASAP
this.update();}};_proto.enableInterval_=function enableInterval_(){if(this.updateInterval){return;}this.updateInterval=this.setInterval(this.update,UPDATE_REFRESH_INTERVAL);};_proto.disableInterval_=function disableInterval_(e){if(this.player_.liveTracker&&this.player_.liveTracker.isLive()&&e&&e.type!=='ended'){return;}if(!this.updateInterval){return;}this.clearInterval(this.updateInterval);this.updateInterval=null;}/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */;_proto.createEl=function createEl(){return _Slider.prototype.createEl.call(this,'div',{className:'vjs-progress-holder'},{'aria-label':this.localize('Progress Bar')});}/**
   * This function updates the play progress bar and accessibility
   * attributes to whatever is passed in.
   *
   * @param {EventTarget~Event} [event]
   *        The `timeupdate` or `ended` event that caused this to run.
   *
   * @listens Player#timeupdate
   *
   * @return {number}
   *          The current percent at a number from 0-1
   */;_proto.update=function update(event){var _this3=this;// ignore updates while the tab is hidden
if((document_default()).visibilityState==='hidden'){return;}var percent=_Slider.prototype.update.call(this);this.requestNamedAnimationFrame('SeekBar#update',function(){var currentTime=_this3.player_.ended()?_this3.player_.duration():_this3.getCurrentTime_();var liveTracker=_this3.player_.liveTracker;var duration=_this3.player_.duration();if(liveTracker&&liveTracker.isLive()){duration=_this3.player_.liveTracker.liveCurrentTime();}if(_this3.percent_!==percent){// machine readable value of progress bar (percentage complete)
_this3.el_.setAttribute('aria-valuenow',(percent*100).toFixed(2));_this3.percent_=percent;}if(_this3.currentTime_!==currentTime||_this3.duration_!==duration){// human readable value of progress bar (time complete)
_this3.el_.setAttribute('aria-valuetext',_this3.localize('progress bar timing: currentTime={1} duration={2}',[formatTime(currentTime,duration),formatTime(duration,duration)],'{1} of {2}'));_this3.currentTime_=currentTime;_this3.duration_=duration;}// update the progress bar time tooltip with the current time
if(_this3.bar){_this3.bar.update(getBoundingClientRect(_this3.el()),_this3.getProgress());}});return percent;}/**
   * Prevent liveThreshold from causing seeks to seem like they
   * are not happening from a user perspective.
   *
   * @param {number} ct
   *        current time to seek to
   */;_proto.userSeek_=function userSeek_(ct){if(this.player_.liveTracker&&this.player_.liveTracker.isLive()){this.player_.liveTracker.nextSeekedFromUser();}this.player_.currentTime(ct);}/**
   * Get the value of current time but allows for smooth scrubbing,
   * when player can't keep up.
   *
   * @return {number}
   *         The current time value to display
   *
   * @private
   */;_proto.getCurrentTime_=function getCurrentTime_(){return this.player_.scrubbing()?this.player_.getCache().currentTime:this.player_.currentTime();}/**
   * Get the percentage of media played so far.
   *
   * @return {number}
   *         The percentage of media played so far (0 to 1).
   */;_proto.getPercent=function getPercent(){var currentTime=this.getCurrentTime_();var percent;var liveTracker=this.player_.liveTracker;if(liveTracker&&liveTracker.isLive()){percent=(currentTime-liveTracker.seekableStart())/liveTracker.liveWindow();// prevent the percent from changing at the live edge
if(liveTracker.atLiveEdge()){percent=1;}}else{percent=currentTime/this.player_.duration();}return percent;}/**
   * Handle mouse down on seek bar
   *
   * @param {EventTarget~Event} event
   *        The `mousedown` event that caused this to run.
   *
   * @listens mousedown
   */;_proto.handleMouseDown=function handleMouseDown(event){if(!isSingleLeftClick(event)){return;}// Stop event propagation to prevent double fire in progress-control.js
event.stopPropagation();this.videoWasPlaying=!this.player_.paused();this.player_.pause();_Slider.prototype.handleMouseDown.call(this,event);}/**
   * Handle mouse move on seek bar
   *
   * @param {EventTarget~Event} event
   *        The `mousemove` event that caused this to run.
   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false
   *
   * @listens mousemove
   */;_proto.handleMouseMove=function handleMouseMove(event,mouseDown){if(mouseDown===void 0){mouseDown=false;}if(!isSingleLeftClick(event)){return;}if(!mouseDown&&!this.player_.scrubbing()){this.player_.scrubbing(true);}var newTime;var distance=this.calculateDistance(event);var liveTracker=this.player_.liveTracker;if(!liveTracker||!liveTracker.isLive()){newTime=distance*this.player_.duration();// Don't let video end while scrubbing.
if(newTime===this.player_.duration()){newTime=newTime-0.1;}}else{if(distance>=0.99){liveTracker.seekToLiveEdge();return;}var seekableStart=liveTracker.seekableStart();var seekableEnd=liveTracker.liveCurrentTime();newTime=seekableStart+distance*liveTracker.liveWindow();// Don't let video end while scrubbing.
if(newTime>=seekableEnd){newTime=seekableEnd;}// Compensate for precision differences so that currentTime is not less
// than seekable start
if(newTime<=seekableStart){newTime=seekableStart+0.1;}// On android seekableEnd can be Infinity sometimes,
// this will cause newTime to be Infinity, which is
// not a valid currentTime.
if(newTime===Infinity){return;}}// Set new time (tell player to seek to new time)
this.userSeek_(newTime);};_proto.enable=function enable(){_Slider.prototype.enable.call(this);var mouseTimeDisplay=this.getChild('mouseTimeDisplay');if(!mouseTimeDisplay){return;}mouseTimeDisplay.show();};_proto.disable=function disable(){_Slider.prototype.disable.call(this);var mouseTimeDisplay=this.getChild('mouseTimeDisplay');if(!mouseTimeDisplay){return;}mouseTimeDisplay.hide();}/**
   * Handle mouse up on seek bar
   *
   * @param {EventTarget~Event} event
   *        The `mouseup` event that caused this to run.
   *
   * @listens mouseup
   */;_proto.handleMouseUp=function handleMouseUp(event){_Slider.prototype.handleMouseUp.call(this,event);// Stop event propagation to prevent double fire in progress-control.js
if(event){event.stopPropagation();}this.player_.scrubbing(false);/**
     * Trigger timeupdate because we're done seeking and the time has changed.
     * This is particularly useful for if the player is paused to time the time displays.
     *
     * @event Tech#timeupdate
     * @type {EventTarget~Event}
     */this.player_.trigger({type:'timeupdate',target:this,manuallyTriggered:true});if(this.videoWasPlaying){silencePromise(this.player_.play());}else{// We're done seeking and the time has changed.
// If the player is paused, make sure we display the correct time on the seek bar.
this.update_();}}/**
   * Move more quickly fast forward for keyboard-only users
   */;_proto.stepForward=function stepForward(){this.userSeek_(this.player_.currentTime()+STEP_SECONDS);}/**
   * Move more quickly rewind for keyboard-only users
   */;_proto.stepBack=function stepBack(){this.userSeek_(this.player_.currentTime()-STEP_SECONDS);}/**
   * Toggles the playback state of the player
   * This gets called when enter or space is used on the seekbar
   *
   * @param {EventTarget~Event} event
   *        The `keydown` event that caused this function to be called
   *
   */;_proto.handleAction=function handleAction(event){if(this.player_.paused()){this.player_.play();}else{this.player_.pause();}}/**
   * Called when this SeekBar has focus and a key gets pressed down.
   * Supports the following keys:
   *
   *   Space or Enter key fire a click event
   *   Home key moves to start of the timeline
   *   End key moves to end of the timeline
   *   Digit "0" through "9" keys move to 0%, 10% ... 80%, 90% of the timeline
   *   PageDown key moves back a larger step than ArrowDown
   *   PageUp key moves forward a large step
   *
   * @param {EventTarget~Event} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */;_proto.handleKeyDown=function handleKeyDown(event){var liveTracker=this.player_.liveTracker;if(keycode_default().isEventKey(event,'Space')||keycode_default().isEventKey(event,'Enter')){event.preventDefault();event.stopPropagation();this.handleAction(event);}else if(keycode_default().isEventKey(event,'Home')){event.preventDefault();event.stopPropagation();this.userSeek_(0);}else if(keycode_default().isEventKey(event,'End')){event.preventDefault();event.stopPropagation();if(liveTracker&&liveTracker.isLive()){this.userSeek_(liveTracker.liveCurrentTime());}else{this.userSeek_(this.player_.duration());}}else if(/^[0-9]$/.test(keycode_default()(event))){event.preventDefault();event.stopPropagation();var gotoFraction=((keycode_default()).codes[keycode_default()(event)]-(keycode_default()).codes[0])*10.0/100.0;if(liveTracker&&liveTracker.isLive()){this.userSeek_(liveTracker.seekableStart()+liveTracker.liveWindow()*gotoFraction);}else{this.userSeek_(this.player_.duration()*gotoFraction);}}else if(keycode_default().isEventKey(event,'PgDn')){event.preventDefault();event.stopPropagation();this.userSeek_(this.player_.currentTime()-STEP_SECONDS*PAGE_KEY_MULTIPLIER);}else if(keycode_default().isEventKey(event,'PgUp')){event.preventDefault();event.stopPropagation();this.userSeek_(this.player_.currentTime()+STEP_SECONDS*PAGE_KEY_MULTIPLIER);}else{// Pass keydown handling up for unsupported keys
_Slider.prototype.handleKeyDown.call(this,event);}};_proto.dispose=function dispose(){this.disableInterval_();this.off(this.player_,['ended','durationchange','timeupdate'],this.update);if(this.player_.liveTracker){this.off(this.player_.liveTracker,'liveedgechange',this.update);}this.off(this.player_,['playing'],this.enableIntervalHandler_);this.off(this.player_,['ended','pause','waiting'],this.disableIntervalHandler_);// we don't need to update the play progress if the document is hidden,
// also, this causes the CPU to spike and eventually crash the page on IE11.
if('hidden'in (document_default())&&'visibilityState'in (document_default())){this.off((document_default()),'visibilitychange',this.toggleVisibility_);}_Slider.prototype.dispose.call(this);};return SeekBar;}(Slider);/**
 * Default options for the `SeekBar`
 *
 * @type {Object}
 * @private
 */SeekBar.prototype.options_={children:['loadProgressBar','playProgressBar'],barName:'playProgressBar'};// MouseTimeDisplay tooltips should not be added to a player on mobile devices
if(!IS_IOS&&!IS_ANDROID){SeekBar.prototype.options_.children.splice(1,0,'mouseTimeDisplay');}Component$1.registerComponent('SeekBar',SeekBar);/**
 * The Progress Control component contains the seek bar, load progress,
 * and play progress.
 *
 * @extends Component
 */var ProgressControl=/*#__PURE__*/function(_Component){_inheritsLoose(ProgressControl,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function ProgressControl(player,options){var _this;_this=_Component.call(this,player,options)||this;_this.handleMouseMove=throttle(bind(_assertThisInitialized(_this),_this.handleMouseMove),UPDATE_REFRESH_INTERVAL);_this.throttledHandleMouseSeek=throttle(bind(_assertThisInitialized(_this),_this.handleMouseSeek),UPDATE_REFRESH_INTERVAL);_this.handleMouseUpHandler_=function(e){return _this.handleMouseUp(e);};_this.handleMouseDownHandler_=function(e){return _this.handleMouseDown(e);};_this.enable();return _this;}/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=ProgressControl.prototype;_proto.createEl=function createEl(){return _Component.prototype.createEl.call(this,'div',{className:'vjs-progress-control vjs-control'});}/**
   * When the mouse moves over the `ProgressControl`, the pointer position
   * gets passed down to the `MouseTimeDisplay` component.
   *
   * @param {EventTarget~Event} event
   *        The `mousemove` event that caused this function to run.
   *
   * @listen mousemove
   */;_proto.handleMouseMove=function handleMouseMove(event){var seekBar=this.getChild('seekBar');if(!seekBar){return;}var playProgressBar=seekBar.getChild('playProgressBar');var mouseTimeDisplay=seekBar.getChild('mouseTimeDisplay');if(!playProgressBar&&!mouseTimeDisplay){return;}var seekBarEl=seekBar.el();var seekBarRect=findPosition(seekBarEl);var seekBarPoint=getPointerPosition(seekBarEl,event).x;// The default skin has a gap on either side of the `SeekBar`. This means
// that it's possible to trigger this behavior outside the boundaries of
// the `SeekBar`. This ensures we stay within it at all times.
seekBarPoint=clamp(seekBarPoint,0,1);if(mouseTimeDisplay){mouseTimeDisplay.update(seekBarRect,seekBarPoint);}if(playProgressBar){playProgressBar.update(seekBarRect,seekBar.getProgress());}}/**
   * A throttled version of the {@link ProgressControl#handleMouseSeek} listener.
   *
   * @method ProgressControl#throttledHandleMouseSeek
   * @param {EventTarget~Event} event
   *        The `mousemove` event that caused this function to run.
   *
   * @listen mousemove
   * @listen touchmove
   */ /**
   * Handle `mousemove` or `touchmove` events on the `ProgressControl`.
   *
   * @param {EventTarget~Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousemove
   * @listens touchmove
   */;_proto.handleMouseSeek=function handleMouseSeek(event){var seekBar=this.getChild('seekBar');if(seekBar){seekBar.handleMouseMove(event);}}/**
   * Are controls are currently enabled for this progress control.
   *
   * @return {boolean}
   *         true if controls are enabled, false otherwise
   */;_proto.enabled=function enabled(){return this.enabled_;}/**
   * Disable all controls on the progress control and its children
   */;_proto.disable=function disable(){this.children().forEach(function(child){return child.disable&&child.disable();});if(!this.enabled()){return;}this.off(['mousedown','touchstart'],this.handleMouseDownHandler_);this.off(this.el_,'mousemove',this.handleMouseMove);this.removeListenersAddedOnMousedownAndTouchstart();this.addClass('disabled');this.enabled_=false;// Restore normal playback state if controls are disabled while scrubbing
if(this.player_.scrubbing()){var seekBar=this.getChild('seekBar');this.player_.scrubbing(false);if(seekBar.videoWasPlaying){silencePromise(this.player_.play());}}}/**
   * Enable all controls on the progress control and its children
   */;_proto.enable=function enable(){this.children().forEach(function(child){return child.enable&&child.enable();});if(this.enabled()){return;}this.on(['mousedown','touchstart'],this.handleMouseDownHandler_);this.on(this.el_,'mousemove',this.handleMouseMove);this.removeClass('disabled');this.enabled_=true;}/**
   * Cleanup listeners after the user finishes interacting with the progress controls
   */;_proto.removeListenersAddedOnMousedownAndTouchstart=function removeListenersAddedOnMousedownAndTouchstart(){var doc=this.el_.ownerDocument;this.off(doc,'mousemove',this.throttledHandleMouseSeek);this.off(doc,'touchmove',this.throttledHandleMouseSeek);this.off(doc,'mouseup',this.handleMouseUpHandler_);this.off(doc,'touchend',this.handleMouseUpHandler_);}/**
   * Handle `mousedown` or `touchstart` events on the `ProgressControl`.
   *
   * @param {EventTarget~Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */;_proto.handleMouseDown=function handleMouseDown(event){var doc=this.el_.ownerDocument;var seekBar=this.getChild('seekBar');if(seekBar){seekBar.handleMouseDown(event);}this.on(doc,'mousemove',this.throttledHandleMouseSeek);this.on(doc,'touchmove',this.throttledHandleMouseSeek);this.on(doc,'mouseup',this.handleMouseUpHandler_);this.on(doc,'touchend',this.handleMouseUpHandler_);}/**
   * Handle `mouseup` or `touchend` events on the `ProgressControl`.
   *
   * @param {EventTarget~Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   */;_proto.handleMouseUp=function handleMouseUp(event){var seekBar=this.getChild('seekBar');if(seekBar){seekBar.handleMouseUp(event);}this.removeListenersAddedOnMousedownAndTouchstart();};return ProgressControl;}(Component$1);/**
 * Default options for `ProgressControl`
 *
 * @type {Object}
 * @private
 */ProgressControl.prototype.options_={children:['seekBar']};Component$1.registerComponent('ProgressControl',ProgressControl);/**
 * Toggle Picture-in-Picture mode
 *
 * @extends Button
 */var PictureInPictureToggle=/*#__PURE__*/function(_Button){_inheritsLoose(PictureInPictureToggle,_Button);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @listens Player#enterpictureinpicture
   * @listens Player#leavepictureinpicture
   */function PictureInPictureToggle(player,options){var _this;_this=_Button.call(this,player,options)||this;_this.on(player,['enterpictureinpicture','leavepictureinpicture'],function(e){return _this.handlePictureInPictureChange(e);});_this.on(player,['disablepictureinpicturechanged','loadedmetadata'],function(e){return _this.handlePictureInPictureEnabledChange(e);});_this.on(player,['loadedmetadata','audioonlymodechange','audiopostermodechange'],function(){// This audio detection will not detect HLS or DASH audio-only streams because there was no reliable way to detect them at the time
var isSourceAudio=player.currentType().substring(0,5)==='audio';if(isSourceAudio||player.audioPosterMode()||player.audioOnlyMode()){if(player.isInPictureInPicture()){player.exitPictureInPicture();}_this.hide();}else{_this.show();}});// TODO: Deactivate button on player emptied event.
_this.disable();return _this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */var _proto=PictureInPictureToggle.prototype;_proto.buildCSSClass=function buildCSSClass(){return"vjs-picture-in-picture-control "+_Button.prototype.buildCSSClass.call(this);}/**
   * Enables or disables button based on document.pictureInPictureEnabled property value
   * or on value returned by player.disablePictureInPicture() method.
   */;_proto.handlePictureInPictureEnabledChange=function handlePictureInPictureEnabledChange(){if((document_default()).pictureInPictureEnabled&&this.player_.disablePictureInPicture()===false){this.enable();}else{this.disable();}}/**
   * Handles enterpictureinpicture and leavepictureinpicture on the player and change control text accordingly.
   *
   * @param {EventTarget~Event} [event]
   *        The {@link Player#enterpictureinpicture} or {@link Player#leavepictureinpicture} event that caused this function to be
   *        called.
   *
   * @listens Player#enterpictureinpicture
   * @listens Player#leavepictureinpicture
   */;_proto.handlePictureInPictureChange=function handlePictureInPictureChange(event){if(this.player_.isInPictureInPicture()){this.controlText('Exit Picture-in-Picture');}else{this.controlText('Picture-in-Picture');}this.handlePictureInPictureEnabledChange();}/**
   * This gets called when an `PictureInPictureToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */;_proto.handleClick=function handleClick(event){if(!this.player_.isInPictureInPicture()){this.player_.requestPictureInPicture();}else{this.player_.exitPictureInPicture();}};return PictureInPictureToggle;}(Button);/**
 * The text that should display over the `PictureInPictureToggle`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */PictureInPictureToggle.prototype.controlText_='Picture-in-Picture';Component$1.registerComponent('PictureInPictureToggle',PictureInPictureToggle);/**
 * Toggle fullscreen video
 *
 * @extends Button
 */var FullscreenToggle=/*#__PURE__*/function(_Button){_inheritsLoose(FullscreenToggle,_Button);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function FullscreenToggle(player,options){var _this;_this=_Button.call(this,player,options)||this;_this.on(player,'fullscreenchange',function(e){return _this.handleFullscreenChange(e);});if((document_default())[player.fsApi_.fullscreenEnabled]===false){_this.disable();}return _this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */var _proto=FullscreenToggle.prototype;_proto.buildCSSClass=function buildCSSClass(){return"vjs-fullscreen-control "+_Button.prototype.buildCSSClass.call(this);}/**
   * Handles fullscreenchange on the player and change control text accordingly.
   *
   * @param {EventTarget~Event} [event]
   *        The {@link Player#fullscreenchange} event that caused this function to be
   *        called.
   *
   * @listens Player#fullscreenchange
   */;_proto.handleFullscreenChange=function handleFullscreenChange(event){if(this.player_.isFullscreen()){this.controlText('Non-Fullscreen');}else{this.controlText('Fullscreen');}}/**
   * This gets called when an `FullscreenToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */;_proto.handleClick=function handleClick(event){if(!this.player_.isFullscreen()){this.player_.requestFullscreen();}else{this.player_.exitFullscreen();}};return FullscreenToggle;}(Button);/**
 * The text that should display over the `FullscreenToggle`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */FullscreenToggle.prototype.controlText_='Fullscreen';Component$1.registerComponent('FullscreenToggle',FullscreenToggle);/**
 * Check if volume control is supported and if it isn't hide the
 * `Component` that was passed  using the `vjs-hidden` class.
 *
 * @param {Component} self
 *        The component that should be hidden if volume is unsupported
 *
 * @param {Player} player
 *        A reference to the player
 *
 * @private
 */var checkVolumeSupport=function checkVolumeSupport(self,player){// hide volume controls when they're not supported by the current tech
if(player.tech_&&!player.tech_.featuresVolumeControl){self.addClass('vjs-hidden');}self.on(player,'loadstart',function(){if(!player.tech_.featuresVolumeControl){self.addClass('vjs-hidden');}else{self.removeClass('vjs-hidden');}});};/**
 * Shows volume level
 *
 * @extends Component
 */var VolumeLevel=/*#__PURE__*/function(_Component){_inheritsLoose(VolumeLevel,_Component);function VolumeLevel(){return _Component.apply(this,arguments)||this;}var _proto=VolumeLevel.prototype;/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */_proto.createEl=function createEl(){var el=_Component.prototype.createEl.call(this,'div',{className:'vjs-volume-level'});el.appendChild(_Component.prototype.createEl.call(this,'span',{className:'vjs-control-text'}));return el;};return VolumeLevel;}(Component$1);Component$1.registerComponent('VolumeLevel',VolumeLevel);/**
 * Volume level tooltips display a volume above or side by side the volume bar.
 *
 * @extends Component
 */var VolumeLevelTooltip=/*#__PURE__*/function(_Component){_inheritsLoose(VolumeLevelTooltip,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function VolumeLevelTooltip(player,options){var _this;_this=_Component.call(this,player,options)||this;_this.update=throttle(bind(_assertThisInitialized(_this),_this.update),UPDATE_REFRESH_INTERVAL);return _this;}/**
   * Create the volume tooltip DOM element
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=VolumeLevelTooltip.prototype;_proto.createEl=function createEl(){return _Component.prototype.createEl.call(this,'div',{className:'vjs-volume-tooltip'},{'aria-hidden':'true'});}/**
   * Updates the position of the tooltip relative to the `VolumeBar` and
   * its content text.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   */;_proto.update=function update(rangeBarRect,rangeBarPoint,vertical,content){if(!vertical){var tooltipRect=getBoundingClientRect(this.el_);var playerRect=getBoundingClientRect(this.player_.el());var volumeBarPointPx=rangeBarRect.width*rangeBarPoint;if(!playerRect||!tooltipRect){return;}var spaceLeftOfPoint=rangeBarRect.left-playerRect.left+volumeBarPointPx;var spaceRightOfPoint=rangeBarRect.width-volumeBarPointPx+(playerRect.right-rangeBarRect.right);var pullTooltipBy=tooltipRect.width/2;if(spaceLeftOfPoint<pullTooltipBy){pullTooltipBy+=pullTooltipBy-spaceLeftOfPoint;}else if(spaceRightOfPoint<pullTooltipBy){pullTooltipBy=spaceRightOfPoint;}if(pullTooltipBy<0){pullTooltipBy=0;}else if(pullTooltipBy>tooltipRect.width){pullTooltipBy=tooltipRect.width;}this.el_.style.right="-"+pullTooltipBy+"px";}this.write(content+"%");}/**
   * Write the volume to the tooltip DOM element.
   *
   * @param {string} content
   *        The formatted volume for the tooltip.
   */;_proto.write=function write(content){textContent(this.el_,content);}/**
   * Updates the position of the volume tooltip relative to the `VolumeBar`.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   * @param {number} volume
   *        The volume level to update the tooltip to
   *
   * @param {Function} cb
   *        A function that will be called during the request animation frame
   *        for tooltips that need to do additional animations from the default
   */;_proto.updateVolume=function updateVolume(rangeBarRect,rangeBarPoint,vertical,volume,cb){var _this2=this;this.requestNamedAnimationFrame('VolumeLevelTooltip#updateVolume',function(){_this2.update(rangeBarRect,rangeBarPoint,vertical,volume.toFixed(0));if(cb){cb();}});};return VolumeLevelTooltip;}(Component$1);Component$1.registerComponent('VolumeLevelTooltip',VolumeLevelTooltip);/**
 * The {@link MouseVolumeLevelDisplay} component tracks mouse movement over the
 * {@link VolumeControl}. It displays an indicator and a {@link VolumeLevelTooltip}
 * indicating the volume level which is represented by a given point in the
 * {@link VolumeBar}.
 *
 * @extends Component
 */var MouseVolumeLevelDisplay=/*#__PURE__*/function(_Component){_inheritsLoose(MouseVolumeLevelDisplay,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function MouseVolumeLevelDisplay(player,options){var _this;_this=_Component.call(this,player,options)||this;_this.update=throttle(bind(_assertThisInitialized(_this),_this.update),UPDATE_REFRESH_INTERVAL);return _this;}/**
   * Create the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=MouseVolumeLevelDisplay.prototype;_proto.createEl=function createEl(){return _Component.prototype.createEl.call(this,'div',{className:'vjs-mouse-display'});}/**
   * Enquires updates to its own DOM as well as the DOM of its
   * {@link VolumeLevelTooltip} child.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   */;_proto.update=function update(rangeBarRect,rangeBarPoint,vertical){var _this2=this;var volume=100*rangeBarPoint;this.getChild('volumeLevelTooltip').updateVolume(rangeBarRect,rangeBarPoint,vertical,volume,function(){if(vertical){_this2.el_.style.bottom=rangeBarRect.height*rangeBarPoint+"px";}else{_this2.el_.style.left=rangeBarRect.width*rangeBarPoint+"px";}});};return MouseVolumeLevelDisplay;}(Component$1);/**
 * Default options for `MouseVolumeLevelDisplay`
 *
 * @type {Object}
 * @private
 */MouseVolumeLevelDisplay.prototype.options_={children:['volumeLevelTooltip']};Component$1.registerComponent('MouseVolumeLevelDisplay',MouseVolumeLevelDisplay);/**
 * The bar that contains the volume level and can be clicked on to adjust the level
 *
 * @extends Slider
 */var VolumeBar=/*#__PURE__*/function(_Slider){_inheritsLoose(VolumeBar,_Slider);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function VolumeBar(player,options){var _this;_this=_Slider.call(this,player,options)||this;_this.on('slideractive',function(e){return _this.updateLastVolume_(e);});_this.on(player,'volumechange',function(e){return _this.updateARIAAttributes(e);});player.ready(function(){return _this.updateARIAAttributes();});return _this;}/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=VolumeBar.prototype;_proto.createEl=function createEl(){return _Slider.prototype.createEl.call(this,'div',{className:'vjs-volume-bar vjs-slider-bar'},{'aria-label':this.localize('Volume Level'),'aria-live':'polite'});}/**
   * Handle mouse down on volume bar
   *
   * @param {EventTarget~Event} event
   *        The `mousedown` event that caused this to run.
   *
   * @listens mousedown
   */;_proto.handleMouseDown=function handleMouseDown(event){if(!isSingleLeftClick(event)){return;}_Slider.prototype.handleMouseDown.call(this,event);}/**
   * Handle movement events on the {@link VolumeMenuButton}.
   *
   * @param {EventTarget~Event} event
   *        The event that caused this function to run.
   *
   * @listens mousemove
   */;_proto.handleMouseMove=function handleMouseMove(event){var mouseVolumeLevelDisplay=this.getChild('mouseVolumeLevelDisplay');if(mouseVolumeLevelDisplay){var volumeBarEl=this.el();var volumeBarRect=getBoundingClientRect(volumeBarEl);var vertical=this.vertical();var volumeBarPoint=getPointerPosition(volumeBarEl,event);volumeBarPoint=vertical?volumeBarPoint.y:volumeBarPoint.x;// The default skin has a gap on either side of the `VolumeBar`. This means
// that it's possible to trigger this behavior outside the boundaries of
// the `VolumeBar`. This ensures we stay within it at all times.
volumeBarPoint=clamp(volumeBarPoint,0,1);mouseVolumeLevelDisplay.update(volumeBarRect,volumeBarPoint,vertical);}if(!isSingleLeftClick(event)){return;}this.checkMuted();this.player_.volume(this.calculateDistance(event));}/**
   * If the player is muted unmute it.
   */;_proto.checkMuted=function checkMuted(){if(this.player_.muted()){this.player_.muted(false);}}/**
   * Get percent of volume level
   *
   * @return {number}
   *         Volume level percent as a decimal number.
   */;_proto.getPercent=function getPercent(){if(this.player_.muted()){return 0;}return this.player_.volume();}/**
   * Increase volume level for keyboard users
   */;_proto.stepForward=function stepForward(){this.checkMuted();this.player_.volume(this.player_.volume()+0.1);}/**
   * Decrease volume level for keyboard users
   */;_proto.stepBack=function stepBack(){this.checkMuted();this.player_.volume(this.player_.volume()-0.1);}/**
   * Update ARIA accessibility attributes
   *
   * @param {EventTarget~Event} [event]
   *        The `volumechange` event that caused this function to run.
   *
   * @listens Player#volumechange
   */;_proto.updateARIAAttributes=function updateARIAAttributes(event){var ariaValue=this.player_.muted()?0:this.volumeAsPercentage_();this.el_.setAttribute('aria-valuenow',ariaValue);this.el_.setAttribute('aria-valuetext',ariaValue+'%');}/**
   * Returns the current value of the player volume as a percentage
   *
   * @private
   */;_proto.volumeAsPercentage_=function volumeAsPercentage_(){return Math.round(this.player_.volume()*100);}/**
   * When user starts dragging the VolumeBar, store the volume and listen for
   * the end of the drag. When the drag ends, if the volume was set to zero,
   * set lastVolume to the stored volume.
   *
   * @listens slideractive
   * @private
   */;_proto.updateLastVolume_=function updateLastVolume_(){var _this2=this;var volumeBeforeDrag=this.player_.volume();this.one('sliderinactive',function(){if(_this2.player_.volume()===0){_this2.player_.lastVolume_(volumeBeforeDrag);}});};return VolumeBar;}(Slider);/**
 * Default options for the `VolumeBar`
 *
 * @type {Object}
 * @private
 */VolumeBar.prototype.options_={children:['volumeLevel'],barName:'volumeLevel'};// MouseVolumeLevelDisplay tooltip should not be added to a player on mobile devices
if(!IS_IOS&&!IS_ANDROID){VolumeBar.prototype.options_.children.splice(0,0,'mouseVolumeLevelDisplay');}/**
 * Call the update event for this Slider when this event happens on the player.
 *
 * @type {string}
 */VolumeBar.prototype.playerEvent='volumechange';Component$1.registerComponent('VolumeBar',VolumeBar);/**
 * The component for controlling the volume level
 *
 * @extends Component
 */var VolumeControl=/*#__PURE__*/function(_Component){_inheritsLoose(VolumeControl,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */function VolumeControl(player,options){var _this;if(options===void 0){options={};}options.vertical=options.vertical||false;// Pass the vertical option down to the VolumeBar if
// the VolumeBar is turned on.
if(typeof options.volumeBar==='undefined'||isPlain(options.volumeBar)){options.volumeBar=options.volumeBar||{};options.volumeBar.vertical=options.vertical;}_this=_Component.call(this,player,options)||this;// hide this control if volume support is missing
checkVolumeSupport(_assertThisInitialized(_this),player);_this.throttledHandleMouseMove=throttle(bind(_assertThisInitialized(_this),_this.handleMouseMove),UPDATE_REFRESH_INTERVAL);_this.handleMouseUpHandler_=function(e){return _this.handleMouseUp(e);};_this.on('mousedown',function(e){return _this.handleMouseDown(e);});_this.on('touchstart',function(e){return _this.handleMouseDown(e);});_this.on('mousemove',function(e){return _this.handleMouseMove(e);});// while the slider is active (the mouse has been pressed down and
// is dragging) or in focus we do not want to hide the VolumeBar
_this.on(_this.volumeBar,['focus','slideractive'],function(){_this.volumeBar.addClass('vjs-slider-active');_this.addClass('vjs-slider-active');_this.trigger('slideractive');});_this.on(_this.volumeBar,['blur','sliderinactive'],function(){_this.volumeBar.removeClass('vjs-slider-active');_this.removeClass('vjs-slider-active');_this.trigger('sliderinactive');});return _this;}/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=VolumeControl.prototype;_proto.createEl=function createEl(){var orientationClass='vjs-volume-horizontal';if(this.options_.vertical){orientationClass='vjs-volume-vertical';}return _Component.prototype.createEl.call(this,'div',{className:"vjs-volume-control vjs-control "+orientationClass});}/**
   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
   *
   * @param {EventTarget~Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */;_proto.handleMouseDown=function handleMouseDown(event){var doc=this.el_.ownerDocument;this.on(doc,'mousemove',this.throttledHandleMouseMove);this.on(doc,'touchmove',this.throttledHandleMouseMove);this.on(doc,'mouseup',this.handleMouseUpHandler_);this.on(doc,'touchend',this.handleMouseUpHandler_);}/**
   * Handle `mouseup` or `touchend` events on the `VolumeControl`.
   *
   * @param {EventTarget~Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   */;_proto.handleMouseUp=function handleMouseUp(event){var doc=this.el_.ownerDocument;this.off(doc,'mousemove',this.throttledHandleMouseMove);this.off(doc,'touchmove',this.throttledHandleMouseMove);this.off(doc,'mouseup',this.handleMouseUpHandler_);this.off(doc,'touchend',this.handleMouseUpHandler_);}/**
   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
   *
   * @param {EventTarget~Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */;_proto.handleMouseMove=function handleMouseMove(event){this.volumeBar.handleMouseMove(event);};return VolumeControl;}(Component$1);/**
 * Default options for the `VolumeControl`
 *
 * @type {Object}
 * @private
 */VolumeControl.prototype.options_={children:['volumeBar']};Component$1.registerComponent('VolumeControl',VolumeControl);/**
 * Check if muting volume is supported and if it isn't hide the mute toggle
 * button.
 *
 * @param {Component} self
 *        A reference to the mute toggle button
 *
 * @param {Player} player
 *        A reference to the player
 *
 * @private
 */var checkMuteSupport=function checkMuteSupport(self,player){// hide mute toggle button if it's not supported by the current tech
if(player.tech_&&!player.tech_.featuresMuteControl){self.addClass('vjs-hidden');}self.on(player,'loadstart',function(){if(!player.tech_.featuresMuteControl){self.addClass('vjs-hidden');}else{self.removeClass('vjs-hidden');}});};/**
 * A button component for muting the audio.
 *
 * @extends Button
 */var MuteToggle=/*#__PURE__*/function(_Button){_inheritsLoose(MuteToggle,_Button);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function MuteToggle(player,options){var _this;_this=_Button.call(this,player,options)||this;// hide this control if volume support is missing
checkMuteSupport(_assertThisInitialized(_this),player);_this.on(player,['loadstart','volumechange'],function(e){return _this.update(e);});return _this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */var _proto=MuteToggle.prototype;_proto.buildCSSClass=function buildCSSClass(){return"vjs-mute-control "+_Button.prototype.buildCSSClass.call(this);}/**
   * This gets called when an `MuteToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */;_proto.handleClick=function handleClick(event){var vol=this.player_.volume();var lastVolume=this.player_.lastVolume_();if(vol===0){var volumeToSet=lastVolume<0.1?0.1:lastVolume;this.player_.volume(volumeToSet);this.player_.muted(false);}else{this.player_.muted(this.player_.muted()?false:true);}}/**
   * Update the `MuteToggle` button based on the state of `volume` and `muted`
   * on the player.
   *
   * @param {EventTarget~Event} [event]
   *        The {@link Player#loadstart} event if this function was called
   *        through an event.
   *
   * @listens Player#loadstart
   * @listens Player#volumechange
   */;_proto.update=function update(event){this.updateIcon_();this.updateControlText_();}/**
   * Update the appearance of the `MuteToggle` icon.
   *
   * Possible states (given `level` variable below):
   * - 0: crossed out
   * - 1: zero bars of volume
   * - 2: one bar of volume
   * - 3: two bars of volume
   *
   * @private
   */;_proto.updateIcon_=function updateIcon_(){var vol=this.player_.volume();var level=3;// in iOS when a player is loaded with muted attribute
// and volume is changed with a native mute button
// we want to make sure muted state is updated
if(IS_IOS&&this.player_.tech_&&this.player_.tech_.el_){this.player_.muted(this.player_.tech_.el_.muted);}if(vol===0||this.player_.muted()){level=0;}else if(vol<0.33){level=1;}else if(vol<0.67){level=2;}// TODO improve muted icon classes
for(var i=0;i<4;i++){removeClass(this.el_,"vjs-vol-"+i);}addClass(this.el_,"vjs-vol-"+level);}/**
   * If `muted` has changed on the player, update the control text
   * (`title` attribute on `vjs-mute-control` element and content of
   * `vjs-control-text` element).
   *
   * @private
   */;_proto.updateControlText_=function updateControlText_(){var soundOff=this.player_.muted()||this.player_.volume()===0;var text=soundOff?'Unmute':'Mute';if(this.controlText()!==text){this.controlText(text);}};return MuteToggle;}(Button);/**
 * The text that should display over the `MuteToggle`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */MuteToggle.prototype.controlText_='Mute';Component$1.registerComponent('MuteToggle',MuteToggle);/**
 * A Component to contain the MuteToggle and VolumeControl so that
 * they can work together.
 *
 * @extends Component
 */var VolumePanel=/*#__PURE__*/function(_Component){_inheritsLoose(VolumePanel,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */function VolumePanel(player,options){var _this;if(options===void 0){options={};}if(typeof options.inline!=='undefined'){options.inline=options.inline;}else{options.inline=true;}// pass the inline option down to the VolumeControl as vertical if
// the VolumeControl is on.
if(typeof options.volumeControl==='undefined'||isPlain(options.volumeControl)){options.volumeControl=options.volumeControl||{};options.volumeControl.vertical=!options.inline;}_this=_Component.call(this,player,options)||this;// this handler is used by mouse handler methods below
_this.handleKeyPressHandler_=function(e){return _this.handleKeyPress(e);};_this.on(player,['loadstart'],function(e){return _this.volumePanelState_(e);});_this.on(_this.muteToggle,'keyup',function(e){return _this.handleKeyPress(e);});_this.on(_this.volumeControl,'keyup',function(e){return _this.handleVolumeControlKeyUp(e);});_this.on('keydown',function(e){return _this.handleKeyPress(e);});_this.on('mouseover',function(e){return _this.handleMouseOver(e);});_this.on('mouseout',function(e){return _this.handleMouseOut(e);});// while the slider is active (the mouse has been pressed down and
// is dragging) we do not want to hide the VolumeBar
_this.on(_this.volumeControl,['slideractive'],_this.sliderActive_);_this.on(_this.volumeControl,['sliderinactive'],_this.sliderInactive_);return _this;}/**
   * Add vjs-slider-active class to the VolumePanel
   *
   * @listens VolumeControl#slideractive
   * @private
   */var _proto=VolumePanel.prototype;_proto.sliderActive_=function sliderActive_(){this.addClass('vjs-slider-active');}/**
   * Removes vjs-slider-active class to the VolumePanel
   *
   * @listens VolumeControl#sliderinactive
   * @private
   */;_proto.sliderInactive_=function sliderInactive_(){this.removeClass('vjs-slider-active');}/**
   * Adds vjs-hidden or vjs-mute-toggle-only to the VolumePanel
   * depending on MuteToggle and VolumeControl state
   *
   * @listens Player#loadstart
   * @private
   */;_proto.volumePanelState_=function volumePanelState_(){// hide volume panel if neither volume control or mute toggle
// are displayed
if(this.volumeControl.hasClass('vjs-hidden')&&this.muteToggle.hasClass('vjs-hidden')){this.addClass('vjs-hidden');}// if only mute toggle is visible we don't want
// volume panel expanding when hovered or active
if(this.volumeControl.hasClass('vjs-hidden')&&!this.muteToggle.hasClass('vjs-hidden')){this.addClass('vjs-mute-toggle-only');}}/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */;_proto.createEl=function createEl(){var orientationClass='vjs-volume-panel-horizontal';if(!this.options_.inline){orientationClass='vjs-volume-panel-vertical';}return _Component.prototype.createEl.call(this,'div',{className:"vjs-volume-panel vjs-control "+orientationClass});}/**
   * Dispose of the `volume-panel` and all child components.
   */;_proto.dispose=function dispose(){this.handleMouseOut();_Component.prototype.dispose.call(this);}/**
   * Handles `keyup` events on the `VolumeControl`, looking for ESC, which closes
   * the volume panel and sets focus on `MuteToggle`.
   *
   * @param {EventTarget~Event} event
   *        The `keyup` event that caused this function to be called.
   *
   * @listens keyup
   */;_proto.handleVolumeControlKeyUp=function handleVolumeControlKeyUp(event){if(keycode_default().isEventKey(event,'Esc')){this.muteToggle.focus();}}/**
   * This gets called when a `VolumePanel` gains hover via a `mouseover` event.
   * Turns on listening for `mouseover` event. When they happen it
   * calls `this.handleMouseOver`.
   *
   * @param {EventTarget~Event} event
   *        The `mouseover` event that caused this function to be called.
   *
   * @listens mouseover
   */;_proto.handleMouseOver=function handleMouseOver(event){this.addClass('vjs-hover');on((document_default()),'keyup',this.handleKeyPressHandler_);}/**
   * This gets called when a `VolumePanel` gains hover via a `mouseout` event.
   * Turns on listening for `mouseout` event. When they happen it
   * calls `this.handleMouseOut`.
   *
   * @param {EventTarget~Event} event
   *        The `mouseout` event that caused this function to be called.
   *
   * @listens mouseout
   */;_proto.handleMouseOut=function handleMouseOut(event){this.removeClass('vjs-hover');off((document_default()),'keyup',this.handleKeyPressHandler_);}/**
   * Handles `keyup` event on the document or `keydown` event on the `VolumePanel`,
   * looking for ESC, which hides the `VolumeControl`.
   *
   * @param {EventTarget~Event} event
   *        The keypress that triggered this event.
   *
   * @listens keydown | keyup
   */;_proto.handleKeyPress=function handleKeyPress(event){if(keycode_default().isEventKey(event,'Esc')){this.handleMouseOut();}};return VolumePanel;}(Component$1);/**
 * Default options for the `VolumeControl`
 *
 * @type {Object}
 * @private
 */VolumePanel.prototype.options_={children:['muteToggle','volumeControl']};Component$1.registerComponent('VolumePanel',VolumePanel);/**
 * The Menu component is used to build popup menus, including subtitle and
 * captions selection menus.
 *
 * @extends Component
 */var Menu=/*#__PURE__*/function(_Component){_inheritsLoose(Menu,_Component);/**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        the player that this component should attach to
   *
   * @param {Object} [options]
   *        Object of option names and values
   *
   */function Menu(player,options){var _this;_this=_Component.call(this,player,options)||this;if(options){_this.menuButton_=options.menuButton;}_this.focusedChild_=-1;_this.on('keydown',function(e){return _this.handleKeyDown(e);});// All the menu item instances share the same blur handler provided by the menu container.
_this.boundHandleBlur_=function(e){return _this.handleBlur(e);};_this.boundHandleTapClick_=function(e){return _this.handleTapClick(e);};return _this;}/**
   * Add event listeners to the {@link MenuItem}.
   *
   * @param {Object} component
   *        The instance of the `MenuItem` to add listeners to.
   *
   */var _proto=Menu.prototype;_proto.addEventListenerForItem=function addEventListenerForItem(component){if(!(component instanceof Component$1)){return;}this.on(component,'blur',this.boundHandleBlur_);this.on(component,['tap','click'],this.boundHandleTapClick_);}/**
   * Remove event listeners from the {@link MenuItem}.
   *
   * @param {Object} component
   *        The instance of the `MenuItem` to remove listeners.
   *
   */;_proto.removeEventListenerForItem=function removeEventListenerForItem(component){if(!(component instanceof Component$1)){return;}this.off(component,'blur',this.boundHandleBlur_);this.off(component,['tap','click'],this.boundHandleTapClick_);}/**
   * This method will be called indirectly when the component has been added
   * before the component adds to the new menu instance by `addItem`.
   * In this case, the original menu instance will remove the component
   * by calling `removeChild`.
   *
   * @param {Object} component
   *        The instance of the `MenuItem`
   */;_proto.removeChild=function removeChild(component){if(typeof component==='string'){component=this.getChild(component);}this.removeEventListenerForItem(component);_Component.prototype.removeChild.call(this,component);}/**
   * Add a {@link MenuItem} to the menu.
   *
   * @param {Object|string} component
   *        The name or instance of the `MenuItem` to add.
   *
   */;_proto.addItem=function addItem(component){var childComponent=this.addChild(component);if(childComponent){this.addEventListenerForItem(childComponent);}}/**
   * Create the `Menu`s DOM element.
   *
   * @return {Element}
   *         the element that was created
   */;_proto.createEl=function createEl$1(){var contentElType=this.options_.contentElType||'ul';this.contentEl_=createEl(contentElType,{className:'vjs-menu-content'});this.contentEl_.setAttribute('role','menu');var el=_Component.prototype.createEl.call(this,'div',{append:this.contentEl_,className:'vjs-menu'});el.appendChild(this.contentEl_);// Prevent clicks from bubbling up. Needed for Menu Buttons,
// where a click on the parent is significant
on(el,'click',function(event){event.preventDefault();event.stopImmediatePropagation();});return el;};_proto.dispose=function dispose(){this.contentEl_=null;this.boundHandleBlur_=null;this.boundHandleTapClick_=null;_Component.prototype.dispose.call(this);}/**
   * Called when a `MenuItem` loses focus.
   *
   * @param {EventTarget~Event} event
   *        The `blur` event that caused this function to be called.
   *
   * @listens blur
   */;_proto.handleBlur=function handleBlur(event){var relatedTarget=event.relatedTarget||(document_default()).activeElement;// Close menu popup when a user clicks outside the menu
if(!this.children().some(function(element){return element.el()===relatedTarget;})){var btn=this.menuButton_;if(btn&&btn.buttonPressed_&&relatedTarget!==btn.el().firstChild){btn.unpressButton();}}}/**
   * Called when a `MenuItem` gets clicked or tapped.
   *
   * @param {EventTarget~Event} event
   *        The `click` or `tap` event that caused this function to be called.
   *
   * @listens click,tap
   */;_proto.handleTapClick=function handleTapClick(event){// Unpress the associated MenuButton, and move focus back to it
if(this.menuButton_){this.menuButton_.unpressButton();var childComponents=this.children();if(!Array.isArray(childComponents)){return;}var foundComponent=childComponents.filter(function(component){return component.el()===event.target;})[0];if(!foundComponent){return;}// don't focus menu button if item is a caption settings item
// because focus will move elsewhere
if(foundComponent.name()!=='CaptionSettingsMenuItem'){this.menuButton_.focus();}}}/**
   * Handle a `keydown` event on this menu. This listener is added in the constructor.
   *
   * @param {EventTarget~Event} event
   *        A `keydown` event that happened on the menu.
   *
   * @listens keydown
   */;_proto.handleKeyDown=function handleKeyDown(event){// Left and Down Arrows
if(keycode_default().isEventKey(event,'Left')||keycode_default().isEventKey(event,'Down')){event.preventDefault();event.stopPropagation();this.stepForward();// Up and Right Arrows
}else if(keycode_default().isEventKey(event,'Right')||keycode_default().isEventKey(event,'Up')){event.preventDefault();event.stopPropagation();this.stepBack();}}/**
   * Move to next (lower) menu item for keyboard users.
   */;_proto.stepForward=function stepForward(){var stepChild=0;if(this.focusedChild_!==undefined){stepChild=this.focusedChild_+1;}this.focus(stepChild);}/**
   * Move to previous (higher) menu item for keyboard users.
   */;_proto.stepBack=function stepBack(){var stepChild=0;if(this.focusedChild_!==undefined){stepChild=this.focusedChild_-1;}this.focus(stepChild);}/**
   * Set focus on a {@link MenuItem} in the `Menu`.
   *
   * @param {Object|string} [item=0]
   *        Index of child item set focus on.
   */;_proto.focus=function focus(item){if(item===void 0){item=0;}var children=this.children().slice();var haveTitle=children.length&&children[0].hasClass('vjs-menu-title');if(haveTitle){children.shift();}if(children.length>0){if(item<0){item=0;}else if(item>=children.length){item=children.length-1;}this.focusedChild_=item;children[item].el_.focus();}};return Menu;}(Component$1);Component$1.registerComponent('Menu',Menu);/**
 * A `MenuButton` class for any popup {@link Menu}.
 *
 * @extends Component
 */var MenuButton=/*#__PURE__*/function(_Component){_inheritsLoose(MenuButton,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */function MenuButton(player,options){var _this;if(options===void 0){options={};}_this=_Component.call(this,player,options)||this;_this.menuButton_=new Button(player,options);_this.menuButton_.controlText(_this.controlText_);_this.menuButton_.el_.setAttribute('aria-haspopup','true');// Add buildCSSClass values to the button, not the wrapper
var buttonClass=Button.prototype.buildCSSClass();_this.menuButton_.el_.className=_this.buildCSSClass()+' '+buttonClass;_this.menuButton_.removeClass('vjs-control');_this.addChild(_this.menuButton_);_this.update();_this.enabled_=true;var handleClick=function handleClick(e){return _this.handleClick(e);};_this.handleMenuKeyUp_=function(e){return _this.handleMenuKeyUp(e);};_this.on(_this.menuButton_,'tap',handleClick);_this.on(_this.menuButton_,'click',handleClick);_this.on(_this.menuButton_,'keydown',function(e){return _this.handleKeyDown(e);});_this.on(_this.menuButton_,'mouseenter',function(){_this.addClass('vjs-hover');_this.menu.show();on((document_default()),'keyup',_this.handleMenuKeyUp_);});_this.on('mouseleave',function(e){return _this.handleMouseLeave(e);});_this.on('keydown',function(e){return _this.handleSubmenuKeyDown(e);});return _this;}/**
   * Update the menu based on the current state of its items.
   */var _proto=MenuButton.prototype;_proto.update=function update(){var menu=this.createMenu();if(this.menu){this.menu.dispose();this.removeChild(this.menu);}this.menu=menu;this.addChild(menu);/**
     * Track the state of the menu button
     *
     * @type {Boolean}
     * @private
     */this.buttonPressed_=false;this.menuButton_.el_.setAttribute('aria-expanded','false');if(this.items&&this.items.length<=this.hideThreshold_){this.hide();this.menu.contentEl_.removeAttribute('role');}else{this.show();this.menu.contentEl_.setAttribute('role','menu');}}/**
   * Create the menu and add all items to it.
   *
   * @return {Menu}
   *         The constructed menu
   */;_proto.createMenu=function createMenu(){var menu=new Menu(this.player_,{menuButton:this});/**
     * Hide the menu if the number of items is less than or equal to this threshold. This defaults
     * to 0 and whenever we add items which can be hidden to the menu we'll increment it. We list
     * it here because every time we run `createMenu` we need to reset the value.
     *
     * @protected
     * @type {Number}
     */this.hideThreshold_=0;// Add a title list item to the top
if(this.options_.title){var titleEl=createEl('li',{className:'vjs-menu-title',textContent:toTitleCase$1(this.options_.title),tabIndex:-1});var titleComponent=new Component$1(this.player_,{el:titleEl});menu.addItem(titleComponent);}this.items=this.createItems();if(this.items){// Add menu items to the menu
for(var i=0;i<this.items.length;i++){menu.addItem(this.items[i]);}}return menu;}/**
   * Create the list of menu items. Specific to each subclass.
   *
   * @abstract
   */;_proto.createItems=function createItems(){}/**
   * Create the `MenuButtons`s DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */;_proto.createEl=function createEl(){return _Component.prototype.createEl.call(this,'div',{className:this.buildWrapperCSSClass()},{});}/**
   * Allow sub components to stack CSS class names for the wrapper element
   *
   * @return {string}
   *         The constructed wrapper DOM `className`
   */;_proto.buildWrapperCSSClass=function buildWrapperCSSClass(){var menuButtonClass='vjs-menu-button';// If the inline option is passed, we want to use different styles altogether.
if(this.options_.inline===true){menuButtonClass+='-inline';}else{menuButtonClass+='-popup';}// TODO: Fix the CSS so that this isn't necessary
var buttonClass=Button.prototype.buildCSSClass();return"vjs-menu-button "+menuButtonClass+" "+buttonClass+" "+_Component.prototype.buildCSSClass.call(this);}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */;_proto.buildCSSClass=function buildCSSClass(){var menuButtonClass='vjs-menu-button';// If the inline option is passed, we want to use different styles altogether.
if(this.options_.inline===true){menuButtonClass+='-inline';}else{menuButtonClass+='-popup';}return"vjs-menu-button "+menuButtonClass+" "+_Component.prototype.buildCSSClass.call(this);}/**
   * Get or set the localized control text that will be used for accessibility.
   *
   * > NOTE: This will come from the internal `menuButton_` element.
   *
   * @param {string} [text]
   *        Control text for element.
   *
   * @param {Element} [el=this.menuButton_.el()]
   *        Element to set the title on.
   *
   * @return {string}
   *         - The control text when getting
   */;_proto.controlText=function controlText(text,el){if(el===void 0){el=this.menuButton_.el();}return this.menuButton_.controlText(text,el);}/**
   * Dispose of the `menu-button` and all child components.
   */;_proto.dispose=function dispose(){this.handleMouseLeave();_Component.prototype.dispose.call(this);}/**
   * Handle a click on a `MenuButton`.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {EventTarget~Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */;_proto.handleClick=function handleClick(event){if(this.buttonPressed_){this.unpressButton();}else{this.pressButton();}}/**
   * Handle `mouseleave` for `MenuButton`.
   *
   * @param {EventTarget~Event} event
   *        The `mouseleave` event that caused this function to be called.
   *
   * @listens mouseleave
   */;_proto.handleMouseLeave=function handleMouseLeave(event){this.removeClass('vjs-hover');off((document_default()),'keyup',this.handleMenuKeyUp_);}/**
   * Set the focus to the actual button, not to this element
   */;_proto.focus=function focus(){this.menuButton_.focus();}/**
   * Remove the focus from the actual button, not this element
   */;_proto.blur=function blur(){this.menuButton_.blur();}/**
   * Handle tab, escape, down arrow, and up arrow keys for `MenuButton`. See
   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
   *
   * @param {EventTarget~Event} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */;_proto.handleKeyDown=function handleKeyDown(event){// Escape or Tab unpress the 'button'
if(keycode_default().isEventKey(event,'Esc')||keycode_default().isEventKey(event,'Tab')){if(this.buttonPressed_){this.unpressButton();}// Don't preventDefault for Tab key - we still want to lose focus
if(!keycode_default().isEventKey(event,'Tab')){event.preventDefault();// Set focus back to the menu button's button
this.menuButton_.focus();}// Up Arrow or Down Arrow also 'press' the button to open the menu
}else if(keycode_default().isEventKey(event,'Up')||keycode_default().isEventKey(event,'Down')){if(!this.buttonPressed_){event.preventDefault();this.pressButton();}}}/**
   * Handle a `keyup` event on a `MenuButton`. The listener for this is added in
   * the constructor.
   *
   * @param {EventTarget~Event} event
   *        Key press event
   *
   * @listens keyup
   */;_proto.handleMenuKeyUp=function handleMenuKeyUp(event){// Escape hides popup menu
if(keycode_default().isEventKey(event,'Esc')||keycode_default().isEventKey(event,'Tab')){this.removeClass('vjs-hover');}}/**
   * This method name now delegates to `handleSubmenuKeyDown`. This means
   * anyone calling `handleSubmenuKeyPress` will not see their method calls
   * stop working.
   *
   * @param {EventTarget~Event} event
   *        The event that caused this function to be called.
   */;_proto.handleSubmenuKeyPress=function handleSubmenuKeyPress(event){this.handleSubmenuKeyDown(event);}/**
   * Handle a `keydown` event on a sub-menu. The listener for this is added in
   * the constructor.
   *
   * @param {EventTarget~Event} event
   *        Key press event
   *
   * @listens keydown
   */;_proto.handleSubmenuKeyDown=function handleSubmenuKeyDown(event){// Escape or Tab unpress the 'button'
if(keycode_default().isEventKey(event,'Esc')||keycode_default().isEventKey(event,'Tab')){if(this.buttonPressed_){this.unpressButton();}// Don't preventDefault for Tab key - we still want to lose focus
if(!keycode_default().isEventKey(event,'Tab')){event.preventDefault();// Set focus back to the menu button's button
this.menuButton_.focus();}}}/**
   * Put the current `MenuButton` into a pressed state.
   */;_proto.pressButton=function pressButton(){if(this.enabled_){this.buttonPressed_=true;this.menu.show();this.menu.lockShowing();this.menuButton_.el_.setAttribute('aria-expanded','true');// set the focus into the submenu, except on iOS where it is resulting in
// undesired scrolling behavior when the player is in an iframe
if(IS_IOS&&isInFrame()){// Return early so that the menu isn't focused
return;}this.menu.focus();}}/**
   * Take the current `MenuButton` out of a pressed state.
   */;_proto.unpressButton=function unpressButton(){if(this.enabled_){this.buttonPressed_=false;this.menu.unlockShowing();this.menu.hide();this.menuButton_.el_.setAttribute('aria-expanded','false');}}/**
   * Disable the `MenuButton`. Don't allow it to be clicked.
   */;_proto.disable=function disable(){this.unpressButton();this.enabled_=false;this.addClass('vjs-disabled');this.menuButton_.disable();}/**
   * Enable the `MenuButton`. Allow it to be clicked.
   */;_proto.enable=function enable(){this.enabled_=true;this.removeClass('vjs-disabled');this.menuButton_.enable();};return MenuButton;}(Component$1);Component$1.registerComponent('MenuButton',MenuButton);/**
 * The base class for buttons that toggle specific  track types (e.g. subtitles).
 *
 * @extends MenuButton
 */var TrackButton=/*#__PURE__*/function(_MenuButton){_inheritsLoose(TrackButton,_MenuButton);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function TrackButton(player,options){var _this;var tracks=options.tracks;_this=_MenuButton.call(this,player,options)||this;if(_this.items.length<=1){_this.hide();}if(!tracks){return _assertThisInitialized(_this);}var updateHandler=bind(_assertThisInitialized(_this),_this.update);tracks.addEventListener('removetrack',updateHandler);tracks.addEventListener('addtrack',updateHandler);tracks.addEventListener('labelchange',updateHandler);_this.player_.on('ready',updateHandler);_this.player_.on('dispose',function(){tracks.removeEventListener('removetrack',updateHandler);tracks.removeEventListener('addtrack',updateHandler);tracks.removeEventListener('labelchange',updateHandler);});return _this;}return TrackButton;}(MenuButton);Component$1.registerComponent('TrackButton',TrackButton);/**
 * @file menu-keys.js
 */ /**
  * All keys used for operation of a menu (`MenuButton`, `Menu`, and `MenuItem`)
  * Note that 'Enter' and 'Space' are not included here (otherwise they would
  * prevent the `MenuButton` and `MenuItem` from being keyboard-clickable)
  * @typedef MenuKeys
  * @array
  */var MenuKeys=['Tab','Esc','Up','Down','Right','Left'];/**
 * The component for a menu item. `<li>`
 *
 * @extends ClickableComponent
 */var MenuItem=/*#__PURE__*/function(_ClickableComponent){_inheritsLoose(MenuItem,_ClickableComponent);/**
   * Creates an instance of the this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   *
   */function MenuItem(player,options){var _this;_this=_ClickableComponent.call(this,player,options)||this;_this.selectable=options.selectable;_this.isSelected_=options.selected||false;_this.multiSelectable=options.multiSelectable;_this.selected(_this.isSelected_);if(_this.selectable){if(_this.multiSelectable){_this.el_.setAttribute('role','menuitemcheckbox');}else{_this.el_.setAttribute('role','menuitemradio');}}else{_this.el_.setAttribute('role','menuitem');}return _this;}/**
   * Create the `MenuItem's DOM element
   *
   * @param {string} [type=li]
   *        Element's node type, not actually used, always set to `li`.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element
   *
   * @param {Object} [attrs={}]
   *        An object of attributes that should be set on the element
   *
   * @return {Element}
   *         The element that gets created.
   */var _proto=MenuItem.prototype;_proto.createEl=function createEl$1(type,props,attrs){// The control is textual, not just an icon
this.nonIconControl=true;var el=_ClickableComponent.prototype.createEl.call(this,'li',video_es_assign({className:'vjs-menu-item',tabIndex:-1},props),attrs);// swap icon with menu item text.
el.replaceChild(createEl('span',{className:'vjs-menu-item-text',textContent:this.localize(this.options_.label)}),el.querySelector('.vjs-icon-placeholder'));return el;}/**
   * Ignore keys which are used by the menu, but pass any other ones up. See
   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
   *
   * @param {EventTarget~Event} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */;_proto.handleKeyDown=function handleKeyDown(event){if(!MenuKeys.some(function(key){return keycode_default().isEventKey(event,key);})){// Pass keydown handling up for unused keys
_ClickableComponent.prototype.handleKeyDown.call(this,event);}}/**
   * Any click on a `MenuItem` puts it into the selected state.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {EventTarget~Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */;_proto.handleClick=function handleClick(event){this.selected(true);}/**
   * Set the state for this menu item as selected or not.
   *
   * @param {boolean} selected
   *        if the menu item is selected or not
   */;_proto.selected=function selected(_selected){if(this.selectable){if(_selected){this.addClass('vjs-selected');this.el_.setAttribute('aria-checked','true');// aria-checked isn't fully supported by browsers/screen readers,
// so indicate selected state to screen reader in the control text.
this.controlText(', selected');this.isSelected_=true;}else{this.removeClass('vjs-selected');this.el_.setAttribute('aria-checked','false');// Indicate un-selected state to screen reader
this.controlText('');this.isSelected_=false;}}};return MenuItem;}(ClickableComponent);Component$1.registerComponent('MenuItem',MenuItem);/**
 * The specific menu item type for selecting a language within a text track kind
 *
 * @extends MenuItem
 */var TextTrackMenuItem=/*#__PURE__*/function(_MenuItem){_inheritsLoose(TextTrackMenuItem,_MenuItem);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function TextTrackMenuItem(player,options){var _this;var track=options.track;var tracks=player.textTracks();// Modify options for parent MenuItem class's init.
options.label=track.label||track.language||'Unknown';options.selected=track.mode==='showing';_this=_MenuItem.call(this,player,options)||this;_this.track=track;// Determine the relevant kind(s) of tracks for this component and filter
// out empty kinds.
_this.kinds=(options.kinds||[options.kind||_this.track.kind]).filter(Boolean);var changeHandler=function changeHandler(){for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}_this.handleTracksChange.apply(_assertThisInitialized(_this),args);};var selectedLanguageChangeHandler=function selectedLanguageChangeHandler(){for(var _len2=arguments.length,args=new Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}_this.handleSelectedLanguageChange.apply(_assertThisInitialized(_this),args);};player.on(['loadstart','texttrackchange'],changeHandler);tracks.addEventListener('change',changeHandler);tracks.addEventListener('selectedlanguagechange',selectedLanguageChangeHandler);_this.on('dispose',function(){player.off(['loadstart','texttrackchange'],changeHandler);tracks.removeEventListener('change',changeHandler);tracks.removeEventListener('selectedlanguagechange',selectedLanguageChangeHandler);});// iOS7 doesn't dispatch change events to TextTrackLists when an
// associated track's mode changes. Without something like
// Object.observe() (also not present on iOS7), it's not
// possible to detect changes to the mode attribute and polyfill
// the change event. As a poor substitute, we manually dispatch
// change events whenever the controls modify the mode.
if(tracks.onchange===undefined){var event;_this.on(['tap','click'],function(){if(video_es_typeof((window_default()).Event)!=='object'){// Android 2.3 throws an Illegal Constructor error for window.Event
try{event=new (window_default()).Event('change');}catch(err){// continue regardless of error
}}if(!event){event=document_default().createEvent('Event');event.initEvent('change',true,true);}tracks.dispatchEvent(event);});}// set the default state based on current tracks
_this.handleTracksChange();return _this;}/**
   * This gets called when an `TextTrackMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */var _proto=TextTrackMenuItem.prototype;_proto.handleClick=function handleClick(event){var referenceTrack=this.track;var tracks=this.player_.textTracks();_MenuItem.prototype.handleClick.call(this,event);if(!tracks){return;}for(var i=0;i<tracks.length;i++){var track=tracks[i];// If the track from the text tracks list is not of the right kind,
// skip it. We do not want to affect tracks of incompatible kind(s).
if(this.kinds.indexOf(track.kind)===-1){continue;}// If this text track is the component's track and it is not showing,
// set it to showing.
if(track===referenceTrack){if(track.mode!=='showing'){track.mode='showing';}// If this text track is not the component's track and it is not
// disabled, set it to disabled.
}else if(track.mode!=='disabled'){track.mode='disabled';}}}/**
   * Handle text track list change
   *
   * @param {EventTarget~Event} event
   *        The `change` event that caused this function to be called.
   *
   * @listens TextTrackList#change
   */;_proto.handleTracksChange=function handleTracksChange(event){var shouldBeSelected=this.track.mode==='showing';// Prevent redundant selected() calls because they may cause
// screen readers to read the appended control text unnecessarily
if(shouldBeSelected!==this.isSelected_){this.selected(shouldBeSelected);}};_proto.handleSelectedLanguageChange=function handleSelectedLanguageChange(event){if(this.track.mode==='showing'){var selectedLanguage=this.player_.cache_.selectedLanguage;// Don't replace the kind of track across the same language
if(selectedLanguage&&selectedLanguage.enabled&&selectedLanguage.language===this.track.language&&selectedLanguage.kind!==this.track.kind){return;}this.player_.cache_.selectedLanguage={enabled:true,language:this.track.language,kind:this.track.kind};}};_proto.dispose=function dispose(){// remove reference to track object on dispose
this.track=null;_MenuItem.prototype.dispose.call(this);};return TextTrackMenuItem;}(MenuItem);Component$1.registerComponent('TextTrackMenuItem',TextTrackMenuItem);/**
 * A special menu item for turning of a specific type of text track
 *
 * @extends TextTrackMenuItem
 */var OffTextTrackMenuItem=/*#__PURE__*/function(_TextTrackMenuItem){_inheritsLoose(OffTextTrackMenuItem,_TextTrackMenuItem);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function OffTextTrackMenuItem(player,options){// Create pseudo track info
// Requires options['kind']
options.track={player:player,// it is no longer necessary to store `kind` or `kinds` on the track itself
// since they are now stored in the `kinds` property of all instances of
// TextTrackMenuItem, but this will remain for backwards compatibility
kind:options.kind,kinds:options.kinds,"default":false,mode:'disabled'};if(!options.kinds){options.kinds=[options.kind];}if(options.label){options.track.label=options.label;}else{options.track.label=options.kinds.join(' and ')+' off';}// MenuItem is selectable
options.selectable=true;// MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
options.multiSelectable=false;return _TextTrackMenuItem.call(this,player,options)||this;}/**
   * Handle text track change
   *
   * @param {EventTarget~Event} event
   *        The event that caused this function to run
   */var _proto=OffTextTrackMenuItem.prototype;_proto.handleTracksChange=function handleTracksChange(event){var tracks=this.player().textTracks();var shouldBeSelected=true;for(var i=0,l=tracks.length;i<l;i++){var track=tracks[i];if(this.options_.kinds.indexOf(track.kind)>-1&&track.mode==='showing'){shouldBeSelected=false;break;}}// Prevent redundant selected() calls because they may cause
// screen readers to read the appended control text unnecessarily
if(shouldBeSelected!==this.isSelected_){this.selected(shouldBeSelected);}};_proto.handleSelectedLanguageChange=function handleSelectedLanguageChange(event){var tracks=this.player().textTracks();var allHidden=true;for(var i=0,l=tracks.length;i<l;i++){var track=tracks[i];if(['captions','descriptions','subtitles'].indexOf(track.kind)>-1&&track.mode==='showing'){allHidden=false;break;}}if(allHidden){this.player_.cache_.selectedLanguage={enabled:false};}};return OffTextTrackMenuItem;}(TextTrackMenuItem);Component$1.registerComponent('OffTextTrackMenuItem',OffTextTrackMenuItem);/**
 * The base class for buttons that toggle specific text track types (e.g. subtitles)
 *
 * @extends MenuButton
 */var TextTrackButton=/*#__PURE__*/function(_TrackButton){_inheritsLoose(TextTrackButton,_TrackButton);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */function TextTrackButton(player,options){if(options===void 0){options={};}options.tracks=player.textTracks();return _TrackButton.call(this,player,options)||this;}/**
   * Create a menu item for each text track
   *
   * @param {TextTrackMenuItem[]} [items=[]]
   *        Existing array of items to use during creation
   *
   * @return {TextTrackMenuItem[]}
   *         Array of menu items that were created
   */var _proto=TextTrackButton.prototype;_proto.createItems=function createItems(items,TrackMenuItem){if(items===void 0){items=[];}if(TrackMenuItem===void 0){TrackMenuItem=TextTrackMenuItem;}// Label is an override for the [track] off label
// USed to localise captions/subtitles
var label;if(this.label_){label=this.label_+" off";}// Add an OFF menu item to turn all tracks off
items.push(new OffTextTrackMenuItem(this.player_,{kinds:this.kinds_,kind:this.kind_,label:label}));this.hideThreshold_+=1;var tracks=this.player_.textTracks();if(!Array.isArray(this.kinds_)){this.kinds_=[this.kind_];}for(var i=0;i<tracks.length;i++){var track=tracks[i];// only add tracks that are of an appropriate kind and have a label
if(this.kinds_.indexOf(track.kind)>-1){var item=new TrackMenuItem(this.player_,{track:track,kinds:this.kinds_,kind:this.kind_,// MenuItem is selectable
selectable:true,// MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
multiSelectable:false});item.addClass("vjs-"+track.kind+"-menu-item");items.push(item);}}return items;};return TextTrackButton;}(TrackButton);Component$1.registerComponent('TextTrackButton',TextTrackButton);/**
 * The chapter track menu item
 *
 * @extends MenuItem
 */var ChaptersTrackMenuItem=/*#__PURE__*/function(_MenuItem){_inheritsLoose(ChaptersTrackMenuItem,_MenuItem);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function ChaptersTrackMenuItem(player,options){var _this;var track=options.track;var cue=options.cue;var currentTime=player.currentTime();// Modify options for parent MenuItem class's init.
options.selectable=true;options.multiSelectable=false;options.label=cue.text;options.selected=cue.startTime<=currentTime&&currentTime<cue.endTime;_this=_MenuItem.call(this,player,options)||this;_this.track=track;_this.cue=cue;return _this;}/**
   * This gets called when an `ChaptersTrackMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */var _proto=ChaptersTrackMenuItem.prototype;_proto.handleClick=function handleClick(event){_MenuItem.prototype.handleClick.call(this);this.player_.currentTime(this.cue.startTime);};return ChaptersTrackMenuItem;}(MenuItem);Component$1.registerComponent('ChaptersTrackMenuItem',ChaptersTrackMenuItem);/**
 * The button component for toggling and selecting chapters
 * Chapters act much differently than other text tracks
 * Cues are navigation vs. other tracks of alternative languages
 *
 * @extends TextTrackButton
 */var ChaptersButton=/*#__PURE__*/function(_TextTrackButton){_inheritsLoose(ChaptersButton,_TextTrackButton);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Component~ReadyCallback} [ready]
   *        The function to call when this function is ready.
   */function ChaptersButton(player,options,ready){var _this;_this=_TextTrackButton.call(this,player,options,ready)||this;_this.selectCurrentItem_=function(){_this.items.forEach(function(item){item.selected(_this.track_.activeCues[0]===item.cue);});};return _this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */var _proto=ChaptersButton.prototype;_proto.buildCSSClass=function buildCSSClass(){return"vjs-chapters-button "+_TextTrackButton.prototype.buildCSSClass.call(this);};_proto.buildWrapperCSSClass=function buildWrapperCSSClass(){return"vjs-chapters-button "+_TextTrackButton.prototype.buildWrapperCSSClass.call(this);}/**
   * Update the menu based on the current state of its items.
   *
   * @param {EventTarget~Event} [event]
   *        An event that triggered this function to run.
   *
   * @listens TextTrackList#addtrack
   * @listens TextTrackList#removetrack
   * @listens TextTrackList#change
   */;_proto.update=function update(event){if(event&&event.track&&event.track.kind!=='chapters'){return;}var track=this.findChaptersTrack();if(track!==this.track_){this.setTrack(track);_TextTrackButton.prototype.update.call(this);}else if(!this.items||track&&track.cues&&track.cues.length!==this.items.length){// Update the menu initially or if the number of cues has changed since set
_TextTrackButton.prototype.update.call(this);}}/**
   * Set the currently selected track for the chapters button.
   *
   * @param {TextTrack} track
   *        The new track to select. Nothing will change if this is the currently selected
   *        track.
   */;_proto.setTrack=function setTrack(track){if(this.track_===track){return;}if(!this.updateHandler_){this.updateHandler_=this.update.bind(this);}// here this.track_ refers to the old track instance
if(this.track_){var remoteTextTrackEl=this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);if(remoteTextTrackEl){remoteTextTrackEl.removeEventListener('load',this.updateHandler_);}this.track_.removeEventListener('cuechange',this.selectCurrentItem_);this.track_=null;}this.track_=track;// here this.track_ refers to the new track instance
if(this.track_){this.track_.mode='hidden';var _remoteTextTrackEl=this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);if(_remoteTextTrackEl){_remoteTextTrackEl.addEventListener('load',this.updateHandler_);}this.track_.addEventListener('cuechange',this.selectCurrentItem_);}}/**
   * Find the track object that is currently in use by this ChaptersButton
   *
   * @return {TextTrack|undefined}
   *         The current track or undefined if none was found.
   */;_proto.findChaptersTrack=function findChaptersTrack(){var tracks=this.player_.textTracks()||[];for(var i=tracks.length-1;i>=0;i--){// We will always choose the last track as our chaptersTrack
var track=tracks[i];if(track.kind===this.kind_){return track;}}}/**
   * Get the caption for the ChaptersButton based on the track label. This will also
   * use the current tracks localized kind as a fallback if a label does not exist.
   *
   * @return {string}
   *         The tracks current label or the localized track kind.
   */;_proto.getMenuCaption=function getMenuCaption(){if(this.track_&&this.track_.label){return this.track_.label;}return this.localize(toTitleCase$1(this.kind_));}/**
   * Create menu from chapter track
   *
   * @return {Menu}
   *         New menu for the chapter buttons
   */;_proto.createMenu=function createMenu(){this.options_.title=this.getMenuCaption();return _TextTrackButton.prototype.createMenu.call(this);}/**
   * Create a menu item for each text track
   *
   * @return {TextTrackMenuItem[]}
   *         Array of menu items
   */;_proto.createItems=function createItems(){var items=[];if(!this.track_){return items;}var cues=this.track_.cues;if(!cues){return items;}for(var i=0,l=cues.length;i<l;i++){var cue=cues[i];var mi=new ChaptersTrackMenuItem(this.player_,{track:this.track_,cue:cue});items.push(mi);}return items;};return ChaptersButton;}(TextTrackButton);/**
 * `kind` of TextTrack to look for to associate it with this menu.
 *
 * @type {string}
 * @private
 */ChaptersButton.prototype.kind_='chapters';/**
 * The text that should display over the `ChaptersButton`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */ChaptersButton.prototype.controlText_='Chapters';Component$1.registerComponent('ChaptersButton',ChaptersButton);/**
 * The button component for toggling and selecting descriptions
 *
 * @extends TextTrackButton
 */var DescriptionsButton=/*#__PURE__*/function(_TextTrackButton){_inheritsLoose(DescriptionsButton,_TextTrackButton);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Component~ReadyCallback} [ready]
   *        The function to call when this component is ready.
   */function DescriptionsButton(player,options,ready){var _this;_this=_TextTrackButton.call(this,player,options,ready)||this;var tracks=player.textTracks();var changeHandler=bind(_assertThisInitialized(_this),_this.handleTracksChange);tracks.addEventListener('change',changeHandler);_this.on('dispose',function(){tracks.removeEventListener('change',changeHandler);});return _this;}/**
   * Handle text track change
   *
   * @param {EventTarget~Event} event
   *        The event that caused this function to run
   *
   * @listens TextTrackList#change
   */var _proto=DescriptionsButton.prototype;_proto.handleTracksChange=function handleTracksChange(event){var tracks=this.player().textTracks();var disabled=false;// Check whether a track of a different kind is showing
for(var i=0,l=tracks.length;i<l;i++){var track=tracks[i];if(track.kind!==this.kind_&&track.mode==='showing'){disabled=true;break;}}// If another track is showing, disable this menu button
if(disabled){this.disable();}else{this.enable();}}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */;_proto.buildCSSClass=function buildCSSClass(){return"vjs-descriptions-button "+_TextTrackButton.prototype.buildCSSClass.call(this);};_proto.buildWrapperCSSClass=function buildWrapperCSSClass(){return"vjs-descriptions-button "+_TextTrackButton.prototype.buildWrapperCSSClass.call(this);};return DescriptionsButton;}(TextTrackButton);/**
 * `kind` of TextTrack to look for to associate it with this menu.
 *
 * @type {string}
 * @private
 */DescriptionsButton.prototype.kind_='descriptions';/**
 * The text that should display over the `DescriptionsButton`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */DescriptionsButton.prototype.controlText_='Descriptions';Component$1.registerComponent('DescriptionsButton',DescriptionsButton);/**
 * The button component for toggling and selecting subtitles
 *
 * @extends TextTrackButton
 */var SubtitlesButton=/*#__PURE__*/function(_TextTrackButton){_inheritsLoose(SubtitlesButton,_TextTrackButton);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Component~ReadyCallback} [ready]
   *        The function to call when this component is ready.
   */function SubtitlesButton(player,options,ready){return _TextTrackButton.call(this,player,options,ready)||this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */var _proto=SubtitlesButton.prototype;_proto.buildCSSClass=function buildCSSClass(){return"vjs-subtitles-button "+_TextTrackButton.prototype.buildCSSClass.call(this);};_proto.buildWrapperCSSClass=function buildWrapperCSSClass(){return"vjs-subtitles-button "+_TextTrackButton.prototype.buildWrapperCSSClass.call(this);};return SubtitlesButton;}(TextTrackButton);/**
 * `kind` of TextTrack to look for to associate it with this menu.
 *
 * @type {string}
 * @private
 */SubtitlesButton.prototype.kind_='subtitles';/**
 * The text that should display over the `SubtitlesButton`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */SubtitlesButton.prototype.controlText_='Subtitles';Component$1.registerComponent('SubtitlesButton',SubtitlesButton);/**
 * The menu item for caption track settings menu
 *
 * @extends TextTrackMenuItem
 */var CaptionSettingsMenuItem=/*#__PURE__*/function(_TextTrackMenuItem){_inheritsLoose(CaptionSettingsMenuItem,_TextTrackMenuItem);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function CaptionSettingsMenuItem(player,options){var _this;options.track={player:player,kind:options.kind,label:options.kind+' settings',selectable:false,"default":false,mode:'disabled'};// CaptionSettingsMenuItem has no concept of 'selected'
options.selectable=false;options.name='CaptionSettingsMenuItem';_this=_TextTrackMenuItem.call(this,player,options)||this;_this.addClass('vjs-texttrack-settings');_this.controlText(', opens '+options.kind+' settings dialog');return _this;}/**
   * This gets called when an `CaptionSettingsMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */var _proto=CaptionSettingsMenuItem.prototype;_proto.handleClick=function handleClick(event){this.player().getChild('textTrackSettings').open();};return CaptionSettingsMenuItem;}(TextTrackMenuItem);Component$1.registerComponent('CaptionSettingsMenuItem',CaptionSettingsMenuItem);/**
 * The button component for toggling and selecting captions
 *
 * @extends TextTrackButton
 */var CaptionsButton=/*#__PURE__*/function(_TextTrackButton){_inheritsLoose(CaptionsButton,_TextTrackButton);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Component~ReadyCallback} [ready]
   *        The function to call when this component is ready.
   */function CaptionsButton(player,options,ready){return _TextTrackButton.call(this,player,options,ready)||this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */var _proto=CaptionsButton.prototype;_proto.buildCSSClass=function buildCSSClass(){return"vjs-captions-button "+_TextTrackButton.prototype.buildCSSClass.call(this);};_proto.buildWrapperCSSClass=function buildWrapperCSSClass(){return"vjs-captions-button "+_TextTrackButton.prototype.buildWrapperCSSClass.call(this);}/**
   * Create caption menu items
   *
   * @return {CaptionSettingsMenuItem[]}
   *         The array of current menu items.
   */;_proto.createItems=function createItems(){var items=[];if(!(this.player().tech_&&this.player().tech_.featuresNativeTextTracks)&&this.player().getChild('textTrackSettings')){items.push(new CaptionSettingsMenuItem(this.player_,{kind:this.kind_}));this.hideThreshold_+=1;}return _TextTrackButton.prototype.createItems.call(this,items);};return CaptionsButton;}(TextTrackButton);/**
 * `kind` of TextTrack to look for to associate it with this menu.
 *
 * @type {string}
 * @private
 */CaptionsButton.prototype.kind_='captions';/**
 * The text that should display over the `CaptionsButton`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */CaptionsButton.prototype.controlText_='Captions';Component$1.registerComponent('CaptionsButton',CaptionsButton);/**
 * SubsCapsMenuItem has an [cc] icon to distinguish captions from subtitles
 * in the SubsCapsMenu.
 *
 * @extends TextTrackMenuItem
 */var SubsCapsMenuItem=/*#__PURE__*/function(_TextTrackMenuItem){_inheritsLoose(SubsCapsMenuItem,_TextTrackMenuItem);function SubsCapsMenuItem(){return _TextTrackMenuItem.apply(this,arguments)||this;}var _proto=SubsCapsMenuItem.prototype;_proto.createEl=function createEl$1(type,props,attrs){var el=_TextTrackMenuItem.prototype.createEl.call(this,type,props,attrs);var parentSpan=el.querySelector('.vjs-menu-item-text');if(this.options_.track.kind==='captions'){parentSpan.appendChild(createEl('span',{className:'vjs-icon-placeholder'},{'aria-hidden':true}));parentSpan.appendChild(createEl('span',{className:'vjs-control-text',// space added as the text will visually flow with the
// label
textContent:" "+this.localize('Captions')}));}return el;};return SubsCapsMenuItem;}(TextTrackMenuItem);Component$1.registerComponent('SubsCapsMenuItem',SubsCapsMenuItem);/**
 * The button component for toggling and selecting captions and/or subtitles
 *
 * @extends TextTrackButton
 */var SubsCapsButton=/*#__PURE__*/function(_TextTrackButton){_inheritsLoose(SubsCapsButton,_TextTrackButton);function SubsCapsButton(player,options){var _this;if(options===void 0){options={};}_this=_TextTrackButton.call(this,player,options)||this;// Although North America uses "captions" in most cases for
// "captions and subtitles" other locales use "subtitles"
_this.label_='subtitles';if(['en','en-us','en-ca','fr-ca'].indexOf(_this.player_.language_)>-1){_this.label_='captions';}_this.menuButton_.controlText(toTitleCase$1(_this.label_));return _this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */var _proto=SubsCapsButton.prototype;_proto.buildCSSClass=function buildCSSClass(){return"vjs-subs-caps-button "+_TextTrackButton.prototype.buildCSSClass.call(this);};_proto.buildWrapperCSSClass=function buildWrapperCSSClass(){return"vjs-subs-caps-button "+_TextTrackButton.prototype.buildWrapperCSSClass.call(this);}/**
   * Create caption/subtitles menu items
   *
   * @return {CaptionSettingsMenuItem[]}
   *         The array of current menu items.
   */;_proto.createItems=function createItems(){var items=[];if(!(this.player().tech_&&this.player().tech_.featuresNativeTextTracks)&&this.player().getChild('textTrackSettings')){items.push(new CaptionSettingsMenuItem(this.player_,{kind:this.label_}));this.hideThreshold_+=1;}items=_TextTrackButton.prototype.createItems.call(this,items,SubsCapsMenuItem);return items;};return SubsCapsButton;}(TextTrackButton);/**
 * `kind`s of TextTrack to look for to associate it with this menu.
 *
 * @type {array}
 * @private
 */SubsCapsButton.prototype.kinds_=['captions','subtitles'];/**
 * The text that should display over the `SubsCapsButton`s controls.
 *
 *
 * @type {string}
 * @private
 */SubsCapsButton.prototype.controlText_='Subtitles';Component$1.registerComponent('SubsCapsButton',SubsCapsButton);/**
 * An {@link AudioTrack} {@link MenuItem}
 *
 * @extends MenuItem
 */var AudioTrackMenuItem=/*#__PURE__*/function(_MenuItem){_inheritsLoose(AudioTrackMenuItem,_MenuItem);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function AudioTrackMenuItem(player,options){var _this;var track=options.track;var tracks=player.audioTracks();// Modify options for parent MenuItem class's init.
options.label=track.label||track.language||'Unknown';options.selected=track.enabled;_this=_MenuItem.call(this,player,options)||this;_this.track=track;_this.addClass("vjs-"+track.kind+"-menu-item");var changeHandler=function changeHandler(){for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}_this.handleTracksChange.apply(_assertThisInitialized(_this),args);};tracks.addEventListener('change',changeHandler);_this.on('dispose',function(){tracks.removeEventListener('change',changeHandler);});return _this;}var _proto=AudioTrackMenuItem.prototype;_proto.createEl=function createEl$1(type,props,attrs){var el=_MenuItem.prototype.createEl.call(this,type,props,attrs);var parentSpan=el.querySelector('.vjs-menu-item-text');if(this.options_.track.kind==='main-desc'){parentSpan.appendChild(createEl('span',{className:'vjs-icon-placeholder'},{'aria-hidden':true}));parentSpan.appendChild(createEl('span',{className:'vjs-control-text',textContent:' '+this.localize('Descriptions')}));}return el;}/**
   * This gets called when an `AudioTrackMenuItem is "clicked". See {@link ClickableComponent}
   * for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */;_proto.handleClick=function handleClick(event){_MenuItem.prototype.handleClick.call(this,event);// the audio track list will automatically toggle other tracks
// off for us.
this.track.enabled=true;// when native audio tracks are used, we want to make sure that other tracks are turned off
if(this.player_.tech_.featuresNativeAudioTracks){var tracks=this.player_.audioTracks();for(var i=0;i<tracks.length;i++){var track=tracks[i];// skip the current track since we enabled it above
if(track===this.track){continue;}track.enabled=track===this.track;}}}/**
   * Handle any {@link AudioTrack} change.
   *
   * @param {EventTarget~Event} [event]
   *        The {@link AudioTrackList#change} event that caused this to run.
   *
   * @listens AudioTrackList#change
   */;_proto.handleTracksChange=function handleTracksChange(event){this.selected(this.track.enabled);};return AudioTrackMenuItem;}(MenuItem);Component$1.registerComponent('AudioTrackMenuItem',AudioTrackMenuItem);/**
 * The base class for buttons that toggle specific {@link AudioTrack} types.
 *
 * @extends TrackButton
 */var AudioTrackButton=/*#__PURE__*/function(_TrackButton){_inheritsLoose(AudioTrackButton,_TrackButton);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */function AudioTrackButton(player,options){if(options===void 0){options={};}options.tracks=player.audioTracks();return _TrackButton.call(this,player,options)||this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */var _proto=AudioTrackButton.prototype;_proto.buildCSSClass=function buildCSSClass(){return"vjs-audio-button "+_TrackButton.prototype.buildCSSClass.call(this);};_proto.buildWrapperCSSClass=function buildWrapperCSSClass(){return"vjs-audio-button "+_TrackButton.prototype.buildWrapperCSSClass.call(this);}/**
   * Create a menu item for each audio track
   *
   * @param {AudioTrackMenuItem[]} [items=[]]
   *        An array of existing menu items to use.
   *
   * @return {AudioTrackMenuItem[]}
   *         An array of menu items
   */;_proto.createItems=function createItems(items){if(items===void 0){items=[];}// if there's only one audio track, there no point in showing it
this.hideThreshold_=1;var tracks=this.player_.audioTracks();for(var i=0;i<tracks.length;i++){var track=tracks[i];items.push(new AudioTrackMenuItem(this.player_,{track:track,// MenuItem is selectable
selectable:true,// MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
multiSelectable:false}));}return items;};return AudioTrackButton;}(TrackButton);/**
 * The text that should display over the `AudioTrackButton`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */AudioTrackButton.prototype.controlText_='Audio Track';Component$1.registerComponent('AudioTrackButton',AudioTrackButton);/**
 * The specific menu item type for selecting a playback rate.
 *
 * @extends MenuItem
 */var PlaybackRateMenuItem=/*#__PURE__*/function(_MenuItem){_inheritsLoose(PlaybackRateMenuItem,_MenuItem);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function PlaybackRateMenuItem(player,options){var _this;var label=options.rate;var rate=parseFloat(label,10);// Modify options for parent MenuItem class's init.
options.label=label;options.selected=rate===player.playbackRate();options.selectable=true;options.multiSelectable=false;_this=_MenuItem.call(this,player,options)||this;_this.label=label;_this.rate=rate;_this.on(player,'ratechange',function(e){return _this.update(e);});return _this;}/**
   * This gets called when an `PlaybackRateMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */var _proto=PlaybackRateMenuItem.prototype;_proto.handleClick=function handleClick(event){_MenuItem.prototype.handleClick.call(this);this.player().playbackRate(this.rate);}/**
   * Update the PlaybackRateMenuItem when the playbackrate changes.
   *
   * @param {EventTarget~Event} [event]
   *        The `ratechange` event that caused this function to run.
   *
   * @listens Player#ratechange
   */;_proto.update=function update(event){this.selected(this.player().playbackRate()===this.rate);};return PlaybackRateMenuItem;}(MenuItem);/**
 * The text that should display over the `PlaybackRateMenuItem`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */PlaybackRateMenuItem.prototype.contentElType='button';Component$1.registerComponent('PlaybackRateMenuItem',PlaybackRateMenuItem);/**
 * The component for controlling the playback rate.
 *
 * @extends MenuButton
 */var PlaybackRateMenuButton=/*#__PURE__*/function(_MenuButton){_inheritsLoose(PlaybackRateMenuButton,_MenuButton);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function PlaybackRateMenuButton(player,options){var _this;_this=_MenuButton.call(this,player,options)||this;_this.menuButton_.el_.setAttribute('aria-describedby',_this.labelElId_);_this.updateVisibility();_this.updateLabel();_this.on(player,'loadstart',function(e){return _this.updateVisibility(e);});_this.on(player,'ratechange',function(e){return _this.updateLabel(e);});_this.on(player,'playbackrateschange',function(e){return _this.handlePlaybackRateschange(e);});return _this;}/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=PlaybackRateMenuButton.prototype;_proto.createEl=function createEl$1(){var el=_MenuButton.prototype.createEl.call(this);this.labelElId_='vjs-playback-rate-value-label-'+this.id_;this.labelEl_=createEl('div',{className:'vjs-playback-rate-value',id:this.labelElId_,textContent:'1x'});el.appendChild(this.labelEl_);return el;};_proto.dispose=function dispose(){this.labelEl_=null;_MenuButton.prototype.dispose.call(this);}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */;_proto.buildCSSClass=function buildCSSClass(){return"vjs-playback-rate "+_MenuButton.prototype.buildCSSClass.call(this);};_proto.buildWrapperCSSClass=function buildWrapperCSSClass(){return"vjs-playback-rate "+_MenuButton.prototype.buildWrapperCSSClass.call(this);}/**
   * Create the list of menu items. Specific to each subclass.
   *
   */;_proto.createItems=function createItems(){var rates=this.playbackRates();var items=[];for(var i=rates.length-1;i>=0;i--){items.push(new PlaybackRateMenuItem(this.player(),{rate:rates[i]+'x'}));}return items;}/**
   * Updates ARIA accessibility attributes
   */;_proto.updateARIAAttributes=function updateARIAAttributes(){// Current playback rate
this.el().setAttribute('aria-valuenow',this.player().playbackRate());}/**
   * This gets called when an `PlaybackRateMenuButton` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */;_proto.handleClick=function handleClick(event){// select next rate option
var currentRate=this.player().playbackRate();var rates=this.playbackRates();var currentIndex=rates.indexOf(currentRate);// this get the next rate and it will select first one if the last one currently selected
var newIndex=(currentIndex+1)%rates.length;this.player().playbackRate(rates[newIndex]);}/**
   * On playbackrateschange, update the menu to account for the new items.
   *
   * @listens Player#playbackrateschange
   */;_proto.handlePlaybackRateschange=function handlePlaybackRateschange(event){this.update();}/**
   * Get possible playback rates
   *
   * @return {Array}
   *         All possible playback rates
   */;_proto.playbackRates=function playbackRates(){var player=this.player();return player.playbackRates&&player.playbackRates()||[];}/**
   * Get whether playback rates is supported by the tech
   * and an array of playback rates exists
   *
   * @return {boolean}
   *         Whether changing playback rate is supported
   */;_proto.playbackRateSupported=function playbackRateSupported(){return this.player().tech_&&this.player().tech_.featuresPlaybackRate&&this.playbackRates()&&this.playbackRates().length>0;}/**
   * Hide playback rate controls when they're no playback rate options to select
   *
   * @param {EventTarget~Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#loadstart
   */;_proto.updateVisibility=function updateVisibility(event){if(this.playbackRateSupported()){this.removeClass('vjs-hidden');}else{this.addClass('vjs-hidden');}}/**
   * Update button label when rate changed
   *
   * @param {EventTarget~Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#ratechange
   */;_proto.updateLabel=function updateLabel(event){if(this.playbackRateSupported()){this.labelEl_.textContent=this.player().playbackRate()+'x';}};return PlaybackRateMenuButton;}(MenuButton);/**
 * The text that should display over the `FullscreenToggle`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */PlaybackRateMenuButton.prototype.controlText_='Playback Rate';Component$1.registerComponent('PlaybackRateMenuButton',PlaybackRateMenuButton);/**
 * Just an empty spacer element that can be used as an append point for plugins, etc.
 * Also can be used to create space between elements when necessary.
 *
 * @extends Component
 */var Spacer=/*#__PURE__*/function(_Component){_inheritsLoose(Spacer,_Component);function Spacer(){return _Component.apply(this,arguments)||this;}var _proto=Spacer.prototype;/**
  * Builds the default DOM `className`.
  *
  * @return {string}
  *         The DOM `className` for this object.
  */_proto.buildCSSClass=function buildCSSClass(){return"vjs-spacer "+_Component.prototype.buildCSSClass.call(this);}/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */;_proto.createEl=function createEl(tag,props,attributes){if(tag===void 0){tag='div';}if(props===void 0){props={};}if(attributes===void 0){attributes={};}if(!props.className){props.className=this.buildCSSClass();}return _Component.prototype.createEl.call(this,tag,props,attributes);};return Spacer;}(Component$1);Component$1.registerComponent('Spacer',Spacer);/**
 * Spacer specifically meant to be used as an insertion point for new plugins, etc.
 *
 * @extends Spacer
 */var CustomControlSpacer=/*#__PURE__*/function(_Spacer){_inheritsLoose(CustomControlSpacer,_Spacer);function CustomControlSpacer(){return _Spacer.apply(this,arguments)||this;}var _proto=CustomControlSpacer.prototype;/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */_proto.buildCSSClass=function buildCSSClass(){return"vjs-custom-control-spacer "+_Spacer.prototype.buildCSSClass.call(this);}/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */;_proto.createEl=function createEl(){return _Spacer.prototype.createEl.call(this,'div',{className:this.buildCSSClass(),// No-flex/table-cell mode requires there be some content
// in the cell to fill the remaining space of the table.
textContent:"\xA0"});};return CustomControlSpacer;}(Spacer);Component$1.registerComponent('CustomControlSpacer',CustomControlSpacer);/**
 * Container of main controls.
 *
 * @extends Component
 */var ControlBar=/*#__PURE__*/function(_Component){_inheritsLoose(ControlBar,_Component);function ControlBar(){return _Component.apply(this,arguments)||this;}var _proto=ControlBar.prototype;/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */_proto.createEl=function createEl(){return _Component.prototype.createEl.call(this,'div',{className:'vjs-control-bar',dir:'ltr'});};return ControlBar;}(Component$1);/**
 * Default options for `ControlBar`
 *
 * @type {Object}
 * @private
 */ControlBar.prototype.options_={children:['playToggle','volumePanel','currentTimeDisplay','timeDivider','durationDisplay','progressControl','liveDisplay','seekToLive','remainingTimeDisplay','customControlSpacer','playbackRateMenuButton','chaptersButton','descriptionsButton','subsCapsButton','audioTrackButton','fullscreenToggle']};if('exitPictureInPicture'in (document_default())){ControlBar.prototype.options_.children.splice(ControlBar.prototype.options_.children.length-1,0,'pictureInPictureToggle');}Component$1.registerComponent('ControlBar',ControlBar);/**
 * A display that indicates an error has occurred. This means that the video
 * is unplayable.
 *
 * @extends ModalDialog
 */var ErrorDisplay=/*#__PURE__*/function(_ModalDialog){_inheritsLoose(ErrorDisplay,_ModalDialog);/**
   * Creates an instance of this class.
   *
   * @param  {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param  {Object} [options]
   *         The key/value store of player options.
   */function ErrorDisplay(player,options){var _this;_this=_ModalDialog.call(this,player,options)||this;_this.on(player,'error',function(e){return _this.open(e);});return _this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   *
   * @deprecated Since version 5.
   */var _proto=ErrorDisplay.prototype;_proto.buildCSSClass=function buildCSSClass(){return"vjs-error-display "+_ModalDialog.prototype.buildCSSClass.call(this);}/**
   * Gets the localized error message based on the `Player`s error.
   *
   * @return {string}
   *         The `Player`s error message localized or an empty string.
   */;_proto.content=function content(){var error=this.player().error();return error?this.localize(error.message):'';};return ErrorDisplay;}(ModalDialog);/**
 * The default options for an `ErrorDisplay`.
 *
 * @private
 */ErrorDisplay.prototype.options_=_extends({},ModalDialog.prototype.options_,{pauseOnOpen:false,fillAlways:true,temporary:false,uncloseable:true});Component$1.registerComponent('ErrorDisplay',ErrorDisplay);var LOCAL_STORAGE_KEY$1='vjs-text-track-settings';var COLOR_BLACK=['#000','Black'];var COLOR_BLUE=['#00F','Blue'];var COLOR_CYAN=['#0FF','Cyan'];var COLOR_GREEN=['#0F0','Green'];var COLOR_MAGENTA=['#F0F','Magenta'];var COLOR_RED=['#F00','Red'];var COLOR_WHITE=['#FFF','White'];var COLOR_YELLOW=['#FF0','Yellow'];var OPACITY_OPAQUE=['1','Opaque'];var OPACITY_SEMI=['0.5','Semi-Transparent'];var OPACITY_TRANS=['0','Transparent'];// Configuration for the various <select> elements in the DOM of this component.
//
// Possible keys include:
//
// `default`:
//   The default option index. Only needs to be provided if not zero.
// `parser`:
//   A function which is used to parse the value from the selected option in
//   a customized way.
// `selector`:
//   The selector used to find the associated <select> element.
var selectConfigs={backgroundColor:{selector:'.vjs-bg-color > select',id:'captions-background-color-%s',label:'Color',options:[COLOR_BLACK,COLOR_WHITE,COLOR_RED,COLOR_GREEN,COLOR_BLUE,COLOR_YELLOW,COLOR_MAGENTA,COLOR_CYAN]},backgroundOpacity:{selector:'.vjs-bg-opacity > select',id:'captions-background-opacity-%s',label:'Transparency',options:[OPACITY_OPAQUE,OPACITY_SEMI,OPACITY_TRANS]},color:{selector:'.vjs-fg-color > select',id:'captions-foreground-color-%s',label:'Color',options:[COLOR_WHITE,COLOR_BLACK,COLOR_RED,COLOR_GREEN,COLOR_BLUE,COLOR_YELLOW,COLOR_MAGENTA,COLOR_CYAN]},edgeStyle:{selector:'.vjs-edge-style > select',id:'%s',label:'Text Edge Style',options:[['none','None'],['raised','Raised'],['depressed','Depressed'],['uniform','Uniform'],['dropshadow','Dropshadow']]},fontFamily:{selector:'.vjs-font-family > select',id:'captions-font-family-%s',label:'Font Family',options:[['proportionalSansSerif','Proportional Sans-Serif'],['monospaceSansSerif','Monospace Sans-Serif'],['proportionalSerif','Proportional Serif'],['monospaceSerif','Monospace Serif'],['casual','Casual'],['script','Script'],['small-caps','Small Caps']]},fontPercent:{selector:'.vjs-font-percent > select',id:'captions-font-size-%s',label:'Font Size',options:[['0.50','50%'],['0.75','75%'],['1.00','100%'],['1.25','125%'],['1.50','150%'],['1.75','175%'],['2.00','200%'],['3.00','300%'],['4.00','400%']],"default":2,parser:function parser(v){return v==='1.00'?null:Number(v);}},textOpacity:{selector:'.vjs-text-opacity > select',id:'captions-foreground-opacity-%s',label:'Transparency',options:[OPACITY_OPAQUE,OPACITY_SEMI]},// Options for this object are defined below.
windowColor:{selector:'.vjs-window-color > select',id:'captions-window-color-%s',label:'Color'},// Options for this object are defined below.
windowOpacity:{selector:'.vjs-window-opacity > select',id:'captions-window-opacity-%s',label:'Transparency',options:[OPACITY_TRANS,OPACITY_SEMI,OPACITY_OPAQUE]}};selectConfigs.windowColor.options=selectConfigs.backgroundColor.options;/**
 * Get the actual value of an option.
 *
 * @param  {string} value
 *         The value to get
 *
 * @param  {Function} [parser]
 *         Optional function to adjust the value.
 *
 * @return {Mixed}
 *         - Will be `undefined` if no value exists
 *         - Will be `undefined` if the given value is "none".
 *         - Will be the actual value otherwise.
 *
 * @private
 */function parseOptionValue(value,parser){if(parser){value=parser(value);}if(value&&value!=='none'){return value;}}/**
 * Gets the value of the selected <option> element within a <select> element.
 *
 * @param  {Element} el
 *         the element to look in
 *
 * @param  {Function} [parser]
 *         Optional function to adjust the value.
 *
 * @return {Mixed}
 *         - Will be `undefined` if no value exists
 *         - Will be `undefined` if the given value is "none".
 *         - Will be the actual value otherwise.
 *
 * @private
 */function getSelectedOptionValue(el,parser){var value=el.options[el.options.selectedIndex].value;return parseOptionValue(value,parser);}/**
 * Sets the selected <option> element within a <select> element based on a
 * given value.
 *
 * @param {Element} el
 *        The element to look in.
 *
 * @param {string} value
 *        the property to look on.
 *
 * @param {Function} [parser]
 *        Optional function to adjust the value before comparing.
 *
 * @private
 */function setSelectedOption(el,value,parser){if(!value){return;}for(var i=0;i<el.options.length;i++){if(parseOptionValue(el.options[i].value,parser)===value){el.selectedIndex=i;break;}}}/**
 * Manipulate Text Tracks settings.
 *
 * @extends ModalDialog
 */var TextTrackSettings=/*#__PURE__*/function(_ModalDialog){_inheritsLoose(TextTrackSettings,_ModalDialog);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *         The key/value store of player options.
   */function TextTrackSettings(player,options){var _this;options.temporary=false;_this=_ModalDialog.call(this,player,options)||this;_this.updateDisplay=_this.updateDisplay.bind(_assertThisInitialized(_this));// fill the modal and pretend we have opened it
_this.fill();_this.hasBeenOpened_=_this.hasBeenFilled_=true;_this.endDialog=createEl('p',{className:'vjs-control-text',textContent:_this.localize('End of dialog window.')});_this.el().appendChild(_this.endDialog);_this.setDefaults();// Grab `persistTextTrackSettings` from the player options if not passed in child options
if(options.persistTextTrackSettings===undefined){_this.options_.persistTextTrackSettings=_this.options_.playerOptions.persistTextTrackSettings;}_this.on(_this.$('.vjs-done-button'),'click',function(){_this.saveSettings();_this.close();});_this.on(_this.$('.vjs-default-button'),'click',function(){_this.setDefaults();_this.updateDisplay();});each(selectConfigs,function(config){_this.on(_this.$(config.selector),'change',_this.updateDisplay);});if(_this.options_.persistTextTrackSettings){_this.restoreSettings();}return _this;}var _proto=TextTrackSettings.prototype;_proto.dispose=function dispose(){this.endDialog=null;_ModalDialog.prototype.dispose.call(this);}/**
   * Create a <select> element with configured options.
   *
   * @param {string} key
   *        Configuration key to use during creation.
   *
   * @return {string}
   *         An HTML string.
   *
   * @private
   */;_proto.createElSelect_=function createElSelect_(key,legendId,type){var _this2=this;if(legendId===void 0){legendId='';}if(type===void 0){type='label';}var config=selectConfigs[key];var id=config.id.replace('%s',this.id_);var selectLabelledbyIds=[legendId,id].join(' ').trim();return["<"+type+" id=\""+id+"\" class=\""+(type==='label'?'vjs-label':'')+"\">",this.localize(config.label),"</"+type+">","<select aria-labelledby=\""+selectLabelledbyIds+"\">"].concat(config.options.map(function(o){var optionId=id+'-'+o[1].replace(/\W+/g,'');return["<option id=\""+optionId+"\" value=\""+o[0]+"\" ","aria-labelledby=\""+selectLabelledbyIds+" "+optionId+"\">",_this2.localize(o[1]),'</option>'].join('');})).concat('</select>').join('');}/**
   * Create foreground color element for the component
   *
   * @return {string}
   *         An HTML string.
   *
   * @private
   */;_proto.createElFgColor_=function createElFgColor_(){var legendId="captions-text-legend-"+this.id_;return['<fieldset class="vjs-fg-color vjs-track-setting">',"<legend id=\""+legendId+"\">",this.localize('Text'),'</legend>',this.createElSelect_('color',legendId),'<span class="vjs-text-opacity vjs-opacity">',this.createElSelect_('textOpacity',legendId),'</span>','</fieldset>'].join('');}/**
   * Create background color element for the component
   *
   * @return {string}
   *         An HTML string.
   *
   * @private
   */;_proto.createElBgColor_=function createElBgColor_(){var legendId="captions-background-"+this.id_;return['<fieldset class="vjs-bg-color vjs-track-setting">',"<legend id=\""+legendId+"\">",this.localize('Background'),'</legend>',this.createElSelect_('backgroundColor',legendId),'<span class="vjs-bg-opacity vjs-opacity">',this.createElSelect_('backgroundOpacity',legendId),'</span>','</fieldset>'].join('');}/**
   * Create window color element for the component
   *
   * @return {string}
   *         An HTML string.
   *
   * @private
   */;_proto.createElWinColor_=function createElWinColor_(){var legendId="captions-window-"+this.id_;return['<fieldset class="vjs-window-color vjs-track-setting">',"<legend id=\""+legendId+"\">",this.localize('Window'),'</legend>',this.createElSelect_('windowColor',legendId),'<span class="vjs-window-opacity vjs-opacity">',this.createElSelect_('windowOpacity',legendId),'</span>','</fieldset>'].join('');}/**
   * Create color elements for the component
   *
   * @return {Element}
   *         The element that was created
   *
   * @private
   */;_proto.createElColors_=function createElColors_(){return createEl('div',{className:'vjs-track-settings-colors',innerHTML:[this.createElFgColor_(),this.createElBgColor_(),this.createElWinColor_()].join('')});}/**
   * Create font elements for the component
   *
   * @return {Element}
   *         The element that was created.
   *
   * @private
   */;_proto.createElFont_=function createElFont_(){return createEl('div',{className:'vjs-track-settings-font',innerHTML:['<fieldset class="vjs-font-percent vjs-track-setting">',this.createElSelect_('fontPercent','','legend'),'</fieldset>','<fieldset class="vjs-edge-style vjs-track-setting">',this.createElSelect_('edgeStyle','','legend'),'</fieldset>','<fieldset class="vjs-font-family vjs-track-setting">',this.createElSelect_('fontFamily','','legend'),'</fieldset>'].join('')});}/**
   * Create controls for the component
   *
   * @return {Element}
   *         The element that was created.
   *
   * @private
   */;_proto.createElControls_=function createElControls_(){var defaultsDescription=this.localize('restore all settings to the default values');return createEl('div',{className:'vjs-track-settings-controls',innerHTML:["<button type=\"button\" class=\"vjs-default-button\" title=\""+defaultsDescription+"\">",this.localize('Reset'),"<span class=\"vjs-control-text\"> "+defaultsDescription+"</span>",'</button>',"<button type=\"button\" class=\"vjs-done-button\">"+this.localize('Done')+"</button>"].join('')});};_proto.content=function content(){return[this.createElColors_(),this.createElFont_(),this.createElControls_()];};_proto.label=function label(){return this.localize('Caption Settings Dialog');};_proto.description=function description(){return this.localize('Beginning of dialog window. Escape will cancel and close the window.');};_proto.buildCSSClass=function buildCSSClass(){return _ModalDialog.prototype.buildCSSClass.call(this)+' vjs-text-track-settings';}/**
   * Gets an object of text track settings (or null).
   *
   * @return {Object}
   *         An object with config values parsed from the DOM or localStorage.
   */;_proto.getValues=function getValues(){var _this3=this;return reduce(selectConfigs,function(accum,config,key){var value=getSelectedOptionValue(_this3.$(config.selector),config.parser);if(value!==undefined){accum[key]=value;}return accum;},{});}/**
   * Sets text track settings from an object of values.
   *
   * @param {Object} values
   *        An object with config values parsed from the DOM or localStorage.
   */;_proto.setValues=function setValues(values){var _this4=this;each(selectConfigs,function(config,key){setSelectedOption(_this4.$(config.selector),values[key],config.parser);});}/**
   * Sets all `<select>` elements to their default values.
   */;_proto.setDefaults=function setDefaults(){var _this5=this;each(selectConfigs,function(config){var index=config.hasOwnProperty('default')?config["default"]:0;_this5.$(config.selector).selectedIndex=index;});}/**
   * Restore texttrack settings from localStorage
   */;_proto.restoreSettings=function restoreSettings(){var values;try{values=JSON.parse(window_default().localStorage.getItem(LOCAL_STORAGE_KEY$1));}catch(err){log$1.warn(err);}if(values){this.setValues(values);}}/**
   * Save text track settings to localStorage
   */;_proto.saveSettings=function saveSettings(){if(!this.options_.persistTextTrackSettings){return;}var values=this.getValues();try{if(Object.keys(values).length){window_default().localStorage.setItem(LOCAL_STORAGE_KEY$1,JSON.stringify(values));}else{window_default().localStorage.removeItem(LOCAL_STORAGE_KEY$1);}}catch(err){log$1.warn(err);}}/**
   * Update display of text track settings
   */;_proto.updateDisplay=function updateDisplay(){var ttDisplay=this.player_.getChild('textTrackDisplay');if(ttDisplay){ttDisplay.updateDisplay();}}/**
   * conditionally blur the element and refocus the captions button
   *
   * @private
   */;_proto.conditionalBlur_=function conditionalBlur_(){this.previouslyActiveEl_=null;var cb=this.player_.controlBar;var subsCapsBtn=cb&&cb.subsCapsButton;var ccBtn=cb&&cb.captionsButton;if(subsCapsBtn){subsCapsBtn.focus();}else if(ccBtn){ccBtn.focus();}};return TextTrackSettings;}(ModalDialog);Component$1.registerComponent('TextTrackSettings',TextTrackSettings);/**
 * A Resize Manager. It is in charge of triggering `playerresize` on the player in the right conditions.
 *
 * It'll either create an iframe and use a debounced resize handler on it or use the new {@link https://wicg.github.io/ResizeObserver/|ResizeObserver}.
 *
 * If the ResizeObserver is available natively, it will be used. A polyfill can be passed in as an option.
 * If a `playerresize` event is not needed, the ResizeManager component can be removed from the player, see the example below.
 * @example <caption>How to disable the resize manager</caption>
 * const player = videojs('#vid', {
 *   resizeManager: false
 * });
 *
 * @see {@link https://wicg.github.io/ResizeObserver/|ResizeObserver specification}
 *
 * @extends Component
 */var ResizeManager=/*#__PURE__*/function(_Component){_inheritsLoose(ResizeManager,_Component);/**
   * Create the ResizeManager.
   *
   * @param {Object} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of ResizeManager options.
   *
   * @param {Object} [options.ResizeObserver]
   *        A polyfill for ResizeObserver can be passed in here.
   *        If this is set to null it will ignore the native ResizeObserver and fall back to the iframe fallback.
   */function ResizeManager(player,options){var _this;var RESIZE_OBSERVER_AVAILABLE=options.ResizeObserver||(window_default()).ResizeObserver;// if `null` was passed, we want to disable the ResizeObserver
if(options.ResizeObserver===null){RESIZE_OBSERVER_AVAILABLE=false;}// Only create an element when ResizeObserver isn't available
var options_=mergeOptions$3({createEl:!RESIZE_OBSERVER_AVAILABLE,reportTouchActivity:false},options);_this=_Component.call(this,player,options_)||this;_this.ResizeObserver=options.ResizeObserver||(window_default()).ResizeObserver;_this.loadListener_=null;_this.resizeObserver_=null;_this.debouncedHandler_=debounce(function(){_this.resizeHandler();},100,false,_assertThisInitialized(_this));if(RESIZE_OBSERVER_AVAILABLE){_this.resizeObserver_=new _this.ResizeObserver(_this.debouncedHandler_);_this.resizeObserver_.observe(player.el());}else{_this.loadListener_=function(){if(!_this.el_||!_this.el_.contentWindow){return;}var debouncedHandler_=_this.debouncedHandler_;var unloadListener_=_this.unloadListener_=function(){off(this,'resize',debouncedHandler_);off(this,'unload',unloadListener_);unloadListener_=null;};// safari and edge can unload the iframe before resizemanager dispose
// we have to dispose of event handlers correctly before that happens
on(_this.el_.contentWindow,'unload',unloadListener_);on(_this.el_.contentWindow,'resize',debouncedHandler_);};_this.one('load',_this.loadListener_);}return _this;}var _proto=ResizeManager.prototype;_proto.createEl=function createEl(){return _Component.prototype.createEl.call(this,'iframe',{className:'vjs-resize-manager',tabIndex:-1,title:this.localize('No content')},{'aria-hidden':'true'});}/**
   * Called when a resize is triggered on the iframe or a resize is observed via the ResizeObserver
   *
   * @fires Player#playerresize
   */;_proto.resizeHandler=function resizeHandler(){/**
     * Called when the player size has changed
     *
     * @event Player#playerresize
     * @type {EventTarget~Event}
     */ // make sure player is still around to trigger
// prevents this from causing an error after dispose
if(!this.player_||!this.player_.trigger){return;}this.player_.trigger('playerresize');};_proto.dispose=function dispose(){if(this.debouncedHandler_){this.debouncedHandler_.cancel();}if(this.resizeObserver_){if(this.player_.el()){this.resizeObserver_.unobserve(this.player_.el());}this.resizeObserver_.disconnect();}if(this.loadListener_){this.off('load',this.loadListener_);}if(this.el_&&this.el_.contentWindow&&this.unloadListener_){this.unloadListener_.call(this.el_.contentWindow);}this.ResizeObserver=null;this.resizeObserver=null;this.debouncedHandler_=null;this.loadListener_=null;_Component.prototype.dispose.call(this);};return ResizeManager;}(Component$1);Component$1.registerComponent('ResizeManager',ResizeManager);var defaults={trackingThreshold:20,liveTolerance:15};/*
  track when we are at the live edge, and other helpers for live playback */ /**
 * A class for checking live current time and determining when the player
 * is at or behind the live edge.
 */var LiveTracker=/*#__PURE__*/function(_Component){_inheritsLoose(LiveTracker,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {number} [options.trackingThreshold=20]
   *        Number of seconds of live window (seekableEnd - seekableStart) that
   *        media needs to have before the liveui will be shown.
   *
   * @param {number} [options.liveTolerance=15]
   *        Number of seconds behind live that we have to be
   *        before we will be considered non-live. Note that this will only
   *        be used when playing at the live edge. This allows large seekable end
   *        changes to not effect wether we are live or not.
   */function LiveTracker(player,options){var _this;// LiveTracker does not need an element
var options_=mergeOptions$3(defaults,options,{createEl:false});_this=_Component.call(this,player,options_)||this;_this.handleVisibilityChange_=function(e){return _this.handleVisibilityChange(e);};_this.trackLiveHandler_=function(){return _this.trackLive_();};_this.handlePlay_=function(e){return _this.handlePlay(e);};_this.handleFirstTimeupdate_=function(e){return _this.handleFirstTimeupdate(e);};_this.handleSeeked_=function(e){return _this.handleSeeked(e);};_this.seekToLiveEdge_=function(e){return _this.seekToLiveEdge(e);};_this.reset_();_this.on(_this.player_,'durationchange',function(e){return _this.handleDurationchange(e);});// we should try to toggle tracking on canplay as native playback engines, like Safari
// may not have the proper values for things like seekableEnd until then
_this.on(_this.player_,'canplay',function(){return _this.toggleTracking();});// we don't need to track live playback if the document is hidden,
// also, tracking when the document is hidden can
// cause the CPU to spike and eventually crash the page on IE11.
if(IE_VERSION&&'hidden'in (document_default())&&'visibilityState'in (document_default())){_this.on((document_default()),'visibilitychange',_this.handleVisibilityChange_);}return _this;}/**
   * toggle tracking based on document visiblility
   */var _proto=LiveTracker.prototype;_proto.handleVisibilityChange=function handleVisibilityChange(){if(this.player_.duration()!==Infinity){return;}if((document_default()).hidden){this.stopTracking();}else{this.startTracking();}}/**
   * all the functionality for tracking when seek end changes
   * and for tracking how far past seek end we should be
   */;_proto.trackLive_=function trackLive_(){var seekable=this.player_.seekable();// skip undefined seekable
if(!seekable||!seekable.length){return;}var newTime=Number(window_default().performance.now().toFixed(4));var deltaTime=this.lastTime_===-1?0:(newTime-this.lastTime_)/1000;this.lastTime_=newTime;this.pastSeekEnd_=this.pastSeekEnd()+deltaTime;var liveCurrentTime=this.liveCurrentTime();var currentTime=this.player_.currentTime();// we are behind live if any are true
// 1. the player is paused
// 2. the user seeked to a location 2 seconds away from live
// 3. the difference between live and current time is greater
//    liveTolerance which defaults to 15s
var isBehind=this.player_.paused()||this.seekedBehindLive_||Math.abs(liveCurrentTime-currentTime)>this.options_.liveTolerance;// we cannot be behind if
// 1. until we have not seen a timeupdate yet
// 2. liveCurrentTime is Infinity, which happens on Android and Native Safari
if(!this.timeupdateSeen_||liveCurrentTime===Infinity){isBehind=false;}if(isBehind!==this.behindLiveEdge_){this.behindLiveEdge_=isBehind;this.trigger('liveedgechange');}}/**
   * handle a durationchange event on the player
   * and start/stop tracking accordingly.
   */;_proto.handleDurationchange=function handleDurationchange(){this.toggleTracking();}/**
   * start/stop tracking
   */;_proto.toggleTracking=function toggleTracking(){if(this.player_.duration()===Infinity&&this.liveWindow()>=this.options_.trackingThreshold){if(this.player_.options_.liveui){this.player_.addClass('vjs-liveui');}this.startTracking();}else{this.player_.removeClass('vjs-liveui');this.stopTracking();}}/**
   * start tracking live playback
   */;_proto.startTracking=function startTracking(){if(this.isTracking()){return;}// If we haven't seen a timeupdate, we need to check whether playback
// began before this component started tracking. This can happen commonly
// when using autoplay.
if(!this.timeupdateSeen_){this.timeupdateSeen_=this.player_.hasStarted();}this.trackingInterval_=this.setInterval(this.trackLiveHandler_,UPDATE_REFRESH_INTERVAL);this.trackLive_();this.on(this.player_,['play','pause'],this.trackLiveHandler_);if(!this.timeupdateSeen_){this.one(this.player_,'play',this.handlePlay_);this.one(this.player_,'timeupdate',this.handleFirstTimeupdate_);}else{this.on(this.player_,'seeked',this.handleSeeked_);}}/**
   * handle the first timeupdate on the player if it wasn't already playing
   * when live tracker started tracking.
   */;_proto.handleFirstTimeupdate=function handleFirstTimeupdate(){this.timeupdateSeen_=true;this.on(this.player_,'seeked',this.handleSeeked_);}/**
   * Keep track of what time a seek starts, and listen for seeked
   * to find where a seek ends.
   */;_proto.handleSeeked=function handleSeeked(){var timeDiff=Math.abs(this.liveCurrentTime()-this.player_.currentTime());this.seekedBehindLive_=this.nextSeekedFromUser_&&timeDiff>2;this.nextSeekedFromUser_=false;this.trackLive_();}/**
   * handle the first play on the player, and make sure that we seek
   * right to the live edge.
   */;_proto.handlePlay=function handlePlay(){this.one(this.player_,'timeupdate',this.seekToLiveEdge_);}/**
   * Stop tracking, and set all internal variables to
   * their initial value.
   */;_proto.reset_=function reset_(){this.lastTime_=-1;this.pastSeekEnd_=0;this.lastSeekEnd_=-1;this.behindLiveEdge_=true;this.timeupdateSeen_=false;this.seekedBehindLive_=false;this.nextSeekedFromUser_=false;this.clearInterval(this.trackingInterval_);this.trackingInterval_=null;this.off(this.player_,['play','pause'],this.trackLiveHandler_);this.off(this.player_,'seeked',this.handleSeeked_);this.off(this.player_,'play',this.handlePlay_);this.off(this.player_,'timeupdate',this.handleFirstTimeupdate_);this.off(this.player_,'timeupdate',this.seekToLiveEdge_);}/**
   * The next seeked event is from the user. Meaning that any seek
   * > 2s behind live will be considered behind live for real and
   * liveTolerance will be ignored.
   */;_proto.nextSeekedFromUser=function nextSeekedFromUser(){this.nextSeekedFromUser_=true;}/**
   * stop tracking live playback
   */;_proto.stopTracking=function stopTracking(){if(!this.isTracking()){return;}this.reset_();this.trigger('liveedgechange');}/**
   * A helper to get the player seekable end
   * so that we don't have to null check everywhere
   *
   * @return {number}
   *         The furthest seekable end or Infinity.
   */;_proto.seekableEnd=function seekableEnd(){var seekable=this.player_.seekable();var seekableEnds=[];var i=seekable?seekable.length:0;while(i--){seekableEnds.push(seekable.end(i));}// grab the furthest seekable end after sorting, or if there are none
// default to Infinity
return seekableEnds.length?seekableEnds.sort()[seekableEnds.length-1]:Infinity;}/**
   * A helper to get the player seekable start
   * so that we don't have to null check everywhere
   *
   * @return {number}
   *         The earliest seekable start or 0.
   */;_proto.seekableStart=function seekableStart(){var seekable=this.player_.seekable();var seekableStarts=[];var i=seekable?seekable.length:0;while(i--){seekableStarts.push(seekable.start(i));}// grab the first seekable start after sorting, or if there are none
// default to 0
return seekableStarts.length?seekableStarts.sort()[0]:0;}/**
   * Get the live time window aka
   * the amount of time between seekable start and
   * live current time.
   *
   * @return {number}
   *         The amount of seconds that are seekable in
   *         the live video.
   */;_proto.liveWindow=function liveWindow(){var liveCurrentTime=this.liveCurrentTime();// if liveCurrenTime is Infinity then we don't have a liveWindow at all
if(liveCurrentTime===Infinity){return 0;}return liveCurrentTime-this.seekableStart();}/**
   * Determines if the player is live, only checks if this component
   * is tracking live playback or not
   *
   * @return {boolean}
   *         Wether liveTracker is tracking
   */;_proto.isLive=function isLive(){return this.isTracking();}/**
   * Determines if currentTime is at the live edge and won't fall behind
   * on each seekableendchange
   *
   * @return {boolean}
   *         Wether playback is at the live edge
   */;_proto.atLiveEdge=function atLiveEdge(){return!this.behindLiveEdge();}/**
   * get what we expect the live current time to be
   *
   * @return {number}
   *         The expected live current time
   */;_proto.liveCurrentTime=function liveCurrentTime(){return this.pastSeekEnd()+this.seekableEnd();}/**
   * The number of seconds that have occured after seekable end
   * changed. This will be reset to 0 once seekable end changes.
   *
   * @return {number}
   *         Seconds past the current seekable end
   */;_proto.pastSeekEnd=function pastSeekEnd(){var seekableEnd=this.seekableEnd();if(this.lastSeekEnd_!==-1&&seekableEnd!==this.lastSeekEnd_){this.pastSeekEnd_=0;}this.lastSeekEnd_=seekableEnd;return this.pastSeekEnd_;}/**
   * If we are currently behind the live edge, aka currentTime will be
   * behind on a seekableendchange
   *
   * @return {boolean}
   *         If we are behind the live edge
   */;_proto.behindLiveEdge=function behindLiveEdge(){return this.behindLiveEdge_;}/**
   * Wether live tracker is currently tracking or not.
   */;_proto.isTracking=function isTracking(){return typeof this.trackingInterval_==='number';}/**
   * Seek to the live edge if we are behind the live edge
   */;_proto.seekToLiveEdge=function seekToLiveEdge(){this.seekedBehindLive_=false;if(this.atLiveEdge()){return;}this.nextSeekedFromUser_=false;this.player_.currentTime(this.liveCurrentTime());}/**
   * Dispose of liveTracker
   */;_proto.dispose=function dispose(){this.off((document_default()),'visibilitychange',this.handleVisibilityChange_);this.stopTracking();_Component.prototype.dispose.call(this);};return LiveTracker;}(Component$1);Component$1.registerComponent('LiveTracker',LiveTracker);/**
 * This function is used to fire a sourceset when there is something
 * similar to `mediaEl.load()` being called. It will try to find the source via
 * the `src` attribute and then the `<source>` elements. It will then fire `sourceset`
 * with the source that was found or empty string if we cannot know. If it cannot
 * find a source then `sourceset` will not be fired.
 *
 * @param {Html5} tech
 *        The tech object that sourceset was setup on
 *
 * @return {boolean}
 *         returns false if the sourceset was not fired and true otherwise.
 */var sourcesetLoad=function sourcesetLoad(tech){var el=tech.el();// if `el.src` is set, that source will be loaded.
if(el.hasAttribute('src')){tech.triggerSourceset(el.src);return true;}/**
   * Since there isn't a src property on the media element, source elements will be used for
   * implementing the source selection algorithm. This happens asynchronously and
   * for most cases were there is more than one source we cannot tell what source will
   * be loaded, without re-implementing the source selection algorithm. At this time we are not
   * going to do that. There are three special cases that we do handle here though:
   *
   * 1. If there are no sources, do not fire `sourceset`.
   * 2. If there is only one `<source>` with a `src` property/attribute that is our `src`
   * 3. If there is more than one `<source>` but all of them have the same `src` url.
   *    That will be our src.
   */var sources=tech.$$('source');var srcUrls=[];var src='';// if there are no sources, do not fire sourceset
if(!sources.length){return false;}// only count valid/non-duplicate source elements
for(var i=0;i<sources.length;i++){var url=sources[i].src;if(url&&srcUrls.indexOf(url)===-1){srcUrls.push(url);}}// there were no valid sources
if(!srcUrls.length){return false;}// there is only one valid source element url
// use that
if(srcUrls.length===1){src=srcUrls[0];}tech.triggerSourceset(src);return true;};/**
 * our implementation of an `innerHTML` descriptor for browsers
 * that do not have one.
 */var innerHTMLDescriptorPolyfill=Object.defineProperty({},'innerHTML',{get:function get(){return this.cloneNode(true).innerHTML;},set:function set(v){// make a dummy node to use innerHTML on
var dummy=document_default().createElement(this.nodeName.toLowerCase());// set innerHTML to the value provided
dummy.innerHTML=v;// make a document fragment to hold the nodes from dummy
var docFrag=document_default().createDocumentFragment();// copy all of the nodes created by the innerHTML on dummy
// to the document fragment
while(dummy.childNodes.length){docFrag.appendChild(dummy.childNodes[0]);}// remove content
this.innerText='';// now we add all of that html in one by appending the
// document fragment. This is how innerHTML does it.
window_default().Element.prototype.appendChild.call(this,docFrag);// then return the result that innerHTML's setter would
return this.innerHTML;}});/**
 * Get a property descriptor given a list of priorities and the
 * property to get.
 */var getDescriptor=function getDescriptor(priority,prop){var descriptor={};for(var i=0;i<priority.length;i++){descriptor=Object.getOwnPropertyDescriptor(priority[i],prop);if(descriptor&&descriptor.set&&descriptor.get){break;}}descriptor.enumerable=true;descriptor.configurable=true;return descriptor;};var getInnerHTMLDescriptor=function getInnerHTMLDescriptor(tech){return getDescriptor([tech.el(),(window_default()).HTMLMediaElement.prototype,(window_default()).Element.prototype,innerHTMLDescriptorPolyfill],'innerHTML');};/**
 * Patches browser internal functions so that we can tell synchronously
 * if a `<source>` was appended to the media element. For some reason this
 * causes a `sourceset` if the the media element is ready and has no source.
 * This happens when:
 * - The page has just loaded and the media element does not have a source.
 * - The media element was emptied of all sources, then `load()` was called.
 *
 * It does this by patching the following functions/properties when they are supported:
 *
 * - `append()` - can be used to add a `<source>` element to the media element
 * - `appendChild()` - can be used to add a `<source>` element to the media element
 * - `insertAdjacentHTML()` -  can be used to add a `<source>` element to the media element
 * - `innerHTML` -  can be used to add a `<source>` element to the media element
 *
 * @param {Html5} tech
 *        The tech object that sourceset is being setup on.
 */var firstSourceWatch=function firstSourceWatch(tech){var el=tech.el();// make sure firstSourceWatch isn't setup twice.
if(el.resetSourceWatch_){return;}var old={};var innerDescriptor=getInnerHTMLDescriptor(tech);var appendWrapper=function appendWrapper(appendFn){return function(){for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}var retval=appendFn.apply(el,args);sourcesetLoad(tech);return retval;};};['append','appendChild','insertAdjacentHTML'].forEach(function(k){if(!el[k]){return;}// store the old function
old[k]=el[k];// call the old function with a sourceset if a source
// was loaded
el[k]=appendWrapper(old[k]);});Object.defineProperty(el,'innerHTML',mergeOptions$3(innerDescriptor,{set:appendWrapper(innerDescriptor.set)}));el.resetSourceWatch_=function(){el.resetSourceWatch_=null;Object.keys(old).forEach(function(k){el[k]=old[k];});Object.defineProperty(el,'innerHTML',innerDescriptor);};// on the first sourceset, we need to revert our changes
tech.one('sourceset',el.resetSourceWatch_);};/**
 * our implementation of a `src` descriptor for browsers
 * that do not have one.
 */var srcDescriptorPolyfill=Object.defineProperty({},'src',{get:function get(){if(this.hasAttribute('src')){return getAbsoluteURL(window_default().Element.prototype.getAttribute.call(this,'src'));}return'';},set:function set(v){window_default().Element.prototype.setAttribute.call(this,'src',v);return v;}});var getSrcDescriptor=function getSrcDescriptor(tech){return getDescriptor([tech.el(),(window_default()).HTMLMediaElement.prototype,srcDescriptorPolyfill],'src');};/**
 * setup `sourceset` handling on the `Html5` tech. This function
 * patches the following element properties/functions:
 *
 * - `src` - to determine when `src` is set
 * - `setAttribute()` - to determine when `src` is set
 * - `load()` - this re-triggers the source selection algorithm, and can
 *              cause a sourceset.
 *
 * If there is no source when we are adding `sourceset` support or during a `load()`
 * we also patch the functions listed in `firstSourceWatch`.
 *
 * @param {Html5} tech
 *        The tech to patch
 */var setupSourceset=function setupSourceset(tech){if(!tech.featuresSourceset){return;}var el=tech.el();// make sure sourceset isn't setup twice.
if(el.resetSourceset_){return;}var srcDescriptor=getSrcDescriptor(tech);var oldSetAttribute=el.setAttribute;var oldLoad=el.load;Object.defineProperty(el,'src',mergeOptions$3(srcDescriptor,{set:function set(v){var retval=srcDescriptor.set.call(el,v);// we use the getter here to get the actual value set on src
tech.triggerSourceset(el.src);return retval;}}));el.setAttribute=function(n,v){var retval=oldSetAttribute.call(el,n,v);if(/src/i.test(n)){tech.triggerSourceset(el.src);}return retval;};el.load=function(){var retval=oldLoad.call(el);// if load was called, but there was no source to fire
// sourceset on. We have to watch for a source append
// as that can trigger a `sourceset` when the media element
// has no source
if(!sourcesetLoad(tech)){tech.triggerSourceset('');firstSourceWatch(tech);}return retval;};if(el.currentSrc){tech.triggerSourceset(el.currentSrc);}else if(!sourcesetLoad(tech)){firstSourceWatch(tech);}el.resetSourceset_=function(){el.resetSourceset_=null;el.load=oldLoad;el.setAttribute=oldSetAttribute;Object.defineProperty(el,'src',srcDescriptor);if(el.resetSourceWatch_){el.resetSourceWatch_();}};};/**
 * Object.defineProperty but "lazy", which means that the value is only set after
 * it retrieved the first time, rather than being set right away.
 *
 * @param {Object} obj the object to set the property on
 * @param {string} key the key for the property to set
 * @param {Function} getValue the function used to get the value when it is needed.
 * @param {boolean} setter wether a setter shoould be allowed or not
 */var defineLazyProperty=function defineLazyProperty(obj,key,getValue,setter){if(setter===void 0){setter=true;}var set=function set(value){return Object.defineProperty(obj,key,{value:value,enumerable:true,writable:true});};var options={configurable:true,enumerable:true,get:function get(){var value=getValue();set(value);return value;}};if(setter){options.set=set;}return Object.defineProperty(obj,key,options);};/**
 * HTML5 Media Controller - Wrapper for HTML5 Media API
 *
 * @mixes Tech~SourceHandlerAdditions
 * @extends Tech
 */var Html5=/*#__PURE__*/function(_Tech){_inheritsLoose(Html5,_Tech);/**
  * Create an instance of this Tech.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  *
  * @param {Component~ReadyCallback} ready
  *        Callback function to call when the `HTML5` Tech is ready.
  */function Html5(options,ready){var _this;_this=_Tech.call(this,options,ready)||this;var source=options.source;var crossoriginTracks=false;_this.featuresVideoFrameCallback=_this.featuresVideoFrameCallback&&_this.el_.tagName==='VIDEO';// Set the source if one is provided
// 1) Check if the source is new (if not, we want to keep the original so playback isn't interrupted)
// 2) Check to see if the network state of the tag was failed at init, and if so, reset the source
// anyway so the error gets fired.
if(source&&(_this.el_.currentSrc!==source.src||options.tag&&options.tag.initNetworkState_===3)){_this.setSource(source);}else{_this.handleLateInit_(_this.el_);}// setup sourceset after late sourceset/init
if(options.enableSourceset){_this.setupSourcesetHandling_();}_this.isScrubbing_=false;if(_this.el_.hasChildNodes()){var nodes=_this.el_.childNodes;var nodesLength=nodes.length;var removeNodes=[];while(nodesLength--){var node=nodes[nodesLength];var nodeName=node.nodeName.toLowerCase();if(nodeName==='track'){if(!_this.featuresNativeTextTracks){// Empty video tag tracks so the built-in player doesn't use them also.
// This may not be fast enough to stop HTML5 browsers from reading the tags
// so we'll need to turn off any default tracks if we're manually doing
// captions and subtitles. videoElement.textTracks
removeNodes.push(node);}else{// store HTMLTrackElement and TextTrack to remote list
_this.remoteTextTrackEls().addTrackElement_(node);_this.remoteTextTracks().addTrack(node.track);_this.textTracks().addTrack(node.track);if(!crossoriginTracks&&!_this.el_.hasAttribute('crossorigin')&&isCrossOrigin(node.src)){crossoriginTracks=true;}}}}for(var i=0;i<removeNodes.length;i++){_this.el_.removeChild(removeNodes[i]);}}_this.proxyNativeTracks_();if(_this.featuresNativeTextTracks&&crossoriginTracks){log$1.warn('Text Tracks are being loaded from another origin but the crossorigin attribute isn\'t used.\n'+'This may prevent text tracks from loading.');}// prevent iOS Safari from disabling metadata text tracks during native playback
_this.restoreMetadataTracksInIOSNativePlayer_();// Determine if native controls should be used
// Our goal should be to get the custom controls on mobile solid everywhere
// so we can remove this all together. Right now this will block custom
// controls on touch enabled laptops like the Chrome Pixel
if((TOUCH_ENABLED||IS_IPHONE||IS_NATIVE_ANDROID)&&options.nativeControlsForTouch===true){_this.setControls(true);}// on iOS, we want to proxy `webkitbeginfullscreen` and `webkitendfullscreen`
// into a `fullscreenchange` event
_this.proxyWebkitFullscreen_();_this.triggerReady();return _this;}/**
   * Dispose of `HTML5` media element and remove all tracks.
   */var _proto=Html5.prototype;_proto.dispose=function dispose(){if(this.el_&&this.el_.resetSourceset_){this.el_.resetSourceset_();}Html5.disposeMediaElement(this.el_);this.options_=null;// tech will handle clearing of the emulated track list
_Tech.prototype.dispose.call(this);}/**
   * Modify the media element so that we can detect when
   * the source is changed. Fires `sourceset` just after the source has changed
   */;_proto.setupSourcesetHandling_=function setupSourcesetHandling_(){setupSourceset(this);}/**
   * When a captions track is enabled in the iOS Safari native player, all other
   * tracks are disabled (including metadata tracks), which nulls all of their
   * associated cue points. This will restore metadata tracks to their pre-fullscreen
   * state in those cases so that cue points are not needlessly lost.
   *
   * @private
   */;_proto.restoreMetadataTracksInIOSNativePlayer_=function restoreMetadataTracksInIOSNativePlayer_(){var textTracks=this.textTracks();var metadataTracksPreFullscreenState;// captures a snapshot of every metadata track's current state
var takeMetadataTrackSnapshot=function takeMetadataTrackSnapshot(){metadataTracksPreFullscreenState=[];for(var i=0;i<textTracks.length;i++){var track=textTracks[i];if(track.kind==='metadata'){metadataTracksPreFullscreenState.push({track:track,storedMode:track.mode});}}};// snapshot each metadata track's initial state, and update the snapshot
// each time there is a track 'change' event
takeMetadataTrackSnapshot();textTracks.addEventListener('change',takeMetadataTrackSnapshot);this.on('dispose',function(){return textTracks.removeEventListener('change',takeMetadataTrackSnapshot);});var restoreTrackMode=function restoreTrackMode(){for(var i=0;i<metadataTracksPreFullscreenState.length;i++){var storedTrack=metadataTracksPreFullscreenState[i];if(storedTrack.track.mode==='disabled'&&storedTrack.track.mode!==storedTrack.storedMode){storedTrack.track.mode=storedTrack.storedMode;}}// we only want this handler to be executed on the first 'change' event
textTracks.removeEventListener('change',restoreTrackMode);};// when we enter fullscreen playback, stop updating the snapshot and
// restore all track modes to their pre-fullscreen state
this.on('webkitbeginfullscreen',function(){textTracks.removeEventListener('change',takeMetadataTrackSnapshot);// remove the listener before adding it just in case it wasn't previously removed
textTracks.removeEventListener('change',restoreTrackMode);textTracks.addEventListener('change',restoreTrackMode);});// start updating the snapshot again after leaving fullscreen
this.on('webkitendfullscreen',function(){// remove the listener before adding it just in case it wasn't previously removed
textTracks.removeEventListener('change',takeMetadataTrackSnapshot);textTracks.addEventListener('change',takeMetadataTrackSnapshot);// remove the restoreTrackMode handler in case it wasn't triggered during fullscreen playback
textTracks.removeEventListener('change',restoreTrackMode);});}/**
   * Attempt to force override of tracks for the given type
   *
   * @param {string} type - Track type to override, possible values include 'Audio',
   * 'Video', and 'Text'.
   * @param {boolean} override - If set to true native audio/video will be overridden,
   * otherwise native audio/video will potentially be used.
   * @private
   */;_proto.overrideNative_=function overrideNative_(type,override){var _this2=this;// If there is no behavioral change don't add/remove listeners
if(override!==this["featuresNative"+type+"Tracks"]){return;}var lowerCaseType=type.toLowerCase();if(this[lowerCaseType+"TracksListeners_"]){Object.keys(this[lowerCaseType+"TracksListeners_"]).forEach(function(eventName){var elTracks=_this2.el()[lowerCaseType+"Tracks"];elTracks.removeEventListener(eventName,_this2[lowerCaseType+"TracksListeners_"][eventName]);});}this["featuresNative"+type+"Tracks"]=!override;this[lowerCaseType+"TracksListeners_"]=null;this.proxyNativeTracksForType_(lowerCaseType);}/**
   * Attempt to force override of native audio tracks.
   *
   * @param {boolean} override - If set to true native audio will be overridden,
   * otherwise native audio will potentially be used.
   */;_proto.overrideNativeAudioTracks=function overrideNativeAudioTracks(override){this.overrideNative_('Audio',override);}/**
   * Attempt to force override of native video tracks.
   *
   * @param {boolean} override - If set to true native video will be overridden,
   * otherwise native video will potentially be used.
   */;_proto.overrideNativeVideoTracks=function overrideNativeVideoTracks(override){this.overrideNative_('Video',override);}/**
   * Proxy native track list events for the given type to our track
   * lists if the browser we are playing in supports that type of track list.
   *
   * @param {string} name - Track type; values include 'audio', 'video', and 'text'
   * @private
   */;_proto.proxyNativeTracksForType_=function proxyNativeTracksForType_(name){var _this3=this;var props=NORMAL[name];var elTracks=this.el()[props.getterName];var techTracks=this[props.getterName]();if(!this["featuresNative"+props.capitalName+"Tracks"]||!elTracks||!elTracks.addEventListener){return;}var listeners={change:function change(e){var event={type:'change',target:techTracks,currentTarget:techTracks,srcElement:techTracks};techTracks.trigger(event);// if we are a text track change event, we should also notify the
// remote text track list. This can potentially cause a false positive
// if we were to get a change event on a non-remote track and
// we triggered the event on the remote text track list which doesn't
// contain that track. However, best practices mean looping through the
// list of tracks and searching for the appropriate mode value, so,
// this shouldn't pose an issue
if(name==='text'){_this3[REMOTE.remoteText.getterName]().trigger(event);}},addtrack:function addtrack(e){techTracks.addTrack(e.track);},removetrack:function removetrack(e){techTracks.removeTrack(e.track);}};var removeOldTracks=function removeOldTracks(){var removeTracks=[];for(var i=0;i<techTracks.length;i++){var found=false;for(var j=0;j<elTracks.length;j++){if(elTracks[j]===techTracks[i]){found=true;break;}}if(!found){removeTracks.push(techTracks[i]);}}while(removeTracks.length){techTracks.removeTrack(removeTracks.shift());}};this[props.getterName+'Listeners_']=listeners;Object.keys(listeners).forEach(function(eventName){var listener=listeners[eventName];elTracks.addEventListener(eventName,listener);_this3.on('dispose',function(e){return elTracks.removeEventListener(eventName,listener);});});// Remove (native) tracks that are not used anymore
this.on('loadstart',removeOldTracks);this.on('dispose',function(e){return _this3.off('loadstart',removeOldTracks);});}/**
   * Proxy all native track list events to our track lists if the browser we are playing
   * in supports that type of track list.
   *
   * @private
   */;_proto.proxyNativeTracks_=function proxyNativeTracks_(){var _this4=this;NORMAL.names.forEach(function(name){_this4.proxyNativeTracksForType_(name);});}/**
   * Create the `Html5` Tech's DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */;_proto.createEl=function createEl(){var el=this.options_.tag;// Check if this browser supports moving the element into the box.
// On the iPhone video will break if you move the element,
// So we have to create a brand new element.
// If we ingested the player div, we do not need to move the media element.
if(!el||!(this.options_.playerElIngest||this.movingMediaElementInDOM)){// If the original tag is still there, clone and remove it.
if(el){var clone=el.cloneNode(true);if(el.parentNode){el.parentNode.insertBefore(clone,el);}Html5.disposeMediaElement(el);el=clone;}else{el=document_default().createElement('video');// determine if native controls should be used
var tagAttributes=this.options_.tag&&getAttributes(this.options_.tag);var attributes=mergeOptions$3({},tagAttributes);if(!TOUCH_ENABLED||this.options_.nativeControlsForTouch!==true){delete attributes.controls;}setAttributes(el,video_es_assign(attributes,{id:this.options_.techId,"class":'vjs-tech'}));}el.playerId=this.options_.playerId;}if(typeof this.options_.preload!=='undefined'){setAttribute(el,'preload',this.options_.preload);}if(this.options_.disablePictureInPicture!==undefined){el.disablePictureInPicture=this.options_.disablePictureInPicture;}// Update specific tag settings, in case they were overridden
// `autoplay` has to be *last* so that `muted` and `playsinline` are present
// when iOS/Safari or other browsers attempt to autoplay.
var settingsAttrs=['loop','muted','playsinline','autoplay'];for(var i=0;i<settingsAttrs.length;i++){var attr=settingsAttrs[i];var value=this.options_[attr];if(typeof value!=='undefined'){if(value){setAttribute(el,attr,attr);}else{removeAttribute(el,attr);}el[attr]=value;}}return el;}/**
   * This will be triggered if the loadstart event has already fired, before videojs was
   * ready. Two known examples of when this can happen are:
   * 1. If we're loading the playback object after it has started loading
   * 2. The media is already playing the (often with autoplay on) then
   *
   * This function will fire another loadstart so that videojs can catchup.
   *
   * @fires Tech#loadstart
   *
   * @return {undefined}
   *         returns nothing.
   */;_proto.handleLateInit_=function handleLateInit_(el){if(el.networkState===0||el.networkState===3){// The video element hasn't started loading the source yet
// or didn't find a source
return;}if(el.readyState===0){// NetworkState is set synchronously BUT loadstart is fired at the
// end of the current stack, usually before setInterval(fn, 0).
// So at this point we know loadstart may have already fired or is
// about to fire, and either way the player hasn't seen it yet.
// We don't want to fire loadstart prematurely here and cause a
// double loadstart so we'll wait and see if it happens between now
// and the next loop, and fire it if not.
// HOWEVER, we also want to make sure it fires before loadedmetadata
// which could also happen between now and the next loop, so we'll
// watch for that also.
var loadstartFired=false;var setLoadstartFired=function setLoadstartFired(){loadstartFired=true;};this.on('loadstart',setLoadstartFired);var triggerLoadstart=function triggerLoadstart(){// We did miss the original loadstart. Make sure the player
// sees loadstart before loadedmetadata
if(!loadstartFired){this.trigger('loadstart');}};this.on('loadedmetadata',triggerLoadstart);this.ready(function(){this.off('loadstart',setLoadstartFired);this.off('loadedmetadata',triggerLoadstart);if(!loadstartFired){// We did miss the original native loadstart. Fire it now.
this.trigger('loadstart');}});return;}// From here on we know that loadstart already fired and we missed it.
// The other readyState events aren't as much of a problem if we double
// them, so not going to go to as much trouble as loadstart to prevent
// that unless we find reason to.
var eventsToTrigger=['loadstart'];// loadedmetadata: newly equal to HAVE_METADATA (1) or greater
eventsToTrigger.push('loadedmetadata');// loadeddata: newly increased to HAVE_CURRENT_DATA (2) or greater
if(el.readyState>=2){eventsToTrigger.push('loadeddata');}// canplay: newly increased to HAVE_FUTURE_DATA (3) or greater
if(el.readyState>=3){eventsToTrigger.push('canplay');}// canplaythrough: newly equal to HAVE_ENOUGH_DATA (4)
if(el.readyState>=4){eventsToTrigger.push('canplaythrough');}// We still need to give the player time to add event listeners
this.ready(function(){eventsToTrigger.forEach(function(type){this.trigger(type);},this);});}/**
   * Set whether we are scrubbing or not.
   * This is used to decide whether we should use `fastSeek` or not.
   * `fastSeek` is used to provide trick play on Safari browsers.
   *
   * @param {boolean} isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   */;_proto.setScrubbing=function setScrubbing(isScrubbing){this.isScrubbing_=isScrubbing;}/**
   * Get whether we are scrubbing or not.
   *
   * @return {boolean} isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   */;_proto.scrubbing=function scrubbing(){return this.isScrubbing_;}/**
   * Set current time for the `HTML5` tech.
   *
   * @param {number} seconds
   *        Set the current time of the media to this.
   */;_proto.setCurrentTime=function setCurrentTime(seconds){try{if(this.isScrubbing_&&this.el_.fastSeek&&IS_ANY_SAFARI){this.el_.fastSeek(seconds);}else{this.el_.currentTime=seconds;}}catch(e){log$1(e,'Video is not ready. (Video.js)');// this.warning(VideoJS.warnings.videoNotReady);
}}/**
   * Get the current duration of the HTML5 media element.
   *
   * @return {number}
   *         The duration of the media or 0 if there is no duration.
   */;_proto.duration=function duration(){var _this5=this;// Android Chrome will report duration as Infinity for VOD HLS until after
// playback has started, which triggers the live display erroneously.
// Return NaN if playback has not started and trigger a durationupdate once
// the duration can be reliably known.
if(this.el_.duration===Infinity&&IS_ANDROID&&IS_CHROME&&this.el_.currentTime===0){// Wait for the first `timeupdate` with currentTime > 0 - there may be
// several with 0
var checkProgress=function checkProgress(){if(_this5.el_.currentTime>0){// Trigger durationchange for genuinely live video
if(_this5.el_.duration===Infinity){_this5.trigger('durationchange');}_this5.off('timeupdate',checkProgress);}};this.on('timeupdate',checkProgress);return NaN;}return this.el_.duration||NaN;}/**
   * Get the current width of the HTML5 media element.
   *
   * @return {number}
   *         The width of the HTML5 media element.
   */;_proto.width=function width(){return this.el_.offsetWidth;}/**
   * Get the current height of the HTML5 media element.
   *
   * @return {number}
   *         The height of the HTML5 media element.
   */;_proto.height=function height(){return this.el_.offsetHeight;}/**
   * Proxy iOS `webkitbeginfullscreen` and `webkitendfullscreen` into
   * `fullscreenchange` event.
   *
   * @private
   * @fires fullscreenchange
   * @listens webkitendfullscreen
   * @listens webkitbeginfullscreen
   * @listens webkitbeginfullscreen
   */;_proto.proxyWebkitFullscreen_=function proxyWebkitFullscreen_(){var _this6=this;if(!('webkitDisplayingFullscreen'in this.el_)){return;}var endFn=function endFn(){this.trigger('fullscreenchange',{isFullscreen:false});// Safari will sometimes set contols on the videoelement when existing fullscreen.
if(this.el_.controls&&!this.options_.nativeControlsForTouch&&this.controls()){this.el_.controls=false;}};var beginFn=function beginFn(){if('webkitPresentationMode'in this.el_&&this.el_.webkitPresentationMode!=='picture-in-picture'){this.one('webkitendfullscreen',endFn);this.trigger('fullscreenchange',{isFullscreen:true,// set a flag in case another tech triggers fullscreenchange
nativeIOSFullscreen:true});}};this.on('webkitbeginfullscreen',beginFn);this.on('dispose',function(){_this6.off('webkitbeginfullscreen',beginFn);_this6.off('webkitendfullscreen',endFn);});}/**
   * Check if fullscreen is supported on the current playback device.
   *
   * @return {boolean}
   *         - True if fullscreen is supported.
   *         - False if fullscreen is not supported.
   */;_proto.supportsFullScreen=function supportsFullScreen(){if(typeof this.el_.webkitEnterFullScreen==='function'){var userAgent=(window_default()).navigator&&(window_default()).navigator.userAgent||'';// Seems to be broken in Chromium/Chrome && Safari in Leopard
if(/Android/.test(userAgent)||!/Chrome|Mac OS X 10.5/.test(userAgent)){return true;}}return false;}/**
   * Request that the `HTML5` Tech enter fullscreen.
   */;_proto.enterFullScreen=function enterFullScreen(){var video=this.el_;if(video.paused&&video.networkState<=video.HAVE_METADATA){// attempt to prime the video element for programmatic access
// this isn't necessary on the desktop but shouldn't hurt
silencePromise(this.el_.play());// playing and pausing synchronously during the transition to fullscreen
// can get iOS ~6.1 devices into a play/pause loop
this.setTimeout(function(){video.pause();try{video.webkitEnterFullScreen();}catch(e){this.trigger('fullscreenerror',e);}},0);}else{try{video.webkitEnterFullScreen();}catch(e){this.trigger('fullscreenerror',e);}}}/**
   * Request that the `HTML5` Tech exit fullscreen.
   */;_proto.exitFullScreen=function exitFullScreen(){if(!this.el_.webkitDisplayingFullscreen){this.trigger('fullscreenerror',new Error('The video is not fullscreen'));return;}this.el_.webkitExitFullScreen();}/**
   * Create a floating video window always on top of other windows so that users may
   * continue consuming media while they interact with other content sites, or
   * applications on their device.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @return {Promise}
   *         A promise with a Picture-in-Picture window.
   */;_proto.requestPictureInPicture=function requestPictureInPicture(){return this.el_.requestPictureInPicture();}/**
   * Native requestVideoFrameCallback if supported by browser/tech, or fallback
   * Don't use rVCF on Safari when DRM is playing, as it doesn't fire
   * Needs to be checked later than the constructor
   * This will be a false positive for clear sources loaded after a Fairplay source
   *
   * @param {function} cb function to call
   * @return {number} id of request
   */;_proto.requestVideoFrameCallback=function requestVideoFrameCallback(cb){if(this.featuresVideoFrameCallback&&!this.el_.webkitKeys){return this.el_.requestVideoFrameCallback(cb);}return _Tech.prototype.requestVideoFrameCallback.call(this,cb);}/**
   * Native or fallback requestVideoFrameCallback
   *
   * @param {number} id request id to cancel
   */;_proto.cancelVideoFrameCallback=function cancelVideoFrameCallback(id){if(this.featuresVideoFrameCallback&&!this.el_.webkitKeys){this.el_.cancelVideoFrameCallback(id);}else{_Tech.prototype.cancelVideoFrameCallback.call(this,id);}}/**
   * A getter/setter for the `Html5` Tech's source object.
   * > Note: Please use {@link Html5#setSource}
   *
   * @param {Tech~SourceObject} [src]
   *        The source object you want to set on the `HTML5` techs element.
   *
   * @return {Tech~SourceObject|undefined}
   *         - The current source object when a source is not passed in.
   *         - undefined when setting
   *
   * @deprecated Since version 5.
   */;_proto.src=function src(_src){if(_src===undefined){return this.el_.src;}// Setting src through `src` instead of `setSrc` will be deprecated
this.setSrc(_src);}/**
   * Reset the tech by removing all sources and then calling
   * {@link Html5.resetMediaElement}.
   */;_proto.reset=function reset(){Html5.resetMediaElement(this.el_);}/**
   * Get the current source on the `HTML5` Tech. Falls back to returning the source from
   * the HTML5 media element.
   *
   * @return {Tech~SourceObject}
   *         The current source object from the HTML5 tech. With a fallback to the
   *         elements source.
   */;_proto.currentSrc=function currentSrc(){if(this.currentSource_){return this.currentSource_.src;}return this.el_.currentSrc;}/**
   * Set controls attribute for the HTML5 media Element.
   *
   * @param {string} val
   *        Value to set the controls attribute to
   */;_proto.setControls=function setControls(val){this.el_.controls=!!val;}/**
   * Create and returns a remote {@link TextTrack} object.
   *
   * @param {string} kind
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
   *
   * @param {string} [label]
   *        Label to identify the text track
   *
   * @param {string} [language]
   *        Two letter language abbreviation
   *
   * @return {TextTrack}
   *         The TextTrack that gets created.
   */;_proto.addTextTrack=function addTextTrack(kind,label,language){if(!this.featuresNativeTextTracks){return _Tech.prototype.addTextTrack.call(this,kind,label,language);}return this.el_.addTextTrack(kind,label,language);}/**
   * Creates either native TextTrack or an emulated TextTrack depending
   * on the value of `featuresNativeTextTracks`
   *
   * @param {Object} options
   *        The object should contain the options to initialize the TextTrack with.
   *
   * @param {string} [options.kind]
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
   *
   * @param {string} [options.label]
   *        Label to identify the text track
   *
   * @param {string} [options.language]
   *        Two letter language abbreviation.
   *
   * @param {boolean} [options.default]
   *        Default this track to on.
   *
   * @param {string} [options.id]
   *        The internal id to assign this track.
   *
   * @param {string} [options.src]
   *        A source url for the track.
   *
   * @return {HTMLTrackElement}
   *         The track element that gets created.
   */;_proto.createRemoteTextTrack=function createRemoteTextTrack(options){if(!this.featuresNativeTextTracks){return _Tech.prototype.createRemoteTextTrack.call(this,options);}var htmlTrackElement=document_default().createElement('track');if(options.kind){htmlTrackElement.kind=options.kind;}if(options.label){htmlTrackElement.label=options.label;}if(options.language||options.srclang){htmlTrackElement.srclang=options.language||options.srclang;}if(options["default"]){htmlTrackElement["default"]=options["default"];}if(options.id){htmlTrackElement.id=options.id;}if(options.src){htmlTrackElement.src=options.src;}return htmlTrackElement;}/**
   * Creates a remote text track object and returns an html track element.
   *
   * @param {Object} options The object should contain values for
   * kind, language, label, and src (location of the WebVTT file)
   * @param {boolean} [manualCleanup=true] if set to false, the TextTrack will be
   * automatically removed from the video element whenever the source changes
   * @return {HTMLTrackElement} An Html Track Element.
   * This can be an emulated {@link HTMLTrackElement} or a native one.
   * @deprecated The default value of the "manualCleanup" parameter will default
   * to "false" in upcoming versions of Video.js
   */;_proto.addRemoteTextTrack=function addRemoteTextTrack(options,manualCleanup){var htmlTrackElement=_Tech.prototype.addRemoteTextTrack.call(this,options,manualCleanup);if(this.featuresNativeTextTracks){this.el().appendChild(htmlTrackElement);}return htmlTrackElement;}/**
   * Remove remote `TextTrack` from `TextTrackList` object
   *
   * @param {TextTrack} track
   *        `TextTrack` object to remove
   */;_proto.removeRemoteTextTrack=function removeRemoteTextTrack(track){_Tech.prototype.removeRemoteTextTrack.call(this,track);if(this.featuresNativeTextTracks){var tracks=this.$$('track');var i=tracks.length;while(i--){if(track===tracks[i]||track===tracks[i].track){this.el().removeChild(tracks[i]);}}}}/**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object}
   *         An object with supported media playback quality metrics
   */;_proto.getVideoPlaybackQuality=function getVideoPlaybackQuality(){if(typeof this.el().getVideoPlaybackQuality==='function'){return this.el().getVideoPlaybackQuality();}var videoPlaybackQuality={};if(typeof this.el().webkitDroppedFrameCount!=='undefined'&&typeof this.el().webkitDecodedFrameCount!=='undefined'){videoPlaybackQuality.droppedVideoFrames=this.el().webkitDroppedFrameCount;videoPlaybackQuality.totalVideoFrames=this.el().webkitDecodedFrameCount;}if((window_default()).performance&&typeof (window_default()).performance.now==='function'){videoPlaybackQuality.creationTime=window_default().performance.now();}else if((window_default()).performance&&(window_default()).performance.timing&&typeof (window_default()).performance.timing.navigationStart==='number'){videoPlaybackQuality.creationTime=window_default().Date.now()-(window_default()).performance.timing.navigationStart;}return videoPlaybackQuality;};return Html5;}(Tech);/* HTML5 Support Testing ---------------------------------------------------- */ /**
 * Element for testing browser HTML5 media capabilities
 *
 * @type {Element}
 * @constant
 * @private
 */defineLazyProperty(Html5,'TEST_VID',function(){if(!isReal()){return;}var video=document_default().createElement('video');var track=document_default().createElement('track');track.kind='captions';track.srclang='en';track.label='English';video.appendChild(track);return video;});/**
 * Check if HTML5 media is supported by this browser/device.
 *
 * @return {boolean}
 *         - True if HTML5 media is supported.
 *         - False if HTML5 media is not supported.
 */Html5.isSupported=function(){// IE with no Media Player is a LIAR! (#984)
try{Html5.TEST_VID.volume=0.5;}catch(e){return false;}return!!(Html5.TEST_VID&&Html5.TEST_VID.canPlayType);};/**
 * Check if the tech can support the given type
 *
 * @param {string} type
 *        The mimetype to check
 * @return {string} 'probably', 'maybe', or '' (empty string)
 */Html5.canPlayType=function(type){return Html5.TEST_VID.canPlayType(type);};/**
 * Check if the tech can support the given source
 *
 * @param {Object} srcObj
 *        The source object
 * @param {Object} options
 *        The options passed to the tech
 * @return {string} 'probably', 'maybe', or '' (empty string)
 */Html5.canPlaySource=function(srcObj,options){return Html5.canPlayType(srcObj.type);};/**
 * Check if the volume can be changed in this browser/device.
 * Volume cannot be changed in a lot of mobile devices.
 * Specifically, it can't be changed from 1 on iOS.
 *
 * @return {boolean}
 *         - True if volume can be controlled
 *         - False otherwise
 */Html5.canControlVolume=function(){// IE will error if Windows Media Player not installed #3315
try{var volume=Html5.TEST_VID.volume;Html5.TEST_VID.volume=volume/2+0.1;var canControl=volume!==Html5.TEST_VID.volume;// With the introduction of iOS 15, there are cases where the volume is read as
// changed but reverts back to its original state at the start of the next tick.
// To determine whether volume can be controlled on iOS,
// a timeout is set and the volume is checked asynchronously.
// Since `features` doesn't currently work asynchronously, the value is manually set.
if(canControl&&IS_IOS){window_default().setTimeout(function(){if(Html5&&Html5.prototype){Html5.prototype.featuresVolumeControl=volume!==Html5.TEST_VID.volume;}});// default iOS to false, which will be updated in the timeout above.
return false;}return canControl;}catch(e){return false;}};/**
 * Check if the volume can be muted in this browser/device.
 * Some devices, e.g. iOS, don't allow changing volume
 * but permits muting/unmuting.
 *
 * @return {bolean}
 *      - True if volume can be muted
 *      - False otherwise
 */Html5.canMuteVolume=function(){try{var muted=Html5.TEST_VID.muted;// in some versions of iOS muted property doesn't always
// work, so we want to set both property and attribute
Html5.TEST_VID.muted=!muted;if(Html5.TEST_VID.muted){setAttribute(Html5.TEST_VID,'muted','muted');}else{removeAttribute(Html5.TEST_VID,'muted','muted');}return muted!==Html5.TEST_VID.muted;}catch(e){return false;}};/**
 * Check if the playback rate can be changed in this browser/device.
 *
 * @return {boolean}
 *         - True if playback rate can be controlled
 *         - False otherwise
 */Html5.canControlPlaybackRate=function(){// Playback rate API is implemented in Android Chrome, but doesn't do anything
// https://github.com/videojs/video.js/issues/3180
if(IS_ANDROID&&IS_CHROME&&CHROME_VERSION<58){return false;}// IE will error if Windows Media Player not installed #3315
try{var playbackRate=Html5.TEST_VID.playbackRate;Html5.TEST_VID.playbackRate=playbackRate/2+0.1;return playbackRate!==Html5.TEST_VID.playbackRate;}catch(e){return false;}};/**
 * Check if we can override a video/audio elements attributes, with
 * Object.defineProperty.
 *
 * @return {boolean}
 *         - True if builtin attributes can be overridden
 *         - False otherwise
 */Html5.canOverrideAttributes=function(){// if we cannot overwrite the src/innerHTML property, there is no support
// iOS 7 safari for instance cannot do this.
try{var noop=function noop(){};Object.defineProperty(document_default().createElement('video'),'src',{get:noop,set:noop});Object.defineProperty(document_default().createElement('audio'),'src',{get:noop,set:noop});Object.defineProperty(document_default().createElement('video'),'innerHTML',{get:noop,set:noop});Object.defineProperty(document_default().createElement('audio'),'innerHTML',{get:noop,set:noop});}catch(e){return false;}return true;};/**
 * Check to see if native `TextTrack`s are supported by this browser/device.
 *
 * @return {boolean}
 *         - True if native `TextTrack`s are supported.
 *         - False otherwise
 */Html5.supportsNativeTextTracks=function(){return IS_ANY_SAFARI||IS_IOS&&IS_CHROME;};/**
 * Check to see if native `VideoTrack`s are supported by this browser/device
 *
 * @return {boolean}
 *        - True if native `VideoTrack`s are supported.
 *        - False otherwise
 */Html5.supportsNativeVideoTracks=function(){return!!(Html5.TEST_VID&&Html5.TEST_VID.videoTracks);};/**
 * Check to see if native `AudioTrack`s are supported by this browser/device
 *
 * @return {boolean}
 *        - True if native `AudioTrack`s are supported.
 *        - False otherwise
 */Html5.supportsNativeAudioTracks=function(){return!!(Html5.TEST_VID&&Html5.TEST_VID.audioTracks);};/**
 * An array of events available on the Html5 tech.
 *
 * @private
 * @type {Array}
 */Html5.Events=['loadstart','suspend','abort','error','emptied','stalled','loadedmetadata','loadeddata','canplay','canplaythrough','playing','waiting','seeking','seeked','ended','durationchange','timeupdate','progress','play','pause','ratechange','resize','volumechange'];/**
 * Boolean indicating whether the `Tech` supports volume control.
 *
 * @type {boolean}
 * @default {@link Html5.canControlVolume}
 */ /**
 * Boolean indicating whether the `Tech` supports muting volume.
 *
 * @type {bolean}
 * @default {@link Html5.canMuteVolume}
 */ /**
 * Boolean indicating whether the `Tech` supports changing the speed at which the media
 * plays. Examples:
 *   - Set player to play 2x (twice) as fast
 *   - Set player to play 0.5x (half) as fast
 *
 * @type {boolean}
 * @default {@link Html5.canControlPlaybackRate}
 */ /**
 * Boolean indicating whether the `Tech` supports the `sourceset` event.
 *
 * @type {boolean}
 * @default
 */ /**
 * Boolean indicating whether the `HTML5` tech currently supports native `TextTrack`s.
 *
 * @type {boolean}
 * @default {@link Html5.supportsNativeTextTracks}
 */ /**
 * Boolean indicating whether the `HTML5` tech currently supports native `VideoTrack`s.
 *
 * @type {boolean}
 * @default {@link Html5.supportsNativeVideoTracks}
 */ /**
 * Boolean indicating whether the `HTML5` tech currently supports native `AudioTrack`s.
 *
 * @type {boolean}
 * @default {@link Html5.supportsNativeAudioTracks}
 */[['featuresMuteControl','canMuteVolume'],['featuresPlaybackRate','canControlPlaybackRate'],['featuresSourceset','canOverrideAttributes'],['featuresNativeTextTracks','supportsNativeTextTracks'],['featuresNativeVideoTracks','supportsNativeVideoTracks'],['featuresNativeAudioTracks','supportsNativeAudioTracks']].forEach(function(_ref){var key=_ref[0],fn=_ref[1];defineLazyProperty(Html5.prototype,key,function(){return Html5[fn]();},true);});Html5.prototype.featuresVolumeControl=Html5.canControlVolume();/**
 * Boolean indicating whether the `HTML5` tech currently supports the media element
 * moving in the DOM. iOS breaks if you move the media element, so this is set this to
 * false there. Everywhere else this should be true.
 *
 * @type {boolean}
 * @default
 */Html5.prototype.movingMediaElementInDOM=!IS_IOS;// TODO: Previous comment: No longer appears to be used. Can probably be removed.
//       Is this true?
/**
 * Boolean indicating whether the `HTML5` tech currently supports automatic media resize
 * when going into fullscreen.
 *
 * @type {boolean}
 * @default
 */Html5.prototype.featuresFullscreenResize=true;/**
 * Boolean indicating whether the `HTML5` tech currently supports the progress event.
 * If this is false, manual `progress` events will be triggered instead.
 *
 * @type {boolean}
 * @default
 */Html5.prototype.featuresProgressEvents=true;/**
 * Boolean indicating whether the `HTML5` tech currently supports the timeupdate event.
 * If this is false, manual `timeupdate` events will be triggered instead.
 *
 * @default
 */Html5.prototype.featuresTimeupdateEvents=true;/**
 * Whether the HTML5 el supports `requestVideoFrameCallback`
 *
 * @type {boolean}
 */Html5.prototype.featuresVideoFrameCallback=!!(Html5.TEST_VID&&Html5.TEST_VID.requestVideoFrameCallback);// HTML5 Feature detection and Device Fixes --------------------------------- //
var canPlayType;Html5.patchCanPlayType=function(){// Android 4.0 and above can play HLS to some extent but it reports being unable to do so
// Firefox and Chrome report correctly
if(ANDROID_VERSION>=4.0&&!IS_FIREFOX&&!IS_CHROME){canPlayType=Html5.TEST_VID&&Html5.TEST_VID.constructor.prototype.canPlayType;Html5.TEST_VID.constructor.prototype.canPlayType=function(type){var mpegurlRE=/^application\/(?:x-|vnd\.apple\.)mpegurl/i;if(type&&mpegurlRE.test(type)){return'maybe';}return canPlayType.call(this,type);};}};Html5.unpatchCanPlayType=function(){var r=Html5.TEST_VID.constructor.prototype.canPlayType;if(canPlayType){Html5.TEST_VID.constructor.prototype.canPlayType=canPlayType;}return r;};// by default, patch the media element
Html5.patchCanPlayType();Html5.disposeMediaElement=function(el){if(!el){return;}if(el.parentNode){el.parentNode.removeChild(el);}// remove any child track or source nodes to prevent their loading
while(el.hasChildNodes()){el.removeChild(el.firstChild);}// remove any src reference. not setting `src=''` because that causes a warning
// in firefox
el.removeAttribute('src');// force the media element to update its loading state by calling load()
// however IE on Windows 7N has a bug that throws an error so need a try/catch (#793)
if(typeof el.load==='function'){// wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
(function(){try{el.load();}catch(e){// not supported
}})();}};Html5.resetMediaElement=function(el){if(!el){return;}var sources=el.querySelectorAll('source');var i=sources.length;while(i--){el.removeChild(sources[i]);}// remove any src reference.
// not setting `src=''` because that throws an error
el.removeAttribute('src');if(typeof el.load==='function'){// wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
(function(){try{el.load();}catch(e){// satisfy linter
}})();}};/* Native HTML5 element property wrapping ----------------------------------- */ // Wrap native boolean attributes with getters that check both property and attribute
// The list is as followed:
// muted, defaultMuted, autoplay, controls, loop, playsinline
[/**
 * Get the value of `muted` from the media element. `muted` indicates
 * that the volume for the media should be set to silent. This does not actually change
 * the `volume` attribute.
 *
 * @method Html5#muted
 * @return {boolean}
 *         - True if the value of `volume` should be ignored and the audio set to silent.
 *         - False if the value of `volume` should be used.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
 */'muted',/**
 * Get the value of `defaultMuted` from the media element. `defaultMuted` indicates
 * whether the media should start muted or not. Only changes the default state of the
 * media. `muted` and `defaultMuted` can have different values. {@link Html5#muted} indicates the
 * current state.
 *
 * @method Html5#defaultMuted
 * @return {boolean}
 *         - The value of `defaultMuted` from the media element.
 *         - True indicates that the media should start muted.
 *         - False indicates that the media should not start muted
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
 */'defaultMuted',/**
 * Get the value of `autoplay` from the media element. `autoplay` indicates
 * that the media should start to play as soon as the page is ready.
 *
 * @method Html5#autoplay
 * @return {boolean}
 *         - The value of `autoplay` from the media element.
 *         - True indicates that the media should start as soon as the page loads.
 *         - False indicates that the media should not start as soon as the page loads.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
 */'autoplay',/**
 * Get the value of `controls` from the media element. `controls` indicates
 * whether the native media controls should be shown or hidden.
 *
 * @method Html5#controls
 * @return {boolean}
 *         - The value of `controls` from the media element.
 *         - True indicates that native controls should be showing.
 *         - False indicates that native controls should be hidden.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-controls}
 */'controls',/**
 * Get the value of `loop` from the media element. `loop` indicates
 * that the media should return to the start of the media and continue playing once
 * it reaches the end.
 *
 * @method Html5#loop
 * @return {boolean}
 *         - The value of `loop` from the media element.
 *         - True indicates that playback should seek back to start once
 *           the end of a media is reached.
 *         - False indicates that playback should not loop back to the start when the
 *           end of the media is reached.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
 */'loop',/**
 * Get the value of `playsinline` from the media element. `playsinline` indicates
 * to the browser that non-fullscreen playback is preferred when fullscreen
 * playback is the native default, such as in iOS Safari.
 *
 * @method Html5#playsinline
 * @return {boolean}
 *         - The value of `playsinline` from the media element.
 *         - True indicates that the media should play inline.
 *         - False indicates that the media should not play inline.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
 */'playsinline'].forEach(function(prop){Html5.prototype[prop]=function(){return this.el_[prop]||this.el_.hasAttribute(prop);};});// Wrap native boolean attributes with setters that set both property and attribute
// The list is as followed:
// setMuted, setDefaultMuted, setAutoplay, setLoop, setPlaysinline
// setControls is special-cased above
[/**
 * Set the value of `muted` on the media element. `muted` indicates that the current
 * audio level should be silent.
 *
 * @method Html5#setMuted
 * @param {boolean} muted
 *        - True if the audio should be set to silent
 *        - False otherwise
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
 */'muted',/**
 * Set the value of `defaultMuted` on the media element. `defaultMuted` indicates that the current
 * audio level should be silent, but will only effect the muted level on initial playback..
 *
 * @method Html5.prototype.setDefaultMuted
 * @param {boolean} defaultMuted
 *        - True if the audio should be set to silent
 *        - False otherwise
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
 */'defaultMuted',/**
 * Set the value of `autoplay` on the media element. `autoplay` indicates
 * that the media should start to play as soon as the page is ready.
 *
 * @method Html5#setAutoplay
 * @param {boolean} autoplay
 *         - True indicates that the media should start as soon as the page loads.
 *         - False indicates that the media should not start as soon as the page loads.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
 */'autoplay',/**
 * Set the value of `loop` on the media element. `loop` indicates
 * that the media should return to the start of the media and continue playing once
 * it reaches the end.
 *
 * @method Html5#setLoop
 * @param {boolean} loop
 *         - True indicates that playback should seek back to start once
 *           the end of a media is reached.
 *         - False indicates that playback should not loop back to the start when the
 *           end of the media is reached.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
 */'loop',/**
 * Set the value of `playsinline` from the media element. `playsinline` indicates
 * to the browser that non-fullscreen playback is preferred when fullscreen
 * playback is the native default, such as in iOS Safari.
 *
 * @method Html5#setPlaysinline
 * @param {boolean} playsinline
 *         - True indicates that the media should play inline.
 *         - False indicates that the media should not play inline.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
 */'playsinline'].forEach(function(prop){Html5.prototype['set'+toTitleCase$1(prop)]=function(v){this.el_[prop]=v;if(v){this.el_.setAttribute(prop,prop);}else{this.el_.removeAttribute(prop);}};});// Wrap native properties with a getter
// The list is as followed
// paused, currentTime, buffered, volume, poster, preload, error, seeking
// seekable, ended, playbackRate, defaultPlaybackRate, disablePictureInPicture
// played, networkState, readyState, videoWidth, videoHeight, crossOrigin
[/**
 * Get the value of `paused` from the media element. `paused` indicates whether the media element
 * is currently paused or not.
 *
 * @method Html5#paused
 * @return {boolean}
 *         The value of `paused` from the media element.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-paused}
 */'paused',/**
 * Get the value of `currentTime` from the media element. `currentTime` indicates
 * the current second that the media is at in playback.
 *
 * @method Html5#currentTime
 * @return {number}
 *         The value of `currentTime` from the media element.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-currenttime}
 */'currentTime',/**
 * Get the value of `buffered` from the media element. `buffered` is a `TimeRange`
 * object that represents the parts of the media that are already downloaded and
 * available for playback.
 *
 * @method Html5#buffered
 * @return {TimeRange}
 *         The value of `buffered` from the media element.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-buffered}
 */'buffered',/**
 * Get the value of `volume` from the media element. `volume` indicates
 * the current playback volume of audio for a media. `volume` will be a value from 0
 * (silent) to 1 (loudest and default).
 *
 * @method Html5#volume
 * @return {number}
 *         The value of `volume` from the media element. Value will be between 0-1.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
 */'volume',/**
 * Get the value of `poster` from the media element. `poster` indicates
 * that the url of an image file that can/will be shown when no media data is available.
 *
 * @method Html5#poster
 * @return {string}
 *         The value of `poster` from the media element. Value will be a url to an
 *         image.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-video-poster}
 */'poster',/**
 * Get the value of `preload` from the media element. `preload` indicates
 * what should download before the media is interacted with. It can have the following
 * values:
 * - none: nothing should be downloaded
 * - metadata: poster and the first few frames of the media may be downloaded to get
 *   media dimensions and other metadata
 * - auto: allow the media and metadata for the media to be downloaded before
 *    interaction
 *
 * @method Html5#preload
 * @return {string}
 *         The value of `preload` from the media element. Will be 'none', 'metadata',
 *         or 'auto'.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
 */'preload',/**
 * Get the value of the `error` from the media element. `error` indicates any
 * MediaError that may have occurred during playback. If error returns null there is no
 * current error.
 *
 * @method Html5#error
 * @return {MediaError|null}
 *         The value of `error` from the media element. Will be `MediaError` if there
 *         is a current error and null otherwise.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-error}
 */'error',/**
 * Get the value of `seeking` from the media element. `seeking` indicates whether the
 * media is currently seeking to a new position or not.
 *
 * @method Html5#seeking
 * @return {boolean}
 *         - The value of `seeking` from the media element.
 *         - True indicates that the media is currently seeking to a new position.
 *         - False indicates that the media is not seeking to a new position at this time.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seeking}
 */'seeking',/**
 * Get the value of `seekable` from the media element. `seekable` returns a
 * `TimeRange` object indicating ranges of time that can currently be `seeked` to.
 *
 * @method Html5#seekable
 * @return {TimeRange}
 *         The value of `seekable` from the media element. A `TimeRange` object
 *         indicating the current ranges of time that can be seeked to.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seekable}
 */'seekable',/**
 * Get the value of `ended` from the media element. `ended` indicates whether
 * the media has reached the end or not.
 *
 * @method Html5#ended
 * @return {boolean}
 *         - The value of `ended` from the media element.
 *         - True indicates that the media has ended.
 *         - False indicates that the media has not ended.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-ended}
 */'ended',/**
 * Get the value of `playbackRate` from the media element. `playbackRate` indicates
 * the rate at which the media is currently playing back. Examples:
 *   - if playbackRate is set to 2, media will play twice as fast.
 *   - if playbackRate is set to 0.5, media will play half as fast.
 *
 * @method Html5#playbackRate
 * @return {number}
 *         The value of `playbackRate` from the media element. A number indicating
 *         the current playback speed of the media, where 1 is normal speed.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
 */'playbackRate',/**
 * Get the value of `defaultPlaybackRate` from the media element. `defaultPlaybackRate` indicates
 * the rate at which the media is currently playing back. This value will not indicate the current
 * `playbackRate` after playback has started, use {@link Html5#playbackRate} for that.
 *
 * Examples:
 *   - if defaultPlaybackRate is set to 2, media will play twice as fast.
 *   - if defaultPlaybackRate is set to 0.5, media will play half as fast.
 *
 * @method Html5.prototype.defaultPlaybackRate
 * @return {number}
 *         The value of `defaultPlaybackRate` from the media element. A number indicating
 *         the current playback speed of the media, where 1 is normal speed.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
 */'defaultPlaybackRate',/**
 * Get the value of 'disablePictureInPicture' from the video element.
 *
 * @method Html5#disablePictureInPicture
 * @return {boolean} value
 *         - The value of `disablePictureInPicture` from the video element.
 *         - True indicates that the video can't be played in Picture-In-Picture mode
 *         - False indicates that the video can be played in Picture-In-Picture mode
 *
 * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
 */'disablePictureInPicture',/**
 * Get the value of `played` from the media element. `played` returns a `TimeRange`
 * object representing points in the media timeline that have been played.
 *
 * @method Html5#played
 * @return {TimeRange}
 *         The value of `played` from the media element. A `TimeRange` object indicating
 *         the ranges of time that have been played.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-played}
 */'played',/**
 * Get the value of `networkState` from the media element. `networkState` indicates
 * the current network state. It returns an enumeration from the following list:
 * - 0: NETWORK_EMPTY
 * - 1: NETWORK_IDLE
 * - 2: NETWORK_LOADING
 * - 3: NETWORK_NO_SOURCE
 *
 * @method Html5#networkState
 * @return {number}
 *         The value of `networkState` from the media element. This will be a number
 *         from the list in the description.
 *
 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-networkstate}
 */'networkState',/**
 * Get the value of `readyState` from the media element. `readyState` indicates
 * the current state of the media element. It returns an enumeration from the
 * following list:
 * - 0: HAVE_NOTHING
 * - 1: HAVE_METADATA
 * - 2: HAVE_CURRENT_DATA
 * - 3: HAVE_FUTURE_DATA
 * - 4: HAVE_ENOUGH_DATA
 *
 * @method Html5#readyState
 * @return {number}
 *         The value of `readyState` from the media element. This will be a number
 *         from the list in the description.
 *
 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#ready-states}
 */'readyState',/**
 * Get the value of `videoWidth` from the video element. `videoWidth` indicates
 * the current width of the video in css pixels.
 *
 * @method Html5#videoWidth
 * @return {number}
 *         The value of `videoWidth` from the video element. This will be a number
 *         in css pixels.
 *
 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
 */'videoWidth',/**
 * Get the value of `videoHeight` from the video element. `videoHeight` indicates
 * the current height of the video in css pixels.
 *
 * @method Html5#videoHeight
 * @return {number}
 *         The value of `videoHeight` from the video element. This will be a number
 *         in css pixels.
 *
 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
 */'videoHeight',/**
 * Get the value of `crossOrigin` from the media element. `crossOrigin` indicates
 * to the browser that should sent the cookies along with the requests for the
 * different assets/playlists
 *
 * @method Html5#crossOrigin
 * @return {string}
 *         - anonymous indicates that the media should not sent cookies.
 *         - use-credentials indicates that the media should sent cookies along the requests.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
 */'crossOrigin'].forEach(function(prop){Html5.prototype[prop]=function(){return this.el_[prop];};});// Wrap native properties with a setter in this format:
// set + toTitleCase(name)
// The list is as follows:
// setVolume, setSrc, setPoster, setPreload, setPlaybackRate, setDefaultPlaybackRate,
// setDisablePictureInPicture, setCrossOrigin
[/**
 * Set the value of `volume` on the media element. `volume` indicates the current
 * audio level as a percentage in decimal form. This means that 1 is 100%, 0.5 is 50%, and
 * so on.
 *
 * @method Html5#setVolume
 * @param {number} percentAsDecimal
 *        The volume percent as a decimal. Valid range is from 0-1.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
 */'volume',/**
 * Set the value of `src` on the media element. `src` indicates the current
 * {@link Tech~SourceObject} for the media.
 *
 * @method Html5#setSrc
 * @param {Tech~SourceObject} src
 *        The source object to set as the current source.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-src}
 */'src',/**
 * Set the value of `poster` on the media element. `poster` is the url to
 * an image file that can/will be shown when no media data is available.
 *
 * @method Html5#setPoster
 * @param {string} poster
 *        The url to an image that should be used as the `poster` for the media
 *        element.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-poster}
 */'poster',/**
 * Set the value of `preload` on the media element. `preload` indicates
 * what should download before the media is interacted with. It can have the following
 * values:
 * - none: nothing should be downloaded
 * - metadata: poster and the first few frames of the media may be downloaded to get
 *   media dimensions and other metadata
 * - auto: allow the media and metadata for the media to be downloaded before
 *    interaction
 *
 * @method Html5#setPreload
 * @param {string} preload
 *         The value of `preload` to set on the media element. Must be 'none', 'metadata',
 *         or 'auto'.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
 */'preload',/**
 * Set the value of `playbackRate` on the media element. `playbackRate` indicates
 * the rate at which the media should play back. Examples:
 *   - if playbackRate is set to 2, media will play twice as fast.
 *   - if playbackRate is set to 0.5, media will play half as fast.
 *
 * @method Html5#setPlaybackRate
 * @return {number}
 *         The value of `playbackRate` from the media element. A number indicating
 *         the current playback speed of the media, where 1 is normal speed.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
 */'playbackRate',/**
 * Set the value of `defaultPlaybackRate` on the media element. `defaultPlaybackRate` indicates
 * the rate at which the media should play back upon initial startup. Changing this value
 * after a video has started will do nothing. Instead you should used {@link Html5#setPlaybackRate}.
 *
 * Example Values:
 *   - if playbackRate is set to 2, media will play twice as fast.
 *   - if playbackRate is set to 0.5, media will play half as fast.
 *
 * @method Html5.prototype.setDefaultPlaybackRate
 * @return {number}
 *         The value of `defaultPlaybackRate` from the media element. A number indicating
 *         the current playback speed of the media, where 1 is normal speed.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultplaybackrate}
 */'defaultPlaybackRate',/**
 * Prevents the browser from suggesting a Picture-in-Picture context menu
 * or to request Picture-in-Picture automatically in some cases.
 *
 * @method Html5#setDisablePictureInPicture
 * @param {boolean} value
 *         The true value will disable Picture-in-Picture mode.
 *
 * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
 */'disablePictureInPicture',/**
 * Set the value of `crossOrigin` from the media element. `crossOrigin` indicates
 * to the browser that should sent the cookies along with the requests for the
 * different assets/playlists
 *
 * @method Html5#setCrossOrigin
 * @param {string} crossOrigin
 *         - anonymous indicates that the media should not sent cookies.
 *         - use-credentials indicates that the media should sent cookies along the requests.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
 */'crossOrigin'].forEach(function(prop){Html5.prototype['set'+toTitleCase$1(prop)]=function(v){this.el_[prop]=v;};});// wrap native functions with a function
// The list is as follows:
// pause, load, play
[/**
 * A wrapper around the media elements `pause` function. This will call the `HTML5`
 * media elements `pause` function.
 *
 * @method Html5#pause
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-pause}
 */'pause',/**
 * A wrapper around the media elements `load` function. This will call the `HTML5`s
 * media element `load` function.
 *
 * @method Html5#load
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-load}
 */'load',/**
 * A wrapper around the media elements `play` function. This will call the `HTML5`s
 * media element `play` function.
 *
 * @method Html5#play
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-play}
 */'play'].forEach(function(prop){Html5.prototype[prop]=function(){return this.el_[prop]();};});Tech.withSourceHandlers(Html5);/**
 * Native source handler for Html5, simply passes the source to the media element.
 *
 * @property {Tech~SourceObject} source
 *        The source object
 *
 * @property {Html5} tech
 *        The instance of the HTML5 tech.
 */Html5.nativeSourceHandler={};/**
 * Check if the media element can play the given mime type.
 *
 * @param {string} type
 *        The mimetype to check
 *
 * @return {string}
 *         'probably', 'maybe', or '' (empty string)
 */Html5.nativeSourceHandler.canPlayType=function(type){// IE without MediaPlayer throws an error (#519)
try{return Html5.TEST_VID.canPlayType(type);}catch(e){return'';}};/**
 * Check if the media element can handle a source natively.
 *
 * @param {Tech~SourceObject} source
 *         The source object
 *
 * @param {Object} [options]
 *         Options to be passed to the tech.
 *
 * @return {string}
 *         'probably', 'maybe', or '' (empty string).
 */Html5.nativeSourceHandler.canHandleSource=function(source,options){// If a type was provided we should rely on that
if(source.type){return Html5.nativeSourceHandler.canPlayType(source.type);// If no type, fall back to checking 'video/[EXTENSION]'
}else if(source.src){var ext=getFileExtension(source.src);return Html5.nativeSourceHandler.canPlayType("video/"+ext);}return'';};/**
 * Pass the source to the native media element.
 *
 * @param {Tech~SourceObject} source
 *        The source object
 *
 * @param {Html5} tech
 *        The instance of the Html5 tech
 *
 * @param {Object} [options]
 *        The options to pass to the source
 */Html5.nativeSourceHandler.handleSource=function(source,tech,options){tech.setSrc(source.src);};/**
 * A noop for the native dispose function, as cleanup is not needed.
 */Html5.nativeSourceHandler.dispose=function(){};// Register the native source handler
Html5.registerSourceHandler(Html5.nativeSourceHandler);Tech.registerTech('Html5',Html5);// on the player when they happen
var TECH_EVENTS_RETRIGGER=[/**
 * Fired while the user agent is downloading media data.
 *
 * @event Player#progress
 * @type {EventTarget~Event}
 */ /**
 * Retrigger the `progress` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechProgress_
 * @fires Player#progress
 * @listens Tech#progress
 */'progress',/**
 * Fires when the loading of an audio/video is aborted.
 *
 * @event Player#abort
 * @type {EventTarget~Event}
 */ /**
 * Retrigger the `abort` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechAbort_
 * @fires Player#abort
 * @listens Tech#abort
 */'abort',/**
 * Fires when the browser is intentionally not getting media data.
 *
 * @event Player#suspend
 * @type {EventTarget~Event}
 */ /**
 * Retrigger the `suspend` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechSuspend_
 * @fires Player#suspend
 * @listens Tech#suspend
 */'suspend',/**
 * Fires when the current playlist is empty.
 *
 * @event Player#emptied
 * @type {EventTarget~Event}
 */ /**
 * Retrigger the `emptied` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechEmptied_
 * @fires Player#emptied
 * @listens Tech#emptied
 */'emptied',/**
 * Fires when the browser is trying to get media data, but data is not available.
 *
 * @event Player#stalled
 * @type {EventTarget~Event}
 */ /**
 * Retrigger the `stalled` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechStalled_
 * @fires Player#stalled
 * @listens Tech#stalled
 */'stalled',/**
 * Fires when the browser has loaded meta data for the audio/video.
 *
 * @event Player#loadedmetadata
 * @type {EventTarget~Event}
 */ /**
 * Retrigger the `loadedmetadata` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechLoadedmetadata_
 * @fires Player#loadedmetadata
 * @listens Tech#loadedmetadata
 */'loadedmetadata',/**
 * Fires when the browser has loaded the current frame of the audio/video.
 *
 * @event Player#loadeddata
 * @type {event}
 */ /**
 * Retrigger the `loadeddata` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechLoaddeddata_
 * @fires Player#loadeddata
 * @listens Tech#loadeddata
 */'loadeddata',/**
 * Fires when the current playback position has changed.
 *
 * @event Player#timeupdate
 * @type {event}
 */ /**
 * Retrigger the `timeupdate` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechTimeUpdate_
 * @fires Player#timeupdate
 * @listens Tech#timeupdate
 */'timeupdate',/**
 * Fires when the video's intrinsic dimensions change
 *
 * @event Player#resize
 * @type {event}
 */ /**
 * Retrigger the `resize` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechResize_
 * @fires Player#resize
 * @listens Tech#resize
 */'resize',/**
 * Fires when the volume has been changed
 *
 * @event Player#volumechange
 * @type {event}
 */ /**
 * Retrigger the `volumechange` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechVolumechange_
 * @fires Player#volumechange
 * @listens Tech#volumechange
 */'volumechange',/**
 * Fires when the text track has been changed
 *
 * @event Player#texttrackchange
 * @type {event}
 */ /**
 * Retrigger the `texttrackchange` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechTexttrackchange_
 * @fires Player#texttrackchange
 * @listens Tech#texttrackchange
 */'texttrackchange'];// events to queue when playback rate is zero
// this is a hash for the sole purpose of mapping non-camel-cased event names
// to camel-cased function names
var TECH_EVENTS_QUEUE={canplay:'CanPlay',canplaythrough:'CanPlayThrough',playing:'Playing',seeked:'Seeked'};var BREAKPOINT_ORDER=['tiny','xsmall','small','medium','large','xlarge','huge'];var BREAKPOINT_CLASSES={};// grep: vjs-layout-tiny
// grep: vjs-layout-x-small
// grep: vjs-layout-small
// grep: vjs-layout-medium
// grep: vjs-layout-large
// grep: vjs-layout-x-large
// grep: vjs-layout-huge
BREAKPOINT_ORDER.forEach(function(k){var v=k.charAt(0)==='x'?"x-"+k.substring(1):k;BREAKPOINT_CLASSES[k]="vjs-layout-"+v;});var DEFAULT_BREAKPOINTS={tiny:210,xsmall:320,small:425,medium:768,large:1440,xlarge:2560,huge:Infinity};/**
 * An instance of the `Player` class is created when any of the Video.js setup methods
 * are used to initialize a video.
 *
 * After an instance has been created it can be accessed globally in two ways:
 * 1. By calling `videojs('example_video_1');`
 * 2. By using it directly via  `videojs.players.example_video_1;`
 *
 * @extends Component
 */var Player=/*#__PURE__*/function(_Component){_inheritsLoose(Player,_Component);/**
   * Create an instance of this class.
   *
   * @param {Element} tag
   *        The original video DOM element used for configuring options.
   *
   * @param {Object} [options]
   *        Object of option names and values.
   *
   * @param {Component~ReadyCallback} [ready]
   *        Ready callback function.
   */function Player(tag,options,ready){var _this;// Make sure tag ID exists
tag.id=tag.id||options.id||"vjs_video_"+newGUID();// Set Options
// The options argument overrides options set in the video tag
// which overrides globally set options.
// This latter part coincides with the load order
// (tag must exist before Player)
options=video_es_assign(Player.getTagSettings(tag),options);// Delay the initialization of children because we need to set up
// player properties first, and can't use `this` before `super()`
options.initChildren=false;// Same with creating the element
options.createEl=false;// don't auto mixin the evented mixin
options.evented=false;// we don't want the player to report touch activity on itself
// see enableTouchActivity in Component
options.reportTouchActivity=false;// If language is not set, get the closest lang attribute
if(!options.language){if(typeof tag.closest==='function'){var closest=tag.closest('[lang]');if(closest&&closest.getAttribute){options.language=closest.getAttribute('lang');}}else{var element=tag;while(element&&element.nodeType===1){if(getAttributes(element).hasOwnProperty('lang')){options.language=element.getAttribute('lang');break;}element=element.parentNode;}}}// Run base component initializing with new options
_this=_Component.call(this,null,options,ready)||this;// Create bound methods for document listeners.
_this.boundDocumentFullscreenChange_=function(e){return _this.documentFullscreenChange_(e);};_this.boundFullWindowOnEscKey_=function(e){return _this.fullWindowOnEscKey(e);};_this.boundUpdateStyleEl_=function(e){return _this.updateStyleEl_(e);};_this.boundApplyInitTime_=function(e){return _this.applyInitTime_(e);};_this.boundUpdateCurrentBreakpoint_=function(e){return _this.updateCurrentBreakpoint_(e);};_this.boundHandleTechClick_=function(e){return _this.handleTechClick_(e);};_this.boundHandleTechDoubleClick_=function(e){return _this.handleTechDoubleClick_(e);};_this.boundHandleTechTouchStart_=function(e){return _this.handleTechTouchStart_(e);};_this.boundHandleTechTouchMove_=function(e){return _this.handleTechTouchMove_(e);};_this.boundHandleTechTouchEnd_=function(e){return _this.handleTechTouchEnd_(e);};_this.boundHandleTechTap_=function(e){return _this.handleTechTap_(e);};// default isFullscreen_ to false
_this.isFullscreen_=false;// create logger
_this.log=createLogger(_this.id_);// Hold our own reference to fullscreen api so it can be mocked in tests
_this.fsApi_=FullscreenApi;// Tracks when a tech changes the poster
_this.isPosterFromTech_=false;// Holds callback info that gets queued when playback rate is zero
// and a seek is happening
_this.queuedCallbacks_=[];// Turn off API access because we're loading a new tech that might load asynchronously
_this.isReady_=false;// Init state hasStarted_
_this.hasStarted_=false;// Init state userActive_
_this.userActive_=false;// Init debugEnabled_
_this.debugEnabled_=false;// Init state audioOnlyMode_
_this.audioOnlyMode_=false;// Init state audioPosterMode_
_this.audioPosterMode_=false;// Init state audioOnlyCache_
_this.audioOnlyCache_={playerHeight:null,hiddenChildren:[]};// if the global option object was accidentally blown away by
// someone, bail early with an informative error
if(!_this.options_||!_this.options_.techOrder||!_this.options_.techOrder.length){throw new Error('No techOrder specified. Did you overwrite '+'videojs.options instead of just changing the '+'properties you want to override?');}// Store the original tag used to set options
_this.tag=tag;// Store the tag attributes used to restore html5 element
_this.tagAttributes=tag&&getAttributes(tag);// Update current language
_this.language(_this.options_.language);// Update Supported Languages
if(options.languages){// Normalise player option languages to lowercase
var languagesToLower={};Object.getOwnPropertyNames(options.languages).forEach(function(name){languagesToLower[name.toLowerCase()]=options.languages[name];});_this.languages_=languagesToLower;}else{_this.languages_=Player.prototype.options_.languages;}_this.resetCache_();// Set poster
_this.poster_=options.poster||'';// Set controls
_this.controls_=!!options.controls;// Original tag settings stored in options
// now remove immediately so native controls don't flash.
// May be turned back on by HTML5 tech if nativeControlsForTouch is true
tag.controls=false;tag.removeAttribute('controls');_this.changingSrc_=false;_this.playCallbacks_=[];_this.playTerminatedQueue_=[];// the attribute overrides the option
if(tag.hasAttribute('autoplay')){_this.autoplay(true);}else{// otherwise use the setter to validate and
// set the correct value.
_this.autoplay(_this.options_.autoplay);}// check plugins
if(options.plugins){Object.keys(options.plugins).forEach(function(name){if(typeof _this[name]!=='function'){throw new Error("plugin \""+name+"\" does not exist");}});}/*
     * Store the internal state of scrubbing
     *
     * @private
     * @return {Boolean} True if the user is scrubbing
     */_this.scrubbing_=false;_this.el_=_this.createEl();// Make this an evented object and use `el_` as its event bus.
evented(_assertThisInitialized(_this),{eventBusKey:'el_'});// listen to document and player fullscreenchange handlers so we receive those events
// before a user can receive them so we can update isFullscreen appropriately.
// make sure that we listen to fullscreenchange events before everything else to make sure that
// our isFullscreen method is updated properly for internal components as well as external.
if(_this.fsApi_.requestFullscreen){on((document_default()),_this.fsApi_.fullscreenchange,_this.boundDocumentFullscreenChange_);_this.on(_this.fsApi_.fullscreenchange,_this.boundDocumentFullscreenChange_);}if(_this.fluid_){_this.on(['playerreset','resize'],_this.boundUpdateStyleEl_);}// We also want to pass the original player options to each component and plugin
// as well so they don't need to reach back into the player for options later.
// We also need to do another copy of this.options_ so we don't end up with
// an infinite loop.
var playerOptionsCopy=mergeOptions$3(_this.options_);// Load plugins
if(options.plugins){Object.keys(options.plugins).forEach(function(name){_this[name](options.plugins[name]);});}// Enable debug mode to fire debugon event for all plugins.
if(options.debug){_this.debug(true);}_this.options_.playerOptions=playerOptionsCopy;_this.middleware_=[];_this.playbackRates(options.playbackRates);_this.initChildren();// Set isAudio based on whether or not an audio tag was used
_this.isAudio(tag.nodeName.toLowerCase()==='audio');// Update controls className. Can't do this when the controls are initially
// set because the element doesn't exist yet.
if(_this.controls()){_this.addClass('vjs-controls-enabled');}else{_this.addClass('vjs-controls-disabled');}// Set ARIA label and region role depending on player type
_this.el_.setAttribute('role','region');if(_this.isAudio()){_this.el_.setAttribute('aria-label',_this.localize('Audio Player'));}else{_this.el_.setAttribute('aria-label',_this.localize('Video Player'));}if(_this.isAudio()){_this.addClass('vjs-audio');}if(_this.flexNotSupported_()){_this.addClass('vjs-no-flex');}// TODO: Make this smarter. Toggle user state between touching/mousing
// using events, since devices can have both touch and mouse events.
// TODO: Make this check be performed again when the window switches between monitors
// (See https://github.com/videojs/video.js/issues/5683)
if(TOUCH_ENABLED){_this.addClass('vjs-touch-enabled');}// iOS Safari has broken hover handling
if(!IS_IOS){_this.addClass('vjs-workinghover');}// Make player easily findable by ID
Player.players[_this.id_]=_assertThisInitialized(_this);// Add a major version class to aid css in plugins
var majorVersion=version$5.split('.')[0];_this.addClass("vjs-v"+majorVersion);// When the player is first initialized, trigger activity so components
// like the control bar show themselves if needed
_this.userActive(true);_this.reportUserActivity();_this.one('play',function(e){return _this.listenForUserActivity_(e);});_this.on('stageclick',function(e){return _this.handleStageClick_(e);});_this.on('keydown',function(e){return _this.handleKeyDown(e);});_this.on('languagechange',function(e){return _this.handleLanguagechange(e);});_this.breakpoints(_this.options_.breakpoints);_this.responsive(_this.options_.responsive);// Calling both the audio mode methods after the player is fully
// setup to be able to listen to the events triggered by them
_this.on('ready',function(){// Calling the audioPosterMode method first so that
// the audioOnlyMode can take precedence when both options are set to true
_this.audioPosterMode(_this.options_.audioPosterMode);_this.audioOnlyMode(_this.options_.audioOnlyMode);});return _this;}/**
   * Destroys the video player and does any necessary cleanup.
   *
   * This is especially helpful if you are dynamically adding and removing videos
   * to/from the DOM.
   *
   * @fires Player#dispose
   */var _proto=Player.prototype;_proto.dispose=function dispose(){var _this2=this;/**
     * Called when the player is being disposed of.
     *
     * @event Player#dispose
     * @type {EventTarget~Event}
     */this.trigger('dispose');// prevent dispose from being called twice
this.off('dispose');// Make sure all player-specific document listeners are unbound. This is
off((document_default()),this.fsApi_.fullscreenchange,this.boundDocumentFullscreenChange_);off((document_default()),'keydown',this.boundFullWindowOnEscKey_);if(this.styleEl_&&this.styleEl_.parentNode){this.styleEl_.parentNode.removeChild(this.styleEl_);this.styleEl_=null;}// Kill reference to this player
Player.players[this.id_]=null;if(this.tag&&this.tag.player){this.tag.player=null;}if(this.el_&&this.el_.player){this.el_.player=null;}if(this.tech_){this.tech_.dispose();this.isPosterFromTech_=false;this.poster_='';}if(this.playerElIngest_){this.playerElIngest_=null;}if(this.tag){this.tag=null;}clearCacheForPlayer(this);// remove all event handlers for track lists
// all tracks and track listeners are removed on
// tech dispose
ALL.names.forEach(function(name){var props=ALL[name];var list=_this2[props.getterName]();// if it is not a native list
// we have to manually remove event listeners
if(list&&list.off){list.off();}});// the actual .el_ is removed here, or replaced if
_Component.prototype.dispose.call(this,{restoreEl:this.options_.restoreEl});}/**
   * Create the `Player`'s DOM element.
   *
   * @return {Element}
   *         The DOM element that gets created.
   */;_proto.createEl=function createEl(){var tag=this.tag;var el;var playerElIngest=this.playerElIngest_=tag.parentNode&&tag.parentNode.hasAttribute&&tag.parentNode.hasAttribute('data-vjs-player');var divEmbed=this.tag.tagName.toLowerCase()==='video-js';if(playerElIngest){el=this.el_=tag.parentNode;}else if(!divEmbed){el=this.el_=_Component.prototype.createEl.call(this,'div');}// Copy over all the attributes from the tag, including ID and class
// ID will now reference player box, not the video tag
var attrs=getAttributes(tag);if(divEmbed){el=this.el_=tag;tag=this.tag=document_default().createElement('video');while(el.children.length){tag.appendChild(el.firstChild);}if(!hasClass(el,'video-js')){addClass(el,'video-js');}el.appendChild(tag);playerElIngest=this.playerElIngest_=el;// move properties over from our custom `video-js` element
// to our new `video` element. This will move things like
// `src` or `controls` that were set via js before the player
// was initialized.
Object.keys(el).forEach(function(k){try{tag[k]=el[k];}catch(e){// we got a a property like outerHTML which we can't actually copy, ignore it
}});}// set tabindex to -1 to remove the video element from the focus order
tag.setAttribute('tabindex','-1');attrs.tabindex='-1';// Workaround for #4583 (JAWS+IE doesn't announce BPB or play button), and
// for the same issue with Chrome (on Windows) with JAWS.
// See https://github.com/FreedomScientific/VFO-standards-support/issues/78
// Note that we can't detect if JAWS is being used, but this ARIA attribute
//  doesn't change behavior of IE11 or Chrome if JAWS is not being used
if(IE_VERSION||IS_CHROME&&IS_WINDOWS){tag.setAttribute('role','application');attrs.role='application';}// Remove width/height attrs from tag so CSS can make it 100% width/height
tag.removeAttribute('width');tag.removeAttribute('height');if('width'in attrs){delete attrs.width;}if('height'in attrs){delete attrs.height;}Object.getOwnPropertyNames(attrs).forEach(function(attr){// don't copy over the class attribute to the player element when we're in a div embed
// the class is already set up properly in the divEmbed case
// and we want to make sure that the `video-js` class doesn't get lost
if(!(divEmbed&&attr==='class')){el.setAttribute(attr,attrs[attr]);}if(divEmbed){tag.setAttribute(attr,attrs[attr]);}});// Update tag id/class for use as HTML5 playback tech
// Might think we should do this after embedding in container so .vjs-tech class
// doesn't flash 100% width/height, but class only applies with .video-js parent
tag.playerId=tag.id;tag.id+='_html5_api';tag.className='vjs-tech';// Make player findable on elements
tag.player=el.player=this;// Default state of video is paused
this.addClass('vjs-paused');// Add a style element in the player that we'll use to set the width/height
// of the player in a way that's still overrideable by CSS, just like the
// video element
if((window_default()).VIDEOJS_NO_DYNAMIC_STYLE!==true){this.styleEl_=createStyleElement('vjs-styles-dimensions');var defaultsStyleEl=$('.vjs-styles-defaults');var head=$('head');head.insertBefore(this.styleEl_,defaultsStyleEl?defaultsStyleEl.nextSibling:head.firstChild);}this.fill_=false;this.fluid_=false;// Pass in the width/height/aspectRatio options which will update the style el
this.width(this.options_.width);this.height(this.options_.height);this.fill(this.options_.fill);this.fluid(this.options_.fluid);this.aspectRatio(this.options_.aspectRatio);// support both crossOrigin and crossorigin to reduce confusion and issues around the name
this.crossOrigin(this.options_.crossOrigin||this.options_.crossorigin);// Hide any links within the video/audio tag,
// because IE doesn't hide them completely from screen readers.
var links=tag.getElementsByTagName('a');for(var i=0;i<links.length;i++){var linkEl=links.item(i);addClass(linkEl,'vjs-hidden');linkEl.setAttribute('hidden','hidden');}// insertElFirst seems to cause the networkState to flicker from 3 to 2, so
// keep track of the original for later so we can know if the source originally failed
tag.initNetworkState_=tag.networkState;// Wrap video tag in div (el/box) container
if(tag.parentNode&&!playerElIngest){tag.parentNode.insertBefore(el,tag);}// insert the tag as the first child of the player element
// then manually add it to the children array so that this.addChild
// will work properly for other components
//
// Breaks iPhone, fixed in HTML5 setup.
prependTo(tag,el);this.children_.unshift(tag);// Set lang attr on player to ensure CSS :lang() in consistent with player
// if it's been set to something different to the doc
this.el_.setAttribute('lang',this.language_);this.el_.setAttribute('translate','no');this.el_=el;return el;}/**
   * Get or set the `Player`'s crossOrigin option. For the HTML5 player, this
   * sets the `crossOrigin` property on the `<video>` tag to control the CORS
   * behavior.
   *
   * @see [Video Element Attributes]{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#attr-crossorigin}
   *
   * @param {string} [value]
   *        The value to set the `Player`'s crossOrigin to. If an argument is
   *        given, must be one of `anonymous` or `use-credentials`.
   *
   * @return {string|undefined}
   *         - The current crossOrigin value of the `Player` when getting.
   *         - undefined when setting
   */;_proto.crossOrigin=function crossOrigin(value){if(!value){return this.techGet_('crossOrigin');}if(value!=='anonymous'&&value!=='use-credentials'){log$1.warn("crossOrigin must be \"anonymous\" or \"use-credentials\", given \""+value+"\"");return;}this.techCall_('setCrossOrigin',value);return;}/**
   * A getter/setter for the `Player`'s width. Returns the player's configured value.
   * To get the current width use `currentWidth()`.
   *
   * @param {number} [value]
   *        The value to set the `Player`'s width to.
   *
   * @return {number}
   *         The current width of the `Player` when getting.
   */;_proto.width=function width(value){return this.dimension('width',value);}/**
   * A getter/setter for the `Player`'s height. Returns the player's configured value.
   * To get the current height use `currentheight()`.
   *
   * @param {number} [value]
   *        The value to set the `Player`'s heigth to.
   *
   * @return {number}
   *         The current height of the `Player` when getting.
   */;_proto.height=function height(value){return this.dimension('height',value);}/**
   * A getter/setter for the `Player`'s width & height.
   *
   * @param {string} dimension
   *        This string can be:
   *        - 'width'
   *        - 'height'
   *
   * @param {number} [value]
   *        Value for dimension specified in the first argument.
   *
   * @return {number}
   *         The dimension arguments value when getting (width/height).
   */;_proto.dimension=function dimension(_dimension,value){var privDimension=_dimension+'_';if(value===undefined){return this[privDimension]||0;}if(value===''||value==='auto'){// If an empty string is given, reset the dimension to be automatic
this[privDimension]=undefined;this.updateStyleEl_();return;}var parsedVal=parseFloat(value);if(isNaN(parsedVal)){log$1.error("Improper value \""+value+"\" supplied for for "+_dimension);return;}this[privDimension]=parsedVal;this.updateStyleEl_();}/**
   * A getter/setter/toggler for the vjs-fluid `className` on the `Player`.
   *
   * Turning this on will turn off fill mode.
   *
   * @param {boolean} [bool]
   *        - A value of true adds the class.
   *        - A value of false removes the class.
   *        - No value will be a getter.
   *
   * @return {boolean|undefined}
   *         - The value of fluid when getting.
   *         - `undefined` when setting.
   */;_proto.fluid=function fluid(bool){var _this3=this;if(bool===undefined){return!!this.fluid_;}this.fluid_=!!bool;if(isEvented(this)){this.off(['playerreset','resize'],this.boundUpdateStyleEl_);}if(bool){this.addClass('vjs-fluid');this.fill(false);addEventedCallback(this,function(){_this3.on(['playerreset','resize'],_this3.boundUpdateStyleEl_);});}else{this.removeClass('vjs-fluid');}this.updateStyleEl_();}/**
   * A getter/setter/toggler for the vjs-fill `className` on the `Player`.
   *
   * Turning this on will turn off fluid mode.
   *
   * @param {boolean} [bool]
   *        - A value of true adds the class.
   *        - A value of false removes the class.
   *        - No value will be a getter.
   *
   * @return {boolean|undefined}
   *         - The value of fluid when getting.
   *         - `undefined` when setting.
   */;_proto.fill=function fill(bool){if(bool===undefined){return!!this.fill_;}this.fill_=!!bool;if(bool){this.addClass('vjs-fill');this.fluid(false);}else{this.removeClass('vjs-fill');}}/**
   * Get/Set the aspect ratio
   *
   * @param {string} [ratio]
   *        Aspect ratio for player
   *
   * @return {string|undefined}
   *         returns the current aspect ratio when getting
   */ /**
   * A getter/setter for the `Player`'s aspect ratio.
   *
   * @param {string} [ratio]
   *        The value to set the `Player`'s aspect ratio to.
   *
   * @return {string|undefined}
   *         - The current aspect ratio of the `Player` when getting.
   *         - undefined when setting
   */;_proto.aspectRatio=function aspectRatio(ratio){if(ratio===undefined){return this.aspectRatio_;}// Check for width:height format
if(!/^\d+\:\d+$/.test(ratio)){throw new Error('Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.');}this.aspectRatio_=ratio;// We're assuming if you set an aspect ratio you want fluid mode,
// because in fixed mode you could calculate width and height yourself.
this.fluid(true);this.updateStyleEl_();}/**
   * Update styles of the `Player` element (height, width and aspect ratio).
   *
   * @private
   * @listens Tech#loadedmetadata
   */;_proto.updateStyleEl_=function updateStyleEl_(){if((window_default()).VIDEOJS_NO_DYNAMIC_STYLE===true){var _width=typeof this.width_==='number'?this.width_:this.options_.width;var _height=typeof this.height_==='number'?this.height_:this.options_.height;var techEl=this.tech_&&this.tech_.el();if(techEl){if(_width>=0){techEl.width=_width;}if(_height>=0){techEl.height=_height;}}return;}var width;var height;var aspectRatio;var idClass;// The aspect ratio is either used directly or to calculate width and height.
if(this.aspectRatio_!==undefined&&this.aspectRatio_!=='auto'){// Use any aspectRatio that's been specifically set
aspectRatio=this.aspectRatio_;}else if(this.videoWidth()>0){// Otherwise try to get the aspect ratio from the video metadata
aspectRatio=this.videoWidth()+':'+this.videoHeight();}else{// Or use a default. The video element's is 2:1, but 16:9 is more common.
aspectRatio='16:9';}// Get the ratio as a decimal we can use to calculate dimensions
var ratioParts=aspectRatio.split(':');var ratioMultiplier=ratioParts[1]/ratioParts[0];if(this.width_!==undefined){// Use any width that's been specifically set
width=this.width_;}else if(this.height_!==undefined){// Or calulate the width from the aspect ratio if a height has been set
width=this.height_/ratioMultiplier;}else{// Or use the video's metadata, or use the video el's default of 300
width=this.videoWidth()||300;}if(this.height_!==undefined){// Use any height that's been specifically set
height=this.height_;}else{// Otherwise calculate the height from the ratio and the width
height=width*ratioMultiplier;}// Ensure the CSS class is valid by starting with an alpha character
if(/^[^a-zA-Z]/.test(this.id())){idClass='dimensions-'+this.id();}else{idClass=this.id()+'-dimensions';}// Ensure the right class is still on the player for the style element
this.addClass(idClass);setTextContent(this.styleEl_,"\n      ."+idClass+" {\n        width: "+width+"px;\n        height: "+height+"px;\n      }\n\n      ."+idClass+".vjs-fluid:not(.vjs-audio-only-mode) {\n        padding-top: "+ratioMultiplier*100+"%;\n      }\n    ");}/**
   * Load/Create an instance of playback {@link Tech} including element
   * and API methods. Then append the `Tech` element in `Player` as a child.
   *
   * @param {string} techName
   *        name of the playback technology
   *
   * @param {string} source
   *        video source
   *
   * @private
   */;_proto.loadTech_=function loadTech_(techName,source){var _this4=this;// Pause and remove current playback technology
if(this.tech_){this.unloadTech_();}var titleTechName=toTitleCase$1(techName);var camelTechName=techName.charAt(0).toLowerCase()+techName.slice(1);// get rid of the HTML5 video tag as soon as we are using another tech
if(titleTechName!=='Html5'&&this.tag){Tech.getTech('Html5').disposeMediaElement(this.tag);this.tag.player=null;this.tag=null;}this.techName_=titleTechName;// Turn off API access because we're loading a new tech that might load asynchronously
this.isReady_=false;var autoplay=this.autoplay();// if autoplay is a string (or `true` with normalizeAutoplay: true) we pass false to the tech
// because the player is going to handle autoplay on `loadstart`
if(typeof this.autoplay()==='string'||this.autoplay()===true&&this.options_.normalizeAutoplay){autoplay=false;}// Grab tech-specific options from player options and add source and parent element to use.
var techOptions={source:source,autoplay:autoplay,'nativeControlsForTouch':this.options_.nativeControlsForTouch,'playerId':this.id(),'techId':this.id()+"_"+camelTechName+"_api",'playsinline':this.options_.playsinline,'preload':this.options_.preload,'loop':this.options_.loop,'disablePictureInPicture':this.options_.disablePictureInPicture,'muted':this.options_.muted,'poster':this.poster(),'language':this.language(),'playerElIngest':this.playerElIngest_||false,'vtt.js':this.options_['vtt.js'],'canOverridePoster':!!this.options_.techCanOverridePoster,'enableSourceset':this.options_.enableSourceset,'Promise':this.options_.Promise};ALL.names.forEach(function(name){var props=ALL[name];techOptions[props.getterName]=_this4[props.privateName];});video_es_assign(techOptions,this.options_[titleTechName]);video_es_assign(techOptions,this.options_[camelTechName]);video_es_assign(techOptions,this.options_[techName.toLowerCase()]);if(this.tag){techOptions.tag=this.tag;}if(source&&source.src===this.cache_.src&&this.cache_.currentTime>0){techOptions.startTime=this.cache_.currentTime;}// Initialize tech instance
var TechClass=Tech.getTech(techName);if(!TechClass){throw new Error("No Tech named '"+titleTechName+"' exists! '"+titleTechName+"' should be registered using videojs.registerTech()'");}this.tech_=new TechClass(techOptions);// player.triggerReady is always async, so don't need this to be async
this.tech_.ready(bind(this,this.handleTechReady_),true);textTrackConverter.jsonToTextTracks(this.textTracksJson_||[],this.tech_);// Listen to all HTML5-defined events and trigger them on the player
TECH_EVENTS_RETRIGGER.forEach(function(event){_this4.on(_this4.tech_,event,function(e){return _this4["handleTech"+toTitleCase$1(event)+"_"](e);});});Object.keys(TECH_EVENTS_QUEUE).forEach(function(event){_this4.on(_this4.tech_,event,function(eventObj){if(_this4.tech_.playbackRate()===0&&_this4.tech_.seeking()){_this4.queuedCallbacks_.push({callback:_this4["handleTech"+TECH_EVENTS_QUEUE[event]+"_"].bind(_this4),event:eventObj});return;}_this4["handleTech"+TECH_EVENTS_QUEUE[event]+"_"](eventObj);});});this.on(this.tech_,'loadstart',function(e){return _this4.handleTechLoadStart_(e);});this.on(this.tech_,'sourceset',function(e){return _this4.handleTechSourceset_(e);});this.on(this.tech_,'waiting',function(e){return _this4.handleTechWaiting_(e);});this.on(this.tech_,'ended',function(e){return _this4.handleTechEnded_(e);});this.on(this.tech_,'seeking',function(e){return _this4.handleTechSeeking_(e);});this.on(this.tech_,'play',function(e){return _this4.handleTechPlay_(e);});this.on(this.tech_,'firstplay',function(e){return _this4.handleTechFirstPlay_(e);});this.on(this.tech_,'pause',function(e){return _this4.handleTechPause_(e);});this.on(this.tech_,'durationchange',function(e){return _this4.handleTechDurationChange_(e);});this.on(this.tech_,'fullscreenchange',function(e,data){return _this4.handleTechFullscreenChange_(e,data);});this.on(this.tech_,'fullscreenerror',function(e,err){return _this4.handleTechFullscreenError_(e,err);});this.on(this.tech_,'enterpictureinpicture',function(e){return _this4.handleTechEnterPictureInPicture_(e);});this.on(this.tech_,'leavepictureinpicture',function(e){return _this4.handleTechLeavePictureInPicture_(e);});this.on(this.tech_,'error',function(e){return _this4.handleTechError_(e);});this.on(this.tech_,'posterchange',function(e){return _this4.handleTechPosterChange_(e);});this.on(this.tech_,'textdata',function(e){return _this4.handleTechTextData_(e);});this.on(this.tech_,'ratechange',function(e){return _this4.handleTechRateChange_(e);});this.on(this.tech_,'loadedmetadata',this.boundUpdateStyleEl_);this.usingNativeControls(this.techGet_('controls'));if(this.controls()&&!this.usingNativeControls()){this.addTechControlsListeners_();}// Add the tech element in the DOM if it was not already there
// Make sure to not insert the original video element if using Html5
if(this.tech_.el().parentNode!==this.el()&&(titleTechName!=='Html5'||!this.tag)){prependTo(this.tech_.el(),this.el());}// Get rid of the original video tag reference after the first tech is loaded
if(this.tag){this.tag.player=null;this.tag=null;}}/**
   * Unload and dispose of the current playback {@link Tech}.
   *
   * @private
   */;_proto.unloadTech_=function unloadTech_(){var _this5=this;// Save the current text tracks so that we can reuse the same text tracks with the next tech
ALL.names.forEach(function(name){var props=ALL[name];_this5[props.privateName]=_this5[props.getterName]();});this.textTracksJson_=textTrackConverter.textTracksToJson(this.tech_);this.isReady_=false;this.tech_.dispose();this.tech_=false;if(this.isPosterFromTech_){this.poster_='';this.trigger('posterchange');}this.isPosterFromTech_=false;}/**
   * Return a reference to the current {@link Tech}.
   * It will print a warning by default about the danger of using the tech directly
   * but any argument that is passed in will silence the warning.
   *
   * @param {*} [safety]
   *        Anything passed in to silence the warning
   *
   * @return {Tech}
   *         The Tech
   */;_proto.tech=function tech(safety){if(safety===undefined){log$1.warn('Using the tech directly can be dangerous. I hope you know what you\'re doing.\n'+'See https://github.com/videojs/video.js/issues/2617 for more info.\n');}return this.tech_;}/**
   * Set up click and touch listeners for the playback element
   *
   * - On desktops: a click on the video itself will toggle playback
   * - On mobile devices: a click on the video toggles controls
   *   which is done by toggling the user state between active and
   *   inactive
   * - A tap can signal that a user has become active or has become inactive
   *   e.g. a quick tap on an iPhone movie should reveal the controls. Another
   *   quick tap should hide them again (signaling the user is in an inactive
   *   viewing state)
   * - In addition to this, we still want the user to be considered inactive after
   *   a few seconds of inactivity.
   *
   * > Note: the only part of iOS interaction we can't mimic with this setup
   * is a touch and hold on the video element counting as activity in order to
   * keep the controls showing, but that shouldn't be an issue. A touch and hold
   * on any controls will still keep the user active
   *
   * @private
   */;_proto.addTechControlsListeners_=function addTechControlsListeners_(){// Make sure to remove all the previous listeners in case we are called multiple times.
this.removeTechControlsListeners_();this.on(this.tech_,'click',this.boundHandleTechClick_);this.on(this.tech_,'dblclick',this.boundHandleTechDoubleClick_);// If the controls were hidden we don't want that to change without a tap event
// so we'll check if the controls were already showing before reporting user
// activity
this.on(this.tech_,'touchstart',this.boundHandleTechTouchStart_);this.on(this.tech_,'touchmove',this.boundHandleTechTouchMove_);this.on(this.tech_,'touchend',this.boundHandleTechTouchEnd_);// The tap listener needs to come after the touchend listener because the tap
// listener cancels out any reportedUserActivity when setting userActive(false)
this.on(this.tech_,'tap',this.boundHandleTechTap_);}/**
   * Remove the listeners used for click and tap controls. This is needed for
   * toggling to controls disabled, where a tap/touch should do nothing.
   *
   * @private
   */;_proto.removeTechControlsListeners_=function removeTechControlsListeners_(){// We don't want to just use `this.off()` because there might be other needed
// listeners added by techs that extend this.
this.off(this.tech_,'tap',this.boundHandleTechTap_);this.off(this.tech_,'touchstart',this.boundHandleTechTouchStart_);this.off(this.tech_,'touchmove',this.boundHandleTechTouchMove_);this.off(this.tech_,'touchend',this.boundHandleTechTouchEnd_);this.off(this.tech_,'click',this.boundHandleTechClick_);this.off(this.tech_,'dblclick',this.boundHandleTechDoubleClick_);}/**
   * Player waits for the tech to be ready
   *
   * @private
   */;_proto.handleTechReady_=function handleTechReady_(){this.triggerReady();// Keep the same volume as before
if(this.cache_.volume){this.techCall_('setVolume',this.cache_.volume);}// Look if the tech found a higher resolution poster while loading
this.handleTechPosterChange_();// Update the duration if available
this.handleTechDurationChange_();}/**
   * Retrigger the `loadstart` event that was triggered by the {@link Tech}. This
   * function will also trigger {@link Player#firstplay} if it is the first loadstart
   * for a video.
   *
   * @fires Player#loadstart
   * @fires Player#firstplay
   * @listens Tech#loadstart
   * @private
   */;_proto.handleTechLoadStart_=function handleTechLoadStart_(){// TODO: Update to use `emptied` event instead. See #1277.
this.removeClass('vjs-ended');this.removeClass('vjs-seeking');// reset the error state
this.error(null);// Update the duration
this.handleTechDurationChange_();// If it's already playing we want to trigger a firstplay event now.
// The firstplay event relies on both the play and loadstart events
// which can happen in any order for a new source
if(!this.paused()){/**
       * Fired when the user agent begins looking for media data
       *
       * @event Player#loadstart
       * @type {EventTarget~Event}
       */this.trigger('loadstart');this.trigger('firstplay');}else{// reset the hasStarted state
this.hasStarted(false);this.trigger('loadstart');}// autoplay happens after loadstart for the browser,
// so we mimic that behavior
this.manualAutoplay_(this.autoplay()===true&&this.options_.normalizeAutoplay?'play':this.autoplay());}/**
   * Handle autoplay string values, rather than the typical boolean
   * values that should be handled by the tech. Note that this is not
   * part of any specification. Valid values and what they do can be
   * found on the autoplay getter at Player#autoplay()
   */;_proto.manualAutoplay_=function manualAutoplay_(type){var _this6=this;if(!this.tech_||typeof type!=='string'){return;}// Save original muted() value, set muted to true, and attempt to play().
// On promise rejection, restore muted from saved value
var resolveMuted=function resolveMuted(){var previouslyMuted=_this6.muted();_this6.muted(true);var restoreMuted=function restoreMuted(){_this6.muted(previouslyMuted);};// restore muted on play terminatation
_this6.playTerminatedQueue_.push(restoreMuted);var mutedPromise=_this6.play();if(!isPromise(mutedPromise)){return;}return mutedPromise["catch"](function(err){restoreMuted();throw new Error("Rejection at manualAutoplay. Restoring muted value. "+(err?err:''));});};var promise;// if muted defaults to true
// the only thing we can do is call play
if(type==='any'&&!this.muted()){promise=this.play();if(isPromise(promise)){promise=promise["catch"](resolveMuted);}}else if(type==='muted'&&!this.muted()){promise=resolveMuted();}else{promise=this.play();}if(!isPromise(promise)){return;}return promise.then(function(){_this6.trigger({type:'autoplay-success',autoplay:type});})["catch"](function(){_this6.trigger({type:'autoplay-failure',autoplay:type});});}/**
   * Update the internal source caches so that we return the correct source from
   * `src()`, `currentSource()`, and `currentSources()`.
   *
   * > Note: `currentSources` will not be updated if the source that is passed in exists
   *         in the current `currentSources` cache.
   *
   *
   * @param {Tech~SourceObject} srcObj
   *        A string or object source to update our caches to.
   */;_proto.updateSourceCaches_=function updateSourceCaches_(srcObj){if(srcObj===void 0){srcObj='';}var src=srcObj;var type='';if(typeof src!=='string'){src=srcObj.src;type=srcObj.type;}// make sure all the caches are set to default values
// to prevent null checking
this.cache_.source=this.cache_.source||{};this.cache_.sources=this.cache_.sources||[];// try to get the type of the src that was passed in
if(src&&!type){type=findMimetype(this,src);}// update `currentSource` cache always
this.cache_.source=mergeOptions$3({},srcObj,{src:src,type:type});var matchingSources=this.cache_.sources.filter(function(s){return s.src&&s.src===src;});var sourceElSources=[];var sourceEls=this.$$('source');var matchingSourceEls=[];for(var i=0;i<sourceEls.length;i++){var sourceObj=getAttributes(sourceEls[i]);sourceElSources.push(sourceObj);if(sourceObj.src&&sourceObj.src===src){matchingSourceEls.push(sourceObj.src);}}// if we have matching source els but not matching sources
// the current source cache is not up to date
if(matchingSourceEls.length&&!matchingSources.length){this.cache_.sources=sourceElSources;// if we don't have matching source or source els set the
// sources cache to the `currentSource` cache
}else if(!matchingSources.length){this.cache_.sources=[this.cache_.source];}// update the tech `src` cache
this.cache_.src=src;}/**
   * *EXPERIMENTAL* Fired when the source is set or changed on the {@link Tech}
   * causing the media element to reload.
   *
   * It will fire for the initial source and each subsequent source.
   * This event is a custom event from Video.js and is triggered by the {@link Tech}.
   *
   * The event object for this event contains a `src` property that will contain the source
   * that was available when the event was triggered. This is generally only necessary if Video.js
   * is switching techs while the source was being changed.
   *
   * It is also fired when `load` is called on the player (or media element)
   * because the {@link https://html.spec.whatwg.org/multipage/media.html#dom-media-load|specification for `load`}
   * says that the resource selection algorithm needs to be aborted and restarted.
   * In this case, it is very likely that the `src` property will be set to the
   * empty string `""` to indicate we do not know what the source will be but
   * that it is changing.
   *
   * *This event is currently still experimental and may change in minor releases.*
   * __To use this, pass `enableSourceset` option to the player.__
   *
   * @event Player#sourceset
   * @type {EventTarget~Event}
   * @prop {string} src
   *                The source url available when the `sourceset` was triggered.
   *                It will be an empty string if we cannot know what the source is
   *                but know that the source will change.
   */ /**
   * Retrigger the `sourceset` event that was triggered by the {@link Tech}.
   *
   * @fires Player#sourceset
   * @listens Tech#sourceset
   * @private
   */;_proto.handleTechSourceset_=function handleTechSourceset_(event){var _this7=this;// only update the source cache when the source
// was not updated using the player api
if(!this.changingSrc_){var updateSourceCaches=function updateSourceCaches(src){return _this7.updateSourceCaches_(src);};var playerSrc=this.currentSource().src;var eventSrc=event.src;// if we have a playerSrc that is not a blob, and a tech src that is a blob
if(playerSrc&&!/^blob:/.test(playerSrc)&&/^blob:/.test(eventSrc)){// if both the tech source and the player source were updated we assume
// something like @videojs/http-streaming did the sourceset and skip updating the source cache.
if(!this.lastSource_||this.lastSource_.tech!==eventSrc&&this.lastSource_.player!==playerSrc){updateSourceCaches=function updateSourceCaches(){};}}// update the source to the initial source right away
// in some cases this will be empty string
updateSourceCaches(eventSrc);// if the `sourceset` `src` was an empty string
// wait for a `loadstart` to update the cache to `currentSrc`.
// If a sourceset happens before a `loadstart`, we reset the state
if(!event.src){this.tech_.any(['sourceset','loadstart'],function(e){// if a sourceset happens before a `loadstart` there
// is nothing to do as this `handleTechSourceset_`
// will be called again and this will be handled there.
if(e.type==='sourceset'){return;}var techSrc=_this7.techGet('currentSrc');_this7.lastSource_.tech=techSrc;_this7.updateSourceCaches_(techSrc);});}}this.lastSource_={player:this.currentSource().src,tech:event.src};this.trigger({src:event.src,type:'sourceset'});}/**
   * Add/remove the vjs-has-started class
   *
   * @fires Player#firstplay
   *
   * @param {boolean} request
   *        - true: adds the class
   *        - false: remove the class
   *
   * @return {boolean}
   *         the boolean value of hasStarted_
   */;_proto.hasStarted=function hasStarted(request){if(request===undefined){// act as getter, if we have no request to change
return this.hasStarted_;}if(request===this.hasStarted_){return;}this.hasStarted_=request;if(this.hasStarted_){this.addClass('vjs-has-started');this.trigger('firstplay');}else{this.removeClass('vjs-has-started');}}/**
   * Fired whenever the media begins or resumes playback
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-play}
   * @fires Player#play
   * @listens Tech#play
   * @private
   */;_proto.handleTechPlay_=function handleTechPlay_(){this.removeClass('vjs-ended');this.removeClass('vjs-paused');this.addClass('vjs-playing');// hide the poster when the user hits play
this.hasStarted(true);/**
     * Triggered whenever an {@link Tech#play} event happens. Indicates that
     * playback has started or resumed.
     *
     * @event Player#play
     * @type {EventTarget~Event}
     */this.trigger('play');}/**
   * Retrigger the `ratechange` event that was triggered by the {@link Tech}.
   *
   * If there were any events queued while the playback rate was zero, fire
   * those events now.
   *
   * @private
   * @method Player#handleTechRateChange_
   * @fires Player#ratechange
   * @listens Tech#ratechange
   */;_proto.handleTechRateChange_=function handleTechRateChange_(){if(this.tech_.playbackRate()>0&&this.cache_.lastPlaybackRate===0){this.queuedCallbacks_.forEach(function(queued){return queued.callback(queued.event);});this.queuedCallbacks_=[];}this.cache_.lastPlaybackRate=this.tech_.playbackRate();/**
     * Fires when the playing speed of the audio/video is changed
     *
     * @event Player#ratechange
     * @type {event}
     */this.trigger('ratechange');}/**
   * Retrigger the `waiting` event that was triggered by the {@link Tech}.
   *
   * @fires Player#waiting
   * @listens Tech#waiting
   * @private
   */;_proto.handleTechWaiting_=function handleTechWaiting_(){var _this8=this;this.addClass('vjs-waiting');/**
     * A readyState change on the DOM element has caused playback to stop.
     *
     * @event Player#waiting
     * @type {EventTarget~Event}
     */this.trigger('waiting');// Browsers may emit a timeupdate event after a waiting event. In order to prevent
// premature removal of the waiting class, wait for the time to change.
var timeWhenWaiting=this.currentTime();var timeUpdateListener=function timeUpdateListener(){if(timeWhenWaiting!==_this8.currentTime()){_this8.removeClass('vjs-waiting');_this8.off('timeupdate',timeUpdateListener);}};this.on('timeupdate',timeUpdateListener);}/**
   * Retrigger the `canplay` event that was triggered by the {@link Tech}.
   * > Note: This is not consistent between browsers. See #1351
   *
   * @fires Player#canplay
   * @listens Tech#canplay
   * @private
   */;_proto.handleTechCanPlay_=function handleTechCanPlay_(){this.removeClass('vjs-waiting');/**
     * The media has a readyState of HAVE_FUTURE_DATA or greater.
     *
     * @event Player#canplay
     * @type {EventTarget~Event}
     */this.trigger('canplay');}/**
   * Retrigger the `canplaythrough` event that was triggered by the {@link Tech}.
   *
   * @fires Player#canplaythrough
   * @listens Tech#canplaythrough
   * @private
   */;_proto.handleTechCanPlayThrough_=function handleTechCanPlayThrough_(){this.removeClass('vjs-waiting');/**
     * The media has a readyState of HAVE_ENOUGH_DATA or greater. This means that the
     * entire media file can be played without buffering.
     *
     * @event Player#canplaythrough
     * @type {EventTarget~Event}
     */this.trigger('canplaythrough');}/**
   * Retrigger the `playing` event that was triggered by the {@link Tech}.
   *
   * @fires Player#playing
   * @listens Tech#playing
   * @private
   */;_proto.handleTechPlaying_=function handleTechPlaying_(){this.removeClass('vjs-waiting');/**
     * The media is no longer blocked from playback, and has started playing.
     *
     * @event Player#playing
     * @type {EventTarget~Event}
     */this.trigger('playing');}/**
   * Retrigger the `seeking` event that was triggered by the {@link Tech}.
   *
   * @fires Player#seeking
   * @listens Tech#seeking
   * @private
   */;_proto.handleTechSeeking_=function handleTechSeeking_(){this.addClass('vjs-seeking');/**
     * Fired whenever the player is jumping to a new time
     *
     * @event Player#seeking
     * @type {EventTarget~Event}
     */this.trigger('seeking');}/**
   * Retrigger the `seeked` event that was triggered by the {@link Tech}.
   *
   * @fires Player#seeked
   * @listens Tech#seeked
   * @private
   */;_proto.handleTechSeeked_=function handleTechSeeked_(){this.removeClass('vjs-seeking');this.removeClass('vjs-ended');/**
     * Fired when the player has finished jumping to a new time
     *
     * @event Player#seeked
     * @type {EventTarget~Event}
     */this.trigger('seeked');}/**
   * Retrigger the `firstplay` event that was triggered by the {@link Tech}.
   *
   * @fires Player#firstplay
   * @listens Tech#firstplay
   * @deprecated As of 6.0 firstplay event is deprecated.
   *             As of 6.0 passing the `starttime` option to the player and the firstplay event are deprecated.
   * @private
   */;_proto.handleTechFirstPlay_=function handleTechFirstPlay_(){// If the first starttime attribute is specified
// then we will start at the given offset in seconds
if(this.options_.starttime){log$1.warn('Passing the `starttime` option to the player will be deprecated in 6.0');this.currentTime(this.options_.starttime);}this.addClass('vjs-has-started');/**
     * Fired the first time a video is played. Not part of the HLS spec, and this is
     * probably not the best implementation yet, so use sparingly. If you don't have a
     * reason to prevent playback, use `myPlayer.one('play');` instead.
     *
     * @event Player#firstplay
     * @deprecated As of 6.0 firstplay event is deprecated.
     * @type {EventTarget~Event}
     */this.trigger('firstplay');}/**
   * Retrigger the `pause` event that was triggered by the {@link Tech}.
   *
   * @fires Player#pause
   * @listens Tech#pause
   * @private
   */;_proto.handleTechPause_=function handleTechPause_(){this.removeClass('vjs-playing');this.addClass('vjs-paused');/**
     * Fired whenever the media has been paused
     *
     * @event Player#pause
     * @type {EventTarget~Event}
     */this.trigger('pause');}/**
   * Retrigger the `ended` event that was triggered by the {@link Tech}.
   *
   * @fires Player#ended
   * @listens Tech#ended
   * @private
   */;_proto.handleTechEnded_=function handleTechEnded_(){this.addClass('vjs-ended');this.removeClass('vjs-waiting');if(this.options_.loop){this.currentTime(0);this.play();}else if(!this.paused()){this.pause();}/**
     * Fired when the end of the media resource is reached (currentTime == duration)
     *
     * @event Player#ended
     * @type {EventTarget~Event}
     */this.trigger('ended');}/**
   * Fired when the duration of the media resource is first known or changed
   *
   * @listens Tech#durationchange
   * @private
   */;_proto.handleTechDurationChange_=function handleTechDurationChange_(){this.duration(this.techGet_('duration'));}/**
   * Handle a click on the media element to play/pause
   *
   * @param {EventTarget~Event} event
   *        the event that caused this function to trigger
   *
   * @listens Tech#click
   * @private
   */;_proto.handleTechClick_=function handleTechClick_(event){// When controls are disabled a click should not toggle playback because
// the click is considered a control
if(!this.controls_){return;}if(this.options_===undefined||this.options_.userActions===undefined||this.options_.userActions.click===undefined||this.options_.userActions.click!==false){if(this.options_!==undefined&&this.options_.userActions!==undefined&&typeof this.options_.userActions.click==='function'){this.options_.userActions.click.call(this,event);}else if(this.paused()){silencePromise(this.play());}else{this.pause();}}}/**
   * Handle a double-click on the media element to enter/exit fullscreen
   *
   * @param {EventTarget~Event} event
   *        the event that caused this function to trigger
   *
   * @listens Tech#dblclick
   * @private
   */;_proto.handleTechDoubleClick_=function handleTechDoubleClick_(event){if(!this.controls_){return;}// we do not want to toggle fullscreen state
// when double-clicking inside a control bar or a modal
var inAllowedEls=Array.prototype.some.call(this.$$('.vjs-control-bar, .vjs-modal-dialog'),function(el){return el.contains(event.target);});if(!inAllowedEls){/*
       * options.userActions.doubleClick
       *
       * If `undefined` or `true`, double-click toggles fullscreen if controls are present
       * Set to `false` to disable double-click handling
       * Set to a function to substitute an external double-click handler
       */if(this.options_===undefined||this.options_.userActions===undefined||this.options_.userActions.doubleClick===undefined||this.options_.userActions.doubleClick!==false){if(this.options_!==undefined&&this.options_.userActions!==undefined&&typeof this.options_.userActions.doubleClick==='function'){this.options_.userActions.doubleClick.call(this,event);}else if(this.isFullscreen()){this.exitFullscreen();}else{this.requestFullscreen();}}}}/**
   * Handle a tap on the media element. It will toggle the user
   * activity state, which hides and shows the controls.
   *
   * @listens Tech#tap
   * @private
   */;_proto.handleTechTap_=function handleTechTap_(){this.userActive(!this.userActive());}/**
   * Handle touch to start
   *
   * @listens Tech#touchstart
   * @private
   */;_proto.handleTechTouchStart_=function handleTechTouchStart_(){this.userWasActive=this.userActive();}/**
   * Handle touch to move
   *
   * @listens Tech#touchmove
   * @private
   */;_proto.handleTechTouchMove_=function handleTechTouchMove_(){if(this.userWasActive){this.reportUserActivity();}}/**
   * Handle touch to end
   *
   * @param {EventTarget~Event} event
   *        the touchend event that triggered
   *        this function
   *
   * @listens Tech#touchend
   * @private
   */;_proto.handleTechTouchEnd_=function handleTechTouchEnd_(event){// Stop the mouse events from also happening
if(event.cancelable){event.preventDefault();}}/**
   * native click events on the SWF aren't triggered on IE11, Win8.1RT
   * use stageclick events triggered from inside the SWF instead
   *
   * @private
   * @listens stageclick
   */;_proto.handleStageClick_=function handleStageClick_(){this.reportUserActivity();}/**
   * @private
   */;_proto.toggleFullscreenClass_=function toggleFullscreenClass_(){if(this.isFullscreen()){this.addClass('vjs-fullscreen');}else{this.removeClass('vjs-fullscreen');}}/**
   * when the document fschange event triggers it calls this
   */;_proto.documentFullscreenChange_=function documentFullscreenChange_(e){var targetPlayer=e.target.player;// if another player was fullscreen
// do a null check for targetPlayer because older firefox's would put document as e.target
if(targetPlayer&&targetPlayer!==this){return;}var el=this.el();var isFs=(document_default())[this.fsApi_.fullscreenElement]===el;if(!isFs&&el.matches){isFs=el.matches(':'+this.fsApi_.fullscreen);}else if(!isFs&&el.msMatchesSelector){isFs=el.msMatchesSelector(':'+this.fsApi_.fullscreen);}this.isFullscreen(isFs);}/**
   * Handle Tech Fullscreen Change
   *
   * @param {EventTarget~Event} event
   *        the fullscreenchange event that triggered this function
   *
   * @param {Object} data
   *        the data that was sent with the event
   *
   * @private
   * @listens Tech#fullscreenchange
   * @fires Player#fullscreenchange
   */;_proto.handleTechFullscreenChange_=function handleTechFullscreenChange_(event,data){var _this9=this;if(data){if(data.nativeIOSFullscreen){this.addClass('vjs-ios-native-fs');this.tech_.one('webkitendfullscreen',function(){_this9.removeClass('vjs-ios-native-fs');});}this.isFullscreen(data.isFullscreen);}};_proto.handleTechFullscreenError_=function handleTechFullscreenError_(event,err){this.trigger('fullscreenerror',err);}/**
   * @private
   */;_proto.togglePictureInPictureClass_=function togglePictureInPictureClass_(){if(this.isInPictureInPicture()){this.addClass('vjs-picture-in-picture');}else{this.removeClass('vjs-picture-in-picture');}}/**
   * Handle Tech Enter Picture-in-Picture.
   *
   * @param {EventTarget~Event} event
   *        the enterpictureinpicture event that triggered this function
   *
   * @private
   * @listens Tech#enterpictureinpicture
   */;_proto.handleTechEnterPictureInPicture_=function handleTechEnterPictureInPicture_(event){this.isInPictureInPicture(true);}/**
   * Handle Tech Leave Picture-in-Picture.
   *
   * @param {EventTarget~Event} event
   *        the leavepictureinpicture event that triggered this function
   *
   * @private
   * @listens Tech#leavepictureinpicture
   */;_proto.handleTechLeavePictureInPicture_=function handleTechLeavePictureInPicture_(event){this.isInPictureInPicture(false);}/**
   * Fires when an error occurred during the loading of an audio/video.
   *
   * @private
   * @listens Tech#error
   */;_proto.handleTechError_=function handleTechError_(){var error=this.tech_.error();this.error(error);}/**
   * Retrigger the `textdata` event that was triggered by the {@link Tech}.
   *
   * @fires Player#textdata
   * @listens Tech#textdata
   * @private
   */;_proto.handleTechTextData_=function handleTechTextData_(){var data=null;if(arguments.length>1){data=arguments[1];}/**
     * Fires when we get a textdata event from tech
     *
     * @event Player#textdata
     * @type {EventTarget~Event}
     */this.trigger('textdata',data);}/**
   * Get object for cached values.
   *
   * @return {Object}
   *         get the current object cache
   */;_proto.getCache=function getCache(){return this.cache_;}/**
   * Resets the internal cache object.
   *
   * Using this function outside the player constructor or reset method may
   * have unintended side-effects.
   *
   * @private
   */;_proto.resetCache_=function resetCache_(){this.cache_={// Right now, the currentTime is not _really_ cached because it is always
// retrieved from the tech (see: currentTime). However, for completeness,
// we set it to zero here to ensure that if we do start actually caching
// it, we reset it along with everything else.
currentTime:0,initTime:0,inactivityTimeout:this.options_.inactivityTimeout,duration:NaN,lastVolume:1,lastPlaybackRate:this.defaultPlaybackRate(),media:null,src:'',source:{},sources:[],playbackRates:[],volume:1};}/**
   * Pass values to the playback tech
   *
   * @param {string} [method]
   *        the method to call
   *
   * @param {Object} arg
   *        the argument to pass
   *
   * @private
   */;_proto.techCall_=function techCall_(method,arg){// If it's not ready yet, call method when it is
this.ready(function(){if(method in allowedSetters){return set(this.middleware_,this.tech_,method,arg);}else if(method in allowedMediators){return mediate(this.middleware_,this.tech_,method,arg);}try{if(this.tech_){this.tech_[method](arg);}}catch(e){log$1(e);throw e;}},true);}/**
   * Get calls can't wait for the tech, and sometimes don't need to.
   *
   * @param {string} method
   *        Tech method
   *
   * @return {Function|undefined}
   *         the method or undefined
   *
   * @private
   */;_proto.techGet_=function techGet_(method){if(!this.tech_||!this.tech_.isReady_){return;}if(method in allowedGetters){return get(this.middleware_,this.tech_,method);}else if(method in allowedMediators){return mediate(this.middleware_,this.tech_,method);}// Flash likes to die and reload when you hide or reposition it.
// In these cases the object methods go away and we get errors.
// TODO: Is this needed for techs other than Flash?
// When that happens we'll catch the errors and inform tech that it's not ready any more.
try{return this.tech_[method]();}catch(e){// When building additional tech libs, an expected method may not be defined yet
if(this.tech_[method]===undefined){log$1("Video.js: "+method+" method not defined for "+this.techName_+" playback technology.",e);throw e;}// When a method isn't available on the object it throws a TypeError
if(e.name==='TypeError'){log$1("Video.js: "+method+" unavailable on "+this.techName_+" playback technology element.",e);this.tech_.isReady_=false;throw e;}// If error unknown, just log and throw
log$1(e);throw e;}}/**
   * Attempt to begin playback at the first opportunity.
   *
   * @return {Promise|undefined}
   *         Returns a promise if the browser supports Promises (or one
   *         was passed in as an option). This promise will be resolved on
   *         the return value of play. If this is undefined it will fulfill the
   *         promise chain otherwise the promise chain will be fulfilled when
   *         the promise from play is fulfilled.
   */;_proto.play=function play(){var _this10=this;var PromiseClass=this.options_.Promise||(window_default()).Promise;if(PromiseClass){return new PromiseClass(function(resolve){_this10.play_(resolve);});}return this.play_();}/**
   * The actual logic for play, takes a callback that will be resolved on the
   * return value of play. This allows us to resolve to the play promise if there
   * is one on modern browsers.
   *
   * @private
   * @param {Function} [callback]
   *        The callback that should be called when the techs play is actually called
   */;_proto.play_=function play_(callback){var _this11=this;if(callback===void 0){callback=silencePromise;}this.playCallbacks_.push(callback);var isSrcReady=Boolean(!this.changingSrc_&&(this.src()||this.currentSrc()));var isSafariOrIOS=Boolean(IS_ANY_SAFARI||IS_IOS);// treat calls to play_ somewhat like the `one` event function
if(this.waitToPlay_){this.off(['ready','loadstart'],this.waitToPlay_);this.waitToPlay_=null;}// if the player/tech is not ready or the src itself is not ready
// queue up a call to play on `ready` or `loadstart`
if(!this.isReady_||!isSrcReady){this.waitToPlay_=function(e){_this11.play_();};this.one(['ready','loadstart'],this.waitToPlay_);// if we are in Safari, there is a high chance that loadstart will trigger after the gesture timeperiod
// in that case, we need to prime the video element by calling load so it'll be ready in time
if(!isSrcReady&&isSafariOrIOS){this.load();}return;}// If the player/tech is ready and we have a source, we can attempt playback.
var val=this.techGet_('play');// For native playback, reset the progress bar if we get a play call from a replay.
var isNativeReplay=isSafariOrIOS&&this.hasClass('vjs-ended');if(isNativeReplay){this.resetProgressBar_();}// play was terminated if the returned value is null
if(val===null){this.runPlayTerminatedQueue_();}else{this.runPlayCallbacks_(val);}}/**
   * These functions will be run when if play is terminated. If play
   * runPlayCallbacks_ is run these function will not be run. This allows us
   * to differenciate between a terminated play and an actual call to play.
   */;_proto.runPlayTerminatedQueue_=function runPlayTerminatedQueue_(){var queue=this.playTerminatedQueue_.slice(0);this.playTerminatedQueue_=[];queue.forEach(function(q){q();});}/**
   * When a callback to play is delayed we have to run these
   * callbacks when play is actually called on the tech. This function
   * runs the callbacks that were delayed and accepts the return value
   * from the tech.
   *
   * @param {undefined|Promise} val
   *        The return value from the tech.
   */;_proto.runPlayCallbacks_=function runPlayCallbacks_(val){var callbacks=this.playCallbacks_.slice(0);this.playCallbacks_=[];// clear play terminatedQueue since we finished a real play
this.playTerminatedQueue_=[];callbacks.forEach(function(cb){cb(val);});}/**
   * Pause the video playback
   *
   * @return {Player}
   *         A reference to the player object this function was called on
   */;_proto.pause=function pause(){this.techCall_('pause');}/**
   * Check if the player is paused or has yet to play
   *
   * @return {boolean}
   *         - false: if the media is currently playing
   *         - true: if media is not currently playing
   */;_proto.paused=function paused(){// The initial state of paused should be true (in Safari it's actually false)
return this.techGet_('paused')===false?false:true;}/**
   * Get a TimeRange object representing the current ranges of time that the user
   * has played.
   *
   * @return {TimeRange}
   *         A time range object that represents all the increments of time that have
   *         been played.
   */;_proto.played=function played(){return this.techGet_('played')||createTimeRanges(0,0);}/**
   * Returns whether or not the user is "scrubbing". Scrubbing is
   * when the user has clicked the progress bar handle and is
   * dragging it along the progress bar.
   *
   * @param {boolean} [isScrubbing]
   *        whether the user is or is not scrubbing
   *
   * @return {boolean}
   *         The value of scrubbing when getting
   */;_proto.scrubbing=function scrubbing(isScrubbing){if(typeof isScrubbing==='undefined'){return this.scrubbing_;}this.scrubbing_=!!isScrubbing;this.techCall_('setScrubbing',this.scrubbing_);if(isScrubbing){this.addClass('vjs-scrubbing');}else{this.removeClass('vjs-scrubbing');}}/**
   * Get or set the current time (in seconds)
   *
   * @param {number|string} [seconds]
   *        The time to seek to in seconds
   *
   * @return {number}
   *         - the current time in seconds when getting
   */;_proto.currentTime=function currentTime(seconds){if(typeof seconds!=='undefined'){if(seconds<0){seconds=0;}if(!this.isReady_||this.changingSrc_||!this.tech_||!this.tech_.isReady_){this.cache_.initTime=seconds;this.off('canplay',this.boundApplyInitTime_);this.one('canplay',this.boundApplyInitTime_);return;}this.techCall_('setCurrentTime',seconds);this.cache_.initTime=0;return;}// cache last currentTime and return. default to 0 seconds
//
// Caching the currentTime is meant to prevent a massive amount of reads on the tech's
// currentTime when scrubbing, but may not provide much performance benefit afterall.
// Should be tested. Also something has to read the actual current time or the cache will
// never get updated.
this.cache_.currentTime=this.techGet_('currentTime')||0;return this.cache_.currentTime;}/**
   * Apply the value of initTime stored in cache as currentTime.
   *
   * @private
   */;_proto.applyInitTime_=function applyInitTime_(){this.currentTime(this.cache_.initTime);}/**
   * Normally gets the length in time of the video in seconds;
   * in all but the rarest use cases an argument will NOT be passed to the method
   *
   * > **NOTE**: The video must have started loading before the duration can be
   * known, and depending on preload behaviour may not be known until the video starts
   * playing.
   *
   * @fires Player#durationchange
   *
   * @param {number} [seconds]
   *        The duration of the video to set in seconds
   *
   * @return {number}
   *         - The duration of the video in seconds when getting
   */;_proto.duration=function duration(seconds){if(seconds===undefined){// return NaN if the duration is not known
return this.cache_.duration!==undefined?this.cache_.duration:NaN;}seconds=parseFloat(seconds);// Standardize on Infinity for signaling video is live
if(seconds<0){seconds=Infinity;}if(seconds!==this.cache_.duration){// Cache the last set value for optimized scrubbing (esp. Flash)
// TODO: Required for techs other than Flash?
this.cache_.duration=seconds;if(seconds===Infinity){this.addClass('vjs-live');}else{this.removeClass('vjs-live');}if(!isNaN(seconds)){// Do not fire durationchange unless the duration value is known.
// @see [Spec]{@link https://www.w3.org/TR/2011/WD-html5-20110113/video.html#media-element-load-algorithm}
/**
         * @event Player#durationchange
         * @type {EventTarget~Event}
         */this.trigger('durationchange');}}}/**
   * Calculates how much time is left in the video. Not part
   * of the native video API.
   *
   * @return {number}
   *         The time remaining in seconds
   */;_proto.remainingTime=function remainingTime(){return this.duration()-this.currentTime();}/**
   * A remaining time function that is intented to be used when
   * the time is to be displayed directly to the user.
   *
   * @return {number}
   *         The rounded time remaining in seconds
   */;_proto.remainingTimeDisplay=function remainingTimeDisplay(){return Math.floor(this.duration())-Math.floor(this.currentTime());}//
// Kind of like an array of portions of the video that have been downloaded.
/**
   * Get a TimeRange object with an array of the times of the video
   * that have been downloaded. If you just want the percent of the
   * video that's been downloaded, use bufferedPercent.
   *
   * @see [Buffered Spec]{@link http://dev.w3.org/html5/spec/video.html#dom-media-buffered}
   *
   * @return {TimeRange}
   *         A mock TimeRange object (following HTML spec)
   */;_proto.buffered=function buffered(){var buffered=this.techGet_('buffered');if(!buffered||!buffered.length){buffered=createTimeRanges(0,0);}return buffered;}/**
   * Get the percent (as a decimal) of the video that's been downloaded.
   * This method is not a part of the native HTML video API.
   *
   * @return {number}
   *         A decimal between 0 and 1 representing the percent
   *         that is buffered 0 being 0% and 1 being 100%
   */;_proto.bufferedPercent=function bufferedPercent$1(){return bufferedPercent(this.buffered(),this.duration());}/**
   * Get the ending time of the last buffered time range
   * This is used in the progress bar to encapsulate all time ranges.
   *
   * @return {number}
   *         The end of the last buffered time range
   */;_proto.bufferedEnd=function bufferedEnd(){var buffered=this.buffered();var duration=this.duration();var end=buffered.end(buffered.length-1);if(end>duration){end=duration;}return end;}/**
   * Get or set the current volume of the media
   *
   * @param  {number} [percentAsDecimal]
   *         The new volume as a decimal percent:
   *         - 0 is muted/0%/off
   *         - 1.0 is 100%/full
   *         - 0.5 is half volume or 50%
   *
   * @return {number}
   *         The current volume as a percent when getting
   */;_proto.volume=function volume(percentAsDecimal){var vol;if(percentAsDecimal!==undefined){// Force value to between 0 and 1
vol=Math.max(0,Math.min(1,parseFloat(percentAsDecimal)));this.cache_.volume=vol;this.techCall_('setVolume',vol);if(vol>0){this.lastVolume_(vol);}return;}// Default to 1 when returning current volume.
vol=parseFloat(this.techGet_('volume'));return isNaN(vol)?1:vol;}/**
   * Get the current muted state, or turn mute on or off
   *
   * @param {boolean} [muted]
   *        - true to mute
   *        - false to unmute
   *
   * @return {boolean}
   *         - true if mute is on and getting
   *         - false if mute is off and getting
   */;_proto.muted=function muted(_muted){if(_muted!==undefined){this.techCall_('setMuted',_muted);return;}return this.techGet_('muted')||false;}/**
   * Get the current defaultMuted state, or turn defaultMuted on or off. defaultMuted
   * indicates the state of muted on initial playback.
   *
   * ```js
   *   var myPlayer = videojs('some-player-id');
   *
   *   myPlayer.src("http://www.example.com/path/to/video.mp4");
   *
   *   // get, should be false
   *   console.log(myPlayer.defaultMuted());
   *   // set to true
   *   myPlayer.defaultMuted(true);
   *   // get should be true
   *   console.log(myPlayer.defaultMuted());
   * ```
   *
   * @param {boolean} [defaultMuted]
   *        - true to mute
   *        - false to unmute
   *
   * @return {boolean|Player}
   *         - true if defaultMuted is on and getting
   *         - false if defaultMuted is off and getting
   *         - A reference to the current player when setting
   */;_proto.defaultMuted=function defaultMuted(_defaultMuted){if(_defaultMuted!==undefined){return this.techCall_('setDefaultMuted',_defaultMuted);}return this.techGet_('defaultMuted')||false;}/**
   * Get the last volume, or set it
   *
   * @param  {number} [percentAsDecimal]
   *         The new last volume as a decimal percent:
   *         - 0 is muted/0%/off
   *         - 1.0 is 100%/full
   *         - 0.5 is half volume or 50%
   *
   * @return {number}
   *         the current value of lastVolume as a percent when getting
   *
   * @private
   */;_proto.lastVolume_=function lastVolume_(percentAsDecimal){if(percentAsDecimal!==undefined&&percentAsDecimal!==0){this.cache_.lastVolume=percentAsDecimal;return;}return this.cache_.lastVolume;}/**
   * Check if current tech can support native fullscreen
   * (e.g. with built in controls like iOS)
   *
   * @return {boolean}
   *         if native fullscreen is supported
   */;_proto.supportsFullScreen=function supportsFullScreen(){return this.techGet_('supportsFullScreen')||false;}/**
   * Check if the player is in fullscreen mode or tell the player that it
   * is or is not in fullscreen mode.
   *
   * > NOTE: As of the latest HTML5 spec, isFullscreen is no longer an official
   * property and instead document.fullscreenElement is used. But isFullscreen is
   * still a valuable property for internal player workings.
   *
   * @param  {boolean} [isFS]
   *         Set the players current fullscreen state
   *
   * @return {boolean}
   *         - true if fullscreen is on and getting
   *         - false if fullscreen is off and getting
   */;_proto.isFullscreen=function isFullscreen(isFS){if(isFS!==undefined){var oldValue=this.isFullscreen_;this.isFullscreen_=Boolean(isFS);// if we changed fullscreen state and we're in prefixed mode, trigger fullscreenchange
// this is the only place where we trigger fullscreenchange events for older browsers
// fullWindow mode is treated as a prefixed event and will get a fullscreenchange event as well
if(this.isFullscreen_!==oldValue&&this.fsApi_.prefixed){/**
           * @event Player#fullscreenchange
           * @type {EventTarget~Event}
           */this.trigger('fullscreenchange');}this.toggleFullscreenClass_();return;}return this.isFullscreen_;}/**
   * Increase the size of the video to full screen
   * In some browsers, full screen is not supported natively, so it enters
   * "full window mode", where the video fills the browser window.
   * In browsers and devices that support native full screen, sometimes the
   * browser's default controls will be shown, and not the Video.js custom skin.
   * This includes most mobile devices (iOS, Android) and older versions of
   * Safari.
   *
   * @param  {Object} [fullscreenOptions]
   *         Override the player fullscreen options
   *
   * @fires Player#fullscreenchange
   */;_proto.requestFullscreen=function requestFullscreen(fullscreenOptions){var PromiseClass=this.options_.Promise||(window_default()).Promise;if(PromiseClass){var self=this;return new PromiseClass(function(resolve,reject){function offHandler(){self.off('fullscreenerror',errorHandler);self.off('fullscreenchange',changeHandler);}function changeHandler(){offHandler();resolve();}function errorHandler(e,err){offHandler();reject(err);}self.one('fullscreenchange',changeHandler);self.one('fullscreenerror',errorHandler);var promise=self.requestFullscreenHelper_(fullscreenOptions);if(promise){promise.then(offHandler,offHandler);promise.then(resolve,reject);}});}return this.requestFullscreenHelper_();};_proto.requestFullscreenHelper_=function requestFullscreenHelper_(fullscreenOptions){var _this12=this;var fsOptions;// Only pass fullscreen options to requestFullscreen in spec-compliant browsers.
// Use defaults or player configured option unless passed directly to this method.
if(!this.fsApi_.prefixed){fsOptions=this.options_.fullscreen&&this.options_.fullscreen.options||{};if(fullscreenOptions!==undefined){fsOptions=fullscreenOptions;}}// This method works as follows:
// 1. if a fullscreen api is available, use it
//   1. call requestFullscreen with potential options
//   2. if we got a promise from above, use it to update isFullscreen()
// 2. otherwise, if the tech supports fullscreen, call `enterFullScreen` on it.
//   This is particularly used for iPhone, older iPads, and non-safari browser on iOS.
// 3. otherwise, use "fullWindow" mode
if(this.fsApi_.requestFullscreen){var promise=this.el_[this.fsApi_.requestFullscreen](fsOptions);if(promise){promise.then(function(){return _this12.isFullscreen(true);},function(){return _this12.isFullscreen(false);});}return promise;}else if(this.tech_.supportsFullScreen()&&!this.options_.preferFullWindow===true){// we can't take the video.js controls fullscreen but we can go fullscreen
// with native controls
this.techCall_('enterFullScreen');}else{// fullscreen isn't supported so we'll just stretch the video element to
// fill the viewport
this.enterFullWindow();}}/**
   * Return the video to its normal size after having been in full screen mode
   *
   * @fires Player#fullscreenchange
   */;_proto.exitFullscreen=function exitFullscreen(){var PromiseClass=this.options_.Promise||(window_default()).Promise;if(PromiseClass){var self=this;return new PromiseClass(function(resolve,reject){function offHandler(){self.off('fullscreenerror',errorHandler);self.off('fullscreenchange',changeHandler);}function changeHandler(){offHandler();resolve();}function errorHandler(e,err){offHandler();reject(err);}self.one('fullscreenchange',changeHandler);self.one('fullscreenerror',errorHandler);var promise=self.exitFullscreenHelper_();if(promise){promise.then(offHandler,offHandler);// map the promise to our resolve/reject methods
promise.then(resolve,reject);}});}return this.exitFullscreenHelper_();};_proto.exitFullscreenHelper_=function exitFullscreenHelper_(){var _this13=this;if(this.fsApi_.requestFullscreen){var promise=(document_default())[this.fsApi_.exitFullscreen]();if(promise){// we're splitting the promise here, so, we want to catch the
// potential error so that this chain doesn't have unhandled errors
silencePromise(promise.then(function(){return _this13.isFullscreen(false);}));}return promise;}else if(this.tech_.supportsFullScreen()&&!this.options_.preferFullWindow===true){this.techCall_('exitFullScreen');}else{this.exitFullWindow();}}/**
   * When fullscreen isn't supported we can stretch the
   * video container to as wide as the browser will let us.
   *
   * @fires Player#enterFullWindow
   */;_proto.enterFullWindow=function enterFullWindow(){this.isFullscreen(true);this.isFullWindow=true;// Storing original doc overflow value to return to when fullscreen is off
this.docOrigOverflow=(document_default()).documentElement.style.overflow;// Add listener for esc key to exit fullscreen
on((document_default()),'keydown',this.boundFullWindowOnEscKey_);// Hide any scroll bars
(document_default()).documentElement.style.overflow='hidden';// Apply fullscreen styles
addClass((document_default()).body,'vjs-full-window');/**
     * @event Player#enterFullWindow
     * @type {EventTarget~Event}
     */this.trigger('enterFullWindow');}/**
   * Check for call to either exit full window or
   * full screen on ESC key
   *
   * @param {string} event
   *        Event to check for key press
   */;_proto.fullWindowOnEscKey=function fullWindowOnEscKey(event){if(keycode_default().isEventKey(event,'Esc')){if(this.isFullscreen()===true){if(!this.isFullWindow){this.exitFullscreen();}else{this.exitFullWindow();}}}}/**
   * Exit full window
   *
   * @fires Player#exitFullWindow
   */;_proto.exitFullWindow=function exitFullWindow(){this.isFullscreen(false);this.isFullWindow=false;off((document_default()),'keydown',this.boundFullWindowOnEscKey_);// Unhide scroll bars.
(document_default()).documentElement.style.overflow=this.docOrigOverflow;// Remove fullscreen styles
removeClass((document_default()).body,'vjs-full-window');// Resize the box, controller, and poster to original sizes
// this.positionAll();
/**
     * @event Player#exitFullWindow
     * @type {EventTarget~Event}
     */this.trigger('exitFullWindow');}/**
   * Disable Picture-in-Picture mode.
   *
   * @param {boolean} value
   *                  - true will disable Picture-in-Picture mode
   *                  - false will enable Picture-in-Picture mode
   */;_proto.disablePictureInPicture=function disablePictureInPicture(value){if(value===undefined){return this.techGet_('disablePictureInPicture');}this.techCall_('setDisablePictureInPicture',value);this.options_.disablePictureInPicture=value;this.trigger('disablepictureinpicturechanged');}/**
   * Check if the player is in Picture-in-Picture mode or tell the player that it
   * is or is not in Picture-in-Picture mode.
   *
   * @param  {boolean} [isPiP]
   *         Set the players current Picture-in-Picture state
   *
   * @return {boolean}
   *         - true if Picture-in-Picture is on and getting
   *         - false if Picture-in-Picture is off and getting
   */;_proto.isInPictureInPicture=function isInPictureInPicture(isPiP){if(isPiP!==undefined){this.isInPictureInPicture_=!!isPiP;this.togglePictureInPictureClass_();return;}return!!this.isInPictureInPicture_;}/**
   * Create a floating video window always on top of other windows so that users may
   * continue consuming media while they interact with other content sites, or
   * applications on their device.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @fires Player#enterpictureinpicture
   *
   * @return {Promise}
   *         A promise with a Picture-in-Picture window.
   */;_proto.requestPictureInPicture=function requestPictureInPicture(){if('pictureInPictureEnabled'in (document_default())&&this.disablePictureInPicture()===false){/**
       * This event fires when the player enters picture in picture mode
       *
       * @event Player#enterpictureinpicture
       * @type {EventTarget~Event}
       */return this.techGet_('requestPictureInPicture');}}/**
   * Exit Picture-in-Picture mode.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @fires Player#leavepictureinpicture
   *
   * @return {Promise}
   *         A promise.
   */;_proto.exitPictureInPicture=function exitPictureInPicture(){if('pictureInPictureEnabled'in (document_default())){/**
       * This event fires when the player leaves picture in picture mode
       *
       * @event Player#leavepictureinpicture
       * @type {EventTarget~Event}
       */return document_default().exitPictureInPicture();}}/**
   * Called when this Player has focus and a key gets pressed down, or when
   * any Component of this player receives a key press that it doesn't handle.
   * This allows player-wide hotkeys (either as defined below, or optionally
   * by an external function).
   *
   * @param {EventTarget~Event} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */;_proto.handleKeyDown=function handleKeyDown(event){var userActions=this.options_.userActions;// Bail out if hotkeys are not configured.
if(!userActions||!userActions.hotkeys){return;}// Function that determines whether or not to exclude an element from
// hotkeys handling.
var excludeElement=function excludeElement(el){var tagName=el.tagName.toLowerCase();// The first and easiest test is for `contenteditable` elements.
if(el.isContentEditable){return true;}// Inputs matching these types will still trigger hotkey handling as
// they are not text inputs.
var allowedInputTypes=['button','checkbox','hidden','radio','reset','submit'];if(tagName==='input'){return allowedInputTypes.indexOf(el.type)===-1;}// The final test is by tag name. These tags will be excluded entirely.
var excludedTags=['textarea'];return excludedTags.indexOf(tagName)!==-1;};// Bail out if the user is focused on an interactive form element.
if(excludeElement(this.el_.ownerDocument.activeElement)){return;}if(typeof userActions.hotkeys==='function'){userActions.hotkeys.call(this,event);}else{this.handleHotkeys(event);}}/**
   * Called when this Player receives a hotkey keydown event.
   * Supported player-wide hotkeys are:
   *
   *   f          - toggle fullscreen
   *   m          - toggle mute
   *   k or Space - toggle play/pause
   *
   * @param {EventTarget~Event} event
   *        The `keydown` event that caused this function to be called.
   */;_proto.handleHotkeys=function handleHotkeys(event){var hotkeys=this.options_.userActions?this.options_.userActions.hotkeys:{};// set fullscreenKey, muteKey, playPauseKey from `hotkeys`, use defaults if not set
var _hotkeys$fullscreenKe=hotkeys.fullscreenKey,fullscreenKey=_hotkeys$fullscreenKe===void 0?function(keydownEvent){return keycode_default().isEventKey(keydownEvent,'f');}:_hotkeys$fullscreenKe,_hotkeys$muteKey=hotkeys.muteKey,muteKey=_hotkeys$muteKey===void 0?function(keydownEvent){return keycode_default().isEventKey(keydownEvent,'m');}:_hotkeys$muteKey,_hotkeys$playPauseKey=hotkeys.playPauseKey,playPauseKey=_hotkeys$playPauseKey===void 0?function(keydownEvent){return keycode_default().isEventKey(keydownEvent,'k')||keycode_default().isEventKey(keydownEvent,'Space');}:_hotkeys$playPauseKey;if(fullscreenKey.call(this,event)){event.preventDefault();event.stopPropagation();var FSToggle=Component$1.getComponent('FullscreenToggle');if((document_default())[this.fsApi_.fullscreenEnabled]!==false){FSToggle.prototype.handleClick.call(this,event);}}else if(muteKey.call(this,event)){event.preventDefault();event.stopPropagation();var MuteToggle=Component$1.getComponent('MuteToggle');MuteToggle.prototype.handleClick.call(this,event);}else if(playPauseKey.call(this,event)){event.preventDefault();event.stopPropagation();var PlayToggle=Component$1.getComponent('PlayToggle');PlayToggle.prototype.handleClick.call(this,event);}}/**
   * Check whether the player can play a given mimetype
   *
   * @see https://www.w3.org/TR/2011/WD-html5-20110113/video.html#dom-navigator-canplaytype
   *
   * @param {string} type
   *        The mimetype to check
   *
   * @return {string}
   *         'probably', 'maybe', or '' (empty string)
   */;_proto.canPlayType=function canPlayType(type){var can;// Loop through each playback technology in the options order
for(var i=0,j=this.options_.techOrder;i<j.length;i++){var techName=j[i];var tech=Tech.getTech(techName);// Support old behavior of techs being registered as components.
// Remove once that deprecated behavior is removed.
if(!tech){tech=Component$1.getComponent(techName);}// Check if the current tech is defined before continuing
if(!tech){log$1.error("The \""+techName+"\" tech is undefined. Skipped browser support check for that tech.");continue;}// Check if the browser supports this technology
if(tech.isSupported()){can=tech.canPlayType(type);if(can){return can;}}}return'';}/**
   * Select source based on tech-order or source-order
   * Uses source-order selection if `options.sourceOrder` is truthy. Otherwise,
   * defaults to tech-order selection
   *
   * @param {Array} sources
   *        The sources for a media asset
   *
   * @return {Object|boolean}
   *         Object of source and tech order or false
   */;_proto.selectSource=function selectSource(sources){var _this14=this;// Get only the techs specified in `techOrder` that exist and are supported by the
// current platform
var techs=this.options_.techOrder.map(function(techName){return[techName,Tech.getTech(techName)];}).filter(function(_ref){var techName=_ref[0],tech=_ref[1];// Check if the current tech is defined before continuing
if(tech){// Check if the browser supports this technology
return tech.isSupported();}log$1.error("The \""+techName+"\" tech is undefined. Skipped browser support check for that tech.");return false;});// Iterate over each `innerArray` element once per `outerArray` element and execute
// `tester` with both. If `tester` returns a non-falsy value, exit early and return
// that value.
var findFirstPassingTechSourcePair=function findFirstPassingTechSourcePair(outerArray,innerArray,tester){var found;outerArray.some(function(outerChoice){return innerArray.some(function(innerChoice){found=tester(outerChoice,innerChoice);if(found){return true;}});});return found;};var foundSourceAndTech;var flip=function flip(fn){return function(a,b){return fn(b,a);};};var finder=function finder(_ref2,source){var techName=_ref2[0],tech=_ref2[1];if(tech.canPlaySource(source,_this14.options_[techName.toLowerCase()])){return{source:source,tech:techName};}};// Depending on the truthiness of `options.sourceOrder`, we swap the order of techs and sources
// to select from them based on their priority.
if(this.options_.sourceOrder){// Source-first ordering
foundSourceAndTech=findFirstPassingTechSourcePair(sources,techs,flip(finder));}else{// Tech-first ordering
foundSourceAndTech=findFirstPassingTechSourcePair(techs,sources,finder);}return foundSourceAndTech||false;}/**
   * Executes source setting and getting logic
   *
   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
   *        A SourceObject, an array of SourceObjects, or a string referencing
   *        a URL to a media source. It is _highly recommended_ that an object
   *        or array of objects is used here, so that source selection
   *        algorithms can take the `type` into account.
   *
   *        If not provided, this method acts as a getter.
   * @param {boolean} isRetry
   *        Indicates whether this is being called internally as a result of a retry
   *
   * @return {string|undefined}
   *         If the `source` argument is missing, returns the current source
   *         URL. Otherwise, returns nothing/undefined.
   */;_proto.handleSrc_=function handleSrc_(source,isRetry){var _this15=this;// getter usage
if(typeof source==='undefined'){return this.cache_.src||'';}// Reset retry behavior for new source
if(this.resetRetryOnError_){this.resetRetryOnError_();}// filter out invalid sources and turn our source into
// an array of source objects
var sources=filterSource(source);// if a source was passed in then it is invalid because
// it was filtered to a zero length Array. So we have to
// show an error
if(!sources.length){this.setTimeout(function(){this.error({code:4,message:this.options_.notSupportedMessage});},0);return;}// initial sources
this.changingSrc_=true;// Only update the cached source list if we are not retrying a new source after error,
// since in that case we want to include the failed source(s) in the cache
if(!isRetry){this.cache_.sources=sources;}this.updateSourceCaches_(sources[0]);// middlewareSource is the source after it has been changed by middleware
setSource(this,sources[0],function(middlewareSource,mws){_this15.middleware_=mws;// since sourceSet is async we have to update the cache again after we select a source since
// the source that is selected could be out of order from the cache update above this callback.
if(!isRetry){_this15.cache_.sources=sources;}_this15.updateSourceCaches_(middlewareSource);var err=_this15.src_(middlewareSource);if(err){if(sources.length>1){return _this15.handleSrc_(sources.slice(1));}_this15.changingSrc_=false;// We need to wrap this in a timeout to give folks a chance to add error event handlers
_this15.setTimeout(function(){this.error({code:4,message:this.options_.notSupportedMessage});},0);// we could not find an appropriate tech, but let's still notify the delegate that this is it
// this needs a better comment about why this is needed
_this15.triggerReady();return;}setTech(mws,_this15.tech_);});// Try another available source if this one fails before playback.
if(this.options_.retryOnError&&sources.length>1){var retry=function retry(){// Remove the error modal
_this15.error(null);_this15.handleSrc_(sources.slice(1),true);};var stopListeningForErrors=function stopListeningForErrors(){_this15.off('error',retry);};this.one('error',retry);this.one('playing',stopListeningForErrors);this.resetRetryOnError_=function(){_this15.off('error',retry);_this15.off('playing',stopListeningForErrors);};}}/**
   * Get or set the video source.
   *
   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
   *        A SourceObject, an array of SourceObjects, or a string referencing
   *        a URL to a media source. It is _highly recommended_ that an object
   *        or array of objects is used here, so that source selection
   *        algorithms can take the `type` into account.
   *
   *        If not provided, this method acts as a getter.
   *
   * @return {string|undefined}
   *         If the `source` argument is missing, returns the current source
   *         URL. Otherwise, returns nothing/undefined.
   */;_proto.src=function src(source){return this.handleSrc_(source,false);}/**
   * Set the source object on the tech, returns a boolean that indicates whether
   * there is a tech that can play the source or not
   *
   * @param {Tech~SourceObject} source
   *        The source object to set on the Tech
   *
   * @return {boolean}
   *         - True if there is no Tech to playback this source
   *         - False otherwise
   *
   * @private
   */;_proto.src_=function src_(source){var _this16=this;var sourceTech=this.selectSource([source]);if(!sourceTech){return true;}if(!titleCaseEquals(sourceTech.tech,this.techName_)){this.changingSrc_=true;// load this technology with the chosen source
this.loadTech_(sourceTech.tech,sourceTech.source);this.tech_.ready(function(){_this16.changingSrc_=false;});return false;}// wait until the tech is ready to set the source
// and set it synchronously if possible (#2326)
this.ready(function(){// The setSource tech method was added with source handlers
// so older techs won't support it
// We need to check the direct prototype for the case where subclasses
// of the tech do not support source handlers
if(this.tech_.constructor.prototype.hasOwnProperty('setSource')){this.techCall_('setSource',source);}else{this.techCall_('src',source.src);}this.changingSrc_=false;},true);return false;}/**
   * Begin loading the src data.
   */;_proto.load=function load(){this.techCall_('load');}/**
   * Reset the player. Loads the first tech in the techOrder,
   * removes all the text tracks in the existing `tech`,
   * and calls `reset` on the `tech`.
   */;_proto.reset=function reset(){var _this17=this;var PromiseClass=this.options_.Promise||(window_default()).Promise;if(this.paused()||!PromiseClass){this.doReset_();}else{var playPromise=this.play();silencePromise(playPromise.then(function(){return _this17.doReset_();}));}};_proto.doReset_=function doReset_(){if(this.tech_){this.tech_.clearTracks('text');}this.resetCache_();this.poster('');this.loadTech_(this.options_.techOrder[0],null);this.techCall_('reset');this.resetControlBarUI_();if(isEvented(this)){this.trigger('playerreset');}}/**
   * Reset Control Bar's UI by calling sub-methods that reset
   * all of Control Bar's components
   */;_proto.resetControlBarUI_=function resetControlBarUI_(){this.resetProgressBar_();this.resetPlaybackRate_();this.resetVolumeBar_();}/**
   * Reset tech's progress so progress bar is reset in the UI
   */;_proto.resetProgressBar_=function resetProgressBar_(){this.currentTime(0);var _ref3=this.controlBar||{},durationDisplay=_ref3.durationDisplay,remainingTimeDisplay=_ref3.remainingTimeDisplay;if(durationDisplay){durationDisplay.updateContent();}if(remainingTimeDisplay){remainingTimeDisplay.updateContent();}}/**
   * Reset Playback ratio
   */;_proto.resetPlaybackRate_=function resetPlaybackRate_(){this.playbackRate(this.defaultPlaybackRate());this.handleTechRateChange_();}/**
   * Reset Volume bar
   */;_proto.resetVolumeBar_=function resetVolumeBar_(){this.volume(1.0);this.trigger('volumechange');}/**
   * Returns all of the current source objects.
   *
   * @return {Tech~SourceObject[]}
   *         The current source objects
   */;_proto.currentSources=function currentSources(){var source=this.currentSource();var sources=[];// assume `{}` or `{ src }`
if(Object.keys(source).length!==0){sources.push(source);}return this.cache_.sources||sources;}/**
   * Returns the current source object.
   *
   * @return {Tech~SourceObject}
   *         The current source object
   */;_proto.currentSource=function currentSource(){return this.cache_.source||{};}/**
   * Returns the fully qualified URL of the current source value e.g. http://mysite.com/video.mp4
   * Can be used in conjunction with `currentType` to assist in rebuilding the current source object.
   *
   * @return {string}
   *         The current source
   */;_proto.currentSrc=function currentSrc(){return this.currentSource()&&this.currentSource().src||'';}/**
   * Get the current source type e.g. video/mp4
   * This can allow you rebuild the current source object so that you could load the same
   * source and tech later
   *
   * @return {string}
   *         The source MIME type
   */;_proto.currentType=function currentType(){return this.currentSource()&&this.currentSource().type||'';}/**
   * Get or set the preload attribute
   *
   * @param {boolean} [value]
   *        - true means that we should preload
   *        - false means that we should not preload
   *
   * @return {string}
   *         The preload attribute value when getting
   */;_proto.preload=function preload(value){if(value!==undefined){this.techCall_('setPreload',value);this.options_.preload=value;return;}return this.techGet_('preload');}/**
   * Get or set the autoplay option. When this is a boolean it will
   * modify the attribute on the tech. When this is a string the attribute on
   * the tech will be removed and `Player` will handle autoplay on loadstarts.
   *
   * @param {boolean|string} [value]
   *        - true: autoplay using the browser behavior
   *        - false: do not autoplay
   *        - 'play': call play() on every loadstart
   *        - 'muted': call muted() then play() on every loadstart
   *        - 'any': call play() on every loadstart. if that fails call muted() then play().
   *        - *: values other than those listed here will be set `autoplay` to true
   *
   * @return {boolean|string}
   *         The current value of autoplay when getting
   */;_proto.autoplay=function autoplay(value){// getter usage
if(value===undefined){return this.options_.autoplay||false;}var techAutoplay;// if the value is a valid string set it to that, or normalize `true` to 'play', if need be
if(typeof value==='string'&&/(any|play|muted)/.test(value)||value===true&&this.options_.normalizeAutoplay){this.options_.autoplay=value;this.manualAutoplay_(typeof value==='string'?value:'play');techAutoplay=false;// any falsy value sets autoplay to false in the browser,
// lets do the same
}else if(!value){this.options_.autoplay=false;// any other value (ie truthy) sets autoplay to true
}else{this.options_.autoplay=true;}techAutoplay=typeof techAutoplay==='undefined'?this.options_.autoplay:techAutoplay;// if we don't have a tech then we do not queue up
// a setAutoplay call on tech ready. We do this because the
// autoplay option will be passed in the constructor and we
// do not need to set it twice
if(this.tech_){this.techCall_('setAutoplay',techAutoplay);}}/**
   * Set or unset the playsinline attribute.
   * Playsinline tells the browser that non-fullscreen playback is preferred.
   *
   * @param {boolean} [value]
   *        - true means that we should try to play inline by default
   *        - false means that we should use the browser's default playback mode,
   *          which in most cases is inline. iOS Safari is a notable exception
   *          and plays fullscreen by default.
   *
   * @return {string|Player}
   *         - the current value of playsinline
   *         - the player when setting
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
   */;_proto.playsinline=function playsinline(value){if(value!==undefined){this.techCall_('setPlaysinline',value);this.options_.playsinline=value;return this;}return this.techGet_('playsinline');}/**
   * Get or set the loop attribute on the video element.
   *
   * @param {boolean} [value]
   *        - true means that we should loop the video
   *        - false means that we should not loop the video
   *
   * @return {boolean}
   *         The current value of loop when getting
   */;_proto.loop=function loop(value){if(value!==undefined){this.techCall_('setLoop',value);this.options_.loop=value;return;}return this.techGet_('loop');}/**
   * Get or set the poster image source url
   *
   * @fires Player#posterchange
   *
   * @param {string} [src]
   *        Poster image source URL
   *
   * @return {string}
   *         The current value of poster when getting
   */;_proto.poster=function poster(src){if(src===undefined){return this.poster_;}// The correct way to remove a poster is to set as an empty string
// other falsey values will throw errors
if(!src){src='';}if(src===this.poster_){return;}// update the internal poster variable
this.poster_=src;// update the tech's poster
this.techCall_('setPoster',src);this.isPosterFromTech_=false;// alert components that the poster has been set
/**
     * This event fires when the poster image is changed on the player.
     *
     * @event Player#posterchange
     * @type {EventTarget~Event}
     */this.trigger('posterchange');}/**
   * Some techs (e.g. YouTube) can provide a poster source in an
   * asynchronous way. We want the poster component to use this
   * poster source so that it covers up the tech's controls.
   * (YouTube's play button). However we only want to use this
   * source if the player user hasn't set a poster through
   * the normal APIs.
   *
   * @fires Player#posterchange
   * @listens Tech#posterchange
   * @private
   */;_proto.handleTechPosterChange_=function handleTechPosterChange_(){if((!this.poster_||this.options_.techCanOverridePoster)&&this.tech_&&this.tech_.poster){var newPoster=this.tech_.poster()||'';if(newPoster!==this.poster_){this.poster_=newPoster;this.isPosterFromTech_=true;// Let components know the poster has changed
this.trigger('posterchange');}}}/**
   * Get or set whether or not the controls are showing.
   *
   * @fires Player#controlsenabled
   *
   * @param {boolean} [bool]
   *        - true to turn controls on
   *        - false to turn controls off
   *
   * @return {boolean}
   *         The current value of controls when getting
   */;_proto.controls=function controls(bool){if(bool===undefined){return!!this.controls_;}bool=!!bool;// Don't trigger a change event unless it actually changed
if(this.controls_===bool){return;}this.controls_=bool;if(this.usingNativeControls()){this.techCall_('setControls',bool);}if(this.controls_){this.removeClass('vjs-controls-disabled');this.addClass('vjs-controls-enabled');/**
       * @event Player#controlsenabled
       * @type {EventTarget~Event}
       */this.trigger('controlsenabled');if(!this.usingNativeControls()){this.addTechControlsListeners_();}}else{this.removeClass('vjs-controls-enabled');this.addClass('vjs-controls-disabled');/**
       * @event Player#controlsdisabled
       * @type {EventTarget~Event}
       */this.trigger('controlsdisabled');if(!this.usingNativeControls()){this.removeTechControlsListeners_();}}}/**
   * Toggle native controls on/off. Native controls are the controls built into
   * devices (e.g. default iPhone controls) or other techs
   * (e.g. Vimeo Controls)
   * **This should only be set by the current tech, because only the tech knows
   * if it can support native controls**
   *
   * @fires Player#usingnativecontrols
   * @fires Player#usingcustomcontrols
   *
   * @param {boolean} [bool]
   *        - true to turn native controls on
   *        - false to turn native controls off
   *
   * @return {boolean}
   *         The current value of native controls when getting
   */;_proto.usingNativeControls=function usingNativeControls(bool){if(bool===undefined){return!!this.usingNativeControls_;}bool=!!bool;// Don't trigger a change event unless it actually changed
if(this.usingNativeControls_===bool){return;}this.usingNativeControls_=bool;if(this.usingNativeControls_){this.addClass('vjs-using-native-controls');/**
       * player is using the native device controls
       *
       * @event Player#usingnativecontrols
       * @type {EventTarget~Event}
       */this.trigger('usingnativecontrols');}else{this.removeClass('vjs-using-native-controls');/**
       * player is using the custom HTML controls
       *
       * @event Player#usingcustomcontrols
       * @type {EventTarget~Event}
       */this.trigger('usingcustomcontrols');}}/**
   * Set or get the current MediaError
   *
   * @fires Player#error
   *
   * @param  {MediaError|string|number} [err]
   *         A MediaError or a string/number to be turned
   *         into a MediaError
   *
   * @return {MediaError|null}
   *         The current MediaError when getting (or null)
   */;_proto.error=function error(err){var _this18=this;if(err===undefined){return this.error_||null;}// allow hooks to modify error object
hooks('beforeerror').forEach(function(hookFunction){var newErr=hookFunction(_this18,err);if(!(video_es_isObject(newErr)&&!Array.isArray(newErr)||typeof newErr==='string'||typeof newErr==='number'||newErr===null)){_this18.log.error('please return a value that MediaError expects in beforeerror hooks');return;}err=newErr;});// Suppress the first error message for no compatible source until
// user interaction
if(this.options_.suppressNotSupportedError&&err&&err.code===4){var triggerSuppressedError=function triggerSuppressedError(){this.error(err);};this.options_.suppressNotSupportedError=false;this.any(['click','touchstart'],triggerSuppressedError);this.one('loadstart',function(){this.off(['click','touchstart'],triggerSuppressedError);});return;}// restoring to default
if(err===null){this.error_=err;this.removeClass('vjs-error');if(this.errorDisplay){this.errorDisplay.close();}return;}this.error_=new MediaError(err);// add the vjs-error classname to the player
this.addClass('vjs-error');// log the name of the error type and any message
// IE11 logs "[object object]" and required you to expand message to see error object
log$1.error("(CODE:"+this.error_.code+" "+MediaError.errorTypes[this.error_.code]+")",this.error_.message,this.error_);/**
     * @event Player#error
     * @type {EventTarget~Event}
     */this.trigger('error');// notify hooks of the per player error
hooks('error').forEach(function(hookFunction){return hookFunction(_this18,_this18.error_);});return;}/**
   * Report user activity
   *
   * @param {Object} event
   *        Event object
   */;_proto.reportUserActivity=function reportUserActivity(event){this.userActivity_=true;}/**
   * Get/set if user is active
   *
   * @fires Player#useractive
   * @fires Player#userinactive
   *
   * @param {boolean} [bool]
   *        - true if the user is active
   *        - false if the user is inactive
   *
   * @return {boolean}
   *         The current value of userActive when getting
   */;_proto.userActive=function userActive(bool){if(bool===undefined){return this.userActive_;}bool=!!bool;if(bool===this.userActive_){return;}this.userActive_=bool;if(this.userActive_){this.userActivity_=true;this.removeClass('vjs-user-inactive');this.addClass('vjs-user-active');/**
       * @event Player#useractive
       * @type {EventTarget~Event}
       */this.trigger('useractive');return;}// Chrome/Safari/IE have bugs where when you change the cursor it can
// trigger a mousemove event. This causes an issue when you're hiding
// the cursor when the user is inactive, and a mousemove signals user
// activity. Making it impossible to go into inactive mode. Specifically
// this happens in fullscreen when we really need to hide the cursor.
//
// When this gets resolved in ALL browsers it can be removed
// https://code.google.com/p/chromium/issues/detail?id=103041
if(this.tech_){this.tech_.one('mousemove',function(e){e.stopPropagation();e.preventDefault();});}this.userActivity_=false;this.removeClass('vjs-user-active');this.addClass('vjs-user-inactive');/**
     * @event Player#userinactive
     * @type {EventTarget~Event}
     */this.trigger('userinactive');}/**
   * Listen for user activity based on timeout value
   *
   * @private
   */;_proto.listenForUserActivity_=function listenForUserActivity_(){var mouseInProgress;var lastMoveX;var lastMoveY;var handleActivity=bind(this,this.reportUserActivity);var handleMouseMove=function handleMouseMove(e){// #1068 - Prevent mousemove spamming
// Chrome Bug: https://code.google.com/p/chromium/issues/detail?id=366970
if(e.screenX!==lastMoveX||e.screenY!==lastMoveY){lastMoveX=e.screenX;lastMoveY=e.screenY;handleActivity();}};var handleMouseDown=function handleMouseDown(){handleActivity();// For as long as the they are touching the device or have their mouse down,
// we consider them active even if they're not moving their finger or mouse.
// So we want to continue to update that they are active
this.clearInterval(mouseInProgress);// Setting userActivity=true now and setting the interval to the same time
// as the activityCheck interval (250) should ensure we never miss the
// next activityCheck
mouseInProgress=this.setInterval(handleActivity,250);};var handleMouseUpAndMouseLeave=function handleMouseUpAndMouseLeave(event){handleActivity();// Stop the interval that maintains activity if the mouse/touch is down
this.clearInterval(mouseInProgress);};// Any mouse movement will be considered user activity
this.on('mousedown',handleMouseDown);this.on('mousemove',handleMouseMove);this.on('mouseup',handleMouseUpAndMouseLeave);this.on('mouseleave',handleMouseUpAndMouseLeave);var controlBar=this.getChild('controlBar');// Fixes bug on Android & iOS where when tapping progressBar (when control bar is displayed)
// controlBar would no longer be hidden by default timeout.
if(controlBar&&!IS_IOS&&!IS_ANDROID){controlBar.on('mouseenter',function(event){if(this.player().options_.inactivityTimeout!==0){this.player().cache_.inactivityTimeout=this.player().options_.inactivityTimeout;}this.player().options_.inactivityTimeout=0;});controlBar.on('mouseleave',function(event){this.player().options_.inactivityTimeout=this.player().cache_.inactivityTimeout;});}// Listen for keyboard navigation
// Shouldn't need to use inProgress interval because of key repeat
this.on('keydown',handleActivity);this.on('keyup',handleActivity);// Run an interval every 250 milliseconds instead of stuffing everything into
// the mousemove/touchmove function itself, to prevent performance degradation.
// `this.reportUserActivity` simply sets this.userActivity_ to true, which
// then gets picked up by this loop
// http://ejohn.org/blog/learning-from-twitter/
var inactivityTimeout;this.setInterval(function(){// Check to see if mouse/touch activity has happened
if(!this.userActivity_){return;}// Reset the activity tracker
this.userActivity_=false;// If the user state was inactive, set the state to active
this.userActive(true);// Clear any existing inactivity timeout to start the timer over
this.clearTimeout(inactivityTimeout);var timeout=this.options_.inactivityTimeout;if(timeout<=0){return;}// In <timeout> milliseconds, if no more activity has occurred the
// user will be considered inactive
inactivityTimeout=this.setTimeout(function(){// Protect against the case where the inactivityTimeout can trigger just
// before the next user activity is picked up by the activity check loop
// causing a flicker
if(!this.userActivity_){this.userActive(false);}},timeout);},250);}/**
   * Gets or sets the current playback rate. A playback rate of
   * 1.0 represents normal speed and 0.5 would indicate half-speed
   * playback, for instance.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-playbackrate
   *
   * @param {number} [rate]
   *       New playback rate to set.
   *
   * @return {number}
   *         The current playback rate when getting or 1.0
   */;_proto.playbackRate=function playbackRate(rate){if(rate!==undefined){// NOTE: this.cache_.lastPlaybackRate is set from the tech handler
// that is registered above
this.techCall_('setPlaybackRate',rate);return;}if(this.tech_&&this.tech_.featuresPlaybackRate){return this.cache_.lastPlaybackRate||this.techGet_('playbackRate');}return 1.0;}/**
   * Gets or sets the current default playback rate. A default playback rate of
   * 1.0 represents normal speed and 0.5 would indicate half-speed playback, for instance.
   * defaultPlaybackRate will only represent what the initial playbackRate of a video was, not
   * not the current playbackRate.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-defaultplaybackrate
   *
   * @param {number} [rate]
   *       New default playback rate to set.
   *
   * @return {number|Player}
   *         - The default playback rate when getting or 1.0
   *         - the player when setting
   */;_proto.defaultPlaybackRate=function defaultPlaybackRate(rate){if(rate!==undefined){return this.techCall_('setDefaultPlaybackRate',rate);}if(this.tech_&&this.tech_.featuresPlaybackRate){return this.techGet_('defaultPlaybackRate');}return 1.0;}/**
   * Gets or sets the audio flag
   *
   * @param {boolean} bool
   *        - true signals that this is an audio player
   *        - false signals that this is not an audio player
   *
   * @return {boolean}
   *         The current value of isAudio when getting
   */;_proto.isAudio=function isAudio(bool){if(bool!==undefined){this.isAudio_=!!bool;return;}return!!this.isAudio_;};_proto.enableAudioOnlyUI_=function enableAudioOnlyUI_(){var _this19=this;// Update styling immediately to show the control bar so we can get its height
this.addClass('vjs-audio-only-mode');var playerChildren=this.children();var controlBar=this.getChild('ControlBar');var controlBarHeight=controlBar&&controlBar.currentHeight();// Hide all player components except the control bar. Control bar components
// needed only for video are hidden with CSS
playerChildren.forEach(function(child){if(child===controlBar){return;}if(child.el_&&!child.hasClass('vjs-hidden')){child.hide();_this19.audioOnlyCache_.hiddenChildren.push(child);}});this.audioOnlyCache_.playerHeight=this.currentHeight();// Set the player height the same as the control bar
this.height(controlBarHeight);this.trigger('audioonlymodechange');};_proto.disableAudioOnlyUI_=function disableAudioOnlyUI_(){this.removeClass('vjs-audio-only-mode');// Show player components that were previously hidden
this.audioOnlyCache_.hiddenChildren.forEach(function(child){return child.show();});// Reset player height
this.height(this.audioOnlyCache_.playerHeight);this.trigger('audioonlymodechange');}/**
   * Get the current audioOnlyMode state or set audioOnlyMode to true or false.
   *
   * Setting this to `true` will hide all player components except the control bar,
   * as well as control bar components needed only for video.
   *
   * @param {boolean} [value]
   *         The value to set audioOnlyMode to.
   *
   * @return {Promise|boolean}
   *        A Promise is returned when setting the state, and a boolean when getting
   *        the present state
   */;_proto.audioOnlyMode=function audioOnlyMode(value){var _this20=this;if(typeof value!=='boolean'||value===this.audioOnlyMode_){return this.audioOnlyMode_;}this.audioOnlyMode_=value;var PromiseClass=this.options_.Promise||(window_default()).Promise;if(PromiseClass){// Enable Audio Only Mode
if(value){var exitPromises=[];// Fullscreen and PiP are not supported in audioOnlyMode, so exit if we need to.
if(this.isInPictureInPicture()){exitPromises.push(this.exitPictureInPicture());}if(this.isFullscreen()){exitPromises.push(this.exitFullscreen());}if(this.audioPosterMode()){exitPromises.push(this.audioPosterMode(false));}return PromiseClass.all(exitPromises).then(function(){return _this20.enableAudioOnlyUI_();});}// Disable Audio Only Mode
return PromiseClass.resolve().then(function(){return _this20.disableAudioOnlyUI_();});}if(value){if(this.isInPictureInPicture()){this.exitPictureInPicture();}if(this.isFullscreen()){this.exitFullscreen();}this.enableAudioOnlyUI_();}else{this.disableAudioOnlyUI_();}};_proto.enablePosterModeUI_=function enablePosterModeUI_(){// Hide the video element and show the poster image to enable posterModeUI
var tech=this.tech_&&this.tech_;tech.hide();this.addClass('vjs-audio-poster-mode');this.trigger('audiopostermodechange');};_proto.disablePosterModeUI_=function disablePosterModeUI_(){// Show the video element and hide the poster image to disable posterModeUI
var tech=this.tech_&&this.tech_;tech.show();this.removeClass('vjs-audio-poster-mode');this.trigger('audiopostermodechange');}/**
   * Get the current audioPosterMode state or set audioPosterMode to true or false
   *
   * @param {boolean} [value]
   *         The value to set audioPosterMode to.
   *
   * @return {Promise|boolean}
   *         A Promise is returned when setting the state, and a boolean when getting
   *        the present state
   */;_proto.audioPosterMode=function audioPosterMode(value){var _this21=this;if(typeof value!=='boolean'||value===this.audioPosterMode_){return this.audioPosterMode_;}this.audioPosterMode_=value;var PromiseClass=this.options_.Promise||(window_default()).Promise;if(PromiseClass){if(value){if(this.audioOnlyMode()){var audioOnlyModePromise=this.audioOnlyMode(false);return audioOnlyModePromise.then(function(){// enable audio poster mode after audio only mode is disabled
_this21.enablePosterModeUI_();});}return PromiseClass.resolve().then(function(){// enable audio poster mode
_this21.enablePosterModeUI_();});}return PromiseClass.resolve().then(function(){// disable audio poster mode
_this21.disablePosterModeUI_();});}if(value){if(this.audioOnlyMode()){this.audioOnlyMode(false);}this.enablePosterModeUI_();return;}this.disablePosterModeUI_();}/**
   * A helper method for adding a {@link TextTrack} to our
   * {@link TextTrackList}.
   *
   * In addition to the W3C settings we allow adding additional info through options.
   *
   * @see http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-addtexttrack
   *
   * @param {string} [kind]
   *        the kind of TextTrack you are adding
   *
   * @param {string} [label]
   *        the label to give the TextTrack label
   *
   * @param {string} [language]
   *        the language to set on the TextTrack
   *
   * @return {TextTrack|undefined}
   *         the TextTrack that was added or undefined
   *         if there is no tech
   */;_proto.addTextTrack=function addTextTrack(kind,label,language){if(this.tech_){return this.tech_.addTextTrack(kind,label,language);}}/**
   * Create a remote {@link TextTrack} and an {@link HTMLTrackElement}.
   * When manualCleanup is set to false, the track will be automatically removed
   * on source changes.
   *
   * @param {Object} options
   *        Options to pass to {@link HTMLTrackElement} during creation. See
   *        {@link HTMLTrackElement} for object properties that you should use.
   *
   * @param {boolean} [manualCleanup=true] if set to false, the TextTrack will be
   *                                       removed on a source change
   *
   * @return {HtmlTrackElement}
   *         the HTMLTrackElement that was created and added
   *         to the HtmlTrackElementList and the remote
   *         TextTrackList
   *
   * @deprecated The default value of the "manualCleanup" parameter will default
   *             to "false" in upcoming versions of Video.js
   */;_proto.addRemoteTextTrack=function addRemoteTextTrack(options,manualCleanup){if(this.tech_){return this.tech_.addRemoteTextTrack(options,manualCleanup);}}/**
   * Remove a remote {@link TextTrack} from the respective
   * {@link TextTrackList} and {@link HtmlTrackElementList}.
   *
   * @param {Object} track
   *        Remote {@link TextTrack} to remove
   *
   * @return {undefined}
   *         does not return anything
   */;_proto.removeRemoteTextTrack=function removeRemoteTextTrack(obj){if(obj===void 0){obj={};}var _obj=obj,track=_obj.track;if(!track){track=obj;}// destructure the input into an object with a track argument, defaulting to arguments[0]
// default the whole argument to an empty object if nothing was passed in
if(this.tech_){return this.tech_.removeRemoteTextTrack(track);}}/**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object|undefined}
   *         An object with supported media playback quality metrics or undefined if there
   *         is no tech or the tech does not support it.
   */;_proto.getVideoPlaybackQuality=function getVideoPlaybackQuality(){return this.techGet_('getVideoPlaybackQuality');}/**
   * Get video width
   *
   * @return {number}
   *         current video width
   */;_proto.videoWidth=function videoWidth(){return this.tech_&&this.tech_.videoWidth&&this.tech_.videoWidth()||0;}/**
   * Get video height
   *
   * @return {number}
   *         current video height
   */;_proto.videoHeight=function videoHeight(){return this.tech_&&this.tech_.videoHeight&&this.tech_.videoHeight()||0;}/**
   * The player's language code.
   *
   * Changing the language will trigger
   * [languagechange]{@link Player#event:languagechange}
   * which Components can use to update control text.
   * ClickableComponent will update its control text by default on
   * [languagechange]{@link Player#event:languagechange}.
   *
   * @fires Player#languagechange
   *
   * @param {string} [code]
   *        the language code to set the player to
   *
   * @return {string}
   *         The current language code when getting
   */;_proto.language=function language(code){if(code===undefined){return this.language_;}if(this.language_!==String(code).toLowerCase()){this.language_=String(code).toLowerCase();// during first init, it's possible some things won't be evented
if(isEvented(this)){/**
        * fires when the player language change
        *
        * @event Player#languagechange
        * @type {EventTarget~Event}
        */this.trigger('languagechange');}}}/**
   * Get the player's language dictionary
   * Merge every time, because a newly added plugin might call videojs.addLanguage() at any time
   * Languages specified directly in the player options have precedence
   *
   * @return {Array}
   *         An array of of supported languages
   */;_proto.languages=function languages(){return mergeOptions$3(Player.prototype.options_.languages,this.languages_);}/**
   * returns a JavaScript object reperesenting the current track
   * information. **DOES not return it as JSON**
   *
   * @return {Object}
   *         Object representing the current of track info
   */;_proto.toJSON=function toJSON(){var options=mergeOptions$3(this.options_);var tracks=options.tracks;options.tracks=[];for(var i=0;i<tracks.length;i++){var track=tracks[i];// deep merge tracks and null out player so no circular references
track=mergeOptions$3(track);track.player=undefined;options.tracks[i]=track;}return options;}/**
   * Creates a simple modal dialog (an instance of the {@link ModalDialog}
   * component) that immediately overlays the player with arbitrary
   * content and removes itself when closed.
   *
   * @param {string|Function|Element|Array|null} content
   *        Same as {@link ModalDialog#content}'s param of the same name.
   *        The most straight-forward usage is to provide a string or DOM
   *        element.
   *
   * @param {Object} [options]
   *        Extra options which will be passed on to the {@link ModalDialog}.
   *
   * @return {ModalDialog}
   *         the {@link ModalDialog} that was created
   */;_proto.createModal=function createModal(content,options){var _this22=this;options=options||{};options.content=content||'';var modal=new ModalDialog(this,options);this.addChild(modal);modal.on('dispose',function(){_this22.removeChild(modal);});modal.open();return modal;}/**
   * Change breakpoint classes when the player resizes.
   *
   * @private
   */;_proto.updateCurrentBreakpoint_=function updateCurrentBreakpoint_(){if(!this.responsive()){return;}var currentBreakpoint=this.currentBreakpoint();var currentWidth=this.currentWidth();for(var i=0;i<BREAKPOINT_ORDER.length;i++){var candidateBreakpoint=BREAKPOINT_ORDER[i];var maxWidth=this.breakpoints_[candidateBreakpoint];if(currentWidth<=maxWidth){// The current breakpoint did not change, nothing to do.
if(currentBreakpoint===candidateBreakpoint){return;}// Only remove a class if there is a current breakpoint.
if(currentBreakpoint){this.removeClass(BREAKPOINT_CLASSES[currentBreakpoint]);}this.addClass(BREAKPOINT_CLASSES[candidateBreakpoint]);this.breakpoint_=candidateBreakpoint;break;}}}/**
   * Removes the current breakpoint.
   *
   * @private
   */;_proto.removeCurrentBreakpoint_=function removeCurrentBreakpoint_(){var className=this.currentBreakpointClass();this.breakpoint_='';if(className){this.removeClass(className);}}/**
   * Get or set breakpoints on the player.
   *
   * Calling this method with an object or `true` will remove any previous
   * custom breakpoints and start from the defaults again.
   *
   * @param  {Object|boolean} [breakpoints]
   *         If an object is given, it can be used to provide custom
   *         breakpoints. If `true` is given, will set default breakpoints.
   *         If this argument is not given, will simply return the current
   *         breakpoints.
   *
   * @param  {number} [breakpoints.tiny]
   *         The maximum width for the "vjs-layout-tiny" class.
   *
   * @param  {number} [breakpoints.xsmall]
   *         The maximum width for the "vjs-layout-x-small" class.
   *
   * @param  {number} [breakpoints.small]
   *         The maximum width for the "vjs-layout-small" class.
   *
   * @param  {number} [breakpoints.medium]
   *         The maximum width for the "vjs-layout-medium" class.
   *
   * @param  {number} [breakpoints.large]
   *         The maximum width for the "vjs-layout-large" class.
   *
   * @param  {number} [breakpoints.xlarge]
   *         The maximum width for the "vjs-layout-x-large" class.
   *
   * @param  {number} [breakpoints.huge]
   *         The maximum width for the "vjs-layout-huge" class.
   *
   * @return {Object}
   *         An object mapping breakpoint names to maximum width values.
   */;_proto.breakpoints=function breakpoints(_breakpoints){// Used as a getter.
if(_breakpoints===undefined){return video_es_assign(this.breakpoints_);}this.breakpoint_='';this.breakpoints_=video_es_assign({},DEFAULT_BREAKPOINTS,_breakpoints);// When breakpoint definitions change, we need to update the currently
// selected breakpoint.
this.updateCurrentBreakpoint_();// Clone the breakpoints before returning.
return video_es_assign(this.breakpoints_);}/**
   * Get or set a flag indicating whether or not this player should adjust
   * its UI based on its dimensions.
   *
   * @param  {boolean} value
   *         Should be `true` if the player should adjust its UI based on its
   *         dimensions; otherwise, should be `false`.
   *
   * @return {boolean}
   *         Will be `true` if this player should adjust its UI based on its
   *         dimensions; otherwise, will be `false`.
   */;_proto.responsive=function responsive(value){// Used as a getter.
if(value===undefined){return this.responsive_;}value=Boolean(value);var current=this.responsive_;// Nothing changed.
if(value===current){return;}// The value actually changed, set it.
this.responsive_=value;// Start listening for breakpoints and set the initial breakpoint if the
// player is now responsive.
if(value){this.on('playerresize',this.boundUpdateCurrentBreakpoint_);this.updateCurrentBreakpoint_();// Stop listening for breakpoints if the player is no longer responsive.
}else{this.off('playerresize',this.boundUpdateCurrentBreakpoint_);this.removeCurrentBreakpoint_();}return value;}/**
   * Get current breakpoint name, if any.
   *
   * @return {string}
   *         If there is currently a breakpoint set, returns a the key from the
   *         breakpoints object matching it. Otherwise, returns an empty string.
   */;_proto.currentBreakpoint=function currentBreakpoint(){return this.breakpoint_;}/**
   * Get the current breakpoint class name.
   *
   * @return {string}
   *         The matching class name (e.g. `"vjs-layout-tiny"` or
   *         `"vjs-layout-large"`) for the current breakpoint. Empty string if
   *         there is no current breakpoint.
   */;_proto.currentBreakpointClass=function currentBreakpointClass(){return BREAKPOINT_CLASSES[this.breakpoint_]||'';}/**
   * An object that describes a single piece of media.
   *
   * Properties that are not part of this type description will be retained; so,
   * this can be viewed as a generic metadata storage mechanism as well.
   *
   * @see      {@link https://wicg.github.io/mediasession/#the-mediametadata-interface}
   * @typedef  {Object} Player~MediaObject
   *
   * @property {string} [album]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {string} [artist]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {Object[]} [artwork]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API. If not specified, will be populated via the `poster`, if
   *           available.
   *
   * @property {string} [poster]
   *           URL to an image that will display before playback.
   *
   * @property {Tech~SourceObject|Tech~SourceObject[]|string} [src]
   *           A single source object, an array of source objects, or a string
   *           referencing a URL to a media source. It is _highly recommended_
   *           that an object or array of objects is used here, so that source
   *           selection algorithms can take the `type` into account.
   *
   * @property {string} [title]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {Object[]} [textTracks]
   *           An array of objects to be used to create text tracks, following
   *           the {@link https://www.w3.org/TR/html50/embedded-content-0.html#the-track-element|native track element format}.
   *           For ease of removal, these will be created as "remote" text
   *           tracks and set to automatically clean up on source changes.
   *
   *           These objects may have properties like `src`, `kind`, `label`,
   *           and `language`, see {@link Tech#createRemoteTextTrack}.
   */ /**
   * Populate the player using a {@link Player~MediaObject|MediaObject}.
   *
   * @param  {Player~MediaObject} media
   *         A media object.
   *
   * @param  {Function} ready
   *         A callback to be called when the player is ready.
   */;_proto.loadMedia=function loadMedia(media,ready){var _this23=this;if(!media||video_es_typeof(media)!=='object'){return;}this.reset();// Clone the media object so it cannot be mutated from outside.
this.cache_.media=mergeOptions$3(media);var _this$cache_$media=this.cache_.media,artwork=_this$cache_$media.artwork,poster=_this$cache_$media.poster,src=_this$cache_$media.src,textTracks=_this$cache_$media.textTracks;// If `artwork` is not given, create it using `poster`.
if(!artwork&&poster){this.cache_.media.artwork=[{src:poster,type:getMimetype(poster)}];}if(src){this.src(src);}if(poster){this.poster(poster);}if(Array.isArray(textTracks)){textTracks.forEach(function(tt){return _this23.addRemoteTextTrack(tt,false);});}this.ready(ready);}/**
   * Get a clone of the current {@link Player~MediaObject} for this player.
   *
   * If the `loadMedia` method has not been used, will attempt to return a
   * {@link Player~MediaObject} based on the current state of the player.
   *
   * @return {Player~MediaObject}
   */;_proto.getMedia=function getMedia(){if(!this.cache_.media){var poster=this.poster();var src=this.currentSources();var textTracks=Array.prototype.map.call(this.remoteTextTracks(),function(tt){return{kind:tt.kind,label:tt.label,language:tt.language,src:tt.src};});var media={src:src,textTracks:textTracks};if(poster){media.poster=poster;media.artwork=[{src:media.poster,type:getMimetype(media.poster)}];}return media;}return mergeOptions$3(this.cache_.media);}/**
   * Gets tag settings
   *
   * @param {Element} tag
   *        The player tag
   *
   * @return {Object}
   *         An object containing all of the settings
   *         for a player tag
   */;Player.getTagSettings=function getTagSettings(tag){var baseOptions={sources:[],tracks:[]};var tagOptions=getAttributes(tag);var dataSetup=tagOptions['data-setup'];if(hasClass(tag,'vjs-fill')){tagOptions.fill=true;}if(hasClass(tag,'vjs-fluid')){tagOptions.fluid=true;}// Check if data-setup attr exists.
if(dataSetup!==null){// Parse options JSON
// If empty string, make it a parsable json object.
var _safeParseTuple=tuple_default()(dataSetup||'{}'),err=_safeParseTuple[0],data=_safeParseTuple[1];if(err){log$1.error(err);}video_es_assign(tagOptions,data);}video_es_assign(baseOptions,tagOptions);// Get tag children settings
if(tag.hasChildNodes()){var children=tag.childNodes;for(var i=0,j=children.length;i<j;i++){var child=children[i];// Change case needed: http://ejohn.org/blog/nodename-case-sensitivity/
var childName=child.nodeName.toLowerCase();if(childName==='source'){baseOptions.sources.push(getAttributes(child));}else if(childName==='track'){baseOptions.tracks.push(getAttributes(child));}}}return baseOptions;}/**
   * Determine whether or not flexbox is supported
   *
   * @return {boolean}
   *         - true if flexbox is supported
   *         - false if flexbox is not supported
   */;_proto.flexNotSupported_=function flexNotSupported_(){var elem=document_default().createElement('i');// Note: We don't actually use flexBasis (or flexOrder), but it's one of the more
// common flex features that we can rely on when checking for flex support.
return!('flexBasis'in elem.style||'webkitFlexBasis'in elem.style||'mozFlexBasis'in elem.style||'msFlexBasis'in elem.style||// IE10-specific (2012 flex spec), available for completeness
'msFlexOrder'in elem.style);}/**
   * Set debug mode to enable/disable logs at info level.
   *
   * @param {boolean} enabled
   * @fires Player#debugon
   * @fires Player#debugoff
   */;_proto.debug=function debug(enabled){if(enabled===undefined){return this.debugEnabled_;}if(enabled){this.trigger('debugon');this.previousLogLevel_=this.log.level;this.log.level('debug');this.debugEnabled_=true;}else{this.trigger('debugoff');this.log.level(this.previousLogLevel_);this.previousLogLevel_=undefined;this.debugEnabled_=false;}}/**
   * Set or get current playback rates.
   * Takes an array and updates the playback rates menu with the new items.
   * Pass in an empty array to hide the menu.
   * Values other than arrays are ignored.
   *
   * @fires Player#playbackrateschange
   * @param {number[]} newRates
   *                   The new rates that the playback rates menu should update to.
   *                   An empty array will hide the menu
   * @return {number[]} When used as a getter will return the current playback rates
   */;_proto.playbackRates=function playbackRates(newRates){if(newRates===undefined){return this.cache_.playbackRates;}// ignore any value that isn't an array
if(!Array.isArray(newRates)){return;}// ignore any arrays that don't only contain numbers
if(!newRates.every(function(rate){return typeof rate==='number';})){return;}this.cache_.playbackRates=newRates;/**
    * fires when the playback rates in a player are changed
    *
    * @event Player#playbackrateschange
    * @type {EventTarget~Event}
    */this.trigger('playbackrateschange');};return Player;}(Component$1);/**
 * Get the {@link VideoTrackList}
 * @link https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist
 *
 * @return {VideoTrackList}
 *         the current video track list
 *
 * @method Player.prototype.videoTracks
 */ /**
 * Get the {@link AudioTrackList}
 * @link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist
 *
 * @return {AudioTrackList}
 *         the current audio track list
 *
 * @method Player.prototype.audioTracks
 */ /**
 * Get the {@link TextTrackList}
 *
 * @link http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-texttracks
 *
 * @return {TextTrackList}
 *         the current text track list
 *
 * @method Player.prototype.textTracks
 */ /**
 * Get the remote {@link TextTrackList}
 *
 * @return {TextTrackList}
 *         The current remote text track list
 *
 * @method Player.prototype.remoteTextTracks
 */ /**
 * Get the remote {@link HtmlTrackElementList} tracks.
 *
 * @return {HtmlTrackElementList}
 *         The current remote text track element list
 *
 * @method Player.prototype.remoteTextTrackEls
 */ALL.names.forEach(function(name){var props=ALL[name];Player.prototype[props.getterName]=function(){if(this.tech_){return this.tech_[props.getterName]();}// if we have not yet loadTech_, we create {video,audio,text}Tracks_
// these will be passed to the tech during loading
this[props.privateName]=this[props.privateName]||new props.ListClass();return this[props.privateName];};});/**
 * Get or set the `Player`'s crossorigin option. For the HTML5 player, this
 * sets the `crossOrigin` property on the `<video>` tag to control the CORS
 * behavior.
 *
 * @see [Video Element Attributes]{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#attr-crossorigin}
 *
 * @param {string} [value]
 *        The value to set the `Player`'s crossorigin to. If an argument is
 *        given, must be one of `anonymous` or `use-credentials`.
 *
 * @return {string|undefined}
 *         - The current crossorigin value of the `Player` when getting.
 *         - undefined when setting
 */Player.prototype.crossorigin=Player.prototype.crossOrigin;/**
 * Global enumeration of players.
 *
 * The keys are the player IDs and the values are either the {@link Player}
 * instance or `null` for disposed players.
 *
 * @type {Object}
 */Player.players={};var video_es_navigator=(window_default()).navigator;/*
 * Player instance options, surfaced using options
 * options = Player.prototype.options_
 * Make changes in options, not here.
 *
 * @type {Object}
 * @private
 */Player.prototype.options_={// Default order of fallback technology
techOrder:Tech.defaultTechOrder_,html5:{},// default inactivity timeout
inactivityTimeout:2000,// default playback rates
playbackRates:[],// Add playback rate selection by adding rates
// 'playbackRates': [0.5, 1, 1.5, 2],
liveui:false,// Included control sets
children:['mediaLoader','posterImage','textTrackDisplay','loadingSpinner','bigPlayButton','liveTracker','controlBar','errorDisplay','textTrackSettings','resizeManager'],language:video_es_navigator&&(video_es_navigator.languages&&video_es_navigator.languages[0]||video_es_navigator.userLanguage||video_es_navigator.language)||'en',// locales and their language translations
languages:{},// Default message to show when a video cannot be played.
notSupportedMessage:'No compatible source was found for this media.',normalizeAutoplay:false,fullscreen:{options:{navigationUI:'hide'}},breakpoints:{},responsive:false,audioOnlyMode:false,audioPosterMode:false};[/**
 * Returns whether or not the player is in the "ended" state.
 *
 * @return {Boolean} True if the player is in the ended state, false if not.
 * @method Player#ended
 */'ended',/**
 * Returns whether or not the player is in the "seeking" state.
 *
 * @return {Boolean} True if the player is in the seeking state, false if not.
 * @method Player#seeking
 */'seeking',/**
 * Returns the TimeRanges of the media that are currently available
 * for seeking to.
 *
 * @return {TimeRanges} the seekable intervals of the media timeline
 * @method Player#seekable
 */'seekable',/**
 * Returns the current state of network activity for the element, from
 * the codes in the list below.
 * - NETWORK_EMPTY (numeric value 0)
 *   The element has not yet been initialised. All attributes are in
 *   their initial states.
 * - NETWORK_IDLE (numeric value 1)
 *   The element's resource selection algorithm is active and has
 *   selected a resource, but it is not actually using the network at
 *   this time.
 * - NETWORK_LOADING (numeric value 2)
 *   The user agent is actively trying to download data.
 * - NETWORK_NO_SOURCE (numeric value 3)
 *   The element's resource selection algorithm is active, but it has
 *   not yet found a resource to use.
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#network-states
 * @return {number} the current network activity state
 * @method Player#networkState
 */'networkState',/**
 * Returns a value that expresses the current state of the element
 * with respect to rendering the current playback position, from the
 * codes in the list below.
 * - HAVE_NOTHING (numeric value 0)
 *   No information regarding the media resource is available.
 * - HAVE_METADATA (numeric value 1)
 *   Enough of the resource has been obtained that the duration of the
 *   resource is available.
 * - HAVE_CURRENT_DATA (numeric value 2)
 *   Data for the immediate current playback position is available.
 * - HAVE_FUTURE_DATA (numeric value 3)
 *   Data for the immediate current playback position is available, as
 *   well as enough data for the user agent to advance the current
 *   playback position in the direction of playback.
 * - HAVE_ENOUGH_DATA (numeric value 4)
 *   The user agent estimates that enough data is available for
 *   playback to proceed uninterrupted.
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-readystate
 * @return {number} the current playback rendering state
 * @method Player#readyState
 */'readyState'].forEach(function(fn){Player.prototype[fn]=function(){return this.techGet_(fn);};});TECH_EVENTS_RETRIGGER.forEach(function(event){Player.prototype["handleTech"+toTitleCase$1(event)+"_"]=function(){return this.trigger(event);};});/**
 * Fired when the player has initial duration and dimension information
 *
 * @event Player#loadedmetadata
 * @type {EventTarget~Event}
 */ /**
 * Fired when the player has downloaded data at the current playback position
 *
 * @event Player#loadeddata
 * @type {EventTarget~Event}
 */ /**
 * Fired when the current playback position has changed *
 * During playback this is fired every 15-250 milliseconds, depending on the
 * playback technology in use.
 *
 * @event Player#timeupdate
 * @type {EventTarget~Event}
 */ /**
 * Fired when the volume changes
 *
 * @event Player#volumechange
 * @type {EventTarget~Event}
 */ /**
 * Reports whether or not a player has a plugin available.
 *
 * This does not report whether or not the plugin has ever been initialized
 * on this player. For that, [usingPlugin]{@link Player#usingPlugin}.
 *
 * @method Player#hasPlugin
 * @param  {string}  name
 *         The name of a plugin.
 *
 * @return {boolean}
 *         Whether or not this player has the requested plugin available.
 */ /**
 * Reports whether or not a player is using a plugin by name.
 *
 * For basic plugins, this only reports whether the plugin has _ever_ been
 * initialized on this player.
 *
 * @method Player#usingPlugin
 * @param  {string} name
 *         The name of a plugin.
 *
 * @return {boolean}
 *         Whether or not this player is using the requested plugin.
 */Component$1.registerComponent('Player',Player);/**
 * The base plugin name.
 *
 * @private
 * @constant
 * @type {string}
 */var BASE_PLUGIN_NAME='plugin';/**
 * The key on which a player's active plugins cache is stored.
 *
 * @private
 * @constant
 * @type     {string}
 */var PLUGIN_CACHE_KEY='activePlugins_';/**
 * Stores registered plugins in a private space.
 *
 * @private
 * @type    {Object}
 */var pluginStorage={};/**
 * Reports whether or not a plugin has been registered.
 *
 * @private
 * @param   {string} name
 *          The name of a plugin.
 *
 * @return {boolean}
 *          Whether or not the plugin has been registered.
 */var pluginExists=function pluginExists(name){return pluginStorage.hasOwnProperty(name);};/**
 * Get a single registered plugin by name.
 *
 * @private
 * @param   {string} name
 *          The name of a plugin.
 *
 * @return {Function|undefined}
 *          The plugin (or undefined).
 */var getPlugin=function getPlugin(name){return pluginExists(name)?pluginStorage[name]:undefined;};/**
 * Marks a plugin as "active" on a player.
 *
 * Also, ensures that the player has an object for tracking active plugins.
 *
 * @private
 * @param   {Player} player
 *          A Video.js player instance.
 *
 * @param   {string} name
 *          The name of a plugin.
 */var markPluginAsActive=function markPluginAsActive(player,name){player[PLUGIN_CACHE_KEY]=player[PLUGIN_CACHE_KEY]||{};player[PLUGIN_CACHE_KEY][name]=true;};/**
 * Triggers a pair of plugin setup events.
 *
 * @private
 * @param  {Player} player
 *         A Video.js player instance.
 *
 * @param  {Plugin~PluginEventHash} hash
 *         A plugin event hash.
 *
 * @param  {boolean} [before]
 *         If true, prefixes the event name with "before". In other words,
 *         use this to trigger "beforepluginsetup" instead of "pluginsetup".
 */var triggerSetupEvent=function triggerSetupEvent(player,hash,before){var eventName=(before?'before':'')+'pluginsetup';player.trigger(eventName,hash);player.trigger(eventName+':'+hash.name,hash);};/**
 * Takes a basic plugin function and returns a wrapper function which marks
 * on the player that the plugin has been activated.
 *
 * @private
 * @param   {string} name
 *          The name of the plugin.
 *
 * @param   {Function} plugin
 *          The basic plugin.
 *
 * @return {Function}
 *          A wrapper function for the given plugin.
 */var createBasicPlugin=function createBasicPlugin(name,plugin){var basicPluginWrapper=function basicPluginWrapper(){// We trigger the "beforepluginsetup" and "pluginsetup" events on the player
// regardless, but we want the hash to be consistent with the hash provided
// for advanced plugins.
//
// The only potentially counter-intuitive thing here is the `instance` in
// the "pluginsetup" event is the value returned by the `plugin` function.
triggerSetupEvent(this,{name:name,plugin:plugin,instance:null},true);var instance=plugin.apply(this,arguments);markPluginAsActive(this,name);triggerSetupEvent(this,{name:name,plugin:plugin,instance:instance});return instance;};Object.keys(plugin).forEach(function(prop){basicPluginWrapper[prop]=plugin[prop];});return basicPluginWrapper;};/**
 * Takes a plugin sub-class and returns a factory function for generating
 * instances of it.
 *
 * This factory function will replace itself with an instance of the requested
 * sub-class of Plugin.
 *
 * @private
 * @param   {string} name
 *          The name of the plugin.
 *
 * @param   {Plugin} PluginSubClass
 *          The advanced plugin.
 *
 * @return {Function}
 */var createPluginFactory=function createPluginFactory(name,PluginSubClass){// Add a `name` property to the plugin prototype so that each plugin can
// refer to itself by name.
PluginSubClass.prototype.name=name;return function(){triggerSetupEvent(this,{name:name,plugin:PluginSubClass,instance:null},true);for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}var instance=_construct(PluginSubClass,[this].concat(args));// The plugin is replaced by a function that returns the current instance.
this[name]=function(){return instance;};triggerSetupEvent(this,instance.getEventHash());return instance;};};/**
 * Parent class for all advanced plugins.
 *
 * @mixes   module:evented~EventedMixin
 * @mixes   module:stateful~StatefulMixin
 * @fires   Player#beforepluginsetup
 * @fires   Player#beforepluginsetup:$name
 * @fires   Player#pluginsetup
 * @fires   Player#pluginsetup:$name
 * @listens Player#dispose
 * @throws  {Error}
 *          If attempting to instantiate the base {@link Plugin} class
 *          directly instead of via a sub-class.
 */var Plugin=/*#__PURE__*/function(){/**
   * Creates an instance of this class.
   *
   * Sub-classes should call `super` to ensure plugins are properly initialized.
   *
   * @param {Player} player
   *        A Video.js player instance.
   */function Plugin(player){if(this.constructor===Plugin){throw new Error('Plugin must be sub-classed; not directly instantiated.');}this.player=player;if(!this.log){this.log=this.player.log.createLogger(this.name);}// Make this object evented, but remove the added `trigger` method so we
// use the prototype version instead.
evented(this);delete this.trigger;stateful(this,this.constructor.defaultState);markPluginAsActive(player,this.name);// Auto-bind the dispose method so we can use it as a listener and unbind
// it later easily.
this.dispose=this.dispose.bind(this);// If the player is disposed, dispose the plugin.
player.on('dispose',this.dispose);}/**
   * Get the version of the plugin that was set on <pluginName>.VERSION
   */var _proto=Plugin.prototype;_proto.version=function version(){return this.constructor.VERSION;}/**
   * Each event triggered by plugins includes a hash of additional data with
   * conventional properties.
   *
   * This returns that object or mutates an existing hash.
   *
   * @param   {Object} [hash={}]
   *          An object to be used as event an event hash.
   *
   * @return {Plugin~PluginEventHash}
   *          An event hash object with provided properties mixed-in.
   */;_proto.getEventHash=function getEventHash(hash){if(hash===void 0){hash={};}hash.name=this.name;hash.plugin=this.constructor;hash.instance=this;return hash;}/**
   * Triggers an event on the plugin object and overrides
   * {@link module:evented~EventedMixin.trigger|EventedMixin.trigger}.
   *
   * @param   {string|Object} event
   *          An event type or an object with a type property.
   *
   * @param   {Object} [hash={}]
   *          Additional data hash to merge with a
   *          {@link Plugin~PluginEventHash|PluginEventHash}.
   *
   * @return {boolean}
   *          Whether or not default was prevented.
   */;_proto.trigger=function trigger$1(event,hash){if(hash===void 0){hash={};}return trigger(this.eventBusEl_,event,this.getEventHash(hash));}/**
   * Handles "statechanged" events on the plugin. No-op by default, override by
   * subclassing.
   *
   * @abstract
   * @param    {Event} e
   *           An event object provided by a "statechanged" event.
   *
   * @param    {Object} e.changes
   *           An object describing changes that occurred with the "statechanged"
   *           event.
   */;_proto.handleStateChanged=function handleStateChanged(e){}/**
   * Disposes a plugin.
   *
   * Subclasses can override this if they want, but for the sake of safety,
   * it's probably best to subscribe the "dispose" event.
   *
   * @fires Plugin#dispose
   */;_proto.dispose=function dispose(){var name=this.name,player=this.player;/**
     * Signals that a advanced plugin is about to be disposed.
     *
     * @event Plugin#dispose
     * @type  {EventTarget~Event}
     */this.trigger('dispose');this.off();player.off('dispose',this.dispose);// Eliminate any possible sources of leaking memory by clearing up
// references between the player and the plugin instance and nulling out
// the plugin's state and replacing methods with a function that throws.
player[PLUGIN_CACHE_KEY][name]=false;this.player=this.state=null;// Finally, replace the plugin name on the player with a new factory
// function, so that the plugin is ready to be set up again.
player[name]=createPluginFactory(name,pluginStorage[name]);}/**
   * Determines if a plugin is a basic plugin (i.e. not a sub-class of `Plugin`).
   *
   * @param   {string|Function} plugin
   *          If a string, matches the name of a plugin. If a function, will be
   *          tested directly.
   *
   * @return {boolean}
   *          Whether or not a plugin is a basic plugin.
   */;Plugin.isBasic=function isBasic(plugin){var p=typeof plugin==='string'?getPlugin(plugin):plugin;return typeof p==='function'&&!Plugin.prototype.isPrototypeOf(p.prototype);}/**
   * Register a Video.js plugin.
   *
   * @param   {string} name
   *          The name of the plugin to be registered. Must be a string and
   *          must not match an existing plugin or a method on the `Player`
   *          prototype.
   *
   * @param   {Function} plugin
   *          A sub-class of `Plugin` or a function for basic plugins.
   *
   * @return {Function}
   *          For advanced plugins, a factory function for that plugin. For
   *          basic plugins, a wrapper function that initializes the plugin.
   */;Plugin.registerPlugin=function registerPlugin(name,plugin){if(typeof name!=='string'){throw new Error("Illegal plugin name, \""+name+"\", must be a string, was "+video_es_typeof(name)+".");}if(pluginExists(name)){log$1.warn("A plugin named \""+name+"\" already exists. You may want to avoid re-registering plugins!");}else if(Player.prototype.hasOwnProperty(name)){throw new Error("Illegal plugin name, \""+name+"\", cannot share a name with an existing player method!");}if(typeof plugin!=='function'){throw new Error("Illegal plugin for \""+name+"\", must be a function, was "+video_es_typeof(plugin)+".");}pluginStorage[name]=plugin;// Add a player prototype method for all sub-classed plugins (but not for
// the base Plugin class).
if(name!==BASE_PLUGIN_NAME){if(Plugin.isBasic(plugin)){Player.prototype[name]=createBasicPlugin(name,plugin);}else{Player.prototype[name]=createPluginFactory(name,plugin);}}return plugin;}/**
   * De-register a Video.js plugin.
   *
   * @param  {string} name
   *         The name of the plugin to be de-registered. Must be a string that
   *         matches an existing plugin.
   *
   * @throws {Error}
   *         If an attempt is made to de-register the base plugin.
   */;Plugin.deregisterPlugin=function deregisterPlugin(name){if(name===BASE_PLUGIN_NAME){throw new Error('Cannot de-register base plugin.');}if(pluginExists(name)){delete pluginStorage[name];delete Player.prototype[name];}}/**
   * Gets an object containing multiple Video.js plugins.
   *
   * @param   {Array} [names]
   *          If provided, should be an array of plugin names. Defaults to _all_
   *          plugin names.
   *
   * @return {Object|undefined}
   *          An object containing plugin(s) associated with their name(s) or
   *          `undefined` if no matching plugins exist).
   */;Plugin.getPlugins=function getPlugins(names){if(names===void 0){names=Object.keys(pluginStorage);}var result;names.forEach(function(name){var plugin=getPlugin(name);if(plugin){result=result||{};result[name]=plugin;}});return result;}/**
   * Gets a plugin's version, if available
   *
   * @param   {string} name
   *          The name of a plugin.
   *
   * @return {string}
   *          The plugin's version or an empty string.
   */;Plugin.getPluginVersion=function getPluginVersion(name){var plugin=getPlugin(name);return plugin&&plugin.VERSION||'';};return Plugin;}();/**
 * Gets a plugin by name if it exists.
 *
 * @static
 * @method   getPlugin
 * @memberOf Plugin
 * @param    {string} name
 *           The name of a plugin.
 *
 * @returns  {Function|undefined}
 *           The plugin (or `undefined`).
 */Plugin.getPlugin=getPlugin;/**
 * The name of the base plugin class as it is registered.
 *
 * @type {string}
 */Plugin.BASE_PLUGIN_NAME=BASE_PLUGIN_NAME;Plugin.registerPlugin(BASE_PLUGIN_NAME,Plugin);/**
 * Documented in player.js
 *
 * @ignore
 */Player.prototype.usingPlugin=function(name){return!!this[PLUGIN_CACHE_KEY]&&this[PLUGIN_CACHE_KEY][name]===true;};/**
 * Documented in player.js
 *
 * @ignore
 */Player.prototype.hasPlugin=function(name){return!!pluginExists(name);};/**
 * Signals that a plugin is about to be set up on a player.
 *
 * @event    Player#beforepluginsetup
 * @type     {Plugin~PluginEventHash}
 */ /**
 * Signals that a plugin is about to be set up on a player - by name. The name
 * is the name of the plugin.
 *
 * @event    Player#beforepluginsetup:$name
 * @type     {Plugin~PluginEventHash}
 */ /**
 * Signals that a plugin has just been set up on a player.
 *
 * @event    Player#pluginsetup
 * @type     {Plugin~PluginEventHash}
 */ /**
 * Signals that a plugin has just been set up on a player - by name. The name
 * is the name of the plugin.
 *
 * @event    Player#pluginsetup:$name
 * @type     {Plugin~PluginEventHash}
 */ /**
 * @typedef  {Object} Plugin~PluginEventHash
 *
 * @property {string} instance
 *           For basic plugins, the return value of the plugin function. For
 *           advanced plugins, the plugin instance on which the event is fired.
 *
 * @property {string} name
 *           The name of the plugin.
 *
 * @property {string} plugin
 *           For basic plugins, the plugin function. For advanced plugins, the
 *           plugin class/constructor.
 */ /**
 * @file extend.js
 * @module extend
 */var hasLogged=false;/**
 * Used to subclass an existing class by emulating ES subclassing using the
 * `extends` keyword.
 *
 * @function
 * @deprecated
 * @example
 * var MyComponent = videojs.extend(videojs.getComponent('Component'), {
 *   myCustomMethod: function() {
 *     // Do things in my method.
 *   }
 * });
 *
 * @param    {Function} superClass
 *           The class to inherit from
 *
 * @param    {Object}   [subClassMethods={}]
 *           Methods of the new class
 *
 * @return   {Function}
 *           The new class with subClassMethods that inherited superClass.
 */var extend=function extend(superClass,subClassMethods){if(subClassMethods===void 0){subClassMethods={};}// Log a warning the first time extend is called to note that it is deprecated
// It was previously deprecated in our documentation (guides, specifically),
// but was never formally deprecated in code.
if(!hasLogged){log$1.warn('videojs.extend is deprecated as of Video.js 7.22.0 and will be removed in Video.js 8.0.0');hasLogged=true;}var subClass=function subClass(){superClass.apply(this,arguments);};var methods={};if(video_es_typeof(subClassMethods)==='object'){if(subClassMethods.constructor!==Object.prototype.constructor){subClass=subClassMethods.constructor;}methods=subClassMethods;}else if(typeof subClassMethods==='function'){subClass=subClassMethods;}_inherits(subClass,superClass);// this is needed for backward-compatibility and node compatibility.
if(superClass){subClass.super_=superClass;}// Extend subObj's prototype with functions and other properties from props
for(var name in methods){if(methods.hasOwnProperty(name)){subClass.prototype[name]=methods[name];}}return subClass;};/**
 * @file video.js
 * @module videojs
 */ /**
 * Normalize an `id` value by trimming off a leading `#`
 *
 * @private
 * @param   {string} id
 *          A string, maybe with a leading `#`.
 *
 * @return {string}
 *          The string, without any leading `#`.
 */var normalizeId=function normalizeId(id){return id.indexOf('#')===0?id.slice(1):id;};/**
 * The `videojs()` function doubles as the main function for users to create a
 * {@link Player} instance as well as the main library namespace.
 *
 * It can also be used as a getter for a pre-existing {@link Player} instance.
 * However, we _strongly_ recommend using `videojs.getPlayer()` for this
 * purpose because it avoids any potential for unintended initialization.
 *
 * Due to [limitations](https://github.com/jsdoc3/jsdoc/issues/955#issuecomment-313829149)
 * of our JSDoc template, we cannot properly document this as both a function
 * and a namespace, so its function signature is documented here.
 *
 * #### Arguments
 * ##### id
 * string|Element, **required**
 *
 * Video element or video element ID.
 *
 * ##### options
 * Object, optional
 *
 * Options object for providing settings.
 * See: [Options Guide](https://docs.videojs.com/tutorial-options.html).
 *
 * ##### ready
 * {@link Component~ReadyCallback}, optional
 *
 * A function to be called when the {@link Player} and {@link Tech} are ready.
 *
 * #### Return Value
 *
 * The `videojs()` function returns a {@link Player} instance.
 *
 * @namespace
 *
 * @borrows AudioTrack as AudioTrack
 * @borrows Component.getComponent as getComponent
 * @borrows module:computed-style~computedStyle as computedStyle
 * @borrows module:events.on as on
 * @borrows module:events.one as one
 * @borrows module:events.off as off
 * @borrows module:events.trigger as trigger
 * @borrows EventTarget as EventTarget
 * @borrows module:extend~extend as extend
 * @borrows module:fn.bind as bind
 * @borrows module:format-time.formatTime as formatTime
 * @borrows module:format-time.resetFormatTime as resetFormatTime
 * @borrows module:format-time.setFormatTime as setFormatTime
 * @borrows module:merge-options.mergeOptions as mergeOptions
 * @borrows module:middleware.use as use
 * @borrows Player.players as players
 * @borrows Plugin.registerPlugin as registerPlugin
 * @borrows Plugin.deregisterPlugin as deregisterPlugin
 * @borrows Plugin.getPlugins as getPlugins
 * @borrows Plugin.getPlugin as getPlugin
 * @borrows Plugin.getPluginVersion as getPluginVersion
 * @borrows Tech.getTech as getTech
 * @borrows Tech.registerTech as registerTech
 * @borrows TextTrack as TextTrack
 * @borrows module:time-ranges.createTimeRanges as createTimeRange
 * @borrows module:time-ranges.createTimeRanges as createTimeRanges
 * @borrows module:url.isCrossOrigin as isCrossOrigin
 * @borrows module:url.parseUrl as parseUrl
 * @borrows VideoTrack as VideoTrack
 *
 * @param  {string|Element} id
 *         Video element or video element ID.
 *
 * @param  {Object} [options]
 *         Options object for providing settings.
 *         See: [Options Guide](https://docs.videojs.com/tutorial-options.html).
 *
 * @param  {Component~ReadyCallback} [ready]
 *         A function to be called when the {@link Player} and {@link Tech} are
 *         ready.
 *
 * @return {Player}
 *         The `videojs()` function returns a {@link Player|Player} instance.
 */function videojs(id,options,ready){var player=videojs.getPlayer(id);if(player){if(options){log$1.warn("Player \""+id+"\" is already initialised. Options will not be applied.");}if(ready){player.ready(ready);}return player;}var el=typeof id==='string'?$('#'+normalizeId(id)):id;if(!isEl(el)){throw new TypeError('The element or ID supplied is not valid. (videojs)');}// document.body.contains(el) will only check if el is contained within that one document.
// This causes problems for elements in iframes.
// Instead, use the element's ownerDocument instead of the global document.
// This will make sure that the element is indeed in the dom of that document.
// Additionally, check that the document in question has a default view.
// If the document is no longer attached to the dom, the defaultView of the document will be null.
if(!el.ownerDocument.defaultView||!el.ownerDocument.body.contains(el)){log$1.warn('The element supplied is not included in the DOM');}options=options||{};// Store a copy of the el before modification, if it is to be restored in destroy()
// If div ingest, store the parent div
if(options.restoreEl===true){options.restoreEl=(el.parentNode&&el.parentNode.hasAttribute('data-vjs-player')?el.parentNode:el).cloneNode(true);}hooks('beforesetup').forEach(function(hookFunction){var opts=hookFunction(el,mergeOptions$3(options));if(!video_es_isObject(opts)||Array.isArray(opts)){log$1.error('please return an object in beforesetup hooks');return;}options=mergeOptions$3(options,opts);});// We get the current "Player" component here in case an integration has
// replaced it with a custom player.
var PlayerComponent=Component$1.getComponent('Player');player=new PlayerComponent(el,options,ready);hooks('setup').forEach(function(hookFunction){return hookFunction(player);});return player;}videojs.hooks_=hooks_;videojs.hooks=hooks;videojs.hook=hook;videojs.hookOnce=hookOnce;videojs.removeHook=removeHook;// Add default styles
if((window_default()).VIDEOJS_NO_DYNAMIC_STYLE!==true&&isReal()){var style=$('.vjs-styles-defaults');if(!style){style=createStyleElement('vjs-styles-defaults');var head=$('head');if(head){head.insertBefore(style,head.firstChild);}setTextContent(style,"\n      .video-js {\n        width: 300px;\n        height: 150px;\n      }\n\n      .vjs-fluid:not(.vjs-audio-only-mode) {\n        padding-top: 56.25%\n      }\n    ");}}// Run Auto-load players
// You have to wait at least once in case this script is loaded after your
// video in the DOM (weird behavior only with minified version)
autoSetupTimeout(1,videojs);/**
 * Current Video.js version. Follows [semantic versioning](https://semver.org/).
 *
 * @type {string}
 */videojs.VERSION=version$5;/**
 * The global options object. These are the settings that take effect
 * if no overrides are specified when the player is created.
 *
 * @type {Object}
 */videojs.options=Player.prototype.options_;/**
 * Get an object with the currently created players, keyed by player ID
 *
 * @return {Object}
 *         The created players
 */videojs.getPlayers=function(){return Player.players;};/**
 * Get a single player based on an ID or DOM element.
 *
 * This is useful if you want to check if an element or ID has an associated
 * Video.js player, but not create one if it doesn't.
 *
 * @param   {string|Element} id
 *          An HTML element - `<video>`, `<audio>`, or `<video-js>` -
 *          or a string matching the `id` of such an element.
 *
 * @return {Player|undefined}
 *          A player instance or `undefined` if there is no player instance
 *          matching the argument.
 */videojs.getPlayer=function(id){var players=Player.players;var tag;if(typeof id==='string'){var nId=normalizeId(id);var player=players[nId];if(player){return player;}tag=$('#'+nId);}else{tag=id;}if(isEl(tag)){var _tag=tag,_player=_tag.player,playerId=_tag.playerId;// Element may have a `player` property referring to an already created
// player instance. If so, return that.
if(_player||players[playerId]){return _player||players[playerId];}}};/**
 * Returns an array of all current players.
 *
 * @return {Array}
 *         An array of all players. The array will be in the order that
 *         `Object.keys` provides, which could potentially vary between
 *         JavaScript engines.
 *
 */videojs.getAllPlayers=function(){return(// Disposed players leave a key with a `null` value, so we need to make sure
// we filter those out.
Object.keys(Player.players).map(function(k){return Player.players[k];}).filter(Boolean));};videojs.players=Player.players;videojs.getComponent=Component$1.getComponent;/**
 * Register a component so it can referred to by name. Used when adding to other
 * components, either through addChild `component.addChild('myComponent')` or through
 * default children options  `{ children: ['myComponent'] }`.
 *
 * > NOTE: You could also just initialize the component before adding.
 * `component.addChild(new MyComponent());`
 *
 * @param {string} name
 *        The class name of the component
 *
 * @param {Component} comp
 *        The component class
 *
 * @return {Component}
 *         The newly registered component
 */videojs.registerComponent=function(name,comp){if(Tech.isTech(comp)){log$1.warn("The "+name+" tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)");}Component$1.registerComponent.call(Component$1,name,comp);};videojs.getTech=Tech.getTech;videojs.registerTech=Tech.registerTech;videojs.use=use;/**
 * An object that can be returned by a middleware to signify
 * that the middleware is being terminated.
 *
 * @type {object}
 * @property {object} middleware.TERMINATOR
 */Object.defineProperty(videojs,'middleware',{value:{},writeable:false,enumerable:true});Object.defineProperty(videojs.middleware,'TERMINATOR',{value:TERMINATOR,writeable:false,enumerable:true});/**
 * A reference to the {@link module:browser|browser utility module} as an object.
 *
 * @type {Object}
 * @see  {@link module:browser|browser}
 */videojs.browser=video_es_browser;/**
 * Use {@link module:browser.TOUCH_ENABLED|browser.TOUCH_ENABLED} instead; only
 * included for backward-compatibility with 4.x.
 *
 * @deprecated Since version 5.0, use {@link module:browser.TOUCH_ENABLED|browser.TOUCH_ENABLED instead.
 * @type {boolean}
 */videojs.TOUCH_ENABLED=TOUCH_ENABLED;videojs.extend=extend;videojs.mergeOptions=mergeOptions$3;videojs.bind=bind;videojs.registerPlugin=Plugin.registerPlugin;videojs.deregisterPlugin=Plugin.deregisterPlugin;/**
 * Deprecated method to register a plugin with Video.js
 *
 * @deprecated videojs.plugin() is deprecated; use videojs.registerPlugin() instead
 *
 * @param {string} name
 *        The plugin name
 *
 * @param {Plugin|Function} plugin
 *         The plugin sub-class or function
 */videojs.plugin=function(name,plugin){log$1.warn('videojs.plugin() is deprecated; use videojs.registerPlugin() instead');return Plugin.registerPlugin(name,plugin);};videojs.getPlugins=Plugin.getPlugins;videojs.getPlugin=Plugin.getPlugin;videojs.getPluginVersion=Plugin.getPluginVersion;/**
 * Adding languages so that they're available to all players.
 * Example: `videojs.addLanguage('es', { 'Hello': 'Hola' });`
 *
 * @param {string} code
 *        The language code or dictionary property
 *
 * @param {Object} data
 *        The data values to be translated
 *
 * @return {Object}
 *         The resulting language dictionary object
 */videojs.addLanguage=function(code,data){var _mergeOptions;code=(''+code).toLowerCase();videojs.options.languages=mergeOptions$3(videojs.options.languages,(_mergeOptions={},_mergeOptions[code]=data,_mergeOptions));return videojs.options.languages[code];};/**
 * A reference to the {@link module:log|log utility module} as an object.
 *
 * @type {Function}
 * @see  {@link module:log|log}
 */videojs.log=log$1;videojs.createLogger=createLogger;videojs.createTimeRange=videojs.createTimeRanges=createTimeRanges;videojs.formatTime=formatTime;videojs.setFormatTime=setFormatTime;videojs.resetFormatTime=resetFormatTime;videojs.parseUrl=parseUrl;videojs.isCrossOrigin=isCrossOrigin;videojs.EventTarget=EventTarget$2;videojs.on=on;videojs.one=one;videojs.off=off;videojs.trigger=trigger;/**
 * A cross-browser XMLHttpRequest wrapper.
 *
 * @function
 * @param    {Object} options
 *           Settings for the request.
 *
 * @return   {XMLHttpRequest|XDomainRequest}
 *           The request object.
 *
 * @see      https://github.com/Raynos/xhr
 */videojs.xhr=(lib_default());videojs.TextTrack=TextTrack;videojs.AudioTrack=AudioTrack;videojs.VideoTrack=VideoTrack;['isEl','isTextNode','createEl','hasClass','addClass','removeClass','toggleClass','setAttributes','getAttributes','emptyEl','appendContent','insertContent'].forEach(function(k){videojs[k]=function(){log$1.warn("videojs."+k+"() is deprecated; use videojs.dom."+k+"() instead");return Dom[k].apply(null,arguments);};});videojs.computedStyle=computedStyle;/**
 * A reference to the {@link module:dom|DOM utility module} as an object.
 *
 * @type {Object}
 * @see  {@link module:dom|dom}
 */videojs.dom=Dom;/**
 * A reference to the {@link module:url|URL utility module} as an object.
 *
 * @type {Object}
 * @see  {@link module:url|url}
 */videojs.url=Url;videojs.defineLazyProperty=defineLazyProperty;// Adding less ambiguous text for fullscreen button.
// In a major update this could become the default text and key.
videojs.addLanguage('en',{'Non-Fullscreen':'Exit Fullscreen'});/*! @name @videojs/http-streaming @version 2.16.3 @license Apache-2.0 */ /**
 * @file resolve-url.js - Handling how URLs are resolved and manipulated
 */var video_es_resolveUrl=resolve_url;/**
 * Checks whether xhr request was redirected and returns correct url depending
 * on `handleManifestRedirects` option
 *
 * @api private
 *
 * @param  {string} url - an url being requested
 * @param  {XMLHttpRequest} req - xhr request result
 *
 * @return {string}
 */var resolveManifestRedirect=function resolveManifestRedirect(handleManifestRedirect,url,req){// To understand how the responseURL below is set and generated:
// - https://fetch.spec.whatwg.org/#concept-response-url
// - https://fetch.spec.whatwg.org/#atomic-http-redirect-handling
if(handleManifestRedirect&&req&&req.responseURL&&url!==req.responseURL){return req.responseURL;}return url;};var logger=function logger(source){if(videojs.log.debug){return videojs.log.debug.bind(videojs,'VHS:',source+" >");}return function(){};};/**
 * ranges
 *
 * Utilities for working with TimeRanges.
 *
 */var TIME_FUDGE_FACTOR=1/30;// Comparisons between time values such as current time and the end of the buffered range
// can be misleading because of precision differences or when the current media has poorly
// aligned audio and video, which can cause values to be slightly off from what you would
// expect. This value is what we consider to be safe to use in such comparisons to account
// for these scenarios.
var SAFE_TIME_DELTA=TIME_FUDGE_FACTOR*3;var filterRanges=function filterRanges(timeRanges,predicate){var results=[];var i;if(timeRanges&&timeRanges.length){// Search for ranges that match the predicate
for(i=0;i<timeRanges.length;i++){if(predicate(timeRanges.start(i),timeRanges.end(i))){results.push([timeRanges.start(i),timeRanges.end(i)]);}}}return videojs.createTimeRanges(results);};/**
 * Attempts to find the buffered TimeRange that contains the specified
 * time.
 *
 * @param {TimeRanges} buffered - the TimeRanges object to query
 * @param {number} time  - the time to filter on.
 * @return {TimeRanges} a new TimeRanges object
 */var findRange=function findRange(buffered,time){return filterRanges(buffered,function(start,end){return start-SAFE_TIME_DELTA<=time&&end+SAFE_TIME_DELTA>=time;});};/**
 * Returns the TimeRanges that begin later than the specified time.
 *
 * @param {TimeRanges} timeRanges - the TimeRanges object to query
 * @param {number} time - the time to filter on.
 * @return {TimeRanges} a new TimeRanges object.
 */var findNextRange=function findNextRange(timeRanges,time){return filterRanges(timeRanges,function(start){return start-TIME_FUDGE_FACTOR>=time;});};/**
 * Returns gaps within a list of TimeRanges
 *
 * @param {TimeRanges} buffered - the TimeRanges object
 * @return {TimeRanges} a TimeRanges object of gaps
 */var findGaps=function findGaps(buffered){if(buffered.length<2){return videojs.createTimeRanges();}var ranges=[];for(var i=1;i<buffered.length;i++){var start=buffered.end(i-1);var end=buffered.start(i);ranges.push([start,end]);}return videojs.createTimeRanges(ranges);};/**
 * Calculate the intersection of two TimeRanges
 *
 * @param {TimeRanges} bufferA
 * @param {TimeRanges} bufferB
 * @return {TimeRanges} The interesection of `bufferA` with `bufferB`
 */var bufferIntersection=function bufferIntersection(bufferA,bufferB){var start=null;var end=null;var arity=0;var extents=[];var ranges=[];if(!bufferA||!bufferA.length||!bufferB||!bufferB.length){return videojs.createTimeRange();}// Handle the case where we have both buffers and create an
// intersection of the two
var count=bufferA.length;// A) Gather up all start and end times
while(count--){extents.push({time:bufferA.start(count),type:'start'});extents.push({time:bufferA.end(count),type:'end'});}count=bufferB.length;while(count--){extents.push({time:bufferB.start(count),type:'start'});extents.push({time:bufferB.end(count),type:'end'});}// B) Sort them by time
extents.sort(function(a,b){return a.time-b.time;});// C) Go along one by one incrementing arity for start and decrementing
//    arity for ends
for(count=0;count<extents.length;count++){if(extents[count].type==='start'){arity++;// D) If arity is ever incremented to 2 we are entering an
//    overlapping range
if(arity===2){start=extents[count].time;}}else if(extents[count].type==='end'){arity--;// E) If arity is ever decremented to 1 we leaving an
//    overlapping range
if(arity===1){end=extents[count].time;}}// F) Record overlapping ranges
if(start!==null&&end!==null){ranges.push([start,end]);start=null;end=null;}}return videojs.createTimeRanges(ranges);};/**
 * Gets a human readable string for a TimeRange
 *
 * @param {TimeRange} range
 * @return {string} a human readable string
 */var printableRange=function printableRange(range){var strArr=[];if(!range||!range.length){return'';}for(var i=0;i<range.length;i++){strArr.push(range.start(i)+' => '+range.end(i));}return strArr.join(', ');};/**
 * Calculates the amount of time left in seconds until the player hits the end of the
 * buffer and causes a rebuffer
 *
 * @param {TimeRange} buffered
 *        The state of the buffer
 * @param {Numnber} currentTime
 *        The current time of the player
 * @param {number} playbackRate
 *        The current playback rate of the player. Defaults to 1.
 * @return {number}
 *         Time until the player has to start rebuffering in seconds.
 * @function timeUntilRebuffer
 */var timeUntilRebuffer=function timeUntilRebuffer(buffered,currentTime,playbackRate){if(playbackRate===void 0){playbackRate=1;}var bufferedEnd=buffered.length?buffered.end(buffered.length-1):0;return(bufferedEnd-currentTime)/playbackRate;};/**
 * Converts a TimeRanges object into an array representation
 *
 * @param {TimeRanges} timeRanges
 * @return {Array}
 */var timeRangesToArray=function timeRangesToArray(timeRanges){var timeRangesList=[];for(var i=0;i<timeRanges.length;i++){timeRangesList.push({start:timeRanges.start(i),end:timeRanges.end(i)});}return timeRangesList;};/**
 * Determines if two time range objects are different.
 *
 * @param {TimeRange} a
 *        the first time range object to check
 *
 * @param {TimeRange} b
 *        the second time range object to check
 *
 * @return {Boolean}
 *         Whether the time range objects differ
 */var isRangeDifferent=function isRangeDifferent(a,b){// same object
if(a===b){return false;}// one or the other is undefined
if(!a&&b||!b&&a){return true;}// length is different
if(a.length!==b.length){return true;}// see if any start/end pair is different
for(var i=0;i<a.length;i++){if(a.start(i)!==b.start(i)||a.end(i)!==b.end(i)){return true;}}// if the length and every pair is the same
// this is the same time range
return false;};var lastBufferedEnd=function lastBufferedEnd(a){if(!a||!a.length||!a.end){return;}return a.end(a.length-1);};/**
 * A utility function to add up the amount of time in a timeRange
 * after a specified startTime.
 * ie:[[0, 10], [20, 40], [50, 60]] with a startTime 0
 *     would return 40 as there are 40s seconds after 0 in the timeRange
 *
 * @param {TimeRange} range
 *        The range to check against
 * @param {number} startTime
 *        The time in the time range that you should start counting from
 *
 * @return {number}
 *          The number of seconds in the buffer passed the specified time.
 */var timeAheadOf=function timeAheadOf(range,startTime){var time=0;if(!range||!range.length){return time;}for(var i=0;i<range.length;i++){var start=range.start(i);var end=range.end(i);// startTime is after this range entirely
if(startTime>end){continue;}// startTime is within this range
if(startTime>start&&startTime<=end){time+=end-startTime;continue;}// startTime is before this range.
time+=end-start;}return time;};/**
 * @file playlist.js
 *
 * Playlist related utilities.
 */var createTimeRange=videojs.createTimeRange;/**
 * Get the duration of a segment, with special cases for
 * llhls segments that do not have a duration yet.
 *
 * @param {Object} playlist
 *        the playlist that the segment belongs to.
 * @param {Object} segment
 *        the segment to get a duration for.
 *
 * @return {number}
 *          the segment duration
 */var segmentDurationWithParts=function segmentDurationWithParts(playlist,segment){// if this isn't a preload segment
// then we will have a segment duration that is accurate.
if(!segment.preload){return segment.duration;}// otherwise we have to add up parts and preload hints
// to get an up to date duration.
var result=0;(segment.parts||[]).forEach(function(p){result+=p.duration;});// for preload hints we have to use partTargetDuration
// as they won't even have a duration yet.
(segment.preloadHints||[]).forEach(function(p){if(p.type==='PART'){result+=playlist.partTargetDuration;}});return result;};/**
 * A function to get a combined list of parts and segments with durations
 * and indexes.
 *
 * @param {Playlist} playlist the playlist to get the list for.
 *
 * @return {Array} The part/segment list.
 */var getPartsAndSegments=function getPartsAndSegments(playlist){return(playlist.segments||[]).reduce(function(acc,segment,si){if(segment.parts){segment.parts.forEach(function(part,pi){acc.push({duration:part.duration,segmentIndex:si,partIndex:pi,part:part,segment:segment});});}else{acc.push({duration:segment.duration,segmentIndex:si,partIndex:null,segment:segment,part:null});}return acc;},[]);};var getLastParts=function getLastParts(media){var lastSegment=media.segments&&media.segments.length&&media.segments[media.segments.length-1];return lastSegment&&lastSegment.parts||[];};var getKnownPartCount=function getKnownPartCount(_ref){var preloadSegment=_ref.preloadSegment;if(!preloadSegment){return;}var parts=preloadSegment.parts,preloadHints=preloadSegment.preloadHints;var partCount=(preloadHints||[]).reduce(function(count,hint){return count+(hint.type==='PART'?1:0);},0);partCount+=parts&&parts.length?parts.length:0;return partCount;};/**
 * Get the number of seconds to delay from the end of a
 * live playlist.
 *
 * @param {Playlist} master the master playlist
 * @param {Playlist} media the media playlist
 * @return {number} the hold back in seconds.
 */var liveEdgeDelay=function liveEdgeDelay(master,media){if(media.endList){return 0;}// dash suggestedPresentationDelay trumps everything
if(master&&master.suggestedPresentationDelay){return master.suggestedPresentationDelay;}var hasParts=getLastParts(media).length>0;// look for "part" delays from ll-hls first
if(hasParts&&media.serverControl&&media.serverControl.partHoldBack){return media.serverControl.partHoldBack;}else if(hasParts&&media.partTargetDuration){return media.partTargetDuration*3;// finally look for full segment delays
}else if(media.serverControl&&media.serverControl.holdBack){return media.serverControl.holdBack;}else if(media.targetDuration){return media.targetDuration*3;}return 0;};/**
 * walk backward until we find a duration we can use
 * or return a failure
 *
 * @param {Playlist} playlist the playlist to walk through
 * @param {Number} endSequence the mediaSequence to stop walking on
 */var backwardDuration=function backwardDuration(playlist,endSequence){var result=0;var i=endSequence-playlist.mediaSequence;// if a start time is available for segment immediately following
// the interval, use it
var segment=playlist.segments[i];// Walk backward until we find the latest segment with timeline
// information that is earlier than endSequence
if(segment){if(typeof segment.start!=='undefined'){return{result:segment.start,precise:true};}if(typeof segment.end!=='undefined'){return{result:segment.end-segment.duration,precise:true};}}while(i--){segment=playlist.segments[i];if(typeof segment.end!=='undefined'){return{result:result+segment.end,precise:true};}result+=segmentDurationWithParts(playlist,segment);if(typeof segment.start!=='undefined'){return{result:result+segment.start,precise:true};}}return{result:result,precise:false};};/**
 * walk forward until we find a duration we can use
 * or return a failure
 *
 * @param {Playlist} playlist the playlist to walk through
 * @param {number} endSequence the mediaSequence to stop walking on
 */var forwardDuration=function forwardDuration(playlist,endSequence){var result=0;var segment;var i=endSequence-playlist.mediaSequence;// Walk forward until we find the earliest segment with timeline
// information
for(;i<playlist.segments.length;i++){segment=playlist.segments[i];if(typeof segment.start!=='undefined'){return{result:segment.start-result,precise:true};}result+=segmentDurationWithParts(playlist,segment);if(typeof segment.end!=='undefined'){return{result:segment.end-result,precise:true};}}// indicate we didn't find a useful duration estimate
return{result:-1,precise:false};};/**
  * Calculate the media duration from the segments associated with a
  * playlist. The duration of a subinterval of the available segments
  * may be calculated by specifying an end index.
  *
  * @param {Object} playlist a media playlist object
  * @param {number=} endSequence an exclusive upper boundary
  * for the playlist.  Defaults to playlist length.
  * @param {number} expired the amount of time that has dropped
  * off the front of the playlist in a live scenario
  * @return {number} the duration between the first available segment
  * and end index.
  */var intervalDuration=function intervalDuration(playlist,endSequence,expired){if(typeof endSequence==='undefined'){endSequence=playlist.mediaSequence+playlist.segments.length;}if(endSequence<playlist.mediaSequence){return 0;}// do a backward walk to estimate the duration
var backward=backwardDuration(playlist,endSequence);if(backward.precise){// if we were able to base our duration estimate on timing
// information provided directly from the Media Source, return
// it
return backward.result;}// walk forward to see if a precise duration estimate can be made
// that way
var forward=forwardDuration(playlist,endSequence);if(forward.precise){// we found a segment that has been buffered and so it's
// position is known precisely
return forward.result;}// return the less-precise, playlist-based duration estimate
return backward.result+expired;};/**
  * Calculates the duration of a playlist. If a start and end index
  * are specified, the duration will be for the subset of the media
  * timeline between those two indices. The total duration for live
  * playlists is always Infinity.
  *
  * @param {Object} playlist a media playlist object
  * @param {number=} endSequence an exclusive upper
  * boundary for the playlist. Defaults to the playlist media
  * sequence number plus its length.
  * @param {number=} expired the amount of time that has
  * dropped off the front of the playlist in a live scenario
  * @return {number} the duration between the start index and end
  * index.
  */var duration=function duration(playlist,endSequence,expired){if(!playlist){return 0;}if(typeof expired!=='number'){expired=0;}// if a slice of the total duration is not requested, use
// playlist-level duration indicators when they're present
if(typeof endSequence==='undefined'){// if present, use the duration specified in the playlist
if(playlist.totalDuration){return playlist.totalDuration;}// duration should be Infinity for live playlists
if(!playlist.endList){return (window_default())[Infinity];}}// calculate the total duration based on the segment durations
return intervalDuration(playlist,endSequence,expired);};/**
  * Calculate the time between two indexes in the current playlist
  * neight the start- nor the end-index need to be within the current
  * playlist in which case, the targetDuration of the playlist is used
  * to approximate the durations of the segments
  *
  * @param {Array} options.durationList list to iterate over for durations.
  * @param {number} options.defaultDuration duration to use for elements before or after the durationList
  * @param {number} options.startIndex partsAndSegments index to start
  * @param {number} options.endIndex partsAndSegments index to end.
  * @return {number} the number of seconds between startIndex and endIndex
  */var sumDurations=function sumDurations(_ref2){var defaultDuration=_ref2.defaultDuration,durationList=_ref2.durationList,startIndex=_ref2.startIndex,endIndex=_ref2.endIndex;var durations=0;if(startIndex>endIndex){var _ref3=[endIndex,startIndex];startIndex=_ref3[0];endIndex=_ref3[1];}if(startIndex<0){for(var i=startIndex;i<Math.min(0,endIndex);i++){durations+=defaultDuration;}startIndex=0;}for(var _i=startIndex;_i<endIndex;_i++){durations+=durationList[_i].duration;}return durations;};/**
 * Calculates the playlist end time
 *
 * @param {Object} playlist a media playlist object
 * @param {number=} expired the amount of time that has
 *                  dropped off the front of the playlist in a live scenario
 * @param {boolean|false} useSafeLiveEnd a boolean value indicating whether or not the
 *                        playlist end calculation should consider the safe live end
 *                        (truncate the playlist end by three segments). This is normally
 *                        used for calculating the end of the playlist's seekable range.
 *                        This takes into account the value of liveEdgePadding.
 *                        Setting liveEdgePadding to 0 is equivalent to setting this to false.
 * @param {number} liveEdgePadding a number indicating how far from the end of the playlist we should be in seconds.
 *                 If this is provided, it is used in the safe live end calculation.
 *                 Setting useSafeLiveEnd=false or liveEdgePadding=0 are equivalent.
 *                 Corresponds to suggestedPresentationDelay in DASH manifests.
 * @return {number} the end time of playlist
 * @function playlistEnd
 */var playlistEnd=function playlistEnd(playlist,expired,useSafeLiveEnd,liveEdgePadding){if(!playlist||!playlist.segments){return null;}if(playlist.endList){return duration(playlist);}if(expired===null){return null;}expired=expired||0;var lastSegmentEndTime=intervalDuration(playlist,playlist.mediaSequence+playlist.segments.length,expired);if(useSafeLiveEnd){liveEdgePadding=typeof liveEdgePadding==='number'?liveEdgePadding:liveEdgeDelay(null,playlist);lastSegmentEndTime-=liveEdgePadding;}// don't return a time less than zero
return Math.max(0,lastSegmentEndTime);};/**
  * Calculates the interval of time that is currently seekable in a
  * playlist. The returned time ranges are relative to the earliest
  * moment in the specified playlist that is still available. A full
  * seekable implementation for live streams would need to offset
  * these values by the duration of content that has expired from the
  * stream.
  *
  * @param {Object} playlist a media playlist object
  * dropped off the front of the playlist in a live scenario
  * @param {number=} expired the amount of time that has
  * dropped off the front of the playlist in a live scenario
  * @param {number} liveEdgePadding how far from the end of the playlist we should be in seconds.
  *        Corresponds to suggestedPresentationDelay in DASH manifests.
  * @return {TimeRanges} the periods of time that are valid targets
  * for seeking
  */var seekable=function seekable(playlist,expired,liveEdgePadding){var useSafeLiveEnd=true;var seekableStart=expired||0;var seekableEnd=playlistEnd(playlist,expired,useSafeLiveEnd,liveEdgePadding);if(seekableEnd===null){return createTimeRange();}return createTimeRange(seekableStart,seekableEnd);};/**
 * Determine the index and estimated starting time of the segment that
 * contains a specified playback position in a media playlist.
 *
 * @param {Object} options.playlist the media playlist to query
 * @param {number} options.currentTime The number of seconds since the earliest
 * possible position to determine the containing segment for
 * @param {number} options.startTime the time when the segment/part starts
 * @param {number} options.startingSegmentIndex the segment index to start looking at.
 * @param {number?} [options.startingPartIndex] the part index to look at within the segment.
 *
 * @return {Object} an object with partIndex, segmentIndex, and startTime.
 */var getMediaInfoForTime=function getMediaInfoForTime(_ref4){var playlist=_ref4.playlist,currentTime=_ref4.currentTime,startingSegmentIndex=_ref4.startingSegmentIndex,startingPartIndex=_ref4.startingPartIndex,startTime=_ref4.startTime,experimentalExactManifestTimings=_ref4.experimentalExactManifestTimings;var time=currentTime-startTime;var partsAndSegments=getPartsAndSegments(playlist);var startIndex=0;for(var i=0;i<partsAndSegments.length;i++){var partAndSegment=partsAndSegments[i];if(startingSegmentIndex!==partAndSegment.segmentIndex){continue;}// skip this if part index does not match.
if(typeof startingPartIndex==='number'&&typeof partAndSegment.partIndex==='number'&&startingPartIndex!==partAndSegment.partIndex){continue;}startIndex=i;break;}if(time<0){// Walk backward from startIndex in the playlist, adding durations
// until we find a segment that contains `time` and return it
if(startIndex>0){for(var _i2=startIndex-1;_i2>=0;_i2--){var _partAndSegment=partsAndSegments[_i2];time+=_partAndSegment.duration;if(experimentalExactManifestTimings){if(time<0){continue;}}else if(time+TIME_FUDGE_FACTOR<=0){continue;}return{partIndex:_partAndSegment.partIndex,segmentIndex:_partAndSegment.segmentIndex,startTime:startTime-sumDurations({defaultDuration:playlist.targetDuration,durationList:partsAndSegments,startIndex:startIndex,endIndex:_i2})};}}// We were unable to find a good segment within the playlist
// so select the first segment
return{partIndex:partsAndSegments[0]&&partsAndSegments[0].partIndex||null,segmentIndex:partsAndSegments[0]&&partsAndSegments[0].segmentIndex||0,startTime:currentTime};}// When startIndex is negative, we first walk forward to first segment
// adding target durations. If we "run out of time" before getting to
// the first segment, return the first segment
if(startIndex<0){for(var _i3=startIndex;_i3<0;_i3++){time-=playlist.targetDuration;if(time<0){return{partIndex:partsAndSegments[0]&&partsAndSegments[0].partIndex||null,segmentIndex:partsAndSegments[0]&&partsAndSegments[0].segmentIndex||0,startTime:currentTime};}}startIndex=0;}// Walk forward from startIndex in the playlist, subtracting durations
// until we find a segment that contains `time` and return it
for(var _i4=startIndex;_i4<partsAndSegments.length;_i4++){var _partAndSegment2=partsAndSegments[_i4];time-=_partAndSegment2.duration;if(experimentalExactManifestTimings){if(time>0){continue;}}else if(time-TIME_FUDGE_FACTOR>=0){continue;}return{partIndex:_partAndSegment2.partIndex,segmentIndex:_partAndSegment2.segmentIndex,startTime:startTime+sumDurations({defaultDuration:playlist.targetDuration,durationList:partsAndSegments,startIndex:startIndex,endIndex:_i4})};}// We are out of possible candidates so load the last one...
return{segmentIndex:partsAndSegments[partsAndSegments.length-1].segmentIndex,partIndex:partsAndSegments[partsAndSegments.length-1].partIndex,startTime:currentTime};};/**
 * Check whether the playlist is blacklisted or not.
 *
 * @param {Object} playlist the media playlist object
 * @return {boolean} whether the playlist is blacklisted or not
 * @function isBlacklisted
 */var isBlacklisted=function isBlacklisted(playlist){return playlist.excludeUntil&&playlist.excludeUntil>Date.now();};/**
 * Check whether the playlist is compatible with current playback configuration or has
 * been blacklisted permanently for being incompatible.
 *
 * @param {Object} playlist the media playlist object
 * @return {boolean} whether the playlist is incompatible or not
 * @function isIncompatible
 */var isIncompatible=function isIncompatible(playlist){return playlist.excludeUntil&&playlist.excludeUntil===Infinity;};/**
 * Check whether the playlist is enabled or not.
 *
 * @param {Object} playlist the media playlist object
 * @return {boolean} whether the playlist is enabled or not
 * @function isEnabled
 */var isEnabled=function isEnabled(playlist){var blacklisted=isBlacklisted(playlist);return!playlist.disabled&&!blacklisted;};/**
 * Check whether the playlist has been manually disabled through the representations api.
 *
 * @param {Object} playlist the media playlist object
 * @return {boolean} whether the playlist is disabled manually or not
 * @function isDisabled
 */var isDisabled=function isDisabled(playlist){return playlist.disabled;};/**
 * Returns whether the current playlist is an AES encrypted HLS stream
 *
 * @return {boolean} true if it's an AES encrypted HLS stream
 */var isAes=function isAes(media){for(var i=0;i<media.segments.length;i++){if(media.segments[i].key){return true;}}return false;};/**
 * Checks if the playlist has a value for the specified attribute
 *
 * @param {string} attr
 *        Attribute to check for
 * @param {Object} playlist
 *        The media playlist object
 * @return {boolean}
 *         Whether the playlist contains a value for the attribute or not
 * @function hasAttribute
 */var hasAttribute=function hasAttribute(attr,playlist){return playlist.attributes&&playlist.attributes[attr];};/**
 * Estimates the time required to complete a segment download from the specified playlist
 *
 * @param {number} segmentDuration
 *        Duration of requested segment
 * @param {number} bandwidth
 *        Current measured bandwidth of the player
 * @param {Object} playlist
 *        The media playlist object
 * @param {number=} bytesReceived
 *        Number of bytes already received for the request. Defaults to 0
 * @return {number|NaN}
 *         The estimated time to request the segment. NaN if bandwidth information for
 *         the given playlist is unavailable
 * @function estimateSegmentRequestTime
 */var estimateSegmentRequestTime=function estimateSegmentRequestTime(segmentDuration,bandwidth,playlist,bytesReceived){if(bytesReceived===void 0){bytesReceived=0;}if(!hasAttribute('BANDWIDTH',playlist)){return NaN;}var size=segmentDuration*playlist.attributes.BANDWIDTH;return(size-bytesReceived*8)/bandwidth;};/*
 * Returns whether the current playlist is the lowest rendition
 *
 * @return {Boolean} true if on lowest rendition
 */var isLowestEnabledRendition=function isLowestEnabledRendition(master,media){if(master.playlists.length===1){return true;}var currentBandwidth=media.attributes.BANDWIDTH||Number.MAX_VALUE;return master.playlists.filter(function(playlist){if(!isEnabled(playlist)){return false;}return(playlist.attributes.BANDWIDTH||0)<currentBandwidth;}).length===0;};var playlistMatch=function playlistMatch(a,b){// both playlits are null
// or only one playlist is non-null
// no match
if(!a&&!b||!a&&b||a&&!b){return false;}// playlist objects are the same, match
if(a===b){return true;}// first try to use id as it should be the most
// accurate
if(a.id&&b.id&&a.id===b.id){return true;}// next try to use reslovedUri as it should be the
// second most accurate.
if(a.resolvedUri&&b.resolvedUri&&a.resolvedUri===b.resolvedUri){return true;}// finally try to use uri as it should be accurate
// but might miss a few cases for relative uris
if(a.uri&&b.uri&&a.uri===b.uri){return true;}return false;};var someAudioVariant=function someAudioVariant(master,callback){var AUDIO=master&&master.mediaGroups&&master.mediaGroups.AUDIO||{};var found=false;for(var groupName in AUDIO){for(var label in AUDIO[groupName]){found=callback(AUDIO[groupName][label]);if(found){break;}}if(found){break;}}return!!found;};var isAudioOnly=function isAudioOnly(master){// we are audio only if we have no main playlists but do
// have media group playlists.
if(!master||!master.playlists||!master.playlists.length){// without audio variants or playlists this
// is not an audio only master.
var found=someAudioVariant(master,function(variant){return variant.playlists&&variant.playlists.length||variant.uri;});return found;}// if every playlist has only an audio codec it is audio only
var _loop=function _loop(i){var playlist=master.playlists[i];var CODECS=playlist.attributes&&playlist.attributes.CODECS;// all codecs are audio, this is an audio playlist.
if(CODECS&&CODECS.split(',').every(function(c){return isAudioCodec(c);})){return"continue";}// playlist is in an audio group it is audio only
var found=someAudioVariant(master,function(variant){return playlistMatch(playlist,variant);});if(found){return"continue";}// if we make it here this playlist isn't audio and we
// are not audio only
return{v:false};};for(var i=0;i<master.playlists.length;i++){var _ret=_loop(i);if(_ret==="continue")continue;if(video_es_typeof(_ret)==="object")return _ret.v;}// if we make it past every playlist without returning, then
// this is an audio only playlist.
return true;};// exports
var Playlist={liveEdgeDelay:liveEdgeDelay,duration:duration,seekable:seekable,getMediaInfoForTime:getMediaInfoForTime,isEnabled:isEnabled,isDisabled:isDisabled,isBlacklisted:isBlacklisted,isIncompatible:isIncompatible,playlistEnd:playlistEnd,isAes:isAes,hasAttribute:hasAttribute,estimateSegmentRequestTime:estimateSegmentRequestTime,isLowestEnabledRendition:isLowestEnabledRendition,isAudioOnly:isAudioOnly,playlistMatch:playlistMatch,segmentDurationWithParts:segmentDurationWithParts};var log=videojs.log;var createPlaylistID=function createPlaylistID(index,uri){return index+"-"+uri;};// default function for creating a group id
var groupID=function groupID(type,group,label){return"placeholder-uri-"+type+"-"+group+"-"+label;};/**
 * Parses a given m3u8 playlist
 *
 * @param {Function} [onwarn]
 *        a function to call when the parser triggers a warning event.
 * @param {Function} [oninfo]
 *        a function to call when the parser triggers an info event.
 * @param {string} manifestString
 *        The downloaded manifest string
 * @param {Object[]} [customTagParsers]
 *        An array of custom tag parsers for the m3u8-parser instance
 * @param {Object[]} [customTagMappers]
 *        An array of custom tag mappers for the m3u8-parser instance
 * @param {boolean} [experimentalLLHLS=false]
 *        Whether to keep ll-hls features in the manifest after parsing.
 * @return {Object}
 *         The manifest object
 */var parseManifest=function parseManifest(_ref){var onwarn=_ref.onwarn,oninfo=_ref.oninfo,manifestString=_ref.manifestString,_ref$customTagParsers=_ref.customTagParsers,customTagParsers=_ref$customTagParsers===void 0?[]:_ref$customTagParsers,_ref$customTagMappers=_ref.customTagMappers,customTagMappers=_ref$customTagMappers===void 0?[]:_ref$customTagMappers,experimentalLLHLS=_ref.experimentalLLHLS;var parser=new Parser();if(onwarn){parser.on('warn',onwarn);}if(oninfo){parser.on('info',oninfo);}customTagParsers.forEach(function(customParser){return parser.addParser(customParser);});customTagMappers.forEach(function(mapper){return parser.addTagMapper(mapper);});parser.push(manifestString);parser.end();var manifest=parser.manifest;// remove llhls features from the parsed manifest
// if we don't want llhls support.
if(!experimentalLLHLS){['preloadSegment','skip','serverControl','renditionReports','partInf','partTargetDuration'].forEach(function(k){if(manifest.hasOwnProperty(k)){delete manifest[k];}});if(manifest.segments){manifest.segments.forEach(function(segment){['parts','preloadHints'].forEach(function(k){if(segment.hasOwnProperty(k)){delete segment[k];}});});}}if(!manifest.targetDuration){var targetDuration=10;if(manifest.segments&&manifest.segments.length){targetDuration=manifest.segments.reduce(function(acc,s){return Math.max(acc,s.duration);},0);}if(onwarn){onwarn("manifest has no targetDuration defaulting to "+targetDuration);}manifest.targetDuration=targetDuration;}var parts=getLastParts(manifest);if(parts.length&&!manifest.partTargetDuration){var partTargetDuration=parts.reduce(function(acc,p){return Math.max(acc,p.duration);},0);if(onwarn){onwarn("manifest has no partTargetDuration defaulting to "+partTargetDuration);log.error('LL-HLS manifest has parts but lacks required #EXT-X-PART-INF:PART-TARGET value. See https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis-09#section-4.4.3.7. Playback is not guaranteed.');}manifest.partTargetDuration=partTargetDuration;}return manifest;};/**
 * Loops through all supported media groups in master and calls the provided
 * callback for each group
 *
 * @param {Object} master
 *        The parsed master manifest object
 * @param {Function} callback
 *        Callback to call for each media group
 */var video_es_forEachMediaGroup=function forEachMediaGroup(master,callback){if(!master.mediaGroups){return;}['AUDIO','SUBTITLES'].forEach(function(mediaType){if(!master.mediaGroups[mediaType]){return;}for(var groupKey in master.mediaGroups[mediaType]){for(var labelKey in master.mediaGroups[mediaType][groupKey]){var mediaProperties=master.mediaGroups[mediaType][groupKey][labelKey];callback(mediaProperties,mediaType,groupKey,labelKey);}}});};/**
 * Adds properties and attributes to the playlist to keep consistent functionality for
 * playlists throughout VHS.
 *
 * @param {Object} config
 *        Arguments object
 * @param {Object} config.playlist
 *        The media playlist
 * @param {string} [config.uri]
 *        The uri to the media playlist (if media playlist is not from within a master
 *        playlist)
 * @param {string} id
 *        ID to use for the playlist
 */var setupMediaPlaylist=function setupMediaPlaylist(_ref2){var playlist=_ref2.playlist,uri=_ref2.uri,id=_ref2.id;playlist.id=id;playlist.playlistErrors_=0;if(uri){// For media playlists, m3u8-parser does not have access to a URI, as HLS media
// playlists do not contain their own source URI, but one is needed for consistency in
// VHS.
playlist.uri=uri;}// For HLS master playlists, even though certain attributes MUST be defined, the
// stream may still be played without them.
// For HLS media playlists, m3u8-parser does not attach an attributes object to the
// manifest.
//
// To avoid undefined reference errors through the project, and make the code easier
// to write/read, add an empty attributes object for these cases.
playlist.attributes=playlist.attributes||{};};/**
 * Adds ID, resolvedUri, and attributes properties to each playlist of the master, where
 * necessary. In addition, creates playlist IDs for each playlist and adds playlist ID to
 * playlist references to the playlists array.
 *
 * @param {Object} master
 *        The master playlist
 */var setupMediaPlaylists=function setupMediaPlaylists(master){var i=master.playlists.length;while(i--){var playlist=master.playlists[i];setupMediaPlaylist({playlist:playlist,id:createPlaylistID(i,playlist.uri)});playlist.resolvedUri=video_es_resolveUrl(master.uri,playlist.uri);master.playlists[playlist.id]=playlist;// URI reference added for backwards compatibility
master.playlists[playlist.uri]=playlist;// Although the spec states an #EXT-X-STREAM-INF tag MUST have a BANDWIDTH attribute,
// the stream can be played without it. Although an attributes property may have been
// added to the playlist to prevent undefined references, issue a warning to fix the
// manifest.
if(!playlist.attributes.BANDWIDTH){log.warn('Invalid playlist STREAM-INF detected. Missing BANDWIDTH attribute.');}}};/**
 * Adds resolvedUri properties to each media group.
 *
 * @param {Object} master
 *        The master playlist
 */var resolveMediaGroupUris=function resolveMediaGroupUris(master){video_es_forEachMediaGroup(master,function(properties){if(properties.uri){properties.resolvedUri=video_es_resolveUrl(master.uri,properties.uri);}});};/**
 * Creates a master playlist wrapper to insert a sole media playlist into.
 *
 * @param {Object} media
 *        Media playlist
 * @param {string} uri
 *        The media URI
 *
 * @return {Object}
 *         Master playlist
 */var masterForMedia=function masterForMedia(media,uri){var id=createPlaylistID(0,uri);var master={mediaGroups:{'AUDIO':{},'VIDEO':{},'CLOSED-CAPTIONS':{},'SUBTITLES':{}},uri:(window_default()).location.href,resolvedUri:(window_default()).location.href,playlists:[{uri:uri,id:id,resolvedUri:uri,// m3u8-parser does not attach an attributes property to media playlists so make
// sure that the property is attached to avoid undefined reference errors
attributes:{}}]};// set up ID reference
master.playlists[id]=master.playlists[0];// URI reference added for backwards compatibility
master.playlists[uri]=master.playlists[0];return master;};/**
 * Does an in-place update of the master manifest to add updated playlist URI references
 * as well as other properties needed by VHS that aren't included by the parser.
 *
 * @param {Object} master
 *        Master manifest object
 * @param {string} uri
 *        The source URI
 * @param {function} createGroupID
 *        A function to determine how to create the groupID for mediaGroups
 */var addPropertiesToMaster=function addPropertiesToMaster(master,uri,createGroupID){if(createGroupID===void 0){createGroupID=groupID;}master.uri=uri;for(var i=0;i<master.playlists.length;i++){if(!master.playlists[i].uri){// Set up phony URIs for the playlists since playlists are referenced by their URIs
// throughout VHS, but some formats (e.g., DASH) don't have external URIs
// TODO: consider adding dummy URIs in mpd-parser
var phonyUri="placeholder-uri-"+i;master.playlists[i].uri=phonyUri;}}var audioOnlyMaster=isAudioOnly(master);video_es_forEachMediaGroup(master,function(properties,mediaType,groupKey,labelKey){// add a playlist array under properties
if(!properties.playlists||!properties.playlists.length){// If the manifest is audio only and this media group does not have a uri, check
// if the media group is located in the main list of playlists. If it is, don't add
// placeholder properties as it shouldn't be considered an alternate audio track.
if(audioOnlyMaster&&mediaType==='AUDIO'&&!properties.uri){for(var _i=0;_i<master.playlists.length;_i++){var p=master.playlists[_i];if(p.attributes&&p.attributes.AUDIO&&p.attributes.AUDIO===groupKey){return;}}}properties.playlists=[_extends({},properties)];}properties.playlists.forEach(function(p,i){var groupId=createGroupID(mediaType,groupKey,labelKey,p);var id=createPlaylistID(i,groupId);if(p.uri){p.resolvedUri=p.resolvedUri||video_es_resolveUrl(master.uri,p.uri);}else{// DEPRECATED, this has been added to prevent a breaking change.
// previously we only ever had a single media group playlist, so
// we mark the first playlist uri without prepending the index as we used to
// ideally we would do all of the playlists the same way.
p.uri=i===0?groupId:id;// don't resolve a placeholder uri to an absolute url, just use
// the placeholder again
p.resolvedUri=p.uri;}p.id=p.id||id;// add an empty attributes object, all playlists are
// expected to have this.
p.attributes=p.attributes||{};// setup ID and URI references (URI for backwards compatibility)
master.playlists[p.id]=p;master.playlists[p.uri]=p;});});setupMediaPlaylists(master);resolveMediaGroupUris(master);};var mergeOptions$2=videojs.mergeOptions,EventTarget$1=videojs.EventTarget;var addLLHLSQueryDirectives=function addLLHLSQueryDirectives(uri,media){if(media.endList||!media.serverControl){return uri;}var parameters={};if(media.serverControl.canBlockReload){var preloadSegment=media.preloadSegment;// next msn is a zero based value, length is not.
var nextMSN=media.mediaSequence+media.segments.length;// If preload segment has parts then it is likely
// that we are going to request a part of that preload segment.
// the logic below is used to determine that.
if(preloadSegment){var parts=preloadSegment.parts||[];// _HLS_part is a zero based index
var nextPart=getKnownPartCount(media)-1;// if nextPart is > -1 and not equal to just the
// length of parts, then we know we had part preload hints
// and we need to add the _HLS_part= query
if(nextPart>-1&&nextPart!==parts.length-1){// add existing parts to our preload hints
// eslint-disable-next-line
parameters._HLS_part=nextPart;}// this if statement makes sure that we request the msn
// of the preload segment if:
// 1. the preload segment had parts (and was not yet a full segment)
//    but was added to our segments array
// 2. the preload segment had preload hints for parts that are not in
//    the manifest yet.
// in all other cases we want the segment after the preload segment
// which will be given by using media.segments.length because it is 1 based
// rather than 0 based.
if(nextPart>-1||parts.length){nextMSN--;}}// add _HLS_msn= in front of any _HLS_part query
// eslint-disable-next-line
parameters._HLS_msn=nextMSN;}if(media.serverControl&&media.serverControl.canSkipUntil){// add _HLS_skip= infront of all other queries.
// eslint-disable-next-line
parameters._HLS_skip=media.serverControl.canSkipDateranges?'v2':'YES';}if(Object.keys(parameters).length){var parsedUri=new (window_default()).URL(uri);['_HLS_skip','_HLS_msn','_HLS_part'].forEach(function(name){if(!parameters.hasOwnProperty(name)){return;}parsedUri.searchParams.set(name,parameters[name]);});uri=parsedUri.toString();}return uri;};/**
 * Returns a new segment object with properties and
 * the parts array merged.
 *
 * @param {Object} a the old segment
 * @param {Object} b the new segment
 *
 * @return {Object} the merged segment
 */var updateSegment=function updateSegment(a,b){if(!a){return b;}var result=mergeOptions$2(a,b);// if only the old segment has preload hints
// and the new one does not, remove preload hints.
if(a.preloadHints&&!b.preloadHints){delete result.preloadHints;}// if only the old segment has parts
// then the parts are no longer valid
if(a.parts&&!b.parts){delete result.parts;// if both segments have parts
// copy part propeties from the old segment
// to the new one.
}else if(a.parts&&b.parts){for(var i=0;i<b.parts.length;i++){if(a.parts&&a.parts[i]){result.parts[i]=mergeOptions$2(a.parts[i],b.parts[i]);}}}// set skipped to false for segments that have
// have had information merged from the old segment.
if(!a.skipped&&b.skipped){result.skipped=false;}// set preload to false for segments that have
// had information added in the new segment.
if(a.preload&&!b.preload){result.preload=false;}return result;};/**
 * Returns a new array of segments that is the result of merging
 * properties from an older list of segments onto an updated
 * list. No properties on the updated playlist will be ovewritten.
 *
 * @param {Array} original the outdated list of segments
 * @param {Array} update the updated list of segments
 * @param {number=} offset the index of the first update
 * segment in the original segment list. For non-live playlists,
 * this should always be zero and does not need to be
 * specified. For live playlists, it should be the difference
 * between the media sequence numbers in the original and updated
 * playlists.
 * @return {Array} a list of merged segment objects
 */var updateSegments=function updateSegments(original,update,offset){var oldSegments=original.slice();var newSegments=update.slice();offset=offset||0;var result=[];var currentMap;for(var newIndex=0;newIndex<newSegments.length;newIndex++){var oldSegment=oldSegments[newIndex+offset];var newSegment=newSegments[newIndex];if(oldSegment){currentMap=oldSegment.map||currentMap;result.push(updateSegment(oldSegment,newSegment));}else{// carry over map to new segment if it is missing
if(currentMap&&!newSegment.map){newSegment.map=currentMap;}result.push(newSegment);}}return result;};var resolveSegmentUris=function resolveSegmentUris(segment,baseUri){// preloadSegment will not have a uri at all
// as the segment isn't actually in the manifest yet, only parts
if(!segment.resolvedUri&&segment.uri){segment.resolvedUri=video_es_resolveUrl(baseUri,segment.uri);}if(segment.key&&!segment.key.resolvedUri){segment.key.resolvedUri=video_es_resolveUrl(baseUri,segment.key.uri);}if(segment.map&&!segment.map.resolvedUri){segment.map.resolvedUri=video_es_resolveUrl(baseUri,segment.map.uri);}if(segment.map&&segment.map.key&&!segment.map.key.resolvedUri){segment.map.key.resolvedUri=video_es_resolveUrl(baseUri,segment.map.key.uri);}if(segment.parts&&segment.parts.length){segment.parts.forEach(function(p){if(p.resolvedUri){return;}p.resolvedUri=video_es_resolveUrl(baseUri,p.uri);});}if(segment.preloadHints&&segment.preloadHints.length){segment.preloadHints.forEach(function(p){if(p.resolvedUri){return;}p.resolvedUri=video_es_resolveUrl(baseUri,p.uri);});}};var getAllSegments=function getAllSegments(media){var segments=media.segments||[];var preloadSegment=media.preloadSegment;// a preloadSegment with only preloadHints is not currently
// a usable segment, only include a preloadSegment that has
// parts.
if(preloadSegment&&preloadSegment.parts&&preloadSegment.parts.length){// if preloadHints has a MAP that means that the
// init segment is going to change. We cannot use any of the parts
// from this preload segment.
if(preloadSegment.preloadHints){for(var i=0;i<preloadSegment.preloadHints.length;i++){if(preloadSegment.preloadHints[i].type==='MAP'){return segments;}}}// set the duration for our preload segment to target duration.
preloadSegment.duration=media.targetDuration;preloadSegment.preload=true;segments.push(preloadSegment);}return segments;};// consider the playlist unchanged if the playlist object is the same or
// the number of segments is equal, the media sequence number is unchanged,
// and this playlist hasn't become the end of the playlist
var isPlaylistUnchanged=function isPlaylistUnchanged(a,b){return a===b||a.segments&&b.segments&&a.segments.length===b.segments.length&&a.endList===b.endList&&a.mediaSequence===b.mediaSequence&&a.preloadSegment===b.preloadSegment;};/**
  * Returns a new master playlist that is the result of merging an
  * updated media playlist into the original version. If the
  * updated media playlist does not match any of the playlist
  * entries in the original master playlist, null is returned.
  *
  * @param {Object} master a parsed master M3U8 object
  * @param {Object} media a parsed media M3U8 object
  * @return {Object} a new object that represents the original
  * master playlist with the updated media playlist merged in, or
  * null if the merge produced no change.
  */var updateMaster$1=function updateMaster(master,newMedia,unchangedCheck){if(unchangedCheck===void 0){unchangedCheck=isPlaylistUnchanged;}var result=mergeOptions$2(master,{});var oldMedia=result.playlists[newMedia.id];if(!oldMedia){return null;}if(unchangedCheck(oldMedia,newMedia)){return null;}newMedia.segments=getAllSegments(newMedia);var mergedPlaylist=mergeOptions$2(oldMedia,newMedia);// always use the new media's preload segment
if(mergedPlaylist.preloadSegment&&!newMedia.preloadSegment){delete mergedPlaylist.preloadSegment;}// if the update could overlap existing segment information, merge the two segment lists
if(oldMedia.segments){if(newMedia.skip){newMedia.segments=newMedia.segments||[];// add back in objects for skipped segments, so that we merge
// old properties into the new segments
for(var i=0;i<newMedia.skip.skippedSegments;i++){newMedia.segments.unshift({skipped:true});}}mergedPlaylist.segments=updateSegments(oldMedia.segments,newMedia.segments,newMedia.mediaSequence-oldMedia.mediaSequence);}// resolve any segment URIs to prevent us from having to do it later
mergedPlaylist.segments.forEach(function(segment){resolveSegmentUris(segment,mergedPlaylist.resolvedUri);});// TODO Right now in the playlists array there are two references to each playlist, one
// that is referenced by index, and one by URI. The index reference may no longer be
// necessary.
for(var _i=0;_i<result.playlists.length;_i++){if(result.playlists[_i].id===newMedia.id){result.playlists[_i]=mergedPlaylist;}}result.playlists[newMedia.id]=mergedPlaylist;// URI reference added for backwards compatibility
result.playlists[newMedia.uri]=mergedPlaylist;// update media group playlist references.
video_es_forEachMediaGroup(master,function(properties,mediaType,groupKey,labelKey){if(!properties.playlists){return;}for(var _i2=0;_i2<properties.playlists.length;_i2++){if(newMedia.id===properties.playlists[_i2].id){properties.playlists[_i2]=mergedPlaylist;}}});return result;};/**
 * Calculates the time to wait before refreshing a live playlist
 *
 * @param {Object} media
 *        The current media
 * @param {boolean} update
 *        True if there were any updates from the last refresh, false otherwise
 * @return {number}
 *         The time in ms to wait before refreshing the live playlist
 */var refreshDelay=function refreshDelay(media,update){var segments=media.segments||[];var lastSegment=segments[segments.length-1];var lastPart=lastSegment&&lastSegment.parts&&lastSegment.parts[lastSegment.parts.length-1];var lastDuration=lastPart&&lastPart.duration||lastSegment&&lastSegment.duration;if(update&&lastDuration){return lastDuration*1000;}// if the playlist is unchanged since the last reload or last segment duration
// cannot be determined, try again after half the target duration
return(media.partTargetDuration||media.targetDuration||10)*500;};/**
 * Load a playlist from a remote location
 *
 * @class PlaylistLoader
 * @extends Stream
 * @param {string|Object} src url or object of manifest
 * @param {boolean} withCredentials the withCredentials xhr option
 * @class
 */var PlaylistLoader=/*#__PURE__*/function(_EventTarget){_inheritsLoose(PlaylistLoader,_EventTarget);function PlaylistLoader(src,vhs,options){var _this;if(options===void 0){options={};}_this=_EventTarget.call(this)||this;if(!src){throw new Error('A non-empty playlist URL or object is required');}_this.logger_=logger('PlaylistLoader');var _options=options,_options$withCredenti=_options.withCredentials,withCredentials=_options$withCredenti===void 0?false:_options$withCredenti,_options$handleManife=_options.handleManifestRedirects,handleManifestRedirects=_options$handleManife===void 0?false:_options$handleManife;_this.src=src;_this.vhs_=vhs;_this.withCredentials=withCredentials;_this.handleManifestRedirects=handleManifestRedirects;var vhsOptions=vhs.options_;_this.customTagParsers=vhsOptions&&vhsOptions.customTagParsers||[];_this.customTagMappers=vhsOptions&&vhsOptions.customTagMappers||[];_this.experimentalLLHLS=vhsOptions&&vhsOptions.experimentalLLHLS||false;// force experimentalLLHLS for IE 11
if(videojs.browser.IE_VERSION){_this.experimentalLLHLS=false;}// initialize the loader state
_this.state='HAVE_NOTHING';// live playlist staleness timeout
_this.handleMediaupdatetimeout_=_this.handleMediaupdatetimeout_.bind(_assertThisInitialized(_this));_this.on('mediaupdatetimeout',_this.handleMediaupdatetimeout_);return _this;}var _proto=PlaylistLoader.prototype;_proto.handleMediaupdatetimeout_=function handleMediaupdatetimeout_(){var _this2=this;if(this.state!=='HAVE_METADATA'){// only refresh the media playlist if no other activity is going on
return;}var media=this.media();var uri=video_es_resolveUrl(this.master.uri,media.uri);if(this.experimentalLLHLS){uri=addLLHLSQueryDirectives(uri,media);}this.state='HAVE_CURRENT_METADATA';this.request=this.vhs_.xhr({uri:uri,withCredentials:this.withCredentials},function(error,req){// disposed
if(!_this2.request){return;}if(error){return _this2.playlistRequestError(_this2.request,_this2.media(),'HAVE_METADATA');}_this2.haveMetadata({playlistString:_this2.request.responseText,url:_this2.media().uri,id:_this2.media().id});});};_proto.playlistRequestError=function playlistRequestError(xhr,playlist,startingState){var uri=playlist.uri,id=playlist.id;// any in-flight request is now finished
this.request=null;if(startingState){this.state=startingState;}this.error={playlist:this.master.playlists[id],status:xhr.status,message:"HLS playlist request error at URL: "+uri+".",responseText:xhr.responseText,code:xhr.status>=500?4:2};this.trigger('error');};_proto.parseManifest_=function parseManifest_(_ref){var _this3=this;var url=_ref.url,manifestString=_ref.manifestString;return parseManifest({onwarn:function onwarn(_ref2){var message=_ref2.message;return _this3.logger_("m3u8-parser warn for "+url+": "+message);},oninfo:function oninfo(_ref3){var message=_ref3.message;return _this3.logger_("m3u8-parser info for "+url+": "+message);},manifestString:manifestString,customTagParsers:this.customTagParsers,customTagMappers:this.customTagMappers,experimentalLLHLS:this.experimentalLLHLS});}/**
   * Update the playlist loader's state in response to a new or updated playlist.
   *
   * @param {string} [playlistString]
   *        Playlist string (if playlistObject is not provided)
   * @param {Object} [playlistObject]
   *        Playlist object (if playlistString is not provided)
   * @param {string} url
   *        URL of playlist
   * @param {string} id
   *        ID to use for playlist
   */;_proto.haveMetadata=function haveMetadata(_ref4){var playlistString=_ref4.playlistString,playlistObject=_ref4.playlistObject,url=_ref4.url,id=_ref4.id;// any in-flight request is now finished
this.request=null;this.state='HAVE_METADATA';var playlist=playlistObject||this.parseManifest_({url:url,manifestString:playlistString});playlist.lastRequest=Date.now();setupMediaPlaylist({playlist:playlist,uri:url,id:id});// merge this playlist into the master
var update=updateMaster$1(this.master,playlist);this.targetDuration=playlist.partTargetDuration||playlist.targetDuration;this.pendingMedia_=null;if(update){this.master=update;this.media_=this.master.playlists[id];}else{this.trigger('playlistunchanged');}this.updateMediaUpdateTimeout_(refreshDelay(this.media(),!!update));this.trigger('loadedplaylist');}/**
    * Abort any outstanding work and clean up.
    */;_proto.dispose=function dispose(){this.trigger('dispose');this.stopRequest();window_default().clearTimeout(this.mediaUpdateTimeout);window_default().clearTimeout(this.finalRenditionTimeout);this.off();};_proto.stopRequest=function stopRequest(){if(this.request){var oldRequest=this.request;this.request=null;oldRequest.onreadystatechange=null;oldRequest.abort();}}/**
    * When called without any arguments, returns the currently
    * active media playlist. When called with a single argument,
    * triggers the playlist loader to asynchronously switch to the
    * specified media playlist. Calling this method while the
    * loader is in the HAVE_NOTHING causes an error to be emitted
    * but otherwise has no effect.
    *
    * @param {Object=} playlist the parsed media playlist
    * object to switch to
    * @param {boolean=} shouldDelay whether we should delay the request by half target duration
    *
    * @return {Playlist} the current loaded media
    */;_proto.media=function media(playlist,shouldDelay){var _this4=this;// getter
if(!playlist){return this.media_;}// setter
if(this.state==='HAVE_NOTHING'){throw new Error('Cannot switch media playlist from '+this.state);}// find the playlist object if the target playlist has been
// specified by URI
if(typeof playlist==='string'){if(!this.master.playlists[playlist]){throw new Error('Unknown playlist URI: '+playlist);}playlist=this.master.playlists[playlist];}window_default().clearTimeout(this.finalRenditionTimeout);if(shouldDelay){var delay=(playlist.partTargetDuration||playlist.targetDuration)/2*1000||5*1000;this.finalRenditionTimeout=window_default().setTimeout(this.media.bind(this,playlist,false),delay);return;}var startingState=this.state;var mediaChange=!this.media_||playlist.id!==this.media_.id;var masterPlaylistRef=this.master.playlists[playlist.id];// switch to fully loaded playlists immediately
if(masterPlaylistRef&&masterPlaylistRef.endList||// handle the case of a playlist object (e.g., if using vhs-json with a resolved
// media playlist or, for the case of demuxed audio, a resolved audio media group)
playlist.endList&&playlist.segments.length){// abort outstanding playlist requests
if(this.request){this.request.onreadystatechange=null;this.request.abort();this.request=null;}this.state='HAVE_METADATA';this.media_=playlist;// trigger media change if the active media has been updated
if(mediaChange){this.trigger('mediachanging');if(startingState==='HAVE_MASTER'){// The initial playlist was a master manifest, and the first media selected was
// also provided (in the form of a resolved playlist object) as part of the
// source object (rather than just a URL). Therefore, since the media playlist
// doesn't need to be requested, loadedmetadata won't trigger as part of the
// normal flow, and needs an explicit trigger here.
this.trigger('loadedmetadata');}else{this.trigger('mediachange');}}return;}// We update/set the timeout here so that live playlists
// that are not a media change will "start" the loader as expected.
// We expect that this function will start the media update timeout
// cycle again. This also prevents a playlist switch failure from
// causing us to stall during live.
this.updateMediaUpdateTimeout_(refreshDelay(playlist,true));// switching to the active playlist is a no-op
if(!mediaChange){return;}this.state='SWITCHING_MEDIA';// there is already an outstanding playlist request
if(this.request){if(playlist.resolvedUri===this.request.url){// requesting to switch to the same playlist multiple times
// has no effect after the first
return;}this.request.onreadystatechange=null;this.request.abort();this.request=null;}// request the new playlist
if(this.media_){this.trigger('mediachanging');}this.pendingMedia_=playlist;this.request=this.vhs_.xhr({uri:playlist.resolvedUri,withCredentials:this.withCredentials},function(error,req){// disposed
if(!_this4.request){return;}playlist.lastRequest=Date.now();playlist.resolvedUri=resolveManifestRedirect(_this4.handleManifestRedirects,playlist.resolvedUri,req);if(error){return _this4.playlistRequestError(_this4.request,playlist,startingState);}_this4.haveMetadata({playlistString:req.responseText,url:playlist.uri,id:playlist.id});// fire loadedmetadata the first time a media playlist is loaded
if(startingState==='HAVE_MASTER'){_this4.trigger('loadedmetadata');}else{_this4.trigger('mediachange');}});}/**
   * pause loading of the playlist
   */;_proto.pause=function pause(){if(this.mediaUpdateTimeout){window_default().clearTimeout(this.mediaUpdateTimeout);this.mediaUpdateTimeout=null;}this.stopRequest();if(this.state==='HAVE_NOTHING'){// If we pause the loader before any data has been retrieved, its as if we never
// started, so reset to an unstarted state.
this.started=false;}// Need to restore state now that no activity is happening
if(this.state==='SWITCHING_MEDIA'){// if the loader was in the process of switching media, it should either return to
// HAVE_MASTER or HAVE_METADATA depending on if the loader has loaded a media
// playlist yet. This is determined by the existence of loader.media_
if(this.media_){this.state='HAVE_METADATA';}else{this.state='HAVE_MASTER';}}else if(this.state==='HAVE_CURRENT_METADATA'){this.state='HAVE_METADATA';}}/**
   * start loading of the playlist
   */;_proto.load=function load(shouldDelay){var _this5=this;if(this.mediaUpdateTimeout){window_default().clearTimeout(this.mediaUpdateTimeout);this.mediaUpdateTimeout=null;}var media=this.media();if(shouldDelay){var delay=media?(media.partTargetDuration||media.targetDuration)/2*1000:5*1000;this.mediaUpdateTimeout=window_default().setTimeout(function(){_this5.mediaUpdateTimeout=null;_this5.load();},delay);return;}if(!this.started){this.start();return;}if(media&&!media.endList){this.trigger('mediaupdatetimeout');}else{this.trigger('loadedplaylist');}};_proto.updateMediaUpdateTimeout_=function updateMediaUpdateTimeout_(delay){var _this6=this;if(this.mediaUpdateTimeout){window_default().clearTimeout(this.mediaUpdateTimeout);this.mediaUpdateTimeout=null;}// we only have use mediaupdatetimeout for live playlists.
if(!this.media()||this.media().endList){return;}this.mediaUpdateTimeout=window_default().setTimeout(function(){_this6.mediaUpdateTimeout=null;_this6.trigger('mediaupdatetimeout');_this6.updateMediaUpdateTimeout_(delay);},delay);}/**
   * start loading of the playlist
   */;_proto.start=function start(){var _this7=this;this.started=true;if(video_es_typeof(this.src)==='object'){// in the case of an entirely constructed manifest object (meaning there's no actual
// manifest on a server), default the uri to the page's href
if(!this.src.uri){this.src.uri=(window_default()).location.href;}// resolvedUri is added on internally after the initial request. Since there's no
// request for pre-resolved manifests, add on resolvedUri here.
this.src.resolvedUri=this.src.uri;// Since a manifest object was passed in as the source (instead of a URL), the first
// request can be skipped (since the top level of the manifest, at a minimum, is
// already available as a parsed manifest object). However, if the manifest object
// represents a master playlist, some media playlists may need to be resolved before
// the starting segment list is available. Therefore, go directly to setup of the
// initial playlist, and let the normal flow continue from there.
//
// Note that the call to setup is asynchronous, as other sections of VHS may assume
// that the first request is asynchronous.
setTimeout(function(){_this7.setupInitialPlaylist(_this7.src);},0);return;}// request the specified URL
this.request=this.vhs_.xhr({uri:this.src,withCredentials:this.withCredentials},function(error,req){// disposed
if(!_this7.request){return;}// clear the loader's request reference
_this7.request=null;if(error){_this7.error={status:req.status,message:"HLS playlist request error at URL: "+_this7.src+".",responseText:req.responseText,// MEDIA_ERR_NETWORK
code:2};if(_this7.state==='HAVE_NOTHING'){_this7.started=false;}return _this7.trigger('error');}_this7.src=resolveManifestRedirect(_this7.handleManifestRedirects,_this7.src,req);var manifest=_this7.parseManifest_({manifestString:req.responseText,url:_this7.src});_this7.setupInitialPlaylist(manifest);});};_proto.srcUri=function srcUri(){return typeof this.src==='string'?this.src:this.src.uri;}/**
   * Given a manifest object that's either a master or media playlist, trigger the proper
   * events and set the state of the playlist loader.
   *
   * If the manifest object represents a master playlist, `loadedplaylist` will be
   * triggered to allow listeners to select a playlist. If none is selected, the loader
   * will default to the first one in the playlists array.
   *
   * If the manifest object represents a media playlist, `loadedplaylist` will be
   * triggered followed by `loadedmetadata`, as the only available playlist is loaded.
   *
   * In the case of a media playlist, a master playlist object wrapper with one playlist
   * will be created so that all logic can handle playlists in the same fashion (as an
   * assumed manifest object schema).
   *
   * @param {Object} manifest
   *        The parsed manifest object
   */;_proto.setupInitialPlaylist=function setupInitialPlaylist(manifest){this.state='HAVE_MASTER';if(manifest.playlists){this.master=manifest;addPropertiesToMaster(this.master,this.srcUri());// If the initial master playlist has playlists wtih segments already resolved,
// then resolve URIs in advance, as they are usually done after a playlist request,
// which may not happen if the playlist is resolved.
manifest.playlists.forEach(function(playlist){playlist.segments=getAllSegments(playlist);playlist.segments.forEach(function(segment){resolveSegmentUris(segment,playlist.resolvedUri);});});this.trigger('loadedplaylist');if(!this.request){// no media playlist was specifically selected so start
// from the first listed one
this.media(this.master.playlists[0]);}return;}// In order to support media playlists passed in as vhs-json, the case where the uri
// is not provided as part of the manifest should be considered, and an appropriate
// default used.
var uri=this.srcUri()||(window_default()).location.href;this.master=masterForMedia(manifest,uri);this.haveMetadata({playlistObject:manifest,url:uri,id:this.master.playlists[0].id});this.trigger('loadedmetadata');};return PlaylistLoader;}(EventTarget$1);/**
 * @file xhr.js
 */var videojsXHR=videojs.xhr,mergeOptions$1=videojs.mergeOptions;var callbackWrapper=function callbackWrapper(request,error,response,callback){var reqResponse=request.responseType==='arraybuffer'?request.response:request.responseText;if(!error&&reqResponse){request.responseTime=Date.now();request.roundTripTime=request.responseTime-request.requestTime;request.bytesReceived=reqResponse.byteLength||reqResponse.length;if(!request.bandwidth){request.bandwidth=Math.floor(request.bytesReceived/request.roundTripTime*8*1000);}}if(response.headers){request.responseHeaders=response.headers;}// videojs.xhr now uses a specific code on the error
// object to signal that a request has timed out instead
// of setting a boolean on the request object
if(error&&error.code==='ETIMEDOUT'){request.timedout=true;}// videojs.xhr no longer considers status codes outside of 200 and 0
// (for file uris) to be errors, but the old XHR did, so emulate that
// behavior. Status 206 may be used in response to byterange requests.
if(!error&&!request.aborted&&response.statusCode!==200&&response.statusCode!==206&&response.statusCode!==0){error=new Error('XHR Failed with a response of: '+(request&&(reqResponse||request.responseText)));}callback(error,request);};var xhrFactory=function xhrFactory(){var xhr=function XhrFunction(options,callback){// Add a default timeout
options=mergeOptions$1({timeout:45e3},options);// Allow an optional user-specified function to modify the option
// object before we construct the xhr request
var beforeRequest=XhrFunction.beforeRequest||videojs.Vhs.xhr.beforeRequest;if(beforeRequest&&typeof beforeRequest==='function'){var newOptions=beforeRequest(options);if(newOptions){options=newOptions;}}// Use the standard videojs.xhr() method unless `videojs.Vhs.xhr` has been overriden
// TODO: switch back to videojs.Vhs.xhr.name === 'XhrFunction' when we drop IE11
var xhrMethod=videojs.Vhs.xhr.original===true?videojsXHR:videojs.Vhs.xhr;var request=xhrMethod(options,function(error,response){return callbackWrapper(request,error,response,callback);});var originalAbort=request.abort;request.abort=function(){request.aborted=true;return originalAbort.apply(request,arguments);};request.uri=options.uri;request.requestTime=Date.now();return request;};xhr.original=true;return xhr;};/**
 * Turns segment byterange into a string suitable for use in
 * HTTP Range requests
 *
 * @param {Object} byterange - an object with two values defining the start and end
 *                             of a byte-range
 */var byterangeStr=function byterangeStr(byterange){// `byterangeEnd` is one less than `offset + length` because the HTTP range
// header uses inclusive ranges
var byterangeEnd;var byterangeStart=byterange.offset;if(typeof byterange.offset==='bigint'||typeof byterange.length==='bigint'){byterangeEnd=window_default().BigInt(byterange.offset)+window_default().BigInt(byterange.length)-window_default().BigInt(1);}else{byterangeEnd=byterange.offset+byterange.length-1;}return'bytes='+byterangeStart+'-'+byterangeEnd;};/**
 * Defines headers for use in the xhr request for a particular segment.
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 */var segmentXhrHeaders=function segmentXhrHeaders(segment){var headers={};if(segment.byterange){headers.Range=byterangeStr(segment.byterange);}return headers;};/**
 * @file bin-utils.js
 */ /**
 * convert a TimeRange to text
 *
 * @param {TimeRange} range the timerange to use for conversion
 * @param {number} i the iterator on the range to convert
 * @return {string} the range in string format
 */var textRange=function textRange(range,i){return range.start(i)+'-'+range.end(i);};/**
 * format a number as hex string
 *
 * @param {number} e The number
 * @param {number} i the iterator
 * @return {string} the hex formatted number as a string
 */var formatHexString=function formatHexString(e,i){var value=e.toString(16);return'00'.substring(0,2-value.length)+value+(i%2?' ':'');};var formatAsciiString=function formatAsciiString(e){if(e>=0x20&&e<0x7e){return String.fromCharCode(e);}return'.';};/**
 * Creates an object for sending to a web worker modifying properties that are TypedArrays
 * into a new object with seperated properties for the buffer, byteOffset, and byteLength.
 *
 * @param {Object} message
 *        Object of properties and values to send to the web worker
 * @return {Object}
 *         Modified message with TypedArray values expanded
 * @function createTransferableMessage
 */var createTransferableMessage=function createTransferableMessage(message){var transferable={};Object.keys(message).forEach(function(key){var value=message[key];if(isArrayBufferView(value)){transferable[key]={bytes:value.buffer,byteOffset:value.byteOffset,byteLength:value.byteLength};}else{transferable[key]=value;}});return transferable;};/**
 * Returns a unique string identifier for a media initialization
 * segment.
 *
 * @param {Object} initSegment
 *        the init segment object.
 *
 * @return {string} the generated init segment id
 */var initSegmentId=function initSegmentId(initSegment){var byterange=initSegment.byterange||{length:Infinity,offset:0};return[byterange.length,byterange.offset,initSegment.resolvedUri].join(',');};/**
 * Returns a unique string identifier for a media segment key.
 *
 * @param {Object} key the encryption key
 * @return {string} the unique id for the media segment key.
 */var segmentKeyId=function segmentKeyId(key){return key.resolvedUri;};/**
 * utils to help dump binary data to the console
 *
 * @param {Array|TypedArray} data
 *        data to dump to a string
 *
 * @return {string} the data as a hex string.
 */var hexDump=function hexDump(data){var bytes=Array.prototype.slice.call(data);var step=16;var result='';var hex;var ascii;for(var j=0;j<bytes.length/step;j++){hex=bytes.slice(j*step,j*step+step).map(formatHexString).join('');ascii=bytes.slice(j*step,j*step+step).map(formatAsciiString).join('');result+=hex+' '+ascii+'\n';}return result;};var tagDump=function tagDump(_ref){var bytes=_ref.bytes;return hexDump(bytes);};var textRanges=function textRanges(ranges){var result='';var i;for(i=0;i<ranges.length;i++){result+=textRange(ranges,i)+' ';}return result;};var utils=/*#__PURE__*/Object.freeze({__proto__:null,createTransferableMessage:createTransferableMessage,initSegmentId:initSegmentId,segmentKeyId:segmentKeyId,hexDump:hexDump,tagDump:tagDump,textRanges:textRanges});// TODO handle fmp4 case where the timing info is accurate and doesn't involve transmux
// 25% was arbitrarily chosen, and may need to be refined over time.
var SEGMENT_END_FUDGE_PERCENT=0.25;/**
 * Converts a player time (any time that can be gotten/set from player.currentTime(),
 * e.g., any time within player.seekable().start(0) to player.seekable().end(0)) to a
 * program time (any time referencing the real world (e.g., EXT-X-PROGRAM-DATE-TIME)).
 *
 * The containing segment is required as the EXT-X-PROGRAM-DATE-TIME serves as an "anchor
 * point" (a point where we have a mapping from program time to player time, with player
 * time being the post transmux start of the segment).
 *
 * For more details, see [this doc](../../docs/program-time-from-player-time.md).
 *
 * @param {number} playerTime the player time
 * @param {Object} segment the segment which contains the player time
 * @return {Date} program time
 */var playerTimeToProgramTime=function playerTimeToProgramTime(playerTime,segment){if(!segment.dateTimeObject){// Can't convert without an "anchor point" for the program time (i.e., a time that can
// be used to map the start of a segment with a real world time).
return null;}var transmuxerPrependedSeconds=segment.videoTimingInfo.transmuxerPrependedSeconds;var transmuxedStart=segment.videoTimingInfo.transmuxedPresentationStart;// get the start of the content from before old content is prepended
var startOfSegment=transmuxedStart+transmuxerPrependedSeconds;var offsetFromSegmentStart=playerTime-startOfSegment;return new Date(segment.dateTimeObject.getTime()+offsetFromSegmentStart*1000);};var originalSegmentVideoDuration=function originalSegmentVideoDuration(videoTimingInfo){return videoTimingInfo.transmuxedPresentationEnd-videoTimingInfo.transmuxedPresentationStart-videoTimingInfo.transmuxerPrependedSeconds;};/**
 * Finds a segment that contains the time requested given as an ISO-8601 string. The
 * returned segment might be an estimate or an accurate match.
 *
 * @param {string} programTime The ISO-8601 programTime to find a match for
 * @param {Object} playlist A playlist object to search within
 */var findSegmentForProgramTime=function findSegmentForProgramTime(programTime,playlist){// Assumptions:
//  - verifyProgramDateTimeTags has already been run
//  - live streams have been started
var dateTimeObject;try{dateTimeObject=new Date(programTime);}catch(e){return null;}if(!playlist||!playlist.segments||playlist.segments.length===0){return null;}var segment=playlist.segments[0];if(dateTimeObject<segment.dateTimeObject){// Requested time is before stream start.
return null;}for(var i=0;i<playlist.segments.length-1;i++){segment=playlist.segments[i];var nextSegmentStart=playlist.segments[i+1].dateTimeObject;if(dateTimeObject<nextSegmentStart){break;}}var lastSegment=playlist.segments[playlist.segments.length-1];var lastSegmentStart=lastSegment.dateTimeObject;var lastSegmentDuration=lastSegment.videoTimingInfo?originalSegmentVideoDuration(lastSegment.videoTimingInfo):lastSegment.duration+lastSegment.duration*SEGMENT_END_FUDGE_PERCENT;var lastSegmentEnd=new Date(lastSegmentStart.getTime()+lastSegmentDuration*1000);if(dateTimeObject>lastSegmentEnd){// Beyond the end of the stream, or our best guess of the end of the stream.
return null;}if(dateTimeObject>lastSegmentStart){segment=lastSegment;}return{segment:segment,estimatedStart:segment.videoTimingInfo?segment.videoTimingInfo.transmuxedPresentationStart:Playlist.duration(playlist,playlist.mediaSequence+playlist.segments.indexOf(segment)),// Although, given that all segments have accurate date time objects, the segment
// selected should be accurate, unless the video has been transmuxed at some point
// (determined by the presence of the videoTimingInfo object), the segment's "player
// time" (the start time in the player) can't be considered accurate.
type:segment.videoTimingInfo?'accurate':'estimate'};};/**
 * Finds a segment that contains the given player time(in seconds).
 *
 * @param {number} time The player time to find a match for
 * @param {Object} playlist A playlist object to search within
 */var findSegmentForPlayerTime=function findSegmentForPlayerTime(time,playlist){// Assumptions:
// - there will always be a segment.duration
// - we can start from zero
// - segments are in time order
if(!playlist||!playlist.segments||playlist.segments.length===0){return null;}var segmentEnd=0;var segment;for(var i=0;i<playlist.segments.length;i++){segment=playlist.segments[i];// videoTimingInfo is set after the segment is downloaded and transmuxed, and
// should contain the most accurate values we have for the segment's player times.
//
// Use the accurate transmuxedPresentationEnd value if it is available, otherwise fall
// back to an estimate based on the manifest derived (inaccurate) segment.duration, to
// calculate an end value.
segmentEnd=segment.videoTimingInfo?segment.videoTimingInfo.transmuxedPresentationEnd:segmentEnd+segment.duration;if(time<=segmentEnd){break;}}var lastSegment=playlist.segments[playlist.segments.length-1];if(lastSegment.videoTimingInfo&&lastSegment.videoTimingInfo.transmuxedPresentationEnd<time){// The time requested is beyond the stream end.
return null;}if(time>segmentEnd){// The time is within or beyond the last segment.
//
// Check to see if the time is beyond a reasonable guess of the end of the stream.
if(time>segmentEnd+lastSegment.duration*SEGMENT_END_FUDGE_PERCENT){// Technically, because the duration value is only an estimate, the time may still
// exist in the last segment, however, there isn't enough information to make even
// a reasonable estimate.
return null;}segment=lastSegment;}return{segment:segment,estimatedStart:segment.videoTimingInfo?segment.videoTimingInfo.transmuxedPresentationStart:segmentEnd-segment.duration,// Because videoTimingInfo is only set after transmux, it is the only way to get
// accurate timing values.
type:segment.videoTimingInfo?'accurate':'estimate'};};/**
 * Gives the offset of the comparisonTimestamp from the programTime timestamp in seconds.
 * If the offset returned is positive, the programTime occurs after the
 * comparisonTimestamp.
 * If the offset is negative, the programTime occurs before the comparisonTimestamp.
 *
 * @param {string} comparisonTimeStamp An ISO-8601 timestamp to compare against
 * @param {string} programTime The programTime as an ISO-8601 string
 * @return {number} offset
 */var getOffsetFromTimestamp=function getOffsetFromTimestamp(comparisonTimeStamp,programTime){var segmentDateTime;var programDateTime;try{segmentDateTime=new Date(comparisonTimeStamp);programDateTime=new Date(programTime);}catch(e){// TODO handle error
}var segmentTimeEpoch=segmentDateTime.getTime();var programTimeEpoch=programDateTime.getTime();return(programTimeEpoch-segmentTimeEpoch)/1000;};/**
 * Checks that all segments in this playlist have programDateTime tags.
 *
 * @param {Object} playlist A playlist object
 */var verifyProgramDateTimeTags=function verifyProgramDateTimeTags(playlist){if(!playlist.segments||playlist.segments.length===0){return false;}for(var i=0;i<playlist.segments.length;i++){var segment=playlist.segments[i];if(!segment.dateTimeObject){return false;}}return true;};/**
 * Returns the programTime of the media given a playlist and a playerTime.
 * The playlist must have programDateTime tags for a programDateTime tag to be returned.
 * If the segments containing the time requested have not been buffered yet, an estimate
 * may be returned to the callback.
 *
 * @param {Object} args
 * @param {Object} args.playlist A playlist object to search within
 * @param {number} time A playerTime in seconds
 * @param {Function} callback(err, programTime)
 * @return {string} err.message A detailed error message
 * @return {Object} programTime
 * @return {number} programTime.mediaSeconds The streamTime in seconds
 * @return {string} programTime.programDateTime The programTime as an ISO-8601 String
 */var getProgramTime=function getProgramTime(_ref){var playlist=_ref.playlist,_ref$time=_ref.time,time=_ref$time===void 0?undefined:_ref$time,callback=_ref.callback;if(!callback){throw new Error('getProgramTime: callback must be provided');}if(!playlist||time===undefined){return callback({message:'getProgramTime: playlist and time must be provided'});}var matchedSegment=findSegmentForPlayerTime(time,playlist);if(!matchedSegment){return callback({message:'valid programTime was not found'});}if(matchedSegment.type==='estimate'){return callback({message:'Accurate programTime could not be determined.'+' Please seek to e.seekTime and try again',seekTime:matchedSegment.estimatedStart});}var programTimeObject={mediaSeconds:time};var programTime=playerTimeToProgramTime(time,matchedSegment.segment);if(programTime){programTimeObject.programDateTime=programTime.toISOString();}return callback(null,programTimeObject);};/**
 * Seeks in the player to a time that matches the given programTime ISO-8601 string.
 *
 * @param {Object} args
 * @param {string} args.programTime A programTime to seek to as an ISO-8601 String
 * @param {Object} args.playlist A playlist to look within
 * @param {number} args.retryCount The number of times to try for an accurate seek. Default is 2.
 * @param {Function} args.seekTo A method to perform a seek
 * @param {boolean} args.pauseAfterSeek Whether to end in a paused state after seeking. Default is true.
 * @param {Object} args.tech The tech to seek on
 * @param {Function} args.callback(err, newTime) A callback to return the new time to
 * @return {string} err.message A detailed error message
 * @return {number} newTime The exact time that was seeked to in seconds
 */var seekToProgramTime=function seekToProgramTime(_ref2){var programTime=_ref2.programTime,playlist=_ref2.playlist,_ref2$retryCount=_ref2.retryCount,retryCount=_ref2$retryCount===void 0?2:_ref2$retryCount,seekTo=_ref2.seekTo,_ref2$pauseAfterSeek=_ref2.pauseAfterSeek,pauseAfterSeek=_ref2$pauseAfterSeek===void 0?true:_ref2$pauseAfterSeek,tech=_ref2.tech,callback=_ref2.callback;if(!callback){throw new Error('seekToProgramTime: callback must be provided');}if(typeof programTime==='undefined'||!playlist||!seekTo){return callback({message:'seekToProgramTime: programTime, seekTo and playlist must be provided'});}if(!playlist.endList&&!tech.hasStarted_){return callback({message:'player must be playing a live stream to start buffering'});}if(!verifyProgramDateTimeTags(playlist)){return callback({message:'programDateTime tags must be provided in the manifest '+playlist.resolvedUri});}var matchedSegment=findSegmentForProgramTime(programTime,playlist);// no match
if(!matchedSegment){return callback({message:programTime+" was not found in the stream"});}var segment=matchedSegment.segment;var mediaOffset=getOffsetFromTimestamp(segment.dateTimeObject,programTime);if(matchedSegment.type==='estimate'){// we've run out of retries
if(retryCount===0){return callback({message:programTime+" is not buffered yet. Try again"});}seekTo(matchedSegment.estimatedStart+mediaOffset);tech.one('seeked',function(){seekToProgramTime({programTime:programTime,playlist:playlist,retryCount:retryCount-1,seekTo:seekTo,pauseAfterSeek:pauseAfterSeek,tech:tech,callback:callback});});return;}// Since the segment.start value is determined from the buffered end or ending time
// of the prior segment, the seekToTime doesn't need to account for any transmuxer
// modifications.
var seekToTime=segment.start+mediaOffset;var seekedCallback=function seekedCallback(){return callback(null,tech.currentTime());};// listen for seeked event
tech.one('seeked',seekedCallback);// pause before seeking as video.js will restore this state
if(pauseAfterSeek){tech.pause();}seekTo(seekToTime);};// which will only happen if the request is complete.
var callbackOnCompleted=function callbackOnCompleted(request,cb){if(request.readyState===4){return cb();}return;};var containerRequest=function containerRequest(uri,xhr,cb){var bytes=[];var id3Offset;var finished=false;var endRequestAndCallback=function endRequestAndCallback(err,req,type,_bytes){req.abort();finished=true;return cb(err,req,type,_bytes);};var progressListener=function progressListener(error,request){if(finished){return;}if(error){return endRequestAndCallback(error,request,'',bytes);}// grap the new part of content that was just downloaded
var newPart=request.responseText.substring(bytes&&bytes.byteLength||0,request.responseText.length);// add that onto bytes
bytes=concatTypedArrays(bytes,stringToBytes(newPart,true));id3Offset=id3Offset||getId3Offset(bytes);// we need at least 10 bytes to determine a type
// or we need at least two bytes after an id3Offset
if(bytes.length<10||id3Offset&&bytes.length<id3Offset+2){return callbackOnCompleted(request,function(){return endRequestAndCallback(error,request,'',bytes);});}var type=detectContainerForBytes(bytes);// if this looks like a ts segment but we don't have enough data
// to see the second sync byte, wait until we have enough data
// before declaring it ts
if(type==='ts'&&bytes.length<188){return callbackOnCompleted(request,function(){return endRequestAndCallback(error,request,'',bytes);});}// this may be an unsynced ts segment
// wait for 376 bytes before detecting no container
if(!type&&bytes.length<376){return callbackOnCompleted(request,function(){return endRequestAndCallback(error,request,'',bytes);});}return endRequestAndCallback(null,request,type,bytes);};var options={uri:uri,beforeSend:function beforeSend(request){// this forces the browser to pass the bytes to us unprocessed
request.overrideMimeType('text/plain; charset=x-user-defined');request.addEventListener('progress',function(_ref){_ref.total;_ref.loaded;return callbackWrapper(request,null,{statusCode:request.status},progressListener);});}};var request=xhr(options,function(error,response){return callbackWrapper(request,error,response,progressListener);});return request;};var EventTarget=videojs.EventTarget,mergeOptions=videojs.mergeOptions;var dashPlaylistUnchanged=function dashPlaylistUnchanged(a,b){if(!isPlaylistUnchanged(a,b)){return false;}// for dash the above check will often return true in scenarios where
// the playlist actually has changed because mediaSequence isn't a
// dash thing, and we often set it to 1. So if the playlists have the same amount
// of segments we return true.
// So for dash we need to make sure that the underlying segments are different.
// if sidx changed then the playlists are different.
if(a.sidx&&b.sidx&&(a.sidx.offset!==b.sidx.offset||a.sidx.length!==b.sidx.length)){return false;}else if(!a.sidx&&b.sidx||a.sidx&&!b.sidx){return false;}// one or the other does not have segments
// there was a change.
if(a.segments&&!b.segments||!a.segments&&b.segments){return false;}// neither has segments nothing changed
if(!a.segments&&!b.segments){return true;}// check segments themselves
for(var i=0;i<a.segments.length;i++){var aSegment=a.segments[i];var bSegment=b.segments[i];// if uris are different between segments there was a change
if(aSegment.uri!==bSegment.uri){return false;}// neither segment has a byterange, there will be no byterange change.
if(!aSegment.byterange&&!bSegment.byterange){continue;}var aByterange=aSegment.byterange;var bByterange=bSegment.byterange;// if byterange only exists on one of the segments, there was a change.
if(aByterange&&!bByterange||!aByterange&&bByterange){return false;}// if both segments have byterange with different offsets, there was a change.
if(aByterange.offset!==bByterange.offset||aByterange.length!==bByterange.length){return false;}}// if everything was the same with segments, this is the same playlist.
return true;};/**
 * Use the representation IDs from the mpd object to create groupIDs, the NAME is set to mandatory representation
 * ID in the parser. This allows for continuous playout across periods with the same representation IDs
 * (continuous periods as defined in DASH-IF 3.2.12). This is assumed in the mpd-parser as well. If we want to support
 * periods without continuous playback this function may need modification as well as the parser.
 */var dashGroupId=function dashGroupId(type,group,label,playlist){// If the manifest somehow does not have an ID (non-dash compliant), use the label.
var playlistId=playlist.attributes.NAME||label;return"placeholder-uri-"+type+"-"+group+"-"+playlistId;};/**
 * Parses the master XML string and updates playlist URI references.
 *
 * @param {Object} config
 *        Object of arguments
 * @param {string} config.masterXml
 *        The mpd XML
 * @param {string} config.srcUrl
 *        The mpd URL
 * @param {Date} config.clientOffset
 *         A time difference between server and client
 * @param {Object} config.sidxMapping
 *        SIDX mappings for moof/mdat URIs and byte ranges
 * @return {Object}
 *         The parsed mpd manifest object
 */var parseMasterXml=function parseMasterXml(_ref){var masterXml=_ref.masterXml,srcUrl=_ref.srcUrl,clientOffset=_ref.clientOffset,sidxMapping=_ref.sidxMapping,previousManifest=_ref.previousManifest;var manifest=parse(masterXml,{manifestUri:srcUrl,clientOffset:clientOffset,sidxMapping:sidxMapping,previousManifest:previousManifest});addPropertiesToMaster(manifest,srcUrl,dashGroupId);return manifest;};/**
 * Removes any mediaGroup labels that no longer exist in the newMaster
 *
 * @param {Object} update
 *         The previous mpd object being updated
 * @param {Object} newMaster
 *         The new mpd object
 */var removeOldMediaGroupLabels=function removeOldMediaGroupLabels(update,newMaster){video_es_forEachMediaGroup(update,function(properties,type,group,label){if(!(label in newMaster.mediaGroups[type][group])){delete update.mediaGroups[type][group][label];}});};/**
 * Returns a new master manifest that is the result of merging an updated master manifest
 * into the original version.
 *
 * @param {Object} oldMaster
 *        The old parsed mpd object
 * @param {Object} newMaster
 *        The updated parsed mpd object
 * @return {Object}
 *         A new object representing the original master manifest with the updated media
 *         playlists merged in
 */var updateMaster=function updateMaster(oldMaster,newMaster,sidxMapping){var noChanges=true;var update=mergeOptions(oldMaster,{// These are top level properties that can be updated
duration:newMaster.duration,minimumUpdatePeriod:newMaster.minimumUpdatePeriod,timelineStarts:newMaster.timelineStarts});// First update the playlists in playlist list
for(var i=0;i<newMaster.playlists.length;i++){var playlist=newMaster.playlists[i];if(playlist.sidx){var sidxKey=generateSidxKey(playlist.sidx);// add sidx segments to the playlist if we have all the sidx info already
if(sidxMapping&&sidxMapping[sidxKey]&&sidxMapping[sidxKey].sidx){addSidxSegmentsToPlaylist$1(playlist,sidxMapping[sidxKey].sidx,playlist.sidx.resolvedUri);}}var playlistUpdate=updateMaster$1(update,playlist,dashPlaylistUnchanged);if(playlistUpdate){update=playlistUpdate;noChanges=false;}}// Then update media group playlists
video_es_forEachMediaGroup(newMaster,function(properties,type,group,label){if(properties.playlists&&properties.playlists.length){var id=properties.playlists[0].id;var _playlistUpdate=updateMaster$1(update,properties.playlists[0],dashPlaylistUnchanged);if(_playlistUpdate){update=_playlistUpdate;// add new mediaGroup label if it doesn't exist and assign the new mediaGroup.
if(!(label in update.mediaGroups[type][group])){update.mediaGroups[type][group][label]=properties;}// update the playlist reference within media groups
update.mediaGroups[type][group][label].playlists[0]=update.playlists[id];noChanges=false;}}});// remove mediaGroup labels and references that no longer exist in the newMaster
removeOldMediaGroupLabels(update,newMaster);if(newMaster.minimumUpdatePeriod!==oldMaster.minimumUpdatePeriod){noChanges=false;}if(noChanges){return null;}return update;};// SIDX should be equivalent if the URI and byteranges of the SIDX match.
// If the SIDXs have maps, the two maps should match,
// both `a` and `b` missing SIDXs is considered matching.
// If `a` or `b` but not both have a map, they aren't matching.
var equivalentSidx=function equivalentSidx(a,b){var neitherMap=Boolean(!a.map&&!b.map);var equivalentMap=neitherMap||Boolean(a.map&&b.map&&a.map.byterange.offset===b.map.byterange.offset&&a.map.byterange.length===b.map.byterange.length);return equivalentMap&&a.uri===b.uri&&a.byterange.offset===b.byterange.offset&&a.byterange.length===b.byterange.length;};// exported for testing
var compareSidxEntry=function compareSidxEntry(playlists,oldSidxMapping){var newSidxMapping={};for(var id in playlists){var playlist=playlists[id];var currentSidxInfo=playlist.sidx;if(currentSidxInfo){var key=generateSidxKey(currentSidxInfo);if(!oldSidxMapping[key]){break;}var savedSidxInfo=oldSidxMapping[key].sidxInfo;if(equivalentSidx(savedSidxInfo,currentSidxInfo)){newSidxMapping[key]=oldSidxMapping[key];}}}return newSidxMapping;};/**
 *  A function that filters out changed items as they need to be requested separately.
 *
 *  The method is exported for testing
 *
 *  @param {Object} master the parsed mpd XML returned via mpd-parser
 *  @param {Object} oldSidxMapping the SIDX to compare against
 */var filterChangedSidxMappings=function filterChangedSidxMappings(master,oldSidxMapping){var videoSidx=compareSidxEntry(master.playlists,oldSidxMapping);var mediaGroupSidx=videoSidx;video_es_forEachMediaGroup(master,function(properties,mediaType,groupKey,labelKey){if(properties.playlists&&properties.playlists.length){var playlists=properties.playlists;mediaGroupSidx=mergeOptions(mediaGroupSidx,compareSidxEntry(playlists,oldSidxMapping));}});return mediaGroupSidx;};var DashPlaylistLoader=/*#__PURE__*/function(_EventTarget){_inheritsLoose(DashPlaylistLoader,_EventTarget);// DashPlaylistLoader must accept either a src url or a playlist because subsequent
// playlist loader setups from media groups will expect to be able to pass a playlist
// (since there aren't external URLs to media playlists with DASH)
function DashPlaylistLoader(srcUrlOrPlaylist,vhs,options,masterPlaylistLoader){var _this;if(options===void 0){options={};}_this=_EventTarget.call(this)||this;_this.masterPlaylistLoader_=masterPlaylistLoader||_assertThisInitialized(_this);if(!masterPlaylistLoader){_this.isMaster_=true;}var _options=options,_options$withCredenti=_options.withCredentials,withCredentials=_options$withCredenti===void 0?false:_options$withCredenti,_options$handleManife=_options.handleManifestRedirects,handleManifestRedirects=_options$handleManife===void 0?false:_options$handleManife;_this.vhs_=vhs;_this.withCredentials=withCredentials;_this.handleManifestRedirects=handleManifestRedirects;if(!srcUrlOrPlaylist){throw new Error('A non-empty playlist URL or object is required');}// event naming?
_this.on('minimumUpdatePeriod',function(){_this.refreshXml_();});// live playlist staleness timeout
_this.on('mediaupdatetimeout',function(){_this.refreshMedia_(_this.media().id);});_this.state='HAVE_NOTHING';_this.loadedPlaylists_={};_this.logger_=logger('DashPlaylistLoader');// initialize the loader state
// The masterPlaylistLoader will be created with a string
if(_this.isMaster_){_this.masterPlaylistLoader_.srcUrl=srcUrlOrPlaylist;// TODO: reset sidxMapping between period changes
// once multi-period is refactored
_this.masterPlaylistLoader_.sidxMapping_={};}else{_this.childPlaylist_=srcUrlOrPlaylist;}return _this;}var _proto=DashPlaylistLoader.prototype;_proto.requestErrored_=function requestErrored_(err,request,startingState){// disposed
if(!this.request){return true;}// pending request is cleared
this.request=null;if(err){// use the provided error object or create one
// based on the request/response
this.error=video_es_typeof(err)==='object'&&!(err instanceof Error)?err:{status:request.status,message:'DASH request error at URL: '+request.uri,response:request.response,// MEDIA_ERR_NETWORK
code:2};if(startingState){this.state=startingState;}this.trigger('error');return true;}}/**
   * Verify that the container of the sidx segment can be parsed
   * and if it can, get and parse that segment.
   */;_proto.addSidxSegments_=function addSidxSegments_(playlist,startingState,cb){var _this2=this;var sidxKey=playlist.sidx&&generateSidxKey(playlist.sidx);// playlist lacks sidx or sidx segments were added to this playlist already.
if(!playlist.sidx||!sidxKey||this.masterPlaylistLoader_.sidxMapping_[sidxKey]){// keep this function async
this.mediaRequest_=window_default().setTimeout(function(){return cb(false);},0);return;}// resolve the segment URL relative to the playlist
var uri=resolveManifestRedirect(this.handleManifestRedirects,playlist.sidx.resolvedUri);var fin=function fin(err,request){if(_this2.requestErrored_(err,request,startingState)){return;}var sidxMapping=_this2.masterPlaylistLoader_.sidxMapping_;var sidx;try{sidx=parse_sidx_default()(byte_helpers_toUint8(request.response).subarray(8));}catch(e){// sidx parsing failed.
_this2.requestErrored_(e,request,startingState);return;}sidxMapping[sidxKey]={sidxInfo:playlist.sidx,sidx:sidx};addSidxSegmentsToPlaylist$1(playlist,sidx,playlist.sidx.resolvedUri);return cb(true);};this.request=containerRequest(uri,this.vhs_.xhr,function(err,request,container,bytes){if(err){return fin(err,request);}if(!container||container!=='mp4'){return fin({status:request.status,message:"Unsupported "+(container||'unknown')+" container type for sidx segment at URL: "+uri,// response is just bytes in this case
// but we really don't want to return that.
response:'',playlist:playlist,internal:true,blacklistDuration:Infinity,// MEDIA_ERR_NETWORK
code:2},request);}// if we already downloaded the sidx bytes in the container request, use them
var _playlist$sidx$bytera=playlist.sidx.byterange,offset=_playlist$sidx$bytera.offset,length=_playlist$sidx$bytera.length;if(bytes.length>=length+offset){return fin(err,{response:bytes.subarray(offset,offset+length),status:request.status,uri:request.uri});}// otherwise request sidx bytes
_this2.request=_this2.vhs_.xhr({uri:uri,responseType:'arraybuffer',headers:segmentXhrHeaders({byterange:playlist.sidx.byterange})},fin);});};_proto.dispose=function dispose(){this.trigger('dispose');this.stopRequest();this.loadedPlaylists_={};window_default().clearTimeout(this.minimumUpdatePeriodTimeout_);window_default().clearTimeout(this.mediaRequest_);window_default().clearTimeout(this.mediaUpdateTimeout);this.mediaUpdateTimeout=null;this.mediaRequest_=null;this.minimumUpdatePeriodTimeout_=null;if(this.masterPlaylistLoader_.createMupOnMedia_){this.off('loadedmetadata',this.masterPlaylistLoader_.createMupOnMedia_);this.masterPlaylistLoader_.createMupOnMedia_=null;}this.off();};_proto.hasPendingRequest=function hasPendingRequest(){return this.request||this.mediaRequest_;};_proto.stopRequest=function stopRequest(){if(this.request){var oldRequest=this.request;this.request=null;oldRequest.onreadystatechange=null;oldRequest.abort();}};_proto.media=function media(playlist){var _this3=this;// getter
if(!playlist){return this.media_;}// setter
if(this.state==='HAVE_NOTHING'){throw new Error('Cannot switch media playlist from '+this.state);}var startingState=this.state;// find the playlist object if the target playlist has been specified by URI
if(typeof playlist==='string'){if(!this.masterPlaylistLoader_.master.playlists[playlist]){throw new Error('Unknown playlist URI: '+playlist);}playlist=this.masterPlaylistLoader_.master.playlists[playlist];}var mediaChange=!this.media_||playlist.id!==this.media_.id;// switch to previously loaded playlists immediately
if(mediaChange&&this.loadedPlaylists_[playlist.id]&&this.loadedPlaylists_[playlist.id].endList){this.state='HAVE_METADATA';this.media_=playlist;// trigger media change if the active media has been updated
if(mediaChange){this.trigger('mediachanging');this.trigger('mediachange');}return;}// switching to the active playlist is a no-op
if(!mediaChange){return;}// switching from an already loaded playlist
if(this.media_){this.trigger('mediachanging');}this.addSidxSegments_(playlist,startingState,function(sidxChanged){// everything is ready just continue to haveMetadata
_this3.haveMetadata({startingState:startingState,playlist:playlist});});};_proto.haveMetadata=function haveMetadata(_ref2){var startingState=_ref2.startingState,playlist=_ref2.playlist;this.state='HAVE_METADATA';this.loadedPlaylists_[playlist.id]=playlist;this.mediaRequest_=null;// This will trigger loadedplaylist
this.refreshMedia_(playlist.id);// fire loadedmetadata the first time a media playlist is loaded
// to resolve setup of media groups
if(startingState==='HAVE_MASTER'){this.trigger('loadedmetadata');}else{// trigger media change if the active media has been updated
this.trigger('mediachange');}};_proto.pause=function pause(){if(this.masterPlaylistLoader_.createMupOnMedia_){this.off('loadedmetadata',this.masterPlaylistLoader_.createMupOnMedia_);this.masterPlaylistLoader_.createMupOnMedia_=null;}this.stopRequest();window_default().clearTimeout(this.mediaUpdateTimeout);this.mediaUpdateTimeout=null;if(this.isMaster_){window_default().clearTimeout(this.masterPlaylistLoader_.minimumUpdatePeriodTimeout_);this.masterPlaylistLoader_.minimumUpdatePeriodTimeout_=null;}if(this.state==='HAVE_NOTHING'){// If we pause the loader before any data has been retrieved, its as if we never
// started, so reset to an unstarted state.
this.started=false;}};_proto.load=function load(isFinalRendition){var _this4=this;window_default().clearTimeout(this.mediaUpdateTimeout);this.mediaUpdateTimeout=null;var media=this.media();if(isFinalRendition){var delay=media?media.targetDuration/2*1000:5*1000;this.mediaUpdateTimeout=window_default().setTimeout(function(){return _this4.load();},delay);return;}// because the playlists are internal to the manifest, load should either load the
// main manifest, or do nothing but trigger an event
if(!this.started){this.start();return;}if(media&&!media.endList){// Check to see if this is the master loader and the MUP was cleared (this happens
// when the loader was paused). `media` should be set at this point since one is always
// set during `start()`.
if(this.isMaster_&&!this.minimumUpdatePeriodTimeout_){// Trigger minimumUpdatePeriod to refresh the master manifest
this.trigger('minimumUpdatePeriod');// Since there was no prior minimumUpdatePeriodTimeout it should be recreated
this.updateMinimumUpdatePeriodTimeout_();}this.trigger('mediaupdatetimeout');}else{this.trigger('loadedplaylist');}};_proto.start=function start(){var _this5=this;this.started=true;// We don't need to request the master manifest again
// Call this asynchronously to match the xhr request behavior below
if(!this.isMaster_){this.mediaRequest_=window_default().setTimeout(function(){return _this5.haveMaster_();},0);return;}this.requestMaster_(function(req,masterChanged){_this5.haveMaster_();if(!_this5.hasPendingRequest()&&!_this5.media_){_this5.media(_this5.masterPlaylistLoader_.master.playlists[0]);}});};_proto.requestMaster_=function requestMaster_(cb){var _this6=this;this.request=this.vhs_.xhr({uri:this.masterPlaylistLoader_.srcUrl,withCredentials:this.withCredentials},function(error,req){if(_this6.requestErrored_(error,req)){if(_this6.state==='HAVE_NOTHING'){_this6.started=false;}return;}var masterChanged=req.responseText!==_this6.masterPlaylistLoader_.masterXml_;_this6.masterPlaylistLoader_.masterXml_=req.responseText;if(req.responseHeaders&&req.responseHeaders.date){_this6.masterLoaded_=Date.parse(req.responseHeaders.date);}else{_this6.masterLoaded_=Date.now();}_this6.masterPlaylistLoader_.srcUrl=resolveManifestRedirect(_this6.handleManifestRedirects,_this6.masterPlaylistLoader_.srcUrl,req);if(masterChanged){_this6.handleMaster_();_this6.syncClientServerClock_(function(){return cb(req,masterChanged);});return;}return cb(req,masterChanged);});}/**
   * Parses the master xml for UTCTiming node to sync the client clock to the server
   * clock. If the UTCTiming node requires a HEAD or GET request, that request is made.
   *
   * @param {Function} done
   *        Function to call when clock sync has completed
   */;_proto.syncClientServerClock_=function syncClientServerClock_(done){var _this7=this;var utcTiming=parseUTCTiming(this.masterPlaylistLoader_.masterXml_);// No UTCTiming element found in the mpd. Use Date header from mpd request as the
// server clock
if(utcTiming===null){this.masterPlaylistLoader_.clientOffset_=this.masterLoaded_-Date.now();return done();}if(utcTiming.method==='DIRECT'){this.masterPlaylistLoader_.clientOffset_=utcTiming.value-Date.now();return done();}this.request=this.vhs_.xhr({uri:video_es_resolveUrl(this.masterPlaylistLoader_.srcUrl,utcTiming.value),method:utcTiming.method,withCredentials:this.withCredentials},function(error,req){// disposed
if(!_this7.request){return;}if(error){// sync request failed, fall back to using date header from mpd
// TODO: log warning
_this7.masterPlaylistLoader_.clientOffset_=_this7.masterLoaded_-Date.now();return done();}var serverTime;if(utcTiming.method==='HEAD'){if(!req.responseHeaders||!req.responseHeaders.date){// expected date header not preset, fall back to using date header from mpd
// TODO: log warning
serverTime=_this7.masterLoaded_;}else{serverTime=Date.parse(req.responseHeaders.date);}}else{serverTime=Date.parse(req.responseText);}_this7.masterPlaylistLoader_.clientOffset_=serverTime-Date.now();done();});};_proto.haveMaster_=function haveMaster_(){this.state='HAVE_MASTER';if(this.isMaster_){// We have the master playlist at this point, so
// trigger this to allow MasterPlaylistController
// to make an initial playlist selection
this.trigger('loadedplaylist');}else if(!this.media_){// no media playlist was specifically selected so select
// the one the child playlist loader was created with
this.media(this.childPlaylist_);}};_proto.handleMaster_=function handleMaster_(){// clear media request
this.mediaRequest_=null;var oldMaster=this.masterPlaylistLoader_.master;var newMaster=parseMasterXml({masterXml:this.masterPlaylistLoader_.masterXml_,srcUrl:this.masterPlaylistLoader_.srcUrl,clientOffset:this.masterPlaylistLoader_.clientOffset_,sidxMapping:this.masterPlaylistLoader_.sidxMapping_,previousManifest:oldMaster});// if we have an old master to compare the new master against
if(oldMaster){newMaster=updateMaster(oldMaster,newMaster,this.masterPlaylistLoader_.sidxMapping_);}// only update master if we have a new master
this.masterPlaylistLoader_.master=newMaster?newMaster:oldMaster;var location=this.masterPlaylistLoader_.master.locations&&this.masterPlaylistLoader_.master.locations[0];if(location&&location!==this.masterPlaylistLoader_.srcUrl){this.masterPlaylistLoader_.srcUrl=location;}if(!oldMaster||newMaster&&newMaster.minimumUpdatePeriod!==oldMaster.minimumUpdatePeriod){this.updateMinimumUpdatePeriodTimeout_();}return Boolean(newMaster);};_proto.updateMinimumUpdatePeriodTimeout_=function updateMinimumUpdatePeriodTimeout_(){var mpl=this.masterPlaylistLoader_;// cancel any pending creation of mup on media
// a new one will be added if needed.
if(mpl.createMupOnMedia_){mpl.off('loadedmetadata',mpl.createMupOnMedia_);mpl.createMupOnMedia_=null;}// clear any pending timeouts
if(mpl.minimumUpdatePeriodTimeout_){window_default().clearTimeout(mpl.minimumUpdatePeriodTimeout_);mpl.minimumUpdatePeriodTimeout_=null;}var mup=mpl.master&&mpl.master.minimumUpdatePeriod;// If the minimumUpdatePeriod has a value of 0, that indicates that the current
// MPD has no future validity, so a new one will need to be acquired when new
// media segments are to be made available. Thus, we use the target duration
// in this case
if(mup===0){if(mpl.media()){mup=mpl.media().targetDuration*1000;}else{mpl.createMupOnMedia_=mpl.updateMinimumUpdatePeriodTimeout_;mpl.one('loadedmetadata',mpl.createMupOnMedia_);}}// if minimumUpdatePeriod is invalid or <= zero, which
// can happen when a live video becomes VOD. skip timeout
// creation.
if(typeof mup!=='number'||mup<=0){if(mup<0){this.logger_("found invalid minimumUpdatePeriod of "+mup+", not setting a timeout");}return;}this.createMUPTimeout_(mup);};_proto.createMUPTimeout_=function createMUPTimeout_(mup){var mpl=this.masterPlaylistLoader_;mpl.minimumUpdatePeriodTimeout_=window_default().setTimeout(function(){mpl.minimumUpdatePeriodTimeout_=null;mpl.trigger('minimumUpdatePeriod');mpl.createMUPTimeout_(mup);},mup);}/**
   * Sends request to refresh the master xml and updates the parsed master manifest
   */;_proto.refreshXml_=function refreshXml_(){var _this8=this;this.requestMaster_(function(req,masterChanged){if(!masterChanged){return;}if(_this8.media_){_this8.media_=_this8.masterPlaylistLoader_.master.playlists[_this8.media_.id];}// This will filter out updated sidx info from the mapping
_this8.masterPlaylistLoader_.sidxMapping_=filterChangedSidxMappings(_this8.masterPlaylistLoader_.master,_this8.masterPlaylistLoader_.sidxMapping_);_this8.addSidxSegments_(_this8.media(),_this8.state,function(sidxChanged){// TODO: do we need to reload the current playlist?
_this8.refreshMedia_(_this8.media().id);});});}/**
   * Refreshes the media playlist by re-parsing the master xml and updating playlist
   * references. If this is an alternate loader, the updated parsed manifest is retrieved
   * from the master loader.
   */;_proto.refreshMedia_=function refreshMedia_(mediaID){var _this9=this;if(!mediaID){throw new Error('refreshMedia_ must take a media id');}// for master we have to reparse the master xml
// to re-create segments based on current timing values
// which may change media. We only skip updating master
// if this is the first time this.media_ is being set.
// as master was just parsed in that case.
if(this.media_&&this.isMaster_){this.handleMaster_();}var playlists=this.masterPlaylistLoader_.master.playlists;var mediaChanged=!this.media_||this.media_!==playlists[mediaID];if(mediaChanged){this.media_=playlists[mediaID];}else{this.trigger('playlistunchanged');}if(!this.mediaUpdateTimeout){var createMediaUpdateTimeout=function createMediaUpdateTimeout(){if(_this9.media().endList){return;}_this9.mediaUpdateTimeout=window_default().setTimeout(function(){_this9.trigger('mediaupdatetimeout');createMediaUpdateTimeout();},refreshDelay(_this9.media(),Boolean(mediaChanged)));};createMediaUpdateTimeout();}this.trigger('loadedplaylist');};return DashPlaylistLoader;}(EventTarget);var Config={GOAL_BUFFER_LENGTH:30,MAX_GOAL_BUFFER_LENGTH:60,BACK_BUFFER_LENGTH:30,GOAL_BUFFER_LENGTH_RATE:1,// 0.5 MB/s
INITIAL_BANDWIDTH:4194304,// A fudge factor to apply to advertised playlist bitrates to account for
// temporary flucations in client bandwidth
BANDWIDTH_VARIANCE:1.2,// How much of the buffer must be filled before we consider upswitching
BUFFER_LOW_WATER_LINE:0,MAX_BUFFER_LOW_WATER_LINE:30,// TODO: Remove this when experimentalBufferBasedABR is removed
EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE:16,BUFFER_LOW_WATER_LINE_RATE:1,// If the buffer is greater than the high water line, we won't switch down
BUFFER_HIGH_WATER_LINE:30};var stringToArrayBuffer=function stringToArrayBuffer(string){var view=new Uint8Array(new ArrayBuffer(string.length));for(var i=0;i<string.length;i++){view[i]=string.charCodeAt(i);}return view.buffer;};/* global Blob, BlobBuilder, Worker */ // unify worker interface
var browserWorkerPolyFill=function browserWorkerPolyFill(workerObj){// node only supports on/off
workerObj.on=workerObj.addEventListener;workerObj.off=workerObj.removeEventListener;return workerObj;};var createObjectURL=function createObjectURL(str){try{return URL.createObjectURL(new Blob([str],{type:'application/javascript'}));}catch(e){var blob=new BlobBuilder();blob.append(str);return URL.createObjectURL(blob.getBlob());}};var factory=function factory(code){return function(){var objectUrl=createObjectURL(code);var worker=browserWorkerPolyFill(new Worker(objectUrl));worker.objURL=objectUrl;var terminate=worker.terminate;worker.on=worker.addEventListener;worker.off=worker.removeEventListener;worker.terminate=function(){URL.revokeObjectURL(objectUrl);return terminate.call(this);};return worker;};};var transform=function transform(code){return"var browserWorkerPolyFill = "+browserWorkerPolyFill.toString()+";\n"+'browserWorkerPolyFill(self);\n'+code;};var getWorkerString=function getWorkerString(fn){return fn.toString().replace(/^function.+?{/,'').slice(0,-1);};/* rollup-plugin-worker-factory start for worker!/home/runner/work/http-streaming/http-streaming/src/transmuxer-worker.js */var workerCode$1=transform(getWorkerString(function(){/**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * A lightweight readable stream implemention that handles event dispatching.
   * Objects that inherit from streams should call init in their constructors.
   */var Stream=function Stream(){this.init=function(){var listeners={};/**
       * Add a listener for a specified event type.
       * @param type {string} the event name
       * @param listener {function} the callback to be invoked when an event of
       * the specified type occurs
       */this.on=function(type,listener){if(!listeners[type]){listeners[type]=[];}listeners[type]=listeners[type].concat(listener);};/**
       * Remove a listener for a specified event type.
       * @param type {string} the event name
       * @param listener {function} a function previously registered for this
       * type of event through `on`
       */this.off=function(type,listener){var index;if(!listeners[type]){return false;}index=listeners[type].indexOf(listener);listeners[type]=listeners[type].slice();listeners[type].splice(index,1);return index>-1;};/**
       * Trigger an event of the specified type on this stream. Any additional
       * arguments to this function are passed as parameters to event listeners.
       * @param type {string} the event name
       */this.trigger=function(type){var callbacks,i,length,args;callbacks=listeners[type];if(!callbacks){return;}// Slicing the arguments on every invocation of this method
// can add a significant amount of overhead. Avoid the
// intermediate object creation for the common case of a
// single callback argument
if(arguments.length===2){length=callbacks.length;for(i=0;i<length;++i){callbacks[i].call(this,arguments[1]);}}else{args=[];i=arguments.length;for(i=1;i<arguments.length;++i){args.push(arguments[i]);}length=callbacks.length;for(i=0;i<length;++i){callbacks[i].apply(this,args);}}};/**
       * Destroys the stream and cleans up.
       */this.dispose=function(){listeners={};};};};/**
   * Forwards all `data` events on this stream to the destination stream. The
   * destination stream should provide a method `push` to receive the data
   * events as they arrive.
   * @param destination {stream} the stream that will receive all `data` events
   * @param autoFlush {boolean} if false, we will not call `flush` on the destination
   *                            when the current stream emits a 'done' event
   * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
   */Stream.prototype.pipe=function(destination){this.on('data',function(data){destination.push(data);});this.on('done',function(flushSource){destination.flush(flushSource);});this.on('partialdone',function(flushSource){destination.partialFlush(flushSource);});this.on('endedtimeline',function(flushSource){destination.endTimeline(flushSource);});this.on('reset',function(flushSource){destination.reset(flushSource);});return destination;};// Default stream functions that are expected to be overridden to perform
// actual work. These are provided by the prototype as a sort of no-op
// implementation so that we don't have to check for their existence in the
// `pipe` function above.
Stream.prototype.push=function(data){this.trigger('data',data);};Stream.prototype.flush=function(flushSource){this.trigger('done',flushSource);};Stream.prototype.partialFlush=function(flushSource){this.trigger('partialdone',flushSource);};Stream.prototype.endTimeline=function(flushSource){this.trigger('endedtimeline',flushSource);};Stream.prototype.reset=function(flushSource){this.trigger('reset',flushSource);};var stream=Stream;var MAX_UINT32$1=Math.pow(2,32);var getUint64$2=function getUint64(uint8){var dv=new DataView(uint8.buffer,uint8.byteOffset,uint8.byteLength);var value;if(dv.getBigUint64){value=dv.getBigUint64(0);if(value<Number.MAX_SAFE_INTEGER){return Number(value);}return value;}return dv.getUint32(0)*MAX_UINT32$1+dv.getUint32(4);};var numbers={getUint64:getUint64$2,MAX_UINT32:MAX_UINT32$1};var MAX_UINT32=numbers.MAX_UINT32;var box,dinf,esds,ftyp,mdat,mfhd,minf,moof,moov,mvex,mvhd,trak,tkhd,mdia,mdhd,hdlr,sdtp,stbl,stsd,traf,trex,trun$1,types,MAJOR_BRAND,MINOR_VERSION,AVC1_BRAND,VIDEO_HDLR,AUDIO_HDLR,HDLR_TYPES,VMHD,SMHD,DREF,STCO,STSC,STSZ,STTS;// pre-calculate constants
(function(){var i;types={avc1:[],// codingname
avcC:[],btrt:[],dinf:[],dref:[],esds:[],ftyp:[],hdlr:[],mdat:[],mdhd:[],mdia:[],mfhd:[],minf:[],moof:[],moov:[],mp4a:[],// codingname
mvex:[],mvhd:[],pasp:[],sdtp:[],smhd:[],stbl:[],stco:[],stsc:[],stsd:[],stsz:[],stts:[],styp:[],tfdt:[],tfhd:[],traf:[],trak:[],trun:[],trex:[],tkhd:[],vmhd:[]};// In environments where Uint8Array is undefined (e.g., IE8), skip set up so that we
// don't throw an error
if(typeof Uint8Array==='undefined'){return;}for(i in types){if(types.hasOwnProperty(i)){types[i]=[i.charCodeAt(0),i.charCodeAt(1),i.charCodeAt(2),i.charCodeAt(3)];}}MAJOR_BRAND=new Uint8Array(['i'.charCodeAt(0),'s'.charCodeAt(0),'o'.charCodeAt(0),'m'.charCodeAt(0)]);AVC1_BRAND=new Uint8Array(['a'.charCodeAt(0),'v'.charCodeAt(0),'c'.charCodeAt(0),'1'.charCodeAt(0)]);MINOR_VERSION=new Uint8Array([0,0,0,1]);VIDEO_HDLR=new Uint8Array([0x00,// version 0
0x00,0x00,0x00,// flags
0x00,0x00,0x00,0x00,// pre_defined
0x76,0x69,0x64,0x65,// handler_type: 'vide'
0x00,0x00,0x00,0x00,// reserved
0x00,0x00,0x00,0x00,// reserved
0x00,0x00,0x00,0x00,// reserved
0x56,0x69,0x64,0x65,0x6f,0x48,0x61,0x6e,0x64,0x6c,0x65,0x72,0x00// name: 'VideoHandler'
]);AUDIO_HDLR=new Uint8Array([0x00,// version 0
0x00,0x00,0x00,// flags
0x00,0x00,0x00,0x00,// pre_defined
0x73,0x6f,0x75,0x6e,// handler_type: 'soun'
0x00,0x00,0x00,0x00,// reserved
0x00,0x00,0x00,0x00,// reserved
0x00,0x00,0x00,0x00,// reserved
0x53,0x6f,0x75,0x6e,0x64,0x48,0x61,0x6e,0x64,0x6c,0x65,0x72,0x00// name: 'SoundHandler'
]);HDLR_TYPES={video:VIDEO_HDLR,audio:AUDIO_HDLR};DREF=new Uint8Array([0x00,// version 0
0x00,0x00,0x00,// flags
0x00,0x00,0x00,0x01,// entry_count
0x00,0x00,0x00,0x0c,// entry_size
0x75,0x72,0x6c,0x20,// 'url' type
0x00,// version 0
0x00,0x00,0x01// entry_flags
]);SMHD=new Uint8Array([0x00,// version
0x00,0x00,0x00,// flags
0x00,0x00,// balance, 0 means centered
0x00,0x00// reserved
]);STCO=new Uint8Array([0x00,// version
0x00,0x00,0x00,// flags
0x00,0x00,0x00,0x00// entry_count
]);STSC=STCO;STSZ=new Uint8Array([0x00,// version
0x00,0x00,0x00,// flags
0x00,0x00,0x00,0x00,// sample_size
0x00,0x00,0x00,0x00// sample_count
]);STTS=STCO;VMHD=new Uint8Array([0x00,// version
0x00,0x00,0x01,// flags
0x00,0x00,// graphicsmode
0x00,0x00,0x00,0x00,0x00,0x00// opcolor
]);})();box=function box(type){var payload=[],size=0,i,result,view;for(i=1;i<arguments.length;i++){payload.push(arguments[i]);}i=payload.length;// calculate the total size we need to allocate
while(i--){size+=payload[i].byteLength;}result=new Uint8Array(size+8);view=new DataView(result.buffer,result.byteOffset,result.byteLength);view.setUint32(0,result.byteLength);result.set(type,4);// copy the payload into the result
for(i=0,size=8;i<payload.length;i++){result.set(payload[i],size);size+=payload[i].byteLength;}return result;};dinf=function dinf(){return box(types.dinf,box(types.dref,DREF));};esds=function esds(track){return box(types.esds,new Uint8Array([0x00,// version
0x00,0x00,0x00,// flags
// ES_Descriptor
0x03,// tag, ES_DescrTag
0x19,// length
0x00,0x00,// ES_ID
0x00,// streamDependenceFlag, URL_flag, reserved, streamPriority
// DecoderConfigDescriptor
0x04,// tag, DecoderConfigDescrTag
0x11,// length
0x40,// object type
0x15,// streamType
0x00,0x06,0x00,// bufferSizeDB
0x00,0x00,0xda,0xc0,// maxBitrate
0x00,0x00,0xda,0xc0,// avgBitrate
// DecoderSpecificInfo
0x05,// tag, DecoderSpecificInfoTag
0x02,// length
// ISO/IEC 14496-3, AudioSpecificConfig
// for samplingFrequencyIndex see ISO/IEC 13818-7:2006, 8.1.3.2.2, Table 35
track.audioobjecttype<<3|track.samplingfrequencyindex>>>1,track.samplingfrequencyindex<<7|track.channelcount<<3,0x06,0x01,0x02// GASpecificConfig
]));};ftyp=function ftyp(){return box(types.ftyp,MAJOR_BRAND,MINOR_VERSION,MAJOR_BRAND,AVC1_BRAND);};hdlr=function hdlr(type){return box(types.hdlr,HDLR_TYPES[type]);};mdat=function mdat(data){return box(types.mdat,data);};mdhd=function mdhd(track){var result=new Uint8Array([0x00,// version 0
0x00,0x00,0x00,// flags
0x00,0x00,0x00,0x02,// creation_time
0x00,0x00,0x00,0x03,// modification_time
0x00,0x01,0x5f,0x90,// timescale, 90,000 "ticks" per second
track.duration>>>24&0xFF,track.duration>>>16&0xFF,track.duration>>>8&0xFF,track.duration&0xFF,// duration
0x55,0xc4,// 'und' language (undetermined)
0x00,0x00]);// Use the sample rate from the track metadata, when it is
// defined. The sample rate can be parsed out of an ADTS header, for
// instance.
if(track.samplerate){result[12]=track.samplerate>>>24&0xFF;result[13]=track.samplerate>>>16&0xFF;result[14]=track.samplerate>>>8&0xFF;result[15]=track.samplerate&0xFF;}return box(types.mdhd,result);};mdia=function mdia(track){return box(types.mdia,mdhd(track),hdlr(track.type),minf(track));};mfhd=function mfhd(sequenceNumber){return box(types.mfhd,new Uint8Array([0x00,0x00,0x00,0x00,// flags
(sequenceNumber&0xFF000000)>>24,(sequenceNumber&0xFF0000)>>16,(sequenceNumber&0xFF00)>>8,sequenceNumber&0xFF// sequence_number
]));};minf=function minf(track){return box(types.minf,track.type==='video'?box(types.vmhd,VMHD):box(types.smhd,SMHD),dinf(),stbl(track));};moof=function moof(sequenceNumber,tracks){var trackFragments=[],i=tracks.length;// build traf boxes for each track fragment
while(i--){trackFragments[i]=traf(tracks[i]);}return box.apply(null,[types.moof,mfhd(sequenceNumber)].concat(trackFragments));};/**
   * Returns a movie box.
   * @param tracks {array} the tracks associated with this movie
   * @see ISO/IEC 14496-12:2012(E), section 8.2.1
   */moov=function moov(tracks){var i=tracks.length,boxes=[];while(i--){boxes[i]=trak(tracks[i]);}return box.apply(null,[types.moov,mvhd(0xffffffff)].concat(boxes).concat(mvex(tracks)));};mvex=function mvex(tracks){var i=tracks.length,boxes=[];while(i--){boxes[i]=trex(tracks[i]);}return box.apply(null,[types.mvex].concat(boxes));};mvhd=function mvhd(duration){var bytes=new Uint8Array([0x00,// version 0
0x00,0x00,0x00,// flags
0x00,0x00,0x00,0x01,// creation_time
0x00,0x00,0x00,0x02,// modification_time
0x00,0x01,0x5f,0x90,// timescale, 90,000 "ticks" per second
(duration&0xFF000000)>>24,(duration&0xFF0000)>>16,(duration&0xFF00)>>8,duration&0xFF,// duration
0x00,0x01,0x00,0x00,// 1.0 rate
0x01,0x00,// 1.0 volume
0x00,0x00,// reserved
0x00,0x00,0x00,0x00,// reserved
0x00,0x00,0x00,0x00,// reserved
0x00,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x40,0x00,0x00,0x00,// transformation: unity matrix
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,// pre_defined
0xff,0xff,0xff,0xff// next_track_ID
]);return box(types.mvhd,bytes);};sdtp=function sdtp(track){var samples=track.samples||[],bytes=new Uint8Array(4+samples.length),flags,i;// leave the full box header (4 bytes) all zero
// write the sample table
for(i=0;i<samples.length;i++){flags=samples[i].flags;bytes[i+4]=flags.dependsOn<<4|flags.isDependedOn<<2|flags.hasRedundancy;}return box(types.sdtp,bytes);};stbl=function stbl(track){return box(types.stbl,stsd(track),box(types.stts,STTS),box(types.stsc,STSC),box(types.stsz,STSZ),box(types.stco,STCO));};(function(){var videoSample,audioSample;stsd=function stsd(track){return box(types.stsd,new Uint8Array([0x00,// version 0
0x00,0x00,0x00,// flags
0x00,0x00,0x00,0x01]),track.type==='video'?videoSample(track):audioSample(track));};videoSample=function videoSample(track){var sps=track.sps||[],pps=track.pps||[],sequenceParameterSets=[],pictureParameterSets=[],i,avc1Box;// assemble the SPSs
for(i=0;i<sps.length;i++){sequenceParameterSets.push((sps[i].byteLength&0xFF00)>>>8);sequenceParameterSets.push(sps[i].byteLength&0xFF);// sequenceParameterSetLength
sequenceParameterSets=sequenceParameterSets.concat(Array.prototype.slice.call(sps[i]));// SPS
}// assemble the PPSs
for(i=0;i<pps.length;i++){pictureParameterSets.push((pps[i].byteLength&0xFF00)>>>8);pictureParameterSets.push(pps[i].byteLength&0xFF);pictureParameterSets=pictureParameterSets.concat(Array.prototype.slice.call(pps[i]));}avc1Box=[types.avc1,new Uint8Array([0x00,0x00,0x00,0x00,0x00,0x00,// reserved
0x00,0x01,// data_reference_index
0x00,0x00,// pre_defined
0x00,0x00,// reserved
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,// pre_defined
(track.width&0xff00)>>8,track.width&0xff,// width
(track.height&0xff00)>>8,track.height&0xff,// height
0x00,0x48,0x00,0x00,// horizresolution
0x00,0x48,0x00,0x00,// vertresolution
0x00,0x00,0x00,0x00,// reserved
0x00,0x01,// frame_count
0x13,0x76,0x69,0x64,0x65,0x6f,0x6a,0x73,0x2d,0x63,0x6f,0x6e,0x74,0x72,0x69,0x62,0x2d,0x68,0x6c,0x73,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,// compressorname
0x00,0x18,// depth = 24
0x11,0x11// pre_defined = -1
]),box(types.avcC,new Uint8Array([0x01,// configurationVersion
track.profileIdc,// AVCProfileIndication
track.profileCompatibility,// profile_compatibility
track.levelIdc,// AVCLevelIndication
0xff// lengthSizeMinusOne, hard-coded to 4 bytes
].concat([sps.length],// numOfSequenceParameterSets
sequenceParameterSets,// "SPS"
[pps.length],// numOfPictureParameterSets
pictureParameterSets// "PPS"
))),box(types.btrt,new Uint8Array([0x00,0x1c,0x9c,0x80,// bufferSizeDB
0x00,0x2d,0xc6,0xc0,// maxBitrate
0x00,0x2d,0xc6,0xc0// avgBitrate
]))];if(track.sarRatio){var hSpacing=track.sarRatio[0],vSpacing=track.sarRatio[1];avc1Box.push(box(types.pasp,new Uint8Array([(hSpacing&0xFF000000)>>24,(hSpacing&0xFF0000)>>16,(hSpacing&0xFF00)>>8,hSpacing&0xFF,(vSpacing&0xFF000000)>>24,(vSpacing&0xFF0000)>>16,(vSpacing&0xFF00)>>8,vSpacing&0xFF])));}return box.apply(null,avc1Box);};audioSample=function audioSample(track){return box(types.mp4a,new Uint8Array([// SampleEntry, ISO/IEC 14496-12
0x00,0x00,0x00,0x00,0x00,0x00,// reserved
0x00,0x01,// data_reference_index
// AudioSampleEntry, ISO/IEC 14496-12
0x00,0x00,0x00,0x00,// reserved
0x00,0x00,0x00,0x00,// reserved
(track.channelcount&0xff00)>>8,track.channelcount&0xff,// channelcount
(track.samplesize&0xff00)>>8,track.samplesize&0xff,// samplesize
0x00,0x00,// pre_defined
0x00,0x00,// reserved
(track.samplerate&0xff00)>>8,track.samplerate&0xff,0x00,0x00// samplerate, 16.16
// MP4AudioSampleEntry, ISO/IEC 14496-14
]),esds(track));};})();tkhd=function tkhd(track){var result=new Uint8Array([0x00,// version 0
0x00,0x00,0x07,// flags
0x00,0x00,0x00,0x00,// creation_time
0x00,0x00,0x00,0x00,// modification_time
(track.id&0xFF000000)>>24,(track.id&0xFF0000)>>16,(track.id&0xFF00)>>8,track.id&0xFF,// track_ID
0x00,0x00,0x00,0x00,// reserved
(track.duration&0xFF000000)>>24,(track.duration&0xFF0000)>>16,(track.duration&0xFF00)>>8,track.duration&0xFF,// duration
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,// reserved
0x00,0x00,// layer
0x00,0x00,// alternate_group
0x01,0x00,// non-audio track volume
0x00,0x00,// reserved
0x00,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x40,0x00,0x00,0x00,// transformation: unity matrix
(track.width&0xFF00)>>8,track.width&0xFF,0x00,0x00,// width
(track.height&0xFF00)>>8,track.height&0xFF,0x00,0x00// height
]);return box(types.tkhd,result);};/**
   * Generate a track fragment (traf) box. A traf box collects metadata
   * about tracks in a movie fragment (moof) box.
   */traf=function traf(track){var trackFragmentHeader,trackFragmentDecodeTime,trackFragmentRun,sampleDependencyTable,dataOffset,upperWordBaseMediaDecodeTime,lowerWordBaseMediaDecodeTime;trackFragmentHeader=box(types.tfhd,new Uint8Array([0x00,// version 0
0x00,0x00,0x3a,// flags
(track.id&0xFF000000)>>24,(track.id&0xFF0000)>>16,(track.id&0xFF00)>>8,track.id&0xFF,// track_ID
0x00,0x00,0x00,0x01,// sample_description_index
0x00,0x00,0x00,0x00,// default_sample_duration
0x00,0x00,0x00,0x00,// default_sample_size
0x00,0x00,0x00,0x00// default_sample_flags
]));upperWordBaseMediaDecodeTime=Math.floor(track.baseMediaDecodeTime/MAX_UINT32);lowerWordBaseMediaDecodeTime=Math.floor(track.baseMediaDecodeTime%MAX_UINT32);trackFragmentDecodeTime=box(types.tfdt,new Uint8Array([0x01,// version 1
0x00,0x00,0x00,// flags
// baseMediaDecodeTime
upperWordBaseMediaDecodeTime>>>24&0xFF,upperWordBaseMediaDecodeTime>>>16&0xFF,upperWordBaseMediaDecodeTime>>>8&0xFF,upperWordBaseMediaDecodeTime&0xFF,lowerWordBaseMediaDecodeTime>>>24&0xFF,lowerWordBaseMediaDecodeTime>>>16&0xFF,lowerWordBaseMediaDecodeTime>>>8&0xFF,lowerWordBaseMediaDecodeTime&0xFF]));// the data offset specifies the number of bytes from the start of
// the containing moof to the first payload byte of the associated
// mdat
dataOffset=32+// tfhd
20+// tfdt
8+// traf header
16+// mfhd
8+// moof header
8;// mdat header
// audio tracks require less metadata
if(track.type==='audio'){trackFragmentRun=trun$1(track,dataOffset);return box(types.traf,trackFragmentHeader,trackFragmentDecodeTime,trackFragmentRun);}// video tracks should contain an independent and disposable samples
// box (sdtp)
// generate one and adjust offsets to match
sampleDependencyTable=sdtp(track);trackFragmentRun=trun$1(track,sampleDependencyTable.length+dataOffset);return box(types.traf,trackFragmentHeader,trackFragmentDecodeTime,trackFragmentRun,sampleDependencyTable);};/**
   * Generate a track box.
   * @param track {object} a track definition
   * @return {Uint8Array} the track box
   */trak=function trak(track){track.duration=track.duration||0xffffffff;return box(types.trak,tkhd(track),mdia(track));};trex=function trex(track){var result=new Uint8Array([0x00,// version 0
0x00,0x00,0x00,// flags
(track.id&0xFF000000)>>24,(track.id&0xFF0000)>>16,(track.id&0xFF00)>>8,track.id&0xFF,// track_ID
0x00,0x00,0x00,0x01,// default_sample_description_index
0x00,0x00,0x00,0x00,// default_sample_duration
0x00,0x00,0x00,0x00,// default_sample_size
0x00,0x01,0x00,0x01// default_sample_flags
]);// the last two bytes of default_sample_flags is the sample
// degradation priority, a hint about the importance of this sample
// relative to others. Lower the degradation priority for all sample
// types other than video.
if(track.type!=='video'){result[result.length-1]=0x00;}return box(types.trex,result);};(function(){var audioTrun,videoTrun,trunHeader;// This method assumes all samples are uniform. That is, if a
// duration is present for the first sample, it will be present for
// all subsequent samples.
// see ISO/IEC 14496-12:2012, Section 8.8.8.1
trunHeader=function trunHeader(samples,offset){var durationPresent=0,sizePresent=0,flagsPresent=0,compositionTimeOffset=0;// trun flag constants
if(samples.length){if(samples[0].duration!==undefined){durationPresent=0x1;}if(samples[0].size!==undefined){sizePresent=0x2;}if(samples[0].flags!==undefined){flagsPresent=0x4;}if(samples[0].compositionTimeOffset!==undefined){compositionTimeOffset=0x8;}}return[0x00,// version 0
0x00,durationPresent|sizePresent|flagsPresent|compositionTimeOffset,0x01,// flags
(samples.length&0xFF000000)>>>24,(samples.length&0xFF0000)>>>16,(samples.length&0xFF00)>>>8,samples.length&0xFF,// sample_count
(offset&0xFF000000)>>>24,(offset&0xFF0000)>>>16,(offset&0xFF00)>>>8,offset&0xFF// data_offset
];};videoTrun=function videoTrun(track,offset){var bytesOffest,bytes,header,samples,sample,i;samples=track.samples||[];offset+=8+12+16*samples.length;header=trunHeader(samples,offset);bytes=new Uint8Array(header.length+samples.length*16);bytes.set(header);bytesOffest=header.length;for(i=0;i<samples.length;i++){sample=samples[i];bytes[bytesOffest++]=(sample.duration&0xFF000000)>>>24;bytes[bytesOffest++]=(sample.duration&0xFF0000)>>>16;bytes[bytesOffest++]=(sample.duration&0xFF00)>>>8;bytes[bytesOffest++]=sample.duration&0xFF;// sample_duration
bytes[bytesOffest++]=(sample.size&0xFF000000)>>>24;bytes[bytesOffest++]=(sample.size&0xFF0000)>>>16;bytes[bytesOffest++]=(sample.size&0xFF00)>>>8;bytes[bytesOffest++]=sample.size&0xFF;// sample_size
bytes[bytesOffest++]=sample.flags.isLeading<<2|sample.flags.dependsOn;bytes[bytesOffest++]=sample.flags.isDependedOn<<6|sample.flags.hasRedundancy<<4|sample.flags.paddingValue<<1|sample.flags.isNonSyncSample;bytes[bytesOffest++]=sample.flags.degradationPriority&0xF0<<8;bytes[bytesOffest++]=sample.flags.degradationPriority&0x0F;// sample_flags
bytes[bytesOffest++]=(sample.compositionTimeOffset&0xFF000000)>>>24;bytes[bytesOffest++]=(sample.compositionTimeOffset&0xFF0000)>>>16;bytes[bytesOffest++]=(sample.compositionTimeOffset&0xFF00)>>>8;bytes[bytesOffest++]=sample.compositionTimeOffset&0xFF;// sample_composition_time_offset
}return box(types.trun,bytes);};audioTrun=function audioTrun(track,offset){var bytes,bytesOffest,header,samples,sample,i;samples=track.samples||[];offset+=8+12+8*samples.length;header=trunHeader(samples,offset);bytes=new Uint8Array(header.length+samples.length*8);bytes.set(header);bytesOffest=header.length;for(i=0;i<samples.length;i++){sample=samples[i];bytes[bytesOffest++]=(sample.duration&0xFF000000)>>>24;bytes[bytesOffest++]=(sample.duration&0xFF0000)>>>16;bytes[bytesOffest++]=(sample.duration&0xFF00)>>>8;bytes[bytesOffest++]=sample.duration&0xFF;// sample_duration
bytes[bytesOffest++]=(sample.size&0xFF000000)>>>24;bytes[bytesOffest++]=(sample.size&0xFF0000)>>>16;bytes[bytesOffest++]=(sample.size&0xFF00)>>>8;bytes[bytesOffest++]=sample.size&0xFF;// sample_size
}return box(types.trun,bytes);};trun$1=function trun(track,offset){if(track.type==='audio'){return audioTrun(track,offset);}return videoTrun(track,offset);};})();var mp4Generator={ftyp:ftyp,mdat:mdat,moof:moof,moov:moov,initSegment:function initSegment(tracks){var fileType=ftyp(),movie=moov(tracks),result;result=new Uint8Array(fileType.byteLength+movie.byteLength);result.set(fileType);result.set(movie,fileType.byteLength);return result;}};/**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ // Convert an array of nal units into an array of frames with each frame being
// composed of the nal units that make up that frame
// Also keep track of cummulative data about the frame from the nal units such
// as the frame duration, starting pts, etc.
var groupNalsIntoFrames=function groupNalsIntoFrames(nalUnits){var i,currentNal,currentFrame=[],frames=[];// TODO added for LHLS, make sure this is OK
frames.byteLength=0;frames.nalCount=0;frames.duration=0;currentFrame.byteLength=0;for(i=0;i<nalUnits.length;i++){currentNal=nalUnits[i];// Split on 'aud'-type nal units
if(currentNal.nalUnitType==='access_unit_delimiter_rbsp'){// Since the very first nal unit is expected to be an AUD
// only push to the frames array when currentFrame is not empty
if(currentFrame.length){currentFrame.duration=currentNal.dts-currentFrame.dts;// TODO added for LHLS, make sure this is OK
frames.byteLength+=currentFrame.byteLength;frames.nalCount+=currentFrame.length;frames.duration+=currentFrame.duration;frames.push(currentFrame);}currentFrame=[currentNal];currentFrame.byteLength=currentNal.data.byteLength;currentFrame.pts=currentNal.pts;currentFrame.dts=currentNal.dts;}else{// Specifically flag key frames for ease of use later
if(currentNal.nalUnitType==='slice_layer_without_partitioning_rbsp_idr'){currentFrame.keyFrame=true;}currentFrame.duration=currentNal.dts-currentFrame.dts;currentFrame.byteLength+=currentNal.data.byteLength;currentFrame.push(currentNal);}}// For the last frame, use the duration of the previous frame if we
// have nothing better to go on
if(frames.length&&(!currentFrame.duration||currentFrame.duration<=0)){currentFrame.duration=frames[frames.length-1].duration;}// Push the final frame
// TODO added for LHLS, make sure this is OK
frames.byteLength+=currentFrame.byteLength;frames.nalCount+=currentFrame.length;frames.duration+=currentFrame.duration;frames.push(currentFrame);return frames;};// Convert an array of frames into an array of Gop with each Gop being composed
// of the frames that make up that Gop
// Also keep track of cummulative data about the Gop from the frames such as the
// Gop duration, starting pts, etc.
var groupFramesIntoGops=function groupFramesIntoGops(frames){var i,currentFrame,currentGop=[],gops=[];// We must pre-set some of the values on the Gop since we
// keep running totals of these values
currentGop.byteLength=0;currentGop.nalCount=0;currentGop.duration=0;currentGop.pts=frames[0].pts;currentGop.dts=frames[0].dts;// store some metadata about all the Gops
gops.byteLength=0;gops.nalCount=0;gops.duration=0;gops.pts=frames[0].pts;gops.dts=frames[0].dts;for(i=0;i<frames.length;i++){currentFrame=frames[i];if(currentFrame.keyFrame){// Since the very first frame is expected to be an keyframe
// only push to the gops array when currentGop is not empty
if(currentGop.length){gops.push(currentGop);gops.byteLength+=currentGop.byteLength;gops.nalCount+=currentGop.nalCount;gops.duration+=currentGop.duration;}currentGop=[currentFrame];currentGop.nalCount=currentFrame.length;currentGop.byteLength=currentFrame.byteLength;currentGop.pts=currentFrame.pts;currentGop.dts=currentFrame.dts;currentGop.duration=currentFrame.duration;}else{currentGop.duration+=currentFrame.duration;currentGop.nalCount+=currentFrame.length;currentGop.byteLength+=currentFrame.byteLength;currentGop.push(currentFrame);}}if(gops.length&&currentGop.duration<=0){currentGop.duration=gops[gops.length-1].duration;}gops.byteLength+=currentGop.byteLength;gops.nalCount+=currentGop.nalCount;gops.duration+=currentGop.duration;// push the final Gop
gops.push(currentGop);return gops;};/*
   * Search for the first keyframe in the GOPs and throw away all frames
   * until that keyframe. Then extend the duration of the pulled keyframe
   * and pull the PTS and DTS of the keyframe so that it covers the time
   * range of the frames that were disposed.
   *
   * @param {Array} gops video GOPs
   * @returns {Array} modified video GOPs
   */var extendFirstKeyFrame=function extendFirstKeyFrame(gops){var currentGop;if(!gops[0][0].keyFrame&&gops.length>1){// Remove the first GOP
currentGop=gops.shift();gops.byteLength-=currentGop.byteLength;gops.nalCount-=currentGop.nalCount;// Extend the first frame of what is now the
// first gop to cover the time period of the
// frames we just removed
gops[0][0].dts=currentGop.dts;gops[0][0].pts=currentGop.pts;gops[0][0].duration+=currentGop.duration;}return gops;};/**
   * Default sample object
   * see ISO/IEC 14496-12:2012, section 8.6.4.3
   */var createDefaultSample=function createDefaultSample(){return{size:0,flags:{isLeading:0,dependsOn:1,isDependedOn:0,hasRedundancy:0,degradationPriority:0,isNonSyncSample:1}};};/*
   * Collates information from a video frame into an object for eventual
   * entry into an MP4 sample table.
   *
   * @param {Object} frame the video frame
   * @param {Number} dataOffset the byte offset to position the sample
   * @return {Object} object containing sample table info for a frame
   */var sampleForFrame=function sampleForFrame(frame,dataOffset){var sample=createDefaultSample();sample.dataOffset=dataOffset;sample.compositionTimeOffset=frame.pts-frame.dts;sample.duration=frame.duration;sample.size=4*frame.length;// Space for nal unit size
sample.size+=frame.byteLength;if(frame.keyFrame){sample.flags.dependsOn=2;sample.flags.isNonSyncSample=0;}return sample;};// generate the track's sample table from an array of gops
var generateSampleTable$1=function generateSampleTable(gops,baseDataOffset){var h,i,sample,currentGop,currentFrame,dataOffset=baseDataOffset||0,samples=[];for(h=0;h<gops.length;h++){currentGop=gops[h];for(i=0;i<currentGop.length;i++){currentFrame=currentGop[i];sample=sampleForFrame(currentFrame,dataOffset);dataOffset+=sample.size;samples.push(sample);}}return samples;};// generate the track's raw mdat data from an array of gops
var concatenateNalData=function concatenateNalData(gops){var h,i,j,currentGop,currentFrame,currentNal,dataOffset=0,nalsByteLength=gops.byteLength,numberOfNals=gops.nalCount,totalByteLength=nalsByteLength+4*numberOfNals,data=new Uint8Array(totalByteLength),view=new DataView(data.buffer);// For each Gop..
for(h=0;h<gops.length;h++){currentGop=gops[h];// For each Frame..
for(i=0;i<currentGop.length;i++){currentFrame=currentGop[i];// For each NAL..
for(j=0;j<currentFrame.length;j++){currentNal=currentFrame[j];view.setUint32(dataOffset,currentNal.data.byteLength);dataOffset+=4;data.set(currentNal.data,dataOffset);dataOffset+=currentNal.data.byteLength;}}}return data;};// generate the track's sample table from a frame
var generateSampleTableForFrame=function generateSampleTableForFrame(frame,baseDataOffset){var sample,dataOffset=baseDataOffset||0,samples=[];sample=sampleForFrame(frame,dataOffset);samples.push(sample);return samples;};// generate the track's raw mdat data from a frame
var concatenateNalDataForFrame=function concatenateNalDataForFrame(frame){var i,currentNal,dataOffset=0,nalsByteLength=frame.byteLength,numberOfNals=frame.length,totalByteLength=nalsByteLength+4*numberOfNals,data=new Uint8Array(totalByteLength),view=new DataView(data.buffer);// For each NAL..
for(i=0;i<frame.length;i++){currentNal=frame[i];view.setUint32(dataOffset,currentNal.data.byteLength);dataOffset+=4;data.set(currentNal.data,dataOffset);dataOffset+=currentNal.data.byteLength;}return data;};var frameUtils={groupNalsIntoFrames:groupNalsIntoFrames,groupFramesIntoGops:groupFramesIntoGops,extendFirstKeyFrame:extendFirstKeyFrame,generateSampleTable:generateSampleTable$1,concatenateNalData:concatenateNalData,generateSampleTableForFrame:generateSampleTableForFrame,concatenateNalDataForFrame:concatenateNalDataForFrame};/**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */var highPrefix=[33,16,5,32,164,27];var lowPrefix=[33,65,108,84,1,2,4,8,168,2,4,8,17,191,252];var zeroFill=function zeroFill(count){var a=[];while(count--){a.push(0);}return a;};var makeTable=function makeTable(metaTable){return Object.keys(metaTable).reduce(function(obj,key){obj[key]=new Uint8Array(metaTable[key].reduce(function(arr,part){return arr.concat(part);},[]));return obj;},{});};var silence;var silence_1=function silence_1(){if(!silence){// Frames-of-silence to use for filling in missing AAC frames
var coneOfSilence={96000:[highPrefix,[227,64],zeroFill(154),[56]],88200:[highPrefix,[231],zeroFill(170),[56]],64000:[highPrefix,[248,192],zeroFill(240),[56]],48000:[highPrefix,[255,192],zeroFill(268),[55,148,128],zeroFill(54),[112]],44100:[highPrefix,[255,192],zeroFill(268),[55,163,128],zeroFill(84),[112]],32000:[highPrefix,[255,192],zeroFill(268),[55,234],zeroFill(226),[112]],24000:[highPrefix,[255,192],zeroFill(268),[55,255,128],zeroFill(268),[111,112],zeroFill(126),[224]],16000:[highPrefix,[255,192],zeroFill(268),[55,255,128],zeroFill(268),[111,255],zeroFill(269),[223,108],zeroFill(195),[1,192]],12000:[lowPrefix,zeroFill(268),[3,127,248],zeroFill(268),[6,255,240],zeroFill(268),[13,255,224],zeroFill(268),[27,253,128],zeroFill(259),[56]],11025:[lowPrefix,zeroFill(268),[3,127,248],zeroFill(268),[6,255,240],zeroFill(268),[13,255,224],zeroFill(268),[27,255,192],zeroFill(268),[55,175,128],zeroFill(108),[112]],8000:[lowPrefix,zeroFill(268),[3,121,16],zeroFill(47),[7]]};silence=makeTable(coneOfSilence);}return silence;};/**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */var ONE_SECOND_IN_TS$4=90000,// 90kHz clock
secondsToVideoTs,secondsToAudioTs,videoTsToSeconds,audioTsToSeconds,audioTsToVideoTs,videoTsToAudioTs,metadataTsToSeconds;secondsToVideoTs=function secondsToVideoTs(seconds){return seconds*ONE_SECOND_IN_TS$4;};secondsToAudioTs=function secondsToAudioTs(seconds,sampleRate){return seconds*sampleRate;};videoTsToSeconds=function videoTsToSeconds(timestamp){return timestamp/ONE_SECOND_IN_TS$4;};audioTsToSeconds=function audioTsToSeconds(timestamp,sampleRate){return timestamp/sampleRate;};audioTsToVideoTs=function audioTsToVideoTs(timestamp,sampleRate){return secondsToVideoTs(audioTsToSeconds(timestamp,sampleRate));};videoTsToAudioTs=function videoTsToAudioTs(timestamp,sampleRate){return secondsToAudioTs(videoTsToSeconds(timestamp),sampleRate);};/**
   * Adjust ID3 tag or caption timing information by the timeline pts values
   * (if keepOriginalTimestamps is false) and convert to seconds
   */metadataTsToSeconds=function metadataTsToSeconds(timestamp,timelineStartPts,keepOriginalTimestamps){return videoTsToSeconds(keepOriginalTimestamps?timestamp:timestamp-timelineStartPts);};var clock={ONE_SECOND_IN_TS:ONE_SECOND_IN_TS$4,secondsToVideoTs:secondsToVideoTs,secondsToAudioTs:secondsToAudioTs,videoTsToSeconds:videoTsToSeconds,audioTsToSeconds:audioTsToSeconds,audioTsToVideoTs:audioTsToVideoTs,videoTsToAudioTs:videoTsToAudioTs,metadataTsToSeconds:metadataTsToSeconds};/**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ /**
   * Sum the `byteLength` properties of the data in each AAC frame
   */var sumFrameByteLengths=function sumFrameByteLengths(array){var i,currentObj,sum=0;// sum the byteLength's all each nal unit in the frame
for(i=0;i<array.length;i++){currentObj=array[i];sum+=currentObj.data.byteLength;}return sum;};// Possibly pad (prefix) the audio track with silence if appending this track
// would lead to the introduction of a gap in the audio buffer
var prefixWithSilence=function prefixWithSilence(track,frames,audioAppendStartTs,videoBaseMediaDecodeTime){var baseMediaDecodeTimeTs,frameDuration=0,audioGapDuration=0,audioFillFrameCount=0,audioFillDuration=0,silentFrame,i,firstFrame;if(!frames.length){return;}baseMediaDecodeTimeTs=clock.audioTsToVideoTs(track.baseMediaDecodeTime,track.samplerate);// determine frame clock duration based on sample rate, round up to avoid overfills
frameDuration=Math.ceil(clock.ONE_SECOND_IN_TS/(track.samplerate/1024));if(audioAppendStartTs&&videoBaseMediaDecodeTime){// insert the shortest possible amount (audio gap or audio to video gap)
audioGapDuration=baseMediaDecodeTimeTs-Math.max(audioAppendStartTs,videoBaseMediaDecodeTime);// number of full frames in the audio gap
audioFillFrameCount=Math.floor(audioGapDuration/frameDuration);audioFillDuration=audioFillFrameCount*frameDuration;}// don't attempt to fill gaps smaller than a single frame or larger
// than a half second
if(audioFillFrameCount<1||audioFillDuration>clock.ONE_SECOND_IN_TS/2){return;}silentFrame=silence_1()[track.samplerate];if(!silentFrame){// we don't have a silent frame pregenerated for the sample rate, so use a frame
// from the content instead
silentFrame=frames[0].data;}for(i=0;i<audioFillFrameCount;i++){firstFrame=frames[0];frames.splice(0,0,{data:silentFrame,dts:firstFrame.dts-frameDuration,pts:firstFrame.pts-frameDuration});}track.baseMediaDecodeTime-=Math.floor(clock.videoTsToAudioTs(audioFillDuration,track.samplerate));return audioFillDuration;};// If the audio segment extends before the earliest allowed dts
// value, remove AAC frames until starts at or after the earliest
// allowed DTS so that we don't end up with a negative baseMedia-
// DecodeTime for the audio track
var trimAdtsFramesByEarliestDts=function trimAdtsFramesByEarliestDts(adtsFrames,track,earliestAllowedDts){if(track.minSegmentDts>=earliestAllowedDts){return adtsFrames;}// We will need to recalculate the earliest segment Dts
track.minSegmentDts=Infinity;return adtsFrames.filter(function(currentFrame){// If this is an allowed frame, keep it and record it's Dts
if(currentFrame.dts>=earliestAllowedDts){track.minSegmentDts=Math.min(track.minSegmentDts,currentFrame.dts);track.minSegmentPts=track.minSegmentDts;return true;}// Otherwise, discard it
return false;});};// generate the track's raw mdat data from an array of frames
var generateSampleTable=function generateSampleTable(frames){var i,currentFrame,samples=[];for(i=0;i<frames.length;i++){currentFrame=frames[i];samples.push({size:currentFrame.data.byteLength,duration:1024// For AAC audio, all samples contain 1024 samples
});}return samples;};// generate the track's sample table from an array of frames
var concatenateFrameData=function concatenateFrameData(frames){var i,currentFrame,dataOffset=0,data=new Uint8Array(sumFrameByteLengths(frames));for(i=0;i<frames.length;i++){currentFrame=frames[i];data.set(currentFrame.data,dataOffset);dataOffset+=currentFrame.data.byteLength;}return data;};var audioFrameUtils={prefixWithSilence:prefixWithSilence,trimAdtsFramesByEarliestDts:trimAdtsFramesByEarliestDts,generateSampleTable:generateSampleTable,concatenateFrameData:concatenateFrameData};/**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */var ONE_SECOND_IN_TS$3=clock.ONE_SECOND_IN_TS;/**
   * Store information about the start and end of the track and the
   * duration for each frame/sample we process in order to calculate
   * the baseMediaDecodeTime
   */var collectDtsInfo=function collectDtsInfo(track,data){if(typeof data.pts==='number'){if(track.timelineStartInfo.pts===undefined){track.timelineStartInfo.pts=data.pts;}if(track.minSegmentPts===undefined){track.minSegmentPts=data.pts;}else{track.minSegmentPts=Math.min(track.minSegmentPts,data.pts);}if(track.maxSegmentPts===undefined){track.maxSegmentPts=data.pts;}else{track.maxSegmentPts=Math.max(track.maxSegmentPts,data.pts);}}if(typeof data.dts==='number'){if(track.timelineStartInfo.dts===undefined){track.timelineStartInfo.dts=data.dts;}if(track.minSegmentDts===undefined){track.minSegmentDts=data.dts;}else{track.minSegmentDts=Math.min(track.minSegmentDts,data.dts);}if(track.maxSegmentDts===undefined){track.maxSegmentDts=data.dts;}else{track.maxSegmentDts=Math.max(track.maxSegmentDts,data.dts);}}};/**
   * Clear values used to calculate the baseMediaDecodeTime between
   * tracks
   */var clearDtsInfo=function clearDtsInfo(track){delete track.minSegmentDts;delete track.maxSegmentDts;delete track.minSegmentPts;delete track.maxSegmentPts;};/**
   * Calculate the track's baseMediaDecodeTime based on the earliest
   * DTS the transmuxer has ever seen and the minimum DTS for the
   * current track
   * @param track {object} track metadata configuration
   * @param keepOriginalTimestamps {boolean} If true, keep the timestamps
   *        in the source; false to adjust the first segment to start at 0.
   */var calculateTrackBaseMediaDecodeTime=function calculateTrackBaseMediaDecodeTime(track,keepOriginalTimestamps){var baseMediaDecodeTime,scale,minSegmentDts=track.minSegmentDts;// Optionally adjust the time so the first segment starts at zero.
if(!keepOriginalTimestamps){minSegmentDts-=track.timelineStartInfo.dts;}// track.timelineStartInfo.baseMediaDecodeTime is the location, in time, where
// we want the start of the first segment to be placed
baseMediaDecodeTime=track.timelineStartInfo.baseMediaDecodeTime;// Add to that the distance this segment is from the very first
baseMediaDecodeTime+=minSegmentDts;// baseMediaDecodeTime must not become negative
baseMediaDecodeTime=Math.max(0,baseMediaDecodeTime);if(track.type==='audio'){// Audio has a different clock equal to the sampling_rate so we need to
// scale the PTS values into the clock rate of the track
scale=track.samplerate/ONE_SECOND_IN_TS$3;baseMediaDecodeTime*=scale;baseMediaDecodeTime=Math.floor(baseMediaDecodeTime);}return baseMediaDecodeTime;};var trackDecodeInfo={clearDtsInfo:clearDtsInfo,calculateTrackBaseMediaDecodeTime:calculateTrackBaseMediaDecodeTime,collectDtsInfo:collectDtsInfo};/**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Reads in-band caption information from a video elementary
   * stream. Captions must follow the CEA-708 standard for injection
   * into an MPEG-2 transport streams.
   * @see https://en.wikipedia.org/wiki/CEA-708
   * @see https://www.gpo.gov/fdsys/pkg/CFR-2007-title47-vol1/pdf/CFR-2007-title47-vol1-sec15-119.pdf
   */ // payload type field to indicate how they are to be
// interpreted. CEAS-708 caption content is always transmitted with
// payload type 0x04.
var USER_DATA_REGISTERED_ITU_T_T35=4,RBSP_TRAILING_BITS=128;/**
    * Parse a supplemental enhancement information (SEI) NAL unit.
    * Stops parsing once a message of type ITU T T35 has been found.
    *
    * @param bytes {Uint8Array} the bytes of a SEI NAL unit
    * @return {object} the parsed SEI payload
    * @see Rec. ITU-T H.264, 7.3.2.3.1
    */var parseSei=function parseSei(bytes){var i=0,result={payloadType:-1,payloadSize:0},payloadType=0,payloadSize=0;// go through the sei_rbsp parsing each each individual sei_message
while(i<bytes.byteLength){// stop once we have hit the end of the sei_rbsp
if(bytes[i]===RBSP_TRAILING_BITS){break;}// Parse payload type
while(bytes[i]===0xFF){payloadType+=255;i++;}payloadType+=bytes[i++];// Parse payload size
while(bytes[i]===0xFF){payloadSize+=255;i++;}payloadSize+=bytes[i++];// this sei_message is a 608/708 caption so save it and break
// there can only ever be one caption message in a frame's sei
if(!result.payload&&payloadType===USER_DATA_REGISTERED_ITU_T_T35){var userIdentifier=String.fromCharCode(bytes[i+3],bytes[i+4],bytes[i+5],bytes[i+6]);if(userIdentifier==='GA94'){result.payloadType=payloadType;result.payloadSize=payloadSize;result.payload=bytes.subarray(i,i+payloadSize);break;}else{result.payload=void 0;}}// skip the payload and parse the next message
i+=payloadSize;payloadType=0;payloadSize=0;}return result;};// see ANSI/SCTE 128-1 (2013), section 8.1
var parseUserData=function parseUserData(sei){// itu_t_t35_contry_code must be 181 (United States) for
// captions
if(sei.payload[0]!==181){return null;}// itu_t_t35_provider_code should be 49 (ATSC) for captions
if((sei.payload[1]<<8|sei.payload[2])!==49){return null;}// the user_identifier should be "GA94" to indicate ATSC1 data
if(String.fromCharCode(sei.payload[3],sei.payload[4],sei.payload[5],sei.payload[6])!=='GA94'){return null;}// finally, user_data_type_code should be 0x03 for caption data
if(sei.payload[7]!==0x03){return null;}// return the user_data_type_structure and strip the trailing
// marker bits
return sei.payload.subarray(8,sei.payload.length-1);};// see CEA-708-D, section 4.4
var parseCaptionPackets=function parseCaptionPackets(pts,userData){var results=[],i,count,offset,data;// if this is just filler, return immediately
if(!(userData[0]&0x40)){return results;}// parse out the cc_data_1 and cc_data_2 fields
count=userData[0]&0x1f;for(i=0;i<count;i++){offset=i*3;data={type:userData[offset+2]&0x03,pts:pts};// capture cc data when cc_valid is 1
if(userData[offset+2]&0x04){data.ccData=userData[offset+3]<<8|userData[offset+4];results.push(data);}}return results;};var discardEmulationPreventionBytes$1=function discardEmulationPreventionBytes(data){var length=data.byteLength,emulationPreventionBytesPositions=[],i=1,newLength,newData;// Find all `Emulation Prevention Bytes`
while(i<length-2){if(data[i]===0&&data[i+1]===0&&data[i+2]===0x03){emulationPreventionBytesPositions.push(i+2);i+=2;}else{i++;}}// If no Emulation Prevention Bytes were found just return the original
// array
if(emulationPreventionBytesPositions.length===0){return data;}// Create a new array to hold the NAL unit data
newLength=length-emulationPreventionBytesPositions.length;newData=new Uint8Array(newLength);var sourceIndex=0;for(i=0;i<newLength;sourceIndex++,i++){if(sourceIndex===emulationPreventionBytesPositions[0]){// Skip this byte
sourceIndex++;// Remove this position index
emulationPreventionBytesPositions.shift();}newData[i]=data[sourceIndex];}return newData;};// exports
var captionPacketParser={parseSei:parseSei,parseUserData:parseUserData,parseCaptionPackets:parseCaptionPackets,discardEmulationPreventionBytes:discardEmulationPreventionBytes$1,USER_DATA_REGISTERED_ITU_T_T35:USER_DATA_REGISTERED_ITU_T_T35};// Link To Transport
// -----------------
var CaptionStream$1=function CaptionStream(options){options=options||{};CaptionStream.prototype.init.call(this);// parse708captions flag, default to true
this.parse708captions_=typeof options.parse708captions==='boolean'?options.parse708captions:true;this.captionPackets_=[];this.ccStreams_=[new Cea608Stream(0,0),// eslint-disable-line no-use-before-define
new Cea608Stream(0,1),// eslint-disable-line no-use-before-define
new Cea608Stream(1,0),// eslint-disable-line no-use-before-define
new Cea608Stream(1,1)// eslint-disable-line no-use-before-define
];if(this.parse708captions_){this.cc708Stream_=new Cea708Stream({captionServices:options.captionServices});// eslint-disable-line no-use-before-define
}this.reset();// forward data and done events from CCs to this CaptionStream
this.ccStreams_.forEach(function(cc){cc.on('data',this.trigger.bind(this,'data'));cc.on('partialdone',this.trigger.bind(this,'partialdone'));cc.on('done',this.trigger.bind(this,'done'));},this);if(this.parse708captions_){this.cc708Stream_.on('data',this.trigger.bind(this,'data'));this.cc708Stream_.on('partialdone',this.trigger.bind(this,'partialdone'));this.cc708Stream_.on('done',this.trigger.bind(this,'done'));}};CaptionStream$1.prototype=new stream();CaptionStream$1.prototype.push=function(event){var sei,userData,newCaptionPackets;// only examine SEI NALs
if(event.nalUnitType!=='sei_rbsp'){return;}// parse the sei
sei=captionPacketParser.parseSei(event.escapedRBSP);// no payload data, skip
if(!sei.payload){return;}// ignore everything but user_data_registered_itu_t_t35
if(sei.payloadType!==captionPacketParser.USER_DATA_REGISTERED_ITU_T_T35){return;}// parse out the user data payload
userData=captionPacketParser.parseUserData(sei);// ignore unrecognized userData
if(!userData){return;}// Sometimes, the same segment # will be downloaded twice. To stop the
// caption data from being processed twice, we track the latest dts we've
// received and ignore everything with a dts before that. However, since
// data for a specific dts can be split across packets on either side of
// a segment boundary, we need to make sure we *don't* ignore the packets
// from the *next* segment that have dts === this.latestDts_. By constantly
// tracking the number of packets received with dts === this.latestDts_, we
// know how many should be ignored once we start receiving duplicates.
if(event.dts<this.latestDts_){// We've started getting older data, so set the flag.
this.ignoreNextEqualDts_=true;return;}else if(event.dts===this.latestDts_&&this.ignoreNextEqualDts_){this.numSameDts_--;if(!this.numSameDts_){// We've received the last duplicate packet, time to start processing again
this.ignoreNextEqualDts_=false;}return;}// parse out CC data packets and save them for later
newCaptionPackets=captionPacketParser.parseCaptionPackets(event.pts,userData);this.captionPackets_=this.captionPackets_.concat(newCaptionPackets);if(this.latestDts_!==event.dts){this.numSameDts_=0;}this.numSameDts_++;this.latestDts_=event.dts;};CaptionStream$1.prototype.flushCCStreams=function(flushType){this.ccStreams_.forEach(function(cc){return flushType==='flush'?cc.flush():cc.partialFlush();},this);};CaptionStream$1.prototype.flushStream=function(flushType){// make sure we actually parsed captions before proceeding
if(!this.captionPackets_.length){this.flushCCStreams(flushType);return;}// In Chrome, the Array#sort function is not stable so add a
// presortIndex that we can use to ensure we get a stable-sort
this.captionPackets_.forEach(function(elem,idx){elem.presortIndex=idx;});// sort caption byte-pairs based on their PTS values
this.captionPackets_.sort(function(a,b){if(a.pts===b.pts){return a.presortIndex-b.presortIndex;}return a.pts-b.pts;});this.captionPackets_.forEach(function(packet){if(packet.type<2){// Dispatch packet to the right Cea608Stream
this.dispatchCea608Packet(packet);}else{// Dispatch packet to the Cea708Stream
this.dispatchCea708Packet(packet);}},this);this.captionPackets_.length=0;this.flushCCStreams(flushType);};CaptionStream$1.prototype.flush=function(){return this.flushStream('flush');};// Only called if handling partial data
CaptionStream$1.prototype.partialFlush=function(){return this.flushStream('partialFlush');};CaptionStream$1.prototype.reset=function(){this.latestDts_=null;this.ignoreNextEqualDts_=false;this.numSameDts_=0;this.activeCea608Channel_=[null,null];this.ccStreams_.forEach(function(ccStream){ccStream.reset();});};// From the CEA-608 spec:
/*
   * When XDS sub-packets are interleaved with other services, the end of each sub-packet shall be followed
   * by a control pair to change to a different service. When any of the control codes from 0x10 to 0x1F is
   * used to begin a control code pair, it indicates the return to captioning or Text data. The control code pair
   * and subsequent data should then be processed according to the FCC rules. It may be necessary for the
   * line 21 data encoder to automatically insert a control code pair (i.e. RCL, RU2, RU3, RU4, RDC, or RTD)
   * to switch to captioning or Text.
  */ // With that in mind, we ignore any data between an XDS control code and a
// subsequent closed-captioning control code.
CaptionStream$1.prototype.dispatchCea608Packet=function(packet){// NOTE: packet.type is the CEA608 field
if(this.setsTextOrXDSActive(packet)){this.activeCea608Channel_[packet.type]=null;}else if(this.setsChannel1Active(packet)){this.activeCea608Channel_[packet.type]=0;}else if(this.setsChannel2Active(packet)){this.activeCea608Channel_[packet.type]=1;}if(this.activeCea608Channel_[packet.type]===null){// If we haven't received anything to set the active channel, or the
// packets are Text/XDS data, discard the data; we don't want jumbled
// captions
return;}this.ccStreams_[(packet.type<<1)+this.activeCea608Channel_[packet.type]].push(packet);};CaptionStream$1.prototype.setsChannel1Active=function(packet){return(packet.ccData&0x7800)===0x1000;};CaptionStream$1.prototype.setsChannel2Active=function(packet){return(packet.ccData&0x7800)===0x1800;};CaptionStream$1.prototype.setsTextOrXDSActive=function(packet){return(packet.ccData&0x7100)===0x0100||(packet.ccData&0x78fe)===0x102a||(packet.ccData&0x78fe)===0x182a;};CaptionStream$1.prototype.dispatchCea708Packet=function(packet){if(this.parse708captions_){this.cc708Stream_.push(packet);}};// ----------------------
// Session to Application
// ----------------------
// This hash maps special and extended character codes to their
// proper Unicode equivalent. The first one-byte key is just a
// non-standard character code. The two-byte keys that follow are
// the extended CEA708 character codes, along with the preceding
// 0x10 extended character byte to distinguish these codes from
// non-extended character codes. Every CEA708 character code that
// is not in this object maps directly to a standard unicode
// character code.
// The transparent space and non-breaking transparent space are
// technically not fully supported since there is no code to
// make them transparent, so they have normal non-transparent
// stand-ins.
// The special closed caption (CC) character isn't a standard
// unicode character, so a fairly similar unicode character was
// chosen in it's place.
var CHARACTER_TRANSLATION_708={0x7f:0x266a,// ♪
0x1020:0x20,// Transparent Space
0x1021:0xa0,// Nob-breaking Transparent Space
0x1025:0x2026,// …
0x102a:0x0160,// Š
0x102c:0x0152,// Œ
0x1030:0x2588,// █
0x1031:0x2018,// ‘
0x1032:0x2019,// ’
0x1033:0x201c,// “
0x1034:0x201d,// ”
0x1035:0x2022,// •
0x1039:0x2122,// ™
0x103a:0x0161,// š
0x103c:0x0153,// œ
0x103d:0x2120,// ℠
0x103f:0x0178,// Ÿ
0x1076:0x215b,// ⅛
0x1077:0x215c,// ⅜
0x1078:0x215d,// ⅝
0x1079:0x215e,// ⅞
0x107a:0x23d0,// ⏐
0x107b:0x23a4,// ⎤
0x107c:0x23a3,// ⎣
0x107d:0x23af,// ⎯
0x107e:0x23a6,// ⎦
0x107f:0x23a1,// ⎡
0x10a0:0x3138// ㄸ (CC char)
};var get708CharFromCode=function get708CharFromCode(code){var newCode=CHARACTER_TRANSLATION_708[code]||code;if(code&0x1000&&code===newCode){// Invalid extended code
return'';}return String.fromCharCode(newCode);};var within708TextBlock=function within708TextBlock(b){return 0x20<=b&&b<=0x7f||0xa0<=b&&b<=0xff;};var Cea708Window=function Cea708Window(windowNum){this.windowNum=windowNum;this.reset();};Cea708Window.prototype.reset=function(){this.clearText();this.pendingNewLine=false;this.winAttr={};this.penAttr={};this.penLoc={};this.penColor={};// These default values are arbitrary,
// defineWindow will usually override them
this.visible=0;this.rowLock=0;this.columnLock=0;this.priority=0;this.relativePositioning=0;this.anchorVertical=0;this.anchorHorizontal=0;this.anchorPoint=0;this.rowCount=1;this.virtualRowCount=this.rowCount+1;this.columnCount=41;this.windowStyle=0;this.penStyle=0;};Cea708Window.prototype.getText=function(){return this.rows.join('\n');};Cea708Window.prototype.clearText=function(){this.rows=[''];this.rowIdx=0;};Cea708Window.prototype.newLine=function(pts){if(this.rows.length>=this.virtualRowCount&&typeof this.beforeRowOverflow==='function'){this.beforeRowOverflow(pts);}if(this.rows.length>0){this.rows.push('');this.rowIdx++;}// Show all virtual rows since there's no visible scrolling
while(this.rows.length>this.virtualRowCount){this.rows.shift();this.rowIdx--;}};Cea708Window.prototype.isEmpty=function(){if(this.rows.length===0){return true;}else if(this.rows.length===1){return this.rows[0]==='';}return false;};Cea708Window.prototype.addText=function(text){this.rows[this.rowIdx]+=text;};Cea708Window.prototype.backspace=function(){if(!this.isEmpty()){var row=this.rows[this.rowIdx];this.rows[this.rowIdx]=row.substr(0,row.length-1);}};var Cea708Service=function Cea708Service(serviceNum,encoding,stream){this.serviceNum=serviceNum;this.text='';this.currentWindow=new Cea708Window(-1);this.windows=[];this.stream=stream;// Try to setup a TextDecoder if an `encoding` value was provided
if(typeof encoding==='string'){this.createTextDecoder(encoding);}};/**
   * Initialize service windows
   * Must be run before service use
   *
   * @param  {Integer}  pts               PTS value
   * @param  {Function} beforeRowOverflow Function to execute before row overflow of a window
   */Cea708Service.prototype.init=function(pts,beforeRowOverflow){this.startPts=pts;for(var win=0;win<8;win++){this.windows[win]=new Cea708Window(win);if(typeof beforeRowOverflow==='function'){this.windows[win].beforeRowOverflow=beforeRowOverflow;}}};/**
   * Set current window of service to be affected by commands
   *
   * @param  {Integer} windowNum Window number
   */Cea708Service.prototype.setCurrentWindow=function(windowNum){this.currentWindow=this.windows[windowNum];};/**
   * Try to create a TextDecoder if it is natively supported
   */Cea708Service.prototype.createTextDecoder=function(encoding){if(typeof TextDecoder==='undefined'){this.stream.trigger('log',{level:'warn',message:'The `encoding` option is unsupported without TextDecoder support'});}else{try{this.textDecoder_=new TextDecoder(encoding);}catch(error){this.stream.trigger('log',{level:'warn',message:'TextDecoder could not be created with '+encoding+' encoding. '+error});}}};var Cea708Stream=function Cea708Stream(options){options=options||{};Cea708Stream.prototype.init.call(this);var self=this;var captionServices=options.captionServices||{};var captionServiceEncodings={};var serviceProps;// Get service encodings from captionServices option block
Object.keys(captionServices).forEach(function(serviceName){serviceProps=captionServices[serviceName];if(/^SERVICE/.test(serviceName)){captionServiceEncodings[serviceName]=serviceProps.encoding;}});this.serviceEncodings=captionServiceEncodings;this.current708Packet=null;this.services={};this.push=function(packet){if(packet.type===3){// 708 packet start
self.new708Packet();self.add708Bytes(packet);}else{if(self.current708Packet===null){// This should only happen at the start of a file if there's no packet start.
self.new708Packet();}self.add708Bytes(packet);}};};Cea708Stream.prototype=new stream();/**
   * Push current 708 packet, create new 708 packet.
   */Cea708Stream.prototype.new708Packet=function(){if(this.current708Packet!==null){this.push708Packet();}this.current708Packet={data:[],ptsVals:[]};};/**
   * Add pts and both bytes from packet into current 708 packet.
   */Cea708Stream.prototype.add708Bytes=function(packet){var data=packet.ccData;var byte0=data>>>8;var byte1=data&0xff;// I would just keep a list of packets instead of bytes, but it isn't clear in the spec
// that service blocks will always line up with byte pairs.
this.current708Packet.ptsVals.push(packet.pts);this.current708Packet.data.push(byte0);this.current708Packet.data.push(byte1);};/**
   * Parse completed 708 packet into service blocks and push each service block.
   */Cea708Stream.prototype.push708Packet=function(){var packet708=this.current708Packet;var packetData=packet708.data;var serviceNum=null;var blockSize=null;var i=0;var b=packetData[i++];packet708.seq=b>>6;packet708.sizeCode=b&0x3f;// 0b00111111;
for(;i<packetData.length;i++){b=packetData[i++];serviceNum=b>>5;blockSize=b&0x1f;// 0b00011111
if(serviceNum===7&&blockSize>0){// Extended service num
b=packetData[i++];serviceNum=b;}this.pushServiceBlock(serviceNum,i,blockSize);if(blockSize>0){i+=blockSize-1;}}};/**
   * Parse service block, execute commands, read text.
   *
   * Note: While many of these commands serve important purposes,
   * many others just parse out the parameters or attributes, but
   * nothing is done with them because this is not a full and complete
   * implementation of the entire 708 spec.
   *
   * @param  {Integer} serviceNum Service number
   * @param  {Integer} start      Start index of the 708 packet data
   * @param  {Integer} size       Block size
   */Cea708Stream.prototype.pushServiceBlock=function(serviceNum,start,size){var b;var i=start;var packetData=this.current708Packet.data;var service=this.services[serviceNum];if(!service){service=this.initService(serviceNum,i);}for(;i<start+size&&i<packetData.length;i++){b=packetData[i];if(within708TextBlock(b)){i=this.handleText(i,service);}else if(b===0x18){i=this.multiByteCharacter(i,service);}else if(b===0x10){i=this.extendedCommands(i,service);}else if(0x80<=b&&b<=0x87){i=this.setCurrentWindow(i,service);}else if(0x98<=b&&b<=0x9f){i=this.defineWindow(i,service);}else if(b===0x88){i=this.clearWindows(i,service);}else if(b===0x8c){i=this.deleteWindows(i,service);}else if(b===0x89){i=this.displayWindows(i,service);}else if(b===0x8a){i=this.hideWindows(i,service);}else if(b===0x8b){i=this.toggleWindows(i,service);}else if(b===0x97){i=this.setWindowAttributes(i,service);}else if(b===0x90){i=this.setPenAttributes(i,service);}else if(b===0x91){i=this.setPenColor(i,service);}else if(b===0x92){i=this.setPenLocation(i,service);}else if(b===0x8f){service=this.reset(i,service);}else if(b===0x08){// BS: Backspace
service.currentWindow.backspace();}else if(b===0x0c){// FF: Form feed
service.currentWindow.clearText();}else if(b===0x0d){// CR: Carriage return
service.currentWindow.pendingNewLine=true;}else if(b===0x0e){// HCR: Horizontal carriage return
service.currentWindow.clearText();}else if(b===0x8d){// DLY: Delay, nothing to do
i++;}else;}};/**
   * Execute an extended command
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.extendedCommands=function(i,service){var packetData=this.current708Packet.data;var b=packetData[++i];if(within708TextBlock(b)){i=this.handleText(i,service,{isExtended:true});}return i;};/**
   * Get PTS value of a given byte index
   *
   * @param  {Integer} byteIndex  Index of the byte
   * @return {Integer}            PTS
   */Cea708Stream.prototype.getPts=function(byteIndex){// There's 1 pts value per 2 bytes
return this.current708Packet.ptsVals[Math.floor(byteIndex/2)];};/**
   * Initializes a service
   *
   * @param  {Integer} serviceNum Service number
   * @return {Service}            Initialized service object
   */Cea708Stream.prototype.initService=function(serviceNum,i){var serviceName='SERVICE'+serviceNum;var self=this;var serviceName;var encoding;if(serviceName in this.serviceEncodings){encoding=this.serviceEncodings[serviceName];}this.services[serviceNum]=new Cea708Service(serviceNum,encoding,self);this.services[serviceNum].init(this.getPts(i),function(pts){self.flushDisplayed(pts,self.services[serviceNum]);});return this.services[serviceNum];};/**
   * Execute text writing to current window
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.handleText=function(i,service,options){var isExtended=options&&options.isExtended;var isMultiByte=options&&options.isMultiByte;var packetData=this.current708Packet.data;var extended=isExtended?0x1000:0x0000;var currentByte=packetData[i];var nextByte=packetData[i+1];var win=service.currentWindow;var _char;var charCodeArray;// Use the TextDecoder if one was created for this service
if(service.textDecoder_&&!isExtended){if(isMultiByte){charCodeArray=[currentByte,nextByte];i++;}else{charCodeArray=[currentByte];}_char=service.textDecoder_.decode(new Uint8Array(charCodeArray));}else{_char=get708CharFromCode(extended|currentByte);}if(win.pendingNewLine&&!win.isEmpty()){win.newLine(this.getPts(i));}win.pendingNewLine=false;win.addText(_char);return i;};/**
   * Handle decoding of multibyte character
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.multiByteCharacter=function(i,service){var packetData=this.current708Packet.data;var firstByte=packetData[i+1];var secondByte=packetData[i+2];if(within708TextBlock(firstByte)&&within708TextBlock(secondByte)){i=this.handleText(++i,service,{isMultiByte:true});}return i;};/**
   * Parse and execute the CW# command.
   *
   * Set the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.setCurrentWindow=function(i,service){var packetData=this.current708Packet.data;var b=packetData[i];var windowNum=b&0x07;service.setCurrentWindow(windowNum);return i;};/**
   * Parse and execute the DF# command.
   *
   * Define a window and set it as the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.defineWindow=function(i,service){var packetData=this.current708Packet.data;var b=packetData[i];var windowNum=b&0x07;service.setCurrentWindow(windowNum);var win=service.currentWindow;b=packetData[++i];win.visible=(b&0x20)>>5;// v
win.rowLock=(b&0x10)>>4;// rl
win.columnLock=(b&0x08)>>3;// cl
win.priority=b&0x07;// p
b=packetData[++i];win.relativePositioning=(b&0x80)>>7;// rp
win.anchorVertical=b&0x7f;// av
b=packetData[++i];win.anchorHorizontal=b;// ah
b=packetData[++i];win.anchorPoint=(b&0xf0)>>4;// ap
win.rowCount=b&0x0f;// rc
b=packetData[++i];win.columnCount=b&0x3f;// cc
b=packetData[++i];win.windowStyle=(b&0x38)>>3;// ws
win.penStyle=b&0x07;// ps
// The spec says there are (rowCount+1) "virtual rows"
win.virtualRowCount=win.rowCount+1;return i;};/**
   * Parse and execute the SWA command.
   *
   * Set attributes of the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.setWindowAttributes=function(i,service){var packetData=this.current708Packet.data;var b=packetData[i];var winAttr=service.currentWindow.winAttr;b=packetData[++i];winAttr.fillOpacity=(b&0xc0)>>6;// fo
winAttr.fillRed=(b&0x30)>>4;// fr
winAttr.fillGreen=(b&0x0c)>>2;// fg
winAttr.fillBlue=b&0x03;// fb
b=packetData[++i];winAttr.borderType=(b&0xc0)>>6;// bt
winAttr.borderRed=(b&0x30)>>4;// br
winAttr.borderGreen=(b&0x0c)>>2;// bg
winAttr.borderBlue=b&0x03;// bb
b=packetData[++i];winAttr.borderType+=(b&0x80)>>5;// bt
winAttr.wordWrap=(b&0x40)>>6;// ww
winAttr.printDirection=(b&0x30)>>4;// pd
winAttr.scrollDirection=(b&0x0c)>>2;// sd
winAttr.justify=b&0x03;// j
b=packetData[++i];winAttr.effectSpeed=(b&0xf0)>>4;// es
winAttr.effectDirection=(b&0x0c)>>2;// ed
winAttr.displayEffect=b&0x03;// de
return i;};/**
   * Gather text from all displayed windows and push a caption to output.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   */Cea708Stream.prototype.flushDisplayed=function(pts,service){var displayedText=[];// TODO: Positioning not supported, displaying multiple windows will not necessarily
// display text in the correct order, but sample files so far have not shown any issue.
for(var winId=0;winId<8;winId++){if(service.windows[winId].visible&&!service.windows[winId].isEmpty()){displayedText.push(service.windows[winId].getText());}}service.endPts=pts;service.text=displayedText.join('\n\n');this.pushCaption(service);service.startPts=pts;};/**
   * Push a caption to output if the caption contains text.
   *
   * @param  {Service} service  The service object to be affected
   */Cea708Stream.prototype.pushCaption=function(service){if(service.text!==''){this.trigger('data',{startPts:service.startPts,endPts:service.endPts,text:service.text,stream:'cc708_'+service.serviceNum});service.text='';service.startPts=service.endPts;}};/**
   * Parse and execute the DSW command.
   *
   * Set visible property of windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.displayWindows=function(i,service){var packetData=this.current708Packet.data;var b=packetData[++i];var pts=this.getPts(i);this.flushDisplayed(pts,service);for(var winId=0;winId<8;winId++){if(b&0x01<<winId){service.windows[winId].visible=1;}}return i;};/**
   * Parse and execute the HDW command.
   *
   * Set visible property of windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.hideWindows=function(i,service){var packetData=this.current708Packet.data;var b=packetData[++i];var pts=this.getPts(i);this.flushDisplayed(pts,service);for(var winId=0;winId<8;winId++){if(b&0x01<<winId){service.windows[winId].visible=0;}}return i;};/**
   * Parse and execute the TGW command.
   *
   * Set visible property of windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.toggleWindows=function(i,service){var packetData=this.current708Packet.data;var b=packetData[++i];var pts=this.getPts(i);this.flushDisplayed(pts,service);for(var winId=0;winId<8;winId++){if(b&0x01<<winId){service.windows[winId].visible^=1;}}return i;};/**
   * Parse and execute the CLW command.
   *
   * Clear text of windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.clearWindows=function(i,service){var packetData=this.current708Packet.data;var b=packetData[++i];var pts=this.getPts(i);this.flushDisplayed(pts,service);for(var winId=0;winId<8;winId++){if(b&0x01<<winId){service.windows[winId].clearText();}}return i;};/**
   * Parse and execute the DLW command.
   *
   * Re-initialize windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.deleteWindows=function(i,service){var packetData=this.current708Packet.data;var b=packetData[++i];var pts=this.getPts(i);this.flushDisplayed(pts,service);for(var winId=0;winId<8;winId++){if(b&0x01<<winId){service.windows[winId].reset();}}return i;};/**
   * Parse and execute the SPA command.
   *
   * Set pen attributes of the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.setPenAttributes=function(i,service){var packetData=this.current708Packet.data;var b=packetData[i];var penAttr=service.currentWindow.penAttr;b=packetData[++i];penAttr.textTag=(b&0xf0)>>4;// tt
penAttr.offset=(b&0x0c)>>2;// o
penAttr.penSize=b&0x03;// s
b=packetData[++i];penAttr.italics=(b&0x80)>>7;// i
penAttr.underline=(b&0x40)>>6;// u
penAttr.edgeType=(b&0x38)>>3;// et
penAttr.fontStyle=b&0x07;// fs
return i;};/**
   * Parse and execute the SPC command.
   *
   * Set pen color of the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.setPenColor=function(i,service){var packetData=this.current708Packet.data;var b=packetData[i];var penColor=service.currentWindow.penColor;b=packetData[++i];penColor.fgOpacity=(b&0xc0)>>6;// fo
penColor.fgRed=(b&0x30)>>4;// fr
penColor.fgGreen=(b&0x0c)>>2;// fg
penColor.fgBlue=b&0x03;// fb
b=packetData[++i];penColor.bgOpacity=(b&0xc0)>>6;// bo
penColor.bgRed=(b&0x30)>>4;// br
penColor.bgGreen=(b&0x0c)>>2;// bg
penColor.bgBlue=b&0x03;// bb
b=packetData[++i];penColor.edgeRed=(b&0x30)>>4;// er
penColor.edgeGreen=(b&0x0c)>>2;// eg
penColor.edgeBlue=b&0x03;// eb
return i;};/**
   * Parse and execute the SPL command.
   *
   * Set pen location of the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.setPenLocation=function(i,service){var packetData=this.current708Packet.data;var b=packetData[i];var penLoc=service.currentWindow.penLoc;// Positioning isn't really supported at the moment, so this essentially just inserts a linebreak
service.currentWindow.pendingNewLine=true;b=packetData[++i];penLoc.row=b&0x0f;// r
b=packetData[++i];penLoc.column=b&0x3f;// c
return i;};/**
   * Execute the RST command.
   *
   * Reset service to a clean slate. Re-initialize.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Service}          Re-initialized service
   */Cea708Stream.prototype.reset=function(i,service){var pts=this.getPts(i);this.flushDisplayed(pts,service);return this.initService(service.serviceNum,i);};// This hash maps non-ASCII, special, and extended character codes to their
// proper Unicode equivalent. The first keys that are only a single byte
// are the non-standard ASCII characters, which simply map the CEA608 byte
// to the standard ASCII/Unicode. The two-byte keys that follow are the CEA608
// character codes, but have their MSB bitmasked with 0x03 so that a lookup
// can be performed regardless of the field and data channel on which the
// character code was received.
var CHARACTER_TRANSLATION={0x2a:0xe1,// á
0x5c:0xe9,// é
0x5e:0xed,// í
0x5f:0xf3,// ó
0x60:0xfa,// ú
0x7b:0xe7,// ç
0x7c:0xf7,// ÷
0x7d:0xd1,// Ñ
0x7e:0xf1,// ñ
0x7f:0x2588,// █
0x0130:0xae,// ®
0x0131:0xb0,// °
0x0132:0xbd,// ½
0x0133:0xbf,// ¿
0x0134:0x2122,// ™
0x0135:0xa2,// ¢
0x0136:0xa3,// £
0x0137:0x266a,// ♪
0x0138:0xe0,// à
0x0139:0xa0,//
0x013a:0xe8,// è
0x013b:0xe2,// â
0x013c:0xea,// ê
0x013d:0xee,// î
0x013e:0xf4,// ô
0x013f:0xfb,// û
0x0220:0xc1,// Á
0x0221:0xc9,// É
0x0222:0xd3,// Ó
0x0223:0xda,// Ú
0x0224:0xdc,// Ü
0x0225:0xfc,// ü
0x0226:0x2018,// ‘
0x0227:0xa1,// ¡
0x0228:0x2a,// *
0x0229:0x27,// '
0x022a:0x2014,// —
0x022b:0xa9,// ©
0x022c:0x2120,// ℠
0x022d:0x2022,// •
0x022e:0x201c,// “
0x022f:0x201d,// ”
0x0230:0xc0,// À
0x0231:0xc2,// Â
0x0232:0xc7,// Ç
0x0233:0xc8,// È
0x0234:0xca,// Ê
0x0235:0xcb,// Ë
0x0236:0xeb,// ë
0x0237:0xce,// Î
0x0238:0xcf,// Ï
0x0239:0xef,// ï
0x023a:0xd4,// Ô
0x023b:0xd9,// Ù
0x023c:0xf9,// ù
0x023d:0xdb,// Û
0x023e:0xab,// «
0x023f:0xbb,// »
0x0320:0xc3,// Ã
0x0321:0xe3,// ã
0x0322:0xcd,// Í
0x0323:0xcc,// Ì
0x0324:0xec,// ì
0x0325:0xd2,// Ò
0x0326:0xf2,// ò
0x0327:0xd5,// Õ
0x0328:0xf5,// õ
0x0329:0x7b,// {
0x032a:0x7d,// }
0x032b:0x5c,// \
0x032c:0x5e,// ^
0x032d:0x5f,// _
0x032e:0x7c,// |
0x032f:0x7e,// ~
0x0330:0xc4,// Ä
0x0331:0xe4,// ä
0x0332:0xd6,// Ö
0x0333:0xf6,// ö
0x0334:0xdf,// ß
0x0335:0xa5,// ¥
0x0336:0xa4,// ¤
0x0337:0x2502,// │
0x0338:0xc5,// Å
0x0339:0xe5,// å
0x033a:0xd8,// Ø
0x033b:0xf8,// ø
0x033c:0x250c,// ┌
0x033d:0x2510,// ┐
0x033e:0x2514,// └
0x033f:0x2518// ┘
};var getCharFromCode=function getCharFromCode(code){if(code===null){return'';}code=CHARACTER_TRANSLATION[code]||code;return String.fromCharCode(code);};// the index of the last row in a CEA-608 display buffer
var BOTTOM_ROW=14;// This array is used for mapping PACs -> row #, since there's no way of
// getting it through bit logic.
var ROWS=[0x1100,0x1120,0x1200,0x1220,0x1500,0x1520,0x1600,0x1620,0x1700,0x1720,0x1000,0x1300,0x1320,0x1400,0x1420];// CEA-608 captions are rendered onto a 34x15 matrix of character
// cells. The "bottom" row is the last element in the outer array.
var createDisplayBuffer=function createDisplayBuffer(){var result=[],i=BOTTOM_ROW+1;while(i--){result.push('');}return result;};var Cea608Stream=function Cea608Stream(field,dataChannel){Cea608Stream.prototype.init.call(this);this.field_=field||0;this.dataChannel_=dataChannel||0;this.name_='CC'+((this.field_<<1|this.dataChannel_)+1);this.setConstants();this.reset();this.push=function(packet){var data,swap,char0,char1,text;// remove the parity bits
data=packet.ccData&0x7f7f;// ignore duplicate control codes; the spec demands they're sent twice
if(data===this.lastControlCode_){this.lastControlCode_=null;return;}// Store control codes
if((data&0xf000)===0x1000){this.lastControlCode_=data;}else if(data!==this.PADDING_){this.lastControlCode_=null;}char0=data>>>8;char1=data&0xff;if(data===this.PADDING_){return;}else if(data===this.RESUME_CAPTION_LOADING_){this.mode_='popOn';}else if(data===this.END_OF_CAPTION_){// If an EOC is received while in paint-on mode, the displayed caption
// text should be swapped to non-displayed memory as if it was a pop-on
// caption. Because of that, we should explicitly switch back to pop-on
// mode
this.mode_='popOn';this.clearFormatting(packet.pts);// if a caption was being displayed, it's gone now
this.flushDisplayed(packet.pts);// flip memory
swap=this.displayed_;this.displayed_=this.nonDisplayed_;this.nonDisplayed_=swap;// start measuring the time to display the caption
this.startPts_=packet.pts;}else if(data===this.ROLL_UP_2_ROWS_){this.rollUpRows_=2;this.setRollUp(packet.pts);}else if(data===this.ROLL_UP_3_ROWS_){this.rollUpRows_=3;this.setRollUp(packet.pts);}else if(data===this.ROLL_UP_4_ROWS_){this.rollUpRows_=4;this.setRollUp(packet.pts);}else if(data===this.CARRIAGE_RETURN_){this.clearFormatting(packet.pts);this.flushDisplayed(packet.pts);this.shiftRowsUp_();this.startPts_=packet.pts;}else if(data===this.BACKSPACE_){if(this.mode_==='popOn'){this.nonDisplayed_[this.row_]=this.nonDisplayed_[this.row_].slice(0,-1);}else{this.displayed_[this.row_]=this.displayed_[this.row_].slice(0,-1);}}else if(data===this.ERASE_DISPLAYED_MEMORY_){this.flushDisplayed(packet.pts);this.displayed_=createDisplayBuffer();}else if(data===this.ERASE_NON_DISPLAYED_MEMORY_){this.nonDisplayed_=createDisplayBuffer();}else if(data===this.RESUME_DIRECT_CAPTIONING_){if(this.mode_!=='paintOn'){// NOTE: This should be removed when proper caption positioning is
// implemented
this.flushDisplayed(packet.pts);this.displayed_=createDisplayBuffer();}this.mode_='paintOn';this.startPts_=packet.pts;// Append special characters to caption text
}else if(this.isSpecialCharacter(char0,char1)){// Bitmask char0 so that we can apply character transformations
// regardless of field and data channel.
// Then byte-shift to the left and OR with char1 so we can pass the
// entire character code to `getCharFromCode`.
char0=(char0&0x03)<<8;text=getCharFromCode(char0|char1);this[this.mode_](packet.pts,text);this.column_++;// Append extended characters to caption text
}else if(this.isExtCharacter(char0,char1)){// Extended characters always follow their "non-extended" equivalents.
// IE if a "è" is desired, you'll always receive "eè"; non-compliant
// decoders are supposed to drop the "è", while compliant decoders
// backspace the "e" and insert "è".
// Delete the previous character
if(this.mode_==='popOn'){this.nonDisplayed_[this.row_]=this.nonDisplayed_[this.row_].slice(0,-1);}else{this.displayed_[this.row_]=this.displayed_[this.row_].slice(0,-1);}// Bitmask char0 so that we can apply character transformations
// regardless of field and data channel.
// Then byte-shift to the left and OR with char1 so we can pass the
// entire character code to `getCharFromCode`.
char0=(char0&0x03)<<8;text=getCharFromCode(char0|char1);this[this.mode_](packet.pts,text);this.column_++;// Process mid-row codes
}else if(this.isMidRowCode(char0,char1)){// Attributes are not additive, so clear all formatting
this.clearFormatting(packet.pts);// According to the standard, mid-row codes
// should be replaced with spaces, so add one now
this[this.mode_](packet.pts,' ');this.column_++;if((char1&0xe)===0xe){this.addFormatting(packet.pts,['i']);}if((char1&0x1)===0x1){this.addFormatting(packet.pts,['u']);}// Detect offset control codes and adjust cursor
}else if(this.isOffsetControlCode(char0,char1)){// Cursor position is set by indent PAC (see below) in 4-column
// increments, with an additional offset code of 1-3 to reach any
// of the 32 columns specified by CEA-608. So all we need to do
// here is increment the column cursor by the given offset.
this.column_+=char1&0x03;// Detect PACs (Preamble Address Codes)
}else if(this.isPAC(char0,char1)){// There's no logic for PAC -> row mapping, so we have to just
// find the row code in an array and use its index :(
var row=ROWS.indexOf(data&0x1f20);// Configure the caption window if we're in roll-up mode
if(this.mode_==='rollUp'){// This implies that the base row is incorrectly set.
// As per the recommendation in CEA-608(Base Row Implementation), defer to the number
// of roll-up rows set.
if(row-this.rollUpRows_+1<0){row=this.rollUpRows_-1;}this.setRollUp(packet.pts,row);}if(row!==this.row_){// formatting is only persistent for current row
this.clearFormatting(packet.pts);this.row_=row;}// All PACs can apply underline, so detect and apply
// (All odd-numbered second bytes set underline)
if(char1&0x1&&this.formatting_.indexOf('u')===-1){this.addFormatting(packet.pts,['u']);}if((data&0x10)===0x10){// We've got an indent level code. Each successive even number
// increments the column cursor by 4, so we can get the desired
// column position by bit-shifting to the right (to get n/2)
// and multiplying by 4.
this.column_=((data&0xe)>>1)*4;}if(this.isColorPAC(char1)){// it's a color code, though we only support white, which
// can be either normal or italicized. white italics can be
// either 0x4e or 0x6e depending on the row, so we just
// bitwise-and with 0xe to see if italics should be turned on
if((char1&0xe)===0xe){this.addFormatting(packet.pts,['i']);}}// We have a normal character in char0, and possibly one in char1
}else if(this.isNormalChar(char0)){if(char1===0x00){char1=null;}text=getCharFromCode(char0);text+=getCharFromCode(char1);this[this.mode_](packet.pts,text);this.column_+=text.length;}// finish data processing
};};Cea608Stream.prototype=new stream();// Trigger a cue point that captures the current state of the
// display buffer
Cea608Stream.prototype.flushDisplayed=function(pts){var content=this.displayed_// remove spaces from the start and end of the string
.map(function(row,index){try{return row.trim();}catch(e){// Ordinarily, this shouldn't happen. However, caption
// parsing errors should not throw exceptions and
// break playback.
this.trigger('log',{level:'warn',message:'Skipping a malformed 608 caption at index '+index+'.'});return'';}},this)// combine all text rows to display in one cue
.join('\n')// and remove blank rows from the start and end, but not the middle
.replace(/^\n+|\n+$/g,'');if(content.length){this.trigger('data',{startPts:this.startPts_,endPts:pts,text:content,stream:this.name_});}};/**
   * Zero out the data, used for startup and on seek
   */Cea608Stream.prototype.reset=function(){this.mode_='popOn';// When in roll-up mode, the index of the last row that will
// actually display captions. If a caption is shifted to a row
// with a lower index than this, it is cleared from the display
// buffer
this.topRow_=0;this.startPts_=0;this.displayed_=createDisplayBuffer();this.nonDisplayed_=createDisplayBuffer();this.lastControlCode_=null;// Track row and column for proper line-breaking and spacing
this.column_=0;this.row_=BOTTOM_ROW;this.rollUpRows_=2;// This variable holds currently-applied formatting
this.formatting_=[];};/**
   * Sets up control code and related constants for this instance
   */Cea608Stream.prototype.setConstants=function(){// The following attributes have these uses:
// ext_ :    char0 for mid-row codes, and the base for extended
//           chars (ext_+0, ext_+1, and ext_+2 are char0s for
//           extended codes)
// control_: char0 for control codes, except byte-shifted to the
//           left so that we can do this.control_ | CONTROL_CODE
// offset_:  char0 for tab offset codes
//
// It's also worth noting that control codes, and _only_ control codes,
// differ between field 1 and field2. Field 2 control codes are always
// their field 1 value plus 1. That's why there's the "| field" on the
// control value.
if(this.dataChannel_===0){this.BASE_=0x10;this.EXT_=0x11;this.CONTROL_=(0x14|this.field_)<<8;this.OFFSET_=0x17;}else if(this.dataChannel_===1){this.BASE_=0x18;this.EXT_=0x19;this.CONTROL_=(0x1c|this.field_)<<8;this.OFFSET_=0x1f;}// Constants for the LSByte command codes recognized by Cea608Stream. This
// list is not exhaustive. For a more comprehensive listing and semantics see
// http://www.gpo.gov/fdsys/pkg/CFR-2010-title47-vol1/pdf/CFR-2010-title47-vol1-sec15-119.pdf
// Padding
this.PADDING_=0x0000;// Pop-on Mode
this.RESUME_CAPTION_LOADING_=this.CONTROL_|0x20;this.END_OF_CAPTION_=this.CONTROL_|0x2f;// Roll-up Mode
this.ROLL_UP_2_ROWS_=this.CONTROL_|0x25;this.ROLL_UP_3_ROWS_=this.CONTROL_|0x26;this.ROLL_UP_4_ROWS_=this.CONTROL_|0x27;this.CARRIAGE_RETURN_=this.CONTROL_|0x2d;// paint-on mode
this.RESUME_DIRECT_CAPTIONING_=this.CONTROL_|0x29;// Erasure
this.BACKSPACE_=this.CONTROL_|0x21;this.ERASE_DISPLAYED_MEMORY_=this.CONTROL_|0x2c;this.ERASE_NON_DISPLAYED_MEMORY_=this.CONTROL_|0x2e;};/**
   * Detects if the 2-byte packet data is a special character
   *
   * Special characters have a second byte in the range 0x30 to 0x3f,
   * with the first byte being 0x11 (for data channel 1) or 0x19 (for
   * data channel 2).
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are an special character
   */Cea608Stream.prototype.isSpecialCharacter=function(char0,char1){return char0===this.EXT_&&char1>=0x30&&char1<=0x3f;};/**
   * Detects if the 2-byte packet data is an extended character
   *
   * Extended characters have a second byte in the range 0x20 to 0x3f,
   * with the first byte being 0x12 or 0x13 (for data channel 1) or
   * 0x1a or 0x1b (for data channel 2).
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are an extended character
   */Cea608Stream.prototype.isExtCharacter=function(char0,char1){return(char0===this.EXT_+1||char0===this.EXT_+2)&&char1>=0x20&&char1<=0x3f;};/**
   * Detects if the 2-byte packet is a mid-row code
   *
   * Mid-row codes have a second byte in the range 0x20 to 0x2f, with
   * the first byte being 0x11 (for data channel 1) or 0x19 (for data
   * channel 2).
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are a mid-row code
   */Cea608Stream.prototype.isMidRowCode=function(char0,char1){return char0===this.EXT_&&char1>=0x20&&char1<=0x2f;};/**
   * Detects if the 2-byte packet is an offset control code
   *
   * Offset control codes have a second byte in the range 0x21 to 0x23,
   * with the first byte being 0x17 (for data channel 1) or 0x1f (for
   * data channel 2).
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are an offset control code
   */Cea608Stream.prototype.isOffsetControlCode=function(char0,char1){return char0===this.OFFSET_&&char1>=0x21&&char1<=0x23;};/**
   * Detects if the 2-byte packet is a Preamble Address Code
   *
   * PACs have a first byte in the range 0x10 to 0x17 (for data channel 1)
   * or 0x18 to 0x1f (for data channel 2), with the second byte in the
   * range 0x40 to 0x7f.
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are a PAC
   */Cea608Stream.prototype.isPAC=function(char0,char1){return char0>=this.BASE_&&char0<this.BASE_+8&&char1>=0x40&&char1<=0x7f;};/**
   * Detects if a packet's second byte is in the range of a PAC color code
   *
   * PAC color codes have the second byte be in the range 0x40 to 0x4f, or
   * 0x60 to 0x6f.
   *
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the byte is a color PAC
   */Cea608Stream.prototype.isColorPAC=function(char1){return char1>=0x40&&char1<=0x4f||char1>=0x60&&char1<=0x7f;};/**
   * Detects if a single byte is in the range of a normal character
   *
   * Normal text bytes are in the range 0x20 to 0x7f.
   *
   * @param  {Integer} char  The byte
   * @return {Boolean}       Whether the byte is a normal character
   */Cea608Stream.prototype.isNormalChar=function(_char2){return _char2>=0x20&&_char2<=0x7f;};/**
   * Configures roll-up
   *
   * @param  {Integer} pts         Current PTS
   * @param  {Integer} newBaseRow  Used by PACs to slide the current window to
   *                               a new position
   */Cea608Stream.prototype.setRollUp=function(pts,newBaseRow){// Reset the base row to the bottom row when switching modes
if(this.mode_!=='rollUp'){this.row_=BOTTOM_ROW;this.mode_='rollUp';// Spec says to wipe memories when switching to roll-up
this.flushDisplayed(pts);this.nonDisplayed_=createDisplayBuffer();this.displayed_=createDisplayBuffer();}if(newBaseRow!==undefined&&newBaseRow!==this.row_){// move currently displayed captions (up or down) to the new base row
for(var i=0;i<this.rollUpRows_;i++){this.displayed_[newBaseRow-i]=this.displayed_[this.row_-i];this.displayed_[this.row_-i]='';}}if(newBaseRow===undefined){newBaseRow=this.row_;}this.topRow_=newBaseRow-this.rollUpRows_+1;};// Adds the opening HTML tag for the passed character to the caption text,
// and keeps track of it for later closing
Cea608Stream.prototype.addFormatting=function(pts,format){this.formatting_=this.formatting_.concat(format);var text=format.reduce(function(text,format){return text+'<'+format+'>';},'');this[this.mode_](pts,text);};// Adds HTML closing tags for current formatting to caption text and
// clears remembered formatting
Cea608Stream.prototype.clearFormatting=function(pts){if(!this.formatting_.length){return;}var text=this.formatting_.reverse().reduce(function(text,format){return text+'</'+format+'>';},'');this.formatting_=[];this[this.mode_](pts,text);};// Mode Implementations
Cea608Stream.prototype.popOn=function(pts,text){var baseRow=this.nonDisplayed_[this.row_];// buffer characters
baseRow+=text;this.nonDisplayed_[this.row_]=baseRow;};Cea608Stream.prototype.rollUp=function(pts,text){var baseRow=this.displayed_[this.row_];baseRow+=text;this.displayed_[this.row_]=baseRow;};Cea608Stream.prototype.shiftRowsUp_=function(){var i;// clear out inactive rows
for(i=0;i<this.topRow_;i++){this.displayed_[i]='';}for(i=this.row_+1;i<BOTTOM_ROW+1;i++){this.displayed_[i]='';}// shift displayed rows up
for(i=this.topRow_;i<this.row_;i++){this.displayed_[i]=this.displayed_[i+1];}// clear out the bottom row
this.displayed_[this.row_]='';};Cea608Stream.prototype.paintOn=function(pts,text){var baseRow=this.displayed_[this.row_];baseRow+=text;this.displayed_[this.row_]=baseRow;};// exports
var captionStream={CaptionStream:CaptionStream$1,Cea608Stream:Cea608Stream,Cea708Stream:Cea708Stream};/**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */var streamTypes={H264_STREAM_TYPE:0x1B,ADTS_STREAM_TYPE:0x0F,METADATA_STREAM_TYPE:0x15};var MAX_TS=8589934592;var RO_THRESH=4294967296;var TYPE_SHARED='shared';var handleRollover$1=function handleRollover(value,reference){var direction=1;if(value>reference){// If the current timestamp value is greater than our reference timestamp and we detect a
// timestamp rollover, this means the roll over is happening in the opposite direction.
// Example scenario: Enter a long stream/video just after a rollover occurred. The reference
// point will be set to a small number, e.g. 1. The user then seeks backwards over the
// rollover point. In loading this segment, the timestamp values will be very large,
// e.g. 2^33 - 1. Since this comes before the data we loaded previously, we want to adjust
// the time stamp to be `value - 2^33`.
direction=-1;}// Note: A seek forwards or back that is greater than the RO_THRESH (2^32, ~13 hours) will
// cause an incorrect adjustment.
while(Math.abs(reference-value)>RO_THRESH){value+=direction*MAX_TS;}return value;};var TimestampRolloverStream$1=function TimestampRolloverStream(type){var lastDTS,referenceDTS;TimestampRolloverStream.prototype.init.call(this);// The "shared" type is used in cases where a stream will contain muxed
// video and audio. We could use `undefined` here, but having a string
// makes debugging a little clearer.
this.type_=type||TYPE_SHARED;this.push=function(data){// Any "shared" rollover streams will accept _all_ data. Otherwise,
// streams will only accept data that matches their type.
if(this.type_!==TYPE_SHARED&&data.type!==this.type_){return;}if(referenceDTS===undefined){referenceDTS=data.dts;}data.dts=handleRollover$1(data.dts,referenceDTS);data.pts=handleRollover$1(data.pts,referenceDTS);lastDTS=data.dts;this.trigger('data',data);};this.flush=function(){referenceDTS=lastDTS;this.trigger('done');};this.endTimeline=function(){this.flush();this.trigger('endedtimeline');};this.discontinuity=function(){referenceDTS=void 0;lastDTS=void 0;};this.reset=function(){this.discontinuity();this.trigger('reset');};};TimestampRolloverStream$1.prototype=new stream();var timestampRolloverStream={TimestampRolloverStream:TimestampRolloverStream$1,handleRollover:handleRollover$1};var percentEncode$1=function percentEncode(bytes,start,end){var i,result='';for(i=start;i<end;i++){result+='%'+('00'+bytes[i].toString(16)).slice(-2);}return result;},// return the string representation of the specified byte range,
// interpreted as UTf-8.
parseUtf8=function parseUtf8(bytes,start,end){return decodeURIComponent(percentEncode$1(bytes,start,end));},// return the string representation of the specified byte range,
// interpreted as ISO-8859-1.
parseIso88591$1=function parseIso88591(bytes,start,end){return unescape(percentEncode$1(bytes,start,end));// jshint ignore:line
},parseSyncSafeInteger$1=function parseSyncSafeInteger(data){return data[0]<<21|data[1]<<14|data[2]<<7|data[3];},tagParsers={TXXX:function TXXX(tag){var i;if(tag.data[0]!==3){// ignore frames with unrecognized character encodings
return;}for(i=1;i<tag.data.length;i++){if(tag.data[i]===0){// parse the text fields
tag.description=parseUtf8(tag.data,1,i);// do not include the null terminator in the tag value
tag.value=parseUtf8(tag.data,i+1,tag.data.length).replace(/\0*$/,'');break;}}tag.data=tag.value;},WXXX:function WXXX(tag){var i;if(tag.data[0]!==3){// ignore frames with unrecognized character encodings
return;}for(i=1;i<tag.data.length;i++){if(tag.data[i]===0){// parse the description and URL fields
tag.description=parseUtf8(tag.data,1,i);tag.url=parseUtf8(tag.data,i+1,tag.data.length);break;}}},PRIV:function PRIV(tag){var i;for(i=0;i<tag.data.length;i++){if(tag.data[i]===0){// parse the description and URL fields
tag.owner=parseIso88591$1(tag.data,0,i);break;}}tag.privateData=tag.data.subarray(i+1);tag.data=tag.privateData;}},_MetadataStream;_MetadataStream=function MetadataStream(options){var settings={// the bytes of the program-level descriptor field in MP2T
// see ISO/IEC 13818-1:2013 (E), section 2.6 "Program and
// program element descriptors"
descriptor:options&&options.descriptor},// the total size in bytes of the ID3 tag being parsed
tagSize=0,// tag data that is not complete enough to be parsed
buffer=[],// the total number of bytes currently in the buffer
bufferSize=0,i;_MetadataStream.prototype.init.call(this);// calculate the text track in-band metadata track dispatch type
// https://html.spec.whatwg.org/multipage/embedded-content.html#steps-to-expose-a-media-resource-specific-text-track
this.dispatchType=streamTypes.METADATA_STREAM_TYPE.toString(16);if(settings.descriptor){for(i=0;i<settings.descriptor.length;i++){this.dispatchType+=('00'+settings.descriptor[i].toString(16)).slice(-2);}}this.push=function(chunk){var tag,frameStart,frameSize,frame,i,frameHeader;if(chunk.type!=='timed-metadata'){return;}// if data_alignment_indicator is set in the PES header,
// we must have the start of a new ID3 tag. Assume anything
// remaining in the buffer was malformed and throw it out
if(chunk.dataAlignmentIndicator){bufferSize=0;buffer.length=0;}// ignore events that don't look like ID3 data
if(buffer.length===0&&(chunk.data.length<10||chunk.data[0]!=='I'.charCodeAt(0)||chunk.data[1]!=='D'.charCodeAt(0)||chunk.data[2]!=='3'.charCodeAt(0))){this.trigger('log',{level:'warn',message:'Skipping unrecognized metadata packet'});return;}// add this chunk to the data we've collected so far
buffer.push(chunk);bufferSize+=chunk.data.byteLength;// grab the size of the entire frame from the ID3 header
if(buffer.length===1){// the frame size is transmitted as a 28-bit integer in the
// last four bytes of the ID3 header.
// The most significant bit of each byte is dropped and the
// results concatenated to recover the actual value.
tagSize=parseSyncSafeInteger$1(chunk.data.subarray(6,10));// ID3 reports the tag size excluding the header but it's more
// convenient for our comparisons to include it
tagSize+=10;}// if the entire frame has not arrived, wait for more data
if(bufferSize<tagSize){return;}// collect the entire frame so it can be parsed
tag={data:new Uint8Array(tagSize),frames:[],pts:buffer[0].pts,dts:buffer[0].dts};for(i=0;i<tagSize;){tag.data.set(buffer[0].data.subarray(0,tagSize-i),i);i+=buffer[0].data.byteLength;bufferSize-=buffer[0].data.byteLength;buffer.shift();}// find the start of the first frame and the end of the tag
frameStart=10;if(tag.data[5]&0x40){// advance the frame start past the extended header
frameStart+=4;// header size field
frameStart+=parseSyncSafeInteger$1(tag.data.subarray(10,14));// clip any padding off the end
tagSize-=parseSyncSafeInteger$1(tag.data.subarray(16,20));}// parse one or more ID3 frames
// http://id3.org/id3v2.3.0#ID3v2_frame_overview
do{// determine the number of bytes in this frame
frameSize=parseSyncSafeInteger$1(tag.data.subarray(frameStart+4,frameStart+8));if(frameSize<1){this.trigger('log',{level:'warn',message:'Malformed ID3 frame encountered. Skipping metadata parsing.'});return;}frameHeader=String.fromCharCode(tag.data[frameStart],tag.data[frameStart+1],tag.data[frameStart+2],tag.data[frameStart+3]);frame={id:frameHeader,data:tag.data.subarray(frameStart+10,frameStart+frameSize+10)};frame.key=frame.id;if(tagParsers[frame.id]){tagParsers[frame.id](frame);// handle the special PRIV frame used to indicate the start
// time for raw AAC data
if(frame.owner==='com.apple.streaming.transportStreamTimestamp'){var d=frame.data,size=(d[3]&0x01)<<30|d[4]<<22|d[5]<<14|d[6]<<6|d[7]>>>2;size*=4;size+=d[7]&0x03;frame.timeStamp=size;// in raw AAC, all subsequent data will be timestamped based
// on the value of this frame
// we couldn't have known the appropriate pts and dts before
// parsing this ID3 tag so set those values now
if(tag.pts===undefined&&tag.dts===undefined){tag.pts=frame.timeStamp;tag.dts=frame.timeStamp;}this.trigger('timestamp',frame);}}tag.frames.push(frame);frameStart+=10;// advance past the frame header
frameStart+=frameSize;// advance past the frame body
}while(frameStart<tagSize);this.trigger('data',tag);};};_MetadataStream.prototype=new stream();var metadataStream=_MetadataStream;var TimestampRolloverStream=timestampRolloverStream.TimestampRolloverStream;// object types
var _TransportPacketStream,_TransportParseStream,_ElementaryStream;// constants
var MP2T_PACKET_LENGTH$1=188,// bytes
SYNC_BYTE$1=0x47;/**
   * Splits an incoming stream of binary data into MPEG-2 Transport
   * Stream packets.
   */_TransportPacketStream=function TransportPacketStream(){var buffer=new Uint8Array(MP2T_PACKET_LENGTH$1),bytesInBuffer=0;_TransportPacketStream.prototype.init.call(this);// Deliver new bytes to the stream.
/**
     * Split a stream of data into M2TS packets
    **/this.push=function(bytes){var startIndex=0,endIndex=MP2T_PACKET_LENGTH$1,everything;// If there are bytes remaining from the last segment, prepend them to the
// bytes that were pushed in
if(bytesInBuffer){everything=new Uint8Array(bytes.byteLength+bytesInBuffer);everything.set(buffer.subarray(0,bytesInBuffer));everything.set(bytes,bytesInBuffer);bytesInBuffer=0;}else{everything=bytes;}// While we have enough data for a packet
while(endIndex<everything.byteLength){// Look for a pair of start and end sync bytes in the data..
if(everything[startIndex]===SYNC_BYTE$1&&everything[endIndex]===SYNC_BYTE$1){// We found a packet so emit it and jump one whole packet forward in
// the stream
this.trigger('data',everything.subarray(startIndex,endIndex));startIndex+=MP2T_PACKET_LENGTH$1;endIndex+=MP2T_PACKET_LENGTH$1;continue;}// If we get here, we have somehow become de-synchronized and we need to step
// forward one byte at a time until we find a pair of sync bytes that denote
// a packet
startIndex++;endIndex++;}// If there was some data left over at the end of the segment that couldn't
// possibly be a whole packet, keep it because it might be the start of a packet
// that continues in the next segment
if(startIndex<everything.byteLength){buffer.set(everything.subarray(startIndex),0);bytesInBuffer=everything.byteLength-startIndex;}};/**
     * Passes identified M2TS packets to the TransportParseStream to be parsed
    **/this.flush=function(){// If the buffer contains a whole packet when we are being flushed, emit it
// and empty the buffer. Otherwise hold onto the data because it may be
// important for decoding the next segment
if(bytesInBuffer===MP2T_PACKET_LENGTH$1&&buffer[0]===SYNC_BYTE$1){this.trigger('data',buffer);bytesInBuffer=0;}this.trigger('done');};this.endTimeline=function(){this.flush();this.trigger('endedtimeline');};this.reset=function(){bytesInBuffer=0;this.trigger('reset');};};_TransportPacketStream.prototype=new stream();/**
   * Accepts an MP2T TransportPacketStream and emits data events with parsed
   * forms of the individual transport stream packets.
   */_TransportParseStream=function TransportParseStream(){var parsePsi,parsePat,parsePmt,self;_TransportParseStream.prototype.init.call(this);self=this;this.packetsWaitingForPmt=[];this.programMapTable=undefined;parsePsi=function parsePsi(payload,psi){var offset=0;// PSI packets may be split into multiple sections and those
// sections may be split into multiple packets. If a PSI
// section starts in this packet, the payload_unit_start_indicator
// will be true and the first byte of the payload will indicate
// the offset from the current position to the start of the
// section.
if(psi.payloadUnitStartIndicator){offset+=payload[offset]+1;}if(psi.type==='pat'){parsePat(payload.subarray(offset),psi);}else{parsePmt(payload.subarray(offset),psi);}};parsePat=function parsePat(payload,pat){pat.section_number=payload[7];// eslint-disable-line camelcase
pat.last_section_number=payload[8];// eslint-disable-line camelcase
// skip the PSI header and parse the first PMT entry
self.pmtPid=(payload[10]&0x1F)<<8|payload[11];pat.pmtPid=self.pmtPid;};/**
     * Parse out the relevant fields of a Program Map Table (PMT).
     * @param payload {Uint8Array} the PMT-specific portion of an MP2T
     * packet. The first byte in this array should be the table_id
     * field.
     * @param pmt {object} the object that should be decorated with
     * fields parsed from the PMT.
     */parsePmt=function parsePmt(payload,pmt){var sectionLength,tableEnd,programInfoLength,offset;// PMTs can be sent ahead of the time when they should actually
// take effect. We don't believe this should ever be the case
// for HLS but we'll ignore "forward" PMT declarations if we see
// them. Future PMT declarations have the current_next_indicator
// set to zero.
if(!(payload[5]&0x01)){return;}// overwrite any existing program map table
self.programMapTable={video:null,audio:null,'timed-metadata':{}};// the mapping table ends at the end of the current section
sectionLength=(payload[1]&0x0f)<<8|payload[2];tableEnd=3+sectionLength-4;// to determine where the table is, we have to figure out how
// long the program info descriptors are
programInfoLength=(payload[10]&0x0f)<<8|payload[11];// advance the offset to the first entry in the mapping table
offset=12+programInfoLength;while(offset<tableEnd){var streamType=payload[offset];var pid=(payload[offset+1]&0x1F)<<8|payload[offset+2];// only map a single elementary_pid for audio and video stream types
// TODO: should this be done for metadata too? for now maintain behavior of
//       multiple metadata streams
if(streamType===streamTypes.H264_STREAM_TYPE&&self.programMapTable.video===null){self.programMapTable.video=pid;}else if(streamType===streamTypes.ADTS_STREAM_TYPE&&self.programMapTable.audio===null){self.programMapTable.audio=pid;}else if(streamType===streamTypes.METADATA_STREAM_TYPE){// map pid to stream type for metadata streams
self.programMapTable['timed-metadata'][pid]=streamType;}// move to the next table entry
// skip past the elementary stream descriptors, if present
offset+=((payload[offset+3]&0x0F)<<8|payload[offset+4])+5;}// record the map on the packet as well
pmt.programMapTable=self.programMapTable;};/**
     * Deliver a new MP2T packet to the next stream in the pipeline.
     */this.push=function(packet){var result={},offset=4;result.payloadUnitStartIndicator=!!(packet[1]&0x40);// pid is a 13-bit field starting at the last bit of packet[1]
result.pid=packet[1]&0x1f;result.pid<<=8;result.pid|=packet[2];// if an adaption field is present, its length is specified by the
// fifth byte of the TS packet header. The adaptation field is
// used to add stuffing to PES packets that don't fill a complete
// TS packet, and to specify some forms of timing and control data
// that we do not currently use.
if((packet[3]&0x30)>>>4>0x01){offset+=packet[offset]+1;}// parse the rest of the packet based on the type
if(result.pid===0){result.type='pat';parsePsi(packet.subarray(offset),result);this.trigger('data',result);}else if(result.pid===this.pmtPid){result.type='pmt';parsePsi(packet.subarray(offset),result);this.trigger('data',result);// if there are any packets waiting for a PMT to be found, process them now
while(this.packetsWaitingForPmt.length){this.processPes_.apply(this,this.packetsWaitingForPmt.shift());}}else if(this.programMapTable===undefined){// When we have not seen a PMT yet, defer further processing of
// PES packets until one has been parsed
this.packetsWaitingForPmt.push([packet,offset,result]);}else{this.processPes_(packet,offset,result);}};this.processPes_=function(packet,offset,result){// set the appropriate stream type
if(result.pid===this.programMapTable.video){result.streamType=streamTypes.H264_STREAM_TYPE;}else if(result.pid===this.programMapTable.audio){result.streamType=streamTypes.ADTS_STREAM_TYPE;}else{// if not video or audio, it is timed-metadata or unknown
// if unknown, streamType will be undefined
result.streamType=this.programMapTable['timed-metadata'][result.pid];}result.type='pes';result.data=packet.subarray(offset);this.trigger('data',result);};};_TransportParseStream.prototype=new stream();_TransportParseStream.STREAM_TYPES={h264:0x1b,adts:0x0f};/**
   * Reconsistutes program elementary stream (PES) packets from parsed
   * transport stream packets. That is, if you pipe an
   * mp2t.TransportParseStream into a mp2t.ElementaryStream, the output
   * events will be events which capture the bytes for individual PES
   * packets plus relevant metadata that has been extracted from the
   * container.
   */_ElementaryStream=function ElementaryStream(){var self=this,segmentHadPmt=false,// PES packet fragments
video={data:[],size:0},audio={data:[],size:0},timedMetadata={data:[],size:0},programMapTable,parsePes=function parsePes(payload,pes){var ptsDtsFlags;var startPrefix=payload[0]<<16|payload[1]<<8|payload[2];// default to an empty array
pes.data=new Uint8Array();// In certain live streams, the start of a TS fragment has ts packets
// that are frame data that is continuing from the previous fragment. This
// is to check that the pes data is the start of a new pes payload
if(startPrefix!==1){return;}// get the packet length, this will be 0 for video
pes.packetLength=6+(payload[4]<<8|payload[5]);// find out if this packets starts a new keyframe
pes.dataAlignmentIndicator=(payload[6]&0x04)!==0;// PES packets may be annotated with a PTS value, or a PTS value
// and a DTS value. Determine what combination of values is
// available to work with.
ptsDtsFlags=payload[7];// PTS and DTS are normally stored as a 33-bit number.  Javascript
// performs all bitwise operations on 32-bit integers but javascript
// supports a much greater range (52-bits) of integer using standard
// mathematical operations.
// We construct a 31-bit value using bitwise operators over the 31
// most significant bits and then multiply by 4 (equal to a left-shift
// of 2) before we add the final 2 least significant bits of the
// timestamp (equal to an OR.)
if(ptsDtsFlags&0xC0){// the PTS and DTS are not written out directly. For information
// on how they are encoded, see
// http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
pes.pts=(payload[9]&0x0E)<<27|(payload[10]&0xFF)<<20|(payload[11]&0xFE)<<12|(payload[12]&0xFF)<<5|(payload[13]&0xFE)>>>3;pes.pts*=4;// Left shift by 2
pes.pts+=(payload[13]&0x06)>>>1;// OR by the two LSBs
pes.dts=pes.pts;if(ptsDtsFlags&0x40){pes.dts=(payload[14]&0x0E)<<27|(payload[15]&0xFF)<<20|(payload[16]&0xFE)<<12|(payload[17]&0xFF)<<5|(payload[18]&0xFE)>>>3;pes.dts*=4;// Left shift by 2
pes.dts+=(payload[18]&0x06)>>>1;// OR by the two LSBs
}}// the data section starts immediately after the PES header.
// pes_header_data_length specifies the number of header bytes
// that follow the last byte of the field.
pes.data=payload.subarray(9+payload[8]);},/**
      * Pass completely parsed PES packets to the next stream in the pipeline
     **/flushStream=function flushStream(stream,type,forceFlush){var packetData=new Uint8Array(stream.size),event={type:type},i=0,offset=0,packetFlushable=false,fragment;// do nothing if there is not enough buffered data for a complete
// PES header
if(!stream.data.length||stream.size<9){return;}event.trackId=stream.data[0].pid;// reassemble the packet
for(i=0;i<stream.data.length;i++){fragment=stream.data[i];packetData.set(fragment.data,offset);offset+=fragment.data.byteLength;}// parse assembled packet's PES header
parsePes(packetData,event);// non-video PES packets MUST have a non-zero PES_packet_length
// check that there is enough stream data to fill the packet
packetFlushable=type==='video'||event.packetLength<=stream.size;// flush pending packets if the conditions are right
if(forceFlush||packetFlushable){stream.size=0;stream.data.length=0;}// only emit packets that are complete. this is to avoid assembling
// incomplete PES packets due to poor segmentation
if(packetFlushable){self.trigger('data',event);}};_ElementaryStream.prototype.init.call(this);/**
     * Identifies M2TS packet types and parses PES packets using metadata
     * parsed from the PMT
     **/this.push=function(data){({pat:function pat(){// we have to wait for the PMT to arrive as well before we
// have any meaningful metadata
},pes:function pes(){var stream,streamType;switch(data.streamType){case streamTypes.H264_STREAM_TYPE:stream=video;streamType='video';break;case streamTypes.ADTS_STREAM_TYPE:stream=audio;streamType='audio';break;case streamTypes.METADATA_STREAM_TYPE:stream=timedMetadata;streamType='timed-metadata';break;default:// ignore unknown stream types
return;}// if a new packet is starting, we can flush the completed
// packet
if(data.payloadUnitStartIndicator){flushStream(stream,streamType,true);}// buffer this fragment until we are sure we've received the
// complete payload
stream.data.push(data);stream.size+=data.data.byteLength;},pmt:function pmt(){var event={type:'metadata',tracks:[]};programMapTable=data.programMapTable;// translate audio and video streams to tracks
if(programMapTable.video!==null){event.tracks.push({timelineStartInfo:{baseMediaDecodeTime:0},id:+programMapTable.video,codec:'avc',type:'video'});}if(programMapTable.audio!==null){event.tracks.push({timelineStartInfo:{baseMediaDecodeTime:0},id:+programMapTable.audio,codec:'adts',type:'audio'});}segmentHadPmt=true;self.trigger('data',event);}})[data.type]();};this.reset=function(){video.size=0;video.data.length=0;audio.size=0;audio.data.length=0;this.trigger('reset');};/**
     * Flush any remaining input. Video PES packets may be of variable
     * length. Normally, the start of a new video packet can trigger the
     * finalization of the previous packet. That is not possible if no
     * more video is forthcoming, however. In that case, some other
     * mechanism (like the end of the file) has to be employed. When it is
     * clear that no additional data is forthcoming, calling this method
     * will flush the buffered packets.
     */this.flushStreams_=function(){// !!THIS ORDER IS IMPORTANT!!
// video first then audio
flushStream(video,'video');flushStream(audio,'audio');flushStream(timedMetadata,'timed-metadata');};this.flush=function(){// if on flush we haven't had a pmt emitted
// and we have a pmt to emit. emit the pmt
// so that we trigger a trackinfo downstream.
if(!segmentHadPmt&&programMapTable){var pmt={type:'metadata',tracks:[]};// translate audio and video streams to tracks
if(programMapTable.video!==null){pmt.tracks.push({timelineStartInfo:{baseMediaDecodeTime:0},id:+programMapTable.video,codec:'avc',type:'video'});}if(programMapTable.audio!==null){pmt.tracks.push({timelineStartInfo:{baseMediaDecodeTime:0},id:+programMapTable.audio,codec:'adts',type:'audio'});}self.trigger('data',pmt);}segmentHadPmt=false;this.flushStreams_();this.trigger('done');};};_ElementaryStream.prototype=new stream();var m2ts={PAT_PID:0x0000,MP2T_PACKET_LENGTH:MP2T_PACKET_LENGTH$1,TransportPacketStream:_TransportPacketStream,TransportParseStream:_TransportParseStream,ElementaryStream:_ElementaryStream,TimestampRolloverStream:TimestampRolloverStream,CaptionStream:captionStream.CaptionStream,Cea608Stream:captionStream.Cea608Stream,Cea708Stream:captionStream.Cea708Stream,MetadataStream:metadataStream};for(var type in streamTypes){if(streamTypes.hasOwnProperty(type)){m2ts[type]=streamTypes[type];}}var m2ts_1=m2ts;var ONE_SECOND_IN_TS$2=clock.ONE_SECOND_IN_TS;var _AdtsStream;var ADTS_SAMPLING_FREQUENCIES$1=[96000,88200,64000,48000,44100,32000,24000,22050,16000,12000,11025,8000,7350];/*
   * Accepts a ElementaryStream and emits data events with parsed
   * AAC Audio Frames of the individual packets. Input audio in ADTS
   * format is unpacked and re-emitted as AAC frames.
   *
   * @see http://wiki.multimedia.cx/index.php?title=ADTS
   * @see http://wiki.multimedia.cx/?title=Understanding_AAC
   */_AdtsStream=function AdtsStream(handlePartialSegments){var buffer,frameNum=0;_AdtsStream.prototype.init.call(this);this.skipWarn_=function(start,end){this.trigger('log',{level:'warn',message:"adts skiping bytes "+start+" to "+end+" in frame "+frameNum+" outside syncword"});};this.push=function(packet){var i=0,frameLength,protectionSkipBytes,oldBuffer,sampleCount,adtsFrameDuration;if(!handlePartialSegments){frameNum=0;}if(packet.type!=='audio'){// ignore non-audio data
return;}// Prepend any data in the buffer to the input data so that we can parse
// aac frames the cross a PES packet boundary
if(buffer&&buffer.length){oldBuffer=buffer;buffer=new Uint8Array(oldBuffer.byteLength+packet.data.byteLength);buffer.set(oldBuffer);buffer.set(packet.data,oldBuffer.byteLength);}else{buffer=packet.data;}// unpack any ADTS frames which have been fully received
// for details on the ADTS header, see http://wiki.multimedia.cx/index.php?title=ADTS
var skip;// We use i + 7 here because we want to be able to parse the entire header.
// If we don't have enough bytes to do that, then we definitely won't have a full frame.
while(i+7<buffer.length){// Look for the start of an ADTS header..
if(buffer[i]!==0xFF||(buffer[i+1]&0xF6)!==0xF0){if(typeof skip!=='number'){skip=i;}// If a valid header was not found,  jump one forward and attempt to
// find a valid ADTS header starting at the next byte
i++;continue;}if(typeof skip==='number'){this.skipWarn_(skip,i);skip=null;}// The protection skip bit tells us if we have 2 bytes of CRC data at the
// end of the ADTS header
protectionSkipBytes=(~buffer[i+1]&0x01)*2;// Frame length is a 13 bit integer starting 16 bits from the
// end of the sync sequence
// NOTE: frame length includes the size of the header
frameLength=(buffer[i+3]&0x03)<<11|buffer[i+4]<<3|(buffer[i+5]&0xe0)>>5;sampleCount=((buffer[i+6]&0x03)+1)*1024;adtsFrameDuration=sampleCount*ONE_SECOND_IN_TS$2/ADTS_SAMPLING_FREQUENCIES$1[(buffer[i+2]&0x3c)>>>2];// If we don't have enough data to actually finish this ADTS frame,
// then we have to wait for more data
if(buffer.byteLength-i<frameLength){break;}// Otherwise, deliver the complete AAC frame
this.trigger('data',{pts:packet.pts+frameNum*adtsFrameDuration,dts:packet.dts+frameNum*adtsFrameDuration,sampleCount:sampleCount,audioobjecttype:(buffer[i+2]>>>6&0x03)+1,channelcount:(buffer[i+2]&1)<<2|(buffer[i+3]&0xc0)>>>6,samplerate:ADTS_SAMPLING_FREQUENCIES$1[(buffer[i+2]&0x3c)>>>2],samplingfrequencyindex:(buffer[i+2]&0x3c)>>>2,// assume ISO/IEC 14496-12 AudioSampleEntry default of 16
samplesize:16,// data is the frame without it's header
data:buffer.subarray(i+7+protectionSkipBytes,i+frameLength)});frameNum++;i+=frameLength;}if(typeof skip==='number'){this.skipWarn_(skip,i);skip=null;}// remove processed bytes from the buffer.
buffer=buffer.subarray(i);};this.flush=function(){frameNum=0;this.trigger('done');};this.reset=function(){buffer=void 0;this.trigger('reset');};this.endTimeline=function(){buffer=void 0;this.trigger('endedtimeline');};};_AdtsStream.prototype=new stream();var adts=_AdtsStream;/**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */var ExpGolomb;/**
   * Parser for exponential Golomb codes, a variable-bitwidth number encoding
   * scheme used by h264.
   */ExpGolomb=function ExpGolomb(workingData){var// the number of bytes left to examine in workingData
workingBytesAvailable=workingData.byteLength,// the current word being examined
workingWord=0,// :uint
// the number of bits left to examine in the current word
workingBitsAvailable=0;// :uint;
// ():uint
this.length=function(){return 8*workingBytesAvailable;};// ():uint
this.bitsAvailable=function(){return 8*workingBytesAvailable+workingBitsAvailable;};// ():void
this.loadWord=function(){var position=workingData.byteLength-workingBytesAvailable,workingBytes=new Uint8Array(4),availableBytes=Math.min(4,workingBytesAvailable);if(availableBytes===0){throw new Error('no bytes available');}workingBytes.set(workingData.subarray(position,position+availableBytes));workingWord=new DataView(workingBytes.buffer).getUint32(0);// track the amount of workingData that has been processed
workingBitsAvailable=availableBytes*8;workingBytesAvailable-=availableBytes;};// (count:int):void
this.skipBits=function(count){var skipBytes;// :int
if(workingBitsAvailable>count){workingWord<<=count;workingBitsAvailable-=count;}else{count-=workingBitsAvailable;skipBytes=Math.floor(count/8);count-=skipBytes*8;workingBytesAvailable-=skipBytes;this.loadWord();workingWord<<=count;workingBitsAvailable-=count;}};// (size:int):uint
this.readBits=function(size){var bits=Math.min(workingBitsAvailable,size),// :uint
valu=workingWord>>>32-bits;// :uint
// if size > 31, handle error
workingBitsAvailable-=bits;if(workingBitsAvailable>0){workingWord<<=bits;}else if(workingBytesAvailable>0){this.loadWord();}bits=size-bits;if(bits>0){return valu<<bits|this.readBits(bits);}return valu;};// ():uint
this.skipLeadingZeros=function(){var leadingZeroCount;// :uint
for(leadingZeroCount=0;leadingZeroCount<workingBitsAvailable;++leadingZeroCount){if((workingWord&0x80000000>>>leadingZeroCount)!==0){// the first bit of working word is 1
workingWord<<=leadingZeroCount;workingBitsAvailable-=leadingZeroCount;return leadingZeroCount;}}// we exhausted workingWord and still have not found a 1
this.loadWord();return leadingZeroCount+this.skipLeadingZeros();};// ():void
this.skipUnsignedExpGolomb=function(){this.skipBits(1+this.skipLeadingZeros());};// ():void
this.skipExpGolomb=function(){this.skipBits(1+this.skipLeadingZeros());};// ():uint
this.readUnsignedExpGolomb=function(){var clz=this.skipLeadingZeros();// :uint
return this.readBits(clz+1)-1;};// ():int
this.readExpGolomb=function(){var valu=this.readUnsignedExpGolomb();// :int
if(0x01&valu){// the number is odd if the low order bit is set
return 1+valu>>>1;// add 1 to make it even, and divide by 2
}return-1*(valu>>>1);// divide by two then make it negative
};// Some convenience functions
// :Boolean
this.readBoolean=function(){return this.readBits(1)===1;};// ():int
this.readUnsignedByte=function(){return this.readBits(8);};this.loadWord();};var expGolomb=ExpGolomb;var _H264Stream,_NalByteStream;var PROFILES_WITH_OPTIONAL_SPS_DATA;/**
   * Accepts a NAL unit byte stream and unpacks the embedded NAL units.
   */_NalByteStream=function NalByteStream(){var syncPoint=0,i,buffer;_NalByteStream.prototype.init.call(this);/*
     * Scans a byte stream and triggers a data event with the NAL units found.
     * @param {Object} data Event received from H264Stream
     * @param {Uint8Array} data.data The h264 byte stream to be scanned
     *
     * @see H264Stream.push
     */this.push=function(data){var swapBuffer;if(!buffer){buffer=data.data;}else{swapBuffer=new Uint8Array(buffer.byteLength+data.data.byteLength);swapBuffer.set(buffer);swapBuffer.set(data.data,buffer.byteLength);buffer=swapBuffer;}var len=buffer.byteLength;// Rec. ITU-T H.264, Annex B
// scan for NAL unit boundaries
// a match looks like this:
// 0 0 1 .. NAL .. 0 0 1
// ^ sync point        ^ i
// or this:
// 0 0 1 .. NAL .. 0 0 0
// ^ sync point        ^ i
// advance the sync point to a NAL start, if necessary
for(;syncPoint<len-3;syncPoint++){if(buffer[syncPoint+2]===1){// the sync point is properly aligned
i=syncPoint+5;break;}}while(i<len){// look at the current byte to determine if we've hit the end of
// a NAL unit boundary
switch(buffer[i]){case 0:// skip past non-sync sequences
if(buffer[i-1]!==0){i+=2;break;}else if(buffer[i-2]!==0){i++;break;}// deliver the NAL unit if it isn't empty
if(syncPoint+3!==i-2){this.trigger('data',buffer.subarray(syncPoint+3,i-2));}// drop trailing zeroes
do{i++;}while(buffer[i]!==1&&i<len);syncPoint=i-2;i+=3;break;case 1:// skip past non-sync sequences
if(buffer[i-1]!==0||buffer[i-2]!==0){i+=3;break;}// deliver the NAL unit
this.trigger('data',buffer.subarray(syncPoint+3,i-2));syncPoint=i-2;i+=3;break;default:// the current byte isn't a one or zero, so it cannot be part
// of a sync sequence
i+=3;break;}}// filter out the NAL units that were delivered
buffer=buffer.subarray(syncPoint);i-=syncPoint;syncPoint=0;};this.reset=function(){buffer=null;syncPoint=0;this.trigger('reset');};this.flush=function(){// deliver the last buffered NAL unit
if(buffer&&buffer.byteLength>3){this.trigger('data',buffer.subarray(syncPoint+3));}// reset the stream state
buffer=null;syncPoint=0;this.trigger('done');};this.endTimeline=function(){this.flush();this.trigger('endedtimeline');};};_NalByteStream.prototype=new stream();// values of profile_idc that indicate additional fields are included in the SPS
// see Recommendation ITU-T H.264 (4/2013),
// 7.3.2.1.1 Sequence parameter set data syntax
PROFILES_WITH_OPTIONAL_SPS_DATA={100:true,110:true,122:true,244:true,44:true,83:true,86:true,118:true,128:true,// TODO: the three profiles below don't
// appear to have sps data in the specificiation anymore?
138:true,139:true,134:true};/**
   * Accepts input from a ElementaryStream and produces H.264 NAL unit data
   * events.
   */_H264Stream=function H264Stream(){var nalByteStream=new _NalByteStream(),self,trackId,currentPts,currentDts,discardEmulationPreventionBytes,readSequenceParameterSet,skipScalingList;_H264Stream.prototype.init.call(this);self=this;/*
     * Pushes a packet from a stream onto the NalByteStream
     *
     * @param {Object} packet - A packet received from a stream
     * @param {Uint8Array} packet.data - The raw bytes of the packet
     * @param {Number} packet.dts - Decode timestamp of the packet
     * @param {Number} packet.pts - Presentation timestamp of the packet
     * @param {Number} packet.trackId - The id of the h264 track this packet came from
     * @param {('video'|'audio')} packet.type - The type of packet
     *
     */this.push=function(packet){if(packet.type!=='video'){return;}trackId=packet.trackId;currentPts=packet.pts;currentDts=packet.dts;nalByteStream.push(packet);};/*
     * Identify NAL unit types and pass on the NALU, trackId, presentation and decode timestamps
     * for the NALUs to the next stream component.
     * Also, preprocess caption and sequence parameter NALUs.
     *
     * @param {Uint8Array} data - A NAL unit identified by `NalByteStream.push`
     * @see NalByteStream.push
     */nalByteStream.on('data',function(data){var event={trackId:trackId,pts:currentPts,dts:currentDts,data:data,nalUnitTypeCode:data[0]&0x1f};switch(event.nalUnitTypeCode){case 0x05:event.nalUnitType='slice_layer_without_partitioning_rbsp_idr';break;case 0x06:event.nalUnitType='sei_rbsp';event.escapedRBSP=discardEmulationPreventionBytes(data.subarray(1));break;case 0x07:event.nalUnitType='seq_parameter_set_rbsp';event.escapedRBSP=discardEmulationPreventionBytes(data.subarray(1));event.config=readSequenceParameterSet(event.escapedRBSP);break;case 0x08:event.nalUnitType='pic_parameter_set_rbsp';break;case 0x09:event.nalUnitType='access_unit_delimiter_rbsp';break;}// This triggers data on the H264Stream
self.trigger('data',event);});nalByteStream.on('done',function(){self.trigger('done');});nalByteStream.on('partialdone',function(){self.trigger('partialdone');});nalByteStream.on('reset',function(){self.trigger('reset');});nalByteStream.on('endedtimeline',function(){self.trigger('endedtimeline');});this.flush=function(){nalByteStream.flush();};this.partialFlush=function(){nalByteStream.partialFlush();};this.reset=function(){nalByteStream.reset();};this.endTimeline=function(){nalByteStream.endTimeline();};/**
     * Advance the ExpGolomb decoder past a scaling list. The scaling
     * list is optionally transmitted as part of a sequence parameter
     * set and is not relevant to transmuxing.
     * @param count {number} the number of entries in this scaling list
     * @param expGolombDecoder {object} an ExpGolomb pointed to the
     * start of a scaling list
     * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
     */skipScalingList=function skipScalingList(count,expGolombDecoder){var lastScale=8,nextScale=8,j,deltaScale;for(j=0;j<count;j++){if(nextScale!==0){deltaScale=expGolombDecoder.readExpGolomb();nextScale=(lastScale+deltaScale+256)%256;}lastScale=nextScale===0?lastScale:nextScale;}};/**
     * Expunge any "Emulation Prevention" bytes from a "Raw Byte
     * Sequence Payload"
     * @param data {Uint8Array} the bytes of a RBSP from a NAL
     * unit
     * @return {Uint8Array} the RBSP without any Emulation
     * Prevention Bytes
     */discardEmulationPreventionBytes=function discardEmulationPreventionBytes(data){var length=data.byteLength,emulationPreventionBytesPositions=[],i=1,newLength,newData;// Find all `Emulation Prevention Bytes`
while(i<length-2){if(data[i]===0&&data[i+1]===0&&data[i+2]===0x03){emulationPreventionBytesPositions.push(i+2);i+=2;}else{i++;}}// If no Emulation Prevention Bytes were found just return the original
// array
if(emulationPreventionBytesPositions.length===0){return data;}// Create a new array to hold the NAL unit data
newLength=length-emulationPreventionBytesPositions.length;newData=new Uint8Array(newLength);var sourceIndex=0;for(i=0;i<newLength;sourceIndex++,i++){if(sourceIndex===emulationPreventionBytesPositions[0]){// Skip this byte
sourceIndex++;// Remove this position index
emulationPreventionBytesPositions.shift();}newData[i]=data[sourceIndex];}return newData;};/**
     * Read a sequence parameter set and return some interesting video
     * properties. A sequence parameter set is the H264 metadata that
     * describes the properties of upcoming video frames.
     * @param data {Uint8Array} the bytes of a sequence parameter set
     * @return {object} an object with configuration parsed from the
     * sequence parameter set, including the dimensions of the
     * associated video frames.
     */readSequenceParameterSet=function readSequenceParameterSet(data){var frameCropLeftOffset=0,frameCropRightOffset=0,frameCropTopOffset=0,frameCropBottomOffset=0,expGolombDecoder,profileIdc,levelIdc,profileCompatibility,chromaFormatIdc,picOrderCntType,numRefFramesInPicOrderCntCycle,picWidthInMbsMinus1,picHeightInMapUnitsMinus1,frameMbsOnlyFlag,scalingListCount,sarRatio=[1,1],aspectRatioIdc,i;expGolombDecoder=new expGolomb(data);profileIdc=expGolombDecoder.readUnsignedByte();// profile_idc
profileCompatibility=expGolombDecoder.readUnsignedByte();// constraint_set[0-5]_flag
levelIdc=expGolombDecoder.readUnsignedByte();// level_idc u(8)
expGolombDecoder.skipUnsignedExpGolomb();// seq_parameter_set_id
// some profiles have more optional data we don't need
if(PROFILES_WITH_OPTIONAL_SPS_DATA[profileIdc]){chromaFormatIdc=expGolombDecoder.readUnsignedExpGolomb();if(chromaFormatIdc===3){expGolombDecoder.skipBits(1);// separate_colour_plane_flag
}expGolombDecoder.skipUnsignedExpGolomb();// bit_depth_luma_minus8
expGolombDecoder.skipUnsignedExpGolomb();// bit_depth_chroma_minus8
expGolombDecoder.skipBits(1);// qpprime_y_zero_transform_bypass_flag
if(expGolombDecoder.readBoolean()){// seq_scaling_matrix_present_flag
scalingListCount=chromaFormatIdc!==3?8:12;for(i=0;i<scalingListCount;i++){if(expGolombDecoder.readBoolean()){// seq_scaling_list_present_flag[ i ]
if(i<6){skipScalingList(16,expGolombDecoder);}else{skipScalingList(64,expGolombDecoder);}}}}}expGolombDecoder.skipUnsignedExpGolomb();// log2_max_frame_num_minus4
picOrderCntType=expGolombDecoder.readUnsignedExpGolomb();if(picOrderCntType===0){expGolombDecoder.readUnsignedExpGolomb();// log2_max_pic_order_cnt_lsb_minus4
}else if(picOrderCntType===1){expGolombDecoder.skipBits(1);// delta_pic_order_always_zero_flag
expGolombDecoder.skipExpGolomb();// offset_for_non_ref_pic
expGolombDecoder.skipExpGolomb();// offset_for_top_to_bottom_field
numRefFramesInPicOrderCntCycle=expGolombDecoder.readUnsignedExpGolomb();for(i=0;i<numRefFramesInPicOrderCntCycle;i++){expGolombDecoder.skipExpGolomb();// offset_for_ref_frame[ i ]
}}expGolombDecoder.skipUnsignedExpGolomb();// max_num_ref_frames
expGolombDecoder.skipBits(1);// gaps_in_frame_num_value_allowed_flag
picWidthInMbsMinus1=expGolombDecoder.readUnsignedExpGolomb();picHeightInMapUnitsMinus1=expGolombDecoder.readUnsignedExpGolomb();frameMbsOnlyFlag=expGolombDecoder.readBits(1);if(frameMbsOnlyFlag===0){expGolombDecoder.skipBits(1);// mb_adaptive_frame_field_flag
}expGolombDecoder.skipBits(1);// direct_8x8_inference_flag
if(expGolombDecoder.readBoolean()){// frame_cropping_flag
frameCropLeftOffset=expGolombDecoder.readUnsignedExpGolomb();frameCropRightOffset=expGolombDecoder.readUnsignedExpGolomb();frameCropTopOffset=expGolombDecoder.readUnsignedExpGolomb();frameCropBottomOffset=expGolombDecoder.readUnsignedExpGolomb();}if(expGolombDecoder.readBoolean()){// vui_parameters_present_flag
if(expGolombDecoder.readBoolean()){// aspect_ratio_info_present_flag
aspectRatioIdc=expGolombDecoder.readUnsignedByte();switch(aspectRatioIdc){case 1:sarRatio=[1,1];break;case 2:sarRatio=[12,11];break;case 3:sarRatio=[10,11];break;case 4:sarRatio=[16,11];break;case 5:sarRatio=[40,33];break;case 6:sarRatio=[24,11];break;case 7:sarRatio=[20,11];break;case 8:sarRatio=[32,11];break;case 9:sarRatio=[80,33];break;case 10:sarRatio=[18,11];break;case 11:sarRatio=[15,11];break;case 12:sarRatio=[64,33];break;case 13:sarRatio=[160,99];break;case 14:sarRatio=[4,3];break;case 15:sarRatio=[3,2];break;case 16:sarRatio=[2,1];break;case 255:{sarRatio=[expGolombDecoder.readUnsignedByte()<<8|expGolombDecoder.readUnsignedByte(),expGolombDecoder.readUnsignedByte()<<8|expGolombDecoder.readUnsignedByte()];break;}}if(sarRatio){sarRatio[0]/sarRatio[1];}}}return{profileIdc:profileIdc,levelIdc:levelIdc,profileCompatibility:profileCompatibility,width:(picWidthInMbsMinus1+1)*16-frameCropLeftOffset*2-frameCropRightOffset*2,height:(2-frameMbsOnlyFlag)*(picHeightInMapUnitsMinus1+1)*16-frameCropTopOffset*2-frameCropBottomOffset*2,// sar is sample aspect ratio
sarRatio:sarRatio};};};_H264Stream.prototype=new stream();var h264={H264Stream:_H264Stream,NalByteStream:_NalByteStream};/**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Utilities to detect basic properties and metadata about Aac data.
   */var ADTS_SAMPLING_FREQUENCIES=[96000,88200,64000,48000,44100,32000,24000,22050,16000,12000,11025,8000,7350];var parseId3TagSize=function parseId3TagSize(header,byteIndex){var returnSize=header[byteIndex+6]<<21|header[byteIndex+7]<<14|header[byteIndex+8]<<7|header[byteIndex+9],flags=header[byteIndex+5],footerPresent=(flags&16)>>4;// if we get a negative returnSize clamp it to 0
returnSize=returnSize>=0?returnSize:0;if(footerPresent){return returnSize+20;}return returnSize+10;};var getId3Offset=function getId3Offset(data,offset){if(data.length-offset<10||data[offset]!=='I'.charCodeAt(0)||data[offset+1]!=='D'.charCodeAt(0)||data[offset+2]!=='3'.charCodeAt(0)){return offset;}offset+=parseId3TagSize(data,offset);return getId3Offset(data,offset);};// TODO: use vhs-utils
var isLikelyAacData$1=function isLikelyAacData(data){var offset=getId3Offset(data,0);return data.length>=offset+2&&(data[offset]&0xFF)===0xFF&&(data[offset+1]&0xF0)===0xF0&&// verify that the 2 layer bits are 0, aka this
// is not mp3 data but aac data.
(data[offset+1]&0x16)===0x10;};var parseSyncSafeInteger=function parseSyncSafeInteger(data){return data[0]<<21|data[1]<<14|data[2]<<7|data[3];};// return a percent-encoded representation of the specified byte range
// @see http://en.wikipedia.org/wiki/Percent-encoding
var percentEncode=function percentEncode(bytes,start,end){var i,result='';for(i=start;i<end;i++){result+='%'+('00'+bytes[i].toString(16)).slice(-2);}return result;};// return the string representation of the specified byte range,
// interpreted as ISO-8859-1.
var parseIso88591=function parseIso88591(bytes,start,end){return unescape(percentEncode(bytes,start,end));// jshint ignore:line
};var parseAdtsSize=function parseAdtsSize(header,byteIndex){var lowThree=(header[byteIndex+5]&0xE0)>>5,middle=header[byteIndex+4]<<3,highTwo=header[byteIndex+3]&0x3<<11;return highTwo|middle|lowThree;};var parseType$2=function parseType(header,byteIndex){if(header[byteIndex]==='I'.charCodeAt(0)&&header[byteIndex+1]==='D'.charCodeAt(0)&&header[byteIndex+2]==='3'.charCodeAt(0)){return'timed-metadata';}else if(header[byteIndex]&0xff===0xff&&(header[byteIndex+1]&0xf0)===0xf0){return'audio';}return null;};var parseSampleRate=function parseSampleRate(packet){var i=0;while(i+5<packet.length){if(packet[i]!==0xFF||(packet[i+1]&0xF6)!==0xF0){// If a valid header was not found,  jump one forward and attempt to
// find a valid ADTS header starting at the next byte
i++;continue;}return ADTS_SAMPLING_FREQUENCIES[(packet[i+2]&0x3c)>>>2];}return null;};var parseAacTimestamp=function parseAacTimestamp(packet){var frameStart,frameSize,frame,frameHeader;// find the start of the first frame and the end of the tag
frameStart=10;if(packet[5]&0x40){// advance the frame start past the extended header
frameStart+=4;// header size field
frameStart+=parseSyncSafeInteger(packet.subarray(10,14));}// parse one or more ID3 frames
// http://id3.org/id3v2.3.0#ID3v2_frame_overview
do{// determine the number of bytes in this frame
frameSize=parseSyncSafeInteger(packet.subarray(frameStart+4,frameStart+8));if(frameSize<1){return null;}frameHeader=String.fromCharCode(packet[frameStart],packet[frameStart+1],packet[frameStart+2],packet[frameStart+3]);if(frameHeader==='PRIV'){frame=packet.subarray(frameStart+10,frameStart+frameSize+10);for(var i=0;i<frame.byteLength;i++){if(frame[i]===0){var owner=parseIso88591(frame,0,i);if(owner==='com.apple.streaming.transportStreamTimestamp'){var d=frame.subarray(i+1);var size=(d[3]&0x01)<<30|d[4]<<22|d[5]<<14|d[6]<<6|d[7]>>>2;size*=4;size+=d[7]&0x03;return size;}break;}}}frameStart+=10;// advance past the frame header
frameStart+=frameSize;// advance past the frame body
}while(frameStart<packet.byteLength);return null;};var utils={isLikelyAacData:isLikelyAacData$1,parseId3TagSize:parseId3TagSize,parseAdtsSize:parseAdtsSize,parseType:parseType$2,parseSampleRate:parseSampleRate,parseAacTimestamp:parseAacTimestamp};var _AacStream;/**
   * Splits an incoming stream of binary data into ADTS and ID3 Frames.
   */_AacStream=function AacStream(){var everything=new Uint8Array(),timeStamp=0;_AacStream.prototype.init.call(this);this.setTimestamp=function(timestamp){timeStamp=timestamp;};this.push=function(bytes){var frameSize=0,byteIndex=0,bytesLeft,chunk,packet,tempLength;// If there are bytes remaining from the last segment, prepend them to the
// bytes that were pushed in
if(everything.length){tempLength=everything.length;everything=new Uint8Array(bytes.byteLength+tempLength);everything.set(everything.subarray(0,tempLength));everything.set(bytes,tempLength);}else{everything=bytes;}while(everything.length-byteIndex>=3){if(everything[byteIndex]==='I'.charCodeAt(0)&&everything[byteIndex+1]==='D'.charCodeAt(0)&&everything[byteIndex+2]==='3'.charCodeAt(0)){// Exit early because we don't have enough to parse
// the ID3 tag header
if(everything.length-byteIndex<10){break;}// check framesize
frameSize=utils.parseId3TagSize(everything,byteIndex);// Exit early if we don't have enough in the buffer
// to emit a full packet
// Add to byteIndex to support multiple ID3 tags in sequence
if(byteIndex+frameSize>everything.length){break;}chunk={type:'timed-metadata',data:everything.subarray(byteIndex,byteIndex+frameSize)};this.trigger('data',chunk);byteIndex+=frameSize;continue;}else if((everything[byteIndex]&0xff)===0xff&&(everything[byteIndex+1]&0xf0)===0xf0){// Exit early because we don't have enough to parse
// the ADTS frame header
if(everything.length-byteIndex<7){break;}frameSize=utils.parseAdtsSize(everything,byteIndex);// Exit early if we don't have enough in the buffer
// to emit a full packet
if(byteIndex+frameSize>everything.length){break;}packet={type:'audio',data:everything.subarray(byteIndex,byteIndex+frameSize),pts:timeStamp,dts:timeStamp};this.trigger('data',packet);byteIndex+=frameSize;continue;}byteIndex++;}bytesLeft=everything.length-byteIndex;if(bytesLeft>0){everything=everything.subarray(byteIndex);}else{everything=new Uint8Array();}};this.reset=function(){everything=new Uint8Array();this.trigger('reset');};this.endTimeline=function(){everything=new Uint8Array();this.trigger('endedtimeline');};};_AacStream.prototype=new stream();var aac=_AacStream;// constants
var AUDIO_PROPERTIES=['audioobjecttype','channelcount','samplerate','samplingfrequencyindex','samplesize'];var audioProperties=AUDIO_PROPERTIES;var VIDEO_PROPERTIES=['width','height','profileIdc','levelIdc','profileCompatibility','sarRatio'];var videoProperties=VIDEO_PROPERTIES;var H264Stream=h264.H264Stream;var isLikelyAacData=utils.isLikelyAacData;var ONE_SECOND_IN_TS$1=clock.ONE_SECOND_IN_TS;// object types
var _VideoSegmentStream,_AudioSegmentStream,_Transmuxer,_CoalesceStream;var retriggerForStream=function retriggerForStream(key,event){event.stream=key;this.trigger('log',event);};var addPipelineLogRetriggers=function addPipelineLogRetriggers(transmuxer,pipeline){var keys=Object.keys(pipeline);for(var i=0;i<keys.length;i++){var key=keys[i];// skip non-stream keys and headOfPipeline
// which is just a duplicate
if(key==='headOfPipeline'||!pipeline[key].on){continue;}pipeline[key].on('log',retriggerForStream.bind(transmuxer,key));}};/**
   * Compare two arrays (even typed) for same-ness
   */var arrayEquals=function arrayEquals(a,b){var i;if(a.length!==b.length){return false;}// compare the value of each element in the array
for(i=0;i<a.length;i++){if(a[i]!==b[i]){return false;}}return true;};var generateSegmentTimingInfo=function generateSegmentTimingInfo(baseMediaDecodeTime,startDts,startPts,endDts,endPts,prependedContentDuration){var ptsOffsetFromDts=startPts-startDts,decodeDuration=endDts-startDts,presentationDuration=endPts-startPts;// The PTS and DTS values are based on the actual stream times from the segment,
// however, the player time values will reflect a start from the baseMediaDecodeTime.
// In order to provide relevant values for the player times, base timing info on the
// baseMediaDecodeTime and the DTS and PTS durations of the segment.
return{start:{dts:baseMediaDecodeTime,pts:baseMediaDecodeTime+ptsOffsetFromDts},end:{dts:baseMediaDecodeTime+decodeDuration,pts:baseMediaDecodeTime+presentationDuration},prependedContentDuration:prependedContentDuration,baseMediaDecodeTime:baseMediaDecodeTime};};/**
   * Constructs a single-track, ISO BMFF media segment from AAC data
   * events. The output of this stream can be fed to a SourceBuffer
   * configured with a suitable initialization segment.
   * @param track {object} track metadata configuration
   * @param options {object} transmuxer options object
   * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
   *        in the source; false to adjust the first segment to start at 0.
   */_AudioSegmentStream=function AudioSegmentStream(track,options){var adtsFrames=[],sequenceNumber,earliestAllowedDts=0,audioAppendStartTs=0,videoBaseMediaDecodeTime=Infinity;options=options||{};sequenceNumber=options.firstSequenceNumber||0;_AudioSegmentStream.prototype.init.call(this);this.push=function(data){trackDecodeInfo.collectDtsInfo(track,data);if(track){audioProperties.forEach(function(prop){track[prop]=data[prop];});}// buffer audio data until end() is called
adtsFrames.push(data);};this.setEarliestDts=function(earliestDts){earliestAllowedDts=earliestDts;};this.setVideoBaseMediaDecodeTime=function(baseMediaDecodeTime){videoBaseMediaDecodeTime=baseMediaDecodeTime;};this.setAudioAppendStart=function(timestamp){audioAppendStartTs=timestamp;};this.flush=function(){var frames,moof,mdat,boxes,frameDuration,segmentDuration,videoClockCyclesOfSilencePrefixed;// return early if no audio data has been observed
if(adtsFrames.length===0){this.trigger('done','AudioSegmentStream');return;}frames=audioFrameUtils.trimAdtsFramesByEarliestDts(adtsFrames,track,earliestAllowedDts);track.baseMediaDecodeTime=trackDecodeInfo.calculateTrackBaseMediaDecodeTime(track,options.keepOriginalTimestamps);// amount of audio filled but the value is in video clock rather than audio clock
videoClockCyclesOfSilencePrefixed=audioFrameUtils.prefixWithSilence(track,frames,audioAppendStartTs,videoBaseMediaDecodeTime);// we have to build the index from byte locations to
// samples (that is, adts frames) in the audio data
track.samples=audioFrameUtils.generateSampleTable(frames);// concatenate the audio data to constuct the mdat
mdat=mp4Generator.mdat(audioFrameUtils.concatenateFrameData(frames));adtsFrames=[];moof=mp4Generator.moof(sequenceNumber,[track]);boxes=new Uint8Array(moof.byteLength+mdat.byteLength);// bump the sequence number for next time
sequenceNumber++;boxes.set(moof);boxes.set(mdat,moof.byteLength);trackDecodeInfo.clearDtsInfo(track);frameDuration=Math.ceil(ONE_SECOND_IN_TS$1*1024/track.samplerate);// TODO this check was added to maintain backwards compatibility (particularly with
// tests) on adding the timingInfo event. However, it seems unlikely that there's a
// valid use-case where an init segment/data should be triggered without associated
// frames. Leaving for now, but should be looked into.
if(frames.length){segmentDuration=frames.length*frameDuration;this.trigger('segmentTimingInfo',generateSegmentTimingInfo(// The audio track's baseMediaDecodeTime is in audio clock cycles, but the
// frame info is in video clock cycles. Convert to match expectation of
// listeners (that all timestamps will be based on video clock cycles).
clock.audioTsToVideoTs(track.baseMediaDecodeTime,track.samplerate),// frame times are already in video clock, as is segment duration
frames[0].dts,frames[0].pts,frames[0].dts+segmentDuration,frames[0].pts+segmentDuration,videoClockCyclesOfSilencePrefixed||0));this.trigger('timingInfo',{start:frames[0].pts,end:frames[0].pts+segmentDuration});}this.trigger('data',{track:track,boxes:boxes});this.trigger('done','AudioSegmentStream');};this.reset=function(){trackDecodeInfo.clearDtsInfo(track);adtsFrames=[];this.trigger('reset');};};_AudioSegmentStream.prototype=new stream();/**
   * Constructs a single-track, ISO BMFF media segment from H264 data
   * events. The output of this stream can be fed to a SourceBuffer
   * configured with a suitable initialization segment.
   * @param track {object} track metadata configuration
   * @param options {object} transmuxer options object
   * @param options.alignGopsAtEnd {boolean} If true, start from the end of the
   *        gopsToAlignWith list when attempting to align gop pts
   * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
   *        in the source; false to adjust the first segment to start at 0.
   */_VideoSegmentStream=function VideoSegmentStream(track,options){var sequenceNumber,nalUnits=[],gopsToAlignWith=[],config,pps;options=options||{};sequenceNumber=options.firstSequenceNumber||0;_VideoSegmentStream.prototype.init.call(this);delete track.minPTS;this.gopCache_=[];/**
      * Constructs a ISO BMFF segment given H264 nalUnits
      * @param {Object} nalUnit A data event representing a nalUnit
      * @param {String} nalUnit.nalUnitType
      * @param {Object} nalUnit.config Properties for a mp4 track
      * @param {Uint8Array} nalUnit.data The nalUnit bytes
      * @see lib/codecs/h264.js
     **/this.push=function(nalUnit){trackDecodeInfo.collectDtsInfo(track,nalUnit);// record the track config
if(nalUnit.nalUnitType==='seq_parameter_set_rbsp'&&!config){config=nalUnit.config;track.sps=[nalUnit.data];videoProperties.forEach(function(prop){track[prop]=config[prop];},this);}if(nalUnit.nalUnitType==='pic_parameter_set_rbsp'&&!pps){pps=nalUnit.data;track.pps=[nalUnit.data];}// buffer video until flush() is called
nalUnits.push(nalUnit);};/**
      * Pass constructed ISO BMFF track and boxes on to the
      * next stream in the pipeline
     **/this.flush=function(){var frames,gopForFusion,gops,moof,mdat,boxes,prependedContentDuration=0,firstGop,lastGop;// Throw away nalUnits at the start of the byte stream until
// we find the first AUD
while(nalUnits.length){if(nalUnits[0].nalUnitType==='access_unit_delimiter_rbsp'){break;}nalUnits.shift();}// Return early if no video data has been observed
if(nalUnits.length===0){this.resetStream_();this.trigger('done','VideoSegmentStream');return;}// Organize the raw nal-units into arrays that represent
// higher-level constructs such as frames and gops
// (group-of-pictures)
frames=frameUtils.groupNalsIntoFrames(nalUnits);gops=frameUtils.groupFramesIntoGops(frames);// If the first frame of this fragment is not a keyframe we have
// a problem since MSE (on Chrome) requires a leading keyframe.
//
// We have two approaches to repairing this situation:
// 1) GOP-FUSION:
//    This is where we keep track of the GOPS (group-of-pictures)
//    from previous fragments and attempt to find one that we can
//    prepend to the current fragment in order to create a valid
//    fragment.
// 2) KEYFRAME-PULLING:
//    Here we search for the first keyframe in the fragment and
//    throw away all the frames between the start of the fragment
//    and that keyframe. We then extend the duration and pull the
//    PTS of the keyframe forward so that it covers the time range
//    of the frames that were disposed of.
//
// #1 is far prefereable over #2 which can cause "stuttering" but
// requires more things to be just right.
if(!gops[0][0].keyFrame){// Search for a gop for fusion from our gopCache
gopForFusion=this.getGopForFusion_(nalUnits[0],track);if(gopForFusion){// in order to provide more accurate timing information about the segment, save
// the number of seconds prepended to the original segment due to GOP fusion
prependedContentDuration=gopForFusion.duration;gops.unshift(gopForFusion);// Adjust Gops' metadata to account for the inclusion of the
// new gop at the beginning
gops.byteLength+=gopForFusion.byteLength;gops.nalCount+=gopForFusion.nalCount;gops.pts=gopForFusion.pts;gops.dts=gopForFusion.dts;gops.duration+=gopForFusion.duration;}else{// If we didn't find a candidate gop fall back to keyframe-pulling
gops=frameUtils.extendFirstKeyFrame(gops);}}// Trim gops to align with gopsToAlignWith
if(gopsToAlignWith.length){var alignedGops;if(options.alignGopsAtEnd){alignedGops=this.alignGopsAtEnd_(gops);}else{alignedGops=this.alignGopsAtStart_(gops);}if(!alignedGops){// save all the nals in the last GOP into the gop cache
this.gopCache_.unshift({gop:gops.pop(),pps:track.pps,sps:track.sps});// Keep a maximum of 6 GOPs in the cache
this.gopCache_.length=Math.min(6,this.gopCache_.length);// Clear nalUnits
nalUnits=[];// return early no gops can be aligned with desired gopsToAlignWith
this.resetStream_();this.trigger('done','VideoSegmentStream');return;}// Some gops were trimmed. clear dts info so minSegmentDts and pts are correct
// when recalculated before sending off to CoalesceStream
trackDecodeInfo.clearDtsInfo(track);gops=alignedGops;}trackDecodeInfo.collectDtsInfo(track,gops);// First, we have to build the index from byte locations to
// samples (that is, frames) in the video data
track.samples=frameUtils.generateSampleTable(gops);// Concatenate the video data and construct the mdat
mdat=mp4Generator.mdat(frameUtils.concatenateNalData(gops));track.baseMediaDecodeTime=trackDecodeInfo.calculateTrackBaseMediaDecodeTime(track,options.keepOriginalTimestamps);this.trigger('processedGopsInfo',gops.map(function(gop){return{pts:gop.pts,dts:gop.dts,byteLength:gop.byteLength};}));firstGop=gops[0];lastGop=gops[gops.length-1];this.trigger('segmentTimingInfo',generateSegmentTimingInfo(track.baseMediaDecodeTime,firstGop.dts,firstGop.pts,lastGop.dts+lastGop.duration,lastGop.pts+lastGop.duration,prependedContentDuration));this.trigger('timingInfo',{start:gops[0].pts,end:gops[gops.length-1].pts+gops[gops.length-1].duration});// save all the nals in the last GOP into the gop cache
this.gopCache_.unshift({gop:gops.pop(),pps:track.pps,sps:track.sps});// Keep a maximum of 6 GOPs in the cache
this.gopCache_.length=Math.min(6,this.gopCache_.length);// Clear nalUnits
nalUnits=[];this.trigger('baseMediaDecodeTime',track.baseMediaDecodeTime);this.trigger('timelineStartInfo',track.timelineStartInfo);moof=mp4Generator.moof(sequenceNumber,[track]);// it would be great to allocate this array up front instead of
// throwing away hundreds of media segment fragments
boxes=new Uint8Array(moof.byteLength+mdat.byteLength);// Bump the sequence number for next time
sequenceNumber++;boxes.set(moof);boxes.set(mdat,moof.byteLength);this.trigger('data',{track:track,boxes:boxes});this.resetStream_();// Continue with the flush process now
this.trigger('done','VideoSegmentStream');};this.reset=function(){this.resetStream_();nalUnits=[];this.gopCache_.length=0;gopsToAlignWith.length=0;this.trigger('reset');};this.resetStream_=function(){trackDecodeInfo.clearDtsInfo(track);// reset config and pps because they may differ across segments
// for instance, when we are rendition switching
config=undefined;pps=undefined;};// Search for a candidate Gop for gop-fusion from the gop cache and
// return it or return null if no good candidate was found
this.getGopForFusion_=function(nalUnit){var halfSecond=45000,// Half-a-second in a 90khz clock
allowableOverlap=10000,// About 3 frames @ 30fps
nearestDistance=Infinity,dtsDistance,nearestGopObj,currentGop,currentGopObj,i;// Search for the GOP nearest to the beginning of this nal unit
for(i=0;i<this.gopCache_.length;i++){currentGopObj=this.gopCache_[i];currentGop=currentGopObj.gop;// Reject Gops with different SPS or PPS
if(!(track.pps&&arrayEquals(track.pps[0],currentGopObj.pps[0]))||!(track.sps&&arrayEquals(track.sps[0],currentGopObj.sps[0]))){continue;}// Reject Gops that would require a negative baseMediaDecodeTime
if(currentGop.dts<track.timelineStartInfo.dts){continue;}// The distance between the end of the gop and the start of the nalUnit
dtsDistance=nalUnit.dts-currentGop.dts-currentGop.duration;// Only consider GOPS that start before the nal unit and end within
// a half-second of the nal unit
if(dtsDistance>=-allowableOverlap&&dtsDistance<=halfSecond){// Always use the closest GOP we found if there is more than
// one candidate
if(!nearestGopObj||nearestDistance>dtsDistance){nearestGopObj=currentGopObj;nearestDistance=dtsDistance;}}}if(nearestGopObj){return nearestGopObj.gop;}return null;};// trim gop list to the first gop found that has a matching pts with a gop in the list
// of gopsToAlignWith starting from the START of the list
this.alignGopsAtStart_=function(gops){var alignIndex,gopIndex,align,gop,byteLength,nalCount,duration,alignedGops;byteLength=gops.byteLength;nalCount=gops.nalCount;duration=gops.duration;alignIndex=gopIndex=0;while(alignIndex<gopsToAlignWith.length&&gopIndex<gops.length){align=gopsToAlignWith[alignIndex];gop=gops[gopIndex];if(align.pts===gop.pts){break;}if(gop.pts>align.pts){// this current gop starts after the current gop we want to align on, so increment
// align index
alignIndex++;continue;}// current gop starts before the current gop we want to align on. so increment gop
// index
gopIndex++;byteLength-=gop.byteLength;nalCount-=gop.nalCount;duration-=gop.duration;}if(gopIndex===0){// no gops to trim
return gops;}if(gopIndex===gops.length){// all gops trimmed, skip appending all gops
return null;}alignedGops=gops.slice(gopIndex);alignedGops.byteLength=byteLength;alignedGops.duration=duration;alignedGops.nalCount=nalCount;alignedGops.pts=alignedGops[0].pts;alignedGops.dts=alignedGops[0].dts;return alignedGops;};// trim gop list to the first gop found that has a matching pts with a gop in the list
// of gopsToAlignWith starting from the END of the list
this.alignGopsAtEnd_=function(gops){var alignIndex,gopIndex,align,gop,alignEndIndex,matchFound;alignIndex=gopsToAlignWith.length-1;gopIndex=gops.length-1;alignEndIndex=null;matchFound=false;while(alignIndex>=0&&gopIndex>=0){align=gopsToAlignWith[alignIndex];gop=gops[gopIndex];if(align.pts===gop.pts){matchFound=true;break;}if(align.pts>gop.pts){alignIndex--;continue;}if(alignIndex===gopsToAlignWith.length-1){// gop.pts is greater than the last alignment candidate. If no match is found
// by the end of this loop, we still want to append gops that come after this
// point
alignEndIndex=gopIndex;}gopIndex--;}if(!matchFound&&alignEndIndex===null){return null;}var trimIndex;if(matchFound){trimIndex=gopIndex;}else{trimIndex=alignEndIndex;}if(trimIndex===0){return gops;}var alignedGops=gops.slice(trimIndex);var metadata=alignedGops.reduce(function(total,gop){total.byteLength+=gop.byteLength;total.duration+=gop.duration;total.nalCount+=gop.nalCount;return total;},{byteLength:0,duration:0,nalCount:0});alignedGops.byteLength=metadata.byteLength;alignedGops.duration=metadata.duration;alignedGops.nalCount=metadata.nalCount;alignedGops.pts=alignedGops[0].pts;alignedGops.dts=alignedGops[0].dts;return alignedGops;};this.alignGopsWith=function(newGopsToAlignWith){gopsToAlignWith=newGopsToAlignWith;};};_VideoSegmentStream.prototype=new stream();/**
   * A Stream that can combine multiple streams (ie. audio & video)
   * into a single output segment for MSE. Also supports audio-only
   * and video-only streams.
   * @param options {object} transmuxer options object
   * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
   *        in the source; false to adjust the first segment to start at media timeline start.
   */_CoalesceStream=function CoalesceStream(options,metadataStream){// Number of Tracks per output segment
// If greater than 1, we combine multiple
// tracks into a single segment
this.numberOfTracks=0;this.metadataStream=metadataStream;options=options||{};if(typeof options.remux!=='undefined'){this.remuxTracks=!!options.remux;}else{this.remuxTracks=true;}if(typeof options.keepOriginalTimestamps==='boolean'){this.keepOriginalTimestamps=options.keepOriginalTimestamps;}else{this.keepOriginalTimestamps=false;}this.pendingTracks=[];this.videoTrack=null;this.pendingBoxes=[];this.pendingCaptions=[];this.pendingMetadata=[];this.pendingBytes=0;this.emittedTracks=0;_CoalesceStream.prototype.init.call(this);// Take output from multiple
this.push=function(output){// buffer incoming captions until the associated video segment
// finishes
if(output.text){return this.pendingCaptions.push(output);}// buffer incoming id3 tags until the final flush
if(output.frames){return this.pendingMetadata.push(output);}// Add this track to the list of pending tracks and store
// important information required for the construction of
// the final segment
this.pendingTracks.push(output.track);this.pendingBytes+=output.boxes.byteLength;// TODO: is there an issue for this against chrome?
// We unshift audio and push video because
// as of Chrome 75 when switching from
// one init segment to another if the video
// mdat does not appear after the audio mdat
// only audio will play for the duration of our transmux.
if(output.track.type==='video'){this.videoTrack=output.track;this.pendingBoxes.push(output.boxes);}if(output.track.type==='audio'){this.audioTrack=output.track;this.pendingBoxes.unshift(output.boxes);}};};_CoalesceStream.prototype=new stream();_CoalesceStream.prototype.flush=function(flushSource){var offset=0,event={captions:[],captionStreams:{},metadata:[],info:{}},caption,id3,initSegment,timelineStartPts=0,i;if(this.pendingTracks.length<this.numberOfTracks){if(flushSource!=='VideoSegmentStream'&&flushSource!=='AudioSegmentStream'){// Return because we haven't received a flush from a data-generating
// portion of the segment (meaning that we have only recieved meta-data
// or captions.)
return;}else if(this.remuxTracks){// Return until we have enough tracks from the pipeline to remux (if we
// are remuxing audio and video into a single MP4)
return;}else if(this.pendingTracks.length===0){// In the case where we receive a flush without any data having been
// received we consider it an emitted track for the purposes of coalescing
// `done` events.
// We do this for the case where there is an audio and video track in the
// segment but no audio data. (seen in several playlists with alternate
// audio tracks and no audio present in the main TS segments.)
this.emittedTracks++;if(this.emittedTracks>=this.numberOfTracks){this.trigger('done');this.emittedTracks=0;}return;}}if(this.videoTrack){timelineStartPts=this.videoTrack.timelineStartInfo.pts;videoProperties.forEach(function(prop){event.info[prop]=this.videoTrack[prop];},this);}else if(this.audioTrack){timelineStartPts=this.audioTrack.timelineStartInfo.pts;audioProperties.forEach(function(prop){event.info[prop]=this.audioTrack[prop];},this);}if(this.videoTrack||this.audioTrack){if(this.pendingTracks.length===1){event.type=this.pendingTracks[0].type;}else{event.type='combined';}this.emittedTracks+=this.pendingTracks.length;initSegment=mp4Generator.initSegment(this.pendingTracks);// Create a new typed array to hold the init segment
event.initSegment=new Uint8Array(initSegment.byteLength);// Create an init segment containing a moov
// and track definitions
event.initSegment.set(initSegment);// Create a new typed array to hold the moof+mdats
event.data=new Uint8Array(this.pendingBytes);// Append each moof+mdat (one per track) together
for(i=0;i<this.pendingBoxes.length;i++){event.data.set(this.pendingBoxes[i],offset);offset+=this.pendingBoxes[i].byteLength;}// Translate caption PTS times into second offsets to match the
// video timeline for the segment, and add track info
for(i=0;i<this.pendingCaptions.length;i++){caption=this.pendingCaptions[i];caption.startTime=clock.metadataTsToSeconds(caption.startPts,timelineStartPts,this.keepOriginalTimestamps);caption.endTime=clock.metadataTsToSeconds(caption.endPts,timelineStartPts,this.keepOriginalTimestamps);event.captionStreams[caption.stream]=true;event.captions.push(caption);}// Translate ID3 frame PTS times into second offsets to match the
// video timeline for the segment
for(i=0;i<this.pendingMetadata.length;i++){id3=this.pendingMetadata[i];id3.cueTime=clock.metadataTsToSeconds(id3.pts,timelineStartPts,this.keepOriginalTimestamps);event.metadata.push(id3);}// We add this to every single emitted segment even though we only need
// it for the first
event.metadata.dispatchType=this.metadataStream.dispatchType;// Reset stream state
this.pendingTracks.length=0;this.videoTrack=null;this.pendingBoxes.length=0;this.pendingCaptions.length=0;this.pendingBytes=0;this.pendingMetadata.length=0;// Emit the built segment
// We include captions and ID3 tags for backwards compatibility,
// ideally we should send only video and audio in the data event
this.trigger('data',event);// Emit each caption to the outside world
// Ideally, this would happen immediately on parsing captions,
// but we need to ensure that video data is sent back first
// so that caption timing can be adjusted to match video timing
for(i=0;i<event.captions.length;i++){caption=event.captions[i];this.trigger('caption',caption);}// Emit each id3 tag to the outside world
// Ideally, this would happen immediately on parsing the tag,
// but we need to ensure that video data is sent back first
// so that ID3 frame timing can be adjusted to match video timing
for(i=0;i<event.metadata.length;i++){id3=event.metadata[i];this.trigger('id3Frame',id3);}}// Only emit `done` if all tracks have been flushed and emitted
if(this.emittedTracks>=this.numberOfTracks){this.trigger('done');this.emittedTracks=0;}};_CoalesceStream.prototype.setRemux=function(val){this.remuxTracks=val;};/**
   * A Stream that expects MP2T binary data as input and produces
   * corresponding media segments, suitable for use with Media Source
   * Extension (MSE) implementations that support the ISO BMFF byte
   * stream format, like Chrome.
   */_Transmuxer=function Transmuxer(options){var self=this,hasFlushed=true,videoTrack,audioTrack;_Transmuxer.prototype.init.call(this);options=options||{};this.baseMediaDecodeTime=options.baseMediaDecodeTime||0;this.transmuxPipeline_={};this.setupAacPipeline=function(){var pipeline={};this.transmuxPipeline_=pipeline;pipeline.type='aac';pipeline.metadataStream=new m2ts_1.MetadataStream();// set up the parsing pipeline
pipeline.aacStream=new aac();pipeline.audioTimestampRolloverStream=new m2ts_1.TimestampRolloverStream('audio');pipeline.timedMetadataTimestampRolloverStream=new m2ts_1.TimestampRolloverStream('timed-metadata');pipeline.adtsStream=new adts();pipeline.coalesceStream=new _CoalesceStream(options,pipeline.metadataStream);pipeline.headOfPipeline=pipeline.aacStream;pipeline.aacStream.pipe(pipeline.audioTimestampRolloverStream).pipe(pipeline.adtsStream);pipeline.aacStream.pipe(pipeline.timedMetadataTimestampRolloverStream).pipe(pipeline.metadataStream).pipe(pipeline.coalesceStream);pipeline.metadataStream.on('timestamp',function(frame){pipeline.aacStream.setTimestamp(frame.timeStamp);});pipeline.aacStream.on('data',function(data){if(data.type!=='timed-metadata'&&data.type!=='audio'||pipeline.audioSegmentStream){return;}audioTrack=audioTrack||{timelineStartInfo:{baseMediaDecodeTime:self.baseMediaDecodeTime},codec:'adts',type:'audio'};// hook up the audio segment stream to the first track with aac data
pipeline.coalesceStream.numberOfTracks++;pipeline.audioSegmentStream=new _AudioSegmentStream(audioTrack,options);pipeline.audioSegmentStream.on('log',self.getLogTrigger_('audioSegmentStream'));pipeline.audioSegmentStream.on('timingInfo',self.trigger.bind(self,'audioTimingInfo'));// Set up the final part of the audio pipeline
pipeline.adtsStream.pipe(pipeline.audioSegmentStream).pipe(pipeline.coalesceStream);// emit pmt info
self.trigger('trackinfo',{hasAudio:!!audioTrack,hasVideo:!!videoTrack});});// Re-emit any data coming from the coalesce stream to the outside world
pipeline.coalesceStream.on('data',this.trigger.bind(this,'data'));// Let the consumer know we have finished flushing the entire pipeline
pipeline.coalesceStream.on('done',this.trigger.bind(this,'done'));addPipelineLogRetriggers(this,pipeline);};this.setupTsPipeline=function(){var pipeline={};this.transmuxPipeline_=pipeline;pipeline.type='ts';pipeline.metadataStream=new m2ts_1.MetadataStream();// set up the parsing pipeline
pipeline.packetStream=new m2ts_1.TransportPacketStream();pipeline.parseStream=new m2ts_1.TransportParseStream();pipeline.elementaryStream=new m2ts_1.ElementaryStream();pipeline.timestampRolloverStream=new m2ts_1.TimestampRolloverStream();pipeline.adtsStream=new adts();pipeline.h264Stream=new H264Stream();pipeline.captionStream=new m2ts_1.CaptionStream(options);pipeline.coalesceStream=new _CoalesceStream(options,pipeline.metadataStream);pipeline.headOfPipeline=pipeline.packetStream;// disassemble MPEG2-TS packets into elementary streams
pipeline.packetStream.pipe(pipeline.parseStream).pipe(pipeline.elementaryStream).pipe(pipeline.timestampRolloverStream);// !!THIS ORDER IS IMPORTANT!!
// demux the streams
pipeline.timestampRolloverStream.pipe(pipeline.h264Stream);pipeline.timestampRolloverStream.pipe(pipeline.adtsStream);pipeline.timestampRolloverStream.pipe(pipeline.metadataStream).pipe(pipeline.coalesceStream);// Hook up CEA-608/708 caption stream
pipeline.h264Stream.pipe(pipeline.captionStream).pipe(pipeline.coalesceStream);pipeline.elementaryStream.on('data',function(data){var i;if(data.type==='metadata'){i=data.tracks.length;// scan the tracks listed in the metadata
while(i--){if(!videoTrack&&data.tracks[i].type==='video'){videoTrack=data.tracks[i];videoTrack.timelineStartInfo.baseMediaDecodeTime=self.baseMediaDecodeTime;}else if(!audioTrack&&data.tracks[i].type==='audio'){audioTrack=data.tracks[i];audioTrack.timelineStartInfo.baseMediaDecodeTime=self.baseMediaDecodeTime;}}// hook up the video segment stream to the first track with h264 data
if(videoTrack&&!pipeline.videoSegmentStream){pipeline.coalesceStream.numberOfTracks++;pipeline.videoSegmentStream=new _VideoSegmentStream(videoTrack,options);pipeline.videoSegmentStream.on('log',self.getLogTrigger_('videoSegmentStream'));pipeline.videoSegmentStream.on('timelineStartInfo',function(timelineStartInfo){// When video emits timelineStartInfo data after a flush, we forward that
// info to the AudioSegmentStream, if it exists, because video timeline
// data takes precedence.  Do not do this if keepOriginalTimestamps is set,
// because this is a particularly subtle form of timestamp alteration.
if(audioTrack&&!options.keepOriginalTimestamps){audioTrack.timelineStartInfo=timelineStartInfo;// On the first segment we trim AAC frames that exist before the
// very earliest DTS we have seen in video because Chrome will
// interpret any video track with a baseMediaDecodeTime that is
// non-zero as a gap.
pipeline.audioSegmentStream.setEarliestDts(timelineStartInfo.dts-self.baseMediaDecodeTime);}});pipeline.videoSegmentStream.on('processedGopsInfo',self.trigger.bind(self,'gopInfo'));pipeline.videoSegmentStream.on('segmentTimingInfo',self.trigger.bind(self,'videoSegmentTimingInfo'));pipeline.videoSegmentStream.on('baseMediaDecodeTime',function(baseMediaDecodeTime){if(audioTrack){pipeline.audioSegmentStream.setVideoBaseMediaDecodeTime(baseMediaDecodeTime);}});pipeline.videoSegmentStream.on('timingInfo',self.trigger.bind(self,'videoTimingInfo'));// Set up the final part of the video pipeline
pipeline.h264Stream.pipe(pipeline.videoSegmentStream).pipe(pipeline.coalesceStream);}if(audioTrack&&!pipeline.audioSegmentStream){// hook up the audio segment stream to the first track with aac data
pipeline.coalesceStream.numberOfTracks++;pipeline.audioSegmentStream=new _AudioSegmentStream(audioTrack,options);pipeline.audioSegmentStream.on('log',self.getLogTrigger_('audioSegmentStream'));pipeline.audioSegmentStream.on('timingInfo',self.trigger.bind(self,'audioTimingInfo'));pipeline.audioSegmentStream.on('segmentTimingInfo',self.trigger.bind(self,'audioSegmentTimingInfo'));// Set up the final part of the audio pipeline
pipeline.adtsStream.pipe(pipeline.audioSegmentStream).pipe(pipeline.coalesceStream);}// emit pmt info
self.trigger('trackinfo',{hasAudio:!!audioTrack,hasVideo:!!videoTrack});}});// Re-emit any data coming from the coalesce stream to the outside world
pipeline.coalesceStream.on('data',this.trigger.bind(this,'data'));pipeline.coalesceStream.on('id3Frame',function(id3Frame){id3Frame.dispatchType=pipeline.metadataStream.dispatchType;self.trigger('id3Frame',id3Frame);});pipeline.coalesceStream.on('caption',this.trigger.bind(this,'caption'));// Let the consumer know we have finished flushing the entire pipeline
pipeline.coalesceStream.on('done',this.trigger.bind(this,'done'));addPipelineLogRetriggers(this,pipeline);};// hook up the segment streams once track metadata is delivered
this.setBaseMediaDecodeTime=function(baseMediaDecodeTime){var pipeline=this.transmuxPipeline_;if(!options.keepOriginalTimestamps){this.baseMediaDecodeTime=baseMediaDecodeTime;}if(audioTrack){audioTrack.timelineStartInfo.dts=undefined;audioTrack.timelineStartInfo.pts=undefined;trackDecodeInfo.clearDtsInfo(audioTrack);if(pipeline.audioTimestampRolloverStream){pipeline.audioTimestampRolloverStream.discontinuity();}}if(videoTrack){if(pipeline.videoSegmentStream){pipeline.videoSegmentStream.gopCache_=[];}videoTrack.timelineStartInfo.dts=undefined;videoTrack.timelineStartInfo.pts=undefined;trackDecodeInfo.clearDtsInfo(videoTrack);pipeline.captionStream.reset();}if(pipeline.timestampRolloverStream){pipeline.timestampRolloverStream.discontinuity();}};this.setAudioAppendStart=function(timestamp){if(audioTrack){this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(timestamp);}};this.setRemux=function(val){var pipeline=this.transmuxPipeline_;options.remux=val;if(pipeline&&pipeline.coalesceStream){pipeline.coalesceStream.setRemux(val);}};this.alignGopsWith=function(gopsToAlignWith){if(videoTrack&&this.transmuxPipeline_.videoSegmentStream){this.transmuxPipeline_.videoSegmentStream.alignGopsWith(gopsToAlignWith);}};this.getLogTrigger_=function(key){var self=this;return function(event){event.stream=key;self.trigger('log',event);};};// feed incoming data to the front of the parsing pipeline
this.push=function(data){if(hasFlushed){var isAac=isLikelyAacData(data);if(isAac&&this.transmuxPipeline_.type!=='aac'){this.setupAacPipeline();}else if(!isAac&&this.transmuxPipeline_.type!=='ts'){this.setupTsPipeline();}hasFlushed=false;}this.transmuxPipeline_.headOfPipeline.push(data);};// flush any buffered data
this.flush=function(){hasFlushed=true;// Start at the top of the pipeline and flush all pending work
this.transmuxPipeline_.headOfPipeline.flush();};this.endTimeline=function(){this.transmuxPipeline_.headOfPipeline.endTimeline();};this.reset=function(){if(this.transmuxPipeline_.headOfPipeline){this.transmuxPipeline_.headOfPipeline.reset();}};// Caption data has to be reset when seeking outside buffered range
this.resetCaptions=function(){if(this.transmuxPipeline_.captionStream){this.transmuxPipeline_.captionStream.reset();}};};_Transmuxer.prototype=new stream();var transmuxer={Transmuxer:_Transmuxer,VideoSegmentStream:_VideoSegmentStream,AudioSegmentStream:_AudioSegmentStream,AUDIO_PROPERTIES:audioProperties,VIDEO_PROPERTIES:videoProperties,// exported for testing
generateSegmentTimingInfo:generateSegmentTimingInfo};/**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */var toUnsigned$3=function toUnsigned(value){return value>>>0;};var toHexString$1=function toHexString(value){return('00'+value.toString(16)).slice(-2);};var bin={toUnsigned:toUnsigned$3,toHexString:toHexString$1};var parseType$1=function parseType(buffer){var result='';result+=String.fromCharCode(buffer[0]);result+=String.fromCharCode(buffer[1]);result+=String.fromCharCode(buffer[2]);result+=String.fromCharCode(buffer[3]);return result;};var parseType_1=parseType$1;var toUnsigned$2=bin.toUnsigned;var findBox=function findBox(data,path){var results=[],i,size,type,end,subresults;if(!path.length){// short-circuit the search for empty paths
return null;}for(i=0;i<data.byteLength;){size=toUnsigned$2(data[i]<<24|data[i+1]<<16|data[i+2]<<8|data[i+3]);type=parseType_1(data.subarray(i+4,i+8));end=size>1?i+size:data.byteLength;if(type===path[0]){if(path.length===1){// this is the end of the path and we've found the box we were
// looking for
results.push(data.subarray(i+8,end));}else{// recursively search for the next box along the path
subresults=findBox(data.subarray(i+8,end),path.slice(1));if(subresults.length){results=results.concat(subresults);}}}i=end;}// we've finished searching all of data
return results;};var findBox_1=findBox;var toUnsigned$1=bin.toUnsigned;var getUint64$1=numbers.getUint64;var tfdt=function tfdt(data){var result={version:data[0],flags:new Uint8Array(data.subarray(1,4))};if(result.version===1){result.baseMediaDecodeTime=getUint64$1(data.subarray(4));}else{result.baseMediaDecodeTime=toUnsigned$1(data[4]<<24|data[5]<<16|data[6]<<8|data[7]);}return result;};var parseTfdt=tfdt;var parseSampleFlags=function parseSampleFlags(flags){return{isLeading:(flags[0]&0x0c)>>>2,dependsOn:flags[0]&0x03,isDependedOn:(flags[1]&0xc0)>>>6,hasRedundancy:(flags[1]&0x30)>>>4,paddingValue:(flags[1]&0x0e)>>>1,isNonSyncSample:flags[1]&0x01,degradationPriority:flags[2]<<8|flags[3]};};var parseSampleFlags_1=parseSampleFlags;var trun=function trun(data){var result={version:data[0],flags:new Uint8Array(data.subarray(1,4)),samples:[]},view=new DataView(data.buffer,data.byteOffset,data.byteLength),// Flag interpretation
dataOffsetPresent=result.flags[2]&0x01,// compare with 2nd byte of 0x1
firstSampleFlagsPresent=result.flags[2]&0x04,// compare with 2nd byte of 0x4
sampleDurationPresent=result.flags[1]&0x01,// compare with 2nd byte of 0x100
sampleSizePresent=result.flags[1]&0x02,// compare with 2nd byte of 0x200
sampleFlagsPresent=result.flags[1]&0x04,// compare with 2nd byte of 0x400
sampleCompositionTimeOffsetPresent=result.flags[1]&0x08,// compare with 2nd byte of 0x800
sampleCount=view.getUint32(4),offset=8,sample;if(dataOffsetPresent){// 32 bit signed integer
result.dataOffset=view.getInt32(offset);offset+=4;}// Overrides the flags for the first sample only. The order of
// optional values will be: duration, size, compositionTimeOffset
if(firstSampleFlagsPresent&&sampleCount){sample={flags:parseSampleFlags_1(data.subarray(offset,offset+4))};offset+=4;if(sampleDurationPresent){sample.duration=view.getUint32(offset);offset+=4;}if(sampleSizePresent){sample.size=view.getUint32(offset);offset+=4;}if(sampleCompositionTimeOffsetPresent){if(result.version===1){sample.compositionTimeOffset=view.getInt32(offset);}else{sample.compositionTimeOffset=view.getUint32(offset);}offset+=4;}result.samples.push(sample);sampleCount--;}while(sampleCount--){sample={};if(sampleDurationPresent){sample.duration=view.getUint32(offset);offset+=4;}if(sampleSizePresent){sample.size=view.getUint32(offset);offset+=4;}if(sampleFlagsPresent){sample.flags=parseSampleFlags_1(data.subarray(offset,offset+4));offset+=4;}if(sampleCompositionTimeOffsetPresent){if(result.version===1){sample.compositionTimeOffset=view.getInt32(offset);}else{sample.compositionTimeOffset=view.getUint32(offset);}offset+=4;}result.samples.push(sample);}return result;};var parseTrun=trun;var tfhd=function tfhd(data){var view=new DataView(data.buffer,data.byteOffset,data.byteLength),result={version:data[0],flags:new Uint8Array(data.subarray(1,4)),trackId:view.getUint32(4)},baseDataOffsetPresent=result.flags[2]&0x01,sampleDescriptionIndexPresent=result.flags[2]&0x02,defaultSampleDurationPresent=result.flags[2]&0x08,defaultSampleSizePresent=result.flags[2]&0x10,defaultSampleFlagsPresent=result.flags[2]&0x20,durationIsEmpty=result.flags[0]&0x010000,defaultBaseIsMoof=result.flags[0]&0x020000,i;i=8;if(baseDataOffsetPresent){i+=4;// truncate top 4 bytes
// FIXME: should we read the full 64 bits?
result.baseDataOffset=view.getUint32(12);i+=4;}if(sampleDescriptionIndexPresent){result.sampleDescriptionIndex=view.getUint32(i);i+=4;}if(defaultSampleDurationPresent){result.defaultSampleDuration=view.getUint32(i);i+=4;}if(defaultSampleSizePresent){result.defaultSampleSize=view.getUint32(i);i+=4;}if(defaultSampleFlagsPresent){result.defaultSampleFlags=view.getUint32(i);}if(durationIsEmpty){result.durationIsEmpty=true;}if(!baseDataOffsetPresent&&defaultBaseIsMoof){result.baseDataOffsetIsMoof=true;}return result;};var parseTfhd=tfhd;var commonjsGlobal=typeof globalThis!=='undefined'?globalThis:typeof window!=='undefined'?window:typeof __webpack_require__.g!=='undefined'?__webpack_require__.g:typeof self!=='undefined'?self:{};var win;if(typeof window!=="undefined"){win=window;}else if(typeof commonjsGlobal!=="undefined"){win=commonjsGlobal;}else if(typeof self!=="undefined"){win=self;}else{win={};}var window_1=win;var discardEmulationPreventionBytes=captionPacketParser.discardEmulationPreventionBytes;var CaptionStream=captionStream.CaptionStream;/**
    * Maps an offset in the mdat to a sample based on the the size of the samples.
    * Assumes that `parseSamples` has been called first.
    *
    * @param {Number} offset - The offset into the mdat
    * @param {Object[]} samples - An array of samples, parsed using `parseSamples`
    * @return {?Object} The matching sample, or null if no match was found.
    *
    * @see ISO-BMFF-12/2015, Section 8.8.8
   **/var mapToSample=function mapToSample(offset,samples){var approximateOffset=offset;for(var i=0;i<samples.length;i++){var sample=samples[i];if(approximateOffset<sample.size){return sample;}approximateOffset-=sample.size;}return null;};/**
    * Finds SEI nal units contained in a Media Data Box.
    * Assumes that `parseSamples` has been called first.
    *
    * @param {Uint8Array} avcStream - The bytes of the mdat
    * @param {Object[]} samples - The samples parsed out by `parseSamples`
    * @param {Number} trackId - The trackId of this video track
    * @return {Object[]} seiNals - the parsed SEI NALUs found.
    *   The contents of the seiNal should match what is expected by
    *   CaptionStream.push (nalUnitType, size, data, escapedRBSP, pts, dts)
    *
    * @see ISO-BMFF-12/2015, Section 8.1.1
    * @see Rec. ITU-T H.264, 7.3.2.3.1
   **/var findSeiNals=function findSeiNals(avcStream,samples,trackId){var avcView=new DataView(avcStream.buffer,avcStream.byteOffset,avcStream.byteLength),result={logs:[],seiNals:[]},seiNal,i,length,lastMatchedSample;for(i=0;i+4<avcStream.length;i+=length){length=avcView.getUint32(i);i+=4;// Bail if this doesn't appear to be an H264 stream
if(length<=0){continue;}switch(avcStream[i]&0x1F){case 0x06:var data=avcStream.subarray(i+1,i+1+length);var matchingSample=mapToSample(i,samples);seiNal={nalUnitType:'sei_rbsp',size:length,data:data,escapedRBSP:discardEmulationPreventionBytes(data),trackId:trackId};if(matchingSample){seiNal.pts=matchingSample.pts;seiNal.dts=matchingSample.dts;lastMatchedSample=matchingSample;}else if(lastMatchedSample){// If a matching sample cannot be found, use the last
// sample's values as they should be as close as possible
seiNal.pts=lastMatchedSample.pts;seiNal.dts=lastMatchedSample.dts;}else{result.logs.push({level:'warn',message:'We\'ve encountered a nal unit without data at '+i+' for trackId '+trackId+'. See mux.js#223.'});break;}result.seiNals.push(seiNal);break;}}return result;};/**
    * Parses sample information out of Track Run Boxes and calculates
    * the absolute presentation and decode timestamps of each sample.
    *
    * @param {Array<Uint8Array>} truns - The Trun Run boxes to be parsed
    * @param {Number|BigInt} baseMediaDecodeTime - base media decode time from tfdt
        @see ISO-BMFF-12/2015, Section 8.8.12
    * @param {Object} tfhd - The parsed Track Fragment Header
    *   @see inspect.parseTfhd
    * @return {Object[]} the parsed samples
    *
    * @see ISO-BMFF-12/2015, Section 8.8.8
   **/var parseSamples=function parseSamples(truns,baseMediaDecodeTime,tfhd){var currentDts=baseMediaDecodeTime;var defaultSampleDuration=tfhd.defaultSampleDuration||0;var defaultSampleSize=tfhd.defaultSampleSize||0;var trackId=tfhd.trackId;var allSamples=[];truns.forEach(function(trun){// Note: We currently do not parse the sample table as well
// as the trun. It's possible some sources will require this.
// moov > trak > mdia > minf > stbl
var trackRun=parseTrun(trun);var samples=trackRun.samples;samples.forEach(function(sample){if(sample.duration===undefined){sample.duration=defaultSampleDuration;}if(sample.size===undefined){sample.size=defaultSampleSize;}sample.trackId=trackId;sample.dts=currentDts;if(sample.compositionTimeOffset===undefined){sample.compositionTimeOffset=0;}if(typeof currentDts==='bigint'){sample.pts=currentDts+window_1.BigInt(sample.compositionTimeOffset);currentDts+=window_1.BigInt(sample.duration);}else{sample.pts=currentDts+sample.compositionTimeOffset;currentDts+=sample.duration;}});allSamples=allSamples.concat(samples);});return allSamples;};/**
    * Parses out caption nals from an FMP4 segment's video tracks.
    *
    * @param {Uint8Array} segment - The bytes of a single segment
    * @param {Number} videoTrackId - The trackId of a video track in the segment
    * @return {Object.<Number, Object[]>} A mapping of video trackId to
    *   a list of seiNals found in that track
   **/var parseCaptionNals=function parseCaptionNals(segment,videoTrackId){// To get the samples
var trafs=findBox_1(segment,['moof','traf']);// To get SEI NAL units
var mdats=findBox_1(segment,['mdat']);var captionNals={};var mdatTrafPairs=[];// Pair up each traf with a mdat as moofs and mdats are in pairs
mdats.forEach(function(mdat,index){var matchingTraf=trafs[index];mdatTrafPairs.push({mdat:mdat,traf:matchingTraf});});mdatTrafPairs.forEach(function(pair){var mdat=pair.mdat;var traf=pair.traf;var tfhd=findBox_1(traf,['tfhd']);// Exactly 1 tfhd per traf
var headerInfo=parseTfhd(tfhd[0]);var trackId=headerInfo.trackId;var tfdt=findBox_1(traf,['tfdt']);// Either 0 or 1 tfdt per traf
var baseMediaDecodeTime=tfdt.length>0?parseTfdt(tfdt[0]).baseMediaDecodeTime:0;var truns=findBox_1(traf,['trun']);var samples;var result;// Only parse video data for the chosen video track
if(videoTrackId===trackId&&truns.length>0){samples=parseSamples(truns,baseMediaDecodeTime,headerInfo);result=findSeiNals(mdat,samples,trackId);if(!captionNals[trackId]){captionNals[trackId]={seiNals:[],logs:[]};}captionNals[trackId].seiNals=captionNals[trackId].seiNals.concat(result.seiNals);captionNals[trackId].logs=captionNals[trackId].logs.concat(result.logs);}});return captionNals;};/**
    * Parses out inband captions from an MP4 container and returns
    * caption objects that can be used by WebVTT and the TextTrack API.
    * @see https://developer.mozilla.org/en-US/docs/Web/API/VTTCue
    * @see https://developer.mozilla.org/en-US/docs/Web/API/TextTrack
    * Assumes that `probe.getVideoTrackIds` and `probe.timescale` have been called first
    *
    * @param {Uint8Array} segment - The fmp4 segment containing embedded captions
    * @param {Number} trackId - The id of the video track to parse
    * @param {Number} timescale - The timescale for the video track from the init segment
    *
    * @return {?Object[]} parsedCaptions - A list of captions or null if no video tracks
    * @return {Number} parsedCaptions[].startTime - The time to show the caption in seconds
    * @return {Number} parsedCaptions[].endTime - The time to stop showing the caption in seconds
    * @return {String} parsedCaptions[].text - The visible content of the caption
   **/var parseEmbeddedCaptions=function parseEmbeddedCaptions(segment,trackId,timescale){var captionNals;// the ISO-BMFF spec says that trackId can't be zero, but there's some broken content out there
if(trackId===null){return null;}captionNals=parseCaptionNals(segment,trackId);var trackNals=captionNals[trackId]||{};return{seiNals:trackNals.seiNals,logs:trackNals.logs,timescale:timescale};};/**
    * Converts SEI NALUs into captions that can be used by video.js
   **/var CaptionParser=function CaptionParser(){var isInitialized=false;var captionStream;// Stores segments seen before trackId and timescale are set
var segmentCache;// Stores video track ID of the track being parsed
var trackId;// Stores the timescale of the track being parsed
var timescale;// Stores captions parsed so far
var parsedCaptions;// Stores whether we are receiving partial data or not
var parsingPartial;/**
      * A method to indicate whether a CaptionParser has been initalized
      * @returns {Boolean}
     **/this.isInitialized=function(){return isInitialized;};/**
      * Initializes the underlying CaptionStream, SEI NAL parsing
      * and management, and caption collection
     **/this.init=function(options){captionStream=new CaptionStream();isInitialized=true;parsingPartial=options?options.isPartial:false;// Collect dispatched captions
captionStream.on('data',function(event){// Convert to seconds in the source's timescale
event.startTime=event.startPts/timescale;event.endTime=event.endPts/timescale;parsedCaptions.captions.push(event);parsedCaptions.captionStreams[event.stream]=true;});captionStream.on('log',function(log){parsedCaptions.logs.push(log);});};/**
      * Determines if a new video track will be selected
      * or if the timescale changed
      * @return {Boolean}
     **/this.isNewInit=function(videoTrackIds,timescales){if(videoTrackIds&&videoTrackIds.length===0||timescales&&video_es_typeof(timescales)==='object'&&Object.keys(timescales).length===0){return false;}return trackId!==videoTrackIds[0]||timescale!==timescales[trackId];};/**
      * Parses out SEI captions and interacts with underlying
      * CaptionStream to return dispatched captions
      *
      * @param {Uint8Array} segment - The fmp4 segment containing embedded captions
      * @param {Number[]} videoTrackIds - A list of video tracks found in the init segment
      * @param {Object.<Number, Number>} timescales - The timescales found in the init segment
      * @see parseEmbeddedCaptions
      * @see m2ts/caption-stream.js
     **/this.parse=function(segment,videoTrackIds,timescales){var parsedData;if(!this.isInitialized()){return null;// This is not likely to be a video segment
}else if(!videoTrackIds||!timescales){return null;}else if(this.isNewInit(videoTrackIds,timescales)){// Use the first video track only as there is no
// mechanism to switch to other video tracks
trackId=videoTrackIds[0];timescale=timescales[trackId];// If an init segment has not been seen yet, hold onto segment
// data until we have one.
// the ISO-BMFF spec says that trackId can't be zero, but there's some broken content out there
}else if(trackId===null||!timescale){segmentCache.push(segment);return null;}// Now that a timescale and trackId is set, parse cached segments
while(segmentCache.length>0){var cachedSegment=segmentCache.shift();this.parse(cachedSegment,videoTrackIds,timescales);}parsedData=parseEmbeddedCaptions(segment,trackId,timescale);if(parsedData&&parsedData.logs){parsedCaptions.logs=parsedCaptions.logs.concat(parsedData.logs);}if(parsedData===null||!parsedData.seiNals){if(parsedCaptions.logs.length){return{logs:parsedCaptions.logs,captions:[],captionStreams:[]};}return null;}this.pushNals(parsedData.seiNals);// Force the parsed captions to be dispatched
this.flushStream();return parsedCaptions;};/**
      * Pushes SEI NALUs onto CaptionStream
      * @param {Object[]} nals - A list of SEI nals parsed using `parseCaptionNals`
      * Assumes that `parseCaptionNals` has been called first
      * @see m2ts/caption-stream.js
      **/this.pushNals=function(nals){if(!this.isInitialized()||!nals||nals.length===0){return null;}nals.forEach(function(nal){captionStream.push(nal);});};/**
      * Flushes underlying CaptionStream to dispatch processed, displayable captions
      * @see m2ts/caption-stream.js
     **/this.flushStream=function(){if(!this.isInitialized()){return null;}if(!parsingPartial){captionStream.flush();}else{captionStream.partialFlush();}};/**
      * Reset caption buckets for new data
     **/this.clearParsedCaptions=function(){parsedCaptions.captions=[];parsedCaptions.captionStreams={};parsedCaptions.logs=[];};/**
      * Resets underlying CaptionStream
      * @see m2ts/caption-stream.js
     **/this.resetCaptionStream=function(){if(!this.isInitialized()){return null;}captionStream.reset();};/**
      * Convenience method to clear all captions flushed from the
      * CaptionStream and still being parsed
      * @see m2ts/caption-stream.js
     **/this.clearAllCaptions=function(){this.clearParsedCaptions();this.resetCaptionStream();};/**
      * Reset caption parser
     **/this.reset=function(){segmentCache=[];trackId=null;timescale=null;if(!parsedCaptions){parsedCaptions={captions:[],// CC1, CC2, CC3, CC4
captionStreams:{},logs:[]};}else{this.clearParsedCaptions();}this.resetCaptionStream();};this.reset();};var captionParser=CaptionParser;var toUnsigned=bin.toUnsigned;var toHexString=bin.toHexString;var getUint64=numbers.getUint64;var timescale,startTime,compositionStartTime,getVideoTrackIds,getTracks,getTimescaleFromMediaHeader;/**
   * Parses an MP4 initialization segment and extracts the timescale
   * values for any declared tracks. Timescale values indicate the
   * number of clock ticks per second to assume for time-based values
   * elsewhere in the MP4.
   *
   * To determine the start time of an MP4, you need two pieces of
   * information: the timescale unit and the earliest base media decode
   * time. Multiple timescales can be specified within an MP4 but the
   * base media decode time is always expressed in the timescale from
   * the media header box for the track:
   * ```
   * moov > trak > mdia > mdhd.timescale
   * ```
   * @param init {Uint8Array} the bytes of the init segment
   * @return {object} a hash of track ids to timescale values or null if
   * the init segment is malformed.
   */timescale=function timescale(init){var result={},traks=findBox_1(init,['moov','trak']);// mdhd timescale
return traks.reduce(function(result,trak){var tkhd,version,index,id,mdhd;tkhd=findBox_1(trak,['tkhd'])[0];if(!tkhd){return null;}version=tkhd[0];index=version===0?12:20;id=toUnsigned(tkhd[index]<<24|tkhd[index+1]<<16|tkhd[index+2]<<8|tkhd[index+3]);mdhd=findBox_1(trak,['mdia','mdhd'])[0];if(!mdhd){return null;}version=mdhd[0];index=version===0?12:20;result[id]=toUnsigned(mdhd[index]<<24|mdhd[index+1]<<16|mdhd[index+2]<<8|mdhd[index+3]);return result;},result);};/**
   * Determine the base media decode start time, in seconds, for an MP4
   * fragment. If multiple fragments are specified, the earliest time is
   * returned.
   *
   * The base media decode time can be parsed from track fragment
   * metadata:
   * ```
   * moof > traf > tfdt.baseMediaDecodeTime
   * ```
   * It requires the timescale value from the mdhd to interpret.
   *
   * @param timescale {object} a hash of track ids to timescale values.
   * @return {number} the earliest base media decode start time for the
   * fragment, in seconds
   */startTime=function startTime(timescale,fragment){var trafs;// we need info from two childrend of each track fragment box
trafs=findBox_1(fragment,['moof','traf']);// determine the start times for each track
var lowestTime=trafs.reduce(function(acc,traf){var tfhd=findBox_1(traf,['tfhd'])[0];// get the track id from the tfhd
var id=toUnsigned(tfhd[4]<<24|tfhd[5]<<16|tfhd[6]<<8|tfhd[7]);// assume a 90kHz clock if no timescale was specified
var scale=timescale[id]||90e3;// get the base media decode time from the tfdt
var tfdt=findBox_1(traf,['tfdt'])[0];var dv=new DataView(tfdt.buffer,tfdt.byteOffset,tfdt.byteLength);var baseTime;// version 1 is 64 bit
if(tfdt[0]===1){baseTime=getUint64(tfdt.subarray(4,12));}else{baseTime=dv.getUint32(4);}// convert base time to seconds if it is a valid number.
var seconds;if(typeof baseTime==='bigint'){seconds=baseTime/window_1.BigInt(scale);}else if(typeof baseTime==='number'&&!isNaN(baseTime)){seconds=baseTime/scale;}if(seconds<Number.MAX_SAFE_INTEGER){seconds=Number(seconds);}if(seconds<acc){acc=seconds;}return acc;},Infinity);return typeof lowestTime==='bigint'||isFinite(lowestTime)?lowestTime:0;};/**
   * Determine the composition start, in seconds, for an MP4
   * fragment.
   *
   * The composition start time of a fragment can be calculated using the base
   * media decode time, composition time offset, and timescale, as follows:
   *
   * compositionStartTime = (baseMediaDecodeTime + compositionTimeOffset) / timescale
   *
   * All of the aforementioned information is contained within a media fragment's
   * `traf` box, except for timescale info, which comes from the initialization
   * segment, so a track id (also contained within a `traf`) is also necessary to
   * associate it with a timescale
   *
   *
   * @param timescales {object} - a hash of track ids to timescale values.
   * @param fragment {Unit8Array} - the bytes of a media segment
   * @return {number} the composition start time for the fragment, in seconds
   **/compositionStartTime=function compositionStartTime(timescales,fragment){var trafBoxes=findBox_1(fragment,['moof','traf']);var baseMediaDecodeTime=0;var compositionTimeOffset=0;var trackId;if(trafBoxes&&trafBoxes.length){// The spec states that track run samples contained within a `traf` box are contiguous, but
// it does not explicitly state whether the `traf` boxes themselves are contiguous.
// We will assume that they are, so we only need the first to calculate start time.
var tfhd=findBox_1(trafBoxes[0],['tfhd'])[0];var trun=findBox_1(trafBoxes[0],['trun'])[0];var tfdt=findBox_1(trafBoxes[0],['tfdt'])[0];if(tfhd){var parsedTfhd=parseTfhd(tfhd);trackId=parsedTfhd.trackId;}if(tfdt){var parsedTfdt=parseTfdt(tfdt);baseMediaDecodeTime=parsedTfdt.baseMediaDecodeTime;}if(trun){var parsedTrun=parseTrun(trun);if(parsedTrun.samples&&parsedTrun.samples.length){compositionTimeOffset=parsedTrun.samples[0].compositionTimeOffset||0;}}}// Get timescale for this specific track. Assume a 90kHz clock if no timescale was
// specified.
var timescale=timescales[trackId]||90e3;// return the composition start time, in seconds
if(typeof baseMediaDecodeTime==='bigint'){compositionTimeOffset=window_1.BigInt(compositionTimeOffset);timescale=window_1.BigInt(timescale);}var result=(baseMediaDecodeTime+compositionTimeOffset)/timescale;if(typeof result==='bigint'&&result<Number.MAX_SAFE_INTEGER){result=Number(result);}return result;};/**
    * Find the trackIds of the video tracks in this source.
    * Found by parsing the Handler Reference and Track Header Boxes:
    *   moov > trak > mdia > hdlr
    *   moov > trak > tkhd
    *
    * @param {Uint8Array} init - The bytes of the init segment for this source
    * @return {Number[]} A list of trackIds
    *
    * @see ISO-BMFF-12/2015, Section 8.4.3
   **/getVideoTrackIds=function getVideoTrackIds(init){var traks=findBox_1(init,['moov','trak']);var videoTrackIds=[];traks.forEach(function(trak){var hdlrs=findBox_1(trak,['mdia','hdlr']);var tkhds=findBox_1(trak,['tkhd']);hdlrs.forEach(function(hdlr,index){var handlerType=parseType_1(hdlr.subarray(8,12));var tkhd=tkhds[index];var view;var version;var trackId;if(handlerType==='vide'){view=new DataView(tkhd.buffer,tkhd.byteOffset,tkhd.byteLength);version=view.getUint8(0);trackId=version===0?view.getUint32(12):view.getUint32(20);videoTrackIds.push(trackId);}});});return videoTrackIds;};getTimescaleFromMediaHeader=function getTimescaleFromMediaHeader(mdhd){// mdhd is a FullBox, meaning it will have its own version as the first byte
var version=mdhd[0];var index=version===0?12:20;return toUnsigned(mdhd[index]<<24|mdhd[index+1]<<16|mdhd[index+2]<<8|mdhd[index+3]);};/**
   * Get all the video, audio, and hint tracks from a non fragmented
   * mp4 segment
   */getTracks=function getTracks(init){var traks=findBox_1(init,['moov','trak']);var tracks=[];traks.forEach(function(trak){var track={};var tkhd=findBox_1(trak,['tkhd'])[0];var view,tkhdVersion;// id
if(tkhd){view=new DataView(tkhd.buffer,tkhd.byteOffset,tkhd.byteLength);tkhdVersion=view.getUint8(0);track.id=tkhdVersion===0?view.getUint32(12):view.getUint32(20);}var hdlr=findBox_1(trak,['mdia','hdlr'])[0];// type
if(hdlr){var type=parseType_1(hdlr.subarray(8,12));if(type==='vide'){track.type='video';}else if(type==='soun'){track.type='audio';}else{track.type=type;}}// codec
var stsd=findBox_1(trak,['mdia','minf','stbl','stsd'])[0];if(stsd){var sampleDescriptions=stsd.subarray(8);// gives the codec type string
track.codec=parseType_1(sampleDescriptions.subarray(4,8));var codecBox=findBox_1(sampleDescriptions,[track.codec])[0];var codecConfig,codecConfigType;if(codecBox){// https://tools.ietf.org/html/rfc6381#section-3.3
if(/^[asm]vc[1-9]$/i.test(track.codec)){// we don't need anything but the "config" parameter of the
// avc1 codecBox
codecConfig=codecBox.subarray(78);codecConfigType=parseType_1(codecConfig.subarray(4,8));if(codecConfigType==='avcC'&&codecConfig.length>11){track.codec+='.';// left padded with zeroes for single digit hex
// profile idc
track.codec+=toHexString(codecConfig[9]);// the byte containing the constraint_set flags
track.codec+=toHexString(codecConfig[10]);// level idc
track.codec+=toHexString(codecConfig[11]);}else{// TODO: show a warning that we couldn't parse the codec
// and are using the default
track.codec='avc1.4d400d';}}else if(/^mp4[a,v]$/i.test(track.codec)){// we do not need anything but the streamDescriptor of the mp4a codecBox
codecConfig=codecBox.subarray(28);codecConfigType=parseType_1(codecConfig.subarray(4,8));if(codecConfigType==='esds'&&codecConfig.length>20&&codecConfig[19]!==0){track.codec+='.'+toHexString(codecConfig[19]);// this value is only a single digit
track.codec+='.'+toHexString(codecConfig[20]>>>2&0x3f).replace(/^0/,'');}else{// TODO: show a warning that we couldn't parse the codec
// and are using the default
track.codec='mp4a.40.2';}}else{// flac, opus, etc
track.codec=track.codec.toLowerCase();}}}var mdhd=findBox_1(trak,['mdia','mdhd'])[0];if(mdhd){track.timescale=getTimescaleFromMediaHeader(mdhd);}tracks.push(track);});return tracks;};var probe$2={// export mp4 inspector's findBox and parseType for backwards compatibility
findBox:findBox_1,parseType:parseType_1,timescale:timescale,startTime:startTime,compositionStartTime:compositionStartTime,videoTrackIds:getVideoTrackIds,tracks:getTracks,getTimescaleFromMediaHeader:getTimescaleFromMediaHeader};var parsePid=function parsePid(packet){var pid=packet[1]&0x1f;pid<<=8;pid|=packet[2];return pid;};var parsePayloadUnitStartIndicator=function parsePayloadUnitStartIndicator(packet){return!!(packet[1]&0x40);};var parseAdaptionField=function parseAdaptionField(packet){var offset=0;// if an adaption field is present, its length is specified by the
// fifth byte of the TS packet header. The adaptation field is
// used to add stuffing to PES packets that don't fill a complete
// TS packet, and to specify some forms of timing and control data
// that we do not currently use.
if((packet[3]&0x30)>>>4>0x01){offset+=packet[4]+1;}return offset;};var parseType=function parseType(packet,pmtPid){var pid=parsePid(packet);if(pid===0){return'pat';}else if(pid===pmtPid){return'pmt';}else if(pmtPid){return'pes';}return null;};var parsePat=function parsePat(packet){var pusi=parsePayloadUnitStartIndicator(packet);var offset=4+parseAdaptionField(packet);if(pusi){offset+=packet[offset]+1;}return(packet[offset+10]&0x1f)<<8|packet[offset+11];};var parsePmt=function parsePmt(packet){var programMapTable={};var pusi=parsePayloadUnitStartIndicator(packet);var payloadOffset=4+parseAdaptionField(packet);if(pusi){payloadOffset+=packet[payloadOffset]+1;}// PMTs can be sent ahead of the time when they should actually
// take effect. We don't believe this should ever be the case
// for HLS but we'll ignore "forward" PMT declarations if we see
// them. Future PMT declarations have the current_next_indicator
// set to zero.
if(!(packet[payloadOffset+5]&0x01)){return;}var sectionLength,tableEnd,programInfoLength;// the mapping table ends at the end of the current section
sectionLength=(packet[payloadOffset+1]&0x0f)<<8|packet[payloadOffset+2];tableEnd=3+sectionLength-4;// to determine where the table is, we have to figure out how
// long the program info descriptors are
programInfoLength=(packet[payloadOffset+10]&0x0f)<<8|packet[payloadOffset+11];// advance the offset to the first entry in the mapping table
var offset=12+programInfoLength;while(offset<tableEnd){var i=payloadOffset+offset;// add an entry that maps the elementary_pid to the stream_type
programMapTable[(packet[i+1]&0x1F)<<8|packet[i+2]]=packet[i];// move to the next table entry
// skip past the elementary stream descriptors, if present
offset+=((packet[i+3]&0x0F)<<8|packet[i+4])+5;}return programMapTable;};var parsePesType=function parsePesType(packet,programMapTable){var pid=parsePid(packet);var type=programMapTable[pid];switch(type){case streamTypes.H264_STREAM_TYPE:return'video';case streamTypes.ADTS_STREAM_TYPE:return'audio';case streamTypes.METADATA_STREAM_TYPE:return'timed-metadata';default:return null;}};var parsePesTime=function parsePesTime(packet){var pusi=parsePayloadUnitStartIndicator(packet);if(!pusi){return null;}var offset=4+parseAdaptionField(packet);if(offset>=packet.byteLength){// From the H 222.0 MPEG-TS spec
// "For transport stream packets carrying PES packets, stuffing is needed when there
//  is insufficient PES packet data to completely fill the transport stream packet
//  payload bytes. Stuffing is accomplished by defining an adaptation field longer than
//  the sum of the lengths of the data elements in it, so that the payload bytes
//  remaining after the adaptation field exactly accommodates the available PES packet
//  data."
//
// If the offset is >= the length of the packet, then the packet contains no data
// and instead is just adaption field stuffing bytes
return null;}var pes=null;var ptsDtsFlags;// PES packets may be annotated with a PTS value, or a PTS value
// and a DTS value. Determine what combination of values is
// available to work with.
ptsDtsFlags=packet[offset+7];// PTS and DTS are normally stored as a 33-bit number.  Javascript
// performs all bitwise operations on 32-bit integers but javascript
// supports a much greater range (52-bits) of integer using standard
// mathematical operations.
// We construct a 31-bit value using bitwise operators over the 31
// most significant bits and then multiply by 4 (equal to a left-shift
// of 2) before we add the final 2 least significant bits of the
// timestamp (equal to an OR.)
if(ptsDtsFlags&0xC0){pes={};// the PTS and DTS are not written out directly. For information
// on how they are encoded, see
// http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
pes.pts=(packet[offset+9]&0x0E)<<27|(packet[offset+10]&0xFF)<<20|(packet[offset+11]&0xFE)<<12|(packet[offset+12]&0xFF)<<5|(packet[offset+13]&0xFE)>>>3;pes.pts*=4;// Left shift by 2
pes.pts+=(packet[offset+13]&0x06)>>>1;// OR by the two LSBs
pes.dts=pes.pts;if(ptsDtsFlags&0x40){pes.dts=(packet[offset+14]&0x0E)<<27|(packet[offset+15]&0xFF)<<20|(packet[offset+16]&0xFE)<<12|(packet[offset+17]&0xFF)<<5|(packet[offset+18]&0xFE)>>>3;pes.dts*=4;// Left shift by 2
pes.dts+=(packet[offset+18]&0x06)>>>1;// OR by the two LSBs
}}return pes;};var parseNalUnitType=function parseNalUnitType(type){switch(type){case 0x05:return'slice_layer_without_partitioning_rbsp_idr';case 0x06:return'sei_rbsp';case 0x07:return'seq_parameter_set_rbsp';case 0x08:return'pic_parameter_set_rbsp';case 0x09:return'access_unit_delimiter_rbsp';default:return null;}};var videoPacketContainsKeyFrame=function videoPacketContainsKeyFrame(packet){var offset=4+parseAdaptionField(packet);var frameBuffer=packet.subarray(offset);var frameI=0;var frameSyncPoint=0;var foundKeyFrame=false;var nalType;// advance the sync point to a NAL start, if necessary
for(;frameSyncPoint<frameBuffer.byteLength-3;frameSyncPoint++){if(frameBuffer[frameSyncPoint+2]===1){// the sync point is properly aligned
frameI=frameSyncPoint+5;break;}}while(frameI<frameBuffer.byteLength){// look at the current byte to determine if we've hit the end of
// a NAL unit boundary
switch(frameBuffer[frameI]){case 0:// skip past non-sync sequences
if(frameBuffer[frameI-1]!==0){frameI+=2;break;}else if(frameBuffer[frameI-2]!==0){frameI++;break;}if(frameSyncPoint+3!==frameI-2){nalType=parseNalUnitType(frameBuffer[frameSyncPoint+3]&0x1f);if(nalType==='slice_layer_without_partitioning_rbsp_idr'){foundKeyFrame=true;}}// drop trailing zeroes
do{frameI++;}while(frameBuffer[frameI]!==1&&frameI<frameBuffer.length);frameSyncPoint=frameI-2;frameI+=3;break;case 1:// skip past non-sync sequences
if(frameBuffer[frameI-1]!==0||frameBuffer[frameI-2]!==0){frameI+=3;break;}nalType=parseNalUnitType(frameBuffer[frameSyncPoint+3]&0x1f);if(nalType==='slice_layer_without_partitioning_rbsp_idr'){foundKeyFrame=true;}frameSyncPoint=frameI-2;frameI+=3;break;default:// the current byte isn't a one or zero, so it cannot be part
// of a sync sequence
frameI+=3;break;}}frameBuffer=frameBuffer.subarray(frameSyncPoint);frameI-=frameSyncPoint;frameSyncPoint=0;// parse the final nal
if(frameBuffer&&frameBuffer.byteLength>3){nalType=parseNalUnitType(frameBuffer[frameSyncPoint+3]&0x1f);if(nalType==='slice_layer_without_partitioning_rbsp_idr'){foundKeyFrame=true;}}return foundKeyFrame;};var probe$1={parseType:parseType,parsePat:parsePat,parsePmt:parsePmt,parsePayloadUnitStartIndicator:parsePayloadUnitStartIndicator,parsePesType:parsePesType,parsePesTime:parsePesTime,videoPacketContainsKeyFrame:videoPacketContainsKeyFrame};var handleRollover=timestampRolloverStream.handleRollover;var probe={};probe.ts=probe$1;probe.aac=utils;var ONE_SECOND_IN_TS=clock.ONE_SECOND_IN_TS;var MP2T_PACKET_LENGTH=188,// bytes
SYNC_BYTE=0x47;/**
   * walks through segment data looking for pat and pmt packets to parse out
   * program map table information
   */var parsePsi_=function parsePsi_(bytes,pmt){var startIndex=0,endIndex=MP2T_PACKET_LENGTH,packet,type;while(endIndex<bytes.byteLength){// Look for a pair of start and end sync bytes in the data..
if(bytes[startIndex]===SYNC_BYTE&&bytes[endIndex]===SYNC_BYTE){// We found a packet
packet=bytes.subarray(startIndex,endIndex);type=probe.ts.parseType(packet,pmt.pid);switch(type){case'pat':pmt.pid=probe.ts.parsePat(packet);break;case'pmt':var table=probe.ts.parsePmt(packet);pmt.table=pmt.table||{};Object.keys(table).forEach(function(key){pmt.table[key]=table[key];});break;}startIndex+=MP2T_PACKET_LENGTH;endIndex+=MP2T_PACKET_LENGTH;continue;}// If we get here, we have somehow become de-synchronized and we need to step
// forward one byte at a time until we find a pair of sync bytes that denote
// a packet
startIndex++;endIndex++;}};/**
   * walks through the segment data from the start and end to get timing information
   * for the first and last audio pes packets
   */var parseAudioPes_=function parseAudioPes_(bytes,pmt,result){var startIndex=0,endIndex=MP2T_PACKET_LENGTH,packet,type,pesType,pusi,parsed;var endLoop=false;// Start walking from start of segment to get first audio packet
while(endIndex<=bytes.byteLength){// Look for a pair of start and end sync bytes in the data..
if(bytes[startIndex]===SYNC_BYTE&&(bytes[endIndex]===SYNC_BYTE||endIndex===bytes.byteLength)){// We found a packet
packet=bytes.subarray(startIndex,endIndex);type=probe.ts.parseType(packet,pmt.pid);switch(type){case'pes':pesType=probe.ts.parsePesType(packet,pmt.table);pusi=probe.ts.parsePayloadUnitStartIndicator(packet);if(pesType==='audio'&&pusi){parsed=probe.ts.parsePesTime(packet);if(parsed){parsed.type='audio';result.audio.push(parsed);endLoop=true;}}break;}if(endLoop){break;}startIndex+=MP2T_PACKET_LENGTH;endIndex+=MP2T_PACKET_LENGTH;continue;}// If we get here, we have somehow become de-synchronized and we need to step
// forward one byte at a time until we find a pair of sync bytes that denote
// a packet
startIndex++;endIndex++;}// Start walking from end of segment to get last audio packet
endIndex=bytes.byteLength;startIndex=endIndex-MP2T_PACKET_LENGTH;endLoop=false;while(startIndex>=0){// Look for a pair of start and end sync bytes in the data..
if(bytes[startIndex]===SYNC_BYTE&&(bytes[endIndex]===SYNC_BYTE||endIndex===bytes.byteLength)){// We found a packet
packet=bytes.subarray(startIndex,endIndex);type=probe.ts.parseType(packet,pmt.pid);switch(type){case'pes':pesType=probe.ts.parsePesType(packet,pmt.table);pusi=probe.ts.parsePayloadUnitStartIndicator(packet);if(pesType==='audio'&&pusi){parsed=probe.ts.parsePesTime(packet);if(parsed){parsed.type='audio';result.audio.push(parsed);endLoop=true;}}break;}if(endLoop){break;}startIndex-=MP2T_PACKET_LENGTH;endIndex-=MP2T_PACKET_LENGTH;continue;}// If we get here, we have somehow become de-synchronized and we need to step
// forward one byte at a time until we find a pair of sync bytes that denote
// a packet
startIndex--;endIndex--;}};/**
   * walks through the segment data from the start and end to get timing information
   * for the first and last video pes packets as well as timing information for the first
   * key frame.
   */var parseVideoPes_=function parseVideoPes_(bytes,pmt,result){var startIndex=0,endIndex=MP2T_PACKET_LENGTH,packet,type,pesType,pusi,parsed,frame,i,pes;var endLoop=false;var currentFrame={data:[],size:0};// Start walking from start of segment to get first video packet
while(endIndex<bytes.byteLength){// Look for a pair of start and end sync bytes in the data..
if(bytes[startIndex]===SYNC_BYTE&&bytes[endIndex]===SYNC_BYTE){// We found a packet
packet=bytes.subarray(startIndex,endIndex);type=probe.ts.parseType(packet,pmt.pid);switch(type){case'pes':pesType=probe.ts.parsePesType(packet,pmt.table);pusi=probe.ts.parsePayloadUnitStartIndicator(packet);if(pesType==='video'){if(pusi&&!endLoop){parsed=probe.ts.parsePesTime(packet);if(parsed){parsed.type='video';result.video.push(parsed);endLoop=true;}}if(!result.firstKeyFrame){if(pusi){if(currentFrame.size!==0){frame=new Uint8Array(currentFrame.size);i=0;while(currentFrame.data.length){pes=currentFrame.data.shift();frame.set(pes,i);i+=pes.byteLength;}if(probe.ts.videoPacketContainsKeyFrame(frame)){var firstKeyFrame=probe.ts.parsePesTime(frame);// PTS/DTS may not be available. Simply *not* setting
// the keyframe seems to work fine with HLS playback
// and definitely preferable to a crash with TypeError...
if(firstKeyFrame){result.firstKeyFrame=firstKeyFrame;result.firstKeyFrame.type='video';}else{// eslint-disable-next-line
console.warn('Failed to extract PTS/DTS from PES at first keyframe. '+'This could be an unusual TS segment, or else mux.js did not '+'parse your TS segment correctly. If you know your TS '+'segments do contain PTS/DTS on keyframes please file a bug '+'report! You can try ffprobe to double check for yourself.');}}currentFrame.size=0;}}currentFrame.data.push(packet);currentFrame.size+=packet.byteLength;}}break;}if(endLoop&&result.firstKeyFrame){break;}startIndex+=MP2T_PACKET_LENGTH;endIndex+=MP2T_PACKET_LENGTH;continue;}// If we get here, we have somehow become de-synchronized and we need to step
// forward one byte at a time until we find a pair of sync bytes that denote
// a packet
startIndex++;endIndex++;}// Start walking from end of segment to get last video packet
endIndex=bytes.byteLength;startIndex=endIndex-MP2T_PACKET_LENGTH;endLoop=false;while(startIndex>=0){// Look for a pair of start and end sync bytes in the data..
if(bytes[startIndex]===SYNC_BYTE&&bytes[endIndex]===SYNC_BYTE){// We found a packet
packet=bytes.subarray(startIndex,endIndex);type=probe.ts.parseType(packet,pmt.pid);switch(type){case'pes':pesType=probe.ts.parsePesType(packet,pmt.table);pusi=probe.ts.parsePayloadUnitStartIndicator(packet);if(pesType==='video'&&pusi){parsed=probe.ts.parsePesTime(packet);if(parsed){parsed.type='video';result.video.push(parsed);endLoop=true;}}break;}if(endLoop){break;}startIndex-=MP2T_PACKET_LENGTH;endIndex-=MP2T_PACKET_LENGTH;continue;}// If we get here, we have somehow become de-synchronized and we need to step
// forward one byte at a time until we find a pair of sync bytes that denote
// a packet
startIndex--;endIndex--;}};/**
   * Adjusts the timestamp information for the segment to account for
   * rollover and convert to seconds based on pes packet timescale (90khz clock)
   */var adjustTimestamp_=function adjustTimestamp_(segmentInfo,baseTimestamp){if(segmentInfo.audio&&segmentInfo.audio.length){var audioBaseTimestamp=baseTimestamp;if(typeof audioBaseTimestamp==='undefined'||isNaN(audioBaseTimestamp)){audioBaseTimestamp=segmentInfo.audio[0].dts;}segmentInfo.audio.forEach(function(info){info.dts=handleRollover(info.dts,audioBaseTimestamp);info.pts=handleRollover(info.pts,audioBaseTimestamp);// time in seconds
info.dtsTime=info.dts/ONE_SECOND_IN_TS;info.ptsTime=info.pts/ONE_SECOND_IN_TS;});}if(segmentInfo.video&&segmentInfo.video.length){var videoBaseTimestamp=baseTimestamp;if(typeof videoBaseTimestamp==='undefined'||isNaN(videoBaseTimestamp)){videoBaseTimestamp=segmentInfo.video[0].dts;}segmentInfo.video.forEach(function(info){info.dts=handleRollover(info.dts,videoBaseTimestamp);info.pts=handleRollover(info.pts,videoBaseTimestamp);// time in seconds
info.dtsTime=info.dts/ONE_SECOND_IN_TS;info.ptsTime=info.pts/ONE_SECOND_IN_TS;});if(segmentInfo.firstKeyFrame){var frame=segmentInfo.firstKeyFrame;frame.dts=handleRollover(frame.dts,videoBaseTimestamp);frame.pts=handleRollover(frame.pts,videoBaseTimestamp);// time in seconds
frame.dtsTime=frame.dts/ONE_SECOND_IN_TS;frame.ptsTime=frame.pts/ONE_SECOND_IN_TS;}}};/**
   * inspects the aac data stream for start and end time information
   */var inspectAac_=function inspectAac_(bytes){var endLoop=false,audioCount=0,sampleRate=null,timestamp=null,frameSize=0,byteIndex=0,packet;while(bytes.length-byteIndex>=3){var type=probe.aac.parseType(bytes,byteIndex);switch(type){case'timed-metadata':// Exit early because we don't have enough to parse
// the ID3 tag header
if(bytes.length-byteIndex<10){endLoop=true;break;}frameSize=probe.aac.parseId3TagSize(bytes,byteIndex);// Exit early if we don't have enough in the buffer
// to emit a full packet
if(frameSize>bytes.length){endLoop=true;break;}if(timestamp===null){packet=bytes.subarray(byteIndex,byteIndex+frameSize);timestamp=probe.aac.parseAacTimestamp(packet);}byteIndex+=frameSize;break;case'audio':// Exit early because we don't have enough to parse
// the ADTS frame header
if(bytes.length-byteIndex<7){endLoop=true;break;}frameSize=probe.aac.parseAdtsSize(bytes,byteIndex);// Exit early if we don't have enough in the buffer
// to emit a full packet
if(frameSize>bytes.length){endLoop=true;break;}if(sampleRate===null){packet=bytes.subarray(byteIndex,byteIndex+frameSize);sampleRate=probe.aac.parseSampleRate(packet);}audioCount++;byteIndex+=frameSize;break;default:byteIndex++;break;}if(endLoop){return null;}}if(sampleRate===null||timestamp===null){return null;}var audioTimescale=ONE_SECOND_IN_TS/sampleRate;var result={audio:[{type:'audio',dts:timestamp,pts:timestamp},{type:'audio',dts:timestamp+audioCount*1024*audioTimescale,pts:timestamp+audioCount*1024*audioTimescale}]};return result;};/**
   * inspects the transport stream segment data for start and end time information
   * of the audio and video tracks (when present) as well as the first key frame's
   * start time.
   */var inspectTs_=function inspectTs_(bytes){var pmt={pid:null,table:null};var result={};parsePsi_(bytes,pmt);for(var pid in pmt.table){if(pmt.table.hasOwnProperty(pid)){var type=pmt.table[pid];switch(type){case streamTypes.H264_STREAM_TYPE:result.video=[];parseVideoPes_(bytes,pmt,result);if(result.video.length===0){delete result.video;}break;case streamTypes.ADTS_STREAM_TYPE:result.audio=[];parseAudioPes_(bytes,pmt,result);if(result.audio.length===0){delete result.audio;}break;}}}return result;};/**
   * Inspects segment byte data and returns an object with start and end timing information
   *
   * @param {Uint8Array} bytes The segment byte data
   * @param {Number} baseTimestamp Relative reference timestamp used when adjusting frame
   *  timestamps for rollover. This value must be in 90khz clock.
   * @return {Object} Object containing start and end frame timing info of segment.
   */var inspect=function inspect(bytes,baseTimestamp){var isAacData=probe.aac.isLikelyAacData(bytes);var result;if(isAacData){result=inspectAac_(bytes);}else{result=inspectTs_(bytes);}if(!result||!result.audio&&!result.video){return null;}adjustTimestamp_(result,baseTimestamp);return result;};var tsInspector={inspect:inspect,parseAudioPes_:parseAudioPes_};/* global self */ /**
   * Re-emits transmuxer events by converting them into messages to the
   * world outside the worker.
   *
   * @param {Object} transmuxer the transmuxer to wire events on
   * @private
   */var wireTransmuxerEvents=function wireTransmuxerEvents(self,transmuxer){transmuxer.on('data',function(segment){// transfer ownership of the underlying ArrayBuffer
// instead of doing a copy to save memory
// ArrayBuffers are transferable but generic TypedArrays are not
// @link https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Using_web_workers#Passing_data_by_transferring_ownership_(transferable_objects)
var initArray=segment.initSegment;segment.initSegment={data:initArray.buffer,byteOffset:initArray.byteOffset,byteLength:initArray.byteLength};var typedArray=segment.data;segment.data=typedArray.buffer;self.postMessage({action:'data',segment:segment,byteOffset:typedArray.byteOffset,byteLength:typedArray.byteLength},[segment.data]);});transmuxer.on('done',function(data){self.postMessage({action:'done'});});transmuxer.on('gopInfo',function(gopInfo){self.postMessage({action:'gopInfo',gopInfo:gopInfo});});transmuxer.on('videoSegmentTimingInfo',function(timingInfo){var videoSegmentTimingInfo={start:{decode:clock.videoTsToSeconds(timingInfo.start.dts),presentation:clock.videoTsToSeconds(timingInfo.start.pts)},end:{decode:clock.videoTsToSeconds(timingInfo.end.dts),presentation:clock.videoTsToSeconds(timingInfo.end.pts)},baseMediaDecodeTime:clock.videoTsToSeconds(timingInfo.baseMediaDecodeTime)};if(timingInfo.prependedContentDuration){videoSegmentTimingInfo.prependedContentDuration=clock.videoTsToSeconds(timingInfo.prependedContentDuration);}self.postMessage({action:'videoSegmentTimingInfo',videoSegmentTimingInfo:videoSegmentTimingInfo});});transmuxer.on('audioSegmentTimingInfo',function(timingInfo){// Note that all times for [audio/video]SegmentTimingInfo events are in video clock
var audioSegmentTimingInfo={start:{decode:clock.videoTsToSeconds(timingInfo.start.dts),presentation:clock.videoTsToSeconds(timingInfo.start.pts)},end:{decode:clock.videoTsToSeconds(timingInfo.end.dts),presentation:clock.videoTsToSeconds(timingInfo.end.pts)},baseMediaDecodeTime:clock.videoTsToSeconds(timingInfo.baseMediaDecodeTime)};if(timingInfo.prependedContentDuration){audioSegmentTimingInfo.prependedContentDuration=clock.videoTsToSeconds(timingInfo.prependedContentDuration);}self.postMessage({action:'audioSegmentTimingInfo',audioSegmentTimingInfo:audioSegmentTimingInfo});});transmuxer.on('id3Frame',function(id3Frame){self.postMessage({action:'id3Frame',id3Frame:id3Frame});});transmuxer.on('caption',function(caption){self.postMessage({action:'caption',caption:caption});});transmuxer.on('trackinfo',function(trackInfo){self.postMessage({action:'trackinfo',trackInfo:trackInfo});});transmuxer.on('audioTimingInfo',function(audioTimingInfo){// convert to video TS since we prioritize video time over audio
self.postMessage({action:'audioTimingInfo',audioTimingInfo:{start:clock.videoTsToSeconds(audioTimingInfo.start),end:clock.videoTsToSeconds(audioTimingInfo.end)}});});transmuxer.on('videoTimingInfo',function(videoTimingInfo){self.postMessage({action:'videoTimingInfo',videoTimingInfo:{start:clock.videoTsToSeconds(videoTimingInfo.start),end:clock.videoTsToSeconds(videoTimingInfo.end)}});});transmuxer.on('log',function(log){self.postMessage({action:'log',log:log});});};/**
   * All incoming messages route through this hash. If no function exists
   * to handle an incoming message, then we ignore the message.
   *
   * @class MessageHandlers
   * @param {Object} options the options to initialize with
   */var MessageHandlers=/*#__PURE__*/function(){function MessageHandlers(self,options){this.options=options||{};this.self=self;this.init();}/**
     * initialize our web worker and wire all the events.
     */var _proto=MessageHandlers.prototype;_proto.init=function init(){if(this.transmuxer){this.transmuxer.dispose();}this.transmuxer=new transmuxer.Transmuxer(this.options);wireTransmuxerEvents(this.self,this.transmuxer);};_proto.pushMp4Captions=function pushMp4Captions(data){if(!this.captionParser){this.captionParser=new captionParser();this.captionParser.init();}var segment=new Uint8Array(data.data,data.byteOffset,data.byteLength);var parsed=this.captionParser.parse(segment,data.trackIds,data.timescales);this.self.postMessage({action:'mp4Captions',captions:parsed&&parsed.captions||[],logs:parsed&&parsed.logs||[],data:segment.buffer},[segment.buffer]);};_proto.probeMp4StartTime=function probeMp4StartTime(_ref){var timescales=_ref.timescales,data=_ref.data;var startTime=probe$2.startTime(timescales,data);this.self.postMessage({action:'probeMp4StartTime',startTime:startTime,data:data},[data.buffer]);};_proto.probeMp4Tracks=function probeMp4Tracks(_ref2){var data=_ref2.data;var tracks=probe$2.tracks(data);this.self.postMessage({action:'probeMp4Tracks',tracks:tracks,data:data},[data.buffer]);}/**
     * Probe an mpeg2-ts segment to determine the start time of the segment in it's
     * internal "media time," as well as whether it contains video and/or audio.
     *
     * @private
     * @param {Uint8Array} bytes - segment bytes
     * @param {number} baseStartTime
     *        Relative reference timestamp used when adjusting frame timestamps for rollover.
     *        This value should be in seconds, as it's converted to a 90khz clock within the
     *        function body.
     * @return {Object} The start time of the current segment in "media time" as well as
     *                  whether it contains video and/or audio
     */;_proto.probeTs=function probeTs(_ref3){var data=_ref3.data,baseStartTime=_ref3.baseStartTime;var tsStartTime=typeof baseStartTime==='number'&&!isNaN(baseStartTime)?baseStartTime*clock.ONE_SECOND_IN_TS:void 0;var timeInfo=tsInspector.inspect(data,tsStartTime);var result=null;if(timeInfo){result={// each type's time info comes back as an array of 2 times, start and end
hasVideo:timeInfo.video&&timeInfo.video.length===2||false,hasAudio:timeInfo.audio&&timeInfo.audio.length===2||false};if(result.hasVideo){result.videoStart=timeInfo.video[0].ptsTime;}if(result.hasAudio){result.audioStart=timeInfo.audio[0].ptsTime;}}this.self.postMessage({action:'probeTs',result:result,data:data},[data.buffer]);};_proto.clearAllMp4Captions=function clearAllMp4Captions(){if(this.captionParser){this.captionParser.clearAllCaptions();}};_proto.clearParsedMp4Captions=function clearParsedMp4Captions(){if(this.captionParser){this.captionParser.clearParsedCaptions();}}/**
     * Adds data (a ts segment) to the start of the transmuxer pipeline for
     * processing.
     *
     * @param {ArrayBuffer} data data to push into the muxer
     */;_proto.push=function push(data){// Cast array buffer to correct type for transmuxer
var segment=new Uint8Array(data.data,data.byteOffset,data.byteLength);this.transmuxer.push(segment);}/**
     * Recreate the transmuxer so that the next segment added via `push`
     * start with a fresh transmuxer.
     */;_proto.reset=function reset(){this.transmuxer.reset();}/**
     * Set the value that will be used as the `baseMediaDecodeTime` time for the
     * next segment pushed in. Subsequent segments will have their `baseMediaDecodeTime`
     * set relative to the first based on the PTS values.
     *
     * @param {Object} data used to set the timestamp offset in the muxer
     */;_proto.setTimestampOffset=function setTimestampOffset(data){var timestampOffset=data.timestampOffset||0;this.transmuxer.setBaseMediaDecodeTime(Math.round(clock.secondsToVideoTs(timestampOffset)));};_proto.setAudioAppendStart=function setAudioAppendStart(data){this.transmuxer.setAudioAppendStart(Math.ceil(clock.secondsToVideoTs(data.appendStart)));};_proto.setRemux=function setRemux(data){this.transmuxer.setRemux(data.remux);}/**
     * Forces the pipeline to finish processing the last segment and emit it's
     * results.
     *
     * @param {Object} data event data, not really used
     */;_proto.flush=function flush(data){this.transmuxer.flush();// transmuxed done action is fired after both audio/video pipelines are flushed
self.postMessage({action:'done',type:'transmuxed'});};_proto.endTimeline=function endTimeline(){this.transmuxer.endTimeline();// transmuxed endedtimeline action is fired after both audio/video pipelines end their
// timelines
self.postMessage({action:'endedtimeline',type:'transmuxed'});};_proto.alignGopsWith=function alignGopsWith(data){this.transmuxer.alignGopsWith(data.gopsToAlignWith.slice());};return MessageHandlers;}();/**
   * Our web worker interface so that things can talk to mux.js
   * that will be running in a web worker. the scope is passed to this by
   * webworkify.
   *
   * @param {Object} self the scope for the web worker
   */self.onmessage=function(event){if(event.data.action==='init'&&event.data.options){this.messageHandlers=new MessageHandlers(self,event.data.options);return;}if(!this.messageHandlers){this.messageHandlers=new MessageHandlers(self);}if(event.data&&event.data.action&&event.data.action!=='init'){if(this.messageHandlers[event.data.action]){this.messageHandlers[event.data.action](event.data);}}};}));var TransmuxWorker=factory(workerCode$1);/* rollup-plugin-worker-factory end for worker!/home/runner/work/http-streaming/http-streaming/src/transmuxer-worker.js */var handleData_=function handleData_(event,transmuxedData,callback){var _event$data$segment=event.data.segment,type=_event$data$segment.type,initSegment=_event$data$segment.initSegment,captions=_event$data$segment.captions,captionStreams=_event$data$segment.captionStreams,metadata=_event$data$segment.metadata,videoFrameDtsTime=_event$data$segment.videoFrameDtsTime,videoFramePtsTime=_event$data$segment.videoFramePtsTime;transmuxedData.buffer.push({captions:captions,captionStreams:captionStreams,metadata:metadata});var boxes=event.data.segment.boxes||{data:event.data.segment.data};var result={type:type,// cast ArrayBuffer to TypedArray
data:new Uint8Array(boxes.data,boxes.data.byteOffset,boxes.data.byteLength),initSegment:new Uint8Array(initSegment.data,initSegment.byteOffset,initSegment.byteLength)};if(typeof videoFrameDtsTime!=='undefined'){result.videoFrameDtsTime=videoFrameDtsTime;}if(typeof videoFramePtsTime!=='undefined'){result.videoFramePtsTime=videoFramePtsTime;}callback(result);};var handleDone_=function handleDone_(_ref){var transmuxedData=_ref.transmuxedData,callback=_ref.callback;// Previously we only returned data on data events,
// not on done events. Clear out the buffer to keep that consistent.
transmuxedData.buffer=[];// all buffers should have been flushed from the muxer, so start processing anything we
// have received
callback(transmuxedData);};var handleGopInfo_=function handleGopInfo_(event,transmuxedData){transmuxedData.gopInfo=event.data.gopInfo;};var processTransmux=function processTransmux(options){var transmuxer=options.transmuxer,bytes=options.bytes,audioAppendStart=options.audioAppendStart,gopsToAlignWith=options.gopsToAlignWith,remux=options.remux,onData=options.onData,onTrackInfo=options.onTrackInfo,onAudioTimingInfo=options.onAudioTimingInfo,onVideoTimingInfo=options.onVideoTimingInfo,onVideoSegmentTimingInfo=options.onVideoSegmentTimingInfo,onAudioSegmentTimingInfo=options.onAudioSegmentTimingInfo,onId3=options.onId3,onCaptions=options.onCaptions,onDone=options.onDone,onEndedTimeline=options.onEndedTimeline,onTransmuxerLog=options.onTransmuxerLog,isEndOfTimeline=options.isEndOfTimeline;var transmuxedData={buffer:[]};var waitForEndedTimelineEvent=isEndOfTimeline;var handleMessage=function handleMessage(event){if(transmuxer.currentTransmux!==options){// disposed
return;}if(event.data.action==='data'){handleData_(event,transmuxedData,onData);}if(event.data.action==='trackinfo'){onTrackInfo(event.data.trackInfo);}if(event.data.action==='gopInfo'){handleGopInfo_(event,transmuxedData);}if(event.data.action==='audioTimingInfo'){onAudioTimingInfo(event.data.audioTimingInfo);}if(event.data.action==='videoTimingInfo'){onVideoTimingInfo(event.data.videoTimingInfo);}if(event.data.action==='videoSegmentTimingInfo'){onVideoSegmentTimingInfo(event.data.videoSegmentTimingInfo);}if(event.data.action==='audioSegmentTimingInfo'){onAudioSegmentTimingInfo(event.data.audioSegmentTimingInfo);}if(event.data.action==='id3Frame'){onId3([event.data.id3Frame],event.data.id3Frame.dispatchType);}if(event.data.action==='caption'){onCaptions(event.data.caption);}if(event.data.action==='endedtimeline'){waitForEndedTimelineEvent=false;onEndedTimeline();}if(event.data.action==='log'){onTransmuxerLog(event.data.log);}// wait for the transmuxed event since we may have audio and video
if(event.data.type!=='transmuxed'){return;}// If the "endedtimeline" event has not yet fired, and this segment represents the end
// of a timeline, that means there may still be data events before the segment
// processing can be considerred complete. In that case, the final event should be
// an "endedtimeline" event with the type "transmuxed."
if(waitForEndedTimelineEvent){return;}transmuxer.onmessage=null;handleDone_({transmuxedData:transmuxedData,callback:onDone});/* eslint-disable no-use-before-define */dequeue(transmuxer);/* eslint-enable */};transmuxer.onmessage=handleMessage;if(audioAppendStart){transmuxer.postMessage({action:'setAudioAppendStart',appendStart:audioAppendStart});}// allow empty arrays to be passed to clear out GOPs
if(Array.isArray(gopsToAlignWith)){transmuxer.postMessage({action:'alignGopsWith',gopsToAlignWith:gopsToAlignWith});}if(typeof remux!=='undefined'){transmuxer.postMessage({action:'setRemux',remux:remux});}if(bytes.byteLength){var buffer=bytes instanceof ArrayBuffer?bytes:bytes.buffer;var byteOffset=bytes instanceof ArrayBuffer?0:bytes.byteOffset;transmuxer.postMessage({action:'push',// Send the typed-array of data as an ArrayBuffer so that
// it can be sent as a "Transferable" and avoid the costly
// memory copy
data:buffer,// To recreate the original typed-array, we need information
// about what portion of the ArrayBuffer it was a view into
byteOffset:byteOffset,byteLength:bytes.byteLength},[buffer]);}if(isEndOfTimeline){transmuxer.postMessage({action:'endTimeline'});}// even if we didn't push any bytes, we have to make sure we flush in case we reached
// the end of the segment
transmuxer.postMessage({action:'flush'});};var dequeue=function dequeue(transmuxer){transmuxer.currentTransmux=null;if(transmuxer.transmuxQueue.length){transmuxer.currentTransmux=transmuxer.transmuxQueue.shift();if(typeof transmuxer.currentTransmux==='function'){transmuxer.currentTransmux();}else{processTransmux(transmuxer.currentTransmux);}}};var processAction=function processAction(transmuxer,action){transmuxer.postMessage({action:action});dequeue(transmuxer);};var enqueueAction=function enqueueAction(action,transmuxer){if(!transmuxer.currentTransmux){transmuxer.currentTransmux=action;processAction(transmuxer,action);return;}transmuxer.transmuxQueue.push(processAction.bind(null,transmuxer,action));};var video_es_reset=function reset(transmuxer){enqueueAction('reset',transmuxer);};var endTimeline=function endTimeline(transmuxer){enqueueAction('endTimeline',transmuxer);};var transmux=function transmux(options){if(!options.transmuxer.currentTransmux){options.transmuxer.currentTransmux=options;processTransmux(options);return;}options.transmuxer.transmuxQueue.push(options);};var createTransmuxer=function createTransmuxer(options){var transmuxer=new TransmuxWorker();transmuxer.currentTransmux=null;transmuxer.transmuxQueue=[];var term=transmuxer.terminate;transmuxer.terminate=function(){transmuxer.currentTransmux=null;transmuxer.transmuxQueue.length=0;return term.call(transmuxer);};transmuxer.postMessage({action:'init',options:options});return transmuxer;};var segmentTransmuxer={reset:video_es_reset,endTimeline:endTimeline,transmux:transmux,createTransmuxer:createTransmuxer};var workerCallback=function workerCallback(options){var transmuxer=options.transmuxer;var endAction=options.endAction||options.action;var callback=options.callback;var message=_extends({},options,{endAction:null,transmuxer:null,callback:null});var listenForEndEvent=function listenForEndEvent(event){if(event.data.action!==endAction){return;}transmuxer.removeEventListener('message',listenForEndEvent);// transfer ownership of bytes back to us.
if(event.data.data){event.data.data=new Uint8Array(event.data.data,options.byteOffset||0,options.byteLength||event.data.data.byteLength);if(options.data){options.data=event.data.data;}}callback(event.data);};transmuxer.addEventListener('message',listenForEndEvent);if(options.data){var isArrayBuffer=options.data instanceof ArrayBuffer;message.byteOffset=isArrayBuffer?0:options.data.byteOffset;message.byteLength=options.data.byteLength;var transfers=[isArrayBuffer?options.data:options.data.buffer];transmuxer.postMessage(message,transfers);}else{transmuxer.postMessage(message);}};var REQUEST_ERRORS={FAILURE:2,TIMEOUT:-101,ABORTED:-102};/**
 * Abort all requests
 *
 * @param {Object} activeXhrs - an object that tracks all XHR requests
 */var abortAll=function abortAll(activeXhrs){activeXhrs.forEach(function(xhr){xhr.abort();});};/**
 * Gather important bandwidth stats once a request has completed
 *
 * @param {Object} request - the XHR request from which to gather stats
 */var getRequestStats=function getRequestStats(request){return{bandwidth:request.bandwidth,bytesReceived:request.bytesReceived||0,roundTripTime:request.roundTripTime||0};};/**
 * If possible gather bandwidth stats as a request is in
 * progress
 *
 * @param {Event} progressEvent - an event object from an XHR's progress event
 */var getProgressStats=function getProgressStats(progressEvent){var request=progressEvent.target;var roundTripTime=Date.now()-request.requestTime;var stats={bandwidth:Infinity,bytesReceived:0,roundTripTime:roundTripTime||0};stats.bytesReceived=progressEvent.loaded;// This can result in Infinity if stats.roundTripTime is 0 but that is ok
// because we should only use bandwidth stats on progress to determine when
// abort a request early due to insufficient bandwidth
stats.bandwidth=Math.floor(stats.bytesReceived/stats.roundTripTime*8*1000);return stats;};/**
 * Handle all error conditions in one place and return an object
 * with all the information
 *
 * @param {Error|null} error - if non-null signals an error occured with the XHR
 * @param {Object} request -  the XHR request that possibly generated the error
 */var handleErrors=function handleErrors(error,request){if(request.timedout){return{status:request.status,message:'HLS request timed-out at URL: '+request.uri,code:REQUEST_ERRORS.TIMEOUT,xhr:request};}if(request.aborted){return{status:request.status,message:'HLS request aborted at URL: '+request.uri,code:REQUEST_ERRORS.ABORTED,xhr:request};}if(error){return{status:request.status,message:'HLS request errored at URL: '+request.uri,code:REQUEST_ERRORS.FAILURE,xhr:request};}if(request.responseType==='arraybuffer'&&request.response.byteLength===0){return{status:request.status,message:'Empty HLS response at URL: '+request.uri,code:REQUEST_ERRORS.FAILURE,xhr:request};}return null;};/**
 * Handle responses for key data and convert the key data to the correct format
 * for the decryption step later
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Array} objects - objects to add the key bytes to.
 * @param {Function} finishProcessingFn - a callback to execute to continue processing
 *                                        this request
 */var handleKeyResponse=function handleKeyResponse(segment,objects,finishProcessingFn){return function(error,request){var response=request.response;var errorObj=handleErrors(error,request);if(errorObj){return finishProcessingFn(errorObj,segment);}if(response.byteLength!==16){return finishProcessingFn({status:request.status,message:'Invalid HLS key at URL: '+request.uri,code:REQUEST_ERRORS.FAILURE,xhr:request},segment);}var view=new DataView(response);var bytes=new Uint32Array([view.getUint32(0),view.getUint32(4),view.getUint32(8),view.getUint32(12)]);for(var i=0;i<objects.length;i++){objects[i].bytes=bytes;}return finishProcessingFn(null,segment);};};var parseInitSegment=function parseInitSegment(segment,_callback){var type=detectContainerForBytes(segment.map.bytes);// TODO: We should also handle ts init segments here, but we
// only know how to parse mp4 init segments at the moment
if(type!=='mp4'){var uri=segment.map.resolvedUri||segment.map.uri;return _callback({internal:true,message:"Found unsupported "+(type||'unknown')+" container for initialization segment at URL: "+uri,code:REQUEST_ERRORS.FAILURE});}workerCallback({action:'probeMp4Tracks',data:segment.map.bytes,transmuxer:segment.transmuxer,callback:function callback(_ref){var tracks=_ref.tracks,data=_ref.data;// transfer bytes back to us
segment.map.bytes=data;tracks.forEach(function(track){segment.map.tracks=segment.map.tracks||{};// only support one track of each type for now
if(segment.map.tracks[track.type]){return;}segment.map.tracks[track.type]=track;if(typeof track.id==='number'&&track.timescale){segment.map.timescales=segment.map.timescales||{};segment.map.timescales[track.id]=track.timescale;}});return _callback(null);}});};/**
 * Handle init-segment responses
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} finishProcessingFn - a callback to execute to continue processing
 *                                        this request
 */var handleInitSegmentResponse=function handleInitSegmentResponse(_ref2){var segment=_ref2.segment,finishProcessingFn=_ref2.finishProcessingFn;return function(error,request){var errorObj=handleErrors(error,request);if(errorObj){return finishProcessingFn(errorObj,segment);}var bytes=new Uint8Array(request.response);// init segment is encypted, we will have to wait
// until the key request is done to decrypt.
if(segment.map.key){segment.map.encryptedBytes=bytes;return finishProcessingFn(null,segment);}segment.map.bytes=bytes;parseInitSegment(segment,function(parseError){if(parseError){parseError.xhr=request;parseError.status=request.status;return finishProcessingFn(parseError,segment);}finishProcessingFn(null,segment);});};};/**
 * Response handler for segment-requests being sure to set the correct
 * property depending on whether the segment is encryped or not
 * Also records and keeps track of stats that are used for ABR purposes
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} finishProcessingFn - a callback to execute to continue processing
 *                                        this request
 */var handleSegmentResponse=function handleSegmentResponse(_ref3){var segment=_ref3.segment,finishProcessingFn=_ref3.finishProcessingFn,responseType=_ref3.responseType;return function(error,request){var errorObj=handleErrors(error,request);if(errorObj){return finishProcessingFn(errorObj,segment);}var newBytes=// although responseText "should" exist, this guard serves to prevent an error being
// thrown for two primary cases:
// 1. the mime type override stops working, or is not implemented for a specific
//    browser
// 2. when using mock XHR libraries like sinon that do not allow the override behavior
responseType==='arraybuffer'||!request.responseText?request.response:stringToArrayBuffer(request.responseText.substring(segment.lastReachedChar||0));segment.stats=getRequestStats(request);if(segment.key){segment.encryptedBytes=new Uint8Array(newBytes);}else{segment.bytes=new Uint8Array(newBytes);}return finishProcessingFn(null,segment);};};var transmuxAndNotify=function transmuxAndNotify(_ref4){var segment=_ref4.segment,bytes=_ref4.bytes,trackInfoFn=_ref4.trackInfoFn,timingInfoFn=_ref4.timingInfoFn,videoSegmentTimingInfoFn=_ref4.videoSegmentTimingInfoFn,audioSegmentTimingInfoFn=_ref4.audioSegmentTimingInfoFn,id3Fn=_ref4.id3Fn,captionsFn=_ref4.captionsFn,isEndOfTimeline=_ref4.isEndOfTimeline,endedTimelineFn=_ref4.endedTimelineFn,dataFn=_ref4.dataFn,doneFn=_ref4.doneFn,onTransmuxerLog=_ref4.onTransmuxerLog;var fmp4Tracks=segment.map&&segment.map.tracks||{};var isMuxed=Boolean(fmp4Tracks.audio&&fmp4Tracks.video);// Keep references to each function so we can null them out after we're done with them.
// One reason for this is that in the case of full segments, we want to trust start
// times from the probe, rather than the transmuxer.
var audioStartFn=timingInfoFn.bind(null,segment,'audio','start');var audioEndFn=timingInfoFn.bind(null,segment,'audio','end');var videoStartFn=timingInfoFn.bind(null,segment,'video','start');var videoEndFn=timingInfoFn.bind(null,segment,'video','end');var finish=function finish(){return transmux({bytes:bytes,transmuxer:segment.transmuxer,audioAppendStart:segment.audioAppendStart,gopsToAlignWith:segment.gopsToAlignWith,remux:isMuxed,onData:function onData(result){result.type=result.type==='combined'?'video':result.type;dataFn(segment,result);},onTrackInfo:function onTrackInfo(trackInfo){if(trackInfoFn){if(isMuxed){trackInfo.isMuxed=true;}trackInfoFn(segment,trackInfo);}},onAudioTimingInfo:function onAudioTimingInfo(audioTimingInfo){// we only want the first start value we encounter
if(audioStartFn&&typeof audioTimingInfo.start!=='undefined'){audioStartFn(audioTimingInfo.start);audioStartFn=null;}// we want to continually update the end time
if(audioEndFn&&typeof audioTimingInfo.end!=='undefined'){audioEndFn(audioTimingInfo.end);}},onVideoTimingInfo:function onVideoTimingInfo(videoTimingInfo){// we only want the first start value we encounter
if(videoStartFn&&typeof videoTimingInfo.start!=='undefined'){videoStartFn(videoTimingInfo.start);videoStartFn=null;}// we want to continually update the end time
if(videoEndFn&&typeof videoTimingInfo.end!=='undefined'){videoEndFn(videoTimingInfo.end);}},onVideoSegmentTimingInfo:function onVideoSegmentTimingInfo(videoSegmentTimingInfo){videoSegmentTimingInfoFn(videoSegmentTimingInfo);},onAudioSegmentTimingInfo:function onAudioSegmentTimingInfo(audioSegmentTimingInfo){audioSegmentTimingInfoFn(audioSegmentTimingInfo);},onId3:function onId3(id3Frames,dispatchType){id3Fn(segment,id3Frames,dispatchType);},onCaptions:function onCaptions(captions){captionsFn(segment,[captions]);},isEndOfTimeline:isEndOfTimeline,onEndedTimeline:function onEndedTimeline(){endedTimelineFn();},onTransmuxerLog:onTransmuxerLog,onDone:function onDone(result){if(!doneFn){return;}result.type=result.type==='combined'?'video':result.type;doneFn(null,segment,result);}});};// In the transmuxer, we don't yet have the ability to extract a "proper" start time.
// Meaning cached frame data may corrupt our notion of where this segment
// really starts. To get around this, probe for the info needed.
workerCallback({action:'probeTs',transmuxer:segment.transmuxer,data:bytes,baseStartTime:segment.baseStartTime,callback:function callback(data){segment.bytes=bytes=data.data;var probeResult=data.result;if(probeResult){trackInfoFn(segment,{hasAudio:probeResult.hasAudio,hasVideo:probeResult.hasVideo,isMuxed:isMuxed});trackInfoFn=null;if(probeResult.hasAudio&&!isMuxed){audioStartFn(probeResult.audioStart);}if(probeResult.hasVideo){videoStartFn(probeResult.videoStart);}audioStartFn=null;videoStartFn=null;}finish();}});};var handleSegmentBytes=function handleSegmentBytes(_ref5){var segment=_ref5.segment,bytes=_ref5.bytes,trackInfoFn=_ref5.trackInfoFn,timingInfoFn=_ref5.timingInfoFn,videoSegmentTimingInfoFn=_ref5.videoSegmentTimingInfoFn,audioSegmentTimingInfoFn=_ref5.audioSegmentTimingInfoFn,id3Fn=_ref5.id3Fn,captionsFn=_ref5.captionsFn,isEndOfTimeline=_ref5.isEndOfTimeline,endedTimelineFn=_ref5.endedTimelineFn,dataFn=_ref5.dataFn,doneFn=_ref5.doneFn,onTransmuxerLog=_ref5.onTransmuxerLog;var bytesAsUint8Array=new Uint8Array(bytes);// TODO:
// We should have a handler that fetches the number of bytes required
// to check if something is fmp4. This will allow us to save bandwidth
// because we can only blacklist a playlist and abort requests
// by codec after trackinfo triggers.
if(isLikelyFmp4MediaSegment(bytesAsUint8Array)){segment.isFmp4=true;var tracks=segment.map.tracks;var trackInfo={isFmp4:true,hasVideo:!!tracks.video,hasAudio:!!tracks.audio};// if we have a audio track, with a codec that is not set to
// encrypted audio
if(tracks.audio&&tracks.audio.codec&&tracks.audio.codec!=='enca'){trackInfo.audioCodec=tracks.audio.codec;}// if we have a video track, with a codec that is not set to
// encrypted video
if(tracks.video&&tracks.video.codec&&tracks.video.codec!=='encv'){trackInfo.videoCodec=tracks.video.codec;}if(tracks.video&&tracks.audio){trackInfo.isMuxed=true;}// since we don't support appending fmp4 data on progress, we know we have the full
// segment here
trackInfoFn(segment,trackInfo);// The probe doesn't provide the segment end time, so only callback with the start
// time. The end time can be roughly calculated by the receiver using the duration.
//
// Note that the start time returned by the probe reflects the baseMediaDecodeTime, as
// that is the true start of the segment (where the playback engine should begin
// decoding).
var finishLoading=function finishLoading(captions){// if the track still has audio at this point it is only possible
// for it to be audio only. See `tracks.video && tracks.audio` if statement
// above.
// we make sure to use segment.bytes here as that
dataFn(segment,{data:bytesAsUint8Array,type:trackInfo.hasAudio&&!trackInfo.isMuxed?'audio':'video'});if(captions&&captions.length){captionsFn(segment,captions);}doneFn(null,segment,{});};workerCallback({action:'probeMp4StartTime',timescales:segment.map.timescales,data:bytesAsUint8Array,transmuxer:segment.transmuxer,callback:function callback(_ref6){var data=_ref6.data,startTime=_ref6.startTime;// transfer bytes back to us
bytes=data.buffer;segment.bytes=bytesAsUint8Array=data;if(trackInfo.hasAudio&&!trackInfo.isMuxed){timingInfoFn(segment,'audio','start',startTime);}if(trackInfo.hasVideo){timingInfoFn(segment,'video','start',startTime);}// Run through the CaptionParser in case there are captions.
// Initialize CaptionParser if it hasn't been yet
if(!tracks.video||!data.byteLength||!segment.transmuxer){finishLoading();return;}workerCallback({action:'pushMp4Captions',endAction:'mp4Captions',transmuxer:segment.transmuxer,data:bytesAsUint8Array,timescales:segment.map.timescales,trackIds:[tracks.video.id],callback:function callback(message){// transfer bytes back to us
bytes=message.data.buffer;segment.bytes=bytesAsUint8Array=message.data;message.logs.forEach(function(log){onTransmuxerLog(videojs.mergeOptions(log,{stream:'mp4CaptionParser'}));});finishLoading(message.captions);}});}});return;}// VTT or other segments that don't need processing
if(!segment.transmuxer){doneFn(null,segment,{});return;}if(typeof segment.container==='undefined'){segment.container=detectContainerForBytes(bytesAsUint8Array);}if(segment.container!=='ts'&&segment.container!=='aac'){trackInfoFn(segment,{hasAudio:false,hasVideo:false});doneFn(null,segment,{});return;}// ts or aac
transmuxAndNotify({segment:segment,bytes:bytes,trackInfoFn:trackInfoFn,timingInfoFn:timingInfoFn,videoSegmentTimingInfoFn:videoSegmentTimingInfoFn,audioSegmentTimingInfoFn:audioSegmentTimingInfoFn,id3Fn:id3Fn,captionsFn:captionsFn,isEndOfTimeline:isEndOfTimeline,endedTimelineFn:endedTimelineFn,dataFn:dataFn,doneFn:doneFn,onTransmuxerLog:onTransmuxerLog});};var decrypt=function decrypt(_ref7,callback){var id=_ref7.id,key=_ref7.key,encryptedBytes=_ref7.encryptedBytes,decryptionWorker=_ref7.decryptionWorker;var decryptionHandler=function decryptionHandler(event){if(event.data.source===id){decryptionWorker.removeEventListener('message',decryptionHandler);var decrypted=event.data.decrypted;callback(new Uint8Array(decrypted.bytes,decrypted.byteOffset,decrypted.byteLength));}};decryptionWorker.addEventListener('message',decryptionHandler);var keyBytes;if(key.bytes.slice){keyBytes=key.bytes.slice();}else{keyBytes=new Uint32Array(Array.prototype.slice.call(key.bytes));}// incrementally decrypt the bytes
decryptionWorker.postMessage(createTransferableMessage({source:id,encrypted:encryptedBytes,key:keyBytes,iv:key.iv}),[encryptedBytes.buffer,keyBytes.buffer]);};/**
 * Decrypt the segment via the decryption web worker
 *
 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128 decryption
 *                                       routines
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} trackInfoFn - a callback that receives track info
 * @param {Function} timingInfoFn - a callback that receives timing info
 * @param {Function} videoSegmentTimingInfoFn
 *                   a callback that receives video timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} audioSegmentTimingInfoFn
 *                   a callback that receives audio timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {boolean}  isEndOfTimeline
 *                   true if this segment represents the last segment in a timeline
 * @param {Function} endedTimelineFn
 *                   a callback made when a timeline is ended, will only be called if
 *                   isEndOfTimeline is true
 * @param {Function} dataFn - a callback that is executed when segment bytes are available
 *                            and ready to use
 * @param {Function} doneFn - a callback that is executed after decryption has completed
 */var decryptSegment=function decryptSegment(_ref8){var decryptionWorker=_ref8.decryptionWorker,segment=_ref8.segment,trackInfoFn=_ref8.trackInfoFn,timingInfoFn=_ref8.timingInfoFn,videoSegmentTimingInfoFn=_ref8.videoSegmentTimingInfoFn,audioSegmentTimingInfoFn=_ref8.audioSegmentTimingInfoFn,id3Fn=_ref8.id3Fn,captionsFn=_ref8.captionsFn,isEndOfTimeline=_ref8.isEndOfTimeline,endedTimelineFn=_ref8.endedTimelineFn,dataFn=_ref8.dataFn,doneFn=_ref8.doneFn,onTransmuxerLog=_ref8.onTransmuxerLog;decrypt({id:segment.requestId,key:segment.key,encryptedBytes:segment.encryptedBytes,decryptionWorker:decryptionWorker},function(decryptedBytes){segment.bytes=decryptedBytes;handleSegmentBytes({segment:segment,bytes:segment.bytes,trackInfoFn:trackInfoFn,timingInfoFn:timingInfoFn,videoSegmentTimingInfoFn:videoSegmentTimingInfoFn,audioSegmentTimingInfoFn:audioSegmentTimingInfoFn,id3Fn:id3Fn,captionsFn:captionsFn,isEndOfTimeline:isEndOfTimeline,endedTimelineFn:endedTimelineFn,dataFn:dataFn,doneFn:doneFn,onTransmuxerLog:onTransmuxerLog});});};/**
 * This function waits for all XHRs to finish (with either success or failure)
 * before continueing processing via it's callback. The function gathers errors
 * from each request into a single errors array so that the error status for
 * each request can be examined later.
 *
 * @param {Object} activeXhrs - an object that tracks all XHR requests
 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128 decryption
 *                                       routines
 * @param {Function} trackInfoFn - a callback that receives track info
 * @param {Function} timingInfoFn - a callback that receives timing info
 * @param {Function} videoSegmentTimingInfoFn
 *                   a callback that receives video timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} audioSegmentTimingInfoFn
 *                   a callback that receives audio timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} id3Fn - a callback that receives ID3 metadata
 * @param {Function} captionsFn - a callback that receives captions
 * @param {boolean}  isEndOfTimeline
 *                   true if this segment represents the last segment in a timeline
 * @param {Function} endedTimelineFn
 *                   a callback made when a timeline is ended, will only be called if
 *                   isEndOfTimeline is true
 * @param {Function} dataFn - a callback that is executed when segment bytes are available
 *                            and ready to use
 * @param {Function} doneFn - a callback that is executed after all resources have been
 *                            downloaded and any decryption completed
 */var waitForCompletion=function waitForCompletion(_ref9){var activeXhrs=_ref9.activeXhrs,decryptionWorker=_ref9.decryptionWorker,trackInfoFn=_ref9.trackInfoFn,timingInfoFn=_ref9.timingInfoFn,videoSegmentTimingInfoFn=_ref9.videoSegmentTimingInfoFn,audioSegmentTimingInfoFn=_ref9.audioSegmentTimingInfoFn,id3Fn=_ref9.id3Fn,captionsFn=_ref9.captionsFn,isEndOfTimeline=_ref9.isEndOfTimeline,endedTimelineFn=_ref9.endedTimelineFn,dataFn=_ref9.dataFn,doneFn=_ref9.doneFn,onTransmuxerLog=_ref9.onTransmuxerLog;var count=0;var didError=false;return function(error,segment){if(didError){return;}if(error){didError=true;// If there are errors, we have to abort any outstanding requests
abortAll(activeXhrs);// Even though the requests above are aborted, and in theory we could wait until we
// handle the aborted events from those requests, there are some cases where we may
// never get an aborted event. For instance, if the network connection is lost and
// there were two requests, the first may have triggered an error immediately, while
// the second request remains unsent. In that case, the aborted algorithm will not
// trigger an abort: see https://xhr.spec.whatwg.org/#the-abort()-method
//
// We also can't rely on the ready state of the XHR, since the request that
// triggered the connection error may also show as a ready state of 0 (unsent).
// Therefore, we have to finish this group of requests immediately after the first
// seen error.
return doneFn(error,segment);}count+=1;if(count===activeXhrs.length){var segmentFinish=function segmentFinish(){if(segment.encryptedBytes){return decryptSegment({decryptionWorker:decryptionWorker,segment:segment,trackInfoFn:trackInfoFn,timingInfoFn:timingInfoFn,videoSegmentTimingInfoFn:videoSegmentTimingInfoFn,audioSegmentTimingInfoFn:audioSegmentTimingInfoFn,id3Fn:id3Fn,captionsFn:captionsFn,isEndOfTimeline:isEndOfTimeline,endedTimelineFn:endedTimelineFn,dataFn:dataFn,doneFn:doneFn,onTransmuxerLog:onTransmuxerLog});}// Otherwise, everything is ready just continue
handleSegmentBytes({segment:segment,bytes:segment.bytes,trackInfoFn:trackInfoFn,timingInfoFn:timingInfoFn,videoSegmentTimingInfoFn:videoSegmentTimingInfoFn,audioSegmentTimingInfoFn:audioSegmentTimingInfoFn,id3Fn:id3Fn,captionsFn:captionsFn,isEndOfTimeline:isEndOfTimeline,endedTimelineFn:endedTimelineFn,dataFn:dataFn,doneFn:doneFn,onTransmuxerLog:onTransmuxerLog});};// Keep track of when *all* of the requests have completed
segment.endOfAllRequests=Date.now();if(segment.map&&segment.map.encryptedBytes&&!segment.map.bytes){return decrypt({decryptionWorker:decryptionWorker,// add -init to the "id" to differentiate between segment
// and init segment decryption, just in case they happen
// at the same time at some point in the future.
id:segment.requestId+'-init',encryptedBytes:segment.map.encryptedBytes,key:segment.map.key},function(decryptedBytes){segment.map.bytes=decryptedBytes;parseInitSegment(segment,function(parseError){if(parseError){abortAll(activeXhrs);return doneFn(parseError,segment);}segmentFinish();});});}segmentFinish();}};};/**
 * Calls the abort callback if any request within the batch was aborted. Will only call
 * the callback once per batch of requests, even if multiple were aborted.
 *
 * @param {Object} loadendState - state to check to see if the abort function was called
 * @param {Function} abortFn - callback to call for abort
 */var handleLoadEnd=function handleLoadEnd(_ref10){var loadendState=_ref10.loadendState,abortFn=_ref10.abortFn;return function(event){var request=event.target;if(request.aborted&&abortFn&&!loadendState.calledAbortFn){abortFn();loadendState.calledAbortFn=true;}};};/**
 * Simple progress event callback handler that gathers some stats before
 * executing a provided callback with the `segment` object
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} progressFn - a callback that is executed each time a progress event
 *                                is received
 * @param {Function} trackInfoFn - a callback that receives track info
 * @param {Function} timingInfoFn - a callback that receives timing info
 * @param {Function} videoSegmentTimingInfoFn
 *                   a callback that receives video timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} audioSegmentTimingInfoFn
 *                   a callback that receives audio timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {boolean}  isEndOfTimeline
 *                   true if this segment represents the last segment in a timeline
 * @param {Function} endedTimelineFn
 *                   a callback made when a timeline is ended, will only be called if
 *                   isEndOfTimeline is true
 * @param {Function} dataFn - a callback that is executed when segment bytes are available
 *                            and ready to use
 * @param {Event} event - the progress event object from XMLHttpRequest
 */var handleProgress=function handleProgress(_ref11){var segment=_ref11.segment,progressFn=_ref11.progressFn;_ref11.trackInfoFn;_ref11.timingInfoFn;_ref11.videoSegmentTimingInfoFn;_ref11.audioSegmentTimingInfoFn;_ref11.id3Fn;_ref11.captionsFn;_ref11.isEndOfTimeline;_ref11.endedTimelineFn;_ref11.dataFn;return function(event){var request=event.target;if(request.aborted){return;}segment.stats=videojs.mergeOptions(segment.stats,getProgressStats(event));// record the time that we receive the first byte of data
if(!segment.stats.firstBytesReceivedAt&&segment.stats.bytesReceived){segment.stats.firstBytesReceivedAt=Date.now();}return progressFn(event,segment);};};/**
 * Load all resources and does any processing necessary for a media-segment
 *
 * Features:
 *   decrypts the media-segment if it has a key uri and an iv
 *   aborts *all* requests if *any* one request fails
 *
 * The segment object, at minimum, has the following format:
 * {
 *   resolvedUri: String,
 *   [transmuxer]: Object,
 *   [byterange]: {
 *     offset: Number,
 *     length: Number
 *   },
 *   [key]: {
 *     resolvedUri: String
 *     [byterange]: {
 *       offset: Number,
 *       length: Number
 *     },
 *     iv: {
 *       bytes: Uint32Array
 *     }
 *   },
 *   [map]: {
 *     resolvedUri: String,
 *     [byterange]: {
 *       offset: Number,
 *       length: Number
 *     },
 *     [bytes]: Uint8Array
 *   }
 * }
 * ...where [name] denotes optional properties
 *
 * @param {Function} xhr - an instance of the xhr wrapper in xhr.js
 * @param {Object} xhrOptions - the base options to provide to all xhr requests
 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128
 *                                       decryption routines
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} abortFn - a callback called (only once) if any piece of a request was
 *                             aborted
 * @param {Function} progressFn - a callback that receives progress events from the main
 *                                segment's xhr request
 * @param {Function} trackInfoFn - a callback that receives track info
 * @param {Function} timingInfoFn - a callback that receives timing info
 * @param {Function} videoSegmentTimingInfoFn
 *                   a callback that receives video timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} audioSegmentTimingInfoFn
 *                   a callback that receives audio timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} id3Fn - a callback that receives ID3 metadata
 * @param {Function} captionsFn - a callback that receives captions
 * @param {boolean}  isEndOfTimeline
 *                   true if this segment represents the last segment in a timeline
 * @param {Function} endedTimelineFn
 *                   a callback made when a timeline is ended, will only be called if
 *                   isEndOfTimeline is true
 * @param {Function} dataFn - a callback that receives data from the main segment's xhr
 *                            request, transmuxed if needed
 * @param {Function} doneFn - a callback that is executed only once all requests have
 *                            succeeded or failed
 * @return {Function} a function that, when invoked, immediately aborts all
 *                     outstanding requests
 */var mediaSegmentRequest=function mediaSegmentRequest(_ref12){var xhr=_ref12.xhr,xhrOptions=_ref12.xhrOptions,decryptionWorker=_ref12.decryptionWorker,segment=_ref12.segment,abortFn=_ref12.abortFn,progressFn=_ref12.progressFn,trackInfoFn=_ref12.trackInfoFn,timingInfoFn=_ref12.timingInfoFn,videoSegmentTimingInfoFn=_ref12.videoSegmentTimingInfoFn,audioSegmentTimingInfoFn=_ref12.audioSegmentTimingInfoFn,id3Fn=_ref12.id3Fn,captionsFn=_ref12.captionsFn,isEndOfTimeline=_ref12.isEndOfTimeline,endedTimelineFn=_ref12.endedTimelineFn,dataFn=_ref12.dataFn,doneFn=_ref12.doneFn,onTransmuxerLog=_ref12.onTransmuxerLog;var activeXhrs=[];var finishProcessingFn=waitForCompletion({activeXhrs:activeXhrs,decryptionWorker:decryptionWorker,trackInfoFn:trackInfoFn,timingInfoFn:timingInfoFn,videoSegmentTimingInfoFn:videoSegmentTimingInfoFn,audioSegmentTimingInfoFn:audioSegmentTimingInfoFn,id3Fn:id3Fn,captionsFn:captionsFn,isEndOfTimeline:isEndOfTimeline,endedTimelineFn:endedTimelineFn,dataFn:dataFn,doneFn:doneFn,onTransmuxerLog:onTransmuxerLog});// optionally, request the decryption key
if(segment.key&&!segment.key.bytes){var objects=[segment.key];if(segment.map&&!segment.map.bytes&&segment.map.key&&segment.map.key.resolvedUri===segment.key.resolvedUri){objects.push(segment.map.key);}var keyRequestOptions=videojs.mergeOptions(xhrOptions,{uri:segment.key.resolvedUri,responseType:'arraybuffer'});var keyRequestCallback=handleKeyResponse(segment,objects,finishProcessingFn);var keyXhr=xhr(keyRequestOptions,keyRequestCallback);activeXhrs.push(keyXhr);}// optionally, request the associated media init segment
if(segment.map&&!segment.map.bytes){var differentMapKey=segment.map.key&&(!segment.key||segment.key.resolvedUri!==segment.map.key.resolvedUri);if(differentMapKey){var mapKeyRequestOptions=videojs.mergeOptions(xhrOptions,{uri:segment.map.key.resolvedUri,responseType:'arraybuffer'});var mapKeyRequestCallback=handleKeyResponse(segment,[segment.map.key],finishProcessingFn);var mapKeyXhr=xhr(mapKeyRequestOptions,mapKeyRequestCallback);activeXhrs.push(mapKeyXhr);}var initSegmentOptions=videojs.mergeOptions(xhrOptions,{uri:segment.map.resolvedUri,responseType:'arraybuffer',headers:segmentXhrHeaders(segment.map)});var initSegmentRequestCallback=handleInitSegmentResponse({segment:segment,finishProcessingFn:finishProcessingFn});var initSegmentXhr=xhr(initSegmentOptions,initSegmentRequestCallback);activeXhrs.push(initSegmentXhr);}var segmentRequestOptions=videojs.mergeOptions(xhrOptions,{uri:segment.part&&segment.part.resolvedUri||segment.resolvedUri,responseType:'arraybuffer',headers:segmentXhrHeaders(segment)});var segmentRequestCallback=handleSegmentResponse({segment:segment,finishProcessingFn:finishProcessingFn,responseType:segmentRequestOptions.responseType});var segmentXhr=xhr(segmentRequestOptions,segmentRequestCallback);segmentXhr.addEventListener('progress',handleProgress({segment:segment,progressFn:progressFn,trackInfoFn:trackInfoFn,timingInfoFn:timingInfoFn,videoSegmentTimingInfoFn:videoSegmentTimingInfoFn,audioSegmentTimingInfoFn:audioSegmentTimingInfoFn,id3Fn:id3Fn,captionsFn:captionsFn,isEndOfTimeline:isEndOfTimeline,endedTimelineFn:endedTimelineFn,dataFn:dataFn}));activeXhrs.push(segmentXhr);// since all parts of the request must be considered, but should not make callbacks
// multiple times, provide a shared state object
var loadendState={};activeXhrs.forEach(function(activeXhr){activeXhr.addEventListener('loadend',handleLoadEnd({loadendState:loadendState,abortFn:abortFn}));});return function(){return abortAll(activeXhrs);};};/**
 * @file - codecs.js - Handles tasks regarding codec strings such as translating them to
 * codec strings, or translating codec strings into objects that can be examined.
 */var logFn$1=logger('CodecUtils');/**
 * Returns a set of codec strings parsed from the playlist or the default
 * codec strings if no codecs were specified in the playlist
 *
 * @param {Playlist} media the current media playlist
 * @return {Object} an object with the video and audio codecs
 */var getCodecs=function getCodecs(media){// if the codecs were explicitly specified, use them instead of the
// defaults
var mediaAttributes=media.attributes||{};if(mediaAttributes.CODECS){return parseCodecs(mediaAttributes.CODECS);}};var isMaat=function isMaat(master,media){var mediaAttributes=media.attributes||{};return master&&master.mediaGroups&&master.mediaGroups.AUDIO&&mediaAttributes.AUDIO&&master.mediaGroups.AUDIO[mediaAttributes.AUDIO];};var isMuxed=function isMuxed(master,media){if(!isMaat(master,media)){return true;}var mediaAttributes=media.attributes||{};var audioGroup=master.mediaGroups.AUDIO[mediaAttributes.AUDIO];for(var groupId in audioGroup){// If an audio group has a URI (the case for HLS, as HLS will use external playlists),
// or there are listed playlists (the case for DASH, as the manifest will have already
// provided all of the details necessary to generate the audio playlist, as opposed to
// HLS' externally requested playlists), then the content is demuxed.
if(!audioGroup[groupId].uri&&!audioGroup[groupId].playlists){return true;}}return false;};var unwrapCodecList=function unwrapCodecList(codecList){var codecs={};codecList.forEach(function(_ref){var mediaType=_ref.mediaType,type=_ref.type,details=_ref.details;codecs[mediaType]=codecs[mediaType]||[];codecs[mediaType].push(translateLegacyCodec(""+type+details));});Object.keys(codecs).forEach(function(mediaType){if(codecs[mediaType].length>1){logFn$1("multiple "+mediaType+" codecs found as attributes: "+codecs[mediaType].join(', ')+". Setting playlist codecs to null so that we wait for mux.js to probe segments for real codecs.");codecs[mediaType]=null;return;}codecs[mediaType]=codecs[mediaType][0];});return codecs;};var codecCount=function codecCount(codecObj){var count=0;if(codecObj.audio){count++;}if(codecObj.video){count++;}return count;};/**
 * Calculates the codec strings for a working configuration of
 * SourceBuffers to play variant streams in a master playlist. If
 * there is no possible working configuration, an empty object will be
 * returned.
 *
 * @param master {Object} the m3u8 object for the master playlist
 * @param media {Object} the m3u8 object for the variant playlist
 * @return {Object} the codec strings.
 *
 * @private
 */var codecsForPlaylist=function codecsForPlaylist(master,media){var mediaAttributes=media.attributes||{};var codecInfo=unwrapCodecList(getCodecs(media)||[]);// HLS with multiple-audio tracks must always get an audio codec.
// Put another way, there is no way to have a video-only multiple-audio HLS!
if(isMaat(master,media)&&!codecInfo.audio){if(!isMuxed(master,media)){// It is possible for codecs to be specified on the audio media group playlist but
// not on the rendition playlist. This is mostly the case for DASH, where audio and
// video are always separate (and separately specified).
var defaultCodecs=unwrapCodecList(codecsFromDefault(master,mediaAttributes.AUDIO)||[]);if(defaultCodecs.audio){codecInfo.audio=defaultCodecs.audio;}}}return codecInfo;};var logFn=logger('PlaylistSelector');var representationToString=function representationToString(representation){if(!representation||!representation.playlist){return;}var playlist=representation.playlist;return JSON.stringify({id:playlist.id,bandwidth:representation.bandwidth,width:representation.width,height:representation.height,codecs:playlist.attributes&&playlist.attributes.CODECS||''});};// Utilities
/**
 * Returns the CSS value for the specified property on an element
 * using `getComputedStyle`. Firefox has a long-standing issue where
 * getComputedStyle() may return null when running in an iframe with
 * `display: none`.
 *
 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 * @param {HTMLElement} el the htmlelement to work on
 * @param {string} the proprety to get the style for
 */var safeGetComputedStyle=function safeGetComputedStyle(el,property){if(!el){return'';}var result=window_default().getComputedStyle(el);if(!result){return'';}return result[property];};/**
 * Resuable stable sort function
 *
 * @param {Playlists} array
 * @param {Function} sortFn Different comparators
 * @function stableSort
 */var stableSort=function stableSort(array,sortFn){var newArray=array.slice();array.sort(function(left,right){var cmp=sortFn(left,right);if(cmp===0){return newArray.indexOf(left)-newArray.indexOf(right);}return cmp;});};/**
 * A comparator function to sort two playlist object by bandwidth.
 *
 * @param {Object} left a media playlist object
 * @param {Object} right a media playlist object
 * @return {number} Greater than zero if the bandwidth attribute of
 * left is greater than the corresponding attribute of right. Less
 * than zero if the bandwidth of right is greater than left and
 * exactly zero if the two are equal.
 */var comparePlaylistBandwidth=function comparePlaylistBandwidth(left,right){var leftBandwidth;var rightBandwidth;if(left.attributes.BANDWIDTH){leftBandwidth=left.attributes.BANDWIDTH;}leftBandwidth=leftBandwidth||(window_default()).Number.MAX_VALUE;if(right.attributes.BANDWIDTH){rightBandwidth=right.attributes.BANDWIDTH;}rightBandwidth=rightBandwidth||(window_default()).Number.MAX_VALUE;return leftBandwidth-rightBandwidth;};/**
 * A comparator function to sort two playlist object by resolution (width).
 *
 * @param {Object} left a media playlist object
 * @param {Object} right a media playlist object
 * @return {number} Greater than zero if the resolution.width attribute of
 * left is greater than the corresponding attribute of right. Less
 * than zero if the resolution.width of right is greater than left and
 * exactly zero if the two are equal.
 */var comparePlaylistResolution=function comparePlaylistResolution(left,right){var leftWidth;var rightWidth;if(left.attributes.RESOLUTION&&left.attributes.RESOLUTION.width){leftWidth=left.attributes.RESOLUTION.width;}leftWidth=leftWidth||(window_default()).Number.MAX_VALUE;if(right.attributes.RESOLUTION&&right.attributes.RESOLUTION.width){rightWidth=right.attributes.RESOLUTION.width;}rightWidth=rightWidth||(window_default()).Number.MAX_VALUE;// NOTE - Fallback to bandwidth sort as appropriate in cases where multiple renditions
// have the same media dimensions/ resolution
if(leftWidth===rightWidth&&left.attributes.BANDWIDTH&&right.attributes.BANDWIDTH){return left.attributes.BANDWIDTH-right.attributes.BANDWIDTH;}return leftWidth-rightWidth;};/**
 * Chooses the appropriate media playlist based on bandwidth and player size
 *
 * @param {Object} master
 *        Object representation of the master manifest
 * @param {number} playerBandwidth
 *        Current calculated bandwidth of the player
 * @param {number} playerWidth
 *        Current width of the player element (should account for the device pixel ratio)
 * @param {number} playerHeight
 *        Current height of the player element (should account for the device pixel ratio)
 * @param {boolean} limitRenditionByPlayerDimensions
 *        True if the player width and height should be used during the selection, false otherwise
 * @param {Object} masterPlaylistController
 *        the current masterPlaylistController object
 * @return {Playlist} the highest bitrate playlist less than the
 * currently detected bandwidth, accounting for some amount of
 * bandwidth variance
 */var simpleSelector=function simpleSelector(master,playerBandwidth,playerWidth,playerHeight,limitRenditionByPlayerDimensions,masterPlaylistController){// If we end up getting called before `master` is available, exit early
if(!master){return;}var options={bandwidth:playerBandwidth,width:playerWidth,height:playerHeight,limitRenditionByPlayerDimensions:limitRenditionByPlayerDimensions};var playlists=master.playlists;// if playlist is audio only, select between currently active audio group playlists.
if(Playlist.isAudioOnly(master)){playlists=masterPlaylistController.getAudioTrackPlaylists_();// add audioOnly to options so that we log audioOnly: true
// at the buttom of this function for debugging.
options.audioOnly=true;}// convert the playlists to an intermediary representation to make comparisons easier
var sortedPlaylistReps=playlists.map(function(playlist){var bandwidth;var width=playlist.attributes&&playlist.attributes.RESOLUTION&&playlist.attributes.RESOLUTION.width;var height=playlist.attributes&&playlist.attributes.RESOLUTION&&playlist.attributes.RESOLUTION.height;bandwidth=playlist.attributes&&playlist.attributes.BANDWIDTH;bandwidth=bandwidth||(window_default()).Number.MAX_VALUE;return{bandwidth:bandwidth,width:width,height:height,playlist:playlist};});stableSort(sortedPlaylistReps,function(left,right){return left.bandwidth-right.bandwidth;});// filter out any playlists that have been excluded due to
// incompatible configurations
sortedPlaylistReps=sortedPlaylistReps.filter(function(rep){return!Playlist.isIncompatible(rep.playlist);});// filter out any playlists that have been disabled manually through the representations
// api or blacklisted temporarily due to playback errors.
var enabledPlaylistReps=sortedPlaylistReps.filter(function(rep){return Playlist.isEnabled(rep.playlist);});if(!enabledPlaylistReps.length){// if there are no enabled playlists, then they have all been blacklisted or disabled
// by the user through the representations api. In this case, ignore blacklisting and
// fallback to what the user wants by using playlists the user has not disabled.
enabledPlaylistReps=sortedPlaylistReps.filter(function(rep){return!Playlist.isDisabled(rep.playlist);});}// filter out any variant that has greater effective bitrate
// than the current estimated bandwidth
var bandwidthPlaylistReps=enabledPlaylistReps.filter(function(rep){return rep.bandwidth*Config.BANDWIDTH_VARIANCE<playerBandwidth;});var highestRemainingBandwidthRep=bandwidthPlaylistReps[bandwidthPlaylistReps.length-1];// get all of the renditions with the same (highest) bandwidth
// and then taking the very first element
var bandwidthBestRep=bandwidthPlaylistReps.filter(function(rep){return rep.bandwidth===highestRemainingBandwidthRep.bandwidth;})[0];// if we're not going to limit renditions by player size, make an early decision.
if(limitRenditionByPlayerDimensions===false){var _chosenRep=bandwidthBestRep||enabledPlaylistReps[0]||sortedPlaylistReps[0];if(_chosenRep&&_chosenRep.playlist){var type='sortedPlaylistReps';if(bandwidthBestRep){type='bandwidthBestRep';}if(enabledPlaylistReps[0]){type='enabledPlaylistReps';}logFn("choosing "+representationToString(_chosenRep)+" using "+type+" with options",options);return _chosenRep.playlist;}logFn('could not choose a playlist with options',options);return null;}// filter out playlists without resolution information
var haveResolution=bandwidthPlaylistReps.filter(function(rep){return rep.width&&rep.height;});// sort variants by resolution
stableSort(haveResolution,function(left,right){return left.width-right.width;});// if we have the exact resolution as the player use it
var resolutionBestRepList=haveResolution.filter(function(rep){return rep.width===playerWidth&&rep.height===playerHeight;});highestRemainingBandwidthRep=resolutionBestRepList[resolutionBestRepList.length-1];// ensure that we pick the highest bandwidth variant that have exact resolution
var resolutionBestRep=resolutionBestRepList.filter(function(rep){return rep.bandwidth===highestRemainingBandwidthRep.bandwidth;})[0];var resolutionPlusOneList;var resolutionPlusOneSmallest;var resolutionPlusOneRep;// find the smallest variant that is larger than the player
// if there is no match of exact resolution
if(!resolutionBestRep){resolutionPlusOneList=haveResolution.filter(function(rep){return rep.width>playerWidth||rep.height>playerHeight;});// find all the variants have the same smallest resolution
resolutionPlusOneSmallest=resolutionPlusOneList.filter(function(rep){return rep.width===resolutionPlusOneList[0].width&&rep.height===resolutionPlusOneList[0].height;});// ensure that we also pick the highest bandwidth variant that
// is just-larger-than the video player
highestRemainingBandwidthRep=resolutionPlusOneSmallest[resolutionPlusOneSmallest.length-1];resolutionPlusOneRep=resolutionPlusOneSmallest.filter(function(rep){return rep.bandwidth===highestRemainingBandwidthRep.bandwidth;})[0];}var leastPixelDiffRep;// If this selector proves to be better than others,
// resolutionPlusOneRep and resolutionBestRep and all
// the code involving them should be removed.
if(masterPlaylistController.experimentalLeastPixelDiffSelector){// find the variant that is closest to the player's pixel size
var leastPixelDiffList=haveResolution.map(function(rep){rep.pixelDiff=Math.abs(rep.width-playerWidth)+Math.abs(rep.height-playerHeight);return rep;});// get the highest bandwidth, closest resolution playlist
stableSort(leastPixelDiffList,function(left,right){// sort by highest bandwidth if pixelDiff is the same
if(left.pixelDiff===right.pixelDiff){return right.bandwidth-left.bandwidth;}return left.pixelDiff-right.pixelDiff;});leastPixelDiffRep=leastPixelDiffList[0];}// fallback chain of variants
var chosenRep=leastPixelDiffRep||resolutionPlusOneRep||resolutionBestRep||bandwidthBestRep||enabledPlaylistReps[0]||sortedPlaylistReps[0];if(chosenRep&&chosenRep.playlist){var _type='sortedPlaylistReps';if(leastPixelDiffRep){_type='leastPixelDiffRep';}else if(resolutionPlusOneRep){_type='resolutionPlusOneRep';}else if(resolutionBestRep){_type='resolutionBestRep';}else if(bandwidthBestRep){_type='bandwidthBestRep';}else if(enabledPlaylistReps[0]){_type='enabledPlaylistReps';}logFn("choosing "+representationToString(chosenRep)+" using "+_type+" with options",options);return chosenRep.playlist;}logFn('could not choose a playlist with options',options);return null;};/**
 * Chooses the appropriate media playlist based on the most recent
 * bandwidth estimate and the player size.
 *
 * Expects to be called within the context of an instance of VhsHandler
 *
 * @return {Playlist} the highest bitrate playlist less than the
 * currently detected bandwidth, accounting for some amount of
 * bandwidth variance
 */var lastBandwidthSelector=function lastBandwidthSelector(){var pixelRatio=this.useDevicePixelRatio?(window_default()).devicePixelRatio||1:1;return simpleSelector(this.playlists.master,this.systemBandwidth,parseInt(safeGetComputedStyle(this.tech_.el(),'width'),10)*pixelRatio,parseInt(safeGetComputedStyle(this.tech_.el(),'height'),10)*pixelRatio,this.limitRenditionByPlayerDimensions,this.masterPlaylistController_);};/**
 * Chooses the appropriate media playlist based on an
 * exponential-weighted moving average of the bandwidth after
 * filtering for player size.
 *
 * Expects to be called within the context of an instance of VhsHandler
 *
 * @param {number} decay - a number between 0 and 1. Higher values of
 * this parameter will cause previous bandwidth estimates to lose
 * significance more quickly.
 * @return {Function} a function which can be invoked to create a new
 * playlist selector function.
 * @see https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
 */var movingAverageBandwidthSelector=function movingAverageBandwidthSelector(decay){var average=-1;var lastSystemBandwidth=-1;if(decay<0||decay>1){throw new Error('Moving average bandwidth decay must be between 0 and 1.');}return function(){var pixelRatio=this.useDevicePixelRatio?(window_default()).devicePixelRatio||1:1;if(average<0){average=this.systemBandwidth;lastSystemBandwidth=this.systemBandwidth;}// stop the average value from decaying for every 250ms
// when the systemBandwidth is constant
// and
// stop average from setting to a very low value when the
// systemBandwidth becomes 0 in case of chunk cancellation
if(this.systemBandwidth>0&&this.systemBandwidth!==lastSystemBandwidth){average=decay*this.systemBandwidth+(1-decay)*average;lastSystemBandwidth=this.systemBandwidth;}return simpleSelector(this.playlists.master,average,parseInt(safeGetComputedStyle(this.tech_.el(),'width'),10)*pixelRatio,parseInt(safeGetComputedStyle(this.tech_.el(),'height'),10)*pixelRatio,this.limitRenditionByPlayerDimensions,this.masterPlaylistController_);};};/**
 * Chooses the appropriate media playlist based on the potential to rebuffer
 *
 * @param {Object} settings
 *        Object of information required to use this selector
 * @param {Object} settings.master
 *        Object representation of the master manifest
 * @param {number} settings.currentTime
 *        The current time of the player
 * @param {number} settings.bandwidth
 *        Current measured bandwidth
 * @param {number} settings.duration
 *        Duration of the media
 * @param {number} settings.segmentDuration
 *        Segment duration to be used in round trip time calculations
 * @param {number} settings.timeUntilRebuffer
 *        Time left in seconds until the player has to rebuffer
 * @param {number} settings.currentTimeline
 *        The current timeline segments are being loaded from
 * @param {SyncController} settings.syncController
 *        SyncController for determining if we have a sync point for a given playlist
 * @return {Object|null}
 *         {Object} return.playlist
 *         The highest bandwidth playlist with the least amount of rebuffering
 *         {Number} return.rebufferingImpact
 *         The amount of time in seconds switching to this playlist will rebuffer. A
 *         negative value means that switching will cause zero rebuffering.
 */var minRebufferMaxBandwidthSelector=function minRebufferMaxBandwidthSelector(settings){var master=settings.master,currentTime=settings.currentTime,bandwidth=settings.bandwidth,duration=settings.duration,segmentDuration=settings.segmentDuration,timeUntilRebuffer=settings.timeUntilRebuffer,currentTimeline=settings.currentTimeline,syncController=settings.syncController;// filter out any playlists that have been excluded due to
// incompatible configurations
var compatiblePlaylists=master.playlists.filter(function(playlist){return!Playlist.isIncompatible(playlist);});// filter out any playlists that have been disabled manually through the representations
// api or blacklisted temporarily due to playback errors.
var enabledPlaylists=compatiblePlaylists.filter(Playlist.isEnabled);if(!enabledPlaylists.length){// if there are no enabled playlists, then they have all been blacklisted or disabled
// by the user through the representations api. In this case, ignore blacklisting and
// fallback to what the user wants by using playlists the user has not disabled.
enabledPlaylists=compatiblePlaylists.filter(function(playlist){return!Playlist.isDisabled(playlist);});}var bandwidthPlaylists=enabledPlaylists.filter(Playlist.hasAttribute.bind(null,'BANDWIDTH'));var rebufferingEstimates=bandwidthPlaylists.map(function(playlist){var syncPoint=syncController.getSyncPoint(playlist,duration,currentTimeline,currentTime);// If there is no sync point for this playlist, switching to it will require a
// sync request first. This will double the request time
var numRequests=syncPoint?1:2;var requestTimeEstimate=Playlist.estimateSegmentRequestTime(segmentDuration,bandwidth,playlist);var rebufferingImpact=requestTimeEstimate*numRequests-timeUntilRebuffer;return{playlist:playlist,rebufferingImpact:rebufferingImpact};});var noRebufferingPlaylists=rebufferingEstimates.filter(function(estimate){return estimate.rebufferingImpact<=0;});// Sort by bandwidth DESC
stableSort(noRebufferingPlaylists,function(a,b){return comparePlaylistBandwidth(b.playlist,a.playlist);});if(noRebufferingPlaylists.length){return noRebufferingPlaylists[0];}stableSort(rebufferingEstimates,function(a,b){return a.rebufferingImpact-b.rebufferingImpact;});return rebufferingEstimates[0]||null;};/**
 * Chooses the appropriate media playlist, which in this case is the lowest bitrate
 * one with video.  If no renditions with video exist, return the lowest audio rendition.
 *
 * Expects to be called within the context of an instance of VhsHandler
 *
 * @return {Object|null}
 *         {Object} return.playlist
 *         The lowest bitrate playlist that contains a video codec.  If no such rendition
 *         exists pick the lowest audio rendition.
 */var lowestBitrateCompatibleVariantSelector=function lowestBitrateCompatibleVariantSelector(){var _this=this;// filter out any playlists that have been excluded due to
// incompatible configurations or playback errors
var playlists=this.playlists.master.playlists.filter(Playlist.isEnabled);// Sort ascending by bitrate
stableSort(playlists,function(a,b){return comparePlaylistBandwidth(a,b);});// Parse and assume that playlists with no video codec have no video
// (this is not necessarily true, although it is generally true).
//
// If an entire manifest has no valid videos everything will get filtered
// out.
var playlistsWithVideo=playlists.filter(function(playlist){return!!codecsForPlaylist(_this.playlists.master,playlist).video;});return playlistsWithVideo[0]||null;};/**
 * Combine all segments into a single Uint8Array
 *
 * @param {Object} segmentObj
 * @return {Uint8Array} concatenated bytes
 * @private
 */var concatSegments=function concatSegments(segmentObj){var offset=0;var tempBuffer;if(segmentObj.bytes){tempBuffer=new Uint8Array(segmentObj.bytes);// combine the individual segments into one large typed-array
segmentObj.segments.forEach(function(segment){tempBuffer.set(segment,offset);offset+=segment.byteLength;});}return tempBuffer;};/**
 * @file text-tracks.js
 */ /**
 * Create captions text tracks on video.js if they do not exist
 *
 * @param {Object} inbandTextTracks a reference to current inbandTextTracks
 * @param {Object} tech the video.js tech
 * @param {Object} captionStream the caption stream to create
 * @private
 */var createCaptionsTrackIfNotExists=function createCaptionsTrackIfNotExists(inbandTextTracks,tech,captionStream){if(!inbandTextTracks[captionStream]){tech.trigger({type:'usage',name:'vhs-608'});tech.trigger({type:'usage',name:'hls-608'});var instreamId=captionStream;// we need to translate SERVICEn for 708 to how mux.js currently labels them
if(/^cc708_/.test(captionStream)){instreamId='SERVICE'+captionStream.split('_')[1];}var track=tech.textTracks().getTrackById(instreamId);if(track){// Resuse an existing track with a CC# id because this was
// very likely created by videojs-contrib-hls from information
// in the m3u8 for us to use
inbandTextTracks[captionStream]=track;}else{// This section gets called when we have caption services that aren't specified in the manifest.
// Manifest level caption services are handled in media-groups.js under CLOSED-CAPTIONS.
var captionServices=tech.options_.vhs&&tech.options_.vhs.captionServices||{};var label=captionStream;var language=captionStream;var def=false;var captionService=captionServices[instreamId];if(captionService){label=captionService.label;language=captionService.language;def=captionService["default"];}// Otherwise, create a track with the default `CC#` label and
// without a language
inbandTextTracks[captionStream]=tech.addRemoteTextTrack({kind:'captions',id:instreamId,// TODO: investigate why this doesn't seem to turn the caption on by default
"default":def,label:label,language:language},false).track;}}};/**
 * Add caption text track data to a source handler given an array of captions
 *
 * @param {Object}
 *   @param {Object} inbandTextTracks the inband text tracks
 *   @param {number} timestampOffset the timestamp offset of the source buffer
 *   @param {Array} captionArray an array of caption data
 * @private
 */var addCaptionData=function addCaptionData(_ref){var inbandTextTracks=_ref.inbandTextTracks,captionArray=_ref.captionArray,timestampOffset=_ref.timestampOffset;if(!captionArray){return;}var Cue=(window_default()).WebKitDataCue||(window_default()).VTTCue;captionArray.forEach(function(caption){var track=caption.stream;inbandTextTracks[track].addCue(new Cue(caption.startTime+timestampOffset,caption.endTime+timestampOffset,caption.text));});};/**
 * Define properties on a cue for backwards compatability,
 * but warn the user that the way that they are using it
 * is depricated and will be removed at a later date.
 *
 * @param {Cue} cue the cue to add the properties on
 * @private
 */var deprecateOldCue=function deprecateOldCue(cue){Object.defineProperties(cue.frame,{id:{get:function get(){videojs.log.warn('cue.frame.id is deprecated. Use cue.value.key instead.');return cue.value.key;}},value:{get:function get(){videojs.log.warn('cue.frame.value is deprecated. Use cue.value.data instead.');return cue.value.data;}},privateData:{get:function get(){videojs.log.warn('cue.frame.privateData is deprecated. Use cue.value.data instead.');return cue.value.data;}}});};/**
 * Add metadata text track data to a source handler given an array of metadata
 *
 * @param {Object}
 *   @param {Object} inbandTextTracks the inband text tracks
 *   @param {Array} metadataArray an array of meta data
 *   @param {number} timestampOffset the timestamp offset of the source buffer
 *   @param {number} videoDuration the duration of the video
 * @private
 */var addMetadata=function addMetadata(_ref2){var inbandTextTracks=_ref2.inbandTextTracks,metadataArray=_ref2.metadataArray,timestampOffset=_ref2.timestampOffset,videoDuration=_ref2.videoDuration;if(!metadataArray){return;}var Cue=(window_default()).WebKitDataCue||(window_default()).VTTCue;var metadataTrack=inbandTextTracks.metadataTrack_;if(!metadataTrack){return;}metadataArray.forEach(function(metadata){var time=metadata.cueTime+timestampOffset;// if time isn't a finite number between 0 and Infinity, like NaN,
// ignore this bit of metadata.
// This likely occurs when you have an non-timed ID3 tag like TIT2,
// which is the "Title/Songname/Content description" frame
if(typeof time!=='number'||window_default().isNaN(time)||time<0||!(time<Infinity)){return;}metadata.frames.forEach(function(frame){var cue=new Cue(time,time,frame.value||frame.url||frame.data||'');cue.frame=frame;cue.value=frame;deprecateOldCue(cue);metadataTrack.addCue(cue);});});if(!metadataTrack.cues||!metadataTrack.cues.length){return;}// Updating the metadeta cues so that
// the endTime of each cue is the startTime of the next cue
// the endTime of last cue is the duration of the video
var cues=metadataTrack.cues;var cuesArray=[];// Create a copy of the TextTrackCueList...
// ...disregarding cues with a falsey value
for(var i=0;i<cues.length;i++){if(cues[i]){cuesArray.push(cues[i]);}}// Group cues by their startTime value
var cuesGroupedByStartTime=cuesArray.reduce(function(obj,cue){var timeSlot=obj[cue.startTime]||[];timeSlot.push(cue);obj[cue.startTime]=timeSlot;return obj;},{});// Sort startTimes by ascending order
var sortedStartTimes=Object.keys(cuesGroupedByStartTime).sort(function(a,b){return Number(a)-Number(b);});// Map each cue group's endTime to the next group's startTime
sortedStartTimes.forEach(function(startTime,idx){var cueGroup=cuesGroupedByStartTime[startTime];var nextTime=Number(sortedStartTimes[idx+1])||videoDuration;// Map each cue's endTime the next group's startTime
cueGroup.forEach(function(cue){cue.endTime=nextTime;});});};/**
 * Create metadata text track on video.js if it does not exist
 *
 * @param {Object} inbandTextTracks a reference to current inbandTextTracks
 * @param {string} dispatchType the inband metadata track dispatch type
 * @param {Object} tech the video.js tech
 * @private
 */var createMetadataTrackIfNotExists=function createMetadataTrackIfNotExists(inbandTextTracks,dispatchType,tech){if(inbandTextTracks.metadataTrack_){return;}inbandTextTracks.metadataTrack_=tech.addRemoteTextTrack({kind:'metadata',label:'Timed Metadata'},false).track;inbandTextTracks.metadataTrack_.inBandMetadataTrackDispatchType=dispatchType;};/**
 * Remove cues from a track on video.js.
 *
 * @param {Double} start start of where we should remove the cue
 * @param {Double} end end of where the we should remove the cue
 * @param {Object} track the text track to remove the cues from
 * @private
 */var removeCuesFromTrack=function removeCuesFromTrack(start,end,track){var i;var cue;if(!track){return;}if(!track.cues){return;}i=track.cues.length;while(i--){cue=track.cues[i];// Remove any cue within the provided start and end time
if(cue.startTime>=start&&cue.endTime<=end){track.removeCue(cue);}}};/**
 * Remove duplicate cues from a track on video.js (a cue is considered a
 * duplicate if it has the same time interval and text as another)
 *
 * @param {Object} track the text track to remove the duplicate cues from
 * @private
 */var removeDuplicateCuesFromTrack=function removeDuplicateCuesFromTrack(track){var cues=track.cues;if(!cues){return;}for(var i=0;i<cues.length;i++){var duplicates=[];var occurrences=0;for(var j=0;j<cues.length;j++){if(cues[i].startTime===cues[j].startTime&&cues[i].endTime===cues[j].endTime&&cues[i].text===cues[j].text){occurrences++;if(occurrences>1){duplicates.push(cues[j]);}}}if(duplicates.length){duplicates.forEach(function(dupe){return track.removeCue(dupe);});}}};/**
 * Returns a list of gops in the buffer that have a pts value of 3 seconds or more in
 * front of current time.
 *
 * @param {Array} buffer
 *        The current buffer of gop information
 * @param {number} currentTime
 *        The current time
 * @param {Double} mapping
 *        Offset to map display time to stream presentation time
 * @return {Array}
 *         List of gops considered safe to append over
 */var gopsSafeToAlignWith=function gopsSafeToAlignWith(buffer,currentTime,mapping){if(typeof currentTime==='undefined'||currentTime===null||!buffer.length){return[];}// pts value for current time + 3 seconds to give a bit more wiggle room
var currentTimePts=Math.ceil((currentTime-mapping+3)*clock.ONE_SECOND_IN_TS);var i;for(i=0;i<buffer.length;i++){if(buffer[i].pts>currentTimePts){break;}}return buffer.slice(i);};/**
 * Appends gop information (timing and byteLength) received by the transmuxer for the
 * gops appended in the last call to appendBuffer
 *
 * @param {Array} buffer
 *        The current buffer of gop information
 * @param {Array} gops
 *        List of new gop information
 * @param {boolean} replace
 *        If true, replace the buffer with the new gop information. If false, append the
 *        new gop information to the buffer in the right location of time.
 * @return {Array}
 *         Updated list of gop information
 */var updateGopBuffer=function updateGopBuffer(buffer,gops,replace){if(!gops.length){return buffer;}if(replace){// If we are in safe append mode, then completely overwrite the gop buffer
// with the most recent appeneded data. This will make sure that when appending
// future segments, we only try to align with gops that are both ahead of current
// time and in the last segment appended.
return gops.slice();}var start=gops[0].pts;var i=0;for(i;i<buffer.length;i++){if(buffer[i].pts>=start){break;}}return buffer.slice(0,i).concat(gops);};/**
 * Removes gop information in buffer that overlaps with provided start and end
 *
 * @param {Array} buffer
 *        The current buffer of gop information
 * @param {Double} start
 *        position to start the remove at
 * @param {Double} end
 *        position to end the remove at
 * @param {Double} mapping
 *        Offset to map display time to stream presentation time
 */var removeGopBuffer=function removeGopBuffer(buffer,start,end,mapping){var startPts=Math.ceil((start-mapping)*clock.ONE_SECOND_IN_TS);var endPts=Math.ceil((end-mapping)*clock.ONE_SECOND_IN_TS);var updatedBuffer=buffer.slice();var i=buffer.length;while(i--){if(buffer[i].pts<=endPts){break;}}if(i===-1){// no removal because end of remove range is before start of buffer
return updatedBuffer;}var j=i+1;while(j--){if(buffer[j].pts<=startPts){break;}}// clamp remove range start to 0 index
j=Math.max(j,0);updatedBuffer.splice(j,i-j+1);return updatedBuffer;};var shallowEqual=function shallowEqual(a,b){// if both are undefined
// or one or the other is undefined
// they are not equal
if(!a&&!b||!a&&b||a&&!b){return false;}// they are the same object and thus, equal
if(a===b){return true;}// sort keys so we can make sure they have
// all the same keys later.
var akeys=Object.keys(a).sort();var bkeys=Object.keys(b).sort();// different number of keys, not equal
if(akeys.length!==bkeys.length){return false;}for(var i=0;i<akeys.length;i++){var key=akeys[i];// different sorted keys, not equal
if(key!==bkeys[i]){return false;}// different values, not equal
if(a[key]!==b[key]){return false;}}return true;};// https://www.w3.org/TR/WebIDL-1/#quotaexceedederror
var QUOTA_EXCEEDED_ERR=22;/**
 * The segment loader has no recourse except to fetch a segment in the
 * current playlist and use the internal timestamps in that segment to
 * generate a syncPoint. This function returns a good candidate index
 * for that process.
 *
 * @param {Array} segments - the segments array from a playlist.
 * @return {number} An index of a segment from the playlist to load
 */var getSyncSegmentCandidate=function getSyncSegmentCandidate(currentTimeline,segments,targetTime){segments=segments||[];var timelineSegments=[];var time=0;for(var i=0;i<segments.length;i++){var segment=segments[i];if(currentTimeline===segment.timeline){timelineSegments.push(i);time+=segment.duration;if(time>targetTime){return i;}}}if(timelineSegments.length===0){return 0;}// default to the last timeline segment
return timelineSegments[timelineSegments.length-1];};// In the event of a quota exceeded error, keep at least one second of back buffer. This
// number was arbitrarily chosen and may be updated in the future, but seemed reasonable
// as a start to prevent any potential issues with removing content too close to the
// playhead.
var MIN_BACK_BUFFER=1;// in ms
var CHECK_BUFFER_DELAY=500;var finite=function finite(num){return typeof num==='number'&&isFinite(num);};// With most content hovering around 30fps, if a segment has a duration less than a half
// frame at 30fps or one frame at 60fps, the bandwidth and throughput calculations will
// not accurately reflect the rest of the content.
var MIN_SEGMENT_DURATION_TO_SAVE_STATS=1/60;var illegalMediaSwitch=function illegalMediaSwitch(loaderType,startingMedia,trackInfo){// Although these checks should most likely cover non 'main' types, for now it narrows
// the scope of our checks.
if(loaderType!=='main'||!startingMedia||!trackInfo){return null;}if(!trackInfo.hasAudio&&!trackInfo.hasVideo){return'Neither audio nor video found in segment.';}if(startingMedia.hasVideo&&!trackInfo.hasVideo){return'Only audio found in segment when we expected video.'+' We can\'t switch to audio only from a stream that had video.'+' To get rid of this message, please add codec information to the manifest.';}if(!startingMedia.hasVideo&&trackInfo.hasVideo){return'Video found in segment when we expected only audio.'+' We can\'t switch to a stream with video from an audio only stream.'+' To get rid of this message, please add codec information to the manifest.';}return null;};/**
 * Calculates a time value that is safe to remove from the back buffer without interrupting
 * playback.
 *
 * @param {TimeRange} seekable
 *        The current seekable range
 * @param {number} currentTime
 *        The current time of the player
 * @param {number} targetDuration
 *        The target duration of the current playlist
 * @return {number}
 *         Time that is safe to remove from the back buffer without interrupting playback
 */var safeBackBufferTrimTime=function safeBackBufferTrimTime(seekable,currentTime,targetDuration){// 30 seconds before the playhead provides a safe default for trimming.
//
// Choosing a reasonable default is particularly important for high bitrate content and
// VOD videos/live streams with large windows, as the buffer may end up overfilled and
// throw an APPEND_BUFFER_ERR.
var trimTime=currentTime-Config.BACK_BUFFER_LENGTH;if(seekable.length){// Some live playlists may have a shorter window of content than the full allowed back
// buffer. For these playlists, don't save content that's no longer within the window.
trimTime=Math.max(trimTime,seekable.start(0));}// Don't remove within target duration of the current time to avoid the possibility of
// removing the GOP currently being played, as removing it can cause playback stalls.
var maxTrimTime=currentTime-targetDuration;return Math.min(maxTrimTime,trimTime);};var segmentInfoString=function segmentInfoString(segmentInfo){var startOfSegment=segmentInfo.startOfSegment,duration=segmentInfo.duration,segment=segmentInfo.segment,part=segmentInfo.part,_segmentInfo$playlist=segmentInfo.playlist,seq=_segmentInfo$playlist.mediaSequence,id=_segmentInfo$playlist.id,_segmentInfo$playlist2=_segmentInfo$playlist.segments,segments=_segmentInfo$playlist2===void 0?[]:_segmentInfo$playlist2,index=segmentInfo.mediaIndex,partIndex=segmentInfo.partIndex,timeline=segmentInfo.timeline;var segmentLen=segments.length-1;var selection='mediaIndex/partIndex increment';if(segmentInfo.getMediaInfoForTime){selection="getMediaInfoForTime ("+segmentInfo.getMediaInfoForTime+")";}else if(segmentInfo.isSyncRequest){selection='getSyncSegmentCandidate (isSyncRequest)';}if(segmentInfo.independent){selection+=" with independent "+segmentInfo.independent;}var hasPartIndex=typeof partIndex==='number';var name=segmentInfo.segment.uri?'segment':'pre-segment';var zeroBasedPartCount=hasPartIndex?getKnownPartCount({preloadSegment:segment})-1:0;return name+" ["+(seq+index)+"/"+(seq+segmentLen)+"]"+(hasPartIndex?" part ["+partIndex+"/"+zeroBasedPartCount+"]":'')+(" segment start/end ["+segment.start+" => "+segment.end+"]")+(hasPartIndex?" part start/end ["+part.start+" => "+part.end+"]":'')+(" startOfSegment ["+startOfSegment+"]")+(" duration ["+duration+"]")+(" timeline ["+timeline+"]")+(" selected by ["+selection+"]")+(" playlist ["+id+"]");};var timingInfoPropertyForMedia=function timingInfoPropertyForMedia(mediaType){return mediaType+"TimingInfo";};/**
 * Returns the timestamp offset to use for the segment.
 *
 * @param {number} segmentTimeline
 *        The timeline of the segment
 * @param {number} currentTimeline
 *        The timeline currently being followed by the loader
 * @param {number} startOfSegment
 *        The estimated segment start
 * @param {TimeRange[]} buffered
 *        The loader's buffer
 * @param {boolean} overrideCheck
 *        If true, no checks are made to see if the timestamp offset value should be set,
 *        but sets it directly to a value.
 *
 * @return {number|null}
 *         Either a number representing a new timestamp offset, or null if the segment is
 *         part of the same timeline
 */var timestampOffsetForSegment=function timestampOffsetForSegment(_ref){var segmentTimeline=_ref.segmentTimeline,currentTimeline=_ref.currentTimeline,startOfSegment=_ref.startOfSegment,buffered=_ref.buffered,overrideCheck=_ref.overrideCheck;// Check to see if we are crossing a discontinuity to see if we need to set the
// timestamp offset on the transmuxer and source buffer.
//
// Previously, we changed the timestampOffset if the start of this segment was less than
// the currently set timestampOffset, but this isn't desirable as it can produce bad
// behavior, especially around long running live streams.
if(!overrideCheck&&segmentTimeline===currentTimeline){return null;}// When changing renditions, it's possible to request a segment on an older timeline. For
// instance, given two renditions with the following:
//
// #EXTINF:10
// segment1
// #EXT-X-DISCONTINUITY
// #EXTINF:10
// segment2
// #EXTINF:10
// segment3
//
// And the current player state:
//
// current time: 8
// buffer: 0 => 20
//
// The next segment on the current rendition would be segment3, filling the buffer from
// 20s onwards. However, if a rendition switch happens after segment2 was requested,
// then the next segment to be requested will be segment1 from the new rendition in
// order to fill time 8 and onwards. Using the buffered end would result in repeated
// content (since it would position segment1 of the new rendition starting at 20s). This
// case can be identified when the new segment's timeline is a prior value. Instead of
// using the buffered end, the startOfSegment can be used, which, hopefully, will be
// more accurate to the actual start time of the segment.
if(segmentTimeline<currentTimeline){return startOfSegment;}// segmentInfo.startOfSegment used to be used as the timestamp offset, however, that
// value uses the end of the last segment if it is available. While this value
// should often be correct, it's better to rely on the buffered end, as the new
// content post discontinuity should line up with the buffered end as if it were
// time 0 for the new content.
return buffered.length?buffered.end(buffered.length-1):startOfSegment;};/**
 * Returns whether or not the loader should wait for a timeline change from the timeline
 * change controller before processing the segment.
 *
 * Primary timing in VHS goes by video. This is different from most media players, as
 * audio is more often used as the primary timing source. For the foreseeable future, VHS
 * will continue to use video as the primary timing source, due to the current logic and
 * expectations built around it.

 * Since the timing follows video, in order to maintain sync, the video loader is
 * responsible for setting both audio and video source buffer timestamp offsets.
 *
 * Setting different values for audio and video source buffers could lead to
 * desyncing. The following examples demonstrate some of the situations where this
 * distinction is important. Note that all of these cases involve demuxed content. When
 * content is muxed, the audio and video are packaged together, therefore syncing
 * separate media playlists is not an issue.
 *
 * CASE 1: Audio prepares to load a new timeline before video:
 *
 * Timeline:       0                 1
 * Audio Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Audio Loader:                     ^
 * Video Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Video Loader              ^
 *
 * In the above example, the audio loader is preparing to load the 6th segment, the first
 * after a discontinuity, while the video loader is still loading the 5th segment, before
 * the discontinuity.
 *
 * If the audio loader goes ahead and loads and appends the 6th segment before the video
 * loader crosses the discontinuity, then when appended, the 6th audio segment will use
 * the timestamp offset from timeline 0. This will likely lead to desyncing. In addition,
 * the audio loader must provide the audioAppendStart value to trim the content in the
 * transmuxer, and that value relies on the audio timestamp offset. Since the audio
 * timestamp offset is set by the video (main) loader, the audio loader shouldn't load the
 * segment until that value is provided.
 *
 * CASE 2: Video prepares to load a new timeline before audio:
 *
 * Timeline:       0                 1
 * Audio Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Audio Loader:             ^
 * Video Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Video Loader                      ^
 *
 * In the above example, the video loader is preparing to load the 6th segment, the first
 * after a discontinuity, while the audio loader is still loading the 5th segment, before
 * the discontinuity.
 *
 * If the video loader goes ahead and loads and appends the 6th segment, then once the
 * segment is loaded and processed, both the video and audio timestamp offsets will be
 * set, since video is used as the primary timing source. This is to ensure content lines
 * up appropriately, as any modifications to the video timing are reflected by audio when
 * the video loader sets the audio and video timestamp offsets to the same value. However,
 * setting the timestamp offset for audio before audio has had a chance to change
 * timelines will likely lead to desyncing, as the audio loader will append segment 5 with
 * a timestamp intended to apply to segments from timeline 1 rather than timeline 0.
 *
 * CASE 3: When seeking, audio prepares to load a new timeline before video
 *
 * Timeline:       0                 1
 * Audio Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Audio Loader:           ^
 * Video Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Video Loader            ^
 *
 * In the above example, both audio and video loaders are loading segments from timeline
 * 0, but imagine that the seek originated from timeline 1.
 *
 * When seeking to a new timeline, the timestamp offset will be set based on the expected
 * segment start of the loaded video segment. In order to maintain sync, the audio loader
 * must wait for the video loader to load its segment and update both the audio and video
 * timestamp offsets before it may load and append its own segment. This is the case
 * whether the seek results in a mismatched segment request (e.g., the audio loader
 * chooses to load segment 3 and the video loader chooses to load segment 4) or the
 * loaders choose to load the same segment index from each playlist, as the segments may
 * not be aligned perfectly, even for matching segment indexes.
 *
 * @param {Object} timelinechangeController
 * @param {number} currentTimeline
 *        The timeline currently being followed by the loader
 * @param {number} segmentTimeline
 *        The timeline of the segment being loaded
 * @param {('main'|'audio')} loaderType
 *        The loader type
 * @param {boolean} audioDisabled
 *        Whether the audio is disabled for the loader. This should only be true when the
 *        loader may have muxed audio in its segment, but should not append it, e.g., for
 *        the main loader when an alternate audio playlist is active.
 *
 * @return {boolean}
 *         Whether the loader should wait for a timeline change from the timeline change
 *         controller before processing the segment
 */var shouldWaitForTimelineChange=function shouldWaitForTimelineChange(_ref2){var timelineChangeController=_ref2.timelineChangeController,currentTimeline=_ref2.currentTimeline,segmentTimeline=_ref2.segmentTimeline,loaderType=_ref2.loaderType,audioDisabled=_ref2.audioDisabled;if(currentTimeline===segmentTimeline){return false;}if(loaderType==='audio'){var lastMainTimelineChange=timelineChangeController.lastTimelineChange({type:'main'});// Audio loader should wait if:
//
// * main hasn't had a timeline change yet (thus has not loaded its first segment)
// * main hasn't yet changed to the timeline audio is looking to load
return!lastMainTimelineChange||lastMainTimelineChange.to!==segmentTimeline;}// The main loader only needs to wait for timeline changes if there's demuxed audio.
// Otherwise, there's nothing to wait for, since audio would be muxed into the main
// loader's segments (or the content is audio/video only and handled by the main
// loader).
if(loaderType==='main'&&audioDisabled){var pendingAudioTimelineChange=timelineChangeController.pendingTimelineChange({type:'audio'});// Main loader should wait for the audio loader if audio is not pending a timeline
// change to the current timeline.
//
// Since the main loader is responsible for setting the timestamp offset for both
// audio and video, the main loader must wait for audio to be about to change to its
// timeline before setting the offset, otherwise, if audio is behind in loading,
// segments from the previous timeline would be adjusted by the new timestamp offset.
//
// This requirement means that video will not cross a timeline until the audio is
// about to cross to it, so that way audio and video will always cross the timeline
// together.
//
// In addition to normal timeline changes, these rules also apply to the start of a
// stream (going from a non-existent timeline, -1, to timeline 0). It's important
// that these rules apply to the first timeline change because if they did not, it's
// possible that the main loader will cross two timelines before the audio loader has
// crossed one. Logic may be implemented to handle the startup as a special case, but
// it's easier to simply treat all timeline changes the same.
if(pendingAudioTimelineChange&&pendingAudioTimelineChange.to===segmentTimeline){return false;}return true;}return false;};var mediaDuration=function mediaDuration(timingInfos){var maxDuration=0;['video','audio'].forEach(function(type){var typeTimingInfo=timingInfos[type+"TimingInfo"];if(!typeTimingInfo){return;}var start=typeTimingInfo.start,end=typeTimingInfo.end;var duration;if(typeof start==='bigint'||typeof end==='bigint'){duration=window_default().BigInt(end)-window_default().BigInt(start);}else if(typeof start==='number'&&typeof end==='number'){duration=end-start;}if(typeof duration!=='undefined'&&duration>maxDuration){maxDuration=duration;}});// convert back to a number if it is lower than MAX_SAFE_INTEGER
// as we only need BigInt when we are above that.
if(typeof maxDuration==='bigint'&&maxDuration<Number.MAX_SAFE_INTEGER){maxDuration=Number(maxDuration);}return maxDuration;};var segmentTooLong=function segmentTooLong(_ref3){var segmentDuration=_ref3.segmentDuration,maxDuration=_ref3.maxDuration;// 0 duration segments are most likely due to metadata only segments or a lack of
// information.
if(!segmentDuration){return false;}// For HLS:
//
// https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1
// The EXTINF duration of each Media Segment in the Playlist
// file, when rounded to the nearest integer, MUST be less than or equal
// to the target duration; longer segments can trigger playback stalls
// or other errors.
//
// For DASH, the mpd-parser uses the largest reported segment duration as the target
// duration. Although that reported duration is occasionally approximate (i.e., not
// exact), a strict check may report that a segment is too long more often in DASH.
return Math.round(segmentDuration)>maxDuration+TIME_FUDGE_FACTOR;};var getTroublesomeSegmentDurationMessage=function getTroublesomeSegmentDurationMessage(segmentInfo,sourceType){// Right now we aren't following DASH's timing model exactly, so only perform
// this check for HLS content.
if(sourceType!=='hls'){return null;}var segmentDuration=mediaDuration({audioTimingInfo:segmentInfo.audioTimingInfo,videoTimingInfo:segmentInfo.videoTimingInfo});// Don't report if we lack information.
//
// If the segment has a duration of 0 it is either a lack of information or a
// metadata only segment and shouldn't be reported here.
if(!segmentDuration){return null;}var targetDuration=segmentInfo.playlist.targetDuration;var isSegmentWayTooLong=segmentTooLong({segmentDuration:segmentDuration,maxDuration:targetDuration*2});var isSegmentSlightlyTooLong=segmentTooLong({segmentDuration:segmentDuration,maxDuration:targetDuration});var segmentTooLongMessage="Segment with index "+segmentInfo.mediaIndex+" "+("from playlist "+segmentInfo.playlist.id+" ")+("has a duration of "+segmentDuration+" ")+("when the reported duration is "+segmentInfo.duration+" ")+("and the target duration is "+targetDuration+". ")+'For HLS content, a duration in excess of the target duration may result in '+'playback issues. See the HLS specification section on EXT-X-TARGETDURATION for '+'more details: '+'https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1';if(isSegmentWayTooLong||isSegmentSlightlyTooLong){return{severity:isSegmentWayTooLong?'warn':'info',message:segmentTooLongMessage};}return null;};/**
 * An object that manages segment loading and appending.
 *
 * @class SegmentLoader
 * @param {Object} options required and optional options
 * @extends videojs.EventTarget
 */var SegmentLoader=/*#__PURE__*/function(_videojs$EventTarget){_inheritsLoose(SegmentLoader,_videojs$EventTarget);function SegmentLoader(settings,options){var _this;_this=_videojs$EventTarget.call(this)||this;// check pre-conditions
if(!settings){throw new TypeError('Initialization settings are required');}if(typeof settings.currentTime!=='function'){throw new TypeError('No currentTime getter specified');}if(!settings.mediaSource){throw new TypeError('No MediaSource specified');}// public properties
_this.bandwidth=settings.bandwidth;_this.throughput={rate:0,count:0};_this.roundTrip=NaN;_this.resetStats_();_this.mediaIndex=null;_this.partIndex=null;// private settings
_this.hasPlayed_=settings.hasPlayed;_this.currentTime_=settings.currentTime;_this.seekable_=settings.seekable;_this.seeking_=settings.seeking;_this.duration_=settings.duration;_this.mediaSource_=settings.mediaSource;_this.vhs_=settings.vhs;_this.loaderType_=settings.loaderType;_this.currentMediaInfo_=void 0;_this.startingMediaInfo_=void 0;_this.segmentMetadataTrack_=settings.segmentMetadataTrack;_this.goalBufferLength_=settings.goalBufferLength;_this.sourceType_=settings.sourceType;_this.sourceUpdater_=settings.sourceUpdater;_this.inbandTextTracks_=settings.inbandTextTracks;_this.state_='INIT';_this.timelineChangeController_=settings.timelineChangeController;_this.shouldSaveSegmentTimingInfo_=true;_this.parse708captions_=settings.parse708captions;_this.useDtsForTimestampOffset_=settings.useDtsForTimestampOffset;_this.captionServices_=settings.captionServices;_this.experimentalExactManifestTimings=settings.experimentalExactManifestTimings;// private instance variables
_this.checkBufferTimeout_=null;_this.error_=void 0;_this.currentTimeline_=-1;_this.pendingSegment_=null;_this.xhrOptions_=null;_this.pendingSegments_=[];_this.audioDisabled_=false;_this.isPendingTimestampOffset_=false;// TODO possibly move gopBuffer and timeMapping info to a separate controller
_this.gopBuffer_=[];_this.timeMapping_=0;_this.safeAppend_=videojs.browser.IE_VERSION>=11;_this.appendInitSegment_={audio:true,video:true};_this.playlistOfLastInitSegment_={audio:null,video:null};_this.callQueue_=[];// If the segment loader prepares to load a segment, but does not have enough
// information yet to start the loading process (e.g., if the audio loader wants to
// load a segment from the next timeline but the main loader hasn't yet crossed that
// timeline), then the load call will be added to the queue until it is ready to be
// processed.
_this.loadQueue_=[];_this.metadataQueue_={id3:[],caption:[]};_this.waitingOnRemove_=false;_this.quotaExceededErrorRetryTimeout_=null;// Fragmented mp4 playback
_this.activeInitSegmentId_=null;_this.initSegments_={};// HLSe playback
_this.cacheEncryptionKeys_=settings.cacheEncryptionKeys;_this.keyCache_={};_this.decrypter_=settings.decrypter;// Manages the tracking and generation of sync-points, mappings
// between a time in the display time and a segment index within
// a playlist
_this.syncController_=settings.syncController;_this.syncPoint_={segmentIndex:0,time:0};_this.transmuxer_=_this.createTransmuxer_();_this.triggerSyncInfoUpdate_=function(){return _this.trigger('syncinfoupdate');};_this.syncController_.on('syncinfoupdate',_this.triggerSyncInfoUpdate_);_this.mediaSource_.addEventListener('sourceopen',function(){if(!_this.isEndOfStream_()){_this.ended_=false;}});// ...for determining the fetch location
_this.fetchAtBuffer_=false;_this.logger_=logger("SegmentLoader["+_this.loaderType_+"]");Object.defineProperty(_assertThisInitialized(_this),'state',{get:function get(){return this.state_;},set:function set(newState){if(newState!==this.state_){this.logger_(this.state_+" -> "+newState);this.state_=newState;this.trigger('statechange');}}});_this.sourceUpdater_.on('ready',function(){if(_this.hasEnoughInfoToAppend_()){_this.processCallQueue_();}});// Only the main loader needs to listen for pending timeline changes, as the main
// loader should wait for audio to be ready to change its timeline so that both main
// and audio timelines change together. For more details, see the
// shouldWaitForTimelineChange function.
if(_this.loaderType_==='main'){_this.timelineChangeController_.on('pendingtimelinechange',function(){if(_this.hasEnoughInfoToAppend_()){_this.processCallQueue_();}});}// The main loader only listens on pending timeline changes, but the audio loader,
// since its loads follow main, needs to listen on timeline changes. For more details,
// see the shouldWaitForTimelineChange function.
if(_this.loaderType_==='audio'){_this.timelineChangeController_.on('timelinechange',function(){if(_this.hasEnoughInfoToLoad_()){_this.processLoadQueue_();}if(_this.hasEnoughInfoToAppend_()){_this.processCallQueue_();}});}return _this;}var _proto=SegmentLoader.prototype;_proto.createTransmuxer_=function createTransmuxer_(){return segmentTransmuxer.createTransmuxer({remux:false,alignGopsAtEnd:this.safeAppend_,keepOriginalTimestamps:true,parse708captions:this.parse708captions_,captionServices:this.captionServices_});}/**
   * reset all of our media stats
   *
   * @private
   */;_proto.resetStats_=function resetStats_(){this.mediaBytesTransferred=0;this.mediaRequests=0;this.mediaRequestsAborted=0;this.mediaRequestsTimedout=0;this.mediaRequestsErrored=0;this.mediaTransferDuration=0;this.mediaSecondsLoaded=0;this.mediaAppends=0;}/**
   * dispose of the SegmentLoader and reset to the default state
   */;_proto.dispose=function dispose(){this.trigger('dispose');this.state='DISPOSED';this.pause();this.abort_();if(this.transmuxer_){this.transmuxer_.terminate();}this.resetStats_();if(this.checkBufferTimeout_){window_default().clearTimeout(this.checkBufferTimeout_);}if(this.syncController_&&this.triggerSyncInfoUpdate_){this.syncController_.off('syncinfoupdate',this.triggerSyncInfoUpdate_);}this.off();};_proto.setAudio=function setAudio(enable){this.audioDisabled_=!enable;if(enable){this.appendInitSegment_.audio=true;}else{// remove current track audio if it gets disabled
this.sourceUpdater_.removeAudio(0,this.duration_());}}/**
   * abort anything that is currently doing on with the SegmentLoader
   * and reset to a default state
   */;_proto.abort=function abort(){if(this.state!=='WAITING'){if(this.pendingSegment_){this.pendingSegment_=null;}return;}this.abort_();// We aborted the requests we were waiting on, so reset the loader's state to READY
// since we are no longer "waiting" on any requests. XHR callback is not always run
// when the request is aborted. This will prevent the loader from being stuck in the
// WAITING state indefinitely.
this.state='READY';// don't wait for buffer check timeouts to begin fetching the
// next segment
if(!this.paused()){this.monitorBuffer_();}}/**
   * abort all pending xhr requests and null any pending segements
   *
   * @private
   */;_proto.abort_=function abort_(){if(this.pendingSegment_&&this.pendingSegment_.abortRequests){this.pendingSegment_.abortRequests();}// clear out the segment being processed
this.pendingSegment_=null;this.callQueue_=[];this.loadQueue_=[];this.metadataQueue_.id3=[];this.metadataQueue_.caption=[];this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_);this.waitingOnRemove_=false;window_default().clearTimeout(this.quotaExceededErrorRetryTimeout_);this.quotaExceededErrorRetryTimeout_=null;};_proto.checkForAbort_=function checkForAbort_(requestId){// If the state is APPENDING, then aborts will not modify the state, meaning the first
// callback that happens should reset the state to READY so that loading can continue.
if(this.state==='APPENDING'&&!this.pendingSegment_){this.state='READY';return true;}if(!this.pendingSegment_||this.pendingSegment_.requestId!==requestId){return true;}return false;}/**
   * set an error on the segment loader and null out any pending segements
   *
   * @param {Error} error the error to set on the SegmentLoader
   * @return {Error} the error that was set or that is currently set
   */;_proto.error=function error(_error){if(typeof _error!=='undefined'){this.logger_('error occurred:',_error);this.error_=_error;}this.pendingSegment_=null;return this.error_;};_proto.endOfStream=function endOfStream(){this.ended_=true;if(this.transmuxer_){// need to clear out any cached data to prepare for the new segment
segmentTransmuxer.reset(this.transmuxer_);}this.gopBuffer_.length=0;this.pause();this.trigger('ended');}/**
   * Indicates which time ranges are buffered
   *
   * @return {TimeRange}
   *         TimeRange object representing the current buffered ranges
   */;_proto.buffered_=function buffered_(){var trackInfo=this.getMediaInfo_();if(!this.sourceUpdater_||!trackInfo){return videojs.createTimeRanges();}if(this.loaderType_==='main'){var hasAudio=trackInfo.hasAudio,hasVideo=trackInfo.hasVideo,isMuxed=trackInfo.isMuxed;if(hasVideo&&hasAudio&&!this.audioDisabled_&&!isMuxed){return this.sourceUpdater_.buffered();}if(hasVideo){return this.sourceUpdater_.videoBuffered();}}// One case that can be ignored for now is audio only with alt audio,
// as we don't yet have proper support for that.
return this.sourceUpdater_.audioBuffered();}/**
   * Gets and sets init segment for the provided map
   *
   * @param {Object} map
   *        The map object representing the init segment to get or set
   * @param {boolean=} set
   *        If true, the init segment for the provided map should be saved
   * @return {Object}
   *         map object for desired init segment
   */;_proto.initSegmentForMap=function initSegmentForMap(map,set){if(set===void 0){set=false;}if(!map){return null;}var id=initSegmentId(map);var storedMap=this.initSegments_[id];if(set&&!storedMap&&map.bytes){this.initSegments_[id]=storedMap={resolvedUri:map.resolvedUri,byterange:map.byterange,bytes:map.bytes,tracks:map.tracks,timescales:map.timescales};}return storedMap||map;}/**
   * Gets and sets key for the provided key
   *
   * @param {Object} key
   *        The key object representing the key to get or set
   * @param {boolean=} set
   *        If true, the key for the provided key should be saved
   * @return {Object}
   *         Key object for desired key
   */;_proto.segmentKey=function segmentKey(key,set){if(set===void 0){set=false;}if(!key){return null;}var id=segmentKeyId(key);var storedKey=this.keyCache_[id];// TODO: We should use the HTTP Expires header to invalidate our cache per
// https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-6.2.3
if(this.cacheEncryptionKeys_&&set&&!storedKey&&key.bytes){this.keyCache_[id]=storedKey={resolvedUri:key.resolvedUri,bytes:key.bytes};}var result={resolvedUri:(storedKey||key).resolvedUri};if(storedKey){result.bytes=storedKey.bytes;}return result;}/**
   * Returns true if all configuration required for loading is present, otherwise false.
   *
   * @return {boolean} True if the all configuration is ready for loading
   * @private
   */;_proto.couldBeginLoading_=function couldBeginLoading_(){return this.playlist_&&!this.paused();}/**
   * load a playlist and start to fill the buffer
   */;_proto.load=function load(){// un-pause
this.monitorBuffer_();// if we don't have a playlist yet, keep waiting for one to be
// specified
if(!this.playlist_){return;}// if all the configuration is ready, initialize and begin loading
if(this.state==='INIT'&&this.couldBeginLoading_()){return this.init_();}// if we're in the middle of processing a segment already, don't
// kick off an additional segment request
if(!this.couldBeginLoading_()||this.state!=='READY'&&this.state!=='INIT'){return;}this.state='READY';}/**
   * Once all the starting parameters have been specified, begin
   * operation. This method should only be invoked from the INIT
   * state.
   *
   * @private
   */;_proto.init_=function init_(){this.state='READY';// if this is the audio segment loader, and it hasn't been inited before, then any old
// audio data from the muxed content should be removed
this.resetEverything();return this.monitorBuffer_();}/**
   * set a playlist on the segment loader
   *
   * @param {PlaylistLoader} media the playlist to set on the segment loader
   */;_proto.playlist=function playlist(newPlaylist,options){if(options===void 0){options={};}if(!newPlaylist){return;}var oldPlaylist=this.playlist_;var segmentInfo=this.pendingSegment_;this.playlist_=newPlaylist;this.xhrOptions_=options;// when we haven't started playing yet, the start of a live playlist
// is always our zero-time so force a sync update each time the playlist
// is refreshed from the server
//
// Use the INIT state to determine if playback has started, as the playlist sync info
// should be fixed once requests begin (as sync points are generated based on sync
// info), but not before then.
if(this.state==='INIT'){newPlaylist.syncInfo={mediaSequence:newPlaylist.mediaSequence,time:0};// Setting the date time mapping means mapping the program date time (if available)
// to time 0 on the player's timeline. The playlist's syncInfo serves a similar
// purpose, mapping the initial mediaSequence to time zero. Since the syncInfo can
// be updated as the playlist is refreshed before the loader starts loading, the
// program date time mapping needs to be updated as well.
//
// This mapping is only done for the main loader because a program date time should
// map equivalently between playlists.
if(this.loaderType_==='main'){this.syncController_.setDateTimeMappingForStart(newPlaylist);}}var oldId=null;if(oldPlaylist){if(oldPlaylist.id){oldId=oldPlaylist.id;}else if(oldPlaylist.uri){oldId=oldPlaylist.uri;}}this.logger_("playlist update ["+oldId+" => "+(newPlaylist.id||newPlaylist.uri)+"]");// in VOD, this is always a rendition switch (or we updated our syncInfo above)
// in LIVE, we always want to update with new playlists (including refreshes)
this.trigger('syncinfoupdate');// if we were unpaused but waiting for a playlist, start
// buffering now
if(this.state==='INIT'&&this.couldBeginLoading_()){return this.init_();}if(!oldPlaylist||oldPlaylist.uri!==newPlaylist.uri){if(this.mediaIndex!==null){// we must reset/resync the segment loader when we switch renditions and
// the segment loader is already synced to the previous rendition
// on playlist changes we want it to be possible to fetch
// at the buffer for vod but not for live. So we use resetLoader
// for live and resyncLoader for vod. We want this because
// if a playlist uses independent and non-independent segments/parts the
// buffer may not accurately reflect the next segment that we should try
// downloading.
if(!newPlaylist.endList){this.resetLoader();}else{this.resyncLoader();}}this.currentMediaInfo_=void 0;this.trigger('playlistupdate');// the rest of this function depends on `oldPlaylist` being defined
return;}// we reloaded the same playlist so we are in a live scenario
// and we will likely need to adjust the mediaIndex
var mediaSequenceDiff=newPlaylist.mediaSequence-oldPlaylist.mediaSequence;this.logger_("live window shift ["+mediaSequenceDiff+"]");// update the mediaIndex on the SegmentLoader
// this is important because we can abort a request and this value must be
// equal to the last appended mediaIndex
if(this.mediaIndex!==null){this.mediaIndex-=mediaSequenceDiff;// this can happen if we are going to load the first segment, but get a playlist
// update during that. mediaIndex would go from 0 to -1 if mediaSequence in the
// new playlist was incremented by 1.
if(this.mediaIndex<0){this.mediaIndex=null;this.partIndex=null;}else{var segment=this.playlist_.segments[this.mediaIndex];// partIndex should remain the same for the same segment
// unless parts fell off of the playlist for this segment.
// In that case we need to reset partIndex and resync
if(this.partIndex&&(!segment.parts||!segment.parts.length||!segment.parts[this.partIndex])){var mediaIndex=this.mediaIndex;this.logger_("currently processing part (index "+this.partIndex+") no longer exists.");this.resetLoader();// We want to throw away the partIndex and the data associated with it,
// as the part was dropped from our current playlists segment.
// The mediaIndex will still be valid so keep that around.
this.mediaIndex=mediaIndex;}}}// update the mediaIndex on the SegmentInfo object
// this is important because we will update this.mediaIndex with this value
// in `handleAppendsDone_` after the segment has been successfully appended
if(segmentInfo){segmentInfo.mediaIndex-=mediaSequenceDiff;if(segmentInfo.mediaIndex<0){segmentInfo.mediaIndex=null;segmentInfo.partIndex=null;}else{// we need to update the referenced segment so that timing information is
// saved for the new playlist's segment, however, if the segment fell off the
// playlist, we can leave the old reference and just lose the timing info
if(segmentInfo.mediaIndex>=0){segmentInfo.segment=newPlaylist.segments[segmentInfo.mediaIndex];}if(segmentInfo.partIndex>=0&&segmentInfo.segment.parts){segmentInfo.part=segmentInfo.segment.parts[segmentInfo.partIndex];}}}this.syncController_.saveExpiredSegmentInfo(oldPlaylist,newPlaylist);}/**
   * Prevent the loader from fetching additional segments. If there
   * is a segment request outstanding, it will finish processing
   * before the loader halts. A segment loader can be unpaused by
   * calling load().
   */;_proto.pause=function pause(){if(this.checkBufferTimeout_){window_default().clearTimeout(this.checkBufferTimeout_);this.checkBufferTimeout_=null;}}/**
   * Returns whether the segment loader is fetching additional
   * segments when given the opportunity. This property can be
   * modified through calls to pause() and load().
   */;_proto.paused=function paused(){return this.checkBufferTimeout_===null;}/**
   * Delete all the buffered data and reset the SegmentLoader
   *
   * @param {Function} [done] an optional callback to be executed when the remove
   * operation is complete
   */;_proto.resetEverything=function resetEverything(done){this.ended_=false;this.activeInitSegmentId_=null;this.appendInitSegment_={audio:true,video:true};this.resetLoader();// remove from 0, the earliest point, to Infinity, to signify removal of everything.
// VTT Segment Loader doesn't need to do anything but in the regular SegmentLoader,
// we then clamp the value to duration if necessary.
this.remove(0,Infinity,done);// clears fmp4 captions
if(this.transmuxer_){this.transmuxer_.postMessage({action:'clearAllMp4Captions'});// reset the cache in the transmuxer
this.transmuxer_.postMessage({action:'reset'});}}/**
   * Force the SegmentLoader to resync and start loading around the currentTime instead
   * of starting at the end of the buffer
   *
   * Useful for fast quality changes
   */;_proto.resetLoader=function resetLoader(){this.fetchAtBuffer_=false;this.resyncLoader();}/**
   * Force the SegmentLoader to restart synchronization and make a conservative guess
   * before returning to the simple walk-forward method
   */;_proto.resyncLoader=function resyncLoader(){if(this.transmuxer_){// need to clear out any cached data to prepare for the new segment
segmentTransmuxer.reset(this.transmuxer_);}this.mediaIndex=null;this.partIndex=null;this.syncPoint_=null;this.isPendingTimestampOffset_=false;this.callQueue_=[];this.loadQueue_=[];this.metadataQueue_.id3=[];this.metadataQueue_.caption=[];this.abort();if(this.transmuxer_){this.transmuxer_.postMessage({action:'clearParsedMp4Captions'});}}/**
   * Remove any data in the source buffer between start and end times
   *
   * @param {number} start - the start time of the region to remove from the buffer
   * @param {number} end - the end time of the region to remove from the buffer
   * @param {Function} [done] - an optional callback to be executed when the remove
   * @param {boolean} force - force all remove operations to happen
   * operation is complete
   */;_proto.remove=function remove(start,end,done,force){if(done===void 0){done=function done(){};}if(force===void 0){force=false;}// clamp end to duration if we need to remove everything.
// This is due to a browser bug that causes issues if we remove to Infinity.
// videojs/videojs-contrib-hls#1225
if(end===Infinity){end=this.duration_();}// skip removes that would throw an error
// commonly happens during a rendition switch at the start of a video
// from start 0 to end 0
if(end<=start){this.logger_('skipping remove because end ${end} is <= start ${start}');return;}if(!this.sourceUpdater_||!this.getMediaInfo_()){this.logger_('skipping remove because no source updater or starting media info');// nothing to remove if we haven't processed any media
return;}// set it to one to complete this function's removes
var removesRemaining=1;var removeFinished=function removeFinished(){removesRemaining--;if(removesRemaining===0){done();}};if(force||!this.audioDisabled_){removesRemaining++;this.sourceUpdater_.removeAudio(start,end,removeFinished);}// While it would be better to only remove video if the main loader has video, this
// should be safe with audio only as removeVideo will call back even if there's no
// video buffer.
//
// In theory we can check to see if there's video before calling the remove, but in
// the event that we're switching between renditions and from video to audio only
// (when we add support for that), we may need to clear the video contents despite
// what the new media will contain.
if(force||this.loaderType_==='main'){this.gopBuffer_=removeGopBuffer(this.gopBuffer_,start,end,this.timeMapping_);removesRemaining++;this.sourceUpdater_.removeVideo(start,end,removeFinished);}// remove any captions and ID3 tags
for(var track in this.inbandTextTracks_){removeCuesFromTrack(start,end,this.inbandTextTracks_[track]);}removeCuesFromTrack(start,end,this.segmentMetadataTrack_);// finished this function's removes
removeFinished();}/**
   * (re-)schedule monitorBufferTick_ to run as soon as possible
   *
   * @private
   */;_proto.monitorBuffer_=function monitorBuffer_(){if(this.checkBufferTimeout_){window_default().clearTimeout(this.checkBufferTimeout_);}this.checkBufferTimeout_=window_default().setTimeout(this.monitorBufferTick_.bind(this),1);}/**
   * As long as the SegmentLoader is in the READY state, periodically
   * invoke fillBuffer_().
   *
   * @private
   */;_proto.monitorBufferTick_=function monitorBufferTick_(){if(this.state==='READY'){this.fillBuffer_();}if(this.checkBufferTimeout_){window_default().clearTimeout(this.checkBufferTimeout_);}this.checkBufferTimeout_=window_default().setTimeout(this.monitorBufferTick_.bind(this),CHECK_BUFFER_DELAY);}/**
   * fill the buffer with segements unless the sourceBuffers are
   * currently updating
   *
   * Note: this function should only ever be called by monitorBuffer_
   * and never directly
   *
   * @private
   */;_proto.fillBuffer_=function fillBuffer_(){// TODO since the source buffer maintains a queue, and we shouldn't call this function
// except when we're ready for the next segment, this check can most likely be removed
if(this.sourceUpdater_.updating()){return;}// see if we need to begin loading immediately
var segmentInfo=this.chooseNextRequest_();if(!segmentInfo){return;}if(typeof segmentInfo.timestampOffset==='number'){this.isPendingTimestampOffset_=false;this.timelineChangeController_.pendingTimelineChange({type:this.loaderType_,from:this.currentTimeline_,to:segmentInfo.timeline});}this.loadSegment_(segmentInfo);}/**
   * Determines if we should call endOfStream on the media source based
   * on the state of the buffer or if appened segment was the final
   * segment in the playlist.
   *
   * @param {number} [mediaIndex] the media index of segment we last appended
   * @param {Object} [playlist] a media playlist object
   * @return {boolean} do we need to call endOfStream on the MediaSource
   */;_proto.isEndOfStream_=function isEndOfStream_(mediaIndex,playlist,partIndex){if(mediaIndex===void 0){mediaIndex=this.mediaIndex;}if(playlist===void 0){playlist=this.playlist_;}if(partIndex===void 0){partIndex=this.partIndex;}if(!playlist||!this.mediaSource_){return false;}var segment=typeof mediaIndex==='number'&&playlist.segments[mediaIndex];// mediaIndex is zero based but length is 1 based
var appendedLastSegment=mediaIndex+1===playlist.segments.length;// true if there are no parts, or this is the last part.
var appendedLastPart=!segment||!segment.parts||partIndex+1===segment.parts.length;// if we've buffered to the end of the video, we need to call endOfStream
// so that MediaSources can trigger the `ended` event when it runs out of
// buffered data instead of waiting for me
return playlist.endList&&this.mediaSource_.readyState==='open'&&appendedLastSegment&&appendedLastPart;}/**
   * Determines what request should be made given current segment loader state.
   *
   * @return {Object} a request object that describes the segment/part to load
   */;_proto.chooseNextRequest_=function chooseNextRequest_(){var buffered=this.buffered_();var bufferedEnd=lastBufferedEnd(buffered)||0;var bufferedTime=timeAheadOf(buffered,this.currentTime_());var preloaded=!this.hasPlayed_()&&bufferedTime>=1;var haveEnoughBuffer=bufferedTime>=this.goalBufferLength_();var segments=this.playlist_.segments;// return no segment if:
// 1. we don't have segments
// 2. The video has not yet played and we already downloaded a segment
// 3. we already have enough buffered time
if(!segments.length||preloaded||haveEnoughBuffer){return null;}this.syncPoint_=this.syncPoint_||this.syncController_.getSyncPoint(this.playlist_,this.duration_(),this.currentTimeline_,this.currentTime_());var next={partIndex:null,mediaIndex:null,startOfSegment:null,playlist:this.playlist_,isSyncRequest:Boolean(!this.syncPoint_)};if(next.isSyncRequest){next.mediaIndex=getSyncSegmentCandidate(this.currentTimeline_,segments,bufferedEnd);}else if(this.mediaIndex!==null){var segment=segments[this.mediaIndex];var partIndex=typeof this.partIndex==='number'?this.partIndex:-1;next.startOfSegment=segment.end?segment.end:bufferedEnd;if(segment.parts&&segment.parts[partIndex+1]){next.mediaIndex=this.mediaIndex;next.partIndex=partIndex+1;}else{next.mediaIndex=this.mediaIndex+1;}}else{// Find the segment containing the end of the buffer or current time.
var _Playlist$getMediaInf=Playlist.getMediaInfoForTime({experimentalExactManifestTimings:this.experimentalExactManifestTimings,playlist:this.playlist_,currentTime:this.fetchAtBuffer_?bufferedEnd:this.currentTime_(),startingPartIndex:this.syncPoint_.partIndex,startingSegmentIndex:this.syncPoint_.segmentIndex,startTime:this.syncPoint_.time}),segmentIndex=_Playlist$getMediaInf.segmentIndex,startTime=_Playlist$getMediaInf.startTime,_partIndex=_Playlist$getMediaInf.partIndex;next.getMediaInfoForTime=this.fetchAtBuffer_?"bufferedEnd "+bufferedEnd:"currentTime "+this.currentTime_();next.mediaIndex=segmentIndex;next.startOfSegment=startTime;next.partIndex=_partIndex;}var nextSegment=segments[next.mediaIndex];var nextPart=nextSegment&&typeof next.partIndex==='number'&&nextSegment.parts&&nextSegment.parts[next.partIndex];// if the next segment index is invalid or
// the next partIndex is invalid do not choose a next segment.
if(!nextSegment||typeof next.partIndex==='number'&&!nextPart){return null;}// if the next segment has parts, and we don't have a partIndex.
// Set partIndex to 0
if(typeof next.partIndex!=='number'&&nextSegment.parts){next.partIndex=0;nextPart=nextSegment.parts[0];}// if we have no buffered data then we need to make sure
// that the next part we append is "independent" if possible.
// So we check if the previous part is independent, and request
// it if it is.
if(!bufferedTime&&nextPart&&!nextPart.independent){if(next.partIndex===0){var lastSegment=segments[next.mediaIndex-1];var lastSegmentLastPart=lastSegment.parts&&lastSegment.parts.length&&lastSegment.parts[lastSegment.parts.length-1];if(lastSegmentLastPart&&lastSegmentLastPart.independent){next.mediaIndex-=1;next.partIndex=lastSegment.parts.length-1;next.independent='previous segment';}}else if(nextSegment.parts[next.partIndex-1].independent){next.partIndex-=1;next.independent='previous part';}}var ended=this.mediaSource_&&this.mediaSource_.readyState==='ended';// do not choose a next segment if all of the following:
// 1. this is the last segment in the playlist
// 2. end of stream has been called on the media source already
// 3. the player is not seeking
if(next.mediaIndex>=segments.length-1&&ended&&!this.seeking_()){return null;}return this.generateSegmentInfo_(next);};_proto.generateSegmentInfo_=function generateSegmentInfo_(options){var independent=options.independent,playlist=options.playlist,mediaIndex=options.mediaIndex,startOfSegment=options.startOfSegment,isSyncRequest=options.isSyncRequest,partIndex=options.partIndex,forceTimestampOffset=options.forceTimestampOffset,getMediaInfoForTime=options.getMediaInfoForTime;var segment=playlist.segments[mediaIndex];var part=typeof partIndex==='number'&&segment.parts[partIndex];var segmentInfo={requestId:'segment-loader-'+Math.random(),// resolve the segment URL relative to the playlist
uri:part&&part.resolvedUri||segment.resolvedUri,// the segment's mediaIndex at the time it was requested
mediaIndex:mediaIndex,partIndex:part?partIndex:null,// whether or not to update the SegmentLoader's state with this
// segment's mediaIndex
isSyncRequest:isSyncRequest,startOfSegment:startOfSegment,// the segment's playlist
playlist:playlist,// unencrypted bytes of the segment
bytes:null,// when a key is defined for this segment, the encrypted bytes
encryptedBytes:null,// The target timestampOffset for this segment when we append it
// to the source buffer
timestampOffset:null,// The timeline that the segment is in
timeline:segment.timeline,// The expected duration of the segment in seconds
duration:part&&part.duration||segment.duration,// retain the segment in case the playlist updates while doing an async process
segment:segment,part:part,byteLength:0,transmuxer:this.transmuxer_,// type of getMediaInfoForTime that was used to get this segment
getMediaInfoForTime:getMediaInfoForTime,independent:independent};var overrideCheck=typeof forceTimestampOffset!=='undefined'?forceTimestampOffset:this.isPendingTimestampOffset_;segmentInfo.timestampOffset=this.timestampOffsetForSegment_({segmentTimeline:segment.timeline,currentTimeline:this.currentTimeline_,startOfSegment:startOfSegment,buffered:this.buffered_(),overrideCheck:overrideCheck});var audioBufferedEnd=lastBufferedEnd(this.sourceUpdater_.audioBuffered());if(typeof audioBufferedEnd==='number'){// since the transmuxer is using the actual timing values, but the buffer is
// adjusted by the timestamp offset, we must adjust the value here
segmentInfo.audioAppendStart=audioBufferedEnd-this.sourceUpdater_.audioTimestampOffset();}if(this.sourceUpdater_.videoBuffered().length){segmentInfo.gopsToAlignWith=gopsSafeToAlignWith(this.gopBuffer_,// since the transmuxer is using the actual timing values, but the time is
// adjusted by the timestmap offset, we must adjust the value here
this.currentTime_()-this.sourceUpdater_.videoTimestampOffset(),this.timeMapping_);}return segmentInfo;}// get the timestampoffset for a segment,
// added so that vtt segment loader can override and prevent
// adding timestamp offsets.
;_proto.timestampOffsetForSegment_=function timestampOffsetForSegment_(options){return timestampOffsetForSegment(options);}/**
   * Determines if the network has enough bandwidth to complete the current segment
   * request in a timely manner. If not, the request will be aborted early and bandwidth
   * updated to trigger a playlist switch.
   *
   * @param {Object} stats
   *        Object containing stats about the request timing and size
   * @private
   */;_proto.earlyAbortWhenNeeded_=function earlyAbortWhenNeeded_(stats){if(this.vhs_.tech_.paused()||// Don't abort if the current playlist is on the lowestEnabledRendition
// TODO: Replace using timeout with a boolean indicating whether this playlist is
//       the lowestEnabledRendition.
!this.xhrOptions_.timeout||// Don't abort if we have no bandwidth information to estimate segment sizes
!this.playlist_.attributes.BANDWIDTH){return;}// Wait at least 1 second since the first byte of data has been received before
// using the calculated bandwidth from the progress event to allow the bitrate
// to stabilize
if(Date.now()-(stats.firstBytesReceivedAt||Date.now())<1000){return;}var currentTime=this.currentTime_();var measuredBandwidth=stats.bandwidth;var segmentDuration=this.pendingSegment_.duration;var requestTimeRemaining=Playlist.estimateSegmentRequestTime(segmentDuration,measuredBandwidth,this.playlist_,stats.bytesReceived);// Subtract 1 from the timeUntilRebuffer so we still consider an early abort
// if we are only left with less than 1 second when the request completes.
// A negative timeUntilRebuffering indicates we are already rebuffering
var timeUntilRebuffer$1=timeUntilRebuffer(this.buffered_(),currentTime,this.vhs_.tech_.playbackRate())-1;// Only consider aborting early if the estimated time to finish the download
// is larger than the estimated time until the player runs out of forward buffer
if(requestTimeRemaining<=timeUntilRebuffer$1){return;}var switchCandidate=minRebufferMaxBandwidthSelector({master:this.vhs_.playlists.master,currentTime:currentTime,bandwidth:measuredBandwidth,duration:this.duration_(),segmentDuration:segmentDuration,timeUntilRebuffer:timeUntilRebuffer$1,currentTimeline:this.currentTimeline_,syncController:this.syncController_});if(!switchCandidate){return;}var rebufferingImpact=requestTimeRemaining-timeUntilRebuffer$1;var timeSavedBySwitching=rebufferingImpact-switchCandidate.rebufferingImpact;var minimumTimeSaving=0.5;// If we are already rebuffering, increase the amount of variance we add to the
// potential round trip time of the new request so that we are not too aggressive
// with switching to a playlist that might save us a fraction of a second.
if(timeUntilRebuffer$1<=TIME_FUDGE_FACTOR){minimumTimeSaving=1;}if(!switchCandidate.playlist||switchCandidate.playlist.uri===this.playlist_.uri||timeSavedBySwitching<minimumTimeSaving){return;}// set the bandwidth to that of the desired playlist being sure to scale by
// BANDWIDTH_VARIANCE and add one so the playlist selector does not exclude it
// don't trigger a bandwidthupdate as the bandwidth is artifial
this.bandwidth=switchCandidate.playlist.attributes.BANDWIDTH*Config.BANDWIDTH_VARIANCE+1;this.trigger('earlyabort');};_proto.handleAbort_=function handleAbort_(segmentInfo){this.logger_("Aborting "+segmentInfoString(segmentInfo));this.mediaRequestsAborted+=1;}/**
   * XHR `progress` event handler
   *
   * @param {Event}
   *        The XHR `progress` event
   * @param {Object} simpleSegment
   *        A simplified segment object copy
   * @private
   */;_proto.handleProgress_=function handleProgress_(event,simpleSegment){this.earlyAbortWhenNeeded_(simpleSegment.stats);if(this.checkForAbort_(simpleSegment.requestId)){return;}this.trigger('progress');};_proto.handleTrackInfo_=function handleTrackInfo_(simpleSegment,trackInfo){this.earlyAbortWhenNeeded_(simpleSegment.stats);if(this.checkForAbort_(simpleSegment.requestId)){return;}if(this.checkForIllegalMediaSwitch(trackInfo)){return;}trackInfo=trackInfo||{};// When we have track info, determine what media types this loader is dealing with.
// Guard against cases where we're not getting track info at all until we are
// certain that all streams will provide it.
if(!shallowEqual(this.currentMediaInfo_,trackInfo)){this.appendInitSegment_={audio:true,video:true};this.startingMediaInfo_=trackInfo;this.currentMediaInfo_=trackInfo;this.logger_('trackinfo update',trackInfo);this.trigger('trackinfo');}// trackinfo may cause an abort if the trackinfo
// causes a codec change to an unsupported codec.
if(this.checkForAbort_(simpleSegment.requestId)){return;}// set trackinfo on the pending segment so that
// it can append.
this.pendingSegment_.trackInfo=trackInfo;// check if any calls were waiting on the track info
if(this.hasEnoughInfoToAppend_()){this.processCallQueue_();}};_proto.handleTimingInfo_=function handleTimingInfo_(simpleSegment,mediaType,timeType,time){this.earlyAbortWhenNeeded_(simpleSegment.stats);if(this.checkForAbort_(simpleSegment.requestId)){return;}var segmentInfo=this.pendingSegment_;var timingInfoProperty=timingInfoPropertyForMedia(mediaType);segmentInfo[timingInfoProperty]=segmentInfo[timingInfoProperty]||{};segmentInfo[timingInfoProperty][timeType]=time;this.logger_("timinginfo: "+mediaType+" - "+timeType+" - "+time);// check if any calls were waiting on the timing info
if(this.hasEnoughInfoToAppend_()){this.processCallQueue_();}};_proto.handleCaptions_=function handleCaptions_(simpleSegment,captionData){var _this2=this;this.earlyAbortWhenNeeded_(simpleSegment.stats);if(this.checkForAbort_(simpleSegment.requestId)){return;}// This could only happen with fmp4 segments, but
// should still not happen in general
if(captionData.length===0){this.logger_('SegmentLoader received no captions from a caption event');return;}var segmentInfo=this.pendingSegment_;// Wait until we have some video data so that caption timing
// can be adjusted by the timestamp offset
if(!segmentInfo.hasAppendedData_){this.metadataQueue_.caption.push(this.handleCaptions_.bind(this,simpleSegment,captionData));return;}var timestampOffset=this.sourceUpdater_.videoTimestampOffset()===null?this.sourceUpdater_.audioTimestampOffset():this.sourceUpdater_.videoTimestampOffset();var captionTracks={};// get total start/end and captions for each track/stream
captionData.forEach(function(caption){// caption.stream is actually a track name...
// set to the existing values in tracks or default values
captionTracks[caption.stream]=captionTracks[caption.stream]||{// Infinity, as any other value will be less than this
startTime:Infinity,captions:[],// 0 as an other value will be more than this
endTime:0};var captionTrack=captionTracks[caption.stream];captionTrack.startTime=Math.min(captionTrack.startTime,caption.startTime+timestampOffset);captionTrack.endTime=Math.max(captionTrack.endTime,caption.endTime+timestampOffset);captionTrack.captions.push(caption);});Object.keys(captionTracks).forEach(function(trackName){var _captionTracks$trackN=captionTracks[trackName],startTime=_captionTracks$trackN.startTime,endTime=_captionTracks$trackN.endTime,captions=_captionTracks$trackN.captions;var inbandTextTracks=_this2.inbandTextTracks_;_this2.logger_("adding cues from "+startTime+" -> "+endTime+" for "+trackName);createCaptionsTrackIfNotExists(inbandTextTracks,_this2.vhs_.tech_,trackName);// clear out any cues that start and end at the same time period for the same track.
// We do this because a rendition change that also changes the timescale for captions
// will result in captions being re-parsed for certain segments. If we add them again
// without clearing we will have two of the same captions visible.
removeCuesFromTrack(startTime,endTime,inbandTextTracks[trackName]);addCaptionData({captionArray:captions,inbandTextTracks:inbandTextTracks,timestampOffset:timestampOffset});});// Reset stored captions since we added parsed
// captions to a text track at this point
if(this.transmuxer_){this.transmuxer_.postMessage({action:'clearParsedMp4Captions'});}};_proto.handleId3_=function handleId3_(simpleSegment,id3Frames,dispatchType){this.earlyAbortWhenNeeded_(simpleSegment.stats);if(this.checkForAbort_(simpleSegment.requestId)){return;}var segmentInfo=this.pendingSegment_;// we need to have appended data in order for the timestamp offset to be set
if(!segmentInfo.hasAppendedData_){this.metadataQueue_.id3.push(this.handleId3_.bind(this,simpleSegment,id3Frames,dispatchType));return;}var timestampOffset=this.sourceUpdater_.videoTimestampOffset()===null?this.sourceUpdater_.audioTimestampOffset():this.sourceUpdater_.videoTimestampOffset();// There's potentially an issue where we could double add metadata if there's a muxed
// audio/video source with a metadata track, and an alt audio with a metadata track.
// However, this probably won't happen, and if it does it can be handled then.
createMetadataTrackIfNotExists(this.inbandTextTracks_,dispatchType,this.vhs_.tech_);addMetadata({inbandTextTracks:this.inbandTextTracks_,metadataArray:id3Frames,timestampOffset:timestampOffset,videoDuration:this.duration_()});};_proto.processMetadataQueue_=function processMetadataQueue_(){this.metadataQueue_.id3.forEach(function(fn){return fn();});this.metadataQueue_.caption.forEach(function(fn){return fn();});this.metadataQueue_.id3=[];this.metadataQueue_.caption=[];};_proto.processCallQueue_=function processCallQueue_(){var callQueue=this.callQueue_;// Clear out the queue before the queued functions are run, since some of the
// functions may check the length of the load queue and default to pushing themselves
// back onto the queue.
this.callQueue_=[];callQueue.forEach(function(fun){return fun();});};_proto.processLoadQueue_=function processLoadQueue_(){var loadQueue=this.loadQueue_;// Clear out the queue before the queued functions are run, since some of the
// functions may check the length of the load queue and default to pushing themselves
// back onto the queue.
this.loadQueue_=[];loadQueue.forEach(function(fun){return fun();});}/**
   * Determines whether the loader has enough info to load the next segment.
   *
   * @return {boolean}
   *         Whether or not the loader has enough info to load the next segment
   */;_proto.hasEnoughInfoToLoad_=function hasEnoughInfoToLoad_(){// Since primary timing goes by video, only the audio loader potentially needs to wait
// to load.
if(this.loaderType_!=='audio'){return true;}var segmentInfo=this.pendingSegment_;// A fill buffer must have already run to establish a pending segment before there's
// enough info to load.
if(!segmentInfo){return false;}// The first segment can and should be loaded immediately so that source buffers are
// created together (before appending). Source buffer creation uses the presence of
// audio and video data to determine whether to create audio/video source buffers, and
// uses processed (transmuxed or parsed) media to determine the types required.
if(!this.getCurrentMediaInfo_()){return true;}if(// Technically, instead of waiting to load a segment on timeline changes, a segment
// can be requested and downloaded and only wait before it is transmuxed or parsed.
// But in practice, there are a few reasons why it is better to wait until a loader
// is ready to append that segment before requesting and downloading:
//
// 1. Because audio and main loaders cross discontinuities together, if this loader
//    is waiting for the other to catch up, then instead of requesting another
//    segment and using up more bandwidth, by not yet loading, more bandwidth is
//    allotted to the loader currently behind.
// 2. media-segment-request doesn't have to have logic to consider whether a segment
// is ready to be processed or not, isolating the queueing behavior to the loader.
// 3. The audio loader bases some of its segment properties on timing information
//    provided by the main loader, meaning that, if the logic for waiting on
//    processing was in media-segment-request, then it would also need to know how
//    to re-generate the segment information after the main loader caught up.
shouldWaitForTimelineChange({timelineChangeController:this.timelineChangeController_,currentTimeline:this.currentTimeline_,segmentTimeline:segmentInfo.timeline,loaderType:this.loaderType_,audioDisabled:this.audioDisabled_})){return false;}return true;};_proto.getCurrentMediaInfo_=function getCurrentMediaInfo_(segmentInfo){if(segmentInfo===void 0){segmentInfo=this.pendingSegment_;}return segmentInfo&&segmentInfo.trackInfo||this.currentMediaInfo_;};_proto.getMediaInfo_=function getMediaInfo_(segmentInfo){if(segmentInfo===void 0){segmentInfo=this.pendingSegment_;}return this.getCurrentMediaInfo_(segmentInfo)||this.startingMediaInfo_;};_proto.getPendingSegmentPlaylist=function getPendingSegmentPlaylist(){return this.pendingSegment_?this.pendingSegment_.playlist:null;};_proto.hasEnoughInfoToAppend_=function hasEnoughInfoToAppend_(){if(!this.sourceUpdater_.ready()){return false;}// If content needs to be removed or the loader is waiting on an append reattempt,
// then no additional content should be appended until the prior append is resolved.
if(this.waitingOnRemove_||this.quotaExceededErrorRetryTimeout_){return false;}var segmentInfo=this.pendingSegment_;var trackInfo=this.getCurrentMediaInfo_();// no segment to append any data for or
// we do not have information on this specific
// segment yet
if(!segmentInfo||!trackInfo){return false;}var hasAudio=trackInfo.hasAudio,hasVideo=trackInfo.hasVideo,isMuxed=trackInfo.isMuxed;if(hasVideo&&!segmentInfo.videoTimingInfo){return false;}// muxed content only relies on video timing information for now.
if(hasAudio&&!this.audioDisabled_&&!isMuxed&&!segmentInfo.audioTimingInfo){return false;}if(shouldWaitForTimelineChange({timelineChangeController:this.timelineChangeController_,currentTimeline:this.currentTimeline_,segmentTimeline:segmentInfo.timeline,loaderType:this.loaderType_,audioDisabled:this.audioDisabled_})){return false;}return true;};_proto.handleData_=function handleData_(simpleSegment,result){this.earlyAbortWhenNeeded_(simpleSegment.stats);if(this.checkForAbort_(simpleSegment.requestId)){return;}// If there's anything in the call queue, then this data came later and should be
// executed after the calls currently queued.
if(this.callQueue_.length||!this.hasEnoughInfoToAppend_()){this.callQueue_.push(this.handleData_.bind(this,simpleSegment,result));return;}var segmentInfo=this.pendingSegment_;// update the time mapping so we can translate from display time to media time
this.setTimeMapping_(segmentInfo.timeline);// for tracking overall stats
this.updateMediaSecondsLoaded_(segmentInfo.part||segmentInfo.segment);// Note that the state isn't changed from loading to appending. This is because abort
// logic may change behavior depending on the state, and changing state too early may
// inflate our estimates of bandwidth. In the future this should be re-examined to
// note more granular states.
// don't process and append data if the mediaSource is closed
if(this.mediaSource_.readyState==='closed'){return;}// if this request included an initialization segment, save that data
// to the initSegment cache
if(simpleSegment.map){simpleSegment.map=this.initSegmentForMap(simpleSegment.map,true);// move over init segment properties to media request
segmentInfo.segment.map=simpleSegment.map;}// if this request included a segment key, save that data in the cache
if(simpleSegment.key){this.segmentKey(simpleSegment.key,true);}segmentInfo.isFmp4=simpleSegment.isFmp4;segmentInfo.timingInfo=segmentInfo.timingInfo||{};if(segmentInfo.isFmp4){this.trigger('fmp4');segmentInfo.timingInfo.start=segmentInfo[timingInfoPropertyForMedia(result.type)].start;}else{var trackInfo=this.getCurrentMediaInfo_();var useVideoTimingInfo=this.loaderType_==='main'&&trackInfo&&trackInfo.hasVideo;var firstVideoFrameTimeForData;if(useVideoTimingInfo){firstVideoFrameTimeForData=segmentInfo.videoTimingInfo.start;}// Segment loader knows more about segment timing than the transmuxer (in certain
// aspects), so make any changes required for a more accurate start time.
// Don't set the end time yet, as the segment may not be finished processing.
segmentInfo.timingInfo.start=this.trueSegmentStart_({currentStart:segmentInfo.timingInfo.start,playlist:segmentInfo.playlist,mediaIndex:segmentInfo.mediaIndex,currentVideoTimestampOffset:this.sourceUpdater_.videoTimestampOffset(),useVideoTimingInfo:useVideoTimingInfo,firstVideoFrameTimeForData:firstVideoFrameTimeForData,videoTimingInfo:segmentInfo.videoTimingInfo,audioTimingInfo:segmentInfo.audioTimingInfo});}// Init segments for audio and video only need to be appended in certain cases. Now
// that data is about to be appended, we can check the final cases to determine
// whether we should append an init segment.
this.updateAppendInitSegmentStatus(segmentInfo,result.type);// Timestamp offset should be updated once we get new data and have its timing info,
// as we use the start of the segment to offset the best guess (playlist provided)
// timestamp offset.
this.updateSourceBufferTimestampOffset_(segmentInfo);// if this is a sync request we need to determine whether it should
// be appended or not.
if(segmentInfo.isSyncRequest){// first save/update our timing info for this segment.
// this is what allows us to choose an accurate segment
// and the main reason we make a sync request.
this.updateTimingInfoEnd_(segmentInfo);this.syncController_.saveSegmentTimingInfo({segmentInfo:segmentInfo,shouldSaveTimelineMapping:this.loaderType_==='main'});var next=this.chooseNextRequest_();// If the sync request isn't the segment that would be requested next
// after taking into account its timing info, do not append it.
if(next.mediaIndex!==segmentInfo.mediaIndex||next.partIndex!==segmentInfo.partIndex){this.logger_('sync segment was incorrect, not appending');return;}// otherwise append it like any other segment as our guess was correct.
this.logger_('sync segment was correct, appending');}// Save some state so that in the future anything waiting on first append (and/or
// timestamp offset(s)) can process immediately. While the extra state isn't optimal,
// we need some notion of whether the timestamp offset or other relevant information
// has had a chance to be set.
segmentInfo.hasAppendedData_=true;// Now that the timestamp offset should be set, we can append any waiting ID3 tags.
this.processMetadataQueue_();this.appendData_(segmentInfo,result);};_proto.updateAppendInitSegmentStatus=function updateAppendInitSegmentStatus(segmentInfo,type){// alt audio doesn't manage timestamp offset
if(this.loaderType_==='main'&&typeof segmentInfo.timestampOffset==='number'&&// in the case that we're handling partial data, we don't want to append an init
// segment for each chunk
!segmentInfo.changedTimestampOffset){// if the timestamp offset changed, the timeline may have changed, so we have to re-
// append init segments
this.appendInitSegment_={audio:true,video:true};}if(this.playlistOfLastInitSegment_[type]!==segmentInfo.playlist){// make sure we append init segment on playlist changes, in case the media config
// changed
this.appendInitSegment_[type]=true;}};_proto.getInitSegmentAndUpdateState_=function getInitSegmentAndUpdateState_(_ref4){var type=_ref4.type,initSegment=_ref4.initSegment,map=_ref4.map,playlist=_ref4.playlist;// "The EXT-X-MAP tag specifies how to obtain the Media Initialization Section
// (Section 3) required to parse the applicable Media Segments.  It applies to every
// Media Segment that appears after it in the Playlist until the next EXT-X-MAP tag
// or until the end of the playlist."
// https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.2.5
if(map){var id=initSegmentId(map);if(this.activeInitSegmentId_===id){// don't need to re-append the init segment if the ID matches
return null;}// a map-specified init segment takes priority over any transmuxed (or otherwise
// obtained) init segment
//
// this also caches the init segment for later use
initSegment=this.initSegmentForMap(map,true).bytes;this.activeInitSegmentId_=id;}// We used to always prepend init segments for video, however, that shouldn't be
// necessary. Instead, we should only append on changes, similar to what we've always
// done for audio. This is more important (though may not be that important) for
// frame-by-frame appending for LHLS, simply because of the increased quantity of
// appends.
if(initSegment&&this.appendInitSegment_[type]){// Make sure we track the playlist that we last used for the init segment, so that
// we can re-append the init segment in the event that we get data from a new
// playlist. Discontinuities and track changes are handled in other sections.
this.playlistOfLastInitSegment_[type]=playlist;// Disable future init segment appends for this type. Until a change is necessary.
this.appendInitSegment_[type]=false;// we need to clear out the fmp4 active init segment id, since
// we are appending the muxer init segment
this.activeInitSegmentId_=null;return initSegment;}return null;};_proto.handleQuotaExceededError_=function handleQuotaExceededError_(_ref5,error){var _this3=this;var segmentInfo=_ref5.segmentInfo,type=_ref5.type,bytes=_ref5.bytes;var audioBuffered=this.sourceUpdater_.audioBuffered();var videoBuffered=this.sourceUpdater_.videoBuffered();// For now we're ignoring any notion of gaps in the buffer, but they, in theory,
// should be cleared out during the buffer removals. However, log in case it helps
// debug.
if(audioBuffered.length>1){this.logger_('On QUOTA_EXCEEDED_ERR, found gaps in the audio buffer: '+timeRangesToArray(audioBuffered).join(', '));}if(videoBuffered.length>1){this.logger_('On QUOTA_EXCEEDED_ERR, found gaps in the video buffer: '+timeRangesToArray(videoBuffered).join(', '));}var audioBufferStart=audioBuffered.length?audioBuffered.start(0):0;var audioBufferEnd=audioBuffered.length?audioBuffered.end(audioBuffered.length-1):0;var videoBufferStart=videoBuffered.length?videoBuffered.start(0):0;var videoBufferEnd=videoBuffered.length?videoBuffered.end(videoBuffered.length-1):0;if(audioBufferEnd-audioBufferStart<=MIN_BACK_BUFFER&&videoBufferEnd-videoBufferStart<=MIN_BACK_BUFFER){// Can't remove enough buffer to make room for new segment (or the browser doesn't
// allow for appends of segments this size). In the future, it may be possible to
// split up the segment and append in pieces, but for now, error out this playlist
// in an attempt to switch to a more manageable rendition.
this.logger_('On QUOTA_EXCEEDED_ERR, single segment too large to append to '+'buffer, triggering an error. '+("Appended byte length: "+bytes.byteLength+", ")+("audio buffer: "+timeRangesToArray(audioBuffered).join(', ')+", ")+("video buffer: "+timeRangesToArray(videoBuffered).join(', ')+", "));this.error({message:'Quota exceeded error with append of a single segment of content',excludeUntil:Infinity});this.trigger('error');return;}// To try to resolve the quota exceeded error, clear back buffer and retry. This means
// that the segment-loader should block on future events until this one is handled, so
// that it doesn't keep moving onto further segments. Adding the call to the call
// queue will prevent further appends until waitingOnRemove_ and
// quotaExceededErrorRetryTimeout_ are cleared.
//
// Note that this will only block the current loader. In the case of demuxed content,
// the other load may keep filling as fast as possible. In practice, this should be
// OK, as it is a rare case when either audio has a high enough bitrate to fill up a
// source buffer, or video fills without enough room for audio to append (and without
// the availability of clearing out seconds of back buffer to make room for audio).
// But it might still be good to handle this case in the future as a TODO.
this.waitingOnRemove_=true;this.callQueue_.push(this.appendToSourceBuffer_.bind(this,{segmentInfo:segmentInfo,type:type,bytes:bytes}));var currentTime=this.currentTime_();// Try to remove as much audio and video as possible to make room for new content
// before retrying.
var timeToRemoveUntil=currentTime-MIN_BACK_BUFFER;this.logger_("On QUOTA_EXCEEDED_ERR, removing audio/video from 0 to "+timeToRemoveUntil);this.remove(0,timeToRemoveUntil,function(){_this3.logger_("On QUOTA_EXCEEDED_ERR, retrying append in "+MIN_BACK_BUFFER+"s");_this3.waitingOnRemove_=false;// wait the length of time alotted in the back buffer to prevent wasted
// attempts (since we can't clear less than the minimum)
_this3.quotaExceededErrorRetryTimeout_=window_default().setTimeout(function(){_this3.logger_('On QUOTA_EXCEEDED_ERR, re-processing call queue');_this3.quotaExceededErrorRetryTimeout_=null;_this3.processCallQueue_();},MIN_BACK_BUFFER*1000);},true);};_proto.handleAppendError_=function handleAppendError_(_ref6,error){var segmentInfo=_ref6.segmentInfo,type=_ref6.type,bytes=_ref6.bytes;// if there's no error, nothing to do
if(!error){return;}if(error.code===QUOTA_EXCEEDED_ERR){this.handleQuotaExceededError_({segmentInfo:segmentInfo,type:type,bytes:bytes});// A quota exceeded error should be recoverable with a future re-append, so no need
// to trigger an append error.
return;}this.logger_('Received non QUOTA_EXCEEDED_ERR on append',error);this.error(type+" append of "+bytes.length+"b failed for segment "+("#"+segmentInfo.mediaIndex+" in playlist "+segmentInfo.playlist.id));// If an append errors, we often can't recover.
// (see https://w3c.github.io/media-source/#sourcebuffer-append-error).
//
// Trigger a special error so that it can be handled separately from normal,
// recoverable errors.
this.trigger('appenderror');};_proto.appendToSourceBuffer_=function appendToSourceBuffer_(_ref7){var segmentInfo=_ref7.segmentInfo,type=_ref7.type,initSegment=_ref7.initSegment,data=_ref7.data,bytes=_ref7.bytes;// If this is a re-append, bytes were already created and don't need to be recreated
if(!bytes){var segments=[data];var byteLength=data.byteLength;if(initSegment){// if the media initialization segment is changing, append it before the content
// segment
segments.unshift(initSegment);byteLength+=initSegment.byteLength;}// Technically we should be OK appending the init segment separately, however, we
// haven't yet tested that, and prepending is how we have always done things.
bytes=concatSegments({bytes:byteLength,segments:segments});}this.sourceUpdater_.appendBuffer({segmentInfo:segmentInfo,type:type,bytes:bytes},this.handleAppendError_.bind(this,{segmentInfo:segmentInfo,type:type,bytes:bytes}));};_proto.handleSegmentTimingInfo_=function handleSegmentTimingInfo_(type,requestId,segmentTimingInfo){if(!this.pendingSegment_||requestId!==this.pendingSegment_.requestId){return;}var segment=this.pendingSegment_.segment;var timingInfoProperty=type+"TimingInfo";if(!segment[timingInfoProperty]){segment[timingInfoProperty]={};}segment[timingInfoProperty].transmuxerPrependedSeconds=segmentTimingInfo.prependedContentDuration||0;segment[timingInfoProperty].transmuxedPresentationStart=segmentTimingInfo.start.presentation;segment[timingInfoProperty].transmuxedDecodeStart=segmentTimingInfo.start.decode;segment[timingInfoProperty].transmuxedPresentationEnd=segmentTimingInfo.end.presentation;segment[timingInfoProperty].transmuxedDecodeEnd=segmentTimingInfo.end.decode;// mainly used as a reference for debugging
segment[timingInfoProperty].baseMediaDecodeTime=segmentTimingInfo.baseMediaDecodeTime;};_proto.appendData_=function appendData_(segmentInfo,result){var type=result.type,data=result.data;if(!data||!data.byteLength){return;}if(type==='audio'&&this.audioDisabled_){return;}var initSegment=this.getInitSegmentAndUpdateState_({type:type,initSegment:result.initSegment,playlist:segmentInfo.playlist,map:segmentInfo.isFmp4?segmentInfo.segment.map:null});this.appendToSourceBuffer_({segmentInfo:segmentInfo,type:type,initSegment:initSegment,data:data});}/**
   * load a specific segment from a request into the buffer
   *
   * @private
   */;_proto.loadSegment_=function loadSegment_(segmentInfo){var _this4=this;this.state='WAITING';this.pendingSegment_=segmentInfo;this.trimBackBuffer_(segmentInfo);if(typeof segmentInfo.timestampOffset==='number'){if(this.transmuxer_){this.transmuxer_.postMessage({action:'clearAllMp4Captions'});}}if(!this.hasEnoughInfoToLoad_()){this.loadQueue_.push(function(){// regenerate the audioAppendStart, timestampOffset, etc as they
// may have changed since this function was added to the queue.
var options=_extends({},segmentInfo,{forceTimestampOffset:true});_extends(segmentInfo,_this4.generateSegmentInfo_(options));_this4.isPendingTimestampOffset_=false;_this4.updateTransmuxerAndRequestSegment_(segmentInfo);});return;}this.updateTransmuxerAndRequestSegment_(segmentInfo);};_proto.updateTransmuxerAndRequestSegment_=function updateTransmuxerAndRequestSegment_(segmentInfo){var _this5=this;// We'll update the source buffer's timestamp offset once we have transmuxed data, but
// the transmuxer still needs to be updated before then.
//
// Even though keepOriginalTimestamps is set to true for the transmuxer, timestamp
// offset must be passed to the transmuxer for stream correcting adjustments.
if(this.shouldUpdateTransmuxerTimestampOffset_(segmentInfo.timestampOffset)){this.gopBuffer_.length=0;// gopsToAlignWith was set before the GOP buffer was cleared
segmentInfo.gopsToAlignWith=[];this.timeMapping_=0;// reset values in the transmuxer since a discontinuity should start fresh
this.transmuxer_.postMessage({action:'reset'});this.transmuxer_.postMessage({action:'setTimestampOffset',timestampOffset:segmentInfo.timestampOffset});}var simpleSegment=this.createSimplifiedSegmentObj_(segmentInfo);var isEndOfStream=this.isEndOfStream_(segmentInfo.mediaIndex,segmentInfo.playlist,segmentInfo.partIndex);var isWalkingForward=this.mediaIndex!==null;var isDiscontinuity=segmentInfo.timeline!==this.currentTimeline_&&// currentTimeline starts at -1, so we shouldn't end the timeline switching to 0,
// the first timeline
segmentInfo.timeline>0;var isEndOfTimeline=isEndOfStream||isWalkingForward&&isDiscontinuity;this.logger_("Requesting "+segmentInfoString(segmentInfo));// If there's an init segment associated with this segment, but it is not cached (identified by a lack of bytes),
// then this init segment has never been seen before and should be appended.
//
// At this point the content type (audio/video or both) is not yet known, but it should be safe to set
// both to true and leave the decision of whether to append the init segment to append time.
if(simpleSegment.map&&!simpleSegment.map.bytes){this.logger_('going to request init segment.');this.appendInitSegment_={video:true,audio:true};}segmentInfo.abortRequests=mediaSegmentRequest({xhr:this.vhs_.xhr,xhrOptions:this.xhrOptions_,decryptionWorker:this.decrypter_,segment:simpleSegment,abortFn:this.handleAbort_.bind(this,segmentInfo),progressFn:this.handleProgress_.bind(this),trackInfoFn:this.handleTrackInfo_.bind(this),timingInfoFn:this.handleTimingInfo_.bind(this),videoSegmentTimingInfoFn:this.handleSegmentTimingInfo_.bind(this,'video',segmentInfo.requestId),audioSegmentTimingInfoFn:this.handleSegmentTimingInfo_.bind(this,'audio',segmentInfo.requestId),captionsFn:this.handleCaptions_.bind(this),isEndOfTimeline:isEndOfTimeline,endedTimelineFn:function endedTimelineFn(){_this5.logger_('received endedtimeline callback');},id3Fn:this.handleId3_.bind(this),dataFn:this.handleData_.bind(this),doneFn:this.segmentRequestFinished_.bind(this),onTransmuxerLog:function onTransmuxerLog(_ref8){var message=_ref8.message,level=_ref8.level,stream=_ref8.stream;_this5.logger_(segmentInfoString(segmentInfo)+" logged from transmuxer stream "+stream+" as a "+level+": "+message);}});}/**
   * trim the back buffer so that we don't have too much data
   * in the source buffer
   *
   * @private
   *
   * @param {Object} segmentInfo - the current segment
   */;_proto.trimBackBuffer_=function trimBackBuffer_(segmentInfo){var removeToTime=safeBackBufferTrimTime(this.seekable_(),this.currentTime_(),this.playlist_.targetDuration||10);// Chrome has a hard limit of 150MB of
// buffer and a very conservative "garbage collector"
// We manually clear out the old buffer to ensure
// we don't trigger the QuotaExceeded error
// on the source buffer during subsequent appends
if(removeToTime>0){this.remove(0,removeToTime);}}/**
   * created a simplified copy of the segment object with just the
   * information necessary to perform the XHR and decryption
   *
   * @private
   *
   * @param {Object} segmentInfo - the current segment
   * @return {Object} a simplified segment object copy
   */;_proto.createSimplifiedSegmentObj_=function createSimplifiedSegmentObj_(segmentInfo){var segment=segmentInfo.segment;var part=segmentInfo.part;var simpleSegment={resolvedUri:part?part.resolvedUri:segment.resolvedUri,byterange:part?part.byterange:segment.byterange,requestId:segmentInfo.requestId,transmuxer:segmentInfo.transmuxer,audioAppendStart:segmentInfo.audioAppendStart,gopsToAlignWith:segmentInfo.gopsToAlignWith,part:segmentInfo.part};var previousSegment=segmentInfo.playlist.segments[segmentInfo.mediaIndex-1];if(previousSegment&&previousSegment.timeline===segment.timeline){// The baseStartTime of a segment is used to handle rollover when probing the TS
// segment to retrieve timing information. Since the probe only looks at the media's
// times (e.g., PTS and DTS values of the segment), and doesn't consider the
// player's time (e.g., player.currentTime()), baseStartTime should reflect the
// media time as well. transmuxedDecodeEnd represents the end time of a segment, in
// seconds of media time, so should be used here. The previous segment is used since
// the end of the previous segment should represent the beginning of the current
// segment, so long as they are on the same timeline.
if(previousSegment.videoTimingInfo){simpleSegment.baseStartTime=previousSegment.videoTimingInfo.transmuxedDecodeEnd;}else if(previousSegment.audioTimingInfo){simpleSegment.baseStartTime=previousSegment.audioTimingInfo.transmuxedDecodeEnd;}}if(segment.key){// if the media sequence is greater than 2^32, the IV will be incorrect
// assuming 10s segments, that would be about 1300 years
var iv=segment.key.iv||new Uint32Array([0,0,0,segmentInfo.mediaIndex+segmentInfo.playlist.mediaSequence]);simpleSegment.key=this.segmentKey(segment.key);simpleSegment.key.iv=iv;}if(segment.map){simpleSegment.map=this.initSegmentForMap(segment.map);}return simpleSegment;};_proto.saveTransferStats_=function saveTransferStats_(stats){// every request counts as a media request even if it has been aborted
// or canceled due to a timeout
this.mediaRequests+=1;if(stats){this.mediaBytesTransferred+=stats.bytesReceived;this.mediaTransferDuration+=stats.roundTripTime;}};_proto.saveBandwidthRelatedStats_=function saveBandwidthRelatedStats_(duration,stats){// byteLength will be used for throughput, and should be based on bytes receieved,
// which we only know at the end of the request and should reflect total bytes
// downloaded rather than just bytes processed from components of the segment
this.pendingSegment_.byteLength=stats.bytesReceived;if(duration<MIN_SEGMENT_DURATION_TO_SAVE_STATS){this.logger_("Ignoring segment's bandwidth because its duration of "+duration+(" is less than the min to record "+MIN_SEGMENT_DURATION_TO_SAVE_STATS));return;}this.bandwidth=stats.bandwidth;this.roundTrip=stats.roundTripTime;};_proto.handleTimeout_=function handleTimeout_(){// although the VTT segment loader bandwidth isn't really used, it's good to
// maintain functinality between segment loaders
this.mediaRequestsTimedout+=1;this.bandwidth=1;this.roundTrip=NaN;this.trigger('bandwidthupdate');this.trigger('timeout');}/**
   * Handle the callback from the segmentRequest function and set the
   * associated SegmentLoader state and errors if necessary
   *
   * @private
   */;_proto.segmentRequestFinished_=function segmentRequestFinished_(error,simpleSegment,result){// TODO handle special cases, e.g., muxed audio/video but only audio in the segment
// check the call queue directly since this function doesn't need to deal with any
// data, and can continue even if the source buffers are not set up and we didn't get
// any data from the segment
if(this.callQueue_.length){this.callQueue_.push(this.segmentRequestFinished_.bind(this,error,simpleSegment,result));return;}this.saveTransferStats_(simpleSegment.stats);// The request was aborted and the SegmentLoader has already been reset
if(!this.pendingSegment_){return;}// the request was aborted and the SegmentLoader has already started
// another request. this can happen when the timeout for an aborted
// request triggers due to a limitation in the XHR library
// do not count this as any sort of request or we risk double-counting
if(simpleSegment.requestId!==this.pendingSegment_.requestId){return;}// an error occurred from the active pendingSegment_ so reset everything
if(error){this.pendingSegment_=null;this.state='READY';// aborts are not a true error condition and nothing corrective needs to be done
if(error.code===REQUEST_ERRORS.ABORTED){return;}this.pause();// the error is really just that at least one of the requests timed-out
// set the bandwidth to a very low value and trigger an ABR switch to
// take emergency action
if(error.code===REQUEST_ERRORS.TIMEOUT){this.handleTimeout_();return;}// if control-flow has arrived here, then the error is real
// emit an error event to blacklist the current playlist
this.mediaRequestsErrored+=1;this.error(error);this.trigger('error');return;}var segmentInfo=this.pendingSegment_;// the response was a success so set any bandwidth stats the request
// generated for ABR purposes
this.saveBandwidthRelatedStats_(segmentInfo.duration,simpleSegment.stats);segmentInfo.endOfAllRequests=simpleSegment.endOfAllRequests;if(result.gopInfo){this.gopBuffer_=updateGopBuffer(this.gopBuffer_,result.gopInfo,this.safeAppend_);}// Although we may have already started appending on progress, we shouldn't switch the
// state away from loading until we are officially done loading the segment data.
this.state='APPENDING';// used for testing
this.trigger('appending');this.waitForAppendsToComplete_(segmentInfo);};_proto.setTimeMapping_=function setTimeMapping_(timeline){var timelineMapping=this.syncController_.mappingForTimeline(timeline);if(timelineMapping!==null){this.timeMapping_=timelineMapping;}};_proto.updateMediaSecondsLoaded_=function updateMediaSecondsLoaded_(segment){if(typeof segment.start==='number'&&typeof segment.end==='number'){this.mediaSecondsLoaded+=segment.end-segment.start;}else{this.mediaSecondsLoaded+=segment.duration;}};_proto.shouldUpdateTransmuxerTimestampOffset_=function shouldUpdateTransmuxerTimestampOffset_(timestampOffset){if(timestampOffset===null){return false;}// note that we're potentially using the same timestamp offset for both video and
// audio
if(this.loaderType_==='main'&&timestampOffset!==this.sourceUpdater_.videoTimestampOffset()){return true;}if(!this.audioDisabled_&&timestampOffset!==this.sourceUpdater_.audioTimestampOffset()){return true;}return false;};_proto.trueSegmentStart_=function trueSegmentStart_(_ref9){var currentStart=_ref9.currentStart,playlist=_ref9.playlist,mediaIndex=_ref9.mediaIndex,firstVideoFrameTimeForData=_ref9.firstVideoFrameTimeForData,currentVideoTimestampOffset=_ref9.currentVideoTimestampOffset,useVideoTimingInfo=_ref9.useVideoTimingInfo,videoTimingInfo=_ref9.videoTimingInfo,audioTimingInfo=_ref9.audioTimingInfo;if(typeof currentStart!=='undefined'){// if start was set once, keep using it
return currentStart;}if(!useVideoTimingInfo){return audioTimingInfo.start;}var previousSegment=playlist.segments[mediaIndex-1];// The start of a segment should be the start of the first full frame contained
// within that segment. Since the transmuxer maintains a cache of incomplete data
// from and/or the last frame seen, the start time may reflect a frame that starts
// in the previous segment. Check for that case and ensure the start time is
// accurate for the segment.
if(mediaIndex===0||!previousSegment||typeof previousSegment.start==='undefined'||previousSegment.end!==firstVideoFrameTimeForData+currentVideoTimestampOffset){return firstVideoFrameTimeForData;}return videoTimingInfo.start;};_proto.waitForAppendsToComplete_=function waitForAppendsToComplete_(segmentInfo){var trackInfo=this.getCurrentMediaInfo_(segmentInfo);if(!trackInfo){this.error({message:'No starting media returned, likely due to an unsupported media format.',blacklistDuration:Infinity});this.trigger('error');return;}// Although transmuxing is done, appends may not yet be finished. Throw a marker
// on each queue this loader is responsible for to ensure that the appends are
// complete.
var hasAudio=trackInfo.hasAudio,hasVideo=trackInfo.hasVideo,isMuxed=trackInfo.isMuxed;var waitForVideo=this.loaderType_==='main'&&hasVideo;var waitForAudio=!this.audioDisabled_&&hasAudio&&!isMuxed;segmentInfo.waitingOnAppends=0;// segments with no data
if(!segmentInfo.hasAppendedData_){if(!segmentInfo.timingInfo&&typeof segmentInfo.timestampOffset==='number'){// When there's no audio or video data in the segment, there's no audio or video
// timing information.
//
// If there's no audio or video timing information, then the timestamp offset
// can't be adjusted to the appropriate value for the transmuxer and source
// buffers.
//
// Therefore, the next segment should be used to set the timestamp offset.
this.isPendingTimestampOffset_=true;}// override settings for metadata only segments
segmentInfo.timingInfo={start:0};segmentInfo.waitingOnAppends++;if(!this.isPendingTimestampOffset_){// update the timestampoffset
this.updateSourceBufferTimestampOffset_(segmentInfo);// make sure the metadata queue is processed even though we have
// no video/audio data.
this.processMetadataQueue_();}// append is "done" instantly with no data.
this.checkAppendsDone_(segmentInfo);return;}// Since source updater could call back synchronously, do the increments first.
if(waitForVideo){segmentInfo.waitingOnAppends++;}if(waitForAudio){segmentInfo.waitingOnAppends++;}if(waitForVideo){this.sourceUpdater_.videoQueueCallback(this.checkAppendsDone_.bind(this,segmentInfo));}if(waitForAudio){this.sourceUpdater_.audioQueueCallback(this.checkAppendsDone_.bind(this,segmentInfo));}};_proto.checkAppendsDone_=function checkAppendsDone_(segmentInfo){if(this.checkForAbort_(segmentInfo.requestId)){return;}segmentInfo.waitingOnAppends--;if(segmentInfo.waitingOnAppends===0){this.handleAppendsDone_();}};_proto.checkForIllegalMediaSwitch=function checkForIllegalMediaSwitch(trackInfo){var illegalMediaSwitchError=illegalMediaSwitch(this.loaderType_,this.getCurrentMediaInfo_(),trackInfo);if(illegalMediaSwitchError){this.error({message:illegalMediaSwitchError,blacklistDuration:Infinity});this.trigger('error');return true;}return false;};_proto.updateSourceBufferTimestampOffset_=function updateSourceBufferTimestampOffset_(segmentInfo){if(segmentInfo.timestampOffset===null||// we don't yet have the start for whatever media type (video or audio) has
// priority, timing-wise, so we must wait
typeof segmentInfo.timingInfo.start!=='number'||// already updated the timestamp offset for this segment
segmentInfo.changedTimestampOffset||// the alt audio loader should not be responsible for setting the timestamp offset
this.loaderType_!=='main'){return;}var didChange=false;// Primary timing goes by video, and audio is trimmed in the transmuxer, meaning that
// the timing info here comes from video. In the event that the audio is longer than
// the video, this will trim the start of the audio.
// This also trims any offset from 0 at the beginning of the media
segmentInfo.timestampOffset-=this.getSegmentStartTimeForTimestampOffsetCalculation_({videoTimingInfo:segmentInfo.segment.videoTimingInfo,audioTimingInfo:segmentInfo.segment.audioTimingInfo,timingInfo:segmentInfo.timingInfo});// In the event that there are part segment downloads, each will try to update the
// timestamp offset. Retaining this bit of state prevents us from updating in the
// future (within the same segment), however, there may be a better way to handle it.
segmentInfo.changedTimestampOffset=true;if(segmentInfo.timestampOffset!==this.sourceUpdater_.videoTimestampOffset()){this.sourceUpdater_.videoTimestampOffset(segmentInfo.timestampOffset);didChange=true;}if(segmentInfo.timestampOffset!==this.sourceUpdater_.audioTimestampOffset()){this.sourceUpdater_.audioTimestampOffset(segmentInfo.timestampOffset);didChange=true;}if(didChange){this.trigger('timestampoffset');}};_proto.getSegmentStartTimeForTimestampOffsetCalculation_=function getSegmentStartTimeForTimestampOffsetCalculation_(_ref10){var videoTimingInfo=_ref10.videoTimingInfo,audioTimingInfo=_ref10.audioTimingInfo,timingInfo=_ref10.timingInfo;if(!this.useDtsForTimestampOffset_){return timingInfo.start;}if(videoTimingInfo&&typeof videoTimingInfo.transmuxedDecodeStart==='number'){return videoTimingInfo.transmuxedDecodeStart;}// handle audio only
if(audioTimingInfo&&typeof audioTimingInfo.transmuxedDecodeStart==='number'){return audioTimingInfo.transmuxedDecodeStart;}// handle content not transmuxed (e.g., MP4)
return timingInfo.start;};_proto.updateTimingInfoEnd_=function updateTimingInfoEnd_(segmentInfo){segmentInfo.timingInfo=segmentInfo.timingInfo||{};var trackInfo=this.getMediaInfo_();var useVideoTimingInfo=this.loaderType_==='main'&&trackInfo&&trackInfo.hasVideo;var prioritizedTimingInfo=useVideoTimingInfo&&segmentInfo.videoTimingInfo?segmentInfo.videoTimingInfo:segmentInfo.audioTimingInfo;if(!prioritizedTimingInfo){return;}segmentInfo.timingInfo.end=typeof prioritizedTimingInfo.end==='number'?// End time may not exist in a case where we aren't parsing the full segment (one
// current example is the case of fmp4), so use the rough duration to calculate an
// end time.
prioritizedTimingInfo.end:prioritizedTimingInfo.start+segmentInfo.duration;}/**
   * callback to run when appendBuffer is finished. detects if we are
   * in a good state to do things with the data we got, or if we need
   * to wait for more
   *
   * @private
   */;_proto.handleAppendsDone_=function handleAppendsDone_(){// appendsdone can cause an abort
if(this.pendingSegment_){this.trigger('appendsdone');}if(!this.pendingSegment_){this.state='READY';// TODO should this move into this.checkForAbort to speed up requests post abort in
// all appending cases?
if(!this.paused()){this.monitorBuffer_();}return;}var segmentInfo=this.pendingSegment_;// Now that the end of the segment has been reached, we can set the end time. It's
// best to wait until all appends are done so we're sure that the primary media is
// finished (and we have its end time).
this.updateTimingInfoEnd_(segmentInfo);if(this.shouldSaveSegmentTimingInfo_){// Timeline mappings should only be saved for the main loader. This is for multiple
// reasons:
//
// 1) Only one mapping is saved per timeline, meaning that if both the audio loader
//    and the main loader try to save the timeline mapping, whichever comes later
//    will overwrite the first. In theory this is OK, as the mappings should be the
//    same, however, it breaks for (2)
// 2) In the event of a live stream, the initial live point will make for a somewhat
//    arbitrary mapping. If audio and video streams are not perfectly in-sync, then
//    the mapping will be off for one of the streams, dependent on which one was
//    first saved (see (1)).
// 3) Primary timing goes by video in VHS, so the mapping should be video.
//
// Since the audio loader will wait for the main loader to load the first segment,
// the main loader will save the first timeline mapping, and ensure that there won't
// be a case where audio loads two segments without saving a mapping (thus leading
// to missing segment timing info).
this.syncController_.saveSegmentTimingInfo({segmentInfo:segmentInfo,shouldSaveTimelineMapping:this.loaderType_==='main'});}var segmentDurationMessage=getTroublesomeSegmentDurationMessage(segmentInfo,this.sourceType_);if(segmentDurationMessage){if(segmentDurationMessage.severity==='warn'){videojs.log.warn(segmentDurationMessage.message);}else{this.logger_(segmentDurationMessage.message);}}this.recordThroughput_(segmentInfo);this.pendingSegment_=null;this.state='READY';if(segmentInfo.isSyncRequest){this.trigger('syncinfoupdate');// if the sync request was not appended
// then it was not the correct segment.
// throw it away and use the data it gave us
// to get the correct one.
if(!segmentInfo.hasAppendedData_){this.logger_("Throwing away un-appended sync request "+segmentInfoString(segmentInfo));return;}}this.logger_("Appended "+segmentInfoString(segmentInfo));this.addSegmentMetadataCue_(segmentInfo);this.fetchAtBuffer_=true;if(this.currentTimeline_!==segmentInfo.timeline){this.timelineChangeController_.lastTimelineChange({type:this.loaderType_,from:this.currentTimeline_,to:segmentInfo.timeline});// If audio is not disabled, the main segment loader is responsible for updating
// the audio timeline as well. If the content is video only, this won't have any
// impact.
if(this.loaderType_==='main'&&!this.audioDisabled_){this.timelineChangeController_.lastTimelineChange({type:'audio',from:this.currentTimeline_,to:segmentInfo.timeline});}}this.currentTimeline_=segmentInfo.timeline;// We must update the syncinfo to recalculate the seekable range before
// the following conditional otherwise it may consider this a bad "guess"
// and attempt to resync when the post-update seekable window and live
// point would mean that this was the perfect segment to fetch
this.trigger('syncinfoupdate');var segment=segmentInfo.segment;var part=segmentInfo.part;var badSegmentGuess=segment.end&&this.currentTime_()-segment.end>segmentInfo.playlist.targetDuration*3;var badPartGuess=part&&part.end&&this.currentTime_()-part.end>segmentInfo.playlist.partTargetDuration*3;// If we previously appended a segment/part that ends more than 3 part/targetDurations before
// the currentTime_ that means that our conservative guess was too conservative.
// In that case, reset the loader state so that we try to use any information gained
// from the previous request to create a new, more accurate, sync-point.
if(badSegmentGuess||badPartGuess){this.logger_("bad "+(badSegmentGuess?'segment':'part')+" "+segmentInfoString(segmentInfo));this.resetEverything();return;}var isWalkingForward=this.mediaIndex!==null;// Don't do a rendition switch unless we have enough time to get a sync segment
// and conservatively guess
if(isWalkingForward){this.trigger('bandwidthupdate');}this.trigger('progress');this.mediaIndex=segmentInfo.mediaIndex;this.partIndex=segmentInfo.partIndex;// any time an update finishes and the last segment is in the
// buffer, end the stream. this ensures the "ended" event will
// fire if playback reaches that point.
if(this.isEndOfStream_(segmentInfo.mediaIndex,segmentInfo.playlist,segmentInfo.partIndex)){this.endOfStream();}// used for testing
this.trigger('appended');if(segmentInfo.hasAppendedData_){this.mediaAppends++;}if(!this.paused()){this.monitorBuffer_();}}/**
   * Records the current throughput of the decrypt, transmux, and append
   * portion of the semgment pipeline. `throughput.rate` is a the cumulative
   * moving average of the throughput. `throughput.count` is the number of
   * data points in the average.
   *
   * @private
   * @param {Object} segmentInfo the object returned by loadSegment
   */;_proto.recordThroughput_=function recordThroughput_(segmentInfo){if(segmentInfo.duration<MIN_SEGMENT_DURATION_TO_SAVE_STATS){this.logger_("Ignoring segment's throughput because its duration of "+segmentInfo.duration+(" is less than the min to record "+MIN_SEGMENT_DURATION_TO_SAVE_STATS));return;}var rate=this.throughput.rate;// Add one to the time to ensure that we don't accidentally attempt to divide
// by zero in the case where the throughput is ridiculously high
var segmentProcessingTime=Date.now()-segmentInfo.endOfAllRequests+1;// Multiply by 8000 to convert from bytes/millisecond to bits/second
var segmentProcessingThroughput=Math.floor(segmentInfo.byteLength/segmentProcessingTime*8*1000);// This is just a cumulative moving average calculation:
//   newAvg = oldAvg + (sample - oldAvg) / (sampleCount + 1)
this.throughput.rate+=(segmentProcessingThroughput-rate)/++this.throughput.count;}/**
   * Adds a cue to the segment-metadata track with some metadata information about the
   * segment
   *
   * @private
   * @param {Object} segmentInfo
   *        the object returned by loadSegment
   * @method addSegmentMetadataCue_
   */;_proto.addSegmentMetadataCue_=function addSegmentMetadataCue_(segmentInfo){if(!this.segmentMetadataTrack_){return;}var segment=segmentInfo.segment;var start=segment.start;var end=segment.end;// Do not try adding the cue if the start and end times are invalid.
if(!finite(start)||!finite(end)){return;}removeCuesFromTrack(start,end,this.segmentMetadataTrack_);var Cue=(window_default()).WebKitDataCue||(window_default()).VTTCue;var value={custom:segment.custom,dateTimeObject:segment.dateTimeObject,dateTimeString:segment.dateTimeString,bandwidth:segmentInfo.playlist.attributes.BANDWIDTH,resolution:segmentInfo.playlist.attributes.RESOLUTION,codecs:segmentInfo.playlist.attributes.CODECS,byteLength:segmentInfo.byteLength,uri:segmentInfo.uri,timeline:segmentInfo.timeline,playlist:segmentInfo.playlist.id,start:start,end:end};var data=JSON.stringify(value);var cue=new Cue(start,end,data);// Attach the metadata to the value property of the cue to keep consistency between
// the differences of WebKitDataCue in safari and VTTCue in other browsers
cue.value=value;this.segmentMetadataTrack_.addCue(cue);};return SegmentLoader;}(videojs.EventTarget);function noop(){}var toTitleCase=function toTitleCase(string){if(typeof string!=='string'){return string;}return string.replace(/./,function(w){return w.toUpperCase();});};var bufferTypes=['video','audio'];var _updating=function updating(type,sourceUpdater){var sourceBuffer=sourceUpdater[type+"Buffer"];return sourceBuffer&&sourceBuffer.updating||sourceUpdater.queuePending[type];};var nextQueueIndexOfType=function nextQueueIndexOfType(type,queue){for(var i=0;i<queue.length;i++){var queueEntry=queue[i];if(queueEntry.type==='mediaSource'){// If the next entry is a media source entry (uses multiple source buffers), block
// processing to allow it to go through first.
return null;}if(queueEntry.type===type){return i;}}return null;};var shiftQueue=function shiftQueue(type,sourceUpdater){if(sourceUpdater.queue.length===0){return;}var queueIndex=0;var queueEntry=sourceUpdater.queue[queueIndex];if(queueEntry.type==='mediaSource'){if(!sourceUpdater.updating()&&sourceUpdater.mediaSource.readyState!=='closed'){sourceUpdater.queue.shift();queueEntry.action(sourceUpdater);if(queueEntry.doneFn){queueEntry.doneFn();}// Only specific source buffer actions must wait for async updateend events. Media
// Source actions process synchronously. Therefore, both audio and video source
// buffers are now clear to process the next queue entries.
shiftQueue('audio',sourceUpdater);shiftQueue('video',sourceUpdater);}// Media Source actions require both source buffers, so if the media source action
// couldn't process yet (because one or both source buffers are busy), block other
// queue actions until both are available and the media source action can process.
return;}if(type==='mediaSource'){// If the queue was shifted by a media source action (this happens when pushing a
// media source action onto the queue), then it wasn't from an updateend event from an
// audio or video source buffer, so there's no change from previous state, and no
// processing should be done.
return;}// Media source queue entries don't need to consider whether the source updater is
// started (i.e., source buffers are created) as they don't need the source buffers, but
// source buffer queue entries do.
if(!sourceUpdater.ready()||sourceUpdater.mediaSource.readyState==='closed'||_updating(type,sourceUpdater)){return;}if(queueEntry.type!==type){queueIndex=nextQueueIndexOfType(type,sourceUpdater.queue);if(queueIndex===null){// Either there's no queue entry that uses this source buffer type in the queue, or
// there's a media source queue entry before the next entry of this type, in which
// case wait for that action to process first.
return;}queueEntry=sourceUpdater.queue[queueIndex];}sourceUpdater.queue.splice(queueIndex,1);// Keep a record that this source buffer type is in use.
//
// The queue pending operation must be set before the action is performed in the event
// that the action results in a synchronous event that is acted upon. For instance, if
// an exception is thrown that can be handled, it's possible that new actions will be
// appended to an empty queue and immediately executed, but would not have the correct
// pending information if this property was set after the action was performed.
sourceUpdater.queuePending[type]=queueEntry;queueEntry.action(type,sourceUpdater);if(!queueEntry.doneFn){// synchronous operation, process next entry
sourceUpdater.queuePending[type]=null;shiftQueue(type,sourceUpdater);return;}};var cleanupBuffer=function cleanupBuffer(type,sourceUpdater){var buffer=sourceUpdater[type+"Buffer"];var titleType=toTitleCase(type);if(!buffer){return;}buffer.removeEventListener('updateend',sourceUpdater["on"+titleType+"UpdateEnd_"]);buffer.removeEventListener('error',sourceUpdater["on"+titleType+"Error_"]);sourceUpdater.codecs[type]=null;sourceUpdater[type+"Buffer"]=null;};var inSourceBuffers=function inSourceBuffers(mediaSource,sourceBuffer){return mediaSource&&sourceBuffer&&Array.prototype.indexOf.call(mediaSource.sourceBuffers,sourceBuffer)!==-1;};var actions={appendBuffer:function appendBuffer(bytes,segmentInfo,onError){return function(type,sourceUpdater){var sourceBuffer=sourceUpdater[type+"Buffer"];// can't do anything if the media source / source buffer is null
// or the media source does not contain this source buffer.
if(!inSourceBuffers(sourceUpdater.mediaSource,sourceBuffer)){return;}sourceUpdater.logger_("Appending segment "+segmentInfo.mediaIndex+"'s "+bytes.length+" bytes to "+type+"Buffer");try{sourceBuffer.appendBuffer(bytes);}catch(e){sourceUpdater.logger_("Error with code "+e.code+" "+(e.code===QUOTA_EXCEEDED_ERR?'(QUOTA_EXCEEDED_ERR) ':'')+("when appending segment "+segmentInfo.mediaIndex+" to "+type+"Buffer"));sourceUpdater.queuePending[type]=null;onError(e);}};},remove:function remove(start,end){return function(type,sourceUpdater){var sourceBuffer=sourceUpdater[type+"Buffer"];// can't do anything if the media source / source buffer is null
// or the media source does not contain this source buffer.
if(!inSourceBuffers(sourceUpdater.mediaSource,sourceBuffer)){return;}sourceUpdater.logger_("Removing "+start+" to "+end+" from "+type+"Buffer");try{sourceBuffer.remove(start,end);}catch(e){sourceUpdater.logger_("Remove "+start+" to "+end+" from "+type+"Buffer failed");}};},timestampOffset:function timestampOffset(offset){return function(type,sourceUpdater){var sourceBuffer=sourceUpdater[type+"Buffer"];// can't do anything if the media source / source buffer is null
// or the media source does not contain this source buffer.
if(!inSourceBuffers(sourceUpdater.mediaSource,sourceBuffer)){return;}sourceUpdater.logger_("Setting "+type+"timestampOffset to "+offset);sourceBuffer.timestampOffset=offset;};},callback:function callback(_callback){return function(type,sourceUpdater){_callback();};},endOfStream:function endOfStream(error){return function(sourceUpdater){if(sourceUpdater.mediaSource.readyState!=='open'){return;}sourceUpdater.logger_("Calling mediaSource endOfStream("+(error||'')+")");try{sourceUpdater.mediaSource.endOfStream(error);}catch(e){videojs.log.warn('Failed to call media source endOfStream',e);}};},duration:function duration(_duration){return function(sourceUpdater){sourceUpdater.logger_("Setting mediaSource duration to "+_duration);try{sourceUpdater.mediaSource.duration=_duration;}catch(e){videojs.log.warn('Failed to set media source duration',e);}};},abort:function abort(){return function(type,sourceUpdater){if(sourceUpdater.mediaSource.readyState!=='open'){return;}var sourceBuffer=sourceUpdater[type+"Buffer"];// can't do anything if the media source / source buffer is null
// or the media source does not contain this source buffer.
if(!inSourceBuffers(sourceUpdater.mediaSource,sourceBuffer)){return;}sourceUpdater.logger_("calling abort on "+type+"Buffer");try{sourceBuffer.abort();}catch(e){videojs.log.warn("Failed to abort on "+type+"Buffer",e);}};},addSourceBuffer:function addSourceBuffer(type,codec){return function(sourceUpdater){var titleType=toTitleCase(type);var mime=getMimeForCodec(codec);sourceUpdater.logger_("Adding "+type+"Buffer with codec "+codec+" to mediaSource");var sourceBuffer=sourceUpdater.mediaSource.addSourceBuffer(mime);sourceBuffer.addEventListener('updateend',sourceUpdater["on"+titleType+"UpdateEnd_"]);sourceBuffer.addEventListener('error',sourceUpdater["on"+titleType+"Error_"]);sourceUpdater.codecs[type]=codec;sourceUpdater[type+"Buffer"]=sourceBuffer;};},removeSourceBuffer:function removeSourceBuffer(type){return function(sourceUpdater){var sourceBuffer=sourceUpdater[type+"Buffer"];cleanupBuffer(type,sourceUpdater);// can't do anything if the media source / source buffer is null
// or the media source does not contain this source buffer.
if(!inSourceBuffers(sourceUpdater.mediaSource,sourceBuffer)){return;}sourceUpdater.logger_("Removing "+type+"Buffer with codec "+sourceUpdater.codecs[type]+" from mediaSource");try{sourceUpdater.mediaSource.removeSourceBuffer(sourceBuffer);}catch(e){videojs.log.warn("Failed to removeSourceBuffer "+type+"Buffer",e);}};},changeType:function changeType(codec){return function(type,sourceUpdater){var sourceBuffer=sourceUpdater[type+"Buffer"];var mime=getMimeForCodec(codec);// can't do anything if the media source / source buffer is null
// or the media source does not contain this source buffer.
if(!inSourceBuffers(sourceUpdater.mediaSource,sourceBuffer)){return;}// do not update codec if we don't need to.
if(sourceUpdater.codecs[type]===codec){return;}sourceUpdater.logger_("changing "+type+"Buffer codec from "+sourceUpdater.codecs[type]+" to "+codec);// check if change to the provided type is supported
try{sourceBuffer.changeType(mime);sourceUpdater.codecs[type]=codec;}catch(e){videojs.log.warn("Failed to changeType on "+type+"Buffer",e);}};}};var pushQueue=function pushQueue(_ref){var type=_ref.type,sourceUpdater=_ref.sourceUpdater,action=_ref.action,doneFn=_ref.doneFn,name=_ref.name;sourceUpdater.queue.push({type:type,action:action,doneFn:doneFn,name:name});shiftQueue(type,sourceUpdater);};var onUpdateend=function onUpdateend(type,sourceUpdater){return function(e){// Although there should, in theory, be a pending action for any updateend receieved,
// there are some actions that may trigger updateend events without set definitions in
// the w3c spec. For instance, setting the duration on the media source may trigger
// updateend events on source buffers. This does not appear to be in the spec. As such,
// if we encounter an updateend without a corresponding pending action from our queue
// for that source buffer type, process the next action.
if(sourceUpdater.queuePending[type]){var doneFn=sourceUpdater.queuePending[type].doneFn;sourceUpdater.queuePending[type]=null;if(doneFn){// if there's an error, report it
doneFn(sourceUpdater[type+"Error_"]);}}shiftQueue(type,sourceUpdater);};};/**
 * A queue of callbacks to be serialized and applied when a
 * MediaSource and its associated SourceBuffers are not in the
 * updating state. It is used by the segment loader to update the
 * underlying SourceBuffers when new data is loaded, for instance.
 *
 * @class SourceUpdater
 * @param {MediaSource} mediaSource the MediaSource to create the SourceBuffer from
 * @param {string} mimeType the desired MIME type of the underlying SourceBuffer
 */var SourceUpdater=/*#__PURE__*/function(_videojs$EventTarget){_inheritsLoose(SourceUpdater,_videojs$EventTarget);function SourceUpdater(mediaSource){var _this;_this=_videojs$EventTarget.call(this)||this;_this.mediaSource=mediaSource;_this.sourceopenListener_=function(){return shiftQueue('mediaSource',_assertThisInitialized(_this));};_this.mediaSource.addEventListener('sourceopen',_this.sourceopenListener_);_this.logger_=logger('SourceUpdater');// initial timestamp offset is 0
_this.audioTimestampOffset_=0;_this.videoTimestampOffset_=0;_this.queue=[];_this.queuePending={audio:null,video:null};_this.delayedAudioAppendQueue_=[];_this.videoAppendQueued_=false;_this.codecs={};_this.onVideoUpdateEnd_=onUpdateend('video',_assertThisInitialized(_this));_this.onAudioUpdateEnd_=onUpdateend('audio',_assertThisInitialized(_this));_this.onVideoError_=function(e){// used for debugging
_this.videoError_=e;};_this.onAudioError_=function(e){// used for debugging
_this.audioError_=e;};_this.createdSourceBuffers_=false;_this.initializedEme_=false;_this.triggeredReady_=false;return _this;}var _proto=SourceUpdater.prototype;_proto.initializedEme=function initializedEme(){this.initializedEme_=true;this.triggerReady();};_proto.hasCreatedSourceBuffers=function hasCreatedSourceBuffers(){// if false, likely waiting on one of the segment loaders to get enough data to create
// source buffers
return this.createdSourceBuffers_;};_proto.hasInitializedAnyEme=function hasInitializedAnyEme(){return this.initializedEme_;};_proto.ready=function ready(){return this.hasCreatedSourceBuffers()&&this.hasInitializedAnyEme();};_proto.createSourceBuffers=function createSourceBuffers(codecs){if(this.hasCreatedSourceBuffers()){// already created them before
return;}// the intial addOrChangeSourceBuffers will always be
// two add buffers.
this.addOrChangeSourceBuffers(codecs);this.createdSourceBuffers_=true;this.trigger('createdsourcebuffers');this.triggerReady();};_proto.triggerReady=function triggerReady(){// only allow ready to be triggered once, this prevents the case
// where:
// 1. we trigger createdsourcebuffers
// 2. ie 11 synchronously initializates eme
// 3. the synchronous initialization causes us to trigger ready
// 4. We go back to the ready check in createSourceBuffers and ready is triggered again.
if(this.ready()&&!this.triggeredReady_){this.triggeredReady_=true;this.trigger('ready');}}/**
   * Add a type of source buffer to the media source.
   *
   * @param {string} type
   *        The type of source buffer to add.
   *
   * @param {string} codec
   *        The codec to add the source buffer with.
   */;_proto.addSourceBuffer=function addSourceBuffer(type,codec){pushQueue({type:'mediaSource',sourceUpdater:this,action:actions.addSourceBuffer(type,codec),name:'addSourceBuffer'});}/**
   * call abort on a source buffer.
   *
   * @param {string} type
   *        The type of source buffer to call abort on.
   */;_proto.abort=function abort(type){pushQueue({type:type,sourceUpdater:this,action:actions.abort(type),name:'abort'});}/**
   * Call removeSourceBuffer and remove a specific type
   * of source buffer on the mediaSource.
   *
   * @param {string} type
   *        The type of source buffer to remove.
   */;_proto.removeSourceBuffer=function removeSourceBuffer(type){if(!this.canRemoveSourceBuffer()){videojs.log.error('removeSourceBuffer is not supported!');return;}pushQueue({type:'mediaSource',sourceUpdater:this,action:actions.removeSourceBuffer(type),name:'removeSourceBuffer'});}/**
   * Whether or not the removeSourceBuffer function is supported
   * on the mediaSource.
   *
   * @return {boolean}
   *          if removeSourceBuffer can be called.
   */;_proto.canRemoveSourceBuffer=function canRemoveSourceBuffer(){// IE reports that it supports removeSourceBuffer, but often throws
// errors when attempting to use the function. So we report that it
// does not support removeSourceBuffer. As of Firefox 83 removeSourceBuffer
// throws errors, so we report that it does not support this as well.
return!videojs.browser.IE_VERSION&&!videojs.browser.IS_FIREFOX&&(window_default()).MediaSource&&(window_default()).MediaSource.prototype&&typeof (window_default()).MediaSource.prototype.removeSourceBuffer==='function';}/**
   * Whether or not the changeType function is supported
   * on our SourceBuffers.
   *
   * @return {boolean}
   *         if changeType can be called.
   */;SourceUpdater.canChangeType=function canChangeType(){return (window_default()).SourceBuffer&&(window_default()).SourceBuffer.prototype&&typeof (window_default()).SourceBuffer.prototype.changeType==='function';}/**
   * Whether or not the changeType function is supported
   * on our SourceBuffers.
   *
   * @return {boolean}
   *         if changeType can be called.
   */;_proto.canChangeType=function canChangeType(){return this.constructor.canChangeType();}/**
   * Call the changeType function on a source buffer, given the code and type.
   *
   * @param {string} type
   *        The type of source buffer to call changeType on.
   *
   * @param {string} codec
   *        The codec string to change type with on the source buffer.
   */;_proto.changeType=function changeType(type,codec){if(!this.canChangeType()){videojs.log.error('changeType is not supported!');return;}pushQueue({type:type,sourceUpdater:this,action:actions.changeType(codec),name:'changeType'});}/**
   * Add source buffers with a codec or, if they are already created,
   * call changeType on source buffers using changeType.
   *
   * @param {Object} codecs
   *        Codecs to switch to
   */;_proto.addOrChangeSourceBuffers=function addOrChangeSourceBuffers(codecs){var _this2=this;if(!codecs||video_es_typeof(codecs)!=='object'||Object.keys(codecs).length===0){throw new Error('Cannot addOrChangeSourceBuffers to undefined codecs');}Object.keys(codecs).forEach(function(type){var codec=codecs[type];if(!_this2.hasCreatedSourceBuffers()){return _this2.addSourceBuffer(type,codec);}if(_this2.canChangeType()){_this2.changeType(type,codec);}});}/**
   * Queue an update to append an ArrayBuffer.
   *
   * @param {MediaObject} object containing audioBytes and/or videoBytes
   * @param {Function} done the function to call when done
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-appendBuffer-void-ArrayBuffer-data
   */;_proto.appendBuffer=function appendBuffer(options,doneFn){var _this3=this;var segmentInfo=options.segmentInfo,type=options.type,bytes=options.bytes;this.processedAppend_=true;if(type==='audio'&&this.videoBuffer&&!this.videoAppendQueued_){this.delayedAudioAppendQueue_.push([options,doneFn]);this.logger_("delayed audio append of "+bytes.length+" until video append");return;}// In the case of certain errors, for instance, QUOTA_EXCEEDED_ERR, updateend will
// not be fired. This means that the queue will be blocked until the next action
// taken by the segment-loader. Provide a mechanism for segment-loader to handle
// these errors by calling the doneFn with the specific error.
var onError=doneFn;pushQueue({type:type,sourceUpdater:this,action:actions.appendBuffer(bytes,segmentInfo||{mediaIndex:-1},onError),doneFn:doneFn,name:'appendBuffer'});if(type==='video'){this.videoAppendQueued_=true;if(!this.delayedAudioAppendQueue_.length){return;}var queue=this.delayedAudioAppendQueue_.slice();this.logger_("queuing delayed audio "+queue.length+" appendBuffers");this.delayedAudioAppendQueue_.length=0;queue.forEach(function(que){_this3.appendBuffer.apply(_this3,que);});}}/**
   * Get the audio buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         The audio buffer's buffered time range
   */;_proto.audioBuffered=function audioBuffered(){// no media source/source buffer or it isn't in the media sources
// source buffer list
if(!inSourceBuffers(this.mediaSource,this.audioBuffer)){return videojs.createTimeRange();}return this.audioBuffer.buffered?this.audioBuffer.buffered:videojs.createTimeRange();}/**
   * Get the video buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         The video buffer's buffered time range
   */;_proto.videoBuffered=function videoBuffered(){// no media source/source buffer or it isn't in the media sources
// source buffer list
if(!inSourceBuffers(this.mediaSource,this.videoBuffer)){return videojs.createTimeRange();}return this.videoBuffer.buffered?this.videoBuffer.buffered:videojs.createTimeRange();}/**
   * Get a combined video/audio buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         the combined time range
   */;_proto.buffered=function buffered(){var video=inSourceBuffers(this.mediaSource,this.videoBuffer)?this.videoBuffer:null;var audio=inSourceBuffers(this.mediaSource,this.audioBuffer)?this.audioBuffer:null;if(audio&&!video){return this.audioBuffered();}if(video&&!audio){return this.videoBuffered();}return bufferIntersection(this.audioBuffered(),this.videoBuffered());}/**
   * Add a callback to the queue that will set duration on the mediaSource.
   *
   * @param {number} duration
   *        The duration to set
   *
   * @param {Function} [doneFn]
   *        function to run after duration has been set.
   */;_proto.setDuration=function setDuration(duration,doneFn){if(doneFn===void 0){doneFn=noop;}// In order to set the duration on the media source, it's necessary to wait for all
// source buffers to no longer be updating. "If the updating attribute equals true on
// any SourceBuffer in sourceBuffers, then throw an InvalidStateError exception and
// abort these steps." (source: https://www.w3.org/TR/media-source/#attributes).
pushQueue({type:'mediaSource',sourceUpdater:this,action:actions.duration(duration),name:'duration',doneFn:doneFn});}/**
   * Add a mediaSource endOfStream call to the queue
   *
   * @param {Error} [error]
   *        Call endOfStream with an error
   *
   * @param {Function} [doneFn]
   *        A function that should be called when the
   *        endOfStream call has finished.
   */;_proto.endOfStream=function endOfStream(error,doneFn){if(error===void 0){error=null;}if(doneFn===void 0){doneFn=noop;}if(typeof error!=='string'){error=undefined;}// In order to set the duration on the media source, it's necessary to wait for all
// source buffers to no longer be updating. "If the updating attribute equals true on
// any SourceBuffer in sourceBuffers, then throw an InvalidStateError exception and
// abort these steps." (source: https://www.w3.org/TR/media-source/#attributes).
pushQueue({type:'mediaSource',sourceUpdater:this,action:actions.endOfStream(error),name:'endOfStream',doneFn:doneFn});}/**
   * Queue an update to remove a time range from the buffer.
   *
   * @param {number} start where to start the removal
   * @param {number} end where to end the removal
   * @param {Function} [done=noop] optional callback to be executed when the remove
   * operation is complete
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
   */;_proto.removeAudio=function removeAudio(start,end,done){if(done===void 0){done=noop;}if(!this.audioBuffered().length||this.audioBuffered().end(0)===0){done();return;}pushQueue({type:'audio',sourceUpdater:this,action:actions.remove(start,end),doneFn:done,name:'remove'});}/**
   * Queue an update to remove a time range from the buffer.
   *
   * @param {number} start where to start the removal
   * @param {number} end where to end the removal
   * @param {Function} [done=noop] optional callback to be executed when the remove
   * operation is complete
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
   */;_proto.removeVideo=function removeVideo(start,end,done){if(done===void 0){done=noop;}if(!this.videoBuffered().length||this.videoBuffered().end(0)===0){done();return;}pushQueue({type:'video',sourceUpdater:this,action:actions.remove(start,end),doneFn:done,name:'remove'});}/**
   * Whether the underlying sourceBuffer is updating or not
   *
   * @return {boolean} the updating status of the SourceBuffer
   */;_proto.updating=function updating(){// the audio/video source buffer is updating
if(_updating('audio',this)||_updating('video',this)){return true;}return false;}/**
   * Set/get the timestampoffset on the audio SourceBuffer
   *
   * @return {number} the timestamp offset
   */;_proto.audioTimestampOffset=function audioTimestampOffset(offset){if(typeof offset!=='undefined'&&this.audioBuffer&&// no point in updating if it's the same
this.audioTimestampOffset_!==offset){pushQueue({type:'audio',sourceUpdater:this,action:actions.timestampOffset(offset),name:'timestampOffset'});this.audioTimestampOffset_=offset;}return this.audioTimestampOffset_;}/**
   * Set/get the timestampoffset on the video SourceBuffer
   *
   * @return {number} the timestamp offset
   */;_proto.videoTimestampOffset=function videoTimestampOffset(offset){if(typeof offset!=='undefined'&&this.videoBuffer&&// no point in updating if it's the same
this.videoTimestampOffset!==offset){pushQueue({type:'video',sourceUpdater:this,action:actions.timestampOffset(offset),name:'timestampOffset'});this.videoTimestampOffset_=offset;}return this.videoTimestampOffset_;}/**
   * Add a function to the queue that will be called
   * when it is its turn to run in the audio queue.
   *
   * @param {Function} callback
   *        The callback to queue.
   */;_proto.audioQueueCallback=function audioQueueCallback(callback){if(!this.audioBuffer){return;}pushQueue({type:'audio',sourceUpdater:this,action:actions.callback(callback),name:'callback'});}/**
   * Add a function to the queue that will be called
   * when it is its turn to run in the video queue.
   *
   * @param {Function} callback
   *        The callback to queue.
   */;_proto.videoQueueCallback=function videoQueueCallback(callback){if(!this.videoBuffer){return;}pushQueue({type:'video',sourceUpdater:this,action:actions.callback(callback),name:'callback'});}/**
   * dispose of the source updater and the underlying sourceBuffer
   */;_proto.dispose=function dispose(){var _this4=this;this.trigger('dispose');bufferTypes.forEach(function(type){_this4.abort(type);if(_this4.canRemoveSourceBuffer()){_this4.removeSourceBuffer(type);}else{_this4[type+"QueueCallback"](function(){return cleanupBuffer(type,_this4);});}});this.videoAppendQueued_=false;this.delayedAudioAppendQueue_.length=0;if(this.sourceopenListener_){this.mediaSource.removeEventListener('sourceopen',this.sourceopenListener_);}this.off();};return SourceUpdater;}(videojs.EventTarget);var uint8ToUtf8=function uint8ToUtf8(uintArray){return decodeURIComponent(escape(String.fromCharCode.apply(null,uintArray)));};var VTT_LINE_TERMINATORS=new Uint8Array('\n\n'.split('').map(function(_char3){return _char3.charCodeAt(0);}));var NoVttJsError=/*#__PURE__*/function(_Error){_inheritsLoose(NoVttJsError,_Error);function NoVttJsError(){return _Error.call(this,'Trying to parse received VTT cues, but there is no WebVTT. Make sure vtt.js is loaded.')||this;}return NoVttJsError;}(/*#__PURE__*/_wrapNativeSuper(Error));/**
 * An object that manages segment loading and appending.
 *
 * @class VTTSegmentLoader
 * @param {Object} options required and optional options
 * @extends videojs.EventTarget
 */var VTTSegmentLoader=/*#__PURE__*/function(_SegmentLoader){_inheritsLoose(VTTSegmentLoader,_SegmentLoader);function VTTSegmentLoader(settings,options){var _this;if(options===void 0){options={};}_this=_SegmentLoader.call(this,settings,options)||this;// SegmentLoader requires a MediaSource be specified or it will throw an error;
// however, VTTSegmentLoader has no need of a media source, so delete the reference
_this.mediaSource_=null;_this.subtitlesTrack_=null;_this.loaderType_='subtitle';_this.featuresNativeTextTracks_=settings.featuresNativeTextTracks;_this.loadVttJs=settings.loadVttJs;// The VTT segment will have its own time mappings. Saving VTT segment timing info in
// the sync controller leads to improper behavior.
_this.shouldSaveSegmentTimingInfo_=false;return _this;}var _proto=VTTSegmentLoader.prototype;_proto.createTransmuxer_=function createTransmuxer_(){// don't need to transmux any subtitles
return null;}/**
   * Indicates which time ranges are buffered
   *
   * @return {TimeRange}
   *         TimeRange object representing the current buffered ranges
   */;_proto.buffered_=function buffered_(){if(!this.subtitlesTrack_||!this.subtitlesTrack_.cues||!this.subtitlesTrack_.cues.length){return videojs.createTimeRanges();}var cues=this.subtitlesTrack_.cues;var start=cues[0].startTime;var end=cues[cues.length-1].startTime;return videojs.createTimeRanges([[start,end]]);}/**
   * Gets and sets init segment for the provided map
   *
   * @param {Object} map
   *        The map object representing the init segment to get or set
   * @param {boolean=} set
   *        If true, the init segment for the provided map should be saved
   * @return {Object}
   *         map object for desired init segment
   */;_proto.initSegmentForMap=function initSegmentForMap(map,set){if(set===void 0){set=false;}if(!map){return null;}var id=initSegmentId(map);var storedMap=this.initSegments_[id];if(set&&!storedMap&&map.bytes){// append WebVTT line terminators to the media initialization segment if it exists
// to follow the WebVTT spec (https://w3c.github.io/webvtt/#file-structure) that
// requires two or more WebVTT line terminators between the WebVTT header and the
// rest of the file
var combinedByteLength=VTT_LINE_TERMINATORS.byteLength+map.bytes.byteLength;var combinedSegment=new Uint8Array(combinedByteLength);combinedSegment.set(map.bytes);combinedSegment.set(VTT_LINE_TERMINATORS,map.bytes.byteLength);this.initSegments_[id]=storedMap={resolvedUri:map.resolvedUri,byterange:map.byterange,bytes:combinedSegment};}return storedMap||map;}/**
   * Returns true if all configuration required for loading is present, otherwise false.
   *
   * @return {boolean} True if the all configuration is ready for loading
   * @private
   */;_proto.couldBeginLoading_=function couldBeginLoading_(){return this.playlist_&&this.subtitlesTrack_&&!this.paused();}/**
   * Once all the starting parameters have been specified, begin
   * operation. This method should only be invoked from the INIT
   * state.
   *
   * @private
   */;_proto.init_=function init_(){this.state='READY';this.resetEverything();return this.monitorBuffer_();}/**
   * Set a subtitle track on the segment loader to add subtitles to
   *
   * @param {TextTrack=} track
   *        The text track to add loaded subtitles to
   * @return {TextTrack}
   *        Returns the subtitles track
   */;_proto.track=function track(_track){if(typeof _track==='undefined'){return this.subtitlesTrack_;}this.subtitlesTrack_=_track;// if we were unpaused but waiting for a sourceUpdater, start
// buffering now
if(this.state==='INIT'&&this.couldBeginLoading_()){this.init_();}return this.subtitlesTrack_;}/**
   * Remove any data in the source buffer between start and end times
   *
   * @param {number} start - the start time of the region to remove from the buffer
   * @param {number} end - the end time of the region to remove from the buffer
   */;_proto.remove=function remove(start,end){removeCuesFromTrack(start,end,this.subtitlesTrack_);}/**
   * fill the buffer with segements unless the sourceBuffers are
   * currently updating
   *
   * Note: this function should only ever be called by monitorBuffer_
   * and never directly
   *
   * @private
   */;_proto.fillBuffer_=function fillBuffer_(){var _this2=this;// see if we need to begin loading immediately
var segmentInfo=this.chooseNextRequest_();if(!segmentInfo){return;}if(this.syncController_.timestampOffsetForTimeline(segmentInfo.timeline)===null){// We don't have the timestamp offset that we need to sync subtitles.
// Rerun on a timestamp offset or user interaction.
var checkTimestampOffset=function checkTimestampOffset(){_this2.state='READY';if(!_this2.paused()){// if not paused, queue a buffer check as soon as possible
_this2.monitorBuffer_();}};this.syncController_.one('timestampoffset',checkTimestampOffset);this.state='WAITING_ON_TIMELINE';return;}this.loadSegment_(segmentInfo);}// never set a timestamp offset for vtt segments.
;_proto.timestampOffsetForSegment_=function timestampOffsetForSegment_(){return null;};_proto.chooseNextRequest_=function chooseNextRequest_(){return this.skipEmptySegments_(_SegmentLoader.prototype.chooseNextRequest_.call(this));}/**
   * Prevents the segment loader from requesting segments we know contain no subtitles
   * by walking forward until we find the next segment that we don't know whether it is
   * empty or not.
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @return {Object}
   *         a segment info object that describes the current segment
   */;_proto.skipEmptySegments_=function skipEmptySegments_(segmentInfo){while(segmentInfo&&segmentInfo.segment.empty){// stop at the last possible segmentInfo
if(segmentInfo.mediaIndex+1>=segmentInfo.playlist.segments.length){segmentInfo=null;break;}segmentInfo=this.generateSegmentInfo_({playlist:segmentInfo.playlist,mediaIndex:segmentInfo.mediaIndex+1,startOfSegment:segmentInfo.startOfSegment+segmentInfo.duration,isSyncRequest:segmentInfo.isSyncRequest});}return segmentInfo;};_proto.stopForError=function stopForError(error){this.error(error);this.state='READY';this.pause();this.trigger('error');}/**
   * append a decrypted segement to the SourceBuffer through a SourceUpdater
   *
   * @private
   */;_proto.segmentRequestFinished_=function segmentRequestFinished_(error,simpleSegment,result){var _this3=this;if(!this.subtitlesTrack_){this.state='READY';return;}this.saveTransferStats_(simpleSegment.stats);// the request was aborted
if(!this.pendingSegment_){this.state='READY';this.mediaRequestsAborted+=1;return;}if(error){if(error.code===REQUEST_ERRORS.TIMEOUT){this.handleTimeout_();}if(error.code===REQUEST_ERRORS.ABORTED){this.mediaRequestsAborted+=1;}else{this.mediaRequestsErrored+=1;}this.stopForError(error);return;}var segmentInfo=this.pendingSegment_;// although the VTT segment loader bandwidth isn't really used, it's good to
// maintain functionality between segment loaders
this.saveBandwidthRelatedStats_(segmentInfo.duration,simpleSegment.stats);// if this request included a segment key, save that data in the cache
if(simpleSegment.key){this.segmentKey(simpleSegment.key,true);}this.state='APPENDING';// used for tests
this.trigger('appending');var segment=segmentInfo.segment;if(segment.map){segment.map.bytes=simpleSegment.map.bytes;}segmentInfo.bytes=simpleSegment.bytes;// Make sure that vttjs has loaded, otherwise, load it and wait till it finished loading
if(typeof (window_default()).WebVTT!=='function'&&typeof this.loadVttJs==='function'){this.state='WAITING_ON_VTTJS';// should be fine to call multiple times
// script will be loaded once but multiple listeners will be added to the queue, which is expected.
this.loadVttJs().then(function(){return _this3.segmentRequestFinished_(error,simpleSegment,result);},function(){return _this3.stopForError({message:'Error loading vtt.js'});});return;}segment.requested=true;try{this.parseVTTCues_(segmentInfo);}catch(e){this.stopForError({message:e.message});return;}this.updateTimeMapping_(segmentInfo,this.syncController_.timelines[segmentInfo.timeline],this.playlist_);if(segmentInfo.cues.length){segmentInfo.timingInfo={start:segmentInfo.cues[0].startTime,end:segmentInfo.cues[segmentInfo.cues.length-1].endTime};}else{segmentInfo.timingInfo={start:segmentInfo.startOfSegment,end:segmentInfo.startOfSegment+segmentInfo.duration};}if(segmentInfo.isSyncRequest){this.trigger('syncinfoupdate');this.pendingSegment_=null;this.state='READY';return;}segmentInfo.byteLength=segmentInfo.bytes.byteLength;this.mediaSecondsLoaded+=segment.duration;// Create VTTCue instances for each cue in the new segment and add them to
// the subtitle track
segmentInfo.cues.forEach(function(cue){_this3.subtitlesTrack_.addCue(_this3.featuresNativeTextTracks_?new (window_default()).VTTCue(cue.startTime,cue.endTime,cue.text):cue);});// Remove any duplicate cues from the subtitle track. The WebVTT spec allows
// cues to have identical time-intervals, but if the text is also identical
// we can safely assume it is a duplicate that can be removed (ex. when a cue
// "overlaps" VTT segments)
removeDuplicateCuesFromTrack(this.subtitlesTrack_);this.handleAppendsDone_();};_proto.handleData_=function handleData_(){// noop as we shouldn't be getting video/audio data captions
// that we do not support here.
};_proto.updateTimingInfoEnd_=function updateTimingInfoEnd_(){// noop
}/**
   * Uses the WebVTT parser to parse the segment response
   *
   * @throws NoVttJsError
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @private
   */;_proto.parseVTTCues_=function parseVTTCues_(segmentInfo){var decoder;var decodeBytesToString=false;if(typeof (window_default()).WebVTT!=='function'){// caller is responsible for exception handling.
throw new NoVttJsError();}if(typeof (window_default()).TextDecoder==='function'){decoder=new (window_default()).TextDecoder('utf8');}else{decoder=window_default().WebVTT.StringDecoder();decodeBytesToString=true;}var parser=new (window_default()).WebVTT.Parser((window_default()),(window_default()).vttjs,decoder);segmentInfo.cues=[];segmentInfo.timestampmap={MPEGTS:0,LOCAL:0};parser.oncue=segmentInfo.cues.push.bind(segmentInfo.cues);parser.ontimestampmap=function(map){segmentInfo.timestampmap=map;};parser.onparsingerror=function(error){videojs.log.warn('Error encountered when parsing cues: '+error.message);};if(segmentInfo.segment.map){var mapData=segmentInfo.segment.map.bytes;if(decodeBytesToString){mapData=uint8ToUtf8(mapData);}parser.parse(mapData);}var segmentData=segmentInfo.bytes;if(decodeBytesToString){segmentData=uint8ToUtf8(segmentData);}parser.parse(segmentData);parser.flush();}/**
   * Updates the start and end times of any cues parsed by the WebVTT parser using
   * the information parsed from the X-TIMESTAMP-MAP header and a TS to media time mapping
   * from the SyncController
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @param {Object} mappingObj
   *        object containing a mapping from TS to media time
   * @param {Object} playlist
   *        the playlist object containing the segment
   * @private
   */;_proto.updateTimeMapping_=function updateTimeMapping_(segmentInfo,mappingObj,playlist){var segment=segmentInfo.segment;if(!mappingObj){// If the sync controller does not have a mapping of TS to Media Time for the
// timeline, then we don't have enough information to update the cue
// start/end times
return;}if(!segmentInfo.cues.length){// If there are no cues, we also do not have enough information to figure out
// segment timing. Mark that the segment contains no cues so we don't re-request
// an empty segment.
segment.empty=true;return;}var timestampmap=segmentInfo.timestampmap;var diff=timestampmap.MPEGTS/clock.ONE_SECOND_IN_TS-timestampmap.LOCAL+mappingObj.mapping;segmentInfo.cues.forEach(function(cue){// First convert cue time to TS time using the timestamp-map provided within the vtt
cue.startTime+=diff;cue.endTime+=diff;});if(!playlist.syncInfo){var firstStart=segmentInfo.cues[0].startTime;var lastStart=segmentInfo.cues[segmentInfo.cues.length-1].startTime;playlist.syncInfo={mediaSequence:playlist.mediaSequence+segmentInfo.mediaIndex,time:Math.min(firstStart,lastStart-segment.duration)};}};return VTTSegmentLoader;}(SegmentLoader);/**
 * @file ad-cue-tags.js
 */ /**
 * Searches for an ad cue that overlaps with the given mediaTime
 *
 * @param {Object} track
 *        the track to find the cue for
 *
 * @param {number} mediaTime
 *        the time to find the cue at
 *
 * @return {Object|null}
 *         the found cue or null
 */var findAdCue=function findAdCue(track,mediaTime){var cues=track.cues;for(var i=0;i<cues.length;i++){var cue=cues[i];if(mediaTime>=cue.adStartTime&&mediaTime<=cue.adEndTime){return cue;}}return null;};var updateAdCues=function updateAdCues(media,track,offset){if(offset===void 0){offset=0;}if(!media.segments){return;}var mediaTime=offset;var cue;for(var i=0;i<media.segments.length;i++){var segment=media.segments[i];if(!cue){// Since the cues will span for at least the segment duration, adding a fudge
// factor of half segment duration will prevent duplicate cues from being
// created when timing info is not exact (e.g. cue start time initialized
// at 10.006677, but next call mediaTime is 10.003332 )
cue=findAdCue(track,mediaTime+segment.duration/2);}if(cue){if('cueIn'in segment){// Found a CUE-IN so end the cue
cue.endTime=mediaTime;cue.adEndTime=mediaTime;mediaTime+=segment.duration;cue=null;continue;}if(mediaTime<cue.endTime){// Already processed this mediaTime for this cue
mediaTime+=segment.duration;continue;}// otherwise extend cue until a CUE-IN is found
cue.endTime+=segment.duration;}else{if('cueOut'in segment){cue=new (window_default()).VTTCue(mediaTime,mediaTime+segment.duration,segment.cueOut);cue.adStartTime=mediaTime;// Assumes tag format to be
// #EXT-X-CUE-OUT:30
cue.adEndTime=mediaTime+parseFloat(segment.cueOut);track.addCue(cue);}if('cueOutCont'in segment){// Entered into the middle of an ad cue
// Assumes tag formate to be
// #EXT-X-CUE-OUT-CONT:10/30
var _segment$cueOutCont$s=segment.cueOutCont.split('/').map(parseFloat),adOffset=_segment$cueOutCont$s[0],adTotal=_segment$cueOutCont$s[1];cue=new (window_default()).VTTCue(mediaTime,mediaTime+segment.duration,'');cue.adStartTime=mediaTime-adOffset;cue.adEndTime=cue.adStartTime+adTotal;track.addCue(cue);}}mediaTime+=segment.duration;}};// synchronize expired playlist segments.
// the max media sequence diff is 48 hours of live stream
// content with two second segments. Anything larger than that
// will likely be invalid.
var MAX_MEDIA_SEQUENCE_DIFF_FOR_SYNC=86400;var syncPointStrategies=[// Stategy "VOD": Handle the VOD-case where the sync-point is *always*
//                the equivalence display-time 0 === segment-index 0
{name:'VOD',run:function run(syncController,playlist,duration,currentTimeline,currentTime){if(duration!==Infinity){var syncPoint={time:0,segmentIndex:0,partIndex:null};return syncPoint;}return null;}},// Stategy "ProgramDateTime": We have a program-date-time tag in this playlist
{name:'ProgramDateTime',run:function run(syncController,playlist,duration,currentTimeline,currentTime){if(!Object.keys(syncController.timelineToDatetimeMappings).length){return null;}var syncPoint=null;var lastDistance=null;var partsAndSegments=getPartsAndSegments(playlist);currentTime=currentTime||0;for(var i=0;i<partsAndSegments.length;i++){// start from the end and loop backwards for live
// or start from the front and loop forwards for non-live
var index=playlist.endList||currentTime===0?i:partsAndSegments.length-(i+1);var partAndSegment=partsAndSegments[index];var segment=partAndSegment.segment;var datetimeMapping=syncController.timelineToDatetimeMappings[segment.timeline];if(!datetimeMapping||!segment.dateTimeObject){continue;}var segmentTime=segment.dateTimeObject.getTime()/1000;var start=segmentTime+datetimeMapping;// take part duration into account.
if(segment.parts&&typeof partAndSegment.partIndex==='number'){for(var z=0;z<partAndSegment.partIndex;z++){start+=segment.parts[z].duration;}}var distance=Math.abs(currentTime-start);// Once the distance begins to increase, or if distance is 0, we have passed
// currentTime and can stop looking for better candidates
if(lastDistance!==null&&(distance===0||lastDistance<distance)){break;}lastDistance=distance;syncPoint={time:start,segmentIndex:partAndSegment.segmentIndex,partIndex:partAndSegment.partIndex};}return syncPoint;}},// Stategy "Segment": We have a known time mapping for a timeline and a
//                    segment in the current timeline with timing data
{name:'Segment',run:function run(syncController,playlist,duration,currentTimeline,currentTime){var syncPoint=null;var lastDistance=null;currentTime=currentTime||0;var partsAndSegments=getPartsAndSegments(playlist);for(var i=0;i<partsAndSegments.length;i++){// start from the end and loop backwards for live
// or start from the front and loop forwards for non-live
var index=playlist.endList||currentTime===0?i:partsAndSegments.length-(i+1);var partAndSegment=partsAndSegments[index];var segment=partAndSegment.segment;var start=partAndSegment.part&&partAndSegment.part.start||segment&&segment.start;if(segment.timeline===currentTimeline&&typeof start!=='undefined'){var distance=Math.abs(currentTime-start);// Once the distance begins to increase, we have passed
// currentTime and can stop looking for better candidates
if(lastDistance!==null&&lastDistance<distance){break;}if(!syncPoint||lastDistance===null||lastDistance>=distance){lastDistance=distance;syncPoint={time:start,segmentIndex:partAndSegment.segmentIndex,partIndex:partAndSegment.partIndex};}}}return syncPoint;}},// Stategy "Discontinuity": We have a discontinuity with a known
//                          display-time
{name:'Discontinuity',run:function run(syncController,playlist,duration,currentTimeline,currentTime){var syncPoint=null;currentTime=currentTime||0;if(playlist.discontinuityStarts&&playlist.discontinuityStarts.length){var lastDistance=null;for(var i=0;i<playlist.discontinuityStarts.length;i++){var segmentIndex=playlist.discontinuityStarts[i];var discontinuity=playlist.discontinuitySequence+i+1;var discontinuitySync=syncController.discontinuities[discontinuity];if(discontinuitySync){var distance=Math.abs(currentTime-discontinuitySync.time);// Once the distance begins to increase, we have passed
// currentTime and can stop looking for better candidates
if(lastDistance!==null&&lastDistance<distance){break;}if(!syncPoint||lastDistance===null||lastDistance>=distance){lastDistance=distance;syncPoint={time:discontinuitySync.time,segmentIndex:segmentIndex,partIndex:null};}}}}return syncPoint;}},// Stategy "Playlist": We have a playlist with a known mapping of
//                     segment index to display time
{name:'Playlist',run:function run(syncController,playlist,duration,currentTimeline,currentTime){if(playlist.syncInfo){var syncPoint={time:playlist.syncInfo.time,segmentIndex:playlist.syncInfo.mediaSequence-playlist.mediaSequence,partIndex:null};return syncPoint;}return null;}}];var SyncController=/*#__PURE__*/function(_videojs$EventTarget){_inheritsLoose(SyncController,_videojs$EventTarget);function SyncController(options){var _this;_this=_videojs$EventTarget.call(this)||this;// ...for synching across variants
_this.timelines=[];_this.discontinuities=[];_this.timelineToDatetimeMappings={};_this.logger_=logger('SyncController');return _this;}/**
   * Find a sync-point for the playlist specified
   *
   * A sync-point is defined as a known mapping from display-time to
   * a segment-index in the current playlist.
   *
   * @param {Playlist} playlist
   *        The playlist that needs a sync-point
   * @param {number} duration
   *        Duration of the MediaSource (Infinite if playing a live source)
   * @param {number} currentTimeline
   *        The last timeline from which a segment was loaded
   * @return {Object}
   *          A sync-point object
   */var _proto=SyncController.prototype;_proto.getSyncPoint=function getSyncPoint(playlist,duration,currentTimeline,currentTime){var syncPoints=this.runStrategies_(playlist,duration,currentTimeline,currentTime);if(!syncPoints.length){// Signal that we need to attempt to get a sync-point manually
// by fetching a segment in the playlist and constructing
// a sync-point from that information
return null;}// Now find the sync-point that is closest to the currentTime because
// that should result in the most accurate guess about which segment
// to fetch
return this.selectSyncPoint_(syncPoints,{key:'time',value:currentTime});}/**
   * Calculate the amount of time that has expired off the playlist during playback
   *
   * @param {Playlist} playlist
   *        Playlist object to calculate expired from
   * @param {number} duration
   *        Duration of the MediaSource (Infinity if playling a live source)
   * @return {number|null}
   *          The amount of time that has expired off the playlist during playback. Null
   *          if no sync-points for the playlist can be found.
   */;_proto.getExpiredTime=function getExpiredTime(playlist,duration){if(!playlist||!playlist.segments){return null;}var syncPoints=this.runStrategies_(playlist,duration,playlist.discontinuitySequence,0);// Without sync-points, there is not enough information to determine the expired time
if(!syncPoints.length){return null;}var syncPoint=this.selectSyncPoint_(syncPoints,{key:'segmentIndex',value:0});// If the sync-point is beyond the start of the playlist, we want to subtract the
// duration from index 0 to syncPoint.segmentIndex instead of adding.
if(syncPoint.segmentIndex>0){syncPoint.time*=-1;}return Math.abs(syncPoint.time+sumDurations({defaultDuration:playlist.targetDuration,durationList:playlist.segments,startIndex:syncPoint.segmentIndex,endIndex:0}));}/**
   * Runs each sync-point strategy and returns a list of sync-points returned by the
   * strategies
   *
   * @private
   * @param {Playlist} playlist
   *        The playlist that needs a sync-point
   * @param {number} duration
   *        Duration of the MediaSource (Infinity if playing a live source)
   * @param {number} currentTimeline
   *        The last timeline from which a segment was loaded
   * @return {Array}
   *          A list of sync-point objects
   */;_proto.runStrategies_=function runStrategies_(playlist,duration,currentTimeline,currentTime){var syncPoints=[];// Try to find a sync-point in by utilizing various strategies...
for(var i=0;i<syncPointStrategies.length;i++){var strategy=syncPointStrategies[i];var syncPoint=strategy.run(this,playlist,duration,currentTimeline,currentTime);if(syncPoint){syncPoint.strategy=strategy.name;syncPoints.push({strategy:strategy.name,syncPoint:syncPoint});}}return syncPoints;}/**
   * Selects the sync-point nearest the specified target
   *
   * @private
   * @param {Array} syncPoints
   *        List of sync-points to select from
   * @param {Object} target
   *        Object specifying the property and value we are targeting
   * @param {string} target.key
   *        Specifies the property to target. Must be either 'time' or 'segmentIndex'
   * @param {number} target.value
   *        The value to target for the specified key.
   * @return {Object}
   *          The sync-point nearest the target
   */;_proto.selectSyncPoint_=function selectSyncPoint_(syncPoints,target){var bestSyncPoint=syncPoints[0].syncPoint;var bestDistance=Math.abs(syncPoints[0].syncPoint[target.key]-target.value);var bestStrategy=syncPoints[0].strategy;for(var i=1;i<syncPoints.length;i++){var newDistance=Math.abs(syncPoints[i].syncPoint[target.key]-target.value);if(newDistance<bestDistance){bestDistance=newDistance;bestSyncPoint=syncPoints[i].syncPoint;bestStrategy=syncPoints[i].strategy;}}this.logger_("syncPoint for ["+target.key+": "+target.value+"] chosen with strategy"+(" ["+bestStrategy+"]: [time:"+bestSyncPoint.time+",")+(" segmentIndex:"+bestSyncPoint.segmentIndex)+(typeof bestSyncPoint.partIndex==='number'?",partIndex:"+bestSyncPoint.partIndex:'')+']');return bestSyncPoint;}/**
   * Save any meta-data present on the segments when segments leave
   * the live window to the playlist to allow for synchronization at the
   * playlist level later.
   *
   * @param {Playlist} oldPlaylist - The previous active playlist
   * @param {Playlist} newPlaylist - The updated and most current playlist
   */;_proto.saveExpiredSegmentInfo=function saveExpiredSegmentInfo(oldPlaylist,newPlaylist){var mediaSequenceDiff=newPlaylist.mediaSequence-oldPlaylist.mediaSequence;// Ignore large media sequence gaps
if(mediaSequenceDiff>MAX_MEDIA_SEQUENCE_DIFF_FOR_SYNC){videojs.log.warn("Not saving expired segment info. Media sequence gap "+mediaSequenceDiff+" is too large.");return;}// When a segment expires from the playlist and it has a start time
// save that information as a possible sync-point reference in future
for(var i=mediaSequenceDiff-1;i>=0;i--){var lastRemovedSegment=oldPlaylist.segments[i];if(lastRemovedSegment&&typeof lastRemovedSegment.start!=='undefined'){newPlaylist.syncInfo={mediaSequence:oldPlaylist.mediaSequence+i,time:lastRemovedSegment.start};this.logger_("playlist refresh sync: [time:"+newPlaylist.syncInfo.time+","+(" mediaSequence: "+newPlaylist.syncInfo.mediaSequence+"]"));this.trigger('syncinfoupdate');break;}}}/**
   * Save the mapping from playlist's ProgramDateTime to display. This should only happen
   * before segments start to load.
   *
   * @param {Playlist} playlist - The currently active playlist
   */;_proto.setDateTimeMappingForStart=function setDateTimeMappingForStart(playlist){// It's possible for the playlist to be updated before playback starts, meaning time
// zero is not yet set. If, during these playlist refreshes, a discontinuity is
// crossed, then the old time zero mapping (for the prior timeline) would be retained
// unless the mappings are cleared.
this.timelineToDatetimeMappings={};if(playlist.segments&&playlist.segments.length&&playlist.segments[0].dateTimeObject){var firstSegment=playlist.segments[0];var playlistTimestamp=firstSegment.dateTimeObject.getTime()/1000;this.timelineToDatetimeMappings[firstSegment.timeline]=-playlistTimestamp;}}/**
   * Calculates and saves timeline mappings, playlist sync info, and segment timing values
   * based on the latest timing information.
   *
   * @param {Object} options
   *        Options object
   * @param {SegmentInfo} options.segmentInfo
   *        The current active request information
   * @param {boolean} options.shouldSaveTimelineMapping
   *        If there's a timeline change, determines if the timeline mapping should be
   *        saved for timeline mapping and program date time mappings.
   */;_proto.saveSegmentTimingInfo=function saveSegmentTimingInfo(_ref){var segmentInfo=_ref.segmentInfo,shouldSaveTimelineMapping=_ref.shouldSaveTimelineMapping;var didCalculateSegmentTimeMapping=this.calculateSegmentTimeMapping_(segmentInfo,segmentInfo.timingInfo,shouldSaveTimelineMapping);var segment=segmentInfo.segment;if(didCalculateSegmentTimeMapping){this.saveDiscontinuitySyncInfo_(segmentInfo);// If the playlist does not have sync information yet, record that information
// now with segment timing information
if(!segmentInfo.playlist.syncInfo){segmentInfo.playlist.syncInfo={mediaSequence:segmentInfo.playlist.mediaSequence+segmentInfo.mediaIndex,time:segment.start};}}var dateTime=segment.dateTimeObject;if(segment.discontinuity&&shouldSaveTimelineMapping&&dateTime){this.timelineToDatetimeMappings[segment.timeline]=-(dateTime.getTime()/1000);}};_proto.timestampOffsetForTimeline=function timestampOffsetForTimeline(timeline){if(typeof this.timelines[timeline]==='undefined'){return null;}return this.timelines[timeline].time;};_proto.mappingForTimeline=function mappingForTimeline(timeline){if(typeof this.timelines[timeline]==='undefined'){return null;}return this.timelines[timeline].mapping;}/**
   * Use the "media time" for a segment to generate a mapping to "display time" and
   * save that display time to the segment.
   *
   * @private
   * @param {SegmentInfo} segmentInfo
   *        The current active request information
   * @param {Object} timingInfo
   *        The start and end time of the current segment in "media time"
   * @param {boolean} shouldSaveTimelineMapping
   *        If there's a timeline change, determines if the timeline mapping should be
   *        saved in timelines.
   * @return {boolean}
   *          Returns false if segment time mapping could not be calculated
   */;_proto.calculateSegmentTimeMapping_=function calculateSegmentTimeMapping_(segmentInfo,timingInfo,shouldSaveTimelineMapping){// TODO: remove side effects
var segment=segmentInfo.segment;var part=segmentInfo.part;var mappingObj=this.timelines[segmentInfo.timeline];var start;var end;if(typeof segmentInfo.timestampOffset==='number'){mappingObj={time:segmentInfo.startOfSegment,mapping:segmentInfo.startOfSegment-timingInfo.start};if(shouldSaveTimelineMapping){this.timelines[segmentInfo.timeline]=mappingObj;this.trigger('timestampoffset');this.logger_("time mapping for timeline "+segmentInfo.timeline+": "+("[time: "+mappingObj.time+"] [mapping: "+mappingObj.mapping+"]"));}start=segmentInfo.startOfSegment;end=timingInfo.end+mappingObj.mapping;}else if(mappingObj){start=timingInfo.start+mappingObj.mapping;end=timingInfo.end+mappingObj.mapping;}else{return false;}if(part){part.start=start;part.end=end;}// If we don't have a segment start yet or the start value we got
// is less than our current segment.start value, save a new start value.
// We have to do this because parts will have segment timing info saved
// multiple times and we want segment start to be the earliest part start
// value for that segment.
if(!segment.start||start<segment.start){segment.start=start;}segment.end=end;return true;}/**
   * Each time we have discontinuity in the playlist, attempt to calculate the location
   * in display of the start of the discontinuity and save that. We also save an accuracy
   * value so that we save values with the most accuracy (closest to 0.)
   *
   * @private
   * @param {SegmentInfo} segmentInfo - The current active request information
   */;_proto.saveDiscontinuitySyncInfo_=function saveDiscontinuitySyncInfo_(segmentInfo){var playlist=segmentInfo.playlist;var segment=segmentInfo.segment;// If the current segment is a discontinuity then we know exactly where
// the start of the range and it's accuracy is 0 (greater accuracy values
// mean more approximation)
if(segment.discontinuity){this.discontinuities[segment.timeline]={time:segment.start,accuracy:0};}else if(playlist.discontinuityStarts&&playlist.discontinuityStarts.length){// Search for future discontinuities that we can provide better timing
// information for and save that information for sync purposes
for(var i=0;i<playlist.discontinuityStarts.length;i++){var segmentIndex=playlist.discontinuityStarts[i];var discontinuity=playlist.discontinuitySequence+i+1;var mediaIndexDiff=segmentIndex-segmentInfo.mediaIndex;var accuracy=Math.abs(mediaIndexDiff);if(!this.discontinuities[discontinuity]||this.discontinuities[discontinuity].accuracy>accuracy){var time=void 0;if(mediaIndexDiff<0){time=segment.start-sumDurations({defaultDuration:playlist.targetDuration,durationList:playlist.segments,startIndex:segmentInfo.mediaIndex,endIndex:segmentIndex});}else{time=segment.end+sumDurations({defaultDuration:playlist.targetDuration,durationList:playlist.segments,startIndex:segmentInfo.mediaIndex+1,endIndex:segmentIndex});}this.discontinuities[discontinuity]={time:time,accuracy:accuracy};}}}};_proto.dispose=function dispose(){this.trigger('dispose');this.off();};return SyncController;}(videojs.EventTarget);/**
 * The TimelineChangeController acts as a source for segment loaders to listen for and
 * keep track of latest and pending timeline changes. This is useful to ensure proper
 * sync, as each loader may need to make a consideration for what timeline the other
 * loader is on before making changes which could impact the other loader's media.
 *
 * @class TimelineChangeController
 * @extends videojs.EventTarget
 */var TimelineChangeController=/*#__PURE__*/function(_videojs$EventTarget){_inheritsLoose(TimelineChangeController,_videojs$EventTarget);function TimelineChangeController(){var _this;_this=_videojs$EventTarget.call(this)||this;_this.pendingTimelineChanges_={};_this.lastTimelineChanges_={};return _this;}var _proto=TimelineChangeController.prototype;_proto.clearPendingTimelineChange=function clearPendingTimelineChange(type){this.pendingTimelineChanges_[type]=null;this.trigger('pendingtimelinechange');};_proto.pendingTimelineChange=function pendingTimelineChange(_ref){var type=_ref.type,from=_ref.from,to=_ref.to;if(typeof from==='number'&&typeof to==='number'){this.pendingTimelineChanges_[type]={type:type,from:from,to:to};this.trigger('pendingtimelinechange');}return this.pendingTimelineChanges_[type];};_proto.lastTimelineChange=function lastTimelineChange(_ref2){var type=_ref2.type,from=_ref2.from,to=_ref2.to;if(typeof from==='number'&&typeof to==='number'){this.lastTimelineChanges_[type]={type:type,from:from,to:to};delete this.pendingTimelineChanges_[type];this.trigger('timelinechange');}return this.lastTimelineChanges_[type];};_proto.dispose=function dispose(){this.trigger('dispose');this.pendingTimelineChanges_={};this.lastTimelineChanges_={};this.off();};return TimelineChangeController;}(videojs.EventTarget);/* rollup-plugin-worker-factory start for worker!/home/runner/work/http-streaming/http-streaming/src/decrypter-worker.js */var workerCode=transform(getWorkerString(function(){var commonjsGlobal=typeof globalThis!=='undefined'?globalThis:typeof window!=='undefined'?window:typeof __webpack_require__.g!=='undefined'?__webpack_require__.g:typeof self!=='undefined'?self:{};function createCommonjsModule(fn,basedir,module){return module={path:basedir,exports:{},require:function require(path,base){return commonjsRequire(path,base===undefined||base===null?module.path:base);}},fn(module,module.exports),module.exports;}function commonjsRequire(){throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');}var createClass=createCommonjsModule(function(module){function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}module.exports=_createClass;module.exports["default"]=module.exports,module.exports.__esModule=true;});var setPrototypeOf=createCommonjsModule(function(module){function _setPrototypeOf(o,p){module.exports=_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};module.exports["default"]=module.exports,module.exports.__esModule=true;return _setPrototypeOf(o,p);}module.exports=_setPrototypeOf;module.exports["default"]=module.exports,module.exports.__esModule=true;});var inheritsLoose=createCommonjsModule(function(module){function _inheritsLoose(subClass,superClass){subClass.prototype=Object.create(superClass.prototype);subClass.prototype.constructor=subClass;setPrototypeOf(subClass,superClass);}module.exports=_inheritsLoose;module.exports["default"]=module.exports,module.exports.__esModule=true;});/**
   * @file stream.js
   */ /**
   * A lightweight readable stream implemention that handles event dispatching.
   *
   * @class Stream
   */var Stream=/*#__PURE__*/function(){function Stream(){this.listeners={};}/**
     * Add a listener for a specified event type.
     *
     * @param {string} type the event name
     * @param {Function} listener the callback to be invoked when an event of
     * the specified type occurs
     */var _proto=Stream.prototype;_proto.on=function on(type,listener){if(!this.listeners[type]){this.listeners[type]=[];}this.listeners[type].push(listener);}/**
     * Remove a listener for a specified event type.
     *
     * @param {string} type the event name
     * @param {Function} listener  a function previously registered for this
     * type of event through `on`
     * @return {boolean} if we could turn it off or not
     */;_proto.off=function off(type,listener){if(!this.listeners[type]){return false;}var index=this.listeners[type].indexOf(listener);// TODO: which is better?
// In Video.js we slice listener functions
// on trigger so that it does not mess up the order
// while we loop through.
//
// Here we slice on off so that the loop in trigger
// can continue using it's old reference to loop without
// messing up the order.
this.listeners[type]=this.listeners[type].slice(0);this.listeners[type].splice(index,1);return index>-1;}/**
     * Trigger an event of the specified type on this stream. Any additional
     * arguments to this function are passed as parameters to event listeners.
     *
     * @param {string} type the event name
     */;_proto.trigger=function trigger(type){var callbacks=this.listeners[type];if(!callbacks){return;}// Slicing the arguments on every invocation of this method
// can add a significant amount of overhead. Avoid the
// intermediate object creation for the common case of a
// single callback argument
if(arguments.length===2){var length=callbacks.length;for(var i=0;i<length;++i){callbacks[i].call(this,arguments[1]);}}else{var args=Array.prototype.slice.call(arguments,1);var _length=callbacks.length;for(var _i=0;_i<_length;++_i){callbacks[_i].apply(this,args);}}}/**
     * Destroys the stream and cleans up.
     */;_proto.dispose=function dispose(){this.listeners={};}/**
     * Forwards all `data` events on this stream to the destination stream. The
     * destination stream should provide a method `push` to receive the data
     * events as they arrive.
     *
     * @param {Stream} destination the stream that will receive all `data` events
     * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
     */;_proto.pipe=function pipe(destination){this.on('data',function(data){destination.push(data);});};return Stream;}();/*! @name pkcs7 @version 1.0.4 @license Apache-2.0 */ /**
   * Returns the subarray of a Uint8Array without PKCS#7 padding.
   *
   * @param padded {Uint8Array} unencrypted bytes that have been padded
   * @return {Uint8Array} the unpadded bytes
   * @see http://tools.ietf.org/html/rfc5652
   */function unpad(padded){return padded.subarray(0,padded.byteLength-padded[padded.byteLength-1]);}/*! @name aes-decrypter @version 3.1.3 @license Apache-2.0 */ /**
   * @file aes.js
   *
   * This file contains an adaptation of the AES decryption algorithm
   * from the Standford Javascript Cryptography Library. That work is
   * covered by the following copyright and permissions notice:
   *
   * Copyright 2009-2010 Emily Stark, Mike Hamburg, Dan Boneh.
   * All rights reserved.
   *
   * Redistribution and use in source and binary forms, with or without
   * modification, are permitted provided that the following conditions are
   * met:
   *
   * 1. Redistributions of source code must retain the above copyright
   *    notice, this list of conditions and the following disclaimer.
   *
   * 2. Redistributions in binary form must reproduce the above
   *    copyright notice, this list of conditions and the following
   *    disclaimer in the documentation and/or other materials provided
   *    with the distribution.
   *
   * THIS SOFTWARE IS PROVIDED BY THE AUTHORS ``AS IS'' AND ANY EXPRESS OR
   * IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
   * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
   * DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> OR CONTRIBUTORS BE
   * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
   * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
   * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
   * BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
   * WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
   * OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN
   * IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   *
   * The views and conclusions contained in the software and documentation
   * are those of the authors and should not be interpreted as representing
   * official policies, either expressed or implied, of the authors.
   */ /**
   * Expand the S-box tables.
   *
   * @private
   */var precompute=function precompute(){var tables=[[[],[],[],[],[]],[[],[],[],[],[]]];var encTable=tables[0];var decTable=tables[1];var sbox=encTable[4];var sboxInv=decTable[4];var i;var x;var xInv;var d=[];var th=[];var x2;var x4;var x8;var s;var tEnc;var tDec;// Compute double and third tables
for(i=0;i<256;i++){th[(d[i]=i<<1^(i>>7)*283)^i]=i;}for(x=xInv=0;!sbox[x];x^=x2||1,xInv=th[xInv]||1){// Compute sbox
s=xInv^xInv<<1^xInv<<2^xInv<<3^xInv<<4;s=s>>8^s&255^99;sbox[x]=s;sboxInv[s]=x;// Compute MixColumns
x8=d[x4=d[x2=d[x]]];tDec=x8*0x1010101^x4*0x10001^x2*0x101^x*0x1010100;tEnc=d[s]*0x101^s*0x1010100;for(i=0;i<4;i++){encTable[i][x]=tEnc=tEnc<<24^tEnc>>>8;decTable[i][s]=tDec=tDec<<24^tDec>>>8;}}// Compactify. Considerable speedup on Firefox.
for(i=0;i<5;i++){encTable[i]=encTable[i].slice(0);decTable[i]=decTable[i].slice(0);}return tables;};var aesTables=null;/**
   * Schedule out an AES key for both encryption and decryption. This
   * is a low-level class. Use a cipher mode to do bulk encryption.
   *
   * @class AES
   * @param key {Array} The key as an array of 4, 6 or 8 words.
   */var AES=/*#__PURE__*/function(){function AES(key){/**
      * The expanded S-box and inverse S-box tables. These will be computed
      * on the client so that we don't have to send them down the wire.
      *
      * There are two tables, _tables[0] is for encryption and
      * _tables[1] is for decryption.
      *
      * The first 4 sub-tables are the expanded S-box with MixColumns. The
      * last (_tables[01][4]) is the S-box itself.
      *
      * @private
      */ // if we have yet to precompute the S-box tables
// do so now
if(!aesTables){aesTables=precompute();}// then make a copy of that object for use
this._tables=[[aesTables[0][0].slice(),aesTables[0][1].slice(),aesTables[0][2].slice(),aesTables[0][3].slice(),aesTables[0][4].slice()],[aesTables[1][0].slice(),aesTables[1][1].slice(),aesTables[1][2].slice(),aesTables[1][3].slice(),aesTables[1][4].slice()]];var i;var j;var tmp;var sbox=this._tables[0][4];var decTable=this._tables[1];var keyLen=key.length;var rcon=1;if(keyLen!==4&&keyLen!==6&&keyLen!==8){throw new Error('Invalid aes key size');}var encKey=key.slice(0);var decKey=[];this._key=[encKey,decKey];// schedule encryption keys
for(i=keyLen;i<4*keyLen+28;i++){tmp=encKey[i-1];// apply sbox
if(i%keyLen===0||keyLen===8&&i%keyLen===4){tmp=sbox[tmp>>>24]<<24^sbox[tmp>>16&255]<<16^sbox[tmp>>8&255]<<8^sbox[tmp&255];// shift rows and add rcon
if(i%keyLen===0){tmp=tmp<<8^tmp>>>24^rcon<<24;rcon=rcon<<1^(rcon>>7)*283;}}encKey[i]=encKey[i-keyLen]^tmp;}// schedule decryption keys
for(j=0;i;j++,i--){tmp=encKey[j&3?i:i-4];if(i<=4||j<4){decKey[j]=tmp;}else{decKey[j]=decTable[0][sbox[tmp>>>24]]^decTable[1][sbox[tmp>>16&255]]^decTable[2][sbox[tmp>>8&255]]^decTable[3][sbox[tmp&255]];}}}/**
     * Decrypt 16 bytes, specified as four 32-bit words.
     *
     * @param {number} encrypted0 the first word to decrypt
     * @param {number} encrypted1 the second word to decrypt
     * @param {number} encrypted2 the third word to decrypt
     * @param {number} encrypted3 the fourth word to decrypt
     * @param {Int32Array} out the array to write the decrypted words
     * into
     * @param {number} offset the offset into the output array to start
     * writing results
     * @return {Array} The plaintext.
     */var _proto=AES.prototype;_proto.decrypt=function decrypt(encrypted0,encrypted1,encrypted2,encrypted3,out,offset){var key=this._key[1];// state variables a,b,c,d are loaded with pre-whitened data
var a=encrypted0^key[0];var b=encrypted3^key[1];var c=encrypted2^key[2];var d=encrypted1^key[3];var a2;var b2;var c2;// key.length === 2 ?
var nInnerRounds=key.length/4-2;var i;var kIndex=4;var table=this._tables[1];// load up the tables
var table0=table[0];var table1=table[1];var table2=table[2];var table3=table[3];var sbox=table[4];// Inner rounds. Cribbed from OpenSSL.
for(i=0;i<nInnerRounds;i++){a2=table0[a>>>24]^table1[b>>16&255]^table2[c>>8&255]^table3[d&255]^key[kIndex];b2=table0[b>>>24]^table1[c>>16&255]^table2[d>>8&255]^table3[a&255]^key[kIndex+1];c2=table0[c>>>24]^table1[d>>16&255]^table2[a>>8&255]^table3[b&255]^key[kIndex+2];d=table0[d>>>24]^table1[a>>16&255]^table2[b>>8&255]^table3[c&255]^key[kIndex+3];kIndex+=4;a=a2;b=b2;c=c2;}// Last round.
for(i=0;i<4;i++){out[(3&-i)+offset]=sbox[a>>>24]<<24^sbox[b>>16&255]<<16^sbox[c>>8&255]<<8^sbox[d&255]^key[kIndex++];a2=a;a=b;b=c;c=d;d=a2;}};return AES;}();/**
   * A wrapper around the Stream class to use setTimeout
   * and run stream "jobs" Asynchronously
   *
   * @class AsyncStream
   * @extends Stream
   */var AsyncStream=/*#__PURE__*/function(_Stream){inheritsLoose(AsyncStream,_Stream);function AsyncStream(){var _this;_this=_Stream.call(this,Stream)||this;_this.jobs=[];_this.delay=1;_this.timeout_=null;return _this;}/**
     * process an async job
     *
     * @private
     */var _proto=AsyncStream.prototype;_proto.processJob_=function processJob_(){this.jobs.shift()();if(this.jobs.length){this.timeout_=setTimeout(this.processJob_.bind(this),this.delay);}else{this.timeout_=null;}}/**
     * push a job into the stream
     *
     * @param {Function} job the job to push into the stream
     */;_proto.push=function push(job){this.jobs.push(job);if(!this.timeout_){this.timeout_=setTimeout(this.processJob_.bind(this),this.delay);}};return AsyncStream;}(Stream);/**
   * Convert network-order (big-endian) bytes into their little-endian
   * representation.
   */var ntoh=function ntoh(word){return word<<24|(word&0xff00)<<8|(word&0xff0000)>>8|word>>>24;};/**
   * Decrypt bytes using AES-128 with CBC and PKCS#7 padding.
   *
   * @param {Uint8Array} encrypted the encrypted bytes
   * @param {Uint32Array} key the bytes of the decryption key
   * @param {Uint32Array} initVector the initialization vector (IV) to
   * use for the first round of CBC.
   * @return {Uint8Array} the decrypted bytes
   *
   * @see http://en.wikipedia.org/wiki/Advanced_Encryption_Standard
   * @see http://en.wikipedia.org/wiki/Block_cipher_mode_of_operation#Cipher_Block_Chaining_.28CBC.29
   * @see https://tools.ietf.org/html/rfc2315
   */var decrypt=function decrypt(encrypted,key,initVector){// word-level access to the encrypted bytes
var encrypted32=new Int32Array(encrypted.buffer,encrypted.byteOffset,encrypted.byteLength>>2);var decipher=new AES(Array.prototype.slice.call(key));// byte and word-level access for the decrypted output
var decrypted=new Uint8Array(encrypted.byteLength);var decrypted32=new Int32Array(decrypted.buffer);// temporary variables for working with the IV, encrypted, and
// decrypted data
var init0;var init1;var init2;var init3;var encrypted0;var encrypted1;var encrypted2;var encrypted3;// iteration variable
var wordIx;// pull out the words of the IV to ensure we don't modify the
// passed-in reference and easier access
init0=initVector[0];init1=initVector[1];init2=initVector[2];init3=initVector[3];// decrypt four word sequences, applying cipher-block chaining (CBC)
// to each decrypted block
for(wordIx=0;wordIx<encrypted32.length;wordIx+=4){// convert big-endian (network order) words into little-endian
// (javascript order)
encrypted0=ntoh(encrypted32[wordIx]);encrypted1=ntoh(encrypted32[wordIx+1]);encrypted2=ntoh(encrypted32[wordIx+2]);encrypted3=ntoh(encrypted32[wordIx+3]);// decrypt the block
decipher.decrypt(encrypted0,encrypted1,encrypted2,encrypted3,decrypted32,wordIx);// XOR with the IV, and restore network byte-order to obtain the
// plaintext
decrypted32[wordIx]=ntoh(decrypted32[wordIx]^init0);decrypted32[wordIx+1]=ntoh(decrypted32[wordIx+1]^init1);decrypted32[wordIx+2]=ntoh(decrypted32[wordIx+2]^init2);decrypted32[wordIx+3]=ntoh(decrypted32[wordIx+3]^init3);// setup the IV for the next round
init0=encrypted0;init1=encrypted1;init2=encrypted2;init3=encrypted3;}return decrypted;};/**
   * The `Decrypter` class that manages decryption of AES
   * data through `AsyncStream` objects and the `decrypt`
   * function
   *
   * @param {Uint8Array} encrypted the encrypted bytes
   * @param {Uint32Array} key the bytes of the decryption key
   * @param {Uint32Array} initVector the initialization vector (IV) to
   * @param {Function} done the function to run when done
   * @class Decrypter
   */var Decrypter=/*#__PURE__*/function(){function Decrypter(encrypted,key,initVector,done){var step=Decrypter.STEP;var encrypted32=new Int32Array(encrypted.buffer);var decrypted=new Uint8Array(encrypted.byteLength);var i=0;this.asyncStream_=new AsyncStream();// split up the encryption job and do the individual chunks asynchronously
this.asyncStream_.push(this.decryptChunk_(encrypted32.subarray(i,i+step),key,initVector,decrypted));for(i=step;i<encrypted32.length;i+=step){initVector=new Uint32Array([ntoh(encrypted32[i-4]),ntoh(encrypted32[i-3]),ntoh(encrypted32[i-2]),ntoh(encrypted32[i-1])]);this.asyncStream_.push(this.decryptChunk_(encrypted32.subarray(i,i+step),key,initVector,decrypted));}// invoke the done() callback when everything is finished
this.asyncStream_.push(function(){// remove pkcs#7 padding from the decrypted bytes
done(null,unpad(decrypted));});}/**
     * a getter for step the maximum number of bytes to process at one time
     *
     * @return {number} the value of step 32000
     */var _proto=Decrypter.prototype;/**
     * @private
     */_proto.decryptChunk_=function decryptChunk_(encrypted,key,initVector,decrypted){return function(){var bytes=decrypt(encrypted,key,initVector);decrypted.set(bytes,encrypted.byteOffset);};};createClass(Decrypter,null,[{key:"STEP",get:function get(){// 4 * 8000;
return 32000;}}]);return Decrypter;}();var win;if(typeof window!=="undefined"){win=window;}else if(typeof commonjsGlobal!=="undefined"){win=commonjsGlobal;}else if(typeof self!=="undefined"){win=self;}else{win={};}var window_1=win;var isArrayBufferView=function isArrayBufferView(obj){if(ArrayBuffer.isView==='function'){return ArrayBuffer.isView(obj);}return obj&&obj.buffer instanceof ArrayBuffer;};var BigInt=window_1.BigInt||Number;[BigInt('0x1'),BigInt('0x100'),BigInt('0x10000'),BigInt('0x1000000'),BigInt('0x100000000'),BigInt('0x10000000000'),BigInt('0x1000000000000'),BigInt('0x100000000000000'),BigInt('0x10000000000000000')];/**
   * Creates an object for sending to a web worker modifying properties that are TypedArrays
   * into a new object with seperated properties for the buffer, byteOffset, and byteLength.
   *
   * @param {Object} message
   *        Object of properties and values to send to the web worker
   * @return {Object}
   *         Modified message with TypedArray values expanded
   * @function createTransferableMessage
   */var createTransferableMessage=function createTransferableMessage(message){var transferable={};Object.keys(message).forEach(function(key){var value=message[key];if(isArrayBufferView(value)){transferable[key]={bytes:value.buffer,byteOffset:value.byteOffset,byteLength:value.byteLength};}else{transferable[key]=value;}});return transferable;};/* global self */ /**
   * Our web worker interface so that things can talk to aes-decrypter
   * that will be running in a web worker. the scope is passed to this by
   * webworkify.
   */self.onmessage=function(event){var data=event.data;var encrypted=new Uint8Array(data.encrypted.bytes,data.encrypted.byteOffset,data.encrypted.byteLength);var key=new Uint32Array(data.key.bytes,data.key.byteOffset,data.key.byteLength/4);var iv=new Uint32Array(data.iv.bytes,data.iv.byteOffset,data.iv.byteLength/4);/* eslint-disable no-new, handle-callback-err */new Decrypter(encrypted,key,iv,function(err,bytes){self.postMessage(createTransferableMessage({source:data.source,decrypted:bytes}),[bytes.buffer]);});/* eslint-enable */};}));var Decrypter=factory(workerCode);/* rollup-plugin-worker-factory end for worker!/home/runner/work/http-streaming/http-streaming/src/decrypter-worker.js */ /**
 * Convert the properties of an HLS track into an audioTrackKind.
 *
 * @private
 */var audioTrackKind_=function audioTrackKind_(properties){var kind=properties["default"]?'main':'alternative';if(properties.characteristics&&properties.characteristics.indexOf('public.accessibility.describes-video')>=0){kind='main-desc';}return kind;};/**
 * Pause provided segment loader and playlist loader if active
 *
 * @param {SegmentLoader} segmentLoader
 *        SegmentLoader to pause
 * @param {Object} mediaType
 *        Active media type
 * @function stopLoaders
 */var stopLoaders=function stopLoaders(segmentLoader,mediaType){segmentLoader.abort();segmentLoader.pause();if(mediaType&&mediaType.activePlaylistLoader){mediaType.activePlaylistLoader.pause();mediaType.activePlaylistLoader=null;}};/**
 * Start loading provided segment loader and playlist loader
 *
 * @param {PlaylistLoader} playlistLoader
 *        PlaylistLoader to start loading
 * @param {Object} mediaType
 *        Active media type
 * @function startLoaders
 */var startLoaders=function startLoaders(playlistLoader,mediaType){// Segment loader will be started after `loadedmetadata` or `loadedplaylist` from the
// playlist loader
mediaType.activePlaylistLoader=playlistLoader;playlistLoader.load();};/**
 * Returns a function to be called when the media group changes. It performs a
 * non-destructive (preserve the buffer) resync of the SegmentLoader. This is because a
 * change of group is merely a rendition switch of the same content at another encoding,
 * rather than a change of content, such as switching audio from English to Spanish.
 *
 * @param {string} type
 *        MediaGroup type
 * @param {Object} settings
 *        Object containing required information for media groups
 * @return {Function}
 *         Handler for a non-destructive resync of SegmentLoader when the active media
 *         group changes.
 * @function onGroupChanged
 */var onGroupChanged=function onGroupChanged(type,settings){return function(){var _settings$segmentLoad=settings.segmentLoaders,segmentLoader=_settings$segmentLoad[type],mainSegmentLoader=_settings$segmentLoad.main,mediaType=settings.mediaTypes[type];var activeTrack=mediaType.activeTrack();var activeGroup=mediaType.getActiveGroup();var previousActiveLoader=mediaType.activePlaylistLoader;var lastGroup=mediaType.lastGroup_;// the group did not change do nothing
if(activeGroup&&lastGroup&&activeGroup.id===lastGroup.id){return;}mediaType.lastGroup_=activeGroup;mediaType.lastTrack_=activeTrack;stopLoaders(segmentLoader,mediaType);if(!activeGroup||activeGroup.isMasterPlaylist){// there is no group active or active group is a main playlist and won't change
return;}if(!activeGroup.playlistLoader){if(previousActiveLoader){// The previous group had a playlist loader but the new active group does not
// this means we are switching from demuxed to muxed audio. In this case we want to
// do a destructive reset of the main segment loader and not restart the audio
// loaders.
mainSegmentLoader.resetEverything();}return;}// Non-destructive resync
segmentLoader.resyncLoader();startLoaders(activeGroup.playlistLoader,mediaType);};};var onGroupChanging=function onGroupChanging(type,settings){return function(){var segmentLoader=settings.segmentLoaders[type],mediaType=settings.mediaTypes[type];mediaType.lastGroup_=null;segmentLoader.abort();segmentLoader.pause();};};/**
 * Returns a function to be called when the media track changes. It performs a
 * destructive reset of the SegmentLoader to ensure we start loading as close to
 * currentTime as possible.
 *
 * @param {string} type
 *        MediaGroup type
 * @param {Object} settings
 *        Object containing required information for media groups
 * @return {Function}
 *         Handler for a destructive reset of SegmentLoader when the active media
 *         track changes.
 * @function onTrackChanged
 */var onTrackChanged=function onTrackChanged(type,settings){return function(){var masterPlaylistLoader=settings.masterPlaylistLoader,_settings$segmentLoad2=settings.segmentLoaders,segmentLoader=_settings$segmentLoad2[type],mainSegmentLoader=_settings$segmentLoad2.main,mediaType=settings.mediaTypes[type];var activeTrack=mediaType.activeTrack();var activeGroup=mediaType.getActiveGroup();var previousActiveLoader=mediaType.activePlaylistLoader;var lastTrack=mediaType.lastTrack_;// track did not change, do nothing
if(lastTrack&&activeTrack&&lastTrack.id===activeTrack.id){return;}mediaType.lastGroup_=activeGroup;mediaType.lastTrack_=activeTrack;stopLoaders(segmentLoader,mediaType);if(!activeGroup){// there is no group active so we do not want to restart loaders
return;}if(activeGroup.isMasterPlaylist){// track did not change, do nothing
if(!activeTrack||!lastTrack||activeTrack.id===lastTrack.id){return;}var mpc=settings.vhs.masterPlaylistController_;var newPlaylist=mpc.selectPlaylist();// media will not change do nothing
if(mpc.media()===newPlaylist){return;}mediaType.logger_("track change. Switching master audio from "+lastTrack.id+" to "+activeTrack.id);masterPlaylistLoader.pause();mainSegmentLoader.resetEverything();mpc.fastQualityChange_(newPlaylist);return;}if(type==='AUDIO'){if(!activeGroup.playlistLoader){// when switching from demuxed audio/video to muxed audio/video (noted by no
// playlist loader for the audio group), we want to do a destructive reset of the
// main segment loader and not restart the audio loaders
mainSegmentLoader.setAudio(true);// don't have to worry about disabling the audio of the audio segment loader since
// it should be stopped
mainSegmentLoader.resetEverything();return;}// although the segment loader is an audio segment loader, call the setAudio
// function to ensure it is prepared to re-append the init segment (or handle other
// config changes)
segmentLoader.setAudio(true);mainSegmentLoader.setAudio(false);}if(previousActiveLoader===activeGroup.playlistLoader){// Nothing has actually changed. This can happen because track change events can fire
// multiple times for a "single" change. One for enabling the new active track, and
// one for disabling the track that was active
startLoaders(activeGroup.playlistLoader,mediaType);return;}if(segmentLoader.track){// For WebVTT, set the new text track in the segmentloader
segmentLoader.track(activeTrack);}// destructive reset
segmentLoader.resetEverything();startLoaders(activeGroup.playlistLoader,mediaType);};};var onError={/**
   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
   * an error.
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Error handler. Logs warning (or error if the playlist is blacklisted) to
   *         console and switches back to default audio track.
   * @function onError.AUDIO
   */AUDIO:function AUDIO(type,settings){return function(){var segmentLoader=settings.segmentLoaders[type],mediaType=settings.mediaTypes[type],blacklistCurrentPlaylist=settings.blacklistCurrentPlaylist;stopLoaders(segmentLoader,mediaType);// switch back to default audio track
var activeTrack=mediaType.activeTrack();var activeGroup=mediaType.activeGroup();var id=(activeGroup.filter(function(group){return group["default"];})[0]||activeGroup[0]).id;var defaultTrack=mediaType.tracks[id];if(activeTrack===defaultTrack){// Default track encountered an error. All we can do now is blacklist the current
// rendition and hope another will switch audio groups
blacklistCurrentPlaylist({message:'Problem encountered loading the default audio track.'});return;}videojs.log.warn('Problem encountered loading the alternate audio track.'+'Switching back to default.');for(var trackId in mediaType.tracks){mediaType.tracks[trackId].enabled=mediaType.tracks[trackId]===defaultTrack;}mediaType.onTrackChanged();};},/**
   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
   * an error.
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Error handler. Logs warning to console and disables the active subtitle track
   * @function onError.SUBTITLES
   */SUBTITLES:function SUBTITLES(type,settings){return function(){var segmentLoader=settings.segmentLoaders[type],mediaType=settings.mediaTypes[type];videojs.log.warn('Problem encountered loading the subtitle track.'+'Disabling subtitle track.');stopLoaders(segmentLoader,mediaType);var track=mediaType.activeTrack();if(track){track.mode='disabled';}mediaType.onTrackChanged();};}};var setupListeners={/**
   * Setup event listeners for audio playlist loader
   *
   * @param {string} type
   *        MediaGroup type
   * @param {PlaylistLoader|null} playlistLoader
   *        PlaylistLoader to register listeners on
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function setupListeners.AUDIO
   */AUDIO:function AUDIO(type,playlistLoader,settings){if(!playlistLoader){// no playlist loader means audio will be muxed with the video
return;}var tech=settings.tech,requestOptions=settings.requestOptions,segmentLoader=settings.segmentLoaders[type];playlistLoader.on('loadedmetadata',function(){var media=playlistLoader.media();segmentLoader.playlist(media,requestOptions);// if the video is already playing, or if this isn't a live video and preload
// permits, start downloading segments
if(!tech.paused()||media.endList&&tech.preload()!=='none'){segmentLoader.load();}});playlistLoader.on('loadedplaylist',function(){segmentLoader.playlist(playlistLoader.media(),requestOptions);// If the player isn't paused, ensure that the segment loader is running
if(!tech.paused()){segmentLoader.load();}});playlistLoader.on('error',onError[type](type,settings));},/**
   * Setup event listeners for subtitle playlist loader
   *
   * @param {string} type
   *        MediaGroup type
   * @param {PlaylistLoader|null} playlistLoader
   *        PlaylistLoader to register listeners on
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function setupListeners.SUBTITLES
   */SUBTITLES:function SUBTITLES(type,playlistLoader,settings){var tech=settings.tech,requestOptions=settings.requestOptions,segmentLoader=settings.segmentLoaders[type],mediaType=settings.mediaTypes[type];playlistLoader.on('loadedmetadata',function(){var media=playlistLoader.media();segmentLoader.playlist(media,requestOptions);segmentLoader.track(mediaType.activeTrack());// if the video is already playing, or if this isn't a live video and preload
// permits, start downloading segments
if(!tech.paused()||media.endList&&tech.preload()!=='none'){segmentLoader.load();}});playlistLoader.on('loadedplaylist',function(){segmentLoader.playlist(playlistLoader.media(),requestOptions);// If the player isn't paused, ensure that the segment loader is running
if(!tech.paused()){segmentLoader.load();}});playlistLoader.on('error',onError[type](type,settings));}};var initialize={/**
   * Setup PlaylistLoaders and AudioTracks for the audio groups
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize.AUDIO
   */'AUDIO':function AUDIO(type,settings){var vhs=settings.vhs,sourceType=settings.sourceType,segmentLoader=settings.segmentLoaders[type],requestOptions=settings.requestOptions,mediaGroups=settings.master.mediaGroups,_settings$mediaTypes$=settings.mediaTypes[type],groups=_settings$mediaTypes$.groups,tracks=_settings$mediaTypes$.tracks,logger_=_settings$mediaTypes$.logger_,masterPlaylistLoader=settings.masterPlaylistLoader;var audioOnlyMaster=isAudioOnly(masterPlaylistLoader.master);// force a default if we have none
if(!mediaGroups[type]||Object.keys(mediaGroups[type]).length===0){mediaGroups[type]={main:{"default":{"default":true}}};if(audioOnlyMaster){mediaGroups[type].main["default"].playlists=masterPlaylistLoader.master.playlists;}}for(var groupId in mediaGroups[type]){if(!groups[groupId]){groups[groupId]=[];}for(var variantLabel in mediaGroups[type][groupId]){var properties=mediaGroups[type][groupId][variantLabel];var playlistLoader=void 0;if(audioOnlyMaster){logger_("AUDIO group '"+groupId+"' label '"+variantLabel+"' is a master playlist");properties.isMasterPlaylist=true;playlistLoader=null;// if vhs-json was provided as the source, and the media playlist was resolved,
// use the resolved media playlist object
}else if(sourceType==='vhs-json'&&properties.playlists){playlistLoader=new PlaylistLoader(properties.playlists[0],vhs,requestOptions);}else if(properties.resolvedUri){playlistLoader=new PlaylistLoader(properties.resolvedUri,vhs,requestOptions);// TODO: dash isn't the only type with properties.playlists
// should we even have properties.playlists in this check.
}else if(properties.playlists&&sourceType==='dash'){playlistLoader=new DashPlaylistLoader(properties.playlists[0],vhs,requestOptions,masterPlaylistLoader);}else{// no resolvedUri means the audio is muxed with the video when using this
// audio track
playlistLoader=null;}properties=videojs.mergeOptions({id:variantLabel,playlistLoader:playlistLoader},properties);setupListeners[type](type,properties.playlistLoader,settings);groups[groupId].push(properties);if(typeof tracks[variantLabel]==='undefined'){var track=new videojs.AudioTrack({id:variantLabel,kind:audioTrackKind_(properties),enabled:false,language:properties.language,"default":properties["default"],label:variantLabel});tracks[variantLabel]=track;}}}// setup single error event handler for the segment loader
segmentLoader.on('error',onError[type](type,settings));},/**
   * Setup PlaylistLoaders and TextTracks for the subtitle groups
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize.SUBTITLES
   */'SUBTITLES':function SUBTITLES(type,settings){var tech=settings.tech,vhs=settings.vhs,sourceType=settings.sourceType,segmentLoader=settings.segmentLoaders[type],requestOptions=settings.requestOptions,mediaGroups=settings.master.mediaGroups,_settings$mediaTypes$2=settings.mediaTypes[type],groups=_settings$mediaTypes$2.groups,tracks=_settings$mediaTypes$2.tracks,masterPlaylistLoader=settings.masterPlaylistLoader;for(var groupId in mediaGroups[type]){if(!groups[groupId]){groups[groupId]=[];}for(var variantLabel in mediaGroups[type][groupId]){if(mediaGroups[type][groupId][variantLabel].forced){// Subtitle playlists with the forced attribute are not selectable in Safari.
// According to Apple's HLS Authoring Specification:
//   If content has forced subtitles and regular subtitles in a given language,
//   the regular subtitles track in that language MUST contain both the forced
//   subtitles and the regular subtitles for that language.
// Because of this requirement and that Safari does not add forced subtitles,
// forced subtitles are skipped here to maintain consistent experience across
// all platforms
continue;}var properties=mediaGroups[type][groupId][variantLabel];var playlistLoader=void 0;if(sourceType==='hls'){playlistLoader=new PlaylistLoader(properties.resolvedUri,vhs,requestOptions);}else if(sourceType==='dash'){var playlists=properties.playlists.filter(function(p){return p.excludeUntil!==Infinity;});if(!playlists.length){return;}playlistLoader=new DashPlaylistLoader(properties.playlists[0],vhs,requestOptions,masterPlaylistLoader);}else if(sourceType==='vhs-json'){playlistLoader=new PlaylistLoader(// if the vhs-json object included the media playlist, use the media playlist
// as provided, otherwise use the resolved URI to load the playlist
properties.playlists?properties.playlists[0]:properties.resolvedUri,vhs,requestOptions);}properties=videojs.mergeOptions({id:variantLabel,playlistLoader:playlistLoader},properties);setupListeners[type](type,properties.playlistLoader,settings);groups[groupId].push(properties);if(typeof tracks[variantLabel]==='undefined'){var track=tech.addRemoteTextTrack({id:variantLabel,kind:'subtitles',"default":properties["default"]&&properties.autoselect,language:properties.language,label:variantLabel},false).track;tracks[variantLabel]=track;}}}// setup single error event handler for the segment loader
segmentLoader.on('error',onError[type](type,settings));},/**
   * Setup TextTracks for the closed-caption groups
   *
   * @param {String} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize['CLOSED-CAPTIONS']
   */'CLOSED-CAPTIONS':function CLOSEDCAPTIONS(type,settings){var tech=settings.tech,mediaGroups=settings.master.mediaGroups,_settings$mediaTypes$3=settings.mediaTypes[type],groups=_settings$mediaTypes$3.groups,tracks=_settings$mediaTypes$3.tracks;for(var groupId in mediaGroups[type]){if(!groups[groupId]){groups[groupId]=[];}for(var variantLabel in mediaGroups[type][groupId]){var properties=mediaGroups[type][groupId][variantLabel];// Look for either 608 (CCn) or 708 (SERVICEn) caption services
if(!/^(?:CC|SERVICE)/.test(properties.instreamId)){continue;}var captionServices=tech.options_.vhs&&tech.options_.vhs.captionServices||{};var newProps={label:variantLabel,language:properties.language,instreamId:properties.instreamId,"default":properties["default"]&&properties.autoselect};if(captionServices[newProps.instreamId]){newProps=videojs.mergeOptions(newProps,captionServices[newProps.instreamId]);}if(newProps["default"]===undefined){delete newProps["default"];}// No PlaylistLoader is required for Closed-Captions because the captions are
// embedded within the video stream
groups[groupId].push(videojs.mergeOptions({id:variantLabel},properties));if(typeof tracks[variantLabel]==='undefined'){var track=tech.addRemoteTextTrack({id:newProps.instreamId,kind:'captions',"default":newProps["default"],language:newProps.language,label:newProps.label},false).track;tracks[variantLabel]=track;}}}}};var groupMatch=function groupMatch(list,media){for(var i=0;i<list.length;i++){if(playlistMatch(media,list[i])){return true;}if(list[i].playlists&&groupMatch(list[i].playlists,media)){return true;}}return false;};/**
 * Returns a function used to get the active group of the provided type
 *
 * @param {string} type
 *        MediaGroup type
 * @param {Object} settings
 *        Object containing required information for media groups
 * @return {Function}
 *         Function that returns the active media group for the provided type. Takes an
 *         optional parameter {TextTrack} track. If no track is provided, a list of all
 *         variants in the group, otherwise the variant corresponding to the provided
 *         track is returned.
 * @function activeGroup
 */var activeGroup=function activeGroup(type,settings){return function(track){var masterPlaylistLoader=settings.masterPlaylistLoader,groups=settings.mediaTypes[type].groups;var media=masterPlaylistLoader.media();if(!media){return null;}var variants=null;// set to variants to main media active group
if(media.attributes[type]){variants=groups[media.attributes[type]];}var groupKeys=Object.keys(groups);if(!variants){// find the masterPlaylistLoader media
// that is in a media group if we are dealing
// with audio only
if(type==='AUDIO'&&groupKeys.length>1&&isAudioOnly(settings.master)){for(var i=0;i<groupKeys.length;i++){var groupPropertyList=groups[groupKeys[i]];if(groupMatch(groupPropertyList,media)){variants=groupPropertyList;break;}}// use the main group if it exists
}else if(groups.main){variants=groups.main;// only one group, use that one
}else if(groupKeys.length===1){variants=groups[groupKeys[0]];}}if(typeof track==='undefined'){return variants;}if(track===null||!variants){// An active track was specified so a corresponding group is expected. track === null
// means no track is currently active so there is no corresponding group
return null;}return variants.filter(function(props){return props.id===track.id;})[0]||null;};};var activeTrack={/**
   * Returns a function used to get the active track of type provided
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Function that returns the active media track for the provided type. Returns
   *         null if no track is active
   * @function activeTrack.AUDIO
   */AUDIO:function AUDIO(type,settings){return function(){var tracks=settings.mediaTypes[type].tracks;for(var id in tracks){if(tracks[id].enabled){return tracks[id];}}return null;};},/**
   * Returns a function used to get the active track of type provided
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Function that returns the active media track for the provided type. Returns
   *         null if no track is active
   * @function activeTrack.SUBTITLES
   */SUBTITLES:function SUBTITLES(type,settings){return function(){var tracks=settings.mediaTypes[type].tracks;for(var id in tracks){if(tracks[id].mode==='showing'||tracks[id].mode==='hidden'){return tracks[id];}}return null;};}};var getActiveGroup=function getActiveGroup(type,_ref){var mediaTypes=_ref.mediaTypes;return function(){var activeTrack_=mediaTypes[type].activeTrack();if(!activeTrack_){return null;}return mediaTypes[type].activeGroup(activeTrack_);};};/**
 * Setup PlaylistLoaders and Tracks for media groups (Audio, Subtitles,
 * Closed-Captions) specified in the master manifest.
 *
 * @param {Object} settings
 *        Object containing required information for setting up the media groups
 * @param {Tech} settings.tech
 *        The tech of the player
 * @param {Object} settings.requestOptions
 *        XHR request options used by the segment loaders
 * @param {PlaylistLoader} settings.masterPlaylistLoader
 *        PlaylistLoader for the master source
 * @param {VhsHandler} settings.vhs
 *        VHS SourceHandler
 * @param {Object} settings.master
 *        The parsed master manifest
 * @param {Object} settings.mediaTypes
 *        Object to store the loaders, tracks, and utility methods for each media type
 * @param {Function} settings.blacklistCurrentPlaylist
 *        Blacklists the current rendition and forces a rendition switch.
 * @function setupMediaGroups
 */var setupMediaGroups=function setupMediaGroups(settings){['AUDIO','SUBTITLES','CLOSED-CAPTIONS'].forEach(function(type){initialize[type](type,settings);});var mediaTypes=settings.mediaTypes,masterPlaylistLoader=settings.masterPlaylistLoader,tech=settings.tech,vhs=settings.vhs,_settings$segmentLoad3=settings.segmentLoaders,audioSegmentLoader=_settings$segmentLoad3['AUDIO'],mainSegmentLoader=_settings$segmentLoad3.main;// setup active group and track getters and change event handlers
['AUDIO','SUBTITLES'].forEach(function(type){mediaTypes[type].activeGroup=activeGroup(type,settings);mediaTypes[type].activeTrack=activeTrack[type](type,settings);mediaTypes[type].onGroupChanged=onGroupChanged(type,settings);mediaTypes[type].onGroupChanging=onGroupChanging(type,settings);mediaTypes[type].onTrackChanged=onTrackChanged(type,settings);mediaTypes[type].getActiveGroup=getActiveGroup(type,settings);});// DO NOT enable the default subtitle or caption track.
// DO enable the default audio track
var audioGroup=mediaTypes.AUDIO.activeGroup();if(audioGroup){var groupId=(audioGroup.filter(function(group){return group["default"];})[0]||audioGroup[0]).id;mediaTypes.AUDIO.tracks[groupId].enabled=true;mediaTypes.AUDIO.onGroupChanged();mediaTypes.AUDIO.onTrackChanged();var activeAudioGroup=mediaTypes.AUDIO.getActiveGroup();// a similar check for handling setAudio on each loader is run again each time the
// track is changed, but needs to be handled here since the track may not be considered
// changed on the first call to onTrackChanged
if(!activeAudioGroup.playlistLoader){// either audio is muxed with video or the stream is audio only
mainSegmentLoader.setAudio(true);}else{// audio is demuxed
mainSegmentLoader.setAudio(false);audioSegmentLoader.setAudio(true);}}masterPlaylistLoader.on('mediachange',function(){['AUDIO','SUBTITLES'].forEach(function(type){return mediaTypes[type].onGroupChanged();});});masterPlaylistLoader.on('mediachanging',function(){['AUDIO','SUBTITLES'].forEach(function(type){return mediaTypes[type].onGroupChanging();});});// custom audio track change event handler for usage event
var onAudioTrackChanged=function onAudioTrackChanged(){mediaTypes.AUDIO.onTrackChanged();tech.trigger({type:'usage',name:'vhs-audio-change'});tech.trigger({type:'usage',name:'hls-audio-change'});};tech.audioTracks().addEventListener('change',onAudioTrackChanged);tech.remoteTextTracks().addEventListener('change',mediaTypes.SUBTITLES.onTrackChanged);vhs.on('dispose',function(){tech.audioTracks().removeEventListener('change',onAudioTrackChanged);tech.remoteTextTracks().removeEventListener('change',mediaTypes.SUBTITLES.onTrackChanged);});// clear existing audio tracks and add the ones we just created
tech.clearTracks('audio');for(var id in mediaTypes.AUDIO.tracks){tech.audioTracks().addTrack(mediaTypes.AUDIO.tracks[id]);}};/**
 * Creates skeleton object used to store the loaders, tracks, and utility methods for each
 * media type
 *
 * @return {Object}
 *         Object to store the loaders, tracks, and utility methods for each media type
 * @function createMediaTypes
 */var createMediaTypes=function createMediaTypes(){var mediaTypes={};['AUDIO','SUBTITLES','CLOSED-CAPTIONS'].forEach(function(type){mediaTypes[type]={groups:{},tracks:{},activePlaylistLoader:null,activeGroup:noop,activeTrack:noop,getActiveGroup:noop,onGroupChanged:noop,onTrackChanged:noop,lastTrack_:null,logger_:logger("MediaGroups["+type+"]")};});return mediaTypes;};var ABORT_EARLY_BLACKLIST_SECONDS=60*2;var Vhs$1;// SegmentLoader stats that need to have each loader's
// values summed to calculate the final value
var loaderStats=['mediaRequests','mediaRequestsAborted','mediaRequestsTimedout','mediaRequestsErrored','mediaTransferDuration','mediaBytesTransferred','mediaAppends'];var sumLoaderStat=function sumLoaderStat(stat){return this.audioSegmentLoader_[stat]+this.mainSegmentLoader_[stat];};var shouldSwitchToMedia=function shouldSwitchToMedia(_ref){var currentPlaylist=_ref.currentPlaylist,buffered=_ref.buffered,currentTime=_ref.currentTime,nextPlaylist=_ref.nextPlaylist,bufferLowWaterLine=_ref.bufferLowWaterLine,bufferHighWaterLine=_ref.bufferHighWaterLine,duration=_ref.duration,experimentalBufferBasedABR=_ref.experimentalBufferBasedABR,log=_ref.log;// we have no other playlist to switch to
if(!nextPlaylist){videojs.log.warn('We received no playlist to switch to. Please check your stream.');return false;}var sharedLogLine="allowing switch "+(currentPlaylist&&currentPlaylist.id||'null')+" -> "+nextPlaylist.id;if(!currentPlaylist){log(sharedLogLine+" as current playlist is not set");return true;}// no need to switch if playlist is the same
if(nextPlaylist.id===currentPlaylist.id){return false;}// determine if current time is in a buffered range.
var isBuffered=Boolean(findRange(buffered,currentTime).length);// If the playlist is live, then we want to not take low water line into account.
// This is because in LIVE, the player plays 3 segments from the end of the
// playlist, and if `BUFFER_LOW_WATER_LINE` is greater than the duration availble
// in those segments, a viewer will never experience a rendition upswitch.
if(!currentPlaylist.endList){// For LLHLS live streams, don't switch renditions before playback has started, as it almost
// doubles the time to first playback.
if(!isBuffered&&typeof currentPlaylist.partTargetDuration==='number'){log("not "+sharedLogLine+" as current playlist is live llhls, but currentTime isn't in buffered.");return false;}log(sharedLogLine+" as current playlist is live");return true;}var forwardBuffer=timeAheadOf(buffered,currentTime);var maxBufferLowWaterLine=experimentalBufferBasedABR?Config.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE:Config.MAX_BUFFER_LOW_WATER_LINE;// For the same reason as LIVE, we ignore the low water line when the VOD
// duration is below the max potential low water line
if(duration<maxBufferLowWaterLine){log(sharedLogLine+" as duration < max low water line ("+duration+" < "+maxBufferLowWaterLine+")");return true;}var nextBandwidth=nextPlaylist.attributes.BANDWIDTH;var currBandwidth=currentPlaylist.attributes.BANDWIDTH;// when switching down, if our buffer is lower than the high water line,
// we can switch down
if(nextBandwidth<currBandwidth&&(!experimentalBufferBasedABR||forwardBuffer<bufferHighWaterLine)){var logLine=sharedLogLine+" as next bandwidth < current bandwidth ("+nextBandwidth+" < "+currBandwidth+")";if(experimentalBufferBasedABR){logLine+=" and forwardBuffer < bufferHighWaterLine ("+forwardBuffer+" < "+bufferHighWaterLine+")";}log(logLine);return true;}// and if our buffer is higher than the low water line,
// we can switch up
if((!experimentalBufferBasedABR||nextBandwidth>currBandwidth)&&forwardBuffer>=bufferLowWaterLine){var _logLine=sharedLogLine+" as forwardBuffer >= bufferLowWaterLine ("+forwardBuffer+" >= "+bufferLowWaterLine+")";if(experimentalBufferBasedABR){_logLine+=" and next bandwidth > current bandwidth ("+nextBandwidth+" > "+currBandwidth+")";}log(_logLine);return true;}log("not "+sharedLogLine+" as no switching criteria met");return false;};/**
 * the master playlist controller controller all interactons
 * between playlists and segmentloaders. At this time this mainly
 * involves a master playlist and a series of audio playlists
 * if they are available
 *
 * @class MasterPlaylistController
 * @extends videojs.EventTarget
 */var MasterPlaylistController=/*#__PURE__*/function(_videojs$EventTarget){_inheritsLoose(MasterPlaylistController,_videojs$EventTarget);function MasterPlaylistController(options){var _this;_this=_videojs$EventTarget.call(this)||this;var src=options.src,handleManifestRedirects=options.handleManifestRedirects,withCredentials=options.withCredentials,tech=options.tech,bandwidth=options.bandwidth,externVhs=options.externVhs,useCueTags=options.useCueTags,blacklistDuration=options.blacklistDuration,enableLowInitialPlaylist=options.enableLowInitialPlaylist,sourceType=options.sourceType,cacheEncryptionKeys=options.cacheEncryptionKeys,experimentalBufferBasedABR=options.experimentalBufferBasedABR,experimentalLeastPixelDiffSelector=options.experimentalLeastPixelDiffSelector,captionServices=options.captionServices;if(!src){throw new Error('A non-empty playlist URL or JSON manifest string is required');}var maxPlaylistRetries=options.maxPlaylistRetries;if(maxPlaylistRetries===null||typeof maxPlaylistRetries==='undefined'){maxPlaylistRetries=Infinity;}Vhs$1=externVhs;_this.experimentalBufferBasedABR=Boolean(experimentalBufferBasedABR);_this.experimentalLeastPixelDiffSelector=Boolean(experimentalLeastPixelDiffSelector);_this.withCredentials=withCredentials;_this.tech_=tech;_this.vhs_=tech.vhs;_this.sourceType_=sourceType;_this.useCueTags_=useCueTags;_this.blacklistDuration=blacklistDuration;_this.maxPlaylistRetries=maxPlaylistRetries;_this.enableLowInitialPlaylist=enableLowInitialPlaylist;if(_this.useCueTags_){_this.cueTagsTrack_=_this.tech_.addTextTrack('metadata','ad-cues');_this.cueTagsTrack_.inBandMetadataTrackDispatchType='';}_this.requestOptions_={withCredentials:withCredentials,handleManifestRedirects:handleManifestRedirects,maxPlaylistRetries:maxPlaylistRetries,timeout:null};_this.on('error',_this.pauseLoading);_this.mediaTypes_=createMediaTypes();_this.mediaSource=new (window_default()).MediaSource();_this.handleDurationChange_=_this.handleDurationChange_.bind(_assertThisInitialized(_this));_this.handleSourceOpen_=_this.handleSourceOpen_.bind(_assertThisInitialized(_this));_this.handleSourceEnded_=_this.handleSourceEnded_.bind(_assertThisInitialized(_this));_this.mediaSource.addEventListener('durationchange',_this.handleDurationChange_);// load the media source into the player
_this.mediaSource.addEventListener('sourceopen',_this.handleSourceOpen_);_this.mediaSource.addEventListener('sourceended',_this.handleSourceEnded_);// we don't have to handle sourceclose since dispose will handle termination of
// everything, and the MediaSource should not be detached without a proper disposal
_this.seekable_=videojs.createTimeRanges();_this.hasPlayed_=false;_this.syncController_=new SyncController(options);_this.segmentMetadataTrack_=tech.addRemoteTextTrack({kind:'metadata',label:'segment-metadata'},false).track;_this.decrypter_=new Decrypter();_this.sourceUpdater_=new SourceUpdater(_this.mediaSource);_this.inbandTextTracks_={};_this.timelineChangeController_=new TimelineChangeController();var segmentLoaderSettings={vhs:_this.vhs_,parse708captions:options.parse708captions,useDtsForTimestampOffset:options.useDtsForTimestampOffset,captionServices:captionServices,mediaSource:_this.mediaSource,currentTime:_this.tech_.currentTime.bind(_this.tech_),seekable:function seekable(){return _this.seekable();},seeking:function seeking(){return _this.tech_.seeking();},duration:function duration(){return _this.duration();},hasPlayed:function hasPlayed(){return _this.hasPlayed_;},goalBufferLength:function goalBufferLength(){return _this.goalBufferLength();},bandwidth:bandwidth,syncController:_this.syncController_,decrypter:_this.decrypter_,sourceType:_this.sourceType_,inbandTextTracks:_this.inbandTextTracks_,cacheEncryptionKeys:cacheEncryptionKeys,sourceUpdater:_this.sourceUpdater_,timelineChangeController:_this.timelineChangeController_,experimentalExactManifestTimings:options.experimentalExactManifestTimings};// The source type check not only determines whether a special DASH playlist loader
// should be used, but also covers the case where the provided src is a vhs-json
// manifest object (instead of a URL). In the case of vhs-json, the default
// PlaylistLoader should be used.
_this.masterPlaylistLoader_=_this.sourceType_==='dash'?new DashPlaylistLoader(src,_this.vhs_,_this.requestOptions_):new PlaylistLoader(src,_this.vhs_,_this.requestOptions_);_this.setupMasterPlaylistLoaderListeners_();// setup segment loaders
// combined audio/video or just video when alternate audio track is selected
_this.mainSegmentLoader_=new SegmentLoader(videojs.mergeOptions(segmentLoaderSettings,{segmentMetadataTrack:_this.segmentMetadataTrack_,loaderType:'main'}),options);// alternate audio track
_this.audioSegmentLoader_=new SegmentLoader(videojs.mergeOptions(segmentLoaderSettings,{loaderType:'audio'}),options);_this.subtitleSegmentLoader_=new VTTSegmentLoader(videojs.mergeOptions(segmentLoaderSettings,{loaderType:'vtt',featuresNativeTextTracks:_this.tech_.featuresNativeTextTracks,loadVttJs:function loadVttJs(){return new Promise(function(resolve,reject){function onLoad(){tech.off('vttjserror',onError);resolve();}function onError(){tech.off('vttjsloaded',onLoad);reject();}tech.one('vttjsloaded',onLoad);tech.one('vttjserror',onError);// safe to call multiple times, script will be loaded only once:
tech.addWebVttScript_();});}}),options);_this.setupSegmentLoaderListeners_();if(_this.experimentalBufferBasedABR){_this.masterPlaylistLoader_.one('loadedplaylist',function(){return _this.startABRTimer_();});_this.tech_.on('pause',function(){return _this.stopABRTimer_();});_this.tech_.on('play',function(){return _this.startABRTimer_();});}// Create SegmentLoader stat-getters
// mediaRequests_
// mediaRequestsAborted_
// mediaRequestsTimedout_
// mediaRequestsErrored_
// mediaTransferDuration_
// mediaBytesTransferred_
// mediaAppends_
loaderStats.forEach(function(stat){_this[stat+'_']=sumLoaderStat.bind(_assertThisInitialized(_this),stat);});_this.logger_=logger('MPC');_this.triggeredFmp4Usage=false;if(_this.tech_.preload()==='none'){_this.loadOnPlay_=function(){_this.loadOnPlay_=null;_this.masterPlaylistLoader_.load();};_this.tech_.one('play',_this.loadOnPlay_);}else{_this.masterPlaylistLoader_.load();}_this.timeToLoadedData__=-1;_this.mainAppendsToLoadedData__=-1;_this.audioAppendsToLoadedData__=-1;var event=_this.tech_.preload()==='none'?'play':'loadstart';// start the first frame timer on loadstart or play (for preload none)
_this.tech_.one(event,function(){var timeToLoadedDataStart=Date.now();_this.tech_.one('loadeddata',function(){_this.timeToLoadedData__=Date.now()-timeToLoadedDataStart;_this.mainAppendsToLoadedData__=_this.mainSegmentLoader_.mediaAppends;_this.audioAppendsToLoadedData__=_this.audioSegmentLoader_.mediaAppends;});});return _this;}var _proto=MasterPlaylistController.prototype;_proto.mainAppendsToLoadedData_=function mainAppendsToLoadedData_(){return this.mainAppendsToLoadedData__;};_proto.audioAppendsToLoadedData_=function audioAppendsToLoadedData_(){return this.audioAppendsToLoadedData__;};_proto.appendsToLoadedData_=function appendsToLoadedData_(){var main=this.mainAppendsToLoadedData_();var audio=this.audioAppendsToLoadedData_();if(main===-1||audio===-1){return-1;}return main+audio;};_proto.timeToLoadedData_=function timeToLoadedData_(){return this.timeToLoadedData__;}/**
   * Run selectPlaylist and switch to the new playlist if we should
   *
   * @param {string} [reason=abr] a reason for why the ABR check is made
   * @private
   */;_proto.checkABR_=function checkABR_(reason){if(reason===void 0){reason='abr';}var nextPlaylist=this.selectPlaylist();if(nextPlaylist&&this.shouldSwitchToMedia_(nextPlaylist)){this.switchMedia_(nextPlaylist,reason);}};_proto.switchMedia_=function switchMedia_(playlist,cause,delay){var oldMedia=this.media();var oldId=oldMedia&&(oldMedia.id||oldMedia.uri);var newId=playlist.id||playlist.uri;if(oldId&&oldId!==newId){this.logger_("switch media "+oldId+" -> "+newId+" from "+cause);this.tech_.trigger({type:'usage',name:"vhs-rendition-change-"+cause});}this.masterPlaylistLoader_.media(playlist,delay);}/**
   * Start a timer that periodically calls checkABR_
   *
   * @private
   */;_proto.startABRTimer_=function startABRTimer_(){var _this2=this;this.stopABRTimer_();this.abrTimer_=window_default().setInterval(function(){return _this2.checkABR_();},250);}/**
   * Stop the timer that periodically calls checkABR_
   *
   * @private
   */;_proto.stopABRTimer_=function stopABRTimer_(){// if we're scrubbing, we don't need to pause.
// This getter will be added to Video.js in version 7.11.
if(this.tech_.scrubbing&&this.tech_.scrubbing()){return;}window_default().clearInterval(this.abrTimer_);this.abrTimer_=null;}/**
   * Get a list of playlists for the currently selected audio playlist
   *
   * @return {Array} the array of audio playlists
   */;_proto.getAudioTrackPlaylists_=function getAudioTrackPlaylists_(){var master=this.master();var defaultPlaylists=master&&master.playlists||[];// if we don't have any audio groups then we can only
// assume that the audio tracks are contained in masters
// playlist array, use that or an empty array.
if(!master||!master.mediaGroups||!master.mediaGroups.AUDIO){return defaultPlaylists;}var AUDIO=master.mediaGroups.AUDIO;var groupKeys=Object.keys(AUDIO);var track;// get the current active track
if(Object.keys(this.mediaTypes_.AUDIO.groups).length){track=this.mediaTypes_.AUDIO.activeTrack();// or get the default track from master if mediaTypes_ isn't setup yet
}else{// default group is `main` or just the first group.
var defaultGroup=AUDIO.main||groupKeys.length&&AUDIO[groupKeys[0]];for(var label in defaultGroup){if(defaultGroup[label]["default"]){track={label:label};break;}}}// no active track no playlists.
if(!track){return defaultPlaylists;}var playlists=[];// get all of the playlists that are possible for the
// active track.
for(var group in AUDIO){if(AUDIO[group][track.label]){var properties=AUDIO[group][track.label];if(properties.playlists&&properties.playlists.length){playlists.push.apply(playlists,properties.playlists);}else if(properties.uri){playlists.push(properties);}else if(master.playlists.length){// if an audio group does not have a uri
// see if we have main playlists that use it as a group.
// if we do then add those to the playlists list.
for(var i=0;i<master.playlists.length;i++){var playlist=master.playlists[i];if(playlist.attributes&&playlist.attributes.AUDIO&&playlist.attributes.AUDIO===group){playlists.push(playlist);}}}}}if(!playlists.length){return defaultPlaylists;}return playlists;}/**
   * Register event handlers on the master playlist loader. A helper
   * function for construction time.
   *
   * @private
   */;_proto.setupMasterPlaylistLoaderListeners_=function setupMasterPlaylistLoaderListeners_(){var _this3=this;this.masterPlaylistLoader_.on('loadedmetadata',function(){var media=_this3.masterPlaylistLoader_.media();var requestTimeout=media.targetDuration*1.5*1000;// If we don't have any more available playlists, we don't want to
// timeout the request.
if(isLowestEnabledRendition(_this3.masterPlaylistLoader_.master,_this3.masterPlaylistLoader_.media())){_this3.requestOptions_.timeout=0;}else{_this3.requestOptions_.timeout=requestTimeout;}// if this isn't a live video and preload permits, start
// downloading segments
if(media.endList&&_this3.tech_.preload()!=='none'){_this3.mainSegmentLoader_.playlist(media,_this3.requestOptions_);_this3.mainSegmentLoader_.load();}setupMediaGroups({sourceType:_this3.sourceType_,segmentLoaders:{AUDIO:_this3.audioSegmentLoader_,SUBTITLES:_this3.subtitleSegmentLoader_,main:_this3.mainSegmentLoader_},tech:_this3.tech_,requestOptions:_this3.requestOptions_,masterPlaylistLoader:_this3.masterPlaylistLoader_,vhs:_this3.vhs_,master:_this3.master(),mediaTypes:_this3.mediaTypes_,blacklistCurrentPlaylist:_this3.blacklistCurrentPlaylist.bind(_this3)});_this3.triggerPresenceUsage_(_this3.master(),media);_this3.setupFirstPlay();if(!_this3.mediaTypes_.AUDIO.activePlaylistLoader||_this3.mediaTypes_.AUDIO.activePlaylistLoader.media()){_this3.trigger('selectedinitialmedia');}else{// We must wait for the active audio playlist loader to
// finish setting up before triggering this event so the
// representations API and EME setup is correct
_this3.mediaTypes_.AUDIO.activePlaylistLoader.one('loadedmetadata',function(){_this3.trigger('selectedinitialmedia');});}});this.masterPlaylistLoader_.on('loadedplaylist',function(){if(_this3.loadOnPlay_){_this3.tech_.off('play',_this3.loadOnPlay_);}var updatedPlaylist=_this3.masterPlaylistLoader_.media();if(!updatedPlaylist){// exclude any variants that are not supported by the browser before selecting
// an initial media as the playlist selectors do not consider browser support
_this3.excludeUnsupportedVariants_();var selectedMedia;if(_this3.enableLowInitialPlaylist){selectedMedia=_this3.selectInitialPlaylist();}if(!selectedMedia){selectedMedia=_this3.selectPlaylist();}if(!selectedMedia||!_this3.shouldSwitchToMedia_(selectedMedia)){return;}_this3.initialMedia_=selectedMedia;_this3.switchMedia_(_this3.initialMedia_,'initial');// Under the standard case where a source URL is provided, loadedplaylist will
// fire again since the playlist will be requested. In the case of vhs-json
// (where the manifest object is provided as the source), when the media
// playlist's `segments` list is already available, a media playlist won't be
// requested, and loadedplaylist won't fire again, so the playlist handler must be
// called on its own here.
var haveJsonSource=_this3.sourceType_==='vhs-json'&&_this3.initialMedia_.segments;if(!haveJsonSource){return;}updatedPlaylist=_this3.initialMedia_;}_this3.handleUpdatedMediaPlaylist(updatedPlaylist);});this.masterPlaylistLoader_.on('error',function(){_this3.blacklistCurrentPlaylist(_this3.masterPlaylistLoader_.error);});this.masterPlaylistLoader_.on('mediachanging',function(){_this3.mainSegmentLoader_.abort();_this3.mainSegmentLoader_.pause();});this.masterPlaylistLoader_.on('mediachange',function(){var media=_this3.masterPlaylistLoader_.media();var requestTimeout=media.targetDuration*1.5*1000;// If we don't have any more available playlists, we don't want to
// timeout the request.
if(isLowestEnabledRendition(_this3.masterPlaylistLoader_.master,_this3.masterPlaylistLoader_.media())){_this3.requestOptions_.timeout=0;}else{_this3.requestOptions_.timeout=requestTimeout;}_this3.masterPlaylistLoader_.load();// TODO: Create a new event on the PlaylistLoader that signals
// that the segments have changed in some way and use that to
// update the SegmentLoader instead of doing it twice here and
// on `loadedplaylist`
_this3.mainSegmentLoader_.playlist(media,_this3.requestOptions_);_this3.mainSegmentLoader_.load();_this3.tech_.trigger({type:'mediachange',bubbles:true});});this.masterPlaylistLoader_.on('playlistunchanged',function(){var updatedPlaylist=_this3.masterPlaylistLoader_.media();// ignore unchanged playlists that have already been
// excluded for not-changing. We likely just have a really slowly updating
// playlist.
if(updatedPlaylist.lastExcludeReason_==='playlist-unchanged'){return;}var playlistOutdated=_this3.stuckAtPlaylistEnd_(updatedPlaylist);if(playlistOutdated){// Playlist has stopped updating and we're stuck at its end. Try to
// blacklist it and switch to another playlist in the hope that that
// one is updating (and give the player a chance to re-adjust to the
// safe live point).
_this3.blacklistCurrentPlaylist({message:'Playlist no longer updating.',reason:'playlist-unchanged'});// useful for monitoring QoS
_this3.tech_.trigger('playliststuck');}});this.masterPlaylistLoader_.on('renditiondisabled',function(){_this3.tech_.trigger({type:'usage',name:'vhs-rendition-disabled'});_this3.tech_.trigger({type:'usage',name:'hls-rendition-disabled'});});this.masterPlaylistLoader_.on('renditionenabled',function(){_this3.tech_.trigger({type:'usage',name:'vhs-rendition-enabled'});_this3.tech_.trigger({type:'usage',name:'hls-rendition-enabled'});});}/**
   * Given an updated media playlist (whether it was loaded for the first time, or
   * refreshed for live playlists), update any relevant properties and state to reflect
   * changes in the media that should be accounted for (e.g., cues and duration).
   *
   * @param {Object} updatedPlaylist the updated media playlist object
   *
   * @private
   */;_proto.handleUpdatedMediaPlaylist=function handleUpdatedMediaPlaylist(updatedPlaylist){if(this.useCueTags_){this.updateAdCues_(updatedPlaylist);}// TODO: Create a new event on the PlaylistLoader that signals
// that the segments have changed in some way and use that to
// update the SegmentLoader instead of doing it twice here and
// on `mediachange`
this.mainSegmentLoader_.playlist(updatedPlaylist,this.requestOptions_);this.updateDuration(!updatedPlaylist.endList);// If the player isn't paused, ensure that the segment loader is running,
// as it is possible that it was temporarily stopped while waiting for
// a playlist (e.g., in case the playlist errored and we re-requested it).
if(!this.tech_.paused()){this.mainSegmentLoader_.load();if(this.audioSegmentLoader_){this.audioSegmentLoader_.load();}}}/**
   * A helper function for triggerring presence usage events once per source
   *
   * @private
   */;_proto.triggerPresenceUsage_=function triggerPresenceUsage_(master,media){var mediaGroups=master.mediaGroups||{};var defaultDemuxed=true;var audioGroupKeys=Object.keys(mediaGroups.AUDIO);for(var mediaGroup in mediaGroups.AUDIO){for(var label in mediaGroups.AUDIO[mediaGroup]){var properties=mediaGroups.AUDIO[mediaGroup][label];if(!properties.uri){defaultDemuxed=false;}}}if(defaultDemuxed){this.tech_.trigger({type:'usage',name:'vhs-demuxed'});this.tech_.trigger({type:'usage',name:'hls-demuxed'});}if(Object.keys(mediaGroups.SUBTITLES).length){this.tech_.trigger({type:'usage',name:'vhs-webvtt'});this.tech_.trigger({type:'usage',name:'hls-webvtt'});}if(Vhs$1.Playlist.isAes(media)){this.tech_.trigger({type:'usage',name:'vhs-aes'});this.tech_.trigger({type:'usage',name:'hls-aes'});}if(audioGroupKeys.length&&Object.keys(mediaGroups.AUDIO[audioGroupKeys[0]]).length>1){this.tech_.trigger({type:'usage',name:'vhs-alternate-audio'});this.tech_.trigger({type:'usage',name:'hls-alternate-audio'});}if(this.useCueTags_){this.tech_.trigger({type:'usage',name:'vhs-playlist-cue-tags'});this.tech_.trigger({type:'usage',name:'hls-playlist-cue-tags'});}};_proto.shouldSwitchToMedia_=function shouldSwitchToMedia_(nextPlaylist){var currentPlaylist=this.masterPlaylistLoader_.media()||this.masterPlaylistLoader_.pendingMedia_;var currentTime=this.tech_.currentTime();var bufferLowWaterLine=this.bufferLowWaterLine();var bufferHighWaterLine=this.bufferHighWaterLine();var buffered=this.tech_.buffered();return shouldSwitchToMedia({buffered:buffered,currentTime:currentTime,currentPlaylist:currentPlaylist,nextPlaylist:nextPlaylist,bufferLowWaterLine:bufferLowWaterLine,bufferHighWaterLine:bufferHighWaterLine,duration:this.duration(),experimentalBufferBasedABR:this.experimentalBufferBasedABR,log:this.logger_});}/**
   * Register event handlers on the segment loaders. A helper function
   * for construction time.
   *
   * @private
   */;_proto.setupSegmentLoaderListeners_=function setupSegmentLoaderListeners_(){var _this4=this;this.mainSegmentLoader_.on('bandwidthupdate',function(){// Whether or not buffer based ABR or another ABR is used, on a bandwidth change it's
// useful to check to see if a rendition switch should be made.
_this4.checkABR_('bandwidthupdate');_this4.tech_.trigger('bandwidthupdate');});this.mainSegmentLoader_.on('timeout',function(){if(_this4.experimentalBufferBasedABR){// If a rendition change is needed, then it would've be done on `bandwidthupdate`.
// Here the only consideration is that for buffer based ABR there's no guarantee
// of an immediate switch (since the bandwidth is averaged with a timeout
// bandwidth value of 1), so force a load on the segment loader to keep it going.
_this4.mainSegmentLoader_.load();}});// `progress` events are not reliable enough of a bandwidth measure to trigger buffer
// based ABR.
if(!this.experimentalBufferBasedABR){this.mainSegmentLoader_.on('progress',function(){_this4.trigger('progress');});}this.mainSegmentLoader_.on('error',function(){_this4.blacklistCurrentPlaylist(_this4.mainSegmentLoader_.error());});this.mainSegmentLoader_.on('appenderror',function(){_this4.error=_this4.mainSegmentLoader_.error_;_this4.trigger('error');});this.mainSegmentLoader_.on('syncinfoupdate',function(){_this4.onSyncInfoUpdate_();});this.mainSegmentLoader_.on('timestampoffset',function(){_this4.tech_.trigger({type:'usage',name:'vhs-timestamp-offset'});_this4.tech_.trigger({type:'usage',name:'hls-timestamp-offset'});});this.audioSegmentLoader_.on('syncinfoupdate',function(){_this4.onSyncInfoUpdate_();});this.audioSegmentLoader_.on('appenderror',function(){_this4.error=_this4.audioSegmentLoader_.error_;_this4.trigger('error');});this.mainSegmentLoader_.on('ended',function(){_this4.logger_('main segment loader ended');_this4.onEndOfStream();});this.mainSegmentLoader_.on('earlyabort',function(event){// never try to early abort with the new ABR algorithm
if(_this4.experimentalBufferBasedABR){return;}_this4.delegateLoaders_('all',['abort']);_this4.blacklistCurrentPlaylist({message:'Aborted early because there isn\'t enough bandwidth to complete the '+'request without rebuffering.'},ABORT_EARLY_BLACKLIST_SECONDS);});var updateCodecs=function updateCodecs(){if(!_this4.sourceUpdater_.hasCreatedSourceBuffers()){return _this4.tryToCreateSourceBuffers_();}var codecs=_this4.getCodecsOrExclude_();// no codecs means that the playlist was excluded
if(!codecs){return;}_this4.sourceUpdater_.addOrChangeSourceBuffers(codecs);};this.mainSegmentLoader_.on('trackinfo',updateCodecs);this.audioSegmentLoader_.on('trackinfo',updateCodecs);this.mainSegmentLoader_.on('fmp4',function(){if(!_this4.triggeredFmp4Usage){_this4.tech_.trigger({type:'usage',name:'vhs-fmp4'});_this4.tech_.trigger({type:'usage',name:'hls-fmp4'});_this4.triggeredFmp4Usage=true;}});this.audioSegmentLoader_.on('fmp4',function(){if(!_this4.triggeredFmp4Usage){_this4.tech_.trigger({type:'usage',name:'vhs-fmp4'});_this4.tech_.trigger({type:'usage',name:'hls-fmp4'});_this4.triggeredFmp4Usage=true;}});this.audioSegmentLoader_.on('ended',function(){_this4.logger_('audioSegmentLoader ended');_this4.onEndOfStream();});};_proto.mediaSecondsLoaded_=function mediaSecondsLoaded_(){return Math.max(this.audioSegmentLoader_.mediaSecondsLoaded+this.mainSegmentLoader_.mediaSecondsLoaded);}/**
   * Call load on our SegmentLoaders
   */;_proto.load=function load(){this.mainSegmentLoader_.load();if(this.mediaTypes_.AUDIO.activePlaylistLoader){this.audioSegmentLoader_.load();}if(this.mediaTypes_.SUBTITLES.activePlaylistLoader){this.subtitleSegmentLoader_.load();}}/**
   * Re-tune playback quality level for the current player
   * conditions without performing destructive actions, like
   * removing already buffered content
   *
   * @private
   * @deprecated
   */;_proto.smoothQualityChange_=function smoothQualityChange_(media){if(media===void 0){media=this.selectPlaylist();}this.fastQualityChange_(media);}/**
   * Re-tune playback quality level for the current player
   * conditions. This method will perform destructive actions like removing
   * already buffered content in order to readjust the currently active
   * playlist quickly. This is good for manual quality changes
   *
   * @private
   */;_proto.fastQualityChange_=function fastQualityChange_(media){var _this5=this;if(media===void 0){media=this.selectPlaylist();}if(media===this.masterPlaylistLoader_.media()){this.logger_('skipping fastQualityChange because new media is same as old');return;}this.switchMedia_(media,'fast-quality');// Delete all buffered data to allow an immediate quality switch, then seek to give
// the browser a kick to remove any cached frames from the previous rendtion (.04 seconds
// ahead is roughly the minimum that will accomplish this across a variety of content
// in IE and Edge, but seeking in place is sufficient on all other browsers)
// Edge/IE bug: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/14600375/
// Chrome bug: https://bugs.chromium.org/p/chromium/issues/detail?id=651904
this.mainSegmentLoader_.resetEverything(function(){// Since this is not a typical seek, we avoid the seekTo method which can cause segments
// from the previously enabled rendition to load before the new playlist has finished loading
if(videojs.browser.IE_VERSION||videojs.browser.IS_EDGE){_this5.tech_.setCurrentTime(_this5.tech_.currentTime()+0.04);}else{_this5.tech_.setCurrentTime(_this5.tech_.currentTime());}});// don't need to reset audio as it is reset when media changes
}/**
   * Begin playback.
   */;_proto.play=function play(){if(this.setupFirstPlay()){return;}if(this.tech_.ended()){this.tech_.setCurrentTime(0);}if(this.hasPlayed_){this.load();}var seekable=this.tech_.seekable();// if the viewer has paused and we fell out of the live window,
// seek forward to the live point
if(this.tech_.duration()===Infinity){if(this.tech_.currentTime()<seekable.start(0)){return this.tech_.setCurrentTime(seekable.end(seekable.length-1));}}}/**
   * Seek to the latest media position if this is a live video and the
   * player and video are loaded and initialized.
   */;_proto.setupFirstPlay=function setupFirstPlay(){var _this6=this;var media=this.masterPlaylistLoader_.media();// Check that everything is ready to begin buffering for the first call to play
//  If 1) there is no active media
//     2) the player is paused
//     3) the first play has already been setup
// then exit early
if(!media||this.tech_.paused()||this.hasPlayed_){return false;}// when the video is a live stream
if(!media.endList){var seekable=this.seekable();if(!seekable.length){// without a seekable range, the player cannot seek to begin buffering at the live
// point
return false;}if(videojs.browser.IE_VERSION&&this.tech_.readyState()===0){// IE11 throws an InvalidStateError if you try to set currentTime while the
// readyState is 0, so it must be delayed until the tech fires loadedmetadata.
this.tech_.one('loadedmetadata',function(){_this6.trigger('firstplay');_this6.tech_.setCurrentTime(seekable.end(0));_this6.hasPlayed_=true;});return false;}// trigger firstplay to inform the source handler to ignore the next seek event
this.trigger('firstplay');// seek to the live point
this.tech_.setCurrentTime(seekable.end(0));}this.hasPlayed_=true;// we can begin loading now that everything is ready
this.load();return true;}/**
   * handle the sourceopen event on the MediaSource
   *
   * @private
   */;_proto.handleSourceOpen_=function handleSourceOpen_(){// Only attempt to create the source buffer if none already exist.
// handleSourceOpen is also called when we are "re-opening" a source buffer
// after `endOfStream` has been called (in response to a seek for instance)
this.tryToCreateSourceBuffers_();// if autoplay is enabled, begin playback. This is duplicative of
// code in video.js but is required because play() must be invoked
// *after* the media source has opened.
if(this.tech_.autoplay()){var playPromise=this.tech_.play();// Catch/silence error when a pause interrupts a play request
// on browsers which return a promise
if(typeof playPromise!=='undefined'&&typeof playPromise.then==='function'){playPromise.then(null,function(e){});}}this.trigger('sourceopen');}/**
   * handle the sourceended event on the MediaSource
   *
   * @private
   */;_proto.handleSourceEnded_=function handleSourceEnded_(){if(!this.inbandTextTracks_.metadataTrack_){return;}var cues=this.inbandTextTracks_.metadataTrack_.cues;if(!cues||!cues.length){return;}var duration=this.duration();cues[cues.length-1].endTime=isNaN(duration)||Math.abs(duration)===Infinity?Number.MAX_VALUE:duration;}/**
   * handle the durationchange event on the MediaSource
   *
   * @private
   */;_proto.handleDurationChange_=function handleDurationChange_(){this.tech_.trigger('durationchange');}/**
   * Calls endOfStream on the media source when all active stream types have called
   * endOfStream
   *
   * @param {string} streamType
   *        Stream type of the segment loader that called endOfStream
   * @private
   */;_proto.onEndOfStream=function onEndOfStream(){var isEndOfStream=this.mainSegmentLoader_.ended_;if(this.mediaTypes_.AUDIO.activePlaylistLoader){var mainMediaInfo=this.mainSegmentLoader_.getCurrentMediaInfo_();// if the audio playlist loader exists, then alternate audio is active
if(!mainMediaInfo||mainMediaInfo.hasVideo){// if we do not know if the main segment loader contains video yet or if we
// definitively know the main segment loader contains video, then we need to wait
// for both main and audio segment loaders to call endOfStream
isEndOfStream=isEndOfStream&&this.audioSegmentLoader_.ended_;}else{// otherwise just rely on the audio loader
isEndOfStream=this.audioSegmentLoader_.ended_;}}if(!isEndOfStream){return;}this.stopABRTimer_();this.sourceUpdater_.endOfStream();}/**
   * Check if a playlist has stopped being updated
   *
   * @param {Object} playlist the media playlist object
   * @return {boolean} whether the playlist has stopped being updated or not
   */;_proto.stuckAtPlaylistEnd_=function stuckAtPlaylistEnd_(playlist){var seekable=this.seekable();if(!seekable.length){// playlist doesn't have enough information to determine whether we are stuck
return false;}var expired=this.syncController_.getExpiredTime(playlist,this.duration());if(expired===null){return false;}// does not use the safe live end to calculate playlist end, since we
// don't want to say we are stuck while there is still content
var absolutePlaylistEnd=Vhs$1.Playlist.playlistEnd(playlist,expired);var currentTime=this.tech_.currentTime();var buffered=this.tech_.buffered();if(!buffered.length){// return true if the playhead reached the absolute end of the playlist
return absolutePlaylistEnd-currentTime<=SAFE_TIME_DELTA;}var bufferedEnd=buffered.end(buffered.length-1);// return true if there is too little buffer left and buffer has reached absolute
// end of playlist
return bufferedEnd-currentTime<=SAFE_TIME_DELTA&&absolutePlaylistEnd-bufferedEnd<=SAFE_TIME_DELTA;}/**
   * Blacklists a playlist when an error occurs for a set amount of time
   * making it unavailable for selection by the rendition selection algorithm
   * and then forces a new playlist (rendition) selection.
   *
   * @param {Object=} error an optional error that may include the playlist
   * to blacklist
   * @param {number=} blacklistDuration an optional number of seconds to blacklist the
   * playlist
   */;_proto.blacklistCurrentPlaylist=function blacklistCurrentPlaylist(error,blacklistDuration){if(error===void 0){error={};}// If the `error` was generated by the playlist loader, it will contain
// the playlist we were trying to load (but failed) and that should be
// blacklisted instead of the currently selected playlist which is likely
// out-of-date in this scenario
var currentPlaylist=error.playlist||this.masterPlaylistLoader_.media();blacklistDuration=blacklistDuration||error.blacklistDuration||this.blacklistDuration;// If there is no current playlist, then an error occurred while we were
// trying to load the master OR while we were disposing of the tech
if(!currentPlaylist){this.error=error;if(this.mediaSource.readyState!=='open'){this.trigger('error');}else{this.sourceUpdater_.endOfStream('network');}return;}currentPlaylist.playlistErrors_++;var playlists=this.masterPlaylistLoader_.master.playlists;var enabledPlaylists=playlists.filter(isEnabled);var isFinalRendition=enabledPlaylists.length===1&&enabledPlaylists[0]===currentPlaylist;// Don't blacklist the only playlist unless it was blacklisted
// forever
if(playlists.length===1&&blacklistDuration!==Infinity){videojs.log.warn("Problem encountered with playlist "+currentPlaylist.id+". "+'Trying again since it is the only playlist.');this.tech_.trigger('retryplaylist');// if this is a final rendition, we should delay
return this.masterPlaylistLoader_.load(isFinalRendition);}if(isFinalRendition){// Since we're on the final non-blacklisted playlist, and we're about to blacklist
// it, instead of erring the player or retrying this playlist, clear out the current
// blacklist. This allows other playlists to be attempted in case any have been
// fixed.
var reincluded=false;playlists.forEach(function(playlist){// skip current playlist which is about to be blacklisted
if(playlist===currentPlaylist){return;}var excludeUntil=playlist.excludeUntil;// a playlist cannot be reincluded if it wasn't excluded to begin with.
if(typeof excludeUntil!=='undefined'&&excludeUntil!==Infinity){reincluded=true;delete playlist.excludeUntil;}});if(reincluded){videojs.log.warn('Removing other playlists from the exclusion list because the last '+'rendition is about to be excluded.');// Technically we are retrying a playlist, in that we are simply retrying a previous
// playlist. This is needed for users relying on the retryplaylist event to catch a
// case where the player might be stuck and looping through "dead" playlists.
this.tech_.trigger('retryplaylist');}}// Blacklist this playlist
var excludeUntil;if(currentPlaylist.playlistErrors_>this.maxPlaylistRetries){excludeUntil=Infinity;}else{excludeUntil=Date.now()+blacklistDuration*1000;}currentPlaylist.excludeUntil=excludeUntil;if(error.reason){currentPlaylist.lastExcludeReason_=error.reason;}this.tech_.trigger('blacklistplaylist');this.tech_.trigger({type:'usage',name:'vhs-rendition-blacklisted'});this.tech_.trigger({type:'usage',name:'hls-rendition-blacklisted'});// TODO: should we select a new playlist if this blacklist wasn't for the currentPlaylist?
// Would be something like media().id !=== currentPlaylist.id and we  would need something
// like `pendingMedia` in playlist loaders to check against that too. This will prevent us
// from loading a new playlist on any blacklist.
// Select a new playlist
var nextPlaylist=this.selectPlaylist();if(!nextPlaylist){this.error='Playback cannot continue. No available working or supported playlists.';this.trigger('error');return;}var logFn=error.internal?this.logger_:videojs.log.warn;var errorMessage=error.message?' '+error.message:'';logFn((error.internal?'Internal problem':'Problem')+" encountered with playlist "+currentPlaylist.id+"."+(errorMessage+" Switching to playlist "+nextPlaylist.id+"."));// if audio group changed reset audio loaders
if(nextPlaylist.attributes.AUDIO!==currentPlaylist.attributes.AUDIO){this.delegateLoaders_('audio',['abort','pause']);}// if subtitle group changed reset subtitle loaders
if(nextPlaylist.attributes.SUBTITLES!==currentPlaylist.attributes.SUBTITLES){this.delegateLoaders_('subtitle',['abort','pause']);}this.delegateLoaders_('main',['abort','pause']);var delayDuration=nextPlaylist.targetDuration/2*1000||5*1000;var shouldDelay=typeof nextPlaylist.lastRequest==='number'&&Date.now()-nextPlaylist.lastRequest<=delayDuration;// delay if it's a final rendition or if the last refresh is sooner than half targetDuration
return this.switchMedia_(nextPlaylist,'exclude',isFinalRendition||shouldDelay);}/**
   * Pause all segment/playlist loaders
   */;_proto.pauseLoading=function pauseLoading(){this.delegateLoaders_('all',['abort','pause']);this.stopABRTimer_();}/**
   * Call a set of functions in order on playlist loaders, segment loaders,
   * or both types of loaders.
   *
   * @param {string} filter
   *        Filter loaders that should call fnNames using a string. Can be:
   *        * all - run on all loaders
   *        * audio - run on all audio loaders
   *        * subtitle - run on all subtitle loaders
   *        * main - run on the main/master loaders
   *
   * @param {Array|string} fnNames
   *        A string or array of function names to call.
   */;_proto.delegateLoaders_=function delegateLoaders_(filter,fnNames){var _this7=this;var loaders=[];var dontFilterPlaylist=filter==='all';if(dontFilterPlaylist||filter==='main'){loaders.push(this.masterPlaylistLoader_);}var mediaTypes=[];if(dontFilterPlaylist||filter==='audio'){mediaTypes.push('AUDIO');}if(dontFilterPlaylist||filter==='subtitle'){mediaTypes.push('CLOSED-CAPTIONS');mediaTypes.push('SUBTITLES');}mediaTypes.forEach(function(mediaType){var loader=_this7.mediaTypes_[mediaType]&&_this7.mediaTypes_[mediaType].activePlaylistLoader;if(loader){loaders.push(loader);}});['main','audio','subtitle'].forEach(function(name){var loader=_this7[name+"SegmentLoader_"];if(loader&&(filter===name||filter==='all')){loaders.push(loader);}});loaders.forEach(function(loader){return fnNames.forEach(function(fnName){if(typeof loader[fnName]==='function'){loader[fnName]();}});});}/**
   * set the current time on all segment loaders
   *
   * @param {TimeRange} currentTime the current time to set
   * @return {TimeRange} the current time
   */;_proto.setCurrentTime=function setCurrentTime(currentTime){var buffered=findRange(this.tech_.buffered(),currentTime);if(!(this.masterPlaylistLoader_&&this.masterPlaylistLoader_.media())){// return immediately if the metadata is not ready yet
return 0;}// it's clearly an edge-case but don't thrown an error if asked to
// seek within an empty playlist
if(!this.masterPlaylistLoader_.media().segments){return 0;}// if the seek location is already buffered, continue buffering as usual
if(buffered&&buffered.length){return currentTime;}// cancel outstanding requests so we begin buffering at the new
// location
this.mainSegmentLoader_.resetEverything();this.mainSegmentLoader_.abort();if(this.mediaTypes_.AUDIO.activePlaylistLoader){this.audioSegmentLoader_.resetEverything();this.audioSegmentLoader_.abort();}if(this.mediaTypes_.SUBTITLES.activePlaylistLoader){this.subtitleSegmentLoader_.resetEverything();this.subtitleSegmentLoader_.abort();}// start segment loader loading in case they are paused
this.load();}/**
   * get the current duration
   *
   * @return {TimeRange} the duration
   */;_proto.duration=function duration(){if(!this.masterPlaylistLoader_){return 0;}var media=this.masterPlaylistLoader_.media();if(!media){// no playlists loaded yet, so can't determine a duration
return 0;}// Don't rely on the media source for duration in the case of a live playlist since
// setting the native MediaSource's duration to infinity ends up with consequences to
// seekable behavior. See https://github.com/w3c/media-source/issues/5 for details.
//
// This is resolved in the spec by https://github.com/w3c/media-source/pull/92,
// however, few browsers have support for setLiveSeekableRange()
// https://developer.mozilla.org/en-US/docs/Web/API/MediaSource/setLiveSeekableRange
//
// Until a time when the duration of the media source can be set to infinity, and a
// seekable range specified across browsers, just return Infinity.
if(!media.endList){return Infinity;}// Since this is a VOD video, it is safe to rely on the media source's duration (if
// available). If it's not available, fall back to a playlist-calculated estimate.
if(this.mediaSource){return this.mediaSource.duration;}return Vhs$1.Playlist.duration(media);}/**
   * check the seekable range
   *
   * @return {TimeRange} the seekable range
   */;_proto.seekable=function seekable(){return this.seekable_;};_proto.onSyncInfoUpdate_=function onSyncInfoUpdate_(){var audioSeekable;// TODO check for creation of both source buffers before updating seekable
//
// A fix was made to this function where a check for
// this.sourceUpdater_.hasCreatedSourceBuffers
// was added to ensure that both source buffers were created before seekable was
// updated. However, it originally had a bug where it was checking for a true and
// returning early instead of checking for false. Setting it to check for false to
// return early though created other issues. A call to play() would check for seekable
// end without verifying that a seekable range was present. In addition, even checking
// for that didn't solve some issues, as handleFirstPlay is sometimes worked around
// due to a media update calling load on the segment loaders, skipping a seek to live,
// thereby starting live streams at the beginning of the stream rather than at the end.
//
// This conditional should be fixed to wait for the creation of two source buffers at
// the same time as the other sections of code are fixed to properly seek to live and
// not throw an error due to checking for a seekable end when no seekable range exists.
//
// For now, fall back to the older behavior, with the understanding that the seekable
// range may not be completely correct, leading to a suboptimal initial live point.
if(!this.masterPlaylistLoader_){return;}var media=this.masterPlaylistLoader_.media();if(!media){return;}var expired=this.syncController_.getExpiredTime(media,this.duration());if(expired===null){// not enough information to update seekable
return;}var master=this.masterPlaylistLoader_.master;var mainSeekable=Vhs$1.Playlist.seekable(media,expired,Vhs$1.Playlist.liveEdgeDelay(master,media));if(mainSeekable.length===0){return;}if(this.mediaTypes_.AUDIO.activePlaylistLoader){media=this.mediaTypes_.AUDIO.activePlaylistLoader.media();expired=this.syncController_.getExpiredTime(media,this.duration());if(expired===null){return;}audioSeekable=Vhs$1.Playlist.seekable(media,expired,Vhs$1.Playlist.liveEdgeDelay(master,media));if(audioSeekable.length===0){return;}}var oldEnd;var oldStart;if(this.seekable_&&this.seekable_.length){oldEnd=this.seekable_.end(0);oldStart=this.seekable_.start(0);}if(!audioSeekable){// seekable has been calculated based on buffering video data so it
// can be returned directly
this.seekable_=mainSeekable;}else if(audioSeekable.start(0)>mainSeekable.end(0)||mainSeekable.start(0)>audioSeekable.end(0)){// seekables are pretty far off, rely on main
this.seekable_=mainSeekable;}else{this.seekable_=videojs.createTimeRanges([[audioSeekable.start(0)>mainSeekable.start(0)?audioSeekable.start(0):mainSeekable.start(0),audioSeekable.end(0)<mainSeekable.end(0)?audioSeekable.end(0):mainSeekable.end(0)]]);}// seekable is the same as last time
if(this.seekable_&&this.seekable_.length){if(this.seekable_.end(0)===oldEnd&&this.seekable_.start(0)===oldStart){return;}}this.logger_("seekable updated ["+printableRange(this.seekable_)+"]");this.tech_.trigger('seekablechanged');}/**
   * Update the player duration
   */;_proto.updateDuration=function updateDuration(isLive){if(this.updateDuration_){this.mediaSource.removeEventListener('sourceopen',this.updateDuration_);this.updateDuration_=null;}if(this.mediaSource.readyState!=='open'){this.updateDuration_=this.updateDuration.bind(this,isLive);this.mediaSource.addEventListener('sourceopen',this.updateDuration_);return;}if(isLive){var seekable=this.seekable();if(!seekable.length){return;}// Even in the case of a live playlist, the native MediaSource's duration should not
// be set to Infinity (even though this would be expected for a live playlist), since
// setting the native MediaSource's duration to infinity ends up with consequences to
// seekable behavior. See https://github.com/w3c/media-source/issues/5 for details.
//
// This is resolved in the spec by https://github.com/w3c/media-source/pull/92,
// however, few browsers have support for setLiveSeekableRange()
// https://developer.mozilla.org/en-US/docs/Web/API/MediaSource/setLiveSeekableRange
//
// Until a time when the duration of the media source can be set to infinity, and a
// seekable range specified across browsers, the duration should be greater than or
// equal to the last possible seekable value.
// MediaSource duration starts as NaN
// It is possible (and probable) that this case will never be reached for many
// sources, since the MediaSource reports duration as the highest value without
// accounting for timestamp offset. For example, if the timestamp offset is -100 and
// we buffered times 0 to 100 with real times of 100 to 200, even though current
// time will be between 0 and 100, the native media source may report the duration
// as 200. However, since we report duration separate from the media source (as
// Infinity), and as long as the native media source duration value is greater than
// our reported seekable range, seeks will work as expected. The large number as
// duration for live is actually a strategy used by some players to work around the
// issue of live seekable ranges cited above.
if(isNaN(this.mediaSource.duration)||this.mediaSource.duration<seekable.end(seekable.length-1)){this.sourceUpdater_.setDuration(seekable.end(seekable.length-1));}return;}var buffered=this.tech_.buffered();var duration=Vhs$1.Playlist.duration(this.masterPlaylistLoader_.media());if(buffered.length>0){duration=Math.max(duration,buffered.end(buffered.length-1));}if(this.mediaSource.duration!==duration){this.sourceUpdater_.setDuration(duration);}}/**
   * dispose of the MasterPlaylistController and everything
   * that it controls
   */;_proto.dispose=function dispose(){var _this8=this;this.trigger('dispose');this.decrypter_.terminate();this.masterPlaylistLoader_.dispose();this.mainSegmentLoader_.dispose();if(this.loadOnPlay_){this.tech_.off('play',this.loadOnPlay_);}['AUDIO','SUBTITLES'].forEach(function(type){var groups=_this8.mediaTypes_[type].groups;for(var id in groups){groups[id].forEach(function(group){if(group.playlistLoader){group.playlistLoader.dispose();}});}});this.audioSegmentLoader_.dispose();this.subtitleSegmentLoader_.dispose();this.sourceUpdater_.dispose();this.timelineChangeController_.dispose();this.stopABRTimer_();if(this.updateDuration_){this.mediaSource.removeEventListener('sourceopen',this.updateDuration_);}this.mediaSource.removeEventListener('durationchange',this.handleDurationChange_);// load the media source into the player
this.mediaSource.removeEventListener('sourceopen',this.handleSourceOpen_);this.mediaSource.removeEventListener('sourceended',this.handleSourceEnded_);this.off();}/**
   * return the master playlist object if we have one
   *
   * @return {Object} the master playlist object that we parsed
   */;_proto.master=function master(){return this.masterPlaylistLoader_.master;}/**
   * return the currently selected playlist
   *
   * @return {Object} the currently selected playlist object that we parsed
   */;_proto.media=function media(){// playlist loader will not return media if it has not been fully loaded
return this.masterPlaylistLoader_.media()||this.initialMedia_;};_proto.areMediaTypesKnown_=function areMediaTypesKnown_(){var usingAudioLoader=!!this.mediaTypes_.AUDIO.activePlaylistLoader;var hasMainMediaInfo=!!this.mainSegmentLoader_.getCurrentMediaInfo_();// if we are not using an audio loader, then we have audio media info
// otherwise check on the segment loader.
var hasAudioMediaInfo=!usingAudioLoader?true:!!this.audioSegmentLoader_.getCurrentMediaInfo_();// one or both loaders has not loaded sufficently to get codecs
if(!hasMainMediaInfo||!hasAudioMediaInfo){return false;}return true;};_proto.getCodecsOrExclude_=function getCodecsOrExclude_(){var _this9=this;var media={main:this.mainSegmentLoader_.getCurrentMediaInfo_()||{},audio:this.audioSegmentLoader_.getCurrentMediaInfo_()||{}};var playlist=this.mainSegmentLoader_.getPendingSegmentPlaylist()||this.media();// set "main" media equal to video
media.video=media.main;var playlistCodecs=codecsForPlaylist(this.master(),playlist);var codecs={};var usingAudioLoader=!!this.mediaTypes_.AUDIO.activePlaylistLoader;if(media.main.hasVideo){codecs.video=playlistCodecs.video||media.main.videoCodec||DEFAULT_VIDEO_CODEC;}if(media.main.isMuxed){codecs.video+=","+(playlistCodecs.audio||media.main.audioCodec||DEFAULT_AUDIO_CODEC);}if(media.main.hasAudio&&!media.main.isMuxed||media.audio.hasAudio||usingAudioLoader){codecs.audio=playlistCodecs.audio||media.main.audioCodec||media.audio.audioCodec||DEFAULT_AUDIO_CODEC;// set audio isFmp4 so we use the correct "supports" function below
media.audio.isFmp4=media.main.hasAudio&&!media.main.isMuxed?media.main.isFmp4:media.audio.isFmp4;}// no codecs, no playback.
if(!codecs.audio&&!codecs.video){this.blacklistCurrentPlaylist({playlist:playlist,message:'Could not determine codecs for playlist.',blacklistDuration:Infinity});return;}// fmp4 relies on browser support, while ts relies on muxer support
var supportFunction=function supportFunction(isFmp4,codec){return isFmp4?browserSupportsCodec(codec):muxerSupportsCodec(codec);};var unsupportedCodecs={};var unsupportedAudio;['video','audio'].forEach(function(type){if(codecs.hasOwnProperty(type)&&!supportFunction(media[type].isFmp4,codecs[type])){var supporter=media[type].isFmp4?'browser':'muxer';unsupportedCodecs[supporter]=unsupportedCodecs[supporter]||[];unsupportedCodecs[supporter].push(codecs[type]);if(type==='audio'){unsupportedAudio=supporter;}}});if(usingAudioLoader&&unsupportedAudio&&playlist.attributes.AUDIO){var audioGroup=playlist.attributes.AUDIO;this.master().playlists.forEach(function(variant){var variantAudioGroup=variant.attributes&&variant.attributes.AUDIO;if(variantAudioGroup===audioGroup&&variant!==playlist){variant.excludeUntil=Infinity;}});this.logger_("excluding audio group "+audioGroup+" as "+unsupportedAudio+" does not support codec(s): \""+codecs.audio+"\"");}// if we have any unsupported codecs blacklist this playlist.
if(Object.keys(unsupportedCodecs).length){var message=Object.keys(unsupportedCodecs).reduce(function(acc,supporter){if(acc){acc+=', ';}acc+=supporter+" does not support codec(s): \""+unsupportedCodecs[supporter].join(',')+"\"";return acc;},'')+'.';this.blacklistCurrentPlaylist({playlist:playlist,internal:true,message:message,blacklistDuration:Infinity});return;}// check if codec switching is happening
if(this.sourceUpdater_.hasCreatedSourceBuffers()&&!this.sourceUpdater_.canChangeType()){var switchMessages=[];['video','audio'].forEach(function(type){var newCodec=(parseCodecs(_this9.sourceUpdater_.codecs[type]||'')[0]||{}).type;var oldCodec=(parseCodecs(codecs[type]||'')[0]||{}).type;if(newCodec&&oldCodec&&newCodec.toLowerCase()!==oldCodec.toLowerCase()){switchMessages.push("\""+_this9.sourceUpdater_.codecs[type]+"\" -> \""+codecs[type]+"\"");}});if(switchMessages.length){this.blacklistCurrentPlaylist({playlist:playlist,message:"Codec switching not supported: "+switchMessages.join(', ')+".",blacklistDuration:Infinity,internal:true});return;}}// TODO: when using the muxer shouldn't we just return
// the codecs that the muxer outputs?
return codecs;}/**
   * Create source buffers and exlude any incompatible renditions.
   *
   * @private
   */;_proto.tryToCreateSourceBuffers_=function tryToCreateSourceBuffers_(){// media source is not ready yet or sourceBuffers are already
// created.
if(this.mediaSource.readyState!=='open'||this.sourceUpdater_.hasCreatedSourceBuffers()){return;}if(!this.areMediaTypesKnown_()){return;}var codecs=this.getCodecsOrExclude_();// no codecs means that the playlist was excluded
if(!codecs){return;}this.sourceUpdater_.createSourceBuffers(codecs);var codecString=[codecs.video,codecs.audio].filter(Boolean).join(',');this.excludeIncompatibleVariants_(codecString);}/**
   * Excludes playlists with codecs that are unsupported by the muxer and browser.
   */;_proto.excludeUnsupportedVariants_=function excludeUnsupportedVariants_(){var _this10=this;var playlists=this.master().playlists;var ids=[];// TODO: why don't we have a property to loop through all
// playlist? Why did we ever mix indexes and keys?
Object.keys(playlists).forEach(function(key){var variant=playlists[key];// check if we already processed this playlist.
if(ids.indexOf(variant.id)!==-1){return;}ids.push(variant.id);var codecs=codecsForPlaylist(_this10.master,variant);var unsupported=[];if(codecs.audio&&!muxerSupportsCodec(codecs.audio)&&!browserSupportsCodec(codecs.audio)){unsupported.push("audio codec "+codecs.audio);}if(codecs.video&&!muxerSupportsCodec(codecs.video)&&!browserSupportsCodec(codecs.video)){unsupported.push("video codec "+codecs.video);}if(codecs.text&&codecs.text==='stpp.ttml.im1t'){unsupported.push("text codec "+codecs.text);}if(unsupported.length){variant.excludeUntil=Infinity;_this10.logger_("excluding "+variant.id+" for unsupported: "+unsupported.join(', '));}});}/**
   * Blacklist playlists that are known to be codec or
   * stream-incompatible with the SourceBuffer configuration. For
   * instance, Media Source Extensions would cause the video element to
   * stall waiting for video data if you switched from a variant with
   * video and audio to an audio-only one.
   *
   * @param {Object} media a media playlist compatible with the current
   * set of SourceBuffers. Variants in the current master playlist that
   * do not appear to have compatible codec or stream configurations
   * will be excluded from the default playlist selection algorithm
   * indefinitely.
   * @private
   */;_proto.excludeIncompatibleVariants_=function excludeIncompatibleVariants_(codecString){var _this11=this;var ids=[];var playlists=this.master().playlists;var codecs=unwrapCodecList(parseCodecs(codecString));var codecCount_=codecCount(codecs);var videoDetails=codecs.video&&parseCodecs(codecs.video)[0]||null;var audioDetails=codecs.audio&&parseCodecs(codecs.audio)[0]||null;Object.keys(playlists).forEach(function(key){var variant=playlists[key];// check if we already processed this playlist.
// or it if it is already excluded forever.
if(ids.indexOf(variant.id)!==-1||variant.excludeUntil===Infinity){return;}ids.push(variant.id);var blacklistReasons=[];// get codecs from the playlist for this variant
var variantCodecs=codecsForPlaylist(_this11.masterPlaylistLoader_.master,variant);var variantCodecCount=codecCount(variantCodecs);// if no codecs are listed, we cannot determine that this
// variant is incompatible. Wait for mux.js to probe
if(!variantCodecs.audio&&!variantCodecs.video){return;}// TODO: we can support this by removing the
// old media source and creating a new one, but it will take some work.
// The number of streams cannot change
if(variantCodecCount!==codecCount_){blacklistReasons.push("codec count \""+variantCodecCount+"\" !== \""+codecCount_+"\"");}// only exclude playlists by codec change, if codecs cannot switch
// during playback.
if(!_this11.sourceUpdater_.canChangeType()){var variantVideoDetails=variantCodecs.video&&parseCodecs(variantCodecs.video)[0]||null;var variantAudioDetails=variantCodecs.audio&&parseCodecs(variantCodecs.audio)[0]||null;// the video codec cannot change
if(variantVideoDetails&&videoDetails&&variantVideoDetails.type.toLowerCase()!==videoDetails.type.toLowerCase()){blacklistReasons.push("video codec \""+variantVideoDetails.type+"\" !== \""+videoDetails.type+"\"");}// the audio codec cannot change
if(variantAudioDetails&&audioDetails&&variantAudioDetails.type.toLowerCase()!==audioDetails.type.toLowerCase()){blacklistReasons.push("audio codec \""+variantAudioDetails.type+"\" !== \""+audioDetails.type+"\"");}}if(blacklistReasons.length){variant.excludeUntil=Infinity;_this11.logger_("blacklisting "+variant.id+": "+blacklistReasons.join(' && '));}});};_proto.updateAdCues_=function updateAdCues_(media){var offset=0;var seekable=this.seekable();if(seekable.length){offset=seekable.start(0);}updateAdCues(media,this.cueTagsTrack_,offset);}/**
   * Calculates the desired forward buffer length based on current time
   *
   * @return {number} Desired forward buffer length in seconds
   */;_proto.goalBufferLength=function goalBufferLength(){var currentTime=this.tech_.currentTime();var initial=Config.GOAL_BUFFER_LENGTH;var rate=Config.GOAL_BUFFER_LENGTH_RATE;var max=Math.max(initial,Config.MAX_GOAL_BUFFER_LENGTH);return Math.min(initial+currentTime*rate,max);}/**
   * Calculates the desired buffer low water line based on current time
   *
   * @return {number} Desired buffer low water line in seconds
   */;_proto.bufferLowWaterLine=function bufferLowWaterLine(){var currentTime=this.tech_.currentTime();var initial=Config.BUFFER_LOW_WATER_LINE;var rate=Config.BUFFER_LOW_WATER_LINE_RATE;var max=Math.max(initial,Config.MAX_BUFFER_LOW_WATER_LINE);var newMax=Math.max(initial,Config.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE);return Math.min(initial+currentTime*rate,this.experimentalBufferBasedABR?newMax:max);};_proto.bufferHighWaterLine=function bufferHighWaterLine(){return Config.BUFFER_HIGH_WATER_LINE;};return MasterPlaylistController;}(videojs.EventTarget);/**
 * Returns a function that acts as the Enable/disable playlist function.
 *
 * @param {PlaylistLoader} loader - The master playlist loader
 * @param {string} playlistID - id of the playlist
 * @param {Function} changePlaylistFn - A function to be called after a
 * playlist's enabled-state has been changed. Will NOT be called if a
 * playlist's enabled-state is unchanged
 * @param {boolean=} enable - Value to set the playlist enabled-state to
 * or if undefined returns the current enabled-state for the playlist
 * @return {Function} Function for setting/getting enabled
 */var enableFunction=function enableFunction(loader,playlistID,changePlaylistFn){return function(enable){var playlist=loader.master.playlists[playlistID];var incompatible=isIncompatible(playlist);var currentlyEnabled=isEnabled(playlist);if(typeof enable==='undefined'){return currentlyEnabled;}if(enable){delete playlist.disabled;}else{playlist.disabled=true;}if(enable!==currentlyEnabled&&!incompatible){// Ensure the outside world knows about our changes
changePlaylistFn();if(enable){loader.trigger('renditionenabled');}else{loader.trigger('renditiondisabled');}}return enable;};};/**
 * The representation object encapsulates the publicly visible information
 * in a media playlist along with a setter/getter-type function (enabled)
 * for changing the enabled-state of a particular playlist entry
 *
 * @class Representation
 */var Representation=function Representation(vhsHandler,playlist,id){var mpc=vhsHandler.masterPlaylistController_,smoothQualityChange=vhsHandler.options_.smoothQualityChange;// Get a reference to a bound version of the quality change function
var changeType=smoothQualityChange?'smooth':'fast';var qualityChangeFunction=mpc[changeType+"QualityChange_"].bind(mpc);// some playlist attributes are optional
if(playlist.attributes){var resolution=playlist.attributes.RESOLUTION;this.width=resolution&&resolution.width;this.height=resolution&&resolution.height;this.bandwidth=playlist.attributes.BANDWIDTH;this.frameRate=playlist.attributes['FRAME-RATE'];}this.codecs=codecsForPlaylist(mpc.master(),playlist);this.playlist=playlist;// The id is simply the ordinality of the media playlist
// within the master playlist
this.id=id;// Partially-apply the enableFunction to create a playlist-
// specific variant
this.enabled=enableFunction(vhsHandler.playlists,playlist.id,qualityChangeFunction);};/**
 * A mixin function that adds the `representations` api to an instance
 * of the VhsHandler class
 *
 * @param {VhsHandler} vhsHandler - An instance of VhsHandler to add the
 * representation API into
 */var renditionSelectionMixin=function renditionSelectionMixin(vhsHandler){// Add a single API-specific function to the VhsHandler instance
vhsHandler.representations=function(){var master=vhsHandler.masterPlaylistController_.master();var playlists=isAudioOnly(master)?vhsHandler.masterPlaylistController_.getAudioTrackPlaylists_():master.playlists;if(!playlists){return[];}return playlists.filter(function(media){return!isIncompatible(media);}).map(function(e,i){return new Representation(vhsHandler,e,e.id);});};};/**
 * @file playback-watcher.js
 *
 * Playback starts, and now my watch begins. It shall not end until my death. I shall
 * take no wait, hold no uncleared timeouts, father no bad seeks. I shall wear no crowns
 * and win no glory. I shall live and die at my post. I am the corrector of the underflow.
 * I am the watcher of gaps. I am the shield that guards the realms of seekable. I pledge
 * my life and honor to the Playback Watch, for this Player and all the Players to come.
 */var timerCancelEvents=['seeking','seeked','pause','playing','error'];/**
 * @class PlaybackWatcher
 */var PlaybackWatcher=/*#__PURE__*/function(){/**
   * Represents an PlaybackWatcher object.
   *
   * @class
   * @param {Object} options an object that includes the tech and settings
   */function PlaybackWatcher(options){var _this=this;this.masterPlaylistController_=options.masterPlaylistController;this.tech_=options.tech;this.seekable=options.seekable;this.allowSeeksWithinUnsafeLiveWindow=options.allowSeeksWithinUnsafeLiveWindow;this.liveRangeSafeTimeDelta=options.liveRangeSafeTimeDelta;this.media=options.media;this.consecutiveUpdates=0;this.lastRecordedTime=null;this.timer_=null;this.checkCurrentTimeTimeout_=null;this.logger_=logger('PlaybackWatcher');this.logger_('initialize');var playHandler=function playHandler(){return _this.monitorCurrentTime_();};var canPlayHandler=function canPlayHandler(){return _this.monitorCurrentTime_();};var waitingHandler=function waitingHandler(){return _this.techWaiting_();};var cancelTimerHandler=function cancelTimerHandler(){return _this.cancelTimer_();};var mpc=this.masterPlaylistController_;var loaderTypes=['main','subtitle','audio'];var loaderChecks={};loaderTypes.forEach(function(type){loaderChecks[type]={reset:function reset(){return _this.resetSegmentDownloads_(type);},updateend:function updateend(){return _this.checkSegmentDownloads_(type);}};mpc[type+"SegmentLoader_"].on('appendsdone',loaderChecks[type].updateend);// If a rendition switch happens during a playback stall where the buffer
// isn't changing we want to reset. We cannot assume that the new rendition
// will also be stalled, until after new appends.
mpc[type+"SegmentLoader_"].on('playlistupdate',loaderChecks[type].reset);// Playback stalls should not be detected right after seeking.
// This prevents one segment playlists (single vtt or single segment content)
// from being detected as stalling. As the buffer will not change in those cases, since
// the buffer is the entire video duration.
_this.tech_.on(['seeked','seeking'],loaderChecks[type].reset);});/**
     * We check if a seek was into a gap through the following steps:
     * 1. We get a seeking event and we do not get a seeked event. This means that
     *    a seek was attempted but not completed.
     * 2. We run `fixesBadSeeks_` on segment loader appends. This means that we already
     *    removed everything from our buffer and appended a segment, and should be ready
     *    to check for gaps.
     */var setSeekingHandlers=function setSeekingHandlers(fn){['main','audio'].forEach(function(type){mpc[type+"SegmentLoader_"][fn]('appended',_this.seekingAppendCheck_);});};this.seekingAppendCheck_=function(){if(_this.fixesBadSeeks_()){_this.consecutiveUpdates=0;_this.lastRecordedTime=_this.tech_.currentTime();setSeekingHandlers('off');}};this.clearSeekingAppendCheck_=function(){return setSeekingHandlers('off');};this.watchForBadSeeking_=function(){_this.clearSeekingAppendCheck_();setSeekingHandlers('on');};this.tech_.on('seeked',this.clearSeekingAppendCheck_);this.tech_.on('seeking',this.watchForBadSeeking_);this.tech_.on('waiting',waitingHandler);this.tech_.on(timerCancelEvents,cancelTimerHandler);this.tech_.on('canplay',canPlayHandler);/*
      An edge case exists that results in gaps not being skipped when they exist at the beginning of a stream. This case
      is surfaced in one of two ways:
       1)  The `waiting` event is fired before the player has buffered content, making it impossible
          to find or skip the gap. The `waiting` event is followed by a `play` event. On first play
          we can check if playback is stalled due to a gap, and skip the gap if necessary.
      2)  A source with a gap at the beginning of the stream is loaded programatically while the player
          is in a playing state. To catch this case, it's important that our one-time play listener is setup
          even if the player is in a playing state
    */this.tech_.one('play',playHandler);// Define the dispose function to clean up our events
this.dispose=function(){_this.clearSeekingAppendCheck_();_this.logger_('dispose');_this.tech_.off('waiting',waitingHandler);_this.tech_.off(timerCancelEvents,cancelTimerHandler);_this.tech_.off('canplay',canPlayHandler);_this.tech_.off('play',playHandler);_this.tech_.off('seeking',_this.watchForBadSeeking_);_this.tech_.off('seeked',_this.clearSeekingAppendCheck_);loaderTypes.forEach(function(type){mpc[type+"SegmentLoader_"].off('appendsdone',loaderChecks[type].updateend);mpc[type+"SegmentLoader_"].off('playlistupdate',loaderChecks[type].reset);_this.tech_.off(['seeked','seeking'],loaderChecks[type].reset);});if(_this.checkCurrentTimeTimeout_){window_default().clearTimeout(_this.checkCurrentTimeTimeout_);}_this.cancelTimer_();};}/**
   * Periodically check current time to see if playback stopped
   *
   * @private
   */var _proto=PlaybackWatcher.prototype;_proto.monitorCurrentTime_=function monitorCurrentTime_(){this.checkCurrentTime_();if(this.checkCurrentTimeTimeout_){window_default().clearTimeout(this.checkCurrentTimeTimeout_);}// 42 = 24 fps // 250 is what Webkit uses // FF uses 15
this.checkCurrentTimeTimeout_=window_default().setTimeout(this.monitorCurrentTime_.bind(this),250);}/**
   * Reset stalled download stats for a specific type of loader
   *
   * @param {string} type
   *        The segment loader type to check.
   *
   * @listens SegmentLoader#playlistupdate
   * @listens Tech#seeking
   * @listens Tech#seeked
   */;_proto.resetSegmentDownloads_=function resetSegmentDownloads_(type){var loader=this.masterPlaylistController_[type+"SegmentLoader_"];if(this[type+"StalledDownloads_"]>0){this.logger_("resetting possible stalled download count for "+type+" loader");}this[type+"StalledDownloads_"]=0;this[type+"Buffered_"]=loader.buffered_();}/**
   * Checks on every segment `appendsdone` to see
   * if segment appends are making progress. If they are not
   * and we are still downloading bytes. We blacklist the playlist.
   *
   * @param {string} type
   *        The segment loader type to check.
   *
   * @listens SegmentLoader#appendsdone
   */;_proto.checkSegmentDownloads_=function checkSegmentDownloads_(type){var mpc=this.masterPlaylistController_;var loader=mpc[type+"SegmentLoader_"];var buffered=loader.buffered_();var isBufferedDifferent=isRangeDifferent(this[type+"Buffered_"],buffered);this[type+"Buffered_"]=buffered;// if another watcher is going to fix the issue or
// the buffered value for this loader changed
// appends are working
if(isBufferedDifferent){this.resetSegmentDownloads_(type);return;}this[type+"StalledDownloads_"]++;this.logger_("found #"+this[type+"StalledDownloads_"]+" "+type+" appends that did not increase buffer (possible stalled download)",{playlistId:loader.playlist_&&loader.playlist_.id,buffered:timeRangesToArray(buffered)});// after 10 possibly stalled appends with no reset, exclude
if(this[type+"StalledDownloads_"]<10){return;}this.logger_(type+" loader stalled download exclusion");this.resetSegmentDownloads_(type);this.tech_.trigger({type:'usage',name:"vhs-"+type+"-download-exclusion"});if(type==='subtitle'){return;}// TODO: should we exclude audio tracks rather than main tracks
// when type is audio?
mpc.blacklistCurrentPlaylist({message:"Excessive "+type+" segment downloading detected."},Infinity);}/**
   * The purpose of this function is to emulate the "waiting" event on
   * browsers that do not emit it when they are waiting for more
   * data to continue playback
   *
   * @private
   */;_proto.checkCurrentTime_=function checkCurrentTime_(){if(this.tech_.paused()||this.tech_.seeking()){return;}var currentTime=this.tech_.currentTime();var buffered=this.tech_.buffered();if(this.lastRecordedTime===currentTime&&(!buffered.length||currentTime+SAFE_TIME_DELTA>=buffered.end(buffered.length-1))){// If current time is at the end of the final buffered region, then any playback
// stall is most likely caused by buffering in a low bandwidth environment. The tech
// should fire a `waiting` event in this scenario, but due to browser and tech
// inconsistencies. Calling `techWaiting_` here allows us to simulate
// responding to a native `waiting` event when the tech fails to emit one.
return this.techWaiting_();}if(this.consecutiveUpdates>=5&&currentTime===this.lastRecordedTime){this.consecutiveUpdates++;this.waiting_();}else if(currentTime===this.lastRecordedTime){this.consecutiveUpdates++;}else{this.consecutiveUpdates=0;this.lastRecordedTime=currentTime;}}/**
   * Cancels any pending timers and resets the 'timeupdate' mechanism
   * designed to detect that we are stalled
   *
   * @private
   */;_proto.cancelTimer_=function cancelTimer_(){this.consecutiveUpdates=0;if(this.timer_){this.logger_('cancelTimer_');clearTimeout(this.timer_);}this.timer_=null;}/**
   * Fixes situations where there's a bad seek
   *
   * @return {boolean} whether an action was taken to fix the seek
   * @private
   */;_proto.fixesBadSeeks_=function fixesBadSeeks_(){var seeking=this.tech_.seeking();if(!seeking){return false;}// TODO: It's possible that these seekable checks should be moved out of this function
// and into a function that runs on seekablechange. It's also possible that we only need
// afterSeekableWindow as the buffered check at the bottom is good enough to handle before
// seekable range.
var seekable=this.seekable();var currentTime=this.tech_.currentTime();var isAfterSeekableRange=this.afterSeekableWindow_(seekable,currentTime,this.media(),this.allowSeeksWithinUnsafeLiveWindow);var seekTo;if(isAfterSeekableRange){var seekableEnd=seekable.end(seekable.length-1);// sync to live point (if VOD, our seekable was updated and we're simply adjusting)
seekTo=seekableEnd;}if(this.beforeSeekableWindow_(seekable,currentTime)){var seekableStart=seekable.start(0);// sync to the beginning of the live window
// provide a buffer of .1 seconds to handle rounding/imprecise numbers
seekTo=seekableStart+(// if the playlist is too short and the seekable range is an exact time (can
// happen in live with a 3 segment playlist), then don't use a time delta
seekableStart===seekable.end(0)?0:SAFE_TIME_DELTA);}if(typeof seekTo!=='undefined'){this.logger_("Trying to seek outside of seekable at time "+currentTime+" with "+("seekable range "+printableRange(seekable)+". Seeking to ")+(seekTo+"."));this.tech_.setCurrentTime(seekTo);return true;}var sourceUpdater=this.masterPlaylistController_.sourceUpdater_;var buffered=this.tech_.buffered();var audioBuffered=sourceUpdater.audioBuffer?sourceUpdater.audioBuffered():null;var videoBuffered=sourceUpdater.videoBuffer?sourceUpdater.videoBuffered():null;var media=this.media();// verify that at least two segment durations or one part duration have been
// appended before checking for a gap.
var minAppendedDuration=media.partTargetDuration?media.partTargetDuration:(media.targetDuration-TIME_FUDGE_FACTOR)*2;// verify that at least two segment durations have been
// appended before checking for a gap.
var bufferedToCheck=[audioBuffered,videoBuffered];for(var i=0;i<bufferedToCheck.length;i++){// skip null buffered
if(!bufferedToCheck[i]){continue;}var timeAhead=timeAheadOf(bufferedToCheck[i],currentTime);// if we are less than two video/audio segment durations or one part
// duration behind we haven't appended enough to call this a bad seek.
if(timeAhead<minAppendedDuration){return false;}}var nextRange=findNextRange(buffered,currentTime);// we have appended enough content, but we don't have anything buffered
// to seek over the gap
if(nextRange.length===0){return false;}seekTo=nextRange.start(0)+SAFE_TIME_DELTA;this.logger_("Buffered region starts ("+nextRange.start(0)+") "+(" just beyond seek point ("+currentTime+"). Seeking to "+seekTo+"."));this.tech_.setCurrentTime(seekTo);return true;}/**
   * Handler for situations when we determine the player is waiting.
   *
   * @private
   */;_proto.waiting_=function waiting_(){if(this.techWaiting_()){return;}// All tech waiting checks failed. Use last resort correction
var currentTime=this.tech_.currentTime();var buffered=this.tech_.buffered();var currentRange=findRange(buffered,currentTime);// Sometimes the player can stall for unknown reasons within a contiguous buffered
// region with no indication that anything is amiss (seen in Firefox). Seeking to
// currentTime is usually enough to kickstart the player. This checks that the player
// is currently within a buffered region before attempting a corrective seek.
// Chrome does not appear to continue `timeupdate` events after a `waiting` event
// until there is ~ 3 seconds of forward buffer available. PlaybackWatcher should also
// make sure there is ~3 seconds of forward buffer before taking any corrective action
// to avoid triggering an `unknownwaiting` event when the network is slow.
if(currentRange.length&&currentTime+3<=currentRange.end(0)){this.cancelTimer_();this.tech_.setCurrentTime(currentTime);this.logger_("Stopped at "+currentTime+" while inside a buffered region "+("["+currentRange.start(0)+" -> "+currentRange.end(0)+"]. Attempting to resume ")+'playback by seeking to the current time.');// unknown waiting corrections may be useful for monitoring QoS
this.tech_.trigger({type:'usage',name:'vhs-unknown-waiting'});this.tech_.trigger({type:'usage',name:'hls-unknown-waiting'});return;}}/**
   * Handler for situations when the tech fires a `waiting` event
   *
   * @return {boolean}
   *         True if an action (or none) was needed to correct the waiting. False if no
   *         checks passed
   * @private
   */;_proto.techWaiting_=function techWaiting_(){var seekable=this.seekable();var currentTime=this.tech_.currentTime();if(this.tech_.seeking()||this.timer_!==null){// Tech is seeking or already waiting on another action, no action needed
return true;}if(this.beforeSeekableWindow_(seekable,currentTime)){var livePoint=seekable.end(seekable.length-1);this.logger_("Fell out of live window at time "+currentTime+". Seeking to "+("live point (seekable end) "+livePoint));this.cancelTimer_();this.tech_.setCurrentTime(livePoint);// live window resyncs may be useful for monitoring QoS
this.tech_.trigger({type:'usage',name:'vhs-live-resync'});this.tech_.trigger({type:'usage',name:'hls-live-resync'});return true;}var sourceUpdater=this.tech_.vhs.masterPlaylistController_.sourceUpdater_;var buffered=this.tech_.buffered();var videoUnderflow=this.videoUnderflow_({audioBuffered:sourceUpdater.audioBuffered(),videoBuffered:sourceUpdater.videoBuffered(),currentTime:currentTime});if(videoUnderflow){// Even though the video underflowed and was stuck in a gap, the audio overplayed
// the gap, leading currentTime into a buffered range. Seeking to currentTime
// allows the video to catch up to the audio position without losing any audio
// (only suffering ~3 seconds of frozen video and a pause in audio playback).
this.cancelTimer_();this.tech_.setCurrentTime(currentTime);// video underflow may be useful for monitoring QoS
this.tech_.trigger({type:'usage',name:'vhs-video-underflow'});this.tech_.trigger({type:'usage',name:'hls-video-underflow'});return true;}var nextRange=findNextRange(buffered,currentTime);// check for gap
if(nextRange.length>0){var difference=nextRange.start(0)-currentTime;this.logger_("Stopped at "+currentTime+", setting timer for "+difference+", seeking "+("to "+nextRange.start(0)));this.cancelTimer_();this.timer_=setTimeout(this.skipTheGap_.bind(this),difference*1000,currentTime);return true;}// All checks failed. Returning false to indicate failure to correct waiting
return false;};_proto.afterSeekableWindow_=function afterSeekableWindow_(seekable,currentTime,playlist,allowSeeksWithinUnsafeLiveWindow){if(allowSeeksWithinUnsafeLiveWindow===void 0){allowSeeksWithinUnsafeLiveWindow=false;}if(!seekable.length){// we can't make a solid case if there's no seekable, default to false
return false;}var allowedEnd=seekable.end(seekable.length-1)+SAFE_TIME_DELTA;var isLive=!playlist.endList;if(isLive&&allowSeeksWithinUnsafeLiveWindow){allowedEnd=seekable.end(seekable.length-1)+playlist.targetDuration*3;}if(currentTime>allowedEnd){return true;}return false;};_proto.beforeSeekableWindow_=function beforeSeekableWindow_(seekable,currentTime){if(seekable.length&&// can't fall before 0 and 0 seekable start identifies VOD stream
seekable.start(0)>0&&currentTime<seekable.start(0)-this.liveRangeSafeTimeDelta){return true;}return false;};_proto.videoUnderflow_=function videoUnderflow_(_ref){var videoBuffered=_ref.videoBuffered,audioBuffered=_ref.audioBuffered,currentTime=_ref.currentTime;// audio only content will not have video underflow :)
if(!videoBuffered){return;}var gap;// find a gap in demuxed content.
if(videoBuffered.length&&audioBuffered.length){// in Chrome audio will continue to play for ~3s when we run out of video
// so we have to check that the video buffer did have some buffer in the
// past.
var lastVideoRange=findRange(videoBuffered,currentTime-3);var videoRange=findRange(videoBuffered,currentTime);var audioRange=findRange(audioBuffered,currentTime);if(audioRange.length&&!videoRange.length&&lastVideoRange.length){gap={start:lastVideoRange.end(0),end:audioRange.end(0)};}// find a gap in muxed content.
}else{var nextRange=findNextRange(videoBuffered,currentTime);// Even if there is no available next range, there is still a possibility we are
// stuck in a gap due to video underflow.
if(!nextRange.length){gap=this.gapFromVideoUnderflow_(videoBuffered,currentTime);}}if(gap){this.logger_("Encountered a gap in video from "+gap.start+" to "+gap.end+". "+("Seeking to current time "+currentTime));return true;}return false;}/**
   * Timer callback. If playback still has not proceeded, then we seek
   * to the start of the next buffered region.
   *
   * @private
   */;_proto.skipTheGap_=function skipTheGap_(scheduledCurrentTime){var buffered=this.tech_.buffered();var currentTime=this.tech_.currentTime();var nextRange=findNextRange(buffered,currentTime);this.cancelTimer_();if(nextRange.length===0||currentTime!==scheduledCurrentTime){return;}this.logger_('skipTheGap_:','currentTime:',currentTime,'scheduled currentTime:',scheduledCurrentTime,'nextRange start:',nextRange.start(0));// only seek if we still have not played
this.tech_.setCurrentTime(nextRange.start(0)+TIME_FUDGE_FACTOR);this.tech_.trigger({type:'usage',name:'vhs-gap-skip'});this.tech_.trigger({type:'usage',name:'hls-gap-skip'});};_proto.gapFromVideoUnderflow_=function gapFromVideoUnderflow_(buffered,currentTime){// At least in Chrome, if there is a gap in the video buffer, the audio will continue
// playing for ~3 seconds after the video gap starts. This is done to account for
// video buffer underflow/underrun (note that this is not done when there is audio
// buffer underflow/underrun -- in that case the video will stop as soon as it
// encounters the gap, as audio stalls are more noticeable/jarring to a user than
// video stalls). The player's time will reflect the playthrough of audio, so the
// time will appear as if we are in a buffered region, even if we are stuck in a
// "gap."
//
// Example:
// video buffer:   0 => 10.1, 10.2 => 20
// audio buffer:   0 => 20
// overall buffer: 0 => 10.1, 10.2 => 20
// current time: 13
//
// Chrome's video froze at 10 seconds, where the video buffer encountered the gap,
// however, the audio continued playing until it reached ~3 seconds past the gap
// (13 seconds), at which point it stops as well. Since current time is past the
// gap, findNextRange will return no ranges.
//
// To check for this issue, we see if there is a gap that starts somewhere within
// a 3 second range (3 seconds +/- 1 second) back from our current time.
var gaps=findGaps(buffered);for(var i=0;i<gaps.length;i++){var start=gaps.start(i);var end=gaps.end(i);// gap is starts no more than 4 seconds back
if(currentTime-start<4&&currentTime-start>2){return{start:start,end:end};}}return null;};return PlaybackWatcher;}();var defaultOptions={errorInterval:30,getSource:function getSource(next){var tech=this.tech({IWillNotUseThisInPlugins:true});var sourceObj=tech.currentSource_||this.currentSource();return next(sourceObj);}};/**
 * Main entry point for the plugin
 *
 * @param {Player} player a reference to a videojs Player instance
 * @param {Object} [options] an object with plugin options
 * @private
 */var initPlugin=function initPlugin(player,options){var lastCalled=0;var seekTo=0;var localOptions=videojs.mergeOptions(defaultOptions,options);player.ready(function(){player.trigger({type:'usage',name:'vhs-error-reload-initialized'});player.trigger({type:'usage',name:'hls-error-reload-initialized'});});/**
   * Player modifications to perform that must wait until `loadedmetadata`
   * has been triggered
   *
   * @private
   */var loadedMetadataHandler=function loadedMetadataHandler(){if(seekTo){player.currentTime(seekTo);}};/**
   * Set the source on the player element, play, and seek if necessary
   *
   * @param {Object} sourceObj An object specifying the source url and mime-type to play
   * @private
   */var setSource=function setSource(sourceObj){if(sourceObj===null||sourceObj===undefined){return;}seekTo=player.duration()!==Infinity&&player.currentTime()||0;player.one('loadedmetadata',loadedMetadataHandler);player.src(sourceObj);player.trigger({type:'usage',name:'vhs-error-reload'});player.trigger({type:'usage',name:'hls-error-reload'});player.play();};/**
   * Attempt to get a source from either the built-in getSource function
   * or a custom function provided via the options
   *
   * @private
   */var errorHandler=function errorHandler(){// Do not attempt to reload the source if a source-reload occurred before
// 'errorInterval' time has elapsed since the last source-reload
if(Date.now()-lastCalled<localOptions.errorInterval*1000){player.trigger({type:'usage',name:'vhs-error-reload-canceled'});player.trigger({type:'usage',name:'hls-error-reload-canceled'});return;}if(!localOptions.getSource||typeof localOptions.getSource!=='function'){videojs.log.error('ERROR: reloadSourceOnError - The option getSource must be a function!');return;}lastCalled=Date.now();return localOptions.getSource.call(player,setSource);};/**
   * Unbind any event handlers that were bound by the plugin
   *
   * @private
   */var cleanupEvents=function cleanupEvents(){player.off('loadedmetadata',loadedMetadataHandler);player.off('error',errorHandler);player.off('dispose',cleanupEvents);};/**
   * Cleanup before re-initializing the plugin
   *
   * @param {Object} [newOptions] an object with plugin options
   * @private
   */var reinitPlugin=function reinitPlugin(newOptions){cleanupEvents();initPlugin(player,newOptions);};player.on('error',errorHandler);player.on('dispose',cleanupEvents);// Overwrite the plugin function so that we can correctly cleanup before
// initializing the plugin
player.reloadSourceOnError=reinitPlugin;};/**
 * Reload the source when an error is detected as long as there
 * wasn't an error previously within the last 30 seconds
 *
 * @param {Object} [options] an object with plugin options
 */var reloadSourceOnError=function reloadSourceOnError(options){initPlugin(this,options);};var version$4="2.16.3";var version$3="6.0.1";var version$2="0.22.1";var version$1="4.8.0";var video_es_version="3.1.3";var Vhs={PlaylistLoader:PlaylistLoader,Playlist:Playlist,utils:utils,STANDARD_PLAYLIST_SELECTOR:lastBandwidthSelector,INITIAL_PLAYLIST_SELECTOR:lowestBitrateCompatibleVariantSelector,lastBandwidthSelector:lastBandwidthSelector,movingAverageBandwidthSelector:movingAverageBandwidthSelector,comparePlaylistBandwidth:comparePlaylistBandwidth,comparePlaylistResolution:comparePlaylistResolution,xhr:xhrFactory()};// Define getter/setters for config properties
Object.keys(Config).forEach(function(prop){Object.defineProperty(Vhs,prop,{get:function get(){videojs.log.warn("using Vhs."+prop+" is UNSAFE be sure you know what you are doing");return Config[prop];},set:function set(value){videojs.log.warn("using Vhs."+prop+" is UNSAFE be sure you know what you are doing");if(typeof value!=='number'||value<0){videojs.log.warn("value of Vhs."+prop+" must be greater than or equal to 0");return;}Config[prop]=value;}});});var LOCAL_STORAGE_KEY='videojs-vhs';/**
 * Updates the selectedIndex of the QualityLevelList when a mediachange happens in vhs.
 *
 * @param {QualityLevelList} qualityLevels The QualityLevelList to update.
 * @param {PlaylistLoader} playlistLoader PlaylistLoader containing the new media info.
 * @function handleVhsMediaChange
 */var handleVhsMediaChange=function handleVhsMediaChange(qualityLevels,playlistLoader){var newPlaylist=playlistLoader.media();var selectedIndex=-1;for(var i=0;i<qualityLevels.length;i++){if(qualityLevels[i].id===newPlaylist.id){selectedIndex=i;break;}}qualityLevels.selectedIndex_=selectedIndex;qualityLevels.trigger({selectedIndex:selectedIndex,type:'change'});};/**
 * Adds quality levels to list once playlist metadata is available
 *
 * @param {QualityLevelList} qualityLevels The QualityLevelList to attach events to.
 * @param {Object} vhs Vhs object to listen to for media events.
 * @function handleVhsLoadedMetadata
 */var handleVhsLoadedMetadata=function handleVhsLoadedMetadata(qualityLevels,vhs){vhs.representations().forEach(function(rep){qualityLevels.addQualityLevel(rep);});handleVhsMediaChange(qualityLevels,vhs.playlists);};// HLS is a source handler, not a tech. Make sure attempts to use it
// as one do not cause exceptions.
Vhs.canPlaySource=function(){return videojs.log.warn('HLS is no longer a tech. Please remove it from '+'your player\'s techOrder.');};var emeKeySystems=function emeKeySystems(keySystemOptions,mainPlaylist,audioPlaylist){if(!keySystemOptions){return keySystemOptions;}var codecs={};if(mainPlaylist&&mainPlaylist.attributes&&mainPlaylist.attributes.CODECS){codecs=unwrapCodecList(parseCodecs(mainPlaylist.attributes.CODECS));}if(audioPlaylist&&audioPlaylist.attributes&&audioPlaylist.attributes.CODECS){codecs.audio=audioPlaylist.attributes.CODECS;}var videoContentType=getMimeForCodec(codecs.video);var audioContentType=getMimeForCodec(codecs.audio);// upsert the content types based on the selected playlist
var keySystemContentTypes={};for(var keySystem in keySystemOptions){keySystemContentTypes[keySystem]={};if(audioContentType){keySystemContentTypes[keySystem].audioContentType=audioContentType;}if(videoContentType){keySystemContentTypes[keySystem].videoContentType=videoContentType;}// Default to using the video playlist's PSSH even though they may be different, as
// videojs-contrib-eme will only accept one in the options.
//
// This shouldn't be an issue for most cases as early intialization will handle all
// unique PSSH values, and if they aren't, then encrypted events should have the
// specific information needed for the unique license.
if(mainPlaylist.contentProtection&&mainPlaylist.contentProtection[keySystem]&&mainPlaylist.contentProtection[keySystem].pssh){keySystemContentTypes[keySystem].pssh=mainPlaylist.contentProtection[keySystem].pssh;}// videojs-contrib-eme accepts the option of specifying: 'com.some.cdm': 'url'
// so we need to prevent overwriting the URL entirely
if(typeof keySystemOptions[keySystem]==='string'){keySystemContentTypes[keySystem].url=keySystemOptions[keySystem];}}return videojs.mergeOptions(keySystemOptions,keySystemContentTypes);};/**
 * @typedef {Object} KeySystems
 *
 * keySystems configuration for https://github.com/videojs/videojs-contrib-eme
 * Note: not all options are listed here.
 *
 * @property {Uint8Array} [pssh]
 *           Protection System Specific Header
 */ /**
 * Goes through all the playlists and collects an array of KeySystems options objects
 * containing each playlist's keySystems and their pssh values, if available.
 *
 * @param {Object[]} playlists
 *        The playlists to look through
 * @param {string[]} keySystems
 *        The keySystems to collect pssh values for
 *
 * @return {KeySystems[]}
 *         An array of KeySystems objects containing available key systems and their
 *         pssh values
 */var getAllPsshKeySystemsOptions=function getAllPsshKeySystemsOptions(playlists,keySystems){return playlists.reduce(function(keySystemsArr,playlist){if(!playlist.contentProtection){return keySystemsArr;}var keySystemsOptions=keySystems.reduce(function(keySystemsObj,keySystem){var keySystemOptions=playlist.contentProtection[keySystem];if(keySystemOptions&&keySystemOptions.pssh){keySystemsObj[keySystem]={pssh:keySystemOptions.pssh};}return keySystemsObj;},{});if(Object.keys(keySystemsOptions).length){keySystemsArr.push(keySystemsOptions);}return keySystemsArr;},[]);};/**
 * Returns a promise that waits for the
 * [eme plugin](https://github.com/videojs/videojs-contrib-eme) to create a key session.
 *
 * Works around https://bugs.chromium.org/p/chromium/issues/detail?id=895449 in non-IE11
 * browsers.
 *
 * As per the above ticket, this is particularly important for Chrome, where, if
 * unencrypted content is appended before encrypted content and the key session has not
 * been created, a MEDIA_ERR_DECODE will be thrown once the encrypted content is reached
 * during playback.
 *
 * @param {Object} player
 *        The player instance
 * @param {Object[]} sourceKeySystems
 *        The key systems options from the player source
 * @param {Object} [audioMedia]
 *        The active audio media playlist (optional)
 * @param {Object[]} mainPlaylists
 *        The playlists found on the master playlist object
 *
 * @return {Object}
 *         Promise that resolves when the key session has been created
 */var waitForKeySessionCreation=function waitForKeySessionCreation(_ref){var player=_ref.player,sourceKeySystems=_ref.sourceKeySystems,audioMedia=_ref.audioMedia,mainPlaylists=_ref.mainPlaylists;if(!player.eme.initializeMediaKeys){return Promise.resolve();}// TODO should all audio PSSH values be initialized for DRM?
//
// All unique video rendition pssh values are initialized for DRM, but here only
// the initial audio playlist license is initialized. In theory, an encrypted
// event should be fired if the user switches to an alternative audio playlist
// where a license is required, but this case hasn't yet been tested. In addition, there
// may be many alternate audio playlists unlikely to be used (e.g., multiple different
// languages).
var playlists=audioMedia?mainPlaylists.concat([audioMedia]):mainPlaylists;var keySystemsOptionsArr=getAllPsshKeySystemsOptions(playlists,Object.keys(sourceKeySystems));var initializationFinishedPromises=[];var keySessionCreatedPromises=[];// Since PSSH values are interpreted as initData, EME will dedupe any duplicates. The
// only place where it should not be deduped is for ms-prefixed APIs, but the early
// return for IE11 above, and the existence of modern EME APIs in addition to
// ms-prefixed APIs on Edge should prevent this from being a concern.
// initializeMediaKeys also won't use the webkit-prefixed APIs.
keySystemsOptionsArr.forEach(function(keySystemsOptions){keySessionCreatedPromises.push(new Promise(function(resolve,reject){player.tech_.one('keysessioncreated',resolve);}));initializationFinishedPromises.push(new Promise(function(resolve,reject){player.eme.initializeMediaKeys({keySystems:keySystemsOptions},function(err){if(err){reject(err);return;}resolve();});}));});// The reasons Promise.race is chosen over Promise.any:
//
// * Promise.any is only available in Safari 14+.
// * None of these promises are expected to reject. If they do reject, it might be
//   better here for the race to surface the rejection, rather than mask it by using
//   Promise.any.
return Promise.race([// If a session was previously created, these will all finish resolving without
// creating a new session, otherwise it will take until the end of all license
// requests, which is why the key session check is used (to make setup much faster).
Promise.all(initializationFinishedPromises),// Once a single session is created, the browser knows DRM will be used.
Promise.race(keySessionCreatedPromises)]);};/**
 * If the [eme](https://github.com/videojs/videojs-contrib-eme) plugin is available, and
 * there are keySystems on the source, sets up source options to prepare the source for
 * eme.
 *
 * @param {Object} player
 *        The player instance
 * @param {Object[]} sourceKeySystems
 *        The key systems options from the player source
 * @param {Object} media
 *        The active media playlist
 * @param {Object} [audioMedia]
 *        The active audio media playlist (optional)
 *
 * @return {boolean}
 *         Whether or not options were configured and EME is available
 */var setupEmeOptions=function setupEmeOptions(_ref2){var player=_ref2.player,sourceKeySystems=_ref2.sourceKeySystems,media=_ref2.media,audioMedia=_ref2.audioMedia;var sourceOptions=emeKeySystems(sourceKeySystems,media,audioMedia);if(!sourceOptions){return false;}player.currentSource().keySystems=sourceOptions;// eme handles the rest of the setup, so if it is missing
// do nothing.
if(sourceOptions&&!player.eme){videojs.log.warn('DRM encrypted source cannot be decrypted without a DRM plugin');return false;}return true;};var getVhsLocalStorage=function getVhsLocalStorage(){if(!(window_default()).localStorage){return null;}var storedObject=window_default().localStorage.getItem(LOCAL_STORAGE_KEY);if(!storedObject){return null;}try{return JSON.parse(storedObject);}catch(e){// someone may have tampered with the value
return null;}};var updateVhsLocalStorage=function updateVhsLocalStorage(options){if(!(window_default()).localStorage){return false;}var objectToStore=getVhsLocalStorage();objectToStore=objectToStore?videojs.mergeOptions(objectToStore,options):options;try{window_default().localStorage.setItem(LOCAL_STORAGE_KEY,JSON.stringify(objectToStore));}catch(e){// Throws if storage is full (e.g., always on iOS 5+ Safari private mode, where
// storage is set to 0).
// https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem#Exceptions
// No need to perform any operation.
return false;}return objectToStore;};/**
 * Parses VHS-supported media types from data URIs. See
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
 * for information on data URIs.
 *
 * @param {string} dataUri
 *        The data URI
 *
 * @return {string|Object}
 *         The parsed object/string, or the original string if no supported media type
 *         was found
 */var expandDataUri=function expandDataUri(dataUri){if(dataUri.toLowerCase().indexOf('data:application/vnd.videojs.vhs+json,')===0){return JSON.parse(dataUri.substring(dataUri.indexOf(',')+1));}// no known case for this data URI, return the string as-is
return dataUri;};/**
 * Whether the browser has built-in HLS support.
 */Vhs.supportsNativeHls=function(){if(!(document_default())||!(document_default()).createElement){return false;}var video=document_default().createElement('video');// native HLS is definitely not supported if HTML5 video isn't
if(!videojs.getTech('Html5').isSupported()){return false;}// HLS manifests can go by many mime-types
var canPlay=[// Apple santioned
'application/vnd.apple.mpegurl',// Apple sanctioned for backwards compatibility
'audio/mpegurl',// Very common
'audio/x-mpegurl',// Very common
'application/x-mpegurl',// Included for completeness
'video/x-mpegurl','video/mpegurl','application/mpegurl'];return canPlay.some(function(canItPlay){return /maybe|probably/i.test(video.canPlayType(canItPlay));});}();Vhs.supportsNativeDash=function(){if(!(document_default())||!(document_default()).createElement||!videojs.getTech('Html5').isSupported()){return false;}return /maybe|probably/i.test(document_default().createElement('video').canPlayType('application/dash+xml'));}();Vhs.supportsTypeNatively=function(type){if(type==='hls'){return Vhs.supportsNativeHls;}if(type==='dash'){return Vhs.supportsNativeDash;}return false;};/**
 * HLS is a source handler, not a tech. Make sure attempts to use it
 * as one do not cause exceptions.
 */Vhs.isSupported=function(){return videojs.log.warn('HLS is no longer a tech. Please remove it from '+'your player\'s techOrder.');};var Component=videojs.getComponent('Component');/**
 * The Vhs Handler object, where we orchestrate all of the parts
 * of HLS to interact with video.js
 *
 * @class VhsHandler
 * @extends videojs.Component
 * @param {Object} source the soruce object
 * @param {Tech} tech the parent tech object
 * @param {Object} options optional and required options
 */var VhsHandler=/*#__PURE__*/function(_Component){_inheritsLoose(VhsHandler,_Component);function VhsHandler(source,tech,options){var _this;_this=_Component.call(this,tech,videojs.mergeOptions(options.hls,options.vhs))||this;if(options.hls&&Object.keys(options.hls).length){videojs.log.warn('Using hls options is deprecated. Please rename `hls` to `vhs` in your options object.');}// if a tech level `initialBandwidth` option was passed
// use that over the VHS level `bandwidth` option
if(typeof options.initialBandwidth==='number'){_this.options_.bandwidth=options.initialBandwidth;}_this.logger_=logger('VhsHandler');// tech.player() is deprecated but setup a reference to HLS for
// backwards-compatibility
if(tech.options_&&tech.options_.playerId){var _player=videojs(tech.options_.playerId);if(!_player.hasOwnProperty('hls')){Object.defineProperty(_player,'hls',{get:function get(){videojs.log.warn('player.hls is deprecated. Use player.tech().vhs instead.');tech.trigger({type:'usage',name:'hls-player-access'});return _assertThisInitialized(_this);},configurable:true});}if(!_player.hasOwnProperty('vhs')){Object.defineProperty(_player,'vhs',{get:function get(){videojs.log.warn('player.vhs is deprecated. Use player.tech().vhs instead.');tech.trigger({type:'usage',name:'vhs-player-access'});return _assertThisInitialized(_this);},configurable:true});}if(!_player.hasOwnProperty('dash')){Object.defineProperty(_player,'dash',{get:function get(){videojs.log.warn('player.dash is deprecated. Use player.tech().vhs instead.');return _assertThisInitialized(_this);},configurable:true});}_this.player_=_player;}_this.tech_=tech;_this.source_=source;_this.stats={};_this.ignoreNextSeekingEvent_=false;_this.setOptions_();if(_this.options_.overrideNative&&tech.overrideNativeAudioTracks&&tech.overrideNativeVideoTracks){tech.overrideNativeAudioTracks(true);tech.overrideNativeVideoTracks(true);}else if(_this.options_.overrideNative&&(tech.featuresNativeVideoTracks||tech.featuresNativeAudioTracks)){// overriding native HLS only works if audio tracks have been emulated
// error early if we're misconfigured
throw new Error('Overriding native HLS requires emulated tracks. '+'See https://git.io/vMpjB');}// listen for fullscreenchange events for this player so that we
// can adjust our quality selection quickly
_this.on((document_default()),['fullscreenchange','webkitfullscreenchange','mozfullscreenchange','MSFullscreenChange'],function(event){var fullscreenElement=(document_default()).fullscreenElement||(document_default()).webkitFullscreenElement||(document_default()).mozFullScreenElement||(document_default()).msFullscreenElement;if(fullscreenElement&&fullscreenElement.contains(_this.tech_.el())){_this.masterPlaylistController_.fastQualityChange_();}else{// When leaving fullscreen, since the in page pixel dimensions should be smaller
// than full screen, see if there should be a rendition switch down to preserve
// bandwidth.
_this.masterPlaylistController_.checkABR_();}});_this.on(_this.tech_,'seeking',function(){if(this.ignoreNextSeekingEvent_){this.ignoreNextSeekingEvent_=false;return;}this.setCurrentTime(this.tech_.currentTime());});_this.on(_this.tech_,'error',function(){// verify that the error was real and we are loaded
// enough to have mpc loaded.
if(this.tech_.error()&&this.masterPlaylistController_){this.masterPlaylistController_.pauseLoading();}});_this.on(_this.tech_,'play',_this.play);return _this;}var _proto=VhsHandler.prototype;_proto.setOptions_=function setOptions_(){var _this2=this;// defaults
this.options_.withCredentials=this.options_.withCredentials||false;this.options_.handleManifestRedirects=this.options_.handleManifestRedirects===false?false:true;this.options_.limitRenditionByPlayerDimensions=this.options_.limitRenditionByPlayerDimensions===false?false:true;this.options_.useDevicePixelRatio=this.options_.useDevicePixelRatio||false;this.options_.smoothQualityChange=this.options_.smoothQualityChange||false;this.options_.useBandwidthFromLocalStorage=typeof this.source_.useBandwidthFromLocalStorage!=='undefined'?this.source_.useBandwidthFromLocalStorage:this.options_.useBandwidthFromLocalStorage||false;this.options_.useNetworkInformationApi=this.options_.useNetworkInformationApi||false;this.options_.useDtsForTimestampOffset=this.options_.useDtsForTimestampOffset||false;this.options_.customTagParsers=this.options_.customTagParsers||[];this.options_.customTagMappers=this.options_.customTagMappers||[];this.options_.cacheEncryptionKeys=this.options_.cacheEncryptionKeys||false;if(typeof this.options_.blacklistDuration!=='number'){this.options_.blacklistDuration=5*60;}if(typeof this.options_.bandwidth!=='number'){if(this.options_.useBandwidthFromLocalStorage){var storedObject=getVhsLocalStorage();if(storedObject&&storedObject.bandwidth){this.options_.bandwidth=storedObject.bandwidth;this.tech_.trigger({type:'usage',name:'vhs-bandwidth-from-local-storage'});this.tech_.trigger({type:'usage',name:'hls-bandwidth-from-local-storage'});}if(storedObject&&storedObject.throughput){this.options_.throughput=storedObject.throughput;this.tech_.trigger({type:'usage',name:'vhs-throughput-from-local-storage'});this.tech_.trigger({type:'usage',name:'hls-throughput-from-local-storage'});}}}// if bandwidth was not set by options or pulled from local storage, start playlist
// selection at a reasonable bandwidth
if(typeof this.options_.bandwidth!=='number'){this.options_.bandwidth=Config.INITIAL_BANDWIDTH;}// If the bandwidth number is unchanged from the initial setting
// then this takes precedence over the enableLowInitialPlaylist option
this.options_.enableLowInitialPlaylist=this.options_.enableLowInitialPlaylist&&this.options_.bandwidth===Config.INITIAL_BANDWIDTH;// grab options passed to player.src
['withCredentials','useDevicePixelRatio','limitRenditionByPlayerDimensions','bandwidth','smoothQualityChange','customTagParsers','customTagMappers','handleManifestRedirects','cacheEncryptionKeys','playlistSelector','initialPlaylistSelector','experimentalBufferBasedABR','liveRangeSafeTimeDelta','experimentalLLHLS','useNetworkInformationApi','useDtsForTimestampOffset','experimentalExactManifestTimings','experimentalLeastPixelDiffSelector'].forEach(function(option){if(typeof _this2.source_[option]!=='undefined'){_this2.options_[option]=_this2.source_[option];}});this.limitRenditionByPlayerDimensions=this.options_.limitRenditionByPlayerDimensions;this.useDevicePixelRatio=this.options_.useDevicePixelRatio;}/**
   * called when player.src gets called, handle a new source
   *
   * @param {Object} src the source object to handle
   */;_proto.src=function src(_src,type){var _this3=this;// do nothing if the src is falsey
if(!_src){return;}this.setOptions_();// add master playlist controller options
this.options_.src=expandDataUri(this.source_.src);this.options_.tech=this.tech_;this.options_.externVhs=Vhs;this.options_.sourceType=simpleTypeFromSourceType(type);// Whenever we seek internally, we should update the tech
this.options_.seekTo=function(time){_this3.tech_.setCurrentTime(time);};if(this.options_.smoothQualityChange){videojs.log.warn('smoothQualityChange is deprecated and will be removed in the next major version');}this.masterPlaylistController_=new MasterPlaylistController(this.options_);var playbackWatcherOptions=videojs.mergeOptions({liveRangeSafeTimeDelta:SAFE_TIME_DELTA},this.options_,{seekable:function seekable(){return _this3.seekable();},media:function media(){return _this3.masterPlaylistController_.media();},masterPlaylistController:this.masterPlaylistController_});this.playbackWatcher_=new PlaybackWatcher(playbackWatcherOptions);this.masterPlaylistController_.on('error',function(){var player=videojs.players[_this3.tech_.options_.playerId];var error=_this3.masterPlaylistController_.error;if(video_es_typeof(error)==='object'&&!error.code){error.code=3;}else if(typeof error==='string'){error={message:error,code:3};}player.error(error);});var defaultSelector=this.options_.experimentalBufferBasedABR?Vhs.movingAverageBandwidthSelector(0.55):Vhs.STANDARD_PLAYLIST_SELECTOR;// `this` in selectPlaylist should be the VhsHandler for backwards
// compatibility with < v2
this.masterPlaylistController_.selectPlaylist=this.selectPlaylist?this.selectPlaylist.bind(this):defaultSelector.bind(this);this.masterPlaylistController_.selectInitialPlaylist=Vhs.INITIAL_PLAYLIST_SELECTOR.bind(this);// re-expose some internal objects for backwards compatibility with < v2
this.playlists=this.masterPlaylistController_.masterPlaylistLoader_;this.mediaSource=this.masterPlaylistController_.mediaSource;// Proxy assignment of some properties to the master playlist
// controller. Using a custom property for backwards compatibility
// with < v2
Object.defineProperties(this,{selectPlaylist:{get:function get(){return this.masterPlaylistController_.selectPlaylist;},set:function set(selectPlaylist){this.masterPlaylistController_.selectPlaylist=selectPlaylist.bind(this);}},throughput:{get:function get(){return this.masterPlaylistController_.mainSegmentLoader_.throughput.rate;},set:function set(throughput){this.masterPlaylistController_.mainSegmentLoader_.throughput.rate=throughput;// By setting `count` to 1 the throughput value becomes the starting value
// for the cumulative average
this.masterPlaylistController_.mainSegmentLoader_.throughput.count=1;}},bandwidth:{get:function get(){var playerBandwidthEst=this.masterPlaylistController_.mainSegmentLoader_.bandwidth;var networkInformation=(window_default()).navigator.connection||(window_default()).navigator.mozConnection||(window_default()).navigator.webkitConnection;var tenMbpsAsBitsPerSecond=10e6;if(this.options_.useNetworkInformationApi&&networkInformation){// downlink returns Mbps
// https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation/downlink
var networkInfoBandwidthEstBitsPerSec=networkInformation.downlink*1000*1000;// downlink maxes out at 10 Mbps. In the event that both networkInformationApi and the player
// estimate a bandwidth greater than 10 Mbps, use the larger of the two estimates to ensure that
// high quality streams are not filtered out.
if(networkInfoBandwidthEstBitsPerSec>=tenMbpsAsBitsPerSecond&&playerBandwidthEst>=tenMbpsAsBitsPerSecond){playerBandwidthEst=Math.max(playerBandwidthEst,networkInfoBandwidthEstBitsPerSec);}else{playerBandwidthEst=networkInfoBandwidthEstBitsPerSec;}}return playerBandwidthEst;},set:function set(bandwidth){this.masterPlaylistController_.mainSegmentLoader_.bandwidth=bandwidth;// setting the bandwidth manually resets the throughput counter
// `count` is set to zero that current value of `rate` isn't included
// in the cumulative average
this.masterPlaylistController_.mainSegmentLoader_.throughput={rate:0,count:0};}},/**
       * `systemBandwidth` is a combination of two serial processes bit-rates. The first
       * is the network bitrate provided by `bandwidth` and the second is the bitrate of
       * the entire process after that - decryption, transmuxing, and appending - provided
       * by `throughput`.
       *
       * Since the two process are serial, the overall system bandwidth is given by:
       *   sysBandwidth = 1 / (1 / bandwidth + 1 / throughput)
       */systemBandwidth:{get:function get(){var invBandwidth=1/(this.bandwidth||1);var invThroughput;if(this.throughput>0){invThroughput=1/this.throughput;}else{invThroughput=0;}var systemBitrate=Math.floor(1/(invBandwidth+invThroughput));return systemBitrate;},set:function set(){videojs.log.error('The "systemBandwidth" property is read-only');}}});if(this.options_.bandwidth){this.bandwidth=this.options_.bandwidth;}if(this.options_.throughput){this.throughput=this.options_.throughput;}Object.defineProperties(this.stats,{bandwidth:{get:function get(){return _this3.bandwidth||0;},enumerable:true},mediaRequests:{get:function get(){return _this3.masterPlaylistController_.mediaRequests_()||0;},enumerable:true},mediaRequestsAborted:{get:function get(){return _this3.masterPlaylistController_.mediaRequestsAborted_()||0;},enumerable:true},mediaRequestsTimedout:{get:function get(){return _this3.masterPlaylistController_.mediaRequestsTimedout_()||0;},enumerable:true},mediaRequestsErrored:{get:function get(){return _this3.masterPlaylistController_.mediaRequestsErrored_()||0;},enumerable:true},mediaTransferDuration:{get:function get(){return _this3.masterPlaylistController_.mediaTransferDuration_()||0;},enumerable:true},mediaBytesTransferred:{get:function get(){return _this3.masterPlaylistController_.mediaBytesTransferred_()||0;},enumerable:true},mediaSecondsLoaded:{get:function get(){return _this3.masterPlaylistController_.mediaSecondsLoaded_()||0;},enumerable:true},mediaAppends:{get:function get(){return _this3.masterPlaylistController_.mediaAppends_()||0;},enumerable:true},mainAppendsToLoadedData:{get:function get(){return _this3.masterPlaylistController_.mainAppendsToLoadedData_()||0;},enumerable:true},audioAppendsToLoadedData:{get:function get(){return _this3.masterPlaylistController_.audioAppendsToLoadedData_()||0;},enumerable:true},appendsToLoadedData:{get:function get(){return _this3.masterPlaylistController_.appendsToLoadedData_()||0;},enumerable:true},timeToLoadedData:{get:function get(){return _this3.masterPlaylistController_.timeToLoadedData_()||0;},enumerable:true},buffered:{get:function get(){return timeRangesToArray(_this3.tech_.buffered());},enumerable:true},currentTime:{get:function get(){return _this3.tech_.currentTime();},enumerable:true},currentSource:{get:function get(){return _this3.tech_.currentSource_;},enumerable:true},currentTech:{get:function get(){return _this3.tech_.name_;},enumerable:true},duration:{get:function get(){return _this3.tech_.duration();},enumerable:true},master:{get:function get(){return _this3.playlists.master;},enumerable:true},playerDimensions:{get:function get(){return _this3.tech_.currentDimensions();},enumerable:true},seekable:{get:function get(){return timeRangesToArray(_this3.tech_.seekable());},enumerable:true},timestamp:{get:function get(){return Date.now();},enumerable:true},videoPlaybackQuality:{get:function get(){return _this3.tech_.getVideoPlaybackQuality();},enumerable:true}});this.tech_.one('canplay',this.masterPlaylistController_.setupFirstPlay.bind(this.masterPlaylistController_));this.tech_.on('bandwidthupdate',function(){if(_this3.options_.useBandwidthFromLocalStorage){updateVhsLocalStorage({bandwidth:_this3.bandwidth,throughput:Math.round(_this3.throughput)});}});this.masterPlaylistController_.on('selectedinitialmedia',function(){// Add the manual rendition mix-in to VhsHandler
renditionSelectionMixin(_this3);});this.masterPlaylistController_.sourceUpdater_.on('createdsourcebuffers',function(){_this3.setupEme_();});// the bandwidth of the primary segment loader is our best
// estimate of overall bandwidth
this.on(this.masterPlaylistController_,'progress',function(){this.tech_.trigger('progress');});// In the live case, we need to ignore the very first `seeking` event since
// that will be the result of the seek-to-live behavior
this.on(this.masterPlaylistController_,'firstplay',function(){this.ignoreNextSeekingEvent_=true;});this.setupQualityLevels_();// do nothing if the tech has been disposed already
// this can occur if someone sets the src in player.ready(), for instance
if(!this.tech_.el()){return;}this.mediaSourceUrl_=window_default().URL.createObjectURL(this.masterPlaylistController_.mediaSource);this.tech_.src(this.mediaSourceUrl_);};_proto.createKeySessions_=function createKeySessions_(){var _this4=this;var audioPlaylistLoader=this.masterPlaylistController_.mediaTypes_.AUDIO.activePlaylistLoader;this.logger_('waiting for EME key session creation');waitForKeySessionCreation({player:this.player_,sourceKeySystems:this.source_.keySystems,audioMedia:audioPlaylistLoader&&audioPlaylistLoader.media(),mainPlaylists:this.playlists.master.playlists}).then(function(){_this4.logger_('created EME key session');_this4.masterPlaylistController_.sourceUpdater_.initializedEme();})["catch"](function(err){_this4.logger_('error while creating EME key session',err);_this4.player_.error({message:'Failed to initialize media keys for EME',code:3});});};_proto.handleWaitingForKey_=function handleWaitingForKey_(){// If waitingforkey is fired, it's possible that the data that's necessary to retrieve
// the key is in the manifest. While this should've happened on initial source load, it
// may happen again in live streams where the keys change, and the manifest info
// reflects the update.
//
// Because videojs-contrib-eme compares the PSSH data we send to that of PSSH data it's
// already requested keys for, we don't have to worry about this generating extraneous
// requests.
this.logger_('waitingforkey fired, attempting to create any new key sessions');this.createKeySessions_();}/**
   * If necessary and EME is available, sets up EME options and waits for key session
   * creation.
   *
   * This function also updates the source updater so taht it can be used, as for some
   * browsers, EME must be configured before content is appended (if appending unencrypted
   * content before encrypted content).
   */;_proto.setupEme_=function setupEme_(){var _this5=this;var audioPlaylistLoader=this.masterPlaylistController_.mediaTypes_.AUDIO.activePlaylistLoader;var didSetupEmeOptions=setupEmeOptions({player:this.player_,sourceKeySystems:this.source_.keySystems,media:this.playlists.media(),audioMedia:audioPlaylistLoader&&audioPlaylistLoader.media()});this.player_.tech_.on('keystatuschange',function(e){if(e.status!=='output-restricted'){return;}var masterPlaylist=_this5.masterPlaylistController_.master();if(!masterPlaylist||!masterPlaylist.playlists){return;}var excludedHDPlaylists=[];// Assume all HD streams are unplayable and exclude them from ABR selection
masterPlaylist.playlists.forEach(function(playlist){if(playlist&&playlist.attributes&&playlist.attributes.RESOLUTION&&playlist.attributes.RESOLUTION.height>=720){if(!playlist.excludeUntil||playlist.excludeUntil<Infinity){playlist.excludeUntil=Infinity;excludedHDPlaylists.push(playlist);}}});if(excludedHDPlaylists.length){var _videojs$log;(_videojs$log=videojs.log).warn.apply(_videojs$log,['DRM keystatus changed to "output-restricted." Removing the following HD playlists '+'that will most likely fail to play and clearing the buffer. '+'This may be due to HDCP restrictions on the stream and the capabilities of the current device.'].concat(excludedHDPlaylists));// Clear the buffer before switching playlists, since it may already contain unplayable segments
_this5.masterPlaylistController_.fastQualityChange_();}});this.handleWaitingForKey_=this.handleWaitingForKey_.bind(this);this.player_.tech_.on('waitingforkey',this.handleWaitingForKey_);// In IE11 this is too early to initialize media keys, and IE11 does not support
// promises.
if(videojs.browser.IE_VERSION===11||!didSetupEmeOptions){// If EME options were not set up, we've done all we could to initialize EME.
this.masterPlaylistController_.sourceUpdater_.initializedEme();return;}this.createKeySessions_();}/**
   * Initializes the quality levels and sets listeners to update them.
   *
   * @method setupQualityLevels_
   * @private
   */;_proto.setupQualityLevels_=function setupQualityLevels_(){var _this6=this;var player=videojs.players[this.tech_.options_.playerId];// if there isn't a player or there isn't a qualityLevels plugin
// or qualityLevels_ listeners have already been setup, do nothing.
if(!player||!player.qualityLevels||this.qualityLevels_){return;}this.qualityLevels_=player.qualityLevels();this.masterPlaylistController_.on('selectedinitialmedia',function(){handleVhsLoadedMetadata(_this6.qualityLevels_,_this6);});this.playlists.on('mediachange',function(){handleVhsMediaChange(_this6.qualityLevels_,_this6.playlists);});}/**
   * return the version
   */;VhsHandler.version=function version$5(){return{'@videojs/http-streaming':version$4,'mux.js':version$3,'mpd-parser':version$2,'m3u8-parser':version$1,'aes-decrypter':video_es_version};}/**
   * return the version
   */;_proto.version=function version(){return this.constructor.version();};_proto.canChangeType=function canChangeType(){return SourceUpdater.canChangeType();}/**
   * Begin playing the video.
   */;_proto.play=function play(){this.masterPlaylistController_.play();}/**
   * a wrapper around the function in MasterPlaylistController
   */;_proto.setCurrentTime=function setCurrentTime(currentTime){this.masterPlaylistController_.setCurrentTime(currentTime);}/**
   * a wrapper around the function in MasterPlaylistController
   */;_proto.duration=function duration(){return this.masterPlaylistController_.duration();}/**
   * a wrapper around the function in MasterPlaylistController
   */;_proto.seekable=function seekable(){return this.masterPlaylistController_.seekable();}/**
   * Abort all outstanding work and cleanup.
   */;_proto.dispose=function dispose(){if(this.playbackWatcher_){this.playbackWatcher_.dispose();}if(this.masterPlaylistController_){this.masterPlaylistController_.dispose();}if(this.qualityLevels_){this.qualityLevels_.dispose();}if(this.player_){delete this.player_.vhs;delete this.player_.dash;delete this.player_.hls;}if(this.tech_&&this.tech_.vhs){delete this.tech_.vhs;}// don't check this.tech_.hls as it will log a deprecated warning
if(this.tech_){delete this.tech_.hls;}if(this.mediaSourceUrl_&&(window_default()).URL.revokeObjectURL){window_default().URL.revokeObjectURL(this.mediaSourceUrl_);this.mediaSourceUrl_=null;}if(this.tech_){this.tech_.off('waitingforkey',this.handleWaitingForKey_);}_Component.prototype.dispose.call(this);};_proto.convertToProgramTime=function convertToProgramTime(time,callback){return getProgramTime({playlist:this.masterPlaylistController_.media(),time:time,callback:callback});}// the player must be playing before calling this
;_proto.seekToProgramTime=function seekToProgramTime$1(programTime,callback,pauseAfterSeek,retryCount){if(pauseAfterSeek===void 0){pauseAfterSeek=true;}if(retryCount===void 0){retryCount=2;}return seekToProgramTime({programTime:programTime,playlist:this.masterPlaylistController_.media(),retryCount:retryCount,pauseAfterSeek:pauseAfterSeek,seekTo:this.options_.seekTo,tech:this.options_.tech,callback:callback});};return VhsHandler;}(Component);/**
 * The Source Handler object, which informs video.js what additional
 * MIME types are supported and sets up playback. It is registered
 * automatically to the appropriate tech based on the capabilities of
 * the browser it is running in. It is not necessary to use or modify
 * this object in normal usage.
 */var VhsSourceHandler={name:'videojs-http-streaming',VERSION:version$4,canHandleSource:function canHandleSource(srcObj,options){if(options===void 0){options={};}var localOptions=videojs.mergeOptions(videojs.options,options);return VhsSourceHandler.canPlayType(srcObj.type,localOptions);},handleSource:function handleSource(source,tech,options){if(options===void 0){options={};}var localOptions=videojs.mergeOptions(videojs.options,options);tech.vhs=new VhsHandler(source,tech,localOptions);if(!videojs.hasOwnProperty('hls')){Object.defineProperty(tech,'hls',{get:function get(){videojs.log.warn('player.tech().hls is deprecated. Use player.tech().vhs instead.');return tech.vhs;},configurable:true});}tech.vhs.xhr=xhrFactory();tech.vhs.src(source.src,source.type);return tech.vhs;},canPlayType:function canPlayType(type,options){var simpleType=simpleTypeFromSourceType(type);if(!simpleType){return'';}var overrideNative=VhsSourceHandler.getOverrideNative(options);var supportsTypeNatively=Vhs.supportsTypeNatively(simpleType);var canUseMsePlayback=!supportsTypeNatively||overrideNative;return canUseMsePlayback?'maybe':'';},getOverrideNative:function getOverrideNative(options){if(options===void 0){options={};}var _options=options,_options$vhs=_options.vhs,vhs=_options$vhs===void 0?{}:_options$vhs,_options$hls=_options.hls,hls=_options$hls===void 0?{}:_options$hls;var defaultOverrideNative=!(videojs.browser.IS_ANY_SAFARI||videojs.browser.IS_IOS);var _vhs$overrideNative=vhs.overrideNative,overrideNative=_vhs$overrideNative===void 0?defaultOverrideNative:_vhs$overrideNative;var _hls$overrideNative=hls.overrideNative,legacyOverrideNative=_hls$overrideNative===void 0?false:_hls$overrideNative;return legacyOverrideNative||overrideNative;}};/**
 * Check to see if the native MediaSource object exists and supports
 * an MP4 container with both H.264 video and AAC-LC audio.
 *
 * @return {boolean} if  native media sources are supported
 */var supportsNativeMediaSources=function supportsNativeMediaSources(){return browserSupportsCodec('avc1.4d400d,mp4a.40.2');};// register source handlers with the appropriate techs
if(supportsNativeMediaSources()){videojs.getTech('Html5').registerSourceHandler(VhsSourceHandler,0);}videojs.VhsHandler=VhsHandler;Object.defineProperty(videojs,'HlsHandler',{get:function get(){videojs.log.warn('videojs.HlsHandler is deprecated. Use videojs.VhsHandler instead.');return VhsHandler;},configurable:true});videojs.VhsSourceHandler=VhsSourceHandler;Object.defineProperty(videojs,'HlsSourceHandler',{get:function get(){videojs.log.warn('videojs.HlsSourceHandler is deprecated. '+'Use videojs.VhsSourceHandler instead.');return VhsSourceHandler;},configurable:true});videojs.Vhs=Vhs;Object.defineProperty(videojs,'Hls',{get:function get(){videojs.log.warn('videojs.Hls is deprecated. Use videojs.Vhs instead.');return Vhs;},configurable:true});if(!videojs.use){videojs.registerComponent('Hls',Vhs);videojs.registerComponent('Vhs',Vhs);}videojs.options.vhs=videojs.options.vhs||{};videojs.options.hls=videojs.options.hls||{};if(!videojs.getPlugin||!videojs.getPlugin('reloadSourceOnError')){var registerPlugin=videojs.registerPlugin||videojs.plugin;registerPlugin('reloadSourceOnError',reloadSourceOnError);}/* harmony default export */ const video_es = (videojs);
// EXTERNAL MODULE: ./node_modules/video.js/dist/video-js.css
var video_js = __webpack_require__(82102);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/video/style.scss
var video_style = __webpack_require__(10962);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.get.js
var es_reflect_get = __webpack_require__(74819);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/forwardButton/forwardButton.js
function forwardButton_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { forwardButton_typeof = function _typeof(obj) { return typeof obj; }; } else { forwardButton_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return forwardButton_typeof(obj); }











function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = forwardButton_getPrototypeOf(object); if (object === null) break; } return object; }
function forwardButton_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) forwardButton_setPrototypeOf(subClass, superClass); }
function forwardButton_setPrototypeOf(o, p) { forwardButton_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return forwardButton_setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = forwardButton_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = forwardButton_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = forwardButton_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (forwardButton_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return forwardButton_assertThisInitialized(self); }
function forwardButton_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function forwardButton_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function forwardButton_getPrototypeOf(o) { forwardButton_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return forwardButton_getPrototypeOf(o); }

var forwardButton_Button = video_es.getComponent('Button');
var ForwardButton = /*#__PURE__*/function (_Button) {
  forwardButton_inherits(ForwardButton, _Button);
  var _super = _createSuper(ForwardButton);
  function ForwardButton(player, options) {
    var _this;
    _classCallCheck(this, ForwardButton);
    _this = _super.call(this, player, options);
    _this.secs = options.seconds || 5;
    return _this;
  }
  _createClass(ForwardButton, [{
    key: "buildCSSClass",
    value: function buildCSSClass() {
      return "vjs-forward-control ".concat(_get(forwardButton_getPrototypeOf(ForwardButton.prototype), "buildCSSClass", this).call(this));
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      var time = this.player().currentTime() + this.secs;
      if (time < 0) {
        time = 0;
      }
      this.player().currentTime(time);
    }
  }]);
  return ForwardButton;
}(forwardButton_Button);
ForwardButton.prototype.controlText_ = 'Forward';
/* harmony default export */ const forwardButton = (ForwardButton);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/forwardButton/style.scss
var forwardButton_style = __webpack_require__(83473);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/forwardButton/index.js
function plugins_forwardButton_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { plugins_forwardButton_typeof = function _typeof(obj) { return typeof obj; }; } else { plugins_forwardButton_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return plugins_forwardButton_typeof(obj); }









function forwardButton_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function plugins_forwardButton_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) plugins_forwardButton_setPrototypeOf(subClass, superClass); }
function plugins_forwardButton_setPrototypeOf(o, p) { plugins_forwardButton_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return plugins_forwardButton_setPrototypeOf(o, p); }
function forwardButton_createSuper(Derived) { var hasNativeReflectConstruct = plugins_forwardButton_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = plugins_forwardButton_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = plugins_forwardButton_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return forwardButton_possibleConstructorReturn(this, result); }; }
function forwardButton_possibleConstructorReturn(self, call) { if (call && (plugins_forwardButton_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return plugins_forwardButton_assertThisInitialized(self); }
function plugins_forwardButton_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function plugins_forwardButton_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function plugins_forwardButton_getPrototypeOf(o) { plugins_forwardButton_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return plugins_forwardButton_getPrototypeOf(o); }



var forwardButton_Plugin = video_es.getPlugin('plugin');
var forwardButton_Component = video_es.getComponent('Component');
forwardButton_Component.registerComponent('forwardButton', forwardButton);
var ForwardButtonPlugin = /*#__PURE__*/function (_Plugin) {
  plugins_forwardButton_inherits(ForwardButtonPlugin, _Plugin);
  var _super = forwardButton_createSuper(ForwardButtonPlugin);
  function ForwardButtonPlugin(player, options) {
    var _this;
    forwardButton_classCallCheck(this, ForwardButtonPlugin);
    _this = _super.call(this, player);
    player.ready(function () {
      player.controlBar.forwardButton = player.controlBar.addChild('forwardButton', {
        seconds: options.seconds
      }, options.index);
    });
    return _this;
  }
  return ForwardButtonPlugin;
}(forwardButton_Plugin);

// EXTERNAL MODULE: ./node_modules/downloadjs/download.js
var download = __webpack_require__(27266);
var download_default = /*#__PURE__*/__webpack_require__.n(download);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/downloadButton/downloadButton.js
function downloadButton_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { downloadButton_typeof = function _typeof(obj) { return typeof obj; }; } else { downloadButton_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return downloadButton_typeof(obj); }











function downloadButton_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function downloadButton_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function downloadButton_createClass(Constructor, protoProps, staticProps) { if (protoProps) downloadButton_defineProperties(Constructor.prototype, protoProps); if (staticProps) downloadButton_defineProperties(Constructor, staticProps); return Constructor; }
function downloadButton_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { downloadButton_get = Reflect.get; } else { downloadButton_get = function _get(target, property, receiver) { var base = downloadButton_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return downloadButton_get(target, property, receiver || target); }
function downloadButton_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = downloadButton_getPrototypeOf(object); if (object === null) break; } return object; }
function downloadButton_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) downloadButton_setPrototypeOf(subClass, superClass); }
function downloadButton_setPrototypeOf(o, p) { downloadButton_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return downloadButton_setPrototypeOf(o, p); }
function downloadButton_createSuper(Derived) { var hasNativeReflectConstruct = downloadButton_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = downloadButton_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = downloadButton_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return downloadButton_possibleConstructorReturn(this, result); }; }
function downloadButton_possibleConstructorReturn(self, call) { if (call && (downloadButton_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return downloadButton_assertThisInitialized(self); }
function downloadButton_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function downloadButton_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function downloadButton_getPrototypeOf(o) { downloadButton_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return downloadButton_getPrototypeOf(o); }


var downloadButton_Button = video_es.getComponent('Button');
var DownloadButton = /*#__PURE__*/function (_Button) {
  downloadButton_inherits(DownloadButton, _Button);
  var _super = downloadButton_createSuper(DownloadButton);
  function DownloadButton(player, options) {
    downloadButton_classCallCheck(this, DownloadButton);
    return _super.call(this, player, options);
  }
  downloadButton_createClass(DownloadButton, [{
    key: "buildCSSClass",
    value: function buildCSSClass() {
      return "vjs-download-button ".concat(downloadButton_get(downloadButton_getPrototypeOf(DownloadButton.prototype), "buildCSSClass", this).call(this));
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      if (!this.options().downloadFn || !this.options().downloadFn(this.options().attachment)) {
        download_default()(this.options().attachment.url);
      }
    }
  }]);
  return DownloadButton;
}(downloadButton_Button);
DownloadButton.prototype.controlText_ = 'Download';
/* harmony default export */ const downloadButton = (DownloadButton);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/downloadButton/style.scss
var downloadButton_style = __webpack_require__(42742);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/downloadButton/index.js
function plugins_downloadButton_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { plugins_downloadButton_typeof = function _typeof(obj) { return typeof obj; }; } else { plugins_downloadButton_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return plugins_downloadButton_typeof(obj); }









function plugins_downloadButton_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function plugins_downloadButton_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) plugins_downloadButton_setPrototypeOf(subClass, superClass); }
function plugins_downloadButton_setPrototypeOf(o, p) { plugins_downloadButton_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return plugins_downloadButton_setPrototypeOf(o, p); }
function plugins_downloadButton_createSuper(Derived) { var hasNativeReflectConstruct = plugins_downloadButton_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = plugins_downloadButton_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = plugins_downloadButton_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return plugins_downloadButton_possibleConstructorReturn(this, result); }; }
function plugins_downloadButton_possibleConstructorReturn(self, call) { if (call && (plugins_downloadButton_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return plugins_downloadButton_assertThisInitialized(self); }
function plugins_downloadButton_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function plugins_downloadButton_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function plugins_downloadButton_getPrototypeOf(o) { plugins_downloadButton_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return plugins_downloadButton_getPrototypeOf(o); }



var downloadButton_Plugin = video_es.getPlugin('plugin');
var downloadButton_Component = video_es.getComponent('Component');
downloadButton_Component.registerComponent('downloadButton', downloadButton);
var DownloadButtonPlugin = /*#__PURE__*/function (_Plugin) {
  plugins_downloadButton_inherits(DownloadButtonPlugin, _Plugin);
  var _super = plugins_downloadButton_createSuper(DownloadButtonPlugin);
  function DownloadButtonPlugin(player, options) {
    var _this;
    plugins_downloadButton_classCallCheck(this, DownloadButtonPlugin);
    _this = _super.call(this, player);
    player.ready(function () {
      player.controlBar.downloadButton = player.controlBar.addChild('downloadButton', {
        downloadFn: options.downloadFn,
        attachment: options.attachment
      }, options.index);
    });
    return _this;
  }
  return DownloadButtonPlugin;
}(downloadButton_Plugin);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/controlShadow/controlShadow.js
function controlShadow_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { controlShadow_typeof = function _typeof(obj) { return typeof obj; }; } else { controlShadow_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return controlShadow_typeof(obj); }











function controlShadow_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function controlShadow_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function controlShadow_createClass(Constructor, protoProps, staticProps) { if (protoProps) controlShadow_defineProperties(Constructor.prototype, protoProps); if (staticProps) controlShadow_defineProperties(Constructor, staticProps); return Constructor; }
function controlShadow_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { controlShadow_get = Reflect.get; } else { controlShadow_get = function _get(target, property, receiver) { var base = controlShadow_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return controlShadow_get(target, property, receiver || target); }
function controlShadow_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = controlShadow_getPrototypeOf(object); if (object === null) break; } return object; }
function controlShadow_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) controlShadow_setPrototypeOf(subClass, superClass); }
function controlShadow_setPrototypeOf(o, p) { controlShadow_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return controlShadow_setPrototypeOf(o, p); }
function controlShadow_createSuper(Derived) { var hasNativeReflectConstruct = controlShadow_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = controlShadow_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = controlShadow_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return controlShadow_possibleConstructorReturn(this, result); }; }
function controlShadow_possibleConstructorReturn(self, call) { if (call && (controlShadow_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return controlShadow_assertThisInitialized(self); }
function controlShadow_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function controlShadow_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function controlShadow_getPrototypeOf(o) { controlShadow_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return controlShadow_getPrototypeOf(o); }

var controlShadow_Spacer = video_es.getComponent('Spacer');
var ControlShadow = /*#__PURE__*/function (_Spacer) {
  controlShadow_inherits(ControlShadow, _Spacer);
  var _super = controlShadow_createSuper(ControlShadow);
  function ControlShadow(player, options) {
    controlShadow_classCallCheck(this, ControlShadow);
    return _super.call(this, player, options);
  }
  controlShadow_createClass(ControlShadow, [{
    key: "buildCSSClass",
    value: function buildCSSClass() {
      return "vjs-shadow";
    }
  }, {
    key: "createEl",
    value: function createEl() {
      var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!props.className) {
        props.className = this.buildCSSClass();
      }
      var node = controlShadow_get(controlShadow_getPrototypeOf(ControlShadow.prototype), "createEl", this).call(this, tag, props, attributes);
      var controlShadow = document.createElement('div');
      controlShadow.classList.add('vjs-control-shadow');
      var videoName = document.createElement('div');
      videoName.classList.add('vjs-video-name');
      videoName.innerText = this.options().videoName;
      node.appendChild(videoName);
      node.appendChild(controlShadow);
      return node;
    }
  }]);
  return ControlShadow;
}(controlShadow_Spacer);
ControlShadow.prototype.controlText_ = 'Shadow';
/* harmony default export */ const controlShadow = (ControlShadow);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/controlShadow/style.scss
var controlShadow_style = __webpack_require__(95306);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/controlShadow/index.js
function plugins_controlShadow_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { plugins_controlShadow_typeof = function _typeof(obj) { return typeof obj; }; } else { plugins_controlShadow_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return plugins_controlShadow_typeof(obj); }














function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function plugins_controlShadow_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function plugins_controlShadow_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) plugins_controlShadow_setPrototypeOf(subClass, superClass); }
function plugins_controlShadow_setPrototypeOf(o, p) { plugins_controlShadow_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return plugins_controlShadow_setPrototypeOf(o, p); }
function plugins_controlShadow_createSuper(Derived) { var hasNativeReflectConstruct = plugins_controlShadow_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = plugins_controlShadow_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = plugins_controlShadow_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return plugins_controlShadow_possibleConstructorReturn(this, result); }; }
function plugins_controlShadow_possibleConstructorReturn(self, call) { if (call && (plugins_controlShadow_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return plugins_controlShadow_assertThisInitialized(self); }
function plugins_controlShadow_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function plugins_controlShadow_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function plugins_controlShadow_getPrototypeOf(o) { plugins_controlShadow_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return plugins_controlShadow_getPrototypeOf(o); }



var controlShadow_Plugin = video_es.getPlugin('plugin');
var controlShadow_Component = video_es.getComponent('Component');
controlShadow_Component.registerComponent('controlShadow', controlShadow);
var ControlShadowPlugin = /*#__PURE__*/function (_Plugin) {
  plugins_controlShadow_inherits(ControlShadowPlugin, _Plugin);
  var _super = plugins_controlShadow_createSuper(ControlShadowPlugin);
  function ControlShadowPlugin(player, options) {
    var _this;
    plugins_controlShadow_classCallCheck(this, ControlShadowPlugin);
    _this = _super.call(this, player);
    player.controlShadow = player.addChild('controlShadow', _objectSpread({}, options), 3);
    return _this;
  }
  return ControlShadowPlugin;
}(controlShadow_Plugin);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/preact/hooks/dist/hooks.module.js
var hooks_module = __webpack_require__(8065);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/callToAction/style.scss
var callToAction_style = __webpack_require__(8523);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/callToAction/ctaComponent.js
function ctaComponent_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
















var buttonPadding = parseInt(callToAction_style.ctaButtonPadding.replace('px', ''));
var PlayAgainButton = function PlayAgainButton(_ref) {
  var onPlayAgain = _ref.onPlayAgain,
    type = _ref.type,
    description = _ref.description,
    i18n = _ref.i18n;
  var className = ['video-player-cta__play-again-button'];
  if (type === 'button' && !description || type === 'image') {
    className.push('video-player-cta__play-again-button_style_button');
  }
  return (0,preact_module.h)("div", {
    className: "video-player-cta__play-again-wrap"
  }, (0,preact_module.h)("button", {
    onClick: onPlayAgain,
    className: className.join(' ')
  }, (0,preact_module.h)("span", null, i18n.get('video.player.watch_again'))));
};
var CtaButton = function CtaButton(props) {
  var description = props.description,
    title = props.title,
    address = props.address,
    buttonSize = props.buttonSize,
    background = props.background,
    buttonShape = props.buttonShape,
    buttonId = props.buttonId,
    playAgainBtn = props.playAgainBtn;
  var wrapCls = ['button-single'];
  if (description) {
    wrapCls.push('video-player-cta__button');
  }
  return (0,preact_module.h)("div", {
    className: "video-player-cta__button-wrapper"
  }, (0,preact_module.h)("div", {
    className: wrapCls.join(' ')
  }, (0,preact_module.h)("div", {
    className: "video-player-cta__nimbus-button-wrap"
  }, (0,preact_module.h)("nimbus-button", {
    id: buttonId,
    "data-size": buttonSize,
    "data-background": background,
    "data-shape": buttonShape,
    "data-type": "default",
    className: "single-button",
    onClick: function onClick() {
      return window.open(address, '_blank');
    }
  }, (0,preact_module.h)("span", {
    className: "button-content"
  }, (0,preact_module.h)("b", null, title)))), description ? (0,preact_module.h)("div", {
    className: "video-payer-cta__description"
  }, description) : null, props.whenToShow === 'end' && props.showPlayAgain ? (0,preact_module.h)(PlayAgainButton, props) : null), playAgainBtn);
};
var CtaImageLink = function CtaImageLink(_ref2) {
  var address = _ref2.address,
    children = _ref2.children;
  if (address) {
    return (0,preact_module.h)("a", {
      href: address,
      target: "_blank",
      className: "video-payer-cta__image-link"
    }, children);
  }
  return children;
};
var CtaImage = function CtaImage(props) {
  var address = props.address,
    imageUrl = props.imageUrl;
  return (0,preact_module.h)("div", {
    className: "video-player-cta__image-wrapper"
  }, (0,preact_module.h)(CtaImageLink, {
    address: address
  }, (0,preact_module.h)("img", {
    src: imageUrl,
    className: "video-player-cta__image"
  })), props.whenToShow === 'end' && props.showPlayAgain ? (0,preact_module.h)(PlayAgainButton, props) : null);
};
var recalculateSize = function recalculateSize(wrapRef, ctaRef, params) {
  if (!(ctaRef !== null && ctaRef !== void 0 && ctaRef.current) || !(wrapRef !== null && wrapRef !== void 0 && wrapRef.current)) return false;
  var setHeight = params.setHeight,
    setWidth = params.setWidth,
    setButtonOversize = params.setButtonOversize,
    setCtaOversize = params.setCtaOversize,
    setIsPanel = params.setIsPanel,
    hideControls = params.hideControls;
  var ctaRect = ctaRef.current.getBoundingClientRect();
  var _wrapRef$current$clos = wrapRef.current.closest('.video-js').querySelector('video').getBoundingClientRect(),
    width = _wrapRef$current$clos.width,
    height = _wrapRef$current$clos.height;
  if (height) {
    var hasPanel = width >= 350 && !hideControls;
    var oversize = ctaRect.height >= height - 30;
    var buttonOversize = ctaRect.width >= width - 2 * buttonPadding;
    setHeight(height);
    setWidth(width);
    setButtonOversize(buttonOversize);
    setCtaOversize(oversize);
    setIsPanel(hasPanel);
  }
};
var CtaComponent = function CtaComponent(props) {
  var _ref3;
  var hideControls = props.hideControls,
    type = props.type,
    description = props.description,
    title = props.title;
  var ref = (0,hooks_module/* useRef */.sO)(null);
  var ctaRef = (0,hooks_module/* useRef */.sO)(null);
  var _useState = (0,hooks_module/* useState */.eJ)(0),
    _useState2 = _slicedToArray(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    height = _useState4[0],
    setHeight = _useState4[1];
  var _useState5 = (0,hooks_module/* useState */.eJ)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    buttonOversize = _useState6[0],
    setButtonOversize = _useState6[1];
  var _useState7 = (0,hooks_module/* useState */.eJ)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    ctaOversize = _useState8[0],
    setCtaOversize = _useState8[1];
  var _useState9 = (0,hooks_module/* useState */.eJ)(true),
    _useState10 = _slicedToArray(_useState9, 2),
    isPanel = _useState10[0],
    setIsPanel = _useState10[1];
  (0,hooks_module/* useEffect */.d4)(function () {
    setCtaOversize(false);
  }, [description, title]);
  (0,hooks_module/* useEffect */.d4)(function () {
    if (!(ref !== null && ref !== void 0 && ref.current)) return;
    var ro = new ResizeObserver(function () {
      recalculateSize(ref, ctaRef, {
        setWidth: setWidth,
        setHeight: setHeight,
        setButtonOversize: setButtonOversize,
        setCtaOversize: setCtaOversize,
        setIsPanel: setIsPanel,
        hideControls: hideControls
      });
    });
    ro.observe(ref.current);
    return function () {
      ro.disconnect(ref.current);
    };
  }, [ctaRef === null || ctaRef === void 0 ? void 0 : ctaRef.current]);
  var cls = ['video-player-cta'];
  if (props.showPlayAgain && props.whenToShow === 'end') {
    cls.push('video-player-cta_play-again');
  }
  if (props.type === 'button') {
    cls.push('video-player-cta_button');
  }
  if (buttonOversize) {
    cls.push('video-player-cta_button-oversize');
  }
  if (ctaOversize) {
    cls.push('video-player-cta_oversize');
  }
  if (isPanel) {
    cls.push('video-player-cta_panel');
  }
  var ctaItemCls = ['video-player-cta__cta'];
  if (type === 'image') {
    ctaItemCls.push('video-player-cta__cta_type_image');
  }
  if (type === 'button') {
    ctaItemCls.push('video-player-cta__cta_type_button');
  }
  var playAgainBtn = props.whenToShow === 'end' && props.showPlayAgain && type !== 'button' ? (0,preact_module.h)(PlayAgainButton, props) : null;
  return (0,preact_module.h)("div", {
    className: cls.join(' '),
    ref: ref,
    style: (_ref3 = {}, ctaComponent_defineProperty(_ref3, '--height', height + 'px'), ctaComponent_defineProperty(_ref3, '--width', width + 'px'), _ref3)
  }, (0,preact_module.h)("div", {
    className: ctaItemCls.join(' '),
    ref: ctaRef
  }, type === 'button' ? (0,preact_module.h)(CtaButton, props) : null, type === 'image' ? (0,preact_module.h)(CtaImage, props) : null));
};
/* harmony default export */ const ctaComponent = (CtaComponent);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/callToAction/cta.js
function cta_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { cta_typeof = function _typeof(obj) { return typeof obj; }; } else { cta_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return cta_typeof(obj); }












function cta_extends() { cta_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cta_extends.apply(this, arguments); }
function cta_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function cta_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function cta_createClass(Constructor, protoProps, staticProps) { if (protoProps) cta_defineProperties(Constructor.prototype, protoProps); if (staticProps) cta_defineProperties(Constructor, staticProps); return Constructor; }
function cta_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { cta_get = Reflect.get; } else { cta_get = function _get(target, property, receiver) { var base = cta_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return cta_get(target, property, receiver || target); }
function cta_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = cta_getPrototypeOf(object); if (object === null) break; } return object; }
function cta_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) cta_setPrototypeOf(subClass, superClass); }
function cta_setPrototypeOf(o, p) { cta_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return cta_setPrototypeOf(o, p); }
function cta_createSuper(Derived) { var hasNativeReflectConstruct = cta_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = cta_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = cta_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return cta_possibleConstructorReturn(this, result); }; }
function cta_possibleConstructorReturn(self, call) { if (call && (cta_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return cta_assertThisInitialized(self); }
function cta_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function cta_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function cta_getPrototypeOf(o) { cta_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return cta_getPrototypeOf(o); }
function cta_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var cta_Spacer = video_es.getComponent('Spacer');
var CTA = /*#__PURE__*/function (_Spacer) {
  cta_inherits(CTA, _Spacer);
  var _super = cta_createSuper(CTA);
  function CTA(player, options) {
    var _this;
    cta_classCallCheck(this, CTA);
    _this = _super.call(this, player, options);
    cta_defineProperty(cta_assertThisInitialized(_this), "onPlayerPause", function () {
      if (_this.player().ended()) return;
      var _this$options = _this.options(),
        whenToShow = _this$options.whenToShow;
      if (whenToShow !== 'pause') return;
      _this.renderCtaComponent();
    });
    cta_defineProperty(cta_assertThisInitialized(_this), "onPlayerEnded", function () {
      var _this$options2 = _this.options(),
        whenToShow = _this$options2.whenToShow;
      if (whenToShow !== 'end') return;
      _this.renderCtaComponent();
    });
    cta_defineProperty(cta_assertThisInitialized(_this), "onPlayerPlay", function () {
      _this.renderCtaComponent(false);
    });
    cta_defineProperty(cta_assertThisInitialized(_this), "onPlayAgain", function () {
      _this.player().play();
    });
    player.on('pause', _this.onPlayerPause);
    player.on('ended', _this.onPlayerEnded);
    player.on('play', _this.onPlayerPlay);
    return _this;
  }
  cta_createClass(CTA, [{
    key: "renderCtaComponent",
    value: function renderCtaComponent() {
      var render = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var container = this.el();
      if (render) {
        (0,preact_module/* render */.sY)((0,preact_module.h)(ctaComponent, cta_extends({}, this.options(), {
          hideControls: !this.player().options().controls,
          onPlayAgain: this.onPlayAgain,
          i18n: this.options().editor.plugins.i18n
        })), container);
      } else if (container.childNodes.length) {
        (0,preact_module/* render */.sY)(null, container);
      }
    }
  }, {
    key: "buildCSSClass",
    value: function buildCSSClass() {
      return "vjs-cta";
    }
  }, {
    key: "createEl",
    value: function createEl() {
      var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!props.className) {
        props.className = this.buildCSSClass();
      }
      return cta_get(cta_getPrototypeOf(CTA.prototype), "createEl", this).call(this, tag, props, attributes);
    }
  }]);
  return CTA;
}(cta_Spacer);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/callToAction/index.js
function callToAction_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { callToAction_typeof = function _typeof(obj) { return typeof obj; }; } else { callToAction_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return callToAction_typeof(obj); }














function callToAction_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function callToAction_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { callToAction_ownKeys(Object(source), true).forEach(function (key) { callToAction_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { callToAction_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function callToAction_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function callToAction_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function callToAction_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) callToAction_setPrototypeOf(subClass, superClass); }
function callToAction_setPrototypeOf(o, p) { callToAction_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return callToAction_setPrototypeOf(o, p); }
function callToAction_createSuper(Derived) { var hasNativeReflectConstruct = callToAction_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = callToAction_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = callToAction_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return callToAction_possibleConstructorReturn(this, result); }; }
function callToAction_possibleConstructorReturn(self, call) { if (call && (callToAction_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return callToAction_assertThisInitialized(self); }
function callToAction_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function callToAction_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function callToAction_getPrototypeOf(o) { callToAction_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return callToAction_getPrototypeOf(o); }



var callToAction_Plugin = video_es.getPlugin('plugin');
var callToAction_Component = video_es.getComponent('Component');
callToAction_Component.registerComponent('cta', CTA);
var CallToActionPlugin = /*#__PURE__*/function (_Plugin) {
  callToAction_inherits(CallToActionPlugin, _Plugin);
  var _super = callToAction_createSuper(CallToActionPlugin);
  function CallToActionPlugin(player, options) {
    var _this;
    callToAction_classCallCheck(this, CallToActionPlugin);
    _this = _super.call(this, player);
    player.cta = player.addChild('cta', callToAction_objectSpread({}, options), 2);
    return _this;
  }
  return CallToActionPlugin;
}(callToAction_Plugin);

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/icons.js
var icons = __webpack_require__(49190);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/nimbusAdv/nimbusAdv.js
function nimbusAdv_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { nimbusAdv_typeof = function _typeof(obj) { return typeof obj; }; } else { nimbusAdv_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return nimbusAdv_typeof(obj); }











function nimbusAdv_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function nimbusAdv_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function nimbusAdv_createClass(Constructor, protoProps, staticProps) { if (protoProps) nimbusAdv_defineProperties(Constructor.prototype, protoProps); if (staticProps) nimbusAdv_defineProperties(Constructor, staticProps); return Constructor; }
function nimbusAdv_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { nimbusAdv_get = Reflect.get; } else { nimbusAdv_get = function _get(target, property, receiver) { var base = nimbusAdv_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return nimbusAdv_get(target, property, receiver || target); }
function nimbusAdv_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = nimbusAdv_getPrototypeOf(object); if (object === null) break; } return object; }
function nimbusAdv_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) nimbusAdv_setPrototypeOf(subClass, superClass); }
function nimbusAdv_setPrototypeOf(o, p) { nimbusAdv_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return nimbusAdv_setPrototypeOf(o, p); }
function nimbusAdv_createSuper(Derived) { var hasNativeReflectConstruct = nimbusAdv_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = nimbusAdv_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = nimbusAdv_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return nimbusAdv_possibleConstructorReturn(this, result); }; }
function nimbusAdv_possibleConstructorReturn(self, call) { if (call && (nimbusAdv_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return nimbusAdv_assertThisInitialized(self); }
function nimbusAdv_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function nimbusAdv_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function nimbusAdv_getPrototypeOf(o) { nimbusAdv_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return nimbusAdv_getPrototypeOf(o); }
function nimbusAdv_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var nimbusAdv_Spacer = video_es.getComponent('Spacer');
var NimbusAdv = /*#__PURE__*/function (_Spacer) {
  nimbusAdv_inherits(NimbusAdv, _Spacer);
  var _super = nimbusAdv_createSuper(NimbusAdv);
  function NimbusAdv(player, options) {
    var _this;
    nimbusAdv_classCallCheck(this, NimbusAdv);
    _this = _super.call(this, player, options);
    nimbusAdv_defineProperty(nimbusAdv_assertThisInitialized(_this), "onPlayerEnded", function () {
      if (!_this.options().showAdv) return;
      _this.renderAdvComonent();
    });
    nimbusAdv_defineProperty(nimbusAdv_assertThisInitialized(_this), "onPlayerPlay", function () {
      if (!_this.options().showAdv) return;
      _this.renderAdvComonent(false);
    });
    nimbusAdv_defineProperty(nimbusAdv_assertThisInitialized(_this), "onPlayAgain", function () {
      _this.player().play();
    });
    player.on('ended', _this.onPlayerEnded);
    player.on('play', _this.onPlayerPlay);
    return _this;
  }
  nimbusAdv_createClass(NimbusAdv, [{
    key: "getAdvHTML",
    value: function getAdvHTML() {
      var _this$options = this.options(),
        blot = _this$options.blot;
      return blot && blot.blotConfig && blot.blotConfig.getAdvert() || null;
    }
  }, {
    key: "renderAdvComonent",
    value: function renderAdvComonent() {
      var render = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var advHTML = this.getAdvHTML();
      var container = this.el();
      if (advHTML && render) {
        var watchAgain = this.options().editor.plugins.i18n.get('video.player.watch_again');
        var component = (0,preact_module.h)("div", {
          className: 'video-player-popup'
        }, (0,preact_module.h)("div", {
          className: "video-player-popup-bg"
        }, (0,preact_module.h)("div", {
          className: "popup-content",
          dangerouslySetInnerHTML: {
            __html: advHTML
          }
        })), (0,preact_module.h)("div", {
          className: "watch-again",
          onClick: this.onPlayAgain
        }, (0,preact_module.h)(icons/* IconWatchAgain */._Ts, null), watchAgain));
        (0,preact_module/* render */.sY)(component, container);
      } else if (container.childNodes.length) {
        (0,preact_module/* render */.sY)(null, container);
      }
    }
  }, {
    key: "buildCSSClass",
    value: function buildCSSClass() {
      return "vjs-nimbus-adv";
    }
  }, {
    key: "createEl",
    value: function createEl() {
      var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!props.className) {
        props.className = this.buildCSSClass();
      }
      return nimbusAdv_get(nimbusAdv_getPrototypeOf(NimbusAdv.prototype), "createEl", this).call(this, tag, props, attributes);
    }
  }]);
  return NimbusAdv;
}(nimbusAdv_Spacer);

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/nimbusAdv/style.scss
var nimbusAdv_style = __webpack_require__(53893);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/nimbusAdv/index.js
function plugins_nimbusAdv_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { plugins_nimbusAdv_typeof = function _typeof(obj) { return typeof obj; }; } else { plugins_nimbusAdv_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return plugins_nimbusAdv_typeof(obj); }














function nimbusAdv_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function nimbusAdv_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { nimbusAdv_ownKeys(Object(source), true).forEach(function (key) { plugins_nimbusAdv_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { nimbusAdv_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function plugins_nimbusAdv_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function plugins_nimbusAdv_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function plugins_nimbusAdv_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) plugins_nimbusAdv_setPrototypeOf(subClass, superClass); }
function plugins_nimbusAdv_setPrototypeOf(o, p) { plugins_nimbusAdv_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return plugins_nimbusAdv_setPrototypeOf(o, p); }
function plugins_nimbusAdv_createSuper(Derived) { var hasNativeReflectConstruct = plugins_nimbusAdv_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = plugins_nimbusAdv_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = plugins_nimbusAdv_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return plugins_nimbusAdv_possibleConstructorReturn(this, result); }; }
function plugins_nimbusAdv_possibleConstructorReturn(self, call) { if (call && (plugins_nimbusAdv_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return plugins_nimbusAdv_assertThisInitialized(self); }
function plugins_nimbusAdv_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function plugins_nimbusAdv_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function plugins_nimbusAdv_getPrototypeOf(o) { plugins_nimbusAdv_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return plugins_nimbusAdv_getPrototypeOf(o); }



var nimbusAdv_Plugin = video_es.getPlugin('plugin');
var nimbusAdv_Component = video_es.getComponent('Component');
nimbusAdv_Component.registerComponent('nimbusAdv', NimbusAdv);
var NimbusAdvPlugin = /*#__PURE__*/function (_Plugin) {
  plugins_nimbusAdv_inherits(NimbusAdvPlugin, _Plugin);
  var _super = plugins_nimbusAdv_createSuper(NimbusAdvPlugin);
  function NimbusAdvPlugin(player, options) {
    var _this;
    plugins_nimbusAdv_classCallCheck(this, NimbusAdvPlugin);
    _this = _super.call(this, player);
    player.nimbusAdv = player.addChild('nimbusAdv', nimbusAdv_objectSpread({}, options), 4);
    return _this;
  }
  return NimbusAdvPlugin;
}(nimbusAdv_Plugin);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/togglePlay/togglePlay.js
function togglePlay_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { togglePlay_typeof = function _typeof(obj) { return typeof obj; }; } else { togglePlay_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return togglePlay_typeof(obj); }











function togglePlay_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function togglePlay_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function togglePlay_createClass(Constructor, protoProps, staticProps) { if (protoProps) togglePlay_defineProperties(Constructor.prototype, protoProps); if (staticProps) togglePlay_defineProperties(Constructor, staticProps); return Constructor; }
function togglePlay_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { togglePlay_get = Reflect.get; } else { togglePlay_get = function _get(target, property, receiver) { var base = togglePlay_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return togglePlay_get(target, property, receiver || target); }
function togglePlay_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = togglePlay_getPrototypeOf(object); if (object === null) break; } return object; }
function togglePlay_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) togglePlay_setPrototypeOf(subClass, superClass); }
function togglePlay_setPrototypeOf(o, p) { togglePlay_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return togglePlay_setPrototypeOf(o, p); }
function togglePlay_createSuper(Derived) { var hasNativeReflectConstruct = togglePlay_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = togglePlay_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = togglePlay_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return togglePlay_possibleConstructorReturn(this, result); }; }
function togglePlay_possibleConstructorReturn(self, call) { if (call && (togglePlay_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return togglePlay_assertThisInitialized(self); }
function togglePlay_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function togglePlay_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function togglePlay_getPrototypeOf(o) { togglePlay_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return togglePlay_getPrototypeOf(o); }

var togglePlay_Button = video_es.getComponent('Button');
var TogglePlay = /*#__PURE__*/function (_Button) {
  togglePlay_inherits(TogglePlay, _Button);
  var _super = togglePlay_createSuper(TogglePlay);
  function TogglePlay(player, options) {
    togglePlay_classCallCheck(this, TogglePlay);
    return _super.call(this, player, options);
  }
  togglePlay_createClass(TogglePlay, [{
    key: "buildCSSClass",
    value: function buildCSSClass() {
      return "vjs-toggle-play";
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault();
      if (this.player().paused()) {
        this.player().play();
      } else {
        this.player().pause();
      }
    }
  }, {
    key: "createEl",
    value: function createEl() {
      var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!props.className) {
        props.className = this.buildCSSClass();
      }
      return togglePlay_get(togglePlay_getPrototypeOf(TogglePlay.prototype), "createEl", this).call(this, tag, props, attributes);
    }
  }]);
  return TogglePlay;
}(togglePlay_Button);
TogglePlay.prototype.controlText_ = 'Toggle Play';
/* harmony default export */ const togglePlay = (TogglePlay);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/togglePlay/style.scss
var togglePlay_style = __webpack_require__(80049);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/togglePlay/index.js
function plugins_togglePlay_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { plugins_togglePlay_typeof = function _typeof(obj) { return typeof obj; }; } else { plugins_togglePlay_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return plugins_togglePlay_typeof(obj); }









function plugins_togglePlay_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function plugins_togglePlay_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) plugins_togglePlay_setPrototypeOf(subClass, superClass); }
function plugins_togglePlay_setPrototypeOf(o, p) { plugins_togglePlay_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return plugins_togglePlay_setPrototypeOf(o, p); }
function plugins_togglePlay_createSuper(Derived) { var hasNativeReflectConstruct = plugins_togglePlay_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = plugins_togglePlay_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = plugins_togglePlay_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return plugins_togglePlay_possibleConstructorReturn(this, result); }; }
function plugins_togglePlay_possibleConstructorReturn(self, call) { if (call && (plugins_togglePlay_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return plugins_togglePlay_assertThisInitialized(self); }
function plugins_togglePlay_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function plugins_togglePlay_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function plugins_togglePlay_getPrototypeOf(o) { plugins_togglePlay_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return plugins_togglePlay_getPrototypeOf(o); }



var togglePlay_Plugin = video_es.getPlugin('plugin');
var togglePlay_Component = video_es.getComponent('Component');
togglePlay_Component.registerComponent('togglePlay', togglePlay);
var TogglePlayPlugin = /*#__PURE__*/function (_Plugin) {
  plugins_togglePlay_inherits(TogglePlayPlugin, _Plugin);
  var _super = plugins_togglePlay_createSuper(TogglePlayPlugin);
  function TogglePlayPlugin(player) {
    var _this;
    plugins_togglePlay_classCallCheck(this, TogglePlayPlugin);
    _this = _super.call(this, player);
    player.togglePlay = player.addChild('togglePlay', {}, 5);
    return _this;
  }
  return TogglePlayPlugin;
}(togglePlay_Plugin);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/previewVideo/previewVideo.js
function previewVideo_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { previewVideo_typeof = function _typeof(obj) { return typeof obj; }; } else { previewVideo_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return previewVideo_typeof(obj); }
















function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function previewVideo_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function previewVideo_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function previewVideo_createClass(Constructor, protoProps, staticProps) { if (protoProps) previewVideo_defineProperties(Constructor.prototype, protoProps); if (staticProps) previewVideo_defineProperties(Constructor, staticProps); return Constructor; }
function previewVideo_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { previewVideo_get = Reflect.get; } else { previewVideo_get = function _get(target, property, receiver) { var base = previewVideo_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return previewVideo_get(target, property, receiver || target); }
function previewVideo_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = previewVideo_getPrototypeOf(object); if (object === null) break; } return object; }
function previewVideo_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) previewVideo_setPrototypeOf(subClass, superClass); }
function previewVideo_setPrototypeOf(o, p) { previewVideo_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return previewVideo_setPrototypeOf(o, p); }
function previewVideo_createSuper(Derived) { var hasNativeReflectConstruct = previewVideo_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = previewVideo_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = previewVideo_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return previewVideo_possibleConstructorReturn(this, result); }; }
function previewVideo_possibleConstructorReturn(self, call) { if (call && (previewVideo_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return previewVideo_assertThisInitialized(self); }
function previewVideo_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function previewVideo_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function previewVideo_getPrototypeOf(o) { previewVideo_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return previewVideo_getPrototypeOf(o); }
function previewVideo_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var previewVideo_Spacer = video_es.getComponent('Spacer');
var PreviewVideo = /*#__PURE__*/function (_Spacer) {
  previewVideo_inherits(PreviewVideo, _Spacer);
  var _super = previewVideo_createSuper(PreviewVideo);
  function PreviewVideo(player, options) {
    var _this;
    previewVideo_classCallCheck(this, PreviewVideo);
    _this = _super.call(this, player, options);
    previewVideo_defineProperty(previewVideo_assertThisInitialized(_this), "reRender", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(newSettings) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.previewSettings = newSettings;
                if (!_this.previewSettings) {
                  _context.next = 7;
                  break;
                }
                _context.next = 4;
                return _this.loadPreviewAttach();
              case 4:
                _this.setState({
                  textColor: _this.previewSettings ? _this.previewSettings.textOverlay ? _this.previewSettings.textOverlay.color : '#fff' : ''
                });
                _this.previewArea();
                _this.renderPreviewComponent();
              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    previewVideo_defineProperty(previewVideo_assertThisInitialized(_this), "onPlayerResize", function () {
      if (_this.previewSettings) {
        _this.previewArea();
        _this.renderPreviewComponent();
      }
    });
    previewVideo_defineProperty(previewVideo_assertThisInitialized(_this), "loadPreviewAttach", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var attachId, attach;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              attachId = null;
              if (!_this.previewSettings) {
                _context2.next = 12;
                break;
              }
              if (!(_this.previewSettings.activePreviewType == 'first_frame')) {
                _context2.next = 6;
                break;
              }
              _this.setState({
                previewImage: null,
                previewBackground: 'none'
              });
              _context2.next = 12;
              break;
            case 6:
              attachId = _this.previewSettings.previews[_this.previewSettings.activePreviewType].attachmentGlobalId;
              if (!attachId) {
                _context2.next = 12;
                break;
              }
              _context2.next = 10;
              return _this.previewAttach(attachId);
            case 10:
              attach = _context2.sent;
              if (attach) {
                _this.setState({
                  previewImage: attach.url,
                  previewBackground: '#141414'
                });
              }
            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    previewVideo_defineProperty(previewVideo_assertThisInitialized(_this), "onPlayerReady", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!_this.previewSettings) {
                _context3.next = 5;
                break;
              }
              _context3.next = 3;
              return _this.loadPreviewAttach();
            case 3:
              _this.previewArea();
              _this.renderPreviewComponent();
            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    previewVideo_defineProperty(previewVideo_assertThisInitialized(_this), "onPlayerPlay", function () {
      _this.setState({
        playerIsPlayed: true
      });
      _this.renderPreviewComponent(false);
    });
    previewVideo_defineProperty(previewVideo_assertThisInitialized(_this), "onPlayerPause", function () {
      _this.setState({
        playerIsPlayed: true
      });
      _this.renderPreviewComponent(false);
    });
    previewVideo_defineProperty(previewVideo_assertThisInitialized(_this), "findFnt", function (ctx, textTemplate, widthOfVideo, fontSizes, lastI) {
      var lines = _this.wrapTextNew(ctx, textTemplate, widthOfVideo);
      if (lines.length > 2) {
        ctx.font = fontSizes[lastI++] + 'px Arial';
        return _this.findFnt(ctx, textTemplate, widthOfVideo, fontSizes, lastI);
      }
      return [lines, lastI];
    });
    previewVideo_defineProperty(previewVideo_assertThisInitialized(_this), "findHeightFnt", function (ctx, lines, canvasHeight, fontSizes, lastI) {
      var fontHeight = 0;
      var height;
      var textDimensions;
      for (var $i = 0; $i < lines.length; $i++) {
        ctx.font = fontSizes[lastI] + 'pt Arial';
        textDimensions = ctx.measureText(lines[$i]);
        height = parseInt(ctx.font.match(/\d+/), 10);
        fontHeight = fontHeight + height;
      }
      if (fontHeight > canvasHeight) {
        return _this.findHeightFnt(ctx, lines, canvasHeight, fontSizes, ++lastI);
      }
      return fontSizes[lastI];
    });
    previewVideo_defineProperty(previewVideo_assertThisInitialized(_this), "wrapTextNew", function (ctx, text, maxWidth) {
      var words = text.split(' ');
      var line = ''; // This will store the text of the current line
      var testLine = ''; // This will store the text when we add a word, to test if it's too long
      var lineArray = []; // This is an array of lines, which the function will return
      // Lets iterate over each word
      for (var n = 0; n < words.length; n++) {
        // Create a test line, and measure it..
        testLine += "".concat(words[n], " ");
        var metrics = ctx.measureText(testLine);
        var testWidth = metrics.width;
        // If the width of this test line is more than the max width
        if (testWidth > maxWidth && n > 0) {
          // Then the line is finished, push the current line into "lineArray"
          lineArray.push(line);
          line = "".concat(words[n], " ");
          testLine = "".concat(words[n], " ");
        } else {
          // If the test line is still less than the max width, then add the word to the current line
          line += "".concat(words[n], " ");
        }
        // If we never reach the full max width, then there is only one line.. so push it into the lineArray so we return something
        if (n === words.length - 1) {
          lineArray.push(line);
        }
      }
      // Return the line array
      return lineArray;
    });
    previewVideo_defineProperty(previewVideo_assertThisInitialized(_this), "setTextDisplay", function (displayState) {
      _this.setState({
        display: displayState
      });
    });
    previewVideo_defineProperty(previewVideo_assertThisInitialized(_this), "previewArea", function () {
      if (_this.state.playerIsPlayed) {
        _this.setTextDisplay('none');
        return false;
      }
      var p = window.document.getElementById(_this.player.id_);
      if (!p) {
        _this.setTextDisplay('none');
        return false;
      }
      var heightOfVideo = p.clientHeight;
      var widthOfVideo = p.clientWidth;
      var widthOfCanvas = Math.floor(widthOfVideo);
      var heightOfCanvas = Math.floor(heightOfVideo) / 2 - 30;
      _this.setState({
        heightOfPreview: heightOfVideo
      });
      if (widthOfCanvas < 280) {
        //Disable text preview
        _this.setTextDisplay('none');
        return false;
      } else {
        //Enable text preview
        _this.setTextDisplay('flex');
      }
      if (!_this.previewSettings.textOverlay || !_this.previewSettings.textOverlay.enable) {
        _this.setState({
          previewText: null,
          display: 'none'
        });
        return false;
      }
      var textTemplate = _this.previewSettings.textOverlay.text;
      var canvas = document.createElement('canvas'),
        ctx = canvas.getContext('2d');
      canvas.width = widthOfVideo;
      canvas.height = heightOfCanvas;
      ctx.textAlign = "left";
      ctx.textBaseline = 'left';
      var textDimensions,
        i = 0;
      var fnt = 52;
      var $i;
      // var fontSizes = [52, 50, 48, 46, 44, 42, 40, 38, 36, 34, 32, 30, 28, 26, 24, 24];
      var fontSizes = [];
      for ($i = 8; $i <= 52; $i++) {
        if ($i % 2) {
          fontSizes.push($i + 1);
        }
      }
      fontSizes.reverse();
      ctx.font = fnt + 'px Arial';
      var linesFnt = _this.findFnt(ctx, textTemplate, widthOfVideo, fontSizes, 0);
      var lines = linesFnt[0];
      var maxFont = linesFnt[1];
      var text = lines.join('\n');
      fnt = maxFont;
      var maxHeight = 0,
        height;
      for ($i = 0; $i < lines.length; $i++) {
        i = 0;
        do {
          ctx.font = fontSizes[i++] + 'pt Arial';
          textDimensions = ctx.measureText(lines[$i]);
          if (fontSizes[i] >= maxFont) {
            fnt = fontSizes[i + 1];
          }
        } while (textDimensions.width >= canvas.width);
        height = parseInt(ctx.font.match(/\d+/), 10);
        maxHeight = maxHeight + height;
      }
      fnt = _this.findHeightFnt(ctx, lines, canvas.height, fontSizes, i);
      canvas.remove();
      text = text.split('\n').join('<br/>');
      _this.setState({
        previewText: text,
        fnt: fnt,
        height: heightOfCanvas
      });
    });
    _this.previewSettings = options.previewSettings;
    _this.previewAttach = options.previewAttach;
    _this.player = player;
    _this.state = {
      textColor: _this.previewSettings ? _this.previewSettings.textOverlay ? _this.previewSettings.textOverlay.color : '#fff' : '',
      previewImage: null,
      previewText: null,
      fnt: null,
      display: 'flex',
      height: '3em',
      heightOfPreview: '100%',
      previewBackground: 'none',
      playerIsPlayed: false
    };
    player.on('ready', _this.onPlayerReady);
    player.on('play', _this.onPlayerPlay);
    player.on('pause', _this.onPlayerPause);
    player.on('playerresize', _this.onPlayerResize);
    return _this;
  }
  previewVideo_createClass(PreviewVideo, [{
    key: "renderPreviewComponent",
    value: function renderPreviewComponent() {
      var render = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var container = this.el();
      if (render) {
        var component = (0,preact_module.h)("div", {
          class: "video-preview-wrapper",
          style: {
            background: !this.state.playerIsPlayed ? this.state.previewBackground : 'none',
            height: this.state.heightOfPreview
          }
        }, (0,preact_module.h)("div", {
          className: 'video-player-popup vjs-emre',
          style: {
            height: this.state.height,
            fontSize: this.state.fnt,
            color: this.state.textColor,
            display: this.state.display
          },
          dangerouslySetInnerHTML: {
            __html: this.state.previewText
          }
        }), (0,preact_module.h)("div", {
          class: "video-player-preview",
          style: {
            height: this.state.heightOfPreview - 41,
            background: this.state.previewImage && !this.state.playerIsPlayed ? 'url(\'' + this.state.previewImage + '\') no-repeat center / contain #141414' : 'none',
            backgroundSize: 'contain',
            display: this.state.previewImage && !this.state.playerIsPlayed ? 'block' : 'none'
          }
        }));
        (0,preact_module/* render */.sY)(component, container);
      } else if (container.childNodes.length) {
        (0,preact_module/* render */.sY)(null, container);
      }
    }
  }, {
    key: "buildCSSClass",
    value: function buildCSSClass() {
      return "vjs-nimbus-preview";
    }
  }, {
    key: "createEl",
    value: function createEl() {
      var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!props.className) {
        props.className = this.buildCSSClass();
      }
      return previewVideo_get(previewVideo_getPrototypeOf(PreviewVideo.prototype), "createEl", this).call(this, tag, props, attributes);
    }
  }]);
  return PreviewVideo;
}(previewVideo_Spacer);

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/previewVideo/style.scss
var previewVideo_style = __webpack_require__(39727);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/previewVideo/index.js
function plugins_previewVideo_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { plugins_previewVideo_typeof = function _typeof(obj) { return typeof obj; }; } else { plugins_previewVideo_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return plugins_previewVideo_typeof(obj); }














function previewVideo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function previewVideo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { previewVideo_ownKeys(Object(source), true).forEach(function (key) { plugins_previewVideo_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { previewVideo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function plugins_previewVideo_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function plugins_previewVideo_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function plugins_previewVideo_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) plugins_previewVideo_setPrototypeOf(subClass, superClass); }
function plugins_previewVideo_setPrototypeOf(o, p) { plugins_previewVideo_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return plugins_previewVideo_setPrototypeOf(o, p); }
function plugins_previewVideo_createSuper(Derived) { var hasNativeReflectConstruct = plugins_previewVideo_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = plugins_previewVideo_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = plugins_previewVideo_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return plugins_previewVideo_possibleConstructorReturn(this, result); }; }
function plugins_previewVideo_possibleConstructorReturn(self, call) { if (call && (plugins_previewVideo_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return plugins_previewVideo_assertThisInitialized(self); }
function plugins_previewVideo_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function plugins_previewVideo_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function plugins_previewVideo_getPrototypeOf(o) { plugins_previewVideo_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return plugins_previewVideo_getPrototypeOf(o); }



var previewVideo_Plugin = video_es.getPlugin('plugin');
var previewVideo_Component = video_es.getComponent('Component');
previewVideo_Component.registerComponent('previewVideo', PreviewVideo);
var PreviewVideoPlugin = /*#__PURE__*/function (_Plugin) {
  plugins_previewVideo_inherits(PreviewVideoPlugin, _Plugin);
  var _super = plugins_previewVideo_createSuper(PreviewVideoPlugin);
  function PreviewVideoPlugin(player, options) {
    var _this;
    plugins_previewVideo_classCallCheck(this, PreviewVideoPlugin);
    _this = _super.call(this, player);
    player.previewVideo = player.addChild('previewVideo', previewVideo_objectSpread({}, options), 4);
    return _this;
  }
  return PreviewVideoPlugin;
}(previewVideo_Plugin);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/previewButton/previewButton.js
function previewButton_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { previewButton_typeof = function _typeof(obj) { return typeof obj; }; } else { previewButton_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return previewButton_typeof(obj); }











function previewButton_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function previewButton_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function previewButton_createClass(Constructor, protoProps, staticProps) { if (protoProps) previewButton_defineProperties(Constructor.prototype, protoProps); if (staticProps) previewButton_defineProperties(Constructor, staticProps); return Constructor; }
function previewButton_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { previewButton_get = Reflect.get; } else { previewButton_get = function _get(target, property, receiver) { var base = previewButton_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return previewButton_get(target, property, receiver || target); }
function previewButton_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = previewButton_getPrototypeOf(object); if (object === null) break; } return object; }
function previewButton_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) previewButton_setPrototypeOf(subClass, superClass); }
function previewButton_setPrototypeOf(o, p) { previewButton_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return previewButton_setPrototypeOf(o, p); }
function previewButton_createSuper(Derived) { var hasNativeReflectConstruct = previewButton_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = previewButton_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = previewButton_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return previewButton_possibleConstructorReturn(this, result); }; }
function previewButton_possibleConstructorReturn(self, call) { if (call && (previewButton_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return previewButton_assertThisInitialized(self); }
function previewButton_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function previewButton_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function previewButton_getPrototypeOf(o) { previewButton_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return previewButton_getPrototypeOf(o); }

// import download from 'downloadjs'

var previewButton_Button = video_es.getComponent('Button');
var PreviewButton = /*#__PURE__*/function (_Button) {
  previewButton_inherits(PreviewButton, _Button);
  var _super = previewButton_createSuper(PreviewButton);
  function PreviewButton(player, options) {
    var _this;
    previewButton_classCallCheck(this, PreviewButton);
    _this = _super.call(this, player, options);
    _this.controlTextEl_.innerHTML = window.gEditor ? window.gEditor.plugins.i18n.get('file.menu.preview_video_btn') : 'Preview';
    return _this;
  }
  previewButton_createClass(PreviewButton, [{
    key: "buildCSSClass",
    value: function buildCSSClass() {
      return "vjs-preview-button ".concat(previewButton_get(previewButton_getPrototypeOf(PreviewButton.prototype), "buildCSSClass", this).call(this));
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      if (this.options().clickFn) {
        this.options().clickFn(this.options().attachment);
      }
    }
  }]);
  return PreviewButton;
}(previewButton_Button);
PreviewButton.prototype.controlText_ = 'Preview';
/* harmony default export */ const previewButton = (PreviewButton);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/previewButton/style.scss
var previewButton_style = __webpack_require__(57167);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/previewButton/index.js
function plugins_previewButton_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { plugins_previewButton_typeof = function _typeof(obj) { return typeof obj; }; } else { plugins_previewButton_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return plugins_previewButton_typeof(obj); }









function plugins_previewButton_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function plugins_previewButton_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function plugins_previewButton_createClass(Constructor, protoProps, staticProps) { if (protoProps) plugins_previewButton_defineProperties(Constructor.prototype, protoProps); if (staticProps) plugins_previewButton_defineProperties(Constructor, staticProps); return Constructor; }
function plugins_previewButton_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) plugins_previewButton_setPrototypeOf(subClass, superClass); }
function plugins_previewButton_setPrototypeOf(o, p) { plugins_previewButton_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return plugins_previewButton_setPrototypeOf(o, p); }
function plugins_previewButton_createSuper(Derived) { var hasNativeReflectConstruct = plugins_previewButton_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = plugins_previewButton_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = plugins_previewButton_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return plugins_previewButton_possibleConstructorReturn(this, result); }; }
function plugins_previewButton_possibleConstructorReturn(self, call) { if (call && (plugins_previewButton_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return plugins_previewButton_assertThisInitialized(self); }
function plugins_previewButton_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function plugins_previewButton_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function plugins_previewButton_getPrototypeOf(o) { plugins_previewButton_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return plugins_previewButton_getPrototypeOf(o); }



var previewButton_Plugin = video_es.getPlugin('plugin');
var previewButton_Component = video_es.getComponent('Component');
previewButton_Component.registerComponent('previewButton', previewButton);
var PreviewButtonPlugin = /*#__PURE__*/function (_Plugin) {
  plugins_previewButton_inherits(PreviewButtonPlugin, _Plugin);
  var _super = plugins_previewButton_createSuper(PreviewButtonPlugin);
  function PreviewButtonPlugin(player, options) {
    var _this;
    plugins_previewButton_classCallCheck(this, PreviewButtonPlugin);
    _this = _super.call(this, player);
    if (!options) {
      return plugins_previewButton_possibleConstructorReturn(_this);
    }
    player.ready(function () {
      _this.previewButton = player.controlBar.addChild('previewButton', {
        clickFn: options.clickFn,
        attachment: options.attachment
      }, options.index);
      if (!options.show) {
        _this.previewButton.hide();
      }
      player.controlBar.previewButton = _this.previewButton;
    });
    return _this;
  }
  plugins_previewButton_createClass(PreviewButtonPlugin, [{
    key: "show",
    value: function show() {
      if (this.previewButton) {
        this.previewButton.show();
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this.previewButton) {
        this.previewButton.hide();
      }
    }
  }]);
  return PreviewButtonPlugin;
}(previewButton_Plugin);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/transcriptButton/transcriptButton.js
function transcriptButton_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { transcriptButton_typeof = function _typeof(obj) { return typeof obj; }; } else { transcriptButton_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return transcriptButton_typeof(obj); }












function transcriptButton_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function transcriptButton_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function transcriptButton_createClass(Constructor, protoProps, staticProps) { if (protoProps) transcriptButton_defineProperties(Constructor.prototype, protoProps); if (staticProps) transcriptButton_defineProperties(Constructor, staticProps); return Constructor; }
function transcriptButton_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { transcriptButton_get = Reflect.get; } else { transcriptButton_get = function _get(target, property, receiver) { var base = transcriptButton_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return transcriptButton_get(target, property, receiver || target); }
function transcriptButton_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = transcriptButton_getPrototypeOf(object); if (object === null) break; } return object; }
function transcriptButton_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) transcriptButton_setPrototypeOf(subClass, superClass); }
function transcriptButton_setPrototypeOf(o, p) { transcriptButton_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return transcriptButton_setPrototypeOf(o, p); }
function transcriptButton_createSuper(Derived) { var hasNativeReflectConstruct = transcriptButton_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = transcriptButton_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = transcriptButton_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return transcriptButton_possibleConstructorReturn(this, result); }; }
function transcriptButton_possibleConstructorReturn(self, call) { if (call && (transcriptButton_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return transcriptButton_assertThisInitialized(self); }
function transcriptButton_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function transcriptButton_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function transcriptButton_getPrototypeOf(o) { transcriptButton_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return transcriptButton_getPrototypeOf(o); }

var transcriptButton_Button = video_es.getComponent('Button');
var TranscriptButton = /*#__PURE__*/function (_Button) {
  transcriptButton_inherits(TranscriptButton, _Button);
  var _super = transcriptButton_createSuper(TranscriptButton);
  function TranscriptButton(player, options) {
    transcriptButton_classCallCheck(this, TranscriptButton);
    return _super.call(this, player, options);
  }
  transcriptButton_createClass(TranscriptButton, [{
    key: "buildCSSClass",
    value: function buildCSSClass() {
      return "vjs-transcript-button ".concat(transcriptButton_get(transcriptButton_getPrototypeOf(TranscriptButton.prototype), "buildCSSClass", this).call(this));
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      var _this = this;
      if (this.options().clickFn) {
        var attachment = Object.assign({}, this.options().attachment);
        var video = document.createElement('video');
        video.src = attachment.url;
        video.onloadedmetadata = function () {
          attachment.duration = video.duration;
          _this.options().clickFn(attachment);
        };
      }
    }
  }]);
  return TranscriptButton;
}(transcriptButton_Button);
TranscriptButton.prototype.controlText_ = 'Transcript';
/* harmony default export */ const transcriptButton = (TranscriptButton);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/transcriptButton/style.scss
var transcriptButton_style = __webpack_require__(36663);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/transcriptButton/index.js
function plugins_transcriptButton_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { plugins_transcriptButton_typeof = function _typeof(obj) { return typeof obj; }; } else { plugins_transcriptButton_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return plugins_transcriptButton_typeof(obj); }









function plugins_transcriptButton_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function plugins_transcriptButton_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function plugins_transcriptButton_createClass(Constructor, protoProps, staticProps) { if (protoProps) plugins_transcriptButton_defineProperties(Constructor.prototype, protoProps); if (staticProps) plugins_transcriptButton_defineProperties(Constructor, staticProps); return Constructor; }
function plugins_transcriptButton_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) plugins_transcriptButton_setPrototypeOf(subClass, superClass); }
function plugins_transcriptButton_setPrototypeOf(o, p) { plugins_transcriptButton_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return plugins_transcriptButton_setPrototypeOf(o, p); }
function plugins_transcriptButton_createSuper(Derived) { var hasNativeReflectConstruct = plugins_transcriptButton_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = plugins_transcriptButton_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = plugins_transcriptButton_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return plugins_transcriptButton_possibleConstructorReturn(this, result); }; }
function plugins_transcriptButton_possibleConstructorReturn(self, call) { if (call && (plugins_transcriptButton_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return plugins_transcriptButton_assertThisInitialized(self); }
function plugins_transcriptButton_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function plugins_transcriptButton_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function plugins_transcriptButton_getPrototypeOf(o) { plugins_transcriptButton_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return plugins_transcriptButton_getPrototypeOf(o); }



var transcriptButton_Plugin = video_es.getPlugin('plugin');
var transcriptButton_Component = video_es.getComponent('Component');
transcriptButton_Component.registerComponent('transcriptButton', transcriptButton);
var TranscriptButtonPlugin = /*#__PURE__*/function (_Plugin) {
  plugins_transcriptButton_inherits(TranscriptButtonPlugin, _Plugin);
  var _super = plugins_transcriptButton_createSuper(TranscriptButtonPlugin);
  function TranscriptButtonPlugin(player, options) {
    var _this;
    plugins_transcriptButton_classCallCheck(this, TranscriptButtonPlugin);
    _this = _super.call(this, player);
    if (!options) {
      return plugins_transcriptButton_possibleConstructorReturn(_this);
    }
    player.ready(function () {
      _this.transcriptButton = player.controlBar.addChild('transcriptButton', {
        clickFn: options.clickFn,
        attachment: options.attachment
      }, options.index);
      if (!options.show) {
        _this.transcriptButton.hide();
      }
      player.controlBar.transcriptButton = _this.transcriptButton;
    });
    return _this;
  }
  plugins_transcriptButton_createClass(TranscriptButtonPlugin, [{
    key: "show",
    value: function show() {
      if (this.transcriptButton) {
        this.transcriptButton.show();
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this.transcriptButton) {
        this.transcriptButton.hide();
      }
    }
  }]);
  return TranscriptButtonPlugin;
}(transcriptButton_Plugin);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/videojs.js
function videojs_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { videojs_typeof = function _typeof(obj) { return typeof obj; }; } else { videojs_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return videojs_typeof(obj); }









function videojs_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function videojs_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function videojs_createClass(Constructor, protoProps, staticProps) { if (protoProps) videojs_defineProperties(Constructor.prototype, protoProps); if (staticProps) videojs_defineProperties(Constructor, staticProps); return Constructor; }
function videojs_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) videojs_setPrototypeOf(subClass, superClass); }
function videojs_setPrototypeOf(o, p) { videojs_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return videojs_setPrototypeOf(o, p); }
function videojs_createSuper(Derived) { var hasNativeReflectConstruct = videojs_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = videojs_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = videojs_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return videojs_possibleConstructorReturn(this, result); }; }
function videojs_possibleConstructorReturn(self, call) { if (call && (videojs_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return videojs_assertThisInitialized(self); }
function videojs_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function videojs_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function videojs_getPrototypeOf(o) { videojs_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return videojs_getPrototypeOf(o); }
function videojs_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




// plugins










// register plugins
video_es.registerPlugin('forwardButtonPlugin', ForwardButtonPlugin);
video_es.registerPlugin('downloadButtonPlugin', DownloadButtonPlugin);
video_es.registerPlugin('controlShadowPlugin', ControlShadowPlugin);
video_es.registerPlugin('callToActionPlugin', CallToActionPlugin);
video_es.registerPlugin('nimbusAdvPlugin', NimbusAdvPlugin);
video_es.registerPlugin('togglePlayPlugin', TogglePlayPlugin);
video_es.registerPlugin('previewVideoPlugin', PreviewVideoPlugin);
video_es.registerPlugin('previewButtonPlugin', PreviewButtonPlugin);
video_es.registerPlugin('transcriptButtonPlugin', TranscriptButtonPlugin);
var VideoPlayer = /*#__PURE__*/function (_Component) {
  videojs_inherits(VideoPlayer, _Component);
  var _super = videojs_createSuper(VideoPlayer);
  function VideoPlayer(props) {
    var _this;
    videojs_classCallCheck(this, VideoPlayer);
    _this = _super.call(this, props);
    videojs_defineProperty(videojs_assertThisInitialized(_this), "onVideoRef", function (node) {
      _this.videoNode = node;
    });
    videojs_defineProperty(videojs_assertThisInitialized(_this), "onRef", function (node) {
      _this.domNode = node;
      if (_this.props.onDomRef) {
        _this.props.onDomRef(node);
      }
    });
    return _this;
  }
  videojs_createClass(VideoPlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.player = video_es(this.videoNode, this.props);
      if (this.props.onPlayerRef) {
        this.props.onPlayerRef(this.player);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.player) {
        this.player.dispose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return (0,preact_module.h)("div", {
        "data-vjs-player": true,
        ref: this.onRef
      }, (0,preact_module.h)("video", {
        ref: this.onVideoRef,
        className: "video-js vjs-big-play-centered vjs-theme-nimbus"
      }));
    }
  }]);
  return VideoPlayer;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/lodash.isequal/index.js
var lodash_isequal = __webpack_require__(37733);
var lodash_isequal_default = /*#__PURE__*/__webpack_require__.n(lodash_isequal);
;// CONCATENATED MODULE: ./node_modules/videojs-errors/dist/videojs-errors.es.js



/*! @name videojs-errors @version 5.1.0 @license Apache-2.0 */


var videojs_errors_es_version = "5.1.0";
var FlashObj = video_es.getComponent('Flash');
var defaultDismiss = !video_es.browser.IS_IPHONE; // Video.js 5/6 cross-compatibility.

var videojs_errors_es_registerPlugin = video_es.registerPlugin || video_es.plugin; // Default options for the plugin.

var videojs_errors_es_defaults = {
  header: '',
  code: '',
  message: '',
  timeout: 45 * 1000,
  backgroundTimeout: 300 * 1000,
  dismiss: defaultDismiss,
  errors: {
    '1': {
      type: 'MEDIA_ERR_ABORTED',
      headline: 'The video download was cancelled'
    },
    '2': {
      type: 'MEDIA_ERR_NETWORK',
      headline: 'The video connection was lost, please confirm you are ' + 'connected to the internet'
    },
    '3': {
      type: 'MEDIA_ERR_DECODE',
      headline: 'The video is bad or in a format that cannot be played on your browser'
    },
    '4': {
      type: 'MEDIA_ERR_SRC_NOT_SUPPORTED',
      headline: 'This video is either unavailable or not supported in this browser'
    },
    '5': {
      type: 'MEDIA_ERR_ENCRYPTED',
      headline: 'The video you are trying to watch is encrypted and we do not know how ' + 'to decrypt it'
    },
    'unknown': {
      type: 'MEDIA_ERR_UNKNOWN',
      headline: 'An unanticipated problem was encountered, check back soon and try again'
    },
    '-1': {
      type: 'PLAYER_ERR_NO_SRC',
      headline: 'No video has been loaded'
    },
    '-2': {
      type: 'PLAYER_ERR_TIMEOUT',
      headline: 'It looks like you\'re having playback issues. Reloading the video may help.'
    },
    'PLAYER_ERR_DOMAIN_RESTRICTED': {
      headline: 'This video is restricted from playing on your current domain'
    },
    'PLAYER_ERR_IP_RESTRICTED': {
      headline: 'This video is restricted at your current IP address'
    },
    'PLAYER_ERR_GEO_RESTRICTED': {
      headline: 'This video is restricted from playing in your current geographic region'
    },
    'FLASHLS_ERR_CROSS_DOMAIN': {
      headline: 'The video could not be loaded: crossdomain access denied.'
    }
  }
};
var videojs_errors_es_initPlugin = function initPlugin(player, options) {
  var monitor;
  var waiting;
  var isStalling;
  var listeners = [];
  var updateErrors = function updateErrors(updates) {
    options.errors = video_es.mergeOptions(options.errors, updates); // Create `code`s from errors which don't have them (based on their keys).

    Object.keys(options.errors).forEach(function (k) {
      var err = options.errors[k];
      if (!err.type) {
        err.type = k;
      }
    });
  }; // Make sure we flesh out initially-provided errors.

  updateErrors(); // clears the previous monitor timeout and sets up a new one

  var resetMonitor = function resetMonitor() {
    // clear out any existing player error now that playback has recovered
    if (player.error() && player.error().code === -2) {
      player.error(null);
    }
    player.clearTimeout(waiting);
    player.clearTimeout(monitor);
    if (isStalling) {
      isStalling = false;
      player.removeClass('vjs-waiting');
    } // Disable timeouts in the background altogether according to the backgroundTimeout
    // option, or if the player is muted, as browsers may throttle javascript timers to
    // 1 minute in that case

    var disableValues = [Infinity, -1];
    var disableValueMatch = function disableValueMatch(valArray, option) {
      return valArray.indexOf(option) !== -1;
    };
    if ((document_default()).visibilityState === 'hidden' && (player.muted() || disableValueMatch(disableValues, options.backgroundTimeout)) || (document_default()).visibilityState === 'visible' && disableValueMatch(disableValues, options.timeout)) {
      return;
    } // start the loading spinner if player has stalled

    waiting = player.setTimeout(function () {
      // player already has an error
      // or is not playing under normal conditions
      if (player.error() || player.paused() || player.ended()) {
        return;
      }
      isStalling = true;
      player.addClass('vjs-waiting');
    }, 1000);
    monitor = player.setTimeout(function () {
      // player already has an error
      // or is not playing under normal conditions
      if (player.error() || player.paused() || player.ended()) {
        return;
      }
      player.error({
        code: -2,
        type: 'PLAYER_ERR_TIMEOUT'
      });
    }, (document_default()).visibilityState === 'hidden' ? options.backgroundTimeout : options.timeout);
  }; // clear any previously registered listeners

  var cleanup = function cleanup() {
    var listener;
    while (listeners.length) {
      listener = listeners.shift();
      player.off(listener[0], listener[1]);
    }
    player.clearTimeout(monitor);
    player.clearTimeout(waiting);
  }; // creates and tracks a player listener if the player looks alive

  var healthcheck = function healthcheck(type, fn) {
    var check = function check() {
      // if there's an error do not reset the monitor and
      // clear the error unless time is progressing
      if (!player.error()) {
        // error if using Flash and its API is unavailable
        var tech = player.$('.vjs-tech');
        if (tech && tech.type === 'application/x-shockwave-flash' && !tech.vjs_getProperty) {
          player.error({
            code: -2,
            type: 'PLAYER_ERR_TIMEOUT'
          });
          return;
        } // playback isn't expected if the player is paused

        if (player.paused()) {
          return resetMonitor();
        } // playback isn't expected once the video has ended

        if (player.ended()) {
          return resetMonitor();
        }
      }
      fn.call(this);
    };
    player.on(type, check);
    listeners.push([type, check]);
  };
  var onPlayStartMonitor = function onPlayStartMonitor() {
    var lastTime = 0;
    cleanup(); // if no playback is detected for long enough, trigger a timeout error

    resetMonitor();
    healthcheck(['timeupdate', 'adtimeupdate'], function () {
      var currentTime = player.currentTime(); // playback is operating normally or has recovered

      if (currentTime !== lastTime) {
        lastTime = currentTime;
        resetMonitor();
      }
    }); // Restart timeout monitor when the document transitions between the
    // foreground and background

    player.off((document_default()), 'visibilitychange', onPlayStartMonitor);
    player.on((document_default()), 'visibilitychange', onPlayStartMonitor);
  };
  var onPlayNoSource = function onPlayNoSource() {
    if (!player.currentSrc()) {
      player.error({
        code: -1,
        type: 'PLAYER_ERR_NO_SRC'
      });
    }
  };
  var onErrorHandler = function onErrorHandler() {
    var details = '';
    var error = player.error();
    var content = document_default().createElement('div');
    var dialogContent = ''; // In the rare case when `error()` does not return an error object,
    // defensively escape the handler function.

    if (!error) {
      return;
    } // Stop restarting the monitor on visibilitychanges now that an error has occurred

    player.off((document_default()), 'visibilitychange', onPlayStartMonitor);
    error = video_es.mergeOptions(error, options.errors[error.code || error.type || 0]);
    if (error.message) {
      details = "<div class=\"vjs-errors-details\">".concat(player.localize('Technical details'), "\n        : <div class=\"vjs-errors-message\">").concat(player.localize(error.message), "</div>\n        </div>");
    }
    if (error.code === 4 && FlashObj && !FlashObj.isSupported()) {
      var flashMessage = player.localize('If you are using an older browser please try upgrading or installing Flash.');
      details += "<span class=\"vjs-errors-flashmessage\">".concat(flashMessage, "</span>");
    }
    var display = player.getChild('errorDisplay');
    content.className = 'vjs-errors-dialog';
    content.id = 'vjs-errors-dialog';
    var errorCode = "<div class=\"vjs-errors-code\"><b>".concat(this.localize('Error Code'), ":</b> ").concat(error.type || error.code, "</div>");
    var isTimeoutError = error.code === -2;
    dialogContent = "<div class=\"vjs-errors-content-container\">\n        <h2 class=\"vjs-errors-headline\">".concat(this.localize(error.headline), "</h2>\n        ").concat(isTimeoutError ? '' : errorCode, "\n        ").concat(isTimeoutError ? '' : details, "\n      </div>");
    var closeable = display.closeable(!('dismiss' in error) || error.dismiss);
    if (isTimeoutError) {
      dialogContent += "<div class=\"vjs-errors-timeout-button-container\">\n         <button>".concat(this.localize('Reload Video'), "</button>\n         <button>").concat(this.localize('Dismiss'), "</button>\n       </div>");
      content.innerHTML = dialogContent;
      display.fillWith(content);
      display.getChild('closeButton').hide();
      var reloadButton = display.el().querySelector('.vjs-errors-timeout-button-container > button:first-child');
      var dismissButton = display.el().querySelector('.vjs-errors-timeout-button-container > button:last-child');
      player.on(reloadButton, 'click', function () {
        var source = player.currentSource();
        player.reset();
        player.src(source);
      });
      player.on(dismissButton, 'click', function () {
        display.close();
      });
      display.one('modalclose', function () {
        player.off(reloadButton);
        player.off(dismissButton);
      });
    } else if (closeable) {
      // We should get a close button
      dialogContent += "<div class=\"vjs-errors-ok-button-container\">\n          <button class=\"vjs-errors-ok-button\">".concat(this.localize('OK'), "</button>\n        </div>");
      content.innerHTML = dialogContent;
      display.fillWith(content); // Get the close button inside the error display

      display.contentEl().firstChild.appendChild(display.getChild('closeButton').el());
      var okButton = display.el().querySelector('.vjs-errors-ok-button');
      player.on(okButton, 'click', function () {
        display.close();
      });
    } else {
      content.innerHTML = dialogContent;
      display.fillWith(content);
    }
    if (player.currentWidth() <= 600 || player.currentHeight() <= 250) {
      display.addClass('vjs-xs');
    }
    display.one('modalclose', function () {
      return player.error(null);
    });
  };
  var onDisposeHandler = function onDisposeHandler() {
    cleanup();
    player.removeClass('vjs-errors');
    player.off('play', onPlayStartMonitor);
    player.off((document_default()), 'visibilitychange', onPlayStartMonitor);
    player.off('play', onPlayNoSource);
    player.off('dispose', onDisposeHandler);
    player.off(['aderror', 'error'], onErrorHandler);
  };
  var reInitPlugin = function reInitPlugin(newOptions) {
    onDisposeHandler();
    initPlugin(player, video_es.mergeOptions(videojs_errors_es_defaults, newOptions));
  };
  reInitPlugin.extend = function (errors) {
    return updateErrors(errors);
  };
  reInitPlugin.getAll = function () {
    return video_es.mergeOptions(options.errors);
  }; // Get / set timeout value. Restart monitor if changed.

  reInitPlugin.timeout = function (timeout) {
    if (typeof timeout === 'undefined') {
      return options.timeout;
    }
    if (timeout !== options.timeout) {
      options.timeout = timeout;
      if (!player.paused()) {
        onPlayStartMonitor();
      }
    }
  }; // Get / set backgroundTimeout value. Restart monitor if changed.

  reInitPlugin.backgroundTimeout = function (timeout) {
    if (typeof timeout === 'undefined') {
      return options.backgroundTimeout;
    }
    if (timeout !== options.backgroundTimeout) {
      options.backgroundTimeout = timeout;
      if (!player.paused()) {
        onPlayStartMonitor();
      }
    }
  }; // no-op API
  // TODO: remove in a major version

  reInitPlugin.disableProgress = function () {};
  player.on('play', onPlayStartMonitor);
  player.on('play', onPlayNoSource);
  player.on('dispose', onDisposeHandler);
  player.on(['aderror', 'contenterror', 'error'], onErrorHandler);
  player.ready(function () {
    player.addClass('vjs-errors');
  }); // if the plugin is re-initialised during playback, start the timeout handler.

  if (!player.paused()) {
    onPlayStartMonitor();
  } // Include the version number.

  reInitPlugin.VERSION = videojs_errors_es_version;
  player.errors = reInitPlugin;
};
var videojs_errors_es_errors = function errors(options) {
  videojs_errors_es_initPlugin(this, video_es.mergeOptions(videojs_errors_es_defaults, options));
};
['extend', 'getAll'].forEach(function (k) {
  videojs_errors_es_errors[k] = function () {
    video_es.log.warn("The errors.".concat(k, "() method is not available until the plugin has been initialized!"));
  };
}); // Include the version number.

videojs_errors_es_errors.VERSION = videojs_errors_es_version; // Register the plugin with video.js.

videojs_errors_es_registerPlugin('errors', videojs_errors_es_errors);

// EXTERNAL MODULE: ./node_modules/is-hotkey/lib/index.js
var is_hotkey_lib = __webpack_require__(28199);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/index.js
function video_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { video_typeof = function _typeof(obj) { return typeof obj; }; } else { video_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return video_typeof(obj); }
function video_extends() { video_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return video_extends.apply(this, arguments); }
























function video_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function video_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { video_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { video_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function video_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function video_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { video_ownKeys(Object(source), true).forEach(function (key) { video_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { video_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function video_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function video_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function video_createClass(Constructor, protoProps, staticProps) { if (protoProps) video_defineProperties(Constructor.prototype, protoProps); if (staticProps) video_defineProperties(Constructor, staticProps); return Constructor; }
function video_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) video_setPrototypeOf(subClass, superClass); }
function video_setPrototypeOf(o, p) { video_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return video_setPrototypeOf(o, p); }
function video_createSuper(Derived) { var hasNativeReflectConstruct = video_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = video_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = video_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return video_possibleConstructorReturn(this, result); }; }
function video_possibleConstructorReturn(self, call) { if (call && (video_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return video_assertThisInitialized(self); }
function video_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function video_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function video_getPrototypeOf(o) { video_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return video_getPrototypeOf(o); }
function video_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var isSpaceKey = (0,is_hotkey_lib/* default */.ZP)('space');
var video_defaults = {
  autoplay: false,
  loop: false,
  controls: true,
  responsive: true,
  fluid: true,
  inactivityTimeout: 3000,
  playbackRates: [1, 1.2, 1.5, 1.7, 2],
  aspectRatio: '16:9',
  controlBar: {
    pictureInPictureToggle: false,
    remainingTimeDisplay: false,
    liveDisplay: false,
    seekToLive: false,
    chaptersButton: false,
    descriptionsButton: false,
    subsCapsButton: false,
    audioTrackButton: false
  },
  plugins: {
    forwardButtonPlugin: {
      index: 1,
      seconds: 5
    },
    togglePlayPlugin: true
  }
};
var DEFAULT_PLAYER_VOLUME = 0.75;
var VideoViewer = /*#__PURE__*/function (_Component) {
  video_inherits(VideoViewer, _Component);
  var _super = video_createSuper(VideoViewer);
  function VideoViewer(props) {
    var _this;
    video_classCallCheck(this, VideoViewer);
    _this = _super.call(this, props);
    video_defineProperty(video_assertThisInitialized(_this), "onRef", function (node) {
      _this.domNode = node;
    });
    video_defineProperty(video_assertThisInitialized(_this), "onPlayerRef", function (player) {
      _this.player = player;
    });
    video_defineProperty(video_assertThisInitialized(_this), "onEditorScroll", function () {
      _this.setAutoplayIfAvailable();
    });
    video_defineProperty(video_assertThisInitialized(_this), "onPlayerReady", function () {
      _this.player.addClass('vjs-wait-metadata');
      var _this$props = _this.props,
        editor = _this$props.editor,
        blot = _this$props.blot;
      editor.getScrollingContainer().addEventListener('scroll', _this.onEditorScroll, false);
      // после того как плеер готов, сразу пробуем его поставить на паузу,
      // если вдруг он находится вне области видимости редактора и включена опция autoplay
      _this.setAutoplayIfAvailable();
      blot.props.videoPlayer = video_assertThisInitialized(_this);
      _this.setState(function () {
        return {
          isPlayerReady: true
        };
      });
    });
    video_defineProperty(video_assertThisInitialized(_this), "onPlayerPlay", function () {
      var _this$props2 = _this.props,
        editor = _this$props2.editor,
        blot = _this$props2.blot;
      editor.emitter.emit('video-play', blot.id);
    });
    video_defineProperty(video_assertThisInitialized(_this), "onEditorVideoPlay", function (blotId) {
      if (blotId === _this.props.blot.id || _this.props.attachment.motionVideo) return;
      _this.player.pause();
    });
    video_defineProperty(video_assertThisInitialized(_this), "onPlayerFullscreenChange", function (event) {
      if (_this.player.isFullscreen()) {
        if (_this.props.onViewerGoFullScreen && !_this.props.fullscreen) {
          _this.props.onViewerGoFullScreen();
        }
      } else {
        if (_this.props.onFullScreenClose && _this.props.fullscreen) {
          _this.props.onFullScreenClose();
        }
      }
    });
    video_defineProperty(video_assertThisInitialized(_this), "onVideoDownload", function (attachment) {
      return _this.props.editor.plugins.attachmentManager.download(attachment);
    });
    video_defineProperty(video_assertThisInitialized(_this), "onDocumentKeyDown", function (event) {
      if (!_this.props.editor.isEditable()) {
        // блок с видео в фокусе или видео воспроизводится
        if (_this.props.blot.scroll.focusedBlot === _this.props.blot || !_this.player.paused()) {
          _this.handleKeyDown(event);
        }
      }
    });
    video_defineProperty(video_assertThisInitialized(_this), "onDomNodeMouseDown", function (event) {
      if (!_this.props.editor.isEditable()) {
        _this.props.blot.selection.setRange({
          index: _this.props.blot.offset(_this.props.blot.scroll),
          length: 0
        });
      }
    });
    video_defineProperty(video_assertThisInitialized(_this), "updateCtaState", function () {
      var _this$props3 = _this.props,
        attachment = _this$props3.attachment,
        editor = _this$props3.editor,
        blot = _this$props3.blot;
      var cta = editor.plugins.ctaManager.getCta(blot.id, attachment.global_id);
      if (!lodash_isequal_default()(_this.state.cta, cta)) {
        _this.state.cta = cta;
        _this.player.cta.options(video_objectSpread({}, cta));
      }
      // тут так же выполняем обновление стейта рекламы
      _this.updateNimbusAdvState();
    });
    video_defineProperty(video_assertThisInitialized(_this), "getPreviewAttach", /*#__PURE__*/function () {
      var _ref = video_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(attachId) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.props.editor.plugins.attachmentManager.resolve(attachId);
              case 2:
                return _context.abrupt("return", _context.sent);
              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    video_defineProperty(video_assertThisInitialized(_this), "updatePreviewState", /*#__PURE__*/video_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.player.previewVideo.reRender(_this.props.syncedState.videoPreview);
            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    video_defineProperty(video_assertThisInitialized(_this), "onPreviewBtn", /*#__PURE__*/function () {
      var _ref3 = video_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(settings) {
        var newState;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this.props.editor.plugins.videoPreview.onEditPreview(_this.props.syncedState.videoPreview || {
                  videoAttachmentId: _this.props.attachment.global_id,
                  textOverlay: null,
                  activePreviewType: "first_frame",
                  previews: {}
                });
              case 2:
                newState = _context3.sent;
                if (newState) {
                  newState.videoAttachmentId = _this.props.attachment.global_id;
                  console.log('setNewState', newState);
                  _this.props.setSyncedState({
                    videoPreview: newState
                  });
                }
              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    var _this$props4 = _this.props,
      _attachment = _this$props4.attachment,
      _editor = _this$props4.editor,
      _blot = _this$props4.blot;
    _this.state = {
      muted: typeof _attachment.soundDefault !== 'undefined' && _attachment.soundDefault || typeof _attachment.autoplay !== 'undefined' && _attachment.autoplay ? true : false,
      controls: typeof _attachment.hideControl !== 'undefined' ? !_attachment.hideControl : true,
      autoplay: typeof _attachment.autoplay !== 'undefined' ? _attachment.autoplay : false,
      loop: typeof _attachment.loop !== 'undefined' ? _attachment.loop : false,
      allowDownload: true,
      showNimbusAdv: false,
      isPlayerReady: false
    };
    var _cta = _editor.plugins.ctaManager.getCta(_blot.id, _attachment.global_id);
    if (!_this.state.loop && !_attachment.motionVideo) {
      _this.state.cta = _cta;
    } else {
      _this.state.cta = {};
    }
    return _this;
  }
  video_createClass(VideoViewer, [{
    key: "isPlayOnAutoplayAvailable",
    value: function isPlayOnAutoplayAvailable() {
      if (!this.domNode) return false;
      var editor = this.props.editor;
      var editorRect = editor.editorBody.getBoundingClientRect();
      var rect = this.domNode.getBoundingClientRect();
      // разрешаем воспроизведение, если хотя бы половина видео находится в области видимости редактора
      return rect.top >= editorRect.top - rect.height / 2 && rect.bottom <= editorRect.bottom + rect.height / 2;
    }
  }, {
    key: "setAutoplayIfAvailable",
    value:
    // Метод включает/выключает воспроизведение видео при включенной опции autoplay.
    // Если хотя бы 50% видео (по вертикали) находится в области видимости редактора,
    // видео начнет воспроизводиться.
    // Если видео находится вне области видимости редактора, или в области видимости редактора находится менее 50% видео,
    // оно поставится на паузу.
    function setAutoplayIfAvailable() {
      var attachment = this.props.attachment;
      var autoplay = attachment.autoplay,
        loop = attachment.loop;
      if (typeof autoplay !== 'undefined' && attachment.autoplay) {
        var available = this.isPlayOnAutoplayAvailable();
        if (typeof loop === 'undefined' || !loop) {
          if (this.player.ended()) {
            available = false;
          }
        }
        if (available) {
          if (this.player.paused()) {
            this.player.play();
          }
        } else if (!this.player.paused()) {
          this.player.pause();
        }
      }
    }
    // Метод выключает/включает (ставит дефолтный уровень) звук
  }, {
    key: "setMuted",
    value: function setMuted() {
      var muted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (muted) {
        this.player.volume(0);
      } else {
        if (this.player.muted()) {
          this.player.muted(false);
        }
        this.player.volume(DEFAULT_PLAYER_VOLUME);
      }
    }
    // Метод выключает/включает автоплей на инициированном плеере
  }, {
    key: "setAutoplay",
    value: function setAutoplay() {
      var autoplay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (autoplay) {
        this.player.autoplay('muted');
        this.player.play();
      } else {
        this.player.autoplay(false);
        if (this.player.played().length && !this.player.paused()) {
          this.player.pause();
        }
      }
    }
    // Метод выключает/включает зацикливание на инициированном плеере
  }, {
    key: "setLoop",
    value: function setLoop() {
      var loop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.player.loop(loop);
    }
    // Метод выключает/включает панель управления видео на инициированном плеере
  }, {
    key: "setControls",
    value: function setControls() {
      var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.player.controls(show);
    }
    // Метод выключает/включает доступность кнопки загрузки
  }, {
    key: "setDownloadAvailable",
    value: function setDownloadAvailable() {
      var allow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (allow) {
        this.player.controlBar.downloadButton.enable();
      } else {
        this.player.controlBar.downloadButton.disable();
      }
    }
    /* TODO */
    // Метод выключает/включает доступность кнопки превью
  }, {
    key: "setPreviewAvailable",
    value: function setPreviewAvailable() {
      var allow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (allow) {
        this.player.controlBar.previewButton.enable();
      } else {
        this.player.controlBar.previewButton.disable();
      }
    }
  }, {
    key: "getCustomErrorMessage",
    value: function getCustomErrorMessage() {
      var videoCodec = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var i18n = this.props.editor.plugins.i18n;
      var _this$props$attachmen = this.props.attachment,
        attachment = _this$props$attachmen === void 0 ? {} : _this$props$attachmen;
      var nbsp = videoCodec ? '' : ' '; // для того, чтобы не было пробела перед запятой если нет кодека
      var errorMessage = i18n.get('file.video_codec_error').replace("".concat(nbsp, "{codec}"), videoCodec);
      if ((0,browser/* detectBrowser */.Ao)() === 'Safari') {
        if (attachment.mime === 'video/webm') {
          errorMessage = i18n.get('file.safari_webm_not_support');
        }
      }
      return errorMessage;
    }
  }, {
    key: "updateNimbusAdvState",
    value: function updateNimbusAdvState() {
      var ctaState = typeof this.state.cta !== 'undefined' && this.state.cta && Boolean(Object.keys(this.state.cta).length);
      var blot = this.props.blot;
      var inGridCol = blot.getWrapper().parent.constructor.blotName === 'gridCol';
      var advert = this.options && this.options.advert;
      var isShare = blot.editor.options.isShare;
      if (advert && isShare && !inGridCol && !ctaState) {
        this.state.showNimbusAdv = true;
      } else {
        this.state.showNimbusAdv = false;
      }
      this.player.nimbusAdv.options({
        showAdv: this.state.showNimbusAdv
      });
    }
  }, {
    key: "updateFullScreenState",
    value: function updateFullScreenState() {
      if (this.props.fullscreen && !this.player.isFullscreen()) {
        this.player.requestFullscreen();
      } else if (!this.props.fullscreen && this.player.isFullscreen()) {
        this.player.exitFullscreen();
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (isSpaceKey(event) && this.player && this.player.played().length) {
        event.preventDefault();
        event.stopPropagation();
        if (this.player.paused()) {
          this.player.play();
        } else {
          this.player.pause();
        }
        return true;
      }
      return false;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.player.one('loadedmetadata', function () {
        _this2.player.removeClass('vjs-wait-metadata');
      });
      this.player.on('ready', this.onPlayerReady);
      this.player.on('play', this.onPlayerPlay);
      this.player.on('fullscreenchange', this.onPlayerFullscreenChange);
      this.props.editor.on('set-cta', this.updateCtaState);
      this.props.editor.on('video-play', this.onEditorVideoPlay);
      // Кастомные сообщения об ошибках. Плагин: videojs-errors
      // https://github.com/brightcove/videojs-errors
      var extendedType = getExtendedVideoType(this.props.attachment);
      this.player.errors({
        errors: {
          3: {
            // MEDIA_ERR_DECODE
            message: this.getCustomErrorMessage(extendedType.codec)
          },
          4: {
            // MEDIA_ERR_SRC_NOT_SUPPORTED
            message: this.getCustomErrorMessage(extendedType.codec)
          },
          5: {
            // MEDIA_ERR_ENCRYPTED
            message: this.getCustomErrorMessage(extendedType.codec)
          }
        }
      });
      document.addEventListener('keydown', this.onDocumentKeyDown, false);
      this.domNode.addEventListener('mousedown', this.onDomNodeMouseDown, false);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props5 = this.props,
        attachment = _this$props5.attachment,
        blot = _this$props5.blot;
      if (attachment && this.state.isPlayerReady) {
        var _this$state = this.state,
          muted = _this$state.muted,
          autoplay = _this$state.autoplay,
          loop = _this$state.loop,
          controls = _this$state.controls,
          allowDownload = _this$state.allowDownload;
        var soundDefault = typeof attachment.soundDefault === 'undefined' ? false : attachment.soundDefault;
        if (typeof attachment.autoplay !== 'undefined' && attachment.autoplay !== autoplay) {
          this.state.autoplay = attachment.autoplay;
          this.state.muted = true;
          this.setMuted(this.state.muted);
          this.setAutoplay(this.state.autoplay);
        } else if (muted !== soundDefault) {
          this.state.muted = soundDefault;
          this.setMuted(this.state.muted);
        }
        if (typeof attachment.loop !== 'undefined' && attachment.loop !== loop) {
          this.state.loop = attachment.loop;
          this.setLoop(this.state.loop);
        }
        if (typeof attachment.hideControl !== 'undefined' && !attachment.hideControl !== controls) {
          this.state.controls = !attachment.hideControl;
          this.setControls(this.state.controls);
        }
        if (!blot.disallowDownloading !== allowDownload) {
          this.state.allowDownload = !blot.disallowDownloading;
          this.setDownloadAvailable(this.state.allowDownload);
        }
        if (!this.props.disallowVideoPreview && !lodash_isequal_default()(prevProps.syncedState.videoPreview, this.props.syncedState.videoPreview)) {
          this.updatePreviewState();
        }
        this.updateNimbusAdvState();
        this.updateFullScreenState();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props6 = this.props,
        editor = _this$props6.editor,
        blot = _this$props6.blot;
      editor.getScrollingContainer().removeEventListener('scroll', this.onEditorScroll, false);
      this.props.editor.off('set-cta', this.updateCtaState);
      this.props.editor.off('video-play', this.onEditorVideoPlay);
      if (this.player) {
        this.player.off('ready', this.onPlayerReady);
        this.player.off('play', this.onPlayerPlay);
      }
      blot.props.videoPlayer = null;
      document.removeEventListener('keydown', this.onDocumentKeyDown, false);
      this.domNode.removeEventListener('mousedown', this.onDomNodeMouseDown, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
        autoplay = _this$state2.autoplay,
        loop = _this$state2.loop,
        controls = _this$state2.controls,
        showNimbusAdv = _this$state2.showNimbusAdv;
      var _this$props7 = this.props,
        attachment = _this$props7.attachment,
        editor = _this$props7.editor,
        blot = _this$props7.blot,
        isBlotLocked = _this$props7.isBlotLocked;
      var _editor$plugins$attac = editor.plugins.attachmentManager.options,
        onTranscript = _editor$plugins$attac.onTranscript,
        isTranscriptEnabled = _editor$plugins$attac.isTranscriptEnabled;
      var extendedType = getExtendedVideoType(attachment);
      var plugins = {
        downloadButtonPlugin: {
          index: 9,
          attachment: attachment,
          downloadFn: this.onVideoDownload
        },
        callToActionPlugin: video_objectSpread(video_objectSpread({}, this.state.cta), {}, {
          editor: editor
        }),
        nimbusAdvPlugin: {
          showAdv: showNimbusAdv,
          editor: editor,
          blot: blot
        },
        controlShadowPlugin: {
          videoName: attachment.display_name.split('.').slice(0, -1).join('.')
        },
        transcriptButtonPlugin: {
          index: 8,
          attachment: attachment,
          clickFn: onTranscript,
          show: isTranscriptEnabled
        }
      };
      var isVideoPreviewEditAvailable = this.props.editor.plugins.videoPreview.isEditAvailable() && editor.mode === editor.constructor.MODE_EDIT && !this.props.disallowVideoPreview;
      var showPreviewButton = !isBlotLocked && isVideoPreviewEditAvailable;
      if (isVideoPreviewEditAvailable) {
        plugins.previewButtonPlugin = {
          index: 9,
          attachment: attachment,
          clickFn: this.onPreviewBtn,
          show: showPreviewButton
        };
        plugins.previewVideoPlugin = {
          previewSettings: this.props.syncedState.videoPreview,
          previewAttach: this.getPreviewAttach
        };
      }
      var props = Object.assign({}, video_defaults, {
        autoplay: autoplay ? 'muted' : video_defaults.autoplay,
        loop: loop,
        controls: controls,
        sources: [{
          src: attachment.url,
          type: extendedType.mime
        }],
        noUITitleAttributes: true,
        plugins: Object.assign({}, video_defaults.plugins, plugins)
      });
      if (this.player) {
        if (isVideoPreviewEditAvailable) {
          if (showPreviewButton) {
            this.player.previewButtonPlugin().show();
          } else {
            this.player.previewButtonPlugin().hide();
          }
        }
      }
      return (0,preact_module.h)(VideoPlayer, video_extends({}, props, {
        onPlayerRef: this.onPlayerRef,
        onDomRef: this.onRef
      }));
    }
  }]);
  return VideoViewer;
}(preact_module/* Component */.wA);

VideoViewer.supportsFullscreen = true;
VideoViewer.FullScreenAction = false;
VideoViewer.viewerName = 'VideoViewer';
var getExtendedVideoType = function getExtendedVideoType() {
  var attachment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var prepareMimeForBrowser = function prepareMimeForBrowser(extendedType) {
    if (extendedType.mime === 'video/quicktime' && window.chrome) {
      return {
        mime: 'video/mp4',
        codec: extendedType.codec
      };
    }
    return extendedType;
  };
  var _attachment$extra = attachment.extra,
    extra = _attachment$extra === void 0 ? "{}" : _attachment$extra;
  var _ref4 = typeof extra === 'string' ? JSON.parse(extra) : extra,
    _ref4$mime = _ref4.mime,
    mime = _ref4$mime === void 0 ? null : _ref4$mime,
    _ref4$general = _ref4.general,
    general = _ref4$general === void 0 ? null : _ref4$general,
    _ref4$video = _ref4.video,
    video = _ref4$video === void 0 ? null : _ref4$video;
  var _navigator = navigator,
    appVersion = _navigator.appVersion;
  var isSafari = appVersion.indexOf('Safari') !== -1 && appVersion.indexOf('Chrome') === -1;
  if (mime) {
    var codec = mime.match(/codecs="(.*?)";/);
    return prepareMimeForBrowser({
      mime: attachment.mime || mime,
      codec: codec[1]
    });
  }
  if (general) {
    var format = general.format,
      _general$codec_id_com = general.codec_id_compatible,
      codec_id_compatible = _general$codec_id_com === void 0 ? '' : _general$codec_id_com,
      general_codec_id = general.codec_id;
    format = format.toLowerCase().replace('mpeg-4', 'mp4');
    codec_id_compatible = codec_id_compatible.toLowerCase().replace(/\//g, ',');
    if (video) {
      var codec_id = video.codec_id;
      codec_id = codec_id.toLowerCase().replace('v_vp8', 'vp8').replace('v_vp9', 'vp9').trim();
      return prepareMimeForBrowser({
        mime: "video/".concat(format),
        codec: codec_id.trim()
      });
    }
    if (isSafari && general_codec_id === 'mp42') {
      general_codec_id = 'hvc1';
    }
    return prepareMimeForBrowser({
      mime: "video/".concat(format),
      codec: general_codec_id.trim()
    });
  }
  if (attachment.mime) {
    return prepareMimeForBrowser({
      mime: attachment.mime,
      codec: ''
    });
  }
  return {
    mime: '',
    codec: ''
  };
};
function getVideoTypes() {
  var allTypes = ['video/mpeg', 'video/mp4', 'video/ogg', 'video/quicktime', 'video/webm', 'video/x-ms-wmv', 'video/x-msvideo', 'video/ms-asf', 'video/x-flv', 'video/3gpp', 'video/3gpp2', 'video/x-m4v'];
  var types = [];
  try {
    var video = document.createElement('video');
    for (var i in allTypes) {
      if (video.canPlayType(allTypes[i])) types.push(allTypes[i]);
    }
    if (['Chrome', 'Opera'].includes((0,browser/* detectBrowser */.Ao)()) && types.indexOf('video/quicktime') < 0) {
      types.push('video/quicktime');
    }
    if ((0,browser/* detectBrowser */.Ao)() === 'Safari') {
      types.push('video/webm');
    }
  } catch (ex) {
    console.warn(ex);
  }
  return types;
}

/***/ }),

/***/ 36790:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DummyProvider": () => (/* binding */ DummyProvider),
/* harmony export */   "DummyProviderSync": () => (/* binding */ DummyProviderSync)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30489);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51532);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12419);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91038);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var yjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(51718);
/* harmony import */ var lib0_mutex_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(70494);
/* harmony import */ var _src_util_encoding__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(59150);
/* harmony import */ var lib0_decoding_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(29693);
/* harmony import */ var y_protocols_sync_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(53665);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }














function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/*
Unlike stated in the LICENSE file, it is not necessary to include the copyright notice and permission notice when you copy code from this file.
*/

/**
 * @module provider/websocket
 */

/* eslint-env browser */






var messageSync = 0;
var messageAwareness = 1;
var messageAuth = 2;
var DummySharedDocument = /*#__PURE__*/function (_Y$Doc) {
  _inherits(DummySharedDocument, _Y$Doc);
  var _super = _createSuper(DummySharedDocument);
  function DummySharedDocument(name) {
    _classCallCheck(this, DummySharedDocument);
    return _super.call(this);
  }
  _createClass(DummySharedDocument, [{
    key: "getLocalAwarenessInfo",
    value: function getLocalAwarenessInfo() {
      return this._localAwarenessState;
    }
  }, {
    key: "getAwarenessInfo",
    value: function getAwarenessInfo() {
      return this.awareness;
    }
  }, {
    key: "setAwarenessField",
    value: function setAwarenessField(field, value) {}
  }]);
  return DummySharedDocument;
}(yjs__WEBPACK_IMPORTED_MODULE_15__.Doc);
var DummySharedDocumentSync = /*#__PURE__*/function (_Y$Doc2) {
  _inherits(DummySharedDocumentSync, _Y$Doc2);
  var _super2 = _createSuper(DummySharedDocumentSync);
  function DummySharedDocumentSync(name) {
    var _this;
    _classCallCheck(this, DummySharedDocumentSync);
    _this = _super2.call(this);
    _defineProperty(_assertThisInitialized(_this), "onDocUpdate", function (update, origin, doc) {
      var encoder = _src_util_encoding__WEBPACK_IMPORTED_MODULE_14__.createEncoder();
      _src_util_encoding__WEBPACK_IMPORTED_MODULE_14__.writeVarUint(encoder, messageSync);
      y_protocols_sync_js__WEBPACK_IMPORTED_MODULE_16__.writeUpdate(encoder, update);
      var buf = _src_util_encoding__WEBPACK_IMPORTED_MODULE_14__.toUint8Array(encoder);
      doc.provider.send(doc, buf);
    });
    _defineProperty(_assertThisInitialized(_this), "onSubDocs", function (_ref) {
      var added = _ref.added,
        removed = _ref.removed,
        loaded = _ref.loaded;
      if (loaded.size) {
        console.log('Init subdocs:', loaded.size);
        var _iterator = _createForOfIteratorHelper(loaded),
          _step;
        try {
          var _loop = function _loop() {
            var subDoc = _step.value;
            subDoc.provider = _this.provider;
            subDoc.providerId = subDoc.guid;
            subDoc.mux = (0,lib0_mutex_js__WEBPACK_IMPORTED_MODULE_17__/* .createMutex */ .M)();
            _this.provider.docs.set(_this.providerName + '_' + subDoc.guid, subDoc);
            setTimeout(_this.initDoc.bind(_assertThisInitialized(_this), subDoc), 0);
            subDoc.on('update', _this.onDocUpdate);
            subDoc.on('synced', function () {
              console.log('GOT SYNCED FOR SUBDOC');
              subDoc.loaded = true;
              subDoc.emit('loaded', []);
            });
          };
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    });
    _this.mux = (0,lib0_mutex_js__WEBPACK_IMPORTED_MODULE_17__/* .createMutex */ .M)();
    setTimeout(_this.initDoc.bind(_assertThisInitialized(_this), _assertThisInitialized(_this)), 0);
    _this.on('update', _this.onDocUpdate);
    _this.on('subdocs', _this.onSubDocs);
    return _this;
  }
  _createClass(DummySharedDocumentSync, [{
    key: "initDoc",
    value: function initDoc(doc) {
      // always send sync step 1 when connected
      var encoder = _src_util_encoding__WEBPACK_IMPORTED_MODULE_14__.createEncoder();
      _src_util_encoding__WEBPACK_IMPORTED_MODULE_14__.writeVarUint(encoder, messageSync);
      y_protocols_sync_js__WEBPACK_IMPORTED_MODULE_16__.writeSyncStep1(encoder, doc);
      doc.provider.send(doc, _src_util_encoding__WEBPACK_IMPORTED_MODULE_14__.toBuffer(encoder));
      console.log('send sync step 1 from', doc.guid);
    }
  }, {
    key: "getLocalAwarenessInfo",
    value: function getLocalAwarenessInfo() {
      return this._localAwarenessState;
    }
  }, {
    key: "getAwarenessInfo",
    value: function getAwarenessInfo() {
      return this.awareness;
    }
  }, {
    key: "setAwarenessField",
    value: function setAwarenessField(field, value) {}
  }]);
  return DummySharedDocumentSync;
}(yjs__WEBPACK_IMPORTED_MODULE_15__.Doc); /**
           * Websocket Provider for Yjs. Creates a single websocket connection to each document.
           * The document name is attached to the provided url. I.e. the following example
           * creates a websocket connection to http://localhost:1234/my-document-name
           *
           * @example
           *   import { WebsocketProvider } from 'yjs/provider/websocket/client.js'
           *   const provider = new WebsocketProvider('http://localhost:1234')
           *   const ydocument = provider.get('my-document-name')
           */
var DummyProvider = /*#__PURE__*/function () {
  function DummyProvider() {
    _classCallCheck(this, DummyProvider);
    this.docs = new Map();
  }
  /**
   * @param {string} name
   * @return {DummySharedDocument}
   */
  _createClass(DummyProvider, [{
    key: "get",
    value: function get(name) {
      var doc = this.docs.get(name);
      if (doc === undefined) {
        doc = new DummySharedDocument(name);
      }
      return doc;
    }
  }]);
  return DummyProvider;
}();
var readMessage = function readMessage(doc, buf) {
  var decoder = lib0_decoding_js__WEBPACK_IMPORTED_MODULE_18__.createDecoder(buf);
  var encoder = _src_util_encoding__WEBPACK_IMPORTED_MODULE_14__.createEncoder();
  var messageType = lib0_decoding_js__WEBPACK_IMPORTED_MODULE_18__.readVarUint(decoder);
  switch (messageType) {
    case messageSync:
      _src_util_encoding__WEBPACK_IMPORTED_MODULE_14__.writeVarUint(encoder, messageSync);
      doc.mux(function () {
        var syncMessageProcessedType = y_protocols_sync_js__WEBPACK_IMPORTED_MODULE_16__.readSyncMessage(decoder, encoder, doc);
        console.log('Reading sync mesage', syncMessageProcessedType, 'for', doc.guid);
        if (syncMessageProcessedType === 1) {
          if (!doc._initialSyncComplete) {
            doc._initialSyncComplete = true;
            doc.emit('synced', []);
          }
        }
      });
      break;
    case messageAwareness:
      //awarenessProtocol.applyAwarenessUpdate(decoder, doc)
      break;
    case messageAuth:
      //Y.authProtocol.readAuthMessage(decoder, doc, permissionDeniedHandler)
      break;
  }
  return encoder;
};
var DummyProviderSync = /*#__PURE__*/function () {
  function DummyProviderSync() {
    _classCallCheck(this, DummyProviderSync);
    this.docs = new Map();
  }
  /**
   * @param {string} name
   * @return {DummySharedDocument}
   */
  _createClass(DummyProviderSync, [{
    key: "get",
    value: function get(name) {
      var doc = this.docs.get(name);
      if (doc === undefined) {
        doc = new DummySharedDocumentSync(name);
        doc.provider = this;
        doc.providerName = name;
        doc.providerId = 'root';
      }
      this.docs.set(name, doc);
      return doc;
    }
  }, {
    key: "send",
    value: function send(fromDoc, data) {
      var _this2 = this;
      this.docs.forEach(function (doc, key) {
        if (doc === fromDoc) {
          return;
        }
        if (fromDoc.providerId !== doc.providerId) {
          // instances of diferent docs
          return;
        }
        var encoder = readMessage(doc, data);
        if (_src_util_encoding__WEBPACK_IMPORTED_MODULE_14__.length(encoder) > 1) {
          _this2.send(doc, _src_util_encoding__WEBPACK_IMPORTED_MODULE_14__.toBuffer(encoder));
        }
      });
    }
  }]);
  return DummyProviderSync;
}();

/***/ }),

/***/ 53940:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(66992);
__webpack_require__(41539);
__webpack_require__(82472);
__webpack_require__(92990);
__webpack_require__(18927);
__webpack_require__(33105);
__webpack_require__(35035);
__webpack_require__(74345);
__webpack_require__(7174);
__webpack_require__(32846);
__webpack_require__(44731);
__webpack_require__(77209);
__webpack_require__(96319);
__webpack_require__(58867);
__webpack_require__(37789);
__webpack_require__(33739);
__webpack_require__(29368);
__webpack_require__(14483);
__webpack_require__(12056);
__webpack_require__(3462);
__webpack_require__(30678);
__webpack_require__(27462);
__webpack_require__(33824);
__webpack_require__(55021);
__webpack_require__(12974);
__webpack_require__(15016);
__webpack_require__(74916);
__webpack_require__(23123);
__webpack_require__(73210);
var window = __webpack_require__(95732);
var httpResponseHandler = function httpResponseHandler(callback, decodeResponseBody) {
  if (decodeResponseBody === void 0) {
    decodeResponseBody = false;
  }
  return function (err, response, responseBody) {
    // if the XHR failed, return that error
    if (err) {
      callback(err);
      return;
    } // if the HTTP status code is 4xx or 5xx, the request also failed

    if (response.statusCode >= 400 && response.statusCode <= 599) {
      var cause = responseBody;
      if (decodeResponseBody) {
        if (window.TextDecoder) {
          var charset = getCharset(response.headers && response.headers['content-type']);
          try {
            cause = new TextDecoder(charset).decode(responseBody);
          } catch (e) {}
        } else {
          cause = String.fromCharCode.apply(null, new Uint8Array(responseBody));
        }
      }
      callback({
        cause: cause
      });
      return;
    } // otherwise, request succeeded

    callback(null, responseBody);
  };
};
function getCharset(contentTypeHeader) {
  if (contentTypeHeader === void 0) {
    contentTypeHeader = '';
  }
  return contentTypeHeader.toLowerCase().split(';').reduce(function (charset, contentType) {
    var _contentType$split = contentType.split('='),
      type = _contentType$split[0],
      value = _contentType$split[1];
    if (type.trim() === 'charset') {
      return value.trim();
    }
    return charset;
  }, 'utf-8');
}
module.exports = httpResponseHandler;

/***/ }),

/***/ 3173:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(54747);
__webpack_require__(74916);
__webpack_require__(23123);
__webpack_require__(73210);
__webpack_require__(47042);
var window = __webpack_require__(95732);
var _extends = __webpack_require__(36413);
var isFunction = __webpack_require__(73562);
createXHR.httpHandler = __webpack_require__(53940);
/**
 * @license
 * slighly modified parse-headers 2.0.2 <https://github.com/kesla/parse-headers/>
 * Copyright (c) 2014 David Björklund
 * Available under the MIT license
 * <https://github.com/kesla/parse-headers/blob/master/LICENCE>
 */

var parseHeaders = function parseHeaders(headers) {
  var result = {};
  if (!headers) {
    return result;
  }
  headers.trim().split('\n').forEach(function (row) {
    var index = row.indexOf(':');
    var key = row.slice(0, index).trim().toLowerCase();
    var value = row.slice(index + 1).trim();
    if (typeof result[key] === 'undefined') {
      result[key] = value;
    } else if (Array.isArray(result[key])) {
      result[key].push(value);
    } else {
      result[key] = [result[key], value];
    }
  });
  return result;
};
module.exports = createXHR; // Allow use of default import syntax in TypeScript

module.exports["default"] = createXHR;
createXHR.XMLHttpRequest = window.XMLHttpRequest || noop;
createXHR.XDomainRequest = "withCredentials" in new createXHR.XMLHttpRequest() ? createXHR.XMLHttpRequest : window.XDomainRequest;
forEachArray(["get", "put", "post", "patch", "head", "delete"], function (method) {
  createXHR[method === "delete" ? "del" : method] = function (uri, options, callback) {
    options = initParams(uri, options, callback);
    options.method = method.toUpperCase();
    return _createXHR(options);
  };
});
function forEachArray(array, iterator) {
  for (var i = 0; i < array.length; i++) {
    iterator(array[i]);
  }
}
function isEmpty(obj) {
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) return false;
  }
  return true;
}
function initParams(uri, options, callback) {
  var params = uri;
  if (isFunction(options)) {
    callback = options;
    if (typeof uri === "string") {
      params = {
        uri: uri
      };
    }
  } else {
    params = _extends({}, options, {
      uri: uri
    });
  }
  params.callback = callback;
  return params;
}
function createXHR(uri, options, callback) {
  options = initParams(uri, options, callback);
  return _createXHR(options);
}
function _createXHR(options) {
  if (typeof options.callback === "undefined") {
    throw new Error("callback argument missing");
  }
  var called = false;
  var callback = function cbOnce(err, response, body) {
    if (!called) {
      called = true;
      options.callback(err, response, body);
    }
  };
  function readystatechange() {
    if (xhr.readyState === 4) {
      setTimeout(loadFunc, 0);
    }
  }
  function getBody() {
    // Chrome with requestType=blob throws errors arround when even testing access to responseText
    var body = undefined;
    if (xhr.response) {
      body = xhr.response;
    } else {
      body = xhr.responseText || getXml(xhr);
    }
    if (isJson) {
      try {
        body = JSON.parse(body);
      } catch (e) {}
    }
    return body;
  }
  function errorFunc(evt) {
    clearTimeout(timeoutTimer);
    if (!(evt instanceof Error)) {
      evt = new Error("" + (evt || "Unknown XMLHttpRequest Error"));
    }
    evt.statusCode = 0;
    return callback(evt, failureResponse);
  } // will load the data & process the response in a special response object

  function loadFunc() {
    if (aborted) return;
    var status;
    clearTimeout(timeoutTimer);
    if (options.useXDR && xhr.status === undefined) {
      //IE8 CORS GET successful response doesn't have a status field, but body is fine
      status = 200;
    } else {
      status = xhr.status === 1223 ? 204 : xhr.status;
    }
    var response = failureResponse;
    var err = null;
    if (status !== 0) {
      response = {
        body: getBody(),
        statusCode: status,
        method: method,
        headers: {},
        url: uri,
        rawRequest: xhr
      };
      if (xhr.getAllResponseHeaders) {
        //remember xhr can in fact be XDR for CORS in IE
        response.headers = parseHeaders(xhr.getAllResponseHeaders());
      }
    } else {
      err = new Error("Internal XMLHttpRequest Error");
    }
    return callback(err, response, response.body);
  }
  var xhr = options.xhr || null;
  if (!xhr) {
    if (options.cors || options.useXDR) {
      xhr = new createXHR.XDomainRequest();
    } else {
      xhr = new createXHR.XMLHttpRequest();
    }
  }
  var key;
  var aborted;
  var uri = xhr.url = options.uri || options.url;
  var method = xhr.method = options.method || "GET";
  var body = options.body || options.data;
  var headers = xhr.headers = options.headers || {};
  var sync = !!options.sync;
  var isJson = false;
  var timeoutTimer;
  var failureResponse = {
    body: undefined,
    headers: {},
    statusCode: 0,
    method: method,
    url: uri,
    rawRequest: xhr
  };
  if ("json" in options && options.json !== false) {
    isJson = true;
    headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json"); //Don't override existing accept header declared by user

    if (method !== "GET" && method !== "HEAD") {
      headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json"); //Don't override existing accept header declared by user

      body = JSON.stringify(options.json === true ? body : options.json);
    }
  }
  xhr.onreadystatechange = readystatechange;
  xhr.onload = loadFunc;
  xhr.onerror = errorFunc; // IE9 must have onprogress be set to a unique function.

  xhr.onprogress = function () {// IE must die
  };
  xhr.onabort = function () {
    aborted = true;
  };
  xhr.ontimeout = errorFunc;
  xhr.open(method, uri, !sync, options.username, options.password); //has to be after open

  if (!sync) {
    xhr.withCredentials = !!options.withCredentials;
  } // Cannot set timeout with sync request
  // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
  // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent

  if (!sync && options.timeout > 0) {
    timeoutTimer = setTimeout(function () {
      if (aborted) return;
      aborted = true; //IE9 may still call readystatechange

      xhr.abort("timeout");
      var e = new Error("XMLHttpRequest timeout");
      e.code = "ETIMEDOUT";
      errorFunc(e);
    }, options.timeout);
  }
  if (xhr.setRequestHeader) {
    for (key in headers) {
      if (headers.hasOwnProperty(key)) {
        xhr.setRequestHeader(key, headers[key]);
      }
    }
  } else if (options.headers && !isEmpty(options.headers)) {
    throw new Error("Headers cannot be set on an XDomainRequest object");
  }
  if ("responseType" in options) {
    xhr.responseType = options.responseType;
  }
  if ("beforeSend" in options && typeof options.beforeSend === "function") {
    options.beforeSend(xhr);
  } // Microsoft Edge browser sends "undefined" when send is called with undefined value.
  // XMLHttpRequest spec says to pass null as body to indicate no body
  // See https://github.com/naugtur/xhr/issues/100.

  xhr.send(body || null);
  return xhr;
}
function getXml(xhr) {
  // xhr.responseXML will throw Exception "InvalidStateError" or "DOMException"
  // See https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseXML.
  try {
    if (xhr.responseType === "document") {
      return xhr.responseXML;
    }
    var firefoxBugTakenEffect = xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror";
    if (xhr.responseType === "" && !firefoxBugTakenEffect) {
      return xhr.responseXML;
    }
  } catch (e) {}
  return null;
}
function noop() {}

/***/ }),

/***/ 62697:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


/**
 * Ponyfill for `Array.prototype.find` which is only available in ES6 runtimes.
 *
 * Works with anything that has a `length` property and index access properties, including NodeList.
 *
 * @template {unknown} T
 * @param {Array<T> | ({length:number, [number]: T})} list
 * @param {function (item: T, index: number, list:Array<T> | ({length:number, [number]: T})):boolean} predicate
 * @param {Partial<Pick<ArrayConstructor['prototype'], 'find'>>?} ac `Array.prototype` by default,
 * 				allows injecting a custom implementation in tests
 * @returns {T | undefined}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
 * @see https://tc39.es/ecma262/multipage/indexed-collections.html#sec-array.prototype.find
 */
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(69826);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function find(list, predicate, ac) {
  if (ac === undefined) {
    ac = Array.prototype;
  }
  if (list && typeof ac.find === 'function') {
    return ac.find.call(list, predicate);
  }
  for (var i = 0; i < list.length; i++) {
    if (Object.prototype.hasOwnProperty.call(list, i)) {
      var item = list[i];
      if (predicate.call(undefined, item, i, list)) {
        return item;
      }
    }
  }
}

/**
 * "Shallow freezes" an object to render it immutable.
 * Uses `Object.freeze` if available,
 * otherwise the immutability is only in the type.
 *
 * Is used to create "enum like" objects.
 *
 * @template T
 * @param {T} object the object to freeze
 * @param {Pick<ObjectConstructor, 'freeze'> = Object} oc `Object` by default,
 * 				allows to inject custom object constructor for tests
 * @returns {Readonly<T>}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
 */
function freeze(object, oc) {
  if (oc === undefined) {
    oc = Object;
  }
  return oc && typeof oc.freeze === 'function' ? oc.freeze(object) : object;
}

/**
 * Since we can not rely on `Object.assign` we provide a simplified version
 * that is sufficient for our needs.
 *
 * @param {Object} target
 * @param {Object | null | undefined} source
 *
 * @returns {Object} target
 * @throws TypeError if target is not an object
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 * @see https://tc39.es/ecma262/multipage/fundamental-objects.html#sec-object.assign
 */
function assign(target, source) {
  if (target === null || _typeof(target) !== 'object') {
    throw new TypeError('target is not an object');
  }
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      target[key] = source[key];
    }
  }
  return target;
}

/**
 * All mime types that are allowed as input to `DOMParser.parseFromString`
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString#Argument02 MDN
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#domparsersupportedtype WHATWG HTML Spec
 * @see DOMParser.prototype.parseFromString
 */
var MIME_TYPE = freeze({
  /**
   * `text/html`, the only mime type that triggers treating an XML document as HTML.
   *
   * @see DOMParser.SupportedType.isHTML
   * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
   * @see https://en.wikipedia.org/wiki/HTML Wikipedia
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
   * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
   */
  HTML: 'text/html',
  /**
   * Helper method to check a mime type if it indicates an HTML document
   *
   * @param {string} [value]
   * @returns {boolean}
   *
   * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
   * @see https://en.wikipedia.org/wiki/HTML Wikipedia
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
   * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */
  isHTML: function isHTML(value) {
    return value === MIME_TYPE.HTML;
  },
  /**
   * `application/xml`, the standard mime type for XML documents.
   *
   * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
   * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
   * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
   */
  XML_APPLICATION: 'application/xml',
  /**
   * `text/html`, an alias for `application/xml`.
   *
   * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
   * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
   * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
   */
  XML_TEXT: 'text/xml',
  /**
   * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
   * but is parsed as an XML document.
   *
   * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
   * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
   */
  XML_XHTML_APPLICATION: 'application/xhtml+xml',
  /**
   * `image/svg+xml`,
   *
   * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
   * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
   * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
   */
  XML_SVG_IMAGE: 'image/svg+xml'
});

/**
 * Namespaces that are used in this code base.
 *
 * @see http://www.w3.org/TR/REC-xml-names
 */
var NAMESPACE = freeze({
  /**
   * The XHTML namespace.
   *
   * @see http://www.w3.org/1999/xhtml
   */
  HTML: 'http://www.w3.org/1999/xhtml',
  /**
   * Checks if `uri` equals `NAMESPACE.HTML`.
   *
   * @param {string} [uri]
   *
   * @see NAMESPACE.HTML
   */
  isHTML: function isHTML(uri) {
    return uri === NAMESPACE.HTML;
  },
  /**
   * The SVG namespace.
   *
   * @see http://www.w3.org/2000/svg
   */
  SVG: 'http://www.w3.org/2000/svg',
  /**
   * The `xml:` namespace.
   *
   * @see http://www.w3.org/XML/1998/namespace
   */
  XML: 'http://www.w3.org/XML/1998/namespace',
  /**
   * The `xmlns:` namespace
   *
   * @see https://www.w3.org/2000/xmlns/
   */
  XMLNS: 'http://www.w3.org/2000/xmlns/'
});
exports.assign = assign;
exports.find = find;
exports.freeze = freeze;
exports.MIME_TYPE = MIME_TYPE;
exports.NAMESPACE = NAMESPACE;

/***/ }),

/***/ 60522:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;
__webpack_require__(74916);
__webpack_require__(15306);
var conventions = __webpack_require__(62697);
var dom = __webpack_require__(67102);
var entities = __webpack_require__(85653);
var sax = __webpack_require__(36752);
var DOMImplementation = dom.DOMImplementation;
var NAMESPACE = conventions.NAMESPACE;
var ParseError = sax.ParseError;
var XMLReader = sax.XMLReader;

/**
 * Normalizes line ending according to https://www.w3.org/TR/xml11/#sec-line-ends:
 *
 * > XML parsed entities are often stored in computer files which,
 * > for editing convenience, are organized into lines.
 * > These lines are typically separated by some combination
 * > of the characters CARRIAGE RETURN (#xD) and LINE FEED (#xA).
 * >
 * > To simplify the tasks of applications, the XML processor must behave
 * > as if it normalized all line breaks in external parsed entities (including the document entity)
 * > on input, before parsing, by translating all of the following to a single #xA character:
 * >
 * > 1. the two-character sequence #xD #xA
 * > 2. the two-character sequence #xD #x85
 * > 3. the single character #x85
 * > 4. the single character #x2028
 * > 5. any #xD character that is not immediately followed by #xA or #x85.
 *
 * @param {string} input
 * @returns {string}
 */
function normalizeLineEndings(input) {
  return input.replace(/\r[\n\u0085]/g, '\n').replace(/[\r\u0085\u2028]/g, '\n');
}

/**
 * @typedef Locator
 * @property {number} [columnNumber]
 * @property {number} [lineNumber]
 */

/**
 * @typedef DOMParserOptions
 * @property {DOMHandler} [domBuilder]
 * @property {Function} [errorHandler]
 * @property {(string) => string} [normalizeLineEndings] used to replace line endings before parsing
 * 						defaults to `normalizeLineEndings`
 * @property {Locator} [locator]
 * @property {Record<string, string>} [xmlns]
 *
 * @see normalizeLineEndings
 */

/**
 * The DOMParser interface provides the ability to parse XML or HTML source code
 * from a string into a DOM `Document`.
 *
 * _xmldom is different from the spec in that it allows an `options` parameter,
 * to override the default behavior._
 *
 * @param {DOMParserOptions} [options]
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-parsing-and-serialization
 */
function DOMParser(options) {
  this.options = options || {
    locator: {}
  };
}
DOMParser.prototype.parseFromString = function (source, mimeType) {
  var options = this.options;
  var sax = new XMLReader();
  var domBuilder = options.domBuilder || new DOMHandler(); //contentHandler and LexicalHandler
  var errorHandler = options.errorHandler;
  var locator = options.locator;
  var defaultNSMap = options.xmlns || {};
  var isHTML = /\/x?html?$/.test(mimeType); //mimeType.toLowerCase().indexOf('html') > -1;
  var entityMap = isHTML ? entities.HTML_ENTITIES : entities.XML_ENTITIES;
  if (locator) {
    domBuilder.setDocumentLocator(locator);
  }
  sax.errorHandler = buildErrorHandler(errorHandler, domBuilder, locator);
  sax.domBuilder = options.domBuilder || domBuilder;
  if (isHTML) {
    defaultNSMap[''] = NAMESPACE.HTML;
  }
  defaultNSMap.xml = defaultNSMap.xml || NAMESPACE.XML;
  var normalize = options.normalizeLineEndings || normalizeLineEndings;
  if (source && typeof source === 'string') {
    sax.parse(normalize(source), defaultNSMap, entityMap);
  } else {
    sax.errorHandler.error('invalid doc source');
  }
  return domBuilder.doc;
};
function buildErrorHandler(errorImpl, domBuilder, locator) {
  if (!errorImpl) {
    if (domBuilder instanceof DOMHandler) {
      return domBuilder;
    }
    errorImpl = domBuilder;
  }
  var errorHandler = {};
  var isCallback = errorImpl instanceof Function;
  locator = locator || {};
  function build(key) {
    var fn = errorImpl[key];
    if (!fn && isCallback) {
      fn = errorImpl.length == 2 ? function (msg) {
        errorImpl(key, msg);
      } : errorImpl;
    }
    errorHandler[key] = fn && function (msg) {
      fn('[xmldom ' + key + ']\t' + msg + _locator(locator));
    } || function () {};
  }
  build('warning');
  build('error');
  build('fatalError');
  return errorHandler;
}

//console.log('#\n\n\n\n\n\n\n####')
/**
 * +ContentHandler+ErrorHandler
 * +LexicalHandler+EntityResolver2
 * -DeclHandler-DTDHandler
 *
 * DefaultHandler:EntityResolver, DTDHandler, ContentHandler, ErrorHandler
 * DefaultHandler2:DefaultHandler,LexicalHandler, DeclHandler, EntityResolver2
 * @link http://www.saxproject.org/apidoc/org/xml/sax/helpers/DefaultHandler.html
 */
function DOMHandler() {
  this.cdata = false;
}
function position(locator, node) {
  node.lineNumber = locator.lineNumber;
  node.columnNumber = locator.columnNumber;
}
/**
 * @see org.xml.sax.ContentHandler#startDocument
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ContentHandler.html
 */
DOMHandler.prototype = {
  startDocument: function startDocument() {
    this.doc = new DOMImplementation().createDocument(null, null, null);
    if (this.locator) {
      this.doc.documentURI = this.locator.systemId;
    }
  },
  startElement: function startElement(namespaceURI, localName, qName, attrs) {
    var doc = this.doc;
    var el = doc.createElementNS(namespaceURI, qName || localName);
    var len = attrs.length;
    appendElement(this, el);
    this.currentElement = el;
    this.locator && position(this.locator, el);
    for (var i = 0; i < len; i++) {
      var namespaceURI = attrs.getURI(i);
      var value = attrs.getValue(i);
      var qName = attrs.getQName(i);
      var attr = doc.createAttributeNS(namespaceURI, qName);
      this.locator && position(attrs.getLocator(i), attr);
      attr.value = attr.nodeValue = value;
      el.setAttributeNode(attr);
    }
  },
  endElement: function endElement(namespaceURI, localName, qName) {
    var current = this.currentElement;
    var tagName = current.tagName;
    this.currentElement = current.parentNode;
  },
  startPrefixMapping: function startPrefixMapping(prefix, uri) {},
  endPrefixMapping: function endPrefixMapping(prefix) {},
  processingInstruction: function processingInstruction(target, data) {
    var ins = this.doc.createProcessingInstruction(target, data);
    this.locator && position(this.locator, ins);
    appendElement(this, ins);
  },
  ignorableWhitespace: function ignorableWhitespace(ch, start, length) {},
  characters: function characters(chars, start, length) {
    chars = _toString.apply(this, arguments);
    //console.log(chars)
    if (chars) {
      if (this.cdata) {
        var charNode = this.doc.createCDATASection(chars);
      } else {
        var charNode = this.doc.createTextNode(chars);
      }
      if (this.currentElement) {
        this.currentElement.appendChild(charNode);
      } else if (/^\s*$/.test(chars)) {
        this.doc.appendChild(charNode);
        //process xml
      }

      this.locator && position(this.locator, charNode);
    }
  },
  skippedEntity: function skippedEntity(name) {},
  endDocument: function endDocument() {
    this.doc.normalize();
  },
  setDocumentLocator: function setDocumentLocator(locator) {
    if (this.locator = locator) {
      // && !('lineNumber' in locator)){
      locator.lineNumber = 0;
    }
  },
  //LexicalHandler
  comment: function comment(chars, start, length) {
    chars = _toString.apply(this, arguments);
    var comm = this.doc.createComment(chars);
    this.locator && position(this.locator, comm);
    appendElement(this, comm);
  },
  startCDATA: function startCDATA() {
    //used in characters() methods
    this.cdata = true;
  },
  endCDATA: function endCDATA() {
    this.cdata = false;
  },
  startDTD: function startDTD(name, publicId, systemId) {
    var impl = this.doc.implementation;
    if (impl && impl.createDocumentType) {
      var dt = impl.createDocumentType(name, publicId, systemId);
      this.locator && position(this.locator, dt);
      appendElement(this, dt);
      this.doc.doctype = dt;
    }
  },
  /**
   * @see org.xml.sax.ErrorHandler
   * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
   */
  warning: function warning(error) {
    console.warn('[xmldom warning]\t' + error, _locator(this.locator));
  },
  error: function error(_error) {
    console.error('[xmldom error]\t' + _error, _locator(this.locator));
  },
  fatalError: function fatalError(error) {
    throw new ParseError(error, this.locator);
  }
};
function _locator(l) {
  if (l) {
    return '\n@' + (l.systemId || '') + '#[line:' + l.lineNumber + ',col:' + l.columnNumber + ']';
  }
}
function _toString(chars, start, length) {
  if (typeof chars == 'string') {
    return chars.substr(start, length);
  } else {
    //java sax connect width xmldom on rhino(what about: "? && !(chars instanceof String)")
    if (chars.length >= start + length || start) {
      return new java.lang.String(chars, start, length) + '';
    }
    return chars;
  }
}

/*
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/LexicalHandler.html
 * used method of org.xml.sax.ext.LexicalHandler:
 *  #comment(chars, start, length)
 *  #startCDATA()
 *  #endCDATA()
 *  #startDTD(name, publicId, systemId)
 *
 *
 * IGNORED method of org.xml.sax.ext.LexicalHandler:
 *  #endDTD()
 *  #startEntity(name)
 *  #endEntity(name)
 *
 *
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/DeclHandler.html
 * IGNORED method of org.xml.sax.ext.DeclHandler
 * 	#attributeDecl(eName, aName, type, mode, value)
 *  #elementDecl(name, model)
 *  #externalEntityDecl(name, publicId, systemId)
 *  #internalEntityDecl(name, value)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/EntityResolver2.html
 * IGNORED method of org.xml.sax.EntityResolver2
 *  #resolveEntity(String name,String publicId,String baseURI,String systemId)
 *  #resolveEntity(publicId, systemId)
 *  #getExternalSubset(name, baseURI)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/DTDHandler.html
 * IGNORED method of org.xml.sax.DTDHandler
 *  #notationDecl(name, publicId, systemId) {};
 *  #unparsedEntityDecl(name, publicId, systemId, notationName) {};
 */
"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function (key) {
  DOMHandler.prototype[key] = function () {
    return null;
  };
});

/* Private static helpers treated below as private instance methods, so don't need to add these to the public API; we might use a Relator to also get rid of non-standard public properties */
function appendElement(hander, node) {
  if (!hander.currentElement) {
    hander.doc.appendChild(node);
  } else {
    hander.currentElement.appendChild(node);
  }
} //appendChild and setAttributeNS are preformance key

__webpack_unused_export__ = DOMHandler;
__webpack_unused_export__ = normalizeLineEndings;
exports.DOMParser = DOMParser;

/***/ }),

/***/ 67102:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(69826);
__webpack_require__(57327);
__webpack_require__(74916);
__webpack_require__(23123);
__webpack_require__(47941);
__webpack_require__(69600);
__webpack_require__(68309);
__webpack_require__(41539);
__webpack_require__(39714);
__webpack_require__(15306);
__webpack_require__(47042);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
var conventions = __webpack_require__(62697);
var find = conventions.find;
var NAMESPACE = conventions.NAMESPACE;

/**
 * A prerequisite for `[].filter`, to drop elements that are empty
 * @param {string} input
 * @returns {boolean}
 */
function notEmptyString(input) {
  return input !== '';
}
/**
 * @see https://infra.spec.whatwg.org/#split-on-ascii-whitespace
 * @see https://infra.spec.whatwg.org/#ascii-whitespace
 *
 * @param {string} input
 * @returns {string[]} (can be empty)
 */
function splitOnASCIIWhitespace(input) {
  // U+0009 TAB, U+000A LF, U+000C FF, U+000D CR, U+0020 SPACE
  return input ? input.split(/[\t\n\f\r ]+/).filter(notEmptyString) : [];
}

/**
 * Adds element as a key to current if it is not already present.
 *
 * @param {Record<string, boolean | undefined>} current
 * @param {string} element
 * @returns {Record<string, boolean | undefined>}
 */
function orderedSetReducer(current, element) {
  if (!current.hasOwnProperty(element)) {
    current[element] = true;
  }
  return current;
}

/**
 * @see https://infra.spec.whatwg.org/#ordered-set
 * @param {string} input
 * @returns {string[]}
 */
function toOrderedSet(input) {
  if (!input) return [];
  var list = splitOnASCIIWhitespace(input);
  return Object.keys(list.reduce(orderedSetReducer, {}));
}

/**
 * Uses `list.indexOf` to implement something like `Array.prototype.includes`,
 * which we can not rely on being available.
 *
 * @param {any[]} list
 * @returns {function(any): boolean}
 */
function arrayIncludes(list) {
  return function (element) {
    return list && list.indexOf(element) !== -1;
  };
}
function copy(src, dest) {
  for (var p in src) {
    if (Object.prototype.hasOwnProperty.call(src, p)) {
      dest[p] = src[p];
    }
  }
}

/**
^\w+\.prototype\.([_\w]+)\s*=\s*((?:.*\{\s*?[\r\n][\s\S]*?^})|\S.*?(?=[;\r\n]));?
^\w+\.prototype\.([_\w]+)\s*=\s*(\S.*?(?=[;\r\n]));?
 */
function _extends(Class, Super) {
  var pt = Class.prototype;
  if (!(pt instanceof Super)) {
    function t() {}
    ;
    t.prototype = Super.prototype;
    t = new t();
    copy(pt, t);
    Class.prototype = pt = t;
  }
  if (pt.constructor != Class) {
    if (typeof Class != 'function') {
      console.error("unknown Class:" + Class);
    }
    pt.constructor = Class;
  }
}

// Node Types
var NodeType = {};
var ELEMENT_NODE = NodeType.ELEMENT_NODE = 1;
var ATTRIBUTE_NODE = NodeType.ATTRIBUTE_NODE = 2;
var TEXT_NODE = NodeType.TEXT_NODE = 3;
var CDATA_SECTION_NODE = NodeType.CDATA_SECTION_NODE = 4;
var ENTITY_REFERENCE_NODE = NodeType.ENTITY_REFERENCE_NODE = 5;
var ENTITY_NODE = NodeType.ENTITY_NODE = 6;
var PROCESSING_INSTRUCTION_NODE = NodeType.PROCESSING_INSTRUCTION_NODE = 7;
var COMMENT_NODE = NodeType.COMMENT_NODE = 8;
var DOCUMENT_NODE = NodeType.DOCUMENT_NODE = 9;
var DOCUMENT_TYPE_NODE = NodeType.DOCUMENT_TYPE_NODE = 10;
var DOCUMENT_FRAGMENT_NODE = NodeType.DOCUMENT_FRAGMENT_NODE = 11;
var NOTATION_NODE = NodeType.NOTATION_NODE = 12;

// ExceptionCode
var ExceptionCode = {};
var ExceptionMessage = {};
var INDEX_SIZE_ERR = ExceptionCode.INDEX_SIZE_ERR = (ExceptionMessage[1] = "Index size error", 1);
var DOMSTRING_SIZE_ERR = ExceptionCode.DOMSTRING_SIZE_ERR = (ExceptionMessage[2] = "DOMString size error", 2);
var HIERARCHY_REQUEST_ERR = ExceptionCode.HIERARCHY_REQUEST_ERR = (ExceptionMessage[3] = "Hierarchy request error", 3);
var WRONG_DOCUMENT_ERR = ExceptionCode.WRONG_DOCUMENT_ERR = (ExceptionMessage[4] = "Wrong document", 4);
var INVALID_CHARACTER_ERR = ExceptionCode.INVALID_CHARACTER_ERR = (ExceptionMessage[5] = "Invalid character", 5);
var NO_DATA_ALLOWED_ERR = ExceptionCode.NO_DATA_ALLOWED_ERR = (ExceptionMessage[6] = "No data allowed", 6);
var NO_MODIFICATION_ALLOWED_ERR = ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = (ExceptionMessage[7] = "No modification allowed", 7);
var NOT_FOUND_ERR = ExceptionCode.NOT_FOUND_ERR = (ExceptionMessage[8] = "Not found", 8);
var NOT_SUPPORTED_ERR = ExceptionCode.NOT_SUPPORTED_ERR = (ExceptionMessage[9] = "Not supported", 9);
var INUSE_ATTRIBUTE_ERR = ExceptionCode.INUSE_ATTRIBUTE_ERR = (ExceptionMessage[10] = "Attribute in use", 10);
//level2
var INVALID_STATE_ERR = ExceptionCode.INVALID_STATE_ERR = (ExceptionMessage[11] = "Invalid state", 11);
var SYNTAX_ERR = ExceptionCode.SYNTAX_ERR = (ExceptionMessage[12] = "Syntax error", 12);
var INVALID_MODIFICATION_ERR = ExceptionCode.INVALID_MODIFICATION_ERR = (ExceptionMessage[13] = "Invalid modification", 13);
var NAMESPACE_ERR = ExceptionCode.NAMESPACE_ERR = (ExceptionMessage[14] = "Invalid namespace", 14);
var INVALID_ACCESS_ERR = ExceptionCode.INVALID_ACCESS_ERR = (ExceptionMessage[15] = "Invalid access", 15);

/**
 * DOM Level 2
 * Object DOMException
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/ecma-script-binding.html
 * @see http://www.w3.org/TR/REC-DOM-Level-1/ecma-script-language-binding.html
 */
function DOMException(code, message) {
  if (message instanceof Error) {
    var error = message;
  } else {
    error = this;
    Error.call(this, ExceptionMessage[code]);
    this.message = ExceptionMessage[code];
    if (Error.captureStackTrace) Error.captureStackTrace(this, DOMException);
  }
  error.code = code;
  if (message) this.message = this.message + ": " + message;
  return error;
}
;
DOMException.prototype = Error.prototype;
copy(ExceptionCode, DOMException);

/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-536297177
 * The NodeList interface provides the abstraction of an ordered collection of nodes, without defining or constraining how this collection is implemented. NodeList objects in the DOM are live.
 * The items in the NodeList are accessible via an integral index, starting from 0.
 */
function NodeList() {}
;
NodeList.prototype = {
  /**
   * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
   * @standard level1
   */
  length: 0,
  /**
   * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
   * @standard level1
   * @param index  unsigned long
   *   Index into the collection.
   * @return Node
   * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
   */
  item: function item(index) {
    return index >= 0 && index < this.length ? this[index] : null;
  },
  toString: function toString(isHTML, nodeFilter) {
    for (var buf = [], i = 0; i < this.length; i++) {
      serializeToString(this[i], buf, isHTML, nodeFilter);
    }
    return buf.join('');
  },
  /**
   * @private
   * @param {function (Node):boolean} predicate
   * @returns {Node[]}
   */
  filter: function filter(predicate) {
    return Array.prototype.filter.call(this, predicate);
  },
  /**
   * @private
   * @param {Node} item
   * @returns {number}
   */
  indexOf: function indexOf(item) {
    return Array.prototype.indexOf.call(this, item);
  }
};
function LiveNodeList(node, refresh) {
  this._node = node;
  this._refresh = refresh;
  _updateLiveList(this);
}
function _updateLiveList(list) {
  var inc = list._node._inc || list._node.ownerDocument._inc;
  if (list._inc !== inc) {
    var ls = list._refresh(list._node);
    __set__(list, 'length', ls.length);
    if (!list.$$length || ls.length < list.$$length) {
      for (var i = ls.length; (i in list); i++) {
        if (Object.prototype.hasOwnProperty.call(list, i)) {
          delete list[i];
        }
      }
    }
    copy(ls, list);
    list._inc = inc;
  }
}
LiveNodeList.prototype.item = function (i) {
  _updateLiveList(this);
  return this[i] || null;
};
_extends(LiveNodeList, NodeList);

/**
 * Objects implementing the NamedNodeMap interface are used
 * to represent collections of nodes that can be accessed by name.
 * Note that NamedNodeMap does not inherit from NodeList;
 * NamedNodeMaps are not maintained in any particular order.
 * Objects contained in an object implementing NamedNodeMap may also be accessed by an ordinal index,
 * but this is simply to allow convenient enumeration of the contents of a NamedNodeMap,
 * and does not imply that the DOM specifies an order to these Nodes.
 * NamedNodeMap objects in the DOM are live.
 * used for attributes or DocumentType entities
 */
function NamedNodeMap() {}
;
function _findNodeIndex(list, node) {
  var i = list.length;
  while (i--) {
    if (list[i] === node) {
      return i;
    }
  }
}
function _addNamedNode(el, list, newAttr, oldAttr) {
  if (oldAttr) {
    list[_findNodeIndex(list, oldAttr)] = newAttr;
  } else {
    list[list.length++] = newAttr;
  }
  if (el) {
    newAttr.ownerElement = el;
    var doc = el.ownerDocument;
    if (doc) {
      oldAttr && _onRemoveAttribute(doc, el, oldAttr);
      _onAddAttribute(doc, el, newAttr);
    }
  }
}
function _removeNamedNode(el, list, attr) {
  //console.log('remove attr:'+attr)
  var i = _findNodeIndex(list, attr);
  if (i >= 0) {
    var lastIndex = list.length - 1;
    while (i < lastIndex) {
      list[i] = list[++i];
    }
    list.length = lastIndex;
    if (el) {
      var doc = el.ownerDocument;
      if (doc) {
        _onRemoveAttribute(doc, el, attr);
        attr.ownerElement = null;
      }
    }
  } else {
    throw new DOMException(NOT_FOUND_ERR, new Error(el.tagName + '@' + attr));
  }
}
NamedNodeMap.prototype = {
  length: 0,
  item: NodeList.prototype.item,
  getNamedItem: function getNamedItem(key) {
    //		if(key.indexOf(':')>0 || key == 'xmlns'){
    //			return null;
    //		}
    //console.log()
    var i = this.length;
    while (i--) {
      var attr = this[i];
      //console.log(attr.nodeName,key)
      if (attr.nodeName == key) {
        return attr;
      }
    }
  },
  setNamedItem: function setNamedItem(attr) {
    var el = attr.ownerElement;
    if (el && el != this._ownerElement) {
      throw new DOMException(INUSE_ATTRIBUTE_ERR);
    }
    var oldAttr = this.getNamedItem(attr.nodeName);
    _addNamedNode(this._ownerElement, this, attr, oldAttr);
    return oldAttr;
  },
  /* returns Node */
  setNamedItemNS: function setNamedItemNS(attr) {
    // raises: WRONG_DOCUMENT_ERR,NO_MODIFICATION_ALLOWED_ERR,INUSE_ATTRIBUTE_ERR
    var el = attr.ownerElement,
      oldAttr;
    if (el && el != this._ownerElement) {
      throw new DOMException(INUSE_ATTRIBUTE_ERR);
    }
    oldAttr = this.getNamedItemNS(attr.namespaceURI, attr.localName);
    _addNamedNode(this._ownerElement, this, attr, oldAttr);
    return oldAttr;
  },
  /* returns Node */
  removeNamedItem: function removeNamedItem(key) {
    var attr = this.getNamedItem(key);
    _removeNamedNode(this._ownerElement, this, attr);
    return attr;
  },
  // raises: NOT_FOUND_ERR,NO_MODIFICATION_ALLOWED_ERR

  //for level2
  removeNamedItemNS: function removeNamedItemNS(namespaceURI, localName) {
    var attr = this.getNamedItemNS(namespaceURI, localName);
    _removeNamedNode(this._ownerElement, this, attr);
    return attr;
  },
  getNamedItemNS: function getNamedItemNS(namespaceURI, localName) {
    var i = this.length;
    while (i--) {
      var node = this[i];
      if (node.localName == localName && node.namespaceURI == namespaceURI) {
        return node;
      }
    }
    return null;
  }
};

/**
 * The DOMImplementation interface represents an object providing methods
 * which are not dependent on any particular document.
 * Such an object is returned by the `Document.implementation` property.
 *
 * __The individual methods describe the differences compared to the specs.__
 *
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation MDN
 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-102161490 DOM Level 1 Core (Initial)
 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#ID-102161490 DOM Level 2 Core
 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-102161490 DOM Level 3 Core
 * @see https://dom.spec.whatwg.org/#domimplementation DOM Living Standard
 */
function DOMImplementation() {}
DOMImplementation.prototype = {
  /**
   * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
   * The different implementations fairly diverged in what kind of features were reported.
   * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
   *
   * @deprecated It is deprecated and modern browsers return true in all cases.
   *
   * @param {string} feature
   * @param {string} [version]
   * @returns {boolean} always true
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
   * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
   */
  hasFeature: function hasFeature(feature, version) {
    return true;
  },
  /**
   * Creates an XML Document object of the specified type with its document element.
   *
   * __It behaves slightly different from the description in the living standard__:
   * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
   * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
   * - this implementation is not validating names or qualified names
   *   (when parsing XML strings, the SAX parser takes care of that)
   *
   * @param {string|null} namespaceURI
   * @param {string} qualifiedName
   * @param {DocumentType=null} doctype
   * @returns {Document}
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
   * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
   *
   * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
   * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
   * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
   */
  createDocument: function createDocument(namespaceURI, qualifiedName, doctype) {
    var doc = new Document();
    doc.implementation = this;
    doc.childNodes = new NodeList();
    doc.doctype = doctype || null;
    if (doctype) {
      doc.appendChild(doctype);
    }
    if (qualifiedName) {
      var root = doc.createElementNS(namespaceURI, qualifiedName);
      doc.appendChild(root);
    }
    return doc;
  },
  /**
   * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
   *
   * __This behavior is slightly different from the in the specs__:
   * - this implementation is not validating names or qualified names
   *   (when parsing XML strings, the SAX parser takes care of that)
   *
   * @param {string} qualifiedName
   * @param {string} [publicId]
   * @param {string} [systemId]
   * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
   * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
   * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
   *
   * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
   * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
   * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
   */
  createDocumentType: function createDocumentType(qualifiedName, publicId, systemId) {
    var node = new DocumentType();
    node.name = qualifiedName;
    node.nodeName = qualifiedName;
    node.publicId = publicId || '';
    node.systemId = systemId || '';
    return node;
  }
};

/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-1950641247
 */

function Node() {}
;
Node.prototype = {
  firstChild: null,
  lastChild: null,
  previousSibling: null,
  nextSibling: null,
  attributes: null,
  parentNode: null,
  childNodes: null,
  ownerDocument: null,
  nodeValue: null,
  namespaceURI: null,
  prefix: null,
  localName: null,
  // Modified in DOM Level 2:
  insertBefore: function insertBefore(newChild, refChild) {
    //raises
    return _insertBefore(this, newChild, refChild);
  },
  replaceChild: function replaceChild(newChild, oldChild) {
    //raises
    _insertBefore(this, newChild, oldChild, assertPreReplacementValidityInDocument);
    if (oldChild) {
      this.removeChild(oldChild);
    }
  },
  removeChild: function removeChild(oldChild) {
    return _removeChild(this, oldChild);
  },
  appendChild: function appendChild(newChild) {
    return this.insertBefore(newChild, null);
  },
  hasChildNodes: function hasChildNodes() {
    return this.firstChild != null;
  },
  cloneNode: function cloneNode(deep) {
    return _cloneNode(this.ownerDocument || this, this, deep);
  },
  // Modified in DOM Level 2:
  normalize: function normalize() {
    var child = this.firstChild;
    while (child) {
      var next = child.nextSibling;
      if (next && next.nodeType == TEXT_NODE && child.nodeType == TEXT_NODE) {
        this.removeChild(next);
        child.appendData(next.data);
      } else {
        child.normalize();
        child = next;
      }
    }
  },
  // Introduced in DOM Level 2:
  isSupported: function isSupported(feature, version) {
    return this.ownerDocument.implementation.hasFeature(feature, version);
  },
  // Introduced in DOM Level 2:
  hasAttributes: function hasAttributes() {
    return this.attributes.length > 0;
  },
  /**
   * Look up the prefix associated to the given namespace URI, starting from this node.
   * **The default namespace declarations are ignored by this method.**
   * See Namespace Prefix Lookup for details on the algorithm used by this method.
   *
   * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
   *
   * @param {string | null} namespaceURI
   * @returns {string | null}
   * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
   * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
   * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
   * @see https://github.com/xmldom/xmldom/issues/322
   */
  lookupPrefix: function lookupPrefix(namespaceURI) {
    var el = this;
    while (el) {
      var map = el._nsMap;
      //console.dir(map)
      if (map) {
        for (var n in map) {
          if (Object.prototype.hasOwnProperty.call(map, n) && map[n] === namespaceURI) {
            return n;
          }
        }
      }
      el = el.nodeType == ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
    }
    return null;
  },
  // Introduced in DOM Level 3:
  lookupNamespaceURI: function lookupNamespaceURI(prefix) {
    var el = this;
    while (el) {
      var map = el._nsMap;
      //console.dir(map)
      if (map) {
        if (Object.prototype.hasOwnProperty.call(map, prefix)) {
          return map[prefix];
        }
      }
      el = el.nodeType == ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
    }
    return null;
  },
  // Introduced in DOM Level 3:
  isDefaultNamespace: function isDefaultNamespace(namespaceURI) {
    var prefix = this.lookupPrefix(namespaceURI);
    return prefix == null;
  }
};
function _xmlEncoder(c) {
  return c == '<' && '&lt;' || c == '>' && '&gt;' || c == '&' && '&amp;' || c == '"' && '&quot;' || '&#' + c.charCodeAt() + ';';
}
copy(NodeType, Node);
copy(NodeType, Node.prototype);

/**
 * @param callback return true for continue,false for break
 * @return boolean true: break visit;
 */
function _visitNode(node, callback) {
  if (callback(node)) {
    return true;
  }
  if (node = node.firstChild) {
    do {
      if (_visitNode(node, callback)) {
        return true;
      }
    } while (node = node.nextSibling);
  }
}
function Document() {
  this.ownerDocument = this;
}
function _onAddAttribute(doc, el, newAttr) {
  doc && doc._inc++;
  var ns = newAttr.namespaceURI;
  if (ns === NAMESPACE.XMLNS) {
    //update namespace
    el._nsMap[newAttr.prefix ? newAttr.localName : ''] = newAttr.value;
  }
}
function _onRemoveAttribute(doc, el, newAttr, remove) {
  doc && doc._inc++;
  var ns = newAttr.namespaceURI;
  if (ns === NAMESPACE.XMLNS) {
    //update namespace
    delete el._nsMap[newAttr.prefix ? newAttr.localName : ''];
  }
}

/**
 * Updates `el.childNodes`, updating the indexed items and it's `length`.
 * Passing `newChild` means it will be appended.
 * Otherwise it's assumed that an item has been removed,
 * and `el.firstNode` and it's `.nextSibling` are used
 * to walk the current list of child nodes.
 *
 * @param {Document} doc
 * @param {Node} el
 * @param {Node} [newChild]
 * @private
 */
function _onUpdateChild(doc, el, newChild) {
  if (doc && doc._inc) {
    doc._inc++;
    //update childNodes
    var cs = el.childNodes;
    if (newChild) {
      cs[cs.length++] = newChild;
    } else {
      var child = el.firstChild;
      var i = 0;
      while (child) {
        cs[i++] = child;
        child = child.nextSibling;
      }
      cs.length = i;
      delete cs[cs.length];
    }
  }
}

/**
 * Removes the connections between `parentNode` and `child`
 * and any existing `child.previousSibling` or `child.nextSibling`.
 *
 * @see https://github.com/xmldom/xmldom/issues/135
 * @see https://github.com/xmldom/xmldom/issues/145
 *
 * @param {Node} parentNode
 * @param {Node} child
 * @returns {Node} the child that was removed.
 * @private
 */
function _removeChild(parentNode, child) {
  var previous = child.previousSibling;
  var next = child.nextSibling;
  if (previous) {
    previous.nextSibling = next;
  } else {
    parentNode.firstChild = next;
  }
  if (next) {
    next.previousSibling = previous;
  } else {
    parentNode.lastChild = previous;
  }
  child.parentNode = null;
  child.previousSibling = null;
  child.nextSibling = null;
  _onUpdateChild(parentNode.ownerDocument, parentNode);
  return child;
}

/**
 * Returns `true` if `node` can be a parent for insertion.
 * @param {Node} node
 * @returns {boolean}
 */
function hasValidParentNodeType(node) {
  return node && (node.nodeType === Node.DOCUMENT_NODE || node.nodeType === Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === Node.ELEMENT_NODE);
}

/**
 * Returns `true` if `node` can be inserted according to it's `nodeType`.
 * @param {Node} node
 * @returns {boolean}
 */
function hasInsertableNodeType(node) {
  return node && (isElementNode(node) || isTextNode(node) || isDocTypeNode(node) || node.nodeType === Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === Node.COMMENT_NODE || node.nodeType === Node.PROCESSING_INSTRUCTION_NODE);
}

/**
 * Returns true if `node` is a DOCTYPE node
 * @param {Node} node
 * @returns {boolean}
 */
function isDocTypeNode(node) {
  return node && node.nodeType === Node.DOCUMENT_TYPE_NODE;
}

/**
 * Returns true if the node is an element
 * @param {Node} node
 * @returns {boolean}
 */
function isElementNode(node) {
  return node && node.nodeType === Node.ELEMENT_NODE;
}
/**
 * Returns true if `node` is a text node
 * @param {Node} node
 * @returns {boolean}
 */
function isTextNode(node) {
  return node && node.nodeType === Node.TEXT_NODE;
}

/**
 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
 * according to the presence and position of a doctype node on the same level.
 *
 * @param {Document} doc The document node
 * @param {Node} child the node that would become the nextSibling if the element would be inserted
 * @returns {boolean} `true` if an element can be inserted before child
 * @private
 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */
function isElementInsertionPossible(doc, child) {
  var parentChildNodes = doc.childNodes || [];
  if (find(parentChildNodes, isElementNode) || isDocTypeNode(child)) {
    return false;
  }
  var docTypeNode = find(parentChildNodes, isDocTypeNode);
  return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}

/**
 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
 * according to the presence and position of a doctype node on the same level.
 *
 * @param {Node} doc The document node
 * @param {Node} child the node that would become the nextSibling if the element would be inserted
 * @returns {boolean} `true` if an element can be inserted before child
 * @private
 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */
function isElementReplacementPossible(doc, child) {
  var parentChildNodes = doc.childNodes || [];
  function hasElementChildThatIsNotChild(node) {
    return isElementNode(node) && node !== child;
  }
  if (find(parentChildNodes, hasElementChildThatIsNotChild)) {
    return false;
  }
  var docTypeNode = find(parentChildNodes, isDocTypeNode);
  return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}

/**
 * @private
 * Steps 1-5 of the checks before inserting and before replacing a child are the same.
 *
 * @param {Node} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node=} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */
function assertPreInsertionValidity1to5(parent, node, child) {
  // 1. If `parent` is not a Document, DocumentFragment, or Element node, then throw a "HierarchyRequestError" DOMException.
  if (!hasValidParentNodeType(parent)) {
    throw new DOMException(HIERARCHY_REQUEST_ERR, 'Unexpected parent node type ' + parent.nodeType);
  }
  // 2. If `node` is a host-including inclusive ancestor of `parent`, then throw a "HierarchyRequestError" DOMException.
  // not implemented!
  // 3. If `child` is non-null and its parent is not `parent`, then throw a "NotFoundError" DOMException.
  if (child && child.parentNode !== parent) {
    throw new DOMException(NOT_FOUND_ERR, 'child not in parent');
  }
  if (
  // 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
  !hasInsertableNodeType(node) || isDocTypeNode(node) && parent.nodeType !== Node.DOCUMENT_NODE) {
    throw new DOMException(HIERARCHY_REQUEST_ERR, 'Unexpected node type ' + node.nodeType + ' for parent node type ' + parent.nodeType);
  }
}

/**
 * @private
 * Step 6 of the checks before inserting and before replacing a child are different.
 *
 * @param {Document} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */
function assertPreInsertionValidityInDocument(parent, node, child) {
  var parentChildNodes = parent.childNodes || [];
  var nodeChildNodes = node.childNodes || [];

  // DocumentFragment
  if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
    var nodeChildElements = nodeChildNodes.filter(isElementNode);
    // If node has more than one element child or has a Text node child.
    if (nodeChildElements.length > 1 || find(nodeChildNodes, isTextNode)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, 'More than one element or text in fragment');
    }
    // Otherwise, if `node` has one element child and either `parent` has an element child,
    // `child` is a doctype, or `child` is non-null and a doctype is following `child`.
    if (nodeChildElements.length === 1 && !isElementInsertionPossible(parent, child)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, 'Element in fragment can not be inserted before doctype');
    }
  }
  // Element
  if (isElementNode(node)) {
    // `parent` has an element child, `child` is a doctype,
    // or `child` is non-null and a doctype is following `child`.
    if (!isElementInsertionPossible(parent, child)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, 'Only one element can be added and only after doctype');
    }
  }
  // DocumentType
  if (isDocTypeNode(node)) {
    // `parent` has a doctype child,
    if (find(parentChildNodes, isDocTypeNode)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, 'Only one doctype is allowed');
    }
    var parentElementChild = find(parentChildNodes, isElementNode);
    // `child` is non-null and an element is preceding `child`,
    if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, 'Doctype can only be inserted before an element');
    }
    // or `child` is null and `parent` has an element child.
    if (!child && parentElementChild) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, 'Doctype can not be appended since element is present');
    }
  }
}

/**
 * @private
 * Step 6 of the checks before inserting and before replacing a child are different.
 *
 * @param {Document} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */
function assertPreReplacementValidityInDocument(parent, node, child) {
  var parentChildNodes = parent.childNodes || [];
  var nodeChildNodes = node.childNodes || [];

  // DocumentFragment
  if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
    var nodeChildElements = nodeChildNodes.filter(isElementNode);
    // If `node` has more than one element child or has a Text node child.
    if (nodeChildElements.length > 1 || find(nodeChildNodes, isTextNode)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, 'More than one element or text in fragment');
    }
    // Otherwise, if `node` has one element child and either `parent` has an element child that is not `child` or a doctype is following `child`.
    if (nodeChildElements.length === 1 && !isElementReplacementPossible(parent, child)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, 'Element in fragment can not be inserted before doctype');
    }
  }
  // Element
  if (isElementNode(node)) {
    // `parent` has an element child that is not `child` or a doctype is following `child`.
    if (!isElementReplacementPossible(parent, child)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, 'Only one element can be added and only after doctype');
    }
  }
  // DocumentType
  if (isDocTypeNode(node)) {
    function hasDoctypeChildThatIsNotChild(node) {
      return isDocTypeNode(node) && node !== child;
    }

    // `parent` has a doctype child that is not `child`,
    if (find(parentChildNodes, hasDoctypeChildThatIsNotChild)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, 'Only one doctype is allowed');
    }
    var parentElementChild = find(parentChildNodes, isElementNode);
    // or an element is preceding `child`.
    if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, 'Doctype can only be inserted before an element');
    }
  }
}

/**
 * @private
 * @param {Node} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node=} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */
function _insertBefore(parent, node, child, _inDocumentAssertion) {
  // To ensure pre-insertion validity of a node into a parent before a child, run these steps:
  assertPreInsertionValidity1to5(parent, node, child);

  // If parent is a document, and any of the statements below, switched on the interface node implements,
  // are true, then throw a "HierarchyRequestError" DOMException.
  if (parent.nodeType === Node.DOCUMENT_NODE) {
    (_inDocumentAssertion || assertPreInsertionValidityInDocument)(parent, node, child);
  }
  var cp = node.parentNode;
  if (cp) {
    cp.removeChild(node); //remove and update
  }

  if (node.nodeType === DOCUMENT_FRAGMENT_NODE) {
    var newFirst = node.firstChild;
    if (newFirst == null) {
      return node;
    }
    var newLast = node.lastChild;
  } else {
    newFirst = newLast = node;
  }
  var pre = child ? child.previousSibling : parent.lastChild;
  newFirst.previousSibling = pre;
  newLast.nextSibling = child;
  if (pre) {
    pre.nextSibling = newFirst;
  } else {
    parent.firstChild = newFirst;
  }
  if (child == null) {
    parent.lastChild = newLast;
  } else {
    child.previousSibling = newLast;
  }
  do {
    newFirst.parentNode = parent;
  } while (newFirst !== newLast && (newFirst = newFirst.nextSibling));
  _onUpdateChild(parent.ownerDocument || parent, parent);
  //console.log(parent.lastChild.nextSibling == null)
  if (node.nodeType == DOCUMENT_FRAGMENT_NODE) {
    node.firstChild = node.lastChild = null;
  }
  return node;
}

/**
 * Appends `newChild` to `parentNode`.
 * If `newChild` is already connected to a `parentNode` it is first removed from it.
 *
 * @see https://github.com/xmldom/xmldom/issues/135
 * @see https://github.com/xmldom/xmldom/issues/145
 * @param {Node} parentNode
 * @param {Node} newChild
 * @returns {Node}
 * @private
 */
function _appendSingleChild(parentNode, newChild) {
  if (newChild.parentNode) {
    newChild.parentNode.removeChild(newChild);
  }
  newChild.parentNode = parentNode;
  newChild.previousSibling = parentNode.lastChild;
  newChild.nextSibling = null;
  if (newChild.previousSibling) {
    newChild.previousSibling.nextSibling = newChild;
  } else {
    parentNode.firstChild = newChild;
  }
  parentNode.lastChild = newChild;
  _onUpdateChild(parentNode.ownerDocument, parentNode, newChild);
  return newChild;
}
Document.prototype = {
  //implementation : null,
  nodeName: '#document',
  nodeType: DOCUMENT_NODE,
  /**
   * The DocumentType node of the document.
   *
   * @readonly
   * @type DocumentType
   */
  doctype: null,
  documentElement: null,
  _inc: 1,
  insertBefore: function insertBefore(newChild, refChild) {
    //raises
    if (newChild.nodeType == DOCUMENT_FRAGMENT_NODE) {
      var child = newChild.firstChild;
      while (child) {
        var next = child.nextSibling;
        this.insertBefore(child, refChild);
        child = next;
      }
      return newChild;
    }
    _insertBefore(this, newChild, refChild);
    newChild.ownerDocument = this;
    if (this.documentElement === null && newChild.nodeType === ELEMENT_NODE) {
      this.documentElement = newChild;
    }
    return newChild;
  },
  removeChild: function removeChild(oldChild) {
    if (this.documentElement == oldChild) {
      this.documentElement = null;
    }
    return _removeChild(this, oldChild);
  },
  replaceChild: function replaceChild(newChild, oldChild) {
    //raises
    _insertBefore(this, newChild, oldChild, assertPreReplacementValidityInDocument);
    newChild.ownerDocument = this;
    if (oldChild) {
      this.removeChild(oldChild);
    }
    if (isElementNode(newChild)) {
      this.documentElement = newChild;
    }
  },
  // Introduced in DOM Level 2:
  importNode: function importNode(importedNode, deep) {
    return _importNode(this, importedNode, deep);
  },
  // Introduced in DOM Level 2:
  getElementById: function getElementById(id) {
    var rtv = null;
    _visitNode(this.documentElement, function (node) {
      if (node.nodeType == ELEMENT_NODE) {
        if (node.getAttribute('id') == id) {
          rtv = node;
          return true;
        }
      }
    });
    return rtv;
  },
  /**
   * The `getElementsByClassName` method of `Document` interface returns an array-like object
   * of all child elements which have **all** of the given class name(s).
   *
   * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
   *
   *
   * Warning: This is a live LiveNodeList.
   * Changes in the DOM will reflect in the array as the changes occur.
   * If an element selected by this array no longer qualifies for the selector,
   * it will automatically be removed. Be aware of this for iteration purposes.
   *
   * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
   * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
   */
  getElementsByClassName: function getElementsByClassName(classNames) {
    var classNamesSet = toOrderedSet(classNames);
    return new LiveNodeList(this, function (base) {
      var ls = [];
      if (classNamesSet.length > 0) {
        _visitNode(base.documentElement, function (node) {
          if (node !== base && node.nodeType === ELEMENT_NODE) {
            var nodeClassNames = node.getAttribute('class');
            // can be null if the attribute does not exist
            if (nodeClassNames) {
              // before splitting and iterating just compare them for the most common case
              var matches = classNames === nodeClassNames;
              if (!matches) {
                var nodeClassNamesSet = toOrderedSet(nodeClassNames);
                matches = classNamesSet.every(arrayIncludes(nodeClassNamesSet));
              }
              if (matches) {
                ls.push(node);
              }
            }
          }
        });
      }
      return ls;
    });
  },
  //document factory method:
  createElement: function createElement(tagName) {
    var node = new Element();
    node.ownerDocument = this;
    node.nodeName = tagName;
    node.tagName = tagName;
    node.localName = tagName;
    node.childNodes = new NodeList();
    var attrs = node.attributes = new NamedNodeMap();
    attrs._ownerElement = node;
    return node;
  },
  createDocumentFragment: function createDocumentFragment() {
    var node = new DocumentFragment();
    node.ownerDocument = this;
    node.childNodes = new NodeList();
    return node;
  },
  createTextNode: function createTextNode(data) {
    var node = new Text();
    node.ownerDocument = this;
    node.appendData(data);
    return node;
  },
  createComment: function createComment(data) {
    var node = new Comment();
    node.ownerDocument = this;
    node.appendData(data);
    return node;
  },
  createCDATASection: function createCDATASection(data) {
    var node = new CDATASection();
    node.ownerDocument = this;
    node.appendData(data);
    return node;
  },
  createProcessingInstruction: function createProcessingInstruction(target, data) {
    var node = new ProcessingInstruction();
    node.ownerDocument = this;
    node.tagName = node.nodeName = node.target = target;
    node.nodeValue = node.data = data;
    return node;
  },
  createAttribute: function createAttribute(name) {
    var node = new Attr();
    node.ownerDocument = this;
    node.name = name;
    node.nodeName = name;
    node.localName = name;
    node.specified = true;
    return node;
  },
  createEntityReference: function createEntityReference(name) {
    var node = new EntityReference();
    node.ownerDocument = this;
    node.nodeName = name;
    return node;
  },
  // Introduced in DOM Level 2:
  createElementNS: function createElementNS(namespaceURI, qualifiedName) {
    var node = new Element();
    var pl = qualifiedName.split(':');
    var attrs = node.attributes = new NamedNodeMap();
    node.childNodes = new NodeList();
    node.ownerDocument = this;
    node.nodeName = qualifiedName;
    node.tagName = qualifiedName;
    node.namespaceURI = namespaceURI;
    if (pl.length == 2) {
      node.prefix = pl[0];
      node.localName = pl[1];
    } else {
      //el.prefix = null;
      node.localName = qualifiedName;
    }
    attrs._ownerElement = node;
    return node;
  },
  // Introduced in DOM Level 2:
  createAttributeNS: function createAttributeNS(namespaceURI, qualifiedName) {
    var node = new Attr();
    var pl = qualifiedName.split(':');
    node.ownerDocument = this;
    node.nodeName = qualifiedName;
    node.name = qualifiedName;
    node.namespaceURI = namespaceURI;
    node.specified = true;
    if (pl.length == 2) {
      node.prefix = pl[0];
      node.localName = pl[1];
    } else {
      //el.prefix = null;
      node.localName = qualifiedName;
    }
    return node;
  }
};
_extends(Document, Node);
function Element() {
  this._nsMap = {};
}
;
Element.prototype = {
  nodeType: ELEMENT_NODE,
  hasAttribute: function hasAttribute(name) {
    return this.getAttributeNode(name) != null;
  },
  getAttribute: function getAttribute(name) {
    var attr = this.getAttributeNode(name);
    return attr && attr.value || '';
  },
  getAttributeNode: function getAttributeNode(name) {
    return this.attributes.getNamedItem(name);
  },
  setAttribute: function setAttribute(name, value) {
    var attr = this.ownerDocument.createAttribute(name);
    attr.value = attr.nodeValue = "" + value;
    this.setAttributeNode(attr);
  },
  removeAttribute: function removeAttribute(name) {
    var attr = this.getAttributeNode(name);
    attr && this.removeAttributeNode(attr);
  },
  //four real opeartion method
  appendChild: function appendChild(newChild) {
    if (newChild.nodeType === DOCUMENT_FRAGMENT_NODE) {
      return this.insertBefore(newChild, null);
    } else {
      return _appendSingleChild(this, newChild);
    }
  },
  setAttributeNode: function setAttributeNode(newAttr) {
    return this.attributes.setNamedItem(newAttr);
  },
  setAttributeNodeNS: function setAttributeNodeNS(newAttr) {
    return this.attributes.setNamedItemNS(newAttr);
  },
  removeAttributeNode: function removeAttributeNode(oldAttr) {
    //console.log(this == oldAttr.ownerElement)
    return this.attributes.removeNamedItem(oldAttr.nodeName);
  },
  //get real attribute name,and remove it by removeAttributeNode
  removeAttributeNS: function removeAttributeNS(namespaceURI, localName) {
    var old = this.getAttributeNodeNS(namespaceURI, localName);
    old && this.removeAttributeNode(old);
  },
  hasAttributeNS: function hasAttributeNS(namespaceURI, localName) {
    return this.getAttributeNodeNS(namespaceURI, localName) != null;
  },
  getAttributeNS: function getAttributeNS(namespaceURI, localName) {
    var attr = this.getAttributeNodeNS(namespaceURI, localName);
    return attr && attr.value || '';
  },
  setAttributeNS: function setAttributeNS(namespaceURI, qualifiedName, value) {
    var attr = this.ownerDocument.createAttributeNS(namespaceURI, qualifiedName);
    attr.value = attr.nodeValue = "" + value;
    this.setAttributeNode(attr);
  },
  getAttributeNodeNS: function getAttributeNodeNS(namespaceURI, localName) {
    return this.attributes.getNamedItemNS(namespaceURI, localName);
  },
  getElementsByTagName: function getElementsByTagName(tagName) {
    return new LiveNodeList(this, function (base) {
      var ls = [];
      _visitNode(base, function (node) {
        if (node !== base && node.nodeType == ELEMENT_NODE && (tagName === '*' || node.tagName == tagName)) {
          ls.push(node);
        }
      });
      return ls;
    });
  },
  getElementsByTagNameNS: function getElementsByTagNameNS(namespaceURI, localName) {
    return new LiveNodeList(this, function (base) {
      var ls = [];
      _visitNode(base, function (node) {
        if (node !== base && node.nodeType === ELEMENT_NODE && (namespaceURI === '*' || node.namespaceURI === namespaceURI) && (localName === '*' || node.localName == localName)) {
          ls.push(node);
        }
      });
      return ls;
    });
  }
};
Document.prototype.getElementsByTagName = Element.prototype.getElementsByTagName;
Document.prototype.getElementsByTagNameNS = Element.prototype.getElementsByTagNameNS;
_extends(Element, Node);
function Attr() {}
;
Attr.prototype.nodeType = ATTRIBUTE_NODE;
_extends(Attr, Node);
function CharacterData() {}
;
CharacterData.prototype = {
  data: '',
  substringData: function substringData(offset, count) {
    return this.data.substring(offset, offset + count);
  },
  appendData: function appendData(text) {
    text = this.data + text;
    this.nodeValue = this.data = text;
    this.length = text.length;
  },
  insertData: function insertData(offset, text) {
    this.replaceData(offset, 0, text);
  },
  appendChild: function appendChild(newChild) {
    throw new Error(ExceptionMessage[HIERARCHY_REQUEST_ERR]);
  },
  deleteData: function deleteData(offset, count) {
    this.replaceData(offset, count, "");
  },
  replaceData: function replaceData(offset, count, text) {
    var start = this.data.substring(0, offset);
    var end = this.data.substring(offset + count);
    text = start + text + end;
    this.nodeValue = this.data = text;
    this.length = text.length;
  }
};
_extends(CharacterData, Node);
function Text() {}
;
Text.prototype = {
  nodeName: "#text",
  nodeType: TEXT_NODE,
  splitText: function splitText(offset) {
    var text = this.data;
    var newText = text.substring(offset);
    text = text.substring(0, offset);
    this.data = this.nodeValue = text;
    this.length = text.length;
    var newNode = this.ownerDocument.createTextNode(newText);
    if (this.parentNode) {
      this.parentNode.insertBefore(newNode, this.nextSibling);
    }
    return newNode;
  }
};
_extends(Text, CharacterData);
function Comment() {}
;
Comment.prototype = {
  nodeName: "#comment",
  nodeType: COMMENT_NODE
};
_extends(Comment, CharacterData);
function CDATASection() {}
;
CDATASection.prototype = {
  nodeName: "#cdata-section",
  nodeType: CDATA_SECTION_NODE
};
_extends(CDATASection, CharacterData);
function DocumentType() {}
;
DocumentType.prototype.nodeType = DOCUMENT_TYPE_NODE;
_extends(DocumentType, Node);
function Notation() {}
;
Notation.prototype.nodeType = NOTATION_NODE;
_extends(Notation, Node);
function Entity() {}
;
Entity.prototype.nodeType = ENTITY_NODE;
_extends(Entity, Node);
function EntityReference() {}
;
EntityReference.prototype.nodeType = ENTITY_REFERENCE_NODE;
_extends(EntityReference, Node);
function DocumentFragment() {}
;
DocumentFragment.prototype.nodeName = "#document-fragment";
DocumentFragment.prototype.nodeType = DOCUMENT_FRAGMENT_NODE;
_extends(DocumentFragment, Node);
function ProcessingInstruction() {}
ProcessingInstruction.prototype.nodeType = PROCESSING_INSTRUCTION_NODE;
_extends(ProcessingInstruction, Node);
function XMLSerializer() {}
XMLSerializer.prototype.serializeToString = function (node, isHtml, nodeFilter) {
  return nodeSerializeToString.call(node, isHtml, nodeFilter);
};
Node.prototype.toString = nodeSerializeToString;
function nodeSerializeToString(isHtml, nodeFilter) {
  var buf = [];
  var refNode = this.nodeType == 9 && this.documentElement || this;
  var prefix = refNode.prefix;
  var uri = refNode.namespaceURI;
  if (uri && prefix == null) {
    //console.log(prefix)
    var prefix = refNode.lookupPrefix(uri);
    if (prefix == null) {
      //isHTML = true;
      var visibleNamespaces = [{
        namespace: uri,
        prefix: null
      }
      //{namespace:uri,prefix:''}
      ];
    }
  }

  serializeToString(this, buf, isHtml, nodeFilter, visibleNamespaces);
  //console.log('###',this.nodeType,uri,prefix,buf.join(''))
  return buf.join('');
}
function needNamespaceDefine(node, isHTML, visibleNamespaces) {
  var prefix = node.prefix || '';
  var uri = node.namespaceURI;
  // According to [Namespaces in XML 1.0](https://www.w3.org/TR/REC-xml-names/#ns-using) ,
  // and more specifically https://www.w3.org/TR/REC-xml-names/#nsc-NoPrefixUndecl :
  // > In a namespace declaration for a prefix [...], the attribute value MUST NOT be empty.
  // in a similar manner [Namespaces in XML 1.1](https://www.w3.org/TR/xml-names11/#ns-using)
  // and more specifically https://www.w3.org/TR/xml-names11/#nsc-NSDeclared :
  // > [...] Furthermore, the attribute value [...] must not be an empty string.
  // so serializing empty namespace value like xmlns:ds="" would produce an invalid XML document.
  if (!uri) {
    return false;
  }
  if (prefix === "xml" && uri === NAMESPACE.XML || uri === NAMESPACE.XMLNS) {
    return false;
  }
  var i = visibleNamespaces.length;
  while (i--) {
    var ns = visibleNamespaces[i];
    // get namespace prefix
    if (ns.prefix === prefix) {
      return ns.namespace !== uri;
    }
  }
  return true;
}
/**
 * Well-formed constraint: No < in Attribute Values
 * > The replacement text of any entity referred to directly or indirectly
 * > in an attribute value must not contain a <.
 * @see https://www.w3.org/TR/xml11/#CleanAttrVals
 * @see https://www.w3.org/TR/xml11/#NT-AttValue
 *
 * Literal whitespace other than space that appear in attribute values
 * are serialized as their entity references, so they will be preserved.
 * (In contrast to whitespace literals in the input which are normalized to spaces)
 * @see https://www.w3.org/TR/xml11/#AVNormalize
 * @see https://w3c.github.io/DOM-Parsing/#serializing-an-element-s-attributes
 */
function addSerializedAttribute(buf, qualifiedName, value) {
  buf.push(' ', qualifiedName, '="', value.replace(/[<>&"\t\n\r]/g, _xmlEncoder), '"');
}
function serializeToString(node, buf, isHTML, nodeFilter, visibleNamespaces) {
  if (!visibleNamespaces) {
    visibleNamespaces = [];
  }
  if (nodeFilter) {
    node = nodeFilter(node);
    if (node) {
      if (typeof node == 'string') {
        buf.push(node);
        return;
      }
    } else {
      return;
    }
    //buf.sort.apply(attrs, attributeSorter);
  }

  switch (node.nodeType) {
    case ELEMENT_NODE:
      var attrs = node.attributes;
      var len = attrs.length;
      var child = node.firstChild;
      var nodeName = node.tagName;
      isHTML = NAMESPACE.isHTML(node.namespaceURI) || isHTML;
      var prefixedNodeName = nodeName;
      if (!isHTML && !node.prefix && node.namespaceURI) {
        var defaultNS;
        // lookup current default ns from `xmlns` attribute
        for (var ai = 0; ai < attrs.length; ai++) {
          if (attrs.item(ai).name === 'xmlns') {
            defaultNS = attrs.item(ai).value;
            break;
          }
        }
        if (!defaultNS) {
          // lookup current default ns in visibleNamespaces
          for (var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--) {
            var namespace = visibleNamespaces[nsi];
            if (namespace.prefix === '' && namespace.namespace === node.namespaceURI) {
              defaultNS = namespace.namespace;
              break;
            }
          }
        }
        if (defaultNS !== node.namespaceURI) {
          for (var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--) {
            var namespace = visibleNamespaces[nsi];
            if (namespace.namespace === node.namespaceURI) {
              if (namespace.prefix) {
                prefixedNodeName = namespace.prefix + ':' + nodeName;
              }
              break;
            }
          }
        }
      }
      buf.push('<', prefixedNodeName);
      for (var i = 0; i < len; i++) {
        // add namespaces for attributes
        var attr = attrs.item(i);
        if (attr.prefix == 'xmlns') {
          visibleNamespaces.push({
            prefix: attr.localName,
            namespace: attr.value
          });
        } else if (attr.nodeName == 'xmlns') {
          visibleNamespaces.push({
            prefix: '',
            namespace: attr.value
          });
        }
      }
      for (var i = 0; i < len; i++) {
        var attr = attrs.item(i);
        if (needNamespaceDefine(attr, isHTML, visibleNamespaces)) {
          var prefix = attr.prefix || '';
          var uri = attr.namespaceURI;
          addSerializedAttribute(buf, prefix ? 'xmlns:' + prefix : "xmlns", uri);
          visibleNamespaces.push({
            prefix: prefix,
            namespace: uri
          });
        }
        serializeToString(attr, buf, isHTML, nodeFilter, visibleNamespaces);
      }

      // add namespace for current node
      if (nodeName === prefixedNodeName && needNamespaceDefine(node, isHTML, visibleNamespaces)) {
        var prefix = node.prefix || '';
        var uri = node.namespaceURI;
        addSerializedAttribute(buf, prefix ? 'xmlns:' + prefix : "xmlns", uri);
        visibleNamespaces.push({
          prefix: prefix,
          namespace: uri
        });
      }
      if (child || isHTML && !/^(?:meta|link|img|br|hr|input)$/i.test(nodeName)) {
        buf.push('>');
        //if is cdata child node
        if (isHTML && /^script$/i.test(nodeName)) {
          while (child) {
            if (child.data) {
              buf.push(child.data);
            } else {
              serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
            }
            child = child.nextSibling;
          }
        } else {
          while (child) {
            serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
            child = child.nextSibling;
          }
        }
        buf.push('</', prefixedNodeName, '>');
      } else {
        buf.push('/>');
      }
      // remove added visible namespaces
      //visibleNamespaces.length = startVisibleNamespaces;
      return;
    case DOCUMENT_NODE:
    case DOCUMENT_FRAGMENT_NODE:
      var child = node.firstChild;
      while (child) {
        serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
        child = child.nextSibling;
      }
      return;
    case ATTRIBUTE_NODE:
      return addSerializedAttribute(buf, node.name, node.value);
    case TEXT_NODE:
      /**
       * The ampersand character (&) and the left angle bracket (<) must not appear in their literal form,
       * except when used as markup delimiters, or within a comment, a processing instruction, or a CDATA section.
       * If they are needed elsewhere, they must be escaped using either numeric character references or the strings
       * `&amp;` and `&lt;` respectively.
       * The right angle bracket (>) may be represented using the string " &gt; ", and must, for compatibility,
       * be escaped using either `&gt;` or a character reference when it appears in the string `]]>` in content,
       * when that string is not marking the end of a CDATA section.
       *
       * In the content of elements, character data is any string of characters
       * which does not contain the start-delimiter of any markup
       * and does not include the CDATA-section-close delimiter, `]]>`.
       *
       * @see https://www.w3.org/TR/xml/#NT-CharData
       * @see https://w3c.github.io/DOM-Parsing/#xml-serializing-a-text-node
       */
      return buf.push(node.data.replace(/[<&>]/g, _xmlEncoder));
    case CDATA_SECTION_NODE:
      return buf.push('<![CDATA[', node.data, ']]>');
    case COMMENT_NODE:
      return buf.push("<!--", node.data, "-->");
    case DOCUMENT_TYPE_NODE:
      var pubid = node.publicId;
      var sysid = node.systemId;
      buf.push('<!DOCTYPE ', node.name);
      if (pubid) {
        buf.push(' PUBLIC ', pubid);
        if (sysid && sysid != '.') {
          buf.push(' ', sysid);
        }
        buf.push('>');
      } else if (sysid && sysid != '.') {
        buf.push(' SYSTEM ', sysid, '>');
      } else {
        var sub = node.internalSubset;
        if (sub) {
          buf.push(" [", sub, "]");
        }
        buf.push(">");
      }
      return;
    case PROCESSING_INSTRUCTION_NODE:
      return buf.push("<?", node.target, " ", node.data, "?>");
    case ENTITY_REFERENCE_NODE:
      return buf.push('&', node.nodeName, ';');
    //case ENTITY_NODE:
    //case NOTATION_NODE:
    default:
      buf.push('??', node.nodeName);
  }
}
function _importNode(doc, node, deep) {
  var node2;
  switch (node.nodeType) {
    case ELEMENT_NODE:
      node2 = node.cloneNode(false);
      node2.ownerDocument = doc;
    //var attrs = node2.attributes;
    //var len = attrs.length;
    //for(var i=0;i<len;i++){
    //node2.setAttributeNodeNS(importNode(doc,attrs.item(i),deep));
    //}
    case DOCUMENT_FRAGMENT_NODE:
      break;
    case ATTRIBUTE_NODE:
      deep = true;
      break;
    //case ENTITY_REFERENCE_NODE:
    //case PROCESSING_INSTRUCTION_NODE:
    ////case TEXT_NODE:
    //case CDATA_SECTION_NODE:
    //case COMMENT_NODE:
    //	deep = false;
    //	break;
    //case DOCUMENT_NODE:
    //case DOCUMENT_TYPE_NODE:
    //cannot be imported.
    //case ENTITY_NODE:
    //case NOTATION_NODE：
    //can not hit in level3
    //default:throw e;
  }

  if (!node2) {
    node2 = node.cloneNode(false); //false
  }

  node2.ownerDocument = doc;
  node2.parentNode = null;
  if (deep) {
    var child = node.firstChild;
    while (child) {
      node2.appendChild(_importNode(doc, child, deep));
      child = child.nextSibling;
    }
  }
  return node2;
}
//
//var _relationMap = {firstChild:1,lastChild:1,previousSibling:1,nextSibling:1,
//					attributes:1,childNodes:1,parentNode:1,documentElement:1,doctype,};
function _cloneNode(doc, node, deep) {
  var node2 = new node.constructor();
  for (var n in node) {
    if (Object.prototype.hasOwnProperty.call(node, n)) {
      var v = node[n];
      if (_typeof(v) != "object") {
        if (v != node2[n]) {
          node2[n] = v;
        }
      }
    }
  }
  if (node.childNodes) {
    node2.childNodes = new NodeList();
  }
  node2.ownerDocument = doc;
  switch (node2.nodeType) {
    case ELEMENT_NODE:
      var attrs = node.attributes;
      var attrs2 = node2.attributes = new NamedNodeMap();
      var len = attrs.length;
      attrs2._ownerElement = node2;
      for (var i = 0; i < len; i++) {
        node2.setAttributeNode(_cloneNode(doc, attrs.item(i), true));
      }
      break;
      ;
    case ATTRIBUTE_NODE:
      deep = true;
  }
  if (deep) {
    var child = node.firstChild;
    while (child) {
      node2.appendChild(_cloneNode(doc, child, deep));
      child = child.nextSibling;
    }
  }
  return node2;
}
function __set__(object, key, value) {
  object[key] = value;
}
//do dynamic
try {
  if (Object.defineProperty) {
    Object.defineProperty(LiveNodeList.prototype, 'length', {
      get: function get() {
        _updateLiveList(this);
        return this.$$length;
      }
    });
    Object.defineProperty(Node.prototype, 'textContent', {
      get: function get() {
        return getTextContent(this);
      },
      set: function set(data) {
        switch (this.nodeType) {
          case ELEMENT_NODE:
          case DOCUMENT_FRAGMENT_NODE:
            while (this.firstChild) {
              this.removeChild(this.firstChild);
            }
            if (data || String(data)) {
              this.appendChild(this.ownerDocument.createTextNode(data));
            }
            break;
          default:
            this.data = data;
            this.value = data;
            this.nodeValue = data;
        }
      }
    });
    function getTextContent(node) {
      switch (node.nodeType) {
        case ELEMENT_NODE:
        case DOCUMENT_FRAGMENT_NODE:
          var buf = [];
          node = node.firstChild;
          while (node) {
            if (node.nodeType !== 7 && node.nodeType !== 8) {
              buf.push(getTextContent(node));
            }
            node = node.nextSibling;
          }
          return buf.join('');
        default:
          return node.nodeValue;
      }
    }
    __set__ = function __set__(object, key, value) {
      //console.log(value)
      object['$$' + key] = value;
    };
  }
} catch (e) {//ie8
}

//if(typeof require == 'function'){
exports.DocumentType = DocumentType;
exports.DOMException = DOMException;
exports.DOMImplementation = DOMImplementation;
exports.Element = Element;
exports.Node = Node;
exports.NodeList = NodeList;
exports.XMLSerializer = XMLSerializer;
//}

/***/ }),

/***/ 85653:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var freeze = __webpack_require__(62697).freeze;

/**
 * The entities that are predefined in every XML document.
 *
 * @see https://www.w3.org/TR/2006/REC-xml11-20060816/#sec-predefined-ent W3C XML 1.1
 * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-predefined-ent W3C XML 1.0
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Predefined_entities_in_XML Wikipedia
 */
exports.XML_ENTITIES = freeze({
  amp: '&',
  apos: "'",
  gt: '>',
  lt: '<',
  quot: '"'
});

/**
 * A map of all entities that are detected in an HTML document.
 * They contain all entries from `XML_ENTITIES`.
 *
 * @see XML_ENTITIES
 * @see DOMParser.parseFromString
 * @see DOMImplementation.prototype.createHTMLDocument
 * @see https://html.spec.whatwg.org/#named-character-references WHATWG HTML(5) Spec
 * @see https://html.spec.whatwg.org/entities.json JSON
 * @see https://www.w3.org/TR/xml-entity-names/ W3C XML Entity Names
 * @see https://www.w3.org/TR/html4/sgml/entities.html W3C HTML4/SGML
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Character_entity_references_in_HTML Wikipedia (HTML)
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Entities_representing_special_characters_in_XHTML Wikpedia (XHTML)
 */
exports.HTML_ENTITIES = freeze({
  Aacute: "\xC1",
  aacute: "\xE1",
  Abreve: "\u0102",
  abreve: "\u0103",
  ac: "\u223E",
  acd: "\u223F",
  acE: "\u223E\u0333",
  Acirc: "\xC2",
  acirc: "\xE2",
  acute: "\xB4",
  Acy: "\u0410",
  acy: "\u0430",
  AElig: "\xC6",
  aelig: "\xE6",
  af: "\u2061",
  Afr: "\uD835\uDD04",
  afr: "\uD835\uDD1E",
  Agrave: "\xC0",
  agrave: "\xE0",
  alefsym: "\u2135",
  aleph: "\u2135",
  Alpha: "\u0391",
  alpha: "\u03B1",
  Amacr: "\u0100",
  amacr: "\u0101",
  amalg: "\u2A3F",
  AMP: "&",
  amp: "&",
  And: "\u2A53",
  and: "\u2227",
  andand: "\u2A55",
  andd: "\u2A5C",
  andslope: "\u2A58",
  andv: "\u2A5A",
  ang: "\u2220",
  ange: "\u29A4",
  angle: "\u2220",
  angmsd: "\u2221",
  angmsdaa: "\u29A8",
  angmsdab: "\u29A9",
  angmsdac: "\u29AA",
  angmsdad: "\u29AB",
  angmsdae: "\u29AC",
  angmsdaf: "\u29AD",
  angmsdag: "\u29AE",
  angmsdah: "\u29AF",
  angrt: "\u221F",
  angrtvb: "\u22BE",
  angrtvbd: "\u299D",
  angsph: "\u2222",
  angst: "\xC5",
  angzarr: "\u237C",
  Aogon: "\u0104",
  aogon: "\u0105",
  Aopf: "\uD835\uDD38",
  aopf: "\uD835\uDD52",
  ap: "\u2248",
  apacir: "\u2A6F",
  apE: "\u2A70",
  ape: "\u224A",
  apid: "\u224B",
  apos: "'",
  ApplyFunction: "\u2061",
  approx: "\u2248",
  approxeq: "\u224A",
  Aring: "\xC5",
  aring: "\xE5",
  Ascr: "\uD835\uDC9C",
  ascr: "\uD835\uDCB6",
  Assign: "\u2254",
  ast: "*",
  asymp: "\u2248",
  asympeq: "\u224D",
  Atilde: "\xC3",
  atilde: "\xE3",
  Auml: "\xC4",
  auml: "\xE4",
  awconint: "\u2233",
  awint: "\u2A11",
  backcong: "\u224C",
  backepsilon: "\u03F6",
  backprime: "\u2035",
  backsim: "\u223D",
  backsimeq: "\u22CD",
  Backslash: "\u2216",
  Barv: "\u2AE7",
  barvee: "\u22BD",
  Barwed: "\u2306",
  barwed: "\u2305",
  barwedge: "\u2305",
  bbrk: "\u23B5",
  bbrktbrk: "\u23B6",
  bcong: "\u224C",
  Bcy: "\u0411",
  bcy: "\u0431",
  bdquo: "\u201E",
  becaus: "\u2235",
  Because: "\u2235",
  because: "\u2235",
  bemptyv: "\u29B0",
  bepsi: "\u03F6",
  bernou: "\u212C",
  Bernoullis: "\u212C",
  Beta: "\u0392",
  beta: "\u03B2",
  beth: "\u2136",
  between: "\u226C",
  Bfr: "\uD835\uDD05",
  bfr: "\uD835\uDD1F",
  bigcap: "\u22C2",
  bigcirc: "\u25EF",
  bigcup: "\u22C3",
  bigodot: "\u2A00",
  bigoplus: "\u2A01",
  bigotimes: "\u2A02",
  bigsqcup: "\u2A06",
  bigstar: "\u2605",
  bigtriangledown: "\u25BD",
  bigtriangleup: "\u25B3",
  biguplus: "\u2A04",
  bigvee: "\u22C1",
  bigwedge: "\u22C0",
  bkarow: "\u290D",
  blacklozenge: "\u29EB",
  blacksquare: "\u25AA",
  blacktriangle: "\u25B4",
  blacktriangledown: "\u25BE",
  blacktriangleleft: "\u25C2",
  blacktriangleright: "\u25B8",
  blank: "\u2423",
  blk12: "\u2592",
  blk14: "\u2591",
  blk34: "\u2593",
  block: "\u2588",
  bne: "=\u20E5",
  bnequiv: "\u2261\u20E5",
  bNot: "\u2AED",
  bnot: "\u2310",
  Bopf: "\uD835\uDD39",
  bopf: "\uD835\uDD53",
  bot: "\u22A5",
  bottom: "\u22A5",
  bowtie: "\u22C8",
  boxbox: "\u29C9",
  boxDL: "\u2557",
  boxDl: "\u2556",
  boxdL: "\u2555",
  boxdl: "\u2510",
  boxDR: "\u2554",
  boxDr: "\u2553",
  boxdR: "\u2552",
  boxdr: "\u250C",
  boxH: "\u2550",
  boxh: "\u2500",
  boxHD: "\u2566",
  boxHd: "\u2564",
  boxhD: "\u2565",
  boxhd: "\u252C",
  boxHU: "\u2569",
  boxHu: "\u2567",
  boxhU: "\u2568",
  boxhu: "\u2534",
  boxminus: "\u229F",
  boxplus: "\u229E",
  boxtimes: "\u22A0",
  boxUL: "\u255D",
  boxUl: "\u255C",
  boxuL: "\u255B",
  boxul: "\u2518",
  boxUR: "\u255A",
  boxUr: "\u2559",
  boxuR: "\u2558",
  boxur: "\u2514",
  boxV: "\u2551",
  boxv: "\u2502",
  boxVH: "\u256C",
  boxVh: "\u256B",
  boxvH: "\u256A",
  boxvh: "\u253C",
  boxVL: "\u2563",
  boxVl: "\u2562",
  boxvL: "\u2561",
  boxvl: "\u2524",
  boxVR: "\u2560",
  boxVr: "\u255F",
  boxvR: "\u255E",
  boxvr: "\u251C",
  bprime: "\u2035",
  Breve: "\u02D8",
  breve: "\u02D8",
  brvbar: "\xA6",
  Bscr: "\u212C",
  bscr: "\uD835\uDCB7",
  bsemi: "\u204F",
  bsim: "\u223D",
  bsime: "\u22CD",
  bsol: "\\",
  bsolb: "\u29C5",
  bsolhsub: "\u27C8",
  bull: "\u2022",
  bullet: "\u2022",
  bump: "\u224E",
  bumpE: "\u2AAE",
  bumpe: "\u224F",
  Bumpeq: "\u224E",
  bumpeq: "\u224F",
  Cacute: "\u0106",
  cacute: "\u0107",
  Cap: "\u22D2",
  cap: "\u2229",
  capand: "\u2A44",
  capbrcup: "\u2A49",
  capcap: "\u2A4B",
  capcup: "\u2A47",
  capdot: "\u2A40",
  CapitalDifferentialD: "\u2145",
  caps: "\u2229\uFE00",
  caret: "\u2041",
  caron: "\u02C7",
  Cayleys: "\u212D",
  ccaps: "\u2A4D",
  Ccaron: "\u010C",
  ccaron: "\u010D",
  Ccedil: "\xC7",
  ccedil: "\xE7",
  Ccirc: "\u0108",
  ccirc: "\u0109",
  Cconint: "\u2230",
  ccups: "\u2A4C",
  ccupssm: "\u2A50",
  Cdot: "\u010A",
  cdot: "\u010B",
  cedil: "\xB8",
  Cedilla: "\xB8",
  cemptyv: "\u29B2",
  cent: "\xA2",
  CenterDot: "\xB7",
  centerdot: "\xB7",
  Cfr: "\u212D",
  cfr: "\uD835\uDD20",
  CHcy: "\u0427",
  chcy: "\u0447",
  check: "\u2713",
  checkmark: "\u2713",
  Chi: "\u03A7",
  chi: "\u03C7",
  cir: "\u25CB",
  circ: "\u02C6",
  circeq: "\u2257",
  circlearrowleft: "\u21BA",
  circlearrowright: "\u21BB",
  circledast: "\u229B",
  circledcirc: "\u229A",
  circleddash: "\u229D",
  CircleDot: "\u2299",
  circledR: "\xAE",
  circledS: "\u24C8",
  CircleMinus: "\u2296",
  CirclePlus: "\u2295",
  CircleTimes: "\u2297",
  cirE: "\u29C3",
  cire: "\u2257",
  cirfnint: "\u2A10",
  cirmid: "\u2AEF",
  cirscir: "\u29C2",
  ClockwiseContourIntegral: "\u2232",
  CloseCurlyDoubleQuote: "\u201D",
  CloseCurlyQuote: "\u2019",
  clubs: "\u2663",
  clubsuit: "\u2663",
  Colon: "\u2237",
  colon: ":",
  Colone: "\u2A74",
  colone: "\u2254",
  coloneq: "\u2254",
  comma: ",",
  commat: "@",
  comp: "\u2201",
  compfn: "\u2218",
  complement: "\u2201",
  complexes: "\u2102",
  cong: "\u2245",
  congdot: "\u2A6D",
  Congruent: "\u2261",
  Conint: "\u222F",
  conint: "\u222E",
  ContourIntegral: "\u222E",
  Copf: "\u2102",
  copf: "\uD835\uDD54",
  coprod: "\u2210",
  Coproduct: "\u2210",
  COPY: "\xA9",
  copy: "\xA9",
  copysr: "\u2117",
  CounterClockwiseContourIntegral: "\u2233",
  crarr: "\u21B5",
  Cross: "\u2A2F",
  cross: "\u2717",
  Cscr: "\uD835\uDC9E",
  cscr: "\uD835\uDCB8",
  csub: "\u2ACF",
  csube: "\u2AD1",
  csup: "\u2AD0",
  csupe: "\u2AD2",
  ctdot: "\u22EF",
  cudarrl: "\u2938",
  cudarrr: "\u2935",
  cuepr: "\u22DE",
  cuesc: "\u22DF",
  cularr: "\u21B6",
  cularrp: "\u293D",
  Cup: "\u22D3",
  cup: "\u222A",
  cupbrcap: "\u2A48",
  CupCap: "\u224D",
  cupcap: "\u2A46",
  cupcup: "\u2A4A",
  cupdot: "\u228D",
  cupor: "\u2A45",
  cups: "\u222A\uFE00",
  curarr: "\u21B7",
  curarrm: "\u293C",
  curlyeqprec: "\u22DE",
  curlyeqsucc: "\u22DF",
  curlyvee: "\u22CE",
  curlywedge: "\u22CF",
  curren: "\xA4",
  curvearrowleft: "\u21B6",
  curvearrowright: "\u21B7",
  cuvee: "\u22CE",
  cuwed: "\u22CF",
  cwconint: "\u2232",
  cwint: "\u2231",
  cylcty: "\u232D",
  Dagger: "\u2021",
  dagger: "\u2020",
  daleth: "\u2138",
  Darr: "\u21A1",
  dArr: "\u21D3",
  darr: "\u2193",
  dash: "\u2010",
  Dashv: "\u2AE4",
  dashv: "\u22A3",
  dbkarow: "\u290F",
  dblac: "\u02DD",
  Dcaron: "\u010E",
  dcaron: "\u010F",
  Dcy: "\u0414",
  dcy: "\u0434",
  DD: "\u2145",
  dd: "\u2146",
  ddagger: "\u2021",
  ddarr: "\u21CA",
  DDotrahd: "\u2911",
  ddotseq: "\u2A77",
  deg: "\xB0",
  Del: "\u2207",
  Delta: "\u0394",
  delta: "\u03B4",
  demptyv: "\u29B1",
  dfisht: "\u297F",
  Dfr: "\uD835\uDD07",
  dfr: "\uD835\uDD21",
  dHar: "\u2965",
  dharl: "\u21C3",
  dharr: "\u21C2",
  DiacriticalAcute: "\xB4",
  DiacriticalDot: "\u02D9",
  DiacriticalDoubleAcute: "\u02DD",
  DiacriticalGrave: "`",
  DiacriticalTilde: "\u02DC",
  diam: "\u22C4",
  Diamond: "\u22C4",
  diamond: "\u22C4",
  diamondsuit: "\u2666",
  diams: "\u2666",
  die: "\xA8",
  DifferentialD: "\u2146",
  digamma: "\u03DD",
  disin: "\u22F2",
  div: "\xF7",
  divide: "\xF7",
  divideontimes: "\u22C7",
  divonx: "\u22C7",
  DJcy: "\u0402",
  djcy: "\u0452",
  dlcorn: "\u231E",
  dlcrop: "\u230D",
  dollar: "$",
  Dopf: "\uD835\uDD3B",
  dopf: "\uD835\uDD55",
  Dot: "\xA8",
  dot: "\u02D9",
  DotDot: "\u20DC",
  doteq: "\u2250",
  doteqdot: "\u2251",
  DotEqual: "\u2250",
  dotminus: "\u2238",
  dotplus: "\u2214",
  dotsquare: "\u22A1",
  doublebarwedge: "\u2306",
  DoubleContourIntegral: "\u222F",
  DoubleDot: "\xA8",
  DoubleDownArrow: "\u21D3",
  DoubleLeftArrow: "\u21D0",
  DoubleLeftRightArrow: "\u21D4",
  DoubleLeftTee: "\u2AE4",
  DoubleLongLeftArrow: "\u27F8",
  DoubleLongLeftRightArrow: "\u27FA",
  DoubleLongRightArrow: "\u27F9",
  DoubleRightArrow: "\u21D2",
  DoubleRightTee: "\u22A8",
  DoubleUpArrow: "\u21D1",
  DoubleUpDownArrow: "\u21D5",
  DoubleVerticalBar: "\u2225",
  DownArrow: "\u2193",
  Downarrow: "\u21D3",
  downarrow: "\u2193",
  DownArrowBar: "\u2913",
  DownArrowUpArrow: "\u21F5",
  DownBreve: "\u0311",
  downdownarrows: "\u21CA",
  downharpoonleft: "\u21C3",
  downharpoonright: "\u21C2",
  DownLeftRightVector: "\u2950",
  DownLeftTeeVector: "\u295E",
  DownLeftVector: "\u21BD",
  DownLeftVectorBar: "\u2956",
  DownRightTeeVector: "\u295F",
  DownRightVector: "\u21C1",
  DownRightVectorBar: "\u2957",
  DownTee: "\u22A4",
  DownTeeArrow: "\u21A7",
  drbkarow: "\u2910",
  drcorn: "\u231F",
  drcrop: "\u230C",
  Dscr: "\uD835\uDC9F",
  dscr: "\uD835\uDCB9",
  DScy: "\u0405",
  dscy: "\u0455",
  dsol: "\u29F6",
  Dstrok: "\u0110",
  dstrok: "\u0111",
  dtdot: "\u22F1",
  dtri: "\u25BF",
  dtrif: "\u25BE",
  duarr: "\u21F5",
  duhar: "\u296F",
  dwangle: "\u29A6",
  DZcy: "\u040F",
  dzcy: "\u045F",
  dzigrarr: "\u27FF",
  Eacute: "\xC9",
  eacute: "\xE9",
  easter: "\u2A6E",
  Ecaron: "\u011A",
  ecaron: "\u011B",
  ecir: "\u2256",
  Ecirc: "\xCA",
  ecirc: "\xEA",
  ecolon: "\u2255",
  Ecy: "\u042D",
  ecy: "\u044D",
  eDDot: "\u2A77",
  Edot: "\u0116",
  eDot: "\u2251",
  edot: "\u0117",
  ee: "\u2147",
  efDot: "\u2252",
  Efr: "\uD835\uDD08",
  efr: "\uD835\uDD22",
  eg: "\u2A9A",
  Egrave: "\xC8",
  egrave: "\xE8",
  egs: "\u2A96",
  egsdot: "\u2A98",
  el: "\u2A99",
  Element: "\u2208",
  elinters: "\u23E7",
  ell: "\u2113",
  els: "\u2A95",
  elsdot: "\u2A97",
  Emacr: "\u0112",
  emacr: "\u0113",
  empty: "\u2205",
  emptyset: "\u2205",
  EmptySmallSquare: "\u25FB",
  emptyv: "\u2205",
  EmptyVerySmallSquare: "\u25AB",
  emsp: "\u2003",
  emsp13: "\u2004",
  emsp14: "\u2005",
  ENG: "\u014A",
  eng: "\u014B",
  ensp: "\u2002",
  Eogon: "\u0118",
  eogon: "\u0119",
  Eopf: "\uD835\uDD3C",
  eopf: "\uD835\uDD56",
  epar: "\u22D5",
  eparsl: "\u29E3",
  eplus: "\u2A71",
  epsi: "\u03B5",
  Epsilon: "\u0395",
  epsilon: "\u03B5",
  epsiv: "\u03F5",
  eqcirc: "\u2256",
  eqcolon: "\u2255",
  eqsim: "\u2242",
  eqslantgtr: "\u2A96",
  eqslantless: "\u2A95",
  Equal: "\u2A75",
  equals: "=",
  EqualTilde: "\u2242",
  equest: "\u225F",
  Equilibrium: "\u21CC",
  equiv: "\u2261",
  equivDD: "\u2A78",
  eqvparsl: "\u29E5",
  erarr: "\u2971",
  erDot: "\u2253",
  Escr: "\u2130",
  escr: "\u212F",
  esdot: "\u2250",
  Esim: "\u2A73",
  esim: "\u2242",
  Eta: "\u0397",
  eta: "\u03B7",
  ETH: "\xD0",
  eth: "\xF0",
  Euml: "\xCB",
  euml: "\xEB",
  euro: "\u20AC",
  excl: "!",
  exist: "\u2203",
  Exists: "\u2203",
  expectation: "\u2130",
  ExponentialE: "\u2147",
  exponentiale: "\u2147",
  fallingdotseq: "\u2252",
  Fcy: "\u0424",
  fcy: "\u0444",
  female: "\u2640",
  ffilig: "\uFB03",
  fflig: "\uFB00",
  ffllig: "\uFB04",
  Ffr: "\uD835\uDD09",
  ffr: "\uD835\uDD23",
  filig: "\uFB01",
  FilledSmallSquare: "\u25FC",
  FilledVerySmallSquare: "\u25AA",
  fjlig: "fj",
  flat: "\u266D",
  fllig: "\uFB02",
  fltns: "\u25B1",
  fnof: "\u0192",
  Fopf: "\uD835\uDD3D",
  fopf: "\uD835\uDD57",
  ForAll: "\u2200",
  forall: "\u2200",
  fork: "\u22D4",
  forkv: "\u2AD9",
  Fouriertrf: "\u2131",
  fpartint: "\u2A0D",
  frac12: "\xBD",
  frac13: "\u2153",
  frac14: "\xBC",
  frac15: "\u2155",
  frac16: "\u2159",
  frac18: "\u215B",
  frac23: "\u2154",
  frac25: "\u2156",
  frac34: "\xBE",
  frac35: "\u2157",
  frac38: "\u215C",
  frac45: "\u2158",
  frac56: "\u215A",
  frac58: "\u215D",
  frac78: "\u215E",
  frasl: "\u2044",
  frown: "\u2322",
  Fscr: "\u2131",
  fscr: "\uD835\uDCBB",
  gacute: "\u01F5",
  Gamma: "\u0393",
  gamma: "\u03B3",
  Gammad: "\u03DC",
  gammad: "\u03DD",
  gap: "\u2A86",
  Gbreve: "\u011E",
  gbreve: "\u011F",
  Gcedil: "\u0122",
  Gcirc: "\u011C",
  gcirc: "\u011D",
  Gcy: "\u0413",
  gcy: "\u0433",
  Gdot: "\u0120",
  gdot: "\u0121",
  gE: "\u2267",
  ge: "\u2265",
  gEl: "\u2A8C",
  gel: "\u22DB",
  geq: "\u2265",
  geqq: "\u2267",
  geqslant: "\u2A7E",
  ges: "\u2A7E",
  gescc: "\u2AA9",
  gesdot: "\u2A80",
  gesdoto: "\u2A82",
  gesdotol: "\u2A84",
  gesl: "\u22DB\uFE00",
  gesles: "\u2A94",
  Gfr: "\uD835\uDD0A",
  gfr: "\uD835\uDD24",
  Gg: "\u22D9",
  gg: "\u226B",
  ggg: "\u22D9",
  gimel: "\u2137",
  GJcy: "\u0403",
  gjcy: "\u0453",
  gl: "\u2277",
  gla: "\u2AA5",
  glE: "\u2A92",
  glj: "\u2AA4",
  gnap: "\u2A8A",
  gnapprox: "\u2A8A",
  gnE: "\u2269",
  gne: "\u2A88",
  gneq: "\u2A88",
  gneqq: "\u2269",
  gnsim: "\u22E7",
  Gopf: "\uD835\uDD3E",
  gopf: "\uD835\uDD58",
  grave: "`",
  GreaterEqual: "\u2265",
  GreaterEqualLess: "\u22DB",
  GreaterFullEqual: "\u2267",
  GreaterGreater: "\u2AA2",
  GreaterLess: "\u2277",
  GreaterSlantEqual: "\u2A7E",
  GreaterTilde: "\u2273",
  Gscr: "\uD835\uDCA2",
  gscr: "\u210A",
  gsim: "\u2273",
  gsime: "\u2A8E",
  gsiml: "\u2A90",
  Gt: "\u226B",
  GT: ">",
  gt: ">",
  gtcc: "\u2AA7",
  gtcir: "\u2A7A",
  gtdot: "\u22D7",
  gtlPar: "\u2995",
  gtquest: "\u2A7C",
  gtrapprox: "\u2A86",
  gtrarr: "\u2978",
  gtrdot: "\u22D7",
  gtreqless: "\u22DB",
  gtreqqless: "\u2A8C",
  gtrless: "\u2277",
  gtrsim: "\u2273",
  gvertneqq: "\u2269\uFE00",
  gvnE: "\u2269\uFE00",
  Hacek: "\u02C7",
  hairsp: "\u200A",
  half: "\xBD",
  hamilt: "\u210B",
  HARDcy: "\u042A",
  hardcy: "\u044A",
  hArr: "\u21D4",
  harr: "\u2194",
  harrcir: "\u2948",
  harrw: "\u21AD",
  Hat: "^",
  hbar: "\u210F",
  Hcirc: "\u0124",
  hcirc: "\u0125",
  hearts: "\u2665",
  heartsuit: "\u2665",
  hellip: "\u2026",
  hercon: "\u22B9",
  Hfr: "\u210C",
  hfr: "\uD835\uDD25",
  HilbertSpace: "\u210B",
  hksearow: "\u2925",
  hkswarow: "\u2926",
  hoarr: "\u21FF",
  homtht: "\u223B",
  hookleftarrow: "\u21A9",
  hookrightarrow: "\u21AA",
  Hopf: "\u210D",
  hopf: "\uD835\uDD59",
  horbar: "\u2015",
  HorizontalLine: "\u2500",
  Hscr: "\u210B",
  hscr: "\uD835\uDCBD",
  hslash: "\u210F",
  Hstrok: "\u0126",
  hstrok: "\u0127",
  HumpDownHump: "\u224E",
  HumpEqual: "\u224F",
  hybull: "\u2043",
  hyphen: "\u2010",
  Iacute: "\xCD",
  iacute: "\xED",
  ic: "\u2063",
  Icirc: "\xCE",
  icirc: "\xEE",
  Icy: "\u0418",
  icy: "\u0438",
  Idot: "\u0130",
  IEcy: "\u0415",
  iecy: "\u0435",
  iexcl: "\xA1",
  iff: "\u21D4",
  Ifr: "\u2111",
  ifr: "\uD835\uDD26",
  Igrave: "\xCC",
  igrave: "\xEC",
  ii: "\u2148",
  iiiint: "\u2A0C",
  iiint: "\u222D",
  iinfin: "\u29DC",
  iiota: "\u2129",
  IJlig: "\u0132",
  ijlig: "\u0133",
  Im: "\u2111",
  Imacr: "\u012A",
  imacr: "\u012B",
  image: "\u2111",
  ImaginaryI: "\u2148",
  imagline: "\u2110",
  imagpart: "\u2111",
  imath: "\u0131",
  imof: "\u22B7",
  imped: "\u01B5",
  Implies: "\u21D2",
  in: "\u2208",
  incare: "\u2105",
  infin: "\u221E",
  infintie: "\u29DD",
  inodot: "\u0131",
  Int: "\u222C",
  int: "\u222B",
  intcal: "\u22BA",
  integers: "\u2124",
  Integral: "\u222B",
  intercal: "\u22BA",
  Intersection: "\u22C2",
  intlarhk: "\u2A17",
  intprod: "\u2A3C",
  InvisibleComma: "\u2063",
  InvisibleTimes: "\u2062",
  IOcy: "\u0401",
  iocy: "\u0451",
  Iogon: "\u012E",
  iogon: "\u012F",
  Iopf: "\uD835\uDD40",
  iopf: "\uD835\uDD5A",
  Iota: "\u0399",
  iota: "\u03B9",
  iprod: "\u2A3C",
  iquest: "\xBF",
  Iscr: "\u2110",
  iscr: "\uD835\uDCBE",
  isin: "\u2208",
  isindot: "\u22F5",
  isinE: "\u22F9",
  isins: "\u22F4",
  isinsv: "\u22F3",
  isinv: "\u2208",
  it: "\u2062",
  Itilde: "\u0128",
  itilde: "\u0129",
  Iukcy: "\u0406",
  iukcy: "\u0456",
  Iuml: "\xCF",
  iuml: "\xEF",
  Jcirc: "\u0134",
  jcirc: "\u0135",
  Jcy: "\u0419",
  jcy: "\u0439",
  Jfr: "\uD835\uDD0D",
  jfr: "\uD835\uDD27",
  jmath: "\u0237",
  Jopf: "\uD835\uDD41",
  jopf: "\uD835\uDD5B",
  Jscr: "\uD835\uDCA5",
  jscr: "\uD835\uDCBF",
  Jsercy: "\u0408",
  jsercy: "\u0458",
  Jukcy: "\u0404",
  jukcy: "\u0454",
  Kappa: "\u039A",
  kappa: "\u03BA",
  kappav: "\u03F0",
  Kcedil: "\u0136",
  kcedil: "\u0137",
  Kcy: "\u041A",
  kcy: "\u043A",
  Kfr: "\uD835\uDD0E",
  kfr: "\uD835\uDD28",
  kgreen: "\u0138",
  KHcy: "\u0425",
  khcy: "\u0445",
  KJcy: "\u040C",
  kjcy: "\u045C",
  Kopf: "\uD835\uDD42",
  kopf: "\uD835\uDD5C",
  Kscr: "\uD835\uDCA6",
  kscr: "\uD835\uDCC0",
  lAarr: "\u21DA",
  Lacute: "\u0139",
  lacute: "\u013A",
  laemptyv: "\u29B4",
  lagran: "\u2112",
  Lambda: "\u039B",
  lambda: "\u03BB",
  Lang: "\u27EA",
  lang: "\u27E8",
  langd: "\u2991",
  langle: "\u27E8",
  lap: "\u2A85",
  Laplacetrf: "\u2112",
  laquo: "\xAB",
  Larr: "\u219E",
  lArr: "\u21D0",
  larr: "\u2190",
  larrb: "\u21E4",
  larrbfs: "\u291F",
  larrfs: "\u291D",
  larrhk: "\u21A9",
  larrlp: "\u21AB",
  larrpl: "\u2939",
  larrsim: "\u2973",
  larrtl: "\u21A2",
  lat: "\u2AAB",
  lAtail: "\u291B",
  latail: "\u2919",
  late: "\u2AAD",
  lates: "\u2AAD\uFE00",
  lBarr: "\u290E",
  lbarr: "\u290C",
  lbbrk: "\u2772",
  lbrace: "{",
  lbrack: "[",
  lbrke: "\u298B",
  lbrksld: "\u298F",
  lbrkslu: "\u298D",
  Lcaron: "\u013D",
  lcaron: "\u013E",
  Lcedil: "\u013B",
  lcedil: "\u013C",
  lceil: "\u2308",
  lcub: "{",
  Lcy: "\u041B",
  lcy: "\u043B",
  ldca: "\u2936",
  ldquo: "\u201C",
  ldquor: "\u201E",
  ldrdhar: "\u2967",
  ldrushar: "\u294B",
  ldsh: "\u21B2",
  lE: "\u2266",
  le: "\u2264",
  LeftAngleBracket: "\u27E8",
  LeftArrow: "\u2190",
  Leftarrow: "\u21D0",
  leftarrow: "\u2190",
  LeftArrowBar: "\u21E4",
  LeftArrowRightArrow: "\u21C6",
  leftarrowtail: "\u21A2",
  LeftCeiling: "\u2308",
  LeftDoubleBracket: "\u27E6",
  LeftDownTeeVector: "\u2961",
  LeftDownVector: "\u21C3",
  LeftDownVectorBar: "\u2959",
  LeftFloor: "\u230A",
  leftharpoondown: "\u21BD",
  leftharpoonup: "\u21BC",
  leftleftarrows: "\u21C7",
  LeftRightArrow: "\u2194",
  Leftrightarrow: "\u21D4",
  leftrightarrow: "\u2194",
  leftrightarrows: "\u21C6",
  leftrightharpoons: "\u21CB",
  leftrightsquigarrow: "\u21AD",
  LeftRightVector: "\u294E",
  LeftTee: "\u22A3",
  LeftTeeArrow: "\u21A4",
  LeftTeeVector: "\u295A",
  leftthreetimes: "\u22CB",
  LeftTriangle: "\u22B2",
  LeftTriangleBar: "\u29CF",
  LeftTriangleEqual: "\u22B4",
  LeftUpDownVector: "\u2951",
  LeftUpTeeVector: "\u2960",
  LeftUpVector: "\u21BF",
  LeftUpVectorBar: "\u2958",
  LeftVector: "\u21BC",
  LeftVectorBar: "\u2952",
  lEg: "\u2A8B",
  leg: "\u22DA",
  leq: "\u2264",
  leqq: "\u2266",
  leqslant: "\u2A7D",
  les: "\u2A7D",
  lescc: "\u2AA8",
  lesdot: "\u2A7F",
  lesdoto: "\u2A81",
  lesdotor: "\u2A83",
  lesg: "\u22DA\uFE00",
  lesges: "\u2A93",
  lessapprox: "\u2A85",
  lessdot: "\u22D6",
  lesseqgtr: "\u22DA",
  lesseqqgtr: "\u2A8B",
  LessEqualGreater: "\u22DA",
  LessFullEqual: "\u2266",
  LessGreater: "\u2276",
  lessgtr: "\u2276",
  LessLess: "\u2AA1",
  lesssim: "\u2272",
  LessSlantEqual: "\u2A7D",
  LessTilde: "\u2272",
  lfisht: "\u297C",
  lfloor: "\u230A",
  Lfr: "\uD835\uDD0F",
  lfr: "\uD835\uDD29",
  lg: "\u2276",
  lgE: "\u2A91",
  lHar: "\u2962",
  lhard: "\u21BD",
  lharu: "\u21BC",
  lharul: "\u296A",
  lhblk: "\u2584",
  LJcy: "\u0409",
  ljcy: "\u0459",
  Ll: "\u22D8",
  ll: "\u226A",
  llarr: "\u21C7",
  llcorner: "\u231E",
  Lleftarrow: "\u21DA",
  llhard: "\u296B",
  lltri: "\u25FA",
  Lmidot: "\u013F",
  lmidot: "\u0140",
  lmoust: "\u23B0",
  lmoustache: "\u23B0",
  lnap: "\u2A89",
  lnapprox: "\u2A89",
  lnE: "\u2268",
  lne: "\u2A87",
  lneq: "\u2A87",
  lneqq: "\u2268",
  lnsim: "\u22E6",
  loang: "\u27EC",
  loarr: "\u21FD",
  lobrk: "\u27E6",
  LongLeftArrow: "\u27F5",
  Longleftarrow: "\u27F8",
  longleftarrow: "\u27F5",
  LongLeftRightArrow: "\u27F7",
  Longleftrightarrow: "\u27FA",
  longleftrightarrow: "\u27F7",
  longmapsto: "\u27FC",
  LongRightArrow: "\u27F6",
  Longrightarrow: "\u27F9",
  longrightarrow: "\u27F6",
  looparrowleft: "\u21AB",
  looparrowright: "\u21AC",
  lopar: "\u2985",
  Lopf: "\uD835\uDD43",
  lopf: "\uD835\uDD5D",
  loplus: "\u2A2D",
  lotimes: "\u2A34",
  lowast: "\u2217",
  lowbar: "_",
  LowerLeftArrow: "\u2199",
  LowerRightArrow: "\u2198",
  loz: "\u25CA",
  lozenge: "\u25CA",
  lozf: "\u29EB",
  lpar: "(",
  lparlt: "\u2993",
  lrarr: "\u21C6",
  lrcorner: "\u231F",
  lrhar: "\u21CB",
  lrhard: "\u296D",
  lrm: "\u200E",
  lrtri: "\u22BF",
  lsaquo: "\u2039",
  Lscr: "\u2112",
  lscr: "\uD835\uDCC1",
  Lsh: "\u21B0",
  lsh: "\u21B0",
  lsim: "\u2272",
  lsime: "\u2A8D",
  lsimg: "\u2A8F",
  lsqb: "[",
  lsquo: "\u2018",
  lsquor: "\u201A",
  Lstrok: "\u0141",
  lstrok: "\u0142",
  Lt: "\u226A",
  LT: "<",
  lt: "<",
  ltcc: "\u2AA6",
  ltcir: "\u2A79",
  ltdot: "\u22D6",
  lthree: "\u22CB",
  ltimes: "\u22C9",
  ltlarr: "\u2976",
  ltquest: "\u2A7B",
  ltri: "\u25C3",
  ltrie: "\u22B4",
  ltrif: "\u25C2",
  ltrPar: "\u2996",
  lurdshar: "\u294A",
  luruhar: "\u2966",
  lvertneqq: "\u2268\uFE00",
  lvnE: "\u2268\uFE00",
  macr: "\xAF",
  male: "\u2642",
  malt: "\u2720",
  maltese: "\u2720",
  Map: "\u2905",
  map: "\u21A6",
  mapsto: "\u21A6",
  mapstodown: "\u21A7",
  mapstoleft: "\u21A4",
  mapstoup: "\u21A5",
  marker: "\u25AE",
  mcomma: "\u2A29",
  Mcy: "\u041C",
  mcy: "\u043C",
  mdash: "\u2014",
  mDDot: "\u223A",
  measuredangle: "\u2221",
  MediumSpace: "\u205F",
  Mellintrf: "\u2133",
  Mfr: "\uD835\uDD10",
  mfr: "\uD835\uDD2A",
  mho: "\u2127",
  micro: "\xB5",
  mid: "\u2223",
  midast: "*",
  midcir: "\u2AF0",
  middot: "\xB7",
  minus: "\u2212",
  minusb: "\u229F",
  minusd: "\u2238",
  minusdu: "\u2A2A",
  MinusPlus: "\u2213",
  mlcp: "\u2ADB",
  mldr: "\u2026",
  mnplus: "\u2213",
  models: "\u22A7",
  Mopf: "\uD835\uDD44",
  mopf: "\uD835\uDD5E",
  mp: "\u2213",
  Mscr: "\u2133",
  mscr: "\uD835\uDCC2",
  mstpos: "\u223E",
  Mu: "\u039C",
  mu: "\u03BC",
  multimap: "\u22B8",
  mumap: "\u22B8",
  nabla: "\u2207",
  Nacute: "\u0143",
  nacute: "\u0144",
  nang: "\u2220\u20D2",
  nap: "\u2249",
  napE: "\u2A70\u0338",
  napid: "\u224B\u0338",
  napos: "\u0149",
  napprox: "\u2249",
  natur: "\u266E",
  natural: "\u266E",
  naturals: "\u2115",
  nbsp: "\xA0",
  nbump: "\u224E\u0338",
  nbumpe: "\u224F\u0338",
  ncap: "\u2A43",
  Ncaron: "\u0147",
  ncaron: "\u0148",
  Ncedil: "\u0145",
  ncedil: "\u0146",
  ncong: "\u2247",
  ncongdot: "\u2A6D\u0338",
  ncup: "\u2A42",
  Ncy: "\u041D",
  ncy: "\u043D",
  ndash: "\u2013",
  ne: "\u2260",
  nearhk: "\u2924",
  neArr: "\u21D7",
  nearr: "\u2197",
  nearrow: "\u2197",
  nedot: "\u2250\u0338",
  NegativeMediumSpace: "\u200B",
  NegativeThickSpace: "\u200B",
  NegativeThinSpace: "\u200B",
  NegativeVeryThinSpace: "\u200B",
  nequiv: "\u2262",
  nesear: "\u2928",
  nesim: "\u2242\u0338",
  NestedGreaterGreater: "\u226B",
  NestedLessLess: "\u226A",
  NewLine: "\n",
  nexist: "\u2204",
  nexists: "\u2204",
  Nfr: "\uD835\uDD11",
  nfr: "\uD835\uDD2B",
  ngE: "\u2267\u0338",
  nge: "\u2271",
  ngeq: "\u2271",
  ngeqq: "\u2267\u0338",
  ngeqslant: "\u2A7E\u0338",
  nges: "\u2A7E\u0338",
  nGg: "\u22D9\u0338",
  ngsim: "\u2275",
  nGt: "\u226B\u20D2",
  ngt: "\u226F",
  ngtr: "\u226F",
  nGtv: "\u226B\u0338",
  nhArr: "\u21CE",
  nharr: "\u21AE",
  nhpar: "\u2AF2",
  ni: "\u220B",
  nis: "\u22FC",
  nisd: "\u22FA",
  niv: "\u220B",
  NJcy: "\u040A",
  njcy: "\u045A",
  nlArr: "\u21CD",
  nlarr: "\u219A",
  nldr: "\u2025",
  nlE: "\u2266\u0338",
  nle: "\u2270",
  nLeftarrow: "\u21CD",
  nleftarrow: "\u219A",
  nLeftrightarrow: "\u21CE",
  nleftrightarrow: "\u21AE",
  nleq: "\u2270",
  nleqq: "\u2266\u0338",
  nleqslant: "\u2A7D\u0338",
  nles: "\u2A7D\u0338",
  nless: "\u226E",
  nLl: "\u22D8\u0338",
  nlsim: "\u2274",
  nLt: "\u226A\u20D2",
  nlt: "\u226E",
  nltri: "\u22EA",
  nltrie: "\u22EC",
  nLtv: "\u226A\u0338",
  nmid: "\u2224",
  NoBreak: "\u2060",
  NonBreakingSpace: "\xA0",
  Nopf: "\u2115",
  nopf: "\uD835\uDD5F",
  Not: "\u2AEC",
  not: "\xAC",
  NotCongruent: "\u2262",
  NotCupCap: "\u226D",
  NotDoubleVerticalBar: "\u2226",
  NotElement: "\u2209",
  NotEqual: "\u2260",
  NotEqualTilde: "\u2242\u0338",
  NotExists: "\u2204",
  NotGreater: "\u226F",
  NotGreaterEqual: "\u2271",
  NotGreaterFullEqual: "\u2267\u0338",
  NotGreaterGreater: "\u226B\u0338",
  NotGreaterLess: "\u2279",
  NotGreaterSlantEqual: "\u2A7E\u0338",
  NotGreaterTilde: "\u2275",
  NotHumpDownHump: "\u224E\u0338",
  NotHumpEqual: "\u224F\u0338",
  notin: "\u2209",
  notindot: "\u22F5\u0338",
  notinE: "\u22F9\u0338",
  notinva: "\u2209",
  notinvb: "\u22F7",
  notinvc: "\u22F6",
  NotLeftTriangle: "\u22EA",
  NotLeftTriangleBar: "\u29CF\u0338",
  NotLeftTriangleEqual: "\u22EC",
  NotLess: "\u226E",
  NotLessEqual: "\u2270",
  NotLessGreater: "\u2278",
  NotLessLess: "\u226A\u0338",
  NotLessSlantEqual: "\u2A7D\u0338",
  NotLessTilde: "\u2274",
  NotNestedGreaterGreater: "\u2AA2\u0338",
  NotNestedLessLess: "\u2AA1\u0338",
  notni: "\u220C",
  notniva: "\u220C",
  notnivb: "\u22FE",
  notnivc: "\u22FD",
  NotPrecedes: "\u2280",
  NotPrecedesEqual: "\u2AAF\u0338",
  NotPrecedesSlantEqual: "\u22E0",
  NotReverseElement: "\u220C",
  NotRightTriangle: "\u22EB",
  NotRightTriangleBar: "\u29D0\u0338",
  NotRightTriangleEqual: "\u22ED",
  NotSquareSubset: "\u228F\u0338",
  NotSquareSubsetEqual: "\u22E2",
  NotSquareSuperset: "\u2290\u0338",
  NotSquareSupersetEqual: "\u22E3",
  NotSubset: "\u2282\u20D2",
  NotSubsetEqual: "\u2288",
  NotSucceeds: "\u2281",
  NotSucceedsEqual: "\u2AB0\u0338",
  NotSucceedsSlantEqual: "\u22E1",
  NotSucceedsTilde: "\u227F\u0338",
  NotSuperset: "\u2283\u20D2",
  NotSupersetEqual: "\u2289",
  NotTilde: "\u2241",
  NotTildeEqual: "\u2244",
  NotTildeFullEqual: "\u2247",
  NotTildeTilde: "\u2249",
  NotVerticalBar: "\u2224",
  npar: "\u2226",
  nparallel: "\u2226",
  nparsl: "\u2AFD\u20E5",
  npart: "\u2202\u0338",
  npolint: "\u2A14",
  npr: "\u2280",
  nprcue: "\u22E0",
  npre: "\u2AAF\u0338",
  nprec: "\u2280",
  npreceq: "\u2AAF\u0338",
  nrArr: "\u21CF",
  nrarr: "\u219B",
  nrarrc: "\u2933\u0338",
  nrarrw: "\u219D\u0338",
  nRightarrow: "\u21CF",
  nrightarrow: "\u219B",
  nrtri: "\u22EB",
  nrtrie: "\u22ED",
  nsc: "\u2281",
  nsccue: "\u22E1",
  nsce: "\u2AB0\u0338",
  Nscr: "\uD835\uDCA9",
  nscr: "\uD835\uDCC3",
  nshortmid: "\u2224",
  nshortparallel: "\u2226",
  nsim: "\u2241",
  nsime: "\u2244",
  nsimeq: "\u2244",
  nsmid: "\u2224",
  nspar: "\u2226",
  nsqsube: "\u22E2",
  nsqsupe: "\u22E3",
  nsub: "\u2284",
  nsubE: "\u2AC5\u0338",
  nsube: "\u2288",
  nsubset: "\u2282\u20D2",
  nsubseteq: "\u2288",
  nsubseteqq: "\u2AC5\u0338",
  nsucc: "\u2281",
  nsucceq: "\u2AB0\u0338",
  nsup: "\u2285",
  nsupE: "\u2AC6\u0338",
  nsupe: "\u2289",
  nsupset: "\u2283\u20D2",
  nsupseteq: "\u2289",
  nsupseteqq: "\u2AC6\u0338",
  ntgl: "\u2279",
  Ntilde: "\xD1",
  ntilde: "\xF1",
  ntlg: "\u2278",
  ntriangleleft: "\u22EA",
  ntrianglelefteq: "\u22EC",
  ntriangleright: "\u22EB",
  ntrianglerighteq: "\u22ED",
  Nu: "\u039D",
  nu: "\u03BD",
  num: "#",
  numero: "\u2116",
  numsp: "\u2007",
  nvap: "\u224D\u20D2",
  nVDash: "\u22AF",
  nVdash: "\u22AE",
  nvDash: "\u22AD",
  nvdash: "\u22AC",
  nvge: "\u2265\u20D2",
  nvgt: ">\u20D2",
  nvHarr: "\u2904",
  nvinfin: "\u29DE",
  nvlArr: "\u2902",
  nvle: "\u2264\u20D2",
  nvlt: "<\u20D2",
  nvltrie: "\u22B4\u20D2",
  nvrArr: "\u2903",
  nvrtrie: "\u22B5\u20D2",
  nvsim: "\u223C\u20D2",
  nwarhk: "\u2923",
  nwArr: "\u21D6",
  nwarr: "\u2196",
  nwarrow: "\u2196",
  nwnear: "\u2927",
  Oacute: "\xD3",
  oacute: "\xF3",
  oast: "\u229B",
  ocir: "\u229A",
  Ocirc: "\xD4",
  ocirc: "\xF4",
  Ocy: "\u041E",
  ocy: "\u043E",
  odash: "\u229D",
  Odblac: "\u0150",
  odblac: "\u0151",
  odiv: "\u2A38",
  odot: "\u2299",
  odsold: "\u29BC",
  OElig: "\u0152",
  oelig: "\u0153",
  ofcir: "\u29BF",
  Ofr: "\uD835\uDD12",
  ofr: "\uD835\uDD2C",
  ogon: "\u02DB",
  Ograve: "\xD2",
  ograve: "\xF2",
  ogt: "\u29C1",
  ohbar: "\u29B5",
  ohm: "\u03A9",
  oint: "\u222E",
  olarr: "\u21BA",
  olcir: "\u29BE",
  olcross: "\u29BB",
  oline: "\u203E",
  olt: "\u29C0",
  Omacr: "\u014C",
  omacr: "\u014D",
  Omega: "\u03A9",
  omega: "\u03C9",
  Omicron: "\u039F",
  omicron: "\u03BF",
  omid: "\u29B6",
  ominus: "\u2296",
  Oopf: "\uD835\uDD46",
  oopf: "\uD835\uDD60",
  opar: "\u29B7",
  OpenCurlyDoubleQuote: "\u201C",
  OpenCurlyQuote: "\u2018",
  operp: "\u29B9",
  oplus: "\u2295",
  Or: "\u2A54",
  or: "\u2228",
  orarr: "\u21BB",
  ord: "\u2A5D",
  order: "\u2134",
  orderof: "\u2134",
  ordf: "\xAA",
  ordm: "\xBA",
  origof: "\u22B6",
  oror: "\u2A56",
  orslope: "\u2A57",
  orv: "\u2A5B",
  oS: "\u24C8",
  Oscr: "\uD835\uDCAA",
  oscr: "\u2134",
  Oslash: "\xD8",
  oslash: "\xF8",
  osol: "\u2298",
  Otilde: "\xD5",
  otilde: "\xF5",
  Otimes: "\u2A37",
  otimes: "\u2297",
  otimesas: "\u2A36",
  Ouml: "\xD6",
  ouml: "\xF6",
  ovbar: "\u233D",
  OverBar: "\u203E",
  OverBrace: "\u23DE",
  OverBracket: "\u23B4",
  OverParenthesis: "\u23DC",
  par: "\u2225",
  para: "\xB6",
  parallel: "\u2225",
  parsim: "\u2AF3",
  parsl: "\u2AFD",
  part: "\u2202",
  PartialD: "\u2202",
  Pcy: "\u041F",
  pcy: "\u043F",
  percnt: "%",
  period: ".",
  permil: "\u2030",
  perp: "\u22A5",
  pertenk: "\u2031",
  Pfr: "\uD835\uDD13",
  pfr: "\uD835\uDD2D",
  Phi: "\u03A6",
  phi: "\u03C6",
  phiv: "\u03D5",
  phmmat: "\u2133",
  phone: "\u260E",
  Pi: "\u03A0",
  pi: "\u03C0",
  pitchfork: "\u22D4",
  piv: "\u03D6",
  planck: "\u210F",
  planckh: "\u210E",
  plankv: "\u210F",
  plus: "+",
  plusacir: "\u2A23",
  plusb: "\u229E",
  pluscir: "\u2A22",
  plusdo: "\u2214",
  plusdu: "\u2A25",
  pluse: "\u2A72",
  PlusMinus: "\xB1",
  plusmn: "\xB1",
  plussim: "\u2A26",
  plustwo: "\u2A27",
  pm: "\xB1",
  Poincareplane: "\u210C",
  pointint: "\u2A15",
  Popf: "\u2119",
  popf: "\uD835\uDD61",
  pound: "\xA3",
  Pr: "\u2ABB",
  pr: "\u227A",
  prap: "\u2AB7",
  prcue: "\u227C",
  prE: "\u2AB3",
  pre: "\u2AAF",
  prec: "\u227A",
  precapprox: "\u2AB7",
  preccurlyeq: "\u227C",
  Precedes: "\u227A",
  PrecedesEqual: "\u2AAF",
  PrecedesSlantEqual: "\u227C",
  PrecedesTilde: "\u227E",
  preceq: "\u2AAF",
  precnapprox: "\u2AB9",
  precneqq: "\u2AB5",
  precnsim: "\u22E8",
  precsim: "\u227E",
  Prime: "\u2033",
  prime: "\u2032",
  primes: "\u2119",
  prnap: "\u2AB9",
  prnE: "\u2AB5",
  prnsim: "\u22E8",
  prod: "\u220F",
  Product: "\u220F",
  profalar: "\u232E",
  profline: "\u2312",
  profsurf: "\u2313",
  prop: "\u221D",
  Proportion: "\u2237",
  Proportional: "\u221D",
  propto: "\u221D",
  prsim: "\u227E",
  prurel: "\u22B0",
  Pscr: "\uD835\uDCAB",
  pscr: "\uD835\uDCC5",
  Psi: "\u03A8",
  psi: "\u03C8",
  puncsp: "\u2008",
  Qfr: "\uD835\uDD14",
  qfr: "\uD835\uDD2E",
  qint: "\u2A0C",
  Qopf: "\u211A",
  qopf: "\uD835\uDD62",
  qprime: "\u2057",
  Qscr: "\uD835\uDCAC",
  qscr: "\uD835\uDCC6",
  quaternions: "\u210D",
  quatint: "\u2A16",
  quest: "?",
  questeq: "\u225F",
  QUOT: "\"",
  quot: "\"",
  rAarr: "\u21DB",
  race: "\u223D\u0331",
  Racute: "\u0154",
  racute: "\u0155",
  radic: "\u221A",
  raemptyv: "\u29B3",
  Rang: "\u27EB",
  rang: "\u27E9",
  rangd: "\u2992",
  range: "\u29A5",
  rangle: "\u27E9",
  raquo: "\xBB",
  Rarr: "\u21A0",
  rArr: "\u21D2",
  rarr: "\u2192",
  rarrap: "\u2975",
  rarrb: "\u21E5",
  rarrbfs: "\u2920",
  rarrc: "\u2933",
  rarrfs: "\u291E",
  rarrhk: "\u21AA",
  rarrlp: "\u21AC",
  rarrpl: "\u2945",
  rarrsim: "\u2974",
  Rarrtl: "\u2916",
  rarrtl: "\u21A3",
  rarrw: "\u219D",
  rAtail: "\u291C",
  ratail: "\u291A",
  ratio: "\u2236",
  rationals: "\u211A",
  RBarr: "\u2910",
  rBarr: "\u290F",
  rbarr: "\u290D",
  rbbrk: "\u2773",
  rbrace: "}",
  rbrack: "]",
  rbrke: "\u298C",
  rbrksld: "\u298E",
  rbrkslu: "\u2990",
  Rcaron: "\u0158",
  rcaron: "\u0159",
  Rcedil: "\u0156",
  rcedil: "\u0157",
  rceil: "\u2309",
  rcub: "}",
  Rcy: "\u0420",
  rcy: "\u0440",
  rdca: "\u2937",
  rdldhar: "\u2969",
  rdquo: "\u201D",
  rdquor: "\u201D",
  rdsh: "\u21B3",
  Re: "\u211C",
  real: "\u211C",
  realine: "\u211B",
  realpart: "\u211C",
  reals: "\u211D",
  rect: "\u25AD",
  REG: "\xAE",
  reg: "\xAE",
  ReverseElement: "\u220B",
  ReverseEquilibrium: "\u21CB",
  ReverseUpEquilibrium: "\u296F",
  rfisht: "\u297D",
  rfloor: "\u230B",
  Rfr: "\u211C",
  rfr: "\uD835\uDD2F",
  rHar: "\u2964",
  rhard: "\u21C1",
  rharu: "\u21C0",
  rharul: "\u296C",
  Rho: "\u03A1",
  rho: "\u03C1",
  rhov: "\u03F1",
  RightAngleBracket: "\u27E9",
  RightArrow: "\u2192",
  Rightarrow: "\u21D2",
  rightarrow: "\u2192",
  RightArrowBar: "\u21E5",
  RightArrowLeftArrow: "\u21C4",
  rightarrowtail: "\u21A3",
  RightCeiling: "\u2309",
  RightDoubleBracket: "\u27E7",
  RightDownTeeVector: "\u295D",
  RightDownVector: "\u21C2",
  RightDownVectorBar: "\u2955",
  RightFloor: "\u230B",
  rightharpoondown: "\u21C1",
  rightharpoonup: "\u21C0",
  rightleftarrows: "\u21C4",
  rightleftharpoons: "\u21CC",
  rightrightarrows: "\u21C9",
  rightsquigarrow: "\u219D",
  RightTee: "\u22A2",
  RightTeeArrow: "\u21A6",
  RightTeeVector: "\u295B",
  rightthreetimes: "\u22CC",
  RightTriangle: "\u22B3",
  RightTriangleBar: "\u29D0",
  RightTriangleEqual: "\u22B5",
  RightUpDownVector: "\u294F",
  RightUpTeeVector: "\u295C",
  RightUpVector: "\u21BE",
  RightUpVectorBar: "\u2954",
  RightVector: "\u21C0",
  RightVectorBar: "\u2953",
  ring: "\u02DA",
  risingdotseq: "\u2253",
  rlarr: "\u21C4",
  rlhar: "\u21CC",
  rlm: "\u200F",
  rmoust: "\u23B1",
  rmoustache: "\u23B1",
  rnmid: "\u2AEE",
  roang: "\u27ED",
  roarr: "\u21FE",
  robrk: "\u27E7",
  ropar: "\u2986",
  Ropf: "\u211D",
  ropf: "\uD835\uDD63",
  roplus: "\u2A2E",
  rotimes: "\u2A35",
  RoundImplies: "\u2970",
  rpar: ")",
  rpargt: "\u2994",
  rppolint: "\u2A12",
  rrarr: "\u21C9",
  Rrightarrow: "\u21DB",
  rsaquo: "\u203A",
  Rscr: "\u211B",
  rscr: "\uD835\uDCC7",
  Rsh: "\u21B1",
  rsh: "\u21B1",
  rsqb: "]",
  rsquo: "\u2019",
  rsquor: "\u2019",
  rthree: "\u22CC",
  rtimes: "\u22CA",
  rtri: "\u25B9",
  rtrie: "\u22B5",
  rtrif: "\u25B8",
  rtriltri: "\u29CE",
  RuleDelayed: "\u29F4",
  ruluhar: "\u2968",
  rx: "\u211E",
  Sacute: "\u015A",
  sacute: "\u015B",
  sbquo: "\u201A",
  Sc: "\u2ABC",
  sc: "\u227B",
  scap: "\u2AB8",
  Scaron: "\u0160",
  scaron: "\u0161",
  sccue: "\u227D",
  scE: "\u2AB4",
  sce: "\u2AB0",
  Scedil: "\u015E",
  scedil: "\u015F",
  Scirc: "\u015C",
  scirc: "\u015D",
  scnap: "\u2ABA",
  scnE: "\u2AB6",
  scnsim: "\u22E9",
  scpolint: "\u2A13",
  scsim: "\u227F",
  Scy: "\u0421",
  scy: "\u0441",
  sdot: "\u22C5",
  sdotb: "\u22A1",
  sdote: "\u2A66",
  searhk: "\u2925",
  seArr: "\u21D8",
  searr: "\u2198",
  searrow: "\u2198",
  sect: "\xA7",
  semi: ";",
  seswar: "\u2929",
  setminus: "\u2216",
  setmn: "\u2216",
  sext: "\u2736",
  Sfr: "\uD835\uDD16",
  sfr: "\uD835\uDD30",
  sfrown: "\u2322",
  sharp: "\u266F",
  SHCHcy: "\u0429",
  shchcy: "\u0449",
  SHcy: "\u0428",
  shcy: "\u0448",
  ShortDownArrow: "\u2193",
  ShortLeftArrow: "\u2190",
  shortmid: "\u2223",
  shortparallel: "\u2225",
  ShortRightArrow: "\u2192",
  ShortUpArrow: "\u2191",
  shy: "\xAD",
  Sigma: "\u03A3",
  sigma: "\u03C3",
  sigmaf: "\u03C2",
  sigmav: "\u03C2",
  sim: "\u223C",
  simdot: "\u2A6A",
  sime: "\u2243",
  simeq: "\u2243",
  simg: "\u2A9E",
  simgE: "\u2AA0",
  siml: "\u2A9D",
  simlE: "\u2A9F",
  simne: "\u2246",
  simplus: "\u2A24",
  simrarr: "\u2972",
  slarr: "\u2190",
  SmallCircle: "\u2218",
  smallsetminus: "\u2216",
  smashp: "\u2A33",
  smeparsl: "\u29E4",
  smid: "\u2223",
  smile: "\u2323",
  smt: "\u2AAA",
  smte: "\u2AAC",
  smtes: "\u2AAC\uFE00",
  SOFTcy: "\u042C",
  softcy: "\u044C",
  sol: "/",
  solb: "\u29C4",
  solbar: "\u233F",
  Sopf: "\uD835\uDD4A",
  sopf: "\uD835\uDD64",
  spades: "\u2660",
  spadesuit: "\u2660",
  spar: "\u2225",
  sqcap: "\u2293",
  sqcaps: "\u2293\uFE00",
  sqcup: "\u2294",
  sqcups: "\u2294\uFE00",
  Sqrt: "\u221A",
  sqsub: "\u228F",
  sqsube: "\u2291",
  sqsubset: "\u228F",
  sqsubseteq: "\u2291",
  sqsup: "\u2290",
  sqsupe: "\u2292",
  sqsupset: "\u2290",
  sqsupseteq: "\u2292",
  squ: "\u25A1",
  Square: "\u25A1",
  square: "\u25A1",
  SquareIntersection: "\u2293",
  SquareSubset: "\u228F",
  SquareSubsetEqual: "\u2291",
  SquareSuperset: "\u2290",
  SquareSupersetEqual: "\u2292",
  SquareUnion: "\u2294",
  squarf: "\u25AA",
  squf: "\u25AA",
  srarr: "\u2192",
  Sscr: "\uD835\uDCAE",
  sscr: "\uD835\uDCC8",
  ssetmn: "\u2216",
  ssmile: "\u2323",
  sstarf: "\u22C6",
  Star: "\u22C6",
  star: "\u2606",
  starf: "\u2605",
  straightepsilon: "\u03F5",
  straightphi: "\u03D5",
  strns: "\xAF",
  Sub: "\u22D0",
  sub: "\u2282",
  subdot: "\u2ABD",
  subE: "\u2AC5",
  sube: "\u2286",
  subedot: "\u2AC3",
  submult: "\u2AC1",
  subnE: "\u2ACB",
  subne: "\u228A",
  subplus: "\u2ABF",
  subrarr: "\u2979",
  Subset: "\u22D0",
  subset: "\u2282",
  subseteq: "\u2286",
  subseteqq: "\u2AC5",
  SubsetEqual: "\u2286",
  subsetneq: "\u228A",
  subsetneqq: "\u2ACB",
  subsim: "\u2AC7",
  subsub: "\u2AD5",
  subsup: "\u2AD3",
  succ: "\u227B",
  succapprox: "\u2AB8",
  succcurlyeq: "\u227D",
  Succeeds: "\u227B",
  SucceedsEqual: "\u2AB0",
  SucceedsSlantEqual: "\u227D",
  SucceedsTilde: "\u227F",
  succeq: "\u2AB0",
  succnapprox: "\u2ABA",
  succneqq: "\u2AB6",
  succnsim: "\u22E9",
  succsim: "\u227F",
  SuchThat: "\u220B",
  Sum: "\u2211",
  sum: "\u2211",
  sung: "\u266A",
  Sup: "\u22D1",
  sup: "\u2283",
  sup1: "\xB9",
  sup2: "\xB2",
  sup3: "\xB3",
  supdot: "\u2ABE",
  supdsub: "\u2AD8",
  supE: "\u2AC6",
  supe: "\u2287",
  supedot: "\u2AC4",
  Superset: "\u2283",
  SupersetEqual: "\u2287",
  suphsol: "\u27C9",
  suphsub: "\u2AD7",
  suplarr: "\u297B",
  supmult: "\u2AC2",
  supnE: "\u2ACC",
  supne: "\u228B",
  supplus: "\u2AC0",
  Supset: "\u22D1",
  supset: "\u2283",
  supseteq: "\u2287",
  supseteqq: "\u2AC6",
  supsetneq: "\u228B",
  supsetneqq: "\u2ACC",
  supsim: "\u2AC8",
  supsub: "\u2AD4",
  supsup: "\u2AD6",
  swarhk: "\u2926",
  swArr: "\u21D9",
  swarr: "\u2199",
  swarrow: "\u2199",
  swnwar: "\u292A",
  szlig: "\xDF",
  Tab: "\t",
  target: "\u2316",
  Tau: "\u03A4",
  tau: "\u03C4",
  tbrk: "\u23B4",
  Tcaron: "\u0164",
  tcaron: "\u0165",
  Tcedil: "\u0162",
  tcedil: "\u0163",
  Tcy: "\u0422",
  tcy: "\u0442",
  tdot: "\u20DB",
  telrec: "\u2315",
  Tfr: "\uD835\uDD17",
  tfr: "\uD835\uDD31",
  there4: "\u2234",
  Therefore: "\u2234",
  therefore: "\u2234",
  Theta: "\u0398",
  theta: "\u03B8",
  thetasym: "\u03D1",
  thetav: "\u03D1",
  thickapprox: "\u2248",
  thicksim: "\u223C",
  ThickSpace: "\u205F\u200A",
  thinsp: "\u2009",
  ThinSpace: "\u2009",
  thkap: "\u2248",
  thksim: "\u223C",
  THORN: "\xDE",
  thorn: "\xFE",
  Tilde: "\u223C",
  tilde: "\u02DC",
  TildeEqual: "\u2243",
  TildeFullEqual: "\u2245",
  TildeTilde: "\u2248",
  times: "\xD7",
  timesb: "\u22A0",
  timesbar: "\u2A31",
  timesd: "\u2A30",
  tint: "\u222D",
  toea: "\u2928",
  top: "\u22A4",
  topbot: "\u2336",
  topcir: "\u2AF1",
  Topf: "\uD835\uDD4B",
  topf: "\uD835\uDD65",
  topfork: "\u2ADA",
  tosa: "\u2929",
  tprime: "\u2034",
  TRADE: "\u2122",
  trade: "\u2122",
  triangle: "\u25B5",
  triangledown: "\u25BF",
  triangleleft: "\u25C3",
  trianglelefteq: "\u22B4",
  triangleq: "\u225C",
  triangleright: "\u25B9",
  trianglerighteq: "\u22B5",
  tridot: "\u25EC",
  trie: "\u225C",
  triminus: "\u2A3A",
  TripleDot: "\u20DB",
  triplus: "\u2A39",
  trisb: "\u29CD",
  tritime: "\u2A3B",
  trpezium: "\u23E2",
  Tscr: "\uD835\uDCAF",
  tscr: "\uD835\uDCC9",
  TScy: "\u0426",
  tscy: "\u0446",
  TSHcy: "\u040B",
  tshcy: "\u045B",
  Tstrok: "\u0166",
  tstrok: "\u0167",
  twixt: "\u226C",
  twoheadleftarrow: "\u219E",
  twoheadrightarrow: "\u21A0",
  Uacute: "\xDA",
  uacute: "\xFA",
  Uarr: "\u219F",
  uArr: "\u21D1",
  uarr: "\u2191",
  Uarrocir: "\u2949",
  Ubrcy: "\u040E",
  ubrcy: "\u045E",
  Ubreve: "\u016C",
  ubreve: "\u016D",
  Ucirc: "\xDB",
  ucirc: "\xFB",
  Ucy: "\u0423",
  ucy: "\u0443",
  udarr: "\u21C5",
  Udblac: "\u0170",
  udblac: "\u0171",
  udhar: "\u296E",
  ufisht: "\u297E",
  Ufr: "\uD835\uDD18",
  ufr: "\uD835\uDD32",
  Ugrave: "\xD9",
  ugrave: "\xF9",
  uHar: "\u2963",
  uharl: "\u21BF",
  uharr: "\u21BE",
  uhblk: "\u2580",
  ulcorn: "\u231C",
  ulcorner: "\u231C",
  ulcrop: "\u230F",
  ultri: "\u25F8",
  Umacr: "\u016A",
  umacr: "\u016B",
  uml: "\xA8",
  UnderBar: "_",
  UnderBrace: "\u23DF",
  UnderBracket: "\u23B5",
  UnderParenthesis: "\u23DD",
  Union: "\u22C3",
  UnionPlus: "\u228E",
  Uogon: "\u0172",
  uogon: "\u0173",
  Uopf: "\uD835\uDD4C",
  uopf: "\uD835\uDD66",
  UpArrow: "\u2191",
  Uparrow: "\u21D1",
  uparrow: "\u2191",
  UpArrowBar: "\u2912",
  UpArrowDownArrow: "\u21C5",
  UpDownArrow: "\u2195",
  Updownarrow: "\u21D5",
  updownarrow: "\u2195",
  UpEquilibrium: "\u296E",
  upharpoonleft: "\u21BF",
  upharpoonright: "\u21BE",
  uplus: "\u228E",
  UpperLeftArrow: "\u2196",
  UpperRightArrow: "\u2197",
  Upsi: "\u03D2",
  upsi: "\u03C5",
  upsih: "\u03D2",
  Upsilon: "\u03A5",
  upsilon: "\u03C5",
  UpTee: "\u22A5",
  UpTeeArrow: "\u21A5",
  upuparrows: "\u21C8",
  urcorn: "\u231D",
  urcorner: "\u231D",
  urcrop: "\u230E",
  Uring: "\u016E",
  uring: "\u016F",
  urtri: "\u25F9",
  Uscr: "\uD835\uDCB0",
  uscr: "\uD835\uDCCA",
  utdot: "\u22F0",
  Utilde: "\u0168",
  utilde: "\u0169",
  utri: "\u25B5",
  utrif: "\u25B4",
  uuarr: "\u21C8",
  Uuml: "\xDC",
  uuml: "\xFC",
  uwangle: "\u29A7",
  vangrt: "\u299C",
  varepsilon: "\u03F5",
  varkappa: "\u03F0",
  varnothing: "\u2205",
  varphi: "\u03D5",
  varpi: "\u03D6",
  varpropto: "\u221D",
  vArr: "\u21D5",
  varr: "\u2195",
  varrho: "\u03F1",
  varsigma: "\u03C2",
  varsubsetneq: "\u228A\uFE00",
  varsubsetneqq: "\u2ACB\uFE00",
  varsupsetneq: "\u228B\uFE00",
  varsupsetneqq: "\u2ACC\uFE00",
  vartheta: "\u03D1",
  vartriangleleft: "\u22B2",
  vartriangleright: "\u22B3",
  Vbar: "\u2AEB",
  vBar: "\u2AE8",
  vBarv: "\u2AE9",
  Vcy: "\u0412",
  vcy: "\u0432",
  VDash: "\u22AB",
  Vdash: "\u22A9",
  vDash: "\u22A8",
  vdash: "\u22A2",
  Vdashl: "\u2AE6",
  Vee: "\u22C1",
  vee: "\u2228",
  veebar: "\u22BB",
  veeeq: "\u225A",
  vellip: "\u22EE",
  Verbar: "\u2016",
  verbar: "|",
  Vert: "\u2016",
  vert: "|",
  VerticalBar: "\u2223",
  VerticalLine: "|",
  VerticalSeparator: "\u2758",
  VerticalTilde: "\u2240",
  VeryThinSpace: "\u200A",
  Vfr: "\uD835\uDD19",
  vfr: "\uD835\uDD33",
  vltri: "\u22B2",
  vnsub: "\u2282\u20D2",
  vnsup: "\u2283\u20D2",
  Vopf: "\uD835\uDD4D",
  vopf: "\uD835\uDD67",
  vprop: "\u221D",
  vrtri: "\u22B3",
  Vscr: "\uD835\uDCB1",
  vscr: "\uD835\uDCCB",
  vsubnE: "\u2ACB\uFE00",
  vsubne: "\u228A\uFE00",
  vsupnE: "\u2ACC\uFE00",
  vsupne: "\u228B\uFE00",
  Vvdash: "\u22AA",
  vzigzag: "\u299A",
  Wcirc: "\u0174",
  wcirc: "\u0175",
  wedbar: "\u2A5F",
  Wedge: "\u22C0",
  wedge: "\u2227",
  wedgeq: "\u2259",
  weierp: "\u2118",
  Wfr: "\uD835\uDD1A",
  wfr: "\uD835\uDD34",
  Wopf: "\uD835\uDD4E",
  wopf: "\uD835\uDD68",
  wp: "\u2118",
  wr: "\u2240",
  wreath: "\u2240",
  Wscr: "\uD835\uDCB2",
  wscr: "\uD835\uDCCC",
  xcap: "\u22C2",
  xcirc: "\u25EF",
  xcup: "\u22C3",
  xdtri: "\u25BD",
  Xfr: "\uD835\uDD1B",
  xfr: "\uD835\uDD35",
  xhArr: "\u27FA",
  xharr: "\u27F7",
  Xi: "\u039E",
  xi: "\u03BE",
  xlArr: "\u27F8",
  xlarr: "\u27F5",
  xmap: "\u27FC",
  xnis: "\u22FB",
  xodot: "\u2A00",
  Xopf: "\uD835\uDD4F",
  xopf: "\uD835\uDD69",
  xoplus: "\u2A01",
  xotime: "\u2A02",
  xrArr: "\u27F9",
  xrarr: "\u27F6",
  Xscr: "\uD835\uDCB3",
  xscr: "\uD835\uDCCD",
  xsqcup: "\u2A06",
  xuplus: "\u2A04",
  xutri: "\u25B3",
  xvee: "\u22C1",
  xwedge: "\u22C0",
  Yacute: "\xDD",
  yacute: "\xFD",
  YAcy: "\u042F",
  yacy: "\u044F",
  Ycirc: "\u0176",
  ycirc: "\u0177",
  Ycy: "\u042B",
  ycy: "\u044B",
  yen: "\xA5",
  Yfr: "\uD835\uDD1C",
  yfr: "\uD835\uDD36",
  YIcy: "\u0407",
  yicy: "\u0457",
  Yopf: "\uD835\uDD50",
  yopf: "\uD835\uDD6A",
  Yscr: "\uD835\uDCB4",
  yscr: "\uD835\uDCCE",
  YUcy: "\u042E",
  yucy: "\u044E",
  Yuml: "\u0178",
  yuml: "\xFF",
  Zacute: "\u0179",
  zacute: "\u017A",
  Zcaron: "\u017D",
  zcaron: "\u017E",
  Zcy: "\u0417",
  zcy: "\u0437",
  Zdot: "\u017B",
  zdot: "\u017C",
  zeetrf: "\u2128",
  ZeroWidthSpace: "\u200B",
  Zeta: "\u0396",
  zeta: "\u03B6",
  Zfr: "\u2128",
  zfr: "\uD835\uDD37",
  ZHcy: "\u0416",
  zhcy: "\u0436",
  zigrarr: "\u21DD",
  Zopf: "\u2124",
  zopf: "\uD835\uDD6B",
  Zscr: "\uD835\uDCB5",
  zscr: "\uD835\uDCCF",
  zwj: "\u200D",
  zwnj: "\u200C"
});

/**
 * @deprecated use `HTML_ENTITIES` instead
 * @see HTML_ENTITIES
 */
exports.entityMap = exports.HTML_ENTITIES;

/***/ }),

/***/ 23399:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;
var dom = __webpack_require__(67102);
__webpack_unused_export__ = dom.DOMImplementation;
__webpack_unused_export__ = dom.XMLSerializer;
exports.DOMParser = __webpack_require__(60522).DOMParser;

/***/ }),

/***/ 36752:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

__webpack_require__(24603);
__webpack_require__(74916);
__webpack_require__(39714);
__webpack_require__(47042);
__webpack_require__(68309);
__webpack_require__(15306);
__webpack_require__(4723);
var NAMESPACE = __webpack_require__(62697).NAMESPACE;

//[4]   	NameStartChar	   ::=   	":" | [A-Z] | "_" | [a-z] | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x2FF] | [#x370-#x37D] | [#x37F-#x1FFF] | [#x200C-#x200D] | [#x2070-#x218F] | [#x2C00-#x2FEF] | [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
//[4a]   	NameChar	   ::=   	NameStartChar | "-" | "." | [0-9] | #xB7 | [#x0300-#x036F] | [#x203F-#x2040]
//[5]   	Name	   ::=   	NameStartChar (NameChar)*
var nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/; //\u10000-\uEFFFF
var nameChar = new RegExp("[\\-\\.0-9" + nameStartChar.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]");
var tagNamePattern = new RegExp('^' + nameStartChar.source + nameChar.source + '*(?:\:' + nameStartChar.source + nameChar.source + '*)?$');
//var tagNamePattern = /^[a-zA-Z_][\w\-\.]*(?:\:[a-zA-Z_][\w\-\.]*)?$/
//var handlers = 'resolveEntity,getExternalSubset,characters,endDocument,endElement,endPrefixMapping,ignorableWhitespace,processingInstruction,setDocumentLocator,skippedEntity,startDocument,startElement,startPrefixMapping,notationDecl,unparsedEntityDecl,error,fatalError,warning,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,comment,endCDATA,endDTD,endEntity,startCDATA,startDTD,startEntity'.split(',')

//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
var S_TAG = 0; //tag name offerring
var S_ATTR = 1; //attr name offerring
var S_ATTR_SPACE = 2; //attr name end and space offer
var S_EQ = 3; //=space?
var S_ATTR_NOQUOT_VALUE = 4; //attr value(no quot value only)
var S_ATTR_END = 5; //attr value end and no space(quot end)
var S_TAG_SPACE = 6; //(attr value end || tag end ) && (space offer)
var S_TAG_CLOSE = 7; //closed el<el />

/**
 * Creates an error that will not be caught by XMLReader aka the SAX parser.
 *
 * @param {string} message
 * @param {any?} locator Optional, can provide details about the location in the source
 * @constructor
 */
function ParseError(message, locator) {
  this.message = message;
  this.locator = locator;
  if (Error.captureStackTrace) Error.captureStackTrace(this, ParseError);
}
ParseError.prototype = new Error();
ParseError.prototype.name = ParseError.name;
function XMLReader() {}
XMLReader.prototype = {
  parse: function parse(source, defaultNSMap, entityMap) {
    var domBuilder = this.domBuilder;
    domBuilder.startDocument();
    _copy(defaultNSMap, defaultNSMap = {});
    _parse(source, defaultNSMap, entityMap, domBuilder, this.errorHandler);
    domBuilder.endDocument();
  }
};
function _parse(source, defaultNSMapCopy, entityMap, domBuilder, errorHandler) {
  function fixedFromCharCode(code) {
    // String.prototype.fromCharCode does not supports
    // > 2 bytes unicode chars directly
    if (code > 0xffff) {
      code -= 0x10000;
      var surrogate1 = 0xd800 + (code >> 10),
        surrogate2 = 0xdc00 + (code & 0x3ff);
      return String.fromCharCode(surrogate1, surrogate2);
    } else {
      return String.fromCharCode(code);
    }
  }
  function entityReplacer(a) {
    var k = a.slice(1, -1);
    if (Object.hasOwnProperty.call(entityMap, k)) {
      return entityMap[k];
    } else if (k.charAt(0) === '#') {
      return fixedFromCharCode(parseInt(k.substr(1).replace('x', '0x')));
    } else {
      errorHandler.error('entity not found:' + a);
      return a;
    }
  }
  function appendText(end) {
    //has some bugs
    if (end > start) {
      var xt = source.substring(start, end).replace(/&#?\w+;/g, entityReplacer);
      locator && position(start);
      domBuilder.characters(xt, 0, end - start);
      start = end;
    }
  }
  function position(p, m) {
    while (p >= lineEnd && (m = linePattern.exec(source))) {
      lineStart = m.index;
      lineEnd = lineStart + m[0].length;
      locator.lineNumber++;
      //console.log('line++:',locator,startPos,endPos)
    }

    locator.columnNumber = p - lineStart + 1;
  }
  var lineStart = 0;
  var lineEnd = 0;
  var linePattern = /.*(?:\r\n?|\n)|.*$/g;
  var locator = domBuilder.locator;
  var parseStack = [{
    currentNSMap: defaultNSMapCopy
  }];
  var closeMap = {};
  var start = 0;
  while (true) {
    try {
      var tagStart = source.indexOf('<', start);
      if (tagStart < 0) {
        if (!source.substr(start).match(/^\s*$/)) {
          var doc = domBuilder.doc;
          var text = doc.createTextNode(source.substr(start));
          doc.appendChild(text);
          domBuilder.currentElement = text;
        }
        return;
      }
      if (tagStart > start) {
        appendText(tagStart);
      }
      switch (source.charAt(tagStart + 1)) {
        case '/':
          var end = source.indexOf('>', tagStart + 3);
          var tagName = source.substring(tagStart + 2, end).replace(/[ \t\n\r]+$/g, '');
          var config = parseStack.pop();
          if (end < 0) {
            tagName = source.substring(tagStart + 2).replace(/[\s<].*/, '');
            errorHandler.error("end tag name: " + tagName + ' is not complete:' + config.tagName);
            end = tagStart + 1 + tagName.length;
          } else if (tagName.match(/\s</)) {
            tagName = tagName.replace(/[\s<].*/, '');
            errorHandler.error("end tag name: " + tagName + ' maybe not complete');
            end = tagStart + 1 + tagName.length;
          }
          var localNSMap = config.localNSMap;
          var endMatch = config.tagName == tagName;
          var endIgnoreCaseMach = endMatch || config.tagName && config.tagName.toLowerCase() == tagName.toLowerCase();
          if (endIgnoreCaseMach) {
            domBuilder.endElement(config.uri, config.localName, tagName);
            if (localNSMap) {
              for (var prefix in localNSMap) {
                if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) {
                  domBuilder.endPrefixMapping(prefix);
                }
              }
            }
            if (!endMatch) {
              errorHandler.fatalError("end tag name: " + tagName + ' is not match the current start tagName:' + config.tagName); // No known test case
            }
          } else {
            parseStack.push(config);
          }
          end++;
          break;
        // end elment
        case '?':
          // <?...?>
          locator && position(tagStart);
          end = parseInstruction(source, tagStart, domBuilder);
          break;
        case '!':
          // <!doctype,<![CDATA,<!--
          locator && position(tagStart);
          end = parseDCC(source, tagStart, domBuilder, errorHandler);
          break;
        default:
          locator && position(tagStart);
          var el = new ElementAttributes();
          var currentNSMap = parseStack[parseStack.length - 1].currentNSMap;
          //elStartEnd
          var end = parseElementStartPart(source, tagStart, el, currentNSMap, entityReplacer, errorHandler);
          var len = el.length;
          if (!el.closed && fixSelfClosed(source, end, el.tagName, closeMap)) {
            el.closed = true;
            if (!entityMap.nbsp) {
              errorHandler.warning('unclosed xml attribute');
            }
          }
          if (locator && len) {
            var locator2 = copyLocator(locator, {});
            //try{//attribute position fixed
            for (var i = 0; i < len; i++) {
              var a = el[i];
              position(a.offset);
              a.locator = copyLocator(locator, {});
            }
            domBuilder.locator = locator2;
            if (appendElement(el, domBuilder, currentNSMap)) {
              parseStack.push(el);
            }
            domBuilder.locator = locator;
          } else {
            if (appendElement(el, domBuilder, currentNSMap)) {
              parseStack.push(el);
            }
          }
          if (NAMESPACE.isHTML(el.uri) && !el.closed) {
            end = parseHtmlSpecialContent(source, end, el.tagName, entityReplacer, domBuilder);
          } else {
            end++;
          }
      }
    } catch (e) {
      if (e instanceof ParseError) {
        throw e;
      }
      errorHandler.error('element parse error: ' + e);
      end = -1;
    }
    if (end > start) {
      start = end;
    } else {
      //TODO: 这里有可能sax回退，有位置错误风险
      appendText(Math.max(tagStart, start) + 1);
    }
  }
}
function copyLocator(f, t) {
  t.lineNumber = f.lineNumber;
  t.columnNumber = f.columnNumber;
  return t;
}

/**
 * @see #appendElement(source,elStartEnd,el,selfClosed,entityReplacer,domBuilder,parseStack);
 * @return end of the elementStartPart(end of elementEndPart for selfClosed el)
 */
function parseElementStartPart(source, start, el, currentNSMap, entityReplacer, errorHandler) {
  /**
   * @param {string} qname
   * @param {string} value
   * @param {number} startIndex
   */
  function addAttribute(qname, value, startIndex) {
    if (el.attributeNames.hasOwnProperty(qname)) {
      errorHandler.fatalError('Attribute ' + qname + ' redefined');
    }
    el.addValue(qname,
    // @see https://www.w3.org/TR/xml/#AVNormalize
    // since the xmldom sax parser does not "interpret" DTD the following is not implemented:
    // - recursive replacement of (DTD) entity references
    // - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
    value.replace(/[\t\n\r]/g, ' ').replace(/&#?\w+;/g, entityReplacer), startIndex);
  }
  var attrName;
  var value;
  var p = ++start;
  var s = S_TAG; //status
  while (true) {
    var c = source.charAt(p);
    switch (c) {
      case '=':
        if (s === S_ATTR) {
          //attrName
          attrName = source.slice(start, p);
          s = S_EQ;
        } else if (s === S_ATTR_SPACE) {
          s = S_EQ;
        } else {
          //fatalError: equal must after attrName or space after attrName
          throw new Error('attribute equal must after attrName'); // No known test case
        }

        break;
      case '\'':
      case '"':
        if (s === S_EQ || s === S_ATTR //|| s == S_ATTR_SPACE
        ) {
          //equal
          if (s === S_ATTR) {
            errorHandler.warning('attribute value must after "="');
            attrName = source.slice(start, p);
          }
          start = p + 1;
          p = source.indexOf(c, start);
          if (p > 0) {
            value = source.slice(start, p);
            addAttribute(attrName, value, start - 1);
            s = S_ATTR_END;
          } else {
            //fatalError: no end quot match
            throw new Error('attribute value no end \'' + c + '\' match');
          }
        } else if (s == S_ATTR_NOQUOT_VALUE) {
          value = source.slice(start, p);
          addAttribute(attrName, value, start);
          errorHandler.warning('attribute "' + attrName + '" missed start quot(' + c + ')!!');
          start = p + 1;
          s = S_ATTR_END;
        } else {
          //fatalError: no equal before
          throw new Error('attribute value must after "="'); // No known test case
        }

        break;
      case '/':
        switch (s) {
          case S_TAG:
            el.setTagName(source.slice(start, p));
          case S_ATTR_END:
          case S_TAG_SPACE:
          case S_TAG_CLOSE:
            s = S_TAG_CLOSE;
            el.closed = true;
          case S_ATTR_NOQUOT_VALUE:
          case S_ATTR:
            break;
          case S_ATTR_SPACE:
            el.closed = true;
            break;
          //case S_EQ:
          default:
            throw new Error("attribute invalid close char('/')");
          // No known test case
        }

        break;
      case '':
        //end document
        errorHandler.error('unexpected end of input');
        if (s == S_TAG) {
          el.setTagName(source.slice(start, p));
        }
        return p;
      case '>':
        switch (s) {
          case S_TAG:
            el.setTagName(source.slice(start, p));
          case S_ATTR_END:
          case S_TAG_SPACE:
          case S_TAG_CLOSE:
            break;
          //normal
          case S_ATTR_NOQUOT_VALUE: //Compatible state
          case S_ATTR:
            value = source.slice(start, p);
            if (value.slice(-1) === '/') {
              el.closed = true;
              value = value.slice(0, -1);
            }
          case S_ATTR_SPACE:
            if (s === S_ATTR_SPACE) {
              value = attrName;
            }
            if (s == S_ATTR_NOQUOT_VALUE) {
              errorHandler.warning('attribute "' + value + '" missed quot(")!');
              addAttribute(attrName, value, start);
            } else {
              if (!NAMESPACE.isHTML(currentNSMap['']) || !value.match(/^(?:disabled|checked|selected)$/i)) {
                errorHandler.warning('attribute "' + value + '" missed value!! "' + value + '" instead!!');
              }
              addAttribute(value, value, start);
            }
            break;
          case S_EQ:
            throw new Error('attribute value missed!!');
        }
        //			console.log(tagName,tagNamePattern,tagNamePattern.test(tagName))
        return p;
      /*xml space '\x20' | #x9 | #xD | #xA; */
      case "\x80":
        c = ' ';
      default:
        if (c <= ' ') {
          //space
          switch (s) {
            case S_TAG:
              el.setTagName(source.slice(start, p)); //tagName
              s = S_TAG_SPACE;
              break;
            case S_ATTR:
              attrName = source.slice(start, p);
              s = S_ATTR_SPACE;
              break;
            case S_ATTR_NOQUOT_VALUE:
              var value = source.slice(start, p);
              errorHandler.warning('attribute "' + value + '" missed quot(")!!');
              addAttribute(attrName, value, start);
            case S_ATTR_END:
              s = S_TAG_SPACE;
              break;
            //case S_TAG_SPACE:
            //case S_EQ:
            //case S_ATTR_SPACE:
            //	void();break;
            //case S_TAG_CLOSE:
            //ignore warning
          }
        } else {
          //not space
          //S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
          //S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
          switch (s) {
            //case S_TAG:void();break;
            //case S_ATTR:void();break;
            //case S_ATTR_NOQUOT_VALUE:void();break;
            case S_ATTR_SPACE:
              var tagName = el.tagName;
              if (!NAMESPACE.isHTML(currentNSMap['']) || !attrName.match(/^(?:disabled|checked|selected)$/i)) {
                errorHandler.warning('attribute "' + attrName + '" missed value!! "' + attrName + '" instead2!!');
              }
              addAttribute(attrName, attrName, start);
              start = p;
              s = S_ATTR;
              break;
            case S_ATTR_END:
              errorHandler.warning('attribute space is required"' + attrName + '"!!');
            case S_TAG_SPACE:
              s = S_ATTR;
              start = p;
              break;
            case S_EQ:
              s = S_ATTR_NOQUOT_VALUE;
              start = p;
              break;
            case S_TAG_CLOSE:
              throw new Error("elements closed character '/' and '>' must be connected to");
          }
        }
    } //end outer switch
    //console.log('p++',p)
    p++;
  }
}
/**
 * @return true if has new namespace define
 */
function appendElement(el, domBuilder, currentNSMap) {
  var tagName = el.tagName;
  var localNSMap = null;
  //var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
  var i = el.length;
  while (i--) {
    var a = el[i];
    var qName = a.qName;
    var value = a.value;
    var nsp = qName.indexOf(':');
    if (nsp > 0) {
      var prefix = a.prefix = qName.slice(0, nsp);
      var localName = qName.slice(nsp + 1);
      var nsPrefix = prefix === 'xmlns' && localName;
    } else {
      localName = qName;
      prefix = null;
      nsPrefix = qName === 'xmlns' && '';
    }
    //can not set prefix,because prefix !== ''
    a.localName = localName;
    //prefix == null for no ns prefix attribute
    if (nsPrefix !== false) {
      //hack!!
      if (localNSMap == null) {
        localNSMap = {};
        //console.log(currentNSMap,0)
        _copy(currentNSMap, currentNSMap = {});
        //console.log(currentNSMap,1)
      }

      currentNSMap[nsPrefix] = localNSMap[nsPrefix] = value;
      a.uri = NAMESPACE.XMLNS;
      domBuilder.startPrefixMapping(nsPrefix, value);
    }
  }
  var i = el.length;
  while (i--) {
    a = el[i];
    var prefix = a.prefix;
    if (prefix) {
      //no prefix attribute has no namespace
      if (prefix === 'xml') {
        a.uri = NAMESPACE.XML;
      }
      if (prefix !== 'xmlns') {
        a.uri = currentNSMap[prefix || ''];

        //{console.log('###'+a.qName,domBuilder.locator.systemId+'',currentNSMap,a.uri)}
      }
    }
  }

  var nsp = tagName.indexOf(':');
  if (nsp > 0) {
    prefix = el.prefix = tagName.slice(0, nsp);
    localName = el.localName = tagName.slice(nsp + 1);
  } else {
    prefix = null; //important!!
    localName = el.localName = tagName;
  }
  //no prefix element has default namespace
  var ns = el.uri = currentNSMap[prefix || ''];
  domBuilder.startElement(ns, localName, tagName, el);
  //endPrefixMapping and startPrefixMapping have not any help for dom builder
  //localNSMap = null
  if (el.closed) {
    domBuilder.endElement(ns, localName, tagName);
    if (localNSMap) {
      for (prefix in localNSMap) {
        if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) {
          domBuilder.endPrefixMapping(prefix);
        }
      }
    }
  } else {
    el.currentNSMap = currentNSMap;
    el.localNSMap = localNSMap;
    //parseStack.push(el);
    return true;
  }
}
function parseHtmlSpecialContent(source, elStartEnd, tagName, entityReplacer, domBuilder) {
  if (/^(?:script|textarea)$/i.test(tagName)) {
    var elEndStart = source.indexOf('</' + tagName + '>', elStartEnd);
    var text = source.substring(elStartEnd + 1, elEndStart);
    if (/[&<]/.test(text)) {
      if (/^script$/i.test(tagName)) {
        //if(!/\]\]>/.test(text)){
        //lexHandler.startCDATA();
        domBuilder.characters(text, 0, text.length);
        //lexHandler.endCDATA();
        return elEndStart;
        //}
      } //}else{//text area
      text = text.replace(/&#?\w+;/g, entityReplacer);
      domBuilder.characters(text, 0, text.length);
      return elEndStart;
      //}
    }
  }

  return elStartEnd + 1;
}
function fixSelfClosed(source, elStartEnd, tagName, closeMap) {
  //if(tagName in closeMap){
  var pos = closeMap[tagName];
  if (pos == null) {
    //console.log(tagName)
    pos = source.lastIndexOf('</' + tagName + '>');
    if (pos < elStartEnd) {
      //忘记闭合
      pos = source.lastIndexOf('</' + tagName);
    }
    closeMap[tagName] = pos;
  }
  return pos < elStartEnd;
  //}
}

function _copy(source, target) {
  for (var n in source) {
    if (Object.prototype.hasOwnProperty.call(source, n)) {
      target[n] = source[n];
    }
  }
}
function parseDCC(source, start, domBuilder, errorHandler) {
  //sure start with '<!'
  var next = source.charAt(start + 2);
  switch (next) {
    case '-':
      if (source.charAt(start + 3) === '-') {
        var end = source.indexOf('-->', start + 4);
        //append comment source.substring(4,end)//<!--
        if (end > start) {
          domBuilder.comment(source, start + 4, end - start - 4);
          return end + 3;
        } else {
          errorHandler.error("Unclosed comment");
          return -1;
        }
      } else {
        //error
        return -1;
      }
    default:
      if (source.substr(start + 3, 6) == 'CDATA[') {
        var end = source.indexOf(']]>', start + 9);
        domBuilder.startCDATA();
        domBuilder.characters(source, start + 9, end - start - 9);
        domBuilder.endCDATA();
        return end + 3;
      }
      //<!DOCTYPE
      //startDTD(java.lang.String name, java.lang.String publicId, java.lang.String systemId)
      var matchs = split(source, start);
      var len = matchs.length;
      if (len > 1 && /!doctype/i.test(matchs[0][0])) {
        var name = matchs[1][0];
        var pubid = false;
        var sysid = false;
        if (len > 3) {
          if (/^public$/i.test(matchs[2][0])) {
            pubid = matchs[3][0];
            sysid = len > 4 && matchs[4][0];
          } else if (/^system$/i.test(matchs[2][0])) {
            sysid = matchs[3][0];
          }
        }
        var lastMatch = matchs[len - 1];
        domBuilder.startDTD(name, pubid, sysid);
        domBuilder.endDTD();
        return lastMatch.index + lastMatch[0].length;
      }
  }
  return -1;
}
function parseInstruction(source, start, domBuilder) {
  var end = source.indexOf('?>', start);
  if (end) {
    var match = source.substring(start, end).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
    if (match) {
      var len = match[0].length;
      domBuilder.processingInstruction(match[1], match[2]);
      return end + 2;
    } else {
      //error
      return -1;
    }
  }
  return -1;
}
function ElementAttributes() {
  this.attributeNames = {};
}
ElementAttributes.prototype = {
  setTagName: function setTagName(tagName) {
    if (!tagNamePattern.test(tagName)) {
      throw new Error('invalid tagName:' + tagName);
    }
    this.tagName = tagName;
  },
  addValue: function addValue(qName, value, offset) {
    if (!tagNamePattern.test(qName)) {
      throw new Error('invalid attribute:' + qName);
    }
    this.attributeNames[qName] = this.length;
    this[this.length++] = {
      qName: qName,
      value: value,
      offset: offset
    };
  },
  length: 0,
  getLocalName: function getLocalName(i) {
    return this[i].localName;
  },
  getLocator: function getLocator(i) {
    return this[i].locator;
  },
  getQName: function getQName(i) {
    return this[i].qName;
  },
  getURI: function getURI(i) {
    return this[i].uri;
  },
  getValue: function getValue(i) {
    return this[i].value;
  }
  //	,getIndex:function(uri, localName)){
  //		if(localName){
  //
  //		}else{
  //			var qName = uri
  //		}
  //	},
  //	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
  //	getType:function(uri,localName){}
  //	getType:function(i){},
};

function split(source, start) {
  var match;
  var buf = [];
  var reg = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
  reg.lastIndex = start;
  reg.exec(source); //skip <
  while (match = reg.exec(source)) {
    buf.push(match);
    if (match[1]) return buf;
  }
}
exports.XMLReader = XMLReader;
exports.ParseError = ParseError;

/***/ }),

/***/ 66488:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var callBound = __webpack_require__(73684);
var $byteLength = callBound('ArrayBuffer.prototype.byteLength', true);
var isArrayBuffer = __webpack_require__(14063);

/** @type {import('.')} */
module.exports = function byteLength(ab) {
  if (!isArrayBuffer(ab)) {
    return NaN;
  }
  return $byteLength ? $byteLength(ab) : ab.byteLength;
}; // in node < 0.11, byteLength is an own nonconfigurable property

/***/ }),

/***/ 65449:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;__webpack_require__(92222);
__webpack_require__(84633);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(39341);
__webpack_require__(73706);
__webpack_require__(10408);
__webpack_require__(39714);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(47941);
__webpack_require__(47042);
__webpack_require__(69600);
__webpack_require__(74916);
__webpack_require__(23123);
__webpack_require__(24603);
__webpack_require__(4723);
__webpack_require__(15306);
__webpack_require__(21249);
__webpack_require__(40561);
__webpack_require__(2707);
__webpack_require__(68309);
__webpack_require__(57327);
__webpack_require__(69826);
__webpack_require__(54747);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
(function (global, factory) {
  ( false ? 0 : _typeof(exports)) === 'object' && "object" !== 'undefined' ? factory(exports) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : 0;
})(this, function (exports) {
  'use strict';

  function slice(arrayLike, start) {
    start = start | 0;
    var newLen = Math.max(arrayLike.length - start, 0);
    var newArr = Array(newLen);
    for (var idx = 0; idx < newLen; idx++) {
      newArr[idx] = arrayLike[start + idx];
    }
    return newArr;
  }

  /**
   * Creates a continuation function with some arguments already applied.
   *
   * Useful as a shorthand when combined with other control flow functions. Any
   * arguments passed to the returned function are added to the arguments
   * originally passed to apply.
   *
   * @name apply
   * @static
   * @memberOf module:Utils
   * @method
   * @category Util
   * @param {Function} fn - The function you want to eventually apply all
   * arguments to. Invokes with (arguments...).
   * @param {...*} arguments... - Any number of arguments to automatically apply
   * when the continuation is called.
   * @returns {Function} the partially-applied function
   * @example
   *
   * // using apply
   * async.parallel([
   *     async.apply(fs.writeFile, 'testfile1', 'test1'),
   *     async.apply(fs.writeFile, 'testfile2', 'test2')
   * ]);
   *
   *
   * // the same process without using apply
   * async.parallel([
   *     function(callback) {
   *         fs.writeFile('testfile1', 'test1', callback);
   *     },
   *     function(callback) {
   *         fs.writeFile('testfile2', 'test2', callback);
   *     }
   * ]);
   *
   * // It's possible to pass any number of additional arguments when calling the
   * // continuation:
   *
   * node> var fn = async.apply(sys.puts, 'one');
   * node> fn('two', 'three');
   * one
   * two
   * three
   */
  var apply = function apply(fn /*, ...args*/) {
    var args = slice(arguments, 1);
    return function /*callArgs*/
    () {
      var callArgs = slice(arguments);
      return fn.apply(null, args.concat(callArgs));
    };
  };
  var initialParams = function initialParams(fn) {
    return function /*...args, callback*/
    () {
      var args = slice(arguments);
      var callback = args.pop();
      fn.call(this, args, callback);
    };
  };

  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */
  function isObject(value) {
    var type = _typeof(value);
    return value != null && (type == 'object' || type == 'function');
  }
  var hasSetImmediate = typeof setImmediate === 'function' && setImmediate;
  var hasNextTick = (typeof process === "undefined" ? "undefined" : _typeof(process)) === 'object' && typeof process.nextTick === 'function';
  function fallback(fn) {
    setTimeout(fn, 0);
  }
  function wrap(defer) {
    return function (fn /*, ...args*/) {
      var args = slice(arguments, 1);
      defer(function () {
        fn.apply(null, args);
      });
    };
  }
  var _defer;
  if (hasSetImmediate) {
    _defer = setImmediate;
  } else if (hasNextTick) {
    _defer = process.nextTick;
  } else {
    _defer = fallback;
  }
  var setImmediate$1 = wrap(_defer);

  /**
   * Take a sync function and make it async, passing its return value to a
   * callback. This is useful for plugging sync functions into a waterfall,
   * series, or other async functions. Any arguments passed to the generated
   * function will be passed to the wrapped function (except for the final
   * callback argument). Errors thrown will be passed to the callback.
   *
   * If the function passed to `asyncify` returns a Promise, that promises's
   * resolved/rejected state will be used to call the callback, rather than simply
   * the synchronous return value.
   *
   * This also means you can asyncify ES2017 `async` functions.
   *
   * @name asyncify
   * @static
   * @memberOf module:Utils
   * @method
   * @alias wrapSync
   * @category Util
   * @param {Function} func - The synchronous function, or Promise-returning
   * function to convert to an {@link AsyncFunction}.
   * @returns {AsyncFunction} An asynchronous wrapper of the `func`. To be
   * invoked with `(args..., callback)`.
   * @example
   *
   * // passing a regular synchronous function
   * async.waterfall([
   *     async.apply(fs.readFile, filename, "utf8"),
   *     async.asyncify(JSON.parse),
   *     function (data, next) {
   *         // data is the result of parsing the text.
   *         // If there was a parsing error, it would have been caught.
   *     }
   * ], callback);
   *
   * // passing a function returning a promise
   * async.waterfall([
   *     async.apply(fs.readFile, filename, "utf8"),
   *     async.asyncify(function (contents) {
   *         return db.model.create(contents);
   *     }),
   *     function (model, next) {
   *         // `model` is the instantiated model object.
   *         // If there was an error, this function would be skipped.
   *     }
   * ], callback);
   *
   * // es2017 example, though `asyncify` is not needed if your JS environment
   * // supports async functions out of the box
   * var q = async.queue(async.asyncify(async function(file) {
   *     var intermediateStep = await processFile(file);
   *     return await somePromise(intermediateStep)
   * }));
   *
   * q.push(files);
   */
  function asyncify(func) {
    return initialParams(function (args, callback) {
      var result;
      try {
        result = func.apply(this, args);
      } catch (e) {
        return callback(e);
      }
      // if result is Promise object
      if (isObject(result) && typeof result.then === 'function') {
        result.then(function (value) {
          invokeCallback(callback, null, value);
        }, function (err) {
          invokeCallback(callback, err.message ? err : new Error(err));
        });
      } else {
        callback(null, result);
      }
    });
  }
  function invokeCallback(callback, error, value) {
    try {
      callback(error, value);
    } catch (e) {
      setImmediate$1(rethrow, e);
    }
  }
  function rethrow(error) {
    throw error;
  }
  var supportsSymbol = typeof Symbol === 'function';
  function isAsync(fn) {
    return supportsSymbol && fn[Symbol.toStringTag] === 'AsyncFunction';
  }
  function wrapAsync(asyncFn) {
    return isAsync(asyncFn) ? asyncify(asyncFn) : asyncFn;
  }
  function applyEach$1(eachfn) {
    return function (fns /*, ...args*/) {
      var args = slice(arguments, 1);
      var go = initialParams(function (args, callback) {
        var that = this;
        return eachfn(fns, function (fn, cb) {
          wrapAsync(fn).apply(that, args.concat(cb));
        }, callback);
      });
      if (args.length) {
        return go.apply(this, args);
      } else {
        return go;
      }
    };
  }

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = (typeof __webpack_require__.g === "undefined" ? "undefined" : _typeof(__webpack_require__.g)) == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Built-in value references. */
  var Symbol$1 = root.Symbol;

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString = objectProto.toString;

  /** Built-in value references. */
  var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : undefined;

  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */
  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];
    try {
      value[symToStringTag$1] = undefined;
      var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag$1] = tag;
      } else {
        delete value[symToStringTag$1];
      }
    }
    return result;
  }

  /** Used for built-in method references. */
  var objectProto$1 = Object.prototype;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString$1 = objectProto$1.toString;

  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */
  function objectToString(value) {
    return nativeObjectToString$1.call(value);
  }

  /** `Object#toString` result references. */
  var nullTag = '[object Null]';
  var undefinedTag = '[object Undefined]';

  /** Built-in value references. */
  var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;

  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  function baseGetTag(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
  }

  /** `Object#toString` result references. */
  var asyncTag = '[object AsyncFunction]';
  var funcTag = '[object Function]';
  var genTag = '[object GeneratorFunction]';
  var proxyTag = '[object Proxy]';

  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */
  function isFunction(value) {
    if (!isObject(value)) {
      return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }

  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER = 9007199254740991;

  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */
  function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }

  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */
  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }

  // A temporary value used to identify if the loop should be broken.
  // See #1064, #1293
  var breakLoop = {};

  /**
   * This method returns `undefined`.
   *
   * @static
   * @memberOf _
   * @since 2.3.0
   * @category Util
   * @example
   *
   * _.times(2, _.noop);
   * // => [undefined, undefined]
   */
  function noop() {
    // No operation performed.
  }
  function once(fn) {
    return function () {
      if (fn === null) return;
      var callFn = fn;
      fn = null;
      callFn.apply(this, arguments);
    };
  }
  var iteratorSymbol = typeof Symbol === 'function' && Symbol.iterator;
  var getIterator = function getIterator(coll) {
    return iteratorSymbol && coll[iteratorSymbol] && coll[iteratorSymbol]();
  };

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
      result = Array(n);
    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike(value) {
    return value != null && _typeof(value) == 'object';
  }

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]';

  /**
   * The base implementation of `_.isArguments`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   */
  function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
  }

  /** Used for built-in method references. */
  var objectProto$3 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

  /** Built-in value references. */
  var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;

  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */
  var isArguments = baseIsArguments(function () {
    return arguments;
  }()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty$2.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
  };

  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */
  var isArray = Array.isArray;

  /**
   * This method returns `false`.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {boolean} Returns `false`.
   * @example
   *
   * _.times(2, _.stubFalse);
   * // => [false, false]
   */
  function stubFalse() {
    return false;
  }

  /** Detect free variable `exports`. */
  var freeExports = _typeof(exports) == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && ( false ? 0 : _typeof(module)) == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Built-in value references. */
  var Buffer = moduleExports ? root.Buffer : undefined;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */
  var isBuffer = nativeIsBuffer || stubFalse;

  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER$1 = 9007199254740991;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */
  function isIndex(value, length) {
    var type = _typeof(value);
    length = length == null ? MAX_SAFE_INTEGER$1 : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
  }

  /** `Object#toString` result references. */
  var argsTag$1 = '[object Arguments]';
  var arrayTag = '[object Array]';
  var boolTag = '[object Boolean]';
  var dateTag = '[object Date]';
  var errorTag = '[object Error]';
  var funcTag$1 = '[object Function]';
  var mapTag = '[object Map]';
  var numberTag = '[object Number]';
  var objectTag = '[object Object]';
  var regexpTag = '[object RegExp]';
  var setTag = '[object Set]';
  var stringTag = '[object String]';
  var weakMapTag = '[object WeakMap]';
  var arrayBufferTag = '[object ArrayBuffer]';
  var dataViewTag = '[object DataView]';
  var float32Tag = '[object Float32Array]';
  var float64Tag = '[object Float64Array]';
  var int8Tag = '[object Int8Array]';
  var int16Tag = '[object Int16Array]';
  var int32Tag = '[object Int32Array]';
  var uint8Tag = '[object Uint8Array]';
  var uint8ClampedTag = '[object Uint8ClampedArray]';
  var uint16Tag = '[object Uint16Array]';
  var uint32Tag = '[object Uint32Array]';

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

  /**
   * The base implementation of `_.isTypedArray` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   */
  function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function (value) {
      return func(value);
    };
  }

  /** Detect free variable `exports`. */
  var freeExports$1 = _typeof(exports) == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule$1 = freeExports$1 && ( false ? 0 : _typeof(module)) == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports$1 && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = function () {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;
      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }();

  /* Node.js helper references. */
  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /**
   * Checks if `value` is classified as a typed array.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   * @example
   *
   * _.isTypedArray(new Uint8Array);
   * // => true
   *
   * _.isTypedArray([]);
   * // => false
   */
  var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

  /** Used for built-in method references. */
  var objectProto$2 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

  /**
   * Creates an array of the enumerable property names of the array-like `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @param {boolean} inherited Specify returning inherited property names.
   * @returns {Array} Returns the array of property names.
   */
  function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;
    for (var key in value) {
      if ((inherited || hasOwnProperty$1.call(value, key)) && !(skipIndexes && (
      // Safari 9 has enumerable `arguments.length` in strict mode.
      key == 'length' || isBuff && (key == 'offset' || key == 'parent') || isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
      // Skip index properties.
      isIndex(key, length)))) {
        result.push(key);
      }
    }
    return result;
  }

  /** Used for built-in method references. */
  var objectProto$5 = Object.prototype;

  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */
  function isPrototype(value) {
    var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$5;
    return value === proto;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function (arg) {
      return func(transform(arg));
    };
  }

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeKeys = overArg(Object.keys, Object);

  /** Used for built-in method references. */
  var objectProto$4 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

  /**
   * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function baseKeys(object) {
    if (!isPrototype(object)) {
      return nativeKeys(object);
    }
    var result = [];
    for (var key in Object(object)) {
      if (hasOwnProperty$3.call(object, key) && key != 'constructor') {
        result.push(key);
      }
    }
    return result;
  }

  /**
   * Creates an array of the own enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects. See the
   * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * for more details.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keys(new Foo);
   * // => ['a', 'b'] (iteration order is not guaranteed)
   *
   * _.keys('hi');
   * // => ['0', '1']
   */
  function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
  }
  function createArrayIterator(coll) {
    var i = -1;
    var len = coll.length;
    return function next() {
      return ++i < len ? {
        value: coll[i],
        key: i
      } : null;
    };
  }
  function createES2015Iterator(iterator) {
    var i = -1;
    return function next() {
      var item = iterator.next();
      if (item.done) return null;
      i++;
      return {
        value: item.value,
        key: i
      };
    };
  }
  function createObjectIterator(obj) {
    var okeys = keys(obj);
    var i = -1;
    var len = okeys.length;
    return function next() {
      var key = okeys[++i];
      return i < len ? {
        value: obj[key],
        key: key
      } : null;
    };
  }
  function iterator(coll) {
    if (isArrayLike(coll)) {
      return createArrayIterator(coll);
    }
    var iterator = getIterator(coll);
    return iterator ? createES2015Iterator(iterator) : createObjectIterator(coll);
  }
  function onlyOnce(fn) {
    return function () {
      if (fn === null) throw new Error("Callback was already called.");
      var callFn = fn;
      fn = null;
      callFn.apply(this, arguments);
    };
  }
  function _eachOfLimit(limit) {
    return function (obj, iteratee, callback) {
      callback = once(callback || noop);
      if (limit <= 0 || !obj) {
        return callback(null);
      }
      var nextElem = iterator(obj);
      var done = false;
      var running = 0;
      var looping = false;
      function iterateeCallback(err, value) {
        running -= 1;
        if (err) {
          done = true;
          callback(err);
        } else if (value === breakLoop || done && running <= 0) {
          done = true;
          return callback(null);
        } else if (!looping) {
          replenish();
        }
      }
      function replenish() {
        looping = true;
        while (running < limit && !done) {
          var elem = nextElem();
          if (elem === null) {
            done = true;
            if (running <= 0) {
              callback(null);
            }
            return;
          }
          running += 1;
          iteratee(elem.value, elem.key, onlyOnce(iterateeCallback));
        }
        looping = false;
      }
      replenish();
    };
  }

  /**
   * The same as [`eachOf`]{@link module:Collections.eachOf} but runs a maximum of `limit` async operations at a
   * time.
   *
   * @name eachOfLimit
   * @static
   * @memberOf module:Collections
   * @method
   * @see [async.eachOf]{@link module:Collections.eachOf}
   * @alias forEachOfLimit
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {number} limit - The maximum number of async operations at a time.
   * @param {AsyncFunction} iteratee - An async function to apply to each
   * item in `coll`. The `key` is the item's key, or index in the case of an
   * array.
   * Invoked with (item, key, callback).
   * @param {Function} [callback] - A callback which is called when all
   * `iteratee` functions have finished, or an error occurs. Invoked with (err).
   */
  function eachOfLimit(coll, limit, iteratee, callback) {
    _eachOfLimit(limit)(coll, wrapAsync(iteratee), callback);
  }
  function doLimit(fn, limit) {
    return function (iterable, iteratee, callback) {
      return fn(iterable, limit, iteratee, callback);
    };
  }

  // eachOf implementation optimized for array-likes
  function eachOfArrayLike(coll, iteratee, callback) {
    callback = once(callback || noop);
    var index = 0,
      completed = 0,
      length = coll.length;
    if (length === 0) {
      callback(null);
    }
    function iteratorCallback(err, value) {
      if (err) {
        callback(err);
      } else if (++completed === length || value === breakLoop) {
        callback(null);
      }
    }
    for (; index < length; index++) {
      iteratee(coll[index], index, onlyOnce(iteratorCallback));
    }
  }

  // a generic version of eachOf which can handle array, object, and iterator cases.
  var eachOfGeneric = doLimit(eachOfLimit, Infinity);

  /**
   * Like [`each`]{@link module:Collections.each}, except that it passes the key (or index) as the second argument
   * to the iteratee.
   *
   * @name eachOf
   * @static
   * @memberOf module:Collections
   * @method
   * @alias forEachOf
   * @category Collection
   * @see [async.each]{@link module:Collections.each}
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {AsyncFunction} iteratee - A function to apply to each
   * item in `coll`.
   * The `key` is the item's key, or index in the case of an array.
   * Invoked with (item, key, callback).
   * @param {Function} [callback] - A callback which is called when all
   * `iteratee` functions have finished, or an error occurs. Invoked with (err).
   * @example
   *
   * var obj = {dev: "/dev.json", test: "/test.json", prod: "/prod.json"};
   * var configs = {};
   *
   * async.forEachOf(obj, function (value, key, callback) {
   *     fs.readFile(__dirname + value, "utf8", function (err, data) {
   *         if (err) return callback(err);
   *         try {
   *             configs[key] = JSON.parse(data);
   *         } catch (e) {
   *             return callback(e);
   *         }
   *         callback();
   *     });
   * }, function (err) {
   *     if (err) console.error(err.message);
   *     // configs is now a map of JSON data
   *     doSomethingWith(configs);
   * });
   */
  var eachOf = function eachOf(coll, iteratee, callback) {
    var eachOfImplementation = isArrayLike(coll) ? eachOfArrayLike : eachOfGeneric;
    eachOfImplementation(coll, wrapAsync(iteratee), callback);
  };
  function doParallel(fn) {
    return function (obj, iteratee, callback) {
      return fn(eachOf, obj, wrapAsync(iteratee), callback);
    };
  }
  function _asyncMap(eachfn, arr, iteratee, callback) {
    callback = callback || noop;
    arr = arr || [];
    var results = [];
    var counter = 0;
    var _iteratee = wrapAsync(iteratee);
    eachfn(arr, function (value, _, callback) {
      var index = counter++;
      _iteratee(value, function (err, v) {
        results[index] = v;
        callback(err);
      });
    }, function (err) {
      callback(err, results);
    });
  }

  /**
   * Produces a new collection of values by mapping each value in `coll` through
   * the `iteratee` function. The `iteratee` is called with an item from `coll`
   * and a callback for when it has finished processing. Each of these callback
   * takes 2 arguments: an `error`, and the transformed item from `coll`. If
   * `iteratee` passes an error to its callback, the main `callback` (for the
   * `map` function) is immediately called with the error.
   *
   * Note, that since this function applies the `iteratee` to each item in
   * parallel, there is no guarantee that the `iteratee` functions will complete
   * in order. However, the results array will be in the same order as the
   * original `coll`.
   *
   * If `map` is passed an Object, the results will be an Array.  The results
   * will roughly be in the order of the original Objects' keys (but this can
   * vary across JavaScript engines).
   *
   * @name map
   * @static
   * @memberOf module:Collections
   * @method
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {AsyncFunction} iteratee - An async function to apply to each item in
   * `coll`.
   * The iteratee should complete with the transformed item.
   * Invoked with (item, callback).
   * @param {Function} [callback] - A callback which is called when all `iteratee`
   * functions have finished, or an error occurs. Results is an Array of the
   * transformed items from the `coll`. Invoked with (err, results).
   * @example
   *
   * async.map(['file1','file2','file3'], fs.stat, function(err, results) {
   *     // results is now an array of stats for each file
   * });
   */
  var map = doParallel(_asyncMap);

  /**
   * Applies the provided arguments to each function in the array, calling
   * `callback` after all functions have completed. If you only provide the first
   * argument, `fns`, then it will return a function which lets you pass in the
   * arguments as if it were a single function call. If more arguments are
   * provided, `callback` is required while `args` is still optional.
   *
   * @name applyEach
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @category Control Flow
   * @param {Array|Iterable|Object} fns - A collection of {@link AsyncFunction}s
   * to all call with the same arguments
   * @param {...*} [args] - any number of separate arguments to pass to the
   * function.
   * @param {Function} [callback] - the final argument should be the callback,
   * called when all functions have completed processing.
   * @returns {Function} - If only the first argument, `fns`, is provided, it will
   * return a function which lets you pass in the arguments as if it were a single
   * function call. The signature is `(..args, callback)`. If invoked with any
   * arguments, `callback` is required.
   * @example
   *
   * async.applyEach([enableSearch, updateSchema], 'bucket', callback);
   *
   * // partial application example:
   * async.each(
   *     buckets,
   *     async.applyEach([enableSearch, updateSchema]),
   *     callback
   * );
   */
  var applyEach = applyEach$1(map);
  function doParallelLimit(fn) {
    return function (obj, limit, iteratee, callback) {
      return fn(_eachOfLimit(limit), obj, wrapAsync(iteratee), callback);
    };
  }

  /**
   * The same as [`map`]{@link module:Collections.map} but runs a maximum of `limit` async operations at a time.
   *
   * @name mapLimit
   * @static
   * @memberOf module:Collections
   * @method
   * @see [async.map]{@link module:Collections.map}
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {number} limit - The maximum number of async operations at a time.
   * @param {AsyncFunction} iteratee - An async function to apply to each item in
   * `coll`.
   * The iteratee should complete with the transformed item.
   * Invoked with (item, callback).
   * @param {Function} [callback] - A callback which is called when all `iteratee`
   * functions have finished, or an error occurs. Results is an array of the
   * transformed items from the `coll`. Invoked with (err, results).
   */
  var mapLimit = doParallelLimit(_asyncMap);

  /**
   * The same as [`map`]{@link module:Collections.map} but runs only a single async operation at a time.
   *
   * @name mapSeries
   * @static
   * @memberOf module:Collections
   * @method
   * @see [async.map]{@link module:Collections.map}
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {AsyncFunction} iteratee - An async function to apply to each item in
   * `coll`.
   * The iteratee should complete with the transformed item.
   * Invoked with (item, callback).
   * @param {Function} [callback] - A callback which is called when all `iteratee`
   * functions have finished, or an error occurs. Results is an array of the
   * transformed items from the `coll`. Invoked with (err, results).
   */
  var mapSeries = doLimit(mapLimit, 1);

  /**
   * The same as [`applyEach`]{@link module:ControlFlow.applyEach} but runs only a single async operation at a time.
   *
   * @name applyEachSeries
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @see [async.applyEach]{@link module:ControlFlow.applyEach}
   * @category Control Flow
   * @param {Array|Iterable|Object} fns - A collection of {@link AsyncFunction}s to all
   * call with the same arguments
   * @param {...*} [args] - any number of separate arguments to pass to the
   * function.
   * @param {Function} [callback] - the final argument should be the callback,
   * called when all functions have completed processing.
   * @returns {Function} - If only the first argument is provided, it will return
   * a function which lets you pass in the arguments as if it were a single
   * function call.
   */
  var applyEachSeries = applyEach$1(mapSeries);

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
      length = array == null ? 0 : array.length;
    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * Creates a base function for methods like `_.forIn` and `_.forOwn`.
   *
   * @private
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Function} Returns the new base function.
   */
  function createBaseFor(fromRight) {
    return function (object, iteratee, keysFunc) {
      var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;
      while (length--) {
        var key = props[fromRight ? length : ++index];
        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }
      return object;
    };
  }

  /**
   * The base implementation of `baseForOwn` which iterates over `object`
   * properties returned by `keysFunc` and invokes `iteratee` for each property.
   * Iteratee functions may exit iteration early by explicitly returning `false`.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @returns {Object} Returns `object`.
   */
  var baseFor = createBaseFor();

  /**
   * The base implementation of `_.forOwn` without support for iteratee shorthands.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Object} Returns `object`.
   */
  function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);
    while (fromRight ? index-- : ++index < length) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
      length = array.length;
    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * Determines the best order for running the {@link AsyncFunction}s in `tasks`, based on
   * their requirements. Each function can optionally depend on other functions
   * being completed first, and each function is run as soon as its requirements
   * are satisfied.
   *
   * If any of the {@link AsyncFunction}s pass an error to their callback, the `auto` sequence
   * will stop. Further tasks will not execute (so any other functions depending
   * on it will not run), and the main `callback` is immediately called with the
   * error.
   *
   * {@link AsyncFunction}s also receive an object containing the results of functions which
   * have completed so far as the first argument, if they have dependencies. If a
   * task function has no dependencies, it will only be passed a callback.
   *
   * @name auto
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @category Control Flow
   * @param {Object} tasks - An object. Each of its properties is either a
   * function or an array of requirements, with the {@link AsyncFunction} itself the last item
   * in the array. The object's key of a property serves as the name of the task
   * defined by that property, i.e. can be used when specifying requirements for
   * other tasks. The function receives one or two arguments:
   * * a `results` object, containing the results of the previously executed
   *   functions, only passed if the task has any dependencies,
   * * a `callback(err, result)` function, which must be called when finished,
   *   passing an `error` (which can be `null`) and the result of the function's
   *   execution.
   * @param {number} [concurrency=Infinity] - An optional `integer` for
   * determining the maximum number of tasks that can be run in parallel. By
   * default, as many as possible.
   * @param {Function} [callback] - An optional callback which is called when all
   * the tasks have been completed. It receives the `err` argument if any `tasks`
   * pass an error to their callback. Results are always returned; however, if an
   * error occurs, no further `tasks` will be performed, and the results object
   * will only contain partial results. Invoked with (err, results).
   * @returns undefined
   * @example
   *
   * async.auto({
   *     // this function will just be passed a callback
   *     readData: async.apply(fs.readFile, 'data.txt', 'utf-8'),
   *     showData: ['readData', function(results, cb) {
   *         // results.readData is the file's contents
   *         // ...
   *     }]
   * }, callback);
   *
   * async.auto({
   *     get_data: function(callback) {
   *         console.log('in get_data');
   *         // async code to get some data
   *         callback(null, 'data', 'converted to array');
   *     },
   *     make_folder: function(callback) {
   *         console.log('in make_folder');
   *         // async code to create a directory to store a file in
   *         // this is run at the same time as getting the data
   *         callback(null, 'folder');
   *     },
   *     write_file: ['get_data', 'make_folder', function(results, callback) {
   *         console.log('in write_file', JSON.stringify(results));
   *         // once there is some data and the directory exists,
   *         // write the data to a file in the directory
   *         callback(null, 'filename');
   *     }],
   *     email_link: ['write_file', function(results, callback) {
   *         console.log('in email_link', JSON.stringify(results));
   *         // once the file is written let's email a link to it...
   *         // results.write_file contains the filename returned by write_file.
   *         callback(null, {'file':results.write_file, 'email':'user@example.com'});
   *     }]
   * }, function(err, results) {
   *     console.log('err = ', err);
   *     console.log('results = ', results);
   * });
   */
  var auto = function auto(tasks, concurrency, callback) {
    if (typeof concurrency === 'function') {
      // concurrency is optional, shift the args.
      callback = concurrency;
      concurrency = null;
    }
    callback = once(callback || noop);
    var keys$$1 = keys(tasks);
    var numTasks = keys$$1.length;
    if (!numTasks) {
      return callback(null);
    }
    if (!concurrency) {
      concurrency = numTasks;
    }
    var results = {};
    var runningTasks = 0;
    var hasError = false;
    var listeners = Object.create(null);
    var readyTasks = [];

    // for cycle detection:
    var readyToCheck = []; // tasks that have been identified as reachable
    // without the possibility of returning to an ancestor task
    var uncheckedDependencies = {};
    baseForOwn(tasks, function (task, key) {
      if (!isArray(task)) {
        // no dependencies
        enqueueTask(key, [task]);
        readyToCheck.push(key);
        return;
      }
      var dependencies = task.slice(0, task.length - 1);
      var remainingDependencies = dependencies.length;
      if (remainingDependencies === 0) {
        enqueueTask(key, task);
        readyToCheck.push(key);
        return;
      }
      uncheckedDependencies[key] = remainingDependencies;
      arrayEach(dependencies, function (dependencyName) {
        if (!tasks[dependencyName]) {
          throw new Error('async.auto task `' + key + '` has a non-existent dependency `' + dependencyName + '` in ' + dependencies.join(', '));
        }
        addListener(dependencyName, function () {
          remainingDependencies--;
          if (remainingDependencies === 0) {
            enqueueTask(key, task);
          }
        });
      });
    });
    checkForDeadlocks();
    processQueue();
    function enqueueTask(key, task) {
      readyTasks.push(function () {
        runTask(key, task);
      });
    }
    function processQueue() {
      if (readyTasks.length === 0 && runningTasks === 0) {
        return callback(null, results);
      }
      while (readyTasks.length && runningTasks < concurrency) {
        var run = readyTasks.shift();
        run();
      }
    }
    function addListener(taskName, fn) {
      var taskListeners = listeners[taskName];
      if (!taskListeners) {
        taskListeners = listeners[taskName] = [];
      }
      taskListeners.push(fn);
    }
    function taskComplete(taskName) {
      var taskListeners = listeners[taskName] || [];
      arrayEach(taskListeners, function (fn) {
        fn();
      });
      processQueue();
    }
    function runTask(key, task) {
      if (hasError) return;
      var taskCallback = onlyOnce(function (err, result) {
        runningTasks--;
        if (arguments.length > 2) {
          result = slice(arguments, 1);
        }
        if (err) {
          var safeResults = {};
          baseForOwn(results, function (val, rkey) {
            safeResults[rkey] = val;
          });
          safeResults[key] = result;
          hasError = true;
          listeners = Object.create(null);
          callback(err, safeResults);
        } else {
          results[key] = result;
          taskComplete(key);
        }
      });
      runningTasks++;
      var taskFn = wrapAsync(task[task.length - 1]);
      if (task.length > 1) {
        taskFn(results, taskCallback);
      } else {
        taskFn(taskCallback);
      }
    }
    function checkForDeadlocks() {
      // Kahn's algorithm
      // https://en.wikipedia.org/wiki/Topological_sorting#Kahn.27s_algorithm
      // http://connalle.blogspot.com/2013/10/topological-sortingkahn-algorithm.html
      var currentTask;
      var counter = 0;
      while (readyToCheck.length) {
        currentTask = readyToCheck.pop();
        counter++;
        arrayEach(getDependents(currentTask), function (dependent) {
          if (--uncheckedDependencies[dependent] === 0) {
            readyToCheck.push(dependent);
          }
        });
      }
      if (counter !== numTasks) {
        throw new Error('async.auto cannot execute tasks due to a recursive dependency');
      }
    }
    function getDependents(taskName) {
      var result = [];
      baseForOwn(tasks, function (task, key) {
        if (isArray(task) && baseIndexOf(task, taskName, 0) >= 0) {
          result.push(key);
        }
      });
      return result;
    }
  };

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);
    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /** `Object#toString` result references. */
  var symbolTag = '[object Symbol]';

  /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */
  function isSymbol(value) {
    return _typeof(value) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
  }

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0;

  /** Used to convert symbols to primitives and strings. */
  var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined;
  var symbolToString = symbolProto ? symbolProto.toString : undefined;

  /**
   * The base implementation of `_.toString` which doesn't convert nullish
   * values to empty strings.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') {
      return value;
    }
    if (isArray(value)) {
      // Recursively convert values (susceptible to call stack limits).
      return arrayMap(value, baseToString) + '';
    }
    if (isSymbol(value)) {
      return symbolToString ? symbolToString.call(value) : '';
    }
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
  }

  /**
   * The base implementation of `_.slice` without an iteratee call guard.
   *
   * @private
   * @param {Array} array The array to slice.
   * @param {number} [start=0] The start position.
   * @param {number} [end=array.length] The end position.
   * @returns {Array} Returns the slice of `array`.
   */
  function baseSlice(array, start, end) {
    var index = -1,
      length = array.length;
    if (start < 0) {
      start = -start > length ? 0 : length + start;
    }
    end = end > length ? length : end;
    if (end < 0) {
      end += length;
    }
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while (++index < length) {
      result[index] = array[index + start];
    }
    return result;
  }

  /**
   * Casts `array` to a slice if it's needed.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {number} start The start position.
   * @param {number} [end=array.length] The end position.
   * @returns {Array} Returns the cast slice.
   */
  function castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : baseSlice(array, start, end);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
      length = strSymbols.length;
    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /** Used to compose unicode character classes. */
  var rsAstralRange = "\\ud800-\\udfff";
  var rsComboMarksRange = "\\u0300-\\u036f";
  var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
  var rsComboSymbolsRange = "\\u20d0-\\u20ff";
  var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
  var rsVarRange = "\\ufe0e\\ufe0f";

  /** Used to compose unicode capture groups. */
  var rsZWJ = "\\u200d";

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /** Used to compose unicode character classes. */
  var rsAstralRange$1 = "\\ud800-\\udfff";
  var rsComboMarksRange$1 = "\\u0300-\\u036f";
  var reComboHalfMarksRange$1 = "\\ufe20-\\ufe2f";
  var rsComboSymbolsRange$1 = "\\u20d0-\\u20ff";
  var rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1;
  var rsVarRange$1 = "\\ufe0e\\ufe0f";

  /** Used to compose unicode capture groups. */
  var rsAstral = '[' + rsAstralRange$1 + ']';
  var rsCombo = '[' + rsComboRange$1 + ']';
  var rsFitz = "\\ud83c[\\udffb-\\udfff]";
  var rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')';
  var rsNonAstral = '[^' + rsAstralRange$1 + ']';
  var rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}";
  var rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]";
  var rsZWJ$1 = "\\u200d";

  /** Used to compose unicode regexes. */
  var reOptMod = rsModifier + '?';
  var rsOptVar = '[' + rsVarRange$1 + ']?';
  var rsOptJoin = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*';
  var rsSeq = rsOptVar + reOptMod + rsOptJoin;
  var rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
  }

  /**
   * Converts `value` to a string. An empty string is returned for `null`
   * and `undefined` values. The sign of `-0` is preserved.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   * @example
   *
   * _.toString(null);
   * // => ''
   *
   * _.toString(-0);
   * // => '-0'
   *
   * _.toString([1, 2, 3]);
   * // => '1,2,3'
   */
  function toString(value) {
    return value == null ? '' : baseToString(value);
  }

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g;

  /**
   * Removes leading and trailing whitespace or specified characters from `string`.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category String
   * @param {string} [string=''] The string to trim.
   * @param {string} [chars=whitespace] The characters to trim.
   * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
   * @returns {string} Returns the trimmed string.
   * @example
   *
   * _.trim('  abc  ');
   * // => 'abc'
   *
   * _.trim('-_-abc-_-', '_-');
   * // => 'abc'
   *
   * _.map(['  foo  ', '  bar  '], _.trim);
   * // => ['foo', 'bar']
   */
  function trim(string, chars, guard) {
    string = toString(string);
    if (string && (guard || chars === undefined)) {
      return string.replace(reTrim, '');
    }
    if (!string || !(chars = baseToString(chars))) {
      return string;
    }
    var strSymbols = stringToArray(string),
      chrSymbols = stringToArray(chars),
      start = charsStartIndex(strSymbols, chrSymbols),
      end = charsEndIndex(strSymbols, chrSymbols) + 1;
    return castSlice(strSymbols, start, end).join('');
  }
  var FN_ARGS = /^(?:async\s+)?(function)?\s*[^\(]*\(\s*([^\)]*)\)/m;
  var FN_ARG_SPLIT = /,/;
  var FN_ARG = /(=.+)?(\s*)$/;
  var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
  function parseParams(func) {
    func = func.toString().replace(STRIP_COMMENTS, '');
    func = func.match(FN_ARGS)[2].replace(' ', '');
    func = func ? func.split(FN_ARG_SPLIT) : [];
    func = func.map(function (arg) {
      return trim(arg.replace(FN_ARG, ''));
    });
    return func;
  }

  /**
   * A dependency-injected version of the [async.auto]{@link module:ControlFlow.auto} function. Dependent
   * tasks are specified as parameters to the function, after the usual callback
   * parameter, with the parameter names matching the names of the tasks it
   * depends on. This can provide even more readable task graphs which can be
   * easier to maintain.
   *
   * If a final callback is specified, the task results are similarly injected,
   * specified as named parameters after the initial error parameter.
   *
   * The autoInject function is purely syntactic sugar and its semantics are
   * otherwise equivalent to [async.auto]{@link module:ControlFlow.auto}.
   *
   * @name autoInject
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @see [async.auto]{@link module:ControlFlow.auto}
   * @category Control Flow
   * @param {Object} tasks - An object, each of whose properties is an {@link AsyncFunction} of
   * the form 'func([dependencies...], callback). The object's key of a property
   * serves as the name of the task defined by that property, i.e. can be used
   * when specifying requirements for other tasks.
   * * The `callback` parameter is a `callback(err, result)` which must be called
   *   when finished, passing an `error` (which can be `null`) and the result of
   *   the function's execution. The remaining parameters name other tasks on
   *   which the task is dependent, and the results from those tasks are the
   *   arguments of those parameters.
   * @param {Function} [callback] - An optional callback which is called when all
   * the tasks have been completed. It receives the `err` argument if any `tasks`
   * pass an error to their callback, and a `results` object with any completed
   * task results, similar to `auto`.
   * @example
   *
   * //  The example from `auto` can be rewritten as follows:
   * async.autoInject({
   *     get_data: function(callback) {
   *         // async code to get some data
   *         callback(null, 'data', 'converted to array');
   *     },
   *     make_folder: function(callback) {
   *         // async code to create a directory to store a file in
   *         // this is run at the same time as getting the data
   *         callback(null, 'folder');
   *     },
   *     write_file: function(get_data, make_folder, callback) {
   *         // once there is some data and the directory exists,
   *         // write the data to a file in the directory
   *         callback(null, 'filename');
   *     },
   *     email_link: function(write_file, callback) {
   *         // once the file is written let's email a link to it...
   *         // write_file contains the filename returned by write_file.
   *         callback(null, {'file':write_file, 'email':'user@example.com'});
   *     }
   * }, function(err, results) {
   *     console.log('err = ', err);
   *     console.log('email_link = ', results.email_link);
   * });
   *
   * // If you are using a JS minifier that mangles parameter names, `autoInject`
   * // will not work with plain functions, since the parameter names will be
   * // collapsed to a single letter identifier.  To work around this, you can
   * // explicitly specify the names of the parameters your task function needs
   * // in an array, similar to Angular.js dependency injection.
   *
   * // This still has an advantage over plain `auto`, since the results a task
   * // depends on are still spread into arguments.
   * async.autoInject({
   *     //...
   *     write_file: ['get_data', 'make_folder', function(get_data, make_folder, callback) {
   *         callback(null, 'filename');
   *     }],
   *     email_link: ['write_file', function(write_file, callback) {
   *         callback(null, {'file':write_file, 'email':'user@example.com'});
   *     }]
   *     //...
   * }, function(err, results) {
   *     console.log('err = ', err);
   *     console.log('email_link = ', results.email_link);
   * });
   */
  function autoInject(tasks, callback) {
    var newTasks = {};
    baseForOwn(tasks, function (taskFn, key) {
      var params;
      var fnIsAsync = isAsync(taskFn);
      var hasNoDeps = !fnIsAsync && taskFn.length === 1 || fnIsAsync && taskFn.length === 0;
      if (isArray(taskFn)) {
        params = taskFn.slice(0, -1);
        taskFn = taskFn[taskFn.length - 1];
        newTasks[key] = params.concat(params.length > 0 ? newTask : taskFn);
      } else if (hasNoDeps) {
        // no dependencies, use the function as-is
        newTasks[key] = taskFn;
      } else {
        params = parseParams(taskFn);
        if (taskFn.length === 0 && !fnIsAsync && params.length === 0) {
          throw new Error("autoInject task functions require explicit parameters.");
        }

        // remove callback param
        if (!fnIsAsync) params.pop();
        newTasks[key] = params.concat(newTask);
      }
      function newTask(results, taskCb) {
        var newArgs = arrayMap(params, function (name) {
          return results[name];
        });
        newArgs.push(taskCb);
        wrapAsync(taskFn).apply(null, newArgs);
      }
    });
    auto(newTasks, callback);
  }

  // Simple doubly linked list (https://en.wikipedia.org/wiki/Doubly_linked_list) implementation
  // used for queues. This implementation assumes that the node provided by the user can be modified
  // to adjust the next and last properties. We implement only the minimal functionality
  // for queue support.
  function DLL() {
    this.head = this.tail = null;
    this.length = 0;
  }
  function setInitial(dll, node) {
    dll.length = 1;
    dll.head = dll.tail = node;
  }
  DLL.prototype.removeLink = function (node) {
    if (node.prev) node.prev.next = node.next;else this.head = node.next;
    if (node.next) node.next.prev = node.prev;else this.tail = node.prev;
    node.prev = node.next = null;
    this.length -= 1;
    return node;
  };
  DLL.prototype.empty = function () {
    while (this.head) {
      this.shift();
    }
    return this;
  };
  DLL.prototype.insertAfter = function (node, newNode) {
    newNode.prev = node;
    newNode.next = node.next;
    if (node.next) node.next.prev = newNode;else this.tail = newNode;
    node.next = newNode;
    this.length += 1;
  };
  DLL.prototype.insertBefore = function (node, newNode) {
    newNode.prev = node.prev;
    newNode.next = node;
    if (node.prev) node.prev.next = newNode;else this.head = newNode;
    node.prev = newNode;
    this.length += 1;
  };
  DLL.prototype.unshift = function (node) {
    if (this.head) this.insertBefore(this.head, node);else setInitial(this, node);
  };
  DLL.prototype.push = function (node) {
    if (this.tail) this.insertAfter(this.tail, node);else setInitial(this, node);
  };
  DLL.prototype.shift = function () {
    return this.head && this.removeLink(this.head);
  };
  DLL.prototype.pop = function () {
    return this.tail && this.removeLink(this.tail);
  };
  DLL.prototype.toArray = function () {
    var arr = Array(this.length);
    var curr = this.head;
    for (var idx = 0; idx < this.length; idx++) {
      arr[idx] = curr.data;
      curr = curr.next;
    }
    return arr;
  };
  DLL.prototype.remove = function (testFn) {
    var curr = this.head;
    while (!!curr) {
      var next = curr.next;
      if (testFn(curr)) {
        this.removeLink(curr);
      }
      curr = next;
    }
    return this;
  };
  function queue(worker, concurrency, payload) {
    if (concurrency == null) {
      concurrency = 1;
    } else if (concurrency === 0) {
      throw new Error('Concurrency must not be zero');
    }
    var _worker = wrapAsync(worker);
    var numRunning = 0;
    var _workersList = [];
    var processingScheduled = false;
    function _insert(data, insertAtFront, callback) {
      if (callback != null && typeof callback !== 'function') {
        throw new Error('task callback must be a function');
      }
      q.started = true;
      if (!isArray(data)) {
        data = [data];
      }
      if (data.length === 0 && q.idle()) {
        // call drain immediately if there are no tasks
        return setImmediate$1(function () {
          q.drain();
        });
      }
      for (var i = 0, l = data.length; i < l; i++) {
        var item = {
          data: data[i],
          callback: callback || noop
        };
        if (insertAtFront) {
          q._tasks.unshift(item);
        } else {
          q._tasks.push(item);
        }
      }
      if (!processingScheduled) {
        processingScheduled = true;
        setImmediate$1(function () {
          processingScheduled = false;
          q.process();
        });
      }
    }
    function _next(tasks) {
      return function (err) {
        numRunning -= 1;
        for (var i = 0, l = tasks.length; i < l; i++) {
          var task = tasks[i];
          var index = baseIndexOf(_workersList, task, 0);
          if (index === 0) {
            _workersList.shift();
          } else if (index > 0) {
            _workersList.splice(index, 1);
          }
          task.callback.apply(task, arguments);
          if (err != null) {
            q.error(err, task.data);
          }
        }
        if (numRunning <= q.concurrency - q.buffer) {
          q.unsaturated();
        }
        if (q.idle()) {
          q.drain();
        }
        q.process();
      };
    }
    var isProcessing = false;
    var q = {
      _tasks: new DLL(),
      concurrency: concurrency,
      payload: payload,
      saturated: noop,
      unsaturated: noop,
      buffer: concurrency / 4,
      empty: noop,
      drain: noop,
      error: noop,
      started: false,
      paused: false,
      push: function push(data, callback) {
        _insert(data, false, callback);
      },
      kill: function kill() {
        q.drain = noop;
        q._tasks.empty();
      },
      unshift: function unshift(data, callback) {
        _insert(data, true, callback);
      },
      remove: function remove(testFn) {
        q._tasks.remove(testFn);
      },
      process: function process() {
        // Avoid trying to start too many processing operations. This can occur
        // when callbacks resolve synchronously (#1267).
        if (isProcessing) {
          return;
        }
        isProcessing = true;
        while (!q.paused && numRunning < q.concurrency && q._tasks.length) {
          var tasks = [],
            data = [];
          var l = q._tasks.length;
          if (q.payload) l = Math.min(l, q.payload);
          for (var i = 0; i < l; i++) {
            var node = q._tasks.shift();
            tasks.push(node);
            _workersList.push(node);
            data.push(node.data);
          }
          numRunning += 1;
          if (q._tasks.length === 0) {
            q.empty();
          }
          if (numRunning === q.concurrency) {
            q.saturated();
          }
          var cb = onlyOnce(_next(tasks));
          _worker(data, cb);
        }
        isProcessing = false;
      },
      length: function length() {
        return q._tasks.length;
      },
      running: function running() {
        return numRunning;
      },
      workersList: function workersList() {
        return _workersList;
      },
      idle: function idle() {
        return q._tasks.length + numRunning === 0;
      },
      pause: function pause() {
        q.paused = true;
      },
      resume: function resume() {
        if (q.paused === false) {
          return;
        }
        q.paused = false;
        setImmediate$1(q.process);
      }
    };
    return q;
  }

  /**
   * A cargo of tasks for the worker function to complete. Cargo inherits all of
   * the same methods and event callbacks as [`queue`]{@link module:ControlFlow.queue}.
   * @typedef {Object} CargoObject
   * @memberOf module:ControlFlow
   * @property {Function} length - A function returning the number of items
   * waiting to be processed. Invoke like `cargo.length()`.
   * @property {number} payload - An `integer` for determining how many tasks
   * should be process per round. This property can be changed after a `cargo` is
   * created to alter the payload on-the-fly.
   * @property {Function} push - Adds `task` to the `queue`. The callback is
   * called once the `worker` has finished processing the task. Instead of a
   * single task, an array of `tasks` can be submitted. The respective callback is
   * used for every task in the list. Invoke like `cargo.push(task, [callback])`.
   * @property {Function} saturated - A callback that is called when the
   * `queue.length()` hits the concurrency and further tasks will be queued.
   * @property {Function} empty - A callback that is called when the last item
   * from the `queue` is given to a `worker`.
   * @property {Function} drain - A callback that is called when the last item
   * from the `queue` has returned from the `worker`.
   * @property {Function} idle - a function returning false if there are items
   * waiting or being processed, or true if not. Invoke like `cargo.idle()`.
   * @property {Function} pause - a function that pauses the processing of tasks
   * until `resume()` is called. Invoke like `cargo.pause()`.
   * @property {Function} resume - a function that resumes the processing of
   * queued tasks when the queue is paused. Invoke like `cargo.resume()`.
   * @property {Function} kill - a function that removes the `drain` callback and
   * empties remaining tasks from the queue forcing it to go idle. Invoke like `cargo.kill()`.
   */

  /**
   * Creates a `cargo` object with the specified payload. Tasks added to the
   * cargo will be processed altogether (up to the `payload` limit). If the
   * `worker` is in progress, the task is queued until it becomes available. Once
   * the `worker` has completed some tasks, each callback of those tasks is
   * called. Check out [these](https://camo.githubusercontent.com/6bbd36f4cf5b35a0f11a96dcd2e97711ffc2fb37/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130382f62626330636662302d356632392d313165322d393734662d3333393763363464633835382e676966) [animations](https://camo.githubusercontent.com/f4810e00e1c5f5f8addbe3e9f49064fd5d102699/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130312f38346339323036362d356632392d313165322d383134662d3964336430323431336266642e676966)
   * for how `cargo` and `queue` work.
   *
   * While [`queue`]{@link module:ControlFlow.queue} passes only one task to one of a group of workers
   * at a time, cargo passes an array of tasks to a single worker, repeating
   * when the worker is finished.
   *
   * @name cargo
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @see [async.queue]{@link module:ControlFlow.queue}
   * @category Control Flow
   * @param {AsyncFunction} worker - An asynchronous function for processing an array
   * of queued tasks. Invoked with `(tasks, callback)`.
   * @param {number} [payload=Infinity] - An optional `integer` for determining
   * how many tasks should be processed per round; if omitted, the default is
   * unlimited.
   * @returns {module:ControlFlow.CargoObject} A cargo object to manage the tasks. Callbacks can
   * attached as certain properties to listen for specific events during the
   * lifecycle of the cargo and inner queue.
   * @example
   *
   * // create a cargo object with payload 2
   * var cargo = async.cargo(function(tasks, callback) {
   *     for (var i=0; i<tasks.length; i++) {
   *         console.log('hello ' + tasks[i].name);
   *     }
   *     callback();
   * }, 2);
   *
   * // add some items
   * cargo.push({name: 'foo'}, function(err) {
   *     console.log('finished processing foo');
   * });
   * cargo.push({name: 'bar'}, function(err) {
   *     console.log('finished processing bar');
   * });
   * cargo.push({name: 'baz'}, function(err) {
   *     console.log('finished processing baz');
   * });
   */
  function cargo(worker, payload) {
    return queue(worker, 1, payload);
  }

  /**
   * The same as [`eachOf`]{@link module:Collections.eachOf} but runs only a single async operation at a time.
   *
   * @name eachOfSeries
   * @static
   * @memberOf module:Collections
   * @method
   * @see [async.eachOf]{@link module:Collections.eachOf}
   * @alias forEachOfSeries
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {AsyncFunction} iteratee - An async function to apply to each item in
   * `coll`.
   * Invoked with (item, key, callback).
   * @param {Function} [callback] - A callback which is called when all `iteratee`
   * functions have finished, or an error occurs. Invoked with (err).
   */
  var eachOfSeries = doLimit(eachOfLimit, 1);

  /**
   * Reduces `coll` into a single value using an async `iteratee` to return each
   * successive step. `memo` is the initial state of the reduction. This function
   * only operates in series.
   *
   * For performance reasons, it may make sense to split a call to this function
   * into a parallel map, and then use the normal `Array.prototype.reduce` on the
   * results. This function is for situations where each step in the reduction
   * needs to be async; if you can get the data before reducing it, then it's
   * probably a good idea to do so.
   *
   * @name reduce
   * @static
   * @memberOf module:Collections
   * @method
   * @alias inject
   * @alias foldl
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {*} memo - The initial state of the reduction.
   * @param {AsyncFunction} iteratee - A function applied to each item in the
   * array to produce the next step in the reduction.
   * The `iteratee` should complete with the next state of the reduction.
   * If the iteratee complete with an error, the reduction is stopped and the
   * main `callback` is immediately called with the error.
   * Invoked with (memo, item, callback).
   * @param {Function} [callback] - A callback which is called after all the
   * `iteratee` functions have finished. Result is the reduced value. Invoked with
   * (err, result).
   * @example
   *
   * async.reduce([1,2,3], 0, function(memo, item, callback) {
   *     // pointless async:
   *     process.nextTick(function() {
   *         callback(null, memo + item)
   *     });
   * }, function(err, result) {
   *     // result is now equal to the last value of memo, which is 6
   * });
   */
  function reduce(coll, memo, iteratee, callback) {
    callback = once(callback || noop);
    var _iteratee = wrapAsync(iteratee);
    eachOfSeries(coll, function (x, i, callback) {
      _iteratee(memo, x, function (err, v) {
        memo = v;
        callback(err);
      });
    }, function (err) {
      callback(err, memo);
    });
  }

  /**
   * Version of the compose function that is more natural to read. Each function
   * consumes the return value of the previous function. It is the equivalent of
   * [compose]{@link module:ControlFlow.compose} with the arguments reversed.
   *
   * Each function is executed with the `this` binding of the composed function.
   *
   * @name seq
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @see [async.compose]{@link module:ControlFlow.compose}
   * @category Control Flow
   * @param {...AsyncFunction} functions - the asynchronous functions to compose
   * @returns {Function} a function that composes the `functions` in order
   * @example
   *
   * // Requires lodash (or underscore), express3 and dresende's orm2.
   * // Part of an app, that fetches cats of the logged user.
   * // This example uses `seq` function to avoid overnesting and error
   * // handling clutter.
   * app.get('/cats', function(request, response) {
   *     var User = request.models.User;
   *     async.seq(
   *         _.bind(User.get, User),  // 'User.get' has signature (id, callback(err, data))
   *         function(user, fn) {
   *             user.getCats(fn);      // 'getCats' has signature (callback(err, data))
   *         }
   *     )(req.session.user_id, function (err, cats) {
   *         if (err) {
   *             console.error(err);
   *             response.json({ status: 'error', message: err.message });
   *         } else {
   *             response.json({ status: 'ok', message: 'Cats found', data: cats });
   *         }
   *     });
   * });
   */
  function /*...functions*/
  seq() {
    var _functions = arrayMap(arguments, wrapAsync);
    return function /*...args*/
    () {
      var args = slice(arguments);
      var that = this;
      var cb = args[args.length - 1];
      if (typeof cb == 'function') {
        args.pop();
      } else {
        cb = noop;
      }
      reduce(_functions, args, function (newargs, fn, cb) {
        fn.apply(that, newargs.concat(function (err /*, ...nextargs*/) {
          var nextargs = slice(arguments, 1);
          cb(err, nextargs);
        }));
      }, function (err, results) {
        cb.apply(that, [err].concat(results));
      });
    };
  }

  /**
   * Creates a function which is a composition of the passed asynchronous
   * functions. Each function consumes the return value of the function that
   * follows. Composing functions `f()`, `g()`, and `h()` would produce the result
   * of `f(g(h()))`, only this version uses callbacks to obtain the return values.
   *
   * Each function is executed with the `this` binding of the composed function.
   *
   * @name compose
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @category Control Flow
   * @param {...AsyncFunction} functions - the asynchronous functions to compose
   * @returns {Function} an asynchronous function that is the composed
   * asynchronous `functions`
   * @example
   *
   * function add1(n, callback) {
   *     setTimeout(function () {
   *         callback(null, n + 1);
   *     }, 10);
   * }
   *
   * function mul3(n, callback) {
   *     setTimeout(function () {
   *         callback(null, n * 3);
   *     }, 10);
   * }
   *
   * var add1mul3 = async.compose(mul3, add1);
   * add1mul3(4, function (err, result) {
   *     // result now equals 15
   * });
   */
  var compose = function /*...args*/
  compose() {
    return seq.apply(null, slice(arguments).reverse());
  };
  var _concat = Array.prototype.concat;

  /**
   * The same as [`concat`]{@link module:Collections.concat} but runs a maximum of `limit` async operations at a time.
   *
   * @name concatLimit
   * @static
   * @memberOf module:Collections
   * @method
   * @see [async.concat]{@link module:Collections.concat}
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {number} limit - The maximum number of async operations at a time.
   * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`,
   * which should use an array as its result. Invoked with (item, callback).
   * @param {Function} [callback] - A callback which is called after all the
   * `iteratee` functions have finished, or an error occurs. Results is an array
   * containing the concatenated results of the `iteratee` function. Invoked with
   * (err, results).
   */
  var concatLimit = function concatLimit(coll, limit, iteratee, callback) {
    callback = callback || noop;
    var _iteratee = wrapAsync(iteratee);
    mapLimit(coll, limit, function (val, callback) {
      _iteratee(val, function (err /*, ...args*/) {
        if (err) return callback(err);
        return callback(null, slice(arguments, 1));
      });
    }, function (err, mapResults) {
      var result = [];
      for (var i = 0; i < mapResults.length; i++) {
        if (mapResults[i]) {
          result = _concat.apply(result, mapResults[i]);
        }
      }
      return callback(err, result);
    });
  };

  /**
   * Applies `iteratee` to each item in `coll`, concatenating the results. Returns
   * the concatenated list. The `iteratee`s are called in parallel, and the
   * results are concatenated as they return. There is no guarantee that the
   * results array will be returned in the original order of `coll` passed to the
   * `iteratee` function.
   *
   * @name concat
   * @static
   * @memberOf module:Collections
   * @method
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`,
   * which should use an array as its result. Invoked with (item, callback).
   * @param {Function} [callback(err)] - A callback which is called after all the
   * `iteratee` functions have finished, or an error occurs. Results is an array
   * containing the concatenated results of the `iteratee` function. Invoked with
   * (err, results).
   * @example
   *
   * async.concat(['dir1','dir2','dir3'], fs.readdir, function(err, files) {
   *     // files is now a list of filenames that exist in the 3 directories
   * });
   */
  var concat = doLimit(concatLimit, Infinity);

  /**
   * The same as [`concat`]{@link module:Collections.concat} but runs only a single async operation at a time.
   *
   * @name concatSeries
   * @static
   * @memberOf module:Collections
   * @method
   * @see [async.concat]{@link module:Collections.concat}
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`.
   * The iteratee should complete with an array an array of results.
   * Invoked with (item, callback).
   * @param {Function} [callback(err)] - A callback which is called after all the
   * `iteratee` functions have finished, or an error occurs. Results is an array
   * containing the concatenated results of the `iteratee` function. Invoked with
   * (err, results).
   */
  var concatSeries = doLimit(concatLimit, 1);

  /**
   * Returns a function that when called, calls-back with the values provided.
   * Useful as the first function in a [`waterfall`]{@link module:ControlFlow.waterfall}, or for plugging values in to
   * [`auto`]{@link module:ControlFlow.auto}.
   *
   * @name constant
   * @static
   * @memberOf module:Utils
   * @method
   * @category Util
   * @param {...*} arguments... - Any number of arguments to automatically invoke
   * callback with.
   * @returns {AsyncFunction} Returns a function that when invoked, automatically
   * invokes the callback with the previous given arguments.
   * @example
   *
   * async.waterfall([
   *     async.constant(42),
   *     function (value, next) {
   *         // value === 42
   *     },
   *     //...
   * ], callback);
   *
   * async.waterfall([
   *     async.constant(filename, "utf8"),
   *     fs.readFile,
   *     function (fileData, next) {
   *         //...
   *     }
   *     //...
   * ], callback);
   *
   * async.auto({
   *     hostname: async.constant("https://server.net/"),
   *     port: findFreePort,
   *     launchServer: ["hostname", "port", function (options, cb) {
   *         startServer(options, cb);
   *     }],
   *     //...
   * }, callback);
   */
  var constant = function /*...values*/
  constant() {
    var values = slice(arguments);
    var args = [null].concat(values);
    return function /*...ignoredArgs, callback*/
    () {
      var callback = arguments[arguments.length - 1];
      return callback.apply(this, args);
    };
  };

  /**
   * This method returns the first argument it receives.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {*} value Any value.
   * @returns {*} Returns `value`.
   * @example
   *
   * var object = { 'a': 1 };
   *
   * console.log(_.identity(object) === object);
   * // => true
   */
  function identity(value) {
    return value;
  }
  function _createTester(check, getResult) {
    return function (eachfn, arr, iteratee, cb) {
      cb = cb || noop;
      var testPassed = false;
      var testResult;
      eachfn(arr, function (value, _, callback) {
        iteratee(value, function (err, result) {
          if (err) {
            callback(err);
          } else if (check(result) && !testResult) {
            testPassed = true;
            testResult = getResult(true, value);
            callback(null, breakLoop);
          } else {
            callback();
          }
        });
      }, function (err) {
        if (err) {
          cb(err);
        } else {
          cb(null, testPassed ? testResult : getResult(false));
        }
      });
    };
  }
  function _findGetResult(v, x) {
    return x;
  }

  /**
   * Returns the first value in `coll` that passes an async truth test. The
   * `iteratee` is applied in parallel, meaning the first iteratee to return
   * `true` will fire the detect `callback` with that result. That means the
   * result might not be the first item in the original `coll` (in terms of order)
   * that passes the test.
  
   * If order within the original `coll` is important, then look at
   * [`detectSeries`]{@link module:Collections.detectSeries}.
   *
   * @name detect
   * @static
   * @memberOf module:Collections
   * @method
   * @alias find
   * @category Collections
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
   * The iteratee must complete with a boolean value as its result.
   * Invoked with (item, callback).
   * @param {Function} [callback] - A callback which is called as soon as any
   * iteratee returns `true`, or after all the `iteratee` functions have finished.
   * Result will be the first item in the array that passes the truth test
   * (iteratee) or the value `undefined` if none passed. Invoked with
   * (err, result).
   * @example
   *
   * async.detect(['file1','file2','file3'], function(filePath, callback) {
   *     fs.access(filePath, function(err) {
   *         callback(null, !err)
   *     });
   * }, function(err, result) {
   *     // result now equals the first file in the list that exists
   * });
   */
  var detect = doParallel(_createTester(identity, _findGetResult));

  /**
   * The same as [`detect`]{@link module:Collections.detect} but runs a maximum of `limit` async operations at a
   * time.
   *
   * @name detectLimit
   * @static
   * @memberOf module:Collections
   * @method
   * @see [async.detect]{@link module:Collections.detect}
   * @alias findLimit
   * @category Collections
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {number} limit - The maximum number of async operations at a time.
   * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
   * The iteratee must complete with a boolean value as its result.
   * Invoked with (item, callback).
   * @param {Function} [callback] - A callback which is called as soon as any
   * iteratee returns `true`, or after all the `iteratee` functions have finished.
   * Result will be the first item in the array that passes the truth test
   * (iteratee) or the value `undefined` if none passed. Invoked with
   * (err, result).
   */
  var detectLimit = doParallelLimit(_createTester(identity, _findGetResult));

  /**
   * The same as [`detect`]{@link module:Collections.detect} but runs only a single async operation at a time.
   *
   * @name detectSeries
   * @static
   * @memberOf module:Collections
   * @method
   * @see [async.detect]{@link module:Collections.detect}
   * @alias findSeries
   * @category Collections
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
   * The iteratee must complete with a boolean value as its result.
   * Invoked with (item, callback).
   * @param {Function} [callback] - A callback which is called as soon as any
   * iteratee returns `true`, or after all the `iteratee` functions have finished.
   * Result will be the first item in the array that passes the truth test
   * (iteratee) or the value `undefined` if none passed. Invoked with
   * (err, result).
   */
  var detectSeries = doLimit(detectLimit, 1);
  function consoleFunc(name) {
    return function (fn /*, ...args*/) {
      var args = slice(arguments, 1);
      args.push(function (err /*, ...args*/) {
        var args = slice(arguments, 1);
        if ((typeof console === "undefined" ? "undefined" : _typeof(console)) === 'object') {
          if (err) {
            if (console.error) {
              console.error(err);
            }
          } else if (console[name]) {
            arrayEach(args, function (x) {
              console[name](x);
            });
          }
        }
      });
      wrapAsync(fn).apply(null, args);
    };
  }

  /**
   * Logs the result of an [`async` function]{@link AsyncFunction} to the
   * `console` using `console.dir` to display the properties of the resulting object.
   * Only works in Node.js or in browsers that support `console.dir` and
   * `console.error` (such as FF and Chrome).
   * If multiple arguments are returned from the async function,
   * `console.dir` is called on each argument in order.
   *
   * @name dir
   * @static
   * @memberOf module:Utils
   * @method
   * @category Util
   * @param {AsyncFunction} function - The function you want to eventually apply
   * all arguments to.
   * @param {...*} arguments... - Any number of arguments to apply to the function.
   * @example
   *
   * // in a module
   * var hello = function(name, callback) {
   *     setTimeout(function() {
   *         callback(null, {hello: name});
   *     }, 1000);
   * };
   *
   * // in the node repl
   * node> async.dir(hello, 'world');
   * {hello: 'world'}
   */
  var dir = consoleFunc('dir');

  /**
   * The post-check version of [`during`]{@link module:ControlFlow.during}. To reflect the difference in
   * the order of operations, the arguments `test` and `fn` are switched.
   *
   * Also a version of [`doWhilst`]{@link module:ControlFlow.doWhilst} with asynchronous `test` function.
   * @name doDuring
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @see [async.during]{@link module:ControlFlow.during}
   * @category Control Flow
   * @param {AsyncFunction} fn - An async function which is called each time
   * `test` passes. Invoked with (callback).
   * @param {AsyncFunction} test - asynchronous truth test to perform before each
   * execution of `fn`. Invoked with (...args, callback), where `...args` are the
   * non-error args from the previous callback of `fn`.
   * @param {Function} [callback] - A callback which is called after the test
   * function has failed and repeated execution of `fn` has stopped. `callback`
   * will be passed an error if one occurred, otherwise `null`.
   */
  function doDuring(fn, test, callback) {
    callback = onlyOnce(callback || noop);
    var _fn = wrapAsync(fn);
    var _test = wrapAsync(test);
    function next(err /*, ...args*/) {
      if (err) return callback(err);
      var args = slice(arguments, 1);
      args.push(check);
      _test.apply(this, args);
    }
    function check(err, truth) {
      if (err) return callback(err);
      if (!truth) return callback(null);
      _fn(next);
    }
    check(null, true);
  }

  /**
   * The post-check version of [`whilst`]{@link module:ControlFlow.whilst}. To reflect the difference in
   * the order of operations, the arguments `test` and `iteratee` are switched.
   *
   * `doWhilst` is to `whilst` as `do while` is to `while` in plain JavaScript.
   *
   * @name doWhilst
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @see [async.whilst]{@link module:ControlFlow.whilst}
   * @category Control Flow
   * @param {AsyncFunction} iteratee - A function which is called each time `test`
   * passes. Invoked with (callback).
   * @param {Function} test - synchronous truth test to perform after each
   * execution of `iteratee`. Invoked with any non-error callback results of
   * `iteratee`.
   * @param {Function} [callback] - A callback which is called after the test
   * function has failed and repeated execution of `iteratee` has stopped.
   * `callback` will be passed an error and any arguments passed to the final
   * `iteratee`'s callback. Invoked with (err, [results]);
   */
  function doWhilst(iteratee, test, callback) {
    callback = onlyOnce(callback || noop);
    var _iteratee = wrapAsync(iteratee);
    var next = function next(err /*, ...args*/) {
      if (err) return callback(err);
      var args = slice(arguments, 1);
      if (test.apply(this, args)) return _iteratee(next);
      callback.apply(null, [null].concat(args));
    };
    _iteratee(next);
  }

  /**
   * Like ['doWhilst']{@link module:ControlFlow.doWhilst}, except the `test` is inverted. Note the
   * argument ordering differs from `until`.
   *
   * @name doUntil
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @see [async.doWhilst]{@link module:ControlFlow.doWhilst}
   * @category Control Flow
   * @param {AsyncFunction} iteratee - An async function which is called each time
   * `test` fails. Invoked with (callback).
   * @param {Function} test - synchronous truth test to perform after each
   * execution of `iteratee`. Invoked with any non-error callback results of
   * `iteratee`.
   * @param {Function} [callback] - A callback which is called after the test
   * function has passed and repeated execution of `iteratee` has stopped. `callback`
   * will be passed an error and any arguments passed to the final `iteratee`'s
   * callback. Invoked with (err, [results]);
   */
  function doUntil(iteratee, test, callback) {
    doWhilst(iteratee, function () {
      return !test.apply(this, arguments);
    }, callback);
  }

  /**
   * Like [`whilst`]{@link module:ControlFlow.whilst}, except the `test` is an asynchronous function that
   * is passed a callback in the form of `function (err, truth)`. If error is
   * passed to `test` or `fn`, the main callback is immediately called with the
   * value of the error.
   *
   * @name during
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @see [async.whilst]{@link module:ControlFlow.whilst}
   * @category Control Flow
   * @param {AsyncFunction} test - asynchronous truth test to perform before each
   * execution of `fn`. Invoked with (callback).
   * @param {AsyncFunction} fn - An async function which is called each time
   * `test` passes. Invoked with (callback).
   * @param {Function} [callback] - A callback which is called after the test
   * function has failed and repeated execution of `fn` has stopped. `callback`
   * will be passed an error, if one occurred, otherwise `null`.
   * @example
   *
   * var count = 0;
   *
   * async.during(
   *     function (callback) {
   *         return callback(null, count < 5);
   *     },
   *     function (callback) {
   *         count++;
   *         setTimeout(callback, 1000);
   *     },
   *     function (err) {
   *         // 5 seconds have passed
   *     }
   * );
   */
  function during(test, fn, callback) {
    callback = onlyOnce(callback || noop);
    var _fn = wrapAsync(fn);
    var _test = wrapAsync(test);
    function next(err) {
      if (err) return callback(err);
      _test(check);
    }
    function check(err, truth) {
      if (err) return callback(err);
      if (!truth) return callback(null);
      _fn(next);
    }
    _test(check);
  }
  function _withoutIndex(iteratee) {
    return function (value, index, callback) {
      return iteratee(value, callback);
    };
  }

  /**
   * Applies the function `iteratee` to each item in `coll`, in parallel.
   * The `iteratee` is called with an item from the list, and a callback for when
   * it has finished. If the `iteratee` passes an error to its `callback`, the
   * main `callback` (for the `each` function) is immediately called with the
   * error.
   *
   * Note, that since this function applies `iteratee` to each item in parallel,
   * there is no guarantee that the iteratee functions will complete in order.
   *
   * @name each
   * @static
   * @memberOf module:Collections
   * @method
   * @alias forEach
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {AsyncFunction} iteratee - An async function to apply to
   * each item in `coll`. Invoked with (item, callback).
   * The array index is not passed to the iteratee.
   * If you need the index, use `eachOf`.
   * @param {Function} [callback] - A callback which is called when all
   * `iteratee` functions have finished, or an error occurs. Invoked with (err).
   * @example
   *
   * // assuming openFiles is an array of file names and saveFile is a function
   * // to save the modified contents of that file:
   *
   * async.each(openFiles, saveFile, function(err){
   *   // if any of the saves produced an error, err would equal that error
   * });
   *
   * // assuming openFiles is an array of file names
   * async.each(openFiles, function(file, callback) {
   *
   *     // Perform operation on file here.
   *     console.log('Processing file ' + file);
   *
   *     if( file.length > 32 ) {
   *       console.log('This file name is too long');
   *       callback('File name too long');
   *     } else {
   *       // Do work to process file here
   *       console.log('File processed');
   *       callback();
   *     }
   * }, function(err) {
   *     // if any of the file processing produced an error, err would equal that error
   *     if( err ) {
   *       // One of the iterations produced an error.
   *       // All processing will now stop.
   *       console.log('A file failed to process');
   *     } else {
   *       console.log('All files have been processed successfully');
   *     }
   * });
   */
  function eachLimit(coll, iteratee, callback) {
    eachOf(coll, _withoutIndex(wrapAsync(iteratee)), callback);
  }

  /**
   * The same as [`each`]{@link module:Collections.each} but runs a maximum of `limit` async operations at a time.
   *
   * @name eachLimit
   * @static
   * @memberOf module:Collections
   * @method
   * @see [async.each]{@link module:Collections.each}
   * @alias forEachLimit
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {number} limit - The maximum number of async operations at a time.
   * @param {AsyncFunction} iteratee - An async function to apply to each item in
   * `coll`.
   * The array index is not passed to the iteratee.
   * If you need the index, use `eachOfLimit`.
   * Invoked with (item, callback).
   * @param {Function} [callback] - A callback which is called when all
   * `iteratee` functions have finished, or an error occurs. Invoked with (err).
   */
  function eachLimit$1(coll, limit, iteratee, callback) {
    _eachOfLimit(limit)(coll, _withoutIndex(wrapAsync(iteratee)), callback);
  }

  /**
   * The same as [`each`]{@link module:Collections.each} but runs only a single async operation at a time.
   *
   * @name eachSeries
   * @static
   * @memberOf module:Collections
   * @method
   * @see [async.each]{@link module:Collections.each}
   * @alias forEachSeries
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {AsyncFunction} iteratee - An async function to apply to each
   * item in `coll`.
   * The array index is not passed to the iteratee.
   * If you need the index, use `eachOfSeries`.
   * Invoked with (item, callback).
   * @param {Function} [callback] - A callback which is called when all
   * `iteratee` functions have finished, or an error occurs. Invoked with (err).
   */
  var eachSeries = doLimit(eachLimit$1, 1);

  /**
   * Wrap an async function and ensure it calls its callback on a later tick of
   * the event loop.  If the function already calls its callback on a next tick,
   * no extra deferral is added. This is useful for preventing stack overflows
   * (`RangeError: Maximum call stack size exceeded`) and generally keeping
   * [Zalgo](http://blog.izs.me/post/59142742143/designing-apis-for-asynchrony)
   * contained. ES2017 `async` functions are returned as-is -- they are immune
   * to Zalgo's corrupting influences, as they always resolve on a later tick.
   *
   * @name ensureAsync
   * @static
   * @memberOf module:Utils
   * @method
   * @category Util
   * @param {AsyncFunction} fn - an async function, one that expects a node-style
   * callback as its last argument.
   * @returns {AsyncFunction} Returns a wrapped function with the exact same call
   * signature as the function passed in.
   * @example
   *
   * function sometimesAsync(arg, callback) {
   *     if (cache[arg]) {
   *         return callback(null, cache[arg]); // this would be synchronous!!
   *     } else {
   *         doSomeIO(arg, callback); // this IO would be asynchronous
   *     }
   * }
   *
   * // this has a risk of stack overflows if many results are cached in a row
   * async.mapSeries(args, sometimesAsync, done);
   *
   * // this will defer sometimesAsync's callback if necessary,
   * // preventing stack overflows
   * async.mapSeries(args, async.ensureAsync(sometimesAsync), done);
   */
  function ensureAsync(fn) {
    if (isAsync(fn)) return fn;
    return initialParams(function (args, callback) {
      var sync = true;
      args.push(function () {
        var innerArgs = arguments;
        if (sync) {
          setImmediate$1(function () {
            callback.apply(null, innerArgs);
          });
        } else {
          callback.apply(null, innerArgs);
        }
      });
      fn.apply(this, args);
      sync = false;
    });
  }
  function notId(v) {
    return !v;
  }

  /**
   * Returns `true` if every element in `coll` satisfies an async test. If any
   * iteratee call returns `false`, the main `callback` is immediately called.
   *
   * @name every
   * @static
   * @memberOf module:Collections
   * @method
   * @alias all
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {AsyncFunction} iteratee - An async truth test to apply to each item
   * in the collection in parallel.
   * The iteratee must complete with a boolean result value.
   * Invoked with (item, callback).
   * @param {Function} [callback] - A callback which is called after all the
   * `iteratee` functions have finished. Result will be either `true` or `false`
   * depending on the values of the async tests. Invoked with (err, result).
   * @example
   *
   * async.every(['file1','file2','file3'], function(filePath, callback) {
   *     fs.access(filePath, function(err) {
   *         callback(null, !err)
   *     });
   * }, function(err, result) {
   *     // if result is true then every file exists
   * });
   */
  var every = doParallel(_createTester(notId, notId));

  /**
   * The same as [`every`]{@link module:Collections.every} but runs a maximum of `limit` async operations at a time.
   *
   * @name everyLimit
   * @static
   * @memberOf module:Collections
   * @method
   * @see [async.every]{@link module:Collections.every}
   * @alias allLimit
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {number} limit - The maximum number of async operations at a time.
   * @param {AsyncFunction} iteratee - An async truth test to apply to each item
   * in the collection in parallel.
   * The iteratee must complete with a boolean result value.
   * Invoked with (item, callback).
   * @param {Function} [callback] - A callback which is called after all the
   * `iteratee` functions have finished. Result will be either `true` or `false`
   * depending on the values of the async tests. Invoked with (err, result).
   */
  var everyLimit = doParallelLimit(_createTester(notId, notId));

  /**
   * The same as [`every`]{@link module:Collections.every} but runs only a single async operation at a time.
   *
   * @name everySeries
   * @static
   * @memberOf module:Collections
   * @method
   * @see [async.every]{@link module:Collections.every}
   * @alias allSeries
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {AsyncFunction} iteratee - An async truth test to apply to each item
   * in the collection in series.
   * The iteratee must complete with a boolean result value.
   * Invoked with (item, callback).
   * @param {Function} [callback] - A callback which is called after all the
   * `iteratee` functions have finished. Result will be either `true` or `false`
   * depending on the values of the async tests. Invoked with (err, result).
   */
  var everySeries = doLimit(everyLimit, 1);

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function (object) {
      return object == null ? undefined : object[key];
    };
  }
  function filterArray(eachfn, arr, iteratee, callback) {
    var truthValues = new Array(arr.length);
    eachfn(arr, function (x, index, callback) {
      iteratee(x, function (err, v) {
        truthValues[index] = !!v;
        callback(err);
      });
    }, function (err) {
      if (err) return callback(err);
      var results = [];
      for (var i = 0; i < arr.length; i++) {
        if (truthValues[i]) results.push(arr[i]);
      }
      callback(null, results);
    });
  }
  function filterGeneric(eachfn, coll, iteratee, callback) {
    var results = [];
    eachfn(coll, function (x, index, callback) {
      iteratee(x, function (err, v) {
        if (err) {
          callback(err);
        } else {
          if (v) {
            results.push({
              index: index,
              value: x
            });
          }
          callback();
        }
      });
    }, function (err) {
      if (err) {
        callback(err);
      } else {
        callback(null, arrayMap(results.sort(function (a, b) {
          return a.index - b.index;
        }), baseProperty('value')));
      }
    });
  }
  function _filter(eachfn, coll, iteratee, callback) {
    var filter = isArrayLike(coll) ? filterArray : filterGeneric;
    filter(eachfn, coll, wrapAsync(iteratee), callback || noop);
  }

  /**
   * Returns a new array of all the values in `coll` which pass an async truth
   * test. This operation is performed in parallel, but the results array will be
   * in the same order as the original.
   *
   * @name filter
   * @static
   * @memberOf module:Collections
   * @method
   * @alias select
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {Function} iteratee - A truth test to apply to each item in `coll`.
   * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
   * with a boolean argument once it has completed. Invoked with (item, callback).
   * @param {Function} [callback] - A callback which is called after all the
   * `iteratee` functions have finished. Invoked with (err, results).
   * @example
   *
   * async.filter(['file1','file2','file3'], function(filePath, callback) {
   *     fs.access(filePath, function(err) {
   *         callback(null, !err)
   *     });
   * }, function(err, results) {
   *     // results now equals an array of the existing files
   * });
   */
  var filter = doParallel(_filter);

  /**
   * The same as [`filter`]{@link module:Collections.filter} but runs a maximum of `limit` async operations at a
   * time.
   *
   * @name filterLimit
   * @static
   * @memberOf module:Collections
   * @method
   * @see [async.filter]{@link module:Collections.filter}
   * @alias selectLimit
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {number} limit - The maximum number of async operations at a time.
   * @param {Function} iteratee - A truth test to apply to each item in `coll`.
   * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
   * with a boolean argument once it has completed. Invoked with (item, callback).
   * @param {Function} [callback] - A callback which is called after all the
   * `iteratee` functions have finished. Invoked with (err, results).
   */
  var filterLimit = doParallelLimit(_filter);

  /**
   * The same as [`filter`]{@link module:Collections.filter} but runs only a single async operation at a time.
   *
   * @name filterSeries
   * @static
   * @memberOf module:Collections
   * @method
   * @see [async.filter]{@link module:Collections.filter}
   * @alias selectSeries
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {Function} iteratee - A truth test to apply to each item in `coll`.
   * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
   * with a boolean argument once it has completed. Invoked with (item, callback).
   * @param {Function} [callback] - A callback which is called after all the
   * `iteratee` functions have finished. Invoked with (err, results)
   */
  var filterSeries = doLimit(filterLimit, 1);

  /**
   * Calls the asynchronous function `fn` with a callback parameter that allows it
   * to call itself again, in series, indefinitely.
  
   * If an error is passed to the callback then `errback` is called with the
   * error, and execution stops, otherwise it will never be called.
   *
   * @name forever
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @category Control Flow
   * @param {AsyncFunction} fn - an async function to call repeatedly.
   * Invoked with (next).
   * @param {Function} [errback] - when `fn` passes an error to it's callback,
   * this function will be called, and execution stops. Invoked with (err).
   * @example
   *
   * async.forever(
   *     function(next) {
   *         // next is suitable for passing to things that need a callback(err [, whatever]);
   *         // it will result in this function being called again.
   *     },
   *     function(err) {
   *         // if next is called with a value in its first parameter, it will appear
   *         // in here as 'err', and execution will stop.
   *     }
   * );
   */
  function forever(fn, errback) {
    var done = onlyOnce(errback || noop);
    var task = wrapAsync(ensureAsync(fn));
    function next(err) {
      if (err) return done(err);
      task(next);
    }
    next();
  }

  /**
   * The same as [`groupBy`]{@link module:Collections.groupBy} but runs a maximum of `limit` async operations at a time.
   *
   * @name groupByLimit
   * @static
   * @memberOf module:Collections
   * @method
   * @see [async.groupBy]{@link module:Collections.groupBy}
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {number} limit - The maximum number of async operations at a time.
   * @param {AsyncFunction} iteratee - An async function to apply to each item in
   * `coll`.
   * The iteratee should complete with a `key` to group the value under.
   * Invoked with (value, callback).
   * @param {Function} [callback] - A callback which is called when all `iteratee`
   * functions have finished, or an error occurs. Result is an `Object` whoses
   * properties are arrays of values which returned the corresponding key.
   */
  var groupByLimit = function groupByLimit(coll, limit, iteratee, callback) {
    callback = callback || noop;
    var _iteratee = wrapAsync(iteratee);
    mapLimit(coll, limit, function (val, callback) {
      _iteratee(val, function (err, key) {
        if (err) return callback(err);
        return callback(null, {
          key: key,
          val: val
        });
      });
    }, function (err, mapResults) {
      var result = {};
      // from MDN, handle object having an `hasOwnProperty` prop
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      for (var i = 0; i < mapResults.length; i++) {
        if (mapResults[i]) {
          var key = mapResults[i].key;
          var val = mapResults[i].val;
          if (hasOwnProperty.call(result, key)) {
            result[key].push(val);
          } else {
            result[key] = [val];
          }
        }
      }
      return callback(err, result);
    });
  };

  /**
   * Returns a new object, where each value corresponds to an array of items, from
   * `coll`, that returned the corresponding key. That is, the keys of the object
   * correspond to the values passed to the `iteratee` callback.
   *
   * Note: Since this function applies the `iteratee` to each item in parallel,
   * there is no guarantee that the `iteratee` functions will complete in order.
   * However, the values for each key in the `result` will be in the same order as
   * the original `coll`. For Objects, the values will roughly be in the order of
   * the original Objects' keys (but this can vary across JavaScript engines).
   *
   * @name groupBy
   * @static
   * @memberOf module:Collections
   * @method
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {AsyncFunction} iteratee - An async function to apply to each item in
   * `coll`.
   * The iteratee should complete with a `key` to group the value under.
   * Invoked with (value, callback).
   * @param {Function} [callback] - A callback which is called when all `iteratee`
   * functions have finished, or an error occurs. Result is an `Object` whoses
   * properties are arrays of values which returned the corresponding key.
   * @example
   *
   * async.groupBy(['userId1', 'userId2', 'userId3'], function(userId, callback) {
   *     db.findById(userId, function(err, user) {
   *         if (err) return callback(err);
   *         return callback(null, user.age);
   *     });
   * }, function(err, result) {
   *     // result is object containing the userIds grouped by age
   *     // e.g. { 30: ['userId1', 'userId3'], 42: ['userId2']};
   * });
   */
  var groupBy = doLimit(groupByLimit, Infinity);

  /**
   * The same as [`groupBy`]{@link module:Collections.groupBy} but runs only a single async operation at a time.
   *
   * @name groupBySeries
   * @static
   * @memberOf module:Collections
   * @method
   * @see [async.groupBy]{@link module:Collections.groupBy}
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {number} limit - The maximum number of async operations at a time.
   * @param {AsyncFunction} iteratee - An async function to apply to each item in
   * `coll`.
   * The iteratee should complete with a `key` to group the value under.
   * Invoked with (value, callback).
   * @param {Function} [callback] - A callback which is called when all `iteratee`
   * functions have finished, or an error occurs. Result is an `Object` whoses
   * properties are arrays of values which returned the corresponding key.
   */
  var groupBySeries = doLimit(groupByLimit, 1);

  /**
   * Logs the result of an `async` function to the `console`. Only works in
   * Node.js or in browsers that support `console.log` and `console.error` (such
   * as FF and Chrome). If multiple arguments are returned from the async
   * function, `console.log` is called on each argument in order.
   *
   * @name log
   * @static
   * @memberOf module:Utils
   * @method
   * @category Util
   * @param {AsyncFunction} function - The function you want to eventually apply
   * all arguments to.
   * @param {...*} arguments... - Any number of arguments to apply to the function.
   * @example
   *
   * // in a module
   * var hello = function(name, callback) {
   *     setTimeout(function() {
   *         callback(null, 'hello ' + name);
   *     }, 1000);
   * };
   *
   * // in the node repl
   * node> async.log(hello, 'world');
   * 'hello world'
   */
  var log = consoleFunc('log');

  /**
   * The same as [`mapValues`]{@link module:Collections.mapValues} but runs a maximum of `limit` async operations at a
   * time.
   *
   * @name mapValuesLimit
   * @static
   * @memberOf module:Collections
   * @method
   * @see [async.mapValues]{@link module:Collections.mapValues}
   * @category Collection
   * @param {Object} obj - A collection to iterate over.
   * @param {number} limit - The maximum number of async operations at a time.
   * @param {AsyncFunction} iteratee - A function to apply to each value and key
   * in `coll`.
   * The iteratee should complete with the transformed value as its result.
   * Invoked with (value, key, callback).
   * @param {Function} [callback] - A callback which is called when all `iteratee`
   * functions have finished, or an error occurs. `result` is a new object consisting
   * of each key from `obj`, with each transformed value on the right-hand side.
   * Invoked with (err, result).
   */
  function mapValuesLimit(obj, limit, iteratee, callback) {
    callback = once(callback || noop);
    var newObj = {};
    var _iteratee = wrapAsync(iteratee);
    eachOfLimit(obj, limit, function (val, key, next) {
      _iteratee(val, key, function (err, result) {
        if (err) return next(err);
        newObj[key] = result;
        next();
      });
    }, function (err) {
      callback(err, newObj);
    });
  }

  /**
   * A relative of [`map`]{@link module:Collections.map}, designed for use with objects.
   *
   * Produces a new Object by mapping each value of `obj` through the `iteratee`
   * function. The `iteratee` is called each `value` and `key` from `obj` and a
   * callback for when it has finished processing. Each of these callbacks takes
   * two arguments: an `error`, and the transformed item from `obj`. If `iteratee`
   * passes an error to its callback, the main `callback` (for the `mapValues`
   * function) is immediately called with the error.
   *
   * Note, the order of the keys in the result is not guaranteed.  The keys will
   * be roughly in the order they complete, (but this is very engine-specific)
   *
   * @name mapValues
   * @static
   * @memberOf module:Collections
   * @method
   * @category Collection
   * @param {Object} obj - A collection to iterate over.
   * @param {AsyncFunction} iteratee - A function to apply to each value and key
   * in `coll`.
   * The iteratee should complete with the transformed value as its result.
   * Invoked with (value, key, callback).
   * @param {Function} [callback] - A callback which is called when all `iteratee`
   * functions have finished, or an error occurs. `result` is a new object consisting
   * of each key from `obj`, with each transformed value on the right-hand side.
   * Invoked with (err, result).
   * @example
   *
   * async.mapValues({
   *     f1: 'file1',
   *     f2: 'file2',
   *     f3: 'file3'
   * }, function (file, key, callback) {
   *   fs.stat(file, callback);
   * }, function(err, result) {
   *     // result is now a map of stats for each file, e.g.
   *     // {
   *     //     f1: [stats for file1],
   *     //     f2: [stats for file2],
   *     //     f3: [stats for file3]
   *     // }
   * });
   */

  var mapValues = doLimit(mapValuesLimit, Infinity);

  /**
   * The same as [`mapValues`]{@link module:Collections.mapValues} but runs only a single async operation at a time.
   *
   * @name mapValuesSeries
   * @static
   * @memberOf module:Collections
   * @method
   * @see [async.mapValues]{@link module:Collections.mapValues}
   * @category Collection
   * @param {Object} obj - A collection to iterate over.
   * @param {AsyncFunction} iteratee - A function to apply to each value and key
   * in `coll`.
   * The iteratee should complete with the transformed value as its result.
   * Invoked with (value, key, callback).
   * @param {Function} [callback] - A callback which is called when all `iteratee`
   * functions have finished, or an error occurs. `result` is a new object consisting
   * of each key from `obj`, with each transformed value on the right-hand side.
   * Invoked with (err, result).
   */
  var mapValuesSeries = doLimit(mapValuesLimit, 1);
  function has(obj, key) {
    return key in obj;
  }

  /**
   * Caches the results of an async function. When creating a hash to store
   * function results against, the callback is omitted from the hash and an
   * optional hash function can be used.
   *
   * If no hash function is specified, the first argument is used as a hash key,
   * which may work reasonably if it is a string or a data type that converts to a
   * distinct string. Note that objects and arrays will not behave reasonably.
   * Neither will cases where the other arguments are significant. In such cases,
   * specify your own hash function.
   *
   * The cache of results is exposed as the `memo` property of the function
   * returned by `memoize`.
   *
   * @name memoize
   * @static
   * @memberOf module:Utils
   * @method
   * @category Util
   * @param {AsyncFunction} fn - The async function to proxy and cache results from.
   * @param {Function} hasher - An optional function for generating a custom hash
   * for storing results. It has all the arguments applied to it apart from the
   * callback, and must be synchronous.
   * @returns {AsyncFunction} a memoized version of `fn`
   * @example
   *
   * var slow_fn = function(name, callback) {
   *     // do something
   *     callback(null, result);
   * };
   * var fn = async.memoize(slow_fn);
   *
   * // fn can now be used as if it were slow_fn
   * fn('some name', function() {
   *     // callback
   * });
   */
  function memoize(fn, hasher) {
    var memo = Object.create(null);
    var queues = Object.create(null);
    hasher = hasher || identity;
    var _fn = wrapAsync(fn);
    var memoized = initialParams(function memoized(args, callback) {
      var key = hasher.apply(null, args);
      if (has(memo, key)) {
        setImmediate$1(function () {
          callback.apply(null, memo[key]);
        });
      } else if (has(queues, key)) {
        queues[key].push(callback);
      } else {
        queues[key] = [callback];
        _fn.apply(null, args.concat(function /*args*/
        () {
          var args = slice(arguments);
          memo[key] = args;
          var q = queues[key];
          delete queues[key];
          for (var i = 0, l = q.length; i < l; i++) {
            q[i].apply(null, args);
          }
        }));
      }
    });
    memoized.memo = memo;
    memoized.unmemoized = fn;
    return memoized;
  }

  /**
   * Calls `callback` on a later loop around the event loop. In Node.js this just
   * calls `process.nextTick`.  In the browser it will use `setImmediate` if
   * available, otherwise `setTimeout(callback, 0)`, which means other higher
   * priority events may precede the execution of `callback`.
   *
   * This is used internally for browser-compatibility purposes.
   *
   * @name nextTick
   * @static
   * @memberOf module:Utils
   * @method
   * @see [async.setImmediate]{@link module:Utils.setImmediate}
   * @category Util
   * @param {Function} callback - The function to call on a later loop around
   * the event loop. Invoked with (args...).
   * @param {...*} args... - any number of additional arguments to pass to the
   * callback on the next tick.
   * @example
   *
   * var call_order = [];
   * async.nextTick(function() {
   *     call_order.push('two');
   *     // call_order now equals ['one','two']
   * });
   * call_order.push('one');
   *
   * async.setImmediate(function (a, b, c) {
   *     // a, b, and c equal 1, 2, and 3
   * }, 1, 2, 3);
   */
  var _defer$1;
  if (hasNextTick) {
    _defer$1 = process.nextTick;
  } else if (hasSetImmediate) {
    _defer$1 = setImmediate;
  } else {
    _defer$1 = fallback;
  }
  var nextTick = wrap(_defer$1);
  function _parallel(eachfn, tasks, callback) {
    callback = callback || noop;
    var results = isArrayLike(tasks) ? [] : {};
    eachfn(tasks, function (task, key, callback) {
      wrapAsync(task)(function (err, result) {
        if (arguments.length > 2) {
          result = slice(arguments, 1);
        }
        results[key] = result;
        callback(err);
      });
    }, function (err) {
      callback(err, results);
    });
  }

  /**
   * Run the `tasks` collection of functions in parallel, without waiting until
   * the previous function has completed. If any of the functions pass an error to
   * its callback, the main `callback` is immediately called with the value of the
   * error. Once the `tasks` have completed, the results are passed to the final
   * `callback` as an array.
   *
   * **Note:** `parallel` is about kicking-off I/O tasks in parallel, not about
   * parallel execution of code.  If your tasks do not use any timers or perform
   * any I/O, they will actually be executed in series.  Any synchronous setup
   * sections for each task will happen one after the other.  JavaScript remains
   * single-threaded.
   *
   * **Hint:** Use [`reflect`]{@link module:Utils.reflect} to continue the
   * execution of other tasks when a task fails.
   *
   * It is also possible to use an object instead of an array. Each property will
   * be run as a function and the results will be passed to the final `callback`
   * as an object instead of an array. This can be a more readable way of handling
   * results from {@link async.parallel}.
   *
   * @name parallel
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @category Control Flow
   * @param {Array|Iterable|Object} tasks - A collection of
   * [async functions]{@link AsyncFunction} to run.
   * Each async function can complete with any number of optional `result` values.
   * @param {Function} [callback] - An optional callback to run once all the
   * functions have completed successfully. This function gets a results array
   * (or object) containing all the result arguments passed to the task callbacks.
   * Invoked with (err, results).
   *
   * @example
   * async.parallel([
   *     function(callback) {
   *         setTimeout(function() {
   *             callback(null, 'one');
   *         }, 200);
   *     },
   *     function(callback) {
   *         setTimeout(function() {
   *             callback(null, 'two');
   *         }, 100);
   *     }
   * ],
   * // optional callback
   * function(err, results) {
   *     // the results array will equal ['one','two'] even though
   *     // the second function had a shorter timeout.
   * });
   *
   * // an example using an object instead of an array
   * async.parallel({
   *     one: function(callback) {
   *         setTimeout(function() {
   *             callback(null, 1);
   *         }, 200);
   *     },
   *     two: function(callback) {
   *         setTimeout(function() {
   *             callback(null, 2);
   *         }, 100);
   *     }
   * }, function(err, results) {
   *     // results is now equals to: {one: 1, two: 2}
   * });
   */
  function parallelLimit(tasks, callback) {
    _parallel(eachOf, tasks, callback);
  }

  /**
   * The same as [`parallel`]{@link module:ControlFlow.parallel} but runs a maximum of `limit` async operations at a
   * time.
   *
   * @name parallelLimit
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @see [async.parallel]{@link module:ControlFlow.parallel}
   * @category Control Flow
   * @param {Array|Iterable|Object} tasks - A collection of
   * [async functions]{@link AsyncFunction} to run.
   * Each async function can complete with any number of optional `result` values.
   * @param {number} limit - The maximum number of async operations at a time.
   * @param {Function} [callback] - An optional callback to run once all the
   * functions have completed successfully. This function gets a results array
   * (or object) containing all the result arguments passed to the task callbacks.
   * Invoked with (err, results).
   */
  function parallelLimit$1(tasks, limit, callback) {
    _parallel(_eachOfLimit(limit), tasks, callback);
  }

  /**
   * A queue of tasks for the worker function to complete.
   * @typedef {Object} QueueObject
   * @memberOf module:ControlFlow
   * @property {Function} length - a function returning the number of items
   * waiting to be processed. Invoke with `queue.length()`.
   * @property {boolean} started - a boolean indicating whether or not any
   * items have been pushed and processed by the queue.
   * @property {Function} running - a function returning the number of items
   * currently being processed. Invoke with `queue.running()`.
   * @property {Function} workersList - a function returning the array of items
   * currently being processed. Invoke with `queue.workersList()`.
   * @property {Function} idle - a function returning false if there are items
   * waiting or being processed, or true if not. Invoke with `queue.idle()`.
   * @property {number} concurrency - an integer for determining how many `worker`
   * functions should be run in parallel. This property can be changed after a
   * `queue` is created to alter the concurrency on-the-fly.
   * @property {Function} push - add a new task to the `queue`. Calls `callback`
   * once the `worker` has finished processing the task. Instead of a single task,
   * a `tasks` array can be submitted. The respective callback is used for every
   * task in the list. Invoke with `queue.push(task, [callback])`,
   * @property {Function} unshift - add a new task to the front of the `queue`.
   * Invoke with `queue.unshift(task, [callback])`.
   * @property {Function} remove - remove items from the queue that match a test
   * function.  The test function will be passed an object with a `data` property,
   * and a `priority` property, if this is a
   * [priorityQueue]{@link module:ControlFlow.priorityQueue} object.
   * Invoked with `queue.remove(testFn)`, where `testFn` is of the form
   * `function ({data, priority}) {}` and returns a Boolean.
   * @property {Function} saturated - a callback that is called when the number of
   * running workers hits the `concurrency` limit, and further tasks will be
   * queued.
   * @property {Function} unsaturated - a callback that is called when the number
   * of running workers is less than the `concurrency` & `buffer` limits, and
   * further tasks will not be queued.
   * @property {number} buffer - A minimum threshold buffer in order to say that
   * the `queue` is `unsaturated`.
   * @property {Function} empty - a callback that is called when the last item
   * from the `queue` is given to a `worker`.
   * @property {Function} drain - a callback that is called when the last item
   * from the `queue` has returned from the `worker`.
   * @property {Function} error - a callback that is called when a task errors.
   * Has the signature `function(error, task)`.
   * @property {boolean} paused - a boolean for determining whether the queue is
   * in a paused state.
   * @property {Function} pause - a function that pauses the processing of tasks
   * until `resume()` is called. Invoke with `queue.pause()`.
   * @property {Function} resume - a function that resumes the processing of
   * queued tasks when the queue is paused. Invoke with `queue.resume()`.
   * @property {Function} kill - a function that removes the `drain` callback and
   * empties remaining tasks from the queue forcing it to go idle. No more tasks
   * should be pushed to the queue after calling this function. Invoke with `queue.kill()`.
   */

  /**
   * Creates a `queue` object with the specified `concurrency`. Tasks added to the
   * `queue` are processed in parallel (up to the `concurrency` limit). If all
   * `worker`s are in progress, the task is queued until one becomes available.
   * Once a `worker` completes a `task`, that `task`'s callback is called.
   *
   * @name queue
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @category Control Flow
   * @param {AsyncFunction} worker - An async function for processing a queued task.
   * If you want to handle errors from an individual task, pass a callback to
   * `q.push()`. Invoked with (task, callback).
   * @param {number} [concurrency=1] - An `integer` for determining how many
   * `worker` functions should be run in parallel.  If omitted, the concurrency
   * defaults to `1`.  If the concurrency is `0`, an error is thrown.
   * @returns {module:ControlFlow.QueueObject} A queue object to manage the tasks. Callbacks can
   * attached as certain properties to listen for specific events during the
   * lifecycle of the queue.
   * @example
   *
   * // create a queue object with concurrency 2
   * var q = async.queue(function(task, callback) {
   *     console.log('hello ' + task.name);
   *     callback();
   * }, 2);
   *
   * // assign a callback
   * q.drain = function() {
   *     console.log('all items have been processed');
   * };
   *
   * // add some items to the queue
   * q.push({name: 'foo'}, function(err) {
   *     console.log('finished processing foo');
   * });
   * q.push({name: 'bar'}, function (err) {
   *     console.log('finished processing bar');
   * });
   *
   * // add some items to the queue (batch-wise)
   * q.push([{name: 'baz'},{name: 'bay'},{name: 'bax'}], function(err) {
   *     console.log('finished processing item');
   * });
   *
   * // add some items to the front of the queue
   * q.unshift({name: 'bar'}, function (err) {
   *     console.log('finished processing bar');
   * });
   */
  var queue$1 = function queue$1(worker, concurrency) {
    var _worker = wrapAsync(worker);
    return queue(function (items, cb) {
      _worker(items[0], cb);
    }, concurrency, 1);
  };

  /**
   * The same as [async.queue]{@link module:ControlFlow.queue} only tasks are assigned a priority and
   * completed in ascending priority order.
   *
   * @name priorityQueue
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @see [async.queue]{@link module:ControlFlow.queue}
   * @category Control Flow
   * @param {AsyncFunction} worker - An async function for processing a queued task.
   * If you want to handle errors from an individual task, pass a callback to
   * `q.push()`.
   * Invoked with (task, callback).
   * @param {number} concurrency - An `integer` for determining how many `worker`
   * functions should be run in parallel.  If omitted, the concurrency defaults to
   * `1`.  If the concurrency is `0`, an error is thrown.
   * @returns {module:ControlFlow.QueueObject} A priorityQueue object to manage the tasks. There are two
   * differences between `queue` and `priorityQueue` objects:
   * * `push(task, priority, [callback])` - `priority` should be a number. If an
   *   array of `tasks` is given, all tasks will be assigned the same priority.
   * * The `unshift` method was removed.
   */
  var priorityQueue = function priorityQueue(worker, concurrency) {
    // Start with a normal queue
    var q = queue$1(worker, concurrency);

    // Override push to accept second parameter representing priority
    q.push = function (data, priority, callback) {
      if (callback == null) callback = noop;
      if (typeof callback !== 'function') {
        throw new Error('task callback must be a function');
      }
      q.started = true;
      if (!isArray(data)) {
        data = [data];
      }
      if (data.length === 0) {
        // call drain immediately if there are no tasks
        return setImmediate$1(function () {
          q.drain();
        });
      }
      priority = priority || 0;
      var nextNode = q._tasks.head;
      while (nextNode && priority >= nextNode.priority) {
        nextNode = nextNode.next;
      }
      for (var i = 0, l = data.length; i < l; i++) {
        var item = {
          data: data[i],
          priority: priority,
          callback: callback
        };
        if (nextNode) {
          q._tasks.insertBefore(nextNode, item);
        } else {
          q._tasks.push(item);
        }
      }
      setImmediate$1(q.process);
    };

    // Remove unshift function
    delete q.unshift;
    return q;
  };

  /**
   * Runs the `tasks` array of functions in parallel, without waiting until the
   * previous function has completed. Once any of the `tasks` complete or pass an
   * error to its callback, the main `callback` is immediately called. It's
   * equivalent to `Promise.race()`.
   *
   * @name race
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @category Control Flow
   * @param {Array} tasks - An array containing [async functions]{@link AsyncFunction}
   * to run. Each function can complete with an optional `result` value.
   * @param {Function} callback - A callback to run once any of the functions have
   * completed. This function gets an error or result from the first function that
   * completed. Invoked with (err, result).
   * @returns undefined
   * @example
   *
   * async.race([
   *     function(callback) {
   *         setTimeout(function() {
   *             callback(null, 'one');
   *         }, 200);
   *     },
   *     function(callback) {
   *         setTimeout(function() {
   *             callback(null, 'two');
   *         }, 100);
   *     }
   * ],
   * // main callback
   * function(err, result) {
   *     // the result will be equal to 'two' as it finishes earlier
   * });
   */
  function race(tasks, callback) {
    callback = once(callback || noop);
    if (!isArray(tasks)) return callback(new TypeError('First argument to race must be an array of functions'));
    if (!tasks.length) return callback();
    for (var i = 0, l = tasks.length; i < l; i++) {
      wrapAsync(tasks[i])(callback);
    }
  }

  /**
   * Same as [`reduce`]{@link module:Collections.reduce}, only operates on `array` in reverse order.
   *
   * @name reduceRight
   * @static
   * @memberOf module:Collections
   * @method
   * @see [async.reduce]{@link module:Collections.reduce}
   * @alias foldr
   * @category Collection
   * @param {Array} array - A collection to iterate over.
   * @param {*} memo - The initial state of the reduction.
   * @param {AsyncFunction} iteratee - A function applied to each item in the
   * array to produce the next step in the reduction.
   * The `iteratee` should complete with the next state of the reduction.
   * If the iteratee complete with an error, the reduction is stopped and the
   * main `callback` is immediately called with the error.
   * Invoked with (memo, item, callback).
   * @param {Function} [callback] - A callback which is called after all the
   * `iteratee` functions have finished. Result is the reduced value. Invoked with
   * (err, result).
   */
  function reduceRight(array, memo, iteratee, callback) {
    var reversed = slice(array).reverse();
    reduce(reversed, memo, iteratee, callback);
  }

  /**
   * Wraps the async function in another function that always completes with a
   * result object, even when it errors.
   *
   * The result object has either the property `error` or `value`.
   *
   * @name reflect
   * @static
   * @memberOf module:Utils
   * @method
   * @category Util
   * @param {AsyncFunction} fn - The async function you want to wrap
   * @returns {Function} - A function that always passes null to it's callback as
   * the error. The second argument to the callback will be an `object` with
   * either an `error` or a `value` property.
   * @example
   *
   * async.parallel([
   *     async.reflect(function(callback) {
   *         // do some stuff ...
   *         callback(null, 'one');
   *     }),
   *     async.reflect(function(callback) {
   *         // do some more stuff but error ...
   *         callback('bad stuff happened');
   *     }),
   *     async.reflect(function(callback) {
   *         // do some more stuff ...
   *         callback(null, 'two');
   *     })
   * ],
   * // optional callback
   * function(err, results) {
   *     // values
   *     // results[0].value = 'one'
   *     // results[1].error = 'bad stuff happened'
   *     // results[2].value = 'two'
   * });
   */
  function reflect(fn) {
    var _fn = wrapAsync(fn);
    return initialParams(function reflectOn(args, reflectCallback) {
      args.push(function callback(error, cbArg) {
        if (error) {
          reflectCallback(null, {
            error: error
          });
        } else {
          var value;
          if (arguments.length <= 2) {
            value = cbArg;
          } else {
            value = slice(arguments, 1);
          }
          reflectCallback(null, {
            value: value
          });
        }
      });
      return _fn.apply(this, args);
    });
  }

  /**
   * A helper function that wraps an array or an object of functions with `reflect`.
   *
   * @name reflectAll
   * @static
   * @memberOf module:Utils
   * @method
   * @see [async.reflect]{@link module:Utils.reflect}
   * @category Util
   * @param {Array|Object|Iterable} tasks - The collection of
   * [async functions]{@link AsyncFunction} to wrap in `async.reflect`.
   * @returns {Array} Returns an array of async functions, each wrapped in
   * `async.reflect`
   * @example
   *
   * let tasks = [
   *     function(callback) {
   *         setTimeout(function() {
   *             callback(null, 'one');
   *         }, 200);
   *     },
   *     function(callback) {
   *         // do some more stuff but error ...
   *         callback(new Error('bad stuff happened'));
   *     },
   *     function(callback) {
   *         setTimeout(function() {
   *             callback(null, 'two');
   *         }, 100);
   *     }
   * ];
   *
   * async.parallel(async.reflectAll(tasks),
   * // optional callback
   * function(err, results) {
   *     // values
   *     // results[0].value = 'one'
   *     // results[1].error = Error('bad stuff happened')
   *     // results[2].value = 'two'
   * });
   *
   * // an example using an object instead of an array
   * let tasks = {
   *     one: function(callback) {
   *         setTimeout(function() {
   *             callback(null, 'one');
   *         }, 200);
   *     },
   *     two: function(callback) {
   *         callback('two');
   *     },
   *     three: function(callback) {
   *         setTimeout(function() {
   *             callback(null, 'three');
   *         }, 100);
   *     }
   * };
   *
   * async.parallel(async.reflectAll(tasks),
   * // optional callback
   * function(err, results) {
   *     // values
   *     // results.one.value = 'one'
   *     // results.two.error = 'two'
   *     // results.three.value = 'three'
   * });
   */
  function reflectAll(tasks) {
    var results;
    if (isArray(tasks)) {
      results = arrayMap(tasks, reflect);
    } else {
      results = {};
      baseForOwn(tasks, function (task, key) {
        results[key] = reflect.call(this, task);
      });
    }
    return results;
  }
  function reject$1(eachfn, arr, iteratee, callback) {
    _filter(eachfn, arr, function (value, cb) {
      iteratee(value, function (err, v) {
        cb(err, !v);
      });
    }, callback);
  }

  /**
   * The opposite of [`filter`]{@link module:Collections.filter}. Removes values that pass an `async` truth test.
   *
   * @name reject
   * @static
   * @memberOf module:Collections
   * @method
   * @see [async.filter]{@link module:Collections.filter}
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {Function} iteratee - An async truth test to apply to each item in
   * `coll`.
   * The should complete with a boolean value as its `result`.
   * Invoked with (item, callback).
   * @param {Function} [callback] - A callback which is called after all the
   * `iteratee` functions have finished. Invoked with (err, results).
   * @example
   *
   * async.reject(['file1','file2','file3'], function(filePath, callback) {
   *     fs.access(filePath, function(err) {
   *         callback(null, !err)
   *     });
   * }, function(err, results) {
   *     // results now equals an array of missing files
   *     createFiles(results);
   * });
   */
  var reject = doParallel(reject$1);

  /**
   * The same as [`reject`]{@link module:Collections.reject} but runs a maximum of `limit` async operations at a
   * time.
   *
   * @name rejectLimit
   * @static
   * @memberOf module:Collections
   * @method
   * @see [async.reject]{@link module:Collections.reject}
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {number} limit - The maximum number of async operations at a time.
   * @param {Function} iteratee - An async truth test to apply to each item in
   * `coll`.
   * The should complete with a boolean value as its `result`.
   * Invoked with (item, callback).
   * @param {Function} [callback] - A callback which is called after all the
   * `iteratee` functions have finished. Invoked with (err, results).
   */
  var rejectLimit = doParallelLimit(reject$1);

  /**
   * The same as [`reject`]{@link module:Collections.reject} but runs only a single async operation at a time.
   *
   * @name rejectSeries
   * @static
   * @memberOf module:Collections
   * @method
   * @see [async.reject]{@link module:Collections.reject}
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {Function} iteratee - An async truth test to apply to each item in
   * `coll`.
   * The should complete with a boolean value as its `result`.
   * Invoked with (item, callback).
   * @param {Function} [callback] - A callback which is called after all the
   * `iteratee` functions have finished. Invoked with (err, results).
   */
  var rejectSeries = doLimit(rejectLimit, 1);

  /**
   * Creates a function that returns `value`.
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Util
   * @param {*} value The value to return from the new function.
   * @returns {Function} Returns the new constant function.
   * @example
   *
   * var objects = _.times(2, _.constant({ 'a': 1 }));
   *
   * console.log(objects);
   * // => [{ 'a': 1 }, { 'a': 1 }]
   *
   * console.log(objects[0] === objects[1]);
   * // => true
   */
  function constant$1(value) {
    return function () {
      return value;
    };
  }

  /**
   * Attempts to get a successful response from `task` no more than `times` times
   * before returning an error. If the task is successful, the `callback` will be
   * passed the result of the successful task. If all attempts fail, the callback
   * will be passed the error and result (if any) of the final attempt.
   *
   * @name retry
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @category Control Flow
   * @see [async.retryable]{@link module:ControlFlow.retryable}
   * @param {Object|number} [opts = {times: 5, interval: 0}| 5] - Can be either an
   * object with `times` and `interval` or a number.
   * * `times` - The number of attempts to make before giving up.  The default
   *   is `5`.
   * * `interval` - The time to wait between retries, in milliseconds.  The
   *   default is `0`. The interval may also be specified as a function of the
   *   retry count (see example).
   * * `errorFilter` - An optional synchronous function that is invoked on
   *   erroneous result. If it returns `true` the retry attempts will continue;
   *   if the function returns `false` the retry flow is aborted with the current
   *   attempt's error and result being returned to the final callback.
   *   Invoked with (err).
   * * If `opts` is a number, the number specifies the number of times to retry,
   *   with the default interval of `0`.
   * @param {AsyncFunction} task - An async function to retry.
   * Invoked with (callback).
   * @param {Function} [callback] - An optional callback which is called when the
   * task has succeeded, or after the final failed attempt. It receives the `err`
   * and `result` arguments of the last attempt at completing the `task`. Invoked
   * with (err, results).
   *
   * @example
   *
   * // The `retry` function can be used as a stand-alone control flow by passing
   * // a callback, as shown below:
   *
   * // try calling apiMethod 3 times
   * async.retry(3, apiMethod, function(err, result) {
   *     // do something with the result
   * });
   *
   * // try calling apiMethod 3 times, waiting 200 ms between each retry
   * async.retry({times: 3, interval: 200}, apiMethod, function(err, result) {
   *     // do something with the result
   * });
   *
   * // try calling apiMethod 10 times with exponential backoff
   * // (i.e. intervals of 100, 200, 400, 800, 1600, ... milliseconds)
   * async.retry({
   *   times: 10,
   *   interval: function(retryCount) {
   *     return 50 * Math.pow(2, retryCount);
   *   }
   * }, apiMethod, function(err, result) {
   *     // do something with the result
   * });
   *
   * // try calling apiMethod the default 5 times no delay between each retry
   * async.retry(apiMethod, function(err, result) {
   *     // do something with the result
   * });
   *
   * // try calling apiMethod only when error condition satisfies, all other
   * // errors will abort the retry control flow and return to final callback
   * async.retry({
   *   errorFilter: function(err) {
   *     return err.message === 'Temporary error'; // only retry on a specific error
   *   }
   * }, apiMethod, function(err, result) {
   *     // do something with the result
   * });
   *
   * // to retry individual methods that are not as reliable within other
   * // control flow functions, use the `retryable` wrapper:
   * async.auto({
   *     users: api.getUsers.bind(api),
   *     payments: async.retryable(3, api.getPayments.bind(api))
   * }, function(err, results) {
   *     // do something with the results
   * });
   *
   */
  function retry(opts, task, callback) {
    var DEFAULT_TIMES = 5;
    var DEFAULT_INTERVAL = 0;
    var options = {
      times: DEFAULT_TIMES,
      intervalFunc: constant$1(DEFAULT_INTERVAL)
    };
    function parseTimes(acc, t) {
      if (_typeof(t) === 'object') {
        acc.times = +t.times || DEFAULT_TIMES;
        acc.intervalFunc = typeof t.interval === 'function' ? t.interval : constant$1(+t.interval || DEFAULT_INTERVAL);
        acc.errorFilter = t.errorFilter;
      } else if (typeof t === 'number' || typeof t === 'string') {
        acc.times = +t || DEFAULT_TIMES;
      } else {
        throw new Error("Invalid arguments for async.retry");
      }
    }
    if (arguments.length < 3 && typeof opts === 'function') {
      callback = task || noop;
      task = opts;
    } else {
      parseTimes(options, opts);
      callback = callback || noop;
    }
    if (typeof task !== 'function') {
      throw new Error("Invalid arguments for async.retry");
    }
    var _task = wrapAsync(task);
    var attempt = 1;
    function retryAttempt() {
      _task(function (err) {
        if (err && attempt++ < options.times && (typeof options.errorFilter != 'function' || options.errorFilter(err))) {
          setTimeout(retryAttempt, options.intervalFunc(attempt));
        } else {
          callback.apply(null, arguments);
        }
      });
    }
    retryAttempt();
  }

  /**
   * A close relative of [`retry`]{@link module:ControlFlow.retry}.  This method
   * wraps a task and makes it retryable, rather than immediately calling it
   * with retries.
   *
   * @name retryable
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @see [async.retry]{@link module:ControlFlow.retry}
   * @category Control Flow
   * @param {Object|number} [opts = {times: 5, interval: 0}| 5] - optional
   * options, exactly the same as from `retry`
   * @param {AsyncFunction} task - the asynchronous function to wrap.
   * This function will be passed any arguments passed to the returned wrapper.
   * Invoked with (...args, callback).
   * @returns {AsyncFunction} The wrapped function, which when invoked, will
   * retry on an error, based on the parameters specified in `opts`.
   * This function will accept the same parameters as `task`.
   * @example
   *
   * async.auto({
   *     dep1: async.retryable(3, getFromFlakyService),
   *     process: ["dep1", async.retryable(3, function (results, cb) {
   *         maybeProcessData(results.dep1, cb);
   *     })]
   * }, callback);
   */
  var retryable = function retryable(opts, task) {
    if (!task) {
      task = opts;
      opts = null;
    }
    var _task = wrapAsync(task);
    return initialParams(function (args, callback) {
      function taskFn(cb) {
        _task.apply(null, args.concat(cb));
      }
      if (opts) retry(opts, taskFn, callback);else retry(taskFn, callback);
    });
  };

  /**
   * Run the functions in the `tasks` collection in series, each one running once
   * the previous function has completed. If any functions in the series pass an
   * error to its callback, no more functions are run, and `callback` is
   * immediately called with the value of the error. Otherwise, `callback`
   * receives an array of results when `tasks` have completed.
   *
   * It is also possible to use an object instead of an array. Each property will
   * be run as a function, and the results will be passed to the final `callback`
   * as an object instead of an array. This can be a more readable way of handling
   *  results from {@link async.series}.
   *
   * **Note** that while many implementations preserve the order of object
   * properties, the [ECMAScript Language Specification](http://www.ecma-international.org/ecma-262/5.1/#sec-8.6)
   * explicitly states that
   *
   * > The mechanics and order of enumerating the properties is not specified.
   *
   * So if you rely on the order in which your series of functions are executed,
   * and want this to work on all platforms, consider using an array.
   *
   * @name series
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @category Control Flow
   * @param {Array|Iterable|Object} tasks - A collection containing
   * [async functions]{@link AsyncFunction} to run in series.
   * Each function can complete with any number of optional `result` values.
   * @param {Function} [callback] - An optional callback to run once all the
   * functions have completed. This function gets a results array (or object)
   * containing all the result arguments passed to the `task` callbacks. Invoked
   * with (err, result).
   * @example
   * async.series([
   *     function(callback) {
   *         // do some stuff ...
   *         callback(null, 'one');
   *     },
   *     function(callback) {
   *         // do some more stuff ...
   *         callback(null, 'two');
   *     }
   * ],
   * // optional callback
   * function(err, results) {
   *     // results is now equal to ['one', 'two']
   * });
   *
   * async.series({
   *     one: function(callback) {
   *         setTimeout(function() {
   *             callback(null, 1);
   *         }, 200);
   *     },
   *     two: function(callback){
   *         setTimeout(function() {
   *             callback(null, 2);
   *         }, 100);
   *     }
   * }, function(err, results) {
   *     // results is now equal to: {one: 1, two: 2}
   * });
   */
  function series(tasks, callback) {
    _parallel(eachOfSeries, tasks, callback);
  }

  /**
   * Returns `true` if at least one element in the `coll` satisfies an async test.
   * If any iteratee call returns `true`, the main `callback` is immediately
   * called.
   *
   * @name some
   * @static
   * @memberOf module:Collections
   * @method
   * @alias any
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {AsyncFunction} iteratee - An async truth test to apply to each item
   * in the collections in parallel.
   * The iteratee should complete with a boolean `result` value.
   * Invoked with (item, callback).
   * @param {Function} [callback] - A callback which is called as soon as any
   * iteratee returns `true`, or after all the iteratee functions have finished.
   * Result will be either `true` or `false` depending on the values of the async
   * tests. Invoked with (err, result).
   * @example
   *
   * async.some(['file1','file2','file3'], function(filePath, callback) {
   *     fs.access(filePath, function(err) {
   *         callback(null, !err)
   *     });
   * }, function(err, result) {
   *     // if result is true then at least one of the files exists
   * });
   */
  var some = doParallel(_createTester(Boolean, identity));

  /**
   * The same as [`some`]{@link module:Collections.some} but runs a maximum of `limit` async operations at a time.
   *
   * @name someLimit
   * @static
   * @memberOf module:Collections
   * @method
   * @see [async.some]{@link module:Collections.some}
   * @alias anyLimit
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {number} limit - The maximum number of async operations at a time.
   * @param {AsyncFunction} iteratee - An async truth test to apply to each item
   * in the collections in parallel.
   * The iteratee should complete with a boolean `result` value.
   * Invoked with (item, callback).
   * @param {Function} [callback] - A callback which is called as soon as any
   * iteratee returns `true`, or after all the iteratee functions have finished.
   * Result will be either `true` or `false` depending on the values of the async
   * tests. Invoked with (err, result).
   */
  var someLimit = doParallelLimit(_createTester(Boolean, identity));

  /**
   * The same as [`some`]{@link module:Collections.some} but runs only a single async operation at a time.
   *
   * @name someSeries
   * @static
   * @memberOf module:Collections
   * @method
   * @see [async.some]{@link module:Collections.some}
   * @alias anySeries
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {AsyncFunction} iteratee - An async truth test to apply to each item
   * in the collections in series.
   * The iteratee should complete with a boolean `result` value.
   * Invoked with (item, callback).
   * @param {Function} [callback] - A callback which is called as soon as any
   * iteratee returns `true`, or after all the iteratee functions have finished.
   * Result will be either `true` or `false` depending on the values of the async
   * tests. Invoked with (err, result).
   */
  var someSeries = doLimit(someLimit, 1);

  /**
   * Sorts a list by the results of running each `coll` value through an async
   * `iteratee`.
   *
   * @name sortBy
   * @static
   * @memberOf module:Collections
   * @method
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {AsyncFunction} iteratee - An async function to apply to each item in
   * `coll`.
   * The iteratee should complete with a value to use as the sort criteria as
   * its `result`.
   * Invoked with (item, callback).
   * @param {Function} callback - A callback which is called after all the
   * `iteratee` functions have finished, or an error occurs. Results is the items
   * from the original `coll` sorted by the values returned by the `iteratee`
   * calls. Invoked with (err, results).
   * @example
   *
   * async.sortBy(['file1','file2','file3'], function(file, callback) {
   *     fs.stat(file, function(err, stats) {
   *         callback(err, stats.mtime);
   *     });
   * }, function(err, results) {
   *     // results is now the original array of files sorted by
   *     // modified date
   * });
   *
   * // By modifying the callback parameter the
   * // sorting order can be influenced:
   *
   * // ascending order
   * async.sortBy([1,9,3,5], function(x, callback) {
   *     callback(null, x);
   * }, function(err,result) {
   *     // result callback
   * });
   *
   * // descending order
   * async.sortBy([1,9,3,5], function(x, callback) {
   *     callback(null, x*-1);    //<- x*-1 instead of x, turns the order around
   * }, function(err,result) {
   *     // result callback
   * });
   */
  function sortBy(coll, iteratee, callback) {
    var _iteratee = wrapAsync(iteratee);
    map(coll, function (x, callback) {
      _iteratee(x, function (err, criteria) {
        if (err) return callback(err);
        callback(null, {
          value: x,
          criteria: criteria
        });
      });
    }, function (err, results) {
      if (err) return callback(err);
      callback(null, arrayMap(results.sort(comparator), baseProperty('value')));
    });
    function comparator(left, right) {
      var a = left.criteria,
        b = right.criteria;
      return a < b ? -1 : a > b ? 1 : 0;
    }
  }

  /**
   * Sets a time limit on an asynchronous function. If the function does not call
   * its callback within the specified milliseconds, it will be called with a
   * timeout error. The code property for the error object will be `'ETIMEDOUT'`.
   *
   * @name timeout
   * @static
   * @memberOf module:Utils
   * @method
   * @category Util
   * @param {AsyncFunction} asyncFn - The async function to limit in time.
   * @param {number} milliseconds - The specified time limit.
   * @param {*} [info] - Any variable you want attached (`string`, `object`, etc)
   * to timeout Error for more information..
   * @returns {AsyncFunction} Returns a wrapped function that can be used with any
   * of the control flow functions.
   * Invoke this function with the same parameters as you would `asyncFunc`.
   * @example
   *
   * function myFunction(foo, callback) {
   *     doAsyncTask(foo, function(err, data) {
   *         // handle errors
   *         if (err) return callback(err);
   *
   *         // do some stuff ...
   *
   *         // return processed data
   *         return callback(null, data);
   *     });
   * }
   *
   * var wrapped = async.timeout(myFunction, 1000);
   *
   * // call `wrapped` as you would `myFunction`
   * wrapped({ bar: 'bar' }, function(err, data) {
   *     // if `myFunction` takes < 1000 ms to execute, `err`
   *     // and `data` will have their expected values
   *
   *     // else `err` will be an Error with the code 'ETIMEDOUT'
   * });
   */
  function timeout(asyncFn, milliseconds, info) {
    var fn = wrapAsync(asyncFn);
    return initialParams(function (args, callback) {
      var timedOut = false;
      var timer;
      function timeoutCallback() {
        var name = asyncFn.name || 'anonymous';
        var error = new Error('Callback function "' + name + '" timed out.');
        error.code = 'ETIMEDOUT';
        if (info) {
          error.info = info;
        }
        timedOut = true;
        callback(error);
      }
      args.push(function () {
        if (!timedOut) {
          callback.apply(null, arguments);
          clearTimeout(timer);
        }
      });

      // setup timer and call original function
      timer = setTimeout(timeoutCallback, milliseconds);
      fn.apply(null, args);
    });
  }

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeCeil = Math.ceil;
  var nativeMax = Math.max;

  /**
   * The base implementation of `_.range` and `_.rangeRight` which doesn't
   * coerce arguments.
   *
   * @private
   * @param {number} start The start of the range.
   * @param {number} end The end of the range.
   * @param {number} step The value to increment or decrement by.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Array} Returns the range of numbers.
   */
  function baseRange(start, end, step, fromRight) {
    var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);
    while (length--) {
      result[fromRight ? length : ++index] = start;
      start += step;
    }
    return result;
  }

  /**
   * The same as [times]{@link module:ControlFlow.times} but runs a maximum of `limit` async operations at a
   * time.
   *
   * @name timesLimit
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @see [async.times]{@link module:ControlFlow.times}
   * @category Control Flow
   * @param {number} count - The number of times to run the function.
   * @param {number} limit - The maximum number of async operations at a time.
   * @param {AsyncFunction} iteratee - The async function to call `n` times.
   * Invoked with the iteration index and a callback: (n, next).
   * @param {Function} callback - see [async.map]{@link module:Collections.map}.
   */
  function timeLimit(count, limit, iteratee, callback) {
    var _iteratee = wrapAsync(iteratee);
    mapLimit(baseRange(0, count, 1), limit, _iteratee, callback);
  }

  /**
   * Calls the `iteratee` function `n` times, and accumulates results in the same
   * manner you would use with [map]{@link module:Collections.map}.
   *
   * @name times
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @see [async.map]{@link module:Collections.map}
   * @category Control Flow
   * @param {number} n - The number of times to run the function.
   * @param {AsyncFunction} iteratee - The async function to call `n` times.
   * Invoked with the iteration index and a callback: (n, next).
   * @param {Function} callback - see {@link module:Collections.map}.
   * @example
   *
   * // Pretend this is some complicated async factory
   * var createUser = function(id, callback) {
   *     callback(null, {
   *         id: 'user' + id
   *     });
   * };
   *
   * // generate 5 users
   * async.times(5, function(n, next) {
   *     createUser(n, function(err, user) {
   *         next(err, user);
   *     });
   * }, function(err, users) {
   *     // we should now have 5 users
   * });
   */
  var times = doLimit(timeLimit, Infinity);

  /**
   * The same as [times]{@link module:ControlFlow.times} but runs only a single async operation at a time.
   *
   * @name timesSeries
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @see [async.times]{@link module:ControlFlow.times}
   * @category Control Flow
   * @param {number} n - The number of times to run the function.
   * @param {AsyncFunction} iteratee - The async function to call `n` times.
   * Invoked with the iteration index and a callback: (n, next).
   * @param {Function} callback - see {@link module:Collections.map}.
   */
  var timesSeries = doLimit(timeLimit, 1);

  /**
   * A relative of `reduce`.  Takes an Object or Array, and iterates over each
   * element in series, each step potentially mutating an `accumulator` value.
   * The type of the accumulator defaults to the type of collection passed in.
   *
   * @name transform
   * @static
   * @memberOf module:Collections
   * @method
   * @category Collection
   * @param {Array|Iterable|Object} coll - A collection to iterate over.
   * @param {*} [accumulator] - The initial state of the transform.  If omitted,
   * it will default to an empty Object or Array, depending on the type of `coll`
   * @param {AsyncFunction} iteratee - A function applied to each item in the
   * collection that potentially modifies the accumulator.
   * Invoked with (accumulator, item, key, callback).
   * @param {Function} [callback] - A callback which is called after all the
   * `iteratee` functions have finished. Result is the transformed accumulator.
   * Invoked with (err, result).
   * @example
   *
   * async.transform([1,2,3], function(acc, item, index, callback) {
   *     // pointless async:
   *     process.nextTick(function() {
   *         acc.push(item * 2)
   *         callback(null)
   *     });
   * }, function(err, result) {
   *     // result is now equal to [2, 4, 6]
   * });
   *
   * @example
   *
   * async.transform({a: 1, b: 2, c: 3}, function (obj, val, key, callback) {
   *     setImmediate(function () {
   *         obj[key] = val * 2;
   *         callback();
   *     })
   * }, function (err, result) {
   *     // result is equal to {a: 2, b: 4, c: 6}
   * })
   */
  function transform(coll, accumulator, iteratee, callback) {
    if (arguments.length <= 3) {
      callback = iteratee;
      iteratee = accumulator;
      accumulator = isArray(coll) ? [] : {};
    }
    callback = once(callback || noop);
    var _iteratee = wrapAsync(iteratee);
    eachOf(coll, function (v, k, cb) {
      _iteratee(accumulator, v, k, cb);
    }, function (err) {
      callback(err, accumulator);
    });
  }

  /**
   * It runs each task in series but stops whenever any of the functions were
   * successful. If one of the tasks were successful, the `callback` will be
   * passed the result of the successful task. If all tasks fail, the callback
   * will be passed the error and result (if any) of the final attempt.
   *
   * @name tryEach
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @category Control Flow
   * @param {Array|Iterable|Object} tasks - A collection containing functions to
   * run, each function is passed a `callback(err, result)` it must call on
   * completion with an error `err` (which can be `null`) and an optional `result`
   * value.
   * @param {Function} [callback] - An optional callback which is called when one
   * of the tasks has succeeded, or all have failed. It receives the `err` and
   * `result` arguments of the last attempt at completing the `task`. Invoked with
   * (err, results).
   * @example
   * async.tryEach([
   *     function getDataFromFirstWebsite(callback) {
   *         // Try getting the data from the first website
   *         callback(err, data);
   *     },
   *     function getDataFromSecondWebsite(callback) {
   *         // First website failed,
   *         // Try getting the data from the backup website
   *         callback(err, data);
   *     }
   * ],
   * // optional callback
   * function(err, results) {
   *     Now do something with the data.
   * });
   *
   */
  function tryEach(tasks, callback) {
    var error = null;
    var result;
    callback = callback || noop;
    eachSeries(tasks, function (task, callback) {
      wrapAsync(task)(function (err, res /*, ...args*/) {
        if (arguments.length > 2) {
          result = slice(arguments, 1);
        } else {
          result = res;
        }
        error = err;
        callback(!err);
      });
    }, function () {
      callback(error, result);
    });
  }

  /**
   * Undoes a [memoize]{@link module:Utils.memoize}d function, reverting it to the original,
   * unmemoized form. Handy for testing.
   *
   * @name unmemoize
   * @static
   * @memberOf module:Utils
   * @method
   * @see [async.memoize]{@link module:Utils.memoize}
   * @category Util
   * @param {AsyncFunction} fn - the memoized function
   * @returns {AsyncFunction} a function that calls the original unmemoized function
   */
  function unmemoize(fn) {
    return function () {
      return (fn.unmemoized || fn).apply(null, arguments);
    };
  }

  /**
   * Repeatedly call `iteratee`, while `test` returns `true`. Calls `callback` when
   * stopped, or an error occurs.
   *
   * @name whilst
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @category Control Flow
   * @param {Function} test - synchronous truth test to perform before each
   * execution of `iteratee`. Invoked with ().
   * @param {AsyncFunction} iteratee - An async function which is called each time
   * `test` passes. Invoked with (callback).
   * @param {Function} [callback] - A callback which is called after the test
   * function has failed and repeated execution of `iteratee` has stopped. `callback`
   * will be passed an error and any arguments passed to the final `iteratee`'s
   * callback. Invoked with (err, [results]);
   * @returns undefined
   * @example
   *
   * var count = 0;
   * async.whilst(
   *     function() { return count < 5; },
   *     function(callback) {
   *         count++;
   *         setTimeout(function() {
   *             callback(null, count);
   *         }, 1000);
   *     },
   *     function (err, n) {
   *         // 5 seconds have passed, n = 5
   *     }
   * );
   */
  function whilst(test, iteratee, callback) {
    callback = onlyOnce(callback || noop);
    var _iteratee = wrapAsync(iteratee);
    if (!test()) return callback(null);
    var next = function next(err /*, ...args*/) {
      if (err) return callback(err);
      if (test()) return _iteratee(next);
      var args = slice(arguments, 1);
      callback.apply(null, [null].concat(args));
    };
    _iteratee(next);
  }

  /**
   * Repeatedly call `iteratee` until `test` returns `true`. Calls `callback` when
   * stopped, or an error occurs. `callback` will be passed an error and any
   * arguments passed to the final `iteratee`'s callback.
   *
   * The inverse of [whilst]{@link module:ControlFlow.whilst}.
   *
   * @name until
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @see [async.whilst]{@link module:ControlFlow.whilst}
   * @category Control Flow
   * @param {Function} test - synchronous truth test to perform before each
   * execution of `iteratee`. Invoked with ().
   * @param {AsyncFunction} iteratee - An async function which is called each time
   * `test` fails. Invoked with (callback).
   * @param {Function} [callback] - A callback which is called after the test
   * function has passed and repeated execution of `iteratee` has stopped. `callback`
   * will be passed an error and any arguments passed to the final `iteratee`'s
   * callback. Invoked with (err, [results]);
   */
  function until(test, iteratee, callback) {
    whilst(function () {
      return !test.apply(this, arguments);
    }, iteratee, callback);
  }

  /**
   * Runs the `tasks` array of functions in series, each passing their results to
   * the next in the array. However, if any of the `tasks` pass an error to their
   * own callback, the next function is not executed, and the main `callback` is
   * immediately called with the error.
   *
   * @name waterfall
   * @static
   * @memberOf module:ControlFlow
   * @method
   * @category Control Flow
   * @param {Array} tasks - An array of [async functions]{@link AsyncFunction}
   * to run.
   * Each function should complete with any number of `result` values.
   * The `result` values will be passed as arguments, in order, to the next task.
   * @param {Function} [callback] - An optional callback to run once all the
   * functions have completed. This will be passed the results of the last task's
   * callback. Invoked with (err, [results]).
   * @returns undefined
   * @example
   *
   * async.waterfall([
   *     function(callback) {
   *         callback(null, 'one', 'two');
   *     },
   *     function(arg1, arg2, callback) {
   *         // arg1 now equals 'one' and arg2 now equals 'two'
   *         callback(null, 'three');
   *     },
   *     function(arg1, callback) {
   *         // arg1 now equals 'three'
   *         callback(null, 'done');
   *     }
   * ], function (err, result) {
   *     // result now equals 'done'
   * });
   *
   * // Or, with named functions:
   * async.waterfall([
   *     myFirstFunction,
   *     mySecondFunction,
   *     myLastFunction,
   * ], function (err, result) {
   *     // result now equals 'done'
   * });
   * function myFirstFunction(callback) {
   *     callback(null, 'one', 'two');
   * }
   * function mySecondFunction(arg1, arg2, callback) {
   *     // arg1 now equals 'one' and arg2 now equals 'two'
   *     callback(null, 'three');
   * }
   * function myLastFunction(arg1, callback) {
   *     // arg1 now equals 'three'
   *     callback(null, 'done');
   * }
   */
  var waterfall = function waterfall(tasks, callback) {
    callback = once(callback || noop);
    if (!isArray(tasks)) return callback(new Error('First argument to waterfall must be an array of functions'));
    if (!tasks.length) return callback();
    var taskIndex = 0;
    function nextTask(args) {
      var task = wrapAsync(tasks[taskIndex++]);
      args.push(onlyOnce(next));
      task.apply(null, args);
    }
    function next(err /*, ...args*/) {
      if (err || taskIndex === tasks.length) {
        return callback.apply(null, arguments);
      }
      nextTask(slice(arguments, 1));
    }
    nextTask([]);
  };

  /**
   * An "async function" in the context of Async is an asynchronous function with
   * a variable number of parameters, with the final parameter being a callback.
   * (`function (arg1, arg2, ..., callback) {}`)
   * The final callback is of the form `callback(err, results...)`, which must be
   * called once the function is completed.  The callback should be called with a
   * Error as its first argument to signal that an error occurred.
   * Otherwise, if no error occurred, it should be called with `null` as the first
   * argument, and any additional `result` arguments that may apply, to signal
   * successful completion.
   * The callback must be called exactly once, ideally on a later tick of the
   * JavaScript event loop.
   *
   * This type of function is also referred to as a "Node-style async function",
   * or a "continuation passing-style function" (CPS). Most of the methods of this
   * library are themselves CPS/Node-style async functions, or functions that
   * return CPS/Node-style async functions.
   *
   * Wherever we accept a Node-style async function, we also directly accept an
   * [ES2017 `async` function]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/async_function}.
   * In this case, the `async` function will not be passed a final callback
   * argument, and any thrown error will be used as the `err` argument of the
   * implicit callback, and the return value will be used as the `result` value.
   * (i.e. a `rejected` of the returned Promise becomes the `err` callback
   * argument, and a `resolved` value becomes the `result`.)
   *
   * Note, due to JavaScript limitations, we can only detect native `async`
   * functions and not transpilied implementations.
   * Your environment must have `async`/`await` support for this to work.
   * (e.g. Node > v7.6, or a recent version of a modern browser).
   * If you are using `async` functions through a transpiler (e.g. Babel), you
   * must still wrap the function with [asyncify]{@link module:Utils.asyncify},
   * because the `async function` will be compiled to an ordinary function that
   * returns a promise.
   *
   * @typedef {Function} AsyncFunction
   * @static
   */

  /**
   * Async is a utility module which provides straight-forward, powerful functions
   * for working with asynchronous JavaScript. Although originally designed for
   * use with [Node.js](http://nodejs.org) and installable via
   * `npm install --save async`, it can also be used directly in the browser.
   * @module async
   * @see AsyncFunction
   */

  /**
   * A collection of `async` functions for manipulating collections, such as
   * arrays and objects.
   * @module Collections
   */

  /**
   * A collection of `async` functions for controlling the flow through a script.
   * @module ControlFlow
   */

  /**
   * A collection of `async` utility functions.
   * @module Utils
   */

  var index = {
    apply: apply,
    applyEach: applyEach,
    applyEachSeries: applyEachSeries,
    asyncify: asyncify,
    auto: auto,
    autoInject: autoInject,
    cargo: cargo,
    compose: compose,
    concat: concat,
    concatLimit: concatLimit,
    concatSeries: concatSeries,
    constant: constant,
    detect: detect,
    detectLimit: detectLimit,
    detectSeries: detectSeries,
    dir: dir,
    doDuring: doDuring,
    doUntil: doUntil,
    doWhilst: doWhilst,
    during: during,
    each: eachLimit,
    eachLimit: eachLimit$1,
    eachOf: eachOf,
    eachOfLimit: eachOfLimit,
    eachOfSeries: eachOfSeries,
    eachSeries: eachSeries,
    ensureAsync: ensureAsync,
    every: every,
    everyLimit: everyLimit,
    everySeries: everySeries,
    filter: filter,
    filterLimit: filterLimit,
    filterSeries: filterSeries,
    forever: forever,
    groupBy: groupBy,
    groupByLimit: groupByLimit,
    groupBySeries: groupBySeries,
    log: log,
    map: map,
    mapLimit: mapLimit,
    mapSeries: mapSeries,
    mapValues: mapValues,
    mapValuesLimit: mapValuesLimit,
    mapValuesSeries: mapValuesSeries,
    memoize: memoize,
    nextTick: nextTick,
    parallel: parallelLimit,
    parallelLimit: parallelLimit$1,
    priorityQueue: priorityQueue,
    queue: queue$1,
    race: race,
    reduce: reduce,
    reduceRight: reduceRight,
    reflect: reflect,
    reflectAll: reflectAll,
    reject: reject,
    rejectLimit: rejectLimit,
    rejectSeries: rejectSeries,
    retry: retry,
    retryable: retryable,
    seq: seq,
    series: series,
    setImmediate: setImmediate$1,
    some: some,
    someLimit: someLimit,
    someSeries: someSeries,
    sortBy: sortBy,
    timeout: timeout,
    times: times,
    timesLimit: timeLimit,
    timesSeries: timesSeries,
    transform: transform,
    tryEach: tryEach,
    unmemoize: unmemoize,
    until: until,
    waterfall: waterfall,
    whilst: whilst,
    // aliases
    all: every,
    allLimit: everyLimit,
    allSeries: everySeries,
    any: some,
    anyLimit: someLimit,
    anySeries: someSeries,
    find: detect,
    findLimit: detectLimit,
    findSeries: detectSeries,
    forEach: eachLimit,
    forEachSeries: eachSeries,
    forEachLimit: eachLimit$1,
    forEachOf: eachOf,
    forEachOfSeries: eachOfSeries,
    forEachOfLimit: eachOfLimit,
    inject: reduce,
    foldl: reduce,
    foldr: reduceRight,
    select: filter,
    selectLimit: filterLimit,
    selectSeries: filterSeries,
    wrapSync: asyncify
  };
  exports['default'] = index;
  exports.apply = apply;
  exports.applyEach = applyEach;
  exports.applyEachSeries = applyEachSeries;
  exports.asyncify = asyncify;
  exports.auto = auto;
  exports.autoInject = autoInject;
  exports.cargo = cargo;
  exports.compose = compose;
  exports.concat = concat;
  exports.concatLimit = concatLimit;
  exports.concatSeries = concatSeries;
  exports.constant = constant;
  exports.detect = detect;
  exports.detectLimit = detectLimit;
  exports.detectSeries = detectSeries;
  exports.dir = dir;
  exports.doDuring = doDuring;
  exports.doUntil = doUntil;
  exports.doWhilst = doWhilst;
  exports.during = during;
  exports.each = eachLimit;
  exports.eachLimit = eachLimit$1;
  exports.eachOf = eachOf;
  exports.eachOfLimit = eachOfLimit;
  exports.eachOfSeries = eachOfSeries;
  exports.eachSeries = eachSeries;
  exports.ensureAsync = ensureAsync;
  exports.every = every;
  exports.everyLimit = everyLimit;
  exports.everySeries = everySeries;
  exports.filter = filter;
  exports.filterLimit = filterLimit;
  exports.filterSeries = filterSeries;
  exports.forever = forever;
  exports.groupBy = groupBy;
  exports.groupByLimit = groupByLimit;
  exports.groupBySeries = groupBySeries;
  exports.log = log;
  exports.map = map;
  exports.mapLimit = mapLimit;
  exports.mapSeries = mapSeries;
  exports.mapValues = mapValues;
  exports.mapValuesLimit = mapValuesLimit;
  exports.mapValuesSeries = mapValuesSeries;
  exports.memoize = memoize;
  exports.nextTick = nextTick;
  exports.parallel = parallelLimit;
  exports.parallelLimit = parallelLimit$1;
  exports.priorityQueue = priorityQueue;
  exports.queue = queue$1;
  exports.race = race;
  exports.reduce = reduce;
  exports.reduceRight = reduceRight;
  exports.reflect = reflect;
  exports.reflectAll = reflectAll;
  exports.reject = reject;
  exports.rejectLimit = rejectLimit;
  exports.rejectSeries = rejectSeries;
  exports.retry = retry;
  exports.retryable = retryable;
  exports.seq = seq;
  exports.series = series;
  exports.setImmediate = setImmediate$1;
  exports.some = some;
  exports.someLimit = someLimit;
  exports.someSeries = someSeries;
  exports.sortBy = sortBy;
  exports.timeout = timeout;
  exports.times = times;
  exports.timesLimit = timeLimit;
  exports.timesSeries = timesSeries;
  exports.transform = transform;
  exports.tryEach = tryEach;
  exports.unmemoize = unmemoize;
  exports.until = until;
  exports.waterfall = waterfall;
  exports.whilst = whilst;
  exports.all = every;
  exports.allLimit = everyLimit;
  exports.allSeries = everySeries;
  exports.any = some;
  exports.anyLimit = someLimit;
  exports.anySeries = someSeries;
  exports.find = detect;
  exports.findLimit = detectLimit;
  exports.findSeries = detectSeries;
  exports.forEach = eachLimit;
  exports.forEachSeries = eachSeries;
  exports.forEachLimit = eachLimit$1;
  exports.forEachOf = eachOf;
  exports.forEachOfSeries = eachOfSeries;
  exports.forEachOfLimit = eachOfLimit;
  exports.inject = reduce;
  exports.foldl = reduce;
  exports.foldr = reduceRight;
  exports.select = filter;
  exports.selectLimit = filterLimit;
  exports.selectSeries = filterSeries;
  exports.wrapSync = asyncify;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});

/***/ }),

/***/ 54878:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;__webpack_require__(66992);
__webpack_require__(51532);
__webpack_require__(41539);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(40561);
__webpack_require__(54747);
__webpack_require__(47941);
/*!
	autosize 4.0.4
	license: MIT
	http://www.jacklmoore.com/autosize
*/
(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function (module, exports) {
  'use strict';

  var map = typeof Map === "function" ? new Map() : function () {
    var keys = [];
    var values = [];
    return {
      has: function has(key) {
        return keys.indexOf(key) > -1;
      },
      get: function get(key) {
        return values[keys.indexOf(key)];
      },
      set: function set(key, value) {
        if (keys.indexOf(key) === -1) {
          keys.push(key);
          values.push(value);
        }
      },
      delete: function _delete(key) {
        var index = keys.indexOf(key);
        if (index > -1) {
          keys.splice(index, 1);
          values.splice(index, 1);
        }
      }
    };
  }();
  var createEvent = function createEvent(name) {
    return new Event(name, {
      bubbles: true
    });
  };
  try {
    new Event('test');
  } catch (e) {
    // IE does not support `new Event()`
    createEvent = function createEvent(name) {
      var evt = document.createEvent('Event');
      evt.initEvent(name, true, false);
      return evt;
    };
  }
  function assign(ta) {
    if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || map.has(ta)) return;
    var heightOffset = null;
    var clientWidth = null;
    var cachedHeight = null;
    function init() {
      var style = window.getComputedStyle(ta, null);
      if (style.resize === 'vertical') {
        ta.style.resize = 'none';
      } else if (style.resize === 'both') {
        ta.style.resize = 'horizontal';
      }
      if (style.boxSizing === 'content-box') {
        heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
      } else {
        heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
      }
      // Fix when a textarea is not on document body and heightOffset is Not a Number
      if (isNaN(heightOffset)) {
        heightOffset = 0;
      }
      update();
    }
    function changeOverflow(value) {
      {
        // Chrome/Safari-specific fix:
        // When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
        // made available by removing the scrollbar. The following forces the necessary text reflow.
        var width = ta.style.width;
        ta.style.width = '0px';
        // Force reflow:
        /* jshint ignore:start */
        ta.offsetWidth;
        /* jshint ignore:end */
        ta.style.width = width;
      }
      ta.style.overflowY = value;
    }
    function getParentOverflows(el) {
      var arr = [];
      while (el && el.parentNode && el.parentNode instanceof Element) {
        if (el.parentNode.scrollTop) {
          arr.push({
            node: el.parentNode,
            scrollTop: el.parentNode.scrollTop
          });
        }
        el = el.parentNode;
      }
      return arr;
    }
    function resize() {
      if (ta.scrollHeight === 0) {
        // If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
        return;
      }
      var overflows = getParentOverflows(ta);
      var docTop = document.documentElement && document.documentElement.scrollTop; // Needed for Mobile IE (ticket #240)

      ta.style.height = '';
      ta.style.height = ta.scrollHeight + heightOffset + 'px';

      // used to check if an update is actually necessary on window.resize
      clientWidth = ta.clientWidth;

      // prevents scroll-position jumping
      overflows.forEach(function (el) {
        el.node.scrollTop = el.scrollTop;
      });
      if (docTop) {
        document.documentElement.scrollTop = docTop;
      }
    }
    function update() {
      resize();
      var styleHeight = Math.round(parseFloat(ta.style.height));
      var computed = window.getComputedStyle(ta, null);

      // Using offsetHeight as a replacement for computed.height in IE, because IE does not account use of border-box
      var actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(computed.height)) : ta.offsetHeight;

      // The actual height not matching the style height (set via the resize method) indicates that 
      // the max-height has been exceeded, in which case the overflow should be allowed.
      if (actualHeight < styleHeight) {
        if (computed.overflowY === 'hidden') {
          changeOverflow('scroll');
          resize();
          actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
        }
      } else {
        // Normally keep overflow set to hidden, to avoid flash of scrollbar as the textarea expands.
        if (computed.overflowY !== 'hidden') {
          changeOverflow('hidden');
          resize();
          actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
        }
      }
      if (cachedHeight !== actualHeight) {
        cachedHeight = actualHeight;
        var evt = createEvent('autosize:resized');
        try {
          ta.dispatchEvent(evt);
        } catch (err) {
          // Firefox will throw an error on dispatchEvent for a detached element
          // https://bugzilla.mozilla.org/show_bug.cgi?id=889376
        }
      }
    }
    var pageResize = function pageResize() {
      if (ta.clientWidth !== clientWidth) {
        update();
      }
    };
    var destroy = function (style) {
      window.removeEventListener('resize', pageResize, false);
      ta.removeEventListener('input', update, false);
      ta.removeEventListener('keyup', update, false);
      ta.removeEventListener('autosize:destroy', destroy, false);
      ta.removeEventListener('autosize:update', update, false);
      Object.keys(style).forEach(function (key) {
        ta.style[key] = style[key];
      });
      map.delete(ta);
    }.bind(ta, {
      height: ta.style.height,
      resize: ta.style.resize,
      overflowY: ta.style.overflowY,
      overflowX: ta.style.overflowX,
      wordWrap: ta.style.wordWrap
    });
    ta.addEventListener('autosize:destroy', destroy, false);

    // IE9 does not fire onpropertychange or oninput for deletions,
    // so binding to onkeyup to catch most of those events.
    // There is no way that I know of to detect something like 'cut' in IE9.
    if ('onpropertychange' in ta && 'oninput' in ta) {
      ta.addEventListener('keyup', update, false);
    }
    window.addEventListener('resize', pageResize, false);
    ta.addEventListener('input', update, false);
    ta.addEventListener('autosize:update', update, false);
    ta.style.overflowX = 'hidden';
    ta.style.wordWrap = 'break-word';
    map.set(ta, {
      destroy: destroy,
      update: update
    });
    init();
  }
  function destroy(ta) {
    var methods = map.get(ta);
    if (methods) {
      methods.destroy();
    }
  }
  function update(ta) {
    var methods = map.get(ta);
    if (methods) {
      methods.update();
    }
  }
  var autosize = null;

  // Do nothing in Node.js environment and IE8 (or lower)
  if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
    autosize = function autosize(el) {
      return el;
    };
    autosize.destroy = function (el) {
      return el;
    };
    autosize.update = function (el) {
      return el;
    };
  } else {
    autosize = function autosize(el, options) {
      if (el) {
        Array.prototype.forEach.call(el.length ? el : [el], function (x) {
          return assign(x, options);
        });
      }
      return el;
    };
    autosize.destroy = function (el) {
      if (el) {
        Array.prototype.forEach.call(el.length ? el : [el], destroy);
      }
      return el;
    };
    autosize.update = function (el) {
      if (el) {
        Array.prototype.forEach.call(el.length ? el : [el], update);
      }
      return el;
    };
  }
  exports.default = autosize;
  module.exports = exports['default'];
});

/***/ }),

/***/ 41285:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__(66992);
__webpack_require__(41539);
__webpack_require__(82472);
__webpack_require__(92990);
__webpack_require__(18927);
__webpack_require__(33105);
__webpack_require__(35035);
__webpack_require__(74345);
__webpack_require__(7174);
__webpack_require__(32846);
__webpack_require__(44731);
__webpack_require__(77209);
__webpack_require__(96319);
__webpack_require__(58867);
__webpack_require__(37789);
__webpack_require__(33739);
__webpack_require__(29368);
__webpack_require__(14483);
__webpack_require__(12056);
__webpack_require__(3462);
__webpack_require__(30678);
__webpack_require__(27462);
__webpack_require__(33824);
__webpack_require__(55021);
__webpack_require__(12974);
__webpack_require__(15016);
__webpack_require__(69600);
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i];
  revLookup[code.charCodeAt(i)] = i;
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
  var len = b64.length;
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4');
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=');
  if (validLen === -1) validLen = len;
  var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
  return [validLen, placeHoldersLen];
}

// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
  var tmp;
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
  var curByte = 0;

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
  var i;
  for (i = 0; i < len; i += 4) {
    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
    arr[curByte++] = tmp >> 16 & 0xFF;
    arr[curByte++] = tmp >> 8 & 0xFF;
    arr[curByte++] = tmp & 0xFF;
  }
  if (placeHoldersLen === 2) {
    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
    arr[curByte++] = tmp & 0xFF;
  }
  if (placeHoldersLen === 1) {
    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
    arr[curByte++] = tmp >> 8 & 0xFF;
    arr[curByte++] = tmp & 0xFF;
  }
  return arr;
}
function tripletToBase64(num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
  var tmp;
  var output = [];
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
    output.push(tripletToBase64(tmp));
  }
  return output.join('');
}
function fromByteArray(uint8) {
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
  var parts = [];
  var maxChunkLength = 16383; // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
    parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
  }
  return parts.join('');
}

/***/ }),

/***/ 13423:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(66992);
__webpack_require__(82472);
__webpack_require__(92990);
__webpack_require__(18927);
__webpack_require__(33105);
__webpack_require__(35035);
__webpack_require__(74345);
__webpack_require__(7174);
__webpack_require__(32846);
__webpack_require__(44731);
__webpack_require__(77209);
__webpack_require__(96319);
__webpack_require__(58867);
__webpack_require__(37789);
__webpack_require__(33739);
__webpack_require__(29368);
__webpack_require__(14483);
__webpack_require__(12056);
__webpack_require__(3462);
__webpack_require__(30678);
__webpack_require__(27462);
__webpack_require__(33824);
__webpack_require__(55021);
__webpack_require__(12974);
__webpack_require__(15016);
__webpack_require__(18264);
__webpack_require__(96649);
__webpack_require__(96078);
__webpack_require__(43290);
__webpack_require__(47042);
__webpack_require__(92222);
__webpack_require__(39714);
__webpack_require__(73210);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(26699);
__webpack_require__(32023);
__webpack_require__(9653);
__webpack_require__(83753);
__webpack_require__(50545);
__webpack_require__(23123);
__webpack_require__(68309);
__webpack_require__(32165);
__webpack_require__(78783);
__webpack_require__(33948);
var base64 = __webpack_require__(41285);
var ieee754 = __webpack_require__(88617);
var customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
: null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
var K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') {
  console.error('This browser lacks typed array (Uint8Array) support which is required by ' + '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.');
}
function typedArraySupport() {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1);
    var proto = {
      foo: function foo() {
        return 42;
      }
    };
    Object.setPrototypeOf(proto, Uint8Array.prototype);
    Object.setPrototypeOf(arr, proto);
    return arr.foo() === 42;
  } catch (e) {
    return false;
  }
}
Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function get() {
    if (!Buffer.isBuffer(this)) return undefined;
    return this.buffer;
  }
});
Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function get() {
    if (!Buffer.isBuffer(this)) return undefined;
    return this.byteOffset;
  }
});
function createBuffer(length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"');
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length);
  Object.setPrototypeOf(buf, Buffer.prototype);
  return buf;
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer(arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError('The "string" argument must be of type string. Received type number');
    }
    return allocUnsafe(arg);
  }
  return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192; // not used by this implementation

function from(value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset);
  }
  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value);
  }
  if (value == null) {
    throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' + 'or Array-like Object. Received type ' + _typeof(value));
  }
  if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
    return fromArrayBuffer(value, encodingOrOffset, length);
  }
  if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length);
  }
  if (typeof value === 'number') {
    throw new TypeError('The "value" argument must not be of type number. Received type number');
  }
  var valueOf = value.valueOf && value.valueOf();
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length);
  }
  var b = fromObject(value);
  if (b) return b;
  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
  }
  throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' + 'or Array-like Object. Received type ' + _typeof(value));
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length);
};

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number');
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"');
  }
}
function alloc(size, fill, encoding) {
  assertSize(size);
  if (size <= 0) {
    return createBuffer(size);
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
  }
  return createBuffer(size);
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
  assertSize(size);
  return createBuffer(size < 0 ? 0 : checked(size) | 0);
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size);
};
function fromString(string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8';
  }
  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding);
  }
  var length = byteLength(string, encoding) | 0;
  var buf = createBuffer(length);
  var actual = buf.write(string, encoding);
  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
  }
  return buf;
}
function fromArrayLike(array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0;
  var buf = createBuffer(length);
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255;
  }
  return buf;
}
function fromArrayView(arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView);
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
  }
  return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds');
  }
  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds');
  }
  var buf;
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array);
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset);
  } else {
    buf = new Uint8Array(array, byteOffset, length);
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype);
  return buf;
}
function fromObject(obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0;
    var buf = createBuffer(len);
    if (buf.length === 0) {
      return buf;
    }
    obj.copy(buf, 0, 0, len);
    return buf;
  }
  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0);
    }
    return fromArrayLike(obj);
  }
  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data);
  }
}
function checked(length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes');
  }
  return length | 0;
}
function SlowBuffer(length) {
  if (+length != length) {
    // eslint-disable-line eqeqeq
    length = 0;
  }
  return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
  return b != null && b._isBuffer === true && b !== Buffer.prototype; // so Buffer.isBuffer(Buffer.prototype) will be false
};

Buffer.compare = function compare(a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
  }
  if (a === b) return 0;
  var x = a.length;
  var y = b.length;
  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }
  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true;
    default:
      return false;
  }
};
Buffer.concat = function concat(list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers');
  }
  if (list.length === 0) {
    return Buffer.alloc(0);
  }
  var i;
  if (length === undefined) {
    length = 0;
    for (i = 0; i < list.length; ++i) {
      length += list[i].length;
    }
  }
  var buffer = Buffer.allocUnsafe(length);
  var pos = 0;
  for (i = 0; i < list.length; ++i) {
    var buf = list[i];
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos);
      } else {
        Uint8Array.prototype.set.call(buffer, buf, pos);
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    } else {
      buf.copy(buffer, pos);
    }
    pos += buf.length;
  }
  return buffer;
};
function byteLength(string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length;
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength;
  }
  if (typeof string !== 'string') {
    throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' + 'Received type ' + _typeof(string));
  }
  var len = string.length;
  var mustMatch = arguments.length > 2 && arguments[2] === true;
  if (!mustMatch && len === 0) return 0;

  // Use a for loop to avoid recursion
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len;
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length;
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2;
      case 'hex':
        return len >>> 1;
      case 'base64':
        return base64ToBytes(string).length;
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length; // assume utf8
        }

        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
  var loweredCase = false;

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0;
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return '';
  }
  if (end === undefined || end > this.length) {
    end = this.length;
  }
  if (end <= 0) {
    return '';
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0;
  start >>>= 0;
  if (end <= start) {
    return '';
  }
  if (!encoding) encoding = 'utf8';
  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end);
      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end);
      case 'ascii':
        return asciiSlice(this, start, end);
      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end);
      case 'base64':
        return base64Slice(this, start, end);
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end);
      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = (encoding + '').toLowerCase();
        loweredCase = true;
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
  var i = b[n];
  b[n] = b[m];
  b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
  var len = this.length;
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits');
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1);
  }
  return this;
};
Buffer.prototype.swap32 = function swap32() {
  var len = this.length;
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits');
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3);
    swap(this, i + 1, i + 2);
  }
  return this;
};
Buffer.prototype.swap64 = function swap64() {
  var len = this.length;
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits');
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7);
    swap(this, i + 1, i + 6);
    swap(this, i + 2, i + 5);
    swap(this, i + 3, i + 4);
  }
  return this;
};
Buffer.prototype.toString = function toString() {
  var length = this.length;
  if (length === 0) return '';
  if (arguments.length === 0) return utf8Slice(this, 0, length);
  return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
  if (this === b) return true;
  return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
  var str = '';
  var max = exports.INSPECT_MAX_BYTES;
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
  if (this.length > max) str += ' ... ';
  return '<Buffer ' + str + '>';
};
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
}
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength);
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. ' + 'Received type ' + _typeof(target));
  }
  if (start === undefined) {
    start = 0;
  }
  if (end === undefined) {
    end = target ? target.length : 0;
  }
  if (thisStart === undefined) {
    thisStart = 0;
  }
  if (thisEnd === undefined) {
    thisEnd = this.length;
  }
  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index');
  }
  if (thisStart >= thisEnd && start >= end) {
    return 0;
  }
  if (thisStart >= thisEnd) {
    return -1;
  }
  if (start >= end) {
    return 1;
  }
  start >>>= 0;
  end >>>= 0;
  thisStart >>>= 0;
  thisEnd >>>= 0;
  if (this === target) return 0;
  var x = thisEnd - thisStart;
  var y = end - start;
  var len = Math.min(x, y);
  var thisCopy = this.slice(thisStart, thisEnd);
  var targetCopy = target.slice(start, end);
  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i];
      y = targetCopy[i];
      break;
    }
  }
  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1;

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset;
    byteOffset = 0;
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff;
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000;
  }
  byteOffset = +byteOffset; // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
  if (byteOffset >= buffer.length) {
    if (dir) return -1;else byteOffset = buffer.length - 1;
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0;else return -1;
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding);
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1;
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
  } else if (typeof val === 'number') {
    val = val & 0xFF; // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
  }
  throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
  var indexSize = 1;
  var arrLength = arr.length;
  var valLength = val.length;
  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase();
    if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1;
      }
      indexSize = 2;
      arrLength /= 2;
      valLength /= 2;
      byteOffset /= 2;
    }
  }
  function read(buf, i) {
    if (indexSize === 1) {
      return buf[i];
    } else {
      return buf.readUInt16BE(i * indexSize);
    }
  }
  var i;
  if (dir) {
    var foundIndex = -1;
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i;
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
      } else {
        if (foundIndex !== -1) i -= i - foundIndex;
        foundIndex = -1;
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
    for (i = byteOffset; i >= 0; i--) {
      var found = true;
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false;
          break;
        }
      }
      if (found) return i;
    }
  }
  return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
  offset = Number(offset) || 0;
  var remaining = buf.length - offset;
  if (!length) {
    length = remaining;
  } else {
    length = Number(length);
    if (length > remaining) {
      length = remaining;
    }
  }
  var strLen = string.length;
  if (length > strLen / 2) {
    length = strLen / 2;
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16);
    if (numberIsNaN(parsed)) return i;
    buf[offset + i] = parsed;
  }
  return i;
}
function utf8Write(buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8';
    length = this.length;
    offset = 0;
    // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset;
    length = this.length;
    offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0;
    if (isFinite(length)) {
      length = length >>> 0;
      if (encoding === undefined) encoding = 'utf8';
    } else {
      encoding = length;
      length = undefined;
    }
  } else {
    throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
  }
  var remaining = this.length - offset;
  if (length === undefined || length > remaining) length = remaining;
  if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds');
  }
  if (!encoding) encoding = 'utf8';
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length);
      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length);
      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length);
      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length);
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length);
      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
};
Buffer.prototype.toJSON = function toJSON() {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function base64Slice(buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf);
  } else {
    return base64.fromByteArray(buf.slice(start, end));
  }
}
function utf8Slice(buf, start, end) {
  end = Math.min(buf.length, end);
  var res = [];
  var i = start;
  while (i < end) {
    var firstByte = buf[i];
    var codePoint = null;
    var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint;
      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte;
          }
          break;
        case 2:
          secondByte = buf[i + 1];
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 3:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 4:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          fourthByte = buf[i + 3];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint;
            }
          }
      }
    }
    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD;
      bytesPerSequence = 1;
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000;
      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
      codePoint = 0xDC00 | codePoint & 0x3FF;
    }
    res.push(codePoint);
    i += bytesPerSequence;
  }
  return decodeCodePointsArray(res);
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
  var len = codePoints.length;
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = '';
  var i = 0;
  while (i < len) {
    res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
  }
  return res;
}
function asciiSlice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);
  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F);
  }
  return ret;
}
function latin1Slice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);
  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i]);
  }
  return ret;
}
function hexSlice(buf, start, end) {
  var len = buf.length;
  if (!start || start < 0) start = 0;
  if (!end || end < 0 || end > len) end = len;
  var out = '';
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]];
  }
  return out;
}
function utf16leSlice(buf, start, end) {
  var bytes = buf.slice(start, end);
  var res = '';
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
  }
  return res;
}
Buffer.prototype.slice = function slice(start, end) {
  var len = this.length;
  start = ~~start;
  end = end === undefined ? len : ~~end;
  if (start < 0) {
    start += len;
    if (start < 0) start = 0;
  } else if (start > len) {
    start = len;
  }
  if (end < 0) {
    end += len;
    if (end < 0) end = 0;
  } else if (end > len) {
    end = len;
  }
  if (end < start) end = start;
  var newBuf = this.subarray(start, end);
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype);
  return newBuf;
};

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset(offset, ext, length) {
  if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);
  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length);
  }
  var val = this[offset + --byteLength];
  var mul = 1;
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul;
  }
  return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 1, this.length);
  return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);
  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  mul *= 0x80;
  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
  return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);
  var i = byteLength;
  var mul = 1;
  var val = this[offset + --i];
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul;
  }
  mul *= 0x80;
  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
  return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 1, this.length);
  if (!(this[offset] & 0x80)) return this[offset];
  return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset] | this[offset + 1] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset + 1] | this[offset] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }
  var mul = 1;
  var i = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }
  var i = byteLength - 1;
  var mul = 1;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
  this[offset] = value & 0xff;
  return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  this[offset] = value & 0xff;
  this[offset + 1] = value >>> 8;
  return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  this[offset] = value >>> 8;
  this[offset + 1] = value & 0xff;
  return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  this[offset + 3] = value >>> 24;
  this[offset + 2] = value >>> 16;
  this[offset + 1] = value >>> 8;
  this[offset] = value & 0xff;
  return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  this[offset] = value >>> 24;
  this[offset + 1] = value >>> 16;
  this[offset + 2] = value >>> 8;
  this[offset + 3] = value & 0xff;
  return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);
    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }
  var i = 0;
  var mul = 1;
  var sub = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);
    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }
  var i = byteLength - 1;
  var mul = 1;
  var sub = 0;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
  if (value < 0) value = 0xff + value + 1;
  this[offset] = value & 0xff;
  return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  this[offset] = value & 0xff;
  this[offset + 1] = value >>> 8;
  return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  this[offset] = value >>> 8;
  this[offset + 1] = value & 0xff;
  return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  this[offset] = value & 0xff;
  this[offset + 1] = value >>> 8;
  this[offset + 2] = value >>> 16;
  this[offset + 3] = value >>> 24;
  return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (value < 0) value = 0xffffffff + value + 1;
  this[offset] = value >>> 24;
  this[offset + 1] = value >>> 16;
  this[offset + 2] = value >>> 8;
  this[offset + 3] = value & 0xff;
  return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
  if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4);
  return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8);
  return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert);
};

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
  if (!start) start = 0;
  if (!end && end !== 0) end = this.length;
  if (targetStart >= target.length) targetStart = target.length;
  if (!targetStart) targetStart = 0;
  if (end > 0 && end < start) end = start;

  // Copy 0 bytes; we're done
  if (end === start) return 0;
  if (target.length === 0 || this.length === 0) return 0;

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds');
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
  if (end < 0) throw new RangeError('sourceEnd out of bounds');

  // Are we oob?
  if (end > this.length) end = this.length;
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start;
  }
  var len = end - start;
  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
  } else {
    Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
  }
  return len;
};

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start;
      start = 0;
      end = this.length;
    } else if (typeof end === 'string') {
      encoding = end;
      end = this.length;
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string');
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding);
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0);
      if (encoding === 'utf8' && code < 128 || encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code;
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255;
  } else if (typeof val === 'boolean') {
    val = Number(val);
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index');
  }
  if (end <= start) {
    return this;
  }
  start = start >>> 0;
  end = end === undefined ? this.length : end >>> 0;
  if (!val) val = 0;
  var i;
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val;
    }
  } else {
    var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
    var len = bytes.length;
    if (len === 0) {
      throw new TypeError('The value "' + val + '" is invalid for argument "value"');
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len];
    }
  }
  return this;
};

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0];
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '');
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return '';
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '=';
  }
  return str;
}
function utf8ToBytes(string, units) {
  units = units || Infinity;
  var codePoint;
  var length = string.length;
  var leadSurrogate = null;
  var bytes = [];
  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i);

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        }

        // valid lead
        leadSurrogate = codePoint;
        continue;
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        leadSurrogate = codePoint;
        continue;
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    }
    leadSurrogate = null;

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break;
      bytes.push(codePoint);
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break;
      bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break;
      bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break;
      bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else {
      throw new Error('Invalid code point');
    }
  }
  return bytes;
}
function asciiToBytes(str) {
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
  }
  return byteArray;
}
function utf16leToBytes(str, units) {
  var c, hi, lo;
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break;
    c = str.charCodeAt(i);
    hi = c >> 8;
    lo = c % 256;
    byteArray.push(lo);
    byteArray.push(hi);
  }
  return byteArray;
}
function base64ToBytes(str) {
  return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if (i + offset >= dst.length || i >= src.length) break;
    dst[i + offset] = src[i];
  }
  return i;
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
  return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
  // For IE11 support
  return obj !== obj; // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = function () {
  var alphabet = '0123456789abcdef';
  var table = new Array(256);
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16;
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j];
    }
  }
  return table;
}();

/***/ }),

/***/ 73684:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(37555);
var callBind = __webpack_require__(53785);
var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
  var intrinsic = GetIntrinsic(name, !!allowMissing);
  if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
    return callBind(intrinsic);
  }
  return intrinsic;
};

/***/ }),

/***/ 53785:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(23723);
var GetIntrinsic = __webpack_require__(37555);
var setFunctionLength = __webpack_require__(2790);
var $TypeError = __webpack_require__(13237);
var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);
var $defineProperty = __webpack_require__(61597);
var $max = GetIntrinsic('%Math.max%');
module.exports = function callBind(originalFunction) {
  if (typeof originalFunction !== 'function') {
    throw new $TypeError('a function is required');
  }
  var func = $reflectApply(bind, $call, arguments);
  return setFunctionLength(func, 1 + $max(0, originalFunction.length - (arguments.length - 1)), true);
};
var applyBind = function applyBind() {
  return $reflectApply(bind, $apply, arguments);
};
if ($defineProperty) {
  $defineProperty(module.exports, 'apply', {
    value: applyBind
  });
} else {
  module.exports.apply = applyBind;
}

/***/ }),

/***/ 58575:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
/* provided dependency */ var Buffer = __webpack_require__(13423)["Buffer"];
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(66992);
__webpack_require__(51532);
__webpack_require__(41539);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(70189);
__webpack_require__(24603);
__webpack_require__(74916);
__webpack_require__(39714);
__webpack_require__(30489);
__webpack_require__(54747);
__webpack_require__(38880);
__webpack_require__(82526);
__webpack_require__(36210);
__webpack_require__(41817);
__webpack_require__(32165);
var clone = function () {
  'use strict';

  function _instanceof(obj, type) {
    return type != null && obj instanceof type;
  }
  var nativeMap;
  try {
    nativeMap = Map;
  } catch (_) {
    // maybe a reference error because no `Map`. Give it a dummy value that no
    // value will ever be an instanceof.
    nativeMap = function nativeMap() {};
  }
  var nativeSet;
  try {
    nativeSet = Set;
  } catch (_) {
    nativeSet = function nativeSet() {};
  }
  var nativePromise;
  try {
    nativePromise = Promise;
  } catch (_) {
    nativePromise = function nativePromise() {};
  }

  /**
   * Clones (copies) an Object using deep copying.
   *
   * This function supports circular references by default, but if you are certain
   * there are no circular references in your object, you can save some CPU time
   * by calling clone(obj, false).
   *
   * Caution: if `circular` is false and `parent` contains circular references,
   * your program may enter an infinite loop and crash.
   *
   * @param `parent` - the object to be cloned
   * @param `circular` - set to true if the object to be cloned may contain
   *    circular references. (optional - true by default)
   * @param `depth` - set to a number if the object is only to be cloned to
   *    a particular depth. (optional - defaults to Infinity)
   * @param `prototype` - sets the prototype to be used when cloning an object.
   *    (optional - defaults to parent prototype).
   * @param `includeNonEnumerable` - set to true if the non-enumerable properties
   *    should be cloned as well. Non-enumerable properties on the prototype
   *    chain will be ignored. (optional - false by default)
  */
  function clone(parent, circular, depth, prototype, includeNonEnumerable) {
    if (_typeof(circular) === 'object') {
      depth = circular.depth;
      prototype = circular.prototype;
      includeNonEnumerable = circular.includeNonEnumerable;
      circular = circular.circular;
    }
    // maintain two arrays for circular references, where corresponding parents
    // and children have the same index
    var allParents = [];
    var allChildren = [];
    var useBuffer = typeof Buffer != 'undefined';
    if (typeof circular == 'undefined') circular = true;
    if (typeof depth == 'undefined') depth = Infinity;

    // recurse this function so we don't reset allParents and allChildren
    function _clone(parent, depth) {
      // cloning null always returns null
      if (parent === null) return null;
      if (depth === 0) return parent;
      var child;
      var proto;
      if (_typeof(parent) != 'object') {
        return parent;
      }
      if (_instanceof(parent, nativeMap)) {
        child = new nativeMap();
      } else if (_instanceof(parent, nativeSet)) {
        child = new nativeSet();
      } else if (_instanceof(parent, nativePromise)) {
        child = new nativePromise(function (resolve, reject) {
          parent.then(function (value) {
            resolve(_clone(value, depth - 1));
          }, function (err) {
            reject(_clone(err, depth - 1));
          });
        });
      } else if (clone.__isArray(parent)) {
        child = [];
      } else if (clone.__isRegExp(parent)) {
        child = new RegExp(parent.source, __getRegExpFlags(parent));
        if (parent.lastIndex) child.lastIndex = parent.lastIndex;
      } else if (clone.__isDate(parent)) {
        child = new Date(parent.getTime());
      } else if (useBuffer && Buffer.isBuffer(parent)) {
        if (Buffer.allocUnsafe) {
          // Node.js >= 4.5.0
          child = Buffer.allocUnsafe(parent.length);
        } else {
          // Older Node.js versions
          child = new Buffer(parent.length);
        }
        parent.copy(child);
        return child;
      } else if (_instanceof(parent, Error)) {
        child = Object.create(parent);
      } else {
        if (typeof prototype == 'undefined') {
          proto = Object.getPrototypeOf(parent);
          child = Object.create(proto);
        } else {
          child = Object.create(prototype);
          proto = prototype;
        }
      }
      if (circular) {
        var index = allParents.indexOf(parent);
        if (index != -1) {
          return allChildren[index];
        }
        allParents.push(parent);
        allChildren.push(child);
      }
      if (_instanceof(parent, nativeMap)) {
        parent.forEach(function (value, key) {
          var keyChild = _clone(key, depth - 1);
          var valueChild = _clone(value, depth - 1);
          child.set(keyChild, valueChild);
        });
      }
      if (_instanceof(parent, nativeSet)) {
        parent.forEach(function (value) {
          var entryChild = _clone(value, depth - 1);
          child.add(entryChild);
        });
      }
      for (var i in parent) {
        var attrs;
        if (proto) {
          attrs = Object.getOwnPropertyDescriptor(proto, i);
        }
        if (attrs && attrs.set == null) {
          continue;
        }
        child[i] = _clone(parent[i], depth - 1);
      }
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(parent);
        for (var i = 0; i < symbols.length; i++) {
          // Don't need to worry about cloning a symbol because it is a primitive,
          // like a number or string.
          var symbol = symbols[i];
          var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
          if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
            continue;
          }
          child[symbol] = _clone(parent[symbol], depth - 1);
          if (!descriptor.enumerable) {
            Object.defineProperty(child, symbol, {
              enumerable: false
            });
          }
        }
      }
      if (includeNonEnumerable) {
        var allPropertyNames = Object.getOwnPropertyNames(parent);
        for (var i = 0; i < allPropertyNames.length; i++) {
          var propertyName = allPropertyNames[i];
          var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
          if (descriptor && descriptor.enumerable) {
            continue;
          }
          child[propertyName] = _clone(parent[propertyName], depth - 1);
          Object.defineProperty(child, propertyName, {
            enumerable: false
          });
        }
      }
      return child;
    }
    return _clone(parent, depth);
  }

  /**
   * Simple flat clone using prototype, accepts only objects, usefull for property
   * override on FLAT configuration object (no nested props).
   *
   * USE WITH CAUTION! This may not behave as you wish if you do not know how this
   * works.
   */
  clone.clonePrototype = function clonePrototype(parent) {
    if (parent === null) return null;
    var c = function c() {};
    c.prototype = parent;
    return new c();
  };

  // private utility functions

  function __objToStr(o) {
    return Object.prototype.toString.call(o);
  }
  clone.__objToStr = __objToStr;
  function __isDate(o) {
    return _typeof(o) === 'object' && __objToStr(o) === '[object Date]';
  }
  clone.__isDate = __isDate;
  function __isArray(o) {
    return _typeof(o) === 'object' && __objToStr(o) === '[object Array]';
  }
  clone.__isArray = __isArray;
  function __isRegExp(o) {
    return _typeof(o) === 'object' && __objToStr(o) === '[object RegExp]';
  }
  clone.__isRegExp = __isRegExp;
  function __getRegExpFlags(re) {
    var flags = '';
    if (re.global) flags += 'g';
    if (re.ignoreCase) flags += 'i';
    if (re.multiline) flags += 'm';
    return flags;
  }
  clone.__getRegExpFlags = __getRegExpFlags;
  return clone;
}();
if (( false ? 0 : _typeof(module)) === 'object' && module.exports) {
  module.exports = clone;
}

/***/ }),

/***/ 4324:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// --------------------
// co-bluebird module
// --------------------

// modules
var co = __webpack_require__(46714),
  Bluebird = __webpack_require__(52107);

// exports
module.exports = co.use(Bluebird);

/***/ }),

/***/ 52107:
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;__webpack_require__(66992);
__webpack_require__(41539);
__webpack_require__(96290);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(47941);
__webpack_require__(39714);
__webpack_require__(23123);
__webpack_require__(69600);
__webpack_require__(40561);
__webpack_require__(47042);
__webpack_require__(68309);
__webpack_require__(4723);
__webpack_require__(43371);
__webpack_require__(38880);
__webpack_require__(36210);
__webpack_require__(30489);
__webpack_require__(21249);
__webpack_require__(57327);
__webpack_require__(17727);
__webpack_require__(92222);
__webpack_require__(83753);
__webpack_require__(24603);
__webpack_require__(84633);
__webpack_require__(9653);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2015 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/**
 * bluebird build version 2.11.0
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, cancel, using, filter, any, each, timers
*/
!function (e) {
  if ("object" == ( false ? 0 : _typeof(exports)) && "undefined" != "object") module.exports = e();else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else { var f; }
}(function () {
  var define, module, exports;
  return function e(t, n, r) {
    function s(o, u) {
      if (!n[o]) {
        if (!t[o]) {
          var a = typeof _dereq_ == "function" && _dereq_;
          if (!u && a) return a(o, !0);
          if (i) return i(o, !0);
          var f = new Error("Cannot find module '" + o + "'");
          throw f.code = "MODULE_NOT_FOUND", f;
        }
        var l = n[o] = {
          exports: {}
        };
        t[o][0].call(l.exports, function (e) {
          var n = t[o][1][e];
          return s(n ? n : e);
        }, l, l.exports, e, t, n, r);
      }
      return n[o].exports;
    }
    var i = typeof _dereq_ == "function" && _dereq_;
    for (var o = 0; o < r.length; o++) {
      s(r[o]);
    }
    return s;
  }({
    1: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise) {
        var SomePromiseArray = Promise._SomePromiseArray;
        function any(promises) {
          var ret = new SomePromiseArray(promises);
          var promise = ret.promise();
          ret.setHowMany(1);
          ret.setUnwrap();
          ret.init();
          return promise;
        }
        Promise.any = function (promises) {
          return any(promises);
        };
        Promise.prototype.any = function () {
          return any(this);
        };
      };
    }, {}],
    2: [function (_dereq_, module, exports) {
      "use strict";

      var firstLineError;
      try {
        throw new Error();
      } catch (e) {
        firstLineError = e;
      }
      var schedule = _dereq_("./schedule.js");
      var Queue = _dereq_("./queue.js");
      var util = _dereq_("./util.js");
      function Async() {
        this._isTickUsed = false;
        this._lateQueue = new Queue(16);
        this._normalQueue = new Queue(16);
        this._trampolineEnabled = true;
        var self = this;
        this.drainQueues = function () {
          self._drainQueues();
        };
        this._schedule = schedule.isStatic ? schedule(this.drainQueues) : schedule;
      }
      Async.prototype.disableTrampolineIfNecessary = function () {
        if (util.hasDevTools) {
          this._trampolineEnabled = false;
        }
      };
      Async.prototype.enableTrampoline = function () {
        if (!this._trampolineEnabled) {
          this._trampolineEnabled = true;
          this._schedule = function (fn) {
            setTimeout(fn, 0);
          };
        }
      };
      Async.prototype.haveItemsQueued = function () {
        return this._normalQueue.length() > 0;
      };
      Async.prototype.throwLater = function (fn, arg) {
        if (arguments.length === 1) {
          arg = fn;
          fn = function fn() {
            throw arg;
          };
        }
        if (typeof setTimeout !== "undefined") {
          setTimeout(function () {
            fn(arg);
          }, 0);
        } else try {
          this._schedule(function () {
            fn(arg);
          });
        } catch (e) {
          throw new Error("No async scheduler available\n\n    See http://goo.gl/m3OTXk\n");
        }
      };
      function AsyncInvokeLater(fn, receiver, arg) {
        this._lateQueue.push(fn, receiver, arg);
        this._queueTick();
      }
      function AsyncInvoke(fn, receiver, arg) {
        this._normalQueue.push(fn, receiver, arg);
        this._queueTick();
      }
      function AsyncSettlePromises(promise) {
        this._normalQueue._pushOne(promise);
        this._queueTick();
      }
      if (!util.hasDevTools) {
        Async.prototype.invokeLater = AsyncInvokeLater;
        Async.prototype.invoke = AsyncInvoke;
        Async.prototype.settlePromises = AsyncSettlePromises;
      } else {
        if (schedule.isStatic) {
          schedule = function schedule(fn) {
            setTimeout(fn, 0);
          };
        }
        Async.prototype.invokeLater = function (fn, receiver, arg) {
          if (this._trampolineEnabled) {
            AsyncInvokeLater.call(this, fn, receiver, arg);
          } else {
            this._schedule(function () {
              setTimeout(function () {
                fn.call(receiver, arg);
              }, 100);
            });
          }
        };
        Async.prototype.invoke = function (fn, receiver, arg) {
          if (this._trampolineEnabled) {
            AsyncInvoke.call(this, fn, receiver, arg);
          } else {
            this._schedule(function () {
              fn.call(receiver, arg);
            });
          }
        };
        Async.prototype.settlePromises = function (promise) {
          if (this._trampolineEnabled) {
            AsyncSettlePromises.call(this, promise);
          } else {
            this._schedule(function () {
              promise._settlePromises();
            });
          }
        };
      }
      Async.prototype.invokeFirst = function (fn, receiver, arg) {
        this._normalQueue.unshift(fn, receiver, arg);
        this._queueTick();
      };
      Async.prototype._drainQueue = function (queue) {
        while (queue.length() > 0) {
          var fn = queue.shift();
          if (typeof fn !== "function") {
            fn._settlePromises();
            continue;
          }
          var receiver = queue.shift();
          var arg = queue.shift();
          fn.call(receiver, arg);
        }
      };
      Async.prototype._drainQueues = function () {
        this._drainQueue(this._normalQueue);
        this._reset();
        this._drainQueue(this._lateQueue);
      };
      Async.prototype._queueTick = function () {
        if (!this._isTickUsed) {
          this._isTickUsed = true;
          this._schedule(this.drainQueues);
        }
      };
      Async.prototype._reset = function () {
        this._isTickUsed = false;
      };
      module.exports = new Async();
      module.exports.firstLineError = firstLineError;
    }, {
      "./queue.js": 28,
      "./schedule.js": 31,
      "./util.js": 38
    }],
    3: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, INTERNAL, tryConvertToPromise) {
        var rejectThis = function rejectThis(_, e) {
          this._reject(e);
        };
        var targetRejected = function targetRejected(e, context) {
          context.promiseRejectionQueued = true;
          context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
        };
        var bindingResolved = function bindingResolved(thisArg, context) {
          if (this._isPending()) {
            this._resolveCallback(context.target);
          }
        };
        var bindingRejected = function bindingRejected(e, context) {
          if (!context.promiseRejectionQueued) this._reject(e);
        };
        Promise.prototype.bind = function (thisArg) {
          var maybePromise = tryConvertToPromise(thisArg);
          var ret = new Promise(INTERNAL);
          ret._propagateFrom(this, 1);
          var target = this._target();
          ret._setBoundTo(maybePromise);
          if (maybePromise instanceof Promise) {
            var context = {
              promiseRejectionQueued: false,
              promise: ret,
              target: target,
              bindingPromise: maybePromise
            };
            target._then(INTERNAL, targetRejected, ret._progress, ret, context);
            maybePromise._then(bindingResolved, bindingRejected, ret._progress, ret, context);
          } else {
            ret._resolveCallback(target);
          }
          return ret;
        };
        Promise.prototype._setBoundTo = function (obj) {
          if (obj !== undefined) {
            this._bitField = this._bitField | 131072;
            this._boundTo = obj;
          } else {
            this._bitField = this._bitField & ~131072;
          }
        };
        Promise.prototype._isBound = function () {
          return (this._bitField & 131072) === 131072;
        };
        Promise.bind = function (thisArg, value) {
          var maybePromise = tryConvertToPromise(thisArg);
          var ret = new Promise(INTERNAL);
          ret._setBoundTo(maybePromise);
          if (maybePromise instanceof Promise) {
            maybePromise._then(function () {
              ret._resolveCallback(value);
            }, ret._reject, ret._progress, ret, null);
          } else {
            ret._resolveCallback(value);
          }
          return ret;
        };
      };
    }, {}],
    4: [function (_dereq_, module, exports) {
      "use strict";

      var old;
      if (typeof Promise !== "undefined") old = Promise;
      function noConflict() {
        try {
          if (Promise === bluebird) Promise = old;
        } catch (e) {}
        return bluebird;
      }
      var bluebird = _dereq_("./promise.js")();
      bluebird.noConflict = noConflict;
      module.exports = bluebird;
    }, {
      "./promise.js": 23
    }],
    5: [function (_dereq_, module, exports) {
      "use strict";

      var cr = Object.create;
      if (cr) {
        var callerCache = cr(null);
        var getterCache = cr(null);
        callerCache[" size"] = getterCache[" size"] = 0;
      }
      module.exports = function (Promise) {
        var util = _dereq_("./util.js");
        var canEvaluate = util.canEvaluate;
        var isIdentifier = util.isIdentifier;
        var getMethodCaller;
        var getGetter;
        if (false) { var getCompiled, makeGetter, makeMethodCaller; }
        function ensureMethod(obj, methodName) {
          var fn;
          if (obj != null) fn = obj[methodName];
          if (typeof fn !== "function") {
            var message = "Object " + util.classString(obj) + " has no method '" + util.toString(methodName) + "'";
            throw new Promise.TypeError(message);
          }
          return fn;
        }
        function caller(obj) {
          var methodName = this.pop();
          var fn = ensureMethod(obj, methodName);
          return fn.apply(obj, this);
        }
        Promise.prototype.call = function (methodName) {
          var $_len = arguments.length;
          var args = new Array($_len - 1);
          for (var $_i = 1; $_i < $_len; ++$_i) {
            args[$_i - 1] = arguments[$_i];
          }
          if (false) { var maybeCaller; }
          args.push(methodName);
          return this._then(caller, undefined, undefined, args, undefined);
        };
        function namedGetter(obj) {
          return obj[this];
        }
        function indexedGetter(obj) {
          var index = +this;
          if (index < 0) index = Math.max(0, index + obj.length);
          return obj[index];
        }
        Promise.prototype.get = function (propertyName) {
          var isIndex = typeof propertyName === "number";
          var getter;
          if (!isIndex) {
            if (canEvaluate) {
              var maybeGetter = getGetter(propertyName);
              getter = maybeGetter !== null ? maybeGetter : namedGetter;
            } else {
              getter = namedGetter;
            }
          } else {
            getter = indexedGetter;
          }
          return this._then(getter, undefined, undefined, propertyName, undefined);
        };
      };
    }, {
      "./util.js": 38
    }],
    6: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise) {
        var errors = _dereq_("./errors.js");
        var async = _dereq_("./async.js");
        var CancellationError = errors.CancellationError;
        Promise.prototype._cancel = function (reason) {
          if (!this.isCancellable()) return this;
          var parent;
          var promiseToReject = this;
          while ((parent = promiseToReject._cancellationParent) !== undefined && parent.isCancellable()) {
            promiseToReject = parent;
          }
          this._unsetCancellable();
          promiseToReject._target()._rejectCallback(reason, false, true);
        };
        Promise.prototype.cancel = function (reason) {
          if (!this.isCancellable()) return this;
          if (reason === undefined) reason = new CancellationError();
          async.invokeLater(this._cancel, this, reason);
          return this;
        };
        Promise.prototype.cancellable = function () {
          if (this._cancellable()) return this;
          async.enableTrampoline();
          this._setCancellable();
          this._cancellationParent = undefined;
          return this;
        };
        Promise.prototype.uncancellable = function () {
          var ret = this.then();
          ret._unsetCancellable();
          return ret;
        };
        Promise.prototype.fork = function (didFulfill, didReject, didProgress) {
          var ret = this._then(didFulfill, didReject, didProgress, undefined, undefined);
          ret._setCancellable();
          ret._cancellationParent = undefined;
          return ret;
        };
      };
    }, {
      "./async.js": 2,
      "./errors.js": 13
    }],
    7: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function () {
        var async = _dereq_("./async.js");
        var util = _dereq_("./util.js");
        var bluebirdFramePattern = /[\\\/]bluebird[\\\/]js[\\\/](main|debug|zalgo|instrumented)/;
        var stackFramePattern = null;
        var formatStack = null;
        var indentStackFrames = false;
        var warn;
        function CapturedTrace(parent) {
          this._parent = parent;
          var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
          captureStackTrace(this, CapturedTrace);
          if (length > 32) this.uncycle();
        }
        util.inherits(CapturedTrace, Error);
        CapturedTrace.prototype.uncycle = function () {
          var length = this._length;
          if (length < 2) return;
          var nodes = [];
          var stackToIndex = {};
          for (var i = 0, node = this; node !== undefined; ++i) {
            nodes.push(node);
            node = node._parent;
          }
          length = this._length = i;
          for (var i = length - 1; i >= 0; --i) {
            var stack = nodes[i].stack;
            if (stackToIndex[stack] === undefined) {
              stackToIndex[stack] = i;
            }
          }
          for (var i = 0; i < length; ++i) {
            var currentStack = nodes[i].stack;
            var index = stackToIndex[currentStack];
            if (index !== undefined && index !== i) {
              if (index > 0) {
                nodes[index - 1]._parent = undefined;
                nodes[index - 1]._length = 1;
              }
              nodes[i]._parent = undefined;
              nodes[i]._length = 1;
              var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
              if (index < length - 1) {
                cycleEdgeNode._parent = nodes[index + 1];
                cycleEdgeNode._parent.uncycle();
                cycleEdgeNode._length = cycleEdgeNode._parent._length + 1;
              } else {
                cycleEdgeNode._parent = undefined;
                cycleEdgeNode._length = 1;
              }
              var currentChildLength = cycleEdgeNode._length + 1;
              for (var j = i - 2; j >= 0; --j) {
                nodes[j]._length = currentChildLength;
                currentChildLength++;
              }
              return;
            }
          }
        };
        CapturedTrace.prototype.parent = function () {
          return this._parent;
        };
        CapturedTrace.prototype.hasParent = function () {
          return this._parent !== undefined;
        };
        CapturedTrace.prototype.attachExtraTrace = function (error) {
          if (error.__stackCleaned__) return;
          this.uncycle();
          var parsed = CapturedTrace.parseStackAndMessage(error);
          var message = parsed.message;
          var stacks = [parsed.stack];
          var trace = this;
          while (trace !== undefined) {
            stacks.push(cleanStack(trace.stack.split("\n")));
            trace = trace._parent;
          }
          removeCommonRoots(stacks);
          removeDuplicateOrEmptyJumps(stacks);
          util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
          util.notEnumerableProp(error, "__stackCleaned__", true);
        };
        function reconstructStack(message, stacks) {
          for (var i = 0; i < stacks.length - 1; ++i) {
            stacks[i].push("From previous event:");
            stacks[i] = stacks[i].join("\n");
          }
          if (i < stacks.length) {
            stacks[i] = stacks[i].join("\n");
          }
          return message + "\n" + stacks.join("\n");
        }
        function removeDuplicateOrEmptyJumps(stacks) {
          for (var i = 0; i < stacks.length; ++i) {
            if (stacks[i].length === 0 || i + 1 < stacks.length && stacks[i][0] === stacks[i + 1][0]) {
              stacks.splice(i, 1);
              i--;
            }
          }
        }
        function removeCommonRoots(stacks) {
          var current = stacks[0];
          for (var i = 1; i < stacks.length; ++i) {
            var prev = stacks[i];
            var currentLastIndex = current.length - 1;
            var currentLastLine = current[currentLastIndex];
            var commonRootMeetPoint = -1;
            for (var j = prev.length - 1; j >= 0; --j) {
              if (prev[j] === currentLastLine) {
                commonRootMeetPoint = j;
                break;
              }
            }
            for (var j = commonRootMeetPoint; j >= 0; --j) {
              var line = prev[j];
              if (current[currentLastIndex] === line) {
                current.pop();
                currentLastIndex--;
              } else {
                break;
              }
            }
            current = prev;
          }
        }
        function cleanStack(stack) {
          var ret = [];
          for (var i = 0; i < stack.length; ++i) {
            var line = stack[i];
            var isTraceLine = stackFramePattern.test(line) || "    (No stack trace)" === line;
            var isInternalFrame = isTraceLine && shouldIgnore(line);
            if (isTraceLine && !isInternalFrame) {
              if (indentStackFrames && line.charAt(0) !== " ") {
                line = "    " + line;
              }
              ret.push(line);
            }
          }
          return ret;
        }
        function stackFramesAsArray(error) {
          var stack = error.stack.replace(/\s+$/g, "").split("\n");
          for (var i = 0; i < stack.length; ++i) {
            var line = stack[i];
            if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
              break;
            }
          }
          if (i > 0) {
            stack = stack.slice(i);
          }
          return stack;
        }
        CapturedTrace.parseStackAndMessage = function (error) {
          var stack = error.stack;
          var message = error.toString();
          stack = typeof stack === "string" && stack.length > 0 ? stackFramesAsArray(error) : ["    (No stack trace)"];
          return {
            message: message,
            stack: cleanStack(stack)
          };
        };
        CapturedTrace.formatAndLogError = function (error, title) {
          if (typeof console !== "undefined") {
            var message;
            if (_typeof(error) === "object" || typeof error === "function") {
              var stack = error.stack;
              message = title + formatStack(stack, error);
            } else {
              message = title + String(error);
            }
            if (typeof warn === "function") {
              warn(message);
            } else if (typeof console.log === "function" || _typeof(console.log) === "object") {
              console.log(message);
            }
          }
        };
        CapturedTrace.unhandledRejection = function (reason) {
          CapturedTrace.formatAndLogError(reason, "^--- With additional stack trace: ");
        };
        CapturedTrace.isSupported = function () {
          return typeof captureStackTrace === "function";
        };
        CapturedTrace.fireRejectionEvent = function (name, localHandler, reason, promise) {
          var localEventFired = false;
          try {
            if (typeof localHandler === "function") {
              localEventFired = true;
              if (name === "rejectionHandled") {
                localHandler(promise);
              } else {
                localHandler(reason, promise);
              }
            }
          } catch (e) {
            async.throwLater(e);
          }
          var globalEventFired = false;
          try {
            globalEventFired = fireGlobalEvent(name, reason, promise);
          } catch (e) {
            globalEventFired = true;
            async.throwLater(e);
          }
          var domEventFired = false;
          if (fireDomEvent) {
            try {
              domEventFired = fireDomEvent(name.toLowerCase(), {
                reason: reason,
                promise: promise
              });
            } catch (e) {
              domEventFired = true;
              async.throwLater(e);
            }
          }
          if (!globalEventFired && !localEventFired && !domEventFired && name === "unhandledRejection") {
            CapturedTrace.formatAndLogError(reason, "Unhandled rejection ");
          }
        };
        function formatNonError(obj) {
          var str;
          if (typeof obj === "function") {
            str = "[function " + (obj.name || "anonymous") + "]";
          } else {
            str = obj.toString();
            var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
            if (ruselessToString.test(str)) {
              try {
                var newStr = JSON.stringify(obj);
                str = newStr;
              } catch (e) {}
            }
            if (str.length === 0) {
              str = "(empty array)";
            }
          }
          return "(<" + snip(str) + ">, no stack trace)";
        }
        function snip(str) {
          var maxChars = 41;
          if (str.length < maxChars) {
            return str;
          }
          return str.substr(0, maxChars - 3) + "...";
        }
        var shouldIgnore = function shouldIgnore() {
          return false;
        };
        var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
        function parseLineInfo(line) {
          var matches = line.match(parseLineInfoRegex);
          if (matches) {
            return {
              fileName: matches[1],
              line: parseInt(matches[2], 10)
            };
          }
        }
        CapturedTrace.setBounds = function (firstLineError, lastLineError) {
          if (!CapturedTrace.isSupported()) return;
          var firstStackLines = firstLineError.stack.split("\n");
          var lastStackLines = lastLineError.stack.split("\n");
          var firstIndex = -1;
          var lastIndex = -1;
          var firstFileName;
          var lastFileName;
          for (var i = 0; i < firstStackLines.length; ++i) {
            var result = parseLineInfo(firstStackLines[i]);
            if (result) {
              firstFileName = result.fileName;
              firstIndex = result.line;
              break;
            }
          }
          for (var i = 0; i < lastStackLines.length; ++i) {
            var result = parseLineInfo(lastStackLines[i]);
            if (result) {
              lastFileName = result.fileName;
              lastIndex = result.line;
              break;
            }
          }
          if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName || firstFileName !== lastFileName || firstIndex >= lastIndex) {
            return;
          }
          shouldIgnore = function shouldIgnore(line) {
            if (bluebirdFramePattern.test(line)) return true;
            var info = parseLineInfo(line);
            if (info) {
              if (info.fileName === firstFileName && firstIndex <= info.line && info.line <= lastIndex) {
                return true;
              }
            }
            return false;
          };
        };
        var captureStackTrace = function stackDetection() {
          var v8stackFramePattern = /^\s*at\s*/;
          var v8stackFormatter = function v8stackFormatter(stack, error) {
            if (typeof stack === "string") return stack;
            if (error.name !== undefined && error.message !== undefined) {
              return error.toString();
            }
            return formatNonError(error);
          };
          if (typeof Error.stackTraceLimit === "number" && typeof Error.captureStackTrace === "function") {
            Error.stackTraceLimit = Error.stackTraceLimit + 6;
            stackFramePattern = v8stackFramePattern;
            formatStack = v8stackFormatter;
            var captureStackTrace = Error.captureStackTrace;
            shouldIgnore = function shouldIgnore(line) {
              return bluebirdFramePattern.test(line);
            };
            return function (receiver, ignoreUntil) {
              Error.stackTraceLimit = Error.stackTraceLimit + 6;
              captureStackTrace(receiver, ignoreUntil);
              Error.stackTraceLimit = Error.stackTraceLimit - 6;
            };
          }
          var err = new Error();
          if (typeof err.stack === "string" && err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
            stackFramePattern = /@/;
            formatStack = v8stackFormatter;
            indentStackFrames = true;
            return function captureStackTrace(o) {
              o.stack = new Error().stack;
            };
          }
          var hasStackAfterThrow;
          try {
            throw new Error();
          } catch (e) {
            hasStackAfterThrow = "stack" in e;
          }
          if (!("stack" in err) && hasStackAfterThrow && typeof Error.stackTraceLimit === "number") {
            stackFramePattern = v8stackFramePattern;
            formatStack = v8stackFormatter;
            return function captureStackTrace(o) {
              Error.stackTraceLimit = Error.stackTraceLimit + 6;
              try {
                throw new Error();
              } catch (e) {
                o.stack = e.stack;
              }
              Error.stackTraceLimit = Error.stackTraceLimit - 6;
            };
          }
          formatStack = function formatStack(stack, error) {
            if (typeof stack === "string") return stack;
            if ((_typeof(error) === "object" || typeof error === "function") && error.name !== undefined && error.message !== undefined) {
              return error.toString();
            }
            return formatNonError(error);
          };
          return null;
        }([]);
        var fireDomEvent;
        var fireGlobalEvent = function () {
          if (util.isNode) {
            return function (name, reason, promise) {
              if (name === "rejectionHandled") {
                return process.emit(name, promise);
              } else {
                return process.emit(name, reason, promise);
              }
            };
          } else {
            var customEventWorks = false;
            var anyEventWorks = true;
            try {
              var ev = new self.CustomEvent("test");
              customEventWorks = ev instanceof CustomEvent;
            } catch (e) {}
            if (!customEventWorks) {
              try {
                var event = document.createEvent("CustomEvent");
                event.initCustomEvent("testingtheevent", false, true, {});
                self.dispatchEvent(event);
              } catch (e) {
                anyEventWorks = false;
              }
            }
            if (anyEventWorks) {
              fireDomEvent = function fireDomEvent(type, detail) {
                var event;
                if (customEventWorks) {
                  event = new self.CustomEvent(type, {
                    detail: detail,
                    bubbles: false,
                    cancelable: true
                  });
                } else if (self.dispatchEvent) {
                  event = document.createEvent("CustomEvent");
                  event.initCustomEvent(type, false, true, detail);
                }
                return event ? !self.dispatchEvent(event) : false;
              };
            }
            var toWindowMethodNameMap = {};
            toWindowMethodNameMap["unhandledRejection"] = ("on" + "unhandledRejection").toLowerCase();
            toWindowMethodNameMap["rejectionHandled"] = ("on" + "rejectionHandled").toLowerCase();
            return function (name, reason, promise) {
              var methodName = toWindowMethodNameMap[name];
              var method = self[methodName];
              if (!method) return false;
              if (name === "rejectionHandled") {
                method.call(self, promise);
              } else {
                method.call(self, reason, promise);
              }
              return true;
            };
          }
        }();
        if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
          warn = function warn(message) {
            console.warn(message);
          };
          if (util.isNode && process.stderr.isTTY) {
            warn = function warn(message) {
              process.stderr.write("\x1B[31m" + message + "\x1B[39m\n");
            };
          } else if (!util.isNode && typeof new Error().stack === "string") {
            warn = function warn(message) {
              console.warn("%c" + message, "color: red");
            };
          }
        }
        return CapturedTrace;
      };
    }, {
      "./async.js": 2,
      "./util.js": 38
    }],
    8: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (NEXT_FILTER) {
        var util = _dereq_("./util.js");
        var errors = _dereq_("./errors.js");
        var tryCatch = util.tryCatch;
        var errorObj = util.errorObj;
        var keys = _dereq_("./es5.js").keys;
        var TypeError = errors.TypeError;
        function CatchFilter(instances, callback, promise) {
          this._instances = instances;
          this._callback = callback;
          this._promise = promise;
        }
        function safePredicate(predicate, e) {
          var safeObject = {};
          var retfilter = tryCatch(predicate).call(safeObject, e);
          if (retfilter === errorObj) return retfilter;
          var safeKeys = keys(safeObject);
          if (safeKeys.length) {
            errorObj.e = new TypeError("Catch filter must inherit from Error or be a simple predicate function\n\n    See http://goo.gl/o84o68\n");
            return errorObj;
          }
          return retfilter;
        }
        CatchFilter.prototype.doFilter = function (e) {
          var cb = this._callback;
          var promise = this._promise;
          var boundTo = promise._boundValue();
          for (var i = 0, len = this._instances.length; i < len; ++i) {
            var item = this._instances[i];
            var itemIsErrorType = item === Error || item != null && item.prototype instanceof Error;
            if (itemIsErrorType && e instanceof item) {
              var ret = tryCatch(cb).call(boundTo, e);
              if (ret === errorObj) {
                NEXT_FILTER.e = ret.e;
                return NEXT_FILTER;
              }
              return ret;
            } else if (typeof item === "function" && !itemIsErrorType) {
              var shouldHandle = safePredicate(item, e);
              if (shouldHandle === errorObj) {
                e = errorObj.e;
                break;
              } else if (shouldHandle) {
                var ret = tryCatch(cb).call(boundTo, e);
                if (ret === errorObj) {
                  NEXT_FILTER.e = ret.e;
                  return NEXT_FILTER;
                }
                return ret;
              }
            }
          }
          NEXT_FILTER.e = e;
          return NEXT_FILTER;
        };
        return CatchFilter;
      };
    }, {
      "./errors.js": 13,
      "./es5.js": 14,
      "./util.js": 38
    }],
    9: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, CapturedTrace, isDebugging) {
        var contextStack = [];
        function Context() {
          this._trace = new CapturedTrace(peekContext());
        }
        Context.prototype._pushContext = function () {
          if (!isDebugging()) return;
          if (this._trace !== undefined) {
            contextStack.push(this._trace);
          }
        };
        Context.prototype._popContext = function () {
          if (!isDebugging()) return;
          if (this._trace !== undefined) {
            contextStack.pop();
          }
        };
        function createContext() {
          if (isDebugging()) return new Context();
        }
        function peekContext() {
          var lastIndex = contextStack.length - 1;
          if (lastIndex >= 0) {
            return contextStack[lastIndex];
          }
          return undefined;
        }
        Promise.prototype._peekContext = peekContext;
        Promise.prototype._pushContext = Context.prototype._pushContext;
        Promise.prototype._popContext = Context.prototype._popContext;
        return createContext;
      };
    }, {}],
    10: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, CapturedTrace) {
        var getDomain = Promise._getDomain;
        var async = _dereq_("./async.js");
        var Warning = _dereq_("./errors.js").Warning;
        var util = _dereq_("./util.js");
        var canAttachTrace = util.canAttachTrace;
        var unhandledRejectionHandled;
        var possiblyUnhandledRejection;
        var debugging =  false || util.isNode && (!!process.env["BLUEBIRD_DEBUG"] || "production" === "development");
        if (util.isNode && process.env["BLUEBIRD_DEBUG"] == 0) debugging = false;
        if (debugging) {
          async.disableTrampolineIfNecessary();
        }
        Promise.prototype._ignoreRejections = function () {
          this._unsetRejectionIsUnhandled();
          this._bitField = this._bitField | 16777216;
        };
        Promise.prototype._ensurePossibleRejectionHandled = function () {
          if ((this._bitField & 16777216) !== 0) return;
          this._setRejectionIsUnhandled();
          async.invokeLater(this._notifyUnhandledRejection, this, undefined);
        };
        Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
          CapturedTrace.fireRejectionEvent("rejectionHandled", unhandledRejectionHandled, undefined, this);
        };
        Promise.prototype._notifyUnhandledRejection = function () {
          if (this._isRejectionUnhandled()) {
            var reason = this._getCarriedStackTrace() || this._settledValue;
            this._setUnhandledRejectionIsNotified();
            CapturedTrace.fireRejectionEvent("unhandledRejection", possiblyUnhandledRejection, reason, this);
          }
        };
        Promise.prototype._setUnhandledRejectionIsNotified = function () {
          this._bitField = this._bitField | 524288;
        };
        Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
          this._bitField = this._bitField & ~524288;
        };
        Promise.prototype._isUnhandledRejectionNotified = function () {
          return (this._bitField & 524288) > 0;
        };
        Promise.prototype._setRejectionIsUnhandled = function () {
          this._bitField = this._bitField | 2097152;
        };
        Promise.prototype._unsetRejectionIsUnhandled = function () {
          this._bitField = this._bitField & ~2097152;
          if (this._isUnhandledRejectionNotified()) {
            this._unsetUnhandledRejectionIsNotified();
            this._notifyUnhandledRejectionIsHandled();
          }
        };
        Promise.prototype._isRejectionUnhandled = function () {
          return (this._bitField & 2097152) > 0;
        };
        Promise.prototype._setCarriedStackTrace = function (capturedTrace) {
          this._bitField = this._bitField | 1048576;
          this._fulfillmentHandler0 = capturedTrace;
        };
        Promise.prototype._isCarryingStackTrace = function () {
          return (this._bitField & 1048576) > 0;
        };
        Promise.prototype._getCarriedStackTrace = function () {
          return this._isCarryingStackTrace() ? this._fulfillmentHandler0 : undefined;
        };
        Promise.prototype._captureStackTrace = function () {
          if (debugging) {
            this._trace = new CapturedTrace(this._peekContext());
          }
          return this;
        };
        Promise.prototype._attachExtraTrace = function (error, ignoreSelf) {
          if (debugging && canAttachTrace(error)) {
            var trace = this._trace;
            if (trace !== undefined) {
              if (ignoreSelf) trace = trace._parent;
            }
            if (trace !== undefined) {
              trace.attachExtraTrace(error);
            } else if (!error.__stackCleaned__) {
              var parsed = CapturedTrace.parseStackAndMessage(error);
              util.notEnumerableProp(error, "stack", parsed.message + "\n" + parsed.stack.join("\n"));
              util.notEnumerableProp(error, "__stackCleaned__", true);
            }
          }
        };
        Promise.prototype._warn = function (message) {
          var warning = new Warning(message);
          var ctx = this._peekContext();
          if (ctx) {
            ctx.attachExtraTrace(warning);
          } else {
            var parsed = CapturedTrace.parseStackAndMessage(warning);
            warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
          }
          CapturedTrace.formatAndLogError(warning, "");
        };
        Promise.onPossiblyUnhandledRejection = function (fn) {
          var domain = getDomain();
          possiblyUnhandledRejection = typeof fn === "function" ? domain === null ? fn : domain.bind(fn) : undefined;
        };
        Promise.onUnhandledRejectionHandled = function (fn) {
          var domain = getDomain();
          unhandledRejectionHandled = typeof fn === "function" ? domain === null ? fn : domain.bind(fn) : undefined;
        };
        Promise.longStackTraces = function () {
          if (async.haveItemsQueued() && debugging === false) {
            throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/DT1qyG\n");
          }
          debugging = CapturedTrace.isSupported();
          if (debugging) {
            async.disableTrampolineIfNecessary();
          }
        };
        Promise.hasLongStackTraces = function () {
          return debugging && CapturedTrace.isSupported();
        };
        if (!CapturedTrace.isSupported()) {
          Promise.longStackTraces = function () {};
          debugging = false;
        }
        return function () {
          return debugging;
        };
      };
    }, {
      "./async.js": 2,
      "./errors.js": 13,
      "./util.js": 38
    }],
    11: [function (_dereq_, module, exports) {
      "use strict";

      var util = _dereq_("./util.js");
      var isPrimitive = util.isPrimitive;
      module.exports = function (Promise) {
        var returner = function returner() {
          return this;
        };
        var thrower = function thrower() {
          throw this;
        };
        var returnUndefined = function returnUndefined() {};
        var throwUndefined = function throwUndefined() {
          throw undefined;
        };
        var wrapper = function wrapper(value, action) {
          if (action === 1) {
            return function () {
              throw value;
            };
          } else if (action === 2) {
            return function () {
              return value;
            };
          }
        };
        Promise.prototype["return"] = Promise.prototype.thenReturn = function (value) {
          if (value === undefined) return this.then(returnUndefined);
          if (isPrimitive(value)) {
            return this._then(wrapper(value, 2), undefined, undefined, undefined, undefined);
          } else if (value instanceof Promise) {
            value._ignoreRejections();
          }
          return this._then(returner, undefined, undefined, value, undefined);
        };
        Promise.prototype["throw"] = Promise.prototype.thenThrow = function (reason) {
          if (reason === undefined) return this.then(throwUndefined);
          if (isPrimitive(reason)) {
            return this._then(wrapper(reason, 1), undefined, undefined, undefined, undefined);
          }
          return this._then(thrower, undefined, undefined, reason, undefined);
        };
      };
    }, {
      "./util.js": 38
    }],
    12: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, INTERNAL) {
        var PromiseReduce = Promise.reduce;
        Promise.prototype.each = function (fn) {
          return PromiseReduce(this, fn, null, INTERNAL);
        };
        Promise.each = function (promises, fn) {
          return PromiseReduce(promises, fn, null, INTERNAL);
        };
      };
    }, {}],
    13: [function (_dereq_, module, exports) {
      "use strict";

      var es5 = _dereq_("./es5.js");
      var Objectfreeze = es5.freeze;
      var util = _dereq_("./util.js");
      var inherits = util.inherits;
      var notEnumerableProp = util.notEnumerableProp;
      function subError(nameProperty, defaultMessage) {
        function SubError(message) {
          if (!(this instanceof SubError)) return new SubError(message);
          notEnumerableProp(this, "message", typeof message === "string" ? message : defaultMessage);
          notEnumerableProp(this, "name", nameProperty);
          if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
          } else {
            Error.call(this);
          }
        }
        inherits(SubError, Error);
        return SubError;
      }
      var _TypeError, _RangeError;
      var Warning = subError("Warning", "warning");
      var CancellationError = subError("CancellationError", "cancellation error");
      var TimeoutError = subError("TimeoutError", "timeout error");
      var AggregateError = subError("AggregateError", "aggregate error");
      try {
        _TypeError = TypeError;
        _RangeError = RangeError;
      } catch (e) {
        _TypeError = subError("TypeError", "type error");
        _RangeError = subError("RangeError", "range error");
      }
      var methods = ("join pop push shift unshift slice filter forEach some " + "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");
      for (var i = 0; i < methods.length; ++i) {
        if (typeof Array.prototype[methods[i]] === "function") {
          AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
        }
      }
      es5.defineProperty(AggregateError.prototype, "length", {
        value: 0,
        configurable: false,
        writable: true,
        enumerable: true
      });
      AggregateError.prototype["isOperational"] = true;
      var level = 0;
      AggregateError.prototype.toString = function () {
        var indent = Array(level * 4 + 1).join(" ");
        var ret = "\n" + indent + "AggregateError of:" + "\n";
        level++;
        indent = Array(level * 4 + 1).join(" ");
        for (var i = 0; i < this.length; ++i) {
          var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
          var lines = str.split("\n");
          for (var j = 0; j < lines.length; ++j) {
            lines[j] = indent + lines[j];
          }
          str = lines.join("\n");
          ret += str + "\n";
        }
        level--;
        return ret;
      };
      function OperationalError(message) {
        if (!(this instanceof OperationalError)) return new OperationalError(message);
        notEnumerableProp(this, "name", "OperationalError");
        notEnumerableProp(this, "message", message);
        this.cause = message;
        this["isOperational"] = true;
        if (message instanceof Error) {
          notEnumerableProp(this, "message", message.message);
          notEnumerableProp(this, "stack", message.stack);
        } else if (Error.captureStackTrace) {
          Error.captureStackTrace(this, this.constructor);
        }
      }
      inherits(OperationalError, Error);
      var errorTypes = Error["__BluebirdErrorTypes__"];
      if (!errorTypes) {
        errorTypes = Objectfreeze({
          CancellationError: CancellationError,
          TimeoutError: TimeoutError,
          OperationalError: OperationalError,
          RejectionError: OperationalError,
          AggregateError: AggregateError
        });
        notEnumerableProp(Error, "__BluebirdErrorTypes__", errorTypes);
      }
      module.exports = {
        Error: Error,
        TypeError: _TypeError,
        RangeError: _RangeError,
        CancellationError: errorTypes.CancellationError,
        OperationalError: errorTypes.OperationalError,
        TimeoutError: errorTypes.TimeoutError,
        AggregateError: errorTypes.AggregateError,
        Warning: Warning
      };
    }, {
      "./es5.js": 14,
      "./util.js": 38
    }],
    14: [function (_dereq_, module, exports) {
      var isES5 = function () {
        "use strict";

        return this === undefined;
      }();
      if (isES5) {
        module.exports = {
          freeze: Object.freeze,
          defineProperty: Object.defineProperty,
          getDescriptor: Object.getOwnPropertyDescriptor,
          keys: Object.keys,
          names: Object.getOwnPropertyNames,
          getPrototypeOf: Object.getPrototypeOf,
          isArray: Array.isArray,
          isES5: isES5,
          propertyIsWritable: function propertyIsWritable(obj, prop) {
            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
            return !!(!descriptor || descriptor.writable || descriptor.set);
          }
        };
      } else {
        var has = {}.hasOwnProperty;
        var str = {}.toString;
        var proto = {}.constructor.prototype;
        var ObjectKeys = function ObjectKeys(o) {
          var ret = [];
          for (var key in o) {
            if (has.call(o, key)) {
              ret.push(key);
            }
          }
          return ret;
        };
        var ObjectGetDescriptor = function ObjectGetDescriptor(o, key) {
          return {
            value: o[key]
          };
        };
        var ObjectDefineProperty = function ObjectDefineProperty(o, key, desc) {
          o[key] = desc.value;
          return o;
        };
        var ObjectFreeze = function ObjectFreeze(obj) {
          return obj;
        };
        var ObjectGetPrototypeOf = function ObjectGetPrototypeOf(obj) {
          try {
            return Object(obj).constructor.prototype;
          } catch (e) {
            return proto;
          }
        };
        var ArrayIsArray = function ArrayIsArray(obj) {
          try {
            return str.call(obj) === "[object Array]";
          } catch (e) {
            return false;
          }
        };
        module.exports = {
          isArray: ArrayIsArray,
          keys: ObjectKeys,
          names: ObjectKeys,
          defineProperty: ObjectDefineProperty,
          getDescriptor: ObjectGetDescriptor,
          freeze: ObjectFreeze,
          getPrototypeOf: ObjectGetPrototypeOf,
          isES5: isES5,
          propertyIsWritable: function propertyIsWritable() {
            return true;
          }
        };
      }
    }, {}],
    15: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, INTERNAL) {
        var PromiseMap = Promise.map;
        Promise.prototype.filter = function (fn, options) {
          return PromiseMap(this, fn, options, INTERNAL);
        };
        Promise.filter = function (promises, fn, options) {
          return PromiseMap(promises, fn, options, INTERNAL);
        };
      };
    }, {}],
    16: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, NEXT_FILTER, tryConvertToPromise) {
        var util = _dereq_("./util.js");
        var isPrimitive = util.isPrimitive;
        var thrower = util.thrower;
        function returnThis() {
          return this;
        }
        function throwThis() {
          throw this;
        }
        function return$(r) {
          return function () {
            return r;
          };
        }
        function throw$(r) {
          return function () {
            throw r;
          };
        }
        function promisedFinally(ret, reasonOrValue, isFulfilled) {
          var then;
          if (isPrimitive(reasonOrValue)) {
            then = isFulfilled ? return$(reasonOrValue) : throw$(reasonOrValue);
          } else {
            then = isFulfilled ? returnThis : throwThis;
          }
          return ret._then(then, thrower, undefined, reasonOrValue, undefined);
        }
        function finallyHandler(reasonOrValue) {
          var promise = this.promise;
          var handler = this.handler;
          var ret = promise._isBound() ? handler.call(promise._boundValue()) : handler();
          if (ret !== undefined) {
            var maybePromise = tryConvertToPromise(ret, promise);
            if (maybePromise instanceof Promise) {
              maybePromise = maybePromise._target();
              return promisedFinally(maybePromise, reasonOrValue, promise.isFulfilled());
            }
          }
          if (promise.isRejected()) {
            NEXT_FILTER.e = reasonOrValue;
            return NEXT_FILTER;
          } else {
            return reasonOrValue;
          }
        }
        function tapHandler(value) {
          var promise = this.promise;
          var handler = this.handler;
          var ret = promise._isBound() ? handler.call(promise._boundValue(), value) : handler(value);
          if (ret !== undefined) {
            var maybePromise = tryConvertToPromise(ret, promise);
            if (maybePromise instanceof Promise) {
              maybePromise = maybePromise._target();
              return promisedFinally(maybePromise, value, true);
            }
          }
          return value;
        }
        Promise.prototype._passThroughHandler = function (handler, isFinally) {
          if (typeof handler !== "function") return this.then();
          var promiseAndHandler = {
            promise: this,
            handler: handler
          };
          return this._then(isFinally ? finallyHandler : tapHandler, isFinally ? finallyHandler : undefined, undefined, promiseAndHandler, undefined);
        };
        Promise.prototype.lastly = Promise.prototype["finally"] = function (handler) {
          return this._passThroughHandler(handler, true);
        };
        Promise.prototype.tap = function (handler) {
          return this._passThroughHandler(handler, false);
        };
      };
    }, {
      "./util.js": 38
    }],
    17: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, apiRejection, INTERNAL, tryConvertToPromise) {
        var errors = _dereq_("./errors.js");
        var TypeError = errors.TypeError;
        var util = _dereq_("./util.js");
        var errorObj = util.errorObj;
        var tryCatch = util.tryCatch;
        var yieldHandlers = [];
        function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
          for (var i = 0; i < yieldHandlers.length; ++i) {
            traceParent._pushContext();
            var result = tryCatch(yieldHandlers[i])(value);
            traceParent._popContext();
            if (result === errorObj) {
              traceParent._pushContext();
              var ret = Promise.reject(errorObj.e);
              traceParent._popContext();
              return ret;
            }
            var maybePromise = tryConvertToPromise(result, traceParent);
            if (maybePromise instanceof Promise) return maybePromise;
          }
          return null;
        }
        function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
          var promise = this._promise = new Promise(INTERNAL);
          promise._captureStackTrace();
          this._stack = stack;
          this._generatorFunction = generatorFunction;
          this._receiver = receiver;
          this._generator = undefined;
          this._yieldHandlers = typeof yieldHandler === "function" ? [yieldHandler].concat(yieldHandlers) : yieldHandlers;
        }
        PromiseSpawn.prototype.promise = function () {
          return this._promise;
        };
        PromiseSpawn.prototype._run = function () {
          this._generator = this._generatorFunction.call(this._receiver);
          this._receiver = this._generatorFunction = undefined;
          this._next(undefined);
        };
        PromiseSpawn.prototype._continue = function (result) {
          if (result === errorObj) {
            return this._promise._rejectCallback(result.e, false, true);
          }
          var value = result.value;
          if (result.done === true) {
            this._promise._resolveCallback(value);
          } else {
            var maybePromise = tryConvertToPromise(value, this._promise);
            if (!(maybePromise instanceof Promise)) {
              maybePromise = promiseFromYieldHandler(maybePromise, this._yieldHandlers, this._promise);
              if (maybePromise === null) {
                this._throw(new TypeError("A value %s was yielded that could not be treated as a promise\n\n    See http://goo.gl/4Y4pDk\n\n".replace("%s", value) + "From coroutine:\n" + this._stack.split("\n").slice(1, -7).join("\n")));
                return;
              }
            }
            maybePromise._then(this._next, this._throw, undefined, this, null);
          }
        };
        PromiseSpawn.prototype._throw = function (reason) {
          this._promise._attachExtraTrace(reason);
          this._promise._pushContext();
          var result = tryCatch(this._generator["throw"]).call(this._generator, reason);
          this._promise._popContext();
          this._continue(result);
        };
        PromiseSpawn.prototype._next = function (value) {
          this._promise._pushContext();
          var result = tryCatch(this._generator.next).call(this._generator, value);
          this._promise._popContext();
          this._continue(result);
        };
        Promise.coroutine = function (generatorFunction, options) {
          if (typeof generatorFunction !== "function") {
            throw new TypeError("generatorFunction must be a function\n\n    See http://goo.gl/6Vqhm0\n");
          }
          var yieldHandler = Object(options).yieldHandler;
          var PromiseSpawn$ = PromiseSpawn;
          var stack = new Error().stack;
          return function () {
            var generator = generatorFunction.apply(this, arguments);
            var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler, stack);
            spawn._generator = generator;
            spawn._next(undefined);
            return spawn.promise();
          };
        };
        Promise.coroutine.addYieldHandler = function (fn) {
          if (typeof fn !== "function") throw new TypeError("fn must be a function\n\n    See http://goo.gl/916lJJ\n");
          yieldHandlers.push(fn);
        };
        Promise.spawn = function (generatorFunction) {
          if (typeof generatorFunction !== "function") {
            return apiRejection("generatorFunction must be a function\n\n    See http://goo.gl/6Vqhm0\n");
          }
          var spawn = new PromiseSpawn(generatorFunction, this);
          var ret = spawn.promise();
          spawn._run(Promise.spawn);
          return ret;
        };
      };
    }, {
      "./errors.js": 13,
      "./util.js": 38
    }],
    18: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, PromiseArray, tryConvertToPromise, INTERNAL) {
        var util = _dereq_("./util.js");
        var canEvaluate = util.canEvaluate;
        var tryCatch = util.tryCatch;
        var errorObj = util.errorObj;
        var reject;
        if (false) { var reject, Holder, i, callers, thenCallbacks, caller, thenCallback; }
        Promise.join = function () {
          var last = arguments.length - 1;
          var fn;
          if (last > 0 && typeof arguments[last] === "function") {
            fn = arguments[last];
            if (false) { var maybePromise, i, callbacks, holder, ret; }
          }
          var $_len = arguments.length;
          var args = new Array($_len);
          for (var $_i = 0; $_i < $_len; ++$_i) {
            args[$_i] = arguments[$_i];
          }
          if (fn) args.pop();
          var ret = new PromiseArray(args).promise();
          return fn !== undefined ? ret.spread(fn) : ret;
        };
      };
    }, {
      "./util.js": 38
    }],
    19: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL) {
        var getDomain = Promise._getDomain;
        var async = _dereq_("./async.js");
        var util = _dereq_("./util.js");
        var tryCatch = util.tryCatch;
        var errorObj = util.errorObj;
        var PENDING = {};
        var EMPTY_ARRAY = [];
        function MappingPromiseArray(promises, fn, limit, _filter) {
          this.constructor$(promises);
          this._promise._captureStackTrace();
          var domain = getDomain();
          this._callback = domain === null ? fn : domain.bind(fn);
          this._preservedValues = _filter === INTERNAL ? new Array(this.length()) : null;
          this._limit = limit;
          this._inFlight = 0;
          this._queue = limit >= 1 ? [] : EMPTY_ARRAY;
          async.invoke(init, this, undefined);
        }
        util.inherits(MappingPromiseArray, PromiseArray);
        function init() {
          this._init$(undefined, -2);
        }
        MappingPromiseArray.prototype._init = function () {};
        MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
          var values = this._values;
          var length = this.length();
          var preservedValues = this._preservedValues;
          var limit = this._limit;
          if (values[index] === PENDING) {
            values[index] = value;
            if (limit >= 1) {
              this._inFlight--;
              this._drainQueue();
              if (this._isResolved()) return;
            }
          } else {
            if (limit >= 1 && this._inFlight >= limit) {
              values[index] = value;
              this._queue.push(index);
              return;
            }
            if (preservedValues !== null) preservedValues[index] = value;
            var callback = this._callback;
            var receiver = this._promise._boundValue();
            this._promise._pushContext();
            var ret = tryCatch(callback).call(receiver, value, index, length);
            this._promise._popContext();
            if (ret === errorObj) return this._reject(ret.e);
            var maybePromise = tryConvertToPromise(ret, this._promise);
            if (maybePromise instanceof Promise) {
              maybePromise = maybePromise._target();
              if (maybePromise._isPending()) {
                if (limit >= 1) this._inFlight++;
                values[index] = PENDING;
                return maybePromise._proxyPromiseArray(this, index);
              } else if (maybePromise._isFulfilled()) {
                ret = maybePromise._value();
              } else {
                return this._reject(maybePromise._reason());
              }
            }
            values[index] = ret;
          }
          var totalResolved = ++this._totalResolved;
          if (totalResolved >= length) {
            if (preservedValues !== null) {
              this._filter(values, preservedValues);
            } else {
              this._resolve(values);
            }
          }
        };
        MappingPromiseArray.prototype._drainQueue = function () {
          var queue = this._queue;
          var limit = this._limit;
          var values = this._values;
          while (queue.length > 0 && this._inFlight < limit) {
            if (this._isResolved()) return;
            var index = queue.pop();
            this._promiseFulfilled(values[index], index);
          }
        };
        MappingPromiseArray.prototype._filter = function (booleans, values) {
          var len = values.length;
          var ret = new Array(len);
          var j = 0;
          for (var i = 0; i < len; ++i) {
            if (booleans[i]) ret[j++] = values[i];
          }
          ret.length = j;
          this._resolve(ret);
        };
        MappingPromiseArray.prototype.preservedValues = function () {
          return this._preservedValues;
        };
        function map(promises, fn, options, _filter) {
          var limit = _typeof(options) === "object" && options !== null ? options.concurrency : 0;
          limit = typeof limit === "number" && isFinite(limit) && limit >= 1 ? limit : 0;
          return new MappingPromiseArray(promises, fn, limit, _filter);
        }
        Promise.prototype.map = function (fn, options) {
          if (typeof fn !== "function") return apiRejection("fn must be a function\n\n    See http://goo.gl/916lJJ\n");
          return map(this, fn, options, null).promise();
        };
        Promise.map = function (promises, fn, options, _filter) {
          if (typeof fn !== "function") return apiRejection("fn must be a function\n\n    See http://goo.gl/916lJJ\n");
          return map(promises, fn, options, _filter).promise();
        };
      };
    }, {
      "./async.js": 2,
      "./util.js": 38
    }],
    20: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, INTERNAL, tryConvertToPromise, apiRejection) {
        var util = _dereq_("./util.js");
        var tryCatch = util.tryCatch;
        Promise.method = function (fn) {
          if (typeof fn !== "function") {
            throw new Promise.TypeError("fn must be a function\n\n    See http://goo.gl/916lJJ\n");
          }
          return function () {
            var ret = new Promise(INTERNAL);
            ret._captureStackTrace();
            ret._pushContext();
            var value = tryCatch(fn).apply(this, arguments);
            ret._popContext();
            ret._resolveFromSyncValue(value);
            return ret;
          };
        };
        Promise.attempt = Promise["try"] = function (fn, args, ctx) {
          if (typeof fn !== "function") {
            return apiRejection("fn must be a function\n\n    See http://goo.gl/916lJJ\n");
          }
          var ret = new Promise(INTERNAL);
          ret._captureStackTrace();
          ret._pushContext();
          var value = util.isArray(args) ? tryCatch(fn).apply(ctx, args) : tryCatch(fn).call(ctx, args);
          ret._popContext();
          ret._resolveFromSyncValue(value);
          return ret;
        };
        Promise.prototype._resolveFromSyncValue = function (value) {
          if (value === util.errorObj) {
            this._rejectCallback(value.e, false, true);
          } else {
            this._resolveCallback(value, true);
          }
        };
      };
    }, {
      "./util.js": 38
    }],
    21: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise) {
        var util = _dereq_("./util.js");
        var async = _dereq_("./async.js");
        var tryCatch = util.tryCatch;
        var errorObj = util.errorObj;
        function spreadAdapter(val, nodeback) {
          var promise = this;
          if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
          var ret = tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
          if (ret === errorObj) {
            async.throwLater(ret.e);
          }
        }
        function successAdapter(val, nodeback) {
          var promise = this;
          var receiver = promise._boundValue();
          var ret = val === undefined ? tryCatch(nodeback).call(receiver, null) : tryCatch(nodeback).call(receiver, null, val);
          if (ret === errorObj) {
            async.throwLater(ret.e);
          }
        }
        function errorAdapter(reason, nodeback) {
          var promise = this;
          if (!reason) {
            var target = promise._target();
            var newReason = target._getCarriedStackTrace();
            newReason.cause = reason;
            reason = newReason;
          }
          var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
          if (ret === errorObj) {
            async.throwLater(ret.e);
          }
        }
        Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback, options) {
          if (typeof nodeback == "function") {
            var adapter = successAdapter;
            if (options !== undefined && Object(options).spread) {
              adapter = spreadAdapter;
            }
            this._then(adapter, errorAdapter, undefined, this, nodeback);
          }
          return this;
        };
      };
    }, {
      "./async.js": 2,
      "./util.js": 38
    }],
    22: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, PromiseArray) {
        var util = _dereq_("./util.js");
        var async = _dereq_("./async.js");
        var tryCatch = util.tryCatch;
        var errorObj = util.errorObj;
        Promise.prototype.progressed = function (handler) {
          return this._then(undefined, undefined, handler, undefined, undefined);
        };
        Promise.prototype._progress = function (progressValue) {
          if (this._isFollowingOrFulfilledOrRejected()) return;
          this._target()._progressUnchecked(progressValue);
        };
        Promise.prototype._progressHandlerAt = function (index) {
          return index === 0 ? this._progressHandler0 : this[(index << 2) + index - 5 + 2];
        };
        Promise.prototype._doProgressWith = function (progression) {
          var progressValue = progression.value;
          var handler = progression.handler;
          var promise = progression.promise;
          var receiver = progression.receiver;
          var ret = tryCatch(handler).call(receiver, progressValue);
          if (ret === errorObj) {
            if (ret.e != null && ret.e.name !== "StopProgressPropagation") {
              var trace = util.canAttachTrace(ret.e) ? ret.e : new Error(util.toString(ret.e));
              promise._attachExtraTrace(trace);
              promise._progress(ret.e);
            }
          } else if (ret instanceof Promise) {
            ret._then(promise._progress, null, null, promise, undefined);
          } else {
            promise._progress(ret);
          }
        };
        Promise.prototype._progressUnchecked = function (progressValue) {
          var len = this._length();
          var progress = this._progress;
          for (var i = 0; i < len; i++) {
            var handler = this._progressHandlerAt(i);
            var promise = this._promiseAt(i);
            if (!(promise instanceof Promise)) {
              var receiver = this._receiverAt(i);
              if (typeof handler === "function") {
                handler.call(receiver, progressValue, promise);
              } else if (receiver instanceof PromiseArray && !receiver._isResolved()) {
                receiver._promiseProgressed(progressValue, promise);
              }
              continue;
            }
            if (typeof handler === "function") {
              async.invoke(this._doProgressWith, this, {
                handler: handler,
                promise: promise,
                receiver: this._receiverAt(i),
                value: progressValue
              });
            } else {
              async.invoke(progress, promise, progressValue);
            }
          }
        };
      };
    }, {
      "./async.js": 2,
      "./util.js": 38
    }],
    23: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function () {
        var makeSelfResolutionError = function makeSelfResolutionError() {
          return new TypeError("circular promise resolution chain\n\n    See http://goo.gl/LhFpo0\n");
        };
        var reflect = function reflect() {
          return new Promise.PromiseInspection(this._target());
        };
        var apiRejection = function apiRejection(msg) {
          return Promise.reject(new TypeError(msg));
        };
        var util = _dereq_("./util.js");
        var getDomain;
        if (util.isNode) {
          getDomain = function getDomain() {
            var ret = process.domain;
            if (ret === undefined) ret = null;
            return ret;
          };
        } else {
          getDomain = function getDomain() {
            return null;
          };
        }
        util.notEnumerableProp(Promise, "_getDomain", getDomain);
        var UNDEFINED_BINDING = {};
        var async = _dereq_("./async.js");
        var errors = _dereq_("./errors.js");
        var TypeError = Promise.TypeError = errors.TypeError;
        Promise.RangeError = errors.RangeError;
        Promise.CancellationError = errors.CancellationError;
        Promise.TimeoutError = errors.TimeoutError;
        Promise.OperationalError = errors.OperationalError;
        Promise.RejectionError = errors.OperationalError;
        Promise.AggregateError = errors.AggregateError;
        var INTERNAL = function INTERNAL() {};
        var APPLY = {};
        var NEXT_FILTER = {
          e: null
        };
        var tryConvertToPromise = _dereq_("./thenables.js")(Promise, INTERNAL);
        var PromiseArray = _dereq_("./promise_array.js")(Promise, INTERNAL, tryConvertToPromise, apiRejection);
        var CapturedTrace = _dereq_("./captured_trace.js")();
        var isDebugging = _dereq_("./debuggability.js")(Promise, CapturedTrace);
        /*jshint unused:false*/
        var createContext = _dereq_("./context.js")(Promise, CapturedTrace, isDebugging);
        var CatchFilter = _dereq_("./catch_filter.js")(NEXT_FILTER);
        var PromiseResolver = _dereq_("./promise_resolver.js");
        var nodebackForPromise = PromiseResolver._nodebackForPromise;
        var errorObj = util.errorObj;
        var tryCatch = util.tryCatch;
        function Promise(resolver) {
          if (typeof resolver !== "function") {
            throw new TypeError("the promise constructor requires a resolver function\n\n    See http://goo.gl/EC22Yn\n");
          }
          if (this.constructor !== Promise) {
            throw new TypeError("the promise constructor cannot be invoked directly\n\n    See http://goo.gl/KsIlge\n");
          }
          this._bitField = 0;
          this._fulfillmentHandler0 = undefined;
          this._rejectionHandler0 = undefined;
          this._progressHandler0 = undefined;
          this._promise0 = undefined;
          this._receiver0 = undefined;
          this._settledValue = undefined;
          if (resolver !== INTERNAL) this._resolveFromResolver(resolver);
        }
        Promise.prototype.toString = function () {
          return "[object Promise]";
        };
        Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
          var len = arguments.length;
          if (len > 1) {
            var catchInstances = new Array(len - 1),
              j = 0,
              i;
            for (i = 0; i < len - 1; ++i) {
              var item = arguments[i];
              if (typeof item === "function") {
                catchInstances[j++] = item;
              } else {
                return Promise.reject(new TypeError("Catch filter must inherit from Error or be a simple predicate function\n\n    See http://goo.gl/o84o68\n"));
              }
            }
            catchInstances.length = j;
            fn = arguments[i];
            var catchFilter = new CatchFilter(catchInstances, fn, this);
            return this._then(undefined, catchFilter.doFilter, undefined, catchFilter, undefined);
          }
          return this._then(undefined, fn, undefined, undefined, undefined);
        };
        Promise.prototype.reflect = function () {
          return this._then(reflect, reflect, undefined, this, undefined);
        };
        Promise.prototype.then = function (didFulfill, didReject, didProgress) {
          if (isDebugging() && arguments.length > 0 && typeof didFulfill !== "function" && typeof didReject !== "function") {
            var msg = ".then() only accepts functions but was passed: " + util.classString(didFulfill);
            if (arguments.length > 1) {
              msg += ", " + util.classString(didReject);
            }
            this._warn(msg);
          }
          return this._then(didFulfill, didReject, didProgress, undefined, undefined);
        };
        Promise.prototype.done = function (didFulfill, didReject, didProgress) {
          var promise = this._then(didFulfill, didReject, didProgress, undefined, undefined);
          promise._setIsFinal();
        };
        Promise.prototype.spread = function (didFulfill, didReject) {
          return this.all()._then(didFulfill, didReject, undefined, APPLY, undefined);
        };
        Promise.prototype.isCancellable = function () {
          return !this.isResolved() && this._cancellable();
        };
        Promise.prototype.toJSON = function () {
          var ret = {
            isFulfilled: false,
            isRejected: false,
            fulfillmentValue: undefined,
            rejectionReason: undefined
          };
          if (this.isFulfilled()) {
            ret.fulfillmentValue = this.value();
            ret.isFulfilled = true;
          } else if (this.isRejected()) {
            ret.rejectionReason = this.reason();
            ret.isRejected = true;
          }
          return ret;
        };
        Promise.prototype.all = function () {
          return new PromiseArray(this).promise();
        };
        Promise.prototype.error = function (fn) {
          return this.caught(util.originatesFromRejection, fn);
        };
        Promise.getNewLibraryCopy = module.exports;
        Promise.is = function (val) {
          return val instanceof Promise;
        };
        Promise.fromNode = function (fn) {
          var ret = new Promise(INTERNAL);
          var result = tryCatch(fn)(nodebackForPromise(ret));
          if (result === errorObj) {
            ret._rejectCallback(result.e, true, true);
          }
          return ret;
        };
        Promise.all = function (promises) {
          return new PromiseArray(promises).promise();
        };
        Promise.defer = Promise.pending = function () {
          var promise = new Promise(INTERNAL);
          return new PromiseResolver(promise);
        };
        Promise.cast = function (obj) {
          var ret = tryConvertToPromise(obj);
          if (!(ret instanceof Promise)) {
            var val = ret;
            ret = new Promise(INTERNAL);
            ret._fulfillUnchecked(val);
          }
          return ret;
        };
        Promise.resolve = Promise.fulfilled = Promise.cast;
        Promise.reject = Promise.rejected = function (reason) {
          var ret = new Promise(INTERNAL);
          ret._captureStackTrace();
          ret._rejectCallback(reason, true);
          return ret;
        };
        Promise.setScheduler = function (fn) {
          if (typeof fn !== "function") throw new TypeError("fn must be a function\n\n    See http://goo.gl/916lJJ\n");
          var prev = async._schedule;
          async._schedule = fn;
          return prev;
        };
        Promise.prototype._then = function (didFulfill, didReject, didProgress, receiver, internalData) {
          var haveInternalData = internalData !== undefined;
          var ret = haveInternalData ? internalData : new Promise(INTERNAL);
          if (!haveInternalData) {
            ret._propagateFrom(this, 4 | 1);
            ret._captureStackTrace();
          }
          var target = this._target();
          if (target !== this) {
            if (receiver === undefined) receiver = this._boundTo;
            if (!haveInternalData) ret._setIsMigrated();
          }
          var callbackIndex = target._addCallbacks(didFulfill, didReject, didProgress, ret, receiver, getDomain());
          if (target._isResolved() && !target._isSettlePromisesQueued()) {
            async.invoke(target._settlePromiseAtPostResolution, target, callbackIndex);
          }
          return ret;
        };
        Promise.prototype._settlePromiseAtPostResolution = function (index) {
          if (this._isRejectionUnhandled()) this._unsetRejectionIsUnhandled();
          this._settlePromiseAt(index);
        };
        Promise.prototype._length = function () {
          return this._bitField & 131071;
        };
        Promise.prototype._isFollowingOrFulfilledOrRejected = function () {
          return (this._bitField & 939524096) > 0;
        };
        Promise.prototype._isFollowing = function () {
          return (this._bitField & 536870912) === 536870912;
        };
        Promise.prototype._setLength = function (len) {
          this._bitField = this._bitField & -131072 | len & 131071;
        };
        Promise.prototype._setFulfilled = function () {
          this._bitField = this._bitField | 268435456;
        };
        Promise.prototype._setRejected = function () {
          this._bitField = this._bitField | 134217728;
        };
        Promise.prototype._setFollowing = function () {
          this._bitField = this._bitField | 536870912;
        };
        Promise.prototype._setIsFinal = function () {
          this._bitField = this._bitField | 33554432;
        };
        Promise.prototype._isFinal = function () {
          return (this._bitField & 33554432) > 0;
        };
        Promise.prototype._cancellable = function () {
          return (this._bitField & 67108864) > 0;
        };
        Promise.prototype._setCancellable = function () {
          this._bitField = this._bitField | 67108864;
        };
        Promise.prototype._unsetCancellable = function () {
          this._bitField = this._bitField & ~67108864;
        };
        Promise.prototype._setIsMigrated = function () {
          this._bitField = this._bitField | 4194304;
        };
        Promise.prototype._unsetIsMigrated = function () {
          this._bitField = this._bitField & ~4194304;
        };
        Promise.prototype._isMigrated = function () {
          return (this._bitField & 4194304) > 0;
        };
        Promise.prototype._receiverAt = function (index) {
          var ret = index === 0 ? this._receiver0 : this[index * 5 - 5 + 4];
          if (ret === UNDEFINED_BINDING) {
            return undefined;
          } else if (ret === undefined && this._isBound()) {
            return this._boundValue();
          }
          return ret;
        };
        Promise.prototype._promiseAt = function (index) {
          return index === 0 ? this._promise0 : this[index * 5 - 5 + 3];
        };
        Promise.prototype._fulfillmentHandlerAt = function (index) {
          return index === 0 ? this._fulfillmentHandler0 : this[index * 5 - 5 + 0];
        };
        Promise.prototype._rejectionHandlerAt = function (index) {
          return index === 0 ? this._rejectionHandler0 : this[index * 5 - 5 + 1];
        };
        Promise.prototype._boundValue = function () {
          var ret = this._boundTo;
          if (ret !== undefined) {
            if (ret instanceof Promise) {
              if (ret.isFulfilled()) {
                return ret.value();
              } else {
                return undefined;
              }
            }
          }
          return ret;
        };
        Promise.prototype._migrateCallbacks = function (follower, index) {
          var fulfill = follower._fulfillmentHandlerAt(index);
          var reject = follower._rejectionHandlerAt(index);
          var progress = follower._progressHandlerAt(index);
          var promise = follower._promiseAt(index);
          var receiver = follower._receiverAt(index);
          if (promise instanceof Promise) promise._setIsMigrated();
          if (receiver === undefined) receiver = UNDEFINED_BINDING;
          this._addCallbacks(fulfill, reject, progress, promise, receiver, null);
        };
        Promise.prototype._addCallbacks = function (fulfill, reject, progress, promise, receiver, domain) {
          var index = this._length();
          if (index >= 131071 - 5) {
            index = 0;
            this._setLength(0);
          }
          if (index === 0) {
            this._promise0 = promise;
            if (receiver !== undefined) this._receiver0 = receiver;
            if (typeof fulfill === "function" && !this._isCarryingStackTrace()) {
              this._fulfillmentHandler0 = domain === null ? fulfill : domain.bind(fulfill);
            }
            if (typeof reject === "function") {
              this._rejectionHandler0 = domain === null ? reject : domain.bind(reject);
            }
            if (typeof progress === "function") {
              this._progressHandler0 = domain === null ? progress : domain.bind(progress);
            }
          } else {
            var base = index * 5 - 5;
            this[base + 3] = promise;
            this[base + 4] = receiver;
            if (typeof fulfill === "function") {
              this[base + 0] = domain === null ? fulfill : domain.bind(fulfill);
            }
            if (typeof reject === "function") {
              this[base + 1] = domain === null ? reject : domain.bind(reject);
            }
            if (typeof progress === "function") {
              this[base + 2] = domain === null ? progress : domain.bind(progress);
            }
          }
          this._setLength(index + 1);
          return index;
        };
        Promise.prototype._setProxyHandlers = function (receiver, promiseSlotValue) {
          var index = this._length();
          if (index >= 131071 - 5) {
            index = 0;
            this._setLength(0);
          }
          if (index === 0) {
            this._promise0 = promiseSlotValue;
            this._receiver0 = receiver;
          } else {
            var base = index * 5 - 5;
            this[base + 3] = promiseSlotValue;
            this[base + 4] = receiver;
          }
          this._setLength(index + 1);
        };
        Promise.prototype._proxyPromiseArray = function (promiseArray, index) {
          this._setProxyHandlers(promiseArray, index);
        };
        Promise.prototype._resolveCallback = function (value, shouldBind) {
          if (this._isFollowingOrFulfilledOrRejected()) return;
          if (value === this) return this._rejectCallback(makeSelfResolutionError(), false, true);
          var maybePromise = tryConvertToPromise(value, this);
          if (!(maybePromise instanceof Promise)) return this._fulfill(value);
          var propagationFlags = 1 | (shouldBind ? 4 : 0);
          this._propagateFrom(maybePromise, propagationFlags);
          var promise = maybePromise._target();
          if (promise._isPending()) {
            var len = this._length();
            for (var i = 0; i < len; ++i) {
              promise._migrateCallbacks(this, i);
            }
            this._setFollowing();
            this._setLength(0);
            this._setFollowee(promise);
          } else if (promise._isFulfilled()) {
            this._fulfillUnchecked(promise._value());
          } else {
            this._rejectUnchecked(promise._reason(), promise._getCarriedStackTrace());
          }
        };
        Promise.prototype._rejectCallback = function (reason, synchronous, shouldNotMarkOriginatingFromRejection) {
          if (!shouldNotMarkOriginatingFromRejection) {
            util.markAsOriginatingFromRejection(reason);
          }
          var trace = util.ensureErrorObject(reason);
          var hasStack = trace === reason;
          this._attachExtraTrace(trace, synchronous ? hasStack : false);
          this._reject(reason, hasStack ? undefined : trace);
        };
        Promise.prototype._resolveFromResolver = function (resolver) {
          var promise = this;
          this._captureStackTrace();
          this._pushContext();
          var synchronous = true;
          var r = tryCatch(resolver)(function (value) {
            if (promise === null) return;
            promise._resolveCallback(value);
            promise = null;
          }, function (reason) {
            if (promise === null) return;
            promise._rejectCallback(reason, synchronous);
            promise = null;
          });
          synchronous = false;
          this._popContext();
          if (r !== undefined && r === errorObj && promise !== null) {
            promise._rejectCallback(r.e, true, true);
            promise = null;
          }
        };
        Promise.prototype._settlePromiseFromHandler = function (handler, receiver, value, promise) {
          if (promise._isRejected()) return;
          promise._pushContext();
          var x;
          if (receiver === APPLY && !this._isRejected()) {
            x = tryCatch(handler).apply(this._boundValue(), value);
          } else {
            x = tryCatch(handler).call(receiver, value);
          }
          promise._popContext();
          if (x === errorObj || x === promise || x === NEXT_FILTER) {
            var err = x === promise ? makeSelfResolutionError() : x.e;
            promise._rejectCallback(err, false, true);
          } else {
            promise._resolveCallback(x);
          }
        };
        Promise.prototype._target = function () {
          var ret = this;
          while (ret._isFollowing()) {
            ret = ret._followee();
          }
          return ret;
        };
        Promise.prototype._followee = function () {
          return this._rejectionHandler0;
        };
        Promise.prototype._setFollowee = function (promise) {
          this._rejectionHandler0 = promise;
        };
        Promise.prototype._cleanValues = function () {
          if (this._cancellable()) {
            this._cancellationParent = undefined;
          }
        };
        Promise.prototype._propagateFrom = function (parent, flags) {
          if ((flags & 1) > 0 && parent._cancellable()) {
            this._setCancellable();
            this._cancellationParent = parent;
          }
          if ((flags & 4) > 0 && parent._isBound()) {
            this._setBoundTo(parent._boundTo);
          }
        };
        Promise.prototype._fulfill = function (value) {
          if (this._isFollowingOrFulfilledOrRejected()) return;
          this._fulfillUnchecked(value);
        };
        Promise.prototype._reject = function (reason, carriedStackTrace) {
          if (this._isFollowingOrFulfilledOrRejected()) return;
          this._rejectUnchecked(reason, carriedStackTrace);
        };
        Promise.prototype._settlePromiseAt = function (index) {
          var promise = this._promiseAt(index);
          var isPromise = promise instanceof Promise;
          if (isPromise && promise._isMigrated()) {
            promise._unsetIsMigrated();
            return async.invoke(this._settlePromiseAt, this, index);
          }
          var handler = this._isFulfilled() ? this._fulfillmentHandlerAt(index) : this._rejectionHandlerAt(index);
          var carriedStackTrace = this._isCarryingStackTrace() ? this._getCarriedStackTrace() : undefined;
          var value = this._settledValue;
          var receiver = this._receiverAt(index);
          this._clearCallbackDataAtIndex(index);
          if (typeof handler === "function") {
            if (!isPromise) {
              handler.call(receiver, value, promise);
            } else {
              this._settlePromiseFromHandler(handler, receiver, value, promise);
            }
          } else if (receiver instanceof PromiseArray) {
            if (!receiver._isResolved()) {
              if (this._isFulfilled()) {
                receiver._promiseFulfilled(value, promise);
              } else {
                receiver._promiseRejected(value, promise);
              }
            }
          } else if (isPromise) {
            if (this._isFulfilled()) {
              promise._fulfill(value);
            } else {
              promise._reject(value, carriedStackTrace);
            }
          }
          if (index >= 4 && (index & 31) === 4) async.invokeLater(this._setLength, this, 0);
        };
        Promise.prototype._clearCallbackDataAtIndex = function (index) {
          if (index === 0) {
            if (!this._isCarryingStackTrace()) {
              this._fulfillmentHandler0 = undefined;
            }
            this._rejectionHandler0 = this._progressHandler0 = this._receiver0 = this._promise0 = undefined;
          } else {
            var base = index * 5 - 5;
            this[base + 3] = this[base + 4] = this[base + 0] = this[base + 1] = this[base + 2] = undefined;
          }
        };
        Promise.prototype._isSettlePromisesQueued = function () {
          return (this._bitField & -1073741824) === -1073741824;
        };
        Promise.prototype._setSettlePromisesQueued = function () {
          this._bitField = this._bitField | -1073741824;
        };
        Promise.prototype._unsetSettlePromisesQueued = function () {
          this._bitField = this._bitField & ~-1073741824;
        };
        Promise.prototype._queueSettlePromises = function () {
          async.settlePromises(this);
          this._setSettlePromisesQueued();
        };
        Promise.prototype._fulfillUnchecked = function (value) {
          if (value === this) {
            var err = makeSelfResolutionError();
            this._attachExtraTrace(err);
            return this._rejectUnchecked(err, undefined);
          }
          this._setFulfilled();
          this._settledValue = value;
          this._cleanValues();
          if (this._length() > 0) {
            this._queueSettlePromises();
          }
        };
        Promise.prototype._rejectUncheckedCheckError = function (reason) {
          var trace = util.ensureErrorObject(reason);
          this._rejectUnchecked(reason, trace === reason ? undefined : trace);
        };
        Promise.prototype._rejectUnchecked = function (reason, trace) {
          if (reason === this) {
            var err = makeSelfResolutionError();
            this._attachExtraTrace(err);
            return this._rejectUnchecked(err);
          }
          this._setRejected();
          this._settledValue = reason;
          this._cleanValues();
          if (this._isFinal()) {
            async.throwLater(function (e) {
              if ("stack" in e) {
                async.invokeFirst(CapturedTrace.unhandledRejection, undefined, e);
              }
              throw e;
            }, trace === undefined ? reason : trace);
            return;
          }
          if (trace !== undefined && trace !== reason) {
            this._setCarriedStackTrace(trace);
          }
          if (this._length() > 0) {
            this._queueSettlePromises();
          } else {
            this._ensurePossibleRejectionHandled();
          }
        };
        Promise.prototype._settlePromises = function () {
          this._unsetSettlePromisesQueued();
          var len = this._length();
          for (var i = 0; i < len; i++) {
            this._settlePromiseAt(i);
          }
        };
        util.notEnumerableProp(Promise, "_makeSelfResolutionError", makeSelfResolutionError);
        _dereq_("./progress.js")(Promise, PromiseArray);
        _dereq_("./method.js")(Promise, INTERNAL, tryConvertToPromise, apiRejection);
        _dereq_("./bind.js")(Promise, INTERNAL, tryConvertToPromise);
        _dereq_("./finally.js")(Promise, NEXT_FILTER, tryConvertToPromise);
        _dereq_("./direct_resolve.js")(Promise);
        _dereq_("./synchronous_inspection.js")(Promise);
        _dereq_("./join.js")(Promise, PromiseArray, tryConvertToPromise, INTERNAL);
        Promise.version = "2.11.0";
        Promise.Promise = Promise;
        _dereq_('./map.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL);
        _dereq_('./cancel.js')(Promise);
        _dereq_('./using.js')(Promise, apiRejection, tryConvertToPromise, createContext);
        _dereq_('./generators.js')(Promise, apiRejection, INTERNAL, tryConvertToPromise);
        _dereq_('./nodeify.js')(Promise);
        _dereq_('./call_get.js')(Promise);
        _dereq_('./props.js')(Promise, PromiseArray, tryConvertToPromise, apiRejection);
        _dereq_('./race.js')(Promise, INTERNAL, tryConvertToPromise, apiRejection);
        _dereq_('./reduce.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL);
        _dereq_('./settle.js')(Promise, PromiseArray);
        _dereq_('./some.js')(Promise, PromiseArray, apiRejection);
        _dereq_('./promisify.js')(Promise, INTERNAL);
        _dereq_('./any.js')(Promise);
        _dereq_('./each.js')(Promise, INTERNAL);
        _dereq_('./timers.js')(Promise, INTERNAL);
        _dereq_('./filter.js')(Promise, INTERNAL);
        util.toFastProperties(Promise);
        util.toFastProperties(Promise.prototype);
        function fillTypes(value) {
          var p = new Promise(INTERNAL);
          p._fulfillmentHandler0 = value;
          p._rejectionHandler0 = value;
          p._progressHandler0 = value;
          p._promise0 = value;
          p._receiver0 = value;
          p._settledValue = value;
        }
        // Complete slack tracking, opt out of field-type tracking and           
        // stabilize map                                                         
        fillTypes({
          a: 1
        });
        fillTypes({
          b: 2
        });
        fillTypes({
          c: 3
        });
        fillTypes(1);
        fillTypes(function () {});
        fillTypes(undefined);
        fillTypes(false);
        fillTypes(new Promise(INTERNAL));
        CapturedTrace.setBounds(async.firstLineError, util.lastLineError);
        return Promise;
      };
    }, {
      "./any.js": 1,
      "./async.js": 2,
      "./bind.js": 3,
      "./call_get.js": 5,
      "./cancel.js": 6,
      "./captured_trace.js": 7,
      "./catch_filter.js": 8,
      "./context.js": 9,
      "./debuggability.js": 10,
      "./direct_resolve.js": 11,
      "./each.js": 12,
      "./errors.js": 13,
      "./filter.js": 15,
      "./finally.js": 16,
      "./generators.js": 17,
      "./join.js": 18,
      "./map.js": 19,
      "./method.js": 20,
      "./nodeify.js": 21,
      "./progress.js": 22,
      "./promise_array.js": 24,
      "./promise_resolver.js": 25,
      "./promisify.js": 26,
      "./props.js": 27,
      "./race.js": 29,
      "./reduce.js": 30,
      "./settle.js": 32,
      "./some.js": 33,
      "./synchronous_inspection.js": 34,
      "./thenables.js": 35,
      "./timers.js": 36,
      "./using.js": 37,
      "./util.js": 38
    }],
    24: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, INTERNAL, tryConvertToPromise, apiRejection) {
        var util = _dereq_("./util.js");
        var isArray = util.isArray;
        function toResolutionValue(val) {
          switch (val) {
            case -2:
              return [];
            case -3:
              return {};
          }
        }
        function PromiseArray(values) {
          var promise = this._promise = new Promise(INTERNAL);
          var parent;
          if (values instanceof Promise) {
            parent = values;
            promise._propagateFrom(parent, 1 | 4);
          }
          this._values = values;
          this._length = 0;
          this._totalResolved = 0;
          this._init(undefined, -2);
        }
        PromiseArray.prototype.length = function () {
          return this._length;
        };
        PromiseArray.prototype.promise = function () {
          return this._promise;
        };
        PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
          var values = tryConvertToPromise(this._values, this._promise);
          if (values instanceof Promise) {
            values = values._target();
            this._values = values;
            if (values._isFulfilled()) {
              values = values._value();
              if (!isArray(values)) {
                var err = new Promise.TypeError("expecting an array, a promise or a thenable\n\n    See http://goo.gl/s8MMhc\n");
                this.__hardReject__(err);
                return;
              }
            } else if (values._isPending()) {
              values._then(init, this._reject, undefined, this, resolveValueIfEmpty);
              return;
            } else {
              this._reject(values._reason());
              return;
            }
          } else if (!isArray(values)) {
            this._promise._reject(apiRejection("expecting an array, a promise or a thenable\n\n    See http://goo.gl/s8MMhc\n")._reason());
            return;
          }
          if (values.length === 0) {
            if (resolveValueIfEmpty === -5) {
              this._resolveEmptyArray();
            } else {
              this._resolve(toResolutionValue(resolveValueIfEmpty));
            }
            return;
          }
          var len = this.getActualLength(values.length);
          this._length = len;
          this._values = this.shouldCopyValues() ? new Array(len) : this._values;
          var promise = this._promise;
          for (var i = 0; i < len; ++i) {
            var isResolved = this._isResolved();
            var maybePromise = tryConvertToPromise(values[i], promise);
            if (maybePromise instanceof Promise) {
              maybePromise = maybePromise._target();
              if (isResolved) {
                maybePromise._ignoreRejections();
              } else if (maybePromise._isPending()) {
                maybePromise._proxyPromiseArray(this, i);
              } else if (maybePromise._isFulfilled()) {
                this._promiseFulfilled(maybePromise._value(), i);
              } else {
                this._promiseRejected(maybePromise._reason(), i);
              }
            } else if (!isResolved) {
              this._promiseFulfilled(maybePromise, i);
            }
          }
        };
        PromiseArray.prototype._isResolved = function () {
          return this._values === null;
        };
        PromiseArray.prototype._resolve = function (value) {
          this._values = null;
          this._promise._fulfill(value);
        };
        PromiseArray.prototype.__hardReject__ = PromiseArray.prototype._reject = function (reason) {
          this._values = null;
          this._promise._rejectCallback(reason, false, true);
        };
        PromiseArray.prototype._promiseProgressed = function (progressValue, index) {
          this._promise._progress({
            index: index,
            value: progressValue
          });
        };
        PromiseArray.prototype._promiseFulfilled = function (value, index) {
          this._values[index] = value;
          var totalResolved = ++this._totalResolved;
          if (totalResolved >= this._length) {
            this._resolve(this._values);
          }
        };
        PromiseArray.prototype._promiseRejected = function (reason, index) {
          this._totalResolved++;
          this._reject(reason);
        };
        PromiseArray.prototype.shouldCopyValues = function () {
          return true;
        };
        PromiseArray.prototype.getActualLength = function (len) {
          return len;
        };
        return PromiseArray;
      };
    }, {
      "./util.js": 38
    }],
    25: [function (_dereq_, module, exports) {
      "use strict";

      var util = _dereq_("./util.js");
      var maybeWrapAsError = util.maybeWrapAsError;
      var errors = _dereq_("./errors.js");
      var TimeoutError = errors.TimeoutError;
      var OperationalError = errors.OperationalError;
      var haveGetters = util.haveGetters;
      var es5 = _dereq_("./es5.js");
      function isUntypedError(obj) {
        return obj instanceof Error && es5.getPrototypeOf(obj) === Error.prototype;
      }
      var rErrorKey = /^(?:name|message|stack|cause)$/;
      function wrapAsOperationalError(obj) {
        var ret;
        if (isUntypedError(obj)) {
          ret = new OperationalError(obj);
          ret.name = obj.name;
          ret.message = obj.message;
          ret.stack = obj.stack;
          var keys = es5.keys(obj);
          for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!rErrorKey.test(key)) {
              ret[key] = obj[key];
            }
          }
          return ret;
        }
        util.markAsOriginatingFromRejection(obj);
        return obj;
      }
      function nodebackForPromise(promise) {
        return function (err, value) {
          if (promise === null) return;
          if (err) {
            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
            promise._attachExtraTrace(wrapped);
            promise._reject(wrapped);
          } else if (arguments.length > 2) {
            var $_len = arguments.length;
            var args = new Array($_len - 1);
            for (var $_i = 1; $_i < $_len; ++$_i) {
              args[$_i - 1] = arguments[$_i];
            }
            promise._fulfill(args);
          } else {
            promise._fulfill(value);
          }
          promise = null;
        };
      }
      var PromiseResolver;
      if (!haveGetters) {
        PromiseResolver = function PromiseResolver(promise) {
          this.promise = promise;
          this.asCallback = nodebackForPromise(promise);
          this.callback = this.asCallback;
        };
      } else {
        PromiseResolver = function PromiseResolver(promise) {
          this.promise = promise;
        };
      }
      if (haveGetters) {
        var prop = {
          get: function get() {
            return nodebackForPromise(this.promise);
          }
        };
        es5.defineProperty(PromiseResolver.prototype, "asCallback", prop);
        es5.defineProperty(PromiseResolver.prototype, "callback", prop);
      }
      PromiseResolver._nodebackForPromise = nodebackForPromise;
      PromiseResolver.prototype.toString = function () {
        return "[object PromiseResolver]";
      };
      PromiseResolver.prototype.resolve = PromiseResolver.prototype.fulfill = function (value) {
        if (!(this instanceof PromiseResolver)) {
          throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\n\n    See http://goo.gl/sdkXL9\n");
        }
        this.promise._resolveCallback(value);
      };
      PromiseResolver.prototype.reject = function (reason) {
        if (!(this instanceof PromiseResolver)) {
          throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\n\n    See http://goo.gl/sdkXL9\n");
        }
        this.promise._rejectCallback(reason);
      };
      PromiseResolver.prototype.progress = function (value) {
        if (!(this instanceof PromiseResolver)) {
          throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\n\n    See http://goo.gl/sdkXL9\n");
        }
        this.promise._progress(value);
      };
      PromiseResolver.prototype.cancel = function (err) {
        this.promise.cancel(err);
      };
      PromiseResolver.prototype.timeout = function () {
        this.reject(new TimeoutError("timeout"));
      };
      PromiseResolver.prototype.isResolved = function () {
        return this.promise.isResolved();
      };
      PromiseResolver.prototype.toJSON = function () {
        return this.promise.toJSON();
      };
      module.exports = PromiseResolver;
    }, {
      "./errors.js": 13,
      "./es5.js": 14,
      "./util.js": 38
    }],
    26: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, INTERNAL) {
        var THIS = {};
        var util = _dereq_("./util.js");
        var nodebackForPromise = _dereq_("./promise_resolver.js")._nodebackForPromise;
        var withAppended = util.withAppended;
        var maybeWrapAsError = util.maybeWrapAsError;
        var canEvaluate = util.canEvaluate;
        var TypeError = _dereq_("./errors").TypeError;
        var defaultSuffix = "Async";
        var defaultPromisified = {
          __isPromisified__: true
        };
        var noCopyProps = ["arity", "length", "name", "arguments", "caller", "callee", "prototype", "__isPromisified__"];
        var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
        var defaultFilter = function defaultFilter(name) {
          return util.isIdentifier(name) && name.charAt(0) !== "_" && name !== "constructor";
        };
        function propsFilter(key) {
          return !noCopyPropsPattern.test(key);
        }
        function isPromisified(fn) {
          try {
            return fn.__isPromisified__ === true;
          } catch (e) {
            return false;
          }
        }
        function hasPromisified(obj, key, suffix) {
          var val = util.getDataPropertyOrDefault(obj, key + suffix, defaultPromisified);
          return val ? isPromisified(val) : false;
        }
        function checkValid(ret, suffix, suffixRegexp) {
          for (var i = 0; i < ret.length; i += 2) {
            var key = ret[i];
            if (suffixRegexp.test(key)) {
              var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
              for (var j = 0; j < ret.length; j += 2) {
                if (ret[j] === keyWithoutAsyncSuffix) {
                  throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See http://goo.gl/iWrZbw\n".replace("%s", suffix));
                }
              }
            }
          }
        }
        function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
          var keys = util.inheritedDataKeys(obj);
          var ret = [];
          for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            var value = obj[key];
            var passesDefaultFilter = filter === defaultFilter ? true : defaultFilter(key, value, obj);
            if (typeof value === "function" && !isPromisified(value) && !hasPromisified(obj, key, suffix) && filter(key, value, obj, passesDefaultFilter)) {
              ret.push(key, value);
            }
          }
          checkValid(ret, suffix, suffixRegexp);
          return ret;
        }
        var escapeIdentRegex = function escapeIdentRegex(str) {
          return str.replace(/([$])/, "\\$");
        };
        var makeNodePromisifiedEval;
        if (false) { var parameterCount, parameterDeclaration, argumentSequence, switchCaseArgumentOrder; }
        function makeNodePromisifiedClosure(callback, receiver, _, fn) {
          var defaultThis = function () {
            return this;
          }();
          var method = callback;
          if (typeof method === "string") {
            callback = fn;
          }
          function promisified() {
            var _receiver = receiver;
            if (receiver === THIS) _receiver = this;
            var promise = new Promise(INTERNAL);
            promise._captureStackTrace();
            var cb = typeof method === "string" && this !== defaultThis ? this[method] : callback;
            var fn = nodebackForPromise(promise);
            try {
              cb.apply(_receiver, withAppended(arguments, fn));
            } catch (e) {
              promise._rejectCallback(maybeWrapAsError(e), true, true);
            }
            return promise;
          }
          util.notEnumerableProp(promisified, "__isPromisified__", true);
          return promisified;
        }
        var makeNodePromisified = canEvaluate ? makeNodePromisifiedEval : makeNodePromisifiedClosure;
        function promisifyAll(obj, suffix, filter, promisifier) {
          var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
          var methods = promisifiableMethods(obj, suffix, suffixRegexp, filter);
          for (var i = 0, len = methods.length; i < len; i += 2) {
            var key = methods[i];
            var fn = methods[i + 1];
            var promisifiedKey = key + suffix;
            if (promisifier === makeNodePromisified) {
              obj[promisifiedKey] = makeNodePromisified(key, THIS, key, fn, suffix);
            } else {
              var promisified = promisifier(fn, function () {
                return makeNodePromisified(key, THIS, key, fn, suffix);
              });
              util.notEnumerableProp(promisified, "__isPromisified__", true);
              obj[promisifiedKey] = promisified;
            }
          }
          util.toFastProperties(obj);
          return obj;
        }
        function promisify(callback, receiver) {
          return makeNodePromisified(callback, receiver, undefined, callback);
        }
        Promise.promisify = function (fn, receiver) {
          if (typeof fn !== "function") {
            throw new TypeError("fn must be a function\n\n    See http://goo.gl/916lJJ\n");
          }
          if (isPromisified(fn)) {
            return fn;
          }
          var ret = promisify(fn, arguments.length < 2 ? THIS : receiver);
          util.copyDescriptors(fn, ret, propsFilter);
          return ret;
        };
        Promise.promisifyAll = function (target, options) {
          if (typeof target !== "function" && _typeof(target) !== "object") {
            throw new TypeError("the target of promisifyAll must be an object or a function\n\n    See http://goo.gl/9ITlV0\n");
          }
          options = Object(options);
          var suffix = options.suffix;
          if (typeof suffix !== "string") suffix = defaultSuffix;
          var filter = options.filter;
          if (typeof filter !== "function") filter = defaultFilter;
          var promisifier = options.promisifier;
          if (typeof promisifier !== "function") promisifier = makeNodePromisified;
          if (!util.isIdentifier(suffix)) {
            throw new RangeError("suffix must be a valid identifier\n\n    See http://goo.gl/8FZo5V\n");
          }
          var keys = util.inheritedDataKeys(target);
          for (var i = 0; i < keys.length; ++i) {
            var value = target[keys[i]];
            if (keys[i] !== "constructor" && util.isClass(value)) {
              promisifyAll(value.prototype, suffix, filter, promisifier);
              promisifyAll(value, suffix, filter, promisifier);
            }
          }
          return promisifyAll(target, suffix, filter, promisifier);
        };
      };
    }, {
      "./errors": 13,
      "./promise_resolver.js": 25,
      "./util.js": 38
    }],
    27: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, PromiseArray, tryConvertToPromise, apiRejection) {
        var util = _dereq_("./util.js");
        var isObject = util.isObject;
        var es5 = _dereq_("./es5.js");
        function PropertiesPromiseArray(obj) {
          var keys = es5.keys(obj);
          var len = keys.length;
          var values = new Array(len * 2);
          for (var i = 0; i < len; ++i) {
            var key = keys[i];
            values[i] = obj[key];
            values[i + len] = key;
          }
          this.constructor$(values);
        }
        util.inherits(PropertiesPromiseArray, PromiseArray);
        PropertiesPromiseArray.prototype._init = function () {
          this._init$(undefined, -3);
        };
        PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
          this._values[index] = value;
          var totalResolved = ++this._totalResolved;
          if (totalResolved >= this._length) {
            var val = {};
            var keyOffset = this.length();
            for (var i = 0, len = this.length(); i < len; ++i) {
              val[this._values[i + keyOffset]] = this._values[i];
            }
            this._resolve(val);
          }
        };
        PropertiesPromiseArray.prototype._promiseProgressed = function (value, index) {
          this._promise._progress({
            key: this._values[index + this.length()],
            value: value
          });
        };
        PropertiesPromiseArray.prototype.shouldCopyValues = function () {
          return false;
        };
        PropertiesPromiseArray.prototype.getActualLength = function (len) {
          return len >> 1;
        };
        function props(promises) {
          var ret;
          var castValue = tryConvertToPromise(promises);
          if (!isObject(castValue)) {
            return apiRejection("cannot await properties of a non-object\n\n    See http://goo.gl/OsFKC8\n");
          } else if (castValue instanceof Promise) {
            ret = castValue._then(Promise.props, undefined, undefined, undefined, undefined);
          } else {
            ret = new PropertiesPromiseArray(castValue).promise();
          }
          if (castValue instanceof Promise) {
            ret._propagateFrom(castValue, 4);
          }
          return ret;
        }
        Promise.prototype.props = function () {
          return props(this);
        };
        Promise.props = function (promises) {
          return props(promises);
        };
      };
    }, {
      "./es5.js": 14,
      "./util.js": 38
    }],
    28: [function (_dereq_, module, exports) {
      "use strict";

      function arrayMove(src, srcIndex, dst, dstIndex, len) {
        for (var j = 0; j < len; ++j) {
          dst[j + dstIndex] = src[j + srcIndex];
          src[j + srcIndex] = void 0;
        }
      }
      function Queue(capacity) {
        this._capacity = capacity;
        this._length = 0;
        this._front = 0;
      }
      Queue.prototype._willBeOverCapacity = function (size) {
        return this._capacity < size;
      };
      Queue.prototype._pushOne = function (arg) {
        var length = this.length();
        this._checkCapacity(length + 1);
        var i = this._front + length & this._capacity - 1;
        this[i] = arg;
        this._length = length + 1;
      };
      Queue.prototype._unshiftOne = function (value) {
        var capacity = this._capacity;
        this._checkCapacity(this.length() + 1);
        var front = this._front;
        var i = (front - 1 & capacity - 1 ^ capacity) - capacity;
        this[i] = value;
        this._front = i;
        this._length = this.length() + 1;
      };
      Queue.prototype.unshift = function (fn, receiver, arg) {
        this._unshiftOne(arg);
        this._unshiftOne(receiver);
        this._unshiftOne(fn);
      };
      Queue.prototype.push = function (fn, receiver, arg) {
        var length = this.length() + 3;
        if (this._willBeOverCapacity(length)) {
          this._pushOne(fn);
          this._pushOne(receiver);
          this._pushOne(arg);
          return;
        }
        var j = this._front + length - 3;
        this._checkCapacity(length);
        var wrapMask = this._capacity - 1;
        this[j + 0 & wrapMask] = fn;
        this[j + 1 & wrapMask] = receiver;
        this[j + 2 & wrapMask] = arg;
        this._length = length;
      };
      Queue.prototype.shift = function () {
        var front = this._front,
          ret = this[front];
        this[front] = undefined;
        this._front = front + 1 & this._capacity - 1;
        this._length--;
        return ret;
      };
      Queue.prototype.length = function () {
        return this._length;
      };
      Queue.prototype._checkCapacity = function (size) {
        if (this._capacity < size) {
          this._resizeTo(this._capacity << 1);
        }
      };
      Queue.prototype._resizeTo = function (capacity) {
        var oldCapacity = this._capacity;
        this._capacity = capacity;
        var front = this._front;
        var length = this._length;
        var moveItemsCount = front + length & oldCapacity - 1;
        arrayMove(this, 0, this, oldCapacity, moveItemsCount);
      };
      module.exports = Queue;
    }, {}],
    29: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, INTERNAL, tryConvertToPromise, apiRejection) {
        var isArray = _dereq_("./util.js").isArray;
        var raceLater = function raceLater(promise) {
          return promise.then(function (array) {
            return race(array, promise);
          });
        };
        function race(promises, parent) {
          var maybePromise = tryConvertToPromise(promises);
          if (maybePromise instanceof Promise) {
            return raceLater(maybePromise);
          } else if (!isArray(promises)) {
            return apiRejection("expecting an array, a promise or a thenable\n\n    See http://goo.gl/s8MMhc\n");
          }
          var ret = new Promise(INTERNAL);
          if (parent !== undefined) {
            ret._propagateFrom(parent, 4 | 1);
          }
          var fulfill = ret._fulfill;
          var reject = ret._reject;
          for (var i = 0, len = promises.length; i < len; ++i) {
            var val = promises[i];
            if (val === undefined && !(i in promises)) {
              continue;
            }
            Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
          }
          return ret;
        }
        Promise.race = function (promises) {
          return race(promises, undefined);
        };
        Promise.prototype.race = function () {
          return race(this, undefined);
        };
      };
    }, {
      "./util.js": 38
    }],
    30: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL) {
        var getDomain = Promise._getDomain;
        var async = _dereq_("./async.js");
        var util = _dereq_("./util.js");
        var tryCatch = util.tryCatch;
        var errorObj = util.errorObj;
        function ReductionPromiseArray(promises, fn, accum, _each) {
          this.constructor$(promises);
          this._promise._captureStackTrace();
          this._preservedValues = _each === INTERNAL ? [] : null;
          this._zerothIsAccum = accum === undefined;
          this._gotAccum = false;
          this._reducingIndex = this._zerothIsAccum ? 1 : 0;
          this._valuesPhase = undefined;
          var maybePromise = tryConvertToPromise(accum, this._promise);
          var rejected = false;
          var isPromise = maybePromise instanceof Promise;
          if (isPromise) {
            maybePromise = maybePromise._target();
            if (maybePromise._isPending()) {
              maybePromise._proxyPromiseArray(this, -1);
            } else if (maybePromise._isFulfilled()) {
              accum = maybePromise._value();
              this._gotAccum = true;
            } else {
              this._reject(maybePromise._reason());
              rejected = true;
            }
          }
          if (!(isPromise || this._zerothIsAccum)) this._gotAccum = true;
          var domain = getDomain();
          this._callback = domain === null ? fn : domain.bind(fn);
          this._accum = accum;
          if (!rejected) async.invoke(init, this, undefined);
        }
        function init() {
          this._init$(undefined, -5);
        }
        util.inherits(ReductionPromiseArray, PromiseArray);
        ReductionPromiseArray.prototype._init = function () {};
        ReductionPromiseArray.prototype._resolveEmptyArray = function () {
          if (this._gotAccum || this._zerothIsAccum) {
            this._resolve(this._preservedValues !== null ? [] : this._accum);
          }
        };
        ReductionPromiseArray.prototype._promiseFulfilled = function (value, index) {
          var values = this._values;
          values[index] = value;
          var length = this.length();
          var preservedValues = this._preservedValues;
          var isEach = preservedValues !== null;
          var gotAccum = this._gotAccum;
          var valuesPhase = this._valuesPhase;
          var valuesPhaseIndex;
          if (!valuesPhase) {
            valuesPhase = this._valuesPhase = new Array(length);
            for (valuesPhaseIndex = 0; valuesPhaseIndex < length; ++valuesPhaseIndex) {
              valuesPhase[valuesPhaseIndex] = 0;
            }
          }
          valuesPhaseIndex = valuesPhase[index];
          if (index === 0 && this._zerothIsAccum) {
            this._accum = value;
            this._gotAccum = gotAccum = true;
            valuesPhase[index] = valuesPhaseIndex === 0 ? 1 : 2;
          } else if (index === -1) {
            this._accum = value;
            this._gotAccum = gotAccum = true;
          } else {
            if (valuesPhaseIndex === 0) {
              valuesPhase[index] = 1;
            } else {
              valuesPhase[index] = 2;
              this._accum = value;
            }
          }
          if (!gotAccum) return;
          var callback = this._callback;
          var receiver = this._promise._boundValue();
          var ret;
          for (var i = this._reducingIndex; i < length; ++i) {
            valuesPhaseIndex = valuesPhase[i];
            if (valuesPhaseIndex === 2) {
              this._reducingIndex = i + 1;
              continue;
            }
            if (valuesPhaseIndex !== 1) return;
            value = values[i];
            this._promise._pushContext();
            if (isEach) {
              preservedValues.push(value);
              ret = tryCatch(callback).call(receiver, value, i, length);
            } else {
              ret = tryCatch(callback).call(receiver, this._accum, value, i, length);
            }
            this._promise._popContext();
            if (ret === errorObj) return this._reject(ret.e);
            var maybePromise = tryConvertToPromise(ret, this._promise);
            if (maybePromise instanceof Promise) {
              maybePromise = maybePromise._target();
              if (maybePromise._isPending()) {
                valuesPhase[i] = 4;
                return maybePromise._proxyPromiseArray(this, i);
              } else if (maybePromise._isFulfilled()) {
                ret = maybePromise._value();
              } else {
                return this._reject(maybePromise._reason());
              }
            }
            this._reducingIndex = i + 1;
            this._accum = ret;
          }
          this._resolve(isEach ? preservedValues : this._accum);
        };
        function reduce(promises, fn, initialValue, _each) {
          if (typeof fn !== "function") return apiRejection("fn must be a function\n\n    See http://goo.gl/916lJJ\n");
          var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
          return array.promise();
        }
        Promise.prototype.reduce = function (fn, initialValue) {
          return reduce(this, fn, initialValue, null);
        };
        Promise.reduce = function (promises, fn, initialValue, _each) {
          return reduce(promises, fn, initialValue, _each);
        };
      };
    }, {
      "./async.js": 2,
      "./util.js": 38
    }],
    31: [function (_dereq_, module, exports) {
      "use strict";

      var schedule;
      var util = _dereq_("./util");
      var noAsyncScheduler = function noAsyncScheduler() {
        throw new Error("No async scheduler available\n\n    See http://goo.gl/m3OTXk\n");
      };
      if (util.isNode && typeof MutationObserver === "undefined") {
        var GlobalSetImmediate = __webpack_require__.g.setImmediate;
        var ProcessNextTick = process.nextTick;
        schedule = util.isRecentNode ? function (fn) {
          GlobalSetImmediate.call(__webpack_require__.g, fn);
        } : function (fn) {
          ProcessNextTick.call(process, fn);
        };
      } else if (typeof MutationObserver !== "undefined" && !(typeof window !== "undefined" && window.navigator && window.navigator.standalone)) {
        schedule = function schedule(fn) {
          var div = document.createElement("div");
          var observer = new MutationObserver(fn);
          observer.observe(div, {
            attributes: true
          });
          return function () {
            div.classList.toggle("foo");
          };
        };
        schedule.isStatic = true;
      } else if (typeof setImmediate !== "undefined") {
        schedule = function schedule(fn) {
          setImmediate(fn);
        };
      } else if (typeof setTimeout !== "undefined") {
        schedule = function schedule(fn) {
          setTimeout(fn, 0);
        };
      } else {
        schedule = noAsyncScheduler;
      }
      module.exports = schedule;
    }, {
      "./util": 38
    }],
    32: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, PromiseArray) {
        var PromiseInspection = Promise.PromiseInspection;
        var util = _dereq_("./util.js");
        function SettledPromiseArray(values) {
          this.constructor$(values);
        }
        util.inherits(SettledPromiseArray, PromiseArray);
        SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
          this._values[index] = inspection;
          var totalResolved = ++this._totalResolved;
          if (totalResolved >= this._length) {
            this._resolve(this._values);
          }
        };
        SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
          var ret = new PromiseInspection();
          ret._bitField = 268435456;
          ret._settledValue = value;
          this._promiseResolved(index, ret);
        };
        SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
          var ret = new PromiseInspection();
          ret._bitField = 134217728;
          ret._settledValue = reason;
          this._promiseResolved(index, ret);
        };
        Promise.settle = function (promises) {
          return new SettledPromiseArray(promises).promise();
        };
        Promise.prototype.settle = function () {
          return new SettledPromiseArray(this).promise();
        };
      };
    }, {
      "./util.js": 38
    }],
    33: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, PromiseArray, apiRejection) {
        var util = _dereq_("./util.js");
        var RangeError = _dereq_("./errors.js").RangeError;
        var AggregateError = _dereq_("./errors.js").AggregateError;
        var isArray = util.isArray;
        function SomePromiseArray(values) {
          this.constructor$(values);
          this._howMany = 0;
          this._unwrap = false;
          this._initialized = false;
        }
        util.inherits(SomePromiseArray, PromiseArray);
        SomePromiseArray.prototype._init = function () {
          if (!this._initialized) {
            return;
          }
          if (this._howMany === 0) {
            this._resolve([]);
            return;
          }
          this._init$(undefined, -5);
          var isArrayResolved = isArray(this._values);
          if (!this._isResolved() && isArrayResolved && this._howMany > this._canPossiblyFulfill()) {
            this._reject(this._getRangeError(this.length()));
          }
        };
        SomePromiseArray.prototype.init = function () {
          this._initialized = true;
          this._init();
        };
        SomePromiseArray.prototype.setUnwrap = function () {
          this._unwrap = true;
        };
        SomePromiseArray.prototype.howMany = function () {
          return this._howMany;
        };
        SomePromiseArray.prototype.setHowMany = function (count) {
          this._howMany = count;
        };
        SomePromiseArray.prototype._promiseFulfilled = function (value) {
          this._addFulfilled(value);
          if (this._fulfilled() === this.howMany()) {
            this._values.length = this.howMany();
            if (this.howMany() === 1 && this._unwrap) {
              this._resolve(this._values[0]);
            } else {
              this._resolve(this._values);
            }
          }
        };
        SomePromiseArray.prototype._promiseRejected = function (reason) {
          this._addRejected(reason);
          if (this.howMany() > this._canPossiblyFulfill()) {
            var e = new AggregateError();
            for (var i = this.length(); i < this._values.length; ++i) {
              e.push(this._values[i]);
            }
            this._reject(e);
          }
        };
        SomePromiseArray.prototype._fulfilled = function () {
          return this._totalResolved;
        };
        SomePromiseArray.prototype._rejected = function () {
          return this._values.length - this.length();
        };
        SomePromiseArray.prototype._addRejected = function (reason) {
          this._values.push(reason);
        };
        SomePromiseArray.prototype._addFulfilled = function (value) {
          this._values[this._totalResolved++] = value;
        };
        SomePromiseArray.prototype._canPossiblyFulfill = function () {
          return this.length() - this._rejected();
        };
        SomePromiseArray.prototype._getRangeError = function (count) {
          var message = "Input array must contain at least " + this._howMany + " items but contains only " + count + " items";
          return new RangeError(message);
        };
        SomePromiseArray.prototype._resolveEmptyArray = function () {
          this._reject(this._getRangeError(0));
        };
        function some(promises, howMany) {
          if ((howMany | 0) !== howMany || howMany < 0) {
            return apiRejection("expecting a positive integer\n\n    See http://goo.gl/1wAmHx\n");
          }
          var ret = new SomePromiseArray(promises);
          var promise = ret.promise();
          ret.setHowMany(howMany);
          ret.init();
          return promise;
        }
        Promise.some = function (promises, howMany) {
          return some(promises, howMany);
        };
        Promise.prototype.some = function (howMany) {
          return some(this, howMany);
        };
        Promise._SomePromiseArray = SomePromiseArray;
      };
    }, {
      "./errors.js": 13,
      "./util.js": 38
    }],
    34: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise) {
        function PromiseInspection(promise) {
          if (promise !== undefined) {
            promise = promise._target();
            this._bitField = promise._bitField;
            this._settledValue = promise._settledValue;
          } else {
            this._bitField = 0;
            this._settledValue = undefined;
          }
        }
        PromiseInspection.prototype.value = function () {
          if (!this.isFulfilled()) {
            throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/hc1DLj\n");
          }
          return this._settledValue;
        };
        PromiseInspection.prototype.error = PromiseInspection.prototype.reason = function () {
          if (!this.isRejected()) {
            throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/hPuiwB\n");
          }
          return this._settledValue;
        };
        PromiseInspection.prototype.isFulfilled = Promise.prototype._isFulfilled = function () {
          return (this._bitField & 268435456) > 0;
        };
        PromiseInspection.prototype.isRejected = Promise.prototype._isRejected = function () {
          return (this._bitField & 134217728) > 0;
        };
        PromiseInspection.prototype.isPending = Promise.prototype._isPending = function () {
          return (this._bitField & 402653184) === 0;
        };
        PromiseInspection.prototype.isResolved = Promise.prototype._isResolved = function () {
          return (this._bitField & 402653184) > 0;
        };
        Promise.prototype.isPending = function () {
          return this._target()._isPending();
        };
        Promise.prototype.isRejected = function () {
          return this._target()._isRejected();
        };
        Promise.prototype.isFulfilled = function () {
          return this._target()._isFulfilled();
        };
        Promise.prototype.isResolved = function () {
          return this._target()._isResolved();
        };
        Promise.prototype._value = function () {
          return this._settledValue;
        };
        Promise.prototype._reason = function () {
          this._unsetRejectionIsUnhandled();
          return this._settledValue;
        };
        Promise.prototype.value = function () {
          var target = this._target();
          if (!target.isFulfilled()) {
            throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/hc1DLj\n");
          }
          return target._settledValue;
        };
        Promise.prototype.reason = function () {
          var target = this._target();
          if (!target.isRejected()) {
            throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/hPuiwB\n");
          }
          target._unsetRejectionIsUnhandled();
          return target._settledValue;
        };
        Promise.PromiseInspection = PromiseInspection;
      };
    }, {}],
    35: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, INTERNAL) {
        var util = _dereq_("./util.js");
        var errorObj = util.errorObj;
        var isObject = util.isObject;
        function tryConvertToPromise(obj, context) {
          if (isObject(obj)) {
            if (obj instanceof Promise) {
              return obj;
            } else if (isAnyBluebirdPromise(obj)) {
              var ret = new Promise(INTERNAL);
              obj._then(ret._fulfillUnchecked, ret._rejectUncheckedCheckError, ret._progressUnchecked, ret, null);
              return ret;
            }
            var then = util.tryCatch(getThen)(obj);
            if (then === errorObj) {
              if (context) context._pushContext();
              var ret = Promise.reject(then.e);
              if (context) context._popContext();
              return ret;
            } else if (typeof then === "function") {
              return doThenable(obj, then, context);
            }
          }
          return obj;
        }
        function getThen(obj) {
          return obj.then;
        }
        var hasProp = {}.hasOwnProperty;
        function isAnyBluebirdPromise(obj) {
          return hasProp.call(obj, "_promise0");
        }
        function doThenable(x, then, context) {
          var promise = new Promise(INTERNAL);
          var ret = promise;
          if (context) context._pushContext();
          promise._captureStackTrace();
          if (context) context._popContext();
          var synchronous = true;
          var result = util.tryCatch(then).call(x, resolveFromThenable, rejectFromThenable, progressFromThenable);
          synchronous = false;
          if (promise && result === errorObj) {
            promise._rejectCallback(result.e, true, true);
            promise = null;
          }
          function resolveFromThenable(value) {
            if (!promise) return;
            promise._resolveCallback(value);
            promise = null;
          }
          function rejectFromThenable(reason) {
            if (!promise) return;
            promise._rejectCallback(reason, synchronous, true);
            promise = null;
          }
          function progressFromThenable(value) {
            if (!promise) return;
            if (typeof promise._progress === "function") {
              promise._progress(value);
            }
          }
          return ret;
        }
        return tryConvertToPromise;
      };
    }, {
      "./util.js": 38
    }],
    36: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, INTERNAL) {
        var util = _dereq_("./util.js");
        var TimeoutError = Promise.TimeoutError;
        var afterTimeout = function afterTimeout(promise, message) {
          if (!promise.isPending()) return;
          var err;
          if (!util.isPrimitive(message) && message instanceof Error) {
            err = message;
          } else {
            if (typeof message !== "string") {
              message = "operation timed out";
            }
            err = new TimeoutError(message);
          }
          util.markAsOriginatingFromRejection(err);
          promise._attachExtraTrace(err);
          promise._cancel(err);
        };
        var afterValue = function afterValue(value) {
          return delay(+this).thenReturn(value);
        };
        var delay = Promise.delay = function (value, ms) {
          if (ms === undefined) {
            ms = value;
            value = undefined;
            var ret = new Promise(INTERNAL);
            setTimeout(function () {
              ret._fulfill();
            }, ms);
            return ret;
          }
          ms = +ms;
          return Promise.resolve(value)._then(afterValue, null, null, ms, undefined);
        };
        Promise.prototype.delay = function (ms) {
          return delay(this, ms);
        };
        function successClear(value) {
          var handle = this;
          if (handle instanceof Number) handle = +handle;
          clearTimeout(handle);
          return value;
        }
        function failureClear(reason) {
          var handle = this;
          if (handle instanceof Number) handle = +handle;
          clearTimeout(handle);
          throw reason;
        }
        Promise.prototype.timeout = function (ms, message) {
          ms = +ms;
          var ret = this.then().cancellable();
          ret._cancellationParent = this;
          var handle = setTimeout(function timeoutTimeout() {
            afterTimeout(ret, message);
          }, ms);
          return ret._then(successClear, failureClear, undefined, handle, undefined);
        };
      };
    }, {
      "./util.js": 38
    }],
    37: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, apiRejection, tryConvertToPromise, createContext) {
        var TypeError = _dereq_("./errors.js").TypeError;
        var inherits = _dereq_("./util.js").inherits;
        var PromiseInspection = Promise.PromiseInspection;
        function inspectionMapper(inspections) {
          var len = inspections.length;
          for (var i = 0; i < len; ++i) {
            var inspection = inspections[i];
            if (inspection.isRejected()) {
              return Promise.reject(inspection.error());
            }
            inspections[i] = inspection._settledValue;
          }
          return inspections;
        }
        function thrower(e) {
          setTimeout(function () {
            throw e;
          }, 0);
        }
        function castPreservingDisposable(thenable) {
          var maybePromise = tryConvertToPromise(thenable);
          if (maybePromise !== thenable && typeof thenable._isDisposable === "function" && typeof thenable._getDisposer === "function" && thenable._isDisposable()) {
            maybePromise._setDisposable(thenable._getDisposer());
          }
          return maybePromise;
        }
        function dispose(resources, inspection) {
          var i = 0;
          var len = resources.length;
          var ret = Promise.defer();
          function iterator() {
            if (i >= len) return ret.resolve();
            var maybePromise = castPreservingDisposable(resources[i++]);
            if (maybePromise instanceof Promise && maybePromise._isDisposable()) {
              try {
                maybePromise = tryConvertToPromise(maybePromise._getDisposer().tryDispose(inspection), resources.promise);
              } catch (e) {
                return thrower(e);
              }
              if (maybePromise instanceof Promise) {
                return maybePromise._then(iterator, thrower, null, null, null);
              }
            }
            iterator();
          }
          iterator();
          return ret.promise;
        }
        function disposerSuccess(value) {
          var inspection = new PromiseInspection();
          inspection._settledValue = value;
          inspection._bitField = 268435456;
          return dispose(this, inspection).thenReturn(value);
        }
        function disposerFail(reason) {
          var inspection = new PromiseInspection();
          inspection._settledValue = reason;
          inspection._bitField = 134217728;
          return dispose(this, inspection).thenThrow(reason);
        }
        function Disposer(data, promise, context) {
          this._data = data;
          this._promise = promise;
          this._context = context;
        }
        Disposer.prototype.data = function () {
          return this._data;
        };
        Disposer.prototype.promise = function () {
          return this._promise;
        };
        Disposer.prototype.resource = function () {
          if (this.promise().isFulfilled()) {
            return this.promise().value();
          }
          return null;
        };
        Disposer.prototype.tryDispose = function (inspection) {
          var resource = this.resource();
          var context = this._context;
          if (context !== undefined) context._pushContext();
          var ret = resource !== null ? this.doDispose(resource, inspection) : null;
          if (context !== undefined) context._popContext();
          this._promise._unsetDisposable();
          this._data = null;
          return ret;
        };
        Disposer.isDisposer = function (d) {
          return d != null && typeof d.resource === "function" && typeof d.tryDispose === "function";
        };
        function FunctionDisposer(fn, promise, context) {
          this.constructor$(fn, promise, context);
        }
        inherits(FunctionDisposer, Disposer);
        FunctionDisposer.prototype.doDispose = function (resource, inspection) {
          var fn = this.data();
          return fn.call(resource, resource, inspection);
        };
        function maybeUnwrapDisposer(value) {
          if (Disposer.isDisposer(value)) {
            this.resources[this.index]._setDisposable(value);
            return value.promise();
          }
          return value;
        }
        Promise.using = function () {
          var len = arguments.length;
          if (len < 2) return apiRejection("you must pass at least 2 arguments to Promise.using");
          var fn = arguments[len - 1];
          if (typeof fn !== "function") return apiRejection("fn must be a function\n\n    See http://goo.gl/916lJJ\n");
          var input;
          var spreadArgs = true;
          if (len === 2 && Array.isArray(arguments[0])) {
            input = arguments[0];
            len = input.length;
            spreadArgs = false;
          } else {
            input = arguments;
            len--;
          }
          var resources = new Array(len);
          for (var i = 0; i < len; ++i) {
            var resource = input[i];
            if (Disposer.isDisposer(resource)) {
              var disposer = resource;
              resource = resource.promise();
              resource._setDisposable(disposer);
            } else {
              var maybePromise = tryConvertToPromise(resource);
              if (maybePromise instanceof Promise) {
                resource = maybePromise._then(maybeUnwrapDisposer, null, null, {
                  resources: resources,
                  index: i
                }, undefined);
              }
            }
            resources[i] = resource;
          }
          var promise = Promise.settle(resources).then(inspectionMapper).then(function (vals) {
            promise._pushContext();
            var ret;
            try {
              ret = spreadArgs ? fn.apply(undefined, vals) : fn.call(undefined, vals);
            } finally {
              promise._popContext();
            }
            return ret;
          })._then(disposerSuccess, disposerFail, undefined, resources, undefined);
          resources.promise = promise;
          return promise;
        };
        Promise.prototype._setDisposable = function (disposer) {
          this._bitField = this._bitField | 262144;
          this._disposer = disposer;
        };
        Promise.prototype._isDisposable = function () {
          return (this._bitField & 262144) > 0;
        };
        Promise.prototype._getDisposer = function () {
          return this._disposer;
        };
        Promise.prototype._unsetDisposable = function () {
          this._bitField = this._bitField & ~262144;
          this._disposer = undefined;
        };
        Promise.prototype.disposer = function (fn) {
          if (typeof fn === "function") {
            return new FunctionDisposer(fn, this, createContext());
          }
          throw new TypeError();
        };
      };
    }, {
      "./errors.js": 13,
      "./util.js": 38
    }],
    38: [function (_dereq_, module, exports) {
      "use strict";

      var es5 = _dereq_("./es5.js");
      var canEvaluate = typeof navigator == "undefined";
      var haveGetters = function () {
        try {
          var o = {};
          es5.defineProperty(o, "f", {
            get: function get() {
              return 3;
            }
          });
          return o.f === 3;
        } catch (e) {
          return false;
        }
      }();
      var errorObj = {
        e: {}
      };
      var tryCatchTarget;
      function tryCatcher() {
        try {
          var target = tryCatchTarget;
          tryCatchTarget = null;
          return target.apply(this, arguments);
        } catch (e) {
          errorObj.e = e;
          return errorObj;
        }
      }
      function tryCatch(fn) {
        tryCatchTarget = fn;
        return tryCatcher;
      }
      var inherits = function inherits(Child, Parent) {
        var hasProp = {}.hasOwnProperty;
        function T() {
          this.constructor = Child;
          this.constructor$ = Parent;
          for (var propertyName in Parent.prototype) {
            if (hasProp.call(Parent.prototype, propertyName) && propertyName.charAt(propertyName.length - 1) !== "$") {
              this[propertyName + "$"] = Parent.prototype[propertyName];
            }
          }
        }
        T.prototype = Parent.prototype;
        Child.prototype = new T();
        return Child.prototype;
      };
      function isPrimitive(val) {
        return val == null || val === true || val === false || typeof val === "string" || typeof val === "number";
      }
      function isObject(value) {
        return !isPrimitive(value);
      }
      function maybeWrapAsError(maybeError) {
        if (!isPrimitive(maybeError)) return maybeError;
        return new Error(safeToString(maybeError));
      }
      function withAppended(target, appendee) {
        var len = target.length;
        var ret = new Array(len + 1);
        var i;
        for (i = 0; i < len; ++i) {
          ret[i] = target[i];
        }
        ret[i] = appendee;
        return ret;
      }
      function getDataPropertyOrDefault(obj, key, defaultValue) {
        if (es5.isES5) {
          var desc = Object.getOwnPropertyDescriptor(obj, key);
          if (desc != null) {
            return desc.get == null && desc.set == null ? desc.value : defaultValue;
          }
        } else {
          return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
        }
      }
      function notEnumerableProp(obj, name, value) {
        if (isPrimitive(obj)) return obj;
        var descriptor = {
          value: value,
          configurable: true,
          enumerable: false,
          writable: true
        };
        es5.defineProperty(obj, name, descriptor);
        return obj;
      }
      function thrower(r) {
        throw r;
      }
      var inheritedDataKeys = function () {
        var excludedPrototypes = [Array.prototype, Object.prototype, Function.prototype];
        var isExcludedProto = function isExcludedProto(val) {
          for (var i = 0; i < excludedPrototypes.length; ++i) {
            if (excludedPrototypes[i] === val) {
              return true;
            }
          }
          return false;
        };
        if (es5.isES5) {
          var getKeys = Object.getOwnPropertyNames;
          return function (obj) {
            var ret = [];
            var visitedKeys = Object.create(null);
            while (obj != null && !isExcludedProto(obj)) {
              var keys;
              try {
                keys = getKeys(obj);
              } catch (e) {
                return ret;
              }
              for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (visitedKeys[key]) continue;
                visitedKeys[key] = true;
                var desc = Object.getOwnPropertyDescriptor(obj, key);
                if (desc != null && desc.get == null && desc.set == null) {
                  ret.push(key);
                }
              }
              obj = es5.getPrototypeOf(obj);
            }
            return ret;
          };
        } else {
          var hasProp = {}.hasOwnProperty;
          return function (obj) {
            if (isExcludedProto(obj)) return [];
            var ret = [];

            /*jshint forin:false */
            enumeration: for (var key in obj) {
              if (hasProp.call(obj, key)) {
                ret.push(key);
              } else {
                for (var i = 0; i < excludedPrototypes.length; ++i) {
                  if (hasProp.call(excludedPrototypes[i], key)) {
                    continue enumeration;
                  }
                }
                ret.push(key);
              }
            }
            return ret;
          };
        }
      }();
      var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
      function isClass(fn) {
        try {
          if (typeof fn === "function") {
            var keys = es5.names(fn.prototype);
            var hasMethods = es5.isES5 && keys.length > 1;
            var hasMethodsOtherThanConstructor = keys.length > 0 && !(keys.length === 1 && keys[0] === "constructor");
            var hasThisAssignmentAndStaticMethods = thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
            if (hasMethods || hasMethodsOtherThanConstructor || hasThisAssignmentAndStaticMethods) {
              return true;
            }
          }
          return false;
        } catch (e) {
          return false;
        }
      }
      function toFastProperties(obj) {
        /*jshint -W027,-W055,-W031*/
        function f() {}
        f.prototype = obj;
        var l = 8;
        while (l--) {
          new f();
        }
        return obj;
        eval(obj);
      }
      var rident = /^[a-z$_][a-z$_0-9]*$/i;
      function isIdentifier(str) {
        return rident.test(str);
      }
      function filledRange(count, prefix, suffix) {
        var ret = new Array(count);
        for (var i = 0; i < count; ++i) {
          ret[i] = prefix + i + suffix;
        }
        return ret;
      }
      function safeToString(obj) {
        try {
          return obj + "";
        } catch (e) {
          return "[no string representation]";
        }
      }
      function markAsOriginatingFromRejection(e) {
        try {
          notEnumerableProp(e, "isOperational", true);
        } catch (ignore) {}
      }
      function originatesFromRejection(e) {
        if (e == null) return false;
        return e instanceof Error["__BluebirdErrorTypes__"].OperationalError || e["isOperational"] === true;
      }
      function canAttachTrace(obj) {
        return obj instanceof Error && es5.propertyIsWritable(obj, "stack");
      }
      var ensureErrorObject = function () {
        if (!("stack" in new Error())) {
          return function (value) {
            if (canAttachTrace(value)) return value;
            try {
              throw new Error(safeToString(value));
            } catch (err) {
              return err;
            }
          };
        } else {
          return function (value) {
            if (canAttachTrace(value)) return value;
            return new Error(safeToString(value));
          };
        }
      }();
      function classString(obj) {
        return {}.toString.call(obj);
      }
      function copyDescriptors(from, to, filter) {
        var keys = es5.names(from);
        for (var i = 0; i < keys.length; ++i) {
          var key = keys[i];
          if (filter(key)) {
            try {
              es5.defineProperty(to, key, es5.getDescriptor(from, key));
            } catch (ignore) {}
          }
        }
      }
      var ret = {
        isClass: isClass,
        isIdentifier: isIdentifier,
        inheritedDataKeys: inheritedDataKeys,
        getDataPropertyOrDefault: getDataPropertyOrDefault,
        thrower: thrower,
        isArray: es5.isArray,
        haveGetters: haveGetters,
        notEnumerableProp: notEnumerableProp,
        isPrimitive: isPrimitive,
        isObject: isObject,
        canEvaluate: canEvaluate,
        errorObj: errorObj,
        tryCatch: tryCatch,
        inherits: inherits,
        withAppended: withAppended,
        maybeWrapAsError: maybeWrapAsError,
        toFastProperties: toFastProperties,
        filledRange: filledRange,
        toString: safeToString,
        canAttachTrace: canAttachTrace,
        ensureErrorObject: ensureErrorObject,
        originatesFromRejection: originatesFromRejection,
        markAsOriginatingFromRejection: markAsOriginatingFromRejection,
        classString: classString,
        copyDescriptors: copyDescriptors,
        hasDevTools: typeof chrome !== "undefined" && chrome && typeof chrome.loadTimes === "function",
        isNode: typeof process !== "undefined" && classString(process).toLowerCase() === "[object process]"
      };
      ret.isRecentNode = ret.isNode && function () {
        var version = process.versions.node.split(".").map(Number);
        return version[0] === 0 && version[1] > 10 || version[0] > 0;
      }();
      if (ret.isNode) ret.toFastProperties(process);
      try {
        throw new Error();
      } catch (e) {
        ret.lastLineError = e;
      }
      module.exports = ret;
    }, {
      "./es5.js": 14
    }]
  }, {}, [4])(4);
});
;
if (typeof window !== 'undefined' && window !== null) {
  window.P = window.Promise;
} else if (typeof self !== 'undefined' && self !== null) {
  self.P = self.Promise;
}

/***/ }),

/***/ 46714:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(41539);
__webpack_require__(47042);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(21249);
__webpack_require__(47941);
__webpack_require__(68309);
// --------------------
// co-use module
// current build based on co version 4.6.0
// --------------------

var P;
try {
  P = Promise;
} catch (err) {}
module.exports = coUse(P);

// wrapper for co
function coUse(Promise) {
  // jshint ignore:line
  var module = {};

  // --------------------
  // code from co starts
  // --------------------

  /**
   * slice() reference.
   */

  var slice = Array.prototype.slice;

  /**
   * Expose `co`.
   */

  module.exports = co['default'] = co.co = co;

  /**
   * Wrap the given generator `fn` into a
   * function that returns a promise.
   * This is a separate function so that
   * every `co()` call doesn't create a new,
   * unnecessary closure.
   *
   * @param {GeneratorFunction} fn
   * @return {Function}
   * @api public
   */

  co.wrap = function (fn) {
    createPromise.__generatorFunction__ = fn;
    return createPromise;
    function createPromise() {
      return co.call(this, fn.apply(this, arguments));
    }
  };

  /**
   * Execute the generator function or a generator
   * and return a promise.
   *
   * @param {Function} fn
   * @return {Promise}
   * @api public
   */

  function co(gen) {
    var ctx = this;
    var args = slice.call(arguments, 1);

    // we wrap everything in a promise to avoid promise chaining,
    // which leads to memory leak errors.
    // see https://github.com/tj/co/issues/180
    return new Promise(function (resolve, reject) {
      if (typeof gen === 'function') gen = gen.apply(ctx, args);
      if (!gen || typeof gen.next !== 'function') return resolve(gen);
      onFulfilled();

      /**
       * @param {Mixed} res
       * @return {Promise}
       * @api private
       */

      function onFulfilled(res) {
        var ret;
        try {
          ret = gen.next(res);
        } catch (e) {
          return reject(e);
        }
        next(ret);
      }

      /**
       * @param {Error} err
       * @return {Promise}
       * @api private
       */

      function onRejected(err) {
        var ret;
        try {
          ret = gen.throw(err);
        } catch (e) {
          return reject(e);
        }
        next(ret);
      }

      /**
       * Get the next value in the generator,
       * return a promise.
       *
       * @param {Object} ret
       * @return {Promise}
       * @api private
       */

      function next(ret) {
        if (ret.done) return resolve(ret.value);
        var value = toPromise.call(ctx, ret.value);
        if (value && isPromise(value)) return value.then(onFulfilled, onRejected);
        return onRejected(new TypeError('You may only yield a function, promise, generator, array, or object, ' + 'but the following object was passed: "' + String(ret.value) + '"'));
      }
    });
  }

  /**
   * Convert a `yield`ed value into a promise.
   *
   * @param {Mixed} obj
   * @return {Promise}
   * @api private
   */

  function toPromise(obj) {
    if (!obj) return obj;
    if (isPromise(obj)) return obj;
    if (isGeneratorFunction(obj) || isGenerator(obj)) return co.call(this, obj);
    if ('function' == typeof obj) return thunkToPromise.call(this, obj);
    if (Array.isArray(obj)) return arrayToPromise.call(this, obj);
    if (isObject(obj)) return objectToPromise.call(this, obj);
    return obj;
  }

  /**
   * Convert a thunk to a promise.
   *
   * @param {Function}
   * @return {Promise}
   * @api private
   */

  function thunkToPromise(fn) {
    var ctx = this;
    return new Promise(function (resolve, reject) {
      fn.call(ctx, function (err, res) {
        if (err) return reject(err);
        if (arguments.length > 2) res = slice.call(arguments, 1);
        resolve(res);
      });
    });
  }

  /**
   * Convert an array of "yieldables" to a promise.
   * Uses `Promise.all()` internally.
   *
   * @param {Array} obj
   * @return {Promise}
   * @api private
   */

  function arrayToPromise(obj) {
    return Promise.all(obj.map(toPromise, this));
  }

  /**
   * Convert an object of "yieldables" to a promise.
   * Uses `Promise.all()` internally.
   *
   * @param {Object} obj
   * @return {Promise}
   * @api private
   */

  function objectToPromise(obj) {
    var results = new obj.constructor();
    var keys = Object.keys(obj);
    var promises = [];
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var promise = toPromise.call(this, obj[key]);
      if (promise && isPromise(promise)) defer(promise, key);else results[key] = obj[key];
    }
    return Promise.all(promises).then(function () {
      return results;
    });
    function defer(promise, key) {
      // predefine the key in the result
      results[key] = undefined;
      promises.push(promise.then(function (res) {
        results[key] = res;
      }));
    }
  }

  /**
   * Check if `obj` is a promise.
   *
   * @param {Object} obj
   * @return {Boolean}
   * @api private
   */

  function isPromise(obj) {
    return 'function' == typeof obj.then;
  }

  /**
   * Check if `obj` is a generator.
   *
   * @param {Mixed} obj
   * @return {Boolean}
   * @api private
   */

  function isGenerator(obj) {
    return 'function' == typeof obj.next && 'function' == typeof obj.throw;
  }

  /**
   * Check if `obj` is a generator function.
   *
   * @param {Mixed} obj
   * @return {Boolean}
   * @api private
   */
  function isGeneratorFunction(obj) {
    var constructor = obj.constructor;
    if (!constructor) return false;
    if ('GeneratorFunction' === constructor.name || 'GeneratorFunction' === constructor.displayName) return true;
    return isGenerator(constructor.prototype);
  }

  /**
   * Check for plain object.
   *
   * @param {Mixed} val
   * @return {Boolean}
   * @api private
   */

  function isObject(val) {
    return Object == val.constructor;
  }

  // --------------------
  // code from co ends
  // --------------------

  // add .use() method
  module.exports.use = coUse;

  // return co
  return module.exports;
}

/***/ }),

/***/ 26766:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(40561);
__webpack_require__(47042);
/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
}
;

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on = Emitter.prototype.addEventListener = function (event, fn) {
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function (event, fn) {
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }
  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function (event, fn) {
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }

  // Remove event specific arrays for event types that no
  // one is subscribed for to avoid memory leak.
  if (callbacks.length === 0) {
    delete this._callbacks['$' + event];
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function (event) {
  this._callbacks = this._callbacks || {};
  var args = new Array(arguments.length - 1),
    callbacks = this._callbacks['$' + event];
  for (var i = 1; i < arguments.length; i++) {
    args[i - 1] = arguments[i];
  }
  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }
  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function (event) {
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function (event) {
  return !!this.listeners(event).length;
};

/***/ }),

/***/ 6426:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(74916);
__webpack_require__(15306);
// This code has been refactored for 140 bytes
// You can see the original here: https://github.com/twolfson/computedStyle/blob/04cd1da2e30fa45844f95f5cb1ac898e9b9ef050/lib/computedStyle.js
var computedStyle = function computedStyle(el, prop, getComputedStyle) {
  getComputedStyle = window.getComputedStyle;

  // In one fell swoop
  return (
  // If we have getComputedStyle
  getComputedStyle ?
  // Query it
  // TODO: From CSS-Query notes, we might need (node, null) for FF
  getComputedStyle(el) :
  // Otherwise, we are in IE and use currentStyle
  el.currentStyle)[
  // Switch to camelCase for CSSOM
  // DEV: Grabbed from jQuery
  // https://github.com/jquery/jquery/blob/1.9-stable/src/css.js#L191-L194
  // https://github.com/jquery/jquery/blob/1.9-stable/src/core.js#L593-L597
  prop.replace(/-(\w)/gi, function (word, letter) {
    return letter.toUpperCase();
  })];
};
module.exports = computedStyle;

/***/ }),

/***/ 28652:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _locale_en_US_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37758);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_locale_en_US_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 11921:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": () => (/* binding */ getDefaultOptions)
/* harmony export */ });
/* unused harmony export setDefaultOptions */
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}

/***/ }),

/***/ 29438:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4723);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_2__);



var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (longFormatters);

/***/ }),

/***/ 49895:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ getTimezoneOffsetInMilliseconds)
/* harmony export */ });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/***/ }),

/***/ 45987:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ getUTCISOWeek)
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(8217);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
var startOfUTCISOWeek = __webpack_require__(45996);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
var getUTCISOWeekYear = __webpack_require__(15070);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(42362);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js



function startOfUTCISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var year = (0,getUTCISOWeekYear/* default */.Z)(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = (0,startOfUTCISOWeek/* default */.Z)(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var diff = (0,startOfUTCISOWeek/* default */.Z)(date).getTime() - startOfUTCISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ 15070:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ getUTCISOWeekYear)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);
/* harmony import */ var _startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45996);



function getUTCISOWeekYear(dirtyDate) {
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0,_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0,_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),

/***/ 45796:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ getUTCWeek)
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(8217);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
var startOfUTCWeek = __webpack_require__(80941);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(16511);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(42362);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(77617);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(11921);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js





function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = (0,getUTCWeekYear/* default */.Z)(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = (0,startOfUTCWeek/* default */.Z)(firstWeek, options);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var diff = (0,startOfUTCWeek/* default */.Z)(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ 16511:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ getUTCWeekYear)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);
/* harmony import */ var _startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80941);
/* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77617);
/* harmony import */ var _defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11921);





function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = (0,_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_2__/* .getDefaultOptions */ .j)();
  var firstWeekContainsDate = (0,_toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0,_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0,_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),

/***/ 35521:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iu": () => (/* binding */ isProtectedDayOfYearToken),
/* harmony export */   "Do": () => (/* binding */ isProtectedWeekYearToken),
/* harmony export */   "qp": () => (/* binding */ throwProtectedError)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

/***/ }),

/***/ 42362:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ requiredArgs)
/* harmony export */ });
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),

/***/ 45996:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ startOfUTCISOWeek)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


function startOfUTCISOWeek(dirtyDate) {
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var weekStartsOn = 1;
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 80941:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ startOfUTCWeek)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8217);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);
/* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77617);
/* harmony import */ var _defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11921);




function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var defaultOptions = (0,_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultOptions */ .j)();
  var weekStartsOn = (0,_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 77617:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ toInteger)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__);

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/***/ }),

/***/ 59165:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ addDays)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77617);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}

/***/ }),

/***/ 83502:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ addHours)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77617);
/* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34683);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);



var MILLISECONDS_IN_HOUR = 3600000;

/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */
function addHours(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

/***/ }),

/***/ 34683:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ addMilliseconds)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77617);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var timestamp = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate).getTime();
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);
  return new Date(timestamp + amount);
}

/***/ }),

/***/ 18444:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ addMinutes)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77617);
/* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34683);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);



var MILLISECONDS_IN_MINUTE = 60000;

/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}

/***/ }),

/***/ 45110:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ addMonths)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77617);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  var dayOfMonth = date.getDate();

  // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.
  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/***/ }),

/***/ 8504:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ addQuarters)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77617);
/* harmony import */ var _addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45110);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);



/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the quarters added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */
function addQuarters(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  var months = amount * 3;
  return (0,_addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, months);
}

/***/ }),

/***/ 57484:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ addWeeks)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77617);
/* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59165);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);



/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  var days = amount * 7;
  return (0,_addDays_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, days);
}

/***/ }),

/***/ 4021:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ addYears)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77617);
/* harmony import */ var _addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45110);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);



/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, amount * 12);
}

/***/ }),

/***/ 43259:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "yJ": () => (/* binding */ millisecondsInMinute),
/* harmony export */   "vh": () => (/* binding */ millisecondsInHour),
/* harmony export */   "qk": () => (/* binding */ millisecondsInSecond)
/* harmony export */ });
/* unused harmony exports daysInWeek, daysInYear, maxTime, minTime, minutesInHour, monthsInQuarter, monthsInYear, quartersInYear, secondsInHour, secondsInMinute, secondsInDay, secondsInWeek, secondsInYear, secondsInMonth, secondsInQuarter */
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */
var daysInWeek = 7;

/**
 * Days in 1 year
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * @name daysInYear
 * @constant
 * @type {number}
 * @default
 */
var daysInYear = 365.2425;

/**
 * Maximum allowed time.
 *
 * @name maxTime
 * @constant
 * @type {number}
 * @default
 */
var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;

/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInMinute = 60000;

/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInHour = 3600000;

/**
 * Milliseconds in 1 second
 *
 * @name millisecondsInSecond
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInSecond = 1000;

/**
 * Minimum allowed time.
 *
 * @name minTime
 * @constant
 * @type {number}
 * @default
 */
var minTime = -maxTime;

/**
 * Minutes in 1 hour
 *
 * @name minutesInHour
 * @constant
 * @type {number}
 * @default
 */
var minutesInHour = 60;

/**
 * Months in 1 quarter
 *
 * @name monthsInQuarter
 * @constant
 * @type {number}
 * @default
 */
var monthsInQuarter = 3;

/**
 * Months in 1 year
 *
 * @name monthsInYear
 * @constant
 * @type {number}
 * @default
 */
var monthsInYear = 12;

/**
 * Quarters in 1 year
 *
 * @name quartersInYear
 * @constant
 * @type {number}
 * @default
 */
var quartersInYear = 4;

/**
 * Seconds in 1 hour
 *
 * @name secondsInHour
 * @constant
 * @type {number}
 * @default
 */
var secondsInHour = 3600;

/**
 * Seconds in 1 minute
 *
 * @name secondsInMinute
 * @constant
 * @type {number}
 * @default
 */
var secondsInMinute = 60;

/**
 * Seconds in 1 day
 *
 * @name secondsInDay
 * @constant
 * @type {number}
 * @default
 */
var secondsInDay = secondsInHour * 24;

/**
 * Seconds in 1 week
 *
 * @name secondsInWeek
 * @constant
 * @type {number}
 * @default
 */
var secondsInWeek = secondsInDay * 7;

/**
 * Seconds in 1 year
 *
 * @name secondsInYear
 * @constant
 * @type {number}
 * @default
 */
var secondsInYear = secondsInDay * daysInYear;

/**
 * Seconds in 1 month
 *
 * @name secondsInMonth
 * @constant
 * @type {number}
 * @default
 */
var secondsInMonth = secondsInYear / 12;

/**
 * Seconds in 1 quarter
 *
 * @name secondsInQuarter
 * @constant
 * @type {number}
 * @default
 */
var secondsInQuarter = secondsInMonth * 3;

/***/ }),

/***/ 25125:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ differenceInCalendarDays)
/* harmony export */ });
/* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49895);
/* harmony import */ var _startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82811);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);



var MILLISECONDS_IN_DAY = 86400000;

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var startOfDayLeft = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var startOfDayRight = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startOfDayRight);

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

/***/ }),

/***/ 81715:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ differenceInCalendarMonths)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}

/***/ }),

/***/ 48933:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ differenceInCalendarWeeks)
/* harmony export */ });
/* harmony import */ var _startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52230);
/* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49895);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);



var MILLISECONDS_IN_WEEK = 604800000;

/**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */
function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, options) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var startOfWeekLeft = (0,_startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft, options);
  var startOfWeekRight = (0,_startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight, options);
  var timestampLeft = startOfWeekLeft.getTime() - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startOfWeekLeft);
  var timestampRight = startOfWeekRight.getTime() - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startOfWeekRight);

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
}

/***/ }),

/***/ 16909:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ differenceInCalendarYears)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}

/***/ }),

/***/ 66939:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ endOfDay)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),

/***/ 88521:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ endOfMonth)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),

/***/ 32408:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ endOfWeek)
/* harmony export */ });
/* harmony import */ var _lib_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11921);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8217);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77617);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);




/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultOptions */ .j)();
  var weekStartsOn = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),

/***/ 11022:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ endOfYear)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */
function endOfYear(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),

/***/ 80900:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ format)
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(69600);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(21249);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(4723);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(15306);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isValid/index.js
var isValid = __webpack_require__(13406);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/subMilliseconds/index.js
var subMilliseconds = __webpack_require__(24219);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(8217);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(42362);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js


var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js + 1 modules
var getUTCISOWeek = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
var getUTCISOWeekYear = __webpack_require__(15070);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js + 1 modules
var getUTCWeek = __webpack_require__(45796);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(16511);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/addLeadingZeros/index.js


function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/lightFormatters/index.js

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
/* harmony default export */ const lightFormatters = (formatters);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/formatters/index.js







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters_formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = (0,getUTCWeekYear/* default */.Z)(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = (0,getUTCISOWeekYear/* default */.Z)(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = (0,getUTCWeek/* default */.Z)(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = (0,getUTCISOWeek/* default */.Z)(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return lightFormatters.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
/* harmony default export */ const format_formatters = (formatters_formatters);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var longFormatters = __webpack_require__(29438);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(49895);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedTokens = __webpack_require__(35521);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(77617);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(11921);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultLocale/index.js
var defaultLocale = __webpack_require__(28652);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/format/index.js















 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  (0,requiredArgs/* default */.Z)(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale/* default */.Z;
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = (0,toDate["default"])(dirtyDate);
  if (!(0,isValid["default"])(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = (0,getTimezoneOffsetInMilliseconds/* default */.Z)(originalDate);
  var utcDate = (0,subMilliseconds/* default */.Z)(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters/* default */.Z[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = format_formatters[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0,protectedTokens/* isProtectedWeekYearToken */.Do)(substring)) {
        (0,protectedTokens/* throwProtectedError */.qp)(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0,protectedTokens/* isProtectedDayOfYearToken */.Iu)(substring)) {
        (0,protectedTokens/* throwProtectedError */.qp)(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),

/***/ 71542:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getDate)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var dayOfMonth = date.getDate();
  return dayOfMonth;
}

/***/ }),

/***/ 46367:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getDay)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var day = date.getDay();
  return day;
}

/***/ }),

/***/ 66774:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getHours)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */
function getHours(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var hours = date.getHours();
  return hours;
}

/***/ }),

/***/ 31411:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ getISOWeek)
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(8217);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfWeek/index.js
var startOfWeek = __webpack_require__(52230);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(42362);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfISOWeek/index.js


/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,startOfWeek["default"])(dirtyDate, {
    weekStartsOn: 1
  });
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getISOWeekYear/index.js



/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var year = date.getFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfISOWeekYear/index.js



/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var year = getISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = startOfISOWeek(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;

/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var diff = startOfISOWeek(date).getTime() - startOfISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ 63735:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getMinutes)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */
function getMinutes(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var minutes = date.getMinutes();
  return minutes;
}

/***/ }),

/***/ 59883:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getMonth)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var month = date.getMonth();
  return month;
}

/***/ }),

/***/ 30455:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getQuarter)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */
function getQuarter(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var quarter = Math.floor(date.getMonth() / 3) + 1;
  return quarter;
}

/***/ }),

/***/ 89933:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getSeconds)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */
function getSeconds(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}

/***/ }),

/***/ 2067:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getTime)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var timestamp = date.getTime();
  return timestamp;
}

/***/ }),

/***/ 225:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getYear)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  return (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate).getFullYear();
}

/***/ }),

/***/ 86723:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isAfter)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(dirtyDate, dirtyDateToCompare) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var dateToCompare = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/***/ }),

/***/ 84787:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isBefore)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore(dirtyDate, dirtyDateToCompare) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var dateToCompare = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/***/ }),

/***/ 26221:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isDate)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9151);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42362);



/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(1, arguments);
  return value instanceof Date || (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/***/ }),

/***/ 62833:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isEqual)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual(dirtyLeftDate, dirtyRightDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyLeftDate);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}

/***/ }),

/***/ 39138:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isSameDay)
/* harmony export */ });
/* harmony import */ var _startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82811);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeftStartOfDay = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRightStartOfDay = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/***/ }),

/***/ 25156:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isSameMonth)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

/***/ }),

/***/ 65695:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isSameQuarter)
/* harmony export */ });
/* harmony import */ var _startOfQuarter_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61261);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */
function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeftStartOfQuarter = (0,_startOfQuarter_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRightStartOfQuarter = (0,_startOfQuarter_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

/***/ }),

/***/ 47718:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isSameYear)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */
function isSameYear(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

/***/ }),

/***/ 13406:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isValid)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _isDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26221);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42362);




/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(1, arguments);
  if (!(0,_isDate_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(dirtyDate);
  return !isNaN(Number(date));
}

/***/ }),

/***/ 99316:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isWithinInterval)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @param {Date|Number} date - the date to check
 * @param {Interval} interval - the interval to check
 * @returns {Boolean} the date is within the interval
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date }) // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end }) // => true
 */
function isWithinInterval(dirtyDate, interval) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var time = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate).getTime();
  var startTime = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(interval.start).getTime();
  var endTime = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(interval.end).getTime();

  // Throw an exception if start date is after end date or if any date is `Invalid Date`
  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }
  return time >= startTime && time <= endTime;
}

/***/ }),

/***/ 26496:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ buildFormatLongFn)
/* harmony export */ });
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

/***/ }),

/***/ 38645:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ buildLocalizeFn)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_2__);



function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}

/***/ }),

/***/ 92395:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ buildMatchFn)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4723);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_2__);



function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

/***/ }),

/***/ 70884:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ buildMatchPatternFn)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4723);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_2__);



function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

/***/ }),

/***/ 37758:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ en_US)
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(15306);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js




var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
/* harmony default export */ const _lib_formatDistance = (formatDistance);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
var buildFormatLongFn = __webpack_require__(26496);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ const _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
/* harmony default export */ const _lib_formatRelative = (formatRelative);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(9653);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
var buildLocalizeFn = __webpack_require__(38645);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js


var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: (0,buildLocalizeFn/* default */.Z)({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,buildLocalizeFn/* default */.Z)({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0,buildLocalizeFn/* default */.Z)({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: (0,buildLocalizeFn/* default */.Z)({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0,buildLocalizeFn/* default */.Z)({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ const _lib_localize = (localize);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
var buildMatchFn = __webpack_require__(92395);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
var buildMatchPatternFn = __webpack_require__(70884);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: (0,buildMatchPatternFn/* default */.Z)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ const _lib_match = (match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ const en_US = (locale);

/***/ }),

/***/ 48703:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ max)
/* harmony export */ });
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9151);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42362);






/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} the latest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */
function max(dirtyDatesArray) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(1, arguments);
  var datesArray;
  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray;

    // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }
  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_5__["default"])(dirtyDate);
    if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

/***/ }),

/***/ 64670:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ min)
/* harmony export */ });
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9151);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42362);





/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} - the earliest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */
function min(dirtyDatesArray) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(1, arguments);
  var datesArray;
  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray;
    // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }
  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_4__["default"])(dirtyDate);
    if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

/***/ }),

/***/ 57135:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ parse)
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(4723);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(69600);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(21249);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__(69826);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(32023);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(57327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__(2707);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(15306);
// EXTERNAL MODULE: ./node_modules/date-fns/node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(9151);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
;// CONCATENATED MODULE: ./node_modules/date-fns/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js






function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js








function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultLocale/index.js
var defaultLocale = __webpack_require__(28652);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/subMilliseconds/index.js
var subMilliseconds = __webpack_require__(24219);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(8217);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/assign/index.js
function assign_assign(target, object) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }
  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      ;
      target[property] = object[property];
    }
  }
  return target;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var longFormatters = __webpack_require__(29438);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(49895);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedTokens = __webpack_require__(35521);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(77617);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(42362);
;// CONCATENATED MODULE: ./node_modules/date-fns/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__(12419);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(30489);
;// CONCATENATED MODULE: ./node_modules/date-fns/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && ((0,esm_typeof/* default */.Z)(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/node_modules/@babel/runtime/helpers/esm/createSuper.js




function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.to-primitive.js
var es_symbol_to_primitive = __webpack_require__(96649);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.date.to-primitive.js
var es_date_to_primitive = __webpack_require__(96078);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(9653);
;// CONCATENATED MODULE: ./node_modules/date-fns/node_modules/@babel/runtime/helpers/esm/toPrimitive.js







function _toPrimitive(input, hint) {
  if ((0,esm_typeof/* default */.Z)(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if ((0,esm_typeof/* default */.Z)(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return (0,esm_typeof/* default */.Z)(key) === "symbol" ? key : String(key);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/node_modules/@babel/runtime/helpers/esm/createClass.js

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/Setter.js







var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/function () {
  function Setter() {
    _classCallCheck(this, Setter);
    _defineProperty(this, "priority", void 0);
    _defineProperty(this, "subPriority", 0);
  }
  _createClass(Setter, [{
    key: "validate",
    value: function validate(_utcDate, _options) {
      return true;
    }
  }]);
  return Setter;
}();
var ValueSetter = /*#__PURE__*/function (_Setter) {
  _inherits(ValueSetter, _Setter);
  var _super = _createSuper(ValueSetter);
  function ValueSetter(value, validateValue, setValue, priority, subPriority) {
    var _this;
    _classCallCheck(this, ValueSetter);
    _this = _super.call(this);
    _this.value = value;
    _this.validateValue = validateValue;
    _this.setValue = setValue;
    _this.priority = priority;
    if (subPriority) {
      _this.subPriority = subPriority;
    }
    return _this;
  }
  _createClass(ValueSetter, [{
    key: "validate",
    value: function validate(utcDate, options) {
      return this.validateValue(utcDate, this.value, options);
    }
  }, {
    key: "set",
    value: function set(utcDate, flags, options) {
      return this.setValue(utcDate, flags, this.value, options);
    }
  }]);
  return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/function (_Setter2) {
  _inherits(DateToSystemTimezoneSetter, _Setter2);
  var _super2 = _createSuper(DateToSystemTimezoneSetter);
  function DateToSystemTimezoneSetter() {
    var _this2;
    _classCallCheck(this, DateToSystemTimezoneSetter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
    _defineProperty(_assertThisInitialized(_this2), "subPriority", -1);
    return _this2;
  }
  _createClass(DateToSystemTimezoneSetter, [{
    key: "set",
    value: function set(date, flags) {
      if (flags.timestampIsSet) {
        return date;
      }
      var convertedDate = new Date(0);
      convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
      convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
      return convertedDate;
    }
  }]);
  return DateToSystemTimezoneSetter;
}(Setter);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/Parser.js




var Parser = /*#__PURE__*/function () {
  function Parser() {
    _classCallCheck(this, Parser);
    _defineProperty(this, "incompatibleTokens", void 0);
    _defineProperty(this, "priority", void 0);
    _defineProperty(this, "subPriority", void 0);
  }
  _createClass(Parser, [{
    key: "run",
    value: function run(dateString, token, match, options) {
      var result = this.parse(dateString, token, match, options);
      if (!result) {
        return null;
      }
      return {
        setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
        rest: result.rest
      };
    }
  }, {
    key: "validate",
    value: function validate(_utcDate, _value, _options) {
      return true;
    }
  }]);
  return Parser;
}();
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/EraParser.js








var EraParser = /*#__PURE__*/function (_Parser) {
  _inherits(EraParser, _Parser);
  var _super = _createSuper(EraParser);
  function EraParser() {
    var _this;
    _classCallCheck(this, EraParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 140);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['R', 'u', 't', 'T']);
    return _this;
  }
  _createClass(EraParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
        // A, B
        case 'GGGGG':
          return match.era(dateString, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ
        case 'GGGG':
        default:
          return match.era(dateString, {
            width: 'wide'
          }) || match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return EraParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__(24603);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/constants/index.js
var constants = __webpack_require__(43259);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/constants.js
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59

  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999

  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};

var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/utils.js







function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }

  // Input is 'Z'
  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * constants/* millisecondsInHour */.vh + minutes * constants/* millisecondsInMinute */.yJ + seconds * constants/* millisecondsInSecond */.qk),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);
    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
  }
}
function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case 'morning':
      return 4;
    case 'evening':
      return 17;
    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;
    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0;
  // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC
  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/YearParser.js









// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
var YearParser = /*#__PURE__*/function (_Parser) {
  _inherits(YearParser, _Parser);
  var _super = _createSuper(YearParser);
  function YearParser() {
    var _this;
    _classCallCheck(this, YearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 130);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(YearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };
      switch (token) {
        case 'y':
          return mapValue(parseNDigits(4, dateString), valueCallback);
        case 'yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);
        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      var currentYear = date.getUTCFullYear();
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return YearParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(16511);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
var startOfUTCWeek = __webpack_require__(80941);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/LocalWeekYearParser.js











// Local week-numbering year
var LocalWeekYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalWeekYearParser, _Parser);
  var _super = _createSuper(LocalWeekYearParser);
  function LocalWeekYearParser() {
    var _this;
    _classCallCheck(this, LocalWeekYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 130);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
    return _this;
  }
  _createClass(LocalWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };
      switch (token) {
        case 'Y':
          return mapValue(parseNDigits(4, dateString), valueCallback);
        case 'Yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);
        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value, options) {
      var currentYear = (0,getUTCWeekYear/* default */.Z)(date, options);
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return (0,startOfUTCWeek/* default */.Z)(date, options);
      }
      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return (0,startOfUTCWeek/* default */.Z)(date, options);
    }
  }]);
  return LocalWeekYearParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
var startOfUTCISOWeek = __webpack_require__(45996);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISOWeekYearParser.js









 // ISO week-numbering year
var ISOWeekYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOWeekYearParser, _Parser);
  var _super = _createSuper(ISOWeekYearParser);
  function ISOWeekYearParser() {
    var _this;
    _classCallCheck(this, ISOWeekYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 130);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ISOWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'R') {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return (0,startOfUTCISOWeek/* default */.Z)(firstWeekOfYear);
    }
  }]);
  return ISOWeekYearParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ExtendedYearParser.js









var ExtendedYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(ExtendedYearParser, _Parser);
  var _super = _createSuper(ExtendedYearParser);
  function ExtendedYearParser() {
    var _this;
    _classCallCheck(this, ExtendedYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 130);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ExtendedYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'u') {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ExtendedYearParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/QuarterParser.js









var QuarterParser = /*#__PURE__*/function (_Parser) {
  _inherits(QuarterParser, _Parser);
  var _super = _createSuper(QuarterParser);
  function QuarterParser() {
    var _this;
    _classCallCheck(this, QuarterParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 120);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(QuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, dateString);
        // 1st, 2nd, 3rd, 4th
        case 'Qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4
        case 'QQQ':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'QQQQQ':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...
        case 'QQQQ':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return QuarterParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/StandAloneQuarterParser.js









var StandAloneQuarterParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneQuarterParser, _Parser);
  var _super = _createSuper(StandAloneQuarterParser);
  function StandAloneQuarterParser() {
    var _this;
    _classCallCheck(this, StandAloneQuarterParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 120);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(StandAloneQuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, dateString);
        // 1st, 2nd, 3rd, 4th
        case 'qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4
        case 'qqq':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'qqqqq':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...
        case 'qqqq':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneQuarterParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/MonthParser.js










var MonthParser = /*#__PURE__*/function (_Parser) {
  _inherits(MonthParser, _Parser);
  var _super = _createSuper(MonthParser);
  function MonthParser() {
    var _this;
    _classCallCheck(this, MonthParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    _defineProperty(_assertThisInitialized(_this), "priority", 110);
    return _this;
  }
  _createClass(MonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };
      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12
        case 'MM':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th
        case 'Mo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec
        case 'MMM':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D
        case 'MMMMM':
          return match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December
        case 'MMMM':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return MonthParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/StandAloneMonthParser.js










var StandAloneMonthParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneMonthParser, _Parser);
  var _super = _createSuper(StandAloneMonthParser);
  function StandAloneMonthParser() {
    var _this;
    _classCallCheck(this, StandAloneMonthParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 110);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(StandAloneMonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };
      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12
        case 'LL':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th
        case 'Lo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec
        case 'LLL':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D
        case 'LLLLL':
          return match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December
        case 'LLLL':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneMonthParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js + 1 modules
var getUTCWeek = __webpack_require__(45796);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCWeek/index.js




function setUTCWeek(dirtyDate, dirtyWeek, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var week = (0,toInteger/* default */.Z)(dirtyWeek);
  var diff = (0,getUTCWeek/* default */.Z)(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/LocalWeekParser.js











 // Local week of year
var LocalWeekParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalWeekParser, _Parser);
  var _super = _createSuper(LocalWeekParser);
  function LocalWeekParser() {
    var _this;
    _classCallCheck(this, LocalWeekParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 100);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
    return _this;
  }
  _createClass(LocalWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, dateString);
        case 'wo':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      return (0,startOfUTCWeek/* default */.Z)(setUTCWeek(date, value, options), options);
    }
  }]);
  return LocalWeekParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js + 1 modules
var getUTCISOWeek = __webpack_require__(45987);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCISOWeek/index.js




function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var isoWeek = (0,toInteger/* default */.Z)(dirtyISOWeek);
  var diff = (0,getUTCISOWeek/* default */.Z)(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISOWeekParser.js











 // ISO week of year
var ISOWeekParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOWeekParser, _Parser);
  var _super = _createSuper(ISOWeekParser);
  function ISOWeekParser() {
    var _this;
    _classCallCheck(this, ISOWeekParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 100);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ISOWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, dateString);
        case 'Io':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      return (0,startOfUTCISOWeek/* default */.Z)(setUTCISOWeek(date, value));
    }
  }]);
  return ISOWeekParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/DateParser.js










var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

// Day of the month
var DateParser = /*#__PURE__*/function (_Parser) {
  _inherits(DateParser, _Parser);
  var _super = _createSuper(DateParser);
  function DateParser() {
    var _this;
    _classCallCheck(this, DateParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "subPriority", 1);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(DateParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, dateString);
        case 'do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      var month = date.getUTCMonth();
      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DateParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/DayOfYearParser.js










var DayOfYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayOfYearParser, _Parser);
  var _super = _createSuper(DayOfYearParser);
  function DayOfYearParser() {
    var _this;
    _classCallCheck(this, DayOfYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "subpriority", 1);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(DayOfYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, dateString);
        case 'Do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayOfYearParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(11921);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCDay/index.js




function setUTCDay(dirtyDate, dirtyDay, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(2, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = (0,toDate["default"])(dirtyDate);
  var day = (0,toInteger/* default */.Z)(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/DayParser.js








 // Day of week
var DayParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayParser, _Parser);
  var _super = _createSuper(DayParser);
  function DayParser() {
    var _this;
    _classCallCheck(this, DayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(DayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T
        case 'EEEEE':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu
        case 'EEEEEE':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday
        case 'EEEE':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/LocalDayParser.js









 // Local day of week
var LocalDayParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalDayParser, _Parser);
  var _super = _createSuper(LocalDayParser);
  function LocalDayParser() {
    var _this;
    _classCallCheck(this, LocalDayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']);
    return _this;
  }
  _createClass(LocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd
        case 'eo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue
        case 'eee':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T
        case 'eeeee':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu
        case 'eeeeee':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday
        case 'eeee':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return LocalDayParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/StandAloneLocalDayParser.js









 // Stand-alone local day of week
var StandAloneLocalDayParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneLocalDayParser, _Parser);
  var _super = _createSuper(StandAloneLocalDayParser);
  function StandAloneLocalDayParser() {
    var _this;
    _classCallCheck(this, StandAloneLocalDayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']);
    return _this;
  }
  _createClass(StandAloneLocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd
        case 'co':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue
        case 'ccc':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // T
        case 'ccccc':
          return match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu
        case 'cccccc':
          return match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday
        case 'cccc':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneLocalDayParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCISODay/index.js



function setUTCISODay(dirtyDate, dirtyDay) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var day = (0,toInteger/* default */.Z)(dirtyDay);
  if (day % 7 === 0) {
    day = day - 7;
  }
  var weekStartsOn = 1;
  var date = (0,toDate["default"])(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISODayParser.js









 // ISO day of week
var ISODayParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISODayParser, _Parser);
  var _super = _createSuper(ISODayParser);
  function ISODayParser() {
    var _this;
    _classCallCheck(this, ISODayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ISODayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        if (value === 0) {
          return 7;
        }
        return value;
      };
      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, dateString);
        // 2nd
        case 'io':
          return match.ordinalNumber(dateString, {
            unit: 'day'
          });
        // Tue
        case 'iii':
          return mapValue(match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // T
        case 'iiiii':
          return mapValue(match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tu
        case 'iiiiii':
          return mapValue(match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tuesday
        case 'iiii':
        default:
          return mapValue(match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 7;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date = setUTCISODay(date, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ISODayParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/AMPMParser.js









var AMPMParser = /*#__PURE__*/function (_Parser) {
  _inherits(AMPMParser, _Parser);
  var _super = _createSuper(AMPMParser);
  function AMPMParser() {
    var _this;
    _classCallCheck(this, AMPMParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 80);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['b', 'B', 'H', 'k', 't', 'T']);
    return _this;
  }
  _createClass(AMPMParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'aaaaa':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'aaaa':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/AMPMMidnightParser.js









var AMPMMidnightParser = /*#__PURE__*/function (_Parser) {
  _inherits(AMPMMidnightParser, _Parser);
  var _super = _createSuper(AMPMMidnightParser);
  function AMPMMidnightParser() {
    var _this;
    _classCallCheck(this, AMPMMidnightParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 80);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['a', 'B', 'H', 'k', 't', 'T']);
    return _this;
  }
  _createClass(AMPMMidnightParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'bbbbb':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'bbbb':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMMidnightParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/DayPeriodParser.js








 // in the morning, in the afternoon, in the evening, at night
var DayPeriodParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayPeriodParser, _Parser);
  var _super = _createSuper(DayPeriodParser);
  function DayPeriodParser() {
    var _this;
    _classCallCheck(this, DayPeriodParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 80);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['a', 'b', 't', 'T']);
    return _this;
  }
  _createClass(DayPeriodParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'BBBBB':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'BBBB':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return DayPeriodParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/Hour1to12Parser.js










var Hour1to12Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour1to12Parser, _Parser);
  var _super = _createSuper(Hour1to12Parser);
  function Hour1to12Parser() {
    var _this;
    _classCallCheck(this, Hour1to12Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 70);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['H', 'K', 'k', 't', 'T']);
    return _this;
  }
  _createClass(Hour1to12Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, dateString);
        case 'ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 12;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour1to12Parser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/Hour0to23Parser.js










var Hour0to23Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour0to23Parser, _Parser);
  var _super = _createSuper(Hour0to23Parser);
  function Hour0to23Parser() {
    var _this;
    _classCallCheck(this, Hour0to23Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 70);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['a', 'b', 'h', 'K', 'k', 't', 'T']);
    return _this;
  }
  _createClass(Hour0to23Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, dateString);
        case 'Ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 23;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    }
  }]);
  return Hour0to23Parser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/Hour0To11Parser.js










var Hour0To11Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour0To11Parser, _Parser);
  var _super = _createSuper(Hour0To11Parser);
  function Hour0To11Parser() {
    var _this;
    _classCallCheck(this, Hour0To11Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 70);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['h', 'H', 'k', 't', 'T']);
    return _this;
  }
  _createClass(Hour0To11Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, dateString);
        case 'Ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour0To11Parser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/Hour1To24Parser.js










var Hour1To24Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour1To24Parser, _Parser);
  var _super = _createSuper(Hour1To24Parser);
  function Hour1To24Parser() {
    var _this;
    _classCallCheck(this, Hour1To24Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 70);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['a', 'b', 'h', 'H', 'K', 't', 'T']);
    return _this;
  }
  _createClass(Hour1To24Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, dateString);
        case 'ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 24;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    }
  }]);
  return Hour1To24Parser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/MinuteParser.js










var MinuteParser = /*#__PURE__*/function (_Parser) {
  _inherits(MinuteParser, _Parser);
  var _super = _createSuper(MinuteParser);
  function MinuteParser() {
    var _this;
    _classCallCheck(this, MinuteParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 60);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  _createClass(MinuteParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, dateString);
        case 'mo':
          return match.ordinalNumber(dateString, {
            unit: 'minute'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    }
  }]);
  return MinuteParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/SecondParser.js










var SecondParser = /*#__PURE__*/function (_Parser) {
  _inherits(SecondParser, _Parser);
  var _super = _createSuper(SecondParser);
  function SecondParser() {
    var _this;
    _classCallCheck(this, SecondParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 50);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  _createClass(SecondParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, dateString);
        case 'so':
          return match.ordinalNumber(dateString, {
            unit: 'second'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCSeconds(value, 0);
      return date;
    }
  }]);
  return SecondParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/FractionOfSecondParser.js









var FractionOfSecondParser = /*#__PURE__*/function (_Parser) {
  _inherits(FractionOfSecondParser, _Parser);
  var _super = _createSuper(FractionOfSecondParser);
  function FractionOfSecondParser() {
    var _this;
    _classCallCheck(this, FractionOfSecondParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 30);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  _createClass(FractionOfSecondParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      var valueCallback = function valueCallback(value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };
      return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMilliseconds(value);
      return date;
    }
  }]);
  return FractionOfSecondParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISOTimezoneWithZParser.js









 // Timezone (ISO-8601. +00:00 is `'Z'`)
var ISOTimezoneWithZParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOTimezoneWithZParser, _Parser);
  var _super = _createSuper(ISOTimezoneWithZParser);
  function ISOTimezoneWithZParser() {
    var _this;
    _classCallCheck(this, ISOTimezoneWithZParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 10);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T', 'x']);
    return _this;
  }
  _createClass(ISOTimezoneWithZParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value);
    }
  }]);
  return ISOTimezoneWithZParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISOTimezoneParser.js









 // Timezone (ISO-8601)
var ISOTimezoneParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOTimezoneParser, _Parser);
  var _super = _createSuper(ISOTimezoneParser);
  function ISOTimezoneParser() {
    var _this;
    _classCallCheck(this, ISOTimezoneParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 10);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T', 'X']);
    return _this;
  }
  _createClass(ISOTimezoneParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value);
    }
  }]);
  return ISOTimezoneParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/TimestampSecondsParser.js









var TimestampSecondsParser = /*#__PURE__*/function (_Parser) {
  _inherits(TimestampSecondsParser, _Parser);
  var _super = _createSuper(TimestampSecondsParser);
  function TimestampSecondsParser() {
    var _this;
    _classCallCheck(this, TimestampSecondsParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 40);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", '*');
    return _this;
  }
  _createClass(TimestampSecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampSecondsParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/TimestampMillisecondsParser.js









var TimestampMillisecondsParser = /*#__PURE__*/function (_Parser) {
  _inherits(TimestampMillisecondsParser, _Parser);
  var _super = _createSuper(TimestampMillisecondsParser);
  function TimestampMillisecondsParser() {
    var _this;
    _classCallCheck(this, TimestampMillisecondsParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 20);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", '*');
    return _this;
  }
  _createClass(TimestampMillisecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampMillisecondsParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/index.js































/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */
var parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
};
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/index.js

























 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */
function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  (0,requiredArgs/* default */.Z)(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale/* default */.Z;
  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (formatString === '') {
    if (dateString === '') {
      return (0,toDate["default"])(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }
  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale
  };

  // If timezone isn't specified, it will be set to the system timezone
  var setters = [new DateToSystemTimezoneSetter()];
  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter in longFormatters/* default */.Z) {
      var longFormatter = longFormatters/* default */.Z[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp);
  var usedTokens = [];
  var _iterator = _createForOfIteratorHelper(tokens),
    _step;
  try {
    var _loop = function _loop() {
      var token = _step.value;
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0,protectedTokens/* isProtectedWeekYearToken */.Do)(token)) {
        (0,protectedTokens/* throwProtectedError */.qp)(token, formatString, dirtyDateString);
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0,protectedTokens/* isProtectedDayOfYearToken */.Iu)(token)) {
        (0,protectedTokens/* throwProtectedError */.qp)(token, formatString, dirtyDateString);
      }
      var firstCharacter = token[0];
      var parser = parsers[firstCharacter];
      if (parser) {
        var incompatibleTokens = parser.incompatibleTokens;
        if (Array.isArray(incompatibleTokens)) {
          var incompatibleToken = usedTokens.find(function (usedToken) {
            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
          });
          if (incompatibleToken) {
            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
          }
        } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) {
          throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
        }
        usedTokens.push({
          token: firstCharacter,
          fullToken: token
        });
        var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
        if (!parseResult) {
          return {
            v: new Date(NaN)
          };
        }
        setters.push(parseResult.setter);
        dateString = parseResult.rest;
      } else {
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
          throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        }

        // Replace two single quote characters with one single quote character
        if (token === "''") {
          token = "'";
        } else if (firstCharacter === "'") {
          token = cleanEscapedString(token);
        }

        // Cut token from string, or, if string doesn't match the token, return Invalid Date
        if (dateString.indexOf(token) === 0) {
          dateString = dateString.slice(token.length);
        } else {
          return {
            v: new Date(NaN)
          };
        }
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();
      if ((0,esm_typeof/* default */.Z)(_ret) === "object") return _ret.v;
    }

    // Check if the remaining input contains something other than whitespace
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }
  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = (0,toDate["default"])(dirtyReferenceDate);
  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  var utcDate = (0,subMilliseconds/* default */.Z)(date, (0,getTimezoneOffsetInMilliseconds/* default */.Z)(date));
  var flags = {};
  var _iterator2 = _createForOfIteratorHelper(uniquePrioritySetters),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var setter = _step2.value;
      if (!setter.validate(utcDate, subFnOptions)) {
        return new Date(NaN);
      }
      var result = setter.set(utcDate, flags, subFnOptions);
      // Result is tuple (date, flags)
      if (Array.isArray(result)) {
        utcDate = result[0];
        assign_assign(flags, result[1]);
        // Result is date
      } else {
        utcDate = result;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return utcDate;
}
function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),

/***/ 32638:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ parseISO)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23123);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24603);
/* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4723);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _constants_index_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43259);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42362);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77617);











/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */
function parseISO(argument, options) {
  var _options$additionalDi;
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(1, arguments);
  var additionalDigits = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }
  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }
  var dateStrings = splitDateString(argument);
  var date;
  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }
  var timestamp = date.getTime();
  var time = 0;
  var offset;
  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return new Date(NaN);
    }
  }
  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);
    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time);
    // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.
    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }
  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString;

  // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }
  if (timeString) {
    var token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex);
  // Invalid ISO-formatted year
  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null;

  // either year or century is null, not both
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex);
  // Invalid ISO-formatted string
  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);
    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}
function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);
  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }
  return hours * _constants_index_js__WEBPACK_IMPORTED_MODULE_10__/* .millisecondsInHour */ .vh + minutes * _constants_index_js__WEBPACK_IMPORTED_MODULE_10__/* .millisecondsInMinute */ .yJ + seconds * 1000;
}
function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}
function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }
  return sign * (hours * _constants_index_js__WEBPACK_IMPORTED_MODULE_10__/* .millisecondsInHour */ .vh + minutes * _constants_index_js__WEBPACK_IMPORTED_MODULE_10__/* .millisecondsInMinute */ .yJ);
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// Validation functions

// February is null to handle the leap year (using ||)
var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }
  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

/***/ }),

/***/ 7549:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ set)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9151);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8217);
/* harmony import */ var _setMonth_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30000);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77617);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42362);





/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Object} values - an object with options
 * @param {Number} [values.year] - the number of years to be set
 * @param {Number} [values.month] - the number of months to be set
 * @param {Number} [values.date] - the number of days to be set
 * @param {Number} [values.hours] - the number of hours to be set
 * @param {Number} [values.minutes] - the number of minutes to be set
 * @param {Number} [values.seconds] - the number of seconds to be set
 * @param {Number} [values.milliseconds] - the number of milliseconds to be set
 * @returns {Date} the new date with options set
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `values` must be an object
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */
function set(dirtyDate, values) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(2, arguments);
  if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(values) !== 'object' || values === null) {
    throw new RangeError('values parameter must be an object');
  }
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }
  if (values.year != null) {
    date.setFullYear(values.year);
  }
  if (values.month != null) {
    date = (0,_setMonth_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(date, values.month);
  }
  if (values.date != null) {
    date.setDate((0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(values.date));
  }
  if (values.hours != null) {
    date.setHours((0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(values.hours));
  }
  if (values.minutes != null) {
    date.setMinutes((0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(values.minutes));
  }
  if (values.seconds != null) {
    date.setSeconds((0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(values.seconds));
  }
  if (values.milliseconds != null) {
    date.setMilliseconds((0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(values.milliseconds));
  }
  return date;
}

/***/ }),

/***/ 10448:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ setHours)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77617);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);



/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */
function setHours(dirtyDate, dirtyHours) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var hours = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyHours);
  date.setHours(hours);
  return date;
}

/***/ }),

/***/ 11301:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ setMinutes)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77617);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);



/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */
function setMinutes(dirtyDate, dirtyMinutes) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var minutes = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}

/***/ }),

/***/ 30000:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ setMonth)
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(77617);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(8217);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(42362);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getDaysInMonth/index.js


/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setMonth/index.js




/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth(dirtyDate, dirtyMonth) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var month = (0,toInteger/* default */.Z)(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth);
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}

/***/ }),

/***/ 9560:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ setQuarter)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77617);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _setMonth_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30000);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);




/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */
function setQuarter(dirtyDate, dirtyQuarter) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var quarter = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyQuarter);
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
  var diff = quarter - oldQuarter;
  return (0,_setMonth_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(date, date.getMonth() + diff * 3);
}

/***/ }),

/***/ 12411:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ setSeconds)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77617);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);



/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */
function setSeconds(dirtyDate, dirtySeconds) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var seconds = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}

/***/ }),

/***/ 28137:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ setYear)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77617);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);



/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear(dirtyDate, dirtyYear) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var year = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyYear);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }
  date.setFullYear(year);
  return date;
}

/***/ }),

/***/ 82811:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ startOfDay)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 99067:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ startOfMonth)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 61261:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ startOfQuarter)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */
function startOfQuarter(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3;
  date.setMonth(month, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 52230:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ startOfWeek)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8217);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77617);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);
/* harmony import */ var _lib_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11921);




/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultOptions */ .j)();
  var weekStartsOn = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 54980:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ startOfYear)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8217);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);


/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var cleanDate = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 66923:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ subDays)
/* harmony export */ });
/* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59165);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77617);



/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addDays_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 85946:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ subHours)
/* harmony export */ });
/* harmony import */ var _addHours_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83502);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77617);



/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */
function subHours(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addHours_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 24219:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ subMilliseconds)
/* harmony export */ });
/* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34683);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77617);



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, -amount);
}

/***/ }),

/***/ 1092:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ subMinutes)
/* harmony export */ });
/* harmony import */ var _addMinutes_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18444);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77617);



/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */
function subMinutes(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMinutes_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 16353:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ subMonths)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77617);
/* harmony import */ var _addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45110);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);



/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 54586:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ subQuarters)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77617);
/* harmony import */ var _addQuarters_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8504);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);



/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the quarters subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */
function subQuarters(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addQuarters_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 81480:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ subWeeks)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77617);
/* harmony import */ var _addWeeks_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57484);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);



/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */
function subWeeks(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addWeeks_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 23946:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ subYears)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77617);
/* harmony import */ var _addYears_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4021);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42362);



/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */
function subYears(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addYears_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 8217:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ toDate)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9151);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42362);



/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

/***/ }),

/***/ 54516:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;__webpack_require__(65743);
__webpack_require__(74916);
__webpack_require__(23123);
__webpack_require__(69600);
__webpack_require__(15306);
__webpack_require__(68309);
__webpack_require__(4723);
__webpack_require__(41539);
__webpack_require__(39714);
__webpack_require__(47042);
__webpack_require__(9653);
__webpack_require__(83753);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
!function (t, e) {
  "object" == ( false ? 0 : _typeof(exports)) && "undefined" != "object" ? module.exports = e() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (e),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : 0;
}(this, function () {
  "use strict";

  var t = 1e3,
    e = 6e4,
    n = 36e5,
    r = "millisecond",
    i = "second",
    s = "minute",
    u = "hour",
    a = "day",
    o = "week",
    c = "month",
    f = "quarter",
    h = "year",
    d = "date",
    l = "Invalid Date",
    $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,
    y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
    M = {
      name: "en",
      weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
      months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
      ordinal: function ordinal(t) {
        var e = ["th", "st", "nd", "rd"],
          n = t % 100;
        return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
      }
    },
    m = function m(t, e, n) {
      var r = String(t);
      return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    },
    v = {
      s: m,
      z: function z(t) {
        var e = -t.utcOffset(),
          n = Math.abs(e),
          r = Math.floor(n / 60),
          i = n % 60;
        return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
      },
      m: function t(e, n) {
        if (e.date() < n.date()) return -t(n, e);
        var r = 12 * (n.year() - e.year()) + (n.month() - e.month()),
          i = e.clone().add(r, c),
          s = n - i < 0,
          u = e.clone().add(r + (s ? -1 : 1), c);
        return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
      },
      a: function a(t) {
        return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
      },
      p: function p(t) {
        return {
          M: c,
          y: h,
          w: o,
          d: a,
          D: d,
          h: u,
          m: s,
          s: i,
          ms: r,
          Q: f
        }[t] || String(t || "").toLowerCase().replace(/s$/, "");
      },
      u: function u(t) {
        return void 0 === t;
      }
    },
    g = "en",
    D = {};
  D[g] = M;
  var p = "$isDayjsObject",
    S = function S(t) {
      return t instanceof _ || !(!t || !t[p]);
    },
    w = function t(e, n, r) {
      var i;
      if (!e) return g;
      if ("string" == typeof e) {
        var s = e.toLowerCase();
        D[s] && (i = s), n && (D[s] = n, i = s);
        var u = e.split("-");
        if (!i && u.length > 1) return t(u[0]);
      } else {
        var a = e.name;
        D[a] = e, i = a;
      }
      return !r && i && (g = i), i || !r && g;
    },
    O = function O(t, e) {
      if (S(t)) return t.clone();
      var n = "object" == _typeof(e) ? e : {};
      return n.date = t, n.args = arguments, new _(n);
    },
    b = v;
  b.l = w, b.i = S, b.w = function (t, e) {
    return O(t, {
      locale: e.$L,
      utc: e.$u,
      x: e.$x,
      $offset: e.$offset
    });
  };
  var _ = function () {
      function M(t) {
        this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
      }
      var m = M.prototype;
      return m.parse = function (t) {
        this.$d = function (t) {
          var e = t.date,
            n = t.utc;
          if (null === e) return new Date(NaN);
          if (b.u(e)) return new Date();
          if (e instanceof Date) return new Date(e);
          if ("string" == typeof e && !/Z$/i.test(e)) {
            var r = e.match($);
            if (r) {
              var i = r[2] - 1 || 0,
                s = (r[7] || "0").substring(0, 3);
              return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
            }
          }
          return new Date(e);
        }(t), this.init();
      }, m.init = function () {
        var t = this.$d;
        this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
      }, m.$utils = function () {
        return b;
      }, m.isValid = function () {
        return !(this.$d.toString() === l);
      }, m.isSame = function (t, e) {
        var n = O(t);
        return this.startOf(e) <= n && n <= this.endOf(e);
      }, m.isAfter = function (t, e) {
        return O(t) < this.startOf(e);
      }, m.isBefore = function (t, e) {
        return this.endOf(e) < O(t);
      }, m.$g = function (t, e, n) {
        return b.u(t) ? this[e] : this.set(n, t);
      }, m.unix = function () {
        return Math.floor(this.valueOf() / 1e3);
      }, m.valueOf = function () {
        return this.$d.getTime();
      }, m.startOf = function (t, e) {
        var n = this,
          r = !!b.u(e) || e,
          f = b.p(t),
          l = function l(t, e) {
            var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
            return r ? i : i.endOf(a);
          },
          $ = function $(t, e) {
            return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e)), n);
          },
          y = this.$W,
          M = this.$M,
          m = this.$D,
          v = "set" + (this.$u ? "UTC" : "");
        switch (f) {
          case h:
            return r ? l(1, 0) : l(31, 11);
          case c:
            return r ? l(1, M) : l(0, M + 1);
          case o:
            var g = this.$locale().weekStart || 0,
              D = (y < g ? y + 7 : y) - g;
            return l(r ? m - D : m + (6 - D), M);
          case a:
          case d:
            return $(v + "Hours", 0);
          case u:
            return $(v + "Minutes", 1);
          case s:
            return $(v + "Seconds", 2);
          case i:
            return $(v + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, m.endOf = function (t) {
        return this.startOf(t, !1);
      }, m.$set = function (t, e) {
        var n,
          o = b.p(t),
          f = "set" + (this.$u ? "UTC" : ""),
          l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o],
          $ = o === a ? this.$D + (e - this.$W) : e;
        if (o === c || o === h) {
          var y = this.clone().set(d, 1);
          y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
        } else l && this.$d[l]($);
        return this.init(), this;
      }, m.set = function (t, e) {
        return this.clone().$set(t, e);
      }, m.get = function (t) {
        return this[b.p(t)]();
      }, m.add = function (r, f) {
        var d,
          l = this;
        r = Number(r);
        var $ = b.p(f),
          y = function y(t) {
            var e = O(l);
            return b.w(e.date(e.date() + Math.round(t * r)), l);
          };
        if ($ === c) return this.set(c, this.$M + r);
        if ($ === h) return this.set(h, this.$y + r);
        if ($ === a) return y(1);
        if ($ === o) return y(7);
        var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1,
          m = this.$d.getTime() + r * M;
        return b.w(m, this);
      }, m.subtract = function (t, e) {
        return this.add(-1 * t, e);
      }, m.format = function (t) {
        var e = this,
          n = this.$locale();
        if (!this.isValid()) return n.invalidDate || l;
        var r = t || "YYYY-MM-DDTHH:mm:ssZ",
          i = b.z(this),
          s = this.$H,
          u = this.$m,
          a = this.$M,
          o = n.weekdays,
          c = n.months,
          f = n.meridiem,
          h = function h(t, n, i, s) {
            return t && (t[n] || t(e, r)) || i[n].slice(0, s);
          },
          d = function d(t) {
            return b.s(s % 12 || 12, t, "0");
          },
          $ = f || function (t, e, n) {
            var r = t < 12 ? "AM" : "PM";
            return n ? r.toLowerCase() : r;
          };
        return r.replace(y, function (t, r) {
          return r || function (t) {
            switch (t) {
              case "YY":
                return String(e.$y).slice(-2);
              case "YYYY":
                return b.s(e.$y, 4, "0");
              case "M":
                return a + 1;
              case "MM":
                return b.s(a + 1, 2, "0");
              case "MMM":
                return h(n.monthsShort, a, c, 3);
              case "MMMM":
                return h(c, a);
              case "D":
                return e.$D;
              case "DD":
                return b.s(e.$D, 2, "0");
              case "d":
                return String(e.$W);
              case "dd":
                return h(n.weekdaysMin, e.$W, o, 2);
              case "ddd":
                return h(n.weekdaysShort, e.$W, o, 3);
              case "dddd":
                return o[e.$W];
              case "H":
                return String(s);
              case "HH":
                return b.s(s, 2, "0");
              case "h":
                return d(1);
              case "hh":
                return d(2);
              case "a":
                return $(s, u, !0);
              case "A":
                return $(s, u, !1);
              case "m":
                return String(u);
              case "mm":
                return b.s(u, 2, "0");
              case "s":
                return String(e.$s);
              case "ss":
                return b.s(e.$s, 2, "0");
              case "SSS":
                return b.s(e.$ms, 3, "0");
              case "Z":
                return i;
            }
            return null;
          }(t) || i.replace(":", "");
        });
      }, m.utcOffset = function () {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, m.diff = function (r, d, l) {
        var $,
          y = this,
          M = b.p(d),
          m = O(r),
          v = (m.utcOffset() - this.utcOffset()) * e,
          g = this - m,
          D = function D() {
            return b.m(y, m);
          };
        switch (M) {
          case h:
            $ = D() / 12;
            break;
          case c:
            $ = D();
            break;
          case f:
            $ = D() / 3;
            break;
          case o:
            $ = (g - v) / 6048e5;
            break;
          case a:
            $ = (g - v) / 864e5;
            break;
          case u:
            $ = g / n;
            break;
          case s:
            $ = g / e;
            break;
          case i:
            $ = g / t;
            break;
          default:
            $ = g;
        }
        return l ? $ : b.a($);
      }, m.daysInMonth = function () {
        return this.endOf(c).$D;
      }, m.$locale = function () {
        return D[this.$L];
      }, m.locale = function (t, e) {
        if (!t) return this.$L;
        var n = this.clone(),
          r = w(t, e, !0);
        return r && (n.$L = r), n;
      }, m.clone = function () {
        return b.w(this.$d, this);
      }, m.toDate = function () {
        return new Date(this.valueOf());
      }, m.toJSON = function () {
        return this.isValid() ? this.toISOString() : null;
      }, m.toISOString = function () {
        return this.$d.toISOString();
      }, m.toString = function () {
        return this.$d.toUTCString();
      }, M;
    }(),
    k = _.prototype;
  return O.prototype = k, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", c], ["$y", h], ["$D", d]].forEach(function (t) {
    k[t[1]] = function (e) {
      return this.$g(e, t[0], t[1]);
    };
  }), O.extend = function (t, e) {
    return t.$i || (t(e, _, O), t.$i = !0), O;
  }, O.locale = w, O.isDayjs = S, O.unix = function (t) {
    return O(1e3 * t);
  }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

/***/ }),

/***/ 96011:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;__webpack_require__(65743);
__webpack_require__(74916);
__webpack_require__(23123);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
!function (_, t) {
  "object" == ( false ? 0 : _typeof(exports)) && "undefined" != "object" ? module.exports = t(__webpack_require__(54516)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(54516)], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : 0;
}(this, function (_) {
  "use strict";

  function t(_) {
    return _ && "object" == _typeof(_) && "default" in _ ? _ : {
      default: _
    };
  }
  var e = t(_),
    n = "января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря".split("_"),
    s = "январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_"),
    r = "янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.".split("_"),
    o = "янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.".split("_"),
    i = /D[oD]?(\[[^[\]]*\]|\s)+MMMM?/;
  function d(_, t, e) {
    var n, s;
    return "m" === e ? t ? "минута" : "минуту" : _ + " " + (n = +_, s = {
      mm: t ? "минута_минуты_минут" : "минуту_минуты_минут",
      hh: "час_часа_часов",
      dd: "день_дня_дней",
      MM: "месяц_месяца_месяцев",
      yy: "год_года_лет"
    }[e].split("_"), n % 10 == 1 && n % 100 != 11 ? s[0] : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? s[1] : s[2]);
  }
  var u = function u(_, t) {
    return i.test(t) ? n[_.month()] : s[_.month()];
  };
  u.s = s, u.f = n;
  var a = function a(_, t) {
    return i.test(t) ? r[_.month()] : o[_.month()];
  };
  a.s = o, a.f = r;
  var m = {
    name: "ru",
    weekdays: "воскресенье_понедельник_вторник_среда_четверг_пятница_суббота".split("_"),
    weekdaysShort: "вск_пнд_втр_срд_чтв_птн_сбт".split("_"),
    weekdaysMin: "вс_пн_вт_ср_чт_пт_сб".split("_"),
    months: u,
    monthsShort: a,
    weekStart: 1,
    yearStart: 4,
    formats: {
      LT: "H:mm",
      LTS: "H:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D MMMM YYYY г.",
      LLL: "D MMMM YYYY г., H:mm",
      LLLL: "dddd, D MMMM YYYY г., H:mm"
    },
    relativeTime: {
      future: "через %s",
      past: "%s назад",
      s: "несколько секунд",
      m: d,
      mm: d,
      h: "час",
      hh: d,
      d: "день",
      dd: d,
      M: "месяц",
      MM: d,
      y: "год",
      yy: d
    },
    ordinal: function ordinal(_) {
      return _;
    },
    meridiem: function meridiem(_) {
      return _ < 4 ? "ночи" : _ < 12 ? "утра" : _ < 17 ? "дня" : "вечера";
    }
  };
  return e.default.locale(m, null, !0), m;
});

/***/ }),

/***/ 35234:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(30489);
__webpack_require__(47042);
__webpack_require__(68309);
__webpack_require__(66992);
__webpack_require__(41539);
__webpack_require__(82472);
__webpack_require__(92990);
__webpack_require__(18927);
__webpack_require__(33105);
__webpack_require__(35035);
__webpack_require__(74345);
__webpack_require__(7174);
__webpack_require__(32846);
__webpack_require__(44731);
__webpack_require__(77209);
__webpack_require__(96319);
__webpack_require__(58867);
__webpack_require__(37789);
__webpack_require__(33739);
__webpack_require__(29368);
__webpack_require__(14483);
__webpack_require__(12056);
__webpack_require__(3462);
__webpack_require__(30678);
__webpack_require__(27462);
__webpack_require__(33824);
__webpack_require__(55021);
__webpack_require__(12974);
__webpack_require__(15016);
__webpack_require__(2707);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(78783);
__webpack_require__(33948);
var assign = __webpack_require__(38385);
var callBound = __webpack_require__(73684);
var flags = __webpack_require__(95081);
var GetIntrinsic = __webpack_require__(37555);
var getIterator = __webpack_require__(92538);
var getSideChannel = __webpack_require__(5757);
var is = __webpack_require__(17556);
var isArguments = __webpack_require__(99719);
var isArray = __webpack_require__(98597);
var isArrayBuffer = __webpack_require__(14063);
var isDate = __webpack_require__(26515);
var isRegex = __webpack_require__(39011);
var isSharedArrayBuffer = __webpack_require__(75769);
var objectKeys = __webpack_require__(38209);
var whichBoxedPrimitive = __webpack_require__(58887);
var whichCollection = __webpack_require__(94555);
var whichTypedArray = __webpack_require__(43219);
var byteLength = __webpack_require__(66488);
var sabByteLength = callBound('SharedArrayBuffer.prototype.byteLength', true);
var $getTime = callBound('Date.prototype.getTime');
var gPO = Object.getPrototypeOf;
var $objToString = callBound('Object.prototype.toString');
var $Set = GetIntrinsic('%Set%', true);
var $mapHas = callBound('Map.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSize = callBound('Map.prototype.size', true);
var $setAdd = callBound('Set.prototype.add', true);
var $setDelete = callBound('Set.prototype.delete', true);
var $setHas = callBound('Set.prototype.has', true);
var $setSize = callBound('Set.prototype.size', true);

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L401-L414
function setHasEqualElement(set, val1, opts, channel) {
  var i = getIterator(set);
  var result;
  while ((result = i.next()) && !result.done) {
    if (internalDeepEqual(val1, result.value, opts, channel)) {
      // eslint-disable-line no-use-before-define
      // Remove the matching element to make sure we do not check that again.
      $setDelete(set, result.value);
      return true;
    }
  }
  return false;
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L416-L439
function findLooseMatchingPrimitives(prim) {
  if (typeof prim === 'undefined') {
    return null;
  }
  if (_typeof(prim) === 'object') {
    // Only pass in null as object!
    return void 0;
  }
  if (_typeof(prim) === 'symbol') {
    return false;
  }
  if (typeof prim === 'string' || typeof prim === 'number') {
    // Loose equal entries exist only if the string is possible to convert to a regular number and not NaN.
    return +prim === +prim; // eslint-disable-line no-implicit-coercion
  }

  return true;
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L449-L460
function mapMightHaveLoosePrim(a, b, prim, item, opts, channel) {
  var altValue = findLooseMatchingPrimitives(prim);
  if (altValue != null) {
    return altValue;
  }
  var curB = $mapGet(b, altValue);
  var looseOpts = assign({}, opts, {
    strict: false
  });
  if (typeof curB === 'undefined' && !$mapHas(b, altValue) || !internalDeepEqual(item, curB, looseOpts, channel)) {
    return false;
  }
  // eslint-disable-next-line no-use-before-define
  return !$mapHas(a, altValue) && internalDeepEqual(item, curB, looseOpts, channel);
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L441-L447
function setMightHaveLoosePrim(a, b, prim) {
  var altValue = findLooseMatchingPrimitives(prim);
  if (altValue != null) {
    return altValue;
  }
  return $setHas(b, altValue) && !$setHas(a, altValue);
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L518-L533
function mapHasEqualEntry(set, map, key1, item1, opts, channel) {
  var i = getIterator(set);
  var result;
  var key2;
  while ((result = i.next()) && !result.done) {
    key2 = result.value;
    if (
    // eslint-disable-next-line no-use-before-define
    internalDeepEqual(key1, key2, opts, channel)
    // eslint-disable-next-line no-use-before-define
    && internalDeepEqual(item1, $mapGet(map, key2), opts, channel)) {
      $setDelete(set, key2);
      return true;
    }
  }
  return false;
}
function internalDeepEqual(actual, expected, options, channel) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }
  var actualBoxed = whichBoxedPrimitive(actual);
  var expectedBoxed = whichBoxedPrimitive(expected);
  if (actualBoxed !== expectedBoxed) {
    return false;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || _typeof(actual) !== 'object' && _typeof(expected) !== 'object') {
    return opts.strict ? is(actual, expected) : actual == expected; // eslint-disable-line eqeqeq
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // see https://github.com/nodejs/node/commit/d3aafd02efd3a403d646a3044adcf14e63a88d32 for memos/channel inspiration

  var hasActual = channel.has(actual);
  var hasExpected = channel.has(expected);
  var sentinel;
  if (hasActual && hasExpected) {
    if (channel.get(actual) === channel.get(expected)) {
      return true;
    }
  } else {
    sentinel = {};
  }
  if (!hasActual) {
    channel.set(actual, sentinel);
  }
  if (!hasExpected) {
    channel.set(expected, sentinel);
  }

  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts, channel);
}
function isBuffer(x) {
  if (!x || _typeof(x) !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return !!(x.constructor && x.constructor.isBuffer && x.constructor.isBuffer(x));
}
function setEquiv(a, b, opts, channel) {
  if ($setSize(a) !== $setSize(b)) {
    return false;
  }
  var iA = getIterator(a);
  var iB = getIterator(b);
  var resultA;
  var resultB;
  var set;
  while ((resultA = iA.next()) && !resultA.done) {
    if (resultA.value && _typeof(resultA.value) === 'object') {
      if (!set) {
        set = new $Set();
      }
      $setAdd(set, resultA.value);
    } else if (!$setHas(b, resultA.value)) {
      if (opts.strict) {
        return false;
      }
      if (!setMightHaveLoosePrim(a, b, resultA.value)) {
        return false;
      }
      if (!set) {
        set = new $Set();
      }
      $setAdd(set, resultA.value);
    }
  }
  if (set) {
    while ((resultB = iB.next()) && !resultB.done) {
      // We have to check if a primitive value is already matching and only if it's not, go hunting for it.
      if (resultB.value && _typeof(resultB.value) === 'object') {
        if (!setHasEqualElement(set, resultB.value, opts.strict, channel)) {
          return false;
        }
      } else if (!opts.strict && !$setHas(a, resultB.value) && !setHasEqualElement(set, resultB.value, opts.strict, channel)) {
        return false;
      }
    }
    return $setSize(set) === 0;
  }
  return true;
}
function mapEquiv(a, b, opts, channel) {
  if ($mapSize(a) !== $mapSize(b)) {
    return false;
  }
  var iA = getIterator(a);
  var iB = getIterator(b);
  var resultA;
  var resultB;
  var set;
  var key;
  var item1;
  var item2;
  while ((resultA = iA.next()) && !resultA.done) {
    key = resultA.value[0];
    item1 = resultA.value[1];
    if (key && _typeof(key) === 'object') {
      if (!set) {
        set = new $Set();
      }
      $setAdd(set, key);
    } else {
      item2 = $mapGet(b, key);
      if (typeof item2 === 'undefined' && !$mapHas(b, key) || !internalDeepEqual(item1, item2, opts, channel)) {
        if (opts.strict) {
          return false;
        }
        if (!mapMightHaveLoosePrim(a, b, key, item1, opts, channel)) {
          return false;
        }
        if (!set) {
          set = new $Set();
        }
        $setAdd(set, key);
      }
    }
  }
  if (set) {
    while ((resultB = iB.next()) && !resultB.done) {
      key = resultB.value[0];
      item2 = resultB.value[1];
      if (key && _typeof(key) === 'object') {
        if (!mapHasEqualEntry(set, a, key, item2, opts, channel)) {
          return false;
        }
      } else if (!opts.strict && (!a.has(key) || !internalDeepEqual($mapGet(a, key), item2, opts, channel)) && !mapHasEqualEntry(set, a, key, item2, assign({}, opts, {
        strict: false
      }), channel)) {
        return false;
      }
    }
    return $setSize(set) === 0;
  }
  return true;
}
function objEquiv(a, b, opts, channel) {
  /* eslint max-statements: [2, 100], max-lines-per-function: [2, 120], max-depth: [2, 5], max-lines: [2, 400] */
  var i, key;
  if (_typeof(a) !== _typeof(b)) {
    return false;
  }
  if (a == null || b == null) {
    return false;
  }
  if ($objToString(a) !== $objToString(b)) {
    return false;
  }
  if (isArguments(a) !== isArguments(b)) {
    return false;
  }
  var aIsArray = isArray(a);
  var bIsArray = isArray(b);
  if (aIsArray !== bIsArray) {
    return false;
  }

  // TODO: replace when a cross-realm brand check is available
  var aIsError = a instanceof Error;
  var bIsError = b instanceof Error;
  if (aIsError !== bIsError) {
    return false;
  }
  if (aIsError || bIsError) {
    if (a.name !== b.name || a.message !== b.message) {
      return false;
    }
  }
  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) {
    return false;
  }
  if ((aIsRegex || bIsRegex) && (a.source !== b.source || flags(a) !== flags(b))) {
    return false;
  }
  var aIsDate = isDate(a);
  var bIsDate = isDate(b);
  if (aIsDate !== bIsDate) {
    return false;
  }
  if (aIsDate || bIsDate) {
    // && would work too, because both are true or both false here
    if ($getTime(a) !== $getTime(b)) {
      return false;
    }
  }
  if (opts.strict && gPO && gPO(a) !== gPO(b)) {
    return false;
  }
  var aWhich = whichTypedArray(a);
  var bWhich = whichTypedArray(b);
  if (aWhich !== bWhich) {
    return false;
  }
  if (aWhich || bWhich) {
    // && would work too, because both are true or both false here
    if (a.length !== b.length) {
      return false;
    }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) {
        return false;
      }
    }
    return true;
  }
  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) {
    return false;
  }
  if (aIsBuffer || bIsBuffer) {
    // && would work too, because both are true or both false here
    if (a.length !== b.length) {
      return false;
    }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) {
        return false;
      }
    }
    return true;
  }
  var aIsArrayBuffer = isArrayBuffer(a);
  var bIsArrayBuffer = isArrayBuffer(b);
  if (aIsArrayBuffer !== bIsArrayBuffer) {
    return false;
  }
  if (aIsArrayBuffer || bIsArrayBuffer) {
    // && would work too, because both are true or both false here
    if (byteLength(a) !== byteLength(b)) {
      return false;
    }
    return typeof Uint8Array === 'function' && internalDeepEqual(new Uint8Array(a), new Uint8Array(b), opts, channel);
  }
  var aIsSAB = isSharedArrayBuffer(a);
  var bIsSAB = isSharedArrayBuffer(b);
  if (aIsSAB !== bIsSAB) {
    return false;
  }
  if (aIsSAB || bIsSAB) {
    // && would work too, because both are true or both false here
    if (sabByteLength(a) !== sabByteLength(b)) {
      return false;
    }
    return typeof Uint8Array === 'function' && internalDeepEqual(new Uint8Array(a), new Uint8Array(b), opts, channel);
  }
  if (_typeof(a) !== _typeof(b)) {
    return false;
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) {
    return false;
  }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) {
      return false;
    } // eslint-disable-line eqeqeq
  }

  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!internalDeepEqual(a[key], b[key], opts, channel)) {
      return false;
    }
  }
  var aCollection = whichCollection(a);
  var bCollection = whichCollection(b);
  if (aCollection !== bCollection) {
    return false;
  }
  if (aCollection === 'Set' || bCollection === 'Set') {
    // aCollection === bCollection
    return setEquiv(a, b, opts, channel);
  }
  if (aCollection === 'Map') {
    // aCollection === bCollection
    return mapEquiv(a, b, opts, channel);
  }
  return true;
}
module.exports = function deepEqual(a, b, opts) {
  return internalDeepEqual(a, b, opts, getSideChannel());
};

/***/ }),

/***/ 94135:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
var $defineProperty = __webpack_require__(61597);
var $SyntaxError = __webpack_require__(59743);
var $TypeError = __webpack_require__(13237);
var gopd = __webpack_require__(12500);

/** @type {import('.')} */
module.exports = function defineDataProperty(obj, property, value) {
  if (!obj || _typeof(obj) !== 'object' && typeof obj !== 'function') {
    throw new $TypeError('`obj` must be an object or a function`');
  }
  if (typeof property !== 'string' && _typeof(property) !== 'symbol') {
    throw new $TypeError('`property` must be a string or a symbol`');
  }
  if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
    throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
  }
  if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
    throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
  }
  if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
    throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
  }
  if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
    throw new $TypeError('`loose`, if provided, must be a boolean');
  }
  var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
  var nonWritable = arguments.length > 4 ? arguments[4] : null;
  var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
  var loose = arguments.length > 6 ? arguments[6] : false;

  /* @type {false | TypedPropertyDescriptor<unknown>} */
  var desc = !!gopd && gopd(obj, property);
  if ($defineProperty) {
    $defineProperty(obj, property, {
      configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
      enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
      value: value,
      writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
  } else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) {
    // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
  } else {
    throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
  }
};

/***/ }),

/***/ 97614:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(92222);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
var keys = __webpack_require__(38209);
var hasSymbols = typeof Symbol === 'function' && _typeof(Symbol('foo')) === 'symbol';
var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var defineDataProperty = __webpack_require__(94135);
var isFunction = function isFunction(fn) {
  return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};
var supportsDescriptors = __webpack_require__(17536)();
var defineProperty = function defineProperty(object, name, value, predicate) {
  if (name in object) {
    if (predicate === true) {
      if (object[name] === value) {
        return;
      }
    } else if (!isFunction(predicate) || !predicate()) {
      return;
    }
  }
  if (supportsDescriptors) {
    defineDataProperty(object, name, value, true);
  } else {
    defineDataProperty(object, name, value);
  }
};
var defineProperties = function defineProperties(object, map) {
  var predicates = arguments.length > 2 ? arguments[2] : {};
  var props = keys(map);
  if (hasSymbols) {
    props = concat.call(props, Object.getOwnPropertySymbols(map));
  }
  for (var i = 0; i < props.length; i += 1) {
    defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
  }
};
defineProperties.supportsDescriptors = !!supportsDescriptors;
module.exports = defineProperties;

/***/ }),

/***/ 14359:
/***/ ((module) => {

"use strict";


/**
 * @class dE00
 * @classdesc
 * The CIE2000 color difference algorithm.
 * http://en.wikipedia.org/wiki/Color_difference#CIEDE2000
 * @constructs dE00
 * @memberOf DeltaE
 * @property {object} x1 The LAB color configuration object.
 * @property {number} x1.L The lightness value, on scale of 0-100.
 * @property {number} x1.A The chroma value, on scale of -128 to 128.
 * @property {number} x1.B The hue value, on scale of -128 to 128.
 * @property {object} x2 The LAB color configuration object.
 * @property {number} x2.L The lightness value, on scale of 0-100.
 * @property {number} x2.A The chroma value, on scale of -128 to 128.
 * @property {number} x2.B The hue value, on scale of -128 to 128.
 * @property {object} weights The weights configuration object.
 * @property {number} weights.lightness A weight factor to apply to lightness.
 * @property {number} weights.chroma A weight factor to apply to chroma.
 * @property {number} weights.hue A weight factor to apply to hue.
 * @example
 * var deltaE = new dE00(
 *     {L:50, A:50, B:50},
 *     {L:100, A:50, B:50},
 * );
 * console.log(deltaE.getDeltaE());
 */
function dE00(x1, x2, weights) {
  var sqrt = Math.sqrt;
  var pow = Math.pow;
  this.x1 = x1;
  this.x2 = x2;
  this.weights = weights || {};
  this.ksubL = this.weights.lightness || 1;
  this.ksubC = this.weights.chroma || 1;
  this.ksubH = this.weights.hue || 1;

  // Delta L Prime
  this.deltaLPrime = x2.L - x1.L;

  // L Bar
  this.LBar = (x1.L + x2.L) / 2;

  // C1 & C2
  this.C1 = sqrt(pow(x1.A, 2) + pow(x1.B, 2));
  this.C2 = sqrt(pow(x2.A, 2) + pow(x2.B, 2));

  // C Bar
  this.CBar = (this.C1 + this.C2) / 2;

  // A Prime 1
  this.aPrime1 = x1.A + x1.A / 2 * (1 - sqrt(pow(this.CBar, 7) / (pow(this.CBar, 7) + pow(25, 7))));

  // A Prime 2
  this.aPrime2 = x2.A + x2.A / 2 * (1 - sqrt(pow(this.CBar, 7) / (pow(this.CBar, 7) + pow(25, 7))));

  // C Prime 1
  this.CPrime1 = sqrt(pow(this.aPrime1, 2) + pow(x1.B, 2));

  // C Prime 2
  this.CPrime2 = sqrt(pow(this.aPrime2, 2) + pow(x2.B, 2));

  // C Bar Prime
  this.CBarPrime = (this.CPrime1 + this.CPrime2) / 2;

  // Delta C Prime
  this.deltaCPrime = this.CPrime2 - this.CPrime1;

  // S sub L
  this.SsubL = 1 + 0.015 * pow(this.LBar - 50, 2) / sqrt(20 + pow(this.LBar - 50, 2));

  // S sub C
  this.SsubC = 1 + 0.045 * this.CBarPrime;

  /**
   * Properties set in getDeltaE method, for access to convenience functions
   */
  // h Prime 1
  this.hPrime1 = 0;

  // h Prime 2
  this.hPrime2 = 0;

  // Delta h Prime
  this.deltahPrime = 0;

  // Delta H Prime
  this.deltaHPrime = 0;

  // H Bar Prime
  this.HBarPrime = 0;

  // T
  this.T = 0;

  // S sub H
  this.SsubH = 0;

  // R sub T
  this.RsubT = 0;
}

/**
 * Returns the deltaE value.
 * @method
 * @returns {number}
 */
dE00.prototype.getDeltaE = function () {
  var sqrt = Math.sqrt;
  var sin = Math.sin;
  var pow = Math.pow;

  // h Prime 1
  this.hPrime1 = this.gethPrime1();

  // h Prime 2
  this.hPrime2 = this.gethPrime2();

  // Delta h Prime
  this.deltahPrime = this.getDeltahPrime();

  // Delta H Prime
  this.deltaHPrime = 2 * sqrt(this.CPrime1 * this.CPrime2) * sin(this.degreesToRadians(this.deltahPrime) / 2);

  // H Bar Prime
  this.HBarPrime = this.getHBarPrime();

  // T
  this.T = this.getT();

  // S sub H
  this.SsubH = 1 + 0.015 * this.CBarPrime * this.T;

  // R sub T
  this.RsubT = this.getRsubT();

  // Put it all together!
  var lightness = this.deltaLPrime / (this.ksubL * this.SsubL);
  var chroma = this.deltaCPrime / (this.ksubC * this.SsubC);
  var hue = this.deltaHPrime / (this.ksubH * this.SsubH);
  return sqrt(pow(lightness, 2) + pow(chroma, 2) + pow(hue, 2) + this.RsubT * chroma * hue);
};

/**
 * Returns the RT variable calculation.
 * @method
 * @returns {number}
 */
dE00.prototype.getRsubT = function () {
  var sin = Math.sin;
  var sqrt = Math.sqrt;
  var pow = Math.pow;
  var exp = Math.exp;
  return -2 * sqrt(pow(this.CBarPrime, 7) / (pow(this.CBarPrime, 7) + pow(25, 7))) * sin(this.degreesToRadians(60 * exp(-pow((this.HBarPrime - 275) / 25, 2))));
};

/**
 * Returns the T variable calculation.
 * @method
 * @returns {number}
 */
dE00.prototype.getT = function () {
  var cos = Math.cos;
  return 1 - 0.17 * cos(this.degreesToRadians(this.HBarPrime - 30)) + 0.24 * cos(this.degreesToRadians(2 * this.HBarPrime)) + 0.32 * cos(this.degreesToRadians(3 * this.HBarPrime + 6)) - 0.20 * cos(this.degreesToRadians(4 * this.HBarPrime - 63));
};

/**
 * Returns the H Bar Prime variable calculation.
 * @method
 * @returns {number}
 */
dE00.prototype.getHBarPrime = function () {
  var abs = Math.abs;
  if (abs(this.hPrime1 - this.hPrime2) > 180) {
    return (this.hPrime1 + this.hPrime2 + 360) / 2;
  }
  return (this.hPrime1 + this.hPrime2) / 2;
};

/**
 * Returns the Delta h Prime variable calculation.
 * @method
 * @returns {number}
 */
dE00.prototype.getDeltahPrime = function () {
  var abs = Math.abs;

  // When either C′1 or C′2 is zero, then Δh′ is irrelevant and may be set to
  // zero.
  if (0 === this.C1 || 0 === this.C2) {
    return 0;
  }
  if (abs(this.hPrime1 - this.hPrime2) <= 180) {
    return this.hPrime2 - this.hPrime1;
  }
  if (this.hPrime2 <= this.hPrime1) {
    return this.hPrime2 - this.hPrime1 + 360;
  } else {
    return this.hPrime2 - this.hPrime1 - 360;
  }
};

/**
 * Returns the h Prime 1 variable calculation.
 * @method
 * @returns {number}
 */
dE00.prototype.gethPrime1 = function () {
  return this._gethPrimeFn(this.x1.B, this.aPrime1);
};

/**
 * Returns the h Prime 2 variable calculation.
 * @method
 * @returns {number}
 */
dE00.prototype.gethPrime2 = function () {
  return this._gethPrimeFn(this.x2.B, this.aPrime2);
};

/**
 * A helper function to calculate the h Prime 1 and h Prime 2 values.
 * @method
 * @private
 * @returns {number}
 */
dE00.prototype._gethPrimeFn = function (x, y) {
  var hueAngle;
  if (x === 0 && y === 0) {
    return 0;
  }
  hueAngle = this.radiansToDegrees(Math.atan2(x, y));
  if (hueAngle >= 0) {
    return hueAngle;
  } else {
    return hueAngle + 360;
  }
};

/**
 * Gives the radian equivalent of a specified degree angle.
 * @method
 * @returns {number}
 */
dE00.prototype.radiansToDegrees = function (radians) {
  return radians * (180 / Math.PI);
};

/**
 * Gives the degree equivalent of a specified radian.
 * @method
 * @returns {number}
 */
dE00.prototype.degreesToRadians = function (degrees) {
  return degrees * (Math.PI / 180);
};
module.exports = dE00;

/***/ }),

/***/ 33999:
/***/ ((module) => {

"use strict";


/**
 * @class dE76
 * @classdesc
 * The CIE76 color difference algorithm: a simple euclidean distance calculation.
 * http://en.wikipedia.org/wiki/Color_difference#CIE76
 * @constructs dE76
 * @memberOf DeltaE
 * @property {object} x1 The LAB color configuration object.
 * @property {number} x1.L The lightness value, on scale of 0-100.
 * @property {number} x1.A The chroma value, on scale of -128 to 128.
 * @property {number} x1.B The hue value, on scale of -128 to 128.
 * @property {object} x2 The LAB color configuration object.
 * @property {number} x2.L The lightness value, on scale of 0-100.
 * @property {number} x2.A The chroma value, on scale of -128 to 128.
 * @property {number} x2.B The hue value, on scale of -128 to 128.
 * @example
 * var deltaE = new dE76(
 *     {L:50, A:50, B:50},
 *     {L:100, A:50, B:50},
 * );
 * console.log(deltaE.getDeltaE());
 */
function dE76(x1, x2) {
  this.x1 = x1;
  this.x2 = x2;
}

/**
 * Returns the dE76 value.
 * @method
 * @returns {number}
 */
dE76.prototype.getDeltaE = function () {
  var x1 = this.x1;
  var x2 = this.x2;
  return Math.sqrt(Math.pow(x2.L - x1.L, 2) + Math.pow(x2.A - x1.A, 2) + Math.pow(x2.B - x1.B, 2));
};
module.exports = dE76;

/***/ }),

/***/ 87892:
/***/ ((module) => {

"use strict";


/**
 * @class dE94
 * @classdesc
 * The CIE94 algorithm: an iteration of the CIE76 algorithm.
 * http://en.wikipedia.org/wiki/Color_difference#CIE94
 * @constructs dE94
 * @memberOf DeltaE
 * @property {object} x1 The LAB color configuration object.
 * @property {number} x1.L The lightness value, on scale of 0-100.
 * @property {number} x1.A The chroma value, on scale of -128 to 128.
 * @property {number} x1.B The hue value, on scale of -128 to 128.
 * @property {object} x2 The LAB color configuration object.
 * @property {number} x2.L The lightness value, on scale of 0-100.
 * @property {number} x2.A The chroma value, on scale of -128 to 128.
 * @property {number} x2.B The hue value, on scale of -128 to 128.
 * @property {object} weights The weights configuration object.
 * @property {number} weights.lightness A weight factor to apply to lightness.
 * @property {number} weights.chroma A weight factor to apply to chroma.
 * @property {number} weights.hue A weight factor to apply to hue.
 * @example
 * var deltaE = new dE94(
 *     {L:50, A:50, B:50},
 *     {L:100, A:50, B:50},
 * );
 * console.log(deltaE.getDeltaE());
 */
function dE94(x1, x2, weights) {
  this.x1 = x1;
  this.x2 = x2;
  this.weights = weights || {};
  this.weights.lightness = this.weights.lightness || 1;
  this.weights.chroma = this.weights.chroma || 1;
  this.weights.hue = this.weights.hue || 1;
  if (1 === this.weights.lightness) {
    this.weights.K1 = 0.045;
    this.weights.K2 = 0.015;
  } else {
    this.weights.K1 = 0.048;
    this.weights.K2 = 0.014;
  }
}

/**
 * Returns the dE94 value.
 * @method
 * @returns {number}
 */
dE94.prototype.getDeltaE = function () {
  var x1 = this.x1;
  var x2 = this.x2;
  var sqrt = Math.sqrt;
  var pow = Math.pow;
  return sqrt(pow(this.calculateL(x1, x2), 2) + pow(this.calculateA(x1, x2), 2) + pow(this.calculateB(x1, x2), 2));
};

/**
 * Calculates the lightness value.
 * @method
 * @returns {number}
 */
dE94.prototype.calculateL = function (x1, x2) {
  return (x1.L - x2.L) / this.weights.lightness;
};

/**
 * Calculates the chroma value.
 * @method
 * @returns {number}
 */
dE94.prototype.calculateA = function (x1, x2) {
  var sqrt = Math.sqrt;
  var pow = Math.pow;

  //top
  var c1 = sqrt(pow(x1.A, 2) + pow(x1.B, 2));
  var c2 = sqrt(pow(x2.A, 2) + pow(x2.B, 2));
  var cab = c1 - c2;

  // bottom
  var sc = 1 + this.weights.K1 * c1;
  return cab / (this.weights.chroma * sc);
};

/**
 * Calculates the hue value.
 * @method
 * @returns {number}
 */
dE94.prototype.calculateB = function (x1, x2) {
  var sqrt = Math.sqrt;
  var pow = Math.pow;

  // cab
  var c1 = sqrt(pow(x1.A, 2) + pow(x1.B, 2));
  var c2 = sqrt(pow(x2.A, 2) + pow(x2.B, 2));
  var cab = c1 - c2;

  // top
  var a = x1.A - x2.A;
  var b = x1.B - x2.B;
  var hab = sqrt(pow(a, 2) + pow(b, 2) - pow(cab, 2));

  // bottom
  var c1 = sqrt(pow(x1.A, 2) + pow(x1.B, 2));
  var sh = 1 + this.weights.K2 * c1;
  return hab / sh;
};
module.exports = dE94;

/***/ }),

/***/ 24508:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/**
 * @class DeltaE
 * @classdesc
 * A package of dE76, dE94, and dE00 algorithms.
 * @constructs DeltaE
 * @example
 * var DeltaE = new DeltaE();
 * var labColor1 = {L: 50, A: 50, B: 50};
 * var labColor2 = {L: 20, A: 20, B: 20};
 * 
 * DeltaE.getDeltaE94(labColor1, labColor2);
 */
var dE76 = __webpack_require__(33999);
var dE94 = __webpack_require__(87892);
var dE00 = __webpack_require__(14359);
function DeltaE() {}

/**
 * The CIE76 color difference algorithm: a simple euclidean distance calculation.
 * http://en.wikipedia.org/wiki/Color_difference#CIE76
 * @property {object} x1 The LAB color configuration object.
 * @property {number} x1.L The lightness value, on scale of 0-100.
 * @property {number} x1.A The chroma value, on scale of -128 to 128.
 * @property {number} x1.B The hue value, on scale of -128 to 128.
 * @property {object} x2 The LAB color configuration object.
 * @property {number} x2.L The lightness value, on scale of 0-100.
 * @property {number} x2.A The chroma value, on scale of -128 to 128.
 * @property {number} x2.B The hue value, on scale of -128 to 128.
 * @returns {number} The computed dE76 value.
 * @example
 * var labColor1 = {L: 50, A: 50, B: 50};
 * var labColor2 = {L: 20, A: 20, B: 20};
 * 
 * DeltaE.getDeltaE76(labColor1, labColor2);
 */
DeltaE.prototype.getDeltaE76 = function (lab1, lab2) {
  var deltaE = new dE76(lab1, lab2);
  return deltaE.getDeltaE();
};

/**
 * The CIE94 algorithm: an iteration of the CIE76 algorithm.
 * http://en.wikipedia.org/wiki/Color_difference#CIE94
 * @property {object} x1 The LAB color configuration object.
 * @property {number} x1.L The lightness value, on scale of 0-100.
 * @property {number} x1.A The chroma value, on scale of -128 to 128.
 * @property {number} x1.B The hue value, on scale of -128 to 128.
 * @property {object} x2 The LAB color configuration object.
 * @property {number} x2.L The lightness value, on scale of 0-100.
 * @property {number} x2.A The chroma value, on scale of -128 to 128.
 * @property {number} x2.B The hue value, on scale of -128 to 128.
 * @property {object} weights The weights configuration object.
 * @property {number} weights.lightness A weight factor to apply to lightness.
 * @property {number} weights.chroma A weight factor to apply to chroma.
 * @property {number} weights.hue A weight factor to apply to hue.
 * @returns {number} The computed dE94 value.
 * @example
 * var labColor1 = {L: 50, A: 50, B: 50};
 * var labColor2 = {L: 20, A: 20, B: 20};
 * 
 * DeltaE.getDeltaE94(labColor1, labColor2);
 */
DeltaE.prototype.getDeltaE94 = function (lab1, lab2) {
  var deltaE = new dE94(lab1, lab2);
  return deltaE.getDeltaE();
};

/**
 * The CIE2000 color difference algorithm.
 * http://en.wikipedia.org/wiki/Color_difference#CIEDE2000
 * @property {object} x1 The LAB color configuration object.
 * @property {number} x1.L The lightness value, on scale of 0-100.
 * @property {number} x1.A The chroma value, on scale of -128 to 128.
 * @property {number} x1.B The hue value, on scale of -128 to 128.
 * @property {object} x2 The LAB color configuration object.
 * @property {number} x2.L The lightness value, on scale of 0-100.
 * @property {number} x2.A The chroma value, on scale of -128 to 128.
 * @property {number} x2.B The hue value, on scale of -128 to 128.
 * @property {object} weights The weights configuration object.
 * @property {number} weights.lightness A weight factor to apply to lightness.
 * @property {number} weights.chroma A weight factor to apply to chroma.
 * @property {number} weights.hue A weight factor to apply to hue.
 * @returns {number} The computed dE00 value.
 * @example
 * var labColor1 = {L: 50, A: 50, B: 50};
 * var labColor2 = {L: 20, A: 20, B: 20};
 * 
 * DeltaE.getDeltaE00(labColor1, labColor2);
 */
DeltaE.prototype.getDeltaE00 = function (lab1, lab2) {
  var deltaE = new dE00(lab1, lab2);
  return deltaE.getDeltaE();
};
module.exports = new DeltaE();

/***/ }),

/***/ 24787:
/***/ ((module) => {

module.exports = false;

/***/ }),

/***/ 50172:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;__webpack_require__(74916);
__webpack_require__(23123);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
!function (t, n) {
  "object" == ( false ? 0 : _typeof(exports)) && "undefined" != "object" ? module.exports = function (t, n, e, i, o) {
    for (n = n.split ? n.split(".") : n, i = 0; i < n.length; i++) {
      t = t ? t[n[i]] : o;
    }
    return t === o ? e : t;
  } :  true ? !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    return function (t, n, e, i, o) {
      for (n = n.split ? n.split(".") : n, i = 0; i < n.length; i++) {
        t = t ? t[n[i]] : o;
      }
      return t === o ? e : t;
    };
  }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : 0;
}(this);

/***/ }),

/***/ 61157:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


__webpack_require__(69600);
__webpack_require__(54747);
__webpack_require__(21249);
__webpack_require__(47941);
var prefix = __webpack_require__(49101);
var isArray = __webpack_require__(20173);
var properties = __webpack_require__(98496);
var applyDefaultUnit = __webpack_require__(66563);
var _has = Object.prototype.hasOwnProperty;
var transformProp = prefix('transform');
var propNameAliases = {
  x: 'translateX',
  y: 'translateY',
  z: 'translateZ',
  origin: 'transformOrigin'
};
exports = module.exports = transform;
function transform(target, opts) {
  var transformOutput = [];
  var propName;
  var propValue;
  var propData;
  replaceAliases(opts);
  for (propName in opts) {
    if (!_has.call(opts, propName)) continue;
    propValue = opts[propName];

    // If it's a transform property.
    if (_has.call(properties.transform, propName)) {
      propData = properties.transform[propName];
      if (isArray(propValue)) {
        propValue = propValue.join(propData.separator);
      }
      transformOutput.push(propName + '(' + applyDefaultUnit(propValue, propData.defaultUnit, propData.separator) + ')');
      continue;
    }

    // For other properties like transform-origin.
    if (_has.call(properties, propName)) {
      propData = properties[propName];
      if (isArray(propValue)) {
        propValue = propValue.join(propData.separator);
      }
      target.style[prefix(propName)] = applyDefaultUnit(propValue, propData.defaultUnit, propData.separator);
      continue;
    }
    console.warn('dom-transform: this property (`' + propName + '`) is not supported.');
  }

  // Apply transform property values.
  target.style[transformProp] = transformOutput.join(' ');
}
exports.get = get;
function get(target, props) {
  var s = target.style;
  if (typeof props === 'string') {
    if (_has.call(properties.transform, props)) {
      return s[transformProp];
    }
    return s[prefix(props)];
  }
  if (!props) {
    props = getPropertiesName();
  }
  var values = {};
  props.forEach(function (propName) {
    values[propName] = s[prefix(propName)];
  });
  return values;
}
exports.reset = reset;
function reset(target, props) {
  var s = target.style;
  if (typeof props === 'string') {
    s[prefix(props)] = null;
    return;
  }
  if (!props) {
    props = getPropertiesName();
  }
  props.forEach(function (propName) {
    s[prefix(propName)] = null;
  });
}
exports.isSupported = isSupported;
function isSupported() {
  return transformProp.length > 0;
}
function replaceAliases(obj) {
  var propName;
  for (propName in obj) {
    if (_has.call(propNameAliases, propName)) {
      obj[propNameAliases[propName]] = obj[propName];
      delete obj[propName];
    }
  }
}
function getPropertiesName() {
  return Object.keys(properties).map(function (propName) {
    return propName;
  });
}

/***/ }),

/***/ 66563:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(24603);
__webpack_require__(74916);
__webpack_require__(39714);
__webpack_require__(23123);
__webpack_require__(69600);
__webpack_require__(21249);
var trim = __webpack_require__(59875);
var NUMBER_REGEX = /^-?\d+(\.\d+)?$/;
module.exports = function (value, unit, separator) {
  separator = separator || ',';
  if (typeof value === 'number') {
    return '' + value + unit;
  }

  // Allow to use either the defined separator or space
  // to delimitate the values.
  // Ex: '10 10' or '10, 10'.
  var separatorRegExp = new RegExp(separator, 'g');
  var values = value.split(separatorRegExp.test(value) ? separator : ' ');
  return values.map(function (v) {
    v = trim(v);
    if (NUMBER_REGEX.test(v)) {
      v += unit;
    }
    return v;
  }).join(separator);
};

/***/ }),

/***/ 98496:
/***/ ((module) => {

"use strict";


module.exports = {
  transform: {
    translate: {
      defaultUnit: 'px'
    },
    translate3d: {
      defaultUnit: 'px'
    },
    translateX: {
      defaultUnit: 'px'
    },
    translateY: {
      defaultUnit: 'px'
    },
    translateZ: {
      defaultUnit: 'px'
    },
    scale: {
      defaultUnit: ''
    },
    scale3d: {
      defaultUnit: ''
    },
    scaleX: {
      defaultUnit: ''
    },
    scaleY: {
      defaultUnit: ''
    },
    scaleZ: {
      defaultUnit: ''
    },
    rotate: {
      defaultUnit: 'deg'
    },
    rotate3d: {
      defaultUnit: ''
    },
    rotateX: {
      defaultUnit: 'deg'
    },
    rotateY: {
      defaultUnit: 'deg'
    },
    rotateZ: {
      defaultUnit: 'deg'
    },
    skew: {
      defaultUnit: 'deg'
    },
    skewX: {
      defaultUnit: 'deg'
    },
    skewY: {
      defaultUnit: 'deg'
    },
    perspective: {
      defaultUnit: 'px'
    },
    matrix: {
      defaultUnit: ''
    },
    matrix3d: {
      defaultUnit: ''
    }
  },
  transformOrigin: {
    defaultUnit: 'px',
    separator: ' '
  }
};

/***/ }),

/***/ 27266:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;__webpack_require__(74916);
__webpack_require__(23123);
__webpack_require__(66992);
__webpack_require__(41539);
__webpack_require__(82472);
__webpack_require__(92990);
__webpack_require__(18927);
__webpack_require__(33105);
__webpack_require__(35035);
__webpack_require__(74345);
__webpack_require__(7174);
__webpack_require__(32846);
__webpack_require__(44731);
__webpack_require__(77209);
__webpack_require__(96319);
__webpack_require__(58867);
__webpack_require__(37789);
__webpack_require__(33739);
__webpack_require__(29368);
__webpack_require__(14483);
__webpack_require__(12056);
__webpack_require__(3462);
__webpack_require__(30678);
__webpack_require__(27462);
__webpack_require__(33824);
__webpack_require__(55021);
__webpack_require__(12974);
__webpack_require__(15016);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(60285);
__webpack_require__(41637);
__webpack_require__(15306);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
// https://github.com/rndme/download

(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(this, function () {
  return function download(data, strFileName, strMimeType) {
    var self = window,
      // this script is only for browsers anyway...
      defaultMime = "application/octet-stream",
      // this default mime also triggers iframe downloads
      mimeType = strMimeType || defaultMime,
      payload = data,
      url = !strFileName && !strMimeType && payload,
      anchor = document.createElement("a"),
      toString = function toString(a) {
        return String(a);
      },
      myBlob = self.Blob || self.MozBlob || self.WebKitBlob || toString,
      fileName = strFileName || "download",
      blob,
      reader;
    myBlob = myBlob.call ? myBlob.bind(self) : Blob;
    if (String(this) === "true") {
      //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
      payload = [payload, mimeType];
      mimeType = payload[0];
      payload = payload[1];
    }
    if (url && url.length < 2048) {
      // if no filename and no mime, assume a url was passed as the only argument
      fileName = url.split("/").pop().split("?")[0];
      anchor.href = url; // assign href prop to temp anchor
      if (anchor.href.indexOf(url) !== -1) {
        // if the browser determines that it's a potentially valid url path:
        var ajax = new XMLHttpRequest();
        ajax.open("GET", url, true);
        ajax.responseType = 'blob';
        ajax.onload = function (e) {
          download(e.target.response, fileName, defaultMime);
        };
        setTimeout(function () {
          ajax.send();
        }, 0); // allows setting custom ajax headers using the return:
        return ajax;
      } // end if valid url?
    } // end if url?

    //go ahead and download dataURLs right away
    if (/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)) {
      if (payload.length > 1024 * 1024 * 1.999 && myBlob !== toString) {
        payload = dataUrlToBlob(payload);
        mimeType = payload.type || defaultMime;
      } else {
        return navigator.msSaveBlob ?
        // IE10 can't do a[download], only Blobs:
        navigator.msSaveBlob(dataUrlToBlob(payload), fileName) : saver(payload); // everyone else can save dataURLs un-processed
      }
    } else {
      //not data url, is it a string with special needs?
      if (/([\x80-\xff])/.test(payload)) {
        var i = 0,
          tempUiArr = new Uint8Array(payload.length),
          mx = tempUiArr.length;
        for (i; i < mx; ++i) {
          tempUiArr[i] = payload.charCodeAt(i);
        }
        payload = new myBlob([tempUiArr], {
          type: mimeType
        });
      }
    }
    blob = payload instanceof myBlob ? payload : new myBlob([payload], {
      type: mimeType
    });
    function dataUrlToBlob(strUrl) {
      var parts = strUrl.split(/[:;,]/),
        type = parts[1],
        decoder = parts[2] == "base64" ? atob : decodeURIComponent,
        binData = decoder(parts.pop()),
        mx = binData.length,
        i = 0,
        uiArr = new Uint8Array(mx);
      for (i; i < mx; ++i) {
        uiArr[i] = binData.charCodeAt(i);
      }
      return new myBlob([uiArr], {
        type: type
      });
    }
    function saver(url, winMode) {
      if ('download' in anchor) {
        //html5 A[download]
        anchor.href = url;
        anchor.setAttribute("download", fileName);
        anchor.className = "download-js-link";
        anchor.innerHTML = "downloading...";
        anchor.style.display = "none";
        document.body.appendChild(anchor);
        setTimeout(function () {
          anchor.click();
          document.body.removeChild(anchor);
          if (winMode === true) {
            setTimeout(function () {
              self.URL.revokeObjectURL(anchor.href);
            }, 250);
          }
        }, 66);
        return true;
      }

      // handle non-a[download] safari as best we can:
      if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
        if (/^data:/.test(url)) url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
        if (!window.open(url)) {
          // popup blocked, offer direct download:
          if (confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")) {
            location.href = url;
          }
        }
        return true;
      }

      //do iframe dataURL download (old ch+FF):
      var f = document.createElement("iframe");
      document.body.appendChild(f);
      if (!winMode && /^data:/.test(url)) {
        // force a mime that will download:
        url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
      }
      f.src = url;
      setTimeout(function () {
        document.body.removeChild(f);
      }, 333);
    } //end saver

    if (navigator.msSaveBlob) {
      // IE10+ : (has Blob, but not a[download] or URL)
      return navigator.msSaveBlob(blob, fileName);
    }
    if (self.URL) {
      // simple fast and modern way using Blob and URL:
      saver(self.URL.createObjectURL(blob), true);
    } else {
      // handle non-Blob()+non-URL browsers:
      if (typeof blob === "string" || blob.constructor === toString) {
        try {
          return saver("data:" + mimeType + ";base64," + self.btoa(blob));
        } catch (y) {
          return saver("data:" + mimeType + "," + encodeURIComponent(blob));
        }
      }

      // Blob but not URL support:
      reader = new FileReader();
      reader.onload = function (e) {
        saver(this.result);
      };
      reader.readAsDataURL(blob);
    }
    return true;
  }; /* end download() */
});

/***/ }),

/***/ 52382:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__(13423)["Buffer"];
__webpack_require__(44048);
__webpack_require__(9653);
__webpack_require__(41539);
__webpack_require__(2707);
__webpack_require__(47941);
__webpack_require__(57327);
var SlowBuffer = __webpack_require__(13423).SlowBuffer;

/*
 * Returns true if the values `a` and `b` are equal.
 *
 * Support for circular structures is implemented through the `seen` argument,
 * expected to be an object with the following signature: `{ a: [], b: [] }`.
 */
function compare(a, b, seen) {
  if (a === b) {
    return true;
  }
  if (Number.isNaN(a)) {
    return Number.isNaN(b);
  }

  // primitive values would have caused the call to return by now, if they
  // were equal
  if (!(a instanceof Object)) {
    return false;
  }
  var type = Object.prototype.toString.call(a);
  if (Object.prototype.toString.call(b) !== type) {
    return false;
  }
  var keys = Object.keys(a).sort(),
    other = Object.keys(b).sort();
  for (var i = 0; i < keys.length; i++) {
    if (keys[i] !== other[i]) {
      return false;
    }
  }
  var index = seen.a.indexOf(a);
  if (index > -1) {
    return seen.b.indexOf(b) === index;
  }
  seen.a.push(a);
  seen.b.push(b);
  if (type === '[object Error]') {
    var first = Error.prototype.toString.call(a),
      second = Error.prototype.toString.call(b);
    if (first !== second) {
      return false;
    }
  } else if (type === '[object RegExp]') {
    if (a.source !== b.source || a.global !== b.global || a.multiline !== b.multiline || a.ignoreCase !== b.ignoreCase) {
      return false;
    }
  } else if (type === '[object Date]') {
    if (a.getTime() !== b.getTime()) {
      return false;
    }
  } else if (type === '[object Boolean]' || type === '[object Number]' || type === '[object String]') {
    if (!equal(a.valueOf(), b.valueOf())) {
      return false;
    }
  } else if (Buffer.isBuffer(a)) {
    if (a instanceof Buffer && !(b instanceof Buffer) || a instanceof SlowBuffer && !(b instanceof SlowBuffer)) {
      return false;
    }

    // discard keys relating to the underlying storage
    keys = keys.filter(function (key) {
      if (a instanceof SlowBuffer) {
        return key !== 'used';
      }
      return key !== 'parent' && key !== 'offset';
    });
  }
  return keys.reduce(function (ok, key) {
    return ok && compare(a[key], b[key], seen);
  }, true);
}

/*
 * Simple wrapper for `compare`.
 */
function equal(a, b) {
  return compare(a, b, {
    a: [],
    b: []
  });
}
module.exports = equal;

/***/ }),

/***/ 61597:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(37555);

/** @type {import('.')} */
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true) || false;
if ($defineProperty) {
  try {
    $defineProperty({}, 'a', {
      value: 1
    });
  } catch (e) {
    // IE 8 has a broken defineProperty
    $defineProperty = false;
  }
}
module.exports = $defineProperty;

/***/ }),

/***/ 36891:
/***/ ((module) => {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;

/***/ }),

/***/ 4468:
/***/ ((module) => {

"use strict";


/** @type {import('.')} */
module.exports = Error;

/***/ }),

/***/ 77754:
/***/ ((module) => {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;

/***/ }),

/***/ 14025:
/***/ ((module) => {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;

/***/ }),

/***/ 59743:
/***/ ((module) => {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;

/***/ }),

/***/ 13237:
/***/ ((module) => {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;

/***/ }),

/***/ 35725:
/***/ ((module) => {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;

/***/ }),

/***/ 34111:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/*!
 * escape-html
 * Copyright(c) 2012-2013 TJ Holowaychuk
 * Copyright(c) 2015 Andreas Lubbe
 * Copyright(c) 2015 Tiancheng "Timothy" Gu
 * MIT Licensed
 */



/**
 * Module variables.
 * @private
 */
__webpack_require__(74916);
var matchHtmlRegExp = /["'&<>]/;

/**
 * Module exports.
 * @public
 */

module.exports = escapeHtml;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);
  if (!match) {
    return str;
  }
  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;
  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#39;';
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }
    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }
    lastIndex = index + 1;
    html += escape;
  }
  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}

/***/ }),

/***/ 94092:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



__webpack_require__(36535);
__webpack_require__(67556);
__webpack_require__(82526);
__webpack_require__(92222);
__webpack_require__(36210);
__webpack_require__(44048);
__webpack_require__(9653);
__webpack_require__(30489);
__webpack_require__(68309);
__webpack_require__(47941);
__webpack_require__(41539);
__webpack_require__(47042);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
var R = (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === 'object' ? Reflect : null;
var ReflectApply = R && typeof R.apply === 'function' ? R.apply : function ReflectApply(target, receiver, args) {
  return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys;
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys;
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}
function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}
var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
};
function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;
function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + _typeof(listener));
  }
}
Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function get() {
    return defaultMaxListeners;
  },
  set: function set(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});
EventEmitter.init = function () {
  if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }
  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};
function _getMaxListeners(that) {
  if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) {
    args.push(arguments[i]);
  }
  var doError = type === 'error';
  var events = this._events;
  if (events !== undefined) doError = doError && events.error === undefined;else if (!doError) return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0) er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];
  if (handler === undefined) return false;
  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i) {
      ReflectApply(listeners[i], this, args);
    }
  }
  return true;
};
function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;
  checkListener(listener);
  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type, listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }
  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] = prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }
  return target;
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function prependListener(type, listener) {
  return _addListener(this, type, listener, true);
};
function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0) return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}
function _onceWrap(target, type, listener) {
  var state = {
    fired: false,
    wrapFn: undefined,
    target: target,
    type: type,
    listener: listener
  };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}
EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};
EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
  checkListener(listener);
  this.prependListener(type, _onceWrap(this, type, listener));
  return this;
};

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener = function removeListener(type, listener) {
  var list, events, position, i, originalListener;
  checkListener(listener);
  events = this._events;
  if (events === undefined) return this;
  list = events[type];
  if (list === undefined) return this;
  if (list === listener || list.listener === listener) {
    if (--this._eventsCount === 0) this._events = Object.create(null);else {
      delete events[type];
      if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
    }
  } else if (typeof list !== 'function') {
    position = -1;
    for (i = list.length - 1; i >= 0; i--) {
      if (list[i] === listener || list[i].listener === listener) {
        originalListener = list[i].listener;
        position = i;
        break;
      }
    }
    if (position < 0) return this;
    if (position === 0) list.shift();else {
      spliceOne(list, position);
    }
    if (list.length === 1) events[type] = list[0];
    if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
  }
  return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
  var listeners, events, i;
  events = this._events;
  if (events === undefined) return this;

  // not listening for removeListener, no need to emit
  if (events.removeListener === undefined) {
    if (arguments.length === 0) {
      this._events = Object.create(null);
      this._eventsCount = 0;
    } else if (events[type] !== undefined) {
      if (--this._eventsCount === 0) this._events = Object.create(null);else delete events[type];
    }
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    var keys = Object.keys(events);
    var key;
    for (i = 0; i < keys.length; ++i) {
      key = keys[i];
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = Object.create(null);
    this._eventsCount = 0;
    return this;
  }
  listeners = events[type];
  if (typeof listeners === 'function') {
    this.removeListener(type, listeners);
  } else if (listeners !== undefined) {
    // LIFO order
    for (i = listeners.length - 1; i >= 0; i--) {
      this.removeListener(type, listeners[i]);
    }
  }
  return this;
};
function _listeners(target, type, unwrap) {
  var events = target._events;
  if (events === undefined) return [];
  var evlistener = events[type];
  if (evlistener === undefined) return [];
  if (typeof evlistener === 'function') return unwrap ? [evlistener.listener || evlistener] : [evlistener];
  return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}
EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};
EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};
EventEmitter.listenerCount = function (emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;
  if (events !== undefined) {
    var evlistener = events[type];
    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }
  return 0;
}
EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i) {
    copy[i] = arr[i];
  }
  return copy;
}
function spliceOne(list, index) {
  for (; index + 1 < list.length; index++) {
    list[index] = list[index + 1];
  }
  list.pop();
}
function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}
function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }
    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    }
    ;
    eventTargetAgnosticAddListener(emitter, name, resolver, {
      once: true
    });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, {
        once: true
      });
    }
  });
}
function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}
function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + _typeof(emitter));
  }
}

/***/ }),

/***/ 40040:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(41539);
__webpack_require__(38880);
__webpack_require__(68309);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;
var isArray = function isArray(arr) {
  if (typeof Array.isArray === 'function') {
    return Array.isArray(arr);
  }
  return toStr.call(arr) === '[object Array]';
};
var isPlainObject = function isPlainObject(obj) {
  if (!obj || toStr.call(obj) !== '[object Object]') {
    return false;
  }
  var hasOwnConstructor = hasOwn.call(obj, 'constructor');
  var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
  // Not own constructor property must be Object
  if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
    return false;
  }

  // Own properties are enumerated firstly, so to speed up,
  // if last one is own, then all properties are own.
  var key;
  for (key in obj) {/**/}
  return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
  if (defineProperty && options.name === '__proto__') {
    defineProperty(target, options.name, {
      enumerable: true,
      configurable: true,
      value: options.newValue,
      writable: true
    });
  } else {
    target[options.name] = options.newValue;
  }
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
  if (name === '__proto__') {
    if (!hasOwn.call(obj, name)) {
      return void 0;
    } else if (gOPD) {
      // In early versions of node, obj['__proto__'] is buggy when obj has
      // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
      return gOPD(obj, name).value;
    }
  }
  return obj[name];
};
module.exports = function extend() {
  var options, name, src, copy, copyIsArray, clone;
  var target = arguments[0];
  var i = 1;
  var length = arguments.length;
  var deep = false;

  // Handle a deep copy situation
  if (typeof target === 'boolean') {
    deep = target;
    target = arguments[1] || {};
    // skip the boolean and the target
    i = 2;
  }
  if (target == null || _typeof(target) !== 'object' && typeof target !== 'function') {
    target = {};
  }
  for (; i < length; ++i) {
    options = arguments[i];
    // Only deal with non-null/undefined values
    if (options != null) {
      // Extend the base object
      for (name in options) {
        src = getProperty(target, name);
        copy = getProperty(options, name);

        // Prevent never-ending loop
        if (target !== copy) {
          // Recurse if we're merging plain objects or arrays
          if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
            if (copyIsArray) {
              copyIsArray = false;
              clone = src && isArray(src) ? src : [];
            } else {
              clone = src && isPlainObject(src) ? src : {};
            }

            // Never move original objects, clone them
            setProperty(target, {
              name: name,
              newValue: extend(deep, clone, copy)
            });

            // Don't bring in undefined values
          } else if (typeof copy !== 'undefined') {
            setProperty(target, {
              name: name,
              newValue: copy
            });
          }
        }
      }
    }
  }

  // Return the modified object
  return target;
};

/***/ }),

/***/ 87790:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
__webpack_require__(47042);
__webpack_require__(40561);
/**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */
var DIFF_DELETE = -1;
var DIFF_INSERT = 1;
var DIFF_EQUAL = 0;

/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int|Object} [cursor_pos] Edit position in text1 or object with more info
 * @return {Array} Array of diff tuples.
 */
function diff_main(text1, text2, cursor_pos, _fix_unicode) {
  // Check for equality
  if (text1 === text2) {
    if (text1) {
      return [[DIFF_EQUAL, text1]];
    }
    return [];
  }
  if (cursor_pos != null) {
    var editdiff = find_cursor_edit_diff(text1, text2, cursor_pos);
    if (editdiff) {
      return editdiff;
    }
  }

  // Trim off common prefix (speedup).
  var commonlength = diff_commonPrefix(text1, text2);
  var commonprefix = text1.substring(0, commonlength);
  text1 = text1.substring(commonlength);
  text2 = text2.substring(commonlength);

  // Trim off common suffix (speedup).
  commonlength = diff_commonSuffix(text1, text2);
  var commonsuffix = text1.substring(text1.length - commonlength);
  text1 = text1.substring(0, text1.length - commonlength);
  text2 = text2.substring(0, text2.length - commonlength);

  // Compute the diff on the middle block.
  var diffs = diff_compute_(text1, text2);

  // Restore the prefix and suffix.
  if (commonprefix) {
    diffs.unshift([DIFF_EQUAL, commonprefix]);
  }
  if (commonsuffix) {
    diffs.push([DIFF_EQUAL, commonsuffix]);
  }
  diff_cleanupMerge(diffs, _fix_unicode);
  return diffs;
}
;

/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */
function diff_compute_(text1, text2) {
  var diffs;
  if (!text1) {
    // Just add some text (speedup).
    return [[DIFF_INSERT, text2]];
  }
  if (!text2) {
    // Just delete some text (speedup).
    return [[DIFF_DELETE, text1]];
  }
  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  var i = longtext.indexOf(shorttext);
  if (i !== -1) {
    // Shorter text is inside the longer text (speedup).
    diffs = [[DIFF_INSERT, longtext.substring(0, i)], [DIFF_EQUAL, shorttext], [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
    // Swap insertions for deletions if diff is reversed.
    if (text1.length > text2.length) {
      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
    }
    return diffs;
  }
  if (shorttext.length === 1) {
    // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
  }

  // Check to see if the problem can be split in two.
  var hm = diff_halfMatch_(text1, text2);
  if (hm) {
    // A half-match was found, sort out the return data.
    var text1_a = hm[0];
    var text1_b = hm[1];
    var text2_a = hm[2];
    var text2_b = hm[3];
    var mid_common = hm[4];
    // Send both pairs off for separate processing.
    var diffs_a = diff_main(text1_a, text2_a);
    var diffs_b = diff_main(text1_b, text2_b);
    // Merge the results.
    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
  }
  return diff_bisect_(text1, text2);
}
;

/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */
function diff_bisect_(text1, text2) {
  // Cache the text lengths to prevent multiple calls.
  var text1_length = text1.length;
  var text2_length = text2.length;
  var max_d = Math.ceil((text1_length + text2_length) / 2);
  var v_offset = max_d;
  var v_length = 2 * max_d;
  var v1 = new Array(v_length);
  var v2 = new Array(v_length);
  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
  // integers and undefined.
  for (var x = 0; x < v_length; x++) {
    v1[x] = -1;
    v2[x] = -1;
  }
  v1[v_offset + 1] = 0;
  v2[v_offset + 1] = 0;
  var delta = text1_length - text2_length;
  // If the total number of characters is odd, then the front path will collide
  // with the reverse path.
  var front = delta % 2 !== 0;
  // Offsets for start and end of k loop.
  // Prevents mapping of space beyond the grid.
  var k1start = 0;
  var k1end = 0;
  var k2start = 0;
  var k2end = 0;
  for (var d = 0; d < max_d; d++) {
    // Walk the front path one step.
    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
      var k1_offset = v_offset + k1;
      var x1;
      if (k1 === -d || k1 !== d && v1[k1_offset - 1] < v1[k1_offset + 1]) {
        x1 = v1[k1_offset + 1];
      } else {
        x1 = v1[k1_offset - 1] + 1;
      }
      var y1 = x1 - k1;
      while (x1 < text1_length && y1 < text2_length && text1.charAt(x1) === text2.charAt(y1)) {
        x1++;
        y1++;
      }
      v1[k1_offset] = x1;
      if (x1 > text1_length) {
        // Ran off the right of the graph.
        k1end += 2;
      } else if (y1 > text2_length) {
        // Ran off the bottom of the graph.
        k1start += 2;
      } else if (front) {
        var k2_offset = v_offset + delta - k1;
        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] !== -1) {
          // Mirror x2 onto top-left coordinate system.
          var x2 = text1_length - v2[k2_offset];
          if (x1 >= x2) {
            // Overlap detected.
            return diff_bisectSplit_(text1, text2, x1, y1);
          }
        }
      }
    }

    // Walk the reverse path one step.
    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
      var k2_offset = v_offset + k2;
      var x2;
      if (k2 === -d || k2 !== d && v2[k2_offset - 1] < v2[k2_offset + 1]) {
        x2 = v2[k2_offset + 1];
      } else {
        x2 = v2[k2_offset - 1] + 1;
      }
      var y2 = x2 - k2;
      while (x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) === text2.charAt(text2_length - y2 - 1)) {
        x2++;
        y2++;
      }
      v2[k2_offset] = x2;
      if (x2 > text1_length) {
        // Ran off the left of the graph.
        k2end += 2;
      } else if (y2 > text2_length) {
        // Ran off the top of the graph.
        k2start += 2;
      } else if (!front) {
        var k1_offset = v_offset + delta - k2;
        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] !== -1) {
          var x1 = v1[k1_offset];
          var y1 = v_offset + x1 - k1_offset;
          // Mirror x2 onto top-left coordinate system.
          x2 = text1_length - x2;
          if (x1 >= x2) {
            // Overlap detected.
            return diff_bisectSplit_(text1, text2, x1, y1);
          }
        }
      }
    }
  }
  // Diff took too long and hit the deadline or
  // number of diffs equals number of characters, no commonality at all.
  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
}
;

/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */
function diff_bisectSplit_(text1, text2, x, y) {
  var text1a = text1.substring(0, x);
  var text2a = text2.substring(0, y);
  var text1b = text1.substring(x);
  var text2b = text2.substring(y);

  // Compute both diffs serially.
  var diffs = diff_main(text1a, text2a);
  var diffsb = diff_main(text1b, text2b);
  return diffs.concat(diffsb);
}
;

/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */
function diff_commonPrefix(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 || text1.charAt(0) !== text2.charAt(0)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerstart = 0;
  while (pointermin < pointermid) {
    if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
      pointermin = pointermid;
      pointerstart = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  if (is_surrogate_pair_start(text1.charCodeAt(pointermid - 1))) {
    pointermid--;
  }
  return pointermid;
}
;

/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */
function diff_commonSuffix(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 || text1.slice(-1) !== text2.slice(-1)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerend = 0;
  while (pointermin < pointermid) {
    if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
      pointermin = pointermid;
      pointerend = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  if (is_surrogate_pair_end(text1.charCodeAt(text1.length - pointermid))) {
    pointermid--;
  }
  return pointermid;
}
;

/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */
function diff_halfMatch_(text1, text2) {
  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
    return null; // Pointless.
  }

  /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */
  function diff_halfMatchI_(longtext, shorttext, i) {
    // Start with a 1/4 length substring at position i as a seed.
    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
    var j = -1;
    var best_common = '';
    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
    while ((j = shorttext.indexOf(seed, j + 1)) !== -1) {
      var prefixLength = diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
      var suffixLength = diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
      if (best_common.length < suffixLength + prefixLength) {
        best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
        best_longtext_a = longtext.substring(0, i - suffixLength);
        best_longtext_b = longtext.substring(i + prefixLength);
        best_shorttext_a = shorttext.substring(0, j - suffixLength);
        best_shorttext_b = shorttext.substring(j + prefixLength);
      }
    }
    if (best_common.length * 2 >= longtext.length) {
      return [best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b, best_common];
    } else {
      return null;
    }
  }

  // First check if the second quarter is the seed for a half-match.
  var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
  // Check again based on the third quarter.
  var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
  var hm;
  if (!hm1 && !hm2) {
    return null;
  } else if (!hm2) {
    hm = hm1;
  } else if (!hm1) {
    hm = hm2;
  } else {
    // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
  }

  // A half-match was found, sort out the return data.
  var text1_a, text1_b, text2_a, text2_b;
  if (text1.length > text2.length) {
    text1_a = hm[0];
    text1_b = hm[1];
    text2_a = hm[2];
    text2_b = hm[3];
  } else {
    text2_a = hm[0];
    text2_b = hm[1];
    text1_a = hm[2];
    text1_b = hm[3];
  }
  var mid_common = hm[4];
  return [text1_a, text1_b, text2_a, text2_b, mid_common];
}
;

/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 * @param {boolean} fix_unicode Whether to normalize to a unicode-correct diff
 */
function diff_cleanupMerge(diffs, fix_unicode) {
  diffs.push([DIFF_EQUAL, '']); // Add a dummy entry at the end.
  var pointer = 0;
  var count_delete = 0;
  var count_insert = 0;
  var text_delete = '';
  var text_insert = '';
  var commonlength;
  while (pointer < diffs.length) {
    if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
      diffs.splice(pointer, 1);
      continue;
    }
    switch (diffs[pointer][0]) {
      case DIFF_INSERT:
        count_insert++;
        text_insert += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_DELETE:
        count_delete++;
        text_delete += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_EQUAL:
        var previous_equality = pointer - count_insert - count_delete - 1;
        if (fix_unicode) {
          // prevent splitting of unicode surrogate pairs.  when fix_unicode is true,
          // we assume that the old and new text in the diff are complete and correct
          // unicode-encoded JS strings, but the tuple boundaries may fall between
          // surrogate pairs.  we fix this by shaving off stray surrogates from the end
          // of the previous equality and the beginning of this equality.  this may create
          // empty equalities or a common prefix or suffix.  for example, if AB and AC are
          // emojis, `[[0, 'A'], [-1, 'BA'], [0, 'C']]` would turn into deleting 'ABAC' and
          // inserting 'AC', and then the common suffix 'AC' will be eliminated.  in this
          // particular case, both equalities go away, we absorb any previous inequalities,
          // and we keep scanning for the next equality before rewriting the tuples.
          if (previous_equality >= 0 && ends_with_pair_start(diffs[previous_equality][1])) {
            var stray = diffs[previous_equality][1].slice(-1);
            diffs[previous_equality][1] = diffs[previous_equality][1].slice(0, -1);
            text_delete = stray + text_delete;
            text_insert = stray + text_insert;
            if (!diffs[previous_equality][1]) {
              // emptied out previous equality, so delete it and include previous delete/insert
              diffs.splice(previous_equality, 1);
              pointer--;
              var k = previous_equality - 1;
              if (diffs[k] && diffs[k][0] === DIFF_INSERT) {
                count_insert++;
                text_insert = diffs[k][1] + text_insert;
                k--;
              }
              if (diffs[k] && diffs[k][0] === DIFF_DELETE) {
                count_delete++;
                text_delete = diffs[k][1] + text_delete;
                k--;
              }
              previous_equality = k;
            }
          }
          if (starts_with_pair_end(diffs[pointer][1])) {
            var stray = diffs[pointer][1].charAt(0);
            diffs[pointer][1] = diffs[pointer][1].slice(1);
            text_delete += stray;
            text_insert += stray;
          }
        }
        if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
          // for empty equality not at end, wait for next equality
          diffs.splice(pointer, 1);
          break;
        }
        if (text_delete.length > 0 || text_insert.length > 0) {
          // note that diff_commonPrefix and diff_commonSuffix are unicode-aware
          if (text_delete.length > 0 && text_insert.length > 0) {
            // Factor out any common prefixes.
            commonlength = diff_commonPrefix(text_insert, text_delete);
            if (commonlength !== 0) {
              if (previous_equality >= 0) {
                diffs[previous_equality][1] += text_insert.substring(0, commonlength);
              } else {
                diffs.splice(0, 0, [DIFF_EQUAL, text_insert.substring(0, commonlength)]);
                pointer++;
              }
              text_insert = text_insert.substring(commonlength);
              text_delete = text_delete.substring(commonlength);
            }
            // Factor out any common suffixes.
            commonlength = diff_commonSuffix(text_insert, text_delete);
            if (commonlength !== 0) {
              diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
              text_insert = text_insert.substring(0, text_insert.length - commonlength);
              text_delete = text_delete.substring(0, text_delete.length - commonlength);
            }
          }
          // Delete the offending records and add the merged ones.
          var n = count_insert + count_delete;
          if (text_delete.length === 0 && text_insert.length === 0) {
            diffs.splice(pointer - n, n);
            pointer = pointer - n;
          } else if (text_delete.length === 0) {
            diffs.splice(pointer - n, n, [DIFF_INSERT, text_insert]);
            pointer = pointer - n + 1;
          } else if (text_insert.length === 0) {
            diffs.splice(pointer - n, n, [DIFF_DELETE, text_delete]);
            pointer = pointer - n + 1;
          } else {
            diffs.splice(pointer - n, n, [DIFF_DELETE, text_delete], [DIFF_INSERT, text_insert]);
            pointer = pointer - n + 2;
          }
        }
        if (pointer !== 0 && diffs[pointer - 1][0] === DIFF_EQUAL) {
          // Merge this equality with the previous one.
          diffs[pointer - 1][1] += diffs[pointer][1];
          diffs.splice(pointer, 1);
        } else {
          pointer++;
        }
        count_insert = 0;
        count_delete = 0;
        text_delete = '';
        text_insert = '';
        break;
    }
  }
  if (diffs[diffs.length - 1][1] === '') {
    diffs.pop(); // Remove the dummy entry at the end.
  }

  // Second pass: look for single edits surrounded on both sides by equalities
  // which can be shifted sideways to eliminate an equality.
  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
  var changes = false;
  pointer = 1;
  // Intentionally ignore the first and last element (don't need checking).
  while (pointer < diffs.length - 1) {
    if (diffs[pointer - 1][0] === DIFF_EQUAL && diffs[pointer + 1][0] === DIFF_EQUAL) {
      // This is a single edit surrounded by equalities.
      if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) === diffs[pointer - 1][1]) {
        // Shift the edit over the previous equality.
        diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
        diffs.splice(pointer - 1, 1);
        changes = true;
      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
        // Shift the edit over the next equality.
        diffs[pointer - 1][1] += diffs[pointer + 1][1];
        diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
        diffs.splice(pointer + 1, 1);
        changes = true;
      }
    }
    pointer++;
  }
  // If shifts were made, the diff needs reordering and another shift sweep.
  if (changes) {
    diff_cleanupMerge(diffs, fix_unicode);
  }
}
;
function is_surrogate_pair_start(charCode) {
  return charCode >= 0xD800 && charCode <= 0xDBFF;
}
function is_surrogate_pair_end(charCode) {
  return charCode >= 0xDC00 && charCode <= 0xDFFF;
}
function starts_with_pair_end(str) {
  return is_surrogate_pair_end(str.charCodeAt(0));
}
function ends_with_pair_start(str) {
  return is_surrogate_pair_start(str.charCodeAt(str.length - 1));
}
function remove_empty_tuples(tuples) {
  var ret = [];
  for (var i = 0; i < tuples.length; i++) {
    if (tuples[i][1].length > 0) {
      ret.push(tuples[i]);
    }
  }
  return ret;
}
function make_edit_splice(before, oldMiddle, newMiddle, after) {
  if (ends_with_pair_start(before) || starts_with_pair_end(after)) {
    return null;
  }
  return remove_empty_tuples([[DIFF_EQUAL, before], [DIFF_DELETE, oldMiddle], [DIFF_INSERT, newMiddle], [DIFF_EQUAL, after]]);
}
function find_cursor_edit_diff(oldText, newText, cursor_pos) {
  // note: this runs after equality check has ruled out exact equality
  var oldRange = typeof cursor_pos === 'number' ? {
    index: cursor_pos,
    length: 0
  } : cursor_pos.oldRange;
  var newRange = typeof cursor_pos === 'number' ? null : cursor_pos.newRange;
  // take into account the old and new selection to generate the best diff
  // possible for a text edit.  for example, a text change from "xxx" to "xx"
  // could be a delete or forwards-delete of any one of the x's, or the
  // result of selecting two of the x's and typing "x".
  var oldLength = oldText.length;
  var newLength = newText.length;
  if (oldRange.length === 0 && (newRange === null || newRange.length === 0)) {
    // see if we have an insert or delete before or after cursor
    var oldCursor = oldRange.index;
    var oldBefore = oldText.slice(0, oldCursor);
    var oldAfter = oldText.slice(oldCursor);
    var maybeNewCursor = newRange ? newRange.index : null;
    editBefore: {
      // is this an insert or delete right before oldCursor?
      var newCursor = oldCursor + newLength - oldLength;
      if (maybeNewCursor !== null && maybeNewCursor !== newCursor) {
        break editBefore;
      }
      if (newCursor < 0 || newCursor > newLength) {
        break editBefore;
      }
      var newBefore = newText.slice(0, newCursor);
      var newAfter = newText.slice(newCursor);
      if (newAfter !== oldAfter) {
        break editBefore;
      }
      var prefixLength = Math.min(oldCursor, newCursor);
      var oldPrefix = oldBefore.slice(0, prefixLength);
      var newPrefix = newBefore.slice(0, prefixLength);
      if (oldPrefix !== newPrefix) {
        break editBefore;
      }
      var oldMiddle = oldBefore.slice(prefixLength);
      var newMiddle = newBefore.slice(prefixLength);
      return make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldAfter);
    }
    editAfter: {
      // is this an insert or delete right after oldCursor?
      if (maybeNewCursor !== null && maybeNewCursor !== oldCursor) {
        break editAfter;
      }
      var cursor = oldCursor;
      var newBefore = newText.slice(0, cursor);
      var newAfter = newText.slice(cursor);
      if (newBefore !== oldBefore) {
        break editAfter;
      }
      var suffixLength = Math.min(oldLength - cursor, newLength - cursor);
      var oldSuffix = oldAfter.slice(oldAfter.length - suffixLength);
      var newSuffix = newAfter.slice(newAfter.length - suffixLength);
      if (oldSuffix !== newSuffix) {
        break editAfter;
      }
      var oldMiddle = oldAfter.slice(0, oldAfter.length - suffixLength);
      var newMiddle = newAfter.slice(0, newAfter.length - suffixLength);
      return make_edit_splice(oldBefore, oldMiddle, newMiddle, oldSuffix);
    }
  }
  if (oldRange.length > 0 && newRange && newRange.length === 0) {
    replaceRange: {
      // see if diff could be a splice of the old selection range
      var oldPrefix = oldText.slice(0, oldRange.index);
      var oldSuffix = oldText.slice(oldRange.index + oldRange.length);
      var prefixLength = oldPrefix.length;
      var suffixLength = oldSuffix.length;
      if (newLength < prefixLength + suffixLength) {
        break replaceRange;
      }
      var newPrefix = newText.slice(0, prefixLength);
      var newSuffix = newText.slice(newLength - suffixLength);
      if (oldPrefix !== newPrefix || oldSuffix !== newSuffix) {
        break replaceRange;
      }
      var oldMiddle = oldText.slice(prefixLength, oldLength - suffixLength);
      var newMiddle = newText.slice(prefixLength, newLength - suffixLength);
      return make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldSuffix);
    }
  }
  return null;
}
function diff(text1, text2, cursor_pos) {
  // only pass fix_unicode=true at the top level, not when diff_main is
  // recursively invoked
  return diff_main(text1, text2, cursor_pos, true);
}
diff.INSERT = DIFF_INSERT;
diff.DELETE = DIFF_DELETE;
diff.EQUAL = DIFF_EQUAL;
module.exports = diff;

/***/ }),

/***/ 26863:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/**
 * filesize
 *
 * @copyright 2018 Jason Mulligan <jason.mulligan@avoidwork.com>
 * @license BSD-3-Clause
 * @version 3.6.1
 */
__webpack_require__(9653);
__webpack_require__(56977);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(41539);
__webpack_require__(39714);
__webpack_require__(69600);
(function (global) {
  var b = /^(b|B)$/,
    symbol = {
      iec: {
        bits: ["b", "Kib", "Mib", "Gib", "Tib", "Pib", "Eib", "Zib", "Yib"],
        bytes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
      },
      jedec: {
        bits: ["b", "Kb", "Mb", "Gb", "Tb", "Pb", "Eb", "Zb", "Yb"],
        bytes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      }
    },
    fullform = {
      iec: ["", "kibi", "mebi", "gibi", "tebi", "pebi", "exbi", "zebi", "yobi"],
      jedec: ["", "kilo", "mega", "giga", "tera", "peta", "exa", "zetta", "yotta"]
    };

  /**
   * filesize
   *
   * @method filesize
   * @param  {Mixed}   arg        String, Int or Float to transform
   * @param  {Object}  descriptor [Optional] Flags
   * @return {String}             Readable file size String
   */
  function filesize(arg) {
    var descriptor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var result = [],
      val = 0,
      e = void 0,
      base = void 0,
      bits = void 0,
      ceil = void 0,
      full = void 0,
      fullforms = void 0,
      neg = void 0,
      num = void 0,
      output = void 0,
      round = void 0,
      unix = void 0,
      separator = void 0,
      spacer = void 0,
      standard = void 0,
      symbols = void 0;
    if (isNaN(arg)) {
      throw new Error("Invalid arguments");
    }
    bits = descriptor.bits === true;
    unix = descriptor.unix === true;
    base = descriptor.base || 2;
    round = descriptor.round !== void 0 ? descriptor.round : unix ? 1 : 2;
    separator = descriptor.separator !== void 0 ? descriptor.separator || "" : "";
    spacer = descriptor.spacer !== void 0 ? descriptor.spacer : unix ? "" : " ";
    symbols = descriptor.symbols || descriptor.suffixes || {};
    standard = base === 2 ? descriptor.standard || "jedec" : "jedec";
    output = descriptor.output || "string";
    full = descriptor.fullform === true;
    fullforms = descriptor.fullforms instanceof Array ? descriptor.fullforms : [];
    e = descriptor.exponent !== void 0 ? descriptor.exponent : -1;
    num = Number(arg);
    neg = num < 0;
    ceil = base > 2 ? 1000 : 1024;

    // Flipping a negative number to determine the size
    if (neg) {
      num = -num;
    }

    // Determining the exponent
    if (e === -1 || isNaN(e)) {
      e = Math.floor(Math.log(num) / Math.log(ceil));
      if (e < 0) {
        e = 0;
      }
    }

    // Exceeding supported length, time to reduce & multiply
    if (e > 8) {
      e = 8;
    }

    // Zero is now a special case because bytes divide by 1
    if (num === 0) {
      result[0] = 0;
      result[1] = unix ? "" : symbol[standard][bits ? "bits" : "bytes"][e];
    } else {
      val = num / (base === 2 ? Math.pow(2, e * 10) : Math.pow(1000, e));
      if (bits) {
        val = val * 8;
        if (val >= ceil && e < 8) {
          val = val / ceil;
          e++;
        }
      }
      result[0] = Number(val.toFixed(e > 0 ? round : 0));
      result[1] = base === 10 && e === 1 ? bits ? "kb" : "kB" : symbol[standard][bits ? "bits" : "bytes"][e];
      if (unix) {
        result[1] = standard === "jedec" ? result[1].charAt(0) : e > 0 ? result[1].replace(/B$/, "") : result[1];
        if (b.test(result[1])) {
          result[0] = Math.floor(result[0]);
          result[1] = "";
        }
      }
    }

    // Decorating a 'diff'
    if (neg) {
      result[0] = -result[0];
    }

    // Applying custom symbol
    result[1] = symbols[result[1]] || result[1];

    // Returning Array, Object, or String (default)
    if (output === "array") {
      return result;
    }
    if (output === "exponent") {
      return e;
    }
    if (output === "object") {
      return {
        value: result[0],
        suffix: result[1],
        symbol: result[1]
      };
    }
    if (full) {
      result[1] = fullforms[e] ? fullforms[e] : fullform[standard][e] + (bits ? "bit" : "byte") + (result[0] === 1 ? "" : "s");
    }
    if (separator.length > 0) {
      result[0] = result[0].toString().replace(".", separator);
    }
    return result.join(spacer);
  }

  // Partial application for functional programming
  filesize.partial = function (opt) {
    return function (arg) {
      return filesize(arg, opt);
    };
  };

  // CommonJS, AMD, script tag
  if (true) {
    module.exports = filesize;
  } else {}
})(typeof window !== "undefined" ? window : __webpack_require__.g);

/***/ }),

/***/ 81999:
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(68309);
__webpack_require__(41539);
__webpack_require__(39714);
__webpack_require__(66992);
__webpack_require__(82472);
__webpack_require__(92990);
__webpack_require__(18927);
__webpack_require__(33105);
__webpack_require__(35035);
__webpack_require__(74345);
__webpack_require__(7174);
__webpack_require__(32846);
__webpack_require__(44731);
__webpack_require__(77209);
__webpack_require__(96319);
__webpack_require__(58867);
__webpack_require__(37789);
__webpack_require__(33739);
__webpack_require__(29368);
__webpack_require__(14483);
__webpack_require__(12056);
__webpack_require__(3462);
__webpack_require__(30678);
__webpack_require__(27462);
__webpack_require__(33824);
__webpack_require__(55021);
__webpack_require__(12974);
__webpack_require__(15016);
__webpack_require__(44197);
__webpack_require__(76495);
__webpack_require__(47042);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(78783);
__webpack_require__(33948);
(function (name, definition) {
  if (true) {
    // RequireJS / AMD
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})('fix-webm-duration', function () {
  /*
   * This is the list of possible WEBM file sections by their IDs.
   * Possible types: Container, Binary, Uint, Int, String, Float, Date
   */
  var sections = {
    0xa45dfa3: {
      name: 'EBML',
      type: 'Container'
    },
    0x286: {
      name: 'EBMLVersion',
      type: 'Uint'
    },
    0x2f7: {
      name: 'EBMLReadVersion',
      type: 'Uint'
    },
    0x2f2: {
      name: 'EBMLMaxIDLength',
      type: 'Uint'
    },
    0x2f3: {
      name: 'EBMLMaxSizeLength',
      type: 'Uint'
    },
    0x282: {
      name: 'DocType',
      type: 'String'
    },
    0x287: {
      name: 'DocTypeVersion',
      type: 'Uint'
    },
    0x285: {
      name: 'DocTypeReadVersion',
      type: 'Uint'
    },
    0x6c: {
      name: 'Void',
      type: 'Binary'
    },
    0x3f: {
      name: 'CRC-32',
      type: 'Binary'
    },
    0xb538667: {
      name: 'SignatureSlot',
      type: 'Container'
    },
    0x3e8a: {
      name: 'SignatureAlgo',
      type: 'Uint'
    },
    0x3e9a: {
      name: 'SignatureHash',
      type: 'Uint'
    },
    0x3ea5: {
      name: 'SignaturePublicKey',
      type: 'Binary'
    },
    0x3eb5: {
      name: 'Signature',
      type: 'Binary'
    },
    0x3e5b: {
      name: 'SignatureElements',
      type: 'Container'
    },
    0x3e7b: {
      name: 'SignatureElementList',
      type: 'Container'
    },
    0x2532: {
      name: 'SignedElement',
      type: 'Binary'
    },
    0x8538067: {
      name: 'Segment',
      type: 'Container'
    },
    0x14d9b74: {
      name: 'SeekHead',
      type: 'Container'
    },
    0xdbb: {
      name: 'Seek',
      type: 'Container'
    },
    0x13ab: {
      name: 'SeekID',
      type: 'Binary'
    },
    0x13ac: {
      name: 'SeekPosition',
      type: 'Uint'
    },
    0x549a966: {
      name: 'Info',
      type: 'Container'
    },
    0x33a4: {
      name: 'SegmentUID',
      type: 'Binary'
    },
    0x3384: {
      name: 'SegmentFilename',
      type: 'String'
    },
    0x1cb923: {
      name: 'PrevUID',
      type: 'Binary'
    },
    0x1c83ab: {
      name: 'PrevFilename',
      type: 'String'
    },
    0x1eb923: {
      name: 'NextUID',
      type: 'Binary'
    },
    0x1e83bb: {
      name: 'NextFilename',
      type: 'String'
    },
    0x444: {
      name: 'SegmentFamily',
      type: 'Binary'
    },
    0x2924: {
      name: 'ChapterTranslate',
      type: 'Container'
    },
    0x29fc: {
      name: 'ChapterTranslateEditionUID',
      type: 'Uint'
    },
    0x29bf: {
      name: 'ChapterTranslateCodec',
      type: 'Uint'
    },
    0x29a5: {
      name: 'ChapterTranslateID',
      type: 'Binary'
    },
    0xad7b1: {
      name: 'TimecodeScale',
      type: 'Uint'
    },
    0x489: {
      name: 'Duration',
      type: 'Float'
    },
    0x461: {
      name: 'DateUTC',
      type: 'Date'
    },
    0x3ba9: {
      name: 'Title',
      type: 'String'
    },
    0xd80: {
      name: 'MuxingApp',
      type: 'String'
    },
    0x1741: {
      name: 'WritingApp',
      type: 'String'
    },
    // 0xf43b675: { name: 'Cluster', type: 'Container' },
    0x67: {
      name: 'Timecode',
      type: 'Uint'
    },
    0x1854: {
      name: 'SilentTracks',
      type: 'Container'
    },
    0x18d7: {
      name: 'SilentTrackNumber',
      type: 'Uint'
    },
    0x27: {
      name: 'Position',
      type: 'Uint'
    },
    0x2b: {
      name: 'PrevSize',
      type: 'Uint'
    },
    0x23: {
      name: 'SimpleBlock',
      type: 'Binary'
    },
    0x20: {
      name: 'BlockGroup',
      type: 'Container'
    },
    0x21: {
      name: 'Block',
      type: 'Binary'
    },
    0x22: {
      name: 'BlockVirtual',
      type: 'Binary'
    },
    0x35a1: {
      name: 'BlockAdditions',
      type: 'Container'
    },
    0x26: {
      name: 'BlockMore',
      type: 'Container'
    },
    0x6e: {
      name: 'BlockAddID',
      type: 'Uint'
    },
    0x25: {
      name: 'BlockAdditional',
      type: 'Binary'
    },
    0x1b: {
      name: 'BlockDuration',
      type: 'Uint'
    },
    0x7a: {
      name: 'ReferencePriority',
      type: 'Uint'
    },
    0x7b: {
      name: 'ReferenceBlock',
      type: 'Int'
    },
    0x7d: {
      name: 'ReferenceVirtual',
      type: 'Int'
    },
    0x24: {
      name: 'CodecState',
      type: 'Binary'
    },
    0x35a2: {
      name: 'DiscardPadding',
      type: 'Int'
    },
    0xe: {
      name: 'Slices',
      type: 'Container'
    },
    0x68: {
      name: 'TimeSlice',
      type: 'Container'
    },
    0x4c: {
      name: 'LaceNumber',
      type: 'Uint'
    },
    0x4d: {
      name: 'FrameNumber',
      type: 'Uint'
    },
    0x4b: {
      name: 'BlockAdditionID',
      type: 'Uint'
    },
    0x4e: {
      name: 'Delay',
      type: 'Uint'
    },
    0x4f: {
      name: 'SliceDuration',
      type: 'Uint'
    },
    0x48: {
      name: 'ReferenceFrame',
      type: 'Container'
    },
    0x49: {
      name: 'ReferenceOffset',
      type: 'Uint'
    },
    0x4a: {
      name: 'ReferenceTimeCode',
      type: 'Uint'
    },
    0x2f: {
      name: 'EncryptedBlock',
      type: 'Binary'
    },
    0x654ae6b: {
      name: 'Tracks',
      type: 'Container'
    },
    0x2e: {
      name: 'TrackEntry',
      type: 'Container'
    },
    0x57: {
      name: 'TrackNumber',
      type: 'Uint'
    },
    0x33c5: {
      name: 'TrackUID',
      type: 'Uint'
    },
    0x3: {
      name: 'TrackType',
      type: 'Uint'
    },
    0x39: {
      name: 'FlagEnabled',
      type: 'Uint'
    },
    0x8: {
      name: 'FlagDefault',
      type: 'Uint'
    },
    0x15aa: {
      name: 'FlagForced',
      type: 'Uint'
    },
    0x1c: {
      name: 'FlagLacing',
      type: 'Uint'
    },
    0x2de7: {
      name: 'MinCache',
      type: 'Uint'
    },
    0x2df8: {
      name: 'MaxCache',
      type: 'Uint'
    },
    0x3e383: {
      name: 'DefaultDuration',
      type: 'Uint'
    },
    0x34e7a: {
      name: 'DefaultDecodedFieldDuration',
      type: 'Uint'
    },
    0x3314f: {
      name: 'TrackTimecodeScale',
      type: 'Float'
    },
    0x137f: {
      name: 'TrackOffset',
      type: 'Int'
    },
    0x15ee: {
      name: 'MaxBlockAdditionID',
      type: 'Uint'
    },
    0x136e: {
      name: 'Name',
      type: 'String'
    },
    0x2b59c: {
      name: 'Language',
      type: 'String'
    },
    0x6: {
      name: 'CodecID',
      type: 'String'
    },
    0x23a2: {
      name: 'CodecPrivate',
      type: 'Binary'
    },
    0x58688: {
      name: 'CodecName',
      type: 'String'
    },
    0x3446: {
      name: 'AttachmentLink',
      type: 'Uint'
    },
    0x1a9697: {
      name: 'CodecSettings',
      type: 'String'
    },
    0x1b4040: {
      name: 'CodecInfoURL',
      type: 'String'
    },
    0x6b240: {
      name: 'CodecDownloadURL',
      type: 'String'
    },
    0x2a: {
      name: 'CodecDecodeAll',
      type: 'Uint'
    },
    0x2fab: {
      name: 'TrackOverlay',
      type: 'Uint'
    },
    0x16aa: {
      name: 'CodecDelay',
      type: 'Uint'
    },
    0x16bb: {
      name: 'SeekPreRoll',
      type: 'Uint'
    },
    0x2624: {
      name: 'TrackTranslate',
      type: 'Container'
    },
    0x26fc: {
      name: 'TrackTranslateEditionUID',
      type: 'Uint'
    },
    0x26bf: {
      name: 'TrackTranslateCodec',
      type: 'Uint'
    },
    0x26a5: {
      name: 'TrackTranslateTrackID',
      type: 'Binary'
    },
    0x60: {
      name: 'Video',
      type: 'Container'
    },
    0x1a: {
      name: 'FlagInterlaced',
      type: 'Uint'
    },
    0x13b8: {
      name: 'StereoMode',
      type: 'Uint'
    },
    0x13c0: {
      name: 'AlphaMode',
      type: 'Uint'
    },
    0x13b9: {
      name: 'OldStereoMode',
      type: 'Uint'
    },
    0x30: {
      name: 'PixelWidth',
      type: 'Uint'
    },
    0x3a: {
      name: 'PixelHeight',
      type: 'Uint'
    },
    0x14aa: {
      name: 'PixelCropBottom',
      type: 'Uint'
    },
    0x14bb: {
      name: 'PixelCropTop',
      type: 'Uint'
    },
    0x14cc: {
      name: 'PixelCropLeft',
      type: 'Uint'
    },
    0x14dd: {
      name: 'PixelCropRight',
      type: 'Uint'
    },
    0x14b0: {
      name: 'DisplayWidth',
      type: 'Uint'
    },
    0x14ba: {
      name: 'DisplayHeight',
      type: 'Uint'
    },
    0x14b2: {
      name: 'DisplayUnit',
      type: 'Uint'
    },
    0x14b3: {
      name: 'AspectRatioType',
      type: 'Uint'
    },
    0xeb524: {
      name: 'ColourSpace',
      type: 'Binary'
    },
    0xfb523: {
      name: 'GammaValue',
      type: 'Float'
    },
    0x383e3: {
      name: 'FrameRate',
      type: 'Float'
    },
    0x61: {
      name: 'Audio',
      type: 'Container'
    },
    0x35: {
      name: 'SamplingFrequency',
      type: 'Float'
    },
    0x38b5: {
      name: 'OutputSamplingFrequency',
      type: 'Float'
    },
    0x1f: {
      name: 'Channels',
      type: 'Uint'
    },
    0x3d7b: {
      name: 'ChannelPositions',
      type: 'Binary'
    },
    0x2264: {
      name: 'BitDepth',
      type: 'Uint'
    },
    0x62: {
      name: 'TrackOperation',
      type: 'Container'
    },
    0x63: {
      name: 'TrackCombinePlanes',
      type: 'Container'
    },
    0x64: {
      name: 'TrackPlane',
      type: 'Container'
    },
    0x65: {
      name: 'TrackPlaneUID',
      type: 'Uint'
    },
    0x66: {
      name: 'TrackPlaneType',
      type: 'Uint'
    },
    0x69: {
      name: 'TrackJoinBlocks',
      type: 'Container'
    },
    0x6d: {
      name: 'TrackJoinUID',
      type: 'Uint'
    },
    0x40: {
      name: 'TrickTrackUID',
      type: 'Uint'
    },
    0x41: {
      name: 'TrickTrackSegmentUID',
      type: 'Binary'
    },
    0x46: {
      name: 'TrickTrackFlag',
      type: 'Uint'
    },
    0x47: {
      name: 'TrickMasterTrackUID',
      type: 'Uint'
    },
    0x44: {
      name: 'TrickMasterTrackSegmentUID',
      type: 'Binary'
    },
    0x2d80: {
      name: 'ContentEncodings',
      type: 'Container'
    },
    0x2240: {
      name: 'ContentEncoding',
      type: 'Container'
    },
    0x1031: {
      name: 'ContentEncodingOrder',
      type: 'Uint'
    },
    0x1032: {
      name: 'ContentEncodingScope',
      type: 'Uint'
    },
    0x1033: {
      name: 'ContentEncodingType',
      type: 'Uint'
    },
    0x1034: {
      name: 'ContentCompression',
      type: 'Container'
    },
    0x254: {
      name: 'ContentCompAlgo',
      type: 'Uint'
    },
    0x255: {
      name: 'ContentCompSettings',
      type: 'Binary'
    },
    0x1035: {
      name: 'ContentEncryption',
      type: 'Container'
    },
    0x7e1: {
      name: 'ContentEncAlgo',
      type: 'Uint'
    },
    0x7e2: {
      name: 'ContentEncKeyID',
      type: 'Binary'
    },
    0x7e3: {
      name: 'ContentSignature',
      type: 'Binary'
    },
    0x7e4: {
      name: 'ContentSigKeyID',
      type: 'Binary'
    },
    0x7e5: {
      name: 'ContentSigAlgo',
      type: 'Uint'
    },
    0x7e6: {
      name: 'ContentSigHashAlgo',
      type: 'Uint'
    },
    0xc53bb6b: {
      name: 'Cues',
      type: 'Container'
    },
    0x3b: {
      name: 'CuePoint',
      type: 'Container'
    },
    0x33: {
      name: 'CueTime',
      type: 'Uint'
    },
    0x37: {
      name: 'CueTrackPositions',
      type: 'Container'
    },
    0x77: {
      name: 'CueTrack',
      type: 'Uint'
    },
    0x71: {
      name: 'CueClusterPosition',
      type: 'Uint'
    },
    0x70: {
      name: 'CueRelativePosition',
      type: 'Uint'
    },
    0x32: {
      name: 'CueDuration',
      type: 'Uint'
    },
    0x1378: {
      name: 'CueBlockNumber',
      type: 'Uint'
    },
    0x6a: {
      name: 'CueCodecState',
      type: 'Uint'
    },
    0x5b: {
      name: 'CueReference',
      type: 'Container'
    },
    0x16: {
      name: 'CueRefTime',
      type: 'Uint'
    },
    0x17: {
      name: 'CueRefCluster',
      type: 'Uint'
    },
    0x135f: {
      name: 'CueRefNumber',
      type: 'Uint'
    },
    0x6b: {
      name: 'CueRefCodecState',
      type: 'Uint'
    },
    0x941a469: {
      name: 'Attachments',
      type: 'Container'
    },
    0x21a7: {
      name: 'AttachedFile',
      type: 'Container'
    },
    0x67e: {
      name: 'FileDescription',
      type: 'String'
    },
    0x66e: {
      name: 'FileName',
      type: 'String'
    },
    0x660: {
      name: 'FileMimeType',
      type: 'String'
    },
    0x65c: {
      name: 'FileData',
      type: 'Binary'
    },
    0x6ae: {
      name: 'FileUID',
      type: 'Uint'
    },
    0x675: {
      name: 'FileReferral',
      type: 'Binary'
    },
    0x661: {
      name: 'FileUsedStartTime',
      type: 'Uint'
    },
    0x662: {
      name: 'FileUsedEndTime',
      type: 'Uint'
    },
    0x43a770: {
      name: 'Chapters',
      type: 'Container'
    },
    0x5b9: {
      name: 'EditionEntry',
      type: 'Container'
    },
    0x5bc: {
      name: 'EditionUID',
      type: 'Uint'
    },
    0x5bd: {
      name: 'EditionFlagHidden',
      type: 'Uint'
    },
    0x5db: {
      name: 'EditionFlagDefault',
      type: 'Uint'
    },
    0x5dd: {
      name: 'EditionFlagOrdered',
      type: 'Uint'
    },
    0x36: {
      name: 'ChapterAtom',
      type: 'Container'
    },
    0x33c4: {
      name: 'ChapterUID',
      type: 'Uint'
    },
    0x1654: {
      name: 'ChapterStringUID',
      type: 'String'
    },
    0x11: {
      name: 'ChapterTimeStart',
      type: 'Uint'
    },
    0x12: {
      name: 'ChapterTimeEnd',
      type: 'Uint'
    },
    0x18: {
      name: 'ChapterFlagHidden',
      type: 'Uint'
    },
    0x598: {
      name: 'ChapterFlagEnabled',
      type: 'Uint'
    },
    0x2e67: {
      name: 'ChapterSegmentUID',
      type: 'Binary'
    },
    0x2ebc: {
      name: 'ChapterSegmentEditionUID',
      type: 'Uint'
    },
    0x23c3: {
      name: 'ChapterPhysicalEquiv',
      type: 'Uint'
    },
    0xf: {
      name: 'ChapterTrack',
      type: 'Container'
    },
    0x9: {
      name: 'ChapterTrackNumber',
      type: 'Uint'
    },
    0x0: {
      name: 'ChapterDisplay',
      type: 'Container'
    },
    0x5: {
      name: 'ChapString',
      type: 'String'
    },
    0x37c: {
      name: 'ChapLanguage',
      type: 'String'
    },
    0x37e: {
      name: 'ChapCountry',
      type: 'String'
    },
    0x2944: {
      name: 'ChapProcess',
      type: 'Container'
    },
    0x2955: {
      name: 'ChapProcessCodecID',
      type: 'Uint'
    },
    0x50d: {
      name: 'ChapProcessPrivate',
      type: 'Binary'
    },
    0x2911: {
      name: 'ChapProcessCommand',
      type: 'Container'
    },
    0x2922: {
      name: 'ChapProcessTime',
      type: 'Uint'
    },
    0x2933: {
      name: 'ChapProcessData',
      type: 'Binary'
    },
    0x254c367: {
      name: 'Tags',
      type: 'Container'
    },
    0x3373: {
      name: 'Tag',
      type: 'Container'
    },
    0x23c0: {
      name: 'Targets',
      type: 'Container'
    },
    0x28ca: {
      name: 'TargetTypeValue',
      type: 'Uint'
    },
    0x23ca: {
      name: 'TargetType',
      type: 'String'
    },
    0x23c5: {
      name: 'TagTrackUID',
      type: 'Uint'
    },
    0x23c9: {
      name: 'TagEditionUID',
      type: 'Uint'
    },
    0x23c4: {
      name: 'TagChapterUID',
      type: 'Uint'
    },
    0x23c6: {
      name: 'TagAttachmentUID',
      type: 'Uint'
    },
    0x27c8: {
      name: 'SimpleTag',
      type: 'Container'
    },
    0x5a3: {
      name: 'TagName',
      type: 'String'
    },
    0x47a: {
      name: 'TagLanguage',
      type: 'String'
    },
    0x484: {
      name: 'TagDefault',
      type: 'Uint'
    },
    0x487: {
      name: 'TagString',
      type: 'String'
    },
    0x485: {
      name: 'TagBinary',
      type: 'Binary'
    }
  };
  function doInherit(newClass, baseClass) {
    newClass.prototype = Object.create(baseClass.prototype);
    newClass.prototype.constructor = newClass;
  }
  function WebmBase(name, type) {
    this.name = name || 'Unknown';
    this.type = type || 'Unknown';
  }
  WebmBase.prototype.updateBySource = function () {};
  WebmBase.prototype.setSource = function (source) {
    this.source = source;
    this.updateBySource();
  };
  WebmBase.prototype.updateByData = function () {};
  WebmBase.prototype.setData = function (data) {
    this.data = data;
    this.updateByData();
  };
  function WebmUint(name, type) {
    WebmBase.call(this, name, type || 'Uint');
  }
  doInherit(WebmUint, WebmBase);
  function padHex(hex) {
    return hex.length % 2 === 1 ? '0' + hex : hex;
  }
  WebmUint.prototype.updateBySource = function () {
    // use hex representation of a number instead of number value
    this.data = '';
    for (var i = 0; i < this.source.length; i++) {
      var hex = this.source[i].toString(16);
      this.data += padHex(hex);
    }
  };
  WebmUint.prototype.updateByData = function () {
    var length = this.data.length / 2;
    this.source = new Uint8Array(length);
    for (var i = 0; i < length; i++) {
      var hex = this.data.substr(i * 2, 2);
      this.source[i] = parseInt(hex, 16);
    }
  };
  WebmUint.prototype.getValue = function () {
    return parseInt(this.data, 16);
  };
  WebmUint.prototype.setValue = function (value) {
    this.setData(padHex(value.toString(16)));
  };
  function WebmFloat(name, type) {
    WebmBase.call(this, name, type || 'Float');
  }
  doInherit(WebmFloat, WebmBase);
  WebmFloat.prototype.getFloatArrayType = function () {
    return this.source && this.source.length === 4 ? Float32Array : Float64Array;
  };
  WebmFloat.prototype.updateBySource = function () {
    var byteArray = this.source.reverse();
    var floatArrayType = this.getFloatArrayType();
    var floatArray = new floatArrayType(byteArray.buffer);
    this.data = floatArray[0];
  };
  WebmFloat.prototype.updateByData = function () {
    var floatArrayType = this.getFloatArrayType();
    var floatArray = new floatArrayType([this.data]);
    var byteArray = new Uint8Array(floatArray.buffer);
    this.source = byteArray.reverse();
  };
  WebmFloat.prototype.getValue = function () {
    return this.data;
  };
  WebmFloat.prototype.setValue = function (value) {
    this.setData(value);
  };
  function WebmContainer(name, type) {
    WebmBase.call(this, name, type || 'Container');
  }
  doInherit(WebmContainer, WebmBase);
  WebmContainer.prototype.readByte = function () {
    return this.source[this.offset++];
  };
  WebmContainer.prototype.readUint = function () {
    var firstByte = this.readByte();
    var bytes = 8 - firstByte.toString(2).length;
    var value = firstByte - (1 << 7 - bytes);
    for (var i = 0; i < bytes; i++) {
      // don't use bit operators to support x86
      value *= 256;
      value += this.readByte();
    }
    return value;
  };
  WebmContainer.prototype.updateBySource = function () {
    this.data = [];
    for (this.offset = 0; this.offset < this.source.length; this.offset = end) {
      var id = this.readUint();
      var len = this.readUint();
      var end = Math.min(this.offset + len, this.source.length);
      var data = this.source.slice(this.offset, end);
      var info = sections[id] || {
        name: 'Unknown',
        type: 'Unknown'
      };
      var ctr = WebmBase;
      switch (info.type) {
        case 'Container':
          ctr = WebmContainer;
          break;
        case 'Uint':
          ctr = WebmUint;
          break;
        case 'Float':
          ctr = WebmFloat;
          break;
      }
      var section = new ctr(info.name, info.type);
      section.setSource(data);
      this.data.push({
        id: id,
        idHex: id.toString(16),
        data: section
      });
    }
  };
  WebmContainer.prototype.writeUint = function (x, draft) {
    for (var bytes = 1, flag = 0x80; x >= flag && bytes < 8; bytes++, flag *= 0x80) {}
    if (!draft) {
      var value = flag + x;
      for (var i = bytes - 1; i >= 0; i--) {
        // don't use bit operators to support x86
        var c = value % 256;
        this.source[this.offset + i] = c;
        value = (value - c) / 256;
      }
    }
    this.offset += bytes;
  };
  WebmContainer.prototype.writeSections = function (draft) {
    this.offset = 0;
    for (var i = 0; i < this.data.length; i++) {
      var section = this.data[i],
        content = section.data.source,
        contentLength = content.length;
      this.writeUint(section.id, draft);
      this.writeUint(contentLength, draft);
      if (!draft) {
        this.source.set(content, this.offset);
      }
      this.offset += contentLength;
    }
    return this.offset;
  };
  WebmContainer.prototype.updateByData = function () {
    // run without accessing this.source to determine total length - need to know it to create Uint8Array
    var length = this.writeSections('draft');
    this.source = new Uint8Array(length);
    // now really write data
    this.writeSections();
  };
  WebmContainer.prototype.getSectionById = function (id) {
    for (var i = 0; i < this.data.length; i++) {
      var section = this.data[i];
      if (section.id === id) {
        return section.data;
      }
    }
    return null;
  };
  function WebmFile(source) {
    WebmContainer.call(this, 'File', 'File');
    this.setSource(source);
  }
  doInherit(WebmFile, WebmContainer);
  WebmFile.prototype.fixDuration = function (duration, options) {
    var logger = options && options.logger;
    if (logger === undefined) {
      logger = function logger(message) {
        console.log(message);
      };
    } else if (!logger) {
      logger = function logger() {};
    }
    var segmentSection = this.getSectionById(0x8538067);
    if (!segmentSection) {
      logger('[fix-webm-duration] Segment section is missing');
      return false;
    }
    var infoSection = segmentSection.getSectionById(0x549a966);
    if (!infoSection) {
      logger('[fix-webm-duration] Info section is missing');
      return false;
    }
    var timeScaleSection = infoSection.getSectionById(0xad7b1);
    if (!timeScaleSection) {
      logger('[fix-webm-duration] TimecodeScale section is missing');
      return false;
    }
    var durationSection = infoSection.getSectionById(0x489);
    if (durationSection) {
      if (durationSection.getValue() <= 0) {
        logger("[fix-webm-duration] Duration section is present, but the value is ".concat(durationSection.getValue()));
        durationSection.setValue(duration);
      } else {
        logger("[fix-webm-duration] Duration section is present, and the value is ".concat(durationSection.getValue()));
        return false;
      }
    } else {
      logger('[fix-webm-duration] Duration section is missing');
      // append Duration section
      durationSection = new WebmFloat('Duration', 'Float');
      durationSection.setValue(duration);
      infoSection.data.push({
        id: 0x489,
        data: durationSection
      });
    }

    // set default time scale to 1 millisecond (1000000 nanoseconds)
    timeScaleSection.setValue(1000000);
    infoSection.updateByData();
    segmentSection.updateByData();
    this.updateByData();
    return true;
  };
  WebmFile.prototype.toBlob = function (mimeType) {
    return new Blob([this.source.buffer], {
      type: mimeType || 'video/webm'
    });
  };
  function fixWebmDuration(blob, duration, callback, options) {
    // The callback may be omitted - then the third argument is options
    if (_typeof(callback) === "object") {
      options = callback;
      callback = undefined;
    }
    if (!callback) {
      return new Promise(function (resolve) {
        fixWebmDuration(blob, duration, resolve, options);
      });
    }
    try {
      var reader = new FileReader();
      reader.onloadend = function () {
        try {
          var file = new WebmFile(new Uint8Array(reader.result));
          if (file.fixDuration(duration, options)) {
            blob = file.toBlob(blob.type);
          }
        } catch (ex) {
          // ignore
        }
        callback(blob);
      };
      reader.readAsArrayBuffer(blob);
    } catch (ex) {
      callback(blob);
    }
  }

  // Support AMD import default
  fixWebmDuration.default = fixWebmDuration;
  return fixWebmDuration;
});

/***/ }),

/***/ 50068:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(41539);
var isCallable = __webpack_require__(30916);
var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var forEachArray = function forEachArray(array, iterator, receiver) {
  for (var i = 0, len = array.length; i < len; i++) {
    if (hasOwnProperty.call(array, i)) {
      if (receiver == null) {
        iterator(array[i], i, array);
      } else {
        iterator.call(receiver, array[i], i, array);
      }
    }
  }
};
var forEachString = function forEachString(string, iterator, receiver) {
  for (var i = 0, len = string.length; i < len; i++) {
    // no such thing as a sparse string.
    if (receiver == null) {
      iterator(string.charAt(i), i, string);
    } else {
      iterator.call(receiver, string.charAt(i), i, string);
    }
  }
};
var forEachObject = function forEachObject(object, iterator, receiver) {
  for (var k in object) {
    if (hasOwnProperty.call(object, k)) {
      if (receiver == null) {
        iterator(object[k], k, object);
      } else {
        iterator.call(receiver, object[k], k, object);
      }
    }
  }
};
var forEach = function forEach(list, iterator, thisArg) {
  if (!isCallable(iterator)) {
    throw new TypeError('iterator must be a function');
  }
  var receiver;
  if (arguments.length >= 3) {
    receiver = thisArg;
  }
  if (toStr.call(list) === '[object Array]') {
    forEachArray(list, iterator, receiver);
  } else if (typeof list === 'string') {
    forEachString(list, iterator, receiver);
  } else {
    forEachObject(list, iterator, receiver);
  }
};
module.exports = forEach;

/***/ }),

/***/ 23632:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* eslint no-invalid-this: 1 */
__webpack_require__(41539);
var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';
var concatty = function concatty(a, b) {
  var arr = [];
  for (var i = 0; i < a.length; i += 1) {
    arr[i] = a[i];
  }
  for (var j = 0; j < b.length; j += 1) {
    arr[j + a.length] = b[j];
  }
  return arr;
};
var slicy = function slicy(arrLike, offset) {
  var arr = [];
  for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
    arr[j] = arrLike[i];
  }
  return arr;
};
var joiny = function joiny(arr, joiner) {
  var str = '';
  for (var i = 0; i < arr.length; i += 1) {
    str += arr[i];
    if (i + 1 < arr.length) {
      str += joiner;
    }
  }
  return str;
};
module.exports = function bind(that) {
  var target = this;
  if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
    throw new TypeError(ERROR_MESSAGE + target);
  }
  var args = slicy(arguments, 1);
  var bound;
  var binder = function binder() {
    if (this instanceof bound) {
      var result = target.apply(this, concatty(args, arguments));
      if (Object(result) === result) {
        return result;
      }
      return this;
    }
    return target.apply(that, concatty(args, arguments));
  };
  var boundLength = max(0, target.length - args.length);
  var boundArgs = [];
  for (var i = 0; i < boundLength; i++) {
    boundArgs[i] = '$' + i;
  }
  bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
  if (target.prototype) {
    var Empty = function Empty() {};
    Empty.prototype = target.prototype;
    bound.prototype = new Empty();
    Empty.prototype = null;
  }
  return bound;
};

/***/ }),

/***/ 23723:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var implementation = __webpack_require__(23632);
module.exports = Function.prototype.bind || implementation;

/***/ }),

/***/ 68237:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(68309);
__webpack_require__(38880);
var functionsHaveNames = function functionsHaveNames() {
  return typeof function f() {}.name === 'string';
};
var gOPD = Object.getOwnPropertyDescriptor;
if (gOPD) {
  try {
    gOPD([], 'length');
  } catch (e) {
    // IE 8 has a broken gOPD
    gOPD = null;
  }
}
functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
  if (!functionsHaveNames() || !gOPD) {
    return false;
  }
  var desc = gOPD(function () {}, 'name');
  return !!desc && !!desc.configurable;
};
var $bind = Function.prototype.bind;
functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
  return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
};
module.exports = functionsHaveNames;

/***/ }),

/***/ 37555:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(38880);
__webpack_require__(30489);
__webpack_require__(66992);
__webpack_require__(41539);
__webpack_require__(82472);
__webpack_require__(92990);
__webpack_require__(18927);
__webpack_require__(33105);
__webpack_require__(35035);
__webpack_require__(74345);
__webpack_require__(7174);
__webpack_require__(32846);
__webpack_require__(44731);
__webpack_require__(77209);
__webpack_require__(96319);
__webpack_require__(58867);
__webpack_require__(37789);
__webpack_require__(33739);
__webpack_require__(29368);
__webpack_require__(14483);
__webpack_require__(12056);
__webpack_require__(3462);
__webpack_require__(30678);
__webpack_require__(27462);
__webpack_require__(33824);
__webpack_require__(55021);
__webpack_require__(12974);
__webpack_require__(15016);
__webpack_require__(8628);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(18264);
__webpack_require__(32165);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(44197);
__webpack_require__(76495);
__webpack_require__(87145);
__webpack_require__(35109);
__webpack_require__(65125);
__webpack_require__(51532);
__webpack_require__(9653);
__webpack_require__(24603);
__webpack_require__(74916);
__webpack_require__(39714);
__webpack_require__(70189);
__webpack_require__(49743);
__webpack_require__(8255);
__webpack_require__(29135);
__webpack_require__(4129);
__webpack_require__(38478);
__webpack_require__(92222);
__webpack_require__(40561);
__webpack_require__(15306);
__webpack_require__(68309);
var undefined;
var $Error = __webpack_require__(4468);
var $EvalError = __webpack_require__(36891);
var $RangeError = __webpack_require__(77754);
var $ReferenceError = __webpack_require__(14025);
var $SyntaxError = __webpack_require__(59743);
var $TypeError = __webpack_require__(13237);
var $URIError = __webpack_require__(35725);
var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function getEvalledConstructor(expressionSyntax) {
  try {
    return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
  } catch (e) {}
};
var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
  try {
    $gOPD({}, '');
  } catch (e) {
    $gOPD = null; // this is IE 8, which has a broken gOPD
  }
}

var throwTypeError = function throwTypeError() {
  throw new $TypeError();
};
var ThrowTypeError = $gOPD ? function () {
  try {
    // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
    arguments.callee; // IE 8 does not throw here
    return throwTypeError;
  } catch (calleeThrows) {
    try {
      // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
      return $gOPD(arguments, 'callee').get;
    } catch (gOPDthrows) {
      return throwTypeError;
    }
  }
}() : throwTypeError;
var hasSymbols = __webpack_require__(98949)();
var hasProto = __webpack_require__(64312)();
var getProto = Object.getPrototypeOf || (hasProto ? function (x) {
  return x.__proto__;
} // eslint-disable-line no-proto
: null);
var needsEval = {};
var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);
var INTRINSICS = {
  __proto__: null,
  '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
  '%Array%': Array,
  '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
  '%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
  '%AsyncFromSyncIteratorPrototype%': undefined,
  '%AsyncFunction%': needsEval,
  '%AsyncGenerator%': needsEval,
  '%AsyncGeneratorFunction%': needsEval,
  '%AsyncIteratorPrototype%': needsEval,
  '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
  '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
  '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
  '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
  '%Boolean%': Boolean,
  '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
  '%Date%': Date,
  '%decodeURI%': decodeURI,
  '%decodeURIComponent%': decodeURIComponent,
  '%encodeURI%': encodeURI,
  '%encodeURIComponent%': encodeURIComponent,
  '%Error%': $Error,
  '%eval%': eval,
  // eslint-disable-line no-eval
  '%EvalError%': $EvalError,
  '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
  '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
  '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
  '%Function%': $Function,
  '%GeneratorFunction%': needsEval,
  '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
  '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
  '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
  '%isFinite%': isFinite,
  '%isNaN%': isNaN,
  '%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
  '%JSON%': (typeof JSON === "undefined" ? "undefined" : _typeof(JSON)) === 'object' ? JSON : undefined,
  '%Map%': typeof Map === 'undefined' ? undefined : Map,
  '%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
  '%Math%': Math,
  '%Number%': Number,
  '%Object%': Object,
  '%parseFloat%': parseFloat,
  '%parseInt%': parseInt,
  '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
  '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
  '%RangeError%': $RangeError,
  '%ReferenceError%': $ReferenceError,
  '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
  '%RegExp%': RegExp,
  '%Set%': typeof Set === 'undefined' ? undefined : Set,
  '%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
  '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
  '%String%': String,
  '%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
  '%Symbol%': hasSymbols ? Symbol : undefined,
  '%SyntaxError%': $SyntaxError,
  '%ThrowTypeError%': ThrowTypeError,
  '%TypedArray%': TypedArray,
  '%TypeError%': $TypeError,
  '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
  '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
  '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
  '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
  '%URIError%': $URIError,
  '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
  '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
  '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};
if (getProto) {
  try {
    null.error; // eslint-disable-line no-unused-expressions
  } catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var errorProto = getProto(getProto(e));
    INTRINSICS['%Error.prototype%'] = errorProto;
  }
}
var doEval = function doEval(name) {
  var value;
  if (name === '%AsyncFunction%') {
    value = getEvalledConstructor('async function () {}');
  } else if (name === '%GeneratorFunction%') {
    value = getEvalledConstructor('function* () {}');
  } else if (name === '%AsyncGeneratorFunction%') {
    value = getEvalledConstructor('async function* () {}');
  } else if (name === '%AsyncGenerator%') {
    var fn = doEval('%AsyncGeneratorFunction%');
    if (fn) {
      value = fn.prototype;
    }
  } else if (name === '%AsyncIteratorPrototype%') {
    var gen = doEval('%AsyncGenerator%');
    if (gen && getProto) {
      value = getProto(gen.prototype);
    }
  }
  INTRINSICS[name] = value;
  return value;
};
var LEGACY_ALIASES = {
  __proto__: null,
  '%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
  '%ArrayPrototype%': ['Array', 'prototype'],
  '%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
  '%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
  '%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
  '%ArrayProto_values%': ['Array', 'prototype', 'values'],
  '%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
  '%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
  '%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
  '%BooleanPrototype%': ['Boolean', 'prototype'],
  '%DataViewPrototype%': ['DataView', 'prototype'],
  '%DatePrototype%': ['Date', 'prototype'],
  '%ErrorPrototype%': ['Error', 'prototype'],
  '%EvalErrorPrototype%': ['EvalError', 'prototype'],
  '%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
  '%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
  '%FunctionPrototype%': ['Function', 'prototype'],
  '%Generator%': ['GeneratorFunction', 'prototype'],
  '%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
  '%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
  '%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
  '%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
  '%JSONParse%': ['JSON', 'parse'],
  '%JSONStringify%': ['JSON', 'stringify'],
  '%MapPrototype%': ['Map', 'prototype'],
  '%NumberPrototype%': ['Number', 'prototype'],
  '%ObjectPrototype%': ['Object', 'prototype'],
  '%ObjProto_toString%': ['Object', 'prototype', 'toString'],
  '%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
  '%PromisePrototype%': ['Promise', 'prototype'],
  '%PromiseProto_then%': ['Promise', 'prototype', 'then'],
  '%Promise_all%': ['Promise', 'all'],
  '%Promise_reject%': ['Promise', 'reject'],
  '%Promise_resolve%': ['Promise', 'resolve'],
  '%RangeErrorPrototype%': ['RangeError', 'prototype'],
  '%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
  '%RegExpPrototype%': ['RegExp', 'prototype'],
  '%SetPrototype%': ['Set', 'prototype'],
  '%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
  '%StringPrototype%': ['String', 'prototype'],
  '%SymbolPrototype%': ['Symbol', 'prototype'],
  '%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
  '%TypedArrayPrototype%': ['TypedArray', 'prototype'],
  '%TypeErrorPrototype%': ['TypeError', 'prototype'],
  '%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
  '%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
  '%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
  '%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
  '%URIErrorPrototype%': ['URIError', 'prototype'],
  '%WeakMapPrototype%': ['WeakMap', 'prototype'],
  '%WeakSetPrototype%': ['WeakSet', 'prototype']
};
var bind = __webpack_require__(23723);
var hasOwn = __webpack_require__(94672);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
  var first = $strSlice(string, 0, 1);
  var last = $strSlice(string, -1);
  if (first === '%' && last !== '%') {
    throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
  } else if (last === '%' && first !== '%') {
    throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
  }
  var result = [];
  $replace(string, rePropName, function (match, number, quote, subString) {
    result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
  });
  return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
  var intrinsicName = name;
  var alias;
  if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
    alias = LEGACY_ALIASES[intrinsicName];
    intrinsicName = '%' + alias[0] + '%';
  }
  if (hasOwn(INTRINSICS, intrinsicName)) {
    var value = INTRINSICS[intrinsicName];
    if (value === needsEval) {
      value = doEval(intrinsicName);
    }
    if (typeof value === 'undefined' && !allowMissing) {
      throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
    }
    return {
      alias: alias,
      name: intrinsicName,
      value: value
    };
  }
  throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
  if (typeof name !== 'string' || name.length === 0) {
    throw new $TypeError('intrinsic name must be a non-empty string');
  }
  if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
    throw new $TypeError('"allowMissing" argument must be a boolean');
  }
  if ($exec(/^%?[^%]*%?$/, name) === null) {
    throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
  }
  var parts = stringToPath(name);
  var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
  var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
  var intrinsicRealName = intrinsic.name;
  var value = intrinsic.value;
  var skipFurtherCaching = false;
  var alias = intrinsic.alias;
  if (alias) {
    intrinsicBaseName = alias[0];
    $spliceApply(parts, $concat([0, 1], alias));
  }
  for (var i = 1, isOwn = true; i < parts.length; i += 1) {
    var part = parts[i];
    var first = $strSlice(part, 0, 1);
    var last = $strSlice(part, -1);
    if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) {
      throw new $SyntaxError('property names with quotes must have matching quotes');
    }
    if (part === 'constructor' || !isOwn) {
      skipFurtherCaching = true;
    }
    intrinsicBaseName += '.' + part;
    intrinsicRealName = '%' + intrinsicBaseName + '%';
    if (hasOwn(INTRINSICS, intrinsicRealName)) {
      value = INTRINSICS[intrinsicRealName];
    } else if (value != null) {
      if (!(part in value)) {
        if (!allowMissing) {
          throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
        }
        return void undefined;
      }
      if ($gOPD && i + 1 >= parts.length) {
        var desc = $gOPD(value, part);
        isOwn = !!desc;

        // By convention, when a data property is converted to an accessor
        // property to emulate a data property that does not suffer from
        // the override mistake, that accessor's getter is marked with
        // an `originalValue` property. Here, when we detect this, we
        // uphold the illusion by pretending to see that original data
        // property, i.e., returning the value rather than the getter
        // itself.
        if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
          value = desc.get;
        } else {
          value = value[part];
        }
      } else {
        isOwn = hasOwn(value, part);
        value = value[part];
      }
      if (isOwn && !skipFurtherCaching) {
        INTRINSICS[intrinsicRealName] = value;
      }
    }
  }
  return value;
};

/***/ }),

/***/ 56374:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var topLevel = typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof window !== 'undefined' ? window : {};
var minDoc = __webpack_require__(25893);
var doccy;
if (typeof document !== 'undefined') {
  doccy = document;
} else {
  doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'];
  if (!doccy) {
    doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'] = minDoc;
  }
}
module.exports = doccy;

/***/ }),

/***/ 95732:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var win;
if (typeof window !== "undefined") {
  win = window;
} else if (typeof __webpack_require__.g !== "undefined") {
  win = __webpack_require__.g;
} else if (typeof self !== "undefined") {
  win = self;
} else {
  win = {};
}
module.exports = win;

/***/ }),

/***/ 12500:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(37555);
var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
if ($gOPD) {
  try {
    $gOPD([], 'length');
  } catch (e) {
    // IE 8 has a broken gOPD
    $gOPD = null;
  }
}
module.exports = $gOPD;

/***/ }),

/***/ 10482:
/***/ ((module) => {

"use strict";


var $BigInt = typeof BigInt !== 'undefined' && BigInt;
module.exports = function hasNativeBigInts() {
  return typeof $BigInt === 'function' && typeof BigInt === 'function' && typeof $BigInt(42) === 'bigint' // eslint-disable-line no-magic-numbers
  && typeof BigInt(42) === 'bigint'; // eslint-disable-line no-magic-numbers
};

/***/ }),

/***/ 17536:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var $defineProperty = __webpack_require__(61597);
var hasPropertyDescriptors = function hasPropertyDescriptors() {
  return !!$defineProperty;
};
hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
  // node v0.6 has a bug where array lengths can be Set but not Defined
  if (!$defineProperty) {
    return null;
  }
  try {
    return $defineProperty([], 'length', {
      value: 1
    }).length !== 1;
  } catch (e) {
    // In Firefox 4-22, defining length on an array throws an exception.
    return true;
  }
};
module.exports = hasPropertyDescriptors;

/***/ }),

/***/ 64312:
/***/ ((module) => {

"use strict";


var test = {
  __proto__: null,
  foo: {}
};
var $Object = Object;

/** @type {import('.')} */
module.exports = function hasProto() {
  // @ts-expect-error: TS errors on an inherited property for some reason
  return {
    __proto__: test
  }.foo === test.foo && !(test instanceof $Object);
};

/***/ }),

/***/ 98949:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(3810);
module.exports = function hasNativeSymbols() {
  if (typeof origSymbol !== 'function') {
    return false;
  }
  if (typeof Symbol !== 'function') {
    return false;
  }
  if (_typeof(origSymbol('foo')) !== 'symbol') {
    return false;
  }
  if (_typeof(Symbol('bar')) !== 'symbol') {
    return false;
  }
  return hasSymbolSham();
};

/***/ }),

/***/ 3810:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(47941);
__webpack_require__(36210);
__webpack_require__(38880);
module.exports = function hasSymbols() {
  if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') {
    return false;
  }
  if (_typeof(Symbol.iterator) === 'symbol') {
    return true;
  }
  var obj = {};
  var sym = Symbol('test');
  var symObj = Object(sym);
  if (typeof sym === 'string') {
    return false;
  }
  if (Object.prototype.toString.call(sym) !== '[object Symbol]') {
    return false;
  }
  if (Object.prototype.toString.call(symObj) !== '[object Symbol]') {
    return false;
  }

  // temp disabled per https://github.com/ljharb/object.assign/issues/17
  // if (sym instanceof Symbol) { return false; }
  // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
  // if (!(symObj instanceof Symbol)) { return false; }

  // if (typeof Symbol.prototype.toString !== 'function') { return false; }
  // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

  var symVal = 42;
  obj[sym] = symVal;
  for (sym in obj) {
    return false;
  } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
  if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) {
    return false;
  }
  if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) {
    return false;
  }
  var syms = Object.getOwnPropertySymbols(obj);
  if (syms.length !== 1 || syms[0] !== sym) {
    return false;
  }
  if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
    return false;
  }
  if (typeof Object.getOwnPropertyDescriptor === 'function') {
    var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
    if (descriptor.value !== symVal || descriptor.enumerable !== true) {
      return false;
    }
  }
  return true;
};

/***/ }),

/***/ 80297:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(39341);
__webpack_require__(73706);
__webpack_require__(10408);
__webpack_require__(41539);
__webpack_require__(82526);
__webpack_require__(41817);
var hasSymbols = __webpack_require__(3810);

/** @type {import('.')} */
module.exports = function hasToStringTagShams() {
  return hasSymbols() && !!Symbol.toStringTag;
};

/***/ }),

/***/ 94672:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(23723);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);

/***/ }),

/***/ 25746:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;__webpack_require__(41539);
__webpack_require__(39714);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
/*! https://mths.be/he v1.2.0 by @mathias | MIT license */
;
(function (root) {
  // Detect free variables `exports`.
  var freeExports = ( false ? 0 : _typeof(exports)) == 'object' && exports;

  // Detect free variable `module`.
  var freeModule = ( false ? 0 : _typeof(module)) == 'object' && module && module.exports == freeExports && module;

  // Detect free variable `global`, from Node.js or Browserified code,
  // and use it as `root`.
  var freeGlobal = (typeof __webpack_require__.g === "undefined" ? "undefined" : _typeof(__webpack_require__.g)) == 'object' && __webpack_require__.g;
  if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
    root = freeGlobal;
  }

  /*--------------------------------------------------------------------------*/

  // All astral symbols.
  var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  // All ASCII symbols (not just printable ASCII) except those listed in the
  // first column of the overrides table.
  // https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides
  var regexAsciiWhitelist = /[\x01-\x7F]/g;
  // All BMP symbols that are not ASCII newlines, printable ASCII symbols, or
  // code points listed in the first column of the overrides table on
  // https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides.
  var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
  var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
  var encodeMap = {
    '\xAD': 'shy',
    "\u200C": 'zwnj',
    "\u200D": 'zwj',
    "\u200E": 'lrm',
    "\u2063": 'ic',
    "\u2062": 'it',
    "\u2061": 'af',
    "\u200F": 'rlm',
    "\u200B": 'ZeroWidthSpace',
    "\u2060": 'NoBreak',
    "\u0311": 'DownBreve',
    "\u20DB": 'tdot',
    "\u20DC": 'DotDot',
    '\t': 'Tab',
    '\n': 'NewLine',
    "\u2008": 'puncsp',
    "\u205F": 'MediumSpace',
    "\u2009": 'thinsp',
    "\u200A": 'hairsp',
    "\u2004": 'emsp13',
    "\u2002": 'ensp',
    "\u2005": 'emsp14',
    "\u2003": 'emsp',
    "\u2007": 'numsp',
    '\xA0': 'nbsp',
    "\u205F\u200A": 'ThickSpace',
    "\u203E": 'oline',
    '_': 'lowbar',
    "\u2010": 'dash',
    "\u2013": 'ndash',
    "\u2014": 'mdash',
    "\u2015": 'horbar',
    ',': 'comma',
    ';': 'semi',
    "\u204F": 'bsemi',
    ':': 'colon',
    "\u2A74": 'Colone',
    '!': 'excl',
    '\xA1': 'iexcl',
    '?': 'quest',
    '\xBF': 'iquest',
    '.': 'period',
    "\u2025": 'nldr',
    "\u2026": 'mldr',
    '\xB7': 'middot',
    '\'': 'apos',
    "\u2018": 'lsquo',
    "\u2019": 'rsquo',
    "\u201A": 'sbquo',
    "\u2039": 'lsaquo',
    "\u203A": 'rsaquo',
    '"': 'quot',
    "\u201C": 'ldquo',
    "\u201D": 'rdquo',
    "\u201E": 'bdquo',
    '\xAB': 'laquo',
    '\xBB': 'raquo',
    '(': 'lpar',
    ')': 'rpar',
    '[': 'lsqb',
    ']': 'rsqb',
    '{': 'lcub',
    '}': 'rcub',
    "\u2308": 'lceil',
    "\u2309": 'rceil',
    "\u230A": 'lfloor',
    "\u230B": 'rfloor',
    "\u2985": 'lopar',
    "\u2986": 'ropar',
    "\u298B": 'lbrke',
    "\u298C": 'rbrke',
    "\u298D": 'lbrkslu',
    "\u298E": 'rbrksld',
    "\u298F": 'lbrksld',
    "\u2990": 'rbrkslu',
    "\u2991": 'langd',
    "\u2992": 'rangd',
    "\u2993": 'lparlt',
    "\u2994": 'rpargt',
    "\u2995": 'gtlPar',
    "\u2996": 'ltrPar',
    "\u27E6": 'lobrk',
    "\u27E7": 'robrk',
    "\u27E8": 'lang',
    "\u27E9": 'rang',
    "\u27EA": 'Lang',
    "\u27EB": 'Rang',
    "\u27EC": 'loang',
    "\u27ED": 'roang',
    "\u2772": 'lbbrk',
    "\u2773": 'rbbrk',
    "\u2016": 'Vert',
    '\xA7': 'sect',
    '\xB6': 'para',
    '@': 'commat',
    '*': 'ast',
    '/': 'sol',
    'undefined': null,
    '&': 'amp',
    '#': 'num',
    '%': 'percnt',
    "\u2030": 'permil',
    "\u2031": 'pertenk',
    "\u2020": 'dagger',
    "\u2021": 'Dagger',
    "\u2022": 'bull',
    "\u2043": 'hybull',
    "\u2032": 'prime',
    "\u2033": 'Prime',
    "\u2034": 'tprime',
    "\u2057": 'qprime',
    "\u2035": 'bprime',
    "\u2041": 'caret',
    '`': 'grave',
    '\xB4': 'acute',
    "\u02DC": 'tilde',
    '^': 'Hat',
    '\xAF': 'macr',
    "\u02D8": 'breve',
    "\u02D9": 'dot',
    '\xA8': 'die',
    "\u02DA": 'ring',
    "\u02DD": 'dblac',
    '\xB8': 'cedil',
    "\u02DB": 'ogon',
    "\u02C6": 'circ',
    "\u02C7": 'caron',
    '\xB0': 'deg',
    '\xA9': 'copy',
    '\xAE': 'reg',
    "\u2117": 'copysr',
    "\u2118": 'wp',
    "\u211E": 'rx',
    "\u2127": 'mho',
    "\u2129": 'iiota',
    "\u2190": 'larr',
    "\u219A": 'nlarr',
    "\u2192": 'rarr',
    "\u219B": 'nrarr',
    "\u2191": 'uarr',
    "\u2193": 'darr',
    "\u2194": 'harr',
    "\u21AE": 'nharr',
    "\u2195": 'varr',
    "\u2196": 'nwarr',
    "\u2197": 'nearr',
    "\u2198": 'searr',
    "\u2199": 'swarr',
    "\u219D": 'rarrw',
    "\u219D\u0338": 'nrarrw',
    "\u219E": 'Larr',
    "\u219F": 'Uarr',
    "\u21A0": 'Rarr',
    "\u21A1": 'Darr',
    "\u21A2": 'larrtl',
    "\u21A3": 'rarrtl',
    "\u21A4": 'mapstoleft',
    "\u21A5": 'mapstoup',
    "\u21A6": 'map',
    "\u21A7": 'mapstodown',
    "\u21A9": 'larrhk',
    "\u21AA": 'rarrhk',
    "\u21AB": 'larrlp',
    "\u21AC": 'rarrlp',
    "\u21AD": 'harrw',
    "\u21B0": 'lsh',
    "\u21B1": 'rsh',
    "\u21B2": 'ldsh',
    "\u21B3": 'rdsh',
    "\u21B5": 'crarr',
    "\u21B6": 'cularr',
    "\u21B7": 'curarr',
    "\u21BA": 'olarr',
    "\u21BB": 'orarr',
    "\u21BC": 'lharu',
    "\u21BD": 'lhard',
    "\u21BE": 'uharr',
    "\u21BF": 'uharl',
    "\u21C0": 'rharu',
    "\u21C1": 'rhard',
    "\u21C2": 'dharr',
    "\u21C3": 'dharl',
    "\u21C4": 'rlarr',
    "\u21C5": 'udarr',
    "\u21C6": 'lrarr',
    "\u21C7": 'llarr',
    "\u21C8": 'uuarr',
    "\u21C9": 'rrarr',
    "\u21CA": 'ddarr',
    "\u21CB": 'lrhar',
    "\u21CC": 'rlhar',
    "\u21D0": 'lArr',
    "\u21CD": 'nlArr',
    "\u21D1": 'uArr',
    "\u21D2": 'rArr',
    "\u21CF": 'nrArr',
    "\u21D3": 'dArr',
    "\u21D4": 'iff',
    "\u21CE": 'nhArr',
    "\u21D5": 'vArr',
    "\u21D6": 'nwArr',
    "\u21D7": 'neArr',
    "\u21D8": 'seArr',
    "\u21D9": 'swArr',
    "\u21DA": 'lAarr',
    "\u21DB": 'rAarr',
    "\u21DD": 'zigrarr',
    "\u21E4": 'larrb',
    "\u21E5": 'rarrb',
    "\u21F5": 'duarr',
    "\u21FD": 'loarr',
    "\u21FE": 'roarr',
    "\u21FF": 'hoarr',
    "\u2200": 'forall',
    "\u2201": 'comp',
    "\u2202": 'part',
    "\u2202\u0338": 'npart',
    "\u2203": 'exist',
    "\u2204": 'nexist',
    "\u2205": 'empty',
    "\u2207": 'Del',
    "\u2208": 'in',
    "\u2209": 'notin',
    "\u220B": 'ni',
    "\u220C": 'notni',
    "\u03F6": 'bepsi',
    "\u220F": 'prod',
    "\u2210": 'coprod',
    "\u2211": 'sum',
    '+': 'plus',
    '\xB1': 'pm',
    '\xF7': 'div',
    '\xD7': 'times',
    '<': 'lt',
    "\u226E": 'nlt',
    "<\u20D2": 'nvlt',
    '=': 'equals',
    "\u2260": 'ne',
    "=\u20E5": 'bne',
    "\u2A75": 'Equal',
    '>': 'gt',
    "\u226F": 'ngt',
    ">\u20D2": 'nvgt',
    '\xAC': 'not',
    '|': 'vert',
    '\xA6': 'brvbar',
    "\u2212": 'minus',
    "\u2213": 'mp',
    "\u2214": 'plusdo',
    "\u2044": 'frasl',
    "\u2216": 'setmn',
    "\u2217": 'lowast',
    "\u2218": 'compfn',
    "\u221A": 'Sqrt',
    "\u221D": 'prop',
    "\u221E": 'infin',
    "\u221F": 'angrt',
    "\u2220": 'ang',
    "\u2220\u20D2": 'nang',
    "\u2221": 'angmsd',
    "\u2222": 'angsph',
    "\u2223": 'mid',
    "\u2224": 'nmid',
    "\u2225": 'par',
    "\u2226": 'npar',
    "\u2227": 'and',
    "\u2228": 'or',
    "\u2229": 'cap',
    "\u2229\uFE00": 'caps',
    "\u222A": 'cup',
    "\u222A\uFE00": 'cups',
    "\u222B": 'int',
    "\u222C": 'Int',
    "\u222D": 'tint',
    "\u2A0C": 'qint',
    "\u222E": 'oint',
    "\u222F": 'Conint',
    "\u2230": 'Cconint',
    "\u2231": 'cwint',
    "\u2232": 'cwconint',
    "\u2233": 'awconint',
    "\u2234": 'there4',
    "\u2235": 'becaus',
    "\u2236": 'ratio',
    "\u2237": 'Colon',
    "\u2238": 'minusd',
    "\u223A": 'mDDot',
    "\u223B": 'homtht',
    "\u223C": 'sim',
    "\u2241": 'nsim',
    "\u223C\u20D2": 'nvsim',
    "\u223D": 'bsim',
    "\u223D\u0331": 'race',
    "\u223E": 'ac',
    "\u223E\u0333": 'acE',
    "\u223F": 'acd',
    "\u2240": 'wr',
    "\u2242": 'esim',
    "\u2242\u0338": 'nesim',
    "\u2243": 'sime',
    "\u2244": 'nsime',
    "\u2245": 'cong',
    "\u2247": 'ncong',
    "\u2246": 'simne',
    "\u2248": 'ap',
    "\u2249": 'nap',
    "\u224A": 'ape',
    "\u224B": 'apid',
    "\u224B\u0338": 'napid',
    "\u224C": 'bcong',
    "\u224D": 'CupCap',
    "\u226D": 'NotCupCap',
    "\u224D\u20D2": 'nvap',
    "\u224E": 'bump',
    "\u224E\u0338": 'nbump',
    "\u224F": 'bumpe',
    "\u224F\u0338": 'nbumpe',
    "\u2250": 'doteq',
    "\u2250\u0338": 'nedot',
    "\u2251": 'eDot',
    "\u2252": 'efDot',
    "\u2253": 'erDot',
    "\u2254": 'colone',
    "\u2255": 'ecolon',
    "\u2256": 'ecir',
    "\u2257": 'cire',
    "\u2259": 'wedgeq',
    "\u225A": 'veeeq',
    "\u225C": 'trie',
    "\u225F": 'equest',
    "\u2261": 'equiv',
    "\u2262": 'nequiv',
    "\u2261\u20E5": 'bnequiv',
    "\u2264": 'le',
    "\u2270": 'nle',
    "\u2264\u20D2": 'nvle',
    "\u2265": 'ge',
    "\u2271": 'nge',
    "\u2265\u20D2": 'nvge',
    "\u2266": 'lE',
    "\u2266\u0338": 'nlE',
    "\u2267": 'gE',
    "\u2267\u0338": 'ngE',
    "\u2268\uFE00": 'lvnE',
    "\u2268": 'lnE',
    "\u2269": 'gnE',
    "\u2269\uFE00": 'gvnE',
    "\u226A": 'll',
    "\u226A\u0338": 'nLtv',
    "\u226A\u20D2": 'nLt',
    "\u226B": 'gg',
    "\u226B\u0338": 'nGtv',
    "\u226B\u20D2": 'nGt',
    "\u226C": 'twixt',
    "\u2272": 'lsim',
    "\u2274": 'nlsim',
    "\u2273": 'gsim',
    "\u2275": 'ngsim',
    "\u2276": 'lg',
    "\u2278": 'ntlg',
    "\u2277": 'gl',
    "\u2279": 'ntgl',
    "\u227A": 'pr',
    "\u2280": 'npr',
    "\u227B": 'sc',
    "\u2281": 'nsc',
    "\u227C": 'prcue',
    "\u22E0": 'nprcue',
    "\u227D": 'sccue',
    "\u22E1": 'nsccue',
    "\u227E": 'prsim',
    "\u227F": 'scsim',
    "\u227F\u0338": 'NotSucceedsTilde',
    "\u2282": 'sub',
    "\u2284": 'nsub',
    "\u2282\u20D2": 'vnsub',
    "\u2283": 'sup',
    "\u2285": 'nsup',
    "\u2283\u20D2": 'vnsup',
    "\u2286": 'sube',
    "\u2288": 'nsube',
    "\u2287": 'supe',
    "\u2289": 'nsupe',
    "\u228A\uFE00": 'vsubne',
    "\u228A": 'subne',
    "\u228B\uFE00": 'vsupne',
    "\u228B": 'supne',
    "\u228D": 'cupdot',
    "\u228E": 'uplus',
    "\u228F": 'sqsub',
    "\u228F\u0338": 'NotSquareSubset',
    "\u2290": 'sqsup',
    "\u2290\u0338": 'NotSquareSuperset',
    "\u2291": 'sqsube',
    "\u22E2": 'nsqsube',
    "\u2292": 'sqsupe',
    "\u22E3": 'nsqsupe',
    "\u2293": 'sqcap',
    "\u2293\uFE00": 'sqcaps',
    "\u2294": 'sqcup',
    "\u2294\uFE00": 'sqcups',
    "\u2295": 'oplus',
    "\u2296": 'ominus',
    "\u2297": 'otimes',
    "\u2298": 'osol',
    "\u2299": 'odot',
    "\u229A": 'ocir',
    "\u229B": 'oast',
    "\u229D": 'odash',
    "\u229E": 'plusb',
    "\u229F": 'minusb',
    "\u22A0": 'timesb',
    "\u22A1": 'sdotb',
    "\u22A2": 'vdash',
    "\u22AC": 'nvdash',
    "\u22A3": 'dashv',
    "\u22A4": 'top',
    "\u22A5": 'bot',
    "\u22A7": 'models',
    "\u22A8": 'vDash',
    "\u22AD": 'nvDash',
    "\u22A9": 'Vdash',
    "\u22AE": 'nVdash',
    "\u22AA": 'Vvdash',
    "\u22AB": 'VDash',
    "\u22AF": 'nVDash',
    "\u22B0": 'prurel',
    "\u22B2": 'vltri',
    "\u22EA": 'nltri',
    "\u22B3": 'vrtri',
    "\u22EB": 'nrtri',
    "\u22B4": 'ltrie',
    "\u22EC": 'nltrie',
    "\u22B4\u20D2": 'nvltrie',
    "\u22B5": 'rtrie',
    "\u22ED": 'nrtrie',
    "\u22B5\u20D2": 'nvrtrie',
    "\u22B6": 'origof',
    "\u22B7": 'imof',
    "\u22B8": 'mumap',
    "\u22B9": 'hercon',
    "\u22BA": 'intcal',
    "\u22BB": 'veebar',
    "\u22BD": 'barvee',
    "\u22BE": 'angrtvb',
    "\u22BF": 'lrtri',
    "\u22C0": 'Wedge',
    "\u22C1": 'Vee',
    "\u22C2": 'xcap',
    "\u22C3": 'xcup',
    "\u22C4": 'diam',
    "\u22C5": 'sdot',
    "\u22C6": 'Star',
    "\u22C7": 'divonx',
    "\u22C8": 'bowtie',
    "\u22C9": 'ltimes',
    "\u22CA": 'rtimes',
    "\u22CB": 'lthree',
    "\u22CC": 'rthree',
    "\u22CD": 'bsime',
    "\u22CE": 'cuvee',
    "\u22CF": 'cuwed',
    "\u22D0": 'Sub',
    "\u22D1": 'Sup',
    "\u22D2": 'Cap',
    "\u22D3": 'Cup',
    "\u22D4": 'fork',
    "\u22D5": 'epar',
    "\u22D6": 'ltdot',
    "\u22D7": 'gtdot',
    "\u22D8": 'Ll',
    "\u22D8\u0338": 'nLl',
    "\u22D9": 'Gg',
    "\u22D9\u0338": 'nGg',
    "\u22DA\uFE00": 'lesg',
    "\u22DA": 'leg',
    "\u22DB": 'gel',
    "\u22DB\uFE00": 'gesl',
    "\u22DE": 'cuepr',
    "\u22DF": 'cuesc',
    "\u22E6": 'lnsim',
    "\u22E7": 'gnsim',
    "\u22E8": 'prnsim',
    "\u22E9": 'scnsim',
    "\u22EE": 'vellip',
    "\u22EF": 'ctdot',
    "\u22F0": 'utdot',
    "\u22F1": 'dtdot',
    "\u22F2": 'disin',
    "\u22F3": 'isinsv',
    "\u22F4": 'isins',
    "\u22F5": 'isindot',
    "\u22F5\u0338": 'notindot',
    "\u22F6": 'notinvc',
    "\u22F7": 'notinvb',
    "\u22F9": 'isinE',
    "\u22F9\u0338": 'notinE',
    "\u22FA": 'nisd',
    "\u22FB": 'xnis',
    "\u22FC": 'nis',
    "\u22FD": 'notnivc',
    "\u22FE": 'notnivb',
    "\u2305": 'barwed',
    "\u2306": 'Barwed',
    "\u230C": 'drcrop',
    "\u230D": 'dlcrop',
    "\u230E": 'urcrop',
    "\u230F": 'ulcrop',
    "\u2310": 'bnot',
    "\u2312": 'profline',
    "\u2313": 'profsurf',
    "\u2315": 'telrec',
    "\u2316": 'target',
    "\u231C": 'ulcorn',
    "\u231D": 'urcorn',
    "\u231E": 'dlcorn',
    "\u231F": 'drcorn',
    "\u2322": 'frown',
    "\u2323": 'smile',
    "\u232D": 'cylcty',
    "\u232E": 'profalar',
    "\u2336": 'topbot',
    "\u233D": 'ovbar',
    "\u233F": 'solbar',
    "\u237C": 'angzarr',
    "\u23B0": 'lmoust',
    "\u23B1": 'rmoust',
    "\u23B4": 'tbrk',
    "\u23B5": 'bbrk',
    "\u23B6": 'bbrktbrk',
    "\u23DC": 'OverParenthesis',
    "\u23DD": 'UnderParenthesis',
    "\u23DE": 'OverBrace',
    "\u23DF": 'UnderBrace',
    "\u23E2": 'trpezium',
    "\u23E7": 'elinters',
    "\u2423": 'blank',
    "\u2500": 'boxh',
    "\u2502": 'boxv',
    "\u250C": 'boxdr',
    "\u2510": 'boxdl',
    "\u2514": 'boxur',
    "\u2518": 'boxul',
    "\u251C": 'boxvr',
    "\u2524": 'boxvl',
    "\u252C": 'boxhd',
    "\u2534": 'boxhu',
    "\u253C": 'boxvh',
    "\u2550": 'boxH',
    "\u2551": 'boxV',
    "\u2552": 'boxdR',
    "\u2553": 'boxDr',
    "\u2554": 'boxDR',
    "\u2555": 'boxdL',
    "\u2556": 'boxDl',
    "\u2557": 'boxDL',
    "\u2558": 'boxuR',
    "\u2559": 'boxUr',
    "\u255A": 'boxUR',
    "\u255B": 'boxuL',
    "\u255C": 'boxUl',
    "\u255D": 'boxUL',
    "\u255E": 'boxvR',
    "\u255F": 'boxVr',
    "\u2560": 'boxVR',
    "\u2561": 'boxvL',
    "\u2562": 'boxVl',
    "\u2563": 'boxVL',
    "\u2564": 'boxHd',
    "\u2565": 'boxhD',
    "\u2566": 'boxHD',
    "\u2567": 'boxHu',
    "\u2568": 'boxhU',
    "\u2569": 'boxHU',
    "\u256A": 'boxvH',
    "\u256B": 'boxVh',
    "\u256C": 'boxVH',
    "\u2580": 'uhblk',
    "\u2584": 'lhblk',
    "\u2588": 'block',
    "\u2591": 'blk14',
    "\u2592": 'blk12',
    "\u2593": 'blk34',
    "\u25A1": 'squ',
    "\u25AA": 'squf',
    "\u25AB": 'EmptyVerySmallSquare',
    "\u25AD": 'rect',
    "\u25AE": 'marker',
    "\u25B1": 'fltns',
    "\u25B3": 'xutri',
    "\u25B4": 'utrif',
    "\u25B5": 'utri',
    "\u25B8": 'rtrif',
    "\u25B9": 'rtri',
    "\u25BD": 'xdtri',
    "\u25BE": 'dtrif',
    "\u25BF": 'dtri',
    "\u25C2": 'ltrif',
    "\u25C3": 'ltri',
    "\u25CA": 'loz',
    "\u25CB": 'cir',
    "\u25EC": 'tridot',
    "\u25EF": 'xcirc',
    "\u25F8": 'ultri',
    "\u25F9": 'urtri',
    "\u25FA": 'lltri',
    "\u25FB": 'EmptySmallSquare',
    "\u25FC": 'FilledSmallSquare',
    "\u2605": 'starf',
    "\u2606": 'star',
    "\u260E": 'phone',
    "\u2640": 'female',
    "\u2642": 'male',
    "\u2660": 'spades',
    "\u2663": 'clubs',
    "\u2665": 'hearts',
    "\u2666": 'diams',
    "\u266A": 'sung',
    "\u2713": 'check',
    "\u2717": 'cross',
    "\u2720": 'malt',
    "\u2736": 'sext',
    "\u2758": 'VerticalSeparator',
    "\u27C8": 'bsolhsub',
    "\u27C9": 'suphsol',
    "\u27F5": 'xlarr',
    "\u27F6": 'xrarr',
    "\u27F7": 'xharr',
    "\u27F8": 'xlArr',
    "\u27F9": 'xrArr',
    "\u27FA": 'xhArr',
    "\u27FC": 'xmap',
    "\u27FF": 'dzigrarr',
    "\u2902": 'nvlArr',
    "\u2903": 'nvrArr',
    "\u2904": 'nvHarr',
    "\u2905": 'Map',
    "\u290C": 'lbarr',
    "\u290D": 'rbarr',
    "\u290E": 'lBarr',
    "\u290F": 'rBarr',
    "\u2910": 'RBarr',
    "\u2911": 'DDotrahd',
    "\u2912": 'UpArrowBar',
    "\u2913": 'DownArrowBar',
    "\u2916": 'Rarrtl',
    "\u2919": 'latail',
    "\u291A": 'ratail',
    "\u291B": 'lAtail',
    "\u291C": 'rAtail',
    "\u291D": 'larrfs',
    "\u291E": 'rarrfs',
    "\u291F": 'larrbfs',
    "\u2920": 'rarrbfs',
    "\u2923": 'nwarhk',
    "\u2924": 'nearhk',
    "\u2925": 'searhk',
    "\u2926": 'swarhk',
    "\u2927": 'nwnear',
    "\u2928": 'toea',
    "\u2929": 'tosa',
    "\u292A": 'swnwar',
    "\u2933": 'rarrc',
    "\u2933\u0338": 'nrarrc',
    "\u2935": 'cudarrr',
    "\u2936": 'ldca',
    "\u2937": 'rdca',
    "\u2938": 'cudarrl',
    "\u2939": 'larrpl',
    "\u293C": 'curarrm',
    "\u293D": 'cularrp',
    "\u2945": 'rarrpl',
    "\u2948": 'harrcir',
    "\u2949": 'Uarrocir',
    "\u294A": 'lurdshar',
    "\u294B": 'ldrushar',
    "\u294E": 'LeftRightVector',
    "\u294F": 'RightUpDownVector',
    "\u2950": 'DownLeftRightVector',
    "\u2951": 'LeftUpDownVector',
    "\u2952": 'LeftVectorBar',
    "\u2953": 'RightVectorBar',
    "\u2954": 'RightUpVectorBar',
    "\u2955": 'RightDownVectorBar',
    "\u2956": 'DownLeftVectorBar',
    "\u2957": 'DownRightVectorBar',
    "\u2958": 'LeftUpVectorBar',
    "\u2959": 'LeftDownVectorBar',
    "\u295A": 'LeftTeeVector',
    "\u295B": 'RightTeeVector',
    "\u295C": 'RightUpTeeVector',
    "\u295D": 'RightDownTeeVector',
    "\u295E": 'DownLeftTeeVector',
    "\u295F": 'DownRightTeeVector',
    "\u2960": 'LeftUpTeeVector',
    "\u2961": 'LeftDownTeeVector',
    "\u2962": 'lHar',
    "\u2963": 'uHar',
    "\u2964": 'rHar',
    "\u2965": 'dHar',
    "\u2966": 'luruhar',
    "\u2967": 'ldrdhar',
    "\u2968": 'ruluhar',
    "\u2969": 'rdldhar',
    "\u296A": 'lharul',
    "\u296B": 'llhard',
    "\u296C": 'rharul',
    "\u296D": 'lrhard',
    "\u296E": 'udhar',
    "\u296F": 'duhar',
    "\u2970": 'RoundImplies',
    "\u2971": 'erarr',
    "\u2972": 'simrarr',
    "\u2973": 'larrsim',
    "\u2974": 'rarrsim',
    "\u2975": 'rarrap',
    "\u2976": 'ltlarr',
    "\u2978": 'gtrarr',
    "\u2979": 'subrarr',
    "\u297B": 'suplarr',
    "\u297C": 'lfisht',
    "\u297D": 'rfisht',
    "\u297E": 'ufisht',
    "\u297F": 'dfisht',
    "\u299A": 'vzigzag',
    "\u299C": 'vangrt',
    "\u299D": 'angrtvbd',
    "\u29A4": 'ange',
    "\u29A5": 'range',
    "\u29A6": 'dwangle',
    "\u29A7": 'uwangle',
    "\u29A8": 'angmsdaa',
    "\u29A9": 'angmsdab',
    "\u29AA": 'angmsdac',
    "\u29AB": 'angmsdad',
    "\u29AC": 'angmsdae',
    "\u29AD": 'angmsdaf',
    "\u29AE": 'angmsdag',
    "\u29AF": 'angmsdah',
    "\u29B0": 'bemptyv',
    "\u29B1": 'demptyv',
    "\u29B2": 'cemptyv',
    "\u29B3": 'raemptyv',
    "\u29B4": 'laemptyv',
    "\u29B5": 'ohbar',
    "\u29B6": 'omid',
    "\u29B7": 'opar',
    "\u29B9": 'operp',
    "\u29BB": 'olcross',
    "\u29BC": 'odsold',
    "\u29BE": 'olcir',
    "\u29BF": 'ofcir',
    "\u29C0": 'olt',
    "\u29C1": 'ogt',
    "\u29C2": 'cirscir',
    "\u29C3": 'cirE',
    "\u29C4": 'solb',
    "\u29C5": 'bsolb',
    "\u29C9": 'boxbox',
    "\u29CD": 'trisb',
    "\u29CE": 'rtriltri',
    "\u29CF": 'LeftTriangleBar',
    "\u29CF\u0338": 'NotLeftTriangleBar',
    "\u29D0": 'RightTriangleBar',
    "\u29D0\u0338": 'NotRightTriangleBar',
    "\u29DC": 'iinfin',
    "\u29DD": 'infintie',
    "\u29DE": 'nvinfin',
    "\u29E3": 'eparsl',
    "\u29E4": 'smeparsl',
    "\u29E5": 'eqvparsl',
    "\u29EB": 'lozf',
    "\u29F4": 'RuleDelayed',
    "\u29F6": 'dsol',
    "\u2A00": 'xodot',
    "\u2A01": 'xoplus',
    "\u2A02": 'xotime',
    "\u2A04": 'xuplus',
    "\u2A06": 'xsqcup',
    "\u2A0D": 'fpartint',
    "\u2A10": 'cirfnint',
    "\u2A11": 'awint',
    "\u2A12": 'rppolint',
    "\u2A13": 'scpolint',
    "\u2A14": 'npolint',
    "\u2A15": 'pointint',
    "\u2A16": 'quatint',
    "\u2A17": 'intlarhk',
    "\u2A22": 'pluscir',
    "\u2A23": 'plusacir',
    "\u2A24": 'simplus',
    "\u2A25": 'plusdu',
    "\u2A26": 'plussim',
    "\u2A27": 'plustwo',
    "\u2A29": 'mcomma',
    "\u2A2A": 'minusdu',
    "\u2A2D": 'loplus',
    "\u2A2E": 'roplus',
    "\u2A2F": 'Cross',
    "\u2A30": 'timesd',
    "\u2A31": 'timesbar',
    "\u2A33": 'smashp',
    "\u2A34": 'lotimes',
    "\u2A35": 'rotimes',
    "\u2A36": 'otimesas',
    "\u2A37": 'Otimes',
    "\u2A38": 'odiv',
    "\u2A39": 'triplus',
    "\u2A3A": 'triminus',
    "\u2A3B": 'tritime',
    "\u2A3C": 'iprod',
    "\u2A3F": 'amalg',
    "\u2A40": 'capdot',
    "\u2A42": 'ncup',
    "\u2A43": 'ncap',
    "\u2A44": 'capand',
    "\u2A45": 'cupor',
    "\u2A46": 'cupcap',
    "\u2A47": 'capcup',
    "\u2A48": 'cupbrcap',
    "\u2A49": 'capbrcup',
    "\u2A4A": 'cupcup',
    "\u2A4B": 'capcap',
    "\u2A4C": 'ccups',
    "\u2A4D": 'ccaps',
    "\u2A50": 'ccupssm',
    "\u2A53": 'And',
    "\u2A54": 'Or',
    "\u2A55": 'andand',
    "\u2A56": 'oror',
    "\u2A57": 'orslope',
    "\u2A58": 'andslope',
    "\u2A5A": 'andv',
    "\u2A5B": 'orv',
    "\u2A5C": 'andd',
    "\u2A5D": 'ord',
    "\u2A5F": 'wedbar',
    "\u2A66": 'sdote',
    "\u2A6A": 'simdot',
    "\u2A6D": 'congdot',
    "\u2A6D\u0338": 'ncongdot',
    "\u2A6E": 'easter',
    "\u2A6F": 'apacir',
    "\u2A70": 'apE',
    "\u2A70\u0338": 'napE',
    "\u2A71": 'eplus',
    "\u2A72": 'pluse',
    "\u2A73": 'Esim',
    "\u2A77": 'eDDot',
    "\u2A78": 'equivDD',
    "\u2A79": 'ltcir',
    "\u2A7A": 'gtcir',
    "\u2A7B": 'ltquest',
    "\u2A7C": 'gtquest',
    "\u2A7D": 'les',
    "\u2A7D\u0338": 'nles',
    "\u2A7E": 'ges',
    "\u2A7E\u0338": 'nges',
    "\u2A7F": 'lesdot',
    "\u2A80": 'gesdot',
    "\u2A81": 'lesdoto',
    "\u2A82": 'gesdoto',
    "\u2A83": 'lesdotor',
    "\u2A84": 'gesdotol',
    "\u2A85": 'lap',
    "\u2A86": 'gap',
    "\u2A87": 'lne',
    "\u2A88": 'gne',
    "\u2A89": 'lnap',
    "\u2A8A": 'gnap',
    "\u2A8B": 'lEg',
    "\u2A8C": 'gEl',
    "\u2A8D": 'lsime',
    "\u2A8E": 'gsime',
    "\u2A8F": 'lsimg',
    "\u2A90": 'gsiml',
    "\u2A91": 'lgE',
    "\u2A92": 'glE',
    "\u2A93": 'lesges',
    "\u2A94": 'gesles',
    "\u2A95": 'els',
    "\u2A96": 'egs',
    "\u2A97": 'elsdot',
    "\u2A98": 'egsdot',
    "\u2A99": 'el',
    "\u2A9A": 'eg',
    "\u2A9D": 'siml',
    "\u2A9E": 'simg',
    "\u2A9F": 'simlE',
    "\u2AA0": 'simgE',
    "\u2AA1": 'LessLess',
    "\u2AA1\u0338": 'NotNestedLessLess',
    "\u2AA2": 'GreaterGreater',
    "\u2AA2\u0338": 'NotNestedGreaterGreater',
    "\u2AA4": 'glj',
    "\u2AA5": 'gla',
    "\u2AA6": 'ltcc',
    "\u2AA7": 'gtcc',
    "\u2AA8": 'lescc',
    "\u2AA9": 'gescc',
    "\u2AAA": 'smt',
    "\u2AAB": 'lat',
    "\u2AAC": 'smte',
    "\u2AAC\uFE00": 'smtes',
    "\u2AAD": 'late',
    "\u2AAD\uFE00": 'lates',
    "\u2AAE": 'bumpE',
    "\u2AAF": 'pre',
    "\u2AAF\u0338": 'npre',
    "\u2AB0": 'sce',
    "\u2AB0\u0338": 'nsce',
    "\u2AB3": 'prE',
    "\u2AB4": 'scE',
    "\u2AB5": 'prnE',
    "\u2AB6": 'scnE',
    "\u2AB7": 'prap',
    "\u2AB8": 'scap',
    "\u2AB9": 'prnap',
    "\u2ABA": 'scnap',
    "\u2ABB": 'Pr',
    "\u2ABC": 'Sc',
    "\u2ABD": 'subdot',
    "\u2ABE": 'supdot',
    "\u2ABF": 'subplus',
    "\u2AC0": 'supplus',
    "\u2AC1": 'submult',
    "\u2AC2": 'supmult',
    "\u2AC3": 'subedot',
    "\u2AC4": 'supedot',
    "\u2AC5": 'subE',
    "\u2AC5\u0338": 'nsubE',
    "\u2AC6": 'supE',
    "\u2AC6\u0338": 'nsupE',
    "\u2AC7": 'subsim',
    "\u2AC8": 'supsim',
    "\u2ACB\uFE00": 'vsubnE',
    "\u2ACB": 'subnE',
    "\u2ACC\uFE00": 'vsupnE',
    "\u2ACC": 'supnE',
    "\u2ACF": 'csub',
    "\u2AD0": 'csup',
    "\u2AD1": 'csube',
    "\u2AD2": 'csupe',
    "\u2AD3": 'subsup',
    "\u2AD4": 'supsub',
    "\u2AD5": 'subsub',
    "\u2AD6": 'supsup',
    "\u2AD7": 'suphsub',
    "\u2AD8": 'supdsub',
    "\u2AD9": 'forkv',
    "\u2ADA": 'topfork',
    "\u2ADB": 'mlcp',
    "\u2AE4": 'Dashv',
    "\u2AE6": 'Vdashl',
    "\u2AE7": 'Barv',
    "\u2AE8": 'vBar',
    "\u2AE9": 'vBarv',
    "\u2AEB": 'Vbar',
    "\u2AEC": 'Not',
    "\u2AED": 'bNot',
    "\u2AEE": 'rnmid',
    "\u2AEF": 'cirmid',
    "\u2AF0": 'midcir',
    "\u2AF1": 'topcir',
    "\u2AF2": 'nhpar',
    "\u2AF3": 'parsim',
    "\u2AFD": 'parsl',
    "\u2AFD\u20E5": 'nparsl',
    "\u266D": 'flat',
    "\u266E": 'natur',
    "\u266F": 'sharp',
    '\xA4': 'curren',
    '\xA2': 'cent',
    '$': 'dollar',
    '\xA3': 'pound',
    '\xA5': 'yen',
    "\u20AC": 'euro',
    '\xB9': 'sup1',
    '\xBD': 'half',
    "\u2153": 'frac13',
    '\xBC': 'frac14',
    "\u2155": 'frac15',
    "\u2159": 'frac16',
    "\u215B": 'frac18',
    '\xB2': 'sup2',
    "\u2154": 'frac23',
    "\u2156": 'frac25',
    '\xB3': 'sup3',
    '\xBE': 'frac34',
    "\u2157": 'frac35',
    "\u215C": 'frac38',
    "\u2158": 'frac45',
    "\u215A": 'frac56',
    "\u215D": 'frac58',
    "\u215E": 'frac78',
    "\uD835\uDCB6": 'ascr',
    "\uD835\uDD52": 'aopf',
    "\uD835\uDD1E": 'afr',
    "\uD835\uDD38": 'Aopf',
    "\uD835\uDD04": 'Afr',
    "\uD835\uDC9C": 'Ascr',
    '\xAA': 'ordf',
    '\xE1': 'aacute',
    '\xC1': 'Aacute',
    '\xE0': 'agrave',
    '\xC0': 'Agrave',
    "\u0103": 'abreve',
    "\u0102": 'Abreve',
    '\xE2': 'acirc',
    '\xC2': 'Acirc',
    '\xE5': 'aring',
    '\xC5': 'angst',
    '\xE4': 'auml',
    '\xC4': 'Auml',
    '\xE3': 'atilde',
    '\xC3': 'Atilde',
    "\u0105": 'aogon',
    "\u0104": 'Aogon',
    "\u0101": 'amacr',
    "\u0100": 'Amacr',
    '\xE6': 'aelig',
    '\xC6': 'AElig',
    "\uD835\uDCB7": 'bscr',
    "\uD835\uDD53": 'bopf',
    "\uD835\uDD1F": 'bfr',
    "\uD835\uDD39": 'Bopf',
    "\u212C": 'Bscr',
    "\uD835\uDD05": 'Bfr',
    "\uD835\uDD20": 'cfr',
    "\uD835\uDCB8": 'cscr',
    "\uD835\uDD54": 'copf',
    "\u212D": 'Cfr',
    "\uD835\uDC9E": 'Cscr',
    "\u2102": 'Copf',
    "\u0107": 'cacute',
    "\u0106": 'Cacute',
    "\u0109": 'ccirc',
    "\u0108": 'Ccirc',
    "\u010D": 'ccaron',
    "\u010C": 'Ccaron',
    "\u010B": 'cdot',
    "\u010A": 'Cdot',
    '\xE7': 'ccedil',
    '\xC7': 'Ccedil',
    "\u2105": 'incare',
    "\uD835\uDD21": 'dfr',
    "\u2146": 'dd',
    "\uD835\uDD55": 'dopf',
    "\uD835\uDCB9": 'dscr',
    "\uD835\uDC9F": 'Dscr',
    "\uD835\uDD07": 'Dfr',
    "\u2145": 'DD',
    "\uD835\uDD3B": 'Dopf',
    "\u010F": 'dcaron',
    "\u010E": 'Dcaron',
    "\u0111": 'dstrok',
    "\u0110": 'Dstrok',
    '\xF0': 'eth',
    '\xD0': 'ETH',
    "\u2147": 'ee',
    "\u212F": 'escr',
    "\uD835\uDD22": 'efr',
    "\uD835\uDD56": 'eopf',
    "\u2130": 'Escr',
    "\uD835\uDD08": 'Efr',
    "\uD835\uDD3C": 'Eopf',
    '\xE9': 'eacute',
    '\xC9': 'Eacute',
    '\xE8': 'egrave',
    '\xC8': 'Egrave',
    '\xEA': 'ecirc',
    '\xCA': 'Ecirc',
    "\u011B": 'ecaron',
    "\u011A": 'Ecaron',
    '\xEB': 'euml',
    '\xCB': 'Euml',
    "\u0117": 'edot',
    "\u0116": 'Edot',
    "\u0119": 'eogon',
    "\u0118": 'Eogon',
    "\u0113": 'emacr',
    "\u0112": 'Emacr',
    "\uD835\uDD23": 'ffr',
    "\uD835\uDD57": 'fopf',
    "\uD835\uDCBB": 'fscr',
    "\uD835\uDD09": 'Ffr',
    "\uD835\uDD3D": 'Fopf',
    "\u2131": 'Fscr',
    "\uFB00": 'fflig',
    "\uFB03": 'ffilig',
    "\uFB04": 'ffllig',
    "\uFB01": 'filig',
    'fj': 'fjlig',
    "\uFB02": 'fllig',
    "\u0192": 'fnof',
    "\u210A": 'gscr',
    "\uD835\uDD58": 'gopf',
    "\uD835\uDD24": 'gfr',
    "\uD835\uDCA2": 'Gscr',
    "\uD835\uDD3E": 'Gopf',
    "\uD835\uDD0A": 'Gfr',
    "\u01F5": 'gacute',
    "\u011F": 'gbreve',
    "\u011E": 'Gbreve',
    "\u011D": 'gcirc',
    "\u011C": 'Gcirc',
    "\u0121": 'gdot',
    "\u0120": 'Gdot',
    "\u0122": 'Gcedil',
    "\uD835\uDD25": 'hfr',
    "\u210E": 'planckh',
    "\uD835\uDCBD": 'hscr',
    "\uD835\uDD59": 'hopf',
    "\u210B": 'Hscr',
    "\u210C": 'Hfr',
    "\u210D": 'Hopf',
    "\u0125": 'hcirc',
    "\u0124": 'Hcirc',
    "\u210F": 'hbar',
    "\u0127": 'hstrok',
    "\u0126": 'Hstrok',
    "\uD835\uDD5A": 'iopf',
    "\uD835\uDD26": 'ifr',
    "\uD835\uDCBE": 'iscr',
    "\u2148": 'ii',
    "\uD835\uDD40": 'Iopf',
    "\u2110": 'Iscr',
    "\u2111": 'Im',
    '\xED': 'iacute',
    '\xCD': 'Iacute',
    '\xEC': 'igrave',
    '\xCC': 'Igrave',
    '\xEE': 'icirc',
    '\xCE': 'Icirc',
    '\xEF': 'iuml',
    '\xCF': 'Iuml',
    "\u0129": 'itilde',
    "\u0128": 'Itilde',
    "\u0130": 'Idot',
    "\u012F": 'iogon',
    "\u012E": 'Iogon',
    "\u012B": 'imacr',
    "\u012A": 'Imacr',
    "\u0133": 'ijlig',
    "\u0132": 'IJlig',
    "\u0131": 'imath',
    "\uD835\uDCBF": 'jscr',
    "\uD835\uDD5B": 'jopf',
    "\uD835\uDD27": 'jfr',
    "\uD835\uDCA5": 'Jscr',
    "\uD835\uDD0D": 'Jfr',
    "\uD835\uDD41": 'Jopf',
    "\u0135": 'jcirc',
    "\u0134": 'Jcirc',
    "\u0237": 'jmath',
    "\uD835\uDD5C": 'kopf',
    "\uD835\uDCC0": 'kscr',
    "\uD835\uDD28": 'kfr',
    "\uD835\uDCA6": 'Kscr',
    "\uD835\uDD42": 'Kopf',
    "\uD835\uDD0E": 'Kfr',
    "\u0137": 'kcedil',
    "\u0136": 'Kcedil',
    "\uD835\uDD29": 'lfr',
    "\uD835\uDCC1": 'lscr',
    "\u2113": 'ell',
    "\uD835\uDD5D": 'lopf',
    "\u2112": 'Lscr',
    "\uD835\uDD0F": 'Lfr',
    "\uD835\uDD43": 'Lopf',
    "\u013A": 'lacute',
    "\u0139": 'Lacute',
    "\u013E": 'lcaron',
    "\u013D": 'Lcaron',
    "\u013C": 'lcedil',
    "\u013B": 'Lcedil',
    "\u0142": 'lstrok',
    "\u0141": 'Lstrok',
    "\u0140": 'lmidot',
    "\u013F": 'Lmidot',
    "\uD835\uDD2A": 'mfr',
    "\uD835\uDD5E": 'mopf',
    "\uD835\uDCC2": 'mscr',
    "\uD835\uDD10": 'Mfr',
    "\uD835\uDD44": 'Mopf',
    "\u2133": 'Mscr',
    "\uD835\uDD2B": 'nfr',
    "\uD835\uDD5F": 'nopf',
    "\uD835\uDCC3": 'nscr',
    "\u2115": 'Nopf',
    "\uD835\uDCA9": 'Nscr',
    "\uD835\uDD11": 'Nfr',
    "\u0144": 'nacute',
    "\u0143": 'Nacute',
    "\u0148": 'ncaron',
    "\u0147": 'Ncaron',
    '\xF1': 'ntilde',
    '\xD1': 'Ntilde',
    "\u0146": 'ncedil',
    "\u0145": 'Ncedil',
    "\u2116": 'numero',
    "\u014B": 'eng',
    "\u014A": 'ENG',
    "\uD835\uDD60": 'oopf',
    "\uD835\uDD2C": 'ofr',
    "\u2134": 'oscr',
    "\uD835\uDCAA": 'Oscr',
    "\uD835\uDD12": 'Ofr',
    "\uD835\uDD46": 'Oopf',
    '\xBA': 'ordm',
    '\xF3': 'oacute',
    '\xD3': 'Oacute',
    '\xF2': 'ograve',
    '\xD2': 'Ograve',
    '\xF4': 'ocirc',
    '\xD4': 'Ocirc',
    '\xF6': 'ouml',
    '\xD6': 'Ouml',
    "\u0151": 'odblac',
    "\u0150": 'Odblac',
    '\xF5': 'otilde',
    '\xD5': 'Otilde',
    '\xF8': 'oslash',
    '\xD8': 'Oslash',
    "\u014D": 'omacr',
    "\u014C": 'Omacr',
    "\u0153": 'oelig',
    "\u0152": 'OElig',
    "\uD835\uDD2D": 'pfr',
    "\uD835\uDCC5": 'pscr',
    "\uD835\uDD61": 'popf',
    "\u2119": 'Popf',
    "\uD835\uDD13": 'Pfr',
    "\uD835\uDCAB": 'Pscr',
    "\uD835\uDD62": 'qopf',
    "\uD835\uDD2E": 'qfr',
    "\uD835\uDCC6": 'qscr',
    "\uD835\uDCAC": 'Qscr',
    "\uD835\uDD14": 'Qfr',
    "\u211A": 'Qopf',
    "\u0138": 'kgreen',
    "\uD835\uDD2F": 'rfr',
    "\uD835\uDD63": 'ropf',
    "\uD835\uDCC7": 'rscr',
    "\u211B": 'Rscr',
    "\u211C": 'Re',
    "\u211D": 'Ropf',
    "\u0155": 'racute',
    "\u0154": 'Racute',
    "\u0159": 'rcaron',
    "\u0158": 'Rcaron',
    "\u0157": 'rcedil',
    "\u0156": 'Rcedil',
    "\uD835\uDD64": 'sopf',
    "\uD835\uDCC8": 'sscr',
    "\uD835\uDD30": 'sfr',
    "\uD835\uDD4A": 'Sopf',
    "\uD835\uDD16": 'Sfr',
    "\uD835\uDCAE": 'Sscr',
    "\u24C8": 'oS',
    "\u015B": 'sacute',
    "\u015A": 'Sacute',
    "\u015D": 'scirc',
    "\u015C": 'Scirc',
    "\u0161": 'scaron',
    "\u0160": 'Scaron',
    "\u015F": 'scedil',
    "\u015E": 'Scedil',
    '\xDF': 'szlig',
    "\uD835\uDD31": 'tfr',
    "\uD835\uDCC9": 'tscr',
    "\uD835\uDD65": 'topf',
    "\uD835\uDCAF": 'Tscr',
    "\uD835\uDD17": 'Tfr',
    "\uD835\uDD4B": 'Topf',
    "\u0165": 'tcaron',
    "\u0164": 'Tcaron',
    "\u0163": 'tcedil',
    "\u0162": 'Tcedil',
    "\u2122": 'trade',
    "\u0167": 'tstrok',
    "\u0166": 'Tstrok',
    "\uD835\uDCCA": 'uscr',
    "\uD835\uDD66": 'uopf',
    "\uD835\uDD32": 'ufr',
    "\uD835\uDD4C": 'Uopf',
    "\uD835\uDD18": 'Ufr',
    "\uD835\uDCB0": 'Uscr',
    '\xFA': 'uacute',
    '\xDA': 'Uacute',
    '\xF9': 'ugrave',
    '\xD9': 'Ugrave',
    "\u016D": 'ubreve',
    "\u016C": 'Ubreve',
    '\xFB': 'ucirc',
    '\xDB': 'Ucirc',
    "\u016F": 'uring',
    "\u016E": 'Uring',
    '\xFC': 'uuml',
    '\xDC': 'Uuml',
    "\u0171": 'udblac',
    "\u0170": 'Udblac',
    "\u0169": 'utilde',
    "\u0168": 'Utilde',
    "\u0173": 'uogon',
    "\u0172": 'Uogon',
    "\u016B": 'umacr',
    "\u016A": 'Umacr',
    "\uD835\uDD33": 'vfr',
    "\uD835\uDD67": 'vopf',
    "\uD835\uDCCB": 'vscr',
    "\uD835\uDD19": 'Vfr',
    "\uD835\uDD4D": 'Vopf',
    "\uD835\uDCB1": 'Vscr',
    "\uD835\uDD68": 'wopf',
    "\uD835\uDCCC": 'wscr',
    "\uD835\uDD34": 'wfr',
    "\uD835\uDCB2": 'Wscr',
    "\uD835\uDD4E": 'Wopf',
    "\uD835\uDD1A": 'Wfr',
    "\u0175": 'wcirc',
    "\u0174": 'Wcirc',
    "\uD835\uDD35": 'xfr',
    "\uD835\uDCCD": 'xscr',
    "\uD835\uDD69": 'xopf',
    "\uD835\uDD4F": 'Xopf',
    "\uD835\uDD1B": 'Xfr',
    "\uD835\uDCB3": 'Xscr',
    "\uD835\uDD36": 'yfr',
    "\uD835\uDCCE": 'yscr',
    "\uD835\uDD6A": 'yopf',
    "\uD835\uDCB4": 'Yscr',
    "\uD835\uDD1C": 'Yfr',
    "\uD835\uDD50": 'Yopf',
    '\xFD': 'yacute',
    '\xDD': 'Yacute',
    "\u0177": 'ycirc',
    "\u0176": 'Ycirc',
    '\xFF': 'yuml',
    "\u0178": 'Yuml',
    "\uD835\uDCCF": 'zscr',
    "\uD835\uDD37": 'zfr',
    "\uD835\uDD6B": 'zopf',
    "\u2128": 'Zfr',
    "\u2124": 'Zopf',
    "\uD835\uDCB5": 'Zscr',
    "\u017A": 'zacute',
    "\u0179": 'Zacute',
    "\u017E": 'zcaron',
    "\u017D": 'Zcaron',
    "\u017C": 'zdot',
    "\u017B": 'Zdot',
    "\u01B5": 'imped',
    '\xFE': 'thorn',
    '\xDE': 'THORN',
    "\u0149": 'napos',
    "\u03B1": 'alpha',
    "\u0391": 'Alpha',
    "\u03B2": 'beta',
    "\u0392": 'Beta',
    "\u03B3": 'gamma',
    "\u0393": 'Gamma',
    "\u03B4": 'delta',
    "\u0394": 'Delta',
    "\u03B5": 'epsi',
    "\u03F5": 'epsiv',
    "\u0395": 'Epsilon',
    "\u03DD": 'gammad',
    "\u03DC": 'Gammad',
    "\u03B6": 'zeta',
    "\u0396": 'Zeta',
    "\u03B7": 'eta',
    "\u0397": 'Eta',
    "\u03B8": 'theta',
    "\u03D1": 'thetav',
    "\u0398": 'Theta',
    "\u03B9": 'iota',
    "\u0399": 'Iota',
    "\u03BA": 'kappa',
    "\u03F0": 'kappav',
    "\u039A": 'Kappa',
    "\u03BB": 'lambda',
    "\u039B": 'Lambda',
    "\u03BC": 'mu',
    '\xB5': 'micro',
    "\u039C": 'Mu',
    "\u03BD": 'nu',
    "\u039D": 'Nu',
    "\u03BE": 'xi',
    "\u039E": 'Xi',
    "\u03BF": 'omicron',
    "\u039F": 'Omicron',
    "\u03C0": 'pi',
    "\u03D6": 'piv',
    "\u03A0": 'Pi',
    "\u03C1": 'rho',
    "\u03F1": 'rhov',
    "\u03A1": 'Rho',
    "\u03C3": 'sigma',
    "\u03A3": 'Sigma',
    "\u03C2": 'sigmaf',
    "\u03C4": 'tau',
    "\u03A4": 'Tau',
    "\u03C5": 'upsi',
    "\u03A5": 'Upsilon',
    "\u03D2": 'Upsi',
    "\u03C6": 'phi',
    "\u03D5": 'phiv',
    "\u03A6": 'Phi',
    "\u03C7": 'chi',
    "\u03A7": 'Chi',
    "\u03C8": 'psi',
    "\u03A8": 'Psi',
    "\u03C9": 'omega',
    "\u03A9": 'ohm',
    "\u0430": 'acy',
    "\u0410": 'Acy',
    "\u0431": 'bcy',
    "\u0411": 'Bcy',
    "\u0432": 'vcy',
    "\u0412": 'Vcy',
    "\u0433": 'gcy',
    "\u0413": 'Gcy',
    "\u0453": 'gjcy',
    "\u0403": 'GJcy',
    "\u0434": 'dcy',
    "\u0414": 'Dcy',
    "\u0452": 'djcy',
    "\u0402": 'DJcy',
    "\u0435": 'iecy',
    "\u0415": 'IEcy',
    "\u0451": 'iocy',
    "\u0401": 'IOcy',
    "\u0454": 'jukcy',
    "\u0404": 'Jukcy',
    "\u0436": 'zhcy',
    "\u0416": 'ZHcy',
    "\u0437": 'zcy',
    "\u0417": 'Zcy',
    "\u0455": 'dscy',
    "\u0405": 'DScy',
    "\u0438": 'icy',
    "\u0418": 'Icy',
    "\u0456": 'iukcy',
    "\u0406": 'Iukcy',
    "\u0457": 'yicy',
    "\u0407": 'YIcy',
    "\u0439": 'jcy',
    "\u0419": 'Jcy',
    "\u0458": 'jsercy',
    "\u0408": 'Jsercy',
    "\u043A": 'kcy',
    "\u041A": 'Kcy',
    "\u045C": 'kjcy',
    "\u040C": 'KJcy',
    "\u043B": 'lcy',
    "\u041B": 'Lcy',
    "\u0459": 'ljcy',
    "\u0409": 'LJcy',
    "\u043C": 'mcy',
    "\u041C": 'Mcy',
    "\u043D": 'ncy',
    "\u041D": 'Ncy',
    "\u045A": 'njcy',
    "\u040A": 'NJcy',
    "\u043E": 'ocy',
    "\u041E": 'Ocy',
    "\u043F": 'pcy',
    "\u041F": 'Pcy',
    "\u0440": 'rcy',
    "\u0420": 'Rcy',
    "\u0441": 'scy',
    "\u0421": 'Scy',
    "\u0442": 'tcy',
    "\u0422": 'Tcy',
    "\u045B": 'tshcy',
    "\u040B": 'TSHcy',
    "\u0443": 'ucy',
    "\u0423": 'Ucy',
    "\u045E": 'ubrcy',
    "\u040E": 'Ubrcy',
    "\u0444": 'fcy',
    "\u0424": 'Fcy',
    "\u0445": 'khcy',
    "\u0425": 'KHcy',
    "\u0446": 'tscy',
    "\u0426": 'TScy',
    "\u0447": 'chcy',
    "\u0427": 'CHcy',
    "\u045F": 'dzcy',
    "\u040F": 'DZcy',
    "\u0448": 'shcy',
    "\u0428": 'SHcy',
    "\u0449": 'shchcy',
    "\u0429": 'SHCHcy',
    "\u044A": 'hardcy',
    "\u042A": 'HARDcy',
    "\u044B": 'ycy',
    "\u042B": 'Ycy',
    "\u044C": 'softcy',
    "\u042C": 'SOFTcy',
    "\u044D": 'ecy',
    "\u042D": 'Ecy',
    "\u044E": 'yucy',
    "\u042E": 'YUcy',
    "\u044F": 'yacy',
    "\u042F": 'YAcy',
    "\u2135": 'aleph',
    "\u2136": 'beth',
    "\u2137": 'gimel',
    "\u2138": 'daleth'
  };
  var regexEscape = /["&'<>`]/g;
  var escapeMap = {
    '"': '&quot;',
    '&': '&amp;',
    '\'': '&#x27;',
    '<': '&lt;',
    // See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
    // following is not strictly necessary unless it’s part of a tag or an
    // unquoted attribute value. We’re only escaping it to support those
    // situations, and for XML support.
    '>': '&gt;',
    // In Internet Explorer ≤ 8, the backtick character can be used
    // to break out of (un)quoted attribute values or HTML comments.
    // See http://html5sec.org/#102, http://html5sec.org/#108, and
    // http://html5sec.org/#133.
    '`': '&#x60;'
  };
  var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
  var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
  var regexDecode = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g;
  var decodeMap = {
    'aacute': '\xE1',
    'Aacute': '\xC1',
    'abreve': "\u0103",
    'Abreve': "\u0102",
    'ac': "\u223E",
    'acd': "\u223F",
    'acE': "\u223E\u0333",
    'acirc': '\xE2',
    'Acirc': '\xC2',
    'acute': '\xB4',
    'acy': "\u0430",
    'Acy': "\u0410",
    'aelig': '\xE6',
    'AElig': '\xC6',
    'af': "\u2061",
    'afr': "\uD835\uDD1E",
    'Afr': "\uD835\uDD04",
    'agrave': '\xE0',
    'Agrave': '\xC0',
    'alefsym': "\u2135",
    'aleph': "\u2135",
    'alpha': "\u03B1",
    'Alpha': "\u0391",
    'amacr': "\u0101",
    'Amacr': "\u0100",
    'amalg': "\u2A3F",
    'amp': '&',
    'AMP': '&',
    'and': "\u2227",
    'And': "\u2A53",
    'andand': "\u2A55",
    'andd': "\u2A5C",
    'andslope': "\u2A58",
    'andv': "\u2A5A",
    'ang': "\u2220",
    'ange': "\u29A4",
    'angle': "\u2220",
    'angmsd': "\u2221",
    'angmsdaa': "\u29A8",
    'angmsdab': "\u29A9",
    'angmsdac': "\u29AA",
    'angmsdad': "\u29AB",
    'angmsdae': "\u29AC",
    'angmsdaf': "\u29AD",
    'angmsdag': "\u29AE",
    'angmsdah': "\u29AF",
    'angrt': "\u221F",
    'angrtvb': "\u22BE",
    'angrtvbd': "\u299D",
    'angsph': "\u2222",
    'angst': '\xC5',
    'angzarr': "\u237C",
    'aogon': "\u0105",
    'Aogon': "\u0104",
    'aopf': "\uD835\uDD52",
    'Aopf': "\uD835\uDD38",
    'ap': "\u2248",
    'apacir': "\u2A6F",
    'ape': "\u224A",
    'apE': "\u2A70",
    'apid': "\u224B",
    'apos': '\'',
    'ApplyFunction': "\u2061",
    'approx': "\u2248",
    'approxeq': "\u224A",
    'aring': '\xE5',
    'Aring': '\xC5',
    'ascr': "\uD835\uDCB6",
    'Ascr': "\uD835\uDC9C",
    'Assign': "\u2254",
    'ast': '*',
    'asymp': "\u2248",
    'asympeq': "\u224D",
    'atilde': '\xE3',
    'Atilde': '\xC3',
    'auml': '\xE4',
    'Auml': '\xC4',
    'awconint': "\u2233",
    'awint': "\u2A11",
    'backcong': "\u224C",
    'backepsilon': "\u03F6",
    'backprime': "\u2035",
    'backsim': "\u223D",
    'backsimeq': "\u22CD",
    'Backslash': "\u2216",
    'Barv': "\u2AE7",
    'barvee': "\u22BD",
    'barwed': "\u2305",
    'Barwed': "\u2306",
    'barwedge': "\u2305",
    'bbrk': "\u23B5",
    'bbrktbrk': "\u23B6",
    'bcong': "\u224C",
    'bcy': "\u0431",
    'Bcy': "\u0411",
    'bdquo': "\u201E",
    'becaus': "\u2235",
    'because': "\u2235",
    'Because': "\u2235",
    'bemptyv': "\u29B0",
    'bepsi': "\u03F6",
    'bernou': "\u212C",
    'Bernoullis': "\u212C",
    'beta': "\u03B2",
    'Beta': "\u0392",
    'beth': "\u2136",
    'between': "\u226C",
    'bfr': "\uD835\uDD1F",
    'Bfr': "\uD835\uDD05",
    'bigcap': "\u22C2",
    'bigcirc': "\u25EF",
    'bigcup': "\u22C3",
    'bigodot': "\u2A00",
    'bigoplus': "\u2A01",
    'bigotimes': "\u2A02",
    'bigsqcup': "\u2A06",
    'bigstar': "\u2605",
    'bigtriangledown': "\u25BD",
    'bigtriangleup': "\u25B3",
    'biguplus': "\u2A04",
    'bigvee': "\u22C1",
    'bigwedge': "\u22C0",
    'bkarow': "\u290D",
    'blacklozenge': "\u29EB",
    'blacksquare': "\u25AA",
    'blacktriangle': "\u25B4",
    'blacktriangledown': "\u25BE",
    'blacktriangleleft': "\u25C2",
    'blacktriangleright': "\u25B8",
    'blank': "\u2423",
    'blk12': "\u2592",
    'blk14': "\u2591",
    'blk34': "\u2593",
    'block': "\u2588",
    'bne': "=\u20E5",
    'bnequiv': "\u2261\u20E5",
    'bnot': "\u2310",
    'bNot': "\u2AED",
    'bopf': "\uD835\uDD53",
    'Bopf': "\uD835\uDD39",
    'bot': "\u22A5",
    'bottom': "\u22A5",
    'bowtie': "\u22C8",
    'boxbox': "\u29C9",
    'boxdl': "\u2510",
    'boxdL': "\u2555",
    'boxDl': "\u2556",
    'boxDL': "\u2557",
    'boxdr': "\u250C",
    'boxdR': "\u2552",
    'boxDr': "\u2553",
    'boxDR': "\u2554",
    'boxh': "\u2500",
    'boxH': "\u2550",
    'boxhd': "\u252C",
    'boxhD': "\u2565",
    'boxHd': "\u2564",
    'boxHD': "\u2566",
    'boxhu': "\u2534",
    'boxhU': "\u2568",
    'boxHu': "\u2567",
    'boxHU': "\u2569",
    'boxminus': "\u229F",
    'boxplus': "\u229E",
    'boxtimes': "\u22A0",
    'boxul': "\u2518",
    'boxuL': "\u255B",
    'boxUl': "\u255C",
    'boxUL': "\u255D",
    'boxur': "\u2514",
    'boxuR': "\u2558",
    'boxUr': "\u2559",
    'boxUR': "\u255A",
    'boxv': "\u2502",
    'boxV': "\u2551",
    'boxvh': "\u253C",
    'boxvH': "\u256A",
    'boxVh': "\u256B",
    'boxVH': "\u256C",
    'boxvl': "\u2524",
    'boxvL': "\u2561",
    'boxVl': "\u2562",
    'boxVL': "\u2563",
    'boxvr': "\u251C",
    'boxvR': "\u255E",
    'boxVr': "\u255F",
    'boxVR': "\u2560",
    'bprime': "\u2035",
    'breve': "\u02D8",
    'Breve': "\u02D8",
    'brvbar': '\xA6',
    'bscr': "\uD835\uDCB7",
    'Bscr': "\u212C",
    'bsemi': "\u204F",
    'bsim': "\u223D",
    'bsime': "\u22CD",
    'bsol': '\\',
    'bsolb': "\u29C5",
    'bsolhsub': "\u27C8",
    'bull': "\u2022",
    'bullet': "\u2022",
    'bump': "\u224E",
    'bumpe': "\u224F",
    'bumpE': "\u2AAE",
    'bumpeq': "\u224F",
    'Bumpeq': "\u224E",
    'cacute': "\u0107",
    'Cacute': "\u0106",
    'cap': "\u2229",
    'Cap': "\u22D2",
    'capand': "\u2A44",
    'capbrcup': "\u2A49",
    'capcap': "\u2A4B",
    'capcup': "\u2A47",
    'capdot': "\u2A40",
    'CapitalDifferentialD': "\u2145",
    'caps': "\u2229\uFE00",
    'caret': "\u2041",
    'caron': "\u02C7",
    'Cayleys': "\u212D",
    'ccaps': "\u2A4D",
    'ccaron': "\u010D",
    'Ccaron': "\u010C",
    'ccedil': '\xE7',
    'Ccedil': '\xC7',
    'ccirc': "\u0109",
    'Ccirc': "\u0108",
    'Cconint': "\u2230",
    'ccups': "\u2A4C",
    'ccupssm': "\u2A50",
    'cdot': "\u010B",
    'Cdot': "\u010A",
    'cedil': '\xB8',
    'Cedilla': '\xB8',
    'cemptyv': "\u29B2",
    'cent': '\xA2',
    'centerdot': '\xB7',
    'CenterDot': '\xB7',
    'cfr': "\uD835\uDD20",
    'Cfr': "\u212D",
    'chcy': "\u0447",
    'CHcy': "\u0427",
    'check': "\u2713",
    'checkmark': "\u2713",
    'chi': "\u03C7",
    'Chi': "\u03A7",
    'cir': "\u25CB",
    'circ': "\u02C6",
    'circeq': "\u2257",
    'circlearrowleft': "\u21BA",
    'circlearrowright': "\u21BB",
    'circledast': "\u229B",
    'circledcirc': "\u229A",
    'circleddash': "\u229D",
    'CircleDot': "\u2299",
    'circledR': '\xAE',
    'circledS': "\u24C8",
    'CircleMinus': "\u2296",
    'CirclePlus': "\u2295",
    'CircleTimes': "\u2297",
    'cire': "\u2257",
    'cirE': "\u29C3",
    'cirfnint': "\u2A10",
    'cirmid': "\u2AEF",
    'cirscir': "\u29C2",
    'ClockwiseContourIntegral': "\u2232",
    'CloseCurlyDoubleQuote': "\u201D",
    'CloseCurlyQuote': "\u2019",
    'clubs': "\u2663",
    'clubsuit': "\u2663",
    'colon': ':',
    'Colon': "\u2237",
    'colone': "\u2254",
    'Colone': "\u2A74",
    'coloneq': "\u2254",
    'comma': ',',
    'commat': '@',
    'comp': "\u2201",
    'compfn': "\u2218",
    'complement': "\u2201",
    'complexes': "\u2102",
    'cong': "\u2245",
    'congdot': "\u2A6D",
    'Congruent': "\u2261",
    'conint': "\u222E",
    'Conint': "\u222F",
    'ContourIntegral': "\u222E",
    'copf': "\uD835\uDD54",
    'Copf': "\u2102",
    'coprod': "\u2210",
    'Coproduct': "\u2210",
    'copy': '\xA9',
    'COPY': '\xA9',
    'copysr': "\u2117",
    'CounterClockwiseContourIntegral': "\u2233",
    'crarr': "\u21B5",
    'cross': "\u2717",
    'Cross': "\u2A2F",
    'cscr': "\uD835\uDCB8",
    'Cscr': "\uD835\uDC9E",
    'csub': "\u2ACF",
    'csube': "\u2AD1",
    'csup': "\u2AD0",
    'csupe': "\u2AD2",
    'ctdot': "\u22EF",
    'cudarrl': "\u2938",
    'cudarrr': "\u2935",
    'cuepr': "\u22DE",
    'cuesc': "\u22DF",
    'cularr': "\u21B6",
    'cularrp': "\u293D",
    'cup': "\u222A",
    'Cup': "\u22D3",
    'cupbrcap': "\u2A48",
    'cupcap': "\u2A46",
    'CupCap': "\u224D",
    'cupcup': "\u2A4A",
    'cupdot': "\u228D",
    'cupor': "\u2A45",
    'cups': "\u222A\uFE00",
    'curarr': "\u21B7",
    'curarrm': "\u293C",
    'curlyeqprec': "\u22DE",
    'curlyeqsucc': "\u22DF",
    'curlyvee': "\u22CE",
    'curlywedge': "\u22CF",
    'curren': '\xA4',
    'curvearrowleft': "\u21B6",
    'curvearrowright': "\u21B7",
    'cuvee': "\u22CE",
    'cuwed': "\u22CF",
    'cwconint': "\u2232",
    'cwint': "\u2231",
    'cylcty': "\u232D",
    'dagger': "\u2020",
    'Dagger': "\u2021",
    'daleth': "\u2138",
    'darr': "\u2193",
    'dArr': "\u21D3",
    'Darr': "\u21A1",
    'dash': "\u2010",
    'dashv': "\u22A3",
    'Dashv': "\u2AE4",
    'dbkarow': "\u290F",
    'dblac': "\u02DD",
    'dcaron': "\u010F",
    'Dcaron': "\u010E",
    'dcy': "\u0434",
    'Dcy': "\u0414",
    'dd': "\u2146",
    'DD': "\u2145",
    'ddagger': "\u2021",
    'ddarr': "\u21CA",
    'DDotrahd': "\u2911",
    'ddotseq': "\u2A77",
    'deg': '\xB0',
    'Del': "\u2207",
    'delta': "\u03B4",
    'Delta': "\u0394",
    'demptyv': "\u29B1",
    'dfisht': "\u297F",
    'dfr': "\uD835\uDD21",
    'Dfr': "\uD835\uDD07",
    'dHar': "\u2965",
    'dharl': "\u21C3",
    'dharr': "\u21C2",
    'DiacriticalAcute': '\xB4',
    'DiacriticalDot': "\u02D9",
    'DiacriticalDoubleAcute': "\u02DD",
    'DiacriticalGrave': '`',
    'DiacriticalTilde': "\u02DC",
    'diam': "\u22C4",
    'diamond': "\u22C4",
    'Diamond': "\u22C4",
    'diamondsuit': "\u2666",
    'diams': "\u2666",
    'die': '\xA8',
    'DifferentialD': "\u2146",
    'digamma': "\u03DD",
    'disin': "\u22F2",
    'div': '\xF7',
    'divide': '\xF7',
    'divideontimes': "\u22C7",
    'divonx': "\u22C7",
    'djcy': "\u0452",
    'DJcy': "\u0402",
    'dlcorn': "\u231E",
    'dlcrop': "\u230D",
    'dollar': '$',
    'dopf': "\uD835\uDD55",
    'Dopf': "\uD835\uDD3B",
    'dot': "\u02D9",
    'Dot': '\xA8',
    'DotDot': "\u20DC",
    'doteq': "\u2250",
    'doteqdot': "\u2251",
    'DotEqual': "\u2250",
    'dotminus': "\u2238",
    'dotplus': "\u2214",
    'dotsquare': "\u22A1",
    'doublebarwedge': "\u2306",
    'DoubleContourIntegral': "\u222F",
    'DoubleDot': '\xA8',
    'DoubleDownArrow': "\u21D3",
    'DoubleLeftArrow': "\u21D0",
    'DoubleLeftRightArrow': "\u21D4",
    'DoubleLeftTee': "\u2AE4",
    'DoubleLongLeftArrow': "\u27F8",
    'DoubleLongLeftRightArrow': "\u27FA",
    'DoubleLongRightArrow': "\u27F9",
    'DoubleRightArrow': "\u21D2",
    'DoubleRightTee': "\u22A8",
    'DoubleUpArrow': "\u21D1",
    'DoubleUpDownArrow': "\u21D5",
    'DoubleVerticalBar': "\u2225",
    'downarrow': "\u2193",
    'Downarrow': "\u21D3",
    'DownArrow': "\u2193",
    'DownArrowBar': "\u2913",
    'DownArrowUpArrow': "\u21F5",
    'DownBreve': "\u0311",
    'downdownarrows': "\u21CA",
    'downharpoonleft': "\u21C3",
    'downharpoonright': "\u21C2",
    'DownLeftRightVector': "\u2950",
    'DownLeftTeeVector': "\u295E",
    'DownLeftVector': "\u21BD",
    'DownLeftVectorBar': "\u2956",
    'DownRightTeeVector': "\u295F",
    'DownRightVector': "\u21C1",
    'DownRightVectorBar': "\u2957",
    'DownTee': "\u22A4",
    'DownTeeArrow': "\u21A7",
    'drbkarow': "\u2910",
    'drcorn': "\u231F",
    'drcrop': "\u230C",
    'dscr': "\uD835\uDCB9",
    'Dscr': "\uD835\uDC9F",
    'dscy': "\u0455",
    'DScy': "\u0405",
    'dsol': "\u29F6",
    'dstrok': "\u0111",
    'Dstrok': "\u0110",
    'dtdot': "\u22F1",
    'dtri': "\u25BF",
    'dtrif': "\u25BE",
    'duarr': "\u21F5",
    'duhar': "\u296F",
    'dwangle': "\u29A6",
    'dzcy': "\u045F",
    'DZcy': "\u040F",
    'dzigrarr': "\u27FF",
    'eacute': '\xE9',
    'Eacute': '\xC9',
    'easter': "\u2A6E",
    'ecaron': "\u011B",
    'Ecaron': "\u011A",
    'ecir': "\u2256",
    'ecirc': '\xEA',
    'Ecirc': '\xCA',
    'ecolon': "\u2255",
    'ecy': "\u044D",
    'Ecy': "\u042D",
    'eDDot': "\u2A77",
    'edot': "\u0117",
    'eDot': "\u2251",
    'Edot': "\u0116",
    'ee': "\u2147",
    'efDot': "\u2252",
    'efr': "\uD835\uDD22",
    'Efr': "\uD835\uDD08",
    'eg': "\u2A9A",
    'egrave': '\xE8',
    'Egrave': '\xC8',
    'egs': "\u2A96",
    'egsdot': "\u2A98",
    'el': "\u2A99",
    'Element': "\u2208",
    'elinters': "\u23E7",
    'ell': "\u2113",
    'els': "\u2A95",
    'elsdot': "\u2A97",
    'emacr': "\u0113",
    'Emacr': "\u0112",
    'empty': "\u2205",
    'emptyset': "\u2205",
    'EmptySmallSquare': "\u25FB",
    'emptyv': "\u2205",
    'EmptyVerySmallSquare': "\u25AB",
    'emsp': "\u2003",
    'emsp13': "\u2004",
    'emsp14': "\u2005",
    'eng': "\u014B",
    'ENG': "\u014A",
    'ensp': "\u2002",
    'eogon': "\u0119",
    'Eogon': "\u0118",
    'eopf': "\uD835\uDD56",
    'Eopf': "\uD835\uDD3C",
    'epar': "\u22D5",
    'eparsl': "\u29E3",
    'eplus': "\u2A71",
    'epsi': "\u03B5",
    'epsilon': "\u03B5",
    'Epsilon': "\u0395",
    'epsiv': "\u03F5",
    'eqcirc': "\u2256",
    'eqcolon': "\u2255",
    'eqsim': "\u2242",
    'eqslantgtr': "\u2A96",
    'eqslantless': "\u2A95",
    'Equal': "\u2A75",
    'equals': '=',
    'EqualTilde': "\u2242",
    'equest': "\u225F",
    'Equilibrium': "\u21CC",
    'equiv': "\u2261",
    'equivDD': "\u2A78",
    'eqvparsl': "\u29E5",
    'erarr': "\u2971",
    'erDot': "\u2253",
    'escr': "\u212F",
    'Escr': "\u2130",
    'esdot': "\u2250",
    'esim': "\u2242",
    'Esim': "\u2A73",
    'eta': "\u03B7",
    'Eta': "\u0397",
    'eth': '\xF0',
    'ETH': '\xD0',
    'euml': '\xEB',
    'Euml': '\xCB',
    'euro': "\u20AC",
    'excl': '!',
    'exist': "\u2203",
    'Exists': "\u2203",
    'expectation': "\u2130",
    'exponentiale': "\u2147",
    'ExponentialE': "\u2147",
    'fallingdotseq': "\u2252",
    'fcy': "\u0444",
    'Fcy': "\u0424",
    'female': "\u2640",
    'ffilig': "\uFB03",
    'fflig': "\uFB00",
    'ffllig': "\uFB04",
    'ffr': "\uD835\uDD23",
    'Ffr': "\uD835\uDD09",
    'filig': "\uFB01",
    'FilledSmallSquare': "\u25FC",
    'FilledVerySmallSquare': "\u25AA",
    'fjlig': 'fj',
    'flat': "\u266D",
    'fllig': "\uFB02",
    'fltns': "\u25B1",
    'fnof': "\u0192",
    'fopf': "\uD835\uDD57",
    'Fopf': "\uD835\uDD3D",
    'forall': "\u2200",
    'ForAll': "\u2200",
    'fork': "\u22D4",
    'forkv': "\u2AD9",
    'Fouriertrf': "\u2131",
    'fpartint': "\u2A0D",
    'frac12': '\xBD',
    'frac13': "\u2153",
    'frac14': '\xBC',
    'frac15': "\u2155",
    'frac16': "\u2159",
    'frac18': "\u215B",
    'frac23': "\u2154",
    'frac25': "\u2156",
    'frac34': '\xBE',
    'frac35': "\u2157",
    'frac38': "\u215C",
    'frac45': "\u2158",
    'frac56': "\u215A",
    'frac58': "\u215D",
    'frac78': "\u215E",
    'frasl': "\u2044",
    'frown': "\u2322",
    'fscr': "\uD835\uDCBB",
    'Fscr': "\u2131",
    'gacute': "\u01F5",
    'gamma': "\u03B3",
    'Gamma': "\u0393",
    'gammad': "\u03DD",
    'Gammad': "\u03DC",
    'gap': "\u2A86",
    'gbreve': "\u011F",
    'Gbreve': "\u011E",
    'Gcedil': "\u0122",
    'gcirc': "\u011D",
    'Gcirc': "\u011C",
    'gcy': "\u0433",
    'Gcy': "\u0413",
    'gdot': "\u0121",
    'Gdot': "\u0120",
    'ge': "\u2265",
    'gE': "\u2267",
    'gel': "\u22DB",
    'gEl': "\u2A8C",
    'geq': "\u2265",
    'geqq': "\u2267",
    'geqslant': "\u2A7E",
    'ges': "\u2A7E",
    'gescc': "\u2AA9",
    'gesdot': "\u2A80",
    'gesdoto': "\u2A82",
    'gesdotol': "\u2A84",
    'gesl': "\u22DB\uFE00",
    'gesles': "\u2A94",
    'gfr': "\uD835\uDD24",
    'Gfr': "\uD835\uDD0A",
    'gg': "\u226B",
    'Gg': "\u22D9",
    'ggg': "\u22D9",
    'gimel': "\u2137",
    'gjcy': "\u0453",
    'GJcy': "\u0403",
    'gl': "\u2277",
    'gla': "\u2AA5",
    'glE': "\u2A92",
    'glj': "\u2AA4",
    'gnap': "\u2A8A",
    'gnapprox': "\u2A8A",
    'gne': "\u2A88",
    'gnE': "\u2269",
    'gneq': "\u2A88",
    'gneqq': "\u2269",
    'gnsim': "\u22E7",
    'gopf': "\uD835\uDD58",
    'Gopf': "\uD835\uDD3E",
    'grave': '`',
    'GreaterEqual': "\u2265",
    'GreaterEqualLess': "\u22DB",
    'GreaterFullEqual': "\u2267",
    'GreaterGreater': "\u2AA2",
    'GreaterLess': "\u2277",
    'GreaterSlantEqual': "\u2A7E",
    'GreaterTilde': "\u2273",
    'gscr': "\u210A",
    'Gscr': "\uD835\uDCA2",
    'gsim': "\u2273",
    'gsime': "\u2A8E",
    'gsiml': "\u2A90",
    'gt': '>',
    'Gt': "\u226B",
    'GT': '>',
    'gtcc': "\u2AA7",
    'gtcir': "\u2A7A",
    'gtdot': "\u22D7",
    'gtlPar': "\u2995",
    'gtquest': "\u2A7C",
    'gtrapprox': "\u2A86",
    'gtrarr': "\u2978",
    'gtrdot': "\u22D7",
    'gtreqless': "\u22DB",
    'gtreqqless': "\u2A8C",
    'gtrless': "\u2277",
    'gtrsim': "\u2273",
    'gvertneqq': "\u2269\uFE00",
    'gvnE': "\u2269\uFE00",
    'Hacek': "\u02C7",
    'hairsp': "\u200A",
    'half': '\xBD',
    'hamilt': "\u210B",
    'hardcy': "\u044A",
    'HARDcy': "\u042A",
    'harr': "\u2194",
    'hArr': "\u21D4",
    'harrcir': "\u2948",
    'harrw': "\u21AD",
    'Hat': '^',
    'hbar': "\u210F",
    'hcirc': "\u0125",
    'Hcirc': "\u0124",
    'hearts': "\u2665",
    'heartsuit': "\u2665",
    'hellip': "\u2026",
    'hercon': "\u22B9",
    'hfr': "\uD835\uDD25",
    'Hfr': "\u210C",
    'HilbertSpace': "\u210B",
    'hksearow': "\u2925",
    'hkswarow': "\u2926",
    'hoarr': "\u21FF",
    'homtht': "\u223B",
    'hookleftarrow': "\u21A9",
    'hookrightarrow': "\u21AA",
    'hopf': "\uD835\uDD59",
    'Hopf': "\u210D",
    'horbar': "\u2015",
    'HorizontalLine': "\u2500",
    'hscr': "\uD835\uDCBD",
    'Hscr': "\u210B",
    'hslash': "\u210F",
    'hstrok': "\u0127",
    'Hstrok': "\u0126",
    'HumpDownHump': "\u224E",
    'HumpEqual': "\u224F",
    'hybull': "\u2043",
    'hyphen': "\u2010",
    'iacute': '\xED',
    'Iacute': '\xCD',
    'ic': "\u2063",
    'icirc': '\xEE',
    'Icirc': '\xCE',
    'icy': "\u0438",
    'Icy': "\u0418",
    'Idot': "\u0130",
    'iecy': "\u0435",
    'IEcy': "\u0415",
    'iexcl': '\xA1',
    'iff': "\u21D4",
    'ifr': "\uD835\uDD26",
    'Ifr': "\u2111",
    'igrave': '\xEC',
    'Igrave': '\xCC',
    'ii': "\u2148",
    'iiiint': "\u2A0C",
    'iiint': "\u222D",
    'iinfin': "\u29DC",
    'iiota': "\u2129",
    'ijlig': "\u0133",
    'IJlig': "\u0132",
    'Im': "\u2111",
    'imacr': "\u012B",
    'Imacr': "\u012A",
    'image': "\u2111",
    'ImaginaryI': "\u2148",
    'imagline': "\u2110",
    'imagpart': "\u2111",
    'imath': "\u0131",
    'imof': "\u22B7",
    'imped': "\u01B5",
    'Implies': "\u21D2",
    'in': "\u2208",
    'incare': "\u2105",
    'infin': "\u221E",
    'infintie': "\u29DD",
    'inodot': "\u0131",
    'int': "\u222B",
    'Int': "\u222C",
    'intcal': "\u22BA",
    'integers': "\u2124",
    'Integral': "\u222B",
    'intercal': "\u22BA",
    'Intersection': "\u22C2",
    'intlarhk': "\u2A17",
    'intprod': "\u2A3C",
    'InvisibleComma': "\u2063",
    'InvisibleTimes': "\u2062",
    'iocy': "\u0451",
    'IOcy': "\u0401",
    'iogon': "\u012F",
    'Iogon': "\u012E",
    'iopf': "\uD835\uDD5A",
    'Iopf': "\uD835\uDD40",
    'iota': "\u03B9",
    'Iota': "\u0399",
    'iprod': "\u2A3C",
    'iquest': '\xBF',
    'iscr': "\uD835\uDCBE",
    'Iscr': "\u2110",
    'isin': "\u2208",
    'isindot': "\u22F5",
    'isinE': "\u22F9",
    'isins': "\u22F4",
    'isinsv': "\u22F3",
    'isinv': "\u2208",
    'it': "\u2062",
    'itilde': "\u0129",
    'Itilde': "\u0128",
    'iukcy': "\u0456",
    'Iukcy': "\u0406",
    'iuml': '\xEF',
    'Iuml': '\xCF',
    'jcirc': "\u0135",
    'Jcirc': "\u0134",
    'jcy': "\u0439",
    'Jcy': "\u0419",
    'jfr': "\uD835\uDD27",
    'Jfr': "\uD835\uDD0D",
    'jmath': "\u0237",
    'jopf': "\uD835\uDD5B",
    'Jopf': "\uD835\uDD41",
    'jscr': "\uD835\uDCBF",
    'Jscr': "\uD835\uDCA5",
    'jsercy': "\u0458",
    'Jsercy': "\u0408",
    'jukcy': "\u0454",
    'Jukcy': "\u0404",
    'kappa': "\u03BA",
    'Kappa': "\u039A",
    'kappav': "\u03F0",
    'kcedil': "\u0137",
    'Kcedil': "\u0136",
    'kcy': "\u043A",
    'Kcy': "\u041A",
    'kfr': "\uD835\uDD28",
    'Kfr': "\uD835\uDD0E",
    'kgreen': "\u0138",
    'khcy': "\u0445",
    'KHcy': "\u0425",
    'kjcy': "\u045C",
    'KJcy': "\u040C",
    'kopf': "\uD835\uDD5C",
    'Kopf': "\uD835\uDD42",
    'kscr': "\uD835\uDCC0",
    'Kscr': "\uD835\uDCA6",
    'lAarr': "\u21DA",
    'lacute': "\u013A",
    'Lacute': "\u0139",
    'laemptyv': "\u29B4",
    'lagran': "\u2112",
    'lambda': "\u03BB",
    'Lambda': "\u039B",
    'lang': "\u27E8",
    'Lang': "\u27EA",
    'langd': "\u2991",
    'langle': "\u27E8",
    'lap': "\u2A85",
    'Laplacetrf': "\u2112",
    'laquo': '\xAB',
    'larr': "\u2190",
    'lArr': "\u21D0",
    'Larr': "\u219E",
    'larrb': "\u21E4",
    'larrbfs': "\u291F",
    'larrfs': "\u291D",
    'larrhk': "\u21A9",
    'larrlp': "\u21AB",
    'larrpl': "\u2939",
    'larrsim': "\u2973",
    'larrtl': "\u21A2",
    'lat': "\u2AAB",
    'latail': "\u2919",
    'lAtail': "\u291B",
    'late': "\u2AAD",
    'lates': "\u2AAD\uFE00",
    'lbarr': "\u290C",
    'lBarr': "\u290E",
    'lbbrk': "\u2772",
    'lbrace': '{',
    'lbrack': '[',
    'lbrke': "\u298B",
    'lbrksld': "\u298F",
    'lbrkslu': "\u298D",
    'lcaron': "\u013E",
    'Lcaron': "\u013D",
    'lcedil': "\u013C",
    'Lcedil': "\u013B",
    'lceil': "\u2308",
    'lcub': '{',
    'lcy': "\u043B",
    'Lcy': "\u041B",
    'ldca': "\u2936",
    'ldquo': "\u201C",
    'ldquor': "\u201E",
    'ldrdhar': "\u2967",
    'ldrushar': "\u294B",
    'ldsh': "\u21B2",
    'le': "\u2264",
    'lE': "\u2266",
    'LeftAngleBracket': "\u27E8",
    'leftarrow': "\u2190",
    'Leftarrow': "\u21D0",
    'LeftArrow': "\u2190",
    'LeftArrowBar': "\u21E4",
    'LeftArrowRightArrow': "\u21C6",
    'leftarrowtail': "\u21A2",
    'LeftCeiling': "\u2308",
    'LeftDoubleBracket': "\u27E6",
    'LeftDownTeeVector': "\u2961",
    'LeftDownVector': "\u21C3",
    'LeftDownVectorBar': "\u2959",
    'LeftFloor': "\u230A",
    'leftharpoondown': "\u21BD",
    'leftharpoonup': "\u21BC",
    'leftleftarrows': "\u21C7",
    'leftrightarrow': "\u2194",
    'Leftrightarrow': "\u21D4",
    'LeftRightArrow': "\u2194",
    'leftrightarrows': "\u21C6",
    'leftrightharpoons': "\u21CB",
    'leftrightsquigarrow': "\u21AD",
    'LeftRightVector': "\u294E",
    'LeftTee': "\u22A3",
    'LeftTeeArrow': "\u21A4",
    'LeftTeeVector': "\u295A",
    'leftthreetimes': "\u22CB",
    'LeftTriangle': "\u22B2",
    'LeftTriangleBar': "\u29CF",
    'LeftTriangleEqual': "\u22B4",
    'LeftUpDownVector': "\u2951",
    'LeftUpTeeVector': "\u2960",
    'LeftUpVector': "\u21BF",
    'LeftUpVectorBar': "\u2958",
    'LeftVector': "\u21BC",
    'LeftVectorBar': "\u2952",
    'leg': "\u22DA",
    'lEg': "\u2A8B",
    'leq': "\u2264",
    'leqq': "\u2266",
    'leqslant': "\u2A7D",
    'les': "\u2A7D",
    'lescc': "\u2AA8",
    'lesdot': "\u2A7F",
    'lesdoto': "\u2A81",
    'lesdotor': "\u2A83",
    'lesg': "\u22DA\uFE00",
    'lesges': "\u2A93",
    'lessapprox': "\u2A85",
    'lessdot': "\u22D6",
    'lesseqgtr': "\u22DA",
    'lesseqqgtr': "\u2A8B",
    'LessEqualGreater': "\u22DA",
    'LessFullEqual': "\u2266",
    'LessGreater': "\u2276",
    'lessgtr': "\u2276",
    'LessLess': "\u2AA1",
    'lesssim': "\u2272",
    'LessSlantEqual': "\u2A7D",
    'LessTilde': "\u2272",
    'lfisht': "\u297C",
    'lfloor': "\u230A",
    'lfr': "\uD835\uDD29",
    'Lfr': "\uD835\uDD0F",
    'lg': "\u2276",
    'lgE': "\u2A91",
    'lHar': "\u2962",
    'lhard': "\u21BD",
    'lharu': "\u21BC",
    'lharul': "\u296A",
    'lhblk': "\u2584",
    'ljcy': "\u0459",
    'LJcy': "\u0409",
    'll': "\u226A",
    'Ll': "\u22D8",
    'llarr': "\u21C7",
    'llcorner': "\u231E",
    'Lleftarrow': "\u21DA",
    'llhard': "\u296B",
    'lltri': "\u25FA",
    'lmidot': "\u0140",
    'Lmidot': "\u013F",
    'lmoust': "\u23B0",
    'lmoustache': "\u23B0",
    'lnap': "\u2A89",
    'lnapprox': "\u2A89",
    'lne': "\u2A87",
    'lnE': "\u2268",
    'lneq': "\u2A87",
    'lneqq': "\u2268",
    'lnsim': "\u22E6",
    'loang': "\u27EC",
    'loarr': "\u21FD",
    'lobrk': "\u27E6",
    'longleftarrow': "\u27F5",
    'Longleftarrow': "\u27F8",
    'LongLeftArrow': "\u27F5",
    'longleftrightarrow': "\u27F7",
    'Longleftrightarrow': "\u27FA",
    'LongLeftRightArrow': "\u27F7",
    'longmapsto': "\u27FC",
    'longrightarrow': "\u27F6",
    'Longrightarrow': "\u27F9",
    'LongRightArrow': "\u27F6",
    'looparrowleft': "\u21AB",
    'looparrowright': "\u21AC",
    'lopar': "\u2985",
    'lopf': "\uD835\uDD5D",
    'Lopf': "\uD835\uDD43",
    'loplus': "\u2A2D",
    'lotimes': "\u2A34",
    'lowast': "\u2217",
    'lowbar': '_',
    'LowerLeftArrow': "\u2199",
    'LowerRightArrow': "\u2198",
    'loz': "\u25CA",
    'lozenge': "\u25CA",
    'lozf': "\u29EB",
    'lpar': '(',
    'lparlt': "\u2993",
    'lrarr': "\u21C6",
    'lrcorner': "\u231F",
    'lrhar': "\u21CB",
    'lrhard': "\u296D",
    'lrm': "\u200E",
    'lrtri': "\u22BF",
    'lsaquo': "\u2039",
    'lscr': "\uD835\uDCC1",
    'Lscr': "\u2112",
    'lsh': "\u21B0",
    'Lsh': "\u21B0",
    'lsim': "\u2272",
    'lsime': "\u2A8D",
    'lsimg': "\u2A8F",
    'lsqb': '[',
    'lsquo': "\u2018",
    'lsquor': "\u201A",
    'lstrok': "\u0142",
    'Lstrok': "\u0141",
    'lt': '<',
    'Lt': "\u226A",
    'LT': '<',
    'ltcc': "\u2AA6",
    'ltcir': "\u2A79",
    'ltdot': "\u22D6",
    'lthree': "\u22CB",
    'ltimes': "\u22C9",
    'ltlarr': "\u2976",
    'ltquest': "\u2A7B",
    'ltri': "\u25C3",
    'ltrie': "\u22B4",
    'ltrif': "\u25C2",
    'ltrPar': "\u2996",
    'lurdshar': "\u294A",
    'luruhar': "\u2966",
    'lvertneqq': "\u2268\uFE00",
    'lvnE': "\u2268\uFE00",
    'macr': '\xAF',
    'male': "\u2642",
    'malt': "\u2720",
    'maltese': "\u2720",
    'map': "\u21A6",
    'Map': "\u2905",
    'mapsto': "\u21A6",
    'mapstodown': "\u21A7",
    'mapstoleft': "\u21A4",
    'mapstoup': "\u21A5",
    'marker': "\u25AE",
    'mcomma': "\u2A29",
    'mcy': "\u043C",
    'Mcy': "\u041C",
    'mdash': "\u2014",
    'mDDot': "\u223A",
    'measuredangle': "\u2221",
    'MediumSpace': "\u205F",
    'Mellintrf': "\u2133",
    'mfr': "\uD835\uDD2A",
    'Mfr': "\uD835\uDD10",
    'mho': "\u2127",
    'micro': '\xB5',
    'mid': "\u2223",
    'midast': '*',
    'midcir': "\u2AF0",
    'middot': '\xB7',
    'minus': "\u2212",
    'minusb': "\u229F",
    'minusd': "\u2238",
    'minusdu': "\u2A2A",
    'MinusPlus': "\u2213",
    'mlcp': "\u2ADB",
    'mldr': "\u2026",
    'mnplus': "\u2213",
    'models': "\u22A7",
    'mopf': "\uD835\uDD5E",
    'Mopf': "\uD835\uDD44",
    'mp': "\u2213",
    'mscr': "\uD835\uDCC2",
    'Mscr': "\u2133",
    'mstpos': "\u223E",
    'mu': "\u03BC",
    'Mu': "\u039C",
    'multimap': "\u22B8",
    'mumap': "\u22B8",
    'nabla': "\u2207",
    'nacute': "\u0144",
    'Nacute': "\u0143",
    'nang': "\u2220\u20D2",
    'nap': "\u2249",
    'napE': "\u2A70\u0338",
    'napid': "\u224B\u0338",
    'napos': "\u0149",
    'napprox': "\u2249",
    'natur': "\u266E",
    'natural': "\u266E",
    'naturals': "\u2115",
    'nbsp': '\xA0',
    'nbump': "\u224E\u0338",
    'nbumpe': "\u224F\u0338",
    'ncap': "\u2A43",
    'ncaron': "\u0148",
    'Ncaron': "\u0147",
    'ncedil': "\u0146",
    'Ncedil': "\u0145",
    'ncong': "\u2247",
    'ncongdot': "\u2A6D\u0338",
    'ncup': "\u2A42",
    'ncy': "\u043D",
    'Ncy': "\u041D",
    'ndash': "\u2013",
    'ne': "\u2260",
    'nearhk': "\u2924",
    'nearr': "\u2197",
    'neArr': "\u21D7",
    'nearrow': "\u2197",
    'nedot': "\u2250\u0338",
    'NegativeMediumSpace': "\u200B",
    'NegativeThickSpace': "\u200B",
    'NegativeThinSpace': "\u200B",
    'NegativeVeryThinSpace': "\u200B",
    'nequiv': "\u2262",
    'nesear': "\u2928",
    'nesim': "\u2242\u0338",
    'NestedGreaterGreater': "\u226B",
    'NestedLessLess': "\u226A",
    'NewLine': '\n',
    'nexist': "\u2204",
    'nexists': "\u2204",
    'nfr': "\uD835\uDD2B",
    'Nfr': "\uD835\uDD11",
    'nge': "\u2271",
    'ngE': "\u2267\u0338",
    'ngeq': "\u2271",
    'ngeqq': "\u2267\u0338",
    'ngeqslant': "\u2A7E\u0338",
    'nges': "\u2A7E\u0338",
    'nGg': "\u22D9\u0338",
    'ngsim': "\u2275",
    'ngt': "\u226F",
    'nGt': "\u226B\u20D2",
    'ngtr': "\u226F",
    'nGtv': "\u226B\u0338",
    'nharr': "\u21AE",
    'nhArr': "\u21CE",
    'nhpar': "\u2AF2",
    'ni': "\u220B",
    'nis': "\u22FC",
    'nisd': "\u22FA",
    'niv': "\u220B",
    'njcy': "\u045A",
    'NJcy': "\u040A",
    'nlarr': "\u219A",
    'nlArr': "\u21CD",
    'nldr': "\u2025",
    'nle': "\u2270",
    'nlE': "\u2266\u0338",
    'nleftarrow': "\u219A",
    'nLeftarrow': "\u21CD",
    'nleftrightarrow': "\u21AE",
    'nLeftrightarrow': "\u21CE",
    'nleq': "\u2270",
    'nleqq': "\u2266\u0338",
    'nleqslant': "\u2A7D\u0338",
    'nles': "\u2A7D\u0338",
    'nless': "\u226E",
    'nLl': "\u22D8\u0338",
    'nlsim': "\u2274",
    'nlt': "\u226E",
    'nLt': "\u226A\u20D2",
    'nltri': "\u22EA",
    'nltrie': "\u22EC",
    'nLtv': "\u226A\u0338",
    'nmid': "\u2224",
    'NoBreak': "\u2060",
    'NonBreakingSpace': '\xA0',
    'nopf': "\uD835\uDD5F",
    'Nopf': "\u2115",
    'not': '\xAC',
    'Not': "\u2AEC",
    'NotCongruent': "\u2262",
    'NotCupCap': "\u226D",
    'NotDoubleVerticalBar': "\u2226",
    'NotElement': "\u2209",
    'NotEqual': "\u2260",
    'NotEqualTilde': "\u2242\u0338",
    'NotExists': "\u2204",
    'NotGreater': "\u226F",
    'NotGreaterEqual': "\u2271",
    'NotGreaterFullEqual': "\u2267\u0338",
    'NotGreaterGreater': "\u226B\u0338",
    'NotGreaterLess': "\u2279",
    'NotGreaterSlantEqual': "\u2A7E\u0338",
    'NotGreaterTilde': "\u2275",
    'NotHumpDownHump': "\u224E\u0338",
    'NotHumpEqual': "\u224F\u0338",
    'notin': "\u2209",
    'notindot': "\u22F5\u0338",
    'notinE': "\u22F9\u0338",
    'notinva': "\u2209",
    'notinvb': "\u22F7",
    'notinvc': "\u22F6",
    'NotLeftTriangle': "\u22EA",
    'NotLeftTriangleBar': "\u29CF\u0338",
    'NotLeftTriangleEqual': "\u22EC",
    'NotLess': "\u226E",
    'NotLessEqual': "\u2270",
    'NotLessGreater': "\u2278",
    'NotLessLess': "\u226A\u0338",
    'NotLessSlantEqual': "\u2A7D\u0338",
    'NotLessTilde': "\u2274",
    'NotNestedGreaterGreater': "\u2AA2\u0338",
    'NotNestedLessLess': "\u2AA1\u0338",
    'notni': "\u220C",
    'notniva': "\u220C",
    'notnivb': "\u22FE",
    'notnivc': "\u22FD",
    'NotPrecedes': "\u2280",
    'NotPrecedesEqual': "\u2AAF\u0338",
    'NotPrecedesSlantEqual': "\u22E0",
    'NotReverseElement': "\u220C",
    'NotRightTriangle': "\u22EB",
    'NotRightTriangleBar': "\u29D0\u0338",
    'NotRightTriangleEqual': "\u22ED",
    'NotSquareSubset': "\u228F\u0338",
    'NotSquareSubsetEqual': "\u22E2",
    'NotSquareSuperset': "\u2290\u0338",
    'NotSquareSupersetEqual': "\u22E3",
    'NotSubset': "\u2282\u20D2",
    'NotSubsetEqual': "\u2288",
    'NotSucceeds': "\u2281",
    'NotSucceedsEqual': "\u2AB0\u0338",
    'NotSucceedsSlantEqual': "\u22E1",
    'NotSucceedsTilde': "\u227F\u0338",
    'NotSuperset': "\u2283\u20D2",
    'NotSupersetEqual': "\u2289",
    'NotTilde': "\u2241",
    'NotTildeEqual': "\u2244",
    'NotTildeFullEqual': "\u2247",
    'NotTildeTilde': "\u2249",
    'NotVerticalBar': "\u2224",
    'npar': "\u2226",
    'nparallel': "\u2226",
    'nparsl': "\u2AFD\u20E5",
    'npart': "\u2202\u0338",
    'npolint': "\u2A14",
    'npr': "\u2280",
    'nprcue': "\u22E0",
    'npre': "\u2AAF\u0338",
    'nprec': "\u2280",
    'npreceq': "\u2AAF\u0338",
    'nrarr': "\u219B",
    'nrArr': "\u21CF",
    'nrarrc': "\u2933\u0338",
    'nrarrw': "\u219D\u0338",
    'nrightarrow': "\u219B",
    'nRightarrow': "\u21CF",
    'nrtri': "\u22EB",
    'nrtrie': "\u22ED",
    'nsc': "\u2281",
    'nsccue': "\u22E1",
    'nsce': "\u2AB0\u0338",
    'nscr': "\uD835\uDCC3",
    'Nscr': "\uD835\uDCA9",
    'nshortmid': "\u2224",
    'nshortparallel': "\u2226",
    'nsim': "\u2241",
    'nsime': "\u2244",
    'nsimeq': "\u2244",
    'nsmid': "\u2224",
    'nspar': "\u2226",
    'nsqsube': "\u22E2",
    'nsqsupe': "\u22E3",
    'nsub': "\u2284",
    'nsube': "\u2288",
    'nsubE': "\u2AC5\u0338",
    'nsubset': "\u2282\u20D2",
    'nsubseteq': "\u2288",
    'nsubseteqq': "\u2AC5\u0338",
    'nsucc': "\u2281",
    'nsucceq': "\u2AB0\u0338",
    'nsup': "\u2285",
    'nsupe': "\u2289",
    'nsupE': "\u2AC6\u0338",
    'nsupset': "\u2283\u20D2",
    'nsupseteq': "\u2289",
    'nsupseteqq': "\u2AC6\u0338",
    'ntgl': "\u2279",
    'ntilde': '\xF1',
    'Ntilde': '\xD1',
    'ntlg': "\u2278",
    'ntriangleleft': "\u22EA",
    'ntrianglelefteq': "\u22EC",
    'ntriangleright': "\u22EB",
    'ntrianglerighteq': "\u22ED",
    'nu': "\u03BD",
    'Nu': "\u039D",
    'num': '#',
    'numero': "\u2116",
    'numsp': "\u2007",
    'nvap': "\u224D\u20D2",
    'nvdash': "\u22AC",
    'nvDash': "\u22AD",
    'nVdash': "\u22AE",
    'nVDash': "\u22AF",
    'nvge': "\u2265\u20D2",
    'nvgt': ">\u20D2",
    'nvHarr': "\u2904",
    'nvinfin': "\u29DE",
    'nvlArr': "\u2902",
    'nvle': "\u2264\u20D2",
    'nvlt': "<\u20D2",
    'nvltrie': "\u22B4\u20D2",
    'nvrArr': "\u2903",
    'nvrtrie': "\u22B5\u20D2",
    'nvsim': "\u223C\u20D2",
    'nwarhk': "\u2923",
    'nwarr': "\u2196",
    'nwArr': "\u21D6",
    'nwarrow': "\u2196",
    'nwnear': "\u2927",
    'oacute': '\xF3',
    'Oacute': '\xD3',
    'oast': "\u229B",
    'ocir': "\u229A",
    'ocirc': '\xF4',
    'Ocirc': '\xD4',
    'ocy': "\u043E",
    'Ocy': "\u041E",
    'odash': "\u229D",
    'odblac': "\u0151",
    'Odblac': "\u0150",
    'odiv': "\u2A38",
    'odot': "\u2299",
    'odsold': "\u29BC",
    'oelig': "\u0153",
    'OElig': "\u0152",
    'ofcir': "\u29BF",
    'ofr': "\uD835\uDD2C",
    'Ofr': "\uD835\uDD12",
    'ogon': "\u02DB",
    'ograve': '\xF2',
    'Ograve': '\xD2',
    'ogt': "\u29C1",
    'ohbar': "\u29B5",
    'ohm': "\u03A9",
    'oint': "\u222E",
    'olarr': "\u21BA",
    'olcir': "\u29BE",
    'olcross': "\u29BB",
    'oline': "\u203E",
    'olt': "\u29C0",
    'omacr': "\u014D",
    'Omacr': "\u014C",
    'omega': "\u03C9",
    'Omega': "\u03A9",
    'omicron': "\u03BF",
    'Omicron': "\u039F",
    'omid': "\u29B6",
    'ominus': "\u2296",
    'oopf': "\uD835\uDD60",
    'Oopf': "\uD835\uDD46",
    'opar': "\u29B7",
    'OpenCurlyDoubleQuote': "\u201C",
    'OpenCurlyQuote': "\u2018",
    'operp': "\u29B9",
    'oplus': "\u2295",
    'or': "\u2228",
    'Or': "\u2A54",
    'orarr': "\u21BB",
    'ord': "\u2A5D",
    'order': "\u2134",
    'orderof': "\u2134",
    'ordf': '\xAA',
    'ordm': '\xBA',
    'origof': "\u22B6",
    'oror': "\u2A56",
    'orslope': "\u2A57",
    'orv': "\u2A5B",
    'oS': "\u24C8",
    'oscr': "\u2134",
    'Oscr': "\uD835\uDCAA",
    'oslash': '\xF8',
    'Oslash': '\xD8',
    'osol': "\u2298",
    'otilde': '\xF5',
    'Otilde': '\xD5',
    'otimes': "\u2297",
    'Otimes': "\u2A37",
    'otimesas': "\u2A36",
    'ouml': '\xF6',
    'Ouml': '\xD6',
    'ovbar': "\u233D",
    'OverBar': "\u203E",
    'OverBrace': "\u23DE",
    'OverBracket': "\u23B4",
    'OverParenthesis': "\u23DC",
    'par': "\u2225",
    'para': '\xB6',
    'parallel': "\u2225",
    'parsim': "\u2AF3",
    'parsl': "\u2AFD",
    'part': "\u2202",
    'PartialD': "\u2202",
    'pcy': "\u043F",
    'Pcy': "\u041F",
    'percnt': '%',
    'period': '.',
    'permil': "\u2030",
    'perp': "\u22A5",
    'pertenk': "\u2031",
    'pfr': "\uD835\uDD2D",
    'Pfr': "\uD835\uDD13",
    'phi': "\u03C6",
    'Phi': "\u03A6",
    'phiv': "\u03D5",
    'phmmat': "\u2133",
    'phone': "\u260E",
    'pi': "\u03C0",
    'Pi': "\u03A0",
    'pitchfork': "\u22D4",
    'piv': "\u03D6",
    'planck': "\u210F",
    'planckh': "\u210E",
    'plankv': "\u210F",
    'plus': '+',
    'plusacir': "\u2A23",
    'plusb': "\u229E",
    'pluscir': "\u2A22",
    'plusdo': "\u2214",
    'plusdu': "\u2A25",
    'pluse': "\u2A72",
    'PlusMinus': '\xB1',
    'plusmn': '\xB1',
    'plussim': "\u2A26",
    'plustwo': "\u2A27",
    'pm': '\xB1',
    'Poincareplane': "\u210C",
    'pointint': "\u2A15",
    'popf': "\uD835\uDD61",
    'Popf': "\u2119",
    'pound': '\xA3',
    'pr': "\u227A",
    'Pr': "\u2ABB",
    'prap': "\u2AB7",
    'prcue': "\u227C",
    'pre': "\u2AAF",
    'prE': "\u2AB3",
    'prec': "\u227A",
    'precapprox': "\u2AB7",
    'preccurlyeq': "\u227C",
    'Precedes': "\u227A",
    'PrecedesEqual': "\u2AAF",
    'PrecedesSlantEqual': "\u227C",
    'PrecedesTilde': "\u227E",
    'preceq': "\u2AAF",
    'precnapprox': "\u2AB9",
    'precneqq': "\u2AB5",
    'precnsim': "\u22E8",
    'precsim': "\u227E",
    'prime': "\u2032",
    'Prime': "\u2033",
    'primes': "\u2119",
    'prnap': "\u2AB9",
    'prnE': "\u2AB5",
    'prnsim': "\u22E8",
    'prod': "\u220F",
    'Product': "\u220F",
    'profalar': "\u232E",
    'profline': "\u2312",
    'profsurf': "\u2313",
    'prop': "\u221D",
    'Proportion': "\u2237",
    'Proportional': "\u221D",
    'propto': "\u221D",
    'prsim': "\u227E",
    'prurel': "\u22B0",
    'pscr': "\uD835\uDCC5",
    'Pscr': "\uD835\uDCAB",
    'psi': "\u03C8",
    'Psi': "\u03A8",
    'puncsp': "\u2008",
    'qfr': "\uD835\uDD2E",
    'Qfr': "\uD835\uDD14",
    'qint': "\u2A0C",
    'qopf': "\uD835\uDD62",
    'Qopf': "\u211A",
    'qprime': "\u2057",
    'qscr': "\uD835\uDCC6",
    'Qscr': "\uD835\uDCAC",
    'quaternions': "\u210D",
    'quatint': "\u2A16",
    'quest': '?',
    'questeq': "\u225F",
    'quot': '"',
    'QUOT': '"',
    'rAarr': "\u21DB",
    'race': "\u223D\u0331",
    'racute': "\u0155",
    'Racute': "\u0154",
    'radic': "\u221A",
    'raemptyv': "\u29B3",
    'rang': "\u27E9",
    'Rang': "\u27EB",
    'rangd': "\u2992",
    'range': "\u29A5",
    'rangle': "\u27E9",
    'raquo': '\xBB',
    'rarr': "\u2192",
    'rArr': "\u21D2",
    'Rarr': "\u21A0",
    'rarrap': "\u2975",
    'rarrb': "\u21E5",
    'rarrbfs': "\u2920",
    'rarrc': "\u2933",
    'rarrfs': "\u291E",
    'rarrhk': "\u21AA",
    'rarrlp': "\u21AC",
    'rarrpl': "\u2945",
    'rarrsim': "\u2974",
    'rarrtl': "\u21A3",
    'Rarrtl': "\u2916",
    'rarrw': "\u219D",
    'ratail': "\u291A",
    'rAtail': "\u291C",
    'ratio': "\u2236",
    'rationals': "\u211A",
    'rbarr': "\u290D",
    'rBarr': "\u290F",
    'RBarr': "\u2910",
    'rbbrk': "\u2773",
    'rbrace': '}',
    'rbrack': ']',
    'rbrke': "\u298C",
    'rbrksld': "\u298E",
    'rbrkslu': "\u2990",
    'rcaron': "\u0159",
    'Rcaron': "\u0158",
    'rcedil': "\u0157",
    'Rcedil': "\u0156",
    'rceil': "\u2309",
    'rcub': '}',
    'rcy': "\u0440",
    'Rcy': "\u0420",
    'rdca': "\u2937",
    'rdldhar': "\u2969",
    'rdquo': "\u201D",
    'rdquor': "\u201D",
    'rdsh': "\u21B3",
    'Re': "\u211C",
    'real': "\u211C",
    'realine': "\u211B",
    'realpart': "\u211C",
    'reals': "\u211D",
    'rect': "\u25AD",
    'reg': '\xAE',
    'REG': '\xAE',
    'ReverseElement': "\u220B",
    'ReverseEquilibrium': "\u21CB",
    'ReverseUpEquilibrium': "\u296F",
    'rfisht': "\u297D",
    'rfloor': "\u230B",
    'rfr': "\uD835\uDD2F",
    'Rfr': "\u211C",
    'rHar': "\u2964",
    'rhard': "\u21C1",
    'rharu': "\u21C0",
    'rharul': "\u296C",
    'rho': "\u03C1",
    'Rho': "\u03A1",
    'rhov': "\u03F1",
    'RightAngleBracket': "\u27E9",
    'rightarrow': "\u2192",
    'Rightarrow': "\u21D2",
    'RightArrow': "\u2192",
    'RightArrowBar': "\u21E5",
    'RightArrowLeftArrow': "\u21C4",
    'rightarrowtail': "\u21A3",
    'RightCeiling': "\u2309",
    'RightDoubleBracket': "\u27E7",
    'RightDownTeeVector': "\u295D",
    'RightDownVector': "\u21C2",
    'RightDownVectorBar': "\u2955",
    'RightFloor': "\u230B",
    'rightharpoondown': "\u21C1",
    'rightharpoonup': "\u21C0",
    'rightleftarrows': "\u21C4",
    'rightleftharpoons': "\u21CC",
    'rightrightarrows': "\u21C9",
    'rightsquigarrow': "\u219D",
    'RightTee': "\u22A2",
    'RightTeeArrow': "\u21A6",
    'RightTeeVector': "\u295B",
    'rightthreetimes': "\u22CC",
    'RightTriangle': "\u22B3",
    'RightTriangleBar': "\u29D0",
    'RightTriangleEqual': "\u22B5",
    'RightUpDownVector': "\u294F",
    'RightUpTeeVector': "\u295C",
    'RightUpVector': "\u21BE",
    'RightUpVectorBar': "\u2954",
    'RightVector': "\u21C0",
    'RightVectorBar': "\u2953",
    'ring': "\u02DA",
    'risingdotseq': "\u2253",
    'rlarr': "\u21C4",
    'rlhar': "\u21CC",
    'rlm': "\u200F",
    'rmoust': "\u23B1",
    'rmoustache': "\u23B1",
    'rnmid': "\u2AEE",
    'roang': "\u27ED",
    'roarr': "\u21FE",
    'robrk': "\u27E7",
    'ropar': "\u2986",
    'ropf': "\uD835\uDD63",
    'Ropf': "\u211D",
    'roplus': "\u2A2E",
    'rotimes': "\u2A35",
    'RoundImplies': "\u2970",
    'rpar': ')',
    'rpargt': "\u2994",
    'rppolint': "\u2A12",
    'rrarr': "\u21C9",
    'Rrightarrow': "\u21DB",
    'rsaquo': "\u203A",
    'rscr': "\uD835\uDCC7",
    'Rscr': "\u211B",
    'rsh': "\u21B1",
    'Rsh': "\u21B1",
    'rsqb': ']',
    'rsquo': "\u2019",
    'rsquor': "\u2019",
    'rthree': "\u22CC",
    'rtimes': "\u22CA",
    'rtri': "\u25B9",
    'rtrie': "\u22B5",
    'rtrif': "\u25B8",
    'rtriltri': "\u29CE",
    'RuleDelayed': "\u29F4",
    'ruluhar': "\u2968",
    'rx': "\u211E",
    'sacute': "\u015B",
    'Sacute': "\u015A",
    'sbquo': "\u201A",
    'sc': "\u227B",
    'Sc': "\u2ABC",
    'scap': "\u2AB8",
    'scaron': "\u0161",
    'Scaron': "\u0160",
    'sccue': "\u227D",
    'sce': "\u2AB0",
    'scE': "\u2AB4",
    'scedil': "\u015F",
    'Scedil': "\u015E",
    'scirc': "\u015D",
    'Scirc': "\u015C",
    'scnap': "\u2ABA",
    'scnE': "\u2AB6",
    'scnsim': "\u22E9",
    'scpolint': "\u2A13",
    'scsim': "\u227F",
    'scy': "\u0441",
    'Scy': "\u0421",
    'sdot': "\u22C5",
    'sdotb': "\u22A1",
    'sdote': "\u2A66",
    'searhk': "\u2925",
    'searr': "\u2198",
    'seArr': "\u21D8",
    'searrow': "\u2198",
    'sect': '\xA7',
    'semi': ';',
    'seswar': "\u2929",
    'setminus': "\u2216",
    'setmn': "\u2216",
    'sext': "\u2736",
    'sfr': "\uD835\uDD30",
    'Sfr': "\uD835\uDD16",
    'sfrown': "\u2322",
    'sharp': "\u266F",
    'shchcy': "\u0449",
    'SHCHcy': "\u0429",
    'shcy': "\u0448",
    'SHcy': "\u0428",
    'ShortDownArrow': "\u2193",
    'ShortLeftArrow': "\u2190",
    'shortmid': "\u2223",
    'shortparallel': "\u2225",
    'ShortRightArrow': "\u2192",
    'ShortUpArrow': "\u2191",
    'shy': '\xAD',
    'sigma': "\u03C3",
    'Sigma': "\u03A3",
    'sigmaf': "\u03C2",
    'sigmav': "\u03C2",
    'sim': "\u223C",
    'simdot': "\u2A6A",
    'sime': "\u2243",
    'simeq': "\u2243",
    'simg': "\u2A9E",
    'simgE': "\u2AA0",
    'siml': "\u2A9D",
    'simlE': "\u2A9F",
    'simne': "\u2246",
    'simplus': "\u2A24",
    'simrarr': "\u2972",
    'slarr': "\u2190",
    'SmallCircle': "\u2218",
    'smallsetminus': "\u2216",
    'smashp': "\u2A33",
    'smeparsl': "\u29E4",
    'smid': "\u2223",
    'smile': "\u2323",
    'smt': "\u2AAA",
    'smte': "\u2AAC",
    'smtes': "\u2AAC\uFE00",
    'softcy': "\u044C",
    'SOFTcy': "\u042C",
    'sol': '/',
    'solb': "\u29C4",
    'solbar': "\u233F",
    'sopf': "\uD835\uDD64",
    'Sopf': "\uD835\uDD4A",
    'spades': "\u2660",
    'spadesuit': "\u2660",
    'spar': "\u2225",
    'sqcap': "\u2293",
    'sqcaps': "\u2293\uFE00",
    'sqcup': "\u2294",
    'sqcups': "\u2294\uFE00",
    'Sqrt': "\u221A",
    'sqsub': "\u228F",
    'sqsube': "\u2291",
    'sqsubset': "\u228F",
    'sqsubseteq': "\u2291",
    'sqsup': "\u2290",
    'sqsupe': "\u2292",
    'sqsupset': "\u2290",
    'sqsupseteq': "\u2292",
    'squ': "\u25A1",
    'square': "\u25A1",
    'Square': "\u25A1",
    'SquareIntersection': "\u2293",
    'SquareSubset': "\u228F",
    'SquareSubsetEqual': "\u2291",
    'SquareSuperset': "\u2290",
    'SquareSupersetEqual': "\u2292",
    'SquareUnion': "\u2294",
    'squarf': "\u25AA",
    'squf': "\u25AA",
    'srarr': "\u2192",
    'sscr': "\uD835\uDCC8",
    'Sscr': "\uD835\uDCAE",
    'ssetmn': "\u2216",
    'ssmile': "\u2323",
    'sstarf': "\u22C6",
    'star': "\u2606",
    'Star': "\u22C6",
    'starf': "\u2605",
    'straightepsilon': "\u03F5",
    'straightphi': "\u03D5",
    'strns': '\xAF',
    'sub': "\u2282",
    'Sub': "\u22D0",
    'subdot': "\u2ABD",
    'sube': "\u2286",
    'subE': "\u2AC5",
    'subedot': "\u2AC3",
    'submult': "\u2AC1",
    'subne': "\u228A",
    'subnE': "\u2ACB",
    'subplus': "\u2ABF",
    'subrarr': "\u2979",
    'subset': "\u2282",
    'Subset': "\u22D0",
    'subseteq': "\u2286",
    'subseteqq': "\u2AC5",
    'SubsetEqual': "\u2286",
    'subsetneq': "\u228A",
    'subsetneqq': "\u2ACB",
    'subsim': "\u2AC7",
    'subsub': "\u2AD5",
    'subsup': "\u2AD3",
    'succ': "\u227B",
    'succapprox': "\u2AB8",
    'succcurlyeq': "\u227D",
    'Succeeds': "\u227B",
    'SucceedsEqual': "\u2AB0",
    'SucceedsSlantEqual': "\u227D",
    'SucceedsTilde': "\u227F",
    'succeq': "\u2AB0",
    'succnapprox': "\u2ABA",
    'succneqq': "\u2AB6",
    'succnsim': "\u22E9",
    'succsim': "\u227F",
    'SuchThat': "\u220B",
    'sum': "\u2211",
    'Sum': "\u2211",
    'sung': "\u266A",
    'sup': "\u2283",
    'Sup': "\u22D1",
    'sup1': '\xB9',
    'sup2': '\xB2',
    'sup3': '\xB3',
    'supdot': "\u2ABE",
    'supdsub': "\u2AD8",
    'supe': "\u2287",
    'supE': "\u2AC6",
    'supedot': "\u2AC4",
    'Superset': "\u2283",
    'SupersetEqual': "\u2287",
    'suphsol': "\u27C9",
    'suphsub': "\u2AD7",
    'suplarr': "\u297B",
    'supmult': "\u2AC2",
    'supne': "\u228B",
    'supnE': "\u2ACC",
    'supplus': "\u2AC0",
    'supset': "\u2283",
    'Supset': "\u22D1",
    'supseteq': "\u2287",
    'supseteqq': "\u2AC6",
    'supsetneq': "\u228B",
    'supsetneqq': "\u2ACC",
    'supsim': "\u2AC8",
    'supsub': "\u2AD4",
    'supsup': "\u2AD6",
    'swarhk': "\u2926",
    'swarr': "\u2199",
    'swArr': "\u21D9",
    'swarrow': "\u2199",
    'swnwar': "\u292A",
    'szlig': '\xDF',
    'Tab': '\t',
    'target': "\u2316",
    'tau': "\u03C4",
    'Tau': "\u03A4",
    'tbrk': "\u23B4",
    'tcaron': "\u0165",
    'Tcaron': "\u0164",
    'tcedil': "\u0163",
    'Tcedil': "\u0162",
    'tcy': "\u0442",
    'Tcy': "\u0422",
    'tdot': "\u20DB",
    'telrec': "\u2315",
    'tfr': "\uD835\uDD31",
    'Tfr': "\uD835\uDD17",
    'there4': "\u2234",
    'therefore': "\u2234",
    'Therefore': "\u2234",
    'theta': "\u03B8",
    'Theta': "\u0398",
    'thetasym': "\u03D1",
    'thetav': "\u03D1",
    'thickapprox': "\u2248",
    'thicksim': "\u223C",
    'ThickSpace': "\u205F\u200A",
    'thinsp': "\u2009",
    'ThinSpace': "\u2009",
    'thkap': "\u2248",
    'thksim': "\u223C",
    'thorn': '\xFE',
    'THORN': '\xDE',
    'tilde': "\u02DC",
    'Tilde': "\u223C",
    'TildeEqual': "\u2243",
    'TildeFullEqual': "\u2245",
    'TildeTilde': "\u2248",
    'times': '\xD7',
    'timesb': "\u22A0",
    'timesbar': "\u2A31",
    'timesd': "\u2A30",
    'tint': "\u222D",
    'toea': "\u2928",
    'top': "\u22A4",
    'topbot': "\u2336",
    'topcir': "\u2AF1",
    'topf': "\uD835\uDD65",
    'Topf': "\uD835\uDD4B",
    'topfork': "\u2ADA",
    'tosa': "\u2929",
    'tprime': "\u2034",
    'trade': "\u2122",
    'TRADE': "\u2122",
    'triangle': "\u25B5",
    'triangledown': "\u25BF",
    'triangleleft': "\u25C3",
    'trianglelefteq': "\u22B4",
    'triangleq': "\u225C",
    'triangleright': "\u25B9",
    'trianglerighteq': "\u22B5",
    'tridot': "\u25EC",
    'trie': "\u225C",
    'triminus': "\u2A3A",
    'TripleDot': "\u20DB",
    'triplus': "\u2A39",
    'trisb': "\u29CD",
    'tritime': "\u2A3B",
    'trpezium': "\u23E2",
    'tscr': "\uD835\uDCC9",
    'Tscr': "\uD835\uDCAF",
    'tscy': "\u0446",
    'TScy': "\u0426",
    'tshcy': "\u045B",
    'TSHcy': "\u040B",
    'tstrok': "\u0167",
    'Tstrok': "\u0166",
    'twixt': "\u226C",
    'twoheadleftarrow': "\u219E",
    'twoheadrightarrow': "\u21A0",
    'uacute': '\xFA',
    'Uacute': '\xDA',
    'uarr': "\u2191",
    'uArr': "\u21D1",
    'Uarr': "\u219F",
    'Uarrocir': "\u2949",
    'ubrcy': "\u045E",
    'Ubrcy': "\u040E",
    'ubreve': "\u016D",
    'Ubreve': "\u016C",
    'ucirc': '\xFB',
    'Ucirc': '\xDB',
    'ucy': "\u0443",
    'Ucy': "\u0423",
    'udarr': "\u21C5",
    'udblac': "\u0171",
    'Udblac': "\u0170",
    'udhar': "\u296E",
    'ufisht': "\u297E",
    'ufr': "\uD835\uDD32",
    'Ufr': "\uD835\uDD18",
    'ugrave': '\xF9',
    'Ugrave': '\xD9',
    'uHar': "\u2963",
    'uharl': "\u21BF",
    'uharr': "\u21BE",
    'uhblk': "\u2580",
    'ulcorn': "\u231C",
    'ulcorner': "\u231C",
    'ulcrop': "\u230F",
    'ultri': "\u25F8",
    'umacr': "\u016B",
    'Umacr': "\u016A",
    'uml': '\xA8',
    'UnderBar': '_',
    'UnderBrace': "\u23DF",
    'UnderBracket': "\u23B5",
    'UnderParenthesis': "\u23DD",
    'Union': "\u22C3",
    'UnionPlus': "\u228E",
    'uogon': "\u0173",
    'Uogon': "\u0172",
    'uopf': "\uD835\uDD66",
    'Uopf': "\uD835\uDD4C",
    'uparrow': "\u2191",
    'Uparrow': "\u21D1",
    'UpArrow': "\u2191",
    'UpArrowBar': "\u2912",
    'UpArrowDownArrow': "\u21C5",
    'updownarrow': "\u2195",
    'Updownarrow': "\u21D5",
    'UpDownArrow': "\u2195",
    'UpEquilibrium': "\u296E",
    'upharpoonleft': "\u21BF",
    'upharpoonright': "\u21BE",
    'uplus': "\u228E",
    'UpperLeftArrow': "\u2196",
    'UpperRightArrow': "\u2197",
    'upsi': "\u03C5",
    'Upsi': "\u03D2",
    'upsih': "\u03D2",
    'upsilon': "\u03C5",
    'Upsilon': "\u03A5",
    'UpTee': "\u22A5",
    'UpTeeArrow': "\u21A5",
    'upuparrows': "\u21C8",
    'urcorn': "\u231D",
    'urcorner': "\u231D",
    'urcrop': "\u230E",
    'uring': "\u016F",
    'Uring': "\u016E",
    'urtri': "\u25F9",
    'uscr': "\uD835\uDCCA",
    'Uscr': "\uD835\uDCB0",
    'utdot': "\u22F0",
    'utilde': "\u0169",
    'Utilde': "\u0168",
    'utri': "\u25B5",
    'utrif': "\u25B4",
    'uuarr': "\u21C8",
    'uuml': '\xFC',
    'Uuml': '\xDC',
    'uwangle': "\u29A7",
    'vangrt': "\u299C",
    'varepsilon': "\u03F5",
    'varkappa': "\u03F0",
    'varnothing': "\u2205",
    'varphi': "\u03D5",
    'varpi': "\u03D6",
    'varpropto': "\u221D",
    'varr': "\u2195",
    'vArr': "\u21D5",
    'varrho': "\u03F1",
    'varsigma': "\u03C2",
    'varsubsetneq': "\u228A\uFE00",
    'varsubsetneqq': "\u2ACB\uFE00",
    'varsupsetneq': "\u228B\uFE00",
    'varsupsetneqq': "\u2ACC\uFE00",
    'vartheta': "\u03D1",
    'vartriangleleft': "\u22B2",
    'vartriangleright': "\u22B3",
    'vBar': "\u2AE8",
    'Vbar': "\u2AEB",
    'vBarv': "\u2AE9",
    'vcy': "\u0432",
    'Vcy': "\u0412",
    'vdash': "\u22A2",
    'vDash': "\u22A8",
    'Vdash': "\u22A9",
    'VDash': "\u22AB",
    'Vdashl': "\u2AE6",
    'vee': "\u2228",
    'Vee': "\u22C1",
    'veebar': "\u22BB",
    'veeeq': "\u225A",
    'vellip': "\u22EE",
    'verbar': '|',
    'Verbar': "\u2016",
    'vert': '|',
    'Vert': "\u2016",
    'VerticalBar': "\u2223",
    'VerticalLine': '|',
    'VerticalSeparator': "\u2758",
    'VerticalTilde': "\u2240",
    'VeryThinSpace': "\u200A",
    'vfr': "\uD835\uDD33",
    'Vfr': "\uD835\uDD19",
    'vltri': "\u22B2",
    'vnsub': "\u2282\u20D2",
    'vnsup': "\u2283\u20D2",
    'vopf': "\uD835\uDD67",
    'Vopf': "\uD835\uDD4D",
    'vprop': "\u221D",
    'vrtri': "\u22B3",
    'vscr': "\uD835\uDCCB",
    'Vscr': "\uD835\uDCB1",
    'vsubne': "\u228A\uFE00",
    'vsubnE': "\u2ACB\uFE00",
    'vsupne': "\u228B\uFE00",
    'vsupnE': "\u2ACC\uFE00",
    'Vvdash': "\u22AA",
    'vzigzag': "\u299A",
    'wcirc': "\u0175",
    'Wcirc': "\u0174",
    'wedbar': "\u2A5F",
    'wedge': "\u2227",
    'Wedge': "\u22C0",
    'wedgeq': "\u2259",
    'weierp': "\u2118",
    'wfr': "\uD835\uDD34",
    'Wfr': "\uD835\uDD1A",
    'wopf': "\uD835\uDD68",
    'Wopf': "\uD835\uDD4E",
    'wp': "\u2118",
    'wr': "\u2240",
    'wreath': "\u2240",
    'wscr': "\uD835\uDCCC",
    'Wscr': "\uD835\uDCB2",
    'xcap': "\u22C2",
    'xcirc': "\u25EF",
    'xcup': "\u22C3",
    'xdtri': "\u25BD",
    'xfr': "\uD835\uDD35",
    'Xfr': "\uD835\uDD1B",
    'xharr': "\u27F7",
    'xhArr': "\u27FA",
    'xi': "\u03BE",
    'Xi': "\u039E",
    'xlarr': "\u27F5",
    'xlArr': "\u27F8",
    'xmap': "\u27FC",
    'xnis': "\u22FB",
    'xodot': "\u2A00",
    'xopf': "\uD835\uDD69",
    'Xopf': "\uD835\uDD4F",
    'xoplus': "\u2A01",
    'xotime': "\u2A02",
    'xrarr': "\u27F6",
    'xrArr': "\u27F9",
    'xscr': "\uD835\uDCCD",
    'Xscr': "\uD835\uDCB3",
    'xsqcup': "\u2A06",
    'xuplus': "\u2A04",
    'xutri': "\u25B3",
    'xvee': "\u22C1",
    'xwedge': "\u22C0",
    'yacute': '\xFD',
    'Yacute': '\xDD',
    'yacy': "\u044F",
    'YAcy': "\u042F",
    'ycirc': "\u0177",
    'Ycirc': "\u0176",
    'ycy': "\u044B",
    'Ycy': "\u042B",
    'yen': '\xA5',
    'yfr': "\uD835\uDD36",
    'Yfr': "\uD835\uDD1C",
    'yicy': "\u0457",
    'YIcy': "\u0407",
    'yopf': "\uD835\uDD6A",
    'Yopf': "\uD835\uDD50",
    'yscr': "\uD835\uDCCE",
    'Yscr': "\uD835\uDCB4",
    'yucy': "\u044E",
    'YUcy': "\u042E",
    'yuml': '\xFF',
    'Yuml': "\u0178",
    'zacute': "\u017A",
    'Zacute': "\u0179",
    'zcaron': "\u017E",
    'Zcaron': "\u017D",
    'zcy': "\u0437",
    'Zcy': "\u0417",
    'zdot': "\u017C",
    'Zdot': "\u017B",
    'zeetrf': "\u2128",
    'ZeroWidthSpace': "\u200B",
    'zeta': "\u03B6",
    'Zeta': "\u0396",
    'zfr': "\uD835\uDD37",
    'Zfr': "\u2128",
    'zhcy': "\u0436",
    'ZHcy': "\u0416",
    'zigrarr': "\u21DD",
    'zopf': "\uD835\uDD6B",
    'Zopf': "\u2124",
    'zscr': "\uD835\uDCCF",
    'Zscr': "\uD835\uDCB5",
    'zwj': "\u200D",
    'zwnj': "\u200C"
  };
  var decodeMapLegacy = {
    'aacute': '\xE1',
    'Aacute': '\xC1',
    'acirc': '\xE2',
    'Acirc': '\xC2',
    'acute': '\xB4',
    'aelig': '\xE6',
    'AElig': '\xC6',
    'agrave': '\xE0',
    'Agrave': '\xC0',
    'amp': '&',
    'AMP': '&',
    'aring': '\xE5',
    'Aring': '\xC5',
    'atilde': '\xE3',
    'Atilde': '\xC3',
    'auml': '\xE4',
    'Auml': '\xC4',
    'brvbar': '\xA6',
    'ccedil': '\xE7',
    'Ccedil': '\xC7',
    'cedil': '\xB8',
    'cent': '\xA2',
    'copy': '\xA9',
    'COPY': '\xA9',
    'curren': '\xA4',
    'deg': '\xB0',
    'divide': '\xF7',
    'eacute': '\xE9',
    'Eacute': '\xC9',
    'ecirc': '\xEA',
    'Ecirc': '\xCA',
    'egrave': '\xE8',
    'Egrave': '\xC8',
    'eth': '\xF0',
    'ETH': '\xD0',
    'euml': '\xEB',
    'Euml': '\xCB',
    'frac12': '\xBD',
    'frac14': '\xBC',
    'frac34': '\xBE',
    'gt': '>',
    'GT': '>',
    'iacute': '\xED',
    'Iacute': '\xCD',
    'icirc': '\xEE',
    'Icirc': '\xCE',
    'iexcl': '\xA1',
    'igrave': '\xEC',
    'Igrave': '\xCC',
    'iquest': '\xBF',
    'iuml': '\xEF',
    'Iuml': '\xCF',
    'laquo': '\xAB',
    'lt': '<',
    'LT': '<',
    'macr': '\xAF',
    'micro': '\xB5',
    'middot': '\xB7',
    'nbsp': '\xA0',
    'not': '\xAC',
    'ntilde': '\xF1',
    'Ntilde': '\xD1',
    'oacute': '\xF3',
    'Oacute': '\xD3',
    'ocirc': '\xF4',
    'Ocirc': '\xD4',
    'ograve': '\xF2',
    'Ograve': '\xD2',
    'ordf': '\xAA',
    'ordm': '\xBA',
    'oslash': '\xF8',
    'Oslash': '\xD8',
    'otilde': '\xF5',
    'Otilde': '\xD5',
    'ouml': '\xF6',
    'Ouml': '\xD6',
    'para': '\xB6',
    'plusmn': '\xB1',
    'pound': '\xA3',
    'quot': '"',
    'QUOT': '"',
    'raquo': '\xBB',
    'reg': '\xAE',
    'REG': '\xAE',
    'sect': '\xA7',
    'shy': '\xAD',
    'sup1': '\xB9',
    'sup2': '\xB2',
    'sup3': '\xB3',
    'szlig': '\xDF',
    'thorn': '\xFE',
    'THORN': '\xDE',
    'times': '\xD7',
    'uacute': '\xFA',
    'Uacute': '\xDA',
    'ucirc': '\xFB',
    'Ucirc': '\xDB',
    'ugrave': '\xF9',
    'Ugrave': '\xD9',
    'uml': '\xA8',
    'uuml': '\xFC',
    'Uuml': '\xDC',
    'yacute': '\xFD',
    'Yacute': '\xDD',
    'yen': '\xA5',
    'yuml': '\xFF'
  };
  var decodeMapNumeric = {
    '0': "\uFFFD",
    '128': "\u20AC",
    '130': "\u201A",
    '131': "\u0192",
    '132': "\u201E",
    '133': "\u2026",
    '134': "\u2020",
    '135': "\u2021",
    '136': "\u02C6",
    '137': "\u2030",
    '138': "\u0160",
    '139': "\u2039",
    '140': "\u0152",
    '142': "\u017D",
    '145': "\u2018",
    '146': "\u2019",
    '147': "\u201C",
    '148': "\u201D",
    '149': "\u2022",
    '150': "\u2013",
    '151': "\u2014",
    '152': "\u02DC",
    '153': "\u2122",
    '154': "\u0161",
    '155': "\u203A",
    '156': "\u0153",
    '158': "\u017E",
    '159': "\u0178"
  };
  var invalidReferenceCodePoints = [1, 2, 3, 4, 5, 6, 7, 8, 11, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 64976, 64977, 64978, 64979, 64980, 64981, 64982, 64983, 64984, 64985, 64986, 64987, 64988, 64989, 64990, 64991, 64992, 64993, 64994, 64995, 64996, 64997, 64998, 64999, 65000, 65001, 65002, 65003, 65004, 65005, 65006, 65007, 65534, 65535, 131070, 131071, 196606, 196607, 262142, 262143, 327678, 327679, 393214, 393215, 458750, 458751, 524286, 524287, 589822, 589823, 655358, 655359, 720894, 720895, 786430, 786431, 851966, 851967, 917502, 917503, 983038, 983039, 1048574, 1048575, 1114110, 1114111];

  /*--------------------------------------------------------------------------*/

  var stringFromCharCode = String.fromCharCode;
  var object = {};
  var hasOwnProperty = object.hasOwnProperty;
  var has = function has(object, propertyName) {
    return hasOwnProperty.call(object, propertyName);
  };
  var contains = function contains(array, value) {
    var index = -1;
    var length = array.length;
    while (++index < length) {
      if (array[index] == value) {
        return true;
      }
    }
    return false;
  };
  var merge = function merge(options, defaults) {
    if (!options) {
      return defaults;
    }
    var result = {};
    var key;
    for (key in defaults) {
      // A `hasOwnProperty` check is not needed here, since only recognized
      // option names are used anyway. Any others are ignored.
      result[key] = has(options, key) ? options[key] : defaults[key];
    }
    return result;
  };

  // Modified version of `ucs2encode`; see https://mths.be/punycode.
  var codePointToSymbol = function codePointToSymbol(codePoint, strict) {
    var output = '';
    if (codePoint >= 0xD800 && codePoint <= 0xDFFF || codePoint > 0x10FFFF) {
      // See issue #4:
      // “Otherwise, if the number is in the range 0xD800 to 0xDFFF or is
      // greater than 0x10FFFF, then this is a parse error. Return a U+FFFD
      // REPLACEMENT CHARACTER.”
      if (strict) {
        parseError('character reference outside the permissible Unicode range');
      }
      return "\uFFFD";
    }
    if (has(decodeMapNumeric, codePoint)) {
      if (strict) {
        parseError('disallowed character reference');
      }
      return decodeMapNumeric[codePoint];
    }
    if (strict && contains(invalidReferenceCodePoints, codePoint)) {
      parseError('disallowed character reference');
    }
    if (codePoint > 0xFFFF) {
      codePoint -= 0x10000;
      output += stringFromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
      codePoint = 0xDC00 | codePoint & 0x3FF;
    }
    output += stringFromCharCode(codePoint);
    return output;
  };
  var hexEscape = function hexEscape(codePoint) {
    return '&#x' + codePoint.toString(16).toUpperCase() + ';';
  };
  var decEscape = function decEscape(codePoint) {
    return '&#' + codePoint + ';';
  };
  var parseError = function parseError(message) {
    throw Error('Parse error: ' + message);
  };

  /*--------------------------------------------------------------------------*/

  var encode = function encode(string, options) {
    options = merge(options, encode.options);
    var strict = options.strict;
    if (strict && regexInvalidRawCodePoint.test(string)) {
      parseError('forbidden code point');
    }
    var encodeEverything = options.encodeEverything;
    var useNamedReferences = options.useNamedReferences;
    var allowUnsafeSymbols = options.allowUnsafeSymbols;
    var escapeCodePoint = options.decimal ? decEscape : hexEscape;
    var escapeBmpSymbol = function escapeBmpSymbol(symbol) {
      return escapeCodePoint(symbol.charCodeAt(0));
    };
    if (encodeEverything) {
      // Encode ASCII symbols.
      string = string.replace(regexAsciiWhitelist, function (symbol) {
        // Use named references if requested & possible.
        if (useNamedReferences && has(encodeMap, symbol)) {
          return '&' + encodeMap[symbol] + ';';
        }
        return escapeBmpSymbol(symbol);
      });
      // Shorten a few escapes that represent two symbols, of which at least one
      // is within the ASCII range.
      if (useNamedReferences) {
        string = string.replace(/&gt;\u20D2/g, '&nvgt;').replace(/&lt;\u20D2/g, '&nvlt;').replace(/&#x66;&#x6A;/g, '&fjlig;');
      }
      // Encode non-ASCII symbols.
      if (useNamedReferences) {
        // Encode non-ASCII symbols that can be replaced with a named reference.
        string = string.replace(regexEncodeNonAscii, function (string) {
          // Note: there is no need to check `has(encodeMap, string)` here.
          return '&' + encodeMap[string] + ';';
        });
      }
      // Note: any remaining non-ASCII symbols are handled outside of the `if`.
    } else if (useNamedReferences) {
      // Apply named character references.
      // Encode `<>"'&` using named character references.
      if (!allowUnsafeSymbols) {
        string = string.replace(regexEscape, function (string) {
          return '&' + encodeMap[string] + ';'; // no need to check `has()` here
        });
      }
      // Shorten escapes that represent two symbols, of which at least one is
      // `<>"'&`.
      string = string.replace(/&gt;\u20D2/g, '&nvgt;').replace(/&lt;\u20D2/g, '&nvlt;');
      // Encode non-ASCII symbols that can be replaced with a named reference.
      string = string.replace(regexEncodeNonAscii, function (string) {
        // Note: there is no need to check `has(encodeMap, string)` here.
        return '&' + encodeMap[string] + ';';
      });
    } else if (!allowUnsafeSymbols) {
      // Encode `<>"'&` using hexadecimal escapes, now that they’re not handled
      // using named character references.
      string = string.replace(regexEscape, escapeBmpSymbol);
    }
    return string
    // Encode astral symbols.
    .replace(regexAstralSymbols, function ($0) {
      // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      var high = $0.charCodeAt(0);
      var low = $0.charCodeAt(1);
      var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
      return escapeCodePoint(codePoint);
    })
    // Encode any remaining BMP symbols that are not printable ASCII symbols
    // using a hexadecimal escape.
    .replace(regexBmpWhitelist, escapeBmpSymbol);
  };
  // Expose default options (so they can be overridden globally).
  encode.options = {
    'allowUnsafeSymbols': false,
    'encodeEverything': false,
    'strict': false,
    'useNamedReferences': false,
    'decimal': false
  };
  var decode = function decode(html, options) {
    options = merge(options, decode.options);
    var strict = options.strict;
    if (strict && regexInvalidEntity.test(html)) {
      parseError('malformed character reference');
    }
    return html.replace(regexDecode, function ($0, $1, $2, $3, $4, $5, $6, $7, $8) {
      var codePoint;
      var semicolon;
      var decDigits;
      var hexDigits;
      var reference;
      var next;
      if ($1) {
        reference = $1;
        // Note: there is no need to check `has(decodeMap, reference)`.
        return decodeMap[reference];
      }
      if ($2) {
        // Decode named character references without trailing `;`, e.g. `&amp`.
        // This is only a parse error if it gets converted to `&`, or if it is
        // followed by `=` in an attribute context.
        reference = $2;
        next = $3;
        if (next && options.isAttributeValue) {
          if (strict && next == '=') {
            parseError('`&` did not start a character reference');
          }
          return $0;
        } else {
          if (strict) {
            parseError('named character reference was not terminated by a semicolon');
          }
          // Note: there is no need to check `has(decodeMapLegacy, reference)`.
          return decodeMapLegacy[reference] + (next || '');
        }
      }
      if ($4) {
        // Decode decimal escapes, e.g. `&#119558;`.
        decDigits = $4;
        semicolon = $5;
        if (strict && !semicolon) {
          parseError('character reference was not terminated by a semicolon');
        }
        codePoint = parseInt(decDigits, 10);
        return codePointToSymbol(codePoint, strict);
      }
      if ($6) {
        // Decode hexadecimal escapes, e.g. `&#x1D306;`.
        hexDigits = $6;
        semicolon = $7;
        if (strict && !semicolon) {
          parseError('character reference was not terminated by a semicolon');
        }
        codePoint = parseInt(hexDigits, 16);
        return codePointToSymbol(codePoint, strict);
      }

      // If we’re still here, `if ($7)` is implied; it’s an ambiguous
      // ampersand for sure. https://mths.be/notes/ambiguous-ampersands
      if (strict) {
        parseError('named character reference was not terminated by a semicolon');
      }
      return $0;
    });
  };
  // Expose default options (so they can be overridden globally).
  decode.options = {
    'isAttributeValue': false,
    'strict': false
  };
  var escape = function escape(string) {
    return string.replace(regexEscape, function ($0) {
      // Note: there is no need to check `has(escapeMap, $0)` here.
      return escapeMap[$0];
    });
  };

  /*--------------------------------------------------------------------------*/

  var he = {
    'version': '1.2.0',
    'encode': encode,
    'decode': decode,
    'escape': escape,
    'unescape': decode
  };

  // Some AMD build optimizers, like r.js, check for specific condition patterns
  // like the following:
  if ( true && _typeof(__webpack_require__.amdO) == 'object' && __webpack_require__.amdO) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return he;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (freeExports && !freeExports.nodeType) {
    if (freeModule) {
      // in Node.js, io.js, or RingoJS v0.8.0+
      freeModule.exports = he;
    } else {
      // in Narwhal or RingoJS v0.7.0-
      for (var key in he) {
        has(he, key) && (freeExports[key] = he[key]);
      }
    }
  } else {
    // in Rhino or a web browser
    root.he = he;
  }
})(this);

/***/ }),

/***/ 16301:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(66992);
__webpack_require__(51532);
__webpack_require__(41539);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(70189);
__webpack_require__(43371);
__webpack_require__(54747);
__webpack_require__(36210);
__webpack_require__(98410);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(92222);
__webpack_require__(69600);
__webpack_require__(24603);
__webpack_require__(39714);
__webpack_require__(21249);
__webpack_require__(9653);
__webpack_require__(19601);
__webpack_require__(23123);
__webpack_require__(4723);
__webpack_require__(47941);
__webpack_require__(26699);
__webpack_require__(34553);
__webpack_require__(40561);
__webpack_require__(47042);
__webpack_require__(32023);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(69826);
__webpack_require__(23157);
__webpack_require__(57327);
__webpack_require__(2707);
__webpack_require__(68309);
__webpack_require__(32165);
__webpack_require__(30489);
__webpack_require__(12419);
__webpack_require__(91038);
function deepFreeze(obj) {
  if (obj instanceof Map) {
    obj.clear = obj.delete = obj.set = function () {
      throw new Error('map is read-only');
    };
  } else if (obj instanceof Set) {
    obj.add = obj.clear = obj.delete = function () {
      throw new Error('set is read-only');
    };
  }

  // Freeze self
  Object.freeze(obj);
  Object.getOwnPropertyNames(obj).forEach(function (name) {
    var prop = obj[name];

    // Freeze prop if it is an object
    if (_typeof(prop) == 'object' && !Object.isFrozen(prop)) {
      deepFreeze(prop);
    }
  });
  return obj;
}
var deepFreezeEs6 = deepFreeze;
var _default = deepFreeze;
deepFreezeEs6.default = _default;

/** @implements CallbackResponse */
var Response = /*#__PURE__*/function () {
  "use strict";

  /**
   * @param {CompiledMode} mode
   */
  function Response(mode) {
    _classCallCheck(this, Response);
    // eslint-disable-next-line no-undefined
    if (mode.data === undefined) mode.data = {};
    this.data = mode.data;
    this.isMatchIgnored = false;
  }
  _createClass(Response, [{
    key: "ignoreMatch",
    value: function ignoreMatch() {
      this.isMatchIgnored = true;
    }
  }]);
  return Response;
}(); /**
      * @param {string} value
      * @returns {string}
      */
function escapeHTML(value) {
  return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;');
}

/**
 * performs a shallow merge of multiple objects into one
 *
 * @template T
 * @param {T} original
 * @param {Record<string,any>[]} objects
 * @returns {T} a single new object
 */
function inherit(original) {
  /** @type Record<string,any> */
  var result = Object.create(null);
  for (var key in original) {
    result[key] = original[key];
  }
  for (var _len = arguments.length, objects = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    objects[_key - 1] = arguments[_key];
  }
  objects.forEach(function (obj) {
    for (var _key2 in obj) {
      result[_key2] = obj[_key2];
    }
  });
  return result;
}

/**
 * @typedef {object} Renderer
 * @property {(text: string) => void} addText
 * @property {(node: Node) => void} openNode
 * @property {(node: Node) => void} closeNode
 * @property {() => string} value
 */

/** @typedef {{kind?: string, sublanguage?: boolean}} Node */
/** @typedef {{walk: (r: Renderer) => void}} Tree */
/** */

var SPAN_CLOSE = '</span>';

/**
 * Determines if a node needs to be wrapped in <span>
 *
 * @param {Node} node */
var emitsWrappingTags = function emitsWrappingTags(node) {
  return !!node.kind;
};

/** @type {Renderer} */
var HTMLRenderer = /*#__PURE__*/function () {
  "use strict";

  /**
   * Creates a new HTMLRenderer
   *
   * @param {Tree} parseTree - the parse tree (must support `walk` API)
   * @param {{classPrefix: string}} options
   */
  function HTMLRenderer(parseTree, options) {
    _classCallCheck(this, HTMLRenderer);
    this.buffer = "";
    this.classPrefix = options.classPrefix;
    parseTree.walk(this);
  }

  /**
   * Adds texts to the output stream
   *
   * @param {string} text */
  _createClass(HTMLRenderer, [{
    key: "addText",
    value: function addText(text) {
      this.buffer += escapeHTML(text);
    }

    /**
     * Adds a node open to the output stream (if needed)
     *
     * @param {Node} node */
  }, {
    key: "openNode",
    value: function openNode(node) {
      if (!emitsWrappingTags(node)) return;
      var className = node.kind;
      if (!node.sublanguage) {
        className = "".concat(this.classPrefix).concat(className);
      }
      this.span(className);
    }

    /**
     * Adds a node close to the output stream (if needed)
     *
     * @param {Node} node */
  }, {
    key: "closeNode",
    value: function closeNode(node) {
      if (!emitsWrappingTags(node)) return;
      this.buffer += SPAN_CLOSE;
    }

    /**
     * returns the accumulated buffer
    */
  }, {
    key: "value",
    value: function value() {
      return this.buffer;
    }

    // helpers

    /**
     * Builds a span element
     *
     * @param {string} className */
  }, {
    key: "span",
    value: function span(className) {
      this.buffer += "<span class=\"".concat(className, "\">");
    }
  }]);
  return HTMLRenderer;
}();
/** @typedef {{kind?: string, sublanguage?: boolean, children: Node[]} | string} Node */
/** @typedef {{kind?: string, sublanguage?: boolean, children: Node[]} } DataNode */
/**  */
var TokenTree = /*#__PURE__*/function () {
  "use strict";

  function TokenTree() {
    _classCallCheck(this, TokenTree);
    /** @type DataNode */
    this.rootNode = {
      children: []
    };
    this.stack = [this.rootNode];
  }
  _createClass(TokenTree, [{
    key: "top",
    get: function get() {
      return this.stack[this.stack.length - 1];
    }
  }, {
    key: "root",
    get: function get() {
      return this.rootNode;
    }

    /** @param {Node} node */
  }, {
    key: "add",
    value: function add(node) {
      this.top.children.push(node);
    }

    /** @param {string} kind */
  }, {
    key: "openNode",
    value: function openNode(kind) {
      /** @type Node */
      var node = {
        kind: kind,
        children: []
      };
      this.add(node);
      this.stack.push(node);
    }
  }, {
    key: "closeNode",
    value: function closeNode() {
      if (this.stack.length > 1) {
        return this.stack.pop();
      }
      // eslint-disable-next-line no-undefined
      return undefined;
    }
  }, {
    key: "closeAllNodes",
    value: function closeAllNodes() {
      while (this.closeNode()) {
        ;
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return JSON.stringify(this.rootNode, null, 4);
    }

    /**
     * @typedef { import("./html_renderer").Renderer } Renderer
     * @param {Renderer} builder
     */
  }, {
    key: "walk",
    value: function walk(builder) {
      // this does not
      return this.constructor._walk(builder, this.rootNode);
      // this works
      // return TokenTree._walk(builder, this.rootNode);
    }

    /**
     * @param {Renderer} builder
     * @param {Node} node
     */
  }], [{
    key: "_walk",
    value: function _walk(builder, node) {
      var _this = this;
      if (typeof node === "string") {
        builder.addText(node);
      } else if (node.children) {
        builder.openNode(node);
        node.children.forEach(function (child) {
          return _this._walk(builder, child);
        });
        builder.closeNode(node);
      }
      return builder;
    }

    /**
     * @param {Node} node
     */
  }, {
    key: "_collapse",
    value: function _collapse(node) {
      if (typeof node === "string") return;
      if (!node.children) return;
      if (node.children.every(function (el) {
        return typeof el === "string";
      })) {
        // node.text = node.children.join("");
        // delete node.children;
        node.children = [node.children.join("")];
      } else {
        node.children.forEach(function (child) {
          TokenTree._collapse(child);
        });
      }
    }
  }]);
  return TokenTree;
}();
/**
  Currently this is all private API, but this is the minimal API necessary
  that an Emitter must implement to fully support the parser.

  Minimal interface:

  - addKeyword(text, kind)
  - addText(text)
  - addSublanguage(emitter, subLanguageName)
  - finalize()
  - openNode(kind)
  - closeNode()
  - closeAllNodes()
  - toHTML()

*/
/**
 * @implements {Emitter}
 */
var TokenTreeEmitter = /*#__PURE__*/function (_TokenTree) {
  "use strict";

  _inherits(TokenTreeEmitter, _TokenTree);
  var _super = _createSuper(TokenTreeEmitter);
  /**
   * @param {*} options
   */
  function TokenTreeEmitter(options) {
    var _this2;
    _classCallCheck(this, TokenTreeEmitter);
    _this2 = _super.call(this);
    _this2.options = options;
    return _this2;
  }

  /**
   * @param {string} text
   * @param {string} kind
   */
  _createClass(TokenTreeEmitter, [{
    key: "addKeyword",
    value: function addKeyword(text, kind) {
      if (text === "") {
        return;
      }
      this.openNode(kind);
      this.addText(text);
      this.closeNode();
    }

    /**
     * @param {string} text
     */
  }, {
    key: "addText",
    value: function addText(text) {
      if (text === "") {
        return;
      }
      this.add(text);
    }

    /**
     * @param {Emitter & {root: DataNode}} emitter
     * @param {string} name
     */
  }, {
    key: "addSublanguage",
    value: function addSublanguage(emitter, name) {
      /** @type DataNode */
      var node = emitter.root;
      node.kind = name;
      node.sublanguage = true;
      this.add(node);
    }
  }, {
    key: "toHTML",
    value: function toHTML() {
      var renderer = new HTMLRenderer(this, this.options);
      return renderer.value();
    }
  }, {
    key: "finalize",
    value: function finalize() {
      return true;
    }
  }]);
  return TokenTreeEmitter;
}(TokenTree); /**
               * @param {string} value
               * @returns {RegExp}
               * */
function escape(value) {
  return new RegExp(value.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), 'm');
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
    args[_key3] = arguments[_key3];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */
function either() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key4 = 0; _key4 < _len3; _key4++) {
    args[_key4] = arguments[_key4];
  }
  var joined = '(' + args.map(function (x) {
    return source(x);
  }).join("|") + ")";
  return joined;
}

/**
 * @param {RegExp} re
 * @returns {number}
 */
function countMatchGroups(re) {
  return new RegExp(re.toString() + '|').exec('').length - 1;
}

/**
 * Does lexeme start with a regular expression match at the beginning
 * @param {RegExp} re
 * @param {string} lexeme
 */
function startsWith(re, lexeme) {
  var match = re && re.exec(lexeme);
  return match && match.index === 0;
}

// BACKREF_RE matches an open parenthesis or backreference. To avoid
// an incorrect parse, it additionally matches the following:
// - [...] elements, where the meaning of parentheses and escapes change
// - other escape sequences, so we do not misparse escape sequences as
//   interesting elements
// - non-matching or lookahead parentheses, which do not capture. These
//   follow the '(' with a '?'.
var BACKREF_RE = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;

// join logically computes regexps.join(separator), but fixes the
// backreferences so they continue to match.
// it also places each individual regular expression into it's own
// match group, keeping track of the sequencing of those match groups
// is currently an exercise for the caller. :-)
/**
 * @param {(string | RegExp)[]} regexps
 * @param {string} separator
 * @returns {string}
 */
function join(regexps) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "|";
  var numCaptures = 0;
  return regexps.map(function (regex) {
    numCaptures += 1;
    var offset = numCaptures;
    var re = source(regex);
    var out = '';
    while (re.length > 0) {
      var match = BACKREF_RE.exec(re);
      if (!match) {
        out += re;
        break;
      }
      out += re.substring(0, match.index);
      re = re.substring(match.index + match[0].length);
      if (match[0][0] === '\\' && match[1]) {
        // Adjust the backreference.
        out += '\\' + String(Number(match[1]) + offset);
      } else {
        out += match[0];
        if (match[0] === '(') {
          numCaptures++;
        }
      }
    }
    return out;
  }).map(function (re) {
    return "(".concat(re, ")");
  }).join(separator);
}

// Common regexps
var MATCH_NOTHING_RE = /\b\B/;
var IDENT_RE = '[a-zA-Z]\\w*';
var UNDERSCORE_IDENT_RE = '[a-zA-Z_]\\w*';
var NUMBER_RE = '\\b\\d+(\\.\\d+)?';
var C_NUMBER_RE = '(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)'; // 0x..., 0..., decimal, float
var BINARY_NUMBER_RE = '\\b(0b[01]+)'; // 0b...
var RE_STARTERS_RE = '!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~';

/**
* @param { Partial<Mode> & {binary?: string | RegExp} } opts
*/
var SHEBANG = function SHEBANG() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var beginShebang = /^#![ ]*\//;
  if (opts.binary) {
    opts.begin = concat(beginShebang, /.*\b/, opts.binary, /\b.*/);
  }
  return inherit({
    className: 'meta',
    begin: beginShebang,
    end: /$/,
    relevance: 0,
    /** @type {ModeCallback} */
    "on:begin": function onBegin(m, resp) {
      if (m.index !== 0) resp.ignoreMatch();
    }
  }, opts);
};

// Common modes
var BACKSLASH_ESCAPE = {
  begin: '\\\\[\\s\\S]',
  relevance: 0
};
var APOS_STRING_MODE = {
  className: 'string',
  begin: '\'',
  end: '\'',
  illegal: '\\n',
  contains: [BACKSLASH_ESCAPE]
};
var QUOTE_STRING_MODE = {
  className: 'string',
  begin: '"',
  end: '"',
  illegal: '\\n',
  contains: [BACKSLASH_ESCAPE]
};
var PHRASAL_WORDS_MODE = {
  begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
};
/**
 * Creates a comment mode
 *
 * @param {string | RegExp} begin
 * @param {string | RegExp} end
 * @param {Mode | {}} [modeOptions]
 * @returns {Partial<Mode>}
 */
var COMMENT = function COMMENT(begin, end) {
  var modeOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var mode = inherit({
    className: 'comment',
    begin: begin,
    end: end,
    contains: []
  }, modeOptions);
  mode.contains.push(PHRASAL_WORDS_MODE);
  mode.contains.push({
    className: 'doctag',
    begin: '(?:TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):',
    relevance: 0
  });
  return mode;
};
var C_LINE_COMMENT_MODE = COMMENT('//', '$');
var C_BLOCK_COMMENT_MODE = COMMENT('/\\*', '\\*/');
var HASH_COMMENT_MODE = COMMENT('#', '$');
var NUMBER_MODE = {
  className: 'number',
  begin: NUMBER_RE,
  relevance: 0
};
var C_NUMBER_MODE = {
  className: 'number',
  begin: C_NUMBER_RE,
  relevance: 0
};
var BINARY_NUMBER_MODE = {
  className: 'number',
  begin: BINARY_NUMBER_RE,
  relevance: 0
};
var CSS_NUMBER_MODE = {
  className: 'number',
  begin: NUMBER_RE + '(' + '%|em|ex|ch|rem' + '|vw|vh|vmin|vmax' + '|cm|mm|in|pt|pc|px' + '|deg|grad|rad|turn' + '|s|ms' + '|Hz|kHz' + '|dpi|dpcm|dppx' + ')?',
  relevance: 0
};
var REGEXP_MODE = {
  // this outer rule makes sure we actually have a WHOLE regex and not simply
  // an expression such as:
  //
  //     3 / something
  //
  // (which will then blow up when regex's `illegal` sees the newline)
  begin: /(?=\/[^/\n]*\/)/,
  contains: [{
    className: 'regexp',
    begin: /\//,
    end: /\/[gimuy]*/,
    illegal: /\n/,
    contains: [BACKSLASH_ESCAPE, {
      begin: /\[/,
      end: /\]/,
      relevance: 0,
      contains: [BACKSLASH_ESCAPE]
    }]
  }]
};
var TITLE_MODE = {
  className: 'title',
  begin: IDENT_RE,
  relevance: 0
};
var UNDERSCORE_TITLE_MODE = {
  className: 'title',
  begin: UNDERSCORE_IDENT_RE,
  relevance: 0
};
var METHOD_GUARD = {
  // excludes method names from keyword processing
  begin: '\\.\\s*' + UNDERSCORE_IDENT_RE,
  relevance: 0
};

/**
 * Adds end same as begin mechanics to a mode
 *
 * Your mode must include at least a single () match group as that first match
 * group is what is used for comparison
 * @param {Partial<Mode>} mode
 */
var END_SAME_AS_BEGIN = function END_SAME_AS_BEGIN(mode) {
  return Object.assign(mode, {
    /** @type {ModeCallback} */
    'on:begin': function onBegin(m, resp) {
      resp.data._beginMatch = m[1];
    },
    /** @type {ModeCallback} */
    'on:end': function onEnd(m, resp) {
      if (resp.data._beginMatch !== m[1]) resp.ignoreMatch();
    }
  });
};
var MODES = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MATCH_NOTHING_RE: MATCH_NOTHING_RE,
  IDENT_RE: IDENT_RE,
  UNDERSCORE_IDENT_RE: UNDERSCORE_IDENT_RE,
  NUMBER_RE: NUMBER_RE,
  C_NUMBER_RE: C_NUMBER_RE,
  BINARY_NUMBER_RE: BINARY_NUMBER_RE,
  RE_STARTERS_RE: RE_STARTERS_RE,
  SHEBANG: SHEBANG,
  BACKSLASH_ESCAPE: BACKSLASH_ESCAPE,
  APOS_STRING_MODE: APOS_STRING_MODE,
  QUOTE_STRING_MODE: QUOTE_STRING_MODE,
  PHRASAL_WORDS_MODE: PHRASAL_WORDS_MODE,
  COMMENT: COMMENT,
  C_LINE_COMMENT_MODE: C_LINE_COMMENT_MODE,
  C_BLOCK_COMMENT_MODE: C_BLOCK_COMMENT_MODE,
  HASH_COMMENT_MODE: HASH_COMMENT_MODE,
  NUMBER_MODE: NUMBER_MODE,
  C_NUMBER_MODE: C_NUMBER_MODE,
  BINARY_NUMBER_MODE: BINARY_NUMBER_MODE,
  CSS_NUMBER_MODE: CSS_NUMBER_MODE,
  REGEXP_MODE: REGEXP_MODE,
  TITLE_MODE: TITLE_MODE,
  UNDERSCORE_TITLE_MODE: UNDERSCORE_TITLE_MODE,
  METHOD_GUARD: METHOD_GUARD,
  END_SAME_AS_BEGIN: END_SAME_AS_BEGIN
});

// Grammar extensions / plugins
// See: https://github.com/highlightjs/highlight.js/issues/2833

// Grammar extensions allow "syntactic sugar" to be added to the grammar modes
// without requiring any underlying changes to the compiler internals.

// `compileMatch` being the perfect small example of now allowing a grammar
// author to write `match` when they desire to match a single expression rather
// than being forced to use `begin`.  The extension then just moves `match` into
// `begin` when it runs.  Ie, no features have been added, but we've just made
// the experience of writing (and reading grammars) a little bit nicer.

// ------

// TODO: We need negative look-behind support to do this properly
/**
 * Skip a match if it has a preceding dot
 *
 * This is used for `beginKeywords` to prevent matching expressions such as
 * `bob.keyword.do()`. The mode compiler automatically wires this up as a
 * special _internal_ 'on:begin' callback for modes with `beginKeywords`
 * @param {RegExpMatchArray} match
 * @param {CallbackResponse} response
 */
function skipIfhasPrecedingDot(match, response) {
  var before = match.input[match.index - 1];
  if (before === ".") {
    response.ignoreMatch();
  }
}

/**
 * `beginKeywords` syntactic sugar
 * @type {CompilerExt}
 */
function beginKeywords(mode, parent) {
  if (!parent) return;
  if (!mode.beginKeywords) return;

  // for languages with keywords that include non-word characters checking for
  // a word boundary is not sufficient, so instead we check for a word boundary
  // or whitespace - this does no harm in any case since our keyword engine
  // doesn't allow spaces in keywords anyways and we still check for the boundary
  // first
  mode.begin = '\\b(' + mode.beginKeywords.split(' ').join('|') + ')(?!\\.)(?=\\b|\\s)';
  mode.__beforeBegin = skipIfhasPrecedingDot;
  mode.keywords = mode.keywords || mode.beginKeywords;
  delete mode.beginKeywords;

  // prevents double relevance, the keywords themselves provide
  // relevance, the mode doesn't need to double it
  // eslint-disable-next-line no-undefined
  if (mode.relevance === undefined) mode.relevance = 0;
}

/**
 * Allow `illegal` to contain an array of illegal values
 * @type {CompilerExt}
 */
function compileIllegal(mode, _parent) {
  if (!Array.isArray(mode.illegal)) return;
  mode.illegal = either.apply(void 0, _toConsumableArray(mode.illegal));
}

/**
 * `match` to match a single expression for readability
 * @type {CompilerExt}
 */
function compileMatch(mode, _parent) {
  if (!mode.match) return;
  if (mode.begin || mode.end) throw new Error("begin & end are not supported with match");
  mode.begin = mode.match;
  delete mode.match;
}

/**
 * provides the default 1 relevance to all modes
 * @type {CompilerExt}
 */
function compileRelevance(mode, _parent) {
  // eslint-disable-next-line no-undefined
  if (mode.relevance === undefined) mode.relevance = 1;
}

// keywords that should have no default relevance value
var COMMON_KEYWORDS = ['of', 'and', 'for', 'in', 'not', 'or', 'if', 'then', 'parent',
// common variable name
'list',
// common variable name
'value' // common variable name
];

var DEFAULT_KEYWORD_CLASSNAME = "keyword";

/**
 * Given raw keywords from a language definition, compile them.
 *
 * @param {string | Record<string,string|string[]> | Array<string>} rawKeywords
 * @param {boolean} caseInsensitive
 */
function compileKeywords(rawKeywords, caseInsensitive) {
  var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_KEYWORD_CLASSNAME;
  /** @type KeywordDict */
  var compiledKeywords = {};

  // input can be a string of keywords, an array of keywords, or a object with
  // named keys representing className (which can then point to a string or array)
  if (typeof rawKeywords === 'string') {
    compileList(className, rawKeywords.split(" "));
  } else if (Array.isArray(rawKeywords)) {
    compileList(className, rawKeywords);
  } else {
    Object.keys(rawKeywords).forEach(function (className) {
      // collapse all our objects back into the parent object
      Object.assign(compiledKeywords, compileKeywords(rawKeywords[className], caseInsensitive, className));
    });
  }
  return compiledKeywords;

  // ---

  /**
   * Compiles an individual list of keywords
   *
   * Ex: "for if when while|5"
   *
   * @param {string} className
   * @param {Array<string>} keywordList
   */
  function compileList(className, keywordList) {
    if (caseInsensitive) {
      keywordList = keywordList.map(function (x) {
        return x.toLowerCase();
      });
    }
    keywordList.forEach(function (keyword) {
      var pair = keyword.split('|');
      compiledKeywords[pair[0]] = [className, scoreForKeyword(pair[0], pair[1])];
    });
  }
}

/**
 * Returns the proper score for a given keyword
 *
 * Also takes into account comment keywords, which will be scored 0 UNLESS
 * another score has been manually assigned.
 * @param {string} keyword
 * @param {string} [providedScore]
 */
function scoreForKeyword(keyword, providedScore) {
  // manual scores always win over common keywords
  // so you can force a score of 1 if you really insist
  if (providedScore) {
    return Number(providedScore);
  }
  return commonKeyword(keyword) ? 0 : 1;
}

/**
 * Determines if a given keyword is common or not
 *
 * @param {string} keyword */
function commonKeyword(keyword) {
  return COMMON_KEYWORDS.includes(keyword.toLowerCase());
}

// compilation

/**
 * Compiles a language definition result
 *
 * Given the raw result of a language definition (Language), compiles this so
 * that it is ready for highlighting code.
 * @param {Language} language
 * @param {{plugins: HLJSPlugin[]}} opts
 * @returns {CompiledLanguage}
 */
function compileLanguage(language, _ref) {
  var plugins = _ref.plugins;
  /**
   * Builds a regex with the case sensativility of the current language
   *
   * @param {RegExp | string} value
   * @param {boolean} [global]
   */
  function langRe(value, global) {
    return new RegExp(source(value), 'm' + (language.case_insensitive ? 'i' : '') + (global ? 'g' : ''));
  }

  /**
    Stores multiple regular expressions and allows you to quickly search for
    them all in a string simultaneously - returning the first match.  It does
    this by creating a huge (a|b|c) regex - each individual item wrapped with ()
    and joined by `|` - using match groups to track position.  When a match is
    found checking which position in the array has content allows us to figure
    out which of the original regexes / match groups triggered the match.
     The match object itself (the result of `Regex.exec`) is returned but also
    enhanced by merging in any meta-data that was registered with the regex.
    This is how we keep track of which mode matched, and what type of rule
    (`illegal`, `begin`, end, etc).
  */
  var MultiRegex = /*#__PURE__*/function () {
    "use strict";

    function MultiRegex() {
      _classCallCheck(this, MultiRegex);
      this.matchIndexes = {};
      // @ts-ignore
      this.regexes = [];
      this.matchAt = 1;
      this.position = 0;
    }

    // @ts-ignore
    _createClass(MultiRegex, [{
      key: "addRule",
      value: function addRule(re, opts) {
        opts.position = this.position++;
        // @ts-ignore
        this.matchIndexes[this.matchAt] = opts;
        this.regexes.push([opts, re]);
        this.matchAt += countMatchGroups(re) + 1;
      }
    }, {
      key: "compile",
      value: function compile() {
        if (this.regexes.length === 0) {
          // avoids the need to check length every time exec is called
          // @ts-ignore
          this.exec = function () {
            return null;
          };
        }
        var terminators = this.regexes.map(function (el) {
          return el[1];
        });
        this.matcherRe = langRe(join(terminators), true);
        this.lastIndex = 0;
      }

      /** @param {string} s */
    }, {
      key: "exec",
      value: function exec(s) {
        this.matcherRe.lastIndex = this.lastIndex;
        var match = this.matcherRe.exec(s);
        if (!match) {
          return null;
        }

        // eslint-disable-next-line no-undefined
        var i = match.findIndex(function (el, i) {
          return i > 0 && el !== undefined;
        });
        // @ts-ignore
        var matchData = this.matchIndexes[i];
        // trim off any earlier non-relevant match groups (ie, the other regex
        // match groups that make up the multi-matcher)
        match.splice(0, i);
        return Object.assign(match, matchData);
      }
    }]);
    return MultiRegex;
  }(); /*
         Created to solve the key deficiently with MultiRegex - there is no way to
         test for multiple matches at a single location.  Why would we need to do
         that?  In the future a more dynamic engine will allow certain matches to be
         ignored.  An example: if we matched say the 3rd regex in a large group but
         decided to ignore it - we'd need to started testing again at the 4th
         regex... but MultiRegex itself gives us no real way to do that.
          So what this class creates MultiRegexs on the fly for whatever search
         position they are needed.
          NOTE: These additional MultiRegex objects are created dynamically.  For most
         grammars most of the time we will never actually need anything more than the
         first MultiRegex - so this shouldn't have too much overhead.
          Say this is our search group, and we match regex3, but wish to ignore it.
            regex1 | regex2 | regex3 | regex4 | regex5    ' ie, startAt = 0
          What we need is a new MultiRegex that only includes the remaining
         possibilities:
            regex4 | regex5                               ' ie, startAt = 3
          This class wraps all that complexity up in a simple API... `startAt` decides
         where in the array of expressions to start doing the matching. It
         auto-increments, so if a match is found at position 2, then startAt will be
         set to 3.  If the end is reached startAt will return to 0.
          MOST of the time the parser will be setting startAt manually to 0.
       */
  var ResumableMultiRegex = /*#__PURE__*/function () {
    "use strict";

    function ResumableMultiRegex() {
      _classCallCheck(this, ResumableMultiRegex);
      // @ts-ignore
      this.rules = [];
      // @ts-ignore
      this.multiRegexes = [];
      this.count = 0;
      this.lastIndex = 0;
      this.regexIndex = 0;
    }

    // @ts-ignore
    _createClass(ResumableMultiRegex, [{
      key: "getMatcher",
      value: function getMatcher(index) {
        if (this.multiRegexes[index]) return this.multiRegexes[index];
        var matcher = new MultiRegex();
        this.rules.slice(index).forEach(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
            re = _ref3[0],
            opts = _ref3[1];
          return matcher.addRule(re, opts);
        });
        matcher.compile();
        this.multiRegexes[index] = matcher;
        return matcher;
      }
    }, {
      key: "resumingScanAtSamePosition",
      value: function resumingScanAtSamePosition() {
        return this.regexIndex !== 0;
      }
    }, {
      key: "considerAll",
      value: function considerAll() {
        this.regexIndex = 0;
      }

      // @ts-ignore
    }, {
      key: "addRule",
      value: function addRule(re, opts) {
        this.rules.push([re, opts]);
        if (opts.type === "begin") this.count++;
      }

      /** @param {string} s */
    }, {
      key: "exec",
      value: function exec(s) {
        var m = this.getMatcher(this.regexIndex);
        m.lastIndex = this.lastIndex;
        var result = m.exec(s);

        // The following is because we have no easy way to say "resume scanning at the
        // existing position but also skip the current rule ONLY". What happens is
        // all prior rules are also skipped which can result in matching the wrong
        // thing. Example of matching "booger":

        // our matcher is [string, "booger", number]
        //
        // ....booger....

        // if "booger" is ignored then we'd really need a regex to scan from the
        // SAME position for only: [string, number] but ignoring "booger" (if it
        // was the first match), a simple resume would scan ahead who knows how
        // far looking only for "number", ignoring potential string matches (or
        // future "booger" matches that might be valid.)

        // So what we do: We execute two matchers, one resuming at the same
        // position, but the second full matcher starting at the position after:

        //     /--- resume first regex match here (for [number])
        //     |/---- full match here for [string, "booger", number]
        //     vv
        // ....booger....

        // Which ever results in a match first is then used. So this 3-4 step
        // process essentially allows us to say "match at this position, excluding
        // a prior rule that was ignored".
        //
        // 1. Match "booger" first, ignore. Also proves that [string] does non match.
        // 2. Resume matching for [number]
        // 3. Match at index + 1 for [string, "booger", number]
        // 4. If #2 and #3 result in matches, which came first?
        if (this.resumingScanAtSamePosition()) {
          if (result && result.index === this.lastIndex) ;else {
            // use the second matcher result
            var m2 = this.getMatcher(0);
            m2.lastIndex = this.lastIndex + 1;
            result = m2.exec(s);
          }
        }
        if (result) {
          this.regexIndex += result.position + 1;
          if (this.regexIndex === this.count) {
            // wrap-around to considering all matches again
            this.considerAll();
          }
        }
        return result;
      }
    }]);
    return ResumableMultiRegex;
  }(); /**
        * Given a mode, builds a huge ResumableMultiRegex that can be used to walk
        * the content and find matches.
        *
        * @param {CompiledMode} mode
        * @returns {ResumableMultiRegex}
        */
  function buildModeRegex(mode) {
    var mm = new ResumableMultiRegex();
    mode.contains.forEach(function (term) {
      return mm.addRule(term.begin, {
        rule: term,
        type: "begin"
      });
    });
    if (mode.terminatorEnd) {
      mm.addRule(mode.terminatorEnd, {
        type: "end"
      });
    }
    if (mode.illegal) {
      mm.addRule(mode.illegal, {
        type: "illegal"
      });
    }
    return mm;
  }

  /** skip vs abort vs ignore
   *
   * @skip   - The mode is still entered and exited normally (and contains rules apply),
   *           but all content is held and added to the parent buffer rather than being
   *           output when the mode ends.  Mostly used with `sublanguage` to build up
   *           a single large buffer than can be parsed by sublanguage.
   *
   *             - The mode begin ands ends normally.
   *             - Content matched is added to the parent mode buffer.
   *             - The parser cursor is moved forward normally.
   *
   * @abort  - A hack placeholder until we have ignore.  Aborts the mode (as if it
   *           never matched) but DOES NOT continue to match subsequent `contains`
   *           modes.  Abort is bad/suboptimal because it can result in modes
   *           farther down not getting applied because an earlier rule eats the
   *           content but then aborts.
   *
   *             - The mode does not begin.
   *             - Content matched by `begin` is added to the mode buffer.
   *             - The parser cursor is moved forward accordingly.
   *
   * @ignore - Ignores the mode (as if it never matched) and continues to match any
   *           subsequent `contains` modes.  Ignore isn't technically possible with
   *           the current parser implementation.
   *
   *             - The mode does not begin.
   *             - Content matched by `begin` is ignored.
   *             - The parser cursor is not moved forward.
   */

  /**
   * Compiles an individual mode
   *
   * This can raise an error if the mode contains certain detectable known logic
   * issues.
   * @param {Mode} mode
   * @param {CompiledMode | null} [parent]
   * @returns {CompiledMode | never}
   */
  function compileMode(mode, parent) {
    var _ref4;
    var cmode = mode;
    if (mode.isCompiled) return cmode;
    [
    // do this early so compiler extensions generally don't have to worry about
    // the distinction between match/begin
    compileMatch].forEach(function (ext) {
      return ext(mode, parent);
    });
    language.compilerExtensions.forEach(function (ext) {
      return ext(mode, parent);
    });

    // __beforeBegin is considered private API, internal use only
    mode.__beforeBegin = null;
    [beginKeywords,
    // do this later so compiler extensions that come earlier have access to the
    // raw array if they wanted to perhaps manipulate it, etc.
    compileIllegal,
    // default to 1 relevance if not specified
    compileRelevance].forEach(function (ext) {
      return ext(mode, parent);
    });
    mode.isCompiled = true;
    var keywordPattern = null;
    if (_typeof(mode.keywords) === "object") {
      keywordPattern = mode.keywords.$pattern;
      delete mode.keywords.$pattern;
    }
    if (mode.keywords) {
      mode.keywords = compileKeywords(mode.keywords, language.case_insensitive);
    }

    // both are not allowed
    if (mode.lexemes && keywordPattern) {
      throw new Error("ERR: Prefer `keywords.$pattern` to `mode.lexemes`, BOTH are not allowed. (see mode reference) ");
    }

    // `mode.lexemes` was the old standard before we added and now recommend
    // using `keywords.$pattern` to pass the keyword pattern
    keywordPattern = keywordPattern || mode.lexemes || /\w+/;
    cmode.keywordPatternRe = langRe(keywordPattern, true);
    if (parent) {
      if (!mode.begin) mode.begin = /\B|\b/;
      cmode.beginRe = langRe(mode.begin);
      if (mode.endSameAsBegin) mode.end = mode.begin;
      if (!mode.end && !mode.endsWithParent) mode.end = /\B|\b/;
      if (mode.end) cmode.endRe = langRe(mode.end);
      cmode.terminatorEnd = source(mode.end) || '';
      if (mode.endsWithParent && parent.terminatorEnd) {
        cmode.terminatorEnd += (mode.end ? '|' : '') + parent.terminatorEnd;
      }
    }
    if (mode.illegal) cmode.illegalRe = langRe(mode.illegal);
    if (!mode.contains) mode.contains = [];
    mode.contains = (_ref4 = []).concat.apply(_ref4, _toConsumableArray(mode.contains.map(function (c) {
      return expandOrCloneMode(c === 'self' ? mode : c);
    })));
    mode.contains.forEach(function (c) {
      compileMode(c, cmode);
    });
    if (mode.starts) {
      compileMode(mode.starts, parent);
    }
    cmode.matcher = buildModeRegex(cmode);
    return cmode;
  }
  if (!language.compilerExtensions) language.compilerExtensions = [];

  // self is not valid at the top-level
  if (language.contains && language.contains.includes('self')) {
    throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
  }

  // we need a null object, which inherit will guarantee
  language.classNameAliases = inherit(language.classNameAliases || {});
  return compileMode(language);
}

/**
 * Determines if a mode has a dependency on it's parent or not
 *
 * If a mode does have a parent dependency then often we need to clone it if
 * it's used in multiple places so that each copy points to the correct parent,
 * where-as modes without a parent can often safely be re-used at the bottom of
 * a mode chain.
 *
 * @param {Mode | null} mode
 * @returns {boolean} - is there a dependency on the parent?
 * */
function dependencyOnParent(mode) {
  if (!mode) return false;
  return mode.endsWithParent || dependencyOnParent(mode.starts);
}

/**
 * Expands a mode or clones it if necessary
 *
 * This is necessary for modes with parental dependenceis (see notes on
 * `dependencyOnParent`) and for nodes that have `variants` - which must then be
 * exploded into their own individual modes at compile time.
 *
 * @param {Mode} mode
 * @returns {Mode | Mode[]}
 * */
function expandOrCloneMode(mode) {
  if (mode.variants && !mode.cachedVariants) {
    mode.cachedVariants = mode.variants.map(function (variant) {
      return inherit(mode, {
        variants: null
      }, variant);
    });
  }

  // EXPAND
  // if we have variants then essentially "replace" the mode with the variants
  // this happens in compileMode, where this function is called from
  if (mode.cachedVariants) {
    return mode.cachedVariants;
  }

  // CLONE
  // if we have dependencies on parents then we need a unique
  // instance of ourselves, so we can be reused with many
  // different parents without issue
  if (dependencyOnParent(mode)) {
    return inherit(mode, {
      starts: mode.starts ? inherit(mode.starts) : null
    });
  }
  if (Object.isFrozen(mode)) {
    return inherit(mode);
  }

  // no special dependency issues, just return ourselves
  return mode;
}
var version = "10.7.3";

// @ts-nocheck

function hasValueOrEmptyAttribute(value) {
  return Boolean(value || value === "");
}
function BuildVuePlugin(hljs) {
  var Component = {
    props: ["language", "code", "autodetect"],
    data: function data() {
      return {
        detectedLanguage: "",
        unknownLanguage: false
      };
    },
    computed: {
      className: function className() {
        if (this.unknownLanguage) return "";
        return "hljs " + this.detectedLanguage;
      },
      highlighted: function highlighted() {
        // no idea what language to use, return raw code
        if (!this.autoDetect && !hljs.getLanguage(this.language)) {
          console.warn("The language \"".concat(this.language, "\" you specified could not be found."));
          this.unknownLanguage = true;
          return escapeHTML(this.code);
        }
        var result = {};
        if (this.autoDetect) {
          result = hljs.highlightAuto(this.code);
          this.detectedLanguage = result.language;
        } else {
          result = hljs.highlight(this.language, this.code, this.ignoreIllegals);
          this.detectedLanguage = this.language;
        }
        return result.value;
      },
      autoDetect: function autoDetect() {
        return !this.language || hasValueOrEmptyAttribute(this.autodetect);
      },
      ignoreIllegals: function ignoreIllegals() {
        return true;
      }
    },
    // this avoids needing to use a whole Vue compilation pipeline just
    // to build Highlight.js
    render: function render(createElement) {
      return createElement("pre", {}, [createElement("code", {
        class: this.className,
        domProps: {
          innerHTML: this.highlighted
        }
      })]);
    } // template: `<pre><code :class="className" v-html="highlighted"></code></pre>`
  };
  var VuePlugin = {
    install: function install(Vue) {
      Vue.component('highlightjs', Component);
    }
  };
  return {
    Component: Component,
    VuePlugin: VuePlugin
  };
}

/* plugin itself */

/** @type {HLJSPlugin} */
var mergeHTMLPlugin = {
  "after:highlightElement": function afterHighlightElement(_ref5) {
    var el = _ref5.el,
      result = _ref5.result,
      text = _ref5.text;
    var originalStream = nodeStream(el);
    if (!originalStream.length) return;
    var resultNode = document.createElement('div');
    resultNode.innerHTML = result.value;
    result.value = mergeStreams(originalStream, nodeStream(resultNode), text);
  }
};

/* Stream merging support functions */

/**
 * @typedef Event
 * @property {'start'|'stop'} event
 * @property {number} offset
 * @property {Node} node
 */

/**
 * @param {Node} node
 */
function tag(node) {
  return node.nodeName.toLowerCase();
}

/**
 * @param {Node} node
 */
function nodeStream(node) {
  /** @type Event[] */
  var result = [];
  (function _nodeStream(node, offset) {
    for (var child = node.firstChild; child; child = child.nextSibling) {
      if (child.nodeType === 3) {
        offset += child.nodeValue.length;
      } else if (child.nodeType === 1) {
        result.push({
          event: 'start',
          offset: offset,
          node: child
        });
        offset = _nodeStream(child, offset);
        // Prevent void elements from having an end tag that would actually
        // double them in the output. There are more void elements in HTML
        // but we list only those realistically expected in code display.
        if (!tag(child).match(/br|hr|img|input/)) {
          result.push({
            event: 'stop',
            offset: offset,
            node: child
          });
        }
      }
    }
    return offset;
  })(node, 0);
  return result;
}

/**
 * @param {any} original - the original stream
 * @param {any} highlighted - stream of the highlighted source
 * @param {string} value - the original source itself
 */
function mergeStreams(original, highlighted, value) {
  var processed = 0;
  var result = '';
  var nodeStack = [];
  function selectStream() {
    if (!original.length || !highlighted.length) {
      return original.length ? original : highlighted;
    }
    if (original[0].offset !== highlighted[0].offset) {
      return original[0].offset < highlighted[0].offset ? original : highlighted;
    }

    /*
    To avoid starting the stream just before it should stop the order is
    ensured that original always starts first and closes last:
     if (event1 == 'start' && event2 == 'start')
      return original;
    if (event1 == 'start' && event2 == 'stop')
      return highlighted;
    if (event1 == 'stop' && event2 == 'start')
      return original;
    if (event1 == 'stop' && event2 == 'stop')
      return highlighted;
     ... which is collapsed to:
    */
    return highlighted[0].event === 'start' ? original : highlighted;
  }

  /**
   * @param {Node} node
   */
  function open(node) {
    /** @param {Attr} attr */
    function attributeString(attr) {
      return ' ' + attr.nodeName + '="' + escapeHTML(attr.value) + '"';
    }
    // @ts-ignore
    result += '<' + tag(node) + [].map.call(node.attributes, attributeString).join('') + '>';
  }

  /**
   * @param {Node} node
   */
  function close(node) {
    result += '</' + tag(node) + '>';
  }

  /**
   * @param {Event} event
   */
  function render(event) {
    (event.event === 'start' ? open : close)(event.node);
  }
  while (original.length || highlighted.length) {
    var stream = selectStream();
    result += escapeHTML(value.substring(processed, stream[0].offset));
    processed = stream[0].offset;
    if (stream === original) {
      /*
      On any opening or closing tag of the original markup we first close
      the entire highlighted node stack, then render the original tag along
      with all the following original tags at the same offset and then
      reopen all the tags on the highlighted stack.
      */
      nodeStack.reverse().forEach(close);
      do {
        render(stream.splice(0, 1)[0]);
        stream = selectStream();
      } while (stream === original && stream.length && stream[0].offset === processed);
      nodeStack.reverse().forEach(open);
    } else {
      if (stream[0].event === 'start') {
        nodeStack.push(stream[0].node);
      } else {
        nodeStack.pop();
      }
      render(stream.splice(0, 1)[0]);
    }
  }
  return result + escapeHTML(value.substr(processed));
}

/*

For the reasoning behind this please see:
https://github.com/highlightjs/highlight.js/issues/2880#issuecomment-747275419

*/

/**
 * @type {Record<string, boolean>}
 */
var seenDeprecations = {};

/**
 * @param {string} message
 */
var error = function error(message) {
  console.error(message);
};

/**
 * @param {string} message
 * @param {any} args
 */
var warn = function warn(message) {
  var _console;
  for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key5 = 1; _key5 < _len4; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }
  (_console = console).log.apply(_console, ["WARN: ".concat(message)].concat(args));
};

/**
 * @param {string} version
 * @param {string} message
 */
var deprecated = function deprecated(version, message) {
  if (seenDeprecations["".concat(version, "/").concat(message)]) return;
  console.log("Deprecated as of ".concat(version, ". ").concat(message));
  seenDeprecations["".concat(version, "/").concat(message)] = true;
};

/*
Syntax highlighting with language autodetection.
https://highlightjs.org/
*/

var escape$1 = escapeHTML;
var inherit$1 = inherit;
var NO_MATCH = Symbol("nomatch");

/**
 * @param {any} hljs - object that is extended (legacy)
 * @returns {HLJSApi}
 */
var HLJS = function HLJS(hljs) {
  // Global internal variables used within the highlight.js library.
  /** @type {Record<string, Language>} */
  var languages = Object.create(null);
  /** @type {Record<string, string>} */
  var aliases = Object.create(null);
  /** @type {HLJSPlugin[]} */
  var plugins = [];

  // safe/production mode - swallows more errors, tries to keep running
  // even if a single syntax or parse hits a fatal error
  var SAFE_MODE = true;
  var fixMarkupRe = /(^(<[^>]+>|\t|)+|\n)/gm;
  var LANGUAGE_NOT_FOUND = "Could not find the language '{}', did you forget to load/include a language module?";
  /** @type {Language} */
  var PLAINTEXT_LANGUAGE = {
    disableAutodetect: true,
    name: 'Plain text',
    contains: []
  };

  // Global options used when within external APIs. This is modified when
  // calling the `hljs.configure` function.
  /** @type HLJSOptions */
  var options = {
    noHighlightRe: /^(no-?highlight)$/i,
    languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
    classPrefix: 'hljs-',
    tabReplace: null,
    useBR: false,
    languages: null,
    // beta configuration options, subject to change, welcome to discuss
    // https://github.com/highlightjs/highlight.js/issues/1086
    __emitter: TokenTreeEmitter
  };

  /* Utility functions */

  /**
   * Tests a language name to see if highlighting should be skipped
   * @param {string} languageName
   */
  function shouldNotHighlight(languageName) {
    return options.noHighlightRe.test(languageName);
  }

  /**
   * @param {HighlightedHTMLElement} block - the HTML element to determine language for
   */
  function blockLanguage(block) {
    var classes = block.className + ' ';
    classes += block.parentNode ? block.parentNode.className : '';

    // language-* takes precedence over non-prefixed class names.
    var match = options.languageDetectRe.exec(classes);
    if (match) {
      var language = getLanguage(match[1]);
      if (!language) {
        warn(LANGUAGE_NOT_FOUND.replace("{}", match[1]));
        warn("Falling back to no-highlight mode for this block.", block);
      }
      return language ? match[1] : 'no-highlight';
    }
    return classes.split(/\s+/).find(function (_class) {
      return shouldNotHighlight(_class) || getLanguage(_class);
    });
  }

  /**
   * Core highlighting function.
   *
   * OLD API
   * highlight(lang, code, ignoreIllegals, continuation)
   *
   * NEW API
   * highlight(code, {lang, ignoreIllegals})
   *
   * @param {string} codeOrlanguageName - the language to use for highlighting
   * @param {string | HighlightOptions} optionsOrCode - the code to highlight
   * @param {boolean} [ignoreIllegals] - whether to ignore illegal matches, default is to bail
   * @param {CompiledMode} [continuation] - current continuation mode, if any
   *
   * @returns {HighlightResult} Result - an object that represents the result
   * @property {string} language - the language name
   * @property {number} relevance - the relevance score
   * @property {string} value - the highlighted HTML code
   * @property {string} code - the original raw code
   * @property {CompiledMode} top - top of the current mode stack
   * @property {boolean} illegal - indicates whether any illegal matches were found
  */
  function highlight(codeOrlanguageName, optionsOrCode, ignoreIllegals, continuation) {
    var code = "";
    var languageName = "";
    if (_typeof(optionsOrCode) === "object") {
      code = codeOrlanguageName;
      ignoreIllegals = optionsOrCode.ignoreIllegals;
      languageName = optionsOrCode.language;
      // continuation not supported at all via the new API
      // eslint-disable-next-line no-undefined
      continuation = undefined;
    } else {
      // old API
      deprecated("10.7.0", "highlight(lang, code, ...args) has been deprecated.");
      deprecated("10.7.0", "Please use highlight(code, options) instead.\nhttps://github.com/highlightjs/highlight.js/issues/2277");
      languageName = codeOrlanguageName;
      code = optionsOrCode;
    }

    /** @type {BeforeHighlightContext} */
    var context = {
      code: code,
      language: languageName
    };
    // the plugin can change the desired language or the code to be highlighted
    // just be changing the object it was passed
    fire("before:highlight", context);

    // a before plugin can usurp the result completely by providing it's own
    // in which case we don't even need to call highlight
    var result = context.result ? context.result : _highlight(context.language, context.code, ignoreIllegals, continuation);
    result.code = context.code;
    // the plugin can change anything in result to suite it
    fire("after:highlight", result);
    return result;
  }

  /**
   * private highlight that's used internally and does not fire callbacks
   *
   * @param {string} languageName - the language to use for highlighting
   * @param {string} codeToHighlight - the code to highlight
   * @param {boolean?} [ignoreIllegals] - whether to ignore illegal matches, default is to bail
   * @param {CompiledMode?} [continuation] - current continuation mode, if any
   * @returns {HighlightResult} - result of the highlight operation
  */
  function _highlight(languageName, codeToHighlight, ignoreIllegals, continuation) {
    /**
     * Return keyword data if a match is a keyword
     * @param {CompiledMode} mode - current mode
     * @param {RegExpMatchArray} match - regexp match data
     * @returns {KeywordData | false}
     */
    function keywordData(mode, match) {
      var matchText = language.case_insensitive ? match[0].toLowerCase() : match[0];
      return Object.prototype.hasOwnProperty.call(mode.keywords, matchText) && mode.keywords[matchText];
    }
    function processKeywords() {
      if (!top.keywords) {
        emitter.addText(modeBuffer);
        return;
      }
      var lastIndex = 0;
      top.keywordPatternRe.lastIndex = 0;
      var match = top.keywordPatternRe.exec(modeBuffer);
      var buf = "";
      while (match) {
        buf += modeBuffer.substring(lastIndex, match.index);
        var data = keywordData(top, match);
        if (data) {
          var _data = _slicedToArray(data, 2),
            kind = _data[0],
            keywordRelevance = _data[1];
          emitter.addText(buf);
          buf = "";
          relevance += keywordRelevance;
          if (kind.startsWith("_")) {
            // _ implied for relevance only, do not highlight
            // by applying a class name
            buf += match[0];
          } else {
            var cssClass = language.classNameAliases[kind] || kind;
            emitter.addKeyword(match[0], cssClass);
          }
        } else {
          buf += match[0];
        }
        lastIndex = top.keywordPatternRe.lastIndex;
        match = top.keywordPatternRe.exec(modeBuffer);
      }
      buf += modeBuffer.substr(lastIndex);
      emitter.addText(buf);
    }
    function processSubLanguage() {
      if (modeBuffer === "") return;
      /** @type HighlightResult */
      var result = null;
      if (typeof top.subLanguage === 'string') {
        if (!languages[top.subLanguage]) {
          emitter.addText(modeBuffer);
          return;
        }
        result = _highlight(top.subLanguage, modeBuffer, true, continuations[top.subLanguage]);
        continuations[top.subLanguage] = result.top;
      } else {
        result = highlightAuto(modeBuffer, top.subLanguage.length ? top.subLanguage : null);
      }

      // Counting embedded language score towards the host language may be disabled
      // with zeroing the containing mode relevance. Use case in point is Markdown that
      // allows XML everywhere and makes every XML snippet to have a much larger Markdown
      // score.
      if (top.relevance > 0) {
        relevance += result.relevance;
      }
      emitter.addSublanguage(result.emitter, result.language);
    }
    function processBuffer() {
      if (top.subLanguage != null) {
        processSubLanguage();
      } else {
        processKeywords();
      }
      modeBuffer = '';
    }

    /**
     * @param {Mode} mode - new mode to start
     */
    function startNewMode(mode) {
      if (mode.className) {
        emitter.openNode(language.classNameAliases[mode.className] || mode.className);
      }
      top = Object.create(mode, {
        parent: {
          value: top
        }
      });
      return top;
    }

    /**
     * @param {CompiledMode } mode - the mode to potentially end
     * @param {RegExpMatchArray} match - the latest match
     * @param {string} matchPlusRemainder - match plus remainder of content
     * @returns {CompiledMode | void} - the next mode, or if void continue on in current mode
     */
    function endOfMode(mode, match, matchPlusRemainder) {
      var matched = startsWith(mode.endRe, matchPlusRemainder);
      if (matched) {
        if (mode["on:end"]) {
          var resp = new Response(mode);
          mode["on:end"](match, resp);
          if (resp.isMatchIgnored) matched = false;
        }
        if (matched) {
          while (mode.endsParent && mode.parent) {
            mode = mode.parent;
          }
          return mode;
        }
      }
      // even if on:end fires an `ignore` it's still possible
      // that we might trigger the end node because of a parent mode
      if (mode.endsWithParent) {
        return endOfMode(mode.parent, match, matchPlusRemainder);
      }
    }

    /**
     * Handle matching but then ignoring a sequence of text
     *
     * @param {string} lexeme - string containing full match text
     */
    function doIgnore(lexeme) {
      if (top.matcher.regexIndex === 0) {
        // no more regexs to potentially match here, so we move the cursor forward one
        // space
        modeBuffer += lexeme[0];
        return 1;
      } else {
        // no need to move the cursor, we still have additional regexes to try and
        // match at this very spot
        resumeScanAtSamePosition = true;
        return 0;
      }
    }

    /**
     * Handle the start of a new potential mode match
     *
     * @param {EnhancedMatch} match - the current match
     * @returns {number} how far to advance the parse cursor
     */
    function doBeginMatch(match) {
      var lexeme = match[0];
      var newMode = match.rule;
      var resp = new Response(newMode);
      // first internal before callbacks, then the public ones
      var beforeCallbacks = [newMode.__beforeBegin, newMode["on:begin"]];
      for (var _i2 = 0, _beforeCallbacks = beforeCallbacks; _i2 < _beforeCallbacks.length; _i2++) {
        var cb = _beforeCallbacks[_i2];
        if (!cb) continue;
        cb(match, resp);
        if (resp.isMatchIgnored) return doIgnore(lexeme);
      }
      if (newMode && newMode.endSameAsBegin) {
        newMode.endRe = escape(lexeme);
      }
      if (newMode.skip) {
        modeBuffer += lexeme;
      } else {
        if (newMode.excludeBegin) {
          modeBuffer += lexeme;
        }
        processBuffer();
        if (!newMode.returnBegin && !newMode.excludeBegin) {
          modeBuffer = lexeme;
        }
      }
      startNewMode(newMode);
      // if (mode["after:begin"]) {
      //   let resp = new Response(mode);
      //   mode["after:begin"](match, resp);
      // }
      return newMode.returnBegin ? 0 : lexeme.length;
    }

    /**
     * Handle the potential end of mode
     *
     * @param {RegExpMatchArray} match - the current match
     */
    function doEndMatch(match) {
      var lexeme = match[0];
      var matchPlusRemainder = codeToHighlight.substr(match.index);
      var endMode = endOfMode(top, match, matchPlusRemainder);
      if (!endMode) {
        return NO_MATCH;
      }
      var origin = top;
      if (origin.skip) {
        modeBuffer += lexeme;
      } else {
        if (!(origin.returnEnd || origin.excludeEnd)) {
          modeBuffer += lexeme;
        }
        processBuffer();
        if (origin.excludeEnd) {
          modeBuffer = lexeme;
        }
      }
      do {
        if (top.className) {
          emitter.closeNode();
        }
        if (!top.skip && !top.subLanguage) {
          relevance += top.relevance;
        }
        top = top.parent;
      } while (top !== endMode.parent);
      if (endMode.starts) {
        if (endMode.endSameAsBegin) {
          endMode.starts.endRe = endMode.endRe;
        }
        startNewMode(endMode.starts);
      }
      return origin.returnEnd ? 0 : lexeme.length;
    }
    function processContinuations() {
      var list = [];
      for (var current = top; current !== language; current = current.parent) {
        if (current.className) {
          list.unshift(current.className);
        }
      }
      list.forEach(function (item) {
        return emitter.openNode(item);
      });
    }

    /** @type {{type?: MatchType, index?: number, rule?: Mode}}} */
    var lastMatch = {};

    /**
     *  Process an individual match
     *
     * @param {string} textBeforeMatch - text preceeding the match (since the last match)
     * @param {EnhancedMatch} [match] - the match itself
     */
    function processLexeme(textBeforeMatch, match) {
      var lexeme = match && match[0];

      // add non-matched text to the current mode buffer
      modeBuffer += textBeforeMatch;
      if (lexeme == null) {
        processBuffer();
        return 0;
      }

      // we've found a 0 width match and we're stuck, so we need to advance
      // this happens when we have badly behaved rules that have optional matchers to the degree that
      // sometimes they can end up matching nothing at all
      // Ref: https://github.com/highlightjs/highlight.js/issues/2140
      if (lastMatch.type === "begin" && match.type === "end" && lastMatch.index === match.index && lexeme === "") {
        // spit the "skipped" character that our regex choked on back into the output sequence
        modeBuffer += codeToHighlight.slice(match.index, match.index + 1);
        if (!SAFE_MODE) {
          /** @type {AnnotatedError} */
          var err = new Error('0 width match regex');
          err.languageName = languageName;
          err.badRule = lastMatch.rule;
          throw err;
        }
        return 1;
      }
      lastMatch = match;
      if (match.type === "begin") {
        return doBeginMatch(match);
      } else if (match.type === "illegal" && !ignoreIllegals) {
        // illegal match, we do not continue processing
        /** @type {AnnotatedError} */
        var _err = new Error('Illegal lexeme "' + lexeme + '" for mode "' + (top.className || '<unnamed>') + '"');
        _err.mode = top;
        throw _err;
      } else if (match.type === "end") {
        var processed = doEndMatch(match);
        if (processed !== NO_MATCH) {
          return processed;
        }
      }

      // edge case for when illegal matches $ (end of line) which is technically
      // a 0 width match but not a begin/end match so it's not caught by the
      // first handler (when ignoreIllegals is true)
      if (match.type === "illegal" && lexeme === "") {
        // advance so we aren't stuck in an infinite loop
        return 1;
      }

      // infinite loops are BAD, this is a last ditch catch all. if we have a
      // decent number of iterations yet our index (cursor position in our
      // parsing) still 3x behind our index then something is very wrong
      // so we bail
      if (iterations > 100000 && iterations > match.index * 3) {
        var _err2 = new Error('potential infinite loop, way more iterations than matches');
        throw _err2;
      }

      /*
      Why might be find ourselves here?  Only one occasion now.  An end match that was
      triggered but could not be completed.  When might this happen?  When an `endSameasBegin`
      rule sets the end rule to a specific match.  Since the overall mode termination rule that's
      being used to scan the text isn't recompiled that means that any match that LOOKS like
      the end (but is not, because it is not an exact match to the beginning) will
      end up here.  A definite end match, but when `doEndMatch` tries to "reapply"
      the end rule and fails to match, we wind up here, and just silently ignore the end.
       This causes no real harm other than stopping a few times too many.
      */

      modeBuffer += lexeme;
      return lexeme.length;
    }
    var language = getLanguage(languageName);
    if (!language) {
      error(LANGUAGE_NOT_FOUND.replace("{}", languageName));
      throw new Error('Unknown language: "' + languageName + '"');
    }
    var md = compileLanguage(language, {
      plugins: plugins
    });
    var result = '';
    /** @type {CompiledMode} */
    var top = continuation || md;
    /** @type Record<string,CompiledMode> */
    var continuations = {}; // keep continuations for sub-languages
    var emitter = new options.__emitter(options);
    processContinuations();
    var modeBuffer = '';
    var relevance = 0;
    var index = 0;
    var iterations = 0;
    var resumeScanAtSamePosition = false;
    try {
      top.matcher.considerAll();
      for (;;) {
        iterations++;
        if (resumeScanAtSamePosition) {
          // only regexes not matched previously will now be
          // considered for a potential match
          resumeScanAtSamePosition = false;
        } else {
          top.matcher.considerAll();
        }
        top.matcher.lastIndex = index;
        var match = top.matcher.exec(codeToHighlight);
        // console.log("match", match[0], match.rule && match.rule.begin)

        if (!match) break;
        var beforeMatch = codeToHighlight.substring(index, match.index);
        var processedCount = processLexeme(beforeMatch, match);
        index = match.index + processedCount;
      }
      processLexeme(codeToHighlight.substr(index));
      emitter.closeAllNodes();
      emitter.finalize();
      result = emitter.toHTML();
      return {
        // avoid possible breakage with v10 clients expecting
        // this to always be an integer
        relevance: Math.floor(relevance),
        value: result,
        language: languageName,
        illegal: false,
        emitter: emitter,
        top: top
      };
    } catch (err) {
      if (err.message && err.message.includes('Illegal')) {
        return {
          illegal: true,
          illegalBy: {
            msg: err.message,
            context: codeToHighlight.slice(index - 100, index + 100),
            mode: err.mode
          },
          sofar: result,
          relevance: 0,
          value: escape$1(codeToHighlight),
          emitter: emitter
        };
      } else if (SAFE_MODE) {
        return {
          illegal: false,
          relevance: 0,
          value: escape$1(codeToHighlight),
          emitter: emitter,
          language: languageName,
          top: top,
          errorRaised: err
        };
      } else {
        throw err;
      }
    }
  }

  /**
   * returns a valid highlight result, without actually doing any actual work,
   * auto highlight starts with this and it's possible for small snippets that
   * auto-detection may not find a better match
   * @param {string} code
   * @returns {HighlightResult}
   */
  function justTextHighlightResult(code) {
    var result = {
      relevance: 0,
      emitter: new options.__emitter(options),
      value: escape$1(code),
      illegal: false,
      top: PLAINTEXT_LANGUAGE
    };
    result.emitter.addText(code);
    return result;
  }

  /**
  Highlighting with language detection. Accepts a string with the code to
  highlight. Returns an object with the following properties:
   - language (detected language)
  - relevance (int)
  - value (an HTML string with highlighting markup)
  - second_best (object with the same structure for second-best heuristically
    detected language, may be absent)
     @param {string} code
    @param {Array<string>} [languageSubset]
    @returns {AutoHighlightResult}
  */
  function highlightAuto(code, languageSubset) {
    languageSubset = languageSubset || options.languages || Object.keys(languages);
    var plaintext = justTextHighlightResult(code);
    var results = languageSubset.filter(getLanguage).filter(autoDetection).map(function (name) {
      return _highlight(name, code, false);
    });
    results.unshift(plaintext); // plaintext is always an option

    var sorted = results.sort(function (a, b) {
      // sort base on relevance
      if (a.relevance !== b.relevance) return b.relevance - a.relevance;

      // always award the tie to the base language
      // ie if C++ and Arduino are tied, it's more likely to be C++
      if (a.language && b.language) {
        if (getLanguage(a.language).supersetOf === b.language) {
          return 1;
        } else if (getLanguage(b.language).supersetOf === a.language) {
          return -1;
        }
      }

      // otherwise say they are equal, which has the effect of sorting on
      // relevance while preserving the original ordering - which is how ties
      // have historically been settled, ie the language that comes first always
      // wins in the case of a tie
      return 0;
    });
    var _sorted = _slicedToArray(sorted, 2),
      best = _sorted[0],
      secondBest = _sorted[1];

    /** @type {AutoHighlightResult} */
    var result = best;
    result.second_best = secondBest;
    return result;
  }

  /**
  Post-processing of the highlighted markup:
   - replace TABs with something more useful
  - replace real line-breaks with '<br>' for non-pre containers
     @param {string} html
    @returns {string}
  */
  function fixMarkup(html) {
    if (!(options.tabReplace || options.useBR)) {
      return html;
    }
    return html.replace(fixMarkupRe, function (match) {
      if (match === '\n') {
        return options.useBR ? '<br>' : match;
      } else if (options.tabReplace) {
        return match.replace(/\t/g, options.tabReplace);
      }
      return match;
    });
  }

  /**
   * Builds new class name for block given the language name
   *
   * @param {HTMLElement} element
   * @param {string} [currentLang]
   * @param {string} [resultLang]
   */
  function updateClassName(element, currentLang, resultLang) {
    var language = currentLang ? aliases[currentLang] : resultLang;
    element.classList.add("hljs");
    if (language) element.classList.add(language);
  }

  /** @type {HLJSPlugin} */
  var brPlugin = {
    "before:highlightElement": function beforeHighlightElement(_ref6) {
      var el = _ref6.el;
      if (options.useBR) {
        el.innerHTML = el.innerHTML.replace(/\n/g, '').replace(/<br[ /]*>/g, '\n');
      }
    },
    "after:highlightElement": function afterHighlightElement(_ref7) {
      var result = _ref7.result;
      if (options.useBR) {
        result.value = result.value.replace(/\n/g, "<br>");
      }
    }
  };
  var TAB_REPLACE_RE = /^(<[^>]+>|\t)+/gm;
  /** @type {HLJSPlugin} */
  var tabReplacePlugin = {
    "after:highlightElement": function afterHighlightElement(_ref8) {
      var result = _ref8.result;
      if (options.tabReplace) {
        result.value = result.value.replace(TAB_REPLACE_RE, function (m) {
          return m.replace(/\t/g, options.tabReplace);
        });
      }
    }
  };

  /**
   * Applies highlighting to a DOM node containing code. Accepts a DOM node and
   * two optional parameters for fixMarkup.
   *
   * @param {HighlightedHTMLElement} element - the HTML element to highlight
  */
  function highlightElement(element) {
    /** @type HTMLElement */
    var node = null;
    var language = blockLanguage(element);
    if (shouldNotHighlight(language)) return;

    // support for v10 API
    fire("before:highlightElement", {
      el: element,
      language: language
    });
    node = element;
    var text = node.textContent;
    var result = language ? highlight(text, {
      language: language,
      ignoreIllegals: true
    }) : highlightAuto(text);

    // support for v10 API
    fire("after:highlightElement", {
      el: element,
      result: result,
      text: text
    });
    element.innerHTML = result.value;
    updateClassName(element, language, result.language);
    element.result = {
      language: result.language,
      // TODO: remove with version 11.0
      re: result.relevance,
      relavance: result.relevance
    };
    if (result.second_best) {
      element.second_best = {
        language: result.second_best.language,
        // TODO: remove with version 11.0
        re: result.second_best.relevance,
        relavance: result.second_best.relevance
      };
    }
  }

  /**
   * Updates highlight.js global options with the passed options
   *
   * @param {Partial<HLJSOptions>} userOptions
   */
  function configure(userOptions) {
    if (userOptions.useBR) {
      deprecated("10.3.0", "'useBR' will be removed entirely in v11.0");
      deprecated("10.3.0", "Please see https://github.com/highlightjs/highlight.js/issues/2559");
    }
    options = inherit$1(options, userOptions);
  }

  /**
   * Highlights to all <pre><code> blocks on a page
   *
   * @type {Function & {called?: boolean}}
   */
  // TODO: remove v12, deprecated
  var initHighlighting = function initHighlighting() {
    if (initHighlighting.called) return;
    initHighlighting.called = true;
    deprecated("10.6.0", "initHighlighting() is deprecated.  Use highlightAll() instead.");
    var blocks = document.querySelectorAll('pre code');
    blocks.forEach(highlightElement);
  };

  // Higlights all when DOMContentLoaded fires
  // TODO: remove v12, deprecated
  function initHighlightingOnLoad() {
    deprecated("10.6.0", "initHighlightingOnLoad() is deprecated.  Use highlightAll() instead.");
    wantsHighlight = true;
  }
  var wantsHighlight = false;

  /**
   * auto-highlights all pre>code elements on the page
   */
  function highlightAll() {
    // if we are called too early in the loading process
    if (document.readyState === "loading") {
      wantsHighlight = true;
      return;
    }
    var blocks = document.querySelectorAll('pre code');
    blocks.forEach(highlightElement);
  }
  function boot() {
    // if a highlight was requested before DOM was loaded, do now
    if (wantsHighlight) highlightAll();
  }

  // make sure we are in the browser environment
  if (typeof window !== 'undefined' && window.addEventListener) {
    window.addEventListener('DOMContentLoaded', boot, false);
  }

  /**
   * Register a language grammar module
   *
   * @param {string} languageName
   * @param {LanguageFn} languageDefinition
   */
  function registerLanguage(languageName, languageDefinition) {
    var lang = null;
    try {
      lang = languageDefinition(hljs);
    } catch (error$1) {
      error("Language definition for '{}' could not be registered.".replace("{}", languageName));
      // hard or soft error
      if (!SAFE_MODE) {
        throw error$1;
      } else {
        error(error$1);
      }
      // languages that have serious errors are replaced with essentially a
      // "plaintext" stand-in so that the code blocks will still get normal
      // css classes applied to them - and one bad language won't break the
      // entire highlighter
      lang = PLAINTEXT_LANGUAGE;
    }
    // give it a temporary name if it doesn't have one in the meta-data
    if (!lang.name) lang.name = languageName;
    languages[languageName] = lang;
    lang.rawDefinition = languageDefinition.bind(null, hljs);
    if (lang.aliases) {
      registerAliases(lang.aliases, {
        languageName: languageName
      });
    }
  }

  /**
   * Remove a language grammar module
   *
   * @param {string} languageName
   */
  function unregisterLanguage(languageName) {
    delete languages[languageName];
    for (var _i3 = 0, _Object$keys = Object.keys(aliases); _i3 < _Object$keys.length; _i3++) {
      var alias = _Object$keys[_i3];
      if (aliases[alias] === languageName) {
        delete aliases[alias];
      }
    }
  }

  /**
   * @returns {string[]} List of language internal names
   */
  function listLanguages() {
    return Object.keys(languages);
  }

  /**
    intended usage: When one language truly requires another
     Unlike `getLanguage`, this will throw when the requested language
    is not available.
     @param {string} name - name of the language to fetch/require
    @returns {Language | never}
  */
  function requireLanguage(name) {
    deprecated("10.4.0", "requireLanguage will be removed entirely in v11.");
    deprecated("10.4.0", "Please see https://github.com/highlightjs/highlight.js/pull/2844");
    var lang = getLanguage(name);
    if (lang) {
      return lang;
    }
    var err = new Error('The \'{}\' language is required, but not loaded.'.replace('{}', name));
    throw err;
  }

  /**
   * @param {string} name - name of the language to retrieve
   * @returns {Language | undefined}
   */
  function getLanguage(name) {
    name = (name || '').toLowerCase();
    return languages[name] || languages[aliases[name]];
  }

  /**
   *
   * @param {string|string[]} aliasList - single alias or list of aliases
   * @param {{languageName: string}} opts
   */
  function registerAliases(aliasList, _ref9) {
    var languageName = _ref9.languageName;
    if (typeof aliasList === 'string') {
      aliasList = [aliasList];
    }
    aliasList.forEach(function (alias) {
      aliases[alias.toLowerCase()] = languageName;
    });
  }

  /**
   * Determines if a given language has auto-detection enabled
   * @param {string} name - name of the language
   */
  function autoDetection(name) {
    var lang = getLanguage(name);
    return lang && !lang.disableAutodetect;
  }

  /**
   * Upgrades the old highlightBlock plugins to the new
   * highlightElement API
   * @param {HLJSPlugin} plugin
   */
  function upgradePluginAPI(plugin) {
    // TODO: remove with v12
    if (plugin["before:highlightBlock"] && !plugin["before:highlightElement"]) {
      plugin["before:highlightElement"] = function (data) {
        plugin["before:highlightBlock"](Object.assign({
          block: data.el
        }, data));
      };
    }
    if (plugin["after:highlightBlock"] && !plugin["after:highlightElement"]) {
      plugin["after:highlightElement"] = function (data) {
        plugin["after:highlightBlock"](Object.assign({
          block: data.el
        }, data));
      };
    }
  }

  /**
   * @param {HLJSPlugin} plugin
   */
  function addPlugin(plugin) {
    upgradePluginAPI(plugin);
    plugins.push(plugin);
  }

  /**
   *
   * @param {PluginEvent} event
   * @param {any} args
   */
  function fire(event, args) {
    var cb = event;
    plugins.forEach(function (plugin) {
      if (plugin[cb]) {
        plugin[cb](args);
      }
    });
  }

  /**
  Note: fixMarkup is deprecated and will be removed entirely in v11
   @param {string} arg
  @returns {string}
  */
  function deprecateFixMarkup(arg) {
    deprecated("10.2.0", "fixMarkup will be removed entirely in v11.0");
    deprecated("10.2.0", "Please see https://github.com/highlightjs/highlight.js/issues/2534");
    return fixMarkup(arg);
  }

  /**
   *
   * @param {HighlightedHTMLElement} el
   */
  function deprecateHighlightBlock(el) {
    deprecated("10.7.0", "highlightBlock will be removed entirely in v12.0");
    deprecated("10.7.0", "Please use highlightElement now.");
    return highlightElement(el);
  }

  /* Interface definition */
  Object.assign(hljs, {
    highlight: highlight,
    highlightAuto: highlightAuto,
    highlightAll: highlightAll,
    fixMarkup: deprecateFixMarkup,
    highlightElement: highlightElement,
    // TODO: Remove with v12 API
    highlightBlock: deprecateHighlightBlock,
    configure: configure,
    initHighlighting: initHighlighting,
    initHighlightingOnLoad: initHighlightingOnLoad,
    registerLanguage: registerLanguage,
    unregisterLanguage: unregisterLanguage,
    listLanguages: listLanguages,
    getLanguage: getLanguage,
    registerAliases: registerAliases,
    requireLanguage: requireLanguage,
    autoDetection: autoDetection,
    inherit: inherit$1,
    addPlugin: addPlugin,
    // plugins for frameworks
    vuePlugin: BuildVuePlugin(hljs).VuePlugin
  });
  hljs.debugMode = function () {
    SAFE_MODE = false;
  };
  hljs.safeMode = function () {
    SAFE_MODE = true;
  };
  hljs.versionString = version;
  for (var key in MODES) {
    // @ts-ignore
    if (_typeof(MODES[key]) === "object") {
      // @ts-ignore
      deepFreezeEs6(MODES[key]);
    }
  }

  // merge all the modes/regexs into our main object
  Object.assign(hljs, MODES);

  // built-in plugins, likely to be moved out of core in the future
  hljs.addPlugin(brPlugin); // slated to be removed in v11
  hljs.addPlugin(mergeHTMLPlugin);
  hljs.addPlugin(tabReplacePlugin);
  return hljs;
};

// export an "instance" of the highlighter
var highlight = HLJS({});
module.exports = highlight;

/***/ }),

/***/ 60311:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hljs = __webpack_require__(16301);
hljs.registerLanguage('1c', __webpack_require__(18141));
hljs.registerLanguage('abnf', __webpack_require__(84749));
hljs.registerLanguage('accesslog', __webpack_require__(44953));
hljs.registerLanguage('actionscript', __webpack_require__(6453));
hljs.registerLanguage('ada', __webpack_require__(74580));
hljs.registerLanguage('angelscript', __webpack_require__(45653));
hljs.registerLanguage('apache', __webpack_require__(1676));
hljs.registerLanguage('applescript', __webpack_require__(16700));
hljs.registerLanguage('arcade', __webpack_require__(15143));
hljs.registerLanguage('arduino', __webpack_require__(3720));
hljs.registerLanguage('armasm', __webpack_require__(90976));
hljs.registerLanguage('xml', __webpack_require__(79457));
hljs.registerLanguage('asciidoc', __webpack_require__(68759));
hljs.registerLanguage('aspectj', __webpack_require__(82809));
hljs.registerLanguage('autohotkey', __webpack_require__(87886));
hljs.registerLanguage('autoit', __webpack_require__(22729));
hljs.registerLanguage('avrasm', __webpack_require__(83061));
hljs.registerLanguage('awk', __webpack_require__(64504));
hljs.registerLanguage('axapta', __webpack_require__(55644));
hljs.registerLanguage('bash', __webpack_require__(33950));
hljs.registerLanguage('basic', __webpack_require__(63309));
hljs.registerLanguage('bnf', __webpack_require__(76220));
hljs.registerLanguage('brainfuck', __webpack_require__(59553));
hljs.registerLanguage('c-like', __webpack_require__(80960));
hljs.registerLanguage('c', __webpack_require__(61981));
hljs.registerLanguage('cal', __webpack_require__(33167));
hljs.registerLanguage('capnproto', __webpack_require__(11139));
hljs.registerLanguage('ceylon', __webpack_require__(92472));
hljs.registerLanguage('clean', __webpack_require__(45136));
hljs.registerLanguage('clojure', __webpack_require__(55272));
hljs.registerLanguage('clojure-repl', __webpack_require__(83776));
hljs.registerLanguage('cmake', __webpack_require__(82984));
hljs.registerLanguage('coffeescript', __webpack_require__(41515));
hljs.registerLanguage('coq', __webpack_require__(67696));
hljs.registerLanguage('cos', __webpack_require__(91771));
hljs.registerLanguage('cpp', __webpack_require__(227));
hljs.registerLanguage('crmsh', __webpack_require__(52685));
hljs.registerLanguage('crystal', __webpack_require__(32599));
hljs.registerLanguage('csharp', __webpack_require__(16718));
hljs.registerLanguage('csp', __webpack_require__(65929));
hljs.registerLanguage('css', __webpack_require__(89210));
hljs.registerLanguage('d', __webpack_require__(82399));
hljs.registerLanguage('markdown', __webpack_require__(8224));
hljs.registerLanguage('dart', __webpack_require__(40494));
hljs.registerLanguage('delphi', __webpack_require__(66187));
hljs.registerLanguage('diff', __webpack_require__(74341));
hljs.registerLanguage('django', __webpack_require__(84567));
hljs.registerLanguage('dns', __webpack_require__(95362));
hljs.registerLanguage('dockerfile', __webpack_require__(84421));
hljs.registerLanguage('dos', __webpack_require__(82901));
hljs.registerLanguage('dsconfig', __webpack_require__(89153));
hljs.registerLanguage('dts', __webpack_require__(60377));
hljs.registerLanguage('dust', __webpack_require__(45971));
hljs.registerLanguage('ebnf', __webpack_require__(89944));
hljs.registerLanguage('elixir', __webpack_require__(30231));
hljs.registerLanguage('elm', __webpack_require__(84180));
hljs.registerLanguage('ruby', __webpack_require__(54458));
hljs.registerLanguage('erb', __webpack_require__(74552));
hljs.registerLanguage('erlang-repl', __webpack_require__(88843));
hljs.registerLanguage('erlang', __webpack_require__(88758));
hljs.registerLanguage('excel', __webpack_require__(20715));
hljs.registerLanguage('fix', __webpack_require__(29834));
hljs.registerLanguage('flix', __webpack_require__(84908));
hljs.registerLanguage('fortran', __webpack_require__(65977));
hljs.registerLanguage('fsharp', __webpack_require__(98810));
hljs.registerLanguage('gams', __webpack_require__(24106));
hljs.registerLanguage('gauss', __webpack_require__(11342));
hljs.registerLanguage('gcode', __webpack_require__(2565));
hljs.registerLanguage('gherkin', __webpack_require__(67580));
hljs.registerLanguage('glsl', __webpack_require__(2212));
hljs.registerLanguage('gml', __webpack_require__(77964));
hljs.registerLanguage('go', __webpack_require__(51464));
hljs.registerLanguage('golo', __webpack_require__(50675));
hljs.registerLanguage('gradle', __webpack_require__(80481));
hljs.registerLanguage('groovy', __webpack_require__(48903));
hljs.registerLanguage('haml', __webpack_require__(14801));
hljs.registerLanguage('handlebars', __webpack_require__(11909));
hljs.registerLanguage('haskell', __webpack_require__(92807));
hljs.registerLanguage('haxe', __webpack_require__(20560));
hljs.registerLanguage('hsp', __webpack_require__(65138));
hljs.registerLanguage('htmlbars', __webpack_require__(3598));
hljs.registerLanguage('http', __webpack_require__(12183));
hljs.registerLanguage('hy', __webpack_require__(95035));
hljs.registerLanguage('inform7', __webpack_require__(9171));
hljs.registerLanguage('ini', __webpack_require__(97970));
hljs.registerLanguage('irpf90', __webpack_require__(89612));
hljs.registerLanguage('isbl', __webpack_require__(16236));
hljs.registerLanguage('java', __webpack_require__(84756));
hljs.registerLanguage('javascript', __webpack_require__(25489));
hljs.registerLanguage('jboss-cli', __webpack_require__(48019));
hljs.registerLanguage('json', __webpack_require__(5392));
hljs.registerLanguage('julia', __webpack_require__(13405));
hljs.registerLanguage('julia-repl', __webpack_require__(29957));
hljs.registerLanguage('kotlin', __webpack_require__(38239));
hljs.registerLanguage('lasso', __webpack_require__(93436));
hljs.registerLanguage('latex', __webpack_require__(81389));
hljs.registerLanguage('ldif', __webpack_require__(7931));
hljs.registerLanguage('leaf', __webpack_require__(54079));
hljs.registerLanguage('less', __webpack_require__(17929));
hljs.registerLanguage('lisp', __webpack_require__(93760));
hljs.registerLanguage('livecodeserver', __webpack_require__(56327));
hljs.registerLanguage('livescript', __webpack_require__(1127));
hljs.registerLanguage('llvm', __webpack_require__(43305));
hljs.registerLanguage('lsl', __webpack_require__(70248));
hljs.registerLanguage('lua', __webpack_require__(61644));
hljs.registerLanguage('makefile', __webpack_require__(17331));
hljs.registerLanguage('mathematica', __webpack_require__(74276));
hljs.registerLanguage('matlab', __webpack_require__(49124));
hljs.registerLanguage('maxima', __webpack_require__(50237));
hljs.registerLanguage('mel', __webpack_require__(49751));
hljs.registerLanguage('mercury', __webpack_require__(7833));
hljs.registerLanguage('mipsasm', __webpack_require__(15743));
hljs.registerLanguage('mizar', __webpack_require__(51183));
hljs.registerLanguage('perl', __webpack_require__(93791));
hljs.registerLanguage('mojolicious', __webpack_require__(83219));
hljs.registerLanguage('monkey', __webpack_require__(97808));
hljs.registerLanguage('moonscript', __webpack_require__(17525));
hljs.registerLanguage('n1ql', __webpack_require__(5290));
hljs.registerLanguage('nginx', __webpack_require__(19837));
hljs.registerLanguage('nim', __webpack_require__(34233));
hljs.registerLanguage('nix', __webpack_require__(40402));
hljs.registerLanguage('node-repl', __webpack_require__(36923));
hljs.registerLanguage('nsis', __webpack_require__(39111));
hljs.registerLanguage('objectivec', __webpack_require__(59942));
hljs.registerLanguage('ocaml', __webpack_require__(22171));
hljs.registerLanguage('openscad', __webpack_require__(284));
hljs.registerLanguage('oxygene', __webpack_require__(58932));
hljs.registerLanguage('parser3', __webpack_require__(88525));
hljs.registerLanguage('pf', __webpack_require__(37940));
hljs.registerLanguage('pgsql', __webpack_require__(25163));
hljs.registerLanguage('php', __webpack_require__(11866));
hljs.registerLanguage('php-template', __webpack_require__(90684));
hljs.registerLanguage('plaintext', __webpack_require__(54249));
hljs.registerLanguage('pony', __webpack_require__(84521));
hljs.registerLanguage('powershell', __webpack_require__(68986));
hljs.registerLanguage('processing', __webpack_require__(2283));
hljs.registerLanguage('profile', __webpack_require__(86209));
hljs.registerLanguage('prolog', __webpack_require__(26695));
hljs.registerLanguage('properties', __webpack_require__(44621));
hljs.registerLanguage('protobuf', __webpack_require__(6348));
hljs.registerLanguage('puppet', __webpack_require__(29247));
hljs.registerLanguage('purebasic', __webpack_require__(82783));
hljs.registerLanguage('python', __webpack_require__(69509));
hljs.registerLanguage('python-repl', __webpack_require__(90258));
hljs.registerLanguage('q', __webpack_require__(40848));
hljs.registerLanguage('qml', __webpack_require__(63650));
hljs.registerLanguage('r', __webpack_require__(84389));
hljs.registerLanguage('reasonml', __webpack_require__(69687));
hljs.registerLanguage('rib', __webpack_require__(16044));
hljs.registerLanguage('roboconf', __webpack_require__(26550));
hljs.registerLanguage('routeros', __webpack_require__(43312));
hljs.registerLanguage('rsl', __webpack_require__(97848));
hljs.registerLanguage('ruleslanguage', __webpack_require__(95264));
hljs.registerLanguage('rust', __webpack_require__(78288));
hljs.registerLanguage('sas', __webpack_require__(83274));
hljs.registerLanguage('scala', __webpack_require__(23601));
hljs.registerLanguage('scheme', __webpack_require__(69254));
hljs.registerLanguage('scilab', __webpack_require__(57828));
hljs.registerLanguage('scss', __webpack_require__(8200));
hljs.registerLanguage('shell', __webpack_require__(90859));
hljs.registerLanguage('smali', __webpack_require__(28765));
hljs.registerLanguage('smalltalk', __webpack_require__(30394));
hljs.registerLanguage('sml', __webpack_require__(23692));
hljs.registerLanguage('sqf', __webpack_require__(84078));
hljs.registerLanguage('sql_more', __webpack_require__(31731));
hljs.registerLanguage('sql', __webpack_require__(69703));
hljs.registerLanguage('stan', __webpack_require__(37787));
hljs.registerLanguage('stata', __webpack_require__(83406));
hljs.registerLanguage('step21', __webpack_require__(8773));
hljs.registerLanguage('stylus', __webpack_require__(4253));
hljs.registerLanguage('subunit', __webpack_require__(42985));
hljs.registerLanguage('swift', __webpack_require__(58243));
hljs.registerLanguage('taggerscript', __webpack_require__(97578));
hljs.registerLanguage('yaml', __webpack_require__(18001));
hljs.registerLanguage('tap', __webpack_require__(23822));
hljs.registerLanguage('tcl', __webpack_require__(65837));
hljs.registerLanguage('thrift', __webpack_require__(29677));
hljs.registerLanguage('tp', __webpack_require__(97029));
hljs.registerLanguage('twig', __webpack_require__(69878));
hljs.registerLanguage('typescript', __webpack_require__(31841));
hljs.registerLanguage('vala', __webpack_require__(86236));
hljs.registerLanguage('vbnet', __webpack_require__(55962));
hljs.registerLanguage('vbscript', __webpack_require__(33095));
hljs.registerLanguage('vbscript-html', __webpack_require__(26835));
hljs.registerLanguage('verilog', __webpack_require__(21554));
hljs.registerLanguage('vhdl', __webpack_require__(90172));
hljs.registerLanguage('vim', __webpack_require__(24431));
hljs.registerLanguage('x86asm', __webpack_require__(28879));
hljs.registerLanguage('xl', __webpack_require__(33843));
hljs.registerLanguage('xquery', __webpack_require__(66500));
hljs.registerLanguage('zephir', __webpack_require__(33501));
module.exports = hljs;

/***/ }),

/***/ 18141:
/***/ ((module) => {

/*
Language: 1C:Enterprise
Author: Stanislav Belov <stbelov@gmail.com>
Description: built-in language 1C:Enterprise (v7, v8)
Category: enterprise
*/

function _1c(hljs) {
  // общий паттерн для определения идентификаторов
  var UNDERSCORE_IDENT_RE = '[A-Za-zА-Яа-яёЁ_][A-Za-zА-Яа-яёЁ_0-9]+';

  // v7 уникальные ключевые слова, отсутствующие в v8 ==> keyword
  var v7_keywords = 'далее ';

  // v8 ключевые слова ==> keyword
  var v8_keywords = 'возврат вызватьисключение выполнить для если и из или иначе иначеесли исключение каждого конецесли ' + 'конецпопытки конеццикла не новый перейти перем по пока попытка прервать продолжить тогда цикл экспорт ';

  // keyword : ключевые слова
  var KEYWORD = v7_keywords + v8_keywords;

  // v7 уникальные директивы, отсутствующие в v8 ==> meta-keyword
  var v7_meta_keywords = 'загрузитьизфайла ';

  // v8 ключевые слова в инструкциях препроцессора, директивах компиляции, аннотациях ==> meta-keyword
  var v8_meta_keywords = 'вебклиент вместо внешнеесоединение клиент конецобласти мобильноеприложениеклиент мобильноеприложениесервер ' + 'наклиенте наклиентенасервере наклиентенасерверебезконтекста насервере насерверебезконтекста область перед ' + 'после сервер толстыйклиентобычноеприложение толстыйклиентуправляемоеприложение тонкийклиент ';

  // meta-keyword : ключевые слова в инструкциях препроцессора, директивах компиляции, аннотациях
  var METAKEYWORD = v7_meta_keywords + v8_meta_keywords;

  // v7 системные константы ==> built_in
  var v7_system_constants = 'разделительстраниц разделительстрок символтабуляции ';

  // v7 уникальные методы глобального контекста, отсутствующие в v8 ==> built_in
  var v7_global_context_methods = 'ansitooem oemtoansi ввестивидсубконто ввестиперечисление ввестипериод ввестиплансчетов выбранныйплансчетов ' + 'датагод датамесяц датачисло заголовоксистемы значениевстроку значениеизстроки каталогиб каталогпользователя ' + 'кодсимв конгода конецпериодаби конецрассчитанногопериодаби конецстандартногоинтервала конквартала конмесяца ' + 'коннедели лог лог10 максимальноеколичествосубконто названиеинтерфейса названиенабораправ назначитьвид ' + 'назначитьсчет найтиссылки началопериодаби началостандартногоинтервала начгода начквартала начмесяца ' + 'начнедели номерднягода номерднянедели номернеделигода обработкаожидания основнойжурналрасчетов ' + 'основнойплансчетов основнойязык очиститьокносообщений периодстр получитьвремята получитьдатута ' + 'получитьдокументта получитьзначенияотбора получитьпозициюта получитьпустоезначение получитьта ' + 'префиксавтонумерации пропись пустоезначение разм разобратьпозициюдокумента рассчитатьрегистрына ' + 'рассчитатьрегистрыпо симв создатьобъект статусвозврата стрколичествострок сформироватьпозициюдокумента ' + 'счетпокоду текущеевремя типзначения типзначениястр установитьтана установитьтапо фиксшаблон шаблон ';

  // v8 методы глобального контекста ==> built_in
  var v8_global_context_methods = 'acos asin atan base64значение base64строка cos exp log log10 pow sin sqrt tan xmlзначение xmlстрока ' + 'xmlтип xmlтипзнч активноеокно безопасныйрежим безопасныйрежимразделенияданных булево ввестидату ввестизначение ' + 'ввестистроку ввестичисло возможностьчтенияxml вопрос восстановитьзначение врег выгрузитьжурналрегистрации ' + 'выполнитьобработкуоповещения выполнитьпроверкуправдоступа вычислить год данныеформывзначение дата день деньгода ' + 'деньнедели добавитьмесяц заблокироватьданныедляредактирования заблокироватьработупользователя завершитьработусистемы ' + 'загрузитьвнешнююкомпоненту закрытьсправку записатьjson записатьxml записатьдатуjson записьжурналарегистрации ' + 'заполнитьзначениясвойств запроситьразрешениепользователя запуститьприложение запуститьсистему зафиксироватьтранзакцию ' + 'значениевданныеформы значениевстрокувнутр значениевфайл значениезаполнено значениеизстрокивнутр значениеизфайла ' + 'изxmlтипа импортмоделиxdto имякомпьютера имяпользователя инициализироватьпредопределенныеданные информацияобошибке ' + 'каталогбиблиотекимобильногоустройства каталогвременныхфайлов каталогдокументов каталогпрограммы кодироватьстроку ' + 'кодлокализацииинформационнойбазы кодсимвола командасистемы конецгода конецдня конецквартала конецмесяца конецминуты ' + 'конецнедели конецчаса конфигурациябазыданныхизмененадинамически конфигурацияизменена копироватьданныеформы ' + 'копироватьфайл краткоепредставлениеошибки лев макс местноевремя месяц мин минута монопольныйрежим найти ' + 'найтинедопустимыесимволыxml найтиокнопонавигационнойссылке найтипомеченныенаудаление найтипоссылкам найтифайлы ' + 'началогода началодня началоквартала началомесяца началоминуты началонедели началочаса начатьзапросразрешенияпользователя ' + 'начатьзапускприложения начатькопированиефайла начатьперемещениефайла начатьподключениевнешнейкомпоненты ' + 'начатьподключениерасширенияработыскриптографией начатьподключениерасширенияработысфайлами начатьпоискфайлов ' + 'начатьполучениекаталогавременныхфайлов начатьполучениекаталогадокументов начатьполучениерабочегокаталогаданныхпользователя ' + 'начатьполучениефайлов начатьпомещениефайла начатьпомещениефайлов начатьсозданиедвоичныхданныхизфайла начатьсозданиекаталога ' + 'начатьтранзакцию начатьудалениефайлов начатьустановкувнешнейкомпоненты начатьустановкурасширенияработыскриптографией ' + 'начатьустановкурасширенияработысфайлами неделягода необходимостьзавершениясоединения номерсеансаинформационнойбазы ' + 'номерсоединенияинформационнойбазы нрег нстр обновитьинтерфейс обновитьнумерациюобъектов обновитьповторноиспользуемыезначения ' + 'обработкапрерыванияпользователя объединитьфайлы окр описаниеошибки оповестить оповеститьобизменении ' + 'отключитьобработчикзапросанастроекклиенталицензирования отключитьобработчикожидания отключитьобработчикоповещения ' + 'открытьзначение открытьиндекссправки открытьсодержаниесправки открытьсправку открытьформу открытьформумодально ' + 'отменитьтранзакцию очиститьжурналрегистрации очиститьнастройкипользователя очиститьсообщения параметрыдоступа ' + 'перейтипонавигационнойссылке переместитьфайл подключитьвнешнююкомпоненту ' + 'подключитьобработчикзапросанастроекклиенталицензирования подключитьобработчикожидания подключитьобработчикоповещения ' + 'подключитьрасширениеработыскриптографией подключитьрасширениеработысфайлами подробноепредставлениеошибки ' + 'показатьвводдаты показатьвводзначения показатьвводстроки показатьвводчисла показатьвопрос показатьзначение ' + 'показатьинформациюобошибке показатьнакарте показатьоповещениепользователя показатьпредупреждение полноеимяпользователя ' + 'получитьcomобъект получитьxmlтип получитьадреспоместоположению получитьблокировкусеансов получитьвремязавершенияспящегосеанса ' + 'получитьвремязасыпанияпассивногосеанса получитьвремяожиданияблокировкиданных получитьданныевыбора ' + 'получитьдополнительныйпараметрклиенталицензирования получитьдопустимыекодылокализации получитьдопустимыечасовыепояса ' + 'получитьзаголовокклиентскогоприложения получитьзаголовоксистемы получитьзначенияотборажурналарегистрации ' + 'получитьидентификаторконфигурации получитьизвременногохранилища получитьимявременногофайла ' + 'получитьимяклиенталицензирования получитьинформациюэкрановклиента получитьиспользованиежурналарегистрации ' + 'получитьиспользованиесобытияжурналарегистрации получитькраткийзаголовокприложения получитьмакетоформления ' + 'получитьмаскувсефайлы получитьмаскувсефайлыклиента получитьмаскувсефайлысервера получитьместоположениепоадресу ' + 'получитьминимальнуюдлинупаролейпользователей получитьнавигационнуюссылку получитьнавигационнуюссылкуинформационнойбазы ' + 'получитьобновлениеконфигурациибазыданных получитьобновлениепредопределенныхданныхинформационнойбазы получитьобщиймакет ' + 'получитьобщуюформу получитьокна получитьоперативнуюотметкувремени получитьотключениебезопасногорежима ' + 'получитьпараметрыфункциональныхопцийинтерфейса получитьполноеимяпредопределенногозначения ' + 'получитьпредставлениянавигационныхссылок получитьпроверкусложностипаролейпользователей получитьразделительпути ' + 'получитьразделительпутиклиента получитьразделительпутисервера получитьсеансыинформационнойбазы ' + 'получитьскоростьклиентскогосоединения получитьсоединенияинформационнойбазы получитьсообщенияпользователю ' + 'получитьсоответствиеобъектаиформы получитьсоставстандартногоинтерфейсаodata получитьструктурухранениябазыданных ' + 'получитьтекущийсеансинформационнойбазы получитьфайл получитьфайлы получитьформу получитьфункциональнуюопцию ' + 'получитьфункциональнуюопциюинтерфейса получитьчасовойпоясинформационнойбазы пользователиос поместитьвовременноехранилище ' + 'поместитьфайл поместитьфайлы прав праводоступа предопределенноезначение представлениекодалокализации представлениепериода ' + 'представлениеправа представлениеприложения представлениесобытияжурналарегистрации представлениечасовогопояса предупреждение ' + 'прекратитьработусистемы привилегированныйрежим продолжитьвызов прочитатьjson прочитатьxml прочитатьдатуjson пустаястрока ' + 'рабочийкаталогданныхпользователя разблокироватьданныедляредактирования разделитьфайл разорватьсоединениесвнешнимисточникомданных ' + 'раскодироватьстроку рольдоступна секунда сигнал символ скопироватьжурналрегистрации смещениелетнеговремени ' + 'смещениестандартноговремени соединитьбуферыдвоичныхданных создатькаталог создатьфабрикуxdto сокрл сокрлп сокрп сообщить ' + 'состояние сохранитьзначение сохранитьнастройкипользователя сред стрдлина стрзаканчиваетсяна стрзаменить стрнайти стрначинаетсяс ' + 'строка строкасоединенияинформационнойбазы стрполучитьстроку стрразделить стрсоединить стрсравнить стрчисловхождений ' + 'стрчислострок стршаблон текущаядата текущаядатасеанса текущаяуниверсальнаядата текущаяуниверсальнаядатавмиллисекундах ' + 'текущийвариантинтерфейсаклиентскогоприложения текущийвариантосновногошрифтаклиентскогоприложения текущийкодлокализации ' + 'текущийрежимзапуска текущийязык текущийязыксистемы тип типзнч транзакцияактивна трег удалитьданныеинформационнойбазы ' + 'удалитьизвременногохранилища удалитьобъекты удалитьфайлы универсальноевремя установитьбезопасныйрежим ' + 'установитьбезопасныйрежимразделенияданных установитьблокировкусеансов установитьвнешнююкомпоненту ' + 'установитьвремязавершенияспящегосеанса установитьвремязасыпанияпассивногосеанса установитьвремяожиданияблокировкиданных ' + 'установитьзаголовокклиентскогоприложения установитьзаголовоксистемы установитьиспользованиежурналарегистрации ' + 'установитьиспользованиесобытияжурналарегистрации установитькраткийзаголовокприложения ' + 'установитьминимальнуюдлинупаролейпользователей установитьмонопольныйрежим установитьнастройкиклиенталицензирования ' + 'установитьобновлениепредопределенныхданныхинформационнойбазы установитьотключениебезопасногорежима ' + 'установитьпараметрыфункциональныхопцийинтерфейса установитьпривилегированныйрежим ' + 'установитьпроверкусложностипаролейпользователей установитьрасширениеработыскриптографией ' + 'установитьрасширениеработысфайлами установитьсоединениесвнешнимисточникомданных установитьсоответствиеобъектаиформы ' + 'установитьсоставстандартногоинтерфейсаodata установитьчасовойпоясинформационнойбазы установитьчасовойпояссеанса ' + 'формат цел час часовойпояс часовойпояссеанса число числопрописью этоадресвременногохранилища ';

  // v8 свойства глобального контекста ==> built_in
  var v8_global_context_property = 'wsссылки библиотекакартинок библиотекамакетовоформлениякомпоновкиданных библиотекастилей бизнеспроцессы ' + 'внешниеисточникиданных внешниеобработки внешниеотчеты встроенныепокупки главныйинтерфейс главныйстиль ' + 'документы доставляемыеуведомления журналыдокументов задачи информацияобинтернетсоединении использованиерабочейдаты ' + 'историяработыпользователя константы критерииотбора метаданные обработки отображениерекламы отправкадоставляемыхуведомлений ' + 'отчеты панельзадачос параметрзапуска параметрысеанса перечисления планывидоврасчета планывидовхарактеристик ' + 'планыобмена планысчетов полнотекстовыйпоиск пользователиинформационнойбазы последовательности проверкавстроенныхпокупок ' + 'рабочаядата расширенияконфигурации регистрыбухгалтерии регистрынакопления регистрырасчета регистрысведений ' + 'регламентныезадания сериализаторxdto справочники средствагеопозиционирования средствакриптографии средствамультимедиа ' + 'средстваотображениярекламы средствапочты средствателефонии фабрикаxdto файловыепотоки фоновыезадания хранилищанастроек ' + 'хранилищевариантовотчетов хранилищенастроекданныхформ хранилищеобщихнастроек хранилищепользовательскихнастроекдинамическихсписков ' + 'хранилищепользовательскихнастроекотчетов хранилищесистемныхнастроек ';

  // built_in : встроенные или библиотечные объекты (константы, классы, функции)
  var BUILTIN = v7_system_constants + v7_global_context_methods + v8_global_context_methods + v8_global_context_property;

  // v8 системные наборы значений ==> class
  var v8_system_sets_of_values = 'webцвета windowsцвета windowsшрифты библиотекакартинок рамкистиля символы цветастиля шрифтыстиля ';

  // v8 системные перечисления - интерфейсные ==> class
  var v8_system_enums_interface = 'автоматическоесохранениеданныхформывнастройках автонумерациявформе автораздвижениесерий ' + 'анимациядиаграммы вариантвыравниванияэлементовизаголовков вариантуправлениявысотойтаблицы ' + 'вертикальнаяпрокруткаформы вертикальноеположение вертикальноеположениеэлемента видгруппыформы ' + 'виддекорацииформы виддополненияэлементаформы видизмененияданных видкнопкиформы видпереключателя ' + 'видподписейкдиаграмме видполяформы видфлажка влияниеразмеранапузырекдиаграммы горизонтальноеположение ' + 'горизонтальноеположениеэлемента группировкаколонок группировкаподчиненныхэлементовформы ' + 'группыиэлементы действиеперетаскивания дополнительныйрежимотображения допустимыедействияперетаскивания ' + 'интервалмеждуэлементамиформы использованиевывода использованиеполосыпрокрутки ' + 'используемоезначениеточкибиржевойдиаграммы историявыборапривводе источникзначенийоситочекдиаграммы ' + 'источникзначенияразмерапузырькадиаграммы категориягруппыкоманд максимумсерий начальноеотображениедерева ' + 'начальноеотображениесписка обновлениетекстаредактирования ориентациядендрограммы ориентациядиаграммы ' + 'ориентацияметокдиаграммы ориентацияметоксводнойдиаграммы ориентацияэлементаформы отображениевдиаграмме ' + 'отображениевлегендедиаграммы отображениегруппыкнопок отображениезаголовкашкалыдиаграммы ' + 'отображениезначенийсводнойдиаграммы отображениезначенияизмерительнойдиаграммы ' + 'отображениеинтерваладиаграммыганта отображениекнопки отображениекнопкивыбора отображениеобсужденийформы ' + 'отображениеобычнойгруппы отображениеотрицательныхзначенийпузырьковойдиаграммы отображениепанелипоиска ' + 'отображениеподсказки отображениепредупрежденияприредактировании отображениеразметкиполосырегулирования ' + 'отображениестраницформы отображениетаблицы отображениетекстазначениядиаграммыганта ' + 'отображениеуправленияобычнойгруппы отображениефигурыкнопки палитрацветовдиаграммы поведениеобычнойгруппы ' + 'поддержкамасштабадендрограммы поддержкамасштабадиаграммыганта поддержкамасштабасводнойдиаграммы ' + 'поисквтаблицепривводе положениезаголовкаэлементаформы положениекартинкикнопкиформы ' + 'положениекартинкиэлементаграфическойсхемы положениекоманднойпанелиформы положениекоманднойпанелиэлементаформы ' + 'положениеопорнойточкиотрисовки положениеподписейкдиаграмме положениеподписейшкалызначенийизмерительнойдиаграммы ' + 'положениесостоянияпросмотра положениестрокипоиска положениетекстасоединительнойлинии положениеуправленияпоиском ' + 'положениешкалывремени порядокотображенияточекгоризонтальнойгистограммы порядоксерийвлегендедиаграммы ' + 'размеркартинки расположениезаголовкашкалыдиаграммы растягиваниеповертикалидиаграммыганта ' + 'режимавтоотображениясостояния режимвводастроктаблицы режимвыборанезаполненного режимвыделениядаты ' + 'режимвыделениястрокитаблицы режимвыделениятаблицы режимизмененияразмера режимизменениясвязанногозначения ' + 'режимиспользованиядиалогапечати режимиспользованияпараметракоманды режиммасштабированияпросмотра ' + 'режимосновногоокнаклиентскогоприложения режимоткрытияокнаформы режимотображениявыделения ' + 'режимотображениягеографическойсхемы режимотображениязначенийсерии режимотрисовкисеткиграфическойсхемы ' + 'режимполупрозрачностидиаграммы режимпробеловдиаграммы режимразмещениянастранице режимредактированияколонки ' + 'режимсглаживаниядиаграммы режимсглаживанияиндикатора режимсписказадач сквозноевыравнивание ' + 'сохранениеданныхформывнастройках способзаполнениятекстазаголовкашкалыдиаграммы ' + 'способопределенияограничивающегозначениядиаграммы стандартнаягруппакоманд стандартноеоформление ' + 'статусоповещенияпользователя стильстрелки типаппроксимациилиниитрендадиаграммы типдиаграммы ' + 'типединицышкалывремени типимпортасерийслоягеографическойсхемы типлиниигеографическойсхемы типлиниидиаграммы ' + 'типмаркерагеографическойсхемы типмаркерадиаграммы типобластиоформления ' + 'типорганизацииисточникаданныхгеографическойсхемы типотображениясериислоягеографическойсхемы ' + 'типотображенияточечногообъектагеографическойсхемы типотображенияшкалыэлементалегендыгеографическойсхемы ' + 'типпоискаобъектовгеографическойсхемы типпроекциигеографическойсхемы типразмещенияизмерений ' + 'типразмещенияреквизитовизмерений типрамкиэлементауправления типсводнойдиаграммы ' + 'типсвязидиаграммыганта типсоединениязначенийпосериямдиаграммы типсоединенияточекдиаграммы ' + 'типсоединительнойлинии типстороныэлементаграфическойсхемы типформыотчета типшкалырадарнойдиаграммы ' + 'факторлиниитрендадиаграммы фигуракнопки фигурыграфическойсхемы фиксациявтаблице форматдняшкалывремени ' + 'форматкартинки ширинаподчиненныхэлементовформы ';

  // v8 системные перечисления - свойства прикладных объектов ==> class
  var v8_system_enums_objects_properties = 'виддвижениябухгалтерии виддвижениянакопления видпериодарегистрарасчета видсчета видточкимаршрутабизнеспроцесса ' + 'использованиеагрегатарегистранакопления использованиегруппиэлементов использованиережимапроведения ' + 'использованиесреза периодичностьагрегатарегистранакопления режимавтовремя режимзаписидокумента режимпроведениядокумента ';

  // v8 системные перечисления - планы обмена ==> class
  var v8_system_enums_exchange_plans = 'авторегистрацияизменений допустимыйномерсообщения отправкаэлементаданных получениеэлементаданных ';

  // v8 системные перечисления - табличный документ ==> class
  var v8_system_enums_tabular_document = 'использованиерасшифровкитабличногодокумента ориентациястраницы положениеитоговколоноксводнойтаблицы ' + 'положениеитоговстроксводнойтаблицы положениетекстаотносительнокартинки расположениезаголовкагруппировкитабличногодокумента ' + 'способчтениязначенийтабличногодокумента типдвустороннейпечати типзаполненияобластитабличногодокумента ' + 'типкурсоровтабличногодокумента типлиниирисункатабличногодокумента типлинииячейкитабличногодокумента ' + 'типнаправленияпереходатабличногодокумента типотображениявыделениятабличногодокумента типотображениялинийсводнойтаблицы ' + 'типразмещениятекстатабличногодокумента типрисункатабличногодокумента типсмещениятабличногодокумента ' + 'типузоратабличногодокумента типфайлатабличногодокумента точностьпечати чередованиерасположениястраниц ';

  // v8 системные перечисления - планировщик ==> class
  var v8_system_enums_sheduler = 'отображениевремениэлементовпланировщика ';

  // v8 системные перечисления - форматированный документ ==> class
  var v8_system_enums_formatted_document = 'типфайлаформатированногодокумента ';

  // v8 системные перечисления - запрос ==> class
  var v8_system_enums_query = 'обходрезультатазапроса типзаписизапроса ';

  // v8 системные перечисления - построитель отчета ==> class
  var v8_system_enums_report_builder = 'видзаполнениярасшифровкипостроителяотчета типдобавленияпредставлений типизмеренияпостроителяотчета типразмещенияитогов ';

  // v8 системные перечисления - работа с файлами ==> class
  var v8_system_enums_files = 'доступкфайлу режимдиалогавыборафайла режимоткрытияфайла ';

  // v8 системные перечисления - построитель запроса ==> class
  var v8_system_enums_query_builder = 'типизмеренияпостроителязапроса ';

  // v8 системные перечисления - анализ данных ==> class
  var v8_system_enums_data_analysis = 'видданныханализа методкластеризации типединицыинтервалавременианализаданных типзаполнениятаблицырезультатаанализаданных ' + 'типиспользованиячисловыхзначенийанализаданных типисточникаданныхпоискаассоциаций типколонкианализаданныхдереворешений ' + 'типколонкианализаданныхкластеризация типколонкианализаданныхобщаястатистика типколонкианализаданныхпоискассоциаций ' + 'типколонкианализаданныхпоискпоследовательностей типколонкимоделипрогноза типмерырасстоянияанализаданных ' + 'типотсеченияправилассоциации типполяанализаданных типстандартизациианализаданных типупорядочиванияправилассоциациианализаданных ' + 'типупорядочиванияшаблоновпоследовательностейанализаданных типупрощениядереварешений ';

  // v8 системные перечисления - xml, json, xs, dom, xdto, web-сервисы ==> class
  var v8_system_enums_xml_json_xs_dom_xdto_ws = 'wsнаправлениепараметра вариантxpathxs вариантзаписидатыjson вариантпростоготипаxs видгруппымоделиxs видфасетаxdto ' + 'действиепостроителяdom завершенностьпростоготипаxs завершенностьсоставноготипаxs завершенностьсхемыxs запрещенныеподстановкиxs ' + 'исключениягруппподстановкиxs категорияиспользованияатрибутаxs категорияограниченияидентичностиxs категорияограниченияпространствименxs ' + 'методнаследованияxs модельсодержимогоxs назначениетипаxml недопустимыеподстановкиxs обработкапробельныхсимволовxs обработкасодержимогоxs ' + 'ограничениезначенияxs параметрыотбораузловdom переносстрокjson позициявдокументеdom пробельныесимволыxml типатрибутаxml типзначенияjson ' + 'типканоническогоxml типкомпонентыxs типпроверкиxml типрезультатаdomxpath типузлаdom типузлаxml формаxml формапредставленияxs ' + 'форматдатыjson экранированиесимволовjson ';

  // v8 системные перечисления - система компоновки данных ==> class
  var v8_system_enums_data_composition_system = 'видсравнениякомпоновкиданных действиеобработкирасшифровкикомпоновкиданных направлениесортировкикомпоновкиданных ' + 'расположениевложенныхэлементоврезультатакомпоновкиданных расположениеитоговкомпоновкиданных расположениегруппировкикомпоновкиданных ' + 'расположениеполейгруппировкикомпоновкиданных расположениеполякомпоновкиданных расположениереквизитовкомпоновкиданных ' + 'расположениересурсовкомпоновкиданных типбухгалтерскогоостаткакомпоновкиданных типвыводатекстакомпоновкиданных ' + 'типгруппировкикомпоновкиданных типгруппыэлементовотборакомпоновкиданных типдополненияпериодакомпоновкиданных ' + 'типзаголовкаполейкомпоновкиданных типмакетагруппировкикомпоновкиданных типмакетаобластикомпоновкиданных типостаткакомпоновкиданных ' + 'типпериодакомпоновкиданных типразмещениятекстакомпоновкиданных типсвязинаборовданныхкомпоновкиданных типэлементарезультатакомпоновкиданных ' + 'расположениелегендыдиаграммыкомпоновкиданных типпримененияотборакомпоновкиданных режимотображенияэлементанастройкикомпоновкиданных ' + 'режимотображениянастроеккомпоновкиданных состояниеэлементанастройкикомпоновкиданных способвосстановлениянастроеккомпоновкиданных ' + 'режимкомпоновкирезультата использованиепараметракомпоновкиданных автопозицияресурсовкомпоновкиданных ' + 'вариантиспользованиягруппировкикомпоновкиданных расположениересурсоввдиаграммекомпоновкиданных фиксациякомпоновкиданных ' + 'использованиеусловногооформлениякомпоновкиданных ';

  // v8 системные перечисления - почта ==> class
  var v8_system_enums_email = 'важностьинтернетпочтовогосообщения обработкатекстаинтернетпочтовогосообщения способкодированияинтернетпочтовоговложения ' + 'способкодированиянеasciiсимволовинтернетпочтовогосообщения типтекстапочтовогосообщения протоколинтернетпочты ' + 'статусразборапочтовогосообщения ';

  // v8 системные перечисления - журнал регистрации ==> class
  var v8_system_enums_logbook = 'режимтранзакциизаписижурналарегистрации статустранзакциизаписижурналарегистрации уровеньжурналарегистрации ';

  // v8 системные перечисления - криптография ==> class
  var v8_system_enums_cryptography = 'расположениехранилищасертификатовкриптографии режимвключениясертификатовкриптографии режимпроверкисертификатакриптографии ' + 'типхранилищасертификатовкриптографии ';

  // v8 системные перечисления - ZIP ==> class
  var v8_system_enums_zip = 'кодировкаименфайловвzipфайле методсжатияzip методшифрованияzip режимвосстановленияпутейфайловzip режимобработкиподкаталоговzip ' + 'режимсохраненияпутейzip уровеньсжатияzip ';

  // v8 системные перечисления -
  // Блокировка данных, Фоновые задания, Автоматизированное тестирование,
  // Доставляемые уведомления, Встроенные покупки, Интернет, Работа с двоичными данными ==> class
  var v8_system_enums_other = 'звуковоеоповещение направлениепереходакстроке позициявпотоке порядокбайтов режимблокировкиданных режимуправленияблокировкойданных ' + 'сервисвстроенныхпокупок состояниефоновогозадания типподписчикадоставляемыхуведомлений уровеньиспользованиязащищенногосоединенияftp ';

  // v8 системные перечисления - схема запроса ==> class
  var v8_system_enums_request_schema = 'направлениепорядкасхемызапроса типдополненияпериодамисхемызапроса типконтрольнойточкисхемызапроса типобъединениясхемызапроса ' + 'типпараметрадоступнойтаблицысхемызапроса типсоединениясхемызапроса ';

  // v8 системные перечисления - свойства объектов метаданных ==> class
  var v8_system_enums_properties_of_metadata_objects = 'httpметод автоиспользованиеобщегореквизита автопрефиксномеразадачи вариантвстроенногоязыка видиерархии видрегистранакопления ' + 'видтаблицывнешнегоисточникаданных записьдвиженийприпроведении заполнениепоследовательностей индексирование ' + 'использованиебазыпланавидоврасчета использованиебыстроговыбора использованиеобщегореквизита использованиеподчинения ' + 'использованиеполнотекстовогопоиска использованиеразделяемыхданныхобщегореквизита использованиереквизита ' + 'назначениеиспользованияприложения назначениерасширенияконфигурации направлениепередачи обновлениепредопределенныхданных ' + 'оперативноепроведение основноепредставлениевидарасчета основноепредставлениевидахарактеристики основноепредставлениезадачи ' + 'основноепредставлениепланаобмена основноепредставлениесправочника основноепредставлениесчета перемещениеграницыприпроведении ' + 'периодичностьномерабизнеспроцесса периодичностьномерадокумента периодичностьрегистрарасчета периодичностьрегистрасведений ' + 'повторноеиспользованиевозвращаемыхзначений полнотекстовыйпоискпривводепостроке принадлежностьобъекта проведение ' + 'разделениеаутентификацииобщегореквизита разделениеданныхобщегореквизита разделениерасширенийконфигурацииобщегореквизита ' + 'режимавтонумерацииобъектов режимзаписирегистра режимиспользованиямодальности ' + 'режимиспользованиясинхронныхвызововрасширенийплатформыивнешнихкомпонент режимповторногоиспользованиясеансов ' + 'режимполученияданныхвыборапривводепостроке режимсовместимости режимсовместимостиинтерфейса ' + 'режимуправленияблокировкойданныхпоумолчанию сериикодовпланавидовхарактеристик сериикодовпланасчетов ' + 'сериикодовсправочника созданиепривводе способвыбора способпоискастрокипривводепостроке способредактирования ' + 'типданныхтаблицывнешнегоисточникаданных типкодапланавидоврасчета типкодасправочника типмакета типномерабизнеспроцесса ' + 'типномерадокумента типномеразадачи типформы удалениедвижений ';

  // v8 системные перечисления - разные ==> class
  var v8_system_enums_differents = 'важностьпроблемыприменениярасширенияконфигурации вариантинтерфейсаклиентскогоприложения вариантмасштабаформклиентскогоприложения ' + 'вариантосновногошрифтаклиентскогоприложения вариантстандартногопериода вариантстандартнойдатыначала видграницы видкартинки ' + 'видотображенияполнотекстовогопоиска видрамки видсравнения видцвета видчисловогозначения видшрифта допустимаядлина допустимыйзнак ' + 'использованиеbyteordermark использованиеметаданныхполнотекстовогопоиска источникрасширенийконфигурации клавиша кодвозвратадиалога ' + 'кодировкаxbase кодировкатекста направлениепоиска направлениесортировки обновлениепредопределенныхданных обновлениеприизмененииданных ' + 'отображениепанелиразделов проверказаполнения режимдиалогавопрос режимзапускаклиентскогоприложения режимокругления режимоткрытияформприложения ' + 'режимполнотекстовогопоиска скоростьклиентскогосоединения состояниевнешнегоисточникаданных состояниеобновленияконфигурациибазыданных ' + 'способвыборасертификатаwindows способкодированиястроки статуссообщения типвнешнейкомпоненты типплатформы типповеденияклавишиenter ' + 'типэлементаинформацииовыполненииобновленияконфигурациибазыданных уровеньизоляциитранзакций хешфункция частидаты';

  // class: встроенные наборы значений, системные перечисления (содержат дочерние значения, обращения к которым через разыменование)
  var CLASS = v8_system_sets_of_values + v8_system_enums_interface + v8_system_enums_objects_properties + v8_system_enums_exchange_plans + v8_system_enums_tabular_document + v8_system_enums_sheduler + v8_system_enums_formatted_document + v8_system_enums_query + v8_system_enums_report_builder + v8_system_enums_files + v8_system_enums_query_builder + v8_system_enums_data_analysis + v8_system_enums_xml_json_xs_dom_xdto_ws + v8_system_enums_data_composition_system + v8_system_enums_email + v8_system_enums_logbook + v8_system_enums_cryptography + v8_system_enums_zip + v8_system_enums_other + v8_system_enums_request_schema + v8_system_enums_properties_of_metadata_objects + v8_system_enums_differents;

  // v8 общие объекты (у объектов есть конструктор, экземпляры создаются методом НОВЫЙ) ==> type
  var v8_shared_object = 'comобъект ftpсоединение httpзапрос httpсервисответ httpсоединение wsопределения wsпрокси xbase анализданных аннотацияxs ' + 'блокировкаданных буфердвоичныхданных включениеxs выражениекомпоновкиданных генераторслучайныхчисел географическаясхема ' + 'географическиекоординаты графическаясхема группамоделиxs данныерасшифровкикомпоновкиданных двоичныеданные дендрограмма ' + 'диаграмма диаграммаганта диалогвыборафайла диалогвыборацвета диалогвыборашрифта диалограсписаниярегламентногозадания ' + 'диалогредактированиястандартногопериода диапазон документdom документhtml документацияxs доставляемоеуведомление ' + 'записьdom записьfastinfoset записьhtml записьjson записьxml записьzipфайла записьданных записьтекста записьузловdom ' + 'запрос защищенноесоединениеopenssl значенияполейрасшифровкикомпоновкиданных извлечениетекста импортxs интернетпочта ' + 'интернетпочтовоесообщение интернетпочтовыйпрофиль интернетпрокси интернетсоединение информациядляприложенияxs ' + 'использованиеатрибутаxs использованиесобытияжурналарегистрации источникдоступныхнастроеккомпоновкиданных ' + 'итераторузловdom картинка квалификаторыдаты квалификаторыдвоичныхданных квалификаторыстроки квалификаторычисла ' + 'компоновщикмакетакомпоновкиданных компоновщикнастроеккомпоновкиданных конструктормакетаоформлениякомпоновкиданных ' + 'конструкторнастроеккомпоновкиданных конструкторформатнойстроки линия макеткомпоновкиданных макетобластикомпоновкиданных ' + 'макетоформлениякомпоновкиданных маскаxs менеджеркриптографии наборсхемxml настройкикомпоновкиданных настройкисериализацииjson ' + 'обработкакартинок обработкарасшифровкикомпоновкиданных обходдереваdom объявлениеатрибутаxs объявлениенотацииxs ' + 'объявлениеэлементаxs описаниеиспользованиясобытиядоступжурналарегистрации ' + 'описаниеиспользованиясобытияотказвдоступежурналарегистрации описаниеобработкирасшифровкикомпоновкиданных ' + 'описаниепередаваемогофайла описаниетипов определениегруппыатрибутовxs определениегруппымоделиxs ' + 'определениеограниченияидентичностиxs определениепростоготипаxs определениесоставноготипаxs определениетипадокументаdom ' + 'определенияxpathxs отборкомпоновкиданных пакетотображаемыхдокументов параметрвыбора параметркомпоновкиданных ' + 'параметрызаписиjson параметрызаписиxml параметрычтенияxml переопределениеxs планировщик полеанализаданных ' + 'полекомпоновкиданных построительdom построительзапроса построительотчета построительотчетаанализаданных ' + 'построительсхемxml поток потоквпамяти почта почтовоесообщение преобразованиеxsl преобразованиекканоническомуxml ' + 'процессорвыводарезультатакомпоновкиданныхвколлекциюзначений процессорвыводарезультатакомпоновкиданныхвтабличныйдокумент ' + 'процессоркомпоновкиданных разыменовательпространствименdom рамка расписаниерегламентногозадания расширенноеимяxml ' + 'результатчтенияданных своднаядиаграмма связьпараметравыбора связьпотипу связьпотипукомпоновкиданных сериализаторxdto ' + 'сертификатклиентаwindows сертификатклиентафайл сертификаткриптографии сертификатыудостоверяющихцентровwindows ' + 'сертификатыудостоверяющихцентровфайл сжатиеданных системнаяинформация сообщениепользователю сочетаниеклавиш ' + 'сравнениезначений стандартнаядатаначала стандартныйпериод схемаxml схемакомпоновкиданных табличныйдокумент ' + 'текстовыйдокумент тестируемоеприложение типданныхxml уникальныйидентификатор фабрикаxdto файл файловыйпоток ' + 'фасетдлиныxs фасетколичестваразрядовдробнойчастиxs фасетмаксимальноговключающегозначенияxs ' + 'фасетмаксимальногоисключающегозначенияxs фасетмаксимальнойдлиныxs фасетминимальноговключающегозначенияxs ' + 'фасетминимальногоисключающегозначенияxs фасетминимальнойдлиныxs фасетобразцаxs фасетобщегоколичестваразрядовxs ' + 'фасетперечисленияxs фасетпробельныхсимволовxs фильтрузловdom форматированнаястрока форматированныйдокумент ' + 'фрагментxs хешированиеданных хранилищезначения цвет чтениеfastinfoset чтениеhtml чтениеjson чтениеxml чтениеzipфайла ' + 'чтениеданных чтениетекста чтениеузловdom шрифт элементрезультатакомпоновкиданных ';

  // v8 универсальные коллекции значений ==> type
  var v8_universal_collection = 'comsafearray деревозначений массив соответствие списокзначений структура таблицазначений фиксированнаяструктура ' + 'фиксированноесоответствие фиксированныймассив ';

  // type : встроенные типы
  var TYPE = v8_shared_object + v8_universal_collection;

  // literal : примитивные типы
  var LITERAL = 'null истина ложь неопределено';

  // number : числа
  var NUMBERS = hljs.inherit(hljs.NUMBER_MODE);

  // string : строки
  var STRINGS = {
    className: 'string',
    begin: '"|\\|',
    end: '"|$',
    contains: [{
      begin: '""'
    }]
  };

  // number : даты
  var DATE = {
    begin: "'",
    end: "'",
    excludeBegin: true,
    excludeEnd: true,
    contains: [{
      className: 'number',
      begin: '\\d{4}([\\.\\\\/:-]?\\d{2}){0,5}'
    }]
  };

  // comment : комментарии
  var COMMENTS = hljs.inherit(hljs.C_LINE_COMMENT_MODE);

  // meta : инструкции препроцессора, директивы компиляции
  var META = {
    className: 'meta',
    begin: '#|&',
    end: '$',
    keywords: {
      $pattern: UNDERSCORE_IDENT_RE,
      'meta-keyword': KEYWORD + METAKEYWORD
    },
    contains: [COMMENTS]
  };

  // symbol : метка goto
  var SYMBOL = {
    className: 'symbol',
    begin: '~',
    end: ';|:',
    excludeEnd: true
  };

  // function : объявление процедур и функций
  var FUNCTION = {
    className: 'function',
    variants: [{
      begin: 'процедура|функция',
      end: '\\)',
      keywords: 'процедура функция'
    }, {
      begin: 'конецпроцедуры|конецфункции',
      keywords: 'конецпроцедуры конецфункции'
    }],
    contains: [{
      begin: '\\(',
      end: '\\)',
      endsParent: true,
      contains: [{
        className: 'params',
        begin: UNDERSCORE_IDENT_RE,
        end: ',',
        excludeEnd: true,
        endsWithParent: true,
        keywords: {
          $pattern: UNDERSCORE_IDENT_RE,
          keyword: 'знач',
          literal: LITERAL
        },
        contains: [NUMBERS, STRINGS, DATE]
      }, COMMENTS]
    }, hljs.inherit(hljs.TITLE_MODE, {
      begin: UNDERSCORE_IDENT_RE
    })]
  };
  return {
    name: '1C:Enterprise',
    case_insensitive: true,
    keywords: {
      $pattern: UNDERSCORE_IDENT_RE,
      keyword: KEYWORD,
      built_in: BUILTIN,
      class: CLASS,
      type: TYPE,
      literal: LITERAL
    },
    contains: [META, FUNCTION, COMMENTS, SYMBOL, NUMBERS, STRINGS, DATE]
  };
}
module.exports = _1c;

/***/ }),

/***/ 84749:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/*
Language: Augmented Backus-Naur Form
Author: Alex McKibben <alex@nullscope.net>
Website: https://tools.ietf.org/html/rfc5234
Audit: 2020
*/

/** @type LanguageFn */
function abnf(hljs) {
  var regexes = {
    ruleDeclaration: /^[a-zA-Z][a-zA-Z0-9-]*/,
    unexpectedChars: /[!@#$^&',?+~`|:]/
  };
  var keywords = ["ALPHA", "BIT", "CHAR", "CR", "CRLF", "CTL", "DIGIT", "DQUOTE", "HEXDIG", "HTAB", "LF", "LWSP", "OCTET", "SP", "VCHAR", "WSP"];
  var commentMode = hljs.COMMENT(/;/, /$/);
  var terminalBinaryMode = {
    className: "symbol",
    begin: /%b[0-1]+(-[0-1]+|(\.[0-1]+)+){0,1}/
  };
  var terminalDecimalMode = {
    className: "symbol",
    begin: /%d[0-9]+(-[0-9]+|(\.[0-9]+)+){0,1}/
  };
  var terminalHexadecimalMode = {
    className: "symbol",
    begin: /%x[0-9A-F]+(-[0-9A-F]+|(\.[0-9A-F]+)+){0,1}/
  };
  var caseSensitivityIndicatorMode = {
    className: "symbol",
    begin: /%[si]/
  };
  var ruleDeclarationMode = {
    className: "attribute",
    begin: concat(regexes.ruleDeclaration, /(?=\s*=)/)
  };
  return {
    name: 'Augmented Backus-Naur Form',
    illegal: regexes.unexpectedChars,
    keywords: keywords,
    contains: [ruleDeclarationMode, commentMode, terminalBinaryMode, terminalDecimalMode, terminalHexadecimalMode, caseSensitivityIndicatorMode, hljs.QUOTE_STRING_MODE, hljs.NUMBER_MODE]
  };
}
module.exports = abnf;

/***/ }),

/***/ 44953:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */
function either() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var joined = '(' + args.map(function (x) {
    return source(x);
  }).join("|") + ")";
  return joined;
}

/*
 Language: Apache Access Log
 Author: Oleg Efimov <efimovov@gmail.com>
 Description: Apache/Nginx Access Logs
 Website: https://httpd.apache.org/docs/2.4/logs.html#accesslog
 Audit: 2020
 */

/** @type LanguageFn */
function accesslog(_hljs) {
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Methods
  var HTTP_VERBS = ["GET", "POST", "HEAD", "PUT", "DELETE", "CONNECT", "OPTIONS", "PATCH", "TRACE"];
  return {
    name: 'Apache Access Log',
    contains: [
    // IP
    {
      className: 'number',
      begin: /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}(:\d{1,5})?\b/,
      relevance: 5
    },
    // Other numbers
    {
      className: 'number',
      begin: /\b\d+\b/,
      relevance: 0
    },
    // Requests
    {
      className: 'string',
      begin: concat(/"/, either.apply(void 0, HTTP_VERBS)),
      end: /"/,
      keywords: HTTP_VERBS,
      illegal: /\n/,
      relevance: 5,
      contains: [{
        begin: /HTTP\/[12]\.\d'/,
        relevance: 5
      }]
    },
    // Dates
    {
      className: 'string',
      // dates must have a certain length, this prevents matching
      // simple array accesses a[123] and [] and other common patterns
      // found in other languages
      begin: /\[\d[^\]\n]{8,}\]/,
      illegal: /\n/,
      relevance: 1
    }, {
      className: 'string',
      begin: /\[/,
      end: /\]/,
      illegal: /\n/,
      relevance: 0
    },
    // User agent / relevance boost
    {
      className: 'string',
      begin: /"Mozilla\/\d\.\d \(/,
      end: /"/,
      illegal: /\n/,
      relevance: 3
    },
    // Strings
    {
      className: 'string',
      begin: /"/,
      end: /"/,
      illegal: /\n/,
      relevance: 0
    }]
  };
}
module.exports = accesslog;

/***/ }),

/***/ 6453:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/*
Language: ActionScript
Author: Alexander Myadzel <myadzel@gmail.com>
Category: scripting
Audit: 2020
*/

/** @type LanguageFn */
function actionscript(hljs) {
  var IDENT_RE = /[a-zA-Z_$][a-zA-Z0-9_$]*/;
  var IDENT_FUNC_RETURN_TYPE_RE = /([*]|[a-zA-Z_$][a-zA-Z0-9_$]*)/;
  var AS3_REST_ARG_MODE = {
    className: 'rest_arg',
    begin: /[.]{3}/,
    end: IDENT_RE,
    relevance: 10
  };
  return {
    name: 'ActionScript',
    aliases: ['as'],
    keywords: {
      keyword: 'as break case catch class const continue default delete do dynamic each ' + 'else extends final finally for function get if implements import in include ' + 'instanceof interface internal is namespace native new override package private ' + 'protected public return set static super switch this throw try typeof use var void ' + 'while with',
      literal: 'true false null undefined'
    },
    contains: [hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.C_NUMBER_MODE, {
      className: 'class',
      beginKeywords: 'package',
      end: /\{/,
      contains: [hljs.TITLE_MODE]
    }, {
      className: 'class',
      beginKeywords: 'class interface',
      end: /\{/,
      excludeEnd: true,
      contains: [{
        beginKeywords: 'extends implements'
      }, hljs.TITLE_MODE]
    }, {
      className: 'meta',
      beginKeywords: 'import include',
      end: /;/,
      keywords: {
        'meta-keyword': 'import include'
      }
    }, {
      className: 'function',
      beginKeywords: 'function',
      end: /[{;]/,
      excludeEnd: true,
      illegal: /\S/,
      contains: [hljs.TITLE_MODE, {
        className: 'params',
        begin: /\(/,
        end: /\)/,
        contains: [hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, AS3_REST_ARG_MODE]
      }, {
        begin: concat(/:\s*/, IDENT_FUNC_RETURN_TYPE_RE)
      }]
    }, hljs.METHOD_GUARD],
    illegal: /#/
  };
}
module.exports = actionscript;

/***/ }),

/***/ 74580:
/***/ ((module) => {

/*
Language: Ada
Author: Lars Schulna <kartoffelbrei.mit.muskatnuss@gmail.org>
Description: Ada is a general-purpose programming language that has great support for saftey critical and real-time applications.
             It has been developed by the DoD and thus has been used in military and safety-critical applications (like civil aviation).
             The first version appeared in the 80s, but it's still actively developed today with
             the newest standard being Ada2012.
*/

// We try to support full Ada2012
//
// We highlight all appearances of types, keywords, literals (string, char, number, bool)
// and titles (user defined function/procedure/package)
// CSS classes are set accordingly
//
// Languages causing problems for language detection:
// xml (broken by Foo : Bar type), elm (broken by Foo : Bar type), vbscript-html (broken by body keyword)
// sql (ada default.txt has a lot of sql keywords)

/** @type LanguageFn */
function ada(hljs) {
  // Regular expression for Ada numeric literals.
  // stolen form the VHDL highlighter

  // Decimal literal:
  var INTEGER_RE = '\\d(_|\\d)*';
  var EXPONENT_RE = '[eE][-+]?' + INTEGER_RE;
  var DECIMAL_LITERAL_RE = INTEGER_RE + '(\\.' + INTEGER_RE + ')?' + '(' + EXPONENT_RE + ')?';

  // Based literal:
  var BASED_INTEGER_RE = '\\w+';
  var BASED_LITERAL_RE = INTEGER_RE + '#' + BASED_INTEGER_RE + '(\\.' + BASED_INTEGER_RE + ')?' + '#' + '(' + EXPONENT_RE + ')?';
  var NUMBER_RE = '\\b(' + BASED_LITERAL_RE + '|' + DECIMAL_LITERAL_RE + ')';

  // Identifier regex
  var ID_REGEX = '[A-Za-z](_?[A-Za-z0-9.])*';

  // bad chars, only allowed in literals
  var BAD_CHARS = "[]\\{\\}%#'\"";

  // Ada doesn't have block comments, only line comments
  var COMMENTS = hljs.COMMENT('--', '$');

  // variable declarations of the form
  // Foo : Bar := Baz;
  // where only Bar will be highlighted
  var VAR_DECLS = {
    // TODO: These spaces are not required by the Ada syntax
    // however, I have yet to see handwritten Ada code where
    // someone does not put spaces around :
    begin: '\\s+:\\s+',
    end: '\\s*(:=|;|\\)|=>|$)',
    // endsWithParent: true,
    // returnBegin: true,
    illegal: BAD_CHARS,
    contains: [{
      // workaround to avoid highlighting
      // named loops and declare blocks
      beginKeywords: 'loop for declare others',
      endsParent: true
    }, {
      // properly highlight all modifiers
      className: 'keyword',
      beginKeywords: 'not null constant access function procedure in out aliased exception'
    }, {
      className: 'type',
      begin: ID_REGEX,
      endsParent: true,
      relevance: 0
    }]
  };
  return {
    name: 'Ada',
    case_insensitive: true,
    keywords: {
      keyword: 'abort else new return abs elsif not reverse abstract end ' + 'accept entry select access exception of separate aliased exit or some ' + 'all others subtype and for out synchronized array function overriding ' + 'at tagged generic package task begin goto pragma terminate ' + 'body private then if procedure type case in protected constant interface ' + 'is raise use declare range delay limited record when delta loop rem while ' + 'digits renames with do mod requeue xor',
      literal: 'True False'
    },
    contains: [COMMENTS,
    // strings "foobar"
    {
      className: 'string',
      begin: /"/,
      end: /"/,
      contains: [{
        begin: /""/,
        relevance: 0
      }]
    },
    // characters ''
    {
      // character literals always contain one char
      className: 'string',
      begin: /'.'/
    }, {
      // number literals
      className: 'number',
      begin: NUMBER_RE,
      relevance: 0
    }, {
      // Attributes
      className: 'symbol',
      begin: "'" + ID_REGEX
    }, {
      // package definition, maybe inside generic
      className: 'title',
      begin: '(\\bwith\\s+)?(\\bprivate\\s+)?\\bpackage\\s+(\\bbody\\s+)?',
      end: '(is|$)',
      keywords: 'package body',
      excludeBegin: true,
      excludeEnd: true,
      illegal: BAD_CHARS
    }, {
      // function/procedure declaration/definition
      // maybe inside generic
      begin: '(\\b(with|overriding)\\s+)?\\b(function|procedure)\\s+',
      end: '(\\bis|\\bwith|\\brenames|\\)\\s*;)',
      keywords: 'overriding function procedure with is renames return',
      // we need to re-match the 'function' keyword, so that
      // the title mode below matches only exactly once
      returnBegin: true,
      contains: [COMMENTS, {
        // name of the function/procedure
        className: 'title',
        begin: '(\\bwith\\s+)?\\b(function|procedure)\\s+',
        end: '(\\(|\\s+|$)',
        excludeBegin: true,
        excludeEnd: true,
        illegal: BAD_CHARS
      },
      // 'self'
      // // parameter types
      VAR_DECLS, {
        // return type
        className: 'type',
        begin: '\\breturn\\s+',
        end: '(\\s+|;|$)',
        keywords: 'return',
        excludeBegin: true,
        excludeEnd: true,
        // we are done with functions
        endsParent: true,
        illegal: BAD_CHARS
      }]
    }, {
      // new type declarations
      // maybe inside generic
      className: 'type',
      begin: '\\b(sub)?type\\s+',
      end: '\\s+',
      keywords: 'type',
      excludeBegin: true,
      illegal: BAD_CHARS
    },
    // see comment above the definition
    VAR_DECLS

    // no markup
    // relevance boosters for small snippets
    // {begin: '\\s*=>\\s*'},
    // {begin: '\\s*:=\\s*'},
    // {begin: '\\s+:=\\s+'},
    ]
  };
}

module.exports = ada;

/***/ }),

/***/ 45653:
/***/ ((module) => {

/*
Language: AngelScript
Author: Melissa Geels <melissa@nimble.tools>
Category: scripting
Website: https://www.angelcode.com/angelscript/
*/

/** @type LanguageFn */
function angelscript(hljs) {
  var builtInTypeMode = {
    className: 'built_in',
    begin: '\\b(void|bool|int|int8|int16|int32|int64|uint|uint8|uint16|uint32|uint64|string|ref|array|double|float|auto|dictionary)'
  };
  var objectHandleMode = {
    className: 'symbol',
    begin: '[a-zA-Z0-9_]+@'
  };
  var genericMode = {
    className: 'keyword',
    begin: '<',
    end: '>',
    contains: [builtInTypeMode, objectHandleMode]
  };
  builtInTypeMode.contains = [genericMode];
  objectHandleMode.contains = [genericMode];
  return {
    name: 'AngelScript',
    aliases: ['asc'],
    keywords: 'for in|0 break continue while do|0 return if else case switch namespace is cast ' + 'or and xor not get|0 in inout|10 out override set|0 private public const default|0 ' + 'final shared external mixin|10 enum typedef funcdef this super import from interface ' + 'abstract|0 try catch protected explicit property',
    // avoid close detection with C# and JS
    illegal: '(^using\\s+[A-Za-z0-9_\\.]+;$|\\bfunction\\s*[^\\(])',
    contains: [{
      // 'strings'
      className: 'string',
      begin: '\'',
      end: '\'',
      illegal: '\\n',
      contains: [hljs.BACKSLASH_ESCAPE],
      relevance: 0
    },
    // """heredoc strings"""
    {
      className: 'string',
      begin: '"""',
      end: '"""'
    }, {
      // "strings"
      className: 'string',
      begin: '"',
      end: '"',
      illegal: '\\n',
      contains: [hljs.BACKSLASH_ESCAPE],
      relevance: 0
    }, hljs.C_LINE_COMMENT_MODE,
    // single-line comments
    hljs.C_BLOCK_COMMENT_MODE,
    // comment blocks

    {
      // metadata
      className: 'string',
      begin: '^\\s*\\[',
      end: '\\]'
    }, {
      // interface or namespace declaration
      beginKeywords: 'interface namespace',
      end: /\{/,
      illegal: '[;.\\-]',
      contains: [{
        // interface or namespace name
        className: 'symbol',
        begin: '[a-zA-Z0-9_]+'
      }]
    }, {
      // class declaration
      beginKeywords: 'class',
      end: /\{/,
      illegal: '[;.\\-]',
      contains: [{
        // class name
        className: 'symbol',
        begin: '[a-zA-Z0-9_]+',
        contains: [{
          begin: '[:,]\\s*',
          contains: [{
            className: 'symbol',
            begin: '[a-zA-Z0-9_]+'
          }]
        }]
      }]
    }, builtInTypeMode,
    // built-in types
    objectHandleMode,
    // object handles

    {
      // literals
      className: 'literal',
      begin: '\\b(null|true|false)'
    }, {
      // numbers
      className: 'number',
      relevance: 0,
      begin: '(-?)(\\b0[xXbBoOdD][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?f?|\\.\\d+f?)([eE][-+]?\\d+f?)?)'
    }]
  };
}
module.exports = angelscript;

/***/ }),

/***/ 1676:
/***/ ((module) => {

/*
Language: Apache config
Author: Ruslan Keba <rukeba@gmail.com>
Contributors: Ivan Sagalaev <maniac@softwaremaniacs.org>
Website: https://httpd.apache.org
Description: language definition for Apache configuration files (httpd.conf & .htaccess)
Category: common, config
Audit: 2020
*/

/** @type LanguageFn */
function apache(hljs) {
  var NUMBER_REF = {
    className: 'number',
    begin: /[$%]\d+/
  };
  var NUMBER = {
    className: 'number',
    begin: /\d+/
  };
  var IP_ADDRESS = {
    className: "number",
    begin: /\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}(:\d{1,5})?/
  };
  var PORT_NUMBER = {
    className: "number",
    begin: /:\d{1,5}/
  };
  return {
    name: 'Apache config',
    aliases: ['apacheconf'],
    case_insensitive: true,
    contains: [hljs.HASH_COMMENT_MODE, {
      className: 'section',
      begin: /<\/?/,
      end: />/,
      contains: [IP_ADDRESS, PORT_NUMBER,
      // low relevance prevents us from claming XML/HTML where this rule would
      // match strings inside of XML tags
      hljs.inherit(hljs.QUOTE_STRING_MODE, {
        relevance: 0
      })]
    }, {
      className: 'attribute',
      begin: /\w+/,
      relevance: 0,
      // keywords aren’t needed for highlighting per se, they only boost relevance
      // for a very generally defined mode (starts with a word, ends with line-end
      keywords: {
        nomarkup: 'order deny allow setenv rewriterule rewriteengine rewritecond documentroot ' + 'sethandler errordocument loadmodule options header listen serverroot ' + 'servername'
      },
      starts: {
        end: /$/,
        relevance: 0,
        keywords: {
          literal: 'on off all deny allow'
        },
        contains: [{
          className: 'meta',
          begin: /\s\[/,
          end: /\]$/
        }, {
          className: 'variable',
          begin: /[\$%]\{/,
          end: /\}/,
          contains: ['self', NUMBER_REF]
        }, IP_ADDRESS, NUMBER, hljs.QUOTE_STRING_MODE]
      }
    }],
    illegal: /\S/
  };
}
module.exports = apache;

/***/ }),

/***/ 16700:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(92222);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */
function either() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var joined = '(' + args.map(function (x) {
    return source(x);
  }).join("|") + ")";
  return joined;
}

/*
Language: AppleScript
Authors: Nathan Grigg <nathan@nathanamy.org>, Dr. Drang <drdrang@gmail.com>
Category: scripting
Website: https://developer.apple.com/library/archive/documentation/AppleScript/Conceptual/AppleScriptLangGuide/introduction/ASLR_intro.html
Audit: 2020
*/

/** @type LanguageFn */
function applescript(hljs) {
  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {
    illegal: null
  });
  var PARAMS = {
    className: 'params',
    begin: /\(/,
    end: /\)/,
    contains: ['self', hljs.C_NUMBER_MODE, STRING]
  };
  var COMMENT_MODE_1 = hljs.COMMENT(/--/, /$/);
  var COMMENT_MODE_2 = hljs.COMMENT(/\(\*/, /\*\)/, {
    contains: ['self',
    // allow nesting
    COMMENT_MODE_1]
  });
  var COMMENTS = [COMMENT_MODE_1, COMMENT_MODE_2, hljs.HASH_COMMENT_MODE];
  var KEYWORD_PATTERNS = [/apart from/, /aside from/, /instead of/, /out of/, /greater than/, /isn't|(doesn't|does not) (equal|come before|come after|contain)/, /(greater|less) than( or equal)?/, /(starts?|ends|begins?) with/, /contained by/, /comes (before|after)/, /a (ref|reference)/, /POSIX (file|path)/, /(date|time) string/, /quoted form/];
  var BUILT_IN_PATTERNS = [/clipboard info/, /the clipboard/, /info for/, /list (disks|folder)/, /mount volume/, /path to/, /(close|open for) access/, /(get|set) eof/, /current date/, /do shell script/, /get volume settings/, /random number/, /set volume/, /system attribute/, /system info/, /time to GMT/, /(load|run|store) script/, /scripting components/, /ASCII (character|number)/, /localized string/, /choose (application|color|file|file name|folder|from list|remote application|URL)/, /display (alert|dialog)/];
  return {
    name: 'AppleScript',
    aliases: ['osascript'],
    keywords: {
      keyword: 'about above after against and around as at back before beginning ' + 'behind below beneath beside between but by considering ' + 'contain contains continue copy div does eighth else end equal ' + 'equals error every exit fifth first for fourth from front ' + 'get given global if ignoring in into is it its last local me ' + 'middle mod my ninth not of on onto or over prop property put ref ' + 'reference repeat returning script second set seventh since ' + 'sixth some tell tenth that the|0 then third through thru ' + 'timeout times to transaction try until where while whose with ' + 'without',
      literal: 'AppleScript false linefeed return pi quote result space tab true',
      built_in: 'alias application boolean class constant date file integer list ' + 'number real record string text ' + 'activate beep count delay launch log offset read round ' + 'run say summarize write ' + 'character characters contents day frontmost id item length ' + 'month name paragraph paragraphs rest reverse running time version ' + 'weekday word words year'
    },
    contains: [STRING, hljs.C_NUMBER_MODE, {
      className: 'built_in',
      begin: concat(/\b/, either.apply(void 0, BUILT_IN_PATTERNS), /\b/)
    }, {
      className: 'built_in',
      begin: /^\s*return\b/
    }, {
      className: 'literal',
      begin: /\b(text item delimiters|current application|missing value)\b/
    }, {
      className: 'keyword',
      begin: concat(/\b/, either.apply(void 0, KEYWORD_PATTERNS), /\b/)
    }, {
      beginKeywords: 'on',
      illegal: /[${=;\n]/,
      contains: [hljs.UNDERSCORE_TITLE_MODE, PARAMS]
    }].concat(COMMENTS),
    illegal: /\/\/|->|=>|\[\[/
  };
}
module.exports = applescript;

/***/ }),

/***/ 15143:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
/*
 Language: ArcGIS Arcade
 Category: scripting
 Author: John Foster <jfoster@esri.com>
 Website: https://developers.arcgis.com/arcade/
 Description: ArcGIS Arcade is an expression language used in many Esri ArcGIS products such as Pro, Online, Server, Runtime, JavaScript, and Python
*/

/** @type LanguageFn */
function arcade(hljs) {
  var IDENT_RE = '[A-Za-z_][0-9A-Za-z_]*';
  var KEYWORDS = {
    keyword: 'if for while var new function do return void else break',
    literal: 'BackSlash DoubleQuote false ForwardSlash Infinity NaN NewLine null PI SingleQuote Tab TextFormatting true undefined',
    built_in: 'Abs Acos Angle Attachments Area AreaGeodetic Asin Atan Atan2 Average Bearing Boolean Buffer BufferGeodetic ' + 'Ceil Centroid Clip Console Constrain Contains Cos Count Crosses Cut Date DateAdd ' + 'DateDiff Day Decode DefaultValue Dictionary Difference Disjoint Distance DistanceGeodetic Distinct ' + 'DomainCode DomainName Equals Exp Extent Feature FeatureSet FeatureSetByAssociation FeatureSetById FeatureSetByPortalItem ' + 'FeatureSetByRelationshipName FeatureSetByTitle FeatureSetByUrl Filter First Floor Geometry GroupBy Guid HasKey Hour IIf IndexOf ' + 'Intersection Intersects IsEmpty IsNan IsSelfIntersecting Length LengthGeodetic Log Max Mean Millisecond Min Minute Month ' + 'MultiPartToSinglePart Multipoint NextSequenceValue Now Number OrderBy Overlaps Point Polygon ' + 'Polyline Portal Pow Random Relate Reverse RingIsClockWise Round Second SetGeometry Sin Sort Sqrt Stdev Sum ' + 'SymmetricDifference Tan Text Timestamp Today ToLocal Top Touches ToUTC TrackCurrentTime ' + 'TrackGeometryWindow TrackIndex TrackStartTime TrackWindow TypeOf Union UrlEncode Variance ' + 'Weekday When Within Year '
  };
  var SYMBOL = {
    className: 'symbol',
    begin: '\\$[datastore|feature|layer|map|measure|sourcefeature|sourcelayer|targetfeature|targetlayer|value|view]+'
  };
  var NUMBER = {
    className: 'number',
    variants: [{
      begin: '\\b(0[bB][01]+)'
    }, {
      begin: '\\b(0[oO][0-7]+)'
    }, {
      begin: hljs.C_NUMBER_RE
    }],
    relevance: 0
  };
  var SUBST = {
    className: 'subst',
    begin: '\\$\\{',
    end: '\\}',
    keywords: KEYWORDS,
    contains: [] // defined later
  };

  var TEMPLATE_STRING = {
    className: 'string',
    begin: '`',
    end: '`',
    contains: [hljs.BACKSLASH_ESCAPE, SUBST]
  };
  SUBST.contains = [hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, TEMPLATE_STRING, NUMBER, hljs.REGEXP_MODE];
  var PARAMS_CONTAINS = SUBST.contains.concat([hljs.C_BLOCK_COMMENT_MODE, hljs.C_LINE_COMMENT_MODE]);
  return {
    name: 'ArcGIS Arcade',
    keywords: KEYWORDS,
    contains: [hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, TEMPLATE_STRING, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, SYMBOL, NUMBER, {
      // object attr container
      begin: /[{,]\s*/,
      relevance: 0,
      contains: [{
        begin: IDENT_RE + '\\s*:',
        returnBegin: true,
        relevance: 0,
        contains: [{
          className: 'attr',
          begin: IDENT_RE,
          relevance: 0
        }]
      }]
    }, {
      // "value" container
      begin: '(' + hljs.RE_STARTERS_RE + '|\\b(return)\\b)\\s*',
      keywords: 'return',
      contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.REGEXP_MODE, {
        className: 'function',
        begin: '(\\(.*?\\)|' + IDENT_RE + ')\\s*=>',
        returnBegin: true,
        end: '\\s*=>',
        contains: [{
          className: 'params',
          variants: [{
            begin: IDENT_RE
          }, {
            begin: /\(\s*\)/
          }, {
            begin: /\(/,
            end: /\)/,
            excludeBegin: true,
            excludeEnd: true,
            keywords: KEYWORDS,
            contains: PARAMS_CONTAINS
          }]
        }]
      }],
      relevance: 0
    }, {
      className: 'function',
      beginKeywords: 'function',
      end: /\{/,
      excludeEnd: true,
      contains: [hljs.inherit(hljs.TITLE_MODE, {
        begin: IDENT_RE
      }), {
        className: 'params',
        begin: /\(/,
        end: /\)/,
        excludeBegin: true,
        excludeEnd: true,
        contains: PARAMS_CONTAINS
      }],
      illegal: /\[|%/
    }, {
      begin: /\$[(.]/
    }],
    illegal: /#(?!!)/
  };
}
module.exports = arcade;

/***/ }),

/***/ 3720:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(92222);
__webpack_require__(68309);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function lookahead(re) {
  return concat('(?=', re, ')');
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function optional(re) {
  return concat('(', re, ')?');
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/*
Language: C++
Category: common, system
Website: https://isocpp.org
*/

/** @type LanguageFn */
function cPlusPlus(hljs) {
  // added for historic reasons because `hljs.C_LINE_COMMENT_MODE` does
  // not include such support nor can we be sure all the grammars depending
  // on it would desire this behavior
  var C_LINE_COMMENT_MODE = hljs.COMMENT('//', '$', {
    contains: [{
      begin: /\\\n/
    }]
  });
  var DECLTYPE_AUTO_RE = 'decltype\\(auto\\)';
  var NAMESPACE_RE = '[a-zA-Z_]\\w*::';
  var TEMPLATE_ARGUMENT_RE = '<[^<>]+>';
  var FUNCTION_TYPE_RE = '(' + DECLTYPE_AUTO_RE + '|' + optional(NAMESPACE_RE) + '[a-zA-Z_]\\w*' + optional(TEMPLATE_ARGUMENT_RE) + ')';
  var CPP_PRIMITIVE_TYPES = {
    className: 'keyword',
    begin: '\\b[a-z\\d_]*_t\\b'
  };

  // https://en.cppreference.com/w/cpp/language/escape
  // \\ \x \xFF \u2837 \u00323747 \374
  var CHARACTER_ESCAPES = '\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)';
  var STRINGS = {
    className: 'string',
    variants: [{
      begin: '(u8?|U|L)?"',
      end: '"',
      illegal: '\\n',
      contains: [hljs.BACKSLASH_ESCAPE]
    }, {
      begin: '(u8?|U|L)?\'(' + CHARACTER_ESCAPES + "|.)",
      end: '\'',
      illegal: '.'
    }, hljs.END_SAME_AS_BEGIN({
      begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
      end: /\)([^()\\ ]{0,16})"/
    })]
  };
  var NUMBERS = {
    className: 'number',
    variants: [{
      begin: '\\b(0b[01\']+)'
    }, {
      begin: '(-?)\\b([\\d\']+(\\.[\\d\']*)?|\\.[\\d\']+)((ll|LL|l|L)(u|U)?|(u|U)(ll|LL|l|L)?|f|F|b|B)'
    }, {
      begin: '(-?)(\\b0[xX][a-fA-F0-9\']+|(\\b[\\d\']+(\\.[\\d\']*)?|\\.[\\d\']+)([eE][-+]?[\\d\']+)?)'
    }],
    relevance: 0
  };
  var PREPROCESSOR = {
    className: 'meta',
    begin: /#\s*[a-z]+\b/,
    end: /$/,
    keywords: {
      'meta-keyword': 'if else elif endif define undef warning error line ' + 'pragma _Pragma ifdef ifndef include'
    },
    contains: [{
      begin: /\\\n/,
      relevance: 0
    }, hljs.inherit(STRINGS, {
      className: 'meta-string'
    }), {
      className: 'meta-string',
      begin: /<.*?>/
    }, C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE]
  };
  var TITLE_MODE = {
    className: 'title',
    begin: optional(NAMESPACE_RE) + hljs.IDENT_RE,
    relevance: 0
  };
  var FUNCTION_TITLE = optional(NAMESPACE_RE) + hljs.IDENT_RE + '\\s*\\(';
  var COMMON_CPP_HINTS = ['asin', 'atan2', 'atan', 'calloc', 'ceil', 'cosh', 'cos', 'exit', 'exp', 'fabs', 'floor', 'fmod', 'fprintf', 'fputs', 'free', 'frexp', 'auto_ptr', 'deque', 'list', 'queue', 'stack', 'vector', 'map', 'set', 'pair', 'bitset', 'multiset', 'multimap', 'unordered_set', 'fscanf', 'future', 'isalnum', 'isalpha', 'iscntrl', 'isdigit', 'isgraph', 'islower', 'isprint', 'ispunct', 'isspace', 'isupper', 'isxdigit', 'tolower', 'toupper', 'labs', 'ldexp', 'log10', 'log', 'malloc', 'realloc', 'memchr', 'memcmp', 'memcpy', 'memset', 'modf', 'pow', 'printf', 'putchar', 'puts', 'scanf', 'sinh', 'sin', 'snprintf', 'sprintf', 'sqrt', 'sscanf', 'strcat', 'strchr', 'strcmp', 'strcpy', 'strcspn', 'strlen', 'strncat', 'strncmp', 'strncpy', 'strpbrk', 'strrchr', 'strspn', 'strstr', 'tanh', 'tan', 'unordered_map', 'unordered_multiset', 'unordered_multimap', 'priority_queue', 'make_pair', 'array', 'shared_ptr', 'abort', 'terminate', 'abs', 'acos', 'vfprintf', 'vprintf', 'vsprintf', 'endl', 'initializer_list', 'unique_ptr', 'complex', 'imaginary', 'std', 'string', 'wstring', 'cin', 'cout', 'cerr', 'clog', 'stdin', 'stdout', 'stderr', 'stringstream', 'istringstream', 'ostringstream'];
  var CPP_KEYWORDS = {
    keyword: 'int float while private char char8_t char16_t char32_t catch import module export virtual operator sizeof ' + 'dynamic_cast|10 typedef const_cast|10 const for static_cast|10 union namespace ' + 'unsigned long volatile static protected bool template mutable if public friend ' + 'do goto auto void enum else break extern using asm case typeid wchar_t ' + 'short reinterpret_cast|10 default double register explicit signed typename try this ' + 'switch continue inline delete alignas alignof constexpr consteval constinit decltype ' + 'concept co_await co_return co_yield requires ' + 'noexcept static_assert thread_local restrict final override ' + 'atomic_bool atomic_char atomic_schar ' + 'atomic_uchar atomic_short atomic_ushort atomic_int atomic_uint atomic_long atomic_ulong atomic_llong ' + 'atomic_ullong new throw return ' + 'and and_eq bitand bitor compl not not_eq or or_eq xor xor_eq',
    built_in: '_Bool _Complex _Imaginary',
    _relevance_hints: COMMON_CPP_HINTS,
    literal: 'true false nullptr NULL'
  };
  var FUNCTION_DISPATCH = {
    className: "function.dispatch",
    relevance: 0,
    keywords: CPP_KEYWORDS,
    begin: concat(/\b/, /(?!decltype)/, /(?!if)/, /(?!for)/, /(?!while)/, hljs.IDENT_RE, lookahead(/\s*\(/))
  };
  var EXPRESSION_CONTAINS = [FUNCTION_DISPATCH, PREPROCESSOR, CPP_PRIMITIVE_TYPES, C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, NUMBERS, STRINGS];
  var EXPRESSION_CONTEXT = {
    // This mode covers expression context where we can't expect a function
    // definition and shouldn't highlight anything that looks like one:
    // `return some()`, `else if()`, `(x*sum(1, 2))`
    variants: [{
      begin: /=/,
      end: /;/
    }, {
      begin: /\(/,
      end: /\)/
    }, {
      beginKeywords: 'new throw return else',
      end: /;/
    }],
    keywords: CPP_KEYWORDS,
    contains: EXPRESSION_CONTAINS.concat([{
      begin: /\(/,
      end: /\)/,
      keywords: CPP_KEYWORDS,
      contains: EXPRESSION_CONTAINS.concat(['self']),
      relevance: 0
    }]),
    relevance: 0
  };
  var FUNCTION_DECLARATION = {
    className: 'function',
    begin: '(' + FUNCTION_TYPE_RE + '[\\*&\\s]+)+' + FUNCTION_TITLE,
    returnBegin: true,
    end: /[{;=]/,
    excludeEnd: true,
    keywords: CPP_KEYWORDS,
    illegal: /[^\w\s\*&:<>.]/,
    contains: [{
      // to prevent it from being confused as the function title
      begin: DECLTYPE_AUTO_RE,
      keywords: CPP_KEYWORDS,
      relevance: 0
    }, {
      begin: FUNCTION_TITLE,
      returnBegin: true,
      contains: [TITLE_MODE],
      relevance: 0
    },
    // needed because we do not have look-behind on the below rule
    // to prevent it from grabbing the final : in a :: pair
    {
      begin: /::/,
      relevance: 0
    },
    // initializers
    {
      begin: /:/,
      endsWithParent: true,
      contains: [STRINGS, NUMBERS]
    }, {
      className: 'params',
      begin: /\(/,
      end: /\)/,
      keywords: CPP_KEYWORDS,
      relevance: 0,
      contains: [C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, STRINGS, NUMBERS, CPP_PRIMITIVE_TYPES,
      // Count matching parentheses.
      {
        begin: /\(/,
        end: /\)/,
        keywords: CPP_KEYWORDS,
        relevance: 0,
        contains: ['self', C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, STRINGS, NUMBERS, CPP_PRIMITIVE_TYPES]
      }]
    }, CPP_PRIMITIVE_TYPES, C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, PREPROCESSOR]
  };
  return {
    name: 'C++',
    aliases: ['cc', 'c++', 'h++', 'hpp', 'hh', 'hxx', 'cxx'],
    keywords: CPP_KEYWORDS,
    illegal: '</',
    classNameAliases: {
      "function.dispatch": "built_in"
    },
    contains: [].concat(EXPRESSION_CONTEXT, FUNCTION_DECLARATION, FUNCTION_DISPATCH, EXPRESSION_CONTAINS, [PREPROCESSOR, {
      // containers: ie, `vector <int> rooms (9);`
      begin: '\\b(deque|list|queue|priority_queue|pair|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array)\\s*<',
      end: '>',
      keywords: CPP_KEYWORDS,
      contains: ['self', CPP_PRIMITIVE_TYPES]
    }, {
      begin: hljs.IDENT_RE + '::',
      keywords: CPP_KEYWORDS
    }, {
      className: 'class',
      beginKeywords: 'enum class struct union',
      end: /[{;:<>=]/,
      contains: [{
        beginKeywords: "final class struct"
      }, hljs.TITLE_MODE]
    }]),
    exports: {
      preprocessor: PREPROCESSOR,
      strings: STRINGS,
      keywords: CPP_KEYWORDS
    }
  };
}

/*
Language: Arduino
Author: Stefania Mellai <s.mellai@arduino.cc>
Description: The Arduino® Language is a superset of C++. This rules are designed to highlight the Arduino® source code. For info about language see http://www.arduino.cc.
Website: https://www.arduino.cc
*/

/** @type LanguageFn */
function arduino(hljs) {
  var ARDUINO_KW = {
    keyword: 'boolean byte word String',
    built_in: 'KeyboardController MouseController SoftwareSerial ' + 'EthernetServer EthernetClient LiquidCrystal ' + 'RobotControl GSMVoiceCall EthernetUDP EsploraTFT ' + 'HttpClient RobotMotor WiFiClient GSMScanner ' + 'FileSystem Scheduler GSMServer YunClient YunServer ' + 'IPAddress GSMClient GSMModem Keyboard Ethernet ' + 'Console GSMBand Esplora Stepper Process ' + 'WiFiUDP GSM_SMS Mailbox USBHost Firmata PImage ' + 'Client Server GSMPIN FileIO Bridge Serial ' + 'EEPROM Stream Mouse Audio Servo File Task ' + 'GPRS WiFi Wire TFT GSM SPI SD ',
    _: 'setup loop ' + 'runShellCommandAsynchronously analogWriteResolution ' + 'retrieveCallingNumber printFirmwareVersion ' + 'analogReadResolution sendDigitalPortPair ' + 'noListenOnLocalhost readJoystickButton setFirmwareVersion ' + 'readJoystickSwitch scrollDisplayRight getVoiceCallStatus ' + 'scrollDisplayLeft writeMicroseconds delayMicroseconds ' + 'beginTransmission getSignalStrength runAsynchronously ' + 'getAsynchronously listenOnLocalhost getCurrentCarrier ' + 'readAccelerometer messageAvailable sendDigitalPorts ' + 'lineFollowConfig countryNameWrite runShellCommand ' + 'readStringUntil rewindDirectory readTemperature ' + 'setClockDivider readLightSensor endTransmission ' + 'analogReference detachInterrupt countryNameRead ' + 'attachInterrupt encryptionType readBytesUntil ' + 'robotNameWrite readMicrophone robotNameRead cityNameWrite ' + 'userNameWrite readJoystickY readJoystickX mouseReleased ' + 'openNextFile scanNetworks noInterrupts digitalWrite ' + 'beginSpeaker mousePressed isActionDone mouseDragged ' + 'displayLogos noAutoscroll addParameter remoteNumber ' + 'getModifiers keyboardRead userNameRead waitContinue ' + 'processInput parseCommand printVersion readNetworks ' + 'writeMessage blinkVersion cityNameRead readMessage ' + 'setDataMode parsePacket isListening setBitOrder ' + 'beginPacket isDirectory motorsWrite drawCompass ' + 'digitalRead clearScreen serialEvent rightToLeft ' + 'setTextSize leftToRight requestFrom keyReleased ' + 'compassRead analogWrite interrupts WiFiServer ' + 'disconnect playMelody parseFloat autoscroll ' + 'getPINUsed setPINUsed setTimeout sendAnalog ' + 'readSlider analogRead beginWrite createChar ' + 'motorsStop keyPressed tempoWrite readButton ' + 'subnetMask debugPrint macAddress writeGreen ' + 'randomSeed attachGPRS readString sendString ' + 'remotePort releaseAll mouseMoved background ' + 'getXChange getYChange answerCall getResult ' + 'voiceCall endPacket constrain getSocket writeJSON ' + 'getButton available connected findUntil readBytes ' + 'exitValue readGreen writeBlue startLoop IPAddress ' + 'isPressed sendSysex pauseMode gatewayIP setCursor ' + 'getOemKey tuneWrite noDisplay loadImage switchPIN ' + 'onRequest onReceive changePIN playFile noBuffer ' + 'parseInt overflow checkPIN knobRead beginTFT ' + 'bitClear updateIR bitWrite position writeRGB ' + 'highByte writeRed setSpeed readBlue noStroke ' + 'remoteIP transfer shutdown hangCall beginSMS ' + 'endWrite attached maintain noCursor checkReg ' + 'checkPUK shiftOut isValid shiftIn pulseIn ' + 'connect println localIP pinMode getIMEI ' + 'display noBlink process getBand running beginSD ' + 'drawBMP lowByte setBand release bitRead prepare ' + 'pointTo readRed setMode noFill remove listen ' + 'stroke detach attach noTone exists buffer ' + 'height bitSet circle config cursor random ' + 'IRread setDNS endSMS getKey micros ' + 'millis begin print write ready flush width ' + 'isPIN blink clear press mkdir rmdir close ' + 'point yield image BSSID click delay ' + 'read text move peek beep rect line open ' + 'seek fill size turn stop home find ' + 'step tone sqrt RSSI SSID ' + 'end bit tan cos sin pow map abs max ' + 'min get run put',
    literal: 'DIGITAL_MESSAGE FIRMATA_STRING ANALOG_MESSAGE ' + 'REPORT_DIGITAL REPORT_ANALOG INPUT_PULLUP ' + 'SET_PIN_MODE INTERNAL2V56 SYSTEM_RESET LED_BUILTIN ' + 'INTERNAL1V1 SYSEX_START INTERNAL EXTERNAL ' + 'DEFAULT OUTPUT INPUT HIGH LOW'
  };
  var ARDUINO = cPlusPlus(hljs);
  var kws = ARDUINO.keywords;
  kws.keyword += ' ' + ARDUINO_KW.keyword;
  kws.literal += ' ' + ARDUINO_KW.literal;
  kws.built_in += ' ' + ARDUINO_KW.built_in;
  kws._ += ' ' + ARDUINO_KW._;
  ARDUINO.name = 'Arduino';
  ARDUINO.aliases = ['ino'];
  ARDUINO.supersetOf = "cpp";
  return ARDUINO;
}
module.exports = arduino;

/***/ }),

/***/ 90976:
/***/ ((module) => {

/*
Language: ARM Assembly
Author: Dan Panzarella <alsoelp@gmail.com>
Description: ARM Assembly including Thumb and Thumb2 instructions
Category: assembler
*/

/** @type LanguageFn */
function armasm(hljs) {
  // local labels: %?[FB]?[AT]?\d{1,2}\w+

  var COMMENT = {
    variants: [hljs.COMMENT('^[ \\t]*(?=#)', '$', {
      relevance: 0,
      excludeBegin: true
    }), hljs.COMMENT('[;@]', '$', {
      relevance: 0
    }), hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE]
  };
  return {
    name: 'ARM Assembly',
    case_insensitive: true,
    aliases: ['arm'],
    keywords: {
      $pattern: '\\.?' + hljs.IDENT_RE,
      meta:
      // GNU preprocs
      '.2byte .4byte .align .ascii .asciz .balign .byte .code .data .else .end .endif .endm .endr .equ .err .exitm .extern .global .hword .if .ifdef .ifndef .include .irp .long .macro .rept .req .section .set .skip .space .text .word .arm .thumb .code16 .code32 .force_thumb .thumb_func .ltorg ' +
      // ARM directives
      'ALIAS ALIGN ARM AREA ASSERT ATTR CN CODE CODE16 CODE32 COMMON CP DATA DCB DCD DCDU DCDO DCFD DCFDU DCI DCQ DCQU DCW DCWU DN ELIF ELSE END ENDFUNC ENDIF ENDP ENTRY EQU EXPORT EXPORTAS EXTERN FIELD FILL FUNCTION GBLA GBLL GBLS GET GLOBAL IF IMPORT INCBIN INCLUDE INFO KEEP LCLA LCLL LCLS LTORG MACRO MAP MEND MEXIT NOFP OPT PRESERVE8 PROC QN READONLY RELOC REQUIRE REQUIRE8 RLIST FN ROUT SETA SETL SETS SN SPACE SUBT THUMB THUMBX TTL WHILE WEND ',
      built_in: 'r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 ' +
      // standard registers
      'pc lr sp ip sl sb fp ' +
      // typical regs plus backward compatibility
      'a1 a2 a3 a4 v1 v2 v3 v4 v5 v6 v7 v8 f0 f1 f2 f3 f4 f5 f6 f7 ' +
      // more regs and fp
      'p0 p1 p2 p3 p4 p5 p6 p7 p8 p9 p10 p11 p12 p13 p14 p15 ' +
      // coprocessor regs
      'c0 c1 c2 c3 c4 c5 c6 c7 c8 c9 c10 c11 c12 c13 c14 c15 ' +
      // more coproc
      'q0 q1 q2 q3 q4 q5 q6 q7 q8 q9 q10 q11 q12 q13 q14 q15 ' +
      // advanced SIMD NEON regs

      // program status registers
      'cpsr_c cpsr_x cpsr_s cpsr_f cpsr_cx cpsr_cxs cpsr_xs cpsr_xsf cpsr_sf cpsr_cxsf ' + 'spsr_c spsr_x spsr_s spsr_f spsr_cx spsr_cxs spsr_xs spsr_xsf spsr_sf spsr_cxsf ' +
      // NEON and VFP registers
      's0 s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 ' + 's16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 ' + 'd0 d1 d2 d3 d4 d5 d6 d7 d8 d9 d10 d11 d12 d13 d14 d15 ' + 'd16 d17 d18 d19 d20 d21 d22 d23 d24 d25 d26 d27 d28 d29 d30 d31 ' + '{PC} {VAR} {TRUE} {FALSE} {OPT} {CONFIG} {ENDIAN} {CODESIZE} {CPU} {FPU} {ARCHITECTURE} {PCSTOREOFFSET} {ARMASM_VERSION} {INTER} {ROPI} {RWPI} {SWST} {NOSWST} . @'
    },
    contains: [{
      className: 'keyword',
      begin: '\\b(' +
      // mnemonics
      'adc|' + '(qd?|sh?|u[qh]?)?add(8|16)?|usada?8|(q|sh?|u[qh]?)?(as|sa)x|' + 'and|adrl?|sbc|rs[bc]|asr|b[lx]?|blx|bxj|cbn?z|tb[bh]|bic|' + 'bfc|bfi|[su]bfx|bkpt|cdp2?|clz|clrex|cmp|cmn|cpsi[ed]|cps|' + 'setend|dbg|dmb|dsb|eor|isb|it[te]{0,3}|lsl|lsr|ror|rrx|' + 'ldm(([id][ab])|f[ds])?|ldr((s|ex)?[bhd])?|movt?|mvn|mra|mar|' + 'mul|[us]mull|smul[bwt][bt]|smu[as]d|smmul|smmla|' + 'mla|umlaal|smlal?([wbt][bt]|d)|mls|smlsl?[ds]|smc|svc|sev|' + 'mia([bt]{2}|ph)?|mrr?c2?|mcrr2?|mrs|msr|orr|orn|pkh(tb|bt)|rbit|' + 'rev(16|sh)?|sel|[su]sat(16)?|nop|pop|push|rfe([id][ab])?|' + 'stm([id][ab])?|str(ex)?[bhd]?|(qd?)?sub|(sh?|q|u[qh]?)?sub(8|16)|' + '[su]xt(a?h|a?b(16)?)|srs([id][ab])?|swpb?|swi|smi|tst|teq|' + 'wfe|wfi|yield' + ')' + '(eq|ne|cs|cc|mi|pl|vs|vc|hi|ls|ge|lt|gt|le|al|hs|lo)?' +
      // condition codes
      '[sptrx]?' +
      // legal postfixes
      '(?=\\s)' // followed by space
    }, COMMENT, hljs.QUOTE_STRING_MODE, {
      className: 'string',
      begin: '\'',
      end: '[^\\\\]\'',
      relevance: 0
    }, {
      className: 'title',
      begin: '\\|',
      end: '\\|',
      illegal: '\\n',
      relevance: 0
    }, {
      className: 'number',
      variants: [{
        // hex
        begin: '[#$=]?0x[0-9a-f]+'
      }, {
        // bin
        begin: '[#$=]?0b[01]+'
      }, {
        // literal
        begin: '[#$=]\\d+'
      }, {
        // bare number
        begin: '\\b\\d+'
      }],
      relevance: 0
    }, {
      className: 'symbol',
      variants: [{
        // GNU ARM syntax
        begin: '^[ \\t]*[a-z_\\.\\$][a-z0-9_\\.\\$]+:'
      }, {
        // ARM syntax
        begin: '^[a-z_\\.\\$][a-z0-9_\\.\\$]+'
      }, {
        // label reference
        begin: '[=#]\\w+'
      }],
      relevance: 0
    }]
  };
}
module.exports = armasm;

/***/ }),

/***/ 68759:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(92222);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/*
Language: AsciiDoc
Requires: xml.js
Author: Dan Allen <dan.j.allen@gmail.com>
Website: http://asciidoc.org
Description: A semantic, text-based document format that can be exported to HTML, DocBook and other backends.
Category: markup
*/

/** @type LanguageFn */
function asciidoc(hljs) {
  var HORIZONTAL_RULE = {
    begin: '^\'{3,}[ \\t]*$',
    relevance: 10
  };
  var ESCAPED_FORMATTING = [
  // escaped constrained formatting marks (i.e., \* \_ or \`)
  {
    begin: /\\[*_`]/
  },
  // escaped unconstrained formatting marks (i.e., \\** \\__ or \\``)
  // must ignore until the next formatting marks
  // this rule might not be 100% compliant with Asciidoctor 2.0 but we are entering undefined behavior territory...
  {
    begin: /\\\\\*{2}[^\n]*?\*{2}/
  }, {
    begin: /\\\\_{2}[^\n]*_{2}/
  }, {
    begin: /\\\\`{2}[^\n]*`{2}/
  },
  // guard: constrained formatting mark may not be preceded by ":", ";" or
  // "}". match these so the constrained rule doesn't see them
  {
    begin: /[:;}][*_`](?![*_`])/
  }];
  var STRONG = [
  // inline unconstrained strong (single line)
  {
    className: 'strong',
    begin: /\*{2}([^\n]+?)\*{2}/
  },
  // inline unconstrained strong (multi-line)
  {
    className: 'strong',
    begin: concat(/\*\*/, /((\*(?!\*)|\\[^\n]|[^*\n\\])+\n)+/, /(\*(?!\*)|\\[^\n]|[^*\n\\])*/, /\*\*/),
    relevance: 0
  },
  // inline constrained strong (single line)
  {
    className: 'strong',
    // must not precede or follow a word character
    begin: /\B\*(\S|\S[^\n]*?\S)\*(?!\w)/
  },
  // inline constrained strong (multi-line)
  {
    className: 'strong',
    // must not precede or follow a word character
    begin: /\*[^\s]([^\n]+\n)+([^\n]+)\*/
  }];
  var EMPHASIS = [
  // inline unconstrained emphasis (single line)
  {
    className: 'emphasis',
    begin: /_{2}([^\n]+?)_{2}/
  },
  // inline unconstrained emphasis (multi-line)
  {
    className: 'emphasis',
    begin: concat(/__/, /((_(?!_)|\\[^\n]|[^_\n\\])+\n)+/, /(_(?!_)|\\[^\n]|[^_\n\\])*/, /__/),
    relevance: 0
  },
  // inline constrained emphasis (single line)
  {
    className: 'emphasis',
    // must not precede or follow a word character
    begin: /\b_(\S|\S[^\n]*?\S)_(?!\w)/
  },
  // inline constrained emphasis (multi-line)
  {
    className: 'emphasis',
    // must not precede or follow a word character
    begin: /_[^\s]([^\n]+\n)+([^\n]+)_/
  },
  // inline constrained emphasis using single quote (legacy)
  {
    className: 'emphasis',
    // must not follow a word character or be followed by a single quote or space
    begin: '\\B\'(?![\'\\s])',
    end: '(\\n{2}|\')',
    // allow escaped single quote followed by word char
    contains: [{
      begin: '\\\\\'\\w',
      relevance: 0
    }],
    relevance: 0
  }];
  var ADMONITION = {
    className: 'symbol',
    begin: '^(NOTE|TIP|IMPORTANT|WARNING|CAUTION):\\s+',
    relevance: 10
  };
  var BULLET_LIST = {
    className: 'bullet',
    begin: '^(\\*+|-+|\\.+|[^\\n]+?::)\\s+'
  };
  return {
    name: 'AsciiDoc',
    aliases: ['adoc'],
    contains: [
    // block comment
    hljs.COMMENT('^/{4,}\\n', '\\n/{4,}$',
    // can also be done as...
    // '^/{4,}$',
    // '^/{4,}$',
    {
      relevance: 10
    }),
    // line comment
    hljs.COMMENT('^//', '$', {
      relevance: 0
    }),
    // title
    {
      className: 'title',
      begin: '^\\.\\w.*$'
    },
    // example, admonition & sidebar blocks
    {
      begin: '^[=\\*]{4,}\\n',
      end: '\\n^[=\\*]{4,}$',
      relevance: 10
    },
    // headings
    {
      className: 'section',
      relevance: 10,
      variants: [{
        begin: '^(={1,6})[ \t].+?([ \t]\\1)?$'
      }, {
        begin: '^[^\\[\\]\\n]+?\\n[=\\-~\\^\\+]{2,}$'
      }]
    },
    // document attributes
    {
      className: 'meta',
      begin: '^:.+?:',
      end: '\\s',
      excludeEnd: true,
      relevance: 10
    },
    // block attributes
    {
      className: 'meta',
      begin: '^\\[.+?\\]$',
      relevance: 0
    },
    // quoteblocks
    {
      className: 'quote',
      begin: '^_{4,}\\n',
      end: '\\n_{4,}$',
      relevance: 10
    },
    // listing and literal blocks
    {
      className: 'code',
      begin: '^[\\-\\.]{4,}\\n',
      end: '\\n[\\-\\.]{4,}$',
      relevance: 10
    },
    // passthrough blocks
    {
      begin: '^\\+{4,}\\n',
      end: '\\n\\+{4,}$',
      contains: [{
        begin: '<',
        end: '>',
        subLanguage: 'xml',
        relevance: 0
      }],
      relevance: 10
    }, BULLET_LIST, ADMONITION].concat(ESCAPED_FORMATTING, STRONG, EMPHASIS, [
    // inline smart quotes
    {
      className: 'string',
      variants: [{
        begin: "``.+?''"
      }, {
        begin: "`.+?'"
      }]
    },
    // inline unconstrained emphasis
    {
      className: 'code',
      begin: /`{2}/,
      end: /(\n{2}|`{2})/
    },
    // inline code snippets (TODO should get same treatment as strong and emphasis)
    {
      className: 'code',
      begin: '(`.+?`|\\+.+?\\+)',
      relevance: 0
    },
    // indented literal block
    {
      className: 'code',
      begin: '^[ \\t]',
      end: '$',
      relevance: 0
    }, HORIZONTAL_RULE,
    // images and links
    {
      begin: '(link:)?(http|https|ftp|file|irc|image:?):\\S+?\\[[^[]*?\\]',
      returnBegin: true,
      contains: [{
        begin: '(link|image:?):',
        relevance: 0
      }, {
        className: 'link',
        begin: '\\w',
        end: '[^\\[]+',
        relevance: 0
      }, {
        className: 'string',
        begin: '\\[',
        end: '\\]',
        excludeBegin: true,
        excludeEnd: true,
        relevance: 0
      }],
      relevance: 10
    }])
  };
}
module.exports = asciidoc;

/***/ }),

/***/ 82809:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/*
Language: AspectJ
Author: Hakan Ozler <ozler.hakan@gmail.com>
Website: https://www.eclipse.org/aspectj/
Description: Syntax Highlighting for the AspectJ Language which is a general-purpose aspect-oriented extension to the Java programming language.
Audit: 2020
*/

/** @type LanguageFn */
function aspectj(hljs) {
  var KEYWORDS = 'false synchronized int abstract float private char boolean static null if const ' + 'for true while long throw strictfp finally protected import native final return void ' + 'enum else extends implements break transient new catch instanceof byte super volatile case ' + 'assert short package default double public try this switch continue throws privileged ' + 'aspectOf adviceexecution proceed cflowbelow cflow initialization preinitialization ' + 'staticinitialization withincode target within execution getWithinTypeName handler ' + 'thisJoinPoint thisJoinPointStaticPart thisEnclosingJoinPointStaticPart declare parents ' + 'warning error soft precedence thisAspectInstance';
  var SHORTKEYS = 'get set args call';
  return {
    name: 'AspectJ',
    keywords: KEYWORDS,
    illegal: /<\/|#/,
    contains: [hljs.COMMENT(/\/\*\*/, /\*\//, {
      relevance: 0,
      contains: [{
        // eat up @'s in emails to prevent them to be recognized as doctags
        begin: /\w+@/,
        relevance: 0
      }, {
        className: 'doctag',
        begin: /@[A-Za-z]+/
      }]
    }), hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, {
      className: 'class',
      beginKeywords: 'aspect',
      end: /[{;=]/,
      excludeEnd: true,
      illegal: /[:;"\[\]]/,
      contains: [{
        beginKeywords: 'extends implements pertypewithin perthis pertarget percflowbelow percflow issingleton'
      }, hljs.UNDERSCORE_TITLE_MODE, {
        begin: /\([^\)]*/,
        end: /[)]+/,
        keywords: KEYWORDS + ' ' + SHORTKEYS,
        excludeEnd: false
      }]
    }, {
      className: 'class',
      beginKeywords: 'class interface',
      end: /[{;=]/,
      excludeEnd: true,
      relevance: 0,
      keywords: 'class interface',
      illegal: /[:"\[\]]/,
      contains: [{
        beginKeywords: 'extends implements'
      }, hljs.UNDERSCORE_TITLE_MODE]
    }, {
      // AspectJ Constructs
      beginKeywords: 'pointcut after before around throwing returning',
      end: /[)]/,
      excludeEnd: false,
      illegal: /["\[\]]/,
      contains: [{
        begin: concat(hljs.UNDERSCORE_IDENT_RE, /\s*\(/),
        returnBegin: true,
        contains: [hljs.UNDERSCORE_TITLE_MODE]
      }]
    }, {
      begin: /[:]/,
      returnBegin: true,
      end: /[{;]/,
      relevance: 0,
      excludeEnd: false,
      keywords: KEYWORDS,
      illegal: /["\[\]]/,
      contains: [{
        begin: concat(hljs.UNDERSCORE_IDENT_RE, /\s*\(/),
        keywords: KEYWORDS + ' ' + SHORTKEYS,
        relevance: 0
      }, hljs.QUOTE_STRING_MODE]
    }, {
      // this prevents 'new Name(...), or throw ...' from being recognized as a function definition
      beginKeywords: 'new throw',
      relevance: 0
    }, {
      // the function class is a bit different for AspectJ compared to the Java language
      className: 'function',
      begin: /\w+ +\w+(\.\w+)?\s*\([^\)]*\)\s*((throws)[\w\s,]+)?[\{;]/,
      returnBegin: true,
      end: /[{;=]/,
      keywords: KEYWORDS,
      excludeEnd: true,
      contains: [{
        begin: concat(hljs.UNDERSCORE_IDENT_RE, /\s*\(/),
        returnBegin: true,
        relevance: 0,
        contains: [hljs.UNDERSCORE_TITLE_MODE]
      }, {
        className: 'params',
        begin: /\(/,
        end: /\)/,
        relevance: 0,
        keywords: KEYWORDS,
        contains: [hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, hljs.C_NUMBER_MODE, hljs.C_BLOCK_COMMENT_MODE]
      }, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE]
    }, hljs.C_NUMBER_MODE, {
      // annotation is also used in this language
      className: 'meta',
      begin: /@[A-Za-z]+/
    }]
  };
}
module.exports = aspectj;

/***/ }),

/***/ 87886:
/***/ ((module) => {

/*
Language: AutoHotkey
Author: Seongwon Lee <dlimpid@gmail.com>
Description: AutoHotkey language definition
Category: scripting
*/

/** @type LanguageFn */
function autohotkey(hljs) {
  var BACKTICK_ESCAPE = {
    begin: '`[\\s\\S]'
  };
  return {
    name: 'AutoHotkey',
    case_insensitive: true,
    aliases: ['ahk'],
    keywords: {
      keyword: 'Break Continue Critical Exit ExitApp Gosub Goto New OnExit Pause return SetBatchLines SetTimer Suspend Thread Throw Until ahk_id ahk_class ahk_pid ahk_exe ahk_group',
      literal: 'true false NOT AND OR',
      built_in: 'ComSpec Clipboard ClipboardAll ErrorLevel'
    },
    contains: [BACKTICK_ESCAPE, hljs.inherit(hljs.QUOTE_STRING_MODE, {
      contains: [BACKTICK_ESCAPE]
    }), hljs.COMMENT(';', '$', {
      relevance: 0
    }), hljs.C_BLOCK_COMMENT_MODE, {
      className: 'number',
      begin: hljs.NUMBER_RE,
      relevance: 0
    }, {
      // subst would be the most accurate however fails the point of
      // highlighting. variable is comparably the most accurate that actually
      // has some effect
      className: 'variable',
      begin: '%[a-zA-Z0-9#_$@]+%'
    }, {
      className: 'built_in',
      begin: '^\\s*\\w+\\s*(,|%)'
      // I don't really know if this is totally relevant
    }, {
      // symbol would be most accurate however is highlighted just like
      // built_in and that makes up a lot of AutoHotkey code meaning that it
      // would fail to highlight anything
      className: 'title',
      variants: [{
        begin: '^[^\\n";]+::(?!=)'
      }, {
        begin: '^[^\\n";]+:(?!=)',
        // zero relevance as it catches a lot of things
        // followed by a single ':' in many languages
        relevance: 0
      }]
    }, {
      className: 'meta',
      begin: '^\\s*#\\w+',
      end: '$',
      relevance: 0
    }, {
      className: 'built_in',
      begin: 'A_[a-zA-Z0-9]+'
    }, {
      // consecutive commas, not for highlighting but just for relevance
      begin: ',\\s*,'
    }]
  };
}
module.exports = autohotkey;

/***/ }),

/***/ 22729:
/***/ ((module) => {

/*
Language: AutoIt
Author: Manh Tuan <junookyo@gmail.com>
Description: AutoIt language definition
Category: scripting
*/

/** @type LanguageFn */
function autoit(hljs) {
  var KEYWORDS = 'ByRef Case Const ContinueCase ContinueLoop ' + 'Dim Do Else ElseIf EndFunc EndIf EndSelect ' + 'EndSwitch EndWith Enum Exit ExitLoop For Func ' + 'Global If In Local Next ReDim Return Select Static ' + 'Step Switch Then To Until Volatile WEnd While With';
  var DIRECTIVES = ["EndRegion", "forcedef", "forceref", "ignorefunc", "include", "include-once", "NoTrayIcon", "OnAutoItStartRegister", "pragma", "Region", "RequireAdmin", "Tidy_Off", "Tidy_On", "Tidy_Parameters"];
  var LITERAL = 'True False And Null Not Or Default';
  var BUILT_IN = 'Abs ACos AdlibRegister AdlibUnRegister Asc AscW ASin Assign ATan AutoItSetOption AutoItWinGetTitle AutoItWinSetTitle Beep Binary BinaryLen BinaryMid BinaryToString BitAND BitNOT BitOR BitRotate BitShift BitXOR BlockInput Break Call CDTray Ceiling Chr ChrW ClipGet ClipPut ConsoleRead ConsoleWrite ConsoleWriteError ControlClick ControlCommand ControlDisable ControlEnable ControlFocus ControlGetFocus ControlGetHandle ControlGetPos ControlGetText ControlHide ControlListView ControlMove ControlSend ControlSetText ControlShow ControlTreeView Cos Dec DirCopy DirCreate DirGetSize DirMove DirRemove DllCall DllCallAddress DllCallbackFree DllCallbackGetPtr DllCallbackRegister DllClose DllOpen DllStructCreate DllStructGetData DllStructGetPtr DllStructGetSize DllStructSetData DriveGetDrive DriveGetFileSystem DriveGetLabel DriveGetSerial DriveGetType DriveMapAdd DriveMapDel DriveMapGet DriveSetLabel DriveSpaceFree DriveSpaceTotal DriveStatus EnvGet EnvSet EnvUpdate Eval Execute Exp FileChangeDir FileClose FileCopy FileCreateNTFSLink FileCreateShortcut FileDelete FileExists FileFindFirstFile FileFindNextFile FileFlush FileGetAttrib FileGetEncoding FileGetLongName FileGetPos FileGetShortcut FileGetShortName FileGetSize FileGetTime FileGetVersion FileInstall FileMove FileOpen FileOpenDialog FileRead FileReadLine FileReadToArray FileRecycle FileRecycleEmpty FileSaveDialog FileSelectFolder FileSetAttrib FileSetEnd FileSetPos FileSetTime FileWrite FileWriteLine Floor FtpSetProxy FuncName GUICreate GUICtrlCreateAvi GUICtrlCreateButton GUICtrlCreateCheckbox GUICtrlCreateCombo GUICtrlCreateContextMenu GUICtrlCreateDate GUICtrlCreateDummy GUICtrlCreateEdit GUICtrlCreateGraphic GUICtrlCreateGroup GUICtrlCreateIcon GUICtrlCreateInput GUICtrlCreateLabel GUICtrlCreateList GUICtrlCreateListView GUICtrlCreateListViewItem GUICtrlCreateMenu GUICtrlCreateMenuItem GUICtrlCreateMonthCal GUICtrlCreateObj GUICtrlCreatePic GUICtrlCreateProgress GUICtrlCreateRadio GUICtrlCreateSlider GUICtrlCreateTab GUICtrlCreateTabItem GUICtrlCreateTreeView GUICtrlCreateTreeViewItem GUICtrlCreateUpdown GUICtrlDelete GUICtrlGetHandle GUICtrlGetState GUICtrlRead GUICtrlRecvMsg GUICtrlRegisterListViewSort GUICtrlSendMsg GUICtrlSendToDummy GUICtrlSetBkColor GUICtrlSetColor GUICtrlSetCursor GUICtrlSetData GUICtrlSetDefBkColor GUICtrlSetDefColor GUICtrlSetFont GUICtrlSetGraphic GUICtrlSetImage GUICtrlSetLimit GUICtrlSetOnEvent GUICtrlSetPos GUICtrlSetResizing GUICtrlSetState GUICtrlSetStyle GUICtrlSetTip GUIDelete GUIGetCursorInfo GUIGetMsg GUIGetStyle GUIRegisterMsg GUISetAccelerators GUISetBkColor GUISetCoord GUISetCursor GUISetFont GUISetHelp GUISetIcon GUISetOnEvent GUISetState GUISetStyle GUIStartGroup GUISwitch Hex HotKeySet HttpSetProxy HttpSetUserAgent HWnd InetClose InetGet InetGetInfo InetGetSize InetRead IniDelete IniRead IniReadSection IniReadSectionNames IniRenameSection IniWrite IniWriteSection InputBox Int IsAdmin IsArray IsBinary IsBool IsDeclared IsDllStruct IsFloat IsFunc IsHWnd IsInt IsKeyword IsNumber IsObj IsPtr IsString Log MemGetStats Mod MouseClick MouseClickDrag MouseDown MouseGetCursor MouseGetPos MouseMove MouseUp MouseWheel MsgBox Number ObjCreate ObjCreateInterface ObjEvent ObjGet ObjName OnAutoItExitRegister OnAutoItExitUnRegister Ping PixelChecksum PixelGetColor PixelSearch ProcessClose ProcessExists ProcessGetStats ProcessList ProcessSetPriority ProcessWait ProcessWaitClose ProgressOff ProgressOn ProgressSet Ptr Random RegDelete RegEnumKey RegEnumVal RegRead RegWrite Round Run RunAs RunAsWait RunWait Send SendKeepActive SetError SetExtended ShellExecute ShellExecuteWait Shutdown Sin Sleep SoundPlay SoundSetWaveVolume SplashImageOn SplashOff SplashTextOn Sqrt SRandom StatusbarGetText StderrRead StdinWrite StdioClose StdoutRead String StringAddCR StringCompare StringFormat StringFromASCIIArray StringInStr StringIsAlNum StringIsAlpha StringIsASCII StringIsDigit StringIsFloat StringIsInt StringIsLower StringIsSpace StringIsUpper StringIsXDigit StringLeft StringLen StringLower StringMid StringRegExp StringRegExpReplace StringReplace StringReverse StringRight StringSplit StringStripCR StringStripWS StringToASCIIArray StringToBinary StringTrimLeft StringTrimRight StringUpper Tan TCPAccept TCPCloseSocket TCPConnect TCPListen TCPNameToIP TCPRecv TCPSend TCPShutdown, UDPShutdown TCPStartup, UDPStartup TimerDiff TimerInit ToolTip TrayCreateItem TrayCreateMenu TrayGetMsg TrayItemDelete TrayItemGetHandle TrayItemGetState TrayItemGetText TrayItemSetOnEvent TrayItemSetState TrayItemSetText TraySetClick TraySetIcon TraySetOnEvent TraySetPauseIcon TraySetState TraySetToolTip TrayTip UBound UDPBind UDPCloseSocket UDPOpen UDPRecv UDPSend VarGetType WinActivate WinActive WinClose WinExists WinFlash WinGetCaretPos WinGetClassList WinGetClientSize WinGetHandle WinGetPos WinGetProcess WinGetState WinGetText WinGetTitle WinKill WinList WinMenuSelectItem WinMinimizeAll WinMinimizeAllUndo WinMove WinSetOnTop WinSetState WinSetTitle WinSetTrans WinWait WinWaitActive WinWaitClose WinWaitNotActive';
  var COMMENT = {
    variants: [hljs.COMMENT(';', '$', {
      relevance: 0
    }), hljs.COMMENT('#cs', '#ce'), hljs.COMMENT('#comments-start', '#comments-end')]
  };
  var VARIABLE = {
    begin: '\\$[A-z0-9_]+'
  };
  var STRING = {
    className: 'string',
    variants: [{
      begin: /"/,
      end: /"/,
      contains: [{
        begin: /""/,
        relevance: 0
      }]
    }, {
      begin: /'/,
      end: /'/,
      contains: [{
        begin: /''/,
        relevance: 0
      }]
    }]
  };
  var NUMBER = {
    variants: [hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE]
  };
  var PREPROCESSOR = {
    className: 'meta',
    begin: '#',
    end: '$',
    keywords: {
      'meta-keyword': DIRECTIVES
    },
    contains: [{
      begin: /\\\n/,
      relevance: 0
    }, {
      beginKeywords: 'include',
      keywords: {
        'meta-keyword': 'include'
      },
      end: '$',
      contains: [STRING, {
        className: 'meta-string',
        variants: [{
          begin: '<',
          end: '>'
        }, {
          begin: /"/,
          end: /"/,
          contains: [{
            begin: /""/,
            relevance: 0
          }]
        }, {
          begin: /'/,
          end: /'/,
          contains: [{
            begin: /''/,
            relevance: 0
          }]
        }]
      }]
    }, STRING, COMMENT]
  };
  var CONSTANT = {
    className: 'symbol',
    // begin: '@',
    // end: '$',
    // keywords: 'AppDataCommonDir AppDataDir AutoItExe AutoItPID AutoItVersion AutoItX64 COM_EventObj CommonFilesDir Compiled ComputerName ComSpec CPUArch CR CRLF DesktopCommonDir DesktopDepth DesktopDir DesktopHeight DesktopRefresh DesktopWidth DocumentsCommonDir error exitCode exitMethod extended FavoritesCommonDir FavoritesDir GUI_CtrlHandle GUI_CtrlId GUI_DragFile GUI_DragId GUI_DropId GUI_WinHandle HomeDrive HomePath HomeShare HotKeyPressed HOUR IPAddress1 IPAddress2 IPAddress3 IPAddress4 KBLayout LF LocalAppDataDir LogonDNSDomain LogonDomain LogonServer MDAY MIN MON MSEC MUILang MyDocumentsDir NumParams OSArch OSBuild OSLang OSServicePack OSType OSVersion ProgramFilesDir ProgramsCommonDir ProgramsDir ScriptDir ScriptFullPath ScriptLineNumber ScriptName SEC StartMenuCommonDir StartMenuDir StartupCommonDir StartupDir SW_DISABLE SW_ENABLE SW_HIDE SW_LOCK SW_MAXIMIZE SW_MINIMIZE SW_RESTORE SW_SHOW SW_SHOWDEFAULT SW_SHOWMAXIMIZED SW_SHOWMINIMIZED SW_SHOWMINNOACTIVE SW_SHOWNA SW_SHOWNOACTIVATE SW_SHOWNORMAL SW_UNLOCK SystemDir TAB TempDir TRAY_ID TrayIconFlashing TrayIconVisible UserName UserProfileDir WDAY WindowsDir WorkingDir YDAY YEAR',
    // relevance: 5
    begin: '@[A-z0-9_]+'
  };
  var FUNCTION = {
    className: 'function',
    beginKeywords: 'Func',
    end: '$',
    illegal: '\\$|\\[|%',
    contains: [hljs.UNDERSCORE_TITLE_MODE, {
      className: 'params',
      begin: '\\(',
      end: '\\)',
      contains: [VARIABLE, STRING, NUMBER]
    }]
  };
  return {
    name: 'AutoIt',
    case_insensitive: true,
    illegal: /\/\*/,
    keywords: {
      keyword: KEYWORDS,
      built_in: BUILT_IN,
      literal: LITERAL
    },
    contains: [COMMENT, VARIABLE, STRING, NUMBER, PREPROCESSOR, CONSTANT, FUNCTION]
  };
}
module.exports = autoit;

/***/ }),

/***/ 83061:
/***/ ((module) => {

/*
Language: AVR Assembly
Author: Vladimir Ermakov <vooon341@gmail.com>
Category: assembler
Website: https://www.microchip.com/webdoc/avrassembler/avrassembler.wb_instruction_list.html
*/

/** @type LanguageFn */
function avrasm(hljs) {
  return {
    name: 'AVR Assembly',
    case_insensitive: true,
    keywords: {
      $pattern: '\\.?' + hljs.IDENT_RE,
      keyword: /* mnemonic */
      'adc add adiw and andi asr bclr bld brbc brbs brcc brcs break breq brge brhc brhs ' + 'brid brie brlo brlt brmi brne brpl brsh brtc brts brvc brvs bset bst call cbi cbr ' + 'clc clh cli cln clr cls clt clv clz com cp cpc cpi cpse dec eicall eijmp elpm eor ' + 'fmul fmuls fmulsu icall ijmp in inc jmp ld ldd ldi lds lpm lsl lsr mov movw mul ' + 'muls mulsu neg nop or ori out pop push rcall ret reti rjmp rol ror sbc sbr sbrc sbrs ' + 'sec seh sbi sbci sbic sbis sbiw sei sen ser ses set sev sez sleep spm st std sts sub ' + 'subi swap tst wdr',
      built_in: /* general purpose registers */
      'r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 r16 r17 r18 r19 r20 r21 r22 ' + 'r23 r24 r25 r26 r27 r28 r29 r30 r31 x|0 xh xl y|0 yh yl z|0 zh zl ' + /* IO Registers (ATMega128) */
      'ucsr1c udr1 ucsr1a ucsr1b ubrr1l ubrr1h ucsr0c ubrr0h tccr3c tccr3a tccr3b tcnt3h ' + 'tcnt3l ocr3ah ocr3al ocr3bh ocr3bl ocr3ch ocr3cl icr3h icr3l etimsk etifr tccr1c ' + 'ocr1ch ocr1cl twcr twdr twar twsr twbr osccal xmcra xmcrb eicra spmcsr spmcr portg ' + 'ddrg ping portf ddrf sreg sph spl xdiv rampz eicrb eimsk gimsk gicr eifr gifr timsk ' + 'tifr mcucr mcucsr tccr0 tcnt0 ocr0 assr tccr1a tccr1b tcnt1h tcnt1l ocr1ah ocr1al ' + 'ocr1bh ocr1bl icr1h icr1l tccr2 tcnt2 ocr2 ocdr wdtcr sfior eearh eearl eedr eecr ' + 'porta ddra pina portb ddrb pinb portc ddrc pinc portd ddrd pind spdr spsr spcr udr0 ' + 'ucsr0a ucsr0b ubrr0l acsr admux adcsr adch adcl porte ddre pine pinf',
      meta: '.byte .cseg .db .def .device .dseg .dw .endmacro .equ .eseg .exit .include .list ' + '.listmac .macro .nolist .org .set'
    },
    contains: [hljs.C_BLOCK_COMMENT_MODE, hljs.COMMENT(';', '$', {
      relevance: 0
    }), hljs.C_NUMBER_MODE,
    // 0x..., decimal, float
    hljs.BINARY_NUMBER_MODE,
    // 0b...
    {
      className: 'number',
      begin: '\\b(\\$[a-zA-Z0-9]+|0o[0-7]+)' // $..., 0o...
    }, hljs.QUOTE_STRING_MODE, {
      className: 'string',
      begin: '\'',
      end: '[^\\\\]\'',
      illegal: '[^\\\\][^\']'
    }, {
      className: 'symbol',
      begin: '^[A-Za-z0-9_.$]+:'
    }, {
      className: 'meta',
      begin: '#',
      end: '$'
    }, {
      // substitution within a macro
      className: 'subst',
      begin: '@[0-9]+'
    }]
  };
}
module.exports = avrasm;

/***/ }),

/***/ 64504:
/***/ ((module) => {

/*
Language: Awk
Author: Matthew Daly <matthewbdaly@gmail.com>
Website: https://www.gnu.org/software/gawk/manual/gawk.html
Description: language definition for Awk scripts
*/

/** @type LanguageFn */
function awk(hljs) {
  var VARIABLE = {
    className: 'variable',
    variants: [{
      begin: /\$[\w\d#@][\w\d_]*/
    }, {
      begin: /\$\{(.*?)\}/
    }]
  };
  var KEYWORDS = 'BEGIN END if else while do for in break continue delete next nextfile function func exit|10';
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE],
    variants: [{
      begin: /(u|b)?r?'''/,
      end: /'''/,
      relevance: 10
    }, {
      begin: /(u|b)?r?"""/,
      end: /"""/,
      relevance: 10
    }, {
      begin: /(u|r|ur)'/,
      end: /'/,
      relevance: 10
    }, {
      begin: /(u|r|ur)"/,
      end: /"/,
      relevance: 10
    }, {
      begin: /(b|br)'/,
      end: /'/
    }, {
      begin: /(b|br)"/,
      end: /"/
    }, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE]
  };
  return {
    name: 'Awk',
    keywords: {
      keyword: KEYWORDS
    },
    contains: [VARIABLE, STRING, hljs.REGEXP_MODE, hljs.HASH_COMMENT_MODE, hljs.NUMBER_MODE]
  };
}
module.exports = awk;

/***/ }),

/***/ 55644:
/***/ ((module) => {

/*
Language: Microsoft X++
Description: X++ is a language used in Microsoft Dynamics 365, Dynamics AX, and Axapta.
Author: Dmitri Roudakov <dmitri@roudakov.ru>
Website: https://dynamics.microsoft.com/en-us/ax-overview/
Category: enterprise
*/

/** @type LanguageFn */
function axapta(hljs) {
  var BUILT_IN_KEYWORDS = ['anytype', 'boolean', 'byte', 'char', 'container', 'date', 'double', 'enum', 'guid', 'int', 'int64', 'long', 'real', 'short', 'str', 'utcdatetime', 'var'];
  var LITERAL_KEYWORDS = ['default', 'false', 'null', 'true'];
  var NORMAL_KEYWORDS = ['abstract', 'as', 'asc', 'avg', 'break', 'breakpoint', 'by', 'byref', 'case', 'catch', 'changecompany', 'class', 'client', 'client', 'common', 'const', 'continue', 'count', 'crosscompany', 'delegate', 'delete_from', 'desc', 'display', 'div', 'do', 'edit', 'else', 'eventhandler', 'exists', 'extends', 'final', 'finally', 'firstfast', 'firstonly', 'firstonly1', 'firstonly10', 'firstonly100', 'firstonly1000', 'flush', 'for', 'forceliterals', 'forcenestedloop', 'forceplaceholders', 'forceselectorder', 'forupdate', 'from', 'generateonly', 'group', 'hint', 'if', 'implements', 'in', 'index', 'insert_recordset', 'interface', 'internal', 'is', 'join', 'like', 'maxof', 'minof', 'mod', 'namespace', 'new', 'next', 'nofetch', 'notexists', 'optimisticlock', 'order', 'outer', 'pessimisticlock', 'print', 'private', 'protected', 'public', 'readonly', 'repeatableread', 'retry', 'return', 'reverse', 'select', 'server', 'setting', 'static', 'sum', 'super', 'switch', 'this', 'throw', 'try', 'ttsabort', 'ttsbegin', 'ttscommit', 'unchecked', 'update_recordset', 'using', 'validtimestate', 'void', 'where', 'while'];
  var KEYWORDS = {
    keyword: NORMAL_KEYWORDS,
    built_in: BUILT_IN_KEYWORDS,
    literal: LITERAL_KEYWORDS
  };
  return {
    name: 'X++',
    aliases: ['x++'],
    keywords: KEYWORDS,
    contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, hljs.C_NUMBER_MODE, {
      className: 'meta',
      begin: '#',
      end: '$'
    }, {
      className: 'class',
      beginKeywords: 'class interface',
      end: /\{/,
      excludeEnd: true,
      illegal: ':',
      contains: [{
        beginKeywords: 'extends implements'
      }, hljs.UNDERSCORE_TITLE_MODE]
    }]
  };
}
module.exports = axapta;

/***/ }),

/***/ 33950:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(19601);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/*
Language: Bash
Author: vah <vahtenberg@gmail.com>
Contributrors: Benjamin Pannell <contact@sierrasoftworks.com>
Website: https://www.gnu.org/software/bash/
Category: common
*/

/** @type LanguageFn */
function bash(hljs) {
  var VAR = {};
  var BRACED_VAR = {
    begin: /\$\{/,
    end: /\}/,
    contains: ["self", {
      begin: /:-/,
      contains: [VAR]
    } // default values
    ]
  };

  Object.assign(VAR, {
    className: 'variable',
    variants: [{
      begin: concat(/\$[\w\d#@][\w\d_]*/, // negative look-ahead tries to avoid matching patterns that are not
      // Perl at all like $ident$, @ident@, etc.
      "(?![\\w\\d])(?![$])")
    }, BRACED_VAR]
  });
  var SUBST = {
    className: 'subst',
    begin: /\$\(/,
    end: /\)/,
    contains: [hljs.BACKSLASH_ESCAPE]
  };
  var HERE_DOC = {
    begin: /<<-?\s*(?=\w+)/,
    starts: {
      contains: [hljs.END_SAME_AS_BEGIN({
        begin: /(\w+)/,
        end: /(\w+)/,
        className: 'string'
      })]
    }
  };
  var QUOTE_STRING = {
    className: 'string',
    begin: /"/,
    end: /"/,
    contains: [hljs.BACKSLASH_ESCAPE, VAR, SUBST]
  };
  SUBST.contains.push(QUOTE_STRING);
  var ESCAPED_QUOTE = {
    className: '',
    begin: /\\"/
  };
  var APOS_STRING = {
    className: 'string',
    begin: /'/,
    end: /'/
  };
  var ARITHMETIC = {
    begin: /\$\(\(/,
    end: /\)\)/,
    contains: [{
      begin: /\d+#[0-9a-f]+/,
      className: "number"
    }, hljs.NUMBER_MODE, VAR]
  };
  var SH_LIKE_SHELLS = ["fish", "bash", "zsh", "sh", "csh", "ksh", "tcsh", "dash", "scsh"];
  var KNOWN_SHEBANG = hljs.SHEBANG({
    binary: "(".concat(SH_LIKE_SHELLS.join("|"), ")"),
    relevance: 10
  });
  var FUNCTION = {
    className: 'function',
    begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
    returnBegin: true,
    contains: [hljs.inherit(hljs.TITLE_MODE, {
      begin: /\w[\w\d_]*/
    })],
    relevance: 0
  };
  return {
    name: 'Bash',
    aliases: ['sh', 'zsh'],
    keywords: {
      $pattern: /\b[a-z._-]+\b/,
      keyword: 'if then else elif fi for while in do done case esac function',
      literal: 'true false',
      built_in:
      // Shell built-ins
      // http://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
      'break cd continue eval exec exit export getopts hash pwd readonly return shift test times ' + 'trap umask unset ' +
      // Bash built-ins
      'alias bind builtin caller command declare echo enable help let local logout mapfile printf ' + 'read readarray source type typeset ulimit unalias ' +
      // Shell modifiers
      'set shopt ' +
      // Zsh built-ins
      'autoload bg bindkey bye cap chdir clone comparguments compcall compctl compdescribe compfiles ' + 'compgroups compquote comptags comptry compvalues dirs disable disown echotc echoti emulate ' + 'fc fg float functions getcap getln history integer jobs kill limit log noglob popd print ' + 'pushd pushln rehash sched setcap setopt stat suspend ttyctl unfunction unhash unlimit ' + 'unsetopt vared wait whence where which zcompile zformat zftp zle zmodload zparseopts zprof ' + 'zpty zregexparse zsocket zstyle ztcp'
    },
    contains: [KNOWN_SHEBANG,
    // to catch known shells and boost relevancy
    hljs.SHEBANG(),
    // to catch unknown shells but still highlight the shebang
    FUNCTION, ARITHMETIC, hljs.HASH_COMMENT_MODE, HERE_DOC, QUOTE_STRING, ESCAPED_QUOTE, APOS_STRING, VAR]
  };
}
module.exports = bash;

/***/ }),

/***/ 63309:
/***/ ((module) => {

/*
Language: BASIC
Author: Raphaël Assénat <raph@raphnet.net>
Description: Based on the BASIC reference from the Tandy 1000 guide
Website: https://en.wikipedia.org/wiki/Tandy_1000
*/

/** @type LanguageFn */
function basic(hljs) {
  return {
    name: 'BASIC',
    case_insensitive: true,
    illegal: '^\.',
    // Support explicitly typed variables that end with $%! or #.
    keywords: {
      $pattern: '[a-zA-Z][a-zA-Z0-9_$%!#]*',
      keyword: 'ABS ASC AND ATN AUTO|0 BEEP BLOAD|10 BSAVE|10 CALL CALLS CDBL CHAIN CHDIR CHR$|10 CINT CIRCLE ' + 'CLEAR CLOSE CLS COLOR COM COMMON CONT COS CSNG CSRLIN CVD CVI CVS DATA DATE$ ' + 'DEFDBL DEFINT DEFSNG DEFSTR DEF|0 SEG USR DELETE DIM DRAW EDIT END ENVIRON ENVIRON$ ' + 'EOF EQV ERASE ERDEV ERDEV$ ERL ERR ERROR EXP FIELD FILES FIX FOR|0 FRE GET GOSUB|10 GOTO ' + 'HEX$ IF THEN ELSE|0 INKEY$ INP INPUT INPUT# INPUT$ INSTR IMP INT IOCTL IOCTL$ KEY ON ' + 'OFF LIST KILL LEFT$ LEN LET LINE LLIST LOAD LOC LOCATE LOF LOG LPRINT USING LSET ' + 'MERGE MID$ MKDIR MKD$ MKI$ MKS$ MOD NAME NEW NEXT NOISE NOT OCT$ ON OR PEN PLAY STRIG OPEN OPTION ' + 'BASE OUT PAINT PALETTE PCOPY PEEK PMAP POINT POKE POS PRINT PRINT] PSET PRESET ' + 'PUT RANDOMIZE READ REM RENUM RESET|0 RESTORE RESUME RETURN|0 RIGHT$ RMDIR RND RSET ' + 'RUN SAVE SCREEN SGN SHELL SIN SOUND SPACE$ SPC SQR STEP STICK STOP STR$ STRING$ SWAP ' + 'SYSTEM TAB TAN TIME$ TIMER TROFF TRON TO USR VAL VARPTR VARPTR$ VIEW WAIT WHILE ' + 'WEND WIDTH WINDOW WRITE XOR'
    },
    contains: [hljs.QUOTE_STRING_MODE, hljs.COMMENT('REM', '$', {
      relevance: 10
    }), hljs.COMMENT('\'', '$', {
      relevance: 0
    }), {
      // Match line numbers
      className: 'symbol',
      begin: '^[0-9]+ ',
      relevance: 10
    }, {
      // Match typed numeric constants (1000, 12.34!, 1.2e5, 1.5#, 1.2D2)
      className: 'number',
      begin: '\\b\\d+(\\.\\d+)?([edED]\\d+)?[#\!]?',
      relevance: 0
    }, {
      // Match hexadecimal numbers (&Hxxxx)
      className: 'number',
      begin: '(&[hH][0-9a-fA-F]{1,4})'
    }, {
      // Match octal numbers (&Oxxxxxx)
      className: 'number',
      begin: '(&[oO][0-7]{1,6})'
    }]
  };
}
module.exports = basic;

/***/ }),

/***/ 76220:
/***/ ((module) => {

/*
Language: Backus–Naur Form
Website: https://en.wikipedia.org/wiki/Backus–Naur_form
Author: Oleg Efimov <efimovov@gmail.com>
*/

/** @type LanguageFn */
function bnf(hljs) {
  return {
    name: 'Backus–Naur Form',
    contains: [
    // Attribute
    {
      className: 'attribute',
      begin: /</,
      end: />/
    },
    // Specific
    {
      begin: /::=/,
      end: /$/,
      contains: [{
        begin: /</,
        end: />/
      },
      // Common
      hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE]
    }]
  };
}
module.exports = bnf;

/***/ }),

/***/ 59553:
/***/ ((module) => {

/*
Language: Brainfuck
Author: Evgeny Stepanischev <imbolk@gmail.com>
Website: https://esolangs.org/wiki/Brainfuck
*/

/** @type LanguageFn */
function brainfuck(hljs) {
  var LITERAL = {
    className: 'literal',
    begin: /[+-]/,
    relevance: 0
  };
  return {
    name: 'Brainfuck',
    aliases: ['bf'],
    contains: [hljs.COMMENT('[^\\[\\]\\.,\\+\\-<> \r\n]', '[\\[\\]\\.,\\+\\-<> \r\n]', {
      returnEnd: true,
      relevance: 0
    }), {
      className: 'title',
      begin: '[\\[\\]]',
      relevance: 0
    }, {
      className: 'string',
      begin: '[\\.,]',
      relevance: 0
    }, {
      // this mode works as the only relevance counter
      begin: /(?:\+\+|--)/,
      contains: [LITERAL]
    }, LITERAL]
  };
}
module.exports = brainfuck;

/***/ }),

/***/ 80960:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(92222);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function lookahead(re) {
  return concat('(?=', re, ')');
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function optional(re) {
  return concat('(', re, ')?');
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/*
Language: C++
Category: common, system
Website: https://isocpp.org
*/

/** @type LanguageFn */
function cPlusPlus(hljs) {
  // added for historic reasons because `hljs.C_LINE_COMMENT_MODE` does
  // not include such support nor can we be sure all the grammars depending
  // on it would desire this behavior
  var C_LINE_COMMENT_MODE = hljs.COMMENT('//', '$', {
    contains: [{
      begin: /\\\n/
    }]
  });
  var DECLTYPE_AUTO_RE = 'decltype\\(auto\\)';
  var NAMESPACE_RE = '[a-zA-Z_]\\w*::';
  var TEMPLATE_ARGUMENT_RE = '<[^<>]+>';
  var FUNCTION_TYPE_RE = '(' + DECLTYPE_AUTO_RE + '|' + optional(NAMESPACE_RE) + '[a-zA-Z_]\\w*' + optional(TEMPLATE_ARGUMENT_RE) + ')';
  var CPP_PRIMITIVE_TYPES = {
    className: 'keyword',
    begin: '\\b[a-z\\d_]*_t\\b'
  };

  // https://en.cppreference.com/w/cpp/language/escape
  // \\ \x \xFF \u2837 \u00323747 \374
  var CHARACTER_ESCAPES = '\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)';
  var STRINGS = {
    className: 'string',
    variants: [{
      begin: '(u8?|U|L)?"',
      end: '"',
      illegal: '\\n',
      contains: [hljs.BACKSLASH_ESCAPE]
    }, {
      begin: '(u8?|U|L)?\'(' + CHARACTER_ESCAPES + "|.)",
      end: '\'',
      illegal: '.'
    }, hljs.END_SAME_AS_BEGIN({
      begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
      end: /\)([^()\\ ]{0,16})"/
    })]
  };
  var NUMBERS = {
    className: 'number',
    variants: [{
      begin: '\\b(0b[01\']+)'
    }, {
      begin: '(-?)\\b([\\d\']+(\\.[\\d\']*)?|\\.[\\d\']+)((ll|LL|l|L)(u|U)?|(u|U)(ll|LL|l|L)?|f|F|b|B)'
    }, {
      begin: '(-?)(\\b0[xX][a-fA-F0-9\']+|(\\b[\\d\']+(\\.[\\d\']*)?|\\.[\\d\']+)([eE][-+]?[\\d\']+)?)'
    }],
    relevance: 0
  };
  var PREPROCESSOR = {
    className: 'meta',
    begin: /#\s*[a-z]+\b/,
    end: /$/,
    keywords: {
      'meta-keyword': 'if else elif endif define undef warning error line ' + 'pragma _Pragma ifdef ifndef include'
    },
    contains: [{
      begin: /\\\n/,
      relevance: 0
    }, hljs.inherit(STRINGS, {
      className: 'meta-string'
    }), {
      className: 'meta-string',
      begin: /<.*?>/
    }, C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE]
  };
  var TITLE_MODE = {
    className: 'title',
    begin: optional(NAMESPACE_RE) + hljs.IDENT_RE,
    relevance: 0
  };
  var FUNCTION_TITLE = optional(NAMESPACE_RE) + hljs.IDENT_RE + '\\s*\\(';
  var COMMON_CPP_HINTS = ['asin', 'atan2', 'atan', 'calloc', 'ceil', 'cosh', 'cos', 'exit', 'exp', 'fabs', 'floor', 'fmod', 'fprintf', 'fputs', 'free', 'frexp', 'auto_ptr', 'deque', 'list', 'queue', 'stack', 'vector', 'map', 'set', 'pair', 'bitset', 'multiset', 'multimap', 'unordered_set', 'fscanf', 'future', 'isalnum', 'isalpha', 'iscntrl', 'isdigit', 'isgraph', 'islower', 'isprint', 'ispunct', 'isspace', 'isupper', 'isxdigit', 'tolower', 'toupper', 'labs', 'ldexp', 'log10', 'log', 'malloc', 'realloc', 'memchr', 'memcmp', 'memcpy', 'memset', 'modf', 'pow', 'printf', 'putchar', 'puts', 'scanf', 'sinh', 'sin', 'snprintf', 'sprintf', 'sqrt', 'sscanf', 'strcat', 'strchr', 'strcmp', 'strcpy', 'strcspn', 'strlen', 'strncat', 'strncmp', 'strncpy', 'strpbrk', 'strrchr', 'strspn', 'strstr', 'tanh', 'tan', 'unordered_map', 'unordered_multiset', 'unordered_multimap', 'priority_queue', 'make_pair', 'array', 'shared_ptr', 'abort', 'terminate', 'abs', 'acos', 'vfprintf', 'vprintf', 'vsprintf', 'endl', 'initializer_list', 'unique_ptr', 'complex', 'imaginary', 'std', 'string', 'wstring', 'cin', 'cout', 'cerr', 'clog', 'stdin', 'stdout', 'stderr', 'stringstream', 'istringstream', 'ostringstream'];
  var CPP_KEYWORDS = {
    keyword: 'int float while private char char8_t char16_t char32_t catch import module export virtual operator sizeof ' + 'dynamic_cast|10 typedef const_cast|10 const for static_cast|10 union namespace ' + 'unsigned long volatile static protected bool template mutable if public friend ' + 'do goto auto void enum else break extern using asm case typeid wchar_t ' + 'short reinterpret_cast|10 default double register explicit signed typename try this ' + 'switch continue inline delete alignas alignof constexpr consteval constinit decltype ' + 'concept co_await co_return co_yield requires ' + 'noexcept static_assert thread_local restrict final override ' + 'atomic_bool atomic_char atomic_schar ' + 'atomic_uchar atomic_short atomic_ushort atomic_int atomic_uint atomic_long atomic_ulong atomic_llong ' + 'atomic_ullong new throw return ' + 'and and_eq bitand bitor compl not not_eq or or_eq xor xor_eq',
    built_in: '_Bool _Complex _Imaginary',
    _relevance_hints: COMMON_CPP_HINTS,
    literal: 'true false nullptr NULL'
  };
  var FUNCTION_DISPATCH = {
    className: "function.dispatch",
    relevance: 0,
    keywords: CPP_KEYWORDS,
    begin: concat(/\b/, /(?!decltype)/, /(?!if)/, /(?!for)/, /(?!while)/, hljs.IDENT_RE, lookahead(/\s*\(/))
  };
  var EXPRESSION_CONTAINS = [FUNCTION_DISPATCH, PREPROCESSOR, CPP_PRIMITIVE_TYPES, C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, NUMBERS, STRINGS];
  var EXPRESSION_CONTEXT = {
    // This mode covers expression context where we can't expect a function
    // definition and shouldn't highlight anything that looks like one:
    // `return some()`, `else if()`, `(x*sum(1, 2))`
    variants: [{
      begin: /=/,
      end: /;/
    }, {
      begin: /\(/,
      end: /\)/
    }, {
      beginKeywords: 'new throw return else',
      end: /;/
    }],
    keywords: CPP_KEYWORDS,
    contains: EXPRESSION_CONTAINS.concat([{
      begin: /\(/,
      end: /\)/,
      keywords: CPP_KEYWORDS,
      contains: EXPRESSION_CONTAINS.concat(['self']),
      relevance: 0
    }]),
    relevance: 0
  };
  var FUNCTION_DECLARATION = {
    className: 'function',
    begin: '(' + FUNCTION_TYPE_RE + '[\\*&\\s]+)+' + FUNCTION_TITLE,
    returnBegin: true,
    end: /[{;=]/,
    excludeEnd: true,
    keywords: CPP_KEYWORDS,
    illegal: /[^\w\s\*&:<>.]/,
    contains: [{
      // to prevent it from being confused as the function title
      begin: DECLTYPE_AUTO_RE,
      keywords: CPP_KEYWORDS,
      relevance: 0
    }, {
      begin: FUNCTION_TITLE,
      returnBegin: true,
      contains: [TITLE_MODE],
      relevance: 0
    },
    // needed because we do not have look-behind on the below rule
    // to prevent it from grabbing the final : in a :: pair
    {
      begin: /::/,
      relevance: 0
    },
    // initializers
    {
      begin: /:/,
      endsWithParent: true,
      contains: [STRINGS, NUMBERS]
    }, {
      className: 'params',
      begin: /\(/,
      end: /\)/,
      keywords: CPP_KEYWORDS,
      relevance: 0,
      contains: [C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, STRINGS, NUMBERS, CPP_PRIMITIVE_TYPES,
      // Count matching parentheses.
      {
        begin: /\(/,
        end: /\)/,
        keywords: CPP_KEYWORDS,
        relevance: 0,
        contains: ['self', C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, STRINGS, NUMBERS, CPP_PRIMITIVE_TYPES]
      }]
    }, CPP_PRIMITIVE_TYPES, C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, PREPROCESSOR]
  };
  return {
    name: 'C++',
    aliases: ['cc', 'c++', 'h++', 'hpp', 'hh', 'hxx', 'cxx'],
    keywords: CPP_KEYWORDS,
    illegal: '</',
    classNameAliases: {
      "function.dispatch": "built_in"
    },
    contains: [].concat(EXPRESSION_CONTEXT, FUNCTION_DECLARATION, FUNCTION_DISPATCH, EXPRESSION_CONTAINS, [PREPROCESSOR, {
      // containers: ie, `vector <int> rooms (9);`
      begin: '\\b(deque|list|queue|priority_queue|pair|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array)\\s*<',
      end: '>',
      keywords: CPP_KEYWORDS,
      contains: ['self', CPP_PRIMITIVE_TYPES]
    }, {
      begin: hljs.IDENT_RE + '::',
      keywords: CPP_KEYWORDS
    }, {
      className: 'class',
      beginKeywords: 'enum class struct union',
      end: /[{;:<>=]/,
      contains: [{
        beginKeywords: "final class struct"
      }, hljs.TITLE_MODE]
    }]),
    exports: {
      preprocessor: PREPROCESSOR,
      strings: STRINGS,
      keywords: CPP_KEYWORDS
    }
  };
}

/*
Language: C-like (deprecated, use C and C++ instead)
Author: Ivan Sagalaev <maniac@softwaremaniacs.org>
Contributors: Evgeny Stepanischev <imbolk@gmail.com>, Zaven Muradyan <megalivoithos@gmail.com>, Roel Deckers <admin@codingcat.nl>, Sam Wu <samsam2310@gmail.com>, Jordi Petit <jordi.petit@gmail.com>, Pieter Vantorre <pietervantorre@gmail.com>, Google Inc. (David Benjamin) <davidben@google.com>
*/

/** @type LanguageFn */
function cLike(hljs) {
  var _lang$aliases, _lang$aliases2;
  var lang = cPlusPlus(hljs);
  var C_ALIASES = ["c", "h"];
  var CPP_ALIASES = ['cc', 'c++', 'h++', 'hpp', 'hh', 'hxx', 'cxx'];
  lang.disableAutodetect = true;
  lang.aliases = [];
  // support users only loading c-like (legacy)
  if (!hljs.getLanguage("c")) (_lang$aliases = lang.aliases).push.apply(_lang$aliases, C_ALIASES);
  if (!hljs.getLanguage("cpp")) (_lang$aliases2 = lang.aliases).push.apply(_lang$aliases2, CPP_ALIASES);

  // if c and cpp are loaded after then they will reclaim these
  // aliases for themselves

  return lang;
}
module.exports = cLike;

/***/ }),

/***/ 61981:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(92222);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function optional(re) {
  return concat('(', re, ')?');
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/*
Language: C
Category: common, system
Website: https://en.wikipedia.org/wiki/C_(programming_language)
*/

/** @type LanguageFn */
function c(hljs) {
  // added for historic reasons because `hljs.C_LINE_COMMENT_MODE` does
  // not include such support nor can we be sure all the grammars depending
  // on it would desire this behavior
  var C_LINE_COMMENT_MODE = hljs.COMMENT('//', '$', {
    contains: [{
      begin: /\\\n/
    }]
  });
  var DECLTYPE_AUTO_RE = 'decltype\\(auto\\)';
  var NAMESPACE_RE = '[a-zA-Z_]\\w*::';
  var TEMPLATE_ARGUMENT_RE = '<[^<>]+>';
  var FUNCTION_TYPE_RE = '(' + DECLTYPE_AUTO_RE + '|' + optional(NAMESPACE_RE) + '[a-zA-Z_]\\w*' + optional(TEMPLATE_ARGUMENT_RE) + ')';
  var CPP_PRIMITIVE_TYPES = {
    className: 'keyword',
    begin: '\\b[a-z\\d_]*_t\\b'
  };

  // https://en.cppreference.com/w/cpp/language/escape
  // \\ \x \xFF \u2837 \u00323747 \374
  var CHARACTER_ESCAPES = '\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)';
  var STRINGS = {
    className: 'string',
    variants: [{
      begin: '(u8?|U|L)?"',
      end: '"',
      illegal: '\\n',
      contains: [hljs.BACKSLASH_ESCAPE]
    }, {
      begin: '(u8?|U|L)?\'(' + CHARACTER_ESCAPES + "|.)",
      end: '\'',
      illegal: '.'
    }, hljs.END_SAME_AS_BEGIN({
      begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
      end: /\)([^()\\ ]{0,16})"/
    })]
  };
  var NUMBERS = {
    className: 'number',
    variants: [{
      begin: '\\b(0b[01\']+)'
    }, {
      begin: '(-?)\\b([\\d\']+(\\.[\\d\']*)?|\\.[\\d\']+)((ll|LL|l|L)(u|U)?|(u|U)(ll|LL|l|L)?|f|F|b|B)'
    }, {
      begin: '(-?)(\\b0[xX][a-fA-F0-9\']+|(\\b[\\d\']+(\\.[\\d\']*)?|\\.[\\d\']+)([eE][-+]?[\\d\']+)?)'
    }],
    relevance: 0
  };
  var PREPROCESSOR = {
    className: 'meta',
    begin: /#\s*[a-z]+\b/,
    end: /$/,
    keywords: {
      'meta-keyword': 'if else elif endif define undef warning error line ' + 'pragma _Pragma ifdef ifndef include'
    },
    contains: [{
      begin: /\\\n/,
      relevance: 0
    }, hljs.inherit(STRINGS, {
      className: 'meta-string'
    }), {
      className: 'meta-string',
      begin: /<.*?>/
    }, C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE]
  };
  var TITLE_MODE = {
    className: 'title',
    begin: optional(NAMESPACE_RE) + hljs.IDENT_RE,
    relevance: 0
  };
  var FUNCTION_TITLE = optional(NAMESPACE_RE) + hljs.IDENT_RE + '\\s*\\(';
  var CPP_KEYWORDS = {
    keyword: 'int float while private char char8_t char16_t char32_t catch import module export virtual operator sizeof ' + 'dynamic_cast|10 typedef const_cast|10 const for static_cast|10 union namespace ' + 'unsigned long volatile static protected bool template mutable if public friend ' + 'do goto auto void enum else break extern using asm case typeid wchar_t ' + 'short reinterpret_cast|10 default double register explicit signed typename try this ' + 'switch continue inline delete alignas alignof constexpr consteval constinit decltype ' + 'concept co_await co_return co_yield requires ' + 'noexcept static_assert thread_local restrict final override ' + 'atomic_bool atomic_char atomic_schar ' + 'atomic_uchar atomic_short atomic_ushort atomic_int atomic_uint atomic_long atomic_ulong atomic_llong ' + 'atomic_ullong new throw return ' + 'and and_eq bitand bitor compl not not_eq or or_eq xor xor_eq',
    built_in: 'std string wstring cin cout cerr clog stdin stdout stderr stringstream istringstream ostringstream ' + 'auto_ptr deque list queue stack vector map set pair bitset multiset multimap unordered_set ' + 'unordered_map unordered_multiset unordered_multimap priority_queue make_pair array shared_ptr abort terminate abs acos ' + 'asin atan2 atan calloc ceil cosh cos exit exp fabs floor fmod fprintf fputs free frexp ' + 'fscanf future isalnum isalpha iscntrl isdigit isgraph islower isprint ispunct isspace isupper ' + 'isxdigit tolower toupper labs ldexp log10 log malloc realloc memchr memcmp memcpy memset modf pow ' + 'printf putchar puts scanf sinh sin snprintf sprintf sqrt sscanf strcat strchr strcmp ' + 'strcpy strcspn strlen strncat strncmp strncpy strpbrk strrchr strspn strstr tanh tan ' + 'vfprintf vprintf vsprintf endl initializer_list unique_ptr _Bool complex _Complex imaginary _Imaginary',
    literal: 'true false nullptr NULL'
  };
  var EXPRESSION_CONTAINS = [PREPROCESSOR, CPP_PRIMITIVE_TYPES, C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, NUMBERS, STRINGS];
  var EXPRESSION_CONTEXT = {
    // This mode covers expression context where we can't expect a function
    // definition and shouldn't highlight anything that looks like one:
    // `return some()`, `else if()`, `(x*sum(1, 2))`
    variants: [{
      begin: /=/,
      end: /;/
    }, {
      begin: /\(/,
      end: /\)/
    }, {
      beginKeywords: 'new throw return else',
      end: /;/
    }],
    keywords: CPP_KEYWORDS,
    contains: EXPRESSION_CONTAINS.concat([{
      begin: /\(/,
      end: /\)/,
      keywords: CPP_KEYWORDS,
      contains: EXPRESSION_CONTAINS.concat(['self']),
      relevance: 0
    }]),
    relevance: 0
  };
  var FUNCTION_DECLARATION = {
    className: 'function',
    begin: '(' + FUNCTION_TYPE_RE + '[\\*&\\s]+)+' + FUNCTION_TITLE,
    returnBegin: true,
    end: /[{;=]/,
    excludeEnd: true,
    keywords: CPP_KEYWORDS,
    illegal: /[^\w\s\*&:<>.]/,
    contains: [{
      // to prevent it from being confused as the function title
      begin: DECLTYPE_AUTO_RE,
      keywords: CPP_KEYWORDS,
      relevance: 0
    }, {
      begin: FUNCTION_TITLE,
      returnBegin: true,
      contains: [TITLE_MODE],
      relevance: 0
    }, {
      className: 'params',
      begin: /\(/,
      end: /\)/,
      keywords: CPP_KEYWORDS,
      relevance: 0,
      contains: [C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, STRINGS, NUMBERS, CPP_PRIMITIVE_TYPES,
      // Count matching parentheses.
      {
        begin: /\(/,
        end: /\)/,
        keywords: CPP_KEYWORDS,
        relevance: 0,
        contains: ['self', C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, STRINGS, NUMBERS, CPP_PRIMITIVE_TYPES]
      }]
    }, CPP_PRIMITIVE_TYPES, C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, PREPROCESSOR]
  };
  return {
    name: "C",
    aliases: ['h'],
    keywords: CPP_KEYWORDS,
    // Until differentiations are added between `c` and `cpp`, `c` will
    // not be auto-detected to avoid auto-detect conflicts between C and C++
    disableAutodetect: true,
    illegal: '</',
    contains: [].concat(EXPRESSION_CONTEXT, FUNCTION_DECLARATION, EXPRESSION_CONTAINS, [PREPROCESSOR, {
      // containers: ie, `vector <int> rooms (9);`
      begin: '\\b(deque|list|queue|priority_queue|pair|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array)\\s*<',
      end: '>',
      keywords: CPP_KEYWORDS,
      contains: ['self', CPP_PRIMITIVE_TYPES]
    }, {
      begin: hljs.IDENT_RE + '::',
      keywords: CPP_KEYWORDS
    }, {
      className: 'class',
      beginKeywords: 'enum class struct union',
      end: /[{;:<>=]/,
      contains: [{
        beginKeywords: "final class struct"
      }, hljs.TITLE_MODE]
    }]),
    exports: {
      preprocessor: PREPROCESSOR,
      strings: STRINGS,
      keywords: CPP_KEYWORDS
    }
  };
}
module.exports = c;

/***/ }),

/***/ 33167:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
/*
Language: C/AL
Author: Kenneth Fuglsang Christensen <kfuglsang@gmail.com>
Description: Provides highlighting of Microsoft Dynamics NAV C/AL code files
Website: https://docs.microsoft.com/en-us/dynamics-nav/programming-in-c-al
*/

/** @type LanguageFn */
function cal(hljs) {
  var KEYWORDS = 'div mod in and or not xor asserterror begin case do downto else end exit for if of repeat then to ' + 'until while with var';
  var LITERALS = 'false true';
  var COMMENT_MODES = [hljs.C_LINE_COMMENT_MODE, hljs.COMMENT(/\{/, /\}/, {
    relevance: 0
  }), hljs.COMMENT(/\(\*/, /\*\)/, {
    relevance: 10
  })];
  var STRING = {
    className: 'string',
    begin: /'/,
    end: /'/,
    contains: [{
      begin: /''/
    }]
  };
  var CHAR_STRING = {
    className: 'string',
    begin: /(#\d+)+/
  };
  var DATE = {
    className: 'number',
    begin: '\\b\\d+(\\.\\d+)?(DT|D|T)',
    relevance: 0
  };
  var DBL_QUOTED_VARIABLE = {
    className: 'string',
    // not a string technically but makes sense to be highlighted in the same style
    begin: '"',
    end: '"'
  };
  var PROCEDURE = {
    className: 'function',
    beginKeywords: 'procedure',
    end: /[:;]/,
    keywords: 'procedure|10',
    contains: [hljs.TITLE_MODE, {
      className: 'params',
      begin: /\(/,
      end: /\)/,
      keywords: KEYWORDS,
      contains: [STRING, CHAR_STRING]
    }].concat(COMMENT_MODES)
  };
  var OBJECT = {
    className: 'class',
    begin: 'OBJECT (Table|Form|Report|Dataport|Codeunit|XMLport|MenuSuite|Page|Query) (\\d+) ([^\\r\\n]+)',
    returnBegin: true,
    contains: [hljs.TITLE_MODE, PROCEDURE]
  };
  return {
    name: 'C/AL',
    case_insensitive: true,
    keywords: {
      keyword: KEYWORDS,
      literal: LITERALS
    },
    illegal: /\/\*/,
    contains: [STRING, CHAR_STRING, DATE, DBL_QUOTED_VARIABLE, hljs.NUMBER_MODE, OBJECT, PROCEDURE]
  };
}
module.exports = cal;

/***/ }),

/***/ 11139:
/***/ ((module) => {

/*
Language: Cap’n Proto
Author: Oleg Efimov <efimovov@gmail.com>
Description: Cap’n Proto message definition format
Website: https://capnproto.org/capnp-tool.html
Category: protocols
*/

/** @type LanguageFn */
function capnproto(hljs) {
  return {
    name: 'Cap’n Proto',
    aliases: ['capnp'],
    keywords: {
      keyword: 'struct enum interface union group import using const annotation extends in of on as with from fixed',
      built_in: 'Void Bool Int8 Int16 Int32 Int64 UInt8 UInt16 UInt32 UInt64 Float32 Float64 ' + 'Text Data AnyPointer AnyStruct Capability List',
      literal: 'true false'
    },
    contains: [hljs.QUOTE_STRING_MODE, hljs.NUMBER_MODE, hljs.HASH_COMMENT_MODE, {
      className: 'meta',
      begin: /@0x[\w\d]{16};/,
      illegal: /\n/
    }, {
      className: 'symbol',
      begin: /@\d+\b/
    }, {
      className: 'class',
      beginKeywords: 'struct enum',
      end: /\{/,
      illegal: /\n/,
      contains: [hljs.inherit(hljs.TITLE_MODE, {
        starts: {
          endsWithParent: true,
          excludeEnd: true
        } // hack: eating everything after the first title
      })]
    }, {
      className: 'class',
      beginKeywords: 'interface',
      end: /\{/,
      illegal: /\n/,
      contains: [hljs.inherit(hljs.TITLE_MODE, {
        starts: {
          endsWithParent: true,
          excludeEnd: true
        } // hack: eating everything after the first title
      })]
    }]
  };
}

module.exports = capnproto;

/***/ }),

/***/ 92472:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
/*
Language: Ceylon
Author: Lucas Werkmeister <mail@lucaswerkmeister.de>
Website: https://ceylon-lang.org
*/

/** @type LanguageFn */
function ceylon(hljs) {
  // 2.3. Identifiers and keywords
  var KEYWORDS = 'assembly module package import alias class interface object given value ' + 'assign void function new of extends satisfies abstracts in out return ' + 'break continue throw assert dynamic if else switch case for while try ' + 'catch finally then let this outer super is exists nonempty';
  // 7.4.1 Declaration Modifiers
  var DECLARATION_MODIFIERS = 'shared abstract formal default actual variable late native deprecated ' + 'final sealed annotation suppressWarnings small';
  // 7.4.2 Documentation
  var DOCUMENTATION = 'doc by license see throws tagged';
  var SUBST = {
    className: 'subst',
    excludeBegin: true,
    excludeEnd: true,
    begin: /``/,
    end: /``/,
    keywords: KEYWORDS,
    relevance: 10
  };
  var EXPRESSIONS = [{
    // verbatim string
    className: 'string',
    begin: '"""',
    end: '"""',
    relevance: 10
  }, {
    // string literal or template
    className: 'string',
    begin: '"',
    end: '"',
    contains: [SUBST]
  }, {
    // character literal
    className: 'string',
    begin: "'",
    end: "'"
  }, {
    // numeric literal
    className: 'number',
    begin: '#[0-9a-fA-F_]+|\\$[01_]+|[0-9_]+(?:\\.[0-9_](?:[eE][+-]?\\d+)?)?[kMGTPmunpf]?',
    relevance: 0
  }];
  SUBST.contains = EXPRESSIONS;
  return {
    name: 'Ceylon',
    keywords: {
      keyword: KEYWORDS + ' ' + DECLARATION_MODIFIERS,
      meta: DOCUMENTATION
    },
    illegal: '\\$[^01]|#[^0-9a-fA-F]',
    contains: [hljs.C_LINE_COMMENT_MODE, hljs.COMMENT('/\\*', '\\*/', {
      contains: ['self']
    }), {
      // compiler annotation
      className: 'meta',
      begin: '@[a-z]\\w*(?::"[^"]*")?'
    }].concat(EXPRESSIONS)
  };
}
module.exports = ceylon;

/***/ }),

/***/ 45136:
/***/ ((module) => {

/*
Language: Clean
Author: Camil Staps <info@camilstaps.nl>
Category: functional
Website: http://clean.cs.ru.nl
*/

/** @type LanguageFn */
function clean(hljs) {
  return {
    name: 'Clean',
    aliases: ['icl', 'dcl'],
    keywords: {
      keyword: 'if let in with where case of class instance otherwise ' + 'implementation definition system module from import qualified as ' + 'special code inline foreign export ccall stdcall generic derive ' + 'infix infixl infixr',
      built_in: 'Int Real Char Bool',
      literal: 'True False'
    },
    contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, hljs.C_NUMBER_MODE, {
      // relevance booster
      begin: '->|<-[|:]?|#!?|>>=|\\{\\||\\|\\}|:==|=:|<>'
    }]
  };
}
module.exports = clean;

/***/ }),

/***/ 83776:
/***/ ((module) => {

/*
Language: Clojure REPL
Description: Clojure REPL sessions
Author: Ivan Sagalaev <maniac@softwaremaniacs.org>
Requires: clojure.js
Website: https://clojure.org
Category: lisp
*/

/** @type LanguageFn */
function clojureRepl(hljs) {
  return {
    name: 'Clojure REPL',
    contains: [{
      className: 'meta',
      begin: /^([\w.-]+|\s*#_)?=>/,
      starts: {
        end: /$/,
        subLanguage: 'clojure'
      }
    }]
  };
}
module.exports = clojureRepl;

/***/ }),

/***/ 55272:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
/*
Language: Clojure
Description: Clojure syntax (based on lisp.js)
Author: mfornos
Website: https://clojure.org
Category: lisp
*/

/** @type LanguageFn */
function clojure(hljs) {
  var SYMBOLSTART = 'a-zA-Z_\\-!.?+*=<>&#\'';
  var SYMBOL_RE = '[' + SYMBOLSTART + '][' + SYMBOLSTART + '0-9/;:]*';
  var globals = 'def defonce defprotocol defstruct defmulti defmethod defn- defn defmacro deftype defrecord';
  var keywords = {
    $pattern: SYMBOL_RE,
    'builtin-name':
    // Clojure keywords
    globals + ' ' + 'cond apply if-not if-let if not not= =|0 <|0 >|0 <=|0 >=|0 ==|0 +|0 /|0 *|0 -|0 rem ' + 'quot neg? pos? delay? symbol? keyword? true? false? integer? empty? coll? list? ' + 'set? ifn? fn? associative? sequential? sorted? counted? reversible? number? decimal? ' + 'class? distinct? isa? float? rational? reduced? ratio? odd? even? char? seq? vector? ' + 'string? map? nil? contains? zero? instance? not-every? not-any? libspec? -> ->> .. . ' + 'inc compare do dotimes mapcat take remove take-while drop letfn drop-last take-last ' + 'drop-while while intern condp case reduced cycle split-at split-with repeat replicate ' + 'iterate range merge zipmap declare line-seq sort comparator sort-by dorun doall nthnext ' + 'nthrest partition eval doseq await await-for let agent atom send send-off release-pending-sends ' + 'add-watch mapv filterv remove-watch agent-error restart-agent set-error-handler error-handler ' + 'set-error-mode! error-mode shutdown-agents quote var fn loop recur throw try monitor-enter ' + 'monitor-exit macroexpand macroexpand-1 for dosync and or ' + 'when when-not when-let comp juxt partial sequence memoize constantly complement identity assert ' + 'peek pop doto proxy first rest cons cast coll last butlast ' + 'sigs reify second ffirst fnext nfirst nnext meta with-meta ns in-ns create-ns import ' + 'refer keys select-keys vals key val rseq name namespace promise into transient persistent! conj! ' + 'assoc! dissoc! pop! disj! use class type num float double short byte boolean bigint biginteger ' + 'bigdec print-method print-dup throw-if printf format load compile get-in update-in pr pr-on newline ' + 'flush read slurp read-line subvec with-open memfn time re-find re-groups rand-int rand mod locking ' + 'assert-valid-fdecl alias resolve ref deref refset swap! reset! set-validator! compare-and-set! alter-meta! ' + 'reset-meta! commute get-validator alter ref-set ref-history-count ref-min-history ref-max-history ensure sync io! ' + 'new next conj set! to-array future future-call into-array aset gen-class reduce map filter find empty ' + 'hash-map hash-set sorted-map sorted-map-by sorted-set sorted-set-by vec vector seq flatten reverse assoc dissoc list ' + 'disj get union difference intersection extend extend-type extend-protocol int nth delay count concat chunk chunk-buffer ' + 'chunk-append chunk-first chunk-rest max min dec unchecked-inc-int unchecked-inc unchecked-dec-inc unchecked-dec unchecked-negate ' + 'unchecked-add-int unchecked-add unchecked-subtract-int unchecked-subtract chunk-next chunk-cons chunked-seq? prn vary-meta ' + 'lazy-seq spread list* str find-keyword keyword symbol gensym force rationalize'
  };
  var SIMPLE_NUMBER_RE = '[-+]?\\d+(\\.\\d+)?';
  var SYMBOL = {
    begin: SYMBOL_RE,
    relevance: 0
  };
  var NUMBER = {
    className: 'number',
    begin: SIMPLE_NUMBER_RE,
    relevance: 0
  };
  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {
    illegal: null
  });
  var COMMENT = hljs.COMMENT(';', '$', {
    relevance: 0
  });
  var LITERAL = {
    className: 'literal',
    begin: /\b(true|false|nil)\b/
  };
  var COLLECTION = {
    begin: '[\\[\\{]',
    end: '[\\]\\}]'
  };
  var HINT = {
    className: 'comment',
    begin: '\\^' + SYMBOL_RE
  };
  var HINT_COL = hljs.COMMENT('\\^\\{', '\\}');
  var KEY = {
    className: 'symbol',
    begin: '[:]{1,2}' + SYMBOL_RE
  };
  var LIST = {
    begin: '\\(',
    end: '\\)'
  };
  var BODY = {
    endsWithParent: true,
    relevance: 0
  };
  var NAME = {
    keywords: keywords,
    className: 'name',
    begin: SYMBOL_RE,
    relevance: 0,
    starts: BODY
  };
  var DEFAULT_CONTAINS = [LIST, STRING, HINT, HINT_COL, COMMENT, KEY, COLLECTION, NUMBER, LITERAL, SYMBOL];
  var GLOBAL = {
    beginKeywords: globals,
    lexemes: SYMBOL_RE,
    end: '(\\[|#|\\d|"|:|\\{|\\)|\\(|$)',
    contains: [{
      className: 'title',
      begin: SYMBOL_RE,
      relevance: 0,
      excludeEnd: true,
      // we can only have a single title
      endsParent: true
    }].concat(DEFAULT_CONTAINS)
  };
  LIST.contains = [hljs.COMMENT('comment', ''), GLOBAL, NAME, BODY];
  BODY.contains = DEFAULT_CONTAINS;
  COLLECTION.contains = DEFAULT_CONTAINS;
  HINT_COL.contains = [COLLECTION];
  return {
    name: 'Clojure',
    aliases: ['clj'],
    illegal: /\S/,
    contains: [LIST, STRING, HINT, HINT_COL, COMMENT, KEY, COLLECTION, NUMBER, LITERAL]
  };
}
module.exports = clojure;

/***/ }),

/***/ 82984:
/***/ ((module) => {

/*
Language: CMake
Description: CMake is an open-source cross-platform system for build automation.
Author: Igor Kalnitsky <igor@kalnitsky.org>
Website: https://cmake.org
*/

/** @type LanguageFn */
function cmake(hljs) {
  return {
    name: 'CMake',
    aliases: ['cmake.in'],
    case_insensitive: true,
    keywords: {
      keyword:
      // scripting commands
      'break cmake_host_system_information cmake_minimum_required cmake_parse_arguments ' + 'cmake_policy configure_file continue elseif else endforeach endfunction endif endmacro ' + 'endwhile execute_process file find_file find_library find_package find_path ' + 'find_program foreach function get_cmake_property get_directory_property ' + 'get_filename_component get_property if include include_guard list macro ' + 'mark_as_advanced math message option return separate_arguments ' + 'set_directory_properties set_property set site_name string unset variable_watch while ' +
      // project commands
      'add_compile_definitions add_compile_options add_custom_command add_custom_target ' + 'add_definitions add_dependencies add_executable add_library add_link_options ' + 'add_subdirectory add_test aux_source_directory build_command create_test_sourcelist ' + 'define_property enable_language enable_testing export fltk_wrap_ui ' + 'get_source_file_property get_target_property get_test_property include_directories ' + 'include_external_msproject include_regular_expression install link_directories ' + 'link_libraries load_cache project qt_wrap_cpp qt_wrap_ui remove_definitions ' + 'set_source_files_properties set_target_properties set_tests_properties source_group ' + 'target_compile_definitions target_compile_features target_compile_options ' + 'target_include_directories target_link_directories target_link_libraries ' + 'target_link_options target_sources try_compile try_run ' +
      // CTest commands
      'ctest_build ctest_configure ctest_coverage ctest_empty_binary_directory ctest_memcheck ' + 'ctest_read_custom_files ctest_run_script ctest_sleep ctest_start ctest_submit ' + 'ctest_test ctest_update ctest_upload ' +
      // deprecated commands
      'build_name exec_program export_library_dependencies install_files install_programs ' + 'install_targets load_command make_directory output_required_files remove ' + 'subdir_depends subdirs use_mangled_mesa utility_source variable_requires write_file ' + 'qt5_use_modules qt5_use_package qt5_wrap_cpp ' +
      // core keywords
      'on off true false and or not command policy target test exists is_newer_than ' + 'is_directory is_symlink is_absolute matches less greater equal less_equal ' + 'greater_equal strless strgreater strequal strless_equal strgreater_equal version_less ' + 'version_greater version_equal version_less_equal version_greater_equal in_list defined'
    },
    contains: [{
      className: 'variable',
      begin: /\$\{/,
      end: /\}/
    }, hljs.HASH_COMMENT_MODE, hljs.QUOTE_STRING_MODE, hljs.NUMBER_MODE]
  };
}
module.exports = cmake;

/***/ }),

/***/ 41515:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
__webpack_require__(26699);
__webpack_require__(32023);
__webpack_require__(57327);
var KEYWORDS = ["as",
// for exports
"in", "of", "if", "for", "while", "finally", "var", "new", "function", "do", "return", "void", "else", "break", "catch", "instanceof", "with", "throw", "case", "default", "try", "switch", "continue", "typeof", "delete", "let", "yield", "const", "class",
// JS handles these with a special rule
// "get",
// "set",
"debugger", "async", "await", "static", "import", "from", "export", "extends"];
var LITERALS = ["true", "false", "null", "undefined", "NaN", "Infinity"];
var TYPES = ["Intl", "DataView", "Number", "Math", "Date", "String", "RegExp", "Object", "Function", "Boolean", "Error", "Symbol", "Set", "Map", "WeakSet", "WeakMap", "Proxy", "Reflect", "JSON", "Promise", "Float64Array", "Int16Array", "Int32Array", "Int8Array", "Uint16Array", "Uint32Array", "Float32Array", "Array", "Uint8Array", "Uint8ClampedArray", "ArrayBuffer", "BigInt64Array", "BigUint64Array", "BigInt"];
var ERROR_TYPES = ["EvalError", "InternalError", "RangeError", "ReferenceError", "SyntaxError", "TypeError", "URIError"];
var BUILT_IN_GLOBALS = ["setInterval", "setTimeout", "clearInterval", "clearTimeout", "require", "exports", "eval", "isFinite", "isNaN", "parseFloat", "parseInt", "decodeURI", "decodeURIComponent", "encodeURI", "encodeURIComponent", "escape", "unescape"];
var BUILT_IN_VARIABLES = ["arguments", "this", "super", "console", "window", "document", "localStorage", "module", "global" // Node.js
];

var BUILT_INS = [].concat(BUILT_IN_GLOBALS, BUILT_IN_VARIABLES, TYPES, ERROR_TYPES);

/*
Language: CoffeeScript
Author: Dmytrii Nagirniak <dnagir@gmail.com>
Contributors: Oleg Efimov <efimovov@gmail.com>, Cédric Néhémie <cedric.nehemie@gmail.com>
Description: CoffeeScript is a programming language that transcompiles to JavaScript. For info about language see http://coffeescript.org/
Category: common, scripting
Website: https://coffeescript.org
*/

/** @type LanguageFn */
function coffeescript(hljs) {
  var COFFEE_BUILT_INS = ['npm', 'print'];
  var COFFEE_LITERALS = ['yes', 'no', 'on', 'off'];
  var COFFEE_KEYWORDS = ['then', 'unless', 'until', 'loop', 'by', 'when', 'and', 'or', 'is', 'isnt', 'not'];
  var NOT_VALID_KEYWORDS = ["var", "const", "let", "function", "static"];
  var excluding = function excluding(list) {
    return function (kw) {
      return !list.includes(kw);
    };
  };
  var KEYWORDS$1 = {
    keyword: KEYWORDS.concat(COFFEE_KEYWORDS).filter(excluding(NOT_VALID_KEYWORDS)),
    literal: LITERALS.concat(COFFEE_LITERALS),
    built_in: BUILT_INS.concat(COFFEE_BUILT_INS)
  };
  var JS_IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
  var SUBST = {
    className: 'subst',
    begin: /#\{/,
    end: /\}/,
    keywords: KEYWORDS$1
  };
  var EXPRESSIONS = [hljs.BINARY_NUMBER_MODE, hljs.inherit(hljs.C_NUMBER_MODE, {
    starts: {
      end: '(\\s*/)?',
      relevance: 0
    }
  }),
  // a number tries to eat the following slash to prevent treating it as a regexp
  {
    className: 'string',
    variants: [{
      begin: /'''/,
      end: /'''/,
      contains: [hljs.BACKSLASH_ESCAPE]
    }, {
      begin: /'/,
      end: /'/,
      contains: [hljs.BACKSLASH_ESCAPE]
    }, {
      begin: /"""/,
      end: /"""/,
      contains: [hljs.BACKSLASH_ESCAPE, SUBST]
    }, {
      begin: /"/,
      end: /"/,
      contains: [hljs.BACKSLASH_ESCAPE, SUBST]
    }]
  }, {
    className: 'regexp',
    variants: [{
      begin: '///',
      end: '///',
      contains: [SUBST, hljs.HASH_COMMENT_MODE]
    }, {
      begin: '//[gim]{0,3}(?=\\W)',
      relevance: 0
    }, {
      // regex can't start with space to parse x / 2 / 3 as two divisions
      // regex can't start with *, and it supports an "illegal" in the main mode
      begin: /\/(?![ *]).*?(?![\\]).\/[gim]{0,3}(?=\W)/
    }]
  }, {
    begin: '@' + JS_IDENT_RE // relevance booster
  }, {
    subLanguage: 'javascript',
    excludeBegin: true,
    excludeEnd: true,
    variants: [{
      begin: '```',
      end: '```'
    }, {
      begin: '`',
      end: '`'
    }]
  }];
  SUBST.contains = EXPRESSIONS;
  var TITLE = hljs.inherit(hljs.TITLE_MODE, {
    begin: JS_IDENT_RE
  });
  var POSSIBLE_PARAMS_RE = '(\\(.*\\)\\s*)?\\B[-=]>';
  var PARAMS = {
    className: 'params',
    begin: '\\([^\\(]',
    returnBegin: true,
    /* We need another contained nameless mode to not have every nested
    pair of parens to be called "params" */
    contains: [{
      begin: /\(/,
      end: /\)/,
      keywords: KEYWORDS$1,
      contains: ['self'].concat(EXPRESSIONS)
    }]
  };
  return {
    name: 'CoffeeScript',
    aliases: ['coffee', 'cson', 'iced'],
    keywords: KEYWORDS$1,
    illegal: /\/\*/,
    contains: EXPRESSIONS.concat([hljs.COMMENT('###', '###'), hljs.HASH_COMMENT_MODE, {
      className: 'function',
      begin: '^\\s*' + JS_IDENT_RE + '\\s*=\\s*' + POSSIBLE_PARAMS_RE,
      end: '[-=]>',
      returnBegin: true,
      contains: [TITLE, PARAMS]
    }, {
      // anonymous function start
      begin: /[:\(,=]\s*/,
      relevance: 0,
      contains: [{
        className: 'function',
        begin: POSSIBLE_PARAMS_RE,
        end: '[-=]>',
        returnBegin: true,
        contains: [PARAMS]
      }]
    }, {
      className: 'class',
      beginKeywords: 'class',
      end: '$',
      illegal: /[:="\[\]]/,
      contains: [{
        beginKeywords: 'extends',
        endsWithParent: true,
        illegal: /[:="\[\]]/,
        contains: [TITLE]
      }, TITLE]
    }, {
      begin: JS_IDENT_RE + ':',
      end: ':',
      returnBegin: true,
      returnEnd: true,
      relevance: 0
    }])
  };
}
module.exports = coffeescript;

/***/ }),

/***/ 67696:
/***/ ((module) => {

/*
Language: Coq
Author: Stephan Boyer <stephan@stephanboyer.com>
Category: functional
Website: https://coq.inria.fr
*/

/** @type LanguageFn */
function coq(hljs) {
  return {
    name: 'Coq',
    keywords: {
      keyword: '_|0 as at cofix else end exists exists2 fix for forall fun if IF in let ' + 'match mod Prop return Set then Type using where with ' + 'Abort About Add Admit Admitted All Arguments Assumptions Axiom Back BackTo ' + 'Backtrack Bind Blacklist Canonical Cd Check Class Classes Close Coercion ' + 'Coercions CoFixpoint CoInductive Collection Combined Compute Conjecture ' + 'Conjectures Constant constr Constraint Constructors Context Corollary ' + 'CreateHintDb Cut Declare Defined Definition Delimit Dependencies Dependent ' + 'Derive Drop eauto End Equality Eval Example Existential Existentials ' + 'Existing Export exporting Extern Extract Extraction Fact Field Fields File ' + 'Fixpoint Focus for From Function Functional Generalizable Global Goal Grab ' + 'Grammar Graph Guarded Heap Hint HintDb Hints Hypotheses Hypothesis ident ' + 'Identity If Immediate Implicit Import Include Inductive Infix Info Initial ' + 'Inline Inspect Instance Instances Intro Intros Inversion Inversion_clear ' + 'Language Left Lemma Let Libraries Library Load LoadPath Local Locate Ltac ML ' + 'Mode Module Modules Monomorphic Morphism Next NoInline Notation Obligation ' + 'Obligations Opaque Open Optimize Options Parameter Parameters Parametric ' + 'Path Paths pattern Polymorphic Preterm Print Printing Program Projections ' + 'Proof Proposition Pwd Qed Quit Rec Record Recursive Redirect Relation Remark ' + 'Remove Require Reserved Reset Resolve Restart Rewrite Right Ring Rings Save ' + 'Scheme Scope Scopes Script Search SearchAbout SearchHead SearchPattern ' + 'SearchRewrite Section Separate Set Setoid Show Solve Sorted Step Strategies ' + 'Strategy Structure SubClass Table Tables Tactic Term Test Theorem Time ' + 'Timeout Transparent Type Typeclasses Types Undelimit Undo Unfocus Unfocused ' + 'Unfold Universe Universes Unset Unshelve using Variable Variables Variant ' + 'Verbose Visibility where with',
      built_in: 'abstract absurd admit after apply as assert assumption at auto autorewrite ' + 'autounfold before bottom btauto by case case_eq cbn cbv change ' + 'classical_left classical_right clear clearbody cofix compare compute ' + 'congruence constr_eq constructor contradict contradiction cut cutrewrite ' + 'cycle decide decompose dependent destruct destruction dintuition ' + 'discriminate discrR do double dtauto eapply eassumption eauto ecase ' + 'econstructor edestruct ediscriminate eelim eexact eexists einduction ' + 'einjection eleft elim elimtype enough equality erewrite eright ' + 'esimplify_eq esplit evar exact exactly_once exfalso exists f_equal fail ' + 'field field_simplify field_simplify_eq first firstorder fix fold fourier ' + 'functional generalize generalizing gfail give_up has_evar hnf idtac in ' + 'induction injection instantiate intro intro_pattern intros intuition ' + 'inversion inversion_clear is_evar is_var lapply lazy left lia lra move ' + 'native_compute nia nsatz omega once pattern pose progress proof psatz quote ' + 'record red refine reflexivity remember rename repeat replace revert ' + 'revgoals rewrite rewrite_strat right ring ring_simplify rtauto set ' + 'setoid_reflexivity setoid_replace setoid_rewrite setoid_symmetry ' + 'setoid_transitivity shelve shelve_unifiable simpl simple simplify_eq solve ' + 'specialize split split_Rabs split_Rmult stepl stepr subst sum swap ' + 'symmetry tactic tauto time timeout top transitivity trivial try tryif ' + 'unfold unify until using vm_compute with'
    },
    contains: [hljs.QUOTE_STRING_MODE, hljs.COMMENT('\\(\\*', '\\*\\)'), hljs.C_NUMBER_MODE, {
      className: 'type',
      excludeBegin: true,
      begin: '\\|\\s*',
      end: '\\w+'
    }, {
      // relevance booster
      begin: /[-=]>/
    }]
  };
}
module.exports = coq;

/***/ }),

/***/ 91771:
/***/ ((module) => {

/*
Language: Caché Object Script
Author: Nikita Savchenko <zitros.lab@gmail.com>
Category: enterprise, scripting
Website: https://cedocs.intersystems.com/latest/csp/docbook/DocBook.UI.Page.cls
*/

/** @type LanguageFn */
function cos(hljs) {
  var STRINGS = {
    className: 'string',
    variants: [{
      begin: '"',
      end: '"',
      contains: [{
        // escaped
        begin: "\"\"",
        relevance: 0
      }]
    }]
  };
  var NUMBERS = {
    className: "number",
    begin: "\\b(\\d+(\\.\\d*)?|\\.\\d+)",
    relevance: 0
  };
  var COS_KEYWORDS = 'property parameter class classmethod clientmethod extends as break ' + 'catch close continue do d|0 else elseif for goto halt hang h|0 if job ' + 'j|0 kill k|0 lock l|0 merge new open quit q|0 read r|0 return set s|0 ' + 'tcommit throw trollback try tstart use view while write w|0 xecute x|0 ' + 'zkill znspace zn ztrap zwrite zw zzdump zzwrite print zbreak zinsert ' + 'zload zprint zremove zsave zzprint mv mvcall mvcrt mvdim mvprint zquit ' + 'zsync ascii';

  // registered function - no need in them due to all functions are highlighted,
  // but I'll just leave this here.

  // "$bit", "$bitcount",
  // "$bitfind", "$bitlogic", "$case", "$char", "$classmethod", "$classname",
  // "$compile", "$data", "$decimal", "$double", "$extract", "$factor",
  // "$find", "$fnumber", "$get", "$increment", "$inumber", "$isobject",
  // "$isvaliddouble", "$isvalidnum", "$justify", "$length", "$list",
  // "$listbuild", "$listdata", "$listfind", "$listfromstring", "$listget",
  // "$listlength", "$listnext", "$listsame", "$listtostring", "$listvalid",
  // "$locate", "$match", "$method", "$name", "$nconvert", "$next",
  // "$normalize", "$now", "$number", "$order", "$parameter", "$piece",
  // "$prefetchoff", "$prefetchon", "$property", "$qlength", "$qsubscript",
  // "$query", "$random", "$replace", "$reverse", "$sconvert", "$select",
  // "$sortbegin", "$sortend", "$stack", "$text", "$translate", "$view",
  // "$wascii", "$wchar", "$wextract", "$wfind", "$wiswide", "$wlength",
  // "$wreverse", "$xecute", "$zabs", "$zarccos", "$zarcsin", "$zarctan",
  // "$zcos", "$zcot", "$zcsc", "$zdate", "$zdateh", "$zdatetime",
  // "$zdatetimeh", "$zexp", "$zhex", "$zln", "$zlog", "$zpower", "$zsec",
  // "$zsin", "$zsqr", "$ztan", "$ztime", "$ztimeh", "$zboolean",
  // "$zconvert", "$zcrc", "$zcyc", "$zdascii", "$zdchar", "$zf",
  // "$ziswide", "$zlascii", "$zlchar", "$zname", "$zposition", "$zqascii",
  // "$zqchar", "$zsearch", "$zseek", "$zstrip", "$zwascii", "$zwchar",
  // "$zwidth", "$zwpack", "$zwbpack", "$zwunpack", "$zwbunpack", "$zzenkaku",
  // "$change", "$mv", "$mvat", "$mvfmt", "$mvfmts", "$mviconv",
  // "$mviconvs", "$mvinmat", "$mvlover", "$mvoconv", "$mvoconvs", "$mvraise",
  // "$mvtrans", "$mvv", "$mvname", "$zbitand", "$zbitcount", "$zbitfind",
  // "$zbitget", "$zbitlen", "$zbitnot", "$zbitor", "$zbitset", "$zbitstr",
  // "$zbitxor", "$zincrement", "$znext", "$zorder", "$zprevious", "$zsort",
  // "device", "$ecode", "$estack", "$etrap", "$halt", "$horolog",
  // "$io", "$job", "$key", "$namespace", "$principal", "$quit", "$roles",
  // "$storage", "$system", "$test", "$this", "$tlevel", "$username",
  // "$x", "$y", "$za", "$zb", "$zchild", "$zeof", "$zeos", "$zerror",
  // "$zhorolog", "$zio", "$zjob", "$zmode", "$znspace", "$zparent", "$zpi",
  // "$zpos", "$zreference", "$zstorage", "$ztimestamp", "$ztimezone",
  // "$ztrap", "$zversion"

  return {
    name: 'Caché Object Script',
    case_insensitive: true,
    aliases: ["cls"],
    keywords: COS_KEYWORDS,
    contains: [NUMBERS, STRINGS, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, {
      className: "comment",
      begin: /;/,
      end: "$",
      relevance: 0
    }, {
      // Functions and user-defined functions: write $ztime(60*60*3), $$myFunc(10), $$^Val(1)
      className: "built_in",
      begin: /(?:\$\$?|\.\.)\^?[a-zA-Z]+/
    }, {
      // Macro command: quit $$$OK
      className: "built_in",
      begin: /\$\$\$[a-zA-Z]+/
    }, {
      // Special (global) variables: write %request.Content; Built-in classes: %Library.Integer
      className: "built_in",
      begin: /%[a-z]+(?:\.[a-z]+)*/
    }, {
      // Global variable: set ^globalName = 12 write ^globalName
      className: "symbol",
      begin: /\^%?[a-zA-Z][\w]*/
    }, {
      // Some control constructions: do ##class(Package.ClassName).Method(), ##super()
      className: "keyword",
      begin: /##class|##super|#define|#dim/
    },
    // sub-languages: are not fully supported by hljs by 11/15/2015
    // left for the future implementation.
    {
      begin: /&sql\(/,
      end: /\)/,
      excludeBegin: true,
      excludeEnd: true,
      subLanguage: "sql"
    }, {
      begin: /&(js|jscript|javascript)</,
      end: />/,
      excludeBegin: true,
      excludeEnd: true,
      subLanguage: "javascript"
    }, {
      // this brakes first and last tag, but this is the only way to embed a valid html
      begin: /&html<\s*</,
      end: />\s*>/,
      subLanguage: "xml"
    }]
  };
}
module.exports = cos;

/***/ }),

/***/ 227:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(92222);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function lookahead(re) {
  return concat('(?=', re, ')');
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function optional(re) {
  return concat('(', re, ')?');
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/*
Language: C++
Category: common, system
Website: https://isocpp.org
*/

/** @type LanguageFn */
function cpp(hljs) {
  // added for historic reasons because `hljs.C_LINE_COMMENT_MODE` does
  // not include such support nor can we be sure all the grammars depending
  // on it would desire this behavior
  var C_LINE_COMMENT_MODE = hljs.COMMENT('//', '$', {
    contains: [{
      begin: /\\\n/
    }]
  });
  var DECLTYPE_AUTO_RE = 'decltype\\(auto\\)';
  var NAMESPACE_RE = '[a-zA-Z_]\\w*::';
  var TEMPLATE_ARGUMENT_RE = '<[^<>]+>';
  var FUNCTION_TYPE_RE = '(' + DECLTYPE_AUTO_RE + '|' + optional(NAMESPACE_RE) + '[a-zA-Z_]\\w*' + optional(TEMPLATE_ARGUMENT_RE) + ')';
  var CPP_PRIMITIVE_TYPES = {
    className: 'keyword',
    begin: '\\b[a-z\\d_]*_t\\b'
  };

  // https://en.cppreference.com/w/cpp/language/escape
  // \\ \x \xFF \u2837 \u00323747 \374
  var CHARACTER_ESCAPES = '\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)';
  var STRINGS = {
    className: 'string',
    variants: [{
      begin: '(u8?|U|L)?"',
      end: '"',
      illegal: '\\n',
      contains: [hljs.BACKSLASH_ESCAPE]
    }, {
      begin: '(u8?|U|L)?\'(' + CHARACTER_ESCAPES + "|.)",
      end: '\'',
      illegal: '.'
    }, hljs.END_SAME_AS_BEGIN({
      begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
      end: /\)([^()\\ ]{0,16})"/
    })]
  };
  var NUMBERS = {
    className: 'number',
    variants: [{
      begin: '\\b(0b[01\']+)'
    }, {
      begin: '(-?)\\b([\\d\']+(\\.[\\d\']*)?|\\.[\\d\']+)((ll|LL|l|L)(u|U)?|(u|U)(ll|LL|l|L)?|f|F|b|B)'
    }, {
      begin: '(-?)(\\b0[xX][a-fA-F0-9\']+|(\\b[\\d\']+(\\.[\\d\']*)?|\\.[\\d\']+)([eE][-+]?[\\d\']+)?)'
    }],
    relevance: 0
  };
  var PREPROCESSOR = {
    className: 'meta',
    begin: /#\s*[a-z]+\b/,
    end: /$/,
    keywords: {
      'meta-keyword': 'if else elif endif define undef warning error line ' + 'pragma _Pragma ifdef ifndef include'
    },
    contains: [{
      begin: /\\\n/,
      relevance: 0
    }, hljs.inherit(STRINGS, {
      className: 'meta-string'
    }), {
      className: 'meta-string',
      begin: /<.*?>/
    }, C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE]
  };
  var TITLE_MODE = {
    className: 'title',
    begin: optional(NAMESPACE_RE) + hljs.IDENT_RE,
    relevance: 0
  };
  var FUNCTION_TITLE = optional(NAMESPACE_RE) + hljs.IDENT_RE + '\\s*\\(';
  var COMMON_CPP_HINTS = ['asin', 'atan2', 'atan', 'calloc', 'ceil', 'cosh', 'cos', 'exit', 'exp', 'fabs', 'floor', 'fmod', 'fprintf', 'fputs', 'free', 'frexp', 'auto_ptr', 'deque', 'list', 'queue', 'stack', 'vector', 'map', 'set', 'pair', 'bitset', 'multiset', 'multimap', 'unordered_set', 'fscanf', 'future', 'isalnum', 'isalpha', 'iscntrl', 'isdigit', 'isgraph', 'islower', 'isprint', 'ispunct', 'isspace', 'isupper', 'isxdigit', 'tolower', 'toupper', 'labs', 'ldexp', 'log10', 'log', 'malloc', 'realloc', 'memchr', 'memcmp', 'memcpy', 'memset', 'modf', 'pow', 'printf', 'putchar', 'puts', 'scanf', 'sinh', 'sin', 'snprintf', 'sprintf', 'sqrt', 'sscanf', 'strcat', 'strchr', 'strcmp', 'strcpy', 'strcspn', 'strlen', 'strncat', 'strncmp', 'strncpy', 'strpbrk', 'strrchr', 'strspn', 'strstr', 'tanh', 'tan', 'unordered_map', 'unordered_multiset', 'unordered_multimap', 'priority_queue', 'make_pair', 'array', 'shared_ptr', 'abort', 'terminate', 'abs', 'acos', 'vfprintf', 'vprintf', 'vsprintf', 'endl', 'initializer_list', 'unique_ptr', 'complex', 'imaginary', 'std', 'string', 'wstring', 'cin', 'cout', 'cerr', 'clog', 'stdin', 'stdout', 'stderr', 'stringstream', 'istringstream', 'ostringstream'];
  var CPP_KEYWORDS = {
    keyword: 'int float while private char char8_t char16_t char32_t catch import module export virtual operator sizeof ' + 'dynamic_cast|10 typedef const_cast|10 const for static_cast|10 union namespace ' + 'unsigned long volatile static protected bool template mutable if public friend ' + 'do goto auto void enum else break extern using asm case typeid wchar_t ' + 'short reinterpret_cast|10 default double register explicit signed typename try this ' + 'switch continue inline delete alignas alignof constexpr consteval constinit decltype ' + 'concept co_await co_return co_yield requires ' + 'noexcept static_assert thread_local restrict final override ' + 'atomic_bool atomic_char atomic_schar ' + 'atomic_uchar atomic_short atomic_ushort atomic_int atomic_uint atomic_long atomic_ulong atomic_llong ' + 'atomic_ullong new throw return ' + 'and and_eq bitand bitor compl not not_eq or or_eq xor xor_eq',
    built_in: '_Bool _Complex _Imaginary',
    _relevance_hints: COMMON_CPP_HINTS,
    literal: 'true false nullptr NULL'
  };
  var FUNCTION_DISPATCH = {
    className: "function.dispatch",
    relevance: 0,
    keywords: CPP_KEYWORDS,
    begin: concat(/\b/, /(?!decltype)/, /(?!if)/, /(?!for)/, /(?!while)/, hljs.IDENT_RE, lookahead(/\s*\(/))
  };
  var EXPRESSION_CONTAINS = [FUNCTION_DISPATCH, PREPROCESSOR, CPP_PRIMITIVE_TYPES, C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, NUMBERS, STRINGS];
  var EXPRESSION_CONTEXT = {
    // This mode covers expression context where we can't expect a function
    // definition and shouldn't highlight anything that looks like one:
    // `return some()`, `else if()`, `(x*sum(1, 2))`
    variants: [{
      begin: /=/,
      end: /;/
    }, {
      begin: /\(/,
      end: /\)/
    }, {
      beginKeywords: 'new throw return else',
      end: /;/
    }],
    keywords: CPP_KEYWORDS,
    contains: EXPRESSION_CONTAINS.concat([{
      begin: /\(/,
      end: /\)/,
      keywords: CPP_KEYWORDS,
      contains: EXPRESSION_CONTAINS.concat(['self']),
      relevance: 0
    }]),
    relevance: 0
  };
  var FUNCTION_DECLARATION = {
    className: 'function',
    begin: '(' + FUNCTION_TYPE_RE + '[\\*&\\s]+)+' + FUNCTION_TITLE,
    returnBegin: true,
    end: /[{;=]/,
    excludeEnd: true,
    keywords: CPP_KEYWORDS,
    illegal: /[^\w\s\*&:<>.]/,
    contains: [{
      // to prevent it from being confused as the function title
      begin: DECLTYPE_AUTO_RE,
      keywords: CPP_KEYWORDS,
      relevance: 0
    }, {
      begin: FUNCTION_TITLE,
      returnBegin: true,
      contains: [TITLE_MODE],
      relevance: 0
    },
    // needed because we do not have look-behind on the below rule
    // to prevent it from grabbing the final : in a :: pair
    {
      begin: /::/,
      relevance: 0
    },
    // initializers
    {
      begin: /:/,
      endsWithParent: true,
      contains: [STRINGS, NUMBERS]
    }, {
      className: 'params',
      begin: /\(/,
      end: /\)/,
      keywords: CPP_KEYWORDS,
      relevance: 0,
      contains: [C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, STRINGS, NUMBERS, CPP_PRIMITIVE_TYPES,
      // Count matching parentheses.
      {
        begin: /\(/,
        end: /\)/,
        keywords: CPP_KEYWORDS,
        relevance: 0,
        contains: ['self', C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, STRINGS, NUMBERS, CPP_PRIMITIVE_TYPES]
      }]
    }, CPP_PRIMITIVE_TYPES, C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, PREPROCESSOR]
  };
  return {
    name: 'C++',
    aliases: ['cc', 'c++', 'h++', 'hpp', 'hh', 'hxx', 'cxx'],
    keywords: CPP_KEYWORDS,
    illegal: '</',
    classNameAliases: {
      "function.dispatch": "built_in"
    },
    contains: [].concat(EXPRESSION_CONTEXT, FUNCTION_DECLARATION, FUNCTION_DISPATCH, EXPRESSION_CONTAINS, [PREPROCESSOR, {
      // containers: ie, `vector <int> rooms (9);`
      begin: '\\b(deque|list|queue|priority_queue|pair|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array)\\s*<',
      end: '>',
      keywords: CPP_KEYWORDS,
      contains: ['self', CPP_PRIMITIVE_TYPES]
    }, {
      begin: hljs.IDENT_RE + '::',
      keywords: CPP_KEYWORDS
    }, {
      className: 'class',
      beginKeywords: 'enum class struct union',
      end: /[{;:<>=]/,
      contains: [{
        beginKeywords: "final class struct"
      }, hljs.TITLE_MODE]
    }]),
    exports: {
      preprocessor: PREPROCESSOR,
      strings: STRINGS,
      keywords: CPP_KEYWORDS
    }
  };
}
module.exports = cpp;

/***/ }),

/***/ 52685:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(74916);
__webpack_require__(23123);
/*
Language: crmsh
Author: Kristoffer Gronlund <kgronlund@suse.com>
Website: http://crmsh.github.io
Description: Syntax Highlighting for the crmsh DSL
Category: config
*/

/** @type LanguageFn */
function crmsh(hljs) {
  var RESOURCES = 'primitive rsc_template';
  var COMMANDS = 'group clone ms master location colocation order fencing_topology ' + 'rsc_ticket acl_target acl_group user role ' + 'tag xml';
  var PROPERTY_SETS = 'property rsc_defaults op_defaults';
  var KEYWORDS = 'params meta operations op rule attributes utilization';
  var OPERATORS = 'read write deny defined not_defined in_range date spec in ' + 'ref reference attribute type xpath version and or lt gt tag ' + 'lte gte eq ne \\';
  var TYPES = 'number string';
  var LITERALS = 'Master Started Slave Stopped start promote demote stop monitor true false';
  return {
    name: 'crmsh',
    aliases: ['crm', 'pcmk'],
    case_insensitive: true,
    keywords: {
      keyword: KEYWORDS + ' ' + OPERATORS + ' ' + TYPES,
      literal: LITERALS
    },
    contains: [hljs.HASH_COMMENT_MODE, {
      beginKeywords: 'node',
      starts: {
        end: '\\s*([\\w_-]+:)?',
        starts: {
          className: 'title',
          end: '\\s*[\\$\\w_][\\w_-]*'
        }
      }
    }, {
      beginKeywords: RESOURCES,
      starts: {
        className: 'title',
        end: '\\s*[\\$\\w_][\\w_-]*',
        starts: {
          end: '\\s*@?[\\w_][\\w_\\.:-]*'
        }
      }
    }, {
      begin: '\\b(' + COMMANDS.split(' ').join('|') + ')\\s+',
      keywords: COMMANDS,
      starts: {
        className: 'title',
        end: '[\\$\\w_][\\w_-]*'
      }
    }, {
      beginKeywords: PROPERTY_SETS,
      starts: {
        className: 'title',
        end: '\\s*([\\w_-]+:)?'
      }
    }, hljs.QUOTE_STRING_MODE, {
      className: 'meta',
      begin: '(ocf|systemd|service|lsb):[\\w_:-]+',
      relevance: 0
    }, {
      className: 'number',
      begin: '\\b\\d+(\\.\\d+)?(ms|s|h|m)?',
      relevance: 0
    }, {
      className: 'literal',
      begin: '[-]?(infinity|inf)',
      relevance: 0
    }, {
      className: 'attr',
      begin: /([A-Za-z$_#][\w_-]+)=/,
      relevance: 0
    }, {
      className: 'tag',
      begin: '</?',
      end: '/?>',
      relevance: 0
    }]
  };
}
module.exports = crmsh;

/***/ }),

/***/ 32599:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(47042);
/*
Language: Crystal
Author: TSUYUSATO Kitsune <make.just.on@gmail.com>
Website: https://crystal-lang.org
*/

/** @type LanguageFn */
function crystal(hljs) {
  var INT_SUFFIX = '(_?[ui](8|16|32|64|128))?';
  var FLOAT_SUFFIX = '(_?f(32|64))?';
  var CRYSTAL_IDENT_RE = '[a-zA-Z_]\\w*[!?=]?';
  var CRYSTAL_METHOD_RE = '[a-zA-Z_]\\w*[!?=]?|[-+~]@|<<|>>|[=!]~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~|]|//|//=|&[-+*]=?|&\\*\\*|\\[\\][=?]?';
  var CRYSTAL_PATH_RE = '[A-Za-z_]\\w*(::\\w+)*(\\?|!)?';
  var CRYSTAL_KEYWORDS = {
    $pattern: CRYSTAL_IDENT_RE,
    keyword: 'abstract alias annotation as as? asm begin break case class def do else elsif end ensure enum extend for fun if ' + 'include instance_sizeof is_a? lib macro module next nil? of out pointerof private protected rescue responds_to? ' + 'return require select self sizeof struct super then type typeof union uninitialized unless until verbatim when while with yield ' + '__DIR__ __END_LINE__ __FILE__ __LINE__',
    literal: 'false nil true'
  };
  var SUBST = {
    className: 'subst',
    begin: /#\{/,
    end: /\}/,
    keywords: CRYSTAL_KEYWORDS
  };
  var EXPANSION = {
    className: 'template-variable',
    variants: [{
      begin: '\\{\\{',
      end: '\\}\\}'
    }, {
      begin: '\\{%',
      end: '%\\}'
    }],
    keywords: CRYSTAL_KEYWORDS
  };
  function recursiveParen(begin, end) {
    var contains = [{
      begin: begin,
      end: end
    }];
    contains[0].contains = contains;
    return contains;
  }
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, SUBST],
    variants: [{
      begin: /'/,
      end: /'/
    }, {
      begin: /"/,
      end: /"/
    }, {
      begin: /`/,
      end: /`/
    }, {
      begin: '%[Qwi]?\\(',
      end: '\\)',
      contains: recursiveParen('\\(', '\\)')
    }, {
      begin: '%[Qwi]?\\[',
      end: '\\]',
      contains: recursiveParen('\\[', '\\]')
    }, {
      begin: '%[Qwi]?\\{',
      end: /\}/,
      contains: recursiveParen(/\{/, /\}/)
    }, {
      begin: '%[Qwi]?<',
      end: '>',
      contains: recursiveParen('<', '>')
    }, {
      begin: '%[Qwi]?\\|',
      end: '\\|'
    }, {
      begin: /<<-\w+$/,
      end: /^\s*\w+$/
    }],
    relevance: 0
  };
  var Q_STRING = {
    className: 'string',
    variants: [{
      begin: '%q\\(',
      end: '\\)',
      contains: recursiveParen('\\(', '\\)')
    }, {
      begin: '%q\\[',
      end: '\\]',
      contains: recursiveParen('\\[', '\\]')
    }, {
      begin: '%q\\{',
      end: /\}/,
      contains: recursiveParen(/\{/, /\}/)
    }, {
      begin: '%q<',
      end: '>',
      contains: recursiveParen('<', '>')
    }, {
      begin: '%q\\|',
      end: '\\|'
    }, {
      begin: /<<-'\w+'$/,
      end: /^\s*\w+$/
    }],
    relevance: 0
  };
  var REGEXP = {
    begin: '(?!%\\})(' + hljs.RE_STARTERS_RE + '|\\n|\\b(case|if|select|unless|until|when|while)\\b)\\s*',
    keywords: 'case if select unless until when while',
    contains: [{
      className: 'regexp',
      contains: [hljs.BACKSLASH_ESCAPE, SUBST],
      variants: [{
        begin: '//[a-z]*',
        relevance: 0
      }, {
        begin: '/(?!\\/)',
        end: '/[a-z]*'
      }]
    }],
    relevance: 0
  };
  var REGEXP2 = {
    className: 'regexp',
    contains: [hljs.BACKSLASH_ESCAPE, SUBST],
    variants: [{
      begin: '%r\\(',
      end: '\\)',
      contains: recursiveParen('\\(', '\\)')
    }, {
      begin: '%r\\[',
      end: '\\]',
      contains: recursiveParen('\\[', '\\]')
    }, {
      begin: '%r\\{',
      end: /\}/,
      contains: recursiveParen(/\{/, /\}/)
    }, {
      begin: '%r<',
      end: '>',
      contains: recursiveParen('<', '>')
    }, {
      begin: '%r\\|',
      end: '\\|'
    }],
    relevance: 0
  };
  var ATTRIBUTE = {
    className: 'meta',
    begin: '@\\[',
    end: '\\]',
    contains: [hljs.inherit(hljs.QUOTE_STRING_MODE, {
      className: 'meta-string'
    })]
  };
  var CRYSTAL_DEFAULT_CONTAINS = [EXPANSION, STRING, Q_STRING, REGEXP2, REGEXP, ATTRIBUTE, hljs.HASH_COMMENT_MODE, {
    className: 'class',
    beginKeywords: 'class module struct',
    end: '$|;',
    illegal: /=/,
    contains: [hljs.HASH_COMMENT_MODE, hljs.inherit(hljs.TITLE_MODE, {
      begin: CRYSTAL_PATH_RE
    }), {
      // relevance booster for inheritance
      begin: '<'
    }]
  }, {
    className: 'class',
    beginKeywords: 'lib enum union',
    end: '$|;',
    illegal: /=/,
    contains: [hljs.HASH_COMMENT_MODE, hljs.inherit(hljs.TITLE_MODE, {
      begin: CRYSTAL_PATH_RE
    })]
  }, {
    beginKeywords: 'annotation',
    end: '$|;',
    illegal: /=/,
    contains: [hljs.HASH_COMMENT_MODE, hljs.inherit(hljs.TITLE_MODE, {
      begin: CRYSTAL_PATH_RE
    })],
    relevance: 2
  }, {
    className: 'function',
    beginKeywords: 'def',
    end: /\B\b/,
    contains: [hljs.inherit(hljs.TITLE_MODE, {
      begin: CRYSTAL_METHOD_RE,
      endsParent: true
    })]
  }, {
    className: 'function',
    beginKeywords: 'fun macro',
    end: /\B\b/,
    contains: [hljs.inherit(hljs.TITLE_MODE, {
      begin: CRYSTAL_METHOD_RE,
      endsParent: true
    })],
    relevance: 2
  }, {
    className: 'symbol',
    begin: hljs.UNDERSCORE_IDENT_RE + '(!|\\?)?:',
    relevance: 0
  }, {
    className: 'symbol',
    begin: ':',
    contains: [STRING, {
      begin: CRYSTAL_METHOD_RE
    }],
    relevance: 0
  }, {
    className: 'number',
    variants: [{
      begin: '\\b0b([01_]+)' + INT_SUFFIX
    }, {
      begin: '\\b0o([0-7_]+)' + INT_SUFFIX
    }, {
      begin: '\\b0x([A-Fa-f0-9_]+)' + INT_SUFFIX
    }, {
      begin: '\\b([1-9][0-9_]*[0-9]|[0-9])(\\.[0-9][0-9_]*)?([eE]_?[-+]?[0-9_]*)?' + FLOAT_SUFFIX + '(?!_)'
    }, {
      begin: '\\b([1-9][0-9_]*|0)' + INT_SUFFIX
    }],
    relevance: 0
  }];
  SUBST.contains = CRYSTAL_DEFAULT_CONTAINS;
  EXPANSION.contains = CRYSTAL_DEFAULT_CONTAINS.slice(1); // without EXPANSION

  return {
    name: 'Crystal',
    aliases: ['cr'],
    keywords: CRYSTAL_KEYWORDS,
    contains: CRYSTAL_DEFAULT_CONTAINS
  };
}
module.exports = crystal;

/***/ }),

/***/ 16718:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
__webpack_require__(69600);
/*
Language: C#
Author: Jason Diamond <jason@diamond.name>
Contributor: Nicolas LLOBERA <nllobera@gmail.com>, Pieter Vantorre <pietervantorre@gmail.com>, David Pine <david.pine@microsoft.com>
Website: https://docs.microsoft.com/en-us/dotnet/csharp/
Category: common
*/

/** @type LanguageFn */
function csharp(hljs) {
  var BUILT_IN_KEYWORDS = ['bool', 'byte', 'char', 'decimal', 'delegate', 'double', 'dynamic', 'enum', 'float', 'int', 'long', 'nint', 'nuint', 'object', 'sbyte', 'short', 'string', 'ulong', 'uint', 'ushort'];
  var FUNCTION_MODIFIERS = ['public', 'private', 'protected', 'static', 'internal', 'protected', 'abstract', 'async', 'extern', 'override', 'unsafe', 'virtual', 'new', 'sealed', 'partial'];
  var LITERAL_KEYWORDS = ['default', 'false', 'null', 'true'];
  var NORMAL_KEYWORDS = ['abstract', 'as', 'base', 'break', 'case', 'class', 'const', 'continue', 'do', 'else', 'event', 'explicit', 'extern', 'finally', 'fixed', 'for', 'foreach', 'goto', 'if', 'implicit', 'in', 'interface', 'internal', 'is', 'lock', 'namespace', 'new', 'operator', 'out', 'override', 'params', 'private', 'protected', 'public', 'readonly', 'record', 'ref', 'return', 'sealed', 'sizeof', 'stackalloc', 'static', 'struct', 'switch', 'this', 'throw', 'try', 'typeof', 'unchecked', 'unsafe', 'using', 'virtual', 'void', 'volatile', 'while'];
  var CONTEXTUAL_KEYWORDS = ['add', 'alias', 'and', 'ascending', 'async', 'await', 'by', 'descending', 'equals', 'from', 'get', 'global', 'group', 'init', 'into', 'join', 'let', 'nameof', 'not', 'notnull', 'on', 'or', 'orderby', 'partial', 'remove', 'select', 'set', 'unmanaged', 'value|0', 'var', 'when', 'where', 'with', 'yield'];
  var KEYWORDS = {
    keyword: NORMAL_KEYWORDS.concat(CONTEXTUAL_KEYWORDS),
    built_in: BUILT_IN_KEYWORDS,
    literal: LITERAL_KEYWORDS
  };
  var TITLE_MODE = hljs.inherit(hljs.TITLE_MODE, {
    begin: '[a-zA-Z](\\.?\\w)*'
  });
  var NUMBERS = {
    className: 'number',
    variants: [{
      begin: '\\b(0b[01\']+)'
    }, {
      begin: '(-?)\\b([\\d\']+(\\.[\\d\']*)?|\\.[\\d\']+)(u|U|l|L|ul|UL|f|F|b|B)'
    }, {
      begin: '(-?)(\\b0[xX][a-fA-F0-9\']+|(\\b[\\d\']+(\\.[\\d\']*)?|\\.[\\d\']+)([eE][-+]?[\\d\']+)?)'
    }],
    relevance: 0
  };
  var VERBATIM_STRING = {
    className: 'string',
    begin: '@"',
    end: '"',
    contains: [{
      begin: '""'
    }]
  };
  var VERBATIM_STRING_NO_LF = hljs.inherit(VERBATIM_STRING, {
    illegal: /\n/
  });
  var SUBST = {
    className: 'subst',
    begin: /\{/,
    end: /\}/,
    keywords: KEYWORDS
  };
  var SUBST_NO_LF = hljs.inherit(SUBST, {
    illegal: /\n/
  });
  var INTERPOLATED_STRING = {
    className: 'string',
    begin: /\$"/,
    end: '"',
    illegal: /\n/,
    contains: [{
      begin: /\{\{/
    }, {
      begin: /\}\}/
    }, hljs.BACKSLASH_ESCAPE, SUBST_NO_LF]
  };
  var INTERPOLATED_VERBATIM_STRING = {
    className: 'string',
    begin: /\$@"/,
    end: '"',
    contains: [{
      begin: /\{\{/
    }, {
      begin: /\}\}/
    }, {
      begin: '""'
    }, SUBST]
  };
  var INTERPOLATED_VERBATIM_STRING_NO_LF = hljs.inherit(INTERPOLATED_VERBATIM_STRING, {
    illegal: /\n/,
    contains: [{
      begin: /\{\{/
    }, {
      begin: /\}\}/
    }, {
      begin: '""'
    }, SUBST_NO_LF]
  });
  SUBST.contains = [INTERPOLATED_VERBATIM_STRING, INTERPOLATED_STRING, VERBATIM_STRING, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, NUMBERS, hljs.C_BLOCK_COMMENT_MODE];
  SUBST_NO_LF.contains = [INTERPOLATED_VERBATIM_STRING_NO_LF, INTERPOLATED_STRING, VERBATIM_STRING_NO_LF, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, NUMBERS, hljs.inherit(hljs.C_BLOCK_COMMENT_MODE, {
    illegal: /\n/
  })];
  var STRING = {
    variants: [INTERPOLATED_VERBATIM_STRING, INTERPOLATED_STRING, VERBATIM_STRING, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE]
  };
  var GENERIC_MODIFIER = {
    begin: "<",
    end: ">",
    contains: [{
      beginKeywords: "in out"
    }, TITLE_MODE]
  };
  var TYPE_IDENT_RE = hljs.IDENT_RE + '(<' + hljs.IDENT_RE + '(\\s*,\\s*' + hljs.IDENT_RE + ')*>)?(\\[\\])?';
  var AT_IDENTIFIER = {
    // prevents expressions like `@class` from incorrect flagging
    // `class` as a keyword
    begin: "@" + hljs.IDENT_RE,
    relevance: 0
  };
  return {
    name: 'C#',
    aliases: ['cs', 'c#'],
    keywords: KEYWORDS,
    illegal: /::/,
    contains: [hljs.COMMENT('///', '$', {
      returnBegin: true,
      contains: [{
        className: 'doctag',
        variants: [{
          begin: '///',
          relevance: 0
        }, {
          begin: '<!--|-->'
        }, {
          begin: '</?',
          end: '>'
        }]
      }]
    }), hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, {
      className: 'meta',
      begin: '#',
      end: '$',
      keywords: {
        'meta-keyword': 'if else elif endif define undef warning error line region endregion pragma checksum'
      }
    }, STRING, NUMBERS, {
      beginKeywords: 'class interface',
      relevance: 0,
      end: /[{;=]/,
      illegal: /[^\s:,]/,
      contains: [{
        beginKeywords: "where class"
      }, TITLE_MODE, GENERIC_MODIFIER, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE]
    }, {
      beginKeywords: 'namespace',
      relevance: 0,
      end: /[{;=]/,
      illegal: /[^\s:]/,
      contains: [TITLE_MODE, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE]
    }, {
      beginKeywords: 'record',
      relevance: 0,
      end: /[{;=]/,
      illegal: /[^\s:]/,
      contains: [TITLE_MODE, GENERIC_MODIFIER, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE]
    }, {
      // [Attributes("")]
      className: 'meta',
      begin: '^\\s*\\[',
      excludeBegin: true,
      end: '\\]',
      excludeEnd: true,
      contains: [{
        className: 'meta-string',
        begin: /"/,
        end: /"/
      }]
    }, {
      // Expression keywords prevent 'keyword Name(...)' from being
      // recognized as a function definition
      beginKeywords: 'new return throw await else',
      relevance: 0
    }, {
      className: 'function',
      begin: '(' + TYPE_IDENT_RE + '\\s+)+' + hljs.IDENT_RE + '\\s*(<.+>\\s*)?\\(',
      returnBegin: true,
      end: /\s*[{;=]/,
      excludeEnd: true,
      keywords: KEYWORDS,
      contains: [
      // prevents these from being highlighted `title`
      {
        beginKeywords: FUNCTION_MODIFIERS.join(" "),
        relevance: 0
      }, {
        begin: hljs.IDENT_RE + '\\s*(<.+>\\s*)?\\(',
        returnBegin: true,
        contains: [hljs.TITLE_MODE, GENERIC_MODIFIER],
        relevance: 0
      }, {
        className: 'params',
        begin: /\(/,
        end: /\)/,
        excludeBegin: true,
        excludeEnd: true,
        keywords: KEYWORDS,
        relevance: 0,
        contains: [STRING, NUMBERS, hljs.C_BLOCK_COMMENT_MODE]
      }, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE]
    }, AT_IDENTIFIER]
  };
}
module.exports = csharp;

/***/ }),

/***/ 65929:
/***/ ((module) => {

/*
Language: CSP
Description: Content Security Policy definition highlighting
Author: Taras <oxdef@oxdef.info>
Website: https://developer.mozilla.org/en-US/docs/Web/HTTP/CSP

vim: ts=2 sw=2 st=2
*/

/** @type LanguageFn */
function csp(hljs) {
  return {
    name: 'CSP',
    case_insensitive: false,
    keywords: {
      $pattern: '[a-zA-Z][a-zA-Z0-9_-]*',
      keyword: 'base-uri child-src connect-src default-src font-src form-action ' + 'frame-ancestors frame-src img-src media-src object-src plugin-types ' + 'report-uri sandbox script-src style-src'
    },
    contains: [{
      className: 'string',
      begin: "'",
      end: "'"
    }, {
      className: 'attribute',
      begin: '^Content',
      end: ':',
      excludeEnd: true
    }]
  };
}
module.exports = csp;

/***/ }),

/***/ 89210:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(92222);
var MODES = function MODES(hljs) {
  return {
    IMPORTANT: {
      className: 'meta',
      begin: '!important'
    },
    HEXCOLOR: {
      className: 'number',
      begin: '#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})'
    },
    ATTRIBUTE_SELECTOR_MODE: {
      className: 'selector-attr',
      begin: /\[/,
      end: /\]/,
      illegal: '$',
      contains: [hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE]
    }
  };
};
var TAGS = ['a', 'abbr', 'address', 'article', 'aside', 'audio', 'b', 'blockquote', 'body', 'button', 'canvas', 'caption', 'cite', 'code', 'dd', 'del', 'details', 'dfn', 'div', 'dl', 'dt', 'em', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'mark', 'menu', 'nav', 'object', 'ol', 'p', 'q', 'quote', 'samp', 'section', 'span', 'strong', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'ul', 'var', 'video'];
var MEDIA_FEATURES = ['any-hover', 'any-pointer', 'aspect-ratio', 'color', 'color-gamut', 'color-index', 'device-aspect-ratio', 'device-height', 'device-width', 'display-mode', 'forced-colors', 'grid', 'height', 'hover', 'inverted-colors', 'monochrome', 'orientation', 'overflow-block', 'overflow-inline', 'pointer', 'prefers-color-scheme', 'prefers-contrast', 'prefers-reduced-motion', 'prefers-reduced-transparency', 'resolution', 'scan', 'scripting', 'update', 'width',
// TODO: find a better solution?
'min-width', 'max-width', 'min-height', 'max-height'];

// https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-classes
var PSEUDO_CLASSES = ['active', 'any-link', 'blank', 'checked', 'current', 'default', 'defined', 'dir',
// dir()
'disabled', 'drop', 'empty', 'enabled', 'first', 'first-child', 'first-of-type', 'fullscreen', 'future', 'focus', 'focus-visible', 'focus-within', 'has',
// has()
'host',
// host or host()
'host-context',
// host-context()
'hover', 'indeterminate', 'in-range', 'invalid', 'is',
// is()
'lang',
// lang()
'last-child', 'last-of-type', 'left', 'link', 'local-link', 'not',
// not()
'nth-child',
// nth-child()
'nth-col',
// nth-col()
'nth-last-child',
// nth-last-child()
'nth-last-col',
// nth-last-col()
'nth-last-of-type',
//nth-last-of-type()
'nth-of-type',
//nth-of-type()
'only-child', 'only-of-type', 'optional', 'out-of-range', 'past', 'placeholder-shown', 'read-only', 'read-write', 'required', 'right', 'root', 'scope', 'target', 'target-within', 'user-invalid', 'valid', 'visited', 'where' // where()
];

// https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-elements
var PSEUDO_ELEMENTS = ['after', 'backdrop', 'before', 'cue', 'cue-region', 'first-letter', 'first-line', 'grammar-error', 'marker', 'part', 'placeholder', 'selection', 'slotted', 'spelling-error'];
var ATTRIBUTES = ['align-content', 'align-items', 'align-self', 'animation', 'animation-delay', 'animation-direction', 'animation-duration', 'animation-fill-mode', 'animation-iteration-count', 'animation-name', 'animation-play-state', 'animation-timing-function', 'auto', 'backface-visibility', 'background', 'background-attachment', 'background-clip', 'background-color', 'background-image', 'background-origin', 'background-position', 'background-repeat', 'background-size', 'border', 'border-bottom', 'border-bottom-color', 'border-bottom-left-radius', 'border-bottom-right-radius', 'border-bottom-style', 'border-bottom-width', 'border-collapse', 'border-color', 'border-image', 'border-image-outset', 'border-image-repeat', 'border-image-slice', 'border-image-source', 'border-image-width', 'border-left', 'border-left-color', 'border-left-style', 'border-left-width', 'border-radius', 'border-right', 'border-right-color', 'border-right-style', 'border-right-width', 'border-spacing', 'border-style', 'border-top', 'border-top-color', 'border-top-left-radius', 'border-top-right-radius', 'border-top-style', 'border-top-width', 'border-width', 'bottom', 'box-decoration-break', 'box-shadow', 'box-sizing', 'break-after', 'break-before', 'break-inside', 'caption-side', 'clear', 'clip', 'clip-path', 'color', 'column-count', 'column-fill', 'column-gap', 'column-rule', 'column-rule-color', 'column-rule-style', 'column-rule-width', 'column-span', 'column-width', 'columns', 'content', 'counter-increment', 'counter-reset', 'cursor', 'direction', 'display', 'empty-cells', 'filter', 'flex', 'flex-basis', 'flex-direction', 'flex-flow', 'flex-grow', 'flex-shrink', 'flex-wrap', 'float', 'font', 'font-display', 'font-family', 'font-feature-settings', 'font-kerning', 'font-language-override', 'font-size', 'font-size-adjust', 'font-smoothing', 'font-stretch', 'font-style', 'font-variant', 'font-variant-ligatures', 'font-variation-settings', 'font-weight', 'height', 'hyphens', 'icon', 'image-orientation', 'image-rendering', 'image-resolution', 'ime-mode', 'inherit', 'initial', 'justify-content', 'left', 'letter-spacing', 'line-height', 'list-style', 'list-style-image', 'list-style-position', 'list-style-type', 'margin', 'margin-bottom', 'margin-left', 'margin-right', 'margin-top', 'marks', 'mask', 'max-height', 'max-width', 'min-height', 'min-width', 'nav-down', 'nav-index', 'nav-left', 'nav-right', 'nav-up', 'none', 'normal', 'object-fit', 'object-position', 'opacity', 'order', 'orphans', 'outline', 'outline-color', 'outline-offset', 'outline-style', 'outline-width', 'overflow', 'overflow-wrap', 'overflow-x', 'overflow-y', 'padding', 'padding-bottom', 'padding-left', 'padding-right', 'padding-top', 'page-break-after', 'page-break-before', 'page-break-inside', 'perspective', 'perspective-origin', 'pointer-events', 'position', 'quotes', 'resize', 'right', 'src',
// @font-face
'tab-size', 'table-layout', 'text-align', 'text-align-last', 'text-decoration', 'text-decoration-color', 'text-decoration-line', 'text-decoration-style', 'text-indent', 'text-overflow', 'text-rendering', 'text-shadow', 'text-transform', 'text-underline-position', 'top', 'transform', 'transform-origin', 'transform-style', 'transition', 'transition-delay', 'transition-duration', 'transition-property', 'transition-timing-function', 'unicode-bidi', 'vertical-align', 'visibility', 'white-space', 'widows', 'width', 'word-break', 'word-spacing', 'word-wrap', 'z-index'
// reverse makes sure longer attributes `font-weight` are matched fully
// instead of getting false positives on say `font`
].reverse();

/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function lookahead(re) {
  return concat('(?=', re, ')');
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/*
Language: CSS
Category: common, css
Website: https://developer.mozilla.org/en-US/docs/Web/CSS
*/

/** @type LanguageFn */
function css(hljs) {
  var modes = MODES(hljs);
  var FUNCTION_DISPATCH = {
    className: "built_in",
    begin: /[\w-]+(?=\()/
  };
  var VENDOR_PREFIX = {
    begin: /-(webkit|moz|ms|o)-(?=[a-z])/
  };
  var AT_MODIFIERS = "and or not only";
  var AT_PROPERTY_RE = /@-?\w[\w]*(-\w+)*/; // @-webkit-keyframes
  var IDENT_RE = '[a-zA-Z-][a-zA-Z0-9_-]*';
  var STRINGS = [hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE];
  return {
    name: 'CSS',
    case_insensitive: true,
    illegal: /[=|'\$]/,
    keywords: {
      keyframePosition: "from to"
    },
    classNameAliases: {
      // for visual continuity with `tag {}` and because we
      // don't have a great class for this?
      keyframePosition: "selector-tag"
    },
    contains: [hljs.C_BLOCK_COMMENT_MODE, VENDOR_PREFIX,
    // to recognize keyframe 40% etc which are outside the scope of our
    // attribute value mode
    hljs.CSS_NUMBER_MODE, {
      className: 'selector-id',
      begin: /#[A-Za-z0-9_-]+/,
      relevance: 0
    }, {
      className: 'selector-class',
      begin: '\\.' + IDENT_RE,
      relevance: 0
    }, modes.ATTRIBUTE_SELECTOR_MODE, {
      className: 'selector-pseudo',
      variants: [{
        begin: ':(' + PSEUDO_CLASSES.join('|') + ')'
      }, {
        begin: '::(' + PSEUDO_ELEMENTS.join('|') + ')'
      }]
    },
    // we may actually need this (12/2020)
    // { // pseudo-selector params
    //   begin: /\(/,
    //   end: /\)/,
    //   contains: [ hljs.CSS_NUMBER_MODE ]
    // },
    {
      className: 'attribute',
      begin: '\\b(' + ATTRIBUTES.join('|') + ')\\b'
    },
    // attribute values
    {
      begin: ':',
      end: '[;}]',
      contains: [modes.HEXCOLOR, modes.IMPORTANT, hljs.CSS_NUMBER_MODE].concat(STRINGS, [
      // needed to highlight these as strings and to avoid issues with
      // illegal characters that might be inside urls that would tigger the
      // languages illegal stack
      {
        begin: /(url|data-uri)\(/,
        end: /\)/,
        relevance: 0,
        // from keywords
        keywords: {
          built_in: "url data-uri"
        },
        contains: [{
          className: "string",
          // any character other than `)` as in `url()` will be the start
          // of a string, which ends with `)` (from the parent mode)
          begin: /[^)]/,
          endsWithParent: true,
          excludeEnd: true
        }]
      }, FUNCTION_DISPATCH])
    }, {
      begin: lookahead(/@/),
      end: '[{;]',
      relevance: 0,
      illegal: /:/,
      // break on Less variables @var: ...
      contains: [{
        className: 'keyword',
        begin: AT_PROPERTY_RE
      }, {
        begin: /\s/,
        endsWithParent: true,
        excludeEnd: true,
        relevance: 0,
        keywords: {
          $pattern: /[a-z-]+/,
          keyword: AT_MODIFIERS,
          attribute: MEDIA_FEATURES.join(" ")
        },
        contains: [{
          begin: /[a-z-]+(?=:)/,
          className: "attribute"
        }].concat(STRINGS, [hljs.CSS_NUMBER_MODE])
      }]
    }, {
      className: 'selector-tag',
      begin: '\\b(' + TAGS.join('|') + ')\\b'
    }]
  };
}
module.exports = css;

/***/ }),

/***/ 82399:
/***/ ((module) => {

/*
Language: D
Author: Aleksandar Ruzicic <aleksandar@ruzicic.info>
Description: D is a language with C-like syntax and static typing. It pragmatically combines efficiency, control, and modeling power, with safety and programmer productivity.
Version: 1.0a
Website: https://dlang.org
Date: 2012-04-08
*/

/**
 * Known issues:
 *
 * - invalid hex string literals will be recognized as a double quoted strings
 *   but 'x' at the beginning of string will not be matched
 *
 * - delimited string literals are not checked for matching end delimiter
 *   (not possible to do with js regexp)
 *
 * - content of token string is colored as a string (i.e. no keyword coloring inside a token string)
 *   also, content of token string is not validated to contain only valid D tokens
 *
 * - special token sequence rule is not strictly following D grammar (anything following #line
 *   up to the end of line is matched as special token sequence)
 */

/** @type LanguageFn */
function d(hljs) {
  /**
   * Language keywords
   *
   * @type {Object}
   */
  var D_KEYWORDS = {
    $pattern: hljs.UNDERSCORE_IDENT_RE,
    keyword: 'abstract alias align asm assert auto body break byte case cast catch class ' + 'const continue debug default delete deprecated do else enum export extern final ' + 'finally for foreach foreach_reverse|10 goto if immutable import in inout int ' + 'interface invariant is lazy macro mixin module new nothrow out override package ' + 'pragma private protected public pure ref return scope shared static struct ' + 'super switch synchronized template this throw try typedef typeid typeof union ' + 'unittest version void volatile while with __FILE__ __LINE__ __gshared|10 ' + '__thread __traits __DATE__ __EOF__ __TIME__ __TIMESTAMP__ __VENDOR__ __VERSION__',
    built_in: 'bool cdouble cent cfloat char creal dchar delegate double dstring float function ' + 'idouble ifloat ireal long real short string ubyte ucent uint ulong ushort wchar ' + 'wstring',
    literal: 'false null true'
  };

  /**
   * Number literal regexps
   *
   * @type {String}
   */
  var decimal_integer_re = '(0|[1-9][\\d_]*)';
  var decimal_integer_nosus_re = '(0|[1-9][\\d_]*|\\d[\\d_]*|[\\d_]+?\\d)';
  var binary_integer_re = '0[bB][01_]+';
  var hexadecimal_digits_re = '([\\da-fA-F][\\da-fA-F_]*|_[\\da-fA-F][\\da-fA-F_]*)';
  var hexadecimal_integer_re = '0[xX]' + hexadecimal_digits_re;
  var decimal_exponent_re = '([eE][+-]?' + decimal_integer_nosus_re + ')';
  var decimal_float_re = '(' + decimal_integer_nosus_re + '(\\.\\d*|' + decimal_exponent_re + ')|' + '\\d+\\.' + decimal_integer_nosus_re + '|' + '\\.' + decimal_integer_re + decimal_exponent_re + '?' + ')';
  var hexadecimal_float_re = '(0[xX](' + hexadecimal_digits_re + '\\.' + hexadecimal_digits_re + '|' + '\\.?' + hexadecimal_digits_re + ')[pP][+-]?' + decimal_integer_nosus_re + ')';
  var integer_re = '(' + decimal_integer_re + '|' + binary_integer_re + '|' + hexadecimal_integer_re + ')';
  var float_re = '(' + hexadecimal_float_re + '|' + decimal_float_re + ')';

  /**
   * Escape sequence supported in D string and character literals
   *
   * @type {String}
   */
  var escape_sequence_re = '\\\\(' + '[\'"\\?\\\\abfnrtv]|' +
  // common escapes
  'u[\\dA-Fa-f]{4}|' +
  // four hex digit unicode codepoint
  '[0-7]{1,3}|' +
  // one to three octal digit ascii char code
  'x[\\dA-Fa-f]{2}|' +
  // two hex digit ascii char code
  'U[\\dA-Fa-f]{8}' +
  // eight hex digit unicode codepoint
  ')|' + '&[a-zA-Z\\d]{2,};'; // named character entity

  /**
   * D integer number literals
   *
   * @type {Object}
   */
  var D_INTEGER_MODE = {
    className: 'number',
    begin: '\\b' + integer_re + '(L|u|U|Lu|LU|uL|UL)?',
    relevance: 0
  };

  /**
   * [D_FLOAT_MODE description]
   * @type {Object}
   */
  var D_FLOAT_MODE = {
    className: 'number',
    begin: '\\b(' + float_re + '([fF]|L|i|[fF]i|Li)?|' + integer_re + '(i|[fF]i|Li)' + ')',
    relevance: 0
  };

  /**
   * D character literal
   *
   * @type {Object}
   */
  var D_CHARACTER_MODE = {
    className: 'string',
    begin: '\'(' + escape_sequence_re + '|.)',
    end: '\'',
    illegal: '.'
  };

  /**
   * D string escape sequence
   *
   * @type {Object}
   */
  var D_ESCAPE_SEQUENCE = {
    begin: escape_sequence_re,
    relevance: 0
  };

  /**
   * D double quoted string literal
   *
   * @type {Object}
   */
  var D_STRING_MODE = {
    className: 'string',
    begin: '"',
    contains: [D_ESCAPE_SEQUENCE],
    end: '"[cwd]?'
  };

  /**
   * D wysiwyg and delimited string literals
   *
   * @type {Object}
   */
  var D_WYSIWYG_DELIMITED_STRING_MODE = {
    className: 'string',
    begin: '[rq]"',
    end: '"[cwd]?',
    relevance: 5
  };

  /**
   * D alternate wysiwyg string literal
   *
   * @type {Object}
   */
  var D_ALTERNATE_WYSIWYG_STRING_MODE = {
    className: 'string',
    begin: '`',
    end: '`[cwd]?'
  };

  /**
   * D hexadecimal string literal
   *
   * @type {Object}
   */
  var D_HEX_STRING_MODE = {
    className: 'string',
    begin: 'x"[\\da-fA-F\\s\\n\\r]*"[cwd]?',
    relevance: 10
  };

  /**
   * D delimited string literal
   *
   * @type {Object}
   */
  var D_TOKEN_STRING_MODE = {
    className: 'string',
    begin: 'q"\\{',
    end: '\\}"'
  };

  /**
   * Hashbang support
   *
   * @type {Object}
   */
  var D_HASHBANG_MODE = {
    className: 'meta',
    begin: '^#!',
    end: '$',
    relevance: 5
  };

  /**
   * D special token sequence
   *
   * @type {Object}
   */
  var D_SPECIAL_TOKEN_SEQUENCE_MODE = {
    className: 'meta',
    begin: '#(line)',
    end: '$',
    relevance: 5
  };

  /**
   * D attributes
   *
   * @type {Object}
   */
  var D_ATTRIBUTE_MODE = {
    className: 'keyword',
    begin: '@[a-zA-Z_][a-zA-Z_\\d]*'
  };

  /**
   * D nesting comment
   *
   * @type {Object}
   */
  var D_NESTING_COMMENT_MODE = hljs.COMMENT('\\/\\+', '\\+\\/', {
    contains: ['self'],
    relevance: 10
  });
  return {
    name: 'D',
    keywords: D_KEYWORDS,
    contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, D_NESTING_COMMENT_MODE, D_HEX_STRING_MODE, D_STRING_MODE, D_WYSIWYG_DELIMITED_STRING_MODE, D_ALTERNATE_WYSIWYG_STRING_MODE, D_TOKEN_STRING_MODE, D_FLOAT_MODE, D_INTEGER_MODE, D_CHARACTER_MODE, D_HASHBANG_MODE, D_SPECIAL_TOKEN_SEQUENCE_MODE, D_ATTRIBUTE_MODE]
  };
}
module.exports = d;

/***/ }),

/***/ 40494:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(21249);
__webpack_require__(92222);
/*
Language: Dart
Requires: markdown.js
Author: Maxim Dikun <dikmax@gmail.com>
Description: Dart a modern, object-oriented language developed by Google. For more information see https://www.dartlang.org/
Website: https://dart.dev
Category: scripting
*/

/** @type LanguageFn */
function dart(hljs) {
  var SUBST = {
    className: 'subst',
    variants: [{
      begin: '\\$[A-Za-z0-9_]+'
    }]
  };
  var BRACED_SUBST = {
    className: 'subst',
    variants: [{
      begin: /\$\{/,
      end: /\}/
    }],
    keywords: 'true false null this is new super'
  };
  var STRING = {
    className: 'string',
    variants: [{
      begin: 'r\'\'\'',
      end: '\'\'\''
    }, {
      begin: 'r"""',
      end: '"""'
    }, {
      begin: 'r\'',
      end: '\'',
      illegal: '\\n'
    }, {
      begin: 'r"',
      end: '"',
      illegal: '\\n'
    }, {
      begin: '\'\'\'',
      end: '\'\'\'',
      contains: [hljs.BACKSLASH_ESCAPE, SUBST, BRACED_SUBST]
    }, {
      begin: '"""',
      end: '"""',
      contains: [hljs.BACKSLASH_ESCAPE, SUBST, BRACED_SUBST]
    }, {
      begin: '\'',
      end: '\'',
      illegal: '\\n',
      contains: [hljs.BACKSLASH_ESCAPE, SUBST, BRACED_SUBST]
    }, {
      begin: '"',
      end: '"',
      illegal: '\\n',
      contains: [hljs.BACKSLASH_ESCAPE, SUBST, BRACED_SUBST]
    }]
  };
  BRACED_SUBST.contains = [hljs.C_NUMBER_MODE, STRING];
  var BUILT_IN_TYPES = [
  // dart:core
  'Comparable', 'DateTime', 'Duration', 'Function', 'Iterable', 'Iterator', 'List', 'Map', 'Match', 'Object', 'Pattern', 'RegExp', 'Set', 'Stopwatch', 'String', 'StringBuffer', 'StringSink', 'Symbol', 'Type', 'Uri', 'bool', 'double', 'int', 'num',
  // dart:html
  'Element', 'ElementList'];
  var NULLABLE_BUILT_IN_TYPES = BUILT_IN_TYPES.map(function (e) {
    return "".concat(e, "?");
  });
  var KEYWORDS = {
    keyword: 'abstract as assert async await break case catch class const continue covariant default deferred do ' + 'dynamic else enum export extends extension external factory false final finally for Function get hide if ' + 'implements import in inferface is late library mixin new null on operator part required rethrow return set ' + 'show static super switch sync this throw true try typedef var void while with yield',
    built_in: BUILT_IN_TYPES.concat(NULLABLE_BUILT_IN_TYPES).concat([
    // dart:core
    'Never', 'Null', 'dynamic', 'print',
    // dart:html
    'document', 'querySelector', 'querySelectorAll', 'window']),
    $pattern: /[A-Za-z][A-Za-z0-9_]*\??/
  };
  return {
    name: 'Dart',
    keywords: KEYWORDS,
    contains: [STRING, hljs.COMMENT(/\/\*\*(?!\/)/, /\*\//, {
      subLanguage: 'markdown',
      relevance: 0
    }), hljs.COMMENT(/\/{3,} ?/, /$/, {
      contains: [{
        subLanguage: 'markdown',
        begin: '.',
        end: '$',
        relevance: 0
      }]
    }), hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, {
      className: 'class',
      beginKeywords: 'class interface',
      end: /\{/,
      excludeEnd: true,
      contains: [{
        beginKeywords: 'extends implements'
      }, hljs.UNDERSCORE_TITLE_MODE]
    }, hljs.C_NUMBER_MODE, {
      className: 'meta',
      begin: '@[A-Za-z]+'
    }, {
      begin: '=>' // No markup, just a relevance booster
    }]
  };
}

module.exports = dart;

/***/ }),

/***/ 66187:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
/*
Language: Delphi
Website: https://www.embarcadero.com/products/delphi
*/

/** @type LanguageFn */
function delphi(hljs) {
  var KEYWORDS = 'exports register file shl array record property for mod while set ally label uses raise not ' + 'stored class safecall var interface or private static exit index inherited to else stdcall ' + 'override shr asm far resourcestring finalization packed virtual out and protected library do ' + 'xorwrite goto near function end div overload object unit begin string on inline repeat until ' + 'destructor write message program with read initialization except default nil if case cdecl in ' + 'downto threadvar of try pascal const external constructor type public then implementation ' + 'finally published procedure absolute reintroduce operator as is abstract alias assembler ' + 'bitpacked break continue cppdecl cvar enumerator experimental platform deprecated ' + 'unimplemented dynamic export far16 forward generic helper implements interrupt iochecks ' + 'local name nodefault noreturn nostackframe oldfpccall otherwise saveregisters softfloat ' + 'specialize strict unaligned varargs ';
  var COMMENT_MODES = [hljs.C_LINE_COMMENT_MODE, hljs.COMMENT(/\{/, /\}/, {
    relevance: 0
  }), hljs.COMMENT(/\(\*/, /\*\)/, {
    relevance: 10
  })];
  var DIRECTIVE = {
    className: 'meta',
    variants: [{
      begin: /\{\$/,
      end: /\}/
    }, {
      begin: /\(\*\$/,
      end: /\*\)/
    }]
  };
  var STRING = {
    className: 'string',
    begin: /'/,
    end: /'/,
    contains: [{
      begin: /''/
    }]
  };
  var NUMBER = {
    className: 'number',
    relevance: 0,
    // Source: https://www.freepascal.org/docs-html/ref/refse6.html
    variants: [{
      // Hexadecimal notation, e.g., $7F.
      begin: '\\$[0-9A-Fa-f]+'
    }, {
      // Octal notation, e.g., &42.
      begin: '&[0-7]+'
    }, {
      // Binary notation, e.g., %1010.
      begin: '%[01]+'
    }]
  };
  var CHAR_STRING = {
    className: 'string',
    begin: /(#\d+)+/
  };
  var CLASS = {
    begin: hljs.IDENT_RE + '\\s*=\\s*class\\s*\\(',
    returnBegin: true,
    contains: [hljs.TITLE_MODE]
  };
  var FUNCTION = {
    className: 'function',
    beginKeywords: 'function constructor destructor procedure',
    end: /[:;]/,
    keywords: 'function constructor|10 destructor|10 procedure|10',
    contains: [hljs.TITLE_MODE, {
      className: 'params',
      begin: /\(/,
      end: /\)/,
      keywords: KEYWORDS,
      contains: [STRING, CHAR_STRING, DIRECTIVE].concat(COMMENT_MODES)
    }, DIRECTIVE].concat(COMMENT_MODES)
  };
  return {
    name: 'Delphi',
    aliases: ['dpr', 'dfm', 'pas', 'pascal', 'freepascal', 'lazarus', 'lpr', 'lfm'],
    case_insensitive: true,
    keywords: KEYWORDS,
    illegal: /"|\$[G-Zg-z]|\/\*|<\/|\|/,
    contains: [STRING, CHAR_STRING, hljs.NUMBER_MODE, NUMBER, CLASS, FUNCTION, DIRECTIVE].concat(COMMENT_MODES)
  };
}
module.exports = delphi;

/***/ }),

/***/ 74341:
/***/ ((module) => {

/*
Language: Diff
Description: Unified and context diff
Author: Vasily Polovnyov <vast@whiteants.net>
Website: https://www.gnu.org/software/diffutils/
Category: common
*/

/** @type LanguageFn */
function diff(hljs) {
  return {
    name: 'Diff',
    aliases: ['patch'],
    contains: [{
      className: 'meta',
      relevance: 10,
      variants: [{
        begin: /^@@ +-\d+,\d+ +\+\d+,\d+ +@@/
      }, {
        begin: /^\*\*\* +\d+,\d+ +\*\*\*\*$/
      }, {
        begin: /^--- +\d+,\d+ +----$/
      }]
    }, {
      className: 'comment',
      variants: [{
        begin: /Index: /,
        end: /$/
      }, {
        begin: /^index/,
        end: /$/
      }, {
        begin: /={3,}/,
        end: /$/
      }, {
        begin: /^-{3}/,
        end: /$/
      }, {
        begin: /^\*{3} /,
        end: /$/
      }, {
        begin: /^\+{3}/,
        end: /$/
      }, {
        begin: /^\*{15}$/
      }, {
        begin: /^diff --git/,
        end: /$/
      }]
    }, {
      className: 'addition',
      begin: /^\+/,
      end: /$/
    }, {
      className: 'deletion',
      begin: /^-/,
      end: /$/
    }, {
      className: 'addition',
      begin: /^!/,
      end: /$/
    }]
  };
}
module.exports = diff;

/***/ }),

/***/ 84567:
/***/ ((module) => {

/*
Language: Django
Description: Django is a high-level Python Web framework that encourages rapid development and clean, pragmatic design.
Requires: xml.js
Author: Ivan Sagalaev <maniac@softwaremaniacs.org>
Contributors: Ilya Baryshev <baryshev@gmail.com>
Website: https://www.djangoproject.com
Category: template
*/

/** @type LanguageFn */
function django(hljs) {
  var FILTER = {
    begin: /\|[A-Za-z]+:?/,
    keywords: {
      name: 'truncatewords removetags linebreaksbr yesno get_digit timesince random striptags ' + 'filesizeformat escape linebreaks length_is ljust rjust cut urlize fix_ampersands ' + 'title floatformat capfirst pprint divisibleby add make_list unordered_list urlencode ' + 'timeuntil urlizetrunc wordcount stringformat linenumbers slice date dictsort ' + 'dictsortreversed default_if_none pluralize lower join center default ' + 'truncatewords_html upper length phone2numeric wordwrap time addslashes slugify first ' + 'escapejs force_escape iriencode last safe safeseq truncatechars localize unlocalize ' + 'localtime utc timezone'
    },
    contains: [hljs.QUOTE_STRING_MODE, hljs.APOS_STRING_MODE]
  };
  return {
    name: 'Django',
    aliases: ['jinja'],
    case_insensitive: true,
    subLanguage: 'xml',
    contains: [hljs.COMMENT(/\{%\s*comment\s*%\}/, /\{%\s*endcomment\s*%\}/), hljs.COMMENT(/\{#/, /#\}/), {
      className: 'template-tag',
      begin: /\{%/,
      end: /%\}/,
      contains: [{
        className: 'name',
        begin: /\w+/,
        keywords: {
          name: 'comment endcomment load templatetag ifchanged endifchanged if endif firstof for ' + 'endfor ifnotequal endifnotequal widthratio extends include spaceless ' + 'endspaceless regroup ifequal endifequal ssi now with cycle url filter ' + 'endfilter debug block endblock else autoescape endautoescape csrf_token empty elif ' + 'endwith static trans blocktrans endblocktrans get_static_prefix get_media_prefix ' + 'plural get_current_language language get_available_languages ' + 'get_current_language_bidi get_language_info get_language_info_list localize ' + 'endlocalize localtime endlocaltime timezone endtimezone get_current_timezone ' + 'verbatim'
        },
        starts: {
          endsWithParent: true,
          keywords: 'in by as',
          contains: [FILTER],
          relevance: 0
        }
      }]
    }, {
      className: 'template-variable',
      begin: /\{\{/,
      end: /\}\}/,
      contains: [FILTER]
    }]
  };
}
module.exports = django;

/***/ }),

/***/ 95362:
/***/ ((module) => {

/*
Language: DNS Zone
Author: Tim Schumacher <tim@datenknoten.me>
Category: config
Website: https://en.wikipedia.org/wiki/Zone_file
*/

/** @type LanguageFn */
function dns(hljs) {
  return {
    name: 'DNS Zone',
    aliases: ['bind', 'zone'],
    keywords: {
      keyword: 'IN A AAAA AFSDB APL CAA CDNSKEY CDS CERT CNAME DHCID DLV DNAME DNSKEY DS HIP IPSECKEY KEY KX ' + 'LOC MX NAPTR NS NSEC NSEC3 NSEC3PARAM PTR RRSIG RP SIG SOA SRV SSHFP TA TKEY TLSA TSIG TXT'
    },
    contains: [hljs.COMMENT(';', '$', {
      relevance: 0
    }), {
      className: 'meta',
      begin: /^\$(TTL|GENERATE|INCLUDE|ORIGIN)\b/
    },
    // IPv6
    {
      className: 'number',
      begin: '((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:)))\\b'
    },
    // IPv4
    {
      className: 'number',
      begin: '((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\b'
    }, hljs.inherit(hljs.NUMBER_MODE, {
      begin: /\b\d+[dhwm]?/
    })]
  };
}
module.exports = dns;

/***/ }),

/***/ 84421:
/***/ ((module) => {

/*
Language: Dockerfile
Requires: bash.js
Author: Alexis Hénaut <alexis@henaut.net>
Description: language definition for Dockerfile files
Website: https://docs.docker.com/engine/reference/builder/
Category: config
*/

/** @type LanguageFn */
function dockerfile(hljs) {
  return {
    name: 'Dockerfile',
    aliases: ['docker'],
    case_insensitive: true,
    keywords: 'from maintainer expose env arg user onbuild stopsignal',
    contains: [hljs.HASH_COMMENT_MODE, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, hljs.NUMBER_MODE, {
      beginKeywords: 'run cmd entrypoint volume add copy workdir label healthcheck shell',
      starts: {
        end: /[^\\]$/,
        subLanguage: 'bash'
      }
    }],
    illegal: '</'
  };
}
module.exports = dockerfile;

/***/ }),

/***/ 82901:
/***/ ((module) => {

/*
Language: Batch file (DOS)
Author: Alexander Makarov <sam@rmcreative.ru>
Contributors: Anton Kochkov <anton.kochkov@gmail.com>
Website: https://en.wikipedia.org/wiki/Batch_file
*/

/** @type LanguageFn */
function dos(hljs) {
  var COMMENT = hljs.COMMENT(/^\s*@?rem\b/, /$/, {
    relevance: 10
  });
  var LABEL = {
    className: 'symbol',
    begin: '^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)',
    relevance: 0
  };
  return {
    name: 'Batch file (DOS)',
    aliases: ['bat', 'cmd'],
    case_insensitive: true,
    illegal: /\/\*/,
    keywords: {
      keyword: 'if else goto for in do call exit not exist errorlevel defined ' + 'equ neq lss leq gtr geq',
      built_in: 'prn nul lpt3 lpt2 lpt1 con com4 com3 com2 com1 aux ' + 'shift cd dir echo setlocal endlocal set pause copy ' + 'append assoc at attrib break cacls cd chcp chdir chkdsk chkntfs cls cmd color ' + 'comp compact convert date dir diskcomp diskcopy doskey erase fs ' + 'find findstr format ftype graftabl help keyb label md mkdir mode more move path ' + 'pause print popd pushd promt rd recover rem rename replace restore rmdir shift ' + 'sort start subst time title tree type ver verify vol ' +
      // winutils
      'ping net ipconfig taskkill xcopy ren del'
    },
    contains: [{
      className: 'variable',
      begin: /%%[^ ]|%[^ ]+?%|![^ ]+?!/
    }, {
      className: 'function',
      begin: LABEL.begin,
      end: 'goto:eof',
      contains: [hljs.inherit(hljs.TITLE_MODE, {
        begin: '([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*'
      }), COMMENT]
    }, {
      className: 'number',
      begin: '\\b\\d+',
      relevance: 0
    }, COMMENT]
  };
}
module.exports = dos;

/***/ }),

/***/ 89153:
/***/ ((module) => {

/*
 Language: dsconfig
 Description: dsconfig batch configuration language for LDAP directory servers
 Contributors: Jacob Childress <jacobc@gmail.com>
 Category: enterprise, config
 */

/** @type LanguageFn */
function dsconfig(hljs) {
  var QUOTED_PROPERTY = {
    className: 'string',
    begin: /"/,
    end: /"/
  };
  var APOS_PROPERTY = {
    className: 'string',
    begin: /'/,
    end: /'/
  };
  var UNQUOTED_PROPERTY = {
    className: 'string',
    begin: /[\w\-?]+:\w+/,
    end: /\W/,
    relevance: 0
  };
  var VALUELESS_PROPERTY = {
    className: 'string',
    begin: /\w+(\-\w+)*/,
    end: /(?=\W)/,
    relevance: 0
  };
  return {
    keywords: 'dsconfig',
    contains: [{
      className: 'keyword',
      begin: '^dsconfig',
      end: /\s/,
      excludeEnd: true,
      relevance: 10
    }, {
      className: 'built_in',
      begin: /(list|create|get|set|delete)-(\w+)/,
      end: /\s/,
      excludeEnd: true,
      illegal: '!@#$%^&*()',
      relevance: 10
    }, {
      className: 'built_in',
      begin: /--(\w+)/,
      end: /\s/,
      excludeEnd: true
    }, QUOTED_PROPERTY, APOS_PROPERTY, UNQUOTED_PROPERTY, VALUELESS_PROPERTY, hljs.HASH_COMMENT_MODE]
  };
}
module.exports = dsconfig;

/***/ }),

/***/ 60377:
/***/ ((module) => {

/*
Language: Device Tree
Description: *.dts files used in the Linux kernel
Author: Martin Braun <martin.braun@ettus.com>, Moritz Fischer <moritz.fischer@ettus.com>
Website: https://elinux.org/Device_Tree_Reference
Category: config
*/

/** @type LanguageFn */
function dts(hljs) {
  var STRINGS = {
    className: 'string',
    variants: [hljs.inherit(hljs.QUOTE_STRING_MODE, {
      begin: '((u8?|U)|L)?"'
    }), {
      begin: '(u8?|U)?R"',
      end: '"',
      contains: [hljs.BACKSLASH_ESCAPE]
    }, {
      begin: '\'\\\\?.',
      end: '\'',
      illegal: '.'
    }]
  };
  var NUMBERS = {
    className: 'number',
    variants: [{
      begin: '\\b(\\d+(\\.\\d*)?|\\.\\d+)(u|U|l|L|ul|UL|f|F)'
    }, {
      begin: hljs.C_NUMBER_RE
    }],
    relevance: 0
  };
  var PREPROCESSOR = {
    className: 'meta',
    begin: '#',
    end: '$',
    keywords: {
      'meta-keyword': 'if else elif endif define undef ifdef ifndef'
    },
    contains: [{
      begin: /\\\n/,
      relevance: 0
    }, {
      beginKeywords: 'include',
      end: '$',
      keywords: {
        'meta-keyword': 'include'
      },
      contains: [hljs.inherit(STRINGS, {
        className: 'meta-string'
      }), {
        className: 'meta-string',
        begin: '<',
        end: '>',
        illegal: '\\n'
      }]
    }, STRINGS, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE]
  };
  var DTS_REFERENCE = {
    className: 'variable',
    begin: /&[a-z\d_]*\b/
  };
  var DTS_KEYWORD = {
    className: 'meta-keyword',
    begin: '/[a-z][a-z\\d-]*/'
  };
  var DTS_LABEL = {
    className: 'symbol',
    begin: '^\\s*[a-zA-Z_][a-zA-Z\\d_]*:'
  };
  var DTS_CELL_PROPERTY = {
    className: 'params',
    begin: '<',
    end: '>',
    contains: [NUMBERS, DTS_REFERENCE]
  };
  var DTS_NODE = {
    className: 'class',
    begin: /[a-zA-Z_][a-zA-Z\d_@]*\s\{/,
    end: /[{;=]/,
    returnBegin: true,
    excludeEnd: true
  };
  var DTS_ROOT_NODE = {
    className: 'class',
    begin: '/\\s*\\{',
    end: /\};/,
    relevance: 10,
    contains: [DTS_REFERENCE, DTS_KEYWORD, DTS_LABEL, DTS_NODE, DTS_CELL_PROPERTY, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, NUMBERS, STRINGS]
  };
  return {
    name: 'Device Tree',
    keywords: "",
    contains: [DTS_ROOT_NODE, DTS_REFERENCE, DTS_KEYWORD, DTS_LABEL, DTS_NODE, DTS_CELL_PROPERTY, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, NUMBERS, STRINGS, PREPROCESSOR, {
      begin: hljs.IDENT_RE + '::',
      keywords: ""
    }]
  };
}
module.exports = dts;

/***/ }),

/***/ 45971:
/***/ ((module) => {

/*
Language: Dust
Requires: xml.js
Author: Michael Allen <michael.allen@benefitfocus.com>
Description: Matcher for dust.js templates.
Website: https://www.dustjs.com
Category: template
*/

/** @type LanguageFn */
function dust(hljs) {
  var EXPRESSION_KEYWORDS = 'if eq ne lt lte gt gte select default math sep';
  return {
    name: 'Dust',
    aliases: ['dst'],
    case_insensitive: true,
    subLanguage: 'xml',
    contains: [{
      className: 'template-tag',
      begin: /\{[#\/]/,
      end: /\}/,
      illegal: /;/,
      contains: [{
        className: 'name',
        begin: /[a-zA-Z\.-]+/,
        starts: {
          endsWithParent: true,
          relevance: 0,
          contains: [hljs.QUOTE_STRING_MODE]
        }
      }]
    }, {
      className: 'template-variable',
      begin: /\{/,
      end: /\}/,
      illegal: /;/,
      keywords: EXPRESSION_KEYWORDS
    }]
  };
}
module.exports = dust;

/***/ }),

/***/ 89944:
/***/ ((module) => {

/*
Language: Extended Backus-Naur Form
Author: Alex McKibben <alex@nullscope.net>
Website: https://en.wikipedia.org/wiki/Extended_Backus–Naur_form
*/

/** @type LanguageFn */
function ebnf(hljs) {
  var commentMode = hljs.COMMENT(/\(\*/, /\*\)/);
  var nonTerminalMode = {
    className: "attribute",
    begin: /^[ ]*[a-zA-Z]+([\s_-]+[a-zA-Z]+)*/
  };
  var specialSequenceMode = {
    className: "meta",
    begin: /\?.*\?/
  };
  var ruleBodyMode = {
    begin: /=/,
    end: /[.;]/,
    contains: [commentMode, specialSequenceMode, {
      // terminals
      className: 'string',
      variants: [hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, {
        begin: '`',
        end: '`'
      }]
    }]
  };
  return {
    name: 'Extended Backus-Naur Form',
    illegal: /\S/,
    contains: [commentMode, nonTerminalMode, ruleBodyMode]
  };
}
module.exports = ebnf;

/***/ }),

/***/ 30231:
/***/ ((module) => {

/*
Language: Elixir
Author: Josh Adams <josh@isotope11.com>
Description: language definition for Elixir source code files (.ex and .exs).  Based on ruby language support.
Category: functional
Website: https://elixir-lang.org
*/

/** @type LanguageFn */
function elixir(hljs) {
  var ELIXIR_IDENT_RE = '[a-zA-Z_][a-zA-Z0-9_.]*(!|\\?)?';
  var ELIXIR_METHOD_RE = '[a-zA-Z_]\\w*[!?=]?|[-+~]@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?';
  var ELIXIR_KEYWORDS = {
    $pattern: ELIXIR_IDENT_RE,
    keyword: 'and false then defined module in return redo retry end for true self when ' + 'next until do begin unless nil break not case cond alias while ensure or ' + 'include use alias fn quote require import with|0'
  };
  var SUBST = {
    className: 'subst',
    begin: /#\{/,
    end: /\}/,
    keywords: ELIXIR_KEYWORDS
  };
  var NUMBER = {
    className: 'number',
    begin: '(\\b0o[0-7_]+)|(\\b0b[01_]+)|(\\b0x[0-9a-fA-F_]+)|(-?\\b[1-9][0-9_]*(\\.[0-9_]+([eE][-+]?[0-9]+)?)?)',
    relevance: 0
  };
  var SIGIL_DELIMITERS = '[/|([{<"\']';
  var LOWERCASE_SIGIL = {
    className: 'string',
    begin: '~[a-z]' + '(?=' + SIGIL_DELIMITERS + ')',
    contains: [{
      endsParent: true,
      contains: [{
        contains: [hljs.BACKSLASH_ESCAPE, SUBST],
        variants: [{
          begin: /"/,
          end: /"/
        }, {
          begin: /'/,
          end: /'/
        }, {
          begin: /\//,
          end: /\//
        }, {
          begin: /\|/,
          end: /\|/
        }, {
          begin: /\(/,
          end: /\)/
        }, {
          begin: /\[/,
          end: /\]/
        }, {
          begin: /\{/,
          end: /\}/
        }, {
          begin: /</,
          end: />/
        }]
      }]
    }]
  };
  var UPCASE_SIGIL = {
    className: 'string',
    begin: '~[A-Z]' + '(?=' + SIGIL_DELIMITERS + ')',
    contains: [{
      begin: /"/,
      end: /"/
    }, {
      begin: /'/,
      end: /'/
    }, {
      begin: /\//,
      end: /\//
    }, {
      begin: /\|/,
      end: /\|/
    }, {
      begin: /\(/,
      end: /\)/
    }, {
      begin: /\[/,
      end: /\]/
    }, {
      begin: /\{/,
      end: /\}/
    }, {
      begin: /</,
      end: />/
    }]
  };
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, SUBST],
    variants: [{
      begin: /"""/,
      end: /"""/
    }, {
      begin: /'''/,
      end: /'''/
    }, {
      begin: /~S"""/,
      end: /"""/,
      contains: [] // override default
    }, {
      begin: /~S"/,
      end: /"/,
      contains: [] // override default
    }, {
      begin: /~S'''/,
      end: /'''/,
      contains: [] // override default
    }, {
      begin: /~S'/,
      end: /'/,
      contains: [] // override default
    }, {
      begin: /'/,
      end: /'/
    }, {
      begin: /"/,
      end: /"/
    }]
  };
  var FUNCTION = {
    className: 'function',
    beginKeywords: 'def defp defmacro',
    end: /\B\b/,
    // the mode is ended by the title
    contains: [hljs.inherit(hljs.TITLE_MODE, {
      begin: ELIXIR_IDENT_RE,
      endsParent: true
    })]
  };
  var CLASS = hljs.inherit(FUNCTION, {
    className: 'class',
    beginKeywords: 'defimpl defmodule defprotocol defrecord',
    end: /\bdo\b|$|;/
  });
  var ELIXIR_DEFAULT_CONTAINS = [STRING, UPCASE_SIGIL, LOWERCASE_SIGIL, hljs.HASH_COMMENT_MODE, CLASS, FUNCTION, {
    begin: '::'
  }, {
    className: 'symbol',
    begin: ':(?![\\s:])',
    contains: [STRING, {
      begin: ELIXIR_METHOD_RE
    }],
    relevance: 0
  }, {
    className: 'symbol',
    begin: ELIXIR_IDENT_RE + ':(?!:)',
    relevance: 0
  }, NUMBER, {
    className: 'variable',
    begin: '(\\$\\W)|((\\$|@@?)(\\w+))'
  }, {
    begin: '->'
  }, {
    // regexp container
    begin: '(' + hljs.RE_STARTERS_RE + ')\\s*',
    contains: [hljs.HASH_COMMENT_MODE, {
      // to prevent false regex triggers for the division function:
      // /:
      begin: /\/: (?=\d+\s*[,\]])/,
      relevance: 0,
      contains: [NUMBER]
    }, {
      className: 'regexp',
      illegal: '\\n',
      contains: [hljs.BACKSLASH_ESCAPE, SUBST],
      variants: [{
        begin: '/',
        end: '/[a-z]*'
      }, {
        begin: '%r\\[',
        end: '\\][a-z]*'
      }]
    }],
    relevance: 0
  }];
  SUBST.contains = ELIXIR_DEFAULT_CONTAINS;
  return {
    name: 'Elixir',
    keywords: ELIXIR_KEYWORDS,
    contains: ELIXIR_DEFAULT_CONTAINS
  };
}
module.exports = elixir;

/***/ }),

/***/ 84180:
/***/ ((module) => {

/*
Language: Elm
Author: Janis Voigtlaender <janis.voigtlaender@gmail.com>
Website: https://elm-lang.org
Category: functional
*/

/** @type LanguageFn */
function elm(hljs) {
  var COMMENT = {
    variants: [hljs.COMMENT('--', '$'), hljs.COMMENT(/\{-/, /-\}/, {
      contains: ['self']
    })]
  };
  var CONSTRUCTOR = {
    className: 'type',
    begin: '\\b[A-Z][\\w\']*',
    // TODO: other constructors (built-in, infix).
    relevance: 0
  };
  var LIST = {
    begin: '\\(',
    end: '\\)',
    illegal: '"',
    contains: [{
      className: 'type',
      begin: '\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?'
    }, COMMENT]
  };
  var RECORD = {
    begin: /\{/,
    end: /\}/,
    contains: LIST.contains
  };
  var CHARACTER = {
    className: 'string',
    begin: '\'\\\\?.',
    end: '\'',
    illegal: '.'
  };
  return {
    name: 'Elm',
    keywords: 'let in if then else case of where module import exposing ' + 'type alias as infix infixl infixr port effect command subscription',
    contains: [
    // Top-level constructions.

    {
      beginKeywords: 'port effect module',
      end: 'exposing',
      keywords: 'port effect module where command subscription exposing',
      contains: [LIST, COMMENT],
      illegal: '\\W\\.|;'
    }, {
      begin: 'import',
      end: '$',
      keywords: 'import as exposing',
      contains: [LIST, COMMENT],
      illegal: '\\W\\.|;'
    }, {
      begin: 'type',
      end: '$',
      keywords: 'type alias',
      contains: [CONSTRUCTOR, LIST, RECORD, COMMENT]
    }, {
      beginKeywords: 'infix infixl infixr',
      end: '$',
      contains: [hljs.C_NUMBER_MODE, COMMENT]
    }, {
      begin: 'port',
      end: '$',
      keywords: 'port',
      contains: [COMMENT]
    },
    // Literals and names.

    CHARACTER, hljs.QUOTE_STRING_MODE, hljs.C_NUMBER_MODE, CONSTRUCTOR, hljs.inherit(hljs.TITLE_MODE, {
      begin: '^[_a-z][\\w\']*'
    }), COMMENT, {
      begin: '->|<-'
    } // No markup, relevance booster
    ],

    illegal: /;/
  };
}
module.exports = elm;

/***/ }),

/***/ 74552:
/***/ ((module) => {

/*
Language: ERB (Embedded Ruby)
Requires: xml.js, ruby.js
Author: Lucas Mazza <lucastmazza@gmail.com>
Contributors: Kassio Borges <kassioborgesm@gmail.com>
Description: "Bridge" language defining fragments of Ruby in HTML within <% .. %>
Website: https://ruby-doc.org/stdlib-2.6.5/libdoc/erb/rdoc/ERB.html
Category: template
*/

/** @type LanguageFn */
function erb(hljs) {
  return {
    name: 'ERB',
    subLanguage: 'xml',
    contains: [hljs.COMMENT('<%#', '%>'), {
      begin: '<%[%=-]?',
      end: '[%-]?%>',
      subLanguage: 'ruby',
      excludeBegin: true,
      excludeEnd: true
    }]
  };
}
module.exports = erb;

/***/ }),

/***/ 88843:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/*
Language: Erlang REPL
Author: Sergey Ignatov <sergey@ignatov.spb.su>
Website: https://www.erlang.org
Category: functional
*/

/** @type LanguageFn */
function erlangRepl(hljs) {
  return {
    name: 'Erlang REPL',
    keywords: {
      built_in: 'spawn spawn_link self',
      keyword: 'after and andalso|10 band begin bnot bor bsl bsr bxor case catch cond div end fun if ' + 'let not of or orelse|10 query receive rem try when xor'
    },
    contains: [{
      className: 'meta',
      begin: '^[0-9]+> ',
      relevance: 10
    }, hljs.COMMENT('%', '$'), {
      className: 'number',
      begin: '\\b(\\d+(_\\d+)*#[a-fA-F0-9]+(_[a-fA-F0-9]+)*|\\d+(_\\d+)*(\\.\\d+(_\\d+)*)?([eE][-+]?\\d+)?)',
      relevance: 0
    }, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, {
      begin: concat(/\?(::)?/, /([A-Z]\w*)/,
      // at least one identifier
      /((::)[A-Z]\w*)*/ // perhaps more
      )
    }, {
      begin: '->'
    }, {
      begin: 'ok'
    }, {
      begin: '!'
    }, {
      begin: '(\\b[a-z\'][a-zA-Z0-9_\']*:[a-z\'][a-zA-Z0-9_\']*)|(\\b[a-z\'][a-zA-Z0-9_\']*)',
      relevance: 0
    }, {
      begin: '[A-Z][a-zA-Z0-9_\']*',
      relevance: 0
    }]
  };
}
module.exports = erlangRepl;

/***/ }),

/***/ 88758:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
/*
Language: Erlang
Description: Erlang is a general-purpose functional language, with strict evaluation, single assignment, and dynamic typing.
Author: Nikolay Zakharov <nikolay.desh@gmail.com>, Dmitry Kovega <arhibot@gmail.com>
Website: https://www.erlang.org
Category: functional
*/

/** @type LanguageFn */
function erlang(hljs) {
  var BASIC_ATOM_RE = '[a-z\'][a-zA-Z0-9_\']*';
  var FUNCTION_NAME_RE = '(' + BASIC_ATOM_RE + ':' + BASIC_ATOM_RE + '|' + BASIC_ATOM_RE + ')';
  var ERLANG_RESERVED = {
    keyword: 'after and andalso|10 band begin bnot bor bsl bzr bxor case catch cond div end fun if ' + 'let not of orelse|10 query receive rem try when xor',
    literal: 'false true'
  };
  var COMMENT = hljs.COMMENT('%', '$');
  var NUMBER = {
    className: 'number',
    begin: '\\b(\\d+(_\\d+)*#[a-fA-F0-9]+(_[a-fA-F0-9]+)*|\\d+(_\\d+)*(\\.\\d+(_\\d+)*)?([eE][-+]?\\d+)?)',
    relevance: 0
  };
  var NAMED_FUN = {
    begin: 'fun\\s+' + BASIC_ATOM_RE + '/\\d+'
  };
  var FUNCTION_CALL = {
    begin: FUNCTION_NAME_RE + '\\(',
    end: '\\)',
    returnBegin: true,
    relevance: 0,
    contains: [{
      begin: FUNCTION_NAME_RE,
      relevance: 0
    }, {
      begin: '\\(',
      end: '\\)',
      endsWithParent: true,
      returnEnd: true,
      relevance: 0
      // "contains" defined later
    }]
  };

  var TUPLE = {
    begin: /\{/,
    end: /\}/,
    relevance: 0
    // "contains" defined later
  };

  var VAR1 = {
    begin: '\\b_([A-Z][A-Za-z0-9_]*)?',
    relevance: 0
  };
  var VAR2 = {
    begin: '[A-Z][a-zA-Z0-9_]*',
    relevance: 0
  };
  var RECORD_ACCESS = {
    begin: '#' + hljs.UNDERSCORE_IDENT_RE,
    relevance: 0,
    returnBegin: true,
    contains: [{
      begin: '#' + hljs.UNDERSCORE_IDENT_RE,
      relevance: 0
    }, {
      begin: /\{/,
      end: /\}/,
      relevance: 0
      // "contains" defined later
    }]
  };

  var BLOCK_STATEMENTS = {
    beginKeywords: 'fun receive if try case',
    end: 'end',
    keywords: ERLANG_RESERVED
  };
  BLOCK_STATEMENTS.contains = [COMMENT, NAMED_FUN, hljs.inherit(hljs.APOS_STRING_MODE, {
    className: ''
  }), BLOCK_STATEMENTS, FUNCTION_CALL, hljs.QUOTE_STRING_MODE, NUMBER, TUPLE, VAR1, VAR2, RECORD_ACCESS];
  var BASIC_MODES = [COMMENT, NAMED_FUN, BLOCK_STATEMENTS, FUNCTION_CALL, hljs.QUOTE_STRING_MODE, NUMBER, TUPLE, VAR1, VAR2, RECORD_ACCESS];
  FUNCTION_CALL.contains[1].contains = BASIC_MODES;
  TUPLE.contains = BASIC_MODES;
  RECORD_ACCESS.contains[1].contains = BASIC_MODES;
  var DIRECTIVES = ["-module", "-record", "-undef", "-export", "-ifdef", "-ifndef", "-author", "-copyright", "-doc", "-vsn", "-import", "-include", "-include_lib", "-compile", "-define", "-else", "-endif", "-file", "-behaviour", "-behavior", "-spec"];
  var PARAMS = {
    className: 'params',
    begin: '\\(',
    end: '\\)',
    contains: BASIC_MODES
  };
  return {
    name: 'Erlang',
    aliases: ['erl'],
    keywords: ERLANG_RESERVED,
    illegal: '(</|\\*=|\\+=|-=|/\\*|\\*/|\\(\\*|\\*\\))',
    contains: [{
      className: 'function',
      begin: '^' + BASIC_ATOM_RE + '\\s*\\(',
      end: '->',
      returnBegin: true,
      illegal: '\\(|#|//|/\\*|\\\\|:|;',
      contains: [PARAMS, hljs.inherit(hljs.TITLE_MODE, {
        begin: BASIC_ATOM_RE
      })],
      starts: {
        end: ';|\\.',
        keywords: ERLANG_RESERVED,
        contains: BASIC_MODES
      }
    }, COMMENT, {
      begin: '^-',
      end: '\\.',
      relevance: 0,
      excludeEnd: true,
      returnBegin: true,
      keywords: {
        $pattern: '-' + hljs.IDENT_RE,
        keyword: DIRECTIVES.map(function (x) {
          return "".concat(x, "|1.5");
        }).join(" ")
      },
      contains: [PARAMS]
    }, NUMBER, hljs.QUOTE_STRING_MODE, RECORD_ACCESS, VAR1, VAR2, TUPLE, {
      begin: /\.$/
    } // relevance booster
    ]
  };
}

module.exports = erlang;

/***/ }),

/***/ 20715:
/***/ ((module) => {

/*
Language: Excel formulae
Author: Victor Zhou <OiCMudkips@users.noreply.github.com>
Description: Excel formulae
Website: https://products.office.com/en-us/excel/
*/

/** @type LanguageFn */
function excel(hljs) {
  return {
    name: 'Excel formulae',
    aliases: ['xlsx', 'xls'],
    case_insensitive: true,
    // built-in functions imported from https://web.archive.org/web/20160513042710/https://support.office.com/en-us/article/Excel-functions-alphabetical-b3944572-255d-4efb-bb96-c6d90033e188
    keywords: {
      $pattern: /[a-zA-Z][\w\.]*/,
      built_in: 'ABS ACCRINT ACCRINTM ACOS ACOSH ACOT ACOTH AGGREGATE ADDRESS AMORDEGRC AMORLINC AND ARABIC AREAS ASC ASIN ASINH ATAN ATAN2 ATANH AVEDEV AVERAGE AVERAGEA AVERAGEIF AVERAGEIFS BAHTTEXT BASE BESSELI BESSELJ BESSELK BESSELY BETADIST BETA.DIST BETAINV BETA.INV BIN2DEC BIN2HEX BIN2OCT BINOMDIST BINOM.DIST BINOM.DIST.RANGE BINOM.INV BITAND BITLSHIFT BITOR BITRSHIFT BITXOR CALL CEILING CEILING.MATH CEILING.PRECISE CELL CHAR CHIDIST CHIINV CHITEST CHISQ.DIST CHISQ.DIST.RT CHISQ.INV CHISQ.INV.RT CHISQ.TEST CHOOSE CLEAN CODE COLUMN COLUMNS COMBIN COMBINA COMPLEX CONCAT CONCATENATE CONFIDENCE CONFIDENCE.NORM CONFIDENCE.T CONVERT CORREL COS COSH COT COTH COUNT COUNTA COUNTBLANK COUNTIF COUNTIFS COUPDAYBS COUPDAYS COUPDAYSNC COUPNCD COUPNUM COUPPCD COVAR COVARIANCE.P COVARIANCE.S CRITBINOM CSC CSCH CUBEKPIMEMBER CUBEMEMBER CUBEMEMBERPROPERTY CUBERANKEDMEMBER CUBESET CUBESETCOUNT CUBEVALUE CUMIPMT CUMPRINC DATE DATEDIF DATEVALUE DAVERAGE DAY DAYS DAYS360 DB DBCS DCOUNT DCOUNTA DDB DEC2BIN DEC2HEX DEC2OCT DECIMAL DEGREES DELTA DEVSQ DGET DISC DMAX DMIN DOLLAR DOLLARDE DOLLARFR DPRODUCT DSTDEV DSTDEVP DSUM DURATION DVAR DVARP EDATE EFFECT ENCODEURL EOMONTH ERF ERF.PRECISE ERFC ERFC.PRECISE ERROR.TYPE EUROCONVERT EVEN EXACT EXP EXPON.DIST EXPONDIST FACT FACTDOUBLE FALSE|0 F.DIST FDIST F.DIST.RT FILTERXML FIND FINDB F.INV F.INV.RT FINV FISHER FISHERINV FIXED FLOOR FLOOR.MATH FLOOR.PRECISE FORECAST FORECAST.ETS FORECAST.ETS.CONFINT FORECAST.ETS.SEASONALITY FORECAST.ETS.STAT FORECAST.LINEAR FORMULATEXT FREQUENCY F.TEST FTEST FV FVSCHEDULE GAMMA GAMMA.DIST GAMMADIST GAMMA.INV GAMMAINV GAMMALN GAMMALN.PRECISE GAUSS GCD GEOMEAN GESTEP GETPIVOTDATA GROWTH HARMEAN HEX2BIN HEX2DEC HEX2OCT HLOOKUP HOUR HYPERLINK HYPGEOM.DIST HYPGEOMDIST IF IFERROR IFNA IFS IMABS IMAGINARY IMARGUMENT IMCONJUGATE IMCOS IMCOSH IMCOT IMCSC IMCSCH IMDIV IMEXP IMLN IMLOG10 IMLOG2 IMPOWER IMPRODUCT IMREAL IMSEC IMSECH IMSIN IMSINH IMSQRT IMSUB IMSUM IMTAN INDEX INDIRECT INFO INT INTERCEPT INTRATE IPMT IRR ISBLANK ISERR ISERROR ISEVEN ISFORMULA ISLOGICAL ISNA ISNONTEXT ISNUMBER ISODD ISREF ISTEXT ISO.CEILING ISOWEEKNUM ISPMT JIS KURT LARGE LCM LEFT LEFTB LEN LENB LINEST LN LOG LOG10 LOGEST LOGINV LOGNORM.DIST LOGNORMDIST LOGNORM.INV LOOKUP LOWER MATCH MAX MAXA MAXIFS MDETERM MDURATION MEDIAN MID MIDBs MIN MINIFS MINA MINUTE MINVERSE MIRR MMULT MOD MODE MODE.MULT MODE.SNGL MONTH MROUND MULTINOMIAL MUNIT N NA NEGBINOM.DIST NEGBINOMDIST NETWORKDAYS NETWORKDAYS.INTL NOMINAL NORM.DIST NORMDIST NORMINV NORM.INV NORM.S.DIST NORMSDIST NORM.S.INV NORMSINV NOT NOW NPER NPV NUMBERVALUE OCT2BIN OCT2DEC OCT2HEX ODD ODDFPRICE ODDFYIELD ODDLPRICE ODDLYIELD OFFSET OR PDURATION PEARSON PERCENTILE.EXC PERCENTILE.INC PERCENTILE PERCENTRANK.EXC PERCENTRANK.INC PERCENTRANK PERMUT PERMUTATIONA PHI PHONETIC PI PMT POISSON.DIST POISSON POWER PPMT PRICE PRICEDISC PRICEMAT PROB PRODUCT PROPER PV QUARTILE QUARTILE.EXC QUARTILE.INC QUOTIENT RADIANS RAND RANDBETWEEN RANK.AVG RANK.EQ RANK RATE RECEIVED REGISTER.ID REPLACE REPLACEB REPT RIGHT RIGHTB ROMAN ROUND ROUNDDOWN ROUNDUP ROW ROWS RRI RSQ RTD SEARCH SEARCHB SEC SECH SECOND SERIESSUM SHEET SHEETS SIGN SIN SINH SKEW SKEW.P SLN SLOPE SMALL SQL.REQUEST SQRT SQRTPI STANDARDIZE STDEV STDEV.P STDEV.S STDEVA STDEVP STDEVPA STEYX SUBSTITUTE SUBTOTAL SUM SUMIF SUMIFS SUMPRODUCT SUMSQ SUMX2MY2 SUMX2PY2 SUMXMY2 SWITCH SYD T TAN TANH TBILLEQ TBILLPRICE TBILLYIELD T.DIST T.DIST.2T T.DIST.RT TDIST TEXT TEXTJOIN TIME TIMEVALUE T.INV T.INV.2T TINV TODAY TRANSPOSE TREND TRIM TRIMMEAN TRUE|0 TRUNC T.TEST TTEST TYPE UNICHAR UNICODE UPPER VALUE VAR VAR.P VAR.S VARA VARP VARPA VDB VLOOKUP WEBSERVICE WEEKDAY WEEKNUM WEIBULL WEIBULL.DIST WORKDAY WORKDAY.INTL XIRR XNPV XOR YEAR YEARFRAC YIELD YIELDDISC YIELDMAT Z.TEST ZTEST'
    },
    contains: [{
      /* matches a beginning equal sign found in Excel formula examples */
      begin: /^=/,
      end: /[^=]/,
      returnEnd: true,
      illegal: /=/,
      /* only allow single equal sign at front of line */
      relevance: 10
    }, /* technically, there can be more than 2 letters in column names, but this prevents conflict with some keywords */
    {
      /* matches a reference to a single cell */
      className: 'symbol',
      begin: /\b[A-Z]{1,2}\d+\b/,
      end: /[^\d]/,
      excludeEnd: true,
      relevance: 0
    }, {
      /* matches a reference to a range of cells */
      className: 'symbol',
      begin: /[A-Z]{0,2}\d*:[A-Z]{0,2}\d*/,
      relevance: 0
    }, hljs.BACKSLASH_ESCAPE, hljs.QUOTE_STRING_MODE, {
      className: 'number',
      begin: hljs.NUMBER_RE + '(%)?',
      relevance: 0
    }, /* Excel formula comments are done by putting the comment in a function call to N() */
    hljs.COMMENT(/\bN\(/, /\)/, {
      excludeBegin: true,
      excludeEnd: true,
      illegal: /\n/
    })]
  };
}
module.exports = excel;

/***/ }),

/***/ 29834:
/***/ ((module) => {

/*
Language: FIX
Author: Brent Bradbury <brent@brentium.com>
*/

/** @type LanguageFn */
function fix(hljs) {
  return {
    name: 'FIX',
    contains: [{
      begin: /[^\u2401\u0001]+/,
      end: /[\u2401\u0001]/,
      excludeEnd: true,
      returnBegin: true,
      returnEnd: false,
      contains: [{
        begin: /([^\u2401\u0001=]+)/,
        end: /=([^\u2401\u0001=]+)/,
        returnEnd: true,
        returnBegin: false,
        className: 'attr'
      }, {
        begin: /=/,
        end: /([\u2401\u0001])/,
        excludeEnd: true,
        excludeBegin: true,
        className: 'string'
      }]
    }],
    case_insensitive: true
  };
}
module.exports = fix;

/***/ }),

/***/ 84908:
/***/ ((module) => {

/*
 Language: Flix
 Category: functional
 Author: Magnus Madsen <mmadsen@uwaterloo.ca>
 Website: https://flix.dev/
 */

/** @type LanguageFn */
function flix(hljs) {
  var CHAR = {
    className: 'string',
    begin: /'(.|\\[xXuU][a-zA-Z0-9]+)'/
  };
  var STRING = {
    className: 'string',
    variants: [{
      begin: '"',
      end: '"'
    }]
  };
  var NAME = {
    className: 'title',
    relevance: 0,
    begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/
  };
  var METHOD = {
    className: 'function',
    beginKeywords: 'def',
    end: /[:={\[(\n;]/,
    excludeEnd: true,
    contains: [NAME]
  };
  return {
    name: 'Flix',
    keywords: {
      literal: 'true false',
      keyword: 'case class def else enum if impl import in lat rel index let match namespace switch type yield with'
    },
    contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, CHAR, STRING, METHOD, hljs.C_NUMBER_MODE]
  };
}
module.exports = flix;

/***/ }),

/***/ 65977:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/*
Language: Fortran
Author: Anthony Scemama <scemama@irsamc.ups-tlse.fr>
Website: https://en.wikipedia.org/wiki/Fortran
Category: scientific
*/

/** @type LanguageFn */
function fortran(hljs) {
  var PARAMS = {
    className: 'params',
    begin: '\\(',
    end: '\\)'
  };
  var COMMENT = {
    variants: [hljs.COMMENT('!', '$', {
      relevance: 0
    }),
    // allow FORTRAN 77 style comments
    hljs.COMMENT('^C[ ]', '$', {
      relevance: 0
    }), hljs.COMMENT('^C$', '$', {
      relevance: 0
    })]
  };

  // regex in both fortran and irpf90 should match
  var OPTIONAL_NUMBER_SUFFIX = /(_[a-z_\d]+)?/;
  var OPTIONAL_NUMBER_EXP = /([de][+-]?\d+)?/;
  var NUMBER = {
    className: 'number',
    variants: [{
      begin: concat(/\b\d+/, /\.(\d*)/, OPTIONAL_NUMBER_EXP, OPTIONAL_NUMBER_SUFFIX)
    }, {
      begin: concat(/\b\d+/, OPTIONAL_NUMBER_EXP, OPTIONAL_NUMBER_SUFFIX)
    }, {
      begin: concat(/\.\d+/, OPTIONAL_NUMBER_EXP, OPTIONAL_NUMBER_SUFFIX)
    }],
    relevance: 0
  };
  var FUNCTION_DEF = {
    className: 'function',
    beginKeywords: 'subroutine function program',
    illegal: '[${=\\n]',
    contains: [hljs.UNDERSCORE_TITLE_MODE, PARAMS]
  };
  var STRING = {
    className: 'string',
    relevance: 0,
    variants: [hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE]
  };
  var KEYWORDS = {
    literal: '.False. .True.',
    keyword: 'kind do concurrent local shared while private call intrinsic where elsewhere ' + 'type endtype endmodule endselect endinterface end enddo endif if forall endforall only contains default return stop then block endblock endassociate ' + 'public subroutine|10 function program .and. .or. .not. .le. .eq. .ge. .gt. .lt. ' + 'goto save else use module select case ' + 'access blank direct exist file fmt form formatted iostat name named nextrec number opened rec recl sequential status unformatted unit ' + 'continue format pause cycle exit ' + 'c_null_char c_alert c_backspace c_form_feed flush wait decimal round iomsg ' + 'synchronous nopass non_overridable pass protected volatile abstract extends import ' + 'non_intrinsic value deferred generic final enumerator class associate bind enum ' + 'c_int c_short c_long c_long_long c_signed_char c_size_t c_int8_t c_int16_t c_int32_t c_int64_t c_int_least8_t c_int_least16_t ' + 'c_int_least32_t c_int_least64_t c_int_fast8_t c_int_fast16_t c_int_fast32_t c_int_fast64_t c_intmax_t C_intptr_t c_float c_double ' + 'c_long_double c_float_complex c_double_complex c_long_double_complex c_bool c_char c_null_ptr c_null_funptr ' + 'c_new_line c_carriage_return c_horizontal_tab c_vertical_tab iso_c_binding c_loc c_funloc c_associated  c_f_pointer ' + 'c_ptr c_funptr iso_fortran_env character_storage_size error_unit file_storage_size input_unit iostat_end iostat_eor ' + 'numeric_storage_size output_unit c_f_procpointer ieee_arithmetic ieee_support_underflow_control ' + 'ieee_get_underflow_mode ieee_set_underflow_mode newunit contiguous recursive ' + 'pad position action delim readwrite eor advance nml interface procedure namelist include sequence elemental pure impure ' + 'integer real character complex logical codimension dimension allocatable|10 parameter ' + 'external implicit|10 none double precision assign intent optional pointer ' + 'target in out common equivalence data',
    built_in: 'alog alog10 amax0 amax1 amin0 amin1 amod cabs ccos cexp clog csin csqrt dabs dacos dasin datan datan2 dcos dcosh ddim dexp dint ' + 'dlog dlog10 dmax1 dmin1 dmod dnint dsign dsin dsinh dsqrt dtan dtanh float iabs idim idint idnint ifix isign max0 max1 min0 min1 sngl ' + 'algama cdabs cdcos cdexp cdlog cdsin cdsqrt cqabs cqcos cqexp cqlog cqsin cqsqrt dcmplx dconjg derf derfc dfloat dgamma dimag dlgama ' + 'iqint qabs qacos qasin qatan qatan2 qcmplx qconjg qcos qcosh qdim qerf qerfc qexp qgamma qimag qlgama qlog qlog10 qmax1 qmin1 qmod ' + 'qnint qsign qsin qsinh qsqrt qtan qtanh abs acos aimag aint anint asin atan atan2 char cmplx conjg cos cosh exp ichar index int log ' + 'log10 max min nint sign sin sinh sqrt tan tanh print write dim lge lgt lle llt mod nullify allocate deallocate ' + 'adjustl adjustr all allocated any associated bit_size btest ceiling count cshift date_and_time digits dot_product ' + 'eoshift epsilon exponent floor fraction huge iand ibclr ibits ibset ieor ior ishft ishftc lbound len_trim matmul ' + 'maxexponent maxloc maxval merge minexponent minloc minval modulo mvbits nearest pack present product ' + 'radix random_number random_seed range repeat reshape rrspacing scale scan selected_int_kind selected_real_kind ' + 'set_exponent shape size spacing spread sum system_clock tiny transpose trim ubound unpack verify achar iachar transfer ' + 'dble entry dprod cpu_time command_argument_count get_command get_command_argument get_environment_variable is_iostat_end ' + 'ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode ' + 'is_iostat_eor move_alloc new_line selected_char_kind same_type_as extends_type_of ' + 'acosh asinh atanh bessel_j0 bessel_j1 bessel_jn bessel_y0 bessel_y1 bessel_yn erf erfc erfc_scaled gamma log_gamma hypot norm2 ' + 'atomic_define atomic_ref execute_command_line leadz trailz storage_size merge_bits ' + 'bge bgt ble blt dshiftl dshiftr findloc iall iany iparity image_index lcobound ucobound maskl maskr ' + 'num_images parity popcnt poppar shifta shiftl shiftr this_image sync change team co_broadcast co_max co_min co_sum co_reduce'
  };
  return {
    name: 'Fortran',
    case_insensitive: true,
    aliases: ['f90', 'f95'],
    keywords: KEYWORDS,
    illegal: /\/\*/,
    contains: [STRING, FUNCTION_DEF,
    // allow `C = value` for assignments so they aren't misdetected
    // as Fortran 77 style comments
    {
      begin: /^C\s*=(?!=)/,
      relevance: 0
    }, COMMENT, NUMBER]
  };
}
module.exports = fortran;

/***/ }),

/***/ 98810:
/***/ ((module) => {

/*
Language: F#
Author: Jonas Follesø <jonas@follesoe.no>
Contributors: Troy Kershaw <hello@troykershaw.com>, Henrik Feldt <henrik@haf.se>
Website: https://docs.microsoft.com/en-us/dotnet/fsharp/
Category: functional
*/

/** @type LanguageFn */
function fsharp(hljs) {
  var TYPEPARAM = {
    begin: '<',
    end: '>',
    contains: [hljs.inherit(hljs.TITLE_MODE, {
      begin: /'[a-zA-Z0-9_]+/
    })]
  };
  return {
    name: 'F#',
    aliases: ['fs'],
    keywords: 'abstract and as assert base begin class default delegate do done ' + 'downcast downto elif else end exception extern false finally for ' + 'fun function global if in inherit inline interface internal lazy let ' + 'match member module mutable namespace new null of open or ' + 'override private public rec return sig static struct then to ' + 'true try type upcast use val void when while with yield',
    illegal: /\/\*/,
    contains: [{
      // monad builder keywords (matches before non-bang kws)
      className: 'keyword',
      begin: /\b(yield|return|let|do)!/
    }, {
      className: 'string',
      begin: '@"',
      end: '"',
      contains: [{
        begin: '""'
      }]
    }, {
      className: 'string',
      begin: '"""',
      end: '"""'
    }, hljs.COMMENT('\\(\\*(\\s)', '\\*\\)', {
      contains: ["self"]
    }), {
      className: 'class',
      beginKeywords: 'type',
      end: '\\(|=|$',
      excludeEnd: true,
      contains: [hljs.UNDERSCORE_TITLE_MODE, TYPEPARAM]
    }, {
      className: 'meta',
      begin: '\\[<',
      end: '>\\]',
      relevance: 10
    }, {
      className: 'symbol',
      begin: '\\B(\'[A-Za-z])\\b',
      contains: [hljs.BACKSLASH_ESCAPE]
    }, hljs.C_LINE_COMMENT_MODE, hljs.inherit(hljs.QUOTE_STRING_MODE, {
      illegal: null
    }), hljs.C_NUMBER_MODE]
  };
}
module.exports = fsharp;

/***/ }),

/***/ 24106:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function anyNumberOfTimes(re) {
  return concat('(', re, ')*');
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/** @type LanguageFn */
function gams(hljs) {
  var KEYWORDS = {
    keyword: 'abort acronym acronyms alias all and assign binary card diag display ' + 'else eq file files for free ge gt if integer le loop lt maximizing ' + 'minimizing model models ne negative no not option options or ord ' + 'positive prod put putpage puttl repeat sameas semicont semiint smax ' + 'smin solve sos1 sos2 sum system table then until using while xor yes',
    literal: 'eps inf na',
    built_in: 'abs arccos arcsin arctan arctan2 Beta betaReg binomial ceil centropy ' + 'cos cosh cvPower div div0 eDist entropy errorf execSeed exp fact ' + 'floor frac gamma gammaReg log logBeta logGamma log10 log2 mapVal max ' + 'min mod ncpCM ncpF ncpVUpow ncpVUsin normal pi poly power ' + 'randBinomial randLinear randTriangle round rPower sigmoid sign ' + 'signPower sin sinh slexp sllog10 slrec sqexp sqlog10 sqr sqrec sqrt ' + 'tan tanh trunc uniform uniformInt vcPower bool_and bool_eqv bool_imp ' + 'bool_not bool_or bool_xor ifThen rel_eq rel_ge rel_gt rel_le rel_lt ' + 'rel_ne gday gdow ghour gleap gmillisec gminute gmonth gsecond gyear ' + 'jdate jnow jstart jtime errorLevel execError gamsRelease gamsVersion ' + 'handleCollect handleDelete handleStatus handleSubmit heapFree ' + 'heapLimit heapSize jobHandle jobKill jobStatus jobTerminate ' + 'licenseLevel licenseStatus maxExecError sleep timeClose timeComp ' + 'timeElapsed timeExec timeStart'
  };
  var PARAMS = {
    className: 'params',
    begin: /\(/,
    end: /\)/,
    excludeBegin: true,
    excludeEnd: true
  };
  var SYMBOLS = {
    className: 'symbol',
    variants: [{
      begin: /=[lgenxc]=/
    }, {
      begin: /\$/
    }]
  };
  var QSTR = {
    // One-line quoted comment string
    className: 'comment',
    variants: [{
      begin: '\'',
      end: '\''
    }, {
      begin: '"',
      end: '"'
    }],
    illegal: '\\n',
    contains: [hljs.BACKSLASH_ESCAPE]
  };
  var ASSIGNMENT = {
    begin: '/',
    end: '/',
    keywords: KEYWORDS,
    contains: [QSTR, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.QUOTE_STRING_MODE, hljs.APOS_STRING_MODE, hljs.C_NUMBER_MODE]
  };
  var COMMENT_WORD = /[a-z0-9&#*=?@\\><:,()$[\]_.{}!+%^-]+/;
  var DESCTEXT = {
    // Parameter/set/variable description text
    begin: /[a-z][a-z0-9_]*(\([a-z0-9_, ]*\))?[ \t]+/,
    excludeBegin: true,
    end: '$',
    endsWithParent: true,
    contains: [QSTR, ASSIGNMENT, {
      className: 'comment',
      // one comment word, then possibly more
      begin: concat(COMMENT_WORD,
      // [ ] because \s would be too broad (matching newlines)
      anyNumberOfTimes(concat(/[ ]+/, COMMENT_WORD))),
      relevance: 0
    }]
  };
  return {
    name: 'GAMS',
    aliases: ['gms'],
    case_insensitive: true,
    keywords: KEYWORDS,
    contains: [hljs.COMMENT(/^\$ontext/, /^\$offtext/), {
      className: 'meta',
      begin: '^\\$[a-z0-9]+',
      end: '$',
      returnBegin: true,
      contains: [{
        className: 'meta-keyword',
        begin: '^\\$[a-z0-9]+'
      }]
    }, hljs.COMMENT('^\\*', '$'), hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.QUOTE_STRING_MODE, hljs.APOS_STRING_MODE,
    // Declarations
    {
      beginKeywords: 'set sets parameter parameters variable variables ' + 'scalar scalars equation equations',
      end: ';',
      contains: [hljs.COMMENT('^\\*', '$'), hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.QUOTE_STRING_MODE, hljs.APOS_STRING_MODE, ASSIGNMENT, DESCTEXT]
    }, {
      // table environment
      beginKeywords: 'table',
      end: ';',
      returnBegin: true,
      contains: [{
        // table header row
        beginKeywords: 'table',
        end: '$',
        contains: [DESCTEXT]
      }, hljs.COMMENT('^\\*', '$'), hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.QUOTE_STRING_MODE, hljs.APOS_STRING_MODE, hljs.C_NUMBER_MODE
      // Table does not contain DESCTEXT or ASSIGNMENT
      ]
    },
    // Function definitions
    {
      className: 'function',
      begin: /^[a-z][a-z0-9_,\-+' ()$]+\.{2}/,
      returnBegin: true,
      contains: [{
        // Function title
        className: 'title',
        begin: /^[a-z0-9_]+/
      }, PARAMS, SYMBOLS]
    }, hljs.C_NUMBER_MODE, SYMBOLS]
  };
}
module.exports = gams;

/***/ }),

/***/ 11342:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
__webpack_require__(69600);
__webpack_require__(74916);
__webpack_require__(23123);
/*
Language: GAUSS
Author: Matt Evans <matt@aptech.com>
Description: GAUSS Mathematical and Statistical language
Website: https://www.aptech.com
Category: scientific
*/
function gauss(hljs) {
  var KEYWORDS = {
    keyword: 'bool break call callexe checkinterrupt clear clearg closeall cls comlog compile ' + 'continue create debug declare delete disable dlibrary dllcall do dos ed edit else ' + 'elseif enable end endfor endif endp endo errorlog errorlogat expr external fn ' + 'for format goto gosub graph if keyword let lib library line load loadarray loadexe ' + 'loadf loadk loadm loadp loads loadx local locate loopnextindex lprint lpwidth lshow ' + 'matrix msym ndpclex new open output outwidth plot plotsym pop prcsn print ' + 'printdos proc push retp return rndcon rndmod rndmult rndseed run save saveall screen ' + 'scroll setarray show sparse stop string struct system trace trap threadfor ' + 'threadendfor threadbegin threadjoin threadstat threadend until use while winprint ' + 'ne ge le gt lt and xor or not eq eqv',
    built_in: 'abs acf aconcat aeye amax amean AmericanBinomCall AmericanBinomCall_Greeks AmericanBinomCall_ImpVol ' + 'AmericanBinomPut AmericanBinomPut_Greeks AmericanBinomPut_ImpVol AmericanBSCall AmericanBSCall_Greeks ' + 'AmericanBSCall_ImpVol AmericanBSPut AmericanBSPut_Greeks AmericanBSPut_ImpVol amin amult annotationGetDefaults ' + 'annotationSetBkd annotationSetFont annotationSetLineColor annotationSetLineStyle annotationSetLineThickness ' + 'annualTradingDays arccos arcsin areshape arrayalloc arrayindex arrayinit arraytomat asciiload asclabel astd ' + 'astds asum atan atan2 atranspose axmargin balance band bandchol bandcholsol bandltsol bandrv bandsolpd bar ' + 'base10 begwind besselj bessely beta box boxcox cdfBeta cdfBetaInv cdfBinomial cdfBinomialInv cdfBvn cdfBvn2 ' + 'cdfBvn2e cdfCauchy cdfCauchyInv cdfChic cdfChii cdfChinc cdfChincInv cdfExp cdfExpInv cdfFc cdfFnc cdfFncInv ' + 'cdfGam cdfGenPareto cdfHyperGeo cdfLaplace cdfLaplaceInv cdfLogistic cdfLogisticInv cdfmControlCreate cdfMvn ' + 'cdfMvn2e cdfMvnce cdfMvne cdfMvt2e cdfMvtce cdfMvte cdfN cdfN2 cdfNc cdfNegBinomial cdfNegBinomialInv cdfNi ' + 'cdfPoisson cdfPoissonInv cdfRayleigh cdfRayleighInv cdfTc cdfTci cdfTnc cdfTvn cdfWeibull cdfWeibullInv cdir ' + 'ceil ChangeDir chdir chiBarSquare chol choldn cholsol cholup chrs close code cols colsf combinate combinated ' + 'complex con cond conj cons ConScore contour conv convertsatostr convertstrtosa corrm corrms corrvc corrx corrxs ' + 'cos cosh counts countwts crossprd crout croutp csrcol csrlin csvReadM csvReadSA cumprodc cumsumc curve cvtos ' + 'datacreate datacreatecomplex datalist dataload dataloop dataopen datasave date datestr datestring datestrymd ' + 'dayinyr dayofweek dbAddDatabase dbClose dbCommit dbCreateQuery dbExecQuery dbGetConnectOptions dbGetDatabaseName ' + 'dbGetDriverName dbGetDrivers dbGetHostName dbGetLastErrorNum dbGetLastErrorText dbGetNumericalPrecPolicy ' + 'dbGetPassword dbGetPort dbGetTableHeaders dbGetTables dbGetUserName dbHasFeature dbIsDriverAvailable dbIsOpen ' + 'dbIsOpenError dbOpen dbQueryBindValue dbQueryClear dbQueryCols dbQueryExecPrepared dbQueryFetchAllM dbQueryFetchAllSA ' + 'dbQueryFetchOneM dbQueryFetchOneSA dbQueryFinish dbQueryGetBoundValue dbQueryGetBoundValues dbQueryGetField ' + 'dbQueryGetLastErrorNum dbQueryGetLastErrorText dbQueryGetLastInsertID dbQueryGetLastQuery dbQueryGetPosition ' + 'dbQueryIsActive dbQueryIsForwardOnly dbQueryIsNull dbQueryIsSelect dbQueryIsValid dbQueryPrepare dbQueryRows ' + 'dbQuerySeek dbQuerySeekFirst dbQuerySeekLast dbQuerySeekNext dbQuerySeekPrevious dbQuerySetForwardOnly ' + 'dbRemoveDatabase dbRollback dbSetConnectOptions dbSetDatabaseName dbSetHostName dbSetNumericalPrecPolicy ' + 'dbSetPort dbSetUserName dbTransaction DeleteFile delif delrows denseToSp denseToSpRE denToZero design det detl ' + 'dfft dffti diag diagrv digamma doswin DOSWinCloseall DOSWinOpen dotfeq dotfeqmt dotfge dotfgemt dotfgt dotfgtmt ' + 'dotfle dotflemt dotflt dotfltmt dotfne dotfnemt draw drop dsCreate dstat dstatmt dstatmtControlCreate dtdate dtday ' + 'dttime dttodtv dttostr dttoutc dtvnormal dtvtodt dtvtoutc dummy dummybr dummydn eig eigh eighv eigv elapsedTradingDays ' + 'endwind envget eof eqSolve eqSolvemt eqSolvemtControlCreate eqSolvemtOutCreate eqSolveset erf erfc erfccplx erfcplx error ' + 'etdays ethsec etstr EuropeanBinomCall EuropeanBinomCall_Greeks EuropeanBinomCall_ImpVol EuropeanBinomPut ' + 'EuropeanBinomPut_Greeks EuropeanBinomPut_ImpVol EuropeanBSCall EuropeanBSCall_Greeks EuropeanBSCall_ImpVol ' + 'EuropeanBSPut EuropeanBSPut_Greeks EuropeanBSPut_ImpVol exctsmpl exec execbg exp extern eye fcheckerr fclearerr feq ' + 'feqmt fflush fft ffti fftm fftmi fftn fge fgemt fgets fgetsa fgetsat fgetst fgt fgtmt fileinfo filesa fle flemt ' + 'floor flt fltmt fmod fne fnemt fonts fopen formatcv formatnv fputs fputst fseek fstrerror ftell ftocv ftos ftostrC ' + 'gamma gammacplx gammaii gausset gdaAppend gdaCreate gdaDStat gdaDStatMat gdaGetIndex gdaGetName gdaGetNames gdaGetOrders ' + 'gdaGetType gdaGetTypes gdaGetVarInfo gdaIsCplx gdaLoad gdaPack gdaRead gdaReadByIndex gdaReadSome gdaReadSparse ' + 'gdaReadStruct gdaReportVarInfo gdaSave gdaUpdate gdaUpdateAndPack gdaVars gdaWrite gdaWrite32 gdaWriteSome getarray ' + 'getdims getf getGAUSShome getmatrix getmatrix4D getname getnamef getNextTradingDay getNextWeekDay getnr getorders ' + 'getpath getPreviousTradingDay getPreviousWeekDay getRow getscalar3D getscalar4D getTrRow getwind glm gradcplx gradMT ' + 'gradMTm gradMTT gradMTTm gradp graphprt graphset hasimag header headermt hess hessMT hessMTg hessMTgw hessMTm ' + 'hessMTmw hessMTT hessMTTg hessMTTgw hessMTTm hessMTw hessp hist histf histp hsec imag indcv indexcat indices indices2 ' + 'indicesf indicesfn indnv indsav integrate1d integrateControlCreate intgrat2 intgrat3 inthp1 inthp2 inthp3 inthp4 ' + 'inthpControlCreate intquad1 intquad2 intquad3 intrleav intrleavsa intrsect intsimp inv invpd invswp iscplx iscplxf ' + 'isden isinfnanmiss ismiss key keyav keyw lag lag1 lagn lapEighb lapEighi lapEighvb lapEighvi lapgEig lapgEigh lapgEighv ' + 'lapgEigv lapgSchur lapgSvdcst lapgSvds lapgSvdst lapSvdcusv lapSvds lapSvdusv ldlp ldlsol linSolve listwise ln lncdfbvn ' + 'lncdfbvn2 lncdfmvn lncdfn lncdfn2 lncdfnc lnfact lngammacplx lnpdfmvn lnpdfmvt lnpdfn lnpdft loadd loadstruct loadwind ' + 'loess loessmt loessmtControlCreate log loglog logx logy lower lowmat lowmat1 ltrisol lu lusol machEpsilon make makevars ' + 'makewind margin matalloc matinit mattoarray maxbytes maxc maxindc maxv maxvec mbesselei mbesselei0 mbesselei1 mbesseli ' + 'mbesseli0 mbesseli1 meanc median mergeby mergevar minc minindc minv miss missex missrv moment momentd movingave ' + 'movingaveExpwgt movingaveWgt nextindex nextn nextnevn nextwind ntos null null1 numCombinations ols olsmt olsmtControlCreate ' + 'olsqr olsqr2 olsqrmt ones optn optnevn orth outtyp pacf packedToSp packr parse pause pdfCauchy pdfChi pdfExp pdfGenPareto ' + 'pdfHyperGeo pdfLaplace pdfLogistic pdfn pdfPoisson pdfRayleigh pdfWeibull pi pinv pinvmt plotAddArrow plotAddBar plotAddBox ' + 'plotAddHist plotAddHistF plotAddHistP plotAddPolar plotAddScatter plotAddShape plotAddTextbox plotAddTS plotAddXY plotArea ' + 'plotBar plotBox plotClearLayout plotContour plotCustomLayout plotGetDefaults plotHist plotHistF plotHistP plotLayout ' + 'plotLogLog plotLogX plotLogY plotOpenWindow plotPolar plotSave plotScatter plotSetAxesPen plotSetBar plotSetBarFill ' + 'plotSetBarStacked plotSetBkdColor plotSetFill plotSetGrid plotSetLegend plotSetLineColor plotSetLineStyle plotSetLineSymbol ' + 'plotSetLineThickness plotSetNewWindow plotSetTitle plotSetWhichYAxis plotSetXAxisShow plotSetXLabel plotSetXRange ' + 'plotSetXTicInterval plotSetXTicLabel plotSetYAxisShow plotSetYLabel plotSetYRange plotSetZAxisShow plotSetZLabel ' + 'plotSurface plotTS plotXY polar polychar polyeval polygamma polyint polymake polymat polymroot polymult polyroot ' + 'pqgwin previousindex princomp printfm printfmt prodc psi putarray putf putvals pvCreate pvGetIndex pvGetParNames ' + 'pvGetParVector pvLength pvList pvPack pvPacki pvPackm pvPackmi pvPacks pvPacksi pvPacksm pvPacksmi pvPutParVector ' + 'pvTest pvUnpack QNewton QNewtonmt QNewtonmtControlCreate QNewtonmtOutCreate QNewtonSet QProg QProgmt QProgmtInCreate ' + 'qqr qqre qqrep qr qre qrep qrsol qrtsol qtyr qtyre qtyrep quantile quantiled qyr qyre qyrep qz rank rankindx readr ' + 'real reclassify reclassifyCuts recode recserar recsercp recserrc rerun rescale reshape rets rev rfft rffti rfftip rfftn ' + 'rfftnp rfftp rndBernoulli rndBeta rndBinomial rndCauchy rndChiSquare rndCon rndCreateState rndExp rndGamma rndGeo rndGumbel ' + 'rndHyperGeo rndi rndKMbeta rndKMgam rndKMi rndKMn rndKMnb rndKMp rndKMu rndKMvm rndLaplace rndLCbeta rndLCgam rndLCi rndLCn ' + 'rndLCnb rndLCp rndLCu rndLCvm rndLogNorm rndMTu rndMVn rndMVt rndn rndnb rndNegBinomial rndp rndPoisson rndRayleigh ' + 'rndStateSkip rndu rndvm rndWeibull rndWishart rotater round rows rowsf rref sampleData satostrC saved saveStruct savewind ' + 'scale scale3d scalerr scalinfnanmiss scalmiss schtoc schur searchsourcepath seekr select selif seqa seqm setdif setdifsa ' + 'setvars setvwrmode setwind shell shiftr sin singleindex sinh sleep solpd sortc sortcc sortd sorthc sorthcc sortind ' + 'sortindc sortmc sortr sortrc spBiconjGradSol spChol spConjGradSol spCreate spDenseSubmat spDiagRvMat spEigv spEye spLDL ' + 'spline spLU spNumNZE spOnes spreadSheetReadM spreadSheetReadSA spreadSheetWrite spScale spSubmat spToDense spTrTDense ' + 'spTScalar spZeros sqpSolve sqpSolveMT sqpSolveMTControlCreate sqpSolveMTlagrangeCreate sqpSolveMToutCreate sqpSolveSet ' + 'sqrt statements stdc stdsc stocv stof strcombine strindx strlen strput strrindx strsect strsplit strsplitPad strtodt ' + 'strtof strtofcplx strtriml strtrimr strtrunc strtruncl strtruncpad strtruncr submat subscat substute subvec sumc sumr ' + 'surface svd svd1 svd2 svdcusv svds svdusv sysstate tab tan tanh tempname ' + 'time timedt timestr timeutc title tkf2eps tkf2ps tocart todaydt toeplitz token topolar trapchk ' + 'trigamma trimr trunc type typecv typef union unionsa uniqindx uniqindxsa unique uniquesa upmat upmat1 upper utctodt ' + 'utctodtv utrisol vals varCovMS varCovXS varget vargetl varmall varmares varput varputl vartypef vcm vcms vcx vcxs ' + 'vec vech vecr vector vget view viewxyz vlist vnamecv volume vput vread vtypecv wait waitc walkindex where window ' + 'writer xlabel xlsGetSheetCount xlsGetSheetSize xlsGetSheetTypes xlsMakeRange xlsReadM xlsReadSA xlsWrite xlsWriteM ' + 'xlsWriteSA xpnd xtics xy xyz ylabel ytics zeros zeta zlabel ztics cdfEmpirical dot h5create h5open h5read h5readAttribute ' + 'h5write h5writeAttribute ldl plotAddErrorBar plotAddSurface plotCDFEmpirical plotSetColormap plotSetContourLabels ' + 'plotSetLegendFont plotSetTextInterpreter plotSetXTicCount plotSetYTicCount plotSetZLevels powerm strjoin sylvester ' + 'strtrim',
    literal: 'DB_AFTER_LAST_ROW DB_ALL_TABLES DB_BATCH_OPERATIONS DB_BEFORE_FIRST_ROW DB_BLOB DB_EVENT_NOTIFICATIONS ' + 'DB_FINISH_QUERY DB_HIGH_PRECISION DB_LAST_INSERT_ID DB_LOW_PRECISION_DOUBLE DB_LOW_PRECISION_INT32 ' + 'DB_LOW_PRECISION_INT64 DB_LOW_PRECISION_NUMBERS DB_MULTIPLE_RESULT_SETS DB_NAMED_PLACEHOLDERS ' + 'DB_POSITIONAL_PLACEHOLDERS DB_PREPARED_QUERIES DB_QUERY_SIZE DB_SIMPLE_LOCKING DB_SYSTEM_TABLES DB_TABLES ' + 'DB_TRANSACTIONS DB_UNICODE DB_VIEWS __STDIN __STDOUT __STDERR __FILE_DIR'
  };
  var AT_COMMENT_MODE = hljs.COMMENT('@', '@');
  var PREPROCESSOR = {
    className: 'meta',
    begin: '#',
    end: '$',
    keywords: {
      'meta-keyword': 'define definecs|10 undef ifdef ifndef iflight ifdllcall ifmac ifos2win ifunix else endif lineson linesoff srcfile srcline'
    },
    contains: [{
      begin: /\\\n/,
      relevance: 0
    }, {
      beginKeywords: 'include',
      end: '$',
      keywords: {
        'meta-keyword': 'include'
      },
      contains: [{
        className: 'meta-string',
        begin: '"',
        end: '"',
        illegal: '\\n'
      }]
    }, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, AT_COMMENT_MODE]
  };
  var STRUCT_TYPE = {
    begin: /\bstruct\s+/,
    end: /\s/,
    keywords: "struct",
    contains: [{
      className: "type",
      begin: hljs.UNDERSCORE_IDENT_RE,
      relevance: 0
    }]
  };

  // only for definitions
  var PARSE_PARAMS = [{
    className: 'params',
    begin: /\(/,
    end: /\)/,
    excludeBegin: true,
    excludeEnd: true,
    endsWithParent: true,
    relevance: 0,
    contains: [{
      // dots
      className: 'literal',
      begin: /\.\.\./
    }, hljs.C_NUMBER_MODE, hljs.C_BLOCK_COMMENT_MODE, AT_COMMENT_MODE, STRUCT_TYPE]
  }];
  var FUNCTION_DEF = {
    className: "title",
    begin: hljs.UNDERSCORE_IDENT_RE,
    relevance: 0
  };
  var DEFINITION = function DEFINITION(beginKeywords, end, inherits) {
    var mode = hljs.inherit({
      className: "function",
      beginKeywords: beginKeywords,
      end: end,
      excludeEnd: true,
      contains: [].concat(PARSE_PARAMS)
    }, inherits || {});
    mode.contains.push(FUNCTION_DEF);
    mode.contains.push(hljs.C_NUMBER_MODE);
    mode.contains.push(hljs.C_BLOCK_COMMENT_MODE);
    mode.contains.push(AT_COMMENT_MODE);
    return mode;
  };
  var BUILT_IN_REF = {
    // these are explicitly named internal function calls
    className: 'built_in',
    begin: '\\b(' + KEYWORDS.built_in.split(' ').join('|') + ')\\b'
  };
  var STRING_REF = {
    className: 'string',
    begin: '"',
    end: '"',
    contains: [hljs.BACKSLASH_ESCAPE],
    relevance: 0
  };
  var FUNCTION_REF = {
    // className: "fn_ref",
    begin: hljs.UNDERSCORE_IDENT_RE + '\\s*\\(',
    returnBegin: true,
    keywords: KEYWORDS,
    relevance: 0,
    contains: [{
      beginKeywords: KEYWORDS.keyword
    }, BUILT_IN_REF, {
      // ambiguously named function calls get a relevance of 0
      className: 'built_in',
      begin: hljs.UNDERSCORE_IDENT_RE,
      relevance: 0
    }]
  };
  var FUNCTION_REF_PARAMS = {
    // className: "fn_ref_params",
    begin: /\(/,
    end: /\)/,
    relevance: 0,
    keywords: {
      built_in: KEYWORDS.built_in,
      literal: KEYWORDS.literal
    },
    contains: [hljs.C_NUMBER_MODE, hljs.C_BLOCK_COMMENT_MODE, AT_COMMENT_MODE, BUILT_IN_REF, FUNCTION_REF, STRING_REF, 'self']
  };
  FUNCTION_REF.contains.push(FUNCTION_REF_PARAMS);
  return {
    name: 'GAUSS',
    aliases: ['gss'],
    case_insensitive: true,
    // language is case-insensitive
    keywords: KEYWORDS,
    illegal: /(\{[%#]|[%#]\}| <- )/,
    contains: [hljs.C_NUMBER_MODE, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, AT_COMMENT_MODE, STRING_REF, PREPROCESSOR, {
      className: 'keyword',
      begin: /\bexternal (matrix|string|array|sparse matrix|struct|proc|keyword|fn)/
    }, DEFINITION('proc keyword', ';'), DEFINITION('fn', '='), {
      beginKeywords: 'for threadfor',
      end: /;/,
      // end: /\(/,
      relevance: 0,
      contains: [hljs.C_BLOCK_COMMENT_MODE, AT_COMMENT_MODE, FUNCTION_REF_PARAMS]
    }, {
      // custom method guard
      // excludes method names from keyword processing
      variants: [{
        begin: hljs.UNDERSCORE_IDENT_RE + '\\.' + hljs.UNDERSCORE_IDENT_RE
      }, {
        begin: hljs.UNDERSCORE_IDENT_RE + '\\s*='
      }],
      relevance: 0
    }, FUNCTION_REF, STRUCT_TYPE]
  };
}
module.exports = gauss;

/***/ }),

/***/ 2565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
/*
 Language: G-code (ISO 6983)
 Contributors: Adam Joseph Cook <adam.joseph.cook@gmail.com>
 Description: G-code syntax highlighter for Fanuc and other common CNC machine tool controls.
 Website: https://www.sis.se/api/document/preview/911952/
 */

function gcode(hljs) {
  var GCODE_IDENT_RE = '[A-Z_][A-Z0-9_.]*';
  var GCODE_CLOSE_RE = '%';
  var GCODE_KEYWORDS = {
    $pattern: GCODE_IDENT_RE,
    keyword: 'IF DO WHILE ENDWHILE CALL ENDIF SUB ENDSUB GOTO REPEAT ENDREPEAT ' + 'EQ LT GT NE GE LE OR XOR'
  };
  var GCODE_START = {
    className: 'meta',
    begin: '([O])([0-9]+)'
  };
  var NUMBER = hljs.inherit(hljs.C_NUMBER_MODE, {
    begin: '([-+]?((\\.\\d+)|(\\d+)(\\.\\d*)?))|' + hljs.C_NUMBER_RE
  });
  var GCODE_CODE = [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.COMMENT(/\(/, /\)/), NUMBER, hljs.inherit(hljs.APOS_STRING_MODE, {
    illegal: null
  }), hljs.inherit(hljs.QUOTE_STRING_MODE, {
    illegal: null
  }), {
    className: 'name',
    begin: '([G])([0-9]+\\.?[0-9]?)'
  }, {
    className: 'name',
    begin: '([M])([0-9]+\\.?[0-9]?)'
  }, {
    className: 'attr',
    begin: '(VC|VS|#)',
    end: '(\\d+)'
  }, {
    className: 'attr',
    begin: '(VZOFX|VZOFY|VZOFZ)'
  }, {
    className: 'built_in',
    begin: '(ATAN|ABS|ACOS|ASIN|SIN|COS|EXP|FIX|FUP|ROUND|LN|TAN)(\\[)',
    contains: [NUMBER],
    end: '\\]'
  }, {
    className: 'symbol',
    variants: [{
      begin: 'N',
      end: '\\d+',
      illegal: '\\W'
    }]
  }];
  return {
    name: 'G-code (ISO 6983)',
    aliases: ['nc'],
    // Some implementations (CNC controls) of G-code are interoperable with uppercase and lowercase letters seamlessly.
    // However, most prefer all uppercase and uppercase is customary.
    case_insensitive: true,
    keywords: GCODE_KEYWORDS,
    contains: [{
      className: 'meta',
      begin: GCODE_CLOSE_RE
    }, GCODE_START].concat(GCODE_CODE)
  };
}
module.exports = gcode;

/***/ }),

/***/ 67580:
/***/ ((module) => {

/*
 Language: Gherkin
 Author: Sam Pikesley (@pikesley) <sam.pikesley@theodi.org>
 Description: Gherkin is the format for cucumber specifications. It is a domain specific language which helps you to describe business behavior without the need to go into detail of implementation.
 Website: https://cucumber.io/docs/gherkin/
 */

function gherkin(hljs) {
  return {
    name: 'Gherkin',
    aliases: ['feature'],
    keywords: 'Feature Background Ability Business\ Need Scenario Scenarios Scenario\ Outline Scenario\ Template Examples Given And Then But When',
    contains: [{
      className: 'symbol',
      begin: '\\*',
      relevance: 0
    }, {
      className: 'meta',
      begin: '@[^@\\s]+'
    }, {
      begin: '\\|',
      end: '\\|\\w*$',
      contains: [{
        className: 'string',
        begin: '[^|]+'
      }]
    }, {
      className: 'variable',
      begin: '<',
      end: '>'
    }, hljs.HASH_COMMENT_MODE, {
      className: 'string',
      begin: '"""',
      end: '"""'
    }, hljs.QUOTE_STRING_MODE]
  };
}
module.exports = gherkin;

/***/ }),

/***/ 2212:
/***/ ((module) => {

/*
Language: GLSL
Description: OpenGL Shading Language
Author: Sergey Tikhomirov <sergey@tikhomirov.io>
Website: https://en.wikipedia.org/wiki/OpenGL_Shading_Language
Category: graphics
*/

function glsl(hljs) {
  return {
    name: 'GLSL',
    keywords: {
      keyword:
      // Statements
      'break continue discard do else for if return while switch case default ' +
      // Qualifiers
      'attribute binding buffer ccw centroid centroid varying coherent column_major const cw ' + 'depth_any depth_greater depth_less depth_unchanged early_fragment_tests equal_spacing ' + 'flat fractional_even_spacing fractional_odd_spacing highp in index inout invariant ' + 'invocations isolines layout line_strip lines lines_adjacency local_size_x local_size_y ' + 'local_size_z location lowp max_vertices mediump noperspective offset origin_upper_left ' + 'out packed patch pixel_center_integer point_mode points precise precision quads r11f_g11f_b10f ' + 'r16 r16_snorm r16f r16i r16ui r32f r32i r32ui r8 r8_snorm r8i r8ui readonly restrict ' + 'rg16 rg16_snorm rg16f rg16i rg16ui rg32f rg32i rg32ui rg8 rg8_snorm rg8i rg8ui rgb10_a2 ' + 'rgb10_a2ui rgba16 rgba16_snorm rgba16f rgba16i rgba16ui rgba32f rgba32i rgba32ui rgba8 ' + 'rgba8_snorm rgba8i rgba8ui row_major sample shared smooth std140 std430 stream triangle_strip ' + 'triangles triangles_adjacency uniform varying vertices volatile writeonly',
      type: 'atomic_uint bool bvec2 bvec3 bvec4 dmat2 dmat2x2 dmat2x3 dmat2x4 dmat3 dmat3x2 dmat3x3 ' + 'dmat3x4 dmat4 dmat4x2 dmat4x3 dmat4x4 double dvec2 dvec3 dvec4 float iimage1D iimage1DArray ' + 'iimage2D iimage2DArray iimage2DMS iimage2DMSArray iimage2DRect iimage3D iimageBuffer ' + 'iimageCube iimageCubeArray image1D image1DArray image2D image2DArray image2DMS image2DMSArray ' + 'image2DRect image3D imageBuffer imageCube imageCubeArray int isampler1D isampler1DArray ' + 'isampler2D isampler2DArray isampler2DMS isampler2DMSArray isampler2DRect isampler3D ' + 'isamplerBuffer isamplerCube isamplerCubeArray ivec2 ivec3 ivec4 mat2 mat2x2 mat2x3 ' + 'mat2x4 mat3 mat3x2 mat3x3 mat3x4 mat4 mat4x2 mat4x3 mat4x4 sampler1D sampler1DArray ' + 'sampler1DArrayShadow sampler1DShadow sampler2D sampler2DArray sampler2DArrayShadow ' + 'sampler2DMS sampler2DMSArray sampler2DRect sampler2DRectShadow sampler2DShadow sampler3D ' + 'samplerBuffer samplerCube samplerCubeArray samplerCubeArrayShadow samplerCubeShadow ' + 'image1D uimage1DArray uimage2D uimage2DArray uimage2DMS uimage2DMSArray uimage2DRect ' + 'uimage3D uimageBuffer uimageCube uimageCubeArray uint usampler1D usampler1DArray ' + 'usampler2D usampler2DArray usampler2DMS usampler2DMSArray usampler2DRect usampler3D ' + 'samplerBuffer usamplerCube usamplerCubeArray uvec2 uvec3 uvec4 vec2 vec3 vec4 void',
      built_in:
      // Constants
      'gl_MaxAtomicCounterBindings gl_MaxAtomicCounterBufferSize gl_MaxClipDistances gl_MaxClipPlanes ' + 'gl_MaxCombinedAtomicCounterBuffers gl_MaxCombinedAtomicCounters gl_MaxCombinedImageUniforms ' + 'gl_MaxCombinedImageUnitsAndFragmentOutputs gl_MaxCombinedTextureImageUnits gl_MaxComputeAtomicCounterBuffers ' + 'gl_MaxComputeAtomicCounters gl_MaxComputeImageUniforms gl_MaxComputeTextureImageUnits ' + 'gl_MaxComputeUniformComponents gl_MaxComputeWorkGroupCount gl_MaxComputeWorkGroupSize ' + 'gl_MaxDrawBuffers gl_MaxFragmentAtomicCounterBuffers gl_MaxFragmentAtomicCounters ' + 'gl_MaxFragmentImageUniforms gl_MaxFragmentInputComponents gl_MaxFragmentInputVectors ' + 'gl_MaxFragmentUniformComponents gl_MaxFragmentUniformVectors gl_MaxGeometryAtomicCounterBuffers ' + 'gl_MaxGeometryAtomicCounters gl_MaxGeometryImageUniforms gl_MaxGeometryInputComponents ' + 'gl_MaxGeometryOutputComponents gl_MaxGeometryOutputVertices gl_MaxGeometryTextureImageUnits ' + 'gl_MaxGeometryTotalOutputComponents gl_MaxGeometryUniformComponents gl_MaxGeometryVaryingComponents ' + 'gl_MaxImageSamples gl_MaxImageUnits gl_MaxLights gl_MaxPatchVertices gl_MaxProgramTexelOffset ' + 'gl_MaxTessControlAtomicCounterBuffers gl_MaxTessControlAtomicCounters gl_MaxTessControlImageUniforms ' + 'gl_MaxTessControlInputComponents gl_MaxTessControlOutputComponents gl_MaxTessControlTextureImageUnits ' + 'gl_MaxTessControlTotalOutputComponents gl_MaxTessControlUniformComponents ' + 'gl_MaxTessEvaluationAtomicCounterBuffers gl_MaxTessEvaluationAtomicCounters ' + 'gl_MaxTessEvaluationImageUniforms gl_MaxTessEvaluationInputComponents gl_MaxTessEvaluationOutputComponents ' + 'gl_MaxTessEvaluationTextureImageUnits gl_MaxTessEvaluationUniformComponents ' + 'gl_MaxTessGenLevel gl_MaxTessPatchComponents gl_MaxTextureCoords gl_MaxTextureImageUnits ' + 'gl_MaxTextureUnits gl_MaxVaryingComponents gl_MaxVaryingFloats gl_MaxVaryingVectors ' + 'gl_MaxVertexAtomicCounterBuffers gl_MaxVertexAtomicCounters gl_MaxVertexAttribs gl_MaxVertexImageUniforms ' + 'gl_MaxVertexOutputComponents gl_MaxVertexOutputVectors gl_MaxVertexTextureImageUnits ' + 'gl_MaxVertexUniformComponents gl_MaxVertexUniformVectors gl_MaxViewports gl_MinProgramTexelOffset ' +
      // Variables
      'gl_BackColor gl_BackLightModelProduct gl_BackLightProduct gl_BackMaterial ' + 'gl_BackSecondaryColor gl_ClipDistance gl_ClipPlane gl_ClipVertex gl_Color ' + 'gl_DepthRange gl_EyePlaneQ gl_EyePlaneR gl_EyePlaneS gl_EyePlaneT gl_Fog gl_FogCoord ' + 'gl_FogFragCoord gl_FragColor gl_FragCoord gl_FragData gl_FragDepth gl_FrontColor ' + 'gl_FrontFacing gl_FrontLightModelProduct gl_FrontLightProduct gl_FrontMaterial ' + 'gl_FrontSecondaryColor gl_GlobalInvocationID gl_InstanceID gl_InvocationID gl_Layer gl_LightModel ' + 'gl_LightSource gl_LocalInvocationID gl_LocalInvocationIndex gl_ModelViewMatrix ' + 'gl_ModelViewMatrixInverse gl_ModelViewMatrixInverseTranspose gl_ModelViewMatrixTranspose ' + 'gl_ModelViewProjectionMatrix gl_ModelViewProjectionMatrixInverse gl_ModelViewProjectionMatrixInverseTranspose ' + 'gl_ModelViewProjectionMatrixTranspose gl_MultiTexCoord0 gl_MultiTexCoord1 gl_MultiTexCoord2 ' + 'gl_MultiTexCoord3 gl_MultiTexCoord4 gl_MultiTexCoord5 gl_MultiTexCoord6 gl_MultiTexCoord7 ' + 'gl_Normal gl_NormalMatrix gl_NormalScale gl_NumSamples gl_NumWorkGroups gl_ObjectPlaneQ ' + 'gl_ObjectPlaneR gl_ObjectPlaneS gl_ObjectPlaneT gl_PatchVerticesIn gl_Point gl_PointCoord ' + 'gl_PointSize gl_Position gl_PrimitiveID gl_PrimitiveIDIn gl_ProjectionMatrix gl_ProjectionMatrixInverse ' + 'gl_ProjectionMatrixInverseTranspose gl_ProjectionMatrixTranspose gl_SampleID gl_SampleMask ' + 'gl_SampleMaskIn gl_SamplePosition gl_SecondaryColor gl_TessCoord gl_TessLevelInner gl_TessLevelOuter ' + 'gl_TexCoord gl_TextureEnvColor gl_TextureMatrix gl_TextureMatrixInverse gl_TextureMatrixInverseTranspose ' + 'gl_TextureMatrixTranspose gl_Vertex gl_VertexID gl_ViewportIndex gl_WorkGroupID gl_WorkGroupSize gl_in gl_out ' +
      // Functions
      'EmitStreamVertex EmitVertex EndPrimitive EndStreamPrimitive abs acos acosh all any asin ' + 'asinh atan atanh atomicAdd atomicAnd atomicCompSwap atomicCounter atomicCounterDecrement ' + 'atomicCounterIncrement atomicExchange atomicMax atomicMin atomicOr atomicXor barrier ' + 'bitCount bitfieldExtract bitfieldInsert bitfieldReverse ceil clamp cos cosh cross ' + 'dFdx dFdy degrees determinant distance dot equal exp exp2 faceforward findLSB findMSB ' + 'floatBitsToInt floatBitsToUint floor fma fract frexp ftransform fwidth greaterThan ' + 'greaterThanEqual groupMemoryBarrier imageAtomicAdd imageAtomicAnd imageAtomicCompSwap ' + 'imageAtomicExchange imageAtomicMax imageAtomicMin imageAtomicOr imageAtomicXor imageLoad ' + 'imageSize imageStore imulExtended intBitsToFloat interpolateAtCentroid interpolateAtOffset ' + 'interpolateAtSample inverse inversesqrt isinf isnan ldexp length lessThan lessThanEqual log ' + 'log2 matrixCompMult max memoryBarrier memoryBarrierAtomicCounter memoryBarrierBuffer ' + 'memoryBarrierImage memoryBarrierShared min mix mod modf noise1 noise2 noise3 noise4 ' + 'normalize not notEqual outerProduct packDouble2x32 packHalf2x16 packSnorm2x16 packSnorm4x8 ' + 'packUnorm2x16 packUnorm4x8 pow radians reflect refract round roundEven shadow1D shadow1DLod ' + 'shadow1DProj shadow1DProjLod shadow2D shadow2DLod shadow2DProj shadow2DProjLod sign sin sinh ' + 'smoothstep sqrt step tan tanh texelFetch texelFetchOffset texture texture1D texture1DLod ' + 'texture1DProj texture1DProjLod texture2D texture2DLod texture2DProj texture2DProjLod ' + 'texture3D texture3DLod texture3DProj texture3DProjLod textureCube textureCubeLod ' + 'textureGather textureGatherOffset textureGatherOffsets textureGrad textureGradOffset ' + 'textureLod textureLodOffset textureOffset textureProj textureProjGrad textureProjGradOffset ' + 'textureProjLod textureProjLodOffset textureProjOffset textureQueryLevels textureQueryLod ' + 'textureSize transpose trunc uaddCarry uintBitsToFloat umulExtended unpackDouble2x32 ' + 'unpackHalf2x16 unpackSnorm2x16 unpackSnorm4x8 unpackUnorm2x16 unpackUnorm4x8 usubBorrow',
      literal: 'true false'
    },
    illegal: '"',
    contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.C_NUMBER_MODE, {
      className: 'meta',
      begin: '#',
      end: '$'
    }]
  };
}
module.exports = glsl;

/***/ }),

/***/ 77964:
/***/ ((module) => {

/*
Language: GML
Author: Meseta <meseta@gmail.com>
Description: Game Maker Language for GameMaker Studio 2
Website: https://docs2.yoyogames.com
Category: scripting
*/

function gml(hljs) {
  var GML_KEYWORDS = {
    keyword: 'begin end if then else while do for break continue with until ' + 'repeat exit and or xor not return mod div switch case default var ' + 'globalvar enum function constructor delete #macro #region #endregion',
    built_in: 'is_real is_string is_array is_undefined is_int32 is_int64 is_ptr ' + 'is_vec3 is_vec4 is_matrix is_bool is_method is_struct is_infinity is_nan ' + 'is_numeric typeof variable_global_exists variable_global_get variable_global_set ' + 'variable_instance_exists variable_instance_get variable_instance_set ' + 'variable_instance_get_names variable_struct_exists variable_struct_get ' + 'variable_struct_get_names variable_struct_names_count variable_struct_remove ' + 'variable_struct_set array_delete array_insert array_length array_length_1d ' + 'array_length_2d array_height_2d array_equals array_create ' + 'array_copy array_pop array_push array_resize array_sort ' + 'random random_range irandom irandom_range random_set_seed random_get_seed ' + 'randomize randomise choose abs round floor ceil sign frac sqrt sqr ' + 'exp ln log2 log10 sin cos tan arcsin arccos arctan arctan2 dsin dcos ' + 'dtan darcsin darccos darctan darctan2 degtorad radtodeg power logn ' + 'min max mean median clamp lerp dot_product dot_product_3d ' + 'dot_product_normalised dot_product_3d_normalised ' + 'dot_product_normalized dot_product_3d_normalized math_set_epsilon ' + 'math_get_epsilon angle_difference point_distance_3d point_distance ' + 'point_direction lengthdir_x lengthdir_y real string int64 ptr ' + 'string_format chr ansi_char ord string_length string_byte_length ' + 'string_pos string_copy string_char_at string_ord_at string_byte_at ' + 'string_set_byte_at string_delete string_insert string_lower ' + 'string_upper string_repeat string_letters string_digits ' + 'string_lettersdigits string_replace string_replace_all string_count ' + 'string_hash_to_newline clipboard_has_text clipboard_set_text ' + 'clipboard_get_text date_current_datetime date_create_datetime ' + 'date_valid_datetime date_inc_year date_inc_month date_inc_week ' + 'date_inc_day date_inc_hour date_inc_minute date_inc_second ' + 'date_get_year date_get_month date_get_week date_get_day ' + 'date_get_hour date_get_minute date_get_second date_get_weekday ' + 'date_get_day_of_year date_get_hour_of_year date_get_minute_of_year ' + 'date_get_second_of_year date_year_span date_month_span ' + 'date_week_span date_day_span date_hour_span date_minute_span ' + 'date_second_span date_compare_datetime date_compare_date ' + 'date_compare_time date_date_of date_time_of date_datetime_string ' + 'date_date_string date_time_string date_days_in_month ' + 'date_days_in_year date_leap_year date_is_today date_set_timezone ' + 'date_get_timezone game_set_speed game_get_speed motion_set ' + 'motion_add place_free place_empty place_meeting place_snapped ' + 'move_random move_snap move_towards_point move_contact_solid ' + 'move_contact_all move_outside_solid move_outside_all ' + 'move_bounce_solid move_bounce_all move_wrap distance_to_point ' + 'distance_to_object position_empty position_meeting path_start ' + 'path_end mp_linear_step mp_potential_step mp_linear_step_object ' + 'mp_potential_step_object mp_potential_settings mp_linear_path ' + 'mp_potential_path mp_linear_path_object mp_potential_path_object ' + 'mp_grid_create mp_grid_destroy mp_grid_clear_all mp_grid_clear_cell ' + 'mp_grid_clear_rectangle mp_grid_add_cell mp_grid_get_cell ' + 'mp_grid_add_rectangle mp_grid_add_instances mp_grid_path ' + 'mp_grid_draw mp_grid_to_ds_grid collision_point collision_rectangle ' + 'collision_circle collision_ellipse collision_line ' + 'collision_point_list collision_rectangle_list collision_circle_list ' + 'collision_ellipse_list collision_line_list instance_position_list ' + 'instance_place_list point_in_rectangle ' + 'point_in_triangle point_in_circle rectangle_in_rectangle ' + 'rectangle_in_triangle rectangle_in_circle instance_find ' + 'instance_exists instance_number instance_position instance_nearest ' + 'instance_furthest instance_place instance_create_depth ' + 'instance_create_layer instance_copy instance_change instance_destroy ' + 'position_destroy position_change instance_id_get ' + 'instance_deactivate_all instance_deactivate_object ' + 'instance_deactivate_region instance_activate_all ' + 'instance_activate_object instance_activate_region room_goto ' + 'room_goto_previous room_goto_next room_previous room_next ' + 'room_restart game_end game_restart game_load game_save ' + 'game_save_buffer game_load_buffer event_perform event_user ' + 'event_perform_object event_inherited show_debug_message ' + 'show_debug_overlay debug_event debug_get_callstack alarm_get ' + 'alarm_set font_texture_page_size keyboard_set_map keyboard_get_map ' + 'keyboard_unset_map keyboard_check keyboard_check_pressed ' + 'keyboard_check_released keyboard_check_direct keyboard_get_numlock ' + 'keyboard_set_numlock keyboard_key_press keyboard_key_release ' + 'keyboard_clear io_clear mouse_check_button ' + 'mouse_check_button_pressed mouse_check_button_released ' + 'mouse_wheel_up mouse_wheel_down mouse_clear draw_self draw_sprite ' + 'draw_sprite_pos draw_sprite_ext draw_sprite_stretched ' + 'draw_sprite_stretched_ext draw_sprite_tiled draw_sprite_tiled_ext ' + 'draw_sprite_part draw_sprite_part_ext draw_sprite_general draw_clear ' + 'draw_clear_alpha draw_point draw_line draw_line_width draw_rectangle ' + 'draw_roundrect draw_roundrect_ext draw_triangle draw_circle ' + 'draw_ellipse draw_set_circle_precision draw_arrow draw_button ' + 'draw_path draw_healthbar draw_getpixel draw_getpixel_ext ' + 'draw_set_colour draw_set_color draw_set_alpha draw_get_colour ' + 'draw_get_color draw_get_alpha merge_colour make_colour_rgb ' + 'make_colour_hsv colour_get_red colour_get_green colour_get_blue ' + 'colour_get_hue colour_get_saturation colour_get_value merge_color ' + 'make_color_rgb make_color_hsv color_get_red color_get_green ' + 'color_get_blue color_get_hue color_get_saturation color_get_value ' + 'merge_color screen_save screen_save_part draw_set_font ' + 'draw_set_halign draw_set_valign draw_text draw_text_ext string_width ' + 'string_height string_width_ext string_height_ext ' + 'draw_text_transformed draw_text_ext_transformed draw_text_colour ' + 'draw_text_ext_colour draw_text_transformed_colour ' + 'draw_text_ext_transformed_colour draw_text_color draw_text_ext_color ' + 'draw_text_transformed_color draw_text_ext_transformed_color ' + 'draw_point_colour draw_line_colour draw_line_width_colour ' + 'draw_rectangle_colour draw_roundrect_colour ' + 'draw_roundrect_colour_ext draw_triangle_colour draw_circle_colour ' + 'draw_ellipse_colour draw_point_color draw_line_color ' + 'draw_line_width_color draw_rectangle_color draw_roundrect_color ' + 'draw_roundrect_color_ext draw_triangle_color draw_circle_color ' + 'draw_ellipse_color draw_primitive_begin draw_vertex ' + 'draw_vertex_colour draw_vertex_color draw_primitive_end ' + 'sprite_get_uvs font_get_uvs sprite_get_texture font_get_texture ' + 'texture_get_width texture_get_height texture_get_uvs ' + 'draw_primitive_begin_texture draw_vertex_texture ' + 'draw_vertex_texture_colour draw_vertex_texture_color ' + 'texture_global_scale surface_create surface_create_ext ' + 'surface_resize surface_free surface_exists surface_get_width ' + 'surface_get_height surface_get_texture surface_set_target ' + 'surface_set_target_ext surface_reset_target surface_depth_disable ' + 'surface_get_depth_disable draw_surface draw_surface_stretched ' + 'draw_surface_tiled draw_surface_part draw_surface_ext ' + 'draw_surface_stretched_ext draw_surface_tiled_ext ' + 'draw_surface_part_ext draw_surface_general surface_getpixel ' + 'surface_getpixel_ext surface_save surface_save_part surface_copy ' + 'surface_copy_part application_surface_draw_enable ' + 'application_get_position application_surface_enable ' + 'application_surface_is_enabled display_get_width display_get_height ' + 'display_get_orientation display_get_gui_width display_get_gui_height ' + 'display_reset display_mouse_get_x display_mouse_get_y ' + 'display_mouse_set display_set_ui_visibility ' + 'window_set_fullscreen window_get_fullscreen ' + 'window_set_caption window_set_min_width window_set_max_width ' + 'window_set_min_height window_set_max_height window_get_visible_rects ' + 'window_get_caption window_set_cursor window_get_cursor ' + 'window_set_colour window_get_colour window_set_color ' + 'window_get_color window_set_position window_set_size ' + 'window_set_rectangle window_center window_get_x window_get_y ' + 'window_get_width window_get_height window_mouse_get_x ' + 'window_mouse_get_y window_mouse_set window_view_mouse_get_x ' + 'window_view_mouse_get_y window_views_mouse_get_x ' + 'window_views_mouse_get_y audio_listener_position ' + 'audio_listener_velocity audio_listener_orientation ' + 'audio_emitter_position audio_emitter_create audio_emitter_free ' + 'audio_emitter_exists audio_emitter_pitch audio_emitter_velocity ' + 'audio_emitter_falloff audio_emitter_gain audio_play_sound ' + 'audio_play_sound_on audio_play_sound_at audio_stop_sound ' + 'audio_resume_music audio_music_is_playing audio_resume_sound ' + 'audio_pause_sound audio_pause_music audio_channel_num ' + 'audio_sound_length audio_get_type audio_falloff_set_model ' + 'audio_play_music audio_stop_music audio_master_gain audio_music_gain ' + 'audio_sound_gain audio_sound_pitch audio_stop_all audio_resume_all ' + 'audio_pause_all audio_is_playing audio_is_paused audio_exists ' + 'audio_sound_set_track_position audio_sound_get_track_position ' + 'audio_emitter_get_gain audio_emitter_get_pitch audio_emitter_get_x ' + 'audio_emitter_get_y audio_emitter_get_z audio_emitter_get_vx ' + 'audio_emitter_get_vy audio_emitter_get_vz ' + 'audio_listener_set_position audio_listener_set_velocity ' + 'audio_listener_set_orientation audio_listener_get_data ' + 'audio_set_master_gain audio_get_master_gain audio_sound_get_gain ' + 'audio_sound_get_pitch audio_get_name audio_sound_set_track_position ' + 'audio_sound_get_track_position audio_create_stream ' + 'audio_destroy_stream audio_create_sync_group ' + 'audio_destroy_sync_group audio_play_in_sync_group ' + 'audio_start_sync_group audio_stop_sync_group audio_pause_sync_group ' + 'audio_resume_sync_group audio_sync_group_get_track_pos ' + 'audio_sync_group_debug audio_sync_group_is_playing audio_debug ' + 'audio_group_load audio_group_unload audio_group_is_loaded ' + 'audio_group_load_progress audio_group_name audio_group_stop_all ' + 'audio_group_set_gain audio_create_buffer_sound ' + 'audio_free_buffer_sound audio_create_play_queue ' + 'audio_free_play_queue audio_queue_sound audio_get_recorder_count ' + 'audio_get_recorder_info audio_start_recording audio_stop_recording ' + 'audio_sound_get_listener_mask audio_emitter_get_listener_mask ' + 'audio_get_listener_mask audio_sound_set_listener_mask ' + 'audio_emitter_set_listener_mask audio_set_listener_mask ' + 'audio_get_listener_count audio_get_listener_info audio_system ' + 'show_message show_message_async clickable_add clickable_add_ext ' + 'clickable_change clickable_change_ext clickable_delete ' + 'clickable_exists clickable_set_style show_question ' + 'show_question_async get_integer get_string get_integer_async ' + 'get_string_async get_login_async get_open_filename get_save_filename ' + 'get_open_filename_ext get_save_filename_ext show_error ' + 'highscore_clear highscore_add highscore_value highscore_name ' + 'draw_highscore sprite_exists sprite_get_name sprite_get_number ' + 'sprite_get_width sprite_get_height sprite_get_xoffset ' + 'sprite_get_yoffset sprite_get_bbox_left sprite_get_bbox_right ' + 'sprite_get_bbox_top sprite_get_bbox_bottom sprite_save ' + 'sprite_save_strip sprite_set_cache_size sprite_set_cache_size_ext ' + 'sprite_get_tpe sprite_prefetch sprite_prefetch_multi sprite_flush ' + 'sprite_flush_multi sprite_set_speed sprite_get_speed_type ' + 'sprite_get_speed font_exists font_get_name font_get_fontname ' + 'font_get_bold font_get_italic font_get_first font_get_last ' + 'font_get_size font_set_cache_size path_exists path_get_name ' + 'path_get_length path_get_time path_get_kind path_get_closed ' + 'path_get_precision path_get_number path_get_point_x path_get_point_y ' + 'path_get_point_speed path_get_x path_get_y path_get_speed ' + 'script_exists script_get_name timeline_add timeline_delete ' + 'timeline_clear timeline_exists timeline_get_name ' + 'timeline_moment_clear timeline_moment_add_script timeline_size ' + 'timeline_max_moment object_exists object_get_name object_get_sprite ' + 'object_get_solid object_get_visible object_get_persistent ' + 'object_get_mask object_get_parent object_get_physics ' + 'object_is_ancestor room_exists room_get_name sprite_set_offset ' + 'sprite_duplicate sprite_assign sprite_merge sprite_add ' + 'sprite_replace sprite_create_from_surface sprite_add_from_surface ' + 'sprite_delete sprite_set_alpha_from_sprite sprite_collision_mask ' + 'font_add_enable_aa font_add_get_enable_aa font_add font_add_sprite ' + 'font_add_sprite_ext font_replace font_replace_sprite ' + 'font_replace_sprite_ext font_delete path_set_kind path_set_closed ' + 'path_set_precision path_add path_assign path_duplicate path_append ' + 'path_delete path_add_point path_insert_point path_change_point ' + 'path_delete_point path_clear_points path_reverse path_mirror ' + 'path_flip path_rotate path_rescale path_shift script_execute ' + 'object_set_sprite object_set_solid object_set_visible ' + 'object_set_persistent object_set_mask room_set_width room_set_height ' + 'room_set_persistent room_set_background_colour ' + 'room_set_background_color room_set_view room_set_viewport ' + 'room_get_viewport room_set_view_enabled room_add room_duplicate ' + 'room_assign room_instance_add room_instance_clear room_get_camera ' + 'room_set_camera asset_get_index asset_get_type ' + 'file_text_open_from_string file_text_open_read file_text_open_write ' + 'file_text_open_append file_text_close file_text_write_string ' + 'file_text_write_real file_text_writeln file_text_read_string ' + 'file_text_read_real file_text_readln file_text_eof file_text_eoln ' + 'file_exists file_delete file_rename file_copy directory_exists ' + 'directory_create directory_destroy file_find_first file_find_next ' + 'file_find_close file_attributes filename_name filename_path ' + 'filename_dir filename_drive filename_ext filename_change_ext ' + 'file_bin_open file_bin_rewrite file_bin_close file_bin_position ' + 'file_bin_size file_bin_seek file_bin_write_byte file_bin_read_byte ' + 'parameter_count parameter_string environment_get_variable ' + 'ini_open_from_string ini_open ini_close ini_read_string ' + 'ini_read_real ini_write_string ini_write_real ini_key_exists ' + 'ini_section_exists ini_key_delete ini_section_delete ' + 'ds_set_precision ds_exists ds_stack_create ds_stack_destroy ' + 'ds_stack_clear ds_stack_copy ds_stack_size ds_stack_empty ' + 'ds_stack_push ds_stack_pop ds_stack_top ds_stack_write ds_stack_read ' + 'ds_queue_create ds_queue_destroy ds_queue_clear ds_queue_copy ' + 'ds_queue_size ds_queue_empty ds_queue_enqueue ds_queue_dequeue ' + 'ds_queue_head ds_queue_tail ds_queue_write ds_queue_read ' + 'ds_list_create ds_list_destroy ds_list_clear ds_list_copy ' + 'ds_list_size ds_list_empty ds_list_add ds_list_insert ' + 'ds_list_replace ds_list_delete ds_list_find_index ds_list_find_value ' + 'ds_list_mark_as_list ds_list_mark_as_map ds_list_sort ' + 'ds_list_shuffle ds_list_write ds_list_read ds_list_set ds_map_create ' + 'ds_map_destroy ds_map_clear ds_map_copy ds_map_size ds_map_empty ' + 'ds_map_add ds_map_add_list ds_map_add_map ds_map_replace ' + 'ds_map_replace_map ds_map_replace_list ds_map_delete ds_map_exists ' + 'ds_map_find_value ds_map_find_previous ds_map_find_next ' + 'ds_map_find_first ds_map_find_last ds_map_write ds_map_read ' + 'ds_map_secure_save ds_map_secure_load ds_map_secure_load_buffer ' + 'ds_map_secure_save_buffer ds_map_set ds_priority_create ' + 'ds_priority_destroy ds_priority_clear ds_priority_copy ' + 'ds_priority_size ds_priority_empty ds_priority_add ' + 'ds_priority_change_priority ds_priority_find_priority ' + 'ds_priority_delete_value ds_priority_delete_min ds_priority_find_min ' + 'ds_priority_delete_max ds_priority_find_max ds_priority_write ' + 'ds_priority_read ds_grid_create ds_grid_destroy ds_grid_copy ' + 'ds_grid_resize ds_grid_width ds_grid_height ds_grid_clear ' + 'ds_grid_set ds_grid_add ds_grid_multiply ds_grid_set_region ' + 'ds_grid_add_region ds_grid_multiply_region ds_grid_set_disk ' + 'ds_grid_add_disk ds_grid_multiply_disk ds_grid_set_grid_region ' + 'ds_grid_add_grid_region ds_grid_multiply_grid_region ds_grid_get ' + 'ds_grid_get_sum ds_grid_get_max ds_grid_get_min ds_grid_get_mean ' + 'ds_grid_get_disk_sum ds_grid_get_disk_min ds_grid_get_disk_max ' + 'ds_grid_get_disk_mean ds_grid_value_exists ds_grid_value_x ' + 'ds_grid_value_y ds_grid_value_disk_exists ds_grid_value_disk_x ' + 'ds_grid_value_disk_y ds_grid_shuffle ds_grid_write ds_grid_read ' + 'ds_grid_sort ds_grid_set ds_grid_get effect_create_below ' + 'effect_create_above effect_clear part_type_create part_type_destroy ' + 'part_type_exists part_type_clear part_type_shape part_type_sprite ' + 'part_type_size part_type_scale part_type_orientation part_type_life ' + 'part_type_step part_type_death part_type_speed part_type_direction ' + 'part_type_gravity part_type_colour1 part_type_colour2 ' + 'part_type_colour3 part_type_colour_mix part_type_colour_rgb ' + 'part_type_colour_hsv part_type_color1 part_type_color2 ' + 'part_type_color3 part_type_color_mix part_type_color_rgb ' + 'part_type_color_hsv part_type_alpha1 part_type_alpha2 ' + 'part_type_alpha3 part_type_blend part_system_create ' + 'part_system_create_layer part_system_destroy part_system_exists ' + 'part_system_clear part_system_draw_order part_system_depth ' + 'part_system_position part_system_automatic_update ' + 'part_system_automatic_draw part_system_update part_system_drawit ' + 'part_system_get_layer part_system_layer part_particles_create ' + 'part_particles_create_colour part_particles_create_color ' + 'part_particles_clear part_particles_count part_emitter_create ' + 'part_emitter_destroy part_emitter_destroy_all part_emitter_exists ' + 'part_emitter_clear part_emitter_region part_emitter_burst ' + 'part_emitter_stream external_call external_define external_free ' + 'window_handle window_device matrix_get matrix_set ' + 'matrix_build_identity matrix_build matrix_build_lookat ' + 'matrix_build_projection_ortho matrix_build_projection_perspective ' + 'matrix_build_projection_perspective_fov matrix_multiply ' + 'matrix_transform_vertex matrix_stack_push matrix_stack_pop ' + 'matrix_stack_multiply matrix_stack_set matrix_stack_clear ' + 'matrix_stack_top matrix_stack_is_empty browser_input_capture ' + 'os_get_config os_get_info os_get_language os_get_region ' + 'os_lock_orientation display_get_dpi_x display_get_dpi_y ' + 'display_set_gui_size display_set_gui_maximise ' + 'display_set_gui_maximize device_mouse_dbclick_enable ' + 'display_set_timing_method display_get_timing_method ' + 'display_set_sleep_margin display_get_sleep_margin virtual_key_add ' + 'virtual_key_hide virtual_key_delete virtual_key_show ' + 'draw_enable_drawevent draw_enable_swf_aa draw_set_swf_aa_level ' + 'draw_get_swf_aa_level draw_texture_flush draw_flush ' + 'gpu_set_blendenable gpu_set_ztestenable gpu_set_zfunc ' + 'gpu_set_zwriteenable gpu_set_lightingenable gpu_set_fog ' + 'gpu_set_cullmode gpu_set_blendmode gpu_set_blendmode_ext ' + 'gpu_set_blendmode_ext_sepalpha gpu_set_colorwriteenable ' + 'gpu_set_colourwriteenable gpu_set_alphatestenable ' + 'gpu_set_alphatestref gpu_set_alphatestfunc gpu_set_texfilter ' + 'gpu_set_texfilter_ext gpu_set_texrepeat gpu_set_texrepeat_ext ' + 'gpu_set_tex_filter gpu_set_tex_filter_ext gpu_set_tex_repeat ' + 'gpu_set_tex_repeat_ext gpu_set_tex_mip_filter ' + 'gpu_set_tex_mip_filter_ext gpu_set_tex_mip_bias ' + 'gpu_set_tex_mip_bias_ext gpu_set_tex_min_mip gpu_set_tex_min_mip_ext ' + 'gpu_set_tex_max_mip gpu_set_tex_max_mip_ext gpu_set_tex_max_aniso ' + 'gpu_set_tex_max_aniso_ext gpu_set_tex_mip_enable ' + 'gpu_set_tex_mip_enable_ext gpu_get_blendenable gpu_get_ztestenable ' + 'gpu_get_zfunc gpu_get_zwriteenable gpu_get_lightingenable ' + 'gpu_get_fog gpu_get_cullmode gpu_get_blendmode gpu_get_blendmode_ext ' + 'gpu_get_blendmode_ext_sepalpha gpu_get_blendmode_src ' + 'gpu_get_blendmode_dest gpu_get_blendmode_srcalpha ' + 'gpu_get_blendmode_destalpha gpu_get_colorwriteenable ' + 'gpu_get_colourwriteenable gpu_get_alphatestenable ' + 'gpu_get_alphatestref gpu_get_alphatestfunc gpu_get_texfilter ' + 'gpu_get_texfilter_ext gpu_get_texrepeat gpu_get_texrepeat_ext ' + 'gpu_get_tex_filter gpu_get_tex_filter_ext gpu_get_tex_repeat ' + 'gpu_get_tex_repeat_ext gpu_get_tex_mip_filter ' + 'gpu_get_tex_mip_filter_ext gpu_get_tex_mip_bias ' + 'gpu_get_tex_mip_bias_ext gpu_get_tex_min_mip gpu_get_tex_min_mip_ext ' + 'gpu_get_tex_max_mip gpu_get_tex_max_mip_ext gpu_get_tex_max_aniso ' + 'gpu_get_tex_max_aniso_ext gpu_get_tex_mip_enable ' + 'gpu_get_tex_mip_enable_ext gpu_push_state gpu_pop_state ' + 'gpu_get_state gpu_set_state draw_light_define_ambient ' + 'draw_light_define_direction draw_light_define_point ' + 'draw_light_enable draw_set_lighting draw_light_get_ambient ' + 'draw_light_get draw_get_lighting shop_leave_rating url_get_domain ' + 'url_open url_open_ext url_open_full get_timer achievement_login ' + 'achievement_logout achievement_post achievement_increment ' + 'achievement_post_score achievement_available ' + 'achievement_show_achievements achievement_show_leaderboards ' + 'achievement_load_friends achievement_load_leaderboard ' + 'achievement_send_challenge achievement_load_progress ' + 'achievement_reset achievement_login_status achievement_get_pic ' + 'achievement_show_challenge_notifications achievement_get_challenges ' + 'achievement_event achievement_show achievement_get_info ' + 'cloud_file_save cloud_string_save cloud_synchronise ads_enable ' + 'ads_disable ads_setup ads_engagement_launch ads_engagement_available ' + 'ads_engagement_active ads_event ads_event_preload ' + 'ads_set_reward_callback ads_get_display_height ads_get_display_width ' + 'ads_move ads_interstitial_available ads_interstitial_display ' + 'device_get_tilt_x device_get_tilt_y device_get_tilt_z ' + 'device_is_keypad_open device_mouse_check_button ' + 'device_mouse_check_button_pressed device_mouse_check_button_released ' + 'device_mouse_x device_mouse_y device_mouse_raw_x device_mouse_raw_y ' + 'device_mouse_x_to_gui device_mouse_y_to_gui iap_activate iap_status ' + 'iap_enumerate_products iap_restore_all iap_acquire iap_consume ' + 'iap_product_details iap_purchase_details facebook_init ' + 'facebook_login facebook_status facebook_graph_request ' + 'facebook_dialog facebook_logout facebook_launch_offerwall ' + 'facebook_post_message facebook_send_invite facebook_user_id ' + 'facebook_accesstoken facebook_check_permission ' + 'facebook_request_read_permissions ' + 'facebook_request_publish_permissions gamepad_is_supported ' + 'gamepad_get_device_count gamepad_is_connected ' + 'gamepad_get_description gamepad_get_button_threshold ' + 'gamepad_set_button_threshold gamepad_get_axis_deadzone ' + 'gamepad_set_axis_deadzone gamepad_button_count gamepad_button_check ' + 'gamepad_button_check_pressed gamepad_button_check_released ' + 'gamepad_button_value gamepad_axis_count gamepad_axis_value ' + 'gamepad_set_vibration gamepad_set_colour gamepad_set_color ' + 'os_is_paused window_has_focus code_is_compiled http_get ' + 'http_get_file http_post_string http_request json_encode json_decode ' + 'zip_unzip load_csv base64_encode base64_decode md5_string_unicode ' + 'md5_string_utf8 md5_file os_is_network_connected sha1_string_unicode ' + 'sha1_string_utf8 sha1_file os_powersave_enable analytics_event ' + 'analytics_event_ext win8_livetile_tile_notification ' + 'win8_livetile_tile_clear win8_livetile_badge_notification ' + 'win8_livetile_badge_clear win8_livetile_queue_enable ' + 'win8_secondarytile_pin win8_secondarytile_badge_notification ' + 'win8_secondarytile_delete win8_livetile_notification_begin ' + 'win8_livetile_notification_secondary_begin ' + 'win8_livetile_notification_expiry win8_livetile_notification_tag ' + 'win8_livetile_notification_text_add ' + 'win8_livetile_notification_image_add win8_livetile_notification_end ' + 'win8_appbar_enable win8_appbar_add_element ' + 'win8_appbar_remove_element win8_settingscharm_add_entry ' + 'win8_settingscharm_add_html_entry win8_settingscharm_add_xaml_entry ' + 'win8_settingscharm_set_xaml_property ' + 'win8_settingscharm_get_xaml_property win8_settingscharm_remove_entry ' + 'win8_share_image win8_share_screenshot win8_share_file ' + 'win8_share_url win8_share_text win8_search_enable ' + 'win8_search_disable win8_search_add_suggestions ' + 'win8_device_touchscreen_available win8_license_initialize_sandbox ' + 'win8_license_trial_version winphone_license_trial_version ' + 'winphone_tile_title winphone_tile_count winphone_tile_back_title ' + 'winphone_tile_back_content winphone_tile_back_content_wide ' + 'winphone_tile_front_image winphone_tile_front_image_small ' + 'winphone_tile_front_image_wide winphone_tile_back_image ' + 'winphone_tile_back_image_wide winphone_tile_background_colour ' + 'winphone_tile_background_color winphone_tile_icon_image ' + 'winphone_tile_small_icon_image winphone_tile_wide_content ' + 'winphone_tile_cycle_images winphone_tile_small_background_image ' + 'physics_world_create physics_world_gravity ' + 'physics_world_update_speed physics_world_update_iterations ' + 'physics_world_draw_debug physics_pause_enable physics_fixture_create ' + 'physics_fixture_set_kinematic physics_fixture_set_density ' + 'physics_fixture_set_awake physics_fixture_set_restitution ' + 'physics_fixture_set_friction physics_fixture_set_collision_group ' + 'physics_fixture_set_sensor physics_fixture_set_linear_damping ' + 'physics_fixture_set_angular_damping physics_fixture_set_circle_shape ' + 'physics_fixture_set_box_shape physics_fixture_set_edge_shape ' + 'physics_fixture_set_polygon_shape physics_fixture_set_chain_shape ' + 'physics_fixture_add_point physics_fixture_bind ' + 'physics_fixture_bind_ext physics_fixture_delete physics_apply_force ' + 'physics_apply_impulse physics_apply_angular_impulse ' + 'physics_apply_local_force physics_apply_local_impulse ' + 'physics_apply_torque physics_mass_properties physics_draw_debug ' + 'physics_test_overlap physics_remove_fixture physics_set_friction ' + 'physics_set_density physics_set_restitution physics_get_friction ' + 'physics_get_density physics_get_restitution ' + 'physics_joint_distance_create physics_joint_rope_create ' + 'physics_joint_revolute_create physics_joint_prismatic_create ' + 'physics_joint_pulley_create physics_joint_wheel_create ' + 'physics_joint_weld_create physics_joint_friction_create ' + 'physics_joint_gear_create physics_joint_enable_motor ' + 'physics_joint_get_value physics_joint_set_value physics_joint_delete ' + 'physics_particle_create physics_particle_delete ' + 'physics_particle_delete_region_circle ' + 'physics_particle_delete_region_box ' + 'physics_particle_delete_region_poly physics_particle_set_flags ' + 'physics_particle_set_category_flags physics_particle_draw ' + 'physics_particle_draw_ext physics_particle_count ' + 'physics_particle_get_data physics_particle_get_data_particle ' + 'physics_particle_group_begin physics_particle_group_circle ' + 'physics_particle_group_box physics_particle_group_polygon ' + 'physics_particle_group_add_point physics_particle_group_end ' + 'physics_particle_group_join physics_particle_group_delete ' + 'physics_particle_group_count physics_particle_group_get_data ' + 'physics_particle_group_get_mass physics_particle_group_get_inertia ' + 'physics_particle_group_get_centre_x ' + 'physics_particle_group_get_centre_y physics_particle_group_get_vel_x ' + 'physics_particle_group_get_vel_y physics_particle_group_get_ang_vel ' + 'physics_particle_group_get_x physics_particle_group_get_y ' + 'physics_particle_group_get_angle physics_particle_set_group_flags ' + 'physics_particle_get_group_flags physics_particle_get_max_count ' + 'physics_particle_get_radius physics_particle_get_density ' + 'physics_particle_get_damping physics_particle_get_gravity_scale ' + 'physics_particle_set_max_count physics_particle_set_radius ' + 'physics_particle_set_density physics_particle_set_damping ' + 'physics_particle_set_gravity_scale network_create_socket ' + 'network_create_socket_ext network_create_server ' + 'network_create_server_raw network_connect network_connect_raw ' + 'network_send_packet network_send_raw network_send_broadcast ' + 'network_send_udp network_send_udp_raw network_set_timeout ' + 'network_set_config network_resolve network_destroy buffer_create ' + 'buffer_write buffer_read buffer_seek buffer_get_surface ' + 'buffer_set_surface buffer_delete buffer_exists buffer_get_type ' + 'buffer_get_alignment buffer_poke buffer_peek buffer_save ' + 'buffer_save_ext buffer_load buffer_load_ext buffer_load_partial ' + 'buffer_copy buffer_fill buffer_get_size buffer_tell buffer_resize ' + 'buffer_md5 buffer_sha1 buffer_base64_encode buffer_base64_decode ' + 'buffer_base64_decode_ext buffer_sizeof buffer_get_address ' + 'buffer_create_from_vertex_buffer ' + 'buffer_create_from_vertex_buffer_ext buffer_copy_from_vertex_buffer ' + 'buffer_async_group_begin buffer_async_group_option ' + 'buffer_async_group_end buffer_load_async buffer_save_async ' + 'gml_release_mode gml_pragma steam_activate_overlay ' + 'steam_is_overlay_enabled steam_is_overlay_activated ' + 'steam_get_persona_name steam_initialised ' + 'steam_is_cloud_enabled_for_app steam_is_cloud_enabled_for_account ' + 'steam_file_persisted steam_get_quota_total steam_get_quota_free ' + 'steam_file_write steam_file_write_file steam_file_read ' + 'steam_file_delete steam_file_exists steam_file_size steam_file_share ' + 'steam_is_screenshot_requested steam_send_screenshot ' + 'steam_is_user_logged_on steam_get_user_steam_id steam_user_owns_dlc ' + 'steam_user_installed_dlc steam_set_achievement steam_get_achievement ' + 'steam_clear_achievement steam_set_stat_int steam_set_stat_float ' + 'steam_set_stat_avg_rate steam_get_stat_int steam_get_stat_float ' + 'steam_get_stat_avg_rate steam_reset_all_stats ' + 'steam_reset_all_stats_achievements steam_stats_ready ' + 'steam_create_leaderboard steam_upload_score steam_upload_score_ext ' + 'steam_download_scores_around_user steam_download_scores ' + 'steam_download_friends_scores steam_upload_score_buffer ' + 'steam_upload_score_buffer_ext steam_current_game_language ' + 'steam_available_languages steam_activate_overlay_browser ' + 'steam_activate_overlay_user steam_activate_overlay_store ' + 'steam_get_user_persona_name steam_get_app_id ' + 'steam_get_user_account_id steam_ugc_download steam_ugc_create_item ' + 'steam_ugc_start_item_update steam_ugc_set_item_title ' + 'steam_ugc_set_item_description steam_ugc_set_item_visibility ' + 'steam_ugc_set_item_tags steam_ugc_set_item_content ' + 'steam_ugc_set_item_preview steam_ugc_submit_item_update ' + 'steam_ugc_get_item_update_progress steam_ugc_subscribe_item ' + 'steam_ugc_unsubscribe_item steam_ugc_num_subscribed_items ' + 'steam_ugc_get_subscribed_items steam_ugc_get_item_install_info ' + 'steam_ugc_get_item_update_info steam_ugc_request_item_details ' + 'steam_ugc_create_query_user steam_ugc_create_query_user_ex ' + 'steam_ugc_create_query_all steam_ugc_create_query_all_ex ' + 'steam_ugc_query_set_cloud_filename_filter ' + 'steam_ugc_query_set_match_any_tag steam_ugc_query_set_search_text ' + 'steam_ugc_query_set_ranked_by_trend_days ' + 'steam_ugc_query_add_required_tag steam_ugc_query_add_excluded_tag ' + 'steam_ugc_query_set_return_long_description ' + 'steam_ugc_query_set_return_total_only ' + 'steam_ugc_query_set_allow_cached_response steam_ugc_send_query ' + 'shader_set shader_get_name shader_reset shader_current ' + 'shader_is_compiled shader_get_sampler_index shader_get_uniform ' + 'shader_set_uniform_i shader_set_uniform_i_array shader_set_uniform_f ' + 'shader_set_uniform_f_array shader_set_uniform_matrix ' + 'shader_set_uniform_matrix_array shader_enable_corner_id ' + 'texture_set_stage texture_get_texel_width texture_get_texel_height ' + 'shaders_are_supported vertex_format_begin vertex_format_end ' + 'vertex_format_delete vertex_format_add_position ' + 'vertex_format_add_position_3d vertex_format_add_colour ' + 'vertex_format_add_color vertex_format_add_normal ' + 'vertex_format_add_texcoord vertex_format_add_textcoord ' + 'vertex_format_add_custom vertex_create_buffer ' + 'vertex_create_buffer_ext vertex_delete_buffer vertex_begin ' + 'vertex_end vertex_position vertex_position_3d vertex_colour ' + 'vertex_color vertex_argb vertex_texcoord vertex_normal vertex_float1 ' + 'vertex_float2 vertex_float3 vertex_float4 vertex_ubyte4 ' + 'vertex_submit vertex_freeze vertex_get_number vertex_get_buffer_size ' + 'vertex_create_buffer_from_buffer ' + 'vertex_create_buffer_from_buffer_ext push_local_notification ' + 'push_get_first_local_notification push_get_next_local_notification ' + 'push_cancel_local_notification skeleton_animation_set ' + 'skeleton_animation_get skeleton_animation_mix ' + 'skeleton_animation_set_ext skeleton_animation_get_ext ' + 'skeleton_animation_get_duration skeleton_animation_get_frames ' + 'skeleton_animation_clear skeleton_skin_set skeleton_skin_get ' + 'skeleton_attachment_set skeleton_attachment_get ' + 'skeleton_attachment_create skeleton_collision_draw_set ' + 'skeleton_bone_data_get skeleton_bone_data_set ' + 'skeleton_bone_state_get skeleton_bone_state_set skeleton_get_minmax ' + 'skeleton_get_num_bounds skeleton_get_bounds ' + 'skeleton_animation_get_frame skeleton_animation_set_frame ' + 'draw_skeleton draw_skeleton_time draw_skeleton_instance ' + 'draw_skeleton_collision skeleton_animation_list skeleton_skin_list ' + 'skeleton_slot_data layer_get_id layer_get_id_at_depth ' + 'layer_get_depth layer_create layer_destroy layer_destroy_instances ' + 'layer_add_instance layer_has_instance layer_set_visible ' + 'layer_get_visible layer_exists layer_x layer_y layer_get_x ' + 'layer_get_y layer_hspeed layer_vspeed layer_get_hspeed ' + 'layer_get_vspeed layer_script_begin layer_script_end layer_shader ' + 'layer_get_script_begin layer_get_script_end layer_get_shader ' + 'layer_set_target_room layer_get_target_room layer_reset_target_room ' + 'layer_get_all layer_get_all_elements layer_get_name layer_depth ' + 'layer_get_element_layer layer_get_element_type layer_element_move ' + 'layer_force_draw_depth layer_is_draw_depth_forced ' + 'layer_get_forced_depth layer_background_get_id ' + 'layer_background_exists layer_background_create ' + 'layer_background_destroy layer_background_visible ' + 'layer_background_change layer_background_sprite ' + 'layer_background_htiled layer_background_vtiled ' + 'layer_background_stretch layer_background_yscale ' + 'layer_background_xscale layer_background_blend ' + 'layer_background_alpha layer_background_index layer_background_speed ' + 'layer_background_get_visible layer_background_get_sprite ' + 'layer_background_get_htiled layer_background_get_vtiled ' + 'layer_background_get_stretch layer_background_get_yscale ' + 'layer_background_get_xscale layer_background_get_blend ' + 'layer_background_get_alpha layer_background_get_index ' + 'layer_background_get_speed layer_sprite_get_id layer_sprite_exists ' + 'layer_sprite_create layer_sprite_destroy layer_sprite_change ' + 'layer_sprite_index layer_sprite_speed layer_sprite_xscale ' + 'layer_sprite_yscale layer_sprite_angle layer_sprite_blend ' + 'layer_sprite_alpha layer_sprite_x layer_sprite_y ' + 'layer_sprite_get_sprite layer_sprite_get_index ' + 'layer_sprite_get_speed layer_sprite_get_xscale ' + 'layer_sprite_get_yscale layer_sprite_get_angle ' + 'layer_sprite_get_blend layer_sprite_get_alpha layer_sprite_get_x ' + 'layer_sprite_get_y layer_tilemap_get_id layer_tilemap_exists ' + 'layer_tilemap_create layer_tilemap_destroy tilemap_tileset tilemap_x ' + 'tilemap_y tilemap_set tilemap_set_at_pixel tilemap_get_tileset ' + 'tilemap_get_tile_width tilemap_get_tile_height tilemap_get_width ' + 'tilemap_get_height tilemap_get_x tilemap_get_y tilemap_get ' + 'tilemap_get_at_pixel tilemap_get_cell_x_at_pixel ' + 'tilemap_get_cell_y_at_pixel tilemap_clear draw_tilemap draw_tile ' + 'tilemap_set_global_mask tilemap_get_global_mask tilemap_set_mask ' + 'tilemap_get_mask tilemap_get_frame tile_set_empty tile_set_index ' + 'tile_set_flip tile_set_mirror tile_set_rotate tile_get_empty ' + 'tile_get_index tile_get_flip tile_get_mirror tile_get_rotate ' + 'layer_tile_exists layer_tile_create layer_tile_destroy ' + 'layer_tile_change layer_tile_xscale layer_tile_yscale ' + 'layer_tile_blend layer_tile_alpha layer_tile_x layer_tile_y ' + 'layer_tile_region layer_tile_visible layer_tile_get_sprite ' + 'layer_tile_get_xscale layer_tile_get_yscale layer_tile_get_blend ' + 'layer_tile_get_alpha layer_tile_get_x layer_tile_get_y ' + 'layer_tile_get_region layer_tile_get_visible ' + 'layer_instance_get_instance instance_activate_layer ' + 'instance_deactivate_layer camera_create camera_create_view ' + 'camera_destroy camera_apply camera_get_active camera_get_default ' + 'camera_set_default camera_set_view_mat camera_set_proj_mat ' + 'camera_set_update_script camera_set_begin_script ' + 'camera_set_end_script camera_set_view_pos camera_set_view_size ' + 'camera_set_view_speed camera_set_view_border camera_set_view_angle ' + 'camera_set_view_target camera_get_view_mat camera_get_proj_mat ' + 'camera_get_update_script camera_get_begin_script ' + 'camera_get_end_script camera_get_view_x camera_get_view_y ' + 'camera_get_view_width camera_get_view_height camera_get_view_speed_x ' + 'camera_get_view_speed_y camera_get_view_border_x ' + 'camera_get_view_border_y camera_get_view_angle ' + 'camera_get_view_target view_get_camera view_get_visible ' + 'view_get_xport view_get_yport view_get_wport view_get_hport ' + 'view_get_surface_id view_set_camera view_set_visible view_set_xport ' + 'view_set_yport view_set_wport view_set_hport view_set_surface_id ' + 'gesture_drag_time gesture_drag_distance gesture_flick_speed ' + 'gesture_double_tap_time gesture_double_tap_distance ' + 'gesture_pinch_distance gesture_pinch_angle_towards ' + 'gesture_pinch_angle_away gesture_rotate_time gesture_rotate_angle ' + 'gesture_tap_count gesture_get_drag_time gesture_get_drag_distance ' + 'gesture_get_flick_speed gesture_get_double_tap_time ' + 'gesture_get_double_tap_distance gesture_get_pinch_distance ' + 'gesture_get_pinch_angle_towards gesture_get_pinch_angle_away ' + 'gesture_get_rotate_time gesture_get_rotate_angle ' + 'gesture_get_tap_count keyboard_virtual_show keyboard_virtual_hide ' + 'keyboard_virtual_status keyboard_virtual_height',
    literal: 'self other all noone global local undefined pointer_invalid ' + 'pointer_null path_action_stop path_action_restart ' + 'path_action_continue path_action_reverse true false pi GM_build_date ' + 'GM_version GM_runtime_version  timezone_local timezone_utc ' + 'gamespeed_fps gamespeed_microseconds  ev_create ev_destroy ev_step ' + 'ev_alarm ev_keyboard ev_mouse ev_collision ev_other ev_draw ' + 'ev_draw_begin ev_draw_end ev_draw_pre ev_draw_post ev_keypress ' + 'ev_keyrelease ev_trigger ev_left_button ev_right_button ' + 'ev_middle_button ev_no_button ev_left_press ev_right_press ' + 'ev_middle_press ev_left_release ev_right_release ev_middle_release ' + 'ev_mouse_enter ev_mouse_leave ev_mouse_wheel_up ev_mouse_wheel_down ' + 'ev_global_left_button ev_global_right_button ev_global_middle_button ' + 'ev_global_left_press ev_global_right_press ev_global_middle_press ' + 'ev_global_left_release ev_global_right_release ' + 'ev_global_middle_release ev_joystick1_left ev_joystick1_right ' + 'ev_joystick1_up ev_joystick1_down ev_joystick1_button1 ' + 'ev_joystick1_button2 ev_joystick1_button3 ev_joystick1_button4 ' + 'ev_joystick1_button5 ev_joystick1_button6 ev_joystick1_button7 ' + 'ev_joystick1_button8 ev_joystick2_left ev_joystick2_right ' + 'ev_joystick2_up ev_joystick2_down ev_joystick2_button1 ' + 'ev_joystick2_button2 ev_joystick2_button3 ev_joystick2_button4 ' + 'ev_joystick2_button5 ev_joystick2_button6 ev_joystick2_button7 ' + 'ev_joystick2_button8 ev_outside ev_boundary ev_game_start ' + 'ev_game_end ev_room_start ev_room_end ev_no_more_lives ' + 'ev_animation_end ev_end_of_path ev_no_more_health ev_close_button ' + 'ev_user0 ev_user1 ev_user2 ev_user3 ev_user4 ev_user5 ev_user6 ' + 'ev_user7 ev_user8 ev_user9 ev_user10 ev_user11 ev_user12 ev_user13 ' + 'ev_user14 ev_user15 ev_step_normal ev_step_begin ev_step_end ev_gui ' + 'ev_gui_begin ev_gui_end ev_cleanup ev_gesture ev_gesture_tap ' + 'ev_gesture_double_tap ev_gesture_drag_start ev_gesture_dragging ' + 'ev_gesture_drag_end ev_gesture_flick ev_gesture_pinch_start ' + 'ev_gesture_pinch_in ev_gesture_pinch_out ev_gesture_pinch_end ' + 'ev_gesture_rotate_start ev_gesture_rotating ev_gesture_rotate_end ' + 'ev_global_gesture_tap ev_global_gesture_double_tap ' + 'ev_global_gesture_drag_start ev_global_gesture_dragging ' + 'ev_global_gesture_drag_end ev_global_gesture_flick ' + 'ev_global_gesture_pinch_start ev_global_gesture_pinch_in ' + 'ev_global_gesture_pinch_out ev_global_gesture_pinch_end ' + 'ev_global_gesture_rotate_start ev_global_gesture_rotating ' + 'ev_global_gesture_rotate_end vk_nokey vk_anykey vk_enter vk_return ' + 'vk_shift vk_control vk_alt vk_escape vk_space vk_backspace vk_tab ' + 'vk_pause vk_printscreen vk_left vk_right vk_up vk_down vk_home ' + 'vk_end vk_delete vk_insert vk_pageup vk_pagedown vk_f1 vk_f2 vk_f3 ' + 'vk_f4 vk_f5 vk_f6 vk_f7 vk_f8 vk_f9 vk_f10 vk_f11 vk_f12 vk_numpad0 ' + 'vk_numpad1 vk_numpad2 vk_numpad3 vk_numpad4 vk_numpad5 vk_numpad6 ' + 'vk_numpad7 vk_numpad8 vk_numpad9 vk_divide vk_multiply vk_subtract ' + 'vk_add vk_decimal vk_lshift vk_lcontrol vk_lalt vk_rshift ' + 'vk_rcontrol vk_ralt  mb_any mb_none mb_left mb_right mb_middle ' + 'c_aqua c_black c_blue c_dkgray c_fuchsia c_gray c_green c_lime ' + 'c_ltgray c_maroon c_navy c_olive c_purple c_red c_silver c_teal ' + 'c_white c_yellow c_orange fa_left fa_center fa_right fa_top ' + 'fa_middle fa_bottom pr_pointlist pr_linelist pr_linestrip ' + 'pr_trianglelist pr_trianglestrip pr_trianglefan bm_complex bm_normal ' + 'bm_add bm_max bm_subtract bm_zero bm_one bm_src_colour ' + 'bm_inv_src_colour bm_src_color bm_inv_src_color bm_src_alpha ' + 'bm_inv_src_alpha bm_dest_alpha bm_inv_dest_alpha bm_dest_colour ' + 'bm_inv_dest_colour bm_dest_color bm_inv_dest_color bm_src_alpha_sat ' + 'tf_point tf_linear tf_anisotropic mip_off mip_on mip_markedonly ' + 'audio_falloff_none audio_falloff_inverse_distance ' + 'audio_falloff_inverse_distance_clamped audio_falloff_linear_distance ' + 'audio_falloff_linear_distance_clamped ' + 'audio_falloff_exponent_distance ' + 'audio_falloff_exponent_distance_clamped audio_old_system ' + 'audio_new_system audio_mono audio_stereo audio_3d cr_default cr_none ' + 'cr_arrow cr_cross cr_beam cr_size_nesw cr_size_ns cr_size_nwse ' + 'cr_size_we cr_uparrow cr_hourglass cr_drag cr_appstart cr_handpoint ' + 'cr_size_all spritespeed_framespersecond ' + 'spritespeed_framespergameframe asset_object asset_unknown ' + 'asset_sprite asset_sound asset_room asset_path asset_script ' + 'asset_font asset_timeline asset_tiles asset_shader fa_readonly ' + 'fa_hidden fa_sysfile fa_volumeid fa_directory fa_archive  ' + 'ds_type_map ds_type_list ds_type_stack ds_type_queue ds_type_grid ' + 'ds_type_priority ef_explosion ef_ring ef_ellipse ef_firework ' + 'ef_smoke ef_smokeup ef_star ef_spark ef_flare ef_cloud ef_rain ' + 'ef_snow pt_shape_pixel pt_shape_disk pt_shape_square pt_shape_line ' + 'pt_shape_star pt_shape_circle pt_shape_ring pt_shape_sphere ' + 'pt_shape_flare pt_shape_spark pt_shape_explosion pt_shape_cloud ' + 'pt_shape_smoke pt_shape_snow ps_distr_linear ps_distr_gaussian ' + 'ps_distr_invgaussian ps_shape_rectangle ps_shape_ellipse ' + 'ps_shape_diamond ps_shape_line ty_real ty_string dll_cdecl ' + 'dll_stdcall matrix_view matrix_projection matrix_world os_win32 ' + 'os_windows os_macosx os_ios os_android os_symbian os_linux ' + 'os_unknown os_winphone os_tizen os_win8native ' + 'os_wiiu os_3ds  os_psvita os_bb10 os_ps4 os_xboxone ' + 'os_ps3 os_xbox360 os_uwp os_tvos os_switch ' + 'browser_not_a_browser browser_unknown browser_ie browser_firefox ' + 'browser_chrome browser_safari browser_safari_mobile browser_opera ' + 'browser_tizen browser_edge browser_windows_store browser_ie_mobile  ' + 'device_ios_unknown device_ios_iphone device_ios_iphone_retina ' + 'device_ios_ipad device_ios_ipad_retina device_ios_iphone5 ' + 'device_ios_iphone6 device_ios_iphone6plus device_emulator ' + 'device_tablet display_landscape display_landscape_flipped ' + 'display_portrait display_portrait_flipped tm_sleep tm_countvsyncs ' + 'of_challenge_win of_challen ge_lose of_challenge_tie ' + 'leaderboard_type_number leaderboard_type_time_mins_secs ' + 'cmpfunc_never cmpfunc_less cmpfunc_equal cmpfunc_lessequal ' + 'cmpfunc_greater cmpfunc_notequal cmpfunc_greaterequal cmpfunc_always ' + 'cull_noculling cull_clockwise cull_counterclockwise lighttype_dir ' + 'lighttype_point iap_ev_storeload iap_ev_product iap_ev_purchase ' + 'iap_ev_consume iap_ev_restore iap_storeload_ok iap_storeload_failed ' + 'iap_status_uninitialised iap_status_unavailable iap_status_loading ' + 'iap_status_available iap_status_processing iap_status_restoring ' + 'iap_failed iap_unavailable iap_available iap_purchased iap_canceled ' + 'iap_refunded fb_login_default fb_login_fallback_to_webview ' + 'fb_login_no_fallback_to_webview fb_login_forcing_webview ' + 'fb_login_use_system_account fb_login_forcing_safari  ' + 'phy_joint_anchor_1_x phy_joint_anchor_1_y phy_joint_anchor_2_x ' + 'phy_joint_anchor_2_y phy_joint_reaction_force_x ' + 'phy_joint_reaction_force_y phy_joint_reaction_torque ' + 'phy_joint_motor_speed phy_joint_angle phy_joint_motor_torque ' + 'phy_joint_max_motor_torque phy_joint_translation phy_joint_speed ' + 'phy_joint_motor_force phy_joint_max_motor_force phy_joint_length_1 ' + 'phy_joint_length_2 phy_joint_damping_ratio phy_joint_frequency ' + 'phy_joint_lower_angle_limit phy_joint_upper_angle_limit ' + 'phy_joint_angle_limits phy_joint_max_length phy_joint_max_torque ' + 'phy_joint_max_force phy_debug_render_aabb ' + 'phy_debug_render_collision_pairs phy_debug_render_coms ' + 'phy_debug_render_core_shapes phy_debug_render_joints ' + 'phy_debug_render_obb phy_debug_render_shapes  ' + 'phy_particle_flag_water phy_particle_flag_zombie ' + 'phy_particle_flag_wall phy_particle_flag_spring ' + 'phy_particle_flag_elastic phy_particle_flag_viscous ' + 'phy_particle_flag_powder phy_particle_flag_tensile ' + 'phy_particle_flag_colourmixing phy_particle_flag_colormixing ' + 'phy_particle_group_flag_solid phy_particle_group_flag_rigid ' + 'phy_particle_data_flag_typeflags phy_particle_data_flag_position ' + 'phy_particle_data_flag_velocity phy_particle_data_flag_colour ' + 'phy_particle_data_flag_color phy_particle_data_flag_category  ' + 'achievement_our_info achievement_friends_info ' + 'achievement_leaderboard_info achievement_achievement_info ' + 'achievement_filter_all_players achievement_filter_friends_only ' + 'achievement_filter_favorites_only ' + 'achievement_type_achievement_challenge ' + 'achievement_type_score_challenge achievement_pic_loaded  ' + 'achievement_show_ui achievement_show_profile ' + 'achievement_show_leaderboard achievement_show_achievement ' + 'achievement_show_bank achievement_show_friend_picker ' + 'achievement_show_purchase_prompt network_socket_tcp ' + 'network_socket_udp network_socket_bluetooth network_type_connect ' + 'network_type_disconnect network_type_data ' + 'network_type_non_blocking_connect network_config_connect_timeout ' + 'network_config_use_non_blocking_socket ' + 'network_config_enable_reliable_udp ' + 'network_config_disable_reliable_udp buffer_fixed buffer_grow ' + 'buffer_wrap buffer_fast buffer_vbuffer buffer_network buffer_u8 ' + 'buffer_s8 buffer_u16 buffer_s16 buffer_u32 buffer_s32 buffer_u64 ' + 'buffer_f16 buffer_f32 buffer_f64 buffer_bool buffer_text ' + 'buffer_string buffer_surface_copy buffer_seek_start ' + 'buffer_seek_relative buffer_seek_end ' + 'buffer_generalerror buffer_outofspace buffer_outofbounds ' + 'buffer_invalidtype  text_type button_type input_type ANSI_CHARSET ' + 'DEFAULT_CHARSET EASTEUROPE_CHARSET RUSSIAN_CHARSET SYMBOL_CHARSET ' + 'SHIFTJIS_CHARSET HANGEUL_CHARSET GB2312_CHARSET CHINESEBIG5_CHARSET ' + 'JOHAB_CHARSET HEBREW_CHARSET ARABIC_CHARSET GREEK_CHARSET ' + 'TURKISH_CHARSET VIETNAMESE_CHARSET THAI_CHARSET MAC_CHARSET ' + 'BALTIC_CHARSET OEM_CHARSET  gp_face1 gp_face2 gp_face3 gp_face4 ' + 'gp_shoulderl gp_shoulderr gp_shoulderlb gp_shoulderrb gp_select ' + 'gp_start gp_stickl gp_stickr gp_padu gp_padd gp_padl gp_padr ' + 'gp_axislh gp_axislv gp_axisrh gp_axisrv ov_friends ov_community ' + 'ov_players ov_settings ov_gamegroup ov_achievements lb_sort_none ' + 'lb_sort_ascending lb_sort_descending lb_disp_none lb_disp_numeric ' + 'lb_disp_time_sec lb_disp_time_ms ugc_result_success ' + 'ugc_filetype_community ugc_filetype_microtrans ugc_visibility_public ' + 'ugc_visibility_friends_only ugc_visibility_private ' + 'ugc_query_RankedByVote ugc_query_RankedByPublicationDate ' + 'ugc_query_AcceptedForGameRankedByAcceptanceDate ' + 'ugc_query_RankedByTrend ' + 'ugc_query_FavoritedByFriendsRankedByPublicationDate ' + 'ugc_query_CreatedByFriendsRankedByPublicationDate ' + 'ugc_query_RankedByNumTimesReported ' + 'ugc_query_CreatedByFollowedUsersRankedByPublicationDate ' + 'ugc_query_NotYetRated ugc_query_RankedByTotalVotesAsc ' + 'ugc_query_RankedByVotesUp ugc_query_RankedByTextSearch ' + 'ugc_sortorder_CreationOrderDesc ugc_sortorder_CreationOrderAsc ' + 'ugc_sortorder_TitleAsc ugc_sortorder_LastUpdatedDesc ' + 'ugc_sortorder_SubscriptionDateDesc ugc_sortorder_VoteScoreDesc ' + 'ugc_sortorder_ForModeration ugc_list_Published ugc_list_VotedOn ' + 'ugc_list_VotedUp ugc_list_VotedDown ugc_list_WillVoteLater ' + 'ugc_list_Favorited ugc_list_Subscribed ugc_list_UsedOrPlayed ' + 'ugc_list_Followed ugc_match_Items ugc_match_Items_Mtx ' + 'ugc_match_Items_ReadyToUse ugc_match_Collections ugc_match_Artwork ' + 'ugc_match_Videos ugc_match_Screenshots ugc_match_AllGuides ' + 'ugc_match_WebGuides ugc_match_IntegratedGuides ' + 'ugc_match_UsableInGame ugc_match_ControllerBindings  ' + 'vertex_usage_position vertex_usage_colour vertex_usage_color ' + 'vertex_usage_normal vertex_usage_texcoord vertex_usage_textcoord ' + 'vertex_usage_blendweight vertex_usage_blendindices ' + 'vertex_usage_psize vertex_usage_tangent vertex_usage_binormal ' + 'vertex_usage_fog vertex_usage_depth vertex_usage_sample ' + 'vertex_type_float1 vertex_type_float2 vertex_type_float3 ' + 'vertex_type_float4 vertex_type_colour vertex_type_color ' + 'vertex_type_ubyte4 layerelementtype_undefined ' + 'layerelementtype_background layerelementtype_instance ' + 'layerelementtype_oldtilemap layerelementtype_sprite ' + 'layerelementtype_tilemap layerelementtype_particlesystem ' + 'layerelementtype_tile tile_rotate tile_flip tile_mirror ' + 'tile_index_mask kbv_type_default kbv_type_ascii kbv_type_url ' + 'kbv_type_email kbv_type_numbers kbv_type_phone kbv_type_phone_name ' + 'kbv_returnkey_default kbv_returnkey_go kbv_returnkey_google ' + 'kbv_returnkey_join kbv_returnkey_next kbv_returnkey_route ' + 'kbv_returnkey_search kbv_returnkey_send kbv_returnkey_yahoo ' + 'kbv_returnkey_done kbv_returnkey_continue kbv_returnkey_emergency ' + 'kbv_autocapitalize_none kbv_autocapitalize_words ' + 'kbv_autocapitalize_sentences kbv_autocapitalize_characters',
    symbol: 'argument_relative argument argument0 argument1 argument2 ' + 'argument3 argument4 argument5 argument6 argument7 argument8 ' + 'argument9 argument10 argument11 argument12 argument13 argument14 ' + 'argument15 argument_count x|0 y|0 xprevious yprevious xstart ystart ' + 'hspeed vspeed direction speed friction gravity gravity_direction ' + 'path_index path_position path_positionprevious path_speed ' + 'path_scale path_orientation path_endaction object_index id solid ' + 'persistent mask_index instance_count instance_id room_speed fps ' + 'fps_real current_time current_year current_month current_day ' + 'current_weekday current_hour current_minute current_second alarm ' + 'timeline_index timeline_position timeline_speed timeline_running ' + 'timeline_loop room room_first room_last room_width room_height ' + 'room_caption room_persistent score lives health show_score ' + 'show_lives show_health caption_score caption_lives caption_health ' + 'event_type event_number event_object event_action ' + 'application_surface gamemaker_pro gamemaker_registered ' + 'gamemaker_version error_occurred error_last debug_mode ' + 'keyboard_key keyboard_lastkey keyboard_lastchar keyboard_string ' + 'mouse_x mouse_y mouse_button mouse_lastbutton cursor_sprite ' + 'visible sprite_index sprite_width sprite_height sprite_xoffset ' + 'sprite_yoffset image_number image_index image_speed depth ' + 'image_xscale image_yscale image_angle image_alpha image_blend ' + 'bbox_left bbox_right bbox_top bbox_bottom layer background_colour  ' + 'background_showcolour background_color background_showcolor ' + 'view_enabled view_current view_visible view_xview view_yview ' + 'view_wview view_hview view_xport view_yport view_wport view_hport ' + 'view_angle view_hborder view_vborder view_hspeed view_vspeed ' + 'view_object view_surface_id view_camera game_id game_display_name ' + 'game_project_name game_save_id working_directory temp_directory ' + 'program_directory browser_width browser_height os_type os_device ' + 'os_browser os_version display_aa async_load delta_time ' + 'webgl_enabled event_data iap_data phy_rotation phy_position_x ' + 'phy_position_y phy_angular_velocity phy_linear_velocity_x ' + 'phy_linear_velocity_y phy_speed_x phy_speed_y phy_speed ' + 'phy_angular_damping phy_linear_damping phy_bullet ' + 'phy_fixed_rotation phy_active phy_mass phy_inertia phy_com_x ' + 'phy_com_y phy_dynamic phy_kinematic phy_sleeping ' + 'phy_collision_points phy_collision_x phy_collision_y ' + 'phy_col_normal_x phy_col_normal_y phy_position_xprevious ' + 'phy_position_yprevious'
  };
  return {
    name: 'GML',
    case_insensitive: false,
    // language is case-insensitive
    keywords: GML_KEYWORDS,
    contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, hljs.C_NUMBER_MODE]
  };
}
module.exports = gml;

/***/ }),

/***/ 51464:
/***/ ((module) => {

/*
Language: Go
Author: Stephan Kountso aka StepLg <steplg@gmail.com>
Contributors: Evgeny Stepanischev <imbolk@gmail.com>
Description: Google go language (golang). For info about language
Website: http://golang.org/
Category: common, system
*/

function go(hljs) {
  var GO_KEYWORDS = {
    keyword: 'break default func interface select case map struct chan else goto package switch ' + 'const fallthrough if range type continue for import return var go defer ' + 'bool byte complex64 complex128 float32 float64 int8 int16 int32 int64 string uint8 ' + 'uint16 uint32 uint64 int uint uintptr rune',
    literal: 'true false iota nil',
    built_in: 'append cap close complex copy imag len make new panic print println real recover delete'
  };
  return {
    name: 'Go',
    aliases: ['golang'],
    keywords: GO_KEYWORDS,
    illegal: '</',
    contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, {
      className: 'string',
      variants: [hljs.QUOTE_STRING_MODE, hljs.APOS_STRING_MODE, {
        begin: '`',
        end: '`'
      }]
    }, {
      className: 'number',
      variants: [{
        begin: hljs.C_NUMBER_RE + '[i]',
        relevance: 1
      }, hljs.C_NUMBER_MODE]
    }, {
      begin: /:=/ // relevance booster
    }, {
      className: 'function',
      beginKeywords: 'func',
      end: '\\s*(\\{|$)',
      excludeEnd: true,
      contains: [hljs.TITLE_MODE, {
        className: 'params',
        begin: /\(/,
        end: /\)/,
        keywords: GO_KEYWORDS,
        illegal: /["']/
      }]
    }]
  };
}
module.exports = go;

/***/ }),

/***/ 50675:
/***/ ((module) => {

/*
Language: Golo
Author: Philippe Charriere <ph.charriere@gmail.com>
Description: a lightweight dynamic language for the JVM
Website: http://golo-lang.org/
*/

function golo(hljs) {
  return {
    name: 'Golo',
    keywords: {
      keyword: 'println readln print import module function local return let var ' + 'while for foreach times in case when match with break continue ' + 'augment augmentation each find filter reduce ' + 'if then else otherwise try catch finally raise throw orIfNull ' + 'DynamicObject|10 DynamicVariable struct Observable map set vector list array',
      literal: 'true false null'
    },
    contains: [hljs.HASH_COMMENT_MODE, hljs.QUOTE_STRING_MODE, hljs.C_NUMBER_MODE, {
      className: 'meta',
      begin: '@[A-Za-z]+'
    }]
  };
}
module.exports = golo;

/***/ }),

/***/ 80481:
/***/ ((module) => {

/*
Language: Gradle
Description: Gradle is an open-source build automation tool focused on flexibility and performance.
Website: https://gradle.org
Author: Damian Mee <mee.damian@gmail.com>
*/

function gradle(hljs) {
  return {
    name: 'Gradle',
    case_insensitive: true,
    keywords: {
      keyword: 'task project allprojects subprojects artifacts buildscript configurations ' + 'dependencies repositories sourceSets description delete from into include ' + 'exclude source classpath destinationDir includes options sourceCompatibility ' + 'targetCompatibility group flatDir doLast doFirst flatten todir fromdir ant ' + 'def abstract break case catch continue default do else extends final finally ' + 'for if implements instanceof native new private protected public return static ' + 'switch synchronized throw throws transient try volatile while strictfp package ' + 'import false null super this true antlrtask checkstyle codenarc copy boolean ' + 'byte char class double float int interface long short void compile runTime ' + 'file fileTree abs any append asList asWritable call collect compareTo count ' + 'div dump each eachByte eachFile eachLine every find findAll flatten getAt ' + 'getErr getIn getOut getText grep immutable inject inspect intersect invokeMethods ' + 'isCase join leftShift minus multiply newInputStream newOutputStream newPrintWriter ' + 'newReader newWriter next plus pop power previous print println push putAt read ' + 'readBytes readLines reverse reverseEach round size sort splitEachLine step subMap ' + 'times toInteger toList tokenize upto waitForOrKill withPrintWriter withReader ' + 'withStream withWriter withWriterAppend write writeLine'
    },
    contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, hljs.NUMBER_MODE, hljs.REGEXP_MODE]
  };
}
module.exports = gradle;

/***/ }),

/***/ 48903:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function lookahead(re) {
  return concat('(?=', re, ')');
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/*
 Language: Groovy
 Author: Guillaume Laforge <glaforge@gmail.com>
 Description: Groovy programming language implementation inspired from Vsevolod's Java mode
 Website: https://groovy-lang.org
 */

function variants(variants) {
  var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  obj.variants = variants;
  return obj;
}
function groovy(hljs) {
  var IDENT_RE = '[A-Za-z0-9_$]+';
  var COMMENT = variants([hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.COMMENT('/\\*\\*', '\\*/', {
    relevance: 0,
    contains: [{
      // eat up @'s in emails to prevent them to be recognized as doctags
      begin: /\w+@/,
      relevance: 0
    }, {
      className: 'doctag',
      begin: '@[A-Za-z]+'
    }]
  })]);
  var REGEXP = {
    className: 'regexp',
    begin: /~?\/[^\/\n]+\//,
    contains: [hljs.BACKSLASH_ESCAPE]
  };
  var NUMBER = variants([hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE]);
  var STRING = variants([{
    begin: /"""/,
    end: /"""/
  }, {
    begin: /'''/,
    end: /'''/
  }, {
    begin: "\\$/",
    end: "/\\$",
    relevance: 10
  }, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE], {
    className: "string"
  });
  return {
    name: 'Groovy',
    keywords: {
      built_in: 'this super',
      literal: 'true false null',
      keyword: 'byte short char int long boolean float double void ' +
      // groovy specific keywords
      'def as in assert trait ' +
      // common keywords with Java
      'abstract static volatile transient public private protected synchronized final ' + 'class interface enum if else for while switch case break default continue ' + 'throw throws try catch finally implements extends new import package return instanceof'
    },
    contains: [hljs.SHEBANG({
      binary: "groovy",
      relevance: 10
    }), COMMENT, STRING, REGEXP, NUMBER, {
      className: 'class',
      beginKeywords: 'class interface trait enum',
      end: /\{/,
      illegal: ':',
      contains: [{
        beginKeywords: 'extends implements'
      }, hljs.UNDERSCORE_TITLE_MODE]
    }, {
      className: 'meta',
      begin: '@[A-Za-z]+',
      relevance: 0
    }, {
      // highlight map keys and named parameters as attrs
      className: 'attr',
      begin: IDENT_RE + '[ \t]*:',
      relevance: 0
    }, {
      // catch middle element of the ternary operator
      // to avoid highlight it as a label, named parameter, or map key
      begin: /\?/,
      end: /:/,
      relevance: 0,
      contains: [COMMENT, STRING, REGEXP, NUMBER, 'self']
    }, {
      // highlight labeled statements
      className: 'symbol',
      begin: '^[ \t]*' + lookahead(IDENT_RE + ':'),
      excludeBegin: true,
      end: IDENT_RE + ':',
      relevance: 0
    }],
    illegal: /#|<\//
  };
}
module.exports = groovy;

/***/ }),

/***/ 14801:
/***/ ((module) => {

/*
Language: HAML
Requires: ruby.js
Author: Dan Allen <dan.j.allen@gmail.com>
Website: http://haml.info
Category: template
*/

// TODO support filter tags like :javascript, support inline HTML
function haml(hljs) {
  return {
    name: 'HAML',
    case_insensitive: true,
    contains: [{
      className: 'meta',
      begin: '^!!!( (5|1\\.1|Strict|Frameset|Basic|Mobile|RDFa|XML\\b.*))?$',
      relevance: 10
    },
    // FIXME these comments should be allowed to span indented lines
    hljs.COMMENT('^\\s*(!=#|=#|-#|/).*$', false, {
      relevance: 0
    }), {
      begin: '^\\s*(-|=|!=)(?!#)',
      starts: {
        end: '\\n',
        subLanguage: 'ruby'
      }
    }, {
      className: 'tag',
      begin: '^\\s*%',
      contains: [{
        className: 'selector-tag',
        begin: '\\w+'
      }, {
        className: 'selector-id',
        begin: '#[\\w-]+'
      }, {
        className: 'selector-class',
        begin: '\\.[\\w-]+'
      }, {
        begin: /\{\s*/,
        end: /\s*\}/,
        contains: [{
          begin: ':\\w+\\s*=>',
          end: ',\\s+',
          returnBegin: true,
          endsWithParent: true,
          contains: [{
            className: 'attr',
            begin: ':\\w+'
          }, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, {
            begin: '\\w+',
            relevance: 0
          }]
        }]
      }, {
        begin: '\\(\\s*',
        end: '\\s*\\)',
        excludeEnd: true,
        contains: [{
          begin: '\\w+\\s*=',
          end: '\\s+',
          returnBegin: true,
          endsWithParent: true,
          contains: [{
            className: 'attr',
            begin: '\\w+',
            relevance: 0
          }, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, {
            begin: '\\w+',
            relevance: 0
          }]
        }]
      }]
    }, {
      begin: '^\\s*[=~]\\s*'
    }, {
      begin: /#\{/,
      starts: {
        end: /\}/,
        subLanguage: 'ruby'
      }
    }]
  };
}
module.exports = haml;

/***/ }),

/***/ 11909:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function anyNumberOfTimes(re) {
  return concat('(', re, ')*');
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function optional(re) {
  return concat('(', re, ')?');
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */
function either() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var joined = '(' + args.map(function (x) {
    return source(x);
  }).join("|") + ")";
  return joined;
}

/*
Language: Handlebars
Requires: xml.js
Author: Robin Ward <robin.ward@gmail.com>
Description: Matcher for Handlebars as well as EmberJS additions.
Website: https://handlebarsjs.com
Category: template
*/

function handlebars(hljs) {
  var BUILT_INS = {
    'builtin-name': ['action', 'bindattr', 'collection', 'component', 'concat', 'debugger', 'each', 'each-in', 'get', 'hash', 'if', 'in', 'input', 'link-to', 'loc', 'log', 'lookup', 'mut', 'outlet', 'partial', 'query-params', 'render', 'template', 'textarea', 'unbound', 'unless', 'view', 'with', 'yield']
  };
  var LITERALS = {
    literal: ['true', 'false', 'undefined', 'null']
  };

  // as defined in https://handlebarsjs.com/guide/expressions.html#literal-segments
  // this regex matches literal segments like ' abc ' or [ abc ] as well as helpers and paths
  // like a/b, ./abc/cde, and abc.bcd

  var DOUBLE_QUOTED_ID_REGEX = /""|"[^"]+"/;
  var SINGLE_QUOTED_ID_REGEX = /''|'[^']+'/;
  var BRACKET_QUOTED_ID_REGEX = /\[\]|\[[^\]]+\]/;
  var PLAIN_ID_REGEX = /[^\s!"#%&'()*+,.\/;<=>@\[\\\]^`{|}~]+/;
  var PATH_DELIMITER_REGEX = /(\.|\/)/;
  var ANY_ID = either(DOUBLE_QUOTED_ID_REGEX, SINGLE_QUOTED_ID_REGEX, BRACKET_QUOTED_ID_REGEX, PLAIN_ID_REGEX);
  var IDENTIFIER_REGEX = concat(optional(/\.|\.\/|\//),
  // relative or absolute path
  ANY_ID, anyNumberOfTimes(concat(PATH_DELIMITER_REGEX, ANY_ID)));

  // identifier followed by a equal-sign (without the equal sign)
  var HASH_PARAM_REGEX = concat('(', BRACKET_QUOTED_ID_REGEX, '|', PLAIN_ID_REGEX, ')(?==)');
  var HELPER_NAME_OR_PATH_EXPRESSION = {
    begin: IDENTIFIER_REGEX,
    lexemes: /[\w.\/]+/
  };
  var HELPER_PARAMETER = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
    keywords: LITERALS
  });
  var SUB_EXPRESSION = {
    begin: /\(/,
    end: /\)/
    // the "contains" is added below when all necessary sub-modes are defined
  };

  var HASH = {
    // fka "attribute-assignment", parameters of the form 'key=value'
    className: 'attr',
    begin: HASH_PARAM_REGEX,
    relevance: 0,
    starts: {
      begin: /=/,
      end: /=/,
      starts: {
        contains: [hljs.NUMBER_MODE, hljs.QUOTE_STRING_MODE, hljs.APOS_STRING_MODE, HELPER_PARAMETER, SUB_EXPRESSION]
      }
    }
  };
  var BLOCK_PARAMS = {
    // parameters of the form '{{#with x as | y |}}...{{/with}}'
    begin: /as\s+\|/,
    keywords: {
      keyword: 'as'
    },
    end: /\|/,
    contains: [{
      // define sub-mode in order to prevent highlighting of block-parameter named "as"
      begin: /\w+/
    }]
  };
  var HELPER_PARAMETERS = {
    contains: [hljs.NUMBER_MODE, hljs.QUOTE_STRING_MODE, hljs.APOS_STRING_MODE, BLOCK_PARAMS, HASH, HELPER_PARAMETER, SUB_EXPRESSION],
    returnEnd: true
    // the property "end" is defined through inheritance when the mode is used. If depends
    // on the surrounding mode, but "endsWithParent" does not work here (i.e. it includes the
    // end-token of the surrounding mode)
  };

  var SUB_EXPRESSION_CONTENTS = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
    className: 'name',
    keywords: BUILT_INS,
    starts: hljs.inherit(HELPER_PARAMETERS, {
      end: /\)/
    })
  });
  SUB_EXPRESSION.contains = [SUB_EXPRESSION_CONTENTS];
  var OPENING_BLOCK_MUSTACHE_CONTENTS = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
    keywords: BUILT_INS,
    className: 'name',
    starts: hljs.inherit(HELPER_PARAMETERS, {
      end: /\}\}/
    })
  });
  var CLOSING_BLOCK_MUSTACHE_CONTENTS = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
    keywords: BUILT_INS,
    className: 'name'
  });
  var BASIC_MUSTACHE_CONTENTS = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
    className: 'name',
    keywords: BUILT_INS,
    starts: hljs.inherit(HELPER_PARAMETERS, {
      end: /\}\}/
    })
  });
  var ESCAPE_MUSTACHE_WITH_PRECEEDING_BACKSLASH = {
    begin: /\\\{\{/,
    skip: true
  };
  var PREVENT_ESCAPE_WITH_ANOTHER_PRECEEDING_BACKSLASH = {
    begin: /\\\\(?=\{\{)/,
    skip: true
  };
  return {
    name: 'Handlebars',
    aliases: ['hbs', 'html.hbs', 'html.handlebars', 'htmlbars'],
    case_insensitive: true,
    subLanguage: 'xml',
    contains: [ESCAPE_MUSTACHE_WITH_PRECEEDING_BACKSLASH, PREVENT_ESCAPE_WITH_ANOTHER_PRECEEDING_BACKSLASH, hljs.COMMENT(/\{\{!--/, /--\}\}/), hljs.COMMENT(/\{\{!/, /\}\}/), {
      // open raw block "{{{{raw}}}} content not evaluated {{{{/raw}}}}"
      className: 'template-tag',
      begin: /\{\{\{\{(?!\/)/,
      end: /\}\}\}\}/,
      contains: [OPENING_BLOCK_MUSTACHE_CONTENTS],
      starts: {
        end: /\{\{\{\{\//,
        returnEnd: true,
        subLanguage: 'xml'
      }
    }, {
      // close raw block
      className: 'template-tag',
      begin: /\{\{\{\{\//,
      end: /\}\}\}\}/,
      contains: [CLOSING_BLOCK_MUSTACHE_CONTENTS]
    }, {
      // open block statement
      className: 'template-tag',
      begin: /\{\{#/,
      end: /\}\}/,
      contains: [OPENING_BLOCK_MUSTACHE_CONTENTS]
    }, {
      className: 'template-tag',
      begin: /\{\{(?=else\}\})/,
      end: /\}\}/,
      keywords: 'else'
    }, {
      className: 'template-tag',
      begin: /\{\{(?=else if)/,
      end: /\}\}/,
      keywords: 'else if'
    }, {
      // closing block statement
      className: 'template-tag',
      begin: /\{\{\//,
      end: /\}\}/,
      contains: [CLOSING_BLOCK_MUSTACHE_CONTENTS]
    }, {
      // template variable or helper-call that is NOT html-escaped
      className: 'template-variable',
      begin: /\{\{\{/,
      end: /\}\}\}/,
      contains: [BASIC_MUSTACHE_CONTENTS]
    }, {
      // template variable or helper-call that is html-escaped
      className: 'template-variable',
      begin: /\{\{/,
      end: /\}\}/,
      contains: [BASIC_MUSTACHE_CONTENTS]
    }]
  };
}
module.exports = handlebars;

/***/ }),

/***/ 92807:
/***/ ((module) => {

/*
Language: Haskell
Author: Jeremy Hull <sourdrums@gmail.com>
Contributors: Zena Treep <zena.treep@gmail.com>
Website: https://www.haskell.org
Category: functional
*/

function haskell(hljs) {
  var COMMENT = {
    variants: [hljs.COMMENT('--', '$'), hljs.COMMENT(/\{-/, /-\}/, {
      contains: ['self']
    })]
  };
  var PRAGMA = {
    className: 'meta',
    begin: /\{-#/,
    end: /#-\}/
  };
  var PREPROCESSOR = {
    className: 'meta',
    begin: '^#',
    end: '$'
  };
  var CONSTRUCTOR = {
    className: 'type',
    begin: '\\b[A-Z][\\w\']*',
    // TODO: other constructors (build-in, infix).
    relevance: 0
  };
  var LIST = {
    begin: '\\(',
    end: '\\)',
    illegal: '"',
    contains: [PRAGMA, PREPROCESSOR, {
      className: 'type',
      begin: '\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?'
    }, hljs.inherit(hljs.TITLE_MODE, {
      begin: '[_a-z][\\w\']*'
    }), COMMENT]
  };
  var RECORD = {
    begin: /\{/,
    end: /\}/,
    contains: LIST.contains
  };
  return {
    name: 'Haskell',
    aliases: ['hs'],
    keywords: 'let in if then else case of where do module import hiding ' + 'qualified type data newtype deriving class instance as default ' + 'infix infixl infixr foreign export ccall stdcall cplusplus ' + 'jvm dotnet safe unsafe family forall mdo proc rec',
    contains: [
    // Top-level constructions.
    {
      beginKeywords: 'module',
      end: 'where',
      keywords: 'module where',
      contains: [LIST, COMMENT],
      illegal: '\\W\\.|;'
    }, {
      begin: '\\bimport\\b',
      end: '$',
      keywords: 'import qualified as hiding',
      contains: [LIST, COMMENT],
      illegal: '\\W\\.|;'
    }, {
      className: 'class',
      begin: '^(\\s*)?(class|instance)\\b',
      end: 'where',
      keywords: 'class family instance where',
      contains: [CONSTRUCTOR, LIST, COMMENT]
    }, {
      className: 'class',
      begin: '\\b(data|(new)?type)\\b',
      end: '$',
      keywords: 'data family type newtype deriving',
      contains: [PRAGMA, CONSTRUCTOR, LIST, RECORD, COMMENT]
    }, {
      beginKeywords: 'default',
      end: '$',
      contains: [CONSTRUCTOR, LIST, COMMENT]
    }, {
      beginKeywords: 'infix infixl infixr',
      end: '$',
      contains: [hljs.C_NUMBER_MODE, COMMENT]
    }, {
      begin: '\\bforeign\\b',
      end: '$',
      keywords: 'foreign import export ccall stdcall cplusplus jvm ' + 'dotnet safe unsafe',
      contains: [CONSTRUCTOR, hljs.QUOTE_STRING_MODE, COMMENT]
    }, {
      className: 'meta',
      begin: '#!\\/usr\\/bin\\/env\ runhaskell',
      end: '$'
    },
    // "Whitespaces".
    PRAGMA, PREPROCESSOR,
    // Literals and names.

    // TODO: characters.
    hljs.QUOTE_STRING_MODE, hljs.C_NUMBER_MODE, CONSTRUCTOR, hljs.inherit(hljs.TITLE_MODE, {
      begin: '^[_a-z][\\w\']*'
    }), COMMENT, {
      // No markup, relevance booster
      begin: '->|<-'
    }]
  };
}
module.exports = haskell;

/***/ }),

/***/ 20560:
/***/ ((module) => {

/*
Language: Haxe
Description: Haxe is an open source toolkit based on a modern, high level, strictly typed programming language.
Author: Christopher Kaster <ikasoki@gmail.com> (Based on the actionscript.js language file by Alexander Myadzel)
Contributors: Kenton Hamaluik <kentonh@gmail.com>
Website: https://haxe.org
*/

function haxe(hljs) {
  var HAXE_BASIC_TYPES = 'Int Float String Bool Dynamic Void Array ';
  return {
    name: 'Haxe',
    aliases: ['hx'],
    keywords: {
      keyword: 'break case cast catch continue default do dynamic else enum extern ' + 'for function here if import in inline never new override package private get set ' + 'public return static super switch this throw trace try typedef untyped using var while ' + HAXE_BASIC_TYPES,
      built_in: 'trace this',
      literal: 'true false null _'
    },
    contains: [{
      className: 'string',
      // interpolate-able strings
      begin: '\'',
      end: '\'',
      contains: [hljs.BACKSLASH_ESCAPE, {
        className: 'subst',
        // interpolation
        begin: '\\$\\{',
        end: '\\}'
      }, {
        className: 'subst',
        // interpolation
        begin: '\\$',
        end: /\W\}/
      }]
    }, hljs.QUOTE_STRING_MODE, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.C_NUMBER_MODE, {
      className: 'meta',
      // compiler meta
      begin: '@:',
      end: '$'
    }, {
      className: 'meta',
      // compiler conditionals
      begin: '#',
      end: '$',
      keywords: {
        'meta-keyword': 'if else elseif end error'
      }
    }, {
      className: 'type',
      // function types
      begin: ':[ \t]*',
      end: '[^A-Za-z0-9_ \t\\->]',
      excludeBegin: true,
      excludeEnd: true,
      relevance: 0
    }, {
      className: 'type',
      // types
      begin: ':[ \t]*',
      end: '\\W',
      excludeBegin: true,
      excludeEnd: true
    }, {
      className: 'type',
      // instantiation
      begin: 'new *',
      end: '\\W',
      excludeBegin: true,
      excludeEnd: true
    }, {
      className: 'class',
      // enums
      beginKeywords: 'enum',
      end: '\\{',
      contains: [hljs.TITLE_MODE]
    }, {
      className: 'class',
      // abstracts
      beginKeywords: 'abstract',
      end: '[\\{$]',
      contains: [{
        className: 'type',
        begin: '\\(',
        end: '\\)',
        excludeBegin: true,
        excludeEnd: true
      }, {
        className: 'type',
        begin: 'from +',
        end: '\\W',
        excludeBegin: true,
        excludeEnd: true
      }, {
        className: 'type',
        begin: 'to +',
        end: '\\W',
        excludeBegin: true,
        excludeEnd: true
      }, hljs.TITLE_MODE],
      keywords: {
        keyword: 'abstract from to'
      }
    }, {
      className: 'class',
      // classes
      begin: '\\b(class|interface) +',
      end: '[\\{$]',
      excludeEnd: true,
      keywords: 'class interface',
      contains: [{
        className: 'keyword',
        begin: '\\b(extends|implements) +',
        keywords: 'extends implements',
        contains: [{
          className: 'type',
          begin: hljs.IDENT_RE,
          relevance: 0
        }]
      }, hljs.TITLE_MODE]
    }, {
      className: 'function',
      beginKeywords: 'function',
      end: '\\(',
      excludeEnd: true,
      illegal: '\\S',
      contains: [hljs.TITLE_MODE]
    }],
    illegal: /<\//
  };
}
module.exports = haxe;

/***/ }),

/***/ 65138:
/***/ ((module) => {

/*
Language: HSP
Author: prince <MC.prince.0203@gmail.com>
Website: https://en.wikipedia.org/wiki/Hot_Soup_Processor
Category: scripting
*/

function hsp(hljs) {
  return {
    name: 'HSP',
    case_insensitive: true,
    keywords: {
      $pattern: /[\w._]+/,
      keyword: 'goto gosub return break repeat loop continue wait await dim sdim foreach dimtype dup dupptr end stop newmod delmod mref run exgoto on mcall assert logmes newlab resume yield onexit onerror onkey onclick oncmd exist delete mkdir chdir dirlist bload bsave bcopy memfile if else poke wpoke lpoke getstr chdpm memexpand memcpy memset notesel noteadd notedel noteload notesave randomize noteunsel noteget split strrep setease button chgdisp exec dialog mmload mmplay mmstop mci pset pget syscolor mes print title pos circle cls font sysfont objsize picload color palcolor palette redraw width gsel gcopy gzoom gmode bmpsave hsvcolor getkey listbox chkbox combox input mesbox buffer screen bgscr mouse objsel groll line clrobj boxf objprm objmode stick grect grotate gsquare gradf objimage objskip objenable celload celdiv celput newcom querycom delcom cnvstow comres axobj winobj sendmsg comevent comevarg sarrayconv callfunc cnvwtos comevdisp libptr system hspstat hspver stat cnt err strsize looplev sublev iparam wparam lparam refstr refdval int rnd strlen length length2 length3 length4 vartype gettime peek wpeek lpeek varptr varuse noteinfo instr abs limit getease str strmid strf getpath strtrim sin cos tan atan sqrt double absf expf logf limitf powf geteasef mousex mousey mousew hwnd hinstance hdc ginfo objinfo dirinfo sysinfo thismod __hspver__ __hsp30__ __date__ __time__ __line__ __file__ _debug __hspdef__ and or xor not screen_normal screen_palette screen_hide screen_fixedsize screen_tool screen_frame gmode_gdi gmode_mem gmode_rgb0 gmode_alpha gmode_rgb0alpha gmode_add gmode_sub gmode_pixela ginfo_mx ginfo_my ginfo_act ginfo_sel ginfo_wx1 ginfo_wy1 ginfo_wx2 ginfo_wy2 ginfo_vx ginfo_vy ginfo_sizex ginfo_sizey ginfo_winx ginfo_winy ginfo_mesx ginfo_mesy ginfo_r ginfo_g ginfo_b ginfo_paluse ginfo_dispx ginfo_dispy ginfo_cx ginfo_cy ginfo_intid ginfo_newid ginfo_sx ginfo_sy objinfo_mode objinfo_bmscr objinfo_hwnd notemax notesize dir_cur dir_exe dir_win dir_sys dir_cmdline dir_desktop dir_mydoc dir_tv font_normal font_bold font_italic font_underline font_strikeout font_antialias objmode_normal objmode_guifont objmode_usefont gsquare_grad msgothic msmincho do until while wend for next _break _continue switch case default swbreak swend ddim ldim alloc m_pi rad2deg deg2rad ease_linear ease_quad_in ease_quad_out ease_quad_inout ease_cubic_in ease_cubic_out ease_cubic_inout ease_quartic_in ease_quartic_out ease_quartic_inout ease_bounce_in ease_bounce_out ease_bounce_inout ease_shake_in ease_shake_out ease_shake_inout ease_loop'
    },
    contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.QUOTE_STRING_MODE, hljs.APOS_STRING_MODE, {
      // multi-line string
      className: 'string',
      begin: /\{"/,
      end: /"\}/,
      contains: [hljs.BACKSLASH_ESCAPE]
    }, hljs.COMMENT(';', '$', {
      relevance: 0
    }), {
      // pre-processor
      className: 'meta',
      begin: '#',
      end: '$',
      keywords: {
        'meta-keyword': 'addion cfunc cmd cmpopt comfunc const defcfunc deffunc define else endif enum epack func global if ifdef ifndef include modcfunc modfunc modinit modterm module pack packopt regcmd runtime undef usecom uselib'
      },
      contains: [hljs.inherit(hljs.QUOTE_STRING_MODE, {
        className: 'meta-string'
      }), hljs.NUMBER_MODE, hljs.C_NUMBER_MODE, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE]
    }, {
      // label
      className: 'symbol',
      begin: '^\\*(\\w+|@)'
    }, hljs.NUMBER_MODE, hljs.C_NUMBER_MODE]
  };
}
module.exports = hsp;

/***/ }),

/***/ 3598:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(68309);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function anyNumberOfTimes(re) {
  return concat('(', re, ')*');
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function optional(re) {
  return concat('(', re, ')?');
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */
function either() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var joined = '(' + args.map(function (x) {
    return source(x);
  }).join("|") + ")";
  return joined;
}

/*
Language: Handlebars
Requires: xml.js
Author: Robin Ward <robin.ward@gmail.com>
Description: Matcher for Handlebars as well as EmberJS additions.
Website: https://handlebarsjs.com
Category: template
*/

function handlebars(hljs) {
  var BUILT_INS = {
    'builtin-name': ['action', 'bindattr', 'collection', 'component', 'concat', 'debugger', 'each', 'each-in', 'get', 'hash', 'if', 'in', 'input', 'link-to', 'loc', 'log', 'lookup', 'mut', 'outlet', 'partial', 'query-params', 'render', 'template', 'textarea', 'unbound', 'unless', 'view', 'with', 'yield']
  };
  var LITERALS = {
    literal: ['true', 'false', 'undefined', 'null']
  };

  // as defined in https://handlebarsjs.com/guide/expressions.html#literal-segments
  // this regex matches literal segments like ' abc ' or [ abc ] as well as helpers and paths
  // like a/b, ./abc/cde, and abc.bcd

  var DOUBLE_QUOTED_ID_REGEX = /""|"[^"]+"/;
  var SINGLE_QUOTED_ID_REGEX = /''|'[^']+'/;
  var BRACKET_QUOTED_ID_REGEX = /\[\]|\[[^\]]+\]/;
  var PLAIN_ID_REGEX = /[^\s!"#%&'()*+,.\/;<=>@\[\\\]^`{|}~]+/;
  var PATH_DELIMITER_REGEX = /(\.|\/)/;
  var ANY_ID = either(DOUBLE_QUOTED_ID_REGEX, SINGLE_QUOTED_ID_REGEX, BRACKET_QUOTED_ID_REGEX, PLAIN_ID_REGEX);
  var IDENTIFIER_REGEX = concat(optional(/\.|\.\/|\//),
  // relative or absolute path
  ANY_ID, anyNumberOfTimes(concat(PATH_DELIMITER_REGEX, ANY_ID)));

  // identifier followed by a equal-sign (without the equal sign)
  var HASH_PARAM_REGEX = concat('(', BRACKET_QUOTED_ID_REGEX, '|', PLAIN_ID_REGEX, ')(?==)');
  var HELPER_NAME_OR_PATH_EXPRESSION = {
    begin: IDENTIFIER_REGEX,
    lexemes: /[\w.\/]+/
  };
  var HELPER_PARAMETER = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
    keywords: LITERALS
  });
  var SUB_EXPRESSION = {
    begin: /\(/,
    end: /\)/
    // the "contains" is added below when all necessary sub-modes are defined
  };

  var HASH = {
    // fka "attribute-assignment", parameters of the form 'key=value'
    className: 'attr',
    begin: HASH_PARAM_REGEX,
    relevance: 0,
    starts: {
      begin: /=/,
      end: /=/,
      starts: {
        contains: [hljs.NUMBER_MODE, hljs.QUOTE_STRING_MODE, hljs.APOS_STRING_MODE, HELPER_PARAMETER, SUB_EXPRESSION]
      }
    }
  };
  var BLOCK_PARAMS = {
    // parameters of the form '{{#with x as | y |}}...{{/with}}'
    begin: /as\s+\|/,
    keywords: {
      keyword: 'as'
    },
    end: /\|/,
    contains: [{
      // define sub-mode in order to prevent highlighting of block-parameter named "as"
      begin: /\w+/
    }]
  };
  var HELPER_PARAMETERS = {
    contains: [hljs.NUMBER_MODE, hljs.QUOTE_STRING_MODE, hljs.APOS_STRING_MODE, BLOCK_PARAMS, HASH, HELPER_PARAMETER, SUB_EXPRESSION],
    returnEnd: true
    // the property "end" is defined through inheritance when the mode is used. If depends
    // on the surrounding mode, but "endsWithParent" does not work here (i.e. it includes the
    // end-token of the surrounding mode)
  };

  var SUB_EXPRESSION_CONTENTS = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
    className: 'name',
    keywords: BUILT_INS,
    starts: hljs.inherit(HELPER_PARAMETERS, {
      end: /\)/
    })
  });
  SUB_EXPRESSION.contains = [SUB_EXPRESSION_CONTENTS];
  var OPENING_BLOCK_MUSTACHE_CONTENTS = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
    keywords: BUILT_INS,
    className: 'name',
    starts: hljs.inherit(HELPER_PARAMETERS, {
      end: /\}\}/
    })
  });
  var CLOSING_BLOCK_MUSTACHE_CONTENTS = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
    keywords: BUILT_INS,
    className: 'name'
  });
  var BASIC_MUSTACHE_CONTENTS = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
    className: 'name',
    keywords: BUILT_INS,
    starts: hljs.inherit(HELPER_PARAMETERS, {
      end: /\}\}/
    })
  });
  var ESCAPE_MUSTACHE_WITH_PRECEEDING_BACKSLASH = {
    begin: /\\\{\{/,
    skip: true
  };
  var PREVENT_ESCAPE_WITH_ANOTHER_PRECEEDING_BACKSLASH = {
    begin: /\\\\(?=\{\{)/,
    skip: true
  };
  return {
    name: 'Handlebars',
    aliases: ['hbs', 'html.hbs', 'html.handlebars', 'htmlbars'],
    case_insensitive: true,
    subLanguage: 'xml',
    contains: [ESCAPE_MUSTACHE_WITH_PRECEEDING_BACKSLASH, PREVENT_ESCAPE_WITH_ANOTHER_PRECEEDING_BACKSLASH, hljs.COMMENT(/\{\{!--/, /--\}\}/), hljs.COMMENT(/\{\{!/, /\}\}/), {
      // open raw block "{{{{raw}}}} content not evaluated {{{{/raw}}}}"
      className: 'template-tag',
      begin: /\{\{\{\{(?!\/)/,
      end: /\}\}\}\}/,
      contains: [OPENING_BLOCK_MUSTACHE_CONTENTS],
      starts: {
        end: /\{\{\{\{\//,
        returnEnd: true,
        subLanguage: 'xml'
      }
    }, {
      // close raw block
      className: 'template-tag',
      begin: /\{\{\{\{\//,
      end: /\}\}\}\}/,
      contains: [CLOSING_BLOCK_MUSTACHE_CONTENTS]
    }, {
      // open block statement
      className: 'template-tag',
      begin: /\{\{#/,
      end: /\}\}/,
      contains: [OPENING_BLOCK_MUSTACHE_CONTENTS]
    }, {
      className: 'template-tag',
      begin: /\{\{(?=else\}\})/,
      end: /\}\}/,
      keywords: 'else'
    }, {
      className: 'template-tag',
      begin: /\{\{(?=else if)/,
      end: /\}\}/,
      keywords: 'else if'
    }, {
      // closing block statement
      className: 'template-tag',
      begin: /\{\{\//,
      end: /\}\}/,
      contains: [CLOSING_BLOCK_MUSTACHE_CONTENTS]
    }, {
      // template variable or helper-call that is NOT html-escaped
      className: 'template-variable',
      begin: /\{\{\{/,
      end: /\}\}\}/,
      contains: [BASIC_MUSTACHE_CONTENTS]
    }, {
      // template variable or helper-call that is html-escaped
      className: 'template-variable',
      begin: /\{\{/,
      end: /\}\}/,
      contains: [BASIC_MUSTACHE_CONTENTS]
    }]
  };
}

/*
 Language: HTMLBars (legacy)
 Requires: xml.js
 Description: Matcher for Handlebars as well as EmberJS additions.
 Website: https://github.com/tildeio/htmlbars
 Category: template
 */

function htmlbars(hljs) {
  var definition = handlebars(hljs);
  definition.name = "HTMLbars";

  // HACK: This lets handlebars do the auto-detection if it's been loaded (by
  // default the build script will load in alphabetical order) and if not (perhaps
  // an install is only using `htmlbars`, not `handlebars`) then this will still
  // allow HTMLBars to participate in the auto-detection

  // worse case someone will have HTMLbars and handlebars competing for the same
  // content and will need to change their setup to only require handlebars, but
  // I don't consider this a breaking change
  if (hljs.getLanguage("handlebars")) {
    definition.disableAutodetect = true;
  }
  return definition;
}
module.exports = htmlbars;

/***/ }),

/***/ 12183:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/*
Language: HTTP
Description: HTTP request and response headers with automatic body highlighting
Author: Ivan Sagalaev <maniac@softwaremaniacs.org>
Category: common, protocols
Website: https://developer.mozilla.org/en-US/docs/Web/HTTP/Overview
*/

function http(hljs) {
  var VERSION = 'HTTP/(2|1\\.[01])';
  var HEADER_NAME = /[A-Za-z][A-Za-z0-9-]*/;
  var HEADER = {
    className: 'attribute',
    begin: concat('^', HEADER_NAME, '(?=\\:\\s)'),
    starts: {
      contains: [{
        className: "punctuation",
        begin: /: /,
        relevance: 0,
        starts: {
          end: '$',
          relevance: 0
        }
      }]
    }
  };
  var HEADERS_AND_BODY = [HEADER, {
    begin: '\\n\\n',
    starts: {
      subLanguage: [],
      endsWithParent: true
    }
  }];
  return {
    name: 'HTTP',
    aliases: ['https'],
    illegal: /\S/,
    contains: [
    // response
    {
      begin: '^(?=' + VERSION + " \\d{3})",
      end: /$/,
      contains: [{
        className: "meta",
        begin: VERSION
      }, {
        className: 'number',
        begin: '\\b\\d{3}\\b'
      }],
      starts: {
        end: /\b\B/,
        illegal: /\S/,
        contains: HEADERS_AND_BODY
      }
    },
    // request
    {
      begin: '(?=^[A-Z]+ (.*?) ' + VERSION + '$)',
      end: /$/,
      contains: [{
        className: 'string',
        begin: ' ',
        end: ' ',
        excludeBegin: true,
        excludeEnd: true
      }, {
        className: "meta",
        begin: VERSION
      }, {
        className: 'keyword',
        begin: '[A-Z]+'
      }],
      starts: {
        end: /\b\B/,
        illegal: /\S/,
        contains: HEADERS_AND_BODY
      }
    },
    // to allow headers to work even without a preamble
    hljs.inherit(HEADER, {
      relevance: 0
    })]
  };
}
module.exports = http;

/***/ }),

/***/ 95035:
/***/ ((module) => {

/*
Language: Hy
Description: Hy is a wonderful dialect of Lisp that’s embedded in Python.
Author: Sergey Sobko <s.sobko@profitware.ru>
Website: http://docs.hylang.org/en/stable/
Category: lisp
*/

function hy(hljs) {
  var SYMBOLSTART = 'a-zA-Z_\\-!.?+*=<>&#\'';
  var SYMBOL_RE = '[' + SYMBOLSTART + '][' + SYMBOLSTART + '0-9/;:]*';
  var keywords = {
    $pattern: SYMBOL_RE,
    'builtin-name':
    // keywords
    '!= % %= & &= * ** **= *= *map ' + '+ += , --build-class-- --import-- -= . / // //= ' + '/= < << <<= <= = > >= >> >>= ' + '@ @= ^ ^= abs accumulate all and any ap-compose ' + 'ap-dotimes ap-each ap-each-while ap-filter ap-first ap-if ap-last ap-map ap-map-when ap-pipe ' + 'ap-reduce ap-reject apply as-> ascii assert assoc bin break butlast ' + 'callable calling-module-name car case cdr chain chr coll? combinations compile ' + 'compress cond cons cons? continue count curry cut cycle dec ' + 'def default-method defclass defmacro defmacro-alias defmacro/g! defmain defmethod defmulti defn ' + 'defn-alias defnc defnr defreader defseq del delattr delete-route dict-comp dir ' + 'disassemble dispatch-reader-macro distinct divmod do doto drop drop-last drop-while empty? ' + 'end-sequence eval eval-and-compile eval-when-compile even? every? except exec filter first ' + 'flatten float? fn fnc fnr for for* format fraction genexpr ' + 'gensym get getattr global globals group-by hasattr hash hex id ' + 'identity if if* if-not if-python2 import in inc input instance? ' + 'integer integer-char? integer? interleave interpose is is-coll is-cons is-empty is-even ' + 'is-every is-float is-instance is-integer is-integer-char is-iterable is-iterator is-keyword is-neg is-none ' + 'is-not is-numeric is-odd is-pos is-string is-symbol is-zero isinstance islice issubclass ' + 'iter iterable? iterate iterator? keyword keyword? lambda last len let ' + 'lif lif-not list* list-comp locals loop macro-error macroexpand macroexpand-1 macroexpand-all ' + 'map max merge-with method-decorator min multi-decorator multicombinations name neg? next ' + 'none? nonlocal not not-in not? nth numeric? oct odd? open ' + 'or ord partition permutations pos? post-route postwalk pow prewalk print ' + 'product profile/calls profile/cpu put-route quasiquote quote raise range read read-str ' + 'recursive-replace reduce remove repeat repeatedly repr require rest round route ' + 'route-with-methods rwm second seq set-comp setattr setv some sorted string ' + 'string? sum switch symbol? take take-nth take-while tee try unless ' + 'unquote unquote-splicing vars walk when while with with* with-decorator with-gensyms ' + 'xi xor yield yield-from zero? zip zip-longest | |= ~'
  };
  var SIMPLE_NUMBER_RE = '[-+]?\\d+(\\.\\d+)?';
  var SYMBOL = {
    begin: SYMBOL_RE,
    relevance: 0
  };
  var NUMBER = {
    className: 'number',
    begin: SIMPLE_NUMBER_RE,
    relevance: 0
  };
  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {
    illegal: null
  });
  var COMMENT = hljs.COMMENT(';', '$', {
    relevance: 0
  });
  var LITERAL = {
    className: 'literal',
    begin: /\b([Tt]rue|[Ff]alse|nil|None)\b/
  };
  var COLLECTION = {
    begin: '[\\[\\{]',
    end: '[\\]\\}]'
  };
  var HINT = {
    className: 'comment',
    begin: '\\^' + SYMBOL_RE
  };
  var HINT_COL = hljs.COMMENT('\\^\\{', '\\}');
  var KEY = {
    className: 'symbol',
    begin: '[:]{1,2}' + SYMBOL_RE
  };
  var LIST = {
    begin: '\\(',
    end: '\\)'
  };
  var BODY = {
    endsWithParent: true,
    relevance: 0
  };
  var NAME = {
    className: 'name',
    relevance: 0,
    keywords: keywords,
    begin: SYMBOL_RE,
    starts: BODY
  };
  var DEFAULT_CONTAINS = [LIST, STRING, HINT, HINT_COL, COMMENT, KEY, COLLECTION, NUMBER, LITERAL, SYMBOL];
  LIST.contains = [hljs.COMMENT('comment', ''), NAME, BODY];
  BODY.contains = DEFAULT_CONTAINS;
  COLLECTION.contains = DEFAULT_CONTAINS;
  return {
    name: 'Hy',
    aliases: ['hylang'],
    illegal: /\S/,
    contains: [hljs.SHEBANG(), LIST, STRING, HINT, HINT_COL, COMMENT, KEY, COLLECTION, NUMBER, LITERAL]
  };
}
module.exports = hy;

/***/ }),

/***/ 9171:
/***/ ((module) => {

/*
Language: Inform 7
Author: Bruno Dias <bruno.r.dias@gmail.com>
Description: Language definition for Inform 7, a DSL for writing parser interactive fiction.
Website: http://inform7.com
*/

function inform7(hljs) {
  var START_BRACKET = '\\[';
  var END_BRACKET = '\\]';
  return {
    name: 'Inform 7',
    aliases: ['i7'],
    case_insensitive: true,
    keywords: {
      // Some keywords more or less unique to I7, for relevance.
      keyword:
      // kind:
      'thing room person man woman animal container ' + 'supporter backdrop door ' +
      // characteristic:
      'scenery open closed locked inside gender ' +
      // verb:
      'is are say understand ' +
      // misc keyword:
      'kind of rule'
    },
    contains: [{
      className: 'string',
      begin: '"',
      end: '"',
      relevance: 0,
      contains: [{
        className: 'subst',
        begin: START_BRACKET,
        end: END_BRACKET
      }]
    }, {
      className: 'section',
      begin: /^(Volume|Book|Part|Chapter|Section|Table)\b/,
      end: '$'
    }, {
      // Rule definition
      // This is here for relevance.
      begin: /^(Check|Carry out|Report|Instead of|To|Rule|When|Before|After)\b/,
      end: ':',
      contains: [{
        // Rule name
        begin: '\\(This',
        end: '\\)'
      }]
    }, {
      className: 'comment',
      begin: START_BRACKET,
      end: END_BRACKET,
      contains: ['self']
    }]
  };
}
module.exports = inform7;

/***/ }),

/***/ 97970:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function lookahead(re) {
  return concat('(?=', re, ')');
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */
function either() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var joined = '(' + args.map(function (x) {
    return source(x);
  }).join("|") + ")";
  return joined;
}

/*
Language: TOML, also INI
Description: TOML aims to be a minimal configuration file format that's easy to read due to obvious semantics.
Contributors: Guillaume Gomez <guillaume1.gomez@gmail.com>
Category: common, config
Website: https://github.com/toml-lang/toml
*/

function ini(hljs) {
  var NUMBERS = {
    className: 'number',
    relevance: 0,
    variants: [{
      begin: /([+-]+)?[\d]+_[\d_]+/
    }, {
      begin: hljs.NUMBER_RE
    }]
  };
  var COMMENTS = hljs.COMMENT();
  COMMENTS.variants = [{
    begin: /;/,
    end: /$/
  }, {
    begin: /#/,
    end: /$/
  }];
  var VARIABLES = {
    className: 'variable',
    variants: [{
      begin: /\$[\w\d"][\w\d_]*/
    }, {
      begin: /\$\{(.*?)\}/
    }]
  };
  var LITERALS = {
    className: 'literal',
    begin: /\bon|off|true|false|yes|no\b/
  };
  var STRINGS = {
    className: "string",
    contains: [hljs.BACKSLASH_ESCAPE],
    variants: [{
      begin: "'''",
      end: "'''",
      relevance: 10
    }, {
      begin: '"""',
      end: '"""',
      relevance: 10
    }, {
      begin: '"',
      end: '"'
    }, {
      begin: "'",
      end: "'"
    }]
  };
  var ARRAY = {
    begin: /\[/,
    end: /\]/,
    contains: [COMMENTS, LITERALS, VARIABLES, STRINGS, NUMBERS, 'self'],
    relevance: 0
  };
  var BARE_KEY = /[A-Za-z0-9_-]+/;
  var QUOTED_KEY_DOUBLE_QUOTE = /"(\\"|[^"])*"/;
  var QUOTED_KEY_SINGLE_QUOTE = /'[^']*'/;
  var ANY_KEY = either(BARE_KEY, QUOTED_KEY_DOUBLE_QUOTE, QUOTED_KEY_SINGLE_QUOTE);
  var DOTTED_KEY = concat(ANY_KEY, '(\\s*\\.\\s*', ANY_KEY, ')*', lookahead(/\s*=\s*[^#\s]/));
  return {
    name: 'TOML, also INI',
    aliases: ['toml'],
    case_insensitive: true,
    illegal: /\S/,
    contains: [COMMENTS, {
      className: 'section',
      begin: /\[+/,
      end: /\]+/
    }, {
      begin: DOTTED_KEY,
      className: 'attr',
      starts: {
        end: /$/,
        contains: [COMMENTS, ARRAY, LITERALS, VARIABLES, STRINGS, NUMBERS]
      }
    }]
  };
}
module.exports = ini;

/***/ }),

/***/ 89612:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/*
Language: IRPF90
Author: Anthony Scemama <scemama@irsamc.ups-tlse.fr>
Description: IRPF90 is an open-source Fortran code generator
Website: http://irpf90.ups-tlse.fr
Category: scientific
*/

/** @type LanguageFn */
function irpf90(hljs) {
  var PARAMS = {
    className: 'params',
    begin: '\\(',
    end: '\\)'
  };

  // regex in both fortran and irpf90 should match
  var OPTIONAL_NUMBER_SUFFIX = /(_[a-z_\d]+)?/;
  var OPTIONAL_NUMBER_EXP = /([de][+-]?\d+)?/;
  var NUMBER = {
    className: 'number',
    variants: [{
      begin: concat(/\b\d+/, /\.(\d*)/, OPTIONAL_NUMBER_EXP, OPTIONAL_NUMBER_SUFFIX)
    }, {
      begin: concat(/\b\d+/, OPTIONAL_NUMBER_EXP, OPTIONAL_NUMBER_SUFFIX)
    }, {
      begin: concat(/\.\d+/, OPTIONAL_NUMBER_EXP, OPTIONAL_NUMBER_SUFFIX)
    }],
    relevance: 0
  };
  var F_KEYWORDS = {
    literal: '.False. .True.',
    keyword: 'kind do while private call intrinsic where elsewhere ' + 'type endtype endmodule endselect endinterface end enddo endif if forall endforall only contains default return stop then ' + 'public subroutine|10 function program .and. .or. .not. .le. .eq. .ge. .gt. .lt. ' + 'goto save else use module select case ' + 'access blank direct exist file fmt form formatted iostat name named nextrec number opened rec recl sequential status unformatted unit ' + 'continue format pause cycle exit ' + 'c_null_char c_alert c_backspace c_form_feed flush wait decimal round iomsg ' + 'synchronous nopass non_overridable pass protected volatile abstract extends import ' + 'non_intrinsic value deferred generic final enumerator class associate bind enum ' + 'c_int c_short c_long c_long_long c_signed_char c_size_t c_int8_t c_int16_t c_int32_t c_int64_t c_int_least8_t c_int_least16_t ' + 'c_int_least32_t c_int_least64_t c_int_fast8_t c_int_fast16_t c_int_fast32_t c_int_fast64_t c_intmax_t C_intptr_t c_float c_double ' + 'c_long_double c_float_complex c_double_complex c_long_double_complex c_bool c_char c_null_ptr c_null_funptr ' + 'c_new_line c_carriage_return c_horizontal_tab c_vertical_tab iso_c_binding c_loc c_funloc c_associated  c_f_pointer ' + 'c_ptr c_funptr iso_fortran_env character_storage_size error_unit file_storage_size input_unit iostat_end iostat_eor ' + 'numeric_storage_size output_unit c_f_procpointer ieee_arithmetic ieee_support_underflow_control ' + 'ieee_get_underflow_mode ieee_set_underflow_mode newunit contiguous recursive ' + 'pad position action delim readwrite eor advance nml interface procedure namelist include sequence elemental pure ' + 'integer real character complex logical dimension allocatable|10 parameter ' + 'external implicit|10 none double precision assign intent optional pointer ' + 'target in out common equivalence data ' +
    // IRPF90 special keywords
    'begin_provider &begin_provider end_provider begin_shell end_shell begin_template end_template subst assert touch ' + 'soft_touch provide no_dep free irp_if irp_else irp_endif irp_write irp_read',
    built_in: 'alog alog10 amax0 amax1 amin0 amin1 amod cabs ccos cexp clog csin csqrt dabs dacos dasin datan datan2 dcos dcosh ddim dexp dint ' + 'dlog dlog10 dmax1 dmin1 dmod dnint dsign dsin dsinh dsqrt dtan dtanh float iabs idim idint idnint ifix isign max0 max1 min0 min1 sngl ' + 'algama cdabs cdcos cdexp cdlog cdsin cdsqrt cqabs cqcos cqexp cqlog cqsin cqsqrt dcmplx dconjg derf derfc dfloat dgamma dimag dlgama ' + 'iqint qabs qacos qasin qatan qatan2 qcmplx qconjg qcos qcosh qdim qerf qerfc qexp qgamma qimag qlgama qlog qlog10 qmax1 qmin1 qmod ' + 'qnint qsign qsin qsinh qsqrt qtan qtanh abs acos aimag aint anint asin atan atan2 char cmplx conjg cos cosh exp ichar index int log ' + 'log10 max min nint sign sin sinh sqrt tan tanh print write dim lge lgt lle llt mod nullify allocate deallocate ' + 'adjustl adjustr all allocated any associated bit_size btest ceiling count cshift date_and_time digits dot_product ' + 'eoshift epsilon exponent floor fraction huge iand ibclr ibits ibset ieor ior ishft ishftc lbound len_trim matmul ' + 'maxexponent maxloc maxval merge minexponent minloc minval modulo mvbits nearest pack present product ' + 'radix random_number random_seed range repeat reshape rrspacing scale scan selected_int_kind selected_real_kind ' + 'set_exponent shape size spacing spread sum system_clock tiny transpose trim ubound unpack verify achar iachar transfer ' + 'dble entry dprod cpu_time command_argument_count get_command get_command_argument get_environment_variable is_iostat_end ' + 'ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode ' + 'is_iostat_eor move_alloc new_line selected_char_kind same_type_as extends_type_of ' + 'acosh asinh atanh bessel_j0 bessel_j1 bessel_jn bessel_y0 bessel_y1 bessel_yn erf erfc erfc_scaled gamma log_gamma hypot norm2 ' + 'atomic_define atomic_ref execute_command_line leadz trailz storage_size merge_bits ' + 'bge bgt ble blt dshiftl dshiftr findloc iall iany iparity image_index lcobound ucobound maskl maskr ' + 'num_images parity popcnt poppar shifta shiftl shiftr this_image ' +
    // IRPF90 special built_ins
    'IRP_ALIGN irp_here'
  };
  return {
    name: 'IRPF90',
    case_insensitive: true,
    keywords: F_KEYWORDS,
    illegal: /\/\*/,
    contains: [hljs.inherit(hljs.APOS_STRING_MODE, {
      className: 'string',
      relevance: 0
    }), hljs.inherit(hljs.QUOTE_STRING_MODE, {
      className: 'string',
      relevance: 0
    }), {
      className: 'function',
      beginKeywords: 'subroutine function program',
      illegal: '[${=\\n]',
      contains: [hljs.UNDERSCORE_TITLE_MODE, PARAMS]
    }, hljs.COMMENT('!', '$', {
      relevance: 0
    }), hljs.COMMENT('begin_doc', 'end_doc', {
      relevance: 10
    }), NUMBER]
  };
}
module.exports = irpf90;

/***/ }),

/***/ 16236:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(73210);
/*
Language: ISBL
Author: Dmitriy Tarasov <dimatar@gmail.com>
Description: built-in language DIRECTUM
Category: enterprise
*/

function isbl(hljs) {
  // Определение идентификаторов
  var UNDERSCORE_IDENT_RE = "[A-Za-zА-Яа-яёЁ_!][A-Za-zА-Яа-яёЁ_0-9]*";

  // Определение имен функций
  var FUNCTION_NAME_IDENT_RE = "[A-Za-zА-Яа-яёЁ_][A-Za-zА-Яа-яёЁ_0-9]*";

  // keyword : ключевые слова
  var KEYWORD = "and и else иначе endexcept endfinally endforeach конецвсе endif конецесли endwhile конецпока " + "except exitfor finally foreach все if если in в not не or или try while пока ";

  // SYSRES Constants
  var sysres_constants = "SYSRES_CONST_ACCES_RIGHT_TYPE_EDIT " + "SYSRES_CONST_ACCES_RIGHT_TYPE_FULL " + "SYSRES_CONST_ACCES_RIGHT_TYPE_VIEW " + "SYSRES_CONST_ACCESS_MODE_REQUISITE_CODE " + "SYSRES_CONST_ACCESS_NO_ACCESS_VIEW " + "SYSRES_CONST_ACCESS_NO_ACCESS_VIEW_CODE " + "SYSRES_CONST_ACCESS_RIGHTS_ADD_REQUISITE_CODE " + "SYSRES_CONST_ACCESS_RIGHTS_ADD_REQUISITE_YES_CODE " + "SYSRES_CONST_ACCESS_RIGHTS_CHANGE_REQUISITE_CODE " + "SYSRES_CONST_ACCESS_RIGHTS_CHANGE_REQUISITE_YES_CODE " + "SYSRES_CONST_ACCESS_RIGHTS_DELETE_REQUISITE_CODE " + "SYSRES_CONST_ACCESS_RIGHTS_DELETE_REQUISITE_YES_CODE " + "SYSRES_CONST_ACCESS_RIGHTS_EXECUTE_REQUISITE_CODE " + "SYSRES_CONST_ACCESS_RIGHTS_EXECUTE_REQUISITE_YES_CODE " + "SYSRES_CONST_ACCESS_RIGHTS_NO_ACCESS_REQUISITE_CODE " + "SYSRES_CONST_ACCESS_RIGHTS_NO_ACCESS_REQUISITE_YES_CODE " + "SYSRES_CONST_ACCESS_RIGHTS_RATIFY_REQUISITE_CODE " + "SYSRES_CONST_ACCESS_RIGHTS_RATIFY_REQUISITE_YES_CODE " + "SYSRES_CONST_ACCESS_RIGHTS_REQUISITE_CODE " + "SYSRES_CONST_ACCESS_RIGHTS_VIEW " + "SYSRES_CONST_ACCESS_RIGHTS_VIEW_CODE " + "SYSRES_CONST_ACCESS_RIGHTS_VIEW_REQUISITE_CODE " + "SYSRES_CONST_ACCESS_RIGHTS_VIEW_REQUISITE_YES_CODE " + "SYSRES_CONST_ACCESS_TYPE_CHANGE " + "SYSRES_CONST_ACCESS_TYPE_CHANGE_CODE " + "SYSRES_CONST_ACCESS_TYPE_EXISTS " + "SYSRES_CONST_ACCESS_TYPE_EXISTS_CODE " + "SYSRES_CONST_ACCESS_TYPE_FULL " + "SYSRES_CONST_ACCESS_TYPE_FULL_CODE " + "SYSRES_CONST_ACCESS_TYPE_VIEW " + "SYSRES_CONST_ACCESS_TYPE_VIEW_CODE " + "SYSRES_CONST_ACTION_TYPE_ABORT " + "SYSRES_CONST_ACTION_TYPE_ACCEPT " + "SYSRES_CONST_ACTION_TYPE_ACCESS_RIGHTS " + "SYSRES_CONST_ACTION_TYPE_ADD_ATTACHMENT " + "SYSRES_CONST_ACTION_TYPE_CHANGE_CARD " + "SYSRES_CONST_ACTION_TYPE_CHANGE_KIND " + "SYSRES_CONST_ACTION_TYPE_CHANGE_STORAGE " + "SYSRES_CONST_ACTION_TYPE_CONTINUE " + "SYSRES_CONST_ACTION_TYPE_COPY " + "SYSRES_CONST_ACTION_TYPE_CREATE " + "SYSRES_CONST_ACTION_TYPE_CREATE_VERSION " + "SYSRES_CONST_ACTION_TYPE_DELETE " + "SYSRES_CONST_ACTION_TYPE_DELETE_ATTACHMENT " + "SYSRES_CONST_ACTION_TYPE_DELETE_VERSION " + "SYSRES_CONST_ACTION_TYPE_DISABLE_DELEGATE_ACCESS_RIGHTS " + "SYSRES_CONST_ACTION_TYPE_ENABLE_DELEGATE_ACCESS_RIGHTS " + "SYSRES_CONST_ACTION_TYPE_ENCRYPTION_BY_CERTIFICATE " + "SYSRES_CONST_ACTION_TYPE_ENCRYPTION_BY_CERTIFICATE_AND_PASSWORD " + "SYSRES_CONST_ACTION_TYPE_ENCRYPTION_BY_PASSWORD " + "SYSRES_CONST_ACTION_TYPE_EXPORT_WITH_LOCK " + "SYSRES_CONST_ACTION_TYPE_EXPORT_WITHOUT_LOCK " + "SYSRES_CONST_ACTION_TYPE_IMPORT_WITH_UNLOCK " + "SYSRES_CONST_ACTION_TYPE_IMPORT_WITHOUT_UNLOCK " + "SYSRES_CONST_ACTION_TYPE_LIFE_CYCLE_STAGE " + "SYSRES_CONST_ACTION_TYPE_LOCK " + "SYSRES_CONST_ACTION_TYPE_LOCK_FOR_SERVER " + "SYSRES_CONST_ACTION_TYPE_LOCK_MODIFY " + "SYSRES_CONST_ACTION_TYPE_MARK_AS_READED " + "SYSRES_CONST_ACTION_TYPE_MARK_AS_UNREADED " + "SYSRES_CONST_ACTION_TYPE_MODIFY " + "SYSRES_CONST_ACTION_TYPE_MODIFY_CARD " + "SYSRES_CONST_ACTION_TYPE_MOVE_TO_ARCHIVE " + "SYSRES_CONST_ACTION_TYPE_OFF_ENCRYPTION " + "SYSRES_CONST_ACTION_TYPE_PASSWORD_CHANGE " + "SYSRES_CONST_ACTION_TYPE_PERFORM " + "SYSRES_CONST_ACTION_TYPE_RECOVER_FROM_LOCAL_COPY " + "SYSRES_CONST_ACTION_TYPE_RESTART " + "SYSRES_CONST_ACTION_TYPE_RESTORE_FROM_ARCHIVE " + "SYSRES_CONST_ACTION_TYPE_REVISION " + "SYSRES_CONST_ACTION_TYPE_SEND_BY_MAIL " + "SYSRES_CONST_ACTION_TYPE_SIGN " + "SYSRES_CONST_ACTION_TYPE_START " + "SYSRES_CONST_ACTION_TYPE_UNLOCK " + "SYSRES_CONST_ACTION_TYPE_UNLOCK_FROM_SERVER " + "SYSRES_CONST_ACTION_TYPE_VERSION_STATE " + "SYSRES_CONST_ACTION_TYPE_VERSION_VISIBILITY " + "SYSRES_CONST_ACTION_TYPE_VIEW " + "SYSRES_CONST_ACTION_TYPE_VIEW_SHADOW_COPY " + "SYSRES_CONST_ACTION_TYPE_WORKFLOW_DESCRIPTION_MODIFY " + "SYSRES_CONST_ACTION_TYPE_WRITE_HISTORY " + "SYSRES_CONST_ACTIVE_VERSION_STATE_PICK_VALUE " + "SYSRES_CONST_ADD_REFERENCE_MODE_NAME " + "SYSRES_CONST_ADDITION_REQUISITE_CODE " + "SYSRES_CONST_ADDITIONAL_PARAMS_REQUISITE_CODE " + "SYSRES_CONST_ADITIONAL_JOB_END_DATE_REQUISITE_NAME " + "SYSRES_CONST_ADITIONAL_JOB_READ_REQUISITE_NAME " + "SYSRES_CONST_ADITIONAL_JOB_START_DATE_REQUISITE_NAME " + "SYSRES_CONST_ADITIONAL_JOB_STATE_REQUISITE_NAME " + "SYSRES_CONST_ADMINISTRATION_HISTORY_ADDING_USER_TO_GROUP_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_ADDING_USER_TO_GROUP_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_COMP_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_COMP_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_GROUP_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_GROUP_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_USER_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_USER_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_CREATION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_CREATION_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_DELETION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_DELETION_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_COMP_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_COMP_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_GROUP_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_GROUP_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_FROM_GROUP_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_FROM_GROUP_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_RESTRICTION_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_RESTRICTION_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_PRIVILEGE_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_PRIVILEGE_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_RIGHTS_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_RIGHTS_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_IS_MAIN_SERVER_CHANGED_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_IS_MAIN_SERVER_CHANGED_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_IS_PUBLIC_CHANGED_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_IS_PUBLIC_CHANGED_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_RESTRICTION_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_RESTRICTION_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_PRIVILEGE_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_PRIVILEGE_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_RIGHTS_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_RIGHTS_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_CREATION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_CREATION_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_DELETION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_DELETION_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_CATEGORY_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_CATEGORY_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_COMP_TITLE_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_COMP_TITLE_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_FULL_NAME_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_FULL_NAME_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_GROUP_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_GROUP_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_PARENT_GROUP_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_PARENT_GROUP_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_AUTH_TYPE_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_AUTH_TYPE_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_LOGIN_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_LOGIN_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_STATUS_ACTION " + "SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_STATUS_ACTION_CODE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_USER_PASSWORD_CHANGE " + "SYSRES_CONST_ADMINISTRATION_HISTORY_USER_PASSWORD_CHANGE_ACTION " + "SYSRES_CONST_ALL_ACCEPT_CONDITION_RUS " + "SYSRES_CONST_ALL_USERS_GROUP " + "SYSRES_CONST_ALL_USERS_GROUP_NAME " + "SYSRES_CONST_ALL_USERS_SERVER_GROUP_NAME " + "SYSRES_CONST_ALLOWED_ACCESS_TYPE_CODE " + "SYSRES_CONST_ALLOWED_ACCESS_TYPE_NAME " + "SYSRES_CONST_APP_VIEWER_TYPE_REQUISITE_CODE " + "SYSRES_CONST_APPROVING_SIGNATURE_NAME " + "SYSRES_CONST_APPROVING_SIGNATURE_REQUISITE_CODE " + "SYSRES_CONST_ASSISTANT_SUBSTITUE_TYPE " + "SYSRES_CONST_ASSISTANT_SUBSTITUE_TYPE_CODE " + "SYSRES_CONST_ATTACH_TYPE_COMPONENT_TOKEN " + "SYSRES_CONST_ATTACH_TYPE_DOC " + "SYSRES_CONST_ATTACH_TYPE_EDOC " + "SYSRES_CONST_ATTACH_TYPE_FOLDER " + "SYSRES_CONST_ATTACH_TYPE_JOB " + "SYSRES_CONST_ATTACH_TYPE_REFERENCE " + "SYSRES_CONST_ATTACH_TYPE_TASK " + "SYSRES_CONST_AUTH_ENCODED_PASSWORD " + "SYSRES_CONST_AUTH_ENCODED_PASSWORD_CODE " + "SYSRES_CONST_AUTH_NOVELL " + "SYSRES_CONST_AUTH_PASSWORD " + "SYSRES_CONST_AUTH_PASSWORD_CODE " + "SYSRES_CONST_AUTH_WINDOWS " + "SYSRES_CONST_AUTHENTICATING_SIGNATURE_NAME " + "SYSRES_CONST_AUTHENTICATING_SIGNATURE_REQUISITE_CODE " + "SYSRES_CONST_AUTO_ENUM_METHOD_FLAG " + "SYSRES_CONST_AUTO_NUMERATION_CODE " + "SYSRES_CONST_AUTO_STRONG_ENUM_METHOD_FLAG " + "SYSRES_CONST_AUTOTEXT_NAME_REQUISITE_CODE " + "SYSRES_CONST_AUTOTEXT_TEXT_REQUISITE_CODE " + "SYSRES_CONST_AUTOTEXT_USAGE_ALL " + "SYSRES_CONST_AUTOTEXT_USAGE_ALL_CODE " + "SYSRES_CONST_AUTOTEXT_USAGE_SIGN " + "SYSRES_CONST_AUTOTEXT_USAGE_SIGN_CODE " + "SYSRES_CONST_AUTOTEXT_USAGE_WORK " + "SYSRES_CONST_AUTOTEXT_USAGE_WORK_CODE " + "SYSRES_CONST_AUTOTEXT_USE_ANYWHERE_CODE " + "SYSRES_CONST_AUTOTEXT_USE_ON_SIGNING_CODE " + "SYSRES_CONST_AUTOTEXT_USE_ON_WORK_CODE " + "SYSRES_CONST_BEGIN_DATE_REQUISITE_CODE " + "SYSRES_CONST_BLACK_LIFE_CYCLE_STAGE_FONT_COLOR " + "SYSRES_CONST_BLUE_LIFE_CYCLE_STAGE_FONT_COLOR " + "SYSRES_CONST_BTN_PART " + "SYSRES_CONST_CALCULATED_ROLE_TYPE_CODE " + "SYSRES_CONST_CALL_TYPE_VARIABLE_BUTTON_VALUE " + "SYSRES_CONST_CALL_TYPE_VARIABLE_PROGRAM_VALUE " + "SYSRES_CONST_CANCEL_MESSAGE_FUNCTION_RESULT " + "SYSRES_CONST_CARD_PART " + "SYSRES_CONST_CARD_REFERENCE_MODE_NAME " + "SYSRES_CONST_CERTIFICATE_TYPE_REQUISITE_ENCRYPT_VALUE " + "SYSRES_CONST_CERTIFICATE_TYPE_REQUISITE_SIGN_AND_ENCRYPT_VALUE " + "SYSRES_CONST_CERTIFICATE_TYPE_REQUISITE_SIGN_VALUE " + "SYSRES_CONST_CHECK_PARAM_VALUE_DATE_PARAM_TYPE " + "SYSRES_CONST_CHECK_PARAM_VALUE_FLOAT_PARAM_TYPE " + "SYSRES_CONST_CHECK_PARAM_VALUE_INTEGER_PARAM_TYPE " + "SYSRES_CONST_CHECK_PARAM_VALUE_PICK_PARAM_TYPE " + "SYSRES_CONST_CHECK_PARAM_VALUE_REEFRENCE_PARAM_TYPE " + "SYSRES_CONST_CLOSED_RECORD_FLAG_VALUE_FEMININE " + "SYSRES_CONST_CLOSED_RECORD_FLAG_VALUE_MASCULINE " + "SYSRES_CONST_CODE_COMPONENT_TYPE_ADMIN " + "SYSRES_CONST_CODE_COMPONENT_TYPE_DEVELOPER " + "SYSRES_CONST_CODE_COMPONENT_TYPE_DOCS " + "SYSRES_CONST_CODE_COMPONENT_TYPE_EDOC_CARDS " + "SYSRES_CONST_CODE_COMPONENT_TYPE_EXTERNAL_EXECUTABLE " + "SYSRES_CONST_CODE_COMPONENT_TYPE_OTHER " + "SYSRES_CONST_CODE_COMPONENT_TYPE_REFERENCE " + "SYSRES_CONST_CODE_COMPONENT_TYPE_REPORT " + "SYSRES_CONST_CODE_COMPONENT_TYPE_SCRIPT " + "SYSRES_CONST_CODE_COMPONENT_TYPE_URL " + "SYSRES_CONST_CODE_REQUISITE_ACCESS " + "SYSRES_CONST_CODE_REQUISITE_CODE " + "SYSRES_CONST_CODE_REQUISITE_COMPONENT " + "SYSRES_CONST_CODE_REQUISITE_DESCRIPTION " + "SYSRES_CONST_CODE_REQUISITE_EXCLUDE_COMPONENT " + "SYSRES_CONST_CODE_REQUISITE_RECORD " + "SYSRES_CONST_COMMENT_REQ_CODE " + "SYSRES_CONST_COMMON_SETTINGS_REQUISITE_CODE " + "SYSRES_CONST_COMP_CODE_GRD " + "SYSRES_CONST_COMPONENT_GROUP_TYPE_REQUISITE_CODE " + "SYSRES_CONST_COMPONENT_TYPE_ADMIN_COMPONENTS " + "SYSRES_CONST_COMPONENT_TYPE_DEVELOPER_COMPONENTS " + "SYSRES_CONST_COMPONENT_TYPE_DOCS " + "SYSRES_CONST_COMPONENT_TYPE_EDOC_CARDS " + "SYSRES_CONST_COMPONENT_TYPE_EDOCS " + "SYSRES_CONST_COMPONENT_TYPE_EXTERNAL_EXECUTABLE " + "SYSRES_CONST_COMPONENT_TYPE_OTHER " + "SYSRES_CONST_COMPONENT_TYPE_REFERENCE_TYPES " + "SYSRES_CONST_COMPONENT_TYPE_REFERENCES " + "SYSRES_CONST_COMPONENT_TYPE_REPORTS " + "SYSRES_CONST_COMPONENT_TYPE_SCRIPTS " + "SYSRES_CONST_COMPONENT_TYPE_URL " + "SYSRES_CONST_COMPONENTS_REMOTE_SERVERS_VIEW_CODE " + "SYSRES_CONST_CONDITION_BLOCK_DESCRIPTION " + "SYSRES_CONST_CONST_FIRM_STATUS_COMMON " + "SYSRES_CONST_CONST_FIRM_STATUS_INDIVIDUAL " + "SYSRES_CONST_CONST_NEGATIVE_VALUE " + "SYSRES_CONST_CONST_POSITIVE_VALUE " + "SYSRES_CONST_CONST_SERVER_STATUS_DONT_REPLICATE " + "SYSRES_CONST_CONST_SERVER_STATUS_REPLICATE " + "SYSRES_CONST_CONTENTS_REQUISITE_CODE " + "SYSRES_CONST_DATA_TYPE_BOOLEAN " + "SYSRES_CONST_DATA_TYPE_DATE " + "SYSRES_CONST_DATA_TYPE_FLOAT " + "SYSRES_CONST_DATA_TYPE_INTEGER " + "SYSRES_CONST_DATA_TYPE_PICK " + "SYSRES_CONST_DATA_TYPE_REFERENCE " + "SYSRES_CONST_DATA_TYPE_STRING " + "SYSRES_CONST_DATA_TYPE_TEXT " + "SYSRES_CONST_DATA_TYPE_VARIANT " + "SYSRES_CONST_DATE_CLOSE_REQ_CODE " + "SYSRES_CONST_DATE_FORMAT_DATE_ONLY_CHAR " + "SYSRES_CONST_DATE_OPEN_REQ_CODE " + "SYSRES_CONST_DATE_REQUISITE " + "SYSRES_CONST_DATE_REQUISITE_CODE " + "SYSRES_CONST_DATE_REQUISITE_NAME " + "SYSRES_CONST_DATE_REQUISITE_TYPE " + "SYSRES_CONST_DATE_TYPE_CHAR " + "SYSRES_CONST_DATETIME_FORMAT_VALUE " + "SYSRES_CONST_DEA_ACCESS_RIGHTS_ACTION_CODE " + "SYSRES_CONST_DESCRIPTION_LOCALIZE_ID_REQUISITE_CODE " + "SYSRES_CONST_DESCRIPTION_REQUISITE_CODE " + "SYSRES_CONST_DET1_PART " + "SYSRES_CONST_DET2_PART " + "SYSRES_CONST_DET3_PART " + "SYSRES_CONST_DET4_PART " + "SYSRES_CONST_DET5_PART " + "SYSRES_CONST_DET6_PART " + "SYSRES_CONST_DETAIL_DATASET_KEY_REQUISITE_CODE " + "SYSRES_CONST_DETAIL_PICK_REQUISITE_CODE " + "SYSRES_CONST_DETAIL_REQ_CODE " + "SYSRES_CONST_DO_NOT_USE_ACCESS_TYPE_CODE " + "SYSRES_CONST_DO_NOT_USE_ACCESS_TYPE_NAME " + "SYSRES_CONST_DO_NOT_USE_ON_VIEW_ACCESS_TYPE_CODE " + "SYSRES_CONST_DO_NOT_USE_ON_VIEW_ACCESS_TYPE_NAME " + "SYSRES_CONST_DOCUMENT_STORAGES_CODE " + "SYSRES_CONST_DOCUMENT_TEMPLATES_TYPE_NAME " + "SYSRES_CONST_DOUBLE_REQUISITE_CODE " + "SYSRES_CONST_EDITOR_CLOSE_FILE_OBSERV_TYPE_CODE " + "SYSRES_CONST_EDITOR_CLOSE_PROCESS_OBSERV_TYPE_CODE " + "SYSRES_CONST_EDITOR_TYPE_REQUISITE_CODE " + "SYSRES_CONST_EDITORS_APPLICATION_NAME_REQUISITE_CODE " + "SYSRES_CONST_EDITORS_CREATE_SEVERAL_PROCESSES_REQUISITE_CODE " + "SYSRES_CONST_EDITORS_EXTENSION_REQUISITE_CODE " + "SYSRES_CONST_EDITORS_OBSERVER_BY_PROCESS_TYPE " + "SYSRES_CONST_EDITORS_REFERENCE_CODE " + "SYSRES_CONST_EDITORS_REPLACE_SPEC_CHARS_REQUISITE_CODE " + "SYSRES_CONST_EDITORS_USE_PLUGINS_REQUISITE_CODE " + "SYSRES_CONST_EDITORS_VIEW_DOCUMENT_OPENED_TO_EDIT_CODE " + "SYSRES_CONST_EDOC_CARD_TYPE_REQUISITE_CODE " + "SYSRES_CONST_EDOC_CARD_TYPES_LINK_REQUISITE_CODE " + "SYSRES_CONST_EDOC_CERTIFICATE_AND_PASSWORD_ENCODE_CODE " + "SYSRES_CONST_EDOC_CERTIFICATE_ENCODE_CODE " + "SYSRES_CONST_EDOC_DATE_REQUISITE_CODE " + "SYSRES_CONST_EDOC_KIND_REFERENCE_CODE " + "SYSRES_CONST_EDOC_KINDS_BY_TEMPLATE_ACTION_CODE " + "SYSRES_CONST_EDOC_MANAGE_ACCESS_CODE " + "SYSRES_CONST_EDOC_NONE_ENCODE_CODE " + "SYSRES_CONST_EDOC_NUMBER_REQUISITE_CODE " + "SYSRES_CONST_EDOC_PASSWORD_ENCODE_CODE " + "SYSRES_CONST_EDOC_READONLY_ACCESS_CODE " + "SYSRES_CONST_EDOC_SHELL_LIFE_TYPE_VIEW_VALUE " + "SYSRES_CONST_EDOC_SIZE_RESTRICTION_PRIORITY_REQUISITE_CODE " + "SYSRES_CONST_EDOC_STORAGE_CHECK_ACCESS_RIGHTS_REQUISITE_CODE " + "SYSRES_CONST_EDOC_STORAGE_COMPUTER_NAME_REQUISITE_CODE " + "SYSRES_CONST_EDOC_STORAGE_DATABASE_NAME_REQUISITE_CODE " + "SYSRES_CONST_EDOC_STORAGE_EDIT_IN_STORAGE_REQUISITE_CODE " + "SYSRES_CONST_EDOC_STORAGE_LOCAL_PATH_REQUISITE_CODE " + "SYSRES_CONST_EDOC_STORAGE_SHARED_SOURCE_NAME_REQUISITE_CODE " + "SYSRES_CONST_EDOC_TEMPLATE_REQUISITE_CODE " + "SYSRES_CONST_EDOC_TYPES_REFERENCE_CODE " + "SYSRES_CONST_EDOC_VERSION_ACTIVE_STAGE_CODE " + "SYSRES_CONST_EDOC_VERSION_DESIGN_STAGE_CODE " + "SYSRES_CONST_EDOC_VERSION_OBSOLETE_STAGE_CODE " + "SYSRES_CONST_EDOC_WRITE_ACCES_CODE " + "SYSRES_CONST_EDOCUMENT_CARD_REQUISITES_REFERENCE_CODE_SELECTED_REQUISITE " + "SYSRES_CONST_ENCODE_CERTIFICATE_TYPE_CODE " + "SYSRES_CONST_END_DATE_REQUISITE_CODE " + "SYSRES_CONST_ENUMERATION_TYPE_REQUISITE_CODE " + "SYSRES_CONST_EXECUTE_ACCESS_RIGHTS_TYPE_CODE " + "SYSRES_CONST_EXECUTIVE_FILE_STORAGE_TYPE " + "SYSRES_CONST_EXIST_CONST " + "SYSRES_CONST_EXIST_VALUE " + "SYSRES_CONST_EXPORT_LOCK_TYPE_ASK " + "SYSRES_CONST_EXPORT_LOCK_TYPE_WITH_LOCK " + "SYSRES_CONST_EXPORT_LOCK_TYPE_WITHOUT_LOCK " + "SYSRES_CONST_EXPORT_VERSION_TYPE_ASK " + "SYSRES_CONST_EXPORT_VERSION_TYPE_LAST " + "SYSRES_CONST_EXPORT_VERSION_TYPE_LAST_ACTIVE " + "SYSRES_CONST_EXTENSION_REQUISITE_CODE " + "SYSRES_CONST_FILTER_NAME_REQUISITE_CODE " + "SYSRES_CONST_FILTER_REQUISITE_CODE " + "SYSRES_CONST_FILTER_TYPE_COMMON_CODE " + "SYSRES_CONST_FILTER_TYPE_COMMON_NAME " + "SYSRES_CONST_FILTER_TYPE_USER_CODE " + "SYSRES_CONST_FILTER_TYPE_USER_NAME " + "SYSRES_CONST_FILTER_VALUE_REQUISITE_NAME " + "SYSRES_CONST_FLOAT_NUMBER_FORMAT_CHAR " + "SYSRES_CONST_FLOAT_REQUISITE_TYPE " + "SYSRES_CONST_FOLDER_AUTHOR_VALUE " + "SYSRES_CONST_FOLDER_KIND_ANY_OBJECTS " + "SYSRES_CONST_FOLDER_KIND_COMPONENTS " + "SYSRES_CONST_FOLDER_KIND_EDOCS " + "SYSRES_CONST_FOLDER_KIND_JOBS " + "SYSRES_CONST_FOLDER_KIND_TASKS " + "SYSRES_CONST_FOLDER_TYPE_COMMON " + "SYSRES_CONST_FOLDER_TYPE_COMPONENT " + "SYSRES_CONST_FOLDER_TYPE_FAVORITES " + "SYSRES_CONST_FOLDER_TYPE_INBOX " + "SYSRES_CONST_FOLDER_TYPE_OUTBOX " + "SYSRES_CONST_FOLDER_TYPE_QUICK_LAUNCH " + "SYSRES_CONST_FOLDER_TYPE_SEARCH " + "SYSRES_CONST_FOLDER_TYPE_SHORTCUTS " + "SYSRES_CONST_FOLDER_TYPE_USER " + "SYSRES_CONST_FROM_DICTIONARY_ENUM_METHOD_FLAG " + "SYSRES_CONST_FULL_SUBSTITUTE_TYPE " + "SYSRES_CONST_FULL_SUBSTITUTE_TYPE_CODE " + "SYSRES_CONST_FUNCTION_CANCEL_RESULT " + "SYSRES_CONST_FUNCTION_CATEGORY_SYSTEM " + "SYSRES_CONST_FUNCTION_CATEGORY_USER " + "SYSRES_CONST_FUNCTION_FAILURE_RESULT " + "SYSRES_CONST_FUNCTION_SAVE_RESULT " + "SYSRES_CONST_GENERATED_REQUISITE " + "SYSRES_CONST_GREEN_LIFE_CYCLE_STAGE_FONT_COLOR " + "SYSRES_CONST_GROUP_ACCOUNT_TYPE_VALUE_CODE " + "SYSRES_CONST_GROUP_CATEGORY_NORMAL_CODE " + "SYSRES_CONST_GROUP_CATEGORY_NORMAL_NAME " + "SYSRES_CONST_GROUP_CATEGORY_SERVICE_CODE " + "SYSRES_CONST_GROUP_CATEGORY_SERVICE_NAME " + "SYSRES_CONST_GROUP_COMMON_CATEGORY_FIELD_VALUE " + "SYSRES_CONST_GROUP_FULL_NAME_REQUISITE_CODE " + "SYSRES_CONST_GROUP_NAME_REQUISITE_CODE " + "SYSRES_CONST_GROUP_RIGHTS_T_REQUISITE_CODE " + "SYSRES_CONST_GROUP_SERVER_CODES_REQUISITE_CODE " + "SYSRES_CONST_GROUP_SERVER_NAME_REQUISITE_CODE " + "SYSRES_CONST_GROUP_SERVICE_CATEGORY_FIELD_VALUE " + "SYSRES_CONST_GROUP_USER_REQUISITE_CODE " + "SYSRES_CONST_GROUPS_REFERENCE_CODE " + "SYSRES_CONST_GROUPS_REQUISITE_CODE " + "SYSRES_CONST_HIDDEN_MODE_NAME " + "SYSRES_CONST_HIGH_LVL_REQUISITE_CODE " + "SYSRES_CONST_HISTORY_ACTION_CREATE_CODE " + "SYSRES_CONST_HISTORY_ACTION_DELETE_CODE " + "SYSRES_CONST_HISTORY_ACTION_EDIT_CODE " + "SYSRES_CONST_HOUR_CHAR " + "SYSRES_CONST_ID_REQUISITE_CODE " + "SYSRES_CONST_IDSPS_REQUISITE_CODE " + "SYSRES_CONST_IMAGE_MODE_COLOR " + "SYSRES_CONST_IMAGE_MODE_GREYSCALE " + "SYSRES_CONST_IMAGE_MODE_MONOCHROME " + "SYSRES_CONST_IMPORTANCE_HIGH " + "SYSRES_CONST_IMPORTANCE_LOW " + "SYSRES_CONST_IMPORTANCE_NORMAL " + "SYSRES_CONST_IN_DESIGN_VERSION_STATE_PICK_VALUE " + "SYSRES_CONST_INCOMING_WORK_RULE_TYPE_CODE " + "SYSRES_CONST_INT_REQUISITE " + "SYSRES_CONST_INT_REQUISITE_TYPE " + "SYSRES_CONST_INTEGER_NUMBER_FORMAT_CHAR " + "SYSRES_CONST_INTEGER_TYPE_CHAR " + "SYSRES_CONST_IS_GENERATED_REQUISITE_NEGATIVE_VALUE " + "SYSRES_CONST_IS_PUBLIC_ROLE_REQUISITE_CODE " + "SYSRES_CONST_IS_REMOTE_USER_NEGATIVE_VALUE " + "SYSRES_CONST_IS_REMOTE_USER_POSITIVE_VALUE " + "SYSRES_CONST_IS_STORED_REQUISITE_NEGATIVE_VALUE " + "SYSRES_CONST_IS_STORED_REQUISITE_STORED_VALUE " + "SYSRES_CONST_ITALIC_LIFE_CYCLE_STAGE_DRAW_STYLE " + "SYSRES_CONST_JOB_BLOCK_DESCRIPTION " + "SYSRES_CONST_JOB_KIND_CONTROL_JOB " + "SYSRES_CONST_JOB_KIND_JOB " + "SYSRES_CONST_JOB_KIND_NOTICE " + "SYSRES_CONST_JOB_STATE_ABORTED " + "SYSRES_CONST_JOB_STATE_COMPLETE " + "SYSRES_CONST_JOB_STATE_WORKING " + "SYSRES_CONST_KIND_REQUISITE_CODE " + "SYSRES_CONST_KIND_REQUISITE_NAME " + "SYSRES_CONST_KINDS_CREATE_SHADOW_COPIES_REQUISITE_CODE " + "SYSRES_CONST_KINDS_DEFAULT_EDOC_LIFE_STAGE_REQUISITE_CODE " + "SYSRES_CONST_KINDS_EDOC_ALL_TEPLATES_ALLOWED_REQUISITE_CODE " + "SYSRES_CONST_KINDS_EDOC_ALLOW_LIFE_CYCLE_STAGE_CHANGING_REQUISITE_CODE " + "SYSRES_CONST_KINDS_EDOC_ALLOW_MULTIPLE_ACTIVE_VERSIONS_REQUISITE_CODE " + "SYSRES_CONST_KINDS_EDOC_SHARE_ACCES_RIGHTS_BY_DEFAULT_CODE " + "SYSRES_CONST_KINDS_EDOC_TEMPLATE_REQUISITE_CODE " + "SYSRES_CONST_KINDS_EDOC_TYPE_REQUISITE_CODE " + "SYSRES_CONST_KINDS_SIGNERS_REQUISITES_CODE " + "SYSRES_CONST_KOD_INPUT_TYPE " + "SYSRES_CONST_LAST_UPDATE_DATE_REQUISITE_CODE " + "SYSRES_CONST_LIFE_CYCLE_START_STAGE_REQUISITE_CODE " + "SYSRES_CONST_LILAC_LIFE_CYCLE_STAGE_FONT_COLOR " + "SYSRES_CONST_LINK_OBJECT_KIND_COMPONENT " + "SYSRES_CONST_LINK_OBJECT_KIND_DOCUMENT " + "SYSRES_CONST_LINK_OBJECT_KIND_EDOC " + "SYSRES_CONST_LINK_OBJECT_KIND_FOLDER " + "SYSRES_CONST_LINK_OBJECT_KIND_JOB " + "SYSRES_CONST_LINK_OBJECT_KIND_REFERENCE " + "SYSRES_CONST_LINK_OBJECT_KIND_TASK " + "SYSRES_CONST_LINK_REF_TYPE_REQUISITE_CODE " + "SYSRES_CONST_LIST_REFERENCE_MODE_NAME " + "SYSRES_CONST_LOCALIZATION_DICTIONARY_MAIN_VIEW_CODE " + "SYSRES_CONST_MAIN_VIEW_CODE " + "SYSRES_CONST_MANUAL_ENUM_METHOD_FLAG " + "SYSRES_CONST_MASTER_COMP_TYPE_REQUISITE_CODE " + "SYSRES_CONST_MASTER_TABLE_REC_ID_REQUISITE_CODE " + "SYSRES_CONST_MAXIMIZED_MODE_NAME " + "SYSRES_CONST_ME_VALUE " + "SYSRES_CONST_MESSAGE_ATTENTION_CAPTION " + "SYSRES_CONST_MESSAGE_CONFIRMATION_CAPTION " + "SYSRES_CONST_MESSAGE_ERROR_CAPTION " + "SYSRES_CONST_MESSAGE_INFORMATION_CAPTION " + "SYSRES_CONST_MINIMIZED_MODE_NAME " + "SYSRES_CONST_MINUTE_CHAR " + "SYSRES_CONST_MODULE_REQUISITE_CODE " + "SYSRES_CONST_MONITORING_BLOCK_DESCRIPTION " + "SYSRES_CONST_MONTH_FORMAT_VALUE " + "SYSRES_CONST_NAME_LOCALIZE_ID_REQUISITE_CODE " + "SYSRES_CONST_NAME_REQUISITE_CODE " + "SYSRES_CONST_NAME_SINGULAR_REQUISITE_CODE " + "SYSRES_CONST_NAMEAN_INPUT_TYPE " + "SYSRES_CONST_NEGATIVE_PICK_VALUE " + "SYSRES_CONST_NEGATIVE_VALUE " + "SYSRES_CONST_NO " + "SYSRES_CONST_NO_PICK_VALUE " + "SYSRES_CONST_NO_SIGNATURE_REQUISITE_CODE " + "SYSRES_CONST_NO_VALUE " + "SYSRES_CONST_NONE_ACCESS_RIGHTS_TYPE_CODE " + "SYSRES_CONST_NONOPERATING_RECORD_FLAG_VALUE " + "SYSRES_CONST_NONOPERATING_RECORD_FLAG_VALUE_MASCULINE " + "SYSRES_CONST_NORMAL_ACCESS_RIGHTS_TYPE_CODE " + "SYSRES_CONST_NORMAL_LIFE_CYCLE_STAGE_DRAW_STYLE " + "SYSRES_CONST_NORMAL_MODE_NAME " + "SYSRES_CONST_NOT_ALLOWED_ACCESS_TYPE_CODE " + "SYSRES_CONST_NOT_ALLOWED_ACCESS_TYPE_NAME " + "SYSRES_CONST_NOTE_REQUISITE_CODE " + "SYSRES_CONST_NOTICE_BLOCK_DESCRIPTION " + "SYSRES_CONST_NUM_REQUISITE " + "SYSRES_CONST_NUM_STR_REQUISITE_CODE " + "SYSRES_CONST_NUMERATION_AUTO_NOT_STRONG " + "SYSRES_CONST_NUMERATION_AUTO_STRONG " + "SYSRES_CONST_NUMERATION_FROM_DICTONARY " + "SYSRES_CONST_NUMERATION_MANUAL " + "SYSRES_CONST_NUMERIC_TYPE_CHAR " + "SYSRES_CONST_NUMREQ_REQUISITE_CODE " + "SYSRES_CONST_OBSOLETE_VERSION_STATE_PICK_VALUE " + "SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE " + "SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE_CODE " + "SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE_FEMININE " + "SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE_MASCULINE " + "SYSRES_CONST_OPTIONAL_FORM_COMP_REQCODE_PREFIX " + "SYSRES_CONST_ORANGE_LIFE_CYCLE_STAGE_FONT_COLOR " + "SYSRES_CONST_ORIGINALREF_REQUISITE_CODE " + "SYSRES_CONST_OURFIRM_REF_CODE " + "SYSRES_CONST_OURFIRM_REQUISITE_CODE " + "SYSRES_CONST_OURFIRM_VAR " + "SYSRES_CONST_OUTGOING_WORK_RULE_TYPE_CODE " + "SYSRES_CONST_PICK_NEGATIVE_RESULT " + "SYSRES_CONST_PICK_POSITIVE_RESULT " + "SYSRES_CONST_PICK_REQUISITE " + "SYSRES_CONST_PICK_REQUISITE_TYPE " + "SYSRES_CONST_PICK_TYPE_CHAR " + "SYSRES_CONST_PLAN_STATUS_REQUISITE_CODE " + "SYSRES_CONST_PLATFORM_VERSION_COMMENT " + "SYSRES_CONST_PLUGINS_SETTINGS_DESCRIPTION_REQUISITE_CODE " + "SYSRES_CONST_POSITIVE_PICK_VALUE " + "SYSRES_CONST_POWER_TO_CREATE_ACTION_CODE " + "SYSRES_CONST_POWER_TO_SIGN_ACTION_CODE " + "SYSRES_CONST_PRIORITY_REQUISITE_CODE " + "SYSRES_CONST_QUALIFIED_TASK_TYPE " + "SYSRES_CONST_QUALIFIED_TASK_TYPE_CODE " + "SYSRES_CONST_RECSTAT_REQUISITE_CODE " + "SYSRES_CONST_RED_LIFE_CYCLE_STAGE_FONT_COLOR " + "SYSRES_CONST_REF_ID_T_REF_TYPE_REQUISITE_CODE " + "SYSRES_CONST_REF_REQUISITE " + "SYSRES_CONST_REF_REQUISITE_TYPE " + "SYSRES_CONST_REF_REQUISITES_REFERENCE_CODE_SELECTED_REQUISITE " + "SYSRES_CONST_REFERENCE_RECORD_HISTORY_CREATE_ACTION_CODE " + "SYSRES_CONST_REFERENCE_RECORD_HISTORY_DELETE_ACTION_CODE " + "SYSRES_CONST_REFERENCE_RECORD_HISTORY_MODIFY_ACTION_CODE " + "SYSRES_CONST_REFERENCE_TYPE_CHAR " + "SYSRES_CONST_REFERENCE_TYPE_REQUISITE_NAME " + "SYSRES_CONST_REFERENCES_ADD_PARAMS_REQUISITE_CODE " + "SYSRES_CONST_REFERENCES_DISPLAY_REQUISITE_REQUISITE_CODE " + "SYSRES_CONST_REMOTE_SERVER_STATUS_WORKING " + "SYSRES_CONST_REMOTE_SERVER_TYPE_MAIN " + "SYSRES_CONST_REMOTE_SERVER_TYPE_SECONDARY " + "SYSRES_CONST_REMOTE_USER_FLAG_VALUE_CODE " + "SYSRES_CONST_REPORT_APP_EDITOR_INTERNAL " + "SYSRES_CONST_REPORT_BASE_REPORT_ID_REQUISITE_CODE " + "SYSRES_CONST_REPORT_BASE_REPORT_REQUISITE_CODE " + "SYSRES_CONST_REPORT_SCRIPT_REQUISITE_CODE " + "SYSRES_CONST_REPORT_TEMPLATE_REQUISITE_CODE " + "SYSRES_CONST_REPORT_VIEWER_CODE_REQUISITE_CODE " + "SYSRES_CONST_REQ_ALLOW_COMPONENT_DEFAULT_VALUE " + "SYSRES_CONST_REQ_ALLOW_RECORD_DEFAULT_VALUE " + "SYSRES_CONST_REQ_ALLOW_SERVER_COMPONENT_DEFAULT_VALUE " + "SYSRES_CONST_REQ_MODE_AVAILABLE_CODE " + "SYSRES_CONST_REQ_MODE_EDIT_CODE " + "SYSRES_CONST_REQ_MODE_HIDDEN_CODE " + "SYSRES_CONST_REQ_MODE_NOT_AVAILABLE_CODE " + "SYSRES_CONST_REQ_MODE_VIEW_CODE " + "SYSRES_CONST_REQ_NUMBER_REQUISITE_CODE " + "SYSRES_CONST_REQ_SECTION_VALUE " + "SYSRES_CONST_REQ_TYPE_VALUE " + "SYSRES_CONST_REQUISITE_FORMAT_BY_UNIT " + "SYSRES_CONST_REQUISITE_FORMAT_DATE_FULL " + "SYSRES_CONST_REQUISITE_FORMAT_DATE_TIME " + "SYSRES_CONST_REQUISITE_FORMAT_LEFT " + "SYSRES_CONST_REQUISITE_FORMAT_RIGHT " + "SYSRES_CONST_REQUISITE_FORMAT_WITHOUT_UNIT " + "SYSRES_CONST_REQUISITE_NUMBER_REQUISITE_CODE " + "SYSRES_CONST_REQUISITE_SECTION_ACTIONS " + "SYSRES_CONST_REQUISITE_SECTION_BUTTON " + "SYSRES_CONST_REQUISITE_SECTION_BUTTONS " + "SYSRES_CONST_REQUISITE_SECTION_CARD " + "SYSRES_CONST_REQUISITE_SECTION_TABLE " + "SYSRES_CONST_REQUISITE_SECTION_TABLE10 " + "SYSRES_CONST_REQUISITE_SECTION_TABLE11 " + "SYSRES_CONST_REQUISITE_SECTION_TABLE12 " + "SYSRES_CONST_REQUISITE_SECTION_TABLE13 " + "SYSRES_CONST_REQUISITE_SECTION_TABLE14 " + "SYSRES_CONST_REQUISITE_SECTION_TABLE15 " + "SYSRES_CONST_REQUISITE_SECTION_TABLE16 " + "SYSRES_CONST_REQUISITE_SECTION_TABLE17 " + "SYSRES_CONST_REQUISITE_SECTION_TABLE18 " + "SYSRES_CONST_REQUISITE_SECTION_TABLE19 " + "SYSRES_CONST_REQUISITE_SECTION_TABLE2 " + "SYSRES_CONST_REQUISITE_SECTION_TABLE20 " + "SYSRES_CONST_REQUISITE_SECTION_TABLE21 " + "SYSRES_CONST_REQUISITE_SECTION_TABLE22 " + "SYSRES_CONST_REQUISITE_SECTION_TABLE23 " + "SYSRES_CONST_REQUISITE_SECTION_TABLE24 " + "SYSRES_CONST_REQUISITE_SECTION_TABLE3 " + "SYSRES_CONST_REQUISITE_SECTION_TABLE4 " + "SYSRES_CONST_REQUISITE_SECTION_TABLE5 " + "SYSRES_CONST_REQUISITE_SECTION_TABLE6 " + "SYSRES_CONST_REQUISITE_SECTION_TABLE7 " + "SYSRES_CONST_REQUISITE_SECTION_TABLE8 " + "SYSRES_CONST_REQUISITE_SECTION_TABLE9 " + "SYSRES_CONST_REQUISITES_PSEUDOREFERENCE_REQUISITE_NUMBER_REQUISITE_CODE " + "SYSRES_CONST_RIGHT_ALIGNMENT_CODE " + "SYSRES_CONST_ROLES_REFERENCE_CODE " + "SYSRES_CONST_ROUTE_STEP_AFTER_RUS " + "SYSRES_CONST_ROUTE_STEP_AND_CONDITION_RUS " + "SYSRES_CONST_ROUTE_STEP_OR_CONDITION_RUS " + "SYSRES_CONST_ROUTE_TYPE_COMPLEX " + "SYSRES_CONST_ROUTE_TYPE_PARALLEL " + "SYSRES_CONST_ROUTE_TYPE_SERIAL " + "SYSRES_CONST_SBDATASETDESC_NEGATIVE_VALUE " + "SYSRES_CONST_SBDATASETDESC_POSITIVE_VALUE " + "SYSRES_CONST_SBVIEWSDESC_POSITIVE_VALUE " + "SYSRES_CONST_SCRIPT_BLOCK_DESCRIPTION " + "SYSRES_CONST_SEARCH_BY_TEXT_REQUISITE_CODE " + "SYSRES_CONST_SEARCHES_COMPONENT_CONTENT " + "SYSRES_CONST_SEARCHES_CRITERIA_ACTION_NAME " + "SYSRES_CONST_SEARCHES_EDOC_CONTENT " + "SYSRES_CONST_SEARCHES_FOLDER_CONTENT " + "SYSRES_CONST_SEARCHES_JOB_CONTENT " + "SYSRES_CONST_SEARCHES_REFERENCE_CODE " + "SYSRES_CONST_SEARCHES_TASK_CONTENT " + "SYSRES_CONST_SECOND_CHAR " + "SYSRES_CONST_SECTION_REQUISITE_ACTIONS_VALUE " + "SYSRES_CONST_SECTION_REQUISITE_CARD_VALUE " + "SYSRES_CONST_SECTION_REQUISITE_CODE " + "SYSRES_CONST_SECTION_REQUISITE_DETAIL_1_VALUE " + "SYSRES_CONST_SECTION_REQUISITE_DETAIL_2_VALUE " + "SYSRES_CONST_SECTION_REQUISITE_DETAIL_3_VALUE " + "SYSRES_CONST_SECTION_REQUISITE_DETAIL_4_VALUE " + "SYSRES_CONST_SECTION_REQUISITE_DETAIL_5_VALUE " + "SYSRES_CONST_SECTION_REQUISITE_DETAIL_6_VALUE " + "SYSRES_CONST_SELECT_REFERENCE_MODE_NAME " + "SYSRES_CONST_SELECT_TYPE_SELECTABLE " + "SYSRES_CONST_SELECT_TYPE_SELECTABLE_ONLY_CHILD " + "SYSRES_CONST_SELECT_TYPE_SELECTABLE_WITH_CHILD " + "SYSRES_CONST_SELECT_TYPE_UNSLECTABLE " + "SYSRES_CONST_SERVER_TYPE_MAIN " + "SYSRES_CONST_SERVICE_USER_CATEGORY_FIELD_VALUE " + "SYSRES_CONST_SETTINGS_USER_REQUISITE_CODE " + "SYSRES_CONST_SIGNATURE_AND_ENCODE_CERTIFICATE_TYPE_CODE " + "SYSRES_CONST_SIGNATURE_CERTIFICATE_TYPE_CODE " + "SYSRES_CONST_SINGULAR_TITLE_REQUISITE_CODE " + "SYSRES_CONST_SQL_SERVER_AUTHENTIFICATION_FLAG_VALUE_CODE " + "SYSRES_CONST_SQL_SERVER_ENCODE_AUTHENTIFICATION_FLAG_VALUE_CODE " + "SYSRES_CONST_STANDART_ROUTE_REFERENCE_CODE " + "SYSRES_CONST_STANDART_ROUTE_REFERENCE_COMMENT_REQUISITE_CODE " + "SYSRES_CONST_STANDART_ROUTES_GROUPS_REFERENCE_CODE " + "SYSRES_CONST_STATE_REQ_NAME " + "SYSRES_CONST_STATE_REQUISITE_ACTIVE_VALUE " + "SYSRES_CONST_STATE_REQUISITE_CLOSED_VALUE " + "SYSRES_CONST_STATE_REQUISITE_CODE " + "SYSRES_CONST_STATIC_ROLE_TYPE_CODE " + "SYSRES_CONST_STATUS_PLAN_DEFAULT_VALUE " + "SYSRES_CONST_STATUS_VALUE_AUTOCLEANING " + "SYSRES_CONST_STATUS_VALUE_BLUE_SQUARE " + "SYSRES_CONST_STATUS_VALUE_COMPLETE " + "SYSRES_CONST_STATUS_VALUE_GREEN_SQUARE " + "SYSRES_CONST_STATUS_VALUE_ORANGE_SQUARE " + "SYSRES_CONST_STATUS_VALUE_PURPLE_SQUARE " + "SYSRES_CONST_STATUS_VALUE_RED_SQUARE " + "SYSRES_CONST_STATUS_VALUE_SUSPEND " + "SYSRES_CONST_STATUS_VALUE_YELLOW_SQUARE " + "SYSRES_CONST_STDROUTE_SHOW_TO_USERS_REQUISITE_CODE " + "SYSRES_CONST_STORAGE_TYPE_FILE " + "SYSRES_CONST_STORAGE_TYPE_SQL_SERVER " + "SYSRES_CONST_STR_REQUISITE " + "SYSRES_CONST_STRIKEOUT_LIFE_CYCLE_STAGE_DRAW_STYLE " + "SYSRES_CONST_STRING_FORMAT_LEFT_ALIGN_CHAR " + "SYSRES_CONST_STRING_FORMAT_RIGHT_ALIGN_CHAR " + "SYSRES_CONST_STRING_REQUISITE_CODE " + "SYSRES_CONST_STRING_REQUISITE_TYPE " + "SYSRES_CONST_STRING_TYPE_CHAR " + "SYSRES_CONST_SUBSTITUTES_PSEUDOREFERENCE_CODE " + "SYSRES_CONST_SUBTASK_BLOCK_DESCRIPTION " + "SYSRES_CONST_SYSTEM_SETTING_CURRENT_USER_PARAM_VALUE " + "SYSRES_CONST_SYSTEM_SETTING_EMPTY_VALUE_PARAM_VALUE " + "SYSRES_CONST_SYSTEM_VERSION_COMMENT " + "SYSRES_CONST_TASK_ACCESS_TYPE_ALL " + "SYSRES_CONST_TASK_ACCESS_TYPE_ALL_MEMBERS " + "SYSRES_CONST_TASK_ACCESS_TYPE_MANUAL " + "SYSRES_CONST_TASK_ENCODE_TYPE_CERTIFICATION " + "SYSRES_CONST_TASK_ENCODE_TYPE_CERTIFICATION_AND_PASSWORD " + "SYSRES_CONST_TASK_ENCODE_TYPE_NONE " + "SYSRES_CONST_TASK_ENCODE_TYPE_PASSWORD " + "SYSRES_CONST_TASK_ROUTE_ALL_CONDITION " + "SYSRES_CONST_TASK_ROUTE_AND_CONDITION " + "SYSRES_CONST_TASK_ROUTE_OR_CONDITION " + "SYSRES_CONST_TASK_STATE_ABORTED " + "SYSRES_CONST_TASK_STATE_COMPLETE " + "SYSRES_CONST_TASK_STATE_CONTINUED " + "SYSRES_CONST_TASK_STATE_CONTROL " + "SYSRES_CONST_TASK_STATE_INIT " + "SYSRES_CONST_TASK_STATE_WORKING " + "SYSRES_CONST_TASK_TITLE " + "SYSRES_CONST_TASK_TYPES_GROUPS_REFERENCE_CODE " + "SYSRES_CONST_TASK_TYPES_REFERENCE_CODE " + "SYSRES_CONST_TEMPLATES_REFERENCE_CODE " + "SYSRES_CONST_TEST_DATE_REQUISITE_NAME " + "SYSRES_CONST_TEST_DEV_DATABASE_NAME " + "SYSRES_CONST_TEST_DEV_SYSTEM_CODE " + "SYSRES_CONST_TEST_EDMS_DATABASE_NAME " + "SYSRES_CONST_TEST_EDMS_MAIN_CODE " + "SYSRES_CONST_TEST_EDMS_MAIN_DB_NAME " + "SYSRES_CONST_TEST_EDMS_SECOND_CODE " + "SYSRES_CONST_TEST_EDMS_SECOND_DB_NAME " + "SYSRES_CONST_TEST_EDMS_SYSTEM_CODE " + "SYSRES_CONST_TEST_NUMERIC_REQUISITE_NAME " + "SYSRES_CONST_TEXT_REQUISITE " + "SYSRES_CONST_TEXT_REQUISITE_CODE " + "SYSRES_CONST_TEXT_REQUISITE_TYPE " + "SYSRES_CONST_TEXT_TYPE_CHAR " + "SYSRES_CONST_TYPE_CODE_REQUISITE_CODE " + "SYSRES_CONST_TYPE_REQUISITE_CODE " + "SYSRES_CONST_UNDEFINED_LIFE_CYCLE_STAGE_FONT_COLOR " + "SYSRES_CONST_UNITS_SECTION_ID_REQUISITE_CODE " + "SYSRES_CONST_UNITS_SECTION_REQUISITE_CODE " + "SYSRES_CONST_UNOPERATING_RECORD_FLAG_VALUE_CODE " + "SYSRES_CONST_UNSTORED_DATA_REQUISITE_CODE " + "SYSRES_CONST_UNSTORED_DATA_REQUISITE_NAME " + "SYSRES_CONST_USE_ACCESS_TYPE_CODE " + "SYSRES_CONST_USE_ACCESS_TYPE_NAME " + "SYSRES_CONST_USER_ACCOUNT_TYPE_VALUE_CODE " + "SYSRES_CONST_USER_ADDITIONAL_INFORMATION_REQUISITE_CODE " + "SYSRES_CONST_USER_AND_GROUP_ID_FROM_PSEUDOREFERENCE_REQUISITE_CODE " + "SYSRES_CONST_USER_CATEGORY_NORMAL " + "SYSRES_CONST_USER_CERTIFICATE_REQUISITE_CODE " + "SYSRES_CONST_USER_CERTIFICATE_STATE_REQUISITE_CODE " + "SYSRES_CONST_USER_CERTIFICATE_SUBJECT_NAME_REQUISITE_CODE " + "SYSRES_CONST_USER_CERTIFICATE_THUMBPRINT_REQUISITE_CODE " + "SYSRES_CONST_USER_COMMON_CATEGORY " + "SYSRES_CONST_USER_COMMON_CATEGORY_CODE " + "SYSRES_CONST_USER_FULL_NAME_REQUISITE_CODE " + "SYSRES_CONST_USER_GROUP_TYPE_REQUISITE_CODE " + "SYSRES_CONST_USER_LOGIN_REQUISITE_CODE " + "SYSRES_CONST_USER_REMOTE_CONTROLLER_REQUISITE_CODE " + "SYSRES_CONST_USER_REMOTE_SYSTEM_REQUISITE_CODE " + "SYSRES_CONST_USER_RIGHTS_T_REQUISITE_CODE " + "SYSRES_CONST_USER_SERVER_NAME_REQUISITE_CODE " + "SYSRES_CONST_USER_SERVICE_CATEGORY " + "SYSRES_CONST_USER_SERVICE_CATEGORY_CODE " + "SYSRES_CONST_USER_STATUS_ADMINISTRATOR_CODE " + "SYSRES_CONST_USER_STATUS_ADMINISTRATOR_NAME " + "SYSRES_CONST_USER_STATUS_DEVELOPER_CODE " + "SYSRES_CONST_USER_STATUS_DEVELOPER_NAME " + "SYSRES_CONST_USER_STATUS_DISABLED_CODE " + "SYSRES_CONST_USER_STATUS_DISABLED_NAME " + "SYSRES_CONST_USER_STATUS_SYSTEM_DEVELOPER_CODE " + "SYSRES_CONST_USER_STATUS_USER_CODE " + "SYSRES_CONST_USER_STATUS_USER_NAME " + "SYSRES_CONST_USER_STATUS_USER_NAME_DEPRECATED " + "SYSRES_CONST_USER_TYPE_FIELD_VALUE_USER " + "SYSRES_CONST_USER_TYPE_REQUISITE_CODE " + "SYSRES_CONST_USERS_CONTROLLER_REQUISITE_CODE " + "SYSRES_CONST_USERS_IS_MAIN_SERVER_REQUISITE_CODE " + "SYSRES_CONST_USERS_REFERENCE_CODE " + "SYSRES_CONST_USERS_REGISTRATION_CERTIFICATES_ACTION_NAME " + "SYSRES_CONST_USERS_REQUISITE_CODE " + "SYSRES_CONST_USERS_SYSTEM_REQUISITE_CODE " + "SYSRES_CONST_USERS_USER_ACCESS_RIGHTS_TYPR_REQUISITE_CODE " + "SYSRES_CONST_USERS_USER_AUTHENTICATION_REQUISITE_CODE " + "SYSRES_CONST_USERS_USER_COMPONENT_REQUISITE_CODE " + "SYSRES_CONST_USERS_USER_GROUP_REQUISITE_CODE " + "SYSRES_CONST_USERS_VIEW_CERTIFICATES_ACTION_NAME " + "SYSRES_CONST_VIEW_DEFAULT_CODE " + "SYSRES_CONST_VIEW_DEFAULT_NAME " + "SYSRES_CONST_VIEWER_REQUISITE_CODE " + "SYSRES_CONST_WAITING_BLOCK_DESCRIPTION " + "SYSRES_CONST_WIZARD_FORM_LABEL_TEST_STRING  " + "SYSRES_CONST_WIZARD_QUERY_PARAM_HEIGHT_ETALON_STRING " + "SYSRES_CONST_WIZARD_REFERENCE_COMMENT_REQUISITE_CODE " + "SYSRES_CONST_WORK_RULES_DESCRIPTION_REQUISITE_CODE " + "SYSRES_CONST_WORK_TIME_CALENDAR_REFERENCE_CODE " + "SYSRES_CONST_WORK_WORKFLOW_HARD_ROUTE_TYPE_VALUE " + "SYSRES_CONST_WORK_WORKFLOW_HARD_ROUTE_TYPE_VALUE_CODE " + "SYSRES_CONST_WORK_WORKFLOW_HARD_ROUTE_TYPE_VALUE_CODE_RUS " + "SYSRES_CONST_WORK_WORKFLOW_SOFT_ROUTE_TYPE_VALUE_CODE_RUS " + "SYSRES_CONST_WORKFLOW_ROUTE_TYPR_HARD " + "SYSRES_CONST_WORKFLOW_ROUTE_TYPR_SOFT " + "SYSRES_CONST_XML_ENCODING " + "SYSRES_CONST_XREC_STAT_REQUISITE_CODE " + "SYSRES_CONST_XRECID_FIELD_NAME " + "SYSRES_CONST_YES " + "SYSRES_CONST_YES_NO_2_REQUISITE_CODE " + "SYSRES_CONST_YES_NO_REQUISITE_CODE " + "SYSRES_CONST_YES_NO_T_REF_TYPE_REQUISITE_CODE " + "SYSRES_CONST_YES_PICK_VALUE " + "SYSRES_CONST_YES_VALUE ";

  // Base constant
  var base_constants = "CR FALSE nil NO_VALUE NULL TAB TRUE YES_VALUE ";

  // Base group name
  var base_group_name_constants = "ADMINISTRATORS_GROUP_NAME CUSTOMIZERS_GROUP_NAME DEVELOPERS_GROUP_NAME SERVICE_USERS_GROUP_NAME ";

  // Decision block properties
  var decision_block_properties_constants = "DECISION_BLOCK_FIRST_OPERAND_PROPERTY DECISION_BLOCK_NAME_PROPERTY DECISION_BLOCK_OPERATION_PROPERTY " + "DECISION_BLOCK_RESULT_TYPE_PROPERTY DECISION_BLOCK_SECOND_OPERAND_PROPERTY ";

  // File extension
  var file_extension_constants = "ANY_FILE_EXTENTION COMPRESSED_DOCUMENT_EXTENSION EXTENDED_DOCUMENT_EXTENSION " + "SHORT_COMPRESSED_DOCUMENT_EXTENSION SHORT_EXTENDED_DOCUMENT_EXTENSION ";

  // Job block properties
  var job_block_properties_constants = "JOB_BLOCK_ABORT_DEADLINE_PROPERTY " + "JOB_BLOCK_AFTER_FINISH_EVENT " + "JOB_BLOCK_AFTER_QUERY_PARAMETERS_EVENT " + "JOB_BLOCK_ATTACHMENT_PROPERTY " + "JOB_BLOCK_ATTACHMENTS_RIGHTS_GROUP_PROPERTY " + "JOB_BLOCK_ATTACHMENTS_RIGHTS_TYPE_PROPERTY " + "JOB_BLOCK_BEFORE_QUERY_PARAMETERS_EVENT " + "JOB_BLOCK_BEFORE_START_EVENT " + "JOB_BLOCK_CREATED_JOBS_PROPERTY " + "JOB_BLOCK_DEADLINE_PROPERTY " + "JOB_BLOCK_EXECUTION_RESULTS_PROPERTY " + "JOB_BLOCK_IS_PARALLEL_PROPERTY " + "JOB_BLOCK_IS_RELATIVE_ABORT_DEADLINE_PROPERTY " + "JOB_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY " + "JOB_BLOCK_JOB_TEXT_PROPERTY " + "JOB_BLOCK_NAME_PROPERTY " + "JOB_BLOCK_NEED_SIGN_ON_PERFORM_PROPERTY " + "JOB_BLOCK_PERFORMER_PROPERTY " + "JOB_BLOCK_RELATIVE_ABORT_DEADLINE_TYPE_PROPERTY " + "JOB_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY " + "JOB_BLOCK_SUBJECT_PROPERTY ";

  // Language code
  var language_code_constants = "ENGLISH_LANGUAGE_CODE RUSSIAN_LANGUAGE_CODE ";

  // Launching external applications
  var launching_external_applications_constants = "smHidden smMaximized smMinimized smNormal wmNo wmYes ";

  // Link kind
  var link_kind_constants = "COMPONENT_TOKEN_LINK_KIND " + "DOCUMENT_LINK_KIND " + "EDOCUMENT_LINK_KIND " + "FOLDER_LINK_KIND " + "JOB_LINK_KIND " + "REFERENCE_LINK_KIND " + "TASK_LINK_KIND ";

  // Lock type
  var lock_type_constants = "COMPONENT_TOKEN_LOCK_TYPE EDOCUMENT_VERSION_LOCK_TYPE ";

  // Monitor block properties
  var monitor_block_properties_constants = "MONITOR_BLOCK_AFTER_FINISH_EVENT " + "MONITOR_BLOCK_BEFORE_START_EVENT " + "MONITOR_BLOCK_DEADLINE_PROPERTY " + "MONITOR_BLOCK_INTERVAL_PROPERTY " + "MONITOR_BLOCK_INTERVAL_TYPE_PROPERTY " + "MONITOR_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY " + "MONITOR_BLOCK_NAME_PROPERTY " + "MONITOR_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY " + "MONITOR_BLOCK_SEARCH_SCRIPT_PROPERTY ";

  // Notice block properties
  var notice_block_properties_constants = "NOTICE_BLOCK_AFTER_FINISH_EVENT " + "NOTICE_BLOCK_ATTACHMENT_PROPERTY " + "NOTICE_BLOCK_ATTACHMENTS_RIGHTS_GROUP_PROPERTY " + "NOTICE_BLOCK_ATTACHMENTS_RIGHTS_TYPE_PROPERTY " + "NOTICE_BLOCK_BEFORE_START_EVENT " + "NOTICE_BLOCK_CREATED_NOTICES_PROPERTY " + "NOTICE_BLOCK_DEADLINE_PROPERTY " + "NOTICE_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY " + "NOTICE_BLOCK_NAME_PROPERTY " + "NOTICE_BLOCK_NOTICE_TEXT_PROPERTY " + "NOTICE_BLOCK_PERFORMER_PROPERTY " + "NOTICE_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY " + "NOTICE_BLOCK_SUBJECT_PROPERTY ";

  // Object events
  var object_events_constants = "dseAfterCancel " + "dseAfterClose " + "dseAfterDelete " + "dseAfterDeleteOutOfTransaction " + "dseAfterInsert " + "dseAfterOpen " + "dseAfterScroll " + "dseAfterUpdate " + "dseAfterUpdateOutOfTransaction " + "dseBeforeCancel " + "dseBeforeClose " + "dseBeforeDelete " + "dseBeforeDetailUpdate " + "dseBeforeInsert " + "dseBeforeOpen " + "dseBeforeUpdate " + "dseOnAnyRequisiteChange " + "dseOnCloseRecord " + "dseOnDeleteError " + "dseOnOpenRecord " + "dseOnPrepareUpdate " + "dseOnUpdateError " + "dseOnUpdateRatifiedRecord " + "dseOnValidDelete " + "dseOnValidUpdate " + "reOnChange " + "reOnChangeValues " + "SELECTION_BEGIN_ROUTE_EVENT " + "SELECTION_END_ROUTE_EVENT ";

  // Object params
  var object_params_constants = "CURRENT_PERIOD_IS_REQUIRED " + "PREVIOUS_CARD_TYPE_NAME " + "SHOW_RECORD_PROPERTIES_FORM ";

  // Other
  var other_constants = "ACCESS_RIGHTS_SETTING_DIALOG_CODE " + "ADMINISTRATOR_USER_CODE " + "ANALYTIC_REPORT_TYPE " + "asrtHideLocal " + "asrtHideRemote " + "CALCULATED_ROLE_TYPE_CODE " + "COMPONENTS_REFERENCE_DEVELOPER_VIEW_CODE " + "DCTS_TEST_PROTOCOLS_FOLDER_PATH " + "E_EDOC_VERSION_ALREADY_APPROVINGLY_SIGNED " + "E_EDOC_VERSION_ALREADY_APPROVINGLY_SIGNED_BY_USER " + "E_EDOC_VERSION_ALREDY_SIGNED " + "E_EDOC_VERSION_ALREDY_SIGNED_BY_USER " + "EDOC_TYPES_CODE_REQUISITE_FIELD_NAME " + "EDOCUMENTS_ALIAS_NAME " + "FILES_FOLDER_PATH " + "FILTER_OPERANDS_DELIMITER " + "FILTER_OPERATIONS_DELIMITER " + "FORMCARD_NAME " + "FORMLIST_NAME " + "GET_EXTENDED_DOCUMENT_EXTENSION_CREATION_MODE " + "GET_EXTENDED_DOCUMENT_EXTENSION_IMPORT_MODE " + "INTEGRATED_REPORT_TYPE " + "IS_BUILDER_APPLICATION_ROLE " + "IS_BUILDER_APPLICATION_ROLE2 " + "IS_BUILDER_USERS " + "ISBSYSDEV " + "LOG_FOLDER_PATH " + "mbCancel " + "mbNo " + "mbNoToAll " + "mbOK " + "mbYes " + "mbYesToAll " + "MEMORY_DATASET_DESRIPTIONS_FILENAME " + "mrNo " + "mrNoToAll " + "mrYes " + "mrYesToAll " + "MULTIPLE_SELECT_DIALOG_CODE " + "NONOPERATING_RECORD_FLAG_FEMININE " + "NONOPERATING_RECORD_FLAG_MASCULINE " + "OPERATING_RECORD_FLAG_FEMININE " + "OPERATING_RECORD_FLAG_MASCULINE " + "PROFILING_SETTINGS_COMMON_SETTINGS_CODE_VALUE " + "PROGRAM_INITIATED_LOOKUP_ACTION " + "ratDelete " + "ratEdit " + "ratInsert " + "REPORT_TYPE " + "REQUIRED_PICK_VALUES_VARIABLE " + "rmCard " + "rmList " + "SBRTE_PROGID_DEV " + "SBRTE_PROGID_RELEASE " + "STATIC_ROLE_TYPE_CODE " + "SUPPRESS_EMPTY_TEMPLATE_CREATION " + "SYSTEM_USER_CODE " + "UPDATE_DIALOG_DATASET " + "USED_IN_OBJECT_HINT_PARAM " + "USER_INITIATED_LOOKUP_ACTION " + "USER_NAME_FORMAT " + "USER_SELECTION_RESTRICTIONS " + "WORKFLOW_TEST_PROTOCOLS_FOLDER_PATH " + "ELS_SUBTYPE_CONTROL_NAME " + "ELS_FOLDER_KIND_CONTROL_NAME " + "REPEAT_PROCESS_CURRENT_OBJECT_EXCEPTION_NAME ";

  // Privileges
  var privileges_constants = "PRIVILEGE_COMPONENT_FULL_ACCESS " + "PRIVILEGE_DEVELOPMENT_EXPORT " + "PRIVILEGE_DEVELOPMENT_IMPORT " + "PRIVILEGE_DOCUMENT_DELETE " + "PRIVILEGE_ESD " + "PRIVILEGE_FOLDER_DELETE " + "PRIVILEGE_MANAGE_ACCESS_RIGHTS " + "PRIVILEGE_MANAGE_REPLICATION " + "PRIVILEGE_MANAGE_SESSION_SERVER " + "PRIVILEGE_OBJECT_FULL_ACCESS " + "PRIVILEGE_OBJECT_VIEW " + "PRIVILEGE_RESERVE_LICENSE " + "PRIVILEGE_SYSTEM_CUSTOMIZE " + "PRIVILEGE_SYSTEM_DEVELOP " + "PRIVILEGE_SYSTEM_INSTALL " + "PRIVILEGE_TASK_DELETE " + "PRIVILEGE_USER_PLUGIN_SETTINGS_CUSTOMIZE " + "PRIVILEGES_PSEUDOREFERENCE_CODE ";

  // Pseudoreference code
  var pseudoreference_code_constants = "ACCESS_TYPES_PSEUDOREFERENCE_CODE " + "ALL_AVAILABLE_COMPONENTS_PSEUDOREFERENCE_CODE " + "ALL_AVAILABLE_PRIVILEGES_PSEUDOREFERENCE_CODE " + "ALL_REPLICATE_COMPONENTS_PSEUDOREFERENCE_CODE " + "AVAILABLE_DEVELOPERS_COMPONENTS_PSEUDOREFERENCE_CODE " + "COMPONENTS_PSEUDOREFERENCE_CODE " + "FILTRATER_SETTINGS_CONFLICTS_PSEUDOREFERENCE_CODE " + "GROUPS_PSEUDOREFERENCE_CODE " + "RECEIVE_PROTOCOL_PSEUDOREFERENCE_CODE " + "REFERENCE_REQUISITE_PSEUDOREFERENCE_CODE " + "REFERENCE_REQUISITES_PSEUDOREFERENCE_CODE " + "REFTYPES_PSEUDOREFERENCE_CODE " + "REPLICATION_SEANCES_DIARY_PSEUDOREFERENCE_CODE " + "SEND_PROTOCOL_PSEUDOREFERENCE_CODE " + "SUBSTITUTES_PSEUDOREFERENCE_CODE " + "SYSTEM_SETTINGS_PSEUDOREFERENCE_CODE " + "UNITS_PSEUDOREFERENCE_CODE " + "USERS_PSEUDOREFERENCE_CODE " + "VIEWERS_PSEUDOREFERENCE_CODE ";

  // Requisite ISBCertificateType values
  var requisite_ISBCertificateType_values_constants = "CERTIFICATE_TYPE_ENCRYPT " + "CERTIFICATE_TYPE_SIGN " + "CERTIFICATE_TYPE_SIGN_AND_ENCRYPT ";

  // Requisite ISBEDocStorageType values
  var requisite_ISBEDocStorageType_values_constants = "STORAGE_TYPE_FILE " + "STORAGE_TYPE_NAS_CIFS " + "STORAGE_TYPE_SAPERION " + "STORAGE_TYPE_SQL_SERVER ";

  // Requisite CompType2 values
  var requisite_compType2_values_constants = "COMPTYPE2_REQUISITE_DOCUMENTS_VALUE " + "COMPTYPE2_REQUISITE_TASKS_VALUE " + "COMPTYPE2_REQUISITE_FOLDERS_VALUE " + "COMPTYPE2_REQUISITE_REFERENCES_VALUE ";

  // Requisite name
  var requisite_name_constants = "SYSREQ_CODE " + "SYSREQ_COMPTYPE2 " + "SYSREQ_CONST_AVAILABLE_FOR_WEB " + "SYSREQ_CONST_COMMON_CODE " + "SYSREQ_CONST_COMMON_VALUE " + "SYSREQ_CONST_FIRM_CODE " + "SYSREQ_CONST_FIRM_STATUS " + "SYSREQ_CONST_FIRM_VALUE " + "SYSREQ_CONST_SERVER_STATUS " + "SYSREQ_CONTENTS " + "SYSREQ_DATE_OPEN " + "SYSREQ_DATE_CLOSE " + "SYSREQ_DESCRIPTION " + "SYSREQ_DESCRIPTION_LOCALIZE_ID " + "SYSREQ_DOUBLE " + "SYSREQ_EDOC_ACCESS_TYPE " + "SYSREQ_EDOC_AUTHOR " + "SYSREQ_EDOC_CREATED " + "SYSREQ_EDOC_DELEGATE_RIGHTS_REQUISITE_CODE " + "SYSREQ_EDOC_EDITOR " + "SYSREQ_EDOC_ENCODE_TYPE " + "SYSREQ_EDOC_ENCRYPTION_PLUGIN_NAME " + "SYSREQ_EDOC_ENCRYPTION_PLUGIN_VERSION " + "SYSREQ_EDOC_EXPORT_DATE " + "SYSREQ_EDOC_EXPORTER " + "SYSREQ_EDOC_KIND " + "SYSREQ_EDOC_LIFE_STAGE_NAME " + "SYSREQ_EDOC_LOCKED_FOR_SERVER_CODE " + "SYSREQ_EDOC_MODIFIED " + "SYSREQ_EDOC_NAME " + "SYSREQ_EDOC_NOTE " + "SYSREQ_EDOC_QUALIFIED_ID " + "SYSREQ_EDOC_SESSION_KEY " + "SYSREQ_EDOC_SESSION_KEY_ENCRYPTION_PLUGIN_NAME " + "SYSREQ_EDOC_SESSION_KEY_ENCRYPTION_PLUGIN_VERSION " + "SYSREQ_EDOC_SIGNATURE_TYPE " + "SYSREQ_EDOC_SIGNED " + "SYSREQ_EDOC_STORAGE " + "SYSREQ_EDOC_STORAGES_ARCHIVE_STORAGE " + "SYSREQ_EDOC_STORAGES_CHECK_RIGHTS " + "SYSREQ_EDOC_STORAGES_COMPUTER_NAME " + "SYSREQ_EDOC_STORAGES_EDIT_IN_STORAGE " + "SYSREQ_EDOC_STORAGES_EXECUTIVE_STORAGE " + "SYSREQ_EDOC_STORAGES_FUNCTION " + "SYSREQ_EDOC_STORAGES_INITIALIZED " + "SYSREQ_EDOC_STORAGES_LOCAL_PATH " + "SYSREQ_EDOC_STORAGES_SAPERION_DATABASE_NAME " + "SYSREQ_EDOC_STORAGES_SEARCH_BY_TEXT " + "SYSREQ_EDOC_STORAGES_SERVER_NAME " + "SYSREQ_EDOC_STORAGES_SHARED_SOURCE_NAME " + "SYSREQ_EDOC_STORAGES_TYPE " + "SYSREQ_EDOC_TEXT_MODIFIED " + "SYSREQ_EDOC_TYPE_ACT_CODE " + "SYSREQ_EDOC_TYPE_ACT_DESCRIPTION " + "SYSREQ_EDOC_TYPE_ACT_DESCRIPTION_LOCALIZE_ID " + "SYSREQ_EDOC_TYPE_ACT_ON_EXECUTE " + "SYSREQ_EDOC_TYPE_ACT_ON_EXECUTE_EXISTS " + "SYSREQ_EDOC_TYPE_ACT_SECTION " + "SYSREQ_EDOC_TYPE_ADD_PARAMS " + "SYSREQ_EDOC_TYPE_COMMENT " + "SYSREQ_EDOC_TYPE_EVENT_TEXT " + "SYSREQ_EDOC_TYPE_NAME_IN_SINGULAR " + "SYSREQ_EDOC_TYPE_NAME_IN_SINGULAR_LOCALIZE_ID " + "SYSREQ_EDOC_TYPE_NAME_LOCALIZE_ID " + "SYSREQ_EDOC_TYPE_NUMERATION_METHOD " + "SYSREQ_EDOC_TYPE_PSEUDO_REQUISITE_CODE " + "SYSREQ_EDOC_TYPE_REQ_CODE " + "SYSREQ_EDOC_TYPE_REQ_DESCRIPTION " + "SYSREQ_EDOC_TYPE_REQ_DESCRIPTION_LOCALIZE_ID " + "SYSREQ_EDOC_TYPE_REQ_IS_LEADING " + "SYSREQ_EDOC_TYPE_REQ_IS_REQUIRED " + "SYSREQ_EDOC_TYPE_REQ_NUMBER " + "SYSREQ_EDOC_TYPE_REQ_ON_CHANGE " + "SYSREQ_EDOC_TYPE_REQ_ON_CHANGE_EXISTS " + "SYSREQ_EDOC_TYPE_REQ_ON_SELECT " + "SYSREQ_EDOC_TYPE_REQ_ON_SELECT_KIND " + "SYSREQ_EDOC_TYPE_REQ_SECTION " + "SYSREQ_EDOC_TYPE_VIEW_CARD " + "SYSREQ_EDOC_TYPE_VIEW_CODE " + "SYSREQ_EDOC_TYPE_VIEW_COMMENT " + "SYSREQ_EDOC_TYPE_VIEW_IS_MAIN " + "SYSREQ_EDOC_TYPE_VIEW_NAME " + "SYSREQ_EDOC_TYPE_VIEW_NAME_LOCALIZE_ID " + "SYSREQ_EDOC_VERSION_AUTHOR " + "SYSREQ_EDOC_VERSION_CRC " + "SYSREQ_EDOC_VERSION_DATA " + "SYSREQ_EDOC_VERSION_EDITOR " + "SYSREQ_EDOC_VERSION_EXPORT_DATE " + "SYSREQ_EDOC_VERSION_EXPORTER " + "SYSREQ_EDOC_VERSION_HIDDEN " + "SYSREQ_EDOC_VERSION_LIFE_STAGE " + "SYSREQ_EDOC_VERSION_MODIFIED " + "SYSREQ_EDOC_VERSION_NOTE " + "SYSREQ_EDOC_VERSION_SIGNATURE_TYPE " + "SYSREQ_EDOC_VERSION_SIGNED " + "SYSREQ_EDOC_VERSION_SIZE " + "SYSREQ_EDOC_VERSION_SOURCE " + "SYSREQ_EDOC_VERSION_TEXT_MODIFIED " + "SYSREQ_EDOCKIND_DEFAULT_VERSION_STATE_CODE " + "SYSREQ_FOLDER_KIND " + "SYSREQ_FUNC_CATEGORY " + "SYSREQ_FUNC_COMMENT " + "SYSREQ_FUNC_GROUP " + "SYSREQ_FUNC_GROUP_COMMENT " + "SYSREQ_FUNC_GROUP_NUMBER " + "SYSREQ_FUNC_HELP " + "SYSREQ_FUNC_PARAM_DEF_VALUE " + "SYSREQ_FUNC_PARAM_IDENT " + "SYSREQ_FUNC_PARAM_NUMBER " + "SYSREQ_FUNC_PARAM_TYPE " + "SYSREQ_FUNC_TEXT " + "SYSREQ_GROUP_CATEGORY " + "SYSREQ_ID " + "SYSREQ_LAST_UPDATE " + "SYSREQ_LEADER_REFERENCE " + "SYSREQ_LINE_NUMBER " + "SYSREQ_MAIN_RECORD_ID " + "SYSREQ_NAME " + "SYSREQ_NAME_LOCALIZE_ID " + "SYSREQ_NOTE " + "SYSREQ_ORIGINAL_RECORD " + "SYSREQ_OUR_FIRM " + "SYSREQ_PROFILING_SETTINGS_BATCH_LOGING " + "SYSREQ_PROFILING_SETTINGS_BATCH_SIZE " + "SYSREQ_PROFILING_SETTINGS_PROFILING_ENABLED " + "SYSREQ_PROFILING_SETTINGS_SQL_PROFILING_ENABLED " + "SYSREQ_PROFILING_SETTINGS_START_LOGGED " + "SYSREQ_RECORD_STATUS " + "SYSREQ_REF_REQ_FIELD_NAME " + "SYSREQ_REF_REQ_FORMAT " + "SYSREQ_REF_REQ_GENERATED " + "SYSREQ_REF_REQ_LENGTH " + "SYSREQ_REF_REQ_PRECISION " + "SYSREQ_REF_REQ_REFERENCE " + "SYSREQ_REF_REQ_SECTION " + "SYSREQ_REF_REQ_STORED " + "SYSREQ_REF_REQ_TOKENS " + "SYSREQ_REF_REQ_TYPE " + "SYSREQ_REF_REQ_VIEW " + "SYSREQ_REF_TYPE_ACT_CODE " + "SYSREQ_REF_TYPE_ACT_DESCRIPTION " + "SYSREQ_REF_TYPE_ACT_DESCRIPTION_LOCALIZE_ID " + "SYSREQ_REF_TYPE_ACT_ON_EXECUTE " + "SYSREQ_REF_TYPE_ACT_ON_EXECUTE_EXISTS " + "SYSREQ_REF_TYPE_ACT_SECTION " + "SYSREQ_REF_TYPE_ADD_PARAMS " + "SYSREQ_REF_TYPE_COMMENT " + "SYSREQ_REF_TYPE_COMMON_SETTINGS " + "SYSREQ_REF_TYPE_DISPLAY_REQUISITE_NAME " + "SYSREQ_REF_TYPE_EVENT_TEXT " + "SYSREQ_REF_TYPE_MAIN_LEADING_REF " + "SYSREQ_REF_TYPE_NAME_IN_SINGULAR " + "SYSREQ_REF_TYPE_NAME_IN_SINGULAR_LOCALIZE_ID " + "SYSREQ_REF_TYPE_NAME_LOCALIZE_ID " + "SYSREQ_REF_TYPE_NUMERATION_METHOD " + "SYSREQ_REF_TYPE_REQ_CODE " + "SYSREQ_REF_TYPE_REQ_DESCRIPTION " + "SYSREQ_REF_TYPE_REQ_DESCRIPTION_LOCALIZE_ID " + "SYSREQ_REF_TYPE_REQ_IS_CONTROL " + "SYSREQ_REF_TYPE_REQ_IS_FILTER " + "SYSREQ_REF_TYPE_REQ_IS_LEADING " + "SYSREQ_REF_TYPE_REQ_IS_REQUIRED " + "SYSREQ_REF_TYPE_REQ_NUMBER " + "SYSREQ_REF_TYPE_REQ_ON_CHANGE " + "SYSREQ_REF_TYPE_REQ_ON_CHANGE_EXISTS " + "SYSREQ_REF_TYPE_REQ_ON_SELECT " + "SYSREQ_REF_TYPE_REQ_ON_SELECT_KIND " + "SYSREQ_REF_TYPE_REQ_SECTION " + "SYSREQ_REF_TYPE_VIEW_CARD " + "SYSREQ_REF_TYPE_VIEW_CODE " + "SYSREQ_REF_TYPE_VIEW_COMMENT " + "SYSREQ_REF_TYPE_VIEW_IS_MAIN " + "SYSREQ_REF_TYPE_VIEW_NAME " + "SYSREQ_REF_TYPE_VIEW_NAME_LOCALIZE_ID " + "SYSREQ_REFERENCE_TYPE_ID " + "SYSREQ_STATE " + "SYSREQ_STATЕ " + "SYSREQ_SYSTEM_SETTINGS_VALUE " + "SYSREQ_TYPE " + "SYSREQ_UNIT " + "SYSREQ_UNIT_ID " + "SYSREQ_USER_GROUPS_GROUP_FULL_NAME " + "SYSREQ_USER_GROUPS_GROUP_NAME " + "SYSREQ_USER_GROUPS_GROUP_SERVER_NAME " + "SYSREQ_USERS_ACCESS_RIGHTS " + "SYSREQ_USERS_AUTHENTICATION " + "SYSREQ_USERS_CATEGORY " + "SYSREQ_USERS_COMPONENT " + "SYSREQ_USERS_COMPONENT_USER_IS_PUBLIC " + "SYSREQ_USERS_DOMAIN " + "SYSREQ_USERS_FULL_USER_NAME " + "SYSREQ_USERS_GROUP " + "SYSREQ_USERS_IS_MAIN_SERVER " + "SYSREQ_USERS_LOGIN " + "SYSREQ_USERS_REFERENCE_USER_IS_PUBLIC " + "SYSREQ_USERS_STATUS " + "SYSREQ_USERS_USER_CERTIFICATE " + "SYSREQ_USERS_USER_CERTIFICATE_INFO " + "SYSREQ_USERS_USER_CERTIFICATE_PLUGIN_NAME " + "SYSREQ_USERS_USER_CERTIFICATE_PLUGIN_VERSION " + "SYSREQ_USERS_USER_CERTIFICATE_STATE " + "SYSREQ_USERS_USER_CERTIFICATE_SUBJECT_NAME " + "SYSREQ_USERS_USER_CERTIFICATE_THUMBPRINT " + "SYSREQ_USERS_USER_DEFAULT_CERTIFICATE " + "SYSREQ_USERS_USER_DESCRIPTION " + "SYSREQ_USERS_USER_GLOBAL_NAME " + "SYSREQ_USERS_USER_LOGIN " + "SYSREQ_USERS_USER_MAIN_SERVER " + "SYSREQ_USERS_USER_TYPE " + "SYSREQ_WORK_RULES_FOLDER_ID ";

  // Result
  var result_constants = "RESULT_VAR_NAME RESULT_VAR_NAME_ENG ";

  // Rule identification
  var rule_identification_constants = "AUTO_NUMERATION_RULE_ID " + "CANT_CHANGE_ID_REQUISITE_RULE_ID " + "CANT_CHANGE_OURFIRM_REQUISITE_RULE_ID " + "CHECK_CHANGING_REFERENCE_RECORD_USE_RULE_ID " + "CHECK_CODE_REQUISITE_RULE_ID " + "CHECK_DELETING_REFERENCE_RECORD_USE_RULE_ID " + "CHECK_FILTRATER_CHANGES_RULE_ID " + "CHECK_RECORD_INTERVAL_RULE_ID " + "CHECK_REFERENCE_INTERVAL_RULE_ID " + "CHECK_REQUIRED_DATA_FULLNESS_RULE_ID " + "CHECK_REQUIRED_REQUISITES_FULLNESS_RULE_ID " + "MAKE_RECORD_UNRATIFIED_RULE_ID " + "RESTORE_AUTO_NUMERATION_RULE_ID " + "SET_FIRM_CONTEXT_FROM_RECORD_RULE_ID " + "SET_FIRST_RECORD_IN_LIST_FORM_RULE_ID " + "SET_IDSPS_VALUE_RULE_ID " + "SET_NEXT_CODE_VALUE_RULE_ID " + "SET_OURFIRM_BOUNDS_RULE_ID " + "SET_OURFIRM_REQUISITE_RULE_ID ";

  // Script block properties
  var script_block_properties_constants = "SCRIPT_BLOCK_AFTER_FINISH_EVENT " + "SCRIPT_BLOCK_BEFORE_START_EVENT " + "SCRIPT_BLOCK_EXECUTION_RESULTS_PROPERTY " + "SCRIPT_BLOCK_NAME_PROPERTY " + "SCRIPT_BLOCK_SCRIPT_PROPERTY ";

  // Subtask block properties
  var subtask_block_properties_constants = "SUBTASK_BLOCK_ABORT_DEADLINE_PROPERTY " + "SUBTASK_BLOCK_AFTER_FINISH_EVENT " + "SUBTASK_BLOCK_ASSIGN_PARAMS_EVENT " + "SUBTASK_BLOCK_ATTACHMENTS_PROPERTY " + "SUBTASK_BLOCK_ATTACHMENTS_RIGHTS_GROUP_PROPERTY " + "SUBTASK_BLOCK_ATTACHMENTS_RIGHTS_TYPE_PROPERTY " + "SUBTASK_BLOCK_BEFORE_START_EVENT " + "SUBTASK_BLOCK_CREATED_TASK_PROPERTY " + "SUBTASK_BLOCK_CREATION_EVENT " + "SUBTASK_BLOCK_DEADLINE_PROPERTY " + "SUBTASK_BLOCK_IMPORTANCE_PROPERTY " + "SUBTASK_BLOCK_INITIATOR_PROPERTY " + "SUBTASK_BLOCK_IS_RELATIVE_ABORT_DEADLINE_PROPERTY " + "SUBTASK_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY " + "SUBTASK_BLOCK_JOBS_TYPE_PROPERTY " + "SUBTASK_BLOCK_NAME_PROPERTY " + "SUBTASK_BLOCK_PARALLEL_ROUTE_PROPERTY " + "SUBTASK_BLOCK_PERFORMERS_PROPERTY " + "SUBTASK_BLOCK_RELATIVE_ABORT_DEADLINE_TYPE_PROPERTY " + "SUBTASK_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY " + "SUBTASK_BLOCK_REQUIRE_SIGN_PROPERTY " + "SUBTASK_BLOCK_STANDARD_ROUTE_PROPERTY " + "SUBTASK_BLOCK_START_EVENT " + "SUBTASK_BLOCK_STEP_CONTROL_PROPERTY " + "SUBTASK_BLOCK_SUBJECT_PROPERTY " + "SUBTASK_BLOCK_TASK_CONTROL_PROPERTY " + "SUBTASK_BLOCK_TEXT_PROPERTY " + "SUBTASK_BLOCK_UNLOCK_ATTACHMENTS_ON_STOP_PROPERTY " + "SUBTASK_BLOCK_USE_STANDARD_ROUTE_PROPERTY " + "SUBTASK_BLOCK_WAIT_FOR_TASK_COMPLETE_PROPERTY ";

  // System component
  var system_component_constants = "SYSCOMP_CONTROL_JOBS " + "SYSCOMP_FOLDERS " + "SYSCOMP_JOBS " + "SYSCOMP_NOTICES " + "SYSCOMP_TASKS ";

  // System dialogs
  var system_dialogs_constants = "SYSDLG_CREATE_EDOCUMENT " + "SYSDLG_CREATE_EDOCUMENT_VERSION " + "SYSDLG_CURRENT_PERIOD " + "SYSDLG_EDIT_FUNCTION_HELP " + "SYSDLG_EDOCUMENT_KINDS_FOR_TEMPLATE " + "SYSDLG_EXPORT_MULTIPLE_EDOCUMENTS " + "SYSDLG_EXPORT_SINGLE_EDOCUMENT " + "SYSDLG_IMPORT_EDOCUMENT " + "SYSDLG_MULTIPLE_SELECT " + "SYSDLG_SETUP_ACCESS_RIGHTS " + "SYSDLG_SETUP_DEFAULT_RIGHTS " + "SYSDLG_SETUP_FILTER_CONDITION " + "SYSDLG_SETUP_SIGN_RIGHTS " + "SYSDLG_SETUP_TASK_OBSERVERS " + "SYSDLG_SETUP_TASK_ROUTE " + "SYSDLG_SETUP_USERS_LIST " + "SYSDLG_SIGN_EDOCUMENT " + "SYSDLG_SIGN_MULTIPLE_EDOCUMENTS ";

  // System reference names
  var system_reference_names_constants = "SYSREF_ACCESS_RIGHTS_TYPES " + "SYSREF_ADMINISTRATION_HISTORY " + "SYSREF_ALL_AVAILABLE_COMPONENTS " + "SYSREF_ALL_AVAILABLE_PRIVILEGES " + "SYSREF_ALL_REPLICATING_COMPONENTS " + "SYSREF_AVAILABLE_DEVELOPERS_COMPONENTS " + "SYSREF_CALENDAR_EVENTS " + "SYSREF_COMPONENT_TOKEN_HISTORY " + "SYSREF_COMPONENT_TOKENS " + "SYSREF_COMPONENTS " + "SYSREF_CONSTANTS " + "SYSREF_DATA_RECEIVE_PROTOCOL " + "SYSREF_DATA_SEND_PROTOCOL " + "SYSREF_DIALOGS " + "SYSREF_DIALOGS_REQUISITES " + "SYSREF_EDITORS " + "SYSREF_EDOC_CARDS " + "SYSREF_EDOC_TYPES " + "SYSREF_EDOCUMENT_CARD_REQUISITES " + "SYSREF_EDOCUMENT_CARD_TYPES " + "SYSREF_EDOCUMENT_CARD_TYPES_REFERENCE " + "SYSREF_EDOCUMENT_CARDS " + "SYSREF_EDOCUMENT_HISTORY " + "SYSREF_EDOCUMENT_KINDS " + "SYSREF_EDOCUMENT_REQUISITES " + "SYSREF_EDOCUMENT_SIGNATURES " + "SYSREF_EDOCUMENT_TEMPLATES " + "SYSREF_EDOCUMENT_TEXT_STORAGES " + "SYSREF_EDOCUMENT_VIEWS " + "SYSREF_FILTERER_SETUP_CONFLICTS " + "SYSREF_FILTRATER_SETTING_CONFLICTS " + "SYSREF_FOLDER_HISTORY " + "SYSREF_FOLDERS " + "SYSREF_FUNCTION_GROUPS " + "SYSREF_FUNCTION_PARAMS " + "SYSREF_FUNCTIONS " + "SYSREF_JOB_HISTORY " + "SYSREF_LINKS " + "SYSREF_LOCALIZATION_DICTIONARY " + "SYSREF_LOCALIZATION_LANGUAGES " + "SYSREF_MODULES " + "SYSREF_PRIVILEGES " + "SYSREF_RECORD_HISTORY " + "SYSREF_REFERENCE_REQUISITES " + "SYSREF_REFERENCE_TYPE_VIEWS " + "SYSREF_REFERENCE_TYPES " + "SYSREF_REFERENCES " + "SYSREF_REFERENCES_REQUISITES " + "SYSREF_REMOTE_SERVERS " + "SYSREF_REPLICATION_SESSIONS_LOG " + "SYSREF_REPLICATION_SESSIONS_PROTOCOL " + "SYSREF_REPORTS " + "SYSREF_ROLES " + "SYSREF_ROUTE_BLOCK_GROUPS " + "SYSREF_ROUTE_BLOCKS " + "SYSREF_SCRIPTS " + "SYSREF_SEARCHES " + "SYSREF_SERVER_EVENTS " + "SYSREF_SERVER_EVENTS_HISTORY " + "SYSREF_STANDARD_ROUTE_GROUPS " + "SYSREF_STANDARD_ROUTES " + "SYSREF_STATUSES " + "SYSREF_SYSTEM_SETTINGS " + "SYSREF_TASK_HISTORY " + "SYSREF_TASK_KIND_GROUPS " + "SYSREF_TASK_KINDS " + "SYSREF_TASK_RIGHTS " + "SYSREF_TASK_SIGNATURES " + "SYSREF_TASKS " + "SYSREF_UNITS " + "SYSREF_USER_GROUPS " + "SYSREF_USER_GROUPS_REFERENCE " + "SYSREF_USER_SUBSTITUTION " + "SYSREF_USERS " + "SYSREF_USERS_REFERENCE " + "SYSREF_VIEWERS " + "SYSREF_WORKING_TIME_CALENDARS ";

  // Table name
  var table_name_constants = "ACCESS_RIGHTS_TABLE_NAME " + "EDMS_ACCESS_TABLE_NAME " + "EDOC_TYPES_TABLE_NAME ";

  // Test
  var test_constants = "TEST_DEV_DB_NAME " + "TEST_DEV_SYSTEM_CODE " + "TEST_EDMS_DB_NAME " + "TEST_EDMS_MAIN_CODE " + "TEST_EDMS_MAIN_DB_NAME " + "TEST_EDMS_SECOND_CODE " + "TEST_EDMS_SECOND_DB_NAME " + "TEST_EDMS_SYSTEM_CODE " + "TEST_ISB5_MAIN_CODE " + "TEST_ISB5_SECOND_CODE " + "TEST_SQL_SERVER_2005_NAME " + "TEST_SQL_SERVER_NAME ";

  // Using the dialog windows
  var using_the_dialog_windows_constants = "ATTENTION_CAPTION " + "cbsCommandLinks " + "cbsDefault " + "CONFIRMATION_CAPTION " + "ERROR_CAPTION " + "INFORMATION_CAPTION " + "mrCancel " + "mrOk ";

  // Using the document
  var using_the_document_constants = "EDOC_VERSION_ACTIVE_STAGE_CODE " + "EDOC_VERSION_DESIGN_STAGE_CODE " + "EDOC_VERSION_OBSOLETE_STAGE_CODE ";

  // Using the EA and encryption
  var using_the_EA_and_encryption_constants = "cpDataEnciphermentEnabled " + "cpDigitalSignatureEnabled " + "cpID " + "cpIssuer " + "cpPluginVersion " + "cpSerial " + "cpSubjectName " + "cpSubjSimpleName " + "cpValidFromDate " + "cpValidToDate ";

  // Using the ISBL-editor
  var using_the_ISBL_editor_constants = "ISBL_SYNTAX " + "NO_SYNTAX " + "XML_SYNTAX ";

  // Wait block properties
  var wait_block_properties_constants = "WAIT_BLOCK_AFTER_FINISH_EVENT " + "WAIT_BLOCK_BEFORE_START_EVENT " + "WAIT_BLOCK_DEADLINE_PROPERTY " + "WAIT_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY " + "WAIT_BLOCK_NAME_PROPERTY " + "WAIT_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY ";

  // SYSRES Common
  var sysres_common_constants = "SYSRES_COMMON " + "SYSRES_CONST " + "SYSRES_MBFUNC " + "SYSRES_SBDATA " + "SYSRES_SBGUI " + "SYSRES_SBINTF " + "SYSRES_SBREFDSC " + "SYSRES_SQLERRORS " + "SYSRES_SYSCOMP ";

  // Константы ==> built_in
  var CONSTANTS = sysres_constants + base_constants + base_group_name_constants + decision_block_properties_constants + file_extension_constants + job_block_properties_constants + language_code_constants + launching_external_applications_constants + link_kind_constants + lock_type_constants + monitor_block_properties_constants + notice_block_properties_constants + object_events_constants + object_params_constants + other_constants + privileges_constants + pseudoreference_code_constants + requisite_ISBCertificateType_values_constants + requisite_ISBEDocStorageType_values_constants + requisite_compType2_values_constants + requisite_name_constants + result_constants + rule_identification_constants + script_block_properties_constants + subtask_block_properties_constants + system_component_constants + system_dialogs_constants + system_reference_names_constants + table_name_constants + test_constants + using_the_dialog_windows_constants + using_the_document_constants + using_the_EA_and_encryption_constants + using_the_ISBL_editor_constants + wait_block_properties_constants + sysres_common_constants;

  // enum TAccountType
  var TAccountType = "atUser atGroup atRole ";

  // enum TActionEnabledMode
  var TActionEnabledMode = "aemEnabledAlways " + "aemDisabledAlways " + "aemEnabledOnBrowse " + "aemEnabledOnEdit " + "aemDisabledOnBrowseEmpty ";

  // enum TAddPosition
  var TAddPosition = "apBegin apEnd ";

  // enum TAlignment
  var TAlignment = "alLeft alRight ";

  // enum TAreaShowMode
  var TAreaShowMode = "asmNever " + "asmNoButCustomize " + "asmAsLastTime " + "asmYesButCustomize " + "asmAlways ";

  // enum TCertificateInvalidationReason
  var TCertificateInvalidationReason = "cirCommon cirRevoked ";

  // enum TCertificateType
  var TCertificateType = "ctSignature ctEncode ctSignatureEncode ";

  // enum TCheckListBoxItemState
  var TCheckListBoxItemState = "clbUnchecked clbChecked clbGrayed ";

  // enum TCloseOnEsc
  var TCloseOnEsc = "ceISB ceAlways ceNever ";

  // enum TCompType
  var TCompType = "ctDocument " + "ctReference " + "ctScript " + "ctUnknown " + "ctReport " + "ctDialog " + "ctFunction " + "ctFolder " + "ctEDocument " + "ctTask " + "ctJob " + "ctNotice " + "ctControlJob ";

  // enum TConditionFormat
  var TConditionFormat = "cfInternal cfDisplay ";

  // enum TConnectionIntent
  var TConnectionIntent = "ciUnspecified ciWrite ciRead ";

  // enum TContentKind
  var TContentKind = "ckFolder " + "ckEDocument " + "ckTask " + "ckJob " + "ckComponentToken " + "ckAny " + "ckReference " + "ckScript " + "ckReport " + "ckDialog ";

  // enum TControlType
  var TControlType = "ctISBLEditor " + "ctBevel " + "ctButton " + "ctCheckListBox " + "ctComboBox " + "ctComboEdit " + "ctGrid " + "ctDBCheckBox " + "ctDBComboBox " + "ctDBEdit " + "ctDBEllipsis " + "ctDBMemo " + "ctDBNavigator " + "ctDBRadioGroup " + "ctDBStatusLabel " + "ctEdit " + "ctGroupBox " + "ctInplaceHint " + "ctMemo " + "ctPanel " + "ctListBox " + "ctRadioButton " + "ctRichEdit " + "ctTabSheet " + "ctWebBrowser " + "ctImage " + "ctHyperLink " + "ctLabel " + "ctDBMultiEllipsis " + "ctRibbon " + "ctRichView " + "ctInnerPanel " + "ctPanelGroup " + "ctBitButton ";

  // enum TCriterionContentType
  var TCriterionContentType = "cctDate " + "cctInteger " + "cctNumeric " + "cctPick " + "cctReference " + "cctString " + "cctText ";

  // enum TCultureType
  var TCultureType = "cltInternal cltPrimary cltGUI ";

  // enum TDataSetEventType
  var TDataSetEventType = "dseBeforeOpen " + "dseAfterOpen " + "dseBeforeClose " + "dseAfterClose " + "dseOnValidDelete " + "dseBeforeDelete " + "dseAfterDelete " + "dseAfterDeleteOutOfTransaction " + "dseOnDeleteError " + "dseBeforeInsert " + "dseAfterInsert " + "dseOnValidUpdate " + "dseBeforeUpdate " + "dseOnUpdateRatifiedRecord " + "dseAfterUpdate " + "dseAfterUpdateOutOfTransaction " + "dseOnUpdateError " + "dseAfterScroll " + "dseOnOpenRecord " + "dseOnCloseRecord " + "dseBeforeCancel " + "dseAfterCancel " + "dseOnUpdateDeadlockError " + "dseBeforeDetailUpdate " + "dseOnPrepareUpdate " + "dseOnAnyRequisiteChange ";

  // enum TDataSetState
  var TDataSetState = "dssEdit dssInsert dssBrowse dssInActive ";

  // enum TDateFormatType
  var TDateFormatType = "dftDate dftShortDate dftDateTime dftTimeStamp ";

  // enum TDateOffsetType
  var TDateOffsetType = "dotDays dotHours dotMinutes dotSeconds ";

  // enum TDateTimeKind
  var TDateTimeKind = "dtkndLocal dtkndUTC ";

  // enum TDeaAccessRights
  var TDeaAccessRights = "arNone arView arEdit arFull ";

  // enum TDocumentDefaultAction
  var TDocumentDefaultAction = "ddaView ddaEdit ";

  // enum TEditMode
  var TEditMode = "emLock " + "emEdit " + "emSign " + "emExportWithLock " + "emImportWithUnlock " + "emChangeVersionNote " + "emOpenForModify " + "emChangeLifeStage " + "emDelete " + "emCreateVersion " + "emImport " + "emUnlockExportedWithLock " + "emStart " + "emAbort " + "emReInit " + "emMarkAsReaded " + "emMarkAsUnreaded " + "emPerform " + "emAccept " + "emResume " + "emChangeRights " + "emEditRoute " + "emEditObserver " + "emRecoveryFromLocalCopy " + "emChangeWorkAccessType " + "emChangeEncodeTypeToCertificate " + "emChangeEncodeTypeToPassword " + "emChangeEncodeTypeToNone " + "emChangeEncodeTypeToCertificatePassword " + "emChangeStandardRoute " + "emGetText " + "emOpenForView " + "emMoveToStorage " + "emCreateObject " + "emChangeVersionHidden " + "emDeleteVersion " + "emChangeLifeCycleStage " + "emApprovingSign " + "emExport " + "emContinue " + "emLockFromEdit " + "emUnLockForEdit " + "emLockForServer " + "emUnlockFromServer " + "emDelegateAccessRights " + "emReEncode ";

  // enum TEditorCloseObservType
  var TEditorCloseObservType = "ecotFile ecotProcess ";

  // enum TEdmsApplicationAction
  var TEdmsApplicationAction = "eaGet eaCopy eaCreate eaCreateStandardRoute ";

  // enum TEDocumentLockType
  var TEDocumentLockType = "edltAll edltNothing edltQuery ";

  // enum TEDocumentStepShowMode
  var TEDocumentStepShowMode = "essmText essmCard ";

  // enum TEDocumentStepVersionType
  var TEDocumentStepVersionType = "esvtLast esvtLastActive esvtSpecified ";

  // enum TEDocumentStorageFunction
  var TEDocumentStorageFunction = "edsfExecutive edsfArchive ";

  // enum TEDocumentStorageType
  var TEDocumentStorageType = "edstSQLServer edstFile ";

  // enum TEDocumentVersionSourceType
  var TEDocumentVersionSourceType = "edvstNone edvstEDocumentVersionCopy edvstFile edvstTemplate edvstScannedFile ";

  // enum TEDocumentVersionState
  var TEDocumentVersionState = "vsDefault vsDesign vsActive vsObsolete ";

  // enum TEncodeType
  var TEncodeType = "etNone etCertificate etPassword etCertificatePassword ";

  // enum TExceptionCategory
  var TExceptionCategory = "ecException ecWarning ecInformation ";

  // enum TExportedSignaturesType
  var TExportedSignaturesType = "estAll estApprovingOnly ";

  // enum TExportedVersionType
  var TExportedVersionType = "evtLast evtLastActive evtQuery ";

  // enum TFieldDataType
  var TFieldDataType = "fdtString " + "fdtNumeric " + "fdtInteger " + "fdtDate " + "fdtText " + "fdtUnknown " + "fdtWideString " + "fdtLargeInteger ";

  // enum TFolderType
  var TFolderType = "ftInbox " + "ftOutbox " + "ftFavorites " + "ftCommonFolder " + "ftUserFolder " + "ftComponents " + "ftQuickLaunch " + "ftShortcuts " + "ftSearch ";

  // enum TGridRowHeight
  var TGridRowHeight = "grhAuto " + "grhX1 " + "grhX2 " + "grhX3 ";

  // enum THyperlinkType
  var THyperlinkType = "hltText " + "hltRTF " + "hltHTML ";

  // enum TImageFileFormat
  var TImageFileFormat = "iffBMP " + "iffJPEG " + "iffMultiPageTIFF " + "iffSinglePageTIFF " + "iffTIFF " + "iffPNG ";

  // enum TImageMode
  var TImageMode = "im8bGrayscale " + "im24bRGB " + "im1bMonochrome ";

  // enum TImageType
  var TImageType = "itBMP " + "itJPEG " + "itWMF " + "itPNG ";

  // enum TInplaceHintKind
  var TInplaceHintKind = "ikhInformation " + "ikhWarning " + "ikhError " + "ikhNoIcon ";

  // enum TISBLContext
  var TISBLContext = "icUnknown " + "icScript " + "icFunction " + "icIntegratedReport " + "icAnalyticReport " + "icDataSetEventHandler " + "icActionHandler " + "icFormEventHandler " + "icLookUpEventHandler " + "icRequisiteChangeEventHandler " + "icBeforeSearchEventHandler " + "icRoleCalculation " + "icSelectRouteEventHandler " + "icBlockPropertyCalculation " + "icBlockQueryParamsEventHandler " + "icChangeSearchResultEventHandler " + "icBlockEventHandler " + "icSubTaskInitEventHandler " + "icEDocDataSetEventHandler " + "icEDocLookUpEventHandler " + "icEDocActionHandler " + "icEDocFormEventHandler " + "icEDocRequisiteChangeEventHandler " + "icStructuredConversionRule " + "icStructuredConversionEventBefore " + "icStructuredConversionEventAfter " + "icWizardEventHandler " + "icWizardFinishEventHandler " + "icWizardStepEventHandler " + "icWizardStepFinishEventHandler " + "icWizardActionEnableEventHandler " + "icWizardActionExecuteEventHandler " + "icCreateJobsHandler " + "icCreateNoticesHandler " + "icBeforeLookUpEventHandler " + "icAfterLookUpEventHandler " + "icTaskAbortEventHandler " + "icWorkflowBlockActionHandler " + "icDialogDataSetEventHandler " + "icDialogActionHandler " + "icDialogLookUpEventHandler " + "icDialogRequisiteChangeEventHandler " + "icDialogFormEventHandler " + "icDialogValidCloseEventHandler " + "icBlockFormEventHandler " + "icTaskFormEventHandler " + "icReferenceMethod " + "icEDocMethod " + "icDialogMethod " + "icProcessMessageHandler ";

  // enum TItemShow
  var TItemShow = "isShow " + "isHide " + "isByUserSettings ";

  // enum TJobKind
  var TJobKind = "jkJob " + "jkNotice " + "jkControlJob ";

  // enum TJoinType
  var TJoinType = "jtInner " + "jtLeft " + "jtRight " + "jtFull " + "jtCross ";

  // enum TLabelPos
  var TLabelPos = "lbpAbove " + "lbpBelow " + "lbpLeft " + "lbpRight ";

  // enum TLicensingType
  var TLicensingType = "eltPerConnection " + "eltPerUser ";

  // enum TLifeCycleStageFontColor
  var TLifeCycleStageFontColor = "sfcUndefined " + "sfcBlack " + "sfcGreen " + "sfcRed " + "sfcBlue " + "sfcOrange " + "sfcLilac ";

  // enum TLifeCycleStageFontStyle
  var TLifeCycleStageFontStyle = "sfsItalic " + "sfsStrikeout " + "sfsNormal ";

  // enum TLockableDevelopmentComponentType
  var TLockableDevelopmentComponentType = "ldctStandardRoute " + "ldctWizard " + "ldctScript " + "ldctFunction " + "ldctRouteBlock " + "ldctIntegratedReport " + "ldctAnalyticReport " + "ldctReferenceType " + "ldctEDocumentType " + "ldctDialog " + "ldctServerEvents ";

  // enum TMaxRecordCountRestrictionType
  var TMaxRecordCountRestrictionType = "mrcrtNone " + "mrcrtUser " + "mrcrtMaximal " + "mrcrtCustom ";

  // enum TRangeValueType
  var TRangeValueType = "vtEqual " + "vtGreaterOrEqual " + "vtLessOrEqual " + "vtRange ";

  // enum TRelativeDate
  var TRelativeDate = "rdYesterday " + "rdToday " + "rdTomorrow " + "rdThisWeek " + "rdThisMonth " + "rdThisYear " + "rdNextMonth " + "rdNextWeek " + "rdLastWeek " + "rdLastMonth ";

  // enum TReportDestination
  var TReportDestination = "rdWindow " + "rdFile " + "rdPrinter ";

  // enum TReqDataType
  var TReqDataType = "rdtString " + "rdtNumeric " + "rdtInteger " + "rdtDate " + "rdtReference " + "rdtAccount " + "rdtText " + "rdtPick " + "rdtUnknown " + "rdtLargeInteger " + "rdtDocument ";

  // enum TRequisiteEventType
  var TRequisiteEventType = "reOnChange " + "reOnChangeValues ";

  // enum TSBTimeType
  var TSBTimeType = "ttGlobal " + "ttLocal " + "ttUser " + "ttSystem ";

  // enum TSearchShowMode
  var TSearchShowMode = "ssmBrowse " + "ssmSelect " + "ssmMultiSelect " + "ssmBrowseModal ";

  // enum TSelectMode
  var TSelectMode = "smSelect " + "smLike " + "smCard ";

  // enum TSignatureType
  var TSignatureType = "stNone " + "stAuthenticating " + "stApproving ";

  // enum TSignerContentType
  var TSignerContentType = "sctString " + "sctStream ";

  // enum TStringsSortType
  var TStringsSortType = "sstAnsiSort " + "sstNaturalSort ";

  // enum TStringValueType
  var TStringValueType = "svtEqual " + "svtContain ";

  // enum TStructuredObjectAttributeType
  var TStructuredObjectAttributeType = "soatString " + "soatNumeric " + "soatInteger " + "soatDatetime " + "soatReferenceRecord " + "soatText " + "soatPick " + "soatBoolean " + "soatEDocument " + "soatAccount " + "soatIntegerCollection " + "soatNumericCollection " + "soatStringCollection " + "soatPickCollection " + "soatDatetimeCollection " + "soatBooleanCollection " + "soatReferenceRecordCollection " + "soatEDocumentCollection " + "soatAccountCollection " + "soatContents " + "soatUnknown ";

  // enum TTaskAbortReason
  var TTaskAbortReason = "tarAbortByUser " + "tarAbortByWorkflowException ";

  // enum TTextValueType
  var TTextValueType = "tvtAllWords " + "tvtExactPhrase " + "tvtAnyWord ";

  // enum TUserObjectStatus
  var TUserObjectStatus = "usNone " + "usCompleted " + "usRedSquare " + "usBlueSquare " + "usYellowSquare " + "usGreenSquare " + "usOrangeSquare " + "usPurpleSquare " + "usFollowUp ";

  // enum TUserType
  var TUserType = "utUnknown " + "utUser " + "utDeveloper " + "utAdministrator " + "utSystemDeveloper " + "utDisconnected ";

  // enum TValuesBuildType
  var TValuesBuildType = "btAnd " + "btDetailAnd " + "btOr " + "btNotOr " + "btOnly ";

  // enum TViewMode
  var TViewMode = "vmView " + "vmSelect " + "vmNavigation ";

  // enum TViewSelectionMode
  var TViewSelectionMode = "vsmSingle " + "vsmMultiple " + "vsmMultipleCheck " + "vsmNoSelection ";

  // enum TWizardActionType
  var TWizardActionType = "wfatPrevious " + "wfatNext " + "wfatCancel " + "wfatFinish ";

  // enum TWizardFormElementProperty
  var TWizardFormElementProperty = "wfepUndefined " + "wfepText3 " + "wfepText6 " + "wfepText9 " + "wfepSpinEdit " + "wfepDropDown " + "wfepRadioGroup " + "wfepFlag " + "wfepText12 " + "wfepText15 " + "wfepText18 " + "wfepText21 " + "wfepText24 " + "wfepText27 " + "wfepText30 " + "wfepRadioGroupColumn1 " + "wfepRadioGroupColumn2 " + "wfepRadioGroupColumn3 ";

  // enum TWizardFormElementType
  var TWizardFormElementType = "wfetQueryParameter " + "wfetText " + "wfetDelimiter " + "wfetLabel ";

  // enum TWizardParamType
  var TWizardParamType = "wptString " + "wptInteger " + "wptNumeric " + "wptBoolean " + "wptDateTime " + "wptPick " + "wptText " + "wptUser " + "wptUserList " + "wptEDocumentInfo " + "wptEDocumentInfoList " + "wptReferenceRecordInfo " + "wptReferenceRecordInfoList " + "wptFolderInfo " + "wptTaskInfo " + "wptContents " + "wptFileName " + "wptDate ";

  // enum TWizardStepResult
  var TWizardStepResult = "wsrComplete " + "wsrGoNext " + "wsrGoPrevious " + "wsrCustom " + "wsrCancel " + "wsrGoFinal ";

  // enum TWizardStepType
  var TWizardStepType = "wstForm " + "wstEDocument " + "wstTaskCard " + "wstReferenceRecordCard " + "wstFinal ";

  // enum TWorkAccessType
  var TWorkAccessType = "waAll " + "waPerformers " + "waManual ";

  // enum TWorkflowBlockType
  var TWorkflowBlockType = "wsbStart " + "wsbFinish " + "wsbNotice " + "wsbStep " + "wsbDecision " + "wsbWait " + "wsbMonitor " + "wsbScript " + "wsbConnector " + "wsbSubTask " + "wsbLifeCycleStage " + "wsbPause ";

  // enum TWorkflowDataType
  var TWorkflowDataType = "wdtInteger " + "wdtFloat " + "wdtString " + "wdtPick " + "wdtDateTime " + "wdtBoolean " + "wdtTask " + "wdtJob " + "wdtFolder " + "wdtEDocument " + "wdtReferenceRecord " + "wdtUser " + "wdtGroup " + "wdtRole " + "wdtIntegerCollection " + "wdtFloatCollection " + "wdtStringCollection " + "wdtPickCollection " + "wdtDateTimeCollection " + "wdtBooleanCollection " + "wdtTaskCollection " + "wdtJobCollection " + "wdtFolderCollection " + "wdtEDocumentCollection " + "wdtReferenceRecordCollection " + "wdtUserCollection " + "wdtGroupCollection " + "wdtRoleCollection " + "wdtContents " + "wdtUserList " + "wdtSearchDescription " + "wdtDeadLine " + "wdtPickSet " + "wdtAccountCollection ";

  // enum TWorkImportance
  var TWorkImportance = "wiLow " + "wiNormal " + "wiHigh ";

  // enum TWorkRouteType
  var TWorkRouteType = "wrtSoft " + "wrtHard ";

  // enum TWorkState
  var TWorkState = "wsInit " + "wsRunning " + "wsDone " + "wsControlled " + "wsAborted " + "wsContinued ";

  // enum TWorkTextBuildingMode
  var TWorkTextBuildingMode = "wtmFull " + "wtmFromCurrent " + "wtmOnlyCurrent ";

  // Перечисления
  var ENUMS = TAccountType + TActionEnabledMode + TAddPosition + TAlignment + TAreaShowMode + TCertificateInvalidationReason + TCertificateType + TCheckListBoxItemState + TCloseOnEsc + TCompType + TConditionFormat + TConnectionIntent + TContentKind + TControlType + TCriterionContentType + TCultureType + TDataSetEventType + TDataSetState + TDateFormatType + TDateOffsetType + TDateTimeKind + TDeaAccessRights + TDocumentDefaultAction + TEditMode + TEditorCloseObservType + TEdmsApplicationAction + TEDocumentLockType + TEDocumentStepShowMode + TEDocumentStepVersionType + TEDocumentStorageFunction + TEDocumentStorageType + TEDocumentVersionSourceType + TEDocumentVersionState + TEncodeType + TExceptionCategory + TExportedSignaturesType + TExportedVersionType + TFieldDataType + TFolderType + TGridRowHeight + THyperlinkType + TImageFileFormat + TImageMode + TImageType + TInplaceHintKind + TISBLContext + TItemShow + TJobKind + TJoinType + TLabelPos + TLicensingType + TLifeCycleStageFontColor + TLifeCycleStageFontStyle + TLockableDevelopmentComponentType + TMaxRecordCountRestrictionType + TRangeValueType + TRelativeDate + TReportDestination + TReqDataType + TRequisiteEventType + TSBTimeType + TSearchShowMode + TSelectMode + TSignatureType + TSignerContentType + TStringsSortType + TStringValueType + TStructuredObjectAttributeType + TTaskAbortReason + TTextValueType + TUserObjectStatus + TUserType + TValuesBuildType + TViewMode + TViewSelectionMode + TWizardActionType + TWizardFormElementProperty + TWizardFormElementType + TWizardParamType + TWizardStepResult + TWizardStepType + TWorkAccessType + TWorkflowBlockType + TWorkflowDataType + TWorkImportance + TWorkRouteType + TWorkState + TWorkTextBuildingMode;

  // Системные функции ==> SYSFUNCTIONS
  var system_functions = "AddSubString " + "AdjustLineBreaks " + "AmountInWords " + "Analysis " + "ArrayDimCount " + "ArrayHighBound " + "ArrayLowBound " + "ArrayOf " + "ArrayReDim " + "Assert " + "Assigned " + "BeginOfMonth " + "BeginOfPeriod " + "BuildProfilingOperationAnalysis " + "CallProcedure " + "CanReadFile " + "CArrayElement " + "CDataSetRequisite " + "ChangeDate " + "ChangeReferenceDataset " + "Char " + "CharPos " + "CheckParam " + "CheckParamValue " + "CompareStrings " + "ConstantExists " + "ControlState " + "ConvertDateStr " + "Copy " + "CopyFile " + "CreateArray " + "CreateCachedReference " + "CreateConnection " + "CreateDialog " + "CreateDualListDialog " + "CreateEditor " + "CreateException " + "CreateFile " + "CreateFolderDialog " + "CreateInputDialog " + "CreateLinkFile " + "CreateList " + "CreateLock " + "CreateMemoryDataSet " + "CreateObject " + "CreateOpenDialog " + "CreateProgress " + "CreateQuery " + "CreateReference " + "CreateReport " + "CreateSaveDialog " + "CreateScript " + "CreateSQLPivotFunction " + "CreateStringList " + "CreateTreeListSelectDialog " + "CSelectSQL " + "CSQL " + "CSubString " + "CurrentUserID " + "CurrentUserName " + "CurrentVersion " + "DataSetLocateEx " + "DateDiff " + "DateTimeDiff " + "DateToStr " + "DayOfWeek " + "DeleteFile " + "DirectoryExists " + "DisableCheckAccessRights " + "DisableCheckFullShowingRestriction " + "DisableMassTaskSendingRestrictions " + "DropTable " + "DupeString " + "EditText " + "EnableCheckAccessRights " + "EnableCheckFullShowingRestriction " + "EnableMassTaskSendingRestrictions " + "EndOfMonth " + "EndOfPeriod " + "ExceptionExists " + "ExceptionsOff " + "ExceptionsOn " + "Execute " + "ExecuteProcess " + "Exit " + "ExpandEnvironmentVariables " + "ExtractFileDrive " + "ExtractFileExt " + "ExtractFileName " + "ExtractFilePath " + "ExtractParams " + "FileExists " + "FileSize " + "FindFile " + "FindSubString " + "FirmContext " + "ForceDirectories " + "Format " + "FormatDate " + "FormatNumeric " + "FormatSQLDate " + "FormatString " + "FreeException " + "GetComponent " + "GetComponentLaunchParam " + "GetConstant " + "GetLastException " + "GetReferenceRecord " + "GetRefTypeByRefID " + "GetTableID " + "GetTempFolder " + "IfThen " + "In " + "IndexOf " + "InputDialog " + "InputDialogEx " + "InteractiveMode " + "IsFileLocked " + "IsGraphicFile " + "IsNumeric " + "Length " + "LoadString " + "LoadStringFmt " + "LocalTimeToUTC " + "LowerCase " + "Max " + "MessageBox " + "MessageBoxEx " + "MimeDecodeBinary " + "MimeDecodeString " + "MimeEncodeBinary " + "MimeEncodeString " + "Min " + "MoneyInWords " + "MoveFile " + "NewID " + "Now " + "OpenFile " + "Ord " + "Precision " + "Raise " + "ReadCertificateFromFile " + "ReadFile " + "ReferenceCodeByID " + "ReferenceNumber " + "ReferenceRequisiteMode " + "ReferenceRequisiteValue " + "RegionDateSettings " + "RegionNumberSettings " + "RegionTimeSettings " + "RegRead " + "RegWrite " + "RenameFile " + "Replace " + "Round " + "SelectServerCode " + "SelectSQL " + "ServerDateTime " + "SetConstant " + "SetManagedFolderFieldsState " + "ShowConstantsInputDialog " + "ShowMessage " + "Sleep " + "Split " + "SQL " + "SQL2XLSTAB " + "SQLProfilingSendReport " + "StrToDate " + "SubString " + "SubStringCount " + "SystemSetting " + "Time " + "TimeDiff " + "Today " + "Transliterate " + "Trim " + "UpperCase " + "UserStatus " + "UTCToLocalTime " + "ValidateXML " + "VarIsClear " + "VarIsEmpty " + "VarIsNull " + "WorkTimeDiff " + "WriteFile " + "WriteFileEx " + "WriteObjectHistory " + "Анализ " + "БазаДанных " + "БлокЕсть " + "БлокЕстьРасш " + "БлокИнфо " + "БлокСнять " + "БлокСнятьРасш " + "БлокУстановить " + "Ввод " + "ВводМеню " + "ВедС " + "ВедСпр " + "ВерхняяГраницаМассива " + "ВнешПрогр " + "Восст " + "ВременнаяПапка " + "Время " + "ВыборSQL " + "ВыбратьЗапись " + "ВыделитьСтр " + "Вызвать " + "Выполнить " + "ВыпПрогр " + "ГрафическийФайл " + "ГруппаДополнительно " + "ДатаВремяСерв " + "ДеньНедели " + "ДиалогДаНет " + "ДлинаСтр " + "ДобПодстр " + "ЕПусто " + "ЕслиТо " + "ЕЧисло " + "ЗамПодстр " + "ЗаписьСправочника " + "ЗначПоляСпр " + "ИДТипСпр " + "ИзвлечьДиск " + "ИзвлечьИмяФайла " + "ИзвлечьПуть " + "ИзвлечьРасширение " + "ИзмДат " + "ИзменитьРазмерМассива " + "ИзмеренийМассива " + "ИмяОрг " + "ИмяПоляСпр " + "Индекс " + "ИндикаторЗакрыть " + "ИндикаторОткрыть " + "ИндикаторШаг " + "ИнтерактивныйРежим " + "ИтогТблСпр " + "КодВидВедСпр " + "КодВидСпрПоИД " + "КодПоAnalit " + "КодСимвола " + "КодСпр " + "КолПодстр " + "КолПроп " + "КонМес " + "Конст " + "КонстЕсть " + "КонстЗнач " + "КонТран " + "КопироватьФайл " + "КопияСтр " + "КПериод " + "КСтрТблСпр " + "Макс " + "МаксСтрТблСпр " + "Массив " + "Меню " + "МенюРасш " + "Мин " + "НаборДанныхНайтиРасш " + "НаимВидСпр " + "НаимПоAnalit " + "НаимСпр " + "НастроитьПереводыСтрок " + "НачМес " + "НачТран " + "НижняяГраницаМассива " + "НомерСпр " + "НПериод " + "Окно " + "Окр " + "Окружение " + "ОтлИнфДобавить " + "ОтлИнфУдалить " + "Отчет " + "ОтчетАнал " + "ОтчетИнт " + "ПапкаСуществует " + "Пауза " + "ПВыборSQL " + "ПереименоватьФайл " + "Переменные " + "ПереместитьФайл " + "Подстр " + "ПоискПодстр " + "ПоискСтр " + "ПолучитьИДТаблицы " + "ПользовательДополнительно " + "ПользовательИД " + "ПользовательИмя " + "ПользовательСтатус " + "Прервать " + "ПроверитьПараметр " + "ПроверитьПараметрЗнач " + "ПроверитьУсловие " + "РазбСтр " + "РазнВремя " + "РазнДат " + "РазнДатаВремя " + "РазнРабВремя " + "РегУстВрем " + "РегУстДат " + "РегУстЧсл " + "РедТекст " + "РеестрЗапись " + "РеестрСписокИменПарам " + "РеестрЧтение " + "РеквСпр " + "РеквСпрПр " + "Сегодня " + "Сейчас " + "Сервер " + "СерверПроцессИД " + "СертификатФайлСчитать " + "СжПроб " + "Символ " + "СистемаДиректумКод " + "СистемаИнформация " + "СистемаКод " + "Содержит " + "СоединениеЗакрыть " + "СоединениеОткрыть " + "СоздатьДиалог " + "СоздатьДиалогВыбораИзДвухСписков " + "СоздатьДиалогВыбораПапки " + "СоздатьДиалогОткрытияФайла " + "СоздатьДиалогСохраненияФайла " + "СоздатьЗапрос " + "СоздатьИндикатор " + "СоздатьИсключение " + "СоздатьКэшированныйСправочник " + "СоздатьМассив " + "СоздатьНаборДанных " + "СоздатьОбъект " + "СоздатьОтчет " + "СоздатьПапку " + "СоздатьРедактор " + "СоздатьСоединение " + "СоздатьСписок " + "СоздатьСписокСтрок " + "СоздатьСправочник " + "СоздатьСценарий " + "СоздСпр " + "СостСпр " + "Сохр " + "СохрСпр " + "СписокСистем " + "Спр " + "Справочник " + "СпрБлокЕсть " + "СпрБлокСнять " + "СпрБлокСнятьРасш " + "СпрБлокУстановить " + "СпрИзмНабДан " + "СпрКод " + "СпрНомер " + "СпрОбновить " + "СпрОткрыть " + "СпрОтменить " + "СпрПарам " + "СпрПолеЗнач " + "СпрПолеИмя " + "СпрРекв " + "СпрРеквВведЗн " + "СпрРеквНовые " + "СпрРеквПр " + "СпрРеквПредЗн " + "СпрРеквРежим " + "СпрРеквТипТекст " + "СпрСоздать " + "СпрСост " + "СпрСохранить " + "СпрТблИтог " + "СпрТблСтр " + "СпрТблСтрКол " + "СпрТблСтрМакс " + "СпрТблСтрМин " + "СпрТблСтрПред " + "СпрТблСтрСлед " + "СпрТблСтрСозд " + "СпрТблСтрУд " + "СпрТекПредст " + "СпрУдалить " + "СравнитьСтр " + "СтрВерхРегистр " + "СтрНижнРегистр " + "СтрТблСпр " + "СумПроп " + "Сценарий " + "СценарийПарам " + "ТекВерсия " + "ТекОрг " + "Точн " + "Тран " + "Транслитерация " + "УдалитьТаблицу " + "УдалитьФайл " + "УдСпр " + "УдСтрТблСпр " + "Уст " + "УстановкиКонстант " + "ФайлАтрибутСчитать " + "ФайлАтрибутУстановить " + "ФайлВремя " + "ФайлВремяУстановить " + "ФайлВыбрать " + "ФайлЗанят " + "ФайлЗаписать " + "ФайлИскать " + "ФайлКопировать " + "ФайлМожноЧитать " + "ФайлОткрыть " + "ФайлПереименовать " + "ФайлПерекодировать " + "ФайлПереместить " + "ФайлПросмотреть " + "ФайлРазмер " + "ФайлСоздать " + "ФайлСсылкаСоздать " + "ФайлСуществует " + "ФайлСчитать " + "ФайлУдалить " + "ФмтSQLДат " + "ФмтДат " + "ФмтСтр " + "ФмтЧсл " + "Формат " + "ЦМассивЭлемент " + "ЦНаборДанныхРеквизит " + "ЦПодстр ";

  // Предопределенные переменные ==> built_in
  var predefined_variables = "AltState " + "Application " + "CallType " + "ComponentTokens " + "CreatedJobs " + "CreatedNotices " + "ControlState " + "DialogResult " + "Dialogs " + "EDocuments " + "EDocumentVersionSource " + "Folders " + "GlobalIDs " + "Job " + "Jobs " + "InputValue " + "LookUpReference " + "LookUpRequisiteNames " + "LookUpSearch " + "Object " + "ParentComponent " + "Processes " + "References " + "Requisite " + "ReportName " + "Reports " + "Result " + "Scripts " + "Searches " + "SelectedAttachments " + "SelectedItems " + "SelectMode " + "Sender " + "ServerEvents " + "ServiceFactory " + "ShiftState " + "SubTask " + "SystemDialogs " + "Tasks " + "Wizard " + "Wizards " + "Work " + "ВызовСпособ " + "ИмяОтчета " + "РеквЗнач ";

  // Интерфейсы ==> type
  var interfaces = "IApplication " + "IAccessRights " + "IAccountRepository " + "IAccountSelectionRestrictions " + "IAction " + "IActionList " + "IAdministrationHistoryDescription " + "IAnchors " + "IApplication " + "IArchiveInfo " + "IAttachment " + "IAttachmentList " + "ICheckListBox " + "ICheckPointedList " + "IColumn " + "IComponent " + "IComponentDescription " + "IComponentToken " + "IComponentTokenFactory " + "IComponentTokenInfo " + "ICompRecordInfo " + "IConnection " + "IContents " + "IControl " + "IControlJob " + "IControlJobInfo " + "IControlList " + "ICrypto " + "ICrypto2 " + "ICustomJob " + "ICustomJobInfo " + "ICustomListBox " + "ICustomObjectWizardStep " + "ICustomWork " + "ICustomWorkInfo " + "IDataSet " + "IDataSetAccessInfo " + "IDataSigner " + "IDateCriterion " + "IDateRequisite " + "IDateRequisiteDescription " + "IDateValue " + "IDeaAccessRights " + "IDeaObjectInfo " + "IDevelopmentComponentLock " + "IDialog " + "IDialogFactory " + "IDialogPickRequisiteItems " + "IDialogsFactory " + "IDICSFactory " + "IDocRequisite " + "IDocumentInfo " + "IDualListDialog " + "IECertificate " + "IECertificateInfo " + "IECertificates " + "IEditControl " + "IEditorForm " + "IEdmsExplorer " + "IEdmsObject " + "IEdmsObjectDescription " + "IEdmsObjectFactory " + "IEdmsObjectInfo " + "IEDocument " + "IEDocumentAccessRights " + "IEDocumentDescription " + "IEDocumentEditor " + "IEDocumentFactory " + "IEDocumentInfo " + "IEDocumentStorage " + "IEDocumentVersion " + "IEDocumentVersionListDialog " + "IEDocumentVersionSource " + "IEDocumentWizardStep " + "IEDocVerSignature " + "IEDocVersionState " + "IEnabledMode " + "IEncodeProvider " + "IEncrypter " + "IEvent " + "IEventList " + "IException " + "IExternalEvents " + "IExternalHandler " + "IFactory " + "IField " + "IFileDialog " + "IFolder " + "IFolderDescription " + "IFolderDialog " + "IFolderFactory " + "IFolderInfo " + "IForEach " + "IForm " + "IFormTitle " + "IFormWizardStep " + "IGlobalIDFactory " + "IGlobalIDInfo " + "IGrid " + "IHasher " + "IHistoryDescription " + "IHyperLinkControl " + "IImageButton " + "IImageControl " + "IInnerPanel " + "IInplaceHint " + "IIntegerCriterion " + "IIntegerList " + "IIntegerRequisite " + "IIntegerValue " + "IISBLEditorForm " + "IJob " + "IJobDescription " + "IJobFactory " + "IJobForm " + "IJobInfo " + "ILabelControl " + "ILargeIntegerCriterion " + "ILargeIntegerRequisite " + "ILargeIntegerValue " + "ILicenseInfo " + "ILifeCycleStage " + "IList " + "IListBox " + "ILocalIDInfo " + "ILocalization " + "ILock " + "IMemoryDataSet " + "IMessagingFactory " + "IMetadataRepository " + "INotice " + "INoticeInfo " + "INumericCriterion " + "INumericRequisite " + "INumericValue " + "IObject " + "IObjectDescription " + "IObjectImporter " + "IObjectInfo " + "IObserver " + "IPanelGroup " + "IPickCriterion " + "IPickProperty " + "IPickRequisite " + "IPickRequisiteDescription " + "IPickRequisiteItem " + "IPickRequisiteItems " + "IPickValue " + "IPrivilege " + "IPrivilegeList " + "IProcess " + "IProcessFactory " + "IProcessMessage " + "IProgress " + "IProperty " + "IPropertyChangeEvent " + "IQuery " + "IReference " + "IReferenceCriterion " + "IReferenceEnabledMode " + "IReferenceFactory " + "IReferenceHistoryDescription " + "IReferenceInfo " + "IReferenceRecordCardWizardStep " + "IReferenceRequisiteDescription " + "IReferencesFactory " + "IReferenceValue " + "IRefRequisite " + "IReport " + "IReportFactory " + "IRequisite " + "IRequisiteDescription " + "IRequisiteDescriptionList " + "IRequisiteFactory " + "IRichEdit " + "IRouteStep " + "IRule " + "IRuleList " + "ISchemeBlock " + "IScript " + "IScriptFactory " + "ISearchCriteria " + "ISearchCriterion " + "ISearchDescription " + "ISearchFactory " + "ISearchFolderInfo " + "ISearchForObjectDescription " + "ISearchResultRestrictions " + "ISecuredContext " + "ISelectDialog " + "IServerEvent " + "IServerEventFactory " + "IServiceDialog " + "IServiceFactory " + "ISignature " + "ISignProvider " + "ISignProvider2 " + "ISignProvider3 " + "ISimpleCriterion " + "IStringCriterion " + "IStringList " + "IStringRequisite " + "IStringRequisiteDescription " + "IStringValue " + "ISystemDialogsFactory " + "ISystemInfo " + "ITabSheet " + "ITask " + "ITaskAbortReasonInfo " + "ITaskCardWizardStep " + "ITaskDescription " + "ITaskFactory " + "ITaskInfo " + "ITaskRoute " + "ITextCriterion " + "ITextRequisite " + "ITextValue " + "ITreeListSelectDialog " + "IUser " + "IUserList " + "IValue " + "IView " + "IWebBrowserControl " + "IWizard " + "IWizardAction " + "IWizardFactory " + "IWizardFormElement " + "IWizardParam " + "IWizardPickParam " + "IWizardReferenceParam " + "IWizardStep " + "IWorkAccessRights " + "IWorkDescription " + "IWorkflowAskableParam " + "IWorkflowAskableParams " + "IWorkflowBlock " + "IWorkflowBlockResult " + "IWorkflowEnabledMode " + "IWorkflowParam " + "IWorkflowPickParam " + "IWorkflowReferenceParam " + "IWorkState " + "IWorkTreeCustomNode " + "IWorkTreeJobNode " + "IWorkTreeTaskNode " + "IXMLEditorForm " + "SBCrypto ";

  // built_in : встроенные или библиотечные объекты (константы, перечисления)
  var BUILTIN = CONSTANTS + ENUMS;

  // class: встроенные наборы значений, системные объекты, фабрики
  var CLASS = predefined_variables;

  // literal : примитивные типы
  var LITERAL = "null true false nil ";

  // number : числа
  var NUMBERS = {
    className: "number",
    begin: hljs.NUMBER_RE,
    relevance: 0
  };

  // string : строки
  var STRINGS = {
    className: "string",
    variants: [{
      begin: '"',
      end: '"'
    }, {
      begin: "'",
      end: "'"
    }]
  };

  // Токены
  var DOCTAGS = {
    className: "doctag",
    begin: "\\b(?:TODO|DONE|BEGIN|END|STUB|CHG|FIXME|NOTE|BUG|XXX)\\b",
    relevance: 0
  };

  // Однострочный комментарий
  var ISBL_LINE_COMMENT_MODE = {
    className: "comment",
    begin: "//",
    end: "$",
    relevance: 0,
    contains: [hljs.PHRASAL_WORDS_MODE, DOCTAGS]
  };

  // Многострочный комментарий
  var ISBL_BLOCK_COMMENT_MODE = {
    className: "comment",
    begin: "/\\*",
    end: "\\*/",
    relevance: 0,
    contains: [hljs.PHRASAL_WORDS_MODE, DOCTAGS]
  };

  // comment : комментарии
  var COMMENTS = {
    variants: [ISBL_LINE_COMMENT_MODE, ISBL_BLOCK_COMMENT_MODE]
  };

  // keywords : ключевые слова
  var KEYWORDS = {
    $pattern: UNDERSCORE_IDENT_RE,
    keyword: KEYWORD,
    built_in: BUILTIN,
    class: CLASS,
    literal: LITERAL
  };

  // methods : методы
  var METHODS = {
    begin: "\\.\\s*" + hljs.UNDERSCORE_IDENT_RE,
    keywords: KEYWORDS,
    relevance: 0
  };

  // type : встроенные типы
  var TYPES = {
    className: "type",
    begin: ":[ \\t]*(" + interfaces.trim().replace(/\s/g, "|") + ")",
    end: "[ \\t]*=",
    excludeEnd: true
  };

  // variables : переменные
  var VARIABLES = {
    className: "variable",
    keywords: KEYWORDS,
    begin: UNDERSCORE_IDENT_RE,
    relevance: 0,
    contains: [TYPES, METHODS]
  };

  // Имена функций
  var FUNCTION_TITLE = FUNCTION_NAME_IDENT_RE + "\\(";
  var TITLE_MODE = {
    className: "title",
    keywords: {
      $pattern: UNDERSCORE_IDENT_RE,
      built_in: system_functions
    },
    begin: FUNCTION_TITLE,
    end: "\\(",
    returnBegin: true,
    excludeEnd: true
  };

  // function : функции
  var FUNCTIONS = {
    className: "function",
    begin: FUNCTION_TITLE,
    end: "\\)$",
    returnBegin: true,
    keywords: KEYWORDS,
    illegal: "[\\[\\]\\|\\$\\?%,~#@]",
    contains: [TITLE_MODE, METHODS, VARIABLES, STRINGS, NUMBERS, COMMENTS]
  };
  return {
    name: 'ISBL',
    case_insensitive: true,
    keywords: KEYWORDS,
    illegal: "\\$|\\?|%|,|;$|~|#|@|</",
    contains: [FUNCTIONS, TYPES, METHODS, VARIABLES, STRINGS, NUMBERS, COMMENTS]
  };
}
module.exports = isbl;

/***/ }),

/***/ 84756:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
// https://docs.oracle.com/javase/specs/jls/se15/html/jls-3.html#jls-3.10
var decimalDigits = '[0-9](_*[0-9])*';
var frac = "\\.(".concat(decimalDigits, ")");
var hexDigits = '[0-9a-fA-F](_*[0-9a-fA-F])*';
var NUMERIC = {
  className: 'number',
  variants: [
  // DecimalFloatingPointLiteral
  // including ExponentPart
  {
    begin: "(\\b(".concat(decimalDigits, ")((").concat(frac, ")|\\.)?|(").concat(frac, "))") + "[eE][+-]?(".concat(decimalDigits, ")[fFdD]?\\b")
  },
  // excluding ExponentPart
  {
    begin: "\\b(".concat(decimalDigits, ")((").concat(frac, ")[fFdD]?\\b|\\.([fFdD]\\b)?)")
  }, {
    begin: "(".concat(frac, ")[fFdD]?\\b")
  }, {
    begin: "\\b(".concat(decimalDigits, ")[fFdD]\\b")
  },
  // HexadecimalFloatingPointLiteral
  {
    begin: "\\b0[xX]((".concat(hexDigits, ")\\.?|(").concat(hexDigits, ")?\\.(").concat(hexDigits, "))") + "[pP][+-]?(".concat(decimalDigits, ")[fFdD]?\\b")
  },
  // DecimalIntegerLiteral
  {
    begin: '\\b(0|[1-9](_*[0-9])*)[lL]?\\b'
  },
  // HexIntegerLiteral
  {
    begin: "\\b0[xX](".concat(hexDigits, ")[lL]?\\b")
  },
  // OctalIntegerLiteral
  {
    begin: '\\b0(_*[0-7])*[lL]?\\b'
  },
  // BinaryIntegerLiteral
  {
    begin: '\\b0[bB][01](_*[01])*[lL]?\\b'
  }],
  relevance: 0
};

/*
Language: Java
Author: Vsevolod Solovyov <vsevolod.solovyov@gmail.com>
Category: common, enterprise
Website: https://www.java.com/
*/

function java(hljs) {
  var JAVA_IDENT_RE = "[\xC0-\u02B8a-zA-Z_$][\xC0-\u02B8a-zA-Z_$0-9]*";
  var GENERIC_IDENT_RE = JAVA_IDENT_RE + '(<' + JAVA_IDENT_RE + '(\\s*,\\s*' + JAVA_IDENT_RE + ')*>)?';
  var KEYWORDS = 'false synchronized int abstract float private char boolean var static null if const ' + 'for true while long strictfp finally protected import native final void ' + 'enum else break transient catch instanceof byte super volatile case assert short ' + 'package default double public try this switch continue throws protected public private ' + 'module requires exports do';
  var ANNOTATION = {
    className: 'meta',
    begin: '@' + JAVA_IDENT_RE,
    contains: [{
      begin: /\(/,
      end: /\)/,
      contains: ["self"] // allow nested () inside our annotation
    }]
  };

  var NUMBER = NUMERIC;
  return {
    name: 'Java',
    aliases: ['jsp'],
    keywords: KEYWORDS,
    illegal: /<\/|#/,
    contains: [hljs.COMMENT('/\\*\\*', '\\*/', {
      relevance: 0,
      contains: [{
        // eat up @'s in emails to prevent them to be recognized as doctags
        begin: /\w+@/,
        relevance: 0
      }, {
        className: 'doctag',
        begin: '@[A-Za-z]+'
      }]
    }),
    // relevance boost
    {
      begin: /import java\.[a-z]+\./,
      keywords: "import",
      relevance: 2
    }, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, {
      className: 'class',
      beginKeywords: 'class interface enum',
      end: /[{;=]/,
      excludeEnd: true,
      // TODO: can this be removed somehow?
      // an extra boost because Java is more popular than other languages with
      // this same syntax feature (this is just to preserve our tests passing
      // for now)
      relevance: 1,
      keywords: 'class interface enum',
      illegal: /[:"\[\]]/,
      contains: [{
        beginKeywords: 'extends implements'
      }, hljs.UNDERSCORE_TITLE_MODE]
    }, {
      // Expression keywords prevent 'keyword Name(...)' from being
      // recognized as a function definition
      beginKeywords: 'new throw return else',
      relevance: 0
    }, {
      className: 'class',
      begin: 'record\\s+' + hljs.UNDERSCORE_IDENT_RE + '\\s*\\(',
      returnBegin: true,
      excludeEnd: true,
      end: /[{;=]/,
      keywords: KEYWORDS,
      contains: [{
        beginKeywords: "record"
      }, {
        begin: hljs.UNDERSCORE_IDENT_RE + '\\s*\\(',
        returnBegin: true,
        relevance: 0,
        contains: [hljs.UNDERSCORE_TITLE_MODE]
      }, {
        className: 'params',
        begin: /\(/,
        end: /\)/,
        keywords: KEYWORDS,
        relevance: 0,
        contains: [hljs.C_BLOCK_COMMENT_MODE]
      }, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE]
    }, {
      className: 'function',
      begin: '(' + GENERIC_IDENT_RE + '\\s+)+' + hljs.UNDERSCORE_IDENT_RE + '\\s*\\(',
      returnBegin: true,
      end: /[{;=]/,
      excludeEnd: true,
      keywords: KEYWORDS,
      contains: [{
        begin: hljs.UNDERSCORE_IDENT_RE + '\\s*\\(',
        returnBegin: true,
        relevance: 0,
        contains: [hljs.UNDERSCORE_TITLE_MODE]
      }, {
        className: 'params',
        begin: /\(/,
        end: /\)/,
        keywords: KEYWORDS,
        relevance: 0,
        contains: [ANNOTATION, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, NUMBER, hljs.C_BLOCK_COMMENT_MODE]
      }, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE]
    }, NUMBER, ANNOTATION]
  };
}
module.exports = java;

/***/ }),

/***/ 25489:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(47042);
var IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
var KEYWORDS = ["as",
// for exports
"in", "of", "if", "for", "while", "finally", "var", "new", "function", "do", "return", "void", "else", "break", "catch", "instanceof", "with", "throw", "case", "default", "try", "switch", "continue", "typeof", "delete", "let", "yield", "const", "class",
// JS handles these with a special rule
// "get",
// "set",
"debugger", "async", "await", "static", "import", "from", "export", "extends"];
var LITERALS = ["true", "false", "null", "undefined", "NaN", "Infinity"];
var TYPES = ["Intl", "DataView", "Number", "Math", "Date", "String", "RegExp", "Object", "Function", "Boolean", "Error", "Symbol", "Set", "Map", "WeakSet", "WeakMap", "Proxy", "Reflect", "JSON", "Promise", "Float64Array", "Int16Array", "Int32Array", "Int8Array", "Uint16Array", "Uint32Array", "Float32Array", "Array", "Uint8Array", "Uint8ClampedArray", "ArrayBuffer", "BigInt64Array", "BigUint64Array", "BigInt"];
var ERROR_TYPES = ["EvalError", "InternalError", "RangeError", "ReferenceError", "SyntaxError", "TypeError", "URIError"];
var BUILT_IN_GLOBALS = ["setInterval", "setTimeout", "clearInterval", "clearTimeout", "require", "exports", "eval", "isFinite", "isNaN", "parseFloat", "parseInt", "decodeURI", "decodeURIComponent", "encodeURI", "encodeURIComponent", "escape", "unescape"];
var BUILT_IN_VARIABLES = ["arguments", "this", "super", "console", "window", "document", "localStorage", "module", "global" // Node.js
];

var BUILT_INS = [].concat(BUILT_IN_GLOBALS, BUILT_IN_VARIABLES, TYPES, ERROR_TYPES);

/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function lookahead(re) {
  return concat('(?=', re, ')');
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/*
Language: JavaScript
Description: JavaScript (JS) is a lightweight, interpreted, or just-in-time compiled programming language with first-class functions.
Category: common, scripting
Website: https://developer.mozilla.org/en-US/docs/Web/JavaScript
*/

/** @type LanguageFn */
function javascript(hljs) {
  /**
   * Takes a string like "<Booger" and checks to see
   * if we can find a matching "</Booger" later in the
   * content.
   * @param {RegExpMatchArray} match
   * @param {{after:number}} param1
   */
  var hasClosingTag = function hasClosingTag(match, _ref) {
    var after = _ref.after;
    var tag = "</" + match[0].slice(1);
    var pos = match.input.indexOf(tag, after);
    return pos !== -1;
  };
  var IDENT_RE$1 = IDENT_RE;
  var FRAGMENT = {
    begin: '<>',
    end: '</>'
  };
  var XML_TAG = {
    begin: /<[A-Za-z0-9\\._:-]+/,
    end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
    /**
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */
    isTrulyOpeningTag: function isTrulyOpeningTag(match, response) {
      var afterMatchIndex = match[0].length + match.index;
      var nextChar = match.input[afterMatchIndex];
      // nested type?
      // HTML should not include another raw `<` inside a tag
      // But a type might: `<Array<Array<number>>`, etc.
      if (nextChar === "<") {
        response.ignoreMatch();
        return;
      }
      // <something>
      // This is now either a tag or a type.
      if (nextChar === ">") {
        // if we cannot find a matching closing tag, then we
        // will ignore it
        if (!hasClosingTag(match, {
          after: afterMatchIndex
        })) {
          response.ignoreMatch();
        }
      }
    }
  };
  var KEYWORDS$1 = {
    $pattern: IDENT_RE,
    keyword: KEYWORDS,
    literal: LITERALS,
    built_in: BUILT_INS
  };

  // https://tc39.es/ecma262/#sec-literals-numeric-literals
  var decimalDigits = '[0-9](_?[0-9])*';
  var frac = "\\.(".concat(decimalDigits, ")");
  // DecimalIntegerLiteral, including Annex B NonOctalDecimalIntegerLiteral
  // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
  var decimalInteger = "0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*";
  var NUMBER = {
    className: 'number',
    variants: [
    // DecimalLiteral
    {
      begin: "(\\b(".concat(decimalInteger, ")((").concat(frac, ")|\\.)?|(").concat(frac, "))") + "[eE][+-]?(".concat(decimalDigits, ")\\b")
    }, {
      begin: "\\b(".concat(decimalInteger, ")\\b((").concat(frac, ")\\b|\\.)?|(").concat(frac, ")\\b")
    },
    // DecimalBigIntegerLiteral
    {
      begin: "\\b(0|[1-9](_?[0-9])*)n\\b"
    },
    // NonDecimalIntegerLiteral
    {
      begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b"
    }, {
      begin: "\\b0[bB][0-1](_?[0-1])*n?\\b"
    }, {
      begin: "\\b0[oO][0-7](_?[0-7])*n?\\b"
    },
    // LegacyOctalIntegerLiteral (does not include underscore separators)
    // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
    {
      begin: "\\b0[0-7]+n?\\b"
    }],
    relevance: 0
  };
  var SUBST = {
    className: 'subst',
    begin: '\\$\\{',
    end: '\\}',
    keywords: KEYWORDS$1,
    contains: [] // defined later
  };

  var HTML_TEMPLATE = {
    begin: 'html`',
    end: '',
    starts: {
      end: '`',
      returnEnd: false,
      contains: [hljs.BACKSLASH_ESCAPE, SUBST],
      subLanguage: 'xml'
    }
  };
  var CSS_TEMPLATE = {
    begin: 'css`',
    end: '',
    starts: {
      end: '`',
      returnEnd: false,
      contains: [hljs.BACKSLASH_ESCAPE, SUBST],
      subLanguage: 'css'
    }
  };
  var TEMPLATE_STRING = {
    className: 'string',
    begin: '`',
    end: '`',
    contains: [hljs.BACKSLASH_ESCAPE, SUBST]
  };
  var JSDOC_COMMENT = hljs.COMMENT(/\/\*\*(?!\/)/, '\\*/', {
    relevance: 0,
    contains: [{
      className: 'doctag',
      begin: '@[A-Za-z]+',
      contains: [{
        className: 'type',
        begin: '\\{',
        end: '\\}',
        relevance: 0
      }, {
        className: 'variable',
        begin: IDENT_RE$1 + '(?=\\s*(-)|$)',
        endsParent: true,
        relevance: 0
      },
      // eat spaces (not newlines) so we can find
      // types or variables
      {
        begin: /(?=[^\n])\s/,
        relevance: 0
      }]
    }]
  });
  var COMMENT = {
    className: "comment",
    variants: [JSDOC_COMMENT, hljs.C_BLOCK_COMMENT_MODE, hljs.C_LINE_COMMENT_MODE]
  };
  var SUBST_INTERNALS = [hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, HTML_TEMPLATE, CSS_TEMPLATE, TEMPLATE_STRING, NUMBER, hljs.REGEXP_MODE];
  SUBST.contains = SUBST_INTERNALS.concat({
    // we need to pair up {} inside our subst to prevent
    // it from ending too early by matching another }
    begin: /\{/,
    end: /\}/,
    keywords: KEYWORDS$1,
    contains: ["self"].concat(SUBST_INTERNALS)
  });
  var SUBST_AND_COMMENTS = [].concat(COMMENT, SUBST.contains);
  var PARAMS_CONTAINS = SUBST_AND_COMMENTS.concat([
  // eat recursive parens in sub expressions
  {
    begin: /\(/,
    end: /\)/,
    keywords: KEYWORDS$1,
    contains: ["self"].concat(SUBST_AND_COMMENTS)
  }]);
  var PARAMS = {
    className: 'params',
    begin: /\(/,
    end: /\)/,
    excludeBegin: true,
    excludeEnd: true,
    keywords: KEYWORDS$1,
    contains: PARAMS_CONTAINS
  };
  return {
    name: 'Javascript',
    aliases: ['js', 'jsx', 'mjs', 'cjs'],
    keywords: KEYWORDS$1,
    // this will be extended by TypeScript
    exports: {
      PARAMS_CONTAINS: PARAMS_CONTAINS
    },
    illegal: /#(?![$_A-z])/,
    contains: [hljs.SHEBANG({
      label: "shebang",
      binary: "node",
      relevance: 5
    }), {
      label: "use_strict",
      className: 'meta',
      relevance: 10,
      begin: /^\s*['"]use (strict|asm)['"]/
    }, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, HTML_TEMPLATE, CSS_TEMPLATE, TEMPLATE_STRING, COMMENT, NUMBER, {
      // object attr container
      begin: concat(/[{,\n]\s*/,
      // we need to look ahead to make sure that we actually have an
      // attribute coming up so we don't steal a comma from a potential
      // "value" container
      //
      // NOTE: this might not work how you think.  We don't actually always
      // enter this mode and stay.  Instead it might merely match `,
      // <comments up next>` and then immediately end after the , because it
      // fails to find any actual attrs. But this still does the job because
      // it prevents the value contain rule from grabbing this instead and
      // prevening this rule from firing when we actually DO have keys.
      lookahead(concat(
      // we also need to allow for multiple possible comments inbetween
      // the first key:value pairing
      /(((\/\/.*$)|(\/\*(\*[^/]|[^*])*\*\/))\s*)*/, IDENT_RE$1 + '\\s*:'))),
      relevance: 0,
      contains: [{
        className: 'attr',
        begin: IDENT_RE$1 + lookahead('\\s*:'),
        relevance: 0
      }]
    }, {
      // "value" container
      begin: '(' + hljs.RE_STARTERS_RE + '|\\b(case|return|throw)\\b)\\s*',
      keywords: 'return throw case',
      contains: [COMMENT, hljs.REGEXP_MODE, {
        className: 'function',
        // we have to count the parens to make sure we actually have the
        // correct bounding ( ) before the =>.  There could be any number of
        // sub-expressions inside also surrounded by parens.
        begin: '(\\(' + '[^()]*(\\(' + '[^()]*(\\(' + '[^()]*' + '\\)[^()]*)*' + '\\)[^()]*)*' + '\\)|' + hljs.UNDERSCORE_IDENT_RE + ')\\s*=>',
        returnBegin: true,
        end: '\\s*=>',
        contains: [{
          className: 'params',
          variants: [{
            begin: hljs.UNDERSCORE_IDENT_RE,
            relevance: 0
          }, {
            className: null,
            begin: /\(\s*\)/,
            skip: true
          }, {
            begin: /\(/,
            end: /\)/,
            excludeBegin: true,
            excludeEnd: true,
            keywords: KEYWORDS$1,
            contains: PARAMS_CONTAINS
          }]
        }]
      }, {
        // could be a comma delimited list of params to a function call
        begin: /,/,
        relevance: 0
      }, {
        className: '',
        begin: /\s/,
        end: /\s*/,
        skip: true
      }, {
        // JSX
        variants: [{
          begin: FRAGMENT.begin,
          end: FRAGMENT.end
        }, {
          begin: XML_TAG.begin,
          // we carefully check the opening tag to see if it truly
          // is a tag and not a false positive
          'on:begin': XML_TAG.isTrulyOpeningTag,
          end: XML_TAG.end
        }],
        subLanguage: 'xml',
        contains: [{
          begin: XML_TAG.begin,
          end: XML_TAG.end,
          skip: true,
          contains: ['self']
        }]
      }],
      relevance: 0
    }, {
      className: 'function',
      beginKeywords: 'function',
      end: /[{;]/,
      excludeEnd: true,
      keywords: KEYWORDS$1,
      contains: ['self', hljs.inherit(hljs.TITLE_MODE, {
        begin: IDENT_RE$1
      }), PARAMS],
      illegal: /%/
    }, {
      // prevent this from getting swallowed up by function
      // since they appear "function like"
      beginKeywords: "while if switch catch for"
    }, {
      className: 'function',
      // we have to count the parens to make sure we actually have the correct
      // bounding ( ).  There could be any number of sub-expressions inside
      // also surrounded by parens.
      begin: hljs.UNDERSCORE_IDENT_RE + '\\(' +
      // first parens
      '[^()]*(\\(' + '[^()]*(\\(' + '[^()]*' + '\\)[^()]*)*' + '\\)[^()]*)*' + '\\)\\s*\\{',
      // end parens
      returnBegin: true,
      contains: [PARAMS, hljs.inherit(hljs.TITLE_MODE, {
        begin: IDENT_RE$1
      })]
    },
    // hack: prevents detection of keywords in some circumstances
    // .keyword()
    // $keyword = x
    {
      variants: [{
        begin: '\\.' + IDENT_RE$1
      }, {
        begin: '\\$' + IDENT_RE$1
      }],
      relevance: 0
    }, {
      // ES6 class
      className: 'class',
      beginKeywords: 'class',
      end: /[{;=]/,
      excludeEnd: true,
      illegal: /[:"[\]]/,
      contains: [{
        beginKeywords: 'extends'
      }, hljs.UNDERSCORE_TITLE_MODE]
    }, {
      begin: /\b(?=constructor)/,
      end: /[{;]/,
      excludeEnd: true,
      contains: [hljs.inherit(hljs.TITLE_MODE, {
        begin: IDENT_RE$1
      }), 'self', PARAMS]
    }, {
      begin: '(get|set)\\s+(?=' + IDENT_RE$1 + '\\()',
      end: /\{/,
      keywords: "get set",
      contains: [hljs.inherit(hljs.TITLE_MODE, {
        begin: IDENT_RE$1
      }), {
        begin: /\(\)/
      },
      // eat to avoid empty params
      PARAMS]
    }, {
      begin: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
    }]
  };
}

module.exports = javascript;

/***/ }),

/***/ 48019:
/***/ ((module) => {

/*
 Language: JBoss CLI
 Author: Raphaël Parrëe <rparree@edc4it.com>
 Description: language definition jboss cli
 Website: https://docs.jboss.org/author/display/WFLY/Command+Line+Interface
 Category: config
 */

function jbossCli(hljs) {
  var PARAM = {
    begin: /[\w-]+ *=/,
    returnBegin: true,
    relevance: 0,
    contains: [{
      className: 'attr',
      begin: /[\w-]+/
    }]
  };
  var PARAMSBLOCK = {
    className: 'params',
    begin: /\(/,
    end: /\)/,
    contains: [PARAM],
    relevance: 0
  };
  var OPERATION = {
    className: 'function',
    begin: /:[\w\-.]+/,
    relevance: 0
  };
  var PATH = {
    className: 'string',
    begin: /\B([\/.])[\w\-.\/=]+/
  };
  var COMMAND_PARAMS = {
    className: 'params',
    begin: /--[\w\-=\/]+/
  };
  return {
    name: 'JBoss CLI',
    aliases: ['wildfly-cli'],
    keywords: {
      $pattern: '[a-z\-]+',
      keyword: 'alias batch cd clear command connect connection-factory connection-info data-source deploy ' + 'deployment-info deployment-overlay echo echo-dmr help history if jdbc-driver-info jms-queue|20 jms-topic|20 ls ' + 'patch pwd quit read-attribute read-operation reload rollout-plan run-batch set shutdown try unalias ' + 'undeploy unset version xa-data-source',
      // module
      literal: 'true false'
    },
    contains: [hljs.HASH_COMMENT_MODE, hljs.QUOTE_STRING_MODE, COMMAND_PARAMS, OPERATION, PATH, PARAMSBLOCK]
  };
}
module.exports = jbossCli;

/***/ }),

/***/ 5392:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
__webpack_require__(54747);
/*
Language: JSON
Description: JSON (JavaScript Object Notation) is a lightweight data-interchange format.
Author: Ivan Sagalaev <maniac@softwaremaniacs.org>
Website: http://www.json.org
Category: common, protocols
*/

function json(hljs) {
  var LITERALS = {
    literal: 'true false null'
  };
  var ALLOWED_COMMENTS = [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE];
  var TYPES = [hljs.QUOTE_STRING_MODE, hljs.C_NUMBER_MODE];
  var VALUE_CONTAINER = {
    end: ',',
    endsWithParent: true,
    excludeEnd: true,
    contains: TYPES,
    keywords: LITERALS
  };
  var OBJECT = {
    begin: /\{/,
    end: /\}/,
    contains: [{
      className: 'attr',
      begin: /"/,
      end: /"/,
      contains: [hljs.BACKSLASH_ESCAPE],
      illegal: '\\n'
    }, hljs.inherit(VALUE_CONTAINER, {
      begin: /:/
    })].concat(ALLOWED_COMMENTS),
    illegal: '\\S'
  };
  var ARRAY = {
    begin: '\\[',
    end: '\\]',
    contains: [hljs.inherit(VALUE_CONTAINER)],
    // inherit is a workaround for a bug that makes shared modes with endsWithParent compile only the ending of one of the parents
    illegal: '\\S'
  };
  TYPES.push(OBJECT, ARRAY);
  ALLOWED_COMMENTS.forEach(function (rule) {
    TYPES.push(rule);
  });
  return {
    name: 'JSON',
    contains: TYPES,
    keywords: LITERALS,
    illegal: '\\S'
  };
}
module.exports = json;

/***/ }),

/***/ 29957:
/***/ ((module) => {

/*
Language: Julia REPL
Description: Julia REPL sessions
Author: Morten Piibeleht <morten.piibeleht@gmail.com>
Website: https://julialang.org
Requires: julia.js

The Julia REPL code blocks look something like the following:

  julia> function foo(x)
             x + 1
         end
  foo (generic function with 1 method)

They start on a new line with "julia>". Usually there should also be a space after this, but
we also allow the code to start right after the > character. The code may run over multiple
lines, but the additional lines must start with six spaces (i.e. be indented to match
"julia>"). The rest of the code is assumed to be output from the executed code and will be
left un-highlighted.

Using simply spaces to identify line continuations may get a false-positive if the output
also prints out six spaces, but such cases should be rare.
*/

function juliaRepl(hljs) {
  return {
    name: 'Julia REPL',
    contains: [{
      className: 'meta',
      begin: /^julia>/,
      relevance: 10,
      starts: {
        // end the highlighting if we are on a new line and the line does not have at
        // least six spaces in the beginning
        end: /^(?![ ]{6})/,
        subLanguage: 'julia'
      },
      // jldoctest Markdown blocks are used in the Julia manual and package docs indicate
      // code snippets that should be verified when the documentation is built. They can be
      // either REPL-like or script-like, but are usually REPL-like and therefore we apply
      // julia-repl highlighting to them. More information can be found in Documenter's
      // manual: https://juliadocs.github.io/Documenter.jl/latest/man/doctests.html
      aliases: ['jldoctest']
    }]
  };
}
module.exports = juliaRepl;

/***/ }),

/***/ 13405:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(68309);
/*
Language: Julia
Description: Julia is a high-level, high-performance, dynamic programming language.
Author: Kenta Sato <bicycle1885@gmail.com>
Contributors: Alex Arslan <ararslan@comcast.net>, Fredrik Ekre <ekrefredrik@gmail.com>
Website: https://julialang.org
*/

function julia(hljs) {
  // Since there are numerous special names in Julia, it is too much trouble
  // to maintain them by hand. Hence these names (i.e. keywords, literals and
  // built-ins) are automatically generated from Julia 1.5.2 itself through
  // the following scripts for each.

  // ref: https://docs.julialang.org/en/v1/manual/variables/#Allowed-Variable-Names
  var VARIABLE_NAME_RE = "[A-Za-z_\\u00A1-\\uFFFF][A-Za-z_0-9\\u00A1-\\uFFFF]*";

  // # keyword generator, multi-word keywords handled manually below (Julia 1.5.2)
  // import REPL.REPLCompletions
  // res = String["in", "isa", "where"]
  // for kw in collect(x.keyword for x in REPLCompletions.complete_keyword(""))
  //     if !(contains(kw, " ") || kw == "struct")
  //         push!(res, kw)
  //     end
  // end
  // sort!(unique!(res))
  // foreach(x -> println("\'", x, "\',"), res)
  var KEYWORD_LIST = ['baremodule', 'begin', 'break', 'catch', 'ccall', 'const', 'continue', 'do', 'else', 'elseif', 'end', 'export', 'false', 'finally', 'for', 'function', 'global', 'if', 'import', 'in', 'isa', 'let', 'local', 'macro', 'module', 'quote', 'return', 'true', 'try', 'using', 'where', 'while'];

  // # literal generator (Julia 1.5.2)
  // import REPL.REPLCompletions
  // res = String["true", "false"]
  // for compl in filter!(x -> isa(x, REPLCompletions.ModuleCompletion) && (x.parent === Base || x.parent === Core),
  //                     REPLCompletions.completions("", 0)[1])
  //     try
  //         v = eval(Symbol(compl.mod))
  //         if !(v isa Function || v isa Type || v isa TypeVar || v isa Module || v isa Colon)
  //             push!(res, compl.mod)
  //         end
  //     catch e
  //     end
  // end
  // sort!(unique!(res))
  // foreach(x -> println("\'", x, "\',"), res)
  var LITERAL_LIST = ['ARGS', 'C_NULL', 'DEPOT_PATH', 'ENDIAN_BOM', 'ENV', 'Inf', 'Inf16', 'Inf32', 'Inf64', 'InsertionSort', 'LOAD_PATH', 'MergeSort', 'NaN', 'NaN16', 'NaN32', 'NaN64', 'PROGRAM_FILE', 'QuickSort', 'RoundDown', 'RoundFromZero', 'RoundNearest', 'RoundNearestTiesAway', 'RoundNearestTiesUp', 'RoundToZero', 'RoundUp', 'VERSION|0', 'devnull', 'false', 'im', 'missing', 'nothing', 'pi', 'stderr', 'stdin', 'stdout', 'true', 'undef', 'π', 'ℯ'];

  // # built_in generator (Julia 1.5.2)
  // import REPL.REPLCompletions
  // res = String[]
  // for compl in filter!(x -> isa(x, REPLCompletions.ModuleCompletion) && (x.parent === Base || x.parent === Core),
  //                     REPLCompletions.completions("", 0)[1])
  //     try
  //         v = eval(Symbol(compl.mod))
  //         if (v isa Type || v isa TypeVar) && (compl.mod != "=>")
  //             push!(res, compl.mod)
  //         end
  //     catch e
  //     end
  // end
  // sort!(unique!(res))
  // foreach(x -> println("\'", x, "\',"), res)
  var BUILT_IN_LIST = ['AbstractArray', 'AbstractChannel', 'AbstractChar', 'AbstractDict', 'AbstractDisplay', 'AbstractFloat', 'AbstractIrrational', 'AbstractMatrix', 'AbstractRange', 'AbstractSet', 'AbstractString', 'AbstractUnitRange', 'AbstractVecOrMat', 'AbstractVector', 'Any', 'ArgumentError', 'Array', 'AssertionError', 'BigFloat', 'BigInt', 'BitArray', 'BitMatrix', 'BitSet', 'BitVector', 'Bool', 'BoundsError', 'CapturedException', 'CartesianIndex', 'CartesianIndices', 'Cchar', 'Cdouble', 'Cfloat', 'Channel', 'Char', 'Cint', 'Cintmax_t', 'Clong', 'Clonglong', 'Cmd', 'Colon', 'Complex', 'ComplexF16', 'ComplexF32', 'ComplexF64', 'CompositeException', 'Condition', 'Cptrdiff_t', 'Cshort', 'Csize_t', 'Cssize_t', 'Cstring', 'Cuchar', 'Cuint', 'Cuintmax_t', 'Culong', 'Culonglong', 'Cushort', 'Cvoid', 'Cwchar_t', 'Cwstring', 'DataType', 'DenseArray', 'DenseMatrix', 'DenseVecOrMat', 'DenseVector', 'Dict', 'DimensionMismatch', 'Dims', 'DivideError', 'DomainError', 'EOFError', 'Enum', 'ErrorException', 'Exception', 'ExponentialBackOff', 'Expr', 'Float16', 'Float32', 'Float64', 'Function', 'GlobalRef', 'HTML', 'IO', 'IOBuffer', 'IOContext', 'IOStream', 'IdDict', 'IndexCartesian', 'IndexLinear', 'IndexStyle', 'InexactError', 'InitError', 'Int', 'Int128', 'Int16', 'Int32', 'Int64', 'Int8', 'Integer', 'InterruptException', 'InvalidStateException', 'Irrational', 'KeyError', 'LinRange', 'LineNumberNode', 'LinearIndices', 'LoadError', 'MIME', 'Matrix', 'Method', 'MethodError', 'Missing', 'MissingException', 'Module', 'NTuple', 'NamedTuple', 'Nothing', 'Number', 'OrdinalRange', 'OutOfMemoryError', 'OverflowError', 'Pair', 'PartialQuickSort', 'PermutedDimsArray', 'Pipe', 'ProcessFailedException', 'Ptr', 'QuoteNode', 'Rational', 'RawFD', 'ReadOnlyMemoryError', 'Real', 'ReentrantLock', 'Ref', 'Regex', 'RegexMatch', 'RoundingMode', 'SegmentationFault', 'Set', 'Signed', 'Some', 'StackOverflowError', 'StepRange', 'StepRangeLen', 'StridedArray', 'StridedMatrix', 'StridedVecOrMat', 'StridedVector', 'String', 'StringIndexError', 'SubArray', 'SubString', 'SubstitutionString', 'Symbol', 'SystemError', 'Task', 'TaskFailedException', 'Text', 'TextDisplay', 'Timer', 'Tuple', 'Type', 'TypeError', 'TypeVar', 'UInt', 'UInt128', 'UInt16', 'UInt32', 'UInt64', 'UInt8', 'UndefInitializer', 'UndefKeywordError', 'UndefRefError', 'UndefVarError', 'Union', 'UnionAll', 'UnitRange', 'Unsigned', 'Val', 'Vararg', 'VecElement', 'VecOrMat', 'Vector', 'VersionNumber', 'WeakKeyDict', 'WeakRef'];
  var KEYWORDS = {
    $pattern: VARIABLE_NAME_RE,
    keyword: KEYWORD_LIST,
    literal: LITERAL_LIST,
    built_in: BUILT_IN_LIST
  };

  // placeholder for recursive self-reference
  var DEFAULT = {
    keywords: KEYWORDS,
    illegal: /<\//
  };

  // ref: https://docs.julialang.org/en/v1/manual/integers-and-floating-point-numbers/
  var NUMBER = {
    className: 'number',
    // supported numeric literals:
    //  * binary literal (e.g. 0x10)
    //  * octal literal (e.g. 0o76543210)
    //  * hexadecimal literal (e.g. 0xfedcba876543210)
    //  * hexadecimal floating point literal (e.g. 0x1p0, 0x1.2p2)
    //  * decimal literal (e.g. 9876543210, 100_000_000)
    //  * floating pointe literal (e.g. 1.2, 1.2f, .2, 1., 1.2e10, 1.2e-10)
    begin: /(\b0x[\d_]*(\.[\d_]*)?|0x\.\d[\d_]*)p[-+]?\d+|\b0[box][a-fA-F0-9][a-fA-F0-9_]*|(\b\d[\d_]*(\.[\d_]*)?|\.\d[\d_]*)([eEfF][-+]?\d+)?/,
    relevance: 0
  };
  var CHAR = {
    className: 'string',
    begin: /'(.|\\[xXuU][a-zA-Z0-9]+)'/
  };
  var INTERPOLATION = {
    className: 'subst',
    begin: /\$\(/,
    end: /\)/,
    keywords: KEYWORDS
  };
  var INTERPOLATED_VARIABLE = {
    className: 'variable',
    begin: '\\$' + VARIABLE_NAME_RE
  };

  // TODO: neatly escape normal code in string literal
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, INTERPOLATION, INTERPOLATED_VARIABLE],
    variants: [{
      begin: /\w*"""/,
      end: /"""\w*/,
      relevance: 10
    }, {
      begin: /\w*"/,
      end: /"\w*/
    }]
  };
  var COMMAND = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, INTERPOLATION, INTERPOLATED_VARIABLE],
    begin: '`',
    end: '`'
  };
  var MACROCALL = {
    className: 'meta',
    begin: '@' + VARIABLE_NAME_RE
  };
  var COMMENT = {
    className: 'comment',
    variants: [{
      begin: '#=',
      end: '=#',
      relevance: 10
    }, {
      begin: '#',
      end: '$'
    }]
  };
  DEFAULT.name = 'Julia';
  DEFAULT.contains = [NUMBER, CHAR, STRING, COMMAND, MACROCALL, COMMENT, hljs.HASH_COMMENT_MODE, {
    className: 'keyword',
    begin: '\\b(((abstract|primitive)\\s+)type|(mutable\\s+)?struct)\\b'
  }, {
    begin: /<:/
  } // relevance booster
  ];

  INTERPOLATION.contains = DEFAULT.contains;
  return DEFAULT;
}
module.exports = julia;

/***/ }),

/***/ 38239:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
// https://docs.oracle.com/javase/specs/jls/se15/html/jls-3.html#jls-3.10
var decimalDigits = '[0-9](_*[0-9])*';
var frac = "\\.(".concat(decimalDigits, ")");
var hexDigits = '[0-9a-fA-F](_*[0-9a-fA-F])*';
var NUMERIC = {
  className: 'number',
  variants: [
  // DecimalFloatingPointLiteral
  // including ExponentPart
  {
    begin: "(\\b(".concat(decimalDigits, ")((").concat(frac, ")|\\.)?|(").concat(frac, "))") + "[eE][+-]?(".concat(decimalDigits, ")[fFdD]?\\b")
  },
  // excluding ExponentPart
  {
    begin: "\\b(".concat(decimalDigits, ")((").concat(frac, ")[fFdD]?\\b|\\.([fFdD]\\b)?)")
  }, {
    begin: "(".concat(frac, ")[fFdD]?\\b")
  }, {
    begin: "\\b(".concat(decimalDigits, ")[fFdD]\\b")
  },
  // HexadecimalFloatingPointLiteral
  {
    begin: "\\b0[xX]((".concat(hexDigits, ")\\.?|(").concat(hexDigits, ")?\\.(").concat(hexDigits, "))") + "[pP][+-]?(".concat(decimalDigits, ")[fFdD]?\\b")
  },
  // DecimalIntegerLiteral
  {
    begin: '\\b(0|[1-9](_*[0-9])*)[lL]?\\b'
  },
  // HexIntegerLiteral
  {
    begin: "\\b0[xX](".concat(hexDigits, ")[lL]?\\b")
  },
  // OctalIntegerLiteral
  {
    begin: '\\b0(_*[0-7])*[lL]?\\b'
  },
  // BinaryIntegerLiteral
  {
    begin: '\\b0[bB][01](_*[01])*[lL]?\\b'
  }],
  relevance: 0
};

/*
 Language: Kotlin
 Description: Kotlin is an OSS statically typed programming language that targets the JVM, Android, JavaScript and Native.
 Author: Sergey Mashkov <cy6erGn0m@gmail.com>
 Website: https://kotlinlang.org
 Category: common
 */

function kotlin(hljs) {
  var KEYWORDS = {
    keyword: 'abstract as val var vararg get set class object open private protected public noinline ' + 'crossinline dynamic final enum if else do while for when throw try catch finally ' + 'import package is in fun override companion reified inline lateinit init ' + 'interface annotation data sealed internal infix operator out by constructor super ' + 'tailrec where const inner suspend typealias external expect actual',
    built_in: 'Byte Short Char Int Long Boolean Float Double Void Unit Nothing',
    literal: 'true false null'
  };
  var KEYWORDS_WITH_LABEL = {
    className: 'keyword',
    begin: /\b(break|continue|return|this)\b/,
    starts: {
      contains: [{
        className: 'symbol',
        begin: /@\w+/
      }]
    }
  };
  var LABEL = {
    className: 'symbol',
    begin: hljs.UNDERSCORE_IDENT_RE + '@'
  };

  // for string templates
  var SUBST = {
    className: 'subst',
    begin: /\$\{/,
    end: /\}/,
    contains: [hljs.C_NUMBER_MODE]
  };
  var VARIABLE = {
    className: 'variable',
    begin: '\\$' + hljs.UNDERSCORE_IDENT_RE
  };
  var STRING = {
    className: 'string',
    variants: [{
      begin: '"""',
      end: '"""(?=[^"])',
      contains: [VARIABLE, SUBST]
    },
    // Can't use built-in modes easily, as we want to use STRING in the meta
    // context as 'meta-string' and there's no syntax to remove explicitly set
    // classNames in built-in modes.
    {
      begin: '\'',
      end: '\'',
      illegal: /\n/,
      contains: [hljs.BACKSLASH_ESCAPE]
    }, {
      begin: '"',
      end: '"',
      illegal: /\n/,
      contains: [hljs.BACKSLASH_ESCAPE, VARIABLE, SUBST]
    }]
  };
  SUBST.contains.push(STRING);
  var ANNOTATION_USE_SITE = {
    className: 'meta',
    begin: '@(?:file|property|field|get|set|receiver|param|setparam|delegate)\\s*:(?:\\s*' + hljs.UNDERSCORE_IDENT_RE + ')?'
  };
  var ANNOTATION = {
    className: 'meta',
    begin: '@' + hljs.UNDERSCORE_IDENT_RE,
    contains: [{
      begin: /\(/,
      end: /\)/,
      contains: [hljs.inherit(STRING, {
        className: 'meta-string'
      })]
    }]
  };

  // https://kotlinlang.org/docs/reference/whatsnew11.html#underscores-in-numeric-literals
  // According to the doc above, the number mode of kotlin is the same as java 8,
  // so the code below is copied from java.js
  var KOTLIN_NUMBER_MODE = NUMERIC;
  var KOTLIN_NESTED_COMMENT = hljs.COMMENT('/\\*', '\\*/', {
    contains: [hljs.C_BLOCK_COMMENT_MODE]
  });
  var KOTLIN_PAREN_TYPE = {
    variants: [{
      className: 'type',
      begin: hljs.UNDERSCORE_IDENT_RE
    }, {
      begin: /\(/,
      end: /\)/,
      contains: [] // defined later
    }]
  };

  var KOTLIN_PAREN_TYPE2 = KOTLIN_PAREN_TYPE;
  KOTLIN_PAREN_TYPE2.variants[1].contains = [KOTLIN_PAREN_TYPE];
  KOTLIN_PAREN_TYPE.variants[1].contains = [KOTLIN_PAREN_TYPE2];
  return {
    name: 'Kotlin',
    aliases: ['kt', 'kts'],
    keywords: KEYWORDS,
    contains: [hljs.COMMENT('/\\*\\*', '\\*/', {
      relevance: 0,
      contains: [{
        className: 'doctag',
        begin: '@[A-Za-z]+'
      }]
    }), hljs.C_LINE_COMMENT_MODE, KOTLIN_NESTED_COMMENT, KEYWORDS_WITH_LABEL, LABEL, ANNOTATION_USE_SITE, ANNOTATION, {
      className: 'function',
      beginKeywords: 'fun',
      end: '[(]|$',
      returnBegin: true,
      excludeEnd: true,
      keywords: KEYWORDS,
      relevance: 5,
      contains: [{
        begin: hljs.UNDERSCORE_IDENT_RE + '\\s*\\(',
        returnBegin: true,
        relevance: 0,
        contains: [hljs.UNDERSCORE_TITLE_MODE]
      }, {
        className: 'type',
        begin: /</,
        end: />/,
        keywords: 'reified',
        relevance: 0
      }, {
        className: 'params',
        begin: /\(/,
        end: /\)/,
        endsParent: true,
        keywords: KEYWORDS,
        relevance: 0,
        contains: [{
          begin: /:/,
          end: /[=,\/]/,
          endsWithParent: true,
          contains: [KOTLIN_PAREN_TYPE, hljs.C_LINE_COMMENT_MODE, KOTLIN_NESTED_COMMENT],
          relevance: 0
        }, hljs.C_LINE_COMMENT_MODE, KOTLIN_NESTED_COMMENT, ANNOTATION_USE_SITE, ANNOTATION, STRING, hljs.C_NUMBER_MODE]
      }, KOTLIN_NESTED_COMMENT]
    }, {
      className: 'class',
      beginKeywords: 'class interface trait',
      // remove 'trait' when removed from KEYWORDS
      end: /[:\{(]|$/,
      excludeEnd: true,
      illegal: 'extends implements',
      contains: [{
        beginKeywords: 'public protected internal private constructor'
      }, hljs.UNDERSCORE_TITLE_MODE, {
        className: 'type',
        begin: /</,
        end: />/,
        excludeBegin: true,
        excludeEnd: true,
        relevance: 0
      }, {
        className: 'type',
        begin: /[,:]\s*/,
        end: /[<\(,]|$/,
        excludeBegin: true,
        returnEnd: true
      }, ANNOTATION_USE_SITE, ANNOTATION]
    }, STRING, {
      className: 'meta',
      begin: "^#!/usr/bin/env",
      end: '$',
      illegal: '\n'
    }, KOTLIN_NUMBER_MODE]
  };
}
module.exports = kotlin;

/***/ }),

/***/ 93436:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
/*
Language: Lasso
Author: Eric Knibbe <eric@lassosoft.com>
Description: Lasso is a language and server platform for database-driven web applications. This definition handles Lasso 9 syntax and LassoScript for Lasso 8.6 and earlier.
Website: http://www.lassosoft.com/What-Is-Lasso
*/

function lasso(hljs) {
  var LASSO_IDENT_RE = '[a-zA-Z_][\\w.]*';
  var LASSO_ANGLE_RE = '<\\?(lasso(script)?|=)';
  var LASSO_CLOSE_RE = '\\]|\\?>';
  var LASSO_KEYWORDS = {
    $pattern: LASSO_IDENT_RE + '|&[lg]t;',
    literal: 'true false none minimal full all void and or not ' + 'bw nbw ew new cn ncn lt lte gt gte eq neq rx nrx ft',
    built_in: 'array date decimal duration integer map pair string tag xml null ' + 'boolean bytes keyword list locale queue set stack staticarray ' + 'local var variable global data self inherited currentcapture givenblock',
    keyword: 'cache database_names database_schemanames database_tablenames ' + 'define_tag define_type email_batch encode_set html_comment handle ' + 'handle_error header if inline iterate ljax_target link ' + 'link_currentaction link_currentgroup link_currentrecord link_detail ' + 'link_firstgroup link_firstrecord link_lastgroup link_lastrecord ' + 'link_nextgroup link_nextrecord link_prevgroup link_prevrecord log ' + 'loop namespace_using output_none portal private protect records ' + 'referer referrer repeating resultset rows search_args ' + 'search_arguments select sort_args sort_arguments thread_atomic ' + 'value_list while abort case else fail_if fail_ifnot fail if_empty ' + 'if_false if_null if_true loop_abort loop_continue loop_count params ' + 'params_up return return_value run_children soap_definetag ' + 'soap_lastrequest soap_lastresponse tag_name ascending average by ' + 'define descending do equals frozen group handle_failure import in ' + 'into join let match max min on order parent protected provide public ' + 'require returnhome skip split_thread sum take thread to trait type ' + 'where with yield yieldhome'
  };
  var HTML_COMMENT = hljs.COMMENT('<!--', '-->', {
    relevance: 0
  });
  var LASSO_NOPROCESS = {
    className: 'meta',
    begin: '\\[noprocess\\]',
    starts: {
      end: '\\[/noprocess\\]',
      returnEnd: true,
      contains: [HTML_COMMENT]
    }
  };
  var LASSO_START = {
    className: 'meta',
    begin: '\\[/noprocess|' + LASSO_ANGLE_RE
  };
  var LASSO_DATAMEMBER = {
    className: 'symbol',
    begin: '\'' + LASSO_IDENT_RE + '\''
  };
  var LASSO_CODE = [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.inherit(hljs.C_NUMBER_MODE, {
    begin: hljs.C_NUMBER_RE + '|(-?infinity|NaN)\\b'
  }), hljs.inherit(hljs.APOS_STRING_MODE, {
    illegal: null
  }), hljs.inherit(hljs.QUOTE_STRING_MODE, {
    illegal: null
  }), {
    className: 'string',
    begin: '`',
    end: '`'
  }, {
    // variables
    variants: [{
      begin: '[#$]' + LASSO_IDENT_RE
    }, {
      begin: '#',
      end: '\\d+',
      illegal: '\\W'
    }]
  }, {
    className: 'type',
    begin: '::\\s*',
    end: LASSO_IDENT_RE,
    illegal: '\\W'
  }, {
    className: 'params',
    variants: [{
      begin: '-(?!infinity)' + LASSO_IDENT_RE,
      relevance: 0
    }, {
      begin: '(\\.\\.\\.)'
    }]
  }, {
    begin: /(->|\.)\s*/,
    relevance: 0,
    contains: [LASSO_DATAMEMBER]
  }, {
    className: 'class',
    beginKeywords: 'define',
    returnEnd: true,
    end: '\\(|=>',
    contains: [hljs.inherit(hljs.TITLE_MODE, {
      begin: LASSO_IDENT_RE + '(=(?!>))?|[-+*/%](?!>)'
    })]
  }];
  return {
    name: 'Lasso',
    aliases: ['ls', 'lassoscript'],
    case_insensitive: true,
    keywords: LASSO_KEYWORDS,
    contains: [{
      className: 'meta',
      begin: LASSO_CLOSE_RE,
      relevance: 0,
      starts: {
        // markup
        end: '\\[|' + LASSO_ANGLE_RE,
        returnEnd: true,
        relevance: 0,
        contains: [HTML_COMMENT]
      }
    }, LASSO_NOPROCESS, LASSO_START, {
      className: 'meta',
      begin: '\\[no_square_brackets',
      starts: {
        end: '\\[/no_square_brackets\\]',
        // not implemented in the language
        keywords: LASSO_KEYWORDS,
        contains: [{
          className: 'meta',
          begin: LASSO_CLOSE_RE,
          relevance: 0,
          starts: {
            end: '\\[noprocess\\]|' + LASSO_ANGLE_RE,
            returnEnd: true,
            contains: [HTML_COMMENT]
          }
        }, LASSO_NOPROCESS, LASSO_START].concat(LASSO_CODE)
      }
    }, {
      className: 'meta',
      begin: '\\[',
      relevance: 0
    }, {
      className: 'meta',
      begin: '^#!',
      end: 'lasso9$',
      relevance: 10
    }].concat(LASSO_CODE)
  };
}
module.exports = lasso;

/***/ }),

/***/ 81389:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(24603);
__webpack_require__(74916);
__webpack_require__(39714);
__webpack_require__(92222);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(91038);
__webpack_require__(47042);
__webpack_require__(68309);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */
function either() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = '(' + args.map(function (x) {
    return source(x);
  }).join("|") + ")";
  return joined;
}

/*
Language: LaTeX
Author: Benedikt Wilde <bwilde@posteo.de>
Website: https://www.latex-project.org
Category: markup
*/

/** @type LanguageFn */
function latex(hljs) {
  var _ref;
  var KNOWN_CONTROL_WORDS = either.apply(void 0, _toConsumableArray(['(?:NeedsTeXFormat|RequirePackage|GetIdInfo)', 'Provides(?:Expl)?(?:Package|Class|File)', '(?:DeclareOption|ProcessOptions)', '(?:documentclass|usepackage|input|include)', 'makeat(?:letter|other)', 'ExplSyntax(?:On|Off)', '(?:new|renew|provide)?command', '(?:re)newenvironment', '(?:New|Renew|Provide|Declare)(?:Expandable)?DocumentCommand', '(?:New|Renew|Provide|Declare)DocumentEnvironment', '(?:(?:e|g|x)?def|let)', '(?:begin|end)', '(?:part|chapter|(?:sub){0,2}section|(?:sub)?paragraph)', 'caption', '(?:label|(?:eq|page|name)?ref|(?:paren|foot|super)?cite)', '(?:alpha|beta|[Gg]amma|[Dd]elta|(?:var)?epsilon|zeta|eta|[Tt]heta|vartheta)', '(?:iota|(?:var)?kappa|[Ll]ambda|mu|nu|[Xx]i|[Pp]i|varpi|(?:var)rho)', '(?:[Ss]igma|varsigma|tau|[Uu]psilon|[Pp]hi|varphi|chi|[Pp]si|[Oo]mega)', '(?:frac|sum|prod|lim|infty|times|sqrt|leq|geq|left|right|middle|[bB]igg?)', '(?:[lr]angle|q?quad|[lcvdi]?dots|d?dot|hat|tilde|bar)'].map(function (word) {
    return word + '(?![a-zA-Z@:_])';
  })));
  var L3_REGEX = new RegExp([
  // A function \module_function_name:signature or \__module_function_name:signature,
  // where both module and function_name need at least two characters and
  // function_name may contain single underscores.
  '(?:__)?[a-zA-Z]{2,}_[a-zA-Z](?:_?[a-zA-Z])+:[a-zA-Z]*',
  // A variable \scope_module_and_name_type or \scope__module_ane_name_type,
  // where scope is one of l, g or c, type needs at least two characters
  // and module_and_name may contain single underscores.
  '[lgc]__?[a-zA-Z](?:_?[a-zA-Z])*_[a-zA-Z]{2,}',
  // A quark \q_the_name or \q__the_name or
  // scan mark \s_the_name or \s__vthe_name,
  // where variable_name needs at least two characters and
  // may contain single underscores.
  '[qs]__?[a-zA-Z](?:_?[a-zA-Z])+',
  // Other LaTeX3 macro names that are not covered by the three rules above.
  'use(?:_i)?:[a-zA-Z]*', '(?:else|fi|or):', '(?:if|cs|exp):w', '(?:hbox|vbox):n', '::[a-zA-Z]_unbraced', '::[a-zA-Z:]'].map(function (pattern) {
    return pattern + '(?![a-zA-Z:_])';
  }).join('|'));
  var L2_VARIANTS = [{
    begin: /[a-zA-Z@]+/
  },
  // control word
  {
    begin: /[^a-zA-Z@]?/
  } // control symbol
  ];

  var DOUBLE_CARET_VARIANTS = [{
    begin: /\^{6}[0-9a-f]{6}/
  }, {
    begin: /\^{5}[0-9a-f]{5}/
  }, {
    begin: /\^{4}[0-9a-f]{4}/
  }, {
    begin: /\^{3}[0-9a-f]{3}/
  }, {
    begin: /\^{2}[0-9a-f]{2}/
  }, {
    begin: /\^{2}[\u0000-\u007f]/
  }];
  var CONTROL_SEQUENCE = {
    className: 'keyword',
    begin: /\\/,
    relevance: 0,
    contains: [{
      endsParent: true,
      begin: KNOWN_CONTROL_WORDS
    }, {
      endsParent: true,
      begin: L3_REGEX
    }, {
      endsParent: true,
      variants: DOUBLE_CARET_VARIANTS
    }, {
      endsParent: true,
      relevance: 0,
      variants: L2_VARIANTS
    }]
  };
  var MACRO_PARAM = {
    className: 'params',
    relevance: 0,
    begin: /#+\d?/
  };
  var DOUBLE_CARET_CHAR = {
    // relevance: 1
    variants: DOUBLE_CARET_VARIANTS
  };
  var SPECIAL_CATCODE = {
    className: 'built_in',
    relevance: 0,
    begin: /[$&^_]/
  };
  var MAGIC_COMMENT = {
    className: 'meta',
    begin: '% !TeX',
    end: '$',
    relevance: 10
  };
  var COMMENT = hljs.COMMENT('%', '$', {
    relevance: 0
  });
  var EVERYTHING_BUT_VERBATIM = [CONTROL_SEQUENCE, MACRO_PARAM, DOUBLE_CARET_CHAR, SPECIAL_CATCODE, MAGIC_COMMENT, COMMENT];
  var BRACE_GROUP_NO_VERBATIM = {
    begin: /\{/,
    end: /\}/,
    relevance: 0,
    contains: ['self'].concat(EVERYTHING_BUT_VERBATIM)
  };
  var ARGUMENT_BRACES = hljs.inherit(BRACE_GROUP_NO_VERBATIM, {
    relevance: 0,
    endsParent: true,
    contains: [BRACE_GROUP_NO_VERBATIM].concat(EVERYTHING_BUT_VERBATIM)
  });
  var ARGUMENT_BRACKETS = {
    begin: /\[/,
    end: /\]/,
    endsParent: true,
    relevance: 0,
    contains: [BRACE_GROUP_NO_VERBATIM].concat(EVERYTHING_BUT_VERBATIM)
  };
  var SPACE_GOBBLER = {
    begin: /\s+/,
    relevance: 0
  };
  var ARGUMENT_M = [ARGUMENT_BRACES];
  var ARGUMENT_O = [ARGUMENT_BRACKETS];
  var ARGUMENT_AND_THEN = function ARGUMENT_AND_THEN(arg, starts_mode) {
    return {
      contains: [SPACE_GOBBLER],
      starts: {
        relevance: 0,
        contains: arg,
        starts: starts_mode
      }
    };
  };
  var CSNAME = function CSNAME(csname, starts_mode) {
    return {
      begin: '\\\\' + csname + '(?![a-zA-Z@:_])',
      keywords: {
        $pattern: /\\[a-zA-Z]+/,
        keyword: '\\' + csname
      },
      relevance: 0,
      contains: [SPACE_GOBBLER],
      starts: starts_mode
    };
  };
  var BEGIN_ENV = function BEGIN_ENV(envname, starts_mode) {
    return hljs.inherit({
      begin: '\\\\begin(?=[ \t]*(\\r?\\n[ \t]*)?\\{' + envname + '\\})',
      keywords: {
        $pattern: /\\[a-zA-Z]+/,
        keyword: '\\begin'
      },
      relevance: 0
    }, ARGUMENT_AND_THEN(ARGUMENT_M, starts_mode));
  };
  var VERBATIM_DELIMITED_EQUAL = function VERBATIM_DELIMITED_EQUAL() {
    var innerName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "string";
    return hljs.END_SAME_AS_BEGIN({
      className: innerName,
      begin: /(.|\r?\n)/,
      end: /(.|\r?\n)/,
      excludeBegin: true,
      excludeEnd: true,
      endsParent: true
    });
  };
  var VERBATIM_DELIMITED_ENV = function VERBATIM_DELIMITED_ENV(envname) {
    return {
      className: 'string',
      end: '(?=\\\\end\\{' + envname + '\\})'
    };
  };
  var VERBATIM_DELIMITED_BRACES = function VERBATIM_DELIMITED_BRACES() {
    var innerName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "string";
    return {
      relevance: 0,
      begin: /\{/,
      starts: {
        endsParent: true,
        contains: [{
          className: innerName,
          end: /(?=\})/,
          endsParent: true,
          contains: [{
            begin: /\{/,
            end: /\}/,
            relevance: 0,
            contains: ["self"]
          }]
        }]
      }
    };
  };
  var VERBATIM = [].concat(_toConsumableArray(['verb', 'lstinline'].map(function (csname) {
    return CSNAME(csname, {
      contains: [VERBATIM_DELIMITED_EQUAL()]
    });
  })), [CSNAME('mint', ARGUMENT_AND_THEN(ARGUMENT_M, {
    contains: [VERBATIM_DELIMITED_EQUAL()]
  })), CSNAME('mintinline', ARGUMENT_AND_THEN(ARGUMENT_M, {
    contains: [VERBATIM_DELIMITED_BRACES(), VERBATIM_DELIMITED_EQUAL()]
  })), CSNAME('url', {
    contains: [VERBATIM_DELIMITED_BRACES("link"), VERBATIM_DELIMITED_BRACES("link")]
  }), CSNAME('hyperref', {
    contains: [VERBATIM_DELIMITED_BRACES("link")]
  }), CSNAME('href', ARGUMENT_AND_THEN(ARGUMENT_O, {
    contains: [VERBATIM_DELIMITED_BRACES("link")]
  }))], _toConsumableArray((_ref = []).concat.apply(_ref, _toConsumableArray(['', '\\*'].map(function (suffix) {
    return [BEGIN_ENV('verbatim' + suffix, VERBATIM_DELIMITED_ENV('verbatim' + suffix)), BEGIN_ENV('filecontents' + suffix, ARGUMENT_AND_THEN(ARGUMENT_M, VERBATIM_DELIMITED_ENV('filecontents' + suffix)))].concat(_toConsumableArray(['', 'B', 'L'].map(function (prefix) {
      return BEGIN_ENV(prefix + 'Verbatim' + suffix, ARGUMENT_AND_THEN(ARGUMENT_O, VERBATIM_DELIMITED_ENV(prefix + 'Verbatim' + suffix)));
    })));
  })))), [BEGIN_ENV('minted', ARGUMENT_AND_THEN(ARGUMENT_O, ARGUMENT_AND_THEN(ARGUMENT_M, VERBATIM_DELIMITED_ENV('minted'))))]);
  return {
    name: 'LaTeX',
    aliases: ['tex'],
    contains: [].concat(_toConsumableArray(VERBATIM), EVERYTHING_BUT_VERBATIM)
  };
}
module.exports = latex;

/***/ }),

/***/ 7931:
/***/ ((module) => {

/*
Language: LDIF
Contributors: Jacob Childress <jacobc@gmail.com>
Category: enterprise, config
Website: https://en.wikipedia.org/wiki/LDAP_Data_Interchange_Format
*/
function ldif(hljs) {
  return {
    name: 'LDIF',
    contains: [{
      className: 'attribute',
      begin: '^dn',
      end: ': ',
      excludeEnd: true,
      starts: {
        end: '$',
        relevance: 0
      },
      relevance: 10
    }, {
      className: 'attribute',
      begin: '^\\w',
      end: ': ',
      excludeEnd: true,
      starts: {
        end: '$',
        relevance: 0
      }
    }, {
      className: 'literal',
      begin: '^-',
      end: '$'
    }, hljs.HASH_COMMENT_MODE]
  };
}
module.exports = ldif;

/***/ }),

/***/ 54079:
/***/ ((module) => {

/*
Language: Leaf
Author: Hale Chan <halechan@qq.com>
Description: Based on the Leaf reference from https://vapor.github.io/documentation/guide/leaf.html.
*/

function leaf(hljs) {
  return {
    name: 'Leaf',
    contains: [{
      className: 'function',
      begin: '#+' + '[A-Za-z_0-9]*' + '\\(',
      end: / \{/,
      returnBegin: true,
      excludeEnd: true,
      contains: [{
        className: 'keyword',
        begin: '#+'
      }, {
        className: 'title',
        begin: '[A-Za-z_][A-Za-z_0-9]*'
      }, {
        className: 'params',
        begin: '\\(',
        end: '\\)',
        endsParent: true,
        contains: [{
          className: 'string',
          begin: '"',
          end: '"'
        }, {
          className: 'variable',
          begin: '[A-Za-z_][A-Za-z_0-9]*'
        }]
      }]
    }]
  };
}
module.exports = leaf;

/***/ }),

/***/ 17929:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
__webpack_require__(69600);
var MODES = function MODES(hljs) {
  return {
    IMPORTANT: {
      className: 'meta',
      begin: '!important'
    },
    HEXCOLOR: {
      className: 'number',
      begin: '#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})'
    },
    ATTRIBUTE_SELECTOR_MODE: {
      className: 'selector-attr',
      begin: /\[/,
      end: /\]/,
      illegal: '$',
      contains: [hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE]
    }
  };
};
var TAGS = ['a', 'abbr', 'address', 'article', 'aside', 'audio', 'b', 'blockquote', 'body', 'button', 'canvas', 'caption', 'cite', 'code', 'dd', 'del', 'details', 'dfn', 'div', 'dl', 'dt', 'em', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'mark', 'menu', 'nav', 'object', 'ol', 'p', 'q', 'quote', 'samp', 'section', 'span', 'strong', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'ul', 'var', 'video'];
var MEDIA_FEATURES = ['any-hover', 'any-pointer', 'aspect-ratio', 'color', 'color-gamut', 'color-index', 'device-aspect-ratio', 'device-height', 'device-width', 'display-mode', 'forced-colors', 'grid', 'height', 'hover', 'inverted-colors', 'monochrome', 'orientation', 'overflow-block', 'overflow-inline', 'pointer', 'prefers-color-scheme', 'prefers-contrast', 'prefers-reduced-motion', 'prefers-reduced-transparency', 'resolution', 'scan', 'scripting', 'update', 'width',
// TODO: find a better solution?
'min-width', 'max-width', 'min-height', 'max-height'];

// https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-classes
var PSEUDO_CLASSES = ['active', 'any-link', 'blank', 'checked', 'current', 'default', 'defined', 'dir',
// dir()
'disabled', 'drop', 'empty', 'enabled', 'first', 'first-child', 'first-of-type', 'fullscreen', 'future', 'focus', 'focus-visible', 'focus-within', 'has',
// has()
'host',
// host or host()
'host-context',
// host-context()
'hover', 'indeterminate', 'in-range', 'invalid', 'is',
// is()
'lang',
// lang()
'last-child', 'last-of-type', 'left', 'link', 'local-link', 'not',
// not()
'nth-child',
// nth-child()
'nth-col',
// nth-col()
'nth-last-child',
// nth-last-child()
'nth-last-col',
// nth-last-col()
'nth-last-of-type',
//nth-last-of-type()
'nth-of-type',
//nth-of-type()
'only-child', 'only-of-type', 'optional', 'out-of-range', 'past', 'placeholder-shown', 'read-only', 'read-write', 'required', 'right', 'root', 'scope', 'target', 'target-within', 'user-invalid', 'valid', 'visited', 'where' // where()
];

// https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-elements
var PSEUDO_ELEMENTS = ['after', 'backdrop', 'before', 'cue', 'cue-region', 'first-letter', 'first-line', 'grammar-error', 'marker', 'part', 'placeholder', 'selection', 'slotted', 'spelling-error'];
var ATTRIBUTES = ['align-content', 'align-items', 'align-self', 'animation', 'animation-delay', 'animation-direction', 'animation-duration', 'animation-fill-mode', 'animation-iteration-count', 'animation-name', 'animation-play-state', 'animation-timing-function', 'auto', 'backface-visibility', 'background', 'background-attachment', 'background-clip', 'background-color', 'background-image', 'background-origin', 'background-position', 'background-repeat', 'background-size', 'border', 'border-bottom', 'border-bottom-color', 'border-bottom-left-radius', 'border-bottom-right-radius', 'border-bottom-style', 'border-bottom-width', 'border-collapse', 'border-color', 'border-image', 'border-image-outset', 'border-image-repeat', 'border-image-slice', 'border-image-source', 'border-image-width', 'border-left', 'border-left-color', 'border-left-style', 'border-left-width', 'border-radius', 'border-right', 'border-right-color', 'border-right-style', 'border-right-width', 'border-spacing', 'border-style', 'border-top', 'border-top-color', 'border-top-left-radius', 'border-top-right-radius', 'border-top-style', 'border-top-width', 'border-width', 'bottom', 'box-decoration-break', 'box-shadow', 'box-sizing', 'break-after', 'break-before', 'break-inside', 'caption-side', 'clear', 'clip', 'clip-path', 'color', 'column-count', 'column-fill', 'column-gap', 'column-rule', 'column-rule-color', 'column-rule-style', 'column-rule-width', 'column-span', 'column-width', 'columns', 'content', 'counter-increment', 'counter-reset', 'cursor', 'direction', 'display', 'empty-cells', 'filter', 'flex', 'flex-basis', 'flex-direction', 'flex-flow', 'flex-grow', 'flex-shrink', 'flex-wrap', 'float', 'font', 'font-display', 'font-family', 'font-feature-settings', 'font-kerning', 'font-language-override', 'font-size', 'font-size-adjust', 'font-smoothing', 'font-stretch', 'font-style', 'font-variant', 'font-variant-ligatures', 'font-variation-settings', 'font-weight', 'height', 'hyphens', 'icon', 'image-orientation', 'image-rendering', 'image-resolution', 'ime-mode', 'inherit', 'initial', 'justify-content', 'left', 'letter-spacing', 'line-height', 'list-style', 'list-style-image', 'list-style-position', 'list-style-type', 'margin', 'margin-bottom', 'margin-left', 'margin-right', 'margin-top', 'marks', 'mask', 'max-height', 'max-width', 'min-height', 'min-width', 'nav-down', 'nav-index', 'nav-left', 'nav-right', 'nav-up', 'none', 'normal', 'object-fit', 'object-position', 'opacity', 'order', 'orphans', 'outline', 'outline-color', 'outline-offset', 'outline-style', 'outline-width', 'overflow', 'overflow-wrap', 'overflow-x', 'overflow-y', 'padding', 'padding-bottom', 'padding-left', 'padding-right', 'padding-top', 'page-break-after', 'page-break-before', 'page-break-inside', 'perspective', 'perspective-origin', 'pointer-events', 'position', 'quotes', 'resize', 'right', 'src',
// @font-face
'tab-size', 'table-layout', 'text-align', 'text-align-last', 'text-decoration', 'text-decoration-color', 'text-decoration-line', 'text-decoration-style', 'text-indent', 'text-overflow', 'text-rendering', 'text-shadow', 'text-transform', 'text-underline-position', 'top', 'transform', 'transform-origin', 'transform-style', 'transition', 'transition-delay', 'transition-duration', 'transition-property', 'transition-timing-function', 'unicode-bidi', 'vertical-align', 'visibility', 'white-space', 'widows', 'width', 'word-break', 'word-spacing', 'word-wrap', 'z-index'
// reverse makes sure longer attributes `font-weight` are matched fully
// instead of getting false positives on say `font`
].reverse();

// some grammars use them all as a single group
var PSEUDO_SELECTORS = PSEUDO_CLASSES.concat(PSEUDO_ELEMENTS);

/*
Language: Less
Description: It's CSS, with just a little more.
Author:   Max Mikhailov <seven.phases.max@gmail.com>
Website: http://lesscss.org
Category: common, css
*/

/** @type LanguageFn */
function less(hljs) {
  var modes = MODES(hljs);
  var PSEUDO_SELECTORS$1 = PSEUDO_SELECTORS;
  var AT_MODIFIERS = "and or not only";
  var IDENT_RE = '[\\w-]+'; // yes, Less identifiers may begin with a digit
  var INTERP_IDENT_RE = '(' + IDENT_RE + '|@\\{' + IDENT_RE + '\\})';

  /* Generic Modes */

  var RULES = [];
  var VALUE_MODES = []; // forward def. for recursive modes

  var STRING_MODE = function STRING_MODE(c) {
    return {
      // Less strings are not multiline (also include '~' for more consistent coloring of "escaped" strings)
      className: 'string',
      begin: '~?' + c + '.*?' + c
    };
  };
  var IDENT_MODE = function IDENT_MODE(name, begin, relevance) {
    return {
      className: name,
      begin: begin,
      relevance: relevance
    };
  };
  var AT_KEYWORDS = {
    $pattern: /[a-z-]+/,
    keyword: AT_MODIFIERS,
    attribute: MEDIA_FEATURES.join(" ")
  };
  var PARENS_MODE = {
    // used only to properly balance nested parens inside mixin call, def. arg list
    begin: '\\(',
    end: '\\)',
    contains: VALUE_MODES,
    keywords: AT_KEYWORDS,
    relevance: 0
  };

  // generic Less highlighter (used almost everywhere except selectors):
  VALUE_MODES.push(hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, STRING_MODE("'"), STRING_MODE('"'), hljs.CSS_NUMBER_MODE,
  // fixme: it does not include dot for numbers like .5em :(
  {
    begin: '(url|data-uri)\\(',
    starts: {
      className: 'string',
      end: '[\\)\\n]',
      excludeEnd: true
    }
  }, modes.HEXCOLOR, PARENS_MODE, IDENT_MODE('variable', '@@?' + IDENT_RE, 10), IDENT_MODE('variable', '@\\{' + IDENT_RE + '\\}'), IDENT_MODE('built_in', '~?`[^`]*?`'),
  // inline javascript (or whatever host language) *multiline* string
  {
    // @media features (it’s here to not duplicate things in AT_RULE_MODE with extra PARENS_MODE overriding):
    className: 'attribute',
    begin: IDENT_RE + '\\s*:',
    end: ':',
    returnBegin: true,
    excludeEnd: true
  }, modes.IMPORTANT);
  var VALUE_WITH_RULESETS = VALUE_MODES.concat({
    begin: /\{/,
    end: /\}/,
    contains: RULES
  });
  var MIXIN_GUARD_MODE = {
    beginKeywords: 'when',
    endsWithParent: true,
    contains: [{
      beginKeywords: 'and not'
    }].concat(VALUE_MODES) // using this form to override VALUE’s 'function' match
  };

  /* Rule-Level Modes */

  var RULE_MODE = {
    begin: INTERP_IDENT_RE + '\\s*:',
    returnBegin: true,
    end: /[;}]/,
    relevance: 0,
    contains: [{
      begin: /-(webkit|moz|ms|o)-/
    }, {
      className: 'attribute',
      begin: '\\b(' + ATTRIBUTES.join('|') + ')\\b',
      end: /(?=:)/,
      starts: {
        endsWithParent: true,
        illegal: '[<=$]',
        relevance: 0,
        contains: VALUE_MODES
      }
    }]
  };
  var AT_RULE_MODE = {
    className: 'keyword',
    begin: '@(import|media|charset|font-face|(-[a-z]+-)?keyframes|supports|document|namespace|page|viewport|host)\\b',
    starts: {
      end: '[;{}]',
      keywords: AT_KEYWORDS,
      returnEnd: true,
      contains: VALUE_MODES,
      relevance: 0
    }
  };

  // variable definitions and calls
  var VAR_RULE_MODE = {
    className: 'variable',
    variants: [
    // using more strict pattern for higher relevance to increase chances of Less detection.
    // this is *the only* Less specific statement used in most of the sources, so...
    // (we’ll still often loose to the css-parser unless there's '//' comment,
    // simply because 1 variable just can't beat 99 properties :)
    {
      begin: '@' + IDENT_RE + '\\s*:',
      relevance: 15
    }, {
      begin: '@' + IDENT_RE
    }],
    starts: {
      end: '[;}]',
      returnEnd: true,
      contains: VALUE_WITH_RULESETS
    }
  };
  var SELECTOR_MODE = {
    // first parse unambiguous selectors (i.e. those not starting with tag)
    // then fall into the scary lookahead-discriminator variant.
    // this mode also handles mixin definitions and calls
    variants: [{
      begin: '[\\.#:&\\[>]',
      end: '[;{}]' // mixin calls end with ';'
    }, {
      begin: INTERP_IDENT_RE,
      end: /\{/
    }],
    returnBegin: true,
    returnEnd: true,
    illegal: '[<=\'$"]',
    relevance: 0,
    contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, MIXIN_GUARD_MODE, IDENT_MODE('keyword', 'all\\b'), IDENT_MODE('variable', '@\\{' + IDENT_RE + '\\}'),
    // otherwise it’s identified as tag
    {
      begin: '\\b(' + TAGS.join('|') + ')\\b',
      className: 'selector-tag'
    }, IDENT_MODE('selector-tag', INTERP_IDENT_RE + '%?', 0),
    // '%' for more consistent coloring of @keyframes "tags"
    IDENT_MODE('selector-id', '#' + INTERP_IDENT_RE), IDENT_MODE('selector-class', '\\.' + INTERP_IDENT_RE, 0), IDENT_MODE('selector-tag', '&', 0), modes.ATTRIBUTE_SELECTOR_MODE, {
      className: 'selector-pseudo',
      begin: ':(' + PSEUDO_CLASSES.join('|') + ')'
    }, {
      className: 'selector-pseudo',
      begin: '::(' + PSEUDO_ELEMENTS.join('|') + ')'
    }, {
      begin: '\\(',
      end: '\\)',
      contains: VALUE_WITH_RULESETS
    },
    // argument list of parametric mixins
    {
      begin: '!important'
    } // eat !important after mixin call or it will be colored as tag
    ]
  };

  var PSEUDO_SELECTOR_MODE = {
    begin: IDENT_RE + ':(:)?' + "(".concat(PSEUDO_SELECTORS$1.join('|'), ")"),
    returnBegin: true,
    contains: [SELECTOR_MODE]
  };
  RULES.push(hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, AT_RULE_MODE, VAR_RULE_MODE, PSEUDO_SELECTOR_MODE, RULE_MODE, SELECTOR_MODE);
  return {
    name: 'Less',
    case_insensitive: true,
    illegal: '[=>\'/<($"]',
    contains: RULES
  };
}
module.exports = less;

/***/ }),

/***/ 93760:
/***/ ((module) => {

/*
Language: Lisp
Description: Generic lisp syntax
Author: Vasily Polovnyov <vast@whiteants.net>
Category: lisp
*/

function lisp(hljs) {
  var LISP_IDENT_RE = '[a-zA-Z_\\-+\\*\\/<=>&#][a-zA-Z0-9_\\-+*\\/<=>&#!]*';
  var MEC_RE = '\\|[^]*?\\|';
  var LISP_SIMPLE_NUMBER_RE = '(-|\\+)?\\d+(\\.\\d+|\\/\\d+)?((d|e|f|l|s|D|E|F|L|S)(\\+|-)?\\d+)?';
  var LITERAL = {
    className: 'literal',
    begin: '\\b(t{1}|nil)\\b'
  };
  var NUMBER = {
    className: 'number',
    variants: [{
      begin: LISP_SIMPLE_NUMBER_RE,
      relevance: 0
    }, {
      begin: '#(b|B)[0-1]+(/[0-1]+)?'
    }, {
      begin: '#(o|O)[0-7]+(/[0-7]+)?'
    }, {
      begin: '#(x|X)[0-9a-fA-F]+(/[0-9a-fA-F]+)?'
    }, {
      begin: '#(c|C)\\(' + LISP_SIMPLE_NUMBER_RE + ' +' + LISP_SIMPLE_NUMBER_RE,
      end: '\\)'
    }]
  };
  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {
    illegal: null
  });
  var COMMENT = hljs.COMMENT(';', '$', {
    relevance: 0
  });
  var VARIABLE = {
    begin: '\\*',
    end: '\\*'
  };
  var KEYWORD = {
    className: 'symbol',
    begin: '[:&]' + LISP_IDENT_RE
  };
  var IDENT = {
    begin: LISP_IDENT_RE,
    relevance: 0
  };
  var MEC = {
    begin: MEC_RE
  };
  var QUOTED_LIST = {
    begin: '\\(',
    end: '\\)',
    contains: ['self', LITERAL, STRING, NUMBER, IDENT]
  };
  var QUOTED = {
    contains: [NUMBER, STRING, VARIABLE, KEYWORD, QUOTED_LIST, IDENT],
    variants: [{
      begin: '[\'`]\\(',
      end: '\\)'
    }, {
      begin: '\\(quote ',
      end: '\\)',
      keywords: {
        name: 'quote'
      }
    }, {
      begin: '\'' + MEC_RE
    }]
  };
  var QUOTED_ATOM = {
    variants: [{
      begin: '\'' + LISP_IDENT_RE
    }, {
      begin: '#\'' + LISP_IDENT_RE + '(::' + LISP_IDENT_RE + ')*'
    }]
  };
  var LIST = {
    begin: '\\(\\s*',
    end: '\\)'
  };
  var BODY = {
    endsWithParent: true,
    relevance: 0
  };
  LIST.contains = [{
    className: 'name',
    variants: [{
      begin: LISP_IDENT_RE,
      relevance: 0
    }, {
      begin: MEC_RE
    }]
  }, BODY];
  BODY.contains = [QUOTED, QUOTED_ATOM, LIST, LITERAL, NUMBER, STRING, COMMENT, VARIABLE, KEYWORD, MEC, IDENT];
  return {
    name: 'Lisp',
    illegal: /\S/,
    contains: [NUMBER, hljs.SHEBANG(), LITERAL, STRING, COMMENT, QUOTED, QUOTED_ATOM, LIST, IDENT]
  };
}
module.exports = lisp;

/***/ }),

/***/ 56327:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
/*
Language: LiveCode
Author: Ralf Bitter <rabit@revigniter.com>
Description: Language definition for LiveCode server accounting for revIgniter (a web application framework) characteristics.
Version: 1.1
Date: 2019-04-17
Category: enterprise
*/

function livecodeserver(hljs) {
  var VARIABLE = {
    className: 'variable',
    variants: [{
      begin: '\\b([gtps][A-Z]{1}[a-zA-Z0-9]*)(\\[.+\\])?(?:\\s*?)'
    }, {
      begin: '\\$_[A-Z]+'
    }],
    relevance: 0
  };
  var COMMENT_MODES = [hljs.C_BLOCK_COMMENT_MODE, hljs.HASH_COMMENT_MODE, hljs.COMMENT('--', '$'), hljs.COMMENT('[^:]//', '$')];
  var TITLE1 = hljs.inherit(hljs.TITLE_MODE, {
    variants: [{
      begin: '\\b_*rig[A-Z][A-Za-z0-9_\\-]*'
    }, {
      begin: '\\b_[a-z0-9\\-]+'
    }]
  });
  var TITLE2 = hljs.inherit(hljs.TITLE_MODE, {
    begin: '\\b([A-Za-z0-9_\\-]+)\\b'
  });
  return {
    name: 'LiveCode',
    case_insensitive: false,
    keywords: {
      keyword: '$_COOKIE $_FILES $_GET $_GET_BINARY $_GET_RAW $_POST $_POST_BINARY $_POST_RAW $_SESSION $_SERVER ' + 'codepoint codepoints segment segments codeunit codeunits sentence sentences trueWord trueWords paragraph ' + 'after byte bytes english the until http forever descending using line real8 with seventh ' + 'for stdout finally element word words fourth before black ninth sixth characters chars stderr ' + 'uInt1 uInt1s uInt2 uInt2s stdin string lines relative rel any fifth items from middle mid ' + 'at else of catch then third it file milliseconds seconds second secs sec int1 int1s int4 ' + 'int4s internet int2 int2s normal text item last long detailed effective uInt4 uInt4s repeat ' + 'end repeat URL in try into switch to words https token binfile each tenth as ticks tick ' + 'system real4 by dateItems without char character ascending eighth whole dateTime numeric short ' + 'first ftp integer abbreviated abbr abbrev private case while if ' + 'div mod wrap and or bitAnd bitNot bitOr bitXor among not in a an within ' + 'contains ends with begins the keys of keys',
      literal: 'SIX TEN FORMFEED NINE ZERO NONE SPACE FOUR FALSE COLON CRLF PI COMMA ENDOFFILE EOF EIGHT FIVE ' + 'QUOTE EMPTY ONE TRUE RETURN CR LINEFEED RIGHT BACKSLASH NULL SEVEN TAB THREE TWO ' + 'six ten formfeed nine zero none space four false colon crlf pi comma endoffile eof eight five ' + 'quote empty one true return cr linefeed right backslash null seven tab three two ' + 'RIVERSION RISTATE FILE_READ_MODE FILE_WRITE_MODE FILE_WRITE_MODE DIR_WRITE_MODE FILE_READ_UMASK ' + 'FILE_WRITE_UMASK DIR_READ_UMASK DIR_WRITE_UMASK',
      built_in: 'put abs acos aliasReference annuity arrayDecode arrayEncode asin atan atan2 average avg avgDev base64Decode ' + 'base64Encode baseConvert binaryDecode binaryEncode byteOffset byteToNum cachedURL cachedURLs charToNum ' + 'cipherNames codepointOffset codepointProperty codepointToNum codeunitOffset commandNames compound compress ' + 'constantNames cos date dateFormat decompress difference directories ' + 'diskSpace DNSServers exp exp1 exp2 exp10 extents files flushEvents folders format functionNames geometricMean global ' + 'globals hasMemory harmonicMean hostAddress hostAddressToName hostName hostNameToAddress isNumber ISOToMac itemOffset ' + 'keys len length libURLErrorData libUrlFormData libURLftpCommand libURLLastHTTPHeaders libURLLastRHHeaders ' + 'libUrlMultipartFormAddPart libUrlMultipartFormData libURLVersion lineOffset ln ln1 localNames log log2 log10 ' + 'longFilePath lower macToISO matchChunk matchText matrixMultiply max md5Digest median merge messageAuthenticationCode messageDigest millisec ' + 'millisecs millisecond milliseconds min monthNames nativeCharToNum normalizeText num number numToByte numToChar ' + 'numToCodepoint numToNativeChar offset open openfiles openProcesses openProcessIDs openSockets ' + 'paragraphOffset paramCount param params peerAddress pendingMessages platform popStdDev populationStandardDeviation ' + 'populationVariance popVariance processID random randomBytes replaceText result revCreateXMLTree revCreateXMLTreeFromFile ' + 'revCurrentRecord revCurrentRecordIsFirst revCurrentRecordIsLast revDatabaseColumnCount revDatabaseColumnIsNull ' + 'revDatabaseColumnLengths revDatabaseColumnNames revDatabaseColumnNamed revDatabaseColumnNumbered ' + 'revDatabaseColumnTypes revDatabaseConnectResult revDatabaseCursors revDatabaseID revDatabaseTableNames ' + 'revDatabaseType revDataFromQuery revdb_closeCursor revdb_columnbynumber revdb_columncount revdb_columnisnull ' + 'revdb_columnlengths revdb_columnnames revdb_columntypes revdb_commit revdb_connect revdb_connections ' + 'revdb_connectionerr revdb_currentrecord revdb_cursorconnection revdb_cursorerr revdb_cursors revdb_dbtype ' + 'revdb_disconnect revdb_execute revdb_iseof revdb_isbof revdb_movefirst revdb_movelast revdb_movenext ' + 'revdb_moveprev revdb_query revdb_querylist revdb_recordcount revdb_rollback revdb_tablenames ' + 'revGetDatabaseDriverPath revNumberOfRecords revOpenDatabase revOpenDatabases revQueryDatabase ' + 'revQueryDatabaseBlob revQueryResult revQueryIsAtStart revQueryIsAtEnd revUnixFromMacPath revXMLAttribute ' + 'revXMLAttributes revXMLAttributeValues revXMLChildContents revXMLChildNames revXMLCreateTreeFromFileWithNamespaces ' + 'revXMLCreateTreeWithNamespaces revXMLDataFromXPathQuery revXMLEvaluateXPath revXMLFirstChild revXMLMatchingNode ' + 'revXMLNextSibling revXMLNodeContents revXMLNumberOfChildren revXMLParent revXMLPreviousSibling ' + 'revXMLRootNode revXMLRPC_CreateRequest revXMLRPC_Documents revXMLRPC_Error ' + 'revXMLRPC_GetHost revXMLRPC_GetMethod revXMLRPC_GetParam revXMLText revXMLRPC_Execute ' + 'revXMLRPC_GetParamCount revXMLRPC_GetParamNode revXMLRPC_GetParamType revXMLRPC_GetPath revXMLRPC_GetPort ' + 'revXMLRPC_GetProtocol revXMLRPC_GetRequest revXMLRPC_GetResponse revXMLRPC_GetSocket revXMLTree ' + 'revXMLTrees revXMLValidateDTD revZipDescribeItem revZipEnumerateItems revZipOpenArchives round sampVariance ' + 'sec secs seconds sentenceOffset sha1Digest shell shortFilePath sin specialFolderPath sqrt standardDeviation statRound ' + 'stdDev sum sysError systemVersion tan tempName textDecode textEncode tick ticks time to tokenOffset toLower toUpper ' + 'transpose truewordOffset trunc uniDecode uniEncode upper URLDecode URLEncode URLStatus uuid value variableNames ' + 'variance version waitDepth weekdayNames wordOffset xsltApplyStylesheet xsltApplyStylesheetFromFile xsltLoadStylesheet ' + 'xsltLoadStylesheetFromFile add breakpoint cancel clear local variable file word line folder directory URL close socket process ' + 'combine constant convert create new alias folder directory decrypt delete variable word line folder ' + 'directory URL dispatch divide do encrypt filter get include intersect kill libURLDownloadToFile ' + 'libURLFollowHttpRedirects libURLftpUpload libURLftpUploadFile libURLresetAll libUrlSetAuthCallback libURLSetDriver ' + 'libURLSetCustomHTTPHeaders libUrlSetExpect100 libURLSetFTPListCommand libURLSetFTPMode libURLSetFTPStopTime ' + 'libURLSetStatusCallback load extension loadedExtensions multiply socket prepare process post seek rel relative read from process rename ' + 'replace require resetAll resolve revAddXMLNode revAppendXML revCloseCursor revCloseDatabase revCommitDatabase ' + 'revCopyFile revCopyFolder revCopyXMLNode revDeleteFolder revDeleteXMLNode revDeleteAllXMLTrees ' + 'revDeleteXMLTree revExecuteSQL revGoURL revInsertXMLNode revMoveFolder revMoveToFirstRecord revMoveToLastRecord ' + 'revMoveToNextRecord revMoveToPreviousRecord revMoveToRecord revMoveXMLNode revPutIntoXMLNode revRollBackDatabase ' + 'revSetDatabaseDriverPath revSetXMLAttribute revXMLRPC_AddParam revXMLRPC_DeleteAllDocuments revXMLAddDTD ' + 'revXMLRPC_Free revXMLRPC_FreeAll revXMLRPC_DeleteDocument revXMLRPC_DeleteParam revXMLRPC_SetHost ' + 'revXMLRPC_SetMethod revXMLRPC_SetPort revXMLRPC_SetProtocol revXMLRPC_SetSocket revZipAddItemWithData ' + 'revZipAddItemWithFile revZipAddUncompressedItemWithData revZipAddUncompressedItemWithFile revZipCancel ' + 'revZipCloseArchive revZipDeleteItem revZipExtractItemToFile revZipExtractItemToVariable revZipSetProgressCallback ' + 'revZipRenameItem revZipReplaceItemWithData revZipReplaceItemWithFile revZipOpenArchive send set sort split start stop ' + 'subtract symmetric union unload vectorDotProduct wait write'
    },
    contains: [VARIABLE, {
      className: 'keyword',
      begin: '\\bend\\sif\\b'
    }, {
      className: 'function',
      beginKeywords: 'function',
      end: '$',
      contains: [VARIABLE, TITLE2, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE, TITLE1]
    }, {
      className: 'function',
      begin: '\\bend\\s+',
      end: '$',
      keywords: 'end',
      contains: [TITLE2, TITLE1],
      relevance: 0
    }, {
      beginKeywords: 'command on',
      end: '$',
      contains: [VARIABLE, TITLE2, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE, TITLE1]
    }, {
      className: 'meta',
      variants: [{
        begin: '<\\?(rev|lc|livecode)',
        relevance: 10
      }, {
        begin: '<\\?'
      }, {
        begin: '\\?>'
      }]
    }, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE, TITLE1].concat(COMMENT_MODES),
    illegal: ';$|^\\[|^=|&|\\{'
  };
}
module.exports = livecodeserver;

/***/ }),

/***/ 1127:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
var KEYWORDS = ["as",
// for exports
"in", "of", "if", "for", "while", "finally", "var", "new", "function", "do", "return", "void", "else", "break", "catch", "instanceof", "with", "throw", "case", "default", "try", "switch", "continue", "typeof", "delete", "let", "yield", "const", "class",
// JS handles these with a special rule
// "get",
// "set",
"debugger", "async", "await", "static", "import", "from", "export", "extends"];
var LITERALS = ["true", "false", "null", "undefined", "NaN", "Infinity"];
var TYPES = ["Intl", "DataView", "Number", "Math", "Date", "String", "RegExp", "Object", "Function", "Boolean", "Error", "Symbol", "Set", "Map", "WeakSet", "WeakMap", "Proxy", "Reflect", "JSON", "Promise", "Float64Array", "Int16Array", "Int32Array", "Int8Array", "Uint16Array", "Uint32Array", "Float32Array", "Array", "Uint8Array", "Uint8ClampedArray", "ArrayBuffer", "BigInt64Array", "BigUint64Array", "BigInt"];
var ERROR_TYPES = ["EvalError", "InternalError", "RangeError", "ReferenceError", "SyntaxError", "TypeError", "URIError"];
var BUILT_IN_GLOBALS = ["setInterval", "setTimeout", "clearInterval", "clearTimeout", "require", "exports", "eval", "isFinite", "isNaN", "parseFloat", "parseInt", "decodeURI", "decodeURIComponent", "encodeURI", "encodeURIComponent", "escape", "unescape"];
var BUILT_IN_VARIABLES = ["arguments", "this", "super", "console", "window", "document", "localStorage", "module", "global" // Node.js
];

var BUILT_INS = [].concat(BUILT_IN_GLOBALS, BUILT_IN_VARIABLES, TYPES, ERROR_TYPES);

/*
Language: LiveScript
Author: Taneli Vatanen <taneli.vatanen@gmail.com>
Contributors: Jen Evers-Corvina <jen@sevvie.net>
Origin: coffeescript.js
Description: LiveScript is a programming language that transcompiles to JavaScript. For info about language see http://livescript.net/
Website: https://livescript.net
Category: scripting
*/

function livescript(hljs) {
  var LIVESCRIPT_BUILT_INS = ['npm', 'print'];
  var LIVESCRIPT_LITERALS = ['yes', 'no', 'on', 'off', 'it', 'that', 'void'];
  var LIVESCRIPT_KEYWORDS = ['then', 'unless', 'until', 'loop', 'of', 'by', 'when', 'and', 'or', 'is', 'isnt', 'not', 'it', 'that', 'otherwise', 'from', 'to', 'til', 'fallthrough', 'case', 'enum', 'native', 'list', 'map', '__hasProp', '__extends', '__slice', '__bind', '__indexOf'];
  var KEYWORDS$1 = {
    keyword: KEYWORDS.concat(LIVESCRIPT_KEYWORDS),
    literal: LITERALS.concat(LIVESCRIPT_LITERALS),
    built_in: BUILT_INS.concat(LIVESCRIPT_BUILT_INS)
  };
  var JS_IDENT_RE = '[A-Za-z$_](?:-[0-9A-Za-z$_]|[0-9A-Za-z$_])*';
  var TITLE = hljs.inherit(hljs.TITLE_MODE, {
    begin: JS_IDENT_RE
  });
  var SUBST = {
    className: 'subst',
    begin: /#\{/,
    end: /\}/,
    keywords: KEYWORDS$1
  };
  var SUBST_SIMPLE = {
    className: 'subst',
    begin: /#[A-Za-z$_]/,
    end: /(?:-[0-9A-Za-z$_]|[0-9A-Za-z$_])*/,
    keywords: KEYWORDS$1
  };
  var EXPRESSIONS = [hljs.BINARY_NUMBER_MODE, {
    className: 'number',
    begin: '(\\b0[xX][a-fA-F0-9_]+)|(\\b\\d(\\d|_\\d)*(\\.(\\d(\\d|_\\d)*)?)?(_*[eE]([-+]\\d(_\\d|\\d)*)?)?[_a-z]*)',
    relevance: 0,
    starts: {
      end: '(\\s*/)?',
      relevance: 0
    } // a number tries to eat the following slash to prevent treating it as a regexp
  }, {
    className: 'string',
    variants: [{
      begin: /'''/,
      end: /'''/,
      contains: [hljs.BACKSLASH_ESCAPE]
    }, {
      begin: /'/,
      end: /'/,
      contains: [hljs.BACKSLASH_ESCAPE]
    }, {
      begin: /"""/,
      end: /"""/,
      contains: [hljs.BACKSLASH_ESCAPE, SUBST, SUBST_SIMPLE]
    }, {
      begin: /"/,
      end: /"/,
      contains: [hljs.BACKSLASH_ESCAPE, SUBST, SUBST_SIMPLE]
    }, {
      begin: /\\/,
      end: /(\s|$)/,
      excludeEnd: true
    }]
  }, {
    className: 'regexp',
    variants: [{
      begin: '//',
      end: '//[gim]*',
      contains: [SUBST, hljs.HASH_COMMENT_MODE]
    }, {
      // regex can't start with space to parse x / 2 / 3 as two divisions
      // regex can't start with *, and it supports an "illegal" in the main mode
      begin: /\/(?![ *])(\\.|[^\\\n])*?\/[gim]*(?=\W)/
    }]
  }, {
    begin: '@' + JS_IDENT_RE
  }, {
    begin: '``',
    end: '``',
    excludeBegin: true,
    excludeEnd: true,
    subLanguage: 'javascript'
  }];
  SUBST.contains = EXPRESSIONS;
  var PARAMS = {
    className: 'params',
    begin: '\\(',
    returnBegin: true,
    /* We need another contained nameless mode to not have every nested
    pair of parens to be called "params" */
    contains: [{
      begin: /\(/,
      end: /\)/,
      keywords: KEYWORDS$1,
      contains: ['self'].concat(EXPRESSIONS)
    }]
  };
  var SYMBOLS = {
    begin: '(#=>|=>|\\|>>|-?->|!->)'
  };
  return {
    name: 'LiveScript',
    aliases: ['ls'],
    keywords: KEYWORDS$1,
    illegal: /\/\*/,
    contains: EXPRESSIONS.concat([hljs.COMMENT('\\/\\*', '\\*\\/'), hljs.HASH_COMMENT_MODE, SYMBOLS,
    // relevance booster
    {
      className: 'function',
      contains: [TITLE, PARAMS],
      returnBegin: true,
      variants: [{
        begin: '(' + JS_IDENT_RE + '\\s*(?:=|:=)\\s*)?(\\(.*\\)\\s*)?\\B->\\*?',
        end: '->\\*?'
      }, {
        begin: '(' + JS_IDENT_RE + '\\s*(?:=|:=)\\s*)?!?(\\(.*\\)\\s*)?\\B[-~]{1,2}>\\*?',
        end: '[-~]{1,2}>\\*?'
      }, {
        begin: '(' + JS_IDENT_RE + '\\s*(?:=|:=)\\s*)?(\\(.*\\)\\s*)?\\B!?[-~]{1,2}>\\*?',
        end: '!?[-~]{1,2}>\\*?'
      }]
    }, {
      className: 'class',
      beginKeywords: 'class',
      end: '$',
      illegal: /[:="\[\]]/,
      contains: [{
        beginKeywords: 'extends',
        endsWithParent: true,
        illegal: /[:="\[\]]/,
        contains: [TITLE]
      }, TITLE]
    }, {
      begin: JS_IDENT_RE + ':',
      end: ':',
      returnBegin: true,
      returnEnd: true,
      relevance: 0
    }])
  };
}
module.exports = livescript;

/***/ }),

/***/ 43305:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/*
Language: LLVM IR
Author: Michael Rodler <contact@f0rki.at>
Description: language used as intermediate representation in the LLVM compiler framework
Website: https://llvm.org/docs/LangRef.html
Category: assembler
Audit: 2020
*/

/** @type LanguageFn */
function llvm(hljs) {
  var IDENT_RE = /([-a-zA-Z$._][\w$.-]*)/;
  var TYPE = {
    className: 'type',
    begin: /\bi\d+(?=\s|\b)/
  };
  var OPERATOR = {
    className: 'operator',
    relevance: 0,
    begin: /=/
  };
  var PUNCTUATION = {
    className: 'punctuation',
    relevance: 0,
    begin: /,/
  };
  var NUMBER = {
    className: 'number',
    variants: [{
      begin: /0[xX][a-fA-F0-9]+/
    }, {
      begin: /-?\d+(?:[.]\d+)?(?:[eE][-+]?\d+(?:[.]\d+)?)?/
    }],
    relevance: 0
  };
  var LABEL = {
    className: 'symbol',
    variants: [{
      begin: /^\s*[a-z]+:/
    } // labels
    ],

    relevance: 0
  };
  var VARIABLE = {
    className: 'variable',
    variants: [{
      begin: concat(/%/, IDENT_RE)
    }, {
      begin: /%\d+/
    }, {
      begin: /#\d+/
    }]
  };
  var FUNCTION = {
    className: 'title',
    variants: [{
      begin: concat(/@/, IDENT_RE)
    }, {
      begin: /@\d+/
    }, {
      begin: concat(/!/, IDENT_RE)
    }, {
      begin: concat(/!\d+/, IDENT_RE)
    },
    // https://llvm.org/docs/LangRef.html#namedmetadatastructure
    // obviously a single digit can also be used in this fashion
    {
      begin: /!\d+/
    }]
  };
  return {
    name: 'LLVM IR',
    // TODO: split into different categories of keywords
    keywords: 'begin end true false declare define global ' + 'constant private linker_private internal ' + 'available_externally linkonce linkonce_odr weak ' + 'weak_odr appending dllimport dllexport common ' + 'default hidden protected extern_weak external ' + 'thread_local zeroinitializer undef null to tail ' + 'target triple datalayout volatile nuw nsw nnan ' + 'ninf nsz arcp fast exact inbounds align ' + 'addrspace section alias module asm sideeffect ' + 'gc dbg linker_private_weak attributes blockaddress ' + 'initialexec localdynamic localexec prefix unnamed_addr ' + 'ccc fastcc coldcc x86_stdcallcc x86_fastcallcc ' + 'arm_apcscc arm_aapcscc arm_aapcs_vfpcc ptx_device ' + 'ptx_kernel intel_ocl_bicc msp430_intrcc spir_func ' + 'spir_kernel x86_64_sysvcc x86_64_win64cc x86_thiscallcc ' + 'cc c signext zeroext inreg sret nounwind ' + 'noreturn noalias nocapture byval nest readnone ' + 'readonly inlinehint noinline alwaysinline optsize ssp ' + 'sspreq noredzone noimplicitfloat naked builtin cold ' + 'nobuiltin noduplicate nonlazybind optnone returns_twice ' + 'sanitize_address sanitize_memory sanitize_thread sspstrong ' + 'uwtable returned type opaque eq ne slt sgt ' + 'sle sge ult ugt ule uge oeq one olt ogt ' + 'ole oge ord uno ueq une x acq_rel acquire ' + 'alignstack atomic catch cleanup filter inteldialect ' + 'max min monotonic nand personality release seq_cst ' + 'singlethread umax umin unordered xchg add fadd ' + 'sub fsub mul fmul udiv sdiv fdiv urem srem ' + 'frem shl lshr ashr and or xor icmp fcmp ' + 'phi call trunc zext sext fptrunc fpext uitofp ' + 'sitofp fptoui fptosi inttoptr ptrtoint bitcast ' + 'addrspacecast select va_arg ret br switch invoke ' + 'unwind unreachable indirectbr landingpad resume ' + 'malloc alloca free load store getelementptr ' + 'extractelement insertelement shufflevector getresult ' + 'extractvalue insertvalue atomicrmw cmpxchg fence ' + 'argmemonly double',
    contains: [TYPE,
    // this matches "empty comments"...
    // ...because it's far more likely this is a statement terminator in
    // another language than an actual comment
    hljs.COMMENT(/;\s*$/, null, {
      relevance: 0
    }), hljs.COMMENT(/;/, /$/), hljs.QUOTE_STRING_MODE, {
      className: 'string',
      variants: [
      // Double-quoted string
      {
        begin: /"/,
        end: /[^\\]"/
      }]
    }, FUNCTION, PUNCTUATION, OPERATOR, VARIABLE, LABEL, NUMBER]
  };
}
module.exports = llvm;

/***/ }),

/***/ 70248:
/***/ ((module) => {

/*
Language: LSL (Linden Scripting Language)
Description: The Linden Scripting Language is used in Second Life by Linden Labs.
Author: Builder's Brewery <buildersbrewery@gmail.com>
Website: http://wiki.secondlife.com/wiki/LSL_Portal
Category: scripting
*/

function lsl(hljs) {
  var LSL_STRING_ESCAPE_CHARS = {
    className: 'subst',
    begin: /\\[tn"\\]/
  };
  var LSL_STRINGS = {
    className: 'string',
    begin: '"',
    end: '"',
    contains: [LSL_STRING_ESCAPE_CHARS]
  };
  var LSL_NUMBERS = {
    className: 'number',
    relevance: 0,
    begin: hljs.C_NUMBER_RE
  };
  var LSL_CONSTANTS = {
    className: 'literal',
    variants: [{
      begin: '\\b(PI|TWO_PI|PI_BY_TWO|DEG_TO_RAD|RAD_TO_DEG|SQRT2)\\b'
    }, {
      begin: '\\b(XP_ERROR_(EXPERIENCES_DISABLED|EXPERIENCE_(DISABLED|SUSPENDED)|INVALID_(EXPERIENCE|PARAMETERS)|KEY_NOT_FOUND|MATURITY_EXCEEDED|NONE|NOT_(FOUND|PERMITTED(_LAND)?)|NO_EXPERIENCE|QUOTA_EXCEEDED|RETRY_UPDATE|STORAGE_EXCEPTION|STORE_DISABLED|THROTTLED|UNKNOWN_ERROR)|JSON_APPEND|STATUS_(PHYSICS|ROTATE_[XYZ]|PHANTOM|SANDBOX|BLOCK_GRAB(_OBJECT)?|(DIE|RETURN)_AT_EDGE|CAST_SHADOWS|OK|MALFORMED_PARAMS|TYPE_MISMATCH|BOUNDS_ERROR|NOT_(FOUND|SUPPORTED)|INTERNAL_ERROR|WHITELIST_FAILED)|AGENT(_(BY_(LEGACY_|USER)NAME|FLYING|ATTACHMENTS|SCRIPTED|MOUSELOOK|SITTING|ON_OBJECT|AWAY|WALKING|IN_AIR|TYPING|CROUCHING|BUSY|ALWAYS_RUN|AUTOPILOT|LIST_(PARCEL(_OWNER)?|REGION)))?|CAMERA_(PITCH|DISTANCE|BEHINDNESS_(ANGLE|LAG)|(FOCUS|POSITION)(_(THRESHOLD|LOCKED|LAG))?|FOCUS_OFFSET|ACTIVE)|ANIM_ON|LOOP|REVERSE|PING_PONG|SMOOTH|ROTATE|SCALE|ALL_SIDES|LINK_(ROOT|SET|ALL_(OTHERS|CHILDREN)|THIS)|ACTIVE|PASS(IVE|_(ALWAYS|IF_NOT_HANDLED|NEVER))|SCRIPTED|CONTROL_(FWD|BACK|(ROT_)?(LEFT|RIGHT)|UP|DOWN|(ML_)?LBUTTON)|PERMISSION_(RETURN_OBJECTS|DEBIT|OVERRIDE_ANIMATIONS|SILENT_ESTATE_MANAGEMENT|TAKE_CONTROLS|TRIGGER_ANIMATION|ATTACH|CHANGE_LINKS|(CONTROL|TRACK)_CAMERA|TELEPORT)|INVENTORY_(TEXTURE|SOUND|OBJECT|SCRIPT|LANDMARK|CLOTHING|NOTECARD|BODYPART|ANIMATION|GESTURE|ALL|NONE)|CHANGED_(INVENTORY|COLOR|SHAPE|SCALE|TEXTURE|LINK|ALLOWED_DROP|OWNER|REGION(_START)?|TELEPORT|MEDIA)|OBJECT_(CLICK_ACTION|HOVER_HEIGHT|LAST_OWNER_ID|(PHYSICS|SERVER|STREAMING)_COST|UNKNOWN_DETAIL|CHARACTER_TIME|PHANTOM|PHYSICS|TEMP_(ATTACHED|ON_REZ)|NAME|DESC|POS|PRIM_(COUNT|EQUIVALENCE)|RETURN_(PARCEL(_OWNER)?|REGION)|REZZER_KEY|ROO?T|VELOCITY|OMEGA|OWNER|GROUP(_TAG)?|CREATOR|ATTACHED_(POINT|SLOTS_AVAILABLE)|RENDER_WEIGHT|(BODY_SHAPE|PATHFINDING)_TYPE|(RUNNING|TOTAL)_SCRIPT_COUNT|TOTAL_INVENTORY_COUNT|SCRIPT_(MEMORY|TIME))|TYPE_(INTEGER|FLOAT|STRING|KEY|VECTOR|ROTATION|INVALID)|(DEBUG|PUBLIC)_CHANNEL|ATTACH_(AVATAR_CENTER|CHEST|HEAD|BACK|PELVIS|MOUTH|CHIN|NECK|NOSE|BELLY|[LR](SHOULDER|HAND|FOOT|EAR|EYE|[UL](ARM|LEG)|HIP)|(LEFT|RIGHT)_PEC|HUD_(CENTER_[12]|TOP_(RIGHT|CENTER|LEFT)|BOTTOM(_(RIGHT|LEFT))?)|[LR]HAND_RING1|TAIL_(BASE|TIP)|[LR]WING|FACE_(JAW|[LR]EAR|[LR]EYE|TOUNGE)|GROIN|HIND_[LR]FOOT)|LAND_(LEVEL|RAISE|LOWER|SMOOTH|NOISE|REVERT)|DATA_(ONLINE|NAME|BORN|SIM_(POS|STATUS|RATING)|PAYINFO)|PAYMENT_INFO_(ON_FILE|USED)|REMOTE_DATA_(CHANNEL|REQUEST|REPLY)|PSYS_(PART_(BF_(ZERO|ONE(_MINUS_(DEST_COLOR|SOURCE_(ALPHA|COLOR)))?|DEST_COLOR|SOURCE_(ALPHA|COLOR))|BLEND_FUNC_(DEST|SOURCE)|FLAGS|(START|END)_(COLOR|ALPHA|SCALE|GLOW)|MAX_AGE|(RIBBON|WIND|INTERP_(COLOR|SCALE)|BOUNCE|FOLLOW_(SRC|VELOCITY)|TARGET_(POS|LINEAR)|EMISSIVE)_MASK)|SRC_(MAX_AGE|PATTERN|ANGLE_(BEGIN|END)|BURST_(RATE|PART_COUNT|RADIUS|SPEED_(MIN|MAX))|ACCEL|TEXTURE|TARGET_KEY|OMEGA|PATTERN_(DROP|EXPLODE|ANGLE(_CONE(_EMPTY)?)?)))|VEHICLE_(REFERENCE_FRAME|TYPE_(NONE|SLED|CAR|BOAT|AIRPLANE|BALLOON)|(LINEAR|ANGULAR)_(FRICTION_TIMESCALE|MOTOR_DIRECTION)|LINEAR_MOTOR_OFFSET|HOVER_(HEIGHT|EFFICIENCY|TIMESCALE)|BUOYANCY|(LINEAR|ANGULAR)_(DEFLECTION_(EFFICIENCY|TIMESCALE)|MOTOR_(DECAY_)?TIMESCALE)|VERTICAL_ATTRACTION_(EFFICIENCY|TIMESCALE)|BANKING_(EFFICIENCY|MIX|TIMESCALE)|FLAG_(NO_DEFLECTION_UP|LIMIT_(ROLL_ONLY|MOTOR_UP)|HOVER_((WATER|TERRAIN|UP)_ONLY|GLOBAL_HEIGHT)|MOUSELOOK_(STEER|BANK)|CAMERA_DECOUPLED))|PRIM_(ALLOW_UNSIT|ALPHA_MODE(_(BLEND|EMISSIVE|MASK|NONE))?|NORMAL|SPECULAR|TYPE(_(BOX|CYLINDER|PRISM|SPHERE|TORUS|TUBE|RING|SCULPT))?|HOLE_(DEFAULT|CIRCLE|SQUARE|TRIANGLE)|MATERIAL(_(STONE|METAL|GLASS|WOOD|FLESH|PLASTIC|RUBBER))?|SHINY_(NONE|LOW|MEDIUM|HIGH)|BUMP_(NONE|BRIGHT|DARK|WOOD|BARK|BRICKS|CHECKER|CONCRETE|TILE|STONE|DISKS|GRAVEL|BLOBS|SIDING|LARGETILE|STUCCO|SUCTION|WEAVE)|TEXGEN_(DEFAULT|PLANAR)|SCRIPTED_SIT_ONLY|SCULPT_(TYPE_(SPHERE|TORUS|PLANE|CYLINDER|MASK)|FLAG_(MIRROR|INVERT))|PHYSICS(_(SHAPE_(CONVEX|NONE|PRIM|TYPE)))?|(POS|ROT)_LOCAL|SLICE|TEXT|FLEXIBLE|POINT_LIGHT|TEMP_ON_REZ|PHANTOM|POSITION|SIT_TARGET|SIZE|ROTATION|TEXTURE|NAME|OMEGA|DESC|LINK_TARGET|COLOR|BUMP_SHINY|FULLBRIGHT|TEXGEN|GLOW|MEDIA_(ALT_IMAGE_ENABLE|CONTROLS|(CURRENT|HOME)_URL|AUTO_(LOOP|PLAY|SCALE|ZOOM)|FIRST_CLICK_INTERACT|(WIDTH|HEIGHT)_PIXELS|WHITELIST(_ENABLE)?|PERMS_(INTERACT|CONTROL)|PARAM_MAX|CONTROLS_(STANDARD|MINI)|PERM_(NONE|OWNER|GROUP|ANYONE)|MAX_(URL_LENGTH|WHITELIST_(SIZE|COUNT)|(WIDTH|HEIGHT)_PIXELS)))|MASK_(BASE|OWNER|GROUP|EVERYONE|NEXT)|PERM_(TRANSFER|MODIFY|COPY|MOVE|ALL)|PARCEL_(MEDIA_COMMAND_(STOP|PAUSE|PLAY|LOOP|TEXTURE|URL|TIME|AGENT|UNLOAD|AUTO_ALIGN|TYPE|SIZE|DESC|LOOP_SET)|FLAG_(ALLOW_(FLY|(GROUP_)?SCRIPTS|LANDMARK|TERRAFORM|DAMAGE|CREATE_(GROUP_)?OBJECTS)|USE_(ACCESS_(GROUP|LIST)|BAN_LIST|LAND_PASS_LIST)|LOCAL_SOUND_ONLY|RESTRICT_PUSHOBJECT|ALLOW_(GROUP|ALL)_OBJECT_ENTRY)|COUNT_(TOTAL|OWNER|GROUP|OTHER|SELECTED|TEMP)|DETAILS_(NAME|DESC|OWNER|GROUP|AREA|ID|SEE_AVATARS))|LIST_STAT_(MAX|MIN|MEAN|MEDIAN|STD_DEV|SUM(_SQUARES)?|NUM_COUNT|GEOMETRIC_MEAN|RANGE)|PAY_(HIDE|DEFAULT)|REGION_FLAG_(ALLOW_DAMAGE|FIXED_SUN|BLOCK_TERRAFORM|SANDBOX|DISABLE_(COLLISIONS|PHYSICS)|BLOCK_FLY|ALLOW_DIRECT_TELEPORT|RESTRICT_PUSHOBJECT)|HTTP_(METHOD|MIMETYPE|BODY_(MAXLENGTH|TRUNCATED)|CUSTOM_HEADER|PRAGMA_NO_CACHE|VERBOSE_THROTTLE|VERIFY_CERT)|SIT_(INVALID_(AGENT|LINK_OBJECT)|NO(T_EXPERIENCE|_(ACCESS|EXPERIENCE_PERMISSION|SIT_TARGET)))|STRING_(TRIM(_(HEAD|TAIL))?)|CLICK_ACTION_(NONE|TOUCH|SIT|BUY|PAY|OPEN(_MEDIA)?|PLAY|ZOOM)|TOUCH_INVALID_FACE|PROFILE_(NONE|SCRIPT_MEMORY)|RC_(DATA_FLAGS|DETECT_PHANTOM|GET_(LINK_NUM|NORMAL|ROOT_KEY)|MAX_HITS|REJECT_(TYPES|AGENTS|(NON)?PHYSICAL|LAND))|RCERR_(CAST_TIME_EXCEEDED|SIM_PERF_LOW|UNKNOWN)|ESTATE_ACCESS_(ALLOWED_(AGENT|GROUP)_(ADD|REMOVE)|BANNED_AGENT_(ADD|REMOVE))|DENSITY|FRICTION|RESTITUTION|GRAVITY_MULTIPLIER|KFM_(COMMAND|CMD_(PLAY|STOP|PAUSE)|MODE|FORWARD|LOOP|PING_PONG|REVERSE|DATA|ROTATION|TRANSLATION)|ERR_(GENERIC|PARCEL_PERMISSIONS|MALFORMED_PARAMS|RUNTIME_PERMISSIONS|THROTTLED)|CHARACTER_(CMD_((SMOOTH_)?STOP|JUMP)|DESIRED_(TURN_)?SPEED|RADIUS|STAY_WITHIN_PARCEL|LENGTH|ORIENTATION|ACCOUNT_FOR_SKIPPED_FRAMES|AVOIDANCE_MODE|TYPE(_([ABCD]|NONE))?|MAX_(DECEL|TURN_RADIUS|(ACCEL|SPEED)))|PURSUIT_(OFFSET|FUZZ_FACTOR|GOAL_TOLERANCE|INTERCEPT)|REQUIRE_LINE_OF_SIGHT|FORCE_DIRECT_PATH|VERTICAL|HORIZONTAL|AVOID_(CHARACTERS|DYNAMIC_OBSTACLES|NONE)|PU_(EVADE_(HIDDEN|SPOTTED)|FAILURE_(DYNAMIC_PATHFINDING_DISABLED|INVALID_(GOAL|START)|NO_(NAVMESH|VALID_DESTINATION)|OTHER|TARGET_GONE|(PARCEL_)?UNREACHABLE)|(GOAL|SLOWDOWN_DISTANCE)_REACHED)|TRAVERSAL_TYPE(_(FAST|NONE|SLOW))?|CONTENT_TYPE_(ATOM|FORM|HTML|JSON|LLSD|RSS|TEXT|XHTML|XML)|GCNP_(RADIUS|STATIC)|(PATROL|WANDER)_PAUSE_AT_WAYPOINTS|OPT_(AVATAR|CHARACTER|EXCLUSION_VOLUME|LEGACY_LINKSET|MATERIAL_VOLUME|OTHER|STATIC_OBSTACLE|WALKABLE)|SIM_STAT_PCT_CHARS_STEPPED)\\b'
    }, {
      begin: '\\b(FALSE|TRUE)\\b'
    }, {
      begin: '\\b(ZERO_ROTATION)\\b'
    }, {
      begin: '\\b(EOF|JSON_(ARRAY|DELETE|FALSE|INVALID|NULL|NUMBER|OBJECT|STRING|TRUE)|NULL_KEY|TEXTURE_(BLANK|DEFAULT|MEDIA|PLYWOOD|TRANSPARENT)|URL_REQUEST_(GRANTED|DENIED))\\b'
    }, {
      begin: '\\b(ZERO_VECTOR|TOUCH_INVALID_(TEXCOORD|VECTOR))\\b'
    }]
  };
  var LSL_FUNCTIONS = {
    className: 'built_in',
    begin: '\\b(ll(AgentInExperience|(Create|DataSize|Delete|KeyCount|Keys|Read|Update)KeyValue|GetExperience(Details|ErrorMessage)|ReturnObjectsBy(ID|Owner)|Json(2List|[GS]etValue|ValueType)|Sin|Cos|Tan|Atan2|Sqrt|Pow|Abs|Fabs|Frand|Floor|Ceil|Round|Vec(Mag|Norm|Dist)|Rot(Between|2(Euler|Fwd|Left|Up))|(Euler|Axes)2Rot|Whisper|(Region|Owner)?Say|Shout|Listen(Control|Remove)?|Sensor(Repeat|Remove)?|Detected(Name|Key|Owner|Type|Pos|Vel|Grab|Rot|Group|LinkNumber)|Die|Ground|Wind|([GS]et)(AnimationOverride|MemoryLimit|PrimMediaParams|ParcelMusicURL|Object(Desc|Name)|PhysicsMaterial|Status|Scale|Color|Alpha|Texture|Pos|Rot|Force|Torque)|ResetAnimationOverride|(Scale|Offset|Rotate)Texture|(Rot)?Target(Remove)?|(Stop)?MoveToTarget|Apply(Rotational)?Impulse|Set(KeyframedMotion|ContentType|RegionPos|(Angular)?Velocity|Buoyancy|HoverHeight|ForceAndTorque|TimerEvent|ScriptState|Damage|TextureAnim|Sound(Queueing|Radius)|Vehicle(Type|(Float|Vector|Rotation)Param)|(Touch|Sit)?Text|Camera(Eye|At)Offset|PrimitiveParams|ClickAction|Link(Alpha|Color|PrimitiveParams(Fast)?|Texture(Anim)?|Camera|Media)|RemoteScriptAccessPin|PayPrice|LocalRot)|ScaleByFactor|Get((Max|Min)ScaleFactor|ClosestNavPoint|StaticPath|SimStats|Env|PrimitiveParams|Link(PrimitiveParams|Number(OfSides)?|Key|Name|Media)|HTTPHeader|FreeURLs|Object(Details|PermMask|PrimCount)|Parcel(MaxPrims|Details|Prim(Count|Owners))|Attached(List)?|(SPMax|Free|Used)Memory|Region(Name|TimeDilation|FPS|Corner|AgentCount)|Root(Position|Rotation)|UnixTime|(Parcel|Region)Flags|(Wall|GMT)clock|SimulatorHostname|BoundingBox|GeometricCenter|Creator|NumberOf(Prims|NotecardLines|Sides)|Animation(List)?|(Camera|Local)(Pos|Rot)|Vel|Accel|Omega|Time(stamp|OfDay)|(Object|CenterOf)?Mass|MassMKS|Energy|Owner|(Owner)?Key|SunDirection|Texture(Offset|Scale|Rot)|Inventory(Number|Name|Key|Type|Creator|PermMask)|Permissions(Key)?|StartParameter|List(Length|EntryType)|Date|Agent(Size|Info|Language|List)|LandOwnerAt|NotecardLine|Script(Name|State))|(Get|Reset|GetAndReset)Time|PlaySound(Slave)?|LoopSound(Master|Slave)?|(Trigger|Stop|Preload)Sound|((Get|Delete)Sub|Insert)String|To(Upper|Lower)|Give(InventoryList|Money)|RezObject|(Stop)?LookAt|Sleep|CollisionFilter|(Take|Release)Controls|DetachFromAvatar|AttachToAvatar(Temp)?|InstantMessage|(GetNext)?Email|StopHover|MinEventDelay|RotLookAt|String(Length|Trim)|(Start|Stop)Animation|TargetOmega|Request(Experience)?Permissions|(Create|Break)Link|BreakAllLinks|(Give|Remove)Inventory|Water|PassTouches|Request(Agent|Inventory)Data|TeleportAgent(Home|GlobalCoords)?|ModifyLand|CollisionSound|ResetScript|MessageLinked|PushObject|PassCollisions|AxisAngle2Rot|Rot2(Axis|Angle)|A(cos|sin)|AngleBetween|AllowInventoryDrop|SubStringIndex|List2(CSV|Integer|Json|Float|String|Key|Vector|Rot|List(Strided)?)|DeleteSubList|List(Statistics|Sort|Randomize|(Insert|Find|Replace)List)|EdgeOfWorld|AdjustSoundVolume|Key2Name|TriggerSoundLimited|EjectFromLand|(CSV|ParseString)2List|OverMyLand|SameGroup|UnSit|Ground(Slope|Normal|Contour)|GroundRepel|(Set|Remove)VehicleFlags|SitOnLink|(AvatarOn)?(Link)?SitTarget|Script(Danger|Profiler)|Dialog|VolumeDetect|ResetOtherScript|RemoteLoadScriptPin|(Open|Close)RemoteDataChannel|SendRemoteData|RemoteDataReply|(Integer|String)ToBase64|XorBase64|Log(10)?|Base64To(String|Integer)|ParseStringKeepNulls|RezAtRoot|RequestSimulatorData|ForceMouselook|(Load|Release|(E|Une)scape)URL|ParcelMedia(CommandList|Query)|ModPow|MapDestination|(RemoveFrom|AddTo|Reset)Land(Pass|Ban)List|(Set|Clear)CameraParams|HTTP(Request|Response)|TextBox|DetectedTouch(UV|Face|Pos|(N|Bin)ormal|ST)|(MD5|SHA1|DumpList2)String|Request(Secure)?URL|Clear(Prim|Link)Media|(Link)?ParticleSystem|(Get|Request)(Username|DisplayName)|RegionSayTo|CastRay|GenerateKey|TransferLindenDollars|ManageEstateAccess|(Create|Delete)Character|ExecCharacterCmd|Evade|FleeFrom|NavigateTo|PatrolPoints|Pursue|UpdateCharacter|WanderWithin))\\b'
  };
  return {
    name: 'LSL (Linden Scripting Language)',
    illegal: ':',
    contains: [LSL_STRINGS, {
      className: 'comment',
      variants: [hljs.COMMENT('//', '$'), hljs.COMMENT('/\\*', '\\*/')],
      relevance: 0
    }, LSL_NUMBERS, {
      className: 'section',
      variants: [{
        begin: '\\b(state|default)\\b'
      }, {
        begin: '\\b(state_(entry|exit)|touch(_(start|end))?|(land_)?collision(_(start|end))?|timer|listen|(no_)?sensor|control|(not_)?at_(rot_)?target|money|email|experience_permissions(_denied)?|run_time_permissions|changed|attach|dataserver|moving_(start|end)|link_message|(on|object)_rez|remote_data|http_re(sponse|quest)|path_update|transaction_result)\\b'
      }]
    }, LSL_FUNCTIONS, LSL_CONSTANTS, {
      className: 'type',
      begin: '\\b(integer|float|string|key|vector|quaternion|rotation|list)\\b'
    }]
  };
}
module.exports = lsl;

/***/ }),

/***/ 61644:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
/*
Language: Lua
Description: Lua is a powerful, efficient, lightweight, embeddable scripting language.
Author: Andrew Fedorov <dmmdrs@mail.ru>
Category: common, scripting
Website: https://www.lua.org
*/

function lua(hljs) {
  var OPENING_LONG_BRACKET = '\\[=*\\[';
  var CLOSING_LONG_BRACKET = '\\]=*\\]';
  var LONG_BRACKETS = {
    begin: OPENING_LONG_BRACKET,
    end: CLOSING_LONG_BRACKET,
    contains: ['self']
  };
  var COMMENTS = [hljs.COMMENT('--(?!' + OPENING_LONG_BRACKET + ')', '$'), hljs.COMMENT('--' + OPENING_LONG_BRACKET, CLOSING_LONG_BRACKET, {
    contains: [LONG_BRACKETS],
    relevance: 10
  })];
  return {
    name: 'Lua',
    keywords: {
      $pattern: hljs.UNDERSCORE_IDENT_RE,
      literal: "true false nil",
      keyword: "and break do else elseif end for goto if in local not or repeat return then until while",
      built_in:
      // Metatags and globals:
      '_G _ENV _VERSION __index __newindex __mode __call __metatable __tostring __len ' + '__gc __add __sub __mul __div __mod __pow __concat __unm __eq __lt __le assert ' +
      // Standard methods and properties:
      'collectgarbage dofile error getfenv getmetatable ipairs load loadfile loadstring ' + 'module next pairs pcall print rawequal rawget rawset require select setfenv ' + 'setmetatable tonumber tostring type unpack xpcall arg self ' +
      // Library methods and properties (one line per library):
      'coroutine resume yield status wrap create running debug getupvalue ' + 'debug sethook getmetatable gethook setmetatable setlocal traceback setfenv getinfo setupvalue getlocal getregistry getfenv ' + 'io lines write close flush open output type read stderr stdin input stdout popen tmpfile ' + 'math log max acos huge ldexp pi cos tanh pow deg tan cosh sinh random randomseed frexp ceil floor rad abs sqrt modf asin min mod fmod log10 atan2 exp sin atan ' + 'os exit setlocale date getenv difftime remove time clock tmpname rename execute package preload loadlib loaded loaders cpath config path seeall ' + 'string sub upper len gfind rep find match char dump gmatch reverse byte format gsub lower ' + 'table setn insert getn foreachi maxn foreach concat sort remove'
    },
    contains: COMMENTS.concat([{
      className: 'function',
      beginKeywords: 'function',
      end: '\\)',
      contains: [hljs.inherit(hljs.TITLE_MODE, {
        begin: '([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*'
      }), {
        className: 'params',
        begin: '\\(',
        endsWithParent: true,
        contains: COMMENTS
      }].concat(COMMENTS)
    }, hljs.C_NUMBER_MODE, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, {
      className: 'string',
      begin: OPENING_LONG_BRACKET,
      end: CLOSING_LONG_BRACKET,
      contains: [LONG_BRACKETS],
      relevance: 5
    }])
  };
}
module.exports = lua;

/***/ }),

/***/ 17331:
/***/ ((module) => {

/*
Language: Makefile
Author: Ivan Sagalaev <maniac@softwaremaniacs.org>
Contributors: Joël Porquet <joel@porquet.org>
Website: https://www.gnu.org/software/make/manual/html_node/Introduction.html
Category: common
*/

function makefile(hljs) {
  /* Variables: simple (eg $(var)) and special (eg $@) */
  var VARIABLE = {
    className: 'variable',
    variants: [{
      begin: '\\$\\(' + hljs.UNDERSCORE_IDENT_RE + '\\)',
      contains: [hljs.BACKSLASH_ESCAPE]
    }, {
      begin: /\$[@%<?\^\+\*]/
    }]
  };
  /* Quoted string with variables inside */
  var QUOTE_STRING = {
    className: 'string',
    begin: /"/,
    end: /"/,
    contains: [hljs.BACKSLASH_ESCAPE, VARIABLE]
  };
  /* Function: $(func arg,...) */
  var FUNC = {
    className: 'variable',
    begin: /\$\([\w-]+\s/,
    end: /\)/,
    keywords: {
      built_in: 'subst patsubst strip findstring filter filter-out sort ' + 'word wordlist firstword lastword dir notdir suffix basename ' + 'addsuffix addprefix join wildcard realpath abspath error warning ' + 'shell origin flavor foreach if or and call eval file value'
    },
    contains: [VARIABLE]
  };
  /* Variable assignment */
  var ASSIGNMENT = {
    begin: '^' + hljs.UNDERSCORE_IDENT_RE + '\\s*(?=[:+?]?=)'
  };
  /* Meta targets (.PHONY) */
  var META = {
    className: 'meta',
    begin: /^\.PHONY:/,
    end: /$/,
    keywords: {
      $pattern: /[\.\w]+/,
      'meta-keyword': '.PHONY'
    }
  };
  /* Targets */
  var TARGET = {
    className: 'section',
    begin: /^[^\s]+:/,
    end: /$/,
    contains: [VARIABLE]
  };
  return {
    name: 'Makefile',
    aliases: ['mk', 'mak', 'make'],
    keywords: {
      $pattern: /[\w-]+/,
      keyword: 'define endef undefine ifdef ifndef ifeq ifneq else endif ' + 'include -include sinclude override export unexport private vpath'
    },
    contains: [hljs.HASH_COMMENT_MODE, VARIABLE, QUOTE_STRING, FUNC, ASSIGNMENT, META, TARGET]
  };
}
module.exports = makefile;

/***/ }),

/***/ 8224:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(92222);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/*
Language: Markdown
Requires: xml.js
Author: John Crepezzi <john.crepezzi@gmail.com>
Website: https://daringfireball.net/projects/markdown/
Category: common, markup
*/

function markdown(hljs) {
  var INLINE_HTML = {
    begin: /<\/?[A-Za-z_]/,
    end: '>',
    subLanguage: 'xml',
    relevance: 0
  };
  var HORIZONTAL_RULE = {
    begin: '^[-\\*]{3,}',
    end: '$'
  };
  var CODE = {
    className: 'code',
    variants: [
    // TODO: fix to allow these to work with sublanguage also
    {
      begin: '(`{3,})[^`](.|\\n)*?\\1`*[ ]*'
    }, {
      begin: '(~{3,})[^~](.|\\n)*?\\1~*[ ]*'
    },
    // needed to allow markdown as a sublanguage to work
    {
      begin: '```',
      end: '```+[ ]*$'
    }, {
      begin: '~~~',
      end: '~~~+[ ]*$'
    }, {
      begin: '`.+?`'
    }, {
      begin: '(?=^( {4}|\\t))',
      // use contains to gobble up multiple lines to allow the block to be whatever size
      // but only have a single open/close tag vs one per line
      contains: [{
        begin: '^( {4}|\\t)',
        end: '(\\n)$'
      }],
      relevance: 0
    }]
  };
  var LIST = {
    className: 'bullet',
    begin: '^[ \t]*([*+-]|(\\d+\\.))(?=\\s+)',
    end: '\\s+',
    excludeEnd: true
  };
  var LINK_REFERENCE = {
    begin: /^\[[^\n]+\]:/,
    returnBegin: true,
    contains: [{
      className: 'symbol',
      begin: /\[/,
      end: /\]/,
      excludeBegin: true,
      excludeEnd: true
    }, {
      className: 'link',
      begin: /:\s*/,
      end: /$/,
      excludeBegin: true
    }]
  };
  var URL_SCHEME = /[A-Za-z][A-Za-z0-9+.-]*/;
  var LINK = {
    variants: [
    // too much like nested array access in so many languages
    // to have any real relevance
    {
      begin: /\[.+?\]\[.*?\]/,
      relevance: 0
    },
    // popular internet URLs
    {
      begin: /\[.+?\]\(((data|javascript|mailto):|(?:http|ftp)s?:\/\/).*?\)/,
      relevance: 2
    }, {
      begin: concat(/\[.+?\]\(/, URL_SCHEME, /:\/\/.*?\)/),
      relevance: 2
    },
    // relative urls
    {
      begin: /\[.+?\]\([./?&#].*?\)/,
      relevance: 1
    },
    // whatever else, lower relevance (might not be a link at all)
    {
      begin: /\[.+?\]\(.*?\)/,
      relevance: 0
    }],
    returnBegin: true,
    contains: [{
      className: 'string',
      relevance: 0,
      begin: '\\[',
      end: '\\]',
      excludeBegin: true,
      returnEnd: true
    }, {
      className: 'link',
      relevance: 0,
      begin: '\\]\\(',
      end: '\\)',
      excludeBegin: true,
      excludeEnd: true
    }, {
      className: 'symbol',
      relevance: 0,
      begin: '\\]\\[',
      end: '\\]',
      excludeBegin: true,
      excludeEnd: true
    }]
  };
  var BOLD = {
    className: 'strong',
    contains: [],
    // defined later
    variants: [{
      begin: /_{2}/,
      end: /_{2}/
    }, {
      begin: /\*{2}/,
      end: /\*{2}/
    }]
  };
  var ITALIC = {
    className: 'emphasis',
    contains: [],
    // defined later
    variants: [{
      begin: /\*(?!\*)/,
      end: /\*/
    }, {
      begin: /_(?!_)/,
      end: /_/,
      relevance: 0
    }]
  };
  BOLD.contains.push(ITALIC);
  ITALIC.contains.push(BOLD);
  var CONTAINABLE = [INLINE_HTML, LINK];
  BOLD.contains = BOLD.contains.concat(CONTAINABLE);
  ITALIC.contains = ITALIC.contains.concat(CONTAINABLE);
  CONTAINABLE = CONTAINABLE.concat(BOLD, ITALIC);
  var HEADER = {
    className: 'section',
    variants: [{
      begin: '^#{1,6}',
      end: '$',
      contains: CONTAINABLE
    }, {
      begin: '(?=^.+?\\n[=-]{2,}$)',
      contains: [{
        begin: '^[=-]*$'
      }, {
        begin: '^',
        end: "\\n",
        contains: CONTAINABLE
      }]
    }]
  };
  var BLOCKQUOTE = {
    className: 'quote',
    begin: '^>\\s+',
    contains: CONTAINABLE,
    end: '$'
  };
  return {
    name: 'Markdown',
    aliases: ['md', 'mkdown', 'mkd'],
    contains: [HEADER, INLINE_HTML, LIST, BOLD, ITALIC, BLOCKQUOTE, CODE, HORIZONTAL_RULE, LINK, LINK_REFERENCE]
  };
}
module.exports = markdown;

/***/ }),

/***/ 74276:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(66992);
__webpack_require__(41539);
__webpack_require__(70189);
__webpack_require__(78783);
__webpack_require__(33948);
var SYSTEM_SYMBOLS = ["AASTriangle", "AbelianGroup", "Abort", "AbortKernels", "AbortProtect", "AbortScheduledTask", "Above", "Abs", "AbsArg", "AbsArgPlot", "Absolute", "AbsoluteCorrelation", "AbsoluteCorrelationFunction", "AbsoluteCurrentValue", "AbsoluteDashing", "AbsoluteFileName", "AbsoluteOptions", "AbsolutePointSize", "AbsoluteThickness", "AbsoluteTime", "AbsoluteTiming", "AcceptanceThreshold", "AccountingForm", "Accumulate", "Accuracy", "AccuracyGoal", "ActionDelay", "ActionMenu", "ActionMenuBox", "ActionMenuBoxOptions", "Activate", "Active", "ActiveClassification", "ActiveClassificationObject", "ActiveItem", "ActivePrediction", "ActivePredictionObject", "ActiveStyle", "AcyclicGraphQ", "AddOnHelpPath", "AddSides", "AddTo", "AddToSearchIndex", "AddUsers", "AdjacencyGraph", "AdjacencyList", "AdjacencyMatrix", "AdjacentMeshCells", "AdjustmentBox", "AdjustmentBoxOptions", "AdjustTimeSeriesForecast", "AdministrativeDivisionData", "AffineHalfSpace", "AffineSpace", "AffineStateSpaceModel", "AffineTransform", "After", "AggregatedEntityClass", "AggregationLayer", "AircraftData", "AirportData", "AirPressureData", "AirTemperatureData", "AiryAi", "AiryAiPrime", "AiryAiZero", "AiryBi", "AiryBiPrime", "AiryBiZero", "AlgebraicIntegerQ", "AlgebraicNumber", "AlgebraicNumberDenominator", "AlgebraicNumberNorm", "AlgebraicNumberPolynomial", "AlgebraicNumberTrace", "AlgebraicRules", "AlgebraicRulesData", "Algebraics", "AlgebraicUnitQ", "Alignment", "AlignmentMarker", "AlignmentPoint", "All", "AllowAdultContent", "AllowedCloudExtraParameters", "AllowedCloudParameterExtensions", "AllowedDimensions", "AllowedFrequencyRange", "AllowedHeads", "AllowGroupClose", "AllowIncomplete", "AllowInlineCells", "AllowKernelInitialization", "AllowLooseGrammar", "AllowReverseGroupClose", "AllowScriptLevelChange", "AllowVersionUpdate", "AllTrue", "Alphabet", "AlphabeticOrder", "AlphabeticSort", "AlphaChannel", "AlternateImage", "AlternatingFactorial", "AlternatingGroup", "AlternativeHypothesis", "Alternatives", "AltitudeMethod", "AmbientLight", "AmbiguityFunction", "AmbiguityList", "Analytic", "AnatomyData", "AnatomyForm", "AnatomyPlot3D", "AnatomySkinStyle", "AnatomyStyling", "AnchoredSearch", "And", "AndersonDarlingTest", "AngerJ", "AngleBisector", "AngleBracket", "AnglePath", "AnglePath3D", "AngleVector", "AngularGauge", "Animate", "AnimationCycleOffset", "AnimationCycleRepetitions", "AnimationDirection", "AnimationDisplayTime", "AnimationRate", "AnimationRepetitions", "AnimationRunning", "AnimationRunTime", "AnimationTimeIndex", "Animator", "AnimatorBox", "AnimatorBoxOptions", "AnimatorElements", "Annotate", "Annotation", "AnnotationDelete", "AnnotationKeys", "AnnotationRules", "AnnotationValue", "Annuity", "AnnuityDue", "Annulus", "AnomalyDetection", "AnomalyDetector", "AnomalyDetectorFunction", "Anonymous", "Antialiasing", "AntihermitianMatrixQ", "Antisymmetric", "AntisymmetricMatrixQ", "Antonyms", "AnyOrder", "AnySubset", "AnyTrue", "Apart", "ApartSquareFree", "APIFunction", "Appearance", "AppearanceElements", "AppearanceRules", "AppellF1", "Append", "AppendCheck", "AppendLayer", "AppendTo", "Apply", "ApplySides", "ArcCos", "ArcCosh", "ArcCot", "ArcCoth", "ArcCsc", "ArcCsch", "ArcCurvature", "ARCHProcess", "ArcLength", "ArcSec", "ArcSech", "ArcSin", "ArcSinDistribution", "ArcSinh", "ArcTan", "ArcTanh", "Area", "Arg", "ArgMax", "ArgMin", "ArgumentCountQ", "ARIMAProcess", "ArithmeticGeometricMean", "ARMAProcess", "Around", "AroundReplace", "ARProcess", "Array", "ArrayComponents", "ArrayDepth", "ArrayFilter", "ArrayFlatten", "ArrayMesh", "ArrayPad", "ArrayPlot", "ArrayQ", "ArrayResample", "ArrayReshape", "ArrayRules", "Arrays", "Arrow", "Arrow3DBox", "ArrowBox", "Arrowheads", "ASATriangle", "Ask", "AskAppend", "AskConfirm", "AskDisplay", "AskedQ", "AskedValue", "AskFunction", "AskState", "AskTemplateDisplay", "AspectRatio", "AspectRatioFixed", "Assert", "AssociateTo", "Association", "AssociationFormat", "AssociationMap", "AssociationQ", "AssociationThread", "AssumeDeterministic", "Assuming", "Assumptions", "AstronomicalData", "Asymptotic", "AsymptoticDSolveValue", "AsymptoticEqual", "AsymptoticEquivalent", "AsymptoticGreater", "AsymptoticGreaterEqual", "AsymptoticIntegrate", "AsymptoticLess", "AsymptoticLessEqual", "AsymptoticOutputTracker", "AsymptoticProduct", "AsymptoticRSolveValue", "AsymptoticSolve", "AsymptoticSum", "Asynchronous", "AsynchronousTaskObject", "AsynchronousTasks", "Atom", "AtomCoordinates", "AtomCount", "AtomDiagramCoordinates", "AtomList", "AtomQ", "AttentionLayer", "Attributes", "Audio", "AudioAmplify", "AudioAnnotate", "AudioAnnotationLookup", "AudioBlockMap", "AudioCapture", "AudioChannelAssignment", "AudioChannelCombine", "AudioChannelMix", "AudioChannels", "AudioChannelSeparate", "AudioData", "AudioDelay", "AudioDelete", "AudioDevice", "AudioDistance", "AudioEncoding", "AudioFade", "AudioFrequencyShift", "AudioGenerator", "AudioIdentify", "AudioInputDevice", "AudioInsert", "AudioInstanceQ", "AudioIntervals", "AudioJoin", "AudioLabel", "AudioLength", "AudioLocalMeasurements", "AudioLooping", "AudioLoudness", "AudioMeasurements", "AudioNormalize", "AudioOutputDevice", "AudioOverlay", "AudioPad", "AudioPan", "AudioPartition", "AudioPause", "AudioPitchShift", "AudioPlay", "AudioPlot", "AudioQ", "AudioRecord", "AudioReplace", "AudioResample", "AudioReverb", "AudioReverse", "AudioSampleRate", "AudioSpectralMap", "AudioSpectralTransformation", "AudioSplit", "AudioStop", "AudioStream", "AudioStreams", "AudioTimeStretch", "AudioTracks", "AudioTrim", "AudioType", "AugmentedPolyhedron", "AugmentedSymmetricPolynomial", "Authenticate", "Authentication", "AuthenticationDialog", "AutoAction", "Autocomplete", "AutocompletionFunction", "AutoCopy", "AutocorrelationTest", "AutoDelete", "AutoEvaluateEvents", "AutoGeneratedPackage", "AutoIndent", "AutoIndentSpacings", "AutoItalicWords", "AutoloadPath", "AutoMatch", "Automatic", "AutomaticImageSize", "AutoMultiplicationSymbol", "AutoNumberFormatting", "AutoOpenNotebooks", "AutoOpenPalettes", "AutoQuoteCharacters", "AutoRefreshed", "AutoRemove", "AutorunSequencing", "AutoScaling", "AutoScroll", "AutoSpacing", "AutoStyleOptions", "AutoStyleWords", "AutoSubmitting", "Axes", "AxesEdge", "AxesLabel", "AxesOrigin", "AxesStyle", "AxiomaticTheory", "Axis", "BabyMonsterGroupB", "Back", "Background", "BackgroundAppearance", "BackgroundTasksSettings", "Backslash", "Backsubstitution", "Backward", "Ball", "Band", "BandpassFilter", "BandstopFilter", "BarabasiAlbertGraphDistribution", "BarChart", "BarChart3D", "BarcodeImage", "BarcodeRecognize", "BaringhausHenzeTest", "BarLegend", "BarlowProschanImportance", "BarnesG", "BarOrigin", "BarSpacing", "BartlettHannWindow", "BartlettWindow", "BaseDecode", "BaseEncode", "BaseForm", "Baseline", "BaselinePosition", "BaseStyle", "BasicRecurrentLayer", "BatchNormalizationLayer", "BatchSize", "BatesDistribution", "BattleLemarieWavelet", "BayesianMaximization", "BayesianMaximizationObject", "BayesianMinimization", "BayesianMinimizationObject", "Because", "BeckmannDistribution", "Beep", "Before", "Begin", "BeginDialogPacket", "BeginFrontEndInteractionPacket", "BeginPackage", "BellB", "BellY", "Below", "BenfordDistribution", "BeniniDistribution", "BenktanderGibratDistribution", "BenktanderWeibullDistribution", "BernoulliB", "BernoulliDistribution", "BernoulliGraphDistribution", "BernoulliProcess", "BernsteinBasis", "BesselFilterModel", "BesselI", "BesselJ", "BesselJZero", "BesselK", "BesselY", "BesselYZero", "Beta", "BetaBinomialDistribution", "BetaDistribution", "BetaNegativeBinomialDistribution", "BetaPrimeDistribution", "BetaRegularized", "Between", "BetweennessCentrality", "BeveledPolyhedron", "BezierCurve", "BezierCurve3DBox", "BezierCurve3DBoxOptions", "BezierCurveBox", "BezierCurveBoxOptions", "BezierFunction", "BilateralFilter", "Binarize", "BinaryDeserialize", "BinaryDistance", "BinaryFormat", "BinaryImageQ", "BinaryRead", "BinaryReadList", "BinarySerialize", "BinaryWrite", "BinCounts", "BinLists", "Binomial", "BinomialDistribution", "BinomialProcess", "BinormalDistribution", "BiorthogonalSplineWavelet", "BipartiteGraphQ", "BiquadraticFilterModel", "BirnbaumImportance", "BirnbaumSaundersDistribution", "BitAnd", "BitClear", "BitGet", "BitLength", "BitNot", "BitOr", "BitSet", "BitShiftLeft", "BitShiftRight", "BitXor", "BiweightLocation", "BiweightMidvariance", "Black", "BlackmanHarrisWindow", "BlackmanNuttallWindow", "BlackmanWindow", "Blank", "BlankForm", "BlankNullSequence", "BlankSequence", "Blend", "Block", "BlockchainAddressData", "BlockchainBase", "BlockchainBlockData", "BlockchainContractValue", "BlockchainData", "BlockchainGet", "BlockchainKeyEncode", "BlockchainPut", "BlockchainTokenData", "BlockchainTransaction", "BlockchainTransactionData", "BlockchainTransactionSign", "BlockchainTransactionSubmit", "BlockMap", "BlockRandom", "BlomqvistBeta", "BlomqvistBetaTest", "Blue", "Blur", "BodePlot", "BohmanWindow", "Bold", "Bond", "BondCount", "BondList", "BondQ", "Bookmarks", "Boole", "BooleanConsecutiveFunction", "BooleanConvert", "BooleanCountingFunction", "BooleanFunction", "BooleanGraph", "BooleanMaxterms", "BooleanMinimize", "BooleanMinterms", "BooleanQ", "BooleanRegion", "Booleans", "BooleanStrings", "BooleanTable", "BooleanVariables", "BorderDimensions", "BorelTannerDistribution", "Bottom", "BottomHatTransform", "BoundaryDiscretizeGraphics", "BoundaryDiscretizeRegion", "BoundaryMesh", "BoundaryMeshRegion", "BoundaryMeshRegionQ", "BoundaryStyle", "BoundedRegionQ", "BoundingRegion", "Bounds", "Box", "BoxBaselineShift", "BoxData", "BoxDimensions", "Boxed", "Boxes", "BoxForm", "BoxFormFormatTypes", "BoxFrame", "BoxID", "BoxMargins", "BoxMatrix", "BoxObject", "BoxRatios", "BoxRotation", "BoxRotationPoint", "BoxStyle", "BoxWhiskerChart", "Bra", "BracketingBar", "BraKet", "BrayCurtisDistance", "BreadthFirstScan", "Break", "BridgeData", "BrightnessEqualize", "BroadcastStationData", "Brown", "BrownForsytheTest", "BrownianBridgeProcess", "BrowserCategory", "BSplineBasis", "BSplineCurve", "BSplineCurve3DBox", "BSplineCurve3DBoxOptions", "BSplineCurveBox", "BSplineCurveBoxOptions", "BSplineFunction", "BSplineSurface", "BSplineSurface3DBox", "BSplineSurface3DBoxOptions", "BubbleChart", "BubbleChart3D", "BubbleScale", "BubbleSizes", "BuildingData", "BulletGauge", "BusinessDayQ", "ButterflyGraph", "ButterworthFilterModel", "Button", "ButtonBar", "ButtonBox", "ButtonBoxOptions", "ButtonCell", "ButtonContents", "ButtonData", "ButtonEvaluator", "ButtonExpandable", "ButtonFrame", "ButtonFunction", "ButtonMargins", "ButtonMinHeight", "ButtonNote", "ButtonNotebook", "ButtonSource", "ButtonStyle", "ButtonStyleMenuListing", "Byte", "ByteArray", "ByteArrayFormat", "ByteArrayQ", "ByteArrayToString", "ByteCount", "ByteOrdering", "C", "CachedValue", "CacheGraphics", "CachePersistence", "CalendarConvert", "CalendarData", "CalendarType", "Callout", "CalloutMarker", "CalloutStyle", "CallPacket", "CanberraDistance", "Cancel", "CancelButton", "CandlestickChart", "CanonicalGraph", "CanonicalizePolygon", "CanonicalizePolyhedron", "CanonicalName", "CanonicalWarpingCorrespondence", "CanonicalWarpingDistance", "CantorMesh", "CantorStaircase", "Cap", "CapForm", "CapitalDifferentialD", "Capitalize", "CapsuleShape", "CaptureRunning", "CardinalBSplineBasis", "CarlemanLinearize", "CarmichaelLambda", "CaseOrdering", "Cases", "CaseSensitive", "Cashflow", "Casoratian", "Catalan", "CatalanNumber", "Catch", "CategoricalDistribution", "Catenate", "CatenateLayer", "CauchyDistribution", "CauchyWindow", "CayleyGraph", "CDF", "CDFDeploy", "CDFInformation", "CDFWavelet", "Ceiling", "CelestialSystem", "Cell", "CellAutoOverwrite", "CellBaseline", "CellBoundingBox", "CellBracketOptions", "CellChangeTimes", "CellContents", "CellContext", "CellDingbat", "CellDynamicExpression", "CellEditDuplicate", "CellElementsBoundingBox", "CellElementSpacings", "CellEpilog", "CellEvaluationDuplicate", "CellEvaluationFunction", "CellEvaluationLanguage", "CellEventActions", "CellFrame", "CellFrameColor", "CellFrameLabelMargins", "CellFrameLabels", "CellFrameMargins", "CellGroup", "CellGroupData", "CellGrouping", "CellGroupingRules", "CellHorizontalScrolling", "CellID", "CellLabel", "CellLabelAutoDelete", "CellLabelMargins", "CellLabelPositioning", "CellLabelStyle", "CellLabelTemplate", "CellMargins", "CellObject", "CellOpen", "CellPrint", "CellProlog", "Cells", "CellSize", "CellStyle", "CellTags", "CellularAutomaton", "CensoredDistribution", "Censoring", "Center", "CenterArray", "CenterDot", "CentralFeature", "CentralMoment", "CentralMomentGeneratingFunction", "Cepstrogram", "CepstrogramArray", "CepstrumArray", "CForm", "ChampernowneNumber", "ChangeOptions", "ChannelBase", "ChannelBrokerAction", "ChannelDatabin", "ChannelHistoryLength", "ChannelListen", "ChannelListener", "ChannelListeners", "ChannelListenerWait", "ChannelObject", "ChannelPreSendFunction", "ChannelReceiverFunction", "ChannelSend", "ChannelSubscribers", "ChanVeseBinarize", "Character", "CharacterCounts", "CharacterEncoding", "CharacterEncodingsPath", "CharacteristicFunction", "CharacteristicPolynomial", "CharacterName", "CharacterNormalize", "CharacterRange", "Characters", "ChartBaseStyle", "ChartElementData", "ChartElementDataFunction", "ChartElementFunction", "ChartElements", "ChartLabels", "ChartLayout", "ChartLegends", "ChartStyle", "Chebyshev1FilterModel", "Chebyshev2FilterModel", "ChebyshevDistance", "ChebyshevT", "ChebyshevU", "Check", "CheckAbort", "CheckAll", "Checkbox", "CheckboxBar", "CheckboxBox", "CheckboxBoxOptions", "ChemicalData", "ChessboardDistance", "ChiDistribution", "ChineseRemainder", "ChiSquareDistribution", "ChoiceButtons", "ChoiceDialog", "CholeskyDecomposition", "Chop", "ChromaticityPlot", "ChromaticityPlot3D", "ChromaticPolynomial", "Circle", "CircleBox", "CircleDot", "CircleMinus", "CirclePlus", "CirclePoints", "CircleThrough", "CircleTimes", "CirculantGraph", "CircularOrthogonalMatrixDistribution", "CircularQuaternionMatrixDistribution", "CircularRealMatrixDistribution", "CircularSymplecticMatrixDistribution", "CircularUnitaryMatrixDistribution", "Circumsphere", "CityData", "ClassifierFunction", "ClassifierInformation", "ClassifierMeasurements", "ClassifierMeasurementsObject", "Classify", "ClassPriors", "Clear", "ClearAll", "ClearAttributes", "ClearCookies", "ClearPermissions", "ClearSystemCache", "ClebschGordan", "ClickPane", "Clip", "ClipboardNotebook", "ClipFill", "ClippingStyle", "ClipPlanes", "ClipPlanesStyle", "ClipRange", "Clock", "ClockGauge", "ClockwiseContourIntegral", "Close", "Closed", "CloseKernels", "ClosenessCentrality", "Closing", "ClosingAutoSave", "ClosingEvent", "ClosingSaveDialog", "CloudAccountData", "CloudBase", "CloudConnect", "CloudConnections", "CloudDeploy", "CloudDirectory", "CloudDisconnect", "CloudEvaluate", "CloudExport", "CloudExpression", "CloudExpressions", "CloudFunction", "CloudGet", "CloudImport", "CloudLoggingData", "CloudObject", "CloudObjectInformation", "CloudObjectInformationData", "CloudObjectNameFormat", "CloudObjects", "CloudObjectURLType", "CloudPublish", "CloudPut", "CloudRenderingMethod", "CloudSave", "CloudShare", "CloudSubmit", "CloudSymbol", "CloudUnshare", "CloudUserID", "ClusterClassify", "ClusterDissimilarityFunction", "ClusteringComponents", "ClusteringTree", "CMYKColor", "Coarse", "CodeAssistOptions", "Coefficient", "CoefficientArrays", "CoefficientDomain", "CoefficientList", "CoefficientRules", "CoifletWavelet", "Collect", "Colon", "ColonForm", "ColorBalance", "ColorCombine", "ColorConvert", "ColorCoverage", "ColorData", "ColorDataFunction", "ColorDetect", "ColorDistance", "ColorFunction", "ColorFunctionScaling", "Colorize", "ColorNegate", "ColorOutput", "ColorProfileData", "ColorQ", "ColorQuantize", "ColorReplace", "ColorRules", "ColorSelectorSettings", "ColorSeparate", "ColorSetter", "ColorSetterBox", "ColorSetterBoxOptions", "ColorSlider", "ColorsNear", "ColorSpace", "ColorToneMapping", "Column", "ColumnAlignments", "ColumnBackgrounds", "ColumnForm", "ColumnLines", "ColumnsEqual", "ColumnSpacings", "ColumnWidths", "CombinedEntityClass", "CombinerFunction", "CometData", "CommonDefaultFormatTypes", "Commonest", "CommonestFilter", "CommonName", "CommonUnits", "CommunityBoundaryStyle", "CommunityGraphPlot", "CommunityLabels", "CommunityRegionStyle", "CompanyData", "CompatibleUnitQ", "CompilationOptions", "CompilationTarget", "Compile", "Compiled", "CompiledCodeFunction", "CompiledFunction", "CompilerOptions", "Complement", "ComplementedEntityClass", "CompleteGraph", "CompleteGraphQ", "CompleteKaryTree", "CompletionsListPacket", "Complex", "ComplexContourPlot", "Complexes", "ComplexExpand", "ComplexInfinity", "ComplexityFunction", "ComplexListPlot", "ComplexPlot", "ComplexPlot3D", "ComplexRegionPlot", "ComplexStreamPlot", "ComplexVectorPlot", "ComponentMeasurements", "ComponentwiseContextMenu", "Compose", "ComposeList", "ComposeSeries", "CompositeQ", "Composition", "CompoundElement", "CompoundExpression", "CompoundPoissonDistribution", "CompoundPoissonProcess", "CompoundRenewalProcess", "Compress", "CompressedData", "CompressionLevel", "ComputeUncertainty", "Condition", "ConditionalExpression", "Conditioned", "Cone", "ConeBox", "ConfidenceLevel", "ConfidenceRange", "ConfidenceTransform", "ConfigurationPath", "ConformAudio", "ConformImages", "Congruent", "ConicHullRegion", "ConicHullRegion3DBox", "ConicHullRegionBox", "ConicOptimization", "Conjugate", "ConjugateTranspose", "Conjunction", "Connect", "ConnectedComponents", "ConnectedGraphComponents", "ConnectedGraphQ", "ConnectedMeshComponents", "ConnectedMoleculeComponents", "ConnectedMoleculeQ", "ConnectionSettings", "ConnectLibraryCallbackFunction", "ConnectSystemModelComponents", "ConnesWindow", "ConoverTest", "ConsoleMessage", "ConsoleMessagePacket", "Constant", "ConstantArray", "ConstantArrayLayer", "ConstantImage", "ConstantPlusLayer", "ConstantRegionQ", "Constants", "ConstantTimesLayer", "ConstellationData", "ConstrainedMax", "ConstrainedMin", "Construct", "Containing", "ContainsAll", "ContainsAny", "ContainsExactly", "ContainsNone", "ContainsOnly", "ContentFieldOptions", "ContentLocationFunction", "ContentObject", "ContentPadding", "ContentsBoundingBox", "ContentSelectable", "ContentSize", "Context", "ContextMenu", "Contexts", "ContextToFileName", "Continuation", "Continue", "ContinuedFraction", "ContinuedFractionK", "ContinuousAction", "ContinuousMarkovProcess", "ContinuousTask", "ContinuousTimeModelQ", "ContinuousWaveletData", "ContinuousWaveletTransform", "ContourDetect", "ContourGraphics", "ContourIntegral", "ContourLabels", "ContourLines", "ContourPlot", "ContourPlot3D", "Contours", "ContourShading", "ContourSmoothing", "ContourStyle", "ContraharmonicMean", "ContrastiveLossLayer", "Control", "ControlActive", "ControlAlignment", "ControlGroupContentsBox", "ControllabilityGramian", "ControllabilityMatrix", "ControllableDecomposition", "ControllableModelQ", "ControllerDuration", "ControllerInformation", "ControllerInformationData", "ControllerLinking", "ControllerManipulate", "ControllerMethod", "ControllerPath", "ControllerState", "ControlPlacement", "ControlsRendering", "ControlType", "Convergents", "ConversionOptions", "ConversionRules", "ConvertToBitmapPacket", "ConvertToPostScript", "ConvertToPostScriptPacket", "ConvexHullMesh", "ConvexPolygonQ", "ConvexPolyhedronQ", "ConvolutionLayer", "Convolve", "ConwayGroupCo1", "ConwayGroupCo2", "ConwayGroupCo3", "CookieFunction", "Cookies", "CoordinateBoundingBox", "CoordinateBoundingBoxArray", "CoordinateBounds", "CoordinateBoundsArray", "CoordinateChartData", "CoordinatesToolOptions", "CoordinateTransform", "CoordinateTransformData", "CoprimeQ", "Coproduct", "CopulaDistribution", "Copyable", "CopyDatabin", "CopyDirectory", "CopyFile", "CopyTag", "CopyToClipboard", "CornerFilter", "CornerNeighbors", "Correlation", "CorrelationDistance", "CorrelationFunction", "CorrelationTest", "Cos", "Cosh", "CoshIntegral", "CosineDistance", "CosineWindow", "CosIntegral", "Cot", "Coth", "Count", "CountDistinct", "CountDistinctBy", "CounterAssignments", "CounterBox", "CounterBoxOptions", "CounterClockwiseContourIntegral", "CounterEvaluator", "CounterFunction", "CounterIncrements", "CounterStyle", "CounterStyleMenuListing", "CountRoots", "CountryData", "Counts", "CountsBy", "Covariance", "CovarianceEstimatorFunction", "CovarianceFunction", "CoxianDistribution", "CoxIngersollRossProcess", "CoxModel", "CoxModelFit", "CramerVonMisesTest", "CreateArchive", "CreateCellID", "CreateChannel", "CreateCloudExpression", "CreateDatabin", "CreateDataStructure", "CreateDataSystemModel", "CreateDialog", "CreateDirectory", "CreateDocument", "CreateFile", "CreateIntermediateDirectories", "CreateManagedLibraryExpression", "CreateNotebook", "CreatePacletArchive", "CreatePalette", "CreatePalettePacket", "CreatePermissionsGroup", "CreateScheduledTask", "CreateSearchIndex", "CreateSystemModel", "CreateTemporary", "CreateUUID", "CreateWindow", "CriterionFunction", "CriticalityFailureImportance", "CriticalitySuccessImportance", "CriticalSection", "Cross", "CrossEntropyLossLayer", "CrossingCount", "CrossingDetect", "CrossingPolygon", "CrossMatrix", "Csc", "Csch", "CTCLossLayer", "Cube", "CubeRoot", "Cubics", "Cuboid", "CuboidBox", "Cumulant", "CumulantGeneratingFunction", "Cup", "CupCap", "Curl", "CurlyDoubleQuote", "CurlyQuote", "CurrencyConvert", "CurrentDate", "CurrentImage", "CurrentlySpeakingPacket", "CurrentNotebookImage", "CurrentScreenImage", "CurrentValue", "Curry", "CurryApplied", "CurvatureFlowFilter", "CurveClosed", "Cyan", "CycleGraph", "CycleIndexPolynomial", "Cycles", "CyclicGroup", "Cyclotomic", "Cylinder", "CylinderBox", "CylindricalDecomposition", "D", "DagumDistribution", "DamData", "DamerauLevenshteinDistance", "DampingFactor", "Darker", "Dashed", "Dashing", "DatabaseConnect", "DatabaseDisconnect", "DatabaseReference", "Databin", "DatabinAdd", "DatabinRemove", "Databins", "DatabinUpload", "DataCompression", "DataDistribution", "DataRange", "DataReversed", "Dataset", "DatasetDisplayPanel", "DataStructure", "DataStructureQ", "Date", "DateBounds", "Dated", "DateDelimiters", "DateDifference", "DatedUnit", "DateFormat", "DateFunction", "DateHistogram", "DateInterval", "DateList", "DateListLogPlot", "DateListPlot", "DateListStepPlot", "DateObject", "DateObjectQ", "DateOverlapsQ", "DatePattern", "DatePlus", "DateRange", "DateReduction", "DateString", "DateTicksFormat", "DateValue", "DateWithinQ", "DaubechiesWavelet", "DavisDistribution", "DawsonF", "DayCount", "DayCountConvention", "DayHemisphere", "DaylightQ", "DayMatchQ", "DayName", "DayNightTerminator", "DayPlus", "DayRange", "DayRound", "DeBruijnGraph", "DeBruijnSequence", "Debug", "DebugTag", "Decapitalize", "Decimal", "DecimalForm", "DeclareKnownSymbols", "DeclarePackage", "Decompose", "DeconvolutionLayer", "Decrement", "Decrypt", "DecryptFile", "DedekindEta", "DeepSpaceProbeData", "Default", "DefaultAxesStyle", "DefaultBaseStyle", "DefaultBoxStyle", "DefaultButton", "DefaultColor", "DefaultControlPlacement", "DefaultDuplicateCellStyle", "DefaultDuration", "DefaultElement", "DefaultFaceGridsStyle", "DefaultFieldHintStyle", "DefaultFont", "DefaultFontProperties", "DefaultFormatType", "DefaultFormatTypeForStyle", "DefaultFrameStyle", "DefaultFrameTicksStyle", "DefaultGridLinesStyle", "DefaultInlineFormatType", "DefaultInputFormatType", "DefaultLabelStyle", "DefaultMenuStyle", "DefaultNaturalLanguage", "DefaultNewCellStyle", "DefaultNewInlineCellStyle", "DefaultNotebook", "DefaultOptions", "DefaultOutputFormatType", "DefaultPrintPrecision", "DefaultStyle", "DefaultStyleDefinitions", "DefaultTextFormatType", "DefaultTextInlineFormatType", "DefaultTicksStyle", "DefaultTooltipStyle", "DefaultValue", "DefaultValues", "Defer", "DefineExternal", "DefineInputStreamMethod", "DefineOutputStreamMethod", "DefineResourceFunction", "Definition", "Degree", "DegreeCentrality", "DegreeGraphDistribution", "DegreeLexicographic", "DegreeReverseLexicographic", "DEigensystem", "DEigenvalues", "Deinitialization", "Del", "DelaunayMesh", "Delayed", "Deletable", "Delete", "DeleteAnomalies", "DeleteBorderComponents", "DeleteCases", "DeleteChannel", "DeleteCloudExpression", "DeleteContents", "DeleteDirectory", "DeleteDuplicates", "DeleteDuplicatesBy", "DeleteFile", "DeleteMissing", "DeleteObject", "DeletePermissionsKey", "DeleteSearchIndex", "DeleteSmallComponents", "DeleteStopwords", "DeleteWithContents", "DeletionWarning", "DelimitedArray", "DelimitedSequence", "Delimiter", "DelimiterFlashTime", "DelimiterMatching", "Delimiters", "DeliveryFunction", "Dendrogram", "Denominator", "DensityGraphics", "DensityHistogram", "DensityPlot", "DensityPlot3D", "DependentVariables", "Deploy", "Deployed", "Depth", "DepthFirstScan", "Derivative", "DerivativeFilter", "DerivedKey", "DescriptorStateSpace", "DesignMatrix", "DestroyAfterEvaluation", "Det", "DeviceClose", "DeviceConfigure", "DeviceExecute", "DeviceExecuteAsynchronous", "DeviceObject", "DeviceOpen", "DeviceOpenQ", "DeviceRead", "DeviceReadBuffer", "DeviceReadLatest", "DeviceReadList", "DeviceReadTimeSeries", "Devices", "DeviceStreams", "DeviceWrite", "DeviceWriteBuffer", "DGaussianWavelet", "DiacriticalPositioning", "Diagonal", "DiagonalizableMatrixQ", "DiagonalMatrix", "DiagonalMatrixQ", "Dialog", "DialogIndent", "DialogInput", "DialogLevel", "DialogNotebook", "DialogProlog", "DialogReturn", "DialogSymbols", "Diamond", "DiamondMatrix", "DiceDissimilarity", "DictionaryLookup", "DictionaryWordQ", "DifferenceDelta", "DifferenceOrder", "DifferenceQuotient", "DifferenceRoot", "DifferenceRootReduce", "Differences", "DifferentialD", "DifferentialRoot", "DifferentialRootReduce", "DifferentiatorFilter", "DigitalSignature", "DigitBlock", "DigitBlockMinimum", "DigitCharacter", "DigitCount", "DigitQ", "DihedralAngle", "DihedralGroup", "Dilation", "DimensionalCombinations", "DimensionalMeshComponents", "DimensionReduce", "DimensionReducerFunction", "DimensionReduction", "Dimensions", "DiracComb", "DiracDelta", "DirectedEdge", "DirectedEdges", "DirectedGraph", "DirectedGraphQ", "DirectedInfinity", "Direction", "Directive", "Directory", "DirectoryName", "DirectoryQ", "DirectoryStack", "DirichletBeta", "DirichletCharacter", "DirichletCondition", "DirichletConvolve", "DirichletDistribution", "DirichletEta", "DirichletL", "DirichletLambda", "DirichletTransform", "DirichletWindow", "DisableConsolePrintPacket", "DisableFormatting", "DiscreteAsymptotic", "DiscreteChirpZTransform", "DiscreteConvolve", "DiscreteDelta", "DiscreteHadamardTransform", "DiscreteIndicator", "DiscreteLimit", "DiscreteLQEstimatorGains", "DiscreteLQRegulatorGains", "DiscreteLyapunovSolve", "DiscreteMarkovProcess", "DiscreteMaxLimit", "DiscreteMinLimit", "DiscretePlot", "DiscretePlot3D", "DiscreteRatio", "DiscreteRiccatiSolve", "DiscreteShift", "DiscreteTimeModelQ", "DiscreteUniformDistribution", "DiscreteVariables", "DiscreteWaveletData", "DiscreteWaveletPacketTransform", "DiscreteWaveletTransform", "DiscretizeGraphics", "DiscretizeRegion", "Discriminant", "DisjointQ", "Disjunction", "Disk", "DiskBox", "DiskMatrix", "DiskSegment", "Dispatch", "DispatchQ", "DispersionEstimatorFunction", "Display", "DisplayAllSteps", "DisplayEndPacket", "DisplayFlushImagePacket", "DisplayForm", "DisplayFunction", "DisplayPacket", "DisplayRules", "DisplaySetSizePacket", "DisplayString", "DisplayTemporary", "DisplayWith", "DisplayWithRef", "DisplayWithVariable", "DistanceFunction", "DistanceMatrix", "DistanceTransform", "Distribute", "Distributed", "DistributedContexts", "DistributeDefinitions", "DistributionChart", "DistributionDomain", "DistributionFitTest", "DistributionParameterAssumptions", "DistributionParameterQ", "Dithering", "Div", "Divergence", "Divide", "DivideBy", "Dividers", "DivideSides", "Divisible", "Divisors", "DivisorSigma", "DivisorSum", "DMSList", "DMSString", "Do", "DockedCells", "DocumentGenerator", "DocumentGeneratorInformation", "DocumentGeneratorInformationData", "DocumentGenerators", "DocumentNotebook", "DocumentWeightingRules", "Dodecahedron", "DomainRegistrationInformation", "DominantColors", "DOSTextFormat", "Dot", "DotDashed", "DotEqual", "DotLayer", "DotPlusLayer", "Dotted", "DoubleBracketingBar", "DoubleContourIntegral", "DoubleDownArrow", "DoubleLeftArrow", "DoubleLeftRightArrow", "DoubleLeftTee", "DoubleLongLeftArrow", "DoubleLongLeftRightArrow", "DoubleLongRightArrow", "DoubleRightArrow", "DoubleRightTee", "DoubleUpArrow", "DoubleUpDownArrow", "DoubleVerticalBar", "DoublyInfinite", "Down", "DownArrow", "DownArrowBar", "DownArrowUpArrow", "DownLeftRightVector", "DownLeftTeeVector", "DownLeftVector", "DownLeftVectorBar", "DownRightTeeVector", "DownRightVector", "DownRightVectorBar", "Downsample", "DownTee", "DownTeeArrow", "DownValues", "DragAndDrop", "DrawEdges", "DrawFrontFaces", "DrawHighlighted", "Drop", "DropoutLayer", "DSolve", "DSolveValue", "Dt", "DualLinearProgramming", "DualPolyhedron", "DualSystemsModel", "DumpGet", "DumpSave", "DuplicateFreeQ", "Duration", "Dynamic", "DynamicBox", "DynamicBoxOptions", "DynamicEvaluationTimeout", "DynamicGeoGraphics", "DynamicImage", "DynamicLocation", "DynamicModule", "DynamicModuleBox", "DynamicModuleBoxOptions", "DynamicModuleParent", "DynamicModuleValues", "DynamicName", "DynamicNamespace", "DynamicReference", "DynamicSetting", "DynamicUpdating", "DynamicWrapper", "DynamicWrapperBox", "DynamicWrapperBoxOptions", "E", "EarthImpactData", "EarthquakeData", "EccentricityCentrality", "Echo", "EchoFunction", "EclipseType", "EdgeAdd", "EdgeBetweennessCentrality", "EdgeCapacity", "EdgeCapForm", "EdgeColor", "EdgeConnectivity", "EdgeContract", "EdgeCost", "EdgeCount", "EdgeCoverQ", "EdgeCycleMatrix", "EdgeDashing", "EdgeDelete", "EdgeDetect", "EdgeForm", "EdgeIndex", "EdgeJoinForm", "EdgeLabeling", "EdgeLabels", "EdgeLabelStyle", "EdgeList", "EdgeOpacity", "EdgeQ", "EdgeRenderingFunction", "EdgeRules", "EdgeShapeFunction", "EdgeStyle", "EdgeTaggedGraph", "EdgeTaggedGraphQ", "EdgeTags", "EdgeThickness", "EdgeWeight", "EdgeWeightedGraphQ", "Editable", "EditButtonSettings", "EditCellTagsSettings", "EditDistance", "EffectiveInterest", "Eigensystem", "Eigenvalues", "EigenvectorCentrality", "Eigenvectors", "Element", "ElementData", "ElementwiseLayer", "ElidedForms", "Eliminate", "EliminationOrder", "Ellipsoid", "EllipticE", "EllipticExp", "EllipticExpPrime", "EllipticF", "EllipticFilterModel", "EllipticK", "EllipticLog", "EllipticNomeQ", "EllipticPi", "EllipticReducedHalfPeriods", "EllipticTheta", "EllipticThetaPrime", "EmbedCode", "EmbeddedHTML", "EmbeddedService", "EmbeddingLayer", "EmbeddingObject", "EmitSound", "EmphasizeSyntaxErrors", "EmpiricalDistribution", "Empty", "EmptyGraphQ", "EmptyRegion", "EnableConsolePrintPacket", "Enabled", "Encode", "Encrypt", "EncryptedObject", "EncryptFile", "End", "EndAdd", "EndDialogPacket", "EndFrontEndInteractionPacket", "EndOfBuffer", "EndOfFile", "EndOfLine", "EndOfString", "EndPackage", "EngineEnvironment", "EngineeringForm", "Enter", "EnterExpressionPacket", "EnterTextPacket", "Entity", "EntityClass", "EntityClassList", "EntityCopies", "EntityFunction", "EntityGroup", "EntityInstance", "EntityList", "EntityPrefetch", "EntityProperties", "EntityProperty", "EntityPropertyClass", "EntityRegister", "EntityStore", "EntityStores", "EntityTypeName", "EntityUnregister", "EntityValue", "Entropy", "EntropyFilter", "Environment", "Epilog", "EpilogFunction", "Equal", "EqualColumns", "EqualRows", "EqualTilde", "EqualTo", "EquatedTo", "Equilibrium", "EquirippleFilterKernel", "Equivalent", "Erf", "Erfc", "Erfi", "ErlangB", "ErlangC", "ErlangDistribution", "Erosion", "ErrorBox", "ErrorBoxOptions", "ErrorNorm", "ErrorPacket", "ErrorsDialogSettings", "EscapeRadius", "EstimatedBackground", "EstimatedDistribution", "EstimatedProcess", "EstimatorGains", "EstimatorRegulator", "EuclideanDistance", "EulerAngles", "EulerCharacteristic", "EulerE", "EulerGamma", "EulerianGraphQ", "EulerMatrix", "EulerPhi", "Evaluatable", "Evaluate", "Evaluated", "EvaluatePacket", "EvaluateScheduledTask", "EvaluationBox", "EvaluationCell", "EvaluationCompletionAction", "EvaluationData", "EvaluationElements", "EvaluationEnvironment", "EvaluationMode", "EvaluationMonitor", "EvaluationNotebook", "EvaluationObject", "EvaluationOrder", "Evaluator", "EvaluatorNames", "EvenQ", "EventData", "EventEvaluator", "EventHandler", "EventHandlerTag", "EventLabels", "EventSeries", "ExactBlackmanWindow", "ExactNumberQ", "ExactRootIsolation", "ExampleData", "Except", "ExcludedForms", "ExcludedLines", "ExcludedPhysicalQuantities", "ExcludePods", "Exclusions", "ExclusionsStyle", "Exists", "Exit", "ExitDialog", "ExoplanetData", "Exp", "Expand", "ExpandAll", "ExpandDenominator", "ExpandFileName", "ExpandNumerator", "Expectation", "ExpectationE", "ExpectedValue", "ExpGammaDistribution", "ExpIntegralE", "ExpIntegralEi", "ExpirationDate", "Exponent", "ExponentFunction", "ExponentialDistribution", "ExponentialFamily", "ExponentialGeneratingFunction", "ExponentialMovingAverage", "ExponentialPowerDistribution", "ExponentPosition", "ExponentStep", "Export", "ExportAutoReplacements", "ExportByteArray", "ExportForm", "ExportPacket", "ExportString", "Expression", "ExpressionCell", "ExpressionGraph", "ExpressionPacket", "ExpressionUUID", "ExpToTrig", "ExtendedEntityClass", "ExtendedGCD", "Extension", "ExtentElementFunction", "ExtentMarkers", "ExtentSize", "ExternalBundle", "ExternalCall", "ExternalDataCharacterEncoding", "ExternalEvaluate", "ExternalFunction", "ExternalFunctionName", "ExternalIdentifier", "ExternalObject", "ExternalOptions", "ExternalSessionObject", "ExternalSessions", "ExternalStorageBase", "ExternalStorageDownload", "ExternalStorageGet", "ExternalStorageObject", "ExternalStoragePut", "ExternalStorageUpload", "ExternalTypeSignature", "ExternalValue", "Extract", "ExtractArchive", "ExtractLayer", "ExtractPacletArchive", "ExtremeValueDistribution", "FaceAlign", "FaceForm", "FaceGrids", "FaceGridsStyle", "FacialFeatures", "Factor", "FactorComplete", "Factorial", "Factorial2", "FactorialMoment", "FactorialMomentGeneratingFunction", "FactorialPower", "FactorInteger", "FactorList", "FactorSquareFree", "FactorSquareFreeList", "FactorTerms", "FactorTermsList", "Fail", "Failure", "FailureAction", "FailureDistribution", "FailureQ", "False", "FareySequence", "FARIMAProcess", "FeatureDistance", "FeatureExtract", "FeatureExtraction", "FeatureExtractor", "FeatureExtractorFunction", "FeatureNames", "FeatureNearest", "FeatureSpacePlot", "FeatureSpacePlot3D", "FeatureTypes", "FEDisableConsolePrintPacket", "FeedbackLinearize", "FeedbackSector", "FeedbackSectorStyle", "FeedbackType", "FEEnableConsolePrintPacket", "FetalGrowthData", "Fibonacci", "Fibonorial", "FieldCompletionFunction", "FieldHint", "FieldHintStyle", "FieldMasked", "FieldSize", "File", "FileBaseName", "FileByteCount", "FileConvert", "FileDate", "FileExistsQ", "FileExtension", "FileFormat", "FileHandler", "FileHash", "FileInformation", "FileName", "FileNameDepth", "FileNameDialogSettings", "FileNameDrop", "FileNameForms", "FileNameJoin", "FileNames", "FileNameSetter", "FileNameSplit", "FileNameTake", "FilePrint", "FileSize", "FileSystemMap", "FileSystemScan", "FileTemplate", "FileTemplateApply", "FileType", "FilledCurve", "FilledCurveBox", "FilledCurveBoxOptions", "Filling", "FillingStyle", "FillingTransform", "FilteredEntityClass", "FilterRules", "FinancialBond", "FinancialData", "FinancialDerivative", "FinancialIndicator", "Find", "FindAnomalies", "FindArgMax", "FindArgMin", "FindChannels", "FindClique", "FindClusters", "FindCookies", "FindCurvePath", "FindCycle", "FindDevices", "FindDistribution", "FindDistributionParameters", "FindDivisions", "FindEdgeCover", "FindEdgeCut", "FindEdgeIndependentPaths", "FindEquationalProof", "FindEulerianCycle", "FindExternalEvaluators", "FindFaces", "FindFile", "FindFit", "FindFormula", "FindFundamentalCycles", "FindGeneratingFunction", "FindGeoLocation", "FindGeometricConjectures", "FindGeometricTransform", "FindGraphCommunities", "FindGraphIsomorphism", "FindGraphPartition", "FindHamiltonianCycle", "FindHamiltonianPath", "FindHiddenMarkovStates", "FindImageText", "FindIndependentEdgeSet", "FindIndependentVertexSet", "FindInstance", "FindIntegerNullVector", "FindKClan", "FindKClique", "FindKClub", "FindKPlex", "FindLibrary", "FindLinearRecurrence", "FindList", "FindMatchingColor", "FindMaximum", "FindMaximumCut", "FindMaximumFlow", "FindMaxValue", "FindMeshDefects", "FindMinimum", "FindMinimumCostFlow", "FindMinimumCut", "FindMinValue", "FindMoleculeSubstructure", "FindPath", "FindPeaks", "FindPermutation", "FindPostmanTour", "FindProcessParameters", "FindRepeat", "FindRoot", "FindSequenceFunction", "FindSettings", "FindShortestPath", "FindShortestTour", "FindSpanningTree", "FindSystemModelEquilibrium", "FindTextualAnswer", "FindThreshold", "FindTransientRepeat", "FindVertexCover", "FindVertexCut", "FindVertexIndependentPaths", "Fine", "FinishDynamic", "FiniteAbelianGroupCount", "FiniteGroupCount", "FiniteGroupData", "First", "FirstCase", "FirstPassageTimeDistribution", "FirstPosition", "FischerGroupFi22", "FischerGroupFi23", "FischerGroupFi24Prime", "FisherHypergeometricDistribution", "FisherRatioTest", "FisherZDistribution", "Fit", "FitAll", "FitRegularization", "FittedModel", "FixedOrder", "FixedPoint", "FixedPointList", "FlashSelection", "Flat", "Flatten", "FlattenAt", "FlattenLayer", "FlatTopWindow", "FlipView", "Floor", "FlowPolynomial", "FlushPrintOutputPacket", "Fold", "FoldList", "FoldPair", "FoldPairList", "FollowRedirects", "Font", "FontColor", "FontFamily", "FontForm", "FontName", "FontOpacity", "FontPostScriptName", "FontProperties", "FontReencoding", "FontSize", "FontSlant", "FontSubstitutions", "FontTracking", "FontVariations", "FontWeight", "For", "ForAll", "ForceVersionInstall", "Format", "FormatRules", "FormatType", "FormatTypeAutoConvert", "FormatValues", "FormBox", "FormBoxOptions", "FormControl", "FormFunction", "FormLayoutFunction", "FormObject", "FormPage", "FormTheme", "FormulaData", "FormulaLookup", "FortranForm", "Forward", "ForwardBackward", "Fourier", "FourierCoefficient", "FourierCosCoefficient", "FourierCosSeries", "FourierCosTransform", "FourierDCT", "FourierDCTFilter", "FourierDCTMatrix", "FourierDST", "FourierDSTMatrix", "FourierMatrix", "FourierParameters", "FourierSequenceTransform", "FourierSeries", "FourierSinCoefficient", "FourierSinSeries", "FourierSinTransform", "FourierTransform", "FourierTrigSeries", "FractionalBrownianMotionProcess", "FractionalGaussianNoiseProcess", "FractionalPart", "FractionBox", "FractionBoxOptions", "FractionLine", "Frame", "FrameBox", "FrameBoxOptions", "Framed", "FrameInset", "FrameLabel", "Frameless", "FrameMargins", "FrameRate", "FrameStyle", "FrameTicks", "FrameTicksStyle", "FRatioDistribution", "FrechetDistribution", "FreeQ", "FrenetSerretSystem", "FrequencySamplingFilterKernel", "FresnelC", "FresnelF", "FresnelG", "FresnelS", "Friday", "FrobeniusNumber", "FrobeniusSolve", "FromAbsoluteTime", "FromCharacterCode", "FromCoefficientRules", "FromContinuedFraction", "FromDate", "FromDigits", "FromDMS", "FromEntity", "FromJulianDate", "FromLetterNumber", "FromPolarCoordinates", "FromRomanNumeral", "FromSphericalCoordinates", "FromUnixTime", "Front", "FrontEndDynamicExpression", "FrontEndEventActions", "FrontEndExecute", "FrontEndObject", "FrontEndResource", "FrontEndResourceString", "FrontEndStackSize", "FrontEndToken", "FrontEndTokenExecute", "FrontEndValueCache", "FrontEndVersion", "FrontFaceColor", "FrontFaceOpacity", "Full", "FullAxes", "FullDefinition", "FullForm", "FullGraphics", "FullInformationOutputRegulator", "FullOptions", "FullRegion", "FullSimplify", "Function", "FunctionCompile", "FunctionCompileExport", "FunctionCompileExportByteArray", "FunctionCompileExportLibrary", "FunctionCompileExportString", "FunctionDomain", "FunctionExpand", "FunctionInterpolation", "FunctionPeriod", "FunctionRange", "FunctionSpace", "FussellVeselyImportance", "GaborFilter", "GaborMatrix", "GaborWavelet", "GainMargins", "GainPhaseMargins", "GalaxyData", "GalleryView", "Gamma", "GammaDistribution", "GammaRegularized", "GapPenalty", "GARCHProcess", "GatedRecurrentLayer", "Gather", "GatherBy", "GaugeFaceElementFunction", "GaugeFaceStyle", "GaugeFrameElementFunction", "GaugeFrameSize", "GaugeFrameStyle", "GaugeLabels", "GaugeMarkers", "GaugeStyle", "GaussianFilter", "GaussianIntegers", "GaussianMatrix", "GaussianOrthogonalMatrixDistribution", "GaussianSymplecticMatrixDistribution", "GaussianUnitaryMatrixDistribution", "GaussianWindow", "GCD", "GegenbauerC", "General", "GeneralizedLinearModelFit", "GenerateAsymmetricKeyPair", "GenerateConditions", "GeneratedCell", "GeneratedDocumentBinding", "GenerateDerivedKey", "GenerateDigitalSignature", "GenerateDocument", "GeneratedParameters", "GeneratedQuantityMagnitudes", "GenerateFileSignature", "GenerateHTTPResponse", "GenerateSecuredAuthenticationKey", "GenerateSymmetricKey", "GeneratingFunction", "GeneratorDescription", "GeneratorHistoryLength", "GeneratorOutputType", "Generic", "GenericCylindricalDecomposition", "GenomeData", "GenomeLookup", "GeoAntipode", "GeoArea", "GeoArraySize", "GeoBackground", "GeoBoundingBox", "GeoBounds", "GeoBoundsRegion", "GeoBubbleChart", "GeoCenter", "GeoCircle", "GeoContourPlot", "GeoDensityPlot", "GeodesicClosing", "GeodesicDilation", "GeodesicErosion", "GeodesicOpening", "GeoDestination", "GeodesyData", "GeoDirection", "GeoDisk", "GeoDisplacement", "GeoDistance", "GeoDistanceList", "GeoElevationData", "GeoEntities", "GeoGraphics", "GeogravityModelData", "GeoGridDirectionDifference", "GeoGridLines", "GeoGridLinesStyle", "GeoGridPosition", "GeoGridRange", "GeoGridRangePadding", "GeoGridUnitArea", "GeoGridUnitDistance", "GeoGridVector", "GeoGroup", "GeoHemisphere", "GeoHemisphereBoundary", "GeoHistogram", "GeoIdentify", "GeoImage", "GeoLabels", "GeoLength", "GeoListPlot", "GeoLocation", "GeologicalPeriodData", "GeomagneticModelData", "GeoMarker", "GeometricAssertion", "GeometricBrownianMotionProcess", "GeometricDistribution", "GeometricMean", "GeometricMeanFilter", "GeometricOptimization", "GeometricScene", "GeometricTransformation", "GeometricTransformation3DBox", "GeometricTransformation3DBoxOptions", "GeometricTransformationBox", "GeometricTransformationBoxOptions", "GeoModel", "GeoNearest", "GeoPath", "GeoPosition", "GeoPositionENU", "GeoPositionXYZ", "GeoProjection", "GeoProjectionData", "GeoRange", "GeoRangePadding", "GeoRegionValuePlot", "GeoResolution", "GeoScaleBar", "GeoServer", "GeoSmoothHistogram", "GeoStreamPlot", "GeoStyling", "GeoStylingImageFunction", "GeoVariant", "GeoVector", "GeoVectorENU", "GeoVectorPlot", "GeoVectorXYZ", "GeoVisibleRegion", "GeoVisibleRegionBoundary", "GeoWithinQ", "GeoZoomLevel", "GestureHandler", "GestureHandlerTag", "Get", "GetBoundingBoxSizePacket", "GetContext", "GetEnvironment", "GetFileName", "GetFrontEndOptionsDataPacket", "GetLinebreakInformationPacket", "GetMenusPacket", "GetPageBreakInformationPacket", "Glaisher", "GlobalClusteringCoefficient", "GlobalPreferences", "GlobalSession", "Glow", "GoldenAngle", "GoldenRatio", "GompertzMakehamDistribution", "GoochShading", "GoodmanKruskalGamma", "GoodmanKruskalGammaTest", "Goto", "Grad", "Gradient", "GradientFilter", "GradientOrientationFilter", "GrammarApply", "GrammarRules", "GrammarToken", "Graph", "Graph3D", "GraphAssortativity", "GraphAutomorphismGroup", "GraphCenter", "GraphComplement", "GraphData", "GraphDensity", "GraphDiameter", "GraphDifference", "GraphDisjointUnion", "GraphDistance", "GraphDistanceMatrix", "GraphElementData", "GraphEmbedding", "GraphHighlight", "GraphHighlightStyle", "GraphHub", "Graphics", "Graphics3D", "Graphics3DBox", "Graphics3DBoxOptions", "GraphicsArray", "GraphicsBaseline", "GraphicsBox", "GraphicsBoxOptions", "GraphicsColor", "GraphicsColumn", "GraphicsComplex", "GraphicsComplex3DBox", "GraphicsComplex3DBoxOptions", "GraphicsComplexBox", "GraphicsComplexBoxOptions", "GraphicsContents", "GraphicsData", "GraphicsGrid", "GraphicsGridBox", "GraphicsGroup", "GraphicsGroup3DBox", "GraphicsGroup3DBoxOptions", "GraphicsGroupBox", "GraphicsGroupBoxOptions", "GraphicsGrouping", "GraphicsHighlightColor", "GraphicsRow", "GraphicsSpacing", "GraphicsStyle", "GraphIntersection", "GraphLayout", "GraphLinkEfficiency", "GraphPeriphery", "GraphPlot", "GraphPlot3D", "GraphPower", "GraphPropertyDistribution", "GraphQ", "GraphRadius", "GraphReciprocity", "GraphRoot", "GraphStyle", "GraphUnion", "Gray", "GrayLevel", "Greater", "GreaterEqual", "GreaterEqualLess", "GreaterEqualThan", "GreaterFullEqual", "GreaterGreater", "GreaterLess", "GreaterSlantEqual", "GreaterThan", "GreaterTilde", "Green", "GreenFunction", "Grid", "GridBaseline", "GridBox", "GridBoxAlignment", "GridBoxBackground", "GridBoxDividers", "GridBoxFrame", "GridBoxItemSize", "GridBoxItemStyle", "GridBoxOptions", "GridBoxSpacings", "GridCreationSettings", "GridDefaultElement", "GridElementStyleOptions", "GridFrame", "GridFrameMargins", "GridGraph", "GridLines", "GridLinesStyle", "GroebnerBasis", "GroupActionBase", "GroupBy", "GroupCentralizer", "GroupElementFromWord", "GroupElementPosition", "GroupElementQ", "GroupElements", "GroupElementToWord", "GroupGenerators", "Groupings", "GroupMultiplicationTable", "GroupOrbits", "GroupOrder", "GroupPageBreakWithin", "GroupSetwiseStabilizer", "GroupStabilizer", "GroupStabilizerChain", "GroupTogetherGrouping", "GroupTogetherNestedGrouping", "GrowCutComponents", "Gudermannian", "GuidedFilter", "GumbelDistribution", "HaarWavelet", "HadamardMatrix", "HalfLine", "HalfNormalDistribution", "HalfPlane", "HalfSpace", "HalftoneShading", "HamiltonianGraphQ", "HammingDistance", "HammingWindow", "HandlerFunctions", "HandlerFunctionsKeys", "HankelH1", "HankelH2", "HankelMatrix", "HankelTransform", "HannPoissonWindow", "HannWindow", "HaradaNortonGroupHN", "HararyGraph", "HarmonicMean", "HarmonicMeanFilter", "HarmonicNumber", "Hash", "HatchFilling", "HatchShading", "Haversine", "HazardFunction", "Head", "HeadCompose", "HeaderAlignment", "HeaderBackground", "HeaderDisplayFunction", "HeaderLines", "HeaderSize", "HeaderStyle", "Heads", "HeavisideLambda", "HeavisidePi", "HeavisideTheta", "HeldGroupHe", "HeldPart", "HelpBrowserLookup", "HelpBrowserNotebook", "HelpBrowserSettings", "Here", "HermiteDecomposition", "HermiteH", "HermitianMatrixQ", "HessenbergDecomposition", "Hessian", "HeunB", "HeunBPrime", "HeunC", "HeunCPrime", "HeunD", "HeunDPrime", "HeunG", "HeunGPrime", "HeunT", "HeunTPrime", "HexadecimalCharacter", "Hexahedron", "HexahedronBox", "HexahedronBoxOptions", "HiddenItems", "HiddenMarkovProcess", "HiddenSurface", "Highlighted", "HighlightGraph", "HighlightImage", "HighlightMesh", "HighpassFilter", "HigmanSimsGroupHS", "HilbertCurve", "HilbertFilter", "HilbertMatrix", "Histogram", "Histogram3D", "HistogramDistribution", "HistogramList", "HistogramTransform", "HistogramTransformInterpolation", "HistoricalPeriodData", "HitMissTransform", "HITSCentrality", "HjorthDistribution", "HodgeDual", "HoeffdingD", "HoeffdingDTest", "Hold", "HoldAll", "HoldAllComplete", "HoldComplete", "HoldFirst", "HoldForm", "HoldPattern", "HoldRest", "HolidayCalendar", "HomeDirectory", "HomePage", "Horizontal", "HorizontalForm", "HorizontalGauge", "HorizontalScrollPosition", "HornerForm", "HostLookup", "HotellingTSquareDistribution", "HoytDistribution", "HTMLSave", "HTTPErrorResponse", "HTTPRedirect", "HTTPRequest", "HTTPRequestData", "HTTPResponse", "Hue", "HumanGrowthData", "HumpDownHump", "HumpEqual", "HurwitzLerchPhi", "HurwitzZeta", "HyperbolicDistribution", "HypercubeGraph", "HyperexponentialDistribution", "Hyperfactorial", "Hypergeometric0F1", "Hypergeometric0F1Regularized", "Hypergeometric1F1", "Hypergeometric1F1Regularized", "Hypergeometric2F1", "Hypergeometric2F1Regularized", "HypergeometricDistribution", "HypergeometricPFQ", "HypergeometricPFQRegularized", "HypergeometricU", "Hyperlink", "HyperlinkAction", "HyperlinkCreationSettings", "Hyperplane", "Hyphenation", "HyphenationOptions", "HypoexponentialDistribution", "HypothesisTestData", "I", "IconData", "Iconize", "IconizedObject", "IconRules", "Icosahedron", "Identity", "IdentityMatrix", "If", "IgnoreCase", "IgnoreDiacritics", "IgnorePunctuation", "IgnoreSpellCheck", "IgnoringInactive", "Im", "Image", "Image3D", "Image3DProjection", "Image3DSlices", "ImageAccumulate", "ImageAdd", "ImageAdjust", "ImageAlign", "ImageApply", "ImageApplyIndexed", "ImageAspectRatio", "ImageAssemble", "ImageAugmentationLayer", "ImageBoundingBoxes", "ImageCache", "ImageCacheValid", "ImageCapture", "ImageCaptureFunction", "ImageCases", "ImageChannels", "ImageClip", "ImageCollage", "ImageColorSpace", "ImageCompose", "ImageContainsQ", "ImageContents", "ImageConvolve", "ImageCooccurrence", "ImageCorners", "ImageCorrelate", "ImageCorrespondingPoints", "ImageCrop", "ImageData", "ImageDeconvolve", "ImageDemosaic", "ImageDifference", "ImageDimensions", "ImageDisplacements", "ImageDistance", "ImageEffect", "ImageExposureCombine", "ImageFeatureTrack", "ImageFileApply", "ImageFileFilter", "ImageFileScan", "ImageFilter", "ImageFocusCombine", "ImageForestingComponents", "ImageFormattingWidth", "ImageForwardTransformation", "ImageGraphics", "ImageHistogram", "ImageIdentify", "ImageInstanceQ", "ImageKeypoints", "ImageLabels", "ImageLegends", "ImageLevels", "ImageLines", "ImageMargins", "ImageMarker", "ImageMarkers", "ImageMeasurements", "ImageMesh", "ImageMultiply", "ImageOffset", "ImagePad", "ImagePadding", "ImagePartition", "ImagePeriodogram", "ImagePerspectiveTransformation", "ImagePosition", "ImagePreviewFunction", "ImagePyramid", "ImagePyramidApply", "ImageQ", "ImageRangeCache", "ImageRecolor", "ImageReflect", "ImageRegion", "ImageResize", "ImageResolution", "ImageRestyle", "ImageRotate", "ImageRotated", "ImageSaliencyFilter", "ImageScaled", "ImageScan", "ImageSize", "ImageSizeAction", "ImageSizeCache", "ImageSizeMultipliers", "ImageSizeRaw", "ImageSubtract", "ImageTake", "ImageTransformation", "ImageTrim", "ImageType", "ImageValue", "ImageValuePositions", "ImagingDevice", "ImplicitRegion", "Implies", "Import", "ImportAutoReplacements", "ImportByteArray", "ImportOptions", "ImportString", "ImprovementImportance", "In", "Inactivate", "Inactive", "IncidenceGraph", "IncidenceList", "IncidenceMatrix", "IncludeAromaticBonds", "IncludeConstantBasis", "IncludeDefinitions", "IncludeDirectories", "IncludeFileExtension", "IncludeGeneratorTasks", "IncludeHydrogens", "IncludeInflections", "IncludeMetaInformation", "IncludePods", "IncludeQuantities", "IncludeRelatedTables", "IncludeSingularTerm", "IncludeWindowTimes", "Increment", "IndefiniteMatrixQ", "Indent", "IndentingNewlineSpacings", "IndentMaxFraction", "IndependenceTest", "IndependentEdgeSetQ", "IndependentPhysicalQuantity", "IndependentUnit", "IndependentUnitDimension", "IndependentVertexSetQ", "Indeterminate", "IndeterminateThreshold", "IndexCreationOptions", "Indexed", "IndexEdgeTaggedGraph", "IndexGraph", "IndexTag", "Inequality", "InexactNumberQ", "InexactNumbers", "InfiniteFuture", "InfiniteLine", "InfinitePast", "InfinitePlane", "Infinity", "Infix", "InflationAdjust", "InflationMethod", "Information", "InformationData", "InformationDataGrid", "Inherited", "InheritScope", "InhomogeneousPoissonProcess", "InitialEvaluationHistory", "Initialization", "InitializationCell", "InitializationCellEvaluation", "InitializationCellWarning", "InitializationObjects", "InitializationValue", "Initialize", "InitialSeeding", "InlineCounterAssignments", "InlineCounterIncrements", "InlineRules", "Inner", "InnerPolygon", "InnerPolyhedron", "Inpaint", "Input", "InputAliases", "InputAssumptions", "InputAutoReplacements", "InputField", "InputFieldBox", "InputFieldBoxOptions", "InputForm", "InputGrouping", "InputNamePacket", "InputNotebook", "InputPacket", "InputSettings", "InputStream", "InputString", "InputStringPacket", "InputToBoxFormPacket", "Insert", "InsertionFunction", "InsertionPointObject", "InsertLinebreaks", "InsertResults", "Inset", "Inset3DBox", "Inset3DBoxOptions", "InsetBox", "InsetBoxOptions", "Insphere", "Install", "InstallService", "InstanceNormalizationLayer", "InString", "Integer", "IntegerDigits", "IntegerExponent", "IntegerLength", "IntegerName", "IntegerPart", "IntegerPartitions", "IntegerQ", "IntegerReverse", "Integers", "IntegerString", "Integral", "Integrate", "Interactive", "InteractiveTradingChart", "Interlaced", "Interleaving", "InternallyBalancedDecomposition", "InterpolatingFunction", "InterpolatingPolynomial", "Interpolation", "InterpolationOrder", "InterpolationPoints", "InterpolationPrecision", "Interpretation", "InterpretationBox", "InterpretationBoxOptions", "InterpretationFunction", "Interpreter", "InterpretTemplate", "InterquartileRange", "Interrupt", "InterruptSettings", "IntersectedEntityClass", "IntersectingQ", "Intersection", "Interval", "IntervalIntersection", "IntervalMarkers", "IntervalMarkersStyle", "IntervalMemberQ", "IntervalSlider", "IntervalUnion", "Into", "Inverse", "InverseBetaRegularized", "InverseCDF", "InverseChiSquareDistribution", "InverseContinuousWaveletTransform", "InverseDistanceTransform", "InverseEllipticNomeQ", "InverseErf", "InverseErfc", "InverseFourier", "InverseFourierCosTransform", "InverseFourierSequenceTransform", "InverseFourierSinTransform", "InverseFourierTransform", "InverseFunction", "InverseFunctions", "InverseGammaDistribution", "InverseGammaRegularized", "InverseGaussianDistribution", "InverseGudermannian", "InverseHankelTransform", "InverseHaversine", "InverseImagePyramid", "InverseJacobiCD", "InverseJacobiCN", "InverseJacobiCS", "InverseJacobiDC", "InverseJacobiDN", "InverseJacobiDS", "InverseJacobiNC", "InverseJacobiND", "InverseJacobiNS", "InverseJacobiSC", "InverseJacobiSD", "InverseJacobiSN", "InverseLaplaceTransform", "InverseMellinTransform", "InversePermutation", "InverseRadon", "InverseRadonTransform", "InverseSeries", "InverseShortTimeFourier", "InverseSpectrogram", "InverseSurvivalFunction", "InverseTransformedRegion", "InverseWaveletTransform", "InverseWeierstrassP", "InverseWishartMatrixDistribution", "InverseZTransform", "Invisible", "InvisibleApplication", "InvisibleTimes", "IPAddress", "IrreduciblePolynomialQ", "IslandData", "IsolatingInterval", "IsomorphicGraphQ", "IsotopeData", "Italic", "Item", "ItemAspectRatio", "ItemBox", "ItemBoxOptions", "ItemDisplayFunction", "ItemSize", "ItemStyle", "ItoProcess", "JaccardDissimilarity", "JacobiAmplitude", "Jacobian", "JacobiCD", "JacobiCN", "JacobiCS", "JacobiDC", "JacobiDN", "JacobiDS", "JacobiNC", "JacobiND", "JacobiNS", "JacobiP", "JacobiSC", "JacobiSD", "JacobiSN", "JacobiSymbol", "JacobiZeta", "JankoGroupJ1", "JankoGroupJ2", "JankoGroupJ3", "JankoGroupJ4", "JarqueBeraALMTest", "JohnsonDistribution", "Join", "JoinAcross", "Joined", "JoinedCurve", "JoinedCurveBox", "JoinedCurveBoxOptions", "JoinForm", "JordanDecomposition", "JordanModelDecomposition", "JulianDate", "JuliaSetBoettcher", "JuliaSetIterationCount", "JuliaSetPlot", "JuliaSetPoints", "K", "KagiChart", "KaiserBesselWindow", "KaiserWindow", "KalmanEstimator", "KalmanFilter", "KarhunenLoeveDecomposition", "KaryTree", "KatzCentrality", "KCoreComponents", "KDistribution", "KEdgeConnectedComponents", "KEdgeConnectedGraphQ", "KeepExistingVersion", "KelvinBei", "KelvinBer", "KelvinKei", "KelvinKer", "KendallTau", "KendallTauTest", "KernelExecute", "KernelFunction", "KernelMixtureDistribution", "KernelObject", "Kernels", "Ket", "Key", "KeyCollisionFunction", "KeyComplement", "KeyDrop", "KeyDropFrom", "KeyExistsQ", "KeyFreeQ", "KeyIntersection", "KeyMap", "KeyMemberQ", "KeypointStrength", "Keys", "KeySelect", "KeySort", "KeySortBy", "KeyTake", "KeyUnion", "KeyValueMap", "KeyValuePattern", "Khinchin", "KillProcess", "KirchhoffGraph", "KirchhoffMatrix", "KleinInvariantJ", "KnapsackSolve", "KnightTourGraph", "KnotData", "KnownUnitQ", "KochCurve", "KolmogorovSmirnovTest", "KroneckerDelta", "KroneckerModelDecomposition", "KroneckerProduct", "KroneckerSymbol", "KuiperTest", "KumaraswamyDistribution", "Kurtosis", "KuwaharaFilter", "KVertexConnectedComponents", "KVertexConnectedGraphQ", "LABColor", "Label", "Labeled", "LabeledSlider", "LabelingFunction", "LabelingSize", "LabelStyle", "LabelVisibility", "LaguerreL", "LakeData", "LambdaComponents", "LambertW", "LaminaData", "LanczosWindow", "LandauDistribution", "Language", "LanguageCategory", "LanguageData", "LanguageIdentify", "LanguageOptions", "LaplaceDistribution", "LaplaceTransform", "Laplacian", "LaplacianFilter", "LaplacianGaussianFilter", "Large", "Larger", "Last", "Latitude", "LatitudeLongitude", "LatticeData", "LatticeReduce", "Launch", "LaunchKernels", "LayeredGraphPlot", "LayerSizeFunction", "LayoutInformation", "LCHColor", "LCM", "LeaderSize", "LeafCount", "LeapYearQ", "LearnDistribution", "LearnedDistribution", "LearningRate", "LearningRateMultipliers", "LeastSquares", "LeastSquaresFilterKernel", "Left", "LeftArrow", "LeftArrowBar", "LeftArrowRightArrow", "LeftDownTeeVector", "LeftDownVector", "LeftDownVectorBar", "LeftRightArrow", "LeftRightVector", "LeftTee", "LeftTeeArrow", "LeftTeeVector", "LeftTriangle", "LeftTriangleBar", "LeftTriangleEqual", "LeftUpDownVector", "LeftUpTeeVector", "LeftUpVector", "LeftUpVectorBar", "LeftVector", "LeftVectorBar", "LegendAppearance", "Legended", "LegendFunction", "LegendLabel", "LegendLayout", "LegendMargins", "LegendMarkers", "LegendMarkerSize", "LegendreP", "LegendreQ", "LegendreType", "Length", "LengthWhile", "LerchPhi", "Less", "LessEqual", "LessEqualGreater", "LessEqualThan", "LessFullEqual", "LessGreater", "LessLess", "LessSlantEqual", "LessThan", "LessTilde", "LetterCharacter", "LetterCounts", "LetterNumber", "LetterQ", "Level", "LeveneTest", "LeviCivitaTensor", "LevyDistribution", "Lexicographic", "LibraryDataType", "LibraryFunction", "LibraryFunctionError", "LibraryFunctionInformation", "LibraryFunctionLoad", "LibraryFunctionUnload", "LibraryLoad", "LibraryUnload", "LicenseID", "LiftingFilterData", "LiftingWaveletTransform", "LightBlue", "LightBrown", "LightCyan", "Lighter", "LightGray", "LightGreen", "Lighting", "LightingAngle", "LightMagenta", "LightOrange", "LightPink", "LightPurple", "LightRed", "LightSources", "LightYellow", "Likelihood", "Limit", "LimitsPositioning", "LimitsPositioningTokens", "LindleyDistribution", "Line", "Line3DBox", "Line3DBoxOptions", "LinearFilter", "LinearFractionalOptimization", "LinearFractionalTransform", "LinearGradientImage", "LinearizingTransformationData", "LinearLayer", "LinearModelFit", "LinearOffsetFunction", "LinearOptimization", "LinearProgramming", "LinearRecurrence", "LinearSolve", "LinearSolveFunction", "LineBox", "LineBoxOptions", "LineBreak", "LinebreakAdjustments", "LineBreakChart", "LinebreakSemicolonWeighting", "LineBreakWithin", "LineColor", "LineGraph", "LineIndent", "LineIndentMaxFraction", "LineIntegralConvolutionPlot", "LineIntegralConvolutionScale", "LineLegend", "LineOpacity", "LineSpacing", "LineWrapParts", "LinkActivate", "LinkClose", "LinkConnect", "LinkConnectedQ", "LinkCreate", "LinkError", "LinkFlush", "LinkFunction", "LinkHost", "LinkInterrupt", "LinkLaunch", "LinkMode", "LinkObject", "LinkOpen", "LinkOptions", "LinkPatterns", "LinkProtocol", "LinkRankCentrality", "LinkRead", "LinkReadHeld", "LinkReadyQ", "Links", "LinkService", "LinkWrite", "LinkWriteHeld", "LiouvilleLambda", "List", "Listable", "ListAnimate", "ListContourPlot", "ListContourPlot3D", "ListConvolve", "ListCorrelate", "ListCurvePathPlot", "ListDeconvolve", "ListDensityPlot", "ListDensityPlot3D", "Listen", "ListFormat", "ListFourierSequenceTransform", "ListInterpolation", "ListLineIntegralConvolutionPlot", "ListLinePlot", "ListLogLinearPlot", "ListLogLogPlot", "ListLogPlot", "ListPicker", "ListPickerBox", "ListPickerBoxBackground", "ListPickerBoxOptions", "ListPlay", "ListPlot", "ListPlot3D", "ListPointPlot3D", "ListPolarPlot", "ListQ", "ListSliceContourPlot3D", "ListSliceDensityPlot3D", "ListSliceVectorPlot3D", "ListStepPlot", "ListStreamDensityPlot", "ListStreamPlot", "ListSurfacePlot3D", "ListVectorDensityPlot", "ListVectorPlot", "ListVectorPlot3D", "ListZTransform", "Literal", "LiteralSearch", "LocalAdaptiveBinarize", "LocalCache", "LocalClusteringCoefficient", "LocalizeDefinitions", "LocalizeVariables", "LocalObject", "LocalObjects", "LocalResponseNormalizationLayer", "LocalSubmit", "LocalSymbol", "LocalTime", "LocalTimeZone", "LocationEquivalenceTest", "LocationTest", "Locator", "LocatorAutoCreate", "LocatorBox", "LocatorBoxOptions", "LocatorCentering", "LocatorPane", "LocatorPaneBox", "LocatorPaneBoxOptions", "LocatorRegion", "Locked", "Log", "Log10", "Log2", "LogBarnesG", "LogGamma", "LogGammaDistribution", "LogicalExpand", "LogIntegral", "LogisticDistribution", "LogisticSigmoid", "LogitModelFit", "LogLikelihood", "LogLinearPlot", "LogLogisticDistribution", "LogLogPlot", "LogMultinormalDistribution", "LogNormalDistribution", "LogPlot", "LogRankTest", "LogSeriesDistribution", "LongEqual", "Longest", "LongestCommonSequence", "LongestCommonSequencePositions", "LongestCommonSubsequence", "LongestCommonSubsequencePositions", "LongestMatch", "LongestOrderedSequence", "LongForm", "Longitude", "LongLeftArrow", "LongLeftRightArrow", "LongRightArrow", "LongShortTermMemoryLayer", "Lookup", "Loopback", "LoopFreeGraphQ", "Looping", "LossFunction", "LowerCaseQ", "LowerLeftArrow", "LowerRightArrow", "LowerTriangularize", "LowerTriangularMatrixQ", "LowpassFilter", "LQEstimatorGains", "LQGRegulator", "LQOutputRegulatorGains", "LQRegulatorGains", "LUBackSubstitution", "LucasL", "LuccioSamiComponents", "LUDecomposition", "LunarEclipse", "LUVColor", "LyapunovSolve", "LyonsGroupLy", "MachineID", "MachineName", "MachineNumberQ", "MachinePrecision", "MacintoshSystemPageSetup", "Magenta", "Magnification", "Magnify", "MailAddressValidation", "MailExecute", "MailFolder", "MailItem", "MailReceiverFunction", "MailResponseFunction", "MailSearch", "MailServerConnect", "MailServerConnection", "MailSettings", "MainSolve", "MaintainDynamicCaches", "Majority", "MakeBoxes", "MakeExpression", "MakeRules", "ManagedLibraryExpressionID", "ManagedLibraryExpressionQ", "MandelbrotSetBoettcher", "MandelbrotSetDistance", "MandelbrotSetIterationCount", "MandelbrotSetMemberQ", "MandelbrotSetPlot", "MangoldtLambda", "ManhattanDistance", "Manipulate", "Manipulator", "MannedSpaceMissionData", "MannWhitneyTest", "MantissaExponent", "Manual", "Map", "MapAll", "MapAt", "MapIndexed", "MAProcess", "MapThread", "MarchenkoPasturDistribution", "MarcumQ", "MardiaCombinedTest", "MardiaKurtosisTest", "MardiaSkewnessTest", "MarginalDistribution", "MarkovProcessProperties", "Masking", "MatchingDissimilarity", "MatchLocalNameQ", "MatchLocalNames", "MatchQ", "Material", "MathematicalFunctionData", "MathematicaNotation", "MathieuC", "MathieuCharacteristicA", "MathieuCharacteristicB", "MathieuCharacteristicExponent", "MathieuCPrime", "MathieuGroupM11", "MathieuGroupM12", "MathieuGroupM22", "MathieuGroupM23", "MathieuGroupM24", "MathieuS", "MathieuSPrime", "MathMLForm", "MathMLText", "Matrices", "MatrixExp", "MatrixForm", "MatrixFunction", "MatrixLog", "MatrixNormalDistribution", "MatrixPlot", "MatrixPower", "MatrixPropertyDistribution", "MatrixQ", "MatrixRank", "MatrixTDistribution", "Max", "MaxBend", "MaxCellMeasure", "MaxColorDistance", "MaxDate", "MaxDetect", "MaxDuration", "MaxExtraBandwidths", "MaxExtraConditions", "MaxFeatureDisplacement", "MaxFeatures", "MaxFilter", "MaximalBy", "Maximize", "MaxItems", "MaxIterations", "MaxLimit", "MaxMemoryUsed", "MaxMixtureKernels", "MaxOverlapFraction", "MaxPlotPoints", "MaxPoints", "MaxRecursion", "MaxStableDistribution", "MaxStepFraction", "MaxSteps", "MaxStepSize", "MaxTrainingRounds", "MaxValue", "MaxwellDistribution", "MaxWordGap", "McLaughlinGroupMcL", "Mean", "MeanAbsoluteLossLayer", "MeanAround", "MeanClusteringCoefficient", "MeanDegreeConnectivity", "MeanDeviation", "MeanFilter", "MeanGraphDistance", "MeanNeighborDegree", "MeanShift", "MeanShiftFilter", "MeanSquaredLossLayer", "Median", "MedianDeviation", "MedianFilter", "MedicalTestData", "Medium", "MeijerG", "MeijerGReduce", "MeixnerDistribution", "MellinConvolve", "MellinTransform", "MemberQ", "MemoryAvailable", "MemoryConstrained", "MemoryConstraint", "MemoryInUse", "MengerMesh", "Menu", "MenuAppearance", "MenuCommandKey", "MenuEvaluator", "MenuItem", "MenuList", "MenuPacket", "MenuSortingValue", "MenuStyle", "MenuView", "Merge", "MergeDifferences", "MergingFunction", "MersennePrimeExponent", "MersennePrimeExponentQ", "Mesh", "MeshCellCentroid", "MeshCellCount", "MeshCellHighlight", "MeshCellIndex", "MeshCellLabel", "MeshCellMarker", "MeshCellMeasure", "MeshCellQuality", "MeshCells", "MeshCellShapeFunction", "MeshCellStyle", "MeshConnectivityGraph", "MeshCoordinates", "MeshFunctions", "MeshPrimitives", "MeshQualityGoal", "MeshRange", "MeshRefinementFunction", "MeshRegion", "MeshRegionQ", "MeshShading", "MeshStyle", "Message", "MessageDialog", "MessageList", "MessageName", "MessageObject", "MessageOptions", "MessagePacket", "Messages", "MessagesNotebook", "MetaCharacters", "MetaInformation", "MeteorShowerData", "Method", "MethodOptions", "MexicanHatWavelet", "MeyerWavelet", "Midpoint", "Min", "MinColorDistance", "MinDate", "MinDetect", "MineralData", "MinFilter", "MinimalBy", "MinimalPolynomial", "MinimalStateSpaceModel", "Minimize", "MinimumTimeIncrement", "MinIntervalSize", "MinkowskiQuestionMark", "MinLimit", "MinMax", "MinorPlanetData", "Minors", "MinRecursion", "MinSize", "MinStableDistribution", "Minus", "MinusPlus", "MinValue", "Missing", "MissingBehavior", "MissingDataMethod", "MissingDataRules", "MissingQ", "MissingString", "MissingStyle", "MissingValuePattern", "MittagLefflerE", "MixedFractionParts", "MixedGraphQ", "MixedMagnitude", "MixedRadix", "MixedRadixQuantity", "MixedUnit", "MixtureDistribution", "Mod", "Modal", "Mode", "Modular", "ModularInverse", "ModularLambda", "Module", "Modulus", "MoebiusMu", "Molecule", "MoleculeContainsQ", "MoleculeEquivalentQ", "MoleculeGraph", "MoleculeModify", "MoleculePattern", "MoleculePlot", "MoleculePlot3D", "MoleculeProperty", "MoleculeQ", "MoleculeRecognize", "MoleculeValue", "Moment", "Momentary", "MomentConvert", "MomentEvaluate", "MomentGeneratingFunction", "MomentOfInertia", "Monday", "Monitor", "MonomialList", "MonomialOrder", "MonsterGroupM", "MoonPhase", "MoonPosition", "MorletWavelet", "MorphologicalBinarize", "MorphologicalBranchPoints", "MorphologicalComponents", "MorphologicalEulerNumber", "MorphologicalGraph", "MorphologicalPerimeter", "MorphologicalTransform", "MortalityData", "Most", "MountainData", "MouseAnnotation", "MouseAppearance", "MouseAppearanceTag", "MouseButtons", "Mouseover", "MousePointerNote", "MousePosition", "MovieData", "MovingAverage", "MovingMap", "MovingMedian", "MoyalDistribution", "Multicolumn", "MultiedgeStyle", "MultigraphQ", "MultilaunchWarning", "MultiLetterItalics", "MultiLetterStyle", "MultilineFunction", "Multinomial", "MultinomialDistribution", "MultinormalDistribution", "MultiplicativeOrder", "Multiplicity", "MultiplySides", "Multiselection", "MultivariateHypergeometricDistribution", "MultivariatePoissonDistribution", "MultivariateTDistribution", "N", "NakagamiDistribution", "NameQ", "Names", "NamespaceBox", "NamespaceBoxOptions", "Nand", "NArgMax", "NArgMin", "NBernoulliB", "NBodySimulation", "NBodySimulationData", "NCache", "NDEigensystem", "NDEigenvalues", "NDSolve", "NDSolveValue", "Nearest", "NearestFunction", "NearestMeshCells", "NearestNeighborGraph", "NearestTo", "NebulaData", "NeedCurrentFrontEndPackagePacket", "NeedCurrentFrontEndSymbolsPacket", "NeedlemanWunschSimilarity", "Needs", "Negative", "NegativeBinomialDistribution", "NegativeDefiniteMatrixQ", "NegativeIntegers", "NegativeMultinomialDistribution", "NegativeRationals", "NegativeReals", "NegativeSemidefiniteMatrixQ", "NeighborhoodData", "NeighborhoodGraph", "Nest", "NestedGreaterGreater", "NestedLessLess", "NestedScriptRules", "NestGraph", "NestList", "NestWhile", "NestWhileList", "NetAppend", "NetBidirectionalOperator", "NetChain", "NetDecoder", "NetDelete", "NetDrop", "NetEncoder", "NetEvaluationMode", "NetExtract", "NetFlatten", "NetFoldOperator", "NetGANOperator", "NetGraph", "NetInformation", "NetInitialize", "NetInsert", "NetInsertSharedArrays", "NetJoin", "NetMapOperator", "NetMapThreadOperator", "NetMeasurements", "NetModel", "NetNestOperator", "NetPairEmbeddingOperator", "NetPort", "NetPortGradient", "NetPrepend", "NetRename", "NetReplace", "NetReplacePart", "NetSharedArray", "NetStateObject", "NetTake", "NetTrain", "NetTrainResultsObject", "NetworkPacketCapture", "NetworkPacketRecording", "NetworkPacketRecordingDuring", "NetworkPacketTrace", "NeumannValue", "NevilleThetaC", "NevilleThetaD", "NevilleThetaN", "NevilleThetaS", "NewPrimitiveStyle", "NExpectation", "Next", "NextCell", "NextDate", "NextPrime", "NextScheduledTaskTime", "NHoldAll", "NHoldFirst", "NHoldRest", "NicholsGridLines", "NicholsPlot", "NightHemisphere", "NIntegrate", "NMaximize", "NMaxValue", "NMinimize", "NMinValue", "NominalVariables", "NonAssociative", "NoncentralBetaDistribution", "NoncentralChiSquareDistribution", "NoncentralFRatioDistribution", "NoncentralStudentTDistribution", "NonCommutativeMultiply", "NonConstants", "NondimensionalizationTransform", "None", "NoneTrue", "NonlinearModelFit", "NonlinearStateSpaceModel", "NonlocalMeansFilter", "NonNegative", "NonNegativeIntegers", "NonNegativeRationals", "NonNegativeReals", "NonPositive", "NonPositiveIntegers", "NonPositiveRationals", "NonPositiveReals", "Nor", "NorlundB", "Norm", "Normal", "NormalDistribution", "NormalGrouping", "NormalizationLayer", "Normalize", "Normalized", "NormalizedSquaredEuclideanDistance", "NormalMatrixQ", "NormalsFunction", "NormFunction", "Not", "NotCongruent", "NotCupCap", "NotDoubleVerticalBar", "Notebook", "NotebookApply", "NotebookAutoSave", "NotebookClose", "NotebookConvertSettings", "NotebookCreate", "NotebookCreateReturnObject", "NotebookDefault", "NotebookDelete", "NotebookDirectory", "NotebookDynamicExpression", "NotebookEvaluate", "NotebookEventActions", "NotebookFileName", "NotebookFind", "NotebookFindReturnObject", "NotebookGet", "NotebookGetLayoutInformationPacket", "NotebookGetMisspellingsPacket", "NotebookImport", "NotebookInformation", "NotebookInterfaceObject", "NotebookLocate", "NotebookObject", "NotebookOpen", "NotebookOpenReturnObject", "NotebookPath", "NotebookPrint", "NotebookPut", "NotebookPutReturnObject", "NotebookRead", "NotebookResetGeneratedCells", "Notebooks", "NotebookSave", "NotebookSaveAs", "NotebookSelection", "NotebookSetupLayoutInformationPacket", "NotebooksMenu", "NotebookTemplate", "NotebookWrite", "NotElement", "NotEqualTilde", "NotExists", "NotGreater", "NotGreaterEqual", "NotGreaterFullEqual", "NotGreaterGreater", "NotGreaterLess", "NotGreaterSlantEqual", "NotGreaterTilde", "Nothing", "NotHumpDownHump", "NotHumpEqual", "NotificationFunction", "NotLeftTriangle", "NotLeftTriangleBar", "NotLeftTriangleEqual", "NotLess", "NotLessEqual", "NotLessFullEqual", "NotLessGreater", "NotLessLess", "NotLessSlantEqual", "NotLessTilde", "NotNestedGreaterGreater", "NotNestedLessLess", "NotPrecedes", "NotPrecedesEqual", "NotPrecedesSlantEqual", "NotPrecedesTilde", "NotReverseElement", "NotRightTriangle", "NotRightTriangleBar", "NotRightTriangleEqual", "NotSquareSubset", "NotSquareSubsetEqual", "NotSquareSuperset", "NotSquareSupersetEqual", "NotSubset", "NotSubsetEqual", "NotSucceeds", "NotSucceedsEqual", "NotSucceedsSlantEqual", "NotSucceedsTilde", "NotSuperset", "NotSupersetEqual", "NotTilde", "NotTildeEqual", "NotTildeFullEqual", "NotTildeTilde", "NotVerticalBar", "Now", "NoWhitespace", "NProbability", "NProduct", "NProductFactors", "NRoots", "NSolve", "NSum", "NSumTerms", "NuclearExplosionData", "NuclearReactorData", "Null", "NullRecords", "NullSpace", "NullWords", "Number", "NumberCompose", "NumberDecompose", "NumberExpand", "NumberFieldClassNumber", "NumberFieldDiscriminant", "NumberFieldFundamentalUnits", "NumberFieldIntegralBasis", "NumberFieldNormRepresentatives", "NumberFieldRegulator", "NumberFieldRootsOfUnity", "NumberFieldSignature", "NumberForm", "NumberFormat", "NumberLinePlot", "NumberMarks", "NumberMultiplier", "NumberPadding", "NumberPoint", "NumberQ", "NumberSeparator", "NumberSigns", "NumberString", "Numerator", "NumeratorDenominator", "NumericalOrder", "NumericalSort", "NumericArray", "NumericArrayQ", "NumericArrayType", "NumericFunction", "NumericQ", "NuttallWindow", "NValues", "NyquistGridLines", "NyquistPlot", "O", "ObservabilityGramian", "ObservabilityMatrix", "ObservableDecomposition", "ObservableModelQ", "OceanData", "Octahedron", "OddQ", "Off", "Offset", "OLEData", "On", "ONanGroupON", "Once", "OneIdentity", "Opacity", "OpacityFunction", "OpacityFunctionScaling", "Open", "OpenAppend", "Opener", "OpenerBox", "OpenerBoxOptions", "OpenerView", "OpenFunctionInspectorPacket", "Opening", "OpenRead", "OpenSpecialOptions", "OpenTemporary", "OpenWrite", "Operate", "OperatingSystem", "OperatorApplied", "OptimumFlowData", "Optional", "OptionalElement", "OptionInspectorSettings", "OptionQ", "Options", "OptionsPacket", "OptionsPattern", "OptionValue", "OptionValueBox", "OptionValueBoxOptions", "Or", "Orange", "Order", "OrderDistribution", "OrderedQ", "Ordering", "OrderingBy", "OrderingLayer", "Orderless", "OrderlessPatternSequence", "OrnsteinUhlenbeckProcess", "Orthogonalize", "OrthogonalMatrixQ", "Out", "Outer", "OuterPolygon", "OuterPolyhedron", "OutputAutoOverwrite", "OutputControllabilityMatrix", "OutputControllableModelQ", "OutputForm", "OutputFormData", "OutputGrouping", "OutputMathEditExpression", "OutputNamePacket", "OutputResponse", "OutputSizeLimit", "OutputStream", "Over", "OverBar", "OverDot", "Overflow", "OverHat", "Overlaps", "Overlay", "OverlayBox", "OverlayBoxOptions", "Overscript", "OverscriptBox", "OverscriptBoxOptions", "OverTilde", "OverVector", "OverwriteTarget", "OwenT", "OwnValues", "Package", "PackingMethod", "PackPaclet", "PacletDataRebuild", "PacletDirectoryAdd", "PacletDirectoryLoad", "PacletDirectoryRemove", "PacletDirectoryUnload", "PacletDisable", "PacletEnable", "PacletFind", "PacletFindRemote", "PacletInformation", "PacletInstall", "PacletInstallSubmit", "PacletNewerQ", "PacletObject", "PacletObjectQ", "PacletSite", "PacletSiteObject", "PacletSiteRegister", "PacletSites", "PacletSiteUnregister", "PacletSiteUpdate", "PacletUninstall", "PacletUpdate", "PaddedForm", "Padding", "PaddingLayer", "PaddingSize", "PadeApproximant", "PadLeft", "PadRight", "PageBreakAbove", "PageBreakBelow", "PageBreakWithin", "PageFooterLines", "PageFooters", "PageHeaderLines", "PageHeaders", "PageHeight", "PageRankCentrality", "PageTheme", "PageWidth", "Pagination", "PairedBarChart", "PairedHistogram", "PairedSmoothHistogram", "PairedTTest", "PairedZTest", "PaletteNotebook", "PalettePath", "PalindromeQ", "Pane", "PaneBox", "PaneBoxOptions", "Panel", "PanelBox", "PanelBoxOptions", "Paneled", "PaneSelector", "PaneSelectorBox", "PaneSelectorBoxOptions", "PaperWidth", "ParabolicCylinderD", "ParagraphIndent", "ParagraphSpacing", "ParallelArray", "ParallelCombine", "ParallelDo", "Parallelepiped", "ParallelEvaluate", "Parallelization", "Parallelize", "ParallelMap", "ParallelNeeds", "Parallelogram", "ParallelProduct", "ParallelSubmit", "ParallelSum", "ParallelTable", "ParallelTry", "Parameter", "ParameterEstimator", "ParameterMixtureDistribution", "ParameterVariables", "ParametricFunction", "ParametricNDSolve", "ParametricNDSolveValue", "ParametricPlot", "ParametricPlot3D", "ParametricRampLayer", "ParametricRegion", "ParentBox", "ParentCell", "ParentConnect", "ParentDirectory", "ParentForm", "Parenthesize", "ParentList", "ParentNotebook", "ParetoDistribution", "ParetoPickandsDistribution", "ParkData", "Part", "PartBehavior", "PartialCorrelationFunction", "PartialD", "ParticleAcceleratorData", "ParticleData", "Partition", "PartitionGranularity", "PartitionsP", "PartitionsQ", "PartLayer", "PartOfSpeech", "PartProtection", "ParzenWindow", "PascalDistribution", "PassEventsDown", "PassEventsUp", "Paste", "PasteAutoQuoteCharacters", "PasteBoxFormInlineCells", "PasteButton", "Path", "PathGraph", "PathGraphQ", "Pattern", "PatternFilling", "PatternSequence", "PatternTest", "PauliMatrix", "PaulWavelet", "Pause", "PausedTime", "PDF", "PeakDetect", "PeanoCurve", "PearsonChiSquareTest", "PearsonCorrelationTest", "PearsonDistribution", "PercentForm", "PerfectNumber", "PerfectNumberQ", "PerformanceGoal", "Perimeter", "PeriodicBoundaryCondition", "PeriodicInterpolation", "Periodogram", "PeriodogramArray", "Permanent", "Permissions", "PermissionsGroup", "PermissionsGroupMemberQ", "PermissionsGroups", "PermissionsKey", "PermissionsKeys", "PermutationCycles", "PermutationCyclesQ", "PermutationGroup", "PermutationLength", "PermutationList", "PermutationListQ", "PermutationMax", "PermutationMin", "PermutationOrder", "PermutationPower", "PermutationProduct", "PermutationReplace", "Permutations", "PermutationSupport", "Permute", "PeronaMalikFilter", "Perpendicular", "PerpendicularBisector", "PersistenceLocation", "PersistenceTime", "PersistentObject", "PersistentObjects", "PersistentValue", "PersonData", "PERTDistribution", "PetersenGraph", "PhaseMargins", "PhaseRange", "PhysicalSystemData", "Pi", "Pick", "PIDData", "PIDDerivativeFilter", "PIDFeedforward", "PIDTune", "Piecewise", "PiecewiseExpand", "PieChart", "PieChart3D", "PillaiTrace", "PillaiTraceTest", "PingTime", "Pink", "PitchRecognize", "Pivoting", "PixelConstrained", "PixelValue", "PixelValuePositions", "Placed", "Placeholder", "PlaceholderReplace", "Plain", "PlanarAngle", "PlanarGraph", "PlanarGraphQ", "PlanckRadiationLaw", "PlaneCurveData", "PlanetaryMoonData", "PlanetData", "PlantData", "Play", "PlayRange", "Plot", "Plot3D", "Plot3Matrix", "PlotDivision", "PlotJoined", "PlotLabel", "PlotLabels", "PlotLayout", "PlotLegends", "PlotMarkers", "PlotPoints", "PlotRange", "PlotRangeClipping", "PlotRangeClipPlanesStyle", "PlotRangePadding", "PlotRegion", "PlotStyle", "PlotTheme", "Pluralize", "Plus", "PlusMinus", "Pochhammer", "PodStates", "PodWidth", "Point", "Point3DBox", "Point3DBoxOptions", "PointBox", "PointBoxOptions", "PointFigureChart", "PointLegend", "PointSize", "PoissonConsulDistribution", "PoissonDistribution", "PoissonProcess", "PoissonWindow", "PolarAxes", "PolarAxesOrigin", "PolarGridLines", "PolarPlot", "PolarTicks", "PoleZeroMarkers", "PolyaAeppliDistribution", "PolyGamma", "Polygon", "Polygon3DBox", "Polygon3DBoxOptions", "PolygonalNumber", "PolygonAngle", "PolygonBox", "PolygonBoxOptions", "PolygonCoordinates", "PolygonDecomposition", "PolygonHoleScale", "PolygonIntersections", "PolygonScale", "Polyhedron", "PolyhedronAngle", "PolyhedronCoordinates", "PolyhedronData", "PolyhedronDecomposition", "PolyhedronGenus", "PolyLog", "PolynomialExtendedGCD", "PolynomialForm", "PolynomialGCD", "PolynomialLCM", "PolynomialMod", "PolynomialQ", "PolynomialQuotient", "PolynomialQuotientRemainder", "PolynomialReduce", "PolynomialRemainder", "Polynomials", "PoolingLayer", "PopupMenu", "PopupMenuBox", "PopupMenuBoxOptions", "PopupView", "PopupWindow", "Position", "PositionIndex", "Positive", "PositiveDefiniteMatrixQ", "PositiveIntegers", "PositiveRationals", "PositiveReals", "PositiveSemidefiniteMatrixQ", "PossibleZeroQ", "Postfix", "PostScript", "Power", "PowerDistribution", "PowerExpand", "PowerMod", "PowerModList", "PowerRange", "PowerSpectralDensity", "PowersRepresentations", "PowerSymmetricPolynomial", "Precedence", "PrecedenceForm", "Precedes", "PrecedesEqual", "PrecedesSlantEqual", "PrecedesTilde", "Precision", "PrecisionGoal", "PreDecrement", "Predict", "PredictionRoot", "PredictorFunction", "PredictorInformation", "PredictorMeasurements", "PredictorMeasurementsObject", "PreemptProtect", "PreferencesPath", "Prefix", "PreIncrement", "Prepend", "PrependLayer", "PrependTo", "PreprocessingRules", "PreserveColor", "PreserveImageOptions", "Previous", "PreviousCell", "PreviousDate", "PriceGraphDistribution", "PrimaryPlaceholder", "Prime", "PrimeNu", "PrimeOmega", "PrimePi", "PrimePowerQ", "PrimeQ", "Primes", "PrimeZetaP", "PrimitivePolynomialQ", "PrimitiveRoot", "PrimitiveRootList", "PrincipalComponents", "PrincipalValue", "Print", "PrintableASCIIQ", "PrintAction", "PrintForm", "PrintingCopies", "PrintingOptions", "PrintingPageRange", "PrintingStartingPageNumber", "PrintingStyleEnvironment", "Printout3D", "Printout3DPreviewer", "PrintPrecision", "PrintTemporary", "Prism", "PrismBox", "PrismBoxOptions", "PrivateCellOptions", "PrivateEvaluationOptions", "PrivateFontOptions", "PrivateFrontEndOptions", "PrivateKey", "PrivateNotebookOptions", "PrivatePaths", "Probability", "ProbabilityDistribution", "ProbabilityPlot", "ProbabilityPr", "ProbabilityScalePlot", "ProbitModelFit", "ProcessConnection", "ProcessDirectory", "ProcessEnvironment", "Processes", "ProcessEstimator", "ProcessInformation", "ProcessObject", "ProcessParameterAssumptions", "ProcessParameterQ", "ProcessStateDomain", "ProcessStatus", "ProcessTimeDomain", "Product", "ProductDistribution", "ProductLog", "ProgressIndicator", "ProgressIndicatorBox", "ProgressIndicatorBoxOptions", "Projection", "Prolog", "PromptForm", "ProofObject", "Properties", "Property", "PropertyList", "PropertyValue", "Proportion", "Proportional", "Protect", "Protected", "ProteinData", "Pruning", "PseudoInverse", "PsychrometricPropertyData", "PublicKey", "PublisherID", "PulsarData", "PunctuationCharacter", "Purple", "Put", "PutAppend", "Pyramid", "PyramidBox", "PyramidBoxOptions", "QBinomial", "QFactorial", "QGamma", "QHypergeometricPFQ", "QnDispersion", "QPochhammer", "QPolyGamma", "QRDecomposition", "QuadraticIrrationalQ", "QuadraticOptimization", "Quantile", "QuantilePlot", "Quantity", "QuantityArray", "QuantityDistribution", "QuantityForm", "QuantityMagnitude", "QuantityQ", "QuantityUnit", "QuantityVariable", "QuantityVariableCanonicalUnit", "QuantityVariableDimensions", "QuantityVariableIdentifier", "QuantityVariablePhysicalQuantity", "Quartics", "QuartileDeviation", "Quartiles", "QuartileSkewness", "Query", "QueueingNetworkProcess", "QueueingProcess", "QueueProperties", "Quiet", "Quit", "Quotient", "QuotientRemainder", "RadialGradientImage", "RadialityCentrality", "RadicalBox", "RadicalBoxOptions", "RadioButton", "RadioButtonBar", "RadioButtonBox", "RadioButtonBoxOptions", "Radon", "RadonTransform", "RamanujanTau", "RamanujanTauL", "RamanujanTauTheta", "RamanujanTauZ", "Ramp", "Random", "RandomChoice", "RandomColor", "RandomComplex", "RandomEntity", "RandomFunction", "RandomGeoPosition", "RandomGraph", "RandomImage", "RandomInstance", "RandomInteger", "RandomPermutation", "RandomPoint", "RandomPolygon", "RandomPolyhedron", "RandomPrime", "RandomReal", "RandomSample", "RandomSeed", "RandomSeeding", "RandomVariate", "RandomWalkProcess", "RandomWord", "Range", "RangeFilter", "RangeSpecification", "RankedMax", "RankedMin", "RarerProbability", "Raster", "Raster3D", "Raster3DBox", "Raster3DBoxOptions", "RasterArray", "RasterBox", "RasterBoxOptions", "Rasterize", "RasterSize", "Rational", "RationalFunctions", "Rationalize", "Rationals", "Ratios", "RawArray", "RawBoxes", "RawData", "RawMedium", "RayleighDistribution", "Re", "Read", "ReadByteArray", "ReadLine", "ReadList", "ReadProtected", "ReadString", "Real", "RealAbs", "RealBlockDiagonalForm", "RealDigits", "RealExponent", "Reals", "RealSign", "Reap", "RebuildPacletData", "RecognitionPrior", "RecognitionThreshold", "Record", "RecordLists", "RecordSeparators", "Rectangle", "RectangleBox", "RectangleBoxOptions", "RectangleChart", "RectangleChart3D", "RectangularRepeatingElement", "RecurrenceFilter", "RecurrenceTable", "RecurringDigitsForm", "Red", "Reduce", "RefBox", "ReferenceLineStyle", "ReferenceMarkers", "ReferenceMarkerStyle", "Refine", "ReflectionMatrix", "ReflectionTransform", "Refresh", "RefreshRate", "Region", "RegionBinarize", "RegionBoundary", "RegionBoundaryStyle", "RegionBounds", "RegionCentroid", "RegionDifference", "RegionDimension", "RegionDisjoint", "RegionDistance", "RegionDistanceFunction", "RegionEmbeddingDimension", "RegionEqual", "RegionFillingStyle", "RegionFunction", "RegionImage", "RegionIntersection", "RegionMeasure", "RegionMember", "RegionMemberFunction", "RegionMoment", "RegionNearest", "RegionNearestFunction", "RegionPlot", "RegionPlot3D", "RegionProduct", "RegionQ", "RegionResize", "RegionSize", "RegionSymmetricDifference", "RegionUnion", "RegionWithin", "RegisterExternalEvaluator", "RegularExpression", "Regularization", "RegularlySampledQ", "RegularPolygon", "ReIm", "ReImLabels", "ReImPlot", "ReImStyle", "Reinstall", "RelationalDatabase", "RelationGraph", "Release", "ReleaseHold", "ReliabilityDistribution", "ReliefImage", "ReliefPlot", "RemoteAuthorizationCaching", "RemoteConnect", "RemoteConnectionObject", "RemoteFile", "RemoteRun", "RemoteRunProcess", "Remove", "RemoveAlphaChannel", "RemoveAsynchronousTask", "RemoveAudioStream", "RemoveBackground", "RemoveChannelListener", "RemoveChannelSubscribers", "Removed", "RemoveDiacritics", "RemoveInputStreamMethod", "RemoveOutputStreamMethod", "RemoveProperty", "RemoveScheduledTask", "RemoveUsers", "RemoveVideoStream", "RenameDirectory", "RenameFile", "RenderAll", "RenderingOptions", "RenewalProcess", "RenkoChart", "RepairMesh", "Repeated", "RepeatedNull", "RepeatedString", "RepeatedTiming", "RepeatingElement", "Replace", "ReplaceAll", "ReplaceHeldPart", "ReplaceImageValue", "ReplaceList", "ReplacePart", "ReplacePixelValue", "ReplaceRepeated", "ReplicateLayer", "RequiredPhysicalQuantities", "Resampling", "ResamplingAlgorithmData", "ResamplingMethod", "Rescale", "RescalingTransform", "ResetDirectory", "ResetMenusPacket", "ResetScheduledTask", "ReshapeLayer", "Residue", "ResizeLayer", "Resolve", "ResourceAcquire", "ResourceData", "ResourceFunction", "ResourceObject", "ResourceRegister", "ResourceRemove", "ResourceSearch", "ResourceSubmissionObject", "ResourceSubmit", "ResourceSystemBase", "ResourceSystemPath", "ResourceUpdate", "ResourceVersion", "ResponseForm", "Rest", "RestartInterval", "Restricted", "Resultant", "ResumePacket", "Return", "ReturnEntersInput", "ReturnExpressionPacket", "ReturnInputFormPacket", "ReturnPacket", "ReturnReceiptFunction", "ReturnTextPacket", "Reverse", "ReverseApplied", "ReverseBiorthogonalSplineWavelet", "ReverseElement", "ReverseEquilibrium", "ReverseGraph", "ReverseSort", "ReverseSortBy", "ReverseUpEquilibrium", "RevolutionAxis", "RevolutionPlot3D", "RGBColor", "RiccatiSolve", "RiceDistribution", "RidgeFilter", "RiemannR", "RiemannSiegelTheta", "RiemannSiegelZ", "RiemannXi", "Riffle", "Right", "RightArrow", "RightArrowBar", "RightArrowLeftArrow", "RightComposition", "RightCosetRepresentative", "RightDownTeeVector", "RightDownVector", "RightDownVectorBar", "RightTee", "RightTeeArrow", "RightTeeVector", "RightTriangle", "RightTriangleBar", "RightTriangleEqual", "RightUpDownVector", "RightUpTeeVector", "RightUpVector", "RightUpVectorBar", "RightVector", "RightVectorBar", "RiskAchievementImportance", "RiskReductionImportance", "RogersTanimotoDissimilarity", "RollPitchYawAngles", "RollPitchYawMatrix", "RomanNumeral", "Root", "RootApproximant", "RootIntervals", "RootLocusPlot", "RootMeanSquare", "RootOfUnityQ", "RootReduce", "Roots", "RootSum", "Rotate", "RotateLabel", "RotateLeft", "RotateRight", "RotationAction", "RotationBox", "RotationBoxOptions", "RotationMatrix", "RotationTransform", "Round", "RoundImplies", "RoundingRadius", "Row", "RowAlignments", "RowBackgrounds", "RowBox", "RowHeights", "RowLines", "RowMinHeight", "RowReduce", "RowsEqual", "RowSpacings", "RSolve", "RSolveValue", "RudinShapiro", "RudvalisGroupRu", "Rule", "RuleCondition", "RuleDelayed", "RuleForm", "RulePlot", "RulerUnits", "Run", "RunProcess", "RunScheduledTask", "RunThrough", "RuntimeAttributes", "RuntimeOptions", "RussellRaoDissimilarity", "SameQ", "SameTest", "SameTestProperties", "SampledEntityClass", "SampleDepth", "SampledSoundFunction", "SampledSoundList", "SampleRate", "SamplingPeriod", "SARIMAProcess", "SARMAProcess", "SASTriangle", "SatelliteData", "SatisfiabilityCount", "SatisfiabilityInstances", "SatisfiableQ", "Saturday", "Save", "Saveable", "SaveAutoDelete", "SaveConnection", "SaveDefinitions", "SavitzkyGolayMatrix", "SawtoothWave", "Scale", "Scaled", "ScaleDivisions", "ScaledMousePosition", "ScaleOrigin", "ScalePadding", "ScaleRanges", "ScaleRangeStyle", "ScalingFunctions", "ScalingMatrix", "ScalingTransform", "Scan", "ScheduledTask", "ScheduledTaskActiveQ", "ScheduledTaskInformation", "ScheduledTaskInformationData", "ScheduledTaskObject", "ScheduledTasks", "SchurDecomposition", "ScientificForm", "ScientificNotationThreshold", "ScorerGi", "ScorerGiPrime", "ScorerHi", "ScorerHiPrime", "ScreenRectangle", "ScreenStyleEnvironment", "ScriptBaselineShifts", "ScriptForm", "ScriptLevel", "ScriptMinSize", "ScriptRules", "ScriptSizeMultipliers", "Scrollbars", "ScrollingOptions", "ScrollPosition", "SearchAdjustment", "SearchIndexObject", "SearchIndices", "SearchQueryString", "SearchResultObject", "Sec", "Sech", "SechDistribution", "SecondOrderConeOptimization", "SectionGrouping", "SectorChart", "SectorChart3D", "SectorOrigin", "SectorSpacing", "SecuredAuthenticationKey", "SecuredAuthenticationKeys", "SeedRandom", "Select", "Selectable", "SelectComponents", "SelectedCells", "SelectedNotebook", "SelectFirst", "Selection", "SelectionAnimate", "SelectionCell", "SelectionCellCreateCell", "SelectionCellDefaultStyle", "SelectionCellParentStyle", "SelectionCreateCell", "SelectionDebuggerTag", "SelectionDuplicateCell", "SelectionEvaluate", "SelectionEvaluateCreateCell", "SelectionMove", "SelectionPlaceholder", "SelectionSetStyle", "SelectWithContents", "SelfLoops", "SelfLoopStyle", "SemanticImport", "SemanticImportString", "SemanticInterpretation", "SemialgebraicComponentInstances", "SemidefiniteOptimization", "SendMail", "SendMessage", "Sequence", "SequenceAlignment", "SequenceAttentionLayer", "SequenceCases", "SequenceCount", "SequenceFold", "SequenceFoldList", "SequenceForm", "SequenceHold", "SequenceLastLayer", "SequenceMostLayer", "SequencePosition", "SequencePredict", "SequencePredictorFunction", "SequenceReplace", "SequenceRestLayer", "SequenceReverseLayer", "SequenceSplit", "Series", "SeriesCoefficient", "SeriesData", "SeriesTermGoal", "ServiceConnect", "ServiceDisconnect", "ServiceExecute", "ServiceObject", "ServiceRequest", "ServiceResponse", "ServiceSubmit", "SessionSubmit", "SessionTime", "Set", "SetAccuracy", "SetAlphaChannel", "SetAttributes", "Setbacks", "SetBoxFormNamesPacket", "SetCloudDirectory", "SetCookies", "SetDelayed", "SetDirectory", "SetEnvironment", "SetEvaluationNotebook", "SetFileDate", "SetFileLoadingContext", "SetNotebookStatusLine", "SetOptions", "SetOptionsPacket", "SetPermissions", "SetPrecision", "SetProperty", "SetSecuredAuthenticationKey", "SetSelectedNotebook", "SetSharedFunction", "SetSharedVariable", "SetSpeechParametersPacket", "SetStreamPosition", "SetSystemModel", "SetSystemOptions", "Setter", "SetterBar", "SetterBox", "SetterBoxOptions", "Setting", "SetUsers", "SetValue", "Shading", "Shallow", "ShannonWavelet", "ShapiroWilkTest", "Share", "SharingList", "Sharpen", "ShearingMatrix", "ShearingTransform", "ShellRegion", "ShenCastanMatrix", "ShiftedGompertzDistribution", "ShiftRegisterSequence", "Short", "ShortDownArrow", "Shortest", "ShortestMatch", "ShortestPathFunction", "ShortLeftArrow", "ShortRightArrow", "ShortTimeFourier", "ShortTimeFourierData", "ShortUpArrow", "Show", "ShowAutoConvert", "ShowAutoSpellCheck", "ShowAutoStyles", "ShowCellBracket", "ShowCellLabel", "ShowCellTags", "ShowClosedCellArea", "ShowCodeAssist", "ShowContents", "ShowControls", "ShowCursorTracker", "ShowGroupOpenCloseIcon", "ShowGroupOpener", "ShowInvisibleCharacters", "ShowPageBreaks", "ShowPredictiveInterface", "ShowSelection", "ShowShortBoxForm", "ShowSpecialCharacters", "ShowStringCharacters", "ShowSyntaxStyles", "ShrinkingDelay", "ShrinkWrapBoundingBox", "SiderealTime", "SiegelTheta", "SiegelTukeyTest", "SierpinskiCurve", "SierpinskiMesh", "Sign", "Signature", "SignedRankTest", "SignedRegionDistance", "SignificanceLevel", "SignPadding", "SignTest", "SimilarityRules", "SimpleGraph", "SimpleGraphQ", "SimplePolygonQ", "SimplePolyhedronQ", "Simplex", "Simplify", "Sin", "Sinc", "SinghMaddalaDistribution", "SingleEvaluation", "SingleLetterItalics", "SingleLetterStyle", "SingularValueDecomposition", "SingularValueList", "SingularValuePlot", "SingularValues", "Sinh", "SinhIntegral", "SinIntegral", "SixJSymbol", "Skeleton", "SkeletonTransform", "SkellamDistribution", "Skewness", "SkewNormalDistribution", "SkinStyle", "Skip", "SliceContourPlot3D", "SliceDensityPlot3D", "SliceDistribution", "SliceVectorPlot3D", "Slider", "Slider2D", "Slider2DBox", "Slider2DBoxOptions", "SliderBox", "SliderBoxOptions", "SlideView", "Slot", "SlotSequence", "Small", "SmallCircle", "Smaller", "SmithDecomposition", "SmithDelayCompensator", "SmithWatermanSimilarity", "SmoothDensityHistogram", "SmoothHistogram", "SmoothHistogram3D", "SmoothKernelDistribution", "SnDispersion", "Snippet", "SnubPolyhedron", "SocialMediaData", "Socket", "SocketConnect", "SocketListen", "SocketListener", "SocketObject", "SocketOpen", "SocketReadMessage", "SocketReadyQ", "Sockets", "SocketWaitAll", "SocketWaitNext", "SoftmaxLayer", "SokalSneathDissimilarity", "SolarEclipse", "SolarSystemFeatureData", "SolidAngle", "SolidData", "SolidRegionQ", "Solve", "SolveAlways", "SolveDelayed", "Sort", "SortBy", "SortedBy", "SortedEntityClass", "Sound", "SoundAndGraphics", "SoundNote", "SoundVolume", "SourceLink", "Sow", "Space", "SpaceCurveData", "SpaceForm", "Spacer", "Spacings", "Span", "SpanAdjustments", "SpanCharacterRounding", "SpanFromAbove", "SpanFromBoth", "SpanFromLeft", "SpanLineThickness", "SpanMaxSize", "SpanMinSize", "SpanningCharacters", "SpanSymmetric", "SparseArray", "SpatialGraphDistribution", "SpatialMedian", "SpatialTransformationLayer", "Speak", "SpeakerMatchQ", "SpeakTextPacket", "SpearmanRankTest", "SpearmanRho", "SpeciesData", "SpecificityGoal", "SpectralLineData", "Spectrogram", "SpectrogramArray", "Specularity", "SpeechCases", "SpeechInterpreter", "SpeechRecognize", "SpeechSynthesize", "SpellingCorrection", "SpellingCorrectionList", "SpellingDictionaries", "SpellingDictionariesPath", "SpellingOptions", "SpellingSuggestionsPacket", "Sphere", "SphereBox", "SpherePoints", "SphericalBesselJ", "SphericalBesselY", "SphericalHankelH1", "SphericalHankelH2", "SphericalHarmonicY", "SphericalPlot3D", "SphericalRegion", "SphericalShell", "SpheroidalEigenvalue", "SpheroidalJoiningFactor", "SpheroidalPS", "SpheroidalPSPrime", "SpheroidalQS", "SpheroidalQSPrime", "SpheroidalRadialFactor", "SpheroidalS1", "SpheroidalS1Prime", "SpheroidalS2", "SpheroidalS2Prime", "Splice", "SplicedDistribution", "SplineClosed", "SplineDegree", "SplineKnots", "SplineWeights", "Split", "SplitBy", "SpokenString", "Sqrt", "SqrtBox", "SqrtBoxOptions", "Square", "SquaredEuclideanDistance", "SquareFreeQ", "SquareIntersection", "SquareMatrixQ", "SquareRepeatingElement", "SquaresR", "SquareSubset", "SquareSubsetEqual", "SquareSuperset", "SquareSupersetEqual", "SquareUnion", "SquareWave", "SSSTriangle", "StabilityMargins", "StabilityMarginsStyle", "StableDistribution", "Stack", "StackBegin", "StackComplete", "StackedDateListPlot", "StackedListPlot", "StackInhibit", "StadiumShape", "StandardAtmosphereData", "StandardDeviation", "StandardDeviationFilter", "StandardForm", "Standardize", "Standardized", "StandardOceanData", "StandbyDistribution", "Star", "StarClusterData", "StarData", "StarGraph", "StartAsynchronousTask", "StartExternalSession", "StartingStepSize", "StartOfLine", "StartOfString", "StartProcess", "StartScheduledTask", "StartupSound", "StartWebSession", "StateDimensions", "StateFeedbackGains", "StateOutputEstimator", "StateResponse", "StateSpaceModel", "StateSpaceRealization", "StateSpaceTransform", "StateTransformationLinearize", "StationaryDistribution", "StationaryWaveletPacketTransform", "StationaryWaveletTransform", "StatusArea", "StatusCentrality", "StepMonitor", "StereochemistryElements", "StieltjesGamma", "StippleShading", "StirlingS1", "StirlingS2", "StopAsynchronousTask", "StoppingPowerData", "StopScheduledTask", "StrataVariables", "StratonovichProcess", "StreamColorFunction", "StreamColorFunctionScaling", "StreamDensityPlot", "StreamMarkers", "StreamPlot", "StreamPoints", "StreamPosition", "Streams", "StreamScale", "StreamStyle", "String", "StringBreak", "StringByteCount", "StringCases", "StringContainsQ", "StringCount", "StringDelete", "StringDrop", "StringEndsQ", "StringExpression", "StringExtract", "StringForm", "StringFormat", "StringFreeQ", "StringInsert", "StringJoin", "StringLength", "StringMatchQ", "StringPadLeft", "StringPadRight", "StringPart", "StringPartition", "StringPosition", "StringQ", "StringRepeat", "StringReplace", "StringReplaceList", "StringReplacePart", "StringReverse", "StringRiffle", "StringRotateLeft", "StringRotateRight", "StringSkeleton", "StringSplit", "StringStartsQ", "StringTake", "StringTemplate", "StringToByteArray", "StringToStream", "StringTrim", "StripBoxes", "StripOnInput", "StripWrapperBoxes", "StrokeForm", "StructuralImportance", "StructuredArray", "StructuredArrayHeadQ", "StructuredSelection", "StruveH", "StruveL", "Stub", "StudentTDistribution", "Style", "StyleBox", "StyleBoxAutoDelete", "StyleData", "StyleDefinitions", "StyleForm", "StyleHints", "StyleKeyMapping", "StyleMenuListing", "StyleNameDialogSettings", "StyleNames", "StylePrint", "StyleSheetPath", "Subdivide", "Subfactorial", "Subgraph", "SubMinus", "SubPlus", "SubresultantPolynomialRemainders", "SubresultantPolynomials", "Subresultants", "Subscript", "SubscriptBox", "SubscriptBoxOptions", "Subscripted", "Subsequences", "Subset", "SubsetCases", "SubsetCount", "SubsetEqual", "SubsetMap", "SubsetPosition", "SubsetQ", "SubsetReplace", "Subsets", "SubStar", "SubstitutionSystem", "Subsuperscript", "SubsuperscriptBox", "SubsuperscriptBoxOptions", "SubtitleEncoding", "SubtitleTracks", "Subtract", "SubtractFrom", "SubtractSides", "SubValues", "Succeeds", "SucceedsEqual", "SucceedsSlantEqual", "SucceedsTilde", "Success", "SuchThat", "Sum", "SumConvergence", "SummationLayer", "Sunday", "SunPosition", "Sunrise", "Sunset", "SuperDagger", "SuperMinus", "SupernovaData", "SuperPlus", "Superscript", "SuperscriptBox", "SuperscriptBoxOptions", "Superset", "SupersetEqual", "SuperStar", "Surd", "SurdForm", "SurfaceAppearance", "SurfaceArea", "SurfaceColor", "SurfaceData", "SurfaceGraphics", "SurvivalDistribution", "SurvivalFunction", "SurvivalModel", "SurvivalModelFit", "SuspendPacket", "SuzukiDistribution", "SuzukiGroupSuz", "SwatchLegend", "Switch", "Symbol", "SymbolName", "SymletWavelet", "Symmetric", "SymmetricGroup", "SymmetricKey", "SymmetricMatrixQ", "SymmetricPolynomial", "SymmetricReduction", "Symmetrize", "SymmetrizedArray", "SymmetrizedArrayRules", "SymmetrizedDependentComponents", "SymmetrizedIndependentComponents", "SymmetrizedReplacePart", "SynchronousInitialization", "SynchronousUpdating", "Synonyms", "Syntax", "SyntaxForm", "SyntaxInformation", "SyntaxLength", "SyntaxPacket", "SyntaxQ", "SynthesizeMissingValues", "SystemCredential", "SystemCredentialData", "SystemCredentialKey", "SystemCredentialKeys", "SystemCredentialStoreObject", "SystemDialogInput", "SystemException", "SystemGet", "SystemHelpPath", "SystemInformation", "SystemInformationData", "SystemInstall", "SystemModel", "SystemModeler", "SystemModelExamples", "SystemModelLinearize", "SystemModelParametricSimulate", "SystemModelPlot", "SystemModelProgressReporting", "SystemModelReliability", "SystemModels", "SystemModelSimulate", "SystemModelSimulateSensitivity", "SystemModelSimulationData", "SystemOpen", "SystemOptions", "SystemProcessData", "SystemProcesses", "SystemsConnectionsModel", "SystemsModelDelay", "SystemsModelDelayApproximate", "SystemsModelDelete", "SystemsModelDimensions", "SystemsModelExtract", "SystemsModelFeedbackConnect", "SystemsModelLabels", "SystemsModelLinearity", "SystemsModelMerge", "SystemsModelOrder", "SystemsModelParallelConnect", "SystemsModelSeriesConnect", "SystemsModelStateFeedbackConnect", "SystemsModelVectorRelativeOrders", "SystemStub", "SystemTest", "Tab", "TabFilling", "Table", "TableAlignments", "TableDepth", "TableDirections", "TableForm", "TableHeadings", "TableSpacing", "TableView", "TableViewBox", "TableViewBoxBackground", "TableViewBoxItemSize", "TableViewBoxOptions", "TabSpacings", "TabView", "TabViewBox", "TabViewBoxOptions", "TagBox", "TagBoxNote", "TagBoxOptions", "TaggingRules", "TagSet", "TagSetDelayed", "TagStyle", "TagUnset", "Take", "TakeDrop", "TakeLargest", "TakeLargestBy", "TakeList", "TakeSmallest", "TakeSmallestBy", "TakeWhile", "Tally", "Tan", "Tanh", "TargetDevice", "TargetFunctions", "TargetSystem", "TargetUnits", "TaskAbort", "TaskExecute", "TaskObject", "TaskRemove", "TaskResume", "Tasks", "TaskSuspend", "TaskWait", "TautologyQ", "TelegraphProcess", "TemplateApply", "TemplateArgBox", "TemplateBox", "TemplateBoxOptions", "TemplateEvaluate", "TemplateExpression", "TemplateIf", "TemplateObject", "TemplateSequence", "TemplateSlot", "TemplateSlotSequence", "TemplateUnevaluated", "TemplateVerbatim", "TemplateWith", "TemporalData", "TemporalRegularity", "Temporary", "TemporaryVariable", "TensorContract", "TensorDimensions", "TensorExpand", "TensorProduct", "TensorQ", "TensorRank", "TensorReduce", "TensorSymmetry", "TensorTranspose", "TensorWedge", "TestID", "TestReport", "TestReportObject", "TestResultObject", "Tetrahedron", "TetrahedronBox", "TetrahedronBoxOptions", "TeXForm", "TeXSave", "Text", "Text3DBox", "Text3DBoxOptions", "TextAlignment", "TextBand", "TextBoundingBox", "TextBox", "TextCases", "TextCell", "TextClipboardType", "TextContents", "TextData", "TextElement", "TextForm", "TextGrid", "TextJustification", "TextLine", "TextPacket", "TextParagraph", "TextPosition", "TextRecognize", "TextSearch", "TextSearchReport", "TextSentences", "TextString", "TextStructure", "TextStyle", "TextTranslation", "Texture", "TextureCoordinateFunction", "TextureCoordinateScaling", "TextWords", "Therefore", "ThermodynamicData", "ThermometerGauge", "Thick", "Thickness", "Thin", "Thinning", "ThisLink", "ThompsonGroupTh", "Thread", "ThreadingLayer", "ThreeJSymbol", "Threshold", "Through", "Throw", "ThueMorse", "Thumbnail", "Thursday", "Ticks", "TicksStyle", "TideData", "Tilde", "TildeEqual", "TildeFullEqual", "TildeTilde", "TimeConstrained", "TimeConstraint", "TimeDirection", "TimeFormat", "TimeGoal", "TimelinePlot", "TimeObject", "TimeObjectQ", "TimeRemaining", "Times", "TimesBy", "TimeSeries", "TimeSeriesAggregate", "TimeSeriesForecast", "TimeSeriesInsert", "TimeSeriesInvertibility", "TimeSeriesMap", "TimeSeriesMapThread", "TimeSeriesModel", "TimeSeriesModelFit", "TimeSeriesResample", "TimeSeriesRescale", "TimeSeriesShift", "TimeSeriesThread", "TimeSeriesWindow", "TimeUsed", "TimeValue", "TimeWarpingCorrespondence", "TimeWarpingDistance", "TimeZone", "TimeZoneConvert", "TimeZoneOffset", "Timing", "Tiny", "TitleGrouping", "TitsGroupT", "ToBoxes", "ToCharacterCode", "ToColor", "ToContinuousTimeModel", "ToDate", "Today", "ToDiscreteTimeModel", "ToEntity", "ToeplitzMatrix", "ToExpression", "ToFileName", "Together", "Toggle", "ToggleFalse", "Toggler", "TogglerBar", "TogglerBox", "TogglerBoxOptions", "ToHeldExpression", "ToInvertibleTimeSeries", "TokenWords", "Tolerance", "ToLowerCase", "Tomorrow", "ToNumberField", "TooBig", "Tooltip", "TooltipBox", "TooltipBoxOptions", "TooltipDelay", "TooltipStyle", "ToonShading", "Top", "TopHatTransform", "ToPolarCoordinates", "TopologicalSort", "ToRadicals", "ToRules", "ToSphericalCoordinates", "ToString", "Total", "TotalHeight", "TotalLayer", "TotalVariationFilter", "TotalWidth", "TouchPosition", "TouchscreenAutoZoom", "TouchscreenControlPlacement", "ToUpperCase", "Tr", "Trace", "TraceAbove", "TraceAction", "TraceBackward", "TraceDepth", "TraceDialog", "TraceForward", "TraceInternal", "TraceLevel", "TraceOff", "TraceOn", "TraceOriginal", "TracePrint", "TraceScan", "TrackedSymbols", "TrackingFunction", "TracyWidomDistribution", "TradingChart", "TraditionalForm", "TraditionalFunctionNotation", "TraditionalNotation", "TraditionalOrder", "TrainingProgressCheckpointing", "TrainingProgressFunction", "TrainingProgressMeasurements", "TrainingProgressReporting", "TrainingStoppingCriterion", "TrainingUpdateSchedule", "TransferFunctionCancel", "TransferFunctionExpand", "TransferFunctionFactor", "TransferFunctionModel", "TransferFunctionPoles", "TransferFunctionTransform", "TransferFunctionZeros", "TransformationClass", "TransformationFunction", "TransformationFunctions", "TransformationMatrix", "TransformedDistribution", "TransformedField", "TransformedProcess", "TransformedRegion", "TransitionDirection", "TransitionDuration", "TransitionEffect", "TransitiveClosureGraph", "TransitiveReductionGraph", "Translate", "TranslationOptions", "TranslationTransform", "Transliterate", "Transparent", "TransparentColor", "Transpose", "TransposeLayer", "TrapSelection", "TravelDirections", "TravelDirectionsData", "TravelDistance", "TravelDistanceList", "TravelMethod", "TravelTime", "TreeForm", "TreeGraph", "TreeGraphQ", "TreePlot", "TrendStyle", "Triangle", "TriangleCenter", "TriangleConstruct", "TriangleMeasurement", "TriangleWave", "TriangularDistribution", "TriangulateMesh", "Trig", "TrigExpand", "TrigFactor", "TrigFactorList", "Trigger", "TrigReduce", "TrigToExp", "TrimmedMean", "TrimmedVariance", "TropicalStormData", "True", "TrueQ", "TruncatedDistribution", "TruncatedPolyhedron", "TsallisQExponentialDistribution", "TsallisQGaussianDistribution", "TTest", "Tube", "TubeBezierCurveBox", "TubeBezierCurveBoxOptions", "TubeBox", "TubeBoxOptions", "TubeBSplineCurveBox", "TubeBSplineCurveBoxOptions", "Tuesday", "TukeyLambdaDistribution", "TukeyWindow", "TunnelData", "Tuples", "TuranGraph", "TuringMachine", "TuttePolynomial", "TwoWayRule", "Typed", "TypeSpecifier", "UnateQ", "Uncompress", "UnconstrainedParameters", "Undefined", "UnderBar", "Underflow", "Underlined", "Underoverscript", "UnderoverscriptBox", "UnderoverscriptBoxOptions", "Underscript", "UnderscriptBox", "UnderscriptBoxOptions", "UnderseaFeatureData", "UndirectedEdge", "UndirectedGraph", "UndirectedGraphQ", "UndoOptions", "UndoTrackedVariables", "Unequal", "UnequalTo", "Unevaluated", "UniformDistribution", "UniformGraphDistribution", "UniformPolyhedron", "UniformSumDistribution", "Uninstall", "Union", "UnionedEntityClass", "UnionPlus", "Unique", "UnitaryMatrixQ", "UnitBox", "UnitConvert", "UnitDimensions", "Unitize", "UnitRootTest", "UnitSimplify", "UnitStep", "UnitSystem", "UnitTriangle", "UnitVector", "UnitVectorLayer", "UnityDimensions", "UniverseModelData", "UniversityData", "UnixTime", "Unprotect", "UnregisterExternalEvaluator", "UnsameQ", "UnsavedVariables", "Unset", "UnsetShared", "UntrackedVariables", "Up", "UpArrow", "UpArrowBar", "UpArrowDownArrow", "Update", "UpdateDynamicObjects", "UpdateDynamicObjectsSynchronous", "UpdateInterval", "UpdatePacletSites", "UpdateSearchIndex", "UpDownArrow", "UpEquilibrium", "UpperCaseQ", "UpperLeftArrow", "UpperRightArrow", "UpperTriangularize", "UpperTriangularMatrixQ", "Upsample", "UpSet", "UpSetDelayed", "UpTee", "UpTeeArrow", "UpTo", "UpValues", "URL", "URLBuild", "URLDecode", "URLDispatcher", "URLDownload", "URLDownloadSubmit", "URLEncode", "URLExecute", "URLExpand", "URLFetch", "URLFetchAsynchronous", "URLParse", "URLQueryDecode", "URLQueryEncode", "URLRead", "URLResponseTime", "URLSave", "URLSaveAsynchronous", "URLShorten", "URLSubmit", "UseGraphicsRange", "UserDefinedWavelet", "Using", "UsingFrontEnd", "UtilityFunction", "V2Get", "ValenceErrorHandling", "ValidationLength", "ValidationSet", "Value", "ValueBox", "ValueBoxOptions", "ValueDimensions", "ValueForm", "ValuePreprocessingFunction", "ValueQ", "Values", "ValuesData", "Variables", "Variance", "VarianceEquivalenceTest", "VarianceEstimatorFunction", "VarianceGammaDistribution", "VarianceTest", "VectorAngle", "VectorAround", "VectorAspectRatio", "VectorColorFunction", "VectorColorFunctionScaling", "VectorDensityPlot", "VectorGlyphData", "VectorGreater", "VectorGreaterEqual", "VectorLess", "VectorLessEqual", "VectorMarkers", "VectorPlot", "VectorPlot3D", "VectorPoints", "VectorQ", "VectorRange", "Vectors", "VectorScale", "VectorScaling", "VectorSizes", "VectorStyle", "Vee", "Verbatim", "Verbose", "VerboseConvertToPostScriptPacket", "VerificationTest", "VerifyConvergence", "VerifyDerivedKey", "VerifyDigitalSignature", "VerifyFileSignature", "VerifyInterpretation", "VerifySecurityCertificates", "VerifySolutions", "VerifyTestAssumptions", "Version", "VersionedPreferences", "VersionNumber", "VertexAdd", "VertexCapacity", "VertexColors", "VertexComponent", "VertexConnectivity", "VertexContract", "VertexCoordinateRules", "VertexCoordinates", "VertexCorrelationSimilarity", "VertexCosineSimilarity", "VertexCount", "VertexCoverQ", "VertexDataCoordinates", "VertexDegree", "VertexDelete", "VertexDiceSimilarity", "VertexEccentricity", "VertexInComponent", "VertexInDegree", "VertexIndex", "VertexJaccardSimilarity", "VertexLabeling", "VertexLabels", "VertexLabelStyle", "VertexList", "VertexNormals", "VertexOutComponent", "VertexOutDegree", "VertexQ", "VertexRenderingFunction", "VertexReplace", "VertexShape", "VertexShapeFunction", "VertexSize", "VertexStyle", "VertexTextureCoordinates", "VertexWeight", "VertexWeightedGraphQ", "Vertical", "VerticalBar", "VerticalForm", "VerticalGauge", "VerticalSeparator", "VerticalSlider", "VerticalTilde", "Video", "VideoEncoding", "VideoExtractFrames", "VideoFrameList", "VideoFrameMap", "VideoPause", "VideoPlay", "VideoQ", "VideoStop", "VideoStream", "VideoStreams", "VideoTimeSeries", "VideoTracks", "VideoTrim", "ViewAngle", "ViewCenter", "ViewMatrix", "ViewPoint", "ViewPointSelectorSettings", "ViewPort", "ViewProjection", "ViewRange", "ViewVector", "ViewVertical", "VirtualGroupData", "Visible", "VisibleCell", "VoiceStyleData", "VoigtDistribution", "VolcanoData", "Volume", "VonMisesDistribution", "VoronoiMesh", "WaitAll", "WaitAsynchronousTask", "WaitNext", "WaitUntil", "WakebyDistribution", "WalleniusHypergeometricDistribution", "WaringYuleDistribution", "WarpingCorrespondence", "WarpingDistance", "WatershedComponents", "WatsonUSquareTest", "WattsStrogatzGraphDistribution", "WaveletBestBasis", "WaveletFilterCoefficients", "WaveletImagePlot", "WaveletListPlot", "WaveletMapIndexed", "WaveletMatrixPlot", "WaveletPhi", "WaveletPsi", "WaveletScale", "WaveletScalogram", "WaveletThreshold", "WeaklyConnectedComponents", "WeaklyConnectedGraphComponents", "WeaklyConnectedGraphQ", "WeakStationarity", "WeatherData", "WeatherForecastData", "WebAudioSearch", "WebElementObject", "WeberE", "WebExecute", "WebImage", "WebImageSearch", "WebSearch", "WebSessionObject", "WebSessions", "WebWindowObject", "Wedge", "Wednesday", "WeibullDistribution", "WeierstrassE1", "WeierstrassE2", "WeierstrassE3", "WeierstrassEta1", "WeierstrassEta2", "WeierstrassEta3", "WeierstrassHalfPeriods", "WeierstrassHalfPeriodW1", "WeierstrassHalfPeriodW2", "WeierstrassHalfPeriodW3", "WeierstrassInvariantG2", "WeierstrassInvariantG3", "WeierstrassInvariants", "WeierstrassP", "WeierstrassPPrime", "WeierstrassSigma", "WeierstrassZeta", "WeightedAdjacencyGraph", "WeightedAdjacencyMatrix", "WeightedData", "WeightedGraphQ", "Weights", "WelchWindow", "WheelGraph", "WhenEvent", "Which", "While", "White", "WhiteNoiseProcess", "WhitePoint", "Whitespace", "WhitespaceCharacter", "WhittakerM", "WhittakerW", "WienerFilter", "WienerProcess", "WignerD", "WignerSemicircleDistribution", "WikidataData", "WikidataSearch", "WikipediaData", "WikipediaSearch", "WilksW", "WilksWTest", "WindDirectionData", "WindingCount", "WindingPolygon", "WindowClickSelect", "WindowElements", "WindowFloating", "WindowFrame", "WindowFrameElements", "WindowMargins", "WindowMovable", "WindowOpacity", "WindowPersistentStyles", "WindowSelected", "WindowSize", "WindowStatusArea", "WindowTitle", "WindowToolbars", "WindowWidth", "WindSpeedData", "WindVectorData", "WinsorizedMean", "WinsorizedVariance", "WishartMatrixDistribution", "With", "WolframAlpha", "WolframAlphaDate", "WolframAlphaQuantity", "WolframAlphaResult", "WolframLanguageData", "Word", "WordBoundary", "WordCharacter", "WordCloud", "WordCount", "WordCounts", "WordData", "WordDefinition", "WordFrequency", "WordFrequencyData", "WordList", "WordOrientation", "WordSearch", "WordSelectionFunction", "WordSeparators", "WordSpacings", "WordStem", "WordTranslation", "WorkingPrecision", "WrapAround", "Write", "WriteLine", "WriteString", "Wronskian", "XMLElement", "XMLObject", "XMLTemplate", "Xnor", "Xor", "XYZColor", "Yellow", "Yesterday", "YuleDissimilarity", "ZernikeR", "ZeroSymmetric", "ZeroTest", "ZeroWidthTimes", "Zeta", "ZetaZero", "ZIPCodeData", "ZipfDistribution", "ZoomCenter", "ZoomFactor", "ZTest", "ZTransform", "$Aborted", "$ActivationGroupID", "$ActivationKey", "$ActivationUserRegistered", "$AddOnsDirectory", "$AllowDataUpdates", "$AllowExternalChannelFunctions", "$AllowInternet", "$AssertFunction", "$Assumptions", "$AsynchronousTask", "$AudioDecoders", "$AudioEncoders", "$AudioInputDevices", "$AudioOutputDevices", "$BaseDirectory", "$BasePacletsDirectory", "$BatchInput", "$BatchOutput", "$BlockchainBase", "$BoxForms", "$ByteOrdering", "$CacheBaseDirectory", "$Canceled", "$ChannelBase", "$CharacterEncoding", "$CharacterEncodings", "$CloudAccountName", "$CloudBase", "$CloudConnected", "$CloudConnection", "$CloudCreditsAvailable", "$CloudEvaluation", "$CloudExpressionBase", "$CloudObjectNameFormat", "$CloudObjectURLType", "$CloudRootDirectory", "$CloudSymbolBase", "$CloudUserID", "$CloudUserUUID", "$CloudVersion", "$CloudVersionNumber", "$CloudWolframEngineVersionNumber", "$CommandLine", "$CompilationTarget", "$ConditionHold", "$ConfiguredKernels", "$Context", "$ContextPath", "$ControlActiveSetting", "$Cookies", "$CookieStore", "$CreationDate", "$CurrentLink", "$CurrentTask", "$CurrentWebSession", "$DataStructures", "$DateStringFormat", "$DefaultAudioInputDevice", "$DefaultAudioOutputDevice", "$DefaultFont", "$DefaultFrontEnd", "$DefaultImagingDevice", "$DefaultLocalBase", "$DefaultMailbox", "$DefaultNetworkInterface", "$DefaultPath", "$DefaultProxyRules", "$DefaultSystemCredentialStore", "$Display", "$DisplayFunction", "$DistributedContexts", "$DynamicEvaluation", "$Echo", "$EmbedCodeEnvironments", "$EmbeddableServices", "$EntityStores", "$Epilog", "$EvaluationCloudBase", "$EvaluationCloudObject", "$EvaluationEnvironment", "$ExportFormats", "$ExternalIdentifierTypes", "$ExternalStorageBase", "$Failed", "$FinancialDataSource", "$FontFamilies", "$FormatType", "$FrontEnd", "$FrontEndSession", "$GeoEntityTypes", "$GeoLocation", "$GeoLocationCity", "$GeoLocationCountry", "$GeoLocationPrecision", "$GeoLocationSource", "$HistoryLength", "$HomeDirectory", "$HTMLExportRules", "$HTTPCookies", "$HTTPRequest", "$IgnoreEOF", "$ImageFormattingWidth", "$ImageResolution", "$ImagingDevice", "$ImagingDevices", "$ImportFormats", "$IncomingMailSettings", "$InitialDirectory", "$Initialization", "$InitializationContexts", "$Input", "$InputFileName", "$InputStreamMethods", "$Inspector", "$InstallationDate", "$InstallationDirectory", "$InterfaceEnvironment", "$InterpreterTypes", "$IterationLimit", "$KernelCount", "$KernelID", "$Language", "$LaunchDirectory", "$LibraryPath", "$LicenseExpirationDate", "$LicenseID", "$LicenseProcesses", "$LicenseServer", "$LicenseSubprocesses", "$LicenseType", "$Line", "$Linked", "$LinkSupported", "$LoadedFiles", "$LocalBase", "$LocalSymbolBase", "$MachineAddresses", "$MachineDomain", "$MachineDomains", "$MachineEpsilon", "$MachineID", "$MachineName", "$MachinePrecision", "$MachineType", "$MaxExtraPrecision", "$MaxLicenseProcesses", "$MaxLicenseSubprocesses", "$MaxMachineNumber", "$MaxNumber", "$MaxPiecewiseCases", "$MaxPrecision", "$MaxRootDegree", "$MessageGroups", "$MessageList", "$MessagePrePrint", "$Messages", "$MinMachineNumber", "$MinNumber", "$MinorReleaseNumber", "$MinPrecision", "$MobilePhone", "$ModuleNumber", "$NetworkConnected", "$NetworkInterfaces", "$NetworkLicense", "$NewMessage", "$NewSymbol", "$NotebookInlineStorageLimit", "$Notebooks", "$NoValue", "$NumberMarks", "$Off", "$OperatingSystem", "$Output", "$OutputForms", "$OutputSizeLimit", "$OutputStreamMethods", "$Packages", "$ParentLink", "$ParentProcessID", "$PasswordFile", "$PatchLevelID", "$Path", "$PathnameSeparator", "$PerformanceGoal", "$Permissions", "$PermissionsGroupBase", "$PersistenceBase", "$PersistencePath", "$PipeSupported", "$PlotTheme", "$Post", "$Pre", "$PreferencesDirectory", "$PreInitialization", "$PrePrint", "$PreRead", "$PrintForms", "$PrintLiteral", "$Printout3DPreviewer", "$ProcessID", "$ProcessorCount", "$ProcessorType", "$ProductInformation", "$ProgramName", "$PublisherID", "$RandomState", "$RecursionLimit", "$RegisteredDeviceClasses", "$RegisteredUserName", "$ReleaseNumber", "$RequesterAddress", "$RequesterWolframID", "$RequesterWolframUUID", "$RootDirectory", "$ScheduledTask", "$ScriptCommandLine", "$ScriptInputString", "$SecuredAuthenticationKeyTokens", "$ServiceCreditsAvailable", "$Services", "$SessionID", "$SetParentLink", "$SharedFunctions", "$SharedVariables", "$SoundDisplay", "$SoundDisplayFunction", "$SourceLink", "$SSHAuthentication", "$SubtitleDecoders", "$SubtitleEncoders", "$SummaryBoxDataSizeLimit", "$SuppressInputFormHeads", "$SynchronousEvaluation", "$SyntaxHandler", "$System", "$SystemCharacterEncoding", "$SystemCredentialStore", "$SystemID", "$SystemMemory", "$SystemShell", "$SystemTimeZone", "$SystemWordLength", "$TemplatePath", "$TemporaryDirectory", "$TemporaryPrefix", "$TestFileName", "$TextStyle", "$TimedOut", "$TimeUnit", "$TimeZone", "$TimeZoneEntity", "$TopDirectory", "$TraceOff", "$TraceOn", "$TracePattern", "$TracePostAction", "$TracePreAction", "$UnitSystem", "$Urgent", "$UserAddOnsDirectory", "$UserAgentLanguages", "$UserAgentMachine", "$UserAgentName", "$UserAgentOperatingSystem", "$UserAgentString", "$UserAgentVersion", "$UserBaseDirectory", "$UserBasePacletsDirectory", "$UserDocumentsDirectory", "$Username", "$UserName", "$UserURLBase", "$Version", "$VersionNumber", "$VideoDecoders", "$VideoEncoders", "$VoiceStyles", "$WolframDocumentsDirectory", "$WolframID", "$WolframUUID"];

/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function optional(re) {
  return concat('(', re, ')?');
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */
function either() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var joined = '(' + args.map(function (x) {
    return source(x);
  }).join("|") + ")";
  return joined;
}

/*
Language: Wolfram Language
Description: The Wolfram Language is the programming language used in Wolfram Mathematica, a modern technical computing system spanning most areas of technical computing.
Authors: Patrick Scheibe <patrick@halirutan.de>, Robert Jacobson <robertjacobson@acm.org>
Website: https://www.wolfram.com/mathematica/
Category: scientific
*/

/** @type LanguageFn */
function mathematica(hljs) {
  /*
  This rather scary looking matching of Mathematica numbers is carefully explained by Robert Jacobson here:
  https://wltools.github.io/LanguageSpec/Specification/Syntax/Number-representations/
   */
  var BASE_RE = /([2-9]|[1-2]\d|[3][0-5])\^\^/;
  var BASE_DIGITS_RE = /(\w*\.\w+|\w+\.\w*|\w+)/;
  var NUMBER_RE = /(\d*\.\d+|\d+\.\d*|\d+)/;
  var BASE_NUMBER_RE = either(concat(BASE_RE, BASE_DIGITS_RE), NUMBER_RE);
  var ACCURACY_RE = /``[+-]?(\d*\.\d+|\d+\.\d*|\d+)/;
  var PRECISION_RE = /`([+-]?(\d*\.\d+|\d+\.\d*|\d+))?/;
  var APPROXIMATE_NUMBER_RE = either(ACCURACY_RE, PRECISION_RE);
  var SCIENTIFIC_NOTATION_RE = /\*\^[+-]?\d+/;
  var MATHEMATICA_NUMBER_RE = concat(BASE_NUMBER_RE, optional(APPROXIMATE_NUMBER_RE), optional(SCIENTIFIC_NOTATION_RE));
  var NUMBERS = {
    className: 'number',
    relevance: 0,
    begin: MATHEMATICA_NUMBER_RE
  };
  var SYMBOL_RE = /[a-zA-Z$][a-zA-Z0-9$]*/;
  var SYSTEM_SYMBOLS_SET = new Set(SYSTEM_SYMBOLS);
  /** @type {Mode} */
  var SYMBOLS = {
    variants: [{
      className: 'builtin-symbol',
      begin: SYMBOL_RE,
      // for performance out of fear of regex.either(...Mathematica.SYSTEM_SYMBOLS)
      "on:begin": function onBegin(match, response) {
        if (!SYSTEM_SYMBOLS_SET.has(match[0])) response.ignoreMatch();
      }
    }, {
      className: 'symbol',
      relevance: 0,
      begin: SYMBOL_RE
    }]
  };
  var NAMED_CHARACTER = {
    className: 'named-character',
    begin: /\\\[[$a-zA-Z][$a-zA-Z0-9]+\]/
  };
  var OPERATORS = {
    className: 'operator',
    relevance: 0,
    begin: /[+\-*/,;.:@~=><&|_`'^?!%]+/
  };
  var PATTERNS = {
    className: 'pattern',
    relevance: 0,
    begin: /([a-zA-Z$][a-zA-Z0-9$]*)?_+([a-zA-Z$][a-zA-Z0-9$]*)?/
  };
  var SLOTS = {
    className: 'slot',
    relevance: 0,
    begin: /#[a-zA-Z$][a-zA-Z0-9$]*|#+[0-9]?/
  };
  var BRACES = {
    className: 'brace',
    relevance: 0,
    begin: /[[\](){}]/
  };
  var MESSAGES = {
    className: 'message-name',
    relevance: 0,
    begin: concat("::", SYMBOL_RE)
  };
  return {
    name: 'Mathematica',
    aliases: ['mma', 'wl'],
    classNameAliases: {
      brace: 'punctuation',
      pattern: 'type',
      slot: 'type',
      symbol: 'variable',
      'named-character': 'variable',
      'builtin-symbol': 'built_in',
      'message-name': 'string'
    },
    contains: [hljs.COMMENT(/\(\*/, /\*\)/, {
      contains: ['self']
    }), PATTERNS, SLOTS, MESSAGES, SYMBOLS, NAMED_CHARACTER, hljs.QUOTE_STRING_MODE, NUMBERS, OPERATORS, BRACES]
  };
}
module.exports = mathematica;

/***/ }),

/***/ 49124:
/***/ ((module) => {

/*
Language: Matlab
Author: Denis Bardadym <bardadymchik@gmail.com>
Contributors: Eugene Nizhibitsky <nizhibitsky@ya.ru>, Egor Rogov <e.rogov@postgrespro.ru>
Website: https://www.mathworks.com/products/matlab.html
Category: scientific
*/

/*
  Formal syntax is not published, helpful link:
  https://github.com/kornilova-l/matlab-IntelliJ-plugin/blob/master/src/main/grammar/Matlab.bnf
*/
function matlab(hljs) {
  var TRANSPOSE_RE = '(\'|\\.\')+';
  var TRANSPOSE = {
    relevance: 0,
    contains: [{
      begin: TRANSPOSE_RE
    }]
  };
  return {
    name: 'Matlab',
    keywords: {
      keyword: 'arguments break case catch classdef continue else elseif end enumeration events for function ' + 'global if methods otherwise parfor persistent properties return spmd switch try while',
      built_in: 'sin sind sinh asin asind asinh cos cosd cosh acos acosd acosh tan tand tanh atan ' + 'atand atan2 atanh sec secd sech asec asecd asech csc cscd csch acsc acscd acsch cot ' + 'cotd coth acot acotd acoth hypot exp expm1 log log1p log10 log2 pow2 realpow reallog ' + 'realsqrt sqrt nthroot nextpow2 abs angle complex conj imag real unwrap isreal ' + 'cplxpair fix floor ceil round mod rem sign airy besselj bessely besselh besseli ' + 'besselk beta betainc betaln ellipj ellipke erf erfc erfcx erfinv expint gamma ' + 'gammainc gammaln psi legendre cross dot factor isprime primes gcd lcm rat rats perms ' + 'nchoosek factorial cart2sph cart2pol pol2cart sph2cart hsv2rgb rgb2hsv zeros ones ' + 'eye repmat rand randn linspace logspace freqspace meshgrid accumarray size length ' + 'ndims numel disp isempty isequal isequalwithequalnans cat reshape diag blkdiag tril ' + 'triu fliplr flipud flipdim rot90 find sub2ind ind2sub bsxfun ndgrid permute ipermute ' + 'shiftdim circshift squeeze isscalar isvector ans eps realmax realmin pi i|0 inf nan ' + 'isnan isinf isfinite j|0 why compan gallery hadamard hankel hilb invhilb magic pascal ' + 'rosser toeplitz vander wilkinson max min nanmax nanmin mean nanmean type table ' + 'readtable writetable sortrows sort figure plot plot3 scatter scatter3 cellfun ' + 'legend intersect ismember procrustes hold num2cell '
    },
    illegal: '(//|"|#|/\\*|\\s+/\\w+)',
    contains: [{
      className: 'function',
      beginKeywords: 'function',
      end: '$',
      contains: [hljs.UNDERSCORE_TITLE_MODE, {
        className: 'params',
        variants: [{
          begin: '\\(',
          end: '\\)'
        }, {
          begin: '\\[',
          end: '\\]'
        }]
      }]
    }, {
      className: 'built_in',
      begin: /true|false/,
      relevance: 0,
      starts: TRANSPOSE
    }, {
      begin: '[a-zA-Z][a-zA-Z_0-9]*' + TRANSPOSE_RE,
      relevance: 0
    }, {
      className: 'number',
      begin: hljs.C_NUMBER_RE,
      relevance: 0,
      starts: TRANSPOSE
    }, {
      className: 'string',
      begin: '\'',
      end: '\'',
      contains: [hljs.BACKSLASH_ESCAPE, {
        begin: '\'\''
      }]
    }, {
      begin: /\]|\}|\)/,
      relevance: 0,
      starts: TRANSPOSE
    }, {
      className: 'string',
      begin: '"',
      end: '"',
      contains: [hljs.BACKSLASH_ESCAPE, {
        begin: '""'
      }],
      starts: TRANSPOSE
    }, hljs.COMMENT('^\\s*%\\{\\s*$', '^\\s*%\\}\\s*$'), hljs.COMMENT('%', '$')]
  };
}
module.exports = matlab;

/***/ }),

/***/ 50237:
/***/ ((module) => {

/*
Language: Maxima
Author: Robert Dodier <robert.dodier@gmail.com>
Website: http://maxima.sourceforge.net
Category: scientific
*/

function maxima(hljs) {
  var KEYWORDS = 'if then else elseif for thru do while unless step in and or not';
  var LITERALS = 'true false unknown inf minf ind und %e %i %pi %phi %gamma';
  var BUILTIN_FUNCTIONS = ' abasep abs absint absolute_real_time acos acosh acot acoth acsc acsch activate' + ' addcol add_edge add_edges addmatrices addrow add_vertex add_vertices adjacency_matrix' + ' adjoin adjoint af agd airy airy_ai airy_bi airy_dai airy_dbi algsys alg_type' + ' alias allroots alphacharp alphanumericp amortization %and annuity_fv' + ' annuity_pv antid antidiff AntiDifference append appendfile apply apply1 apply2' + ' applyb1 apropos args arit_amortization arithmetic arithsum array arrayapply' + ' arrayinfo arraymake arraysetapply ascii asec asech asin asinh askinteger' + ' asksign assoc assoc_legendre_p assoc_legendre_q assume assume_external_byte_order' + ' asympa at atan atan2 atanh atensimp atom atvalue augcoefmatrix augmented_lagrangian_method' + ' av average_degree backtrace bars barsplot barsplot_description base64 base64_decode' + ' bashindices batch batchload bc2 bdvac belln benefit_cost bern bernpoly bernstein_approx' + ' bernstein_expand bernstein_poly bessel bessel_i bessel_j bessel_k bessel_simplify' + ' bessel_y beta beta_incomplete beta_incomplete_generalized beta_incomplete_regularized' + ' bezout bfallroots bffac bf_find_root bf_fmin_cobyla bfhzeta bfloat bfloatp' + ' bfpsi bfpsi0 bfzeta biconnected_components bimetric binomial bipartition' + ' block blockmatrixp bode_gain bode_phase bothcoef box boxplot boxplot_description' + ' break bug_report build_info|10 buildq build_sample burn cabs canform canten' + ' cardinality carg cartan cartesian_product catch cauchy_matrix cbffac cdf_bernoulli' + ' cdf_beta cdf_binomial cdf_cauchy cdf_chi2 cdf_continuous_uniform cdf_discrete_uniform' + ' cdf_exp cdf_f cdf_gamma cdf_general_finite_discrete cdf_geometric cdf_gumbel' + ' cdf_hypergeometric cdf_laplace cdf_logistic cdf_lognormal cdf_negative_binomial' + ' cdf_noncentral_chi2 cdf_noncentral_student_t cdf_normal cdf_pareto cdf_poisson' + ' cdf_rank_sum cdf_rayleigh cdf_signed_rank cdf_student_t cdf_weibull cdisplay' + ' ceiling central_moment cequal cequalignore cf cfdisrep cfexpand cgeodesic' + ' cgreaterp cgreaterpignore changename changevar chaosgame charat charfun charfun2' + ' charlist charp charpoly chdir chebyshev_t chebyshev_u checkdiv check_overlaps' + ' chinese cholesky christof chromatic_index chromatic_number cint circulant_graph' + ' clear_edge_weight clear_rules clear_vertex_label clebsch_gordan clebsch_graph' + ' clessp clesspignore close closefile cmetric coeff coefmatrix cograd col collapse' + ' collectterms columnop columnspace columnswap columnvector combination combine' + ' comp2pui compare compfile compile compile_file complement_graph complete_bipartite_graph' + ' complete_graph complex_number_p components compose_functions concan concat' + ' conjugate conmetderiv connected_components connect_vertices cons constant' + ' constantp constituent constvalue cont2part content continuous_freq contortion' + ' contour_plot contract contract_edge contragrad contrib_ode convert coord' + ' copy copy_file copy_graph copylist copymatrix cor cos cosh cot coth cov cov1' + ' covdiff covect covers crc24sum create_graph create_list csc csch csetup cspline' + ' ctaylor ct_coordsys ctransform ctranspose cube_graph cuboctahedron_graph' + ' cunlisp cv cycle_digraph cycle_graph cylindrical days360 dblint deactivate' + ' declare declare_constvalue declare_dimensions declare_fundamental_dimensions' + ' declare_fundamental_units declare_qty declare_translated declare_unit_conversion' + ' declare_units declare_weights decsym defcon define define_alt_display define_variable' + ' defint defmatch defrule defstruct deftaylor degree_sequence del delete deleten' + ' delta demo demoivre denom depends derivdegree derivlist describe desolve' + ' determinant dfloat dgauss_a dgauss_b dgeev dgemm dgeqrf dgesv dgesvd diag' + ' diagmatrix diag_matrix diagmatrixp diameter diff digitcharp dimacs_export' + ' dimacs_import dimension dimensionless dimensions dimensions_as_list direct' + ' directory discrete_freq disjoin disjointp disolate disp dispcon dispform' + ' dispfun dispJordan display disprule dispterms distrib divide divisors divsum' + ' dkummer_m dkummer_u dlange dodecahedron_graph dotproduct dotsimp dpart' + ' draw draw2d draw3d drawdf draw_file draw_graph dscalar echelon edge_coloring' + ' edge_connectivity edges eigens_by_jacobi eigenvalues eigenvectors eighth' + ' einstein eivals eivects elapsed_real_time elapsed_run_time ele2comp ele2polynome' + ' ele2pui elem elementp elevation_grid elim elim_allbut eliminate eliminate_using' + ' ellipse elliptic_e elliptic_ec elliptic_eu elliptic_f elliptic_kc elliptic_pi' + ' ematrix empty_graph emptyp endcons entermatrix entertensor entier equal equalp' + ' equiv_classes erf erfc erf_generalized erfi errcatch error errormsg errors' + ' euler ev eval_string evenp every evolution evolution2d evundiff example exp' + ' expand expandwrt expandwrt_factored expint expintegral_chi expintegral_ci' + ' expintegral_e expintegral_e1 expintegral_ei expintegral_e_simplify expintegral_li' + ' expintegral_shi expintegral_si explicit explose exponentialize express expt' + ' exsec extdiff extract_linear_equations extremal_subset ezgcd %f f90 facsum' + ' factcomb factor factorfacsum factorial factorout factorsum facts fast_central_elements' + ' fast_linsolve fasttimes featurep fernfale fft fib fibtophi fifth filename_merge' + ' file_search file_type fillarray findde find_root find_root_abs find_root_error' + ' find_root_rel first fix flatten flength float floatnump floor flower_snark' + ' flush flush1deriv flushd flushnd flush_output fmin_cobyla forget fortran' + ' fourcos fourexpand fourier fourier_elim fourint fourintcos fourintsin foursimp' + ' foursin fourth fposition frame_bracket freeof freshline fresnel_c fresnel_s' + ' from_adjacency_matrix frucht_graph full_listify fullmap fullmapl fullratsimp' + ' fullratsubst fullsetify funcsolve fundamental_dimensions fundamental_units' + ' fundef funmake funp fv g0 g1 gamma gamma_greek gamma_incomplete gamma_incomplete_generalized' + ' gamma_incomplete_regularized gauss gauss_a gauss_b gaussprob gcd gcdex gcdivide' + ' gcfac gcfactor gd generalized_lambert_w genfact gen_laguerre genmatrix gensym' + ' geo_amortization geo_annuity_fv geo_annuity_pv geomap geometric geometric_mean' + ' geosum get getcurrentdirectory get_edge_weight getenv get_lu_factors get_output_stream_string' + ' get_pixel get_plot_option get_tex_environment get_tex_environment_default' + ' get_vertex_label gfactor gfactorsum ggf girth global_variances gn gnuplot_close' + ' gnuplot_replot gnuplot_reset gnuplot_restart gnuplot_start go Gosper GosperSum' + ' gr2d gr3d gradef gramschmidt graph6_decode graph6_encode graph6_export graph6_import' + ' graph_center graph_charpoly graph_eigenvalues graph_flow graph_order graph_periphery' + ' graph_product graph_size graph_union great_rhombicosidodecahedron_graph great_rhombicuboctahedron_graph' + ' grid_graph grind grobner_basis grotzch_graph hamilton_cycle hamilton_path' + ' hankel hankel_1 hankel_2 harmonic harmonic_mean hav heawood_graph hermite' + ' hessian hgfred hilbertmap hilbert_matrix hipow histogram histogram_description' + ' hodge horner hypergeometric i0 i1 %ibes ic1 ic2 ic_convert ichr1 ichr2 icosahedron_graph' + ' icosidodecahedron_graph icurvature ident identfor identity idiff idim idummy' + ' ieqn %if ifactors iframes ifs igcdex igeodesic_coords ilt image imagpart' + ' imetric implicit implicit_derivative implicit_plot indexed_tensor indices' + ' induced_subgraph inferencep inference_result infix info_display init_atensor' + ' init_ctensor in_neighbors innerproduct inpart inprod inrt integerp integer_partitions' + ' integrate intersect intersection intervalp intopois intosum invariant1 invariant2' + ' inverse_fft inverse_jacobi_cd inverse_jacobi_cn inverse_jacobi_cs inverse_jacobi_dc' + ' inverse_jacobi_dn inverse_jacobi_ds inverse_jacobi_nc inverse_jacobi_nd inverse_jacobi_ns' + ' inverse_jacobi_sc inverse_jacobi_sd inverse_jacobi_sn invert invert_by_adjoint' + ' invert_by_lu inv_mod irr is is_biconnected is_bipartite is_connected is_digraph' + ' is_edge_in_graph is_graph is_graph_or_digraph ishow is_isomorphic isolate' + ' isomorphism is_planar isqrt isreal_p is_sconnected is_tree is_vertex_in_graph' + ' items_inference %j j0 j1 jacobi jacobian jacobi_cd jacobi_cn jacobi_cs jacobi_dc' + ' jacobi_dn jacobi_ds jacobi_nc jacobi_nd jacobi_ns jacobi_p jacobi_sc jacobi_sd' + ' jacobi_sn JF jn join jordan julia julia_set julia_sin %k kdels kdelta kill' + ' killcontext kostka kron_delta kronecker_product kummer_m kummer_u kurtosis' + ' kurtosis_bernoulli kurtosis_beta kurtosis_binomial kurtosis_chi2 kurtosis_continuous_uniform' + ' kurtosis_discrete_uniform kurtosis_exp kurtosis_f kurtosis_gamma kurtosis_general_finite_discrete' + ' kurtosis_geometric kurtosis_gumbel kurtosis_hypergeometric kurtosis_laplace' + ' kurtosis_logistic kurtosis_lognormal kurtosis_negative_binomial kurtosis_noncentral_chi2' + ' kurtosis_noncentral_student_t kurtosis_normal kurtosis_pareto kurtosis_poisson' + ' kurtosis_rayleigh kurtosis_student_t kurtosis_weibull label labels lagrange' + ' laguerre lambda lambert_w laplace laplacian_matrix last lbfgs lc2kdt lcharp' + ' lc_l lcm lc_u ldefint ldisp ldisplay legendre_p legendre_q leinstein length' + ' let letrules letsimp levi_civita lfreeof lgtreillis lhs li liediff limit' + ' Lindstedt linear linearinterpol linear_program linear_regression line_graph' + ' linsolve listarray list_correlations listify list_matrix_entries list_nc_monomials' + ' listoftens listofvars listp lmax lmin load loadfile local locate_matrix_entry' + ' log logcontract log_gamma lopow lorentz_gauge lowercasep lpart lratsubst' + ' lreduce lriemann lsquares_estimates lsquares_estimates_approximate lsquares_estimates_exact' + ' lsquares_mse lsquares_residual_mse lsquares_residuals lsum ltreillis lu_backsub' + ' lucas lu_factor %m macroexpand macroexpand1 make_array makebox makefact makegamma' + ' make_graph make_level_picture makelist makeOrders make_poly_continent make_poly_country' + ' make_polygon make_random_state make_rgb_picture makeset make_string_input_stream' + ' make_string_output_stream make_transform mandelbrot mandelbrot_set map mapatom' + ' maplist matchdeclare matchfix mat_cond mat_fullunblocker mat_function mathml_display' + ' mat_norm matrix matrixmap matrixp matrix_size mattrace mat_trace mat_unblocker' + ' max max_clique max_degree max_flow maximize_lp max_independent_set max_matching' + ' maybe md5sum mean mean_bernoulli mean_beta mean_binomial mean_chi2 mean_continuous_uniform' + ' mean_deviation mean_discrete_uniform mean_exp mean_f mean_gamma mean_general_finite_discrete' + ' mean_geometric mean_gumbel mean_hypergeometric mean_laplace mean_logistic' + ' mean_lognormal mean_negative_binomial mean_noncentral_chi2 mean_noncentral_student_t' + ' mean_normal mean_pareto mean_poisson mean_rayleigh mean_student_t mean_weibull' + ' median median_deviation member mesh metricexpandall mgf1_sha1 min min_degree' + ' min_edge_cut minfactorial minimalPoly minimize_lp minimum_spanning_tree minor' + ' minpack_lsquares minpack_solve min_vertex_cover min_vertex_cut mkdir mnewton' + ' mod mode_declare mode_identity ModeMatrix moebius mon2schur mono monomial_dimensions' + ' multibernstein_poly multi_display_for_texinfo multi_elem multinomial multinomial_coeff' + ' multi_orbit multiplot_mode multi_pui multsym multthru mycielski_graph nary' + ' natural_unit nc_degree ncexpt ncharpoly negative_picture neighbors new newcontext' + ' newdet new_graph newline newton new_variable next_prime nicedummies niceindices' + ' ninth nofix nonarray noncentral_moment nonmetricity nonnegintegerp nonscalarp' + ' nonzeroandfreeof notequal nounify nptetrad npv nroots nterms ntermst' + ' nthroot nullity nullspace num numbered_boundaries numberp number_to_octets' + ' num_distinct_partitions numerval numfactor num_partitions nusum nzeta nzetai' + ' nzetar octets_to_number octets_to_oid odd_girth oddp ode2 ode_check odelin' + ' oid_to_octets op opena opena_binary openr openr_binary openw openw_binary' + ' operatorp opsubst optimize %or orbit orbits ordergreat ordergreatp orderless' + ' orderlessp orthogonal_complement orthopoly_recur orthopoly_weight outermap' + ' out_neighbors outofpois pade parabolic_cylinder_d parametric parametric_surface' + ' parg parGosper parse_string parse_timedate part part2cont partfrac partition' + ' partition_set partpol path_digraph path_graph pathname_directory pathname_name' + ' pathname_type pdf_bernoulli pdf_beta pdf_binomial pdf_cauchy pdf_chi2 pdf_continuous_uniform' + ' pdf_discrete_uniform pdf_exp pdf_f pdf_gamma pdf_general_finite_discrete' + ' pdf_geometric pdf_gumbel pdf_hypergeometric pdf_laplace pdf_logistic pdf_lognormal' + ' pdf_negative_binomial pdf_noncentral_chi2 pdf_noncentral_student_t pdf_normal' + ' pdf_pareto pdf_poisson pdf_rank_sum pdf_rayleigh pdf_signed_rank pdf_student_t' + ' pdf_weibull pearson_skewness permanent permut permutation permutations petersen_graph' + ' petrov pickapart picture_equalp picturep piechart piechart_description planar_embedding' + ' playback plog plot2d plot3d plotdf ploteq plsquares pochhammer points poisdiff' + ' poisexpt poisint poismap poisplus poissimp poissubst poistimes poistrim polar' + ' polarform polartorect polar_to_xy poly_add poly_buchberger poly_buchberger_criterion' + ' poly_colon_ideal poly_content polydecomp poly_depends_p poly_elimination_ideal' + ' poly_exact_divide poly_expand poly_expt poly_gcd polygon poly_grobner poly_grobner_equal' + ' poly_grobner_member poly_grobner_subsetp poly_ideal_intersection poly_ideal_polysaturation' + ' poly_ideal_polysaturation1 poly_ideal_saturation poly_ideal_saturation1 poly_lcm' + ' poly_minimization polymod poly_multiply polynome2ele polynomialp poly_normal_form' + ' poly_normalize poly_normalize_list poly_polysaturation_extension poly_primitive_part' + ' poly_pseudo_divide poly_reduced_grobner poly_reduction poly_saturation_extension' + ' poly_s_polynomial poly_subtract polytocompanion pop postfix potential power_mod' + ' powerseries powerset prefix prev_prime primep primes principal_components' + ' print printf printfile print_graph printpois printprops prodrac product properties' + ' propvars psi psubst ptriangularize pui pui2comp pui2ele pui2polynome pui_direct' + ' puireduc push put pv qput qrange qty quad_control quad_qag quad_qagi quad_qagp' + ' quad_qags quad_qawc quad_qawf quad_qawo quad_qaws quadrilateral quantile' + ' quantile_bernoulli quantile_beta quantile_binomial quantile_cauchy quantile_chi2' + ' quantile_continuous_uniform quantile_discrete_uniform quantile_exp quantile_f' + ' quantile_gamma quantile_general_finite_discrete quantile_geometric quantile_gumbel' + ' quantile_hypergeometric quantile_laplace quantile_logistic quantile_lognormal' + ' quantile_negative_binomial quantile_noncentral_chi2 quantile_noncentral_student_t' + ' quantile_normal quantile_pareto quantile_poisson quantile_rayleigh quantile_student_t' + ' quantile_weibull quartile_skewness quit qunit quotient racah_v racah_w radcan' + ' radius random random_bernoulli random_beta random_binomial random_bipartite_graph' + ' random_cauchy random_chi2 random_continuous_uniform random_digraph random_discrete_uniform' + ' random_exp random_f random_gamma random_general_finite_discrete random_geometric' + ' random_graph random_graph1 random_gumbel random_hypergeometric random_laplace' + ' random_logistic random_lognormal random_negative_binomial random_network' + ' random_noncentral_chi2 random_noncentral_student_t random_normal random_pareto' + ' random_permutation random_poisson random_rayleigh random_regular_graph random_student_t' + ' random_tournament random_tree random_weibull range rank rat ratcoef ratdenom' + ' ratdiff ratdisrep ratexpand ratinterpol rational rationalize ratnumer ratnump' + ' ratp ratsimp ratsubst ratvars ratweight read read_array read_binary_array' + ' read_binary_list read_binary_matrix readbyte readchar read_hashed_array readline' + ' read_list read_matrix read_nested_list readonly read_xpm real_imagpart_to_conjugate' + ' realpart realroots rearray rectangle rectform rectform_log_if_constant recttopolar' + ' rediff reduce_consts reduce_order region region_boundaries region_boundaries_plus' + ' rem remainder remarray rembox remcomps remcon remcoord remfun remfunction' + ' remlet remove remove_constvalue remove_dimensions remove_edge remove_fundamental_dimensions' + ' remove_fundamental_units remove_plot_option remove_vertex rempart remrule' + ' remsym remvalue rename rename_file reset reset_displays residue resolvante' + ' resolvante_alternee1 resolvante_bipartite resolvante_diedrale resolvante_klein' + ' resolvante_klein3 resolvante_produit_sym resolvante_unitaire resolvante_vierer' + ' rest resultant return reveal reverse revert revert2 rgb2level rhs ricci riemann' + ' rinvariant risch rk rmdir rncombine romberg room rootscontract round row' + ' rowop rowswap rreduce run_testsuite %s save saving scalarp scaled_bessel_i' + ' scaled_bessel_i0 scaled_bessel_i1 scalefactors scanmap scatterplot scatterplot_description' + ' scene schur2comp sconcat scopy scsimp scurvature sdowncase sec sech second' + ' sequal sequalignore set_alt_display setdifference set_draw_defaults set_edge_weight' + ' setelmx setequalp setify setp set_partitions set_plot_option set_prompt set_random_state' + ' set_tex_environment set_tex_environment_default setunits setup_autoload set_up_dot_simplifications' + ' set_vertex_label seventh sexplode sf sha1sum sha256sum shortest_path shortest_weighted_path' + ' show showcomps showratvars sierpinskiale sierpinskimap sign signum similaritytransform' + ' simp_inequality simplify_sum simplode simpmetderiv simtran sin sinh sinsert' + ' sinvertcase sixth skewness skewness_bernoulli skewness_beta skewness_binomial' + ' skewness_chi2 skewness_continuous_uniform skewness_discrete_uniform skewness_exp' + ' skewness_f skewness_gamma skewness_general_finite_discrete skewness_geometric' + ' skewness_gumbel skewness_hypergeometric skewness_laplace skewness_logistic' + ' skewness_lognormal skewness_negative_binomial skewness_noncentral_chi2 skewness_noncentral_student_t' + ' skewness_normal skewness_pareto skewness_poisson skewness_rayleigh skewness_student_t' + ' skewness_weibull slength smake small_rhombicosidodecahedron_graph small_rhombicuboctahedron_graph' + ' smax smin smismatch snowmap snub_cube_graph snub_dodecahedron_graph solve' + ' solve_rec solve_rec_rat some somrac sort sparse6_decode sparse6_encode sparse6_export' + ' sparse6_import specint spherical spherical_bessel_j spherical_bessel_y spherical_hankel1' + ' spherical_hankel2 spherical_harmonic spherical_to_xyz splice split sposition' + ' sprint sqfr sqrt sqrtdenest sremove sremovefirst sreverse ssearch ssort sstatus' + ' ssubst ssubstfirst staircase standardize standardize_inverse_trig starplot' + ' starplot_description status std std1 std_bernoulli std_beta std_binomial' + ' std_chi2 std_continuous_uniform std_discrete_uniform std_exp std_f std_gamma' + ' std_general_finite_discrete std_geometric std_gumbel std_hypergeometric std_laplace' + ' std_logistic std_lognormal std_negative_binomial std_noncentral_chi2 std_noncentral_student_t' + ' std_normal std_pareto std_poisson std_rayleigh std_student_t std_weibull' + ' stemplot stirling stirling1 stirling2 strim striml strimr string stringout' + ' stringp strong_components struve_h struve_l sublis sublist sublist_indices' + ' submatrix subsample subset subsetp subst substinpart subst_parallel substpart' + ' substring subvar subvarp sum sumcontract summand_to_rec supcase supcontext' + ' symbolp symmdifference symmetricp system take_channel take_inference tan' + ' tanh taylor taylorinfo taylorp taylor_simplifier taytorat tcl_output tcontract' + ' tellrat tellsimp tellsimpafter tentex tenth test_mean test_means_difference' + ' test_normality test_proportion test_proportions_difference test_rank_sum' + ' test_sign test_signed_rank test_variance test_variance_ratio tex tex1 tex_display' + ' texput %th third throw time timedate timer timer_info tldefint tlimit todd_coxeter' + ' toeplitz tokens to_lisp topological_sort to_poly to_poly_solve totaldisrep' + ' totalfourier totient tpartpol trace tracematrix trace_options transform_sample' + ' translate translate_file transpose treefale tree_reduce treillis treinat' + ' triangle triangularize trigexpand trigrat trigreduce trigsimp trunc truncate' + ' truncated_cube_graph truncated_dodecahedron_graph truncated_icosahedron_graph' + ' truncated_tetrahedron_graph tr_warnings_get tube tutte_graph ueivects uforget' + ' ultraspherical underlying_graph undiff union unique uniteigenvectors unitp' + ' units unit_step unitvector unorder unsum untellrat untimer' + ' untrace uppercasep uricci uriemann uvect vandermonde_matrix var var1 var_bernoulli' + ' var_beta var_binomial var_chi2 var_continuous_uniform var_discrete_uniform' + ' var_exp var_f var_gamma var_general_finite_discrete var_geometric var_gumbel' + ' var_hypergeometric var_laplace var_logistic var_lognormal var_negative_binomial' + ' var_noncentral_chi2 var_noncentral_student_t var_normal var_pareto var_poisson' + ' var_rayleigh var_student_t var_weibull vector vectorpotential vectorsimp' + ' verbify vers vertex_coloring vertex_connectivity vertex_degree vertex_distance' + ' vertex_eccentricity vertex_in_degree vertex_out_degree vertices vertices_to_cycle' + ' vertices_to_path %w weyl wheel_graph wiener_index wigner_3j wigner_6j' + ' wigner_9j with_stdout write_binary_data writebyte write_data writefile wronskian' + ' xreduce xthru %y Zeilberger zeroequiv zerofor zeromatrix zeromatrixp zeta' + ' zgeev zheev zlange zn_add_table zn_carmichael_lambda zn_characteristic_factors' + ' zn_determinant zn_factor_generators zn_invert_by_lu zn_log zn_mult_table' + ' absboxchar activecontexts adapt_depth additive adim aform algebraic' + ' algepsilon algexact aliases allbut all_dotsimp_denoms allocation allsym alphabetic' + ' animation antisymmetric arrays askexp assume_pos assume_pos_pred assumescalar' + ' asymbol atomgrad atrig1 axes axis_3d axis_bottom axis_left axis_right axis_top' + ' azimuth background background_color backsubst berlefact bernstein_explicit' + ' besselexpand beta_args_sum_to_integer beta_expand bftorat bftrunc bindtest' + ' border boundaries_array box boxchar breakup %c capping cauchysum cbrange' + ' cbtics center cflength cframe_flag cnonmet_flag color color_bar color_bar_tics' + ' colorbox columns commutative complex cone context contexts contour contour_levels' + ' cosnpiflag ctaypov ctaypt ctayswitch ctayvar ct_coords ctorsion_flag ctrgsimp' + ' cube current_let_rule_package cylinder data_file_name debugmode decreasing' + ' default_let_rule_package delay dependencies derivabbrev derivsubst detout' + ' diagmetric diff dim dimensions dispflag display2d|10 display_format_internal' + ' distribute_over doallmxops domain domxexpt domxmxops domxnctimes dontfactor' + ' doscmxops doscmxplus dot0nscsimp dot0simp dot1simp dotassoc dotconstrules' + ' dotdistrib dotexptsimp dotident dotscrules draw_graph_program draw_realpart' + ' edge_color edge_coloring edge_partition edge_type edge_width %edispflag' + ' elevation %emode endphi endtheta engineering_format_floats enhanced3d %enumer' + ' epsilon_lp erfflag erf_representation errormsg error_size error_syms error_type' + ' %e_to_numlog eval even evenfun evflag evfun ev_point expandwrt_denom expintexpand' + ' expintrep expon expop exptdispflag exptisolate exptsubst facexpand facsum_combine' + ' factlim factorflag factorial_expand factors_only fb feature features' + ' file_name file_output_append file_search_demo file_search_lisp file_search_maxima|10' + ' file_search_tests file_search_usage file_type_lisp file_type_maxima|10 fill_color' + ' fill_density filled_func fixed_vertices flipflag float2bf font font_size' + ' fortindent fortspaces fpprec fpprintprec functions gamma_expand gammalim' + ' gdet genindex gensumnum GGFCFMAX GGFINFINITY globalsolve gnuplot_command' + ' gnuplot_curve_styles gnuplot_curve_titles gnuplot_default_term_command gnuplot_dumb_term_command' + ' gnuplot_file_args gnuplot_file_name gnuplot_out_file gnuplot_pdf_term_command' + ' gnuplot_pm3d gnuplot_png_term_command gnuplot_postamble gnuplot_preamble' + ' gnuplot_ps_term_command gnuplot_svg_term_command gnuplot_term gnuplot_view_args' + ' Gosper_in_Zeilberger gradefs grid grid2d grind halfangles head_angle head_both' + ' head_length head_type height hypergeometric_representation %iargs ibase' + ' icc1 icc2 icounter idummyx ieqnprint ifb ifc1 ifc2 ifg ifgi ifr iframe_bracket_form' + ' ifri igeowedge_flag ikt1 ikt2 imaginary inchar increasing infeval' + ' infinity inflag infolists inm inmc1 inmc2 intanalysis integer integervalued' + ' integrate_use_rootsof integration_constant integration_constant_counter interpolate_color' + ' intfaclim ip_grid ip_grid_in irrational isolate_wrt_times iterations itr' + ' julia_parameter %k1 %k2 keepfloat key key_pos kinvariant kt label label_alignment' + ' label_orientation labels lassociative lbfgs_ncorrections lbfgs_nfeval_max' + ' leftjust legend letrat let_rule_packages lfg lg lhospitallim limsubst linear' + ' linear_solver linechar linel|10 linenum line_type linewidth line_width linsolve_params' + ' linsolvewarn lispdisp listarith listconstvars listdummyvars lmxchar load_pathname' + ' loadprint logabs logarc logcb logconcoeffp logexpand lognegint logsimp logx' + ' logx_secondary logy logy_secondary logz lriem m1pbranch macroexpansion macros' + ' mainvar manual_demo maperror mapprint matrix_element_add matrix_element_mult' + ' matrix_element_transpose maxapplydepth maxapplyheight maxima_tempdir|10 maxima_userdir|10' + ' maxnegex MAX_ORD maxposex maxpsifracdenom maxpsifracnum maxpsinegint maxpsiposint' + ' maxtayorder mesh_lines_color method mod_big_prime mode_check_errorp' + ' mode_checkp mode_check_warnp mod_test mod_threshold modular_linear_solver' + ' modulus multiplicative multiplicities myoptions nary negdistrib negsumdispflag' + ' newline newtonepsilon newtonmaxiter nextlayerfactor niceindicespref nm nmc' + ' noeval nolabels nonegative_lp noninteger nonscalar noun noundisp nouns np' + ' npi nticks ntrig numer numer_pbranch obase odd oddfun opacity opproperties' + ' opsubst optimprefix optionset orientation origin orthopoly_returns_intervals' + ' outative outchar packagefile palette partswitch pdf_file pfeformat phiresolution' + ' %piargs piece pivot_count_sx pivot_max_sx plot_format plot_options plot_realpart' + ' png_file pochhammer_max_index points pointsize point_size points_joined point_type' + ' poislim poisson poly_coefficient_ring poly_elimination_order polyfactor poly_grobner_algorithm' + ' poly_grobner_debug poly_monomial_order poly_primary_elimination_order poly_return_term_list' + ' poly_secondary_elimination_order poly_top_reduction_only posfun position' + ' powerdisp pred prederror primep_number_of_tests product_use_gamma program' + ' programmode promote_float_to_bigfloat prompt proportional_axes props psexpand' + ' ps_file radexpand radius radsubstflag rassociative ratalgdenom ratchristof' + ' ratdenomdivide rateinstein ratepsilon ratfac rational ratmx ratprint ratriemann' + ' ratsimpexpons ratvarswitch ratweights ratweyl ratwtlvl real realonly redraw' + ' refcheck resolution restart resultant ric riem rmxchar %rnum_list rombergabs' + ' rombergit rombergmin rombergtol rootsconmode rootsepsilon run_viewer same_xy' + ' same_xyz savedef savefactors scalar scalarmatrixp scale scale_lp setcheck' + ' setcheckbreak setval show_edge_color show_edges show_edge_type show_edge_width' + ' show_id show_label showtime show_vertex_color show_vertex_size show_vertex_type' + ' show_vertices show_weight simp simplified_output simplify_products simpproduct' + ' simpsum sinnpiflag solvedecomposes solveexplicit solvefactors solvenullwarn' + ' solveradcan solvetrigwarn space sparse sphere spring_embedding_depth sqrtdispflag' + ' stardisp startphi starttheta stats_numer stringdisp structures style sublis_apply_lambda' + ' subnumsimp sumexpand sumsplitfact surface surface_hide svg_file symmetric' + ' tab taylordepth taylor_logexpand taylor_order_coefficients taylor_truncate_polynomials' + ' tensorkill terminal testsuite_files thetaresolution timer_devalue title tlimswitch' + ' tr track transcompile transform transform_xy translate_fast_arrays transparent' + ' transrun tr_array_as_ref tr_bound_function_applyp tr_file_tty_messagesp tr_float_can_branch_complex' + ' tr_function_call_default trigexpandplus trigexpandtimes triginverses trigsign' + ' trivial_solutions tr_numer tr_optimize_max_loop tr_semicompile tr_state_vars' + ' tr_warn_bad_function_calls tr_warn_fexpr tr_warn_meval tr_warn_mode' + ' tr_warn_undeclared tr_warn_undefined_variable tstep ttyoff tube_extremes' + ' ufg ug %unitexpand unit_vectors uric uriem use_fast_arrays user_preamble' + ' usersetunits values vect_cross verbose vertex_color vertex_coloring vertex_partition' + ' vertex_size vertex_type view warnings weyl width windowname windowtitle wired_surface' + ' wireframe xaxis xaxis_color xaxis_secondary xaxis_type xaxis_width xlabel' + ' xlabel_secondary xlength xrange xrange_secondary xtics xtics_axis xtics_rotate' + ' xtics_rotate_secondary xtics_secondary xtics_secondary_axis xu_grid x_voxel' + ' xy_file xyplane xy_scale yaxis yaxis_color yaxis_secondary yaxis_type yaxis_width' + ' ylabel ylabel_secondary ylength yrange yrange_secondary ytics ytics_axis' + ' ytics_rotate ytics_rotate_secondary ytics_secondary ytics_secondary_axis' + ' yv_grid y_voxel yx_ratio zaxis zaxis_color zaxis_type zaxis_width zeroa zerob' + ' zerobern zeta%pi zlabel zlabel_rotate zlength zmin zn_primroot_limit zn_primroot_pretest';
  var SYMBOLS = '_ __ %|0 %%|0';
  return {
    name: 'Maxima',
    keywords: {
      $pattern: '[A-Za-z_%][0-9A-Za-z_%]*',
      keyword: KEYWORDS,
      literal: LITERALS,
      built_in: BUILTIN_FUNCTIONS,
      symbol: SYMBOLS
    },
    contains: [{
      className: 'comment',
      begin: '/\\*',
      end: '\\*/',
      contains: ['self']
    }, hljs.QUOTE_STRING_MODE, {
      className: 'number',
      relevance: 0,
      variants: [{
        // float number w/ exponent
        // hmm, I wonder if we ought to include other exponent markers?
        begin: '\\b(\\d+|\\d+\\.|\\.\\d+|\\d+\\.\\d+)[Ee][-+]?\\d+\\b'
      }, {
        // bigfloat number
        begin: '\\b(\\d+|\\d+\\.|\\.\\d+|\\d+\\.\\d+)[Bb][-+]?\\d+\\b',
        relevance: 10
      }, {
        // float number w/out exponent
        // Doesn't seem to recognize floats which start with '.'
        begin: '\\b(\\.\\d+|\\d+\\.\\d+)\\b'
      }, {
        // integer in base up to 36
        // Doesn't seem to recognize integers which end with '.'
        begin: '\\b(\\d+|0[0-9A-Za-z]+)\\.?\\b'
      }]
    }],
    illegal: /@/
  };
}
module.exports = maxima;

/***/ }),

/***/ 49751:
/***/ ((module) => {

/*
Language: MEL
Description: Maya Embedded Language
Author: Shuen-Huei Guan <drake.guan@gmail.com>
Website: http://www.autodesk.com/products/autodesk-maya/overview
Category: graphics
*/

function mel(hljs) {
  return {
    name: 'MEL',
    keywords: 'int float string vector matrix if else switch case default while do for in break ' + 'continue global proc return about abs addAttr addAttributeEditorNodeHelp addDynamic ' + 'addNewShelfTab addPP addPanelCategory addPrefixToName advanceToNextDrivenKey ' + 'affectedNet affects aimConstraint air alias aliasAttr align alignCtx alignCurve ' + 'alignSurface allViewFit ambientLight angle angleBetween animCone animCurveEditor ' + 'animDisplay animView annotate appendStringArray applicationName applyAttrPreset ' + 'applyTake arcLenDimContext arcLengthDimension arclen arrayMapper art3dPaintCtx ' + 'artAttrCtx artAttrPaintVertexCtx artAttrSkinPaintCtx artAttrTool artBuildPaintMenu ' + 'artFluidAttrCtx artPuttyCtx artSelectCtx artSetPaintCtx artUserPaintCtx assignCommand ' + 'assignInputDevice assignViewportFactories attachCurve attachDeviceAttr attachSurface ' + 'attrColorSliderGrp attrCompatibility attrControlGrp attrEnumOptionMenu ' + 'attrEnumOptionMenuGrp attrFieldGrp attrFieldSliderGrp attrNavigationControlGrp ' + 'attrPresetEditWin attributeExists attributeInfo attributeMenu attributeQuery ' + 'autoKeyframe autoPlace bakeClip bakeFluidShading bakePartialHistory bakeResults ' + 'bakeSimulation basename basenameEx batchRender bessel bevel bevelPlus binMembership ' + 'bindSkin blend2 blendShape blendShapeEditor blendShapePanel blendTwoAttr blindDataType ' + 'boneLattice boundary boxDollyCtx boxZoomCtx bufferCurve buildBookmarkMenu ' + 'buildKeyframeMenu button buttonManip CBG cacheFile cacheFileCombine cacheFileMerge ' + 'cacheFileTrack camera cameraView canCreateManip canvas capitalizeString catch ' + 'catchQuiet ceil changeSubdivComponentDisplayLevel changeSubdivRegion channelBox ' + 'character characterMap characterOutlineEditor characterize chdir checkBox checkBoxGrp ' + 'checkDefaultRenderGlobals choice circle circularFillet clamp clear clearCache clip ' + 'clipEditor clipEditorCurrentTimeCtx clipSchedule clipSchedulerOutliner clipTrimBefore ' + 'closeCurve closeSurface cluster cmdFileOutput cmdScrollFieldExecuter ' + 'cmdScrollFieldReporter cmdShell coarsenSubdivSelectionList collision color ' + 'colorAtPoint colorEditor colorIndex colorIndexSliderGrp colorSliderButtonGrp ' + 'colorSliderGrp columnLayout commandEcho commandLine commandPort compactHairSystem ' + 'componentEditor compositingInterop computePolysetVolume condition cone confirmDialog ' + 'connectAttr connectControl connectDynamic connectJoint connectionInfo constrain ' + 'constrainValue constructionHistory container containsMultibyte contextInfo control ' + 'convertFromOldLayers convertIffToPsd convertLightmap convertSolidTx convertTessellation ' + 'convertUnit copyArray copyFlexor copyKey copySkinWeights cos cpButton cpCache ' + 'cpClothSet cpCollision cpConstraint cpConvClothToMesh cpForces cpGetSolverAttr cpPanel ' + 'cpProperty cpRigidCollisionFilter cpSeam cpSetEdit cpSetSolverAttr cpSolver ' + 'cpSolverTypes cpTool cpUpdateClothUVs createDisplayLayer createDrawCtx createEditor ' + 'createLayeredPsdFile createMotionField createNewShelf createNode createRenderLayer ' + 'createSubdivRegion cross crossProduct ctxAbort ctxCompletion ctxEditMode ctxTraverse ' + 'currentCtx currentTime currentTimeCtx currentUnit curve curveAddPtCtx ' + 'curveCVCtx curveEPCtx curveEditorCtx curveIntersect curveMoveEPCtx curveOnSurface ' + 'curveSketchCtx cutKey cycleCheck cylinder dagPose date defaultLightListCheckBox ' + 'defaultNavigation defineDataServer defineVirtualDevice deformer deg_to_rad delete ' + 'deleteAttr deleteShadingGroupsAndMaterials deleteShelfTab deleteUI deleteUnusedBrushes ' + 'delrandstr detachCurve detachDeviceAttr detachSurface deviceEditor devicePanel dgInfo ' + 'dgdirty dgeval dgtimer dimWhen directKeyCtx directionalLight dirmap dirname disable ' + 'disconnectAttr disconnectJoint diskCache displacementToPoly displayAffected ' + 'displayColor displayCull displayLevelOfDetail displayPref displayRGBColor ' + 'displaySmoothness displayStats displayString displaySurface distanceDimContext ' + 'distanceDimension doBlur dolly dollyCtx dopeSheetEditor dot dotProduct ' + 'doubleProfileBirailSurface drag dragAttrContext draggerContext dropoffLocator ' + 'duplicate duplicateCurve duplicateSurface dynCache dynControl dynExport dynExpression ' + 'dynGlobals dynPaintEditor dynParticleCtx dynPref dynRelEdPanel dynRelEditor ' + 'dynamicLoad editAttrLimits editDisplayLayerGlobals editDisplayLayerMembers ' + 'editRenderLayerAdjustment editRenderLayerGlobals editRenderLayerMembers editor ' + 'editorTemplate effector emit emitter enableDevice encodeString endString endsWith env ' + 'equivalent equivalentTol erf error eval evalDeferred evalEcho event ' + 'exactWorldBoundingBox exclusiveLightCheckBox exec executeForEachObject exists exp ' + 'expression expressionEditorListen extendCurve extendSurface extrude fcheck fclose feof ' + 'fflush fgetline fgetword file fileBrowserDialog fileDialog fileExtension fileInfo ' + 'filetest filletCurve filter filterCurve filterExpand filterStudioImport ' + 'findAllIntersections findAnimCurves findKeyframe findMenuItem findRelatedSkinCluster ' + 'finder firstParentOf fitBspline flexor floatEq floatField floatFieldGrp floatScrollBar ' + 'floatSlider floatSlider2 floatSliderButtonGrp floatSliderGrp floor flow fluidCacheInfo ' + 'fluidEmitter fluidVoxelInfo flushUndo fmod fontDialog fopen formLayout format fprint ' + 'frameLayout fread freeFormFillet frewind fromNativePath fwrite gamma gauss ' + 'geometryConstraint getApplicationVersionAsFloat getAttr getClassification ' + 'getDefaultBrush getFileList getFluidAttr getInputDeviceRange getMayaPanelTypes ' + 'getModifiers getPanel getParticleAttr getPluginResource getenv getpid glRender ' + 'glRenderEditor globalStitch gmatch goal gotoBindPose grabColor gradientControl ' + 'gradientControlNoAttr graphDollyCtx graphSelectContext graphTrackCtx gravity grid ' + 'gridLayout group groupObjectsByName HfAddAttractorToAS HfAssignAS HfBuildEqualMap ' + 'HfBuildFurFiles HfBuildFurImages HfCancelAFR HfConnectASToHF HfCreateAttractor ' + 'HfDeleteAS HfEditAS HfPerformCreateAS HfRemoveAttractorFromAS HfSelectAttached ' + 'HfSelectAttractors HfUnAssignAS hardenPointCurve hardware hardwareRenderPanel ' + 'headsUpDisplay headsUpMessage help helpLine hermite hide hilite hitTest hotBox hotkey ' + 'hotkeyCheck hsv_to_rgb hudButton hudSlider hudSliderButton hwReflectionMap hwRender ' + 'hwRenderLoad hyperGraph hyperPanel hyperShade hypot iconTextButton iconTextCheckBox ' + 'iconTextRadioButton iconTextRadioCollection iconTextScrollList iconTextStaticLabel ' + 'ikHandle ikHandleCtx ikHandleDisplayScale ikSolver ikSplineHandleCtx ikSystem ' + 'ikSystemInfo ikfkDisplayMethod illustratorCurves image imfPlugins inheritTransform ' + 'insertJoint insertJointCtx insertKeyCtx insertKnotCurve insertKnotSurface instance ' + 'instanceable instancer intField intFieldGrp intScrollBar intSlider intSliderGrp ' + 'interToUI internalVar intersect iprEngine isAnimCurve isConnected isDirty isParentOf ' + 'isSameObject isTrue isValidObjectName isValidString isValidUiName isolateSelect ' + 'itemFilter itemFilterAttr itemFilterRender itemFilterType joint jointCluster jointCtx ' + 'jointDisplayScale jointLattice keyTangent keyframe keyframeOutliner ' + 'keyframeRegionCurrentTimeCtx keyframeRegionDirectKeyCtx keyframeRegionDollyCtx ' + 'keyframeRegionInsertKeyCtx keyframeRegionMoveKeyCtx keyframeRegionScaleKeyCtx ' + 'keyframeRegionSelectKeyCtx keyframeRegionSetKeyCtx keyframeRegionTrackCtx ' + 'keyframeStats lassoContext lattice latticeDeformKeyCtx launch launchImageEditor ' + 'layerButton layeredShaderPort layeredTexturePort layout layoutDialog lightList ' + 'lightListEditor lightListPanel lightlink lineIntersection linearPrecision linstep ' + 'listAnimatable listAttr listCameras listConnections listDeviceAttachments listHistory ' + 'listInputDeviceAxes listInputDeviceButtons listInputDevices listMenuAnnotation ' + 'listNodeTypes listPanelCategories listRelatives listSets listTransforms ' + 'listUnselected listerEditor loadFluid loadNewShelf loadPlugin ' + 'loadPluginLanguageResources loadPrefObjects localizedPanelLabel lockNode loft log ' + 'longNameOf lookThru ls lsThroughFilter lsType lsUI Mayatomr mag makeIdentity makeLive ' + 'makePaintable makeRoll makeSingleSurface makeTubeOn makebot manipMoveContext ' + 'manipMoveLimitsCtx manipOptions manipRotateContext manipRotateLimitsCtx ' + 'manipScaleContext manipScaleLimitsCtx marker match max memory menu menuBarLayout ' + 'menuEditor menuItem menuItemToShelf menuSet menuSetPref messageLine min minimizeApp ' + 'mirrorJoint modelCurrentTimeCtx modelEditor modelPanel mouse movIn movOut move ' + 'moveIKtoFK moveKeyCtx moveVertexAlongDirection multiProfileBirailSurface mute ' + 'nParticle nameCommand nameField namespace namespaceInfo newPanelItems newton nodeCast ' + 'nodeIconButton nodeOutliner nodePreset nodeType noise nonLinear normalConstraint ' + 'normalize nurbsBoolean nurbsCopyUVSet nurbsCube nurbsEditUV nurbsPlane nurbsSelect ' + 'nurbsSquare nurbsToPoly nurbsToPolygonsPref nurbsToSubdiv nurbsToSubdivPref ' + 'nurbsUVSet nurbsViewDirectionVector objExists objectCenter objectLayer objectType ' + 'objectTypeUI obsoleteProc oceanNurbsPreviewPlane offsetCurve offsetCurveOnSurface ' + 'offsetSurface openGLExtension openMayaPref optionMenu optionMenuGrp optionVar orbit ' + 'orbitCtx orientConstraint outlinerEditor outlinerPanel overrideModifier ' + 'paintEffectsDisplay pairBlend palettePort paneLayout panel panelConfiguration ' + 'panelHistory paramDimContext paramDimension paramLocator parent parentConstraint ' + 'particle particleExists particleInstancer particleRenderInfo partition pasteKey ' + 'pathAnimation pause pclose percent performanceOptions pfxstrokes pickWalk picture ' + 'pixelMove planarSrf plane play playbackOptions playblast plugAttr plugNode pluginInfo ' + 'pluginResourceUtil pointConstraint pointCurveConstraint pointLight pointMatrixMult ' + 'pointOnCurve pointOnSurface pointPosition poleVectorConstraint polyAppend ' + 'polyAppendFacetCtx polyAppendVertex polyAutoProjection polyAverageNormal ' + 'polyAverageVertex polyBevel polyBlendColor polyBlindData polyBoolOp polyBridgeEdge ' + 'polyCacheMonitor polyCheck polyChipOff polyClipboard polyCloseBorder polyCollapseEdge ' + 'polyCollapseFacet polyColorBlindData polyColorDel polyColorPerVertex polyColorSet ' + 'polyCompare polyCone polyCopyUV polyCrease polyCreaseCtx polyCreateFacet ' + 'polyCreateFacetCtx polyCube polyCut polyCutCtx polyCylinder polyCylindricalProjection ' + 'polyDelEdge polyDelFacet polyDelVertex polyDuplicateAndConnect polyDuplicateEdge ' + 'polyEditUV polyEditUVShell polyEvaluate polyExtrudeEdge polyExtrudeFacet ' + 'polyExtrudeVertex polyFlipEdge polyFlipUV polyForceUV polyGeoSampler polyHelix ' + 'polyInfo polyInstallAction polyLayoutUV polyListComponentConversion polyMapCut ' + 'polyMapDel polyMapSew polyMapSewMove polyMergeEdge polyMergeEdgeCtx polyMergeFacet ' + 'polyMergeFacetCtx polyMergeUV polyMergeVertex polyMirrorFace polyMoveEdge ' + 'polyMoveFacet polyMoveFacetUV polyMoveUV polyMoveVertex polyNormal polyNormalPerVertex ' + 'polyNormalizeUV polyOptUvs polyOptions polyOutput polyPipe polyPlanarProjection ' + 'polyPlane polyPlatonicSolid polyPoke polyPrimitive polyPrism polyProjection ' + 'polyPyramid polyQuad polyQueryBlindData polyReduce polySelect polySelectConstraint ' + 'polySelectConstraintMonitor polySelectCtx polySelectEditCtx polySeparate ' + 'polySetToFaceNormal polySewEdge polyShortestPathCtx polySmooth polySoftEdge ' + 'polySphere polySphericalProjection polySplit polySplitCtx polySplitEdge polySplitRing ' + 'polySplitVertex polyStraightenUVBorder polySubdivideEdge polySubdivideFacet ' + 'polyToSubdiv polyTorus polyTransfer polyTriangulate polyUVSet polyUnite polyWedgeFace ' + 'popen popupMenu pose pow preloadRefEd print progressBar progressWindow projFileViewer ' + 'projectCurve projectTangent projectionContext projectionManip promptDialog propModCtx ' + 'propMove psdChannelOutliner psdEditTextureFile psdExport psdTextureFile putenv pwd ' + 'python querySubdiv quit rad_to_deg radial radioButton radioButtonGrp radioCollection ' + 'radioMenuItemCollection rampColorPort rand randomizeFollicles randstate rangeControl ' + 'readTake rebuildCurve rebuildSurface recordAttr recordDevice redo reference ' + 'referenceEdit referenceQuery refineSubdivSelectionList refresh refreshAE ' + 'registerPluginResource rehash reloadImage removeJoint removeMultiInstance ' + 'removePanelCategory rename renameAttr renameSelectionList renameUI render ' + 'renderGlobalsNode renderInfo renderLayerButton renderLayerParent ' + 'renderLayerPostProcess renderLayerUnparent renderManip renderPartition ' + 'renderQualityNode renderSettings renderThumbnailUpdate renderWindowEditor ' + 'renderWindowSelectContext renderer reorder reorderDeformers requires reroot ' + 'resampleFluid resetAE resetPfxToPolyCamera resetTool resolutionNode retarget ' + 'reverseCurve reverseSurface revolve rgb_to_hsv rigidBody rigidSolver roll rollCtx ' + 'rootOf rot rotate rotationInterpolation roundConstantRadius rowColumnLayout rowLayout ' + 'runTimeCommand runup sampleImage saveAllShelves saveAttrPreset saveFluid saveImage ' + 'saveInitialState saveMenu savePrefObjects savePrefs saveShelf saveToolSettings scale ' + 'scaleBrushBrightness scaleComponents scaleConstraint scaleKey scaleKeyCtx sceneEditor ' + 'sceneUIReplacement scmh scriptCtx scriptEditorInfo scriptJob scriptNode scriptTable ' + 'scriptToShelf scriptedPanel scriptedPanelType scrollField scrollLayout sculpt ' + 'searchPathArray seed selLoadSettings select selectContext selectCurveCV selectKey ' + 'selectKeyCtx selectKeyframeRegionCtx selectMode selectPref selectPriority selectType ' + 'selectedNodes selectionConnection separator setAttr setAttrEnumResource ' + 'setAttrMapping setAttrNiceNameResource setConstraintRestPosition ' + 'setDefaultShadingGroup setDrivenKeyframe setDynamic setEditCtx setEditor setFluidAttr ' + 'setFocus setInfinity setInputDeviceMapping setKeyCtx setKeyPath setKeyframe ' + 'setKeyframeBlendshapeTargetWts setMenuMode setNodeNiceNameResource setNodeTypeFlag ' + 'setParent setParticleAttr setPfxToPolyCamera setPluginResource setProject ' + 'setStampDensity setStartupMessage setState setToolTo setUITemplate setXformManip sets ' + 'shadingConnection shadingGeometryRelCtx shadingLightRelCtx shadingNetworkCompare ' + 'shadingNode shapeCompare shelfButton shelfLayout shelfTabLayout shellField ' + 'shortNameOf showHelp showHidden showManipCtx showSelectionInTitle ' + 'showShadingGroupAttrEditor showWindow sign simplify sin singleProfileBirailSurface ' + 'size sizeBytes skinCluster skinPercent smoothCurve smoothTangentSurface smoothstep ' + 'snap2to2 snapKey snapMode snapTogetherCtx snapshot soft softMod softModCtx sort sound ' + 'soundControl source spaceLocator sphere sphrand spotLight spotLightPreviewPort ' + 'spreadSheetEditor spring sqrt squareSurface srtContext stackTrace startString ' + 'startsWith stitchAndExplodeShell stitchSurface stitchSurfacePoints strcmp ' + 'stringArrayCatenate stringArrayContains stringArrayCount stringArrayInsertAtIndex ' + 'stringArrayIntersector stringArrayRemove stringArrayRemoveAtIndex ' + 'stringArrayRemoveDuplicates stringArrayRemoveExact stringArrayToString ' + 'stringToStringArray strip stripPrefixFromName stroke subdAutoProjection ' + 'subdCleanTopology subdCollapse subdDuplicateAndConnect subdEditUV ' + 'subdListComponentConversion subdMapCut subdMapSewMove subdMatchTopology subdMirror ' + 'subdToBlind subdToPoly subdTransferUVsToCache subdiv subdivCrease ' + 'subdivDisplaySmoothness substitute substituteAllString substituteGeometry substring ' + 'surface surfaceSampler surfaceShaderList swatchDisplayPort switchTable symbolButton ' + 'symbolCheckBox sysFile system tabLayout tan tangentConstraint texLatticeDeformContext ' + 'texManipContext texMoveContext texMoveUVShellContext texRotateContext texScaleContext ' + 'texSelectContext texSelectShortestPathCtx texSmudgeUVContext texWinToolCtx text ' + 'textCurves textField textFieldButtonGrp textFieldGrp textManip textScrollList ' + 'textToShelf textureDisplacePlane textureHairColor texturePlacementContext ' + 'textureWindow threadCount threePointArcCtx timeControl timePort timerX toNativePath ' + 'toggle toggleAxis toggleWindowVisibility tokenize tokenizeList tolerance tolower ' + 'toolButton toolCollection toolDropped toolHasOptions toolPropertyWindow torus toupper ' + 'trace track trackCtx transferAttributes transformCompare transformLimits translator ' + 'trim trunc truncateFluidCache truncateHairCache tumble tumbleCtx turbulence ' + 'twoPointArcCtx uiRes uiTemplate unassignInputDevice undo undoInfo ungroup uniform unit ' + 'unloadPlugin untangleUV untitledFileName untrim upAxis updateAE userCtx uvLink ' + 'uvSnapshot validateShelfName vectorize view2dToolCtx viewCamera viewClipPlane ' + 'viewFit viewHeadOn viewLookAt viewManip viewPlace viewSet visor volumeAxis vortex ' + 'waitCursor warning webBrowser webBrowserPrefs whatIs window windowPref wire ' + 'wireContext workspace wrinkle wrinkleContext writeTake xbmLangPathList xform',
    illegal: '</',
    contains: [hljs.C_NUMBER_MODE, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, {
      className: 'string',
      begin: '`',
      end: '`',
      contains: [hljs.BACKSLASH_ESCAPE]
    }, {
      // eats variables
      begin: /[$%@](\^\w\b|#\w+|[^\s\w{]|\{\w+\}|\w+)/
    }, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE]
  };
}
module.exports = mel;

/***/ }),

/***/ 7833:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(47042);
/*
Language: Mercury
Author: mucaho <mkucko@gmail.com>
Description: Mercury is a logic/functional programming language which combines the clarity and expressiveness of declarative programming with advanced static analysis and error detection features.
Website: https://www.mercurylang.org
*/

function mercury(hljs) {
  var KEYWORDS = {
    keyword: 'module use_module import_module include_module end_module initialise ' + 'mutable initialize finalize finalise interface implementation pred ' + 'mode func type inst solver any_pred any_func is semidet det nondet ' + 'multi erroneous failure cc_nondet cc_multi typeclass instance where ' + 'pragma promise external trace atomic or_else require_complete_switch ' + 'require_det require_semidet require_multi require_nondet ' + 'require_cc_multi require_cc_nondet require_erroneous require_failure',
    meta:
    // pragma
    'inline no_inline type_spec source_file fact_table obsolete memo ' + 'loop_check minimal_model terminates does_not_terminate ' + 'check_termination promise_equivalent_clauses ' +
    // preprocessor
    'foreign_proc foreign_decl foreign_code foreign_type ' + 'foreign_import_module foreign_export_enum foreign_export ' + 'foreign_enum may_call_mercury will_not_call_mercury thread_safe ' + 'not_thread_safe maybe_thread_safe promise_pure promise_semipure ' + 'tabled_for_io local untrailed trailed attach_to_io_state ' + 'can_pass_as_mercury_type stable will_not_throw_exception ' + 'may_modify_trail will_not_modify_trail may_duplicate ' + 'may_not_duplicate affects_liveness does_not_affect_liveness ' + 'doesnt_affect_liveness no_sharing unknown_sharing sharing',
    built_in: 'some all not if then else true fail false try catch catch_any ' + 'semidet_true semidet_false semidet_fail impure_true impure semipure'
  };
  var COMMENT = hljs.COMMENT('%', '$');
  var NUMCODE = {
    className: 'number',
    begin: "0'.\\|0[box][0-9a-fA-F]*"
  };
  var ATOM = hljs.inherit(hljs.APOS_STRING_MODE, {
    relevance: 0
  });
  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {
    relevance: 0
  });
  var STRING_FMT = {
    className: 'subst',
    begin: '\\\\[abfnrtv]\\|\\\\x[0-9a-fA-F]*\\\\\\|%[-+# *.0-9]*[dioxXucsfeEgGp]',
    relevance: 0
  };
  STRING.contains = STRING.contains.slice(); // we need our own copy of contains
  STRING.contains.push(STRING_FMT);
  var IMPLICATION = {
    className: 'built_in',
    variants: [{
      begin: '<=>'
    }, {
      begin: '<=',
      relevance: 0
    }, {
      begin: '=>',
      relevance: 0
    }, {
      begin: '/\\\\'
    }, {
      begin: '\\\\/'
    }]
  };
  var HEAD_BODY_CONJUNCTION = {
    className: 'built_in',
    variants: [{
      begin: ':-\\|-->'
    }, {
      begin: '=',
      relevance: 0
    }]
  };
  return {
    name: 'Mercury',
    aliases: ['m', 'moo'],
    keywords: KEYWORDS,
    contains: [IMPLICATION, HEAD_BODY_CONJUNCTION, COMMENT, hljs.C_BLOCK_COMMENT_MODE, NUMCODE, hljs.NUMBER_MODE, ATOM, STRING, {
      // relevance booster
      begin: /:-/
    }, {
      // relevance booster
      begin: /\.$/
    }]
  };
}
module.exports = mercury;

/***/ }),

/***/ 15743:
/***/ ((module) => {

/*
Language: MIPS Assembly
Author: Nebuleon Fumika <nebuleon.fumika@gmail.com>
Description: MIPS Assembly (up to MIPS32R2)
Website: https://en.wikipedia.org/wiki/MIPS_architecture
Category: assembler
*/

function mipsasm(hljs) {
  // local labels: %?[FB]?[AT]?\d{1,2}\w+
  return {
    name: 'MIPS Assembly',
    case_insensitive: true,
    aliases: ['mips'],
    keywords: {
      $pattern: '\\.?' + hljs.IDENT_RE,
      meta:
      // GNU preprocs
      '.2byte .4byte .align .ascii .asciz .balign .byte .code .data .else .end .endif .endm .endr .equ .err .exitm .extern .global .hword .if .ifdef .ifndef .include .irp .long .macro .rept .req .section .set .skip .space .text .word .ltorg ',
      built_in: '$0 $1 $2 $3 $4 $5 $6 $7 $8 $9 $10 $11 $12 $13 $14 $15 ' +
      // integer registers
      '$16 $17 $18 $19 $20 $21 $22 $23 $24 $25 $26 $27 $28 $29 $30 $31 ' +
      // integer registers
      'zero at v0 v1 a0 a1 a2 a3 a4 a5 a6 a7 ' +
      // integer register aliases
      't0 t1 t2 t3 t4 t5 t6 t7 t8 t9 s0 s1 s2 s3 s4 s5 s6 s7 s8 ' +
      // integer register aliases
      'k0 k1 gp sp fp ra ' +
      // integer register aliases
      '$f0 $f1 $f2 $f2 $f4 $f5 $f6 $f7 $f8 $f9 $f10 $f11 $f12 $f13 $f14 $f15 ' +
      // floating-point registers
      '$f16 $f17 $f18 $f19 $f20 $f21 $f22 $f23 $f24 $f25 $f26 $f27 $f28 $f29 $f30 $f31 ' +
      // floating-point registers
      'Context Random EntryLo0 EntryLo1 Context PageMask Wired EntryHi ' +
      // Coprocessor 0 registers
      'HWREna BadVAddr Count Compare SR IntCtl SRSCtl SRSMap Cause EPC PRId ' +
      // Coprocessor 0 registers
      'EBase Config Config1 Config2 Config3 LLAddr Debug DEPC DESAVE CacheErr ' +
      // Coprocessor 0 registers
      'ECC ErrorEPC TagLo DataLo TagHi DataHi WatchLo WatchHi PerfCtl PerfCnt ' // Coprocessor 0 registers
    },

    contains: [{
      className: 'keyword',
      begin: '\\b(' +
      // mnemonics
      // 32-bit integer instructions
      'addi?u?|andi?|b(al)?|beql?|bgez(al)?l?|bgtzl?|blezl?|bltz(al)?l?|' + 'bnel?|cl[oz]|divu?|ext|ins|j(al)?|jalr(\\.hb)?|jr(\\.hb)?|lbu?|lhu?|' + 'll|lui|lw[lr]?|maddu?|mfhi|mflo|movn|movz|move|msubu?|mthi|mtlo|mul|' + 'multu?|nop|nor|ori?|rotrv?|sb|sc|se[bh]|sh|sllv?|slti?u?|srav?|' + 'srlv?|subu?|sw[lr]?|xori?|wsbh|' +
      // floating-point instructions
      'abs\\.[sd]|add\\.[sd]|alnv.ps|bc1[ft]l?|' + 'c\\.(s?f|un|u?eq|[ou]lt|[ou]le|ngle?|seq|l[et]|ng[et])\\.[sd]|' + '(ceil|floor|round|trunc)\\.[lw]\\.[sd]|cfc1|cvt\\.d\\.[lsw]|' + 'cvt\\.l\\.[dsw]|cvt\\.ps\\.s|cvt\\.s\\.[dlw]|cvt\\.s\\.p[lu]|cvt\\.w\\.[dls]|' + 'div\\.[ds]|ldx?c1|luxc1|lwx?c1|madd\\.[sd]|mfc1|mov[fntz]?\\.[ds]|' + 'msub\\.[sd]|mth?c1|mul\\.[ds]|neg\\.[ds]|nmadd\\.[ds]|nmsub\\.[ds]|' + 'p[lu][lu]\\.ps|recip\\.fmt|r?sqrt\\.[ds]|sdx?c1|sub\\.[ds]|suxc1|' + 'swx?c1|' +
      // system control instructions
      'break|cache|d?eret|[de]i|ehb|mfc0|mtc0|pause|prefx?|rdhwr|' + 'rdpgpr|sdbbp|ssnop|synci?|syscall|teqi?|tgei?u?|tlb(p|r|w[ir])|' + 'tlti?u?|tnei?|wait|wrpgpr' + ')',
      end: '\\s'
    },
    // lines ending with ; or # aren't really comments, probably auto-detect fail
    hljs.COMMENT('[;#](?!\\s*$)', '$'), hljs.C_BLOCK_COMMENT_MODE, hljs.QUOTE_STRING_MODE, {
      className: 'string',
      begin: '\'',
      end: '[^\\\\]\'',
      relevance: 0
    }, {
      className: 'title',
      begin: '\\|',
      end: '\\|',
      illegal: '\\n',
      relevance: 0
    }, {
      className: 'number',
      variants: [{
        // hex
        begin: '0x[0-9a-f]+'
      }, {
        // bare number
        begin: '\\b-?\\d+'
      }],
      relevance: 0
    }, {
      className: 'symbol',
      variants: [{
        // GNU MIPS syntax
        begin: '^\\s*[a-z_\\.\\$][a-z0-9_\\.\\$]+:'
      }, {
        // numbered local labels
        begin: '^\\s*[0-9]+:'
      }, {
        // number local label reference (backwards, forwards)
        begin: '[0-9]+[bf]'
      }],
      relevance: 0
    }],
    // forward slashes are not allowed
    illegal: /\//
  };
}
module.exports = mipsasm;

/***/ }),

/***/ 51183:
/***/ ((module) => {

/*
Language: Mizar
Description: The Mizar Language is a formal language derived from the mathematical vernacular.
Author: Kelley van Evert <kelleyvanevert@gmail.com>
Website: http://mizar.org/language/
Category: scientific
*/

function mizar(hljs) {
  return {
    name: 'Mizar',
    keywords: 'environ vocabularies notations constructors definitions ' + 'registrations theorems schemes requirements begin end definition ' + 'registration cluster existence pred func defpred deffunc theorem ' + 'proof let take assume then thus hence ex for st holds consider ' + 'reconsider such that and in provided of as from be being by means ' + 'equals implies iff redefine define now not or attr is mode ' + 'suppose per cases set thesis contradiction scheme reserve struct ' + 'correctness compatibility coherence symmetry assymetry ' + 'reflexivity irreflexivity connectedness uniqueness commutativity ' + 'idempotence involutiveness projectivity',
    contains: [hljs.COMMENT('::', '$')]
  };
}
module.exports = mizar;

/***/ }),

/***/ 83219:
/***/ ((module) => {

/*
Language: Mojolicious
Requires: xml.js, perl.js
Author: Dotan Dimet <dotan@corky.net>
Description: Mojolicious .ep (Embedded Perl) templates
Website: https://mojolicious.org
Category: template
*/
function mojolicious(hljs) {
  return {
    name: 'Mojolicious',
    subLanguage: 'xml',
    contains: [{
      className: 'meta',
      begin: '^__(END|DATA)__$'
    },
    // mojolicious line
    {
      begin: "^\\s*%{1,2}={0,2}",
      end: '$',
      subLanguage: 'perl'
    },
    // mojolicious block
    {
      begin: "<%{1,2}={0,2}",
      end: "={0,1}%>",
      subLanguage: 'perl',
      excludeBegin: true,
      excludeEnd: true
    }]
  };
}
module.exports = mojolicious;

/***/ }),

/***/ 97808:
/***/ ((module) => {

/*
Language: Monkey
Description: Monkey2 is an easy to use, cross platform, games oriented programming language from Blitz Research.
Author: Arthur Bikmullin <devolonter@gmail.com>
Website: https://blitzresearch.itch.io/monkey2
*/

function monkey(hljs) {
  var NUMBER = {
    className: 'number',
    relevance: 0,
    variants: [{
      begin: '[$][a-fA-F0-9]+'
    }, hljs.NUMBER_MODE]
  };
  return {
    name: 'Monkey',
    case_insensitive: true,
    keywords: {
      keyword: 'public private property continue exit extern new try catch ' + 'eachin not abstract final select case default const local global field ' + 'end if then else elseif endif while wend repeat until forever for ' + 'to step next return module inline throw import',
      built_in: 'DebugLog DebugStop Error Print ACos ACosr ASin ASinr ATan ATan2 ATan2r ATanr Abs Abs Ceil ' + 'Clamp Clamp Cos Cosr Exp Floor Log Max Max Min Min Pow Sgn Sgn Sin Sinr Sqrt Tan Tanr Seed PI HALFPI TWOPI',
      literal: 'true false null and or shl shr mod'
    },
    illegal: /\/\*/,
    contains: [hljs.COMMENT('#rem', '#end'), hljs.COMMENT("'", '$', {
      relevance: 0
    }), {
      className: 'function',
      beginKeywords: 'function method',
      end: '[(=:]|$',
      illegal: /\n/,
      contains: [hljs.UNDERSCORE_TITLE_MODE]
    }, {
      className: 'class',
      beginKeywords: 'class interface',
      end: '$',
      contains: [{
        beginKeywords: 'extends implements'
      }, hljs.UNDERSCORE_TITLE_MODE]
    }, {
      className: 'built_in',
      begin: '\\b(self|super)\\b'
    }, {
      className: 'meta',
      begin: '\\s*#',
      end: '$',
      keywords: {
        'meta-keyword': 'if else elseif endif end then'
      }
    }, {
      className: 'meta',
      begin: '^\\s*strict\\b'
    }, {
      beginKeywords: 'alias',
      end: '=',
      contains: [hljs.UNDERSCORE_TITLE_MODE]
    }, hljs.QUOTE_STRING_MODE, NUMBER]
  };
}
module.exports = monkey;

/***/ }),

/***/ 17525:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
/*
Language: MoonScript
Author: Billy Quith <chinbillybilbo@gmail.com>
Description: MoonScript is a programming language that transcompiles to Lua.
Origin: coffeescript.js
Website: http://moonscript.org/
Category: scripting
*/

function moonscript(hljs) {
  var KEYWORDS = {
    keyword:
    // Moonscript keywords
    'if then not for in while do return else elseif break continue switch and or ' + 'unless when class extends super local import export from using',
    literal: 'true false nil',
    built_in: '_G _VERSION assert collectgarbage dofile error getfenv getmetatable ipairs load ' + 'loadfile loadstring module next pairs pcall print rawequal rawget rawset require ' + 'select setfenv setmetatable tonumber tostring type unpack xpcall coroutine debug ' + 'io math os package string table'
  };
  var JS_IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
  var SUBST = {
    className: 'subst',
    begin: /#\{/,
    end: /\}/,
    keywords: KEYWORDS
  };
  var EXPRESSIONS = [hljs.inherit(hljs.C_NUMBER_MODE, {
    starts: {
      end: '(\\s*/)?',
      relevance: 0
    }
  }),
  // a number tries to eat the following slash to prevent treating it as a regexp
  {
    className: 'string',
    variants: [{
      begin: /'/,
      end: /'/,
      contains: [hljs.BACKSLASH_ESCAPE]
    }, {
      begin: /"/,
      end: /"/,
      contains: [hljs.BACKSLASH_ESCAPE, SUBST]
    }]
  }, {
    className: 'built_in',
    begin: '@__' + hljs.IDENT_RE
  }, {
    begin: '@' + hljs.IDENT_RE // relevance booster on par with CoffeeScript
  }, {
    begin: hljs.IDENT_RE + '\\\\' + hljs.IDENT_RE // inst\method
  }];

  SUBST.contains = EXPRESSIONS;
  var TITLE = hljs.inherit(hljs.TITLE_MODE, {
    begin: JS_IDENT_RE
  });
  var POSSIBLE_PARAMS_RE = '(\\(.*\\)\\s*)?\\B[-=]>';
  var PARAMS = {
    className: 'params',
    begin: '\\([^\\(]',
    returnBegin: true,
    /* We need another contained nameless mode to not have every nested
    pair of parens to be called "params" */
    contains: [{
      begin: /\(/,
      end: /\)/,
      keywords: KEYWORDS,
      contains: ['self'].concat(EXPRESSIONS)
    }]
  };
  return {
    name: 'MoonScript',
    aliases: ['moon'],
    keywords: KEYWORDS,
    illegal: /\/\*/,
    contains: EXPRESSIONS.concat([hljs.COMMENT('--', '$'), {
      className: 'function',
      // function: -> =>
      begin: '^\\s*' + JS_IDENT_RE + '\\s*=\\s*' + POSSIBLE_PARAMS_RE,
      end: '[-=]>',
      returnBegin: true,
      contains: [TITLE, PARAMS]
    }, {
      begin: /[\(,:=]\s*/,
      // anonymous function start
      relevance: 0,
      contains: [{
        className: 'function',
        begin: POSSIBLE_PARAMS_RE,
        end: '[-=]>',
        returnBegin: true,
        contains: [PARAMS]
      }]
    }, {
      className: 'class',
      beginKeywords: 'class',
      end: '$',
      illegal: /[:="\[\]]/,
      contains: [{
        beginKeywords: 'extends',
        endsWithParent: true,
        illegal: /[:="\[\]]/,
        contains: [TITLE]
      }, TITLE]
    }, {
      className: 'name',
      // table
      begin: JS_IDENT_RE + ':',
      end: ':',
      returnBegin: true,
      returnEnd: true,
      relevance: 0
    }])
  };
}
module.exports = moonscript;

/***/ }),

/***/ 5290:
/***/ ((module) => {

/*
 Language: N1QL
 Author: Andres Täht <andres.taht@gmail.com>
 Contributors: Rene Saarsoo <nene@triin.net>
 Description: Couchbase query language
 Website: https://www.couchbase.com/products/n1ql
 */

function n1ql(hljs) {
  return {
    name: 'N1QL',
    case_insensitive: true,
    contains: [{
      beginKeywords: 'build create index delete drop explain infer|10 insert merge prepare select update upsert|10',
      end: /;/,
      endsWithParent: true,
      keywords: {
        // Taken from http://developer.couchbase.com/documentation/server/current/n1ql/n1ql-language-reference/reservedwords.html
        keyword: 'all alter analyze and any array as asc begin between binary boolean break bucket build by call ' + 'case cast cluster collate collection commit connect continue correlate cover create database ' + 'dataset datastore declare decrement delete derived desc describe distinct do drop each element ' + 'else end every except exclude execute exists explain fetch first flatten for force from ' + 'function grant group gsi having if ignore ilike in include increment index infer inline inner ' + 'insert intersect into is join key keys keyspace known last left let letting like limit lsm map ' + 'mapping matched materialized merge minus namespace nest not number object offset on ' + 'option or order outer over parse partition password path pool prepare primary private privilege ' + 'procedure public raw realm reduce rename return returning revoke right role rollback satisfies ' + 'schema select self semi set show some start statistics string system then to transaction trigger ' + 'truncate under union unique unknown unnest unset update upsert use user using validate value ' + 'valued values via view when where while with within work xor',
        // Taken from http://developer.couchbase.com/documentation/server/4.5/n1ql/n1ql-language-reference/literals.html
        literal: 'true false null missing|5',
        // Taken from http://developer.couchbase.com/documentation/server/4.5/n1ql/n1ql-language-reference/functions.html
        built_in: 'array_agg array_append array_concat array_contains array_count array_distinct array_ifnull array_length ' + 'array_max array_min array_position array_prepend array_put array_range array_remove array_repeat array_replace ' + 'array_reverse array_sort array_sum avg count max min sum greatest least ifmissing ifmissingornull ifnull ' + 'missingif nullif ifinf ifnan ifnanorinf naninf neginfif posinfif clock_millis clock_str date_add_millis ' + 'date_add_str date_diff_millis date_diff_str date_part_millis date_part_str date_trunc_millis date_trunc_str ' + 'duration_to_str millis str_to_millis millis_to_str millis_to_utc millis_to_zone_name now_millis now_str ' + 'str_to_duration str_to_utc str_to_zone_name decode_json encode_json encoded_size poly_length base64 base64_encode ' + 'base64_decode meta uuid abs acos asin atan atan2 ceil cos degrees e exp ln log floor pi power radians random ' + 'round sign sin sqrt tan trunc object_length object_names object_pairs object_inner_pairs object_values ' + 'object_inner_values object_add object_put object_remove object_unwrap regexp_contains regexp_like regexp_position ' + 'regexp_replace contains initcap length lower ltrim position repeat replace rtrim split substr title trim upper ' + 'isarray isatom isboolean isnumber isobject isstring type toarray toatom toboolean tonumber toobject tostring'
      },
      contains: [{
        className: 'string',
        begin: '\'',
        end: '\'',
        contains: [hljs.BACKSLASH_ESCAPE]
      }, {
        className: 'string',
        begin: '"',
        end: '"',
        contains: [hljs.BACKSLASH_ESCAPE]
      }, {
        className: 'symbol',
        begin: '`',
        end: '`',
        contains: [hljs.BACKSLASH_ESCAPE],
        relevance: 2
      }, hljs.C_NUMBER_MODE, hljs.C_BLOCK_COMMENT_MODE]
    }, hljs.C_BLOCK_COMMENT_MODE]
  };
}
module.exports = n1ql;

/***/ }),

/***/ 19837:
/***/ ((module) => {

/*
Language: Nginx config
Author: Peter Leonov <gojpeg@yandex.ru>
Contributors: Ivan Sagalaev <maniac@softwaremaniacs.org>
Category: common, config
Website: https://www.nginx.com
*/

function nginx(hljs) {
  var VAR = {
    className: 'variable',
    variants: [{
      begin: /\$\d+/
    }, {
      begin: /\$\{/,
      end: /\}/
    }, {
      begin: /[$@]/ + hljs.UNDERSCORE_IDENT_RE
    }]
  };
  var DEFAULT = {
    endsWithParent: true,
    keywords: {
      $pattern: '[a-z/_]+',
      literal: 'on off yes no true false none blocked debug info notice warn error crit ' + 'select break last permanent redirect kqueue rtsig epoll poll /dev/poll'
    },
    relevance: 0,
    illegal: '=>',
    contains: [hljs.HASH_COMMENT_MODE, {
      className: 'string',
      contains: [hljs.BACKSLASH_ESCAPE, VAR],
      variants: [{
        begin: /"/,
        end: /"/
      }, {
        begin: /'/,
        end: /'/
      }]
    },
    // this swallows entire URLs to avoid detecting numbers within
    {
      begin: '([a-z]+):/',
      end: '\\s',
      endsWithParent: true,
      excludeEnd: true,
      contains: [VAR]
    }, {
      className: 'regexp',
      contains: [hljs.BACKSLASH_ESCAPE, VAR],
      variants: [{
        begin: "\\s\\^",
        end: "\\s|\\{|;",
        returnEnd: true
      },
      // regexp locations (~, ~*)
      {
        begin: "~\\*?\\s+",
        end: "\\s|\\{|;",
        returnEnd: true
      },
      // *.example.com
      {
        begin: "\\*(\\.[a-z\\-]+)+"
      },
      // sub.example.*
      {
        begin: "([a-z\\-]+\\.)+\\*"
      }]
    },
    // IP
    {
      className: 'number',
      begin: '\\b\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}(:\\d{1,5})?\\b'
    },
    // units
    {
      className: 'number',
      begin: '\\b\\d+[kKmMgGdshdwy]*\\b',
      relevance: 0
    }, VAR]
  };
  return {
    name: 'Nginx config',
    aliases: ['nginxconf'],
    contains: [hljs.HASH_COMMENT_MODE, {
      begin: hljs.UNDERSCORE_IDENT_RE + '\\s+\\{',
      returnBegin: true,
      end: /\{/,
      contains: [{
        className: 'section',
        begin: hljs.UNDERSCORE_IDENT_RE
      }],
      relevance: 0
    }, {
      begin: hljs.UNDERSCORE_IDENT_RE + '\\s',
      end: ';|\\{',
      returnBegin: true,
      contains: [{
        className: 'attribute',
        begin: hljs.UNDERSCORE_IDENT_RE,
        starts: DEFAULT
      }],
      relevance: 0
    }],
    illegal: '[^\\s\\}]'
  };
}
module.exports = nginx;

/***/ }),

/***/ 34233:
/***/ ((module) => {

/*
Language: Nim
Description: Nim is a statically typed compiled systems programming language.
Website: https://nim-lang.org
Category: system
*/

function nim(hljs) {
  return {
    name: 'Nim',
    keywords: {
      keyword: 'addr and as asm bind block break case cast const continue converter ' + 'discard distinct div do elif else end enum except export finally ' + 'for from func generic if import in include interface is isnot iterator ' + 'let macro method mixin mod nil not notin object of or out proc ptr ' + 'raise ref return shl shr static template try tuple type using var ' + 'when while with without xor yield',
      literal: 'shared guarded stdin stdout stderr result true false',
      built_in: 'int int8 int16 int32 int64 uint uint8 uint16 uint32 uint64 float ' + 'float32 float64 bool char string cstring pointer expr stmt void ' + 'auto any range array openarray varargs seq set clong culong cchar ' + 'cschar cshort cint csize clonglong cfloat cdouble clongdouble ' + 'cuchar cushort cuint culonglong cstringarray semistatic'
    },
    contains: [{
      className: 'meta',
      // Actually pragma
      begin: /\{\./,
      end: /\.\}/,
      relevance: 10
    }, {
      className: 'string',
      begin: /[a-zA-Z]\w*"/,
      end: /"/,
      contains: [{
        begin: /""/
      }]
    }, {
      className: 'string',
      begin: /([a-zA-Z]\w*)?"""/,
      end: /"""/
    }, hljs.QUOTE_STRING_MODE, {
      className: 'type',
      begin: /\b[A-Z]\w+\b/,
      relevance: 0
    }, {
      className: 'number',
      relevance: 0,
      variants: [{
        begin: /\b(0[xX][0-9a-fA-F][_0-9a-fA-F]*)('?[iIuU](8|16|32|64))?/
      }, {
        begin: /\b(0o[0-7][_0-7]*)('?[iIuUfF](8|16|32|64))?/
      }, {
        begin: /\b(0(b|B)[01][_01]*)('?[iIuUfF](8|16|32|64))?/
      }, {
        begin: /\b(\d[_\d]*)('?[iIuUfF](8|16|32|64))?/
      }]
    }, hljs.HASH_COMMENT_MODE]
  };
}
module.exports = nim;

/***/ }),

/***/ 40402:
/***/ ((module) => {

/*
Language: Nix
Author: Domen Kožar <domen@dev.si>
Description: Nix functional language
Website: http://nixos.org/nix
*/

function nix(hljs) {
  var NIX_KEYWORDS = {
    keyword: 'rec with let in inherit assert if else then',
    literal: 'true false or and null',
    built_in: 'import abort baseNameOf dirOf isNull builtins map removeAttrs throw ' + 'toString derivation'
  };
  var ANTIQUOTE = {
    className: 'subst',
    begin: /\$\{/,
    end: /\}/,
    keywords: NIX_KEYWORDS
  };
  var ATTRS = {
    begin: /[a-zA-Z0-9-_]+(\s*=)/,
    returnBegin: true,
    relevance: 0,
    contains: [{
      className: 'attr',
      begin: /\S+/
    }]
  };
  var STRING = {
    className: 'string',
    contains: [ANTIQUOTE],
    variants: [{
      begin: "''",
      end: "''"
    }, {
      begin: '"',
      end: '"'
    }]
  };
  var EXPRESSIONS = [hljs.NUMBER_MODE, hljs.HASH_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, STRING, ATTRS];
  ANTIQUOTE.contains = EXPRESSIONS;
  return {
    name: 'Nix',
    aliases: ["nixos"],
    keywords: NIX_KEYWORDS,
    contains: EXPRESSIONS
  };
}
module.exports = nix;

/***/ }),

/***/ 36923:
/***/ ((module) => {

/*
Language: Node REPL
Requires: javascript.js
Author: Marat Nagayev <nagaevmt@yandex.ru>
Category: scripting
*/

/** @type LanguageFn */
function nodeRepl(hljs) {
  return {
    name: 'Node REPL',
    contains: [{
      className: 'meta',
      starts: {
        // a space separates the REPL prefix from the actual code
        // this is purely for cleaner HTML output
        end: / |$/,
        starts: {
          end: '$',
          subLanguage: 'javascript'
        }
      },
      variants: [{
        begin: /^>(?=[ ]|$)/
      }, {
        begin: /^\.\.\.(?=[ ]|$)/
      }]
    }]
  };
}
module.exports = nodeRepl;

/***/ }),

/***/ 39111:
/***/ ((module) => {

/*
Language: NSIS
Description: Nullsoft Scriptable Install System
Author: Jan T. Sott <jan.sott@gmail.com>
Website: https://nsis.sourceforge.io/Main_Page
*/

function nsis(hljs) {
  var CONSTANTS = {
    className: 'variable',
    begin: /\$(ADMINTOOLS|APPDATA|CDBURN_AREA|CMDLINE|COMMONFILES32|COMMONFILES64|COMMONFILES|COOKIES|DESKTOP|DOCUMENTS|EXEDIR|EXEFILE|EXEPATH|FAVORITES|FONTS|HISTORY|HWNDPARENT|INSTDIR|INTERNET_CACHE|LANGUAGE|LOCALAPPDATA|MUSIC|NETHOOD|OUTDIR|PICTURES|PLUGINSDIR|PRINTHOOD|PROFILE|PROGRAMFILES32|PROGRAMFILES64|PROGRAMFILES|QUICKLAUNCH|RECENT|RESOURCES_LOCALIZED|RESOURCES|SENDTO|SMPROGRAMS|SMSTARTUP|STARTMENU|SYSDIR|TEMP|TEMPLATES|VIDEOS|WINDIR)/
  };
  var DEFINES = {
    // ${defines}
    className: 'variable',
    begin: /\$+\{[\w.:-]+\}/
  };
  var VARIABLES = {
    // $variables
    className: 'variable',
    begin: /\$+\w+/,
    illegal: /\(\)\{\}/
  };
  var LANGUAGES = {
    // $(language_strings)
    className: 'variable',
    begin: /\$+\([\w^.:-]+\)/
  };
  var PARAMETERS = {
    // command parameters
    className: 'params',
    begin: '(ARCHIVE|FILE_ATTRIBUTE_ARCHIVE|FILE_ATTRIBUTE_NORMAL|FILE_ATTRIBUTE_OFFLINE|FILE_ATTRIBUTE_READONLY|FILE_ATTRIBUTE_SYSTEM|FILE_ATTRIBUTE_TEMPORARY|HKCR|HKCU|HKDD|HKEY_CLASSES_ROOT|HKEY_CURRENT_CONFIG|HKEY_CURRENT_USER|HKEY_DYN_DATA|HKEY_LOCAL_MACHINE|HKEY_PERFORMANCE_DATA|HKEY_USERS|HKLM|HKPD|HKU|IDABORT|IDCANCEL|IDIGNORE|IDNO|IDOK|IDRETRY|IDYES|MB_ABORTRETRYIGNORE|MB_DEFBUTTON1|MB_DEFBUTTON2|MB_DEFBUTTON3|MB_DEFBUTTON4|MB_ICONEXCLAMATION|MB_ICONINFORMATION|MB_ICONQUESTION|MB_ICONSTOP|MB_OK|MB_OKCANCEL|MB_RETRYCANCEL|MB_RIGHT|MB_RTLREADING|MB_SETFOREGROUND|MB_TOPMOST|MB_USERICON|MB_YESNO|NORMAL|OFFLINE|READONLY|SHCTX|SHELL_CONTEXT|SYSTEM|TEMPORARY)'
  };
  var COMPILER = {
    // !compiler_flags
    className: 'keyword',
    begin: /!(addincludedir|addplugindir|appendfile|cd|define|delfile|echo|else|endif|error|execute|finalize|getdllversion|gettlbversion|if|ifdef|ifmacrodef|ifmacrondef|ifndef|include|insertmacro|macro|macroend|makensis|packhdr|searchparse|searchreplace|system|tempfile|undef|verbose|warning)/
  };
  var METACHARS = {
    // $\n, $\r, $\t, $$
    className: 'meta',
    begin: /\$(\\[nrt]|\$)/
  };
  var PLUGINS = {
    // plug::ins
    className: 'class',
    begin: /\w+::\w+/
  };
  var STRING = {
    className: 'string',
    variants: [{
      begin: '"',
      end: '"'
    }, {
      begin: '\'',
      end: '\''
    }, {
      begin: '`',
      end: '`'
    }],
    illegal: /\n/,
    contains: [METACHARS, CONSTANTS, DEFINES, VARIABLES, LANGUAGES]
  };
  return {
    name: 'NSIS',
    case_insensitive: false,
    keywords: {
      keyword: 'Abort AddBrandingImage AddSize AllowRootDirInstall AllowSkipFiles AutoCloseWindow BGFont BGGradient BrandingText BringToFront Call CallInstDLL Caption ChangeUI CheckBitmap ClearErrors CompletedText ComponentText CopyFiles CRCCheck CreateDirectory CreateFont CreateShortCut Delete DeleteINISec DeleteINIStr DeleteRegKey DeleteRegValue DetailPrint DetailsButtonText DirText DirVar DirVerify EnableWindow EnumRegKey EnumRegValue Exch Exec ExecShell ExecShellWait ExecWait ExpandEnvStrings File FileBufSize FileClose FileErrorText FileOpen FileRead FileReadByte FileReadUTF16LE FileReadWord FileWriteUTF16LE FileSeek FileWrite FileWriteByte FileWriteWord FindClose FindFirst FindNext FindWindow FlushINI GetCurInstType GetCurrentAddress GetDlgItem GetDLLVersion GetDLLVersionLocal GetErrorLevel GetFileTime GetFileTimeLocal GetFullPathName GetFunctionAddress GetInstDirError GetKnownFolderPath GetLabelAddress GetTempFileName Goto HideWindow Icon IfAbort IfErrors IfFileExists IfRebootFlag IfRtlLanguage IfShellVarContextAll IfSilent InitPluginsDir InstallButtonText InstallColors InstallDir InstallDirRegKey InstProgressFlags InstType InstTypeGetText InstTypeSetText Int64Cmp Int64CmpU Int64Fmt IntCmp IntCmpU IntFmt IntOp IntPtrCmp IntPtrCmpU IntPtrOp IsWindow LangString LicenseBkColor LicenseData LicenseForceSelection LicenseLangString LicenseText LoadAndSetImage LoadLanguageFile LockWindow LogSet LogText ManifestDPIAware ManifestLongPathAware ManifestMaxVersionTested ManifestSupportedOS MessageBox MiscButtonText Name Nop OutFile Page PageCallbacks PEAddResource PEDllCharacteristics PERemoveResource PESubsysVer Pop Push Quit ReadEnvStr ReadINIStr ReadRegDWORD ReadRegStr Reboot RegDLL Rename RequestExecutionLevel ReserveFile Return RMDir SearchPath SectionGetFlags SectionGetInstTypes SectionGetSize SectionGetText SectionIn SectionSetFlags SectionSetInstTypes SectionSetSize SectionSetText SendMessage SetAutoClose SetBrandingImage SetCompress SetCompressor SetCompressorDictSize SetCtlColors SetCurInstType SetDatablockOptimize SetDateSave SetDetailsPrint SetDetailsView SetErrorLevel SetErrors SetFileAttributes SetFont SetOutPath SetOverwrite SetRebootFlag SetRegView SetShellVarContext SetSilent ShowInstDetails ShowUninstDetails ShowWindow SilentInstall SilentUnInstall Sleep SpaceTexts StrCmp StrCmpS StrCpy StrLen SubCaption Unicode UninstallButtonText UninstallCaption UninstallIcon UninstallSubCaption UninstallText UninstPage UnRegDLL Var VIAddVersionKey VIFileVersion VIProductVersion WindowIcon WriteINIStr WriteRegBin WriteRegDWORD WriteRegExpandStr WriteRegMultiStr WriteRegNone WriteRegStr WriteUninstaller XPStyle',
      literal: 'admin all auto both bottom bzip2 colored components current custom directory false force hide highest ifdiff ifnewer instfiles lastused leave left license listonly lzma nevershow none normal notset off on open print right show silent silentlog smooth textonly top true try un.components un.custom un.directory un.instfiles un.license uninstConfirm user Win10 Win7 Win8 WinVista zlib'
    },
    contains: [hljs.HASH_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.COMMENT(';', '$', {
      relevance: 0
    }), {
      className: 'function',
      beginKeywords: 'Function PageEx Section SectionGroup',
      end: '$'
    }, STRING, COMPILER, DEFINES, VARIABLES, LANGUAGES, PARAMETERS, PLUGINS, hljs.NUMBER_MODE]
  };
}
module.exports = nsis;

/***/ }),

/***/ 59942:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(74916);
__webpack_require__(23123);
/*
Language: Objective-C
Author: Valerii Hiora <valerii.hiora@gmail.com>
Contributors: Angel G. Olloqui <angelgarcia.mail@gmail.com>, Matt Diephouse <matt@diephouse.com>, Andrew Farmer <ahfarmer@gmail.com>, Minh Nguyễn <mxn@1ec5.org>
Website: https://developer.apple.com/documentation/objectivec
Category: common
*/

function objectivec(hljs) {
  var API_CLASS = {
    className: 'built_in',
    begin: '\\b(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)\\w+'
  };
  var IDENTIFIER_RE = /[a-zA-Z@][a-zA-Z0-9_]*/;
  var OBJC_KEYWORDS = {
    $pattern: IDENTIFIER_RE,
    keyword: 'int float while char export sizeof typedef const struct for union ' + 'unsigned long volatile static bool mutable if do return goto void ' + 'enum else break extern asm case short default double register explicit ' + 'signed typename this switch continue wchar_t inline readonly assign ' + 'readwrite self @synchronized id typeof ' + 'nonatomic super unichar IBOutlet IBAction strong weak copy ' + 'in out inout bycopy byref oneway __strong __weak __block __autoreleasing ' + '@private @protected @public @try @property @end @throw @catch @finally ' + '@autoreleasepool @synthesize @dynamic @selector @optional @required ' + '@encode @package @import @defs @compatibility_alias ' + '__bridge __bridge_transfer __bridge_retained __bridge_retain ' + '__covariant __contravariant __kindof ' + '_Nonnull _Nullable _Null_unspecified ' + '__FUNCTION__ __PRETTY_FUNCTION__ __attribute__ ' + 'getter setter retain unsafe_unretained ' + 'nonnull nullable null_unspecified null_resettable class instancetype ' + 'NS_DESIGNATED_INITIALIZER NS_UNAVAILABLE NS_REQUIRES_SUPER ' + 'NS_RETURNS_INNER_POINTER NS_INLINE NS_AVAILABLE NS_DEPRECATED ' + 'NS_ENUM NS_OPTIONS NS_SWIFT_UNAVAILABLE ' + 'NS_ASSUME_NONNULL_BEGIN NS_ASSUME_NONNULL_END ' + 'NS_REFINED_FOR_SWIFT NS_SWIFT_NAME NS_SWIFT_NOTHROW ' + 'NS_DURING NS_HANDLER NS_ENDHANDLER NS_VALUERETURN NS_VOIDRETURN',
    literal: 'false true FALSE TRUE nil YES NO NULL',
    built_in: 'BOOL dispatch_once_t dispatch_queue_t dispatch_sync dispatch_async dispatch_once'
  };
  var CLASS_KEYWORDS = {
    $pattern: IDENTIFIER_RE,
    keyword: '@interface @class @protocol @implementation'
  };
  return {
    name: 'Objective-C',
    aliases: ['mm', 'objc', 'obj-c', 'obj-c++', 'objective-c++'],
    keywords: OBJC_KEYWORDS,
    illegal: '</',
    contains: [API_CLASS, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.C_NUMBER_MODE, hljs.QUOTE_STRING_MODE, hljs.APOS_STRING_MODE, {
      className: 'string',
      variants: [{
        begin: '@"',
        end: '"',
        illegal: '\\n',
        contains: [hljs.BACKSLASH_ESCAPE]
      }]
    }, {
      className: 'meta',
      begin: /#\s*[a-z]+\b/,
      end: /$/,
      keywords: {
        'meta-keyword': 'if else elif endif define undef warning error line ' + 'pragma ifdef ifndef include'
      },
      contains: [{
        begin: /\\\n/,
        relevance: 0
      }, hljs.inherit(hljs.QUOTE_STRING_MODE, {
        className: 'meta-string'
      }), {
        className: 'meta-string',
        begin: /<.*?>/,
        end: /$/,
        illegal: '\\n'
      }, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE]
    }, {
      className: 'class',
      begin: '(' + CLASS_KEYWORDS.keyword.split(' ').join('|') + ')\\b',
      end: /(\{|$)/,
      excludeEnd: true,
      keywords: CLASS_KEYWORDS,
      contains: [hljs.UNDERSCORE_TITLE_MODE]
    }, {
      begin: '\\.' + hljs.UNDERSCORE_IDENT_RE,
      relevance: 0
    }]
  };
}
module.exports = objectivec;

/***/ }),

/***/ 22171:
/***/ ((module) => {

/*
Language: OCaml
Author: Mehdi Dogguy <mehdi@dogguy.org>
Contributors: Nicolas Braud-Santoni <nicolas.braud-santoni@ens-cachan.fr>, Mickael Delahaye <mickael.delahaye@gmail.com>
Description: OCaml language definition.
Website: https://ocaml.org
Category: functional
*/

function ocaml(hljs) {
  /* missing support for heredoc-like string (OCaml 4.0.2+) */
  return {
    name: 'OCaml',
    aliases: ['ml'],
    keywords: {
      $pattern: '[a-z_]\\w*!?',
      keyword: 'and as assert asr begin class constraint do done downto else end ' + 'exception external for fun function functor if in include ' + 'inherit! inherit initializer land lazy let lor lsl lsr lxor match method!|10 method ' + 'mod module mutable new object of open! open or private rec sig struct ' + 'then to try type val! val virtual when while with ' + /* camlp4 */
      'parser value',
      built_in: /* built-in types */
      'array bool bytes char exn|5 float int int32 int64 list lazy_t|5 nativeint|5 string unit ' + /* (some) types in Pervasives */
      'in_channel out_channel ref',
      literal: 'true false'
    },
    illegal: /\/\/|>>/,
    contains: [{
      className: 'literal',
      begin: '\\[(\\|\\|)?\\]|\\(\\)',
      relevance: 0
    }, hljs.COMMENT('\\(\\*', '\\*\\)', {
      contains: ['self']
    }), {
      /* type variable */
      className: 'symbol',
      begin: '\'[A-Za-z_](?!\')[\\w\']*'
      /* the grammar is ambiguous on how 'a'b should be interpreted but not the compiler */
    }, {
      /* polymorphic variant */
      className: 'type',
      begin: '`[A-Z][\\w\']*'
    }, {
      /* module or constructor */
      className: 'type',
      begin: '\\b[A-Z][\\w\']*',
      relevance: 0
    }, {
      /* don't color identifiers, but safely catch all identifiers with '*/
      begin: '[a-z_]\\w*\'[\\w\']*',
      relevance: 0
    }, hljs.inherit(hljs.APOS_STRING_MODE, {
      className: 'string',
      relevance: 0
    }), hljs.inherit(hljs.QUOTE_STRING_MODE, {
      illegal: null
    }), {
      className: 'number',
      begin: '\\b(0[xX][a-fA-F0-9_]+[Lln]?|' + '0[oO][0-7_]+[Lln]?|' + '0[bB][01_]+[Lln]?|' + '[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)',
      relevance: 0
    }, {
      begin: /->/ // relevance booster
    }]
  };
}

module.exports = ocaml;

/***/ }),

/***/ 284:
/***/ ((module) => {

/*
Language: OpenSCAD
Author: Dan Panzarella <alsoelp@gmail.com>
Description: OpenSCAD is a language for the 3D CAD modeling software of the same name.
Website: https://www.openscad.org
Category: scientific
*/

function openscad(hljs) {
  var SPECIAL_VARS = {
    className: 'keyword',
    begin: '\\$(f[asn]|t|vp[rtd]|children)'
  };
  var LITERALS = {
    className: 'literal',
    begin: 'false|true|PI|undef'
  };
  var NUMBERS = {
    className: 'number',
    begin: '\\b\\d+(\\.\\d+)?(e-?\\d+)?',
    // adds 1e5, 1e-10
    relevance: 0
  };
  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {
    illegal: null
  });
  var PREPRO = {
    className: 'meta',
    keywords: {
      'meta-keyword': 'include use'
    },
    begin: 'include|use <',
    end: '>'
  };
  var PARAMS = {
    className: 'params',
    begin: '\\(',
    end: '\\)',
    contains: ['self', NUMBERS, STRING, SPECIAL_VARS, LITERALS]
  };
  var MODIFIERS = {
    begin: '[*!#%]',
    relevance: 0
  };
  var FUNCTIONS = {
    className: 'function',
    beginKeywords: 'module function',
    end: /=|\{/,
    contains: [PARAMS, hljs.UNDERSCORE_TITLE_MODE]
  };
  return {
    name: 'OpenSCAD',
    aliases: ['scad'],
    keywords: {
      keyword: 'function module include use for intersection_for if else \\%',
      literal: 'false true PI undef',
      built_in: 'circle square polygon text sphere cube cylinder polyhedron translate rotate scale resize mirror multmatrix color offset hull minkowski union difference intersection abs sign sin cos tan acos asin atan atan2 floor round ceil ln log pow sqrt exp rands min max concat lookup str chr search version version_num norm cross parent_module echo import import_dxf dxf_linear_extrude linear_extrude rotate_extrude surface projection render children dxf_cross dxf_dim let assign'
    },
    contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, NUMBERS, PREPRO, STRING, SPECIAL_VARS, MODIFIERS, FUNCTIONS]
  };
}
module.exports = openscad;

/***/ }),

/***/ 58932:
/***/ ((module) => {

/*
Language: Oxygene
Author: Carlo Kok <ck@remobjects.com>
Description: Oxygene is built on the foundation of Object Pascal, revamped and extended to be a modern language for the twenty-first century.
Website: https://www.elementscompiler.com/elements/default.aspx
*/

function oxygene(hljs) {
  var OXYGENE_KEYWORDS = {
    $pattern: /\.?\w+/,
    keyword: 'abstract add and array as asc aspect assembly async begin break block by case class concat const copy constructor continue ' + 'create default delegate desc distinct div do downto dynamic each else empty end ensure enum equals event except exit extension external false ' + 'final finalize finalizer finally flags for forward from function future global group has if implementation implements implies in index inherited ' + 'inline interface into invariants is iterator join locked locking loop matching method mod module namespace nested new nil not notify nullable of ' + 'old on operator or order out override parallel params partial pinned private procedure property protected public queryable raise read readonly ' + 'record reintroduce remove repeat require result reverse sealed select self sequence set shl shr skip static step soft take then to true try tuple ' + 'type union unit unsafe until uses using var virtual raises volatile where while with write xor yield await mapped deprecated stdcall cdecl pascal ' + 'register safecall overload library platform reference packed strict published autoreleasepool selector strong weak unretained'
  };
  var CURLY_COMMENT = hljs.COMMENT(/\{/, /\}/, {
    relevance: 0
  });
  var PAREN_COMMENT = hljs.COMMENT('\\(\\*', '\\*\\)', {
    relevance: 10
  });
  var STRING = {
    className: 'string',
    begin: '\'',
    end: '\'',
    contains: [{
      begin: '\'\''
    }]
  };
  var CHAR_STRING = {
    className: 'string',
    begin: '(#\\d+)+'
  };
  var FUNCTION = {
    className: 'function',
    beginKeywords: 'function constructor destructor procedure method',
    end: '[:;]',
    keywords: 'function constructor|10 destructor|10 procedure|10 method|10',
    contains: [hljs.TITLE_MODE, {
      className: 'params',
      begin: '\\(',
      end: '\\)',
      keywords: OXYGENE_KEYWORDS,
      contains: [STRING, CHAR_STRING]
    }, CURLY_COMMENT, PAREN_COMMENT]
  };
  return {
    name: 'Oxygene',
    case_insensitive: true,
    keywords: OXYGENE_KEYWORDS,
    illegal: '("|\\$[G-Zg-z]|\\/\\*|</|=>|->)',
    contains: [CURLY_COMMENT, PAREN_COMMENT, hljs.C_LINE_COMMENT_MODE, STRING, CHAR_STRING, hljs.NUMBER_MODE, FUNCTION, {
      className: 'class',
      begin: '=\\bclass\\b',
      end: 'end;',
      keywords: OXYGENE_KEYWORDS,
      contains: [STRING, CHAR_STRING, CURLY_COMMENT, PAREN_COMMENT, hljs.C_LINE_COMMENT_MODE, FUNCTION]
    }]
  };
}
module.exports = oxygene;

/***/ }),

/***/ 88525:
/***/ ((module) => {

/*
Language: Parser3
Requires: xml.js
Author: Oleg Volchkov <oleg@volchkov.net>
Website: https://www.parser.ru/en/
Category: template
*/

function parser3(hljs) {
  var CURLY_SUBCOMMENT = hljs.COMMENT(/\{/, /\}/, {
    contains: ['self']
  });
  return {
    name: 'Parser3',
    subLanguage: 'xml',
    relevance: 0,
    contains: [hljs.COMMENT('^#', '$'), hljs.COMMENT(/\^rem\{/, /\}/, {
      relevance: 10,
      contains: [CURLY_SUBCOMMENT]
    }), {
      className: 'meta',
      begin: '^@(?:BASE|USE|CLASS|OPTIONS)$',
      relevance: 10
    }, {
      className: 'title',
      begin: '@[\\w\\-]+\\[[\\w^;\\-]*\\](?:\\[[\\w^;\\-]*\\])?(?:.*)$'
    }, {
      className: 'variable',
      begin: /\$\{?[\w\-.:]+\}?/
    }, {
      className: 'keyword',
      begin: /\^[\w\-.:]+/
    }, {
      className: 'number',
      begin: '\\^#[0-9a-fA-F]+'
    }, hljs.C_NUMBER_MODE]
  };
}
module.exports = parser3;

/***/ }),

/***/ 93791:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */
function either() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var joined = '(' + args.map(function (x) {
    return source(x);
  }).join("|") + ")";
  return joined;
}

/*
Language: Perl
Author: Peter Leonov <gojpeg@yandex.ru>
Website: https://www.perl.org
Category: common
*/

/** @type LanguageFn */
function perl(hljs) {
  var KEYWORDS = ['abs', 'accept', 'alarm', 'and', 'atan2', 'bind', 'binmode', 'bless', 'break', 'caller', 'chdir', 'chmod', 'chomp', 'chop', 'chown', 'chr', 'chroot', 'close', 'closedir', 'connect', 'continue', 'cos', 'crypt', 'dbmclose', 'dbmopen', 'defined', 'delete', 'die', 'do', 'dump', 'each', 'else', 'elsif', 'endgrent', 'endhostent', 'endnetent', 'endprotoent', 'endpwent', 'endservent', 'eof', 'eval', 'exec', 'exists', 'exit', 'exp', 'fcntl', 'fileno', 'flock', 'for', 'foreach', 'fork', 'format', 'formline', 'getc', 'getgrent', 'getgrgid', 'getgrnam', 'gethostbyaddr', 'gethostbyname', 'gethostent', 'getlogin', 'getnetbyaddr', 'getnetbyname', 'getnetent', 'getpeername', 'getpgrp', 'getpriority', 'getprotobyname', 'getprotobynumber', 'getprotoent', 'getpwent', 'getpwnam', 'getpwuid', 'getservbyname', 'getservbyport', 'getservent', 'getsockname', 'getsockopt', 'given', 'glob', 'gmtime', 'goto', 'grep', 'gt', 'hex', 'if', 'index', 'int', 'ioctl', 'join', 'keys', 'kill', 'last', 'lc', 'lcfirst', 'length', 'link', 'listen', 'local', 'localtime', 'log', 'lstat', 'lt', 'ma', 'map', 'mkdir', 'msgctl', 'msgget', 'msgrcv', 'msgsnd', 'my', 'ne', 'next', 'no', 'not', 'oct', 'open', 'opendir', 'or', 'ord', 'our', 'pack', 'package', 'pipe', 'pop', 'pos', 'print', 'printf', 'prototype', 'push', 'q|0', 'qq', 'quotemeta', 'qw', 'qx', 'rand', 'read', 'readdir', 'readline', 'readlink', 'readpipe', 'recv', 'redo', 'ref', 'rename', 'require', 'reset', 'return', 'reverse', 'rewinddir', 'rindex', 'rmdir', 'say', 'scalar', 'seek', 'seekdir', 'select', 'semctl', 'semget', 'semop', 'send', 'setgrent', 'sethostent', 'setnetent', 'setpgrp', 'setpriority', 'setprotoent', 'setpwent', 'setservent', 'setsockopt', 'shift', 'shmctl', 'shmget', 'shmread', 'shmwrite', 'shutdown', 'sin', 'sleep', 'socket', 'socketpair', 'sort', 'splice', 'split', 'sprintf', 'sqrt', 'srand', 'stat', 'state', 'study', 'sub', 'substr', 'symlink', 'syscall', 'sysopen', 'sysread', 'sysseek', 'system', 'syswrite', 'tell', 'telldir', 'tie', 'tied', 'time', 'times', 'tr', 'truncate', 'uc', 'ucfirst', 'umask', 'undef', 'unless', 'unlink', 'unpack', 'unshift', 'untie', 'until', 'use', 'utime', 'values', 'vec', 'wait', 'waitpid', 'wantarray', 'warn', 'when', 'while', 'write', 'x|0', 'xor', 'y|0'];

  // https://perldoc.perl.org/perlre#Modifiers
  var REGEX_MODIFIERS = /[dualxmsipngr]{0,12}/; // aa and xx are valid, making max length 12
  var PERL_KEYWORDS = {
    $pattern: /[\w.]+/,
    keyword: KEYWORDS.join(" ")
  };
  var SUBST = {
    className: 'subst',
    begin: '[$@]\\{',
    end: '\\}',
    keywords: PERL_KEYWORDS
  };
  var METHOD = {
    begin: /->\{/,
    end: /\}/
    // contains defined later
  };

  var VAR = {
    variants: [{
      begin: /\$\d/
    }, {
      begin: concat(/[$%@](\^\w\b|#\w+(::\w+)*|\{\w+\}|\w+(::\w*)*)/, // negative look-ahead tries to avoid matching patterns that are not
      // Perl at all like $ident$, @ident@, etc.
      "(?![A-Za-z])(?![@$%])")
    }, {
      begin: /[$%@][^\s\w{]/,
      relevance: 0
    }]
  };
  var STRING_CONTAINS = [hljs.BACKSLASH_ESCAPE, SUBST, VAR];
  var REGEX_DELIMS = [/!/, /\//, /\|/, /\?/, /'/, /"/,
  // valid but infrequent and weird
  /#/ // valid but infrequent and weird
  ];
  /**
   * @param {string|RegExp} prefix
   * @param {string|RegExp} open
   * @param {string|RegExp} close
   */
  var PAIRED_DOUBLE_RE = function PAIRED_DOUBLE_RE(prefix, open) {
    var close = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '\\1';
    var middle = close === '\\1' ? close : concat(close, open);
    return concat(concat("(?:", prefix, ")"), open, /(?:\\.|[^\\\/])*?/, middle, /(?:\\.|[^\\\/])*?/, close, REGEX_MODIFIERS);
  };
  /**
   * @param {string|RegExp} prefix
   * @param {string|RegExp} open
   * @param {string|RegExp} close
   */
  var PAIRED_RE = function PAIRED_RE(prefix, open, close) {
    return concat(concat("(?:", prefix, ")"), open, /(?:\\.|[^\\\/])*?/, close, REGEX_MODIFIERS);
  };
  var PERL_DEFAULT_CONTAINS = [VAR, hljs.HASH_COMMENT_MODE, hljs.COMMENT(/^=\w/, /=cut/, {
    endsWithParent: true
  }), METHOD, {
    className: 'string',
    contains: STRING_CONTAINS,
    variants: [{
      begin: 'q[qwxr]?\\s*\\(',
      end: '\\)',
      relevance: 5
    }, {
      begin: 'q[qwxr]?\\s*\\[',
      end: '\\]',
      relevance: 5
    }, {
      begin: 'q[qwxr]?\\s*\\{',
      end: '\\}',
      relevance: 5
    }, {
      begin: 'q[qwxr]?\\s*\\|',
      end: '\\|',
      relevance: 5
    }, {
      begin: 'q[qwxr]?\\s*<',
      end: '>',
      relevance: 5
    }, {
      begin: 'qw\\s+q',
      end: 'q',
      relevance: 5
    }, {
      begin: '\'',
      end: '\'',
      contains: [hljs.BACKSLASH_ESCAPE]
    }, {
      begin: '"',
      end: '"'
    }, {
      begin: '`',
      end: '`',
      contains: [hljs.BACKSLASH_ESCAPE]
    }, {
      begin: /\{\w+\}/,
      relevance: 0
    }, {
      begin: '-?\\w+\\s*=>',
      relevance: 0
    }]
  }, {
    className: 'number',
    begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
    relevance: 0
  }, {
    // regexp container
    begin: '(\\/\\/|' + hljs.RE_STARTERS_RE + '|\\b(split|return|print|reverse|grep)\\b)\\s*',
    keywords: 'split return print reverse grep',
    relevance: 0,
    contains: [hljs.HASH_COMMENT_MODE, {
      className: 'regexp',
      variants: [
      // allow matching common delimiters
      {
        begin: PAIRED_DOUBLE_RE("s|tr|y", either.apply(void 0, REGEX_DELIMS))
      },
      // and then paired delmis
      {
        begin: PAIRED_DOUBLE_RE("s|tr|y", "\\(", "\\)")
      }, {
        begin: PAIRED_DOUBLE_RE("s|tr|y", "\\[", "\\]")
      }, {
        begin: PAIRED_DOUBLE_RE("s|tr|y", "\\{", "\\}")
      }],
      relevance: 2
    }, {
      className: 'regexp',
      variants: [{
        // could be a comment in many languages so do not count
        // as relevant
        begin: /(m|qr)\/\//,
        relevance: 0
      },
      // prefix is optional with /regex/
      {
        begin: PAIRED_RE("(?:m|qr)?", /\//, /\//)
      },
      // allow matching common delimiters
      {
        begin: PAIRED_RE("m|qr", either.apply(void 0, REGEX_DELIMS), /\1/)
      },
      // allow common paired delmins
      {
        begin: PAIRED_RE("m|qr", /\(/, /\)/)
      }, {
        begin: PAIRED_RE("m|qr", /\[/, /\]/)
      }, {
        begin: PAIRED_RE("m|qr", /\{/, /\}/)
      }]
    }]
  }, {
    className: 'function',
    beginKeywords: 'sub',
    end: '(\\s*\\(.*?\\))?[;{]',
    excludeEnd: true,
    relevance: 5,
    contains: [hljs.TITLE_MODE]
  }, {
    begin: '-\\w\\b',
    relevance: 0
  }, {
    begin: "^__DATA__$",
    end: "^__END__$",
    subLanguage: 'mojolicious',
    contains: [{
      begin: "^@@.*",
      end: "$",
      className: "comment"
    }]
  }];
  SUBST.contains = PERL_DEFAULT_CONTAINS;
  METHOD.contains = PERL_DEFAULT_CONTAINS;
  return {
    name: 'Perl',
    aliases: ['pl', 'pm'],
    keywords: PERL_KEYWORDS,
    contains: PERL_DEFAULT_CONTAINS
  };
}
module.exports = perl;

/***/ }),

/***/ 37940:
/***/ ((module) => {

/*
Language: Packet Filter config
Description: pf.conf — packet filter configuration file (OpenBSD)
Author: Peter Piwowarski <oldlaptop654@aol.com>
Website: http://man.openbsd.org/pf.conf
Category: config
*/

function pf(hljs) {
  var MACRO = {
    className: 'variable',
    begin: /\$[\w\d#@][\w\d_]*/
  };
  var TABLE = {
    className: 'variable',
    begin: /<(?!\/)/,
    end: />/
  };
  return {
    name: 'Packet Filter config',
    aliases: ['pf.conf'],
    keywords: {
      $pattern: /[a-z0-9_<>-]+/,
      built_in:
      /* block match pass are "actions" in pf.conf(5), the rest are
       * lexically similar top-level commands.
       */
      'block match pass load anchor|5 antispoof|10 set table',
      keyword: 'in out log quick on rdomain inet inet6 proto from port os to route ' + 'allow-opts divert-packet divert-reply divert-to flags group icmp-type ' + 'icmp6-type label once probability recieved-on rtable prio queue ' + 'tos tag tagged user keep fragment for os drop ' + 'af-to|10 binat-to|10 nat-to|10 rdr-to|10 bitmask least-stats random round-robin ' + 'source-hash static-port ' + 'dup-to reply-to route-to ' + 'parent bandwidth default min max qlimit ' + 'block-policy debug fingerprints hostid limit loginterface optimization ' + 'reassemble ruleset-optimization basic none profile skip state-defaults ' + 'state-policy timeout ' + 'const counters persist ' + 'no modulate synproxy state|5 floating if-bound no-sync pflow|10 sloppy ' + 'source-track global rule max-src-nodes max-src-states max-src-conn ' + 'max-src-conn-rate overload flush ' + 'scrub|5 max-mss min-ttl no-df|10 random-id',
      literal: 'all any no-route self urpf-failed egress|5 unknown'
    },
    contains: [hljs.HASH_COMMENT_MODE, hljs.NUMBER_MODE, hljs.QUOTE_STRING_MODE, MACRO, TABLE]
  };
}
module.exports = pf;

/***/ }),

/***/ 25163:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(74916);
__webpack_require__(23123);
__webpack_require__(73210);
__webpack_require__(15306);
/*
Language: PostgreSQL and PL/pgSQL
Author: Egor Rogov (e.rogov@postgrespro.ru)
Website: https://www.postgresql.org/docs/11/sql.html
Description:
    This language incorporates both PostgreSQL SQL dialect and PL/pgSQL language.
    It is based on PostgreSQL version 11. Some notes:
    - Text in double-dollar-strings is _always_ interpreted as some programming code. Text
      in ordinary quotes is _never_ interpreted that way and highlighted just as a string.
    - There are quite a bit "special cases". That's because many keywords are not strictly
      they are keywords in some contexts and ordinary identifiers in others. Only some
      of such cases are handled; you still can get some of your identifiers highlighted
      wrong way.
    - Function names deliberately are not highlighted. There is no way to tell function
      call from other constructs, hence we can't highlight _all_ function names. And
      some names highlighted while others not looks ugly.
*/

function pgsql(hljs) {
  var COMMENT_MODE = hljs.COMMENT('--', '$');
  var UNQUOTED_IDENT = '[a-zA-Z_][a-zA-Z_0-9$]*';
  var DOLLAR_STRING = '\\$([a-zA-Z_]?|[a-zA-Z_][a-zA-Z_0-9]*)\\$';
  var LABEL = '<<\\s*' + UNQUOTED_IDENT + '\\s*>>';
  var SQL_KW =
  // https://www.postgresql.org/docs/11/static/sql-keywords-appendix.html
  // https://www.postgresql.org/docs/11/static/sql-commands.html
  // SQL commands (starting words)
  'ABORT ALTER ANALYZE BEGIN CALL CHECKPOINT|10 CLOSE CLUSTER COMMENT COMMIT COPY CREATE DEALLOCATE DECLARE ' + 'DELETE DISCARD DO DROP END EXECUTE EXPLAIN FETCH GRANT IMPORT INSERT LISTEN LOAD LOCK MOVE NOTIFY ' + 'PREPARE REASSIGN|10 REFRESH REINDEX RELEASE RESET REVOKE ROLLBACK SAVEPOINT SECURITY SELECT SET SHOW ' + 'START TRUNCATE UNLISTEN|10 UPDATE VACUUM|10 VALUES ' +
  // SQL commands (others)
  'AGGREGATE COLLATION CONVERSION|10 DATABASE DEFAULT PRIVILEGES DOMAIN TRIGGER EXTENSION FOREIGN ' + 'WRAPPER|10 TABLE FUNCTION GROUP LANGUAGE LARGE OBJECT MATERIALIZED VIEW OPERATOR CLASS ' + 'FAMILY POLICY PUBLICATION|10 ROLE RULE SCHEMA SEQUENCE SERVER STATISTICS SUBSCRIPTION SYSTEM ' + 'TABLESPACE CONFIGURATION DICTIONARY PARSER TEMPLATE TYPE USER MAPPING PREPARED ACCESS ' + 'METHOD CAST AS TRANSFORM TRANSACTION OWNED TO INTO SESSION AUTHORIZATION ' + 'INDEX PROCEDURE ASSERTION ' +
  // additional reserved key words
  'ALL ANALYSE AND ANY ARRAY ASC ASYMMETRIC|10 BOTH CASE CHECK ' + 'COLLATE COLUMN CONCURRENTLY|10 CONSTRAINT CROSS ' + 'DEFERRABLE RANGE ' + 'DESC DISTINCT ELSE EXCEPT FOR FREEZE|10 FROM FULL HAVING ' + 'ILIKE IN INITIALLY INNER INTERSECT IS ISNULL JOIN LATERAL LEADING LIKE LIMIT ' + 'NATURAL NOT NOTNULL NULL OFFSET ON ONLY OR ORDER OUTER OVERLAPS PLACING PRIMARY ' + 'REFERENCES RETURNING SIMILAR SOME SYMMETRIC TABLESAMPLE THEN ' + 'TRAILING UNION UNIQUE USING VARIADIC|10 VERBOSE WHEN WHERE WINDOW WITH ' +
  // some of non-reserved (which are used in clauses or as PL/pgSQL keyword)
  'BY RETURNS INOUT OUT SETOF|10 IF STRICT CURRENT CONTINUE OWNER LOCATION OVER PARTITION WITHIN ' + 'BETWEEN ESCAPE EXTERNAL INVOKER DEFINER WORK RENAME VERSION CONNECTION CONNECT ' + 'TABLES TEMP TEMPORARY FUNCTIONS SEQUENCES TYPES SCHEMAS OPTION CASCADE RESTRICT ADD ADMIN ' + 'EXISTS VALID VALIDATE ENABLE DISABLE REPLICA|10 ALWAYS PASSING COLUMNS PATH ' + 'REF VALUE OVERRIDING IMMUTABLE STABLE VOLATILE BEFORE AFTER EACH ROW PROCEDURAL ' + 'ROUTINE NO HANDLER VALIDATOR OPTIONS STORAGE OIDS|10 WITHOUT INHERIT DEPENDS CALLED ' + 'INPUT LEAKPROOF|10 COST ROWS NOWAIT SEARCH UNTIL ENCRYPTED|10 PASSWORD CONFLICT|10 ' + 'INSTEAD INHERITS CHARACTERISTICS WRITE CURSOR ALSO STATEMENT SHARE EXCLUSIVE INLINE ' + 'ISOLATION REPEATABLE READ COMMITTED SERIALIZABLE UNCOMMITTED LOCAL GLOBAL SQL PROCEDURES ' + 'RECURSIVE SNAPSHOT ROLLUP CUBE TRUSTED|10 INCLUDE FOLLOWING PRECEDING UNBOUNDED RANGE GROUPS ' + 'UNENCRYPTED|10 SYSID FORMAT DELIMITER HEADER QUOTE ENCODING FILTER OFF ' +
  // some parameters of VACUUM/ANALYZE/EXPLAIN
  'FORCE_QUOTE FORCE_NOT_NULL FORCE_NULL COSTS BUFFERS TIMING SUMMARY DISABLE_PAGE_SKIPPING ' +
  //
  'RESTART CYCLE GENERATED IDENTITY DEFERRED IMMEDIATE LEVEL LOGGED UNLOGGED ' + 'OF NOTHING NONE EXCLUDE ATTRIBUTE ' +
  // from GRANT (not keywords actually)
  'USAGE ROUTINES ' +
  // actually literals, but look better this way (due to IS TRUE, IS FALSE, ISNULL etc)
  'TRUE FALSE NAN INFINITY ';
  var ROLE_ATTRS =
  // only those not in keywrods already
  'SUPERUSER NOSUPERUSER CREATEDB NOCREATEDB CREATEROLE NOCREATEROLE INHERIT NOINHERIT ' + 'LOGIN NOLOGIN REPLICATION NOREPLICATION BYPASSRLS NOBYPASSRLS ';
  var PLPGSQL_KW = 'ALIAS BEGIN CONSTANT DECLARE END EXCEPTION RETURN PERFORM|10 RAISE GET DIAGNOSTICS ' + 'STACKED|10 FOREACH LOOP ELSIF EXIT WHILE REVERSE SLICE DEBUG LOG INFO NOTICE WARNING ASSERT ' + 'OPEN ';
  var TYPES =
  // https://www.postgresql.org/docs/11/static/datatype.html
  'BIGINT INT8 BIGSERIAL SERIAL8 BIT VARYING VARBIT BOOLEAN BOOL BOX BYTEA CHARACTER CHAR VARCHAR ' + 'CIDR CIRCLE DATE DOUBLE PRECISION FLOAT8 FLOAT INET INTEGER INT INT4 INTERVAL JSON JSONB LINE LSEG|10 ' + 'MACADDR MACADDR8 MONEY NUMERIC DEC DECIMAL PATH POINT POLYGON REAL FLOAT4 SMALLINT INT2 ' + 'SMALLSERIAL|10 SERIAL2|10 SERIAL|10 SERIAL4|10 TEXT TIME ZONE TIMETZ|10 TIMESTAMP TIMESTAMPTZ|10 TSQUERY|10 TSVECTOR|10 ' + 'TXID_SNAPSHOT|10 UUID XML NATIONAL NCHAR ' + 'INT4RANGE|10 INT8RANGE|10 NUMRANGE|10 TSRANGE|10 TSTZRANGE|10 DATERANGE|10 ' +
  // pseudotypes
  'ANYELEMENT ANYARRAY ANYNONARRAY ANYENUM ANYRANGE CSTRING INTERNAL ' + 'RECORD PG_DDL_COMMAND VOID UNKNOWN OPAQUE REFCURSOR ' +
  // spec. type
  'NAME ' +
  // OID-types
  'OID REGPROC|10 REGPROCEDURE|10 REGOPER|10 REGOPERATOR|10 REGCLASS|10 REGTYPE|10 REGROLE|10 ' + 'REGNAMESPACE|10 REGCONFIG|10 REGDICTIONARY|10 '; // +

  var TYPES_RE = TYPES.trim().split(' ').map(function (val) {
    return val.split('|')[0];
  }).join('|');
  var SQL_BI = 'CURRENT_TIME CURRENT_TIMESTAMP CURRENT_USER CURRENT_CATALOG|10 CURRENT_DATE LOCALTIME LOCALTIMESTAMP ' + 'CURRENT_ROLE|10 CURRENT_SCHEMA|10 SESSION_USER PUBLIC ';
  var PLPGSQL_BI = 'FOUND NEW OLD TG_NAME|10 TG_WHEN|10 TG_LEVEL|10 TG_OP|10 TG_RELID|10 TG_RELNAME|10 ' + 'TG_TABLE_NAME|10 TG_TABLE_SCHEMA|10 TG_NARGS|10 TG_ARGV|10 TG_EVENT|10 TG_TAG|10 ' +
  // get diagnostics
  'ROW_COUNT RESULT_OID|10 PG_CONTEXT|10 RETURNED_SQLSTATE COLUMN_NAME CONSTRAINT_NAME ' + 'PG_DATATYPE_NAME|10 MESSAGE_TEXT TABLE_NAME SCHEMA_NAME PG_EXCEPTION_DETAIL|10 ' + 'PG_EXCEPTION_HINT|10 PG_EXCEPTION_CONTEXT|10 ';
  var PLPGSQL_EXCEPTIONS =
  // exceptions https://www.postgresql.org/docs/current/static/errcodes-appendix.html
  'SQLSTATE SQLERRM|10 ' + 'SUCCESSFUL_COMPLETION WARNING DYNAMIC_RESULT_SETS_RETURNED IMPLICIT_ZERO_BIT_PADDING ' + 'NULL_VALUE_ELIMINATED_IN_SET_FUNCTION PRIVILEGE_NOT_GRANTED PRIVILEGE_NOT_REVOKED ' + 'STRING_DATA_RIGHT_TRUNCATION DEPRECATED_FEATURE NO_DATA NO_ADDITIONAL_DYNAMIC_RESULT_SETS_RETURNED ' + 'SQL_STATEMENT_NOT_YET_COMPLETE CONNECTION_EXCEPTION CONNECTION_DOES_NOT_EXIST CONNECTION_FAILURE ' + 'SQLCLIENT_UNABLE_TO_ESTABLISH_SQLCONNECTION SQLSERVER_REJECTED_ESTABLISHMENT_OF_SQLCONNECTION ' + 'TRANSACTION_RESOLUTION_UNKNOWN PROTOCOL_VIOLATION TRIGGERED_ACTION_EXCEPTION FEATURE_NOT_SUPPORTED ' + 'INVALID_TRANSACTION_INITIATION LOCATOR_EXCEPTION INVALID_LOCATOR_SPECIFICATION INVALID_GRANTOR ' + 'INVALID_GRANT_OPERATION INVALID_ROLE_SPECIFICATION DIAGNOSTICS_EXCEPTION ' + 'STACKED_DIAGNOSTICS_ACCESSED_WITHOUT_ACTIVE_HANDLER CASE_NOT_FOUND CARDINALITY_VIOLATION ' + 'DATA_EXCEPTION ARRAY_SUBSCRIPT_ERROR CHARACTER_NOT_IN_REPERTOIRE DATETIME_FIELD_OVERFLOW ' + 'DIVISION_BY_ZERO ERROR_IN_ASSIGNMENT ESCAPE_CHARACTER_CONFLICT INDICATOR_OVERFLOW ' + 'INTERVAL_FIELD_OVERFLOW INVALID_ARGUMENT_FOR_LOGARITHM INVALID_ARGUMENT_FOR_NTILE_FUNCTION ' + 'INVALID_ARGUMENT_FOR_NTH_VALUE_FUNCTION INVALID_ARGUMENT_FOR_POWER_FUNCTION ' + 'INVALID_ARGUMENT_FOR_WIDTH_BUCKET_FUNCTION INVALID_CHARACTER_VALUE_FOR_CAST ' + 'INVALID_DATETIME_FORMAT INVALID_ESCAPE_CHARACTER INVALID_ESCAPE_OCTET INVALID_ESCAPE_SEQUENCE ' + 'NONSTANDARD_USE_OF_ESCAPE_CHARACTER INVALID_INDICATOR_PARAMETER_VALUE INVALID_PARAMETER_VALUE ' + 'INVALID_REGULAR_EXPRESSION INVALID_ROW_COUNT_IN_LIMIT_CLAUSE ' + 'INVALID_ROW_COUNT_IN_RESULT_OFFSET_CLAUSE INVALID_TABLESAMPLE_ARGUMENT INVALID_TABLESAMPLE_REPEAT ' + 'INVALID_TIME_ZONE_DISPLACEMENT_VALUE INVALID_USE_OF_ESCAPE_CHARACTER MOST_SPECIFIC_TYPE_MISMATCH ' + 'NULL_VALUE_NOT_ALLOWED NULL_VALUE_NO_INDICATOR_PARAMETER NUMERIC_VALUE_OUT_OF_RANGE ' + 'SEQUENCE_GENERATOR_LIMIT_EXCEEDED STRING_DATA_LENGTH_MISMATCH STRING_DATA_RIGHT_TRUNCATION ' + 'SUBSTRING_ERROR TRIM_ERROR UNTERMINATED_C_STRING ZERO_LENGTH_CHARACTER_STRING ' + 'FLOATING_POINT_EXCEPTION INVALID_TEXT_REPRESENTATION INVALID_BINARY_REPRESENTATION ' + 'BAD_COPY_FILE_FORMAT UNTRANSLATABLE_CHARACTER NOT_AN_XML_DOCUMENT INVALID_XML_DOCUMENT ' + 'INVALID_XML_CONTENT INVALID_XML_COMMENT INVALID_XML_PROCESSING_INSTRUCTION ' + 'INTEGRITY_CONSTRAINT_VIOLATION RESTRICT_VIOLATION NOT_NULL_VIOLATION FOREIGN_KEY_VIOLATION ' + 'UNIQUE_VIOLATION CHECK_VIOLATION EXCLUSION_VIOLATION INVALID_CURSOR_STATE ' + 'INVALID_TRANSACTION_STATE ACTIVE_SQL_TRANSACTION BRANCH_TRANSACTION_ALREADY_ACTIVE ' + 'HELD_CURSOR_REQUIRES_SAME_ISOLATION_LEVEL INAPPROPRIATE_ACCESS_MODE_FOR_BRANCH_TRANSACTION ' + 'INAPPROPRIATE_ISOLATION_LEVEL_FOR_BRANCH_TRANSACTION ' + 'NO_ACTIVE_SQL_TRANSACTION_FOR_BRANCH_TRANSACTION READ_ONLY_SQL_TRANSACTION ' + 'SCHEMA_AND_DATA_STATEMENT_MIXING_NOT_SUPPORTED NO_ACTIVE_SQL_TRANSACTION ' + 'IN_FAILED_SQL_TRANSACTION IDLE_IN_TRANSACTION_SESSION_TIMEOUT INVALID_SQL_STATEMENT_NAME ' + 'TRIGGERED_DATA_CHANGE_VIOLATION INVALID_AUTHORIZATION_SPECIFICATION INVALID_PASSWORD ' + 'DEPENDENT_PRIVILEGE_DESCRIPTORS_STILL_EXIST DEPENDENT_OBJECTS_STILL_EXIST ' + 'INVALID_TRANSACTION_TERMINATION SQL_ROUTINE_EXCEPTION FUNCTION_EXECUTED_NO_RETURN_STATEMENT ' + 'MODIFYING_SQL_DATA_NOT_PERMITTED PROHIBITED_SQL_STATEMENT_ATTEMPTED ' + 'READING_SQL_DATA_NOT_PERMITTED INVALID_CURSOR_NAME EXTERNAL_ROUTINE_EXCEPTION ' + 'CONTAINING_SQL_NOT_PERMITTED MODIFYING_SQL_DATA_NOT_PERMITTED ' + 'PROHIBITED_SQL_STATEMENT_ATTEMPTED READING_SQL_DATA_NOT_PERMITTED ' + 'EXTERNAL_ROUTINE_INVOCATION_EXCEPTION INVALID_SQLSTATE_RETURNED NULL_VALUE_NOT_ALLOWED ' + 'TRIGGER_PROTOCOL_VIOLATED SRF_PROTOCOL_VIOLATED EVENT_TRIGGER_PROTOCOL_VIOLATED ' + 'SAVEPOINT_EXCEPTION INVALID_SAVEPOINT_SPECIFICATION INVALID_CATALOG_NAME ' + 'INVALID_SCHEMA_NAME TRANSACTION_ROLLBACK TRANSACTION_INTEGRITY_CONSTRAINT_VIOLATION ' + 'SERIALIZATION_FAILURE STATEMENT_COMPLETION_UNKNOWN DEADLOCK_DETECTED ' + 'SYNTAX_ERROR_OR_ACCESS_RULE_VIOLATION SYNTAX_ERROR INSUFFICIENT_PRIVILEGE CANNOT_COERCE ' + 'GROUPING_ERROR WINDOWING_ERROR INVALID_RECURSION INVALID_FOREIGN_KEY INVALID_NAME ' + 'NAME_TOO_LONG RESERVED_NAME DATATYPE_MISMATCH INDETERMINATE_DATATYPE COLLATION_MISMATCH ' + 'INDETERMINATE_COLLATION WRONG_OBJECT_TYPE GENERATED_ALWAYS UNDEFINED_COLUMN ' + 'UNDEFINED_FUNCTION UNDEFINED_TABLE UNDEFINED_PARAMETER UNDEFINED_OBJECT ' + 'DUPLICATE_COLUMN DUPLICATE_CURSOR DUPLICATE_DATABASE DUPLICATE_FUNCTION ' + 'DUPLICATE_PREPARED_STATEMENT DUPLICATE_SCHEMA DUPLICATE_TABLE DUPLICATE_ALIAS ' + 'DUPLICATE_OBJECT AMBIGUOUS_COLUMN AMBIGUOUS_FUNCTION AMBIGUOUS_PARAMETER AMBIGUOUS_ALIAS ' + 'INVALID_COLUMN_REFERENCE INVALID_COLUMN_DEFINITION INVALID_CURSOR_DEFINITION ' + 'INVALID_DATABASE_DEFINITION INVALID_FUNCTION_DEFINITION ' + 'INVALID_PREPARED_STATEMENT_DEFINITION INVALID_SCHEMA_DEFINITION INVALID_TABLE_DEFINITION ' + 'INVALID_OBJECT_DEFINITION WITH_CHECK_OPTION_VIOLATION INSUFFICIENT_RESOURCES DISK_FULL ' + 'OUT_OF_MEMORY TOO_MANY_CONNECTIONS CONFIGURATION_LIMIT_EXCEEDED PROGRAM_LIMIT_EXCEEDED ' + 'STATEMENT_TOO_COMPLEX TOO_MANY_COLUMNS TOO_MANY_ARGUMENTS OBJECT_NOT_IN_PREREQUISITE_STATE ' + 'OBJECT_IN_USE CANT_CHANGE_RUNTIME_PARAM LOCK_NOT_AVAILABLE OPERATOR_INTERVENTION ' + 'QUERY_CANCELED ADMIN_SHUTDOWN CRASH_SHUTDOWN CANNOT_CONNECT_NOW DATABASE_DROPPED ' + 'SYSTEM_ERROR IO_ERROR UNDEFINED_FILE DUPLICATE_FILE SNAPSHOT_TOO_OLD CONFIG_FILE_ERROR ' + 'LOCK_FILE_EXISTS FDW_ERROR FDW_COLUMN_NAME_NOT_FOUND FDW_DYNAMIC_PARAMETER_VALUE_NEEDED ' + 'FDW_FUNCTION_SEQUENCE_ERROR FDW_INCONSISTENT_DESCRIPTOR_INFORMATION ' + 'FDW_INVALID_ATTRIBUTE_VALUE FDW_INVALID_COLUMN_NAME FDW_INVALID_COLUMN_NUMBER ' + 'FDW_INVALID_DATA_TYPE FDW_INVALID_DATA_TYPE_DESCRIPTORS ' + 'FDW_INVALID_DESCRIPTOR_FIELD_IDENTIFIER FDW_INVALID_HANDLE FDW_INVALID_OPTION_INDEX ' + 'FDW_INVALID_OPTION_NAME FDW_INVALID_STRING_LENGTH_OR_BUFFER_LENGTH ' + 'FDW_INVALID_STRING_FORMAT FDW_INVALID_USE_OF_NULL_POINTER FDW_TOO_MANY_HANDLES ' + 'FDW_OUT_OF_MEMORY FDW_NO_SCHEMAS FDW_OPTION_NAME_NOT_FOUND FDW_REPLY_HANDLE ' + 'FDW_SCHEMA_NOT_FOUND FDW_TABLE_NOT_FOUND FDW_UNABLE_TO_CREATE_EXECUTION ' + 'FDW_UNABLE_TO_CREATE_REPLY FDW_UNABLE_TO_ESTABLISH_CONNECTION PLPGSQL_ERROR ' + 'RAISE_EXCEPTION NO_DATA_FOUND TOO_MANY_ROWS ASSERT_FAILURE INTERNAL_ERROR DATA_CORRUPTED ' + 'INDEX_CORRUPTED ';
  var FUNCTIONS =
  // https://www.postgresql.org/docs/11/static/functions-aggregate.html
  'ARRAY_AGG AVG BIT_AND BIT_OR BOOL_AND BOOL_OR COUNT EVERY JSON_AGG JSONB_AGG JSON_OBJECT_AGG ' + 'JSONB_OBJECT_AGG MAX MIN MODE STRING_AGG SUM XMLAGG ' + 'CORR COVAR_POP COVAR_SAMP REGR_AVGX REGR_AVGY REGR_COUNT REGR_INTERCEPT REGR_R2 REGR_SLOPE ' + 'REGR_SXX REGR_SXY REGR_SYY STDDEV STDDEV_POP STDDEV_SAMP VARIANCE VAR_POP VAR_SAMP ' + 'PERCENTILE_CONT PERCENTILE_DISC ' +
  // https://www.postgresql.org/docs/11/static/functions-window.html
  'ROW_NUMBER RANK DENSE_RANK PERCENT_RANK CUME_DIST NTILE LAG LEAD FIRST_VALUE LAST_VALUE NTH_VALUE ' +
  // https://www.postgresql.org/docs/11/static/functions-comparison.html
  'NUM_NONNULLS NUM_NULLS ' +
  // https://www.postgresql.org/docs/11/static/functions-math.html
  'ABS CBRT CEIL CEILING DEGREES DIV EXP FLOOR LN LOG MOD PI POWER RADIANS ROUND SCALE SIGN SQRT ' + 'TRUNC WIDTH_BUCKET ' + 'RANDOM SETSEED ' + 'ACOS ACOSD ASIN ASIND ATAN ATAND ATAN2 ATAN2D COS COSD COT COTD SIN SIND TAN TAND ' +
  // https://www.postgresql.org/docs/11/static/functions-string.html
  'BIT_LENGTH CHAR_LENGTH CHARACTER_LENGTH LOWER OCTET_LENGTH OVERLAY POSITION SUBSTRING TREAT TRIM UPPER ' + 'ASCII BTRIM CHR CONCAT CONCAT_WS CONVERT CONVERT_FROM CONVERT_TO DECODE ENCODE INITCAP ' + 'LEFT LENGTH LPAD LTRIM MD5 PARSE_IDENT PG_CLIENT_ENCODING QUOTE_IDENT|10 QUOTE_LITERAL|10 ' + 'QUOTE_NULLABLE|10 REGEXP_MATCH REGEXP_MATCHES REGEXP_REPLACE REGEXP_SPLIT_TO_ARRAY ' + 'REGEXP_SPLIT_TO_TABLE REPEAT REPLACE REVERSE RIGHT RPAD RTRIM SPLIT_PART STRPOS SUBSTR ' + 'TO_ASCII TO_HEX TRANSLATE ' +
  // https://www.postgresql.org/docs/11/static/functions-binarystring.html
  'OCTET_LENGTH GET_BIT GET_BYTE SET_BIT SET_BYTE ' +
  // https://www.postgresql.org/docs/11/static/functions-formatting.html
  'TO_CHAR TO_DATE TO_NUMBER TO_TIMESTAMP ' +
  // https://www.postgresql.org/docs/11/static/functions-datetime.html
  'AGE CLOCK_TIMESTAMP|10 DATE_PART DATE_TRUNC ISFINITE JUSTIFY_DAYS JUSTIFY_HOURS JUSTIFY_INTERVAL ' + 'MAKE_DATE MAKE_INTERVAL|10 MAKE_TIME MAKE_TIMESTAMP|10 MAKE_TIMESTAMPTZ|10 NOW STATEMENT_TIMESTAMP|10 ' + 'TIMEOFDAY TRANSACTION_TIMESTAMP|10 ' +
  // https://www.postgresql.org/docs/11/static/functions-enum.html
  'ENUM_FIRST ENUM_LAST ENUM_RANGE ' +
  // https://www.postgresql.org/docs/11/static/functions-geometry.html
  'AREA CENTER DIAMETER HEIGHT ISCLOSED ISOPEN NPOINTS PCLOSE POPEN RADIUS WIDTH ' + 'BOX BOUND_BOX CIRCLE LINE LSEG PATH POLYGON ' +
  // https://www.postgresql.org/docs/11/static/functions-net.html
  'ABBREV BROADCAST HOST HOSTMASK MASKLEN NETMASK NETWORK SET_MASKLEN TEXT INET_SAME_FAMILY ' + 'INET_MERGE MACADDR8_SET7BIT ' +
  // https://www.postgresql.org/docs/11/static/functions-textsearch.html
  'ARRAY_TO_TSVECTOR GET_CURRENT_TS_CONFIG NUMNODE PLAINTO_TSQUERY PHRASETO_TSQUERY WEBSEARCH_TO_TSQUERY ' + 'QUERYTREE SETWEIGHT STRIP TO_TSQUERY TO_TSVECTOR JSON_TO_TSVECTOR JSONB_TO_TSVECTOR TS_DELETE ' + 'TS_FILTER TS_HEADLINE TS_RANK TS_RANK_CD TS_REWRITE TSQUERY_PHRASE TSVECTOR_TO_ARRAY ' + 'TSVECTOR_UPDATE_TRIGGER TSVECTOR_UPDATE_TRIGGER_COLUMN ' +
  // https://www.postgresql.org/docs/11/static/functions-xml.html
  'XMLCOMMENT XMLCONCAT XMLELEMENT XMLFOREST XMLPI XMLROOT ' + 'XMLEXISTS XML_IS_WELL_FORMED XML_IS_WELL_FORMED_DOCUMENT XML_IS_WELL_FORMED_CONTENT ' + 'XPATH XPATH_EXISTS XMLTABLE XMLNAMESPACES ' + 'TABLE_TO_XML TABLE_TO_XMLSCHEMA TABLE_TO_XML_AND_XMLSCHEMA ' + 'QUERY_TO_XML QUERY_TO_XMLSCHEMA QUERY_TO_XML_AND_XMLSCHEMA ' + 'CURSOR_TO_XML CURSOR_TO_XMLSCHEMA ' + 'SCHEMA_TO_XML SCHEMA_TO_XMLSCHEMA SCHEMA_TO_XML_AND_XMLSCHEMA ' + 'DATABASE_TO_XML DATABASE_TO_XMLSCHEMA DATABASE_TO_XML_AND_XMLSCHEMA ' + 'XMLATTRIBUTES ' +
  // https://www.postgresql.org/docs/11/static/functions-json.html
  'TO_JSON TO_JSONB ARRAY_TO_JSON ROW_TO_JSON JSON_BUILD_ARRAY JSONB_BUILD_ARRAY JSON_BUILD_OBJECT ' + 'JSONB_BUILD_OBJECT JSON_OBJECT JSONB_OBJECT JSON_ARRAY_LENGTH JSONB_ARRAY_LENGTH JSON_EACH ' + 'JSONB_EACH JSON_EACH_TEXT JSONB_EACH_TEXT JSON_EXTRACT_PATH JSONB_EXTRACT_PATH ' + 'JSON_OBJECT_KEYS JSONB_OBJECT_KEYS JSON_POPULATE_RECORD JSONB_POPULATE_RECORD JSON_POPULATE_RECORDSET ' + 'JSONB_POPULATE_RECORDSET JSON_ARRAY_ELEMENTS JSONB_ARRAY_ELEMENTS JSON_ARRAY_ELEMENTS_TEXT ' + 'JSONB_ARRAY_ELEMENTS_TEXT JSON_TYPEOF JSONB_TYPEOF JSON_TO_RECORD JSONB_TO_RECORD JSON_TO_RECORDSET ' + 'JSONB_TO_RECORDSET JSON_STRIP_NULLS JSONB_STRIP_NULLS JSONB_SET JSONB_INSERT JSONB_PRETTY ' +
  // https://www.postgresql.org/docs/11/static/functions-sequence.html
  'CURRVAL LASTVAL NEXTVAL SETVAL ' +
  // https://www.postgresql.org/docs/11/static/functions-conditional.html
  'COALESCE NULLIF GREATEST LEAST ' +
  // https://www.postgresql.org/docs/11/static/functions-array.html
  'ARRAY_APPEND ARRAY_CAT ARRAY_NDIMS ARRAY_DIMS ARRAY_FILL ARRAY_LENGTH ARRAY_LOWER ARRAY_POSITION ' + 'ARRAY_POSITIONS ARRAY_PREPEND ARRAY_REMOVE ARRAY_REPLACE ARRAY_TO_STRING ARRAY_UPPER CARDINALITY ' + 'STRING_TO_ARRAY UNNEST ' +
  // https://www.postgresql.org/docs/11/static/functions-range.html
  'ISEMPTY LOWER_INC UPPER_INC LOWER_INF UPPER_INF RANGE_MERGE ' +
  // https://www.postgresql.org/docs/11/static/functions-srf.html
  'GENERATE_SERIES GENERATE_SUBSCRIPTS ' +
  // https://www.postgresql.org/docs/11/static/functions-info.html
  'CURRENT_DATABASE CURRENT_QUERY CURRENT_SCHEMA|10 CURRENT_SCHEMAS|10 INET_CLIENT_ADDR INET_CLIENT_PORT ' + 'INET_SERVER_ADDR INET_SERVER_PORT ROW_SECURITY_ACTIVE FORMAT_TYPE ' + 'TO_REGCLASS TO_REGPROC TO_REGPROCEDURE TO_REGOPER TO_REGOPERATOR TO_REGTYPE TO_REGNAMESPACE TO_REGROLE ' + 'COL_DESCRIPTION OBJ_DESCRIPTION SHOBJ_DESCRIPTION ' + 'TXID_CURRENT TXID_CURRENT_IF_ASSIGNED TXID_CURRENT_SNAPSHOT TXID_SNAPSHOT_XIP TXID_SNAPSHOT_XMAX ' + 'TXID_SNAPSHOT_XMIN TXID_VISIBLE_IN_SNAPSHOT TXID_STATUS ' +
  // https://www.postgresql.org/docs/11/static/functions-admin.html
  'CURRENT_SETTING SET_CONFIG BRIN_SUMMARIZE_NEW_VALUES BRIN_SUMMARIZE_RANGE BRIN_DESUMMARIZE_RANGE ' + 'GIN_CLEAN_PENDING_LIST ' +
  // https://www.postgresql.org/docs/11/static/functions-trigger.html
  'SUPPRESS_REDUNDANT_UPDATES_TRIGGER ' +
  // ihttps://www.postgresql.org/docs/devel/static/lo-funcs.html
  'LO_FROM_BYTEA LO_PUT LO_GET LO_CREAT LO_CREATE LO_UNLINK LO_IMPORT LO_EXPORT LOREAD LOWRITE ' +
  //
  'GROUPING CAST ';
  var FUNCTIONS_RE = FUNCTIONS.trim().split(' ').map(function (val) {
    return val.split('|')[0];
  }).join('|');
  return {
    name: 'PostgreSQL',
    aliases: ['postgres', 'postgresql'],
    case_insensitive: true,
    keywords: {
      keyword: SQL_KW + PLPGSQL_KW + ROLE_ATTRS,
      built_in: SQL_BI + PLPGSQL_BI + PLPGSQL_EXCEPTIONS
    },
    // Forbid some cunstructs from other languages to improve autodetect. In fact
    // "[a-z]:" is legal (as part of array slice), but improbabal.
    illegal: /:==|\W\s*\(\*|(^|\s)\$[a-z]|\{\{|[a-z]:\s*$|\.\.\.|TO:|DO:/,
    contains: [
    // special handling of some words, which are reserved only in some contexts
    {
      className: 'keyword',
      variants: [{
        begin: /\bTEXT\s*SEARCH\b/
      }, {
        begin: /\b(PRIMARY|FOREIGN|FOR(\s+NO)?)\s+KEY\b/
      }, {
        begin: /\bPARALLEL\s+(UNSAFE|RESTRICTED|SAFE)\b/
      }, {
        begin: /\bSTORAGE\s+(PLAIN|EXTERNAL|EXTENDED|MAIN)\b/
      }, {
        begin: /\bMATCH\s+(FULL|PARTIAL|SIMPLE)\b/
      }, {
        begin: /\bNULLS\s+(FIRST|LAST)\b/
      }, {
        begin: /\bEVENT\s+TRIGGER\b/
      }, {
        begin: /\b(MAPPING|OR)\s+REPLACE\b/
      }, {
        begin: /\b(FROM|TO)\s+(PROGRAM|STDIN|STDOUT)\b/
      }, {
        begin: /\b(SHARE|EXCLUSIVE)\s+MODE\b/
      }, {
        begin: /\b(LEFT|RIGHT)\s+(OUTER\s+)?JOIN\b/
      }, {
        begin: /\b(FETCH|MOVE)\s+(NEXT|PRIOR|FIRST|LAST|ABSOLUTE|RELATIVE|FORWARD|BACKWARD)\b/
      }, {
        begin: /\bPRESERVE\s+ROWS\b/
      }, {
        begin: /\bDISCARD\s+PLANS\b/
      }, {
        begin: /\bREFERENCING\s+(OLD|NEW)\b/
      }, {
        begin: /\bSKIP\s+LOCKED\b/
      }, {
        begin: /\bGROUPING\s+SETS\b/
      }, {
        begin: /\b(BINARY|INSENSITIVE|SCROLL|NO\s+SCROLL)\s+(CURSOR|FOR)\b/
      }, {
        begin: /\b(WITH|WITHOUT)\s+HOLD\b/
      }, {
        begin: /\bWITH\s+(CASCADED|LOCAL)\s+CHECK\s+OPTION\b/
      }, {
        begin: /\bEXCLUDE\s+(TIES|NO\s+OTHERS)\b/
      }, {
        begin: /\bFORMAT\s+(TEXT|XML|JSON|YAML)\b/
      }, {
        begin: /\bSET\s+((SESSION|LOCAL)\s+)?NAMES\b/
      }, {
        begin: /\bIS\s+(NOT\s+)?UNKNOWN\b/
      }, {
        begin: /\bSECURITY\s+LABEL\b/
      }, {
        begin: /\bSTANDALONE\s+(YES|NO|NO\s+VALUE)\b/
      }, {
        begin: /\bWITH\s+(NO\s+)?DATA\b/
      }, {
        begin: /\b(FOREIGN|SET)\s+DATA\b/
      }, {
        begin: /\bSET\s+(CATALOG|CONSTRAINTS)\b/
      }, {
        begin: /\b(WITH|FOR)\s+ORDINALITY\b/
      }, {
        begin: /\bIS\s+(NOT\s+)?DOCUMENT\b/
      }, {
        begin: /\bXML\s+OPTION\s+(DOCUMENT|CONTENT)\b/
      }, {
        begin: /\b(STRIP|PRESERVE)\s+WHITESPACE\b/
      }, {
        begin: /\bNO\s+(ACTION|MAXVALUE|MINVALUE)\b/
      }, {
        begin: /\bPARTITION\s+BY\s+(RANGE|LIST|HASH)\b/
      }, {
        begin: /\bAT\s+TIME\s+ZONE\b/
      }, {
        begin: /\bGRANTED\s+BY\b/
      }, {
        begin: /\bRETURN\s+(QUERY|NEXT)\b/
      }, {
        begin: /\b(ATTACH|DETACH)\s+PARTITION\b/
      }, {
        begin: /\bFORCE\s+ROW\s+LEVEL\s+SECURITY\b/
      }, {
        begin: /\b(INCLUDING|EXCLUDING)\s+(COMMENTS|CONSTRAINTS|DEFAULTS|IDENTITY|INDEXES|STATISTICS|STORAGE|ALL)\b/
      }, {
        begin: /\bAS\s+(ASSIGNMENT|IMPLICIT|PERMISSIVE|RESTRICTIVE|ENUM|RANGE)\b/
      }]
    },
    // functions named as keywords, followed by '('
    {
      begin: /\b(FORMAT|FAMILY|VERSION)\s*\(/
      // keywords: { built_in: 'FORMAT FAMILY VERSION' }
    },
    // INCLUDE ( ... ) in index_parameters in CREATE TABLE
    {
      begin: /\bINCLUDE\s*\(/,
      keywords: 'INCLUDE'
    },
    // not highlight RANGE if not in frame_clause (not 100% correct, but seems satisfactory)
    {
      begin: /\bRANGE(?!\s*(BETWEEN|UNBOUNDED|CURRENT|[-0-9]+))/
    },
    // disable highlighting in commands CREATE AGGREGATE/COLLATION/DATABASE/OPERTOR/TEXT SEARCH .../TYPE
    // and in PL/pgSQL RAISE ... USING
    {
      begin: /\b(VERSION|OWNER|TEMPLATE|TABLESPACE|CONNECTION\s+LIMIT|PROCEDURE|RESTRICT|JOIN|PARSER|COPY|START|END|COLLATION|INPUT|ANALYZE|STORAGE|LIKE|DEFAULT|DELIMITER|ENCODING|COLUMN|CONSTRAINT|TABLE|SCHEMA)\s*=/
    },
    // PG_smth; HAS_some_PRIVILEGE
    {
      // className: 'built_in',
      begin: /\b(PG_\w+?|HAS_[A-Z_]+_PRIVILEGE)\b/,
      relevance: 10
    },
    // extract
    {
      begin: /\bEXTRACT\s*\(/,
      end: /\bFROM\b/,
      returnEnd: true,
      keywords: {
        // built_in: 'EXTRACT',
        type: 'CENTURY DAY DECADE DOW DOY EPOCH HOUR ISODOW ISOYEAR MICROSECONDS ' + 'MILLENNIUM MILLISECONDS MINUTE MONTH QUARTER SECOND TIMEZONE TIMEZONE_HOUR ' + 'TIMEZONE_MINUTE WEEK YEAR'
      }
    },
    // xmlelement, xmlpi - special NAME
    {
      begin: /\b(XMLELEMENT|XMLPI)\s*\(\s*NAME/,
      keywords: {
        // built_in: 'XMLELEMENT XMLPI',
        keyword: 'NAME'
      }
    },
    // xmlparse, xmlserialize
    {
      begin: /\b(XMLPARSE|XMLSERIALIZE)\s*\(\s*(DOCUMENT|CONTENT)/,
      keywords: {
        // built_in: 'XMLPARSE XMLSERIALIZE',
        keyword: 'DOCUMENT CONTENT'
      }
    },
    // Sequences. We actually skip everything between CACHE|INCREMENT|MAXVALUE|MINVALUE and
    // nearest following numeric constant. Without with trick we find a lot of "keywords"
    // in 'avrasm' autodetection test...
    {
      beginKeywords: 'CACHE INCREMENT MAXVALUE MINVALUE',
      end: hljs.C_NUMBER_RE,
      returnEnd: true,
      keywords: 'BY CACHE INCREMENT MAXVALUE MINVALUE'
    },
    // WITH|WITHOUT TIME ZONE as part of datatype
    {
      className: 'type',
      begin: /\b(WITH|WITHOUT)\s+TIME\s+ZONE\b/
    },
    // INTERVAL optional fields
    {
      className: 'type',
      begin: /\bINTERVAL\s+(YEAR|MONTH|DAY|HOUR|MINUTE|SECOND)(\s+TO\s+(MONTH|HOUR|MINUTE|SECOND))?\b/
    },
    // Pseudo-types which allowed only as return type
    {
      begin: /\bRETURNS\s+(LANGUAGE_HANDLER|TRIGGER|EVENT_TRIGGER|FDW_HANDLER|INDEX_AM_HANDLER|TSM_HANDLER)\b/,
      keywords: {
        keyword: 'RETURNS',
        type: 'LANGUAGE_HANDLER TRIGGER EVENT_TRIGGER FDW_HANDLER INDEX_AM_HANDLER TSM_HANDLER'
      }
    },
    // Known functions - only when followed by '('
    {
      begin: '\\b(' + FUNCTIONS_RE + ')\\s*\\('
      // keywords: { built_in: FUNCTIONS }
    },
    // Types
    {
      begin: '\\.(' + TYPES_RE + ')\\b' // prevent highlight as type, say, 'oid' in 'pgclass.oid'
    }, {
      begin: '\\b(' + TYPES_RE + ')\\s+PATH\\b',
      // in XMLTABLE
      keywords: {
        keyword: 'PATH',
        // hopefully no one would use PATH type in XMLTABLE...
        type: TYPES.replace('PATH ', '')
      }
    }, {
      className: 'type',
      begin: '\\b(' + TYPES_RE + ')\\b'
    },
    // Strings, see https://www.postgresql.org/docs/11/static/sql-syntax-lexical.html#SQL-SYNTAX-CONSTANTS
    {
      className: 'string',
      begin: '\'',
      end: '\'',
      contains: [{
        begin: '\'\''
      }]
    }, {
      className: 'string',
      begin: '(e|E|u&|U&)\'',
      end: '\'',
      contains: [{
        begin: '\\\\.'
      }],
      relevance: 10
    }, hljs.END_SAME_AS_BEGIN({
      begin: DOLLAR_STRING,
      end: DOLLAR_STRING,
      contains: [{
        // actually we want them all except SQL; listed are those with known implementations
        // and XML + JSON just in case
        subLanguage: ['pgsql', 'perl', 'python', 'tcl', 'r', 'lua', 'java', 'php', 'ruby', 'bash', 'scheme', 'xml', 'json'],
        endsWithParent: true
      }]
    }),
    // identifiers in quotes
    {
      begin: '"',
      end: '"',
      contains: [{
        begin: '""'
      }]
    },
    // numbers
    hljs.C_NUMBER_MODE,
    // comments
    hljs.C_BLOCK_COMMENT_MODE, COMMENT_MODE,
    // PL/pgSQL staff
    // %ROWTYPE, %TYPE, $n
    {
      className: 'meta',
      variants: [{
        // %TYPE, %ROWTYPE
        begin: '%(ROW)?TYPE',
        relevance: 10
      }, {
        // $n
        begin: '\\$\\d+'
      }, {
        // #compiler option
        begin: '^#\\w',
        end: '$'
      }]
    },
    // <<labeles>>
    {
      className: 'symbol',
      begin: LABEL,
      relevance: 10
    }]
  };
}
module.exports = pgsql;

/***/ }),

/***/ 90684:
/***/ ((module) => {

/*
Language: PHP Template
Requires: xml.js, php.js
Author: Josh Goebel <hello@joshgoebel.com>
Website: https://www.php.net
Category: common
*/

function phpTemplate(hljs) {
  return {
    name: "PHP template",
    subLanguage: 'xml',
    contains: [{
      begin: /<\?(php|=)?/,
      end: /\?>/,
      subLanguage: 'php',
      contains: [
      // We don't want the php closing tag ?> to close the PHP block when
      // inside any of the following blocks:
      {
        begin: '/\\*',
        end: '\\*/',
        skip: true
      }, {
        begin: 'b"',
        end: '"',
        skip: true
      }, {
        begin: 'b\'',
        end: '\'',
        skip: true
      }, hljs.inherit(hljs.APOS_STRING_MODE, {
        illegal: null,
        className: null,
        contains: null,
        skip: true
      }), hljs.inherit(hljs.QUOTE_STRING_MODE, {
        illegal: null,
        className: null,
        contains: null,
        skip: true
      })]
    }]
  };
}
module.exports = phpTemplate;

/***/ }),

/***/ 11866:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
/*
Language: PHP
Author: Victor Karamzin <Victor.Karamzin@enterra-inc.com>
Contributors: Evgeny Stepanischev <imbolk@gmail.com>, Ivan Sagalaev <maniac@softwaremaniacs.org>
Website: https://www.php.net
Category: common
*/

/**
 * @param {HLJSApi} hljs
 * @returns {LanguageDetail}
 * */
function php(hljs) {
  var VARIABLE = {
    className: 'variable',
    begin: '\\$+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*' + // negative look-ahead tries to avoid matching patterns that are not
    // Perl at all like $ident$, @ident@, etc.
    "(?![A-Za-z0-9])(?![$])"
  };
  var PREPROCESSOR = {
    className: 'meta',
    variants: [{
      begin: /<\?php/,
      relevance: 10
    },
    // boost for obvious PHP
    {
      begin: /<\?[=]?/
    }, {
      begin: /\?>/
    } // end php tag
    ]
  };

  var SUBST = {
    className: 'subst',
    variants: [{
      begin: /\$\w+/
    }, {
      begin: /\{\$/,
      end: /\}/
    }]
  };
  var SINGLE_QUOTED = hljs.inherit(hljs.APOS_STRING_MODE, {
    illegal: null
  });
  var DOUBLE_QUOTED = hljs.inherit(hljs.QUOTE_STRING_MODE, {
    illegal: null,
    contains: hljs.QUOTE_STRING_MODE.contains.concat(SUBST)
  });
  var HEREDOC = hljs.END_SAME_AS_BEGIN({
    begin: /<<<[ \t]*(\w+)\n/,
    end: /[ \t]*(\w+)\b/,
    contains: hljs.QUOTE_STRING_MODE.contains.concat(SUBST)
  });
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, PREPROCESSOR],
    variants: [hljs.inherit(SINGLE_QUOTED, {
      begin: "b'",
      end: "'"
    }), hljs.inherit(DOUBLE_QUOTED, {
      begin: 'b"',
      end: '"'
    }), DOUBLE_QUOTED, SINGLE_QUOTED, HEREDOC]
  };
  var NUMBER = {
    className: 'number',
    variants: [{
      begin: "\\b0b[01]+(?:_[01]+)*\\b"
    },
    // Binary w/ underscore support
    {
      begin: "\\b0o[0-7]+(?:_[0-7]+)*\\b"
    },
    // Octals w/ underscore support
    {
      begin: "\\b0x[\\da-f]+(?:_[\\da-f]+)*\\b"
    },
    // Hex w/ underscore support
    // Decimals w/ underscore support, with optional fragments and scientific exponent (e) suffix.
    {
      begin: "(?:\\b\\d+(?:_\\d+)*(\\.(?:\\d+(?:_\\d+)*))?|\\B\\.\\d+)(?:e[+-]?\\d+)?"
    }],
    relevance: 0
  };
  var KEYWORDS = {
    keyword:
    // Magic constants:
    // <https://www.php.net/manual/en/language.constants.predefined.php>
    '__CLASS__ __DIR__ __FILE__ __FUNCTION__ __LINE__ __METHOD__ __NAMESPACE__ __TRAIT__ ' +
    // Function that look like language construct or language construct that look like function:
    // List of keywords that may not require parenthesis
    'die echo exit include include_once print require require_once ' +
    // These are not language construct (function) but operate on the currently-executing function and can access the current symbol table
    // 'compact extract func_get_arg func_get_args func_num_args get_called_class get_parent_class ' +
    // Other keywords:
    // <https://www.php.net/manual/en/reserved.php>
    // <https://www.php.net/manual/en/language.types.type-juggling.php>
    'array abstract and as binary bool boolean break callable case catch class clone const continue declare ' + 'default do double else elseif empty enddeclare endfor endforeach endif endswitch endwhile enum eval extends ' + 'final finally float for foreach from global goto if implements instanceof insteadof int integer interface ' + 'isset iterable list match|0 mixed new object or private protected public real return string switch throw trait ' + 'try unset use var void while xor yield',
    literal: 'false null true',
    built_in:
    // Standard PHP library:
    // <https://www.php.net/manual/en/book.spl.php>
    'Error|0 ' +
    // error is too common a name esp since PHP is case in-sensitive
    'AppendIterator ArgumentCountError ArithmeticError ArrayIterator ArrayObject AssertionError BadFunctionCallException BadMethodCallException CachingIterator CallbackFilterIterator CompileError Countable DirectoryIterator DivisionByZeroError DomainException EmptyIterator ErrorException Exception FilesystemIterator FilterIterator GlobIterator InfiniteIterator InvalidArgumentException IteratorIterator LengthException LimitIterator LogicException MultipleIterator NoRewindIterator OutOfBoundsException OutOfRangeException OuterIterator OverflowException ParentIterator ParseError RangeException RecursiveArrayIterator RecursiveCachingIterator RecursiveCallbackFilterIterator RecursiveDirectoryIterator RecursiveFilterIterator RecursiveIterator RecursiveIteratorIterator RecursiveRegexIterator RecursiveTreeIterator RegexIterator RuntimeException SeekableIterator SplDoublyLinkedList SplFileInfo SplFileObject SplFixedArray SplHeap SplMaxHeap SplMinHeap SplObjectStorage SplObserver SplObserver SplPriorityQueue SplQueue SplStack SplSubject SplSubject SplTempFileObject TypeError UnderflowException UnexpectedValueException UnhandledMatchError ' +
    // Reserved interfaces:
    // <https://www.php.net/manual/en/reserved.interfaces.php>
    'ArrayAccess Closure Generator Iterator IteratorAggregate Serializable Stringable Throwable Traversable WeakReference WeakMap ' +
    // Reserved classes:
    // <https://www.php.net/manual/en/reserved.classes.php>
    'Directory __PHP_Incomplete_Class parent php_user_filter self static stdClass'
  };
  return {
    aliases: ['php3', 'php4', 'php5', 'php6', 'php7', 'php8'],
    case_insensitive: true,
    keywords: KEYWORDS,
    contains: [hljs.HASH_COMMENT_MODE, hljs.COMMENT('//', '$', {
      contains: [PREPROCESSOR]
    }), hljs.COMMENT('/\\*', '\\*/', {
      contains: [{
        className: 'doctag',
        begin: '@[A-Za-z]+'
      }]
    }), hljs.COMMENT('__halt_compiler.+?;', false, {
      endsWithParent: true,
      keywords: '__halt_compiler'
    }), PREPROCESSOR, {
      className: 'keyword',
      begin: /\$this\b/
    }, VARIABLE, {
      // swallow composed identifiers to avoid parsing them as keywords
      begin: /(::|->)+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/
    }, {
      className: 'function',
      relevance: 0,
      beginKeywords: 'fn function',
      end: /[;{]/,
      excludeEnd: true,
      illegal: '[$%\\[]',
      contains: [{
        beginKeywords: 'use'
      }, hljs.UNDERSCORE_TITLE_MODE, {
        begin: '=>',
        // No markup, just a relevance booster
        endsParent: true
      }, {
        className: 'params',
        begin: '\\(',
        end: '\\)',
        excludeBegin: true,
        excludeEnd: true,
        keywords: KEYWORDS,
        contains: ['self', VARIABLE, hljs.C_BLOCK_COMMENT_MODE, STRING, NUMBER]
      }]
    }, {
      className: 'class',
      variants: [{
        beginKeywords: "enum",
        illegal: /[($"]/
      }, {
        beginKeywords: "class interface trait",
        illegal: /[:($"]/
      }],
      relevance: 0,
      end: /\{/,
      excludeEnd: true,
      contains: [{
        beginKeywords: 'extends implements'
      }, hljs.UNDERSCORE_TITLE_MODE]
    }, {
      beginKeywords: 'namespace',
      relevance: 0,
      end: ';',
      illegal: /[.']/,
      contains: [hljs.UNDERSCORE_TITLE_MODE]
    }, {
      beginKeywords: 'use',
      relevance: 0,
      end: ';',
      contains: [hljs.UNDERSCORE_TITLE_MODE]
    }, STRING, NUMBER]
  };
}
module.exports = php;

/***/ }),

/***/ 54249:
/***/ ((module) => {

/*
Language: Plain text
Author: Egor Rogov (e.rogov@postgrespro.ru)
Description: Plain text without any highlighting.
Category: common
*/

function plaintext(hljs) {
  return {
    name: 'Plain text',
    aliases: ['text', 'txt'],
    disableAutodetect: true
  };
}
module.exports = plaintext;

/***/ }),

/***/ 84521:
/***/ ((module) => {

/*
Language: Pony
Author: Joe Eli McIlvain <joe.eli.mac@gmail.com>
Description: Pony is an open-source, object-oriented, actor-model,
             capabilities-secure, high performance programming language.
Website: https://www.ponylang.io
*/

function pony(hljs) {
  var KEYWORDS = {
    keyword: 'actor addressof and as be break class compile_error compile_intrinsic ' + 'consume continue delegate digestof do else elseif embed end error ' + 'for fun if ifdef in interface is isnt lambda let match new not object ' + 'or primitive recover repeat return struct then trait try type until ' + 'use var where while with xor',
    meta: 'iso val tag trn box ref',
    literal: 'this false true'
  };
  var TRIPLE_QUOTE_STRING_MODE = {
    className: 'string',
    begin: '"""',
    end: '"""',
    relevance: 10
  };
  var QUOTE_STRING_MODE = {
    className: 'string',
    begin: '"',
    end: '"',
    contains: [hljs.BACKSLASH_ESCAPE]
  };
  var SINGLE_QUOTE_CHAR_MODE = {
    className: 'string',
    begin: '\'',
    end: '\'',
    contains: [hljs.BACKSLASH_ESCAPE],
    relevance: 0
  };
  var TYPE_NAME = {
    className: 'type',
    begin: '\\b_?[A-Z][\\w]*',
    relevance: 0
  };
  var PRIMED_NAME = {
    begin: hljs.IDENT_RE + '\'',
    relevance: 0
  };
  var NUMBER_MODE = {
    className: 'number',
    begin: '(-?)(\\b0[xX][a-fA-F0-9]+|\\b0[bB][01]+|(\\b\\d+(_\\d+)?(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)',
    relevance: 0
  };

  /**
   * The `FUNCTION` and `CLASS` modes were intentionally removed to simplify
   * highlighting and fix cases like
   * ```
   * interface Iterator[A: A]
   *   fun has_next(): Bool
   *   fun next(): A?
   * ```
   * where it is valid to have a function head without a body
   */

  return {
    name: 'Pony',
    keywords: KEYWORDS,
    contains: [TYPE_NAME, TRIPLE_QUOTE_STRING_MODE, QUOTE_STRING_MODE, SINGLE_QUOTE_CHAR_MODE, PRIMED_NAME, NUMBER_MODE, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE]
  };
}
module.exports = pony;

/***/ }),

/***/ 68986:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(41539);
__webpack_require__(39714);
__webpack_require__(92222);
__webpack_require__(69600);
/*
Language: PowerShell
Description: PowerShell is a task-based command-line shell and scripting language built on .NET.
Author: David Mohundro <david@mohundro.com>
Contributors: Nicholas Blumhardt <nblumhardt@nblumhardt.com>, Victor Zhou <OiCMudkips@users.noreply.github.com>, Nicolas Le Gall <contact@nlegall.fr>
Website: https://docs.microsoft.com/en-us/powershell/
*/

function powershell(hljs) {
  var TYPES = ["string", "char", "byte", "int", "long", "bool", "decimal", "single", "double", "DateTime", "xml", "array", "hashtable", "void"];

  // https://docs.microsoft.com/en-us/powershell/scripting/developer/cmdlet/approved-verbs-for-windows-powershell-commands
  var VALID_VERBS = 'Add|Clear|Close|Copy|Enter|Exit|Find|Format|Get|Hide|Join|Lock|' + 'Move|New|Open|Optimize|Pop|Push|Redo|Remove|Rename|Reset|Resize|' + 'Search|Select|Set|Show|Skip|Split|Step|Switch|Undo|Unlock|' + 'Watch|Backup|Checkpoint|Compare|Compress|Convert|ConvertFrom|' + 'ConvertTo|Dismount|Edit|Expand|Export|Group|Import|Initialize|' + 'Limit|Merge|Mount|Out|Publish|Restore|Save|Sync|Unpublish|Update|' + 'Approve|Assert|Build|Complete|Confirm|Deny|Deploy|Disable|Enable|Install|Invoke|' + 'Register|Request|Restart|Resume|Start|Stop|Submit|Suspend|Uninstall|' + 'Unregister|Wait|Debug|Measure|Ping|Repair|Resolve|Test|Trace|Connect|' + 'Disconnect|Read|Receive|Send|Write|Block|Grant|Protect|Revoke|Unblock|' + 'Unprotect|Use|ForEach|Sort|Tee|Where';
  var COMPARISON_OPERATORS = '-and|-as|-band|-bnot|-bor|-bxor|-casesensitive|-ccontains|-ceq|-cge|-cgt|' + '-cle|-clike|-clt|-cmatch|-cne|-cnotcontains|-cnotlike|-cnotmatch|-contains|' + '-creplace|-csplit|-eq|-exact|-f|-file|-ge|-gt|-icontains|-ieq|-ige|-igt|' + '-ile|-ilike|-ilt|-imatch|-in|-ine|-inotcontains|-inotlike|-inotmatch|' + '-ireplace|-is|-isnot|-isplit|-join|-le|-like|-lt|-match|-ne|-not|' + '-notcontains|-notin|-notlike|-notmatch|-or|-regex|-replace|-shl|-shr|' + '-split|-wildcard|-xor';
  var KEYWORDS = {
    $pattern: /-?[A-z\.\-]+\b/,
    keyword: 'if else foreach return do while until elseif begin for trap data dynamicparam ' + 'end break throw param continue finally in switch exit filter try process catch ' + 'hidden static parameter',
    // "echo" relevance has been set to 0 to avoid auto-detect conflicts with shell transcripts
    built_in: 'ac asnp cat cd CFS chdir clc clear clhy cli clp cls clv cnsn compare copy cp ' + 'cpi cpp curl cvpa dbp del diff dir dnsn ebp echo|0 epal epcsv epsn erase etsn exsn fc fhx ' + 'fl ft fw gal gbp gc gcb gci gcm gcs gdr gerr ghy gi gin gjb gl gm gmo gp gps gpv group ' + 'gsn gsnp gsv gtz gu gv gwmi h history icm iex ihy ii ipal ipcsv ipmo ipsn irm ise iwmi ' + 'iwr kill lp ls man md measure mi mount move mp mv nal ndr ni nmo npssc nsn nv ogv oh ' + 'popd ps pushd pwd r rbp rcjb rcsn rd rdr ren ri rjb rm rmdir rmo rni rnp rp rsn rsnp ' + 'rujb rv rvpa rwmi sajb sal saps sasv sbp sc scb select set shcm si sl sleep sls sort sp ' + 'spjb spps spsv start stz sujb sv swmi tee trcm type wget where wjb write'
    // TODO: 'validate[A-Z]+' can't work in keywords
  };

  var TITLE_NAME_RE = /\w[\w\d]*((-)[\w\d]+)*/;
  var BACKTICK_ESCAPE = {
    begin: '`[\\s\\S]',
    relevance: 0
  };
  var VAR = {
    className: 'variable',
    variants: [{
      begin: /\$\B/
    }, {
      className: 'keyword',
      begin: /\$this/
    }, {
      begin: /\$[\w\d][\w\d_:]*/
    }]
  };
  var LITERAL = {
    className: 'literal',
    begin: /\$(null|true|false)\b/
  };
  var QUOTE_STRING = {
    className: "string",
    variants: [{
      begin: /"/,
      end: /"/
    }, {
      begin: /@"/,
      end: /^"@/
    }],
    contains: [BACKTICK_ESCAPE, VAR, {
      className: 'variable',
      begin: /\$[A-z]/,
      end: /[^A-z]/
    }]
  };
  var APOS_STRING = {
    className: 'string',
    variants: [{
      begin: /'/,
      end: /'/
    }, {
      begin: /@'/,
      end: /^'@/
    }]
  };
  var PS_HELPTAGS = {
    className: "doctag",
    variants: [/* no paramater help tags */
    {
      begin: /\.(synopsis|description|example|inputs|outputs|notes|link|component|role|functionality)/
    }, /* one parameter help tags */
    {
      begin: /\.(parameter|forwardhelptargetname|forwardhelpcategory|remotehelprunspace|externalhelp)\s+\S+/
    }]
  };
  var PS_COMMENT = hljs.inherit(hljs.COMMENT(null, null), {
    variants: [/* single-line comment */
    {
      begin: /#/,
      end: /$/
    }, /* multi-line comment */
    {
      begin: /<#/,
      end: /#>/
    }],
    contains: [PS_HELPTAGS]
  });
  var CMDLETS = {
    className: 'built_in',
    variants: [{
      begin: '('.concat(VALID_VERBS, ')+(-)[\\w\\d]+')
    }]
  };
  var PS_CLASS = {
    className: 'class',
    beginKeywords: 'class enum',
    end: /\s*[{]/,
    excludeEnd: true,
    relevance: 0,
    contains: [hljs.TITLE_MODE]
  };
  var PS_FUNCTION = {
    className: 'function',
    begin: /function\s+/,
    end: /\s*\{|$/,
    excludeEnd: true,
    returnBegin: true,
    relevance: 0,
    contains: [{
      begin: "function",
      relevance: 0,
      className: "keyword"
    }, {
      className: "title",
      begin: TITLE_NAME_RE,
      relevance: 0
    }, {
      begin: /\(/,
      end: /\)/,
      className: "params",
      relevance: 0,
      contains: [VAR]
    }
    // CMDLETS
    ]
  };

  // Using statment, plus type, plus assembly name.
  var PS_USING = {
    begin: /using\s/,
    end: /$/,
    returnBegin: true,
    contains: [QUOTE_STRING, APOS_STRING, {
      className: 'keyword',
      begin: /(using|assembly|command|module|namespace|type)/
    }]
  };

  // Comperison operators & function named parameters.
  var PS_ARGUMENTS = {
    variants: [
    // PS literals are pretty verbose so it's a good idea to accent them a bit.
    {
      className: 'operator',
      begin: '('.concat(COMPARISON_OPERATORS, ')\\b')
    }, {
      className: 'literal',
      begin: /(-)[\w\d]+/,
      relevance: 0
    }]
  };
  var HASH_SIGNS = {
    className: 'selector-tag',
    begin: /@\B/,
    relevance: 0
  };

  // It's a very general rule so I'll narrow it a bit with some strict boundaries
  // to avoid any possible false-positive collisions!
  var PS_METHODS = {
    className: 'function',
    begin: /\[.*\]\s*[\w]+[ ]??\(/,
    end: /$/,
    returnBegin: true,
    relevance: 0,
    contains: [{
      className: 'keyword',
      begin: '('.concat(KEYWORDS.keyword.toString().replace(/\s/g, '|'), ')\\b'),
      endsParent: true,
      relevance: 0
    }, hljs.inherit(hljs.TITLE_MODE, {
      endsParent: true
    })]
  };
  var GENTLEMANS_SET = [
  // STATIC_MEMBER,
  PS_METHODS, PS_COMMENT, BACKTICK_ESCAPE, hljs.NUMBER_MODE, QUOTE_STRING, APOS_STRING,
  // PS_NEW_OBJECT_TYPE,
  CMDLETS, VAR, LITERAL, HASH_SIGNS];
  var PS_TYPE = {
    begin: /\[/,
    end: /\]/,
    excludeBegin: true,
    excludeEnd: true,
    relevance: 0,
    contains: [].concat('self', GENTLEMANS_SET, {
      begin: "(" + TYPES.join("|") + ")",
      className: "built_in",
      relevance: 0
    }, {
      className: 'type',
      begin: /[\.\w\d]+/,
      relevance: 0
    })
  };
  PS_METHODS.contains.unshift(PS_TYPE);
  return {
    name: 'PowerShell',
    aliases: ["ps", "ps1"],
    case_insensitive: true,
    keywords: KEYWORDS,
    contains: GENTLEMANS_SET.concat(PS_CLASS, PS_FUNCTION, PS_USING, PS_ARGUMENTS, PS_TYPE)
  };
}
module.exports = powershell;

/***/ }),

/***/ 2283:
/***/ ((module) => {

/*
Language: Processing
Description: Processing is a flexible software sketchbook and a language for learning how to code within the context of the visual arts.
Author: Erik Paluka <erik.paluka@gmail.com>
Website: https://processing.org
Category: graphics
*/

function processing(hljs) {
  return {
    name: 'Processing',
    keywords: {
      keyword: 'BufferedReader PVector PFont PImage PGraphics HashMap boolean byte char color ' + 'double float int long String Array FloatDict FloatList IntDict IntList JSONArray JSONObject ' + 'Object StringDict StringList Table TableRow XML ' +
      // Java keywords
      'false synchronized int abstract float private char boolean static null if const ' + 'for true while long throw strictfp finally protected import native final return void ' + 'enum else break transient new catch instanceof byte super volatile case assert short ' + 'package default double public try this switch continue throws protected public private',
      literal: 'P2D P3D HALF_PI PI QUARTER_PI TAU TWO_PI',
      title: 'setup draw',
      built_in: 'displayHeight displayWidth mouseY mouseX mousePressed pmouseX pmouseY key ' + 'keyCode pixels focused frameCount frameRate height width ' + 'size createGraphics beginDraw createShape loadShape PShape arc ellipse line point ' + 'quad rect triangle bezier bezierDetail bezierPoint bezierTangent curve curveDetail curvePoint ' + 'curveTangent curveTightness shape shapeMode beginContour beginShape bezierVertex curveVertex ' + 'endContour endShape quadraticVertex vertex ellipseMode noSmooth rectMode smooth strokeCap ' + 'strokeJoin strokeWeight mouseClicked mouseDragged mouseMoved mousePressed mouseReleased ' + 'mouseWheel keyPressed keyPressedkeyReleased keyTyped print println save saveFrame day hour ' + 'millis minute month second year background clear colorMode fill noFill noStroke stroke alpha ' + 'blue brightness color green hue lerpColor red saturation modelX modelY modelZ screenX screenY ' + 'screenZ ambient emissive shininess specular add createImage beginCamera camera endCamera frustum ' + 'ortho perspective printCamera printProjection cursor frameRate noCursor exit loop noLoop popStyle ' + 'pushStyle redraw binary boolean byte char float hex int str unbinary unhex join match matchAll nf ' + 'nfc nfp nfs split splitTokens trim append arrayCopy concat expand reverse shorten sort splice subset ' + 'box sphere sphereDetail createInput createReader loadBytes loadJSONArray loadJSONObject loadStrings ' + 'loadTable loadXML open parseXML saveTable selectFolder selectInput beginRaw beginRecord createOutput ' + 'createWriter endRaw endRecord PrintWritersaveBytes saveJSONArray saveJSONObject saveStream saveStrings ' + 'saveXML selectOutput popMatrix printMatrix pushMatrix resetMatrix rotate rotateX rotateY rotateZ scale ' + 'shearX shearY translate ambientLight directionalLight lightFalloff lights lightSpecular noLights normal ' + 'pointLight spotLight image imageMode loadImage noTint requestImage tint texture textureMode textureWrap ' + 'blend copy filter get loadPixels set updatePixels blendMode loadShader PShaderresetShader shader createFont ' + 'loadFont text textFont textAlign textLeading textMode textSize textWidth textAscent textDescent abs ceil ' + 'constrain dist exp floor lerp log mag map max min norm pow round sq sqrt acos asin atan atan2 cos degrees ' + 'radians sin tan noise noiseDetail noiseSeed random randomGaussian randomSeed'
    },
    contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, hljs.C_NUMBER_MODE]
  };
}
module.exports = processing;

/***/ }),

/***/ 86209:
/***/ ((module) => {

/*
Language: Python profiler
Description: Python profiler results
Author: Brian Beck <exogen@gmail.com>
*/

function profile(hljs) {
  return {
    name: 'Python profiler',
    contains: [hljs.C_NUMBER_MODE, {
      begin: '[a-zA-Z_][\\da-zA-Z_]+\\.[\\da-zA-Z_]{1,3}',
      end: ':',
      excludeEnd: true
    }, {
      begin: '(ncalls|tottime|cumtime)',
      end: '$',
      keywords: 'ncalls tottime|10 cumtime|10 filename',
      relevance: 10
    }, {
      begin: 'function calls',
      end: '$',
      contains: [hljs.C_NUMBER_MODE],
      relevance: 10
    }, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, {
      className: 'string',
      begin: '\\(',
      end: '\\)$',
      excludeBegin: true,
      excludeEnd: true,
      relevance: 0
    }]
  };
}
module.exports = profile;

/***/ }),

/***/ 26695:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
/*
Language: Prolog
Description: Prolog is a general purpose logic programming language associated with artificial intelligence and computational linguistics.
Author: Raivo Laanemets <raivo@infdot.com>
Website: https://en.wikipedia.org/wiki/Prolog
*/

function prolog(hljs) {
  var ATOM = {
    begin: /[a-z][A-Za-z0-9_]*/,
    relevance: 0
  };
  var VAR = {
    className: 'symbol',
    variants: [{
      begin: /[A-Z][a-zA-Z0-9_]*/
    }, {
      begin: /_[A-Za-z0-9_]*/
    }],
    relevance: 0
  };
  var PARENTED = {
    begin: /\(/,
    end: /\)/,
    relevance: 0
  };
  var LIST = {
    begin: /\[/,
    end: /\]/
  };
  var LINE_COMMENT = {
    className: 'comment',
    begin: /%/,
    end: /$/,
    contains: [hljs.PHRASAL_WORDS_MODE]
  };
  var BACKTICK_STRING = {
    className: 'string',
    begin: /`/,
    end: /`/,
    contains: [hljs.BACKSLASH_ESCAPE]
  };
  var CHAR_CODE = {
    className: 'string',
    // 0'a etc.
    begin: /0'(\\'|.)/
  };
  var SPACE_CODE = {
    className: 'string',
    begin: /0'\\s/ // 0'\s
  };

  var PRED_OP = {
    // relevance booster
    begin: /:-/
  };
  var inner = [ATOM, VAR, PARENTED, PRED_OP, LIST, LINE_COMMENT, hljs.C_BLOCK_COMMENT_MODE, hljs.QUOTE_STRING_MODE, hljs.APOS_STRING_MODE, BACKTICK_STRING, CHAR_CODE, SPACE_CODE, hljs.C_NUMBER_MODE];
  PARENTED.contains = inner;
  LIST.contains = inner;
  return {
    name: 'Prolog',
    contains: inner.concat([{
      // relevance booster
      begin: /\.$/
    }])
  };
}
module.exports = prolog;

/***/ }),

/***/ 44621:
/***/ ((module) => {

/*
Language: .properties
Contributors: Valentin Aitken <valentin@nalisbg.com>, Egor Rogov <e.rogov@postgrespro.ru>
Website: https://en.wikipedia.org/wiki/.properties
Category: common, config
*/

function properties(hljs) {
  // whitespaces: space, tab, formfeed
  var WS0 = '[ \\t\\f]*';
  var WS1 = '[ \\t\\f]+';
  // delimiter
  var EQUAL_DELIM = WS0 + '[:=]' + WS0;
  var WS_DELIM = WS1;
  var DELIM = '(' + EQUAL_DELIM + '|' + WS_DELIM + ')';
  var KEY_ALPHANUM = '([^\\\\\\W:= \\t\\f\\n]|\\\\.)+';
  var KEY_OTHER = '([^\\\\:= \\t\\f\\n]|\\\\.)+';
  var DELIM_AND_VALUE = {
    // skip DELIM
    end: DELIM,
    relevance: 0,
    starts: {
      // value: everything until end of line (again, taking into account backslashes)
      className: 'string',
      end: /$/,
      relevance: 0,
      contains: [{
        begin: '\\\\\\\\'
      }, {
        begin: '\\\\\\n'
      }]
    }
  };
  return {
    name: '.properties',
    case_insensitive: true,
    illegal: /\S/,
    contains: [hljs.COMMENT('^\\s*[!#]', '$'),
    // key: everything until whitespace or = or : (taking into account backslashes)
    // case of a "normal" key
    {
      returnBegin: true,
      variants: [{
        begin: KEY_ALPHANUM + EQUAL_DELIM,
        relevance: 1
      }, {
        begin: KEY_ALPHANUM + WS_DELIM,
        relevance: 0
      }],
      contains: [{
        className: 'attr',
        begin: KEY_ALPHANUM,
        endsParent: true,
        relevance: 0
      }],
      starts: DELIM_AND_VALUE
    },
    // case of key containing non-alphanumeric chars => relevance = 0
    {
      begin: KEY_OTHER + DELIM,
      returnBegin: true,
      relevance: 0,
      contains: [{
        className: 'meta',
        begin: KEY_OTHER,
        endsParent: true,
        relevance: 0
      }],
      starts: DELIM_AND_VALUE
    },
    // case of an empty key
    {
      className: 'attr',
      relevance: 0,
      begin: KEY_OTHER + WS0 + '$'
    }]
  };
}
module.exports = properties;

/***/ }),

/***/ 6348:
/***/ ((module) => {

/*
Language: Protocol Buffers
Author: Dan Tao <daniel.tao@gmail.com>
Description: Protocol buffer message definition format
Website: https://developers.google.com/protocol-buffers/docs/proto3
Category: protocols
*/

function protobuf(hljs) {
  return {
    name: 'Protocol Buffers',
    keywords: {
      keyword: 'package import option optional required repeated group oneof',
      built_in: 'double float int32 int64 uint32 uint64 sint32 sint64 ' + 'fixed32 fixed64 sfixed32 sfixed64 bool string bytes',
      literal: 'true false'
    },
    contains: [hljs.QUOTE_STRING_MODE, hljs.NUMBER_MODE, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, {
      className: 'class',
      beginKeywords: 'message enum service',
      end: /\{/,
      illegal: /\n/,
      contains: [hljs.inherit(hljs.TITLE_MODE, {
        starts: {
          endsWithParent: true,
          excludeEnd: true
        } // hack: eating everything after the first title
      })]
    }, {
      className: 'function',
      beginKeywords: 'rpc',
      end: /[{;]/,
      excludeEnd: true,
      keywords: 'rpc returns'
    }, {
      // match enum items (relevance)
      // BLAH = ...;
      begin: /^\s*[A-Z_]+(?=\s*=[^\n]+;$)/
    }]
  };
}
module.exports = protobuf;

/***/ }),

/***/ 29247:
/***/ ((module) => {

/*
Language: Puppet
Author: Jose Molina Colmenero <gaudy41@gmail.com>
Website: https://puppet.com/docs
Category: config
*/

function puppet(hljs) {
  var PUPPET_KEYWORDS = {
    keyword: /* language keywords */
    'and case default else elsif false if in import enherits node or true undef unless main settings $string ',
    literal: /* metaparameters */
    'alias audit before loglevel noop require subscribe tag ' + /* normal attributes */
    'owner ensure group mode name|0 changes context force incl lens load_path onlyif provider returns root show_diff type_check ' + 'en_address ip_address realname command environment hour monute month monthday special target weekday ' + 'creates cwd ogoutput refresh refreshonly tries try_sleep umask backup checksum content ctime force ignore ' + 'links mtime purge recurse recurselimit replace selinux_ignore_defaults selrange selrole seltype seluser source ' + 'souirce_permissions sourceselect validate_cmd validate_replacement allowdupe attribute_membership auth_membership forcelocal gid ' + 'ia_load_module members system host_aliases ip allowed_trunk_vlans description device_url duplex encapsulation etherchannel ' + 'native_vlan speed principals allow_root auth_class auth_type authenticate_user k_of_n mechanisms rule session_owner shared options ' + 'device fstype enable hasrestart directory present absent link atboot blockdevice device dump pass remounts poller_tag use ' + 'message withpath adminfile allow_virtual allowcdrom category configfiles flavor install_options instance package_settings platform ' + 'responsefile status uninstall_options vendor unless_system_user unless_uid binary control flags hasstatus manifest pattern restart running ' + 'start stop allowdupe auths expiry gid groups home iterations key_membership keys managehome membership password password_max_age ' + 'password_min_age profile_membership profiles project purge_ssh_keys role_membership roles salt shell uid baseurl cost descr enabled ' + 'enablegroups exclude failovermethod gpgcheck gpgkey http_caching include includepkgs keepalive metadata_expire metalink mirrorlist ' + 'priority protect proxy proxy_password proxy_username repo_gpgcheck s3_enabled skip_if_unavailable sslcacert sslclientcert sslclientkey ' + 'sslverify mounted',
    built_in: /* core facts */
    'architecture augeasversion blockdevices boardmanufacturer boardproductname boardserialnumber cfkey dhcp_servers ' + 'domain ec2_ ec2_userdata facterversion filesystems ldom fqdn gid hardwareisa hardwaremodel hostname id|0 interfaces ' + 'ipaddress ipaddress_ ipaddress6 ipaddress6_ iphostnumber is_virtual kernel kernelmajversion kernelrelease kernelversion ' + 'kernelrelease kernelversion lsbdistcodename lsbdistdescription lsbdistid lsbdistrelease lsbmajdistrelease lsbminordistrelease ' + 'lsbrelease macaddress macaddress_ macosx_buildversion macosx_productname macosx_productversion macosx_productverson_major ' + 'macosx_productversion_minor manufacturer memoryfree memorysize netmask metmask_ network_ operatingsystem operatingsystemmajrelease ' + 'operatingsystemrelease osfamily partitions path physicalprocessorcount processor processorcount productname ps puppetversion ' + 'rubysitedir rubyversion selinux selinux_config_mode selinux_config_policy selinux_current_mode selinux_current_mode selinux_enforced ' + 'selinux_policyversion serialnumber sp_ sshdsakey sshecdsakey sshrsakey swapencrypted swapfree swapsize timezone type uniqueid uptime ' + 'uptime_days uptime_hours uptime_seconds uuid virtual vlans xendomains zfs_version zonenae zones zpool_version'
  };
  var COMMENT = hljs.COMMENT('#', '$');
  var IDENT_RE = '([A-Za-z_]|::)(\\w|::)*';
  var TITLE = hljs.inherit(hljs.TITLE_MODE, {
    begin: IDENT_RE
  });
  var VARIABLE = {
    className: 'variable',
    begin: '\\$' + IDENT_RE
  };
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, VARIABLE],
    variants: [{
      begin: /'/,
      end: /'/
    }, {
      begin: /"/,
      end: /"/
    }]
  };
  return {
    name: 'Puppet',
    aliases: ['pp'],
    contains: [COMMENT, VARIABLE, STRING, {
      beginKeywords: 'class',
      end: '\\{|;',
      illegal: /=/,
      contains: [TITLE, COMMENT]
    }, {
      beginKeywords: 'define',
      end: /\{/,
      contains: [{
        className: 'section',
        begin: hljs.IDENT_RE,
        endsParent: true
      }]
    }, {
      begin: hljs.IDENT_RE + '\\s+\\{',
      returnBegin: true,
      end: /\S/,
      contains: [{
        className: 'keyword',
        begin: hljs.IDENT_RE
      }, {
        begin: /\{/,
        end: /\}/,
        keywords: PUPPET_KEYWORDS,
        relevance: 0,
        contains: [STRING, COMMENT, {
          begin: '[a-zA-Z_]+\\s*=>',
          returnBegin: true,
          end: '=>',
          contains: [{
            className: 'attr',
            begin: hljs.IDENT_RE
          }]
        }, {
          className: 'number',
          begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
          relevance: 0
        }, VARIABLE]
      }],
      relevance: 0
    }]
  };
}
module.exports = puppet;

/***/ }),

/***/ 82783:
/***/ ((module) => {

/*
Language: PureBASIC
Author: Tristano Ajmone <tajmone@gmail.com>
Description: Syntax highlighting for PureBASIC (v.5.00-5.60). No inline ASM highlighting. (v.1.2, May 2017)
Credits: I've taken inspiration from the PureBasic language file for GeSHi, created by Gustavo Julio Fiorenza (GuShH).
Website: https://www.purebasic.com
*/

// Base deafult colors in PB IDE: background: #FFFFDF; foreground: #000000;

function purebasic(hljs) {
  var STRINGS = {
    // PB IDE color: #0080FF (Azure Radiance)
    className: 'string',
    begin: '(~)?"',
    end: '"',
    illegal: '\\n'
  };
  var CONSTANTS = {
    // PB IDE color: #924B72 (Cannon Pink)
    //  "#" + a letter or underscore + letters, digits or underscores + (optional) "$"
    className: 'symbol',
    begin: '#[a-zA-Z_]\\w*\\$?'
  };
  return {
    name: 'PureBASIC',
    aliases: ['pb', 'pbi'],
    keywords:
    // PB IDE color: #006666 (Blue Stone) + Bold
    // Keywords from all version of PureBASIC 5.00 upward ...
    'Align And Array As Break CallDebugger Case CompilerCase CompilerDefault ' + 'CompilerElse CompilerElseIf CompilerEndIf CompilerEndSelect CompilerError ' + 'CompilerIf CompilerSelect CompilerWarning Continue Data DataSection Debug ' + 'DebugLevel Declare DeclareC DeclareCDLL DeclareDLL DeclareModule Default ' + 'Define Dim DisableASM DisableDebugger DisableExplicit Else ElseIf EnableASM ' + 'EnableDebugger EnableExplicit End EndDataSection EndDeclareModule EndEnumeration ' + 'EndIf EndImport EndInterface EndMacro EndModule EndProcedure EndSelect ' + 'EndStructure EndStructureUnion EndWith Enumeration EnumerationBinary Extends ' + 'FakeReturn For ForEach ForEver Global Gosub Goto If Import ImportC ' + 'IncludeBinary IncludeFile IncludePath Interface List Macro MacroExpandedCount ' + 'Map Module NewList NewMap Next Not Or Procedure ProcedureC ' + 'ProcedureCDLL ProcedureDLL ProcedureReturn Protected Prototype PrototypeC ReDim ' + 'Read Repeat Restore Return Runtime Select Shared Static Step Structure ' + 'StructureUnion Swap Threaded To UndefineMacro Until Until  UnuseModule ' + 'UseModule Wend While With XIncludeFile XOr',
    contains: [
    // COMMENTS | PB IDE color: #00AAAA (Persian Green)
    hljs.COMMENT(';', '$', {
      relevance: 0
    }), {
      // PROCEDURES DEFINITIONS
      className: 'function',
      begin: '\\b(Procedure|Declare)(C|CDLL|DLL)?\\b',
      end: '\\(',
      excludeEnd: true,
      returnBegin: true,
      contains: [{
        // PROCEDURE KEYWORDS | PB IDE color: #006666 (Blue Stone) + Bold
        className: 'keyword',
        begin: '(Procedure|Declare)(C|CDLL|DLL)?',
        excludeEnd: true
      }, {
        // PROCEDURE RETURN TYPE SETTING | PB IDE color: #000000 (Black)
        className: 'type',
        begin: '\\.\\w*'
        // end: ' ',
      }, hljs.UNDERSCORE_TITLE_MODE // PROCEDURE NAME | PB IDE color: #006666 (Blue Stone)
      ]
    }, STRINGS, CONSTANTS]
  };
}

/*  ==============================================================================
                                      CHANGELOG
    ==============================================================================
    - v.1.2 (2017-05-12)
        -- BUG-FIX: Some keywords were accidentally joyned together. Now fixed.
    - v.1.1 (2017-04-30)
        -- Updated to PureBASIC 5.60.
        -- Keywords list now built by extracting them from the PureBASIC SDK's
           "SyntaxHilighting.dll" (from each PureBASIC version). Tokens from each
           version are added to the list, and renamed or removed tokens are kept
           for the sake of covering all versions of the language from PureBASIC
           v5.00 upward. (NOTE: currently, there are no renamed or deprecated
           tokens in the keywords list). For more info, see:
           -- http://www.purebasic.fr/english/viewtopic.php?&p=506269
           -- https://github.com/tajmone/purebasic-archives/tree/master/syntax-highlighting/guidelines
    - v.1.0 (April 2016)
        -- First release
        -- Keywords list taken and adapted from GuShH's (Gustavo Julio Fiorenza)
           PureBasic language file for GeSHi:
           -- https://github.com/easybook/geshi/blob/master/geshi/purebasic.php
*/

module.exports = purebasic;

/***/ }),

/***/ 90258:
/***/ ((module) => {

/*
Language: Python REPL
Requires: python.js
Author: Josh Goebel <hello@joshgoebel.com>
Category: common
*/

function pythonRepl(hljs) {
  return {
    aliases: ['pycon'],
    contains: [{
      className: 'meta',
      starts: {
        // a space separates the REPL prefix from the actual code
        // this is purely for cleaner HTML output
        end: / |$/,
        starts: {
          end: '$',
          subLanguage: 'python'
        }
      },
      variants: [{
        begin: /^>>>(?=[ ]|$)/
      }, {
        begin: /^\.\.\.(?=[ ]|$)/
      }]
    }]
  };
}
module.exports = pythonRepl;

/***/ }),

/***/ 69509:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(92222);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function lookahead(re) {
  return concat('(?=', re, ')');
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/*
Language: Python
Description: Python is an interpreted, object-oriented, high-level programming language with dynamic semantics.
Website: https://www.python.org
Category: common
*/

function python(hljs) {
  var RESERVED_WORDS = ['and', 'as', 'assert', 'async', 'await', 'break', 'class', 'continue', 'def', 'del', 'elif', 'else', 'except', 'finally', 'for', 'from', 'global', 'if', 'import', 'in', 'is', 'lambda', 'nonlocal|10', 'not', 'or', 'pass', 'raise', 'return', 'try', 'while', 'with', 'yield'];
  var BUILT_INS = ['__import__', 'abs', 'all', 'any', 'ascii', 'bin', 'bool', 'breakpoint', 'bytearray', 'bytes', 'callable', 'chr', 'classmethod', 'compile', 'complex', 'delattr', 'dict', 'dir', 'divmod', 'enumerate', 'eval', 'exec', 'filter', 'float', 'format', 'frozenset', 'getattr', 'globals', 'hasattr', 'hash', 'help', 'hex', 'id', 'input', 'int', 'isinstance', 'issubclass', 'iter', 'len', 'list', 'locals', 'map', 'max', 'memoryview', 'min', 'next', 'object', 'oct', 'open', 'ord', 'pow', 'print', 'property', 'range', 'repr', 'reversed', 'round', 'set', 'setattr', 'slice', 'sorted', 'staticmethod', 'str', 'sum', 'super', 'tuple', 'type', 'vars', 'zip'];
  var LITERALS = ['__debug__', 'Ellipsis', 'False', 'None', 'NotImplemented', 'True'];

  // https://docs.python.org/3/library/typing.html
  // TODO: Could these be supplemented by a CamelCase matcher in certain
  // contexts, leaving these remaining only for relevance hinting?
  var TYPES = ["Any", "Callable", "Coroutine", "Dict", "List", "Literal", "Generic", "Optional", "Sequence", "Set", "Tuple", "Type", "Union"];
  var KEYWORDS = {
    $pattern: /[A-Za-z]\w+|__\w+__/,
    keyword: RESERVED_WORDS,
    built_in: BUILT_INS,
    literal: LITERALS,
    type: TYPES
  };
  var PROMPT = {
    className: 'meta',
    begin: /^(>>>|\.\.\.) /
  };
  var SUBST = {
    className: 'subst',
    begin: /\{/,
    end: /\}/,
    keywords: KEYWORDS,
    illegal: /#/
  };
  var LITERAL_BRACKET = {
    begin: /\{\{/,
    relevance: 0
  };
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE],
    variants: [{
      begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?'''/,
      end: /'''/,
      contains: [hljs.BACKSLASH_ESCAPE, PROMPT],
      relevance: 10
    }, {
      begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?"""/,
      end: /"""/,
      contains: [hljs.BACKSLASH_ESCAPE, PROMPT],
      relevance: 10
    }, {
      begin: /([fF][rR]|[rR][fF]|[fF])'''/,
      end: /'''/,
      contains: [hljs.BACKSLASH_ESCAPE, PROMPT, LITERAL_BRACKET, SUBST]
    }, {
      begin: /([fF][rR]|[rR][fF]|[fF])"""/,
      end: /"""/,
      contains: [hljs.BACKSLASH_ESCAPE, PROMPT, LITERAL_BRACKET, SUBST]
    }, {
      begin: /([uU]|[rR])'/,
      end: /'/,
      relevance: 10
    }, {
      begin: /([uU]|[rR])"/,
      end: /"/,
      relevance: 10
    }, {
      begin: /([bB]|[bB][rR]|[rR][bB])'/,
      end: /'/
    }, {
      begin: /([bB]|[bB][rR]|[rR][bB])"/,
      end: /"/
    }, {
      begin: /([fF][rR]|[rR][fF]|[fF])'/,
      end: /'/,
      contains: [hljs.BACKSLASH_ESCAPE, LITERAL_BRACKET, SUBST]
    }, {
      begin: /([fF][rR]|[rR][fF]|[fF])"/,
      end: /"/,
      contains: [hljs.BACKSLASH_ESCAPE, LITERAL_BRACKET, SUBST]
    }, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE]
  };

  // https://docs.python.org/3.9/reference/lexical_analysis.html#numeric-literals
  var digitpart = '[0-9](_?[0-9])*';
  var pointfloat = "(\\b(".concat(digitpart, "))?\\.(").concat(digitpart, ")|\\b(").concat(digitpart, ")\\.");
  var NUMBER = {
    className: 'number',
    relevance: 0,
    variants: [
    // exponentfloat, pointfloat
    // https://docs.python.org/3.9/reference/lexical_analysis.html#floating-point-literals
    // optionally imaginary
    // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
    // Note: no leading \b because floats can start with a decimal point
    // and we don't want to mishandle e.g. `fn(.5)`,
    // no trailing \b for pointfloat because it can end with a decimal point
    // and we don't want to mishandle e.g. `0..hex()`; this should be safe
    // because both MUST contain a decimal point and so cannot be confused with
    // the interior part of an identifier
    {
      begin: "(\\b(".concat(digitpart, ")|(").concat(pointfloat, "))[eE][+-]?(").concat(digitpart, ")[jJ]?\\b")
    }, {
      begin: "(".concat(pointfloat, ")[jJ]?")
    },
    // decinteger, bininteger, octinteger, hexinteger
    // https://docs.python.org/3.9/reference/lexical_analysis.html#integer-literals
    // optionally "long" in Python 2
    // https://docs.python.org/2.7/reference/lexical_analysis.html#integer-and-long-integer-literals
    // decinteger is optionally imaginary
    // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
    {
      begin: '\\b([1-9](_?[0-9])*|0+(_?0)*)[lLjJ]?\\b'
    }, {
      begin: '\\b0[bB](_?[01])+[lL]?\\b'
    }, {
      begin: '\\b0[oO](_?[0-7])+[lL]?\\b'
    }, {
      begin: '\\b0[xX](_?[0-9a-fA-F])+[lL]?\\b'
    },
    // imagnumber (digitpart-based)
    // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
    {
      begin: "\\b(".concat(digitpart, ")[jJ]\\b")
    }]
  };
  var COMMENT_TYPE = {
    className: "comment",
    begin: lookahead(/# type:/),
    end: /$/,
    keywords: KEYWORDS,
    contains: [{
      // prevent keywords from coloring `type`
      begin: /# type:/
    },
    // comment within a datatype comment includes no keywords
    {
      begin: /#/,
      end: /\b\B/,
      endsWithParent: true
    }]
  };
  var PARAMS = {
    className: 'params',
    variants: [
    // Exclude params in functions without params
    {
      className: "",
      begin: /\(\s*\)/,
      skip: true
    }, {
      begin: /\(/,
      end: /\)/,
      excludeBegin: true,
      excludeEnd: true,
      keywords: KEYWORDS,
      contains: ['self', PROMPT, NUMBER, STRING, hljs.HASH_COMMENT_MODE]
    }]
  };
  SUBST.contains = [STRING, NUMBER, PROMPT];
  return {
    name: 'Python',
    aliases: ['py', 'gyp', 'ipython'],
    keywords: KEYWORDS,
    illegal: /(<\/|->|\?)|=>/,
    contains: [PROMPT, NUMBER, {
      // very common convention
      begin: /\bself\b/
    }, {
      // eat "if" prior to string so that it won't accidentally be
      // labeled as an f-string
      beginKeywords: "if",
      relevance: 0
    }, STRING, COMMENT_TYPE, hljs.HASH_COMMENT_MODE, {
      variants: [{
        className: 'function',
        beginKeywords: 'def'
      }, {
        className: 'class',
        beginKeywords: 'class'
      }],
      end: /:/,
      illegal: /[${=;\n,]/,
      contains: [hljs.UNDERSCORE_TITLE_MODE, PARAMS, {
        begin: /->/,
        endsWithParent: true,
        keywords: KEYWORDS
      }]
    }, {
      className: 'meta',
      begin: /^[\t ]*@/,
      end: /(?=#)|$/,
      contains: [NUMBER, PARAMS, STRING]
    }]
  };
}
module.exports = python;

/***/ }),

/***/ 40848:
/***/ ((module) => {

/*
Language: Q
Description: Q is a vector-based functional paradigm programming language built into the kdb+ database.
             (K/Q/Kdb+ from Kx Systems)
Author: Sergey Vidyuk <svidyuk@gmail.com>
Website: https://kx.com/connect-with-us/developers/
*/

function q(hljs) {
  var KEYWORDS = {
    $pattern: /(`?)[A-Za-z0-9_]+\b/,
    keyword: 'do while select delete by update from',
    literal: '0b 1b',
    built_in: 'neg not null string reciprocal floor ceiling signum mod xbar xlog and or each scan over prior mmu lsq inv md5 ltime gtime count first var dev med cov cor all any rand sums prds mins maxs fills deltas ratios avgs differ prev next rank reverse iasc idesc asc desc msum mcount mavg mdev xrank mmin mmax xprev rotate distinct group where flip type key til get value attr cut set upsert raze union inter except cross sv vs sublist enlist read0 read1 hopen hclose hdel hsym hcount peach system ltrim rtrim trim lower upper ssr view tables views cols xcols keys xkey xcol xasc xdesc fkeys meta lj aj aj0 ij pj asof uj ww wj wj1 fby xgroup ungroup ej save load rsave rload show csv parse eval min max avg wavg wsum sin cos tan sum',
    type: '`float `double int `timestamp `timespan `datetime `time `boolean `symbol `char `byte `short `long `real `month `date `minute `second `guid'
  };
  return {
    name: 'Q',
    aliases: ['k', 'kdb'],
    keywords: KEYWORDS,
    contains: [hljs.C_LINE_COMMENT_MODE, hljs.QUOTE_STRING_MODE, hljs.C_NUMBER_MODE]
  };
}
module.exports = q;

/***/ }),

/***/ 63650:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/*
Language: QML
Requires: javascript.js, xml.js
Author: John Foster <jfoster@esri.com>
Description: Syntax highlighting for the Qt Quick QML scripting language, based mostly off
             the JavaScript parser.
Website: https://doc.qt.io/qt-5/qmlapplications.html
Category: scripting
*/

function qml(hljs) {
  var KEYWORDS = {
    keyword: 'in of on if for while finally var new function do return void else break catch ' + 'instanceof with throw case default try this switch continue typeof delete ' + 'let yield const export super debugger as async await import',
    literal: 'true false null undefined NaN Infinity',
    built_in: 'eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent ' + 'encodeURI encodeURIComponent escape unescape Object Function Boolean Error ' + 'EvalError InternalError RangeError ReferenceError StopIteration SyntaxError ' + 'TypeError URIError Number Math Date String RegExp Array Float32Array ' + 'Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array ' + 'Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require ' + 'module console window document Symbol Set Map WeakSet WeakMap Proxy Reflect ' + 'Behavior bool color coordinate date double enumeration font geocircle georectangle ' + 'geoshape int list matrix4x4 parent point quaternion real rect ' + 'size string url variant vector2d vector3d vector4d ' + 'Promise'
  };
  var QML_IDENT_RE = '[a-zA-Z_][a-zA-Z0-9\\._]*';

  // Isolate property statements. Ends at a :, =, ;, ,, a comment or end of line.
  // Use property class.
  var PROPERTY = {
    className: 'keyword',
    begin: '\\bproperty\\b',
    starts: {
      className: 'string',
      end: '(:|=|;|,|//|/\\*|$)',
      returnEnd: true
    }
  };

  // Isolate signal statements. Ends at a ) a comment or end of line.
  // Use property class.
  var SIGNAL = {
    className: 'keyword',
    begin: '\\bsignal\\b',
    starts: {
      className: 'string',
      end: '(\\(|:|=|;|,|//|/\\*|$)',
      returnEnd: true
    }
  };

  // id: is special in QML. When we see id: we want to mark the id: as attribute and
  // emphasize the token following.
  var ID_ID = {
    className: 'attribute',
    begin: '\\bid\\s*:',
    starts: {
      className: 'string',
      end: QML_IDENT_RE,
      returnEnd: false
    }
  };

  // Find QML object attribute. An attribute is a QML identifier followed by :.
  // Unfortunately it's hard to know where it ends, as it may contain scalars,
  // objects, object definitions, or javascript. The true end is either when the parent
  // ends or the next attribute is detected.
  var QML_ATTRIBUTE = {
    begin: QML_IDENT_RE + '\\s*:',
    returnBegin: true,
    contains: [{
      className: 'attribute',
      begin: QML_IDENT_RE,
      end: '\\s*:',
      excludeEnd: true,
      relevance: 0
    }],
    relevance: 0
  };

  // Find QML object. A QML object is a QML identifier followed by { and ends at the matching }.
  // All we really care about is finding IDENT followed by { and just mark up the IDENT and ignore the {.
  var QML_OBJECT = {
    begin: concat(QML_IDENT_RE, /\s*\{/),
    end: /\{/,
    returnBegin: true,
    relevance: 0,
    contains: [hljs.inherit(hljs.TITLE_MODE, {
      begin: QML_IDENT_RE
    })]
  };
  return {
    name: 'QML',
    aliases: ['qt'],
    case_insensitive: false,
    keywords: KEYWORDS,
    contains: [{
      className: 'meta',
      begin: /^\s*['"]use (strict|asm)['"]/
    }, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, {
      // template string
      className: 'string',
      begin: '`',
      end: '`',
      contains: [hljs.BACKSLASH_ESCAPE, {
        className: 'subst',
        begin: '\\$\\{',
        end: '\\}'
      }]
    }, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, {
      className: 'number',
      variants: [{
        begin: '\\b(0[bB][01]+)'
      }, {
        begin: '\\b(0[oO][0-7]+)'
      }, {
        begin: hljs.C_NUMBER_RE
      }],
      relevance: 0
    }, {
      // "value" container
      begin: '(' + hljs.RE_STARTERS_RE + '|\\b(case|return|throw)\\b)\\s*',
      keywords: 'return throw case',
      contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.REGEXP_MODE, {
        // E4X / JSX
        begin: /</,
        end: />\s*[);\]]/,
        relevance: 0,
        subLanguage: 'xml'
      }],
      relevance: 0
    }, SIGNAL, PROPERTY, {
      className: 'function',
      beginKeywords: 'function',
      end: /\{/,
      excludeEnd: true,
      contains: [hljs.inherit(hljs.TITLE_MODE, {
        begin: /[A-Za-z$_][0-9A-Za-z$_]*/
      }), {
        className: 'params',
        begin: /\(/,
        end: /\)/,
        excludeBegin: true,
        excludeEnd: true,
        contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE]
      }],
      illegal: /\[|%/
    }, {
      // hack: prevents detection of keywords after dots
      begin: '\\.' + hljs.IDENT_RE,
      relevance: 0
    }, ID_ID, QML_ATTRIBUTE, QML_OBJECT],
    illegal: /#/
  };
}
module.exports = qml;

/***/ }),

/***/ 84389:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(19601);
__webpack_require__(54747);
__webpack_require__(47941);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function lookahead(re) {
  return concat('(?=', re, ')');
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/*
Language: R
Description: R is a free software environment for statistical computing and graphics.
Author: Joe Cheng <joe@rstudio.org>
Contributors: Konrad Rudolph <konrad.rudolph@gmail.com>
Website: https://www.r-project.org
Category: common,scientific
*/

/** @type LanguageFn */
function r(hljs) {
  // Identifiers in R cannot start with `_`, but they can start with `.` if it
  // is not immediately followed by a digit.
  // R also supports quoted identifiers, which are near-arbitrary sequences
  // delimited by backticks (`…`), which may contain escape sequences. These are
  // handled in a separate mode. See `test/markup/r/names.txt` for examples.
  // FIXME: Support Unicode identifiers.
  var IDENT_RE = /(?:(?:[a-zA-Z]|\.[._a-zA-Z])[._a-zA-Z0-9]*)|\.(?!\d)/;
  var SIMPLE_IDENT = /[a-zA-Z][a-zA-Z_0-9]*/;
  return {
    name: 'R',
    // only in Haskell, not R
    illegal: /->/,
    keywords: {
      $pattern: IDENT_RE,
      keyword: 'function if in break next repeat else for while',
      literal: 'NULL NA TRUE FALSE Inf NaN NA_integer_|10 NA_real_|10 ' + 'NA_character_|10 NA_complex_|10',
      built_in:
      // Builtin constants
      'LETTERS letters month.abb month.name pi T F ' +
      // Primitive functions
      // These are all the functions in `base` that are implemented as a
      // `.Primitive`, minus those functions that are also keywords.
      'abs acos acosh all any anyNA Arg as.call as.character ' + 'as.complex as.double as.environment as.integer as.logical ' + 'as.null.default as.numeric as.raw asin asinh atan atanh attr ' + 'attributes baseenv browser c call ceiling class Conj cos cosh ' + 'cospi cummax cummin cumprod cumsum digamma dim dimnames ' + 'emptyenv exp expression floor forceAndCall gamma gc.time ' + 'globalenv Im interactive invisible is.array is.atomic is.call ' + 'is.character is.complex is.double is.environment is.expression ' + 'is.finite is.function is.infinite is.integer is.language ' + 'is.list is.logical is.matrix is.na is.name is.nan is.null ' + 'is.numeric is.object is.pairlist is.raw is.recursive is.single ' + 'is.symbol lazyLoadDBfetch length lgamma list log max min ' + 'missing Mod names nargs nzchar oldClass on.exit pos.to.env ' + 'proc.time prod quote range Re rep retracemem return round ' + 'seq_along seq_len seq.int sign signif sin sinh sinpi sqrt ' + 'standardGeneric substitute sum switch tan tanh tanpi tracemem ' + 'trigamma trunc unclass untracemem UseMethod xtfrm'
    },
    compilerExtensions: [
    // allow beforeMatch to act as a "qualifier" for the match
    // the full match begin must be [beforeMatch][begin]
    function (mode, parent) {
      if (!mode.beforeMatch) return;
      // starts conflicts with endsParent which we need to make sure the child
      // rule is not matched multiple times
      if (mode.starts) throw new Error("beforeMatch cannot be used with starts");
      var originalMode = Object.assign({}, mode);
      Object.keys(mode).forEach(function (key) {
        delete mode[key];
      });
      mode.begin = concat(originalMode.beforeMatch, lookahead(originalMode.begin));
      mode.starts = {
        relevance: 0,
        contains: [Object.assign(originalMode, {
          endsParent: true
        })]
      };
      mode.relevance = 0;
      delete originalMode.beforeMatch;
    }],
    contains: [
    // Roxygen comments
    hljs.COMMENT(/#'/, /$/, {
      contains: [{
        // Handle `@examples` separately to cause all subsequent code
        // until the next `@`-tag on its own line to be kept as-is,
        // preventing highlighting. This code is example R code, so nested
        // doctags shouldn’t be treated as such. See
        // `test/markup/r/roxygen.txt` for an example.
        className: 'doctag',
        begin: '@examples',
        starts: {
          contains: [{
            begin: /\n/
          }, {
            begin: /#'\s*(?=@[a-zA-Z]+)/,
            endsParent: true
          }, {
            begin: /#'/,
            end: /$/,
            excludeBegin: true
          }]
        }
      }, {
        // Handle `@param` to highlight the parameter name following
        // after.
        className: 'doctag',
        begin: '@param',
        end: /$/,
        contains: [{
          className: 'variable',
          variants: [{
            begin: IDENT_RE
          }, {
            begin: /`(?:\\.|[^`\\])+`/
          }],
          endsParent: true
        }]
      }, {
        className: 'doctag',
        begin: /@[a-zA-Z]+/
      }, {
        className: 'meta-keyword',
        begin: /\\[a-zA-Z]+/
      }]
    }), hljs.HASH_COMMENT_MODE, {
      className: 'string',
      contains: [hljs.BACKSLASH_ESCAPE],
      variants: [hljs.END_SAME_AS_BEGIN({
        begin: /[rR]"(-*)\(/,
        end: /\)(-*)"/
      }), hljs.END_SAME_AS_BEGIN({
        begin: /[rR]"(-*)\{/,
        end: /\}(-*)"/
      }), hljs.END_SAME_AS_BEGIN({
        begin: /[rR]"(-*)\[/,
        end: /\](-*)"/
      }), hljs.END_SAME_AS_BEGIN({
        begin: /[rR]'(-*)\(/,
        end: /\)(-*)'/
      }), hljs.END_SAME_AS_BEGIN({
        begin: /[rR]'(-*)\{/,
        end: /\}(-*)'/
      }), hljs.END_SAME_AS_BEGIN({
        begin: /[rR]'(-*)\[/,
        end: /\](-*)'/
      }), {
        begin: '"',
        end: '"',
        relevance: 0
      }, {
        begin: "'",
        end: "'",
        relevance: 0
      }]
    }, {
      className: 'number',
      relevance: 0,
      beforeMatch: /([^a-zA-Z0-9._])/,
      // not part of an identifier
      variants: [
      // TODO: replace with negative look-behind when available
      // { begin: /(?<![a-zA-Z0-9._])0[xX][0-9a-fA-F]+\.[0-9a-fA-F]*[pP][+-]?\d+i?/ },
      // { begin: /(?<![a-zA-Z0-9._])0[xX][0-9a-fA-F]+([pP][+-]?\d+)?[Li]?/ },
      // { begin: /(?<![a-zA-Z0-9._])(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?[Li]?/ }
      {
        // Special case: only hexadecimal binary powers can contain fractions.
        match: /0[xX][0-9a-fA-F]+\.[0-9a-fA-F]*[pP][+-]?\d+i?/
      }, {
        match: /0[xX][0-9a-fA-F]+([pP][+-]?\d+)?[Li]?/
      }, {
        match: /(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?[Li]?/
      }]
    }, {
      // infix operator
      begin: '%',
      end: '%'
    },
    // relevance boost for assignment
    {
      begin: concat(SIMPLE_IDENT, "\\s+<-\\s+")
    }, {
      // escaped identifier
      begin: '`',
      end: '`',
      contains: [{
        begin: /\\./
      }]
    }]
  };
}
module.exports = r;

/***/ }),

/***/ 69687:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(74916);
__webpack_require__(23123);
__webpack_require__(92222);
/*
Language: ReasonML
Description: Reason lets you write simple, fast and quality type safe code while leveraging both the JavaScript & OCaml ecosystems.
Website: https://reasonml.github.io
Author: Gidi Meir Morris <oss@gidi.io>
Category: functional
*/
function reasonml(hljs) {
  function orReValues(ops) {
    return ops.map(function (op) {
      return op.split('').map(function (char) {
        return '\\' + char;
      }).join('');
    }).join('|');
  }
  var RE_IDENT = '~?[a-z$_][0-9a-zA-Z$_]*';
  var RE_MODULE_IDENT = '`?[A-Z$_][0-9a-zA-Z$_]*';
  var RE_PARAM_TYPEPARAM = '\'?[a-z$_][0-9a-z$_]*';
  var RE_PARAM_TYPE = '\\s*:\\s*[a-z$_][0-9a-z$_]*(\\(\\s*(' + RE_PARAM_TYPEPARAM + '\\s*(,' + RE_PARAM_TYPEPARAM + '\\s*)*)?\\))?';
  var RE_PARAM = RE_IDENT + '(' + RE_PARAM_TYPE + '){0,2}';
  var RE_OPERATOR = "(" + orReValues(['||', '++', '**', '+.', '*', '/', '*.', '/.', '...']) + "|\\|>|&&|==|===)";
  var RE_OPERATOR_SPACED = "\\s+" + RE_OPERATOR + "\\s+";
  var KEYWORDS = {
    keyword: 'and as asr assert begin class constraint do done downto else end exception external ' + 'for fun function functor if in include inherit initializer ' + 'land lazy let lor lsl lsr lxor match method mod module mutable new nonrec ' + 'object of open or private rec sig struct then to try type val virtual when while with',
    built_in: 'array bool bytes char exn|5 float int int32 int64 list lazy_t|5 nativeint|5 ref string unit ',
    literal: 'true false'
  };
  var RE_NUMBER = '\\b(0[xX][a-fA-F0-9_]+[Lln]?|' + '0[oO][0-7_]+[Lln]?|' + '0[bB][01_]+[Lln]?|' + '[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)';
  var NUMBER_MODE = {
    className: 'number',
    relevance: 0,
    variants: [{
      begin: RE_NUMBER
    }, {
      begin: '\\(-' + RE_NUMBER + '\\)'
    }]
  };
  var OPERATOR_MODE = {
    className: 'operator',
    relevance: 0,
    begin: RE_OPERATOR
  };
  var LIST_CONTENTS_MODES = [{
    className: 'identifier',
    relevance: 0,
    begin: RE_IDENT
  }, OPERATOR_MODE, NUMBER_MODE];
  var MODULE_ACCESS_CONTENTS = [hljs.QUOTE_STRING_MODE, OPERATOR_MODE, {
    className: 'module',
    begin: "\\b" + RE_MODULE_IDENT,
    returnBegin: true,
    end: "\.",
    contains: [{
      className: 'identifier',
      begin: RE_MODULE_IDENT,
      relevance: 0
    }]
  }];
  var PARAMS_CONTENTS = [{
    className: 'module',
    begin: "\\b" + RE_MODULE_IDENT,
    returnBegin: true,
    end: "\.",
    relevance: 0,
    contains: [{
      className: 'identifier',
      begin: RE_MODULE_IDENT,
      relevance: 0
    }]
  }];
  var PARAMS_MODE = {
    begin: RE_IDENT,
    end: '(,|\\n|\\))',
    relevance: 0,
    contains: [OPERATOR_MODE, {
      className: 'typing',
      begin: ':',
      end: '(,|\\n)',
      returnBegin: true,
      relevance: 0,
      contains: PARAMS_CONTENTS
    }]
  };
  var FUNCTION_BLOCK_MODE = {
    className: 'function',
    relevance: 0,
    keywords: KEYWORDS,
    variants: [{
      begin: '\\s(\\(\\.?.*?\\)|' + RE_IDENT + ')\\s*=>',
      end: '\\s*=>',
      returnBegin: true,
      relevance: 0,
      contains: [{
        className: 'params',
        variants: [{
          begin: RE_IDENT
        }, {
          begin: RE_PARAM
        }, {
          begin: /\(\s*\)/
        }]
      }]
    }, {
      begin: '\\s\\(\\.?[^;\\|]*\\)\\s*=>',
      end: '\\s=>',
      returnBegin: true,
      relevance: 0,
      contains: [{
        className: 'params',
        relevance: 0,
        variants: [PARAMS_MODE]
      }]
    }, {
      begin: '\\(\\.\\s' + RE_IDENT + '\\)\\s*=>'
    }]
  };
  MODULE_ACCESS_CONTENTS.push(FUNCTION_BLOCK_MODE);
  var CONSTRUCTOR_MODE = {
    className: 'constructor',
    begin: RE_MODULE_IDENT + '\\(',
    end: '\\)',
    illegal: '\\n',
    keywords: KEYWORDS,
    contains: [hljs.QUOTE_STRING_MODE, OPERATOR_MODE, {
      className: 'params',
      begin: '\\b' + RE_IDENT
    }]
  };
  var PATTERN_MATCH_BLOCK_MODE = {
    className: 'pattern-match',
    begin: '\\|',
    returnBegin: true,
    keywords: KEYWORDS,
    end: '=>',
    relevance: 0,
    contains: [CONSTRUCTOR_MODE, OPERATOR_MODE, {
      relevance: 0,
      className: 'constructor',
      begin: RE_MODULE_IDENT
    }]
  };
  var MODULE_ACCESS_MODE = {
    className: 'module-access',
    keywords: KEYWORDS,
    returnBegin: true,
    variants: [{
      begin: "\\b(" + RE_MODULE_IDENT + "\\.)+" + RE_IDENT
    }, {
      begin: "\\b(" + RE_MODULE_IDENT + "\\.)+\\(",
      end: "\\)",
      returnBegin: true,
      contains: [FUNCTION_BLOCK_MODE, {
        begin: '\\(',
        end: '\\)',
        skip: true
      }].concat(MODULE_ACCESS_CONTENTS)
    }, {
      begin: "\\b(" + RE_MODULE_IDENT + "\\.)+\\{",
      end: /\}/
    }],
    contains: MODULE_ACCESS_CONTENTS
  };
  PARAMS_CONTENTS.push(MODULE_ACCESS_MODE);
  return {
    name: 'ReasonML',
    aliases: ['re'],
    keywords: KEYWORDS,
    illegal: '(:-|:=|\\$\\{|\\+=)',
    contains: [hljs.COMMENT('/\\*', '\\*/', {
      illegal: '^(#,\\/\\/)'
    }), {
      className: 'character',
      begin: '\'(\\\\[^\']+|[^\'])\'',
      illegal: '\\n',
      relevance: 0
    }, hljs.QUOTE_STRING_MODE, {
      className: 'literal',
      begin: '\\(\\)',
      relevance: 0
    }, {
      className: 'literal',
      begin: '\\[\\|',
      end: '\\|\\]',
      relevance: 0,
      contains: LIST_CONTENTS_MODES
    }, {
      className: 'literal',
      begin: '\\[',
      end: '\\]',
      relevance: 0,
      contains: LIST_CONTENTS_MODES
    }, CONSTRUCTOR_MODE, {
      className: 'operator',
      begin: RE_OPERATOR_SPACED,
      illegal: '-->',
      relevance: 0
    }, NUMBER_MODE, hljs.C_LINE_COMMENT_MODE, PATTERN_MATCH_BLOCK_MODE, FUNCTION_BLOCK_MODE, {
      className: 'module-def',
      begin: "\\bmodule\\s+" + RE_IDENT + "\\s+" + RE_MODULE_IDENT + "\\s+=\\s+\\{",
      end: /\}/,
      returnBegin: true,
      keywords: KEYWORDS,
      relevance: 0,
      contains: [{
        className: 'module',
        relevance: 0,
        begin: RE_MODULE_IDENT
      }, {
        begin: /\{/,
        end: /\}/,
        skip: true
      }].concat(MODULE_ACCESS_CONTENTS)
    }, MODULE_ACCESS_MODE]
  };
}
module.exports = reasonml;

/***/ }),

/***/ 16044:
/***/ ((module) => {

/*
Language: RenderMan RIB
Author: Konstantin Evdokimenko <qewerty@gmail.com>
Contributors: Shuen-Huei Guan <drake.guan@gmail.com>
Website: https://renderman.pixar.com/resources/RenderMan_20/ribBinding.html
Category: graphics
*/

function rib(hljs) {
  return {
    name: 'RenderMan RIB',
    keywords: 'ArchiveRecord AreaLightSource Atmosphere Attribute AttributeBegin AttributeEnd Basis ' + 'Begin Blobby Bound Clipping ClippingPlane Color ColorSamples ConcatTransform Cone ' + 'CoordinateSystem CoordSysTransform CropWindow Curves Cylinder DepthOfField Detail ' + 'DetailRange Disk Displacement Display End ErrorHandler Exposure Exterior Format ' + 'FrameAspectRatio FrameBegin FrameEnd GeneralPolygon GeometricApproximation Geometry ' + 'Hider Hyperboloid Identity Illuminate Imager Interior LightSource ' + 'MakeCubeFaceEnvironment MakeLatLongEnvironment MakeShadow MakeTexture Matte ' + 'MotionBegin MotionEnd NuPatch ObjectBegin ObjectEnd ObjectInstance Opacity Option ' + 'Orientation Paraboloid Patch PatchMesh Perspective PixelFilter PixelSamples ' + 'PixelVariance Points PointsGeneralPolygons PointsPolygons Polygon Procedural Projection ' + 'Quantize ReadArchive RelativeDetail ReverseOrientation Rotate Scale ScreenWindow ' + 'ShadingInterpolation ShadingRate Shutter Sides Skew SolidBegin SolidEnd Sphere ' + 'SubdivisionMesh Surface TextureCoordinates Torus Transform TransformBegin TransformEnd ' + 'TransformPoints Translate TrimCurve WorldBegin WorldEnd',
    illegal: '</',
    contains: [hljs.HASH_COMMENT_MODE, hljs.C_NUMBER_MODE, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE]
  };
}
module.exports = rib;

/***/ }),

/***/ 26550:
/***/ ((module) => {

/*
Language: Roboconf
Author: Vincent Zurczak <vzurczak@linagora.com>
Description: Syntax highlighting for Roboconf's DSL
Website: http://roboconf.net
Category: config
*/

function roboconf(hljs) {
  var IDENTIFIER = '[a-zA-Z-_][^\\n{]+\\{';
  var PROPERTY = {
    className: 'attribute',
    begin: /[a-zA-Z-_]+/,
    end: /\s*:/,
    excludeEnd: true,
    starts: {
      end: ';',
      relevance: 0,
      contains: [{
        className: 'variable',
        begin: /\.[a-zA-Z-_]+/
      }, {
        className: 'keyword',
        begin: /\(optional\)/
      }]
    }
  };
  return {
    name: 'Roboconf',
    aliases: ['graph', 'instances'],
    case_insensitive: true,
    keywords: 'import',
    contains: [
    // Facet sections
    {
      begin: '^facet ' + IDENTIFIER,
      end: /\}/,
      keywords: 'facet',
      contains: [PROPERTY, hljs.HASH_COMMENT_MODE]
    },
    // Instance sections
    {
      begin: '^\\s*instance of ' + IDENTIFIER,
      end: /\}/,
      keywords: 'name count channels instance-data instance-state instance of',
      illegal: /\S/,
      contains: ['self', PROPERTY, hljs.HASH_COMMENT_MODE]
    },
    // Component sections
    {
      begin: '^' + IDENTIFIER,
      end: /\}/,
      contains: [PROPERTY, hljs.HASH_COMMENT_MODE]
    },
    // Comments
    hljs.HASH_COMMENT_MODE]
  };
}
module.exports = roboconf;

/***/ }),

/***/ 43312:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(74916);
__webpack_require__(23123);
/*
Language: Microtik RouterOS script
Author: Ivan Dementev <ivan_div@mail.ru>
Description: Scripting host provides a way to automate some router maintenance tasks by means of executing user-defined scripts bounded to some event occurrence
Website: https://wiki.mikrotik.com/wiki/Manual:Scripting
*/

// Colors from RouterOS terminal:
//   green        - #0E9A00
//   teal         - #0C9A9A
//   purple       - #99069A
//   light-brown  - #9A9900

function routeros(hljs) {
  var STATEMENTS = 'foreach do while for if from to step else on-error and or not in';

  // Global commands: Every global command should start with ":" token, otherwise it will be treated as variable.
  var GLOBAL_COMMANDS = 'global local beep delay put len typeof pick log time set find environment terminal error execute parse resolve toarray tobool toid toip toip6 tonum tostr totime';

  // Common commands: Following commands available from most sub-menus:
  var COMMON_COMMANDS = 'add remove enable disable set get print export edit find run debug error info warning';
  var LITERALS = 'true false yes no nothing nil null';
  var OBJECTS = 'traffic-flow traffic-generator firewall scheduler aaa accounting address-list address align area bandwidth-server bfd bgp bridge client clock community config connection console customer default dhcp-client dhcp-server discovery dns e-mail ethernet filter firmware gps graphing group hardware health hotspot identity igmp-proxy incoming instance interface ip ipsec ipv6 irq l2tp-server lcd ldp logging mac-server mac-winbox mangle manual mirror mme mpls nat nd neighbor network note ntp ospf ospf-v3 ovpn-server page peer pim ping policy pool port ppp pppoe-client pptp-server prefix profile proposal proxy queue radius resource rip ripng route routing screen script security-profiles server service service-port settings shares smb sms sniffer snmp snooper socks sstp-server system tool tracking type upgrade upnp user-manager users user vlan secret vrrp watchdog web-access wireless pptp pppoe lan wan layer7-protocol lease simple raw';
  var VAR = {
    className: 'variable',
    variants: [{
      begin: /\$[\w\d#@][\w\d_]*/
    }, {
      begin: /\$\{(.*?)\}/
    }]
  };
  var QUOTE_STRING = {
    className: 'string',
    begin: /"/,
    end: /"/,
    contains: [hljs.BACKSLASH_ESCAPE, VAR, {
      className: 'variable',
      begin: /\$\(/,
      end: /\)/,
      contains: [hljs.BACKSLASH_ESCAPE]
    }]
  };
  var APOS_STRING = {
    className: 'string',
    begin: /'/,
    end: /'/
  };
  return {
    name: 'Microtik RouterOS script',
    aliases: ['mikrotik'],
    case_insensitive: true,
    keywords: {
      $pattern: /:?[\w-]+/,
      literal: LITERALS,
      keyword: STATEMENTS + ' :' + STATEMENTS.split(' ').join(' :') + ' :' + GLOBAL_COMMANDS.split(' ').join(' :')
    },
    contains: [{
      // illegal syntax
      variants: [{
        // -- comment
        begin: /\/\*/,
        end: /\*\//
      }, {
        // Stan comment
        begin: /\/\//,
        end: /$/
      }, {
        // HTML tags
        begin: /<\//,
        end: />/
      }],
      illegal: /./
    }, hljs.COMMENT('^#', '$'), QUOTE_STRING, APOS_STRING, VAR,
    // attribute=value
    {
      // > is to avoid matches with => in other grammars
      begin: /[\w-]+=([^\s{}[\]()>]+)/,
      relevance: 0,
      returnBegin: true,
      contains: [{
        className: 'attribute',
        begin: /[^=]+/
      }, {
        begin: /=/,
        endsWithParent: true,
        relevance: 0,
        contains: [QUOTE_STRING, APOS_STRING, VAR, {
          className: 'literal',
          begin: '\\b(' + LITERALS.split(' ').join('|') + ')\\b'
        }, {
          // Do not format unclassified values. Needed to exclude highlighting of values as built_in.
          begin: /("[^"]*"|[^\s{}[\]]+)/
        }
        /*
        {
          // IPv4 addresses and subnets
          className: 'number',
          variants: [
            {begin: IPADDR_wBITMASK+'(,'+IPADDR_wBITMASK+')*'}, //192.168.0.0/24,1.2.3.0/24
            {begin: IPADDR+'-'+IPADDR},       // 192.168.0.1-192.168.0.3
            {begin: IPADDR+'(,'+IPADDR+')*'}, // 192.168.0.1,192.168.0.34,192.168.24.1,192.168.0.1
          ]
        },
        {
          // MAC addresses and DHCP Client IDs
          className: 'number',
          begin: /\b(1:)?([0-9A-Fa-f]{1,2}[:-]){5}([0-9A-Fa-f]){1,2}\b/,
        },
        */]
      }]
    }, {
      // HEX values
      className: 'number',
      begin: /\*[0-9a-fA-F]+/
    }, {
      begin: '\\b(' + COMMON_COMMANDS.split(' ').join('|') + ')([\\s[(\\]|])',
      returnBegin: true,
      contains: [{
        className: 'builtin-name',
        // 'function',
        begin: /\w+/
      }]
    }, {
      className: 'built_in',
      variants: [{
        begin: '(\\.\\./|/|\\s)((' + OBJECTS.split(' ').join('|') + ');?\\s)+'
      }, {
        begin: /\.\./,
        relevance: 0
      }]
    }]
  };
}
module.exports = routeros;

/***/ }),

/***/ 97848:
/***/ ((module) => {

/*
Language: RenderMan RSL
Author: Konstantin Evdokimenko <qewerty@gmail.com>
Contributors: Shuen-Huei Guan <drake.guan@gmail.com>
Website: https://renderman.pixar.com/resources/RenderMan_20/shadingLanguage.html
Category: graphics
*/

function rsl(hljs) {
  return {
    name: 'RenderMan RSL',
    keywords: {
      keyword: 'float color point normal vector matrix while for if do return else break extern continue',
      built_in: 'abs acos ambient area asin atan atmosphere attribute calculatenormal ceil cellnoise ' + 'clamp comp concat cos degrees depth Deriv diffuse distance Du Dv environment exp ' + 'faceforward filterstep floor format fresnel incident length lightsource log match ' + 'max min mod noise normalize ntransform opposite option phong pnoise pow printf ' + 'ptlined radians random reflect refract renderinfo round setcomp setxcomp setycomp ' + 'setzcomp shadow sign sin smoothstep specular specularbrdf spline sqrt step tan ' + 'texture textureinfo trace transform vtransform xcomp ycomp zcomp'
    },
    illegal: '</',
    contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.QUOTE_STRING_MODE, hljs.APOS_STRING_MODE, hljs.C_NUMBER_MODE, {
      className: 'meta',
      begin: '#',
      end: '$'
    }, {
      className: 'class',
      beginKeywords: 'surface displacement light volume imager',
      end: '\\('
    }, {
      beginKeywords: 'illuminate illuminance gather',
      end: '\\('
    }]
  };
}
module.exports = rsl;

/***/ }),

/***/ 54458:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(92222);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function lookahead(re) {
  return concat('(?=', re, ')');
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/*
Language: Ruby
Description: Ruby is a dynamic, open source programming language with a focus on simplicity and productivity.
Website: https://www.ruby-lang.org/
Author: Anton Kovalyov <anton@kovalyov.net>
Contributors: Peter Leonov <gojpeg@yandex.ru>, Vasily Polovnyov <vast@whiteants.net>, Loren Segal <lsegal@soen.ca>, Pascal Hurni <phi@ruby-reactive.org>, Cedric Sohrauer <sohrauer@googlemail.com>
Category: common
*/

function ruby(hljs) {
  var RUBY_METHOD_RE = '([a-zA-Z_]\\w*[!?=]?|[-+~]@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?)';
  var RUBY_KEYWORDS = {
    keyword: 'and then defined module in return redo if BEGIN retry end for self when ' + 'next until do begin unless END rescue else break undef not super class case ' + 'require yield alias while ensure elsif or include attr_reader attr_writer attr_accessor ' + '__FILE__',
    built_in: 'proc lambda',
    literal: 'true false nil'
  };
  var YARDOCTAG = {
    className: 'doctag',
    begin: '@[A-Za-z]+'
  };
  var IRB_OBJECT = {
    begin: '#<',
    end: '>'
  };
  var COMMENT_MODES = [hljs.COMMENT('#', '$', {
    contains: [YARDOCTAG]
  }), hljs.COMMENT('^=begin', '^=end', {
    contains: [YARDOCTAG],
    relevance: 10
  }), hljs.COMMENT('^__END__', '\\n$')];
  var SUBST = {
    className: 'subst',
    begin: /#\{/,
    end: /\}/,
    keywords: RUBY_KEYWORDS
  };
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, SUBST],
    variants: [{
      begin: /'/,
      end: /'/
    }, {
      begin: /"/,
      end: /"/
    }, {
      begin: /`/,
      end: /`/
    }, {
      begin: /%[qQwWx]?\(/,
      end: /\)/
    }, {
      begin: /%[qQwWx]?\[/,
      end: /\]/
    }, {
      begin: /%[qQwWx]?\{/,
      end: /\}/
    }, {
      begin: /%[qQwWx]?</,
      end: />/
    }, {
      begin: /%[qQwWx]?\//,
      end: /\//
    }, {
      begin: /%[qQwWx]?%/,
      end: /%/
    }, {
      begin: /%[qQwWx]?-/,
      end: /-/
    }, {
      begin: /%[qQwWx]?\|/,
      end: /\|/
    },
    // in the following expressions, \B in the beginning suppresses recognition of ?-sequences
    // where ? is the last character of a preceding identifier, as in: `func?4`
    {
      begin: /\B\?(\\\d{1,3})/
    }, {
      begin: /\B\?(\\x[A-Fa-f0-9]{1,2})/
    }, {
      begin: /\B\?(\\u\{?[A-Fa-f0-9]{1,6}\}?)/
    }, {
      begin: /\B\?(\\M-\\C-|\\M-\\c|\\c\\M-|\\M-|\\C-\\M-)[\x20-\x7e]/
    }, {
      begin: /\B\?\\(c|C-)[\x20-\x7e]/
    }, {
      begin: /\B\?\\?\S/
    }, {
      // heredocs
      begin: /<<[-~]?'?(\w+)\n(?:[^\n]*\n)*?\s*\1\b/,
      returnBegin: true,
      contains: [{
        begin: /<<[-~]?'?/
      }, hljs.END_SAME_AS_BEGIN({
        begin: /(\w+)/,
        end: /(\w+)/,
        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
      })]
    }]
  };

  // Ruby syntax is underdocumented, but this grammar seems to be accurate
  // as of version 2.7.2 (confirmed with (irb and `Ripper.sexp(...)`)
  // https://docs.ruby-lang.org/en/2.7.0/doc/syntax/literals_rdoc.html#label-Numbers
  var decimal = '[1-9](_?[0-9])*|0';
  var digits = '[0-9](_?[0-9])*';
  var NUMBER = {
    className: 'number',
    relevance: 0,
    variants: [
    // decimal integer/float, optionally exponential or rational, optionally imaginary
    {
      begin: "\\b(".concat(decimal, ")(\\.(").concat(digits, "))?([eE][+-]?(").concat(digits, ")|r)?i?\\b")
    },
    // explicit decimal/binary/octal/hexadecimal integer,
    // optionally rational and/or imaginary
    {
      begin: "\\b0[dD][0-9](_?[0-9])*r?i?\\b"
    }, {
      begin: "\\b0[bB][0-1](_?[0-1])*r?i?\\b"
    }, {
      begin: "\\b0[oO][0-7](_?[0-7])*r?i?\\b"
    }, {
      begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*r?i?\\b"
    },
    // 0-prefixed implicit octal integer, optionally rational and/or imaginary
    {
      begin: "\\b0(_?[0-7])+r?i?\\b"
    }]
  };
  var PARAMS = {
    className: 'params',
    begin: '\\(',
    end: '\\)',
    endsParent: true,
    keywords: RUBY_KEYWORDS
  };
  var RUBY_DEFAULT_CONTAINS = [STRING, {
    className: 'class',
    beginKeywords: 'class module',
    end: '$|;',
    illegal: /=/,
    contains: [hljs.inherit(hljs.TITLE_MODE, {
      begin: '[A-Za-z_]\\w*(::\\w+)*(\\?|!)?'
    }), {
      begin: '<\\s*',
      contains: [{
        begin: '(' + hljs.IDENT_RE + '::)?' + hljs.IDENT_RE,
        // we already get points for <, we don't need poitns
        // for the name also
        relevance: 0
      }]
    }].concat(COMMENT_MODES)
  }, {
    className: 'function',
    // def method_name(
    // def method_name;
    // def method_name (end of line)
    begin: concat(/def\s+/, lookahead(RUBY_METHOD_RE + "\\s*(\\(|;|$)")),
    relevance: 0,
    // relevance comes from kewords
    keywords: "def",
    end: '$|;',
    contains: [hljs.inherit(hljs.TITLE_MODE, {
      begin: RUBY_METHOD_RE
    }), PARAMS].concat(COMMENT_MODES)
  }, {
    // swallow namespace qualifiers before symbols
    begin: hljs.IDENT_RE + '::'
  }, {
    className: 'symbol',
    begin: hljs.UNDERSCORE_IDENT_RE + '(!|\\?)?:',
    relevance: 0
  }, {
    className: 'symbol',
    begin: ':(?!\\s)',
    contains: [STRING, {
      begin: RUBY_METHOD_RE
    }],
    relevance: 0
  }, NUMBER, {
    // negative-look forward attemps to prevent false matches like:
    // @ident@ or $ident$ that might indicate this is not ruby at all
    className: "variable",
    begin: '(\\$\\W)|((\\$|@@?)(\\w+))(?=[^@$?])' + "(?![A-Za-z])(?![@$?'])"
  }, {
    className: 'params',
    begin: /\|/,
    end: /\|/,
    relevance: 0,
    // this could be a lot of things (in other languages) other than params
    keywords: RUBY_KEYWORDS
  }, {
    // regexp container
    begin: '(' + hljs.RE_STARTERS_RE + '|unless)\\s*',
    keywords: 'unless',
    contains: [{
      className: 'regexp',
      contains: [hljs.BACKSLASH_ESCAPE, SUBST],
      illegal: /\n/,
      variants: [{
        begin: '/',
        end: '/[a-z]*'
      }, {
        begin: /%r\{/,
        end: /\}[a-z]*/
      }, {
        begin: '%r\\(',
        end: '\\)[a-z]*'
      }, {
        begin: '%r!',
        end: '![a-z]*'
      }, {
        begin: '%r\\[',
        end: '\\][a-z]*'
      }]
    }].concat(IRB_OBJECT, COMMENT_MODES),
    relevance: 0
  }].concat(IRB_OBJECT, COMMENT_MODES);
  SUBST.contains = RUBY_DEFAULT_CONTAINS;
  PARAMS.contains = RUBY_DEFAULT_CONTAINS;

  // >>
  // ?>
  var SIMPLE_PROMPT = "[>?]>";
  // irb(main):001:0>
  var DEFAULT_PROMPT = "[\\w#]+\\(\\w+\\):\\d+:\\d+>";
  var RVM_PROMPT = "(\\w+-)?\\d+\\.\\d+\\.\\d+(p\\d+)?[^\\d][^>]+>";
  var IRB_DEFAULT = [{
    begin: /^\s*=>/,
    starts: {
      end: '$',
      contains: RUBY_DEFAULT_CONTAINS
    }
  }, {
    className: 'meta',
    begin: '^(' + SIMPLE_PROMPT + "|" + DEFAULT_PROMPT + '|' + RVM_PROMPT + ')(?=[ ])',
    starts: {
      end: '$',
      contains: RUBY_DEFAULT_CONTAINS
    }
  }];
  COMMENT_MODES.unshift(IRB_OBJECT);
  return {
    name: 'Ruby',
    aliases: ['rb', 'gemspec', 'podspec', 'thor', 'irb'],
    keywords: RUBY_KEYWORDS,
    illegal: /\/\*/,
    contains: [hljs.SHEBANG({
      binary: "ruby"
    })].concat(IRB_DEFAULT).concat(COMMENT_MODES).concat(RUBY_DEFAULT_CONTAINS)
  };
}
module.exports = ruby;

/***/ }),

/***/ 95264:
/***/ ((module) => {

/*
Language: Oracle Rules Language
Author: Jason Jacobson <jason.a.jacobson@gmail.com>
Description: The Oracle Utilities Rules Language is used to program the Oracle Utilities Applications acquired from LODESTAR Corporation.  The products include Billing Component, LPSS, Pricing Component etc. through version 1.6.1.
Website: https://docs.oracle.com/cd/E17904_01/dev.1111/e10227/rlref.htm
Category: enterprise
*/

function ruleslanguage(hljs) {
  return {
    name: 'Oracle Rules Language',
    keywords: {
      keyword: 'BILL_PERIOD BILL_START BILL_STOP RS_EFFECTIVE_START RS_EFFECTIVE_STOP RS_JURIS_CODE RS_OPCO_CODE ' + 'INTDADDATTRIBUTE|5 INTDADDVMSG|5 INTDBLOCKOP|5 INTDBLOCKOPNA|5 INTDCLOSE|5 INTDCOUNT|5 ' + 'INTDCOUNTSTATUSCODE|5 INTDCREATEMASK|5 INTDCREATEDAYMASK|5 INTDCREATEFACTORMASK|5 ' + 'INTDCREATEHANDLE|5 INTDCREATEOVERRIDEDAYMASK|5 INTDCREATEOVERRIDEMASK|5 ' + 'INTDCREATESTATUSCODEMASK|5 INTDCREATETOUPERIOD|5 INTDDELETE|5 INTDDIPTEST|5 INTDEXPORT|5 ' + 'INTDGETERRORCODE|5 INTDGETERRORMESSAGE|5 INTDISEQUAL|5 INTDJOIN|5 INTDLOAD|5 INTDLOADACTUALCUT|5 ' + 'INTDLOADDATES|5 INTDLOADHIST|5 INTDLOADLIST|5 INTDLOADLISTDATES|5 INTDLOADLISTENERGY|5 ' + 'INTDLOADLISTHIST|5 INTDLOADRELATEDCHANNEL|5 INTDLOADSP|5 INTDLOADSTAGING|5 INTDLOADUOM|5 ' + 'INTDLOADUOMDATES|5 INTDLOADUOMHIST|5 INTDLOADVERSION|5 INTDOPEN|5 INTDREADFIRST|5 INTDREADNEXT|5 ' + 'INTDRECCOUNT|5 INTDRELEASE|5 INTDREPLACE|5 INTDROLLAVG|5 INTDROLLPEAK|5 INTDSCALAROP|5 INTDSCALE|5 ' + 'INTDSETATTRIBUTE|5 INTDSETDSTPARTICIPANT|5 INTDSETSTRING|5 INTDSETVALUE|5 INTDSETVALUESTATUS|5 ' + 'INTDSHIFTSTARTTIME|5 INTDSMOOTH|5 INTDSORT|5 INTDSPIKETEST|5 INTDSUBSET|5 INTDTOU|5 ' + 'INTDTOURELEASE|5 INTDTOUVALUE|5 INTDUPDATESTATS|5 INTDVALUE|5 STDEV INTDDELETEEX|5 ' + 'INTDLOADEXACTUAL|5 INTDLOADEXCUT|5 INTDLOADEXDATES|5 INTDLOADEX|5 INTDLOADEXRELATEDCHANNEL|5 ' + 'INTDSAVEEX|5 MVLOAD|5 MVLOADACCT|5 MVLOADACCTDATES|5 MVLOADACCTHIST|5 MVLOADDATES|5 MVLOADHIST|5 ' + 'MVLOADLIST|5 MVLOADLISTDATES|5 MVLOADLISTHIST|5 IF FOR NEXT DONE SELECT END CALL ABORT CLEAR CHANNEL FACTOR LIST NUMBER ' + 'OVERRIDE SET WEEK DISTRIBUTIONNODE ELSE WHEN THEN OTHERWISE IENUM CSV INCLUDE LEAVE RIDER SAVE DELETE ' + 'NOVALUE SECTION WARN SAVE_UPDATE DETERMINANT LABEL REPORT REVENUE EACH ' + 'IN FROM TOTAL CHARGE BLOCK AND OR CSV_FILE RATE_CODE AUXILIARY_DEMAND ' + 'UIDACCOUNT RS BILL_PERIOD_SELECT HOURS_PER_MONTH INTD_ERROR_STOP SEASON_SCHEDULE_NAME ' + 'ACCOUNTFACTOR ARRAYUPPERBOUND CALLSTOREDPROC GETADOCONNECTION GETCONNECT GETDATASOURCE ' + 'GETQUALIFIER GETUSERID HASVALUE LISTCOUNT LISTOP LISTUPDATE LISTVALUE PRORATEFACTOR RSPRORATE ' + 'SETBINPATH SETDBMONITOR WQ_OPEN BILLINGHOURS DATE DATEFROMFLOAT DATETIMEFROMSTRING ' + 'DATETIMETOSTRING DATETOFLOAT DAY DAYDIFF DAYNAME DBDATETIME HOUR MINUTE MONTH MONTHDIFF ' + 'MONTHHOURS MONTHNAME ROUNDDATE SAMEWEEKDAYLASTYEAR SECOND WEEKDAY WEEKDIFF YEAR YEARDAY ' + 'YEARSTR COMPSUM HISTCOUNT HISTMAX HISTMIN HISTMINNZ HISTVALUE MAXNRANGE MAXRANGE MINRANGE ' + 'COMPIKVA COMPKVA COMPKVARFROMKQKW COMPLF IDATTR FLAG LF2KW LF2KWH MAXKW POWERFACTOR ' + 'READING2USAGE AVGSEASON MAXSEASON MONTHLYMERGE SEASONVALUE SUMSEASON ACCTREADDATES ' + 'ACCTTABLELOAD CONFIGADD CONFIGGET CREATEOBJECT CREATEREPORT EMAILCLIENT EXPBLKMDMUSAGE ' + 'EXPMDMUSAGE EXPORT_USAGE FACTORINEFFECT GETUSERSPECIFIEDSTOP INEFFECT ISHOLIDAY RUNRATE ' + 'SAVE_PROFILE SETREPORTTITLE USEREXIT WATFORRUNRATE TO TABLE ACOS ASIN ATAN ATAN2 BITAND CEIL ' + 'COS COSECANT COSH COTANGENT DIVQUOT DIVREM EXP FABS FLOOR FMOD FREPM FREXPN LOG LOG10 MAX MAXN ' + 'MIN MINNZ MODF POW ROUND ROUND2VALUE ROUNDINT SECANT SIN SINH SQROOT TAN TANH FLOAT2STRING ' + 'FLOAT2STRINGNC INSTR LEFT LEN LTRIM MID RIGHT RTRIM STRING STRINGNC TOLOWER TOUPPER TRIM ' + 'NUMDAYS READ_DATE STAGING',
      built_in: 'IDENTIFIER OPTIONS XML_ELEMENT XML_OP XML_ELEMENT_OF DOMDOCCREATE DOMDOCLOADFILE DOMDOCLOADXML ' + 'DOMDOCSAVEFILE DOMDOCGETROOT DOMDOCADDPI DOMNODEGETNAME DOMNODEGETTYPE DOMNODEGETVALUE DOMNODEGETCHILDCT ' + 'DOMNODEGETFIRSTCHILD DOMNODEGETSIBLING DOMNODECREATECHILDELEMENT DOMNODESETATTRIBUTE ' + 'DOMNODEGETCHILDELEMENTCT DOMNODEGETFIRSTCHILDELEMENT DOMNODEGETSIBLINGELEMENT DOMNODEGETATTRIBUTECT ' + 'DOMNODEGETATTRIBUTEI DOMNODEGETATTRIBUTEBYNAME DOMNODEGETBYNAME'
    },
    contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, hljs.C_NUMBER_MODE, {
      className: 'literal',
      variants: [{
        // looks like #-comment
        begin: '#\\s+',
        relevance: 0
      }, {
        begin: '#[a-zA-Z .]+'
      }]
    }]
  };
}
module.exports = ruleslanguage;

/***/ }),

/***/ 78288:
/***/ ((module) => {

/*
Language: Rust
Author: Andrey Vlasovskikh <andrey.vlasovskikh@gmail.com>
Contributors: Roman Shmatov <romanshmatov@gmail.com>, Kasper Andersen <kma_untrusted@protonmail.com>
Website: https://www.rust-lang.org
Category: common, system
*/

function rust(hljs) {
  var NUM_SUFFIX = '([ui](8|16|32|64|128|size)|f(32|64))\?';
  var KEYWORDS = 'abstract as async await become box break const continue crate do dyn ' + 'else enum extern false final fn for if impl in let loop macro match mod ' + 'move mut override priv pub ref return self Self static struct super ' + 'trait true try type typeof unsafe unsized use virtual where while yield';
  var BUILTINS =
  // functions
  'drop ' +
  // types
  'i8 i16 i32 i64 i128 isize ' + 'u8 u16 u32 u64 u128 usize ' + 'f32 f64 ' + 'str char bool ' + 'Box Option Result String Vec ' +
  // traits
  'Copy Send Sized Sync Drop Fn FnMut FnOnce ToOwned Clone Debug ' + 'PartialEq PartialOrd Eq Ord AsRef AsMut Into From Default Iterator ' + 'Extend IntoIterator DoubleEndedIterator ExactSizeIterator ' + 'SliceConcatExt ToString ' +
  // macros
  'assert! assert_eq! bitflags! bytes! cfg! col! concat! concat_idents! ' + 'debug_assert! debug_assert_eq! env! panic! file! format! format_args! ' + 'include_bin! include_str! line! local_data_key! module_path! ' + 'option_env! print! println! select! stringify! try! unimplemented! ' + 'unreachable! vec! write! writeln! macro_rules! assert_ne! debug_assert_ne!';
  return {
    name: 'Rust',
    aliases: ['rs'],
    keywords: {
      $pattern: hljs.IDENT_RE + '!?',
      keyword: KEYWORDS,
      literal: 'true false Some None Ok Err',
      built_in: BUILTINS
    },
    illegal: '</',
    contains: [hljs.C_LINE_COMMENT_MODE, hljs.COMMENT('/\\*', '\\*/', {
      contains: ['self']
    }), hljs.inherit(hljs.QUOTE_STRING_MODE, {
      begin: /b?"/,
      illegal: null
    }), {
      className: 'string',
      variants: [{
        begin: /r(#*)"(.|\n)*?"\1(?!#)/
      }, {
        begin: /b?'\\?(x\w{2}|u\w{4}|U\w{8}|.)'/
      }]
    }, {
      className: 'symbol',
      begin: /'[a-zA-Z_][a-zA-Z0-9_]*/
    }, {
      className: 'number',
      variants: [{
        begin: '\\b0b([01_]+)' + NUM_SUFFIX
      }, {
        begin: '\\b0o([0-7_]+)' + NUM_SUFFIX
      }, {
        begin: '\\b0x([A-Fa-f0-9_]+)' + NUM_SUFFIX
      }, {
        begin: '\\b(\\d[\\d_]*(\\.[0-9_]+)?([eE][+-]?[0-9_]+)?)' + NUM_SUFFIX
      }],
      relevance: 0
    }, {
      className: 'function',
      beginKeywords: 'fn',
      end: '(\\(|<)',
      excludeEnd: true,
      contains: [hljs.UNDERSCORE_TITLE_MODE]
    }, {
      className: 'meta',
      begin: '#!?\\[',
      end: '\\]',
      contains: [{
        className: 'meta-string',
        begin: /"/,
        end: /"/
      }]
    }, {
      className: 'class',
      beginKeywords: 'type',
      end: ';',
      contains: [hljs.inherit(hljs.UNDERSCORE_TITLE_MODE, {
        endsParent: true
      })],
      illegal: '\\S'
    }, {
      className: 'class',
      beginKeywords: 'trait enum struct union',
      end: /\{/,
      contains: [hljs.inherit(hljs.UNDERSCORE_TITLE_MODE, {
        endsParent: true
      })],
      illegal: '[\\w\\d]'
    }, {
      begin: hljs.IDENT_RE + '::',
      keywords: {
        built_in: BUILTINS
      }
    }, {
      begin: '->'
    }]
  };
}
module.exports = rust;

/***/ }),

/***/ 83274:
/***/ ((module) => {

/*
Language: SAS
Author: Mauricio Caceres <mauricio.caceres.bravo@gmail.com>
Description: Syntax Highlighting for SAS
*/

function sas(hljs) {
  // Data step and PROC SQL statements
  var SAS_KEYWORDS = 'do if then else end until while ' + '' + 'abort array attrib by call cards cards4 catname continue ' + 'datalines datalines4 delete delim delimiter display dm drop ' + 'endsas error file filename footnote format goto in infile ' + 'informat input keep label leave length libname link list ' + 'lostcard merge missing modify options output out page put ' + 'redirect remove rename replace retain return select set skip ' + 'startsas stop title update waitsas where window x systask ' + '' + 'add and alter as cascade check create delete describe ' + 'distinct drop foreign from group having index insert into in ' + 'key like message modify msgtype not null on or order primary ' + 'references reset restrict select set table unique update ' + 'validate view where';

  // Built-in SAS functions
  var SAS_FUN = 'abs|addr|airy|arcos|arsin|atan|attrc|attrn|band|' + 'betainv|blshift|bnot|bor|brshift|bxor|byte|cdf|ceil|' + 'cexist|cinv|close|cnonct|collate|compbl|compound|' + 'compress|cos|cosh|css|curobs|cv|daccdb|daccdbsl|' + 'daccsl|daccsyd|dacctab|dairy|date|datejul|datepart|' + 'datetime|day|dclose|depdb|depdbsl|depdbsl|depsl|' + 'depsl|depsyd|depsyd|deptab|deptab|dequote|dhms|dif|' + 'digamma|dim|dinfo|dnum|dopen|doptname|doptnum|dread|' + 'dropnote|dsname|erf|erfc|exist|exp|fappend|fclose|' + 'fcol|fdelete|fetch|fetchobs|fexist|fget|fileexist|' + 'filename|fileref|finfo|finv|fipname|fipnamel|' + 'fipstate|floor|fnonct|fnote|fopen|foptname|foptnum|' + 'fpoint|fpos|fput|fread|frewind|frlen|fsep|fuzz|' + 'fwrite|gaminv|gamma|getoption|getvarc|getvarn|hbound|' + 'hms|hosthelp|hour|ibessel|index|indexc|indexw|input|' + 'inputc|inputn|int|intck|intnx|intrr|irr|jbessel|' + 'juldate|kurtosis|lag|lbound|left|length|lgamma|' + 'libname|libref|log|log10|log2|logpdf|logpmf|logsdf|' + 'lowcase|max|mdy|mean|min|minute|mod|month|mopen|' + 'mort|n|netpv|nmiss|normal|note|npv|open|ordinal|' + 'pathname|pdf|peek|peekc|pmf|point|poisson|poke|' + 'probbeta|probbnml|probchi|probf|probgam|probhypr|' + 'probit|probnegb|probnorm|probt|put|putc|putn|qtr|' + 'quote|ranbin|rancau|ranexp|rangam|range|rank|rannor|' + 'ranpoi|rantbl|rantri|ranuni|repeat|resolve|reverse|' + 'rewind|right|round|saving|scan|sdf|second|sign|' + 'sin|sinh|skewness|soundex|spedis|sqrt|std|stderr|' + 'stfips|stname|stnamel|substr|sum|symget|sysget|' + 'sysmsg|sysprod|sysrc|system|tan|tanh|time|timepart|' + 'tinv|tnonct|today|translate|tranwrd|trigamma|' + 'trim|trimn|trunc|uniform|upcase|uss|var|varfmt|' + 'varinfmt|varlabel|varlen|varname|varnum|varray|' + 'varrayx|vartype|verify|vformat|vformatd|vformatdx|' + 'vformatn|vformatnx|vformatw|vformatwx|vformatx|' + 'vinarray|vinarrayx|vinformat|vinformatd|vinformatdx|' + 'vinformatn|vinformatnx|vinformatw|vinformatwx|' + 'vinformatx|vlabel|vlabelx|vlength|vlengthx|vname|' + 'vnamex|vtype|vtypex|weekday|year|yyq|zipfips|zipname|' + 'zipnamel|zipstate';

  // Built-in macro functions
  var SAS_MACRO_FUN = 'bquote|nrbquote|cmpres|qcmpres|compstor|' + 'datatyp|display|do|else|end|eval|global|goto|' + 'if|index|input|keydef|label|left|length|let|' + 'local|lowcase|macro|mend|nrbquote|nrquote|' + 'nrstr|put|qcmpres|qleft|qlowcase|qscan|' + 'qsubstr|qsysfunc|qtrim|quote|qupcase|scan|str|' + 'substr|superq|syscall|sysevalf|sysexec|sysfunc|' + 'sysget|syslput|sysprod|sysrc|sysrput|then|to|' + 'trim|unquote|until|upcase|verify|while|window';
  return {
    name: 'SAS',
    case_insensitive: true,
    // SAS is case-insensitive
    keywords: {
      literal: 'null missing _all_ _automatic_ _character_ _infile_ ' + '_n_ _name_ _null_ _numeric_ _user_ _webout_',
      meta: SAS_KEYWORDS
    },
    contains: [{
      // Distinct highlight for proc <proc>, data, run, quit
      className: 'keyword',
      begin: /^\s*(proc [\w\d_]+|data|run|quit)[\s;]/
    }, {
      // Macro variables
      className: 'variable',
      begin: /&[a-zA-Z_&][a-zA-Z0-9_]*\.?/
    }, {
      // Special emphasis for datalines|cards
      className: 'emphasis',
      begin: /^\s*datalines|cards.*;/,
      end: /^\s*;\s*$/
    }, {
      // Built-in macro variables take precedence
      className: 'built_in',
      begin: '%(' + SAS_MACRO_FUN + ')'
    }, {
      // User-defined macro functions highlighted after
      className: 'name',
      begin: /%[a-zA-Z_][a-zA-Z_0-9]*/
    }, {
      className: 'meta',
      begin: '[^%](' + SAS_FUN + ')[\(]'
    }, {
      className: 'string',
      variants: [hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE]
    }, hljs.COMMENT('\\*', ';'), hljs.C_BLOCK_COMMENT_MODE]
  };
}
module.exports = sas;

/***/ }),

/***/ 23601:
/***/ ((module) => {

/*
Language: Scala
Category: functional
Author: Jan Berkel <jan.berkel@gmail.com>
Contributors: Erik Osheim <d_m@plastic-idolatry.com>
Website: https://www.scala-lang.org
*/

function scala(hljs) {
  var ANNOTATION = {
    className: 'meta',
    begin: '@[A-Za-z]+'
  };

  // used in strings for escaping/interpolation/substitution
  var SUBST = {
    className: 'subst',
    variants: [{
      begin: '\\$[A-Za-z0-9_]+'
    }, {
      begin: /\$\{/,
      end: /\}/
    }]
  };
  var STRING = {
    className: 'string',
    variants: [{
      begin: '"""',
      end: '"""'
    }, {
      begin: '"',
      end: '"',
      illegal: '\\n',
      contains: [hljs.BACKSLASH_ESCAPE]
    }, {
      begin: '[a-z]+"',
      end: '"',
      illegal: '\\n',
      contains: [hljs.BACKSLASH_ESCAPE, SUBST]
    }, {
      className: 'string',
      begin: '[a-z]+"""',
      end: '"""',
      contains: [SUBST],
      relevance: 10
    }]
  };
  var SYMBOL = {
    className: 'symbol',
    begin: '\'\\w[\\w\\d_]*(?!\')'
  };
  var TYPE = {
    className: 'type',
    begin: '\\b[A-Z][A-Za-z0-9_]*',
    relevance: 0
  };
  var NAME = {
    className: 'title',
    begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/,
    relevance: 0
  };
  var CLASS = {
    className: 'class',
    beginKeywords: 'class object trait type',
    end: /[:={\[\n;]/,
    excludeEnd: true,
    contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, {
      beginKeywords: 'extends with',
      relevance: 10
    }, {
      begin: /\[/,
      end: /\]/,
      excludeBegin: true,
      excludeEnd: true,
      relevance: 0,
      contains: [TYPE]
    }, {
      className: 'params',
      begin: /\(/,
      end: /\)/,
      excludeBegin: true,
      excludeEnd: true,
      relevance: 0,
      contains: [TYPE]
    }, NAME]
  };
  var METHOD = {
    className: 'function',
    beginKeywords: 'def',
    end: /[:={\[(\n;]/,
    excludeEnd: true,
    contains: [NAME]
  };
  return {
    name: 'Scala',
    keywords: {
      literal: 'true false null',
      keyword: 'type yield lazy override def with val var sealed abstract private trait object if forSome for while throw finally protected extends import final return else break new catch super class case package default try this match continue throws implicit'
    },
    contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, STRING, SYMBOL, TYPE, METHOD, CLASS, hljs.C_NUMBER_MODE, ANNOTATION]
  };
}
module.exports = scala;

/***/ }),

/***/ 69254:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
/*
Language: Scheme
Description: Scheme is a programming language in the Lisp family.
             (keywords based on http://community.schemewiki.org/?scheme-keywords)
Author: JP Verkamp <me@jverkamp.com>
Contributors: Ivan Sagalaev <maniac@softwaremaniacs.org>
Origin: clojure.js
Website: http://community.schemewiki.org/?what-is-scheme
Category: lisp
*/

function scheme(hljs) {
  var SCHEME_IDENT_RE = '[^\\(\\)\\[\\]\\{\\}",\'`;#|\\\\\\s]+';
  var SCHEME_SIMPLE_NUMBER_RE = '(-|\\+)?\\d+([./]\\d+)?';
  var SCHEME_COMPLEX_NUMBER_RE = SCHEME_SIMPLE_NUMBER_RE + '[+\\-]' + SCHEME_SIMPLE_NUMBER_RE + 'i';
  var KEYWORDS = {
    $pattern: SCHEME_IDENT_RE,
    'builtin-name': 'case-lambda call/cc class define-class exit-handler field import ' + 'inherit init-field interface let*-values let-values let/ec mixin ' + 'opt-lambda override protect provide public rename require ' + 'require-for-syntax syntax syntax-case syntax-error unit/sig unless ' + 'when with-syntax and begin call-with-current-continuation ' + 'call-with-input-file call-with-output-file case cond define ' + 'define-syntax delay do dynamic-wind else for-each if lambda let let* ' + 'let-syntax letrec letrec-syntax map or syntax-rules \' * + , ,@ - ... / ' + '; < <= = => > >= ` abs acos angle append apply asin assoc assq assv atan ' + 'boolean? caar cadr call-with-input-file call-with-output-file ' + 'call-with-values car cdddar cddddr cdr ceiling char->integer ' + 'char-alphabetic? char-ci<=? char-ci<? char-ci=? char-ci>=? char-ci>? ' + 'char-downcase char-lower-case? char-numeric? char-ready? char-upcase ' + 'char-upper-case? char-whitespace? char<=? char<? char=? char>=? char>? ' + 'char? close-input-port close-output-port complex? cons cos ' + 'current-input-port current-output-port denominator display eof-object? ' + 'eq? equal? eqv? eval even? exact->inexact exact? exp expt floor ' + 'force gcd imag-part inexact->exact inexact? input-port? integer->char ' + 'integer? interaction-environment lcm length list list->string ' + 'list->vector list-ref list-tail list? load log magnitude make-polar ' + 'make-rectangular make-string make-vector max member memq memv min ' + 'modulo negative? newline not null-environment null? number->string ' + 'number? numerator odd? open-input-file open-output-file output-port? ' + 'pair? peek-char port? positive? procedure? quasiquote quote quotient ' + 'rational? rationalize read read-char real-part real? remainder reverse ' + 'round scheme-report-environment set! set-car! set-cdr! sin sqrt string ' + 'string->list string->number string->symbol string-append string-ci<=? ' + 'string-ci<? string-ci=? string-ci>=? string-ci>? string-copy ' + 'string-fill! string-length string-ref string-set! string<=? string<? ' + 'string=? string>=? string>? string? substring symbol->string symbol? ' + 'tan transcript-off transcript-on truncate values vector ' + 'vector->list vector-fill! vector-length vector-ref vector-set! ' + 'with-input-from-file with-output-to-file write write-char zero?'
  };
  var LITERAL = {
    className: 'literal',
    begin: '(#t|#f|#\\\\' + SCHEME_IDENT_RE + '|#\\\\.)'
  };
  var NUMBER = {
    className: 'number',
    variants: [{
      begin: SCHEME_SIMPLE_NUMBER_RE,
      relevance: 0
    }, {
      begin: SCHEME_COMPLEX_NUMBER_RE,
      relevance: 0
    }, {
      begin: '#b[0-1]+(/[0-1]+)?'
    }, {
      begin: '#o[0-7]+(/[0-7]+)?'
    }, {
      begin: '#x[0-9a-f]+(/[0-9a-f]+)?'
    }]
  };
  var STRING = hljs.QUOTE_STRING_MODE;
  var COMMENT_MODES = [hljs.COMMENT(';', '$', {
    relevance: 0
  }), hljs.COMMENT('#\\|', '\\|#')];
  var IDENT = {
    begin: SCHEME_IDENT_RE,
    relevance: 0
  };
  var QUOTED_IDENT = {
    className: 'symbol',
    begin: '\'' + SCHEME_IDENT_RE
  };
  var BODY = {
    endsWithParent: true,
    relevance: 0
  };
  var QUOTED_LIST = {
    variants: [{
      begin: /'/
    }, {
      begin: '`'
    }],
    contains: [{
      begin: '\\(',
      end: '\\)',
      contains: ['self', LITERAL, STRING, NUMBER, IDENT, QUOTED_IDENT]
    }]
  };
  var NAME = {
    className: 'name',
    relevance: 0,
    begin: SCHEME_IDENT_RE,
    keywords: KEYWORDS
  };
  var LAMBDA = {
    begin: /lambda/,
    endsWithParent: true,
    returnBegin: true,
    contains: [NAME, {
      endsParent: true,
      variants: [{
        begin: /\(/,
        end: /\)/
      }, {
        begin: /\[/,
        end: /\]/
      }],
      contains: [IDENT]
    }]
  };
  var LIST = {
    variants: [{
      begin: '\\(',
      end: '\\)'
    }, {
      begin: '\\[',
      end: '\\]'
    }],
    contains: [LAMBDA, NAME, BODY]
  };
  BODY.contains = [LITERAL, NUMBER, STRING, IDENT, QUOTED_IDENT, QUOTED_LIST, LIST].concat(COMMENT_MODES);
  return {
    name: 'Scheme',
    illegal: /\S/,
    contains: [hljs.SHEBANG(), NUMBER, STRING, QUOTED_IDENT, QUOTED_LIST, LIST].concat(COMMENT_MODES)
  };
}
module.exports = scheme;

/***/ }),

/***/ 57828:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
/*
Language: Scilab
Author: Sylvestre Ledru <sylvestre.ledru@scilab-enterprises.com>
Origin: matlab.js
Description: Scilab is a port from Matlab
Website: https://www.scilab.org
Category: scientific
*/

function scilab(hljs) {
  var COMMON_CONTAINS = [hljs.C_NUMBER_MODE, {
    className: 'string',
    begin: '\'|\"',
    end: '\'|\"',
    contains: [hljs.BACKSLASH_ESCAPE, {
      begin: '\'\''
    }]
  }];
  return {
    name: 'Scilab',
    aliases: ['sci'],
    keywords: {
      $pattern: /%?\w+/,
      keyword: 'abort break case clear catch continue do elseif else endfunction end for function ' + 'global if pause return resume select try then while',
      literal: '%f %F %t %T %pi %eps %inf %nan %e %i %z %s',
      built_in:
      // Scilab has more than 2000 functions. Just list the most commons
      'abs and acos asin atan ceil cd chdir clearglobal cosh cos cumprod deff disp error ' + 'exec execstr exists exp eye gettext floor fprintf fread fsolve imag isdef isempty ' + 'isinfisnan isvector lasterror length load linspace list listfiles log10 log2 log ' + 'max min msprintf mclose mopen ones or pathconvert poly printf prod pwd rand real ' + 'round sinh sin size gsort sprintf sqrt strcat strcmps tring sum system tanh tan ' + 'type typename warning zeros matrix'
    },
    illegal: '("|#|/\\*|\\s+/\\w+)',
    contains: [{
      className: 'function',
      beginKeywords: 'function',
      end: '$',
      contains: [hljs.UNDERSCORE_TITLE_MODE, {
        className: 'params',
        begin: '\\(',
        end: '\\)'
      }]
    },
    // seems to be a guard against [ident]' or [ident].
    // perhaps to prevent attributes from flagging as keywords?
    {
      begin: '[a-zA-Z_][a-zA-Z_0-9]*[\\.\']+',
      relevance: 0
    }, {
      begin: '\\[',
      end: '\\][\\.\']*',
      relevance: 0,
      contains: COMMON_CONTAINS
    }, hljs.COMMENT('//', '$')].concat(COMMON_CONTAINS)
  };
}
module.exports = scilab;

/***/ }),

/***/ 8200:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
var MODES = function MODES(hljs) {
  return {
    IMPORTANT: {
      className: 'meta',
      begin: '!important'
    },
    HEXCOLOR: {
      className: 'number',
      begin: '#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})'
    },
    ATTRIBUTE_SELECTOR_MODE: {
      className: 'selector-attr',
      begin: /\[/,
      end: /\]/,
      illegal: '$',
      contains: [hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE]
    }
  };
};
var TAGS = ['a', 'abbr', 'address', 'article', 'aside', 'audio', 'b', 'blockquote', 'body', 'button', 'canvas', 'caption', 'cite', 'code', 'dd', 'del', 'details', 'dfn', 'div', 'dl', 'dt', 'em', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'mark', 'menu', 'nav', 'object', 'ol', 'p', 'q', 'quote', 'samp', 'section', 'span', 'strong', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'ul', 'var', 'video'];
var MEDIA_FEATURES = ['any-hover', 'any-pointer', 'aspect-ratio', 'color', 'color-gamut', 'color-index', 'device-aspect-ratio', 'device-height', 'device-width', 'display-mode', 'forced-colors', 'grid', 'height', 'hover', 'inverted-colors', 'monochrome', 'orientation', 'overflow-block', 'overflow-inline', 'pointer', 'prefers-color-scheme', 'prefers-contrast', 'prefers-reduced-motion', 'prefers-reduced-transparency', 'resolution', 'scan', 'scripting', 'update', 'width',
// TODO: find a better solution?
'min-width', 'max-width', 'min-height', 'max-height'];

// https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-classes
var PSEUDO_CLASSES = ['active', 'any-link', 'blank', 'checked', 'current', 'default', 'defined', 'dir',
// dir()
'disabled', 'drop', 'empty', 'enabled', 'first', 'first-child', 'first-of-type', 'fullscreen', 'future', 'focus', 'focus-visible', 'focus-within', 'has',
// has()
'host',
// host or host()
'host-context',
// host-context()
'hover', 'indeterminate', 'in-range', 'invalid', 'is',
// is()
'lang',
// lang()
'last-child', 'last-of-type', 'left', 'link', 'local-link', 'not',
// not()
'nth-child',
// nth-child()
'nth-col',
// nth-col()
'nth-last-child',
// nth-last-child()
'nth-last-col',
// nth-last-col()
'nth-last-of-type',
//nth-last-of-type()
'nth-of-type',
//nth-of-type()
'only-child', 'only-of-type', 'optional', 'out-of-range', 'past', 'placeholder-shown', 'read-only', 'read-write', 'required', 'right', 'root', 'scope', 'target', 'target-within', 'user-invalid', 'valid', 'visited', 'where' // where()
];

// https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-elements
var PSEUDO_ELEMENTS = ['after', 'backdrop', 'before', 'cue', 'cue-region', 'first-letter', 'first-line', 'grammar-error', 'marker', 'part', 'placeholder', 'selection', 'slotted', 'spelling-error'];
var ATTRIBUTES = ['align-content', 'align-items', 'align-self', 'animation', 'animation-delay', 'animation-direction', 'animation-duration', 'animation-fill-mode', 'animation-iteration-count', 'animation-name', 'animation-play-state', 'animation-timing-function', 'auto', 'backface-visibility', 'background', 'background-attachment', 'background-clip', 'background-color', 'background-image', 'background-origin', 'background-position', 'background-repeat', 'background-size', 'border', 'border-bottom', 'border-bottom-color', 'border-bottom-left-radius', 'border-bottom-right-radius', 'border-bottom-style', 'border-bottom-width', 'border-collapse', 'border-color', 'border-image', 'border-image-outset', 'border-image-repeat', 'border-image-slice', 'border-image-source', 'border-image-width', 'border-left', 'border-left-color', 'border-left-style', 'border-left-width', 'border-radius', 'border-right', 'border-right-color', 'border-right-style', 'border-right-width', 'border-spacing', 'border-style', 'border-top', 'border-top-color', 'border-top-left-radius', 'border-top-right-radius', 'border-top-style', 'border-top-width', 'border-width', 'bottom', 'box-decoration-break', 'box-shadow', 'box-sizing', 'break-after', 'break-before', 'break-inside', 'caption-side', 'clear', 'clip', 'clip-path', 'color', 'column-count', 'column-fill', 'column-gap', 'column-rule', 'column-rule-color', 'column-rule-style', 'column-rule-width', 'column-span', 'column-width', 'columns', 'content', 'counter-increment', 'counter-reset', 'cursor', 'direction', 'display', 'empty-cells', 'filter', 'flex', 'flex-basis', 'flex-direction', 'flex-flow', 'flex-grow', 'flex-shrink', 'flex-wrap', 'float', 'font', 'font-display', 'font-family', 'font-feature-settings', 'font-kerning', 'font-language-override', 'font-size', 'font-size-adjust', 'font-smoothing', 'font-stretch', 'font-style', 'font-variant', 'font-variant-ligatures', 'font-variation-settings', 'font-weight', 'height', 'hyphens', 'icon', 'image-orientation', 'image-rendering', 'image-resolution', 'ime-mode', 'inherit', 'initial', 'justify-content', 'left', 'letter-spacing', 'line-height', 'list-style', 'list-style-image', 'list-style-position', 'list-style-type', 'margin', 'margin-bottom', 'margin-left', 'margin-right', 'margin-top', 'marks', 'mask', 'max-height', 'max-width', 'min-height', 'min-width', 'nav-down', 'nav-index', 'nav-left', 'nav-right', 'nav-up', 'none', 'normal', 'object-fit', 'object-position', 'opacity', 'order', 'orphans', 'outline', 'outline-color', 'outline-offset', 'outline-style', 'outline-width', 'overflow', 'overflow-wrap', 'overflow-x', 'overflow-y', 'padding', 'padding-bottom', 'padding-left', 'padding-right', 'padding-top', 'page-break-after', 'page-break-before', 'page-break-inside', 'perspective', 'perspective-origin', 'pointer-events', 'position', 'quotes', 'resize', 'right', 'src',
// @font-face
'tab-size', 'table-layout', 'text-align', 'text-align-last', 'text-decoration', 'text-decoration-color', 'text-decoration-line', 'text-decoration-style', 'text-indent', 'text-overflow', 'text-rendering', 'text-shadow', 'text-transform', 'text-underline-position', 'top', 'transform', 'transform-origin', 'transform-style', 'transition', 'transition-delay', 'transition-duration', 'transition-property', 'transition-timing-function', 'unicode-bidi', 'vertical-align', 'visibility', 'white-space', 'widows', 'width', 'word-break', 'word-spacing', 'word-wrap', 'z-index'
// reverse makes sure longer attributes `font-weight` are matched fully
// instead of getting false positives on say `font`
].reverse();

/*
Language: SCSS
Description: Scss is an extension of the syntax of CSS.
Author: Kurt Emch <kurt@kurtemch.com>
Website: https://sass-lang.com
Category: common, css
*/

/** @type LanguageFn */
function scss(hljs) {
  var modes = MODES(hljs);
  var PSEUDO_ELEMENTS$1 = PSEUDO_ELEMENTS;
  var PSEUDO_CLASSES$1 = PSEUDO_CLASSES;
  var AT_IDENTIFIER = '@[a-z-]+'; // @font-face
  var AT_MODIFIERS = "and or not only";
  var IDENT_RE = '[a-zA-Z-][a-zA-Z0-9_-]*';
  var VARIABLE = {
    className: 'variable',
    begin: '(\\$' + IDENT_RE + ')\\b'
  };
  return {
    name: 'SCSS',
    case_insensitive: true,
    illegal: '[=/|\']',
    contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, {
      className: 'selector-id',
      begin: '#[A-Za-z0-9_-]+',
      relevance: 0
    }, {
      className: 'selector-class',
      begin: '\\.[A-Za-z0-9_-]+',
      relevance: 0
    }, modes.ATTRIBUTE_SELECTOR_MODE, {
      className: 'selector-tag',
      begin: '\\b(' + TAGS.join('|') + ')\\b',
      // was there, before, but why?
      relevance: 0
    }, {
      className: 'selector-pseudo',
      begin: ':(' + PSEUDO_CLASSES$1.join('|') + ')'
    }, {
      className: 'selector-pseudo',
      begin: '::(' + PSEUDO_ELEMENTS$1.join('|') + ')'
    }, VARIABLE, {
      // pseudo-selector params
      begin: /\(/,
      end: /\)/,
      contains: [hljs.CSS_NUMBER_MODE]
    }, {
      className: 'attribute',
      begin: '\\b(' + ATTRIBUTES.join('|') + ')\\b'
    }, {
      begin: '\\b(whitespace|wait|w-resize|visible|vertical-text|vertical-ideographic|uppercase|upper-roman|upper-alpha|underline|transparent|top|thin|thick|text|text-top|text-bottom|tb-rl|table-header-group|table-footer-group|sw-resize|super|strict|static|square|solid|small-caps|separate|se-resize|scroll|s-resize|rtl|row-resize|ridge|right|repeat|repeat-y|repeat-x|relative|progress|pointer|overline|outside|outset|oblique|nowrap|not-allowed|normal|none|nw-resize|no-repeat|no-drop|newspaper|ne-resize|n-resize|move|middle|medium|ltr|lr-tb|lowercase|lower-roman|lower-alpha|loose|list-item|line|line-through|line-edge|lighter|left|keep-all|justify|italic|inter-word|inter-ideograph|inside|inset|inline|inline-block|inherit|inactive|ideograph-space|ideograph-parenthesis|ideograph-numeric|ideograph-alpha|horizontal|hidden|help|hand|groove|fixed|ellipsis|e-resize|double|dotted|distribute|distribute-space|distribute-letter|distribute-all-lines|disc|disabled|default|decimal|dashed|crosshair|collapse|col-resize|circle|char|center|capitalize|break-word|break-all|bottom|both|bolder|bold|block|bidi-override|below|baseline|auto|always|all-scroll|absolute|table|table-cell)\\b'
    }, {
      begin: ':',
      end: ';',
      contains: [VARIABLE, modes.HEXCOLOR, hljs.CSS_NUMBER_MODE, hljs.QUOTE_STRING_MODE, hljs.APOS_STRING_MODE, modes.IMPORTANT]
    },
    // matching these here allows us to treat them more like regular CSS
    // rules so everything between the {} gets regular rule highlighting,
    // which is what we want for page and font-face
    {
      begin: '@(page|font-face)',
      lexemes: AT_IDENTIFIER,
      keywords: '@page @font-face'
    }, {
      begin: '@',
      end: '[{;]',
      returnBegin: true,
      keywords: {
        $pattern: /[a-z-]+/,
        keyword: AT_MODIFIERS,
        attribute: MEDIA_FEATURES.join(" ")
      },
      contains: [{
        begin: AT_IDENTIFIER,
        className: "keyword"
      }, {
        begin: /[a-z-]+(?=:)/,
        className: "attribute"
      }, VARIABLE, hljs.QUOTE_STRING_MODE, hljs.APOS_STRING_MODE, modes.HEXCOLOR, hljs.CSS_NUMBER_MODE]
    }]
  };
}
module.exports = scss;

/***/ }),

/***/ 90859:
/***/ ((module) => {

/*
Language: Shell Session
Requires: bash.js
Author: TSUYUSATO Kitsune <make.just.on@gmail.com>
Category: common
Audit: 2020
*/

/** @type LanguageFn */
function shell(hljs) {
  return {
    name: 'Shell Session',
    aliases: ['console'],
    contains: [{
      className: 'meta',
      // We cannot add \s (spaces) in the regular expression otherwise it will be too broad and produce unexpected result.
      // For instance, in the following example, it would match "echo /path/to/home >" as a prompt:
      // echo /path/to/home > t.exe
      begin: /^\s{0,3}[/~\w\d[\]()@-]*[>%$#]/,
      starts: {
        end: /[^\\](?=\s*$)/,
        subLanguage: 'bash'
      }
    }]
  };
}
module.exports = shell;

/***/ }),

/***/ 28765:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
/*
Language: Smali
Author: Dennis Titze <dennis.titze@gmail.com>
Description: Basic Smali highlighting
Website: https://github.com/JesusFreke/smali
*/

function smali(hljs) {
  var smali_instr_low_prio = ['add', 'and', 'cmp', 'cmpg', 'cmpl', 'const', 'div', 'double', 'float', 'goto', 'if', 'int', 'long', 'move', 'mul', 'neg', 'new', 'nop', 'not', 'or', 'rem', 'return', 'shl', 'shr', 'sput', 'sub', 'throw', 'ushr', 'xor'];
  var smali_instr_high_prio = ['aget', 'aput', 'array', 'check', 'execute', 'fill', 'filled', 'goto/16', 'goto/32', 'iget', 'instance', 'invoke', 'iput', 'monitor', 'packed', 'sget', 'sparse'];
  var smali_keywords = ['transient', 'constructor', 'abstract', 'final', 'synthetic', 'public', 'private', 'protected', 'static', 'bridge', 'system'];
  return {
    name: 'Smali',
    contains: [{
      className: 'string',
      begin: '"',
      end: '"',
      relevance: 0
    }, hljs.COMMENT('#', '$', {
      relevance: 0
    }), {
      className: 'keyword',
      variants: [{
        begin: '\\s*\\.end\\s[a-zA-Z0-9]*'
      }, {
        begin: '^[ ]*\\.[a-zA-Z]*',
        relevance: 0
      }, {
        begin: '\\s:[a-zA-Z_0-9]*',
        relevance: 0
      }, {
        begin: '\\s(' + smali_keywords.join('|') + ')'
      }]
    }, {
      className: 'built_in',
      variants: [{
        begin: '\\s(' + smali_instr_low_prio.join('|') + ')\\s'
      }, {
        begin: '\\s(' + smali_instr_low_prio.join('|') + ')((-|/)[a-zA-Z0-9]+)+\\s',
        relevance: 10
      }, {
        begin: '\\s(' + smali_instr_high_prio.join('|') + ')((-|/)[a-zA-Z0-9]+)*\\s',
        relevance: 10
      }]
    }, {
      className: 'class',
      begin: 'L[^\(;:\n]*;',
      relevance: 0
    }, {
      begin: '[vp][0-9]+'
    }]
  };
}
module.exports = smali;

/***/ }),

/***/ 30394:
/***/ ((module) => {

/*
Language: Smalltalk
Description: Smalltalk is an object-oriented, dynamically typed reflective programming language.
Author: Vladimir Gubarkov <xonixx@gmail.com>
Website: https://en.wikipedia.org/wiki/Smalltalk
*/

function smalltalk(hljs) {
  var VAR_IDENT_RE = '[a-z][a-zA-Z0-9_]*';
  var CHAR = {
    className: 'string',
    begin: '\\$.{1}'
  };
  var SYMBOL = {
    className: 'symbol',
    begin: '#' + hljs.UNDERSCORE_IDENT_RE
  };
  return {
    name: 'Smalltalk',
    aliases: ['st'],
    keywords: 'self super nil true false thisContext',
    // only 6
    contains: [hljs.COMMENT('"', '"'), hljs.APOS_STRING_MODE, {
      className: 'type',
      begin: '\\b[A-Z][A-Za-z0-9_]*',
      relevance: 0
    }, {
      begin: VAR_IDENT_RE + ':',
      relevance: 0
    }, hljs.C_NUMBER_MODE, SYMBOL, CHAR, {
      // This looks more complicated than needed to avoid combinatorial
      // explosion under V8. It effectively means `| var1 var2 ... |` with
      // whitespace adjacent to `|` being optional.
      begin: '\\|[ ]*' + VAR_IDENT_RE + '([ ]+' + VAR_IDENT_RE + ')*[ ]*\\|',
      returnBegin: true,
      end: /\|/,
      illegal: /\S/,
      contains: [{
        begin: '(\\|[ ]*)?' + VAR_IDENT_RE
      }]
    }, {
      begin: '#\\(',
      end: '\\)',
      contains: [hljs.APOS_STRING_MODE, CHAR, hljs.C_NUMBER_MODE, SYMBOL]
    }]
  };
}
module.exports = smalltalk;

/***/ }),

/***/ 23692:
/***/ ((module) => {

/*
Language: SML (Standard ML)
Author: Edwin Dalorzo <edwin@dalorzo.org>
Description: SML language definition.
Website: https://www.smlnj.org
Origin: ocaml.js
Category: functional
*/
function sml(hljs) {
  return {
    name: 'SML (Standard ML)',
    aliases: ['ml'],
    keywords: {
      $pattern: '[a-z_]\\w*!?',
      keyword: /* according to Definition of Standard ML 97  */
      'abstype and andalso as case datatype do else end eqtype ' + 'exception fn fun functor handle if in include infix infixr ' + 'let local nonfix of op open orelse raise rec sharing sig ' + 'signature struct structure then type val with withtype where while',
      built_in: /* built-in types according to basis library */
      'array bool char exn int list option order real ref string substring vector unit word',
      literal: 'true false NONE SOME LESS EQUAL GREATER nil'
    },
    illegal: /\/\/|>>/,
    contains: [{
      className: 'literal',
      begin: /\[(\|\|)?\]|\(\)/,
      relevance: 0
    }, hljs.COMMENT('\\(\\*', '\\*\\)', {
      contains: ['self']
    }), {
      /* type variable */
      className: 'symbol',
      begin: '\'[A-Za-z_](?!\')[\\w\']*'
      /* the grammar is ambiguous on how 'a'b should be interpreted but not the compiler */
    }, {
      /* polymorphic variant */
      className: 'type',
      begin: '`[A-Z][\\w\']*'
    }, {
      /* module or constructor */
      className: 'type',
      begin: '\\b[A-Z][\\w\']*',
      relevance: 0
    }, {
      /* don't color identifiers, but safely catch all identifiers with ' */
      begin: '[a-z_]\\w*\'[\\w\']*'
    }, hljs.inherit(hljs.APOS_STRING_MODE, {
      className: 'string',
      relevance: 0
    }), hljs.inherit(hljs.QUOTE_STRING_MODE, {
      illegal: null
    }), {
      className: 'number',
      begin: '\\b(0[xX][a-fA-F0-9_]+[Lln]?|' + '0[oO][0-7_]+[Lln]?|' + '0[bB][01_]+[Lln]?|' + '[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)',
      relevance: 0
    }, {
      begin: /[-=]>/ // relevance booster
    }]
  };
}

module.exports = sml;

/***/ }),

/***/ 84078:
/***/ ((module) => {

/*
Language: SQF
Author: Søren Enevoldsen <senevoldsen90@gmail.com>
Contributors: Marvin Saignat <contact@zgmrvn.com>, Dedmen Miller <dedmen@dedmen.de>
Description: Scripting language for the Arma game series
Website: https://community.bistudio.com/wiki/SQF_syntax
Category: scripting
*/

function sqf(hljs) {
  // In SQF, a variable start with _
  var VARIABLE = {
    className: 'variable',
    begin: /\b_+[a-zA-Z]\w*/
  };

  // In SQF, a function should fit myTag_fnc_myFunction pattern
  // https://community.bistudio.com/wiki/Functions_Library_(Arma_3)#Adding_a_Function
  var FUNCTION = {
    className: 'title',
    begin: /[a-zA-Z][a-zA-Z0-9]+_fnc_\w*/
  };

  // In SQF strings, quotes matching the start are escaped by adding a consecutive.
  // Example of single escaped quotes: " "" " and  ' '' '.
  var STRINGS = {
    className: 'string',
    variants: [{
      begin: '"',
      end: '"',
      contains: [{
        begin: '""',
        relevance: 0
      }]
    }, {
      begin: '\'',
      end: '\'',
      contains: [{
        begin: '\'\'',
        relevance: 0
      }]
    }]
  };

  // list of keywords from:
  // https://community.bistudio.com/wiki/PreProcessor_Commands
  var PREPROCESSOR = {
    className: 'meta',
    begin: /#\s*[a-z]+\b/,
    end: /$/,
    keywords: {
      'meta-keyword': 'define undef ifdef ifndef else endif include'
    },
    contains: [{
      begin: /\\\n/,
      relevance: 0
    }, hljs.inherit(STRINGS, {
      className: 'meta-string'
    }), {
      className: 'meta-string',
      begin: /<[^\n>]*>/,
      end: /$/,
      illegal: '\\n'
    }, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE]
  };
  return {
    name: 'SQF',
    case_insensitive: true,
    keywords: {
      keyword: 'case catch default do else exit exitWith for forEach from if ' + 'private switch then throw to try waitUntil while with',
      built_in: 'abs accTime acos action actionIDs actionKeys actionKeysImages actionKeysNames ' + 'actionKeysNamesArray actionName actionParams activateAddons activatedAddons activateKey ' + 'add3DENConnection add3DENEventHandler add3DENLayer addAction addBackpack addBackpackCargo ' + 'addBackpackCargoGlobal addBackpackGlobal addCamShake addCuratorAddons addCuratorCameraArea ' + 'addCuratorEditableObjects addCuratorEditingArea addCuratorPoints addEditorObject addEventHandler ' + 'addForce addGoggles addGroupIcon addHandgunItem addHeadgear addItem addItemCargo ' + 'addItemCargoGlobal addItemPool addItemToBackpack addItemToUniform addItemToVest addLiveStats ' + 'addMagazine addMagazineAmmoCargo addMagazineCargo addMagazineCargoGlobal addMagazineGlobal ' + 'addMagazinePool addMagazines addMagazineTurret addMenu addMenuItem addMissionEventHandler ' + 'addMPEventHandler addMusicEventHandler addOwnedMine addPlayerScores addPrimaryWeaponItem ' + 'addPublicVariableEventHandler addRating addResources addScore addScoreSide addSecondaryWeaponItem ' + 'addSwitchableUnit addTeamMember addToRemainsCollector addTorque addUniform addVehicle addVest ' + 'addWaypoint addWeapon addWeaponCargo addWeaponCargoGlobal addWeaponGlobal addWeaponItem ' + 'addWeaponPool addWeaponTurret admin agent agents AGLToASL aimedAtTarget aimPos airDensityRTD ' + 'airplaneThrottle airportSide AISFinishHeal alive all3DENEntities allAirports allControls ' + 'allCurators allCutLayers allDead allDeadMen allDisplays allGroups allMapMarkers allMines ' + 'allMissionObjects allow3DMode allowCrewInImmobile allowCuratorLogicIgnoreAreas allowDamage ' + 'allowDammage allowFileOperations allowFleeing allowGetIn allowSprint allPlayers allSimpleObjects ' + 'allSites allTurrets allUnits allUnitsUAV allVariables ammo ammoOnPylon and animate animateBay ' + 'animateDoor animatePylon animateSource animationNames animationPhase animationSourcePhase ' + 'animationState append apply armoryPoints arrayIntersect asin ASLToAGL ASLToATL assert ' + 'assignAsCargo assignAsCargoIndex assignAsCommander assignAsDriver assignAsGunner assignAsTurret ' + 'assignCurator assignedCargo assignedCommander assignedDriver assignedGunner assignedItems ' + 'assignedTarget assignedTeam assignedVehicle assignedVehicleRole assignItem assignTeam ' + 'assignToAirport atan atan2 atg ATLToASL attachedObject attachedObjects attachedTo attachObject ' + 'attachTo attackEnabled backpack backpackCargo backpackContainer backpackItems backpackMagazines ' + 'backpackSpaceFor behaviour benchmark binocular boundingBox boundingBoxReal boundingCenter ' + 'breakOut breakTo briefingName buildingExit buildingPos buttonAction buttonSetAction cadetMode ' + 'call callExtension camCommand camCommit camCommitPrepared camCommitted camConstuctionSetParams ' + 'camCreate camDestroy cameraEffect cameraEffectEnableHUD cameraInterest cameraOn cameraView ' + 'campaignConfigFile camPreload camPreloaded camPrepareBank camPrepareDir camPrepareDive ' + 'camPrepareFocus camPrepareFov camPrepareFovRange camPreparePos camPrepareRelPos camPrepareTarget ' + 'camSetBank camSetDir camSetDive camSetFocus camSetFov camSetFovRange camSetPos camSetRelPos ' + 'camSetTarget camTarget camUseNVG canAdd canAddItemToBackpack canAddItemToUniform canAddItemToVest ' + 'cancelSimpleTaskDestination canFire canMove canSlingLoad canStand canSuspend ' + 'canTriggerDynamicSimulation canUnloadInCombat canVehicleCargo captive captiveNum cbChecked ' + 'cbSetChecked ceil channelEnabled cheatsEnabled checkAIFeature checkVisibility className ' + 'clearAllItemsFromBackpack clearBackpackCargo clearBackpackCargoGlobal clearGroupIcons ' + 'clearItemCargo clearItemCargoGlobal clearItemPool clearMagazineCargo clearMagazineCargoGlobal ' + 'clearMagazinePool clearOverlay clearRadio clearWeaponCargo clearWeaponCargoGlobal clearWeaponPool ' + 'clientOwner closeDialog closeDisplay closeOverlay collapseObjectTree collect3DENHistory ' + 'collectiveRTD combatMode commandArtilleryFire commandChat commander commandFire commandFollow ' + 'commandFSM commandGetOut commandingMenu commandMove commandRadio commandStop ' + 'commandSuppressiveFire commandTarget commandWatch comment commitOverlay compile compileFinal ' + 'completedFSM composeText configClasses configFile configHierarchy configName configProperties ' + 'configSourceAddonList configSourceMod configSourceModList confirmSensorTarget ' + 'connectTerminalToUAV controlsGroupCtrl copyFromClipboard copyToClipboard copyWaypoints cos count ' + 'countEnemy countFriendly countSide countType countUnknown create3DENComposition create3DENEntity ' + 'createAgent createCenter createDialog createDiaryLink createDiaryRecord createDiarySubject ' + 'createDisplay createGearDialog createGroup createGuardedPoint createLocation createMarker ' + 'createMarkerLocal createMenu createMine createMissionDisplay createMPCampaignDisplay ' + 'createSimpleObject createSimpleTask createSite createSoundSource createTask createTeam ' + 'createTrigger createUnit createVehicle createVehicleCrew createVehicleLocal crew ctAddHeader ' + 'ctAddRow ctClear ctCurSel ctData ctFindHeaderRows ctFindRowHeader ctHeaderControls ctHeaderCount ' + 'ctRemoveHeaders ctRemoveRows ctrlActivate ctrlAddEventHandler ctrlAngle ctrlAutoScrollDelay ' + 'ctrlAutoScrollRewind ctrlAutoScrollSpeed ctrlChecked ctrlClassName ctrlCommit ctrlCommitted ' + 'ctrlCreate ctrlDelete ctrlEnable ctrlEnabled ctrlFade ctrlHTMLLoaded ctrlIDC ctrlIDD ' + 'ctrlMapAnimAdd ctrlMapAnimClear ctrlMapAnimCommit ctrlMapAnimDone ctrlMapCursor ctrlMapMouseOver ' + 'ctrlMapScale ctrlMapScreenToWorld ctrlMapWorldToScreen ctrlModel ctrlModelDirAndUp ctrlModelScale ' + 'ctrlParent ctrlParentControlsGroup ctrlPosition ctrlRemoveAllEventHandlers ctrlRemoveEventHandler ' + 'ctrlScale ctrlSetActiveColor ctrlSetAngle ctrlSetAutoScrollDelay ctrlSetAutoScrollRewind ' + 'ctrlSetAutoScrollSpeed ctrlSetBackgroundColor ctrlSetChecked ctrlSetEventHandler ctrlSetFade ' + 'ctrlSetFocus ctrlSetFont ctrlSetFontH1 ctrlSetFontH1B ctrlSetFontH2 ctrlSetFontH2B ctrlSetFontH3 ' + 'ctrlSetFontH3B ctrlSetFontH4 ctrlSetFontH4B ctrlSetFontH5 ctrlSetFontH5B ctrlSetFontH6 ' + 'ctrlSetFontH6B ctrlSetFontHeight ctrlSetFontHeightH1 ctrlSetFontHeightH2 ctrlSetFontHeightH3 ' + 'ctrlSetFontHeightH4 ctrlSetFontHeightH5 ctrlSetFontHeightH6 ctrlSetFontHeightSecondary ' + 'ctrlSetFontP ctrlSetFontPB ctrlSetFontSecondary ctrlSetForegroundColor ctrlSetModel ' + 'ctrlSetModelDirAndUp ctrlSetModelScale ctrlSetPixelPrecision ctrlSetPosition ctrlSetScale ' + 'ctrlSetStructuredText ctrlSetText ctrlSetTextColor ctrlSetTooltip ctrlSetTooltipColorBox ' + 'ctrlSetTooltipColorShade ctrlSetTooltipColorText ctrlShow ctrlShown ctrlText ctrlTextHeight ' + 'ctrlTextWidth ctrlType ctrlVisible ctRowControls ctRowCount ctSetCurSel ctSetData ' + 'ctSetHeaderTemplate ctSetRowTemplate ctSetValue ctValue curatorAddons curatorCamera ' + 'curatorCameraArea curatorCameraAreaCeiling curatorCoef curatorEditableObjects curatorEditingArea ' + 'curatorEditingAreaType curatorMouseOver curatorPoints curatorRegisteredObjects curatorSelected ' + 'curatorWaypointCost current3DENOperation currentChannel currentCommand currentMagazine ' + 'currentMagazineDetail currentMagazineDetailTurret currentMagazineTurret currentMuzzle ' + 'currentNamespace currentTask currentTasks currentThrowable currentVisionMode currentWaypoint ' + 'currentWeapon currentWeaponMode currentWeaponTurret currentZeroing cursorObject cursorTarget ' + 'customChat customRadio cutFadeOut cutObj cutRsc cutText damage date dateToNumber daytime ' + 'deActivateKey debriefingText debugFSM debugLog deg delete3DENEntities deleteAt deleteCenter ' + 'deleteCollection deleteEditorObject deleteGroup deleteGroupWhenEmpty deleteIdentity ' + 'deleteLocation deleteMarker deleteMarkerLocal deleteRange deleteResources deleteSite deleteStatus ' + 'deleteTeam deleteVehicle deleteVehicleCrew deleteWaypoint detach detectedMines ' + 'diag_activeMissionFSMs diag_activeScripts diag_activeSQFScripts diag_activeSQSScripts ' + 'diag_captureFrame diag_captureFrameToFile diag_captureSlowFrame diag_codePerformance ' + 'diag_drawMode diag_enable diag_enabled diag_fps diag_fpsMin diag_frameNo diag_lightNewLoad ' + 'diag_list diag_log diag_logSlowFrame diag_mergeConfigFile diag_recordTurretLimits ' + 'diag_setLightNew diag_tickTime diag_toggle dialog diarySubjectExists didJIP didJIPOwner ' + 'difficulty difficultyEnabled difficultyEnabledRTD difficultyOption direction directSay disableAI ' + 'disableCollisionWith disableConversation disableDebriefingStats disableMapIndicators ' + 'disableNVGEquipment disableRemoteSensors disableSerialization disableTIEquipment ' + 'disableUAVConnectability disableUserInput displayAddEventHandler displayCtrl displayParent ' + 'displayRemoveAllEventHandlers displayRemoveEventHandler displaySetEventHandler dissolveTeam ' + 'distance distance2D distanceSqr distributionRegion do3DENAction doArtilleryFire doFire doFollow ' + 'doFSM doGetOut doMove doorPhase doStop doSuppressiveFire doTarget doWatch drawArrow drawEllipse ' + 'drawIcon drawIcon3D drawLine drawLine3D drawLink drawLocation drawPolygon drawRectangle ' + 'drawTriangle driver drop dynamicSimulationDistance dynamicSimulationDistanceCoef ' + 'dynamicSimulationEnabled dynamicSimulationSystemEnabled echo edit3DENMissionAttributes editObject ' + 'editorSetEventHandler effectiveCommander emptyPositions enableAI enableAIFeature ' + 'enableAimPrecision enableAttack enableAudioFeature enableAutoStartUpRTD enableAutoTrimRTD ' + 'enableCamShake enableCaustics enableChannel enableCollisionWith enableCopilot ' + 'enableDebriefingStats enableDiagLegend enableDynamicSimulation enableDynamicSimulationSystem ' + 'enableEndDialog enableEngineArtillery enableEnvironment enableFatigue enableGunLights ' + 'enableInfoPanelComponent enableIRLasers enableMimics enablePersonTurret enableRadio enableReload ' + 'enableRopeAttach enableSatNormalOnDetail enableSaving enableSentences enableSimulation ' + 'enableSimulationGlobal enableStamina enableTeamSwitch enableTraffic enableUAVConnectability ' + 'enableUAVWaypoints enableVehicleCargo enableVehicleSensor enableWeaponDisassembly ' + 'endLoadingScreen endMission engineOn enginesIsOnRTD enginesRpmRTD enginesTorqueRTD entities ' + 'environmentEnabled estimatedEndServerTime estimatedTimeLeft evalObjectArgument everyBackpack ' + 'everyContainer exec execEditorScript execFSM execVM exp expectedDestination exportJIPMessages ' + 'eyeDirection eyePos face faction fadeMusic fadeRadio fadeSound fadeSpeech failMission ' + 'fillWeaponsFromPool find findCover findDisplay findEditorObject findEmptyPosition ' + 'findEmptyPositionReady findIf findNearestEnemy finishMissionInit finite fire fireAtTarget ' + 'firstBackpack flag flagAnimationPhase flagOwner flagSide flagTexture fleeing floor flyInHeight ' + 'flyInHeightASL fog fogForecast fogParams forceAddUniform forcedMap forceEnd forceFlagTexture ' + 'forceFollowRoad forceMap forceRespawn forceSpeed forceWalk forceWeaponFire forceWeatherChange ' + 'forEachMember forEachMemberAgent forEachMemberTeam forgetTarget format formation ' + 'formationDirection formationLeader formationMembers formationPosition formationTask formatText ' + 'formLeader freeLook fromEditor fuel fullCrew gearIDCAmmoCount gearSlotAmmoCount gearSlotData ' + 'get3DENActionState get3DENAttribute get3DENCamera get3DENConnections get3DENEntity ' + 'get3DENEntityID get3DENGrid get3DENIconsVisible get3DENLayerEntities get3DENLinesVisible ' + 'get3DENMissionAttribute get3DENMouseOver get3DENSelected getAimingCoef getAllEnvSoundControllers ' + 'getAllHitPointsDamage getAllOwnedMines getAllSoundControllers getAmmoCargo getAnimAimPrecision ' + 'getAnimSpeedCoef getArray getArtilleryAmmo getArtilleryComputerSettings getArtilleryETA ' + 'getAssignedCuratorLogic getAssignedCuratorUnit getBackpackCargo getBleedingRemaining ' + 'getBurningValue getCameraViewDirection getCargoIndex getCenterOfMass getClientState ' + 'getClientStateNumber getCompatiblePylonMagazines getConnectedUAV getContainerMaxLoad ' + 'getCursorObjectParams getCustomAimCoef getDammage getDescription getDir getDirVisual ' + 'getDLCAssetsUsage getDLCAssetsUsageByName getDLCs getEditorCamera getEditorMode ' + 'getEditorObjectScope getElevationOffset getEnvSoundController getFatigue getForcedFlagTexture ' + 'getFriend getFSMVariable getFuelCargo getGroupIcon getGroupIconParams getGroupIcons getHideFrom ' + 'getHit getHitIndex getHitPointDamage getItemCargo getMagazineCargo getMarkerColor getMarkerPos ' + 'getMarkerSize getMarkerType getMass getMissionConfig getMissionConfigValue getMissionDLCs ' + 'getMissionLayerEntities getModelInfo getMousePosition getMusicPlayedTime getNumber ' + 'getObjectArgument getObjectChildren getObjectDLC getObjectMaterials getObjectProxy ' + 'getObjectTextures getObjectType getObjectViewDistance getOxygenRemaining getPersonUsedDLCs ' + 'getPilotCameraDirection getPilotCameraPosition getPilotCameraRotation getPilotCameraTarget ' + 'getPlateNumber getPlayerChannel getPlayerScores getPlayerUID getPos getPosASL getPosASLVisual ' + 'getPosASLW getPosATL getPosATLVisual getPosVisual getPosWorld getPylonMagazines getRelDir ' + 'getRelPos getRemoteSensorsDisabled getRepairCargo getResolution getShadowDistance getShotParents ' + 'getSlingLoad getSoundController getSoundControllerResult getSpeed getStamina getStatValue ' + 'getSuppression getTerrainGrid getTerrainHeightASL getText getTotalDLCUsageTime getUnitLoadout ' + 'getUnitTrait getUserMFDText getUserMFDvalue getVariable getVehicleCargo getWeaponCargo ' + 'getWeaponSway getWingsOrientationRTD getWingsPositionRTD getWPPos glanceAt globalChat globalRadio ' + 'goggles goto group groupChat groupFromNetId groupIconSelectable groupIconsVisible groupId ' + 'groupOwner groupRadio groupSelectedUnits groupSelectUnit gunner gusts halt handgunItems ' + 'handgunMagazine handgunWeapon handsHit hasInterface hasPilotCamera hasWeapon hcAllGroups ' + 'hcGroupParams hcLeader hcRemoveAllGroups hcRemoveGroup hcSelected hcSelectGroup hcSetGroup ' + 'hcShowBar hcShownBar headgear hideBody hideObject hideObjectGlobal hideSelection hint hintC ' + 'hintCadet hintSilent hmd hostMission htmlLoad HUDMovementLevels humidity image importAllGroups ' + 'importance in inArea inAreaArray incapacitatedState inflame inflamed infoPanel ' + 'infoPanelComponentEnabled infoPanelComponents infoPanels inGameUISetEventHandler inheritsFrom ' + 'initAmbientLife inPolygon inputAction inRangeOfArtillery insertEditorObject intersect is3DEN ' + 'is3DENMultiplayer isAbleToBreathe isAgent isArray isAutoHoverOn isAutonomous isAutotest ' + 'isBleeding isBurning isClass isCollisionLightOn isCopilotEnabled isDamageAllowed isDedicated ' + 'isDLCAvailable isEngineOn isEqualTo isEqualType isEqualTypeAll isEqualTypeAny isEqualTypeArray ' + 'isEqualTypeParams isFilePatchingEnabled isFlashlightOn isFlatEmpty isForcedWalk isFormationLeader ' + 'isGroupDeletedWhenEmpty isHidden isInRemainsCollector isInstructorFigureEnabled isIRLaserOn ' + 'isKeyActive isKindOf isLaserOn isLightOn isLocalized isManualFire isMarkedForCollection ' + 'isMultiplayer isMultiplayerSolo isNil isNull isNumber isObjectHidden isObjectRTD isOnRoad ' + 'isPipEnabled isPlayer isRealTime isRemoteExecuted isRemoteExecutedJIP isServer isShowing3DIcons ' + 'isSimpleObject isSprintAllowed isStaminaEnabled isSteamMission isStreamFriendlyUIEnabled isText ' + 'isTouchingGround isTurnedOut isTutHintsEnabled isUAVConnectable isUAVConnected isUIContext ' + 'isUniformAllowed isVehicleCargo isVehicleRadarOn isVehicleSensorEnabled isWalking ' + 'isWeaponDeployed isWeaponRested itemCargo items itemsWithMagazines join joinAs joinAsSilent ' + 'joinSilent joinString kbAddDatabase kbAddDatabaseTargets kbAddTopic kbHasTopic kbReact ' + 'kbRemoveTopic kbTell kbWasSaid keyImage keyName knowsAbout land landAt landResult language ' + 'laserTarget lbAdd lbClear lbColor lbColorRight lbCurSel lbData lbDelete lbIsSelected lbPicture ' + 'lbPictureRight lbSelection lbSetColor lbSetColorRight lbSetCurSel lbSetData lbSetPicture ' + 'lbSetPictureColor lbSetPictureColorDisabled lbSetPictureColorSelected lbSetPictureRight ' + 'lbSetPictureRightColor lbSetPictureRightColorDisabled lbSetPictureRightColorSelected ' + 'lbSetSelectColor lbSetSelectColorRight lbSetSelected lbSetText lbSetTextRight lbSetTooltip ' + 'lbSetValue lbSize lbSort lbSortByValue lbText lbTextRight lbValue leader leaderboardDeInit ' + 'leaderboardGetRows leaderboardInit leaderboardRequestRowsFriends leaderboardsRequestUploadScore ' + 'leaderboardsRequestUploadScoreKeepBest leaderboardState leaveVehicle libraryCredits ' + 'libraryDisclaimers lifeState lightAttachObject lightDetachObject lightIsOn lightnings limitSpeed ' + 'linearConversion lineIntersects lineIntersectsObjs lineIntersectsSurfaces lineIntersectsWith ' + 'linkItem list listObjects listRemoteTargets listVehicleSensors ln lnbAddArray lnbAddColumn ' + 'lnbAddRow lnbClear lnbColor lnbCurSelRow lnbData lnbDeleteColumn lnbDeleteRow ' + 'lnbGetColumnsPosition lnbPicture lnbSetColor lnbSetColumnsPos lnbSetCurSelRow lnbSetData ' + 'lnbSetPicture lnbSetText lnbSetValue lnbSize lnbSort lnbSortByValue lnbText lnbValue load loadAbs ' + 'loadBackpack loadFile loadGame loadIdentity loadMagazine loadOverlay loadStatus loadUniform ' + 'loadVest local localize locationPosition lock lockCameraTo lockCargo lockDriver locked ' + 'lockedCargo lockedDriver lockedTurret lockIdentity lockTurret lockWP log logEntities logNetwork ' + 'logNetworkTerminate lookAt lookAtPos magazineCargo magazines magazinesAllTurrets magazinesAmmo ' + 'magazinesAmmoCargo magazinesAmmoFull magazinesDetail magazinesDetailBackpack ' + 'magazinesDetailUniform magazinesDetailVest magazinesTurret magazineTurretAmmo mapAnimAdd ' + 'mapAnimClear mapAnimCommit mapAnimDone mapCenterOnCamera mapGridPosition markAsFinishedOnSteam ' + 'markerAlpha markerBrush markerColor markerDir markerPos markerShape markerSize markerText ' + 'markerType max members menuAction menuAdd menuChecked menuClear menuCollapse menuData menuDelete ' + 'menuEnable menuEnabled menuExpand menuHover menuPicture menuSetAction menuSetCheck menuSetData ' + 'menuSetPicture menuSetValue menuShortcut menuShortcutText menuSize menuSort menuText menuURL ' + 'menuValue min mineActive mineDetectedBy missionConfigFile missionDifficulty missionName ' + 'missionNamespace missionStart missionVersion mod modelToWorld modelToWorldVisual ' + 'modelToWorldVisualWorld modelToWorldWorld modParams moonIntensity moonPhase morale move ' + 'move3DENCamera moveInAny moveInCargo moveInCommander moveInDriver moveInGunner moveInTurret ' + 'moveObjectToEnd moveOut moveTime moveTo moveToCompleted moveToFailed musicVolume name nameSound ' + 'nearEntities nearestBuilding nearestLocation nearestLocations nearestLocationWithDubbing ' + 'nearestObject nearestObjects nearestTerrainObjects nearObjects nearObjectsReady nearRoads ' + 'nearSupplies nearTargets needReload netId netObjNull newOverlay nextMenuItemIndex ' + 'nextWeatherChange nMenuItems not numberOfEnginesRTD numberToDate objectCurators objectFromNetId ' + 'objectParent objStatus onBriefingGroup onBriefingNotes onBriefingPlan onBriefingTeamSwitch ' + 'onCommandModeChanged onDoubleClick onEachFrame onGroupIconClick onGroupIconOverEnter ' + 'onGroupIconOverLeave onHCGroupSelectionChanged onMapSingleClick onPlayerConnected ' + 'onPlayerDisconnected onPreloadFinished onPreloadStarted onShowNewObject onTeamSwitch ' + 'openCuratorInterface openDLCPage openMap openSteamApp openYoutubeVideo or orderGetIn overcast ' + 'overcastForecast owner param params parseNumber parseSimpleArray parseText parsingNamespace ' + 'particlesQuality pickWeaponPool pitch pixelGrid pixelGridBase pixelGridNoUIScale pixelH pixelW ' + 'playableSlotsNumber playableUnits playAction playActionNow player playerRespawnTime playerSide ' + 'playersNumber playGesture playMission playMove playMoveNow playMusic playScriptedMission ' + 'playSound playSound3D position positionCameraToWorld posScreenToWorld posWorldToScreen ' + 'ppEffectAdjust ppEffectCommit ppEffectCommitted ppEffectCreate ppEffectDestroy ppEffectEnable ' + 'ppEffectEnabled ppEffectForceInNVG precision preloadCamera preloadObject preloadSound ' + 'preloadTitleObj preloadTitleRsc preprocessFile preprocessFileLineNumbers primaryWeapon ' + 'primaryWeaponItems primaryWeaponMagazine priority processDiaryLink productVersion profileName ' + 'profileNamespace profileNameSteam progressLoadingScreen progressPosition progressSetPosition ' + 'publicVariable publicVariableClient publicVariableServer pushBack pushBackUnique putWeaponPool ' + 'queryItemsPool queryMagazinePool queryWeaponPool rad radioChannelAdd radioChannelCreate ' + 'radioChannelRemove radioChannelSetCallSign radioChannelSetLabel radioVolume rain rainbow random ' + 'rank rankId rating rectangular registeredTasks registerTask reload reloadEnabled remoteControl ' + 'remoteExec remoteExecCall remoteExecutedOwner remove3DENConnection remove3DENEventHandler ' + 'remove3DENLayer removeAction removeAll3DENEventHandlers removeAllActions removeAllAssignedItems ' + 'removeAllContainers removeAllCuratorAddons removeAllCuratorCameraAreas ' + 'removeAllCuratorEditingAreas removeAllEventHandlers removeAllHandgunItems removeAllItems ' + 'removeAllItemsWithMagazines removeAllMissionEventHandlers removeAllMPEventHandlers ' + 'removeAllMusicEventHandlers removeAllOwnedMines removeAllPrimaryWeaponItems removeAllWeapons ' + 'removeBackpack removeBackpackGlobal removeCuratorAddons removeCuratorCameraArea ' + 'removeCuratorEditableObjects removeCuratorEditingArea removeDrawIcon removeDrawLinks ' + 'removeEventHandler removeFromRemainsCollector removeGoggles removeGroupIcon removeHandgunItem ' + 'removeHeadgear removeItem removeItemFromBackpack removeItemFromUniform removeItemFromVest ' + 'removeItems removeMagazine removeMagazineGlobal removeMagazines removeMagazinesTurret ' + 'removeMagazineTurret removeMenuItem removeMissionEventHandler removeMPEventHandler ' + 'removeMusicEventHandler removeOwnedMine removePrimaryWeaponItem removeSecondaryWeaponItem ' + 'removeSimpleTask removeSwitchableUnit removeTeamMember removeUniform removeVest removeWeapon ' + 'removeWeaponAttachmentCargo removeWeaponCargo removeWeaponGlobal removeWeaponTurret ' + 'reportRemoteTarget requiredVersion resetCamShake resetSubgroupDirection resize resources ' + 'respawnVehicle restartEditorCamera reveal revealMine reverse reversedMouseY roadAt ' + 'roadsConnectedTo roleDescription ropeAttachedObjects ropeAttachedTo ropeAttachEnabled ' + 'ropeAttachTo ropeCreate ropeCut ropeDestroy ropeDetach ropeEndPosition ropeLength ropes ' + 'ropeUnwind ropeUnwound rotorsForcesRTD rotorsRpmRTD round runInitScript safeZoneH safeZoneW ' + 'safeZoneWAbs safeZoneX safeZoneXAbs safeZoneY save3DENInventory saveGame saveIdentity ' + 'saveJoysticks saveOverlay saveProfileNamespace saveStatus saveVar savingEnabled say say2D say3D ' + 'scopeName score scoreSide screenshot screenToWorld scriptDone scriptName scudState ' + 'secondaryWeapon secondaryWeaponItems secondaryWeaponMagazine select selectBestPlaces ' + 'selectDiarySubject selectedEditorObjects selectEditorObject selectionNames selectionPosition ' + 'selectLeader selectMax selectMin selectNoPlayer selectPlayer selectRandom selectRandomWeighted ' + 'selectWeapon selectWeaponTurret sendAUMessage sendSimpleCommand sendTask sendTaskResult ' + 'sendUDPMessage serverCommand serverCommandAvailable serverCommandExecutable serverName serverTime ' + 'set set3DENAttribute set3DENAttributes set3DENGrid set3DENIconsVisible set3DENLayer ' + 'set3DENLinesVisible set3DENLogicType set3DENMissionAttribute set3DENMissionAttributes ' + 'set3DENModelsVisible set3DENObjectType set3DENSelected setAccTime setActualCollectiveRTD ' + 'setAirplaneThrottle setAirportSide setAmmo setAmmoCargo setAmmoOnPylon setAnimSpeedCoef ' + 'setAperture setApertureNew setArmoryPoints setAttributes setAutonomous setBehaviour ' + 'setBleedingRemaining setBrakesRTD setCameraInterest setCamShakeDefParams setCamShakeParams ' + 'setCamUseTI setCaptive setCenterOfMass setCollisionLight setCombatMode setCompassOscillation ' + 'setConvoySeparation setCuratorCameraAreaCeiling setCuratorCoef setCuratorEditingAreaType ' + 'setCuratorWaypointCost setCurrentChannel setCurrentTask setCurrentWaypoint setCustomAimCoef ' + 'setCustomWeightRTD setDamage setDammage setDate setDebriefingText setDefaultCamera setDestination ' + 'setDetailMapBlendPars setDir setDirection setDrawIcon setDriveOnPath setDropInterval ' + 'setDynamicSimulationDistance setDynamicSimulationDistanceCoef setEditorMode setEditorObjectScope ' + 'setEffectCondition setEngineRPMRTD setFace setFaceAnimation setFatigue setFeatureType ' + 'setFlagAnimationPhase setFlagOwner setFlagSide setFlagTexture setFog setFormation ' + 'setFormationTask setFormDir setFriend setFromEditor setFSMVariable setFuel setFuelCargo ' + 'setGroupIcon setGroupIconParams setGroupIconsSelectable setGroupIconsVisible setGroupId ' + 'setGroupIdGlobal setGroupOwner setGusts setHideBehind setHit setHitIndex setHitPointDamage ' + 'setHorizonParallaxCoef setHUDMovementLevels setIdentity setImportance setInfoPanel setLeader ' + 'setLightAmbient setLightAttenuation setLightBrightness setLightColor setLightDayLight ' + 'setLightFlareMaxDistance setLightFlareSize setLightIntensity setLightnings setLightUseFlare ' + 'setLocalWindParams setMagazineTurretAmmo setMarkerAlpha setMarkerAlphaLocal setMarkerBrush ' + 'setMarkerBrushLocal setMarkerColor setMarkerColorLocal setMarkerDir setMarkerDirLocal ' + 'setMarkerPos setMarkerPosLocal setMarkerShape setMarkerShapeLocal setMarkerSize ' + 'setMarkerSizeLocal setMarkerText setMarkerTextLocal setMarkerType setMarkerTypeLocal setMass ' + 'setMimic setMousePosition setMusicEffect setMusicEventHandler setName setNameSound ' + 'setObjectArguments setObjectMaterial setObjectMaterialGlobal setObjectProxy setObjectTexture ' + 'setObjectTextureGlobal setObjectViewDistance setOvercast setOwner setOxygenRemaining ' + 'setParticleCircle setParticleClass setParticleFire setParticleParams setParticleRandom ' + 'setPilotCameraDirection setPilotCameraRotation setPilotCameraTarget setPilotLight setPiPEffect ' + 'setPitch setPlateNumber setPlayable setPlayerRespawnTime setPos setPosASL setPosASL2 setPosASLW ' + 'setPosATL setPosition setPosWorld setPylonLoadOut setPylonsPriority setRadioMsg setRain ' + 'setRainbow setRandomLip setRank setRectangular setRepairCargo setRotorBrakeRTD setShadowDistance ' + 'setShotParents setSide setSimpleTaskAlwaysVisible setSimpleTaskCustomData ' + 'setSimpleTaskDescription setSimpleTaskDestination setSimpleTaskTarget setSimpleTaskType ' + 'setSimulWeatherLayers setSize setSkill setSlingLoad setSoundEffect setSpeaker setSpeech ' + 'setSpeedMode setStamina setStaminaScheme setStatValue setSuppression setSystemOfUnits ' + 'setTargetAge setTaskMarkerOffset setTaskResult setTaskState setTerrainGrid setText ' + 'setTimeMultiplier setTitleEffect setTrafficDensity setTrafficDistance setTrafficGap ' + 'setTrafficSpeed setTriggerActivation setTriggerArea setTriggerStatements setTriggerText ' + 'setTriggerTimeout setTriggerType setType setUnconscious setUnitAbility setUnitLoadout setUnitPos ' + 'setUnitPosWeak setUnitRank setUnitRecoilCoefficient setUnitTrait setUnloadInCombat ' + 'setUserActionText setUserMFDText setUserMFDvalue setVariable setVectorDir setVectorDirAndUp ' + 'setVectorUp setVehicleAmmo setVehicleAmmoDef setVehicleArmor setVehicleCargo setVehicleId ' + 'setVehicleLock setVehiclePosition setVehicleRadar setVehicleReceiveRemoteTargets ' + 'setVehicleReportOwnPosition setVehicleReportRemoteTargets setVehicleTIPars setVehicleVarName ' + 'setVelocity setVelocityModelSpace setVelocityTransformation setViewDistance ' + 'setVisibleIfTreeCollapsed setWantedRPMRTD setWaves setWaypointBehaviour setWaypointCombatMode ' + 'setWaypointCompletionRadius setWaypointDescription setWaypointForceBehaviour setWaypointFormation ' + 'setWaypointHousePosition setWaypointLoiterRadius setWaypointLoiterType setWaypointName ' + 'setWaypointPosition setWaypointScript setWaypointSpeed setWaypointStatements setWaypointTimeout ' + 'setWaypointType setWaypointVisible setWeaponReloadingTime setWind setWindDir setWindForce ' + 'setWindStr setWingForceScaleRTD setWPPos show3DIcons showChat showCinemaBorder showCommandingMenu ' + 'showCompass showCuratorCompass showGPS showHUD showLegend showMap shownArtilleryComputer ' + 'shownChat shownCompass shownCuratorCompass showNewEditorObject shownGPS shownHUD shownMap ' + 'shownPad shownRadio shownScoretable shownUAVFeed shownWarrant shownWatch showPad showRadio ' + 'showScoretable showSubtitles showUAVFeed showWarrant showWatch showWaypoint showWaypoints side ' + 'sideChat sideEnemy sideFriendly sideRadio simpleTasks simulationEnabled simulCloudDensity ' + 'simulCloudOcclusion simulInClouds simulWeatherSync sin size sizeOf skill skillFinal skipTime ' + 'sleep sliderPosition sliderRange sliderSetPosition sliderSetRange sliderSetSpeed sliderSpeed ' + 'slingLoadAssistantShown soldierMagazines someAmmo sort soundVolume spawn speaker speed speedMode ' + 'splitString sqrt squadParams stance startLoadingScreen step stop stopEngineRTD stopped str ' + 'sunOrMoon supportInfo suppressFor surfaceIsWater surfaceNormal surfaceType swimInDepth ' + 'switchableUnits switchAction switchCamera switchGesture switchLight switchMove ' + 'synchronizedObjects synchronizedTriggers synchronizedWaypoints synchronizeObjectsAdd ' + 'synchronizeObjectsRemove synchronizeTrigger synchronizeWaypoint systemChat systemOfUnits tan ' + 'targetKnowledge targets targetsAggregate targetsQuery taskAlwaysVisible taskChildren ' + 'taskCompleted taskCustomData taskDescription taskDestination taskHint taskMarkerOffset taskParent ' + 'taskResult taskState taskType teamMember teamName teams teamSwitch teamSwitchEnabled teamType ' + 'terminate terrainIntersect terrainIntersectASL terrainIntersectAtASL text textLog textLogFormat ' + 'tg time timeMultiplier titleCut titleFadeOut titleObj titleRsc titleText toArray toFixed toLower ' + 'toString toUpper triggerActivated triggerActivation triggerArea triggerAttachedVehicle ' + 'triggerAttachObject triggerAttachVehicle triggerDynamicSimulation triggerStatements triggerText ' + 'triggerTimeout triggerTimeoutCurrent triggerType turretLocal turretOwner turretUnit tvAdd tvClear ' + 'tvCollapse tvCollapseAll tvCount tvCurSel tvData tvDelete tvExpand tvExpandAll tvPicture ' + 'tvSetColor tvSetCurSel tvSetData tvSetPicture tvSetPictureColor tvSetPictureColorDisabled ' + 'tvSetPictureColorSelected tvSetPictureRight tvSetPictureRightColor tvSetPictureRightColorDisabled ' + 'tvSetPictureRightColorSelected tvSetText tvSetTooltip tvSetValue tvSort tvSortByValue tvText ' + 'tvTooltip tvValue type typeName typeOf UAVControl uiNamespace uiSleep unassignCurator ' + 'unassignItem unassignTeam unassignVehicle underwater uniform uniformContainer uniformItems ' + 'uniformMagazines unitAddons unitAimPosition unitAimPositionVisual unitBackpack unitIsUAV unitPos ' + 'unitReady unitRecoilCoefficient units unitsBelowHeight unlinkItem unlockAchievement ' + 'unregisterTask updateDrawIcon updateMenuItem updateObjectTree useAISteeringComponent ' + 'useAudioTimeForMoves userInputDisabled vectorAdd vectorCos vectorCrossProduct vectorDiff ' + 'vectorDir vectorDirVisual vectorDistance vectorDistanceSqr vectorDotProduct vectorFromTo ' + 'vectorMagnitude vectorMagnitudeSqr vectorModelToWorld vectorModelToWorldVisual vectorMultiply ' + 'vectorNormalized vectorUp vectorUpVisual vectorWorldToModel vectorWorldToModelVisual vehicle ' + 'vehicleCargoEnabled vehicleChat vehicleRadio vehicleReceiveRemoteTargets vehicleReportOwnPosition ' + 'vehicleReportRemoteTargets vehicles vehicleVarName velocity velocityModelSpace verifySignature ' + 'vest vestContainer vestItems vestMagazines viewDistance visibleCompass visibleGPS visibleMap ' + 'visiblePosition visiblePositionASL visibleScoretable visibleWatch waves waypointAttachedObject ' + 'waypointAttachedVehicle waypointAttachObject waypointAttachVehicle waypointBehaviour ' + 'waypointCombatMode waypointCompletionRadius waypointDescription waypointForceBehaviour ' + 'waypointFormation waypointHousePosition waypointLoiterRadius waypointLoiterType waypointName ' + 'waypointPosition waypoints waypointScript waypointsEnabledUAV waypointShow waypointSpeed ' + 'waypointStatements waypointTimeout waypointTimeoutCurrent waypointType waypointVisible ' + 'weaponAccessories weaponAccessoriesCargo weaponCargo weaponDirection weaponInertia weaponLowered ' + 'weapons weaponsItems weaponsItemsCargo weaponState weaponsTurret weightRTD WFSideText wind ',
      literal: 'blufor civilian configNull controlNull displayNull east endl false grpNull independent lineBreak ' + 'locationNull nil objNull opfor pi resistance scriptNull sideAmbientLife sideEmpty sideLogic ' + 'sideUnknown taskNull teamMemberNull true west'
    },
    contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.NUMBER_MODE, VARIABLE, FUNCTION, STRINGS, PREPROCESSOR],
    illegal: /#|^\$ /
  };
}
module.exports = sqf;

/***/ }),

/***/ 69703:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(57327);
__webpack_require__(92222);
__webpack_require__(26699);
__webpack_require__(74916);
__webpack_require__(4723);
__webpack_require__(32023);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */
function either() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var joined = '(' + args.map(function (x) {
    return source(x);
  }).join("|") + ")";
  return joined;
}

/*
 Language: SQL
 Website: https://en.wikipedia.org/wiki/SQL
 Category: common, database
 */

function sql(hljs) {
  var COMMENT_MODE = hljs.COMMENT('--', '$');
  var STRING = {
    className: 'string',
    variants: [{
      begin: /'/,
      end: /'/,
      contains: [{
        begin: /''/
      }]
    }]
  };
  var QUOTED_IDENTIFIER = {
    begin: /"/,
    end: /"/,
    contains: [{
      begin: /""/
    }]
  };
  var LITERALS = ["true", "false",
  // Not sure it's correct to call NULL literal, and clauses like IS [NOT] NULL look strange that way.
  // "null",
  "unknown"];
  var MULTI_WORD_TYPES = ["double precision", "large object", "with timezone", "without timezone"];
  var TYPES = ['bigint', 'binary', 'blob', 'boolean', 'char', 'character', 'clob', 'date', 'dec', 'decfloat', 'decimal', 'float', 'int', 'integer', 'interval', 'nchar', 'nclob', 'national', 'numeric', 'real', 'row', 'smallint', 'time', 'timestamp', 'varchar', 'varying',
  // modifier (character varying)
  'varbinary'];
  var NON_RESERVED_WORDS = ["add", "asc", "collation", "desc", "final", "first", "last", "view"];

  // https://jakewheat.github.io/sql-overview/sql-2016-foundation-grammar.html#reserved-word
  var RESERVED_WORDS = ["abs", "acos", "all", "allocate", "alter", "and", "any", "are", "array", "array_agg", "array_max_cardinality", "as", "asensitive", "asin", "asymmetric", "at", "atan", "atomic", "authorization", "avg", "begin", "begin_frame", "begin_partition", "between", "bigint", "binary", "blob", "boolean", "both", "by", "call", "called", "cardinality", "cascaded", "case", "cast", "ceil", "ceiling", "char", "char_length", "character", "character_length", "check", "classifier", "clob", "close", "coalesce", "collate", "collect", "column", "commit", "condition", "connect", "constraint", "contains", "convert", "copy", "corr", "corresponding", "cos", "cosh", "count", "covar_pop", "covar_samp", "create", "cross", "cube", "cume_dist", "current", "current_catalog", "current_date", "current_default_transform_group", "current_path", "current_role", "current_row", "current_schema", "current_time", "current_timestamp", "current_path", "current_role", "current_transform_group_for_type", "current_user", "cursor", "cycle", "date", "day", "deallocate", "dec", "decimal", "decfloat", "declare", "default", "define", "delete", "dense_rank", "deref", "describe", "deterministic", "disconnect", "distinct", "double", "drop", "dynamic", "each", "element", "else", "empty", "end", "end_frame", "end_partition", "end-exec", "equals", "escape", "every", "except", "exec", "execute", "exists", "exp", "external", "extract", "false", "fetch", "filter", "first_value", "float", "floor", "for", "foreign", "frame_row", "free", "from", "full", "function", "fusion", "get", "global", "grant", "group", "grouping", "groups", "having", "hold", "hour", "identity", "in", "indicator", "initial", "inner", "inout", "insensitive", "insert", "int", "integer", "intersect", "intersection", "interval", "into", "is", "join", "json_array", "json_arrayagg", "json_exists", "json_object", "json_objectagg", "json_query", "json_table", "json_table_primitive", "json_value", "lag", "language", "large", "last_value", "lateral", "lead", "leading", "left", "like", "like_regex", "listagg", "ln", "local", "localtime", "localtimestamp", "log", "log10", "lower", "match", "match_number", "match_recognize", "matches", "max", "member", "merge", "method", "min", "minute", "mod", "modifies", "module", "month", "multiset", "national", "natural", "nchar", "nclob", "new", "no", "none", "normalize", "not", "nth_value", "ntile", "null", "nullif", "numeric", "octet_length", "occurrences_regex", "of", "offset", "old", "omit", "on", "one", "only", "open", "or", "order", "out", "outer", "over", "overlaps", "overlay", "parameter", "partition", "pattern", "per", "percent", "percent_rank", "percentile_cont", "percentile_disc", "period", "portion", "position", "position_regex", "power", "precedes", "precision", "prepare", "primary", "procedure", "ptf", "range", "rank", "reads", "real", "recursive", "ref", "references", "referencing", "regr_avgx", "regr_avgy", "regr_count", "regr_intercept", "regr_r2", "regr_slope", "regr_sxx", "regr_sxy", "regr_syy", "release", "result", "return", "returns", "revoke", "right", "rollback", "rollup", "row", "row_number", "rows", "running", "savepoint", "scope", "scroll", "search", "second", "seek", "select", "sensitive", "session_user", "set", "show", "similar", "sin", "sinh", "skip", "smallint", "some", "specific", "specifictype", "sql", "sqlexception", "sqlstate", "sqlwarning", "sqrt", "start", "static", "stddev_pop", "stddev_samp", "submultiset", "subset", "substring", "substring_regex", "succeeds", "sum", "symmetric", "system", "system_time", "system_user", "table", "tablesample", "tan", "tanh", "then", "time", "timestamp", "timezone_hour", "timezone_minute", "to", "trailing", "translate", "translate_regex", "translation", "treat", "trigger", "trim", "trim_array", "true", "truncate", "uescape", "union", "unique", "unknown", "unnest", "update   ", "upper", "user", "using", "value", "values", "value_of", "var_pop", "var_samp", "varbinary", "varchar", "varying", "versioning", "when", "whenever", "where", "width_bucket", "window", "with", "within", "without", "year"];

  // these are reserved words we have identified to be functions
  // and should only be highlighted in a dispatch-like context
  // ie, array_agg(...), etc.
  var RESERVED_FUNCTIONS = ["abs", "acos", "array_agg", "asin", "atan", "avg", "cast", "ceil", "ceiling", "coalesce", "corr", "cos", "cosh", "count", "covar_pop", "covar_samp", "cume_dist", "dense_rank", "deref", "element", "exp", "extract", "first_value", "floor", "json_array", "json_arrayagg", "json_exists", "json_object", "json_objectagg", "json_query", "json_table", "json_table_primitive", "json_value", "lag", "last_value", "lead", "listagg", "ln", "log", "log10", "lower", "max", "min", "mod", "nth_value", "ntile", "nullif", "percent_rank", "percentile_cont", "percentile_disc", "position", "position_regex", "power", "rank", "regr_avgx", "regr_avgy", "regr_count", "regr_intercept", "regr_r2", "regr_slope", "regr_sxx", "regr_sxy", "regr_syy", "row_number", "sin", "sinh", "sqrt", "stddev_pop", "stddev_samp", "substring", "substring_regex", "sum", "tan", "tanh", "translate", "translate_regex", "treat", "trim", "trim_array", "unnest", "upper", "value_of", "var_pop", "var_samp", "width_bucket"];

  // these functions can
  var POSSIBLE_WITHOUT_PARENS = ["current_catalog", "current_date", "current_default_transform_group", "current_path", "current_role", "current_schema", "current_transform_group_for_type", "current_user", "session_user", "system_time", "system_user", "current_time", "localtime", "current_timestamp", "localtimestamp"];

  // those exist to boost relevance making these very
  // "SQL like" keyword combos worth +1 extra relevance
  var COMBOS = ["create table", "insert into", "primary key", "foreign key", "not null", "alter table", "add constraint", "grouping sets", "on overflow", "character set", "respect nulls", "ignore nulls", "nulls first", "nulls last", "depth first", "breadth first"];
  var FUNCTIONS = RESERVED_FUNCTIONS;
  var KEYWORDS = [].concat(RESERVED_WORDS, NON_RESERVED_WORDS).filter(function (keyword) {
    return !RESERVED_FUNCTIONS.includes(keyword);
  });
  var VARIABLE = {
    className: "variable",
    begin: /@[a-z0-9]+/
  };
  var OPERATOR = {
    className: "operator",
    begin: /[-+*/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?/,
    relevance: 0
  };
  var FUNCTION_CALL = {
    begin: concat(/\b/, either.apply(void 0, FUNCTIONS), /\s*\(/),
    keywords: {
      built_in: FUNCTIONS
    }
  };

  // keywords with less than 3 letters are reduced in relevancy
  function reduceRelevancy(list) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      exceptions = _ref.exceptions,
      when = _ref.when;
    var qualifyFn = when;
    exceptions = exceptions || [];
    return list.map(function (item) {
      if (item.match(/\|\d+$/) || exceptions.includes(item)) {
        return item;
      } else if (qualifyFn(item)) {
        return "".concat(item, "|0");
      } else {
        return item;
      }
    });
  }
  return {
    name: 'SQL',
    case_insensitive: true,
    // does not include {} or HTML tags `</`
    illegal: /[{}]|<\//,
    keywords: {
      $pattern: /\b[\w\.]+/,
      keyword: reduceRelevancy(KEYWORDS, {
        when: function when(x) {
          return x.length < 3;
        }
      }),
      literal: LITERALS,
      type: TYPES,
      built_in: POSSIBLE_WITHOUT_PARENS
    },
    contains: [{
      begin: either.apply(void 0, COMBOS),
      keywords: {
        $pattern: /[\w\.]+/,
        keyword: KEYWORDS.concat(COMBOS),
        literal: LITERALS,
        type: TYPES
      }
    }, {
      className: "type",
      begin: either.apply(void 0, MULTI_WORD_TYPES)
    }, FUNCTION_CALL, VARIABLE, STRING, QUOTED_IDENTIFIER, hljs.C_NUMBER_MODE, hljs.C_BLOCK_COMMENT_MODE, COMMENT_MODE, OPERATOR]
  };
}
module.exports = sql;

/***/ }),

/***/ 31731:
/***/ ((module) => {

/*
 Language: SQL More (mix of MySQL, Oracle, etc)
 Contributors: Nikolay Lisienko <info@neor.ru>, Heiko August <post@auge8472.de>, Travis Odom <travis.a.odom@gmail.com>, Vadimtro <vadimtro@yahoo.com>, Benjamin Auder <benjamin.auder@gmail.com>
 Website: https://en.wikipedia.org/wiki/SQL
 Category: database
 */

/*

This is a preservation of the old bloated SQL grammar which includes pretty much
the kitchen sink because no one was keeping track of which keywords belong to
which databases.  This is likely to be removed in the future.

- Oracle SQL should be factored into it's own 3rd party grammar.
- MySQL should be factored out into it's own 3rd party grammar.

*/

function sql_more(hljs) {
  var COMMENT_MODE = hljs.COMMENT('--', '$');
  return {
    name: 'SQL (more)',
    aliases: ["mysql", "oracle"],
    disableAutodetect: true,
    case_insensitive: true,
    illegal: /[<>{}*]/,
    contains: [{
      beginKeywords: 'begin end start commit rollback savepoint lock alter create drop rename call ' + 'delete do handler insert load replace select truncate update set show pragma grant ' + 'merge describe use explain help declare prepare execute deallocate release ' + 'unlock purge reset change stop analyze cache flush optimize repair kill ' + 'install uninstall checksum restore check backup revoke comment values with',
      end: /;/,
      endsWithParent: true,
      keywords: {
        $pattern: /[\w\.]+/,
        keyword: 'as abort abs absolute acc acce accep accept access accessed accessible account acos action activate add ' + 'addtime admin administer advanced advise aes_decrypt aes_encrypt after agent aggregate ali alia alias ' + 'all allocate allow alter always analyze ancillary and anti any anydata anydataset anyschema anytype apply ' + 'archive archived archivelog are as asc ascii asin assembly assertion associate asynchronous at atan ' + 'atn2 attr attri attrib attribu attribut attribute attributes audit authenticated authentication authid ' + 'authors auto autoallocate autodblink autoextend automatic availability avg backup badfile basicfile ' + 'before begin beginning benchmark between bfile bfile_base big bigfile bin binary_double binary_float ' + 'binlog bit_and bit_count bit_length bit_or bit_xor bitmap blob_base block blocksize body both bound ' + 'bucket buffer_cache buffer_pool build bulk by byte byteordermark bytes cache caching call calling cancel ' + 'capacity cascade cascaded case cast catalog category ceil ceiling chain change changed char_base ' + 'char_length character_length characters characterset charindex charset charsetform charsetid check ' + 'checksum checksum_agg child choose chr chunk class cleanup clear client clob clob_base clone close ' + 'cluster_id cluster_probability cluster_set clustering coalesce coercibility col collate collation ' + 'collect colu colum column column_value columns columns_updated comment commit compact compatibility ' + 'compiled complete composite_limit compound compress compute concat concat_ws concurrent confirm conn ' + 'connec connect connect_by_iscycle connect_by_isleaf connect_by_root connect_time connection ' + 'consider consistent constant constraint constraints constructor container content contents context ' + 'contributors controlfile conv convert convert_tz corr corr_k corr_s corresponding corruption cos cost ' + 'count count_big counted covar_pop covar_samp cpu_per_call cpu_per_session crc32 create creation ' + 'critical cross cube cume_dist curdate current current_date current_time current_timestamp current_user ' + 'cursor curtime customdatum cycle data database databases datafile datafiles datalength date_add ' + 'date_cache date_format date_sub dateadd datediff datefromparts datename datepart datetime2fromparts ' + 'day day_to_second dayname dayofmonth dayofweek dayofyear days db_role_change dbtimezone ddl deallocate ' + 'declare decode decompose decrement decrypt deduplicate def defa defau defaul default defaults ' + 'deferred defi defin define degrees delayed delegate delete delete_all delimited demand dense_rank ' + 'depth dequeue des_decrypt des_encrypt des_key_file desc descr descri describ describe descriptor ' + 'deterministic diagnostics difference dimension direct_load directory disable disable_all ' + 'disallow disassociate discardfile disconnect diskgroup distinct distinctrow distribute distributed div ' + 'do document domain dotnet double downgrade drop dumpfile duplicate duration each edition editionable ' + 'editions element ellipsis else elsif elt empty enable enable_all enclosed encode encoding encrypt ' + 'end end-exec endian enforced engine engines enqueue enterprise entityescaping eomonth error errors ' + 'escaped evalname evaluate event eventdata events except exception exceptions exchange exclude excluding ' + 'execu execut execute exempt exists exit exp expire explain explode export export_set extended extent external ' + 'external_1 external_2 externally extract failed failed_login_attempts failover failure far fast ' + 'feature_set feature_value fetch field fields file file_name_convert filesystem_like_logging final ' + 'finish first first_value fixed flash_cache flashback floor flush following follows for forall force foreign ' + 'form forma format found found_rows freelist freelists freepools fresh from from_base64 from_days ' + 'ftp full function general generated get get_format get_lock getdate getutcdate global global_name ' + 'globally go goto grant grants greatest group group_concat group_id grouping grouping_id groups ' + 'gtid_subtract guarantee guard handler hash hashkeys having hea head headi headin heading heap help hex ' + 'hierarchy high high_priority hosts hour hours http id ident_current ident_incr ident_seed identified ' + 'identity idle_time if ifnull ignore iif ilike ilm immediate import in include including increment ' + 'index indexes indexing indextype indicator indices inet6_aton inet6_ntoa inet_aton inet_ntoa infile ' + 'initial initialized initially initrans inmemory inner innodb input insert install instance instantiable ' + 'instr interface interleaved intersect into invalidate invisible is is_free_lock is_ipv4 is_ipv4_compat ' + 'is_not is_not_null is_used_lock isdate isnull isolation iterate java join json json_exists ' + 'keep keep_duplicates key keys kill language large last last_day last_insert_id last_value lateral lax lcase ' + 'lead leading least leaves left len lenght length less level levels library like like2 like4 likec limit ' + 'lines link list listagg little ln load load_file lob lobs local localtime localtimestamp locate ' + 'locator lock locked log log10 log2 logfile logfiles logging logical logical_reads_per_call ' + 'logoff logon logs long loop low low_priority lower lpad lrtrim ltrim main make_set makedate maketime ' + 'managed management manual map mapping mask master master_pos_wait match matched materialized max ' + 'maxextents maximize maxinstances maxlen maxlogfiles maxloghistory maxlogmembers maxsize maxtrans ' + 'md5 measures median medium member memcompress memory merge microsecond mid migration min minextents ' + 'minimum mining minus minute minutes minvalue missing mod mode model modification modify module monitoring month ' + 'months mount move movement multiset mutex name name_const names nan national native natural nav nchar ' + 'nclob nested never new newline next nextval no no_write_to_binlog noarchivelog noaudit nobadfile ' + 'nocheck nocompress nocopy nocycle nodelay nodiscardfile noentityescaping noguarantee nokeep nologfile ' + 'nomapping nomaxvalue nominimize nominvalue nomonitoring none noneditionable nonschema noorder ' + 'nopr nopro noprom nopromp noprompt norely noresetlogs noreverse normal norowdependencies noschemacheck ' + 'noswitch not nothing notice notnull notrim novalidate now nowait nth_value nullif nulls num numb numbe ' + 'nvarchar nvarchar2 object ocicoll ocidate ocidatetime ociduration ociinterval ociloblocator ocinumber ' + 'ociref ocirefcursor ocirowid ocistring ocitype oct octet_length of off offline offset oid oidindex old ' + 'on online only opaque open operations operator optimal optimize option optionally or oracle oracle_date ' + 'oradata ord ordaudio orddicom orddoc order ordimage ordinality ordvideo organization orlany orlvary ' + 'out outer outfile outline output over overflow overriding package pad parallel parallel_enable ' + 'parameters parent parse partial partition partitions pascal passing password password_grace_time ' + 'password_lock_time password_reuse_max password_reuse_time password_verify_function patch path patindex ' + 'pctincrease pctthreshold pctused pctversion percent percent_rank percentile_cont percentile_disc ' + 'performance period period_add period_diff permanent physical pi pipe pipelined pivot pluggable plugin ' + 'policy position post_transaction pow power pragma prebuilt precedes preceding precision prediction ' + 'prediction_cost prediction_details prediction_probability prediction_set prepare present preserve ' + 'prior priority private private_sga privileges procedural procedure procedure_analyze processlist ' + 'profiles project prompt protection public publishingservername purge quarter query quick quiesce quota ' + 'quotename radians raise rand range rank raw read reads readsize rebuild record records ' + 'recover recovery recursive recycle redo reduced ref reference referenced references referencing refresh ' + 'regexp_like register regr_avgx regr_avgy regr_count regr_intercept regr_r2 regr_slope regr_sxx regr_sxy ' + 'reject rekey relational relative relaylog release release_lock relies_on relocate rely rem remainder rename ' + 'repair repeat replace replicate replication required reset resetlogs resize resource respect restore ' + 'restricted result result_cache resumable resume retention return returning returns reuse reverse revoke ' + 'right rlike role roles rollback rolling rollup round row row_count rowdependencies rowid rownum rows ' + 'rtrim rules safe salt sample save savepoint sb1 sb2 sb4 scan schema schemacheck scn scope scroll ' + 'sdo_georaster sdo_topo_geometry search sec_to_time second seconds section securefile security seed segment select ' + 'self semi sequence sequential serializable server servererror session session_user sessions_per_user set ' + 'sets settings sha sha1 sha2 share shared shared_pool short show shrink shutdown si_averagecolor ' + 'si_colorhistogram si_featurelist si_positionalcolor si_stillimage si_texture siblings sid sign sin ' + 'size size_t sizes skip slave sleep smalldatetimefromparts smallfile snapshot some soname sort soundex ' + 'source space sparse spfile split sql sql_big_result sql_buffer_result sql_cache sql_calc_found_rows ' + 'sql_small_result sql_variant_property sqlcode sqldata sqlerror sqlname sqlstate sqrt square standalone ' + 'standby start starting startup statement static statistics stats_binomial_test stats_crosstab ' + 'stats_ks_test stats_mode stats_mw_test stats_one_way_anova stats_t_test_ stats_t_test_indep ' + 'stats_t_test_one stats_t_test_paired stats_wsr_test status std stddev stddev_pop stddev_samp stdev ' + 'stop storage store stored str str_to_date straight_join strcmp strict string struct stuff style subdate ' + 'subpartition subpartitions substitutable substr substring subtime subtring_index subtype success sum ' + 'suspend switch switchoffset switchover sync synchronous synonym sys sys_xmlagg sysasm sysaux sysdate ' + 'sysdatetimeoffset sysdba sysoper system system_user sysutcdatetime table tables tablespace tablesample tan tdo ' + 'template temporary terminated tertiary_weights test than then thread through tier ties time time_format ' + 'time_zone timediff timefromparts timeout timestamp timestampadd timestampdiff timezone_abbr ' + 'timezone_minute timezone_region to to_base64 to_date to_days to_seconds todatetimeoffset trace tracking ' + 'transaction transactional translate translation treat trigger trigger_nestlevel triggers trim truncate ' + 'try_cast try_convert try_parse type ub1 ub2 ub4 ucase unarchived unbounded uncompress ' + 'under undo unhex unicode uniform uninstall union unique unix_timestamp unknown unlimited unlock unnest unpivot ' + 'unrecoverable unsafe unsigned until untrusted unusable unused update updated upgrade upped upper upsert ' + 'url urowid usable usage use use_stored_outlines user user_data user_resources users using utc_date ' + 'utc_timestamp uuid uuid_short validate validate_password_strength validation valist value values var ' + 'var_samp varcharc vari varia variab variabl variable variables variance varp varraw varrawc varray ' + 'verify version versions view virtual visible void wait wallet warning warnings week weekday weekofyear ' + 'wellformed when whene whenev wheneve whenever where while whitespace window with within without work wrapped ' + 'xdb xml xmlagg xmlattributes xmlcast xmlcolattval xmlelement xmlexists xmlforest xmlindex xmlnamespaces ' + 'xmlpi xmlquery xmlroot xmlschema xmlserialize xmltable xmltype xor year year_to_month years yearweek',
        literal: 'true false null unknown',
        built_in: 'array bigint binary bit blob bool boolean char character date dec decimal float int int8 integer interval number ' + 'numeric real record serial serial8 smallint text time timestamp tinyint varchar varchar2 varying void'
      },
      contains: [{
        className: 'string',
        begin: '\'',
        end: '\'',
        contains: [{
          begin: '\'\''
        }]
      }, {
        className: 'string',
        begin: '"',
        end: '"',
        contains: [{
          begin: '""'
        }]
      }, {
        className: 'string',
        begin: '`',
        end: '`'
      }, hljs.C_NUMBER_MODE, hljs.C_BLOCK_COMMENT_MODE, COMMENT_MODE, hljs.HASH_COMMENT_MODE]
    }, hljs.C_BLOCK_COMMENT_MODE, COMMENT_MODE, hljs.HASH_COMMENT_MODE]
  };
}
module.exports = sql_more;

/***/ }),

/***/ 37787:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
/*
Language: Stan
Description: The Stan probabilistic programming language
Author: Jeffrey B. Arnold <jeffrey.arnold@gmail.com>
Website: http://mc-stan.org/
Category: scientific
*/

function stan(hljs) {
  // variable names cannot conflict with block identifiers
  var BLOCKS = ['functions', 'model', 'data', 'parameters', 'quantities', 'transformed', 'generated'];
  var STATEMENTS = ['for', 'in', 'if', 'else', 'while', 'break', 'continue', 'return'];
  var SPECIAL_FUNCTIONS = ['print', 'reject', 'increment_log_prob|10', 'integrate_ode|10', 'integrate_ode_rk45|10', 'integrate_ode_bdf|10', 'algebra_solver'];
  var VAR_TYPES = ['int', 'real', 'vector', 'ordered', 'positive_ordered', 'simplex', 'unit_vector', 'row_vector', 'matrix', 'cholesky_factor_corr|10', 'cholesky_factor_cov|10', 'corr_matrix|10', 'cov_matrix|10', 'void'];
  var FUNCTIONS = ['Phi', 'Phi_approx', 'abs', 'acos', 'acosh', 'algebra_solver', 'append_array', 'append_col', 'append_row', 'asin', 'asinh', 'atan', 'atan2', 'atanh', 'bernoulli_cdf', 'bernoulli_lccdf', 'bernoulli_lcdf', 'bernoulli_logit_lpmf', 'bernoulli_logit_rng', 'bernoulli_lpmf', 'bernoulli_rng', 'bessel_first_kind', 'bessel_second_kind', 'beta_binomial_cdf', 'beta_binomial_lccdf', 'beta_binomial_lcdf', 'beta_binomial_lpmf', 'beta_binomial_rng', 'beta_cdf', 'beta_lccdf', 'beta_lcdf', 'beta_lpdf', 'beta_rng', 'binary_log_loss', 'binomial_cdf', 'binomial_coefficient_log', 'binomial_lccdf', 'binomial_lcdf', 'binomial_logit_lpmf', 'binomial_lpmf', 'binomial_rng', 'block', 'categorical_logit_lpmf', 'categorical_logit_rng', 'categorical_lpmf', 'categorical_rng', 'cauchy_cdf', 'cauchy_lccdf', 'cauchy_lcdf', 'cauchy_lpdf', 'cauchy_rng', 'cbrt', 'ceil', 'chi_square_cdf', 'chi_square_lccdf', 'chi_square_lcdf', 'chi_square_lpdf', 'chi_square_rng', 'cholesky_decompose', 'choose', 'col', 'cols', 'columns_dot_product', 'columns_dot_self', 'cos', 'cosh', 'cov_exp_quad', 'crossprod', 'csr_extract_u', 'csr_extract_v', 'csr_extract_w', 'csr_matrix_times_vector', 'csr_to_dense_matrix', 'cumulative_sum', 'determinant', 'diag_matrix', 'diag_post_multiply', 'diag_pre_multiply', 'diagonal', 'digamma', 'dims', 'dirichlet_lpdf', 'dirichlet_rng', 'distance', 'dot_product', 'dot_self', 'double_exponential_cdf', 'double_exponential_lccdf', 'double_exponential_lcdf', 'double_exponential_lpdf', 'double_exponential_rng', 'e', 'eigenvalues_sym', 'eigenvectors_sym', 'erf', 'erfc', 'exp', 'exp2', 'exp_mod_normal_cdf', 'exp_mod_normal_lccdf', 'exp_mod_normal_lcdf', 'exp_mod_normal_lpdf', 'exp_mod_normal_rng', 'expm1', 'exponential_cdf', 'exponential_lccdf', 'exponential_lcdf', 'exponential_lpdf', 'exponential_rng', 'fabs', 'falling_factorial', 'fdim', 'floor', 'fma', 'fmax', 'fmin', 'fmod', 'frechet_cdf', 'frechet_lccdf', 'frechet_lcdf', 'frechet_lpdf', 'frechet_rng', 'gamma_cdf', 'gamma_lccdf', 'gamma_lcdf', 'gamma_lpdf', 'gamma_p', 'gamma_q', 'gamma_rng', 'gaussian_dlm_obs_lpdf', 'get_lp', 'gumbel_cdf', 'gumbel_lccdf', 'gumbel_lcdf', 'gumbel_lpdf', 'gumbel_rng', 'head', 'hypergeometric_lpmf', 'hypergeometric_rng', 'hypot', 'inc_beta', 'int_step', 'integrate_ode', 'integrate_ode_bdf', 'integrate_ode_rk45', 'inv', 'inv_Phi', 'inv_chi_square_cdf', 'inv_chi_square_lccdf', 'inv_chi_square_lcdf', 'inv_chi_square_lpdf', 'inv_chi_square_rng', 'inv_cloglog', 'inv_gamma_cdf', 'inv_gamma_lccdf', 'inv_gamma_lcdf', 'inv_gamma_lpdf', 'inv_gamma_rng', 'inv_logit', 'inv_sqrt', 'inv_square', 'inv_wishart_lpdf', 'inv_wishart_rng', 'inverse', 'inverse_spd', 'is_inf', 'is_nan', 'lbeta', 'lchoose', 'lgamma', 'lkj_corr_cholesky_lpdf', 'lkj_corr_cholesky_rng', 'lkj_corr_lpdf', 'lkj_corr_rng', 'lmgamma', 'lmultiply', 'log', 'log10', 'log1m', 'log1m_exp', 'log1m_inv_logit', 'log1p', 'log1p_exp', 'log2', 'log_determinant', 'log_diff_exp', 'log_falling_factorial', 'log_inv_logit', 'log_mix', 'log_rising_factorial', 'log_softmax', 'log_sum_exp', 'logistic_cdf', 'logistic_lccdf', 'logistic_lcdf', 'logistic_lpdf', 'logistic_rng', 'logit', 'lognormal_cdf', 'lognormal_lccdf', 'lognormal_lcdf', 'lognormal_lpdf', 'lognormal_rng', 'machine_precision', 'matrix_exp', 'max', 'mdivide_left_spd', 'mdivide_left_tri_low', 'mdivide_right_spd', 'mdivide_right_tri_low', 'mean', 'min', 'modified_bessel_first_kind', 'modified_bessel_second_kind', 'multi_gp_cholesky_lpdf', 'multi_gp_lpdf', 'multi_normal_cholesky_lpdf', 'multi_normal_cholesky_rng', 'multi_normal_lpdf', 'multi_normal_prec_lpdf', 'multi_normal_rng', 'multi_student_t_lpdf', 'multi_student_t_rng', 'multinomial_lpmf', 'multinomial_rng', 'multiply_log', 'multiply_lower_tri_self_transpose', 'neg_binomial_2_cdf', 'neg_binomial_2_lccdf', 'neg_binomial_2_lcdf', 'neg_binomial_2_log_lpmf', 'neg_binomial_2_log_rng', 'neg_binomial_2_lpmf', 'neg_binomial_2_rng', 'neg_binomial_cdf', 'neg_binomial_lccdf', 'neg_binomial_lcdf', 'neg_binomial_lpmf', 'neg_binomial_rng', 'negative_infinity', 'normal_cdf', 'normal_lccdf', 'normal_lcdf', 'normal_lpdf', 'normal_rng', 'not_a_number', 'num_elements', 'ordered_logistic_lpmf', 'ordered_logistic_rng', 'owens_t', 'pareto_cdf', 'pareto_lccdf', 'pareto_lcdf', 'pareto_lpdf', 'pareto_rng', 'pareto_type_2_cdf', 'pareto_type_2_lccdf', 'pareto_type_2_lcdf', 'pareto_type_2_lpdf', 'pareto_type_2_rng', 'pi', 'poisson_cdf', 'poisson_lccdf', 'poisson_lcdf', 'poisson_log_lpmf', 'poisson_log_rng', 'poisson_lpmf', 'poisson_rng', 'positive_infinity', 'pow', 'print', 'prod', 'qr_Q', 'qr_R', 'quad_form', 'quad_form_diag', 'quad_form_sym', 'rank', 'rayleigh_cdf', 'rayleigh_lccdf', 'rayleigh_lcdf', 'rayleigh_lpdf', 'rayleigh_rng', 'reject', 'rep_array', 'rep_matrix', 'rep_row_vector', 'rep_vector', 'rising_factorial', 'round', 'row', 'rows', 'rows_dot_product', 'rows_dot_self', 'scaled_inv_chi_square_cdf', 'scaled_inv_chi_square_lccdf', 'scaled_inv_chi_square_lcdf', 'scaled_inv_chi_square_lpdf', 'scaled_inv_chi_square_rng', 'sd', 'segment', 'sin', 'singular_values', 'sinh', 'size', 'skew_normal_cdf', 'skew_normal_lccdf', 'skew_normal_lcdf', 'skew_normal_lpdf', 'skew_normal_rng', 'softmax', 'sort_asc', 'sort_desc', 'sort_indices_asc', 'sort_indices_desc', 'sqrt', 'sqrt2', 'square', 'squared_distance', 'step', 'student_t_cdf', 'student_t_lccdf', 'student_t_lcdf', 'student_t_lpdf', 'student_t_rng', 'sub_col', 'sub_row', 'sum', 'tail', 'tan', 'tanh', 'target', 'tcrossprod', 'tgamma', 'to_array_1d', 'to_array_2d', 'to_matrix', 'to_row_vector', 'to_vector', 'trace', 'trace_gen_quad_form', 'trace_quad_form', 'trigamma', 'trunc', 'uniform_cdf', 'uniform_lccdf', 'uniform_lcdf', 'uniform_lpdf', 'uniform_rng', 'variance', 'von_mises_lpdf', 'von_mises_rng', 'weibull_cdf', 'weibull_lccdf', 'weibull_lcdf', 'weibull_lpdf', 'weibull_rng', 'wiener_lpdf', 'wishart_lpdf', 'wishart_rng'];
  var DISTRIBUTIONS = ['bernoulli', 'bernoulli_logit', 'beta', 'beta_binomial', 'binomial', 'binomial_logit', 'categorical', 'categorical_logit', 'cauchy', 'chi_square', 'dirichlet', 'double_exponential', 'exp_mod_normal', 'exponential', 'frechet', 'gamma', 'gaussian_dlm_obs', 'gumbel', 'hypergeometric', 'inv_chi_square', 'inv_gamma', 'inv_wishart', 'lkj_corr', 'lkj_corr_cholesky', 'logistic', 'lognormal', 'multi_gp', 'multi_gp_cholesky', 'multi_normal', 'multi_normal_cholesky', 'multi_normal_prec', 'multi_student_t', 'multinomial', 'neg_binomial', 'neg_binomial_2', 'neg_binomial_2_log', 'normal', 'ordered_logistic', 'pareto', 'pareto_type_2', 'poisson', 'poisson_log', 'rayleigh', 'scaled_inv_chi_square', 'skew_normal', 'student_t', 'uniform', 'von_mises', 'weibull', 'wiener', 'wishart'];
  return {
    name: 'Stan',
    aliases: ['stanfuncs'],
    keywords: {
      $pattern: hljs.IDENT_RE,
      title: BLOCKS,
      keyword: STATEMENTS.concat(VAR_TYPES).concat(SPECIAL_FUNCTIONS),
      built_in: FUNCTIONS
    },
    contains: [hljs.C_LINE_COMMENT_MODE, hljs.COMMENT(/#/, /$/, {
      relevance: 0,
      keywords: {
        'meta-keyword': 'include'
      }
    }), hljs.COMMENT(/\/\*/, /\*\//, {
      relevance: 0,
      // highlight doc strings mentioned in Stan reference
      contains: [{
        className: 'doctag',
        begin: /@(return|param)/
      }]
    }), {
      // hack: in range constraints, lower must follow "<"
      begin: /<\s*lower\s*=/,
      keywords: 'lower'
    }, {
      // hack: in range constraints, upper must follow either , or <
      // <lower = ..., upper = ...> or <upper = ...>
      begin: /[<,]\s*upper\s*=/,
      keywords: 'upper'
    }, {
      className: 'keyword',
      begin: /\btarget\s*\+=/,
      relevance: 10
    }, {
      begin: '~\\s*(' + hljs.IDENT_RE + ')\\s*\\(',
      keywords: DISTRIBUTIONS
    }, {
      className: 'number',
      variants: [{
        begin: /\b\d+(?:\.\d*)?(?:[eE][+-]?\d+)?/
      }, {
        begin: /\.\d+(?:[eE][+-]?\d+)?\b/
      }],
      relevance: 0
    }, {
      className: 'string',
      begin: '"',
      end: '"',
      relevance: 0
    }]
  };
}
module.exports = stan;

/***/ }),

/***/ 83406:
/***/ ((module) => {

/*
Language: Stata
Author: Brian Quistorff <bquistorff@gmail.com>
Contributors: Drew McDonald <drewmcdo@gmail.com>
Description: Stata is a general-purpose statistical software package created in 1985 by StataCorp.
Website: https://en.wikipedia.org/wiki/Stata
Category: scientific
*/

/*
  This is a fork and modification of Drew McDonald's file (https://github.com/drewmcdonald/stata-highlighting). I have also included a list of builtin commands from https://bugs.kde.org/show_bug.cgi?id=135646.
*/

function stata(hljs) {
  return {
    name: 'Stata',
    aliases: ['do', 'ado'],
    case_insensitive: true,
    keywords: 'if else in foreach for forv forva forval forvalu forvalue forvalues by bys bysort xi quietly qui capture about ac ac_7 acprplot acprplot_7 adjust ado adopath adoupdate alpha ameans an ano anov anova anova_estat anova_terms anovadef aorder ap app appe appen append arch arch_dr arch_estat arch_p archlm areg areg_p args arima arima_dr arima_estat arima_p as asmprobit asmprobit_estat asmprobit_lf asmprobit_mfx__dlg asmprobit_p ass asse asser assert avplot avplot_7 avplots avplots_7 bcskew0 bgodfrey bias binreg bip0_lf biplot bipp_lf bipr_lf bipr_p biprobit bitest bitesti bitowt blogit bmemsize boot bootsamp bootstrap bootstrap_8 boxco_l boxco_p boxcox boxcox_6 boxcox_p bprobit br break brier bro brow brows browse brr brrstat bs bs_7 bsampl_w bsample bsample_7 bsqreg bstat bstat_7 bstat_8 bstrap bstrap_7 bubble bubbleplot ca ca_estat ca_p cabiplot camat canon canon_8 canon_8_p canon_estat canon_p cap caprojection capt captu captur capture cat cc cchart cchart_7 cci cd censobs_table centile cf char chdir checkdlgfiles checkestimationsample checkhlpfiles checksum chelp ci cii cl class classutil clear cli clis clist clo clog clog_lf clog_p clogi clogi_sw clogit clogit_lf clogit_p clogitp clogl_sw cloglog clonevar clslistarray cluster cluster_measures cluster_stop cluster_tree cluster_tree_8 clustermat cmdlog cnr cnre cnreg cnreg_p cnreg_sw cnsreg codebook collaps4 collapse colormult_nb colormult_nw compare compress conf confi confir confirm conren cons const constr constra constrai constrain constraint continue contract copy copyright copysource cor corc corr corr2data corr_anti corr_kmo corr_smc corre correl correla correlat correlate corrgram cou coun count cox cox_p cox_sw coxbase coxhaz coxvar cprplot cprplot_7 crc cret cretu cretur creturn cross cs cscript cscript_log csi ct ct_is ctset ctst_5 ctst_st cttost cumsp cumsp_7 cumul cusum cusum_7 cutil d|0 datasig datasign datasigna datasignat datasignatu datasignatur datasignature datetof db dbeta de dec deco decod decode deff des desc descr descri describ describe destring dfbeta dfgls dfuller di di_g dir dirstats dis discard disp disp_res disp_s displ displa display distinct do doe doed doedi doedit dotplot dotplot_7 dprobit drawnorm drop ds ds_util dstdize duplicates durbina dwstat dydx e|0 ed edi edit egen eivreg emdef en enc enco encod encode eq erase ereg ereg_lf ereg_p ereg_sw ereghet ereghet_glf ereghet_glf_sh ereghet_gp ereghet_ilf ereghet_ilf_sh ereghet_ip eret eretu eretur ereturn err erro error esize est est_cfexist est_cfname est_clickable est_expand est_hold est_table est_unhold est_unholdok estat estat_default estat_summ estat_vce_only esti estimates etodow etof etomdy ex exi exit expand expandcl fac fact facto factor factor_estat factor_p factor_pca_rotated factor_rotate factormat fcast fcast_compute fcast_graph fdades fdadesc fdadescr fdadescri fdadescrib fdadescribe fdasav fdasave fdause fh_st file open file read file close file filefilter fillin find_hlp_file findfile findit findit_7 fit fl fli flis flist for5_0 forest forestplot form forma format fpredict frac_154 frac_adj frac_chk frac_cox frac_ddp frac_dis frac_dv frac_in frac_mun frac_pp frac_pq frac_pv frac_wgt frac_xo fracgen fracplot fracplot_7 fracpoly fracpred fron_ex fron_hn fron_p fron_tn fron_tn2 frontier ftodate ftoe ftomdy ftowdate funnel funnelplot g|0 gamhet_glf gamhet_gp gamhet_ilf gamhet_ip gamma gamma_d2 gamma_p gamma_sw gammahet gdi_hexagon gdi_spokes ge gen gene gener genera generat generate genrank genstd genvmean gettoken gl gladder gladder_7 glim_l01 glim_l02 glim_l03 glim_l04 glim_l05 glim_l06 glim_l07 glim_l08 glim_l09 glim_l10 glim_l11 glim_l12 glim_lf glim_mu glim_nw1 glim_nw2 glim_nw3 glim_p glim_v1 glim_v2 glim_v3 glim_v4 glim_v5 glim_v6 glim_v7 glm glm_6 glm_p glm_sw glmpred glo glob globa global glogit glogit_8 glogit_p gmeans gnbre_lf gnbreg gnbreg_5 gnbreg_p gomp_lf gompe_sw gomper_p gompertz gompertzhet gomphet_glf gomphet_glf_sh gomphet_gp gomphet_ilf gomphet_ilf_sh gomphet_ip gphdot gphpen gphprint gprefs gprobi_p gprobit gprobit_8 gr gr7 gr_copy gr_current gr_db gr_describe gr_dir gr_draw gr_draw_replay gr_drop gr_edit gr_editviewopts gr_example gr_example2 gr_export gr_print gr_qscheme gr_query gr_read gr_rename gr_replay gr_save gr_set gr_setscheme gr_table gr_undo gr_use graph graph7 grebar greigen greigen_7 greigen_8 grmeanby grmeanby_7 gs_fileinfo gs_filetype gs_graphinfo gs_stat gsort gwood h|0 hadimvo hareg hausman haver he heck_d2 heckma_p heckman heckp_lf heckpr_p heckprob hel help hereg hetpr_lf hetpr_p hetprob hettest hexdump hilite hist hist_7 histogram hlogit hlu hmeans hotel hotelling hprobit hreg hsearch icd9 icd9_ff icd9p iis impute imtest inbase include inf infi infil infile infix inp inpu input ins insheet insp inspe inspec inspect integ inten intreg intreg_7 intreg_p intrg2_ll intrg_ll intrg_ll2 ipolate iqreg ir irf irf_create irfm iri is_svy is_svysum isid istdize ivprob_1_lf ivprob_lf ivprobit ivprobit_p ivreg ivreg_footnote ivtob_1_lf ivtob_lf ivtobit ivtobit_p jackknife jacknife jknife jknife_6 jknife_8 jkstat joinby kalarma1 kap kap_3 kapmeier kappa kapwgt kdensity kdensity_7 keep ksm ksmirnov ktau kwallis l|0 la lab labbe labbeplot labe label labelbook ladder levels levelsof leverage lfit lfit_p li lincom line linktest lis list lloghet_glf lloghet_glf_sh lloghet_gp lloghet_ilf lloghet_ilf_sh lloghet_ip llogi_sw llogis_p llogist llogistic llogistichet lnorm_lf lnorm_sw lnorma_p lnormal lnormalhet lnormhet_glf lnormhet_glf_sh lnormhet_gp lnormhet_ilf lnormhet_ilf_sh lnormhet_ip lnskew0 loadingplot loc loca local log logi logis_lf logistic logistic_p logit logit_estat logit_p loglogs logrank loneway lookfor lookup lowess lowess_7 lpredict lrecomp lroc lroc_7 lrtest ls lsens lsens_7 lsens_x lstat ltable ltable_7 ltriang lv lvr2plot lvr2plot_7 m|0 ma mac macr macro makecns man manova manova_estat manova_p manovatest mantel mark markin markout marksample mat mat_capp mat_order mat_put_rr mat_rapp mata mata_clear mata_describe mata_drop mata_matdescribe mata_matsave mata_matuse mata_memory mata_mlib mata_mosave mata_rename mata_which matalabel matcproc matlist matname matr matri matrix matrix_input__dlg matstrik mcc mcci md0_ md1_ md1debug_ md2_ md2debug_ mds mds_estat mds_p mdsconfig mdslong mdsmat mdsshepard mdytoe mdytof me_derd mean means median memory memsize menl meqparse mer merg merge meta mfp mfx mhelp mhodds minbound mixed_ll mixed_ll_reparm mkassert mkdir mkmat mkspline ml ml_5 ml_adjs ml_bhhhs ml_c_d ml_check ml_clear ml_cnt ml_debug ml_defd ml_e0 ml_e0_bfgs ml_e0_cycle ml_e0_dfp ml_e0i ml_e1 ml_e1_bfgs ml_e1_bhhh ml_e1_cycle ml_e1_dfp ml_e2 ml_e2_cycle ml_ebfg0 ml_ebfr0 ml_ebfr1 ml_ebh0q ml_ebhh0 ml_ebhr0 ml_ebr0i ml_ecr0i ml_edfp0 ml_edfr0 ml_edfr1 ml_edr0i ml_eds ml_eer0i ml_egr0i ml_elf ml_elf_bfgs ml_elf_bhhh ml_elf_cycle ml_elf_dfp ml_elfi ml_elfs ml_enr0i ml_enrr0 ml_erdu0 ml_erdu0_bfgs ml_erdu0_bhhh ml_erdu0_bhhhq ml_erdu0_cycle ml_erdu0_dfp ml_erdu0_nrbfgs ml_exde ml_footnote ml_geqnr ml_grad0 ml_graph ml_hbhhh ml_hd0 ml_hold ml_init ml_inv ml_log ml_max ml_mlout ml_mlout_8 ml_model ml_nb0 ml_opt ml_p ml_plot ml_query ml_rdgrd ml_repor ml_s_e ml_score ml_searc ml_technique ml_unhold mleval mlf_ mlmatbysum mlmatsum mlog mlogi mlogit mlogit_footnote mlogit_p mlopts mlsum mlvecsum mnl0_ mor more mov move mprobit mprobit_lf mprobit_p mrdu0_ mrdu1_ mvdecode mvencode mvreg mvreg_estat n|0 nbreg nbreg_al nbreg_lf nbreg_p nbreg_sw nestreg net newey newey_7 newey_p news nl nl_7 nl_9 nl_9_p nl_p nl_p_7 nlcom nlcom_p nlexp2 nlexp2_7 nlexp2a nlexp2a_7 nlexp3 nlexp3_7 nlgom3 nlgom3_7 nlgom4 nlgom4_7 nlinit nllog3 nllog3_7 nllog4 nllog4_7 nlog_rd nlogit nlogit_p nlogitgen nlogittree nlpred no nobreak noi nois noisi noisil noisily note notes notes_dlg nptrend numlabel numlist odbc old_ver olo olog ologi ologi_sw ologit ologit_p ologitp on one onew onewa oneway op_colnm op_comp op_diff op_inv op_str opr opro oprob oprob_sw oprobi oprobi_p oprobit oprobitp opts_exclusive order orthog orthpoly ou out outf outfi outfil outfile outs outsh outshe outshee outsheet ovtest pac pac_7 palette parse parse_dissim pause pca pca_8 pca_display pca_estat pca_p pca_rotate pcamat pchart pchart_7 pchi pchi_7 pcorr pctile pentium pergram pergram_7 permute permute_8 personal peto_st pkcollapse pkcross pkequiv pkexamine pkexamine_7 pkshape pksumm pksumm_7 pl plo plot plugin pnorm pnorm_7 poisgof poiss_lf poiss_sw poisso_p poisson poisson_estat post postclose postfile postutil pperron pr prais prais_e prais_e2 prais_p predict predictnl preserve print pro prob probi probit probit_estat probit_p proc_time procoverlay procrustes procrustes_estat procrustes_p profiler prog progr progra program prop proportion prtest prtesti pwcorr pwd q\\s qby qbys qchi qchi_7 qladder qladder_7 qnorm qnorm_7 qqplot qqplot_7 qreg qreg_c qreg_p qreg_sw qu quadchk quantile quantile_7 que quer query range ranksum ratio rchart rchart_7 rcof recast reclink recode reg reg3 reg3_p regdw regr regre regre_p2 regres regres_p regress regress_estat regriv_p remap ren rena renam rename renpfix repeat replace report reshape restore ret retu retur return rm rmdir robvar roccomp roccomp_7 roccomp_8 rocf_lf rocfit rocfit_8 rocgold rocplot rocplot_7 roctab roctab_7 rolling rologit rologit_p rot rota rotat rotate rotatemat rreg rreg_p ru run runtest rvfplot rvfplot_7 rvpplot rvpplot_7 sa safesum sample sampsi sav save savedresults saveold sc sca scal scala scalar scatter scm_mine sco scob_lf scob_p scobi_sw scobit scor score scoreplot scoreplot_help scree screeplot screeplot_help sdtest sdtesti se search separate seperate serrbar serrbar_7 serset set set_defaults sfrancia sh she shel shell shewhart shewhart_7 signestimationsample signrank signtest simul simul_7 simulate simulate_8 sktest sleep slogit slogit_d2 slogit_p smooth snapspan so sor sort spearman spikeplot spikeplot_7 spikeplt spline_x split sqreg sqreg_p sret sretu sretur sreturn ssc st st_ct st_hc st_hcd st_hcd_sh st_is st_issys st_note st_promo st_set st_show st_smpl st_subid stack statsby statsby_8 stbase stci stci_7 stcox stcox_estat stcox_fr stcox_fr_ll stcox_p stcox_sw stcoxkm stcoxkm_7 stcstat stcurv stcurve stcurve_7 stdes stem stepwise stereg stfill stgen stir stjoin stmc stmh stphplot stphplot_7 stphtest stphtest_7 stptime strate strate_7 streg streg_sw streset sts sts_7 stset stsplit stsum sttocc sttoct stvary stweib su suest suest_8 sum summ summa summar summari summariz summarize sunflower sureg survcurv survsum svar svar_p svmat svy svy_disp svy_dreg svy_est svy_est_7 svy_estat svy_get svy_gnbreg_p svy_head svy_header svy_heckman_p svy_heckprob_p svy_intreg_p svy_ivreg_p svy_logistic_p svy_logit_p svy_mlogit_p svy_nbreg_p svy_ologit_p svy_oprobit_p svy_poisson_p svy_probit_p svy_regress_p svy_sub svy_sub_7 svy_x svy_x_7 svy_x_p svydes svydes_8 svygen svygnbreg svyheckman svyheckprob svyintreg svyintreg_7 svyintrg svyivreg svylc svylog_p svylogit svymarkout svymarkout_8 svymean svymlog svymlogit svynbreg svyolog svyologit svyoprob svyoprobit svyopts svypois svypois_7 svypoisson svyprobit svyprobt svyprop svyprop_7 svyratio svyreg svyreg_p svyregress svyset svyset_7 svyset_8 svytab svytab_7 svytest svytotal sw sw_8 swcnreg swcox swereg swilk swlogis swlogit swologit swoprbt swpois swprobit swqreg swtobit swweib symmetry symmi symplot symplot_7 syntax sysdescribe sysdir sysuse szroeter ta tab tab1 tab2 tab_or tabd tabdi tabdis tabdisp tabi table tabodds tabodds_7 tabstat tabu tabul tabula tabulat tabulate te tempfile tempname tempvar tes test testnl testparm teststd tetrachoric time_it timer tis tob tobi tobit tobit_p tobit_sw token tokeni tokeniz tokenize tostring total translate translator transmap treat_ll treatr_p treatreg trim trimfill trnb_cons trnb_mean trpoiss_d2 trunc_ll truncr_p truncreg tsappend tset tsfill tsline tsline_ex tsreport tsrevar tsrline tsset tssmooth tsunab ttest ttesti tut_chk tut_wait tutorial tw tware_st two twoway twoway__fpfit_serset twoway__function_gen twoway__histogram_gen twoway__ipoint_serset twoway__ipoints_serset twoway__kdensity_gen twoway__lfit_serset twoway__normgen_gen twoway__pci_serset twoway__qfit_serset twoway__scatteri_serset twoway__sunflower_gen twoway_ksm_serset ty typ type typeof u|0 unab unabbrev unabcmd update us use uselabel var var_mkcompanion var_p varbasic varfcast vargranger varirf varirf_add varirf_cgraph varirf_create varirf_ctable varirf_describe varirf_dir varirf_drop varirf_erase varirf_graph varirf_ograph varirf_rename varirf_set varirf_table varlist varlmar varnorm varsoc varstable varstable_w varstable_w2 varwle vce vec vec_fevd vec_mkphi vec_p vec_p_w vecirf_create veclmar veclmar_w vecnorm vecnorm_w vecrank vecstable verinst vers versi versio version view viewsource vif vwls wdatetof webdescribe webseek webuse weib1_lf weib2_lf weib_lf weib_lf0 weibhet_glf weibhet_glf_sh weibhet_glfa weibhet_glfa_sh weibhet_gp weibhet_ilf weibhet_ilf_sh weibhet_ilfa weibhet_ilfa_sh weibhet_ip weibu_sw weibul_p weibull weibull_c weibull_s weibullhet wh whelp whi which whil while wilc_st wilcoxon win wind windo window winexec wntestb wntestb_7 wntestq xchart xchart_7 xcorr xcorr_7 xi xi_6 xmlsav xmlsave xmluse xpose xsh xshe xshel xshell xt_iis xt_tis xtab_p xtabond xtbin_p xtclog xtcloglog xtcloglog_8 xtcloglog_d2 xtcloglog_pa_p xtcloglog_re_p xtcnt_p xtcorr xtdata xtdes xtfront_p xtfrontier xtgee xtgee_elink xtgee_estat xtgee_makeivar xtgee_p xtgee_plink xtgls xtgls_p xthaus xthausman xtht_p xthtaylor xtile xtint_p xtintreg xtintreg_8 xtintreg_d2 xtintreg_p xtivp_1 xtivp_2 xtivreg xtline xtline_ex xtlogit xtlogit_8 xtlogit_d2 xtlogit_fe_p xtlogit_pa_p xtlogit_re_p xtmixed xtmixed_estat xtmixed_p xtnb_fe xtnb_lf xtnbreg xtnbreg_pa_p xtnbreg_refe_p xtpcse xtpcse_p xtpois xtpoisson xtpoisson_d2 xtpoisson_pa_p xtpoisson_refe_p xtpred xtprobit xtprobit_8 xtprobit_d2 xtprobit_re_p xtps_fe xtps_lf xtps_ren xtps_ren_8 xtrar_p xtrc xtrc_p xtrchh xtrefe_p xtreg xtreg_be xtreg_fe xtreg_ml xtreg_pa_p xtreg_re xtregar xtrere_p xtset xtsf_ll xtsf_llti xtsum xttab xttest0 xttobit xttobit_8 xttobit_p xttrans yx yxview__barlike_draw yxview_area_draw yxview_bar_draw yxview_dot_draw yxview_dropline_draw yxview_function_draw yxview_iarrow_draw yxview_ilabels_draw yxview_normal_draw yxview_pcarrow_draw yxview_pcbarrow_draw yxview_pccapsym_draw yxview_pcscatter_draw yxview_pcspike_draw yxview_rarea_draw yxview_rbar_draw yxview_rbarm_draw yxview_rcap_draw yxview_rcapsym_draw yxview_rconnected_draw yxview_rline_draw yxview_rscatter_draw yxview_rspike_draw yxview_spike_draw yxview_sunflower_draw zap_s zinb zinb_llf zinb_plf zip zip_llf zip_p zip_plf zt_ct_5 zt_hc_5 zt_hcd_5 zt_is_5 zt_iss_5 zt_sho_5 zt_smp_5 ztbase_5 ztcox_5 ztdes_5 ztereg_5 ztfill_5 ztgen_5 ztir_5 ztjoin_5 ztnb ztnb_p ztp ztp_p zts_5 ztset_5 ztspli_5 ztsum_5 zttoct_5 ztvary_5 ztweib_5',
    contains: [{
      className: 'symbol',
      begin: /`[a-zA-Z0-9_]+'/
    }, {
      className: 'variable',
      begin: /\$\{?[a-zA-Z0-9_]+\}?/
    }, {
      className: 'string',
      variants: [{
        begin: '`"[^\r\n]*?"\''
      }, {
        begin: '"[^\r\n"]*"'
      }]
    }, {
      className: 'built_in',
      variants: [{
        begin: '\\b(abs|acos|asin|atan|atan2|atanh|ceil|cloglog|comb|cos|digamma|exp|floor|invcloglog|invlogit|ln|lnfact|lnfactorial|lngamma|log|log10|max|min|mod|reldif|round|sign|sin|sqrt|sum|tan|tanh|trigamma|trunc|betaden|Binomial|binorm|binormal|chi2|chi2tail|dgammapda|dgammapdada|dgammapdadx|dgammapdx|dgammapdxdx|F|Fden|Ftail|gammaden|gammap|ibeta|invbinomial|invchi2|invchi2tail|invF|invFtail|invgammap|invibeta|invnchi2|invnFtail|invnibeta|invnorm|invnormal|invttail|nbetaden|nchi2|nFden|nFtail|nibeta|norm|normal|normalden|normd|npnchi2|tden|ttail|uniform|abbrev|char|index|indexnot|length|lower|ltrim|match|plural|proper|real|regexm|regexr|regexs|reverse|rtrim|string|strlen|strlower|strltrim|strmatch|strofreal|strpos|strproper|strreverse|strrtrim|strtrim|strupper|subinstr|subinword|substr|trim|upper|word|wordcount|_caller|autocode|byteorder|chop|clip|cond|e|epsdouble|epsfloat|group|inlist|inrange|irecode|matrix|maxbyte|maxdouble|maxfloat|maxint|maxlong|mi|minbyte|mindouble|minfloat|minint|minlong|missing|r|recode|replay|return|s|scalar|d|date|day|dow|doy|halfyear|mdy|month|quarter|week|year|d|daily|dofd|dofh|dofm|dofq|dofw|dofy|h|halfyearly|hofd|m|mofd|monthly|q|qofd|quarterly|tin|twithin|w|weekly|wofd|y|yearly|yh|ym|yofd|yq|yw|cholesky|colnumb|colsof|corr|det|diag|diag0cnt|el|get|hadamard|I|inv|invsym|issym|issymmetric|J|matmissing|matuniform|mreldif|nullmat|rownumb|rowsof|sweep|syminv|trace|vec|vecdiag)(?=\\()'
      }]
    }, hljs.COMMENT('^[ \t]*\\*.*$', false), hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE]
  };
}
module.exports = stata;

/***/ }),

/***/ 8773:
/***/ ((module) => {

/*
Language: STEP Part 21
Contributors: Adam Joseph Cook <adam.joseph.cook@gmail.com>
Description: Syntax highlighter for STEP Part 21 files (ISO 10303-21).
Website: https://en.wikipedia.org/wiki/ISO_10303-21
*/

function step21(hljs) {
  var STEP21_IDENT_RE = '[A-Z_][A-Z0-9_.]*';
  var STEP21_KEYWORDS = {
    $pattern: STEP21_IDENT_RE,
    keyword: 'HEADER ENDSEC DATA'
  };
  var STEP21_START = {
    className: 'meta',
    begin: 'ISO-10303-21;',
    relevance: 10
  };
  var STEP21_CLOSE = {
    className: 'meta',
    begin: 'END-ISO-10303-21;',
    relevance: 10
  };
  return {
    name: 'STEP Part 21',
    aliases: ['p21', 'step', 'stp'],
    case_insensitive: true,
    // STEP 21 is case insensitive in theory, in practice all non-comments are capitalized.
    keywords: STEP21_KEYWORDS,
    contains: [STEP21_START, STEP21_CLOSE, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.COMMENT('/\\*\\*!', '\\*/'), hljs.C_NUMBER_MODE, hljs.inherit(hljs.APOS_STRING_MODE, {
      illegal: null
    }), hljs.inherit(hljs.QUOTE_STRING_MODE, {
      illegal: null
    }), {
      className: 'string',
      begin: "'",
      end: "'"
    }, {
      className: 'symbol',
      variants: [{
        begin: '#',
        end: '\\d+',
        illegal: '\\W'
      }]
    }]
  };
}
module.exports = step21;

/***/ }),

/***/ 4253:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
var MODES = function MODES(hljs) {
  return {
    IMPORTANT: {
      className: 'meta',
      begin: '!important'
    },
    HEXCOLOR: {
      className: 'number',
      begin: '#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})'
    },
    ATTRIBUTE_SELECTOR_MODE: {
      className: 'selector-attr',
      begin: /\[/,
      end: /\]/,
      illegal: '$',
      contains: [hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE]
    }
  };
};
var TAGS = ['a', 'abbr', 'address', 'article', 'aside', 'audio', 'b', 'blockquote', 'body', 'button', 'canvas', 'caption', 'cite', 'code', 'dd', 'del', 'details', 'dfn', 'div', 'dl', 'dt', 'em', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'mark', 'menu', 'nav', 'object', 'ol', 'p', 'q', 'quote', 'samp', 'section', 'span', 'strong', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'ul', 'var', 'video'];
var MEDIA_FEATURES = ['any-hover', 'any-pointer', 'aspect-ratio', 'color', 'color-gamut', 'color-index', 'device-aspect-ratio', 'device-height', 'device-width', 'display-mode', 'forced-colors', 'grid', 'height', 'hover', 'inverted-colors', 'monochrome', 'orientation', 'overflow-block', 'overflow-inline', 'pointer', 'prefers-color-scheme', 'prefers-contrast', 'prefers-reduced-motion', 'prefers-reduced-transparency', 'resolution', 'scan', 'scripting', 'update', 'width',
// TODO: find a better solution?
'min-width', 'max-width', 'min-height', 'max-height'];

// https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-classes
var PSEUDO_CLASSES = ['active', 'any-link', 'blank', 'checked', 'current', 'default', 'defined', 'dir',
// dir()
'disabled', 'drop', 'empty', 'enabled', 'first', 'first-child', 'first-of-type', 'fullscreen', 'future', 'focus', 'focus-visible', 'focus-within', 'has',
// has()
'host',
// host or host()
'host-context',
// host-context()
'hover', 'indeterminate', 'in-range', 'invalid', 'is',
// is()
'lang',
// lang()
'last-child', 'last-of-type', 'left', 'link', 'local-link', 'not',
// not()
'nth-child',
// nth-child()
'nth-col',
// nth-col()
'nth-last-child',
// nth-last-child()
'nth-last-col',
// nth-last-col()
'nth-last-of-type',
//nth-last-of-type()
'nth-of-type',
//nth-of-type()
'only-child', 'only-of-type', 'optional', 'out-of-range', 'past', 'placeholder-shown', 'read-only', 'read-write', 'required', 'right', 'root', 'scope', 'target', 'target-within', 'user-invalid', 'valid', 'visited', 'where' // where()
];

// https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-elements
var PSEUDO_ELEMENTS = ['after', 'backdrop', 'before', 'cue', 'cue-region', 'first-letter', 'first-line', 'grammar-error', 'marker', 'part', 'placeholder', 'selection', 'slotted', 'spelling-error'];
var ATTRIBUTES = ['align-content', 'align-items', 'align-self', 'animation', 'animation-delay', 'animation-direction', 'animation-duration', 'animation-fill-mode', 'animation-iteration-count', 'animation-name', 'animation-play-state', 'animation-timing-function', 'auto', 'backface-visibility', 'background', 'background-attachment', 'background-clip', 'background-color', 'background-image', 'background-origin', 'background-position', 'background-repeat', 'background-size', 'border', 'border-bottom', 'border-bottom-color', 'border-bottom-left-radius', 'border-bottom-right-radius', 'border-bottom-style', 'border-bottom-width', 'border-collapse', 'border-color', 'border-image', 'border-image-outset', 'border-image-repeat', 'border-image-slice', 'border-image-source', 'border-image-width', 'border-left', 'border-left-color', 'border-left-style', 'border-left-width', 'border-radius', 'border-right', 'border-right-color', 'border-right-style', 'border-right-width', 'border-spacing', 'border-style', 'border-top', 'border-top-color', 'border-top-left-radius', 'border-top-right-radius', 'border-top-style', 'border-top-width', 'border-width', 'bottom', 'box-decoration-break', 'box-shadow', 'box-sizing', 'break-after', 'break-before', 'break-inside', 'caption-side', 'clear', 'clip', 'clip-path', 'color', 'column-count', 'column-fill', 'column-gap', 'column-rule', 'column-rule-color', 'column-rule-style', 'column-rule-width', 'column-span', 'column-width', 'columns', 'content', 'counter-increment', 'counter-reset', 'cursor', 'direction', 'display', 'empty-cells', 'filter', 'flex', 'flex-basis', 'flex-direction', 'flex-flow', 'flex-grow', 'flex-shrink', 'flex-wrap', 'float', 'font', 'font-display', 'font-family', 'font-feature-settings', 'font-kerning', 'font-language-override', 'font-size', 'font-size-adjust', 'font-smoothing', 'font-stretch', 'font-style', 'font-variant', 'font-variant-ligatures', 'font-variation-settings', 'font-weight', 'height', 'hyphens', 'icon', 'image-orientation', 'image-rendering', 'image-resolution', 'ime-mode', 'inherit', 'initial', 'justify-content', 'left', 'letter-spacing', 'line-height', 'list-style', 'list-style-image', 'list-style-position', 'list-style-type', 'margin', 'margin-bottom', 'margin-left', 'margin-right', 'margin-top', 'marks', 'mask', 'max-height', 'max-width', 'min-height', 'min-width', 'nav-down', 'nav-index', 'nav-left', 'nav-right', 'nav-up', 'none', 'normal', 'object-fit', 'object-position', 'opacity', 'order', 'orphans', 'outline', 'outline-color', 'outline-offset', 'outline-style', 'outline-width', 'overflow', 'overflow-wrap', 'overflow-x', 'overflow-y', 'padding', 'padding-bottom', 'padding-left', 'padding-right', 'padding-top', 'page-break-after', 'page-break-before', 'page-break-inside', 'perspective', 'perspective-origin', 'pointer-events', 'position', 'quotes', 'resize', 'right', 'src',
// @font-face
'tab-size', 'table-layout', 'text-align', 'text-align-last', 'text-decoration', 'text-decoration-color', 'text-decoration-line', 'text-decoration-style', 'text-indent', 'text-overflow', 'text-rendering', 'text-shadow', 'text-transform', 'text-underline-position', 'top', 'transform', 'transform-origin', 'transform-style', 'transition', 'transition-delay', 'transition-duration', 'transition-property', 'transition-timing-function', 'unicode-bidi', 'vertical-align', 'visibility', 'white-space', 'widows', 'width', 'word-break', 'word-spacing', 'word-wrap', 'z-index'
// reverse makes sure longer attributes `font-weight` are matched fully
// instead of getting false positives on say `font`
].reverse();

/*
Language: Stylus
Author: Bryant Williams <b.n.williams@gmail.com>
Description: Stylus is an expressive, robust, feature-rich CSS language built for nodejs.
Website: https://github.com/stylus/stylus
Category: css
*/

/** @type LanguageFn */
function stylus(hljs) {
  var modes = MODES(hljs);
  var AT_MODIFIERS = "and or not only";
  var VARIABLE = {
    className: 'variable',
    begin: '\\$' + hljs.IDENT_RE
  };
  var AT_KEYWORDS = ['charset', 'css', 'debug', 'extend', 'font-face', 'for', 'import', 'include', 'keyframes', 'media', 'mixin', 'page', 'warn', 'while'];
  var LOOKAHEAD_TAG_END = '(?=[.\\s\\n[:,(])';

  // illegals
  var ILLEGAL = ['\\?', '(\\bReturn\\b)',
  // monkey
  '(\\bEnd\\b)',
  // monkey
  '(\\bend\\b)',
  // vbscript
  '(\\bdef\\b)',
  // gradle
  ';',
  // a whole lot of languages
  '#\\s',
  // markdown
  '\\*\\s',
  // markdown
  '===\\s',
  // markdown
  '\\|', '%' // prolog
  ];

  return {
    name: 'Stylus',
    aliases: ['styl'],
    case_insensitive: false,
    keywords: 'if else for in',
    illegal: '(' + ILLEGAL.join('|') + ')',
    contains: [
    // strings
    hljs.QUOTE_STRING_MODE, hljs.APOS_STRING_MODE,
    // comments
    hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE,
    // hex colors
    modes.HEXCOLOR,
    // class tag
    {
      begin: '\\.[a-zA-Z][a-zA-Z0-9_-]*' + LOOKAHEAD_TAG_END,
      className: 'selector-class'
    },
    // id tag
    {
      begin: '#[a-zA-Z][a-zA-Z0-9_-]*' + LOOKAHEAD_TAG_END,
      className: 'selector-id'
    },
    // tags
    {
      begin: '\\b(' + TAGS.join('|') + ')' + LOOKAHEAD_TAG_END,
      className: 'selector-tag'
    },
    // psuedo selectors
    {
      className: 'selector-pseudo',
      begin: '&?:(' + PSEUDO_CLASSES.join('|') + ')' + LOOKAHEAD_TAG_END
    }, {
      className: 'selector-pseudo',
      begin: '&?::(' + PSEUDO_ELEMENTS.join('|') + ')' + LOOKAHEAD_TAG_END
    }, modes.ATTRIBUTE_SELECTOR_MODE, {
      className: "keyword",
      begin: /@media/,
      starts: {
        end: /[{;}]/,
        keywords: {
          $pattern: /[a-z-]+/,
          keyword: AT_MODIFIERS,
          attribute: MEDIA_FEATURES.join(" ")
        },
        contains: [hljs.CSS_NUMBER_MODE]
      }
    },
    // @ keywords
    {
      className: 'keyword',
      begin: '\@((-(o|moz|ms|webkit)-)?(' + AT_KEYWORDS.join('|') + '))\\b'
    },
    // variables
    VARIABLE,
    // dimension
    hljs.CSS_NUMBER_MODE,
    // functions
    //  - only from beginning of line + whitespace
    {
      className: 'function',
      begin: '^[a-zA-Z][a-zA-Z0-9_\-]*\\(.*\\)',
      illegal: '[\\n]',
      returnBegin: true,
      contains: [{
        className: 'title',
        begin: '\\b[a-zA-Z][a-zA-Z0-9_\-]*'
      }, {
        className: 'params',
        begin: /\(/,
        end: /\)/,
        contains: [modes.HEXCOLOR, VARIABLE, hljs.APOS_STRING_MODE, hljs.CSS_NUMBER_MODE, hljs.QUOTE_STRING_MODE]
      }]
    },
    // attributes
    //  - only from beginning of line + whitespace
    //  - must have whitespace after it
    {
      className: 'attribute',
      begin: '\\b(' + ATTRIBUTES.join('|') + ')\\b',
      starts: {
        // value container
        end: /;|$/,
        contains: [modes.HEXCOLOR, VARIABLE, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, hljs.CSS_NUMBER_MODE, hljs.C_BLOCK_COMMENT_MODE, modes.IMPORTANT],
        illegal: /\./,
        relevance: 0
      }
    }]
  };
}
module.exports = stylus;

/***/ }),

/***/ 42985:
/***/ ((module) => {

/*
Language: SubUnit
Author: Sergey Bronnikov <sergeyb@bronevichok.ru>
Website: https://pypi.org/project/python-subunit/
*/

function subunit(hljs) {
  var DETAILS = {
    className: 'string',
    begin: '\\[\n(multipart)?',
    end: '\\]\n'
  };
  var TIME = {
    className: 'string',
    begin: '\\d{4}-\\d{2}-\\d{2}(\\s+)\\d{2}:\\d{2}:\\d{2}\.\\d+Z'
  };
  var PROGRESSVALUE = {
    className: 'string',
    begin: '(\\+|-)\\d+'
  };
  var KEYWORDS = {
    className: 'keyword',
    relevance: 10,
    variants: [{
      begin: '^(test|testing|success|successful|failure|error|skip|xfail|uxsuccess)(:?)\\s+(test)?'
    }, {
      begin: '^progress(:?)(\\s+)?(pop|push)?'
    }, {
      begin: '^tags:'
    }, {
      begin: '^time:'
    }]
  };
  return {
    name: 'SubUnit',
    case_insensitive: true,
    contains: [DETAILS, TIME, PROGRESSVALUE, KEYWORDS]
  };
}
module.exports = subunit;

/***/ }),

/***/ 58243:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(92222);
__webpack_require__(57327);
__webpack_require__(74916);
__webpack_require__(4723);
__webpack_require__(69826);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(91038);
__webpack_require__(47042);
__webpack_require__(68309);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function lookahead(re) {
  return concat('(?=', re, ')');
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */
function either() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var joined = '(' + args.map(function (x) {
    return source(x);
  }).join("|") + ")";
  return joined;
}
var keywordWrapper = function keywordWrapper(keyword) {
  return concat(/\b/, keyword, /\w$/.test(keyword) ? /\b/ : /\B/);
};

// Keywords that require a leading dot.
var dotKeywords = ['Protocol',
// contextual
'Type' // contextual
].map(keywordWrapper);

// Keywords that may have a leading dot.
var optionalDotKeywords = ['init', 'self'].map(keywordWrapper);

// should register as keyword, not type
var keywordTypes = ['Any', 'Self'];

// Regular keywords and literals.
var keywords = [
// strings below will be fed into the regular `keywords` engine while regex
// will result in additional modes being created to scan for those keywords to
// avoid conflicts with other rules
'associatedtype', 'async', 'await', /as\?/,
// operator
/as!/,
// operator
'as',
// operator
'break', 'case', 'catch', 'class', 'continue', 'convenience',
// contextual
'default', 'defer', 'deinit', 'didSet',
// contextual
'do', 'dynamic',
// contextual
'else', 'enum', 'extension', 'fallthrough', /fileprivate\(set\)/, 'fileprivate', 'final',
// contextual
'for', 'func', 'get',
// contextual
'guard', 'if', 'import', 'indirect',
// contextual
'infix',
// contextual
/init\?/, /init!/, 'inout', /internal\(set\)/, 'internal', 'in', 'is',
// operator
'lazy',
// contextual
'let', 'mutating',
// contextual
'nonmutating',
// contextual
/open\(set\)/,
// contextual
'open',
// contextual
'operator', 'optional',
// contextual
'override',
// contextual
'postfix',
// contextual
'precedencegroup', 'prefix',
// contextual
/private\(set\)/, 'private', 'protocol', /public\(set\)/, 'public', 'repeat', 'required',
// contextual
'rethrows', 'return', 'set',
// contextual
'some',
// contextual
'static', 'struct', 'subscript', 'super', 'switch', 'throws', 'throw', /try\?/,
// operator
/try!/,
// operator
'try',
// operator
'typealias', /unowned\(safe\)/,
// contextual
/unowned\(unsafe\)/,
// contextual
'unowned',
// contextual
'var', 'weak',
// contextual
'where', 'while', 'willSet' // contextual
];

// NOTE: Contextual keywords are reserved only in specific contexts.
// Ideally, these should be matched using modes to avoid false positives.

// Literals.
var literals = ['false', 'nil', 'true'];

// Keywords used in precedence groups.
var precedencegroupKeywords = ['assignment', 'associativity', 'higherThan', 'left', 'lowerThan', 'none', 'right'];

// Keywords that start with a number sign (#).
// #available is handled separately.
var numberSignKeywords = ['#colorLiteral', '#column', '#dsohandle', '#else', '#elseif', '#endif', '#error', '#file', '#fileID', '#fileLiteral', '#filePath', '#function', '#if', '#imageLiteral', '#keyPath', '#line', '#selector', '#sourceLocation', '#warn_unqualified_access', '#warning'];

// Global functions in the Standard Library.
var builtIns = ['abs', 'all', 'any', 'assert', 'assertionFailure', 'debugPrint', 'dump', 'fatalError', 'getVaList', 'isKnownUniquelyReferenced', 'max', 'min', 'numericCast', 'pointwiseMax', 'pointwiseMin', 'precondition', 'preconditionFailure', 'print', 'readLine', 'repeatElement', 'sequence', 'stride', 'swap', 'swift_unboxFromSwiftValueWithType', 'transcode', 'type', 'unsafeBitCast', 'unsafeDowncast', 'withExtendedLifetime', 'withUnsafeMutablePointer', 'withUnsafePointer', 'withVaList', 'withoutActuallyEscaping', 'zip'];

// Valid first characters for operators.
var operatorHead = either(/[/=\-+!*%<>&|^~?]/, /[\u00A1-\u00A7]/, /[\u00A9\u00AB]/, /[\u00AC\u00AE]/, /[\u00B0\u00B1]/, /[\u00B6\u00BB\u00BF\u00D7\u00F7]/, /[\u2016-\u2017]/, /[\u2020-\u2027]/, /[\u2030-\u203E]/, /[\u2041-\u2053]/, /[\u2055-\u205E]/, /[\u2190-\u23FF]/, /[\u2500-\u2775]/, /[\u2794-\u2BFF]/, /[\u2E00-\u2E7F]/, /[\u3001-\u3003]/, /[\u3008-\u3020]/, /[\u3030]/);

// Valid characters for operators.
var operatorCharacter = either(operatorHead, /[\u0300-\u036F]/, /[\u1DC0-\u1DFF]/, /[\u20D0-\u20FF]/, /[\uFE00-\uFE0F]/, /[\uFE20-\uFE2F]/
// TODO: The following characters are also allowed, but the regex isn't supported yet.
// /[\u{E0100}-\u{E01EF}]/u
);

// Valid operator.
var operator = concat(operatorHead, operatorCharacter, '*');

// Valid first characters for identifiers.
var identifierHead = either(/[a-zA-Z_]/, /[\u00A8\u00AA\u00AD\u00AF\u00B2-\u00B5\u00B7-\u00BA]/, /[\u00BC-\u00BE\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]/, /[\u0100-\u02FF\u0370-\u167F\u1681-\u180D\u180F-\u1DBF]/, /[\u1E00-\u1FFF]/, /[\u200B-\u200D\u202A-\u202E\u203F-\u2040\u2054\u2060-\u206F]/, /[\u2070-\u20CF\u2100-\u218F\u2460-\u24FF\u2776-\u2793]/, /[\u2C00-\u2DFF\u2E80-\u2FFF]/, /[\u3004-\u3007\u3021-\u302F\u3031-\u303F\u3040-\uD7FF]/, /[\uF900-\uFD3D\uFD40-\uFDCF\uFDF0-\uFE1F\uFE30-\uFE44]/, /[\uFE47-\uFEFE\uFF00-\uFFFD]/ // Should be /[\uFE47-\uFFFD]/, but we have to exclude FEFF.
// The following characters are also allowed, but the regexes aren't supported yet.
// /[\u{10000}-\u{1FFFD}\u{20000-\u{2FFFD}\u{30000}-\u{3FFFD}\u{40000}-\u{4FFFD}]/u,
// /[\u{50000}-\u{5FFFD}\u{60000-\u{6FFFD}\u{70000}-\u{7FFFD}\u{80000}-\u{8FFFD}]/u,
// /[\u{90000}-\u{9FFFD}\u{A0000-\u{AFFFD}\u{B0000}-\u{BFFFD}\u{C0000}-\u{CFFFD}]/u,
// /[\u{D0000}-\u{DFFFD}\u{E0000-\u{EFFFD}]/u
);

// Valid characters for identifiers.
var identifierCharacter = either(identifierHead, /\d/, /[\u0300-\u036F\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]/);

// Valid identifier.
var identifier = concat(identifierHead, identifierCharacter, '*');

// Valid type identifier.
var typeIdentifier = concat(/[A-Z]/, identifierCharacter, '*');

// Built-in attributes, which are highlighted as keywords.
// @available is handled separately.
var keywordAttributes = ['autoclosure', concat(/convention\(/, either('swift', 'block', 'c'), /\)/), 'discardableResult', 'dynamicCallable', 'dynamicMemberLookup', 'escaping', 'frozen', 'GKInspectable', 'IBAction', 'IBDesignable', 'IBInspectable', 'IBOutlet', 'IBSegueAction', 'inlinable', 'main', 'nonobjc', 'NSApplicationMain', 'NSCopying', 'NSManaged', concat(/objc\(/, identifier, /\)/), 'objc', 'objcMembers', 'propertyWrapper', 'requires_stored_property_inits', 'testable', 'UIApplicationMain', 'unknown', 'usableFromInline'];

// Contextual keywords used in @available and #available.
var availabilityKeywords = ['iOS', 'iOSApplicationExtension', 'macOS', 'macOSApplicationExtension', 'macCatalyst', 'macCatalystApplicationExtension', 'watchOS', 'watchOSApplicationExtension', 'tvOS', 'tvOSApplicationExtension', 'swift'];

/*
Language: Swift
Description: Swift is a general-purpose programming language built using a modern approach to safety, performance, and software design patterns.
Author: Steven Van Impe <steven.vanimpe@icloud.com>
Contributors: Chris Eidhof <chris@eidhof.nl>, Nate Cook <natecook@gmail.com>, Alexander Lichter <manniL@gmx.net>, Richard Gibson <gibson042@github>
Website: https://swift.org
Category: common, system
*/

/** @type LanguageFn */
function swift(hljs) {
  var WHITESPACE = {
    match: /\s+/,
    relevance: 0
  };
  // https://docs.swift.org/swift-book/ReferenceManual/LexicalStructure.html#ID411
  var BLOCK_COMMENT = hljs.COMMENT('/\\*', '\\*/', {
    contains: ['self']
  });
  var COMMENTS = [hljs.C_LINE_COMMENT_MODE, BLOCK_COMMENT];

  // https://docs.swift.org/swift-book/ReferenceManual/LexicalStructure.html#ID413
  // https://docs.swift.org/swift-book/ReferenceManual/zzSummaryOfTheGrammar.html
  var DOT_KEYWORD = {
    className: 'keyword',
    begin: concat(/\./, lookahead(either.apply(void 0, _toConsumableArray(dotKeywords).concat(_toConsumableArray(optionalDotKeywords))))),
    end: either.apply(void 0, _toConsumableArray(dotKeywords).concat(_toConsumableArray(optionalDotKeywords))),
    excludeBegin: true
  };
  var KEYWORD_GUARD = {
    // Consume .keyword to prevent highlighting properties and methods as keywords.
    match: concat(/\./, either.apply(void 0, keywords)),
    relevance: 0
  };
  var PLAIN_KEYWORDS = keywords.filter(function (kw) {
    return typeof kw === 'string';
  }).concat(["_|0"]); // seems common, so 0 relevance
  var REGEX_KEYWORDS = keywords.filter(function (kw) {
    return typeof kw !== 'string';
  }) // find regex
  .concat(keywordTypes).map(keywordWrapper);
  var KEYWORD = {
    variants: [{
      className: 'keyword',
      match: either.apply(void 0, _toConsumableArray(REGEX_KEYWORDS).concat(_toConsumableArray(optionalDotKeywords)))
    }]
  };
  // find all the regular keywords
  var KEYWORDS = {
    $pattern: either(/\b\w+/,
    // regular keywords
    /#\w+/ // number keywords
    ),

    keyword: PLAIN_KEYWORDS.concat(numberSignKeywords),
    literal: literals
  };
  var KEYWORD_MODES = [DOT_KEYWORD, KEYWORD_GUARD, KEYWORD];

  // https://github.com/apple/swift/tree/main/stdlib/public/core
  var BUILT_IN_GUARD = {
    // Consume .built_in to prevent highlighting properties and methods.
    match: concat(/\./, either.apply(void 0, builtIns)),
    relevance: 0
  };
  var BUILT_IN = {
    className: 'built_in',
    match: concat(/\b/, either.apply(void 0, builtIns), /(?=\()/)
  };
  var BUILT_INS = [BUILT_IN_GUARD, BUILT_IN];

  // https://docs.swift.org/swift-book/ReferenceManual/LexicalStructure.html#ID418
  var OPERATOR_GUARD = {
    // Prevent -> from being highlighting as an operator.
    match: /->/,
    relevance: 0
  };
  var OPERATOR = {
    className: 'operator',
    relevance: 0,
    variants: [{
      match: operator
    }, {
      // dot-operator: only operators that start with a dot are allowed to use dots as
      // characters (..., ...<, .*, etc). So there rule here is: a dot followed by one or more
      // characters that may also include dots.
      match: "\\.(\\.|".concat(operatorCharacter, ")+")
    }]
  };
  var OPERATORS = [OPERATOR_GUARD, OPERATOR];

  // https://docs.swift.org/swift-book/ReferenceManual/LexicalStructure.html#grammar_numeric-literal
  // TODO: Update for leading `-` after lookbehind is supported everywhere
  var decimalDigits = '([0-9]_*)+';
  var hexDigits = '([0-9a-fA-F]_*)+';
  var NUMBER = {
    className: 'number',
    relevance: 0,
    variants: [
    // decimal floating-point-literal (subsumes decimal-literal)
    {
      match: "\\b(".concat(decimalDigits, ")(\\.(").concat(decimalDigits, "))?") + "([eE][+-]?(".concat(decimalDigits, "))?\\b")
    },
    // hexadecimal floating-point-literal (subsumes hexadecimal-literal)
    {
      match: "\\b0x(".concat(hexDigits, ")(\\.(").concat(hexDigits, "))?") + "([pP][+-]?(".concat(decimalDigits, "))?\\b")
    },
    // octal-literal
    {
      match: /\b0o([0-7]_*)+\b/
    },
    // binary-literal
    {
      match: /\b0b([01]_*)+\b/
    }]
  };

  // https://docs.swift.org/swift-book/ReferenceManual/LexicalStructure.html#grammar_string-literal
  var ESCAPED_CHARACTER = function ESCAPED_CHARACTER() {
    var rawDelimiter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return {
      className: 'subst',
      variants: [{
        match: concat(/\\/, rawDelimiter, /[0\\tnr"']/)
      }, {
        match: concat(/\\/, rawDelimiter, /u\{[0-9a-fA-F]{1,8}\}/)
      }]
    };
  };
  var ESCAPED_NEWLINE = function ESCAPED_NEWLINE() {
    var rawDelimiter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return {
      className: 'subst',
      match: concat(/\\/, rawDelimiter, /[\t ]*(?:[\r\n]|\r\n)/)
    };
  };
  var INTERPOLATION = function INTERPOLATION() {
    var rawDelimiter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return {
      className: 'subst',
      label: "interpol",
      begin: concat(/\\/, rawDelimiter, /\(/),
      end: /\)/
    };
  };
  var MULTILINE_STRING = function MULTILINE_STRING() {
    var rawDelimiter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return {
      begin: concat(rawDelimiter, /"""/),
      end: concat(/"""/, rawDelimiter),
      contains: [ESCAPED_CHARACTER(rawDelimiter), ESCAPED_NEWLINE(rawDelimiter), INTERPOLATION(rawDelimiter)]
    };
  };
  var SINGLE_LINE_STRING = function SINGLE_LINE_STRING() {
    var rawDelimiter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return {
      begin: concat(rawDelimiter, /"/),
      end: concat(/"/, rawDelimiter),
      contains: [ESCAPED_CHARACTER(rawDelimiter), INTERPOLATION(rawDelimiter)]
    };
  };
  var STRING = {
    className: 'string',
    variants: [MULTILINE_STRING(), MULTILINE_STRING("#"), MULTILINE_STRING("##"), MULTILINE_STRING("###"), SINGLE_LINE_STRING(), SINGLE_LINE_STRING("#"), SINGLE_LINE_STRING("##"), SINGLE_LINE_STRING("###")]
  };

  // https://docs.swift.org/swift-book/ReferenceManual/LexicalStructure.html#ID412
  var QUOTED_IDENTIFIER = {
    match: concat(/`/, identifier, /`/)
  };
  var IMPLICIT_PARAMETER = {
    className: 'variable',
    match: /\$\d+/
  };
  var PROPERTY_WRAPPER_PROJECTION = {
    className: 'variable',
    match: "\\$".concat(identifierCharacter, "+")
  };
  var IDENTIFIERS = [QUOTED_IDENTIFIER, IMPLICIT_PARAMETER, PROPERTY_WRAPPER_PROJECTION];

  // https://docs.swift.org/swift-book/ReferenceManual/Attributes.html
  var AVAILABLE_ATTRIBUTE = {
    match: /(@|#)available/,
    className: "keyword",
    starts: {
      contains: [{
        begin: /\(/,
        end: /\)/,
        keywords: availabilityKeywords,
        contains: [].concat(OPERATORS, [NUMBER, STRING])
      }]
    }
  };
  var KEYWORD_ATTRIBUTE = {
    className: 'keyword',
    match: concat(/@/, either.apply(void 0, keywordAttributes))
  };
  var USER_DEFINED_ATTRIBUTE = {
    className: 'meta',
    match: concat(/@/, identifier)
  };
  var ATTRIBUTES = [AVAILABLE_ATTRIBUTE, KEYWORD_ATTRIBUTE, USER_DEFINED_ATTRIBUTE];

  // https://docs.swift.org/swift-book/ReferenceManual/Types.html
  var TYPE = {
    match: lookahead(/\b[A-Z]/),
    relevance: 0,
    contains: [{
      // Common Apple frameworks, for relevance boost
      className: 'type',
      match: concat(/(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)/, identifierCharacter, '+')
    }, {
      // Type identifier
      className: 'type',
      match: typeIdentifier,
      relevance: 0
    }, {
      // Optional type
      match: /[?!]+/,
      relevance: 0
    }, {
      // Variadic parameter
      match: /\.\.\./,
      relevance: 0
    }, {
      // Protocol composition
      match: concat(/\s+&\s+/, lookahead(typeIdentifier)),
      relevance: 0
    }]
  };
  var GENERIC_ARGUMENTS = {
    begin: /</,
    end: />/,
    keywords: KEYWORDS,
    contains: [].concat(COMMENTS, KEYWORD_MODES, ATTRIBUTES, [OPERATOR_GUARD, TYPE])
  };
  TYPE.contains.push(GENERIC_ARGUMENTS);

  // https://docs.swift.org/swift-book/ReferenceManual/Expressions.html#ID552
  // Prevents element names from being highlighted as keywords.
  var TUPLE_ELEMENT_NAME = {
    match: concat(identifier, /\s*:/),
    keywords: "_|0",
    relevance: 0
  };
  // Matches tuples as well as the parameter list of a function type.
  var TUPLE = {
    begin: /\(/,
    end: /\)/,
    relevance: 0,
    keywords: KEYWORDS,
    contains: ['self', TUPLE_ELEMENT_NAME].concat(COMMENTS, KEYWORD_MODES, BUILT_INS, OPERATORS, [NUMBER, STRING], IDENTIFIERS, ATTRIBUTES, [TYPE])
  };

  // https://docs.swift.org/swift-book/ReferenceManual/Declarations.html#ID362
  // Matches both the keyword func and the function title.
  // Grouping these lets us differentiate between the operator function <
  // and the start of the generic parameter clause (also <).
  var FUNC_PLUS_TITLE = {
    beginKeywords: 'func',
    contains: [{
      className: 'title',
      match: either(QUOTED_IDENTIFIER.match, identifier, operator),
      // Required to make sure the opening < of the generic parameter clause
      // isn't parsed as a second title.
      endsParent: true,
      relevance: 0
    }, WHITESPACE]
  };
  var GENERIC_PARAMETERS = {
    begin: /</,
    end: />/,
    contains: [].concat(COMMENTS, [TYPE])
  };
  var FUNCTION_PARAMETER_NAME = {
    begin: either(lookahead(concat(identifier, /\s*:/)), lookahead(concat(identifier, /\s+/, identifier, /\s*:/))),
    end: /:/,
    relevance: 0,
    contains: [{
      className: 'keyword',
      match: /\b_\b/
    }, {
      className: 'params',
      match: identifier
    }]
  };
  var FUNCTION_PARAMETERS = {
    begin: /\(/,
    end: /\)/,
    keywords: KEYWORDS,
    contains: [FUNCTION_PARAMETER_NAME].concat(COMMENTS, KEYWORD_MODES, OPERATORS, [NUMBER, STRING], ATTRIBUTES, [TYPE, TUPLE]),
    endsParent: true,
    illegal: /["']/
  };
  var FUNCTION = {
    className: 'function',
    match: lookahead(/\bfunc\b/),
    contains: [FUNC_PLUS_TITLE, GENERIC_PARAMETERS, FUNCTION_PARAMETERS, WHITESPACE],
    illegal: [/\[/, /%/]
  };

  // https://docs.swift.org/swift-book/ReferenceManual/Declarations.html#ID375
  // https://docs.swift.org/swift-book/ReferenceManual/Declarations.html#ID379
  var INIT_SUBSCRIPT = {
    className: 'function',
    match: /\b(subscript|init[?!]?)\s*(?=[<(])/,
    keywords: {
      keyword: "subscript init init? init!",
      $pattern: /\w+[?!]?/
    },
    contains: [GENERIC_PARAMETERS, FUNCTION_PARAMETERS, WHITESPACE],
    illegal: /\[|%/
  };
  // https://docs.swift.org/swift-book/ReferenceManual/Declarations.html#ID380
  var OPERATOR_DECLARATION = {
    beginKeywords: 'operator',
    end: hljs.MATCH_NOTHING_RE,
    contains: [{
      className: 'title',
      match: operator,
      endsParent: true,
      relevance: 0
    }]
  };

  // https://docs.swift.org/swift-book/ReferenceManual/Declarations.html#ID550
  var PRECEDENCEGROUP = {
    beginKeywords: 'precedencegroup',
    end: hljs.MATCH_NOTHING_RE,
    contains: [{
      className: 'title',
      match: typeIdentifier,
      relevance: 0
    }, {
      begin: /{/,
      end: /}/,
      relevance: 0,
      endsParent: true,
      keywords: [].concat(precedencegroupKeywords, literals),
      contains: [TYPE]
    }]
  };

  // Add supported submodes to string interpolation.
  var _iterator = _createForOfIteratorHelper(STRING.variants),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var variant = _step.value;
      var interpolation = variant.contains.find(function (mode) {
        return mode.label === "interpol";
      });
      // TODO: Interpolation can contain any expression, so there's room for improvement here.
      interpolation.keywords = KEYWORDS;
      var submodes = [].concat(KEYWORD_MODES, BUILT_INS, OPERATORS, [NUMBER, STRING], IDENTIFIERS);
      interpolation.contains = [].concat(_toConsumableArray(submodes), [{
        begin: /\(/,
        end: /\)/,
        contains: ['self'].concat(_toConsumableArray(submodes))
      }]);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return {
    name: 'Swift',
    keywords: KEYWORDS,
    contains: [].concat(COMMENTS, [FUNCTION, INIT_SUBSCRIPT, {
      className: 'class',
      beginKeywords: 'struct protocol class extension enum',
      end: '\\{',
      excludeEnd: true,
      keywords: KEYWORDS,
      contains: [hljs.inherit(hljs.TITLE_MODE, {
        begin: /[A-Za-z$_][\u00C0-\u02B80-9A-Za-z$_]*/
      })].concat(KEYWORD_MODES)
    }, OPERATOR_DECLARATION, PRECEDENCEGROUP, {
      beginKeywords: 'import',
      end: /$/,
      contains: [].concat(COMMENTS),
      relevance: 0
    }], KEYWORD_MODES, BUILT_INS, OPERATORS, [NUMBER, STRING], IDENTIFIERS, ATTRIBUTES, [TYPE, TUPLE])
  };
}
module.exports = swift;

/***/ }),

/***/ 97578:
/***/ ((module) => {

/*
Language: Tagger Script
Author: Philipp Wolfer <ph.wolfer@gmail.com>
Description: Syntax Highlighting for the Tagger Script as used by MusicBrainz Picard.
Website: https://picard.musicbrainz.org
 */
function taggerscript(hljs) {
  var COMMENT = {
    className: 'comment',
    begin: /\$noop\(/,
    end: /\)/,
    contains: [{
      begin: /\(/,
      end: /\)/,
      contains: ['self', {
        begin: /\\./
      }]
    }],
    relevance: 10
  };
  var FUNCTION = {
    className: 'keyword',
    begin: /\$(?!noop)[a-zA-Z][_a-zA-Z0-9]*/,
    end: /\(/,
    excludeEnd: true
  };
  var VARIABLE = {
    className: 'variable',
    begin: /%[_a-zA-Z0-9:]*/,
    end: '%'
  };
  var ESCAPE_SEQUENCE = {
    className: 'symbol',
    begin: /\\./
  };
  return {
    name: 'Tagger Script',
    contains: [COMMENT, FUNCTION, VARIABLE, ESCAPE_SEQUENCE]
  };
}
module.exports = taggerscript;

/***/ }),

/***/ 23822:
/***/ ((module) => {

/*
Language: Test Anything Protocol
Description: TAP, the Test Anything Protocol, is a simple text-based interface between testing modules in a test harness.
Requires: yaml.js
Author: Sergey Bronnikov <sergeyb@bronevichok.ru>
Website: https://testanything.org
*/

function tap(hljs) {
  return {
    name: 'Test Anything Protocol',
    case_insensitive: true,
    contains: [hljs.HASH_COMMENT_MODE,
    // version of format and total amount of testcases
    {
      className: 'meta',
      variants: [{
        begin: '^TAP version (\\d+)$'
      }, {
        begin: '^1\\.\\.(\\d+)$'
      }]
    },
    // YAML block
    {
      begin: /---$/,
      end: '\\.\\.\\.$',
      subLanguage: 'yaml',
      relevance: 0
    },
    // testcase number
    {
      className: 'number',
      begin: ' (\\d+) '
    },
    // testcase status and description
    {
      className: 'symbol',
      variants: [{
        begin: '^ok'
      }, {
        begin: '^not ok'
      }]
    }]
  };
}
module.exports = tap;

/***/ }),

/***/ 65837:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function optional(re) {
  return concat('(', re, ')?');
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/*
Language: Tcl
Description: Tcl is a very simple programming language.
Author: Radek Liska <radekliska@gmail.com>
Website: https://www.tcl.tk/about/language.html
*/

function tcl(hljs) {
  var TCL_IDENT = /[a-zA-Z_][a-zA-Z0-9_]*/;
  var NUMBER = {
    className: 'number',
    variants: [hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE]
  };
  return {
    name: 'Tcl',
    aliases: ['tk'],
    keywords: 'after append apply array auto_execok auto_import auto_load auto_mkindex ' + 'auto_mkindex_old auto_qualify auto_reset bgerror binary break catch cd chan clock ' + 'close concat continue dde dict encoding eof error eval exec exit expr fblocked ' + 'fconfigure fcopy file fileevent filename flush for foreach format gets glob global ' + 'history http if incr info interp join lappend|10 lassign|10 lindex|10 linsert|10 list ' + 'llength|10 load lrange|10 lrepeat|10 lreplace|10 lreverse|10 lsearch|10 lset|10 lsort|10 ' + 'mathfunc mathop memory msgcat namespace open package parray pid pkg::create pkg_mkIndex ' + 'platform platform::shell proc puts pwd read refchan regexp registry regsub|10 rename ' + 'return safe scan seek set socket source split string subst switch tcl_endOfWord ' + 'tcl_findLibrary tcl_startOfNextWord tcl_startOfPreviousWord tcl_wordBreakAfter ' + 'tcl_wordBreakBefore tcltest tclvars tell time tm trace unknown unload unset update ' + 'uplevel upvar variable vwait while',
    contains: [hljs.COMMENT(';[ \\t]*#', '$'), hljs.COMMENT('^[ \\t]*#', '$'), {
      beginKeywords: 'proc',
      end: '[\\{]',
      excludeEnd: true,
      contains: [{
        className: 'title',
        begin: '[ \\t\\n\\r]+(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*',
        end: '[ \\t\\n\\r]',
        endsWithParent: true,
        excludeEnd: true
      }]
    }, {
      className: "variable",
      variants: [{
        begin: concat(/\$/, optional(/::/), TCL_IDENT, '(::', TCL_IDENT, ')*')
      }, {
        begin: '\\$\\{(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*',
        end: '\\}',
        contains: [NUMBER]
      }]
    }, {
      className: 'string',
      contains: [hljs.BACKSLASH_ESCAPE],
      variants: [hljs.inherit(hljs.QUOTE_STRING_MODE, {
        illegal: null
      })]
    }, NUMBER]
  };
}
module.exports = tcl;

/***/ }),

/***/ 29677:
/***/ ((module) => {

/*
Language: Thrift
Author: Oleg Efimov <efimovov@gmail.com>
Description: Thrift message definition format
Website: https://thrift.apache.org
Category: protocols
*/

function thrift(hljs) {
  var BUILT_IN_TYPES = 'bool byte i16 i32 i64 double string binary';
  return {
    name: 'Thrift',
    keywords: {
      keyword: 'namespace const typedef struct enum service exception void oneway set list map required optional',
      built_in: BUILT_IN_TYPES,
      literal: 'true false'
    },
    contains: [hljs.QUOTE_STRING_MODE, hljs.NUMBER_MODE, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, {
      className: 'class',
      beginKeywords: 'struct enum service exception',
      end: /\{/,
      illegal: /\n/,
      contains: [hljs.inherit(hljs.TITLE_MODE, {
        // hack: eating everything after the first title
        starts: {
          endsWithParent: true,
          excludeEnd: true
        }
      })]
    }, {
      begin: '\\b(set|list|map)\\s*<',
      end: '>',
      keywords: BUILT_IN_TYPES,
      contains: ['self']
    }]
  };
}
module.exports = thrift;

/***/ }),

/***/ 97029:
/***/ ((module) => {

/*
Language: TP
Author: Jay Strybis <jay.strybis@gmail.com>
Description: FANUC TP programming language (TPP).
*/

function tp(hljs) {
  var TPID = {
    className: 'number',
    begin: '[1-9][0-9]*',
    /* no leading zeros */
    relevance: 0
  };
  var TPLABEL = {
    className: 'symbol',
    begin: ':[^\\]]+'
  };
  var TPDATA = {
    className: 'built_in',
    begin: '(AR|P|PAYLOAD|PR|R|SR|RSR|LBL|VR|UALM|MESSAGE|UTOOL|UFRAME|TIMER|' + 'TIMER_OVERFLOW|JOINT_MAX_SPEED|RESUME_PROG|DIAG_REC)\\[',
    end: '\\]',
    contains: ['self', TPID, TPLABEL]
  };
  var TPIO = {
    className: 'built_in',
    begin: '(AI|AO|DI|DO|F|RI|RO|UI|UO|GI|GO|SI|SO)\\[',
    end: '\\]',
    contains: ['self', TPID, hljs.QUOTE_STRING_MODE, /* for pos section at bottom */
    TPLABEL]
  };
  return {
    name: 'TP',
    keywords: {
      keyword: 'ABORT ACC ADJUST AND AP_LD BREAK CALL CNT COL CONDITION CONFIG DA DB ' + 'DIV DETECT ELSE END ENDFOR ERR_NUM ERROR_PROG FINE FOR GP GUARD INC ' + 'IF JMP LINEAR_MAX_SPEED LOCK MOD MONITOR OFFSET Offset OR OVERRIDE ' + 'PAUSE PREG PTH RT_LD RUN SELECT SKIP Skip TA TB TO TOOL_OFFSET ' + 'Tool_Offset UF UT UFRAME_NUM UTOOL_NUM UNLOCK WAIT X Y Z W P R STRLEN ' + 'SUBSTR FINDSTR VOFFSET PROG ATTR MN POS',
      literal: 'ON OFF max_speed LPOS JPOS ENABLE DISABLE START STOP RESET'
    },
    contains: [TPDATA, TPIO, {
      className: 'keyword',
      begin: '/(PROG|ATTR|MN|POS|END)\\b'
    }, {
      /* this is for cases like ,CALL */
      className: 'keyword',
      begin: '(CALL|RUN|POINT_LOGIC|LBL)\\b'
    }, {
      /* this is for cases like CNT100 where the default lexemes do not
       * separate the keyword and the number */
      className: 'keyword',
      begin: '\\b(ACC|CNT|Skip|Offset|PSPD|RT_LD|AP_LD|Tool_Offset)'
    }, {
      /* to catch numbers that do not have a word boundary on the left */
      className: 'number',
      begin: '\\d+(sec|msec|mm/sec|cm/min|inch/min|deg/sec|mm|in|cm)?\\b',
      relevance: 0
    }, hljs.COMMENT('//', '[;$]'), hljs.COMMENT('!', '[;$]'), hljs.COMMENT('--eg:', '$'), hljs.QUOTE_STRING_MODE, {
      className: 'string',
      begin: '\'',
      end: '\''
    }, hljs.C_NUMBER_MODE, {
      className: 'variable',
      begin: '\\$[A-Za-z0-9_]+'
    }]
  };
}
module.exports = tp;

/***/ }),

/***/ 69878:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(74916);
__webpack_require__(23123);
/*
Language: Twig
Requires: xml.js
Author: Luke Holder <lukemh@gmail.com>
Description: Twig is a templating language for PHP
Website: https://twig.symfony.com
Category: template
*/

function twig(hljs) {
  var PARAMS = {
    className: 'params',
    begin: '\\(',
    end: '\\)'
  };
  var FUNCTION_NAMES = 'attribute block constant cycle date dump include ' + 'max min parent random range source template_from_string';
  var FUNCTIONS = {
    beginKeywords: FUNCTION_NAMES,
    keywords: {
      name: FUNCTION_NAMES
    },
    relevance: 0,
    contains: [PARAMS]
  };
  var FILTER = {
    begin: /\|[A-Za-z_]+:?/,
    keywords: 'abs batch capitalize column convert_encoding date date_modify default ' + 'escape filter first format inky_to_html inline_css join json_encode keys last ' + 'length lower map markdown merge nl2br number_format raw reduce replace ' + 'reverse round slice sort spaceless split striptags title trim upper url_encode',
    contains: [FUNCTIONS]
  };
  var TAGS = 'apply autoescape block deprecated do embed extends filter flush for from ' + 'if import include macro sandbox set use verbatim with';
  TAGS = TAGS + ' ' + TAGS.split(' ').map(function (t) {
    return 'end' + t;
  }).join(' ');
  return {
    name: 'Twig',
    aliases: ['craftcms'],
    case_insensitive: true,
    subLanguage: 'xml',
    contains: [hljs.COMMENT(/\{#/, /#\}/), {
      className: 'template-tag',
      begin: /\{%/,
      end: /%\}/,
      contains: [{
        className: 'name',
        begin: /\w+/,
        keywords: TAGS,
        starts: {
          endsWithParent: true,
          contains: [FILTER, FUNCTIONS],
          relevance: 0
        }
      }]
    }, {
      className: 'template-variable',
      begin: /\{\{/,
      end: /\}\}/,
      contains: ['self', FILTER, FUNCTIONS]
    }]
  };
}
module.exports = twig;

/***/ }),

/***/ 31841:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(47042);
__webpack_require__(34553);
__webpack_require__(40561);
__webpack_require__(19601);
__webpack_require__(69826);
var IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
var KEYWORDS = ["as",
// for exports
"in", "of", "if", "for", "while", "finally", "var", "new", "function", "do", "return", "void", "else", "break", "catch", "instanceof", "with", "throw", "case", "default", "try", "switch", "continue", "typeof", "delete", "let", "yield", "const", "class",
// JS handles these with a special rule
// "get",
// "set",
"debugger", "async", "await", "static", "import", "from", "export", "extends"];
var LITERALS = ["true", "false", "null", "undefined", "NaN", "Infinity"];
var TYPES = ["Intl", "DataView", "Number", "Math", "Date", "String", "RegExp", "Object", "Function", "Boolean", "Error", "Symbol", "Set", "Map", "WeakSet", "WeakMap", "Proxy", "Reflect", "JSON", "Promise", "Float64Array", "Int16Array", "Int32Array", "Int8Array", "Uint16Array", "Uint32Array", "Float32Array", "Array", "Uint8Array", "Uint8ClampedArray", "ArrayBuffer", "BigInt64Array", "BigUint64Array", "BigInt"];
var ERROR_TYPES = ["EvalError", "InternalError", "RangeError", "ReferenceError", "SyntaxError", "TypeError", "URIError"];
var BUILT_IN_GLOBALS = ["setInterval", "setTimeout", "clearInterval", "clearTimeout", "require", "exports", "eval", "isFinite", "isNaN", "parseFloat", "parseInt", "decodeURI", "decodeURIComponent", "encodeURI", "encodeURIComponent", "escape", "unescape"];
var BUILT_IN_VARIABLES = ["arguments", "this", "super", "console", "window", "document", "localStorage", "module", "global" // Node.js
];

var BUILT_INS = [].concat(BUILT_IN_GLOBALS, BUILT_IN_VARIABLES, TYPES, ERROR_TYPES);

/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function lookahead(re) {
  return concat('(?=', re, ')');
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/*
Language: JavaScript
Description: JavaScript (JS) is a lightweight, interpreted, or just-in-time compiled programming language with first-class functions.
Category: common, scripting
Website: https://developer.mozilla.org/en-US/docs/Web/JavaScript
*/

/** @type LanguageFn */
function javascript(hljs) {
  /**
   * Takes a string like "<Booger" and checks to see
   * if we can find a matching "</Booger" later in the
   * content.
   * @param {RegExpMatchArray} match
   * @param {{after:number}} param1
   */
  var hasClosingTag = function hasClosingTag(match, _ref) {
    var after = _ref.after;
    var tag = "</" + match[0].slice(1);
    var pos = match.input.indexOf(tag, after);
    return pos !== -1;
  };
  var IDENT_RE$1 = IDENT_RE;
  var FRAGMENT = {
    begin: '<>',
    end: '</>'
  };
  var XML_TAG = {
    begin: /<[A-Za-z0-9\\._:-]+/,
    end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
    /**
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */
    isTrulyOpeningTag: function isTrulyOpeningTag(match, response) {
      var afterMatchIndex = match[0].length + match.index;
      var nextChar = match.input[afterMatchIndex];
      // nested type?
      // HTML should not include another raw `<` inside a tag
      // But a type might: `<Array<Array<number>>`, etc.
      if (nextChar === "<") {
        response.ignoreMatch();
        return;
      }
      // <something>
      // This is now either a tag or a type.
      if (nextChar === ">") {
        // if we cannot find a matching closing tag, then we
        // will ignore it
        if (!hasClosingTag(match, {
          after: afterMatchIndex
        })) {
          response.ignoreMatch();
        }
      }
    }
  };
  var KEYWORDS$1 = {
    $pattern: IDENT_RE,
    keyword: KEYWORDS,
    literal: LITERALS,
    built_in: BUILT_INS
  };

  // https://tc39.es/ecma262/#sec-literals-numeric-literals
  var decimalDigits = '[0-9](_?[0-9])*';
  var frac = "\\.(".concat(decimalDigits, ")");
  // DecimalIntegerLiteral, including Annex B NonOctalDecimalIntegerLiteral
  // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
  var decimalInteger = "0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*";
  var NUMBER = {
    className: 'number',
    variants: [
    // DecimalLiteral
    {
      begin: "(\\b(".concat(decimalInteger, ")((").concat(frac, ")|\\.)?|(").concat(frac, "))") + "[eE][+-]?(".concat(decimalDigits, ")\\b")
    }, {
      begin: "\\b(".concat(decimalInteger, ")\\b((").concat(frac, ")\\b|\\.)?|(").concat(frac, ")\\b")
    },
    // DecimalBigIntegerLiteral
    {
      begin: "\\b(0|[1-9](_?[0-9])*)n\\b"
    },
    // NonDecimalIntegerLiteral
    {
      begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b"
    }, {
      begin: "\\b0[bB][0-1](_?[0-1])*n?\\b"
    }, {
      begin: "\\b0[oO][0-7](_?[0-7])*n?\\b"
    },
    // LegacyOctalIntegerLiteral (does not include underscore separators)
    // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
    {
      begin: "\\b0[0-7]+n?\\b"
    }],
    relevance: 0
  };
  var SUBST = {
    className: 'subst',
    begin: '\\$\\{',
    end: '\\}',
    keywords: KEYWORDS$1,
    contains: [] // defined later
  };

  var HTML_TEMPLATE = {
    begin: 'html`',
    end: '',
    starts: {
      end: '`',
      returnEnd: false,
      contains: [hljs.BACKSLASH_ESCAPE, SUBST],
      subLanguage: 'xml'
    }
  };
  var CSS_TEMPLATE = {
    begin: 'css`',
    end: '',
    starts: {
      end: '`',
      returnEnd: false,
      contains: [hljs.BACKSLASH_ESCAPE, SUBST],
      subLanguage: 'css'
    }
  };
  var TEMPLATE_STRING = {
    className: 'string',
    begin: '`',
    end: '`',
    contains: [hljs.BACKSLASH_ESCAPE, SUBST]
  };
  var JSDOC_COMMENT = hljs.COMMENT(/\/\*\*(?!\/)/, '\\*/', {
    relevance: 0,
    contains: [{
      className: 'doctag',
      begin: '@[A-Za-z]+',
      contains: [{
        className: 'type',
        begin: '\\{',
        end: '\\}',
        relevance: 0
      }, {
        className: 'variable',
        begin: IDENT_RE$1 + '(?=\\s*(-)|$)',
        endsParent: true,
        relevance: 0
      },
      // eat spaces (not newlines) so we can find
      // types or variables
      {
        begin: /(?=[^\n])\s/,
        relevance: 0
      }]
    }]
  });
  var COMMENT = {
    className: "comment",
    variants: [JSDOC_COMMENT, hljs.C_BLOCK_COMMENT_MODE, hljs.C_LINE_COMMENT_MODE]
  };
  var SUBST_INTERNALS = [hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, HTML_TEMPLATE, CSS_TEMPLATE, TEMPLATE_STRING, NUMBER, hljs.REGEXP_MODE];
  SUBST.contains = SUBST_INTERNALS.concat({
    // we need to pair up {} inside our subst to prevent
    // it from ending too early by matching another }
    begin: /\{/,
    end: /\}/,
    keywords: KEYWORDS$1,
    contains: ["self"].concat(SUBST_INTERNALS)
  });
  var SUBST_AND_COMMENTS = [].concat(COMMENT, SUBST.contains);
  var PARAMS_CONTAINS = SUBST_AND_COMMENTS.concat([
  // eat recursive parens in sub expressions
  {
    begin: /\(/,
    end: /\)/,
    keywords: KEYWORDS$1,
    contains: ["self"].concat(SUBST_AND_COMMENTS)
  }]);
  var PARAMS = {
    className: 'params',
    begin: /\(/,
    end: /\)/,
    excludeBegin: true,
    excludeEnd: true,
    keywords: KEYWORDS$1,
    contains: PARAMS_CONTAINS
  };
  return {
    name: 'Javascript',
    aliases: ['js', 'jsx', 'mjs', 'cjs'],
    keywords: KEYWORDS$1,
    // this will be extended by TypeScript
    exports: {
      PARAMS_CONTAINS: PARAMS_CONTAINS
    },
    illegal: /#(?![$_A-z])/,
    contains: [hljs.SHEBANG({
      label: "shebang",
      binary: "node",
      relevance: 5
    }), {
      label: "use_strict",
      className: 'meta',
      relevance: 10,
      begin: /^\s*['"]use (strict|asm)['"]/
    }, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, HTML_TEMPLATE, CSS_TEMPLATE, TEMPLATE_STRING, COMMENT, NUMBER, {
      // object attr container
      begin: concat(/[{,\n]\s*/,
      // we need to look ahead to make sure that we actually have an
      // attribute coming up so we don't steal a comma from a potential
      // "value" container
      //
      // NOTE: this might not work how you think.  We don't actually always
      // enter this mode and stay.  Instead it might merely match `,
      // <comments up next>` and then immediately end after the , because it
      // fails to find any actual attrs. But this still does the job because
      // it prevents the value contain rule from grabbing this instead and
      // prevening this rule from firing when we actually DO have keys.
      lookahead(concat(
      // we also need to allow for multiple possible comments inbetween
      // the first key:value pairing
      /(((\/\/.*$)|(\/\*(\*[^/]|[^*])*\*\/))\s*)*/, IDENT_RE$1 + '\\s*:'))),
      relevance: 0,
      contains: [{
        className: 'attr',
        begin: IDENT_RE$1 + lookahead('\\s*:'),
        relevance: 0
      }]
    }, {
      // "value" container
      begin: '(' + hljs.RE_STARTERS_RE + '|\\b(case|return|throw)\\b)\\s*',
      keywords: 'return throw case',
      contains: [COMMENT, hljs.REGEXP_MODE, {
        className: 'function',
        // we have to count the parens to make sure we actually have the
        // correct bounding ( ) before the =>.  There could be any number of
        // sub-expressions inside also surrounded by parens.
        begin: '(\\(' + '[^()]*(\\(' + '[^()]*(\\(' + '[^()]*' + '\\)[^()]*)*' + '\\)[^()]*)*' + '\\)|' + hljs.UNDERSCORE_IDENT_RE + ')\\s*=>',
        returnBegin: true,
        end: '\\s*=>',
        contains: [{
          className: 'params',
          variants: [{
            begin: hljs.UNDERSCORE_IDENT_RE,
            relevance: 0
          }, {
            className: null,
            begin: /\(\s*\)/,
            skip: true
          }, {
            begin: /\(/,
            end: /\)/,
            excludeBegin: true,
            excludeEnd: true,
            keywords: KEYWORDS$1,
            contains: PARAMS_CONTAINS
          }]
        }]
      }, {
        // could be a comma delimited list of params to a function call
        begin: /,/,
        relevance: 0
      }, {
        className: '',
        begin: /\s/,
        end: /\s*/,
        skip: true
      }, {
        // JSX
        variants: [{
          begin: FRAGMENT.begin,
          end: FRAGMENT.end
        }, {
          begin: XML_TAG.begin,
          // we carefully check the opening tag to see if it truly
          // is a tag and not a false positive
          'on:begin': XML_TAG.isTrulyOpeningTag,
          end: XML_TAG.end
        }],
        subLanguage: 'xml',
        contains: [{
          begin: XML_TAG.begin,
          end: XML_TAG.end,
          skip: true,
          contains: ['self']
        }]
      }],
      relevance: 0
    }, {
      className: 'function',
      beginKeywords: 'function',
      end: /[{;]/,
      excludeEnd: true,
      keywords: KEYWORDS$1,
      contains: ['self', hljs.inherit(hljs.TITLE_MODE, {
        begin: IDENT_RE$1
      }), PARAMS],
      illegal: /%/
    }, {
      // prevent this from getting swallowed up by function
      // since they appear "function like"
      beginKeywords: "while if switch catch for"
    }, {
      className: 'function',
      // we have to count the parens to make sure we actually have the correct
      // bounding ( ).  There could be any number of sub-expressions inside
      // also surrounded by parens.
      begin: hljs.UNDERSCORE_IDENT_RE + '\\(' +
      // first parens
      '[^()]*(\\(' + '[^()]*(\\(' + '[^()]*' + '\\)[^()]*)*' + '\\)[^()]*)*' + '\\)\\s*\\{',
      // end parens
      returnBegin: true,
      contains: [PARAMS, hljs.inherit(hljs.TITLE_MODE, {
        begin: IDENT_RE$1
      })]
    },
    // hack: prevents detection of keywords in some circumstances
    // .keyword()
    // $keyword = x
    {
      variants: [{
        begin: '\\.' + IDENT_RE$1
      }, {
        begin: '\\$' + IDENT_RE$1
      }],
      relevance: 0
    }, {
      // ES6 class
      className: 'class',
      beginKeywords: 'class',
      end: /[{;=]/,
      excludeEnd: true,
      illegal: /[:"[\]]/,
      contains: [{
        beginKeywords: 'extends'
      }, hljs.UNDERSCORE_TITLE_MODE]
    }, {
      begin: /\b(?=constructor)/,
      end: /[{;]/,
      excludeEnd: true,
      contains: [hljs.inherit(hljs.TITLE_MODE, {
        begin: IDENT_RE$1
      }), 'self', PARAMS]
    }, {
      begin: '(get|set)\\s+(?=' + IDENT_RE$1 + '\\()',
      end: /\{/,
      keywords: "get set",
      contains: [hljs.inherit(hljs.TITLE_MODE, {
        begin: IDENT_RE$1
      }), {
        begin: /\(\)/
      },
      // eat to avoid empty params
      PARAMS]
    }, {
      begin: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
    }]
  };
}

/*
Language: TypeScript
Author: Panu Horsmalahti <panu.horsmalahti@iki.fi>
Contributors: Ike Ku <dempfi@yahoo.com>
Description: TypeScript is a strict superset of JavaScript
Website: https://www.typescriptlang.org
Category: common, scripting
*/

/** @type LanguageFn */
function typescript(hljs) {
  var IDENT_RE$1 = IDENT_RE;
  var NAMESPACE = {
    beginKeywords: 'namespace',
    end: /\{/,
    excludeEnd: true
  };
  var INTERFACE = {
    beginKeywords: 'interface',
    end: /\{/,
    excludeEnd: true,
    keywords: 'interface extends'
  };
  var USE_STRICT = {
    className: 'meta',
    relevance: 10,
    begin: /^\s*['"]use strict['"]/
  };
  var TYPES = ["any", "void", "number", "boolean", "string", "object", "never", "enum"];
  var TS_SPECIFIC_KEYWORDS = ["type", "namespace", "typedef", "interface", "public", "private", "protected", "implements", "declare", "abstract", "readonly"];
  var KEYWORDS$1 = {
    $pattern: IDENT_RE,
    keyword: KEYWORDS.concat(TS_SPECIFIC_KEYWORDS),
    literal: LITERALS,
    built_in: BUILT_INS.concat(TYPES)
  };
  var DECORATOR = {
    className: 'meta',
    begin: '@' + IDENT_RE$1
  };
  var swapMode = function swapMode(mode, label, replacement) {
    var indx = mode.contains.findIndex(function (m) {
      return m.label === label;
    });
    if (indx === -1) {
      throw new Error("can not find mode to replace");
    }
    mode.contains.splice(indx, 1, replacement);
  };
  var tsLanguage = javascript(hljs);

  // this should update anywhere keywords is used since
  // it will be the same actual JS object
  Object.assign(tsLanguage.keywords, KEYWORDS$1);
  tsLanguage.exports.PARAMS_CONTAINS.push(DECORATOR);
  tsLanguage.contains = tsLanguage.contains.concat([DECORATOR, NAMESPACE, INTERFACE]);

  // TS gets a simpler shebang rule than JS
  swapMode(tsLanguage, "shebang", hljs.SHEBANG());
  // JS use strict rule purposely excludes `asm` which makes no sense
  swapMode(tsLanguage, "use_strict", USE_STRICT);
  var functionDeclaration = tsLanguage.contains.find(function (m) {
    return m.className === "function";
  });
  functionDeclaration.relevance = 0; // () => {} is more typical in TypeScript

  Object.assign(tsLanguage, {
    name: 'TypeScript',
    aliases: ['ts', 'tsx']
  });
  return tsLanguage;
}
module.exports = typescript;

/***/ }),

/***/ 86236:
/***/ ((module) => {

/*
Language: Vala
Author: Antono Vasiljev <antono.vasiljev@gmail.com>
Description: Vala is a new programming language that aims to bring modern programming language features to GNOME developers without imposing any additional runtime requirements and without using a different ABI compared to applications and libraries written in C.
Website: https://wiki.gnome.org/Projects/Vala
*/

function vala(hljs) {
  return {
    name: 'Vala',
    keywords: {
      keyword:
      // Value types
      'char uchar unichar int uint long ulong short ushort int8 int16 int32 int64 uint8 ' + 'uint16 uint32 uint64 float double bool struct enum string void ' +
      // Reference types
      'weak unowned owned ' +
      // Modifiers
      'async signal static abstract interface override virtual delegate ' +
      // Control Structures
      'if while do for foreach else switch case break default return try catch ' +
      // Visibility
      'public private protected internal ' +
      // Other
      'using new this get set const stdout stdin stderr var',
      built_in: 'DBus GLib CCode Gee Object Gtk Posix',
      literal: 'false true null'
    },
    contains: [{
      className: 'class',
      beginKeywords: 'class interface namespace',
      end: /\{/,
      excludeEnd: true,
      illegal: '[^,:\\n\\s\\.]',
      contains: [hljs.UNDERSCORE_TITLE_MODE]
    }, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, {
      className: 'string',
      begin: '"""',
      end: '"""',
      relevance: 5
    }, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, hljs.C_NUMBER_MODE, {
      className: 'meta',
      begin: '^#',
      end: '$',
      relevance: 2
    }]
  };
}
module.exports = vala;

/***/ }),

/***/ 55962:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */
function either() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var joined = '(' + args.map(function (x) {
    return source(x);
  }).join("|") + ")";
  return joined;
}

/*
Language: Visual Basic .NET
Description: Visual Basic .NET (VB.NET) is a multi-paradigm, object-oriented programming language, implemented on the .NET Framework.
Authors: Poren Chiang <ren.chiang@gmail.com>, Jan Pilzer
Website: https://docs.microsoft.com/dotnet/visual-basic/getting-started
Category: common
*/

/** @type LanguageFn */
function vbnet(hljs) {
  /**
   * Character Literal
   * Either a single character ("a"C) or an escaped double quote (""""C).
   */
  var CHARACTER = {
    className: 'string',
    begin: /"(""|[^/n])"C\b/
  };
  var STRING = {
    className: 'string',
    begin: /"/,
    end: /"/,
    illegal: /\n/,
    contains: [{
      // double quote escape
      begin: /""/
    }]
  };

  /** Date Literals consist of a date, a time, or both separated by whitespace, surrounded by # */
  var MM_DD_YYYY = /\d{1,2}\/\d{1,2}\/\d{4}/;
  var YYYY_MM_DD = /\d{4}-\d{1,2}-\d{1,2}/;
  var TIME_12H = /(\d|1[012])(:\d+){0,2} *(AM|PM)/;
  var TIME_24H = /\d{1,2}(:\d{1,2}){1,2}/;
  var DATE = {
    className: 'literal',
    variants: [{
      // #YYYY-MM-DD# (ISO-Date) or #M/D/YYYY# (US-Date)
      begin: concat(/# */, either(YYYY_MM_DD, MM_DD_YYYY), / *#/)
    }, {
      // #H:mm[:ss]# (24h Time)
      begin: concat(/# */, TIME_24H, / *#/)
    }, {
      // #h[:mm[:ss]] A# (12h Time)
      begin: concat(/# */, TIME_12H, / *#/)
    }, {
      // date plus time
      begin: concat(/# */, either(YYYY_MM_DD, MM_DD_YYYY), / +/, either(TIME_12H, TIME_24H), / *#/)
    }]
  };
  var NUMBER = {
    className: 'number',
    relevance: 0,
    variants: [{
      // Float
      begin: /\b\d[\d_]*((\.[\d_]+(E[+-]?[\d_]+)?)|(E[+-]?[\d_]+))[RFD@!#]?/
    }, {
      // Integer (base 10)
      begin: /\b\d[\d_]*((U?[SIL])|[%&])?/
    }, {
      // Integer (base 16)
      begin: /&H[\dA-F_]+((U?[SIL])|[%&])?/
    }, {
      // Integer (base 8)
      begin: /&O[0-7_]+((U?[SIL])|[%&])?/
    }, {
      // Integer (base 2)
      begin: /&B[01_]+((U?[SIL])|[%&])?/
    }]
  };
  var LABEL = {
    className: 'label',
    begin: /^\w+:/
  };
  var DOC_COMMENT = hljs.COMMENT(/'''/, /$/, {
    contains: [{
      className: 'doctag',
      begin: /<\/?/,
      end: />/
    }]
  });
  var COMMENT = hljs.COMMENT(null, /$/, {
    variants: [{
      begin: /'/
    }, {
      // TODO: Use `beforeMatch:` for leading spaces
      begin: /([\t ]|^)REM(?=\s)/
    }]
  });
  var DIRECTIVES = {
    className: 'meta',
    // TODO: Use `beforeMatch:` for indentation once available
    begin: /[\t ]*#(const|disable|else|elseif|enable|end|externalsource|if|region)\b/,
    end: /$/,
    keywords: {
      'meta-keyword': 'const disable else elseif enable end externalsource if region then'
    },
    contains: [COMMENT]
  };
  return {
    name: 'Visual Basic .NET',
    aliases: ['vb'],
    case_insensitive: true,
    classNameAliases: {
      label: 'symbol'
    },
    keywords: {
      keyword: 'addhandler alias aggregate ansi as async assembly auto binary by byref byval ' + /* a-b */
      'call case catch class compare const continue custom declare default delegate dim distinct do ' + /* c-d */
      'each equals else elseif end enum erase error event exit explicit finally for friend from function ' + /* e-f */
      'get global goto group handles if implements imports in inherits interface into iterator ' + /* g-i */
      'join key let lib loop me mid module mustinherit mustoverride mybase myclass ' + /* j-m */
      'namespace narrowing new next notinheritable notoverridable ' + /* n */
      'of off on operator option optional order overloads overridable overrides ' + /* o */
      'paramarray partial preserve private property protected public ' + /* p */
      'raiseevent readonly redim removehandler resume return ' + /* r */
      'select set shadows shared skip static step stop structure strict sub synclock ' + /* s */
      'take text then throw to try unicode until using when where while widening with withevents writeonly yield' /* t-y */,
      built_in:
      // Operators https://docs.microsoft.com/dotnet/visual-basic/language-reference/operators
      'addressof and andalso await directcast gettype getxmlnamespace is isfalse isnot istrue like mod nameof new not or orelse trycast typeof xor ' +
      // Type Conversion Functions https://docs.microsoft.com/dotnet/visual-basic/language-reference/functions/type-conversion-functions
      'cbool cbyte cchar cdate cdbl cdec cint clng cobj csbyte cshort csng cstr cuint culng cushort',
      type:
      // Data types https://docs.microsoft.com/dotnet/visual-basic/language-reference/data-types
      'boolean byte char date decimal double integer long object sbyte short single string uinteger ulong ushort',
      literal: 'true false nothing'
    },
    illegal: '//|\\{|\\}|endif|gosub|variant|wend|^\\$ ' /* reserved deprecated keywords */,
    contains: [CHARACTER, STRING, DATE, NUMBER, LABEL, DOC_COMMENT, COMMENT, DIRECTIVES]
  };
}
module.exports = vbnet;

/***/ }),

/***/ 26835:
/***/ ((module) => {

/*
Language: VBScript in HTML
Requires: xml.js, vbscript.js
Author: Ivan Sagalaev <maniac@softwaremaniacs.org>
Description: "Bridge" language defining fragments of VBScript in HTML within <% .. %>
Website: https://en.wikipedia.org/wiki/VBScript
Category: scripting
*/

function vbscriptHtml(hljs) {
  return {
    name: 'VBScript in HTML',
    subLanguage: 'xml',
    contains: [{
      begin: '<%',
      end: '%>',
      subLanguage: 'vbscript'
    }]
  };
}
module.exports = vbscriptHtml;

/***/ }),

/***/ 33095:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(74916);
__webpack_require__(23123);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(91038);
__webpack_require__(47042);
__webpack_require__(68309);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */
function either() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var joined = '(' + args.map(function (x) {
    return source(x);
  }).join("|") + ")";
  return joined;
}

/*
Language: VBScript
Description: VBScript ("Microsoft Visual Basic Scripting Edition") is an Active Scripting language developed by Microsoft that is modeled on Visual Basic.
Author: Nikita Ledyaev <lenikita@yandex.ru>
Contributors: Michal Gabrukiewicz <mgabru@gmail.com>
Website: https://en.wikipedia.org/wiki/VBScript
Category: scripting
*/

/** @type LanguageFn */
function vbscript(hljs) {
  var BUILT_IN_FUNCTIONS = ('lcase month vartype instrrev ubound setlocale getobject rgb getref string ' + 'weekdayname rnd dateadd monthname now day minute isarray cbool round formatcurrency ' + 'conversions csng timevalue second year space abs clng timeserial fixs len asc ' + 'isempty maths dateserial atn timer isobject filter weekday datevalue ccur isdate ' + 'instr datediff formatdatetime replace isnull right sgn array snumeric log cdbl hex ' + 'chr lbound msgbox ucase getlocale cos cdate cbyte rtrim join hour oct typename trim ' + 'strcomp int createobject loadpicture tan formatnumber mid ' + 'split  cint sin datepart ltrim sqr ' + 'time derived eval date formatpercent exp inputbox left ascw ' + 'chrw regexp cstr err').split(" ");
  var BUILT_IN_OBJECTS = ["server", "response", "request",
  // take no arguments so can be called without ()
  "scriptengine", "scriptenginebuildversion", "scriptengineminorversion", "scriptenginemajorversion"];
  var BUILT_IN_CALL = {
    begin: concat(either.apply(void 0, _toConsumableArray(BUILT_IN_FUNCTIONS)), "\\s*\\("),
    // relevance 0 because this is acting as a beginKeywords really
    relevance: 0,
    keywords: {
      built_in: BUILT_IN_FUNCTIONS
    }
  };
  return {
    name: 'VBScript',
    aliases: ['vbs'],
    case_insensitive: true,
    keywords: {
      keyword: 'call class const dim do loop erase execute executeglobal exit for each next function ' + 'if then else on error option explicit new private property let get public randomize ' + 'redim rem select case set stop sub while wend with end to elseif is or xor and not ' + 'class_initialize class_terminate default preserve in me byval byref step resume goto',
      built_in: BUILT_IN_OBJECTS,
      literal: 'true false null nothing empty'
    },
    illegal: '//',
    contains: [BUILT_IN_CALL, hljs.inherit(hljs.QUOTE_STRING_MODE, {
      contains: [{
        begin: '""'
      }]
    }), hljs.COMMENT(/'/, /$/, {
      relevance: 0
    }), hljs.C_NUMBER_MODE]
  };
}
module.exports = vbscript;

/***/ }),

/***/ 21554:
/***/ ((module) => {

/*
Language: Verilog
Author: Jon Evans <jon@craftyjon.com>
Contributors: Boone Severson <boone.severson@gmail.com>
Description: Verilog is a hardware description language used in electronic design automation to describe digital and mixed-signal systems. This highlighter supports Verilog and SystemVerilog through IEEE 1800-2012.
Website: http://www.verilog.com
*/

function verilog(hljs) {
  var SV_KEYWORDS = {
    $pattern: /[\w\$]+/,
    keyword: 'accept_on alias always always_comb always_ff always_latch and assert assign ' + 'assume automatic before begin bind bins binsof bit break buf|0 bufif0 bufif1 ' + 'byte case casex casez cell chandle checker class clocking cmos config const ' + 'constraint context continue cover covergroup coverpoint cross deassign default ' + 'defparam design disable dist do edge else end endcase endchecker endclass ' + 'endclocking endconfig endfunction endgenerate endgroup endinterface endmodule ' + 'endpackage endprimitive endprogram endproperty endspecify endsequence endtable ' + 'endtask enum event eventually expect export extends extern final first_match for ' + 'force foreach forever fork forkjoin function generate|5 genvar global highz0 highz1 ' + 'if iff ifnone ignore_bins illegal_bins implements implies import incdir include ' + 'initial inout input inside instance int integer interconnect interface intersect ' + 'join join_any join_none large let liblist library local localparam logic longint ' + 'macromodule matches medium modport module nand negedge nettype new nexttime nmos ' + 'nor noshowcancelled not notif0 notif1 or output package packed parameter pmos ' + 'posedge primitive priority program property protected pull0 pull1 pulldown pullup ' + 'pulsestyle_ondetect pulsestyle_onevent pure rand randc randcase randsequence rcmos ' + 'real realtime ref reg reject_on release repeat restrict return rnmos rpmos rtran ' + 'rtranif0 rtranif1 s_always s_eventually s_nexttime s_until s_until_with scalared ' + 'sequence shortint shortreal showcancelled signed small soft solve specify specparam ' + 'static string strong strong0 strong1 struct super supply0 supply1 sync_accept_on ' + 'sync_reject_on table tagged task this throughout time timeprecision timeunit tran ' + 'tranif0 tranif1 tri tri0 tri1 triand trior trireg type typedef union unique unique0 ' + 'unsigned until until_with untyped use uwire var vectored virtual void wait wait_order ' + 'wand weak weak0 weak1 while wildcard wire with within wor xnor xor',
    literal: 'null',
    built_in: '$finish $stop $exit $fatal $error $warning $info $realtime $time $printtimescale ' + '$bitstoreal $bitstoshortreal $itor $signed $cast $bits $stime $timeformat ' + '$realtobits $shortrealtobits $rtoi $unsigned $asserton $assertkill $assertpasson ' + '$assertfailon $assertnonvacuouson $assertoff $assertcontrol $assertpassoff ' + '$assertfailoff $assertvacuousoff $isunbounded $sampled $fell $changed $past_gclk ' + '$fell_gclk $changed_gclk $rising_gclk $steady_gclk $coverage_control ' + '$coverage_get $coverage_save $set_coverage_db_name $rose $stable $past ' + '$rose_gclk $stable_gclk $future_gclk $falling_gclk $changing_gclk $display ' + '$coverage_get_max $coverage_merge $get_coverage $load_coverage_db $typename ' + '$unpacked_dimensions $left $low $increment $clog2 $ln $log10 $exp $sqrt $pow ' + '$floor $ceil $sin $cos $tan $countbits $onehot $isunknown $fatal $warning ' + '$dimensions $right $high $size $asin $acos $atan $atan2 $hypot $sinh $cosh ' + '$tanh $asinh $acosh $atanh $countones $onehot0 $error $info $random ' + '$dist_chi_square $dist_erlang $dist_exponential $dist_normal $dist_poisson ' + '$dist_t $dist_uniform $q_initialize $q_remove $q_exam $async$and$array ' + '$async$nand$array $async$or$array $async$nor$array $sync$and$array ' + '$sync$nand$array $sync$or$array $sync$nor$array $q_add $q_full $psprintf ' + '$async$and$plane $async$nand$plane $async$or$plane $async$nor$plane ' + '$sync$and$plane $sync$nand$plane $sync$or$plane $sync$nor$plane $system ' + '$display $displayb $displayh $displayo $strobe $strobeb $strobeh $strobeo ' + '$write $readmemb $readmemh $writememh $value$plusargs ' + '$dumpvars $dumpon $dumplimit $dumpports $dumpportson $dumpportslimit ' + '$writeb $writeh $writeo $monitor $monitorb $monitorh $monitoro $writememb ' + '$dumpfile $dumpoff $dumpall $dumpflush $dumpportsoff $dumpportsall ' + '$dumpportsflush $fclose $fdisplay $fdisplayb $fdisplayh $fdisplayo ' + '$fstrobe $fstrobeb $fstrobeh $fstrobeo $swrite $swriteb $swriteh ' + '$swriteo $fscanf $fread $fseek $fflush $feof $fopen $fwrite $fwriteb ' + '$fwriteh $fwriteo $fmonitor $fmonitorb $fmonitorh $fmonitoro $sformat ' + '$sformatf $fgetc $ungetc $fgets $sscanf $rewind $ftell $ferror'
  };
  return {
    name: 'Verilog',
    aliases: ['v', 'sv', 'svh'],
    case_insensitive: false,
    keywords: SV_KEYWORDS,
    contains: [hljs.C_BLOCK_COMMENT_MODE, hljs.C_LINE_COMMENT_MODE, hljs.QUOTE_STRING_MODE, {
      className: 'number',
      contains: [hljs.BACKSLASH_ESCAPE],
      variants: [{
        begin: '\\b((\\d+\'(b|h|o|d|B|H|O|D))[0-9xzXZa-fA-F_]+)'
      }, {
        begin: '\\B((\'(b|h|o|d|B|H|O|D))[0-9xzXZa-fA-F_]+)'
      }, {
        begin: '\\b([0-9_])+',
        relevance: 0
      }]
    }, /* parameters to instances */
    {
      className: 'variable',
      variants: [{
        begin: '#\\((?!parameter).+\\)'
      }, {
        begin: '\\.\\w+',
        relevance: 0
      }]
    }, {
      className: 'meta',
      begin: '`',
      end: '$',
      keywords: {
        'meta-keyword': 'define __FILE__ ' + '__LINE__ begin_keywords celldefine default_nettype define ' + 'else elsif end_keywords endcelldefine endif ifdef ifndef ' + 'include line nounconnected_drive pragma resetall timescale ' + 'unconnected_drive undef undefineall'
      },
      relevance: 0
    }]
  };
}
module.exports = verilog;

/***/ }),

/***/ 90172:
/***/ ((module) => {

/*
Language: VHDL
Author: Igor Kalnitsky <igor@kalnitsky.org>
Contributors: Daniel C.K. Kho <daniel.kho@tauhop.com>, Guillaume Savaton <guillaume.savaton@eseo.fr>
Description: VHDL is a hardware description language used in electronic design automation to describe digital and mixed-signal systems.
Website: https://en.wikipedia.org/wiki/VHDL
*/

function vhdl(hljs) {
  // Regular expression for VHDL numeric literals.

  // Decimal literal:
  var INTEGER_RE = '\\d(_|\\d)*';
  var EXPONENT_RE = '[eE][-+]?' + INTEGER_RE;
  var DECIMAL_LITERAL_RE = INTEGER_RE + '(\\.' + INTEGER_RE + ')?' + '(' + EXPONENT_RE + ')?';
  // Based literal:
  var BASED_INTEGER_RE = '\\w+';
  var BASED_LITERAL_RE = INTEGER_RE + '#' + BASED_INTEGER_RE + '(\\.' + BASED_INTEGER_RE + ')?' + '#' + '(' + EXPONENT_RE + ')?';
  var NUMBER_RE = '\\b(' + BASED_LITERAL_RE + '|' + DECIMAL_LITERAL_RE + ')';
  return {
    name: 'VHDL',
    case_insensitive: true,
    keywords: {
      keyword: 'abs access after alias all and architecture array assert assume assume_guarantee attribute ' + 'begin block body buffer bus case component configuration constant context cover disconnect ' + 'downto default else elsif end entity exit fairness file for force function generate ' + 'generic group guarded if impure in inertial inout is label library linkage literal ' + 'loop map mod nand new next nor not null of on open or others out package parameter port ' + 'postponed procedure process property protected pure range record register reject ' + 'release rem report restrict restrict_guarantee return rol ror select sequence ' + 'severity shared signal sla sll sra srl strong subtype then to transport type ' + 'unaffected units until use variable view vmode vprop vunit wait when while with xnor xor',
      built_in: 'boolean bit character ' + 'integer time delay_length natural positive ' + 'string bit_vector file_open_kind file_open_status ' + 'std_logic std_logic_vector unsigned signed boolean_vector integer_vector ' + 'std_ulogic std_ulogic_vector unresolved_unsigned u_unsigned unresolved_signed u_signed ' + 'real_vector time_vector',
      literal: 'false true note warning error failure ' +
      // severity_level
      'line text side width' // textio
    },

    illegal: /\{/,
    contains: [hljs.C_BLOCK_COMMENT_MODE,
    // VHDL-2008 block commenting.
    hljs.COMMENT('--', '$'), hljs.QUOTE_STRING_MODE, {
      className: 'number',
      begin: NUMBER_RE,
      relevance: 0
    }, {
      className: 'string',
      begin: '\'(U|X|0|1|Z|W|L|H|-)\'',
      contains: [hljs.BACKSLASH_ESCAPE]
    }, {
      className: 'symbol',
      begin: '\'[A-Za-z](_?[A-Za-z0-9])*',
      contains: [hljs.BACKSLASH_ESCAPE]
    }]
  };
}
module.exports = vhdl;

/***/ }),

/***/ 24431:
/***/ ((module) => {

/*
Language: Vim Script
Author: Jun Yang <yangjvn@126.com>
Description: full keyword and built-in from http://vimdoc.sourceforge.net/htmldoc/
Website: https://www.vim.org
Category: scripting
*/

function vim(hljs) {
  return {
    name: 'Vim Script',
    keywords: {
      $pattern: /[!#@\w]+/,
      keyword:
      // express version except: ! & * < = > !! # @ @@
      'N|0 P|0 X|0 a|0 ab abc abo al am an|0 ar arga argd arge argdo argg argl argu as au aug aun b|0 bN ba bad bd be bel bf bl bm bn bo bp br brea breaka breakd breakl bro bufdo buffers bun bw c|0 cN cNf ca cabc caddb cad caddf cal cat cb cc ccl cd ce cex cf cfir cgetb cgete cg changes chd che checkt cl cla clo cm cmapc cme cn cnew cnf cno cnorea cnoreme co col colo com comc comp con conf cope ' + 'cp cpf cq cr cs cst cu cuna cunme cw delm deb debugg delc delf dif diffg diffo diffp diffpu diffs diffthis dig di dl dell dj dli do doautoa dp dr ds dsp e|0 ea ec echoe echoh echom echon el elsei em en endfo endf endt endw ene ex exe exi exu f|0 files filet fin fina fini fir fix fo foldc foldd folddoc foldo for fu go gr grepa gu gv ha helpf helpg helpt hi hid his ia iabc if ij il im imapc ' + 'ime ino inorea inoreme int is isp iu iuna iunme j|0 ju k|0 keepa kee keepj lN lNf l|0 lad laddb laddf la lan lat lb lc lch lcl lcs le lefta let lex lf lfir lgetb lgete lg lgr lgrepa lh ll lla lli lmak lm lmapc lne lnew lnf ln loadk lo loc lockv lol lope lp lpf lr ls lt lu lua luad luaf lv lvimgrepa lw m|0 ma mak map mapc marks mat me menut mes mk mks mksp mkv mkvie mod mz mzf nbc nb nbs new nm nmapc nme nn nnoreme noa no noh norea noreme norm nu nun nunme ol o|0 om omapc ome on ono onoreme opt ou ounme ow p|0 ' + 'profd prof pro promptr pc ped pe perld po popu pp pre prev ps pt ptN ptf ptj ptl ptn ptp ptr pts pu pw py3 python3 py3d py3f py pyd pyf quita qa rec red redi redr redraws reg res ret retu rew ri rightb rub rubyd rubyf rund ru rv sN san sa sal sav sb sbN sba sbf sbl sbm sbn sbp sbr scrip scripte scs se setf setg setl sf sfir sh sim sig sil sl sla sm smap smapc sme sn sni sno snor snoreme sor ' + 'so spelld spe spelli spellr spellu spellw sp spr sre st sta startg startr star stopi stj sts sun sunm sunme sus sv sw sy synti sync tN tabN tabc tabdo tabe tabf tabfir tabl tabm tabnew ' + 'tabn tabo tabp tabr tabs tab ta tags tc tcld tclf te tf th tj tl tm tn to tp tr try ts tu u|0 undoj undol una unh unl unlo unm unme uns up ve verb vert vim vimgrepa vi viu vie vm vmapc vme vne vn vnoreme vs vu vunme windo w|0 wN wa wh wi winc winp wn wp wq wqa ws wu wv x|0 xa xmapc xm xme xn xnoreme xu xunme y|0 z|0 ~ ' +
      // full version
      'Next Print append abbreviate abclear aboveleft all amenu anoremenu args argadd argdelete argedit argglobal arglocal argument ascii autocmd augroup aunmenu buffer bNext ball badd bdelete behave belowright bfirst blast bmodified bnext botright bprevious brewind break breakadd breakdel breaklist browse bunload ' + 'bwipeout change cNext cNfile cabbrev cabclear caddbuffer caddexpr caddfile call catch cbuffer cclose center cexpr cfile cfirst cgetbuffer cgetexpr cgetfile chdir checkpath checktime clist clast close cmap cmapclear cmenu cnext cnewer cnfile cnoremap cnoreabbrev cnoremenu copy colder colorscheme command comclear compiler continue confirm copen cprevious cpfile cquit crewind cscope cstag cunmap ' + 'cunabbrev cunmenu cwindow delete delmarks debug debuggreedy delcommand delfunction diffupdate diffget diffoff diffpatch diffput diffsplit digraphs display deletel djump dlist doautocmd doautoall deletep drop dsearch dsplit edit earlier echo echoerr echohl echomsg else elseif emenu endif endfor ' + 'endfunction endtry endwhile enew execute exit exusage file filetype find finally finish first fixdel fold foldclose folddoopen folddoclosed foldopen function global goto grep grepadd gui gvim hardcopy help helpfind helpgrep helptags highlight hide history insert iabbrev iabclear ijump ilist imap ' + 'imapclear imenu inoremap inoreabbrev inoremenu intro isearch isplit iunmap iunabbrev iunmenu join jumps keepalt keepmarks keepjumps lNext lNfile list laddexpr laddbuffer laddfile last language later lbuffer lcd lchdir lclose lcscope left leftabove lexpr lfile lfirst lgetbuffer lgetexpr lgetfile lgrep lgrepadd lhelpgrep llast llist lmake lmap lmapclear lnext lnewer lnfile lnoremap loadkeymap loadview ' + 'lockmarks lockvar lolder lopen lprevious lpfile lrewind ltag lunmap luado luafile lvimgrep lvimgrepadd lwindow move mark make mapclear match menu menutranslate messages mkexrc mksession mkspell mkvimrc mkview mode mzscheme mzfile nbclose nbkey nbsart next nmap nmapclear nmenu nnoremap ' + 'nnoremenu noautocmd noremap nohlsearch noreabbrev noremenu normal number nunmap nunmenu oldfiles open omap omapclear omenu only onoremap onoremenu options ounmap ounmenu ownsyntax print profdel profile promptfind promptrepl pclose pedit perl perldo pop popup ppop preserve previous psearch ptag ptNext ' + 'ptfirst ptjump ptlast ptnext ptprevious ptrewind ptselect put pwd py3do py3file python pydo pyfile quit quitall qall read recover redo redir redraw redrawstatus registers resize retab return rewind right rightbelow ruby rubydo rubyfile rundo runtime rviminfo substitute sNext sandbox sargument sall saveas sbuffer sbNext sball sbfirst sblast sbmodified sbnext sbprevious sbrewind scriptnames scriptencoding ' + 'scscope set setfiletype setglobal setlocal sfind sfirst shell simalt sign silent sleep slast smagic smapclear smenu snext sniff snomagic snoremap snoremenu sort source spelldump spellgood spellinfo spellrepall spellundo spellwrong split sprevious srewind stop stag startgreplace startreplace ' + 'startinsert stopinsert stjump stselect sunhide sunmap sunmenu suspend sview swapname syntax syntime syncbind tNext tabNext tabclose tabedit tabfind tabfirst tablast tabmove tabnext tabonly tabprevious tabrewind tag tcl tcldo tclfile tearoff tfirst throw tjump tlast tmenu tnext topleft tprevious ' + 'trewind tselect tunmenu undo undojoin undolist unabbreviate unhide unlet unlockvar unmap unmenu unsilent update vglobal version verbose vertical vimgrep vimgrepadd visual viusage view vmap vmapclear vmenu vnew ' + 'vnoremap vnoremenu vsplit vunmap vunmenu write wNext wall while winsize wincmd winpos wnext wprevious wqall wsverb wundo wviminfo xit xall xmapclear xmap xmenu xnoremap xnoremenu xunmap xunmenu yank',
      built_in:
      // built in func
      'synIDtrans atan2 range matcharg did_filetype asin feedkeys xor argv ' + 'complete_check add getwinposx getqflist getwinposy screencol ' + 'clearmatches empty extend getcmdpos mzeval garbagecollect setreg ' + 'ceil sqrt diff_hlID inputsecret get getfperm getpid filewritable ' + 'shiftwidth max sinh isdirectory synID system inputrestore winline ' + 'atan visualmode inputlist tabpagewinnr round getregtype mapcheck ' + 'hasmapto histdel argidx findfile sha256 exists toupper getcmdline ' + 'taglist string getmatches bufnr strftime winwidth bufexists ' + 'strtrans tabpagebuflist setcmdpos remote_read printf setloclist ' + 'getpos getline bufwinnr float2nr len getcmdtype diff_filler luaeval ' + 'resolve libcallnr foldclosedend reverse filter has_key bufname ' + 'str2float strlen setline getcharmod setbufvar index searchpos ' + 'shellescape undofile foldclosed setqflist buflisted strchars str2nr ' + 'virtcol floor remove undotree remote_expr winheight gettabwinvar ' + 'reltime cursor tabpagenr finddir localtime acos getloclist search ' + 'tanh matchend rename gettabvar strdisplaywidth type abs py3eval ' + 'setwinvar tolower wildmenumode log10 spellsuggest bufloaded ' + 'synconcealed nextnonblank server2client complete settabwinvar ' + 'executable input wincol setmatches getftype hlID inputsave ' + 'searchpair or screenrow line settabvar histadd deepcopy strpart ' + 'remote_peek and eval getftime submatch screenchar winsaveview ' + 'matchadd mkdir screenattr getfontname libcall reltimestr getfsize ' + 'winnr invert pow getbufline byte2line soundfold repeat fnameescape ' + 'tagfiles sin strwidth spellbadword trunc maparg log lispindent ' + 'hostname setpos globpath remote_foreground getchar synIDattr ' + 'fnamemodify cscope_connection stridx winbufnr indent min ' + 'complete_add nr2char searchpairpos inputdialog values matchlist ' + 'items hlexists strridx browsedir expand fmod pathshorten line2byte ' + 'argc count getwinvar glob foldtextresult getreg foreground cosh ' + 'matchdelete has char2nr simplify histget searchdecl iconv ' + 'winrestcmd pumvisible writefile foldlevel haslocaldir keys cos ' + 'matchstr foldtext histnr tan tempname getcwd byteidx getbufvar ' + 'islocked escape eventhandler remote_send serverlist winrestview ' + 'synstack pyeval prevnonblank readfile cindent filereadable changenr ' + 'exp'
    },
    illegal: /;/,
    contains: [hljs.NUMBER_MODE, {
      className: 'string',
      begin: '\'',
      end: '\'',
      illegal: '\\n'
    },
    /*
    A double quote can start either a string or a line comment. Strings are
    ended before the end of a line by another double quote and can contain
    escaped double-quotes and post-escaped line breaks.
     Also, any double quote at the beginning of a line is a comment but we
    don't handle that properly at the moment: any double quote inside will
    turn them into a string. Handling it properly will require a smarter
    parser.
    */
    {
      className: 'string',
      begin: /"(\\"|\n\\|[^"\n])*"/
    }, hljs.COMMENT('"', '$'), {
      className: 'variable',
      begin: /[bwtglsav]:[\w\d_]*/
    }, {
      className: 'function',
      beginKeywords: 'function function!',
      end: '$',
      relevance: 0,
      contains: [hljs.TITLE_MODE, {
        className: 'params',
        begin: '\\(',
        end: '\\)'
      }]
    }, {
      className: 'symbol',
      begin: /<[\w-]+>/
    }]
  };
}
module.exports = vim;

/***/ }),

/***/ 28879:
/***/ ((module) => {

/*
Language: Intel x86 Assembly
Author: innocenat <innocenat@gmail.com>
Description: x86 assembly language using Intel's mnemonic and NASM syntax
Website: https://en.wikipedia.org/wiki/X86_assembly_language
Category: assembler
*/

function x86asm(hljs) {
  return {
    name: 'Intel x86 Assembly',
    case_insensitive: true,
    keywords: {
      $pattern: '[.%]?' + hljs.IDENT_RE,
      keyword: 'lock rep repe repz repne repnz xaquire xrelease bnd nobnd ' + 'aaa aad aam aas adc add and arpl bb0_reset bb1_reset bound bsf bsr bswap bt btc btr bts call cbw cdq cdqe clc cld cli clts cmc cmp cmpsb cmpsd cmpsq cmpsw cmpxchg cmpxchg486 cmpxchg8b cmpxchg16b cpuid cpu_read cpu_write cqo cwd cwde daa das dec div dmint emms enter equ f2xm1 fabs fadd faddp fbld fbstp fchs fclex fcmovb fcmovbe fcmove fcmovnb fcmovnbe fcmovne fcmovnu fcmovu fcom fcomi fcomip fcomp fcompp fcos fdecstp fdisi fdiv fdivp fdivr fdivrp femms feni ffree ffreep fiadd ficom ficomp fidiv fidivr fild fimul fincstp finit fist fistp fisttp fisub fisubr fld fld1 fldcw fldenv fldl2e fldl2t fldlg2 fldln2 fldpi fldz fmul fmulp fnclex fndisi fneni fninit fnop fnsave fnstcw fnstenv fnstsw fpatan fprem fprem1 fptan frndint frstor fsave fscale fsetpm fsin fsincos fsqrt fst fstcw fstenv fstp fstsw fsub fsubp fsubr fsubrp ftst fucom fucomi fucomip fucomp fucompp fxam fxch fxtract fyl2x fyl2xp1 hlt ibts icebp idiv imul in inc incbin insb insd insw int int01 int1 int03 int3 into invd invpcid invlpg invlpga iret iretd iretq iretw jcxz jecxz jrcxz jmp jmpe lahf lar lds lea leave les lfence lfs lgdt lgs lidt lldt lmsw loadall loadall286 lodsb lodsd lodsq lodsw loop loope loopne loopnz loopz lsl lss ltr mfence monitor mov movd movq movsb movsd movsq movsw movsx movsxd movzx mul mwait neg nop not or out outsb outsd outsw packssdw packsswb packuswb paddb paddd paddsb paddsiw paddsw paddusb paddusw paddw pand pandn pause paveb pavgusb pcmpeqb pcmpeqd pcmpeqw pcmpgtb pcmpgtd pcmpgtw pdistib pf2id pfacc pfadd pfcmpeq pfcmpge pfcmpgt pfmax pfmin pfmul pfrcp pfrcpit1 pfrcpit2 pfrsqit1 pfrsqrt pfsub pfsubr pi2fd pmachriw pmaddwd pmagw pmulhriw pmulhrwa pmulhrwc pmulhw pmullw pmvgezb pmvlzb pmvnzb pmvzb pop popa popad popaw popf popfd popfq popfw por prefetch prefetchw pslld psllq psllw psrad psraw psrld psrlq psrlw psubb psubd psubsb psubsiw psubsw psubusb psubusw psubw punpckhbw punpckhdq punpckhwd punpcklbw punpckldq punpcklwd push pusha pushad pushaw pushf pushfd pushfq pushfw pxor rcl rcr rdshr rdmsr rdpmc rdtsc rdtscp ret retf retn rol ror rdm rsdc rsldt rsm rsts sahf sal salc sar sbb scasb scasd scasq scasw sfence sgdt shl shld shr shrd sidt sldt skinit smi smint smintold smsw stc std sti stosb stosd stosq stosw str sub svdc svldt svts swapgs syscall sysenter sysexit sysret test ud0 ud1 ud2b ud2 ud2a umov verr verw fwait wbinvd wrshr wrmsr xadd xbts xchg xlatb xlat xor cmove cmovz cmovne cmovnz cmova cmovnbe cmovae cmovnb cmovb cmovnae cmovbe cmovna cmovg cmovnle cmovge cmovnl cmovl cmovnge cmovle cmovng cmovc cmovnc cmovo cmovno cmovs cmovns cmovp cmovpe cmovnp cmovpo je jz jne jnz ja jnbe jae jnb jb jnae jbe jna jg jnle jge jnl jl jnge jle jng jc jnc jo jno js jns jpo jnp jpe jp sete setz setne setnz seta setnbe setae setnb setnc setb setnae setcset setbe setna setg setnle setge setnl setl setnge setle setng sets setns seto setno setpe setp setpo setnp addps addss andnps andps cmpeqps cmpeqss cmpleps cmpless cmpltps cmpltss cmpneqps cmpneqss cmpnleps cmpnless cmpnltps cmpnltss cmpordps cmpordss cmpunordps cmpunordss cmpps cmpss comiss cvtpi2ps cvtps2pi cvtsi2ss cvtss2si cvttps2pi cvttss2si divps divss ldmxcsr maxps maxss minps minss movaps movhps movlhps movlps movhlps movmskps movntps movss movups mulps mulss orps rcpps rcpss rsqrtps rsqrtss shufps sqrtps sqrtss stmxcsr subps subss ucomiss unpckhps unpcklps xorps fxrstor fxrstor64 fxsave fxsave64 xgetbv xsetbv xsave xsave64 xsaveopt xsaveopt64 xrstor xrstor64 prefetchnta prefetcht0 prefetcht1 prefetcht2 maskmovq movntq pavgb pavgw pextrw pinsrw pmaxsw pmaxub pminsw pminub pmovmskb pmulhuw psadbw pshufw pf2iw pfnacc pfpnacc pi2fw pswapd maskmovdqu clflush movntdq movnti movntpd movdqa movdqu movdq2q movq2dq paddq pmuludq pshufd pshufhw pshuflw pslldq psrldq psubq punpckhqdq punpcklqdq addpd addsd andnpd andpd cmpeqpd cmpeqsd cmplepd cmplesd cmpltpd cmpltsd cmpneqpd cmpneqsd cmpnlepd cmpnlesd cmpnltpd cmpnltsd cmpordpd cmpordsd cmpunordpd cmpunordsd cmppd comisd cvtdq2pd cvtdq2ps cvtpd2dq cvtpd2pi cvtpd2ps cvtpi2pd cvtps2dq cvtps2pd cvtsd2si cvtsd2ss cvtsi2sd cvtss2sd cvttpd2pi cvttpd2dq cvttps2dq cvttsd2si divpd divsd maxpd maxsd minpd minsd movapd movhpd movlpd movmskpd movupd mulpd mulsd orpd shufpd sqrtpd sqrtsd subpd subsd ucomisd unpckhpd unpcklpd xorpd addsubpd addsubps haddpd haddps hsubpd hsubps lddqu movddup movshdup movsldup clgi stgi vmcall vmclear vmfunc vmlaunch vmload vmmcall vmptrld vmptrst vmread vmresume vmrun vmsave vmwrite vmxoff vmxon invept invvpid pabsb pabsw pabsd palignr phaddw phaddd phaddsw phsubw phsubd phsubsw pmaddubsw pmulhrsw pshufb psignb psignw psignd extrq insertq movntsd movntss lzcnt blendpd blendps blendvpd blendvps dppd dpps extractps insertps movntdqa mpsadbw packusdw pblendvb pblendw pcmpeqq pextrb pextrd pextrq phminposuw pinsrb pinsrd pinsrq pmaxsb pmaxsd pmaxud pmaxuw pminsb pminsd pminud pminuw pmovsxbw pmovsxbd pmovsxbq pmovsxwd pmovsxwq pmovsxdq pmovzxbw pmovzxbd pmovzxbq pmovzxwd pmovzxwq pmovzxdq pmuldq pmulld ptest roundpd roundps roundsd roundss crc32 pcmpestri pcmpestrm pcmpistri pcmpistrm pcmpgtq popcnt getsec pfrcpv pfrsqrtv movbe aesenc aesenclast aesdec aesdeclast aesimc aeskeygenassist vaesenc vaesenclast vaesdec vaesdeclast vaesimc vaeskeygenassist vaddpd vaddps vaddsd vaddss vaddsubpd vaddsubps vandpd vandps vandnpd vandnps vblendpd vblendps vblendvpd vblendvps vbroadcastss vbroadcastsd vbroadcastf128 vcmpeq_ospd vcmpeqpd vcmplt_ospd vcmpltpd vcmple_ospd vcmplepd vcmpunord_qpd vcmpunordpd vcmpneq_uqpd vcmpneqpd vcmpnlt_uspd vcmpnltpd vcmpnle_uspd vcmpnlepd vcmpord_qpd vcmpordpd vcmpeq_uqpd vcmpnge_uspd vcmpngepd vcmpngt_uspd vcmpngtpd vcmpfalse_oqpd vcmpfalsepd vcmpneq_oqpd vcmpge_ospd vcmpgepd vcmpgt_ospd vcmpgtpd vcmptrue_uqpd vcmptruepd vcmplt_oqpd vcmple_oqpd vcmpunord_spd vcmpneq_uspd vcmpnlt_uqpd vcmpnle_uqpd vcmpord_spd vcmpeq_uspd vcmpnge_uqpd vcmpngt_uqpd vcmpfalse_ospd vcmpneq_ospd vcmpge_oqpd vcmpgt_oqpd vcmptrue_uspd vcmppd vcmpeq_osps vcmpeqps vcmplt_osps vcmpltps vcmple_osps vcmpleps vcmpunord_qps vcmpunordps vcmpneq_uqps vcmpneqps vcmpnlt_usps vcmpnltps vcmpnle_usps vcmpnleps vcmpord_qps vcmpordps vcmpeq_uqps vcmpnge_usps vcmpngeps vcmpngt_usps vcmpngtps vcmpfalse_oqps vcmpfalseps vcmpneq_oqps vcmpge_osps vcmpgeps vcmpgt_osps vcmpgtps vcmptrue_uqps vcmptrueps vcmplt_oqps vcmple_oqps vcmpunord_sps vcmpneq_usps vcmpnlt_uqps vcmpnle_uqps vcmpord_sps vcmpeq_usps vcmpnge_uqps vcmpngt_uqps vcmpfalse_osps vcmpneq_osps vcmpge_oqps vcmpgt_oqps vcmptrue_usps vcmpps vcmpeq_ossd vcmpeqsd vcmplt_ossd vcmpltsd vcmple_ossd vcmplesd vcmpunord_qsd vcmpunordsd vcmpneq_uqsd vcmpneqsd vcmpnlt_ussd vcmpnltsd vcmpnle_ussd vcmpnlesd vcmpord_qsd vcmpordsd vcmpeq_uqsd vcmpnge_ussd vcmpngesd vcmpngt_ussd vcmpngtsd vcmpfalse_oqsd vcmpfalsesd vcmpneq_oqsd vcmpge_ossd vcmpgesd vcmpgt_ossd vcmpgtsd vcmptrue_uqsd vcmptruesd vcmplt_oqsd vcmple_oqsd vcmpunord_ssd vcmpneq_ussd vcmpnlt_uqsd vcmpnle_uqsd vcmpord_ssd vcmpeq_ussd vcmpnge_uqsd vcmpngt_uqsd vcmpfalse_ossd vcmpneq_ossd vcmpge_oqsd vcmpgt_oqsd vcmptrue_ussd vcmpsd vcmpeq_osss vcmpeqss vcmplt_osss vcmpltss vcmple_osss vcmpless vcmpunord_qss vcmpunordss vcmpneq_uqss vcmpneqss vcmpnlt_usss vcmpnltss vcmpnle_usss vcmpnless vcmpord_qss vcmpordss vcmpeq_uqss vcmpnge_usss vcmpngess vcmpngt_usss vcmpngtss vcmpfalse_oqss vcmpfalsess vcmpneq_oqss vcmpge_osss vcmpgess vcmpgt_osss vcmpgtss vcmptrue_uqss vcmptruess vcmplt_oqss vcmple_oqss vcmpunord_sss vcmpneq_usss vcmpnlt_uqss vcmpnle_uqss vcmpord_sss vcmpeq_usss vcmpnge_uqss vcmpngt_uqss vcmpfalse_osss vcmpneq_osss vcmpge_oqss vcmpgt_oqss vcmptrue_usss vcmpss vcomisd vcomiss vcvtdq2pd vcvtdq2ps vcvtpd2dq vcvtpd2ps vcvtps2dq vcvtps2pd vcvtsd2si vcvtsd2ss vcvtsi2sd vcvtsi2ss vcvtss2sd vcvtss2si vcvttpd2dq vcvttps2dq vcvttsd2si vcvttss2si vdivpd vdivps vdivsd vdivss vdppd vdpps vextractf128 vextractps vhaddpd vhaddps vhsubpd vhsubps vinsertf128 vinsertps vlddqu vldqqu vldmxcsr vmaskmovdqu vmaskmovps vmaskmovpd vmaxpd vmaxps vmaxsd vmaxss vminpd vminps vminsd vminss vmovapd vmovaps vmovd vmovq vmovddup vmovdqa vmovqqa vmovdqu vmovqqu vmovhlps vmovhpd vmovhps vmovlhps vmovlpd vmovlps vmovmskpd vmovmskps vmovntdq vmovntqq vmovntdqa vmovntpd vmovntps vmovsd vmovshdup vmovsldup vmovss vmovupd vmovups vmpsadbw vmulpd vmulps vmulsd vmulss vorpd vorps vpabsb vpabsw vpabsd vpacksswb vpackssdw vpackuswb vpackusdw vpaddb vpaddw vpaddd vpaddq vpaddsb vpaddsw vpaddusb vpaddusw vpalignr vpand vpandn vpavgb vpavgw vpblendvb vpblendw vpcmpestri vpcmpestrm vpcmpistri vpcmpistrm vpcmpeqb vpcmpeqw vpcmpeqd vpcmpeqq vpcmpgtb vpcmpgtw vpcmpgtd vpcmpgtq vpermilpd vpermilps vperm2f128 vpextrb vpextrw vpextrd vpextrq vphaddw vphaddd vphaddsw vphminposuw vphsubw vphsubd vphsubsw vpinsrb vpinsrw vpinsrd vpinsrq vpmaddwd vpmaddubsw vpmaxsb vpmaxsw vpmaxsd vpmaxub vpmaxuw vpmaxud vpminsb vpminsw vpminsd vpminub vpminuw vpminud vpmovmskb vpmovsxbw vpmovsxbd vpmovsxbq vpmovsxwd vpmovsxwq vpmovsxdq vpmovzxbw vpmovzxbd vpmovzxbq vpmovzxwd vpmovzxwq vpmovzxdq vpmulhuw vpmulhrsw vpmulhw vpmullw vpmulld vpmuludq vpmuldq vpor vpsadbw vpshufb vpshufd vpshufhw vpshuflw vpsignb vpsignw vpsignd vpslldq vpsrldq vpsllw vpslld vpsllq vpsraw vpsrad vpsrlw vpsrld vpsrlq vptest vpsubb vpsubw vpsubd vpsubq vpsubsb vpsubsw vpsubusb vpsubusw vpunpckhbw vpunpckhwd vpunpckhdq vpunpckhqdq vpunpcklbw vpunpcklwd vpunpckldq vpunpcklqdq vpxor vrcpps vrcpss vrsqrtps vrsqrtss vroundpd vroundps vroundsd vroundss vshufpd vshufps vsqrtpd vsqrtps vsqrtsd vsqrtss vstmxcsr vsubpd vsubps vsubsd vsubss vtestps vtestpd vucomisd vucomiss vunpckhpd vunpckhps vunpcklpd vunpcklps vxorpd vxorps vzeroall vzeroupper pclmullqlqdq pclmulhqlqdq pclmullqhqdq pclmulhqhqdq pclmulqdq vpclmullqlqdq vpclmulhqlqdq vpclmullqhqdq vpclmulhqhqdq vpclmulqdq vfmadd132ps vfmadd132pd vfmadd312ps vfmadd312pd vfmadd213ps vfmadd213pd vfmadd123ps vfmadd123pd vfmadd231ps vfmadd231pd vfmadd321ps vfmadd321pd vfmaddsub132ps vfmaddsub132pd vfmaddsub312ps vfmaddsub312pd vfmaddsub213ps vfmaddsub213pd vfmaddsub123ps vfmaddsub123pd vfmaddsub231ps vfmaddsub231pd vfmaddsub321ps vfmaddsub321pd vfmsub132ps vfmsub132pd vfmsub312ps vfmsub312pd vfmsub213ps vfmsub213pd vfmsub123ps vfmsub123pd vfmsub231ps vfmsub231pd vfmsub321ps vfmsub321pd vfmsubadd132ps vfmsubadd132pd vfmsubadd312ps vfmsubadd312pd vfmsubadd213ps vfmsubadd213pd vfmsubadd123ps vfmsubadd123pd vfmsubadd231ps vfmsubadd231pd vfmsubadd321ps vfmsubadd321pd vfnmadd132ps vfnmadd132pd vfnmadd312ps vfnmadd312pd vfnmadd213ps vfnmadd213pd vfnmadd123ps vfnmadd123pd vfnmadd231ps vfnmadd231pd vfnmadd321ps vfnmadd321pd vfnmsub132ps vfnmsub132pd vfnmsub312ps vfnmsub312pd vfnmsub213ps vfnmsub213pd vfnmsub123ps vfnmsub123pd vfnmsub231ps vfnmsub231pd vfnmsub321ps vfnmsub321pd vfmadd132ss vfmadd132sd vfmadd312ss vfmadd312sd vfmadd213ss vfmadd213sd vfmadd123ss vfmadd123sd vfmadd231ss vfmadd231sd vfmadd321ss vfmadd321sd vfmsub132ss vfmsub132sd vfmsub312ss vfmsub312sd vfmsub213ss vfmsub213sd vfmsub123ss vfmsub123sd vfmsub231ss vfmsub231sd vfmsub321ss vfmsub321sd vfnmadd132ss vfnmadd132sd vfnmadd312ss vfnmadd312sd vfnmadd213ss vfnmadd213sd vfnmadd123ss vfnmadd123sd vfnmadd231ss vfnmadd231sd vfnmadd321ss vfnmadd321sd vfnmsub132ss vfnmsub132sd vfnmsub312ss vfnmsub312sd vfnmsub213ss vfnmsub213sd vfnmsub123ss vfnmsub123sd vfnmsub231ss vfnmsub231sd vfnmsub321ss vfnmsub321sd rdfsbase rdgsbase rdrand wrfsbase wrgsbase vcvtph2ps vcvtps2ph adcx adox rdseed clac stac xstore xcryptecb xcryptcbc xcryptctr xcryptcfb xcryptofb montmul xsha1 xsha256 llwpcb slwpcb lwpval lwpins vfmaddpd vfmaddps vfmaddsd vfmaddss vfmaddsubpd vfmaddsubps vfmsubaddpd vfmsubaddps vfmsubpd vfmsubps vfmsubsd vfmsubss vfnmaddpd vfnmaddps vfnmaddsd vfnmaddss vfnmsubpd vfnmsubps vfnmsubsd vfnmsubss vfrczpd vfrczps vfrczsd vfrczss vpcmov vpcomb vpcomd vpcomq vpcomub vpcomud vpcomuq vpcomuw vpcomw vphaddbd vphaddbq vphaddbw vphadddq vphaddubd vphaddubq vphaddubw vphaddudq vphadduwd vphadduwq vphaddwd vphaddwq vphsubbw vphsubdq vphsubwd vpmacsdd vpmacsdqh vpmacsdql vpmacssdd vpmacssdqh vpmacssdql vpmacsswd vpmacssww vpmacswd vpmacsww vpmadcsswd vpmadcswd vpperm vprotb vprotd vprotq vprotw vpshab vpshad vpshaq vpshaw vpshlb vpshld vpshlq vpshlw vbroadcasti128 vpblendd vpbroadcastb vpbroadcastw vpbroadcastd vpbroadcastq vpermd vpermpd vpermps vpermq vperm2i128 vextracti128 vinserti128 vpmaskmovd vpmaskmovq vpsllvd vpsllvq vpsravd vpsrlvd vpsrlvq vgatherdpd vgatherqpd vgatherdps vgatherqps vpgatherdd vpgatherqd vpgatherdq vpgatherqq xabort xbegin xend xtest andn bextr blci blcic blsi blsic blcfill blsfill blcmsk blsmsk blsr blcs bzhi mulx pdep pext rorx sarx shlx shrx tzcnt tzmsk t1mskc valignd valignq vblendmpd vblendmps vbroadcastf32x4 vbroadcastf64x4 vbroadcasti32x4 vbroadcasti64x4 vcompresspd vcompressps vcvtpd2udq vcvtps2udq vcvtsd2usi vcvtss2usi vcvttpd2udq vcvttps2udq vcvttsd2usi vcvttss2usi vcvtudq2pd vcvtudq2ps vcvtusi2sd vcvtusi2ss vexpandpd vexpandps vextractf32x4 vextractf64x4 vextracti32x4 vextracti64x4 vfixupimmpd vfixupimmps vfixupimmsd vfixupimmss vgetexppd vgetexpps vgetexpsd vgetexpss vgetmantpd vgetmantps vgetmantsd vgetmantss vinsertf32x4 vinsertf64x4 vinserti32x4 vinserti64x4 vmovdqa32 vmovdqa64 vmovdqu32 vmovdqu64 vpabsq vpandd vpandnd vpandnq vpandq vpblendmd vpblendmq vpcmpltd vpcmpled vpcmpneqd vpcmpnltd vpcmpnled vpcmpd vpcmpltq vpcmpleq vpcmpneqq vpcmpnltq vpcmpnleq vpcmpq vpcmpequd vpcmpltud vpcmpleud vpcmpnequd vpcmpnltud vpcmpnleud vpcmpud vpcmpequq vpcmpltuq vpcmpleuq vpcmpnequq vpcmpnltuq vpcmpnleuq vpcmpuq vpcompressd vpcompressq vpermi2d vpermi2pd vpermi2ps vpermi2q vpermt2d vpermt2pd vpermt2ps vpermt2q vpexpandd vpexpandq vpmaxsq vpmaxuq vpminsq vpminuq vpmovdb vpmovdw vpmovqb vpmovqd vpmovqw vpmovsdb vpmovsdw vpmovsqb vpmovsqd vpmovsqw vpmovusdb vpmovusdw vpmovusqb vpmovusqd vpmovusqw vpord vporq vprold vprolq vprolvd vprolvq vprord vprorq vprorvd vprorvq vpscatterdd vpscatterdq vpscatterqd vpscatterqq vpsraq vpsravq vpternlogd vpternlogq vptestmd vptestmq vptestnmd vptestnmq vpxord vpxorq vrcp14pd vrcp14ps vrcp14sd vrcp14ss vrndscalepd vrndscaleps vrndscalesd vrndscaless vrsqrt14pd vrsqrt14ps vrsqrt14sd vrsqrt14ss vscalefpd vscalefps vscalefsd vscalefss vscatterdpd vscatterdps vscatterqpd vscatterqps vshuff32x4 vshuff64x2 vshufi32x4 vshufi64x2 kandnw kandw kmovw knotw kortestw korw kshiftlw kshiftrw kunpckbw kxnorw kxorw vpbroadcastmb2q vpbroadcastmw2d vpconflictd vpconflictq vplzcntd vplzcntq vexp2pd vexp2ps vrcp28pd vrcp28ps vrcp28sd vrcp28ss vrsqrt28pd vrsqrt28ps vrsqrt28sd vrsqrt28ss vgatherpf0dpd vgatherpf0dps vgatherpf0qpd vgatherpf0qps vgatherpf1dpd vgatherpf1dps vgatherpf1qpd vgatherpf1qps vscatterpf0dpd vscatterpf0dps vscatterpf0qpd vscatterpf0qps vscatterpf1dpd vscatterpf1dps vscatterpf1qpd vscatterpf1qps prefetchwt1 bndmk bndcl bndcu bndcn bndmov bndldx bndstx sha1rnds4 sha1nexte sha1msg1 sha1msg2 sha256rnds2 sha256msg1 sha256msg2 hint_nop0 hint_nop1 hint_nop2 hint_nop3 hint_nop4 hint_nop5 hint_nop6 hint_nop7 hint_nop8 hint_nop9 hint_nop10 hint_nop11 hint_nop12 hint_nop13 hint_nop14 hint_nop15 hint_nop16 hint_nop17 hint_nop18 hint_nop19 hint_nop20 hint_nop21 hint_nop22 hint_nop23 hint_nop24 hint_nop25 hint_nop26 hint_nop27 hint_nop28 hint_nop29 hint_nop30 hint_nop31 hint_nop32 hint_nop33 hint_nop34 hint_nop35 hint_nop36 hint_nop37 hint_nop38 hint_nop39 hint_nop40 hint_nop41 hint_nop42 hint_nop43 hint_nop44 hint_nop45 hint_nop46 hint_nop47 hint_nop48 hint_nop49 hint_nop50 hint_nop51 hint_nop52 hint_nop53 hint_nop54 hint_nop55 hint_nop56 hint_nop57 hint_nop58 hint_nop59 hint_nop60 hint_nop61 hint_nop62 hint_nop63',
      built_in:
      // Instruction pointer
      'ip eip rip ' +
      // 8-bit registers
      'al ah bl bh cl ch dl dh sil dil bpl spl r8b r9b r10b r11b r12b r13b r14b r15b ' +
      // 16-bit registers
      'ax bx cx dx si di bp sp r8w r9w r10w r11w r12w r13w r14w r15w ' +
      // 32-bit registers
      'eax ebx ecx edx esi edi ebp esp eip r8d r9d r10d r11d r12d r13d r14d r15d ' +
      // 64-bit registers
      'rax rbx rcx rdx rsi rdi rbp rsp r8 r9 r10 r11 r12 r13 r14 r15 ' +
      // Segment registers
      'cs ds es fs gs ss ' +
      // Floating point stack registers
      'st st0 st1 st2 st3 st4 st5 st6 st7 ' +
      // MMX Registers
      'mm0 mm1 mm2 mm3 mm4 mm5 mm6 mm7 ' +
      // SSE registers
      'xmm0  xmm1  xmm2  xmm3  xmm4  xmm5  xmm6  xmm7  xmm8  xmm9 xmm10  xmm11 xmm12 xmm13 xmm14 xmm15 ' + 'xmm16 xmm17 xmm18 xmm19 xmm20 xmm21 xmm22 xmm23 xmm24 xmm25 xmm26 xmm27 xmm28 xmm29 xmm30 xmm31 ' +
      // AVX registers
      'ymm0  ymm1  ymm2  ymm3  ymm4  ymm5  ymm6  ymm7  ymm8  ymm9 ymm10  ymm11 ymm12 ymm13 ymm14 ymm15 ' + 'ymm16 ymm17 ymm18 ymm19 ymm20 ymm21 ymm22 ymm23 ymm24 ymm25 ymm26 ymm27 ymm28 ymm29 ymm30 ymm31 ' +
      // AVX-512F registers
      'zmm0  zmm1  zmm2  zmm3  zmm4  zmm5  zmm6  zmm7  zmm8  zmm9 zmm10  zmm11 zmm12 zmm13 zmm14 zmm15 ' + 'zmm16 zmm17 zmm18 zmm19 zmm20 zmm21 zmm22 zmm23 zmm24 zmm25 zmm26 zmm27 zmm28 zmm29 zmm30 zmm31 ' +
      // AVX-512F mask registers
      'k0 k1 k2 k3 k4 k5 k6 k7 ' +
      // Bound (MPX) register
      'bnd0 bnd1 bnd2 bnd3 ' +
      // Special register
      'cr0 cr1 cr2 cr3 cr4 cr8 dr0 dr1 dr2 dr3 dr8 tr3 tr4 tr5 tr6 tr7 ' +
      // NASM altreg package
      'r0 r1 r2 r3 r4 r5 r6 r7 r0b r1b r2b r3b r4b r5b r6b r7b ' + 'r0w r1w r2w r3w r4w r5w r6w r7w r0d r1d r2d r3d r4d r5d r6d r7d ' + 'r0h r1h r2h r3h ' + 'r0l r1l r2l r3l r4l r5l r6l r7l r8l r9l r10l r11l r12l r13l r14l r15l ' + 'db dw dd dq dt ddq do dy dz ' + 'resb resw resd resq rest resdq reso resy resz ' + 'incbin equ times ' + 'byte word dword qword nosplit rel abs seg wrt strict near far a32 ptr',
      meta: '%define %xdefine %+ %undef %defstr %deftok %assign %strcat %strlen %substr %rotate %elif %else %endif ' + '%if %ifmacro %ifctx %ifidn %ifidni %ifid %ifnum %ifstr %iftoken %ifempty %ifenv %error %warning %fatal %rep ' + '%endrep %include %push %pop %repl %pathsearch %depend %use %arg %stacksize %local %line %comment %endcomment ' + '.nolist ' + '__FILE__ __LINE__ __SECT__  __BITS__ __OUTPUT_FORMAT__ __DATE__ __TIME__ __DATE_NUM__ __TIME_NUM__ ' + '__UTC_DATE__ __UTC_TIME__ __UTC_DATE_NUM__ __UTC_TIME_NUM__  __PASS__ struc endstruc istruc at iend ' + 'align alignb sectalign daz nodaz up down zero default option assume public ' + 'bits use16 use32 use64 default section segment absolute extern global common cpu float ' + '__utf16__ __utf16le__ __utf16be__ __utf32__ __utf32le__ __utf32be__ ' + '__float8__ __float16__ __float32__ __float64__ __float80m__ __float80e__ __float128l__ __float128h__ ' + '__Infinity__ __QNaN__ __SNaN__ Inf NaN QNaN SNaN float8 float16 float32 float64 float80m float80e ' + 'float128l float128h __FLOAT_DAZ__ __FLOAT_ROUND__ __FLOAT__'
    },
    contains: [hljs.COMMENT(';', '$', {
      relevance: 0
    }), {
      className: 'number',
      variants: [
      // Float number and x87 BCD
      {
        begin: '\\b(?:([0-9][0-9_]*)?\\.[0-9_]*(?:[eE][+-]?[0-9_]+)?|' + '(0[Xx])?[0-9][0-9_]*(\\.[0-9_]*)?(?:[pP](?:[+-]?[0-9_]+)?)?)\\b',
        relevance: 0
      },
      // Hex number in $
      {
        begin: '\\$[0-9][0-9A-Fa-f]*',
        relevance: 0
      },
      // Number in H,D,T,Q,O,B,Y suffix
      {
        begin: '\\b(?:[0-9A-Fa-f][0-9A-Fa-f_]*[Hh]|[0-9][0-9_]*[DdTt]?|[0-7][0-7_]*[QqOo]|[0-1][0-1_]*[BbYy])\\b'
      },
      // Number in X,D,T,Q,O,B,Y prefix
      {
        begin: '\\b(?:0[Xx][0-9A-Fa-f_]+|0[DdTt][0-9_]+|0[QqOo][0-7_]+|0[BbYy][0-1_]+)\\b'
      }]
    },
    // Double quote string
    hljs.QUOTE_STRING_MODE, {
      className: 'string',
      variants: [
      // Single-quoted string
      {
        begin: '\'',
        end: '[^\\\\]\''
      },
      // Backquoted string
      {
        begin: '`',
        end: '[^\\\\]`'
      }],
      relevance: 0
    }, {
      className: 'symbol',
      variants: [
      // Global label and local label
      {
        begin: '^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)'
      },
      // Macro-local label
      {
        begin: '^\\s*%%[A-Za-z0-9_$#@~.?]*:'
      }],
      relevance: 0
    },
    // Macro parameter
    {
      className: 'subst',
      begin: '%[0-9]+',
      relevance: 0
    },
    // Macro parameter
    {
      className: 'subst',
      begin: '%!\S+',
      relevance: 0
    }, {
      className: 'meta',
      begin: /^\s*\.[\w_-]+/
    }]
  };
}
module.exports = x86asm;

/***/ }),

/***/ 33843:
/***/ ((module) => {

/*
Language: XL
Author: Christophe de Dinechin <christophe@taodyne.com>
Description: An extensible programming language, based on parse tree rewriting
Website: http://xlr.sf.net
*/

function xl(hljs) {
  var BUILTIN_MODULES = 'ObjectLoader Animate MovieCredits Slides Filters Shading Materials LensFlare Mapping VLCAudioVideo ' + 'StereoDecoder PointCloud NetworkAccess RemoteControl RegExp ChromaKey Snowfall NodeJS Speech Charts';
  var XL_KEYWORDS = {
    $pattern: /[a-zA-Z][a-zA-Z0-9_?]*/,
    keyword: 'if then else do while until for loop import with is as where when by data constant ' + 'integer real text name boolean symbol infix prefix postfix block tree',
    literal: 'true false nil',
    built_in: 'in mod rem and or xor not abs sign floor ceil sqrt sin cos tan asin ' + 'acos atan exp expm1 log log2 log10 log1p pi at text_length text_range ' + 'text_find text_replace contains page slide basic_slide title_slide ' + 'title subtitle fade_in fade_out fade_at clear_color color line_color ' + 'line_width texture_wrap texture_transform texture scale_?x scale_?y ' + 'scale_?z? translate_?x translate_?y translate_?z? rotate_?x rotate_?y ' + 'rotate_?z? rectangle circle ellipse sphere path line_to move_to ' + 'quad_to curve_to theme background contents locally time mouse_?x ' + 'mouse_?y mouse_buttons ' + BUILTIN_MODULES
  };
  var DOUBLE_QUOTE_TEXT = {
    className: 'string',
    begin: '"',
    end: '"',
    illegal: '\\n'
  };
  var SINGLE_QUOTE_TEXT = {
    className: 'string',
    begin: '\'',
    end: '\'',
    illegal: '\\n'
  };
  var LONG_TEXT = {
    className: 'string',
    begin: '<<',
    end: '>>'
  };
  var BASED_NUMBER = {
    className: 'number',
    begin: '[0-9]+#[0-9A-Z_]+(\\.[0-9-A-Z_]+)?#?([Ee][+-]?[0-9]+)?'
  };
  var IMPORT = {
    beginKeywords: 'import',
    end: '$',
    keywords: XL_KEYWORDS,
    contains: [DOUBLE_QUOTE_TEXT]
  };
  var FUNCTION_DEFINITION = {
    className: 'function',
    begin: /[a-z][^\n]*->/,
    returnBegin: true,
    end: /->/,
    contains: [hljs.inherit(hljs.TITLE_MODE, {
      starts: {
        endsWithParent: true,
        keywords: XL_KEYWORDS
      }
    })]
  };
  return {
    name: 'XL',
    aliases: ['tao'],
    keywords: XL_KEYWORDS,
    contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, DOUBLE_QUOTE_TEXT, SINGLE_QUOTE_TEXT, LONG_TEXT, FUNCTION_DEFINITION, IMPORT, BASED_NUMBER, hljs.NUMBER_MODE]
  };
}
module.exports = xl;

/***/ }),

/***/ 79457:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(69600);
__webpack_require__(21249);
/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;
  return re.source;
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function lookahead(re) {
  return concat('(?=', re, ')');
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function optional(re) {
  return concat('(', re, ')?');
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var joined = args.map(function (x) {
    return source(x);
  }).join("");
  return joined;
}

/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */
function either() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var joined = '(' + args.map(function (x) {
    return source(x);
  }).join("|") + ")";
  return joined;
}

/*
Language: HTML, XML
Website: https://www.w3.org/XML/
Category: common
Audit: 2020
*/

/** @type LanguageFn */
function xml(hljs) {
  // Element names can contain letters, digits, hyphens, underscores, and periods
  var TAG_NAME_RE = concat(/[A-Z_]/, optional(/[A-Z0-9_.-]*:/), /[A-Z0-9_.-]*/);
  var XML_IDENT_RE = /[A-Za-z0-9._:-]+/;
  var XML_ENTITIES = {
    className: 'symbol',
    begin: /&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;/
  };
  var XML_META_KEYWORDS = {
    begin: /\s/,
    contains: [{
      className: 'meta-keyword',
      begin: /#?[a-z_][a-z1-9_-]+/,
      illegal: /\n/
    }]
  };
  var XML_META_PAR_KEYWORDS = hljs.inherit(XML_META_KEYWORDS, {
    begin: /\(/,
    end: /\)/
  });
  var APOS_META_STRING_MODE = hljs.inherit(hljs.APOS_STRING_MODE, {
    className: 'meta-string'
  });
  var QUOTE_META_STRING_MODE = hljs.inherit(hljs.QUOTE_STRING_MODE, {
    className: 'meta-string'
  });
  var TAG_INTERNALS = {
    endsWithParent: true,
    illegal: /</,
    relevance: 0,
    contains: [{
      className: 'attr',
      begin: XML_IDENT_RE,
      relevance: 0
    }, {
      begin: /=\s*/,
      relevance: 0,
      contains: [{
        className: 'string',
        endsParent: true,
        variants: [{
          begin: /"/,
          end: /"/,
          contains: [XML_ENTITIES]
        }, {
          begin: /'/,
          end: /'/,
          contains: [XML_ENTITIES]
        }, {
          begin: /[^\s"'=<>`]+/
        }]
      }]
    }]
  };
  return {
    name: 'HTML, XML',
    aliases: ['html', 'xhtml', 'rss', 'atom', 'xjb', 'xsd', 'xsl', 'plist', 'wsf', 'svg'],
    case_insensitive: true,
    contains: [{
      className: 'meta',
      begin: /<![a-z]/,
      end: />/,
      relevance: 10,
      contains: [XML_META_KEYWORDS, QUOTE_META_STRING_MODE, APOS_META_STRING_MODE, XML_META_PAR_KEYWORDS, {
        begin: /\[/,
        end: /\]/,
        contains: [{
          className: 'meta',
          begin: /<![a-z]/,
          end: />/,
          contains: [XML_META_KEYWORDS, XML_META_PAR_KEYWORDS, QUOTE_META_STRING_MODE, APOS_META_STRING_MODE]
        }]
      }]
    }, hljs.COMMENT(/<!--/, /-->/, {
      relevance: 10
    }), {
      begin: /<!\[CDATA\[/,
      end: /\]\]>/,
      relevance: 10
    }, XML_ENTITIES, {
      className: 'meta',
      begin: /<\?xml/,
      end: /\?>/,
      relevance: 10
    }, {
      className: 'tag',
      /*
      The lookahead pattern (?=...) ensures that 'begin' only matches
      '<style' as a single word, followed by a whitespace or an
      ending braket. The '$' is needed for the lexeme to be recognized
      by hljs.subMode() that tests lexemes outside the stream.
      */
      begin: /<style(?=\s|>)/,
      end: />/,
      keywords: {
        name: 'style'
      },
      contains: [TAG_INTERNALS],
      starts: {
        end: /<\/style>/,
        returnEnd: true,
        subLanguage: ['css', 'xml']
      }
    }, {
      className: 'tag',
      // See the comment in the <style tag about the lookahead pattern
      begin: /<script(?=\s|>)/,
      end: />/,
      keywords: {
        name: 'script'
      },
      contains: [TAG_INTERNALS],
      starts: {
        end: /<\/script>/,
        returnEnd: true,
        subLanguage: ['javascript', 'handlebars', 'xml']
      }
    },
    // we need this for now for jSX
    {
      className: 'tag',
      begin: /<>|<\/>/
    },
    // open tag
    {
      className: 'tag',
      begin: concat(/</, lookahead(concat(TAG_NAME_RE,
      // <tag/>
      // <tag>
      // <tag ...
      either(/\/>/, />/, /\s/)))),
      end: /\/?>/,
      contains: [{
        className: 'name',
        begin: TAG_NAME_RE,
        relevance: 0,
        starts: TAG_INTERNALS
      }]
    },
    // close tag
    {
      className: 'tag',
      begin: concat(/<\//, lookahead(concat(TAG_NAME_RE, />/))),
      contains: [{
        className: 'name',
        begin: TAG_NAME_RE,
        relevance: 0
      }, {
        begin: />/,
        relevance: 0,
        endsParent: true
      }]
    }]
  };
}
module.exports = xml;

/***/ }),

/***/ 66500:
/***/ ((module) => {

/*
Language: XQuery
Author: Dirk Kirsten <dk@basex.org>
Contributor: Duncan Paterson
Description: Supports XQuery 3.1 including XQuery Update 3, so also XPath (as it is a superset)
Refactored to process xml constructor syntax and function-bodies. Added missing data-types, xpath operands, inbuilt functions, and query prologs
Website: https://www.w3.org/XML/Query/
Category: functional
Audit: 2020
*/

/** @type LanguageFn */
function xquery(_hljs) {
  // see https://www.w3.org/TR/xquery/#id-terminal-delimitation
  var KEYWORDS = 'module schema namespace boundary-space preserve no-preserve strip default collation base-uri ordering context decimal-format decimal-separator copy-namespaces empty-sequence except exponent-separator external grouping-separator inherit no-inherit lax minus-sign per-mille percent schema-attribute schema-element strict unordered zero-digit ' + 'declare import option function validate variable ' + 'for at in let where order group by return if then else ' + 'tumbling sliding window start when only end previous next stable ' + 'ascending descending allowing empty greatest least some every satisfies switch case typeswitch try catch ' + 'and or to union intersect instance of treat as castable cast map array ' + 'delete insert into replace value rename copy modify update';

  // Node Types (sorted by inheritance)
  // atomic types (sorted by inheritance)
  var TYPE = 'item document-node node attribute document element comment namespace namespace-node processing-instruction text construction ' + 'xs:anyAtomicType xs:untypedAtomic xs:duration xs:time xs:decimal xs:float xs:double xs:gYearMonth xs:gYear xs:gMonthDay xs:gMonth xs:gDay xs:boolean xs:base64Binary xs:hexBinary xs:anyURI xs:QName xs:NOTATION xs:dateTime xs:dateTimeStamp xs:date xs:string xs:normalizedString xs:token xs:language xs:NMTOKEN xs:Name xs:NCName xs:ID xs:IDREF xs:ENTITY xs:integer xs:nonPositiveInteger xs:negativeInteger xs:long xs:int xs:short xs:byte xs:nonNegativeInteger xs:unisignedLong xs:unsignedInt xs:unsignedShort xs:unsignedByte xs:positiveInteger xs:yearMonthDuration xs:dayTimeDuration';
  var LITERAL = 'eq ne lt le gt ge is ' + 'self:: child:: descendant:: descendant-or-self:: attribute:: following:: following-sibling:: parent:: ancestor:: ancestor-or-self:: preceding:: preceding-sibling:: ' + 'NaN';

  // functions (TODO: find regex for op: without breaking build)
  var BUILT_IN = {
    className: 'built_in',
    variants: [{
      begin: /\barray:/,
      end: /(?:append|filter|flatten|fold-(?:left|right)|for-each(?:-pair)?|get|head|insert-before|join|put|remove|reverse|size|sort|subarray|tail)\b/
    }, {
      begin: /\bmap:/,
      end: /(?:contains|entry|find|for-each|get|keys|merge|put|remove|size)\b/
    }, {
      begin: /\bmath:/,
      end: /(?:a(?:cos|sin|tan[2]?)|cos|exp(?:10)?|log(?:10)?|pi|pow|sin|sqrt|tan)\b/
    }, {
      begin: /\bop:/,
      end: /\(/,
      excludeEnd: true
    }, {
      begin: /\bfn:/,
      end: /\(/,
      excludeEnd: true
    },
    // do not highlight inbuilt strings as variable or xml element names
    {
      begin: /[^</$:'"-]\b(?:abs|accumulator-(?:after|before)|adjust-(?:date(?:Time)?|time)-to-timezone|analyze-string|apply|available-(?:environment-variables|system-properties)|avg|base-uri|boolean|ceiling|codepoints?-(?:equal|to-string)|collation-key|collection|compare|concat|contains(?:-token)?|copy-of|count|current(?:-)?(?:date(?:Time)?|time|group(?:ing-key)?|output-uri|merge-(?:group|key))?data|dateTime|days?-from-(?:date(?:Time)?|duration)|deep-equal|default-(?:collation|language)|distinct-values|document(?:-uri)?|doc(?:-available)?|element-(?:available|with-id)|empty|encode-for-uri|ends-with|environment-variable|error|escape-html-uri|exactly-one|exists|false|filter|floor|fold-(?:left|right)|for-each(?:-pair)?|format-(?:date(?:Time)?|time|integer|number)|function-(?:arity|available|lookup|name)|generate-id|has-children|head|hours-from-(?:dateTime|duration|time)|id(?:ref)?|implicit-timezone|in-scope-prefixes|index-of|innermost|insert-before|iri-to-uri|json-(?:doc|to-xml)|key|lang|last|load-xquery-module|local-name(?:-from-QName)?|(?:lower|upper)-case|matches|max|minutes-from-(?:dateTime|duration|time)|min|months?-from-(?:date(?:Time)?|duration)|name(?:space-uri-?(?:for-prefix|from-QName)?)?|nilled|node-name|normalize-(?:space|unicode)|not|number|one-or-more|outermost|parse-(?:ietf-date|json)|path|position|(?:prefix-from-)?QName|random-number-generator|regex-group|remove|replace|resolve-(?:QName|uri)|reverse|root|round(?:-half-to-even)?|seconds-from-(?:dateTime|duration|time)|snapshot|sort|starts-with|static-base-uri|stream-available|string-?(?:join|length|to-codepoints)?|subsequence|substring-?(?:after|before)?|sum|system-property|tail|timezone-from-(?:date(?:Time)?|time)|tokenize|trace|trans(?:form|late)|true|type-available|unordered|unparsed-(?:entity|text)?-?(?:public-id|uri|available|lines)?|uri-collection|xml-to-json|years?-from-(?:date(?:Time)?|duration)|zero-or-one)\b/
    }, {
      begin: /\blocal:/,
      end: /\(/,
      excludeEnd: true
    }, {
      begin: /\bzip:/,
      end: /(?:zip-file|(?:xml|html|text|binary)-entry| (?:update-)?entries)\b/
    }, {
      begin: /\b(?:util|db|functx|app|xdmp|xmldb):/,
      end: /\(/,
      excludeEnd: true
    }]
  };
  var TITLE = {
    className: 'title',
    begin: /\bxquery version "[13]\.[01]"\s?(?:encoding ".+")?/,
    end: /;/
  };
  var VAR = {
    className: 'variable',
    begin: /[$][\w\-:]+/
  };
  var NUMBER = {
    className: 'number',
    begin: /(\b0[0-7_]+)|(\b0x[0-9a-fA-F_]+)|(\b[1-9][0-9_]*(\.[0-9_]+)?)|[0_]\b/,
    relevance: 0
  };
  var STRING = {
    className: 'string',
    variants: [{
      begin: /"/,
      end: /"/,
      contains: [{
        begin: /""/,
        relevance: 0
      }]
    }, {
      begin: /'/,
      end: /'/,
      contains: [{
        begin: /''/,
        relevance: 0
      }]
    }]
  };
  var ANNOTATION = {
    className: 'meta',
    begin: /%[\w\-:]+/
  };
  var COMMENT = {
    className: 'comment',
    begin: /\(:/,
    end: /:\)/,
    relevance: 10,
    contains: [{
      className: 'doctag',
      begin: /@\w+/
    }]
  };

  // see https://www.w3.org/TR/xquery/#id-computedConstructors
  // mocha: computed_inbuilt
  // see https://www.regexpal.com/?fam=99749
  var COMPUTED = {
    beginKeywords: 'element attribute comment document processing-instruction',
    end: /\{/,
    excludeEnd: true
  };

  // mocha: direct_method
  var DIRECT = {
    begin: /<([\w._:-]+)(\s+\S*=('|").*('|"))?>/,
    end: /(\/[\w._:-]+>)/,
    subLanguage: 'xml',
    contains: [{
      begin: /\{/,
      end: /\}/,
      subLanguage: 'xquery'
    }, 'self']
  };
  var CONTAINS = [VAR, BUILT_IN, STRING, NUMBER, COMMENT, ANNOTATION, TITLE, COMPUTED, DIRECT];
  return {
    name: 'XQuery',
    aliases: ['xpath', 'xq'],
    case_insensitive: false,
    illegal: /(proc)|(abstract)|(extends)|(until)|(#)/,
    keywords: {
      $pattern: /[a-zA-Z$][a-zA-Z0-9_:-]*/,
      keyword: KEYWORDS,
      type: TYPE,
      literal: LITERAL
    },
    contains: CONTAINS
  };
}
module.exports = xquery;

/***/ }),

/***/ 18001:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(92222);
/*
Language: YAML
Description: Yet Another Markdown Language
Author: Stefan Wienert <stwienert@gmail.com>
Contributors: Carl Baxter <carl@cbax.tech>
Requires: ruby.js
Website: https://yaml.org
Category: common, config
*/
function yaml(hljs) {
  var LITERALS = 'true false yes no null';

  // YAML spec allows non-reserved URI characters in tags.
  var URI_CHARACTERS = '[\\w#;/?:@&=+$,.~*\'()[\\]]+';

  // Define keys as starting with a word character
  // ...containing word chars, spaces, colons, forward-slashes, hyphens and periods
  // ...and ending with a colon followed immediately by a space, tab or newline.
  // The YAML spec allows for much more than this, but this covers most use-cases.
  var KEY = {
    className: 'attr',
    variants: [{
      begin: '\\w[\\w :\\/.-]*:(?=[ \t]|$)'
    }, {
      begin: '"\\w[\\w :\\/.-]*":(?=[ \t]|$)'
    },
    // double quoted keys
    {
      begin: '\'\\w[\\w :\\/.-]*\':(?=[ \t]|$)'
    } // single quoted keys
    ]
  };

  var TEMPLATE_VARIABLES = {
    className: 'template-variable',
    variants: [{
      begin: /\{\{/,
      end: /\}\}/
    },
    // jinja templates Ansible
    {
      begin: /%\{/,
      end: /\}/
    } // Ruby i18n
    ]
  };

  var STRING = {
    className: 'string',
    relevance: 0,
    variants: [{
      begin: /'/,
      end: /'/
    }, {
      begin: /"/,
      end: /"/
    }, {
      begin: /\S+/
    }],
    contains: [hljs.BACKSLASH_ESCAPE, TEMPLATE_VARIABLES]
  };

  // Strings inside of value containers (objects) can't contain braces,
  // brackets, or commas
  var CONTAINER_STRING = hljs.inherit(STRING, {
    variants: [{
      begin: /'/,
      end: /'/
    }, {
      begin: /"/,
      end: /"/
    }, {
      begin: /[^\s,{}[\]]+/
    }]
  });
  var DATE_RE = '[0-9]{4}(-[0-9][0-9]){0,2}';
  var TIME_RE = '([Tt \\t][0-9][0-9]?(:[0-9][0-9]){2})?';
  var FRACTION_RE = '(\\.[0-9]*)?';
  var ZONE_RE = '([ \\t])*(Z|[-+][0-9][0-9]?(:[0-9][0-9])?)?';
  var TIMESTAMP = {
    className: 'number',
    begin: '\\b' + DATE_RE + TIME_RE + FRACTION_RE + ZONE_RE + '\\b'
  };
  var VALUE_CONTAINER = {
    end: ',',
    endsWithParent: true,
    excludeEnd: true,
    keywords: LITERALS,
    relevance: 0
  };
  var OBJECT = {
    begin: /\{/,
    end: /\}/,
    contains: [VALUE_CONTAINER],
    illegal: '\\n',
    relevance: 0
  };
  var ARRAY = {
    begin: '\\[',
    end: '\\]',
    contains: [VALUE_CONTAINER],
    illegal: '\\n',
    relevance: 0
  };
  var MODES = [KEY, {
    className: 'meta',
    begin: '^---\\s*$',
    relevance: 10
  }, {
    // multi line string
    // Blocks start with a | or > followed by a newline
    //
    // Indentation of subsequent lines must be the same to
    // be considered part of the block
    className: 'string',
    begin: '[\\|>]([1-9]?[+-])?[ ]*\\n( +)[^ ][^\\n]*\\n(\\2[^\\n]+\\n?)*'
  }, {
    // Ruby/Rails erb
    begin: '<%[%=-]?',
    end: '[%-]?%>',
    subLanguage: 'ruby',
    excludeBegin: true,
    excludeEnd: true,
    relevance: 0
  }, {
    // named tags
    className: 'type',
    begin: '!\\w+!' + URI_CHARACTERS
  },
  // https://yaml.org/spec/1.2/spec.html#id2784064
  {
    // verbatim tags
    className: 'type',
    begin: '!<' + URI_CHARACTERS + ">"
  }, {
    // primary tags
    className: 'type',
    begin: '!' + URI_CHARACTERS
  }, {
    // secondary tags
    className: 'type',
    begin: '!!' + URI_CHARACTERS
  }, {
    // fragment id &ref
    className: 'meta',
    begin: '&' + hljs.UNDERSCORE_IDENT_RE + '$'
  }, {
    // fragment reference *ref
    className: 'meta',
    begin: '\\*' + hljs.UNDERSCORE_IDENT_RE + '$'
  }, {
    // array listing
    className: 'bullet',
    // TODO: remove |$ hack when we have proper look-ahead support
    begin: '-(?=[ ]|$)',
    relevance: 0
  }, hljs.HASH_COMMENT_MODE, {
    beginKeywords: LITERALS,
    keywords: {
      literal: LITERALS
    }
  }, TIMESTAMP,
  // numbers are any valid C-style number that
  // sit isolated from other words
  {
    className: 'number',
    begin: hljs.C_NUMBER_RE + '\\b',
    relevance: 0
  }, OBJECT, ARRAY, STRING];
  var VALUE_MODES = [].concat(MODES);
  VALUE_MODES.pop();
  VALUE_MODES.push(CONTAINER_STRING);
  VALUE_CONTAINER.contains = VALUE_MODES;
  return {
    name: 'YAML',
    case_insensitive: true,
    aliases: ['yml'],
    contains: MODES
  };
}
module.exports = yaml;

/***/ }),

/***/ 33501:
/***/ ((module) => {

/*
 Language: Zephir
 Description: Zephir, an open source, high-level language designed to ease the creation and maintainability of extensions for PHP with a focus on type and memory safety.
 Author: Oleg Efimov <efimovov@gmail.com>
 Website: https://zephir-lang.com/en
 Audit: 2020
 */

/** @type LanguageFn */
function zephir(hljs) {
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE],
    variants: [hljs.inherit(hljs.APOS_STRING_MODE, {
      illegal: null
    }), hljs.inherit(hljs.QUOTE_STRING_MODE, {
      illegal: null
    })]
  };
  var TITLE_MODE = hljs.UNDERSCORE_TITLE_MODE;
  var NUMBER = {
    variants: [hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE]
  };
  var KEYWORDS =
  // classes and objects
  'namespace class interface use extends ' + 'function return ' + 'abstract final public protected private static deprecated ' +
  // error handling
  'throw try catch Exception ' +
  // keyword-ish things their website does NOT seem to highlight (in their own snippets)
  // 'typeof fetch in ' +
  // operators/helpers
  'echo empty isset instanceof unset ' +
  // assignment/variables
  'let var new const self ' +
  // control
  'require ' + 'if else elseif switch case default ' + 'do while loop for continue break ' + 'likely unlikely ' +
  // magic constants
  // https://github.com/phalcon/zephir/blob/master/Library/Expression/Constants.php
  '__LINE__ __FILE__ __DIR__ __FUNCTION__ __CLASS__ __TRAIT__ __METHOD__ __NAMESPACE__ ' +
  // types - https://docs.zephir-lang.com/0.12/en/types
  'array boolean float double integer object resource string ' + 'char long unsigned bool int uint ulong uchar ' +
  // built-ins
  'true false null undefined';
  return {
    name: 'Zephir',
    aliases: ['zep'],
    keywords: KEYWORDS,
    contains: [hljs.C_LINE_COMMENT_MODE, hljs.COMMENT(/\/\*/, /\*\//, {
      contains: [{
        className: 'doctag',
        begin: /@[A-Za-z]+/
      }]
    }), {
      className: 'string',
      begin: /<<<['"]?\w+['"]?$/,
      end: /^\w+;/,
      contains: [hljs.BACKSLASH_ESCAPE]
    }, {
      // swallow composed identifiers to avoid parsing them as keywords
      begin: /(::|->)+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/
    }, {
      className: 'function',
      beginKeywords: 'function fn',
      end: /[;{]/,
      excludeEnd: true,
      illegal: /\$|\[|%/,
      contains: [TITLE_MODE, {
        className: 'params',
        begin: /\(/,
        end: /\)/,
        keywords: KEYWORDS,
        contains: ['self', hljs.C_BLOCK_COMMENT_MODE, STRING, NUMBER]
      }]
    }, {
      className: 'class',
      beginKeywords: 'class interface',
      end: /\{/,
      excludeEnd: true,
      illegal: /[:($"]/,
      contains: [{
        beginKeywords: 'extends implements'
      }, TITLE_MODE]
    }, {
      beginKeywords: 'namespace',
      end: /;/,
      illegal: /[.']/,
      contains: [TITLE_MODE]
    }, {
      beginKeywords: 'use',
      end: /;/,
      contains: [TITLE_MODE]
    }, {
      begin: /=>/ // No markup, just a relevance booster
    }, STRING, NUMBER]
  };
}
module.exports = zephir;

/***/ }),

/***/ 88617:
/***/ ((__unused_webpack_module, exports) => {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i = isLE ? nBytes - 1 : 0;
  var d = isLE ? -1 : 1;
  var s = buffer[offset + i];
  i += d;
  e = s & (1 << -nBits) - 1;
  s >>= -nBits;
  nBits += eLen;
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : (s ? -1 : 1) * Infinity;
  } else {
    m = m + Math.pow(2, mLen);
    e = e - eBias;
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
  var i = isLE ? 0 : nBytes - 1;
  var d = isLE ? 1 : -1;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  value = Math.abs(value);
  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
  buffer[offset + i - d] |= s * 128;
};

/***/ }),

/***/ 74915:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(43371);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
var hasOwn = __webpack_require__(94672);
var channel = __webpack_require__(5757)();
var $TypeError = __webpack_require__(13237);
var SLOT = {
  assert: function assert(O, slot) {
    if (!O || _typeof(O) !== 'object' && typeof O !== 'function') {
      throw new $TypeError('`O` is not an object');
    }
    if (typeof slot !== 'string') {
      throw new $TypeError('`slot` must be a string');
    }
    channel.assert(O);
    if (!SLOT.has(O, slot)) {
      throw new $TypeError('`' + slot + '` is not present on `O`');
    }
  },
  get: function get(O, slot) {
    if (!O || _typeof(O) !== 'object' && typeof O !== 'function') {
      throw new $TypeError('`O` is not an object');
    }
    if (typeof slot !== 'string') {
      throw new $TypeError('`slot` must be a string');
    }
    var slots = channel.get(O);
    return slots && slots['$' + slot];
  },
  has: function has(O, slot) {
    if (!O || _typeof(O) !== 'object' && typeof O !== 'function') {
      throw new $TypeError('`O` is not an object');
    }
    if (typeof slot !== 'string') {
      throw new $TypeError('`slot` must be a string');
    }
    var slots = channel.get(O);
    return !!slots && hasOwn(slots, '$' + slot);
  },
  set: function set(O, slot, V) {
    if (!O || _typeof(O) !== 'object' && typeof O !== 'function') {
      throw new $TypeError('`O` is not an object');
    }
    if (typeof slot !== 'string') {
      throw new $TypeError('`slot` must be a string');
    }
    var slots = channel.get(O);
    if (!slots) {
      slots = {};
      channel.set(O, slots);
    }
    slots['$' + slot] = V;
  }
};
if (Object.freeze) {
  Object.freeze(SLOT);
}
module.exports = SLOT;

/***/ }),

/***/ 99719:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(39341);
__webpack_require__(73706);
__webpack_require__(10408);
__webpack_require__(41539);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
var hasToStringTag = __webpack_require__(80297)();
var callBound = __webpack_require__(73684);
var $toString = callBound('Object.prototype.toString');
var isStandardArguments = function isArguments(value) {
  if (hasToStringTag && value && _typeof(value) === 'object' && Symbol.toStringTag in value) {
    return false;
  }
  return $toString(value) === '[object Arguments]';
};
var isLegacyArguments = function isArguments(value) {
  if (isStandardArguments(value)) {
    return true;
  }
  return value !== null && _typeof(value) === 'object' && typeof value.length === 'number' && value.length >= 0 && $toString(value) !== '[object Array]' && $toString(value.callee) === '[object Function]';
};
var supportsStandardArguments = function () {
  return isStandardArguments(arguments);
}();
isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;

/***/ }),

/***/ 14063:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(47042);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
var callBind = __webpack_require__(53785);
var callBound = __webpack_require__(73684);
var GetIntrinsic = __webpack_require__(37555);
var $ArrayBuffer = GetIntrinsic('%ArrayBuffer%', true);
/** @type {undefined | ((receiver: ArrayBuffer) => number) | ((receiver: unknown) => never)} */
var $byteLength = callBound('ArrayBuffer.prototype.byteLength', true);
var $toString = callBound('Object.prototype.toString');

// in node 0.10, ArrayBuffers have no prototype methods, but have an own slot-checking `slice` method
var abSlice = !!$ArrayBuffer && !$byteLength && new $ArrayBuffer(0).slice;
var $abSlice = !!abSlice && callBind(abSlice);

/** @type {import('.')} */
module.exports = $byteLength || $abSlice ? function isArrayBuffer(obj) {
  if (!obj || _typeof(obj) !== 'object') {
    return false;
  }
  try {
    if ($byteLength) {
      // @ts-expect-error no idea why TS can't handle the overload
      $byteLength(obj);
    } else {
      // @ts-expect-error TS chooses not to type-narrow inside a closure
      $abSlice(obj, 0);
    }
    return true;
  } catch (e) {
    return false;
  }
} : $ArrayBuffer
// in node 0.8, ArrayBuffers have no prototype or own methods, but also no Symbol.toStringTag
? function isArrayBuffer(obj) {
  return $toString(obj) === '[object ArrayBuffer]';
} : function isArrayBuffer(obj) {
  // eslint-disable-line no-unused-vars
  return false;
};

/***/ }),

/***/ 20173:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(41539);
/**
 * isArray
 */

var isArray = Array.isArray;

/**
 * toString
 */

var str = Object.prototype.toString;

/**
 * Whether or not the given `val`
 * is an array.
 *
 * example:
 *
 *        isArray([]);
 *        // > true
 *        isArray(arguments);
 *        // > false
 *        isArray('');
 *        // > false
 *
 * @param {mixed} val
 * @return {bool}
 */

module.exports = isArray || function (val) {
  return !!val && '[object Array]' == str.call(val);
};

/***/ }),

/***/ 12783:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
var hasBigInts = __webpack_require__(10482)();
if (hasBigInts) {
  var bigIntValueOf = BigInt.prototype.valueOf;
  var tryBigInt = function tryBigIntObject(value) {
    try {
      bigIntValueOf.call(value);
      return true;
    } catch (e) {}
    return false;
  };
  module.exports = function isBigInt(value) {
    if (value === null || typeof value === 'undefined' || typeof value === 'boolean' || typeof value === 'string' || typeof value === 'number' || _typeof(value) === 'symbol' || typeof value === 'function') {
      return false;
    }
    if (typeof value === 'bigint') {
      return true;
    }
    return tryBigInt(value);
  };
} else {
  module.exports = function isBigInt(value) {
    return  false && 0;
  };
}

/***/ }),

/***/ 57801:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(39341);
__webpack_require__(73706);
__webpack_require__(10408);
__webpack_require__(41539);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
var callBound = __webpack_require__(73684);
var $boolToStr = callBound('Boolean.prototype.toString');
var $toString = callBound('Object.prototype.toString');
var tryBooleanObject = function booleanBrandCheck(value) {
  try {
    $boolToStr(value);
    return true;
  } catch (e) {
    return false;
  }
};
var boolClass = '[object Boolean]';
var hasToStringTag = __webpack_require__(80297)();
module.exports = function isBoolean(value) {
  if (typeof value === 'boolean') {
    return true;
  }
  if (value === null || _typeof(value) !== 'object') {
    return false;
  }
  return hasToStringTag && Symbol.toStringTag in value ? tryBooleanObject(value) : $toString(value) === boolClass;
};

/***/ }),

/***/ 61343:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(47042);
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
};
function isBuffer(obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer(obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0));
}

/***/ }),

/***/ 30916:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(41539);
__webpack_require__(36535);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(39341);
__webpack_require__(73706);
__webpack_require__(10408);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
var fnToStr = Function.prototype.toString;
var reflectApply = (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
  try {
    badArrayLike = Object.defineProperty({}, 'length', {
      get: function get() {
        throw isCallableMarker;
      }
    });
    isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    reflectApply(function () {
      throw 42;
    }, null, badArrayLike);
  } catch (_) {
    if (_ !== isCallableMarker) {
      reflectApply = null;
    }
  }
} else {
  reflectApply = null;
}
var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
  try {
    var fnStr = fnToStr.call(value);
    return constructorRegex.test(fnStr);
  } catch (e) {
    return false; // not a function
  }
};

var tryFunctionObject = function tryFunctionToStr(value) {
  try {
    if (isES6ClassFn(value)) {
      return false;
    }
    fnToStr.call(value);
    return true;
  } catch (e) {
    return false;
  }
};
var toStr = Object.prototype.toString;
var objectClass = '[object Object]';
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var ddaClass = '[object HTMLAllCollection]'; // IE 11
var ddaClass2 = '[object HTML document.all class]';
var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`

var isIE68 = !(0 in [,]); // eslint-disable-line no-sparse-arrays, comma-spacing

var isDDA = function isDocumentDotAll() {
  return false;
};
if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object') {
  // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
  var all = document.all;
  if (toStr.call(all) === toStr.call(document.all)) {
    isDDA = function isDocumentDotAll(value) {
      /* globals document: false */
      // in IE 6-8, typeof document.all is "object" and it's truthy
      if ((isIE68 || !value) && (typeof value === 'undefined' || _typeof(value) === 'object')) {
        try {
          var str = toStr.call(value);
          return (str === ddaClass || str === ddaClass2 || str === ddaClass3 // opera 12.16
          || str === objectClass // IE 6-8
          ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {/**/}
      }
      return false;
    };
  }
}
module.exports = reflectApply ? function isCallable(value) {
  if (isDDA(value)) {
    return true;
  }
  if (!value) {
    return false;
  }
  if (typeof value !== 'function' && _typeof(value) !== 'object') {
    return false;
  }
  try {
    reflectApply(value, null, badArrayLike);
  } catch (e) {
    if (e !== isCallableMarker) {
      return false;
    }
  }
  return !isES6ClassFn(value) && tryFunctionObject(value);
} : function isCallable(value) {
  if (isDDA(value)) {
    return true;
  }
  if (!value) {
    return false;
  }
  if (typeof value !== 'function' && _typeof(value) !== 'object') {
    return false;
  }
  if (hasToStringTag) {
    return tryFunctionObject(value);
  }
  if (isES6ClassFn(value)) {
    return false;
  }
  var strClass = toStr.call(value);
  if (strClass !== fnClass && strClass !== genClass && !/^\[object HTML/.test(strClass)) {
    return false;
  }
  return tryFunctionObject(value);
};

/***/ }),

/***/ 26515:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(41539);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
  try {
    getDay.call(value);
    return true;
  } catch (e) {
    return false;
  }
};
var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = __webpack_require__(80297)();
module.exports = function isDateObject(value) {
  if (_typeof(value) !== 'object' || value === null) {
    return false;
  }
  return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};

/***/ }),

/***/ 73562:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(41539);
module.exports = isFunction;
var toString = Object.prototype.toString;
function isFunction(fn) {
  if (!fn) {
    return false;
  }
  var string = toString.call(fn);
  return string === '[object Function]' || typeof fn === 'function' && string !== '[object RegExp]' || typeof window !== 'undefined' && (fn === window.setTimeout || fn === window.alert || fn === window.confirm || fn === window.prompt);
}
;

/***/ }),

/***/ 28026:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(68309);
/**
 * Export generator function checks.
 */
module.exports = isGenerator;
module.exports.fn = isGeneratorFunction;

/**
 * Check whether an object is a generator.
 *
 * @param  {Object}  obj
 * @return {Boolean}
 */
function isGenerator(obj) {
  return obj && typeof obj.next === 'function' && typeof obj.throw === 'function';
}

/**
 * Check whether a function is generator.
 *
 * @param  {Function} fn
 * @return {Boolean}
 */
function isGeneratorFunction(fn) {
  return typeof fn === 'function' && fn.constructor && fn.constructor.name === 'GeneratorFunction';
}

/***/ }),

/***/ 28199:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_require__(21249);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(23123);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(41539);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(27852);
__webpack_require__(47042);
__webpack_unused_export__ = ({
  value: true
});

/**
 * Constants.
 */

var IS_MAC = typeof window != 'undefined' && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);
var MODIFIERS = {
  alt: 'altKey',
  control: 'ctrlKey',
  meta: 'metaKey',
  shift: 'shiftKey'
};
var ALIASES = {
  add: '+',
  break: 'pause',
  cmd: 'meta',
  command: 'meta',
  ctl: 'control',
  ctrl: 'control',
  del: 'delete',
  down: 'arrowdown',
  esc: 'escape',
  ins: 'insert',
  left: 'arrowleft',
  mod: IS_MAC ? 'meta' : 'control',
  opt: 'alt',
  option: 'alt',
  return: 'enter',
  right: 'arrowright',
  space: ' ',
  spacebar: ' ',
  up: 'arrowup',
  win: 'meta',
  windows: 'meta'
};
var CODES = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  control: 17,
  alt: 18,
  pause: 19,
  capslock: 20,
  escape: 27,
  ' ': 32,
  pageup: 33,
  pagedown: 34,
  end: 35,
  home: 36,
  arrowleft: 37,
  arrowup: 38,
  arrowright: 39,
  arrowdown: 40,
  insert: 45,
  delete: 46,
  meta: 91,
  numlock: 144,
  scrolllock: 145,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  '\'': 222
};
for (var f = 1; f < 20; f++) {
  CODES['f' + f] = 111 + f;
}

/**
 * Is hotkey?
 */

function isHotkey(hotkey, options, event) {
  if (options && !('byKey' in options)) {
    event = options;
    options = null;
  }
  if (!Array.isArray(hotkey)) {
    hotkey = [hotkey];
  }
  var array = hotkey.map(function (string) {
    return parseHotkey(string, options);
  });
  var check = function check(e) {
    return array.some(function (object) {
      return compareHotkey(object, e);
    });
  };
  var ret = event == null ? check : check(event);
  return ret;
}
function isCodeHotkey(hotkey, event) {
  return isHotkey(hotkey, event);
}
function isKeyHotkey(hotkey, event) {
  return isHotkey(hotkey, {
    byKey: true
  }, event);
}

/**
 * Parse.
 */

function parseHotkey(hotkey, options) {
  var byKey = options && options.byKey;
  var ret = {};

  // Special case to handle the `+` key since we use it as a separator.
  hotkey = hotkey.replace('++', '+add');
  var values = hotkey.split('+');
  var length = values.length;

  // Ensure that all the modifiers are set to false unless the hotkey has them.

  for (var k in MODIFIERS) {
    ret[MODIFIERS[k]] = false;
  }
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;
  try {
    for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var value = _step.value;
      var optional = value.endsWith('?') && value.length > 1;
      if (optional) {
        value = value.slice(0, -1);
      }
      var name = toKeyName(value);
      var modifier = MODIFIERS[name];
      if (length === 1 || !modifier) {
        if (byKey) {
          ret.key = name;
        } else {
          ret.which = toKeyCode(value);
        }
      }
      if (modifier) {
        ret[modifier] = optional ? null : true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return ret;
}

/**
 * Compare.
 */

function compareHotkey(object, event) {
  for (var key in object) {
    var expected = object[key];
    var actual = void 0;
    if (expected == null) {
      continue;
    }
    if (key === 'key' && event.key != null) {
      actual = event.key.toLowerCase();
    } else if (key === 'which') {
      actual = expected === 91 && event.which === 93 ? 91 : event.which;
    } else {
      actual = event[key];
    }
    if (actual == null && expected === false) {
      continue;
    }
    if (actual !== expected) {
      return false;
    }
  }
  return true;
}

/**
 * Utils.
 */

function toKeyCode(name) {
  name = toKeyName(name);
  var code = CODES[name] || name.toUpperCase().charCodeAt(0);
  return code;
}
function toKeyName(name) {
  name = name.toLowerCase();
  name = ALIASES[name] || name;
  return name;
}

/**
 * Export.
 */

exports.ZP = isHotkey;
__webpack_unused_export__ = isHotkey;
__webpack_unused_export__ = isCodeHotkey;
__webpack_unused_export__ = isKeyHotkey;
__webpack_unused_export__ = parseHotkey;
__webpack_unused_export__ = compareHotkey;
__webpack_unused_export__ = toKeyCode;
exports.rs = toKeyName;

/***/ }),

/***/ 77088:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/** @const */
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(66992);
__webpack_require__(51532);
__webpack_require__(41539);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(70189);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
var $Map = typeof Map === 'function' && Map.prototype ? Map : null;
var $Set = typeof Set === 'function' && Set.prototype ? Set : null;
var exported;
if (!$Map) {
  /** @type {import('.')} */
  // eslint-disable-next-line no-unused-vars
  exported = function isMap(x) {
    // `Map` is not present in this environment.
    return false;
  };
}
var $mapHas = $Map ? Map.prototype.has : null;
var $setHas = $Set ? Set.prototype.has : null;
if (!exported && !$mapHas) {
  /** @type {import('.')} */
  // eslint-disable-next-line no-unused-vars
  exported = function isMap(x) {
    // `Map` does not have a `has` method
    return false;
  };
}

/** @type {import('.')} */
module.exports = exported || function isMap(x) {
  if (!x || _typeof(x) !== 'object') {
    return false;
  }
  try {
    $mapHas.call(x);
    if ($setHas) {
      try {
        $setHas.call(x);
      } catch (e) {
        return true;
      }
    }
    // @ts-expect-error TS can't figure out that $Map is always truthy here
    return x instanceof $Map; // core-js workaround, pre-v2.5.0
  } catch (e) {}
  return false;
};

/***/ }),

/***/ 39943:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(41539);
__webpack_require__(9653);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
var numToStr = Number.prototype.toString;
var tryNumberObject = function tryNumberObject(value) {
  try {
    numToStr.call(value);
    return true;
  } catch (e) {
    return false;
  }
};
var toStr = Object.prototype.toString;
var numClass = '[object Number]';
var hasToStringTag = __webpack_require__(80297)();
module.exports = function isNumberObject(value) {
  if (typeof value === 'number') {
    return true;
  }
  if (_typeof(value) !== 'object') {
    return false;
  }
  return hasToStringTag ? tryNumberObject(value) : toStr.call(value) === numClass;
};

/***/ }),

/***/ 43100:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/*!
 * is-number <https://github.com/jonschlinkert/is-number>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */



__webpack_require__(73210);
var typeOf = __webpack_require__(71387);
module.exports = function isNumber(num) {
  var type = typeOf(num);
  if (type === 'string') {
    if (!num.trim()) return false;
  } else if (type !== 'number') {
    return false;
  }
  return num - num + 1 >= 0;
};

/***/ }),

/***/ 71387:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(41539);
__webpack_require__(9653);
__webpack_require__(24603);
__webpack_require__(74916);
__webpack_require__(39714);
var isBuffer = __webpack_require__(61343);
var toString = Object.prototype.toString;

/**
 * Get the native `typeof` a value.
 *
 * @param  {*} `val`
 * @return {*} Native javascript type
 */

module.exports = function kindOf(val) {
  // primitivies
  if (typeof val === 'undefined') {
    return 'undefined';
  }
  if (val === null) {
    return 'null';
  }
  if (val === true || val === false || val instanceof Boolean) {
    return 'boolean';
  }
  if (typeof val === 'string' || val instanceof String) {
    return 'string';
  }
  if (typeof val === 'number' || val instanceof Number) {
    return 'number';
  }

  // functions
  if (typeof val === 'function' || val instanceof Function) {
    return 'function';
  }

  // array
  if (typeof Array.isArray !== 'undefined' && Array.isArray(val)) {
    return 'array';
  }

  // check for instances of RegExp and Date before calling `toString`
  if (val instanceof RegExp) {
    return 'regexp';
  }
  if (val instanceof Date) {
    return 'date';
  }

  // other objects
  var type = toString.call(val);
  if (type === '[object RegExp]') {
    return 'regexp';
  }
  if (type === '[object Date]') {
    return 'date';
  }
  if (type === '[object Arguments]') {
    return 'arguments';
  }
  if (type === '[object Error]') {
    return 'error';
  }

  // buffer
  if (isBuffer(val)) {
    return 'buffer';
  }

  // es6: Map, WeakMap, Set, WeakSet
  if (type === '[object Set]') {
    return 'set';
  }
  if (type === '[object WeakSet]') {
    return 'weakset';
  }
  if (type === '[object Map]') {
    return 'map';
  }
  if (type === '[object WeakMap]') {
    return 'weakmap';
  }
  if (type === '[object Symbol]') {
    return 'symbol';
  }

  // typed arrays
  if (type === '[object Int8Array]') {
    return 'int8array';
  }
  if (type === '[object Uint8Array]') {
    return 'uint8array';
  }
  if (type === '[object Uint8ClampedArray]') {
    return 'uint8clampedarray';
  }
  if (type === '[object Int16Array]') {
    return 'int16array';
  }
  if (type === '[object Uint16Array]') {
    return 'uint16array';
  }
  if (type === '[object Int32Array]') {
    return 'int32array';
  }
  if (type === '[object Uint32Array]') {
    return 'uint32array';
  }
  if (type === '[object Float32Array]') {
    return 'float32array';
  }
  if (type === '[object Float64Array]') {
    return 'float64array';
  }

  // must be a plain object
  return 'object';
};

/***/ }),

/***/ 39011:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(96649);
__webpack_require__(96078);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(38880);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
var callBound = __webpack_require__(73684);
var hasToStringTag = __webpack_require__(80297)();
var has;
var $exec;
var isRegexMarker;
var badStringifier;
if (hasToStringTag) {
  has = callBound('Object.prototype.hasOwnProperty');
  $exec = callBound('RegExp.prototype.exec');
  isRegexMarker = {};
  var throwRegexMarker = function throwRegexMarker() {
    throw isRegexMarker;
  };
  badStringifier = {
    toString: throwRegexMarker,
    valueOf: throwRegexMarker
  };
  if (_typeof(Symbol.toPrimitive) === 'symbol') {
    badStringifier[Symbol.toPrimitive] = throwRegexMarker;
  }
}
var $toString = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';
module.exports = hasToStringTag
// eslint-disable-next-line consistent-return
? function isRegex(value) {
  if (!value || _typeof(value) !== 'object') {
    return false;
  }
  var descriptor = gOPD(value, 'lastIndex');
  var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
  if (!hasLastIndexDataProperty) {
    return false;
  }
  try {
    $exec(value, badStringifier);
  } catch (e) {
    return e === isRegexMarker;
  }
} : function isRegex(value) {
  // In older browsers, typeof regex incorrectly returns 'function'
  if (!value || _typeof(value) !== 'object' && typeof value !== 'function') {
    return false;
  }
  return $toString(value) === regexClass;
};

/***/ }),

/***/ 9458:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(66992);
__webpack_require__(51532);
__webpack_require__(41539);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(70189);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
var $Map = typeof Map === 'function' && Map.prototype ? Map : null;
var $Set = typeof Set === 'function' && Set.prototype ? Set : null;
var exported;
if (!$Set) {
  /** @type {import('.')} */
  // eslint-disable-next-line no-unused-vars
  exported = function isSet(x) {
    // `Set` is not present in this environment.
    return false;
  };
}
var $mapHas = $Map ? Map.prototype.has : null;
var $setHas = $Set ? Set.prototype.has : null;
if (!exported && !$setHas) {
  /** @type {import('.')} */
  // eslint-disable-next-line no-unused-vars
  exported = function isSet(x) {
    // `Set` does not have a `has` method
    return false;
  };
}

/** @type {import('.')} */
module.exports = exported || function isSet(x) {
  if (!x || _typeof(x) !== 'object') {
    return false;
  }
  try {
    $setHas.call(x);
    if ($mapHas) {
      try {
        $mapHas.call(x);
      } catch (e) {
        return true;
      }
    }
    // @ts-expect-error TS can't figure out that $Set is always truthy here
    return x instanceof $Set; // core-js workaround, pre-v2.5.0
  } catch (e) {}
  return false;
};

/***/ }),

/***/ 75769:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
var callBound = __webpack_require__(73684);
var $byteLength = callBound('SharedArrayBuffer.prototype.byteLength', true);

/** @type {import('.')} */
module.exports = $byteLength ? function isSharedArrayBuffer(obj) {
  if (!obj || _typeof(obj) !== 'object') {
    return false;
  }
  try {
    $byteLength(obj);
    return true;
  } catch (e) {
    return false;
  }
} : function isSharedArrayBuffer(obj) {
  // eslint-disable-line no-unused-vars
  return false;
};

/***/ }),

/***/ 68210:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(41539);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
var strValue = String.prototype.valueOf;
var tryStringObject = function tryStringObject(value) {
  try {
    strValue.call(value);
    return true;
  } catch (e) {
    return false;
  }
};
var toStr = Object.prototype.toString;
var strClass = '[object String]';
var hasToStringTag = __webpack_require__(80297)();
module.exports = function isString(value) {
  if (typeof value === 'string') {
    return true;
  }
  if (_typeof(value) !== 'object') {
    return false;
  }
  return hasToStringTag ? tryStringObject(value) : toStr.call(value) === strClass;
};

/***/ }),

/***/ 86967:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(41539);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
var toStr = Object.prototype.toString;
var hasSymbols = __webpack_require__(98949)();
if (hasSymbols) {
  var symToStr = Symbol.prototype.toString;
  var symStringRegex = /^Symbol\(.*\)$/;
  var isSymbolObject = function isRealSymbolObject(value) {
    if (_typeof(value.valueOf()) !== 'symbol') {
      return false;
    }
    return symStringRegex.test(symToStr.call(value));
  };
  module.exports = function isSymbol(value) {
    if (_typeof(value) === 'symbol') {
      return true;
    }
    if (toStr.call(value) !== '[object Symbol]') {
      return false;
    }
    try {
      return isSymbolObject(value);
    } catch (e) {
      return false;
    }
  };
} else {
  module.exports = function isSymbol(value) {
    // this environment does not support Symbols.
    return  false && 0;
  };
}

/***/ }),

/***/ 77219:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(66992);
__webpack_require__(41539);
__webpack_require__(78783);
__webpack_require__(4129);
__webpack_require__(33948);
__webpack_require__(38478);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
var $WeakMap = typeof WeakMap === 'function' && WeakMap.prototype ? WeakMap : null;
var $WeakSet = typeof WeakSet === 'function' && WeakSet.prototype ? WeakSet : null;
var exported;
if (!$WeakMap) {
  /** @type {import('.')} */
  // eslint-disable-next-line no-unused-vars
  exported = function isWeakMap(x) {
    // `WeakMap` is not present in this environment.
    return false;
  };
}
var $mapHas = $WeakMap ? $WeakMap.prototype.has : null;
var $setHas = $WeakSet ? $WeakSet.prototype.has : null;
if (!exported && !$mapHas) {
  /** @type {import('.')} */
  // eslint-disable-next-line no-unused-vars
  exported = function isWeakMap(x) {
    // `WeakMap` does not have a `has` method
    return false;
  };
}

/** @type {import('.')} */
module.exports = exported || function isWeakMap(x) {
  if (!x || _typeof(x) !== 'object') {
    return false;
  }
  try {
    $mapHas.call(x, $mapHas);
    if ($setHas) {
      try {
        $setHas.call(x, $setHas);
      } catch (e) {
        return true;
      }
    }
    // @ts-expect-error TS can't figure out that $WeakMap is always truthy here
    return x instanceof $WeakMap; // core-js workaround, pre-v3
  } catch (e) {}
  return false;
};

/***/ }),

/***/ 34301:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
var GetIntrinsic = __webpack_require__(37555);
var callBound = __webpack_require__(73684);
var $WeakSet = GetIntrinsic('%WeakSet%', true);
var $setHas = callBound('WeakSet.prototype.has', true);
if ($setHas) {
  var $mapHas = callBound('WeakMap.prototype.has', true);

  /** @type {import('.')} */
  module.exports = function isWeakSet(x) {
    if (!x || _typeof(x) !== 'object') {
      return false;
    }
    try {
      $setHas(x, $setHas);
      if ($mapHas) {
        try {
          $mapHas(x, $mapHas);
        } catch (e) {
          return true;
        }
      }
      // @ts-expect-error TS can't figure out that $WeakSet is always truthy here
      return x instanceof $WeakSet; // core-js workaround, pre-v3
    } catch (e) {}
    return false;
  };
} else {
  /** @type {import('.')} */
  // eslint-disable-next-line no-unused-vars
  module.exports = function isWeakSet(x) {
    // `WeakSet` does not exist, or does not have a `has` method
    return false;
  };
}

/***/ }),

/***/ 98597:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(41539);
var toString = {}.toString;
module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

/***/ }),

/***/ 47765:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

__webpack_require__(18264);
__webpack_require__(41539);
__webpack_require__(66992);
__webpack_require__(82472);
__webpack_require__(92990);
__webpack_require__(18927);
__webpack_require__(33105);
__webpack_require__(35035);
__webpack_require__(74345);
__webpack_require__(7174);
__webpack_require__(32846);
__webpack_require__(44731);
__webpack_require__(77209);
__webpack_require__(96319);
__webpack_require__(58867);
__webpack_require__(37789);
__webpack_require__(33739);
__webpack_require__(29368);
__webpack_require__(14483);
__webpack_require__(12056);
__webpack_require__(3462);
__webpack_require__(30678);
__webpack_require__(27462);
__webpack_require__(33824);
__webpack_require__(55021);
__webpack_require__(12974);
__webpack_require__(15016);
/* eslint-env browser */
var perf = typeof performance === 'undefined' ? null : performance;
var isoCrypto = typeof crypto === 'undefined' ? null : crypto;

/**
 * @type {function(number):ArrayBuffer}
 */
var cryptoRandomBuffer = isoCrypto !== null ? function (len) {
  // browser
  var buf = new ArrayBuffer(len);
  var arr = new Uint8Array(buf);
  isoCrypto.getRandomValues(arr);
  return buf;
} : function (len) {
  // polyfill
  var buf = new ArrayBuffer(len);
  var arr = new Uint8Array(buf);
  for (var i = 0; i < len; i++) {
    arr[i] = Math.ceil(Math.random() * 0xFFFFFFFF >>> 0);
  }
  return buf;
};
exports.performance = perf;
exports.cryptoRandomBuffer = cryptoRandomBuffer;

/***/ }),

/***/ 19820:
/***/ ((module, exports, __webpack_require__) => {

__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === _typeof(searchInput)) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
    if (hasKeyCode) searchInput = hasKeyCode;
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput];

  // Everything else (cast to string)
  var search = String(searchInput);

  // check codes
  var foundNamedKey = codes[search.toLowerCase()];
  if (foundNamedKey) return foundNamedKey;

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()];
  if (foundNamedKey) return foundNamedKey;

  // weird character?
  if (search.length === 1) return search.charCodeAt(0);
  return undefined;
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === _typeof(event)) {
    var keyCode = event.which || event.keyCode || event.charCode;
    if (keyCode === null || keyCode === undefined) {
      return false;
    }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()];
      if (foundNamedKey) {
        return foundNamedKey === keyCode;
      }

      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()];
      if (foundNamedKey) {
        return foundNamedKey === keyCode;
      }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
};
exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
};

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
};

/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) {
  codes[String.fromCharCode(i)] = i - 32;
}

// numbers
for (var i = 48; i < 58; i++) {
  codes[i - 48] = i;
}

// function keys
for (i = 1; i < 13; i++) {
  codes['f' + i] = i + 111;
}

// numpad keys
for (i = 0; i < 10; i++) {
  codes['numpad ' + i] = i + 96;
}

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {}; // title for backward compat

// Create reverse mapping
for (i in codes) {
  names[codes[i]] = i;
}

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias];
}

/***/ }),

/***/ 78503:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// Load in dependencies
var computedStyle = __webpack_require__(6426);

/**
 * Calculate the `line-height` of a given node
 * @param {HTMLElement} node Element to calculate line height of. Must be in the DOM.
 * @returns {Number} `line-height` of the element in pixels
 */
function lineHeight(node) {
  // Grab the line-height via style
  var lnHeightStr = computedStyle(node, 'line-height');
  var lnHeight = parseFloat(lnHeightStr, 10);

  // If the lineHeight did not contain a unit (i.e. it was numeric), convert it to ems (e.g. '2.3' === '2.3em')
  if (lnHeightStr === lnHeight + '') {
    // Save the old lineHeight style and update the em unit to the element
    var _lnHeightStyle = node.style.lineHeight;
    node.style.lineHeight = lnHeightStr + 'em';

    // Calculate the em based height
    lnHeightStr = computedStyle(node, 'line-height');
    lnHeight = parseFloat(lnHeightStr, 10);

    // Revert the lineHeight style
    if (_lnHeightStyle) {
      node.style.lineHeight = _lnHeightStyle;
    } else {
      delete node.style.lineHeight;
    }
  }

  // If the lineHeight is in `pt`, convert it to pixels (4px for 3pt)
  // DEV: `em` units are converted to `pt` in IE6
  // Conversion ratio from https://developer.mozilla.org/en-US/docs/Web/CSS/length
  if (lnHeightStr.indexOf('pt') !== -1) {
    lnHeight *= 4;
    lnHeight /= 3;
    // Otherwise, if the lineHeight is in `mm`, convert it to pixels (96px for 25.4mm)
  } else if (lnHeightStr.indexOf('mm') !== -1) {
    lnHeight *= 96;
    lnHeight /= 25.4;
    // Otherwise, if the lineHeight is in `cm`, convert it to pixels (96px for 2.54cm)
  } else if (lnHeightStr.indexOf('cm') !== -1) {
    lnHeight *= 96;
    lnHeight /= 2.54;
    // Otherwise, if the lineHeight is in `in`, convert it to pixels (96px for 1in)
  } else if (lnHeightStr.indexOf('in') !== -1) {
    lnHeight *= 96;
    // Otherwise, if the lineHeight is in `pc`, convert it to pixels (12pt for 1pc)
  } else if (lnHeightStr.indexOf('pc') !== -1) {
    lnHeight *= 16;
  }

  // Continue our computation
  lnHeight = Math.round(lnHeight);

  // If the line-height is "normal", calculate by font-size
  if (lnHeightStr === 'normal') {
    // Create a temporary node
    var nodeName = node.nodeName;
    var _node = document.createElement(nodeName);
    _node.innerHTML = '&nbsp;';

    // If we have a text area, reset it to only 1 row
    // https://github.com/twolfson/line-height/issues/4
    if (nodeName.toUpperCase() === 'TEXTAREA') {
      _node.setAttribute('rows', '1');
    }

    // Set the font-size of the element
    var fontSizeStr = computedStyle(node, 'font-size');
    _node.style.fontSize = fontSizeStr;

    // Remove default padding/border which can affect offset height
    // https://github.com/twolfson/line-height/issues/4
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetHeight
    _node.style.padding = '0px';
    _node.style.border = '0px';

    // Append it to the body
    var body = document.body;
    body.appendChild(_node);

    // Assume the line height of the element is the height
    var height = _node.offsetHeight;
    lnHeight = height;

    // Remove our child from the DOM
    body.removeChild(_node);
  }

  // Return the calculated height
  return lnHeight;
}

// Export lineHeight
module.exports = lineHeight;

/***/ }),

/***/ 97754:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


////////////////////////////////////////////////////////////////////////////////
// Helpers

// Merge objects
//
__webpack_require__(47042);
__webpack_require__(54747);
__webpack_require__(47941);
__webpack_require__(41539);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(24603);
__webpack_require__(39714);
__webpack_require__(4723);
__webpack_require__(23123);
__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(57327);
__webpack_require__(64765);
__webpack_require__(2707);
__webpack_require__(92222);
function assign(obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);
  sources.forEach(function (source) {
    if (!source) {
      return;
    }
    Object.keys(source).forEach(function (key) {
      obj[key] = source[key];
    });
  });
  return obj;
}
function _class(obj) {
  return Object.prototype.toString.call(obj);
}
function isString(obj) {
  return _class(obj) === '[object String]';
}
function isObject(obj) {
  return _class(obj) === '[object Object]';
}
function isRegExp(obj) {
  return _class(obj) === '[object RegExp]';
}
function isFunction(obj) {
  return _class(obj) === '[object Function]';
}
function escapeRE(str) {
  return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}

////////////////////////////////////////////////////////////////////////////////

var defaultOptions = {
  fuzzyLink: true,
  fuzzyEmail: true,
  fuzzyIP: false
};
function isOptionsObj(obj) {
  return Object.keys(obj || {}).reduce(function (acc, k) {
    return acc || defaultOptions.hasOwnProperty(k);
  }, false);
}
var defaultSchemas = {
  'http:': {
    validate: function validate(text, pos, self) {
      var tail = text.slice(pos);
      if (!self.re.http) {
        // compile lazily, because "host"-containing variables can change on tlds update.
        self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
      }
      if (self.re.http.test(tail)) {
        return tail.match(self.re.http)[0].length;
      }
      return 0;
    }
  },
  'https:': 'http:',
  'ftp:': 'http:',
  '//': {
    validate: function validate(text, pos, self) {
      var tail = text.slice(pos);
      if (!self.re.no_http) {
        // compile lazily, because "host"-containing variables can change on tlds update.
        self.re.no_http = new RegExp('^' + self.re.src_auth +
        // Don't allow single-level domains, because of false positives like '//test'
        // with code comments
        '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
      }
      if (self.re.no_http.test(tail)) {
        // should not be `://` & `///`, that protects from errors in protocol name
        if (pos >= 3 && text[pos - 3] === ':') {
          return 0;
        }
        if (pos >= 3 && text[pos - 3] === '/') {
          return 0;
        }
        return tail.match(self.re.no_http)[0].length;
      }
      return 0;
    }
  },
  'mailto:': {
    validate: function validate(text, pos, self) {
      var tail = text.slice(pos);
      if (!self.re.mailto) {
        self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
      }
      if (self.re.mailto.test(tail)) {
        return tail.match(self.re.mailto)[0].length;
      }
      return 0;
    }
  }
};

/*eslint-disable max-len*/

// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';

// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var tlds_default = 'biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф'.split('|');

/*eslint-enable max-len*/

////////////////////////////////////////////////////////////////////////////////

function resetScanCache(self) {
  self.__index__ = -1;
  self.__text_cache__ = '';
}
function createValidator(re) {
  return function (text, pos) {
    var tail = text.slice(pos);
    if (re.test(tail)) {
      return tail.match(re)[0].length;
    }
    return 0;
  };
}
function createNormalizer() {
  return function (match, self) {
    self.normalize(match);
  };
}

// Schemas compiler. Build regexps.
//
function compile(self) {
  // Load & clone RE patterns.
  var re = self.re = __webpack_require__(34073)(self.__opts__);

  // Define dynamic patterns
  var tlds = self.__tlds__.slice();
  self.onCompile();
  if (!self.__tlds_replaced__) {
    tlds.push(tlds_2ch_src_re);
  }
  tlds.push(re.src_xn);
  re.src_tlds = tlds.join('|');
  function untpl(tpl) {
    return tpl.replace('%TLDS%', re.src_tlds);
  }
  re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
  re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
  re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
  re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');

  //
  // Compile each schema
  //

  var aliases = [];
  self.__compiled__ = {}; // Reset compiled data

  function schemaError(name, val) {
    throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
  }
  Object.keys(self.__schemas__).forEach(function (name) {
    var val = self.__schemas__[name];

    // skip disabled methods
    if (val === null) {
      return;
    }
    var compiled = {
      validate: null,
      link: null
    };
    self.__compiled__[name] = compiled;
    if (isObject(val)) {
      if (isRegExp(val.validate)) {
        compiled.validate = createValidator(val.validate);
      } else if (isFunction(val.validate)) {
        compiled.validate = val.validate;
      } else {
        schemaError(name, val);
      }
      if (isFunction(val.normalize)) {
        compiled.normalize = val.normalize;
      } else if (!val.normalize) {
        compiled.normalize = createNormalizer();
      } else {
        schemaError(name, val);
      }
      return;
    }
    if (isString(val)) {
      aliases.push(name);
      return;
    }
    schemaError(name, val);
  });

  //
  // Compile postponed aliases
  //

  aliases.forEach(function (alias) {
    if (!self.__compiled__[self.__schemas__[alias]]) {
      // Silently fail on missed schemas to avoid errons on disable.
      // schemaError(alias, self.__schemas__[alias]);
      return;
    }
    self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
    self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
  });

  //
  // Fake record for guessed links
  //
  self.__compiled__[''] = {
    validate: null,
    normalize: createNormalizer()
  };

  //
  // Build schema condition
  //
  var slist = Object.keys(self.__compiled__).filter(function (name) {
    // Filter disabled & fake schemas
    return name.length > 0 && self.__compiled__[name];
  }).map(escapeRE).join('|');
  // (?!_) cause 1.5x slowdown
  self.re.schema_test = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + '))(' + slist + ')', 'i');
  self.re.schema_search = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + '))(' + slist + ')', 'ig');
  self.re.schema_at_start = RegExp('^' + self.re.schema_search.source, 'i');
  self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');

  //
  // Cleanup
  //

  resetScanCache(self);
}

/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/
function Match(self, shift) {
  var start = self.__index__,
    end = self.__last_index__,
    text = self.__text_cache__.slice(start, end);

  /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/
  this.schema = self.__schema__.toLowerCase();
  /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/
  this.index = start + shift;
  /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/
  this.lastIndex = end + shift;
  /**
   * Match#raw -> String
   *
   * Matched string.
   **/
  this.raw = text;
  /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/
  this.text = text;
  /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/
  this.url = text;
}
function createMatch(self, shift) {
  var match = new Match(self, shift);
  self.__compiled__[match.schema].normalize(match, self);
  return match;
}

/**
 * class LinkifyIt
 **/

/**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/
function LinkifyIt(schemas, options) {
  if (!(this instanceof LinkifyIt)) {
    return new LinkifyIt(schemas, options);
  }
  if (!options) {
    if (isOptionsObj(schemas)) {
      options = schemas;
      schemas = {};
    }
  }
  this.__opts__ = assign({}, defaultOptions, options);

  // Cache last tested result. Used to skip repeating steps on next `match` call.
  this.__index__ = -1;
  this.__last_index__ = -1; // Next scan position
  this.__schema__ = '';
  this.__text_cache__ = '';
  this.__schemas__ = assign({}, defaultSchemas, schemas);
  this.__compiled__ = {};
  this.__tlds__ = tlds_default;
  this.__tlds_replaced__ = false;
  this.re = {};
  compile(this);
}

/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/
LinkifyIt.prototype.add = function add(schema, definition) {
  this.__schemas__[schema] = definition;
  compile(this);
  return this;
};

/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/
LinkifyIt.prototype.set = function set(options) {
  this.__opts__ = assign(this.__opts__, options);
  return this;
};

/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/
LinkifyIt.prototype.test = function test(text) {
  // Reset scan cache
  this.__text_cache__ = text;
  this.__index__ = -1;
  if (!text.length) {
    return false;
  }
  var m, ml, me, len, shift, next, re, tld_pos, at_pos;

  // try to scan for link with schema - that's the most simple rule
  if (this.re.schema_test.test(text)) {
    re = this.re.schema_search;
    re.lastIndex = 0;
    while ((m = re.exec(text)) !== null) {
      len = this.testSchemaAt(text, m[2], re.lastIndex);
      if (len) {
        this.__schema__ = m[2];
        this.__index__ = m.index + m[1].length;
        this.__last_index__ = m.index + m[0].length + len;
        break;
      }
    }
  }
  if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
    // guess schemaless links
    tld_pos = text.search(this.re.host_fuzzy_test);
    if (tld_pos >= 0) {
      // if tld is located after found link - no need to check fuzzy pattern
      if (this.__index__ < 0 || tld_pos < this.__index__) {
        if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
          shift = ml.index + ml[1].length;
          if (this.__index__ < 0 || shift < this.__index__) {
            this.__schema__ = '';
            this.__index__ = shift;
            this.__last_index__ = ml.index + ml[0].length;
          }
        }
      }
    }
  }
  if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
    // guess schemaless emails
    at_pos = text.indexOf('@');
    if (at_pos >= 0) {
      // We can't skip this check, because this cases are possible:
      // 192.168.1.1@gmail.com, my.in@example.com
      if ((me = text.match(this.re.email_fuzzy)) !== null) {
        shift = me.index + me[1].length;
        next = me.index + me[0].length;
        if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
          this.__schema__ = 'mailto:';
          this.__index__ = shift;
          this.__last_index__ = next;
        }
      }
    }
  }
  return this.__index__ >= 0;
};

/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/
LinkifyIt.prototype.pretest = function pretest(text) {
  return this.re.pretest.test(text);
};

/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/
LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
  // If not supported schema check requested - terminate
  if (!this.__compiled__[schema.toLowerCase()]) {
    return 0;
  }
  return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};

/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/
LinkifyIt.prototype.match = function match(text) {
  var shift = 0,
    result = [];

  // Try to take previous element from cache, if .test() called before
  if (this.__index__ >= 0 && this.__text_cache__ === text) {
    result.push(createMatch(this, shift));
    shift = this.__last_index__;
  }

  // Cut head if cache was used
  var tail = shift ? text.slice(shift) : text;

  // Scan string until end reached
  while (this.test(tail)) {
    result.push(createMatch(this, shift));
    tail = tail.slice(this.__last_index__);
    shift += this.__last_index__;
  }
  if (result.length) {
    return result;
  }
  return null;
};

/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/
LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
  // Reset scan cache
  this.__text_cache__ = text;
  this.__index__ = -1;
  if (!text.length) return null;
  var m = this.re.schema_at_start.exec(text);
  if (!m) return null;
  var len = this.testSchemaAt(text, m[2], m[0].length);
  if (!len) return null;
  this.__schema__ = m[2];
  this.__index__ = m.index + m[1].length;
  this.__last_index__ = m.index + m[0].length + len;
  return createMatch(this, 0);
};

/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/
LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
  list = Array.isArray(list) ? list : [list];
  if (!keepOld) {
    this.__tlds__ = list.slice();
    this.__tlds_replaced__ = true;
    compile(this);
    return this;
  }
  this.__tlds__ = this.__tlds__.concat(list).sort().filter(function (el, idx, arr) {
    return el !== arr[idx - 1];
  }).reverse();
  compile(this);
  return this;
};

/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/
LinkifyIt.prototype.normalize = function normalize(match) {
  // Do minimal possible changes by default. Need to collect feedback prior
  // to move forward https://github.com/markdown-it/linkify-it/issues/1

  if (!match.schema) {
    match.url = 'http://' + match.url;
  }
  if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) {
    match.url = 'mailto:' + match.url;
  }
};

/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/
LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = LinkifyIt;

/***/ }),

/***/ 34073:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(69600);
module.exports = function (opts) {
  var re = {};
  opts = opts || {};

  // Use direct extract instead of `regenerate` to reduse browserified size
  re.src_Any = __webpack_require__(40146).source;
  re.src_Cc = __webpack_require__(2605).source;
  re.src_Z = __webpack_require__(35732).source;
  re.src_P = __webpack_require__(67925).source;

  // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
  re.src_ZPCc = [re.src_Z, re.src_P, re.src_Cc].join('|');

  // \p{\Z\Cc} (white spaces + control)
  re.src_ZCc = [re.src_Z, re.src_Cc].join('|');

  // Experimental. List of chars, completely prohibited in links
  // because can separate it from other part of text
  var text_separators = "[><\uFF5C]";

  // All possible word characters (everything without punctuation, spaces & controls)
  // Defined via punctuation & spaces to save space
  // Should be something like \p{\L\N\S\M} (\w but without `_`)
  re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
  // The same as abothe but without [0-9]
  // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';

  ////////////////////////////////////////////////////////////////////////////////

  re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';

  // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
  re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
  re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
  re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')' + '(?!' + (opts['---'] ? '-(?!--)|' : '-|') + '_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
  re.src_path = '(?:' + '[/?#]' + '(?:' + '(?!' + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-])|' +
  // allow `I'm_king` if no pair found
  '\\.{2,}[a-zA-Z0-9%/&]|' +
  // google has many dots in "google search" links (#66, #81).
  // github has ... in commit range links,
  // Restrict to
  // - english
  // - percent-encoded
  // - parts of file path
  // - params separator
  // until more examples found.
  '\\.(?!' + re.src_ZCc + '|[.]|$)|' + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
  : '\\-+|') + ',(?!' + re.src_ZCc + '|$)|' +
  // allow `,,,` in paths
  ';(?!' + re.src_ZCc + '|$)|' +
  // allow `;` if not followed by space-like char
  '\\!+(?!' + re.src_ZCc + '|[!]|$)|' +
  // allow `!!!` in paths, but not at the end
  '\\?(?!' + re.src_ZCc + '|[?]|$)' + ')+' + '|\\/' + ')?';

  // Allow anything in markdown spec, forbid quote (") at the first position
  // because emails enclosed in quotes are far more common
  re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
  re.src_xn = 'xn--[a-z0-9\\-]{1,59}';

  // More to read about domain names
  // http://serverfault.com/questions/638260/

  re.src_domain_root =
  // Allow letters & digits (http://test1)
  '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
  re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
  re.src_host = '(?:' +
  // Don't need IP check, because digits are already allowed in normal domain names
  //   src_ip4 +
  // '|' +
  '(?:(?:(?:' + re.src_domain + ')\\.)*' + re.src_domain /*_root*/ + ')' + ')';
  re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
  re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
  re.src_host_strict = re.src_host + re.src_host_terminator;
  re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
  re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
  re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
  re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;

  ////////////////////////////////////////////////////////////////////////////////
  // Main rules

  // Rude test fuzzy links by host, for quick deny
  re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
  re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
  re.tpl_link_fuzzy =
  // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + '))' + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
  re.tpl_link_no_ip_fuzzy =
  // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + '))' + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
  return re;
};

/***/ }),

/***/ 60764:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(41539);
__webpack_require__(39714);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(47042);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
  MAX_SAFE_INTEGER = 9007199254740991,
  MAX_INTEGER = 1.7976931348623157e+308,
  NAN = 0 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
  genTag = '[object GeneratorFunction]',
  symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
  nativeMax = Math.max;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
    length = array.length;
  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = _typeof(index);
  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if (guard ? isIterateeCall(array, size, guard) : size === undefined) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array ? array.length : 0;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
    resIndex = 0,
    result = Array(nativeCeil(length / size));
  while (index < length) {
    result[resIndex++] = baseSlice(array, index, index += size);
  }
  return result;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = _typeof(value);
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && _typeof(value) == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return _typeof(value) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
    remainder = result % 1;
  return result === result ? remainder ? result - remainder : result : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = chunk;

/***/ }),

/***/ 92585:
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
__webpack_require__(41539);
__webpack_require__(39714);
__webpack_require__(54747);
__webpack_require__(74916);
__webpack_require__(66992);
__webpack_require__(33948);
__webpack_require__(24603);
__webpack_require__(15306);
__webpack_require__(30489);
__webpack_require__(40561);
__webpack_require__(82526);
__webpack_require__(47941);
__webpack_require__(47042);
__webpack_require__(21249);
__webpack_require__(18264);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(78783);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
  arrayTag = '[object Array]',
  boolTag = '[object Boolean]',
  dateTag = '[object Date]',
  errorTag = '[object Error]',
  funcTag = '[object Function]',
  genTag = '[object GeneratorFunction]',
  mapTag = '[object Map]',
  numberTag = '[object Number]',
  objectTag = '[object Object]',
  promiseTag = '[object Promise]',
  regexpTag = '[object RegExp]',
  setTag = '[object Set]',
  stringTag = '[object String]',
  symbolTag = '[object Symbol]',
  weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]',
  dataViewTag = '[object DataView]',
  float32Tag = '[object Float32Array]',
  float64Tag = '[object Float64Array]',
  int8Tag = '[object Int8Array]',
  int16Tag = '[object Int16Array]',
  int32Tag = '[object Int32Array]',
  uint8Tag = '[object Uint8Array]',
  uint8ClampedTag = '[object Uint8ClampedArray]',
  uint16Tag = '[object Uint16Array]',
  uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof __webpack_require__.g === "undefined" ? "undefined" : _typeof(__webpack_require__.g)) == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = ( false ? 0 : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 0 : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
    length = array ? array.length : 0;
  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
    length = values.length,
    offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
    length = array ? array.length : 0;
  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
    result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
    result = Array(map.size);
  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
    result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
  funcProto = Function.prototype,
  objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
  _Symbol = root.Symbol,
  Uint8Array = root.Uint8Array,
  getPrototype = overArg(Object.getPrototypeOf, Object),
  objectCreate = Object.create,
  propertyIsEnumerable = objectProto.propertyIsEnumerable,
  splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
  nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
  nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
  Map = getNative(root, 'Map'),
  Promise = getNative(root, 'Promise'),
  Set = getNative(root, 'Set'),
  WeakMap = getNative(root, 'WeakMap'),
  nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
  mapCtorString = toSource(Map),
  promiseCtorString = toSource(Promise),
  setCtorString = toSource(Set),
  weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
  symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
    length = entries ? entries.length : 0;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
    length = entries ? entries.length : 0;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
    length = entries ? entries.length : 0;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache();
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
  var length = result.length,
    skipIndexes = !!length;
  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
      isFunc = tag == funcTag || tag == genTag;
    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || isFunc && !object) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);
  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor());
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor());
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
    length = source.length;
  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});
  var index = -1,
    length = props.length;
  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
  getTag = function getTag(value) {
    var result = objectToString.call(value),
      Ctor = result == objectTag ? value.constructor : undefined,
      ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;
        case mapCtorString:
          return mapTag;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
    result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);
    case boolTag:
    case dateTag:
      return new Ctor(+object);
    case dataViewTag:
      return cloneDataView(object, isDeep);
    case float32Tag:
    case float64Tag:
    case int8Tag:
    case int16Tag:
    case int32Tag:
    case uint8Tag:
    case uint8ClampedTag:
    case uint16Tag:
    case uint32Tag:
      return cloneTypedArray(object, isDeep);
    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);
    case numberTag:
    case stringTag:
      return new Ctor(object);
    case regexpTag:
      return cloneRegExp(object);
    case setTag:
      return cloneSet(object, isDeep, cloneFunc);
    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = _typeof(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
    proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = _typeof(value);
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && _typeof(value) == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}
module.exports = cloneDeep;

/***/ }),

/***/ 21791:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(41539);
__webpack_require__(39714);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(47042);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof __webpack_require__.g === "undefined" ? "undefined" : _typeof(__webpack_require__.g)) == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
  nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function now() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
    lastThis,
    maxWait,
    result,
    timerId,
    lastCallTime,
    lastInvokeTime = 0,
    leading = false,
    maxing = false,
    trailing = true;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs,
      thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime,
      result = wait - timeSinceLastCall;
    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }
  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }
  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }
  function debounced() {
    var time = now(),
      isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = _typeof(value);
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && _typeof(value) == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return _typeof(value) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = debounce;

/***/ }),

/***/ 66213:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(24603);
__webpack_require__(74916);
__webpack_require__(39714);
__webpack_require__(41539);
__webpack_require__(15306);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"'`]/g,
  reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '`': '&#96;'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof __webpack_require__.g === "undefined" ? "undefined" : _typeof(__webpack_require__.g)) == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function (key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var _Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
  symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && _typeof(value) == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return _typeof(value) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
 * their corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * Backticks are escaped because in IE < 9, they can break out of
 * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
 * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
 * [#133](https://html5sec.org/#133) of the
 * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape(string) {
  string = toString(string);
  return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
}
module.exports = escape;

/***/ }),

/***/ 37733:
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
__webpack_require__(54747);
__webpack_require__(41539);
__webpack_require__(39714);
__webpack_require__(74916);
__webpack_require__(66992);
__webpack_require__(33948);
__webpack_require__(24603);
__webpack_require__(15306);
__webpack_require__(40561);
__webpack_require__(82526);
__webpack_require__(47941);
__webpack_require__(68309);
__webpack_require__(21249);
__webpack_require__(18264);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(78783);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
  COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
  arrayTag = '[object Array]',
  asyncTag = '[object AsyncFunction]',
  boolTag = '[object Boolean]',
  dateTag = '[object Date]',
  errorTag = '[object Error]',
  funcTag = '[object Function]',
  genTag = '[object GeneratorFunction]',
  mapTag = '[object Map]',
  numberTag = '[object Number]',
  nullTag = '[object Null]',
  objectTag = '[object Object]',
  promiseTag = '[object Promise]',
  proxyTag = '[object Proxy]',
  regexpTag = '[object RegExp]',
  setTag = '[object Set]',
  stringTag = '[object String]',
  symbolTag = '[object Symbol]',
  undefinedTag = '[object Undefined]',
  weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]',
  dataViewTag = '[object DataView]',
  float32Tag = '[object Float32Array]',
  float64Tag = '[object Float64Array]',
  int8Tag = '[object Int8Array]',
  int16Tag = '[object Int16Array]',
  int32Tag = '[object Int32Array]',
  uint8Tag = '[object Uint8Array]',
  uint8ClampedTag = '[object Uint8ClampedArray]',
  uint16Tag = '[object Uint16Array]',
  uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof __webpack_require__.g === "undefined" ? "undefined" : _typeof(__webpack_require__.g)) == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = ( false ? 0 : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 0 : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
    length = values.length,
    offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
    result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
    result = Array(map.size);
  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
    result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
  funcProto = Function.prototype,
  objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
  _Symbol = root.Symbol,
  Uint8Array = root.Uint8Array,
  propertyIsEnumerable = objectProto.propertyIsEnumerable,
  splice = arrayProto.splice,
  symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
  nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
  nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
  Map = getNative(root, 'Map'),
  Promise = getNative(root, 'Promise'),
  Set = getNative(root, 'Set'),
  WeakMap = getNative(root, 'WeakMap'),
  nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
  mapCtorString = toSource(Map),
  promiseCtorString = toSource(Promise),
  setCtorString = toSource(Set),
  weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
  symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
    size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
    length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
    result = data['delete'](key);
  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
    isArg = !isArr && isArguments(value),
    isBuff = !isArr && !isArg && isBuffer(value),
    isType = !isArr && !isArg && !isBuff && isTypedArray(value),
    skipIndexes = isArr || isArg || isBuff || isType,
    result = skipIndexes ? baseTimes(value.length, String) : [],
    length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' || isBuff && (key == 'offset' || key == 'parent') || isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
    othIsArr = isArray(other),
    objTag = objIsArr ? arrayTag : getTag(object),
    othTag = othIsArr ? arrayTag : getTag(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag,
    othIsObj = othTag == objectTag,
    isSameTag = objTag == othTag;
  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
      othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
        othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
    arrLength = array.length,
    othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
    result = true,
    seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;
  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
      othValue = other[index];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;
    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);
    case errorTag:
      return object.name == other.name && object.message == other.message;
    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';
    case mapTag:
      var convert = mapToArray;
    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
    objProps = getAllKeys(object),
    objLength = objProps.length,
    othProps = getAllKeys(other),
    othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
      othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
      othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
    tag = value[symToStringTag];
  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
  getTag = function getTag(value) {
    var result = baseGetTag(value),
      Ctor = result == objectTag ? value.constructor : undefined,
      ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;
        case mapCtorString:
          return mapTag;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = _typeof(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
    proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = _typeof(value);
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && _typeof(value) == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}
module.exports = isEqual;

/***/ }),

/***/ 3260:
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
__webpack_require__(41539);
__webpack_require__(39714);
__webpack_require__(74916);
__webpack_require__(66992);
__webpack_require__(33948);
__webpack_require__(24603);
__webpack_require__(15306);
__webpack_require__(30489);
__webpack_require__(40561);
__webpack_require__(47042);
__webpack_require__(21249);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(78783);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
  HOT_SPAN = 16;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
  arrayTag = '[object Array]',
  asyncTag = '[object AsyncFunction]',
  boolTag = '[object Boolean]',
  dateTag = '[object Date]',
  errorTag = '[object Error]',
  funcTag = '[object Function]',
  genTag = '[object GeneratorFunction]',
  mapTag = '[object Map]',
  numberTag = '[object Number]',
  nullTag = '[object Null]',
  objectTag = '[object Object]',
  proxyTag = '[object Proxy]',
  regexpTag = '[object RegExp]',
  setTag = '[object Set]',
  stringTag = '[object String]',
  undefinedTag = '[object Undefined]',
  weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]',
  dataViewTag = '[object DataView]',
  float32Tag = '[object Float32Array]',
  float64Tag = '[object Float64Array]',
  int8Tag = '[object Int8Array]',
  int16Tag = '[object Int16Array]',
  int32Tag = '[object Int32Array]',
  uint8Tag = '[object Uint8Array]',
  uint8ClampedTag = '[object Uint8ClampedArray]',
  uint16Tag = '[object Uint16Array]',
  uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof __webpack_require__.g === "undefined" ? "undefined" : _typeof(__webpack_require__.g)) == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = ( false ? 0 : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 0 : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;
    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
    result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
  funcProto = Function.prototype,
  objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
  _Symbol = root.Symbol,
  Uint8Array = root.Uint8Array,
  allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
  getPrototype = overArg(Object.getPrototypeOf, Object),
  objectCreate = Object.create,
  propertyIsEnumerable = objectProto.propertyIsEnumerable,
  splice = arrayProto.splice,
  symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
  nativeMax = Math.max,
  nativeNow = Date.now;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
  nativeCreate = getNative(Object, 'create');

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = function () {
  function object() {}
  return function (proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
    size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
    result = data['delete'](key);
  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
    isArg = !isArr && isArguments(value),
    isBuff = !isArr && !isArg && isBuffer(value),
    isType = !isArr && !isArg && !isBuff && isTypedArray(value),
    skipIndexes = isArr || isArg || isBuff || isType,
    result = skipIndexes ? baseTimes(value.length, String) : [],
    length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' || isBuff && (key == 'offset' || key == 'parent') || isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
    result = [];
  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function (srcValue, key) {
    stack || (stack = new Stack());
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    } else {
      var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
    srcValue = safeGet(source, key),
    stacked = stack.get(srcValue);
  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
  var isCommon = newValue === undefined;
  if (isCommon) {
    var isArr = isArray(srcValue),
      isBuff = !isArr && isBuffer(srcValue),
      isTyped = !isArr && !isBuff && isTypedArray(srcValue);
    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      } else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function (func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
    result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
    length = source.length;
  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
    length = props.length;
  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function (object, sources) {
    var index = -1,
      length = sources.length,
      customizer = length > 1 ? sources[length - 1] : undefined,
      guard = length > 2 ? sources[2] : undefined;
    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
      iterable = Object(object),
      props = keysFunc(object),
      length = props.length;
    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
    tag = value[symToStringTag];
  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = _typeof(value);
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = _typeof(index);
  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = _typeof(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
    proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
      index = -1,
      length = nativeMax(args.length - start, 0),
      array = Array(length);
    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }
  if (key == '__proto__') {
    return;
  }
  return object[key];
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
    lastCalled = 0;
  return function () {
    var stamp = nativeNow(),
      remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = _typeof(value);
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && _typeof(value) == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function (object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function () {
    return value;
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}
module.exports = merge;

/***/ }),

/***/ 47983:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(41539);
__webpack_require__(39714);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(47042);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof __webpack_require__.g === "undefined" ? "undefined" : _typeof(__webpack_require__.g)) == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
  nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function now() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
    lastThis,
    maxWait,
    result,
    timerId,
    lastCallTime,
    lastInvokeTime = 0,
    leading = false,
    maxing = false,
    trailing = true;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs,
      thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime,
      result = wait - timeSinceLastCall;
    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }
  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }
  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }
  function debounced() {
    var time = now(),
      isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
    trailing = true;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = _typeof(value);
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && _typeof(value) == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return _typeof(value) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = throttle;

/***/ }),

/***/ 62899:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(41539);
__webpack_require__(39714);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(47042);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
  MAX_INTEGER = 1.7976931348623157e+308,
  NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = _typeof(value);
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && _typeof(value) == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return _typeof(value) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = toFinite;

/***/ }),

/***/ 33141:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}__webpack_require__(24603);__webpack_require__(74916);__webpack_require__(39714);__webpack_require__(69600);__webpack_require__(23123);__webpack_require__(4723);__webpack_require__(2707);__webpack_require__(15306);__webpack_require__(47042);__webpack_require__(54747);__webpack_require__(41539);__webpack_require__(66992);__webpack_require__(33948);__webpack_require__(40561);__webpack_require__(68309);__webpack_require__(21249);__webpack_require__(18264);__webpack_require__(64765);__webpack_require__(92222);__webpack_require__(43290);__webpack_require__(57327);__webpack_require__(86535);__webpack_require__(99244);__webpack_require__(27852);__webpack_require__(69826);__webpack_require__(34553);__webpack_require__(26699);__webpack_require__(32023);__webpack_require__(66528);__webpack_require__(83112);__webpack_require__(83714);__webpack_require__(23157);__webpack_require__(73210);__webpack_require__(48702);__webpack_require__(55674);__webpack_require__(83753);__webpack_require__(82526);__webpack_require__(41817);__webpack_require__(32165);__webpack_require__(78783);/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */;(function(){/** Used as a safe reference for `undefined` in pre-ES5 environments. */var undefined;/** Used as the semantic version number. */var VERSION='4.17.21';/** Used as the size to enable large array optimizations. */var LARGE_ARRAY_SIZE=200;/** Error message constants. */var CORE_ERROR_TEXT='Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',FUNC_ERROR_TEXT='Expected a function',INVALID_TEMPL_VAR_ERROR_TEXT='Invalid `variable` option passed into `_.template`';/** Used to stand-in for `undefined` hash values. */var HASH_UNDEFINED='__lodash_hash_undefined__';/** Used as the maximum memoize cache size. */var MAX_MEMOIZE_SIZE=500;/** Used as the internal argument placeholder. */var PLACEHOLDER='__lodash_placeholder__';/** Used to compose bitmasks for cloning. */var CLONE_DEEP_FLAG=1,CLONE_FLAT_FLAG=2,CLONE_SYMBOLS_FLAG=4;/** Used to compose bitmasks for value comparisons. */var COMPARE_PARTIAL_FLAG=1,COMPARE_UNORDERED_FLAG=2;/** Used to compose bitmasks for function metadata. */var WRAP_BIND_FLAG=1,WRAP_BIND_KEY_FLAG=2,WRAP_CURRY_BOUND_FLAG=4,WRAP_CURRY_FLAG=8,WRAP_CURRY_RIGHT_FLAG=16,WRAP_PARTIAL_FLAG=32,WRAP_PARTIAL_RIGHT_FLAG=64,WRAP_ARY_FLAG=128,WRAP_REARG_FLAG=256,WRAP_FLIP_FLAG=512;/** Used as default options for `_.truncate`. */var DEFAULT_TRUNC_LENGTH=30,DEFAULT_TRUNC_OMISSION='...';/** Used to detect hot functions by number of calls within a span of milliseconds. */var HOT_COUNT=800,HOT_SPAN=16;/** Used to indicate the type of lazy iteratees. */var LAZY_FILTER_FLAG=1,LAZY_MAP_FLAG=2,LAZY_WHILE_FLAG=3;/** Used as references for various `Number` constants. */var INFINITY=1/0,MAX_SAFE_INTEGER=9007199254740991,MAX_INTEGER=1.7976931348623157e+308,NAN=0/0;/** Used as references for the maximum length and index of an array. */var MAX_ARRAY_LENGTH=4294967295,MAX_ARRAY_INDEX=MAX_ARRAY_LENGTH-1,HALF_MAX_ARRAY_LENGTH=MAX_ARRAY_LENGTH>>>1;/** Used to associate wrap methods with their bit flags. */var wrapFlags=[['ary',WRAP_ARY_FLAG],['bind',WRAP_BIND_FLAG],['bindKey',WRAP_BIND_KEY_FLAG],['curry',WRAP_CURRY_FLAG],['curryRight',WRAP_CURRY_RIGHT_FLAG],['flip',WRAP_FLIP_FLAG],['partial',WRAP_PARTIAL_FLAG],['partialRight',WRAP_PARTIAL_RIGHT_FLAG],['rearg',WRAP_REARG_FLAG]];/** `Object#toString` result references. */var argsTag='[object Arguments]',arrayTag='[object Array]',asyncTag='[object AsyncFunction]',boolTag='[object Boolean]',dateTag='[object Date]',domExcTag='[object DOMException]',errorTag='[object Error]',funcTag='[object Function]',genTag='[object GeneratorFunction]',mapTag='[object Map]',numberTag='[object Number]',nullTag='[object Null]',objectTag='[object Object]',promiseTag='[object Promise]',proxyTag='[object Proxy]',regexpTag='[object RegExp]',setTag='[object Set]',stringTag='[object String]',symbolTag='[object Symbol]',undefinedTag='[object Undefined]',weakMapTag='[object WeakMap]',weakSetTag='[object WeakSet]';var arrayBufferTag='[object ArrayBuffer]',dataViewTag='[object DataView]',float32Tag='[object Float32Array]',float64Tag='[object Float64Array]',int8Tag='[object Int8Array]',int16Tag='[object Int16Array]',int32Tag='[object Int32Array]',uint8Tag='[object Uint8Array]',uint8ClampedTag='[object Uint8ClampedArray]',uint16Tag='[object Uint16Array]',uint32Tag='[object Uint32Array]';/** Used to match empty string literals in compiled template source. */var reEmptyStringLeading=/\b__p \+= '';/g,reEmptyStringMiddle=/\b(__p \+=) '' \+/g,reEmptyStringTrailing=/(__e\(.*?\)|\b__t\)) \+\n'';/g;/** Used to match HTML entities and HTML characters. */var reEscapedHtml=/&(?:amp|lt|gt|quot|#39);/g,reUnescapedHtml=/[&<>"']/g,reHasEscapedHtml=RegExp(reEscapedHtml.source),reHasUnescapedHtml=RegExp(reUnescapedHtml.source);/** Used to match template delimiters. */var reEscape=/<%-([\s\S]+?)%>/g,reEvaluate=/<%([\s\S]+?)%>/g,reInterpolate=/<%=([\s\S]+?)%>/g;/** Used to match property names within property paths. */var reIsDeepProp=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,reIsPlainProp=/^\w*$/,rePropName=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;/**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */var reRegExpChar=/[\\^$.*+?()[\]{}|]/g,reHasRegExpChar=RegExp(reRegExpChar.source);/** Used to match leading whitespace. */var reTrimStart=/^\s+/;/** Used to match a single whitespace character. */var reWhitespace=/\s/;/** Used to match wrap detail comments. */var reWrapComment=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,reWrapDetails=/\{\n\/\* \[wrapped with (.+)\] \*/,reSplitDetails=/,? & /;/** Used to match words composed of alphanumeric characters. */var reAsciiWord=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;/**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */var reForbiddenIdentifierChars=/[()=,{}\[\]\/\s]/;/** Used to match backslashes in property paths. */var reEscapeChar=/\\(\\)?/g;/**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */var reEsTemplate=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;/** Used to match `RegExp` flags from their coerced string values. */var reFlags=/\w*$/;/** Used to detect bad signed hexadecimal string values. */var reIsBadHex=/^[-+]0x[0-9a-f]+$/i;/** Used to detect binary string values. */var reIsBinary=/^0b[01]+$/i;/** Used to detect host constructors (Safari). */var reIsHostCtor=/^\[object .+?Constructor\]$/;/** Used to detect octal string values. */var reIsOctal=/^0o[0-7]+$/i;/** Used to detect unsigned integer values. */var reIsUint=/^(?:0|[1-9]\d*)$/;/** Used to match Latin Unicode letters (excluding mathematical operators). */var reLatin=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;/** Used to ensure capturing order of template delimiters. */var reNoMatch=/($^)/;/** Used to match unescaped characters in compiled string literals. */var reUnescapedString=/['\n\r\u2028\u2029\\]/g;/** Used to compose unicode character classes. */var rsAstralRange="\\ud800-\\udfff",rsComboMarksRange="\\u0300-\\u036f",reComboHalfMarksRange="\\ufe20-\\ufe2f",rsComboSymbolsRange="\\u20d0-\\u20ff",rsComboRange=rsComboMarksRange+reComboHalfMarksRange+rsComboSymbolsRange,rsDingbatRange="\\u2700-\\u27bf",rsLowerRange='a-z\\xdf-\\xf6\\xf8-\\xff',rsMathOpRange='\\xac\\xb1\\xd7\\xf7',rsNonCharRange='\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',rsPunctuationRange="\\u2000-\\u206f",rsSpaceRange=" \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",rsUpperRange='A-Z\\xc0-\\xd6\\xd8-\\xde',rsVarRange="\\ufe0e\\ufe0f",rsBreakRange=rsMathOpRange+rsNonCharRange+rsPunctuationRange+rsSpaceRange;/** Used to compose unicode capture groups. */var rsApos="['\u2019]",rsAstral='['+rsAstralRange+']',rsBreak='['+rsBreakRange+']',rsCombo='['+rsComboRange+']',rsDigits='\\d+',rsDingbat='['+rsDingbatRange+']',rsLower='['+rsLowerRange+']',rsMisc='[^'+rsAstralRange+rsBreakRange+rsDigits+rsDingbatRange+rsLowerRange+rsUpperRange+']',rsFitz="\\ud83c[\\udffb-\\udfff]",rsModifier='(?:'+rsCombo+'|'+rsFitz+')',rsNonAstral='[^'+rsAstralRange+']',rsRegional="(?:\\ud83c[\\udde6-\\uddff]){2}",rsSurrPair="[\\ud800-\\udbff][\\udc00-\\udfff]",rsUpper='['+rsUpperRange+']',rsZWJ="\\u200d";/** Used to compose unicode regexes. */var rsMiscLower='(?:'+rsLower+'|'+rsMisc+')',rsMiscUpper='(?:'+rsUpper+'|'+rsMisc+')',rsOptContrLower='(?:'+rsApos+'(?:d|ll|m|re|s|t|ve))?',rsOptContrUpper='(?:'+rsApos+'(?:D|LL|M|RE|S|T|VE))?',reOptMod=rsModifier+'?',rsOptVar='['+rsVarRange+']?',rsOptJoin='(?:'+rsZWJ+'(?:'+[rsNonAstral,rsRegional,rsSurrPair].join('|')+')'+rsOptVar+reOptMod+')*',rsOrdLower='\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',rsOrdUpper='\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',rsSeq=rsOptVar+reOptMod+rsOptJoin,rsEmoji='(?:'+[rsDingbat,rsRegional,rsSurrPair].join('|')+')'+rsSeq,rsSymbol='(?:'+[rsNonAstral+rsCombo+'?',rsCombo,rsRegional,rsSurrPair,rsAstral].join('|')+')';/** Used to match apostrophes. */var reApos=RegExp(rsApos,'g');/**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */var reComboMark=RegExp(rsCombo,'g');/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */var reUnicode=RegExp(rsFitz+'(?='+rsFitz+')|'+rsSymbol+rsSeq,'g');/** Used to match complex or compound words. */var reUnicodeWord=RegExp([rsUpper+'?'+rsLower+'+'+rsOptContrLower+'(?='+[rsBreak,rsUpper,'$'].join('|')+')',rsMiscUpper+'+'+rsOptContrUpper+'(?='+[rsBreak,rsUpper+rsMiscLower,'$'].join('|')+')',rsUpper+'?'+rsMiscLower+'+'+rsOptContrLower,rsUpper+'+'+rsOptContrUpper,rsOrdUpper,rsOrdLower,rsDigits,rsEmoji].join('|'),'g');/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */var reHasUnicode=RegExp('['+rsZWJ+rsAstralRange+rsComboRange+rsVarRange+']');/** Used to detect strings that need a more robust regexp to match words. */var reHasUnicodeWord=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;/** Used to assign default `context` object properties. */var contextProps=['Array','Buffer','DataView','Date','Error','Float32Array','Float64Array','Function','Int8Array','Int16Array','Int32Array','Map','Math','Object','Promise','RegExp','Set','String','Symbol','TypeError','Uint8Array','Uint8ClampedArray','Uint16Array','Uint32Array','WeakMap','_','clearTimeout','isFinite','parseInt','setTimeout'];/** Used to make template sourceURLs easier to identify. */var templateCounter=-1;/** Used to identify `toStringTag` values of typed arrays. */var typedArrayTags={};typedArrayTags[float32Tag]=typedArrayTags[float64Tag]=typedArrayTags[int8Tag]=typedArrayTags[int16Tag]=typedArrayTags[int32Tag]=typedArrayTags[uint8Tag]=typedArrayTags[uint8ClampedTag]=typedArrayTags[uint16Tag]=typedArrayTags[uint32Tag]=true;typedArrayTags[argsTag]=typedArrayTags[arrayTag]=typedArrayTags[arrayBufferTag]=typedArrayTags[boolTag]=typedArrayTags[dataViewTag]=typedArrayTags[dateTag]=typedArrayTags[errorTag]=typedArrayTags[funcTag]=typedArrayTags[mapTag]=typedArrayTags[numberTag]=typedArrayTags[objectTag]=typedArrayTags[regexpTag]=typedArrayTags[setTag]=typedArrayTags[stringTag]=typedArrayTags[weakMapTag]=false;/** Used to identify `toStringTag` values supported by `_.clone`. */var cloneableTags={};cloneableTags[argsTag]=cloneableTags[arrayTag]=cloneableTags[arrayBufferTag]=cloneableTags[dataViewTag]=cloneableTags[boolTag]=cloneableTags[dateTag]=cloneableTags[float32Tag]=cloneableTags[float64Tag]=cloneableTags[int8Tag]=cloneableTags[int16Tag]=cloneableTags[int32Tag]=cloneableTags[mapTag]=cloneableTags[numberTag]=cloneableTags[objectTag]=cloneableTags[regexpTag]=cloneableTags[setTag]=cloneableTags[stringTag]=cloneableTags[symbolTag]=cloneableTags[uint8Tag]=cloneableTags[uint8ClampedTag]=cloneableTags[uint16Tag]=cloneableTags[uint32Tag]=true;cloneableTags[errorTag]=cloneableTags[funcTag]=cloneableTags[weakMapTag]=false;/** Used to map Latin Unicode letters to basic Latin letters. */var deburredLetters={// Latin-1 Supplement block.
'\xc0':'A','\xc1':'A','\xc2':'A','\xc3':'A','\xc4':'A','\xc5':'A','\xe0':'a','\xe1':'a','\xe2':'a','\xe3':'a','\xe4':'a','\xe5':'a','\xc7':'C','\xe7':'c','\xd0':'D','\xf0':'d','\xc8':'E','\xc9':'E','\xca':'E','\xcb':'E','\xe8':'e','\xe9':'e','\xea':'e','\xeb':'e','\xcc':'I','\xcd':'I','\xce':'I','\xcf':'I','\xec':'i','\xed':'i','\xee':'i','\xef':'i','\xd1':'N','\xf1':'n','\xd2':'O','\xd3':'O','\xd4':'O','\xd5':'O','\xd6':'O','\xd8':'O','\xf2':'o','\xf3':'o','\xf4':'o','\xf5':'o','\xf6':'o','\xf8':'o','\xd9':'U','\xda':'U','\xdb':'U','\xdc':'U','\xf9':'u','\xfa':'u','\xfb':'u','\xfc':'u','\xdd':'Y','\xfd':'y','\xff':'y','\xc6':'Ae','\xe6':'ae','\xde':'Th','\xfe':'th','\xdf':'ss',// Latin Extended-A block.
"\u0100":'A',"\u0102":'A',"\u0104":'A',"\u0101":'a',"\u0103":'a',"\u0105":'a',"\u0106":'C',"\u0108":'C',"\u010A":'C',"\u010C":'C',"\u0107":'c',"\u0109":'c',"\u010B":'c',"\u010D":'c',"\u010E":'D',"\u0110":'D',"\u010F":'d',"\u0111":'d',"\u0112":'E',"\u0114":'E',"\u0116":'E',"\u0118":'E',"\u011A":'E',"\u0113":'e',"\u0115":'e',"\u0117":'e',"\u0119":'e',"\u011B":'e',"\u011C":'G',"\u011E":'G',"\u0120":'G',"\u0122":'G',"\u011D":'g',"\u011F":'g',"\u0121":'g',"\u0123":'g',"\u0124":'H',"\u0126":'H',"\u0125":'h',"\u0127":'h',"\u0128":'I',"\u012A":'I',"\u012C":'I',"\u012E":'I',"\u0130":'I',"\u0129":'i',"\u012B":'i',"\u012D":'i',"\u012F":'i',"\u0131":'i',"\u0134":'J',"\u0135":'j',"\u0136":'K',"\u0137":'k',"\u0138":'k',"\u0139":'L',"\u013B":'L',"\u013D":'L',"\u013F":'L',"\u0141":'L',"\u013A":'l',"\u013C":'l',"\u013E":'l',"\u0140":'l',"\u0142":'l',"\u0143":'N',"\u0145":'N',"\u0147":'N',"\u014A":'N',"\u0144":'n',"\u0146":'n',"\u0148":'n',"\u014B":'n',"\u014C":'O',"\u014E":'O',"\u0150":'O',"\u014D":'o',"\u014F":'o',"\u0151":'o',"\u0154":'R',"\u0156":'R',"\u0158":'R',"\u0155":'r',"\u0157":'r',"\u0159":'r',"\u015A":'S',"\u015C":'S',"\u015E":'S',"\u0160":'S',"\u015B":'s',"\u015D":'s',"\u015F":'s',"\u0161":'s',"\u0162":'T',"\u0164":'T',"\u0166":'T',"\u0163":'t',"\u0165":'t',"\u0167":'t',"\u0168":'U',"\u016A":'U',"\u016C":'U',"\u016E":'U',"\u0170":'U',"\u0172":'U',"\u0169":'u',"\u016B":'u',"\u016D":'u',"\u016F":'u',"\u0171":'u',"\u0173":'u',"\u0174":'W',"\u0175":'w',"\u0176":'Y',"\u0177":'y',"\u0178":'Y',"\u0179":'Z',"\u017B":'Z',"\u017D":'Z',"\u017A":'z',"\u017C":'z',"\u017E":'z',"\u0132":'IJ',"\u0133":'ij',"\u0152":'Oe',"\u0153":'oe',"\u0149":"'n","\u017F":'s'};/** Used to map characters to HTML entities. */var htmlEscapes={'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'};/** Used to map HTML entities to characters. */var htmlUnescapes={'&amp;':'&','&lt;':'<','&gt;':'>','&quot;':'"','&#39;':"'"};/** Used to escape characters for inclusion in compiled string literals. */var stringEscapes={'\\':'\\',"'":"'",'\n':'n','\r':'r',"\u2028":'u2028',"\u2029":'u2029'};/** Built-in method references without a dependency on `root`. */var freeParseFloat=parseFloat,freeParseInt=parseInt;/** Detect free variable `global` from Node.js. */var freeGlobal=(typeof __webpack_require__.g==="undefined"?"undefined":_typeof(__webpack_require__.g))=='object'&&__webpack_require__.g&&__webpack_require__.g.Object===Object&&__webpack_require__.g;/** Detect free variable `self`. */var freeSelf=(typeof self==="undefined"?"undefined":_typeof(self))=='object'&&self&&self.Object===Object&&self;/** Used as a reference to the global object. */var root=freeGlobal||freeSelf||Function('return this')();/** Detect free variable `exports`. */var freeExports=( false?0:_typeof(exports))=='object'&&exports&&!exports.nodeType&&exports;/** Detect free variable `module`. */var freeModule=freeExports&&( false?0:_typeof(module))=='object'&&module&&!module.nodeType&&module;/** Detect the popular CommonJS extension `module.exports`. */var moduleExports=freeModule&&freeModule.exports===freeExports;/** Detect free variable `process` from Node.js. */var freeProcess=moduleExports&&freeGlobal.process;/** Used to access faster Node.js helpers. */var nodeUtil=function(){try{// Use `util.types` for Node.js 10+.
var types=freeModule&&freeModule.require&&freeModule.require('util').types;if(types){return types;}// Legacy `process.binding('util')` for Node.js < 10.
return freeProcess&&freeProcess.binding&&freeProcess.binding('util');}catch(e){}}();/* Node.js helper references. */var nodeIsArrayBuffer=nodeUtil&&nodeUtil.isArrayBuffer,nodeIsDate=nodeUtil&&nodeUtil.isDate,nodeIsMap=nodeUtil&&nodeUtil.isMap,nodeIsRegExp=nodeUtil&&nodeUtil.isRegExp,nodeIsSet=nodeUtil&&nodeUtil.isSet,nodeIsTypedArray=nodeUtil&&nodeUtil.isTypedArray;/*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */function apply(func,thisArg,args){switch(args.length){case 0:return func.call(thisArg);case 1:return func.call(thisArg,args[0]);case 2:return func.call(thisArg,args[0],args[1]);case 3:return func.call(thisArg,args[0],args[1],args[2]);}return func.apply(thisArg,args);}/**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */function arrayAggregator(array,setter,iteratee,accumulator){var index=-1,length=array==null?0:array.length;while(++index<length){var value=array[index];setter(accumulator,value,iteratee(value),array);}return accumulator;}/**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */function arrayEach(array,iteratee){var index=-1,length=array==null?0:array.length;while(++index<length){if(iteratee(array[index],index,array)===false){break;}}return array;}/**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */function arrayEachRight(array,iteratee){var length=array==null?0:array.length;while(length--){if(iteratee(array[length],length,array)===false){break;}}return array;}/**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */function arrayEvery(array,predicate){var index=-1,length=array==null?0:array.length;while(++index<length){if(!predicate(array[index],index,array)){return false;}}return true;}/**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */function arrayFilter(array,predicate){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(predicate(value,index,array)){result[resIndex++]=value;}}return result;}/**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */function arrayIncludes(array,value){var length=array==null?0:array.length;return!!length&&baseIndexOf(array,value,0)>-1;}/**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */function arrayIncludesWith(array,value,comparator){var index=-1,length=array==null?0:array.length;while(++index<length){if(comparator(value,array[index])){return true;}}return false;}/**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */function arrayMap(array,iteratee){var index=-1,length=array==null?0:array.length,result=Array(length);while(++index<length){result[index]=iteratee(array[index],index,array);}return result;}/**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */function arrayPush(array,values){var index=-1,length=values.length,offset=array.length;while(++index<length){array[offset+index]=values[index];}return array;}/**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */function arrayReduce(array,iteratee,accumulator,initAccum){var index=-1,length=array==null?0:array.length;if(initAccum&&length){accumulator=array[++index];}while(++index<length){accumulator=iteratee(accumulator,array[index],index,array);}return accumulator;}/**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */function arrayReduceRight(array,iteratee,accumulator,initAccum){var length=array==null?0:array.length;if(initAccum&&length){accumulator=array[--length];}while(length--){accumulator=iteratee(accumulator,array[length],length,array);}return accumulator;}/**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */function arraySome(array,predicate){var index=-1,length=array==null?0:array.length;while(++index<length){if(predicate(array[index],index,array)){return true;}}return false;}/**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */var asciiSize=baseProperty('length');/**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */function asciiToArray(string){return string.split('');}/**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */function asciiWords(string){return string.match(reAsciiWord)||[];}/**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */function baseFindKey(collection,predicate,eachFunc){var result;eachFunc(collection,function(value,key,collection){if(predicate(value,key,collection)){result=key;return false;}});return result;}/**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function baseFindIndex(array,predicate,fromIndex,fromRight){var length=array.length,index=fromIndex+(fromRight?1:-1);while(fromRight?index--:++index<length){if(predicate(array[index],index,array)){return index;}}return-1;}/**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function baseIndexOf(array,value,fromIndex){return value===value?strictIndexOf(array,value,fromIndex):baseFindIndex(array,baseIsNaN,fromIndex);}/**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function baseIndexOfWith(array,value,fromIndex,comparator){var index=fromIndex-1,length=array.length;while(++index<length){if(comparator(array[index],value)){return index;}}return-1;}/**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */function baseIsNaN(value){return value!==value;}/**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */function baseMean(array,iteratee){var length=array==null?0:array.length;return length?baseSum(array,iteratee)/length:NAN;}/**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */function baseProperty(key){return function(object){return object==null?undefined:object[key];};}/**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */function basePropertyOf(object){return function(key){return object==null?undefined:object[key];};}/**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */function baseReduce(collection,iteratee,accumulator,initAccum,eachFunc){eachFunc(collection,function(value,index,collection){accumulator=initAccum?(initAccum=false,value):iteratee(accumulator,value,index,collection);});return accumulator;}/**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */function baseSortBy(array,comparer){var length=array.length;array.sort(comparer);while(length--){array[length]=array[length].value;}return array;}/**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */function baseSum(array,iteratee){var result,index=-1,length=array.length;while(++index<length){var current=iteratee(array[index]);if(current!==undefined){result=result===undefined?current:result+current;}}return result;}/**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */function baseTimes(n,iteratee){var index=-1,result=Array(n);while(++index<n){result[index]=iteratee(index);}return result;}/**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */function baseToPairs(object,props){return arrayMap(props,function(key){return[key,object[key]];});}/**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */function baseTrim(string){return string?string.slice(0,trimmedEndIndex(string)+1).replace(reTrimStart,''):string;}/**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */function baseUnary(func){return function(value){return func(value);};}/**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */function baseValues(object,props){return arrayMap(props,function(key){return object[key];});}/**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */function cacheHas(cache,key){return cache.has(key);}/**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */function charsStartIndex(strSymbols,chrSymbols){var index=-1,length=strSymbols.length;while(++index<length&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */function charsEndIndex(strSymbols,chrSymbols){var index=strSymbols.length;while(index--&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */function countHolders(array,placeholder){var length=array.length,result=0;while(length--){if(array[length]===placeholder){++result;}}return result;}/**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */var deburrLetter=basePropertyOf(deburredLetters);/**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */var escapeHtmlChar=basePropertyOf(htmlEscapes);/**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */function escapeStringChar(chr){return'\\'+stringEscapes[chr];}/**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */function getValue(object,key){return object==null?undefined:object[key];}/**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */function hasUnicode(string){return reHasUnicode.test(string);}/**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */function hasUnicodeWord(string){return reHasUnicodeWord.test(string);}/**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */function iteratorToArray(iterator){var data,result=[];while(!(data=iterator.next()).done){result.push(data.value);}return result;}/**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */function mapToArray(map){var index=-1,result=Array(map.size);map.forEach(function(value,key){result[++index]=[key,value];});return result;}/**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */function overArg(func,transform){return function(arg){return func(transform(arg));};}/**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */function replaceHolders(array,placeholder){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value===placeholder||value===PLACEHOLDER){array[index]=PLACEHOLDER;result[resIndex++]=index;}}return result;}/**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */function setToArray(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=value;});return result;}/**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */function setToPairs(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=[value,value];});return result;}/**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function strictIndexOf(array,value,fromIndex){var index=fromIndex-1,length=array.length;while(++index<length){if(array[index]===value){return index;}}return-1;}/**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function strictLastIndexOf(array,value,fromIndex){var index=fromIndex+1;while(index--){if(array[index]===value){return index;}}return index;}/**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */function stringSize(string){return hasUnicode(string)?unicodeSize(string):asciiSize(string);}/**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */function stringToArray(string){return hasUnicode(string)?unicodeToArray(string):asciiToArray(string);}/**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */function trimmedEndIndex(string){var index=string.length;while(index--&&reWhitespace.test(string.charAt(index))){}return index;}/**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */var unescapeHtmlChar=basePropertyOf(htmlUnescapes);/**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */function unicodeSize(string){var result=reUnicode.lastIndex=0;while(reUnicode.test(string)){++result;}return result;}/**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */function unicodeToArray(string){return string.match(reUnicode)||[];}/**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */function unicodeWords(string){return string.match(reUnicodeWord)||[];}/*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */var runInContext=function runInContext(context){context=context==null?root:_.defaults(root.Object(),context,_.pick(root,contextProps));/** Built-in constructor references. */var Array=context.Array,Date=context.Date,Error=context.Error,Function=context.Function,Math=context.Math,Object=context.Object,RegExp=context.RegExp,String=context.String,TypeError=context.TypeError;/** Used for built-in method references. */var arrayProto=Array.prototype,funcProto=Function.prototype,objectProto=Object.prototype;/** Used to detect overreaching core-js shims. */var coreJsData=context['__core-js_shared__'];/** Used to resolve the decompiled source of functions. */var funcToString=funcProto.toString;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/** Used to generate unique IDs. */var idCounter=0;/** Used to detect methods masquerading as native. */var maskSrcKey=function(){var uid=/[^.]+$/.exec(coreJsData&&coreJsData.keys&&coreJsData.keys.IE_PROTO||'');return uid?'Symbol(src)_1.'+uid:'';}();/**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */var nativeObjectToString=objectProto.toString;/** Used to infer the `Object` constructor. */var objectCtorString=funcToString.call(Object);/** Used to restore the original `_` reference in `_.noConflict`. */var oldDash=root._;/** Used to detect if a method is native. */var reIsNative=RegExp('^'+funcToString.call(hasOwnProperty).replace(reRegExpChar,'\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,'$1.*?')+'$');/** Built-in value references. */var Buffer=moduleExports?context.Buffer:undefined,_Symbol=context.Symbol,Uint8Array=context.Uint8Array,allocUnsafe=Buffer?Buffer.allocUnsafe:undefined,getPrototype=overArg(Object.getPrototypeOf,Object),objectCreate=Object.create,propertyIsEnumerable=objectProto.propertyIsEnumerable,splice=arrayProto.splice,spreadableSymbol=_Symbol?_Symbol.isConcatSpreadable:undefined,symIterator=_Symbol?_Symbol.iterator:undefined,symToStringTag=_Symbol?_Symbol.toStringTag:undefined;var defineProperty=function(){try{var func=getNative(Object,'defineProperty');func({},'',{});return func;}catch(e){}}();/** Mocked built-ins. */var ctxClearTimeout=context.clearTimeout!==root.clearTimeout&&context.clearTimeout,ctxNow=Date&&Date.now!==root.Date.now&&Date.now,ctxSetTimeout=context.setTimeout!==root.setTimeout&&context.setTimeout;/* Built-in method references for those with the same name as other `lodash` methods. */var nativeCeil=Math.ceil,nativeFloor=Math.floor,nativeGetSymbols=Object.getOwnPropertySymbols,nativeIsBuffer=Buffer?Buffer.isBuffer:undefined,nativeIsFinite=context.isFinite,nativeJoin=arrayProto.join,nativeKeys=overArg(Object.keys,Object),nativeMax=Math.max,nativeMin=Math.min,nativeNow=Date.now,nativeParseInt=context.parseInt,nativeRandom=Math.random,nativeReverse=arrayProto.reverse;/* Built-in method references that are verified to be native. */var DataView=getNative(context,'DataView'),Map=getNative(context,'Map'),Promise=getNative(context,'Promise'),Set=getNative(context,'Set'),WeakMap=getNative(context,'WeakMap'),nativeCreate=getNative(Object,'create');/** Used to store function metadata. */var metaMap=WeakMap&&new WeakMap();/** Used to lookup unminified function names. */var realNames={};/** Used to detect maps, sets, and weakmaps. */var dataViewCtorString=toSource(DataView),mapCtorString=toSource(Map),promiseCtorString=toSource(Promise),setCtorString=toSource(Set),weakMapCtorString=toSource(WeakMap);/** Used to convert symbols to primitives and strings. */var symbolProto=_Symbol?_Symbol.prototype:undefined,symbolValueOf=symbolProto?symbolProto.valueOf:undefined,symbolToString=symbolProto?symbolProto.toString:undefined;/*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */function lodash(value){if(isObjectLike(value)&&!isArray(value)&&!(value instanceof LazyWrapper)){if(value instanceof LodashWrapper){return value;}if(hasOwnProperty.call(value,'__wrapped__')){return wrapperClone(value);}}return new LodashWrapper(value);}/**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */var baseCreate=function(){function object(){}return function(proto){if(!isObject(proto)){return{};}if(objectCreate){return objectCreate(proto);}object.prototype=proto;var result=new object();object.prototype=undefined;return result;};}();/**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */function baseLodash(){// No operation performed.
}/**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */function LodashWrapper(value,chainAll){this.__wrapped__=value;this.__actions__=[];this.__chain__=!!chainAll;this.__index__=0;this.__values__=undefined;}/**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */lodash.templateSettings={/**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */'escape':reEscape,/**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */'evaluate':reEvaluate,/**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */'interpolate':reInterpolate,/**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */'variable':'',/**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */'imports':{/**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */'_':lodash}};// Ensure wrappers are instances of `baseLodash`.
lodash.prototype=baseLodash.prototype;lodash.prototype.constructor=lodash;LodashWrapper.prototype=baseCreate(baseLodash.prototype);LodashWrapper.prototype.constructor=LodashWrapper;/*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */function LazyWrapper(value){this.__wrapped__=value;this.__actions__=[];this.__dir__=1;this.__filtered__=false;this.__iteratees__=[];this.__takeCount__=MAX_ARRAY_LENGTH;this.__views__=[];}/**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */function lazyClone(){var result=new LazyWrapper(this.__wrapped__);result.__actions__=copyArray(this.__actions__);result.__dir__=this.__dir__;result.__filtered__=this.__filtered__;result.__iteratees__=copyArray(this.__iteratees__);result.__takeCount__=this.__takeCount__;result.__views__=copyArray(this.__views__);return result;}/**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */function lazyReverse(){if(this.__filtered__){var result=new LazyWrapper(this);result.__dir__=-1;result.__filtered__=true;}else{result=this.clone();result.__dir__*=-1;}return result;}/**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */function lazyValue(){var array=this.__wrapped__.value(),dir=this.__dir__,isArr=isArray(array),isRight=dir<0,arrLength=isArr?array.length:0,view=getView(0,arrLength,this.__views__),start=view.start,end=view.end,length=end-start,index=isRight?end:start-1,iteratees=this.__iteratees__,iterLength=iteratees.length,resIndex=0,takeCount=nativeMin(length,this.__takeCount__);if(!isArr||!isRight&&arrLength==length&&takeCount==length){return baseWrapperValue(array,this.__actions__);}var result=[];outer:while(length--&&resIndex<takeCount){index+=dir;var iterIndex=-1,value=array[index];while(++iterIndex<iterLength){var data=iteratees[iterIndex],iteratee=data.iteratee,type=data.type,computed=iteratee(value);if(type==LAZY_MAP_FLAG){value=computed;}else if(!computed){if(type==LAZY_FILTER_FLAG){continue outer;}else{break outer;}}}result[resIndex++]=value;}return result;}// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype=baseCreate(baseLodash.prototype);LazyWrapper.prototype.constructor=LazyWrapper;/*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function Hash(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */function hashClear(){this.__data__=nativeCreate?nativeCreate(null):{};this.size=0;}/**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function hashDelete(key){var result=this.has(key)&&delete this.__data__[key];this.size-=result?1:0;return result;}/**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function hashGet(key){var data=this.__data__;if(nativeCreate){var result=data[key];return result===HASH_UNDEFINED?undefined:result;}return hasOwnProperty.call(data,key)?data[key]:undefined;}/**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function hashHas(key){var data=this.__data__;return nativeCreate?data[key]!==undefined:hasOwnProperty.call(data,key);}/**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */function hashSet(key,value){var data=this.__data__;this.size+=this.has(key)?0:1;data[key]=nativeCreate&&value===undefined?HASH_UNDEFINED:value;return this;}// Add methods to `Hash`.
Hash.prototype.clear=hashClear;Hash.prototype['delete']=hashDelete;Hash.prototype.get=hashGet;Hash.prototype.has=hashHas;Hash.prototype.set=hashSet;/*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function ListCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */function listCacheClear(){this.__data__=[];this.size=0;}/**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function listCacheDelete(key){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){return false;}var lastIndex=data.length-1;if(index==lastIndex){data.pop();}else{splice.call(data,index,1);}--this.size;return true;}/**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function listCacheGet(key){var data=this.__data__,index=assocIndexOf(data,key);return index<0?undefined:data[index][1];}/**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function listCacheHas(key){return assocIndexOf(this.__data__,key)>-1;}/**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */function listCacheSet(key,value){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){++this.size;data.push([key,value]);}else{data[index][1]=value;}return this;}// Add methods to `ListCache`.
ListCache.prototype.clear=listCacheClear;ListCache.prototype['delete']=listCacheDelete;ListCache.prototype.get=listCacheGet;ListCache.prototype.has=listCacheHas;ListCache.prototype.set=listCacheSet;/*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function MapCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */function mapCacheClear(){this.size=0;this.__data__={'hash':new Hash(),'map':new(Map||ListCache)(),'string':new Hash()};}/**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function mapCacheDelete(key){var result=getMapData(this,key)['delete'](key);this.size-=result?1:0;return result;}/**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function mapCacheGet(key){return getMapData(this,key).get(key);}/**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function mapCacheHas(key){return getMapData(this,key).has(key);}/**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */function mapCacheSet(key,value){var data=getMapData(this,key),size=data.size;data.set(key,value);this.size+=data.size==size?0:1;return this;}// Add methods to `MapCache`.
MapCache.prototype.clear=mapCacheClear;MapCache.prototype['delete']=mapCacheDelete;MapCache.prototype.get=mapCacheGet;MapCache.prototype.has=mapCacheHas;MapCache.prototype.set=mapCacheSet;/*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */function SetCache(values){var index=-1,length=values==null?0:values.length;this.__data__=new MapCache();while(++index<length){this.add(values[index]);}}/**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */function setCacheAdd(value){this.__data__.set(value,HASH_UNDEFINED);return this;}/**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */function setCacheHas(value){return this.__data__.has(value);}// Add methods to `SetCache`.
SetCache.prototype.add=SetCache.prototype.push=setCacheAdd;SetCache.prototype.has=setCacheHas;/*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function Stack(entries){var data=this.__data__=new ListCache(entries);this.size=data.size;}/**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */function stackClear(){this.__data__=new ListCache();this.size=0;}/**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function stackDelete(key){var data=this.__data__,result=data['delete'](key);this.size=data.size;return result;}/**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function stackGet(key){return this.__data__.get(key);}/**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function stackHas(key){return this.__data__.has(key);}/**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */function stackSet(key,value){var data=this.__data__;if(data instanceof ListCache){var pairs=data.__data__;if(!Map||pairs.length<LARGE_ARRAY_SIZE-1){pairs.push([key,value]);this.size=++data.size;return this;}data=this.__data__=new MapCache(pairs);}data.set(key,value);this.size=data.size;return this;}// Add methods to `Stack`.
Stack.prototype.clear=stackClear;Stack.prototype['delete']=stackDelete;Stack.prototype.get=stackGet;Stack.prototype.has=stackHas;Stack.prototype.set=stackSet;/*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */function arrayLikeKeys(value,inherited){var isArr=isArray(value),isArg=!isArr&&isArguments(value),isBuff=!isArr&&!isArg&&isBuffer(value),isType=!isArr&&!isArg&&!isBuff&&isTypedArray(value),skipIndexes=isArr||isArg||isBuff||isType,result=skipIndexes?baseTimes(value.length,String):[],length=result.length;for(var key in value){if((inherited||hasOwnProperty.call(value,key))&&!(skipIndexes&&(// Safari 9 has enumerable `arguments.length` in strict mode.
key=='length'||isBuff&&(key=='offset'||key=='parent')||isType&&(key=='buffer'||key=='byteLength'||key=='byteOffset')||// Skip index properties.
isIndex(key,length)))){result.push(key);}}return result;}/**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */function arraySample(array){var length=array.length;return length?array[baseRandom(0,length-1)]:undefined;}/**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */function arraySampleSize(array,n){return shuffleSelf(copyArray(array),baseClamp(n,0,array.length));}/**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */function arrayShuffle(array){return shuffleSelf(copyArray(array));}/**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */function assignMergeValue(object,key,value){if(value!==undefined&&!eq(object[key],value)||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}/**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */function assignValue(object,key,value){var objValue=object[key];if(!(hasOwnProperty.call(object,key)&&eq(objValue,value))||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}/**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */function assocIndexOf(array,key){var length=array.length;while(length--){if(eq(array[length][0],key)){return length;}}return-1;}/**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */function baseAggregator(collection,setter,iteratee,accumulator){baseEach(collection,function(value,key,collection){setter(accumulator,value,iteratee(value),collection);});return accumulator;}/**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */function baseAssign(object,source){return object&&copyObject(source,keys(source),object);}/**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */function baseAssignIn(object,source){return object&&copyObject(source,keysIn(source),object);}/**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */function baseAssignValue(object,key,value){if(key=='__proto__'&&defineProperty){defineProperty(object,key,{'configurable':true,'enumerable':true,'value':value,'writable':true});}else{object[key]=value;}}/**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */function baseAt(object,paths){var index=-1,length=paths.length,result=Array(length),skip=object==null;while(++index<length){result[index]=skip?undefined:get(object,paths[index]);}return result;}/**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */function baseClamp(number,lower,upper){if(number===number){if(upper!==undefined){number=number<=upper?number:upper;}if(lower!==undefined){number=number>=lower?number:lower;}}return number;}/**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */function baseClone(value,bitmask,customizer,key,object,stack){var result,isDeep=bitmask&CLONE_DEEP_FLAG,isFlat=bitmask&CLONE_FLAT_FLAG,isFull=bitmask&CLONE_SYMBOLS_FLAG;if(customizer){result=object?customizer(value,key,object,stack):customizer(value);}if(result!==undefined){return result;}if(!isObject(value)){return value;}var isArr=isArray(value);if(isArr){result=initCloneArray(value);if(!isDeep){return copyArray(value,result);}}else{var tag=getTag(value),isFunc=tag==funcTag||tag==genTag;if(isBuffer(value)){return cloneBuffer(value,isDeep);}if(tag==objectTag||tag==argsTag||isFunc&&!object){result=isFlat||isFunc?{}:initCloneObject(value);if(!isDeep){return isFlat?copySymbolsIn(value,baseAssignIn(result,value)):copySymbols(value,baseAssign(result,value));}}else{if(!cloneableTags[tag]){return object?value:{};}result=initCloneByTag(value,tag,isDeep);}}// Check for circular references and return its corresponding clone.
stack||(stack=new Stack());var stacked=stack.get(value);if(stacked){return stacked;}stack.set(value,result);if(isSet(value)){value.forEach(function(subValue){result.add(baseClone(subValue,bitmask,customizer,subValue,value,stack));});}else if(isMap(value)){value.forEach(function(subValue,key){result.set(key,baseClone(subValue,bitmask,customizer,key,value,stack));});}var keysFunc=isFull?isFlat?getAllKeysIn:getAllKeys:isFlat?keysIn:keys;var props=isArr?undefined:keysFunc(value);arrayEach(props||value,function(subValue,key){if(props){key=subValue;subValue=value[key];}// Recursively populate clone (susceptible to call stack limits).
assignValue(result,key,baseClone(subValue,bitmask,customizer,key,value,stack));});return result;}/**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */function baseConforms(source){var props=keys(source);return function(object){return baseConformsTo(object,source,props);};}/**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */function baseConformsTo(object,source,props){var length=props.length;if(object==null){return!length;}object=Object(object);while(length--){var key=props[length],predicate=source[key],value=object[key];if(value===undefined&&!(key in object)||!predicate(value)){return false;}}return true;}/**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */function baseDelay(func,wait,args){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return setTimeout(function(){func.apply(undefined,args);},wait);}/**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */function baseDifference(array,values,iteratee,comparator){var index=-1,includes=arrayIncludes,isCommon=true,length=array.length,result=[],valuesLength=values.length;if(!length){return result;}if(iteratee){values=arrayMap(values,baseUnary(iteratee));}if(comparator){includes=arrayIncludesWith;isCommon=false;}else if(values.length>=LARGE_ARRAY_SIZE){includes=cacheHas;isCommon=false;values=new SetCache(values);}outer:while(++index<length){var value=array[index],computed=iteratee==null?value:iteratee(value);value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var valuesIndex=valuesLength;while(valuesIndex--){if(values[valuesIndex]===computed){continue outer;}}result.push(value);}else if(!includes(values,computed,comparator)){result.push(value);}}return result;}/**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */var baseEach=createBaseEach(baseForOwn);/**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */var baseEachRight=createBaseEach(baseForOwnRight,true);/**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */function baseEvery(collection,predicate){var result=true;baseEach(collection,function(value,index,collection){result=!!predicate(value,index,collection);return result;});return result;}/**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */function baseExtremum(array,iteratee,comparator){var index=-1,length=array.length;while(++index<length){var value=array[index],current=iteratee(value);if(current!=null&&(computed===undefined?current===current&&!isSymbol(current):comparator(current,computed))){var computed=current,result=value;}}return result;}/**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */function baseFill(array,value,start,end){var length=array.length;start=toInteger(start);if(start<0){start=-start>length?0:length+start;}end=end===undefined||end>length?length:toInteger(end);if(end<0){end+=length;}end=start>end?0:toLength(end);while(start<end){array[start++]=value;}return array;}/**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */function baseFilter(collection,predicate){var result=[];baseEach(collection,function(value,index,collection){if(predicate(value,index,collection)){result.push(value);}});return result;}/**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */function baseFlatten(array,depth,predicate,isStrict,result){var index=-1,length=array.length;predicate||(predicate=isFlattenable);result||(result=[]);while(++index<length){var value=array[index];if(depth>0&&predicate(value)){if(depth>1){// Recursively flatten arrays (susceptible to call stack limits).
baseFlatten(value,depth-1,predicate,isStrict,result);}else{arrayPush(result,value);}}else if(!isStrict){result[result.length]=value;}}return result;}/**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */var baseFor=createBaseFor();/**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */var baseForRight=createBaseFor(true);/**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */function baseForOwn(object,iteratee){return object&&baseFor(object,iteratee,keys);}/**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */function baseForOwnRight(object,iteratee){return object&&baseForRight(object,iteratee,keys);}/**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */function baseFunctions(object,props){return arrayFilter(props,function(key){return isFunction(object[key]);});}/**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */function baseGet(object,path){path=castPath(path,object);var index=0,length=path.length;while(object!=null&&index<length){object=object[toKey(path[index++])];}return index&&index==length?object:undefined;}/**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */function baseGetAllKeys(object,keysFunc,symbolsFunc){var result=keysFunc(object);return isArray(object)?result:arrayPush(result,symbolsFunc(object));}/**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */function baseGetTag(value){if(value==null){return value===undefined?undefinedTag:nullTag;}return symToStringTag&&symToStringTag in Object(value)?getRawTag(value):objectToString(value);}/**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */function baseGt(value,other){return value>other;}/**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */function baseHas(object,key){return object!=null&&hasOwnProperty.call(object,key);}/**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */function baseHasIn(object,key){return object!=null&&key in Object(object);}/**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */function baseInRange(number,start,end){return number>=nativeMin(start,end)&&number<nativeMax(start,end);}/**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */function baseIntersection(arrays,iteratee,comparator){var includes=comparator?arrayIncludesWith:arrayIncludes,length=arrays[0].length,othLength=arrays.length,othIndex=othLength,caches=Array(othLength),maxLength=Infinity,result=[];while(othIndex--){var array=arrays[othIndex];if(othIndex&&iteratee){array=arrayMap(array,baseUnary(iteratee));}maxLength=nativeMin(array.length,maxLength);caches[othIndex]=!comparator&&(iteratee||length>=120&&array.length>=120)?new SetCache(othIndex&&array):undefined;}array=arrays[0];var index=-1,seen=caches[0];outer:while(++index<length&&result.length<maxLength){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(!(seen?cacheHas(seen,computed):includes(result,computed,comparator))){othIndex=othLength;while(--othIndex){var cache=caches[othIndex];if(!(cache?cacheHas(cache,computed):includes(arrays[othIndex],computed,comparator))){continue outer;}}if(seen){seen.push(computed);}result.push(value);}}return result;}/**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */function baseInverter(object,setter,iteratee,accumulator){baseForOwn(object,function(value,key,object){setter(accumulator,iteratee(value),key,object);});return accumulator;}/**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */function baseInvoke(object,path,args){path=castPath(path,object);object=parent(object,path);var func=object==null?object:object[toKey(last(path))];return func==null?undefined:apply(func,object,args);}/**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */function baseIsArguments(value){return isObjectLike(value)&&baseGetTag(value)==argsTag;}/**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */function baseIsArrayBuffer(value){return isObjectLike(value)&&baseGetTag(value)==arrayBufferTag;}/**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */function baseIsDate(value){return isObjectLike(value)&&baseGetTag(value)==dateTag;}/**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */function baseIsEqual(value,other,bitmask,customizer,stack){if(value===other){return true;}if(value==null||other==null||!isObjectLike(value)&&!isObjectLike(other)){return value!==value&&other!==other;}return baseIsEqualDeep(value,other,bitmask,customizer,baseIsEqual,stack);}/**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */function baseIsEqualDeep(object,other,bitmask,customizer,equalFunc,stack){var objIsArr=isArray(object),othIsArr=isArray(other),objTag=objIsArr?arrayTag:getTag(object),othTag=othIsArr?arrayTag:getTag(other);objTag=objTag==argsTag?objectTag:objTag;othTag=othTag==argsTag?objectTag:othTag;var objIsObj=objTag==objectTag,othIsObj=othTag==objectTag,isSameTag=objTag==othTag;if(isSameTag&&isBuffer(object)){if(!isBuffer(other)){return false;}objIsArr=true;objIsObj=false;}if(isSameTag&&!objIsObj){stack||(stack=new Stack());return objIsArr||isTypedArray(object)?equalArrays(object,other,bitmask,customizer,equalFunc,stack):equalByTag(object,other,objTag,bitmask,customizer,equalFunc,stack);}if(!(bitmask&COMPARE_PARTIAL_FLAG)){var objIsWrapped=objIsObj&&hasOwnProperty.call(object,'__wrapped__'),othIsWrapped=othIsObj&&hasOwnProperty.call(other,'__wrapped__');if(objIsWrapped||othIsWrapped){var objUnwrapped=objIsWrapped?object.value():object,othUnwrapped=othIsWrapped?other.value():other;stack||(stack=new Stack());return equalFunc(objUnwrapped,othUnwrapped,bitmask,customizer,stack);}}if(!isSameTag){return false;}stack||(stack=new Stack());return equalObjects(object,other,bitmask,customizer,equalFunc,stack);}/**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */function baseIsMap(value){return isObjectLike(value)&&getTag(value)==mapTag;}/**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */function baseIsMatch(object,source,matchData,customizer){var index=matchData.length,length=index,noCustomizer=!customizer;if(object==null){return!length;}object=Object(object);while(index--){var data=matchData[index];if(noCustomizer&&data[2]?data[1]!==object[data[0]]:!(data[0]in object)){return false;}}while(++index<length){data=matchData[index];var key=data[0],objValue=object[key],srcValue=data[1];if(noCustomizer&&data[2]){if(objValue===undefined&&!(key in object)){return false;}}else{var stack=new Stack();if(customizer){var result=customizer(objValue,srcValue,key,object,source,stack);}if(!(result===undefined?baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG,customizer,stack):result)){return false;}}}return true;}/**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */function baseIsNative(value){if(!isObject(value)||isMasked(value)){return false;}var pattern=isFunction(value)?reIsNative:reIsHostCtor;return pattern.test(toSource(value));}/**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */function baseIsRegExp(value){return isObjectLike(value)&&baseGetTag(value)==regexpTag;}/**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */function baseIsSet(value){return isObjectLike(value)&&getTag(value)==setTag;}/**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */function baseIsTypedArray(value){return isObjectLike(value)&&isLength(value.length)&&!!typedArrayTags[baseGetTag(value)];}/**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */function baseIteratee(value){// Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
// See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
if(typeof value=='function'){return value;}if(value==null){return identity;}if(_typeof(value)=='object'){return isArray(value)?baseMatchesProperty(value[0],value[1]):baseMatches(value);}return property(value);}/**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */function baseKeys(object){if(!isPrototype(object)){return nativeKeys(object);}var result=[];for(var key in Object(object)){if(hasOwnProperty.call(object,key)&&key!='constructor'){result.push(key);}}return result;}/**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */function baseKeysIn(object){if(!isObject(object)){return nativeKeysIn(object);}var isProto=isPrototype(object),result=[];for(var key in object){if(!(key=='constructor'&&(isProto||!hasOwnProperty.call(object,key)))){result.push(key);}}return result;}/**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */function baseLt(value,other){return value<other;}/**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */function baseMap(collection,iteratee){var index=-1,result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value,key,collection){result[++index]=iteratee(value,key,collection);});return result;}/**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */function baseMatches(source){var matchData=getMatchData(source);if(matchData.length==1&&matchData[0][2]){return matchesStrictComparable(matchData[0][0],matchData[0][1]);}return function(object){return object===source||baseIsMatch(object,source,matchData);};}/**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */function baseMatchesProperty(path,srcValue){if(isKey(path)&&isStrictComparable(srcValue)){return matchesStrictComparable(toKey(path),srcValue);}return function(object){var objValue=get(object,path);return objValue===undefined&&objValue===srcValue?hasIn(object,path):baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG);};}/**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */function baseMerge(object,source,srcIndex,customizer,stack){if(object===source){return;}baseFor(source,function(srcValue,key){stack||(stack=new Stack());if(isObject(srcValue)){baseMergeDeep(object,source,key,srcIndex,baseMerge,customizer,stack);}else{var newValue=customizer?customizer(safeGet(object,key),srcValue,key+'',object,source,stack):undefined;if(newValue===undefined){newValue=srcValue;}assignMergeValue(object,key,newValue);}},keysIn);}/**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */function baseMergeDeep(object,source,key,srcIndex,mergeFunc,customizer,stack){var objValue=safeGet(object,key),srcValue=safeGet(source,key),stacked=stack.get(srcValue);if(stacked){assignMergeValue(object,key,stacked);return;}var newValue=customizer?customizer(objValue,srcValue,key+'',object,source,stack):undefined;var isCommon=newValue===undefined;if(isCommon){var isArr=isArray(srcValue),isBuff=!isArr&&isBuffer(srcValue),isTyped=!isArr&&!isBuff&&isTypedArray(srcValue);newValue=srcValue;if(isArr||isBuff||isTyped){if(isArray(objValue)){newValue=objValue;}else if(isArrayLikeObject(objValue)){newValue=copyArray(objValue);}else if(isBuff){isCommon=false;newValue=cloneBuffer(srcValue,true);}else if(isTyped){isCommon=false;newValue=cloneTypedArray(srcValue,true);}else{newValue=[];}}else if(isPlainObject(srcValue)||isArguments(srcValue)){newValue=objValue;if(isArguments(objValue)){newValue=toPlainObject(objValue);}else if(!isObject(objValue)||isFunction(objValue)){newValue=initCloneObject(srcValue);}}else{isCommon=false;}}if(isCommon){// Recursively merge objects and arrays (susceptible to call stack limits).
stack.set(srcValue,newValue);mergeFunc(newValue,srcValue,srcIndex,customizer,stack);stack['delete'](srcValue);}assignMergeValue(object,key,newValue);}/**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */function baseNth(array,n){var length=array.length;if(!length){return;}n+=n<0?length:0;return isIndex(n,length)?array[n]:undefined;}/**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */function baseOrderBy(collection,iteratees,orders){if(iteratees.length){iteratees=arrayMap(iteratees,function(iteratee){if(isArray(iteratee)){return function(value){return baseGet(value,iteratee.length===1?iteratee[0]:iteratee);};}return iteratee;});}else{iteratees=[identity];}var index=-1;iteratees=arrayMap(iteratees,baseUnary(getIteratee()));var result=baseMap(collection,function(value,key,collection){var criteria=arrayMap(iteratees,function(iteratee){return iteratee(value);});return{'criteria':criteria,'index':++index,'value':value};});return baseSortBy(result,function(object,other){return compareMultiple(object,other,orders);});}/**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */function basePick(object,paths){return basePickBy(object,paths,function(value,path){return hasIn(object,path);});}/**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */function basePickBy(object,paths,predicate){var index=-1,length=paths.length,result={};while(++index<length){var path=paths[index],value=baseGet(object,path);if(predicate(value,path)){baseSet(result,castPath(path,object),value);}}return result;}/**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */function basePropertyDeep(path){return function(object){return baseGet(object,path);};}/**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */function basePullAll(array,values,iteratee,comparator){var indexOf=comparator?baseIndexOfWith:baseIndexOf,index=-1,length=values.length,seen=array;if(array===values){values=copyArray(values);}if(iteratee){seen=arrayMap(array,baseUnary(iteratee));}while(++index<length){var fromIndex=0,value=values[index],computed=iteratee?iteratee(value):value;while((fromIndex=indexOf(seen,computed,fromIndex,comparator))>-1){if(seen!==array){splice.call(seen,fromIndex,1);}splice.call(array,fromIndex,1);}}return array;}/**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */function basePullAt(array,indexes){var length=array?indexes.length:0,lastIndex=length-1;while(length--){var index=indexes[length];if(length==lastIndex||index!==previous){var previous=index;if(isIndex(index)){splice.call(array,index,1);}else{baseUnset(array,index);}}}return array;}/**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */function baseRandom(lower,upper){return lower+nativeFloor(nativeRandom()*(upper-lower+1));}/**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */function baseRange(start,end,step,fromRight){var index=-1,length=nativeMax(nativeCeil((end-start)/(step||1)),0),result=Array(length);while(length--){result[fromRight?length:++index]=start;start+=step;}return result;}/**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */function baseRepeat(string,n){var result='';if(!string||n<1||n>MAX_SAFE_INTEGER){return result;}// Leverage the exponentiation by squaring algorithm for a faster repeat.
// See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
do{if(n%2){result+=string;}n=nativeFloor(n/2);if(n){string+=string;}}while(n);return result;}/**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */function baseRest(func,start){return setToString(overRest(func,start,identity),func+'');}/**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */function baseSample(collection){return arraySample(values(collection));}/**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */function baseSampleSize(collection,n){var array=values(collection);return shuffleSelf(array,baseClamp(n,0,array.length));}/**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */function baseSet(object,path,value,customizer){if(!isObject(object)){return object;}path=castPath(path,object);var index=-1,length=path.length,lastIndex=length-1,nested=object;while(nested!=null&&++index<length){var key=toKey(path[index]),newValue=value;if(key==='__proto__'||key==='constructor'||key==='prototype'){return object;}if(index!=lastIndex){var objValue=nested[key];newValue=customizer?customizer(objValue,key,nested):undefined;if(newValue===undefined){newValue=isObject(objValue)?objValue:isIndex(path[index+1])?[]:{};}}assignValue(nested,key,newValue);nested=nested[key];}return object;}/**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */var baseSetData=!metaMap?identity:function(func,data){metaMap.set(func,data);return func;};/**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */var baseSetToString=!defineProperty?identity:function(func,string){return defineProperty(func,'toString',{'configurable':true,'enumerable':false,'value':constant(string),'writable':true});};/**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */function baseShuffle(collection){return shuffleSelf(values(collection));}/**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */function baseSlice(array,start,end){var index=-1,length=array.length;if(start<0){start=-start>length?0:length+start;}end=end>length?length:end;if(end<0){end+=length;}length=start>end?0:end-start>>>0;start>>>=0;var result=Array(length);while(++index<length){result[index]=array[index+start];}return result;}/**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */function baseSome(collection,predicate){var result;baseEach(collection,function(value,index,collection){result=predicate(value,index,collection);return!result;});return!!result;}/**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */function baseSortedIndex(array,value,retHighest){var low=0,high=array==null?low:array.length;if(typeof value=='number'&&value===value&&high<=HALF_MAX_ARRAY_LENGTH){while(low<high){var mid=low+high>>>1,computed=array[mid];if(computed!==null&&!isSymbol(computed)&&(retHighest?computed<=value:computed<value)){low=mid+1;}else{high=mid;}}return high;}return baseSortedIndexBy(array,value,identity,retHighest);}/**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */function baseSortedIndexBy(array,value,iteratee,retHighest){var low=0,high=array==null?0:array.length;if(high===0){return 0;}value=iteratee(value);var valIsNaN=value!==value,valIsNull=value===null,valIsSymbol=isSymbol(value),valIsUndefined=value===undefined;while(low<high){var mid=nativeFloor((low+high)/2),computed=iteratee(array[mid]),othIsDefined=computed!==undefined,othIsNull=computed===null,othIsReflexive=computed===computed,othIsSymbol=isSymbol(computed);if(valIsNaN){var setLow=retHighest||othIsReflexive;}else if(valIsUndefined){setLow=othIsReflexive&&(retHighest||othIsDefined);}else if(valIsNull){setLow=othIsReflexive&&othIsDefined&&(retHighest||!othIsNull);}else if(valIsSymbol){setLow=othIsReflexive&&othIsDefined&&!othIsNull&&(retHighest||!othIsSymbol);}else if(othIsNull||othIsSymbol){setLow=false;}else{setLow=retHighest?computed<=value:computed<value;}if(setLow){low=mid+1;}else{high=mid;}}return nativeMin(high,MAX_ARRAY_INDEX);}/**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */function baseSortedUniq(array,iteratee){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;if(!index||!eq(computed,seen)){var seen=computed;result[resIndex++]=value===0?0:value;}}return result;}/**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */function baseToNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}return+value;}/**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */function baseToString(value){// Exit early for strings to avoid a performance hit in some environments.
if(typeof value=='string'){return value;}if(isArray(value)){// Recursively convert values (susceptible to call stack limits).
return arrayMap(value,baseToString)+'';}if(isSymbol(value)){return symbolToString?symbolToString.call(value):'';}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */function baseUniq(array,iteratee,comparator){var index=-1,includes=arrayIncludes,length=array.length,isCommon=true,result=[],seen=result;if(comparator){isCommon=false;includes=arrayIncludesWith;}else if(length>=LARGE_ARRAY_SIZE){var set=iteratee?null:createSet(array);if(set){return setToArray(set);}isCommon=false;includes=cacheHas;seen=new SetCache();}else{seen=iteratee?[]:result;}outer:while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var seenIndex=seen.length;while(seenIndex--){if(seen[seenIndex]===computed){continue outer;}}if(iteratee){seen.push(computed);}result.push(value);}else if(!includes(seen,computed,comparator)){if(seen!==result){seen.push(computed);}result.push(value);}}return result;}/**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */function baseUnset(object,path){path=castPath(path,object);object=parent(object,path);return object==null||delete object[toKey(last(path))];}/**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */function baseUpdate(object,path,updater,customizer){return baseSet(object,path,updater(baseGet(object,path)),customizer);}/**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */function baseWhile(array,predicate,isDrop,fromRight){var length=array.length,index=fromRight?length:-1;while((fromRight?index--:++index<length)&&predicate(array[index],index,array)){}return isDrop?baseSlice(array,fromRight?0:index,fromRight?index+1:length):baseSlice(array,fromRight?index+1:0,fromRight?length:index);}/**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */function baseWrapperValue(value,actions){var result=value;if(result instanceof LazyWrapper){result=result.value();}return arrayReduce(actions,function(result,action){return action.func.apply(action.thisArg,arrayPush([result],action.args));},result);}/**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */function baseXor(arrays,iteratee,comparator){var length=arrays.length;if(length<2){return length?baseUniq(arrays[0]):[];}var index=-1,result=Array(length);while(++index<length){var array=arrays[index],othIndex=-1;while(++othIndex<length){if(othIndex!=index){result[index]=baseDifference(result[index]||array,arrays[othIndex],iteratee,comparator);}}}return baseUniq(baseFlatten(result,1),iteratee,comparator);}/**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */function baseZipObject(props,values,assignFunc){var index=-1,length=props.length,valsLength=values.length,result={};while(++index<length){var value=index<valsLength?values[index]:undefined;assignFunc(result,props[index],value);}return result;}/**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */function castArrayLikeObject(value){return isArrayLikeObject(value)?value:[];}/**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */function castFunction(value){return typeof value=='function'?value:identity;}/**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */function castPath(value,object){if(isArray(value)){return value;}return isKey(value,object)?[value]:stringToPath(toString(value));}/**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */var castRest=baseRest;/**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */function castSlice(array,start,end){var length=array.length;end=end===undefined?length:end;return!start&&end>=length?array:baseSlice(array,start,end);}/**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */var clearTimeout=ctxClearTimeout||function(id){return root.clearTimeout(id);};/**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */function cloneBuffer(buffer,isDeep){if(isDeep){return buffer.slice();}var length=buffer.length,result=allocUnsafe?allocUnsafe(length):new buffer.constructor(length);buffer.copy(result);return result;}/**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */function cloneArrayBuffer(arrayBuffer){var result=new arrayBuffer.constructor(arrayBuffer.byteLength);new Uint8Array(result).set(new Uint8Array(arrayBuffer));return result;}/**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */function cloneDataView(dataView,isDeep){var buffer=isDeep?cloneArrayBuffer(dataView.buffer):dataView.buffer;return new dataView.constructor(buffer,dataView.byteOffset,dataView.byteLength);}/**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */function cloneRegExp(regexp){var result=new regexp.constructor(regexp.source,reFlags.exec(regexp));result.lastIndex=regexp.lastIndex;return result;}/**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */function cloneSymbol(symbol){return symbolValueOf?Object(symbolValueOf.call(symbol)):{};}/**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */function cloneTypedArray(typedArray,isDeep){var buffer=isDeep?cloneArrayBuffer(typedArray.buffer):typedArray.buffer;return new typedArray.constructor(buffer,typedArray.byteOffset,typedArray.length);}/**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */function compareAscending(value,other){if(value!==other){var valIsDefined=value!==undefined,valIsNull=value===null,valIsReflexive=value===value,valIsSymbol=isSymbol(value);var othIsDefined=other!==undefined,othIsNull=other===null,othIsReflexive=other===other,othIsSymbol=isSymbol(other);if(!othIsNull&&!othIsSymbol&&!valIsSymbol&&value>other||valIsSymbol&&othIsDefined&&othIsReflexive&&!othIsNull&&!othIsSymbol||valIsNull&&othIsDefined&&othIsReflexive||!valIsDefined&&othIsReflexive||!valIsReflexive){return 1;}if(!valIsNull&&!valIsSymbol&&!othIsSymbol&&value<other||othIsSymbol&&valIsDefined&&valIsReflexive&&!valIsNull&&!valIsSymbol||othIsNull&&valIsDefined&&valIsReflexive||!othIsDefined&&valIsReflexive||!othIsReflexive){return-1;}}return 0;}/**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */function compareMultiple(object,other,orders){var index=-1,objCriteria=object.criteria,othCriteria=other.criteria,length=objCriteria.length,ordersLength=orders.length;while(++index<length){var result=compareAscending(objCriteria[index],othCriteria[index]);if(result){if(index>=ordersLength){return result;}var order=orders[index];return result*(order=='desc'?-1:1);}}// Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
// that causes it, under certain circumstances, to provide the same value for
// `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
// for more details.
//
// This also ensures a stable sort in V8 and other engines.
// See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
return object.index-other.index;}/**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */function composeArgs(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersLength=holders.length,leftIndex=-1,leftLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(leftLength+rangeLength),isUncurried=!isCurried;while(++leftIndex<leftLength){result[leftIndex]=partials[leftIndex];}while(++argsIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[holders[argsIndex]]=args[argsIndex];}}while(rangeLength--){result[leftIndex++]=args[argsIndex++];}return result;}/**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */function composeArgsRight(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersIndex=-1,holdersLength=holders.length,rightIndex=-1,rightLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(rangeLength+rightLength),isUncurried=!isCurried;while(++argsIndex<rangeLength){result[argsIndex]=args[argsIndex];}var offset=argsIndex;while(++rightIndex<rightLength){result[offset+rightIndex]=partials[rightIndex];}while(++holdersIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[offset+holders[holdersIndex]]=args[argsIndex++];}}return result;}/**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */function copyArray(source,array){var index=-1,length=source.length;array||(array=Array(length));while(++index<length){array[index]=source[index];}return array;}/**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */function copyObject(source,props,object,customizer){var isNew=!object;object||(object={});var index=-1,length=props.length;while(++index<length){var key=props[index];var newValue=customizer?customizer(object[key],source[key],key,object,source):undefined;if(newValue===undefined){newValue=source[key];}if(isNew){baseAssignValue(object,key,newValue);}else{assignValue(object,key,newValue);}}return object;}/**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */function copySymbols(source,object){return copyObject(source,getSymbols(source),object);}/**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */function copySymbolsIn(source,object){return copyObject(source,getSymbolsIn(source),object);}/**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */function createAggregator(setter,initializer){return function(collection,iteratee){var func=isArray(collection)?arrayAggregator:baseAggregator,accumulator=initializer?initializer():{};return func(collection,setter,getIteratee(iteratee,2),accumulator);};}/**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */function createAssigner(assigner){return baseRest(function(object,sources){var index=-1,length=sources.length,customizer=length>1?sources[length-1]:undefined,guard=length>2?sources[2]:undefined;customizer=assigner.length>3&&typeof customizer=='function'?(length--,customizer):undefined;if(guard&&isIterateeCall(sources[0],sources[1],guard)){customizer=length<3?undefined:customizer;length=1;}object=Object(object);while(++index<length){var source=sources[index];if(source){assigner(object,source,index,customizer);}}return object;});}/**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */function createBaseEach(eachFunc,fromRight){return function(collection,iteratee){if(collection==null){return collection;}if(!isArrayLike(collection)){return eachFunc(collection,iteratee);}var length=collection.length,index=fromRight?length:-1,iterable=Object(collection);while(fromRight?index--:++index<length){if(iteratee(iterable[index],index,iterable)===false){break;}}return collection;};}/**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */function createBaseFor(fromRight){return function(object,iteratee,keysFunc){var index=-1,iterable=Object(object),props=keysFunc(object),length=props.length;while(length--){var key=props[fromRight?length:++index];if(iteratee(iterable[key],key,iterable)===false){break;}}return object;};}/**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createBind(func,bitmask,thisArg){var isBind=bitmask&WRAP_BIND_FLAG,Ctor=createCtor(func);function wrapper(){var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return fn.apply(isBind?thisArg:this,arguments);}return wrapper;}/**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */function createCaseFirst(methodName){return function(string){string=toString(string);var strSymbols=hasUnicode(string)?stringToArray(string):undefined;var chr=strSymbols?strSymbols[0]:string.charAt(0);var trailing=strSymbols?castSlice(strSymbols,1).join(''):string.slice(1);return chr[methodName]()+trailing;};}/**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */function createCompounder(callback){return function(string){return arrayReduce(words(deburr(string).replace(reApos,'')),callback,'');};}/**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */function createCtor(Ctor){return function(){// Use a `switch` statement to work with class constructors. See
// http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
// for more details.
var args=arguments;switch(args.length){case 0:return new Ctor();case 1:return new Ctor(args[0]);case 2:return new Ctor(args[0],args[1]);case 3:return new Ctor(args[0],args[1],args[2]);case 4:return new Ctor(args[0],args[1],args[2],args[3]);case 5:return new Ctor(args[0],args[1],args[2],args[3],args[4]);case 6:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5]);case 7:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5],args[6]);}var thisBinding=baseCreate(Ctor.prototype),result=Ctor.apply(thisBinding,args);// Mimic the constructor's `return` behavior.
// See https://es5.github.io/#x13.2.2 for more details.
return isObject(result)?result:thisBinding;};}/**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createCurry(func,bitmask,arity){var Ctor=createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length,placeholder=getHolder(wrapper);while(index--){args[index]=arguments[index];}var holders=length<3&&args[0]!==placeholder&&args[length-1]!==placeholder?[]:replaceHolders(args,placeholder);length-=holders.length;if(length<arity){return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,undefined,args,holders,undefined,undefined,arity-length);}var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return apply(fn,this,args);}return wrapper;}/**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */function createFind(findIndexFunc){return function(collection,predicate,fromIndex){var iterable=Object(collection);if(!isArrayLike(collection)){var iteratee=getIteratee(predicate,3);collection=keys(collection);predicate=function predicate(key){return iteratee(iterable[key],key,iterable);};}var index=findIndexFunc(collection,predicate,fromIndex);return index>-1?iterable[iteratee?collection[index]:index]:undefined;};}/**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */function createFlow(fromRight){return flatRest(function(funcs){var length=funcs.length,index=length,prereq=LodashWrapper.prototype.thru;if(fromRight){funcs.reverse();}while(index--){var func=funcs[index];if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(prereq&&!wrapper&&getFuncName(func)=='wrapper'){var wrapper=new LodashWrapper([],true);}}index=wrapper?index:length;while(++index<length){func=funcs[index];var funcName=getFuncName(func),data=funcName=='wrapper'?getData(func):undefined;if(data&&isLaziable(data[0])&&data[1]==(WRAP_ARY_FLAG|WRAP_CURRY_FLAG|WRAP_PARTIAL_FLAG|WRAP_REARG_FLAG)&&!data[4].length&&data[9]==1){wrapper=wrapper[getFuncName(data[0])].apply(wrapper,data[3]);}else{wrapper=func.length==1&&isLaziable(func)?wrapper[funcName]():wrapper.thru(func);}}return function(){var args=arguments,value=args[0];if(wrapper&&args.length==1&&isArray(value)){return wrapper.plant(value).value();}var index=0,result=length?funcs[index].apply(this,args):value;while(++index<length){result=funcs[index].call(this,result);}return result;};});}/**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createHybrid(func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity){var isAry=bitmask&WRAP_ARY_FLAG,isBind=bitmask&WRAP_BIND_FLAG,isBindKey=bitmask&WRAP_BIND_KEY_FLAG,isCurried=bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG),isFlip=bitmask&WRAP_FLIP_FLAG,Ctor=isBindKey?undefined:createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length;while(index--){args[index]=arguments[index];}if(isCurried){var placeholder=getHolder(wrapper),holdersCount=countHolders(args,placeholder);}if(partials){args=composeArgs(args,partials,holders,isCurried);}if(partialsRight){args=composeArgsRight(args,partialsRight,holdersRight,isCurried);}length-=holdersCount;if(isCurried&&length<arity){var newHolders=replaceHolders(args,placeholder);return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,thisArg,args,newHolders,argPos,ary,arity-length);}var thisBinding=isBind?thisArg:this,fn=isBindKey?thisBinding[func]:func;length=args.length;if(argPos){args=reorder(args,argPos);}else if(isFlip&&length>1){args.reverse();}if(isAry&&ary<length){args.length=ary;}if(this&&this!==root&&this instanceof wrapper){fn=Ctor||createCtor(fn);}return fn.apply(thisBinding,args);}return wrapper;}/**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */function createInverter(setter,toIteratee){return function(object,iteratee){return baseInverter(object,setter,toIteratee(iteratee),{});};}/**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */function createMathOperation(operator,defaultValue){return function(value,other){var result;if(value===undefined&&other===undefined){return defaultValue;}if(value!==undefined){result=value;}if(other!==undefined){if(result===undefined){return other;}if(typeof value=='string'||typeof other=='string'){value=baseToString(value);other=baseToString(other);}else{value=baseToNumber(value);other=baseToNumber(other);}result=operator(value,other);}return result;};}/**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */function createOver(arrayFunc){return flatRest(function(iteratees){iteratees=arrayMap(iteratees,baseUnary(getIteratee()));return baseRest(function(args){var thisArg=this;return arrayFunc(iteratees,function(iteratee){return apply(iteratee,thisArg,args);});});});}/**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */function createPadding(length,chars){chars=chars===undefined?' ':baseToString(chars);var charsLength=chars.length;if(charsLength<2){return charsLength?baseRepeat(chars,length):chars;}var result=baseRepeat(chars,nativeCeil(length/stringSize(chars)));return hasUnicode(chars)?castSlice(stringToArray(result),0,length).join(''):result.slice(0,length);}/**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */function createPartial(func,bitmask,thisArg,partials){var isBind=bitmask&WRAP_BIND_FLAG,Ctor=createCtor(func);function wrapper(){var argsIndex=-1,argsLength=arguments.length,leftIndex=-1,leftLength=partials.length,args=Array(leftLength+argsLength),fn=this&&this!==root&&this instanceof wrapper?Ctor:func;while(++leftIndex<leftLength){args[leftIndex]=partials[leftIndex];}while(argsLength--){args[leftIndex++]=arguments[++argsIndex];}return apply(fn,isBind?thisArg:this,args);}return wrapper;}/**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */function createRange(fromRight){return function(start,end,step){if(step&&typeof step!='number'&&isIterateeCall(start,end,step)){end=step=undefined;}// Ensure the sign of `-0` is preserved.
start=toFinite(start);if(end===undefined){end=start;start=0;}else{end=toFinite(end);}step=step===undefined?start<end?1:-1:toFinite(step);return baseRange(start,end,step,fromRight);};}/**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */function createRelationalOperation(operator){return function(value,other){if(!(typeof value=='string'&&typeof other=='string')){value=toNumber(value);other=toNumber(other);}return operator(value,other);};}/**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createRecurry(func,bitmask,wrapFunc,placeholder,thisArg,partials,holders,argPos,ary,arity){var isCurry=bitmask&WRAP_CURRY_FLAG,newHolders=isCurry?holders:undefined,newHoldersRight=isCurry?undefined:holders,newPartials=isCurry?partials:undefined,newPartialsRight=isCurry?undefined:partials;bitmask|=isCurry?WRAP_PARTIAL_FLAG:WRAP_PARTIAL_RIGHT_FLAG;bitmask&=~(isCurry?WRAP_PARTIAL_RIGHT_FLAG:WRAP_PARTIAL_FLAG);if(!(bitmask&WRAP_CURRY_BOUND_FLAG)){bitmask&=~(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG);}var newData=[func,bitmask,thisArg,newPartials,newHolders,newPartialsRight,newHoldersRight,argPos,ary,arity];var result=wrapFunc.apply(undefined,newData);if(isLaziable(func)){setData(result,newData);}result.placeholder=placeholder;return setWrapToString(result,func,bitmask);}/**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */function createRound(methodName){var func=Math[methodName];return function(number,precision){number=toNumber(number);precision=precision==null?0:nativeMin(toInteger(precision),292);if(precision&&nativeIsFinite(number)){// Shift with exponential notation to avoid floating-point issues.
// See [MDN](https://mdn.io/round#Examples) for more details.
var pair=(toString(number)+'e').split('e'),value=func(pair[0]+'e'+(+pair[1]+precision));pair=(toString(value)+'e').split('e');return+(pair[0]+'e'+(+pair[1]-precision));}return func(number);};}/**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */var createSet=!(Set&&1/setToArray(new Set([,-0]))[1]==INFINITY)?noop:function(values){return new Set(values);};/**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */function createToPairs(keysFunc){return function(object){var tag=getTag(object);if(tag==mapTag){return mapToArray(object);}if(tag==setTag){return setToPairs(object);}return baseToPairs(object,keysFunc(object));};}/**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createWrap(func,bitmask,thisArg,partials,holders,argPos,ary,arity){var isBindKey=bitmask&WRAP_BIND_KEY_FLAG;if(!isBindKey&&typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var length=partials?partials.length:0;if(!length){bitmask&=~(WRAP_PARTIAL_FLAG|WRAP_PARTIAL_RIGHT_FLAG);partials=holders=undefined;}ary=ary===undefined?ary:nativeMax(toInteger(ary),0);arity=arity===undefined?arity:toInteger(arity);length-=holders?holders.length:0;if(bitmask&WRAP_PARTIAL_RIGHT_FLAG){var partialsRight=partials,holdersRight=holders;partials=holders=undefined;}var data=isBindKey?undefined:getData(func);var newData=[func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity];if(data){mergeData(newData,data);}func=newData[0];bitmask=newData[1];thisArg=newData[2];partials=newData[3];holders=newData[4];arity=newData[9]=newData[9]===undefined?isBindKey?0:func.length:nativeMax(newData[9]-length,0);if(!arity&&bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG)){bitmask&=~(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG);}if(!bitmask||bitmask==WRAP_BIND_FLAG){var result=createBind(func,bitmask,thisArg);}else if(bitmask==WRAP_CURRY_FLAG||bitmask==WRAP_CURRY_RIGHT_FLAG){result=createCurry(func,bitmask,arity);}else if((bitmask==WRAP_PARTIAL_FLAG||bitmask==(WRAP_BIND_FLAG|WRAP_PARTIAL_FLAG))&&!holders.length){result=createPartial(func,bitmask,thisArg,partials);}else{result=createHybrid.apply(undefined,newData);}var setter=data?baseSetData:setData;return setWrapToString(setter(result,newData),func,bitmask);}/**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */function customDefaultsAssignIn(objValue,srcValue,key,object){if(objValue===undefined||eq(objValue,objectProto[key])&&!hasOwnProperty.call(object,key)){return srcValue;}return objValue;}/**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */function customDefaultsMerge(objValue,srcValue,key,object,source,stack){if(isObject(objValue)&&isObject(srcValue)){// Recursively merge objects and arrays (susceptible to call stack limits).
stack.set(srcValue,objValue);baseMerge(objValue,srcValue,undefined,customDefaultsMerge,stack);stack['delete'](srcValue);}return objValue;}/**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */function customOmitClone(value){return isPlainObject(value)?undefined:value;}/**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */function equalArrays(array,other,bitmask,customizer,equalFunc,stack){var isPartial=bitmask&COMPARE_PARTIAL_FLAG,arrLength=array.length,othLength=other.length;if(arrLength!=othLength&&!(isPartial&&othLength>arrLength)){return false;}// Check that cyclic values are equal.
var arrStacked=stack.get(array);var othStacked=stack.get(other);if(arrStacked&&othStacked){return arrStacked==other&&othStacked==array;}var index=-1,result=true,seen=bitmask&COMPARE_UNORDERED_FLAG?new SetCache():undefined;stack.set(array,other);stack.set(other,array);// Ignore non-index properties.
while(++index<arrLength){var arrValue=array[index],othValue=other[index];if(customizer){var compared=isPartial?customizer(othValue,arrValue,index,other,array,stack):customizer(arrValue,othValue,index,array,other,stack);}if(compared!==undefined){if(compared){continue;}result=false;break;}// Recursively compare arrays (susceptible to call stack limits).
if(seen){if(!arraySome(other,function(othValue,othIndex){if(!cacheHas(seen,othIndex)&&(arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){return seen.push(othIndex);}})){result=false;break;}}else if(!(arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){result=false;break;}}stack['delete'](array);stack['delete'](other);return result;}/**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */function equalByTag(object,other,tag,bitmask,customizer,equalFunc,stack){switch(tag){case dataViewTag:if(object.byteLength!=other.byteLength||object.byteOffset!=other.byteOffset){return false;}object=object.buffer;other=other.buffer;case arrayBufferTag:if(object.byteLength!=other.byteLength||!equalFunc(new Uint8Array(object),new Uint8Array(other))){return false;}return true;case boolTag:case dateTag:case numberTag:// Coerce booleans to `1` or `0` and dates to milliseconds.
// Invalid dates are coerced to `NaN`.
return eq(+object,+other);case errorTag:return object.name==other.name&&object.message==other.message;case regexpTag:case stringTag:// Coerce regexes to strings and treat strings, primitives and objects,
// as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
// for more details.
return object==other+'';case mapTag:var convert=mapToArray;case setTag:var isPartial=bitmask&COMPARE_PARTIAL_FLAG;convert||(convert=setToArray);if(object.size!=other.size&&!isPartial){return false;}// Assume cyclic values are equal.
var stacked=stack.get(object);if(stacked){return stacked==other;}bitmask|=COMPARE_UNORDERED_FLAG;// Recursively compare objects (susceptible to call stack limits).
stack.set(object,other);var result=equalArrays(convert(object),convert(other),bitmask,customizer,equalFunc,stack);stack['delete'](object);return result;case symbolTag:if(symbolValueOf){return symbolValueOf.call(object)==symbolValueOf.call(other);}}return false;}/**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */function equalObjects(object,other,bitmask,customizer,equalFunc,stack){var isPartial=bitmask&COMPARE_PARTIAL_FLAG,objProps=getAllKeys(object),objLength=objProps.length,othProps=getAllKeys(other),othLength=othProps.length;if(objLength!=othLength&&!isPartial){return false;}var index=objLength;while(index--){var key=objProps[index];if(!(isPartial?key in other:hasOwnProperty.call(other,key))){return false;}}// Check that cyclic values are equal.
var objStacked=stack.get(object);var othStacked=stack.get(other);if(objStacked&&othStacked){return objStacked==other&&othStacked==object;}var result=true;stack.set(object,other);stack.set(other,object);var skipCtor=isPartial;while(++index<objLength){key=objProps[index];var objValue=object[key],othValue=other[key];if(customizer){var compared=isPartial?customizer(othValue,objValue,key,other,object,stack):customizer(objValue,othValue,key,object,other,stack);}// Recursively compare objects (susceptible to call stack limits).
if(!(compared===undefined?objValue===othValue||equalFunc(objValue,othValue,bitmask,customizer,stack):compared)){result=false;break;}skipCtor||(skipCtor=key=='constructor');}if(result&&!skipCtor){var objCtor=object.constructor,othCtor=other.constructor;// Non `Object` object instances with different constructors are not equal.
if(objCtor!=othCtor&&'constructor'in object&&'constructor'in other&&!(typeof objCtor=='function'&&objCtor instanceof objCtor&&typeof othCtor=='function'&&othCtor instanceof othCtor)){result=false;}}stack['delete'](object);stack['delete'](other);return result;}/**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */function flatRest(func){return setToString(overRest(func,undefined,flatten),func+'');}/**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */function getAllKeys(object){return baseGetAllKeys(object,keys,getSymbols);}/**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */function getAllKeysIn(object){return baseGetAllKeys(object,keysIn,getSymbolsIn);}/**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */var getData=!metaMap?noop:function(func){return metaMap.get(func);};/**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */function getFuncName(func){var result=func.name+'',array=realNames[result],length=hasOwnProperty.call(realNames,result)?array.length:0;while(length--){var data=array[length],otherFunc=data.func;if(otherFunc==null||otherFunc==func){return data.name;}}return result;}/**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */function getHolder(func){var object=hasOwnProperty.call(lodash,'placeholder')?lodash:func;return object.placeholder;}/**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */function getIteratee(){var result=lodash.iteratee||iteratee;result=result===iteratee?baseIteratee:result;return arguments.length?result(arguments[0],arguments[1]):result;}/**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */function getMapData(map,key){var data=map.__data__;return isKeyable(key)?data[typeof key=='string'?'string':'hash']:data.map;}/**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */function getMatchData(object){var result=keys(object),length=result.length;while(length--){var key=result[length],value=object[key];result[length]=[key,value,isStrictComparable(value)];}return result;}/**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */function getNative(object,key){var value=getValue(object,key);return baseIsNative(value)?value:undefined;}/**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */function getRawTag(value){var isOwn=hasOwnProperty.call(value,symToStringTag),tag=value[symToStringTag];try{value[symToStringTag]=undefined;var unmasked=true;}catch(e){}var result=nativeObjectToString.call(value);if(unmasked){if(isOwn){value[symToStringTag]=tag;}else{delete value[symToStringTag];}}return result;}/**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */var getSymbols=!nativeGetSymbols?stubArray:function(object){if(object==null){return[];}object=Object(object);return arrayFilter(nativeGetSymbols(object),function(symbol){return propertyIsEnumerable.call(object,symbol);});};/**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */var getSymbolsIn=!nativeGetSymbols?stubArray:function(object){var result=[];while(object){arrayPush(result,getSymbols(object));object=getPrototype(object);}return result;};/**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */var getTag=baseGetTag;// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if(DataView&&getTag(new DataView(new ArrayBuffer(1)))!=dataViewTag||Map&&getTag(new Map())!=mapTag||Promise&&getTag(Promise.resolve())!=promiseTag||Set&&getTag(new Set())!=setTag||WeakMap&&getTag(new WeakMap())!=weakMapTag){getTag=function getTag(value){var result=baseGetTag(value),Ctor=result==objectTag?value.constructor:undefined,ctorString=Ctor?toSource(Ctor):'';if(ctorString){switch(ctorString){case dataViewCtorString:return dataViewTag;case mapCtorString:return mapTag;case promiseCtorString:return promiseTag;case setCtorString:return setTag;case weakMapCtorString:return weakMapTag;}}return result;};}/**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */function getView(start,end,transforms){var index=-1,length=transforms.length;while(++index<length){var data=transforms[index],size=data.size;switch(data.type){case'drop':start+=size;break;case'dropRight':end-=size;break;case'take':end=nativeMin(end,start+size);break;case'takeRight':start=nativeMax(start,end-size);break;}}return{'start':start,'end':end};}/**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */function getWrapDetails(source){var match=source.match(reWrapDetails);return match?match[1].split(reSplitDetails):[];}/**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */function hasPath(object,path,hasFunc){path=castPath(path,object);var index=-1,length=path.length,result=false;while(++index<length){var key=toKey(path[index]);if(!(result=object!=null&&hasFunc(object,key))){break;}object=object[key];}if(result||++index!=length){return result;}length=object==null?0:object.length;return!!length&&isLength(length)&&isIndex(key,length)&&(isArray(object)||isArguments(object));}/**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */function initCloneArray(array){var length=array.length,result=new array.constructor(length);// Add properties assigned by `RegExp#exec`.
if(length&&typeof array[0]=='string'&&hasOwnProperty.call(array,'index')){result.index=array.index;result.input=array.input;}return result;}/**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */function initCloneObject(object){return typeof object.constructor=='function'&&!isPrototype(object)?baseCreate(getPrototype(object)):{};}/**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */function initCloneByTag(object,tag,isDeep){var Ctor=object.constructor;switch(tag){case arrayBufferTag:return cloneArrayBuffer(object);case boolTag:case dateTag:return new Ctor(+object);case dataViewTag:return cloneDataView(object,isDeep);case float32Tag:case float64Tag:case int8Tag:case int16Tag:case int32Tag:case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:return cloneTypedArray(object,isDeep);case mapTag:return new Ctor();case numberTag:case stringTag:return new Ctor(object);case regexpTag:return cloneRegExp(object);case setTag:return new Ctor();case symbolTag:return cloneSymbol(object);}}/**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */function insertWrapDetails(source,details){var length=details.length;if(!length){return source;}var lastIndex=length-1;details[lastIndex]=(length>1?'& ':'')+details[lastIndex];details=details.join(length>2?', ':' ');return source.replace(reWrapComment,'{\n/* [wrapped with '+details+'] */\n');}/**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */function isFlattenable(value){return isArray(value)||isArguments(value)||!!(spreadableSymbol&&value&&value[spreadableSymbol]);}/**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */function isIndex(value,length){var type=_typeof(value);length=length==null?MAX_SAFE_INTEGER:length;return!!length&&(type=='number'||type!='symbol'&&reIsUint.test(value))&&value>-1&&value%1==0&&value<length;}/**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */function isIterateeCall(value,index,object){if(!isObject(object)){return false;}var type=_typeof(index);if(type=='number'?isArrayLike(object)&&isIndex(index,object.length):type=='string'&&index in object){return eq(object[index],value);}return false;}/**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */function isKey(value,object){if(isArray(value)){return false;}var type=_typeof(value);if(type=='number'||type=='symbol'||type=='boolean'||value==null||isSymbol(value)){return true;}return reIsPlainProp.test(value)||!reIsDeepProp.test(value)||object!=null&&value in Object(object);}/**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */function isKeyable(value){var type=_typeof(value);return type=='string'||type=='number'||type=='symbol'||type=='boolean'?value!=='__proto__':value===null;}/**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */function isLaziable(func){var funcName=getFuncName(func),other=lodash[funcName];if(typeof other!='function'||!(funcName in LazyWrapper.prototype)){return false;}if(func===other){return true;}var data=getData(other);return!!data&&func===data[0];}/**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */function isMasked(func){return!!maskSrcKey&&maskSrcKey in func;}/**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */var isMaskable=coreJsData?isFunction:stubFalse;/**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */function isPrototype(value){var Ctor=value&&value.constructor,proto=typeof Ctor=='function'&&Ctor.prototype||objectProto;return value===proto;}/**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */function isStrictComparable(value){return value===value&&!isObject(value);}/**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */function matchesStrictComparable(key,srcValue){return function(object){if(object==null){return false;}return object[key]===srcValue&&(srcValue!==undefined||key in Object(object));};}/**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */function memoizeCapped(func){var result=memoize(func,function(key){if(cache.size===MAX_MEMOIZE_SIZE){cache.clear();}return key;});var cache=result.cache;return result;}/**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */function mergeData(data,source){var bitmask=data[1],srcBitmask=source[1],newBitmask=bitmask|srcBitmask,isCommon=newBitmask<(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG|WRAP_ARY_FLAG);var isCombo=srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_CURRY_FLAG||srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_REARG_FLAG&&data[7].length<=source[8]||srcBitmask==(WRAP_ARY_FLAG|WRAP_REARG_FLAG)&&source[7].length<=source[8]&&bitmask==WRAP_CURRY_FLAG;// Exit early if metadata can't be merged.
if(!(isCommon||isCombo)){return data;}// Use source `thisArg` if available.
if(srcBitmask&WRAP_BIND_FLAG){data[2]=source[2];// Set when currying a bound function.
newBitmask|=bitmask&WRAP_BIND_FLAG?0:WRAP_CURRY_BOUND_FLAG;}// Compose partial arguments.
var value=source[3];if(value){var partials=data[3];data[3]=partials?composeArgs(partials,value,source[4]):value;data[4]=partials?replaceHolders(data[3],PLACEHOLDER):source[4];}// Compose partial right arguments.
value=source[5];if(value){partials=data[5];data[5]=partials?composeArgsRight(partials,value,source[6]):value;data[6]=partials?replaceHolders(data[5],PLACEHOLDER):source[6];}// Use source `argPos` if available.
value=source[7];if(value){data[7]=value;}// Use source `ary` if it's smaller.
if(srcBitmask&WRAP_ARY_FLAG){data[8]=data[8]==null?source[8]:nativeMin(data[8],source[8]);}// Use source `arity` if one is not provided.
if(data[9]==null){data[9]=source[9];}// Use source `func` and merge bitmasks.
data[0]=source[0];data[1]=newBitmask;return data;}/**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */function nativeKeysIn(object){var result=[];if(object!=null){for(var key in Object(object)){result.push(key);}}return result;}/**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */function objectToString(value){return nativeObjectToString.call(value);}/**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */function overRest(func,start,transform){start=nativeMax(start===undefined?func.length-1:start,0);return function(){var args=arguments,index=-1,length=nativeMax(args.length-start,0),array=Array(length);while(++index<length){array[index]=args[start+index];}index=-1;var otherArgs=Array(start+1);while(++index<start){otherArgs[index]=args[index];}otherArgs[start]=transform(array);return apply(func,this,otherArgs);};}/**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */function parent(object,path){return path.length<2?object:baseGet(object,baseSlice(path,0,-1));}/**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */function reorder(array,indexes){var arrLength=array.length,length=nativeMin(indexes.length,arrLength),oldArray=copyArray(array);while(length--){var index=indexes[length];array[length]=isIndex(index,arrLength)?oldArray[index]:undefined;}return array;}/**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */function safeGet(object,key){if(key==='constructor'&&typeof object[key]==='function'){return;}if(key=='__proto__'){return;}return object[key];}/**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */var setData=shortOut(baseSetData);/**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */var setTimeout=ctxSetTimeout||function(func,wait){return root.setTimeout(func,wait);};/**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */var setToString=shortOut(baseSetToString);/**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */function setWrapToString(wrapper,reference,bitmask){var source=reference+'';return setToString(wrapper,insertWrapDetails(source,updateWrapDetails(getWrapDetails(source),bitmask)));}/**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */function shortOut(func){var count=0,lastCalled=0;return function(){var stamp=nativeNow(),remaining=HOT_SPAN-(stamp-lastCalled);lastCalled=stamp;if(remaining>0){if(++count>=HOT_COUNT){return arguments[0];}}else{count=0;}return func.apply(undefined,arguments);};}/**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */function shuffleSelf(array,size){var index=-1,length=array.length,lastIndex=length-1;size=size===undefined?length:size;while(++index<size){var rand=baseRandom(index,lastIndex),value=array[rand];array[rand]=array[index];array[index]=value;}array.length=size;return array;}/**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */var stringToPath=memoizeCapped(function(string){var result=[];if(string.charCodeAt(0)===46/* . */){result.push('');}string.replace(rePropName,function(match,number,quote,subString){result.push(quote?subString.replace(reEscapeChar,'$1'):number||match);});return result;});/**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */function toKey(value){if(typeof value=='string'||isSymbol(value)){return value;}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */function toSource(func){if(func!=null){try{return funcToString.call(func);}catch(e){}try{return func+'';}catch(e){}}return'';}/**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */function updateWrapDetails(details,bitmask){arrayEach(wrapFlags,function(pair){var value='_.'+pair[0];if(bitmask&pair[1]&&!arrayIncludes(details,value)){details.push(value);}});return details.sort();}/**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */function wrapperClone(wrapper){if(wrapper instanceof LazyWrapper){return wrapper.clone();}var result=new LodashWrapper(wrapper.__wrapped__,wrapper.__chain__);result.__actions__=copyArray(wrapper.__actions__);result.__index__=wrapper.__index__;result.__values__=wrapper.__values__;return result;}/*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */function chunk(array,size,guard){if(guard?isIterateeCall(array,size,guard):size===undefined){size=1;}else{size=nativeMax(toInteger(size),0);}var length=array==null?0:array.length;if(!length||size<1){return[];}var index=0,resIndex=0,result=Array(nativeCeil(length/size));while(index<length){result[resIndex++]=baseSlice(array,index,index+=size);}return result;}/**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */function compact(array){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value){result[resIndex++]=value;}}return result;}/**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */function concat(){var length=arguments.length;if(!length){return[];}var args=Array(length-1),array=arguments[0],index=length;while(index--){args[index-1]=arguments[index];}return arrayPush(isArray(array)?copyArray(array):[array],baseFlatten(args,1));}/**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */var difference=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true)):[];});/**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */var differenceBy=baseRest(function(array,values){var iteratee=last(values);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),getIteratee(iteratee,2)):[];});/**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */var differenceWith=baseRest(function(array,values){var comparator=last(values);if(isArrayLikeObject(comparator)){comparator=undefined;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),undefined,comparator):[];});/**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */function drop(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);return baseSlice(array,n<0?0:n,length);}/**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */function dropRight(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);n=length-n;return baseSlice(array,0,n<0?0:n);}/**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */function dropRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true,true):[];}/**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */function dropWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true):[];}/**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */function fill(array,value,start,end){var length=array==null?0:array.length;if(!length){return[];}if(start&&typeof start!='number'&&isIterateeCall(array,value,start)){start=0;end=length;}return baseFill(array,value,start,end);}/**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */function findIndex(array,predicate,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseFindIndex(array,getIteratee(predicate,3),index);}/**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */function findLastIndex(array,predicate,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=length-1;if(fromIndex!==undefined){index=toInteger(fromIndex);index=fromIndex<0?nativeMax(length+index,0):nativeMin(index,length-1);}return baseFindIndex(array,getIteratee(predicate,3),index,true);}/**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */function flatten(array){var length=array==null?0:array.length;return length?baseFlatten(array,1):[];}/**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */function flattenDeep(array){var length=array==null?0:array.length;return length?baseFlatten(array,INFINITY):[];}/**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */function flattenDepth(array,depth){var length=array==null?0:array.length;if(!length){return[];}depth=depth===undefined?1:toInteger(depth);return baseFlatten(array,depth);}/**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */function fromPairs(pairs){var index=-1,length=pairs==null?0:pairs.length,result={};while(++index<length){var pair=pairs[index];result[pair[0]]=pair[1];}return result;}/**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */function head(array){return array&&array.length?array[0]:undefined;}/**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */function indexOf(array,value,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseIndexOf(array,value,index);}/**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */function initial(array){var length=array==null?0:array.length;return length?baseSlice(array,0,-1):[];}/**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */var intersection=baseRest(function(arrays){var mapped=arrayMap(arrays,castArrayLikeObject);return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped):[];});/**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */var intersectionBy=baseRest(function(arrays){var iteratee=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);if(iteratee===last(mapped)){iteratee=undefined;}else{mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,getIteratee(iteratee,2)):[];});/**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */var intersectionWith=baseRest(function(arrays){var comparator=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);comparator=typeof comparator=='function'?comparator:undefined;if(comparator){mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,undefined,comparator):[];});/**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */function join(array,separator){return array==null?'':nativeJoin.call(array,separator);}/**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */function last(array){var length=array==null?0:array.length;return length?array[length-1]:undefined;}/**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */function lastIndexOf(array,value,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=length;if(fromIndex!==undefined){index=toInteger(fromIndex);index=index<0?nativeMax(length+index,0):nativeMin(index,length-1);}return value===value?strictLastIndexOf(array,value,index):baseFindIndex(array,baseIsNaN,index,true);}/**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */function nth(array,n){return array&&array.length?baseNth(array,toInteger(n)):undefined;}/**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */var pull=baseRest(pullAll);/**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */function pullAll(array,values){return array&&array.length&&values&&values.length?basePullAll(array,values):array;}/**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */function pullAllBy(array,values,iteratee){return array&&array.length&&values&&values.length?basePullAll(array,values,getIteratee(iteratee,2)):array;}/**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */function pullAllWith(array,values,comparator){return array&&array.length&&values&&values.length?basePullAll(array,values,undefined,comparator):array;}/**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */var pullAt=flatRest(function(array,indexes){var length=array==null?0:array.length,result=baseAt(array,indexes);basePullAt(array,arrayMap(indexes,function(index){return isIndex(index,length)?+index:index;}).sort(compareAscending));return result;});/**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */function remove(array,predicate){var result=[];if(!(array&&array.length)){return result;}var index=-1,indexes=[],length=array.length;predicate=getIteratee(predicate,3);while(++index<length){var value=array[index];if(predicate(value,index,array)){result.push(value);indexes.push(index);}}basePullAt(array,indexes);return result;}/**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */function reverse(array){return array==null?array:nativeReverse.call(array);}/**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */function slice(array,start,end){var length=array==null?0:array.length;if(!length){return[];}if(end&&typeof end!='number'&&isIterateeCall(array,start,end)){start=0;end=length;}else{start=start==null?0:toInteger(start);end=end===undefined?length:toInteger(end);}return baseSlice(array,start,end);}/**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */function sortedIndex(array,value){return baseSortedIndex(array,value);}/**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */function sortedIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2));}/**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */function sortedIndexOf(array,value){var length=array==null?0:array.length;if(length){var index=baseSortedIndex(array,value);if(index<length&&eq(array[index],value)){return index;}}return-1;}/**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */function sortedLastIndex(array,value){return baseSortedIndex(array,value,true);}/**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */function sortedLastIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2),true);}/**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */function sortedLastIndexOf(array,value){var length=array==null?0:array.length;if(length){var index=baseSortedIndex(array,value,true)-1;if(eq(array[index],value)){return index;}}return-1;}/**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */function sortedUniq(array){return array&&array.length?baseSortedUniq(array):[];}/**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */function sortedUniqBy(array,iteratee){return array&&array.length?baseSortedUniq(array,getIteratee(iteratee,2)):[];}/**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */function tail(array){var length=array==null?0:array.length;return length?baseSlice(array,1,length):[];}/**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */function take(array,n,guard){if(!(array&&array.length)){return[];}n=guard||n===undefined?1:toInteger(n);return baseSlice(array,0,n<0?0:n);}/**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */function takeRight(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);n=length-n;return baseSlice(array,n<0?0:n,length);}/**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */function takeRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),false,true):[];}/**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */function takeWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3)):[];}/**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */var union=baseRest(function(arrays){return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true));});/**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */var unionBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),getIteratee(iteratee,2));});/**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */var unionWith=baseRest(function(arrays){var comparator=last(arrays);comparator=typeof comparator=='function'?comparator:undefined;return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),undefined,comparator);});/**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */function uniq(array){return array&&array.length?baseUniq(array):[];}/**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */function uniqBy(array,iteratee){return array&&array.length?baseUniq(array,getIteratee(iteratee,2)):[];}/**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */function uniqWith(array,comparator){comparator=typeof comparator=='function'?comparator:undefined;return array&&array.length?baseUniq(array,undefined,comparator):[];}/**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */function unzip(array){if(!(array&&array.length)){return[];}var length=0;array=arrayFilter(array,function(group){if(isArrayLikeObject(group)){length=nativeMax(group.length,length);return true;}});return baseTimes(length,function(index){return arrayMap(array,baseProperty(index));});}/**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */function unzipWith(array,iteratee){if(!(array&&array.length)){return[];}var result=unzip(array);if(iteratee==null){return result;}return arrayMap(result,function(group){return apply(iteratee,undefined,group);});}/**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */var without=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,values):[];});/**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */var xor=baseRest(function(arrays){return baseXor(arrayFilter(arrays,isArrayLikeObject));});/**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */var xorBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return baseXor(arrayFilter(arrays,isArrayLikeObject),getIteratee(iteratee,2));});/**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */var xorWith=baseRest(function(arrays){var comparator=last(arrays);comparator=typeof comparator=='function'?comparator:undefined;return baseXor(arrayFilter(arrays,isArrayLikeObject),undefined,comparator);});/**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */var zip=baseRest(unzip);/**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */function zipObject(props,values){return baseZipObject(props||[],values||[],assignValue);}/**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */function zipObjectDeep(props,values){return baseZipObject(props||[],values||[],baseSet);}/**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */var zipWith=baseRest(function(arrays){var length=arrays.length,iteratee=length>1?arrays[length-1]:undefined;iteratee=typeof iteratee=='function'?(arrays.pop(),iteratee):undefined;return unzipWith(arrays,iteratee);});/*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */function chain(value){var result=lodash(value);result.__chain__=true;return result;}/**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */function tap(value,interceptor){interceptor(value);return value;}/**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */function thru(value,interceptor){return interceptor(value);}/**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */var wrapperAt=flatRest(function(paths){var length=paths.length,start=length?paths[0]:0,value=this.__wrapped__,interceptor=function interceptor(object){return baseAt(object,paths);};if(length>1||this.__actions__.length||!(value instanceof LazyWrapper)||!isIndex(start)){return this.thru(interceptor);}value=value.slice(start,+start+(length?1:0));value.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined});return new LodashWrapper(value,this.__chain__).thru(function(array){if(length&&!array.length){array.push(undefined);}return array;});});/**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */function wrapperChain(){return chain(this);}/**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */function wrapperCommit(){return new LodashWrapper(this.value(),this.__chain__);}/**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */function wrapperNext(){if(this.__values__===undefined){this.__values__=toArray(this.value());}var done=this.__index__>=this.__values__.length,value=done?undefined:this.__values__[this.__index__++];return{'done':done,'value':value};}/**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */function wrapperToIterator(){return this;}/**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */function wrapperPlant(value){var result,parent=this;while(parent instanceof baseLodash){var clone=wrapperClone(parent);clone.__index__=0;clone.__values__=undefined;if(result){previous.__wrapped__=clone;}else{result=clone;}var previous=clone;parent=parent.__wrapped__;}previous.__wrapped__=value;return result;}/**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */function wrapperReverse(){var value=this.__wrapped__;if(value instanceof LazyWrapper){var wrapped=value;if(this.__actions__.length){wrapped=new LazyWrapper(this);}wrapped=wrapped.reverse();wrapped.__actions__.push({'func':thru,'args':[reverse],'thisArg':undefined});return new LodashWrapper(wrapped,this.__chain__);}return this.thru(reverse);}/**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */function wrapperValue(){return baseWrapperValue(this.__wrapped__,this.__actions__);}/*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */var countBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){++result[key];}else{baseAssignValue(result,key,1);}});/**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */function every(collection,predicate,guard){var func=isArray(collection)?arrayEvery:baseEvery;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined;}return func(collection,getIteratee(predicate,3));}/**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */function filter(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,getIteratee(predicate,3));}/**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */var find=createFind(findIndex);/**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */var findLast=createFind(findLastIndex);/**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */function flatMap(collection,iteratee){return baseFlatten(map(collection,iteratee),1);}/**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */function flatMapDeep(collection,iteratee){return baseFlatten(map(collection,iteratee),INFINITY);}/**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */function flatMapDepth(collection,iteratee,depth){depth=depth===undefined?1:toInteger(depth);return baseFlatten(map(collection,iteratee),depth);}/**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */function forEach(collection,iteratee){var func=isArray(collection)?arrayEach:baseEach;return func(collection,getIteratee(iteratee,3));}/**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */function forEachRight(collection,iteratee){var func=isArray(collection)?arrayEachRight:baseEachRight;return func(collection,getIteratee(iteratee,3));}/**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */var groupBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){result[key].push(value);}else{baseAssignValue(result,key,[value]);}});/**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */function includes(collection,value,fromIndex,guard){collection=isArrayLike(collection)?collection:values(collection);fromIndex=fromIndex&&!guard?toInteger(fromIndex):0;var length=collection.length;if(fromIndex<0){fromIndex=nativeMax(length+fromIndex,0);}return isString(collection)?fromIndex<=length&&collection.indexOf(value,fromIndex)>-1:!!length&&baseIndexOf(collection,value,fromIndex)>-1;}/**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */var invokeMap=baseRest(function(collection,path,args){var index=-1,isFunc=typeof path=='function',result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value){result[++index]=isFunc?apply(path,value,args):baseInvoke(value,path,args);});return result;});/**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */var keyBy=createAggregator(function(result,value,key){baseAssignValue(result,key,value);});/**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */function map(collection,iteratee){var func=isArray(collection)?arrayMap:baseMap;return func(collection,getIteratee(iteratee,3));}/**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */function orderBy(collection,iteratees,orders,guard){if(collection==null){return[];}if(!isArray(iteratees)){iteratees=iteratees==null?[]:[iteratees];}orders=guard?undefined:orders;if(!isArray(orders)){orders=orders==null?[]:[orders];}return baseOrderBy(collection,iteratees,orders);}/**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */var partition=createAggregator(function(result,value,key){result[key?0:1].push(value);},function(){return[[],[]];});/**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */function reduce(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduce:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEach);}/**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */function reduceRight(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduceRight:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEachRight);}/**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */function reject(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,negate(getIteratee(predicate,3)));}/**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */function sample(collection){var func=isArray(collection)?arraySample:baseSample;return func(collection);}/**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */function sampleSize(collection,n,guard){if(guard?isIterateeCall(collection,n,guard):n===undefined){n=1;}else{n=toInteger(n);}var func=isArray(collection)?arraySampleSize:baseSampleSize;return func(collection,n);}/**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */function shuffle(collection){var func=isArray(collection)?arrayShuffle:baseShuffle;return func(collection);}/**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */function size(collection){if(collection==null){return 0;}if(isArrayLike(collection)){return isString(collection)?stringSize(collection):collection.length;}var tag=getTag(collection);if(tag==mapTag||tag==setTag){return collection.size;}return baseKeys(collection).length;}/**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */function some(collection,predicate,guard){var func=isArray(collection)?arraySome:baseSome;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined;}return func(collection,getIteratee(predicate,3));}/**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */var sortBy=baseRest(function(collection,iteratees){if(collection==null){return[];}var length=iteratees.length;if(length>1&&isIterateeCall(collection,iteratees[0],iteratees[1])){iteratees=[];}else if(length>2&&isIterateeCall(iteratees[0],iteratees[1],iteratees[2])){iteratees=[iteratees[0]];}return baseOrderBy(collection,baseFlatten(iteratees,1),[]);});/*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */var now=ctxNow||function(){return root.Date.now();};/*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */function after(n,func){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n<1){return func.apply(this,arguments);}};}/**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */function ary(func,n,guard){n=guard?undefined:n;n=func&&n==null?func.length:n;return createWrap(func,WRAP_ARY_FLAG,undefined,undefined,undefined,undefined,n);}/**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */function before(n,func){var result;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n>0){result=func.apply(this,arguments);}if(n<=1){func=undefined;}return result;};}/**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */var bind=baseRest(function(func,thisArg,partials){var bitmask=WRAP_BIND_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bind));bitmask|=WRAP_PARTIAL_FLAG;}return createWrap(func,bitmask,thisArg,partials,holders);});/**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */var bindKey=baseRest(function(object,key,partials){var bitmask=WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bindKey));bitmask|=WRAP_PARTIAL_FLAG;}return createWrap(key,bitmask,object,partials,holders);});/**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */function curry(func,arity,guard){arity=guard?undefined:arity;var result=createWrap(func,WRAP_CURRY_FLAG,undefined,undefined,undefined,undefined,undefined,arity);result.placeholder=curry.placeholder;return result;}/**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */function curryRight(func,arity,guard){arity=guard?undefined:arity;var result=createWrap(func,WRAP_CURRY_RIGHT_FLAG,undefined,undefined,undefined,undefined,undefined,arity);result.placeholder=curryRight.placeholder;return result;}/**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */function debounce(func,wait,options){var lastArgs,lastThis,maxWait,result,timerId,lastCallTime,lastInvokeTime=0,leading=false,maxing=false,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}wait=toNumber(wait)||0;if(isObject(options)){leading=!!options.leading;maxing='maxWait'in options;maxWait=maxing?nativeMax(toNumber(options.maxWait)||0,wait):maxWait;trailing='trailing'in options?!!options.trailing:trailing;}function invokeFunc(time){var args=lastArgs,thisArg=lastThis;lastArgs=lastThis=undefined;lastInvokeTime=time;result=func.apply(thisArg,args);return result;}function leadingEdge(time){// Reset any `maxWait` timer.
lastInvokeTime=time;// Start the timer for the trailing edge.
timerId=setTimeout(timerExpired,wait);// Invoke the leading edge.
return leading?invokeFunc(time):result;}function remainingWait(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime,timeWaiting=wait-timeSinceLastCall;return maxing?nativeMin(timeWaiting,maxWait-timeSinceLastInvoke):timeWaiting;}function shouldInvoke(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime;// Either this is the first call, activity has stopped and we're at the
// trailing edge, the system time has gone backwards and we're treating
// it as the trailing edge, or we've hit the `maxWait` limit.
return lastCallTime===undefined||timeSinceLastCall>=wait||timeSinceLastCall<0||maxing&&timeSinceLastInvoke>=maxWait;}function timerExpired(){var time=now();if(shouldInvoke(time)){return trailingEdge(time);}// Restart the timer.
timerId=setTimeout(timerExpired,remainingWait(time));}function trailingEdge(time){timerId=undefined;// Only invoke if we have `lastArgs` which means `func` has been
// debounced at least once.
if(trailing&&lastArgs){return invokeFunc(time);}lastArgs=lastThis=undefined;return result;}function cancel(){if(timerId!==undefined){clearTimeout(timerId);}lastInvokeTime=0;lastArgs=lastCallTime=lastThis=timerId=undefined;}function flush(){return timerId===undefined?result:trailingEdge(now());}function debounced(){var time=now(),isInvoking=shouldInvoke(time);lastArgs=arguments;lastThis=this;lastCallTime=time;if(isInvoking){if(timerId===undefined){return leadingEdge(lastCallTime);}if(maxing){// Handle invocations in a tight loop.
clearTimeout(timerId);timerId=setTimeout(timerExpired,wait);return invokeFunc(lastCallTime);}}if(timerId===undefined){timerId=setTimeout(timerExpired,wait);}return result;}debounced.cancel=cancel;debounced.flush=flush;return debounced;}/**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */var defer=baseRest(function(func,args){return baseDelay(func,1,args);});/**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */var delay=baseRest(function(func,wait,args){return baseDelay(func,toNumber(wait)||0,args);});/**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */function flip(func){return createWrap(func,WRAP_FLIP_FLAG);}/**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */function memoize(func,resolver){if(typeof func!='function'||resolver!=null&&typeof resolver!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var memoized=function memoized(){var args=arguments,key=resolver?resolver.apply(this,args):args[0],cache=memoized.cache;if(cache.has(key)){return cache.get(key);}var result=func.apply(this,args);memoized.cache=cache.set(key,result)||cache;return result;};memoized.cache=new(memoize.Cache||MapCache)();return memoized;}// Expose `MapCache`.
memoize.Cache=MapCache;/**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */function negate(predicate){if(typeof predicate!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return function(){var args=arguments;switch(args.length){case 0:return!predicate.call(this);case 1:return!predicate.call(this,args[0]);case 2:return!predicate.call(this,args[0],args[1]);case 3:return!predicate.call(this,args[0],args[1],args[2]);}return!predicate.apply(this,args);};}/**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */function once(func){return before(2,func);}/**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */var overArgs=castRest(function(func,transforms){transforms=transforms.length==1&&isArray(transforms[0])?arrayMap(transforms[0],baseUnary(getIteratee())):arrayMap(baseFlatten(transforms,1),baseUnary(getIteratee()));var funcsLength=transforms.length;return baseRest(function(args){var index=-1,length=nativeMin(args.length,funcsLength);while(++index<length){args[index]=transforms[index].call(this,args[index]);}return apply(func,this,args);});});/**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */var partial=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partial));return createWrap(func,WRAP_PARTIAL_FLAG,undefined,partials,holders);});/**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */var partialRight=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partialRight));return createWrap(func,WRAP_PARTIAL_RIGHT_FLAG,undefined,partials,holders);});/**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */var rearg=flatRest(function(func,indexes){return createWrap(func,WRAP_REARG_FLAG,undefined,undefined,undefined,indexes);});/**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */function rest(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start===undefined?start:toInteger(start);return baseRest(func,start);}/**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */function spread(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start==null?0:nativeMax(toInteger(start),0);return baseRest(function(args){var array=args[start],otherArgs=castSlice(args,0,start);if(array){arrayPush(otherArgs,array);}return apply(func,this,otherArgs);});}/**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */function throttle(func,wait,options){var leading=true,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(isObject(options)){leading='leading'in options?!!options.leading:leading;trailing='trailing'in options?!!options.trailing:trailing;}return debounce(func,wait,{'leading':leading,'maxWait':wait,'trailing':trailing});}/**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */function unary(func){return ary(func,1);}/**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */function wrap(value,wrapper){return partial(castFunction(wrapper),value);}/*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */function castArray(){if(!arguments.length){return[];}var value=arguments[0];return isArray(value)?value:[value];}/**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */function clone(value){return baseClone(value,CLONE_SYMBOLS_FLAG);}/**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */function cloneWith(value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseClone(value,CLONE_SYMBOLS_FLAG,customizer);}/**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */function cloneDeep(value){return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG);}/**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */function cloneDeepWith(value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG,customizer);}/**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */function conformsTo(object,source){return source==null||baseConformsTo(object,source,keys(source));}/**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */function eq(value,other){return value===other||value!==value&&other!==other;}/**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */var gt=createRelationalOperation(baseGt);/**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */var gte=createRelationalOperation(function(value,other){return value>=other;});/**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */var isArguments=baseIsArguments(function(){return arguments;}())?baseIsArguments:function(value){return isObjectLike(value)&&hasOwnProperty.call(value,'callee')&&!propertyIsEnumerable.call(value,'callee');};/**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */var isArray=Array.isArray;/**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */var isArrayBuffer=nodeIsArrayBuffer?baseUnary(nodeIsArrayBuffer):baseIsArrayBuffer;/**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */function isArrayLike(value){return value!=null&&isLength(value.length)&&!isFunction(value);}/**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */function isArrayLikeObject(value){return isObjectLike(value)&&isArrayLike(value);}/**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */function isBoolean(value){return value===true||value===false||isObjectLike(value)&&baseGetTag(value)==boolTag;}/**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */var isBuffer=nativeIsBuffer||stubFalse;/**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */var isDate=nodeIsDate?baseUnary(nodeIsDate):baseIsDate;/**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */function isElement(value){return isObjectLike(value)&&value.nodeType===1&&!isPlainObject(value);}/**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */function isEmpty(value){if(value==null){return true;}if(isArrayLike(value)&&(isArray(value)||typeof value=='string'||typeof value.splice=='function'||isBuffer(value)||isTypedArray(value)||isArguments(value))){return!value.length;}var tag=getTag(value);if(tag==mapTag||tag==setTag){return!value.size;}if(isPrototype(value)){return!baseKeys(value).length;}for(var key in value){if(hasOwnProperty.call(value,key)){return false;}}return true;}/**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */function isEqual(value,other){return baseIsEqual(value,other);}/**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */function isEqualWith(value,other,customizer){customizer=typeof customizer=='function'?customizer:undefined;var result=customizer?customizer(value,other):undefined;return result===undefined?baseIsEqual(value,other,undefined,customizer):!!result;}/**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */function isError(value){if(!isObjectLike(value)){return false;}var tag=baseGetTag(value);return tag==errorTag||tag==domExcTag||typeof value.message=='string'&&typeof value.name=='string'&&!isPlainObject(value);}/**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */function isFinite(value){return typeof value=='number'&&nativeIsFinite(value);}/**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */function isFunction(value){if(!isObject(value)){return false;}// The use of `Object#toString` avoids issues with the `typeof` operator
// in Safari 9 which returns 'object' for typed arrays and other constructors.
var tag=baseGetTag(value);return tag==funcTag||tag==genTag||tag==asyncTag||tag==proxyTag;}/**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */function isInteger(value){return typeof value=='number'&&value==toInteger(value);}/**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */function isLength(value){return typeof value=='number'&&value>-1&&value%1==0&&value<=MAX_SAFE_INTEGER;}/**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */function isObject(value){var type=_typeof(value);return value!=null&&(type=='object'||type=='function');}/**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */function isObjectLike(value){return value!=null&&_typeof(value)=='object';}/**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */var isMap=nodeIsMap?baseUnary(nodeIsMap):baseIsMap;/**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */function isMatch(object,source){return object===source||baseIsMatch(object,source,getMatchData(source));}/**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */function isMatchWith(object,source,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseIsMatch(object,source,getMatchData(source),customizer);}/**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */function isNaN(value){// An `NaN` primitive is the only value that is not equal to itself.
// Perform the `toStringTag` check first to avoid errors with some
// ActiveX objects in IE.
return isNumber(value)&&value!=+value;}/**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */function isNative(value){if(isMaskable(value)){throw new Error(CORE_ERROR_TEXT);}return baseIsNative(value);}/**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */function isNull(value){return value===null;}/**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */function isNil(value){return value==null;}/**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */function isNumber(value){return typeof value=='number'||isObjectLike(value)&&baseGetTag(value)==numberTag;}/**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */function isPlainObject(value){if(!isObjectLike(value)||baseGetTag(value)!=objectTag){return false;}var proto=getPrototype(value);if(proto===null){return true;}var Ctor=hasOwnProperty.call(proto,'constructor')&&proto.constructor;return typeof Ctor=='function'&&Ctor instanceof Ctor&&funcToString.call(Ctor)==objectCtorString;}/**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */var isRegExp=nodeIsRegExp?baseUnary(nodeIsRegExp):baseIsRegExp;/**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */function isSafeInteger(value){return isInteger(value)&&value>=-MAX_SAFE_INTEGER&&value<=MAX_SAFE_INTEGER;}/**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */var isSet=nodeIsSet?baseUnary(nodeIsSet):baseIsSet;/**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */function isString(value){return typeof value=='string'||!isArray(value)&&isObjectLike(value)&&baseGetTag(value)==stringTag;}/**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */function isSymbol(value){return _typeof(value)=='symbol'||isObjectLike(value)&&baseGetTag(value)==symbolTag;}/**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */var isTypedArray=nodeIsTypedArray?baseUnary(nodeIsTypedArray):baseIsTypedArray;/**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */function isUndefined(value){return value===undefined;}/**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */function isWeakMap(value){return isObjectLike(value)&&getTag(value)==weakMapTag;}/**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */function isWeakSet(value){return isObjectLike(value)&&baseGetTag(value)==weakSetTag;}/**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */var lt=createRelationalOperation(baseLt);/**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */var lte=createRelationalOperation(function(value,other){return value<=other;});/**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */function toArray(value){if(!value){return[];}if(isArrayLike(value)){return isString(value)?stringToArray(value):copyArray(value);}if(symIterator&&value[symIterator]){return iteratorToArray(value[symIterator]());}var tag=getTag(value),func=tag==mapTag?mapToArray:tag==setTag?setToArray:values;return func(value);}/**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */function toFinite(value){if(!value){return value===0?value:0;}value=toNumber(value);if(value===INFINITY||value===-INFINITY){var sign=value<0?-1:1;return sign*MAX_INTEGER;}return value===value?value:0;}/**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */function toInteger(value){var result=toFinite(value),remainder=result%1;return result===result?remainder?result-remainder:result:0;}/**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */function toLength(value){return value?baseClamp(toInteger(value),0,MAX_ARRAY_LENGTH):0;}/**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */function toNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}if(isObject(value)){var other=typeof value.valueOf=='function'?value.valueOf():value;value=isObject(other)?other+'':other;}if(typeof value!='string'){return value===0?value:+value;}value=baseTrim(value);var isBinary=reIsBinary.test(value);return isBinary||reIsOctal.test(value)?freeParseInt(value.slice(2),isBinary?2:8):reIsBadHex.test(value)?NAN:+value;}/**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */function toPlainObject(value){return copyObject(value,keysIn(value));}/**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */function toSafeInteger(value){return value?baseClamp(toInteger(value),-MAX_SAFE_INTEGER,MAX_SAFE_INTEGER):value===0?value:0;}/**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */function toString(value){return value==null?'':baseToString(value);}/*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */var assign=createAssigner(function(object,source){if(isPrototype(source)||isArrayLike(source)){copyObject(source,keys(source),object);return;}for(var key in source){if(hasOwnProperty.call(source,key)){assignValue(object,key,source[key]);}}});/**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */var assignIn=createAssigner(function(object,source){copyObject(source,keysIn(source),object);});/**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */var assignInWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keysIn(source),object,customizer);});/**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */var assignWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keys(source),object,customizer);});/**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */var at=flatRest(baseAt);/**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */function create(prototype,properties){var result=baseCreate(prototype);return properties==null?result:baseAssign(result,properties);}/**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */var defaults=baseRest(function(object,sources){object=Object(object);var index=-1;var length=sources.length;var guard=length>2?sources[2]:undefined;if(guard&&isIterateeCall(sources[0],sources[1],guard)){length=1;}while(++index<length){var source=sources[index];var props=keysIn(source);var propsIndex=-1;var propsLength=props.length;while(++propsIndex<propsLength){var key=props[propsIndex];var value=object[key];if(value===undefined||eq(value,objectProto[key])&&!hasOwnProperty.call(object,key)){object[key]=source[key];}}}return object;});/**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */var defaultsDeep=baseRest(function(args){args.push(undefined,customDefaultsMerge);return apply(mergeWith,undefined,args);});/**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */function findKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwn);}/**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */function findLastKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwnRight);}/**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */function forIn(object,iteratee){return object==null?object:baseFor(object,getIteratee(iteratee,3),keysIn);}/**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */function forInRight(object,iteratee){return object==null?object:baseForRight(object,getIteratee(iteratee,3),keysIn);}/**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */function forOwn(object,iteratee){return object&&baseForOwn(object,getIteratee(iteratee,3));}/**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */function forOwnRight(object,iteratee){return object&&baseForOwnRight(object,getIteratee(iteratee,3));}/**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */function functions(object){return object==null?[]:baseFunctions(object,keys(object));}/**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */function functionsIn(object){return object==null?[]:baseFunctions(object,keysIn(object));}/**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */function get(object,path,defaultValue){var result=object==null?undefined:baseGet(object,path);return result===undefined?defaultValue:result;}/**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */function has(object,path){return object!=null&&hasPath(object,path,baseHas);}/**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */function hasIn(object,path){return object!=null&&hasPath(object,path,baseHasIn);}/**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */var invert=createInverter(function(result,value,key){if(value!=null&&typeof value.toString!='function'){value=nativeObjectToString.call(value);}result[value]=key;},constant(identity));/**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */var invertBy=createInverter(function(result,value,key){if(value!=null&&typeof value.toString!='function'){value=nativeObjectToString.call(value);}if(hasOwnProperty.call(result,value)){result[value].push(key);}else{result[value]=[key];}},getIteratee);/**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */var invoke=baseRest(baseInvoke);/**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */function keys(object){return isArrayLike(object)?arrayLikeKeys(object):baseKeys(object);}/**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */function keysIn(object){return isArrayLike(object)?arrayLikeKeys(object,true):baseKeysIn(object);}/**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */function mapKeys(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,iteratee(value,key,object),value);});return result;}/**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */function mapValues(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,key,iteratee(value,key,object));});return result;}/**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */var merge=createAssigner(function(object,source,srcIndex){baseMerge(object,source,srcIndex);});/**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */var mergeWith=createAssigner(function(object,source,srcIndex,customizer){baseMerge(object,source,srcIndex,customizer);});/**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */var omit=flatRest(function(object,paths){var result={};if(object==null){return result;}var isDeep=false;paths=arrayMap(paths,function(path){path=castPath(path,object);isDeep||(isDeep=path.length>1);return path;});copyObject(object,getAllKeysIn(object),result);if(isDeep){result=baseClone(result,CLONE_DEEP_FLAG|CLONE_FLAT_FLAG|CLONE_SYMBOLS_FLAG,customOmitClone);}var length=paths.length;while(length--){baseUnset(result,paths[length]);}return result;});/**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */function omitBy(object,predicate){return pickBy(object,negate(getIteratee(predicate)));}/**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */var pick=flatRest(function(object,paths){return object==null?{}:basePick(object,paths);});/**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */function pickBy(object,predicate){if(object==null){return{};}var props=arrayMap(getAllKeysIn(object),function(prop){return[prop];});predicate=getIteratee(predicate);return basePickBy(object,props,function(value,path){return predicate(value,path[0]);});}/**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */function result(object,path,defaultValue){path=castPath(path,object);var index=-1,length=path.length;// Ensure the loop is entered when path is empty.
if(!length){length=1;object=undefined;}while(++index<length){var value=object==null?undefined:object[toKey(path[index])];if(value===undefined){index=length;value=defaultValue;}object=isFunction(value)?value.call(object):value;}return object;}/**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */function set(object,path,value){return object==null?object:baseSet(object,path,value);}/**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */function setWith(object,path,value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return object==null?object:baseSet(object,path,value,customizer);}/**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */var toPairs=createToPairs(keys);/**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */var toPairsIn=createToPairs(keysIn);/**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */function transform(object,iteratee,accumulator){var isArr=isArray(object),isArrLike=isArr||isBuffer(object)||isTypedArray(object);iteratee=getIteratee(iteratee,4);if(accumulator==null){var Ctor=object&&object.constructor;if(isArrLike){accumulator=isArr?new Ctor():[];}else if(isObject(object)){accumulator=isFunction(Ctor)?baseCreate(getPrototype(object)):{};}else{accumulator={};}}(isArrLike?arrayEach:baseForOwn)(object,function(value,index,object){return iteratee(accumulator,value,index,object);});return accumulator;}/**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */function unset(object,path){return object==null?true:baseUnset(object,path);}/**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */function update(object,path,updater){return object==null?object:baseUpdate(object,path,castFunction(updater));}/**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */function updateWith(object,path,updater,customizer){customizer=typeof customizer=='function'?customizer:undefined;return object==null?object:baseUpdate(object,path,castFunction(updater),customizer);}/**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */function values(object){return object==null?[]:baseValues(object,keys(object));}/**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */function valuesIn(object){return object==null?[]:baseValues(object,keysIn(object));}/*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */function clamp(number,lower,upper){if(upper===undefined){upper=lower;lower=undefined;}if(upper!==undefined){upper=toNumber(upper);upper=upper===upper?upper:0;}if(lower!==undefined){lower=toNumber(lower);lower=lower===lower?lower:0;}return baseClamp(toNumber(number),lower,upper);}/**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */function inRange(number,start,end){start=toFinite(start);if(end===undefined){end=start;start=0;}else{end=toFinite(end);}number=toNumber(number);return baseInRange(number,start,end);}/**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */function random(lower,upper,floating){if(floating&&typeof floating!='boolean'&&isIterateeCall(lower,upper,floating)){upper=floating=undefined;}if(floating===undefined){if(typeof upper=='boolean'){floating=upper;upper=undefined;}else if(typeof lower=='boolean'){floating=lower;lower=undefined;}}if(lower===undefined&&upper===undefined){lower=0;upper=1;}else{lower=toFinite(lower);if(upper===undefined){upper=lower;lower=0;}else{upper=toFinite(upper);}}if(lower>upper){var temp=lower;lower=upper;upper=temp;}if(floating||lower%1||upper%1){var rand=nativeRandom();return nativeMin(lower+rand*(upper-lower+freeParseFloat('1e-'+((rand+'').length-1))),upper);}return baseRandom(lower,upper);}/*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */var camelCase=createCompounder(function(result,word,index){word=word.toLowerCase();return result+(index?capitalize(word):word);});/**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */function capitalize(string){return upperFirst(toString(string).toLowerCase());}/**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */function deburr(string){string=toString(string);return string&&string.replace(reLatin,deburrLetter).replace(reComboMark,'');}/**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */function endsWith(string,target,position){string=toString(string);target=baseToString(target);var length=string.length;position=position===undefined?length:baseClamp(toInteger(position),0,length);var end=position;position-=target.length;return position>=0&&string.slice(position,end)==target;}/**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */function escape(string){string=toString(string);return string&&reHasUnescapedHtml.test(string)?string.replace(reUnescapedHtml,escapeHtmlChar):string;}/**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */function escapeRegExp(string){string=toString(string);return string&&reHasRegExpChar.test(string)?string.replace(reRegExpChar,'\\$&'):string;}/**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */var kebabCase=createCompounder(function(result,word,index){return result+(index?'-':'')+word.toLowerCase();});/**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */var lowerCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toLowerCase();});/**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */var lowerFirst=createCaseFirst('toLowerCase');/**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */function pad(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;if(!length||strLength>=length){return string;}var mid=(length-strLength)/2;return createPadding(nativeFloor(mid),chars)+string+createPadding(nativeCeil(mid),chars);}/**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */function padEnd(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?string+createPadding(length-strLength,chars):string;}/**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */function padStart(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?createPadding(length-strLength,chars)+string:string;}/**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */function parseInt(string,radix,guard){if(guard||radix==null){radix=0;}else if(radix){radix=+radix;}return nativeParseInt(toString(string).replace(reTrimStart,''),radix||0);}/**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */function repeat(string,n,guard){if(guard?isIterateeCall(string,n,guard):n===undefined){n=1;}else{n=toInteger(n);}return baseRepeat(toString(string),n);}/**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */function replace(){var args=arguments,string=toString(args[0]);return args.length<3?string:string.replace(args[1],args[2]);}/**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */var snakeCase=createCompounder(function(result,word,index){return result+(index?'_':'')+word.toLowerCase();});/**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */function split(string,separator,limit){if(limit&&typeof limit!='number'&&isIterateeCall(string,separator,limit)){separator=limit=undefined;}limit=limit===undefined?MAX_ARRAY_LENGTH:limit>>>0;if(!limit){return[];}string=toString(string);if(string&&(typeof separator=='string'||separator!=null&&!isRegExp(separator))){separator=baseToString(separator);if(!separator&&hasUnicode(string)){return castSlice(stringToArray(string),0,limit);}}return string.split(separator,limit);}/**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */var startCase=createCompounder(function(result,word,index){return result+(index?' ':'')+upperFirst(word);});/**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */function startsWith(string,target,position){string=toString(string);position=position==null?0:baseClamp(toInteger(position),0,string.length);target=baseToString(target);return string.slice(position,position+target.length)==target;}/**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */function template(string,options,guard){// Based on John Resig's `tmpl` implementation
// (http://ejohn.org/blog/javascript-micro-templating/)
// and Laura Doktorova's doT.js (https://github.com/olado/doT).
var settings=lodash.templateSettings;if(guard&&isIterateeCall(string,options,guard)){options=undefined;}string=toString(string);options=assignInWith({},options,settings,customDefaultsAssignIn);var imports=assignInWith({},options.imports,settings.imports,customDefaultsAssignIn),importsKeys=keys(imports),importsValues=baseValues(imports,importsKeys);var isEscaping,isEvaluating,index=0,interpolate=options.interpolate||reNoMatch,source="__p += '";// Compile the regexp to match each delimiter.
var reDelimiters=RegExp((options.escape||reNoMatch).source+'|'+interpolate.source+'|'+(interpolate===reInterpolate?reEsTemplate:reNoMatch).source+'|'+(options.evaluate||reNoMatch).source+'|$','g');// Use a sourceURL for easier debugging.
// The sourceURL gets injected into the source that's eval-ed, so be careful
// to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
// and escape the comment, thus injecting code that gets evaled.
var sourceURL='//# sourceURL='+(hasOwnProperty.call(options,'sourceURL')?(options.sourceURL+'').replace(/\s/g,' '):'lodash.templateSources['+ ++templateCounter+']')+'\n';string.replace(reDelimiters,function(match,escapeValue,interpolateValue,esTemplateValue,evaluateValue,offset){interpolateValue||(interpolateValue=esTemplateValue);// Escape characters that can't be included in string literals.
source+=string.slice(index,offset).replace(reUnescapedString,escapeStringChar);// Replace delimiters with snippets.
if(escapeValue){isEscaping=true;source+="' +\n__e("+escapeValue+") +\n'";}if(evaluateValue){isEvaluating=true;source+="';\n"+evaluateValue+";\n__p += '";}if(interpolateValue){source+="' +\n((__t = ("+interpolateValue+")) == null ? '' : __t) +\n'";}index=offset+match.length;// The JS engine embedded in Adobe products needs `match` returned in
// order to produce the correct `offset` value.
return match;});source+="';\n";// If `variable` is not specified wrap a with-statement around the generated
// code to add the data object to the top of the scope chain.
var variable=hasOwnProperty.call(options,'variable')&&options.variable;if(!variable){source='with (obj) {\n'+source+'\n}\n';}// Throw an error if a forbidden character was found in `variable`, to prevent
// potential command injection attacks.
else if(reForbiddenIdentifierChars.test(variable)){throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);}// Cleanup code by stripping empty strings.
source=(isEvaluating?source.replace(reEmptyStringLeading,''):source).replace(reEmptyStringMiddle,'$1').replace(reEmptyStringTrailing,'$1;');// Frame code as the function body.
source='function('+(variable||'obj')+') {\n'+(variable?'':'obj || (obj = {});\n')+"var __t, __p = ''"+(isEscaping?', __e = _.escape':'')+(isEvaluating?', __j = Array.prototype.join;\n'+"function print() { __p += __j.call(arguments, '') }\n":';\n')+source+'return __p\n}';var result=attempt(function(){return Function(importsKeys,sourceURL+'return '+source).apply(undefined,importsValues);});// Provide the compiled function's source by its `toString` method or
// the `source` property as a convenience for inlining compiled templates.
result.source=source;if(isError(result)){throw result;}return result;}/**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */function toLower(value){return toString(value).toLowerCase();}/**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */function toUpper(value){return toString(value).toUpperCase();}/**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */function trim(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return baseTrim(string);}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),chrSymbols=stringToArray(chars),start=charsStartIndex(strSymbols,chrSymbols),end=charsEndIndex(strSymbols,chrSymbols)+1;return castSlice(strSymbols,start,end).join('');}/**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */function trimEnd(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.slice(0,trimmedEndIndex(string)+1);}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),end=charsEndIndex(strSymbols,stringToArray(chars))+1;return castSlice(strSymbols,0,end).join('');}/**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */function trimStart(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrimStart,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),start=charsStartIndex(strSymbols,stringToArray(chars));return castSlice(strSymbols,start).join('');}/**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */function truncate(string,options){var length=DEFAULT_TRUNC_LENGTH,omission=DEFAULT_TRUNC_OMISSION;if(isObject(options)){var separator='separator'in options?options.separator:separator;length='length'in options?toInteger(options.length):length;omission='omission'in options?baseToString(options.omission):omission;}string=toString(string);var strLength=string.length;if(hasUnicode(string)){var strSymbols=stringToArray(string);strLength=strSymbols.length;}if(length>=strLength){return string;}var end=length-stringSize(omission);if(end<1){return omission;}var result=strSymbols?castSlice(strSymbols,0,end).join(''):string.slice(0,end);if(separator===undefined){return result+omission;}if(strSymbols){end+=result.length-end;}if(isRegExp(separator)){if(string.slice(end).search(separator)){var match,substring=result;if(!separator.global){separator=RegExp(separator.source,toString(reFlags.exec(separator))+'g');}separator.lastIndex=0;while(match=separator.exec(substring)){var newEnd=match.index;}result=result.slice(0,newEnd===undefined?end:newEnd);}}else if(string.indexOf(baseToString(separator),end)!=end){var index=result.lastIndexOf(separator);if(index>-1){result=result.slice(0,index);}}return result+omission;}/**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */function unescape(string){string=toString(string);return string&&reHasEscapedHtml.test(string)?string.replace(reEscapedHtml,unescapeHtmlChar):string;}/**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */var upperCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toUpperCase();});/**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */var upperFirst=createCaseFirst('toUpperCase');/**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */function words(string,pattern,guard){string=toString(string);pattern=guard?undefined:pattern;if(pattern===undefined){return hasUnicodeWord(string)?unicodeWords(string):asciiWords(string);}return string.match(pattern)||[];}/*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */var attempt=baseRest(function(func,args){try{return apply(func,undefined,args);}catch(e){return isError(e)?e:new Error(e);}});/**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */var bindAll=flatRest(function(object,methodNames){arrayEach(methodNames,function(key){key=toKey(key);baseAssignValue(object,key,bind(object[key],object));});return object;});/**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */function cond(pairs){var length=pairs==null?0:pairs.length,toIteratee=getIteratee();pairs=!length?[]:arrayMap(pairs,function(pair){if(typeof pair[1]!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return[toIteratee(pair[0]),pair[1]];});return baseRest(function(args){var index=-1;while(++index<length){var pair=pairs[index];if(apply(pair[0],this,args)){return apply(pair[1],this,args);}}});}/**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */function conforms(source){return baseConforms(baseClone(source,CLONE_DEEP_FLAG));}/**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */function constant(value){return function(){return value;};}/**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */function defaultTo(value,defaultValue){return value==null||value!==value?defaultValue:value;}/**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */var flow=createFlow();/**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */var flowRight=createFlow(true);/**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */function identity(value){return value;}/**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */function iteratee(func){return baseIteratee(typeof func=='function'?func:baseClone(func,CLONE_DEEP_FLAG));}/**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */function matches(source){return baseMatches(baseClone(source,CLONE_DEEP_FLAG));}/**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */function matchesProperty(path,srcValue){return baseMatchesProperty(path,baseClone(srcValue,CLONE_DEEP_FLAG));}/**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */var method=baseRest(function(path,args){return function(object){return baseInvoke(object,path,args);};});/**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */var methodOf=baseRest(function(object,args){return function(path){return baseInvoke(object,path,args);};});/**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */function mixin(object,source,options){var props=keys(source),methodNames=baseFunctions(source,props);if(options==null&&!(isObject(source)&&(methodNames.length||!props.length))){options=source;source=object;object=this;methodNames=baseFunctions(source,keys(source));}var chain=!(isObject(options)&&'chain'in options)||!!options.chain,isFunc=isFunction(object);arrayEach(methodNames,function(methodName){var func=source[methodName];object[methodName]=func;if(isFunc){object.prototype[methodName]=function(){var chainAll=this.__chain__;if(chain||chainAll){var result=object(this.__wrapped__),actions=result.__actions__=copyArray(this.__actions__);actions.push({'func':func,'args':arguments,'thisArg':object});result.__chain__=chainAll;return result;}return func.apply(object,arrayPush([this.value()],arguments));};}});return object;}/**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */function noConflict(){if(root._===this){root._=oldDash;}return this;}/**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */function noop(){// No operation performed.
}/**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */function nthArg(n){n=toInteger(n);return baseRest(function(args){return baseNth(args,n);});}/**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */var over=createOver(arrayMap);/**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */var overEvery=createOver(arrayEvery);/**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */var overSome=createOver(arraySome);/**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */function property(path){return isKey(path)?baseProperty(toKey(path)):basePropertyDeep(path);}/**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */function propertyOf(object){return function(path){return object==null?undefined:baseGet(object,path);};}/**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */var range=createRange();/**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */var rangeRight=createRange(true);/**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */function stubArray(){return[];}/**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */function stubFalse(){return false;}/**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */function stubObject(){return{};}/**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */function stubString(){return'';}/**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */function stubTrue(){return true;}/**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */function times(n,iteratee){n=toInteger(n);if(n<1||n>MAX_SAFE_INTEGER){return[];}var index=MAX_ARRAY_LENGTH,length=nativeMin(n,MAX_ARRAY_LENGTH);iteratee=getIteratee(iteratee);n-=MAX_ARRAY_LENGTH;var result=baseTimes(length,iteratee);while(++index<n){iteratee(index);}return result;}/**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */function toPath(value){if(isArray(value)){return arrayMap(value,toKey);}return isSymbol(value)?[value]:copyArray(stringToPath(toString(value)));}/**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */function uniqueId(prefix){var id=++idCounter;return toString(prefix)+id;}/*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */var add=createMathOperation(function(augend,addend){return augend+addend;},0);/**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */var ceil=createRound('ceil');/**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */var divide=createMathOperation(function(dividend,divisor){return dividend/divisor;},1);/**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */var floor=createRound('floor');/**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */function max(array){return array&&array.length?baseExtremum(array,identity,baseGt):undefined;}/**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */function maxBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseGt):undefined;}/**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */function mean(array){return baseMean(array,identity);}/**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */function meanBy(array,iteratee){return baseMean(array,getIteratee(iteratee,2));}/**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */function min(array){return array&&array.length?baseExtremum(array,identity,baseLt):undefined;}/**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */function minBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseLt):undefined;}/**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */var multiply=createMathOperation(function(multiplier,multiplicand){return multiplier*multiplicand;},1);/**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */var round=createRound('round');/**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */var subtract=createMathOperation(function(minuend,subtrahend){return minuend-subtrahend;},0);/**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */function sum(array){return array&&array.length?baseSum(array,identity):0;}/**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */function sumBy(array,iteratee){return array&&array.length?baseSum(array,getIteratee(iteratee,2)):0;}/*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
lodash.after=after;lodash.ary=ary;lodash.assign=assign;lodash.assignIn=assignIn;lodash.assignInWith=assignInWith;lodash.assignWith=assignWith;lodash.at=at;lodash.before=before;lodash.bind=bind;lodash.bindAll=bindAll;lodash.bindKey=bindKey;lodash.castArray=castArray;lodash.chain=chain;lodash.chunk=chunk;lodash.compact=compact;lodash.concat=concat;lodash.cond=cond;lodash.conforms=conforms;lodash.constant=constant;lodash.countBy=countBy;lodash.create=create;lodash.curry=curry;lodash.curryRight=curryRight;lodash.debounce=debounce;lodash.defaults=defaults;lodash.defaultsDeep=defaultsDeep;lodash.defer=defer;lodash.delay=delay;lodash.difference=difference;lodash.differenceBy=differenceBy;lodash.differenceWith=differenceWith;lodash.drop=drop;lodash.dropRight=dropRight;lodash.dropRightWhile=dropRightWhile;lodash.dropWhile=dropWhile;lodash.fill=fill;lodash.filter=filter;lodash.flatMap=flatMap;lodash.flatMapDeep=flatMapDeep;lodash.flatMapDepth=flatMapDepth;lodash.flatten=flatten;lodash.flattenDeep=flattenDeep;lodash.flattenDepth=flattenDepth;lodash.flip=flip;lodash.flow=flow;lodash.flowRight=flowRight;lodash.fromPairs=fromPairs;lodash.functions=functions;lodash.functionsIn=functionsIn;lodash.groupBy=groupBy;lodash.initial=initial;lodash.intersection=intersection;lodash.intersectionBy=intersectionBy;lodash.intersectionWith=intersectionWith;lodash.invert=invert;lodash.invertBy=invertBy;lodash.invokeMap=invokeMap;lodash.iteratee=iteratee;lodash.keyBy=keyBy;lodash.keys=keys;lodash.keysIn=keysIn;lodash.map=map;lodash.mapKeys=mapKeys;lodash.mapValues=mapValues;lodash.matches=matches;lodash.matchesProperty=matchesProperty;lodash.memoize=memoize;lodash.merge=merge;lodash.mergeWith=mergeWith;lodash.method=method;lodash.methodOf=methodOf;lodash.mixin=mixin;lodash.negate=negate;lodash.nthArg=nthArg;lodash.omit=omit;lodash.omitBy=omitBy;lodash.once=once;lodash.orderBy=orderBy;lodash.over=over;lodash.overArgs=overArgs;lodash.overEvery=overEvery;lodash.overSome=overSome;lodash.partial=partial;lodash.partialRight=partialRight;lodash.partition=partition;lodash.pick=pick;lodash.pickBy=pickBy;lodash.property=property;lodash.propertyOf=propertyOf;lodash.pull=pull;lodash.pullAll=pullAll;lodash.pullAllBy=pullAllBy;lodash.pullAllWith=pullAllWith;lodash.pullAt=pullAt;lodash.range=range;lodash.rangeRight=rangeRight;lodash.rearg=rearg;lodash.reject=reject;lodash.remove=remove;lodash.rest=rest;lodash.reverse=reverse;lodash.sampleSize=sampleSize;lodash.set=set;lodash.setWith=setWith;lodash.shuffle=shuffle;lodash.slice=slice;lodash.sortBy=sortBy;lodash.sortedUniq=sortedUniq;lodash.sortedUniqBy=sortedUniqBy;lodash.split=split;lodash.spread=spread;lodash.tail=tail;lodash.take=take;lodash.takeRight=takeRight;lodash.takeRightWhile=takeRightWhile;lodash.takeWhile=takeWhile;lodash.tap=tap;lodash.throttle=throttle;lodash.thru=thru;lodash.toArray=toArray;lodash.toPairs=toPairs;lodash.toPairsIn=toPairsIn;lodash.toPath=toPath;lodash.toPlainObject=toPlainObject;lodash.transform=transform;lodash.unary=unary;lodash.union=union;lodash.unionBy=unionBy;lodash.unionWith=unionWith;lodash.uniq=uniq;lodash.uniqBy=uniqBy;lodash.uniqWith=uniqWith;lodash.unset=unset;lodash.unzip=unzip;lodash.unzipWith=unzipWith;lodash.update=update;lodash.updateWith=updateWith;lodash.values=values;lodash.valuesIn=valuesIn;lodash.without=without;lodash.words=words;lodash.wrap=wrap;lodash.xor=xor;lodash.xorBy=xorBy;lodash.xorWith=xorWith;lodash.zip=zip;lodash.zipObject=zipObject;lodash.zipObjectDeep=zipObjectDeep;lodash.zipWith=zipWith;// Add aliases.
lodash.entries=toPairs;lodash.entriesIn=toPairsIn;lodash.extend=assignIn;lodash.extendWith=assignInWith;// Add methods to `lodash.prototype`.
mixin(lodash,lodash);/*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
lodash.add=add;lodash.attempt=attempt;lodash.camelCase=camelCase;lodash.capitalize=capitalize;lodash.ceil=ceil;lodash.clamp=clamp;lodash.clone=clone;lodash.cloneDeep=cloneDeep;lodash.cloneDeepWith=cloneDeepWith;lodash.cloneWith=cloneWith;lodash.conformsTo=conformsTo;lodash.deburr=deburr;lodash.defaultTo=defaultTo;lodash.divide=divide;lodash.endsWith=endsWith;lodash.eq=eq;lodash.escape=escape;lodash.escapeRegExp=escapeRegExp;lodash.every=every;lodash.find=find;lodash.findIndex=findIndex;lodash.findKey=findKey;lodash.findLast=findLast;lodash.findLastIndex=findLastIndex;lodash.findLastKey=findLastKey;lodash.floor=floor;lodash.forEach=forEach;lodash.forEachRight=forEachRight;lodash.forIn=forIn;lodash.forInRight=forInRight;lodash.forOwn=forOwn;lodash.forOwnRight=forOwnRight;lodash.get=get;lodash.gt=gt;lodash.gte=gte;lodash.has=has;lodash.hasIn=hasIn;lodash.head=head;lodash.identity=identity;lodash.includes=includes;lodash.indexOf=indexOf;lodash.inRange=inRange;lodash.invoke=invoke;lodash.isArguments=isArguments;lodash.isArray=isArray;lodash.isArrayBuffer=isArrayBuffer;lodash.isArrayLike=isArrayLike;lodash.isArrayLikeObject=isArrayLikeObject;lodash.isBoolean=isBoolean;lodash.isBuffer=isBuffer;lodash.isDate=isDate;lodash.isElement=isElement;lodash.isEmpty=isEmpty;lodash.isEqual=isEqual;lodash.isEqualWith=isEqualWith;lodash.isError=isError;lodash.isFinite=isFinite;lodash.isFunction=isFunction;lodash.isInteger=isInteger;lodash.isLength=isLength;lodash.isMap=isMap;lodash.isMatch=isMatch;lodash.isMatchWith=isMatchWith;lodash.isNaN=isNaN;lodash.isNative=isNative;lodash.isNil=isNil;lodash.isNull=isNull;lodash.isNumber=isNumber;lodash.isObject=isObject;lodash.isObjectLike=isObjectLike;lodash.isPlainObject=isPlainObject;lodash.isRegExp=isRegExp;lodash.isSafeInteger=isSafeInteger;lodash.isSet=isSet;lodash.isString=isString;lodash.isSymbol=isSymbol;lodash.isTypedArray=isTypedArray;lodash.isUndefined=isUndefined;lodash.isWeakMap=isWeakMap;lodash.isWeakSet=isWeakSet;lodash.join=join;lodash.kebabCase=kebabCase;lodash.last=last;lodash.lastIndexOf=lastIndexOf;lodash.lowerCase=lowerCase;lodash.lowerFirst=lowerFirst;lodash.lt=lt;lodash.lte=lte;lodash.max=max;lodash.maxBy=maxBy;lodash.mean=mean;lodash.meanBy=meanBy;lodash.min=min;lodash.minBy=minBy;lodash.stubArray=stubArray;lodash.stubFalse=stubFalse;lodash.stubObject=stubObject;lodash.stubString=stubString;lodash.stubTrue=stubTrue;lodash.multiply=multiply;lodash.nth=nth;lodash.noConflict=noConflict;lodash.noop=noop;lodash.now=now;lodash.pad=pad;lodash.padEnd=padEnd;lodash.padStart=padStart;lodash.parseInt=parseInt;lodash.random=random;lodash.reduce=reduce;lodash.reduceRight=reduceRight;lodash.repeat=repeat;lodash.replace=replace;lodash.result=result;lodash.round=round;lodash.runInContext=runInContext;lodash.sample=sample;lodash.size=size;lodash.snakeCase=snakeCase;lodash.some=some;lodash.sortedIndex=sortedIndex;lodash.sortedIndexBy=sortedIndexBy;lodash.sortedIndexOf=sortedIndexOf;lodash.sortedLastIndex=sortedLastIndex;lodash.sortedLastIndexBy=sortedLastIndexBy;lodash.sortedLastIndexOf=sortedLastIndexOf;lodash.startCase=startCase;lodash.startsWith=startsWith;lodash.subtract=subtract;lodash.sum=sum;lodash.sumBy=sumBy;lodash.template=template;lodash.times=times;lodash.toFinite=toFinite;lodash.toInteger=toInteger;lodash.toLength=toLength;lodash.toLower=toLower;lodash.toNumber=toNumber;lodash.toSafeInteger=toSafeInteger;lodash.toString=toString;lodash.toUpper=toUpper;lodash.trim=trim;lodash.trimEnd=trimEnd;lodash.trimStart=trimStart;lodash.truncate=truncate;lodash.unescape=unescape;lodash.uniqueId=uniqueId;lodash.upperCase=upperCase;lodash.upperFirst=upperFirst;// Add aliases.
lodash.each=forEach;lodash.eachRight=forEachRight;lodash.first=head;mixin(lodash,function(){var source={};baseForOwn(lodash,function(func,methodName){if(!hasOwnProperty.call(lodash.prototype,methodName)){source[methodName]=func;}});return source;}(),{'chain':false});/*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */lodash.VERSION=VERSION;// Assign default placeholders.
arrayEach(['bind','bindKey','curry','curryRight','partial','partialRight'],function(methodName){lodash[methodName].placeholder=lodash;});// Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
arrayEach(['drop','take'],function(methodName,index){LazyWrapper.prototype[methodName]=function(n){n=n===undefined?1:nativeMax(toInteger(n),0);var result=this.__filtered__&&!index?new LazyWrapper(this):this.clone();if(result.__filtered__){result.__takeCount__=nativeMin(n,result.__takeCount__);}else{result.__views__.push({'size':nativeMin(n,MAX_ARRAY_LENGTH),'type':methodName+(result.__dir__<0?'Right':'')});}return result;};LazyWrapper.prototype[methodName+'Right']=function(n){return this.reverse()[methodName](n).reverse();};});// Add `LazyWrapper` methods that accept an `iteratee` value.
arrayEach(['filter','map','takeWhile'],function(methodName,index){var type=index+1,isFilter=type==LAZY_FILTER_FLAG||type==LAZY_WHILE_FLAG;LazyWrapper.prototype[methodName]=function(iteratee){var result=this.clone();result.__iteratees__.push({'iteratee':getIteratee(iteratee,3),'type':type});result.__filtered__=result.__filtered__||isFilter;return result;};});// Add `LazyWrapper` methods for `_.head` and `_.last`.
arrayEach(['head','last'],function(methodName,index){var takeName='take'+(index?'Right':'');LazyWrapper.prototype[methodName]=function(){return this[takeName](1).value()[0];};});// Add `LazyWrapper` methods for `_.initial` and `_.tail`.
arrayEach(['initial','tail'],function(methodName,index){var dropName='drop'+(index?'':'Right');LazyWrapper.prototype[methodName]=function(){return this.__filtered__?new LazyWrapper(this):this[dropName](1);};});LazyWrapper.prototype.compact=function(){return this.filter(identity);};LazyWrapper.prototype.find=function(predicate){return this.filter(predicate).head();};LazyWrapper.prototype.findLast=function(predicate){return this.reverse().find(predicate);};LazyWrapper.prototype.invokeMap=baseRest(function(path,args){if(typeof path=='function'){return new LazyWrapper(this);}return this.map(function(value){return baseInvoke(value,path,args);});});LazyWrapper.prototype.reject=function(predicate){return this.filter(negate(getIteratee(predicate)));};LazyWrapper.prototype.slice=function(start,end){start=toInteger(start);var result=this;if(result.__filtered__&&(start>0||end<0)){return new LazyWrapper(result);}if(start<0){result=result.takeRight(-start);}else if(start){result=result.drop(start);}if(end!==undefined){end=toInteger(end);result=end<0?result.dropRight(-end):result.take(end-start);}return result;};LazyWrapper.prototype.takeRightWhile=function(predicate){return this.reverse().takeWhile(predicate).reverse();};LazyWrapper.prototype.toArray=function(){return this.take(MAX_ARRAY_LENGTH);};// Add `LazyWrapper` methods to `lodash.prototype`.
baseForOwn(LazyWrapper.prototype,function(func,methodName){var checkIteratee=/^(?:filter|find|map|reject)|While$/.test(methodName),isTaker=/^(?:head|last)$/.test(methodName),lodashFunc=lodash[isTaker?'take'+(methodName=='last'?'Right':''):methodName],retUnwrapped=isTaker||/^find/.test(methodName);if(!lodashFunc){return;}lodash.prototype[methodName]=function(){var value=this.__wrapped__,args=isTaker?[1]:arguments,isLazy=value instanceof LazyWrapper,iteratee=args[0],useLazy=isLazy||isArray(value);var interceptor=function interceptor(value){var result=lodashFunc.apply(lodash,arrayPush([value],args));return isTaker&&chainAll?result[0]:result;};if(useLazy&&checkIteratee&&typeof iteratee=='function'&&iteratee.length!=1){// Avoid lazy use if the iteratee has a "length" value other than `1`.
isLazy=useLazy=false;}var chainAll=this.__chain__,isHybrid=!!this.__actions__.length,isUnwrapped=retUnwrapped&&!chainAll,onlyLazy=isLazy&&!isHybrid;if(!retUnwrapped&&useLazy){value=onlyLazy?value:new LazyWrapper(this);var result=func.apply(value,args);result.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined});return new LodashWrapper(result,chainAll);}if(isUnwrapped&&onlyLazy){return func.apply(this,args);}result=this.thru(interceptor);return isUnwrapped?isTaker?result.value()[0]:result.value():result;};});// Add `Array` methods to `lodash.prototype`.
arrayEach(['pop','push','shift','sort','splice','unshift'],function(methodName){var func=arrayProto[methodName],chainName=/^(?:push|sort|unshift)$/.test(methodName)?'tap':'thru',retUnwrapped=/^(?:pop|shift)$/.test(methodName);lodash.prototype[methodName]=function(){var args=arguments;if(retUnwrapped&&!this.__chain__){var value=this.value();return func.apply(isArray(value)?value:[],args);}return this[chainName](function(value){return func.apply(isArray(value)?value:[],args);});};});// Map minified method names to their real names.
baseForOwn(LazyWrapper.prototype,function(func,methodName){var lodashFunc=lodash[methodName];if(lodashFunc){var key=lodashFunc.name+'';if(!hasOwnProperty.call(realNames,key)){realNames[key]=[];}realNames[key].push({'name':methodName,'func':lodashFunc});}});realNames[createHybrid(undefined,WRAP_BIND_KEY_FLAG).name]=[{'name':'wrapper','func':undefined}];// Add methods to `LazyWrapper`.
LazyWrapper.prototype.clone=lazyClone;LazyWrapper.prototype.reverse=lazyReverse;LazyWrapper.prototype.value=lazyValue;// Add chain sequence methods to the `lodash` wrapper.
lodash.prototype.at=wrapperAt;lodash.prototype.chain=wrapperChain;lodash.prototype.commit=wrapperCommit;lodash.prototype.next=wrapperNext;lodash.prototype.plant=wrapperPlant;lodash.prototype.reverse=wrapperReverse;lodash.prototype.toJSON=lodash.prototype.valueOf=lodash.prototype.value=wrapperValue;// Add lazy aliases.
lodash.prototype.first=lodash.prototype.head;if(symIterator){lodash.prototype[symIterator]=wrapperToIterator;}return lodash;};/*--------------------------------------------------------------------------*/ // Export lodash.
var _=runInContext();// Some AMD build optimizers, like r.js, check for condition patterns like:
if( true&&_typeof(__webpack_require__.amdO)=='object'&&__webpack_require__.amdO){// Expose Lodash on the global object to prevent errors when Lodash is
// loaded by a script tag in the presence of an AMD loader.
// See http://requirejs.org/docs/errors.html#mismatch for more details.
// Use `_.noConflict` to remove Lodash from the global object.
root._=_;// Define as an anonymous module so, through path mapping, it can be
// referenced as the "underscore" module.
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return _;}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}// Check for `exports` after `define` in case a build optimizer adds it.
else if(freeModule){// Export for Node.js.
(freeModule.exports=_)._=_;// Export for CommonJS support.
freeExports._=_;}else{// Export to the global object.
root._=_;}}).call(this);

/***/ }),

/***/ 57115:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(19601);
__webpack_require__(47042);
__webpack_require__(54747);
__webpack_require__(57327);
__webpack_require__(73210);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(47941);
__webpack_require__(24603);
__webpack_require__(39714);
__webpack_require__(69600);
__webpack_require__(23123);
__webpack_require__(2707);
__webpack_require__(9653);
__webpack_require__(92222);
function _typeof2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }
/*!***************************************************
* mark.js v8.11.1
* https://markjs.io/
* Copyright (c) 2014–2018, Julian Kühnel
* Released under the MIT license https://git.io/vwTVl
*****************************************************/

(function (global, factory) {
  ( false ? 0 : _typeof2(exports)) === 'object' && "object" !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : 0;
})(this, function () {
  'use strict';

  var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
    return _typeof2(obj);
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
  };
  var classCallCheck = function classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };
  var createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  var DOMIterator = function () {
    function DOMIterator(ctx) {
      var iframes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var exclude = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var iframesTimeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 5000;
      classCallCheck(this, DOMIterator);
      this.ctx = ctx;
      this.iframes = iframes;
      this.exclude = exclude;
      this.iframesTimeout = iframesTimeout;
    }
    createClass(DOMIterator, [{
      key: 'getContexts',
      value: function getContexts() {
        var ctx = void 0,
          filteredCtx = [];
        if (typeof this.ctx === 'undefined' || !this.ctx) {
          ctx = [];
        } else if (NodeList.prototype.isPrototypeOf(this.ctx)) {
          ctx = Array.prototype.slice.call(this.ctx);
        } else if (Array.isArray(this.ctx)) {
          ctx = this.ctx;
        } else if (typeof this.ctx === 'string') {
          ctx = Array.prototype.slice.call(document.querySelectorAll(this.ctx));
        } else {
          ctx = [this.ctx];
        }
        ctx.forEach(function (ctx) {
          var isDescendant = filteredCtx.filter(function (contexts) {
            return contexts.contains(ctx);
          }).length > 0;
          if (filteredCtx.indexOf(ctx) === -1 && !isDescendant) {
            filteredCtx.push(ctx);
          }
        });
        return filteredCtx;
      }
    }, {
      key: 'getIframeContents',
      value: function getIframeContents(ifr, successFn) {
        var errorFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
        var doc = void 0;
        try {
          var ifrWin = ifr.contentWindow;
          doc = ifrWin.document;
          if (!ifrWin || !doc) {
            throw new Error('iframe inaccessible');
          }
        } catch (e) {
          errorFn();
        }
        if (doc) {
          successFn(doc);
        }
      }
    }, {
      key: 'isIframeBlank',
      value: function isIframeBlank(ifr) {
        var bl = 'about:blank',
          src = ifr.getAttribute('src').trim(),
          href = ifr.contentWindow.location.href;
        return href === bl && src !== bl && src;
      }
    }, {
      key: 'observeIframeLoad',
      value: function observeIframeLoad(ifr, successFn, errorFn) {
        var _this = this;
        var called = false,
          tout = null;
        var listener = function listener() {
          if (called) {
            return;
          }
          called = true;
          clearTimeout(tout);
          try {
            if (!_this.isIframeBlank(ifr)) {
              ifr.removeEventListener('load', listener);
              _this.getIframeContents(ifr, successFn, errorFn);
            }
          } catch (e) {
            errorFn();
          }
        };
        ifr.addEventListener('load', listener);
        tout = setTimeout(listener, this.iframesTimeout);
      }
    }, {
      key: 'onIframeReady',
      value: function onIframeReady(ifr, successFn, errorFn) {
        try {
          if (ifr.contentWindow.document.readyState === 'complete') {
            if (this.isIframeBlank(ifr)) {
              this.observeIframeLoad(ifr, successFn, errorFn);
            } else {
              this.getIframeContents(ifr, successFn, errorFn);
            }
          } else {
            this.observeIframeLoad(ifr, successFn, errorFn);
          }
        } catch (e) {
          errorFn();
        }
      }
    }, {
      key: 'waitForIframes',
      value: function waitForIframes(ctx, done) {
        var _this2 = this;
        var eachCalled = 0;
        this.forEachIframe(ctx, function () {
          return true;
        }, function (ifr) {
          eachCalled++;
          _this2.waitForIframes(ifr.querySelector('html'), function () {
            if (! --eachCalled) {
              done();
            }
          });
        }, function (handled) {
          if (!handled) {
            done();
          }
        });
      }
    }, {
      key: 'forEachIframe',
      value: function forEachIframe(ctx, filter, each) {
        var _this3 = this;
        var end = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
        var ifr = ctx.querySelectorAll('iframe'),
          open = ifr.length,
          handled = 0;
        ifr = Array.prototype.slice.call(ifr);
        var checkEnd = function checkEnd() {
          if (--open <= 0) {
            end(handled);
          }
        };
        if (!open) {
          checkEnd();
        }
        ifr.forEach(function (ifr) {
          if (DOMIterator.matches(ifr, _this3.exclude)) {
            checkEnd();
          } else {
            _this3.onIframeReady(ifr, function (con) {
              if (filter(ifr)) {
                handled++;
                each(con);
              }
              checkEnd();
            }, checkEnd);
          }
        });
      }
    }, {
      key: 'createIterator',
      value: function createIterator(ctx, whatToShow, filter) {
        return document.createNodeIterator(ctx, whatToShow, filter, false);
      }
    }, {
      key: 'createInstanceOnIframe',
      value: function createInstanceOnIframe(contents) {
        return new DOMIterator(contents.querySelector('html'), this.iframes);
      }
    }, {
      key: 'compareNodeIframe',
      value: function compareNodeIframe(node, prevNode, ifr) {
        var compCurr = node.compareDocumentPosition(ifr),
          prev = Node.DOCUMENT_POSITION_PRECEDING;
        if (compCurr & prev) {
          if (prevNode !== null) {
            var compPrev = prevNode.compareDocumentPosition(ifr),
              after = Node.DOCUMENT_POSITION_FOLLOWING;
            if (compPrev & after) {
              return true;
            }
          } else {
            return true;
          }
        }
        return false;
      }
    }, {
      key: 'getIteratorNode',
      value: function getIteratorNode(itr) {
        var prevNode = itr.previousNode();
        var node = void 0;
        if (prevNode === null) {
          node = itr.nextNode();
        } else {
          node = itr.nextNode() && itr.nextNode();
        }
        return {
          prevNode: prevNode,
          node: node
        };
      }
    }, {
      key: 'checkIframeFilter',
      value: function checkIframeFilter(node, prevNode, currIfr, ifr) {
        var key = false,
          handled = false;
        ifr.forEach(function (ifrDict, i) {
          if (ifrDict.val === currIfr) {
            key = i;
            handled = ifrDict.handled;
          }
        });
        if (this.compareNodeIframe(node, prevNode, currIfr)) {
          if (key === false && !handled) {
            ifr.push({
              val: currIfr,
              handled: true
            });
          } else if (key !== false && !handled) {
            ifr[key].handled = true;
          }
          return true;
        }
        if (key === false) {
          ifr.push({
            val: currIfr,
            handled: false
          });
        }
        return false;
      }
    }, {
      key: 'handleOpenIframes',
      value: function handleOpenIframes(ifr, whatToShow, eCb, fCb) {
        var _this4 = this;
        ifr.forEach(function (ifrDict) {
          if (!ifrDict.handled) {
            _this4.getIframeContents(ifrDict.val, function (con) {
              _this4.createInstanceOnIframe(con).forEachNode(whatToShow, eCb, fCb);
            });
          }
        });
      }
    }, {
      key: 'iterateThroughNodes',
      value: function iterateThroughNodes(whatToShow, ctx, eachCb, filterCb, doneCb) {
        var _this5 = this;
        var itr = this.createIterator(ctx, whatToShow, filterCb);
        var ifr = [],
          elements = [],
          node = void 0,
          prevNode = void 0,
          retrieveNodes = function retrieveNodes() {
            var _getIteratorNode = _this5.getIteratorNode(itr);
            prevNode = _getIteratorNode.prevNode;
            node = _getIteratorNode.node;
            return node;
          };
        while (retrieveNodes()) {
          if (this.iframes) {
            this.forEachIframe(ctx, function (currIfr) {
              return _this5.checkIframeFilter(node, prevNode, currIfr, ifr);
            }, function (con) {
              _this5.createInstanceOnIframe(con).forEachNode(whatToShow, function (ifrNode) {
                return elements.push(ifrNode);
              }, filterCb);
            });
          }
          elements.push(node);
        }
        elements.forEach(function (node) {
          eachCb(node);
        });
        if (this.iframes) {
          this.handleOpenIframes(ifr, whatToShow, eachCb, filterCb);
        }
        doneCb();
      }
    }, {
      key: 'forEachNode',
      value: function forEachNode(whatToShow, each, filter) {
        var _this6 = this;
        var done = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
        var contexts = this.getContexts();
        var open = contexts.length;
        if (!open) {
          done();
        }
        contexts.forEach(function (ctx) {
          var ready = function ready() {
            _this6.iterateThroughNodes(whatToShow, ctx, each, filter, function () {
              if (--open <= 0) {
                done();
              }
            });
          };
          if (_this6.iframes) {
            _this6.waitForIframes(ctx, ready);
          } else {
            ready();
          }
        });
      }
    }], [{
      key: 'matches',
      value: function matches(element, selector) {
        var selectors = typeof selector === 'string' ? [selector] : selector,
          fn = element.matches || element.matchesSelector || element.msMatchesSelector || element.mozMatchesSelector || element.oMatchesSelector || element.webkitMatchesSelector;
        if (fn) {
          var match = false;
          selectors.every(function (sel) {
            if (fn.call(element, sel)) {
              match = true;
              return false;
            }
            return true;
          });
          return match;
        } else {
          return false;
        }
      }
    }]);
    return DOMIterator;
  }();
  var Mark$1 = function () {
    function Mark(ctx) {
      classCallCheck(this, Mark);
      this.ctx = ctx;
      this.ie = false;
      var ua = window.navigator.userAgent;
      if (ua.indexOf('MSIE') > -1 || ua.indexOf('Trident') > -1) {
        this.ie = true;
      }
    }
    createClass(Mark, [{
      key: 'log',
      value: function log(msg) {
        var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'debug';
        var log = this.opt.log;
        if (!this.opt.debug) {
          return;
        }
        if ((typeof log === 'undefined' ? 'undefined' : _typeof(log)) === 'object' && typeof log[level] === 'function') {
          log[level]('mark.js: ' + msg);
        }
      }
    }, {
      key: 'escapeStr',
      value: function escapeStr(str) {
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
      }
    }, {
      key: 'createRegExp',
      value: function createRegExp(str) {
        if (this.opt.wildcards !== 'disabled') {
          str = this.setupWildcardsRegExp(str);
        }
        str = this.escapeStr(str);
        if (Object.keys(this.opt.synonyms).length) {
          str = this.createSynonymsRegExp(str);
        }
        if (this.opt.ignoreJoiners || this.opt.ignorePunctuation.length) {
          str = this.setupIgnoreJoinersRegExp(str);
        }
        if (this.opt.diacritics) {
          str = this.createDiacriticsRegExp(str);
        }
        str = this.createMergedBlanksRegExp(str);
        if (this.opt.ignoreJoiners || this.opt.ignorePunctuation.length) {
          str = this.createJoinersRegExp(str);
        }
        if (this.opt.wildcards !== 'disabled') {
          str = this.createWildcardsRegExp(str);
        }
        str = this.createAccuracyRegExp(str);
        return str;
      }
    }, {
      key: 'createSynonymsRegExp',
      value: function createSynonymsRegExp(str) {
        var syn = this.opt.synonyms,
          sens = this.opt.caseSensitive ? '' : 'i',
          joinerPlaceholder = this.opt.ignoreJoiners || this.opt.ignorePunctuation.length ? '\0' : '';
        for (var index in syn) {
          if (syn.hasOwnProperty(index)) {
            var value = syn[index],
              k1 = this.opt.wildcards !== 'disabled' ? this.setupWildcardsRegExp(index) : this.escapeStr(index),
              k2 = this.opt.wildcards !== 'disabled' ? this.setupWildcardsRegExp(value) : this.escapeStr(value);
            if (k1 !== '' && k2 !== '') {
              str = str.replace(new RegExp('(' + this.escapeStr(k1) + '|' + this.escapeStr(k2) + ')', 'gm' + sens), joinerPlaceholder + ('(' + this.processSynomyms(k1) + '|') + (this.processSynomyms(k2) + ')') + joinerPlaceholder);
            }
          }
        }
        return str;
      }
    }, {
      key: 'processSynomyms',
      value: function processSynomyms(str) {
        if (this.opt.ignoreJoiners || this.opt.ignorePunctuation.length) {
          str = this.setupIgnoreJoinersRegExp(str);
        }
        return str;
      }
    }, {
      key: 'setupWildcardsRegExp',
      value: function setupWildcardsRegExp(str) {
        str = str.replace(/(?:\\)*\?/g, function (val) {
          return val.charAt(0) === '\\' ? '?' : '\x01';
        });
        return str.replace(/(?:\\)*\*/g, function (val) {
          return val.charAt(0) === '\\' ? '*' : '\x02';
        });
      }
    }, {
      key: 'createWildcardsRegExp',
      value: function createWildcardsRegExp(str) {
        var spaces = this.opt.wildcards === 'withSpaces';
        return str.replace(/\u0001/g, spaces ? '[\\S\\s]?' : '\\S?').replace(/\u0002/g, spaces ? '[\\S\\s]*?' : '\\S*');
      }
    }, {
      key: 'setupIgnoreJoinersRegExp',
      value: function setupIgnoreJoinersRegExp(str) {
        return str.replace(/[^(|)\\]/g, function (val, indx, original) {
          var nextChar = original.charAt(indx + 1);
          if (/[(|)\\]/.test(nextChar) || nextChar === '') {
            return val;
          } else {
            return val + '\0';
          }
        });
      }
    }, {
      key: 'createJoinersRegExp',
      value: function createJoinersRegExp(str) {
        var joiner = [];
        var ignorePunctuation = this.opt.ignorePunctuation;
        if (Array.isArray(ignorePunctuation) && ignorePunctuation.length) {
          joiner.push(this.escapeStr(ignorePunctuation.join('')));
        }
        if (this.opt.ignoreJoiners) {
          joiner.push("\\u00ad\\u200b\\u200c\\u200d");
        }
        return joiner.length ? str.split(/\u0000+/).join('[' + joiner.join('') + ']*') : str;
      }
    }, {
      key: 'createDiacriticsRegExp',
      value: function createDiacriticsRegExp(str) {
        var sens = this.opt.caseSensitive ? '' : 'i',
          dct = this.opt.caseSensitive ? ['aàáảãạăằắẳẵặâầấẩẫậäåāą', 'AÀÁẢÃẠĂẰẮẲẴẶÂẦẤẨẪẬÄÅĀĄ', 'cçćč', 'CÇĆČ', 'dđď', 'DĐĎ', 'eèéẻẽẹêềếểễệëěēę', 'EÈÉẺẼẸÊỀẾỂỄỆËĚĒĘ', 'iìíỉĩịîïī', 'IÌÍỈĨỊÎÏĪ', 'lł', 'LŁ', 'nñňń', 'NÑŇŃ', 'oòóỏõọôồốổỗộơởỡớờợöøō', 'OÒÓỎÕỌÔỒỐỔỖỘƠỞỠỚỜỢÖØŌ', 'rř', 'RŘ', 'sšśșş', 'SŠŚȘŞ', 'tťțţ', 'TŤȚŢ', 'uùúủũụưừứửữựûüůū', 'UÙÚỦŨỤƯỪỨỬỮỰÛÜŮŪ', 'yýỳỷỹỵÿ', 'YÝỲỶỸỴŸ', 'zžżź', 'ZŽŻŹ'] : ['aàáảãạăằắẳẵặâầấẩẫậäåāąAÀÁẢÃẠĂẰẮẲẴẶÂẦẤẨẪẬÄÅĀĄ', 'cçćčCÇĆČ', 'dđďDĐĎ', 'eèéẻẽẹêềếểễệëěēęEÈÉẺẼẸÊỀẾỂỄỆËĚĒĘ', 'iìíỉĩịîïīIÌÍỈĨỊÎÏĪ', 'lłLŁ', 'nñňńNÑŇŃ', 'oòóỏõọôồốổỗộơởỡớờợöøōOÒÓỎÕỌÔỒỐỔỖỘƠỞỠỚỜỢÖØŌ', 'rřRŘ', 'sšśșşSŠŚȘŞ', 'tťțţTŤȚŢ', 'uùúủũụưừứửữựûüůūUÙÚỦŨỤƯỪỨỬỮỰÛÜŮŪ', 'yýỳỷỹỵÿYÝỲỶỸỴŸ', 'zžżźZŽŻŹ'];
        var handled = [];
        str.split('').forEach(function (ch) {
          dct.every(function (dct) {
            if (dct.indexOf(ch) !== -1) {
              if (handled.indexOf(dct) > -1) {
                return false;
              }
              str = str.replace(new RegExp('[' + dct + ']', 'gm' + sens), '[' + dct + ']');
              handled.push(dct);
            }
            return true;
          });
        });
        return str;
      }
    }, {
      key: 'createMergedBlanksRegExp',
      value: function createMergedBlanksRegExp(str) {
        return str.replace(/[\s]+/gmi, '[\\s]+');
      }
    }, {
      key: 'createAccuracyRegExp',
      value: function createAccuracyRegExp(str) {
        var _this = this;
        var chars = '!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~¡¿';
        var acc = this.opt.accuracy,
          val = typeof acc === 'string' ? acc : acc.value,
          ls = typeof acc === 'string' ? [] : acc.limiters,
          lsJoin = '';
        ls.forEach(function (limiter) {
          lsJoin += '|' + _this.escapeStr(limiter);
        });
        switch (val) {
          case 'partially':
          default:
            return '()(' + str + ')';
          case 'complementary':
            lsJoin = '\\s' + (lsJoin ? lsJoin : this.escapeStr(chars));
            return '()([^' + lsJoin + ']*' + str + '[^' + lsJoin + ']*)';
          case 'exactly':
            return '(^|\\s' + lsJoin + ')(' + str + ')(?=$|\\s' + lsJoin + ')';
        }
      }
    }, {
      key: 'getSeparatedKeywords',
      value: function getSeparatedKeywords(sv) {
        var _this2 = this;
        var stack = [];
        sv.forEach(function (kw) {
          if (!_this2.opt.separateWordSearch) {
            if (kw.trim() && stack.indexOf(kw) === -1) {
              stack.push(kw);
            }
          } else {
            kw.split(' ').forEach(function (kwSplitted) {
              if (kwSplitted.trim() && stack.indexOf(kwSplitted) === -1) {
                stack.push(kwSplitted);
              }
            });
          }
        });
        return {
          'keywords': stack.sort(function (a, b) {
            return b.length - a.length;
          }),
          'length': stack.length
        };
      }
    }, {
      key: 'isNumeric',
      value: function isNumeric(value) {
        return Number(parseFloat(value)) == value;
      }
    }, {
      key: 'checkRanges',
      value: function checkRanges(array) {
        var _this3 = this;
        if (!Array.isArray(array) || Object.prototype.toString.call(array[0]) !== '[object Object]') {
          this.log('markRanges() will only accept an array of objects');
          this.opt.noMatch(array);
          return [];
        }
        var stack = [];
        var last = 0;
        array.sort(function (a, b) {
          return a.start - b.start;
        }).forEach(function (item) {
          var _callNoMatchOnInvalid = _this3.callNoMatchOnInvalidRanges(item, last),
            start = _callNoMatchOnInvalid.start,
            end = _callNoMatchOnInvalid.end,
            valid = _callNoMatchOnInvalid.valid;
          if (valid) {
            item.start = start;
            item.length = end - start;
            stack.push(item);
            last = end;
          }
        });
        return stack;
      }
    }, {
      key: 'callNoMatchOnInvalidRanges',
      value: function callNoMatchOnInvalidRanges(range, last) {
        var start = void 0,
          end = void 0,
          valid = false;
        if (range && typeof range.start !== 'undefined') {
          start = parseInt(range.start, 10);
          end = start + parseInt(range.length, 10);
          if (this.isNumeric(range.start) && this.isNumeric(range.length) && end - last > 0 && end - start > 0) {
            valid = true;
          } else {
            this.log('Ignoring invalid or overlapping range: ' + ('' + JSON.stringify(range)));
            this.opt.noMatch(range);
          }
        } else {
          this.log('Ignoring invalid range: ' + JSON.stringify(range));
          this.opt.noMatch(range);
        }
        return {
          start: start,
          end: end,
          valid: valid
        };
      }
    }, {
      key: 'checkWhitespaceRanges',
      value: function checkWhitespaceRanges(range, originalLength, string) {
        var end = void 0,
          valid = true,
          max = string.length,
          offset = originalLength - max,
          start = parseInt(range.start, 10) - offset;
        start = start > max ? max : start;
        end = start + parseInt(range.length, 10);
        if (end > max) {
          end = max;
          this.log('End range automatically set to the max value of ' + max);
        }
        if (start < 0 || end - start < 0 || start > max || end > max) {
          valid = false;
          this.log('Invalid range: ' + JSON.stringify(range));
          this.opt.noMatch(range);
        } else if (string.substring(start, end).replace(/\s+/g, '') === '') {
          valid = false;
          this.log('Skipping whitespace only range: ' + JSON.stringify(range));
          this.opt.noMatch(range);
        }
        return {
          start: start,
          end: end,
          valid: valid
        };
      }
    }, {
      key: 'getTextNodes',
      value: function getTextNodes(cb) {
        var _this4 = this;
        var val = '',
          nodes = [];
        this.iterator.forEachNode(NodeFilter.SHOW_TEXT, function (node) {
          nodes.push({
            start: val.length,
            end: (val += node.textContent).length,
            node: node
          });
        }, function (node) {
          if (_this4.matchesExclude(node.parentNode)) {
            return NodeFilter.FILTER_REJECT;
          } else {
            return NodeFilter.FILTER_ACCEPT;
          }
        }, function () {
          cb({
            value: val,
            nodes: nodes
          });
        });
      }
    }, {
      key: 'matchesExclude',
      value: function matchesExclude(el) {
        return DOMIterator.matches(el, this.opt.exclude.concat(['script', 'style', 'title', 'head', 'html']));
      }
    }, {
      key: 'wrapRangeInTextNode',
      value: function wrapRangeInTextNode(node, start, end) {
        var hEl = !this.opt.element ? 'mark' : this.opt.element,
          startNode = node.splitText(start),
          ret = startNode.splitText(end - start);
        var repl = document.createElement(hEl);
        repl.setAttribute('data-markjs', 'true');
        if (this.opt.className) {
          repl.setAttribute('class', this.opt.className);
        }
        repl.textContent = startNode.textContent;
        startNode.parentNode.replaceChild(repl, startNode);
        return ret;
      }
    }, {
      key: 'wrapRangeInMappedTextNode',
      value: function wrapRangeInMappedTextNode(dict, start, end, filterCb, eachCb) {
        var _this5 = this;
        dict.nodes.every(function (n, i) {
          var sibl = dict.nodes[i + 1];
          if (typeof sibl === 'undefined' || sibl.start > start) {
            if (!filterCb(n.node)) {
              return false;
            }
            var s = start - n.start,
              e = (end > n.end ? n.end : end) - n.start,
              startStr = dict.value.substr(0, n.start),
              endStr = dict.value.substr(e + n.start);
            n.node = _this5.wrapRangeInTextNode(n.node, s, e);
            dict.value = startStr + endStr;
            dict.nodes.forEach(function (k, j) {
              if (j >= i) {
                if (dict.nodes[j].start > 0 && j !== i) {
                  dict.nodes[j].start -= e;
                }
                dict.nodes[j].end -= e;
              }
            });
            end -= e;
            eachCb(n.node.previousSibling, n.start);
            if (end > n.end) {
              start = n.end;
            } else {
              return false;
            }
          }
          return true;
        });
      }
    }, {
      key: 'wrapMatches',
      value: function wrapMatches(regex, ignoreGroups, filterCb, eachCb, endCb) {
        var _this6 = this;
        var matchIdx = ignoreGroups === 0 ? 0 : ignoreGroups + 1;
        this.getTextNodes(function (dict) {
          dict.nodes.forEach(function (node) {
            node = node.node;
            var match = void 0;
            while ((match = regex.exec(node.textContent)) !== null && match[matchIdx] !== '') {
              if (!filterCb(match[matchIdx], node)) {
                continue;
              }
              var pos = match.index;
              if (matchIdx !== 0) {
                for (var i = 1; i < matchIdx; i++) {
                  pos += match[i].length;
                }
              }
              node = _this6.wrapRangeInTextNode(node, pos, pos + match[matchIdx].length);
              eachCb(node.previousSibling);
              regex.lastIndex = 0;
            }
          });
          endCb();
        });
      }
    }, {
      key: 'wrapMatchesAcrossElements',
      value: function wrapMatchesAcrossElements(regex, ignoreGroups, filterCb, eachCb, endCb) {
        var _this7 = this;
        var matchIdx = ignoreGroups === 0 ? 0 : ignoreGroups + 1;
        this.getTextNodes(function (dict) {
          var match = void 0;
          while ((match = regex.exec(dict.value)) !== null && match[matchIdx] !== '') {
            var start = match.index;
            if (matchIdx !== 0) {
              for (var i = 1; i < matchIdx; i++) {
                start += match[i].length;
              }
            }
            var end = start + match[matchIdx].length;
            _this7.wrapRangeInMappedTextNode(dict, start, end, function (node) {
              return filterCb(match[matchIdx], node);
            }, function (node, lastIndex) {
              regex.lastIndex = lastIndex;
              eachCb(node);
            });
          }
          endCb();
        });
      }
    }, {
      key: 'wrapRangeFromIndex',
      value: function wrapRangeFromIndex(ranges, filterCb, eachCb, endCb) {
        var _this8 = this;
        this.getTextNodes(function (dict) {
          var originalLength = dict.value.length;
          ranges.forEach(function (range, counter) {
            var _checkWhitespaceRange = _this8.checkWhitespaceRanges(range, originalLength, dict.value),
              start = _checkWhitespaceRange.start,
              end = _checkWhitespaceRange.end,
              valid = _checkWhitespaceRange.valid;
            if (valid) {
              _this8.wrapRangeInMappedTextNode(dict, start, end, function (node) {
                return filterCb(node, range, dict.value.substring(start, end), counter);
              }, function (node) {
                eachCb(node, range);
              });
            }
          });
          endCb();
        });
      }
    }, {
      key: 'unwrapMatches',
      value: function unwrapMatches(node) {
        var parent = node.parentNode;
        var docFrag = document.createDocumentFragment();
        while (node.firstChild) {
          docFrag.appendChild(node.removeChild(node.firstChild));
        }
        parent.replaceChild(docFrag, node);
        if (!this.ie) {
          parent.normalize();
        } else {
          this.normalizeTextNode(parent);
        }
      }
    }, {
      key: 'normalizeTextNode',
      value: function normalizeTextNode(node) {
        if (!node) {
          return;
        }
        if (node.nodeType === 3) {
          while (node.nextSibling && node.nextSibling.nodeType === 3) {
            node.nodeValue += node.nextSibling.nodeValue;
            node.parentNode.removeChild(node.nextSibling);
          }
        } else {
          this.normalizeTextNode(node.firstChild);
        }
        this.normalizeTextNode(node.nextSibling);
      }
    }, {
      key: 'markRegExp',
      value: function markRegExp(regexp, opt) {
        var _this9 = this;
        this.opt = opt;
        this.log('Searching with expression "' + regexp + '"');
        var totalMatches = 0,
          fn = 'wrapMatches';
        var eachCb = function eachCb(element) {
          totalMatches++;
          _this9.opt.each(element);
        };
        if (this.opt.acrossElements) {
          fn = 'wrapMatchesAcrossElements';
        }
        this[fn](regexp, this.opt.ignoreGroups, function (match, node) {
          return _this9.opt.filter(node, match, totalMatches);
        }, eachCb, function () {
          if (totalMatches === 0) {
            _this9.opt.noMatch(regexp);
          }
          _this9.opt.done(totalMatches);
        });
      }
    }, {
      key: 'mark',
      value: function mark(sv, opt) {
        var _this10 = this;
        this.opt = opt;
        var totalMatches = 0,
          fn = 'wrapMatches';
        var _getSeparatedKeywords = this.getSeparatedKeywords(typeof sv === 'string' ? [sv] : sv),
          kwArr = _getSeparatedKeywords.keywords,
          kwArrLen = _getSeparatedKeywords.length,
          sens = this.opt.caseSensitive ? '' : 'i',
          handler = function handler(kw) {
            var regex = new RegExp(_this10.createRegExp(kw), 'gm' + sens),
              matches = 0;
            _this10.log('Searching with expression "' + regex + '"');
            _this10[fn](regex, 1, function (term, node) {
              return _this10.opt.filter(node, kw, totalMatches, matches);
            }, function (element) {
              matches++;
              totalMatches++;
              _this10.opt.each(element);
            }, function () {
              if (matches === 0) {
                _this10.opt.noMatch(kw);
              }
              if (kwArr[kwArrLen - 1] === kw) {
                _this10.opt.done(totalMatches);
              } else {
                handler(kwArr[kwArr.indexOf(kw) + 1]);
              }
            });
          };
        if (this.opt.acrossElements) {
          fn = 'wrapMatchesAcrossElements';
        }
        if (kwArrLen === 0) {
          this.opt.done(totalMatches);
        } else {
          handler(kwArr[0]);
        }
      }
    }, {
      key: 'markRanges',
      value: function markRanges(rawRanges, opt) {
        var _this11 = this;
        this.opt = opt;
        var totalMatches = 0,
          ranges = this.checkRanges(rawRanges);
        if (ranges && ranges.length) {
          this.log('Starting to mark with the following ranges: ' + JSON.stringify(ranges));
          this.wrapRangeFromIndex(ranges, function (node, range, match, counter) {
            return _this11.opt.filter(node, range, match, counter);
          }, function (element, range) {
            totalMatches++;
            _this11.opt.each(element, range);
          }, function () {
            _this11.opt.done(totalMatches);
          });
        } else {
          this.opt.done(totalMatches);
        }
      }
    }, {
      key: 'unmark',
      value: function unmark(opt) {
        var _this12 = this;
        this.opt = opt;
        var sel = this.opt.element ? this.opt.element : '*';
        sel += '[data-markjs]';
        if (this.opt.className) {
          sel += '.' + this.opt.className;
        }
        this.log('Removal selector "' + sel + '"');
        this.iterator.forEachNode(NodeFilter.SHOW_ELEMENT, function (node) {
          _this12.unwrapMatches(node);
        }, function (node) {
          var matchesSel = DOMIterator.matches(node, sel),
            matchesExclude = _this12.matchesExclude(node);
          if (!matchesSel || matchesExclude) {
            return NodeFilter.FILTER_REJECT;
          } else {
            return NodeFilter.FILTER_ACCEPT;
          }
        }, this.opt.done);
      }
    }, {
      key: 'opt',
      set: function set$$1(val) {
        this._opt = _extends({}, {
          'element': '',
          'className': '',
          'exclude': [],
          'iframes': false,
          'iframesTimeout': 5000,
          'separateWordSearch': true,
          'diacritics': true,
          'synonyms': {},
          'accuracy': 'partially',
          'acrossElements': false,
          'caseSensitive': false,
          'ignoreJoiners': false,
          'ignoreGroups': 0,
          'ignorePunctuation': [],
          'wildcards': 'disabled',
          'each': function each() {},
          'noMatch': function noMatch() {},
          'filter': function filter() {
            return true;
          },
          'done': function done() {},
          'debug': false,
          'log': window.console
        }, val);
      },
      get: function get$$1() {
        return this._opt;
      }
    }, {
      key: 'iterator',
      get: function get$$1() {
        return new DOMIterator(this.ctx, this.opt.iframes, this.opt.exclude, this.opt.iframesTimeout);
      }
    }]);
    return Mark;
  }();
  function Mark(ctx) {
    var _this = this;
    var instance = new Mark$1(ctx);
    this.mark = function (sv, opt) {
      instance.mark(sv, opt);
      return _this;
    };
    this.markRegExp = function (sv, opt) {
      instance.markRegExp(sv, opt);
      return _this;
    };
    this.markRanges = function (sv, opt) {
      instance.markRanges(sv, opt);
      return _this;
    };
    this.unmark = function (opt) {
      instance.unmark(opt);
      return _this;
    };
    return this;
  }
  return Mark;
});

/***/ }),

/***/ 8707:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = __webpack_require__(85855);

/***/ }),

/***/ 58565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// HTML5 entities map: { name -> utf16string }
//


/*eslint quotes:0*/
module.exports = __webpack_require__(95485);

/***/ }),

/***/ 35042:
/***/ ((module) => {

"use strict";
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks



module.exports = ['address', 'article', 'aside', 'base', 'basefont', 'blockquote', 'body', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dialog', 'dir', 'div', 'dl', 'dt', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hr', 'html', 'iframe', 'legend', 'li', 'link', 'main', 'menu', 'menuitem', 'nav', 'noframes', 'ol', 'optgroup', 'option', 'p', 'param', 'section', 'source', 'summary', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul'];

/***/ }),

/***/ 6251:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Regexps to match html elements



__webpack_require__(24603);
__webpack_require__(74916);
__webpack_require__(39714);
var attr_name = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
var unquoted = '[^"\'=<>`\\x00-\\x20]+';
var single_quoted = "'[^']*'";
var double_quoted = '"[^"]*"';
var attr_value = '(?:' + unquoted + '|' + single_quoted + '|' + double_quoted + ')';
var attribute = '(?:\\s+' + attr_name + '(?:\\s*=\\s*' + attr_value + ')?)';
var open_tag = '<[A-Za-z][A-Za-z0-9\\-]*' + attribute + '*\\s*\\/?>';
var close_tag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
var comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
var processing = '<[?][\\s\\S]*?[?]>';
var declaration = '<![A-Z]+\\s+[^>]*>';
var cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
var HTML_TAG_RE = new RegExp('^(?:' + open_tag + '|' + close_tag + '|' + comment + '|' + processing + '|' + declaration + '|' + cdata + ')');
var HTML_OPEN_CLOSE_TAG_RE = new RegExp('^(?:' + open_tag + '|' + close_tag + ')');
module.exports.n = HTML_TAG_RE;
module.exports.q = HTML_OPEN_CLOSE_TAG_RE;

/***/ }),

/***/ 14348:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// Utilities
//


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(41539);
__webpack_require__(47042);
__webpack_require__(54747);
__webpack_require__(47941);
__webpack_require__(92222);
__webpack_require__(24603);
__webpack_require__(74916);
__webpack_require__(39714);
__webpack_require__(15306);
__webpack_require__(73210);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _class(obj) {
  return Object.prototype.toString.call(obj);
}
function isString(obj) {
  return _class(obj) === '[object String]';
}
var _hasOwnProperty = Object.prototype.hasOwnProperty;
function has(object, key) {
  return _hasOwnProperty.call(object, key);
}

// Merge objects
//
function assign(obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);
  sources.forEach(function (source) {
    if (!source) {
      return;
    }
    if (_typeof(source) !== 'object') {
      throw new TypeError(source + 'must be object');
    }
    Object.keys(source).forEach(function (key) {
      obj[key] = source[key];
    });
  });
  return obj;
}

// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function arrayReplaceAt(src, pos, newElements) {
  return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}

////////////////////////////////////////////////////////////////////////////////

function isValidEntityCode(c) {
  /*eslint no-bitwise:0*/
  // broken sequence
  if (c >= 0xD800 && c <= 0xDFFF) {
    return false;
  }
  // never used
  if (c >= 0xFDD0 && c <= 0xFDEF) {
    return false;
  }
  if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) {
    return false;
  }
  // control codes
  if (c >= 0x00 && c <= 0x08) {
    return false;
  }
  if (c === 0x0B) {
    return false;
  }
  if (c >= 0x0E && c <= 0x1F) {
    return false;
  }
  if (c >= 0x7F && c <= 0x9F) {
    return false;
  }
  // out of range
  if (c > 0x10FFFF) {
    return false;
  }
  return true;
}
function fromCodePoint(c) {
  /*eslint no-bitwise:0*/
  if (c > 0xffff) {
    c -= 0x10000;
    var surrogate1 = 0xd800 + (c >> 10),
      surrogate2 = 0xdc00 + (c & 0x3ff);
    return String.fromCharCode(surrogate1, surrogate2);
  }
  return String.fromCharCode(c);
}
var UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
var ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
var UNESCAPE_ALL_RE = new RegExp(UNESCAPE_MD_RE.source + '|' + ENTITY_RE.source, 'gi');
var DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))/i;
var entities = __webpack_require__(58565);
function replaceEntityPattern(match, name) {
  var code = 0;
  if (has(entities, name)) {
    return entities[name];
  }
  if (name.charCodeAt(0) === 0x23 /* # */ && DIGITAL_ENTITY_TEST_RE.test(name)) {
    code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
    if (isValidEntityCode(code)) {
      return fromCodePoint(code);
    }
  }
  return match;
}

/*function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
}*/

function unescapeMd(str) {
  if (str.indexOf('\\') < 0) {
    return str;
  }
  return str.replace(UNESCAPE_MD_RE, '$1');
}
function unescapeAll(str) {
  if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) {
    return str;
  }
  return str.replace(UNESCAPE_ALL_RE, function (match, escaped, entity) {
    if (escaped) {
      return escaped;
    }
    return replaceEntityPattern(match, entity);
  });
}

////////////////////////////////////////////////////////////////////////////////

var HTML_ESCAPE_TEST_RE = /[&<>"]/;
var HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var HTML_REPLACEMENTS = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;'
};
function replaceUnsafeChar(ch) {
  return HTML_REPLACEMENTS[ch];
}
function escapeHtml(str) {
  if (HTML_ESCAPE_TEST_RE.test(str)) {
    return str.replace(HTML_ESCAPE_REPLACE_RE, replaceUnsafeChar);
  }
  return str;
}

////////////////////////////////////////////////////////////////////////////////

var REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function escapeRE(str) {
  return str.replace(REGEXP_ESCAPE_RE, '\\$&');
}

////////////////////////////////////////////////////////////////////////////////

function isSpace(code) {
  switch (code) {
    case 0x09:
    case 0x20:
      return true;
  }
  return false;
}

// Zs (unicode class) || [\t\f\v\r\n]
function isWhiteSpace(code) {
  if (code >= 0x2000 && code <= 0x200A) {
    return true;
  }
  switch (code) {
    case 0x09: // \t
    case 0x0A: // \n
    case 0x0B: // \v
    case 0x0C: // \f
    case 0x0D: // \r
    case 0x20:
    case 0xA0:
    case 0x1680:
    case 0x202F:
    case 0x205F:
    case 0x3000:
      return true;
  }
  return false;
}

////////////////////////////////////////////////////////////////////////////////

/*eslint-disable max-len*/
var UNICODE_PUNCT_RE = __webpack_require__(67925);

// Currently without astral characters support.
function isPunctChar(ch) {
  return UNICODE_PUNCT_RE.test(ch);
}

// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function isMdAsciiPunct(ch) {
  switch (ch) {
    case 0x21 /* ! */:
    case 0x22 /* " */:
    case 0x23 /* # */:
    case 0x24 /* $ */:
    case 0x25 /* % */:
    case 0x26 /* & */:
    case 0x27 /* ' */:
    case 0x28 /* ( */:
    case 0x29 /* ) */:
    case 0x2A /* * */:
    case 0x2B /* + */:
    case 0x2C /* , */:
    case 0x2D /* - */:
    case 0x2E /* . */:
    case 0x2F /* / */:
    case 0x3A /* : */:
    case 0x3B /* ; */:
    case 0x3C /* < */:
    case 0x3D /* = */:
    case 0x3E /* > */:
    case 0x3F /* ? */:
    case 0x40 /* @ */:
    case 0x5B /* [ */:
    case 0x5C /* \ */:
    case 0x5D /* ] */:
    case 0x5E /* ^ */:
    case 0x5F /* _ */:
    case 0x60 /* ` */:
    case 0x7B /* { */:
    case 0x7C /* | */:
    case 0x7D /* } */:
    case 0x7E /* ~ */:
      return true;
    default:
      return false;
  }
}

// Hepler to unify [reference labels].
//
function normalizeReference(str) {
  // Trim and collapse whitespace
  //
  str = str.trim().replace(/\s+/g, ' ');

  // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
  // fixed in v12 (couldn't find any details).
  //
  // So treat this one as a special case
  // (remove this when node v10 is no longer supported).
  //
  if ('ẞ'.toLowerCase() === 'Ṿ') {
    str = str.replace(/ẞ/g, 'ß');
  }

  // .toLowerCase().toUpperCase() should get rid of all differences
  // between letter variants.
  //
  // Simple .toLowerCase() doesn't normalize 125 code points correctly,
  // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
  // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
  // uppercased versions).
  //
  // Here's an example showing how it happens. Lets take greek letter omega:
  // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
  //
  // Unicode entries:
  // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
  // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
  // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
  // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
  //
  // Case-insensitive comparison should treat all of them as equivalent.
  //
  // But .toLowerCase() doesn't change ϑ (it's already lowercase),
  // and .toUpperCase() doesn't change ϴ (already uppercase).
  //
  // Applying first lower then upper case normalizes any character:
  // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
  //
  // Note: this is equivalent to unicode case folding; unicode normalization
  // is a different step that is not required here.
  //
  // Final result should be uppercased, because it's later stored in an object
  // (this avoid a conflict with Object.prototype members,
  // most notably, `__proto__`)
  //
  return str.toLowerCase().toUpperCase();
}

////////////////////////////////////////////////////////////////////////////////

// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
exports.lib = {};
exports.lib.mdurl = __webpack_require__(75577);
exports.lib.ucmicro = __webpack_require__(19234);
exports.assign = assign;
exports.isString = isString;
exports.has = has;
exports.unescapeMd = unescapeMd;
exports.unescapeAll = unescapeAll;
exports.isValidEntityCode = isValidEntityCode;
exports.fromCodePoint = fromCodePoint;
// exports.replaceEntities     = replaceEntities;
exports.escapeHtml = escapeHtml;
exports.arrayReplaceAt = arrayReplaceAt;
exports.isSpace = isSpace;
exports.isWhiteSpace = isWhiteSpace;
exports.isMdAsciiPunct = isMdAsciiPunct;
exports.isPunctChar = isPunctChar;
exports.escapeRE = escapeRE;
exports.normalizeReference = normalizeReference;

/***/ }),

/***/ 66647:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// Just a shortcut for bulk export


exports.parseLinkLabel = __webpack_require__(66322);
exports.parseLinkDestination = __webpack_require__(29883);
exports.parseLinkTitle = __webpack_require__(6150);

/***/ }),

/***/ 29883:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Parse link destination
//


__webpack_require__(47042);
var unescapeAll = __webpack_require__(14348).unescapeAll;
module.exports = function parseLinkDestination(str, pos, max) {
  var code,
    level,
    lines = 0,
    start = pos,
    result = {
      ok: false,
      pos: 0,
      lines: 0,
      str: ''
    };
  if (str.charCodeAt(pos) === 0x3C /* < */) {
    pos++;
    while (pos < max) {
      code = str.charCodeAt(pos);
      if (code === 0x0A /* \n */) {
        return result;
      }
      if (code === 0x3C /* < */) {
        return result;
      }
      if (code === 0x3E /* > */) {
        result.pos = pos + 1;
        result.str = unescapeAll(str.slice(start + 1, pos));
        result.ok = true;
        return result;
      }
      if (code === 0x5C /* \ */ && pos + 1 < max) {
        pos += 2;
        continue;
      }
      pos++;
    }

    // no closing '>'
    return result;
  }

  // this should be ... } else { ... branch

  level = 0;
  while (pos < max) {
    code = str.charCodeAt(pos);
    if (code === 0x20) {
      break;
    }

    // ascii control characters
    if (code < 0x20 || code === 0x7F) {
      break;
    }
    if (code === 0x5C /* \ */ && pos + 1 < max) {
      if (str.charCodeAt(pos + 1) === 0x20) {
        break;
      }
      pos += 2;
      continue;
    }
    if (code === 0x28 /* ( */) {
      level++;
      if (level > 32) {
        return result;
      }
    }
    if (code === 0x29 /* ) */) {
      if (level === 0) {
        break;
      }
      level--;
    }
    pos++;
  }
  if (start === pos) {
    return result;
  }
  if (level !== 0) {
    return result;
  }
  result.str = unescapeAll(str.slice(start, pos));
  result.lines = lines;
  result.pos = pos;
  result.ok = true;
  return result;
};

/***/ }),

/***/ 66322:
/***/ ((module) => {

"use strict";
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//


module.exports = function parseLinkLabel(state, start, disableNested) {
  var level,
    found,
    marker,
    prevPos,
    labelEnd = -1,
    max = state.posMax,
    oldPos = state.pos;
  state.pos = start + 1;
  level = 1;
  while (state.pos < max) {
    marker = state.src.charCodeAt(state.pos);
    if (marker === 0x5D /* ] */) {
      level--;
      if (level === 0) {
        found = true;
        break;
      }
    }
    prevPos = state.pos;
    state.md.inline.skipToken(state);
    if (marker === 0x5B /* [ */) {
      if (prevPos === state.pos - 1) {
        // increase level if we find text `[`, which is not a part of any token
        level++;
      } else if (disableNested) {
        state.pos = oldPos;
        return -1;
      }
    }
  }
  if (found) {
    labelEnd = state.pos;
  }

  // restore old state
  state.pos = oldPos;
  return labelEnd;
};

/***/ }),

/***/ 6150:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Parse link title
//


__webpack_require__(47042);
var unescapeAll = __webpack_require__(14348).unescapeAll;
module.exports = function parseLinkTitle(str, pos, max) {
  var code,
    marker,
    lines = 0,
    start = pos,
    result = {
      ok: false,
      pos: 0,
      lines: 0,
      str: ''
    };
  if (pos >= max) {
    return result;
  }
  marker = str.charCodeAt(pos);
  if (marker !== 0x22 /* " */ && marker !== 0x27 /* ' */ && marker !== 0x28 /* ( */) {
    return result;
  }
  pos++;

  // if opening marker is "(", switch it to closing marker ")"
  if (marker === 0x28) {
    marker = 0x29;
  }
  while (pos < max) {
    code = str.charCodeAt(pos);
    if (code === marker) {
      result.pos = pos + 1;
      result.lines = lines;
      result.str = unescapeAll(str.slice(start + 1, pos));
      result.ok = true;
      return result;
    } else if (code === 0x28 /* ( */ && marker === 0x29 /* ) */) {
      return result;
    } else if (code === 0x0A) {
      lines++;
    } else if (code === 0x5C /* \ */ && pos + 1 < max) {
      pos++;
      if (str.charCodeAt(pos) === 0x0A) {
        lines++;
      }
    }
    pos++;
  }
  return result;
};

/***/ }),

/***/ 85855:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Main parser class



__webpack_require__(73210);
__webpack_require__(54747);
__webpack_require__(47941);
__webpack_require__(92222);
__webpack_require__(57327);
__webpack_require__(47042);
var utils = __webpack_require__(14348);
var helpers = __webpack_require__(66647);
var Renderer = __webpack_require__(94613);
var ParserCore = __webpack_require__(5900);
var ParserBlock = __webpack_require__(12156);
var ParserInline = __webpack_require__(91063);
var LinkifyIt = __webpack_require__(97754);
var mdurl = __webpack_require__(75577);
var punycode = __webpack_require__(41625);
var config = {
  default: __webpack_require__(91885),
  zero: __webpack_require__(66358),
  commonmark: __webpack_require__(14712)
};

////////////////////////////////////////////////////////////////////////////////
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//

var BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
var GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function validateLink(url) {
  // url should be normalized at this point, and existing entities are decoded
  var str = url.trim().toLowerCase();
  return BAD_PROTO_RE.test(str) ? GOOD_DATA_RE.test(str) ? true : false : true;
}

////////////////////////////////////////////////////////////////////////////////

var RECODE_HOSTNAME_FOR = ['http:', 'https:', 'mailto:'];
function normalizeLink(url) {
  var parsed = mdurl.parse(url, true);
  if (parsed.hostname) {
    // Encode hostnames in urls like:
    // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
    //
    // We don't encode unknown schemas, because it's likely that we encode
    // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
    //
    if (!parsed.protocol || RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) {
      try {
        parsed.hostname = punycode.toASCII(parsed.hostname);
      } catch (er) {/**/}
    }
  }
  return mdurl.encode(mdurl.format(parsed));
}
function normalizeLinkText(url) {
  var parsed = mdurl.parse(url, true);
  if (parsed.hostname) {
    // Encode hostnames in urls like:
    // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
    //
    // We don't encode unknown schemas, because it's likely that we encode
    // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
    //
    if (!parsed.protocol || RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) {
      try {
        parsed.hostname = punycode.toUnicode(parsed.hostname);
      } catch (er) {/**/}
    }
  }

  // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
  return mdurl.decode(mdurl.format(parsed), mdurl.decode.defaultChars + '%');
}

/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/

/**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre class="hljs"><code>' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/
function MarkdownIt(presetName, options) {
  if (!(this instanceof MarkdownIt)) {
    return new MarkdownIt(presetName, options);
  }
  if (!options) {
    if (!utils.isString(presetName)) {
      options = presetName || {};
      presetName = 'default';
    }
  }

  /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/
  this.inline = new ParserInline();

  /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/
  this.block = new ParserBlock();

  /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/
  this.core = new ParserCore();

  /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
   **/
  this.renderer = new Renderer();

  /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
   * rule.
   **/
  this.linkify = new LinkifyIt();

  /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/
  this.validateLink = validateLink;

  /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/
  this.normalizeLink = normalizeLink;

  /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/
  this.normalizeLinkText = normalizeLinkText;

  // Expose utils & helpers for easy acces from plugins

  /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.js).
   **/
  this.utils = utils;

  /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/
  this.helpers = utils.assign({}, helpers);
  this.options = {};
  this.configure(presetName);
  if (options) {
    this.set(options);
  }
}

/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/
MarkdownIt.prototype.set = function (options) {
  utils.assign(this.options, options);
  return this;
};

/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/
MarkdownIt.prototype.configure = function (presets) {
  var self = this,
    presetName;
  if (utils.isString(presets)) {
    presetName = presets;
    presets = config[presetName];
    if (!presets) {
      throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
  }
  if (!presets) {
    throw new Error('Wrong `markdown-it` preset, can\'t be empty');
  }
  if (presets.options) {
    self.set(presets.options);
  }
  if (presets.components) {
    Object.keys(presets.components).forEach(function (name) {
      if (presets.components[name].rules) {
        self[name].ruler.enableOnly(presets.components[name].rules);
      }
      if (presets.components[name].rules2) {
        self[name].ruler2.enableOnly(presets.components[name].rules2);
      }
    });
  }
  return this;
};

/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/
MarkdownIt.prototype.enable = function (list, ignoreInvalid) {
  var result = [];
  if (!Array.isArray(list)) {
    list = [list];
  }
  ['core', 'block', 'inline'].forEach(function (chain) {
    result = result.concat(this[chain].ruler.enable(list, true));
  }, this);
  result = result.concat(this.inline.ruler2.enable(list, true));
  var missed = list.filter(function (name) {
    return result.indexOf(name) < 0;
  });
  if (missed.length && !ignoreInvalid) {
    throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
  }
  return this;
};

/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/
MarkdownIt.prototype.disable = function (list, ignoreInvalid) {
  var result = [];
  if (!Array.isArray(list)) {
    list = [list];
  }
  ['core', 'block', 'inline'].forEach(function (chain) {
    result = result.concat(this[chain].ruler.disable(list, true));
  }, this);
  result = result.concat(this.inline.ruler2.disable(list, true));
  var missed = list.filter(function (name) {
    return result.indexOf(name) < 0;
  });
  if (missed.length && !ignoreInvalid) {
    throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
  }
  return this;
};

/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/
MarkdownIt.prototype.use = function (plugin /*, params, ... */) {
  var args = [this].concat(Array.prototype.slice.call(arguments, 1));
  plugin.apply(plugin, args);
  return this;
};

/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/
MarkdownIt.prototype.parse = function (src, env) {
  if (typeof src !== 'string') {
    throw new Error('Input data should be a String');
  }
  var state = new this.core.State(src, this, env);
  this.core.process(state);
  return state.tokens;
};

/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/
MarkdownIt.prototype.render = function (src, env) {
  env = env || {};
  return this.renderer.render(this.parse(src, env), this.options, env);
};

/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/
MarkdownIt.prototype.parseInline = function (src, env) {
  var state = new this.core.State(src, this, env);
  state.inlineMode = true;
  this.core.process(state);
  return state.tokens;
};

/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/
MarkdownIt.prototype.renderInline = function (src, env) {
  env = env || {};
  return this.renderer.render(this.parseInline(src, env), this.options, env);
};
module.exports = MarkdownIt;

/***/ }),

/***/ 12156:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/


__webpack_require__(47042);
var Ruler = __webpack_require__(52822);
var _rules = [
// First 2 params - rule name & source. Secondary array - list of rules,
// which can be terminated by this one.
['table', __webpack_require__(41069), ['paragraph', 'reference']], ['code', __webpack_require__(26618)], ['fence', __webpack_require__(73909), ['paragraph', 'reference', 'blockquote', 'list']], ['blockquote', __webpack_require__(56321), ['paragraph', 'reference', 'blockquote', 'list']], ['hr', __webpack_require__(53419), ['paragraph', 'reference', 'blockquote', 'list']], ['list', __webpack_require__(76564), ['paragraph', 'reference', 'blockquote']], ['reference', __webpack_require__(15379)], ['html_block', __webpack_require__(88164), ['paragraph', 'reference', 'blockquote']], ['heading', __webpack_require__(55410), ['paragraph', 'reference', 'blockquote']], ['lheading', __webpack_require__(91029)], ['paragraph', __webpack_require__(71017)]];

/**
 * new ParserBlock()
 **/
function ParserBlock() {
  /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/
  this.ruler = new Ruler();
  for (var i = 0; i < _rules.length; i++) {
    this.ruler.push(_rules[i][0], _rules[i][1], {
      alt: (_rules[i][2] || []).slice()
    });
  }
}

// Generate tokens for input range
//
ParserBlock.prototype.tokenize = function (state, startLine, endLine) {
  var ok,
    i,
    rules = this.ruler.getRules(''),
    len = rules.length,
    line = startLine,
    hasEmptyLines = false,
    maxNesting = state.md.options.maxNesting;
  while (line < endLine) {
    state.line = line = state.skipEmptyLines(line);
    if (line >= endLine) {
      break;
    }

    // Termination condition for nested calls.
    // Nested calls currently used for blockquotes & lists
    if (state.sCount[line] < state.blkIndent) {
      break;
    }

    // If nesting level exceeded - skip tail to the end. That's not ordinary
    // situation and we should not care about content.
    if (state.level >= maxNesting) {
      state.line = endLine;
      break;
    }

    // Try all possible rules.
    // On success, rule should:
    //
    // - update `state.line`
    // - update `state.tokens`
    // - return true

    for (i = 0; i < len; i++) {
      ok = rules[i](state, line, endLine, false);
      if (ok) {
        break;
      }
    }

    // set state.tight if we had an empty line before current tag
    // i.e. latest empty line should not count
    state.tight = !hasEmptyLines;

    // paragraph might "eat" one newline after it in nested lists
    if (state.isEmpty(state.line - 1)) {
      hasEmptyLines = true;
    }
    line = state.line;
    if (line < endLine && state.isEmpty(line)) {
      hasEmptyLines = true;
      line++;
      state.line = line;
    }
  }
};

/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/
ParserBlock.prototype.parse = function (src, md, env, outTokens) {
  var state;
  if (!src) {
    return;
  }
  state = new this.State(src, md, env, outTokens);
  this.tokenize(state, state.line, state.lineMax);
};
ParserBlock.prototype.State = __webpack_require__(89157);
module.exports = ParserBlock;

/***/ }),

/***/ 5900:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/


var Ruler = __webpack_require__(52822);
var _rules = [['normalize', __webpack_require__(56817)], ['block', __webpack_require__(58992)], ['inline', __webpack_require__(6676)], ['linkify', __webpack_require__(31380)], ['replacements', __webpack_require__(93365)], ['smartquotes', __webpack_require__(77937)],
// `text_join` finds `text_special` tokens (for escape sequences)
// and joins them with the rest of the text
['text_join', __webpack_require__(48662)]];

/**
 * new Core()
 **/
function Core() {
  /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/
  this.ruler = new Ruler();
  for (var i = 0; i < _rules.length; i++) {
    this.ruler.push(_rules[i][0], _rules[i][1]);
  }
}

/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/
Core.prototype.process = function (state) {
  var i, l, rules;
  rules = this.ruler.getRules('');
  for (i = 0, l = rules.length; i < l; i++) {
    rules[i](state);
  }
};
Core.prototype.State = __webpack_require__(20110);
module.exports = Core;

/***/ }),

/***/ 91063:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/


var Ruler = __webpack_require__(52822);

////////////////////////////////////////////////////////////////////////////////
// Parser rules

var _rules = [['text', __webpack_require__(43154)], ['linkify', __webpack_require__(853)], ['newline', __webpack_require__(13377)], ['escape', __webpack_require__(50251)], ['backticks', __webpack_require__(58677)], ['strikethrough', __webpack_require__(97097)/* .tokenize */ .w], ['emphasis', __webpack_require__(18949)/* .tokenize */ .w], ['link', __webpack_require__(87582)], ['image', __webpack_require__(21900)], ['autolink', __webpack_require__(11758)], ['html_inline', __webpack_require__(11579)], ['entity', __webpack_require__(2438)]];

// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
var _rules2 = [['balance_pairs', __webpack_require__(51500)], ['strikethrough', __webpack_require__(97097)/* .postProcess */ .g], ['emphasis', __webpack_require__(18949)/* .postProcess */ .g],
// rules for pairs separate '**' into its own text tokens, which may be left unused,
// rule below merges unused segments back with the rest of the text
['fragments_join', __webpack_require__(82006)]];

/**
 * new ParserInline()
 **/
function ParserInline() {
  var i;

  /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/
  this.ruler = new Ruler();
  for (i = 0; i < _rules.length; i++) {
    this.ruler.push(_rules[i][0], _rules[i][1]);
  }

  /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/
  this.ruler2 = new Ruler();
  for (i = 0; i < _rules2.length; i++) {
    this.ruler2.push(_rules2[i][0], _rules2[i][1]);
  }
}

// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
ParserInline.prototype.skipToken = function (state) {
  var ok,
    i,
    pos = state.pos,
    rules = this.ruler.getRules(''),
    len = rules.length,
    maxNesting = state.md.options.maxNesting,
    cache = state.cache;
  if (typeof cache[pos] !== 'undefined') {
    state.pos = cache[pos];
    return;
  }
  if (state.level < maxNesting) {
    for (i = 0; i < len; i++) {
      // Increment state.level and decrement it later to limit recursion.
      // It's harmless to do here, because no tokens are created. But ideally,
      // we'd need a separate private state variable for this purpose.
      //
      state.level++;
      ok = rules[i](state, true);
      state.level--;
      if (ok) {
        break;
      }
    }
  } else {
    // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
  }
  if (!ok) {
    state.pos++;
  }
  cache[pos] = state.pos;
};

// Generate tokens for input range
//
ParserInline.prototype.tokenize = function (state) {
  var ok,
    i,
    rules = this.ruler.getRules(''),
    len = rules.length,
    end = state.posMax,
    maxNesting = state.md.options.maxNesting;
  while (state.pos < end) {
    // Try all possible rules.
    // On success, rule should:
    //
    // - update `state.pos`
    // - update `state.tokens`
    // - return true

    if (state.level < maxNesting) {
      for (i = 0; i < len; i++) {
        ok = rules[i](state, false);
        if (ok) {
          break;
        }
      }
    }
    if (ok) {
      if (state.pos >= end) {
        break;
      }
      continue;
    }
    state.pending += state.src[state.pos++];
  }
  if (state.pending) {
    state.pushPending();
  }
};

/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/
ParserInline.prototype.parse = function (str, md, env, outTokens) {
  var i, rules, len;
  var state = new this.State(str, md, env, outTokens);
  this.tokenize(state);
  rules = this.ruler2.getRules('');
  len = rules.length;
  for (i = 0; i < len; i++) {
    rules[i](state);
  }
};
ParserInline.prototype.State = __webpack_require__(59427);
module.exports = ParserInline;

/***/ }),

/***/ 14712:
/***/ ((module) => {

"use strict";
// Commonmark default options



module.exports = {
  options: {
    html: true,
    // Enable HTML tags in source
    xhtmlOut: true,
    // Use '/' to close single tags (<br />)
    breaks: false,
    // Convert '\n' in paragraphs into <br>
    langPrefix: 'language-',
    // CSS language prefix for fenced blocks
    linkify: false,
    // autoconvert URL-like texts to links

    // Enable some language-neutral replacements + quotes beautification
    typographer: false,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "\u201C\u201D\u2018\u2019",
    /* “”‘’ */

    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    maxNesting: 20 // Internal protection, recursion limit
  },

  components: {
    core: {
      rules: ['normalize', 'block', 'inline', 'text_join']
    },
    block: {
      rules: ['blockquote', 'code', 'fence', 'heading', 'hr', 'html_block', 'lheading', 'list', 'reference', 'paragraph']
    },
    inline: {
      rules: ['autolink', 'backticks', 'emphasis', 'entity', 'escape', 'html_inline', 'image', 'link', 'newline', 'text'],
      rules2: ['balance_pairs', 'emphasis', 'fragments_join']
    }
  }
};

/***/ }),

/***/ 91885:
/***/ ((module) => {

"use strict";
// markdown-it default options



module.exports = {
  options: {
    html: false,
    // Enable HTML tags in source
    xhtmlOut: false,
    // Use '/' to close single tags (<br />)
    breaks: false,
    // Convert '\n' in paragraphs into <br>
    langPrefix: 'language-',
    // CSS language prefix for fenced blocks
    linkify: false,
    // autoconvert URL-like texts to links

    // Enable some language-neutral replacements + quotes beautification
    typographer: false,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "\u201C\u201D\u2018\u2019",
    /* “”‘’ */

    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    maxNesting: 100 // Internal protection, recursion limit
  },

  components: {
    core: {},
    block: {},
    inline: {}
  }
};

/***/ }),

/***/ 66358:
/***/ ((module) => {

"use strict";
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.



module.exports = {
  options: {
    html: false,
    // Enable HTML tags in source
    xhtmlOut: false,
    // Use '/' to close single tags (<br />)
    breaks: false,
    // Convert '\n' in paragraphs into <br>
    langPrefix: 'language-',
    // CSS language prefix for fenced blocks
    linkify: false,
    // autoconvert URL-like texts to links

    // Enable some language-neutral replacements + quotes beautification
    typographer: false,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "\u201C\u201D\u2018\u2019",
    /* “”‘’ */

    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    maxNesting: 20 // Internal protection, recursion limit
  },

  components: {
    core: {
      rules: ['normalize', 'block', 'inline', 'text_join']
    },
    block: {
      rules: ['paragraph']
    },
    inline: {
      rules: ['text'],
      rules2: ['balance_pairs', 'fragments_join']
    }
  }
};

/***/ }),

/***/ 94613:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/


__webpack_require__(73210);
__webpack_require__(74916);
__webpack_require__(23123);
__webpack_require__(69600);
__webpack_require__(47042);
var assign = __webpack_require__(14348).assign;
var unescapeAll = __webpack_require__(14348).unescapeAll;
var escapeHtml = __webpack_require__(14348).escapeHtml;

////////////////////////////////////////////////////////////////////////////////

var default_rules = {};
default_rules.code_inline = function (tokens, idx, options, env, slf) {
  var token = tokens[idx];
  return '<code' + slf.renderAttrs(token) + '>' + escapeHtml(tokens[idx].content) + '</code>';
};
default_rules.code_block = function (tokens, idx, options, env, slf) {
  var token = tokens[idx];
  return '<pre' + slf.renderAttrs(token) + '><code>' + escapeHtml(tokens[idx].content) + '</code></pre>\n';
};
default_rules.fence = function (tokens, idx, options, env, slf) {
  var token = tokens[idx],
    info = token.info ? unescapeAll(token.info).trim() : '',
    langName = '',
    langAttrs = '',
    highlighted,
    i,
    arr,
    tmpAttrs,
    tmpToken;
  if (info) {
    arr = info.split(/(\s+)/g);
    langName = arr[0];
    langAttrs = arr.slice(2).join('');
  }
  if (options.highlight) {
    highlighted = options.highlight(token.content, langName, langAttrs) || escapeHtml(token.content);
  } else {
    highlighted = escapeHtml(token.content);
  }
  if (highlighted.indexOf('<pre') === 0) {
    return highlighted + '\n';
  }

  // If language exists, inject class gently, without modifying original token.
  // May be, one day we will add .deepClone() for token and simplify this part, but
  // now we prefer to keep things local.
  if (info) {
    i = token.attrIndex('class');
    tmpAttrs = token.attrs ? token.attrs.slice() : [];
    if (i < 0) {
      tmpAttrs.push(['class', options.langPrefix + langName]);
    } else {
      tmpAttrs[i] = tmpAttrs[i].slice();
      tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
    }

    // Fake token just to render attributes
    tmpToken = {
      attrs: tmpAttrs
    };
    return '<pre><code' + slf.renderAttrs(tmpToken) + '>' + highlighted + '</code></pre>\n';
  }
  return '<pre><code' + slf.renderAttrs(token) + '>' + highlighted + '</code></pre>\n';
};
default_rules.image = function (tokens, idx, options, env, slf) {
  var token = tokens[idx];

  // "alt" attr MUST be set, even if empty. Because it's mandatory and
  // should be placed on proper position for tests.
  //
  // Replace content with actual value

  token.attrs[token.attrIndex('alt')][1] = slf.renderInlineAsText(token.children, options, env);
  return slf.renderToken(tokens, idx, options);
};
default_rules.hardbreak = function (tokens, idx, options /*, env */) {
  return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
default_rules.softbreak = function (tokens, idx, options /*, env */) {
  return options.breaks ? options.xhtmlOut ? '<br />\n' : '<br>\n' : '\n';
};
default_rules.text = function (tokens, idx /*, options, env */) {
  return escapeHtml(tokens[idx].content);
};
default_rules.html_block = function (tokens, idx /*, options, env */) {
  return tokens[idx].content;
};
default_rules.html_inline = function (tokens, idx /*, options, env */) {
  return tokens[idx].content;
};

/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/
function Renderer() {
  /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
   * for more details and examples.
   **/
  this.rules = assign({}, default_rules);
}

/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/
Renderer.prototype.renderAttrs = function renderAttrs(token) {
  var i, l, result;
  if (!token.attrs) {
    return '';
  }
  result = '';
  for (i = 0, l = token.attrs.length; i < l; i++) {
    result += ' ' + escapeHtml(token.attrs[i][0]) + '="' + escapeHtml(token.attrs[i][1]) + '"';
  }
  return result;
};

/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/
Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
  var nextToken,
    result = '',
    needLf = false,
    token = tokens[idx];

  // Tight list paragraphs
  if (token.hidden) {
    return '';
  }

  // Insert a newline between hidden paragraph and subsequent opening
  // block-level tag.
  //
  // For example, here we should insert a newline before blockquote:
  //  - a
  //    >
  //
  if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) {
    result += '\n';
  }

  // Add token name, e.g. `<img`
  result += (token.nesting === -1 ? '</' : '<') + token.tag;

  // Encode attributes, e.g. `<img src="foo"`
  result += this.renderAttrs(token);

  // Add a slash for self-closing tags, e.g. `<img src="foo" /`
  if (token.nesting === 0 && options.xhtmlOut) {
    result += ' /';
  }

  // Check if we need to add a newline after this tag
  if (token.block) {
    needLf = true;
    if (token.nesting === 1) {
      if (idx + 1 < tokens.length) {
        nextToken = tokens[idx + 1];
        if (nextToken.type === 'inline' || nextToken.hidden) {
          // Block-level tag containing an inline tag.
          //
          needLf = false;
        } else if (nextToken.nesting === -1 && nextToken.tag === token.tag) {
          // Opening tag + closing tag of the same type. E.g. `<li></li>`.
          //
          needLf = false;
        }
      }
    }
  }
  result += needLf ? '>\n' : '>';
  return result;
};

/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/
Renderer.prototype.renderInline = function (tokens, options, env) {
  var type,
    result = '',
    rules = this.rules;
  for (var i = 0, len = tokens.length; i < len; i++) {
    type = tokens[i].type;
    if (typeof rules[type] !== 'undefined') {
      result += rules[type](tokens, i, options, env, this);
    } else {
      result += this.renderToken(tokens, i, options);
    }
  }
  return result;
};

/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/
Renderer.prototype.renderInlineAsText = function (tokens, options, env) {
  var result = '';
  for (var i = 0, len = tokens.length; i < len; i++) {
    if (tokens[i].type === 'text') {
      result += tokens[i].content;
    } else if (tokens[i].type === 'image') {
      result += this.renderInlineAsText(tokens[i].children, options, env);
    } else if (tokens[i].type === 'softbreak') {
      result += '\n';
    }
  }
  return result;
};

/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/
Renderer.prototype.render = function (tokens, options, env) {
  var i,
    len,
    type,
    result = '',
    rules = this.rules;
  for (i = 0, len = tokens.length; i < len; i++) {
    type = tokens[i].type;
    if (type === 'inline') {
      result += this.renderInline(tokens[i].children, options, env);
    } else if (typeof rules[type] !== 'undefined') {
      result += rules[tokens[i].type](tokens, i, options, env, this);
    } else {
      result += this.renderToken(tokens, i, options, env);
    }
  }
  return result;
};
module.exports = Renderer;

/***/ }),

/***/ 52822:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/


/**
 * new Ruler()
 **/
__webpack_require__(68309);
__webpack_require__(54747);
__webpack_require__(40561);
function Ruler() {
  // List of added rules. Each element is:
  //
  // {
  //   name: XXX,
  //   enabled: Boolean,
  //   fn: Function(),
  //   alt: [ name2, name3 ]
  // }
  //
  this.__rules__ = [];

  // Cached rule chains.
  //
  // First level - chain name, '' for default.
  // Second level - diginal anchor for fast filtering by charcodes.
  //
  this.__cache__ = null;
}

////////////////////////////////////////////////////////////////////////////////
// Helper methods, should not be used directly

// Find rule index by name
//
Ruler.prototype.__find__ = function (name) {
  for (var i = 0; i < this.__rules__.length; i++) {
    if (this.__rules__[i].name === name) {
      return i;
    }
  }
  return -1;
};

// Build rules lookup cache
//
Ruler.prototype.__compile__ = function () {
  var self = this;
  var chains = [''];

  // collect unique names
  self.__rules__.forEach(function (rule) {
    if (!rule.enabled) {
      return;
    }
    rule.alt.forEach(function (altName) {
      if (chains.indexOf(altName) < 0) {
        chains.push(altName);
      }
    });
  });
  self.__cache__ = {};
  chains.forEach(function (chain) {
    self.__cache__[chain] = [];
    self.__rules__.forEach(function (rule) {
      if (!rule.enabled) {
        return;
      }
      if (chain && rule.alt.indexOf(chain) < 0) {
        return;
      }
      self.__cache__[chain].push(rule.fn);
    });
  });
};

/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/
Ruler.prototype.at = function (name, fn, options) {
  var index = this.__find__(name);
  var opt = options || {};
  if (index === -1) {
    throw new Error('Parser rule not found: ' + name);
  }
  this.__rules__[index].fn = fn;
  this.__rules__[index].alt = opt.alt || [];
  this.__cache__ = null;
};

/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/
Ruler.prototype.before = function (beforeName, ruleName, fn, options) {
  var index = this.__find__(beforeName);
  var opt = options || {};
  if (index === -1) {
    throw new Error('Parser rule not found: ' + beforeName);
  }
  this.__rules__.splice(index, 0, {
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });
  this.__cache__ = null;
};

/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/
Ruler.prototype.after = function (afterName, ruleName, fn, options) {
  var index = this.__find__(afterName);
  var opt = options || {};
  if (index === -1) {
    throw new Error('Parser rule not found: ' + afterName);
  }
  this.__rules__.splice(index + 1, 0, {
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });
  this.__cache__ = null;
};

/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/
Ruler.prototype.push = function (ruleName, fn, options) {
  var opt = options || {};
  this.__rules__.push({
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });
  this.__cache__ = null;
};

/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/
Ruler.prototype.enable = function (list, ignoreInvalid) {
  if (!Array.isArray(list)) {
    list = [list];
  }
  var result = [];

  // Search by name and enable
  list.forEach(function (name) {
    var idx = this.__find__(name);
    if (idx < 0) {
      if (ignoreInvalid) {
        return;
      }
      throw new Error('Rules manager: invalid rule name ' + name);
    }
    this.__rules__[idx].enabled = true;
    result.push(name);
  }, this);
  this.__cache__ = null;
  return result;
};

/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/
Ruler.prototype.enableOnly = function (list, ignoreInvalid) {
  if (!Array.isArray(list)) {
    list = [list];
  }
  this.__rules__.forEach(function (rule) {
    rule.enabled = false;
  });
  this.enable(list, ignoreInvalid);
};

/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/
Ruler.prototype.disable = function (list, ignoreInvalid) {
  if (!Array.isArray(list)) {
    list = [list];
  }
  var result = [];

  // Search by name and disable
  list.forEach(function (name) {
    var idx = this.__find__(name);
    if (idx < 0) {
      if (ignoreInvalid) {
        return;
      }
      throw new Error('Rules manager: invalid rule name ' + name);
    }
    this.__rules__[idx].enabled = false;
    result.push(name);
  }, this);
  this.__cache__ = null;
  return result;
};

/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/
Ruler.prototype.getRules = function (chainName) {
  if (this.__cache__ === null) {
    this.__compile__();
  }

  // Chain can be empty, if rules disabled. But we still have to return Array.
  return this.__cache__[chainName] || [];
};
module.exports = Ruler;

/***/ }),

/***/ 56321:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Block quotes



__webpack_require__(21249);
var isSpace = __webpack_require__(14348).isSpace;
module.exports = function blockquote(state, startLine, endLine, silent) {
  var adjustTab,
    ch,
    i,
    initial,
    l,
    lastLineEmpty,
    lines,
    nextLine,
    offset,
    oldBMarks,
    oldBSCount,
    oldIndent,
    oldParentType,
    oldSCount,
    oldTShift,
    spaceAfterMarker,
    terminate,
    terminatorRules,
    token,
    isOutdented,
    oldLineMax = state.lineMax,
    pos = state.bMarks[startLine] + state.tShift[startLine],
    max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) {
    return false;
  }

  // check the block quote marker
  if (state.src.charCodeAt(pos++) !== 0x3E /* > */) {
    return false;
  }

  // we know that it's going to be a valid blockquote,
  // so no point trying to find the end of it in silent mode
  if (silent) {
    return true;
  }

  // set offset past spaces and ">"
  initial = offset = state.sCount[startLine] + 1;

  // skip one optional space after '>'
  if (state.src.charCodeAt(pos) === 0x20 /* space */) {
    // ' >   test '
    //     ^ -- position start of line here:
    pos++;
    initial++;
    offset++;
    adjustTab = false;
    spaceAfterMarker = true;
  } else if (state.src.charCodeAt(pos) === 0x09 /* tab */) {
    spaceAfterMarker = true;
    if ((state.bsCount[startLine] + offset) % 4 === 3) {
      // '  >\t  test '
      //       ^ -- position start of line here (tab has width===1)
      pos++;
      initial++;
      offset++;
      adjustTab = false;
    } else {
      // ' >\t  test '
      //    ^ -- position start of line here + shift bsCount slightly
      //         to make extra space appear
      adjustTab = true;
    }
  } else {
    spaceAfterMarker = false;
  }
  oldBMarks = [state.bMarks[startLine]];
  state.bMarks[startLine] = pos;
  while (pos < max) {
    ch = state.src.charCodeAt(pos);
    if (isSpace(ch)) {
      if (ch === 0x09) {
        offset += 4 - (offset + state.bsCount[startLine] + (adjustTab ? 1 : 0)) % 4;
      } else {
        offset++;
      }
    } else {
      break;
    }
    pos++;
  }
  oldBSCount = [state.bsCount[startLine]];
  state.bsCount[startLine] = state.sCount[startLine] + 1 + (spaceAfterMarker ? 1 : 0);
  lastLineEmpty = pos >= max;
  oldSCount = [state.sCount[startLine]];
  state.sCount[startLine] = offset - initial;
  oldTShift = [state.tShift[startLine]];
  state.tShift[startLine] = pos - state.bMarks[startLine];
  terminatorRules = state.md.block.ruler.getRules('blockquote');
  oldParentType = state.parentType;
  state.parentType = 'blockquote';

  // Search the end of the block
  //
  // Block ends with either:
  //  1. an empty line outside:
  //     ```
  //     > test
  //
  //     ```
  //  2. an empty line inside:
  //     ```
  //     >
  //     test
  //     ```
  //  3. another tag:
  //     ```
  //     > test
  //      - - -
  //     ```
  for (nextLine = startLine + 1; nextLine < endLine; nextLine++) {
    // check if it's outdented, i.e. it's inside list item and indented
    // less than said list item:
    //
    // ```
    // 1. anything
    //    > current blockquote
    // 2. checking this line
    // ```
    isOutdented = state.sCount[nextLine] < state.blkIndent;
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    max = state.eMarks[nextLine];
    if (pos >= max) {
      // Case 1: line is not inside the blockquote, and this line is empty.
      break;
    }
    if (state.src.charCodeAt(pos++) === 0x3E /* > */ && !isOutdented) {
      // This line is inside the blockquote.

      // set offset past spaces and ">"
      initial = offset = state.sCount[nextLine] + 1;

      // skip one optional space after '>'
      if (state.src.charCodeAt(pos) === 0x20 /* space */) {
        // ' >   test '
        //     ^ -- position start of line here:
        pos++;
        initial++;
        offset++;
        adjustTab = false;
        spaceAfterMarker = true;
      } else if (state.src.charCodeAt(pos) === 0x09 /* tab */) {
        spaceAfterMarker = true;
        if ((state.bsCount[nextLine] + offset) % 4 === 3) {
          // '  >\t  test '
          //       ^ -- position start of line here (tab has width===1)
          pos++;
          initial++;
          offset++;
          adjustTab = false;
        } else {
          // ' >\t  test '
          //    ^ -- position start of line here + shift bsCount slightly
          //         to make extra space appear
          adjustTab = true;
        }
      } else {
        spaceAfterMarker = false;
      }
      oldBMarks.push(state.bMarks[nextLine]);
      state.bMarks[nextLine] = pos;
      while (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (isSpace(ch)) {
          if (ch === 0x09) {
            offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
          } else {
            offset++;
          }
        } else {
          break;
        }
        pos++;
      }
      lastLineEmpty = pos >= max;
      oldBSCount.push(state.bsCount[nextLine]);
      state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
      oldSCount.push(state.sCount[nextLine]);
      state.sCount[nextLine] = offset - initial;
      oldTShift.push(state.tShift[nextLine]);
      state.tShift[nextLine] = pos - state.bMarks[nextLine];
      continue;
    }

    // Case 2: line is not inside the blockquote, and the last line was empty.
    if (lastLineEmpty) {
      break;
    }

    // Case 3: another tag found.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) {
      // Quirk to enforce "hard termination mode" for paragraphs;
      // normally if you call `tokenize(state, startLine, nextLine)`,
      // paragraphs will look below nextLine for paragraph continuation,
      // but if blockquote is terminated by another tag, they shouldn't
      state.lineMax = nextLine;
      if (state.blkIndent !== 0) {
        // state.blkIndent was non-zero, we now set it to zero,
        // so we need to re-calculate all offsets to appear as
        // if indent wasn't changed
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        state.sCount[nextLine] -= state.blkIndent;
      }
      break;
    }
    oldBMarks.push(state.bMarks[nextLine]);
    oldBSCount.push(state.bsCount[nextLine]);
    oldTShift.push(state.tShift[nextLine]);
    oldSCount.push(state.sCount[nextLine]);

    // A negative indentation means that this is a paragraph continuation
    //
    state.sCount[nextLine] = -1;
  }
  oldIndent = state.blkIndent;
  state.blkIndent = 0;
  token = state.push('blockquote_open', 'blockquote', 1);
  token.markup = '>';
  token.map = lines = [startLine, 0];
  state.md.block.tokenize(state, startLine, nextLine);
  token = state.push('blockquote_close', 'blockquote', -1);
  token.markup = '>';
  state.lineMax = oldLineMax;
  state.parentType = oldParentType;
  lines[1] = state.line;

  // Restore original tShift; this might not be necessary since the parser
  // has already been here, but just to make sure we can do that.
  for (i = 0; i < oldTShift.length; i++) {
    state.bMarks[i + startLine] = oldBMarks[i];
    state.tShift[i + startLine] = oldTShift[i];
    state.sCount[i + startLine] = oldSCount[i];
    state.bsCount[i + startLine] = oldBSCount[i];
  }
  state.blkIndent = oldIndent;
  return true;
};

/***/ }),

/***/ 26618:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Code block (4 spaces padded)



__webpack_require__(21249);
module.exports = function code(state, startLine, endLine /*, silent*/) {
  var nextLine, last, token;
  if (state.sCount[startLine] - state.blkIndent < 4) {
    return false;
  }
  last = nextLine = startLine + 1;
  while (nextLine < endLine) {
    if (state.isEmpty(nextLine)) {
      nextLine++;
      continue;
    }
    if (state.sCount[nextLine] - state.blkIndent >= 4) {
      nextLine++;
      last = nextLine;
      continue;
    }
    break;
  }
  state.line = last;
  token = state.push('code_block', 'code', 0);
  token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + '\n';
  token.map = [startLine, state.line];
  return true;
};

/***/ }),

/***/ 73909:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// fences (``` lang, ~~~ lang)



__webpack_require__(47042);
__webpack_require__(21249);
module.exports = function fence(state, startLine, endLine, silent) {
  var marker,
    len,
    params,
    nextLine,
    mem,
    token,
    markup,
    haveEndMarker = false,
    pos = state.bMarks[startLine] + state.tShift[startLine],
    max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) {
    return false;
  }
  if (pos + 3 > max) {
    return false;
  }
  marker = state.src.charCodeAt(pos);
  if (marker !== 0x7E /* ~ */ && marker !== 0x60 /* ` */) {
    return false;
  }

  // scan marker length
  mem = pos;
  pos = state.skipChars(pos, marker);
  len = pos - mem;
  if (len < 3) {
    return false;
  }
  markup = state.src.slice(mem, pos);
  params = state.src.slice(pos, max);
  if (marker === 0x60 /* ` */) {
    if (params.indexOf(String.fromCharCode(marker)) >= 0) {
      return false;
    }
  }

  // Since start is found, we can report success here in validation mode
  if (silent) {
    return true;
  }

  // search end of block
  nextLine = startLine;
  for (;;) {
    nextLine++;
    if (nextLine >= endLine) {
      // unclosed block should be autoclosed by end of document.
      // also block seems to be autoclosed by end of parent
      break;
    }
    pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
    max = state.eMarks[nextLine];
    if (pos < max && state.sCount[nextLine] < state.blkIndent) {
      // non-empty line with negative indent should stop the list:
      // - ```
      //  test
      break;
    }
    if (state.src.charCodeAt(pos) !== marker) {
      continue;
    }
    if (state.sCount[nextLine] - state.blkIndent >= 4) {
      // closing fence should be indented less than 4 spaces
      continue;
    }
    pos = state.skipChars(pos, marker);

    // closing code fence must be at least as long as the opening one
    if (pos - mem < len) {
      continue;
    }

    // make sure tail has spaces only
    pos = state.skipSpaces(pos);
    if (pos < max) {
      continue;
    }
    haveEndMarker = true;
    // found!
    break;
  }

  // If a fence has heading spaces, they should be removed from its inner block
  len = state.sCount[startLine];
  state.line = nextLine + (haveEndMarker ? 1 : 0);
  token = state.push('fence', 'code', 0);
  token.info = params;
  token.content = state.getLines(startLine + 1, nextLine, len, true);
  token.markup = markup;
  token.map = [startLine, state.line];
  return true;
};

/***/ }),

/***/ 55410:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// heading (#, ##, ...)



__webpack_require__(21249);
__webpack_require__(73210);
__webpack_require__(47042);
var isSpace = __webpack_require__(14348).isSpace;
module.exports = function heading(state, startLine, endLine, silent) {
  var ch,
    level,
    tmp,
    token,
    pos = state.bMarks[startLine] + state.tShift[startLine],
    max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) {
    return false;
  }
  ch = state.src.charCodeAt(pos);
  if (ch !== 0x23 /* # */ || pos >= max) {
    return false;
  }

  // count heading level
  level = 1;
  ch = state.src.charCodeAt(++pos);
  while (ch === 0x23 /* # */ && pos < max && level <= 6) {
    level++;
    ch = state.src.charCodeAt(++pos);
  }
  if (level > 6 || pos < max && !isSpace(ch)) {
    return false;
  }
  if (silent) {
    return true;
  }

  // Let's cut tails like '    ###  ' from the end of string

  max = state.skipSpacesBack(max, pos);
  tmp = state.skipCharsBack(max, 0x23, pos); // #
  if (tmp > pos && isSpace(state.src.charCodeAt(tmp - 1))) {
    max = tmp;
  }
  state.line = startLine + 1;
  token = state.push('heading_open', 'h' + String(level), 1);
  token.markup = '########'.slice(0, level);
  token.map = [startLine, state.line];
  token = state.push('inline', '', 0);
  token.content = state.src.slice(pos, max).trim();
  token.map = [startLine, state.line];
  token.children = [];
  token = state.push('heading_close', 'h' + String(level), -1);
  token.markup = '########'.slice(0, level);
  return true;
};

/***/ }),

/***/ 53419:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Horizontal rule



__webpack_require__(21249);
__webpack_require__(69600);
var isSpace = __webpack_require__(14348).isSpace;
module.exports = function hr(state, startLine, endLine, silent) {
  var marker,
    cnt,
    ch,
    token,
    pos = state.bMarks[startLine] + state.tShift[startLine],
    max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) {
    return false;
  }
  marker = state.src.charCodeAt(pos++);

  // Check hr marker
  if (marker !== 0x2A /* * */ && marker !== 0x2D /* - */ && marker !== 0x5F /* _ */) {
    return false;
  }

  // markers can be mixed with spaces, but there should be at least 3 of them

  cnt = 1;
  while (pos < max) {
    ch = state.src.charCodeAt(pos++);
    if (ch !== marker && !isSpace(ch)) {
      return false;
    }
    if (ch === marker) {
      cnt++;
    }
  }
  if (cnt < 3) {
    return false;
  }
  if (silent) {
    return true;
  }
  state.line = startLine + 1;
  token = state.push('hr', 'hr', 0);
  token.map = [startLine, state.line];
  token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
  return true;
};

/***/ }),

/***/ 88164:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// HTML block



__webpack_require__(24603);
__webpack_require__(74916);
__webpack_require__(39714);
__webpack_require__(69600);
__webpack_require__(47042);
__webpack_require__(21249);
var block_names = __webpack_require__(35042);
var HTML_OPEN_CLOSE_TAG_RE = __webpack_require__(6251)/* .HTML_OPEN_CLOSE_TAG_RE */ .q;

// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
var HTML_SEQUENCES = [[/^<(script|pre|style|textarea)(?=(\s|>|$))/i, /<\/(script|pre|style|textarea)>/i, true], [/^<!--/, /-->/, true], [/^<\?/, /\?>/, true], [/^<![A-Z]/, />/, true], [/^<!\[CDATA\[/, /\]\]>/, true], [new RegExp('^</?(' + block_names.join('|') + ')(?=(\\s|/?>|$))', 'i'), /^$/, true], [new RegExp(HTML_OPEN_CLOSE_TAG_RE.source + '\\s*$'), /^$/, false]];
module.exports = function html_block(state, startLine, endLine, silent) {
  var i,
    nextLine,
    token,
    lineText,
    pos = state.bMarks[startLine] + state.tShift[startLine],
    max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) {
    return false;
  }
  if (!state.md.options.html) {
    return false;
  }
  if (state.src.charCodeAt(pos) !== 0x3C /* < */) {
    return false;
  }
  lineText = state.src.slice(pos, max);
  for (i = 0; i < HTML_SEQUENCES.length; i++) {
    if (HTML_SEQUENCES[i][0].test(lineText)) {
      break;
    }
  }
  if (i === HTML_SEQUENCES.length) {
    return false;
  }
  if (silent) {
    // true if this sequence can be a terminator, false otherwise
    return HTML_SEQUENCES[i][2];
  }
  nextLine = startLine + 1;

  // If we are here - we detected HTML block.
  // Let's roll down till block end.
  if (!HTML_SEQUENCES[i][1].test(lineText)) {
    for (; nextLine < endLine; nextLine++) {
      if (state.sCount[nextLine] < state.blkIndent) {
        break;
      }
      pos = state.bMarks[nextLine] + state.tShift[nextLine];
      max = state.eMarks[nextLine];
      lineText = state.src.slice(pos, max);
      if (HTML_SEQUENCES[i][1].test(lineText)) {
        if (lineText.length !== 0) {
          nextLine++;
        }
        break;
      }
    }
  }
  state.line = nextLine;
  token = state.push('html_block', '', 0);
  token.map = [startLine, nextLine];
  token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
  return true;
};

/***/ }),

/***/ 91029:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// lheading (---, ===)



__webpack_require__(73210);
__webpack_require__(21249);
module.exports = function lheading(state, startLine, endLine /*, silent*/) {
  var content,
    terminate,
    i,
    l,
    token,
    pos,
    max,
    level,
    marker,
    nextLine = startLine + 1,
    oldParentType,
    terminatorRules = state.md.block.ruler.getRules('paragraph');

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) {
    return false;
  }
  oldParentType = state.parentType;
  state.parentType = 'paragraph'; // use paragraph to match terminatorRules

  // jump line-by-line until empty one or EOF
  for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
    // this would be a code block normally, but after paragraph
    // it's considered a lazy continuation regardless of what's there
    if (state.sCount[nextLine] - state.blkIndent > 3) {
      continue;
    }

    //
    // Check for underline in setext header
    //
    if (state.sCount[nextLine] >= state.blkIndent) {
      pos = state.bMarks[nextLine] + state.tShift[nextLine];
      max = state.eMarks[nextLine];
      if (pos < max) {
        marker = state.src.charCodeAt(pos);
        if (marker === 0x2D /* - */ || marker === 0x3D /* = */) {
          pos = state.skipChars(pos, marker);
          pos = state.skipSpaces(pos);
          if (pos >= max) {
            level = marker === 0x3D /* = */ ? 1 : 2;
            break;
          }
        }
      }
    }

    // quirk for blockquotes, this line should already be checked by that rule
    if (state.sCount[nextLine] < 0) {
      continue;
    }

    // Some tags can terminate paragraph without empty line.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) {
      break;
    }
  }
  if (!level) {
    // Didn't find valid underline
    return false;
  }
  content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
  state.line = nextLine + 1;
  token = state.push('heading_open', 'h' + String(level), 1);
  token.markup = String.fromCharCode(marker);
  token.map = [startLine, state.line];
  token = state.push('inline', '', 0);
  token.content = content;
  token.map = [startLine, state.line - 1];
  token.children = [];
  token = state.push('heading_close', 'h' + String(level), -1);
  token.markup = String.fromCharCode(marker);
  state.parentType = oldParentType;
  return true;
};

/***/ }),

/***/ 76564:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Lists



__webpack_require__(9653);
__webpack_require__(47042);
__webpack_require__(21249);
var isSpace = __webpack_require__(14348).isSpace;

// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function skipBulletListMarker(state, startLine) {
  var marker, pos, max, ch;
  pos = state.bMarks[startLine] + state.tShift[startLine];
  max = state.eMarks[startLine];
  marker = state.src.charCodeAt(pos++);
  // Check bullet
  if (marker !== 0x2A /* * */ && marker !== 0x2D /* - */ && marker !== 0x2B /* + */) {
    return -1;
  }
  if (pos < max) {
    ch = state.src.charCodeAt(pos);
    if (!isSpace(ch)) {
      // " -test " - is not a list item
      return -1;
    }
  }
  return pos;
}

// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function skipOrderedListMarker(state, startLine) {
  var ch,
    start = state.bMarks[startLine] + state.tShift[startLine],
    pos = start,
    max = state.eMarks[startLine];

  // List marker should have at least 2 chars (digit + dot)
  if (pos + 1 >= max) {
    return -1;
  }
  ch = state.src.charCodeAt(pos++);
  if (ch < 0x30 /* 0 */ || ch > 0x39 /* 9 */) {
    return -1;
  }
  for (;;) {
    // EOL -> fail
    if (pos >= max) {
      return -1;
    }
    ch = state.src.charCodeAt(pos++);
    if (ch >= 0x30 /* 0 */ && ch <= 0x39 /* 9 */) {
      // List marker should have no more than 9 digits
      // (prevents integer overflow in browsers)
      if (pos - start >= 10) {
        return -1;
      }
      continue;
    }

    // found valid marker
    if (ch === 0x29 /* ) */ || ch === 0x2e /* . */) {
      break;
    }
    return -1;
  }
  if (pos < max) {
    ch = state.src.charCodeAt(pos);
    if (!isSpace(ch)) {
      // " 1.test " - is not a list item
      return -1;
    }
  }
  return pos;
}
function markTightParagraphs(state, idx) {
  var i,
    l,
    level = state.level + 2;
  for (i = idx + 2, l = state.tokens.length - 2; i < l; i++) {
    if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
      state.tokens[i + 2].hidden = true;
      state.tokens[i].hidden = true;
      i += 2;
    }
  }
}
module.exports = function list(state, startLine, endLine, silent) {
  var ch,
    contentStart,
    i,
    indent,
    indentAfterMarker,
    initial,
    isOrdered,
    itemLines,
    l,
    listLines,
    listTokIdx,
    markerCharCode,
    markerValue,
    max,
    nextLine,
    offset,
    oldListIndent,
    oldParentType,
    oldSCount,
    oldTShift,
    oldTight,
    pos,
    posAfterMarker,
    prevEmptyEnd,
    start,
    terminate,
    terminatorRules,
    token,
    isTerminatingParagraph = false,
    tight = true;

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) {
    return false;
  }

  // Special case:
  //  - item 1
  //   - item 2
  //    - item 3
  //     - item 4
  //      - this one is a paragraph continuation
  if (state.listIndent >= 0 && state.sCount[startLine] - state.listIndent >= 4 && state.sCount[startLine] < state.blkIndent) {
    return false;
  }

  // limit conditions when list can interrupt
  // a paragraph (validation mode only)
  if (silent && state.parentType === 'paragraph') {
    // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    if (state.sCount[startLine] >= state.blkIndent) {
      isTerminatingParagraph = true;
    }
  }

  // Detect list type and position after marker
  if ((posAfterMarker = skipOrderedListMarker(state, startLine)) >= 0) {
    isOrdered = true;
    start = state.bMarks[startLine] + state.tShift[startLine];
    markerValue = Number(state.src.slice(start, posAfterMarker - 1));

    // If we're starting a new ordered list right after
    // a paragraph, it should start with 1.
    if (isTerminatingParagraph && markerValue !== 1) return false;
  } else if ((posAfterMarker = skipBulletListMarker(state, startLine)) >= 0) {
    isOrdered = false;
  } else {
    return false;
  }

  // If we're starting a new unordered list right after
  // a paragraph, first line should not be empty.
  if (isTerminatingParagraph) {
    if (state.skipSpaces(posAfterMarker) >= state.eMarks[startLine]) return false;
  }

  // We should terminate list on style change. Remember first one to compare.
  markerCharCode = state.src.charCodeAt(posAfterMarker - 1);

  // For validation mode we can terminate immediately
  if (silent) {
    return true;
  }

  // Start list
  listTokIdx = state.tokens.length;
  if (isOrdered) {
    token = state.push('ordered_list_open', 'ol', 1);
    if (markerValue !== 1) {
      token.attrs = [['start', markerValue]];
    }
  } else {
    token = state.push('bullet_list_open', 'ul', 1);
  }
  token.map = listLines = [startLine, 0];
  token.markup = String.fromCharCode(markerCharCode);

  //
  // Iterate list items
  //

  nextLine = startLine;
  prevEmptyEnd = false;
  terminatorRules = state.md.block.ruler.getRules('list');
  oldParentType = state.parentType;
  state.parentType = 'list';
  while (nextLine < endLine) {
    pos = posAfterMarker;
    max = state.eMarks[nextLine];
    initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[startLine] + state.tShift[startLine]);
    while (pos < max) {
      ch = state.src.charCodeAt(pos);
      if (ch === 0x09) {
        offset += 4 - (offset + state.bsCount[nextLine]) % 4;
      } else if (ch === 0x20) {
        offset++;
      } else {
        break;
      }
      pos++;
    }
    contentStart = pos;
    if (contentStart >= max) {
      // trimming space in "-    \n  3" case, indent is 1 here
      indentAfterMarker = 1;
    } else {
      indentAfterMarker = offset - initial;
    }

    // If we have more than 4 spaces, the indent is 1
    // (the rest is just indented code block)
    if (indentAfterMarker > 4) {
      indentAfterMarker = 1;
    }

    // "  -  test"
    //  ^^^^^ - calculating total length of this thing
    indent = initial + indentAfterMarker;

    // Run subparser & write tokens
    token = state.push('list_item_open', 'li', 1);
    token.markup = String.fromCharCode(markerCharCode);
    token.map = itemLines = [startLine, 0];
    if (isOrdered) {
      token.info = state.src.slice(start, posAfterMarker - 1);
    }

    // change current state, then restore it after parser subcall
    oldTight = state.tight;
    oldTShift = state.tShift[startLine];
    oldSCount = state.sCount[startLine];

    //  - example list
    // ^ listIndent position will be here
    //   ^ blkIndent position will be here
    //
    oldListIndent = state.listIndent;
    state.listIndent = state.blkIndent;
    state.blkIndent = indent;
    state.tight = true;
    state.tShift[startLine] = contentStart - state.bMarks[startLine];
    state.sCount[startLine] = offset;
    if (contentStart >= max && state.isEmpty(startLine + 1)) {
      // workaround for this case
      // (list item is empty, list terminates before "foo"):
      // ~~~~~~~~
      //   -
      //
      //     foo
      // ~~~~~~~~
      state.line = Math.min(state.line + 2, endLine);
    } else {
      state.md.block.tokenize(state, startLine, endLine, true);
    }

    // If any of list item is tight, mark list as tight
    if (!state.tight || prevEmptyEnd) {
      tight = false;
    }
    // Item become loose if finish with empty line,
    // but we should filter last element, because it means list finish
    prevEmptyEnd = state.line - startLine > 1 && state.isEmpty(state.line - 1);
    state.blkIndent = state.listIndent;
    state.listIndent = oldListIndent;
    state.tShift[startLine] = oldTShift;
    state.sCount[startLine] = oldSCount;
    state.tight = oldTight;
    token = state.push('list_item_close', 'li', -1);
    token.markup = String.fromCharCode(markerCharCode);
    nextLine = startLine = state.line;
    itemLines[1] = nextLine;
    contentStart = state.bMarks[startLine];
    if (nextLine >= endLine) {
      break;
    }

    //
    // Try to check if list is terminated or continued.
    //
    if (state.sCount[nextLine] < state.blkIndent) {
      break;
    }

    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) {
      break;
    }

    // fail if terminating block found
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) {
      break;
    }

    // fail if list has another type
    if (isOrdered) {
      posAfterMarker = skipOrderedListMarker(state, nextLine);
      if (posAfterMarker < 0) {
        break;
      }
      start = state.bMarks[nextLine] + state.tShift[nextLine];
    } else {
      posAfterMarker = skipBulletListMarker(state, nextLine);
      if (posAfterMarker < 0) {
        break;
      }
    }
    if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) {
      break;
    }
  }

  // Finalize list
  if (isOrdered) {
    token = state.push('ordered_list_close', 'ol', -1);
  } else {
    token = state.push('bullet_list_close', 'ul', -1);
  }
  token.markup = String.fromCharCode(markerCharCode);
  listLines[1] = nextLine;
  state.line = nextLine;
  state.parentType = oldParentType;

  // mark paragraphs tight if needed
  if (tight) {
    markTightParagraphs(state, listTokIdx);
  }
  return true;
};

/***/ }),

/***/ 71017:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Paragraph



__webpack_require__(73210);
__webpack_require__(21249);
module.exports = function paragraph(state, startLine /*, endLine*/) {
  var content,
    terminate,
    i,
    l,
    token,
    oldParentType,
    nextLine = startLine + 1,
    terminatorRules = state.md.block.ruler.getRules('paragraph'),
    endLine = state.lineMax;
  oldParentType = state.parentType;
  state.parentType = 'paragraph';

  // jump line-by-line until empty one or EOF
  for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
    // this would be a code block normally, but after paragraph
    // it's considered a lazy continuation regardless of what's there
    if (state.sCount[nextLine] - state.blkIndent > 3) {
      continue;
    }

    // quirk for blockquotes, this line should already be checked by that rule
    if (state.sCount[nextLine] < 0) {
      continue;
    }

    // Some tags can terminate paragraph without empty line.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) {
      break;
    }
  }
  content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
  state.line = nextLine;
  token = state.push('paragraph_open', 'p', 1);
  token.map = [startLine, state.line];
  token = state.push('inline', '', 0);
  token.content = content;
  token.map = [startLine, state.line];
  token.children = [];
  token = state.push('paragraph_close', 'p', -1);
  state.parentType = oldParentType;
  return true;
};

/***/ }),

/***/ 15379:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(73210);
__webpack_require__(47042);
var normalizeReference = __webpack_require__(14348).normalizeReference;
var isSpace = __webpack_require__(14348).isSpace;
module.exports = function reference(state, startLine, _endLine, silent) {
  var ch,
    destEndPos,
    destEndLineNo,
    endLine,
    href,
    i,
    l,
    label,
    labelEnd,
    oldParentType,
    res,
    start,
    str,
    terminate,
    terminatorRules,
    title,
    lines = 0,
    pos = state.bMarks[startLine] + state.tShift[startLine],
    max = state.eMarks[startLine],
    nextLine = startLine + 1;

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) {
    return false;
  }
  if (state.src.charCodeAt(pos) !== 0x5B /* [ */) {
    return false;
  }

  // Simple check to quickly interrupt scan on [link](url) at the start of line.
  // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
  while (++pos < max) {
    if (state.src.charCodeAt(pos) === 0x5D /* ] */ && state.src.charCodeAt(pos - 1) !== 0x5C /* \ */) {
      if (pos + 1 === max) {
        return false;
      }
      if (state.src.charCodeAt(pos + 1) !== 0x3A /* : */) {
        return false;
      }
      break;
    }
  }
  endLine = state.lineMax;

  // jump line-by-line until empty one or EOF
  terminatorRules = state.md.block.ruler.getRules('reference');
  oldParentType = state.parentType;
  state.parentType = 'reference';
  for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
    // this would be a code block normally, but after paragraph
    // it's considered a lazy continuation regardless of what's there
    if (state.sCount[nextLine] - state.blkIndent > 3) {
      continue;
    }

    // quirk for blockquotes, this line should already be checked by that rule
    if (state.sCount[nextLine] < 0) {
      continue;
    }

    // Some tags can terminate paragraph without empty line.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) {
      break;
    }
  }
  str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
  max = str.length;
  for (pos = 1; pos < max; pos++) {
    ch = str.charCodeAt(pos);
    if (ch === 0x5B /* [ */) {
      return false;
    } else if (ch === 0x5D /* ] */) {
      labelEnd = pos;
      break;
    } else if (ch === 0x0A /* \n */) {
      lines++;
    } else if (ch === 0x5C /* \ */) {
      pos++;
      if (pos < max && str.charCodeAt(pos) === 0x0A) {
        lines++;
      }
    }
  }
  if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */) {
    return false;
  }

  // [label]:   destination   'title'
  //         ^^^ skip optional whitespace here
  for (pos = labelEnd + 2; pos < max; pos++) {
    ch = str.charCodeAt(pos);
    if (ch === 0x0A) {
      lines++;
    } else if (isSpace(ch)) {
      /*eslint no-empty:0*/
    } else {
      break;
    }
  }

  // [label]:   destination   'title'
  //            ^^^^^^^^^^^ parse this
  res = state.md.helpers.parseLinkDestination(str, pos, max);
  if (!res.ok) {
    return false;
  }
  href = state.md.normalizeLink(res.str);
  if (!state.md.validateLink(href)) {
    return false;
  }
  pos = res.pos;
  lines += res.lines;

  // save cursor state, we could require to rollback later
  destEndPos = pos;
  destEndLineNo = lines;

  // [label]:   destination   'title'
  //                       ^^^ skipping those spaces
  start = pos;
  for (; pos < max; pos++) {
    ch = str.charCodeAt(pos);
    if (ch === 0x0A) {
      lines++;
    } else if (isSpace(ch)) {
      /*eslint no-empty:0*/
    } else {
      break;
    }
  }

  // [label]:   destination   'title'
  //                          ^^^^^^^ parse this
  res = state.md.helpers.parseLinkTitle(str, pos, max);
  if (pos < max && start !== pos && res.ok) {
    title = res.str;
    pos = res.pos;
    lines += res.lines;
  } else {
    title = '';
    pos = destEndPos;
    lines = destEndLineNo;
  }

  // skip trailing spaces until the rest of the line
  while (pos < max) {
    ch = str.charCodeAt(pos);
    if (!isSpace(ch)) {
      break;
    }
    pos++;
  }
  if (pos < max && str.charCodeAt(pos) !== 0x0A) {
    if (title) {
      // garbage at the end of the line after title,
      // but it could still be a valid reference if we roll back
      title = '';
      pos = destEndPos;
      lines = destEndLineNo;
      while (pos < max) {
        ch = str.charCodeAt(pos);
        if (!isSpace(ch)) {
          break;
        }
        pos++;
      }
    }
  }
  if (pos < max && str.charCodeAt(pos) !== 0x0A) {
    // garbage at the end of the line
    return false;
  }
  label = normalizeReference(str.slice(1, labelEnd));
  if (!label) {
    // CommonMark 0.20 disallows empty labels
    return false;
  }

  // Reference can not terminate anything. This check is for safety only.
  /*istanbul ignore if*/
  if (silent) {
    return true;
  }
  if (typeof state.env.references === 'undefined') {
    state.env.references = {};
  }
  if (typeof state.env.references[label] === 'undefined') {
    state.env.references[label] = {
      title: title,
      href: href
    };
  }
  state.parentType = oldParentType;
  state.line = startLine + lines + 1;
  return true;
};

/***/ }),

/***/ 89157:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Parser state class



__webpack_require__(69600);
__webpack_require__(47042);
var Token = __webpack_require__(98640);
var isSpace = __webpack_require__(14348).isSpace;
function StateBlock(src, md, env, tokens) {
  var ch, s, start, pos, len, indent, offset, indent_found;
  this.src = src;

  // link to parser instance
  this.md = md;
  this.env = env;

  //
  // Internal state vartiables
  //

  this.tokens = tokens;
  this.bMarks = []; // line begin offsets for fast jumps
  this.eMarks = []; // line end offsets for fast jumps
  this.tShift = []; // offsets of the first non-space characters (tabs not expanded)
  this.sCount = []; // indents for each line (tabs expanded)

  // An amount of virtual spaces (tabs expanded) between beginning
  // of each line (bMarks) and real beginning of that line.
  //
  // It exists only as a hack because blockquotes override bMarks
  // losing information in the process.
  //
  // It's used only when expanding tabs, you can think about it as
  // an initial tab length, e.g. bsCount=21 applied to string `\t123`
  // means first tab should be expanded to 4-21%4 === 3 spaces.
  //
  this.bsCount = [];

  // block parser variables
  this.blkIndent = 0; // required block content indent (for example, if we are
  // inside a list, it would be positioned after list marker)
  this.line = 0; // line index in src
  this.lineMax = 0; // lines count
  this.tight = false; // loose/tight mode for lists
  this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)
  this.listIndent = -1; // indent of the current list block (-1 if there isn't any)

  // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
  // used in lists to determine if they interrupt a paragraph
  this.parentType = 'root';
  this.level = 0;

  // renderer
  this.result = '';

  // Create caches
  // Generate markers.
  s = this.src;
  indent_found = false;
  for (start = pos = indent = offset = 0, len = s.length; pos < len; pos++) {
    ch = s.charCodeAt(pos);
    if (!indent_found) {
      if (isSpace(ch)) {
        indent++;
        if (ch === 0x09) {
          offset += 4 - offset % 4;
        } else {
          offset++;
        }
        continue;
      } else {
        indent_found = true;
      }
    }
    if (ch === 0x0A || pos === len - 1) {
      if (ch !== 0x0A) {
        pos++;
      }
      this.bMarks.push(start);
      this.eMarks.push(pos);
      this.tShift.push(indent);
      this.sCount.push(offset);
      this.bsCount.push(0);
      indent_found = false;
      indent = 0;
      offset = 0;
      start = pos + 1;
    }
  }

  // Push fake entry to simplify cache bounds checks
  this.bMarks.push(s.length);
  this.eMarks.push(s.length);
  this.tShift.push(0);
  this.sCount.push(0);
  this.bsCount.push(0);
  this.lineMax = this.bMarks.length - 1; // don't count last fake line
}

// Push new token to "stream".
//
StateBlock.prototype.push = function (type, tag, nesting) {
  var token = new Token(type, tag, nesting);
  token.block = true;
  if (nesting < 0) this.level--; // closing tag
  token.level = this.level;
  if (nesting > 0) this.level++; // opening tag

  this.tokens.push(token);
  return token;
};
StateBlock.prototype.isEmpty = function isEmpty(line) {
  return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
  for (var max = this.lineMax; from < max; from++) {
    if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) {
      break;
    }
  }
  return from;
};

// Skip spaces from given position.
StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
  var ch;
  for (var max = this.src.length; pos < max; pos++) {
    ch = this.src.charCodeAt(pos);
    if (!isSpace(ch)) {
      break;
    }
  }
  return pos;
};

// Skip spaces from given position in reverse.
StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
  if (pos <= min) {
    return pos;
  }
  while (pos > min) {
    if (!isSpace(this.src.charCodeAt(--pos))) {
      return pos + 1;
    }
  }
  return pos;
};

// Skip char codes from given position
StateBlock.prototype.skipChars = function skipChars(pos, code) {
  for (var max = this.src.length; pos < max; pos++) {
    if (this.src.charCodeAt(pos) !== code) {
      break;
    }
  }
  return pos;
};

// Skip char codes reverse from given position - 1
StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
  if (pos <= min) {
    return pos;
  }
  while (pos > min) {
    if (code !== this.src.charCodeAt(--pos)) {
      return pos + 1;
    }
  }
  return pos;
};

// cut lines range from source.
StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
  var i,
    lineIndent,
    ch,
    first,
    last,
    queue,
    lineStart,
    line = begin;
  if (begin >= end) {
    return '';
  }
  queue = new Array(end - begin);
  for (i = 0; line < end; line++, i++) {
    lineIndent = 0;
    lineStart = first = this.bMarks[line];
    if (line + 1 < end || keepLastLF) {
      // No need for bounds check because we have fake entry on tail.
      last = this.eMarks[line] + 1;
    } else {
      last = this.eMarks[line];
    }
    while (first < last && lineIndent < indent) {
      ch = this.src.charCodeAt(first);
      if (isSpace(ch)) {
        if (ch === 0x09) {
          lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
        } else {
          lineIndent++;
        }
      } else if (first - lineStart < this.tShift[line]) {
        // patched tShift masked characters to look like spaces (blockquotes, list markers)
        lineIndent++;
      } else {
        break;
      }
      first++;
    }
    if (lineIndent > indent) {
      // partially expanding tabs in code blocks, e.g '\t\tfoobar'
      // with indent=2 becomes '  \tfoobar'
      queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
    } else {
      queue[i] = this.src.slice(first, last);
    }
  }
  return queue.join('');
};

// re-export Token class to use in block rules
StateBlock.prototype.Token = Token;
module.exports = StateBlock;

/***/ }),

/***/ 41069:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// GFM table, https://github.github.com/gfm/#tables-extension-



__webpack_require__(47042);
__webpack_require__(74916);
__webpack_require__(23123);
__webpack_require__(73210);
__webpack_require__(21249);
var isSpace = __webpack_require__(14348).isSpace;
function getLine(state, line) {
  var pos = state.bMarks[line] + state.tShift[line],
    max = state.eMarks[line];
  return state.src.slice(pos, max);
}
function escapedSplit(str) {
  var result = [],
    pos = 0,
    max = str.length,
    ch,
    isEscaped = false,
    lastPos = 0,
    current = '';
  ch = str.charCodeAt(pos);
  while (pos < max) {
    if (ch === 0x7c /* | */) {
      if (!isEscaped) {
        // pipe separating cells, '|'
        result.push(current + str.substring(lastPos, pos));
        current = '';
        lastPos = pos + 1;
      } else {
        // escaped pipe, '\|'
        current += str.substring(lastPos, pos - 1);
        lastPos = pos;
      }
    }
    isEscaped = ch === 0x5c /* \ */;
    pos++;
    ch = str.charCodeAt(pos);
  }
  result.push(current + str.substring(lastPos));
  return result;
}
module.exports = function table(state, startLine, endLine, silent) {
  var ch, lineText, pos, i, l, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines, oldParentType, terminate, terminatorRules, firstCh, secondCh;

  // should have at least two lines
  if (startLine + 2 > endLine) {
    return false;
  }
  nextLine = startLine + 1;
  if (state.sCount[nextLine] < state.blkIndent) {
    return false;
  }

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[nextLine] - state.blkIndent >= 4) {
    return false;
  }

  // first character of the second line should be '|', '-', ':',
  // and no other characters are allowed but spaces;
  // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp

  pos = state.bMarks[nextLine] + state.tShift[nextLine];
  if (pos >= state.eMarks[nextLine]) {
    return false;
  }
  firstCh = state.src.charCodeAt(pos++);
  if (firstCh !== 0x7C /* | */ && firstCh !== 0x2D /* - */ && firstCh !== 0x3A /* : */) {
    return false;
  }
  if (pos >= state.eMarks[nextLine]) {
    return false;
  }
  secondCh = state.src.charCodeAt(pos++);
  if (secondCh !== 0x7C /* | */ && secondCh !== 0x2D /* - */ && secondCh !== 0x3A /* : */ && !isSpace(secondCh)) {
    return false;
  }

  // if first character is '-', then second character must not be a space
  // (due to parsing ambiguity with list)
  if (firstCh === 0x2D /* - */ && isSpace(secondCh)) {
    return false;
  }
  while (pos < state.eMarks[nextLine]) {
    ch = state.src.charCodeAt(pos);
    if (ch !== 0x7C /* | */ && ch !== 0x2D /* - */ && ch !== 0x3A /* : */ && !isSpace(ch)) {
      return false;
    }
    pos++;
  }
  lineText = getLine(state, startLine + 1);
  columns = lineText.split('|');
  aligns = [];
  for (i = 0; i < columns.length; i++) {
    t = columns[i].trim();
    if (!t) {
      // allow empty columns before and after table, but not in between columns;
      // e.g. allow ` |---| `, disallow ` ---||--- `
      if (i === 0 || i === columns.length - 1) {
        continue;
      } else {
        return false;
      }
    }
    if (!/^:?-+:?$/.test(t)) {
      return false;
    }
    if (t.charCodeAt(t.length - 1) === 0x3A /* : */) {
      aligns.push(t.charCodeAt(0) === 0x3A /* : */ ? 'center' : 'right');
    } else if (t.charCodeAt(0) === 0x3A /* : */) {
      aligns.push('left');
    } else {
      aligns.push('');
    }
  }
  lineText = getLine(state, startLine).trim();
  if (lineText.indexOf('|') === -1) {
    return false;
  }
  if (state.sCount[startLine] - state.blkIndent >= 4) {
    return false;
  }
  columns = escapedSplit(lineText);
  if (columns.length && columns[0] === '') columns.shift();
  if (columns.length && columns[columns.length - 1] === '') columns.pop();

  // header row will define an amount of columns in the entire table,
  // and align row should be exactly the same (the rest of the rows can differ)
  columnCount = columns.length;
  if (columnCount === 0 || columnCount !== aligns.length) {
    return false;
  }
  if (silent) {
    return true;
  }
  oldParentType = state.parentType;
  state.parentType = 'table';

  // use 'blockquote' lists for termination because it's
  // the most similar to tables
  terminatorRules = state.md.block.ruler.getRules('blockquote');
  token = state.push('table_open', 'table', 1);
  token.map = tableLines = [startLine, 0];
  token = state.push('thead_open', 'thead', 1);
  token.map = [startLine, startLine + 1];
  token = state.push('tr_open', 'tr', 1);
  token.map = [startLine, startLine + 1];
  for (i = 0; i < columns.length; i++) {
    token = state.push('th_open', 'th', 1);
    if (aligns[i]) {
      token.attrs = [['style', 'text-align:' + aligns[i]]];
    }
    token = state.push('inline', '', 0);
    token.content = columns[i].trim();
    token.children = [];
    token = state.push('th_close', 'th', -1);
  }
  token = state.push('tr_close', 'tr', -1);
  token = state.push('thead_close', 'thead', -1);
  for (nextLine = startLine + 2; nextLine < endLine; nextLine++) {
    if (state.sCount[nextLine] < state.blkIndent) {
      break;
    }
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) {
      break;
    }
    lineText = getLine(state, nextLine).trim();
    if (!lineText) {
      break;
    }
    if (state.sCount[nextLine] - state.blkIndent >= 4) {
      break;
    }
    columns = escapedSplit(lineText);
    if (columns.length && columns[0] === '') columns.shift();
    if (columns.length && columns[columns.length - 1] === '') columns.pop();
    if (nextLine === startLine + 2) {
      token = state.push('tbody_open', 'tbody', 1);
      token.map = tbodyLines = [startLine + 2, 0];
    }
    token = state.push('tr_open', 'tr', 1);
    token.map = [nextLine, nextLine + 1];
    for (i = 0; i < columnCount; i++) {
      token = state.push('td_open', 'td', 1);
      if (aligns[i]) {
        token.attrs = [['style', 'text-align:' + aligns[i]]];
      }
      token = state.push('inline', '', 0);
      token.content = columns[i] ? columns[i].trim() : '';
      token.children = [];
      token = state.push('td_close', 'td', -1);
    }
    token = state.push('tr_close', 'tr', -1);
  }
  if (tbodyLines) {
    token = state.push('tbody_close', 'tbody', -1);
    tbodyLines[1] = nextLine;
  }
  token = state.push('table_close', 'table', -1);
  tableLines[1] = nextLine;
  state.parentType = oldParentType;
  state.line = nextLine;
  return true;
};

/***/ }),

/***/ 58992:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(21249);
module.exports = function block(state) {
  var token;
  if (state.inlineMode) {
    token = new state.Token('inline', '', 0);
    token.content = state.src;
    token.map = [0, 1];
    token.children = [];
    state.tokens.push(token);
  } else {
    state.md.block.parse(state.src, state.md, state.env, state.tokens);
  }
};

/***/ }),

/***/ 6676:
/***/ ((module) => {

"use strict";


module.exports = function inline(state) {
  var tokens = state.tokens,
    tok,
    i,
    l;

  // Parse inlines
  for (i = 0, l = tokens.length; i < l; i++) {
    tok = tokens[i];
    if (tok.type === 'inline') {
      state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
  }
};

/***/ }),

/***/ 31380:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//


__webpack_require__(74916);
__webpack_require__(4723);
__webpack_require__(47042);
__webpack_require__(15306);
var arrayReplaceAt = __webpack_require__(14348).arrayReplaceAt;
function isLinkOpen(str) {
  return /^<a[>\s]/i.test(str);
}
function isLinkClose(str) {
  return /^<\/a\s*>/i.test(str);
}
module.exports = function linkify(state) {
  var i,
    j,
    l,
    tokens,
    token,
    currentToken,
    nodes,
    ln,
    text,
    pos,
    lastPos,
    level,
    htmlLinkLevel,
    url,
    fullUrl,
    urlText,
    blockTokens = state.tokens,
    links;
  if (!state.md.options.linkify) {
    return;
  }
  for (j = 0, l = blockTokens.length; j < l; j++) {
    if (blockTokens[j].type !== 'inline' || !state.md.linkify.pretest(blockTokens[j].content)) {
      continue;
    }
    tokens = blockTokens[j].children;
    htmlLinkLevel = 0;

    // We scan from the end, to keep position when new tags added.
    // Use reversed logic in links start/end match
    for (i = tokens.length - 1; i >= 0; i--) {
      currentToken = tokens[i];

      // Skip content of markdown links
      if (currentToken.type === 'link_close') {
        i--;
        while (tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open') {
          i--;
        }
        continue;
      }

      // Skip content of html tag links
      if (currentToken.type === 'html_inline') {
        if (isLinkOpen(currentToken.content) && htmlLinkLevel > 0) {
          htmlLinkLevel--;
        }
        if (isLinkClose(currentToken.content)) {
          htmlLinkLevel++;
        }
      }
      if (htmlLinkLevel > 0) {
        continue;
      }
      if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {
        text = currentToken.content;
        links = state.md.linkify.match(text);

        // Now split string to nodes
        nodes = [];
        level = currentToken.level;
        lastPos = 0;

        // forbid escape sequence at the start of the string,
        // this avoids http\://example.com/ from being linkified as
        // http:<a href="//example.com/">//example.com/</a>
        if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === 'text_special') {
          links = links.slice(1);
        }
        for (ln = 0; ln < links.length; ln++) {
          url = links[ln].url;
          fullUrl = state.md.normalizeLink(url);
          if (!state.md.validateLink(fullUrl)) {
            continue;
          }
          urlText = links[ln].text;

          // Linkifier might send raw hostnames like "example.com", where url
          // starts with domain name. So we prepend http:// in those cases,
          // and remove it afterwards.
          //
          if (!links[ln].schema) {
            urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
          } else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) {
            urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
          } else {
            urlText = state.md.normalizeLinkText(urlText);
          }
          pos = links[ln].index;
          if (pos > lastPos) {
            token = new state.Token('text', '', 0);
            token.content = text.slice(lastPos, pos);
            token.level = level;
            nodes.push(token);
          }
          token = new state.Token('link_open', 'a', 1);
          token.attrs = [['href', fullUrl]];
          token.level = level++;
          token.markup = 'linkify';
          token.info = 'auto';
          nodes.push(token);
          token = new state.Token('text', '', 0);
          token.content = urlText;
          token.level = level;
          nodes.push(token);
          token = new state.Token('link_close', 'a', -1);
          token.level = --level;
          token.markup = 'linkify';
          token.info = 'auto';
          nodes.push(token);
          lastPos = links[ln].lastIndex;
        }
        if (lastPos < text.length) {
          token = new state.Token('text', '', 0);
          token.content = text.slice(lastPos);
          token.level = level;
          nodes.push(token);
        }

        // replace current node
        blockTokens[j].children = tokens = arrayReplaceAt(tokens, i, nodes);
      }
    }
  }
};

/***/ }),

/***/ 56817:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Normalize input string



// https://spec.commonmark.org/0.29/#line-ending
__webpack_require__(74916);
__webpack_require__(15306);
var NEWLINES_RE = /\r\n?|\n/g;
var NULL_RE = /\0/g;
module.exports = function normalize(state) {
  var str;

  // Normalize newlines
  str = state.src.replace(NEWLINES_RE, '\n');

  // Replace NULL characters
  str = str.replace(NULL_RE, "\uFFFD");
  state.src = str;
};

/***/ }),

/***/ 93365:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// (p) (P) -> §
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//


// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
__webpack_require__(74916);
__webpack_require__(15306);
var RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;

// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
var SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
var SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
var SCOPED_ABBR = {
  c: '©',
  r: '®',
  tm: '™'
};
function replaceFn(match, name) {
  return SCOPED_ABBR[name.toLowerCase()];
}
function replace_scoped(inlineTokens) {
  var i,
    token,
    inside_autolink = 0;
  for (i = inlineTokens.length - 1; i >= 0; i--) {
    token = inlineTokens[i];
    if (token.type === 'text' && !inside_autolink) {
      token.content = token.content.replace(SCOPED_ABBR_RE, replaceFn);
    }
    if (token.type === 'link_open' && token.info === 'auto') {
      inside_autolink--;
    }
    if (token.type === 'link_close' && token.info === 'auto') {
      inside_autolink++;
    }
  }
}
function replace_rare(inlineTokens) {
  var i,
    token,
    inside_autolink = 0;
  for (i = inlineTokens.length - 1; i >= 0; i--) {
    token = inlineTokens[i];
    if (token.type === 'text' && !inside_autolink) {
      if (RARE_RE.test(token.content)) {
        token.content = token.content.replace(/\+-/g, '±')
        // .., ..., ....... -> …
        // but ?..... & !..... -> ?.. & !..
        .replace(/\.{2,}/g, '…').replace(/([?!])…/g, '$1..').replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')
        // em-dash
        .replace(/(^|[^-])---(?=[^-]|$)/mg, "$1\u2014")
        // en-dash
        .replace(/(^|\s)--(?=\s|$)/mg, "$1\u2013").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1\u2013");
      }
    }
    if (token.type === 'link_open' && token.info === 'auto') {
      inside_autolink--;
    }
    if (token.type === 'link_close' && token.info === 'auto') {
      inside_autolink++;
    }
  }
}
module.exports = function replace(state) {
  var blkIdx;
  if (!state.md.options.typographer) {
    return;
  }
  for (blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--) {
    if (state.tokens[blkIdx].type !== 'inline') {
      continue;
    }
    if (SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) {
      replace_scoped(state.tokens[blkIdx].children);
    }
    if (RARE_RE.test(state.tokens[blkIdx].content)) {
      replace_rare(state.tokens[blkIdx].children);
    }
  }
};

/***/ }),

/***/ 77937:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Convert straight quotation marks to typographic ones
//


__webpack_require__(47042);
__webpack_require__(74916);
var isWhiteSpace = __webpack_require__(14348).isWhiteSpace;
var isPunctChar = __webpack_require__(14348).isPunctChar;
var isMdAsciiPunct = __webpack_require__(14348).isMdAsciiPunct;
var QUOTE_TEST_RE = /['"]/;
var QUOTE_RE = /['"]/g;
var APOSTROPHE = "\u2019"; /* ’ */

function replaceAt(str, index, ch) {
  return str.slice(0, index) + ch + str.slice(index + 1);
}
function process_inlines(tokens, state) {
  var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar, isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace, canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;
  stack = [];
  for (i = 0; i < tokens.length; i++) {
    token = tokens[i];
    thisLevel = tokens[i].level;
    for (j = stack.length - 1; j >= 0; j--) {
      if (stack[j].level <= thisLevel) {
        break;
      }
    }
    stack.length = j + 1;
    if (token.type !== 'text') {
      continue;
    }
    text = token.content;
    pos = 0;
    max = text.length;

    /*eslint no-labels:0,block-scoped-var:0*/
    OUTER: while (pos < max) {
      QUOTE_RE.lastIndex = pos;
      t = QUOTE_RE.exec(text);
      if (!t) {
        break;
      }
      canOpen = canClose = true;
      pos = t.index + 1;
      isSingle = t[0] === "'";

      // Find previous character,
      // default to space if it's the beginning of the line
      //
      lastChar = 0x20;
      if (t.index - 1 >= 0) {
        lastChar = text.charCodeAt(t.index - 1);
      } else {
        for (j = i - 1; j >= 0; j--) {
          if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
          if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'

          lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
          break;
        }
      }

      // Find next character,
      // default to space if it's the end of the line
      //
      nextChar = 0x20;
      if (pos < max) {
        nextChar = text.charCodeAt(pos);
      } else {
        for (j = i + 1; j < tokens.length; j++) {
          if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
          if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'

          nextChar = tokens[j].content.charCodeAt(0);
          break;
        }
      }
      isLastPunctChar = isMdAsciiPunct(lastChar) || isPunctChar(String.fromCharCode(lastChar));
      isNextPunctChar = isMdAsciiPunct(nextChar) || isPunctChar(String.fromCharCode(nextChar));
      isLastWhiteSpace = isWhiteSpace(lastChar);
      isNextWhiteSpace = isWhiteSpace(nextChar);
      if (isNextWhiteSpace) {
        canOpen = false;
      } else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) {
          canOpen = false;
        }
      }
      if (isLastWhiteSpace) {
        canClose = false;
      } else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) {
          canClose = false;
        }
      }
      if (nextChar === 0x22 /* " */ && t[0] === '"') {
        if (lastChar >= 0x30 /* 0 */ && lastChar <= 0x39 /* 9 */) {
          // special case: 1"" - count first quote as an inch
          canClose = canOpen = false;
        }
      }
      if (canOpen && canClose) {
        // Replace quotes in the middle of punctuation sequence, but not
        // in the middle of the words, i.e.:
        //
        // 1. foo " bar " baz - not replaced
        // 2. foo-"-bar-"-baz - replaced
        // 3. foo"bar"baz     - not replaced
        //
        canOpen = isLastPunctChar;
        canClose = isNextPunctChar;
      }
      if (!canOpen && !canClose) {
        // middle of word
        if (isSingle) {
          token.content = replaceAt(token.content, t.index, APOSTROPHE);
        }
        continue;
      }
      if (canClose) {
        // this could be a closing quote, rewind the stack to get a match
        for (j = stack.length - 1; j >= 0; j--) {
          item = stack[j];
          if (stack[j].level < thisLevel) {
            break;
          }
          if (item.single === isSingle && stack[j].level === thisLevel) {
            item = stack[j];
            if (isSingle) {
              openQuote = state.md.options.quotes[2];
              closeQuote = state.md.options.quotes[3];
            } else {
              openQuote = state.md.options.quotes[0];
              closeQuote = state.md.options.quotes[1];
            }

            // replace token.content *before* tokens[item.token].content,
            // because, if they are pointing at the same token, replaceAt
            // could mess up indices when quote length != 1
            token.content = replaceAt(token.content, t.index, closeQuote);
            tokens[item.token].content = replaceAt(tokens[item.token].content, item.pos, openQuote);
            pos += closeQuote.length - 1;
            if (item.token === i) {
              pos += openQuote.length - 1;
            }
            text = token.content;
            max = text.length;
            stack.length = j;
            continue OUTER;
          }
        }
      }
      if (canOpen) {
        stack.push({
          token: i,
          pos: t.index,
          single: isSingle,
          level: thisLevel
        });
      } else if (canClose && isSingle) {
        token.content = replaceAt(token.content, t.index, APOSTROPHE);
      }
    }
  }
}
module.exports = function smartquotes(state) {
  /*eslint max-depth:0*/
  var blkIdx;
  if (!state.md.options.typographer) {
    return;
  }
  for (blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--) {
    if (state.tokens[blkIdx].type !== 'inline' || !QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) {
      continue;
    }
    process_inlines(state.tokens[blkIdx].children, state);
  }
};

/***/ }),

/***/ 20110:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Core state object
//


var Token = __webpack_require__(98640);
function StateCore(src, md, env) {
  this.src = src;
  this.env = env;
  this.tokens = [];
  this.inlineMode = false;
  this.md = md; // link to parser instance
}

// re-export Token class to use in core rules
StateCore.prototype.Token = Token;
module.exports = StateCore;

/***/ }),

/***/ 48662:
/***/ ((module) => {

"use strict";
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//


module.exports = function text_join(state) {
  var j,
    l,
    tokens,
    curr,
    max,
    last,
    blockTokens = state.tokens;
  for (j = 0, l = blockTokens.length; j < l; j++) {
    if (blockTokens[j].type !== 'inline') continue;
    tokens = blockTokens[j].children;
    max = tokens.length;
    for (curr = 0; curr < max; curr++) {
      if (tokens[curr].type === 'text_special') {
        tokens[curr].type = 'text';
      }
    }
    for (curr = last = 0; curr < max; curr++) {
      if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') {
        // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
      } else {
        if (curr !== last) {
          tokens[last] = tokens[curr];
        }
        last++;
      }
    }
    if (curr !== last) {
      tokens.length = last;
    }
  }
};

/***/ }),

/***/ 11758:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Process autolinks '<protocol:...>'



/*eslint max-len:0*/
__webpack_require__(47042);
var EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
var AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/;
module.exports = function autolink(state, silent) {
  var url,
    fullUrl,
    token,
    ch,
    start,
    max,
    pos = state.pos;
  if (state.src.charCodeAt(pos) !== 0x3C /* < */) {
    return false;
  }
  start = state.pos;
  max = state.posMax;
  for (;;) {
    if (++pos >= max) return false;
    ch = state.src.charCodeAt(pos);
    if (ch === 0x3C /* < */) return false;
    if (ch === 0x3E /* > */) break;
  }
  url = state.src.slice(start + 1, pos);
  if (AUTOLINK_RE.test(url)) {
    fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) {
      return false;
    }
    if (!silent) {
      token = state.push('link_open', 'a', 1);
      token.attrs = [['href', fullUrl]];
      token.markup = 'autolink';
      token.info = 'auto';
      token = state.push('text', '', 0);
      token.content = state.md.normalizeLinkText(url);
      token = state.push('link_close', 'a', -1);
      token.markup = 'autolink';
      token.info = 'auto';
    }
    state.pos += url.length + 2;
    return true;
  }
  if (EMAIL_RE.test(url)) {
    fullUrl = state.md.normalizeLink('mailto:' + url);
    if (!state.md.validateLink(fullUrl)) {
      return false;
    }
    if (!silent) {
      token = state.push('link_open', 'a', 1);
      token.attrs = [['href', fullUrl]];
      token.markup = 'autolink';
      token.info = 'auto';
      token = state.push('text', '', 0);
      token.content = state.md.normalizeLinkText(url);
      token = state.push('link_close', 'a', -1);
      token.markup = 'autolink';
      token.info = 'auto';
    }
    state.pos += url.length + 2;
    return true;
  }
  return false;
};

/***/ }),

/***/ 58677:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Parse backticks



__webpack_require__(47042);
__webpack_require__(74916);
__webpack_require__(15306);
module.exports = function backtick(state, silent) {
  var start,
    max,
    marker,
    token,
    matchStart,
    matchEnd,
    openerLength,
    closerLength,
    pos = state.pos,
    ch = state.src.charCodeAt(pos);
  if (ch !== 0x60 /* ` */) {
    return false;
  }
  start = pos;
  pos++;
  max = state.posMax;

  // scan marker length
  while (pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */) {
    pos++;
  }
  marker = state.src.slice(start, pos);
  openerLength = marker.length;
  if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
  }
  matchStart = matchEnd = pos;

  // Nothing found in the cache, scan until the end of the line (or until marker is found)
  while ((matchStart = state.src.indexOf('`', matchEnd)) !== -1) {
    matchEnd = matchStart + 1;

    // scan marker length
    while (matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */) {
      matchEnd++;
    }
    closerLength = matchEnd - matchStart;
    if (closerLength === openerLength) {
      // Found matching closer length.
      if (!silent) {
        token = state.push('code_inline', 'code', 0);
        token.markup = marker;
        token.content = state.src.slice(pos, matchStart).replace(/\n/g, ' ').replace(/^ (.+) $/, '$1');
      }
      state.pos = matchEnd;
      return true;
    }

    // Some different length found, put it in cache as upper limit of where closer can be found
    state.backticks[closerLength] = matchStart;
  }

  // Scanned through the end, didn't find anything
  state.backticksScanned = true;
  if (!silent) state.pending += marker;
  state.pos += openerLength;
  return true;
};

/***/ }),

/***/ 51500:
/***/ ((module) => {

"use strict";
// For each opening emphasis-like marker find a matching closing one
//


function processDelimiters(state, delimiters) {
  var closerIdx,
    openerIdx,
    closer,
    opener,
    minOpenerIdx,
    newMinOpenerIdx,
    isOddMatch,
    lastJump,
    openersBottom = {},
    max = delimiters.length;
  if (!max) return;

  // headerIdx is the first delimiter of the current (where closer is) delimiter run
  var headerIdx = 0;
  var lastTokenIdx = -2; // needs any value lower than -1
  var jumps = [];
  for (closerIdx = 0; closerIdx < max; closerIdx++) {
    closer = delimiters[closerIdx];
    jumps.push(0);

    // markers belong to same delimiter run if:
    //  - they have adjacent tokens
    //  - AND markers are the same
    //
    if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) {
      headerIdx = closerIdx;
    }
    lastTokenIdx = closer.token;

    // Length is only used for emphasis-specific "rule of 3",
    // if it's not defined (in strikethrough or 3rd party plugins),
    // we can default it to 0 to disable those checks.
    //
    closer.length = closer.length || 0;
    if (!closer.close) continue;

    // Previously calculated lower bounds (previous fails)
    // for each marker, each delimiter length modulo 3,
    // and for whether this closer can be an opener;
    // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
    if (!openersBottom.hasOwnProperty(closer.marker)) {
      openersBottom[closer.marker] = [-1, -1, -1, -1, -1, -1];
    }
    minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
    openerIdx = headerIdx - jumps[headerIdx] - 1;
    newMinOpenerIdx = openerIdx;
    for (; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1) {
      opener = delimiters[openerIdx];
      if (opener.marker !== closer.marker) continue;
      if (opener.open && opener.end < 0) {
        isOddMatch = false;

        // from spec:
        //
        // If one of the delimiters can both open and close emphasis, then the
        // sum of the lengths of the delimiter runs containing the opening and
        // closing delimiters must not be a multiple of 3 unless both lengths
        // are multiples of 3.
        //
        if (opener.close || closer.open) {
          if ((opener.length + closer.length) % 3 === 0) {
            if (opener.length % 3 !== 0 || closer.length % 3 !== 0) {
              isOddMatch = true;
            }
          }
        }
        if (!isOddMatch) {
          // If previous delimiter cannot be an opener, we can safely skip
          // the entire sequence in future checks. This is required to make
          // sure algorithm has linear complexity (see *_*_*_*_*_... case).
          //
          lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
          jumps[closerIdx] = closerIdx - openerIdx + lastJump;
          jumps[openerIdx] = lastJump;
          closer.open = false;
          opener.end = closerIdx;
          opener.close = false;
          newMinOpenerIdx = -1;
          // treat next token as start of run,
          // it optimizes skips in **<...>**a**<...>** pathological case
          lastTokenIdx = -2;
          break;
        }
      }
    }
    if (newMinOpenerIdx !== -1) {
      // If match for this delimiter run failed, we want to set lower bound for
      // future lookups. This is required to make sure algorithm has linear
      // complexity.
      //
      // See details here:
      // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
      //
      openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
  }
}
module.exports = function link_pairs(state) {
  var curr,
    tokens_meta = state.tokens_meta,
    max = state.tokens_meta.length;
  processDelimiters(state, state.delimiters);
  for (curr = 0; curr < max; curr++) {
    if (tokens_meta[curr] && tokens_meta[curr].delimiters) {
      processDelimiters(state, tokens_meta[curr].delimiters);
    }
  }
};

/***/ }),

/***/ 18949:
/***/ ((module) => {

"use strict";
// Process *this* and _that_
//


// Insert each marker as a separate text token, and add it to delimiter list
//
module.exports.w = function emphasis(state, silent) {
  var i,
    scanned,
    token,
    start = state.pos,
    marker = state.src.charCodeAt(start);
  if (silent) {
    return false;
  }
  if (marker !== 0x5F /* _ */ && marker !== 0x2A /* * */) {
    return false;
  }
  scanned = state.scanDelims(state.pos, marker === 0x2A);
  for (i = 0; i < scanned.length; i++) {
    token = state.push('text', '', 0);
    token.content = String.fromCharCode(marker);
    state.delimiters.push({
      // Char code of the starting marker (number).
      //
      marker: marker,
      // Total length of these series of delimiters.
      //
      length: scanned.length,
      // A position of the token this delimiter corresponds to.
      //
      token: state.tokens.length - 1,
      // If this delimiter is matched as a valid opener, `end` will be
      // equal to its position, otherwise it's `-1`.
      //
      end: -1,
      // Boolean flags that determine if this delimiter could open or close
      // an emphasis.
      //
      open: scanned.can_open,
      close: scanned.can_close
    });
  }
  state.pos += scanned.length;
  return true;
};
function postProcess(state, delimiters) {
  var i,
    startDelim,
    endDelim,
    token,
    ch,
    isStrong,
    max = delimiters.length;
  for (i = max - 1; i >= 0; i--) {
    startDelim = delimiters[i];
    if (startDelim.marker !== 0x5F /* _ */ && startDelim.marker !== 0x2A /* * */) {
      continue;
    }

    // Process only opening markers
    if (startDelim.end === -1) {
      continue;
    }
    endDelim = delimiters[startDelim.end];

    // If the previous delimiter has the same marker and is adjacent to this one,
    // merge those into one strong delimiter.
    //
    // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
    //
    isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 &&
    // check that first two markers match and adjacent
    delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 &&
    // check that last two markers are adjacent (we can safely assume they match)
    delimiters[startDelim.end + 1].token === endDelim.token + 1;
    ch = String.fromCharCode(startDelim.marker);
    token = state.tokens[startDelim.token];
    token.type = isStrong ? 'strong_open' : 'em_open';
    token.tag = isStrong ? 'strong' : 'em';
    token.nesting = 1;
    token.markup = isStrong ? ch + ch : ch;
    token.content = '';
    token = state.tokens[endDelim.token];
    token.type = isStrong ? 'strong_close' : 'em_close';
    token.tag = isStrong ? 'strong' : 'em';
    token.nesting = -1;
    token.markup = isStrong ? ch + ch : ch;
    token.content = '';
    if (isStrong) {
      state.tokens[delimiters[i - 1].token].content = '';
      state.tokens[delimiters[startDelim.end + 1].token].content = '';
      i--;
    }
  }
}

// Walk through delimiter list and replace text tokens with tags
//
module.exports.g = function emphasis(state) {
  var curr,
    tokens_meta = state.tokens_meta,
    max = state.tokens_meta.length;
  postProcess(state, state.delimiters);
  for (curr = 0; curr < max; curr++) {
    if (tokens_meta[curr] && tokens_meta[curr].delimiters) {
      postProcess(state, tokens_meta[curr].delimiters);
    }
  }
};

/***/ }),

/***/ 2438:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Process html entity - &#123;, &#xAF;, &quot;, ...



__webpack_require__(74916);
__webpack_require__(4723);
__webpack_require__(47042);
var entities = __webpack_require__(58565);
var has = __webpack_require__(14348).has;
var isValidEntityCode = __webpack_require__(14348).isValidEntityCode;
var fromCodePoint = __webpack_require__(14348).fromCodePoint;
var DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
var NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
module.exports = function entity(state, silent) {
  var ch,
    code,
    match,
    token,
    pos = state.pos,
    max = state.posMax;
  if (state.src.charCodeAt(pos) !== 0x26 /* & */) return false;
  if (pos + 1 >= max) return false;
  ch = state.src.charCodeAt(pos + 1);
  if (ch === 0x23 /* # */) {
    match = state.src.slice(pos).match(DIGITAL_RE);
    if (match) {
      if (!silent) {
        code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
        token = state.push('text_special', '', 0);
        token.content = isValidEntityCode(code) ? fromCodePoint(code) : fromCodePoint(0xFFFD);
        token.markup = match[0];
        token.info = 'entity';
      }
      state.pos += match[0].length;
      return true;
    }
  } else {
    match = state.src.slice(pos).match(NAMED_RE);
    if (match) {
      if (has(entities, match[1])) {
        if (!silent) {
          token = state.push('text_special', '', 0);
          token.content = entities[match[1]];
          token.markup = match[0];
          token.info = 'entity';
        }
        state.pos += match[0].length;
        return true;
      }
    }
  }
  return false;
};

/***/ }),

/***/ 50251:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Process escaped chars and hardbreaks



__webpack_require__(74916);
__webpack_require__(23123);
var isSpace = __webpack_require__(14348).isSpace;
var ESCAPED = [];
for (var i = 0; i < 256; i++) {
  ESCAPED.push(0);
}
'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split('').forEach(function (ch) {
  ESCAPED[ch.charCodeAt(0)] = 1;
});
module.exports = function escape(state, silent) {
  var ch1,
    ch2,
    origStr,
    escapedStr,
    token,
    pos = state.pos,
    max = state.posMax;
  if (state.src.charCodeAt(pos) !== 0x5C /* \ */) return false;
  pos++;

  // '\' at the end of the inline block
  if (pos >= max) return false;
  ch1 = state.src.charCodeAt(pos);
  if (ch1 === 0x0A) {
    if (!silent) {
      state.push('hardbreak', 'br', 0);
    }
    pos++;
    // skip leading whitespaces from next line
    while (pos < max) {
      ch1 = state.src.charCodeAt(pos);
      if (!isSpace(ch1)) break;
      pos++;
    }
    state.pos = pos;
    return true;
  }
  escapedStr = state.src[pos];
  if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
    ch2 = state.src.charCodeAt(pos + 1);
    if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
      escapedStr += state.src[pos + 1];
      pos++;
    }
  }
  origStr = '\\' + escapedStr;
  if (!silent) {
    token = state.push('text_special', '', 0);
    if (ch1 < 256 && ESCAPED[ch1] !== 0) {
      token.content = escapedStr;
    } else {
      token.content = origStr;
    }
    token.markup = origStr;
    token.info = 'escape';
  }
  state.pos = pos + 1;
  return true;
};

/***/ }),

/***/ 82006:
/***/ ((module) => {

"use strict";
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//


module.exports = function fragments_join(state) {
  var curr,
    last,
    level = 0,
    tokens = state.tokens,
    max = state.tokens.length;
  for (curr = last = 0; curr < max; curr++) {
    // re-calculate levels after emphasis/strikethrough turns some text nodes
    // into opening/closing tags
    if (tokens[curr].nesting < 0) level--; // closing tag
    tokens[curr].level = level;
    if (tokens[curr].nesting > 0) level++; // opening tag

    if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') {
      // collapse two adjacent text nodes
      tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
    } else {
      if (curr !== last) {
        tokens[last] = tokens[curr];
      }
      last++;
    }
  }
  if (curr !== last) {
    tokens.length = last;
  }
};

/***/ }),

/***/ 11579:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Process html tags



__webpack_require__(74916);
__webpack_require__(4723);
__webpack_require__(47042);
var HTML_TAG_RE = __webpack_require__(6251)/* .HTML_TAG_RE */ .n;
function isLinkOpen(str) {
  return /^<a[>\s]/i.test(str);
}
function isLinkClose(str) {
  return /^<\/a\s*>/i.test(str);
}
function isLetter(ch) {
  /*eslint no-bitwise:0*/
  var lc = ch | 0x20; // to lower case
  return lc >= 0x61 /* a */ && lc <= 0x7a /* z */;
}

module.exports = function html_inline(state, silent) {
  var ch,
    match,
    max,
    token,
    pos = state.pos;
  if (!state.md.options.html) {
    return false;
  }

  // Check start
  max = state.posMax;
  if (state.src.charCodeAt(pos) !== 0x3C /* < */ || pos + 2 >= max) {
    return false;
  }

  // Quick fail on second char
  ch = state.src.charCodeAt(pos + 1);
  if (ch !== 0x21 /* ! */ && ch !== 0x3F /* ? */ && ch !== 0x2F /* / */ && !isLetter(ch)) {
    return false;
  }
  match = state.src.slice(pos).match(HTML_TAG_RE);
  if (!match) {
    return false;
  }
  if (!silent) {
    token = state.push('html_inline', '', 0);
    token.content = state.src.slice(pos, pos + match[0].length);
    if (isLinkOpen(token.content)) state.linkLevel++;
    if (isLinkClose(token.content)) state.linkLevel--;
  }
  state.pos += match[0].length;
  return true;
};

/***/ }),

/***/ 21900:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Process ![image](<src> "title")



__webpack_require__(47042);
var normalizeReference = __webpack_require__(14348).normalizeReference;
var isSpace = __webpack_require__(14348).isSpace;
module.exports = function image(state, silent) {
  var attrs,
    code,
    content,
    label,
    labelEnd,
    labelStart,
    pos,
    ref,
    res,
    title,
    token,
    tokens,
    start,
    href = '',
    oldPos = state.pos,
    max = state.posMax;
  if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */) {
    return false;
  }
  if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */) {
    return false;
  }
  labelStart = state.pos + 2;
  labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);

  // parser failed to find ']', so it's not a valid link
  if (labelEnd < 0) {
    return false;
  }
  pos = labelEnd + 1;
  if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */) {
    //
    // Inline link
    //

    // [link](  <href>  "title"  )
    //        ^^ skipping these spaces
    pos++;
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (!isSpace(code) && code !== 0x0A) {
        break;
      }
    }
    if (pos >= max) {
      return false;
    }

    // [link](  <href>  "title"  )
    //          ^^^^^^ parsing link destination
    start = pos;
    res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
    if (res.ok) {
      href = state.md.normalizeLink(res.str);
      if (state.md.validateLink(href)) {
        pos = res.pos;
      } else {
        href = '';
      }
    }

    // [link](  <href>  "title"  )
    //                ^^ skipping these spaces
    start = pos;
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (!isSpace(code) && code !== 0x0A) {
        break;
      }
    }

    // [link](  <href>  "title"  )
    //                  ^^^^^^^ parsing link title
    res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
    if (pos < max && start !== pos && res.ok) {
      title = res.str;
      pos = res.pos;

      // [link](  <href>  "title"  )
      //                         ^^ skipping these spaces
      for (; pos < max; pos++) {
        code = state.src.charCodeAt(pos);
        if (!isSpace(code) && code !== 0x0A) {
          break;
        }
      }
    } else {
      title = '';
    }
    if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */) {
      state.pos = oldPos;
      return false;
    }
    pos++;
  } else {
    //
    // Link reference
    //
    if (typeof state.env.references === 'undefined') {
      return false;
    }
    if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */) {
      start = pos + 1;
      pos = state.md.helpers.parseLinkLabel(state, pos);
      if (pos >= 0) {
        label = state.src.slice(start, pos++);
      } else {
        pos = labelEnd + 1;
      }
    } else {
      pos = labelEnd + 1;
    }

    // covers label === '' and label === undefined
    // (collapsed reference link and shortcut reference link respectively)
    if (!label) {
      label = state.src.slice(labelStart, labelEnd);
    }
    ref = state.env.references[normalizeReference(label)];
    if (!ref) {
      state.pos = oldPos;
      return false;
    }
    href = ref.href;
    title = ref.title;
  }

  //
  // We found the end of the link, and know for a fact it's a valid link;
  // so all that's left to do is to call tokenizer.
  //
  if (!silent) {
    content = state.src.slice(labelStart, labelEnd);
    state.md.inline.parse(content, state.md, state.env, tokens = []);
    token = state.push('image', 'img', 0);
    token.attrs = attrs = [['src', href], ['alt', '']];
    token.children = tokens;
    token.content = content;
    if (title) {
      attrs.push(['title', title]);
    }
  }
  state.pos = pos;
  state.posMax = max;
  return true;
};

/***/ }),

/***/ 87582:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Process [link](<to> "stuff")



__webpack_require__(47042);
var normalizeReference = __webpack_require__(14348).normalizeReference;
var isSpace = __webpack_require__(14348).isSpace;
module.exports = function link(state, silent) {
  var attrs,
    code,
    label,
    labelEnd,
    labelStart,
    pos,
    res,
    ref,
    token,
    href = '',
    title = '',
    oldPos = state.pos,
    max = state.posMax,
    start = state.pos,
    parseReference = true;
  if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */) {
    return false;
  }
  labelStart = state.pos + 1;
  labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);

  // parser failed to find ']', so it's not a valid link
  if (labelEnd < 0) {
    return false;
  }
  pos = labelEnd + 1;
  if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */) {
    //
    // Inline link
    //

    // might have found a valid shortcut link, disable reference parsing
    parseReference = false;

    // [link](  <href>  "title"  )
    //        ^^ skipping these spaces
    pos++;
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (!isSpace(code) && code !== 0x0A) {
        break;
      }
    }
    if (pos >= max) {
      return false;
    }

    // [link](  <href>  "title"  )
    //          ^^^^^^ parsing link destination
    start = pos;
    res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
    if (res.ok) {
      href = state.md.normalizeLink(res.str);
      if (state.md.validateLink(href)) {
        pos = res.pos;
      } else {
        href = '';
      }

      // [link](  <href>  "title"  )
      //                ^^ skipping these spaces
      start = pos;
      for (; pos < max; pos++) {
        code = state.src.charCodeAt(pos);
        if (!isSpace(code) && code !== 0x0A) {
          break;
        }
      }

      // [link](  <href>  "title"  )
      //                  ^^^^^^^ parsing link title
      res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
      if (pos < max && start !== pos && res.ok) {
        title = res.str;
        pos = res.pos;

        // [link](  <href>  "title"  )
        //                         ^^ skipping these spaces
        for (; pos < max; pos++) {
          code = state.src.charCodeAt(pos);
          if (!isSpace(code) && code !== 0x0A) {
            break;
          }
        }
      }
    }
    if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */) {
      // parsing a valid shortcut link failed, fallback to reference
      parseReference = true;
    }
    pos++;
  }
  if (parseReference) {
    //
    // Link reference
    //
    if (typeof state.env.references === 'undefined') {
      return false;
    }
    if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */) {
      start = pos + 1;
      pos = state.md.helpers.parseLinkLabel(state, pos);
      if (pos >= 0) {
        label = state.src.slice(start, pos++);
      } else {
        pos = labelEnd + 1;
      }
    } else {
      pos = labelEnd + 1;
    }

    // covers label === '' and label === undefined
    // (collapsed reference link and shortcut reference link respectively)
    if (!label) {
      label = state.src.slice(labelStart, labelEnd);
    }
    ref = state.env.references[normalizeReference(label)];
    if (!ref) {
      state.pos = oldPos;
      return false;
    }
    href = ref.href;
    title = ref.title;
  }

  //
  // We found the end of the link, and know for a fact it's a valid link;
  // so all that's left to do is to call tokenizer.
  //
  if (!silent) {
    state.pos = labelStart;
    state.posMax = labelEnd;
    token = state.push('link_open', 'a', 1);
    token.attrs = attrs = [['href', href]];
    if (title) {
      attrs.push(['title', title]);
    }
    state.linkLevel++;
    state.md.inline.tokenize(state);
    state.linkLevel--;
    token = state.push('link_close', 'a', -1);
  }
  state.pos = pos;
  state.posMax = max;
  return true;
};

/***/ }),

/***/ 853:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Process links like https://example.org/



// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
__webpack_require__(74916);
__webpack_require__(4723);
__webpack_require__(47042);
__webpack_require__(15306);
var SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
module.exports = function linkify(state, silent) {
  var pos, max, match, proto, link, url, fullUrl, token;
  if (!state.md.options.linkify) return false;
  if (state.linkLevel > 0) return false;
  pos = state.pos;
  max = state.posMax;
  if (pos + 3 > max) return false;
  if (state.src.charCodeAt(pos) !== 0x3A /* : */) return false;
  if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */) return false;
  if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */) return false;
  match = state.pending.match(SCHEME_RE);
  if (!match) return false;
  proto = match[1];
  link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
  if (!link) return false;
  url = link.url;

  // disallow '*' at the end of the link (conflicts with emphasis)
  url = url.replace(/\*+$/, '');
  fullUrl = state.md.normalizeLink(url);
  if (!state.md.validateLink(fullUrl)) return false;
  if (!silent) {
    state.pending = state.pending.slice(0, -proto.length);
    token = state.push('link_open', 'a', 1);
    token.attrs = [['href', fullUrl]];
    token.markup = 'linkify';
    token.info = 'auto';
    token = state.push('text', '', 0);
    token.content = state.md.normalizeLinkText(url);
    token = state.push('link_close', 'a', -1);
    token.markup = 'linkify';
    token.info = 'auto';
  }
  state.pos += url.length - proto.length;
  return true;
};

/***/ }),

/***/ 13377:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Proceess '\n'



__webpack_require__(47042);
var isSpace = __webpack_require__(14348).isSpace;
module.exports = function newline(state, silent) {
  var pmax,
    max,
    ws,
    pos = state.pos;
  if (state.src.charCodeAt(pos) !== 0x0A /* \n */) {
    return false;
  }
  pmax = state.pending.length - 1;
  max = state.posMax;

  // '  \n' -> hardbreak
  // Lookup in pending chars is bad practice! Don't copy to other rules!
  // Pending string is stored in concat mode, indexed lookups will cause
  // convertion to flat mode.
  if (!silent) {
    if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
      if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
        // Find whitespaces tail of pending chars.
        ws = pmax - 1;
        while (ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20) {
          ws--;
        }
        state.pending = state.pending.slice(0, ws);
        state.push('hardbreak', 'br', 0);
      } else {
        state.pending = state.pending.slice(0, -1);
        state.push('softbreak', 'br', 0);
      }
    } else {
      state.push('softbreak', 'br', 0);
    }
  }
  pos++;

  // skip heading spaces for next line
  while (pos < max && isSpace(state.src.charCodeAt(pos))) {
    pos++;
  }
  state.pos = pos;
  return true;
};

/***/ }),

/***/ 59427:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Inline parser state



var Token = __webpack_require__(98640);
var isWhiteSpace = __webpack_require__(14348).isWhiteSpace;
var isPunctChar = __webpack_require__(14348).isPunctChar;
var isMdAsciiPunct = __webpack_require__(14348).isMdAsciiPunct;
function StateInline(src, md, env, outTokens) {
  this.src = src;
  this.env = env;
  this.md = md;
  this.tokens = outTokens;
  this.tokens_meta = Array(outTokens.length);
  this.pos = 0;
  this.posMax = this.src.length;
  this.level = 0;
  this.pending = '';
  this.pendingLevel = 0;

  // Stores { start: end } pairs. Useful for backtrack
  // optimization of pairs parse (emphasis, strikes).
  this.cache = {};

  // List of emphasis-like delimiters for current tag
  this.delimiters = [];

  // Stack of delimiter lists for upper level tags
  this._prev_delimiters = [];

  // backtick length => last seen position
  this.backticks = {};
  this.backticksScanned = false;

  // Counter used to disable inline linkify-it execution
  // inside <a> and markdown links
  this.linkLevel = 0;
}

// Flush pending text
//
StateInline.prototype.pushPending = function () {
  var token = new Token('text', '', 0);
  token.content = this.pending;
  token.level = this.pendingLevel;
  this.tokens.push(token);
  this.pending = '';
  return token;
};

// Push new token to "stream".
// If pending text exists - flush it as text token
//
StateInline.prototype.push = function (type, tag, nesting) {
  if (this.pending) {
    this.pushPending();
  }
  var token = new Token(type, tag, nesting);
  var token_meta = null;
  if (nesting < 0) {
    // closing tag
    this.level--;
    this.delimiters = this._prev_delimiters.pop();
  }
  token.level = this.level;
  if (nesting > 0) {
    // opening tag
    this.level++;
    this._prev_delimiters.push(this.delimiters);
    this.delimiters = [];
    token_meta = {
      delimiters: this.delimiters
    };
  }
  this.pendingLevel = this.level;
  this.tokens.push(token);
  this.tokens_meta.push(token_meta);
  return token;
};

// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
StateInline.prototype.scanDelims = function (start, canSplitWord) {
  var pos = start,
    lastChar,
    nextChar,
    count,
    can_open,
    can_close,
    isLastWhiteSpace,
    isLastPunctChar,
    isNextWhiteSpace,
    isNextPunctChar,
    left_flanking = true,
    right_flanking = true,
    max = this.posMax,
    marker = this.src.charCodeAt(start);

  // treat beginning of the line as a whitespace
  lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
  while (pos < max && this.src.charCodeAt(pos) === marker) {
    pos++;
  }
  count = pos - start;

  // treat end of the line as a whitespace
  nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
  isLastPunctChar = isMdAsciiPunct(lastChar) || isPunctChar(String.fromCharCode(lastChar));
  isNextPunctChar = isMdAsciiPunct(nextChar) || isPunctChar(String.fromCharCode(nextChar));
  isLastWhiteSpace = isWhiteSpace(lastChar);
  isNextWhiteSpace = isWhiteSpace(nextChar);
  if (isNextWhiteSpace) {
    left_flanking = false;
  } else if (isNextPunctChar) {
    if (!(isLastWhiteSpace || isLastPunctChar)) {
      left_flanking = false;
    }
  }
  if (isLastWhiteSpace) {
    right_flanking = false;
  } else if (isLastPunctChar) {
    if (!(isNextWhiteSpace || isNextPunctChar)) {
      right_flanking = false;
    }
  }
  if (!canSplitWord) {
    can_open = left_flanking && (!right_flanking || isLastPunctChar);
    can_close = right_flanking && (!left_flanking || isNextPunctChar);
  } else {
    can_open = left_flanking;
    can_close = right_flanking;
  }
  return {
    can_open: can_open,
    can_close: can_close,
    length: count
  };
};

// re-export Token class to use in block rules
StateInline.prototype.Token = Token;
module.exports = StateInline;

/***/ }),

/***/ 97097:
/***/ ((module) => {

"use strict";
// ~~strike through~~
//


// Insert each marker as a separate text token, and add it to delimiter list
//
module.exports.w = function strikethrough(state, silent) {
  var i,
    scanned,
    token,
    len,
    ch,
    start = state.pos,
    marker = state.src.charCodeAt(start);
  if (silent) {
    return false;
  }
  if (marker !== 0x7E /* ~ */) {
    return false;
  }
  scanned = state.scanDelims(state.pos, true);
  len = scanned.length;
  ch = String.fromCharCode(marker);
  if (len < 2) {
    return false;
  }
  if (len % 2) {
    token = state.push('text', '', 0);
    token.content = ch;
    len--;
  }
  for (i = 0; i < len; i += 2) {
    token = state.push('text', '', 0);
    token.content = ch + ch;
    state.delimiters.push({
      marker: marker,
      length: 0,
      // disable "rule of 3" length checks meant for emphasis
      token: state.tokens.length - 1,
      end: -1,
      open: scanned.can_open,
      close: scanned.can_close
    });
  }
  state.pos += scanned.length;
  return true;
};
function postProcess(state, delimiters) {
  var i,
    j,
    startDelim,
    endDelim,
    token,
    loneMarkers = [],
    max = delimiters.length;
  for (i = 0; i < max; i++) {
    startDelim = delimiters[i];
    if (startDelim.marker !== 0x7E /* ~ */) {
      continue;
    }
    if (startDelim.end === -1) {
      continue;
    }
    endDelim = delimiters[startDelim.end];
    token = state.tokens[startDelim.token];
    token.type = 's_open';
    token.tag = 's';
    token.nesting = 1;
    token.markup = '~~';
    token.content = '';
    token = state.tokens[endDelim.token];
    token.type = 's_close';
    token.tag = 's';
    token.nesting = -1;
    token.markup = '~~';
    token.content = '';
    if (state.tokens[endDelim.token - 1].type === 'text' && state.tokens[endDelim.token - 1].content === '~') {
      loneMarkers.push(endDelim.token - 1);
    }
  }

  // If a marker sequence has an odd number of characters, it's splitted
  // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
  // start of the sequence.
  //
  // So, we have to move all those markers after subsequent s_close tags.
  //
  while (loneMarkers.length) {
    i = loneMarkers.pop();
    j = i + 1;
    while (j < state.tokens.length && state.tokens[j].type === 's_close') {
      j++;
    }
    j--;
    if (i !== j) {
      token = state.tokens[j];
      state.tokens[j] = state.tokens[i];
      state.tokens[i] = token;
    }
  }
}

// Walk through delimiter list and replace text tokens with tags
//
module.exports.g = function strikethrough(state) {
  var curr,
    tokens_meta = state.tokens_meta,
    max = state.tokens_meta.length;
  postProcess(state, state.delimiters);
  for (curr = 0; curr < max; curr++) {
    if (tokens_meta[curr] && tokens_meta[curr].delimiters) {
      postProcess(state, tokens_meta[curr].delimiters);
    }
  }
};

/***/ }),

/***/ 43154:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Skip text characters for text token, place those to pending buffer
// and increment current pos



// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions

// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~

// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
__webpack_require__(47042);
function isTerminatorChar(ch) {
  switch (ch) {
    case 0x0A /* \n */:
    case 0x21 /* ! */:
    case 0x23 /* # */:
    case 0x24 /* $ */:
    case 0x25 /* % */:
    case 0x26 /* & */:
    case 0x2A /* * */:
    case 0x2B /* + */:
    case 0x2D /* - */:
    case 0x3A /* : */:
    case 0x3C /* < */:
    case 0x3D /* = */:
    case 0x3E /* > */:
    case 0x40 /* @ */:
    case 0x5B /* [ */:
    case 0x5C /* \ */:
    case 0x5D /* ] */:
    case 0x5E /* ^ */:
    case 0x5F /* _ */:
    case 0x60 /* ` */:
    case 0x7B /* { */:
    case 0x7D /* } */:
    case 0x7E /* ~ */:
      return true;
    default:
      return false;
  }
}
module.exports = function text(state, silent) {
  var pos = state.pos;
  while (pos < state.posMax && !isTerminatorChar(state.src.charCodeAt(pos))) {
    pos++;
  }
  if (pos === state.pos) {
    return false;
  }
  if (!silent) {
    state.pending += state.src.slice(state.pos, pos);
  }
  state.pos = pos;
  return true;
};

// Alternative implementation, for memory.
//
// It costs 10% of performance, but allows extend terminators list, if place it
// to `ParcerInline` property. Probably, will switch to it sometime, such
// flexibility required.

/*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
};*/

/***/ }),

/***/ 98640:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Token class



/**
 * class Token
 **/

/**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/
__webpack_require__(21249);
function Token(type, tag, nesting) {
  /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/
  this.type = type;

  /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/
  this.tag = tag;

  /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/
  this.attrs = null;

  /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/
  this.map = null;

  /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/
  this.nesting = nesting;

  /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/
  this.level = 0;

  /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/
  this.children = null;

  /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/
  this.content = '';

  /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/
  this.markup = '';

  /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/
  this.info = '';

  /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/
  this.meta = null;

  /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/
  this.block = false;

  /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/
  this.hidden = false;
}

/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/
Token.prototype.attrIndex = function attrIndex(name) {
  var attrs, i, len;
  if (!this.attrs) {
    return -1;
  }
  attrs = this.attrs;
  for (i = 0, len = attrs.length; i < len; i++) {
    if (attrs[i][0] === name) {
      return i;
    }
  }
  return -1;
};

/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/
Token.prototype.attrPush = function attrPush(attrData) {
  if (this.attrs) {
    this.attrs.push(attrData);
  } else {
    this.attrs = [attrData];
  }
};

/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/
Token.prototype.attrSet = function attrSet(name, value) {
  var idx = this.attrIndex(name),
    attrData = [name, value];
  if (idx < 0) {
    this.attrPush(attrData);
  } else {
    this.attrs[idx] = attrData;
  }
};

/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/
Token.prototype.attrGet = function attrGet(name) {
  var idx = this.attrIndex(name),
    value = null;
  if (idx >= 0) {
    value = this.attrs[idx][1];
  }
  return value;
};

/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/
Token.prototype.attrJoin = function attrJoin(name, value) {
  var idx = this.attrIndex(name);
  if (idx < 0) {
    this.attrPush([name, value]);
  } else {
    this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
  }
};
module.exports = Token;

/***/ }),

/***/ 82858:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* eslint-disable no-bitwise */
__webpack_require__(47042);
__webpack_require__(41539);
__webpack_require__(39714);
__webpack_require__(74916);
__webpack_require__(15306);
var decodeCache = {};
function getDecodeCache(exclude) {
  var i,
    ch,
    cache = decodeCache[exclude];
  if (cache) {
    return cache;
  }
  cache = decodeCache[exclude] = [];
  for (i = 0; i < 128; i++) {
    ch = String.fromCharCode(i);
    cache.push(ch);
  }
  for (i = 0; i < exclude.length; i++) {
    ch = exclude.charCodeAt(i);
    cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
  }
  return cache;
}

// Decode percent-encoded string.
//
function decode(string, exclude) {
  var cache;
  if (typeof exclude !== 'string') {
    exclude = decode.defaultChars;
  }
  cache = getDecodeCache(exclude);
  return string.replace(/(%[a-f0-9]{2})+/gi, function (seq) {
    var i,
      l,
      b1,
      b2,
      b3,
      b4,
      chr,
      result = '';
    for (i = 0, l = seq.length; i < l; i += 3) {
      b1 = parseInt(seq.slice(i + 1, i + 3), 16);
      if (b1 < 0x80) {
        result += cache[b1];
        continue;
      }
      if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
        // 110xxxxx 10xxxxxx
        b2 = parseInt(seq.slice(i + 4, i + 6), 16);
        if ((b2 & 0xC0) === 0x80) {
          chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
          if (chr < 0x80) {
            result += "\uFFFD\uFFFD";
          } else {
            result += String.fromCharCode(chr);
          }
          i += 3;
          continue;
        }
      }
      if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
        // 1110xxxx 10xxxxxx 10xxxxxx
        b2 = parseInt(seq.slice(i + 4, i + 6), 16);
        b3 = parseInt(seq.slice(i + 7, i + 9), 16);
        if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
          chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
          if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) {
            result += "\uFFFD\uFFFD\uFFFD";
          } else {
            result += String.fromCharCode(chr);
          }
          i += 6;
          continue;
        }
      }
      if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
        // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
        b2 = parseInt(seq.slice(i + 4, i + 6), 16);
        b3 = parseInt(seq.slice(i + 7, i + 9), 16);
        b4 = parseInt(seq.slice(i + 10, i + 12), 16);
        if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
          chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
          if (chr < 0x10000 || chr > 0x10FFFF) {
            result += "\uFFFD\uFFFD\uFFFD\uFFFD";
          } else {
            chr -= 0x10000;
            result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
          }
          i += 9;
          continue;
        }
      }
      result += "\uFFFD";
    }
    return result;
  });
}
decode.defaultChars = ';/?:@&=+$,#';
decode.componentChars = '';
module.exports = decode;

/***/ }),

/***/ 94279:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(47042);
__webpack_require__(41539);
__webpack_require__(39714);
var encodeCache = {};

// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function getEncodeCache(exclude) {
  var i,
    ch,
    cache = encodeCache[exclude];
  if (cache) {
    return cache;
  }
  cache = encodeCache[exclude] = [];
  for (i = 0; i < 128; i++) {
    ch = String.fromCharCode(i);
    if (/^[0-9a-z]$/i.test(ch)) {
      // always allow unencoded alphanumeric characters
      cache.push(ch);
    } else {
      cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
  }
  for (i = 0; i < exclude.length; i++) {
    cache[exclude.charCodeAt(i)] = exclude[i];
  }
  return cache;
}

// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function encode(string, exclude, keepEscaped) {
  var i,
    l,
    code,
    nextCode,
    cache,
    result = '';
  if (typeof exclude !== 'string') {
    // encode(string, keepEscaped)
    keepEscaped = exclude;
    exclude = encode.defaultChars;
  }
  if (typeof keepEscaped === 'undefined') {
    keepEscaped = true;
  }
  cache = getEncodeCache(exclude);
  for (i = 0, l = string.length; i < l; i++) {
    code = string.charCodeAt(i);
    if (keepEscaped && code === 0x25 /* % */ && i + 2 < l) {
      if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
        result += string.slice(i, i + 3);
        i += 2;
        continue;
      }
    }
    if (code < 128) {
      result += cache[code];
      continue;
    }
    if (code >= 0xD800 && code <= 0xDFFF) {
      if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
        nextCode = string.charCodeAt(i + 1);
        if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
          result += encodeURIComponent(string[i] + string[i + 1]);
          i++;
          continue;
        }
      }
      result += '%EF%BF%BD';
      continue;
    }
    result += encodeURIComponent(string[i]);
  }
  return result;
}
encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
encode.componentChars = "-_.!~*'()";
module.exports = encode;

/***/ }),

/***/ 99363:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(74916);
__webpack_require__(64765);
module.exports = function format(url) {
  var result = '';
  result += url.protocol || '';
  result += url.slashes ? '//' : '';
  result += url.auth ? url.auth + '@' : '';
  if (url.hostname && url.hostname.indexOf(':') !== -1) {
    // ipv6 address
    result += '[' + url.hostname + ']';
  } else {
    result += url.hostname || '';
  }
  result += url.port ? ':' + url.port : '';
  result += url.pathname || '';
  result += url.search || '';
  result += url.hash || '';
  return result;
};

/***/ }),

/***/ 75577:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports.encode = __webpack_require__(94279);
module.exports.decode = __webpack_require__(82858);
module.exports.format = __webpack_require__(99363);
module.exports.parse = __webpack_require__(38770);

/***/ }),

/***/ 38770:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
__webpack_require__(74916);
__webpack_require__(64765);
__webpack_require__(92222);
__webpack_require__(73210);
__webpack_require__(23123);
__webpack_require__(4723);
__webpack_require__(47042);
__webpack_require__(69600);
function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.pathname = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
  portPattern = /:[0-9]*$/,
  // Special case for a simple path URL
  simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
  // RFC 2396: characters reserved for delimiting URLs.
  // We actually just auto-escape these.
  delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
  // RFC 2396: characters not allowed for various reasons.
  unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
  // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
  autoEscape = ['\''].concat(unwise),
  // Characters that are never ever allowed in a hostname.
  // Note that any invalid chars are also handled, but these
  // are the ones that are *expected* to be seen, so we fast-path
  // them.
  nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
  hostEndingChars = ['/', '?', '#'],
  hostnameMaxLen = 255,
  hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
  hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
  // protocols that can allow "unsafe" and "unwise" chars.
  /* eslint-disable no-script-url */
  // protocols that never have a hostname.
  hostlessProtocol = {
    'javascript': true,
    'javascript:': true
  },
  // protocols that always contain a // bit.
  slashedProtocol = {
    'http': true,
    'https': true,
    'ftp': true,
    'gopher': true,
    'file': true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
  };
/* eslint-enable no-script-url */

function urlParse(url, slashesDenoteHost) {
  if (url && url instanceof Url) {
    return url;
  }
  var u = new Url();
  u.parse(url, slashesDenoteHost);
  return u;
}
Url.prototype.parse = function (url, slashesDenoteHost) {
  var i,
    l,
    lowerProto,
    hec,
    slashes,
    rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();
  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
      }
      return this;
    }
  }
  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    lowerProto = proto.toLowerCase();
    this.protocol = proto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }
  if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (i = 0; i < hostEndingChars.length; i++) {
      hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) {
        hostEnd = hec;
      }
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = auth;
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (i = 0; i < nonHostChars.length; i++) {
      hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) {
        hostEnd = hec;
      }
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1) {
      hostEnd = rest.length;
    }
    if (rest[hostEnd - 1] === ':') {
      hostEnd--;
    }
    var host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost(host);

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) {
          continue;
        }
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }
    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    }

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
  }

  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    rest = rest.slice(0, qm);
  }
  if (rest) {
    this.pathname = rest;
  }
  if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
    this.pathname = '';
  }
  return this;
};
Url.prototype.parseHost = function (host) {
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) {
    this.hostname = host;
  }
};
module.exports = urlParse;

/***/ }),

/***/ 24412:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;__webpack_require__(66992);
__webpack_require__(41539);
__webpack_require__(33948);
__webpack_require__(40561);
__webpack_require__(47941);
__webpack_require__(56977);
__webpack_require__(19601);
__webpack_require__(78783);
__webpack_require__(38478);
__webpack_require__(54747);
__webpack_require__(24603);
__webpack_require__(74916);
__webpack_require__(39714);
__webpack_require__(51532);
__webpack_require__(70189);
__webpack_require__(47042);
__webpack_require__(68309);
__webpack_require__(23123);
__webpack_require__(73210);
__webpack_require__(15306);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
!function (e, n) {
  "object" == ( false ? 0 : _typeof(exports)) && "undefined" != "object" ? n(exports) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (n),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : 0;
}(this, function (e) {
  "use strict";

  var i = Object.prototype.hasOwnProperty,
    O = function O(e) {
      for (var n, t = 0; t < (arguments.length <= 1 ? 0 : arguments.length - 1); t++) {
        if ((n = t + 1 < 1 || arguments.length <= t + 1 ? void 0 : arguments[t + 1]) && "object" == _typeof(n)) for (var r in n) {
          i.call(n, r) && (e[r] = n[r]);
        }
      }
      return e;
    },
    E = function E(e) {
      var n = e.length;
      if (!n) return [];
      if (1 === n) return [e[0]];
      if (2 === n) return [e[0], e[1]];
      if (3 === n) return [e[0], e[1], e[2]];
      for (var t = new Array(n), r = 0; r < n; r++) {
        t[r] = e[r];
      }
      return t;
    },
    j = function j(e, n) {
      var r = "function" == typeof n ? n : function (i) {
        return function (e, n) {
          if (e.length !== n.length) return !1;
          for (var t = 0, r = e.length; t < r; t++) {
            if (!i(e[t], n[t])) return !1;
          }
          return !0;
        };
      }(e);
      return function (e, n) {
        for (var t = 0; t < e.length; t++) {
          if (r(e[t], n)) return t;
        }
        return -1;
      };
    },
    M = function M(e, n) {
      return e === n || e != e && n != n;
    },
    P = function P(e, n, t) {},
    q = function q(e, n, t) {
      for (var r = t; r--;) {
        e[r + 1] = e[r];
      }
      e[0] = n;
    },
    K = function K(i) {
      var o = j(i.isEqual, i.isMatchingKey);
      return function (t, n) {
        var r = t.keys[0];
        t.values[0] = t.values[0].then(function (e) {
          return i.onCacheHit(t, i, n), i.onCacheChange(t, i, n), e;
        }).catch(function (e) {
          var n = o(t.keys, r);
          throw ~n && (t.keys.splice(n, 1), t.values.splice(n, 1)), e;
        });
      };
    };
  function y(a, e) {
    if (a.isMemoized) return a;
    var n = e || {},
      t = n.isEqual,
      r = void 0 === t ? M : t,
      i = n.isMatchingKey,
      o = n.isPromise,
      u = void 0 !== o && o,
      c = n.maxSize,
      s = void 0 === c ? 1 : c,
      f = n.onCacheAdd,
      l = void 0 === f ? P : f,
      h = n.onCacheChange,
      p = void 0 === h ? P : h,
      g = n.onCacheHit,
      v = void 0 === g ? P : g,
      y = n.transformKey,
      d = function (e, n) {
        if (null == e) return {};
        var t,
          r,
          i = {},
          o = Object.keys(e);
        for (r = 0; r < o.length; r++) {
          t = o[r], 0 <= n.indexOf(t) || (i[t] = e[t]);
        }
        return i;
      }(n, ["isEqual", "isMatchingKey", "isPromise", "maxSize", "onCacheAdd", "onCacheChange", "onCacheHit", "transformKey"]),
      m = O({}, d, {
        isEqual: r,
        isMatchingKey: i,
        isPromise: u,
        maxSize: s,
        onCacheAdd: l,
        onCacheChange: p,
        onCacheHit: v,
        transformKey: y
      }),
      x = j(r, i),
      C = K(m),
      S = !(!y && !i),
      z = {
        keys: [],
        get size() {
          return z.keys.length;
        },
        values: []
      },
      A = z.keys,
      b = z.values;
    function k() {
      var e = arguments,
        n = S ? E(e) : e,
        t = y ? y(n) : n,
        r = x(A, t);
      if (~r) v(z, m, k), r && (q(A, A[r], r), q(b, b[r], r), p(z, m, k));else {
        A.length >= s && (A.pop(), b.pop());
        var i = S ? t : E(n),
          o = a.apply(this, e);
        q(A, i, A.length), q(b, o, b.length), u && C(z, k), l(z, m, k), p(z, m, k);
      }
      return b[0];
    }
    return Object.defineProperties(k, {
      cache: {
        configurable: !0,
        get: function get() {
          return z;
        }
      },
      cacheSnapshot: {
        configurable: !0,
        get: function get() {
          return {
            keys: E(z.keys),
            size: z.size,
            values: E(z.values)
          };
        }
      },
      isMemoized: {
        configurable: !0,
        get: function get() {
          return !0;
        }
      },
      options: {
        configurable: !0,
        get: function get() {
          return m;
        }
      }
    }), k;
  }
  function o() {
    for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++) {
      n[t] = arguments[t];
    }
    if (n.length) return n.reduce(function (e, n) {
      return "function" == typeof e ? "function" == typeof n ? function () {
        return e(n.apply(this, arguments));
      } : e : "function" == typeof n ? n : void 0;
    });
  }
  function p(e, n) {
    for (var t = 0; t < e.length; t++) {
      if (e[t].key === n) return t;
    }
    return -1;
  }
  function g(r, e) {
    var i = "function" == typeof e ? e : function (e, n) {
      for (var t = 0; t < n.length; t++) {
        if (!r(e[t], n[t])) return !1;
      }
      return !0;
    };
    return function (e, n) {
      for (var t = 0; t < e.length; t++) {
        if (e[t].length === n.length && i(e[t], n)) return t;
      }
      return -1;
    };
  }
  function a(e) {
    return Array.isArray(e) ? e : [e];
  }
  function v(e, n, t) {
    var r = p(e, n);
    ~r && (clearTimeout(e[r].timeoutId), t && e.splice(r, 1));
  }
  function d(e, n) {
    var t = setTimeout(e, n);
    return "function" == typeof t.unref && t.unref(), t;
  }
  function n() {
    h.isCollectingStats = !0;
  }
  function r(e, n) {
    return e ? (n / e * 100).toFixed(4) + "%" : "0%";
  }
  function f(e) {
    if (h.isCollectingStats || R || (console.warn('Stats are not currently being collected, please run "collectStats" to enable them.'), R = !0), e) {
      if (!h.profiles[e]) return {
        calls: 0,
        hits: 0,
        usage: "0%"
      };
      var n = h.profiles[e];
      return Object.assign({}, n, {
        usage: r(n.calls, n.hits)
      });
    }
    var t = Object.keys(h.profiles).reduce(function (e, n) {
      return e.calls += h.profiles[n].calls, e.hits += h.profiles[n].hits, e;
    }, {
      calls: 0,
      hits: 0
    });
    return Object.assign({}, t, {
      profiles: Object.keys(h.profiles).reduce(function (e, n) {
        return e[n] = f(n), e;
      }, {}),
      usage: r(t.calls, t.hits)
    });
  }
  function u(e, n) {
    return e && "object" == _typeof(e) && n.add(e);
  }
  function m(e, n, t, r) {
    for (var i, o = 0; o < e.length; o++) {
      if (t((i = e[o])[0], n[0], r) && t(i[1], n[1], r)) return !0;
    }
    return !1;
  }
  function x(e, n, t, r) {
    for (var i = 0; i < e.length; i++) {
      if (t(e[i], n, r)) return !0;
    }
    return !1;
  }
  function C(e, n) {
    return e === n || e != e && n != n;
  }
  function S(e) {
    return e.constructor === Object;
  }
  function z(e) {
    return "function" == typeof e.then;
  }
  function c(e) {
    return !(!e.$$typeof || !e._store);
  }
  function t(n) {
    return function (e) {
      var o = n || e;
      return function (e, n, t) {
        void 0 === t && (t = W ? new WeakSet() : Object.create({
          _values: [],
          add: function add(e) {
            this._values.push(e);
          },
          has: function has(e) {
            return !!~this._values.indexOf(e);
          }
        }));
        var r = t.has(e),
          i = t.has(n);
        return r || i ? r && i : (u(e, t), u(n, t), o(e, n, t));
      };
    };
  }
  function A(e) {
    var t = [];
    return e.forEach(function (e, n) {
      return t.push([n, e]);
    }), t;
  }
  function b(e) {
    var n = [];
    return e.forEach(function (e) {
      return n.push(e);
    }), n;
  }
  function k(e, n, t, r) {
    var i,
      o = $(e),
      a = $(n);
    if (o.length !== a.length) return !1;
    for (var u = 0; u < o.length; u++) {
      if (i = o[u], !x(a, i, C)) return !1;
      if (("_owner" !== i || !c(e) || !c(n)) && !t(e[i], n[i], r)) return !1;
    }
    return !0;
  }
  function s(e) {
    var g = "function" == typeof e ? e(n) : n;
    function n(e, n, t) {
      if (C(e, n)) return !0;
      var r = _typeof(e);
      if (r != _typeof(n) || "object" != r || !e || !n) return !1;
      if (S(e) && S(n)) return k(e, n, g, t);
      var i = B(e),
        o = B(n);
      if (i || o) return i === o && function (e, n, t, r) {
        if (e.length !== n.length) return !1;
        for (var i = 0; i < e.length; i++) {
          if (!t(e[i], n[i], r)) return !1;
        }
        return !0;
      }(e, n, g, t);
      var a = e instanceof Date,
        u = n instanceof Date;
      if (a || u) return a == u && C(e.getTime(), n.getTime());
      var c = e instanceof RegExp,
        s = n instanceof RegExp;
      if (c || s) return c == s && function (e, n) {
        return e.source === n.source && e.global === n.global && e.ignoreCase === n.ignoreCase && e.multiline === n.multiline && e.unicode === n.unicode && e.sticky === n.sticky && e.lastIndex === n.lastIndex;
      }(e, n);
      if (z(e) || z(n)) return e === n;
      if (I) {
        var f = e instanceof Map,
          l = n instanceof Map;
        if (f || l) return f == l && function (e, n, t, r) {
          if (e.size !== n.size) return !1;
          for (var i = A(e), o = A(n), a = 0; a < i.length; a++) {
            if (!m(o, i[a], t, r) || !m(i, o[a], t, r)) return !1;
          }
          return !0;
        }(e, n, g, t);
      }
      if (J) {
        var h = e instanceof Set,
          p = n instanceof Set;
        if (h || p) return h == p && function (e, n, t, r) {
          if (e.size !== n.size) return !1;
          for (var i = b(e), o = b(n), a = 0; a < i.length; a++) {
            if (!x(o, i[a], t, r) || !x(i, o[a], t, r)) return !1;
          }
          return !0;
        }(e, n, g, t);
      }
      return k(e, n, g, t);
    }
    return n;
  }
  function l(n) {
    return function (e) {
      if (n >= e.length) return e;
      switch (n) {
        case 0:
          return [];
        case 1:
          return [e[0]];
        case 2:
          return [e[0], e[1]];
        case 3:
          return [e[0], e[1], e[2]];
        case 4:
          return [e[0], e[1], e[2], e[3]];
        case 5:
          return [e[0], e[1], e[2], e[3], e[4]];
      }
      return Array.prototype.slice.call(e, 0, n);
    };
  }
  var N = {
      equals: void 0,
      isDeepEqual: !1,
      isPromise: !1,
      isReact: !1,
      isSerialized: !1,
      matchesKey: void 0,
      maxAge: void 0,
      maxArgs: void 0,
      maxSize: 1 / 0,
      onExpire: void 0,
      profileName: void 0,
      serializer: void 0,
      shouldSerializeFunctions: !1,
      transformArgs: void 0,
      updateExpire: !1
    },
    H = function H() {
      for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++) {
        n[t] = arguments[t];
      }
      if (n.length) return n.reduce(function (e, n) {
        return "function" == typeof e ? "function" == typeof n ? function () {
          n.apply(this, arguments), e.apply(this, arguments);
        } : e : "function" == typeof n ? n : void 0;
      });
    },
    w = function w(e, n) {
      return n === N ? e : Object.assign({}, e, n, {
        onCacheAdd: H(e.onCacheAdd, n.onCacheAdd),
        onCacheChange: H(e.onCacheChange, n.onCacheChange),
        onCacheHit: H(e.onCacheHit, n.onCacheHit),
        transformArgs: o(e.transformArgs, n.transformArgs)
      });
    },
    F = function F(e, n, t, r) {
      var i = n.maxAge,
        o = n.updateExpire,
        a = "number" == typeof i && isFinite(i) ? function a(u, c, s, e) {
          var n = c.maxAge,
            f = c.onCacheChange,
            l = c.onExpire,
            h = g(s, e);
          return function (t, r, i) {
            var o = t.keys[0];
            if (!~p(u, o)) {
              var e = function e() {
                var e = h(t.keys, o),
                  n = t.values[e];
                ~e && (t.keys.splice(e, 1), t.values.splice(e, 1), "function" == typeof f && f(t, r, i)), v(u, o, !0), "function" == typeof l && !1 === l(o) && (t.keys.unshift(o), t.values.unshift(n), a(u, c, s)(t, r, i), "function" == typeof f && f(t, r, i));
              };
              u.push({
                expirationMethod: e,
                key: o,
                timeoutId: d(e, n)
              });
            }
          };
        }(e, n, t, r) : void 0;
      return {
        onCacheAdd: a,
        onCacheHit: a && o ? function (r, e) {
          var i = e.maxAge;
          return function (e) {
            var n = e.keys[0],
              t = p(r, n);
            ~t && (v(r, n, !1), r[t].timeoutId = d(r[t].expirationMethod, i));
          };
        }(e, n) : void 0
      };
    },
    h = {
      anonymousProfileNameCounter: 1,
      isCollectingStats: !1,
      profiles: {}
    },
    R = !1,
    T = function T(e) {
      var n = new Error().stack,
        t = e.displayName || e.name || "Anonymous " + h.anonymousProfileNameCounter++;
      if (!n) return t;
      for (var r, i, o = n.split("\n").slice(3), a = 0; a < o.length; a++) {
        if (!~(r = o[a]).indexOf("/moize/") && !~r.indexOf(" (native)") && !~r.indexOf(" Function.")) {
          i = r.replace(/\n/g, "\\n").trim();
          break;
        }
      }
      return i ? t + " " + i : t;
    },
    _ = function _(e) {
      return h.isCollectingStats ? {
        onCacheAdd: function (e) {
          var n = e.profileName;
          return h.profiles[n] || (h.profiles[n] = {
            calls: 0,
            hits: 0
          }), function () {
            h.profiles[n].calls++;
          };
        }(e),
        onCacheHit: function (e) {
          var n = e.profileName;
          return function () {
            h.profiles[n].calls++, h.profiles[n].hits++;
          };
        }(e)
      } : {};
    },
    D = function D(e, n) {
      return function (i, e) {
        var r = e.expirations,
          n = i.options,
          t = n.isEqual,
          o = n.isMatchingKey,
          a = n.onCacheAdd,
          u = n.onCacheChange,
          c = n.transformKey,
          s = g(t, o);
        i.add = function (e, n) {
          var t = c ? c(e) : e;
          ~s(i.cache.keys, t) || (i.cache.size >= i.options.maxSize && (i.cache.keys.pop(), i.cache.values.pop()), i.cache.keys.unshift(t), i.cache.values.unshift(n), a(i.cache, i.options, i), u(i.cache, i.options, i));
        }, i.clear = function () {
          i.cache.keys.length = 0, i.cache.values.length = 0, u(i.cache, i.options, i);
        }, i.get = function (e) {
          var n = s(i.cache.keys, c ? c(e) : e);
          return ~n ? i.apply(this, i.cache.keys[n]) : void 0;
        }, i.getStats = function () {
          var e = i.options.profileName;
          return f(e);
        }, i.has = function (e) {
          return !!~s(i.cache.keys, c ? c(e) : e);
        }, i.keys = function () {
          return i.cacheSnapshot.keys;
        }, i.remove = function (e) {
          var n = s(i.cache.keys, c ? c(e) : e);
          if (~n) {
            var t = i.cache.keys[n];
            i.cache.keys.splice(n, 1), i.cache.values.splice(n, 1), u(i.cache, i.options, i), v(r, t, !0);
          }
        }, i.update = function (e, n) {
          var t = s(i.cache.keys, c ? c(e) : e);
          if (~t) {
            var r = i.cache.keys[t];
            q(i.cache.keys, r, t), q(i.cache.values, n, t), u(i.cache, i.options, i);
          }
        }, i.values = function () {
          return i.cacheSnapshot.values;
        };
      }(e, n), function (e, n) {
        var t = n.expirations,
          r = n.options,
          i = n.originalFunction,
          o = e.options;
        Object.defineProperties(e, {
          _microMemoizeOptions: {
            configurable: !0,
            get: function get() {
              return o;
            }
          },
          expirations: {
            configurable: !0,
            get: function get() {
              return t;
            }
          },
          expirationsSnapshot: {
            configurable: !0,
            get: function get() {
              return t.slice(0);
            }
          },
          isCollectingStats: {
            configurable: !0,
            get: function get() {
              return h.isCollectingStats;
            }
          },
          isMoized: {
            configurable: !0,
            get: function get() {
              return !0;
            }
          },
          options: {
            configurable: !0,
            get: function get() {
              return r;
            }
          },
          originalFunction: {
            configurable: !0,
            get: function get() {
              return i;
            }
          }
        }), r.isReact && (e.contextTypes = i.contextTypes, e.defaultProps = i.defaultProps, e.displayName = "Moized(" + (i.displayName || i.name || "Component") + ")", e.propTypes = i.propTypes);
      }(e, n), e;
    },
    I = "function" == typeof Map,
    J = "function" == typeof Set,
    W = "function" == typeof WeakSet,
    $ = Object.keys,
    B = Array.isArray,
    G = (s(t()), s(t(C)), s()),
    L = s(function () {
      return C;
    });
  function Q(e, n, t) {
    return "[ref-" + t + "]";
  }
  var U = function U(e, n) {
    if (e[0] === n) return 0;
    for (var t = e.length, r = 1; r < t; r++) {
      if (e[r] === n) return r;
    }
    return -1;
  };
  function V(i, e) {
    var o = e || Q,
      a = "function" == typeof i,
      u = [];
    return function (e, n) {
      if ("object" == _typeof(n)) if (u.length) {
        var t = U(u, this) + 1;
        t ? u = function (e, n) {
          for (var t = new Array(n), r = 0; r < n; r++) {
            t[r] = e[r];
          }
          return t;
        }(u, t) : u[u.length] = this;
        var r = U(u, n);
        if (~r) return o.call(this, e, n, r);
      } else u[0] = n;
      return a ? i.call(this, e, n) : n;
    };
  }
  function X(e, n) {
    return "function" == typeof n ? "" + n : n;
  }
  function Y(n, t) {
    try {
      return JSON.stringify(n, t);
    } catch (e) {
      return function (e, n, t, r) {
        return JSON.stringify(e, V(n, r), t);
      }(n, t);
    }
  }
  function Z(e) {
    return "function" == typeof e.serializer ? o(a, e.serializer) : function (e) {
      var a = e.shouldSerializeFunctions ? X : null;
      return function (e) {
        for (var n, t, r, i = "|", o = 0; o < e.length; o++) {
          i += (n = e[o], t = a, void 0, r = _typeof(n), (!n || "object" != r && "function" != r ? n : Y(n, t)) + "|");
        }
        return [i];
      };
    }(e);
  }
  function ee(e, n) {
    return e[0] === n[0];
  }
  var ne = function ne(r) {
      if ("function" == typeof r) return function (e, n, t) {
        return r(t.cache, t.options, t);
      };
    },
    te = function te(e) {
      var n = e.equals,
        t = e.isDeepEqual,
        r = e.isReact;
      return n || t && G || r && L || C;
    },
    re = function re(e) {
      var n = e.isSerialized;
      return e.matchesKey || n && ee || void 0;
    },
    ie = function ie(e) {
      var n = e.maxArgs,
        t = e.isReact,
        r = e.isSerialized,
        i = e.transformArgs;
      return o(r && Z(e), "function" == typeof i && o(a, i), t && l(2), "number" == typeof n && l(n));
    };
  function oe(t, e) {
    if (void 0 === e && (e = N), t.isMoized) return oe(t.originalFunction, w(t.options, e));
    if ("object" == _typeof(t)) return function (e, n) {
      return void 0 === n && (n = {}), "function" == typeof e ? oe(e, w(t, n)) : oe(w(t, e));
    };
    var n = Object.assign({}, N, e, {
        maxArgs: "number" == typeof e.maxArgs && 0 <= e.maxArgs ? e.maxArgs : N.maxArgs,
        maxSize: "number" == typeof e.maxSize && 0 <= e.maxSize ? e.maxSize : N.maxSize,
        profileName: e.profileName || T(t)
      }),
      r = [],
      i = (n.equals, n.isDeepEqual, n.isPromise),
      o = (n.isReact, n.isSerialized, n.matchesKey, n.maxAge, n.maxArgs, n.maxSize),
      a = n.onCacheAdd,
      u = n.onCacheChange,
      c = n.onCacheHit,
      s = (n.onExpire, n.profileName, n.shouldSerializeFunctions, n.serializer, n.transformArgs, n.updateExpire, function (e, n) {
        if (null == e) return {};
        var t,
          r,
          i = {},
          o = Object.keys(e);
        for (r = 0; r < o.length; r++) {
          t = o[r], 0 <= n.indexOf(t) || (i[t] = e[t]);
        }
        return i;
      }(n, ["equals", "isDeepEqual", "isPromise", "isReact", "isSerialized", "matchesKey", "maxAge", "maxArgs", "maxSize", "onCacheAdd", "onCacheChange", "onCacheHit", "onExpire", "profileName", "shouldSerializeFunctions", "serializer", "transformArgs", "updateExpire"])),
      f = te(n),
      l = re(n),
      h = F(r, n, f, l),
      p = _(n),
      g = ie(n),
      v = Object.assign({}, s, {
        isEqual: f,
        isMatchingKey: l,
        isPromise: i,
        maxSize: o,
        onCacheAdd: ne(H(a, h.onCacheAdd, p.onCacheAdd)),
        onCacheChange: ne(u),
        onCacheHit: ne(H(c, h.onCacheHit, p.onCacheHit)),
        transformKey: g
      });
    return D(y(t, v), {
      expirations: r,
      options: n,
      originalFunction: t
    });
  }
  oe.collectStats = n, oe.compose = function () {
    return o.apply(null, arguments) || oe;
  }, oe.deep = oe({
    isDeepEqual: !0
  }), oe.getStats = f, oe.isCollectingStats = function () {
    return h.isCollectingStats;
  }, oe.isMoized = function (e) {
    return "function" == typeof e && !!e.isMoized;
  }, oe.maxAge = function (e) {
    return oe({
      maxAge: e
    });
  }, oe.maxArgs = function (e) {
    return oe({
      maxArgs: e
    });
  }, oe.maxSize = function (e) {
    return oe({
      maxSize: e
    });
  }, oe.promise = oe({
    isPromise: !0,
    updateExpire: !0
  }), oe.react = oe({
    isReact: !0
  }), oe.reactSimple = oe({
    isReact: !0,
    maxSize: 1
  }), oe.serialize = oe({
    isSerialized: !0
  }), oe.simple = oe({
    maxSize: 1
  }), e.collectStats = n, e.default = oe, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});

/***/ }),

/***/ 47376:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(41539);
__webpack_require__(66992);
__webpack_require__(82472);
__webpack_require__(92990);
__webpack_require__(18927);
__webpack_require__(33105);
__webpack_require__(35035);
__webpack_require__(74345);
__webpack_require__(7174);
__webpack_require__(32846);
__webpack_require__(44731);
__webpack_require__(77209);
__webpack_require__(96319);
__webpack_require__(58867);
__webpack_require__(37789);
__webpack_require__(33739);
__webpack_require__(29368);
__webpack_require__(14483);
__webpack_require__(12056);
__webpack_require__(3462);
__webpack_require__(30678);
__webpack_require__(27462);
__webpack_require__(33824);
__webpack_require__(55021);
__webpack_require__(12974);
__webpack_require__(15016);
var getUint64 = __webpack_require__(80545).getUint64;
var parseSidx = function parseSidx(data) {
  var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
    result = {
      version: data[0],
      flags: new Uint8Array(data.subarray(1, 4)),
      references: [],
      referenceId: view.getUint32(4),
      timescale: view.getUint32(8)
    },
    i = 12;
  if (result.version === 0) {
    result.earliestPresentationTime = view.getUint32(i);
    result.firstOffset = view.getUint32(i + 4);
    i += 8;
  } else {
    // read 64 bits
    result.earliestPresentationTime = getUint64(data.subarray(i));
    result.firstOffset = getUint64(data.subarray(i + 8));
    i += 16;
  }
  i += 2; // reserved

  var referenceCount = view.getUint16(i);
  i += 2; // start of references

  for (; referenceCount > 0; i += 12, referenceCount--) {
    result.references.push({
      referenceType: (data[i] & 0x80) >>> 7,
      referencedSize: view.getUint32(i) & 0x7FFFFFFF,
      subsegmentDuration: view.getUint32(i + 4),
      startsWithSap: !!(data[i + 8] & 0x80),
      sapType: (data[i + 8] & 0x70) >>> 4,
      sapDeltaTime: view.getUint32(i + 8) & 0x0FFFFFFF
    });
  }
  return result;
};
module.exports = parseSidx;

/***/ }),

/***/ 52953:
/***/ ((module) => {

/**
 * mux.js
 *
 * Copyright (c) Brightcove
 * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
 */
var ONE_SECOND_IN_TS = 90000,
  // 90kHz clock
  secondsToVideoTs,
  secondsToAudioTs,
  videoTsToSeconds,
  audioTsToSeconds,
  audioTsToVideoTs,
  videoTsToAudioTs,
  metadataTsToSeconds;
secondsToVideoTs = function secondsToVideoTs(seconds) {
  return seconds * ONE_SECOND_IN_TS;
};
secondsToAudioTs = function secondsToAudioTs(seconds, sampleRate) {
  return seconds * sampleRate;
};
videoTsToSeconds = function videoTsToSeconds(timestamp) {
  return timestamp / ONE_SECOND_IN_TS;
};
audioTsToSeconds = function audioTsToSeconds(timestamp, sampleRate) {
  return timestamp / sampleRate;
};
audioTsToVideoTs = function audioTsToVideoTs(timestamp, sampleRate) {
  return secondsToVideoTs(audioTsToSeconds(timestamp, sampleRate));
};
videoTsToAudioTs = function videoTsToAudioTs(timestamp, sampleRate) {
  return secondsToAudioTs(videoTsToSeconds(timestamp), sampleRate);
};

/**
 * Adjust ID3 tag or caption timing information by the timeline pts values
 * (if keepOriginalTimestamps is false) and convert to seconds
 */
metadataTsToSeconds = function metadataTsToSeconds(timestamp, timelineStartPts, keepOriginalTimestamps) {
  return videoTsToSeconds(keepOriginalTimestamps ? timestamp : timestamp - timelineStartPts);
};
module.exports = {
  ONE_SECOND_IN_TS: ONE_SECOND_IN_TS,
  secondsToVideoTs: secondsToVideoTs,
  secondsToAudioTs: secondsToAudioTs,
  videoTsToSeconds: videoTsToSeconds,
  audioTsToSeconds: audioTsToSeconds,
  audioTsToVideoTs: audioTsToVideoTs,
  videoTsToAudioTs: videoTsToAudioTs,
  metadataTsToSeconds: metadataTsToSeconds
};

/***/ }),

/***/ 80545:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(41539);
__webpack_require__(44363);
__webpack_require__(9653);
var MAX_UINT32 = Math.pow(2, 32);
var getUint64 = function getUint64(uint8) {
  var dv = new DataView(uint8.buffer, uint8.byteOffset, uint8.byteLength);
  var value;
  if (dv.getBigUint64) {
    value = dv.getBigUint64(0);
    if (value < Number.MAX_SAFE_INTEGER) {
      return Number(value);
    }
    return value;
  }
  return dv.getUint32(0) * MAX_UINT32 + dv.getUint32(4);
};
module.exports = {
  getUint64: getUint64,
  MAX_UINT32: MAX_UINT32
};

/***/ }),

/***/ 72213:
/***/ ((module) => {

"use strict";


var numberIsNaN = function numberIsNaN(value) {
  return value !== value;
};
module.exports = function is(a, b) {
  if (a === 0 && b === 0) {
    return 1 / a === 1 / b;
  }
  if (a === b) {
    return true;
  }
  if (numberIsNaN(a) && numberIsNaN(b)) {
    return true;
  }
  return false;
};

/***/ }),

/***/ 17556:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var define = __webpack_require__(97614);
var callBind = __webpack_require__(53785);
var implementation = __webpack_require__(72213);
var getPolyfill = __webpack_require__(52425);
var shim = __webpack_require__(75065);
var polyfill = callBind(getPolyfill(), Object);
define(polyfill, {
  getPolyfill: getPolyfill,
  implementation: implementation,
  shim: shim
});
module.exports = polyfill;

/***/ }),

/***/ 52425:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(43304);
var implementation = __webpack_require__(72213);
module.exports = function getPolyfill() {
  return typeof Object.is === 'function' ? Object.is : implementation;
};

/***/ }),

/***/ 75065:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(43304);
var getPolyfill = __webpack_require__(52425);
var define = __webpack_require__(97614);
module.exports = function shimObjectIs() {
  var polyfill = getPolyfill();
  define(Object, {
    is: polyfill
  }, {
    is: function testObjectIs() {
      return Object.is !== polyfill;
    }
  });
  return polyfill;
};

/***/ }),

/***/ 54874:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(47941);
__webpack_require__(41539);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
var keysShim;
if (!Object.keys) {
  // modified from https://github.com/es-shims/es5-shim
  var has = Object.prototype.hasOwnProperty;
  var toStr = Object.prototype.toString;
  var isArgs = __webpack_require__(83692); // eslint-disable-line global-require
  var isEnumerable = Object.prototype.propertyIsEnumerable;
  var hasDontEnumBug = !isEnumerable.call({
    toString: null
  }, 'toString');
  var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
  var dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor'];
  var equalsConstructorPrototype = function equalsConstructorPrototype(o) {
    var ctor = o.constructor;
    return ctor && ctor.prototype === o;
  };
  var excludedKeys = {
    $applicationCache: true,
    $console: true,
    $external: true,
    $frame: true,
    $frameElement: true,
    $frames: true,
    $innerHeight: true,
    $innerWidth: true,
    $onmozfullscreenchange: true,
    $onmozfullscreenerror: true,
    $outerHeight: true,
    $outerWidth: true,
    $pageXOffset: true,
    $pageYOffset: true,
    $parent: true,
    $scrollLeft: true,
    $scrollTop: true,
    $scrollX: true,
    $scrollY: true,
    $self: true,
    $webkitIndexedDB: true,
    $webkitStorageInfo: true,
    $window: true
  };
  var hasAutomationEqualityBug = function () {
    /* global window */
    if (typeof window === 'undefined') {
      return false;
    }
    for (var k in window) {
      try {
        if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && _typeof(window[k]) === 'object') {
          try {
            equalsConstructorPrototype(window[k]);
          } catch (e) {
            return true;
          }
        }
      } catch (e) {
        return true;
      }
    }
    return false;
  }();
  var equalsConstructorPrototypeIfNotBuggy = function equalsConstructorPrototypeIfNotBuggy(o) {
    /* global window */
    if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
      return equalsConstructorPrototype(o);
    }
    try {
      return equalsConstructorPrototype(o);
    } catch (e) {
      return false;
    }
  };
  keysShim = function keys(object) {
    var isObject = object !== null && _typeof(object) === 'object';
    var isFunction = toStr.call(object) === '[object Function]';
    var isArguments = isArgs(object);
    var isString = isObject && toStr.call(object) === '[object String]';
    var theKeys = [];
    if (!isObject && !isFunction && !isArguments) {
      throw new TypeError('Object.keys called on a non-object');
    }
    var skipProto = hasProtoEnumBug && isFunction;
    if (isString && object.length > 0 && !has.call(object, 0)) {
      for (var i = 0; i < object.length; ++i) {
        theKeys.push(String(i));
      }
    }
    if (isArguments && object.length > 0) {
      for (var j = 0; j < object.length; ++j) {
        theKeys.push(String(j));
      }
    } else {
      for (var name in object) {
        if (!(skipProto && name === 'prototype') && has.call(object, name)) {
          theKeys.push(String(name));
        }
      }
    }
    if (hasDontEnumBug) {
      var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
      for (var k = 0; k < dontEnums.length; ++k) {
        if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
          theKeys.push(dontEnums[k]);
        }
      }
    }
    return theKeys;
  };
}
module.exports = keysShim;

/***/ }),

/***/ 38209:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(47042);
__webpack_require__(47941);
var slice = Array.prototype.slice;
var isArgs = __webpack_require__(83692);
var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) {
  return origKeys(o);
} : __webpack_require__(54874);
var originalKeys = Object.keys;
keysShim.shim = function shimObjectKeys() {
  if (Object.keys) {
    var keysWorksWithArguments = function () {
      // Safari 5.0 bug
      var args = Object.keys(arguments);
      return args && args.length === arguments.length;
    }(1, 2);
    if (!keysWorksWithArguments) {
      Object.keys = function keys(object) {
        // eslint-disable-line func-name-matching
        if (isArgs(object)) {
          return originalKeys(slice.call(object));
        }
        return originalKeys(object);
      };
    }
  } else {
    Object.keys = keysShim;
  }
  return Object.keys || keysShim;
};
module.exports = keysShim;

/***/ }),

/***/ 83692:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(41539);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
var toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
  var str = toStr.call(value);
  var isArgs = str === '[object Arguments]';
  if (!isArgs) {
    isArgs = str !== '[object Array]' && value !== null && _typeof(value) === 'object' && typeof value.length === 'number' && value.length >= 0 && toStr.call(value.callee) === '[object Function]';
  }
  return isArgs;
};

/***/ }),

/***/ 95751:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


// modified from https://github.com/es-shims/es6-shim
__webpack_require__(82526);
var objectKeys = __webpack_require__(38209);
var hasSymbols = __webpack_require__(3810)();
var callBound = __webpack_require__(73684);
var toObject = Object;
var $push = callBound('Array.prototype.push');
var $propIsEnumerable = callBound('Object.prototype.propertyIsEnumerable');
var originalGetSymbols = hasSymbols ? Object.getOwnPropertySymbols : null;

// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
  if (target == null) {
    throw new TypeError('target must be an object');
  }
  var to = toObject(target); // step 1
  if (arguments.length === 1) {
    return to; // step 2
  }

  for (var s = 1; s < arguments.length; ++s) {
    var from = toObject(arguments[s]); // step 3.a.i

    // step 3.a.ii:
    var keys = objectKeys(from);
    var getSymbols = hasSymbols && (Object.getOwnPropertySymbols || originalGetSymbols);
    if (getSymbols) {
      var syms = getSymbols(from);
      for (var j = 0; j < syms.length; ++j) {
        var key = syms[j];
        if ($propIsEnumerable(from, key)) {
          $push(keys, key);
        }
      }
    }

    // step 3.a.iii:
    for (var i = 0; i < keys.length; ++i) {
      var nextKey = keys[i];
      if ($propIsEnumerable(from, nextKey)) {
        // step 3.a.iii.2
        var propValue = from[nextKey]; // step 3.a.iii.2.a
        to[nextKey] = propValue; // step 3.a.iii.2.b
      }
    }
  }

  return to; // step 4
};

/***/ }),

/***/ 38385:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var defineProperties = __webpack_require__(97614);
var callBind = __webpack_require__(53785);
var implementation = __webpack_require__(95751);
var getPolyfill = __webpack_require__(94848);
var shim = __webpack_require__(13666);
var polyfill = callBind.apply(getPolyfill());
// eslint-disable-next-line no-unused-vars
var bound = function assign(target, source1) {
  return polyfill(Object, arguments);
};
defineProperties(bound, {
  getPolyfill: getPolyfill,
  implementation: implementation,
  shim: shim
});
module.exports = bound;

/***/ }),

/***/ 94848:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(19601);
__webpack_require__(74916);
__webpack_require__(23123);
__webpack_require__(57227);
var implementation = __webpack_require__(95751);
var lacksProperEnumerationOrder = function lacksProperEnumerationOrder() {
  if (!Object.assign) {
    return false;
  }
  /*
   * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
   * note: this does not detect the bug unless there's 20 characters
   */
  var str = 'abcdefghijklmnopqrst';
  var letters = str.split('');
  var map = {};
  for (var i = 0; i < letters.length; ++i) {
    map[letters[i]] = letters[i];
  }
  var obj = Object.assign({}, map);
  var actual = '';
  for (var k in obj) {
    actual += k;
  }
  return str !== actual;
};
var assignHasPendingExceptions = function assignHasPendingExceptions() {
  if (!Object.assign || !Object.preventExtensions) {
    return false;
  }
  /*
   * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
   * which is 72% slower than our shim, and Firefox 40's native implementation.
   */
  var thrower = Object.preventExtensions({
    1: 2
  });
  try {
    Object.assign(thrower, 'xy');
  } catch (e) {
    return thrower[1] === 'y';
  }
  return false;
};
module.exports = function getPolyfill() {
  if (!Object.assign) {
    return implementation;
  }
  if (lacksProperEnumerationOrder()) {
    return implementation;
  }
  if (assignHasPendingExceptions()) {
    return implementation;
  }
  return Object.assign;
};

/***/ }),

/***/ 13666:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(19601);
var define = __webpack_require__(97614);
var getPolyfill = __webpack_require__(94848);
module.exports = function shimAssign() {
  var polyfill = getPolyfill();
  define(Object, {
    assign: polyfill
  }, {
    assign: function assign() {
      return Object.assign !== polyfill;
    }
  });
  return polyfill;
};

/***/ }),

/***/ 75419:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
__webpack_require__(68309);
__webpack_require__(30489);
__webpack_require__(41539);
__webpack_require__(17727);
__webpack_require__(39714);
__webpack_require__(12419);
__webpack_require__(66992);
__webpack_require__(51532);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(47042);
__webpack_require__(91038);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var CancelError = /*#__PURE__*/function (_Error) {
  _inherits(CancelError, _Error);
  var _super = _createSuper(CancelError);
  function CancelError(reason) {
    var _this;
    _classCallCheck(this, CancelError);
    _this = _super.call(this, reason || 'Promise was canceled');
    _this.name = 'CancelError';
    return _this;
  }
  _createClass(CancelError, [{
    key: "isCanceled",
    get: function get() {
      return true;
    }
  }]);
  return CancelError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
var PCancelable = /*#__PURE__*/function () {
  function PCancelable(executor) {
    var _this2 = this;
    _classCallCheck(this, PCancelable);
    this._cancelHandlers = [];
    this._isPending = true;
    this._isCanceled = false;
    this._rejectOnCancel = true;
    this._promise = new Promise(function (resolve, reject) {
      _this2._reject = reject;
      var onResolve = function onResolve(value) {
        _this2._isPending = false;
        resolve(value);
      };
      var onReject = function onReject(error) {
        _this2._isPending = false;
        reject(error);
      };
      var onCancel = function onCancel(handler) {
        if (!_this2._isPending) {
          throw new Error('The `onCancel` handler was attached after the promise settled.');
        }
        _this2._cancelHandlers.push(handler);
      };
      Object.defineProperties(onCancel, {
        shouldReject: {
          get: function get() {
            return _this2._rejectOnCancel;
          },
          set: function set(boolean) {
            _this2._rejectOnCancel = boolean;
          }
        }
      });
      return executor(onResolve, onReject, onCancel);
    });
  }
  _createClass(PCancelable, [{
    key: "then",
    value: function then(onFulfilled, onRejected) {
      // eslint-disable-next-line promise/prefer-await-to-then
      return this._promise.then(onFulfilled, onRejected);
    }
  }, {
    key: "catch",
    value: function _catch(onRejected) {
      return this._promise.catch(onRejected);
    }
  }, {
    key: "finally",
    value: function _finally(onFinally) {
      return this._promise.finally(onFinally);
    }
  }, {
    key: "cancel",
    value: function cancel(reason) {
      if (!this._isPending || this._isCanceled) {
        return;
      }
      if (this._cancelHandlers.length > 0) {
        try {
          var _iterator = _createForOfIteratorHelper(this._cancelHandlers),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var handler = _step.value;
              handler();
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } catch (error) {
          this._reject(error);
        }
      }
      this._isCanceled = true;
      if (this._rejectOnCancel) {
        this._reject(new CancelError(reason));
      }
    }
  }, {
    key: "isCanceled",
    get: function get() {
      return this._isCanceled;
    }
  }], [{
    key: "fn",
    value: function fn(userFn) {
      return function () {
        for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
          arguments_[_key] = arguments[_key];
        }
        return new PCancelable(function (resolve, reject, onCancel) {
          arguments_.push(onCancel);
          // eslint-disable-next-line promise/prefer-await-to-then
          userFn.apply(void 0, arguments_).then(resolve, reject);
        });
      };
    }
  }]);
  return PCancelable;
}();
Object.setPrototypeOf(PCancelable.prototype, Promise.prototype);
module.exports = PCancelable;
module.exports.CancelError = CancelError;

/***/ }),

/***/ 82360:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;__webpack_require__(66992);
__webpack_require__(41539);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(60285);
__webpack_require__(41637);
__webpack_require__(39714);
__webpack_require__(47042);
__webpack_require__(57327);
__webpack_require__(24603);
__webpack_require__(74916);
__webpack_require__(47941);
__webpack_require__(73210);
__webpack_require__(69600);
__webpack_require__(15306);
__webpack_require__(40561);
__webpack_require__(92222);
__webpack_require__(54747);
__webpack_require__(21249);
__webpack_require__(23123);
__webpack_require__(26699);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
/* @license
Papa Parse
v5.4.1
https://github.com/mholt/PapaParse
License: MIT
*/
!function (e, t) {
   true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : 0;
}(this, function s() {
  "use strict";

  var f = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== f ? f : {};
  var n = !f.document && !!f.postMessage,
    o = f.IS_PAPA_WORKER || !1,
    a = {},
    u = 0,
    b = {
      parse: function parse(e, t) {
        var r = (t = t || {}).dynamicTyping || !1;
        J(r) && (t.dynamicTypingFunction = r, r = {});
        if (t.dynamicTyping = r, t.transform = !!J(t.transform) && t.transform, t.worker && b.WORKERS_SUPPORTED) {
          var i = function () {
            if (!b.WORKERS_SUPPORTED) return !1;
            var e = (r = f.URL || f.webkitURL || null, i = s.toString(), b.BLOB_URL || (b.BLOB_URL = r.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ", "(", i, ")();"], {
                type: "text/javascript"
              })))),
              t = new f.Worker(e);
            var r, i;
            return t.onmessage = _, t.id = u++, a[t.id] = t;
          }();
          return i.userStep = t.step, i.userChunk = t.chunk, i.userComplete = t.complete, i.userError = t.error, t.step = J(t.step), t.chunk = J(t.chunk), t.complete = J(t.complete), t.error = J(t.error), delete t.worker, void i.postMessage({
            input: e,
            config: t,
            workerId: i.id
          });
        }
        var n = null;
        b.NODE_STREAM_INPUT, "string" == typeof e ? (e = function (e) {
          if (65279 === e.charCodeAt(0)) return e.slice(1);
          return e;
        }(e), n = t.download ? new l(t) : new p(t)) : !0 === e.readable && J(e.read) && J(e.on) ? n = new g(t) : (f.File && e instanceof File || e instanceof Object) && (n = new c(t));
        return n.stream(e);
      },
      unparse: function unparse(e, t) {
        var n = !1,
          _ = !0,
          m = ",",
          y = "\r\n",
          s = '"',
          a = s + s,
          r = !1,
          i = null,
          o = !1;
        !function () {
          if ("object" != _typeof(t)) return;
          "string" != typeof t.delimiter || b.BAD_DELIMITERS.filter(function (e) {
            return -1 !== t.delimiter.indexOf(e);
          }).length || (m = t.delimiter);
          ("boolean" == typeof t.quotes || "function" == typeof t.quotes || Array.isArray(t.quotes)) && (n = t.quotes);
          "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (r = t.skipEmptyLines);
          "string" == typeof t.newline && (y = t.newline);
          "string" == typeof t.quoteChar && (s = t.quoteChar);
          "boolean" == typeof t.header && (_ = t.header);
          if (Array.isArray(t.columns)) {
            if (0 === t.columns.length) throw new Error("Option columns is empty");
            i = t.columns;
          }
          void 0 !== t.escapeChar && (a = t.escapeChar + s);
          ("boolean" == typeof t.escapeFormulae || t.escapeFormulae instanceof RegExp) && (o = t.escapeFormulae instanceof RegExp ? t.escapeFormulae : /^[=+\-@\t\r].*$/);
        }();
        var u = new RegExp(Q(s), "g");
        "string" == typeof e && (e = JSON.parse(e));
        if (Array.isArray(e)) {
          if (!e.length || Array.isArray(e[0])) return h(null, e, r);
          if ("object" == _typeof(e[0])) return h(i || Object.keys(e[0]), e, r);
        } else if ("object" == _typeof(e)) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields || i), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : "object" == _typeof(e.data[0]) ? Object.keys(e.data[0]) : []), Array.isArray(e.data[0]) || "object" == _typeof(e.data[0]) || (e.data = [e.data])), h(e.fields || [], e.data || [], r);
        throw new Error("Unable to serialize unrecognized input");
        function h(e, t, r) {
          var i = "";
          "string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t));
          var n = Array.isArray(e) && 0 < e.length,
            s = !Array.isArray(t[0]);
          if (n && _) {
            for (var a = 0; a < e.length; a++) {
              0 < a && (i += m), i += v(e[a], a);
            }
            0 < t.length && (i += y);
          }
          for (var o = 0; o < t.length; o++) {
            var u = n ? e.length : t[o].length,
              h = !1,
              f = n ? 0 === Object.keys(t[o]).length : 0 === t[o].length;
            if (r && !n && (h = "greedy" === r ? "" === t[o].join("").trim() : 1 === t[o].length && 0 === t[o][0].length), "greedy" === r && n) {
              for (var d = [], l = 0; l < u; l++) {
                var c = s ? e[l] : l;
                d.push(t[o][c]);
              }
              h = "" === d.join("").trim();
            }
            if (!h) {
              for (var p = 0; p < u; p++) {
                0 < p && !f && (i += m);
                var g = n && s ? e[p] : p;
                i += v(t[o][g], p);
              }
              o < t.length - 1 && (!r || 0 < u && !f) && (i += y);
            }
          }
          return i;
        }
        function v(e, t) {
          if (null == e) return "";
          if (e.constructor === Date) return JSON.stringify(e).slice(1, 25);
          var r = !1;
          o && "string" == typeof e && o.test(e) && (e = "'" + e, r = !0);
          var i = e.toString().replace(u, a);
          return (r = r || !0 === n || "function" == typeof n && n(e, t) || Array.isArray(n) && n[t] || function (e, t) {
            for (var r = 0; r < t.length; r++) {
              if (-1 < e.indexOf(t[r])) return !0;
            }
            return !1;
          }(i, b.BAD_DELIMITERS) || -1 < i.indexOf(m) || " " === i.charAt(0) || " " === i.charAt(i.length - 1)) ? s + i + s : i;
        }
      }
    };
  if (b.RECORD_SEP = String.fromCharCode(30), b.UNIT_SEP = String.fromCharCode(31), b.BYTE_ORDER_MARK = "\uFEFF", b.BAD_DELIMITERS = ["\r", "\n", '"', b.BYTE_ORDER_MARK], b.WORKERS_SUPPORTED = !n && !!f.Worker, b.NODE_STREAM_INPUT = 1, b.LocalChunkSize = 10485760, b.RemoteChunkSize = 5242880, b.DefaultDelimiter = ",", b.Parser = E, b.ParserHandle = r, b.NetworkStreamer = l, b.FileStreamer = c, b.StringStreamer = p, b.ReadableStreamStreamer = g, f.jQuery) {
    var d = f.jQuery;
    d.fn.parse = function (o) {
      var r = o.config || {},
        u = [];
      return this.each(function (e) {
        if (!("INPUT" === d(this).prop("tagName").toUpperCase() && "file" === d(this).attr("type").toLowerCase() && f.FileReader) || !this.files || 0 === this.files.length) return !0;
        for (var t = 0; t < this.files.length; t++) {
          u.push({
            file: this.files[t],
            inputElem: this,
            instanceConfig: d.extend({}, r)
          });
        }
      }), e(), this;
      function e() {
        if (0 !== u.length) {
          var e,
            t,
            r,
            i,
            n = u[0];
          if (J(o.before)) {
            var s = o.before(n.file, n.inputElem);
            if ("object" == _typeof(s)) {
              if ("abort" === s.action) return e = "AbortError", t = n.file, r = n.inputElem, i = s.reason, void (J(o.error) && o.error({
                name: e
              }, t, r, i));
              if ("skip" === s.action) return void h();
              "object" == _typeof(s.config) && (n.instanceConfig = d.extend(n.instanceConfig, s.config));
            } else if ("skip" === s) return void h();
          }
          var a = n.instanceConfig.complete;
          n.instanceConfig.complete = function (e) {
            J(a) && a(e, n.file, n.inputElem), h();
          }, b.parse(n.file, n.instanceConfig);
        } else J(o.complete) && o.complete();
      }
      function h() {
        u.splice(0, 1), e();
      }
    };
  }
  function h(e) {
    this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
      data: [],
      errors: [],
      meta: {}
    }, function (e) {
      var t = w(e);
      t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null);
      this._handle = new r(t), (this._handle.streamer = this)._config = t;
    }.call(this, e), this.parseChunk = function (e, t) {
      if (this.isFirstChunk && J(this._config.beforeFirstChunk)) {
        var r = this._config.beforeFirstChunk(e);
        void 0 !== r && (e = r);
      }
      this.isFirstChunk = !1, this._halted = !1;
      var i = this._partialLine + e;
      this._partialLine = "";
      var n = this._handle.parse(i, this._baseIndex, !this._finished);
      if (!this._handle.paused() && !this._handle.aborted()) {
        var s = n.meta.cursor;
        this._finished || (this._partialLine = i.substring(s - this._baseIndex), this._baseIndex = s), n && n.data && (this._rowCount += n.data.length);
        var a = this._finished || this._config.preview && this._rowCount >= this._config.preview;
        if (o) f.postMessage({
          results: n,
          workerId: b.WORKER_ID,
          finished: a
        });else if (J(this._config.chunk) && !t) {
          if (this._config.chunk(n, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
          n = void 0, this._completeResults = void 0;
        }
        return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(n.data), this._completeResults.errors = this._completeResults.errors.concat(n.errors), this._completeResults.meta = n.meta), this._completed || !a || !J(this._config.complete) || n && n.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), a || n && n.meta.paused || this._nextChunk(), n;
      }
      this._halted = !0;
    }, this._sendError = function (e) {
      J(this._config.error) ? this._config.error(e) : o && this._config.error && f.postMessage({
        workerId: b.WORKER_ID,
        error: e,
        finished: !1
      });
    };
  }
  function l(e) {
    var i;
    (e = e || {}).chunkSize || (e.chunkSize = b.RemoteChunkSize), h.call(this, e), this._nextChunk = n ? function () {
      this._readChunk(), this._chunkLoaded();
    } : function () {
      this._readChunk();
    }, this.stream = function (e) {
      this._input = e, this._nextChunk();
    }, this._readChunk = function () {
      if (this._finished) this._chunkLoaded();else {
        if (i = new XMLHttpRequest(), this._config.withCredentials && (i.withCredentials = this._config.withCredentials), n || (i.onload = v(this._chunkLoaded, this), i.onerror = v(this._chunkError, this)), i.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !n), this._config.downloadRequestHeaders) {
          var e = this._config.downloadRequestHeaders;
          for (var t in e) {
            i.setRequestHeader(t, e[t]);
          }
        }
        if (this._config.chunkSize) {
          var r = this._start + this._config.chunkSize - 1;
          i.setRequestHeader("Range", "bytes=" + this._start + "-" + r);
        }
        try {
          i.send(this._config.downloadRequestBody);
        } catch (e) {
          this._chunkError(e.message);
        }
        n && 0 === i.status && this._chunkError();
      }
    }, this._chunkLoaded = function () {
      4 === i.readyState && (i.status < 200 || 400 <= i.status ? this._chunkError() : (this._start += this._config.chunkSize ? this._config.chunkSize : i.responseText.length, this._finished = !this._config.chunkSize || this._start >= function (e) {
        var t = e.getResponseHeader("Content-Range");
        if (null === t) return -1;
        return parseInt(t.substring(t.lastIndexOf("/") + 1));
      }(i), this.parseChunk(i.responseText)));
    }, this._chunkError = function (e) {
      var t = i.statusText || e;
      this._sendError(new Error(t));
    };
  }
  function c(e) {
    var i, n;
    (e = e || {}).chunkSize || (e.chunkSize = b.LocalChunkSize), h.call(this, e);
    var s = "undefined" != typeof FileReader;
    this.stream = function (e) {
      this._input = e, n = e.slice || e.webkitSlice || e.mozSlice, s ? ((i = new FileReader()).onload = v(this._chunkLoaded, this), i.onerror = v(this._chunkError, this)) : i = new FileReaderSync(), this._nextChunk();
    }, this._nextChunk = function () {
      this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
    }, this._readChunk = function () {
      var e = this._input;
      if (this._config.chunkSize) {
        var t = Math.min(this._start + this._config.chunkSize, this._input.size);
        e = n.call(e, this._start, t);
      }
      var r = i.readAsText(e, this._config.encoding);
      s || this._chunkLoaded({
        target: {
          result: r
        }
      });
    }, this._chunkLoaded = function (e) {
      this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
    }, this._chunkError = function () {
      this._sendError(i.error);
    };
  }
  function p(e) {
    var r;
    h.call(this, e = e || {}), this.stream = function (e) {
      return r = e, this._nextChunk();
    }, this._nextChunk = function () {
      if (!this._finished) {
        var e,
          t = this._config.chunkSize;
        return t ? (e = r.substring(0, t), r = r.substring(t)) : (e = r, r = ""), this._finished = !r, this.parseChunk(e);
      }
    };
  }
  function g(e) {
    h.call(this, e = e || {});
    var t = [],
      r = !0,
      i = !1;
    this.pause = function () {
      h.prototype.pause.apply(this, arguments), this._input.pause();
    }, this.resume = function () {
      h.prototype.resume.apply(this, arguments), this._input.resume();
    }, this.stream = function (e) {
      this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
    }, this._checkIsFinished = function () {
      i && 1 === t.length && (this._finished = !0);
    }, this._nextChunk = function () {
      this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : r = !0;
    }, this._streamData = v(function (e) {
      try {
        t.push("string" == typeof e ? e : e.toString(this._config.encoding)), r && (r = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
      } catch (e) {
        this._streamError(e);
      }
    }, this), this._streamError = v(function (e) {
      this._streamCleanUp(), this._sendError(e);
    }, this), this._streamEnd = v(function () {
      this._streamCleanUp(), i = !0, this._streamData("");
    }, this), this._streamCleanUp = v(function () {
      this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
    }, this);
  }
  function r(m) {
    var a,
      o,
      u,
      i = Math.pow(2, 53),
      n = -i,
      s = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/,
      h = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/,
      t = this,
      r = 0,
      f = 0,
      d = !1,
      e = !1,
      l = [],
      c = {
        data: [],
        errors: [],
        meta: {}
      };
    if (J(m.step)) {
      var p = m.step;
      m.step = function (e) {
        if (c = e, _()) g();else {
          if (g(), 0 === c.data.length) return;
          r += e.data.length, m.preview && r > m.preview ? o.abort() : (c.data = c.data[0], p(c, t));
        }
      };
    }
    function y(e) {
      return "greedy" === m.skipEmptyLines ? "" === e.join("").trim() : 1 === e.length && 0 === e[0].length;
    }
    function g() {
      return c && u && (k("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + b.DefaultDelimiter + "'"), u = !1), m.skipEmptyLines && (c.data = c.data.filter(function (e) {
        return !y(e);
      })), _() && function () {
        if (!c) return;
        function e(e, t) {
          J(m.transformHeader) && (e = m.transformHeader(e, t)), l.push(e);
        }
        if (Array.isArray(c.data[0])) {
          for (var t = 0; _() && t < c.data.length; t++) {
            c.data[t].forEach(e);
          }
          c.data.splice(0, 1);
        } else c.data.forEach(e);
      }(), function () {
        if (!c || !m.header && !m.dynamicTyping && !m.transform) return c;
        function e(e, t) {
          var r,
            i = m.header ? {} : [];
          for (r = 0; r < e.length; r++) {
            var n = r,
              s = e[r];
            m.header && (n = r >= l.length ? "__parsed_extra" : l[r]), m.transform && (s = m.transform(s, n)), s = v(n, s), "__parsed_extra" === n ? (i[n] = i[n] || [], i[n].push(s)) : i[n] = s;
          }
          return m.header && (r > l.length ? k("FieldMismatch", "TooManyFields", "Too many fields: expected " + l.length + " fields but parsed " + r, f + t) : r < l.length && k("FieldMismatch", "TooFewFields", "Too few fields: expected " + l.length + " fields but parsed " + r, f + t)), i;
        }
        var t = 1;
        !c.data.length || Array.isArray(c.data[0]) ? (c.data = c.data.map(e), t = c.data.length) : c.data = e(c.data, 0);
        m.header && c.meta && (c.meta.fields = l);
        return f += t, c;
      }();
    }
    function _() {
      return m.header && 0 === l.length;
    }
    function v(e, t) {
      return r = e, m.dynamicTypingFunction && void 0 === m.dynamicTyping[r] && (m.dynamicTyping[r] = m.dynamicTypingFunction(r)), !0 === (m.dynamicTyping[r] || m.dynamicTyping) ? "true" === t || "TRUE" === t || "false" !== t && "FALSE" !== t && (function (e) {
        if (s.test(e)) {
          var t = parseFloat(e);
          if (n < t && t < i) return !0;
        }
        return !1;
      }(t) ? parseFloat(t) : h.test(t) ? new Date(t) : "" === t ? null : t) : t;
      var r;
    }
    function k(e, t, r, i) {
      var n = {
        type: e,
        code: t,
        message: r
      };
      void 0 !== i && (n.row = i), c.errors.push(n);
    }
    this.parse = function (e, t, r) {
      var i = m.quoteChar || '"';
      if (m.newline || (m.newline = function (e, t) {
        e = e.substring(0, 1048576);
        var r = new RegExp(Q(t) + "([^]*?)" + Q(t), "gm"),
          i = (e = e.replace(r, "")).split("\r"),
          n = e.split("\n"),
          s = 1 < n.length && n[0].length < i[0].length;
        if (1 === i.length || s) return "\n";
        for (var a = 0, o = 0; o < i.length; o++) {
          "\n" === i[o][0] && a++;
        }
        return a >= i.length / 2 ? "\r\n" : "\r";
      }(e, i)), u = !1, m.delimiter) J(m.delimiter) && (m.delimiter = m.delimiter(e), c.meta.delimiter = m.delimiter);else {
        var n = function (e, t, r, i, n) {
          var s, a, o, u;
          n = n || [",", "\t", "|", ";", b.RECORD_SEP, b.UNIT_SEP];
          for (var h = 0; h < n.length; h++) {
            var f = n[h],
              d = 0,
              l = 0,
              c = 0;
            o = void 0;
            for (var p = new E({
                comments: i,
                delimiter: f,
                newline: t,
                preview: 10
              }).parse(e), g = 0; g < p.data.length; g++) {
              if (r && y(p.data[g])) c++;else {
                var _ = p.data[g].length;
                l += _, void 0 !== o ? 0 < _ && (d += Math.abs(_ - o), o = _) : o = _;
              }
            }
            0 < p.data.length && (l /= p.data.length - c), (void 0 === a || d <= a) && (void 0 === u || u < l) && 1.99 < l && (a = d, s = f, u = l);
          }
          return {
            successful: !!(m.delimiter = s),
            bestDelimiter: s
          };
        }(e, m.newline, m.skipEmptyLines, m.comments, m.delimitersToGuess);
        n.successful ? m.delimiter = n.bestDelimiter : (u = !0, m.delimiter = b.DefaultDelimiter), c.meta.delimiter = m.delimiter;
      }
      var s = w(m);
      return m.preview && m.header && s.preview++, a = e, o = new E(s), c = o.parse(a, t, r), g(), d ? {
        meta: {
          paused: !0
        }
      } : c || {
        meta: {
          paused: !1
        }
      };
    }, this.paused = function () {
      return d;
    }, this.pause = function () {
      d = !0, o.abort(), a = J(m.chunk) ? "" : a.substring(o.getCharIndex());
    }, this.resume = function () {
      t.streamer._halted ? (d = !1, t.streamer.parseChunk(a, !0)) : setTimeout(t.resume, 3);
    }, this.aborted = function () {
      return e;
    }, this.abort = function () {
      e = !0, o.abort(), c.meta.aborted = !0, J(m.complete) && m.complete(c), a = "";
    };
  }
  function Q(e) {
    return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
  function E(j) {
    var z,
      M = (j = j || {}).delimiter,
      P = j.newline,
      U = j.comments,
      q = j.step,
      N = j.preview,
      B = j.fastMode,
      K = z = void 0 === j.quoteChar || null === j.quoteChar ? '"' : j.quoteChar;
    if (void 0 !== j.escapeChar && (K = j.escapeChar), ("string" != typeof M || -1 < b.BAD_DELIMITERS.indexOf(M)) && (M = ","), U === M) throw new Error("Comment character same as delimiter");
    !0 === U ? U = "#" : ("string" != typeof U || -1 < b.BAD_DELIMITERS.indexOf(U)) && (U = !1), "\n" !== P && "\r" !== P && "\r\n" !== P && (P = "\n");
    var W = 0,
      H = !1;
    this.parse = function (i, t, r) {
      if ("string" != typeof i) throw new Error("Input must be a string");
      var n = i.length,
        e = M.length,
        s = P.length,
        a = U.length,
        o = J(q),
        u = [],
        h = [],
        f = [],
        d = W = 0;
      if (!i) return L();
      if (j.header && !t) {
        var l = i.split(P)[0].split(M),
          c = [],
          p = {},
          g = !1;
        for (var _ in l) {
          var m = l[_];
          J(j.transformHeader) && (m = j.transformHeader(m, _));
          var y = m,
            v = p[m] || 0;
          for (0 < v && (g = !0, y = m + "_" + v), p[m] = v + 1; c.includes(y);) {
            y = y + "_" + v;
          }
          c.push(y);
        }
        if (g) {
          var k = i.split(P);
          k[0] = c.join(M), i = k.join(P);
        }
      }
      if (B || !1 !== B && -1 === i.indexOf(z)) {
        for (var b = i.split(P), E = 0; E < b.length; E++) {
          if (f = b[E], W += f.length, E !== b.length - 1) W += P.length;else if (r) return L();
          if (!U || f.substring(0, a) !== U) {
            if (o) {
              if (u = [], I(f.split(M)), F(), H) return L();
            } else I(f.split(M));
            if (N && N <= E) return u = u.slice(0, N), L(!0);
          }
        }
        return L();
      }
      for (var w = i.indexOf(M, W), R = i.indexOf(P, W), C = new RegExp(Q(K) + Q(z), "g"), S = i.indexOf(z, W);;) {
        if (i[W] !== z) {
          if (U && 0 === f.length && i.substring(W, W + a) === U) {
            if (-1 === R) return L();
            W = R + s, R = i.indexOf(P, W), w = i.indexOf(M, W);
          } else if (-1 !== w && (w < R || -1 === R)) f.push(i.substring(W, w)), W = w + e, w = i.indexOf(M, W);else {
            if (-1 === R) break;
            if (f.push(i.substring(W, R)), D(R + s), o && (F(), H)) return L();
            if (N && u.length >= N) return L(!0);
          }
        } else for (S = W, W++;;) {
          if (-1 === (S = i.indexOf(z, S + 1))) return r || h.push({
            type: "Quotes",
            code: "MissingQuotes",
            message: "Quoted field unterminated",
            row: u.length,
            index: W
          }), T();
          if (S === n - 1) return T(i.substring(W, S).replace(C, z));
          if (z !== K || i[S + 1] !== K) {
            if (z === K || 0 === S || i[S - 1] !== K) {
              -1 !== w && w < S + 1 && (w = i.indexOf(M, S + 1)), -1 !== R && R < S + 1 && (R = i.indexOf(P, S + 1));
              var O = A(-1 === R ? w : Math.min(w, R));
              if (i.substr(S + 1 + O, e) === M) {
                f.push(i.substring(W, S).replace(C, z)), i[W = S + 1 + O + e] !== z && (S = i.indexOf(z, W)), w = i.indexOf(M, W), R = i.indexOf(P, W);
                break;
              }
              var x = A(R);
              if (i.substring(S + 1 + x, S + 1 + x + s) === P) {
                if (f.push(i.substring(W, S).replace(C, z)), D(S + 1 + x + s), w = i.indexOf(M, W), S = i.indexOf(z, W), o && (F(), H)) return L();
                if (N && u.length >= N) return L(!0);
                break;
              }
              h.push({
                type: "Quotes",
                code: "InvalidQuotes",
                message: "Trailing quote on quoted field is malformed",
                row: u.length,
                index: W
              }), S++;
            }
          } else S++;
        }
      }
      return T();
      function I(e) {
        u.push(e), d = W;
      }
      function A(e) {
        var t = 0;
        if (-1 !== e) {
          var r = i.substring(S + 1, e);
          r && "" === r.trim() && (t = r.length);
        }
        return t;
      }
      function T(e) {
        return r || (void 0 === e && (e = i.substring(W)), f.push(e), W = n, I(f), o && F()), L();
      }
      function D(e) {
        W = e, I(f), f = [], R = i.indexOf(P, W);
      }
      function L(e) {
        return {
          data: u,
          errors: h,
          meta: {
            delimiter: M,
            linebreak: P,
            aborted: H,
            truncated: !!e,
            cursor: d + (t || 0)
          }
        };
      }
      function F() {
        q(L()), u = [], h = [];
      }
    }, this.abort = function () {
      H = !0;
    }, this.getCharIndex = function () {
      return W;
    };
  }
  function _(e) {
    var t = e.data,
      r = a[t.workerId],
      i = !1;
    if (t.error) r.userError(t.error, t.file);else if (t.results && t.results.data) {
      var n = {
        abort: function abort() {
          i = !0, m(t.workerId, {
            data: [],
            errors: [],
            meta: {
              aborted: !0
            }
          });
        },
        pause: y,
        resume: y
      };
      if (J(r.userStep)) {
        for (var s = 0; s < t.results.data.length && (r.userStep({
          data: t.results.data[s],
          errors: t.results.errors,
          meta: t.results.meta
        }, n), !i); s++) {
          ;
        }
        delete t.results;
      } else J(r.userChunk) && (r.userChunk(t.results, n, t.file), delete t.results);
    }
    t.finished && !i && m(t.workerId, t.results);
  }
  function m(e, t) {
    var r = a[e];
    J(r.userComplete) && r.userComplete(t), r.terminate(), delete a[e];
  }
  function y() {
    throw new Error("Not implemented.");
  }
  function w(e) {
    if ("object" != _typeof(e) || null === e) return e;
    var t = Array.isArray(e) ? [] : {};
    for (var r in e) {
      t[r] = w(e[r]);
    }
    return t;
  }
  function v(e, t) {
    return function () {
      e.apply(t, arguments);
    };
  }
  function J(e) {
    return "function" == typeof e;
  }
  return o && (f.onmessage = function (e) {
    var t = e.data;
    void 0 === b.WORKER_ID && t && (b.WORKER_ID = t.workerId);
    if ("string" == typeof t.input) f.postMessage({
      workerId: b.WORKER_ID,
      results: b.parse(t.input, t.config),
      finished: !0
    });else if (f.File && t.input instanceof File || t.input instanceof Object) {
      var r = b.parse(t.input, t.config);
      r && f.postMessage({
        workerId: b.WORKER_ID,
        results: r,
        finished: !0
      });
    }
  }), (l.prototype = Object.create(h.prototype)).constructor = l, (c.prototype = Object.create(h.prototype)).constructor = c, (p.prototype = Object.create(p.prototype)).constructor = p, (g.prototype = Object.create(h.prototype)).constructor = g, b;
});

/***/ }),

/***/ 15461:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(21249);
__webpack_require__(23123);
__webpack_require__(47042);
__webpack_require__(57327);
__webpack_require__(69600);
__webpack_require__(41539);
__webpack_require__(39714);
__webpack_require__(92222);
var convert = __webpack_require__(77306);
module.exports = function (cstr) {
  var m, conv, parts, alpha;
  if (m = /^((?:rgb|hs[lv]|cmyk|xyz|lab)a?)\s*\(([^\)]*)\)/.exec(cstr)) {
    var name = m[1];
    var base = name.replace(/a$/, '');
    var size = base === 'cmyk' ? 4 : 3;
    conv = convert[base];
    parts = m[2].replace(/^\s+|\s+$/g, '').split(/\s*,\s*/).map(function (x, i) {
      if (/%$/.test(x) && i === size) {
        return parseFloat(x) / 100;
      } else if (/%$/.test(x)) {
        return parseFloat(x);
      }
      return parseFloat(x);
    });
    if (name === base) parts.push(1);
    alpha = parts[size] === undefined ? 1 : parts[size];
    parts = parts.slice(0, size);
    conv[base] = function () {
      return parts;
    };
  } else if (/^#[A-Fa-f0-9]+$/.test(cstr)) {
    var base = cstr.replace(/^#/, '');
    var size = base.length;
    conv = convert.rgb;
    parts = base.split(size === 3 ? /(.)/ : /(..)/);
    parts = parts.filter(Boolean).map(function (x) {
      if (size === 3) {
        return parseInt(x + x, 16);
      } else {
        return parseInt(x, 16);
      }
    });
    alpha = 1;
    conv.rgb = function () {
      return parts;
    };
    if (!parts[0]) parts[0] = 0;
    if (!parts[1]) parts[1] = 0;
    if (!parts[2]) parts[2] = 0;
  } else {
    conv = convert.keyword;
    conv.keyword = function () {
      return cstr;
    };
    parts = cstr;
    alpha = 1;
  }
  var res = {
    rgb: undefined,
    hsl: undefined,
    hsv: undefined,
    cmyk: undefined,
    keyword: undefined,
    hex: undefined
  };
  try {
    res.rgb = conv.rgb(parts);
  } catch (e) {}
  try {
    res.hsl = conv.hsl(parts);
  } catch (e) {}
  try {
    res.hsv = conv.hsv(parts);
  } catch (e) {}
  try {
    res.cmyk = conv.cmyk(parts);
  } catch (e) {}
  try {
    res.keyword = conv.keyword(parts);
  } catch (e) {}
  if (res.rgb) res.hex = '#' + res.rgb.map(function (x) {
    var s = x.toString(16);
    if (s.length === 1) return '0' + s;
    return s;
  }).join('');
  if (res.rgb) res.rgba = res.rgb.concat(alpha);
  if (res.hsl) res.hsla = res.hsl.concat(alpha);
  if (res.hsv) res.hsva = res.hsv.concat(alpha);
  if (res.cmyk) res.cmyka = res.cmyk.concat(alpha);
  return res;
};

/***/ }),

/***/ 76882:
/***/ ((module) => {

/* MIT license */

module.exports = {
  rgb2hsl: rgb2hsl,
  rgb2hsv: rgb2hsv,
  rgb2hwb: rgb2hwb,
  rgb2cmyk: rgb2cmyk,
  rgb2keyword: rgb2keyword,
  rgb2xyz: rgb2xyz,
  rgb2lab: rgb2lab,
  rgb2lch: rgb2lch,
  hsl2rgb: hsl2rgb,
  hsl2hsv: hsl2hsv,
  hsl2hwb: hsl2hwb,
  hsl2cmyk: hsl2cmyk,
  hsl2keyword: hsl2keyword,
  hsv2rgb: hsv2rgb,
  hsv2hsl: hsv2hsl,
  hsv2hwb: hsv2hwb,
  hsv2cmyk: hsv2cmyk,
  hsv2keyword: hsv2keyword,
  hwb2rgb: hwb2rgb,
  hwb2hsl: hwb2hsl,
  hwb2hsv: hwb2hsv,
  hwb2cmyk: hwb2cmyk,
  hwb2keyword: hwb2keyword,
  cmyk2rgb: cmyk2rgb,
  cmyk2hsl: cmyk2hsl,
  cmyk2hsv: cmyk2hsv,
  cmyk2hwb: cmyk2hwb,
  cmyk2keyword: cmyk2keyword,
  keyword2rgb: keyword2rgb,
  keyword2hsl: keyword2hsl,
  keyword2hsv: keyword2hsv,
  keyword2hwb: keyword2hwb,
  keyword2cmyk: keyword2cmyk,
  keyword2lab: keyword2lab,
  keyword2xyz: keyword2xyz,
  xyz2rgb: xyz2rgb,
  xyz2lab: xyz2lab,
  xyz2lch: xyz2lch,
  lab2xyz: lab2xyz,
  lab2rgb: lab2rgb,
  lab2lch: lab2lch,
  lch2lab: lch2lab,
  lch2xyz: lch2xyz,
  lch2rgb: lch2rgb
};
function rgb2hsl(rgb) {
  var r = rgb[0] / 255,
    g = rgb[1] / 255,
    b = rgb[2] / 255,
    min = Math.min(r, g, b),
    max = Math.max(r, g, b),
    delta = max - min,
    h,
    s,
    l;
  if (max == min) h = 0;else if (r == max) h = (g - b) / delta;else if (g == max) h = 2 + (b - r) / delta;else if (b == max) h = 4 + (r - g) / delta;
  h = Math.min(h * 60, 360);
  if (h < 0) h += 360;
  l = (min + max) / 2;
  if (max == min) s = 0;else if (l <= 0.5) s = delta / (max + min);else s = delta / (2 - max - min);
  return [h, s * 100, l * 100];
}
function rgb2hsv(rgb) {
  var r = rgb[0],
    g = rgb[1],
    b = rgb[2],
    min = Math.min(r, g, b),
    max = Math.max(r, g, b),
    delta = max - min,
    h,
    s,
    v;
  if (max == 0) s = 0;else s = delta / max * 1000 / 10;
  if (max == min) h = 0;else if (r == max) h = (g - b) / delta;else if (g == max) h = 2 + (b - r) / delta;else if (b == max) h = 4 + (r - g) / delta;
  h = Math.min(h * 60, 360);
  if (h < 0) h += 360;
  v = max / 255 * 1000 / 10;
  return [h, s, v];
}
function rgb2hwb(rgb) {
  var r = rgb[0],
    g = rgb[1],
    b = rgb[2],
    h = rgb2hsl(rgb)[0],
    w = 1 / 255 * Math.min(r, Math.min(g, b)),
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
  return [h, w * 100, b * 100];
}
function rgb2cmyk(rgb) {
  var r = rgb[0] / 255,
    g = rgb[1] / 255,
    b = rgb[2] / 255,
    c,
    m,
    y,
    k;
  k = Math.min(1 - r, 1 - g, 1 - b);
  c = (1 - r - k) / (1 - k) || 0;
  m = (1 - g - k) / (1 - k) || 0;
  y = (1 - b - k) / (1 - k) || 0;
  return [c * 100, m * 100, y * 100, k * 100];
}
function rgb2keyword(rgb) {
  return reverseKeywords[JSON.stringify(rgb)];
}
function rgb2xyz(rgb) {
  var r = rgb[0] / 255,
    g = rgb[1] / 255,
    b = rgb[2] / 255;

  // assume sRGB
  r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
  g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
  b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
  var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
  var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
  var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
  return [x * 100, y * 100, z * 100];
}
function rgb2lab(rgb) {
  var xyz = rgb2xyz(rgb),
    x = xyz[0],
    y = xyz[1],
    z = xyz[2],
    l,
    a,
    b;
  x /= 95.047;
  y /= 100;
  z /= 108.883;
  x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
  y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
  z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
  l = 116 * y - 16;
  a = 500 * (x - y);
  b = 200 * (y - z);
  return [l, a, b];
}
function rgb2lch(args) {
  return lab2lch(rgb2lab(args));
}
function hsl2rgb(hsl) {
  var h = hsl[0] / 360,
    s = hsl[1] / 100,
    l = hsl[2] / 100,
    t1,
    t2,
    t3,
    rgb,
    val;
  if (s == 0) {
    val = l * 255;
    return [val, val, val];
  }
  if (l < 0.5) t2 = l * (1 + s);else t2 = l + s - l * s;
  t1 = 2 * l - t2;
  rgb = [0, 0, 0];
  for (var i = 0; i < 3; i++) {
    t3 = h + 1 / 3 * -(i - 1);
    t3 < 0 && t3++;
    t3 > 1 && t3--;
    if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;else if (2 * t3 < 1) val = t2;else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;else val = t1;
    rgb[i] = val * 255;
  }
  return rgb;
}
function hsl2hsv(hsl) {
  var h = hsl[0],
    s = hsl[1] / 100,
    l = hsl[2] / 100,
    sv,
    v;
  if (l === 0) {
    // no need to do calc on black
    // also avoids divide by 0 error
    return [0, 0, 0];
  }
  l *= 2;
  s *= l <= 1 ? l : 2 - l;
  v = (l + s) / 2;
  sv = 2 * s / (l + s);
  return [h, sv * 100, v * 100];
}
function hsl2hwb(args) {
  return rgb2hwb(hsl2rgb(args));
}
function hsl2cmyk(args) {
  return rgb2cmyk(hsl2rgb(args));
}
function hsl2keyword(args) {
  return rgb2keyword(hsl2rgb(args));
}
function hsv2rgb(hsv) {
  var h = hsv[0] / 60,
    s = hsv[1] / 100,
    v = hsv[2] / 100,
    hi = Math.floor(h) % 6;
  var f = h - Math.floor(h),
    p = 255 * v * (1 - s),
    q = 255 * v * (1 - s * f),
    t = 255 * v * (1 - s * (1 - f)),
    v = 255 * v;
  switch (hi) {
    case 0:
      return [v, t, p];
    case 1:
      return [q, v, p];
    case 2:
      return [p, v, t];
    case 3:
      return [p, q, v];
    case 4:
      return [t, p, v];
    case 5:
      return [v, p, q];
  }
}
function hsv2hsl(hsv) {
  var h = hsv[0],
    s = hsv[1] / 100,
    v = hsv[2] / 100,
    sl,
    l;
  l = (2 - s) * v;
  sl = s * v;
  sl /= l <= 1 ? l : 2 - l;
  sl = sl || 0;
  l /= 2;
  return [h, sl * 100, l * 100];
}
function hsv2hwb(args) {
  return rgb2hwb(hsv2rgb(args));
}
function hsv2cmyk(args) {
  return rgb2cmyk(hsv2rgb(args));
}
function hsv2keyword(args) {
  return rgb2keyword(hsv2rgb(args));
}

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
function hwb2rgb(hwb) {
  var h = hwb[0] / 360,
    wh = hwb[1] / 100,
    bl = hwb[2] / 100,
    ratio = wh + bl,
    i,
    v,
    f,
    n;

  // wh + bl cant be > 1
  if (ratio > 1) {
    wh /= ratio;
    bl /= ratio;
  }
  i = Math.floor(6 * h);
  v = 1 - bl;
  f = 6 * h - i;
  if ((i & 0x01) != 0) {
    f = 1 - f;
  }
  n = wh + f * (v - wh); // linear interpolation

  switch (i) {
    default:
    case 6:
    case 0:
      r = v;
      g = n;
      b = wh;
      break;
    case 1:
      r = n;
      g = v;
      b = wh;
      break;
    case 2:
      r = wh;
      g = v;
      b = n;
      break;
    case 3:
      r = wh;
      g = n;
      b = v;
      break;
    case 4:
      r = n;
      g = wh;
      b = v;
      break;
    case 5:
      r = v;
      g = wh;
      b = n;
      break;
  }
  return [r * 255, g * 255, b * 255];
}
function hwb2hsl(args) {
  return rgb2hsl(hwb2rgb(args));
}
function hwb2hsv(args) {
  return rgb2hsv(hwb2rgb(args));
}
function hwb2cmyk(args) {
  return rgb2cmyk(hwb2rgb(args));
}
function hwb2keyword(args) {
  return rgb2keyword(hwb2rgb(args));
}
function cmyk2rgb(cmyk) {
  var c = cmyk[0] / 100,
    m = cmyk[1] / 100,
    y = cmyk[2] / 100,
    k = cmyk[3] / 100,
    r,
    g,
    b;
  r = 1 - Math.min(1, c * (1 - k) + k);
  g = 1 - Math.min(1, m * (1 - k) + k);
  b = 1 - Math.min(1, y * (1 - k) + k);
  return [r * 255, g * 255, b * 255];
}
function cmyk2hsl(args) {
  return rgb2hsl(cmyk2rgb(args));
}
function cmyk2hsv(args) {
  return rgb2hsv(cmyk2rgb(args));
}
function cmyk2hwb(args) {
  return rgb2hwb(cmyk2rgb(args));
}
function cmyk2keyword(args) {
  return rgb2keyword(cmyk2rgb(args));
}
function xyz2rgb(xyz) {
  var x = xyz[0] / 100,
    y = xyz[1] / 100,
    z = xyz[2] / 100,
    r,
    g,
    b;
  r = x * 3.2406 + y * -1.5372 + z * -0.4986;
  g = x * -0.9689 + y * 1.8758 + z * 0.0415;
  b = x * 0.0557 + y * -0.2040 + z * 1.0570;

  // assume sRGB
  r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r = r * 12.92;
  g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g = g * 12.92;
  b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b = b * 12.92;
  r = Math.min(Math.max(0, r), 1);
  g = Math.min(Math.max(0, g), 1);
  b = Math.min(Math.max(0, b), 1);
  return [r * 255, g * 255, b * 255];
}
function xyz2lab(xyz) {
  var x = xyz[0],
    y = xyz[1],
    z = xyz[2],
    l,
    a,
    b;
  x /= 95.047;
  y /= 100;
  z /= 108.883;
  x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
  y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
  z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
  l = 116 * y - 16;
  a = 500 * (x - y);
  b = 200 * (y - z);
  return [l, a, b];
}
function xyz2lch(args) {
  return lab2lch(xyz2lab(args));
}
function lab2xyz(lab) {
  var l = lab[0],
    a = lab[1],
    b = lab[2],
    x,
    y,
    z,
    y2;
  if (l <= 8) {
    y = l * 100 / 903.3;
    y2 = 7.787 * (y / 100) + 16 / 116;
  } else {
    y = 100 * Math.pow((l + 16) / 116, 3);
    y2 = Math.pow(y / 100, 1 / 3);
  }
  x = x / 95.047 <= 0.008856 ? x = 95.047 * (a / 500 + y2 - 16 / 116) / 7.787 : 95.047 * Math.pow(a / 500 + y2, 3);
  z = z / 108.883 <= 0.008859 ? z = 108.883 * (y2 - b / 200 - 16 / 116) / 7.787 : 108.883 * Math.pow(y2 - b / 200, 3);
  return [x, y, z];
}
function lab2lch(lab) {
  var l = lab[0],
    a = lab[1],
    b = lab[2],
    hr,
    h,
    c;
  hr = Math.atan2(b, a);
  h = hr * 360 / 2 / Math.PI;
  if (h < 0) {
    h += 360;
  }
  c = Math.sqrt(a * a + b * b);
  return [l, c, h];
}
function lab2rgb(args) {
  return xyz2rgb(lab2xyz(args));
}
function lch2lab(lch) {
  var l = lch[0],
    c = lch[1],
    h = lch[2],
    a,
    b,
    hr;
  hr = h / 360 * 2 * Math.PI;
  a = c * Math.cos(hr);
  b = c * Math.sin(hr);
  return [l, a, b];
}
function lch2xyz(args) {
  return lab2xyz(lch2lab(args));
}
function lch2rgb(args) {
  return lab2rgb(lch2lab(args));
}
function keyword2rgb(keyword) {
  return cssKeywords[keyword];
}
function keyword2hsl(args) {
  return rgb2hsl(keyword2rgb(args));
}
function keyword2hsv(args) {
  return rgb2hsv(keyword2rgb(args));
}
function keyword2hwb(args) {
  return rgb2hwb(keyword2rgb(args));
}
function keyword2cmyk(args) {
  return rgb2cmyk(keyword2rgb(args));
}
function keyword2lab(args) {
  return rgb2lab(keyword2rgb(args));
}
function keyword2xyz(args) {
  return rgb2xyz(keyword2rgb(args));
}
var cssKeywords = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  rebeccapurple: [102, 51, 153],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
};
var reverseKeywords = {};
for (var key in cssKeywords) {
  reverseKeywords[JSON.stringify(cssKeywords[key])] = key;
}

/***/ }),

/***/ 77306:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(47042);
__webpack_require__(74916);
var conversions = __webpack_require__(76882);
var convert = function convert() {
  return new Converter();
};
for (var func in conversions) {
  // export Raw versions
  convert[func + "Raw"] = function (func) {
    // accept array or plain args
    return function (arg) {
      if (typeof arg == "number") arg = Array.prototype.slice.call(arguments);
      return conversions[func](arg);
    };
  }(func);
  var pair = /(\w+)2(\w+)/.exec(func),
    from = pair[1],
    to = pair[2];

  // export rgb2hsl and ["rgb"]["hsl"]
  convert[from] = convert[from] || {};
  convert[from][to] = convert[func] = function (func) {
    return function (arg) {
      if (typeof arg == "number") arg = Array.prototype.slice.call(arguments);
      var val = conversions[func](arg);
      if (typeof val == "string" || val === undefined) return val; // keyword

      for (var i = 0; i < val.length; i++) {
        val[i] = Math.round(val[i]);
      }
      return val;
    };
  }(func);
}

/* Converter does lazy conversion and caching */
var Converter = function Converter() {
  this.convs = {};
};

/* Either get the values for a space or
  set the values for a space, depending on args */
Converter.prototype.routeSpace = function (space, args) {
  var values = args[0];
  if (values === undefined) {
    // color.rgb()
    return this.getValues(space);
  }
  // color.rgb(10, 10, 10)
  if (typeof values == "number") {
    values = Array.prototype.slice.call(args);
  }
  return this.setValues(space, values);
};

/* Set the values for a space, invalidating cache */
Converter.prototype.setValues = function (space, values) {
  this.space = space;
  this.convs = {};
  this.convs[space] = values;
  return this;
};

/* Get the values for a space. If there's already
  a conversion for the space, fetch it, otherwise
  compute it */
Converter.prototype.getValues = function (space) {
  var vals = this.convs[space];
  if (!vals) {
    var fspace = this.space,
      from = this.convs[fspace];
    vals = convert[fspace][space](from);
    this.convs[space] = vals;
  }
  return vals;
};
["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function (space) {
  Converter.prototype[space] = function (vals) {
    return this.routeSpace(space, arguments);
  };
});
module.exports = convert;

/***/ }),

/***/ 15583:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

__webpack_require__(74916);
__webpack_require__(23123);
__webpack_require__(69600);
__webpack_require__(47042);
exports.basename = function (path) {
  return path.split('/').pop();
};
exports.dirname = function (path) {
  return path.split('/').slice(0, -1).join('/') || '.';
};
exports.extname = function (path) {
  var base = exports.basename(path);
  if (!~base.indexOf('.')) return '';
  var ext = base.split('.').pop();
  return '.' + ext;
};

/***/ }),

/***/ 12212:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_sort_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2707);
/* harmony import */ var core_js_modules_es_array_sort_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21249);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23123);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69826);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_find_index_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34553);
/* harmony import */ var core_js_modules_es_array_find_index_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(4723);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(73210);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(64765);
/* harmony import */ var core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_17__);


















/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();
function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}
function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}
var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }
  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
    overflow = _getStyleComputedProp.overflow,
    overflowX = _getStyleComputedProp.overflowX,
    overflowY = _getStyleComputedProp.overflowY;
  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }
  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }
  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }
  var nodeName = offsetParent && offsetParent.nodeName;
  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }
  return offsetParent;
}
function isOffsetContainer(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }
  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }
    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }
  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}
function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}
function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);
  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}
var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var defineProperty = function defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
};
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}
  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;
  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');
    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }
  return getClientRect(result);
}
function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);
  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);
    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }
  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }
  return offsets;
}
function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);
  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };
  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = {
    top: 0,
    left: 0
  };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }
    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
        height = _getWindowSizes.height,
        width = _getWindowSizes.width;
      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
  return boundaries;
}
function getArea(_ref) {
  var width = _ref.width,
    height = _ref.height;
  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  if (placement.indexOf('auto') === -1) {
    return placement;
  }
  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };
  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });
  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
      height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });
  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
  var variation = placement.split('-')[1];
  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
  };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }
  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);
      data = fn(data, modifier);
    }
  });
  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }
  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;
  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
      enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }
  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}
function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, {
    passive: true
  });
  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, {
    passive: true
  });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;
  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }
  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, {
    position: options.positionFixed ? 'fixed' : 'absolute'
  });
  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
    popper = _data$offsets.popper,
    reference = _data$offsets.reference;
  var round = Math.round,
    floor = Math.floor;
  var noRound = function noRound(v) {
    return v;
  };
  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);
  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;
  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}
var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
    y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };
  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
    top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });
  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });
  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }
  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }
  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
    popper = _data$offsets.popper,
    reference = _data$offsets.reference;
  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}
var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }
  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }
  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';
  var flipOrder = [];
  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }
  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }
    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);
    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;
      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }
      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }
      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
    popper = _data$offsets.popper,
    reference = _data$offsets.reference;
  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';
  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }
  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }
  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }
    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));
  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
    _data$offsets = data.offsets,
    popper = _data$offsets.popper,
    reference = _data$offsets.reference;
  var basePlacement = placement.split('-')[0];
  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }
  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }
  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
    left = popperStyles.left,
    transform = popperStyles[transformProp];
  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';
  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;
  options.boundaries = boundaries;
  var order = options.priority;
  var popper = data.offsets.popper;
  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };
  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });
  data.offsets.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
      reference = _data$offsets.reference,
      popper = _data$offsets.popper;
    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };
    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }
  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;
  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }
    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }
    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
    popper = _data$offsets.popper,
    reference = _data$offsets.reference;
  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);
  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },
  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },
  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },
  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },
  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },
  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },
  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },
  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },
  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },
  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',
  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,
  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,
  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,
  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},
  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},
  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);
    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();
    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }
    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs

  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */

    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */
  }]);

  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */

Popper.Utils = (typeof window !== 'undefined' ? window : __webpack_require__.g).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Popper);

/***/ }),

/***/ 82212:
/***/ ((module) => {

"use strict";


/** @type {import('.')} */
module.exports = ['Float32Array', 'Float64Array', 'Int8Array', 'Int16Array', 'Int32Array', 'Uint8Array', 'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'BigInt64Array', 'BigUint64Array'];

/***/ }),

/***/ 10097:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useCallback": () => (/* reexport safe */ preact_hooks__WEBPACK_IMPORTED_MODULE_14__.I4),
/* harmony export */   "useContext": () => (/* reexport safe */ preact_hooks__WEBPACK_IMPORTED_MODULE_14__.qp),
/* harmony export */   "useDebugValue": () => (/* reexport safe */ preact_hooks__WEBPACK_IMPORTED_MODULE_14__.Qb),
/* harmony export */   "useEffect": () => (/* reexport safe */ preact_hooks__WEBPACK_IMPORTED_MODULE_14__.d4),
/* harmony export */   "useErrorBoundary": () => (/* reexport safe */ preact_hooks__WEBPACK_IMPORTED_MODULE_14__.cO),
/* harmony export */   "useImperativeHandle": () => (/* reexport safe */ preact_hooks__WEBPACK_IMPORTED_MODULE_14__.aP),
/* harmony export */   "useLayoutEffect": () => (/* reexport safe */ preact_hooks__WEBPACK_IMPORTED_MODULE_14__.bt),
/* harmony export */   "useMemo": () => (/* reexport safe */ preact_hooks__WEBPACK_IMPORTED_MODULE_14__.Ye),
/* harmony export */   "useReducer": () => (/* reexport safe */ preact_hooks__WEBPACK_IMPORTED_MODULE_14__._Y),
/* harmony export */   "useRef": () => (/* reexport safe */ preact_hooks__WEBPACK_IMPORTED_MODULE_14__.sO),
/* harmony export */   "useState": () => (/* reexport safe */ preact_hooks__WEBPACK_IMPORTED_MODULE_14__.eJ),
/* harmony export */   "createElement": () => (/* reexport safe */ preact__WEBPACK_IMPORTED_MODULE_15__.az),
/* harmony export */   "createContext": () => (/* reexport safe */ preact__WEBPACK_IMPORTED_MODULE_15__.kr),
/* harmony export */   "createRef": () => (/* reexport safe */ preact__WEBPACK_IMPORTED_MODULE_15__.Vf),
/* harmony export */   "Fragment": () => (/* reexport safe */ preact__WEBPACK_IMPORTED_MODULE_15__.HY),
/* harmony export */   "Component": () => (/* reexport safe */ preact__WEBPACK_IMPORTED_MODULE_15__.wA),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "version": () => (/* binding */ X),
/* harmony export */   "Children": () => (/* binding */ k),
/* harmony export */   "render": () => (/* binding */ z),
/* harmony export */   "hydrate": () => (/* binding */ B),
/* harmony export */   "unmountComponentAtNode": () => (/* binding */ rn),
/* harmony export */   "createPortal": () => (/* binding */ W),
/* harmony export */   "createFactory": () => (/* binding */ nn),
/* harmony export */   "cloneElement": () => (/* binding */ en),
/* harmony export */   "isValidElement": () => (/* binding */ tn),
/* harmony export */   "findDOMNode": () => (/* binding */ un),
/* harmony export */   "PureComponent": () => (/* binding */ E),
/* harmony export */   "memo": () => (/* binding */ g),
/* harmony export */   "forwardRef": () => (/* binding */ x),
/* harmony export */   "flushSync": () => (/* binding */ ln),
/* harmony export */   "unstable_batchedUpdates": () => (/* binding */ on),
/* harmony export */   "StrictMode": () => (/* binding */ fn),
/* harmony export */   "Suspense": () => (/* binding */ L),
/* harmony export */   "SuspenseList": () => (/* binding */ M),
/* harmony export */   "lazy": () => (/* binding */ F),
/* harmony export */   "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED": () => (/* binding */ Q)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21249);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40561);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51532);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var preact_hooks__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8065);
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(79758);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


















function S(n, t) {
  for (var e in t) {
    n[e] = t[e];
  }
  return n;
}
function C(n, t) {
  for (var e in n) {
    if ("__source" !== e && !(e in t)) return !0;
  }
  for (var r in t) {
    if ("__source" !== r && n[r] !== t[r]) return !0;
  }
  return !1;
}
function E(n) {
  this.props = n;
}
function g(n, t) {
  function e(n) {
    var e = this.props.ref,
      r = e == n.ref;
    return !r && e && (e.call ? e(null) : e.current = null), t ? !t(this.props, n) || !r : C(this.props, n);
  }
  function r(t) {
    return this.shouldComponentUpdate = e, (0,preact__WEBPACK_IMPORTED_MODULE_15__/* .createElement */ .az)(n, t);
  }
  return r.displayName = "Memo(" + (n.displayName || n.name) + ")", r.prototype.isReactComponent = !0, r.__f = !0, r;
}
(E.prototype = new preact__WEBPACK_IMPORTED_MODULE_15__/* .Component */ .wA()).isPureReactComponent = !0, E.prototype.shouldComponentUpdate = function (n, t) {
  return C(this.props, n) || C(this.state, t);
};
var w = preact__WEBPACK_IMPORTED_MODULE_15__/* .options.__b */ .YM.__b;
preact__WEBPACK_IMPORTED_MODULE_15__/* .options.__b */ .YM.__b = function (n) {
  n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), w && w(n);
};
var R = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function x(n) {
  function t(t, e) {
    var r = S({}, t);
    return delete r.ref, n(r, (e = t.ref || e) && ("object" != _typeof(e) || "current" in e) ? e : null);
  }
  return t.$$typeof = R, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var N = function N(n, t) {
    return null == n ? null : (0,preact__WEBPACK_IMPORTED_MODULE_15__/* .toChildArray */ .bR)((0,preact__WEBPACK_IMPORTED_MODULE_15__/* .toChildArray */ .bR)(n).map(t));
  },
  k = {
    map: N,
    forEach: N,
    count: function count(n) {
      return n ? (0,preact__WEBPACK_IMPORTED_MODULE_15__/* .toChildArray */ .bR)(n).length : 0;
    },
    only: function only(n) {
      var t = (0,preact__WEBPACK_IMPORTED_MODULE_15__/* .toChildArray */ .bR)(n);
      if (1 !== t.length) throw "Children.only";
      return t[0];
    },
    toArray: preact__WEBPACK_IMPORTED_MODULE_15__/* .toChildArray */ .bR
  },
  A = preact__WEBPACK_IMPORTED_MODULE_15__/* .options.__e */ .YM.__e;
preact__WEBPACK_IMPORTED_MODULE_15__/* .options.__e */ .YM.__e = function (n, t, e) {
  if (n.then) for (var r, u = t; u = u.__;) {
    if ((r = u.__c) && r.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), r.__c(n, t);
  }
  A(n, t, e);
};
var O = preact__WEBPACK_IMPORTED_MODULE_15__/* .options.unmount */ .YM.unmount;
function L() {
  this.__u = 0, this.t = null, this.__b = null;
}
function U(n) {
  var t = n.__.__c;
  return t && t.__e && t.__e(n);
}
function F(n) {
  var t, e, r;
  function u(u) {
    if (t || (t = n()).then(function (n) {
      e = n.default || n;
    }, function (n) {
      r = n;
    }), r) throw r;
    if (!e) throw t;
    return (0,preact__WEBPACK_IMPORTED_MODULE_15__/* .createElement */ .az)(e, u);
  }
  return u.displayName = "Lazy", u.__f = !0, u;
}
function M() {
  this.u = null, this.o = null;
}
preact__WEBPACK_IMPORTED_MODULE_15__/* .options.unmount */ .YM.unmount = function (n) {
  var t = n.__c;
  t && t.__R && t.__R(), t && !0 === n.__h && (n.type = null), O && O(n);
}, (L.prototype = new preact__WEBPACK_IMPORTED_MODULE_15__/* .Component */ .wA()).__c = function (n, t) {
  var e = t.__c,
    r = this;
  null == r.t && (r.t = []), r.t.push(e);
  var u = U(r.__v),
    o = !1,
    i = function i() {
      o || (o = !0, e.__R = null, u ? u(l) : l());
    };
  e.__R = i;
  var l = function l() {
      if (! --r.__u) {
        if (r.state.__e) {
          var n = r.state.__e;
          r.__v.__k[0] = function n(t, e, r) {
            return t && (t.__v = null, t.__k = t.__k && t.__k.map(function (t) {
              return n(t, e, r);
            }), t.__c && t.__c.__P === e && (t.__e && r.insertBefore(t.__e, t.__d), t.__c.__e = !0, t.__c.__P = r)), t;
          }(n, n.__c.__P, n.__c.__O);
        }
        var t;
        for (r.setState({
          __e: r.__b = null
        }); t = r.t.pop();) {
          t.forceUpdate();
        }
      }
    },
    f = !0 === t.__h;
  r.__u++ || f || r.setState({
    __e: r.__b = r.__v.__k[0]
  }), n.then(i, i);
}, L.prototype.componentWillUnmount = function () {
  this.t = [];
}, L.prototype.render = function (n, t) {
  if (this.__b) {
    if (this.__v.__k) {
      var e = document.createElement("div"),
        r = this.__v.__k[0].__c;
      this.__v.__k[0] = function n(t, e, r) {
        return t && (t.__c && t.__c.__H && (t.__c.__H.__.forEach(function (n) {
          "function" == typeof n.__c && n.__c();
        }), t.__c.__H = null), null != (t = S({}, t)).__c && (t.__c.__P === r && (t.__c.__P = e), t.__c = null), t.__k = t.__k && t.__k.map(function (t) {
          return n(t, e, r);
        })), t;
      }(this.__b, e, r.__O = r.__P);
    }
    this.__b = null;
  }
  var u = t.__e && (0,preact__WEBPACK_IMPORTED_MODULE_15__/* .createElement */ .az)(preact__WEBPACK_IMPORTED_MODULE_15__/* .Fragment */ .HY, null, n.fallback);
  return u && (u.__h = null), [(0,preact__WEBPACK_IMPORTED_MODULE_15__/* .createElement */ .az)(preact__WEBPACK_IMPORTED_MODULE_15__/* .Fragment */ .HY, null, t.__e ? null : n.children), u];
};
var T = function T(n, t, e) {
  if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for (e = n.u; e;) {
    for (; e.length > 3;) {
      e.pop()();
    }
    if (e[1] < e[0]) break;
    n.u = e = e[2];
  }
};
function D(n) {
  return this.getChildContext = function () {
    return n.context;
  }, n.children;
}
function I(n) {
  var t = this,
    e = n.i;
  t.componentWillUnmount = function () {
    (0,preact__WEBPACK_IMPORTED_MODULE_15__/* .render */ .sY)(null, t.l), t.l = null, t.i = null;
  }, t.i && t.i !== e && t.componentWillUnmount(), n.__v ? (t.l || (t.i = e, t.l = {
    nodeType: 1,
    parentNode: e,
    childNodes: [],
    appendChild: function appendChild(n) {
      this.childNodes.push(n), t.i.appendChild(n);
    },
    insertBefore: function insertBefore(n, e) {
      this.childNodes.push(n), t.i.appendChild(n);
    },
    removeChild: function removeChild(n) {
      this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), t.i.removeChild(n);
    }
  }), (0,preact__WEBPACK_IMPORTED_MODULE_15__/* .render */ .sY)((0,preact__WEBPACK_IMPORTED_MODULE_15__/* .createElement */ .az)(D, {
    context: t.context
  }, n.__v), t.l)) : t.l && t.componentWillUnmount();
}
function W(n, t) {
  return (0,preact__WEBPACK_IMPORTED_MODULE_15__/* .createElement */ .az)(I, {
    __v: n,
    i: t
  });
}
(M.prototype = new preact__WEBPACK_IMPORTED_MODULE_15__/* .Component */ .wA()).__e = function (n) {
  var t = this,
    e = U(t.__v),
    r = t.o.get(n);
  return r[0]++, function (u) {
    var o = function o() {
      t.props.revealOrder ? (r.push(u), T(t, n, r)) : u();
    };
    e ? e(o) : o();
  };
}, M.prototype.render = function (n) {
  this.u = null, this.o = new Map();
  var t = (0,preact__WEBPACK_IMPORTED_MODULE_15__/* .toChildArray */ .bR)(n.children);
  n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
  for (var e = t.length; e--;) {
    this.o.set(t[e], this.u = [1, 0, this.u]);
  }
  return n.children;
}, M.prototype.componentDidUpdate = M.prototype.componentDidMount = function () {
  var n = this;
  this.o.forEach(function (t, e) {
    T(n, e, t);
  });
};
var j = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103,
  P = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/,
  V = function V(n) {
    return ("undefined" != typeof Symbol && "symbol" == _typeof(Symbol()) ? /fil|che|rad/i : /fil|che|ra/i).test(n);
  };
function z(n, t, e) {
  return null == t.__k && (t.textContent = ""), (0,preact__WEBPACK_IMPORTED_MODULE_15__/* .render */ .sY)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function B(n, t, e) {
  return (0,preact__WEBPACK_IMPORTED_MODULE_15__/* .hydrate */ .ZB)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
preact__WEBPACK_IMPORTED_MODULE_15__/* .Component.prototype.isReactComponent */ .wA.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function (n) {
  Object.defineProperty(preact__WEBPACK_IMPORTED_MODULE_15__/* .Component.prototype */ .wA.prototype, n, {
    configurable: !0,
    get: function get() {
      return this["UNSAFE_" + n];
    },
    set: function set(t) {
      Object.defineProperty(this, n, {
        configurable: !0,
        writable: !0,
        value: t
      });
    }
  });
});
var H = preact__WEBPACK_IMPORTED_MODULE_15__/* .options.event */ .YM.event;
function Z() {}
function Y() {
  return this.cancelBubble;
}
function $() {
  return this.defaultPrevented;
}
preact__WEBPACK_IMPORTED_MODULE_15__/* .options.event */ .YM.event = function (n) {
  return H && (n = H(n)), n.persist = Z, n.isPropagationStopped = Y, n.isDefaultPrevented = $, n.nativeEvent = n;
};
var q,
  G = {
    configurable: !0,
    get: function get() {
      return this.class;
    }
  },
  J = preact__WEBPACK_IMPORTED_MODULE_15__/* .options.vnode */ .YM.vnode;
preact__WEBPACK_IMPORTED_MODULE_15__/* .options.vnode */ .YM.vnode = function (n) {
  var t = n.type,
    e = n.props,
    r = e;
  if ("string" == typeof t) {
    for (var u in r = {}, e) {
      var o = e[u];
      "value" === u && "defaultValue" in e && null == o || ("defaultValue" === u && "value" in e && null == e.value ? u = "value" : "download" === u && !0 === o ? o = "" : /ondoubleclick/i.test(u) ? u = "ondblclick" : /^onchange(textarea|input)/i.test(u + t) && !V(e.type) ? u = "oninput" : /^on(Ani|Tra|Tou|BeforeInp)/.test(u) ? u = u.toLowerCase() : P.test(u) ? u = u.replace(/[A-Z0-9]/, "-$&").toLowerCase() : null === o && (o = void 0), r[u] = o);
    }
    "select" == t && r.multiple && Array.isArray(r.value) && (r.value = (0,preact__WEBPACK_IMPORTED_MODULE_15__/* .toChildArray */ .bR)(e.children).forEach(function (n) {
      n.props.selected = -1 != r.value.indexOf(n.props.value);
    })), "select" == t && null != r.defaultValue && (r.value = (0,preact__WEBPACK_IMPORTED_MODULE_15__/* .toChildArray */ .bR)(e.children).forEach(function (n) {
      n.props.selected = r.multiple ? -1 != r.defaultValue.indexOf(n.props.value) : r.defaultValue == n.props.value;
    })), n.props = r;
  }
  t && e.class != e.className && (G.enumerable = "className" in e, null != e.className && (r.class = e.className), Object.defineProperty(r, "className", G)), n.$$typeof = j, J && J(n);
};
var K = preact__WEBPACK_IMPORTED_MODULE_15__/* .options.__r */ .YM.__r;
preact__WEBPACK_IMPORTED_MODULE_15__/* .options.__r */ .YM.__r = function (n) {
  K && K(n), q = n.__c;
};
var Q = {
    ReactCurrentDispatcher: {
      current: {
        readContext: function readContext(n) {
          return q.__n[n.__c].props.value;
        }
      }
    }
  },
  X = "17.0.2";
function nn(n) {
  return preact__WEBPACK_IMPORTED_MODULE_15__/* .createElement.bind */ .az.bind(null, n);
}
function tn(n) {
  return !!n && n.$$typeof === j;
}
function en(n) {
  return tn(n) ? preact__WEBPACK_IMPORTED_MODULE_15__/* .cloneElement.apply */ .Tm.apply(null, arguments) : n;
}
function rn(n) {
  return !!n.__k && ((0,preact__WEBPACK_IMPORTED_MODULE_15__/* .render */ .sY)(null, n), !0);
}
function un(n) {
  return n && (n.base || 1 === n.nodeType && n) || null;
}
var on = function on(n, t) {
    return n(t);
  },
  ln = function ln(n, t) {
    return n(t);
  },
  fn = preact__WEBPACK_IMPORTED_MODULE_15__/* .Fragment */ .HY;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  useState: preact_hooks__WEBPACK_IMPORTED_MODULE_14__/* .useState */ .eJ,
  useReducer: preact_hooks__WEBPACK_IMPORTED_MODULE_14__/* .useReducer */ ._Y,
  useEffect: preact_hooks__WEBPACK_IMPORTED_MODULE_14__/* .useEffect */ .d4,
  useLayoutEffect: preact_hooks__WEBPACK_IMPORTED_MODULE_14__/* .useLayoutEffect */ .bt,
  useRef: preact_hooks__WEBPACK_IMPORTED_MODULE_14__/* .useRef */ .sO,
  useImperativeHandle: preact_hooks__WEBPACK_IMPORTED_MODULE_14__/* .useImperativeHandle */ .aP,
  useMemo: preact_hooks__WEBPACK_IMPORTED_MODULE_14__/* .useMemo */ .Ye,
  useCallback: preact_hooks__WEBPACK_IMPORTED_MODULE_14__/* .useCallback */ .I4,
  useContext: preact_hooks__WEBPACK_IMPORTED_MODULE_14__/* .useContext */ .qp,
  useDebugValue: preact_hooks__WEBPACK_IMPORTED_MODULE_14__/* .useDebugValue */ .Qb,
  version: "17.0.2",
  Children: k,
  render: z,
  hydrate: B,
  unmountComponentAtNode: rn,
  createPortal: W,
  createElement: preact__WEBPACK_IMPORTED_MODULE_15__/* .createElement */ .az,
  createContext: preact__WEBPACK_IMPORTED_MODULE_15__/* .createContext */ .kr,
  createFactory: nn,
  cloneElement: en,
  createRef: preact__WEBPACK_IMPORTED_MODULE_15__/* .createRef */ .Vf,
  Fragment: preact__WEBPACK_IMPORTED_MODULE_15__/* .Fragment */ .HY,
  isValidElement: tn,
  findDOMNode: un,
  Component: preact__WEBPACK_IMPORTED_MODULE_15__/* .Component */ .wA,
  PureComponent: E,
  memo: g,
  forwardRef: x,
  flushSync: ln,
  unstable_batchedUpdates: on,
  StrictMode: preact__WEBPACK_IMPORTED_MODULE_15__/* .Fragment */ .HY,
  Suspense: L,
  SuspenseList: M,
  lazy: F,
  __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: Q
});


/***/ }),

/***/ 79758:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sY": () => (/* binding */ S),
/* harmony export */   "ZB": () => (/* binding */ q),
/* harmony export */   "az": () => (/* binding */ v),
/* harmony export */   "h": () => (/* binding */ v),
/* harmony export */   "HY": () => (/* binding */ d),
/* harmony export */   "Vf": () => (/* binding */ p),
/* harmony export */   "wA": () => (/* binding */ _),
/* harmony export */   "Tm": () => (/* binding */ B),
/* harmony export */   "kr": () => (/* binding */ D),
/* harmony export */   "bR": () => (/* binding */ A),
/* harmony export */   "YM": () => (/* binding */ l)
/* harmony export */ });
/* unused harmony export isValidElement */
/* harmony import */ var core_js_modules_es_array_sort_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2707);
/* harmony import */ var core_js_modules_es_array_sort_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_sub_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60086);
/* harmony import */ var core_js_modules_es_string_sub_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_sub_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40561);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8__);









var n,
  l,
  u,
  i,
  t,
  o,
  r,
  f,
  e = {},
  c = [],
  s = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function a(n, l) {
  for (var u in l) {
    n[u] = l[u];
  }
  return n;
}
function h(n) {
  var l = n.parentNode;
  l && l.removeChild(n);
}
function v(l, u, i) {
  var t,
    o,
    r,
    f = {};
  for (r in u) {
    "key" == r ? t = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
  }
  if (arguments.length > 2 && (f.children = arguments.length > 3 ? n.call(arguments, 2) : i), "function" == typeof l && null != l.defaultProps) for (r in l.defaultProps) {
    void 0 === f[r] && (f[r] = l.defaultProps[r]);
  }
  return y(l, f, t, o, null);
}
function y(n, i, t, o, r) {
  var f = {
    type: n,
    props: i,
    key: t,
    ref: o,
    __k: null,
    __: null,
    __b: 0,
    __e: null,
    __d: void 0,
    __c: null,
    __h: null,
    constructor: void 0,
    __v: null == r ? ++u : r
  };
  return null != l.vnode && l.vnode(f), f;
}
function p() {
  return {
    current: null
  };
}
function d(n) {
  return n.children;
}
function _(n, l) {
  this.props = n, this.context = l;
}
function k(n, l) {
  if (null == l) return n.__ ? k(n.__, n.__.__k.indexOf(n) + 1) : null;
  for (var u; l < n.__k.length; l++) {
    if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
  }
  return "function" == typeof n.type ? k(n) : null;
}
function b(n) {
  var l, u;
  if (null != (n = n.__) && null != n.__c) {
    for (n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++) {
      if (null != (u = n.__k[l]) && null != u.__e) {
        n.__e = n.__c.base = u.__e;
        break;
      }
    }
    return b(n);
  }
}
function m(n) {
  (!n.__d && (n.__d = !0) && t.push(n) && !g.__r++ || r !== l.debounceRendering) && ((r = l.debounceRendering) || o)(g);
}
function g() {
  for (var n; g.__r = t.length;) {
    n = t.sort(function (n, l) {
      return n.__v.__b - l.__v.__b;
    }), t = [], n.some(function (n) {
      var l, u, i, t, o, r;
      n.__d && (o = (t = (l = n).__v).__e, (r = l.__P) && (u = [], (i = a({}, t)).__v = t.__v + 1, j(r, t, i, l.__n, void 0 !== r.ownerSVGElement, null != t.__h ? [o] : null, u, null == o ? k(t) : o, t.__h), z(u, t), t.__e != o && b(t)));
    });
  }
}
function w(n, l, u, i, t, o, r, f, s, a) {
  var h,
    v,
    p,
    _,
    b,
    m,
    g,
    w = i && i.__k || c,
    A = w.length;
  for (u.__k = [], h = 0; h < l.length; h++) {
    if (null != (_ = u.__k[h] = null == (_ = l[h]) || "boolean" == typeof _ ? null : "string" == typeof _ || "number" == typeof _ || "bigint" == typeof _ ? y(null, _, null, null, _) : Array.isArray(_) ? y(d, {
      children: _
    }, null, null, null) : _.__b > 0 ? y(_.type, _.props, _.key, null, _.__v) : _)) {
      if (_.__ = u, _.__b = u.__b + 1, null === (p = w[h]) || p && _.key == p.key && _.type === p.type) w[h] = void 0;else for (v = 0; v < A; v++) {
        if ((p = w[v]) && _.key == p.key && _.type === p.type) {
          w[v] = void 0;
          break;
        }
        p = null;
      }
      j(n, _, p = p || e, t, o, r, f, s, a), b = _.__e, (v = _.ref) && p.ref != v && (g || (g = []), p.ref && g.push(p.ref, null, _), g.push(v, _.__c || b, _)), null != b ? (null == m && (m = b), "function" == typeof _.type && null != _.__k && _.__k === p.__k ? _.__d = s = x(_, s, n) : s = P(n, _, p, w, b, s), a || "option" !== u.type ? "function" == typeof u.type && (u.__d = s) : n.value = "") : s && p.__e == s && s.parentNode != n && (s = k(p));
    }
  }
  for (u.__e = m, h = A; h--;) {
    null != w[h] && ("function" == typeof u.type && null != w[h].__e && w[h].__e == u.__d && (u.__d = k(i, h + 1)), N(w[h], w[h]));
  }
  if (g) for (h = 0; h < g.length; h++) {
    M(g[h], g[++h], g[++h]);
  }
}
function x(n, l, u) {
  var i, t;
  for (i = 0; i < n.__k.length; i++) {
    (t = n.__k[i]) && (t.__ = n, l = "function" == typeof t.type ? x(t, l, u) : P(u, t, t, n.__k, t.__e, l));
  }
  return l;
}
function A(n, l) {
  return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function (n) {
    A(n, l);
  }) : l.push(n)), l;
}
function P(n, l, u, i, t, o) {
  var r, f, e;
  if (void 0 !== l.__d) r = l.__d, l.__d = void 0;else if (null == u || t != o || null == t.parentNode) n: if (null == o || o.parentNode !== n) n.appendChild(t), r = null;else {
    for (f = o, e = 0; (f = f.nextSibling) && e < i.length; e += 2) {
      if (f == t) break n;
    }
    n.insertBefore(t, o), r = o;
  }
  return void 0 !== r ? r : t.nextSibling;
}
function C(n, l, u, i, t) {
  var o;
  for (o in u) {
    "children" === o || "key" === o || o in l || H(n, o, null, u[o], i);
  }
  for (o in l) {
    t && "function" != typeof l[o] || "children" === o || "key" === o || "value" === o || "checked" === o || u[o] === l[o] || H(n, o, l[o], u[o], i);
  }
}
function $(n, l, u) {
  "-" === l[0] ? n.setProperty(l, u) : n[l] = null == u ? "" : "number" != typeof u || s.test(l) ? u : u + "px";
}
function H(n, l, u, i, t) {
  var o;
  n: if ("style" === l) {
    if ("string" == typeof u) n.style.cssText = u;else {
      if ("string" == typeof i && (n.style.cssText = i = ""), i) for (l in i) {
        u && l in u || $(n.style, l, "");
      }
      if (u) for (l in u) {
        i && u[l] === i[l] || $(n.style, l, u[l]);
      }
    }
  } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? i || n.addEventListener(l, o ? T : I, o) : n.removeEventListener(l, o ? T : I, o);else if ("dangerouslySetInnerHTML" !== l) {
    if (t) l = l.replace(/xlink[H:h]/, "h").replace(/sName$/, "s");else if ("href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
      n[l] = null == u ? "" : u;
      break n;
    } catch (n) {}
    "function" == typeof u || (null != u && (!1 !== u || "a" === l[0] && "r" === l[1]) ? n.setAttribute(l, u) : n.removeAttribute(l));
  }
}
function I(n) {
  this.l[n.type + !1](l.event ? l.event(n) : n);
}
function T(n) {
  this.l[n.type + !0](l.event ? l.event(n) : n);
}
function j(n, u, i, t, o, r, f, e, c) {
  var s,
    h,
    v,
    y,
    p,
    k,
    b,
    m,
    g,
    x,
    A,
    P = u.type;
  if (void 0 !== u.constructor) return null;
  null != i.__h && (c = i.__h, e = u.__e = i.__e, u.__h = null, r = [e]), (s = l.__b) && s(u);
  try {
    n: if ("function" == typeof P) {
      if (m = u.props, g = (s = P.contextType) && t[s.__c], x = s ? g ? g.props.value : s.__ : t, i.__c ? b = (h = u.__c = i.__c).__ = h.__E : ("prototype" in P && P.prototype.render ? u.__c = h = new P(m, x) : (u.__c = h = new _(m, x), h.constructor = P, h.render = O), g && g.sub(h), h.props = m, h.state || (h.state = {}), h.context = x, h.__n = t, v = h.__d = !0, h.__h = []), null == h.__s && (h.__s = h.state), null != P.getDerivedStateFromProps && (h.__s == h.state && (h.__s = a({}, h.__s)), a(h.__s, P.getDerivedStateFromProps(m, h.__s))), y = h.props, p = h.state, v) null == P.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), null != h.componentDidMount && h.__h.push(h.componentDidMount);else {
        if (null == P.getDerivedStateFromProps && m !== y && null != h.componentWillReceiveProps && h.componentWillReceiveProps(m, x), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(m, h.__s, x) || u.__v === i.__v) {
          h.props = m, h.state = h.__s, u.__v !== i.__v && (h.__d = !1), h.__v = u, u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function (n) {
            n && (n.__ = u);
          }), h.__h.length && f.push(h);
          break n;
        }
        null != h.componentWillUpdate && h.componentWillUpdate(m, h.__s, x), null != h.componentDidUpdate && h.__h.push(function () {
          h.componentDidUpdate(y, p, k);
        });
      }
      h.context = x, h.props = m, h.state = h.__s, (s = l.__r) && s(u), h.__d = !1, h.__v = u, h.__P = n, s = h.render(h.props, h.state, h.context), h.state = h.__s, null != h.getChildContext && (t = a(a({}, t), h.getChildContext())), v || null == h.getSnapshotBeforeUpdate || (k = h.getSnapshotBeforeUpdate(y, p)), A = null != s && s.type === d && null == s.key ? s.props.children : s, w(n, Array.isArray(A) ? A : [A], u, i, t, o, r, f, e, c), h.base = u.__e, u.__h = null, h.__h.length && f.push(h), b && (h.__E = h.__ = null), h.__e = !1;
    } else null == r && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = L(i.__e, u, i, t, o, r, f, c);
    (s = l.diffed) && s(u);
  } catch (n) {
    u.__v = null, (c || null != r) && (u.__e = e, u.__h = !!c, r[r.indexOf(e)] = null), l.__e(n, u, i);
  }
}
function z(n, u) {
  l.__c && l.__c(u, n), n.some(function (u) {
    try {
      n = u.__h, u.__h = [], n.some(function (n) {
        n.call(u);
      });
    } catch (n) {
      l.__e(n, u.__v);
    }
  });
}
function L(l, u, i, t, o, r, f, c) {
  var s,
    a,
    v,
    y = i.props,
    p = u.props,
    d = u.type,
    _ = 0;
  if ("svg" === d && (o = !0), null != r) for (; _ < r.length; _++) {
    if ((s = r[_]) && (s === l || (d ? s.localName == d : 3 == s.nodeType))) {
      l = s, r[_] = null;
      break;
    }
  }
  if (null == l) {
    if (null === d) return document.createTextNode(p);
    l = o ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, p.is && p), r = null, c = !1;
  }
  if (null === d) y === p || c && l.data === p || (l.data = p);else {
    if (r = r && n.call(l.childNodes), a = (y = i.props || e).dangerouslySetInnerHTML, v = p.dangerouslySetInnerHTML, !c) {
      if (null != r) for (y = {}, _ = 0; _ < l.attributes.length; _++) {
        y[l.attributes[_].name] = l.attributes[_].value;
      }
      (v || a) && (v && (a && v.__html == a.__html || v.__html === l.innerHTML) || (l.innerHTML = v && v.__html || ""));
    }
    if (C(l, p, y, o, c), v) u.__k = [];else if (_ = u.props.children, w(l, Array.isArray(_) ? _ : [_], u, i, t, o && "foreignObject" !== d, r, f, r ? r[0] : i.__k && k(i, 0), c), null != r) for (_ = r.length; _--;) {
      null != r[_] && h(r[_]);
    }
    c || ("value" in p && void 0 !== (_ = p.value) && (_ !== l.value || "progress" === d && !_) && H(l, "value", _, y.value, !1), "checked" in p && void 0 !== (_ = p.checked) && _ !== l.checked && H(l, "checked", _, y.checked, !1));
  }
  return l;
}
function M(n, u, i) {
  try {
    "function" == typeof n ? n(u) : n.current = u;
  } catch (n) {
    l.__e(n, i);
  }
}
function N(n, u, i) {
  var t, o;
  if (l.unmount && l.unmount(n), (t = n.ref) && (t.current && t.current !== n.__e || M(t, null, u)), null != (t = n.__c)) {
    if (t.componentWillUnmount) try {
      t.componentWillUnmount();
    } catch (n) {
      l.__e(n, u);
    }
    t.base = t.__P = null;
  }
  if (t = n.__k) for (o = 0; o < t.length; o++) {
    t[o] && N(t[o], u, "function" != typeof n.type);
  }
  i || null == n.__e || h(n.__e), n.__e = n.__d = void 0;
}
function O(n, l, u) {
  return this.constructor(n, u);
}
function S(u, i, t) {
  var o, r, f;
  l.__ && l.__(u, i), r = (o = "function" == typeof t) ? null : t && t.__k || i.__k, f = [], j(i, u = (!o && t || i).__k = v(d, null, [u]), r || e, e, void 0 !== i.ownerSVGElement, !o && t ? [t] : r ? null : i.firstChild ? n.call(i.childNodes) : null, f, !o && t ? t : r ? r.__e : i.firstChild, o), z(f, u);
}
function q(n, l) {
  S(n, l, q);
}
function B(l, u, i) {
  var t,
    o,
    r,
    f = a({}, l.props);
  for (r in u) {
    "key" == r ? t = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
  }
  return arguments.length > 2 && (f.children = arguments.length > 3 ? n.call(arguments, 2) : i), y(l.type, f, t || l.key, o || l.ref, null);
}
function D(n, l) {
  var u = {
    __c: l = "__cC" + f++,
    __: n,
    Consumer: function Consumer(n, l) {
      return n.children(l);
    },
    Provider: function Provider(n) {
      var u, i;
      return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function () {
        return i;
      }, this.shouldComponentUpdate = function (n) {
        this.props.value !== n.value && u.some(m);
      }, this.sub = function (n) {
        u.push(n);
        var l = n.componentWillUnmount;
        n.componentWillUnmount = function () {
          u.splice(u.indexOf(n), 1), l && l.call(n);
        };
      }), n.children;
    }
  };
  return u.Provider.__ = u.Consumer.contextType = u;
}
n = c.slice, l = {
  __e: function __e(n, l) {
    for (var u, i, t; l = l.__;) {
      if ((u = l.__c) && !u.__) try {
        if ((i = u.constructor) && null != i.getDerivedStateFromError && (u.setState(i.getDerivedStateFromError(n)), t = u.__d), null != u.componentDidCatch && (u.componentDidCatch(n), t = u.__d), t) return u.__E = u;
      } catch (l) {
        n = l;
      }
    }
    throw n;
  }
}, u = 0, i = function i(n) {
  return null != n && void 0 === n.constructor;
}, _.prototype.setState = function (n, l) {
  var u;
  u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = a({}, this.state), "function" == typeof n && (n = n(a({}, u), this.props)), n && a(u, n), null != n && this.__v && (l && this.__h.push(l), m(this));
}, _.prototype.forceUpdate = function (n) {
  this.__v && (this.__e = !0, n && this.__h.push(n), m(this));
}, _.prototype.render = d, t = [], o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, g.__r = 0, f = 0;


/***/ }),

/***/ 8065:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "eJ": () => (/* binding */ l),
/* harmony export */   "_Y": () => (/* binding */ p),
/* harmony export */   "d4": () => (/* binding */ y),
/* harmony export */   "bt": () => (/* binding */ h),
/* harmony export */   "sO": () => (/* binding */ s),
/* harmony export */   "aP": () => (/* binding */ _),
/* harmony export */   "Ye": () => (/* binding */ d),
/* harmony export */   "I4": () => (/* binding */ A),
/* harmony export */   "qp": () => (/* binding */ F),
/* harmony export */   "Qb": () => (/* binding */ T),
/* harmony export */   "cO": () => (/* binding */ q)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_sub_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60086);
/* harmony import */ var core_js_modules_es_string_sub_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_sub_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79758);





var t,
  u,
  r,
  o = 0,
  i = [],
  c = preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__b */ .YM.__b,
  f = preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__r */ .YM.__r,
  e = preact__WEBPACK_IMPORTED_MODULE_4__/* .options.diffed */ .YM.diffed,
  a = preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__c */ .YM.__c,
  v = preact__WEBPACK_IMPORTED_MODULE_4__/* .options.unmount */ .YM.unmount;
function m(t, r) {
  preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__h */ .YM.__h && preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__h */ .YM.__h(u, t, o || r), o = 0;
  var i = u.__H || (u.__H = {
    __: [],
    __h: []
  });
  return t >= i.__.length && i.__.push({}), i.__[t];
}
function l(n) {
  return o = 1, p(w, n);
}
function p(n, r, o) {
  var i = m(t++, 2);
  return i.t = n, i.__c || (i.__ = [o ? o(r) : w(void 0, r), function (n) {
    var t = i.t(i.__[0], n);
    i.__[0] !== t && (i.__ = [t, i.__[1]], i.__c.setState({}));
  }], i.__c = u), i.__;
}
function y(r, o) {
  var i = m(t++, 3);
  !preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__s */ .YM.__s && k(i.__H, o) && (i.__ = r, i.__H = o, u.__H.__h.push(i));
}
function h(r, o) {
  var i = m(t++, 4);
  !preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__s */ .YM.__s && k(i.__H, o) && (i.__ = r, i.__H = o, u.__h.push(i));
}
function s(n) {
  return o = 5, d(function () {
    return {
      current: n
    };
  }, []);
}
function _(n, t, u) {
  o = 6, h(function () {
    "function" == typeof n ? n(t()) : n && (n.current = t());
  }, null == u ? u : u.concat(n));
}
function d(n, u) {
  var r = m(t++, 7);
  return k(r.__H, u) && (r.__ = n(), r.__H = u, r.__h = n), r.__;
}
function A(n, t) {
  return o = 8, d(function () {
    return n;
  }, t);
}
function F(n) {
  var r = u.context[n.__c],
    o = m(t++, 9);
  return o.c = n, r ? (null == o.__ && (o.__ = !0, r.sub(u)), r.props.value) : n.__;
}
function T(t, u) {
  preact__WEBPACK_IMPORTED_MODULE_4__/* .options.useDebugValue */ .YM.useDebugValue && preact__WEBPACK_IMPORTED_MODULE_4__/* .options.useDebugValue */ .YM.useDebugValue(u ? u(t) : t);
}
function q(n) {
  var r = m(t++, 10),
    o = l();
  return r.__ = n, u.componentDidCatch || (u.componentDidCatch = function (n) {
    r.__ && r.__(n), o[1](n);
  }), [o[0], function () {
    o[1](void 0);
  }];
}
function x() {
  i.forEach(function (t) {
    if (t.__P) try {
      t.__H.__h.forEach(g), t.__H.__h.forEach(j), t.__H.__h = [];
    } catch (u) {
      t.__H.__h = [], preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__e */ .YM.__e(u, t.__v);
    }
  }), i = [];
}
preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__b */ .YM.__b = function (n) {
  u = null, c && c(n);
}, preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__r */ .YM.__r = function (n) {
  f && f(n), t = 0;
  var r = (u = n.__c).__H;
  r && (r.__h.forEach(g), r.__h.forEach(j), r.__h = []);
}, preact__WEBPACK_IMPORTED_MODULE_4__/* .options.diffed */ .YM.diffed = function (t) {
  e && e(t);
  var o = t.__c;
  o && o.__H && o.__H.__h.length && (1 !== i.push(o) && r === preact__WEBPACK_IMPORTED_MODULE_4__/* .options.requestAnimationFrame */ .YM.requestAnimationFrame || ((r = preact__WEBPACK_IMPORTED_MODULE_4__/* .options.requestAnimationFrame */ .YM.requestAnimationFrame) || function (n) {
    var t,
      u = function u() {
        clearTimeout(r), b && cancelAnimationFrame(t), setTimeout(n);
      },
      r = setTimeout(u, 100);
    b && (t = requestAnimationFrame(u));
  })(x)), u = void 0;
}, preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__c */ .YM.__c = function (t, u) {
  u.some(function (t) {
    try {
      t.__h.forEach(g), t.__h = t.__h.filter(function (n) {
        return !n.__ || j(n);
      });
    } catch (r) {
      u.some(function (n) {
        n.__h && (n.__h = []);
      }), u = [], preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__e */ .YM.__e(r, t.__v);
    }
  }), a && a(t, u);
}, preact__WEBPACK_IMPORTED_MODULE_4__/* .options.unmount */ .YM.unmount = function (t) {
  v && v(t);
  var u = t.__c;
  if (u && u.__H) try {
    u.__H.__.forEach(g);
  } catch (t) {
    preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__e */ .YM.__e(t, u.__v);
  }
};
var b = "function" == typeof requestAnimationFrame;
function g(n) {
  var t = u;
  "function" == typeof n.__c && n.__c(), u = t;
}
function j(n) {
  var t = u;
  n.__c = n.__(), u = t;
}
function k(n, t) {
  return !n || n.length !== t.length || t.some(function (t, u) {
    return t !== n[u];
  });
}
function w(n, t) {
  return "function" == typeof t ? t(n) : t;
}


/***/ }),

/***/ 49101:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(47042);
// check document first so it doesn't error in node.js
var style = typeof document != 'undefined' ? document.createElement('p').style : {};
var prefixes = ['O', 'ms', 'Moz', 'Webkit'];
var upper = /([A-Z])/g;
var memo = {};

/**
 * prefix `key`
 *
 *   prefix('transform') // => WebkitTransform
 *
 * @param {String} key
 * @return {String}
 * @api public
 */
function prefix(key) {
  // Camel case
  key = key.replace(/-([a-z])/g, function (_, char) {
    return char.toUpperCase();
  });

  // Without prefix
  if (style[key] !== undefined) return key;

  // With prefix
  var Key = key.charAt(0).toUpperCase() + key.slice(1);
  var i = prefixes.length;
  while (i--) {
    var name = prefixes[i] + Key;
    if (style[name] !== undefined) return name;
  }
  return key;
}

/**
 * Memoized version of `prefix`
 *
 * @param {String} key
 * @return {String}
 * @api public
 */
function prefixMemozied(key) {
  return key in memo ? memo[key] : memo[key] = prefix(key);
}

/**
 * Create a dashed prefix
 *
 * @param {String} key
 * @return {String}
 * @api public
 */
function prefixDashed(key) {
  key = prefix(key);
  if (upper.test(key)) {
    key = '-' + key.replace(upper, '-$1');
    upper.lastIndex = 0;
  }
  return key.toLowerCase();
}
module.exports = prefixMemozied;
module.exports.dash = prefixDashed;

/***/ }),

/***/ 93860:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// --------------------
// promisify-any module
// --------------------

// modules
var Promise = __webpack_require__(83456),
  coBluebird = __webpack_require__(4324),
  isGeneratorFn = __webpack_require__(28026).fn;

// exports

module.exports = makePromisify(Promise);
function makePromisify(Promise) {
  var co = coBluebird.use(Promise);
  var promisify = function promisify(fn, options) {
    // conform options
    if (typeof options == 'number') {
      options = {
        numArgs: options
      };
    } else {
      if (options === undefined) options = {};
      if (options.numArgs === undefined) options.numArgs = 0;
    }

    // deal with generators
    if (isGeneratorFn(fn)) return co.wrap(fn);

    // deal with callback functions
    if (fn.length > options.numArgs) return Promise.promisify(fn);

    // deal with sync functions or promise-returning functions
    return Promise.method(fn);
  };

  // promisify all generators method
  promisify.generators = function (obj) {
    // promisify all methods of the object which are generators
    for (var name in obj) {
      var fn = obj[name];
      if (isGeneratorFn(fn)) obj[name] = co.wrap(fn);
    }

    // return obj for chaining
    return obj;
  };

  // method to set Promise implementation
  promisify.use = makePromisify;
  return promisify;
}

/***/ }),

/***/ 83456:
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;__webpack_require__(66992);
__webpack_require__(41539);
__webpack_require__(96290);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(47941);
__webpack_require__(39714);
__webpack_require__(23123);
__webpack_require__(69600);
__webpack_require__(40561);
__webpack_require__(47042);
__webpack_require__(68309);
__webpack_require__(4723);
__webpack_require__(43371);
__webpack_require__(38880);
__webpack_require__(36210);
__webpack_require__(30489);
__webpack_require__(21249);
__webpack_require__(57327);
__webpack_require__(17727);
__webpack_require__(92222);
__webpack_require__(83753);
__webpack_require__(24603);
__webpack_require__(84633);
__webpack_require__(9653);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2015 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/**
 * bluebird build version 2.11.0
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, cancel, using, filter, any, each, timers
*/
!function (e) {
  if ("object" == ( false ? 0 : _typeof(exports)) && "undefined" != "object") module.exports = e();else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else { var f; }
}(function () {
  var define, module, exports;
  return function e(t, n, r) {
    function s(o, u) {
      if (!n[o]) {
        if (!t[o]) {
          var a = typeof _dereq_ == "function" && _dereq_;
          if (!u && a) return a(o, !0);
          if (i) return i(o, !0);
          var f = new Error("Cannot find module '" + o + "'");
          throw f.code = "MODULE_NOT_FOUND", f;
        }
        var l = n[o] = {
          exports: {}
        };
        t[o][0].call(l.exports, function (e) {
          var n = t[o][1][e];
          return s(n ? n : e);
        }, l, l.exports, e, t, n, r);
      }
      return n[o].exports;
    }
    var i = typeof _dereq_ == "function" && _dereq_;
    for (var o = 0; o < r.length; o++) {
      s(r[o]);
    }
    return s;
  }({
    1: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise) {
        var SomePromiseArray = Promise._SomePromiseArray;
        function any(promises) {
          var ret = new SomePromiseArray(promises);
          var promise = ret.promise();
          ret.setHowMany(1);
          ret.setUnwrap();
          ret.init();
          return promise;
        }
        Promise.any = function (promises) {
          return any(promises);
        };
        Promise.prototype.any = function () {
          return any(this);
        };
      };
    }, {}],
    2: [function (_dereq_, module, exports) {
      "use strict";

      var firstLineError;
      try {
        throw new Error();
      } catch (e) {
        firstLineError = e;
      }
      var schedule = _dereq_("./schedule.js");
      var Queue = _dereq_("./queue.js");
      var util = _dereq_("./util.js");
      function Async() {
        this._isTickUsed = false;
        this._lateQueue = new Queue(16);
        this._normalQueue = new Queue(16);
        this._trampolineEnabled = true;
        var self = this;
        this.drainQueues = function () {
          self._drainQueues();
        };
        this._schedule = schedule.isStatic ? schedule(this.drainQueues) : schedule;
      }
      Async.prototype.disableTrampolineIfNecessary = function () {
        if (util.hasDevTools) {
          this._trampolineEnabled = false;
        }
      };
      Async.prototype.enableTrampoline = function () {
        if (!this._trampolineEnabled) {
          this._trampolineEnabled = true;
          this._schedule = function (fn) {
            setTimeout(fn, 0);
          };
        }
      };
      Async.prototype.haveItemsQueued = function () {
        return this._normalQueue.length() > 0;
      };
      Async.prototype.throwLater = function (fn, arg) {
        if (arguments.length === 1) {
          arg = fn;
          fn = function fn() {
            throw arg;
          };
        }
        if (typeof setTimeout !== "undefined") {
          setTimeout(function () {
            fn(arg);
          }, 0);
        } else try {
          this._schedule(function () {
            fn(arg);
          });
        } catch (e) {
          throw new Error("No async scheduler available\n\n    See http://goo.gl/m3OTXk\n");
        }
      };
      function AsyncInvokeLater(fn, receiver, arg) {
        this._lateQueue.push(fn, receiver, arg);
        this._queueTick();
      }
      function AsyncInvoke(fn, receiver, arg) {
        this._normalQueue.push(fn, receiver, arg);
        this._queueTick();
      }
      function AsyncSettlePromises(promise) {
        this._normalQueue._pushOne(promise);
        this._queueTick();
      }
      if (!util.hasDevTools) {
        Async.prototype.invokeLater = AsyncInvokeLater;
        Async.prototype.invoke = AsyncInvoke;
        Async.prototype.settlePromises = AsyncSettlePromises;
      } else {
        if (schedule.isStatic) {
          schedule = function schedule(fn) {
            setTimeout(fn, 0);
          };
        }
        Async.prototype.invokeLater = function (fn, receiver, arg) {
          if (this._trampolineEnabled) {
            AsyncInvokeLater.call(this, fn, receiver, arg);
          } else {
            this._schedule(function () {
              setTimeout(function () {
                fn.call(receiver, arg);
              }, 100);
            });
          }
        };
        Async.prototype.invoke = function (fn, receiver, arg) {
          if (this._trampolineEnabled) {
            AsyncInvoke.call(this, fn, receiver, arg);
          } else {
            this._schedule(function () {
              fn.call(receiver, arg);
            });
          }
        };
        Async.prototype.settlePromises = function (promise) {
          if (this._trampolineEnabled) {
            AsyncSettlePromises.call(this, promise);
          } else {
            this._schedule(function () {
              promise._settlePromises();
            });
          }
        };
      }
      Async.prototype.invokeFirst = function (fn, receiver, arg) {
        this._normalQueue.unshift(fn, receiver, arg);
        this._queueTick();
      };
      Async.prototype._drainQueue = function (queue) {
        while (queue.length() > 0) {
          var fn = queue.shift();
          if (typeof fn !== "function") {
            fn._settlePromises();
            continue;
          }
          var receiver = queue.shift();
          var arg = queue.shift();
          fn.call(receiver, arg);
        }
      };
      Async.prototype._drainQueues = function () {
        this._drainQueue(this._normalQueue);
        this._reset();
        this._drainQueue(this._lateQueue);
      };
      Async.prototype._queueTick = function () {
        if (!this._isTickUsed) {
          this._isTickUsed = true;
          this._schedule(this.drainQueues);
        }
      };
      Async.prototype._reset = function () {
        this._isTickUsed = false;
      };
      module.exports = new Async();
      module.exports.firstLineError = firstLineError;
    }, {
      "./queue.js": 28,
      "./schedule.js": 31,
      "./util.js": 38
    }],
    3: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, INTERNAL, tryConvertToPromise) {
        var rejectThis = function rejectThis(_, e) {
          this._reject(e);
        };
        var targetRejected = function targetRejected(e, context) {
          context.promiseRejectionQueued = true;
          context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
        };
        var bindingResolved = function bindingResolved(thisArg, context) {
          if (this._isPending()) {
            this._resolveCallback(context.target);
          }
        };
        var bindingRejected = function bindingRejected(e, context) {
          if (!context.promiseRejectionQueued) this._reject(e);
        };
        Promise.prototype.bind = function (thisArg) {
          var maybePromise = tryConvertToPromise(thisArg);
          var ret = new Promise(INTERNAL);
          ret._propagateFrom(this, 1);
          var target = this._target();
          ret._setBoundTo(maybePromise);
          if (maybePromise instanceof Promise) {
            var context = {
              promiseRejectionQueued: false,
              promise: ret,
              target: target,
              bindingPromise: maybePromise
            };
            target._then(INTERNAL, targetRejected, ret._progress, ret, context);
            maybePromise._then(bindingResolved, bindingRejected, ret._progress, ret, context);
          } else {
            ret._resolveCallback(target);
          }
          return ret;
        };
        Promise.prototype._setBoundTo = function (obj) {
          if (obj !== undefined) {
            this._bitField = this._bitField | 131072;
            this._boundTo = obj;
          } else {
            this._bitField = this._bitField & ~131072;
          }
        };
        Promise.prototype._isBound = function () {
          return (this._bitField & 131072) === 131072;
        };
        Promise.bind = function (thisArg, value) {
          var maybePromise = tryConvertToPromise(thisArg);
          var ret = new Promise(INTERNAL);
          ret._setBoundTo(maybePromise);
          if (maybePromise instanceof Promise) {
            maybePromise._then(function () {
              ret._resolveCallback(value);
            }, ret._reject, ret._progress, ret, null);
          } else {
            ret._resolveCallback(value);
          }
          return ret;
        };
      };
    }, {}],
    4: [function (_dereq_, module, exports) {
      "use strict";

      var old;
      if (typeof Promise !== "undefined") old = Promise;
      function noConflict() {
        try {
          if (Promise === bluebird) Promise = old;
        } catch (e) {}
        return bluebird;
      }
      var bluebird = _dereq_("./promise.js")();
      bluebird.noConflict = noConflict;
      module.exports = bluebird;
    }, {
      "./promise.js": 23
    }],
    5: [function (_dereq_, module, exports) {
      "use strict";

      var cr = Object.create;
      if (cr) {
        var callerCache = cr(null);
        var getterCache = cr(null);
        callerCache[" size"] = getterCache[" size"] = 0;
      }
      module.exports = function (Promise) {
        var util = _dereq_("./util.js");
        var canEvaluate = util.canEvaluate;
        var isIdentifier = util.isIdentifier;
        var getMethodCaller;
        var getGetter;
        if (false) { var getCompiled, makeGetter, makeMethodCaller; }
        function ensureMethod(obj, methodName) {
          var fn;
          if (obj != null) fn = obj[methodName];
          if (typeof fn !== "function") {
            var message = "Object " + util.classString(obj) + " has no method '" + util.toString(methodName) + "'";
            throw new Promise.TypeError(message);
          }
          return fn;
        }
        function caller(obj) {
          var methodName = this.pop();
          var fn = ensureMethod(obj, methodName);
          return fn.apply(obj, this);
        }
        Promise.prototype.call = function (methodName) {
          var $_len = arguments.length;
          var args = new Array($_len - 1);
          for (var $_i = 1; $_i < $_len; ++$_i) {
            args[$_i - 1] = arguments[$_i];
          }
          if (false) { var maybeCaller; }
          args.push(methodName);
          return this._then(caller, undefined, undefined, args, undefined);
        };
        function namedGetter(obj) {
          return obj[this];
        }
        function indexedGetter(obj) {
          var index = +this;
          if (index < 0) index = Math.max(0, index + obj.length);
          return obj[index];
        }
        Promise.prototype.get = function (propertyName) {
          var isIndex = typeof propertyName === "number";
          var getter;
          if (!isIndex) {
            if (canEvaluate) {
              var maybeGetter = getGetter(propertyName);
              getter = maybeGetter !== null ? maybeGetter : namedGetter;
            } else {
              getter = namedGetter;
            }
          } else {
            getter = indexedGetter;
          }
          return this._then(getter, undefined, undefined, propertyName, undefined);
        };
      };
    }, {
      "./util.js": 38
    }],
    6: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise) {
        var errors = _dereq_("./errors.js");
        var async = _dereq_("./async.js");
        var CancellationError = errors.CancellationError;
        Promise.prototype._cancel = function (reason) {
          if (!this.isCancellable()) return this;
          var parent;
          var promiseToReject = this;
          while ((parent = promiseToReject._cancellationParent) !== undefined && parent.isCancellable()) {
            promiseToReject = parent;
          }
          this._unsetCancellable();
          promiseToReject._target()._rejectCallback(reason, false, true);
        };
        Promise.prototype.cancel = function (reason) {
          if (!this.isCancellable()) return this;
          if (reason === undefined) reason = new CancellationError();
          async.invokeLater(this._cancel, this, reason);
          return this;
        };
        Promise.prototype.cancellable = function () {
          if (this._cancellable()) return this;
          async.enableTrampoline();
          this._setCancellable();
          this._cancellationParent = undefined;
          return this;
        };
        Promise.prototype.uncancellable = function () {
          var ret = this.then();
          ret._unsetCancellable();
          return ret;
        };
        Promise.prototype.fork = function (didFulfill, didReject, didProgress) {
          var ret = this._then(didFulfill, didReject, didProgress, undefined, undefined);
          ret._setCancellable();
          ret._cancellationParent = undefined;
          return ret;
        };
      };
    }, {
      "./async.js": 2,
      "./errors.js": 13
    }],
    7: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function () {
        var async = _dereq_("./async.js");
        var util = _dereq_("./util.js");
        var bluebirdFramePattern = /[\\\/]bluebird[\\\/]js[\\\/](main|debug|zalgo|instrumented)/;
        var stackFramePattern = null;
        var formatStack = null;
        var indentStackFrames = false;
        var warn;
        function CapturedTrace(parent) {
          this._parent = parent;
          var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
          captureStackTrace(this, CapturedTrace);
          if (length > 32) this.uncycle();
        }
        util.inherits(CapturedTrace, Error);
        CapturedTrace.prototype.uncycle = function () {
          var length = this._length;
          if (length < 2) return;
          var nodes = [];
          var stackToIndex = {};
          for (var i = 0, node = this; node !== undefined; ++i) {
            nodes.push(node);
            node = node._parent;
          }
          length = this._length = i;
          for (var i = length - 1; i >= 0; --i) {
            var stack = nodes[i].stack;
            if (stackToIndex[stack] === undefined) {
              stackToIndex[stack] = i;
            }
          }
          for (var i = 0; i < length; ++i) {
            var currentStack = nodes[i].stack;
            var index = stackToIndex[currentStack];
            if (index !== undefined && index !== i) {
              if (index > 0) {
                nodes[index - 1]._parent = undefined;
                nodes[index - 1]._length = 1;
              }
              nodes[i]._parent = undefined;
              nodes[i]._length = 1;
              var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
              if (index < length - 1) {
                cycleEdgeNode._parent = nodes[index + 1];
                cycleEdgeNode._parent.uncycle();
                cycleEdgeNode._length = cycleEdgeNode._parent._length + 1;
              } else {
                cycleEdgeNode._parent = undefined;
                cycleEdgeNode._length = 1;
              }
              var currentChildLength = cycleEdgeNode._length + 1;
              for (var j = i - 2; j >= 0; --j) {
                nodes[j]._length = currentChildLength;
                currentChildLength++;
              }
              return;
            }
          }
        };
        CapturedTrace.prototype.parent = function () {
          return this._parent;
        };
        CapturedTrace.prototype.hasParent = function () {
          return this._parent !== undefined;
        };
        CapturedTrace.prototype.attachExtraTrace = function (error) {
          if (error.__stackCleaned__) return;
          this.uncycle();
          var parsed = CapturedTrace.parseStackAndMessage(error);
          var message = parsed.message;
          var stacks = [parsed.stack];
          var trace = this;
          while (trace !== undefined) {
            stacks.push(cleanStack(trace.stack.split("\n")));
            trace = trace._parent;
          }
          removeCommonRoots(stacks);
          removeDuplicateOrEmptyJumps(stacks);
          util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
          util.notEnumerableProp(error, "__stackCleaned__", true);
        };
        function reconstructStack(message, stacks) {
          for (var i = 0; i < stacks.length - 1; ++i) {
            stacks[i].push("From previous event:");
            stacks[i] = stacks[i].join("\n");
          }
          if (i < stacks.length) {
            stacks[i] = stacks[i].join("\n");
          }
          return message + "\n" + stacks.join("\n");
        }
        function removeDuplicateOrEmptyJumps(stacks) {
          for (var i = 0; i < stacks.length; ++i) {
            if (stacks[i].length === 0 || i + 1 < stacks.length && stacks[i][0] === stacks[i + 1][0]) {
              stacks.splice(i, 1);
              i--;
            }
          }
        }
        function removeCommonRoots(stacks) {
          var current = stacks[0];
          for (var i = 1; i < stacks.length; ++i) {
            var prev = stacks[i];
            var currentLastIndex = current.length - 1;
            var currentLastLine = current[currentLastIndex];
            var commonRootMeetPoint = -1;
            for (var j = prev.length - 1; j >= 0; --j) {
              if (prev[j] === currentLastLine) {
                commonRootMeetPoint = j;
                break;
              }
            }
            for (var j = commonRootMeetPoint; j >= 0; --j) {
              var line = prev[j];
              if (current[currentLastIndex] === line) {
                current.pop();
                currentLastIndex--;
              } else {
                break;
              }
            }
            current = prev;
          }
        }
        function cleanStack(stack) {
          var ret = [];
          for (var i = 0; i < stack.length; ++i) {
            var line = stack[i];
            var isTraceLine = stackFramePattern.test(line) || "    (No stack trace)" === line;
            var isInternalFrame = isTraceLine && shouldIgnore(line);
            if (isTraceLine && !isInternalFrame) {
              if (indentStackFrames && line.charAt(0) !== " ") {
                line = "    " + line;
              }
              ret.push(line);
            }
          }
          return ret;
        }
        function stackFramesAsArray(error) {
          var stack = error.stack.replace(/\s+$/g, "").split("\n");
          for (var i = 0; i < stack.length; ++i) {
            var line = stack[i];
            if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
              break;
            }
          }
          if (i > 0) {
            stack = stack.slice(i);
          }
          return stack;
        }
        CapturedTrace.parseStackAndMessage = function (error) {
          var stack = error.stack;
          var message = error.toString();
          stack = typeof stack === "string" && stack.length > 0 ? stackFramesAsArray(error) : ["    (No stack trace)"];
          return {
            message: message,
            stack: cleanStack(stack)
          };
        };
        CapturedTrace.formatAndLogError = function (error, title) {
          if (typeof console !== "undefined") {
            var message;
            if (_typeof(error) === "object" || typeof error === "function") {
              var stack = error.stack;
              message = title + formatStack(stack, error);
            } else {
              message = title + String(error);
            }
            if (typeof warn === "function") {
              warn(message);
            } else if (typeof console.log === "function" || _typeof(console.log) === "object") {
              console.log(message);
            }
          }
        };
        CapturedTrace.unhandledRejection = function (reason) {
          CapturedTrace.formatAndLogError(reason, "^--- With additional stack trace: ");
        };
        CapturedTrace.isSupported = function () {
          return typeof captureStackTrace === "function";
        };
        CapturedTrace.fireRejectionEvent = function (name, localHandler, reason, promise) {
          var localEventFired = false;
          try {
            if (typeof localHandler === "function") {
              localEventFired = true;
              if (name === "rejectionHandled") {
                localHandler(promise);
              } else {
                localHandler(reason, promise);
              }
            }
          } catch (e) {
            async.throwLater(e);
          }
          var globalEventFired = false;
          try {
            globalEventFired = fireGlobalEvent(name, reason, promise);
          } catch (e) {
            globalEventFired = true;
            async.throwLater(e);
          }
          var domEventFired = false;
          if (fireDomEvent) {
            try {
              domEventFired = fireDomEvent(name.toLowerCase(), {
                reason: reason,
                promise: promise
              });
            } catch (e) {
              domEventFired = true;
              async.throwLater(e);
            }
          }
          if (!globalEventFired && !localEventFired && !domEventFired && name === "unhandledRejection") {
            CapturedTrace.formatAndLogError(reason, "Unhandled rejection ");
          }
        };
        function formatNonError(obj) {
          var str;
          if (typeof obj === "function") {
            str = "[function " + (obj.name || "anonymous") + "]";
          } else {
            str = obj.toString();
            var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
            if (ruselessToString.test(str)) {
              try {
                var newStr = JSON.stringify(obj);
                str = newStr;
              } catch (e) {}
            }
            if (str.length === 0) {
              str = "(empty array)";
            }
          }
          return "(<" + snip(str) + ">, no stack trace)";
        }
        function snip(str) {
          var maxChars = 41;
          if (str.length < maxChars) {
            return str;
          }
          return str.substr(0, maxChars - 3) + "...";
        }
        var shouldIgnore = function shouldIgnore() {
          return false;
        };
        var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
        function parseLineInfo(line) {
          var matches = line.match(parseLineInfoRegex);
          if (matches) {
            return {
              fileName: matches[1],
              line: parseInt(matches[2], 10)
            };
          }
        }
        CapturedTrace.setBounds = function (firstLineError, lastLineError) {
          if (!CapturedTrace.isSupported()) return;
          var firstStackLines = firstLineError.stack.split("\n");
          var lastStackLines = lastLineError.stack.split("\n");
          var firstIndex = -1;
          var lastIndex = -1;
          var firstFileName;
          var lastFileName;
          for (var i = 0; i < firstStackLines.length; ++i) {
            var result = parseLineInfo(firstStackLines[i]);
            if (result) {
              firstFileName = result.fileName;
              firstIndex = result.line;
              break;
            }
          }
          for (var i = 0; i < lastStackLines.length; ++i) {
            var result = parseLineInfo(lastStackLines[i]);
            if (result) {
              lastFileName = result.fileName;
              lastIndex = result.line;
              break;
            }
          }
          if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName || firstFileName !== lastFileName || firstIndex >= lastIndex) {
            return;
          }
          shouldIgnore = function shouldIgnore(line) {
            if (bluebirdFramePattern.test(line)) return true;
            var info = parseLineInfo(line);
            if (info) {
              if (info.fileName === firstFileName && firstIndex <= info.line && info.line <= lastIndex) {
                return true;
              }
            }
            return false;
          };
        };
        var captureStackTrace = function stackDetection() {
          var v8stackFramePattern = /^\s*at\s*/;
          var v8stackFormatter = function v8stackFormatter(stack, error) {
            if (typeof stack === "string") return stack;
            if (error.name !== undefined && error.message !== undefined) {
              return error.toString();
            }
            return formatNonError(error);
          };
          if (typeof Error.stackTraceLimit === "number" && typeof Error.captureStackTrace === "function") {
            Error.stackTraceLimit = Error.stackTraceLimit + 6;
            stackFramePattern = v8stackFramePattern;
            formatStack = v8stackFormatter;
            var captureStackTrace = Error.captureStackTrace;
            shouldIgnore = function shouldIgnore(line) {
              return bluebirdFramePattern.test(line);
            };
            return function (receiver, ignoreUntil) {
              Error.stackTraceLimit = Error.stackTraceLimit + 6;
              captureStackTrace(receiver, ignoreUntil);
              Error.stackTraceLimit = Error.stackTraceLimit - 6;
            };
          }
          var err = new Error();
          if (typeof err.stack === "string" && err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
            stackFramePattern = /@/;
            formatStack = v8stackFormatter;
            indentStackFrames = true;
            return function captureStackTrace(o) {
              o.stack = new Error().stack;
            };
          }
          var hasStackAfterThrow;
          try {
            throw new Error();
          } catch (e) {
            hasStackAfterThrow = "stack" in e;
          }
          if (!("stack" in err) && hasStackAfterThrow && typeof Error.stackTraceLimit === "number") {
            stackFramePattern = v8stackFramePattern;
            formatStack = v8stackFormatter;
            return function captureStackTrace(o) {
              Error.stackTraceLimit = Error.stackTraceLimit + 6;
              try {
                throw new Error();
              } catch (e) {
                o.stack = e.stack;
              }
              Error.stackTraceLimit = Error.stackTraceLimit - 6;
            };
          }
          formatStack = function formatStack(stack, error) {
            if (typeof stack === "string") return stack;
            if ((_typeof(error) === "object" || typeof error === "function") && error.name !== undefined && error.message !== undefined) {
              return error.toString();
            }
            return formatNonError(error);
          };
          return null;
        }([]);
        var fireDomEvent;
        var fireGlobalEvent = function () {
          if (util.isNode) {
            return function (name, reason, promise) {
              if (name === "rejectionHandled") {
                return process.emit(name, promise);
              } else {
                return process.emit(name, reason, promise);
              }
            };
          } else {
            var customEventWorks = false;
            var anyEventWorks = true;
            try {
              var ev = new self.CustomEvent("test");
              customEventWorks = ev instanceof CustomEvent;
            } catch (e) {}
            if (!customEventWorks) {
              try {
                var event = document.createEvent("CustomEvent");
                event.initCustomEvent("testingtheevent", false, true, {});
                self.dispatchEvent(event);
              } catch (e) {
                anyEventWorks = false;
              }
            }
            if (anyEventWorks) {
              fireDomEvent = function fireDomEvent(type, detail) {
                var event;
                if (customEventWorks) {
                  event = new self.CustomEvent(type, {
                    detail: detail,
                    bubbles: false,
                    cancelable: true
                  });
                } else if (self.dispatchEvent) {
                  event = document.createEvent("CustomEvent");
                  event.initCustomEvent(type, false, true, detail);
                }
                return event ? !self.dispatchEvent(event) : false;
              };
            }
            var toWindowMethodNameMap = {};
            toWindowMethodNameMap["unhandledRejection"] = ("on" + "unhandledRejection").toLowerCase();
            toWindowMethodNameMap["rejectionHandled"] = ("on" + "rejectionHandled").toLowerCase();
            return function (name, reason, promise) {
              var methodName = toWindowMethodNameMap[name];
              var method = self[methodName];
              if (!method) return false;
              if (name === "rejectionHandled") {
                method.call(self, promise);
              } else {
                method.call(self, reason, promise);
              }
              return true;
            };
          }
        }();
        if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
          warn = function warn(message) {
            console.warn(message);
          };
          if (util.isNode && process.stderr.isTTY) {
            warn = function warn(message) {
              process.stderr.write("\x1B[31m" + message + "\x1B[39m\n");
            };
          } else if (!util.isNode && typeof new Error().stack === "string") {
            warn = function warn(message) {
              console.warn("%c" + message, "color: red");
            };
          }
        }
        return CapturedTrace;
      };
    }, {
      "./async.js": 2,
      "./util.js": 38
    }],
    8: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (NEXT_FILTER) {
        var util = _dereq_("./util.js");
        var errors = _dereq_("./errors.js");
        var tryCatch = util.tryCatch;
        var errorObj = util.errorObj;
        var keys = _dereq_("./es5.js").keys;
        var TypeError = errors.TypeError;
        function CatchFilter(instances, callback, promise) {
          this._instances = instances;
          this._callback = callback;
          this._promise = promise;
        }
        function safePredicate(predicate, e) {
          var safeObject = {};
          var retfilter = tryCatch(predicate).call(safeObject, e);
          if (retfilter === errorObj) return retfilter;
          var safeKeys = keys(safeObject);
          if (safeKeys.length) {
            errorObj.e = new TypeError("Catch filter must inherit from Error or be a simple predicate function\n\n    See http://goo.gl/o84o68\n");
            return errorObj;
          }
          return retfilter;
        }
        CatchFilter.prototype.doFilter = function (e) {
          var cb = this._callback;
          var promise = this._promise;
          var boundTo = promise._boundValue();
          for (var i = 0, len = this._instances.length; i < len; ++i) {
            var item = this._instances[i];
            var itemIsErrorType = item === Error || item != null && item.prototype instanceof Error;
            if (itemIsErrorType && e instanceof item) {
              var ret = tryCatch(cb).call(boundTo, e);
              if (ret === errorObj) {
                NEXT_FILTER.e = ret.e;
                return NEXT_FILTER;
              }
              return ret;
            } else if (typeof item === "function" && !itemIsErrorType) {
              var shouldHandle = safePredicate(item, e);
              if (shouldHandle === errorObj) {
                e = errorObj.e;
                break;
              } else if (shouldHandle) {
                var ret = tryCatch(cb).call(boundTo, e);
                if (ret === errorObj) {
                  NEXT_FILTER.e = ret.e;
                  return NEXT_FILTER;
                }
                return ret;
              }
            }
          }
          NEXT_FILTER.e = e;
          return NEXT_FILTER;
        };
        return CatchFilter;
      };
    }, {
      "./errors.js": 13,
      "./es5.js": 14,
      "./util.js": 38
    }],
    9: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, CapturedTrace, isDebugging) {
        var contextStack = [];
        function Context() {
          this._trace = new CapturedTrace(peekContext());
        }
        Context.prototype._pushContext = function () {
          if (!isDebugging()) return;
          if (this._trace !== undefined) {
            contextStack.push(this._trace);
          }
        };
        Context.prototype._popContext = function () {
          if (!isDebugging()) return;
          if (this._trace !== undefined) {
            contextStack.pop();
          }
        };
        function createContext() {
          if (isDebugging()) return new Context();
        }
        function peekContext() {
          var lastIndex = contextStack.length - 1;
          if (lastIndex >= 0) {
            return contextStack[lastIndex];
          }
          return undefined;
        }
        Promise.prototype._peekContext = peekContext;
        Promise.prototype._pushContext = Context.prototype._pushContext;
        Promise.prototype._popContext = Context.prototype._popContext;
        return createContext;
      };
    }, {}],
    10: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, CapturedTrace) {
        var getDomain = Promise._getDomain;
        var async = _dereq_("./async.js");
        var Warning = _dereq_("./errors.js").Warning;
        var util = _dereq_("./util.js");
        var canAttachTrace = util.canAttachTrace;
        var unhandledRejectionHandled;
        var possiblyUnhandledRejection;
        var debugging =  false || util.isNode && (!!process.env["BLUEBIRD_DEBUG"] || "production" === "development");
        if (util.isNode && process.env["BLUEBIRD_DEBUG"] == 0) debugging = false;
        if (debugging) {
          async.disableTrampolineIfNecessary();
        }
        Promise.prototype._ignoreRejections = function () {
          this._unsetRejectionIsUnhandled();
          this._bitField = this._bitField | 16777216;
        };
        Promise.prototype._ensurePossibleRejectionHandled = function () {
          if ((this._bitField & 16777216) !== 0) return;
          this._setRejectionIsUnhandled();
          async.invokeLater(this._notifyUnhandledRejection, this, undefined);
        };
        Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
          CapturedTrace.fireRejectionEvent("rejectionHandled", unhandledRejectionHandled, undefined, this);
        };
        Promise.prototype._notifyUnhandledRejection = function () {
          if (this._isRejectionUnhandled()) {
            var reason = this._getCarriedStackTrace() || this._settledValue;
            this._setUnhandledRejectionIsNotified();
            CapturedTrace.fireRejectionEvent("unhandledRejection", possiblyUnhandledRejection, reason, this);
          }
        };
        Promise.prototype._setUnhandledRejectionIsNotified = function () {
          this._bitField = this._bitField | 524288;
        };
        Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
          this._bitField = this._bitField & ~524288;
        };
        Promise.prototype._isUnhandledRejectionNotified = function () {
          return (this._bitField & 524288) > 0;
        };
        Promise.prototype._setRejectionIsUnhandled = function () {
          this._bitField = this._bitField | 2097152;
        };
        Promise.prototype._unsetRejectionIsUnhandled = function () {
          this._bitField = this._bitField & ~2097152;
          if (this._isUnhandledRejectionNotified()) {
            this._unsetUnhandledRejectionIsNotified();
            this._notifyUnhandledRejectionIsHandled();
          }
        };
        Promise.prototype._isRejectionUnhandled = function () {
          return (this._bitField & 2097152) > 0;
        };
        Promise.prototype._setCarriedStackTrace = function (capturedTrace) {
          this._bitField = this._bitField | 1048576;
          this._fulfillmentHandler0 = capturedTrace;
        };
        Promise.prototype._isCarryingStackTrace = function () {
          return (this._bitField & 1048576) > 0;
        };
        Promise.prototype._getCarriedStackTrace = function () {
          return this._isCarryingStackTrace() ? this._fulfillmentHandler0 : undefined;
        };
        Promise.prototype._captureStackTrace = function () {
          if (debugging) {
            this._trace = new CapturedTrace(this._peekContext());
          }
          return this;
        };
        Promise.prototype._attachExtraTrace = function (error, ignoreSelf) {
          if (debugging && canAttachTrace(error)) {
            var trace = this._trace;
            if (trace !== undefined) {
              if (ignoreSelf) trace = trace._parent;
            }
            if (trace !== undefined) {
              trace.attachExtraTrace(error);
            } else if (!error.__stackCleaned__) {
              var parsed = CapturedTrace.parseStackAndMessage(error);
              util.notEnumerableProp(error, "stack", parsed.message + "\n" + parsed.stack.join("\n"));
              util.notEnumerableProp(error, "__stackCleaned__", true);
            }
          }
        };
        Promise.prototype._warn = function (message) {
          var warning = new Warning(message);
          var ctx = this._peekContext();
          if (ctx) {
            ctx.attachExtraTrace(warning);
          } else {
            var parsed = CapturedTrace.parseStackAndMessage(warning);
            warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
          }
          CapturedTrace.formatAndLogError(warning, "");
        };
        Promise.onPossiblyUnhandledRejection = function (fn) {
          var domain = getDomain();
          possiblyUnhandledRejection = typeof fn === "function" ? domain === null ? fn : domain.bind(fn) : undefined;
        };
        Promise.onUnhandledRejectionHandled = function (fn) {
          var domain = getDomain();
          unhandledRejectionHandled = typeof fn === "function" ? domain === null ? fn : domain.bind(fn) : undefined;
        };
        Promise.longStackTraces = function () {
          if (async.haveItemsQueued() && debugging === false) {
            throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/DT1qyG\n");
          }
          debugging = CapturedTrace.isSupported();
          if (debugging) {
            async.disableTrampolineIfNecessary();
          }
        };
        Promise.hasLongStackTraces = function () {
          return debugging && CapturedTrace.isSupported();
        };
        if (!CapturedTrace.isSupported()) {
          Promise.longStackTraces = function () {};
          debugging = false;
        }
        return function () {
          return debugging;
        };
      };
    }, {
      "./async.js": 2,
      "./errors.js": 13,
      "./util.js": 38
    }],
    11: [function (_dereq_, module, exports) {
      "use strict";

      var util = _dereq_("./util.js");
      var isPrimitive = util.isPrimitive;
      module.exports = function (Promise) {
        var returner = function returner() {
          return this;
        };
        var thrower = function thrower() {
          throw this;
        };
        var returnUndefined = function returnUndefined() {};
        var throwUndefined = function throwUndefined() {
          throw undefined;
        };
        var wrapper = function wrapper(value, action) {
          if (action === 1) {
            return function () {
              throw value;
            };
          } else if (action === 2) {
            return function () {
              return value;
            };
          }
        };
        Promise.prototype["return"] = Promise.prototype.thenReturn = function (value) {
          if (value === undefined) return this.then(returnUndefined);
          if (isPrimitive(value)) {
            return this._then(wrapper(value, 2), undefined, undefined, undefined, undefined);
          } else if (value instanceof Promise) {
            value._ignoreRejections();
          }
          return this._then(returner, undefined, undefined, value, undefined);
        };
        Promise.prototype["throw"] = Promise.prototype.thenThrow = function (reason) {
          if (reason === undefined) return this.then(throwUndefined);
          if (isPrimitive(reason)) {
            return this._then(wrapper(reason, 1), undefined, undefined, undefined, undefined);
          }
          return this._then(thrower, undefined, undefined, reason, undefined);
        };
      };
    }, {
      "./util.js": 38
    }],
    12: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, INTERNAL) {
        var PromiseReduce = Promise.reduce;
        Promise.prototype.each = function (fn) {
          return PromiseReduce(this, fn, null, INTERNAL);
        };
        Promise.each = function (promises, fn) {
          return PromiseReduce(promises, fn, null, INTERNAL);
        };
      };
    }, {}],
    13: [function (_dereq_, module, exports) {
      "use strict";

      var es5 = _dereq_("./es5.js");
      var Objectfreeze = es5.freeze;
      var util = _dereq_("./util.js");
      var inherits = util.inherits;
      var notEnumerableProp = util.notEnumerableProp;
      function subError(nameProperty, defaultMessage) {
        function SubError(message) {
          if (!(this instanceof SubError)) return new SubError(message);
          notEnumerableProp(this, "message", typeof message === "string" ? message : defaultMessage);
          notEnumerableProp(this, "name", nameProperty);
          if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
          } else {
            Error.call(this);
          }
        }
        inherits(SubError, Error);
        return SubError;
      }
      var _TypeError, _RangeError;
      var Warning = subError("Warning", "warning");
      var CancellationError = subError("CancellationError", "cancellation error");
      var TimeoutError = subError("TimeoutError", "timeout error");
      var AggregateError = subError("AggregateError", "aggregate error");
      try {
        _TypeError = TypeError;
        _RangeError = RangeError;
      } catch (e) {
        _TypeError = subError("TypeError", "type error");
        _RangeError = subError("RangeError", "range error");
      }
      var methods = ("join pop push shift unshift slice filter forEach some " + "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");
      for (var i = 0; i < methods.length; ++i) {
        if (typeof Array.prototype[methods[i]] === "function") {
          AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
        }
      }
      es5.defineProperty(AggregateError.prototype, "length", {
        value: 0,
        configurable: false,
        writable: true,
        enumerable: true
      });
      AggregateError.prototype["isOperational"] = true;
      var level = 0;
      AggregateError.prototype.toString = function () {
        var indent = Array(level * 4 + 1).join(" ");
        var ret = "\n" + indent + "AggregateError of:" + "\n";
        level++;
        indent = Array(level * 4 + 1).join(" ");
        for (var i = 0; i < this.length; ++i) {
          var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
          var lines = str.split("\n");
          for (var j = 0; j < lines.length; ++j) {
            lines[j] = indent + lines[j];
          }
          str = lines.join("\n");
          ret += str + "\n";
        }
        level--;
        return ret;
      };
      function OperationalError(message) {
        if (!(this instanceof OperationalError)) return new OperationalError(message);
        notEnumerableProp(this, "name", "OperationalError");
        notEnumerableProp(this, "message", message);
        this.cause = message;
        this["isOperational"] = true;
        if (message instanceof Error) {
          notEnumerableProp(this, "message", message.message);
          notEnumerableProp(this, "stack", message.stack);
        } else if (Error.captureStackTrace) {
          Error.captureStackTrace(this, this.constructor);
        }
      }
      inherits(OperationalError, Error);
      var errorTypes = Error["__BluebirdErrorTypes__"];
      if (!errorTypes) {
        errorTypes = Objectfreeze({
          CancellationError: CancellationError,
          TimeoutError: TimeoutError,
          OperationalError: OperationalError,
          RejectionError: OperationalError,
          AggregateError: AggregateError
        });
        notEnumerableProp(Error, "__BluebirdErrorTypes__", errorTypes);
      }
      module.exports = {
        Error: Error,
        TypeError: _TypeError,
        RangeError: _RangeError,
        CancellationError: errorTypes.CancellationError,
        OperationalError: errorTypes.OperationalError,
        TimeoutError: errorTypes.TimeoutError,
        AggregateError: errorTypes.AggregateError,
        Warning: Warning
      };
    }, {
      "./es5.js": 14,
      "./util.js": 38
    }],
    14: [function (_dereq_, module, exports) {
      var isES5 = function () {
        "use strict";

        return this === undefined;
      }();
      if (isES5) {
        module.exports = {
          freeze: Object.freeze,
          defineProperty: Object.defineProperty,
          getDescriptor: Object.getOwnPropertyDescriptor,
          keys: Object.keys,
          names: Object.getOwnPropertyNames,
          getPrototypeOf: Object.getPrototypeOf,
          isArray: Array.isArray,
          isES5: isES5,
          propertyIsWritable: function propertyIsWritable(obj, prop) {
            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
            return !!(!descriptor || descriptor.writable || descriptor.set);
          }
        };
      } else {
        var has = {}.hasOwnProperty;
        var str = {}.toString;
        var proto = {}.constructor.prototype;
        var ObjectKeys = function ObjectKeys(o) {
          var ret = [];
          for (var key in o) {
            if (has.call(o, key)) {
              ret.push(key);
            }
          }
          return ret;
        };
        var ObjectGetDescriptor = function ObjectGetDescriptor(o, key) {
          return {
            value: o[key]
          };
        };
        var ObjectDefineProperty = function ObjectDefineProperty(o, key, desc) {
          o[key] = desc.value;
          return o;
        };
        var ObjectFreeze = function ObjectFreeze(obj) {
          return obj;
        };
        var ObjectGetPrototypeOf = function ObjectGetPrototypeOf(obj) {
          try {
            return Object(obj).constructor.prototype;
          } catch (e) {
            return proto;
          }
        };
        var ArrayIsArray = function ArrayIsArray(obj) {
          try {
            return str.call(obj) === "[object Array]";
          } catch (e) {
            return false;
          }
        };
        module.exports = {
          isArray: ArrayIsArray,
          keys: ObjectKeys,
          names: ObjectKeys,
          defineProperty: ObjectDefineProperty,
          getDescriptor: ObjectGetDescriptor,
          freeze: ObjectFreeze,
          getPrototypeOf: ObjectGetPrototypeOf,
          isES5: isES5,
          propertyIsWritable: function propertyIsWritable() {
            return true;
          }
        };
      }
    }, {}],
    15: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, INTERNAL) {
        var PromiseMap = Promise.map;
        Promise.prototype.filter = function (fn, options) {
          return PromiseMap(this, fn, options, INTERNAL);
        };
        Promise.filter = function (promises, fn, options) {
          return PromiseMap(promises, fn, options, INTERNAL);
        };
      };
    }, {}],
    16: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, NEXT_FILTER, tryConvertToPromise) {
        var util = _dereq_("./util.js");
        var isPrimitive = util.isPrimitive;
        var thrower = util.thrower;
        function returnThis() {
          return this;
        }
        function throwThis() {
          throw this;
        }
        function return$(r) {
          return function () {
            return r;
          };
        }
        function throw$(r) {
          return function () {
            throw r;
          };
        }
        function promisedFinally(ret, reasonOrValue, isFulfilled) {
          var then;
          if (isPrimitive(reasonOrValue)) {
            then = isFulfilled ? return$(reasonOrValue) : throw$(reasonOrValue);
          } else {
            then = isFulfilled ? returnThis : throwThis;
          }
          return ret._then(then, thrower, undefined, reasonOrValue, undefined);
        }
        function finallyHandler(reasonOrValue) {
          var promise = this.promise;
          var handler = this.handler;
          var ret = promise._isBound() ? handler.call(promise._boundValue()) : handler();
          if (ret !== undefined) {
            var maybePromise = tryConvertToPromise(ret, promise);
            if (maybePromise instanceof Promise) {
              maybePromise = maybePromise._target();
              return promisedFinally(maybePromise, reasonOrValue, promise.isFulfilled());
            }
          }
          if (promise.isRejected()) {
            NEXT_FILTER.e = reasonOrValue;
            return NEXT_FILTER;
          } else {
            return reasonOrValue;
          }
        }
        function tapHandler(value) {
          var promise = this.promise;
          var handler = this.handler;
          var ret = promise._isBound() ? handler.call(promise._boundValue(), value) : handler(value);
          if (ret !== undefined) {
            var maybePromise = tryConvertToPromise(ret, promise);
            if (maybePromise instanceof Promise) {
              maybePromise = maybePromise._target();
              return promisedFinally(maybePromise, value, true);
            }
          }
          return value;
        }
        Promise.prototype._passThroughHandler = function (handler, isFinally) {
          if (typeof handler !== "function") return this.then();
          var promiseAndHandler = {
            promise: this,
            handler: handler
          };
          return this._then(isFinally ? finallyHandler : tapHandler, isFinally ? finallyHandler : undefined, undefined, promiseAndHandler, undefined);
        };
        Promise.prototype.lastly = Promise.prototype["finally"] = function (handler) {
          return this._passThroughHandler(handler, true);
        };
        Promise.prototype.tap = function (handler) {
          return this._passThroughHandler(handler, false);
        };
      };
    }, {
      "./util.js": 38
    }],
    17: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, apiRejection, INTERNAL, tryConvertToPromise) {
        var errors = _dereq_("./errors.js");
        var TypeError = errors.TypeError;
        var util = _dereq_("./util.js");
        var errorObj = util.errorObj;
        var tryCatch = util.tryCatch;
        var yieldHandlers = [];
        function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
          for (var i = 0; i < yieldHandlers.length; ++i) {
            traceParent._pushContext();
            var result = tryCatch(yieldHandlers[i])(value);
            traceParent._popContext();
            if (result === errorObj) {
              traceParent._pushContext();
              var ret = Promise.reject(errorObj.e);
              traceParent._popContext();
              return ret;
            }
            var maybePromise = tryConvertToPromise(result, traceParent);
            if (maybePromise instanceof Promise) return maybePromise;
          }
          return null;
        }
        function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
          var promise = this._promise = new Promise(INTERNAL);
          promise._captureStackTrace();
          this._stack = stack;
          this._generatorFunction = generatorFunction;
          this._receiver = receiver;
          this._generator = undefined;
          this._yieldHandlers = typeof yieldHandler === "function" ? [yieldHandler].concat(yieldHandlers) : yieldHandlers;
        }
        PromiseSpawn.prototype.promise = function () {
          return this._promise;
        };
        PromiseSpawn.prototype._run = function () {
          this._generator = this._generatorFunction.call(this._receiver);
          this._receiver = this._generatorFunction = undefined;
          this._next(undefined);
        };
        PromiseSpawn.prototype._continue = function (result) {
          if (result === errorObj) {
            return this._promise._rejectCallback(result.e, false, true);
          }
          var value = result.value;
          if (result.done === true) {
            this._promise._resolveCallback(value);
          } else {
            var maybePromise = tryConvertToPromise(value, this._promise);
            if (!(maybePromise instanceof Promise)) {
              maybePromise = promiseFromYieldHandler(maybePromise, this._yieldHandlers, this._promise);
              if (maybePromise === null) {
                this._throw(new TypeError("A value %s was yielded that could not be treated as a promise\n\n    See http://goo.gl/4Y4pDk\n\n".replace("%s", value) + "From coroutine:\n" + this._stack.split("\n").slice(1, -7).join("\n")));
                return;
              }
            }
            maybePromise._then(this._next, this._throw, undefined, this, null);
          }
        };
        PromiseSpawn.prototype._throw = function (reason) {
          this._promise._attachExtraTrace(reason);
          this._promise._pushContext();
          var result = tryCatch(this._generator["throw"]).call(this._generator, reason);
          this._promise._popContext();
          this._continue(result);
        };
        PromiseSpawn.prototype._next = function (value) {
          this._promise._pushContext();
          var result = tryCatch(this._generator.next).call(this._generator, value);
          this._promise._popContext();
          this._continue(result);
        };
        Promise.coroutine = function (generatorFunction, options) {
          if (typeof generatorFunction !== "function") {
            throw new TypeError("generatorFunction must be a function\n\n    See http://goo.gl/6Vqhm0\n");
          }
          var yieldHandler = Object(options).yieldHandler;
          var PromiseSpawn$ = PromiseSpawn;
          var stack = new Error().stack;
          return function () {
            var generator = generatorFunction.apply(this, arguments);
            var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler, stack);
            spawn._generator = generator;
            spawn._next(undefined);
            return spawn.promise();
          };
        };
        Promise.coroutine.addYieldHandler = function (fn) {
          if (typeof fn !== "function") throw new TypeError("fn must be a function\n\n    See http://goo.gl/916lJJ\n");
          yieldHandlers.push(fn);
        };
        Promise.spawn = function (generatorFunction) {
          if (typeof generatorFunction !== "function") {
            return apiRejection("generatorFunction must be a function\n\n    See http://goo.gl/6Vqhm0\n");
          }
          var spawn = new PromiseSpawn(generatorFunction, this);
          var ret = spawn.promise();
          spawn._run(Promise.spawn);
          return ret;
        };
      };
    }, {
      "./errors.js": 13,
      "./util.js": 38
    }],
    18: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, PromiseArray, tryConvertToPromise, INTERNAL) {
        var util = _dereq_("./util.js");
        var canEvaluate = util.canEvaluate;
        var tryCatch = util.tryCatch;
        var errorObj = util.errorObj;
        var reject;
        if (false) { var reject, Holder, i, callers, thenCallbacks, caller, thenCallback; }
        Promise.join = function () {
          var last = arguments.length - 1;
          var fn;
          if (last > 0 && typeof arguments[last] === "function") {
            fn = arguments[last];
            if (false) { var maybePromise, i, callbacks, holder, ret; }
          }
          var $_len = arguments.length;
          var args = new Array($_len);
          for (var $_i = 0; $_i < $_len; ++$_i) {
            args[$_i] = arguments[$_i];
          }
          if (fn) args.pop();
          var ret = new PromiseArray(args).promise();
          return fn !== undefined ? ret.spread(fn) : ret;
        };
      };
    }, {
      "./util.js": 38
    }],
    19: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL) {
        var getDomain = Promise._getDomain;
        var async = _dereq_("./async.js");
        var util = _dereq_("./util.js");
        var tryCatch = util.tryCatch;
        var errorObj = util.errorObj;
        var PENDING = {};
        var EMPTY_ARRAY = [];
        function MappingPromiseArray(promises, fn, limit, _filter) {
          this.constructor$(promises);
          this._promise._captureStackTrace();
          var domain = getDomain();
          this._callback = domain === null ? fn : domain.bind(fn);
          this._preservedValues = _filter === INTERNAL ? new Array(this.length()) : null;
          this._limit = limit;
          this._inFlight = 0;
          this._queue = limit >= 1 ? [] : EMPTY_ARRAY;
          async.invoke(init, this, undefined);
        }
        util.inherits(MappingPromiseArray, PromiseArray);
        function init() {
          this._init$(undefined, -2);
        }
        MappingPromiseArray.prototype._init = function () {};
        MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
          var values = this._values;
          var length = this.length();
          var preservedValues = this._preservedValues;
          var limit = this._limit;
          if (values[index] === PENDING) {
            values[index] = value;
            if (limit >= 1) {
              this._inFlight--;
              this._drainQueue();
              if (this._isResolved()) return;
            }
          } else {
            if (limit >= 1 && this._inFlight >= limit) {
              values[index] = value;
              this._queue.push(index);
              return;
            }
            if (preservedValues !== null) preservedValues[index] = value;
            var callback = this._callback;
            var receiver = this._promise._boundValue();
            this._promise._pushContext();
            var ret = tryCatch(callback).call(receiver, value, index, length);
            this._promise._popContext();
            if (ret === errorObj) return this._reject(ret.e);
            var maybePromise = tryConvertToPromise(ret, this._promise);
            if (maybePromise instanceof Promise) {
              maybePromise = maybePromise._target();
              if (maybePromise._isPending()) {
                if (limit >= 1) this._inFlight++;
                values[index] = PENDING;
                return maybePromise._proxyPromiseArray(this, index);
              } else if (maybePromise._isFulfilled()) {
                ret = maybePromise._value();
              } else {
                return this._reject(maybePromise._reason());
              }
            }
            values[index] = ret;
          }
          var totalResolved = ++this._totalResolved;
          if (totalResolved >= length) {
            if (preservedValues !== null) {
              this._filter(values, preservedValues);
            } else {
              this._resolve(values);
            }
          }
        };
        MappingPromiseArray.prototype._drainQueue = function () {
          var queue = this._queue;
          var limit = this._limit;
          var values = this._values;
          while (queue.length > 0 && this._inFlight < limit) {
            if (this._isResolved()) return;
            var index = queue.pop();
            this._promiseFulfilled(values[index], index);
          }
        };
        MappingPromiseArray.prototype._filter = function (booleans, values) {
          var len = values.length;
          var ret = new Array(len);
          var j = 0;
          for (var i = 0; i < len; ++i) {
            if (booleans[i]) ret[j++] = values[i];
          }
          ret.length = j;
          this._resolve(ret);
        };
        MappingPromiseArray.prototype.preservedValues = function () {
          return this._preservedValues;
        };
        function map(promises, fn, options, _filter) {
          var limit = _typeof(options) === "object" && options !== null ? options.concurrency : 0;
          limit = typeof limit === "number" && isFinite(limit) && limit >= 1 ? limit : 0;
          return new MappingPromiseArray(promises, fn, limit, _filter);
        }
        Promise.prototype.map = function (fn, options) {
          if (typeof fn !== "function") return apiRejection("fn must be a function\n\n    See http://goo.gl/916lJJ\n");
          return map(this, fn, options, null).promise();
        };
        Promise.map = function (promises, fn, options, _filter) {
          if (typeof fn !== "function") return apiRejection("fn must be a function\n\n    See http://goo.gl/916lJJ\n");
          return map(promises, fn, options, _filter).promise();
        };
      };
    }, {
      "./async.js": 2,
      "./util.js": 38
    }],
    20: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, INTERNAL, tryConvertToPromise, apiRejection) {
        var util = _dereq_("./util.js");
        var tryCatch = util.tryCatch;
        Promise.method = function (fn) {
          if (typeof fn !== "function") {
            throw new Promise.TypeError("fn must be a function\n\n    See http://goo.gl/916lJJ\n");
          }
          return function () {
            var ret = new Promise(INTERNAL);
            ret._captureStackTrace();
            ret._pushContext();
            var value = tryCatch(fn).apply(this, arguments);
            ret._popContext();
            ret._resolveFromSyncValue(value);
            return ret;
          };
        };
        Promise.attempt = Promise["try"] = function (fn, args, ctx) {
          if (typeof fn !== "function") {
            return apiRejection("fn must be a function\n\n    See http://goo.gl/916lJJ\n");
          }
          var ret = new Promise(INTERNAL);
          ret._captureStackTrace();
          ret._pushContext();
          var value = util.isArray(args) ? tryCatch(fn).apply(ctx, args) : tryCatch(fn).call(ctx, args);
          ret._popContext();
          ret._resolveFromSyncValue(value);
          return ret;
        };
        Promise.prototype._resolveFromSyncValue = function (value) {
          if (value === util.errorObj) {
            this._rejectCallback(value.e, false, true);
          } else {
            this._resolveCallback(value, true);
          }
        };
      };
    }, {
      "./util.js": 38
    }],
    21: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise) {
        var util = _dereq_("./util.js");
        var async = _dereq_("./async.js");
        var tryCatch = util.tryCatch;
        var errorObj = util.errorObj;
        function spreadAdapter(val, nodeback) {
          var promise = this;
          if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
          var ret = tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
          if (ret === errorObj) {
            async.throwLater(ret.e);
          }
        }
        function successAdapter(val, nodeback) {
          var promise = this;
          var receiver = promise._boundValue();
          var ret = val === undefined ? tryCatch(nodeback).call(receiver, null) : tryCatch(nodeback).call(receiver, null, val);
          if (ret === errorObj) {
            async.throwLater(ret.e);
          }
        }
        function errorAdapter(reason, nodeback) {
          var promise = this;
          if (!reason) {
            var target = promise._target();
            var newReason = target._getCarriedStackTrace();
            newReason.cause = reason;
            reason = newReason;
          }
          var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
          if (ret === errorObj) {
            async.throwLater(ret.e);
          }
        }
        Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback, options) {
          if (typeof nodeback == "function") {
            var adapter = successAdapter;
            if (options !== undefined && Object(options).spread) {
              adapter = spreadAdapter;
            }
            this._then(adapter, errorAdapter, undefined, this, nodeback);
          }
          return this;
        };
      };
    }, {
      "./async.js": 2,
      "./util.js": 38
    }],
    22: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, PromiseArray) {
        var util = _dereq_("./util.js");
        var async = _dereq_("./async.js");
        var tryCatch = util.tryCatch;
        var errorObj = util.errorObj;
        Promise.prototype.progressed = function (handler) {
          return this._then(undefined, undefined, handler, undefined, undefined);
        };
        Promise.prototype._progress = function (progressValue) {
          if (this._isFollowingOrFulfilledOrRejected()) return;
          this._target()._progressUnchecked(progressValue);
        };
        Promise.prototype._progressHandlerAt = function (index) {
          return index === 0 ? this._progressHandler0 : this[(index << 2) + index - 5 + 2];
        };
        Promise.prototype._doProgressWith = function (progression) {
          var progressValue = progression.value;
          var handler = progression.handler;
          var promise = progression.promise;
          var receiver = progression.receiver;
          var ret = tryCatch(handler).call(receiver, progressValue);
          if (ret === errorObj) {
            if (ret.e != null && ret.e.name !== "StopProgressPropagation") {
              var trace = util.canAttachTrace(ret.e) ? ret.e : new Error(util.toString(ret.e));
              promise._attachExtraTrace(trace);
              promise._progress(ret.e);
            }
          } else if (ret instanceof Promise) {
            ret._then(promise._progress, null, null, promise, undefined);
          } else {
            promise._progress(ret);
          }
        };
        Promise.prototype._progressUnchecked = function (progressValue) {
          var len = this._length();
          var progress = this._progress;
          for (var i = 0; i < len; i++) {
            var handler = this._progressHandlerAt(i);
            var promise = this._promiseAt(i);
            if (!(promise instanceof Promise)) {
              var receiver = this._receiverAt(i);
              if (typeof handler === "function") {
                handler.call(receiver, progressValue, promise);
              } else if (receiver instanceof PromiseArray && !receiver._isResolved()) {
                receiver._promiseProgressed(progressValue, promise);
              }
              continue;
            }
            if (typeof handler === "function") {
              async.invoke(this._doProgressWith, this, {
                handler: handler,
                promise: promise,
                receiver: this._receiverAt(i),
                value: progressValue
              });
            } else {
              async.invoke(progress, promise, progressValue);
            }
          }
        };
      };
    }, {
      "./async.js": 2,
      "./util.js": 38
    }],
    23: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function () {
        var makeSelfResolutionError = function makeSelfResolutionError() {
          return new TypeError("circular promise resolution chain\n\n    See http://goo.gl/LhFpo0\n");
        };
        var reflect = function reflect() {
          return new Promise.PromiseInspection(this._target());
        };
        var apiRejection = function apiRejection(msg) {
          return Promise.reject(new TypeError(msg));
        };
        var util = _dereq_("./util.js");
        var getDomain;
        if (util.isNode) {
          getDomain = function getDomain() {
            var ret = process.domain;
            if (ret === undefined) ret = null;
            return ret;
          };
        } else {
          getDomain = function getDomain() {
            return null;
          };
        }
        util.notEnumerableProp(Promise, "_getDomain", getDomain);
        var UNDEFINED_BINDING = {};
        var async = _dereq_("./async.js");
        var errors = _dereq_("./errors.js");
        var TypeError = Promise.TypeError = errors.TypeError;
        Promise.RangeError = errors.RangeError;
        Promise.CancellationError = errors.CancellationError;
        Promise.TimeoutError = errors.TimeoutError;
        Promise.OperationalError = errors.OperationalError;
        Promise.RejectionError = errors.OperationalError;
        Promise.AggregateError = errors.AggregateError;
        var INTERNAL = function INTERNAL() {};
        var APPLY = {};
        var NEXT_FILTER = {
          e: null
        };
        var tryConvertToPromise = _dereq_("./thenables.js")(Promise, INTERNAL);
        var PromiseArray = _dereq_("./promise_array.js")(Promise, INTERNAL, tryConvertToPromise, apiRejection);
        var CapturedTrace = _dereq_("./captured_trace.js")();
        var isDebugging = _dereq_("./debuggability.js")(Promise, CapturedTrace);
        /*jshint unused:false*/
        var createContext = _dereq_("./context.js")(Promise, CapturedTrace, isDebugging);
        var CatchFilter = _dereq_("./catch_filter.js")(NEXT_FILTER);
        var PromiseResolver = _dereq_("./promise_resolver.js");
        var nodebackForPromise = PromiseResolver._nodebackForPromise;
        var errorObj = util.errorObj;
        var tryCatch = util.tryCatch;
        function Promise(resolver) {
          if (typeof resolver !== "function") {
            throw new TypeError("the promise constructor requires a resolver function\n\n    See http://goo.gl/EC22Yn\n");
          }
          if (this.constructor !== Promise) {
            throw new TypeError("the promise constructor cannot be invoked directly\n\n    See http://goo.gl/KsIlge\n");
          }
          this._bitField = 0;
          this._fulfillmentHandler0 = undefined;
          this._rejectionHandler0 = undefined;
          this._progressHandler0 = undefined;
          this._promise0 = undefined;
          this._receiver0 = undefined;
          this._settledValue = undefined;
          if (resolver !== INTERNAL) this._resolveFromResolver(resolver);
        }
        Promise.prototype.toString = function () {
          return "[object Promise]";
        };
        Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
          var len = arguments.length;
          if (len > 1) {
            var catchInstances = new Array(len - 1),
              j = 0,
              i;
            for (i = 0; i < len - 1; ++i) {
              var item = arguments[i];
              if (typeof item === "function") {
                catchInstances[j++] = item;
              } else {
                return Promise.reject(new TypeError("Catch filter must inherit from Error or be a simple predicate function\n\n    See http://goo.gl/o84o68\n"));
              }
            }
            catchInstances.length = j;
            fn = arguments[i];
            var catchFilter = new CatchFilter(catchInstances, fn, this);
            return this._then(undefined, catchFilter.doFilter, undefined, catchFilter, undefined);
          }
          return this._then(undefined, fn, undefined, undefined, undefined);
        };
        Promise.prototype.reflect = function () {
          return this._then(reflect, reflect, undefined, this, undefined);
        };
        Promise.prototype.then = function (didFulfill, didReject, didProgress) {
          if (isDebugging() && arguments.length > 0 && typeof didFulfill !== "function" && typeof didReject !== "function") {
            var msg = ".then() only accepts functions but was passed: " + util.classString(didFulfill);
            if (arguments.length > 1) {
              msg += ", " + util.classString(didReject);
            }
            this._warn(msg);
          }
          return this._then(didFulfill, didReject, didProgress, undefined, undefined);
        };
        Promise.prototype.done = function (didFulfill, didReject, didProgress) {
          var promise = this._then(didFulfill, didReject, didProgress, undefined, undefined);
          promise._setIsFinal();
        };
        Promise.prototype.spread = function (didFulfill, didReject) {
          return this.all()._then(didFulfill, didReject, undefined, APPLY, undefined);
        };
        Promise.prototype.isCancellable = function () {
          return !this.isResolved() && this._cancellable();
        };
        Promise.prototype.toJSON = function () {
          var ret = {
            isFulfilled: false,
            isRejected: false,
            fulfillmentValue: undefined,
            rejectionReason: undefined
          };
          if (this.isFulfilled()) {
            ret.fulfillmentValue = this.value();
            ret.isFulfilled = true;
          } else if (this.isRejected()) {
            ret.rejectionReason = this.reason();
            ret.isRejected = true;
          }
          return ret;
        };
        Promise.prototype.all = function () {
          return new PromiseArray(this).promise();
        };
        Promise.prototype.error = function (fn) {
          return this.caught(util.originatesFromRejection, fn);
        };
        Promise.getNewLibraryCopy = module.exports;
        Promise.is = function (val) {
          return val instanceof Promise;
        };
        Promise.fromNode = function (fn) {
          var ret = new Promise(INTERNAL);
          var result = tryCatch(fn)(nodebackForPromise(ret));
          if (result === errorObj) {
            ret._rejectCallback(result.e, true, true);
          }
          return ret;
        };
        Promise.all = function (promises) {
          return new PromiseArray(promises).promise();
        };
        Promise.defer = Promise.pending = function () {
          var promise = new Promise(INTERNAL);
          return new PromiseResolver(promise);
        };
        Promise.cast = function (obj) {
          var ret = tryConvertToPromise(obj);
          if (!(ret instanceof Promise)) {
            var val = ret;
            ret = new Promise(INTERNAL);
            ret._fulfillUnchecked(val);
          }
          return ret;
        };
        Promise.resolve = Promise.fulfilled = Promise.cast;
        Promise.reject = Promise.rejected = function (reason) {
          var ret = new Promise(INTERNAL);
          ret._captureStackTrace();
          ret._rejectCallback(reason, true);
          return ret;
        };
        Promise.setScheduler = function (fn) {
          if (typeof fn !== "function") throw new TypeError("fn must be a function\n\n    See http://goo.gl/916lJJ\n");
          var prev = async._schedule;
          async._schedule = fn;
          return prev;
        };
        Promise.prototype._then = function (didFulfill, didReject, didProgress, receiver, internalData) {
          var haveInternalData = internalData !== undefined;
          var ret = haveInternalData ? internalData : new Promise(INTERNAL);
          if (!haveInternalData) {
            ret._propagateFrom(this, 4 | 1);
            ret._captureStackTrace();
          }
          var target = this._target();
          if (target !== this) {
            if (receiver === undefined) receiver = this._boundTo;
            if (!haveInternalData) ret._setIsMigrated();
          }
          var callbackIndex = target._addCallbacks(didFulfill, didReject, didProgress, ret, receiver, getDomain());
          if (target._isResolved() && !target._isSettlePromisesQueued()) {
            async.invoke(target._settlePromiseAtPostResolution, target, callbackIndex);
          }
          return ret;
        };
        Promise.prototype._settlePromiseAtPostResolution = function (index) {
          if (this._isRejectionUnhandled()) this._unsetRejectionIsUnhandled();
          this._settlePromiseAt(index);
        };
        Promise.prototype._length = function () {
          return this._bitField & 131071;
        };
        Promise.prototype._isFollowingOrFulfilledOrRejected = function () {
          return (this._bitField & 939524096) > 0;
        };
        Promise.prototype._isFollowing = function () {
          return (this._bitField & 536870912) === 536870912;
        };
        Promise.prototype._setLength = function (len) {
          this._bitField = this._bitField & -131072 | len & 131071;
        };
        Promise.prototype._setFulfilled = function () {
          this._bitField = this._bitField | 268435456;
        };
        Promise.prototype._setRejected = function () {
          this._bitField = this._bitField | 134217728;
        };
        Promise.prototype._setFollowing = function () {
          this._bitField = this._bitField | 536870912;
        };
        Promise.prototype._setIsFinal = function () {
          this._bitField = this._bitField | 33554432;
        };
        Promise.prototype._isFinal = function () {
          return (this._bitField & 33554432) > 0;
        };
        Promise.prototype._cancellable = function () {
          return (this._bitField & 67108864) > 0;
        };
        Promise.prototype._setCancellable = function () {
          this._bitField = this._bitField | 67108864;
        };
        Promise.prototype._unsetCancellable = function () {
          this._bitField = this._bitField & ~67108864;
        };
        Promise.prototype._setIsMigrated = function () {
          this._bitField = this._bitField | 4194304;
        };
        Promise.prototype._unsetIsMigrated = function () {
          this._bitField = this._bitField & ~4194304;
        };
        Promise.prototype._isMigrated = function () {
          return (this._bitField & 4194304) > 0;
        };
        Promise.prototype._receiverAt = function (index) {
          var ret = index === 0 ? this._receiver0 : this[index * 5 - 5 + 4];
          if (ret === UNDEFINED_BINDING) {
            return undefined;
          } else if (ret === undefined && this._isBound()) {
            return this._boundValue();
          }
          return ret;
        };
        Promise.prototype._promiseAt = function (index) {
          return index === 0 ? this._promise0 : this[index * 5 - 5 + 3];
        };
        Promise.prototype._fulfillmentHandlerAt = function (index) {
          return index === 0 ? this._fulfillmentHandler0 : this[index * 5 - 5 + 0];
        };
        Promise.prototype._rejectionHandlerAt = function (index) {
          return index === 0 ? this._rejectionHandler0 : this[index * 5 - 5 + 1];
        };
        Promise.prototype._boundValue = function () {
          var ret = this._boundTo;
          if (ret !== undefined) {
            if (ret instanceof Promise) {
              if (ret.isFulfilled()) {
                return ret.value();
              } else {
                return undefined;
              }
            }
          }
          return ret;
        };
        Promise.prototype._migrateCallbacks = function (follower, index) {
          var fulfill = follower._fulfillmentHandlerAt(index);
          var reject = follower._rejectionHandlerAt(index);
          var progress = follower._progressHandlerAt(index);
          var promise = follower._promiseAt(index);
          var receiver = follower._receiverAt(index);
          if (promise instanceof Promise) promise._setIsMigrated();
          if (receiver === undefined) receiver = UNDEFINED_BINDING;
          this._addCallbacks(fulfill, reject, progress, promise, receiver, null);
        };
        Promise.prototype._addCallbacks = function (fulfill, reject, progress, promise, receiver, domain) {
          var index = this._length();
          if (index >= 131071 - 5) {
            index = 0;
            this._setLength(0);
          }
          if (index === 0) {
            this._promise0 = promise;
            if (receiver !== undefined) this._receiver0 = receiver;
            if (typeof fulfill === "function" && !this._isCarryingStackTrace()) {
              this._fulfillmentHandler0 = domain === null ? fulfill : domain.bind(fulfill);
            }
            if (typeof reject === "function") {
              this._rejectionHandler0 = domain === null ? reject : domain.bind(reject);
            }
            if (typeof progress === "function") {
              this._progressHandler0 = domain === null ? progress : domain.bind(progress);
            }
          } else {
            var base = index * 5 - 5;
            this[base + 3] = promise;
            this[base + 4] = receiver;
            if (typeof fulfill === "function") {
              this[base + 0] = domain === null ? fulfill : domain.bind(fulfill);
            }
            if (typeof reject === "function") {
              this[base + 1] = domain === null ? reject : domain.bind(reject);
            }
            if (typeof progress === "function") {
              this[base + 2] = domain === null ? progress : domain.bind(progress);
            }
          }
          this._setLength(index + 1);
          return index;
        };
        Promise.prototype._setProxyHandlers = function (receiver, promiseSlotValue) {
          var index = this._length();
          if (index >= 131071 - 5) {
            index = 0;
            this._setLength(0);
          }
          if (index === 0) {
            this._promise0 = promiseSlotValue;
            this._receiver0 = receiver;
          } else {
            var base = index * 5 - 5;
            this[base + 3] = promiseSlotValue;
            this[base + 4] = receiver;
          }
          this._setLength(index + 1);
        };
        Promise.prototype._proxyPromiseArray = function (promiseArray, index) {
          this._setProxyHandlers(promiseArray, index);
        };
        Promise.prototype._resolveCallback = function (value, shouldBind) {
          if (this._isFollowingOrFulfilledOrRejected()) return;
          if (value === this) return this._rejectCallback(makeSelfResolutionError(), false, true);
          var maybePromise = tryConvertToPromise(value, this);
          if (!(maybePromise instanceof Promise)) return this._fulfill(value);
          var propagationFlags = 1 | (shouldBind ? 4 : 0);
          this._propagateFrom(maybePromise, propagationFlags);
          var promise = maybePromise._target();
          if (promise._isPending()) {
            var len = this._length();
            for (var i = 0; i < len; ++i) {
              promise._migrateCallbacks(this, i);
            }
            this._setFollowing();
            this._setLength(0);
            this._setFollowee(promise);
          } else if (promise._isFulfilled()) {
            this._fulfillUnchecked(promise._value());
          } else {
            this._rejectUnchecked(promise._reason(), promise._getCarriedStackTrace());
          }
        };
        Promise.prototype._rejectCallback = function (reason, synchronous, shouldNotMarkOriginatingFromRejection) {
          if (!shouldNotMarkOriginatingFromRejection) {
            util.markAsOriginatingFromRejection(reason);
          }
          var trace = util.ensureErrorObject(reason);
          var hasStack = trace === reason;
          this._attachExtraTrace(trace, synchronous ? hasStack : false);
          this._reject(reason, hasStack ? undefined : trace);
        };
        Promise.prototype._resolveFromResolver = function (resolver) {
          var promise = this;
          this._captureStackTrace();
          this._pushContext();
          var synchronous = true;
          var r = tryCatch(resolver)(function (value) {
            if (promise === null) return;
            promise._resolveCallback(value);
            promise = null;
          }, function (reason) {
            if (promise === null) return;
            promise._rejectCallback(reason, synchronous);
            promise = null;
          });
          synchronous = false;
          this._popContext();
          if (r !== undefined && r === errorObj && promise !== null) {
            promise._rejectCallback(r.e, true, true);
            promise = null;
          }
        };
        Promise.prototype._settlePromiseFromHandler = function (handler, receiver, value, promise) {
          if (promise._isRejected()) return;
          promise._pushContext();
          var x;
          if (receiver === APPLY && !this._isRejected()) {
            x = tryCatch(handler).apply(this._boundValue(), value);
          } else {
            x = tryCatch(handler).call(receiver, value);
          }
          promise._popContext();
          if (x === errorObj || x === promise || x === NEXT_FILTER) {
            var err = x === promise ? makeSelfResolutionError() : x.e;
            promise._rejectCallback(err, false, true);
          } else {
            promise._resolveCallback(x);
          }
        };
        Promise.prototype._target = function () {
          var ret = this;
          while (ret._isFollowing()) {
            ret = ret._followee();
          }
          return ret;
        };
        Promise.prototype._followee = function () {
          return this._rejectionHandler0;
        };
        Promise.prototype._setFollowee = function (promise) {
          this._rejectionHandler0 = promise;
        };
        Promise.prototype._cleanValues = function () {
          if (this._cancellable()) {
            this._cancellationParent = undefined;
          }
        };
        Promise.prototype._propagateFrom = function (parent, flags) {
          if ((flags & 1) > 0 && parent._cancellable()) {
            this._setCancellable();
            this._cancellationParent = parent;
          }
          if ((flags & 4) > 0 && parent._isBound()) {
            this._setBoundTo(parent._boundTo);
          }
        };
        Promise.prototype._fulfill = function (value) {
          if (this._isFollowingOrFulfilledOrRejected()) return;
          this._fulfillUnchecked(value);
        };
        Promise.prototype._reject = function (reason, carriedStackTrace) {
          if (this._isFollowingOrFulfilledOrRejected()) return;
          this._rejectUnchecked(reason, carriedStackTrace);
        };
        Promise.prototype._settlePromiseAt = function (index) {
          var promise = this._promiseAt(index);
          var isPromise = promise instanceof Promise;
          if (isPromise && promise._isMigrated()) {
            promise._unsetIsMigrated();
            return async.invoke(this._settlePromiseAt, this, index);
          }
          var handler = this._isFulfilled() ? this._fulfillmentHandlerAt(index) : this._rejectionHandlerAt(index);
          var carriedStackTrace = this._isCarryingStackTrace() ? this._getCarriedStackTrace() : undefined;
          var value = this._settledValue;
          var receiver = this._receiverAt(index);
          this._clearCallbackDataAtIndex(index);
          if (typeof handler === "function") {
            if (!isPromise) {
              handler.call(receiver, value, promise);
            } else {
              this._settlePromiseFromHandler(handler, receiver, value, promise);
            }
          } else if (receiver instanceof PromiseArray) {
            if (!receiver._isResolved()) {
              if (this._isFulfilled()) {
                receiver._promiseFulfilled(value, promise);
              } else {
                receiver._promiseRejected(value, promise);
              }
            }
          } else if (isPromise) {
            if (this._isFulfilled()) {
              promise._fulfill(value);
            } else {
              promise._reject(value, carriedStackTrace);
            }
          }
          if (index >= 4 && (index & 31) === 4) async.invokeLater(this._setLength, this, 0);
        };
        Promise.prototype._clearCallbackDataAtIndex = function (index) {
          if (index === 0) {
            if (!this._isCarryingStackTrace()) {
              this._fulfillmentHandler0 = undefined;
            }
            this._rejectionHandler0 = this._progressHandler0 = this._receiver0 = this._promise0 = undefined;
          } else {
            var base = index * 5 - 5;
            this[base + 3] = this[base + 4] = this[base + 0] = this[base + 1] = this[base + 2] = undefined;
          }
        };
        Promise.prototype._isSettlePromisesQueued = function () {
          return (this._bitField & -1073741824) === -1073741824;
        };
        Promise.prototype._setSettlePromisesQueued = function () {
          this._bitField = this._bitField | -1073741824;
        };
        Promise.prototype._unsetSettlePromisesQueued = function () {
          this._bitField = this._bitField & ~-1073741824;
        };
        Promise.prototype._queueSettlePromises = function () {
          async.settlePromises(this);
          this._setSettlePromisesQueued();
        };
        Promise.prototype._fulfillUnchecked = function (value) {
          if (value === this) {
            var err = makeSelfResolutionError();
            this._attachExtraTrace(err);
            return this._rejectUnchecked(err, undefined);
          }
          this._setFulfilled();
          this._settledValue = value;
          this._cleanValues();
          if (this._length() > 0) {
            this._queueSettlePromises();
          }
        };
        Promise.prototype._rejectUncheckedCheckError = function (reason) {
          var trace = util.ensureErrorObject(reason);
          this._rejectUnchecked(reason, trace === reason ? undefined : trace);
        };
        Promise.prototype._rejectUnchecked = function (reason, trace) {
          if (reason === this) {
            var err = makeSelfResolutionError();
            this._attachExtraTrace(err);
            return this._rejectUnchecked(err);
          }
          this._setRejected();
          this._settledValue = reason;
          this._cleanValues();
          if (this._isFinal()) {
            async.throwLater(function (e) {
              if ("stack" in e) {
                async.invokeFirst(CapturedTrace.unhandledRejection, undefined, e);
              }
              throw e;
            }, trace === undefined ? reason : trace);
            return;
          }
          if (trace !== undefined && trace !== reason) {
            this._setCarriedStackTrace(trace);
          }
          if (this._length() > 0) {
            this._queueSettlePromises();
          } else {
            this._ensurePossibleRejectionHandled();
          }
        };
        Promise.prototype._settlePromises = function () {
          this._unsetSettlePromisesQueued();
          var len = this._length();
          for (var i = 0; i < len; i++) {
            this._settlePromiseAt(i);
          }
        };
        util.notEnumerableProp(Promise, "_makeSelfResolutionError", makeSelfResolutionError);
        _dereq_("./progress.js")(Promise, PromiseArray);
        _dereq_("./method.js")(Promise, INTERNAL, tryConvertToPromise, apiRejection);
        _dereq_("./bind.js")(Promise, INTERNAL, tryConvertToPromise);
        _dereq_("./finally.js")(Promise, NEXT_FILTER, tryConvertToPromise);
        _dereq_("./direct_resolve.js")(Promise);
        _dereq_("./synchronous_inspection.js")(Promise);
        _dereq_("./join.js")(Promise, PromiseArray, tryConvertToPromise, INTERNAL);
        Promise.version = "2.11.0";
        Promise.Promise = Promise;
        _dereq_('./map.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL);
        _dereq_('./cancel.js')(Promise);
        _dereq_('./using.js')(Promise, apiRejection, tryConvertToPromise, createContext);
        _dereq_('./generators.js')(Promise, apiRejection, INTERNAL, tryConvertToPromise);
        _dereq_('./nodeify.js')(Promise);
        _dereq_('./call_get.js')(Promise);
        _dereq_('./props.js')(Promise, PromiseArray, tryConvertToPromise, apiRejection);
        _dereq_('./race.js')(Promise, INTERNAL, tryConvertToPromise, apiRejection);
        _dereq_('./reduce.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL);
        _dereq_('./settle.js')(Promise, PromiseArray);
        _dereq_('./some.js')(Promise, PromiseArray, apiRejection);
        _dereq_('./promisify.js')(Promise, INTERNAL);
        _dereq_('./any.js')(Promise);
        _dereq_('./each.js')(Promise, INTERNAL);
        _dereq_('./timers.js')(Promise, INTERNAL);
        _dereq_('./filter.js')(Promise, INTERNAL);
        util.toFastProperties(Promise);
        util.toFastProperties(Promise.prototype);
        function fillTypes(value) {
          var p = new Promise(INTERNAL);
          p._fulfillmentHandler0 = value;
          p._rejectionHandler0 = value;
          p._progressHandler0 = value;
          p._promise0 = value;
          p._receiver0 = value;
          p._settledValue = value;
        }
        // Complete slack tracking, opt out of field-type tracking and           
        // stabilize map                                                         
        fillTypes({
          a: 1
        });
        fillTypes({
          b: 2
        });
        fillTypes({
          c: 3
        });
        fillTypes(1);
        fillTypes(function () {});
        fillTypes(undefined);
        fillTypes(false);
        fillTypes(new Promise(INTERNAL));
        CapturedTrace.setBounds(async.firstLineError, util.lastLineError);
        return Promise;
      };
    }, {
      "./any.js": 1,
      "./async.js": 2,
      "./bind.js": 3,
      "./call_get.js": 5,
      "./cancel.js": 6,
      "./captured_trace.js": 7,
      "./catch_filter.js": 8,
      "./context.js": 9,
      "./debuggability.js": 10,
      "./direct_resolve.js": 11,
      "./each.js": 12,
      "./errors.js": 13,
      "./filter.js": 15,
      "./finally.js": 16,
      "./generators.js": 17,
      "./join.js": 18,
      "./map.js": 19,
      "./method.js": 20,
      "./nodeify.js": 21,
      "./progress.js": 22,
      "./promise_array.js": 24,
      "./promise_resolver.js": 25,
      "./promisify.js": 26,
      "./props.js": 27,
      "./race.js": 29,
      "./reduce.js": 30,
      "./settle.js": 32,
      "./some.js": 33,
      "./synchronous_inspection.js": 34,
      "./thenables.js": 35,
      "./timers.js": 36,
      "./using.js": 37,
      "./util.js": 38
    }],
    24: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, INTERNAL, tryConvertToPromise, apiRejection) {
        var util = _dereq_("./util.js");
        var isArray = util.isArray;
        function toResolutionValue(val) {
          switch (val) {
            case -2:
              return [];
            case -3:
              return {};
          }
        }
        function PromiseArray(values) {
          var promise = this._promise = new Promise(INTERNAL);
          var parent;
          if (values instanceof Promise) {
            parent = values;
            promise._propagateFrom(parent, 1 | 4);
          }
          this._values = values;
          this._length = 0;
          this._totalResolved = 0;
          this._init(undefined, -2);
        }
        PromiseArray.prototype.length = function () {
          return this._length;
        };
        PromiseArray.prototype.promise = function () {
          return this._promise;
        };
        PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
          var values = tryConvertToPromise(this._values, this._promise);
          if (values instanceof Promise) {
            values = values._target();
            this._values = values;
            if (values._isFulfilled()) {
              values = values._value();
              if (!isArray(values)) {
                var err = new Promise.TypeError("expecting an array, a promise or a thenable\n\n    See http://goo.gl/s8MMhc\n");
                this.__hardReject__(err);
                return;
              }
            } else if (values._isPending()) {
              values._then(init, this._reject, undefined, this, resolveValueIfEmpty);
              return;
            } else {
              this._reject(values._reason());
              return;
            }
          } else if (!isArray(values)) {
            this._promise._reject(apiRejection("expecting an array, a promise or a thenable\n\n    See http://goo.gl/s8MMhc\n")._reason());
            return;
          }
          if (values.length === 0) {
            if (resolveValueIfEmpty === -5) {
              this._resolveEmptyArray();
            } else {
              this._resolve(toResolutionValue(resolveValueIfEmpty));
            }
            return;
          }
          var len = this.getActualLength(values.length);
          this._length = len;
          this._values = this.shouldCopyValues() ? new Array(len) : this._values;
          var promise = this._promise;
          for (var i = 0; i < len; ++i) {
            var isResolved = this._isResolved();
            var maybePromise = tryConvertToPromise(values[i], promise);
            if (maybePromise instanceof Promise) {
              maybePromise = maybePromise._target();
              if (isResolved) {
                maybePromise._ignoreRejections();
              } else if (maybePromise._isPending()) {
                maybePromise._proxyPromiseArray(this, i);
              } else if (maybePromise._isFulfilled()) {
                this._promiseFulfilled(maybePromise._value(), i);
              } else {
                this._promiseRejected(maybePromise._reason(), i);
              }
            } else if (!isResolved) {
              this._promiseFulfilled(maybePromise, i);
            }
          }
        };
        PromiseArray.prototype._isResolved = function () {
          return this._values === null;
        };
        PromiseArray.prototype._resolve = function (value) {
          this._values = null;
          this._promise._fulfill(value);
        };
        PromiseArray.prototype.__hardReject__ = PromiseArray.prototype._reject = function (reason) {
          this._values = null;
          this._promise._rejectCallback(reason, false, true);
        };
        PromiseArray.prototype._promiseProgressed = function (progressValue, index) {
          this._promise._progress({
            index: index,
            value: progressValue
          });
        };
        PromiseArray.prototype._promiseFulfilled = function (value, index) {
          this._values[index] = value;
          var totalResolved = ++this._totalResolved;
          if (totalResolved >= this._length) {
            this._resolve(this._values);
          }
        };
        PromiseArray.prototype._promiseRejected = function (reason, index) {
          this._totalResolved++;
          this._reject(reason);
        };
        PromiseArray.prototype.shouldCopyValues = function () {
          return true;
        };
        PromiseArray.prototype.getActualLength = function (len) {
          return len;
        };
        return PromiseArray;
      };
    }, {
      "./util.js": 38
    }],
    25: [function (_dereq_, module, exports) {
      "use strict";

      var util = _dereq_("./util.js");
      var maybeWrapAsError = util.maybeWrapAsError;
      var errors = _dereq_("./errors.js");
      var TimeoutError = errors.TimeoutError;
      var OperationalError = errors.OperationalError;
      var haveGetters = util.haveGetters;
      var es5 = _dereq_("./es5.js");
      function isUntypedError(obj) {
        return obj instanceof Error && es5.getPrototypeOf(obj) === Error.prototype;
      }
      var rErrorKey = /^(?:name|message|stack|cause)$/;
      function wrapAsOperationalError(obj) {
        var ret;
        if (isUntypedError(obj)) {
          ret = new OperationalError(obj);
          ret.name = obj.name;
          ret.message = obj.message;
          ret.stack = obj.stack;
          var keys = es5.keys(obj);
          for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!rErrorKey.test(key)) {
              ret[key] = obj[key];
            }
          }
          return ret;
        }
        util.markAsOriginatingFromRejection(obj);
        return obj;
      }
      function nodebackForPromise(promise) {
        return function (err, value) {
          if (promise === null) return;
          if (err) {
            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
            promise._attachExtraTrace(wrapped);
            promise._reject(wrapped);
          } else if (arguments.length > 2) {
            var $_len = arguments.length;
            var args = new Array($_len - 1);
            for (var $_i = 1; $_i < $_len; ++$_i) {
              args[$_i - 1] = arguments[$_i];
            }
            promise._fulfill(args);
          } else {
            promise._fulfill(value);
          }
          promise = null;
        };
      }
      var PromiseResolver;
      if (!haveGetters) {
        PromiseResolver = function PromiseResolver(promise) {
          this.promise = promise;
          this.asCallback = nodebackForPromise(promise);
          this.callback = this.asCallback;
        };
      } else {
        PromiseResolver = function PromiseResolver(promise) {
          this.promise = promise;
        };
      }
      if (haveGetters) {
        var prop = {
          get: function get() {
            return nodebackForPromise(this.promise);
          }
        };
        es5.defineProperty(PromiseResolver.prototype, "asCallback", prop);
        es5.defineProperty(PromiseResolver.prototype, "callback", prop);
      }
      PromiseResolver._nodebackForPromise = nodebackForPromise;
      PromiseResolver.prototype.toString = function () {
        return "[object PromiseResolver]";
      };
      PromiseResolver.prototype.resolve = PromiseResolver.prototype.fulfill = function (value) {
        if (!(this instanceof PromiseResolver)) {
          throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\n\n    See http://goo.gl/sdkXL9\n");
        }
        this.promise._resolveCallback(value);
      };
      PromiseResolver.prototype.reject = function (reason) {
        if (!(this instanceof PromiseResolver)) {
          throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\n\n    See http://goo.gl/sdkXL9\n");
        }
        this.promise._rejectCallback(reason);
      };
      PromiseResolver.prototype.progress = function (value) {
        if (!(this instanceof PromiseResolver)) {
          throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\n\n    See http://goo.gl/sdkXL9\n");
        }
        this.promise._progress(value);
      };
      PromiseResolver.prototype.cancel = function (err) {
        this.promise.cancel(err);
      };
      PromiseResolver.prototype.timeout = function () {
        this.reject(new TimeoutError("timeout"));
      };
      PromiseResolver.prototype.isResolved = function () {
        return this.promise.isResolved();
      };
      PromiseResolver.prototype.toJSON = function () {
        return this.promise.toJSON();
      };
      module.exports = PromiseResolver;
    }, {
      "./errors.js": 13,
      "./es5.js": 14,
      "./util.js": 38
    }],
    26: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, INTERNAL) {
        var THIS = {};
        var util = _dereq_("./util.js");
        var nodebackForPromise = _dereq_("./promise_resolver.js")._nodebackForPromise;
        var withAppended = util.withAppended;
        var maybeWrapAsError = util.maybeWrapAsError;
        var canEvaluate = util.canEvaluate;
        var TypeError = _dereq_("./errors").TypeError;
        var defaultSuffix = "Async";
        var defaultPromisified = {
          __isPromisified__: true
        };
        var noCopyProps = ["arity", "length", "name", "arguments", "caller", "callee", "prototype", "__isPromisified__"];
        var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
        var defaultFilter = function defaultFilter(name) {
          return util.isIdentifier(name) && name.charAt(0) !== "_" && name !== "constructor";
        };
        function propsFilter(key) {
          return !noCopyPropsPattern.test(key);
        }
        function isPromisified(fn) {
          try {
            return fn.__isPromisified__ === true;
          } catch (e) {
            return false;
          }
        }
        function hasPromisified(obj, key, suffix) {
          var val = util.getDataPropertyOrDefault(obj, key + suffix, defaultPromisified);
          return val ? isPromisified(val) : false;
        }
        function checkValid(ret, suffix, suffixRegexp) {
          for (var i = 0; i < ret.length; i += 2) {
            var key = ret[i];
            if (suffixRegexp.test(key)) {
              var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
              for (var j = 0; j < ret.length; j += 2) {
                if (ret[j] === keyWithoutAsyncSuffix) {
                  throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See http://goo.gl/iWrZbw\n".replace("%s", suffix));
                }
              }
            }
          }
        }
        function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
          var keys = util.inheritedDataKeys(obj);
          var ret = [];
          for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            var value = obj[key];
            var passesDefaultFilter = filter === defaultFilter ? true : defaultFilter(key, value, obj);
            if (typeof value === "function" && !isPromisified(value) && !hasPromisified(obj, key, suffix) && filter(key, value, obj, passesDefaultFilter)) {
              ret.push(key, value);
            }
          }
          checkValid(ret, suffix, suffixRegexp);
          return ret;
        }
        var escapeIdentRegex = function escapeIdentRegex(str) {
          return str.replace(/([$])/, "\\$");
        };
        var makeNodePromisifiedEval;
        if (false) { var parameterCount, parameterDeclaration, argumentSequence, switchCaseArgumentOrder; }
        function makeNodePromisifiedClosure(callback, receiver, _, fn) {
          var defaultThis = function () {
            return this;
          }();
          var method = callback;
          if (typeof method === "string") {
            callback = fn;
          }
          function promisified() {
            var _receiver = receiver;
            if (receiver === THIS) _receiver = this;
            var promise = new Promise(INTERNAL);
            promise._captureStackTrace();
            var cb = typeof method === "string" && this !== defaultThis ? this[method] : callback;
            var fn = nodebackForPromise(promise);
            try {
              cb.apply(_receiver, withAppended(arguments, fn));
            } catch (e) {
              promise._rejectCallback(maybeWrapAsError(e), true, true);
            }
            return promise;
          }
          util.notEnumerableProp(promisified, "__isPromisified__", true);
          return promisified;
        }
        var makeNodePromisified = canEvaluate ? makeNodePromisifiedEval : makeNodePromisifiedClosure;
        function promisifyAll(obj, suffix, filter, promisifier) {
          var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
          var methods = promisifiableMethods(obj, suffix, suffixRegexp, filter);
          for (var i = 0, len = methods.length; i < len; i += 2) {
            var key = methods[i];
            var fn = methods[i + 1];
            var promisifiedKey = key + suffix;
            if (promisifier === makeNodePromisified) {
              obj[promisifiedKey] = makeNodePromisified(key, THIS, key, fn, suffix);
            } else {
              var promisified = promisifier(fn, function () {
                return makeNodePromisified(key, THIS, key, fn, suffix);
              });
              util.notEnumerableProp(promisified, "__isPromisified__", true);
              obj[promisifiedKey] = promisified;
            }
          }
          util.toFastProperties(obj);
          return obj;
        }
        function promisify(callback, receiver) {
          return makeNodePromisified(callback, receiver, undefined, callback);
        }
        Promise.promisify = function (fn, receiver) {
          if (typeof fn !== "function") {
            throw new TypeError("fn must be a function\n\n    See http://goo.gl/916lJJ\n");
          }
          if (isPromisified(fn)) {
            return fn;
          }
          var ret = promisify(fn, arguments.length < 2 ? THIS : receiver);
          util.copyDescriptors(fn, ret, propsFilter);
          return ret;
        };
        Promise.promisifyAll = function (target, options) {
          if (typeof target !== "function" && _typeof(target) !== "object") {
            throw new TypeError("the target of promisifyAll must be an object or a function\n\n    See http://goo.gl/9ITlV0\n");
          }
          options = Object(options);
          var suffix = options.suffix;
          if (typeof suffix !== "string") suffix = defaultSuffix;
          var filter = options.filter;
          if (typeof filter !== "function") filter = defaultFilter;
          var promisifier = options.promisifier;
          if (typeof promisifier !== "function") promisifier = makeNodePromisified;
          if (!util.isIdentifier(suffix)) {
            throw new RangeError("suffix must be a valid identifier\n\n    See http://goo.gl/8FZo5V\n");
          }
          var keys = util.inheritedDataKeys(target);
          for (var i = 0; i < keys.length; ++i) {
            var value = target[keys[i]];
            if (keys[i] !== "constructor" && util.isClass(value)) {
              promisifyAll(value.prototype, suffix, filter, promisifier);
              promisifyAll(value, suffix, filter, promisifier);
            }
          }
          return promisifyAll(target, suffix, filter, promisifier);
        };
      };
    }, {
      "./errors": 13,
      "./promise_resolver.js": 25,
      "./util.js": 38
    }],
    27: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, PromiseArray, tryConvertToPromise, apiRejection) {
        var util = _dereq_("./util.js");
        var isObject = util.isObject;
        var es5 = _dereq_("./es5.js");
        function PropertiesPromiseArray(obj) {
          var keys = es5.keys(obj);
          var len = keys.length;
          var values = new Array(len * 2);
          for (var i = 0; i < len; ++i) {
            var key = keys[i];
            values[i] = obj[key];
            values[i + len] = key;
          }
          this.constructor$(values);
        }
        util.inherits(PropertiesPromiseArray, PromiseArray);
        PropertiesPromiseArray.prototype._init = function () {
          this._init$(undefined, -3);
        };
        PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
          this._values[index] = value;
          var totalResolved = ++this._totalResolved;
          if (totalResolved >= this._length) {
            var val = {};
            var keyOffset = this.length();
            for (var i = 0, len = this.length(); i < len; ++i) {
              val[this._values[i + keyOffset]] = this._values[i];
            }
            this._resolve(val);
          }
        };
        PropertiesPromiseArray.prototype._promiseProgressed = function (value, index) {
          this._promise._progress({
            key: this._values[index + this.length()],
            value: value
          });
        };
        PropertiesPromiseArray.prototype.shouldCopyValues = function () {
          return false;
        };
        PropertiesPromiseArray.prototype.getActualLength = function (len) {
          return len >> 1;
        };
        function props(promises) {
          var ret;
          var castValue = tryConvertToPromise(promises);
          if (!isObject(castValue)) {
            return apiRejection("cannot await properties of a non-object\n\n    See http://goo.gl/OsFKC8\n");
          } else if (castValue instanceof Promise) {
            ret = castValue._then(Promise.props, undefined, undefined, undefined, undefined);
          } else {
            ret = new PropertiesPromiseArray(castValue).promise();
          }
          if (castValue instanceof Promise) {
            ret._propagateFrom(castValue, 4);
          }
          return ret;
        }
        Promise.prototype.props = function () {
          return props(this);
        };
        Promise.props = function (promises) {
          return props(promises);
        };
      };
    }, {
      "./es5.js": 14,
      "./util.js": 38
    }],
    28: [function (_dereq_, module, exports) {
      "use strict";

      function arrayMove(src, srcIndex, dst, dstIndex, len) {
        for (var j = 0; j < len; ++j) {
          dst[j + dstIndex] = src[j + srcIndex];
          src[j + srcIndex] = void 0;
        }
      }
      function Queue(capacity) {
        this._capacity = capacity;
        this._length = 0;
        this._front = 0;
      }
      Queue.prototype._willBeOverCapacity = function (size) {
        return this._capacity < size;
      };
      Queue.prototype._pushOne = function (arg) {
        var length = this.length();
        this._checkCapacity(length + 1);
        var i = this._front + length & this._capacity - 1;
        this[i] = arg;
        this._length = length + 1;
      };
      Queue.prototype._unshiftOne = function (value) {
        var capacity = this._capacity;
        this._checkCapacity(this.length() + 1);
        var front = this._front;
        var i = (front - 1 & capacity - 1 ^ capacity) - capacity;
        this[i] = value;
        this._front = i;
        this._length = this.length() + 1;
      };
      Queue.prototype.unshift = function (fn, receiver, arg) {
        this._unshiftOne(arg);
        this._unshiftOne(receiver);
        this._unshiftOne(fn);
      };
      Queue.prototype.push = function (fn, receiver, arg) {
        var length = this.length() + 3;
        if (this._willBeOverCapacity(length)) {
          this._pushOne(fn);
          this._pushOne(receiver);
          this._pushOne(arg);
          return;
        }
        var j = this._front + length - 3;
        this._checkCapacity(length);
        var wrapMask = this._capacity - 1;
        this[j + 0 & wrapMask] = fn;
        this[j + 1 & wrapMask] = receiver;
        this[j + 2 & wrapMask] = arg;
        this._length = length;
      };
      Queue.prototype.shift = function () {
        var front = this._front,
          ret = this[front];
        this[front] = undefined;
        this._front = front + 1 & this._capacity - 1;
        this._length--;
        return ret;
      };
      Queue.prototype.length = function () {
        return this._length;
      };
      Queue.prototype._checkCapacity = function (size) {
        if (this._capacity < size) {
          this._resizeTo(this._capacity << 1);
        }
      };
      Queue.prototype._resizeTo = function (capacity) {
        var oldCapacity = this._capacity;
        this._capacity = capacity;
        var front = this._front;
        var length = this._length;
        var moveItemsCount = front + length & oldCapacity - 1;
        arrayMove(this, 0, this, oldCapacity, moveItemsCount);
      };
      module.exports = Queue;
    }, {}],
    29: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, INTERNAL, tryConvertToPromise, apiRejection) {
        var isArray = _dereq_("./util.js").isArray;
        var raceLater = function raceLater(promise) {
          return promise.then(function (array) {
            return race(array, promise);
          });
        };
        function race(promises, parent) {
          var maybePromise = tryConvertToPromise(promises);
          if (maybePromise instanceof Promise) {
            return raceLater(maybePromise);
          } else if (!isArray(promises)) {
            return apiRejection("expecting an array, a promise or a thenable\n\n    See http://goo.gl/s8MMhc\n");
          }
          var ret = new Promise(INTERNAL);
          if (parent !== undefined) {
            ret._propagateFrom(parent, 4 | 1);
          }
          var fulfill = ret._fulfill;
          var reject = ret._reject;
          for (var i = 0, len = promises.length; i < len; ++i) {
            var val = promises[i];
            if (val === undefined && !(i in promises)) {
              continue;
            }
            Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
          }
          return ret;
        }
        Promise.race = function (promises) {
          return race(promises, undefined);
        };
        Promise.prototype.race = function () {
          return race(this, undefined);
        };
      };
    }, {
      "./util.js": 38
    }],
    30: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL) {
        var getDomain = Promise._getDomain;
        var async = _dereq_("./async.js");
        var util = _dereq_("./util.js");
        var tryCatch = util.tryCatch;
        var errorObj = util.errorObj;
        function ReductionPromiseArray(promises, fn, accum, _each) {
          this.constructor$(promises);
          this._promise._captureStackTrace();
          this._preservedValues = _each === INTERNAL ? [] : null;
          this._zerothIsAccum = accum === undefined;
          this._gotAccum = false;
          this._reducingIndex = this._zerothIsAccum ? 1 : 0;
          this._valuesPhase = undefined;
          var maybePromise = tryConvertToPromise(accum, this._promise);
          var rejected = false;
          var isPromise = maybePromise instanceof Promise;
          if (isPromise) {
            maybePromise = maybePromise._target();
            if (maybePromise._isPending()) {
              maybePromise._proxyPromiseArray(this, -1);
            } else if (maybePromise._isFulfilled()) {
              accum = maybePromise._value();
              this._gotAccum = true;
            } else {
              this._reject(maybePromise._reason());
              rejected = true;
            }
          }
          if (!(isPromise || this._zerothIsAccum)) this._gotAccum = true;
          var domain = getDomain();
          this._callback = domain === null ? fn : domain.bind(fn);
          this._accum = accum;
          if (!rejected) async.invoke(init, this, undefined);
        }
        function init() {
          this._init$(undefined, -5);
        }
        util.inherits(ReductionPromiseArray, PromiseArray);
        ReductionPromiseArray.prototype._init = function () {};
        ReductionPromiseArray.prototype._resolveEmptyArray = function () {
          if (this._gotAccum || this._zerothIsAccum) {
            this._resolve(this._preservedValues !== null ? [] : this._accum);
          }
        };
        ReductionPromiseArray.prototype._promiseFulfilled = function (value, index) {
          var values = this._values;
          values[index] = value;
          var length = this.length();
          var preservedValues = this._preservedValues;
          var isEach = preservedValues !== null;
          var gotAccum = this._gotAccum;
          var valuesPhase = this._valuesPhase;
          var valuesPhaseIndex;
          if (!valuesPhase) {
            valuesPhase = this._valuesPhase = new Array(length);
            for (valuesPhaseIndex = 0; valuesPhaseIndex < length; ++valuesPhaseIndex) {
              valuesPhase[valuesPhaseIndex] = 0;
            }
          }
          valuesPhaseIndex = valuesPhase[index];
          if (index === 0 && this._zerothIsAccum) {
            this._accum = value;
            this._gotAccum = gotAccum = true;
            valuesPhase[index] = valuesPhaseIndex === 0 ? 1 : 2;
          } else if (index === -1) {
            this._accum = value;
            this._gotAccum = gotAccum = true;
          } else {
            if (valuesPhaseIndex === 0) {
              valuesPhase[index] = 1;
            } else {
              valuesPhase[index] = 2;
              this._accum = value;
            }
          }
          if (!gotAccum) return;
          var callback = this._callback;
          var receiver = this._promise._boundValue();
          var ret;
          for (var i = this._reducingIndex; i < length; ++i) {
            valuesPhaseIndex = valuesPhase[i];
            if (valuesPhaseIndex === 2) {
              this._reducingIndex = i + 1;
              continue;
            }
            if (valuesPhaseIndex !== 1) return;
            value = values[i];
            this._promise._pushContext();
            if (isEach) {
              preservedValues.push(value);
              ret = tryCatch(callback).call(receiver, value, i, length);
            } else {
              ret = tryCatch(callback).call(receiver, this._accum, value, i, length);
            }
            this._promise._popContext();
            if (ret === errorObj) return this._reject(ret.e);
            var maybePromise = tryConvertToPromise(ret, this._promise);
            if (maybePromise instanceof Promise) {
              maybePromise = maybePromise._target();
              if (maybePromise._isPending()) {
                valuesPhase[i] = 4;
                return maybePromise._proxyPromiseArray(this, i);
              } else if (maybePromise._isFulfilled()) {
                ret = maybePromise._value();
              } else {
                return this._reject(maybePromise._reason());
              }
            }
            this._reducingIndex = i + 1;
            this._accum = ret;
          }
          this._resolve(isEach ? preservedValues : this._accum);
        };
        function reduce(promises, fn, initialValue, _each) {
          if (typeof fn !== "function") return apiRejection("fn must be a function\n\n    See http://goo.gl/916lJJ\n");
          var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
          return array.promise();
        }
        Promise.prototype.reduce = function (fn, initialValue) {
          return reduce(this, fn, initialValue, null);
        };
        Promise.reduce = function (promises, fn, initialValue, _each) {
          return reduce(promises, fn, initialValue, _each);
        };
      };
    }, {
      "./async.js": 2,
      "./util.js": 38
    }],
    31: [function (_dereq_, module, exports) {
      "use strict";

      var schedule;
      var util = _dereq_("./util");
      var noAsyncScheduler = function noAsyncScheduler() {
        throw new Error("No async scheduler available\n\n    See http://goo.gl/m3OTXk\n");
      };
      if (util.isNode && typeof MutationObserver === "undefined") {
        var GlobalSetImmediate = __webpack_require__.g.setImmediate;
        var ProcessNextTick = process.nextTick;
        schedule = util.isRecentNode ? function (fn) {
          GlobalSetImmediate.call(__webpack_require__.g, fn);
        } : function (fn) {
          ProcessNextTick.call(process, fn);
        };
      } else if (typeof MutationObserver !== "undefined" && !(typeof window !== "undefined" && window.navigator && window.navigator.standalone)) {
        schedule = function schedule(fn) {
          var div = document.createElement("div");
          var observer = new MutationObserver(fn);
          observer.observe(div, {
            attributes: true
          });
          return function () {
            div.classList.toggle("foo");
          };
        };
        schedule.isStatic = true;
      } else if (typeof setImmediate !== "undefined") {
        schedule = function schedule(fn) {
          setImmediate(fn);
        };
      } else if (typeof setTimeout !== "undefined") {
        schedule = function schedule(fn) {
          setTimeout(fn, 0);
        };
      } else {
        schedule = noAsyncScheduler;
      }
      module.exports = schedule;
    }, {
      "./util": 38
    }],
    32: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, PromiseArray) {
        var PromiseInspection = Promise.PromiseInspection;
        var util = _dereq_("./util.js");
        function SettledPromiseArray(values) {
          this.constructor$(values);
        }
        util.inherits(SettledPromiseArray, PromiseArray);
        SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
          this._values[index] = inspection;
          var totalResolved = ++this._totalResolved;
          if (totalResolved >= this._length) {
            this._resolve(this._values);
          }
        };
        SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
          var ret = new PromiseInspection();
          ret._bitField = 268435456;
          ret._settledValue = value;
          this._promiseResolved(index, ret);
        };
        SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
          var ret = new PromiseInspection();
          ret._bitField = 134217728;
          ret._settledValue = reason;
          this._promiseResolved(index, ret);
        };
        Promise.settle = function (promises) {
          return new SettledPromiseArray(promises).promise();
        };
        Promise.prototype.settle = function () {
          return new SettledPromiseArray(this).promise();
        };
      };
    }, {
      "./util.js": 38
    }],
    33: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, PromiseArray, apiRejection) {
        var util = _dereq_("./util.js");
        var RangeError = _dereq_("./errors.js").RangeError;
        var AggregateError = _dereq_("./errors.js").AggregateError;
        var isArray = util.isArray;
        function SomePromiseArray(values) {
          this.constructor$(values);
          this._howMany = 0;
          this._unwrap = false;
          this._initialized = false;
        }
        util.inherits(SomePromiseArray, PromiseArray);
        SomePromiseArray.prototype._init = function () {
          if (!this._initialized) {
            return;
          }
          if (this._howMany === 0) {
            this._resolve([]);
            return;
          }
          this._init$(undefined, -5);
          var isArrayResolved = isArray(this._values);
          if (!this._isResolved() && isArrayResolved && this._howMany > this._canPossiblyFulfill()) {
            this._reject(this._getRangeError(this.length()));
          }
        };
        SomePromiseArray.prototype.init = function () {
          this._initialized = true;
          this._init();
        };
        SomePromiseArray.prototype.setUnwrap = function () {
          this._unwrap = true;
        };
        SomePromiseArray.prototype.howMany = function () {
          return this._howMany;
        };
        SomePromiseArray.prototype.setHowMany = function (count) {
          this._howMany = count;
        };
        SomePromiseArray.prototype._promiseFulfilled = function (value) {
          this._addFulfilled(value);
          if (this._fulfilled() === this.howMany()) {
            this._values.length = this.howMany();
            if (this.howMany() === 1 && this._unwrap) {
              this._resolve(this._values[0]);
            } else {
              this._resolve(this._values);
            }
          }
        };
        SomePromiseArray.prototype._promiseRejected = function (reason) {
          this._addRejected(reason);
          if (this.howMany() > this._canPossiblyFulfill()) {
            var e = new AggregateError();
            for (var i = this.length(); i < this._values.length; ++i) {
              e.push(this._values[i]);
            }
            this._reject(e);
          }
        };
        SomePromiseArray.prototype._fulfilled = function () {
          return this._totalResolved;
        };
        SomePromiseArray.prototype._rejected = function () {
          return this._values.length - this.length();
        };
        SomePromiseArray.prototype._addRejected = function (reason) {
          this._values.push(reason);
        };
        SomePromiseArray.prototype._addFulfilled = function (value) {
          this._values[this._totalResolved++] = value;
        };
        SomePromiseArray.prototype._canPossiblyFulfill = function () {
          return this.length() - this._rejected();
        };
        SomePromiseArray.prototype._getRangeError = function (count) {
          var message = "Input array must contain at least " + this._howMany + " items but contains only " + count + " items";
          return new RangeError(message);
        };
        SomePromiseArray.prototype._resolveEmptyArray = function () {
          this._reject(this._getRangeError(0));
        };
        function some(promises, howMany) {
          if ((howMany | 0) !== howMany || howMany < 0) {
            return apiRejection("expecting a positive integer\n\n    See http://goo.gl/1wAmHx\n");
          }
          var ret = new SomePromiseArray(promises);
          var promise = ret.promise();
          ret.setHowMany(howMany);
          ret.init();
          return promise;
        }
        Promise.some = function (promises, howMany) {
          return some(promises, howMany);
        };
        Promise.prototype.some = function (howMany) {
          return some(this, howMany);
        };
        Promise._SomePromiseArray = SomePromiseArray;
      };
    }, {
      "./errors.js": 13,
      "./util.js": 38
    }],
    34: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise) {
        function PromiseInspection(promise) {
          if (promise !== undefined) {
            promise = promise._target();
            this._bitField = promise._bitField;
            this._settledValue = promise._settledValue;
          } else {
            this._bitField = 0;
            this._settledValue = undefined;
          }
        }
        PromiseInspection.prototype.value = function () {
          if (!this.isFulfilled()) {
            throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/hc1DLj\n");
          }
          return this._settledValue;
        };
        PromiseInspection.prototype.error = PromiseInspection.prototype.reason = function () {
          if (!this.isRejected()) {
            throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/hPuiwB\n");
          }
          return this._settledValue;
        };
        PromiseInspection.prototype.isFulfilled = Promise.prototype._isFulfilled = function () {
          return (this._bitField & 268435456) > 0;
        };
        PromiseInspection.prototype.isRejected = Promise.prototype._isRejected = function () {
          return (this._bitField & 134217728) > 0;
        };
        PromiseInspection.prototype.isPending = Promise.prototype._isPending = function () {
          return (this._bitField & 402653184) === 0;
        };
        PromiseInspection.prototype.isResolved = Promise.prototype._isResolved = function () {
          return (this._bitField & 402653184) > 0;
        };
        Promise.prototype.isPending = function () {
          return this._target()._isPending();
        };
        Promise.prototype.isRejected = function () {
          return this._target()._isRejected();
        };
        Promise.prototype.isFulfilled = function () {
          return this._target()._isFulfilled();
        };
        Promise.prototype.isResolved = function () {
          return this._target()._isResolved();
        };
        Promise.prototype._value = function () {
          return this._settledValue;
        };
        Promise.prototype._reason = function () {
          this._unsetRejectionIsUnhandled();
          return this._settledValue;
        };
        Promise.prototype.value = function () {
          var target = this._target();
          if (!target.isFulfilled()) {
            throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/hc1DLj\n");
          }
          return target._settledValue;
        };
        Promise.prototype.reason = function () {
          var target = this._target();
          if (!target.isRejected()) {
            throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/hPuiwB\n");
          }
          target._unsetRejectionIsUnhandled();
          return target._settledValue;
        };
        Promise.PromiseInspection = PromiseInspection;
      };
    }, {}],
    35: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, INTERNAL) {
        var util = _dereq_("./util.js");
        var errorObj = util.errorObj;
        var isObject = util.isObject;
        function tryConvertToPromise(obj, context) {
          if (isObject(obj)) {
            if (obj instanceof Promise) {
              return obj;
            } else if (isAnyBluebirdPromise(obj)) {
              var ret = new Promise(INTERNAL);
              obj._then(ret._fulfillUnchecked, ret._rejectUncheckedCheckError, ret._progressUnchecked, ret, null);
              return ret;
            }
            var then = util.tryCatch(getThen)(obj);
            if (then === errorObj) {
              if (context) context._pushContext();
              var ret = Promise.reject(then.e);
              if (context) context._popContext();
              return ret;
            } else if (typeof then === "function") {
              return doThenable(obj, then, context);
            }
          }
          return obj;
        }
        function getThen(obj) {
          return obj.then;
        }
        var hasProp = {}.hasOwnProperty;
        function isAnyBluebirdPromise(obj) {
          return hasProp.call(obj, "_promise0");
        }
        function doThenable(x, then, context) {
          var promise = new Promise(INTERNAL);
          var ret = promise;
          if (context) context._pushContext();
          promise._captureStackTrace();
          if (context) context._popContext();
          var synchronous = true;
          var result = util.tryCatch(then).call(x, resolveFromThenable, rejectFromThenable, progressFromThenable);
          synchronous = false;
          if (promise && result === errorObj) {
            promise._rejectCallback(result.e, true, true);
            promise = null;
          }
          function resolveFromThenable(value) {
            if (!promise) return;
            promise._resolveCallback(value);
            promise = null;
          }
          function rejectFromThenable(reason) {
            if (!promise) return;
            promise._rejectCallback(reason, synchronous, true);
            promise = null;
          }
          function progressFromThenable(value) {
            if (!promise) return;
            if (typeof promise._progress === "function") {
              promise._progress(value);
            }
          }
          return ret;
        }
        return tryConvertToPromise;
      };
    }, {
      "./util.js": 38
    }],
    36: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, INTERNAL) {
        var util = _dereq_("./util.js");
        var TimeoutError = Promise.TimeoutError;
        var afterTimeout = function afterTimeout(promise, message) {
          if (!promise.isPending()) return;
          var err;
          if (!util.isPrimitive(message) && message instanceof Error) {
            err = message;
          } else {
            if (typeof message !== "string") {
              message = "operation timed out";
            }
            err = new TimeoutError(message);
          }
          util.markAsOriginatingFromRejection(err);
          promise._attachExtraTrace(err);
          promise._cancel(err);
        };
        var afterValue = function afterValue(value) {
          return delay(+this).thenReturn(value);
        };
        var delay = Promise.delay = function (value, ms) {
          if (ms === undefined) {
            ms = value;
            value = undefined;
            var ret = new Promise(INTERNAL);
            setTimeout(function () {
              ret._fulfill();
            }, ms);
            return ret;
          }
          ms = +ms;
          return Promise.resolve(value)._then(afterValue, null, null, ms, undefined);
        };
        Promise.prototype.delay = function (ms) {
          return delay(this, ms);
        };
        function successClear(value) {
          var handle = this;
          if (handle instanceof Number) handle = +handle;
          clearTimeout(handle);
          return value;
        }
        function failureClear(reason) {
          var handle = this;
          if (handle instanceof Number) handle = +handle;
          clearTimeout(handle);
          throw reason;
        }
        Promise.prototype.timeout = function (ms, message) {
          ms = +ms;
          var ret = this.then().cancellable();
          ret._cancellationParent = this;
          var handle = setTimeout(function timeoutTimeout() {
            afterTimeout(ret, message);
          }, ms);
          return ret._then(successClear, failureClear, undefined, handle, undefined);
        };
      };
    }, {
      "./util.js": 38
    }],
    37: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (Promise, apiRejection, tryConvertToPromise, createContext) {
        var TypeError = _dereq_("./errors.js").TypeError;
        var inherits = _dereq_("./util.js").inherits;
        var PromiseInspection = Promise.PromiseInspection;
        function inspectionMapper(inspections) {
          var len = inspections.length;
          for (var i = 0; i < len; ++i) {
            var inspection = inspections[i];
            if (inspection.isRejected()) {
              return Promise.reject(inspection.error());
            }
            inspections[i] = inspection._settledValue;
          }
          return inspections;
        }
        function thrower(e) {
          setTimeout(function () {
            throw e;
          }, 0);
        }
        function castPreservingDisposable(thenable) {
          var maybePromise = tryConvertToPromise(thenable);
          if (maybePromise !== thenable && typeof thenable._isDisposable === "function" && typeof thenable._getDisposer === "function" && thenable._isDisposable()) {
            maybePromise._setDisposable(thenable._getDisposer());
          }
          return maybePromise;
        }
        function dispose(resources, inspection) {
          var i = 0;
          var len = resources.length;
          var ret = Promise.defer();
          function iterator() {
            if (i >= len) return ret.resolve();
            var maybePromise = castPreservingDisposable(resources[i++]);
            if (maybePromise instanceof Promise && maybePromise._isDisposable()) {
              try {
                maybePromise = tryConvertToPromise(maybePromise._getDisposer().tryDispose(inspection), resources.promise);
              } catch (e) {
                return thrower(e);
              }
              if (maybePromise instanceof Promise) {
                return maybePromise._then(iterator, thrower, null, null, null);
              }
            }
            iterator();
          }
          iterator();
          return ret.promise;
        }
        function disposerSuccess(value) {
          var inspection = new PromiseInspection();
          inspection._settledValue = value;
          inspection._bitField = 268435456;
          return dispose(this, inspection).thenReturn(value);
        }
        function disposerFail(reason) {
          var inspection = new PromiseInspection();
          inspection._settledValue = reason;
          inspection._bitField = 134217728;
          return dispose(this, inspection).thenThrow(reason);
        }
        function Disposer(data, promise, context) {
          this._data = data;
          this._promise = promise;
          this._context = context;
        }
        Disposer.prototype.data = function () {
          return this._data;
        };
        Disposer.prototype.promise = function () {
          return this._promise;
        };
        Disposer.prototype.resource = function () {
          if (this.promise().isFulfilled()) {
            return this.promise().value();
          }
          return null;
        };
        Disposer.prototype.tryDispose = function (inspection) {
          var resource = this.resource();
          var context = this._context;
          if (context !== undefined) context._pushContext();
          var ret = resource !== null ? this.doDispose(resource, inspection) : null;
          if (context !== undefined) context._popContext();
          this._promise._unsetDisposable();
          this._data = null;
          return ret;
        };
        Disposer.isDisposer = function (d) {
          return d != null && typeof d.resource === "function" && typeof d.tryDispose === "function";
        };
        function FunctionDisposer(fn, promise, context) {
          this.constructor$(fn, promise, context);
        }
        inherits(FunctionDisposer, Disposer);
        FunctionDisposer.prototype.doDispose = function (resource, inspection) {
          var fn = this.data();
          return fn.call(resource, resource, inspection);
        };
        function maybeUnwrapDisposer(value) {
          if (Disposer.isDisposer(value)) {
            this.resources[this.index]._setDisposable(value);
            return value.promise();
          }
          return value;
        }
        Promise.using = function () {
          var len = arguments.length;
          if (len < 2) return apiRejection("you must pass at least 2 arguments to Promise.using");
          var fn = arguments[len - 1];
          if (typeof fn !== "function") return apiRejection("fn must be a function\n\n    See http://goo.gl/916lJJ\n");
          var input;
          var spreadArgs = true;
          if (len === 2 && Array.isArray(arguments[0])) {
            input = arguments[0];
            len = input.length;
            spreadArgs = false;
          } else {
            input = arguments;
            len--;
          }
          var resources = new Array(len);
          for (var i = 0; i < len; ++i) {
            var resource = input[i];
            if (Disposer.isDisposer(resource)) {
              var disposer = resource;
              resource = resource.promise();
              resource._setDisposable(disposer);
            } else {
              var maybePromise = tryConvertToPromise(resource);
              if (maybePromise instanceof Promise) {
                resource = maybePromise._then(maybeUnwrapDisposer, null, null, {
                  resources: resources,
                  index: i
                }, undefined);
              }
            }
            resources[i] = resource;
          }
          var promise = Promise.settle(resources).then(inspectionMapper).then(function (vals) {
            promise._pushContext();
            var ret;
            try {
              ret = spreadArgs ? fn.apply(undefined, vals) : fn.call(undefined, vals);
            } finally {
              promise._popContext();
            }
            return ret;
          })._then(disposerSuccess, disposerFail, undefined, resources, undefined);
          resources.promise = promise;
          return promise;
        };
        Promise.prototype._setDisposable = function (disposer) {
          this._bitField = this._bitField | 262144;
          this._disposer = disposer;
        };
        Promise.prototype._isDisposable = function () {
          return (this._bitField & 262144) > 0;
        };
        Promise.prototype._getDisposer = function () {
          return this._disposer;
        };
        Promise.prototype._unsetDisposable = function () {
          this._bitField = this._bitField & ~262144;
          this._disposer = undefined;
        };
        Promise.prototype.disposer = function (fn) {
          if (typeof fn === "function") {
            return new FunctionDisposer(fn, this, createContext());
          }
          throw new TypeError();
        };
      };
    }, {
      "./errors.js": 13,
      "./util.js": 38
    }],
    38: [function (_dereq_, module, exports) {
      "use strict";

      var es5 = _dereq_("./es5.js");
      var canEvaluate = typeof navigator == "undefined";
      var haveGetters = function () {
        try {
          var o = {};
          es5.defineProperty(o, "f", {
            get: function get() {
              return 3;
            }
          });
          return o.f === 3;
        } catch (e) {
          return false;
        }
      }();
      var errorObj = {
        e: {}
      };
      var tryCatchTarget;
      function tryCatcher() {
        try {
          var target = tryCatchTarget;
          tryCatchTarget = null;
          return target.apply(this, arguments);
        } catch (e) {
          errorObj.e = e;
          return errorObj;
        }
      }
      function tryCatch(fn) {
        tryCatchTarget = fn;
        return tryCatcher;
      }
      var inherits = function inherits(Child, Parent) {
        var hasProp = {}.hasOwnProperty;
        function T() {
          this.constructor = Child;
          this.constructor$ = Parent;
          for (var propertyName in Parent.prototype) {
            if (hasProp.call(Parent.prototype, propertyName) && propertyName.charAt(propertyName.length - 1) !== "$") {
              this[propertyName + "$"] = Parent.prototype[propertyName];
            }
          }
        }
        T.prototype = Parent.prototype;
        Child.prototype = new T();
        return Child.prototype;
      };
      function isPrimitive(val) {
        return val == null || val === true || val === false || typeof val === "string" || typeof val === "number";
      }
      function isObject(value) {
        return !isPrimitive(value);
      }
      function maybeWrapAsError(maybeError) {
        if (!isPrimitive(maybeError)) return maybeError;
        return new Error(safeToString(maybeError));
      }
      function withAppended(target, appendee) {
        var len = target.length;
        var ret = new Array(len + 1);
        var i;
        for (i = 0; i < len; ++i) {
          ret[i] = target[i];
        }
        ret[i] = appendee;
        return ret;
      }
      function getDataPropertyOrDefault(obj, key, defaultValue) {
        if (es5.isES5) {
          var desc = Object.getOwnPropertyDescriptor(obj, key);
          if (desc != null) {
            return desc.get == null && desc.set == null ? desc.value : defaultValue;
          }
        } else {
          return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
        }
      }
      function notEnumerableProp(obj, name, value) {
        if (isPrimitive(obj)) return obj;
        var descriptor = {
          value: value,
          configurable: true,
          enumerable: false,
          writable: true
        };
        es5.defineProperty(obj, name, descriptor);
        return obj;
      }
      function thrower(r) {
        throw r;
      }
      var inheritedDataKeys = function () {
        var excludedPrototypes = [Array.prototype, Object.prototype, Function.prototype];
        var isExcludedProto = function isExcludedProto(val) {
          for (var i = 0; i < excludedPrototypes.length; ++i) {
            if (excludedPrototypes[i] === val) {
              return true;
            }
          }
          return false;
        };
        if (es5.isES5) {
          var getKeys = Object.getOwnPropertyNames;
          return function (obj) {
            var ret = [];
            var visitedKeys = Object.create(null);
            while (obj != null && !isExcludedProto(obj)) {
              var keys;
              try {
                keys = getKeys(obj);
              } catch (e) {
                return ret;
              }
              for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (visitedKeys[key]) continue;
                visitedKeys[key] = true;
                var desc = Object.getOwnPropertyDescriptor(obj, key);
                if (desc != null && desc.get == null && desc.set == null) {
                  ret.push(key);
                }
              }
              obj = es5.getPrototypeOf(obj);
            }
            return ret;
          };
        } else {
          var hasProp = {}.hasOwnProperty;
          return function (obj) {
            if (isExcludedProto(obj)) return [];
            var ret = [];

            /*jshint forin:false */
            enumeration: for (var key in obj) {
              if (hasProp.call(obj, key)) {
                ret.push(key);
              } else {
                for (var i = 0; i < excludedPrototypes.length; ++i) {
                  if (hasProp.call(excludedPrototypes[i], key)) {
                    continue enumeration;
                  }
                }
                ret.push(key);
              }
            }
            return ret;
          };
        }
      }();
      var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
      function isClass(fn) {
        try {
          if (typeof fn === "function") {
            var keys = es5.names(fn.prototype);
            var hasMethods = es5.isES5 && keys.length > 1;
            var hasMethodsOtherThanConstructor = keys.length > 0 && !(keys.length === 1 && keys[0] === "constructor");
            var hasThisAssignmentAndStaticMethods = thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
            if (hasMethods || hasMethodsOtherThanConstructor || hasThisAssignmentAndStaticMethods) {
              return true;
            }
          }
          return false;
        } catch (e) {
          return false;
        }
      }
      function toFastProperties(obj) {
        /*jshint -W027,-W055,-W031*/
        function f() {}
        f.prototype = obj;
        var l = 8;
        while (l--) {
          new f();
        }
        return obj;
        eval(obj);
      }
      var rident = /^[a-z$_][a-z$_0-9]*$/i;
      function isIdentifier(str) {
        return rident.test(str);
      }
      function filledRange(count, prefix, suffix) {
        var ret = new Array(count);
        for (var i = 0; i < count; ++i) {
          ret[i] = prefix + i + suffix;
        }
        return ret;
      }
      function safeToString(obj) {
        try {
          return obj + "";
        } catch (e) {
          return "[no string representation]";
        }
      }
      function markAsOriginatingFromRejection(e) {
        try {
          notEnumerableProp(e, "isOperational", true);
        } catch (ignore) {}
      }
      function originatesFromRejection(e) {
        if (e == null) return false;
        return e instanceof Error["__BluebirdErrorTypes__"].OperationalError || e["isOperational"] === true;
      }
      function canAttachTrace(obj) {
        return obj instanceof Error && es5.propertyIsWritable(obj, "stack");
      }
      var ensureErrorObject = function () {
        if (!("stack" in new Error())) {
          return function (value) {
            if (canAttachTrace(value)) return value;
            try {
              throw new Error(safeToString(value));
            } catch (err) {
              return err;
            }
          };
        } else {
          return function (value) {
            if (canAttachTrace(value)) return value;
            return new Error(safeToString(value));
          };
        }
      }();
      function classString(obj) {
        return {}.toString.call(obj);
      }
      function copyDescriptors(from, to, filter) {
        var keys = es5.names(from);
        for (var i = 0; i < keys.length; ++i) {
          var key = keys[i];
          if (filter(key)) {
            try {
              es5.defineProperty(to, key, es5.getDescriptor(from, key));
            } catch (ignore) {}
          }
        }
      }
      var ret = {
        isClass: isClass,
        isIdentifier: isIdentifier,
        inheritedDataKeys: inheritedDataKeys,
        getDataPropertyOrDefault: getDataPropertyOrDefault,
        thrower: thrower,
        isArray: es5.isArray,
        haveGetters: haveGetters,
        notEnumerableProp: notEnumerableProp,
        isPrimitive: isPrimitive,
        isObject: isObject,
        canEvaluate: canEvaluate,
        errorObj: errorObj,
        tryCatch: tryCatch,
        inherits: inherits,
        withAppended: withAppended,
        maybeWrapAsError: maybeWrapAsError,
        toFastProperties: toFastProperties,
        filledRange: filledRange,
        toString: safeToString,
        canAttachTrace: canAttachTrace,
        ensureErrorObject: ensureErrorObject,
        originatesFromRejection: originatesFromRejection,
        markAsOriginatingFromRejection: markAsOriginatingFromRejection,
        classString: classString,
        copyDescriptors: copyDescriptors,
        hasDevTools: typeof chrome !== "undefined" && chrome && typeof chrome.loadTimes === "function",
        isNode: typeof process !== "undefined" && classString(process).toLowerCase() === "[object process]"
      };
      ret.isRecentNode = ret.isNode && function () {
        var version = process.versions.node.split(".").map(Number);
        return version[0] === 0 && version[1] > 10 || version[0] > 0;
      }();
      if (ret.isNode) ret.toFastProperties(process);
      try {
        throw new Error();
      } catch (e) {
        ret.lastLineError = e;
      }
      module.exports = ret;
    }, {
      "./es5.js": 14
    }]
  }, {}, [4])(4);
});
;
if (typeof window !== 'undefined' && window !== null) {
  window.P = window.Promise;
} else if (typeof self !== 'undefined' && self !== null) {
  self.P = self.Promise;
}

/***/ }),

/***/ 44102:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



__webpack_require__(68309);
var ReactPropTypesSecret = __webpack_require__(24135);
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  ;
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  ;
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/***/ }),

/***/ 23398:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(44102)();
}

/***/ }),

/***/ 24135:
/***/ ((module) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

/***/ }),

/***/ 41625:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ucs2decode": () => (/* binding */ ucs2decode),
/* harmony export */   "ucs2encode": () => (/* binding */ ucs2encode),
/* harmony export */   "decode": () => (/* binding */ decode),
/* harmony export */   "encode": () => (/* binding */ encode),
/* harmony export */   "toASCII": () => (/* binding */ toASCII),
/* harmony export */   "toUnicode": () => (/* binding */ toUnicode),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23123);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69600);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_from_code_point_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94953);
/* harmony import */ var core_js_modules_es_string_from_code_point_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_from_code_point_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40561);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(91038);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_15__);


/** Highest positive signed 32-bit float value */
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
















var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1

/** Bootstring parameters */
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'

/** Regular expressions */
var regexPunycode = /^xn--/;
var regexNonASCII = /[^\0-\x7E]/; // non-ASCII chars
var regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators

/** Error messages */
var errors = {
  'overflow': 'Overflow: input needs wider integers to process',
  'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
  'invalid-input': 'Invalid input'
};

/** Convenience shortcuts */
var baseMinusTMin = base - tMin;
var floor = Math.floor;
var stringFromCharCode = String.fromCharCode;

/*--------------------------------------------------------------------------*/

/**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */
function error(type) {
  throw new RangeError(errors[type]);
}

/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */
function map(array, fn) {
  var result = [];
  var length = array.length;
  while (length--) {
    result[length] = fn(array[length]);
  }
  return result;
}

/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {Array} A new string of characters returned by the callback
 * function.
 */
function mapDomain(string, fn) {
  var parts = string.split('@');
  var result = '';
  if (parts.length > 1) {
    // In email addresses, only the domain name should be punycoded. Leave
    // the local part (i.e. everything up to `@`) intact.
    result = parts[0] + '@';
    string = parts[1];
  }
  // Avoid `split(regex)` for IE8 compatibility. See #17.
  string = string.replace(regexSeparators, '\x2E');
  var labels = string.split('.');
  var encoded = map(labels, fn).join('.');
  return result + encoded;
}

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */
function ucs2decode(string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = string.charCodeAt(counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = string.charCodeAt(counter++);
      if ((extra & 0xFC00) == 0xDC00) {
        // Low surrogate.
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }
  return output;
}

/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */
var ucs2encode = function ucs2encode(array) {
  return String.fromCodePoint.apply(String, _toConsumableArray(array));
};

/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */
var basicToDigit = function basicToDigit(codePoint) {
  if (codePoint - 0x30 < 0x0A) {
    return codePoint - 0x16;
  }
  if (codePoint - 0x41 < 0x1A) {
    return codePoint - 0x41;
  }
  if (codePoint - 0x61 < 0x1A) {
    return codePoint - 0x61;
  }
  return base;
};

/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */
var digitToBasic = function digitToBasic(digit, flag) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */
var adapt = function adapt(delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor(delta / damp) : delta >> 1;
  delta += floor(delta / numPoints);
  for (; delta > baseMinusTMin * tMax >> 1; k += base) {
    delta = floor(delta / baseMinusTMin);
  }
  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */
var decode = function decode(input) {
  // Don't use UCS-2.
  var output = [];
  var inputLength = input.length;
  var i = 0;
  var n = initialN;
  var bias = initialBias;

  // Handle the basic code points: let `basic` be the number of input code
  // points before the last delimiter, or `0` if there is none, then copy
  // the first basic code points to the output.

  var basic = input.lastIndexOf(delimiter);
  if (basic < 0) {
    basic = 0;
  }
  for (var j = 0; j < basic; ++j) {
    // if it's not a basic code point
    if (input.charCodeAt(j) >= 0x80) {
      error('not-basic');
    }
    output.push(input.charCodeAt(j));
  }

  // Main decoding loop: start just after the last delimiter if any basic code
  // points were copied; start at the beginning otherwise.

  for (var index = basic > 0 ? basic + 1 : 0; index < inputLength;) {
    // `index` is the index of the next character to be consumed.
    // Decode a generalized variable-length integer into `delta`,
    // which gets added to `i`. The overflow checking is easier
    // if we increase `i` as we go, then subtract off its starting
    // value at the end to obtain `delta`.
    var oldi = i;
    for (var w = 1, k = base;; k += base) {
      if (index >= inputLength) {
        error('invalid-input');
      }
      var digit = basicToDigit(input.charCodeAt(index++));
      if (digit >= base || digit > floor((maxInt - i) / w)) {
        error('overflow');
      }
      i += digit * w;
      var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
      if (digit < t) {
        break;
      }
      var baseMinusT = base - t;
      if (w > floor(maxInt / baseMinusT)) {
        error('overflow');
      }
      w *= baseMinusT;
    }
    var out = output.length + 1;
    bias = adapt(i - oldi, out, oldi == 0);

    // `i` was supposed to wrap around from `out` to `0`,
    // incrementing `n` each time, so we'll fix that now:
    if (floor(i / out) > maxInt - n) {
      error('overflow');
    }
    n += floor(i / out);
    i %= out;

    // Insert `n` at position `i` of the output.
    output.splice(i++, 0, n);
  }
  return String.fromCodePoint.apply(String, output);
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */
var encode = function encode(input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;

  // Handle the basic code points.
  var _iterator = _createForOfIteratorHelper(input),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _currentValue2 = _step.value;
      if (_currentValue2 < 0x80) {
        output.push(stringFromCharCode(_currentValue2));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var basicLength = output.length;
  var handledCPCount = basicLength;

  // `handledCPCount` is the number of code points that have been handled;
  // `basicLength` is the number of basic code points.

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    output.push(delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next
    // larger one:
    var m = maxInt;
    var _iterator2 = _createForOfIteratorHelper(input),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var currentValue = _step2.value;
        if (currentValue >= n && currentValue < m) {
          m = currentValue;
        }
      }

      // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
      // but guard against overflow.
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
      error('overflow');
    }
    delta += (m - n) * handledCPCountPlusOne;
    n = m;
    var _iterator3 = _createForOfIteratorHelper(input),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _currentValue = _step3.value;
        if (_currentValue < n && ++delta > maxInt) {
          error('overflow');
        }
        if (_currentValue == n) {
          // Represent delta as a generalized variable-length integer.
          var q = delta;
          for (var k = base;; k += base) {
            var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
            if (q < t) {
              break;
            }
            var qMinusT = q - t;
            var baseMinusT = base - t;
            output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
            q = floor(qMinusT / baseMinusT);
          }
          output.push(stringFromCharCode(digitToBasic(q, 0)));
          bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
          delta = 0;
          ++handledCPCount;
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    ++delta;
    ++n;
  }
  return output.join('');
};

/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */
var toUnicode = function toUnicode(input) {
  return mapDomain(input, function (string) {
    return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
  });
};

/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */
var toASCII = function toASCII(input) {
  return mapDomain(input, function (string) {
    return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
  });
};

/*--------------------------------------------------------------------------*/

/** Define the public API */
var punycode = {
  /**
   * A string representing the current Punycode.js version number.
   * @memberOf punycode
   * @type String
   */
  'version': '2.1.0',
  /**
   * An object of methods to convert from JavaScript's internal character
   * representation (UCS-2) to Unicode code points, and back.
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode
   * @type Object
   */
  'ucs2': {
    'decode': ucs2decode,
    'encode': ucs2encode
  },
  'decode': decode,
  'encode': encode,
  'toASCII': toASCII,
  'toUnicode': toUnicode
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (punycode);

/***/ }),

/***/ 37807:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
__webpack_require__(74916);
__webpack_require__(23123);
__webpack_require__(15306);
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function (qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};
  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }
  var regexp = /\+/g;
  qs = qs.split(sep);
  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }
  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }
  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
      idx = x.indexOf(eq),
      kstr,
      vstr,
      k,
      v;
    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }
    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);
    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (Array.isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }
  return obj;
};

/***/ }),

/***/ 36542:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(47941);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
var stringifyPrimitive = function stringifyPrimitive(v) {
  switch (_typeof(v)) {
    case 'string':
      return v;
    case 'boolean':
      return v ? 'true' : 'false';
    case 'number':
      return isFinite(v) ? v : '';
    default:
      return '';
  }
};
module.exports = function (obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }
  if (_typeof(obj) === 'object') {
    return Object.keys(obj).map(function (k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (Array.isArray(obj[k])) {
        return obj[k].map(function (v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);
  }
  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq + encodeURIComponent(stringifyPrimitive(obj));
};

/***/ }),

/***/ 86406:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


exports.decode = exports.parse = __webpack_require__(37807);
exports.encode = exports.stringify = __webpack_require__(36542);

/***/ }),

/***/ 23328:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


__webpack_require__(47941);
__webpack_require__(92222);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var lodash_clonedeep_1 = __importDefault(__webpack_require__(92585));
var lodash_isequal_1 = __importDefault(__webpack_require__(37733));
var AttributeMap;
(function (AttributeMap) {
  function compose(a, b, keepNull) {
    if (a === void 0) {
      a = {};
    }
    if (b === void 0) {
      b = {};
    }
    if (_typeof(a) !== 'object') {
      a = {};
    }
    if (_typeof(b) !== 'object') {
      b = {};
    }
    var attributes = lodash_clonedeep_1.default(b);
    if (!keepNull) {
      attributes = Object.keys(attributes).reduce(function (copy, key) {
        if (attributes[key] != null) {
          copy[key] = attributes[key];
        }
        return copy;
      }, {});
    }
    for (var key in a) {
      if (a[key] !== undefined && b[key] === undefined) {
        attributes[key] = a[key];
      }
    }
    return Object.keys(attributes).length > 0 ? attributes : undefined;
  }
  AttributeMap.compose = compose;
  function diff(a, b) {
    if (a === void 0) {
      a = {};
    }
    if (b === void 0) {
      b = {};
    }
    if (_typeof(a) !== 'object') {
      a = {};
    }
    if (_typeof(b) !== 'object') {
      b = {};
    }
    var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function (attrs, key) {
      if (!lodash_isequal_1.default(a[key], b[key])) {
        attrs[key] = b[key] === undefined ? null : b[key];
      }
      return attrs;
    }, {});
    return Object.keys(attributes).length > 0 ? attributes : undefined;
  }
  AttributeMap.diff = diff;
  function invert(attr, base) {
    if (attr === void 0) {
      attr = {};
    }
    if (base === void 0) {
      base = {};
    }
    attr = attr || {};
    var baseInverted = Object.keys(base).reduce(function (memo, key) {
      if (base[key] !== attr[key] && attr[key] !== undefined) {
        memo[key] = base[key];
      }
      return memo;
    }, {});
    return Object.keys(attr).reduce(function (memo, key) {
      if (attr[key] !== base[key] && base[key] === undefined) {
        memo[key] = null;
      }
      return memo;
    }, baseInverted);
  }
  AttributeMap.invert = invert;
  function transform(a, b, priority) {
    if (priority === void 0) {
      priority = false;
    }
    if (_typeof(a) !== 'object') {
      return b;
    }
    if (_typeof(b) !== 'object') {
      return undefined;
    }
    if (!priority) {
      return b; // b simply overwrites us without priority
    }

    var attributes = Object.keys(b).reduce(function (attrs, key) {
      if (a[key] === undefined) {
        attrs[key] = b[key]; // null is a valid value
      }

      return attrs;
    }, {});
    return Object.keys(attributes).length > 0 ? attributes : undefined;
  }
  AttributeMap.transform = transform;
})(AttributeMap || (AttributeMap = {}));
exports["default"] = AttributeMap;

/***/ }),

/***/ 22463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


__webpack_require__(47941);
__webpack_require__(40561);
__webpack_require__(57327);
__webpack_require__(54747);
__webpack_require__(21249);
__webpack_require__(47042);
__webpack_require__(92222);
__webpack_require__(69600);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
var fast_diff_1 = __importDefault(__webpack_require__(87790));
var lodash_clonedeep_1 = __importDefault(__webpack_require__(92585));
var lodash_isequal_1 = __importDefault(__webpack_require__(37733));
var AttributeMap_1 = __importDefault(__webpack_require__(23328));
var Op_1 = __importDefault(__webpack_require__(3590));
var NULL_CHARACTER = String.fromCharCode(0); // Placeholder char for embed in diff()
var Delta = function () {
  function Delta(ops) {
    // Assume we are given a well formed ops
    if (Array.isArray(ops)) {
      this.ops = ops;
    } else if (ops != null && Array.isArray(ops.ops)) {
      this.ops = ops.ops;
    } else {
      this.ops = [];
    }
  }
  Delta.prototype.insert = function (arg, attributes) {
    var newOp = {};
    if (typeof arg === 'string' && arg.length === 0) {
      return this;
    }
    newOp.insert = arg;
    if (attributes != null && _typeof(attributes) === 'object' && Object.keys(attributes).length > 0) {
      newOp.attributes = attributes;
    }
    return this.push(newOp);
  };
  Delta.prototype.delete = function (length) {
    if (length <= 0) {
      return this;
    }
    return this.push({
      delete: length
    });
  };
  Delta.prototype.retain = function (length, attributes) {
    if (length <= 0) {
      return this;
    }
    var newOp = {
      retain: length
    };
    if (attributes != null && _typeof(attributes) === 'object' && Object.keys(attributes).length > 0) {
      newOp.attributes = attributes;
    }
    return this.push(newOp);
  };
  Delta.prototype.push = function (newOp) {
    var index = this.ops.length;
    var lastOp = this.ops[index - 1];
    newOp = lodash_clonedeep_1.default(newOp);
    if (_typeof(lastOp) === 'object') {
      if (typeof newOp.delete === 'number' && typeof lastOp.delete === 'number') {
        this.ops[index - 1] = {
          delete: lastOp.delete + newOp.delete
        };
        return this;
      }
      // Since it does not matter if we insert before or after deleting at the same index,
      // always prefer to insert first
      if (typeof lastOp.delete === 'number' && newOp.insert != null) {
        index -= 1;
        lastOp = this.ops[index - 1];
        if (_typeof(lastOp) !== 'object') {
          this.ops.unshift(newOp);
          return this;
        }
      }
      if (lodash_isequal_1.default(newOp.attributes, lastOp.attributes)) {
        if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
          this.ops[index - 1] = {
            insert: lastOp.insert + newOp.insert
          };
          if (_typeof(newOp.attributes) === 'object') {
            this.ops[index - 1].attributes = newOp.attributes;
          }
          return this;
        } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
          this.ops[index - 1] = {
            retain: lastOp.retain + newOp.retain
          };
          if (_typeof(newOp.attributes) === 'object') {
            this.ops[index - 1].attributes = newOp.attributes;
          }
          return this;
        }
      }
    }
    if (index === this.ops.length) {
      this.ops.push(newOp);
    } else {
      this.ops.splice(index, 0, newOp);
    }
    return this;
  };
  Delta.prototype.chop = function () {
    var lastOp = this.ops[this.ops.length - 1];
    if (lastOp && lastOp.retain && !lastOp.attributes) {
      this.ops.pop();
    }
    return this;
  };
  Delta.prototype.filter = function (predicate) {
    return this.ops.filter(predicate);
  };
  Delta.prototype.forEach = function (predicate) {
    this.ops.forEach(predicate);
  };
  Delta.prototype.map = function (predicate) {
    return this.ops.map(predicate);
  };
  Delta.prototype.partition = function (predicate) {
    var passed = [];
    var failed = [];
    this.forEach(function (op) {
      var target = predicate(op) ? passed : failed;
      target.push(op);
    });
    return [passed, failed];
  };
  Delta.prototype.reduce = function (predicate, initialValue) {
    return this.ops.reduce(predicate, initialValue);
  };
  Delta.prototype.changeLength = function () {
    return this.reduce(function (length, elem) {
      if (elem.insert) {
        return length + Op_1.default.length(elem);
      } else if (elem.delete) {
        return length - elem.delete;
      }
      return length;
    }, 0);
  };
  Delta.prototype.length = function () {
    return this.reduce(function (length, elem) {
      return length + Op_1.default.length(elem);
    }, 0);
  };
  Delta.prototype.slice = function (start, end) {
    if (start === void 0) {
      start = 0;
    }
    if (end === void 0) {
      end = Infinity;
    }
    var ops = [];
    var iter = Op_1.default.iterator(this.ops);
    var index = 0;
    while (index < end && iter.hasNext()) {
      var nextOp = void 0;
      if (index < start) {
        nextOp = iter.next(start - index);
      } else {
        nextOp = iter.next(end - index);
        ops.push(nextOp);
      }
      index += Op_1.default.length(nextOp);
    }
    return new Delta(ops);
  };
  Delta.prototype.compose = function (other) {
    var thisIter = Op_1.default.iterator(this.ops);
    var otherIter = Op_1.default.iterator(other.ops);
    var ops = [];
    var firstOther = otherIter.peek();
    if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
      var firstLeft = firstOther.retain;
      while (thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft) {
        firstLeft -= thisIter.peekLength();
        ops.push(thisIter.next());
      }
      if (firstOther.retain - firstLeft > 0) {
        otherIter.next(firstOther.retain - firstLeft);
      }
    }
    var delta = new Delta(ops);
    while (thisIter.hasNext() || otherIter.hasNext()) {
      if (otherIter.peekType() === 'insert') {
        delta.push(otherIter.next());
      } else if (thisIter.peekType() === 'delete') {
        delta.push(thisIter.next());
      } else {
        var length_1 = Math.min(thisIter.peekLength(), otherIter.peekLength());
        var thisOp = thisIter.next(length_1);
        var otherOp = otherIter.next(length_1);
        if (typeof otherOp.retain === 'number') {
          var newOp = {};
          if (typeof thisOp.retain === 'number') {
            newOp.retain = length_1;
          } else {
            newOp.insert = thisOp.insert;
          }
          // Preserve null when composing with a retain, otherwise remove it for inserts
          var attributes = AttributeMap_1.default.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
          if (attributes) {
            newOp.attributes = attributes;
          }
          delta.push(newOp);
          // Optimization if rest of other is just retain
          if (!otherIter.hasNext() && lodash_isequal_1.default(delta.ops[delta.ops.length - 1], newOp)) {
            var rest = new Delta(thisIter.rest());
            return delta.concat(rest).chop();
          }
          // Other op should be delete, we could be an insert or retain
          // Insert + delete cancels out
        } else if (typeof otherOp.delete === 'number' && typeof thisOp.retain === 'number') {
          delta.push(otherOp);
        }
      }
    }
    return delta.chop();
  };
  Delta.prototype.concat = function (other) {
    var delta = new Delta(this.ops.slice());
    if (other.ops.length > 0) {
      delta.push(other.ops[0]);
      delta.ops = delta.ops.concat(other.ops.slice(1));
    }
    return delta;
  };
  Delta.prototype.diff = function (other, cursor) {
    if (this.ops === other.ops) {
      return new Delta();
    }
    var strings = [this, other].map(function (delta) {
      return delta.map(function (op) {
        if (op.insert != null) {
          return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
        }
        var prep = delta === other ? 'on' : 'with';
        throw new Error('diff() called ' + prep + ' non-document');
      }).join('');
    });
    var retDelta = new Delta();
    var diffResult = fast_diff_1.default(strings[0], strings[1], cursor);
    var thisIter = Op_1.default.iterator(this.ops);
    var otherIter = Op_1.default.iterator(other.ops);
    diffResult.forEach(function (component) {
      var length = component[1].length;
      while (length > 0) {
        var opLength = 0;
        switch (component[0]) {
          case fast_diff_1.default.INSERT:
            opLength = Math.min(otherIter.peekLength(), length);
            retDelta.push(otherIter.next(opLength));
            break;
          case fast_diff_1.default.DELETE:
            opLength = Math.min(length, thisIter.peekLength());
            thisIter.next(opLength);
            retDelta.delete(opLength);
            break;
          case fast_diff_1.default.EQUAL:
            opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
            var thisOp = thisIter.next(opLength);
            var otherOp = otherIter.next(opLength);
            if (lodash_isequal_1.default(thisOp.insert, otherOp.insert)) {
              retDelta.retain(opLength, AttributeMap_1.default.diff(thisOp.attributes, otherOp.attributes));
            } else {
              retDelta.push(otherOp).delete(opLength);
            }
            break;
        }
        length -= opLength;
      }
    });
    return retDelta.chop();
  };
  Delta.prototype.eachLine = function (predicate, newline) {
    if (newline === void 0) {
      newline = '\n';
    }
    var iter = Op_1.default.iterator(this.ops);
    var line = new Delta();
    var i = 0;
    while (iter.hasNext()) {
      if (iter.peekType() !== 'insert') {
        return;
      }
      var thisOp = iter.peek();
      var start = Op_1.default.length(thisOp) - iter.peekLength();
      var index = typeof thisOp.insert === 'string' ? thisOp.insert.indexOf(newline, start) - start : -1;
      if (index < 0) {
        line.push(iter.next());
      } else if (index > 0) {
        line.push(iter.next(index));
      } else {
        if (predicate(line, iter.next(1).attributes || {}, i) === false) {
          return;
        }
        i += 1;
        line = new Delta();
      }
    }
    if (line.length() > 0) {
      predicate(line, {}, i);
    }
  };
  Delta.prototype.invert = function (base) {
    var inverted = new Delta();
    this.reduce(function (baseIndex, op) {
      if (op.insert) {
        inverted.delete(Op_1.default.length(op));
      } else if (op.retain && op.attributes == null) {
        inverted.retain(op.retain);
        return baseIndex + op.retain;
      } else if (op.delete || op.retain && op.attributes) {
        var length_2 = op.delete || op.retain;
        var slice = base.slice(baseIndex, baseIndex + length_2);
        slice.forEach(function (baseOp) {
          if (op.delete) {
            inverted.push(baseOp);
          } else if (op.retain && op.attributes) {
            inverted.retain(Op_1.default.length(baseOp), AttributeMap_1.default.invert(op.attributes, baseOp.attributes));
          }
        });
        return baseIndex + length_2;
      }
      return baseIndex;
    }, 0);
    return inverted.chop();
  };
  Delta.prototype.transform = function (arg, priority) {
    if (priority === void 0) {
      priority = false;
    }
    priority = !!priority;
    if (typeof arg === 'number') {
      return this.transformPosition(arg, priority);
    }
    var other = arg;
    var thisIter = Op_1.default.iterator(this.ops);
    var otherIter = Op_1.default.iterator(other.ops);
    var delta = new Delta();
    while (thisIter.hasNext() || otherIter.hasNext()) {
      if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) {
        delta.retain(Op_1.default.length(thisIter.next()));
      } else if (otherIter.peekType() === 'insert') {
        delta.push(otherIter.next());
      } else {
        var length_3 = Math.min(thisIter.peekLength(), otherIter.peekLength());
        var thisOp = thisIter.next(length_3);
        var otherOp = otherIter.next(length_3);
        if (thisOp.delete) {
          // Our delete either makes their delete redundant or removes their retain
          continue;
        } else if (otherOp.delete) {
          delta.push(otherOp);
        } else {
          // We retain either their retain or insert
          delta.retain(length_3, AttributeMap_1.default.transform(thisOp.attributes, otherOp.attributes, priority));
        }
      }
    }
    return delta.chop();
  };
  Delta.prototype.transformPosition = function (index, priority) {
    if (priority === void 0) {
      priority = false;
    }
    priority = !!priority;
    var thisIter = Op_1.default.iterator(this.ops);
    var offset = 0;
    while (thisIter.hasNext() && offset <= index) {
      var length_4 = thisIter.peekLength();
      var nextType = thisIter.peekType();
      thisIter.next();
      if (nextType === 'delete') {
        index -= Math.min(length_4, index - offset);
        continue;
      } else if (nextType === 'insert' && (offset < index || !priority)) {
        index += length_4;
      }
      offset += length_4;
    }
    return index;
  };
  Delta.Op = Op_1.default;
  Delta.AttributeMap = AttributeMap_1.default;
  return Delta;
}();
module.exports = Delta;

/***/ }),

/***/ 26844:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


__webpack_require__(47042);
__webpack_require__(92222);
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var Op_1 = __importDefault(__webpack_require__(3590));
var Iterator = function () {
  function Iterator(ops) {
    this.ops = ops;
    this.index = 0;
    this.offset = 0;
  }
  Iterator.prototype.hasNext = function () {
    return this.peekLength() < Infinity;
  };
  Iterator.prototype.next = function (length) {
    if (!length) {
      length = Infinity;
    }
    var nextOp = this.ops[this.index];
    if (nextOp) {
      var offset = this.offset;
      var opLength = Op_1.default.length(nextOp);
      if (length >= opLength - offset) {
        length = opLength - offset;
        this.index += 1;
        this.offset = 0;
      } else {
        this.offset += length;
      }
      if (typeof nextOp.delete === 'number') {
        return {
          delete: length
        };
      } else {
        var retOp = {};
        if (nextOp.attributes) {
          retOp.attributes = nextOp.attributes;
        }
        if (typeof nextOp.retain === 'number') {
          retOp.retain = length;
        } else if (typeof nextOp.insert === 'string') {
          retOp.insert = nextOp.insert.substr(offset, length);
        } else {
          // offset should === 0, length should === 1
          retOp.insert = nextOp.insert;
        }
        return retOp;
      }
    } else {
      return {
        retain: Infinity
      };
    }
  };
  Iterator.prototype.peek = function () {
    return this.ops[this.index];
  };
  Iterator.prototype.peekLength = function () {
    if (this.ops[this.index]) {
      // Should never return 0 if our index is being managed correctly
      return Op_1.default.length(this.ops[this.index]) - this.offset;
    } else {
      return Infinity;
    }
  };
  Iterator.prototype.peekType = function () {
    if (this.ops[this.index]) {
      if (typeof this.ops[this.index].delete === 'number') {
        return 'delete';
      } else if (typeof this.ops[this.index].retain === 'number') {
        return 'retain';
      } else {
        return 'insert';
      }
    }
    return 'retain';
  };
  Iterator.prototype.rest = function () {
    if (!this.hasNext()) {
      return [];
    } else if (this.offset === 0) {
      return this.ops.slice(this.index);
    } else {
      var offset = this.offset;
      var index = this.index;
      var next = this.next();
      var rest = this.ops.slice(this.index);
      this.offset = offset;
      this.index = index;
      return [next].concat(rest);
    }
  };
  return Iterator;
}();
exports["default"] = Iterator;

/***/ }),

/***/ 3590:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var Iterator_1 = __importDefault(__webpack_require__(26844));
var Op;
(function (Op) {
  function iterator(ops) {
    return new Iterator_1.default(ops);
  }
  Op.iterator = iterator;
  function length(op) {
    if (typeof op.delete === 'number') {
      return op.delete;
    } else if (typeof op.retain === 'number') {
      return op.retain;
    } else {
      return typeof op.insert === 'string' ? op.insert.length : 1;
    }
  }
  Op.length = length;
})(Op || (Op = {}));
exports["default"] = Op;

/***/ }),

/***/ 88131:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;__webpack_require__(21249);
__webpack_require__(47042);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
/*!
 * RangeFix v0.2.9
 * https://github.com/edg2s/rangefix
 *
 * Copyright 2014-17 Ed Sanders.
 * Released under the MIT license
 */
(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(this, function () {
  var broken,
    rangeFix = {};

  /**
   * Check if bugs are present in the native functions
   *
   * For getClientRects, constructs two lines of text and
   * creates a range between them. Broken browsers will
   * return three rectangles instead of two.
   *
   * For getBoundingClientRect, create a collapsed range
   * and check if the resulting rect has non-zero offsets.
   *
   * getBoundingClientRect is also considered broken if
   * getClientRects is broken.
   *
   * For the IE zoom bug, just check the version number as
   * we can't detect the bug if the zoom level is currently 100%.
   *
   * @private
   * @return {Object} Object containing boolean properties 'getClientRects',
   *                  'getBoundingClientRect' and 'ieZoom' indicating bugs are present
   *                  in these functions/browsers.
   */
  rangeFix.isBroken = function () {
    var boundingRect, p, span, t1, t2, img, range, jscriptVersion;
    if (broken === undefined) {
      p = document.createElement('p');
      span = document.createElement('span');
      t1 = document.createTextNode('aa');
      t2 = document.createTextNode('aa');
      img = document.createElement('img');
      img.setAttribute('src', 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=');
      range = document.createRange();
      broken = {};
      p.appendChild(t1);
      p.appendChild(span);
      span.appendChild(img);
      span.appendChild(t2);
      document.body.appendChild(p);
      range.setStart(t1, 1);
      range.setEnd(span, 0);

      // A selection ending just inside another element shouldn't select that whole element
      // Broken in Chrome <= 55 and Firefox
      broken.getClientRects = broken.getBoundingClientRect = range.getClientRects().length > 1;
      if (!broken.getClientRects) {
        // Regression in Chrome 55:
        // A selection across a wrapped image should give a rect for that image.
        // In Chrome we get two rectangles, one for each text node. In working browsers
        // we get three or more, or in Edge we get one surrounding the text and the image.
        range.setEnd(t2, 1);
        broken.getClientRects = broken.getBoundingClientRect = range.getClientRects().length === 2;
      }
      if (!broken.getBoundingClientRect) {
        // Safari doesn't return a valid bounding rect for collapsed ranges
        // Equivalent to range.collapse( true ) which isn't well supported
        range.setEnd(range.startContainer, range.startOffset);
        boundingRect = range.getBoundingClientRect();
        broken.getBoundingClientRect = boundingRect.top === 0 && boundingRect.left === 0;
      }
      document.body.removeChild(p);

      // Detect IE<=10 where zooming scaling is broken
      // eslint-disable-next-line no-new-func
      jscriptVersion = window.ActiveXObject && new Function('/*@cc_on return @_jscript_version; @*/')();
      broken.ieZoom = !!jscriptVersion && jscriptVersion <= 10;
    }
    return broken;
  };

  /**
   * Compensate for the current zoom level in IE<=10
   *
   * getClientRects returns values in real pixels in these browsers,
   * so using them in your CSS will result in them getting scaled again.
   *
   * @private
   * @param {ClientRectList|ClientRect[]|ClientRect|Object|null} rectOrRects Rect or list of rects to fix
   * @return {ClientRectList|ClientRect[]|ClientRect|Object|null} Fixed rect or list of rects
   */
  function zoomFix(rectOrRects) {
    var zoom;
    if (!rectOrRects) {
      return rectOrRects;
    }
    // Optimisation when zoom level is 1: return original object
    if (screen.deviceXDPI === screen.logicalXDPI) {
      return rectOrRects;
    }
    // Rect list: map this function to each rect
    if ('length' in rectOrRects) {
      return Array.prototype.map.call(rectOrRects, zoomFix);
    }
    // Single rect: Adjust by zoom factor
    zoom = screen.deviceXDPI / screen.logicalXDPI;
    return {
      top: rectOrRects.top / zoom,
      bottom: rectOrRects.bottom / zoom,
      left: rectOrRects.left / zoom,
      right: rectOrRects.right / zoom,
      width: rectOrRects.width / zoom,
      height: rectOrRects.height / zoom
    };
  }

  /**
   * Push one array-like object onto another.
   *
   * @param {Object} arr Array or array-like object. Will be modified
   * @param {Object} data Array-like object of items to insert.
   * @return {number} length of the new array
   */
  function batchPush(arr, data) {
    // We need to push insertion in batches, because of parameter list length limits which vary
    // cross-browser - 1024 seems to be a safe batch size on all browsers
    var length,
      index = 0,
      batchSize = 1024;
    if (batchSize >= data.length) {
      // Avoid slicing for small lists
      return Array.prototype.push.apply(arr, data);
    }
    while (index < data.length) {
      // Call arr.push( i0, i1, i2, ..., i1023 );
      length = Array.prototype.push.apply(arr, Array.prototype.slice.call(data, index, index + batchSize));
      index += batchSize;
    }
    return length;
  }

  /**
   * Get client rectangles from a range
   *
   * @param {Range} range Range
   * @return {ClientRectList|ClientRect[]} ClientRectList or list of ClientRect objects describing range
   */
  rangeFix.getClientRects = function (range) {
    var rects,
      endContainer,
      endContainerRects,
      endOffset,
      partialRange,
      broken = this.isBroken();
    if (broken.ieZoom) {
      return zoomFix(range.getClientRects());
    } else if (!broken.getClientRects) {
      return range.getClientRects();
    }

    // Chrome gets the end container rects wrong when spanning
    // nodes so we need to traverse up the tree from the endContainer until
    // we reach the common ancestor, then we can add on from start to where
    // we got up to
    // https://code.google.com/p/chromium/issues/detail?id=324437
    rects = [];
    endContainerRects = [];
    endContainer = range.endContainer;
    endOffset = range.endOffset;
    partialRange = document.createRange();
    function indexOf(child) {
      var i = 0;
      while (child = child.previousSibling) {
        i++;
      }
      return i;
    }
    while (endContainer !== range.commonAncestorContainer) {
      partialRange.setStart(endContainer, 0);
      partialRange.setEnd(endContainer, endOffset);
      batchPush(endContainerRects, partialRange.getClientRects());
      endOffset = indexOf(endContainer);
      endContainer = endContainer.parentNode;
    }

    // Once we've reached the common ancestor, add on the range from the
    // original start position to where we ended up.
    partialRange = range.cloneRange();
    partialRange.setEnd(endContainer, endOffset);
    batchPush(rects, partialRange.getClientRects());
    batchPush(rects, endContainerRects);
    return rects;
  };

  /**
   * Get bounding rectangle from a range
   *
   * @param {Range} range Range
   * @return {ClientRect|Object|null} ClientRect or ClientRect-like object describing
   *                                  bounding rectangle, or null if not computable
   */
  rangeFix.getBoundingClientRect = function (range) {
    var i,
      l,
      boundingRect,
      rect,
      nativeBoundingRect,
      broken,
      rects = this.getClientRects(range);

    // If there are no rects return null, otherwise we'll fall through to
    // getBoundingClientRect, which in Chrome and Firefox becomes [0,0,0,0].
    if (rects.length === 0) {
      return null;
    }
    nativeBoundingRect = range.getBoundingClientRect();
    broken = this.isBroken();
    if (broken.ieZoom) {
      return zoomFix(nativeBoundingRect);
    } else if (!broken.getBoundingClientRect) {
      return nativeBoundingRect;
    }

    // When nativeRange is a collapsed cursor at the end of a line or
    // the start of a line, the bounding rect is [0,0,0,0] in Chrome.
    // getClientRects returns two rects, one correct, and one at the
    // end of the next line / start of the previous line. We can't tell
    // here which one to use so just pick the first. This matches
    // Firefox's behaviour, which tells you the cursor is at the end
    // of the previous line when it is at the start of the line.
    // See https://code.google.com/p/chromium/issues/detail?id=426017
    if (nativeBoundingRect.width === 0 && nativeBoundingRect.height === 0) {
      return rects[0];
    }
    for (i = 0, l = rects.length; i < l; i++) {
      rect = rects[i];
      if (!boundingRect) {
        boundingRect = {
          left: rect.left,
          top: rect.top,
          right: rect.right,
          bottom: rect.bottom
        };
      } else {
        boundingRect.left = Math.min(boundingRect.left, rect.left);
        boundingRect.top = Math.min(boundingRect.top, rect.top);
        boundingRect.right = Math.max(boundingRect.right, rect.right);
        boundingRect.bottom = Math.max(boundingRect.bottom, rect.bottom);
      }
    }
    if (boundingRect) {
      boundingRect.width = boundingRect.right - boundingRect.left;
      boundingRect.height = boundingRect.bottom - boundingRect.top;
    }
    return boundingRect;
  };
  return rangeFix;
});

/***/ }),

/***/ 4254:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19601);
__webpack_require__(82526);
var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];
    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }
  return t;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};
exports.__esModule = true;
var React = __webpack_require__(10097);
var PropTypes = __webpack_require__(17694);
var autosize = __webpack_require__(54878);
var _getLineHeight = __webpack_require__(78503);
var getLineHeight = _getLineHeight;
var RESIZED = "autosize:resized";
/**
 * A light replacement for built-in textarea component
 * which automaticaly adjusts its height to match the content
 */
var TextareaAutosizeClass = function (_super) {
  __extends(TextareaAutosizeClass, _super);
  function TextareaAutosizeClass() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      lineHeight: null
    };
    _this.textarea = null;
    _this.onResize = function (e) {
      if (_this.props.onResize) {
        _this.props.onResize(e);
      }
    };
    _this.updateLineHeight = function () {
      if (_this.textarea) {
        _this.setState({
          lineHeight: getLineHeight(_this.textarea)
        });
      }
    };
    _this.onChange = function (e) {
      var onChange = _this.props.onChange;
      _this.currentValue = e.currentTarget.value;
      onChange && onChange(e);
    };
    return _this;
  }
  TextareaAutosizeClass.prototype.componentDidMount = function () {
    var _this = this;
    var _a = this.props,
      maxRows = _a.maxRows,
      async = _a.async;
    if (typeof maxRows === "number") {
      this.updateLineHeight();
    }
    if (typeof maxRows === "number" || async) {
      /*
        the defer is needed to:
          - force "autosize" to activate the scrollbar when this.props.maxRows is passed
          - support StyledComponents (see #71)
      */
      setTimeout(function () {
        return _this.textarea && autosize(_this.textarea);
      });
    } else {
      this.textarea && autosize(this.textarea);
    }
    if (this.textarea) {
      this.textarea.addEventListener(RESIZED, this.onResize);
    }
  };
  TextareaAutosizeClass.prototype.componentWillUnmount = function () {
    if (this.textarea) {
      this.textarea.removeEventListener(RESIZED, this.onResize);
      autosize.destroy(this.textarea);
    }
  };
  TextareaAutosizeClass.prototype.render = function () {
    var _this = this;
    var _a = this,
      _b = _a.props,
      onResize = _b.onResize,
      maxRows = _b.maxRows,
      onChange = _b.onChange,
      style = _b.style,
      innerRef = _b.innerRef,
      children = _b.children,
      props = __rest(_b, ["onResize", "maxRows", "onChange", "style", "innerRef", "children"]),
      lineHeight = _a.state.lineHeight;
    var maxHeight = maxRows && lineHeight ? lineHeight * maxRows : null;
    return React.createElement("textarea", __assign({}, props, {
      onChange: this.onChange,
      style: maxHeight ? __assign({}, style, {
        maxHeight: maxHeight
      }) : style,
      ref: function ref(element) {
        _this.textarea = element;
        if (typeof _this.props.innerRef === 'function') {
          _this.props.innerRef(element);
        } else if (_this.props.innerRef) {
          _this.props.innerRef.current = element;
        }
      }
    }), children);
  };
  TextareaAutosizeClass.prototype.componentDidUpdate = function () {
    this.textarea && autosize.update(this.textarea);
  };
  TextareaAutosizeClass.defaultProps = {
    rows: 1,
    async: false
  };
  TextareaAutosizeClass.propTypes = {
    rows: PropTypes.number,
    maxRows: PropTypes.number,
    onResize: PropTypes.func,
    innerRef: PropTypes.any,
    async: PropTypes.bool
  };
  return TextareaAutosizeClass;
}(React.Component);
exports.TextareaAutosize = React.forwardRef(function (props, ref) {
  return React.createElement(TextareaAutosizeClass, __assign({}, props, {
    innerRef: ref
  }));
});

/***/ }),

/***/ 15806:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;
var TextareaAutosize_1 = __webpack_require__(4254);
exports.Z = TextareaAutosize_1.TextareaAutosize;

/***/ }),

/***/ 67457:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



__webpack_require__(68309);
var ReactPropTypesSecret = __webpack_require__(39442);
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  ;
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  ;
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/***/ }),

/***/ 17694:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(67457)();
}

/***/ }),

/***/ 39442:
/***/ ((module) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

/***/ }),

/***/ 25992:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;__webpack_require__(65743);
__webpack_require__(47941);
__webpack_require__(82526);
__webpack_require__(57327);
__webpack_require__(38880);
__webpack_require__(54747);
__webpack_require__(49337);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(19601);
__webpack_require__(30489);
__webpack_require__(12419);
__webpack_require__(91038);
__webpack_require__(47042);
__webpack_require__(68309);
__webpack_require__(96649);
__webpack_require__(96078);
__webpack_require__(9653);
__webpack_require__(74916);
__webpack_require__(4723);
__webpack_require__(15306);
__webpack_require__(69600);
__webpack_require__(21249);
__webpack_require__(51532);
__webpack_require__(26699);
__webpack_require__(32023);
__webpack_require__(69826);
__webpack_require__(92222);
__webpack_require__(2707);
__webpack_require__(23123);
__webpack_require__(73210);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
!function (e, t) {
  "object" == ( false ? 0 : _typeof(exports)) && "undefined" != "object" ? t(exports, __webpack_require__(10097), __webpack_require__(23398), __webpack_require__(3770), __webpack_require__(26221), __webpack_require__(13406), __webpack_require__(80900), __webpack_require__(18444), __webpack_require__(83502), __webpack_require__(59165), __webpack_require__(57484), __webpack_require__(45110), __webpack_require__(8504), __webpack_require__(4021), __webpack_require__(1092), __webpack_require__(85946), __webpack_require__(66923), __webpack_require__(81480), __webpack_require__(16353), __webpack_require__(54586), __webpack_require__(23946), __webpack_require__(89933), __webpack_require__(63735), __webpack_require__(66774), __webpack_require__(46367), __webpack_require__(71542), __webpack_require__(31411), __webpack_require__(59883), __webpack_require__(30455), __webpack_require__(225), __webpack_require__(2067), __webpack_require__(12411), __webpack_require__(11301), __webpack_require__(10448), __webpack_require__(30000), __webpack_require__(9560), __webpack_require__(28137), __webpack_require__(64670), __webpack_require__(48703), __webpack_require__(25125), __webpack_require__(81715), __webpack_require__(48933), __webpack_require__(16909), __webpack_require__(82811), __webpack_require__(52230), __webpack_require__(99067), __webpack_require__(61261), __webpack_require__(54980), __webpack_require__(66939), __webpack_require__(32408), __webpack_require__(88521), __webpack_require__(11022), __webpack_require__(62833), __webpack_require__(39138), __webpack_require__(25156), __webpack_require__(47718), __webpack_require__(65695), __webpack_require__(86723), __webpack_require__(84787), __webpack_require__(99316), __webpack_require__(8217), __webpack_require__(57135), __webpack_require__(32638), __webpack_require__(6034), __webpack_require__(10097), __webpack_require__(25984), __webpack_require__(7549)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(10097), __webpack_require__(23398), __webpack_require__(3770), __webpack_require__(26221), __webpack_require__(13406), __webpack_require__(80900), __webpack_require__(18444), __webpack_require__(83502), __webpack_require__(59165), __webpack_require__(57484), __webpack_require__(45110), __webpack_require__(8504), __webpack_require__(4021), __webpack_require__(1092), __webpack_require__(85946), __webpack_require__(66923), __webpack_require__(81480), __webpack_require__(16353), __webpack_require__(54586), __webpack_require__(23946), __webpack_require__(89933), __webpack_require__(63735), __webpack_require__(66774), __webpack_require__(46367), __webpack_require__(71542), __webpack_require__(31411), __webpack_require__(59883), __webpack_require__(30455), __webpack_require__(225), __webpack_require__(2067), __webpack_require__(12411), __webpack_require__(11301), __webpack_require__(10448), __webpack_require__(30000), __webpack_require__(9560), __webpack_require__(28137), __webpack_require__(64670), __webpack_require__(48703), __webpack_require__(25125), __webpack_require__(81715), __webpack_require__(48933), __webpack_require__(16909), __webpack_require__(82811), __webpack_require__(52230), __webpack_require__(99067), __webpack_require__(61261), __webpack_require__(54980), __webpack_require__(66939), __webpack_require__(32408), __webpack_require__(88521), __webpack_require__(11022), __webpack_require__(62833), __webpack_require__(39138), __webpack_require__(25156), __webpack_require__(47718), __webpack_require__(65695), __webpack_require__(86723), __webpack_require__(84787), __webpack_require__(99316), __webpack_require__(8217), __webpack_require__(57135), __webpack_require__(32638), __webpack_require__(6034), __webpack_require__(10097), __webpack_require__(25984), __webpack_require__(7549)], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : 0;
}(this, function (e, t, r, a, n, o, s, i, p, l, d, c, u, f, h, m, y, v, D, w, g, k, b, S, C, _, M, P, E, N, x, O, Y, I, T, L, R, F, A, q, K, W, B, Q, H, j, V, U, z, $, G, J, X, Z, ee, te, re, ae, ne, oe, se, ie, pe, le, de, ce, ue) {
  "use strict";

  function fe(e) {
    return e && "object" == _typeof(e) && "default" in e ? e : {
      default: e
    };
  }
  var he = fe(t),
    me = fe(a),
    ye = fe(n),
    ve = fe(o),
    De = fe(s),
    we = fe(i),
    ge = fe(p),
    ke = fe(l),
    be = fe(d),
    Se = fe(c),
    Ce = fe(u),
    _e = fe(f),
    Me = fe(y),
    Pe = fe(v),
    Ee = fe(D),
    Ne = fe(w),
    xe = fe(g),
    Oe = fe(k),
    Ye = fe(b),
    Ie = fe(S),
    Te = fe(C),
    Le = fe(_),
    Re = fe(M),
    Fe = fe(P),
    Ae = fe(E),
    qe = fe(N),
    Ke = fe(x),
    We = fe(O),
    Be = fe(Y),
    Qe = fe(I),
    He = fe(T),
    je = fe(L),
    Ve = fe(R),
    Ue = fe(F),
    ze = fe(A),
    $e = fe(q),
    Ge = fe(K),
    Je = fe(B),
    Xe = fe(Q),
    Ze = fe(H),
    et = fe(j),
    tt = fe(V),
    rt = fe(U),
    at = fe(z),
    nt = fe(G),
    ot = fe(J),
    st = fe(X),
    it = fe(Z),
    pt = fe(ee),
    lt = fe(te),
    dt = fe(re),
    ct = fe(ae),
    ut = fe(ne),
    ft = fe(oe),
    ht = fe(se),
    mt = fe(ie),
    yt = fe(pe),
    vt = fe(le),
    Dt = fe(de),
    wt = fe(ue);
  function gt(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      t && (a = a.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, a);
    }
    return r;
  }
  function kt(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? gt(Object(r), !0).forEach(function (t) {
        Mt(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : gt(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }
    return e;
  }
  function bt(e) {
    return (bt = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    })(e);
  }
  function St(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function Ct(e, t) {
    for (var r = 0; r < t.length; r++) {
      var a = t[r];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, Rt(a.key), a);
    }
  }
  function _t(e, t, r) {
    return t && Ct(e.prototype, t), r && Ct(e, r), Object.defineProperty(e, "prototype", {
      writable: !1
    }), e;
  }
  function Mt(e, t, r) {
    return (t = Rt(t)) in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }
  function Pt() {
    return (Pt = Object.assign ? Object.assign.bind() : function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var a in r) {
          Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
        }
      }
      return e;
    }).apply(this, arguments);
  }
  function Et(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(e, "prototype", {
      writable: !1
    }), t && xt(e, t);
  }
  function Nt(e) {
    return (Nt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }
  function xt(e, t) {
    return (xt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }
  function Ot(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function Yt(e, t) {
    if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
    return Ot(e);
  }
  function It(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var r,
        a = Nt(e);
      if (t) {
        var n = Nt(this).constructor;
        r = Reflect.construct(a, arguments, n);
      } else r = a.apply(this, arguments);
      return Yt(this, r);
    };
  }
  function Tt(e) {
    return function (e) {
      if (Array.isArray(e)) return Lt(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return Lt(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === r && e.constructor && (r = e.constructor.name);
      if ("Map" === r || "Set" === r) return Array.from(e);
      if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Lt(e, t);
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function Lt(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var r = 0, a = new Array(t); r < t; r++) {
      a[r] = e[r];
    }
    return a;
  }
  function Rt(e) {
    var t = function (e, t) {
      if ("object" != _typeof(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var a = r.call(e, t || "default");
        if ("object" != _typeof(a)) return a;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" == _typeof(t) ? t : String(t);
  }
  function Ft(e, t) {
    switch (e) {
      case "P":
        return t.date({
          width: "short"
        });
      case "PP":
        return t.date({
          width: "medium"
        });
      case "PPP":
        return t.date({
          width: "long"
        });
      case "PPPP":
      default:
        return t.date({
          width: "full"
        });
    }
  }
  function At(e, t) {
    switch (e) {
      case "p":
        return t.time({
          width: "short"
        });
      case "pp":
        return t.time({
          width: "medium"
        });
      case "ppp":
        return t.time({
          width: "long"
        });
      case "pppp":
      default:
        return t.time({
          width: "full"
        });
    }
  }
  var qt = {
      p: At,
      P: function P(e, t) {
        var r,
          a = e.match(/(P+)(p+)?/) || [],
          n = a[1],
          o = a[2];
        if (!o) return Ft(e, t);
        switch (n) {
          case "P":
            r = t.dateTime({
              width: "short"
            });
            break;
          case "PP":
            r = t.dateTime({
              width: "medium"
            });
            break;
          case "PPP":
            r = t.dateTime({
              width: "long"
            });
            break;
          case "PPPP":
          default:
            r = t.dateTime({
              width: "full"
            });
        }
        return r.replace("{{date}}", Ft(n, t)).replace("{{time}}", At(o, t));
      }
    },
    Kt = 12,
    Wt = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
  function Bt(e) {
    var t = e ? "string" == typeof e || e instanceof String ? yt.default(e) : ht.default(e) : new Date();
    return Ht(t) ? t : null;
  }
  function Qt(e, t, r, a, n) {
    var o = null,
      s = lr(r) || lr(pr()),
      i = !0;
    return Array.isArray(t) ? (t.forEach(function (t) {
      var p = mt.default(e, t, new Date(), {
        locale: s
      });
      a && (i = Ht(p, n) && e === jt(p, t, r)), Ht(p, n) && i && (o = p);
    }), o) : (o = mt.default(e, t, new Date(), {
      locale: s
    }), a ? i = Ht(o) && e === jt(o, t, r) : Ht(o) || (t = t.match(Wt).map(function (e) {
      var t = e[0];
      return "p" === t || "P" === t ? s ? (0, qt[t])(e, s.formatLong) : t : e;
    }).join(""), e.length > 0 && (o = mt.default(e, t.slice(0, e.length), new Date())), Ht(o) || (o = new Date(e))), Ht(o) && i ? o : null);
  }
  function Ht(e, t) {
    return t = t || new Date("1/1/1000"), ve.default(e) && !ut.default(e, t);
  }
  function jt(e, t, r) {
    if ("en" === r) return De.default(e, t, {
      awareOfUnicodeTokens: !0
    });
    var a = lr(r);
    return r && !a && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), !a && pr() && lr(pr()) && (a = lr(pr())), De.default(e, t, {
      locale: a || null,
      awareOfUnicodeTokens: !0
    });
  }
  function Vt(e, t) {
    var r = t.dateFormat,
      a = t.locale;
    return e && jt(e, Array.isArray(r) ? r[0] : r, a) || "";
  }
  function Ut(e, t) {
    var r = t.hour,
      a = void 0 === r ? 0 : r,
      n = t.minute,
      o = void 0 === n ? 0 : n,
      s = t.second,
      i = void 0 === s ? 0 : s;
    return Qe.default(Be.default(We.default(e, i), o), a);
  }
  function zt(e, t) {
    var r = t && lr(t) || pr() && lr(pr());
    return Re.default(e, r ? {
      locale: r
    } : null);
  }
  function $t(e, t) {
    return jt(e, "ddd", t);
  }
  function Gt(e) {
    return Xe.default(e);
  }
  function Jt(e, t, r) {
    var a = lr(t || pr());
    return Ze.default(e, {
      locale: a,
      weekStartsOn: r
    });
  }
  function Xt(e) {
    return et.default(e);
  }
  function Zt(e) {
    return rt.default(e);
  }
  function er(e) {
    return tt.default(e);
  }
  function tr() {
    return Xe.default(Bt());
  }
  function rr(e, t) {
    return e && t ? lt.default(e, t) : !e && !t;
  }
  function ar(e, t) {
    return e && t ? pt.default(e, t) : !e && !t;
  }
  function nr(e, t) {
    return e && t ? dt.default(e, t) : !e && !t;
  }
  function or(e, t) {
    return e && t ? it.default(e, t) : !e && !t;
  }
  function sr(e, t) {
    return e && t ? st.default(e, t) : !e && !t;
  }
  function ir(e, t, r) {
    var a,
      n = Xe.default(t),
      o = at.default(r);
    try {
      a = ft.default(e, {
        start: n,
        end: o
      });
    } catch (e) {
      a = !1;
    }
    return a;
  }
  function pr() {
    return ("undefined" != typeof window ? window : globalThis).__localeId__;
  }
  function lr(e) {
    if ("string" == typeof e) {
      var t = "undefined" != typeof window ? window : globalThis;
      return t.__localeData__ ? t.__localeData__[e] : null;
    }
    return e;
  }
  function dr(e, t) {
    return jt(He.default(Bt(), e), "LLLL", t);
  }
  function cr(e, t) {
    return jt(He.default(Bt(), e), "LLL", t);
  }
  function ur(e, t) {
    return jt(je.default(Bt(), e), "QQQ", t);
  }
  function fr(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = t.minDate,
      a = t.maxDate,
      n = t.excludeDates,
      o = t.excludeDateIntervals,
      s = t.includeDates,
      i = t.includeDateIntervals,
      p = t.filterDate;
    return gr(e, {
      minDate: r,
      maxDate: a
    }) || n && n.some(function (t) {
      return or(e, t);
    }) || o && o.some(function (t) {
      var r = t.start,
        a = t.end;
      return ft.default(e, {
        start: r,
        end: a
      });
    }) || s && !s.some(function (t) {
      return or(e, t);
    }) || i && !i.some(function (t) {
      var r = t.start,
        a = t.end;
      return ft.default(e, {
        start: r,
        end: a
      });
    }) || p && !p(Bt(e)) || !1;
  }
  function hr(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = t.excludeDates,
      a = t.excludeDateIntervals;
    return a && a.length > 0 ? a.some(function (t) {
      var r = t.start,
        a = t.end;
      return ft.default(e, {
        start: r,
        end: a
      });
    }) : r && r.some(function (t) {
      return or(e, t);
    }) || !1;
  }
  function mr(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = t.minDate,
      a = t.maxDate,
      n = t.excludeDates,
      o = t.includeDates,
      s = t.filterDate;
    return gr(e, {
      minDate: et.default(r),
      maxDate: nt.default(a)
    }) || n && n.some(function (t) {
      return ar(e, t);
    }) || o && !o.some(function (t) {
      return ar(e, t);
    }) || s && !s(Bt(e)) || !1;
  }
  function yr(e, t, r, a) {
    var n = qe.default(e),
      o = Fe.default(e),
      s = qe.default(t),
      i = Fe.default(t),
      p = qe.default(a);
    return n === s && n === p ? o <= r && r <= i : n < s ? p === n && o <= r || p === s && i >= r || p < s && p > n : void 0;
  }
  function vr(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = t.minDate,
      a = t.maxDate,
      n = t.excludeDates,
      o = t.includeDates,
      s = t.filterDate;
    return gr(e, {
      minDate: r,
      maxDate: a
    }) || n && n.some(function (t) {
      return nr(e, t);
    }) || o && !o.some(function (t) {
      return nr(e, t);
    }) || s && !s(Bt(e)) || !1;
  }
  function Dr(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = t.minDate,
      a = t.maxDate,
      n = t.excludeDates,
      o = t.includeDates,
      s = t.filterDate,
      i = new Date(e, 0, 1);
    return gr(i, {
      minDate: rt.default(r),
      maxDate: ot.default(a)
    }) || n && n.some(function (e) {
      return rr(i, e);
    }) || o && !o.some(function (e) {
      return rr(i, e);
    }) || s && !s(Bt(i)) || !1;
  }
  function wr(e, t, r, a) {
    var n = qe.default(e),
      o = Ae.default(e),
      s = qe.default(t),
      i = Ae.default(t),
      p = qe.default(a);
    return n === s && n === p ? o <= r && r <= i : n < s ? p === n && o <= r || p === s && i >= r || p < s && p > n : void 0;
  }
  function gr(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = t.minDate,
      a = t.maxDate;
    return r && $e.default(e, r) < 0 || a && $e.default(e, a) > 0;
  }
  function kr(e, t) {
    return t.some(function (t) {
      return Ie.default(t) === Ie.default(e) && Ye.default(t) === Ye.default(e);
    });
  }
  function br(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = t.excludeTimes,
      a = t.includeTimes,
      n = t.filterTime;
    return r && kr(e, r) || a && !kr(e, a) || n && !n(e) || !1;
  }
  function Sr(e, t) {
    var r = t.minTime,
      a = t.maxTime;
    if (!r || !a) throw new Error("Both minTime and maxTime props required");
    var n,
      o = Bt(),
      s = Qe.default(Be.default(o, Ye.default(e)), Ie.default(e)),
      i = Qe.default(Be.default(o, Ye.default(r)), Ie.default(r)),
      p = Qe.default(Be.default(o, Ye.default(a)), Ie.default(a));
    try {
      n = !ft.default(s, {
        start: i,
        end: p
      });
    } catch (e) {
      n = !1;
    }
    return n;
  }
  function Cr(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = t.minDate,
      a = t.includeDates,
      n = Ee.default(e, 1);
    return r && Ge.default(r, n) > 0 || a && a.every(function (e) {
      return Ge.default(e, n) > 0;
    }) || !1;
  }
  function _r(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = t.maxDate,
      a = t.includeDates,
      n = Se.default(e, 1);
    return r && Ge.default(n, r) > 0 || a && a.every(function (e) {
      return Ge.default(n, e) > 0;
    }) || !1;
  }
  function Mr(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = t.minDate,
      a = t.includeDates,
      n = xe.default(e, 1);
    return r && Je.default(r, n) > 0 || a && a.every(function (e) {
      return Je.default(e, n) > 0;
    }) || !1;
  }
  function Pr(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = t.maxDate,
      a = t.includeDates,
      n = _e.default(e, 1);
    return r && Je.default(n, r) > 0 || a && a.every(function (e) {
      return Je.default(n, e) > 0;
    }) || !1;
  }
  function Er(e) {
    var t = e.minDate,
      r = e.includeDates;
    if (r && t) {
      var a = r.filter(function (e) {
        return $e.default(e, t) >= 0;
      });
      return Ue.default(a);
    }
    return r ? Ue.default(r) : t;
  }
  function Nr(e) {
    var t = e.maxDate,
      r = e.includeDates;
    if (r && t) {
      var a = r.filter(function (e) {
        return $e.default(e, t) <= 0;
      });
      return ze.default(a);
    }
    return r ? ze.default(r) : t;
  }
  function xr() {
    for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--highlighted", r = new Map(), a = 0, n = e.length; a < n; a++) {
      var o = e[a];
      if (ye.default(o)) {
        var s = jt(o, "MM.dd.yyyy"),
          i = r.get(s) || [];
        i.includes(t) || (i.push(t), r.set(s, i));
      } else if ("object" === bt(o)) {
        var p = Object.keys(o),
          l = p[0],
          d = o[p[0]];
        if ("string" == typeof l && d.constructor === Array) for (var c = 0, u = d.length; c < u; c++) {
          var f = jt(d[c], "MM.dd.yyyy"),
            h = r.get(f) || [];
          h.includes(l) || (h.push(l), r.set(f, h));
        }
      }
    }
    return r;
  }
  function Or(e, t, r, a, n) {
    for (var o = n.length, s = [], i = 0; i < o; i++) {
      var p = we.default(ge.default(e, Ie.default(n[i])), Ye.default(n[i])),
        l = we.default(e, (r + 1) * a);
      ct.default(p, t) && ut.default(p, l) && s.push(n[i]);
    }
    return s;
  }
  function Yr(e) {
    return e < 10 ? "0".concat(e) : "".concat(e);
  }
  function Ir(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Kt,
      r = Math.ceil(qe.default(e) / t) * t,
      a = r - (t - 1);
    return {
      startPeriod: a,
      endPeriod: r
    };
  }
  function Tr(e, t, r, a) {
    for (var n = [], o = 0; o < 2 * t + 1; o++) {
      var s = e + t - o,
        i = !0;
      r && (i = qe.default(r) <= s), a && i && (i = qe.default(a) >= s), i && n.push(s);
    }
    return n;
  }
  var Lr = function (e) {
      Et(a, e);
      var r = It(a);
      function a(e) {
        var n;
        St(this, a), Mt(Ot(n = r.call(this, e)), "renderOptions", function () {
          var e = n.props.year,
            t = n.state.yearsList.map(function (t) {
              return he.default.createElement("div", {
                className: e === t ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                key: t,
                onClick: n.onChange.bind(Ot(n), t),
                "aria-selected": e === t ? "true" : void 0
              }, e === t ? he.default.createElement("span", {
                className: "react-datepicker__year-option--selected"
              }, "✓") : "", t);
            }),
            r = n.props.minDate ? qe.default(n.props.minDate) : null,
            a = n.props.maxDate ? qe.default(n.props.maxDate) : null;
          return a && n.state.yearsList.find(function (e) {
            return e === a;
          }) || t.unshift(he.default.createElement("div", {
            className: "react-datepicker__year-option",
            key: "upcoming",
            onClick: n.incrementYears
          }, he.default.createElement("a", {
            className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
          }))), r && n.state.yearsList.find(function (e) {
            return e === r;
          }) || t.push(he.default.createElement("div", {
            className: "react-datepicker__year-option",
            key: "previous",
            onClick: n.decrementYears
          }, he.default.createElement("a", {
            className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
          }))), t;
        }), Mt(Ot(n), "onChange", function (e) {
          n.props.onChange(e);
        }), Mt(Ot(n), "handleClickOutside", function () {
          n.props.onCancel();
        }), Mt(Ot(n), "shiftYears", function (e) {
          var t = n.state.yearsList.map(function (t) {
            return t + e;
          });
          n.setState({
            yearsList: t
          });
        }), Mt(Ot(n), "incrementYears", function () {
          return n.shiftYears(1);
        }), Mt(Ot(n), "decrementYears", function () {
          return n.shiftYears(-1);
        });
        var o = e.yearDropdownItemNumber,
          s = e.scrollableYearDropdown,
          i = o || (s ? 10 : 5);
        return n.state = {
          yearsList: Tr(n.props.year, i, n.props.minDate, n.props.maxDate)
        }, n.dropdownRef = t.createRef(), n;
      }
      return _t(a, [{
        key: "componentDidMount",
        value: function value() {
          var e = this.dropdownRef.current;
          if (e) {
            var t = e.children ? Array.from(e.children) : null,
              r = t ? t.find(function (e) {
                return e.ariaSelected;
              }) : null;
            e.scrollTop = r ? r.offsetTop + (r.clientHeight - e.clientHeight) / 2 : (e.scrollHeight - e.clientHeight) / 2;
          }
        }
      }, {
        key: "render",
        value: function value() {
          var e = me.default({
            "react-datepicker__year-dropdown": !0,
            "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
          });
          return he.default.createElement("div", {
            className: e,
            ref: this.dropdownRef
          }, this.renderOptions());
        }
      }]), a;
    }(he.default.Component),
    Rr = vt.default(Lr),
    Fr = function (e) {
      Et(r, e);
      var t = It(r);
      function r() {
        var e;
        St(this, r);
        for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) {
          n[o] = arguments[o];
        }
        return Mt(Ot(e = t.call.apply(t, [this].concat(n))), "state", {
          dropdownVisible: !1
        }), Mt(Ot(e), "renderSelectOptions", function () {
          for (var t = e.props.minDate ? qe.default(e.props.minDate) : 1900, r = e.props.maxDate ? qe.default(e.props.maxDate) : 2100, a = [], n = t; n <= r; n++) {
            a.push(he.default.createElement("option", {
              key: n,
              value: n
            }, n));
          }
          return a;
        }), Mt(Ot(e), "onSelectChange", function (t) {
          e.onChange(t.target.value);
        }), Mt(Ot(e), "renderSelectMode", function () {
          return he.default.createElement("select", {
            value: e.props.year,
            className: "react-datepicker__year-select",
            onChange: e.onSelectChange
          }, e.renderSelectOptions());
        }), Mt(Ot(e), "renderReadView", function (t) {
          return he.default.createElement("div", {
            key: "read",
            style: {
              visibility: t ? "visible" : "hidden"
            },
            className: "react-datepicker__year-read-view",
            onClick: function onClick(t) {
              return e.toggleDropdown(t);
            }
          }, he.default.createElement("span", {
            className: "react-datepicker__year-read-view--down-arrow"
          }), he.default.createElement("span", {
            className: "react-datepicker__year-read-view--selected-year"
          }, e.props.year));
        }), Mt(Ot(e), "renderDropdown", function () {
          return he.default.createElement(Rr, {
            key: "dropdown",
            year: e.props.year,
            onChange: e.onChange,
            onCancel: e.toggleDropdown,
            minDate: e.props.minDate,
            maxDate: e.props.maxDate,
            scrollableYearDropdown: e.props.scrollableYearDropdown,
            yearDropdownItemNumber: e.props.yearDropdownItemNumber
          });
        }), Mt(Ot(e), "renderScrollMode", function () {
          var t = e.state.dropdownVisible,
            r = [e.renderReadView(!t)];
          return t && r.unshift(e.renderDropdown()), r;
        }), Mt(Ot(e), "onChange", function (t) {
          e.toggleDropdown(), t !== e.props.year && e.props.onChange(t);
        }), Mt(Ot(e), "toggleDropdown", function (t) {
          e.setState({
            dropdownVisible: !e.state.dropdownVisible
          }, function () {
            e.props.adjustDateOnChange && e.handleYearChange(e.props.date, t);
          });
        }), Mt(Ot(e), "handleYearChange", function (t, r) {
          e.onSelect(t, r), e.setOpen();
        }), Mt(Ot(e), "onSelect", function (t, r) {
          e.props.onSelect && e.props.onSelect(t, r);
        }), Mt(Ot(e), "setOpen", function () {
          e.props.setOpen && e.props.setOpen(!0);
        }), e;
      }
      return _t(r, [{
        key: "render",
        value: function value() {
          var e;
          switch (this.props.dropdownMode) {
            case "scroll":
              e = this.renderScrollMode();
              break;
            case "select":
              e = this.renderSelectMode();
          }
          return he.default.createElement("div", {
            className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
          }, e);
        }
      }]), r;
    }(he.default.Component),
    Ar = function (e) {
      Et(r, e);
      var t = It(r);
      function r() {
        var e;
        St(this, r);
        for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) {
          n[o] = arguments[o];
        }
        return Mt(Ot(e = t.call.apply(t, [this].concat(n))), "isSelectedMonth", function (t) {
          return e.props.month === t;
        }), Mt(Ot(e), "renderOptions", function () {
          return e.props.monthNames.map(function (t, r) {
            return he.default.createElement("div", {
              className: e.isSelectedMonth(r) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
              key: t,
              onClick: e.onChange.bind(Ot(e), r),
              "aria-selected": e.isSelectedMonth(r) ? "true" : void 0
            }, e.isSelectedMonth(r) ? he.default.createElement("span", {
              className: "react-datepicker__month-option--selected"
            }, "✓") : "", t);
          });
        }), Mt(Ot(e), "onChange", function (t) {
          return e.props.onChange(t);
        }), Mt(Ot(e), "handleClickOutside", function () {
          return e.props.onCancel();
        }), e;
      }
      return _t(r, [{
        key: "render",
        value: function value() {
          return he.default.createElement("div", {
            className: "react-datepicker__month-dropdown"
          }, this.renderOptions());
        }
      }]), r;
    }(he.default.Component),
    qr = vt.default(Ar),
    Kr = function (e) {
      Et(r, e);
      var t = It(r);
      function r() {
        var e;
        St(this, r);
        for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) {
          n[o] = arguments[o];
        }
        return Mt(Ot(e = t.call.apply(t, [this].concat(n))), "state", {
          dropdownVisible: !1
        }), Mt(Ot(e), "renderSelectOptions", function (e) {
          return e.map(function (e, t) {
            return he.default.createElement("option", {
              key: t,
              value: t
            }, e);
          });
        }), Mt(Ot(e), "renderSelectMode", function (t) {
          return he.default.createElement("select", {
            value: e.props.month,
            className: "react-datepicker__month-select",
            onChange: function onChange(t) {
              return e.onChange(t.target.value);
            }
          }, e.renderSelectOptions(t));
        }), Mt(Ot(e), "renderReadView", function (t, r) {
          return he.default.createElement("div", {
            key: "read",
            style: {
              visibility: t ? "visible" : "hidden"
            },
            className: "react-datepicker__month-read-view",
            onClick: e.toggleDropdown
          }, he.default.createElement("span", {
            className: "react-datepicker__month-read-view--down-arrow"
          }), he.default.createElement("span", {
            className: "react-datepicker__month-read-view--selected-month"
          }, r[e.props.month]));
        }), Mt(Ot(e), "renderDropdown", function (t) {
          return he.default.createElement(qr, {
            key: "dropdown",
            month: e.props.month,
            monthNames: t,
            onChange: e.onChange,
            onCancel: e.toggleDropdown
          });
        }), Mt(Ot(e), "renderScrollMode", function (t) {
          var r = e.state.dropdownVisible,
            a = [e.renderReadView(!r, t)];
          return r && a.unshift(e.renderDropdown(t)), a;
        }), Mt(Ot(e), "onChange", function (t) {
          e.toggleDropdown(), t !== e.props.month && e.props.onChange(t);
        }), Mt(Ot(e), "toggleDropdown", function () {
          return e.setState({
            dropdownVisible: !e.state.dropdownVisible
          });
        }), e;
      }
      return _t(r, [{
        key: "render",
        value: function value() {
          var e,
            t = this,
            r = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function (e) {
              return cr(e, t.props.locale);
            } : function (e) {
              return dr(e, t.props.locale);
            });
          switch (this.props.dropdownMode) {
            case "scroll":
              e = this.renderScrollMode(r);
              break;
            case "select":
              e = this.renderSelectMode(r);
          }
          return he.default.createElement("div", {
            className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
          }, e);
        }
      }]), r;
    }(he.default.Component);
  function Wr(e, t) {
    for (var r = [], a = Xt(e), n = Xt(t); !ct.default(a, n);) {
      r.push(Bt(a)), a = Se.default(a, 1);
    }
    return r;
  }
  var Br = function (e) {
      Et(r, e);
      var t = It(r);
      function r(e) {
        var a;
        return St(this, r), Mt(Ot(a = t.call(this, e)), "renderOptions", function () {
          return a.state.monthYearsList.map(function (e) {
            var t = Ke.default(e),
              r = rr(a.props.date, e) && ar(a.props.date, e);
            return he.default.createElement("div", {
              className: r ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
              key: t,
              onClick: a.onChange.bind(Ot(a), t),
              "aria-selected": r ? "true" : void 0
            }, r ? he.default.createElement("span", {
              className: "react-datepicker__month-year-option--selected"
            }, "✓") : "", jt(e, a.props.dateFormat, a.props.locale));
          });
        }), Mt(Ot(a), "onChange", function (e) {
          return a.props.onChange(e);
        }), Mt(Ot(a), "handleClickOutside", function () {
          a.props.onCancel();
        }), a.state = {
          monthYearsList: Wr(a.props.minDate, a.props.maxDate)
        }, a;
      }
      return _t(r, [{
        key: "render",
        value: function value() {
          var e = me.default({
            "react-datepicker__month-year-dropdown": !0,
            "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
          });
          return he.default.createElement("div", {
            className: e
          }, this.renderOptions());
        }
      }]), r;
    }(he.default.Component),
    Qr = vt.default(Br),
    Hr = function (e) {
      Et(r, e);
      var t = It(r);
      function r() {
        var e;
        St(this, r);
        for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) {
          n[o] = arguments[o];
        }
        return Mt(Ot(e = t.call.apply(t, [this].concat(n))), "state", {
          dropdownVisible: !1
        }), Mt(Ot(e), "renderSelectOptions", function () {
          for (var t = Xt(e.props.minDate), r = Xt(e.props.maxDate), a = []; !ct.default(t, r);) {
            var n = Ke.default(t);
            a.push(he.default.createElement("option", {
              key: n,
              value: n
            }, jt(t, e.props.dateFormat, e.props.locale))), t = Se.default(t, 1);
          }
          return a;
        }), Mt(Ot(e), "onSelectChange", function (t) {
          e.onChange(t.target.value);
        }), Mt(Ot(e), "renderSelectMode", function () {
          return he.default.createElement("select", {
            value: Ke.default(Xt(e.props.date)),
            className: "react-datepicker__month-year-select",
            onChange: e.onSelectChange
          }, e.renderSelectOptions());
        }), Mt(Ot(e), "renderReadView", function (t) {
          var r = jt(e.props.date, e.props.dateFormat, e.props.locale);
          return he.default.createElement("div", {
            key: "read",
            style: {
              visibility: t ? "visible" : "hidden"
            },
            className: "react-datepicker__month-year-read-view",
            onClick: function onClick(t) {
              return e.toggleDropdown(t);
            }
          }, he.default.createElement("span", {
            className: "react-datepicker__month-year-read-view--down-arrow"
          }), he.default.createElement("span", {
            className: "react-datepicker__month-year-read-view--selected-month-year"
          }, r));
        }), Mt(Ot(e), "renderDropdown", function () {
          return he.default.createElement(Qr, {
            key: "dropdown",
            date: e.props.date,
            dateFormat: e.props.dateFormat,
            onChange: e.onChange,
            onCancel: e.toggleDropdown,
            minDate: e.props.minDate,
            maxDate: e.props.maxDate,
            scrollableMonthYearDropdown: e.props.scrollableMonthYearDropdown,
            locale: e.props.locale
          });
        }), Mt(Ot(e), "renderScrollMode", function () {
          var t = e.state.dropdownVisible,
            r = [e.renderReadView(!t)];
          return t && r.unshift(e.renderDropdown()), r;
        }), Mt(Ot(e), "onChange", function (t) {
          e.toggleDropdown();
          var r = Bt(parseInt(t));
          rr(e.props.date, r) && ar(e.props.date, r) || e.props.onChange(r);
        }), Mt(Ot(e), "toggleDropdown", function () {
          return e.setState({
            dropdownVisible: !e.state.dropdownVisible
          });
        }), e;
      }
      return _t(r, [{
        key: "render",
        value: function value() {
          var e;
          switch (this.props.dropdownMode) {
            case "scroll":
              e = this.renderScrollMode();
              break;
            case "select":
              e = this.renderSelectMode();
          }
          return he.default.createElement("div", {
            className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
          }, e);
        }
      }]), r;
    }(he.default.Component),
    jr = function (e) {
      Et(r, e);
      var t = It(r);
      function r() {
        var e;
        St(this, r);
        for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) {
          n[o] = arguments[o];
        }
        return Mt(Ot(e = t.call.apply(t, [this].concat(n))), "dayEl", he.default.createRef()), Mt(Ot(e), "handleClick", function (t) {
          !e.isDisabled() && e.props.onClick && e.props.onClick(t);
        }), Mt(Ot(e), "handleMouseEnter", function (t) {
          !e.isDisabled() && e.props.onMouseEnter && e.props.onMouseEnter(t);
        }), Mt(Ot(e), "handleOnKeyDown", function (t) {
          " " === t.key && (t.preventDefault(), t.key = "Enter"), e.props.handleOnKeyDown(t);
        }), Mt(Ot(e), "isSameDay", function (t) {
          return or(e.props.day, t);
        }), Mt(Ot(e), "isKeyboardSelected", function () {
          return !e.props.disabledKeyboardNavigation && !e.isSameDay(e.props.selected) && e.isSameDay(e.props.preSelection);
        }), Mt(Ot(e), "isDisabled", function () {
          return fr(e.props.day, e.props);
        }), Mt(Ot(e), "isExcluded", function () {
          return hr(e.props.day, e.props);
        }), Mt(Ot(e), "getHighLightedClass", function (t) {
          var r = e.props,
            a = r.day,
            n = r.highlightDates;
          if (!n) return !1;
          var o = jt(a, "MM.dd.yyyy");
          return n.get(o);
        }), Mt(Ot(e), "isInRange", function () {
          var t = e.props,
            r = t.day,
            a = t.startDate,
            n = t.endDate;
          return !(!a || !n) && ir(r, a, n);
        }), Mt(Ot(e), "isInSelectingRange", function () {
          var t,
            r = e.props,
            a = r.day,
            n = r.selectsStart,
            o = r.selectsEnd,
            s = r.selectsRange,
            i = r.selectsDisabledDaysInRange,
            p = r.startDate,
            l = r.endDate,
            d = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
          return !(!(n || o || s) || !d || !i && e.isDisabled()) && (n && l && (ut.default(d, l) || sr(d, l)) ? ir(a, d, l) : (o && p && (ct.default(d, p) || sr(d, p)) || !(!s || !p || l || !ct.default(d, p) && !sr(d, p))) && ir(a, p, d));
        }), Mt(Ot(e), "isSelectingRangeStart", function () {
          var t;
          if (!e.isInSelectingRange()) return !1;
          var r = e.props,
            a = r.day,
            n = r.startDate,
            o = r.selectsStart,
            s = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
          return or(a, o ? s : n);
        }), Mt(Ot(e), "isSelectingRangeEnd", function () {
          var t;
          if (!e.isInSelectingRange()) return !1;
          var r = e.props,
            a = r.day,
            n = r.endDate,
            o = r.selectsEnd,
            s = r.selectsRange,
            i = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
          return or(a, o || s ? i : n);
        }), Mt(Ot(e), "isRangeStart", function () {
          var t = e.props,
            r = t.day,
            a = t.startDate,
            n = t.endDate;
          return !(!a || !n) && or(a, r);
        }), Mt(Ot(e), "isRangeEnd", function () {
          var t = e.props,
            r = t.day,
            a = t.startDate,
            n = t.endDate;
          return !(!a || !n) && or(n, r);
        }), Mt(Ot(e), "isWeekend", function () {
          var t = Te.default(e.props.day);
          return 0 === t || 6 === t;
        }), Mt(Ot(e), "isAfterMonth", function () {
          return void 0 !== e.props.month && (e.props.month + 1) % 12 === Fe.default(e.props.day);
        }), Mt(Ot(e), "isBeforeMonth", function () {
          return void 0 !== e.props.month && (Fe.default(e.props.day) + 1) % 12 === e.props.month;
        }), Mt(Ot(e), "isCurrentDay", function () {
          return e.isSameDay(Bt());
        }), Mt(Ot(e), "isSelected", function () {
          return e.isSameDay(e.props.selected);
        }), Mt(Ot(e), "getClassNames", function (t) {
          var r = e.props.dayClassName ? e.props.dayClassName(t) : void 0;
          return me.default("react-datepicker__day", r, "react-datepicker__day--" + $t(e.props.day), {
            "react-datepicker__day--disabled": e.isDisabled(),
            "react-datepicker__day--excluded": e.isExcluded(),
            "react-datepicker__day--selected": e.isSelected(),
            "react-datepicker__day--keyboard-selected": e.isKeyboardSelected(),
            "react-datepicker__day--range-start": e.isRangeStart(),
            "react-datepicker__day--range-end": e.isRangeEnd(),
            "react-datepicker__day--in-range": e.isInRange(),
            "react-datepicker__day--in-selecting-range": e.isInSelectingRange(),
            "react-datepicker__day--selecting-range-start": e.isSelectingRangeStart(),
            "react-datepicker__day--selecting-range-end": e.isSelectingRangeEnd(),
            "react-datepicker__day--today": e.isCurrentDay(),
            "react-datepicker__day--weekend": e.isWeekend(),
            "react-datepicker__day--outside-month": e.isAfterMonth() || e.isBeforeMonth()
          }, e.getHighLightedClass("react-datepicker__day--highlighted"));
        }), Mt(Ot(e), "getAriaLabel", function () {
          var t = e.props,
            r = t.day,
            a = t.ariaLabelPrefixWhenEnabled,
            n = void 0 === a ? "Choose" : a,
            o = t.ariaLabelPrefixWhenDisabled,
            s = void 0 === o ? "Not available" : o,
            i = e.isDisabled() || e.isExcluded() ? s : n;
          return "".concat(i, " ").concat(jt(r, "PPPP", e.props.locale));
        }), Mt(Ot(e), "getTabIndex", function (t, r) {
          var a = t || e.props.selected,
            n = r || e.props.preSelection;
          return e.isKeyboardSelected() || e.isSameDay(a) && or(n, a) ? 0 : -1;
        }), Mt(Ot(e), "handleFocusDay", function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = !1;
          0 === e.getTabIndex() && !t.isInputFocused && e.isSameDay(e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (r = !0), e.props.inline && !e.props.shouldFocusDayInline && (r = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (r = !0)), r && e.dayEl.current.focus({
            preventScroll: !0
          });
        }), Mt(Ot(e), "renderDayContents", function () {
          return e.props.monthShowsDuplicateDaysEnd && e.isAfterMonth() || e.props.monthShowsDuplicateDaysStart && e.isBeforeMonth() ? null : e.props.renderDayContents ? e.props.renderDayContents(Le.default(e.props.day), e.props.day) : Le.default(e.props.day);
        }), Mt(Ot(e), "render", function () {
          return he.default.createElement("div", {
            ref: e.dayEl,
            className: e.getClassNames(e.props.day),
            onKeyDown: e.handleOnKeyDown,
            onClick: e.handleClick,
            onMouseEnter: e.handleMouseEnter,
            tabIndex: e.getTabIndex(),
            "aria-label": e.getAriaLabel(),
            role: "option",
            "aria-disabled": e.isDisabled(),
            "aria-current": e.isCurrentDay() ? "date" : void 0,
            "aria-selected": e.isSelected()
          }, e.renderDayContents());
        }), e;
      }
      return _t(r, [{
        key: "componentDidMount",
        value: function value() {
          this.handleFocusDay();
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e) {
          this.handleFocusDay(e);
        }
      }]), r;
    }(he.default.Component),
    Vr = function (e) {
      Et(r, e);
      var t = It(r);
      function r() {
        var e;
        St(this, r);
        for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) {
          n[o] = arguments[o];
        }
        return Mt(Ot(e = t.call.apply(t, [this].concat(n))), "handleClick", function (t) {
          e.props.onClick && e.props.onClick(t);
        }), e;
      }
      return _t(r, [{
        key: "render",
        value: function value() {
          var e = this.props,
            t = e.weekNumber,
            r = e.ariaLabelPrefix,
            a = void 0 === r ? "week " : r,
            n = {
              "react-datepicker__week-number": !0,
              "react-datepicker__week-number--clickable": !!e.onClick
            };
          return he.default.createElement("div", {
            className: me.default(n),
            "aria-label": "".concat(a, " ").concat(this.props.weekNumber),
            onClick: this.handleClick
          }, t);
        }
      }]), r;
    }(he.default.Component),
    Ur = function (e) {
      Et(r, e);
      var t = It(r);
      function r() {
        var e;
        St(this, r);
        for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) {
          n[o] = arguments[o];
        }
        return Mt(Ot(e = t.call.apply(t, [this].concat(n))), "handleDayClick", function (t, r) {
          e.props.onDayClick && e.props.onDayClick(t, r);
        }), Mt(Ot(e), "handleDayMouseEnter", function (t) {
          e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
        }), Mt(Ot(e), "handleWeekClick", function (t, r, a) {
          "function" == typeof e.props.onWeekSelect && e.props.onWeekSelect(t, r, a), e.props.shouldCloseOnSelect && e.props.setOpen(!1);
        }), Mt(Ot(e), "formatWeekNumber", function (t) {
          return e.props.formatWeekNumber ? e.props.formatWeekNumber(t) : zt(t);
        }), Mt(Ot(e), "renderDays", function () {
          var t = Jt(e.props.day, e.props.locale, e.props.calendarStartDay),
            r = [],
            a = e.formatWeekNumber(t);
          if (e.props.showWeekNumber) {
            var n = e.props.onWeekSelect ? e.handleWeekClick.bind(Ot(e), t, a) : void 0;
            r.push(he.default.createElement(Vr, {
              key: "W",
              weekNumber: a,
              onClick: n,
              ariaLabelPrefix: e.props.ariaLabelPrefix
            }));
          }
          return r.concat([0, 1, 2, 3, 4, 5, 6].map(function (r) {
            var a = ke.default(t, r);
            return he.default.createElement(jr, {
              ariaLabelPrefixWhenEnabled: e.props.chooseDayAriaLabelPrefix,
              ariaLabelPrefixWhenDisabled: e.props.disabledDayAriaLabelPrefix,
              key: a.valueOf(),
              day: a,
              month: e.props.month,
              onClick: e.handleDayClick.bind(Ot(e), a),
              onMouseEnter: e.handleDayMouseEnter.bind(Ot(e), a),
              minDate: e.props.minDate,
              maxDate: e.props.maxDate,
              excludeDates: e.props.excludeDates,
              excludeDateIntervals: e.props.excludeDateIntervals,
              includeDates: e.props.includeDates,
              includeDateIntervals: e.props.includeDateIntervals,
              highlightDates: e.props.highlightDates,
              selectingDate: e.props.selectingDate,
              filterDate: e.props.filterDate,
              preSelection: e.props.preSelection,
              selected: e.props.selected,
              selectsStart: e.props.selectsStart,
              selectsEnd: e.props.selectsEnd,
              selectsRange: e.props.selectsRange,
              selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
              startDate: e.props.startDate,
              endDate: e.props.endDate,
              dayClassName: e.props.dayClassName,
              renderDayContents: e.props.renderDayContents,
              disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
              handleOnKeyDown: e.props.handleOnKeyDown,
              isInputFocused: e.props.isInputFocused,
              containerRef: e.props.containerRef,
              inline: e.props.inline,
              shouldFocusDayInline: e.props.shouldFocusDayInline,
              monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
              monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart,
              locale: e.props.locale
            });
          }));
        }), e;
      }
      return _t(r, [{
        key: "render",
        value: function value() {
          return he.default.createElement("div", {
            className: "react-datepicker__week"
          }, this.renderDays());
        }
      }], [{
        key: "defaultProps",
        get: function get() {
          return {
            shouldCloseOnSelect: !0
          };
        }
      }]), r;
    }(he.default.Component),
    zr = function (e) {
      Et(r, e);
      var t = It(r);
      function r() {
        var e;
        St(this, r);
        for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) {
          n[o] = arguments[o];
        }
        return Mt(Ot(e = t.call.apply(t, [this].concat(n))), "MONTH_REFS", Tt(Array(12)).map(function () {
          return he.default.createRef();
        })), Mt(Ot(e), "QUARTER_REFS", Tt(Array(4)).map(function () {
          return he.default.createRef();
        })), Mt(Ot(e), "isDisabled", function (t) {
          return fr(t, e.props);
        }), Mt(Ot(e), "isExcluded", function (t) {
          return hr(t, e.props);
        }), Mt(Ot(e), "handleDayClick", function (t, r) {
          e.props.onDayClick && e.props.onDayClick(t, r, e.props.orderInDisplay);
        }), Mt(Ot(e), "handleDayMouseEnter", function (t) {
          e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
        }), Mt(Ot(e), "handleMouseLeave", function () {
          e.props.onMouseLeave && e.props.onMouseLeave();
        }), Mt(Ot(e), "isRangeStartMonth", function (t) {
          var r = e.props,
            a = r.day,
            n = r.startDate,
            o = r.endDate;
          return !(!n || !o) && ar(He.default(a, t), n);
        }), Mt(Ot(e), "isRangeStartQuarter", function (t) {
          var r = e.props,
            a = r.day,
            n = r.startDate,
            o = r.endDate;
          return !(!n || !o) && nr(je.default(a, t), n);
        }), Mt(Ot(e), "isRangeEndMonth", function (t) {
          var r = e.props,
            a = r.day,
            n = r.startDate,
            o = r.endDate;
          return !(!n || !o) && ar(He.default(a, t), o);
        }), Mt(Ot(e), "isRangeEndQuarter", function (t) {
          var r = e.props,
            a = r.day,
            n = r.startDate,
            o = r.endDate;
          return !(!n || !o) && nr(je.default(a, t), o);
        }), Mt(Ot(e), "isWeekInMonth", function (t) {
          var r = e.props.day,
            a = ke.default(t, 6);
          return ar(t, r) || ar(a, r);
        }), Mt(Ot(e), "isCurrentMonth", function (e, t) {
          return qe.default(e) === qe.default(Bt()) && t === Fe.default(Bt());
        }), Mt(Ot(e), "isCurrentQuarter", function (e, t) {
          return qe.default(e) === qe.default(Bt()) && t === Ae.default(Bt());
        }), Mt(Ot(e), "isSelectedMonth", function (e, t, r) {
          return Fe.default(e) === t && qe.default(e) === qe.default(r);
        }), Mt(Ot(e), "isSelectedQuarter", function (e, t, r) {
          return Ae.default(e) === t && qe.default(e) === qe.default(r);
        }), Mt(Ot(e), "renderWeeks", function () {
          for (var t = [], r = e.props.fixedHeight, a = 0, n = !1, o = Jt(Xt(e.props.day), e.props.locale, e.props.calendarStartDay); t.push(he.default.createElement(Ur, {
            ariaLabelPrefix: e.props.weekAriaLabelPrefix,
            chooseDayAriaLabelPrefix: e.props.chooseDayAriaLabelPrefix,
            disabledDayAriaLabelPrefix: e.props.disabledDayAriaLabelPrefix,
            key: a,
            day: o,
            month: Fe.default(e.props.day),
            onDayClick: e.handleDayClick,
            onDayMouseEnter: e.handleDayMouseEnter,
            onWeekSelect: e.props.onWeekSelect,
            formatWeekNumber: e.props.formatWeekNumber,
            locale: e.props.locale,
            minDate: e.props.minDate,
            maxDate: e.props.maxDate,
            excludeDates: e.props.excludeDates,
            excludeDateIntervals: e.props.excludeDateIntervals,
            includeDates: e.props.includeDates,
            includeDateIntervals: e.props.includeDateIntervals,
            inline: e.props.inline,
            shouldFocusDayInline: e.props.shouldFocusDayInline,
            highlightDates: e.props.highlightDates,
            selectingDate: e.props.selectingDate,
            filterDate: e.props.filterDate,
            preSelection: e.props.preSelection,
            selected: e.props.selected,
            selectsStart: e.props.selectsStart,
            selectsEnd: e.props.selectsEnd,
            selectsRange: e.props.selectsRange,
            selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
            showWeekNumber: e.props.showWeekNumbers,
            startDate: e.props.startDate,
            endDate: e.props.endDate,
            dayClassName: e.props.dayClassName,
            setOpen: e.props.setOpen,
            shouldCloseOnSelect: e.props.shouldCloseOnSelect,
            disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
            renderDayContents: e.props.renderDayContents,
            handleOnKeyDown: e.props.handleOnKeyDown,
            isInputFocused: e.props.isInputFocused,
            containerRef: e.props.containerRef,
            calendarStartDay: e.props.calendarStartDay,
            monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
            monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart
          })), !n;) {
            a++, o = be.default(o, 1);
            var s = r && a >= 6,
              i = !r && !e.isWeekInMonth(o);
            if (s || i) {
              if (!e.props.peekNextMonth) break;
              n = !0;
            }
          }
          return t;
        }), Mt(Ot(e), "onMonthClick", function (t, r) {
          e.handleDayClick(Xt(He.default(e.props.day, r)), t);
        }), Mt(Ot(e), "handleMonthNavigation", function (t, r) {
          e.isDisabled(r) || e.isExcluded(r) || (e.props.setPreSelection(r), e.MONTH_REFS[t].current && e.MONTH_REFS[t].current.focus());
        }), Mt(Ot(e), "onMonthKeyDown", function (t, r) {
          t.preventDefault();
          var a = t.key;
          if (!e.props.disabledKeyboardNavigation) switch (a) {
            case "Enter":
              e.onMonthClick(t, r), e.props.setPreSelection(e.props.selected);
              break;
            case "ArrowRight":
              e.handleMonthNavigation(11 === r ? 0 : r + 1, Se.default(e.props.preSelection, 1));
              break;
            case "ArrowLeft":
              e.handleMonthNavigation(0 === r ? 11 : r - 1, Ee.default(e.props.preSelection, 1));
              break;
            case "ArrowUp":
              e.handleMonthNavigation(r >= 0 && r <= 2 ? r + 9 : r - 3, Ee.default(e.props.preSelection, 3));
              break;
            case "ArrowDown":
              e.handleMonthNavigation(r >= 9 && r <= 11 ? r - 9 : r + 3, Se.default(e.props.preSelection, 3));
          }
        }), Mt(Ot(e), "onQuarterClick", function (t, r) {
          e.handleDayClick(er(je.default(e.props.day, r)), t);
        }), Mt(Ot(e), "handleQuarterNavigation", function (t, r) {
          e.isDisabled(r) || e.isExcluded(r) || (e.props.setPreSelection(r), e.QUARTER_REFS[t - 1].current && e.QUARTER_REFS[t - 1].current.focus());
        }), Mt(Ot(e), "onQuarterKeyDown", function (t, r) {
          var a = t.key;
          if (!e.props.disabledKeyboardNavigation) switch (a) {
            case "Enter":
              e.onQuarterClick(t, r), e.props.setPreSelection(e.props.selected);
              break;
            case "ArrowRight":
              e.handleQuarterNavigation(4 === r ? 1 : r + 1, Ce.default(e.props.preSelection, 1));
              break;
            case "ArrowLeft":
              e.handleQuarterNavigation(1 === r ? 4 : r - 1, Ne.default(e.props.preSelection, 1));
          }
        }), Mt(Ot(e), "getMonthClassNames", function (t) {
          var r = e.props,
            a = r.day,
            n = r.startDate,
            o = r.endDate,
            s = r.selected,
            i = r.minDate,
            p = r.maxDate,
            l = r.preSelection,
            d = r.monthClassName,
            c = r.excludeDates,
            u = r.includeDates,
            f = d ? d(He.default(a, t)) : void 0,
            h = He.default(a, t);
          return me.default("react-datepicker__month-text", "react-datepicker__month-".concat(t), f, {
            "react-datepicker__month--disabled": (i || p || c || u) && mr(h, e.props),
            "react-datepicker__month--selected": e.isSelectedMonth(a, t, s),
            "react-datepicker__month-text--keyboard-selected": !e.props.disabledKeyboardNavigation && Fe.default(l) === t,
            "react-datepicker__month--in-range": yr(n, o, t, a),
            "react-datepicker__month--range-start": e.isRangeStartMonth(t),
            "react-datepicker__month--range-end": e.isRangeEndMonth(t),
            "react-datepicker__month-text--today": e.isCurrentMonth(a, t)
          });
        }), Mt(Ot(e), "getTabIndex", function (t) {
          var r = Fe.default(e.props.preSelection);
          return e.props.disabledKeyboardNavigation || t !== r ? "-1" : "0";
        }), Mt(Ot(e), "getQuarterTabIndex", function (t) {
          var r = Ae.default(e.props.preSelection);
          return e.props.disabledKeyboardNavigation || t !== r ? "-1" : "0";
        }), Mt(Ot(e), "getAriaLabel", function (t) {
          var r = e.props,
            a = r.chooseDayAriaLabelPrefix,
            n = void 0 === a ? "Choose" : a,
            o = r.disabledDayAriaLabelPrefix,
            s = void 0 === o ? "Not available" : o,
            i = r.day,
            p = He.default(i, t),
            l = e.isDisabled(p) || e.isExcluded(p) ? s : n;
          return "".concat(l, " ").concat(jt(p, "MMMM yyyy"));
        }), Mt(Ot(e), "getQuarterClassNames", function (t) {
          var r = e.props,
            a = r.day,
            n = r.startDate,
            o = r.endDate,
            s = r.selected,
            i = r.minDate,
            p = r.maxDate,
            l = r.preSelection;
          return me.default("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(t), {
            "react-datepicker__quarter--disabled": (i || p) && vr(je.default(a, t), e.props),
            "react-datepicker__quarter--selected": e.isSelectedQuarter(a, t, s),
            "react-datepicker__quarter-text--keyboard-selected": Ae.default(l) === t,
            "react-datepicker__quarter--in-range": wr(n, o, t, a),
            "react-datepicker__quarter--range-start": e.isRangeStartQuarter(t),
            "react-datepicker__quarter--range-end": e.isRangeEndQuarter(t)
          });
        }), Mt(Ot(e), "renderMonths", function () {
          var t = e.props,
            r = t.showFullMonthYearPicker,
            a = t.showTwoColumnMonthYearPicker,
            n = t.showFourColumnMonthYearPicker,
            o = t.locale,
            s = t.day,
            i = t.selected;
          return (n ? [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]] : a ? [[0, 1], [2, 3], [4, 5], [6, 7], [8, 9], [10, 11]] : [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]]).map(function (t, a) {
            return he.default.createElement("div", {
              className: "react-datepicker__month-wrapper",
              key: a
            }, t.map(function (t, a) {
              return he.default.createElement("div", {
                ref: e.MONTH_REFS[t],
                key: a,
                onClick: function onClick(r) {
                  e.onMonthClick(r, t);
                },
                onKeyDown: function onKeyDown(r) {
                  e.onMonthKeyDown(r, t);
                },
                tabIndex: e.getTabIndex(t),
                className: e.getMonthClassNames(t),
                role: "option",
                "aria-label": e.getAriaLabel(t),
                "aria-current": e.isCurrentMonth(s, t) ? "date" : void 0,
                "aria-selected": e.isSelectedMonth(s, t, i)
              }, r ? dr(t, o) : cr(t, o));
            }));
          });
        }), Mt(Ot(e), "renderQuarters", function () {
          var t = e.props,
            r = t.day,
            a = t.selected;
          return he.default.createElement("div", {
            className: "react-datepicker__quarter-wrapper"
          }, [1, 2, 3, 4].map(function (t, n) {
            return he.default.createElement("div", {
              key: n,
              ref: e.QUARTER_REFS[n],
              role: "option",
              onClick: function onClick(r) {
                e.onQuarterClick(r, t);
              },
              onKeyDown: function onKeyDown(r) {
                e.onQuarterKeyDown(r, t);
              },
              className: e.getQuarterClassNames(t),
              "aria-selected": e.isSelectedQuarter(r, t, a),
              tabIndex: e.getQuarterTabIndex(t),
              "aria-current": e.isCurrentQuarter(r, t) ? "date" : void 0
            }, ur(t, e.props.locale));
          }));
        }), Mt(Ot(e), "getClassNames", function () {
          var t = e.props;
          t.day;
          var r = t.selectingDate,
            a = t.selectsStart,
            n = t.selectsEnd,
            o = t.showMonthYearPicker,
            s = t.showQuarterYearPicker;
          return me.default("react-datepicker__month", {
            "react-datepicker__month--selecting-range": r && (a || n)
          }, {
            "react-datepicker__monthPicker": o
          }, {
            "react-datepicker__quarterPicker": s
          });
        }), e;
      }
      return _t(r, [{
        key: "render",
        value: function value() {
          var e = this.props,
            t = e.showMonthYearPicker,
            r = e.showQuarterYearPicker,
            a = e.day,
            n = e.ariaLabelPrefix,
            o = void 0 === n ? "month " : n;
          return he.default.createElement("div", {
            className: this.getClassNames(),
            onMouseLeave: this.handleMouseLeave,
            "aria-label": "".concat(o, " ").concat(jt(a, "yyyy-MM")),
            role: "listbox"
          }, t ? this.renderMonths() : r ? this.renderQuarters() : this.renderWeeks());
        }
      }]), r;
    }(he.default.Component),
    $r = function (e) {
      Et(r, e);
      var t = It(r);
      function r() {
        var e;
        St(this, r);
        for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) {
          n[o] = arguments[o];
        }
        return Mt(Ot(e = t.call.apply(t, [this].concat(n))), "state", {
          height: null
        }), Mt(Ot(e), "handleClick", function (t) {
          (e.props.minTime || e.props.maxTime) && Sr(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && br(t, e.props) || e.props.onChange(t);
        }), Mt(Ot(e), "isSelectedTime", function (t, r, a) {
          return e.props.selected && r === Ie.default(t) && a === Ye.default(t);
        }), Mt(Ot(e), "liClasses", function (t, r, a) {
          var n = ["react-datepicker__time-list-item", e.props.timeClassName ? e.props.timeClassName(t, r, a) : void 0];
          return e.isSelectedTime(t, r, a) && n.push("react-datepicker__time-list-item--selected"), ((e.props.minTime || e.props.maxTime) && Sr(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && br(t, e.props)) && n.push("react-datepicker__time-list-item--disabled"), e.props.injectTimes && (60 * Ie.default(t) + Ye.default(t)) % e.props.intervals != 0 && n.push("react-datepicker__time-list-item--injected"), n.join(" ");
        }), Mt(Ot(e), "handleOnKeyDown", function (t, r) {
          " " === t.key && (t.preventDefault(), t.key = "Enter"), "Enter" === t.key && e.handleClick(r), e.props.handleOnKeyDown(t);
        }), Mt(Ot(e), "renderTimes", function () {
          for (var t = [], r = e.props.format ? e.props.format : "p", a = e.props.intervals, n = Gt(Bt(e.props.selected)), o = 1440 / a, s = e.props.injectTimes && e.props.injectTimes.sort(function (e, t) {
              return e - t;
            }), i = e.props.selected || e.props.openToDate || Bt(), p = Ie.default(i), l = Ye.default(i), d = Qe.default(Be.default(n, l), p), c = 0; c < o; c++) {
            var u = we.default(n, c * a);
            if (t.push(u), s) {
              var f = Or(n, u, c, a, s);
              t = t.concat(f);
            }
          }
          return t.map(function (t, a) {
            return he.default.createElement("li", {
              key: a,
              onClick: e.handleClick.bind(Ot(e), t),
              className: e.liClasses(t, p, l),
              ref: function ref(r) {
                (ut.default(t, d) || sr(t, d)) && (e.centerLi = r);
              },
              onKeyDown: function onKeyDown(r) {
                e.handleOnKeyDown(r, t);
              },
              tabIndex: "0",
              "aria-selected": e.isSelectedTime(t, p, l) ? "true" : void 0
            }, jt(t, r, e.props.locale));
          });
        }), e;
      }
      return _t(r, [{
        key: "componentDidMount",
        value: function value() {
          this.list.scrollTop = this.centerLi && r.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi), this.props.monthRef && this.header && this.setState({
            height: this.props.monthRef.clientHeight - this.header.clientHeight
          });
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
            t = this.state.height;
          return he.default.createElement("div", {
            className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
          }, he.default.createElement("div", {
            className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
            ref: function ref(t) {
              e.header = t;
            }
          }, he.default.createElement("div", {
            className: "react-datepicker-time__header"
          }, this.props.timeCaption)), he.default.createElement("div", {
            className: "react-datepicker__time"
          }, he.default.createElement("div", {
            className: "react-datepicker__time-box"
          }, he.default.createElement("ul", {
            className: "react-datepicker__time-list",
            ref: function ref(t) {
              e.list = t;
            },
            style: t ? {
              height: t
            } : {},
            tabIndex: "0"
          }, this.renderTimes()))));
        }
      }], [{
        key: "defaultProps",
        get: function get() {
          return {
            intervals: 30,
            onTimeChange: function onTimeChange() {},
            todayButton: null,
            timeCaption: "Time"
          };
        }
      }]), r;
    }(he.default.Component);
  Mt($r, "calcCenterPosition", function (e, t) {
    return t.offsetTop - (e / 2 - t.clientHeight / 2);
  });
  var Gr = function (e) {
      Et(r, e);
      var t = It(r);
      function r(e) {
        var a;
        return St(this, r), Mt(Ot(a = t.call(this, e)), "YEAR_REFS", Tt(Array(a.props.yearItemNumber)).map(function () {
          return he.default.createRef();
        })), Mt(Ot(a), "isDisabled", function (e) {
          return fr(e, a.props);
        }), Mt(Ot(a), "isExcluded", function (e) {
          return hr(e, a.props);
        }), Mt(Ot(a), "updateFocusOnPaginate", function (e) {
          var t = function () {
            this.YEAR_REFS[e].current.focus();
          }.bind(Ot(a));
          window.requestAnimationFrame(t);
        }), Mt(Ot(a), "handleYearClick", function (e, t) {
          a.props.onDayClick && a.props.onDayClick(e, t);
        }), Mt(Ot(a), "handleYearNavigation", function (e, t) {
          var r = a.props,
            n = r.date,
            o = r.yearItemNumber,
            s = Ir(n, o).startPeriod;
          a.isDisabled(t) || a.isExcluded(t) || (a.props.setPreSelection(t), e - s == -1 ? a.updateFocusOnPaginate(o - 1) : e - s === o ? a.updateFocusOnPaginate(0) : a.YEAR_REFS[e - s].current.focus());
        }), Mt(Ot(a), "isSameDay", function (e, t) {
          return or(e, t);
        }), Mt(Ot(a), "isCurrentYear", function (e) {
          return e === qe.default(Bt());
        }), Mt(Ot(a), "isKeyboardSelected", function (e) {
          var t = Zt(Ve.default(a.props.date, e));
          return !a.props.disabledKeyboardNavigation && !a.props.inline && !or(t, Zt(a.props.selected)) && or(t, Zt(a.props.preSelection));
        }), Mt(Ot(a), "onYearClick", function (e, t) {
          var r = a.props.date;
          a.handleYearClick(Zt(Ve.default(r, t)), e);
        }), Mt(Ot(a), "onYearKeyDown", function (e, t) {
          var r = e.key;
          if (!a.props.disabledKeyboardNavigation) switch (r) {
            case "Enter":
              a.onYearClick(e, t), a.props.setPreSelection(a.props.selected);
              break;
            case "ArrowRight":
              a.handleYearNavigation(t + 1, _e.default(a.props.preSelection, 1));
              break;
            case "ArrowLeft":
              a.handleYearNavigation(t - 1, xe.default(a.props.preSelection, 1));
          }
        }), Mt(Ot(a), "getYearClassNames", function (e) {
          var t = a.props,
            r = t.minDate,
            n = t.maxDate,
            o = t.selected,
            s = t.excludeDates,
            i = t.includeDates,
            p = t.filterDate;
          return me.default("react-datepicker__year-text", {
            "react-datepicker__year-text--selected": e === qe.default(o),
            "react-datepicker__year-text--disabled": (r || n || s || i || p) && Dr(e, a.props),
            "react-datepicker__year-text--keyboard-selected": a.isKeyboardSelected(e),
            "react-datepicker__year-text--today": a.isCurrentYear(e)
          });
        }), Mt(Ot(a), "getYearTabIndex", function (e) {
          return a.props.disabledKeyboardNavigation ? "-1" : e === qe.default(a.props.preSelection) ? "0" : "-1";
        }), a;
      }
      return _t(r, [{
        key: "render",
        value: function value() {
          for (var e = this, t = [], r = this.props, a = Ir(r.date, r.yearItemNumber), n = a.startPeriod, o = a.endPeriod, s = function s(r) {
              t.push(he.default.createElement("div", {
                ref: e.YEAR_REFS[r - n],
                onClick: function onClick(t) {
                  e.onYearClick(t, r);
                },
                onKeyDown: function onKeyDown(t) {
                  e.onYearKeyDown(t, r);
                },
                tabIndex: e.getYearTabIndex(r),
                className: e.getYearClassNames(r),
                key: r,
                "aria-current": e.isCurrentYear(r) ? "date" : void 0
              }, r));
            }, i = n; i <= o; i++) {
            s(i);
          }
          return he.default.createElement("div", {
            className: "react-datepicker__year"
          }, he.default.createElement("div", {
            className: "react-datepicker__year-wrapper"
          }, t));
        }
      }]), r;
    }(he.default.Component),
    Jr = function (e) {
      Et(r, e);
      var t = It(r);
      function r(e) {
        var a;
        return St(this, r), Mt(Ot(a = t.call(this, e)), "onTimeChange", function (e) {
          a.setState({
            time: e
          });
          var t = new Date();
          t.setHours(e.split(":")[0]), t.setMinutes(e.split(":")[1]), a.props.onChange(t);
        }), Mt(Ot(a), "renderTimeInput", function () {
          var e = a.state.time,
            t = a.props,
            r = t.date,
            n = t.timeString,
            o = t.customTimeInput;
          return o ? he.default.cloneElement(o, {
            date: r,
            value: e,
            onChange: a.onTimeChange
          }) : he.default.createElement("input", {
            type: "time",
            className: "react-datepicker-time__input",
            placeholder: "Time",
            name: "time-input",
            required: !0,
            value: e,
            onChange: function onChange(e) {
              a.onTimeChange(e.target.value || n);
            }
          });
        }), a.state = {
          time: a.props.timeString
        }, a;
      }
      return _t(r, [{
        key: "render",
        value: function value() {
          return he.default.createElement("div", {
            className: "react-datepicker__input-time-container"
          }, he.default.createElement("div", {
            className: "react-datepicker-time__caption"
          }, this.props.timeInputLabel), he.default.createElement("div", {
            className: "react-datepicker-time__input-container"
          }, he.default.createElement("div", {
            className: "react-datepicker-time__input"
          }, this.renderTimeInput())));
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: function value(e, t) {
          return e.timeString !== t.time ? {
            time: e.timeString
          } : null;
        }
      }]), r;
    }(he.default.Component);
  function Xr(e) {
    var t = e.className,
      r = e.children,
      a = e.showPopperArrow,
      n = e.arrowProps,
      o = void 0 === n ? {} : n;
    return he.default.createElement("div", {
      className: t
    }, a && he.default.createElement("div", Pt({
      className: "react-datepicker__triangle"
    }, o)), r);
  }
  var Zr = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"],
    ea = function (e) {
      Et(r, e);
      var t = It(r);
      function r(e) {
        var a;
        return St(this, r), Mt(Ot(a = t.call(this, e)), "handleClickOutside", function (e) {
          a.props.onClickOutside(e);
        }), Mt(Ot(a), "setClickOutsideRef", function () {
          return a.containerRef.current;
        }), Mt(Ot(a), "handleDropdownFocus", function (e) {
          (function () {
            var e = ((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).className || "").split(/\s+/);
            return Zr.some(function (t) {
              return e.indexOf(t) >= 0;
            });
          })(e.target) && a.props.onDropdownFocus();
        }), Mt(Ot(a), "getDateInView", function () {
          var e = a.props,
            t = e.preSelection,
            r = e.selected,
            n = e.openToDate,
            o = Er(a.props),
            s = Nr(a.props),
            i = Bt(),
            p = n || r || t;
          return p || (o && ut.default(i, o) ? o : s && ct.default(i, s) ? s : i);
        }), Mt(Ot(a), "increaseMonth", function () {
          a.setState(function (e) {
            var t = e.date;
            return {
              date: Se.default(t, 1)
            };
          }, function () {
            return a.handleMonthChange(a.state.date);
          });
        }), Mt(Ot(a), "decreaseMonth", function () {
          a.setState(function (e) {
            var t = e.date;
            return {
              date: Ee.default(t, 1)
            };
          }, function () {
            return a.handleMonthChange(a.state.date);
          });
        }), Mt(Ot(a), "handleDayClick", function (e, t, r) {
          a.props.onSelect(e, t, r), a.props.setPreSelection && a.props.setPreSelection(e);
        }), Mt(Ot(a), "handleDayMouseEnter", function (e) {
          a.setState({
            selectingDate: e
          }), a.props.onDayMouseEnter && a.props.onDayMouseEnter(e);
        }), Mt(Ot(a), "handleMonthMouseLeave", function () {
          a.setState({
            selectingDate: null
          }), a.props.onMonthMouseLeave && a.props.onMonthMouseLeave();
        }), Mt(Ot(a), "handleYearChange", function (e) {
          a.props.onYearChange && (a.props.onYearChange(e), a.setState({
            isRenderAriaLiveMessage: !0
          })), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(e), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(e);
        }), Mt(Ot(a), "handleMonthChange", function (e) {
          a.props.onMonthChange && (a.props.onMonthChange(e), a.setState({
            isRenderAriaLiveMessage: !0
          })), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(e), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(e);
        }), Mt(Ot(a), "handleMonthYearChange", function (e) {
          a.handleYearChange(e), a.handleMonthChange(e);
        }), Mt(Ot(a), "changeYear", function (e) {
          a.setState(function (t) {
            var r = t.date;
            return {
              date: Ve.default(r, e)
            };
          }, function () {
            return a.handleYearChange(a.state.date);
          });
        }), Mt(Ot(a), "changeMonth", function (e) {
          a.setState(function (t) {
            var r = t.date;
            return {
              date: He.default(r, e)
            };
          }, function () {
            return a.handleMonthChange(a.state.date);
          });
        }), Mt(Ot(a), "changeMonthYear", function (e) {
          a.setState(function (t) {
            var r = t.date;
            return {
              date: Ve.default(He.default(r, Fe.default(e)), qe.default(e))
            };
          }, function () {
            return a.handleMonthYearChange(a.state.date);
          });
        }), Mt(Ot(a), "header", function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.state.date,
            t = Jt(e, a.props.locale, a.props.calendarStartDay),
            r = [];
          return a.props.showWeekNumbers && r.push(he.default.createElement("div", {
            key: "W",
            className: "react-datepicker__day-name"
          }, a.props.weekLabel || "#")), r.concat([0, 1, 2, 3, 4, 5, 6].map(function (e) {
            var r = ke.default(t, e),
              n = a.formatWeekday(r, a.props.locale),
              o = a.props.weekDayClassName ? a.props.weekDayClassName(r) : void 0;
            return he.default.createElement("div", {
              key: e,
              className: me.default("react-datepicker__day-name", o)
            }, n);
          }));
        }), Mt(Ot(a), "formatWeekday", function (e, t) {
          return a.props.formatWeekDay ? function (e, t, r) {
            return t(jt(e, "EEEE", r));
          }(e, a.props.formatWeekDay, t) : a.props.useWeekdaysShort ? function (e, t) {
            return jt(e, "EEE", t);
          }(e, t) : function (e, t) {
            return jt(e, "EEEEEE", t);
          }(e, t);
        }), Mt(Ot(a), "decreaseYear", function () {
          a.setState(function (e) {
            var t = e.date;
            return {
              date: xe.default(t, a.props.showYearPicker ? a.props.yearItemNumber : 1)
            };
          }, function () {
            return a.handleYearChange(a.state.date);
          });
        }), Mt(Ot(a), "renderPreviousButton", function () {
          if (!a.props.renderCustomHeader) {
            var e;
            switch (!0) {
              case a.props.showMonthYearPicker:
                e = Mr(a.state.date, a.props);
                break;
              case a.props.showYearPicker:
                e = function (e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    r = t.minDate,
                    a = t.yearItemNumber,
                    n = void 0 === a ? Kt : a,
                    o = Ir(Zt(xe.default(e, n)), n).endPeriod,
                    s = r && qe.default(r);
                  return s && s > o || !1;
                }(a.state.date, a.props);
                break;
              default:
                e = Cr(a.state.date, a.props);
            }
            if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !e) && !a.props.showTimeSelectOnly) {
              var t = ["react-datepicker__navigation", "react-datepicker__navigation--previous"],
                r = a.decreaseMonth;
              (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (r = a.decreaseYear), e && a.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--previous--disabled"), r = null);
              var n = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker,
                o = a.props,
                s = o.previousMonthButtonLabel,
                i = o.previousYearButtonLabel,
                p = a.props,
                l = p.previousMonthAriaLabel,
                d = void 0 === l ? "string" == typeof s ? s : "Previous Month" : l,
                c = p.previousYearAriaLabel,
                u = void 0 === c ? "string" == typeof i ? i : "Previous Year" : c;
              return he.default.createElement("button", {
                type: "button",
                className: t.join(" "),
                onClick: r,
                onKeyDown: a.props.handleOnKeyDown,
                "aria-label": n ? u : d
              }, he.default.createElement("span", {
                className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--previous"].join(" ")
              }, n ? a.props.previousYearButtonLabel : a.props.previousMonthButtonLabel));
            }
          }
        }), Mt(Ot(a), "increaseYear", function () {
          a.setState(function (e) {
            var t = e.date;
            return {
              date: _e.default(t, a.props.showYearPicker ? a.props.yearItemNumber : 1)
            };
          }, function () {
            return a.handleYearChange(a.state.date);
          });
        }), Mt(Ot(a), "renderNextButton", function () {
          if (!a.props.renderCustomHeader) {
            var e;
            switch (!0) {
              case a.props.showMonthYearPicker:
                e = Pr(a.state.date, a.props);
                break;
              case a.props.showYearPicker:
                e = function (e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    r = t.maxDate,
                    a = t.yearItemNumber,
                    n = void 0 === a ? Kt : a,
                    o = Ir(_e.default(e, n), n).startPeriod,
                    s = r && qe.default(r);
                  return s && s < o || !1;
                }(a.state.date, a.props);
                break;
              default:
                e = _r(a.state.date, a.props);
            }
            if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !e) && !a.props.showTimeSelectOnly) {
              var t = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
              a.props.showTimeSelect && t.push("react-datepicker__navigation--next--with-time"), a.props.todayButton && t.push("react-datepicker__navigation--next--with-today-button");
              var r = a.increaseMonth;
              (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (r = a.increaseYear), e && a.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--next--disabled"), r = null);
              var n = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker,
                o = a.props,
                s = o.nextMonthButtonLabel,
                i = o.nextYearButtonLabel,
                p = a.props,
                l = p.nextMonthAriaLabel,
                d = void 0 === l ? "string" == typeof s ? s : "Next Month" : l,
                c = p.nextYearAriaLabel,
                u = void 0 === c ? "string" == typeof i ? i : "Next Year" : c;
              return he.default.createElement("button", {
                type: "button",
                className: t.join(" "),
                onClick: r,
                onKeyDown: a.props.handleOnKeyDown,
                "aria-label": n ? u : d
              }, he.default.createElement("span", {
                className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--next"].join(" ")
              }, n ? a.props.nextYearButtonLabel : a.props.nextMonthButtonLabel));
            }
          }
        }), Mt(Ot(a), "renderCurrentMonth", function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.state.date,
            t = ["react-datepicker__current-month"];
          return a.props.showYearDropdown && t.push("react-datepicker__current-month--hasYearDropdown"), a.props.showMonthDropdown && t.push("react-datepicker__current-month--hasMonthDropdown"), a.props.showMonthYearDropdown && t.push("react-datepicker__current-month--hasMonthYearDropdown"), he.default.createElement("div", {
            className: t.join(" ")
          }, jt(e, a.props.dateFormat, a.props.locale));
        }), Mt(Ot(a), "renderYearDropdown", function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          if (a.props.showYearDropdown && !e) return he.default.createElement(Fr, {
            adjustDateOnChange: a.props.adjustDateOnChange,
            date: a.state.date,
            onSelect: a.props.onSelect,
            setOpen: a.props.setOpen,
            dropdownMode: a.props.dropdownMode,
            onChange: a.changeYear,
            minDate: a.props.minDate,
            maxDate: a.props.maxDate,
            year: qe.default(a.state.date),
            scrollableYearDropdown: a.props.scrollableYearDropdown,
            yearDropdownItemNumber: a.props.yearDropdownItemNumber
          });
        }), Mt(Ot(a), "renderMonthDropdown", function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          if (a.props.showMonthDropdown && !e) return he.default.createElement(Kr, {
            dropdownMode: a.props.dropdownMode,
            locale: a.props.locale,
            onChange: a.changeMonth,
            month: Fe.default(a.state.date),
            useShortMonthInDropdown: a.props.useShortMonthInDropdown
          });
        }), Mt(Ot(a), "renderMonthYearDropdown", function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          if (a.props.showMonthYearDropdown && !e) return he.default.createElement(Hr, {
            dropdownMode: a.props.dropdownMode,
            locale: a.props.locale,
            dateFormat: a.props.dateFormat,
            onChange: a.changeMonthYear,
            minDate: a.props.minDate,
            maxDate: a.props.maxDate,
            date: a.state.date,
            scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown
          });
        }), Mt(Ot(a), "handleTodayButtonClick", function (e) {
          a.props.onSelect(tr(), e), a.props.setPreSelection && a.props.setPreSelection(tr());
        }), Mt(Ot(a), "renderTodayButton", function () {
          if (a.props.todayButton && !a.props.showTimeSelectOnly) return he.default.createElement("div", {
            className: "react-datepicker__today-button",
            onClick: function onClick(e) {
              return a.handleTodayButtonClick(e);
            }
          }, a.props.todayButton);
        }), Mt(Ot(a), "renderDefaultHeader", function (e) {
          var t = e.monthDate,
            r = e.i;
          return he.default.createElement("div", {
            className: "react-datepicker__header ".concat(a.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
          }, a.renderCurrentMonth(t), he.default.createElement("div", {
            className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode),
            onFocus: a.handleDropdownFocus
          }, a.renderMonthDropdown(0 !== r), a.renderMonthYearDropdown(0 !== r), a.renderYearDropdown(0 !== r)), he.default.createElement("div", {
            className: "react-datepicker__day-names"
          }, a.header(t)));
        }), Mt(Ot(a), "renderCustomHeader", function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.monthDate,
            r = e.i;
          if (a.props.showTimeSelect && !a.state.monthContainer || a.props.showTimeSelectOnly) return null;
          var n = Cr(a.state.date, a.props),
            o = _r(a.state.date, a.props),
            s = Mr(a.state.date, a.props),
            i = Pr(a.state.date, a.props),
            p = !a.props.showMonthYearPicker && !a.props.showQuarterYearPicker && !a.props.showYearPicker;
          return he.default.createElement("div", {
            className: "react-datepicker__header react-datepicker__header--custom",
            onFocus: a.props.onDropdownFocus
          }, a.props.renderCustomHeader(kt(kt({}, a.state), {}, {
            customHeaderCount: r,
            monthDate: t,
            changeMonth: a.changeMonth,
            changeYear: a.changeYear,
            decreaseMonth: a.decreaseMonth,
            increaseMonth: a.increaseMonth,
            decreaseYear: a.decreaseYear,
            increaseYear: a.increaseYear,
            prevMonthButtonDisabled: n,
            nextMonthButtonDisabled: o,
            prevYearButtonDisabled: s,
            nextYearButtonDisabled: i
          })), p && he.default.createElement("div", {
            className: "react-datepicker__day-names"
          }, a.header(t)));
        }), Mt(Ot(a), "renderYearHeader", function () {
          var e = a.state.date,
            t = a.props,
            r = t.showYearPicker,
            n = Ir(e, t.yearItemNumber),
            o = n.startPeriod,
            s = n.endPeriod;
          return he.default.createElement("div", {
            className: "react-datepicker__header react-datepicker-year-header"
          }, r ? "".concat(o, " - ").concat(s) : qe.default(e));
        }), Mt(Ot(a), "renderHeader", function (e) {
          switch (!0) {
            case void 0 !== a.props.renderCustomHeader:
              return a.renderCustomHeader(e);
            case a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker:
              return a.renderYearHeader(e);
            default:
              return a.renderDefaultHeader(e);
          }
        }), Mt(Ot(a), "renderMonths", function () {
          if (!a.props.showTimeSelectOnly && !a.props.showYearPicker) {
            for (var e = [], t = a.props.showPreviousMonths ? a.props.monthsShown - 1 : 0, r = Ee.default(a.state.date, t), n = 0; n < a.props.monthsShown; ++n) {
              var o = n - a.props.monthSelectedIn,
                s = Se.default(r, o),
                i = "month-".concat(n),
                p = n < a.props.monthsShown - 1,
                l = n > 0;
              e.push(he.default.createElement("div", {
                key: i,
                ref: function ref(e) {
                  a.monthContainer = e;
                },
                className: "react-datepicker__month-container"
              }, a.renderHeader({
                monthDate: s,
                i: n
              }), he.default.createElement(zr, {
                chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix,
                disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix,
                weekAriaLabelPrefix: a.props.weekAriaLabelPrefix,
                ariaLabelPrefix: a.props.monthAriaLabelPrefix,
                onChange: a.changeMonthYear,
                day: s,
                dayClassName: a.props.dayClassName,
                calendarStartDay: a.props.calendarStartDay,
                monthClassName: a.props.monthClassName,
                onDayClick: a.handleDayClick,
                handleOnKeyDown: a.props.handleOnDayKeyDown,
                onDayMouseEnter: a.handleDayMouseEnter,
                onMouseLeave: a.handleMonthMouseLeave,
                onWeekSelect: a.props.onWeekSelect,
                orderInDisplay: n,
                formatWeekNumber: a.props.formatWeekNumber,
                locale: a.props.locale,
                minDate: a.props.minDate,
                maxDate: a.props.maxDate,
                excludeDates: a.props.excludeDates,
                excludeDateIntervals: a.props.excludeDateIntervals,
                highlightDates: a.props.highlightDates,
                selectingDate: a.state.selectingDate,
                includeDates: a.props.includeDates,
                includeDateIntervals: a.props.includeDateIntervals,
                inline: a.props.inline,
                shouldFocusDayInline: a.props.shouldFocusDayInline,
                fixedHeight: a.props.fixedHeight,
                filterDate: a.props.filterDate,
                preSelection: a.props.preSelection,
                setPreSelection: a.props.setPreSelection,
                selected: a.props.selected,
                selectsStart: a.props.selectsStart,
                selectsEnd: a.props.selectsEnd,
                selectsRange: a.props.selectsRange,
                selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange,
                showWeekNumbers: a.props.showWeekNumbers,
                startDate: a.props.startDate,
                endDate: a.props.endDate,
                peekNextMonth: a.props.peekNextMonth,
                setOpen: a.props.setOpen,
                shouldCloseOnSelect: a.props.shouldCloseOnSelect,
                renderDayContents: a.props.renderDayContents,
                disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
                showMonthYearPicker: a.props.showMonthYearPicker,
                showFullMonthYearPicker: a.props.showFullMonthYearPicker,
                showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker,
                showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker,
                showYearPicker: a.props.showYearPicker,
                showQuarterYearPicker: a.props.showQuarterYearPicker,
                isInputFocused: a.props.isInputFocused,
                containerRef: a.containerRef,
                monthShowsDuplicateDaysEnd: p,
                monthShowsDuplicateDaysStart: l
              })));
            }
            return e;
          }
        }), Mt(Ot(a), "renderYears", function () {
          if (!a.props.showTimeSelectOnly) return a.props.showYearPicker ? he.default.createElement("div", {
            className: "react-datepicker__year--container"
          }, a.renderHeader(), he.default.createElement(Gr, Pt({
            onDayClick: a.handleDayClick,
            date: a.state.date
          }, a.props))) : void 0;
        }), Mt(Ot(a), "renderTimeSection", function () {
          if (a.props.showTimeSelect && (a.state.monthContainer || a.props.showTimeSelectOnly)) return he.default.createElement($r, {
            selected: a.props.selected,
            openToDate: a.props.openToDate,
            onChange: a.props.onTimeChange,
            timeClassName: a.props.timeClassName,
            format: a.props.timeFormat,
            includeTimes: a.props.includeTimes,
            intervals: a.props.timeIntervals,
            minTime: a.props.minTime,
            maxTime: a.props.maxTime,
            excludeTimes: a.props.excludeTimes,
            filterTime: a.props.filterTime,
            timeCaption: a.props.timeCaption,
            todayButton: a.props.todayButton,
            showMonthDropdown: a.props.showMonthDropdown,
            showMonthYearDropdown: a.props.showMonthYearDropdown,
            showYearDropdown: a.props.showYearDropdown,
            withPortal: a.props.withPortal,
            monthRef: a.state.monthContainer,
            injectTimes: a.props.injectTimes,
            locale: a.props.locale,
            handleOnKeyDown: a.props.handleOnKeyDown,
            showTimeSelectOnly: a.props.showTimeSelectOnly
          });
        }), Mt(Ot(a), "renderInputTimeSection", function () {
          var e = new Date(a.props.selected),
            t = Ht(e) && Boolean(a.props.selected) ? "".concat(Yr(e.getHours()), ":").concat(Yr(e.getMinutes())) : "";
          if (a.props.showTimeInput) return he.default.createElement(Jr, {
            date: e,
            timeString: t,
            timeInputLabel: a.props.timeInputLabel,
            onChange: a.props.onTimeChange,
            customTimeInput: a.props.customTimeInput
          });
        }), Mt(Ot(a), "renderAriaLiveRegion", function () {
          var e,
            t = Ir(a.state.date, a.props.yearItemNumber),
            r = t.startPeriod,
            n = t.endPeriod;
          return e = a.props.showYearPicker ? "".concat(r, " - ").concat(n) : a.props.showMonthYearPicker || a.props.showQuarterYearPicker ? qe.default(a.state.date) : "".concat(dr(Fe.default(a.state.date), a.props.locale), " ").concat(qe.default(a.state.date)), he.default.createElement("span", {
            role: "alert",
            "aria-live": "polite",
            className: "react-datepicker__aria-live"
          }, a.state.isRenderAriaLiveMessage && e);
        }), Mt(Ot(a), "renderChildren", function () {
          if (a.props.children) return he.default.createElement("div", {
            className: "react-datepicker__children-container"
          }, a.props.children);
        }), a.containerRef = he.default.createRef(), a.state = {
          date: a.getDateInView(),
          selectingDate: null,
          monthContainer: null,
          isRenderAriaLiveMessage: !1
        }, a;
      }
      return _t(r, [{
        key: "componentDidMount",
        value: function value() {
          var e = this;
          this.props.showTimeSelect && (this.assignMonthContainer = void e.setState({
            monthContainer: e.monthContainer
          }));
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e) {
          !this.props.preSelection || or(this.props.preSelection, e.preSelection) && this.props.monthSelectedIn === e.monthSelectedIn ? this.props.openToDate && !or(this.props.openToDate, e.openToDate) && this.setState({
            date: this.props.openToDate
          }) : this.setState({
            date: this.props.preSelection
          });
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props.container || Xr;
          return he.default.createElement("div", {
            ref: this.containerRef
          }, he.default.createElement(e, {
            className: me.default("react-datepicker", this.props.className, {
              "react-datepicker--time-only": this.props.showTimeSelectOnly
            }),
            showPopperArrow: this.props.showPopperArrow,
            arrowProps: this.props.arrowProps
          }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
        }
      }], [{
        key: "defaultProps",
        get: function get() {
          return {
            onDropdownFocus: function onDropdownFocus() {},
            monthsShown: 1,
            monthSelectedIn: 0,
            forceShowMonthNavigation: !1,
            timeCaption: "Time",
            previousYearButtonLabel: "Previous Year",
            nextYearButtonLabel: "Next Year",
            previousMonthButtonLabel: "Previous Month",
            nextMonthButtonLabel: "Next Month",
            customTimeInput: null,
            yearItemNumber: Kt
          };
        }
      }]), r;
    }(he.default.Component),
    ta = function (e) {
      Et(r, e);
      var t = It(r);
      function r(e) {
        var a;
        return St(this, r), (a = t.call(this, e)).el = document.createElement("div"), a;
      }
      return _t(r, [{
        key: "componentDidMount",
        value: function value() {
          this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.portalRoot.removeChild(this.el);
        }
      }, {
        key: "render",
        value: function value() {
          return Dt.default.createPortal(this.props.children, this.el);
        }
      }]), r;
    }(he.default.Component),
    ra = function ra(e) {
      return !e.disabled && -1 !== e.tabIndex;
    },
    aa = function (e) {
      Et(r, e);
      var t = It(r);
      function r(e) {
        var a;
        return St(this, r), Mt(Ot(a = t.call(this, e)), "getTabChildren", function () {
          return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(ra);
        }), Mt(Ot(a), "handleFocusStart", function (e) {
          var t = a.getTabChildren();
          t && t.length > 1 && t[t.length - 1].focus();
        }), Mt(Ot(a), "handleFocusEnd", function (e) {
          var t = a.getTabChildren();
          t && t.length > 1 && t[0].focus();
        }), a.tabLoopRef = he.default.createRef(), a;
      }
      return _t(r, [{
        key: "render",
        value: function value() {
          return this.props.enableTabLoop ? he.default.createElement("div", {
            className: "react-datepicker__tab-loop",
            ref: this.tabLoopRef
          }, he.default.createElement("div", {
            className: "react-datepicker__tab-loop__start",
            tabIndex: "0",
            onFocus: this.handleFocusStart
          }), this.props.children, he.default.createElement("div", {
            className: "react-datepicker__tab-loop__end",
            tabIndex: "0",
            onFocus: this.handleFocusEnd
          })) : this.props.children;
        }
      }], [{
        key: "defaultProps",
        get: function get() {
          return {
            enableTabLoop: !0
          };
        }
      }]), r;
    }(he.default.Component),
    na = function (e) {
      Et(r, e);
      var t = It(r);
      function r() {
        return St(this, r), t.apply(this, arguments);
      }
      return _t(r, [{
        key: "render",
        value: function value() {
          var e,
            t = this.props,
            r = t.className,
            a = t.wrapperClassName,
            n = t.hidePopper,
            o = t.popperComponent,
            s = t.popperModifiers,
            i = t.popperPlacement,
            p = t.popperProps,
            l = t.targetComponent,
            d = t.enableTabLoop,
            c = t.popperOnKeyDown,
            u = t.portalId,
            f = t.portalHost;
          if (!n) {
            var h = me.default("react-datepicker-popper", r);
            e = he.default.createElement(ce.Popper, Pt({
              modifiers: s,
              placement: i
            }, p), function (e) {
              var t = e.ref,
                r = e.style,
                a = e.placement,
                n = e.arrowProps;
              return he.default.createElement(aa, {
                enableTabLoop: d
              }, he.default.createElement("div", {
                ref: t,
                style: r,
                className: h,
                "data-placement": a,
                onKeyDown: c
              }, he.default.cloneElement(o, {
                arrowProps: n
              })));
            });
          }
          this.props.popperContainer && (e = he.default.createElement(this.props.popperContainer, {}, e)), u && !n && (e = he.default.createElement(ta, {
            portalId: u,
            portalHost: f
          }, e));
          var m = me.default("react-datepicker-wrapper", a);
          return he.default.createElement(ce.Manager, {
            className: "react-datepicker-manager"
          }, he.default.createElement(ce.Reference, null, function (e) {
            var t = e.ref;
            return he.default.createElement("div", {
              ref: t,
              className: m
            }, l);
          }), e);
        }
      }], [{
        key: "defaultProps",
        get: function get() {
          return {
            hidePopper: !0,
            popperModifiers: [],
            popperProps: {},
            popperPlacement: "bottom-start"
          };
        }
      }]), r;
    }(he.default.Component),
    oa = "react-datepicker-ignore-onclickoutside",
    sa = vt.default(ea);
  var ia = "Date input not valid.",
    pa = function (e) {
      Et(r, e);
      var t = It(r);
      function r(e) {
        var a;
        return St(this, r), Mt(Ot(a = t.call(this, e)), "getPreSelection", function () {
          return a.props.openToDate ? a.props.openToDate : a.props.selectsEnd && a.props.startDate ? a.props.startDate : a.props.selectsStart && a.props.endDate ? a.props.endDate : Bt();
        }), Mt(Ot(a), "calcInitialState", function () {
          var e,
            t = a.getPreSelection(),
            r = Er(a.props),
            n = Nr(a.props),
            o = r && ut.default(t, Xe.default(r)) ? r : n && ct.default(t, at.default(n)) ? n : t;
          return {
            open: a.props.startOpen || !1,
            preventFocus: !1,
            preSelection: null !== (e = a.props.selectsRange ? a.props.startDate : a.props.selected) && void 0 !== e ? e : o,
            highlightDates: xr(a.props.highlightDates),
            focused: !1,
            shouldFocusDayInline: !1,
            isRenderAriaLiveMessage: !1
          };
        }), Mt(Ot(a), "clearPreventFocusTimeout", function () {
          a.preventFocusTimeout && clearTimeout(a.preventFocusTimeout);
        }), Mt(Ot(a), "setFocus", function () {
          a.input && a.input.focus && a.input.focus({
            preventScroll: !0
          });
        }), Mt(Ot(a), "setBlur", function () {
          a.input && a.input.blur && a.input.blur(), a.cancelFocusInput();
        }), Mt(Ot(a), "setOpen", function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          a.setState({
            open: e,
            preSelection: e && a.state.open ? a.state.preSelection : a.calcInitialState().preSelection,
            lastPreSelectChange: da
          }, function () {
            e || a.setState(function (e) {
              return {
                focused: !!t && e.focused
              };
            }, function () {
              !t && a.setBlur(), a.setState({
                inputValue: null
              });
            });
          });
        }), Mt(Ot(a), "inputOk", function () {
          return ye.default(a.state.preSelection);
        }), Mt(Ot(a), "isCalendarOpen", function () {
          return void 0 === a.props.open ? a.state.open && !a.props.disabled && !a.props.readOnly : a.props.open;
        }), Mt(Ot(a), "handleFocus", function (e) {
          a.state.preventFocus || (a.props.onFocus(e), a.props.preventOpenOnFocus || a.props.readOnly || a.setOpen(!0)), a.setState({
            focused: !0
          });
        }), Mt(Ot(a), "cancelFocusInput", function () {
          clearTimeout(a.inputFocusTimeout), a.inputFocusTimeout = null;
        }), Mt(Ot(a), "deferFocusInput", function () {
          a.cancelFocusInput(), a.inputFocusTimeout = setTimeout(function () {
            return a.setFocus();
          }, 1);
        }), Mt(Ot(a), "handleDropdownFocus", function () {
          a.cancelFocusInput();
        }), Mt(Ot(a), "handleBlur", function (e) {
          (!a.state.open || a.props.withPortal || a.props.showTimeInput) && a.props.onBlur(e), a.setState({
            focused: !1
          });
        }), Mt(Ot(a), "handleCalendarClickOutside", function (e) {
          a.props.inline || a.setOpen(!1), a.props.onClickOutside(e), a.props.withPortal && e.preventDefault();
        }), Mt(Ot(a), "handleChange", function () {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
            t[r] = arguments[r];
          }
          var n = t[0];
          if (!a.props.onChangeRaw || (a.props.onChangeRaw.apply(Ot(a), t), "function" == typeof n.isDefaultPrevented && !n.isDefaultPrevented())) {
            a.setState({
              inputValue: n.target.value,
              lastPreSelectChange: la
            });
            var o = Qt(n.target.value, a.props.dateFormat, a.props.locale, a.props.strictParsing, a.props.minDate);
            a.props.showTimeSelectOnly && !or(o, a.props.selected) && (o = null == o ? wt.default(a.props.selected, {
              hours: Ie.default(a.props.selected),
              minutes: Ye.default(a.props.selected),
              seconds: Oe.default(a.props.selected)
            }) : wt.default(a.props.selected, {
              hours: Ie.default(o),
              minutes: Ye.default(o),
              seconds: Oe.default(o)
            })), !o && n.target.value || a.setSelected(o, n, !0);
          }
        }), Mt(Ot(a), "handleSelect", function (e, t, r) {
          if (a.setState({
            preventFocus: !0
          }, function () {
            return a.preventFocusTimeout = setTimeout(function () {
              return a.setState({
                preventFocus: !1
              });
            }, 50), a.preventFocusTimeout;
          }), a.props.onChangeRaw && a.props.onChangeRaw(t), a.setSelected(e, t, !1, r), a.setState({
            isRenderAriaLiveMessage: !0
          }), !a.props.shouldCloseOnSelect || a.props.showTimeSelect) a.setPreSelection(e);else if (!a.props.inline) {
            a.props.selectsRange || a.setOpen(!1);
            var n = a.props,
              o = n.startDate,
              s = n.endDate;
            !o || s || ut.default(e, o) || a.setOpen(!1);
          }
        }), Mt(Ot(a), "setSelected", function (e, t, r, n) {
          var o = e;
          if (a.props.showYearPicker) {
            if (null !== o && Dr(qe.default(o), a.props)) return;
          } else if (a.props.showMonthYearPicker) {
            if (null !== o && mr(o, a.props)) return;
          } else if (null !== o && fr(o, a.props)) return;
          var s = a.props,
            i = s.onChange,
            p = s.selectsRange,
            l = s.startDate,
            d = s.endDate;
          if (!sr(a.props.selected, o) || a.props.allowSameDay || p) if (null !== o && (!a.props.selected || r && (a.props.showTimeSelect || a.props.showTimeSelectOnly || a.props.showTimeInput) || (o = Ut(o, {
            hour: Ie.default(a.props.selected),
            minute: Ye.default(a.props.selected),
            second: Oe.default(a.props.selected)
          })), a.props.inline || a.setState({
            preSelection: o
          }), a.props.focusSelectedMonth || a.setState({
            monthSelectedIn: n
          })), p) {
            var c = l && !d,
              u = l && d;
            !l && !d ? i([o, null], t) : c && (ut.default(o, l) ? i([o, null], t) : i([l, o], t)), u && i([o, null], t);
          } else i(o, t);
          r || (a.props.onSelect(o, t), a.setState({
            inputValue: null
          }));
        }), Mt(Ot(a), "setPreSelection", function (e) {
          var t = void 0 !== a.props.minDate,
            r = void 0 !== a.props.maxDate,
            n = !0;
          if (e) {
            var o = Xe.default(e);
            if (t && r) n = ir(e, a.props.minDate, a.props.maxDate);else if (t) {
              var s = Xe.default(a.props.minDate);
              n = ct.default(e, s) || sr(o, s);
            } else if (r) {
              var i = at.default(a.props.maxDate);
              n = ut.default(e, i) || sr(o, i);
            }
          }
          n && a.setState({
            preSelection: e
          });
        }), Mt(Ot(a), "handleTimeChange", function (e) {
          var t = Ut(a.props.selected ? a.props.selected : a.getPreSelection(), {
            hour: Ie.default(e),
            minute: Ye.default(e)
          });
          a.setState({
            preSelection: t
          }), a.props.onChange(t), a.props.shouldCloseOnSelect && a.setOpen(!1), a.props.showTimeInput && a.setOpen(!0), (a.props.showTimeSelectOnly || a.props.showTimeSelect) && a.setState({
            isRenderAriaLiveMessage: !0
          }), a.setState({
            inputValue: null
          });
        }), Mt(Ot(a), "onInputClick", function () {
          a.props.disabled || a.props.readOnly || a.setOpen(!0), a.props.onInputClick();
        }), Mt(Ot(a), "onInputKeyDown", function (e) {
          a.props.onKeyDown(e);
          var t = e.key;
          if (a.state.open || a.props.inline || a.props.preventOpenOnFocus) {
            if (a.state.open) {
              if ("ArrowDown" === t || "ArrowUp" === t) {
                e.preventDefault();
                var r = a.calendar.componentNode && a.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');
                return void (r && r.focus({
                  preventScroll: !0
                }));
              }
              var n = Bt(a.state.preSelection);
              "Enter" === t ? (e.preventDefault(), a.inputOk() && a.state.lastPreSelectChange === da ? (a.handleSelect(n, e), !a.props.shouldCloseOnSelect && a.setPreSelection(n)) : a.setOpen(!1)) : "Escape" === t && (e.preventDefault(), a.setOpen(!1)), a.inputOk() || a.props.onInputError({
                code: 1,
                msg: ia
              });
            }
          } else "ArrowDown" !== t && "ArrowUp" !== t && "Enter" !== t || a.onInputClick();
        }), Mt(Ot(a), "onPortalKeyDown", function (e) {
          "Escape" === e.key && (e.preventDefault(), a.setState({
            preventFocus: !0
          }, function () {
            a.setOpen(!1), setTimeout(function () {
              a.setFocus(), a.setState({
                preventFocus: !1
              });
            });
          }));
        }), Mt(Ot(a), "onDayKeyDown", function (e) {
          a.props.onKeyDown(e);
          var t = e.key,
            r = Bt(a.state.preSelection);
          if ("Enter" === t) e.preventDefault(), a.handleSelect(r, e), !a.props.shouldCloseOnSelect && a.setPreSelection(r);else if ("Escape" === t) e.preventDefault(), a.setOpen(!1), a.inputOk() || a.props.onInputError({
            code: 1,
            msg: ia
          });else if (!a.props.disabledKeyboardNavigation) {
            var n;
            switch (t) {
              case "ArrowLeft":
                n = Me.default(r, 1);
                break;
              case "ArrowRight":
                n = ke.default(r, 1);
                break;
              case "ArrowUp":
                n = Pe.default(r, 1);
                break;
              case "ArrowDown":
                n = be.default(r, 1);
                break;
              case "PageUp":
                n = Ee.default(r, 1);
                break;
              case "PageDown":
                n = Se.default(r, 1);
                break;
              case "Home":
                n = xe.default(r, 1);
                break;
              case "End":
                n = _e.default(r, 1);
            }
            if (!n) return void (a.props.onInputError && a.props.onInputError({
              code: 1,
              msg: ia
            }));
            if (e.preventDefault(), a.setState({
              lastPreSelectChange: da
            }), a.props.adjustDateOnChange && a.setSelected(n), a.setPreSelection(n), a.props.inline) {
              var o = Fe.default(r),
                s = Fe.default(n),
                i = qe.default(r),
                p = qe.default(n);
              o !== s || i !== p ? a.setState({
                shouldFocusDayInline: !0
              }) : a.setState({
                shouldFocusDayInline: !1
              });
            }
          }
        }), Mt(Ot(a), "onPopperKeyDown", function (e) {
          "Escape" === e.key && (e.preventDefault(), a.setState({
            preventFocus: !0
          }, function () {
            a.setOpen(!1), setTimeout(function () {
              a.setFocus(), a.setState({
                preventFocus: !1
              });
            });
          }));
        }), Mt(Ot(a), "onClearClick", function (e) {
          e && e.preventDefault && e.preventDefault(), a.props.selectsRange ? a.props.onChange([null, null], e) : a.props.onChange(null, e), a.setState({
            inputValue: null
          });
        }), Mt(Ot(a), "clear", function () {
          a.onClearClick();
        }), Mt(Ot(a), "onScroll", function (e) {
          "boolean" == typeof a.props.closeOnScroll && a.props.closeOnScroll ? e.target !== document && e.target !== document.documentElement && e.target !== document.body || a.setOpen(!1) : "function" == typeof a.props.closeOnScroll && a.props.closeOnScroll(e) && a.setOpen(!1);
        }), Mt(Ot(a), "renderCalendar", function () {
          return a.props.inline || a.isCalendarOpen() ? he.default.createElement(sa, {
            ref: function ref(e) {
              a.calendar = e;
            },
            locale: a.props.locale,
            calendarStartDay: a.props.calendarStartDay,
            chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix,
            disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix,
            weekAriaLabelPrefix: a.props.weekAriaLabelPrefix,
            monthAriaLabelPrefix: a.props.monthAriaLabelPrefix,
            adjustDateOnChange: a.props.adjustDateOnChange,
            setOpen: a.setOpen,
            shouldCloseOnSelect: a.props.shouldCloseOnSelect,
            dateFormat: a.props.dateFormatCalendar,
            useWeekdaysShort: a.props.useWeekdaysShort,
            formatWeekDay: a.props.formatWeekDay,
            dropdownMode: a.props.dropdownMode,
            selected: a.props.selected,
            preSelection: a.state.preSelection,
            onSelect: a.handleSelect,
            onWeekSelect: a.props.onWeekSelect,
            openToDate: a.props.openToDate,
            minDate: a.props.minDate,
            maxDate: a.props.maxDate,
            selectsStart: a.props.selectsStart,
            selectsEnd: a.props.selectsEnd,
            selectsRange: a.props.selectsRange,
            startDate: a.props.startDate,
            endDate: a.props.endDate,
            excludeDates: a.props.excludeDates,
            excludeDateIntervals: a.props.excludeDateIntervals,
            filterDate: a.props.filterDate,
            onClickOutside: a.handleCalendarClickOutside,
            formatWeekNumber: a.props.formatWeekNumber,
            highlightDates: a.state.highlightDates,
            includeDates: a.props.includeDates,
            includeDateIntervals: a.props.includeDateIntervals,
            includeTimes: a.props.includeTimes,
            injectTimes: a.props.injectTimes,
            inline: a.props.inline,
            shouldFocusDayInline: a.state.shouldFocusDayInline,
            peekNextMonth: a.props.peekNextMonth,
            showMonthDropdown: a.props.showMonthDropdown,
            showPreviousMonths: a.props.showPreviousMonths,
            useShortMonthInDropdown: a.props.useShortMonthInDropdown,
            showMonthYearDropdown: a.props.showMonthYearDropdown,
            showWeekNumbers: a.props.showWeekNumbers,
            showYearDropdown: a.props.showYearDropdown,
            withPortal: a.props.withPortal,
            forceShowMonthNavigation: a.props.forceShowMonthNavigation,
            showDisabledMonthNavigation: a.props.showDisabledMonthNavigation,
            scrollableYearDropdown: a.props.scrollableYearDropdown,
            scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown,
            todayButton: a.props.todayButton,
            weekLabel: a.props.weekLabel,
            outsideClickIgnoreClass: oa,
            fixedHeight: a.props.fixedHeight,
            monthsShown: a.props.monthsShown,
            monthSelectedIn: a.state.monthSelectedIn,
            onDropdownFocus: a.handleDropdownFocus,
            onMonthChange: a.props.onMonthChange,
            onYearChange: a.props.onYearChange,
            dayClassName: a.props.dayClassName,
            weekDayClassName: a.props.weekDayClassName,
            monthClassName: a.props.monthClassName,
            timeClassName: a.props.timeClassName,
            showTimeSelect: a.props.showTimeSelect,
            showTimeSelectOnly: a.props.showTimeSelectOnly,
            onTimeChange: a.handleTimeChange,
            timeFormat: a.props.timeFormat,
            timeIntervals: a.props.timeIntervals,
            minTime: a.props.minTime,
            maxTime: a.props.maxTime,
            excludeTimes: a.props.excludeTimes,
            filterTime: a.props.filterTime,
            timeCaption: a.props.timeCaption,
            className: a.props.calendarClassName,
            container: a.props.calendarContainer,
            yearItemNumber: a.props.yearItemNumber,
            yearDropdownItemNumber: a.props.yearDropdownItemNumber,
            previousMonthAriaLabel: a.props.previousMonthAriaLabel,
            previousMonthButtonLabel: a.props.previousMonthButtonLabel,
            nextMonthAriaLabel: a.props.nextMonthAriaLabel,
            nextMonthButtonLabel: a.props.nextMonthButtonLabel,
            previousYearAriaLabel: a.props.previousYearAriaLabel,
            previousYearButtonLabel: a.props.previousYearButtonLabel,
            nextYearAriaLabel: a.props.nextYearAriaLabel,
            nextYearButtonLabel: a.props.nextYearButtonLabel,
            timeInputLabel: a.props.timeInputLabel,
            disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
            renderCustomHeader: a.props.renderCustomHeader,
            popperProps: a.props.popperProps,
            renderDayContents: a.props.renderDayContents,
            onDayMouseEnter: a.props.onDayMouseEnter,
            onMonthMouseLeave: a.props.onMonthMouseLeave,
            selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange,
            showTimeInput: a.props.showTimeInput,
            showMonthYearPicker: a.props.showMonthYearPicker,
            showFullMonthYearPicker: a.props.showFullMonthYearPicker,
            showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker,
            showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker,
            showYearPicker: a.props.showYearPicker,
            showQuarterYearPicker: a.props.showQuarterYearPicker,
            showPopperArrow: a.props.showPopperArrow,
            excludeScrollbar: a.props.excludeScrollbar,
            handleOnKeyDown: a.props.onKeyDown,
            handleOnDayKeyDown: a.onDayKeyDown,
            isInputFocused: a.state.focused,
            customTimeInput: a.props.customTimeInput,
            setPreSelection: a.setPreSelection
          }, a.props.children) : null;
        }), Mt(Ot(a), "renderAriaLiveRegion", function () {
          var e,
            t = a.props,
            r = t.dateFormat,
            n = t.locale,
            o = a.props.showTimeInput || a.props.showTimeSelect ? "PPPPp" : "PPPP";
          return e = a.props.selectsRange ? "Selected start date: ".concat(Vt(a.props.startDate, {
            dateFormat: o,
            locale: n
          }), ". ").concat(a.props.endDate ? "End date: " + Vt(a.props.endDate, {
            dateFormat: o,
            locale: n
          }) : "") : a.props.showTimeSelectOnly ? "Selected time: ".concat(Vt(a.props.selected, {
            dateFormat: r,
            locale: n
          })) : a.props.showYearPicker ? "Selected year: ".concat(Vt(a.props.selected, {
            dateFormat: "yyyy",
            locale: n
          })) : a.props.showMonthYearPicker ? "Selected month: ".concat(Vt(a.props.selected, {
            dateFormat: "MMMM yyyy",
            locale: n
          })) : a.props.showQuarterYearPicker ? "Selected quarter: ".concat(Vt(a.props.selected, {
            dateFormat: "yyyy, QQQ",
            locale: n
          })) : "Selected date: ".concat(Vt(a.props.selected, {
            dateFormat: o,
            locale: n
          })), he.default.createElement("span", {
            role: "alert",
            "aria-live": "polite",
            className: "react-datepicker__aria-live"
          }, a.state.isRenderAriaLiveMessage && e);
        }), Mt(Ot(a), "renderDateInput", function () {
          var e,
            t = me.default(a.props.className, Mt({}, oa, a.state.open)),
            r = a.props.customInput || he.default.createElement("input", {
              type: "text"
            }),
            n = a.props.customInputRef || "ref",
            o = "string" == typeof a.props.value ? a.props.value : "string" == typeof a.state.inputValue ? a.state.inputValue : a.props.selectsRange ? function (e, t, r) {
              if (!e) return "";
              var a = Vt(e, r),
                n = t ? Vt(t, r) : "";
              return "".concat(a, " - ").concat(n);
            }(a.props.startDate, a.props.endDate, a.props) : Vt(a.props.selected, a.props);
          return he.default.cloneElement(r, (Mt(e = {}, n, function (e) {
            a.input = e;
          }), Mt(e, "value", o), Mt(e, "onBlur", a.handleBlur), Mt(e, "onChange", a.handleChange), Mt(e, "onClick", a.onInputClick), Mt(e, "onFocus", a.handleFocus), Mt(e, "onKeyDown", a.onInputKeyDown), Mt(e, "id", a.props.id), Mt(e, "name", a.props.name), Mt(e, "form", a.props.form), Mt(e, "autoFocus", a.props.autoFocus), Mt(e, "placeholder", a.props.placeholderText), Mt(e, "disabled", a.props.disabled), Mt(e, "autoComplete", a.props.autoComplete), Mt(e, "className", me.default(r.props.className, t)), Mt(e, "title", a.props.title), Mt(e, "readOnly", a.props.readOnly), Mt(e, "required", a.props.required), Mt(e, "tabIndex", a.props.tabIndex), Mt(e, "aria-describedby", a.props.ariaDescribedBy), Mt(e, "aria-invalid", a.props.ariaInvalid), Mt(e, "aria-labelledby", a.props.ariaLabelledBy), Mt(e, "aria-required", a.props.ariaRequired), e));
        }), Mt(Ot(a), "renderClearButton", function () {
          var e = a.props,
            t = e.isClearable,
            r = e.selected,
            n = e.startDate,
            o = e.endDate,
            s = e.clearButtonTitle,
            i = e.clearButtonClassName,
            p = void 0 === i ? "" : i,
            l = e.ariaLabelClose,
            d = void 0 === l ? "Close" : l;
          return !t || null == r && null == n && null == o ? null : he.default.createElement("button", {
            type: "button",
            className: "react-datepicker__close-icon ".concat(p).trim(),
            "aria-label": d,
            onClick: a.onClearClick,
            title: s,
            tabIndex: -1
          });
        }), a.state = a.calcInitialState(), a;
      }
      return _t(r, [{
        key: "componentDidMount",
        value: function value() {
          window.addEventListener("scroll", this.onScroll, !0);
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e, t) {
          var r, a;
          e.inline && (r = e.selected, a = this.props.selected, r && a ? Fe.default(r) !== Fe.default(a) || qe.default(r) !== qe.default(a) : r !== a) && this.setPreSelection(this.props.selected), void 0 !== this.state.monthSelectedIn && e.monthsShown !== this.props.monthsShown && this.setState({
            monthSelectedIn: 0
          }), e.highlightDates !== this.props.highlightDates && this.setState({
            highlightDates: xr(this.props.highlightDates)
          }), t.focused || sr(e.selected, this.props.selected) || this.setState({
            inputValue: null
          }), t.open !== this.state.open && (!1 === t.open && !0 === this.state.open && this.props.onCalendarOpen(), !0 === t.open && !1 === this.state.open && this.props.onCalendarClose());
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
        }
      }, {
        key: "renderInputContainer",
        value: function value() {
          var e = this.props.showIcon;
          return he.default.createElement("div", {
            className: "react-datepicker__input-container ".concat(e ? "react-datepicker__view-calendar-icon" : "")
          }, e && he.default.createElement("svg", {
            className: "react-datepicker__calendar-icon",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512"
          }, he.default.createElement("path", {
            d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
          })), this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.renderCalendar();
          if (this.props.inline) return e;
          if (this.props.withPortal) {
            var t = this.state.open ? he.default.createElement(aa, {
              enableTabLoop: this.props.enableTabLoop
            }, he.default.createElement("div", {
              className: "react-datepicker__portal",
              tabIndex: -1,
              onKeyDown: this.onPortalKeyDown
            }, e)) : null;
            return this.state.open && this.props.portalId && (t = he.default.createElement(ta, {
              portalId: this.props.portalId,
              portalHost: this.props.portalHost
            }, t)), he.default.createElement("div", null, this.renderInputContainer(), t);
          }
          return he.default.createElement(na, {
            className: this.props.popperClassName,
            wrapperClassName: this.props.wrapperClassName,
            hidePopper: !this.isCalendarOpen(),
            portalId: this.props.portalId,
            portalHost: this.props.portalHost,
            popperModifiers: this.props.popperModifiers,
            targetComponent: this.renderInputContainer(),
            popperContainer: this.props.popperContainer,
            popperComponent: e,
            popperPlacement: this.props.popperPlacement,
            popperProps: this.props.popperProps,
            popperOnKeyDown: this.onPopperKeyDown,
            enableTabLoop: this.props.enableTabLoop
          });
        }
      }], [{
        key: "defaultProps",
        get: function get() {
          return {
            allowSameDay: !1,
            dateFormat: "MM/dd/yyyy",
            dateFormatCalendar: "LLLL yyyy",
            onChange: function onChange() {},
            disabled: !1,
            disabledKeyboardNavigation: !1,
            dropdownMode: "scroll",
            onFocus: function onFocus() {},
            onBlur: function onBlur() {},
            onKeyDown: function onKeyDown() {},
            onInputClick: function onInputClick() {},
            onSelect: function onSelect() {},
            onClickOutside: function onClickOutside() {},
            onMonthChange: function onMonthChange() {},
            onCalendarOpen: function onCalendarOpen() {},
            onCalendarClose: function onCalendarClose() {},
            preventOpenOnFocus: !1,
            onYearChange: function onYearChange() {},
            onInputError: function onInputError() {},
            monthsShown: 1,
            readOnly: !1,
            withPortal: !1,
            selectsDisabledDaysInRange: !1,
            shouldCloseOnSelect: !0,
            showTimeSelect: !1,
            showTimeInput: !1,
            showPreviousMonths: !1,
            showMonthYearPicker: !1,
            showFullMonthYearPicker: !1,
            showTwoColumnMonthYearPicker: !1,
            showFourColumnMonthYearPicker: !1,
            showYearPicker: !1,
            showQuarterYearPicker: !1,
            strictParsing: !1,
            timeIntervals: 30,
            timeCaption: "Time",
            previousMonthAriaLabel: "Previous Month",
            previousMonthButtonLabel: "Previous Month",
            nextMonthAriaLabel: "Next Month",
            nextMonthButtonLabel: "Next Month",
            previousYearAriaLabel: "Previous Year",
            previousYearButtonLabel: "Previous Year",
            nextYearAriaLabel: "Next Year",
            nextYearButtonLabel: "Next Year",
            timeInputLabel: "Time",
            enableTabLoop: !0,
            yearItemNumber: Kt,
            renderDayContents: function renderDayContents(e) {
              return e;
            },
            focusSelectedMonth: !1,
            showPopperArrow: !0,
            excludeScrollbar: !0,
            customTimeInput: null,
            calendarStartDay: void 0
          };
        }
      }]), r;
    }(he.default.Component),
    la = "input",
    da = "navigate";
  e.CalendarContainer = Xr, e.default = pa, e.getDefaultLocale = pr, e.registerLocale = function (e, t) {
    var r = "undefined" != typeof window ? window : globalThis;
    r.__localeData__ || (r.__localeData__ = {}), r.__localeData__[e] = t;
  }, e.setDefaultLocale = function (e) {
    ("undefined" != typeof window ? window : globalThis).__localeId__ = e;
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});

/***/ }),

/***/ 30124:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(66992);
__webpack_require__(51532);
__webpack_require__(41539);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(70189);
__webpack_require__(18264);
__webpack_require__(24603);
__webpack_require__(74916);
__webpack_require__(39714);
__webpack_require__(92087);
__webpack_require__(47941);
__webpack_require__(4723);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.3
  if (a === b) return true;
  if (a && b && _typeof(a) == 'object' && _typeof(b) == 'object') {
    if (a.constructor !== b.constructor) return false;
    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && a instanceof Map && b instanceof Map) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done) {
        if (!b.has(i.value[0])) return false;
      }
      it = a.entries();
      while (!(i = it.next()).done) {
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      }
      return true;
    }
    if (hasSet && a instanceof Set && b instanceof Set) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done) {
        if (!b.has(i.value[0])) return false;
      }
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) {
        if (a[i] !== b[i]) return false;
      }
      return true;
    }
    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    // START: Modifications:
    // Apply guards for `Object.create(null)` handling. See:
    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
    // END: Modifications

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;
    for (i = length; i-- !== 0;) {
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    }
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }
  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message || '').match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

/***/ }),

/***/ 6034:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "IGNORE_CLASS_NAME": () => (/* binding */ IGNORE_CLASS_NAME)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10097);





function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
} /**
  * Check whether some DOM node is our Component's node.
  */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17

  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }
  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.
  // Also cover shadowRoot node by checking current.host

  while (current.parentNode || current.host) {
    // Only check normal node without shadowRoot
    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }
    current = current.parentNode || current.host;
  }
  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
} // ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }
  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });
  var noop = function noop() {};
  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};
function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }
  return function () {
    return ++seed;
  };
}
var uid = autoInc();
var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = {};
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
  if (isTouchEvent && passiveEventSupport) {
    handlerOptions.passive = !instance.props.preventDefault;
  }
  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */

function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;
  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inheritsLoose(onClickOutside, _Component);
    function onClickOutside(props) {
      var _this;
      _this = _Component.call(this, props) || this;
      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);
          return;
        }
        var instance = _this.getInstance();
        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }
        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }
        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };
      _this.__getComponentNode = function () {
        var instance = _this.getInstance();
        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }
        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }
        return (0,react__WEBPACK_IMPORTED_MODULE_3__.findDOMNode)(instance);
      };
      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }
        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }
        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;
        if (!events.forEach) {
          events = [events];
        }
        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;
          if (_this.props.preventDefault) {
            event.preventDefault();
          }
          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }
          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }
          _this.__outsideClickHandler(event);
        };
        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
        });
      };
      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];
        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;
          if (!events.forEach) {
            events = [events];
          }
          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
          });
          delete handlersMap[_this._uid];
        }
      };
      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };
      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */

    var _proto = onClickOutside.prototype;
    _proto.getInstance = function getInstance() {
      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
        return this;
      }
      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }
      var instance = this.getInstance();
      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }
      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    }
    /**
     * Remove all document's event listeners for this component
     */;

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    }
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */;

    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props;
      _this$props.excludeScrollbar;
      var props = _objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);
      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }
      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return (0,react__WEBPACK_IMPORTED_MODULE_3__.createElement)(WrappedComponent, props);
    };
    return onClickOutside;
  }(react__WEBPACK_IMPORTED_MODULE_3__.Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (onClickOutsideHOC);


/***/ }),

/***/ 25984:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Manager": () => (/* reexport */ Manager),
  "Popper": () => (/* reexport */ Popper),
  "Reference": () => (/* reexport */ Reference),
  "usePopper": () => (/* reexport */ usePopper)
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js
var compat_module = __webpack_require__(10097);
;// CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/Manager.js

var ManagerReferenceNodeContext = compat_module.createContext();
var ManagerReferenceNodeSetterContext = compat_module.createContext();
function Manager(_ref) {
  var children = _ref.children;
  var _React$useState = compat_module.useState(null),
    referenceNode = _React$useState[0],
    setReferenceNode = _React$useState[1];
  var hasUnmounted = compat_module.useRef(false);
  compat_module.useEffect(function () {
    return function () {
      hasUnmounted.current = true;
    };
  }, []);
  var handleSetReferenceNode = compat_module.useCallback(function (node) {
    if (!hasUnmounted.current) {
      setReferenceNode(node);
    }
  }, []);
  return /*#__PURE__*/compat_module.createElement(ManagerReferenceNodeContext.Provider, {
    value: referenceNode
  }, /*#__PURE__*/compat_module.createElement(ManagerReferenceNodeSetterContext.Provider, {
    value: handleSetReferenceNode
  }, children));
}
;// CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/utils.js


/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return fn.apply(void 0, args);
  }
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === 'function') {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
    ref.current = node;
  }
};
/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
      value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? compat_module.useLayoutEffect : compat_module.useEffect;
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(21249);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(19601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(57327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__(69826);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(69600);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(54747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js


function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/math.js
var math_max = Math.max;
var math_min = Math.min;
var round = Math.round;
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/userAgent.js


function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }
  return navigator.userAgent;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js




function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref = isElement(element) ? getWindow(element) : window,
    visualViewport = _ref.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js




function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument :
  // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
    overflow = _getComputedStyle.overflow,
    overflowX = _getComputedStyle.overflowX,
    overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js








function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.

function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' ||
    // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js



function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }
  return (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot ||
    // step into the shadow DOM of the parent of a slotted node
    element.parentNode || (
    // DOM Element detected
    isShadowRoot(element) ? element.host : null) ||
    // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback
  );
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode(node));
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js





/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList :
  // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isTableElement.js

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js








function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) ||
  // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }
  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block

function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);
    if (elementCss.position === 'fixed') {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.

function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }
  return offsetParent || getContainingBlock(element) || window;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.map.js
var es_map = __webpack_require__(51532);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__(70189);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/enums.js

var enums_top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [enums_top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var enums_placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/orderModifiers.js










 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/debounce.js

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }
    return pending;
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergeByName.js




function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/createPopper.js






















var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions,
    _generatorOptions$def = _generatorOptions.defaultModifiers,
    defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
    _generatorOptions$def2 = _generatorOptions.defaultOptions,
    defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (false) { var _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft, flipModifier, modifiers; }
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements,
          reference = _state$elements.reference,
          popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (false) {}
          return;
        } // Store the reference and popper rects to be read by modifiers

        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;
        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (false) {}
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index],
            fn = _state$orderedModifie.fn,
            _state$orderedModifie2 = _state$orderedModifie.options,
            _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
            name = _state$orderedModifie.name;
          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference, popper)) {
      if (false) {}
      return instance;
    }
    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
          _ref3$options = _ref3.options,
          options = _ref3$options === void 0 ? {} : _ref3$options,
          effect = _ref3.effect;
        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });
          var noopFn = function noopFn() {};
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}
var createPopper = /*#__PURE__*/(/* unused pure expression or super */ null && (popperGenerator())); // eslint-disable-next-line import/no-unused-modules


;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/eventListeners.js


 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};
function effect(_ref) {
  var state = _ref.state,
    instance = _ref.instance,
    options = _ref.options;
  var _options$scroll = options.scroll,
    scroll = _options$scroll === void 0 ? true : _options$scroll,
    _options$resize = options.resize,
    resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }
  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }
  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }
    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules

/* harmony default export */ const eventListeners = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__(23123);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getBasePlacement.js



function getBasePlacement(placement) {
  return placement.split('-')[0];
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getVariation.js


function getVariation(placement) {
  return placement.split('-')[1];
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeOffsets.js




function computeOffsets(_ref) {
  var reference = _ref.reference,
    element = _ref.element,
    placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case enums_top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
      default:
    }
  }
  return offsets;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js


function popperOffsets(_ref) {
  var state = _ref.state,
    name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules

/* harmony default export */ const modifiers_popperOffsets = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/computeStyles.js









 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
    y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper = _ref2.popper,
    popperRect = _ref2.popperRect,
    placement = _ref2.placement,
    variation = _ref2.variation,
    offsets = _ref2.offsets,
    position = _ref2.position,
    gpuAcceleration = _ref2.gpuAcceleration,
    adaptive = _ref2.adaptive,
    roundOffsets = _ref2.roundOffsets,
    isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
    x = _offsets$x === void 0 ? 0 : _offsets$x,
    _offsets$y = offsets.y,
    y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = enums_top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';
    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);
      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it

    offsetParent = offsetParent;
    if (placement === enums_top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height :
      // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === enums_top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width :
      // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state,
    options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
    gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
    _options$adaptive = options.adaptive,
    adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
    _options$roundOffsets = options.roundOffsets,
    roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  if (false) { var transitionProperty; }
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules

/* harmony default export */ const modifiers_computeStyles = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/applyStyles.js




 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]

    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];
      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}
function applyStyles_effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules

/* harmony default export */ const modifiers_applyStyles = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: applyStyles_effect,
  requires: ['computeStyles']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/offset.js



 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, enums_top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
      placement: placement
    })) : offset,
    skidding = _ref[0],
    distance = _ref[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state,
    options = _ref2.options,
    name = _ref2.name;
  var _options$offset = options.offset,
    offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = enums_placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
    x = _data$state$placement.x,
    y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules

/* harmony default export */ const modifiers_offset = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(15306);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositePlacement.js


var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js


var getOppositeVariationPlacement_hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return getOppositeVariationPlacement_hash[matched];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js




function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = math_max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = math_max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;
  if (getComputedStyle(body || html).direction === 'rtl') {
    x += math_max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/contains.js

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;
    do {
      if (next && parent.isSameNode(next)) {
        return true;
      } // $FlowFixMe[prop-missing]: need a better way to handle this...

      next = next.parentNode || next.host;
    } while (next);
  } // Give up, the result is false

  return false;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/rectToClientRect.js

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js
















function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`

function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414

  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents

function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = math_max(rect.top, accRect.top);
    accRect.right = math_min(rect.right, accRect.right);
    accRect.bottom = math_min(rect.bottom, accRect.bottom);
    accRect.left = math_max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js


function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/detectOverflow.js











 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    _options$placement = _options.placement,
    placement = _options$placement === void 0 ? state.placement : _options$placement,
    _options$strategy = _options.strategy,
    strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
    _options$boundary = _options.boundary,
    boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
    _options$rootBoundary = _options.rootBoundary,
    rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
    _options$elementConte = _options.elementContext,
    elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
    _options$altBoundary = _options.altBoundary,
    altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
    _options$padding = _options.padding,
    padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [enums_top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }
  return overflowOffsets;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__(2707);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js








function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    placement = _options.placement,
    boundary = _options.boundary,
    rootBoundary = _options.rootBoundary,
    padding = _options.padding,
    flipVariations = _options.flipVariations,
    _options$allowedAutoP = _options.allowedAutoPlacements,
    allowedAutoPlacements = _options$allowedAutoP === void 0 ? enums_placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;
    if (false) {}
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...

  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/flip.js















 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref) {
  var state = _ref.state,
    options = _ref.options,
    name = _ref.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis,
    checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
    _options$altAxis = options.altAxis,
    checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
    specifiedFallbackPlacements = options.fallbackPlacements,
    padding = options.padding,
    boundary = options.boundary,
    rootBoundary = options.rootBoundary,
    altBoundary = options.altBoundary,
    _options$flipVariatio = options.flipVariations,
    flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
    allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];
  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [enums_top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : enums_top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);
        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break") break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules

/* harmony default export */ const modifiers_flip = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/within.js

function within(min, value, max) {
  return math_max(min, math_min(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js













function preventOverflow(_ref) {
  var state = _ref.state,
    options = _ref.options,
    name = _ref.name;
  var _options$mainAxis = options.mainAxis,
    checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
    _options$altAxis = options.altAxis,
    checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
    boundary = options.boundary,
    rootBoundary = options.rootBoundary,
    altBoundary = options.altBoundary,
    padding = options.padding,
    _options$tether = options.tether,
    tether = _options$tether === void 0 ? true : _options$tether,
    _options$tetherOffset = options.tetherOffset,
    tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === 'y' ? enums_top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? math_min(min, tetherMin) : min, offset, tether ? math_max(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === 'x' ? enums_top : left;
    var _altSide = mainAxis === 'x' ? bottom : right;
    var _offset = popperOffsets[altAxis];
    var _len = altAxis === 'y' ? 'height' : 'width';
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [enums_top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules

/* harmony default export */ const modifiers_preventOverflow = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/arrow.js












 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref) {
  var _state$modifiersData$;
  var state = _ref.state,
    name = _ref.name,
    options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';
  if (!arrowElement || !popperOffsets) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? enums_top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function arrow_effect(_ref2) {
  var state = _ref2.state,
    options = _ref2.options;
  var _options$element = options.element,
    arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
  if (arrowElement == null) {
    return;
  } // CSS selector

  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (false) {}
  if (!contains(state.elements.popper, arrowElement)) {
    if (false) {}
    return;
  }
  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules

/* harmony default export */ const modifiers_arrow = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: arrow_effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/hide.js




function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [enums_top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref) {
  var state = _ref.state,
    name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules

/* harmony default export */ const modifiers_hide = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/popper.js










var defaultModifiers = [eventListeners, modifiers_popperOffsets, modifiers_computeStyles, modifiers_applyStyles, modifiers_offset, modifiers_flip, modifiers_preventOverflow, modifiers_arrow, modifiers_hide];
var popper_createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules


// EXTERNAL MODULE: ./node_modules/react-fast-compare/index.js
var react_fast_compare = __webpack_require__(30124);
var react_fast_compare_default = /*#__PURE__*/__webpack_require__.n(react_fast_compare);
;// CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/usePopper.js








var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }
  var prevOptions = compat_module.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };
  var _React$useState = compat_module.useState({
      styles: {
        popper: {
          position: optionsWithDefaults.strategy,
          left: '0',
          top: '0'
        },
        arrow: {
          position: 'absolute'
        }
      },
      attributes: {}
    }),
    state = _React$useState[0],
    setState = _React$useState[1];
  var updateStateModifier = compat_module.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        compat_module.flushSync(function () {
          setState({
            styles: fromEntries(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = compat_module.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };
    if (react_fast_compare_default()(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = compat_module.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }
    var createPopper = options.createPopper || popper_createPopper;
    var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};
;// CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/Popper.js






var NOOP = function NOOP() {
  return void 0;
};
var NOOP_PROMISE = function NOOP_PROMISE() {
  return Promise.resolve(null);
};
var Popper_EMPTY_MODIFIERS = [];
function Popper(_ref) {
  var _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
    _ref$strategy = _ref.strategy,
    strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy,
    _ref$modifiers = _ref.modifiers,
    modifiers = _ref$modifiers === void 0 ? Popper_EMPTY_MODIFIERS : _ref$modifiers,
    referenceElement = _ref.referenceElement,
    onFirstUpdate = _ref.onFirstUpdate,
    innerRef = _ref.innerRef,
    children = _ref.children;
  var referenceNode = compat_module.useContext(ManagerReferenceNodeContext);
  var _React$useState = compat_module.useState(null),
    popperElement = _React$useState[0],
    setPopperElement = _React$useState[1];
  var _React$useState2 = compat_module.useState(null),
    arrowElement = _React$useState2[0],
    setArrowElement = _React$useState2[1];
  compat_module.useEffect(function () {
    setRef(innerRef, popperElement);
  }, [innerRef, popperElement]);
  var options = compat_module.useMemo(function () {
    return {
      placement: placement,
      strategy: strategy,
      onFirstUpdate: onFirstUpdate,
      modifiers: [].concat(modifiers, [{
        name: 'arrow',
        enabled: arrowElement != null,
        options: {
          element: arrowElement
        }
      }])
    };
  }, [placement, strategy, onFirstUpdate, modifiers, arrowElement]);
  var _usePopper = usePopper(referenceElement || referenceNode, popperElement, options),
    state = _usePopper.state,
    styles = _usePopper.styles,
    forceUpdate = _usePopper.forceUpdate,
    update = _usePopper.update;
  var childrenProps = compat_module.useMemo(function () {
    return {
      ref: setPopperElement,
      style: styles.popper,
      placement: state ? state.placement : placement,
      hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: styles.arrow,
        ref: setArrowElement
      },
      forceUpdate: forceUpdate || NOOP,
      update: update || NOOP_PROMISE
    };
  }, [setPopperElement, setArrowElement, placement, state, styles, update, forceUpdate]);
  return unwrapArray(children)(childrenProps);
}
// EXTERNAL MODULE: ./node_modules/warning/warning.js
var warning = __webpack_require__(98939);
var warning_default = /*#__PURE__*/__webpack_require__.n(warning);
;// CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/Reference.js




function Reference(_ref) {
  var children = _ref.children,
    innerRef = _ref.innerRef;
  var setReferenceNode = compat_module.useContext(ManagerReferenceNodeSetterContext);
  var refHandler = compat_module.useCallback(function (node) {
    setRef(innerRef, node);
    safeInvoke(setReferenceNode, node);
  }, [innerRef, setReferenceNode]); // ran on unmount
  // eslint-disable-next-line react-hooks/exhaustive-deps

  compat_module.useEffect(function () {
    return function () {
      return setRef(innerRef, null);
    };
  }, []);
  compat_module.useEffect(function () {
    warning_default()(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
  }, [setReferenceNode]);
  return unwrapArray(children)({
    ref: refHandler
  });
}
;// CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/index.js
// Public components




 // Public types

/***/ }),

/***/ 87751:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(72443);
__webpack_require__(39341);
__webpack_require__(73706);
__webpack_require__(10408);
__webpack_require__(30489);
__webpack_require__(68309);
__webpack_require__(54747);
__webpack_require__(47042);
__webpack_require__(65743);
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);
    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  exports.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction ||
    // For the native GeneratorFunction constructor, the best we can
    // do is to check its .name property.
    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };
  exports.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function (arg) {
    return {
      __await: arg
    };
  };
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value && _typeof(value) === "object" && hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }
        return PromiseImpl.resolve(value).then(function (unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function (error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }
    var previousPromise;
    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }
      return previousPromise =
      // If enqueue has been called before, then we want to wait until
      // all previous Promises have been resolved before calling invoke,
      // so that results are always delivered in the correct order. If
      // enqueue has not been called before, then it is important to
      // call invoke immediately, without waiting on a callback to fire,
      // so that the async generator function has the opportunity to do
      // any necessary setup in a predictable way. This predictability
      // is why the Promise constructor synchronously invokes its
      // executor callback, and why async functions synchronously
      // execute code before the first await. Since we implement simple
      // async functions in terms of async generators, it is especially
      // important to get this right, even though it requires care.
      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
      // Avoid propagating failures to Promises returned by later
      // invocations of the iterator.
      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }
  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
    : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };
  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;
    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }
      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }
      context.method = method;
      context.arg = arg;
      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }
          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }
        state = GenStateExecuting;
        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;
          if (record.arg === ContinueSentinel) {
            continue;
          }
          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;
      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);
          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }
        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return ContinueSentinel;
    }
    var record = tryCatch(method, delegate.iterator, context.arg);
    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }
    var info = record.arg;
    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }
    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }
    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);
  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function () {
    return this;
  });
  define(Gp, "toString", function () {
    return "[object Generator]";
  });
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    if (1 in locs) {
      entry.catchLoc = locs[1];
    }
    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }
    this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }
  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{
      tryLoc: "root"
    }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }
  exports.keys = function (object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }
      if (typeof iterable.next === "function") {
        return iterable;
      }
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }
            next.value = undefined;
            next.done = true;
            return next;
          };
        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return {
      next: doneResult
    };
  }
  exports.values = values;
  function doneResult() {
    return {
      value: undefined,
      done: true
    };
  }
  Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;
      this.method = "next";
      this.arg = undefined;
      this.tryEntries.forEach(resetTryEntry);
      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },
    stop: function stop() {
      this.done = true;
      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }
      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;
        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }
        return !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;
        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }
      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;
      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }
      return this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }
      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }
      return ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };
      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }
      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;
}(
// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
( false ? 0 : _typeof(module)) === "object" ? module.exports : {});
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if ((typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}

/***/ }),

/***/ 23412:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var setFunctionName = __webpack_require__(34385);
var $TypeError = __webpack_require__(13237);
var $Object = Object;
module.exports = setFunctionName(function flags() {
  if (this == null || this !== $Object(this)) {
    throw new $TypeError('RegExp.prototype.flags getter called on non-object');
  }
  var result = '';
  if (this.hasIndices) {
    result += 'd';
  }
  if (this.global) {
    result += 'g';
  }
  if (this.ignoreCase) {
    result += 'i';
  }
  if (this.multiline) {
    result += 'm';
  }
  if (this.dotAll) {
    result += 's';
  }
  if (this.unicode) {
    result += 'u';
  }
  if (this.unicodeSets) {
    result += 'v';
  }
  if (this.sticky) {
    result += 'y';
  }
  return result;
}, 'get flags', true);

/***/ }),

/***/ 95081:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var define = __webpack_require__(97614);
var callBind = __webpack_require__(53785);
var implementation = __webpack_require__(23412);
var getPolyfill = __webpack_require__(31660);
var shim = __webpack_require__(40193);
var flagsBound = callBind(getPolyfill());
define(flagsBound, {
  getPolyfill: getPolyfill,
  implementation: implementation,
  shim: shim
});
module.exports = flagsBound;

/***/ }),

/***/ 31660:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(38880);
__webpack_require__(92087);
__webpack_require__(24603);
__webpack_require__(74916);
__webpack_require__(39714);
var implementation = __webpack_require__(23412);
var supportsDescriptors = __webpack_require__(97614).supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;
module.exports = function getPolyfill() {
  if (supportsDescriptors && /a/mig.flags === 'gim') {
    var descriptor = $gOPD(RegExp.prototype, 'flags');
    if (descriptor && typeof descriptor.get === 'function' && 'dotAll' in RegExp.prototype && 'hasIndices' in RegExp.prototype) {
      /* eslint getter-return: 0 */
      var calls = '';
      var o = {};
      Object.defineProperty(o, 'hasIndices', {
        get: function get() {
          calls += 'd';
        }
      });
      Object.defineProperty(o, 'sticky', {
        get: function get() {
          calls += 'y';
        }
      });
      descriptor.get.call(o);
      if (calls === 'dy') {
        return descriptor.get;
      }
    }
  }
  return implementation;
};

/***/ }),

/***/ 40193:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(38880);
__webpack_require__(30489);
var supportsDescriptors = __webpack_require__(97614).supportsDescriptors;
var getPolyfill = __webpack_require__(31660);
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;
module.exports = function shimFlags() {
  if (!supportsDescriptors || !getProto) {
    throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
  }
  var polyfill = getPolyfill();
  var proto = getProto(regex);
  var descriptor = gOPD(proto, 'flags');
  if (!descriptor || descriptor.get !== polyfill) {
    defineProperty(proto, 'flags', {
      configurable: true,
      enumerable: false,
      get: polyfill
    });
  }
  return polyfill;
};

/***/ }),

/***/ 52298:
/***/ ((__unused_webpack_module, exports) => {

var __webpack_unused_export__;
// the following functions are based off of the pseudocode
// found on www.easyrgb.com

__webpack_unused_export__ = function lab2rgb(lab) {
  var y = (lab[0] + 16) / 116,
    x = lab[1] / 500 + y,
    z = y - lab[2] / 200,
    r,
    g,
    b;
  x = 0.95047 * (x * x * x > 0.008856 ? x * x * x : (x - 16 / 116) / 7.787);
  y = 1.00000 * (y * y * y > 0.008856 ? y * y * y : (y - 16 / 116) / 7.787);
  z = 1.08883 * (z * z * z > 0.008856 ? z * z * z : (z - 16 / 116) / 7.787);
  r = x * 3.2406 + y * -1.5372 + z * -0.4986;
  g = x * -0.9689 + y * 1.8758 + z * 0.0415;
  b = x * 0.0557 + y * -0.2040 + z * 1.0570;
  r = r > 0.0031308 ? 1.055 * Math.pow(r, 1 / 2.4) - 0.055 : 12.92 * r;
  g = g > 0.0031308 ? 1.055 * Math.pow(g, 1 / 2.4) - 0.055 : 12.92 * g;
  b = b > 0.0031308 ? 1.055 * Math.pow(b, 1 / 2.4) - 0.055 : 12.92 * b;
  return [Math.max(0, Math.min(1, r)) * 255, Math.max(0, Math.min(1, g)) * 255, Math.max(0, Math.min(1, b)) * 255];
};
exports.Rw = function rgb2lab(rgb) {
  var r = rgb[0] / 255,
    g = rgb[1] / 255,
    b = rgb[2] / 255,
    x,
    y,
    z;
  r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
  g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
  b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
  x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
  y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.00000;
  z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
  x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
  y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
  z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
  return [116 * y - 16, 500 * (x - y), 200 * (y - z)];
};

// calculate the perceptual distance between colors in CIELAB
// https://github.com/THEjoezack/ColorMine/blob/master/ColorMine/ColorSpaces/Comparisons/Cie94Comparison.cs

__webpack_unused_export__ = function deltaE(labA, labB) {
  var deltaL = labA[0] - labB[0];
  var deltaA = labA[1] - labB[1];
  var deltaB = labA[2] - labB[2];
  var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
  var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
  var deltaC = c1 - c2;
  var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
  deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
  var sc = 1.0 + 0.045 * c1;
  var sh = 1.0 + 0.015 * c1;
  var deltaLKlsl = deltaL / 1.0;
  var deltaCkcsc = deltaC / sc;
  var deltaHkhsh = deltaH / sh;
  var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
  return i < 0 ? 0 : Math.sqrt(i);
};

/***/ }),

/***/ 48119:
/***/ ((module) => {

module.exports = SafeParseTuple;
function SafeParseTuple(obj, reviver) {
  var json;
  var error = null;
  try {
    json = JSON.parse(obj, reviver);
  } catch (err) {
    error = err;
  }
  return [error, json];
}

/***/ }),

/***/ 2790:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(37555);
var define = __webpack_require__(94135);
var hasDescriptors = __webpack_require__(17536)();
var gOPD = __webpack_require__(12500);
var $TypeError = __webpack_require__(13237);
var $floor = GetIntrinsic('%Math.floor%');

/** @type {import('.')} */
module.exports = function setFunctionLength(fn, length) {
  if (typeof fn !== 'function') {
    throw new $TypeError('`fn` is not a function');
  }
  if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
    throw new $TypeError('`length` must be a positive 32-bit integer');
  }
  var loose = arguments.length > 2 && !!arguments[2];
  var functionLengthIsConfigurable = true;
  var functionLengthIsWritable = true;
  if ('length' in fn && gOPD) {
    var desc = gOPD(fn, 'length');
    if (desc && !desc.configurable) {
      functionLengthIsConfigurable = false;
    }
    if (desc && !desc.writable) {
      functionLengthIsWritable = false;
    }
  }
  if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
    if (hasDescriptors) {
      define(fn, 'length', length, true, true);
    } else {
      define(fn, 'length', length);
    }
  }
  return fn;
};

/***/ }),

/***/ 34385:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var define = __webpack_require__(94135);
var hasDescriptors = __webpack_require__(17536)();
var functionsHaveConfigurableNames = __webpack_require__(68237).functionsHaveConfigurableNames();
var $TypeError = __webpack_require__(13237);

/** @type {import('.')} */
module.exports = function setFunctionName(fn, name) {
  if (typeof fn !== 'function') {
    throw new $TypeError('`fn` is not a function');
  }
  var loose = arguments.length > 2 && !!arguments[2];
  if (!loose || functionsHaveConfigurableNames) {
    if (hasDescriptors) {
      define(fn, 'name', name, true, true);
    } else {
      define(fn, 'name', name);
    }
  }
  return fn;
};

/***/ }),

/***/ 5757:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
var GetIntrinsic = __webpack_require__(37555);
var callBound = __webpack_require__(73684);
var inspect = __webpack_require__(41077);
var $TypeError = __webpack_require__(13237);
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);
var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('.').listGetNode} */
var listGetNode = function listGetNode(list, key) {
  // eslint-disable-line consistent-return
  /** @type {typeof list | NonNullable<(typeof list)['next']>} */
  var prev = list;
  /** @type {(typeof list)['next']} */
  var curr;
  for (; (curr = prev.next) !== null; prev = curr) {
    if (curr.key === key) {
      prev.next = curr.next;
      // eslint-disable-next-line no-extra-parens
      curr.next = list.next;
      list.next = curr; // eslint-disable-line no-param-reassign
      return curr;
    }
  }
};

/** @type {import('.').listGet} */
var listGet = function listGet(objects, key) {
  var node = listGetNode(objects, key);
  return node && node.value;
};
/** @type {import('.').listSet} */
var listSet = function listSet(objects, key, value) {
  var node = listGetNode(objects, key);
  if (node) {
    node.value = value;
  } else {
    // Prepend the new node to the beginning of the list
    objects.next = {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: key,
      next: objects.next,
      value: value
    };
  }
};
/** @type {import('.').listHas} */
var listHas = function listHas(objects, key) {
  return !!listGetNode(objects, key);
};

/** @type {import('.')} */
module.exports = function getSideChannel() {
  /** @type {WeakMap<object, unknown>} */var $wm;
  /** @type {Map<object, unknown>} */
  var $m;
  /** @type {import('.').RootNode<unknown>} */
  var $o;

  /** @type {import('.').Channel} */
  var channel = {
    assert: function assert(key) {
      if (!channel.has(key)) {
        throw new $TypeError('Side channel does not contain ' + inspect(key));
      }
    },
    get: function get(key) {
      // eslint-disable-line consistent-return
      if ($WeakMap && key && (_typeof(key) === 'object' || typeof key === 'function')) {
        if ($wm) {
          return $weakMapGet($wm, key);
        }
      } else if ($Map) {
        if ($m) {
          return $mapGet($m, key);
        }
      } else {
        if ($o) {
          // eslint-disable-line no-lonely-if
          return listGet($o, key);
        }
      }
    },
    has: function has(key) {
      if ($WeakMap && key && (_typeof(key) === 'object' || typeof key === 'function')) {
        if ($wm) {
          return $weakMapHas($wm, key);
        }
      } else if ($Map) {
        if ($m) {
          return $mapHas($m, key);
        }
      } else {
        if ($o) {
          // eslint-disable-line no-lonely-if
          return listHas($o, key);
        }
      }
      return false;
    },
    set: function set(key, value) {
      if ($WeakMap && key && (_typeof(key) === 'object' || typeof key === 'function')) {
        if (!$wm) {
          $wm = new $WeakMap();
        }
        $weakMapSet($wm, key, value);
      } else if ($Map) {
        if (!$m) {
          $m = new $Map();
        }
        $mapSet($m, key, value);
      } else {
        if (!$o) {
          // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
          $o = {
            key: {},
            next: null
          };
        }
        listSet($o, key, value);
      }
    }
  };
  return channel;
};

/***/ }),

/***/ 41077:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(66992);
__webpack_require__(51532);
__webpack_require__(41539);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(38880);
__webpack_require__(70189);
__webpack_require__(4129);
__webpack_require__(38478);
__webpack_require__(74916);
__webpack_require__(4723);
__webpack_require__(15306);
__webpack_require__(24603);
__webpack_require__(39714);
__webpack_require__(92222);
__webpack_require__(69600);
__webpack_require__(47042);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(39341);
__webpack_require__(73706);
__webpack_require__(10408);
__webpack_require__(39361);
__webpack_require__(30489);
__webpack_require__(68309);
__webpack_require__(9653);
__webpack_require__(65743);
var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && _typeof(Symbol.iterator) === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && _typeof(Symbol.iterator) === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (_typeof(Symbol.toStringTag) === hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;
var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
? function (O) {
  return O.__proto__; // eslint-disable-line no-proto
} : null);
function addNumericSeparator(num, str) {
  if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $test.call(/e/, str)) {
    return str;
  }
  var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof num === 'number') {
    var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
    if (int !== num) {
      var intStr = String(int);
      var dec = $slice.call(str, intStr.length + 1);
      return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
    }
  }
  return $replace.call(str, sepRegex, '$&_');
}
var utilInspect = __webpack_require__(47165);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
  var opts = options || {};
  if (has(opts, 'quoteStyle') && opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double') {
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  }
  if (has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  }
  var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
  if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
    throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
  }
  if (has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  }
  if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  }
  var numericSeparator = opts.numericSeparator;
  if (typeof obj === 'undefined') {
    return 'undefined';
  }
  if (obj === null) {
    return 'null';
  }
  if (typeof obj === 'boolean') {
    return obj ? 'true' : 'false';
  }
  if (typeof obj === 'string') {
    return inspectString(obj, opts);
  }
  if (typeof obj === 'number') {
    if (obj === 0) {
      return Infinity / obj > 0 ? '0' : '-0';
    }
    var str = String(obj);
    return numericSeparator ? addNumericSeparator(obj, str) : str;
  }
  if (typeof obj === 'bigint') {
    var bigIntStr = String(obj) + 'n';
    return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
  }
  var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
  if (typeof depth === 'undefined') {
    depth = 0;
  }
  if (depth >= maxDepth && maxDepth > 0 && _typeof(obj) === 'object') {
    return isArray(obj) ? '[Array]' : '[Object]';
  }
  var indent = getIndent(opts, depth);
  if (typeof seen === 'undefined') {
    seen = [];
  } else if (indexOf(seen, obj) >= 0) {
    return '[Circular]';
  }
  function inspect(value, from, noIndent) {
    if (from) {
      seen = $arrSlice.call(seen);
      seen.push(from);
    }
    if (noIndent) {
      var newOpts = {
        depth: opts.depth
      };
      if (has(opts, 'quoteStyle')) {
        newOpts.quoteStyle = opts.quoteStyle;
      }
      return inspect_(value, newOpts, depth + 1, seen);
    }
    return inspect_(value, opts, depth + 1, seen);
  }
  if (typeof obj === 'function' && !isRegExp(obj)) {
    // in older engines, regexes are callable
    var name = nameOf(obj);
    var keys = arrObjKeys(obj, inspect);
    return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
  }
  if (isSymbol(obj)) {
    var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
    return _typeof(obj) === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
  }
  if (isElement(obj)) {
    var s = '<' + $toLowerCase.call(String(obj.nodeName));
    var attrs = obj.attributes || [];
    for (var i = 0; i < attrs.length; i++) {
      s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
    }
    s += '>';
    if (obj.childNodes && obj.childNodes.length) {
      s += '...';
    }
    s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
    return s;
  }
  if (isArray(obj)) {
    if (obj.length === 0) {
      return '[]';
    }
    var xs = arrObjKeys(obj, inspect);
    if (indent && !singleLineValues(xs)) {
      return '[' + indentedJoin(xs, indent) + ']';
    }
    return '[ ' + $join.call(xs, ', ') + ' ]';
  }
  if (isError(obj)) {
    var parts = arrObjKeys(obj, inspect);
    if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
      return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
    }
    if (parts.length === 0) {
      return '[' + String(obj) + ']';
    }
    return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
  }
  if (_typeof(obj) === 'object' && customInspect) {
    if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
      return utilInspect(obj, {
        depth: maxDepth - depth
      });
    } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
      return obj.inspect();
    }
  }
  if (isMap(obj)) {
    var mapParts = [];
    if (mapForEach) {
      mapForEach.call(obj, function (value, key) {
        mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
      });
    }
    return collectionOf('Map', mapSize.call(obj), mapParts, indent);
  }
  if (isSet(obj)) {
    var setParts = [];
    if (setForEach) {
      setForEach.call(obj, function (value) {
        setParts.push(inspect(value, obj));
      });
    }
    return collectionOf('Set', setSize.call(obj), setParts, indent);
  }
  if (isWeakMap(obj)) {
    return weakCollectionOf('WeakMap');
  }
  if (isWeakSet(obj)) {
    return weakCollectionOf('WeakSet');
  }
  if (isWeakRef(obj)) {
    return weakCollectionOf('WeakRef');
  }
  if (isNumber(obj)) {
    return markBoxed(inspect(Number(obj)));
  }
  if (isBigInt(obj)) {
    return markBoxed(inspect(bigIntValueOf.call(obj)));
  }
  if (isBoolean(obj)) {
    return markBoxed(booleanValueOf.call(obj));
  }
  if (isString(obj)) {
    return markBoxed(inspect(String(obj)));
  }
  // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
  /* eslint-env browser */
  if (typeof window !== 'undefined' && obj === window) {
    return '{ [object Window] }';
  }
  if (typeof globalThis !== 'undefined' && obj === globalThis || typeof __webpack_require__.g !== 'undefined' && obj === __webpack_require__.g) {
    return '{ [object globalThis] }';
  }
  if (!isDate(obj) && !isRegExp(obj)) {
    var ys = arrObjKeys(obj, inspect);
    var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
    var protoTag = obj instanceof Object ? '' : 'null prototype';
    var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
    var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
    var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
    if (ys.length === 0) {
      return tag + '{}';
    }
    if (indent) {
      return tag + '{' + indentedJoin(ys, indent) + '}';
    }
    return tag + '{ ' + $join.call(ys, ', ') + ' }';
  }
  return String(obj);
};
function wrapQuotes(s, defaultStyle, opts) {
  var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
  return quoteChar + s + quoteChar;
}
function quote(s) {
  return $replace.call(String(s), /"/g, '&quot;');
}
function isArray(obj) {
  return toStr(obj) === '[object Array]' && (!toStringTag || !(_typeof(obj) === 'object' && toStringTag in obj));
}
function isDate(obj) {
  return toStr(obj) === '[object Date]' && (!toStringTag || !(_typeof(obj) === 'object' && toStringTag in obj));
}
function isRegExp(obj) {
  return toStr(obj) === '[object RegExp]' && (!toStringTag || !(_typeof(obj) === 'object' && toStringTag in obj));
}
function isError(obj) {
  return toStr(obj) === '[object Error]' && (!toStringTag || !(_typeof(obj) === 'object' && toStringTag in obj));
}
function isString(obj) {
  return toStr(obj) === '[object String]' && (!toStringTag || !(_typeof(obj) === 'object' && toStringTag in obj));
}
function isNumber(obj) {
  return toStr(obj) === '[object Number]' && (!toStringTag || !(_typeof(obj) === 'object' && toStringTag in obj));
}
function isBoolean(obj) {
  return toStr(obj) === '[object Boolean]' && (!toStringTag || !(_typeof(obj) === 'object' && toStringTag in obj));
}

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
  if (hasShammedSymbols) {
    return obj && _typeof(obj) === 'object' && obj instanceof Symbol;
  }
  if (_typeof(obj) === 'symbol') {
    return true;
  }
  if (!obj || _typeof(obj) !== 'object' || !symToString) {
    return false;
  }
  try {
    symToString.call(obj);
    return true;
  } catch (e) {}
  return false;
}
function isBigInt(obj) {
  if (!obj || _typeof(obj) !== 'object' || !bigIntValueOf) {
    return false;
  }
  try {
    bigIntValueOf.call(obj);
    return true;
  } catch (e) {}
  return false;
}
var hasOwn = Object.prototype.hasOwnProperty || function (key) {
  return key in this;
};
function has(obj, key) {
  return hasOwn.call(obj, key);
}
function toStr(obj) {
  return objectToString.call(obj);
}
function nameOf(f) {
  if (f.name) {
    return f.name;
  }
  var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
  if (m) {
    return m[1];
  }
  return null;
}
function indexOf(xs, x) {
  if (xs.indexOf) {
    return xs.indexOf(x);
  }
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) {
      return i;
    }
  }
  return -1;
}
function isMap(x) {
  if (!mapSize || !x || _typeof(x) !== 'object') {
    return false;
  }
  try {
    mapSize.call(x);
    try {
      setSize.call(x);
    } catch (s) {
      return true;
    }
    return x instanceof Map; // core-js workaround, pre-v2.5.0
  } catch (e) {}
  return false;
}
function isWeakMap(x) {
  if (!weakMapHas || !x || _typeof(x) !== 'object') {
    return false;
  }
  try {
    weakMapHas.call(x, weakMapHas);
    try {
      weakSetHas.call(x, weakSetHas);
    } catch (s) {
      return true;
    }
    return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
  } catch (e) {}
  return false;
}
function isWeakRef(x) {
  if (!weakRefDeref || !x || _typeof(x) !== 'object') {
    return false;
  }
  try {
    weakRefDeref.call(x);
    return true;
  } catch (e) {}
  return false;
}
function isSet(x) {
  if (!setSize || !x || _typeof(x) !== 'object') {
    return false;
  }
  try {
    setSize.call(x);
    try {
      mapSize.call(x);
    } catch (m) {
      return true;
    }
    return x instanceof Set; // core-js workaround, pre-v2.5.0
  } catch (e) {}
  return false;
}
function isWeakSet(x) {
  if (!weakSetHas || !x || _typeof(x) !== 'object') {
    return false;
  }
  try {
    weakSetHas.call(x, weakSetHas);
    try {
      weakMapHas.call(x, weakMapHas);
    } catch (s) {
      return true;
    }
    return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
  } catch (e) {}
  return false;
}
function isElement(x) {
  if (!x || _typeof(x) !== 'object') {
    return false;
  }
  if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
    return true;
  }
  return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function inspectString(str, opts) {
  if (str.length > opts.maxStringLength) {
    var remaining = str.length - opts.maxStringLength;
    var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
    return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
  }
  // eslint-disable-next-line no-control-regex
  var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
  return wrapQuotes(s, 'single', opts);
}
function lowbyte(c) {
  var n = c.charCodeAt(0);
  var x = {
    8: 'b',
    9: 't',
    10: 'n',
    12: 'f',
    13: 'r'
  }[n];
  if (x) {
    return '\\' + x;
  }
  return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}
function markBoxed(str) {
  return 'Object(' + str + ')';
}
function weakCollectionOf(type) {
  return type + ' { ? }';
}
function collectionOf(type, size, entries, indent) {
  var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
  return type + ' (' + size + ') {' + joinedEntries + '}';
}
function singleLineValues(xs) {
  for (var i = 0; i < xs.length; i++) {
    if (indexOf(xs[i], '\n') >= 0) {
      return false;
    }
  }
  return true;
}
function getIndent(opts, depth) {
  var baseIndent;
  if (opts.indent === '\t') {
    baseIndent = '\t';
  } else if (typeof opts.indent === 'number' && opts.indent > 0) {
    baseIndent = $join.call(Array(opts.indent + 1), ' ');
  } else {
    return null;
  }
  return {
    base: baseIndent,
    prev: $join.call(Array(depth + 1), baseIndent)
  };
}
function indentedJoin(xs, indent) {
  if (xs.length === 0) {
    return '';
  }
  var lineJoiner = '\n' + indent.prev + indent.base;
  return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function arrObjKeys(obj, inspect) {
  var isArr = isArray(obj);
  var xs = [];
  if (isArr) {
    xs.length = obj.length;
    for (var i = 0; i < obj.length; i++) {
      xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
    }
  }
  var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
  var symMap;
  if (hasShammedSymbols) {
    symMap = {};
    for (var k = 0; k < syms.length; k++) {
      symMap['$' + syms[k]] = syms[k];
    }
  }
  for (var key in obj) {
    // eslint-disable-line no-restricted-syntax
    if (!has(obj, key)) {
      continue;
    } // eslint-disable-line no-restricted-syntax, no-continue
    if (isArr && String(Number(key)) === key && key < obj.length) {
      continue;
    } // eslint-disable-line no-restricted-syntax, no-continue
    if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
      // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
      continue; // eslint-disable-line no-restricted-syntax, no-continue
    } else if ($test.call(/[^\w$]/, key)) {
      xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
    } else {
      xs.push(key + ': ' + inspect(obj[key], obj));
    }
  }
  if (typeof gOPS === 'function') {
    for (var j = 0; j < syms.length; j++) {
      if (isEnumerable.call(obj, syms[j])) {
        xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
      }
    }
  }
  return xs;
}

/***/ }),

/***/ 88692:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(69600);
__webpack_require__(41539);
__webpack_require__(39714);
(function () {
  var Emitter = __webpack_require__(26766);
  var isNumber = __webpack_require__(43100);
  var tinycolor = __webpack_require__(60119);
  var transform = __webpack_require__(61157);

  /**
   * Creates a new SimpleColorPicker
   * @param {Object} options
   * @param {String|Number|Object} options.color The default color that the picker will display. Default is #FFFFFF. It can be a hexadecimal number or an hex String.
   * @param {String|Number|Object} options.background The background color of the picker. Default is transparent. It can be a hexadecimal number or an hex String.
   * @param {HTMLElement} options.el A dom node to add the picker to. You can also use `colorPicker.appendTo(domNode)` afterwards if you prefer.
   * @param {Number} options.width Desired width of the color picker. Default is 175.
   * @param {Number} options.height Desired height of the color picker. Default is 150.
   */
  function SimpleColorPicker(options) {
    // Options
    options = options || {};

    // Properties
    this.color = null;
    this.width = 0;
    this.widthUnits = 'px';
    this.height = 0;
    this.heightUnits = 'px';
    this.hue = 0;
    this.position = {
      x: 0,
      y: 0
    };
    this.huePosition = 0;
    this.saturationWidth = 0;
    this.hueHeight = 0;
    this.maxHue = 0;
    this.inputIsNumber = false;

    // Bind methods to scope (if needed)
    this._onSaturationMouseDown = this._onSaturationMouseDown.bind(this);
    this._onSaturationMouseMove = this._onSaturationMouseMove.bind(this);
    this._onSaturationMouseUp = this._onSaturationMouseUp.bind(this);
    this._onHueMouseDown = this._onHueMouseDown.bind(this);
    this._onHueMouseMove = this._onHueMouseMove.bind(this);
    this._onHueMouseUp = this._onHueMouseUp.bind(this);

    // Create DOM
    this.$el = document.createElement('div');
    this.$el.className = 'Scp';
    this.$el.innerHTML = ['<div class="Scp-saturation">', '<div class="Scp-brightness"></div>', '<div class="Scp-sbSelector"></div>', '</div>', '<div class="Scp-hue">', '<div class="Scp-hSelector"></div>', '</div>'].join('');

    // DOM accessors
    this.$saturation = this.$el.querySelector('.Scp-saturation');
    this.$hue = this.$el.querySelector('.Scp-hue');
    this.$sbSelector = this.$el.querySelector('.Scp-sbSelector');
    this.$hSelector = this.$el.querySelector('.Scp-hSelector');

    // Event listeners
    this.$saturation.addEventListener('mousedown', this._onSaturationMouseDown);
    this.$saturation.addEventListener('touchstart', this._onSaturationMouseDown);
    this.$hue.addEventListener('mousedown', this._onHueMouseDown);
    this.$hue.addEventListener('touchstart', this._onHueMouseDown);

    // Some styling and DOMing from options
    if (options.el) {
      this.appendTo(options.el);
    }
    if (options.background) {
      this.setBackgroundColor(options.background);
    }
    if (options.widthUnits) {
      this.widthUnits = options.widthUnits;
    }
    if (options.heightUnits) {
      this.heightUnits = options.heightUnits;
    }
    this.setSize(options.width || 175, options.height || 150);
    this.setColor(options.color);
    return this;
  }
  Emitter(SimpleColorPicker.prototype);

  /* =============================================================================
    Public API
  ============================================================================= */
  /**
   * Add the SimpleColorPicker instance to a DOM element.
   * @param  {HTMLElement} el
   * @return {SimpleColorPicker} Returns itself for chaining purpose
   */
  SimpleColorPicker.prototype.appendTo = function (el) {
    el.appendChild(this.$el);
    return this;
  };

  /**
   * Removes picker from its parent and kill all listeners.
   * Call this method for proper destroy.
   */
  SimpleColorPicker.prototype.remove = function () {
    this._onSaturationMouseUp();
    this._onHueMouseUp();
    this.$saturation.removeEventListener('mousedown', this._onSaturationMouseDown);
    this.$saturation.removeEventListener('touchstart', this._onSaturationMouseDown);
    this.$hue.removeEventListener('mousedown', this._onHueMouseDown);
    this.$hue.removeEventListener('touchstart', this._onHueMouseDown);
    this.off();
    if (this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  };

  /**
   * Manually set the current color of the picker. This is the method
   * used on instantiation to convert `color` option to actual color for
   * the picker. Param can be a hexadecimal number or an hex String.
   * @param {String|Number} color hex color desired
   * @return {SimpleColorPicker} Returns itself for chaining purpose
   */
  SimpleColorPicker.prototype.setColor = function (color) {
    if (isNumber(color)) {
      this.inputIsNumber = true;
      color = numberToHex(color);
    } else {
      this.inputIsNumber = false;
    }
    this.color = tinycolor(color);
    var hsvColor = this.color.toHsv();
    if (!isNaN(hsvColor.h)) {
      this.hue = hsvColor.h;
    }
    this._moveSelectorTo(this.saturationWidth * hsvColor.s, (1 - hsvColor.v) * this.hueHeight);
    this._moveHueTo((1 - this.hue / 360) * this.hueHeight);
    this._updateHue();
    return this;
  };

  /**
   * Set size of the color picker for a given width and height. Note that
   * a padding of 5px will be added if you chose to use the background option
   * of the constructor.
   * @param {Number} width
   * @param {Number} height
   * @return {SimpleColorPicker} Returns itself for chaining purpose
   */
  SimpleColorPicker.prototype.setSize = function (width, height) {
    this.width = width;
    this.height = height;
    this.$el.style.width = this.width + this.widthUnits;
    this.$el.style.height = this.height + this.heightUnits;
    this.saturationWidth = this.width - 25;
    this.$saturation.style.width = this.saturationWidth + 'px';
    this.hueHeight = this.height;
    this.maxHue = this.hueHeight - 2;
    return this;
  };

  /**
   * Set the background color of the picker. It also adds a 5px padding
   * for design purpose.
   * @param {String|Number} color hex color desired for background
   * @return {SimpleColorPicker} Returns itself for chaining purpose
   */
  SimpleColorPicker.prototype.setBackgroundColor = function (color) {
    if (isNumber(color)) {
      color = numberToHex(color);
    }
    this.$el.style.padding = '5px';
    this.$el.style.background = tinycolor(color).toHexString();
    return this;
  };

  /**
   * Removes background of the picker if previously set. It's no use
   * calling this method if you didn't set the background option on start
   * or if you didn't call setBackgroundColor previously.
   */
  SimpleColorPicker.prototype.setNoBackground = function () {
    this.$el.style.padding = '0px';
    this.$el.style.background = 'none';
  };

  /**
   * Registers callback to the update event of the picker.
   * picker inherits from [component/emitter](https://github.com/component/emitter)
   * so you could do the same thing by calling `colorPicker.on('update');`
   * @param  {Function} callback
   * @return {SimpleColorPicker} Returns itself for chaining purpose
   */
  SimpleColorPicker.prototype.onChange = function (callback) {
    this.on('update', callback);
    this.emit('update', this.getHexString());
    return this;
  };

  /* =============================================================================
    Color getters
  ============================================================================= */
  /**
   * Main color getter, will return a formatted color string depending on input
   * or a number depending on the last setColor call.
   * @return {Number|String}
   */
  SimpleColorPicker.prototype.getColor = function () {
    if (this.inputIsNumber) {
      return this.getHexNumber();
    }
    return this.color.toString();
  };

  /**
   * Returns color as css hex string (ex: '#FF0000').
   * @return {String}
   */
  SimpleColorPicker.prototype.getHexString = function () {
    return this.color.toHexString().toUpperCase();
  };

  /**
   * Returns color as number (ex: 0xFF0000).
   * @return {Number}
   */
  SimpleColorPicker.prototype.getHexNumber = function () {
    return parseInt(this.color.toHex(), 16);
  };

  /**
   * Returns color as {r: 255, g: 0, b: 0} object.
   * @return {Object}
   */
  SimpleColorPicker.prototype.getRGB = function () {
    return this.color.toRgb();
  };

  /**
   * Returns color as {h: 100, s: 1, v: 1} object.
   * @return {Object}
   */
  SimpleColorPicker.prototype.getHSV = function () {
    return this.color.toHsv();
  };

  /**
   * Returns true if color is perceived as dark
   * @return {Boolean}
   */
  SimpleColorPicker.prototype.isDark = function () {
    return this.color.isDark();
  };

  /**
   * Returns true if color is perceived as light
   * @return {Boolean}
   */
  SimpleColorPicker.prototype.isLight = function () {
    return this.color.isLight();
  };

  /* =============================================================================
    "Private" methods
  ============================================================================= */
  SimpleColorPicker.prototype._moveSelectorTo = function (x, y) {
    this.position.x = clamp(x, 0, this.saturationWidth);
    this.position.y = clamp(y, 0, this.hueHeight);
    transform(this.$sbSelector, {
      x: this.position.x,
      y: this.position.y
    });
  };
  SimpleColorPicker.prototype._updateColorFromPosition = function () {
    this.color = tinycolor({
      h: this.hue,
      s: this.position.x / this.saturationWidth,
      v: 1 - this.position.y / this.hueHeight
    });
    this._updateColor();
  };
  SimpleColorPicker.prototype._moveHueTo = function (y) {
    this.huePosition = clamp(y, 0, this.maxHue);
    transform(this.$hSelector, {
      y: this.huePosition
    });
  };
  SimpleColorPicker.prototype._updateHueFromPosition = function () {
    var hsvColor = this.color.toHsv();
    this.hue = 360 * (1 - this.huePosition / this.maxHue);
    this.color = tinycolor({
      h: this.hue,
      s: hsvColor.s,
      v: hsvColor.v
    });
    this._updateHue();
  };
  SimpleColorPicker.prototype._updateHue = function () {
    var hueColor = tinycolor({
      h: this.hue,
      s: 1,
      v: 1
    });
    this.$saturation.style.background = 'linear-gradient(to right, #fff, ' + hueColor.toHexString() + ')';
    this._updateColor();
  };
  SimpleColorPicker.prototype._updateColor = function () {
    this.$sbSelector.style.background = this.color.toHexString();
    this.$sbSelector.style.borderColor = this.color.isDark() ? '#fff' : '#000';
    this.emit('update', this.color.toHexString());
  };

  /* =============================================================================
    Events handlers
  ============================================================================= */
  SimpleColorPicker.prototype._onSaturationMouseDown = function (e) {
    var sbOffset = this.$saturation.getBoundingClientRect();
    var xPos = getMousePosition(e).x;
    var yPos = getMousePosition(e).y;
    this._moveSelectorTo(xPos - sbOffset.left, yPos - sbOffset.top);
    this._updateColorFromPosition();
    window.addEventListener('mouseup', this._onSaturationMouseUp);
    window.addEventListener('touchend', this._onSaturationMouseUp);
    window.addEventListener('mousemove', this._onSaturationMouseMove);
    window.addEventListener('touchmove', this._onSaturationMouseMove);
    e.preventDefault();
  };
  SimpleColorPicker.prototype._onSaturationMouseMove = function (e) {
    var sbOffset = this.$saturation.getBoundingClientRect();
    var xPos = getMousePosition(e).x;
    var yPos = getMousePosition(e).y;
    this._moveSelectorTo(xPos - sbOffset.left, yPos - sbOffset.top);
    this._updateColorFromPosition();
  };
  SimpleColorPicker.prototype._onSaturationMouseUp = function () {
    window.removeEventListener('mouseup', this._onSaturationMouseUp);
    window.removeEventListener('touchend', this._onSaturationMouseUp);
    window.removeEventListener('mousemove', this._onSaturationMouseMove);
    window.removeEventListener('touchmove', this._onSaturationMouseMove);
  };
  SimpleColorPicker.prototype._onHueMouseDown = function (e) {
    var hOffset = this.$hue.getBoundingClientRect();
    var yPos = getMousePosition(e).y;
    this._moveHueTo(yPos - hOffset.top);
    this._updateHueFromPosition();
    window.addEventListener('mouseup', this._onHueMouseUp);
    window.addEventListener('touchend', this._onHueMouseUp);
    window.addEventListener('mousemove', this._onHueMouseMove);
    window.addEventListener('touchmove', this._onHueMouseMove);
    e.preventDefault();
  };
  SimpleColorPicker.prototype._onHueMouseMove = function (e) {
    var hOffset = this.$hue.getBoundingClientRect();
    var yPos = getMousePosition(e).y;
    this._moveHueTo(yPos - hOffset.top);
    this._updateHueFromPosition();
  };
  SimpleColorPicker.prototype._onHueMouseUp = function () {
    window.removeEventListener('mouseup', this._onHueMouseUp);
    window.removeEventListener('touchend', this._onHueMouseUp);
    window.removeEventListener('mousemove', this._onHueMouseMove);
    window.removeEventListener('touchmove', this._onHueMouseMove);
  };

  /* =============================================================================
    Helper functions
  ============================================================================= */
  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }
  function getMousePosition(e) {
    e = e.type.indexOf('touch') === 0 ? e.touches[0] : e;
    return {
      x: e.clientX,
      y: e.clientY
    };
  }
  function numberToHex(color) {
    return color = '#' + ('00000' + (color | 0).toString(16)).substr(-6);
  }
  if ( true && module.exports) {
    module.exports = SimpleColorPicker;
  }
})();

/***/ }),

/***/ 27154:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
var SLOT = __webpack_require__(74915);
var $SyntaxError = SyntaxError;
var $StopIteration = (typeof StopIteration === "undefined" ? "undefined" : _typeof(StopIteration)) === 'object' ? StopIteration : null;
module.exports = function getStopIterationIterator(origIterator) {
  if (!$StopIteration) {
    throw new $SyntaxError('this environment lacks StopIteration');
  }
  SLOT.set(origIterator, '[[Done]]', false);
  var siIterator = {
    next: function next() {
      var iterator = SLOT.get(this, '[[Iterator]]');
      var done = SLOT.get(iterator, '[[Done]]');
      try {
        return {
          done: done,
          value: done ? void undefined : iterator.next()
        };
      } catch (e) {
        SLOT.set(iterator, '[[Done]]', true);
        if (e !== $StopIteration) {
          throw e;
        }
        return {
          done: true,
          value: void undefined
        };
      }
    }
  };
  SLOT.set(siIterator, '[[Iterator]]', origIterator);
  return siIterator;
};

/***/ }),

/***/ 56153:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
__webpack_require__(47941);
__webpack_require__(82526);
__webpack_require__(57327);
__webpack_require__(38880);
__webpack_require__(54747);
__webpack_require__(49337);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(23123);
__webpack_require__(73210);
__webpack_require__(41539);
__webpack_require__(39714);
__webpack_require__(69600);
__webpack_require__(26699);
__webpack_require__(43371);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(47042);
__webpack_require__(68309);
__webpack_require__(91038);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
(function (global, factory) {
  ( false ? 0 : _typeof(exports)) === 'object' && "object" !== 'undefined' ? factory(exports) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : (0);
})(this, function (exports) {
  'use strict';

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys(source, true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(source).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }

  /*
   B2	Break Opportunity Before and After	Em dash	Provide a line break opportunity before and after the character
   BA	Break After	Spaces, hyphens	Generally provide a line break opportunity after the character
   BB	Break Before	Punctuation used in dictionaries	Generally provide a line break opportunity before the character
   HY	Hyphen	HYPHEN-MINUS	Provide a line break opportunity after the character, except in numeric context
   CB	Contingent Break Opportunity	Inline objects	Provide a line break opportunity contingent on additional information
   */
  // B2 Break Opportunity Before and After - http://www.unicode.org/reports/tr14/#B2
  var B2 = ["\u2014"];
  var SHY = [
  // Soft hyphen
  "\xAD"]; // BA: Break After (remove on break) - http://www.unicode.org/reports/tr14/#BA

  var BAI = [
  // Spaces
  " ", "\u1680", "\u2000", "\u2001", "\u2002", "\u2003", "\u2004", "\u2005", "\u2006", "\u2008", "\u2009", "\u200A", "\u205F", "\u3000",
  // Tab
  "\t",
  // ZW Zero Width Space - http://www.unicode.org/reports/tr14/#ZW
  "\u200B",
  // Mandatory breaks not interpreted by html
  "\u2028", "\u2029"];
  var BA = [
  // Hyphen
  "\u058A", "\u2010", "\u2012", "\u2013",
  // Visible Word Dividers
  "\u05BE", "\u0F0B", "\u1361", "\u17D8", "\u17DA", "\u2027", "|",
  // Historic Word Separators
  "\u16EB", "\u16EC", "\u16ED", "\u2056", "\u2058", "\u2059", "\u205A", "\u205B", "\u205D", "\u205E", "\u2E19", "\u2E2A", "\u2E2B", "\u2E2C", "\u2E2D", "\u2E30", "\u10100", "\u10101", "\u10102", "\u1039F", "\u103D0", "\u1091F", "\u12470"]; // BB: Break Before - http://www.unicode.org/reports/tr14/#BB

  var BB = ["\xB4", "\u1FFD"]; // BK: Mandatory Break (A) (Non-tailorable) - http://www.unicode.org/reports/tr14/#BK

  var BK = ["\n"];
  /* eslint-env es6, browser */

  var DEFAULTS = {
    'font-size': '16px',
    'font-weight': '400',
    'font-family': 'Helvetica, Arial, sans-serif'
  };
  /**
   * We only support rem/em/pt conversion
   * @param val
   * @param options
   * @return {*}
   */

  function pxValue(val, options) {
    if (!options) {
      options = {};
    }
    var baseFontSize = parseInt(prop(options, 'base-font-size', 16), 10);
    var value = parseFloat(val);
    var unit = val.replace(value, ''); // eslint-disable-next-line default-case

    switch (unit) {
      case 'rem':
      case 'em':
        return value * baseFontSize;
      case 'pt':
        return value / (96 / 72);
      case 'px':
        return value;
    }
    throw new Error('The unit ' + unit + ' is not supported');
  }
  /**
   * Get computed word- and letter spacing for text
   * @param ws
   * @param ls
   * @return {function(*)}
   */

  function addWordAndLetterSpacing(ws, ls) {
    var blacklist = ['inherit', 'initial', 'unset', 'normal'];
    var wordAddon = 0;
    if (ws && blacklist.indexOf(ws) === -1) {
      wordAddon = pxValue(ws);
    }
    var letterAddon = 0;
    if (ls && blacklist.indexOf(ls) === -1) {
      letterAddon = pxValue(ls);
    }
    return function (text) {
      var words = text.trim().replace(/\s+/gi, ' ').split(' ').length - 1;
      var chars = text.length;
      return words * wordAddon + chars * letterAddon;
    };
  }
  /**
   * Map css styles to canvas font property
   *
   * font: font-style font-variant font-weight font-size/line-height font-family;
   * http://www.w3schools.com/tags/canvas_font.asp
   *
   * @param {CSSStyleDeclaration} style
   * @param {object} options
   * @returns {string}
   */

  function getFont(style, options) {
    var font = [];
    var fontWeight = prop(options, 'font-weight', style.getPropertyValue('font-weight')) || DEFAULTS['font-weight'];
    if (['normal', 'bold', 'bolder', 'lighter', '100', '200', '300', '400', '500', '600', '700', '800', '900'].indexOf(fontWeight.toString()) !== -1) {
      font.push(fontWeight);
    }
    var fontStyle = prop(options, 'font-style', style.getPropertyValue('font-style'));
    if (['normal', 'italic', 'oblique'].indexOf(fontStyle) !== -1) {
      font.push(fontStyle);
    }
    var fontVariant = prop(options, 'font-variant', style.getPropertyValue('font-variant'));
    if (['normal', 'small-caps'].indexOf(fontVariant) !== -1) {
      font.push(fontVariant);
    }
    var fontSize = prop(options, 'font-size', style.getPropertyValue('font-size')) || DEFAULTS['font-size'];
    var fontSizeValue = pxValue(fontSize);
    font.push(fontSizeValue + 'px');
    var fontFamily = prop(options, 'font-family', style.getPropertyValue('font-family')) || DEFAULTS['font-family'];
    font.push(fontFamily);
    return font.join(' ');
  }
  /**
   * Check for CSSStyleDeclaration
   *
   * @param val
   * @returns {bool}
   */

  function isCSSStyleDeclaration(val) {
    return val && typeof val.getPropertyValue === 'function';
  }
  /**
   * Check wether we can get computed style
   *
   * @param el
   * @returns {bool}
   */

  function canGetComputedStyle(el) {
    return isElement(el) && el.style && typeof window !== 'undefined' && typeof window.getComputedStyle === 'function';
  }
  /**
   * Check for DOM element
   *
   * @param el
   * @retutns {bool}
   */

  function isElement(el) {
    return (typeof HTMLElement === "undefined" ? "undefined" : _typeof(HTMLElement)) === 'object' ? el instanceof HTMLElement : Boolean(el && _typeof(el) === 'object' && el !== null && el.nodeType === 1 && typeof el.nodeName === 'string');
  }
  /**
   * Check if argument is object
   * @param obj
   * @returns {boolean}
   */

  function isObject(obj) {
    return _typeof(obj) === 'object' && obj !== null && !Array.isArray(obj);
  }
  /**
   * Get style declaration if available
   *
   * @returns {CSSStyleDeclaration}
   */

  function getStyle(el, options) {
    var opts = _objectSpread2({}, options || {});
    var style = opts.style;
    if (!options) {
      options = {};
    }
    if (isCSSStyleDeclaration(style)) {
      return style;
    }
    if (canGetComputedStyle(el)) {
      return window.getComputedStyle(el, prop(options, 'pseudoElt', null));
    }
    return {
      getPropertyValue: function getPropertyValue(key) {
        return prop(options, key);
      }
    };
  }
  /**
   * Get styled text
   *
   * @param {string} text
   * @param {CSSStyleDeclaration} style
   * @returns {string}
   */

  function getStyledText(text, style) {
    switch (style.getPropertyValue('text-transform')) {
      case 'uppercase':
        return text.toUpperCase();
      case 'lowercase':
        return text.toLowerCase();
      default:
        return text;
    }
  }
  /**
   * Trim text and repace some breaking htmlentities for convenience
   * Point user to https://mths.be/he for real htmlentity decode
   * @param text
   * @returns {string}
   */

  function prepareText(text) {
    // Convert to unicode
    text = (text || '').replace(/<wbr>/gi, "\u200B").replace(/<br\s*\/?>/gi, "\n").replace(/&shy;/gi, "\xAD").replace(/&mdash;/gi, "\u2014");
    if (/&#(\d+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+);/g.test(text) && console) {
      console.error('text-metrics: Found encoded htmlenties. You may want to use https://mths.be/he to decode your text first.');
    }
    return text.trim();
  }
  /**
   * Get textcontent from element
   * Try innerText first
   * @param el
   */

  function getText(el) {
    if (!el) {
      return '';
    }
    var text = el.innerText || el.textContent || '';
    return text.trim();
  }
  /**
   * Get property from src
   *
   * @param src
   * @param attr
   * @param defaultValue
   * @returns {*}
   */

  function prop(src, attr, defaultValue) {
    return src && typeof src[attr] !== 'undefined' && src[attr] || defaultValue;
  }
  /**
   * Normalize options
   *
   * @param options
   * @returns {*}
   */

  function normalizeOptions(options) {
    var opts = {}; // Normalize keys (fontSize => font-size)

    Object.keys(options || {}).forEach(function (key) {
      var dashedKey = key.replace(/([A-Z])/g, function ($1) {
        return '-' + $1.toLowerCase();
      });
      opts[dashedKey] = options[key];
    });
    return opts;
  }
  /**
   * Get Canvas
   * @param font
   * @throws {Error}
   * @return {Context2d}
   */

  function getContext2d(font) {
    try {
      var ctx = document.createElement('canvas').getContext('2d');
      var dpr = window.devicePixelRatio || 1;
      var bsr = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
      ctx.font = font;
      ctx.setTransform(dpr / bsr, 0, 0, dpr / bsr, 0, 0);
      return ctx;
    } catch (error) {
      throw new Error('Canvas support required');
    }
  }
  /**
   * Check breaking character
   * http://www.unicode.org/reports/tr14/#Table1
   *
   * @param chr
   */

  function checkBreak(chr) {
    return B2.includes(chr) && 'B2' || BAI.includes(chr) && 'BAI' || SHY.includes(chr) && 'SHY' || BA.includes(chr) && 'BA' || BB.includes(chr) && 'BB' || BK.includes(chr) && 'BK';
  }
  function computeLinesDefault(_ref) {
    var ctx = _ref.ctx,
      text = _ref.text,
      max = _ref.max,
      wordSpacing = _ref.wordSpacing,
      letterSpacing = _ref.letterSpacing;
    var addSpacing = addWordAndLetterSpacing(wordSpacing, letterSpacing);
    var lines = [];
    var parts = [];
    var breakpoints = [];
    var line = '';
    var part = '';
    if (!text) {
      return [];
    } // Compute array of breakpoints
    var _iterator = _createForOfIteratorHelper(text),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _chr = _step.value;
        var type = checkBreak(_chr);
        if (part === '' && type === 'BAI') {
          continue;
        }
        if (type) {
          breakpoints.push({
            chr: _chr,
            type: type
          });
          parts.push(part);
          part = '';
        } else {
          part += _chr;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (part) {
      parts.push(part);
    } // Loop over text parts and compute the lines

    for (var i = 0; i < parts.length; i++) {
      if (i === 0) {
        line = parts[i];
        continue;
      }
      var _part = parts[i];
      if (BAI.includes(parts[i - 1]) && BAI.includes(parts[i])) {
        continue;
      }
      var breakpoint = breakpoints[i - 1]; // Special treatment as we only render the soft hyphen if we need to split

      var chr = breakpoint.type === 'SHY' ? '' : breakpoint.chr;
      if (breakpoint.type === 'BK') {
        lines.push(line);
        line = _part;
        continue;
      } // Measure width

      var rawWidth = ctx.measureText(line + chr + _part).width + addSpacing(line + chr + _part);
      var width = Math.round(rawWidth, 10); // Still fits in line

      if (width <= max) {
        line += chr + _part;
        continue;
      } // Line is to long, we split at the breakpoint

      switch (breakpoint.type) {
        case 'SHY':
          lines.push(line + '-');
          line = _part;
          break;
        case 'BA':
          lines.push(line + chr);
          line = _part;
          break;
        case 'BAI':
          lines.push(line);
          line = _part;
          break;
        case 'BB':
          lines.push(line);
          line = chr + _part;
          break;
        case 'B2':
          if (parseInt(ctx.measureText(line + chr).width + addSpacing(line + chr), 10) <= max) {
            lines.push(line + chr);
            line = _part;
          } else if (parseInt(ctx.measureText(chr + _part).width + addSpacing(chr + _part), 10) <= max) {
            lines.push(line);
            line = chr + _part;
          } else {
            lines.push(line);
            lines.push(chr);
            line = _part;
          }
          break;
        default:
          throw new Error('Undefoined break');
      }
    }
    if (_toConsumableArray(line).length !== 0) {
      lines.push(line);
    }
    return lines;
  }
  function computeLinesBreakAll(_ref2) {
    var ctx = _ref2.ctx,
      text = _ref2.text,
      max = _ref2.max,
      wordSpacing = _ref2.wordSpacing,
      letterSpacing = _ref2.letterSpacing;
    var addSpacing = addWordAndLetterSpacing(wordSpacing, letterSpacing);
    var lines = [];
    var line = '';
    var index = 0;
    if (!text) {
      return [];
    }
    var _iterator2 = _createForOfIteratorHelper(text),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var chr = _step2.value;
        var type = checkBreak(chr); // Mandatory break found (br's converted to \u000A and innerText keeps br's as \u000A

        if (type === 'BK') {
          lines.push(line);
          line = '';
          continue;
        }
        var lineLength = line.length;
        if (BAI.includes(chr) && (lineLength === 0 || BAI.includes(line[lineLength - 1]))) {
          continue;
        } // Measure width

        var rawWidth = ctx.measureText(line + chr).width + addSpacing(line + chr);
        var width = Math.ceil(rawWidth); // Check if we can put char behind the shy

        if (type === 'SHY') {
          var next = text[index + 1] || '';
          rawWidth = ctx.measureText(line + chr + next).width + addSpacing(line + chr + next);
          width = Math.ceil(rawWidth);
        } // Needs at least one character

        if (width > max && _toConsumableArray(line).length !== 0) {
          switch (type) {
            case 'SHY':
              lines.push(line + '-');
              line = '';
              break;
            case 'BA':
              lines.push(line + chr);
              line = '';
              break;
            case 'BAI':
              lines.push(line);
              line = '';
              break;
            default:
              lines.push(line);
              line = chr;
              break;
          }
        } else if (chr !== "\xAD") {
          line += chr;
        }
        index++;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    if (_toConsumableArray(line).length !== 0) {
      lines.push(line);
    }
    return lines;
  }
  var _ = /*#__PURE__*/Object.freeze({
    addWordAndLetterSpacing: addWordAndLetterSpacing,
    getFont: getFont,
    isCSSStyleDeclaration: isCSSStyleDeclaration,
    canGetComputedStyle: canGetComputedStyle,
    isElement: isElement,
    isObject: isObject,
    getStyle: getStyle,
    getStyledText: getStyledText,
    prepareText: prepareText,
    getText: getText,
    prop: prop,
    normalizeOptions: normalizeOptions,
    getContext2d: getContext2d,
    computeLinesDefault: computeLinesDefault,
    computeLinesBreakAll: computeLinesBreakAll
  });
  var TextMetrics = /*#__PURE__*/function () {
    function TextMetrics(el) {
      var overwrites = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _classCallCheck(this, TextMetrics);
      if (!isElement(el) && isObject(el)) {
        this.el = undefined;
        this.overwrites = normalizeOptions(el);
      } else {
        this.el = el;
        this.overwrites = normalizeOptions(overwrites);
      }
      this.style = getStyle(this.el, this.overwrites);
      this.font = prop(overwrites, 'font', null) || getFont(this.style, this.overwrites);
    }
    _createClass(TextMetrics, [{
      key: "padding",
      value: function padding() {
        return this.el ? parseInt(this.style.paddingLeft || 0, 10) + parseInt(this.style.paddingRight || 0, 10) : 0;
      }
      /**
       * Compute Text Metrics based for given text
       *
       * @param {string} text
       * @param {object} options
       * @param {object} overwrites
       * @returns {function}
       */
    }, {
      key: "width",
      value: function width(text) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var overwrites = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (_typeof(text) === 'object' && text) {
          overwrites = options;
          options = text || {};
          text = undefined;
        }
        if (!text && this.el) {
          text = this.el.textContent.trim();
        } else {
          text = prepareText(text);
        }
        if (!text) {
          return 0;
        }
        var styledText = getStyledText(text, this.style);
        var styles = _objectSpread2({}, this.overwrites, {}, normalizeOptions(overwrites));
        var font = getFont(this.style, styles);
        var letterSpacing = prop(styles, 'letter-spacing') || this.style.getPropertyValue('letter-spacing');
        var wordSpacing = prop(styles, 'word-spacing') || this.style.getPropertyValue('word-spacing');
        var addSpacing = addWordAndLetterSpacing(wordSpacing, letterSpacing);
        var ctx = getContext2d(font);
        if (options.multiline) {
          return this.lines(styledText, options, overwrites).reduce(function (res, text) {
            var w = ctx.measureText(text).width + addSpacing(text);
            return Math.max(res, w);
          }, 0);
        }
        return ctx.measureText(styledText).width + addSpacing(styledText);
      }
      /**
       * Compute height from textbox
       *
       * @param {string} text
       * @param {object} options
       * @param {object} overwrites
       * @returns {number}
       */
    }, {
      key: "height",
      value: function height(text, options, overwrites) {
        if (_typeof(text) === 'object' && text) {
          overwrites = options;
          options = text || {};
          text = undefined;
        }
        if (!options) {
          options = {};
        }
        if (!overwrites) {
          options = {};
        }
        if (!text && this.el) {
          text = getText(this.el);
        } else {
          text = prepareText(text);
        }
        var styles = _objectSpread2({}, this.overwrites, {}, normalizeOptions(overwrites));
        var lineHeight = parseFloat(prop(styles, 'line-height') || this.style.getPropertyValue('line-height'));
        return Math.ceil(this.lines(text, options, styles).length * lineHeight || 0);
      }
      /**
       * Compute lines of text with automatic word wraparound
       * element styles
       *
       * @param {string} text
       * @param {object} options
       * @param {object} overwrites
       * @returns {*}
       */
    }, {
      key: "lines",
      value: function lines(text, options, overwrites) {
        if (_typeof(text) === 'object' && text) {
          overwrites = options;
          options = text;
          text = undefined;
        }
        if (typeof overwrites === 'undefined') {
          overwrites = options;
        }
        if (!options) {
          options = {};
        }
        if (!overwrites) {
          options = {};
        }
        if (!text && this.el) {
          text = getText(this.el);
        } else {
          text = prepareText(text);
        }
        var styles = _objectSpread2({}, this.overwrites, {}, normalizeOptions(overwrites));
        var font = getFont(this.style, styles); // Get max width

        var max = parseInt(prop(options, 'width') || prop(overwrites, 'width'), 10) || prop(this.el, 'offsetWidth', 0) || parseInt(prop(styles, 'width', 0), 10) || parseInt(this.style.width, 10);
        max -= this.padding();
        var wordBreak = prop(styles, 'word-break') || this.style.getPropertyValue('word-break');
        var letterSpacing = prop(styles, 'letter-spacing') || this.style.getPropertyValue('letter-spacing');
        var wordSpacing = prop(styles, 'word-spacing') || this.style.getPropertyValue('word-spacing');
        var ctx = getContext2d(font);
        text = getStyledText(text, this.style); // Different scenario when break-word is allowed

        if (wordBreak === 'break-all') {
          return computeLinesBreakAll({
            ctx: ctx,
            text: text,
            max: max,
            wordSpacing: wordSpacing,
            letterSpacing: letterSpacing
          });
        }
        return computeLinesDefault({
          ctx: ctx,
          text: text,
          max: max,
          wordSpacing: wordSpacing,
          letterSpacing: letterSpacing
        });
      }
      /**
       * Compute Text Metrics based for given text
       *
       * @param {string} text
       * @param {object} options
       * @param {object} overwrites
       * @returns {string} Pixelvalue e.g. 14px
       */
    }, {
      key: "maxFontSize",
      value: function maxFontSize(text, options, overwrites) {
        var _this = this;
        if (_typeof(text) === 'object' && text) {
          overwrites = options;
          options = text;
          text = undefined;
        }
        if (typeof overwrites === 'undefined') {
          overwrites = options;
        }
        if (!options) {
          options = {};
        }
        if (!overwrites) {
          options = {};
        }
        if (!text && this.el) {
          text = getText(this.el);
        } else {
          text = prepareText(text);
        }
        var styles = _objectSpread2({}, this.overwrites, {}, normalizeOptions(overwrites)); // Simple compute function which adds the size and computes the with

        var compute = function compute(size) {
          return Math.ceil(_this.width(text, options, _objectSpread2({}, styles, {
            'font-size': size + 'px'
          })));
        }; // Get max width

        var max = parseInt(prop(options, 'width') || prop(overwrites, 'width'), 10) || prop(this.el, 'offsetWidth', 0) || parseInt(prop(styles, 'width', 0), 10) || parseInt(this.style.width, 10);
        max -= this.padding(); // Start with half the max size

        var size = Math.floor(max / 2);
        var cur = compute(size); // Compute next result based on first result

        size = Math.floor(size / cur * max);
        cur = compute(size); // Happy cause we got it already

        if (Math.ceil(cur) === max) {
          return size ? size + 'px' : undefined;
        } // Go on by increase/decrease pixels

        var greater = cur > max && size > 0;
        while (cur > max && size > 0) {
          size -= 1;
          cur = compute(size);
        }
        if (!greater) {
          while (cur < max) {
            cur = compute(size + 1);
            if (cur > max) {
              return size ? size + 'px' : undefined;
            }
            size += 1;
          }
        }
        return size ? size + 'px' : undefined;
      }
    }]);
    return TextMetrics;
  }();
  var init = function init(el, overwrites) {
    return new TextMetrics(el, overwrites);
  };
  var utils = _objectSpread2({}, _);
  exports.init = init;
  exports.utils = utils;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});

/***/ }),

/***/ 60119:
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(41539);
__webpack_require__(39714);
__webpack_require__(92222);
__webpack_require__(47042);
__webpack_require__(69600);
__webpack_require__(24603);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
// TinyColor v1.4.2
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

(function (Math) {
  var trimLeft = /^\s+/,
    trimRight = /\s+$/,
    tinyCounter = 0,
    mathRound = Math.round,
    mathMin = Math.min,
    mathMax = Math.max,
    mathRandom = Math.random;
  function tinycolor(color, opts) {
    color = color ? color : '';
    opts = opts || {};

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
      return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
      return new tinycolor(color, opts);
    }
    var rgb = inputToRGB(color);
    this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = mathRound(100 * this._a) / 100, this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) {
      this._r = mathRound(this._r);
    }
    if (this._g < 1) {
      this._g = mathRound(this._g);
    }
    if (this._b < 1) {
      this._b = mathRound(this._b);
    }
    this._ok = rgb.ok;
    this._tc_id = tinyCounter++;
  }
  tinycolor.prototype = {
    isDark: function isDark() {
      return this.getBrightness() < 128;
    },
    isLight: function isLight() {
      return !this.isDark();
    },
    isValid: function isValid() {
      return this._ok;
    },
    getOriginalInput: function getOriginalInput() {
      return this._originalInput;
    },
    getFormat: function getFormat() {
      return this._format;
    },
    getAlpha: function getAlpha() {
      return this._a;
    },
    getBrightness: function getBrightness() {
      //http://www.w3.org/TR/AERT#color-contrast
      var rgb = this.toRgb();
      return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function getLuminance() {
      //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
      var rgb = this.toRgb();
      var RsRGB, GsRGB, BsRGB, R, G, B;
      RsRGB = rgb.r / 255;
      GsRGB = rgb.g / 255;
      BsRGB = rgb.b / 255;
      if (RsRGB <= 0.03928) {
        R = RsRGB / 12.92;
      } else {
        R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
      }
      if (GsRGB <= 0.03928) {
        G = GsRGB / 12.92;
      } else {
        G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
      }
      if (BsRGB <= 0.03928) {
        B = BsRGB / 12.92;
      } else {
        B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
      }
      return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    },
    setAlpha: function setAlpha(value) {
      this._a = boundAlpha(value);
      this._roundA = mathRound(100 * this._a) / 100;
      return this;
    },
    toHsv: function toHsv() {
      var hsv = rgbToHsv(this._r, this._g, this._b);
      return {
        h: hsv.h * 360,
        s: hsv.s,
        v: hsv.v,
        a: this._a
      };
    },
    toHsvString: function toHsvString() {
      var hsv = rgbToHsv(this._r, this._g, this._b);
      var h = mathRound(hsv.h * 360),
        s = mathRound(hsv.s * 100),
        v = mathRound(hsv.v * 100);
      return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
    },
    toHsl: function toHsl() {
      var hsl = rgbToHsl(this._r, this._g, this._b);
      return {
        h: hsl.h * 360,
        s: hsl.s,
        l: hsl.l,
        a: this._a
      };
    },
    toHslString: function toHslString() {
      var hsl = rgbToHsl(this._r, this._g, this._b);
      var h = mathRound(hsl.h * 360),
        s = mathRound(hsl.s * 100),
        l = mathRound(hsl.l * 100);
      return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
    },
    toHex: function toHex(allow3Char) {
      return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function toHexString(allow3Char) {
      return '#' + this.toHex(allow3Char);
    },
    toHex8: function toHex8(allow4Char) {
      return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function toHex8String(allow4Char) {
      return '#' + this.toHex8(allow4Char);
    },
    toRgb: function toRgb() {
      return {
        r: mathRound(this._r),
        g: mathRound(this._g),
        b: mathRound(this._b),
        a: this._a
      };
    },
    toRgbString: function toRgbString() {
      return this._a == 1 ? "rgb(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" : "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function toPercentageRgb() {
      return {
        r: mathRound(bound01(this._r, 255) * 100) + "%",
        g: mathRound(bound01(this._g, 255) * 100) + "%",
        b: mathRound(bound01(this._b, 255) * 100) + "%",
        a: this._a
      };
    },
    toPercentageRgbString: function toPercentageRgbString() {
      return this._a == 1 ? "rgb(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" : "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function toName() {
      if (this._a === 0) {
        return "transparent";
      }
      if (this._a < 1) {
        return false;
      }
      return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function toFilter(secondColor) {
      var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
      var secondHex8String = hex8String;
      var gradientType = this._gradientType ? "GradientType = 1, " : "";
      if (secondColor) {
        var s = tinycolor(secondColor);
        secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
      }
      return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
    },
    toString: function toString(format) {
      var formatSet = !!format;
      format = format || this._format;
      var formattedString = false;
      var hasAlpha = this._a < 1 && this._a >= 0;
      var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
      if (needsAlphaFormat) {
        // Special case for "transparent", all other non-alpha formats
        // will return rgba when there is transparency.
        if (format === "name" && this._a === 0) {
          return this.toName();
        }
        return this.toRgbString();
      }
      if (format === "rgb") {
        formattedString = this.toRgbString();
      }
      if (format === "prgb") {
        formattedString = this.toPercentageRgbString();
      }
      if (format === "hex" || format === "hex6") {
        formattedString = this.toHexString();
      }
      if (format === "hex3") {
        formattedString = this.toHexString(true);
      }
      if (format === "hex4") {
        formattedString = this.toHex8String(true);
      }
      if (format === "hex8") {
        formattedString = this.toHex8String();
      }
      if (format === "name") {
        formattedString = this.toName();
      }
      if (format === "hsl") {
        formattedString = this.toHslString();
      }
      if (format === "hsv") {
        formattedString = this.toHsvString();
      }
      return formattedString || this.toHexString();
    },
    clone: function clone() {
      return tinycolor(this.toString());
    },
    _applyModification: function _applyModification(fn, args) {
      var color = fn.apply(null, [this].concat([].slice.call(args)));
      this._r = color._r;
      this._g = color._g;
      this._b = color._b;
      this.setAlpha(color._a);
      return this;
    },
    lighten: function lighten() {
      return this._applyModification(_lighten, arguments);
    },
    brighten: function brighten() {
      return this._applyModification(_brighten, arguments);
    },
    darken: function darken() {
      return this._applyModification(_darken, arguments);
    },
    desaturate: function desaturate() {
      return this._applyModification(_desaturate, arguments);
    },
    saturate: function saturate() {
      return this._applyModification(_saturate, arguments);
    },
    greyscale: function greyscale() {
      return this._applyModification(_greyscale, arguments);
    },
    spin: function spin() {
      return this._applyModification(_spin, arguments);
    },
    _applyCombination: function _applyCombination(fn, args) {
      return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function analogous() {
      return this._applyCombination(_analogous, arguments);
    },
    complement: function complement() {
      return this._applyCombination(_complement, arguments);
    },
    monochromatic: function monochromatic() {
      return this._applyCombination(_monochromatic, arguments);
    },
    splitcomplement: function splitcomplement() {
      return this._applyCombination(_splitcomplement, arguments);
    },
    triad: function triad() {
      return this._applyCombination(_triad, arguments);
    },
    tetrad: function tetrad() {
      return this._applyCombination(_tetrad, arguments);
    }
  };

  // If input is an object, force 1 into "1.0" to handle ratios properly
  // String input requires "1.0" as input, so 1 will be treated as 1
  tinycolor.fromRatio = function (color, opts) {
    if (_typeof(color) == "object") {
      var newColor = {};
      for (var i in color) {
        if (color.hasOwnProperty(i)) {
          if (i === "a") {
            newColor[i] = color[i];
          } else {
            newColor[i] = convertToPercentage(color[i]);
          }
        }
      }
      color = newColor;
    }
    return tinycolor(color, opts);
  };

  // Given a string or object, convert that input to RGB
  // Possible string inputs:
  //
  //     "red"
  //     "#f00" or "f00"
  //     "#ff0000" or "ff0000"
  //     "#ff000000" or "ff000000"
  //     "rgb 255 0 0" or "rgb (255, 0, 0)"
  //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
  //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
  //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
  //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
  //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
  //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
  //
  function inputToRGB(color) {
    var rgb = {
      r: 0,
      g: 0,
      b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color == "string") {
      color = stringInputToObject(color);
    }
    if (_typeof(color) == "object") {
      if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
        rgb = rgbToRgb(color.r, color.g, color.b);
        ok = true;
        format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
        s = convertToPercentage(color.s);
        v = convertToPercentage(color.v);
        rgb = hsvToRgb(color.h, s, v);
        ok = true;
        format = "hsv";
      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
        s = convertToPercentage(color.s);
        l = convertToPercentage(color.l);
        rgb = hslToRgb(color.h, s, l);
        ok = true;
        format = "hsl";
      }
      if (color.hasOwnProperty("a")) {
        a = color.a;
      }
    }
    a = boundAlpha(a);
    return {
      ok: ok,
      format: color.format || format,
      r: mathMin(255, mathMax(rgb.r, 0)),
      g: mathMin(255, mathMax(rgb.g, 0)),
      b: mathMin(255, mathMax(rgb.b, 0)),
      a: a
    };
  }

  // Conversion Functions
  // --------------------

  // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
  // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

  // `rgbToRgb`
  // Handle bounds / percentage checking to conform to CSS color spec
  // <http://www.w3.org/TR/css3-color/>
  // *Assumes:* r, g, b in [0, 255] or [0, 1]
  // *Returns:* { r, g, b } in [0, 255]
  function rgbToRgb(r, g, b) {
    return {
      r: bound01(r, 255) * 255,
      g: bound01(g, 255) * 255,
      b: bound01(b, 255) * 255
    };
  }

  // `rgbToHsl`
  // Converts an RGB color value to HSL.
  // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
  // *Returns:* { h, s, l } in [0,1]
  function rgbToHsl(r, g, b) {
    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);
    var max = mathMax(r, g, b),
      min = mathMin(r, g, b);
    var h,
      s,
      l = (max + min) / 2;
    if (max == min) {
      h = s = 0; // achromatic
    } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }
    return {
      h: h,
      s: s,
      l: l
    };
  }

  // `hslToRgb`
  // Converts an HSL color value to RGB.
  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
  // *Returns:* { r, g, b } in the set [0, 255]
  function hslToRgb(h, s, l) {
    var r, g, b;
    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);
    function hue2rgb(p, q, t) {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    }
    if (s === 0) {
      r = g = b = l; // achromatic
    } else {
      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;
      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }
    return {
      r: r * 255,
      g: g * 255,
      b: b * 255
    };
  }

  // `rgbToHsv`
  // Converts an RGB color value to HSV
  // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
  // *Returns:* { h, s, v } in [0,1]
  function rgbToHsv(r, g, b) {
    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);
    var max = mathMax(r, g, b),
      min = mathMin(r, g, b);
    var h,
      s,
      v = max;
    var d = max - min;
    s = max === 0 ? 0 : d / max;
    if (max == min) {
      h = 0; // achromatic
    } else {
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }
    return {
      h: h,
      s: s,
      v: v
    };
  }

  // `hsvToRgb`
  // Converts an HSV color value to RGB.
  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
  // *Returns:* { r, g, b } in the set [0, 255]
  function hsvToRgb(h, s, v) {
    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);
    var i = Math.floor(h),
      f = h - i,
      p = v * (1 - s),
      q = v * (1 - f * s),
      t = v * (1 - (1 - f) * s),
      mod = i % 6,
      r = [v, q, p, p, t, v][mod],
      g = [t, v, v, q, p, p][mod],
      b = [p, p, t, v, v, q][mod];
    return {
      r: r * 255,
      g: g * 255,
      b: b * 255
    };
  }

  // `rgbToHex`
  // Converts an RGB color to hex
  // Assumes r, g, and b are contained in the set [0, 255]
  // Returns a 3 or 6 character hex
  function rgbToHex(r, g, b, allow3Char) {
    var hex = [pad2(mathRound(r).toString(16)), pad2(mathRound(g).toString(16)), pad2(mathRound(b).toString(16))];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }
    return hex.join("");
  }

  // `rgbaToHex`
  // Converts an RGBA color plus alpha transparency to hex
  // Assumes r, g, b are contained in the set [0, 255] and
  // a in [0, 1]. Returns a 4 or 8 character rgba hex
  function rgbaToHex(r, g, b, a, allow4Char) {
    var hex = [pad2(mathRound(r).toString(16)), pad2(mathRound(g).toString(16)), pad2(mathRound(b).toString(16)), pad2(convertDecimalToHex(a))];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }
    return hex.join("");
  }

  // `rgbaToArgbHex`
  // Converts an RGBA color to an ARGB Hex8 string
  // Rarely used, but required for "toFilter()"
  function rgbaToArgbHex(r, g, b, a) {
    var hex = [pad2(convertDecimalToHex(a)), pad2(mathRound(r).toString(16)), pad2(mathRound(g).toString(16)), pad2(mathRound(b).toString(16))];
    return hex.join("");
  }

  // `equals`
  // Can be called with any tinycolor input
  tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) {
      return false;
    }
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
  };
  tinycolor.random = function () {
    return tinycolor.fromRatio({
      r: mathRandom(),
      g: mathRandom(),
      b: mathRandom()
    });
  };

  // Modification Functions
  // ----------------------
  // Thanks to less.js for some of the basics here
  // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

  function _desaturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
  }
  function _saturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
  }
  function _greyscale(color) {
    return tinycolor(color).desaturate(100);
  }
  function _lighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
  }
  function _brighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var rgb = tinycolor(color).toRgb();
    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * -(amount / 100))));
    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * -(amount / 100))));
    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * -(amount / 100))));
    return tinycolor(rgb);
  }
  function _darken(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
  }

  // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
  // Values outside of this range will be wrapped into this range.
  function _spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
  }

  // Combination Functions
  // ---------------------
  // Thanks to jQuery xColor for some of the ideas behind these
  // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

  function _complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
  }
  function _triad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [tinycolor(color), tinycolor({
      h: (h + 120) % 360,
      s: hsl.s,
      l: hsl.l
    }), tinycolor({
      h: (h + 240) % 360,
      s: hsl.s,
      l: hsl.l
    })];
  }
  function _tetrad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [tinycolor(color), tinycolor({
      h: (h + 90) % 360,
      s: hsl.s,
      l: hsl.l
    }), tinycolor({
      h: (h + 180) % 360,
      s: hsl.s,
      l: hsl.l
    }), tinycolor({
      h: (h + 270) % 360,
      s: hsl.s,
      l: hsl.l
    })];
  }
  function _splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [tinycolor(color), tinycolor({
      h: (h + 72) % 360,
      s: hsl.s,
      l: hsl.l
    }), tinycolor({
      h: (h + 216) % 360,
      s: hsl.s,
      l: hsl.l
    })];
  }
  function _analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;
    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];
    for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;) {
      hsl.h = (hsl.h + part) % 360;
      ret.push(tinycolor(hsl));
    }
    return ret;
  }
  function _monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h,
      s = hsv.s,
      v = hsv.v;
    var ret = [];
    var modification = 1 / results;
    while (results--) {
      ret.push(tinycolor({
        h: h,
        s: s,
        v: v
      }));
      v = (v + modification) % 1;
    }
    return ret;
  }

  // Utility Functions
  // ---------------------

  tinycolor.mix = function (color1, color2, amount) {
    amount = amount === 0 ? 0 : amount || 50;
    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();
    var p = amount / 100;
    var rgba = {
      r: (rgb2.r - rgb1.r) * p + rgb1.r,
      g: (rgb2.g - rgb1.g) * p + rgb1.g,
      b: (rgb2.b - rgb1.b) * p + rgb1.b,
      a: (rgb2.a - rgb1.a) * p + rgb1.a
    };
    return tinycolor(rgba);
  };

  // Readability Functions
  // ---------------------
  // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

  // `contrast`
  // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
  tinycolor.readability = function (color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
  };

  // `isReadable`
  // Ensure that foreground and background color combinations meet WCAG2 guidelines.
  // The third argument is an optional Object.
  //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
  //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
  // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

  // *Example*
  //    tinycolor.isReadable("#000", "#111") => false
  //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
  tinycolor.isReadable = function (color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;
    out = false;
    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
      case "AAsmall":
      case "AAAlarge":
        out = readability >= 4.5;
        break;
      case "AAlarge":
        out = readability >= 3;
        break;
      case "AAAsmall":
        out = readability >= 7;
        break;
    }
    return out;
  };

  // `mostReadable`
  // Given a base color and a list of possible foreground or background
  // colors for that base, returns the most readable color.
  // Optionally returns Black or White if the most readable color is unreadable.
  // *Example*
  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
  tinycolor.mostReadable = function (baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors;
    level = args.level;
    size = args.size;
    for (var i = 0; i < colorList.length; i++) {
      readability = tinycolor.readability(baseColor, colorList[i]);
      if (readability > bestScore) {
        bestScore = readability;
        bestColor = tinycolor(colorList[i]);
      }
    }
    if (tinycolor.isReadable(baseColor, bestColor, {
      "level": level,
      "size": size
    }) || !includeFallbackColors) {
      return bestColor;
    } else {
      args.includeFallbackColors = false;
      return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
    }
  };

  // Big List of Colors
  // ------------------
  // <http://www.w3.org/TR/css3-color/#svg-color>
  var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
  };

  // Make it easy to access colors via `hexNames[hex]`
  var hexNames = tinycolor.hexNames = flip(names);

  // Utilities
  // ---------

  // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
  function flip(o) {
    var flipped = {};
    for (var i in o) {
      if (o.hasOwnProperty(i)) {
        flipped[o[i]] = i;
      }
    }
    return flipped;
  }

  // Return a valid alpha value [0,1] with all invalid values being set to 1
  function boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) {
      a = 1;
    }
    return a;
  }

  // Take input from [0, n] and return it as [0, 1]
  function bound01(n, max) {
    if (isOnePointZero(n)) {
      n = "100%";
    }
    var processPercent = isPercentage(n);
    n = mathMin(max, mathMax(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
      n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) {
      return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return n % max / parseFloat(max);
  }

  // Force a number between 0 and 1
  function clamp01(val) {
    return mathMin(1, mathMax(0, val));
  }

  // Parse a base-16 hex value into a base-10 integer
  function parseIntFromHex(val) {
    return parseInt(val, 16);
  }

  // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
  // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
  function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
  }

  // Check to see if string passed in is a percentage
  function isPercentage(n) {
    return typeof n === "string" && n.indexOf('%') != -1;
  }

  // Force a hex value to have 2 characters
  function pad2(c) {
    return c.length == 1 ? '0' + c : '' + c;
  }

  // Replace a decimal with it's percentage value
  function convertToPercentage(n) {
    if (n <= 1) {
      n = n * 100 + "%";
    }
    return n;
  }

  // Converts a decimal to a hex value
  function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
  }
  // Converts a hex value to a decimal
  function convertHexToDecimal(h) {
    return parseIntFromHex(h) / 255;
  }
  var matchers = function () {
    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    return {
      CSS_UNIT: new RegExp(CSS_UNIT),
      rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
      rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
      hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
      hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
      hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
      hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
      hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
      hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
  }();

  // `isValidCSSUnit`
  // Take in a single string / number and check to see if it looks like a CSS unit
  // (see `matchers` above for definition).
  function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
  }

  // `stringInputToObject`
  // Permissive string parsing.  Take in a number of formats, and output an object
  // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
  function stringInputToObject(color) {
    color = color.replace(trimLeft, '').replace(trimRight, '').toLowerCase();
    var named = false;
    if (names[color]) {
      color = names[color];
      named = true;
    } else if (color == 'transparent') {
      return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
      };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if (match = matchers.rgb.exec(color)) {
      return {
        r: match[1],
        g: match[2],
        b: match[3]
      };
    }
    if (match = matchers.rgba.exec(color)) {
      return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hsl.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        l: match[3]
      };
    }
    if (match = matchers.hsla.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hsv.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        v: match[3]
      };
    }
    if (match = matchers.hsva.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hex8.exec(color)) {
      return {
        r: parseIntFromHex(match[1]),
        g: parseIntFromHex(match[2]),
        b: parseIntFromHex(match[3]),
        a: convertHexToDecimal(match[4]),
        format: named ? "name" : "hex8"
      };
    }
    if (match = matchers.hex6.exec(color)) {
      return {
        r: parseIntFromHex(match[1]),
        g: parseIntFromHex(match[2]),
        b: parseIntFromHex(match[3]),
        format: named ? "name" : "hex"
      };
    }
    if (match = matchers.hex4.exec(color)) {
      return {
        r: parseIntFromHex(match[1] + '' + match[1]),
        g: parseIntFromHex(match[2] + '' + match[2]),
        b: parseIntFromHex(match[3] + '' + match[3]),
        a: convertHexToDecimal(match[4] + '' + match[4]),
        format: named ? "name" : "hex8"
      };
    }
    if (match = matchers.hex3.exec(color)) {
      return {
        r: parseIntFromHex(match[1] + '' + match[1]),
        g: parseIntFromHex(match[2] + '' + match[2]),
        b: parseIntFromHex(match[3] + '' + match[3]),
        format: named ? "name" : "hex"
      };
    }
    return false;
  }
  function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {
      "level": "AA",
      "size": "small"
    };
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
      level = "AA";
    }
    if (size !== "small" && size !== "large") {
      size = "small";
    }
    return {
      "level": level,
      "size": size
    };
  }

  // Node: Export function
  if ( true && module.exports) {
    module.exports = tinycolor;
  }
  // AMD/requirejs: Define the module
  else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return tinycolor;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Browser: Expose to window
  else {}
})(Math);

/***/ }),

/***/ 59875:
/***/ ((module, exports, __webpack_require__) => {

__webpack_require__(74916);
__webpack_require__(15306);
exports = module.exports = trim;
function trim(str) {
  return str.replace(/^\s*|\s*$/g, '');
}
exports.left = function (str) {
  return str.replace(/^\s*/, '');
};
exports.right = function (str) {
  return str.replace(/\s*$/, '');
};

/***/ }),

/***/ 2605:
/***/ ((module) => {

module.exports = /[\0-\x1F\x7F-\x9F]/;

/***/ }),

/***/ 20810:
/***/ ((module) => {

module.exports = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

/***/ }),

/***/ 67925:
/***/ ((module) => {

module.exports = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

/***/ }),

/***/ 35732:
/***/ ((module) => {

module.exports = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

/***/ }),

/***/ 19234:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


exports.Any = __webpack_require__(40146);
exports.Cc = __webpack_require__(2605);
exports.Cf = __webpack_require__(20810);
exports.P = __webpack_require__(67925);
exports.Z = __webpack_require__(35732);

/***/ }),

/***/ 40146:
/***/ ((module) => {

module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

/***/ }),

/***/ 13650:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;
/*!
 * content-type
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * RegExp to match *( ";" parameter ) in RFC 7231 sec 3.1.1.1
 *
 * parameter     = token "=" ( token / quoted-string )
 * token         = 1*tchar
 * tchar         = "!" / "#" / "$" / "%" / "&" / "'" / "*"
 *               / "+" / "-" / "." / "^" / "_" / "`" / "|" / "~"
 *               / DIGIT / ALPHA
 *               ; any VCHAR, except delimiters
 * quoted-string = DQUOTE *( qdtext / quoted-pair ) DQUOTE
 * qdtext        = HTAB / SP / %x21 / %x23-5B / %x5D-7E / obs-text
 * obs-text      = %x80-FF
 * quoted-pair   = "\" ( HTAB / SP / VCHAR / obs-text )
 */
__webpack_require__(2707);
__webpack_require__(47941);
__webpack_require__(73210);
__webpack_require__(47042);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
var PARAM_REGEXP = /; *([!#$%&'*+.^_`|~0-9A-Za-z-]+) *= *("(?:[\u000b\u0020\u0021\u0023-\u005b\u005d-\u007e\u0080-\u00ff]|\\[\u000b\u0020-\u00ff])*"|[!#$%&'*+.^_`|~0-9A-Za-z-]+) */g; // eslint-disable-line no-control-regex
var TEXT_REGEXP = /^[\u000b\u0020-\u007e\u0080-\u00ff]+$/; // eslint-disable-line no-control-regex
var TOKEN_REGEXP = /^[!#$%&'*+.^_`|~0-9A-Za-z-]+$/;

/**
 * RegExp to match quoted-pair in RFC 7230 sec 3.2.6
 *
 * quoted-pair = "\" ( HTAB / SP / VCHAR / obs-text )
 * obs-text    = %x80-FF
 */
var QESC_REGEXP = /\\([\u000b\u0020-\u00ff])/g; // eslint-disable-line no-control-regex

/**
 * RegExp to match chars that must be quoted-pair in RFC 7230 sec 3.2.6
 */
var QUOTE_REGEXP = /([\\"])/g;

/**
 * RegExp to match type in RFC 7231 sec 3.1.1.1
 *
 * media-type = type "/" subtype
 * type       = token
 * subtype    = token
 */
var TYPE_REGEXP = /^[!#$%&'*+.^_`|~0-9A-Za-z-]+\/[!#$%&'*+.^_`|~0-9A-Za-z-]+$/;

/**
 * Module exports.
 * @public
 */

__webpack_unused_export__ = format;
exports.Q = parse;

/**
 * Format object to media type.
 *
 * @param {object} obj
 * @return {string}
 * @public
 */

function format(obj) {
  if (!obj || _typeof(obj) !== 'object') {
    throw new TypeError('argument obj is required');
  }
  var parameters = obj.parameters;
  var type = obj.type;
  if (!type || !TYPE_REGEXP.test(type)) {
    throw new TypeError('invalid type');
  }
  var string = type;

  // append parameters
  if (parameters && _typeof(parameters) === 'object') {
    var param;
    var params = Object.keys(parameters).sort();
    for (var i = 0; i < params.length; i++) {
      param = params[i];
      if (!TOKEN_REGEXP.test(param)) {
        throw new TypeError('invalid parameter name');
      }
      string += '; ' + param + '=' + qstring(parameters[param]);
    }
  }
  return string;
}

/**
 * Parse media type to object.
 *
 * @param {string|object} string
 * @return {Object}
 * @public
 */

function parse(string) {
  if (!string) {
    throw new TypeError('argument string is required');
  }

  // support req/res-like objects as argument
  var header = _typeof(string) === 'object' ? getcontenttype(string) : string;
  if (typeof header !== 'string') {
    throw new TypeError('argument string is required to be a string');
  }
  var index = header.indexOf(';');
  var type = index !== -1 ? header.slice(0, index).trim() : header.trim();
  if (!TYPE_REGEXP.test(type)) {
    throw new TypeError('invalid media type');
  }
  var obj = new ContentType(type.toLowerCase());

  // parse parameters
  if (index !== -1) {
    var key;
    var match;
    var value;
    PARAM_REGEXP.lastIndex = index;
    while (match = PARAM_REGEXP.exec(header)) {
      if (match.index !== index) {
        throw new TypeError('invalid parameter format');
      }
      index += match[0].length;
      key = match[1].toLowerCase();
      value = match[2];
      if (value.charCodeAt(0) === 0x22 /* " */) {
        // remove quotes
        value = value.slice(1, -1);

        // remove escapes
        if (value.indexOf('\\') !== -1) {
          value = value.replace(QESC_REGEXP, '$1');
        }
      }
      obj.parameters[key] = value;
    }
    if (index !== header.length) {
      throw new TypeError('invalid parameter format');
    }
  }
  return obj;
}

/**
 * Get content-type from req/res objects.
 *
 * @param {object}
 * @return {Object}
 * @private
 */

function getcontenttype(obj) {
  var header;
  if (typeof obj.getHeader === 'function') {
    // res-like
    header = obj.getHeader('content-type');
  } else if (_typeof(obj.headers) === 'object') {
    // req-like
    header = obj.headers && obj.headers['content-type'];
  }
  if (typeof header !== 'string') {
    throw new TypeError('content-type header is missing from object');
  }
  return header;
}

/**
 * Quote a string if necessary.
 *
 * @param {string} val
 * @return {string}
 * @private
 */

function qstring(val) {
  var str = String(val);

  // no need to quote tokens
  if (TOKEN_REGEXP.test(str)) {
    return str;
  }
  if (str.length > 0 && !TEXT_REGEXP.test(str)) {
    throw new TypeError('invalid parameter value');
  }
  return '"' + str.replace(QUOTE_REGEXP, '\\$1') + '"';
}

/**
 * Class to represent a content type.
 * @private
 */
function ContentType(type) {
  this.parameters = Object.create(null);
  this.type = type;
}

/***/ }),

/***/ 39724:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(73210);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(69600);
__webpack_require__(23123);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
// see https://tools.ietf.org/html/rfc1808

(function (root) {
  var URL_REGEX = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/;
  var FIRST_SEGMENT_REGEX = /^(?=([^\/?#]*))\1([^]*)$/;
  var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
  var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g;
  var URLToolkit = {
    // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
    // E.g
    // With opts.alwaysNormalize = false (default, spec compliant)
    // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
    // With opts.alwaysNormalize = true (not spec compliant)
    // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
    buildAbsoluteURL: function buildAbsoluteURL(baseURL, relativeURL, opts) {
      opts = opts || {};
      // remove any remaining space and CRLF
      baseURL = baseURL.trim();
      relativeURL = relativeURL.trim();
      if (!relativeURL) {
        // 2a) If the embedded URL is entirely empty, it inherits the
        // entire base URL (i.e., is set equal to the base URL)
        // and we are done.
        if (!opts.alwaysNormalize) {
          return baseURL;
        }
        var basePartsForNormalise = URLToolkit.parseURL(baseURL);
        if (!basePartsForNormalise) {
          throw new Error('Error trying to parse base URL.');
        }
        basePartsForNormalise.path = URLToolkit.normalizePath(basePartsForNormalise.path);
        return URLToolkit.buildURLFromParts(basePartsForNormalise);
      }
      var relativeParts = URLToolkit.parseURL(relativeURL);
      if (!relativeParts) {
        throw new Error('Error trying to parse relative URL.');
      }
      if (relativeParts.scheme) {
        // 2b) If the embedded URL starts with a scheme name, it is
        // interpreted as an absolute URL and we are done.
        if (!opts.alwaysNormalize) {
          return relativeURL;
        }
        relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
        return URLToolkit.buildURLFromParts(relativeParts);
      }
      var baseParts = URLToolkit.parseURL(baseURL);
      if (!baseParts) {
        throw new Error('Error trying to parse base URL.');
      }
      if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== '/') {
        // If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
        // This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
        var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
        baseParts.netLoc = pathParts[1];
        baseParts.path = pathParts[2];
      }
      if (baseParts.netLoc && !baseParts.path) {
        baseParts.path = '/';
      }
      var builtParts = {
        // 2c) Otherwise, the embedded URL inherits the scheme of
        // the base URL.
        scheme: baseParts.scheme,
        netLoc: relativeParts.netLoc,
        path: null,
        params: relativeParts.params,
        query: relativeParts.query,
        fragment: relativeParts.fragment
      };
      if (!relativeParts.netLoc) {
        // 3) If the embedded URL's <net_loc> is non-empty, we skip to
        // Step 7.  Otherwise, the embedded URL inherits the <net_loc>
        // (if any) of the base URL.
        builtParts.netLoc = baseParts.netLoc;
        // 4) If the embedded URL path is preceded by a slash "/", the
        // path is not relative and we skip to Step 7.
        if (relativeParts.path[0] !== '/') {
          if (!relativeParts.path) {
            // 5) If the embedded URL path is empty (and not preceded by a
            // slash), then the embedded URL inherits the base URL path
            builtParts.path = baseParts.path;
            // 5a) if the embedded URL's <params> is non-empty, we skip to
            // step 7; otherwise, it inherits the <params> of the base
            // URL (if any) and
            if (!relativeParts.params) {
              builtParts.params = baseParts.params;
              // 5b) if the embedded URL's <query> is non-empty, we skip to
              // step 7; otherwise, it inherits the <query> of the base
              // URL (if any) and we skip to step 7.
              if (!relativeParts.query) {
                builtParts.query = baseParts.query;
              }
            }
          } else {
            // 6) The last segment of the base URL's path (anything
            // following the rightmost slash "/", or the entire path if no
            // slash is present) is removed and the embedded URL's path is
            // appended in its place.
            var baseURLPath = baseParts.path;
            var newPath = baseURLPath.substring(0, baseURLPath.lastIndexOf('/') + 1) + relativeParts.path;
            builtParts.path = URLToolkit.normalizePath(newPath);
          }
        }
      }
      if (builtParts.path === null) {
        builtParts.path = opts.alwaysNormalize ? URLToolkit.normalizePath(relativeParts.path) : relativeParts.path;
      }
      return URLToolkit.buildURLFromParts(builtParts);
    },
    parseURL: function parseURL(url) {
      var parts = URL_REGEX.exec(url);
      if (!parts) {
        return null;
      }
      return {
        scheme: parts[1] || '',
        netLoc: parts[2] || '',
        path: parts[3] || '',
        params: parts[4] || '',
        query: parts[5] || '',
        fragment: parts[6] || ''
      };
    },
    normalizePath: function normalizePath(path) {
      // The following operations are
      // then applied, in order, to the new path:
      // 6a) All occurrences of "./", where "." is a complete path
      // segment, are removed.
      // 6b) If the path ends with "." as a complete path segment,
      // that "." is removed.
      path = path.split('').reverse().join('').replace(SLASH_DOT_REGEX, '');
      // 6c) All occurrences of "<segment>/../", where <segment> is a
      // complete path segment not equal to "..", are removed.
      // Removal of these path segments is performed iteratively,
      // removing the leftmost matching pattern on each iteration,
      // until no matching pattern remains.
      // 6d) If the path ends with "<segment>/..", where <segment> is a
      // complete path segment not equal to "..", that
      // "<segment>/.." is removed.
      while (path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, '')).length) {}
      return path.split('').reverse().join('');
    },
    buildURLFromParts: function buildURLFromParts(parts) {
      return parts.scheme + parts.netLoc + parts.path + parts.params + parts.query + parts.fragment;
    }
  };
  if (( false ? 0 : _typeof(exports)) === 'object' && ( false ? 0 : _typeof(module)) === 'object') module.exports = URLToolkit;else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    return URLToolkit;
  }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {}
})(this);

/***/ }),

/***/ 21889:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;__webpack_require__(74916);
__webpack_require__(23123);
__webpack_require__(15306);
__webpack_require__(69600);
__webpack_require__(40561);
__webpack_require__(47042);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
/*! https://mths.be/punycode v1.3.2 by @mathias */
;
(function (root) {
  /** Detect free variables */
  var freeExports = ( false ? 0 : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;
  var freeModule = ( false ? 0 : _typeof(module)) == 'object' && module && !module.nodeType && module;
  var freeGlobal = (typeof __webpack_require__.g === "undefined" ? "undefined" : _typeof(__webpack_require__.g)) == 'object' && __webpack_require__.g;
  if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) {
    root = freeGlobal;
  }

  /**
   * The `punycode` object.
   * @name punycode
   * @type Object
   */
  var punycode,
    /** Highest positive signed 32-bit float value */
    maxInt = 2147483647,
    // aka. 0x7FFFFFFF or 2^31-1

    /** Bootstring parameters */
    base = 36,
    tMin = 1,
    tMax = 26,
    skew = 38,
    damp = 700,
    initialBias = 72,
    initialN = 128,
    // 0x80
    delimiter = '-',
    // '\x2D'

    /** Regular expressions */
    regexPunycode = /^xn--/,
    regexNonASCII = /[^\x20-\x7E]/,
    // unprintable ASCII chars + non-ASCII chars
    regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g,
    // RFC 3490 separators

    /** Error messages */
    errors = {
      'overflow': 'Overflow: input needs wider integers to process',
      'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
      'invalid-input': 'Invalid input'
    },
    /** Convenience shortcuts */
    baseMinusTMin = base - tMin,
    floor = Math.floor,
    stringFromCharCode = String.fromCharCode,
    /** Temporary variable */
    key;

  /*--------------------------------------------------------------------------*/

  /**
   * A generic error utility function.
   * @private
   * @param {String} type The error type.
   * @returns {Error} Throws a `RangeError` with the applicable error message.
   */
  function error(type) {
    throw RangeError(errors[type]);
  }

  /**
   * A generic `Array#map` utility function.
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} callback The function that gets called for every array
   * item.
   * @returns {Array} A new array of values returned by the callback function.
   */
  function map(array, fn) {
    var length = array.length;
    var result = [];
    while (length--) {
      result[length] = fn(array[length]);
    }
    return result;
  }

  /**
   * A simple `Array#map`-like wrapper to work with domain name strings or email
   * addresses.
   * @private
   * @param {String} domain The domain name or email address.
   * @param {Function} callback The function that gets called for every
   * character.
   * @returns {Array} A new string of characters returned by the callback
   * function.
   */
  function mapDomain(string, fn) {
    var parts = string.split('@');
    var result = '';
    if (parts.length > 1) {
      // In email addresses, only the domain name should be punycoded. Leave
      // the local part (i.e. everything up to `@`) intact.
      result = parts[0] + '@';
      string = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    string = string.replace(regexSeparators, '\x2E');
    var labels = string.split('.');
    var encoded = map(labels, fn).join('.');
    return result + encoded;
  }

  /**
   * Creates an array containing the numeric code points of each Unicode
   * character in the string. While JavaScript uses UCS-2 internally,
   * this function will convert a pair of surrogate halves (each of which
   * UCS-2 exposes as separate characters) into a single code point,
   * matching UTF-16.
   * @see `punycode.ucs2.encode`
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode.ucs2
   * @name decode
   * @param {String} string The Unicode input string (UCS-2).
   * @returns {Array} The new array of code points.
   */
  function ucs2decode(string) {
    var output = [],
      counter = 0,
      length = string.length,
      value,
      extra;
    while (counter < length) {
      value = string.charCodeAt(counter++);
      if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
        // high surrogate, and there is a next character
        extra = string.charCodeAt(counter++);
        if ((extra & 0xFC00) == 0xDC00) {
          // low surrogate
          output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
        } else {
          // unmatched surrogate; only append this code unit, in case the next
          // code unit is the high surrogate of a surrogate pair
          output.push(value);
          counter--;
        }
      } else {
        output.push(value);
      }
    }
    return output;
  }

  /**
   * Creates a string based on an array of numeric code points.
   * @see `punycode.ucs2.decode`
   * @memberOf punycode.ucs2
   * @name encode
   * @param {Array} codePoints The array of numeric code points.
   * @returns {String} The new Unicode string (UCS-2).
   */
  function ucs2encode(array) {
    return map(array, function (value) {
      var output = '';
      if (value > 0xFFFF) {
        value -= 0x10000;
        output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
        value = 0xDC00 | value & 0x3FF;
      }
      output += stringFromCharCode(value);
      return output;
    }).join('');
  }

  /**
   * Converts a basic code point into a digit/integer.
   * @see `digitToBasic()`
   * @private
   * @param {Number} codePoint The basic numeric code point value.
   * @returns {Number} The numeric value of a basic code point (for use in
   * representing integers) in the range `0` to `base - 1`, or `base` if
   * the code point does not represent a value.
   */
  function basicToDigit(codePoint) {
    if (codePoint - 48 < 10) {
      return codePoint - 22;
    }
    if (codePoint - 65 < 26) {
      return codePoint - 65;
    }
    if (codePoint - 97 < 26) {
      return codePoint - 97;
    }
    return base;
  }

  /**
   * Converts a digit/integer into a basic code point.
   * @see `basicToDigit()`
   * @private
   * @param {Number} digit The numeric value of a basic code point.
   * @returns {Number} The basic code point whose value (when used for
   * representing integers) is `digit`, which needs to be in the range
   * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
   * used; else, the lowercase form is used. The behavior is undefined
   * if `flag` is non-zero and `digit` has no uppercase form.
   */
  function digitToBasic(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
  }

  /**
   * Bias adaptation function as per section 3.4 of RFC 3492.
   * http://tools.ietf.org/html/rfc3492#section-3.4
   * @private
   */
  function adapt(delta, numPoints, firstTime) {
    var k = 0;
    delta = firstTime ? floor(delta / damp) : delta >> 1;
    delta += floor(delta / numPoints);
    for (; delta > baseMinusTMin * tMax >> 1; k += base) {
      delta = floor(delta / baseMinusTMin);
    }
    return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
  }

  /**
   * Converts a Punycode string of ASCII-only symbols to a string of Unicode
   * symbols.
   * @memberOf punycode
   * @param {String} input The Punycode string of ASCII-only symbols.
   * @returns {String} The resulting string of Unicode symbols.
   */
  function decode(input) {
    // Don't use UCS-2
    var output = [],
      inputLength = input.length,
      out,
      i = 0,
      n = initialN,
      bias = initialBias,
      basic,
      j,
      index,
      oldi,
      w,
      k,
      digit,
      t,
      /** Cached calculation results */
      baseMinusT;

    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.

    basic = input.lastIndexOf(delimiter);
    if (basic < 0) {
      basic = 0;
    }
    for (j = 0; j < basic; ++j) {
      // if it's not a basic code point
      if (input.charCodeAt(j) >= 0x80) {
        error('not-basic');
      }
      output.push(input.charCodeAt(j));
    }

    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.

    for (index = basic > 0 ? basic + 1 : 0; index < inputLength;) {
      // `index` is the index of the next character to be consumed.
      // Decode a generalized variable-length integer into `delta`,
      // which gets added to `i`. The overflow checking is easier
      // if we increase `i` as we go, then subtract off its starting
      // value at the end to obtain `delta`.
      for (oldi = i, w = 1, k = base;; k += base) {
        if (index >= inputLength) {
          error('invalid-input');
        }
        digit = basicToDigit(input.charCodeAt(index++));
        if (digit >= base || digit > floor((maxInt - i) / w)) {
          error('overflow');
        }
        i += digit * w;
        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
        if (digit < t) {
          break;
        }
        baseMinusT = base - t;
        if (w > floor(maxInt / baseMinusT)) {
          error('overflow');
        }
        w *= baseMinusT;
      }
      out = output.length + 1;
      bias = adapt(i - oldi, out, oldi == 0);

      // `i` was supposed to wrap around from `out` to `0`,
      // incrementing `n` each time, so we'll fix that now:
      if (floor(i / out) > maxInt - n) {
        error('overflow');
      }
      n += floor(i / out);
      i %= out;

      // Insert `n` at position `i` of the output
      output.splice(i++, 0, n);
    }
    return ucs2encode(output);
  }

  /**
   * Converts a string of Unicode symbols (e.g. a domain name label) to a
   * Punycode string of ASCII-only symbols.
   * @memberOf punycode
   * @param {String} input The string of Unicode symbols.
   * @returns {String} The resulting Punycode string of ASCII-only symbols.
   */
  function encode(input) {
    var n,
      delta,
      handledCPCount,
      basicLength,
      bias,
      j,
      m,
      q,
      k,
      t,
      currentValue,
      output = [],
      /** `inputLength` will hold the number of code points in `input`. */
      inputLength,
      /** Cached calculation results */
      handledCPCountPlusOne,
      baseMinusT,
      qMinusT;

    // Convert the input in UCS-2 to Unicode
    input = ucs2decode(input);

    // Cache the length
    inputLength = input.length;

    // Initialize the state
    n = initialN;
    delta = 0;
    bias = initialBias;

    // Handle the basic code points
    for (j = 0; j < inputLength; ++j) {
      currentValue = input[j];
      if (currentValue < 0x80) {
        output.push(stringFromCharCode(currentValue));
      }
    }
    handledCPCount = basicLength = output.length;

    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.

    // Finish the basic string - if it is not empty - with a delimiter
    if (basicLength) {
      output.push(delimiter);
    }

    // Main encoding loop:
    while (handledCPCount < inputLength) {
      // All non-basic code points < n have been handled already. Find the next
      // larger one:
      for (m = maxInt, j = 0; j < inputLength; ++j) {
        currentValue = input[j];
        if (currentValue >= n && currentValue < m) {
          m = currentValue;
        }
      }

      // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
      // but guard against overflow
      handledCPCountPlusOne = handledCPCount + 1;
      if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
        error('overflow');
      }
      delta += (m - n) * handledCPCountPlusOne;
      n = m;
      for (j = 0; j < inputLength; ++j) {
        currentValue = input[j];
        if (currentValue < n && ++delta > maxInt) {
          error('overflow');
        }
        if (currentValue == n) {
          // Represent delta as a generalized variable-length integer
          for (q = delta, k = base;; k += base) {
            t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
            if (q < t) {
              break;
            }
            qMinusT = q - t;
            baseMinusT = base - t;
            output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
            q = floor(qMinusT / baseMinusT);
          }
          output.push(stringFromCharCode(digitToBasic(q, 0)));
          bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
          delta = 0;
          ++handledCPCount;
        }
      }
      ++delta;
      ++n;
    }
    return output.join('');
  }

  /**
   * Converts a Punycode string representing a domain name or an email address
   * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
   * it doesn't matter if you call it on a string that has already been
   * converted to Unicode.
   * @memberOf punycode
   * @param {String} input The Punycoded domain name or email address to
   * convert to Unicode.
   * @returns {String} The Unicode representation of the given Punycode
   * string.
   */
  function toUnicode(input) {
    return mapDomain(input, function (string) {
      return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
    });
  }

  /**
   * Converts a Unicode string representing a domain name or an email address to
   * Punycode. Only the non-ASCII parts of the domain name will be converted,
   * i.e. it doesn't matter if you call it with a domain that's already in
   * ASCII.
   * @memberOf punycode
   * @param {String} input The domain name or email address to convert, as a
   * Unicode string.
   * @returns {String} The Punycode representation of the given domain name or
   * email address.
   */
  function toASCII(input) {
    return mapDomain(input, function (string) {
      return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
    });
  }

  /*--------------------------------------------------------------------------*/

  /** Define the public API */
  punycode = {
    /**
     * A string representing the current Punycode.js version number.
     * @memberOf punycode
     * @type String
     */
    'version': '1.3.2',
    /**
     * An object of methods to convert from JavaScript's internal character
     * representation (UCS-2) to Unicode code points, and back.
     * @see <https://mathiasbynens.be/notes/javascript-encoding>
     * @memberOf punycode
     * @type Object
     */
    'ucs2': {
      'decode': ucs2decode,
      'encode': ucs2encode
    },
    'decode': decode,
    'encode': encode,
    'toASCII': toASCII,
    'toUnicode': toUnicode
  };

  /** Expose `punycode` */
  // Some AMD build optimizers, like r.js, check for specific condition patterns
  // like the following:
  if ( true && _typeof(__webpack_require__.amdO) == 'object' && __webpack_require__.amdO) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return punycode;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (freeExports && freeModule) {
    if (module.exports == freeExports) {
      // in Node.js or RingoJS v0.8.0+
      freeModule.exports = punycode;
    } else {
      // in Narwhal or RingoJS v0.7.0-
      for (key in punycode) {
        punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
      }
    }
  } else {
    // in Rhino or a web browser
    root.punycode = punycode;
  }
})(this);

/***/ }),

/***/ 34546:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(74916);
__webpack_require__(64765);
__webpack_require__(92222);
__webpack_require__(23123);
__webpack_require__(15306);
__webpack_require__(69600);
__webpack_require__(73210);
__webpack_require__(4723);
__webpack_require__(47042);
__webpack_require__(47941);
__webpack_require__(40561);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
var punycode = __webpack_require__(21889);
var util = __webpack_require__(7504);
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;
function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
  portPattern = /:[0-9]*$/,
  // Special case for a simple path URL
  simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
  // RFC 2396: characters reserved for delimiting URLs.
  // We actually just auto-escape these.
  delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
  // RFC 2396: characters not allowed for various reasons.
  unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
  // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
  autoEscape = ['\''].concat(unwise),
  // Characters that are never ever allowed in a hostname.
  // Note that any invalid chars are also handled, but these
  // are the ones that are *expected* to be seen, so we fast-path
  // them.
  nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
  hostEndingChars = ['/', '?', '#'],
  hostnameMaxLen = 255,
  hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
  hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
  // protocols that can allow "unsafe" and "unwise" chars.
  unsafeProtocol = {
    'javascript': true,
    'javascript:': true
  },
  // protocols that never have a hostname.
  hostlessProtocol = {
    'javascript': true,
    'javascript:': true
  },
  // protocols that always contain a // bit.
  slashedProtocol = {
    'http': true,
    'https': true,
    'ftp': true,
    'gopher': true,
    'file': true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
  },
  querystring = __webpack_require__(86406);
function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;
  var u = new Url();
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}
Url.prototype.parse = function (url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + _typeof(url));
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
    splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#',
    uSplit = url.split(splitter),
    slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);
  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();
  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }
  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }
  if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1) hostEnd = rest.length;
    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }
    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }
    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }
    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {
    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1) continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }

  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}
Url.prototype.format = function () {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }
  var protocol = this.protocol || '',
    pathname = this.pathname || '',
    hash = this.hash || '',
    host = false,
    query = '';
  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }
  if (this.query && util.isObject(this.query) && Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }
  var search = this.search || query && '?' + query || '';
  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }
  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;
  pathname = pathname.replace(/[?#]/g, function (match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');
  return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function (relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function (relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }
  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol') result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }
    result.href = result.format();
    return result;
  }
  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }
    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift())) {
        ;
      }
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }
  var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/',
    isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/',
    mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname,
    removeAllDots = mustEndAbs,
    srcPath = result.pathname && result.pathname.split('/') || [],
    relPath = relative.pathname && relative.pathname.split('/') || [],
    psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }
  if (isRelAbs) {
    // it's absolute.
    result.host = relative.host || relative.host === '' ? relative.host : result.host;
    result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }
  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }
  if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }
  if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') {
    srcPath.push('');
  }
  var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }
  mustEndAbs = mustEndAbs || result.host && srcPath.length;
  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }
  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};
Url.prototype.parseHost = function () {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};

/***/ }),

/***/ 7504:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
module.exports = {
  isString: function isString(arg) {
    return typeof arg === 'string';
  },
  isObject: function isObject(arg) {
    return _typeof(arg) === 'object' && arg !== null;
  },
  isNull: function isNull(arg) {
    return arg === null;
  },
  isNullOrUndefined: function isNullOrUndefined(arg) {
    return arg == null;
  }
};

/***/ }),

/***/ 99227:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// Default exports for Node. Export the extended versions of VTTCue and
// VTTRegion in Node since we likely want the capability to convert back and
// forth between JSON. If we don't then it's not that big of a deal since we're
// off browser.

var window = __webpack_require__(95732);
var vttjs = module.exports = {
  WebVTT: __webpack_require__(6123),
  VTTCue: __webpack_require__(26456),
  VTTRegion: __webpack_require__(55787)
};
window.vttjs = vttjs;
window.WebVTT = vttjs.WebVTT;
var cueShim = vttjs.VTTCue;
var regionShim = vttjs.VTTRegion;
var nativeVTTCue = window.VTTCue;
var nativeVTTRegion = window.VTTRegion;
vttjs.shim = function () {
  window.VTTCue = cueShim;
  window.VTTRegion = regionShim;
};
vttjs.restore = function () {
  window.VTTCue = nativeVTTCue;
  window.VTTRegion = nativeVTTRegion;
};
if (!window.VTTCue) {
  vttjs.shim();
}

/***/ }),

/***/ 6123:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(68309);
__webpack_require__(74916);
__webpack_require__(4723);
__webpack_require__(15306);
__webpack_require__(66992);
__webpack_require__(41539);
__webpack_require__(33948);
__webpack_require__(23123);
__webpack_require__(73210);
__webpack_require__(54747);
__webpack_require__(47042);
__webpack_require__(69600);
/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* -*- Mode: Java; tab-width: 2; indent-tabs-mode: nil; c-basic-offset: 2 -*- */
/* vim: set shiftwidth=2 tabstop=2 autoindent cindent expandtab: */
var document = __webpack_require__(56374);
var _objCreate = Object.create || function () {
  function F() {}
  return function (o) {
    if (arguments.length !== 1) {
      throw new Error('Object.create shim only accepts one parameter.');
    }
    F.prototype = o;
    return new F();
  };
}();

// Creates a new ParserError object from an errorData object. The errorData
// object should have default code and message properties. The default message
// property can be overriden by passing in a message parameter.
// See ParsingError.Errors below for acceptable errors.
function ParsingError(errorData, message) {
  this.name = "ParsingError";
  this.code = errorData.code;
  this.message = message || errorData.message;
}
ParsingError.prototype = _objCreate(Error.prototype);
ParsingError.prototype.constructor = ParsingError;

// ParsingError metadata for acceptable ParsingErrors.
ParsingError.Errors = {
  BadSignature: {
    code: 0,
    message: "Malformed WebVTT signature."
  },
  BadTimeStamp: {
    code: 1,
    message: "Malformed time stamp."
  }
};

// Try to parse input as a time stamp.
function parseTimeStamp(input) {
  function computeSeconds(h, m, s, f) {
    return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + (f | 0) / 1000;
  }
  var m = input.match(/^(\d+):(\d{1,2})(:\d{1,2})?\.(\d{3})/);
  if (!m) {
    return null;
  }
  if (m[3]) {
    // Timestamp takes the form of [hours]:[minutes]:[seconds].[milliseconds]
    return computeSeconds(m[1], m[2], m[3].replace(":", ""), m[4]);
  } else if (m[1] > 59) {
    // Timestamp takes the form of [hours]:[minutes].[milliseconds]
    // First position is hours as it's over 59.
    return computeSeconds(m[1], m[2], 0, m[4]);
  } else {
    // Timestamp takes the form of [minutes]:[seconds].[milliseconds]
    return computeSeconds(0, m[1], m[2], m[4]);
  }
}

// A settings object holds key/value pairs and will ignore anything but the first
// assignment to a specific key.
function Settings() {
  this.values = _objCreate(null);
}
Settings.prototype = {
  // Only accept the first assignment to any key.
  set: function set(k, v) {
    if (!this.get(k) && v !== "") {
      this.values[k] = v;
    }
  },
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get: function get(k, dflt, defaultKey) {
    if (defaultKey) {
      return this.has(k) ? this.values[k] : dflt[defaultKey];
    }
    return this.has(k) ? this.values[k] : dflt;
  },
  // Check whether we have a value for a key.
  has: function has(k) {
    return k in this.values;
  },
  // Accept a setting if its one of the given alternatives.
  alt: function alt(k, v, a) {
    for (var n = 0; n < a.length; ++n) {
      if (v === a[n]) {
        this.set(k, v);
        break;
      }
    }
  },
  // Accept a setting if its a valid (signed) integer.
  integer: function integer(k, v) {
    if (/^-?\d+$/.test(v)) {
      // integer
      this.set(k, parseInt(v, 10));
    }
  },
  // Accept a setting if its a valid percentage.
  percent: function percent(k, v) {
    var m;
    if (m = v.match(/^([\d]{1,3})(\.[\d]*)?%$/)) {
      v = parseFloat(v);
      if (v >= 0 && v <= 100) {
        this.set(k, v);
        return true;
      }
    }
    return false;
  }
};

// Helper function to parse input into groups separated by 'groupDelim', and
// interprete each group as a key/value pair separated by 'keyValueDelim'.
function parseOptions(input, callback, keyValueDelim, groupDelim) {
  var groups = groupDelim ? input.split(groupDelim) : [input];
  for (var i in groups) {
    if (typeof groups[i] !== "string") {
      continue;
    }
    var kv = groups[i].split(keyValueDelim);
    if (kv.length !== 2) {
      continue;
    }
    var k = kv[0].trim();
    var v = kv[1].trim();
    callback(k, v);
  }
}
function parseCue(input, cue, regionList) {
  // Remember the original input if we need to throw an error.
  var oInput = input;
  // 4.1 WebVTT timestamp
  function consumeTimeStamp() {
    var ts = parseTimeStamp(input);
    if (ts === null) {
      throw new ParsingError(ParsingError.Errors.BadTimeStamp, "Malformed timestamp: " + oInput);
    }
    // Remove time stamp from input.
    input = input.replace(/^[^\sa-zA-Z-]+/, "");
    return ts;
  }

  // 4.4.2 WebVTT cue settings
  function consumeCueSettings(input, cue) {
    var settings = new Settings();
    parseOptions(input, function (k, v) {
      switch (k) {
        case "region":
          // Find the last region we parsed with the same region id.
          for (var i = regionList.length - 1; i >= 0; i--) {
            if (regionList[i].id === v) {
              settings.set(k, regionList[i].region);
              break;
            }
          }
          break;
        case "vertical":
          settings.alt(k, v, ["rl", "lr"]);
          break;
        case "line":
          var vals = v.split(","),
            vals0 = vals[0];
          settings.integer(k, vals0);
          settings.percent(k, vals0) ? settings.set("snapToLines", false) : null;
          settings.alt(k, vals0, ["auto"]);
          if (vals.length === 2) {
            settings.alt("lineAlign", vals[1], ["start", "center", "end"]);
          }
          break;
        case "position":
          vals = v.split(",");
          settings.percent(k, vals[0]);
          if (vals.length === 2) {
            settings.alt("positionAlign", vals[1], ["start", "center", "end"]);
          }
          break;
        case "size":
          settings.percent(k, v);
          break;
        case "align":
          settings.alt(k, v, ["start", "center", "end", "left", "right"]);
          break;
      }
    }, /:/, /\s/);

    // Apply default values for any missing fields.
    cue.region = settings.get("region", null);
    cue.vertical = settings.get("vertical", "");
    try {
      cue.line = settings.get("line", "auto");
    } catch (e) {}
    cue.lineAlign = settings.get("lineAlign", "start");
    cue.snapToLines = settings.get("snapToLines", true);
    cue.size = settings.get("size", 100);
    // Safari still uses the old middle value and won't accept center
    try {
      cue.align = settings.get("align", "center");
    } catch (e) {
      cue.align = settings.get("align", "middle");
    }
    try {
      cue.position = settings.get("position", "auto");
    } catch (e) {
      cue.position = settings.get("position", {
        start: 0,
        left: 0,
        center: 50,
        middle: 50,
        end: 100,
        right: 100
      }, cue.align);
    }
    cue.positionAlign = settings.get("positionAlign", {
      start: "start",
      left: "start",
      center: "center",
      middle: "center",
      end: "end",
      right: "end"
    }, cue.align);
  }
  function skipWhitespace() {
    input = input.replace(/^\s+/, "");
  }

  // 4.1 WebVTT cue timings.
  skipWhitespace();
  cue.startTime = consumeTimeStamp(); // (1) collect cue start time
  skipWhitespace();
  if (input.substr(0, 3) !== "-->") {
    // (3) next characters must match "-->"
    throw new ParsingError(ParsingError.Errors.BadTimeStamp, "Malformed time stamp (time stamps must be separated by '-->'): " + oInput);
  }
  input = input.substr(3);
  skipWhitespace();
  cue.endTime = consumeTimeStamp(); // (5) collect cue end time

  // 4.1 WebVTT cue settings list.
  skipWhitespace();
  consumeCueSettings(input, cue);
}

// When evaluating this file as part of a Webpack bundle for server
// side rendering, `document` is an empty object.
var TEXTAREA_ELEMENT = document.createElement && document.createElement("textarea");
var TAG_NAME = {
  c: "span",
  i: "i",
  b: "b",
  u: "u",
  ruby: "ruby",
  rt: "rt",
  v: "span",
  lang: "span"
};

// 5.1 default text color
// 5.2 default text background color is equivalent to text color with bg_ prefix
var DEFAULT_COLOR_CLASS = {
  white: 'rgba(255,255,255,1)',
  lime: 'rgba(0,255,0,1)',
  cyan: 'rgba(0,255,255,1)',
  red: 'rgba(255,0,0,1)',
  yellow: 'rgba(255,255,0,1)',
  magenta: 'rgba(255,0,255,1)',
  blue: 'rgba(0,0,255,1)',
  black: 'rgba(0,0,0,1)'
};
var TAG_ANNOTATION = {
  v: "title",
  lang: "lang"
};
var NEEDS_PARENT = {
  rt: "ruby"
};

// Parse content into a document fragment.
function parseContent(window, input) {
  function nextToken() {
    // Check for end-of-string.
    if (!input) {
      return null;
    }

    // Consume 'n' characters from the input.
    function consume(result) {
      input = input.substr(result.length);
      return result;
    }
    var m = input.match(/^([^<]*)(<[^>]*>?)?/);
    // If there is some text before the next tag, return it, otherwise return
    // the tag.
    return consume(m[1] ? m[1] : m[2]);
  }
  function unescape(s) {
    TEXTAREA_ELEMENT.innerHTML = s;
    s = TEXTAREA_ELEMENT.textContent;
    TEXTAREA_ELEMENT.textContent = "";
    return s;
  }
  function shouldAdd(current, element) {
    return !NEEDS_PARENT[element.localName] || NEEDS_PARENT[element.localName] === current.localName;
  }

  // Create an element for this tag.
  function createElement(type, annotation) {
    var tagName = TAG_NAME[type];
    if (!tagName) {
      return null;
    }
    var element = window.document.createElement(tagName);
    var name = TAG_ANNOTATION[type];
    if (name && annotation) {
      element[name] = annotation.trim();
    }
    return element;
  }
  var rootDiv = window.document.createElement("div"),
    current = rootDiv,
    t,
    tagStack = [];
  while ((t = nextToken()) !== null) {
    if (t[0] === '<') {
      if (t[1] === "/") {
        // If the closing tag matches, move back up to the parent node.
        if (tagStack.length && tagStack[tagStack.length - 1] === t.substr(2).replace(">", "")) {
          tagStack.pop();
          current = current.parentNode;
        }
        // Otherwise just ignore the end tag.
        continue;
      }
      var ts = parseTimeStamp(t.substr(1, t.length - 2));
      var node;
      if (ts) {
        // Timestamps are lead nodes as well.
        node = window.document.createProcessingInstruction("timestamp", ts);
        current.appendChild(node);
        continue;
      }
      var m = t.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
      // If we can't parse the tag, skip to the next tag.
      if (!m) {
        continue;
      }
      // Try to construct an element, and ignore the tag if we couldn't.
      node = createElement(m[1], m[3]);
      if (!node) {
        continue;
      }
      // Determine if the tag should be added based on the context of where it
      // is placed in the cuetext.
      if (!shouldAdd(current, node)) {
        continue;
      }
      // Set the class list (as a list of classes, separated by space).
      if (m[2]) {
        var classes = m[2].split('.');
        classes.forEach(function (cl) {
          var bgColor = /^bg_/.test(cl);
          // slice out `bg_` if it's a background color
          var colorName = bgColor ? cl.slice(3) : cl;
          if (DEFAULT_COLOR_CLASS.hasOwnProperty(colorName)) {
            var propName = bgColor ? 'background-color' : 'color';
            var propValue = DEFAULT_COLOR_CLASS[colorName];
            node.style[propName] = propValue;
          }
        });
        node.className = classes.join(' ');
      }
      // Append the node to the current node, and enter the scope of the new
      // node.
      tagStack.push(m[1]);
      current.appendChild(node);
      current = node;
      continue;
    }

    // Text nodes are leaf nodes.
    current.appendChild(window.document.createTextNode(unescape(t)));
  }
  return rootDiv;
}

// This is a list of all the Unicode characters that have a strong
// right-to-left category. What this means is that these characters are
// written right-to-left for sure. It was generated by pulling all the strong
// right-to-left characters out of the Unicode data table. That table can
// found at: http://www.unicode.org/Public/UNIDATA/UnicodeData.txt
var strongRTLRanges = [[0x5be, 0x5be], [0x5c0, 0x5c0], [0x5c3, 0x5c3], [0x5c6, 0x5c6], [0x5d0, 0x5ea], [0x5f0, 0x5f4], [0x608, 0x608], [0x60b, 0x60b], [0x60d, 0x60d], [0x61b, 0x61b], [0x61e, 0x64a], [0x66d, 0x66f], [0x671, 0x6d5], [0x6e5, 0x6e6], [0x6ee, 0x6ef], [0x6fa, 0x70d], [0x70f, 0x710], [0x712, 0x72f], [0x74d, 0x7a5], [0x7b1, 0x7b1], [0x7c0, 0x7ea], [0x7f4, 0x7f5], [0x7fa, 0x7fa], [0x800, 0x815], [0x81a, 0x81a], [0x824, 0x824], [0x828, 0x828], [0x830, 0x83e], [0x840, 0x858], [0x85e, 0x85e], [0x8a0, 0x8a0], [0x8a2, 0x8ac], [0x200f, 0x200f], [0xfb1d, 0xfb1d], [0xfb1f, 0xfb28], [0xfb2a, 0xfb36], [0xfb38, 0xfb3c], [0xfb3e, 0xfb3e], [0xfb40, 0xfb41], [0xfb43, 0xfb44], [0xfb46, 0xfbc1], [0xfbd3, 0xfd3d], [0xfd50, 0xfd8f], [0xfd92, 0xfdc7], [0xfdf0, 0xfdfc], [0xfe70, 0xfe74], [0xfe76, 0xfefc], [0x10800, 0x10805], [0x10808, 0x10808], [0x1080a, 0x10835], [0x10837, 0x10838], [0x1083c, 0x1083c], [0x1083f, 0x10855], [0x10857, 0x1085f], [0x10900, 0x1091b], [0x10920, 0x10939], [0x1093f, 0x1093f], [0x10980, 0x109b7], [0x109be, 0x109bf], [0x10a00, 0x10a00], [0x10a10, 0x10a13], [0x10a15, 0x10a17], [0x10a19, 0x10a33], [0x10a40, 0x10a47], [0x10a50, 0x10a58], [0x10a60, 0x10a7f], [0x10b00, 0x10b35], [0x10b40, 0x10b55], [0x10b58, 0x10b72], [0x10b78, 0x10b7f], [0x10c00, 0x10c48], [0x1ee00, 0x1ee03], [0x1ee05, 0x1ee1f], [0x1ee21, 0x1ee22], [0x1ee24, 0x1ee24], [0x1ee27, 0x1ee27], [0x1ee29, 0x1ee32], [0x1ee34, 0x1ee37], [0x1ee39, 0x1ee39], [0x1ee3b, 0x1ee3b], [0x1ee42, 0x1ee42], [0x1ee47, 0x1ee47], [0x1ee49, 0x1ee49], [0x1ee4b, 0x1ee4b], [0x1ee4d, 0x1ee4f], [0x1ee51, 0x1ee52], [0x1ee54, 0x1ee54], [0x1ee57, 0x1ee57], [0x1ee59, 0x1ee59], [0x1ee5b, 0x1ee5b], [0x1ee5d, 0x1ee5d], [0x1ee5f, 0x1ee5f], [0x1ee61, 0x1ee62], [0x1ee64, 0x1ee64], [0x1ee67, 0x1ee6a], [0x1ee6c, 0x1ee72], [0x1ee74, 0x1ee77], [0x1ee79, 0x1ee7c], [0x1ee7e, 0x1ee7e], [0x1ee80, 0x1ee89], [0x1ee8b, 0x1ee9b], [0x1eea1, 0x1eea3], [0x1eea5, 0x1eea9], [0x1eeab, 0x1eebb], [0x10fffd, 0x10fffd]];
function isStrongRTLChar(charCode) {
  for (var i = 0; i < strongRTLRanges.length; i++) {
    var currentRange = strongRTLRanges[i];
    if (charCode >= currentRange[0] && charCode <= currentRange[1]) {
      return true;
    }
  }
  return false;
}
function determineBidi(cueDiv) {
  var nodeStack = [],
    text = "",
    charCode;
  if (!cueDiv || !cueDiv.childNodes) {
    return "ltr";
  }
  function pushNodes(nodeStack, node) {
    for (var i = node.childNodes.length - 1; i >= 0; i--) {
      nodeStack.push(node.childNodes[i]);
    }
  }
  function nextTextNode(nodeStack) {
    if (!nodeStack || !nodeStack.length) {
      return null;
    }
    var node = nodeStack.pop(),
      text = node.textContent || node.innerText;
    if (text) {
      // TODO: This should match all unicode type B characters (paragraph
      // separator characters). See issue #115.
      var m = text.match(/^.*(\n|\r)/);
      if (m) {
        nodeStack.length = 0;
        return m[0];
      }
      return text;
    }
    if (node.tagName === "ruby") {
      return nextTextNode(nodeStack);
    }
    if (node.childNodes) {
      pushNodes(nodeStack, node);
      return nextTextNode(nodeStack);
    }
  }
  pushNodes(nodeStack, cueDiv);
  while (text = nextTextNode(nodeStack)) {
    for (var i = 0; i < text.length; i++) {
      charCode = text.charCodeAt(i);
      if (isStrongRTLChar(charCode)) {
        return "rtl";
      }
    }
  }
  return "ltr";
}
function computeLinePos(cue) {
  if (typeof cue.line === "number" && (cue.snapToLines || cue.line >= 0 && cue.line <= 100)) {
    return cue.line;
  }
  if (!cue.track || !cue.track.textTrackList || !cue.track.textTrackList.mediaElement) {
    return -1;
  }
  var track = cue.track,
    trackList = track.textTrackList,
    count = 0;
  for (var i = 0; i < trackList.length && trackList[i] !== track; i++) {
    if (trackList[i].mode === "showing") {
      count++;
    }
  }
  return ++count * -1;
}
function StyleBox() {}

// Apply styles to a div. If there is no div passed then it defaults to the
// div on 'this'.
StyleBox.prototype.applyStyles = function (styles, div) {
  div = div || this.div;
  for (var prop in styles) {
    if (styles.hasOwnProperty(prop)) {
      div.style[prop] = styles[prop];
    }
  }
};
StyleBox.prototype.formatStyle = function (val, unit) {
  return val === 0 ? 0 : val + unit;
};

// Constructs the computed display state of the cue (a div). Places the div
// into the overlay which should be a block level element (usually a div).
function CueStyleBox(window, cue, styleOptions) {
  StyleBox.call(this);
  this.cue = cue;

  // Parse our cue's text into a DOM tree rooted at 'cueDiv'. This div will
  // have inline positioning and will function as the cue background box.
  this.cueDiv = parseContent(window, cue.text);
  var styles = {
    color: "rgba(255, 255, 255, 1)",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    position: "relative",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "inline",
    writingMode: cue.vertical === "" ? "horizontal-tb" : cue.vertical === "lr" ? "vertical-lr" : "vertical-rl",
    unicodeBidi: "plaintext"
  };
  this.applyStyles(styles, this.cueDiv);

  // Create an absolutely positioned div that will be used to position the cue
  // div. Note, all WebVTT cue-setting alignments are equivalent to the CSS
  // mirrors of them except middle instead of center on Safari.
  this.div = window.document.createElement("div");
  styles = {
    direction: determineBidi(this.cueDiv),
    writingMode: cue.vertical === "" ? "horizontal-tb" : cue.vertical === "lr" ? "vertical-lr" : "vertical-rl",
    unicodeBidi: "plaintext",
    textAlign: cue.align === "middle" ? "center" : cue.align,
    font: styleOptions.font,
    whiteSpace: "pre-line",
    position: "absolute"
  };
  this.applyStyles(styles);
  this.div.appendChild(this.cueDiv);

  // Calculate the distance from the reference edge of the viewport to the text
  // position of the cue box. The reference edge will be resolved later when
  // the box orientation styles are applied.
  var textPos = 0;
  switch (cue.positionAlign) {
    case "start":
    case "line-left":
      textPos = cue.position;
      break;
    case "center":
      textPos = cue.position - cue.size / 2;
      break;
    case "end":
    case "line-right":
      textPos = cue.position - cue.size;
      break;
  }

  // Horizontal box orientation; textPos is the distance from the left edge of the
  // area to the left edge of the box and cue.size is the distance extending to
  // the right from there.
  if (cue.vertical === "") {
    this.applyStyles({
      left: this.formatStyle(textPos, "%"),
      width: this.formatStyle(cue.size, "%")
    });
    // Vertical box orientation; textPos is the distance from the top edge of the
    // area to the top edge of the box and cue.size is the height extending
    // downwards from there.
  } else {
    this.applyStyles({
      top: this.formatStyle(textPos, "%"),
      height: this.formatStyle(cue.size, "%")
    });
  }
  this.move = function (box) {
    this.applyStyles({
      top: this.formatStyle(box.top, "px"),
      bottom: this.formatStyle(box.bottom, "px"),
      left: this.formatStyle(box.left, "px"),
      right: this.formatStyle(box.right, "px"),
      height: this.formatStyle(box.height, "px"),
      width: this.formatStyle(box.width, "px")
    });
  };
}
CueStyleBox.prototype = _objCreate(StyleBox.prototype);
CueStyleBox.prototype.constructor = CueStyleBox;

// Represents the co-ordinates of an Element in a way that we can easily
// compute things with such as if it overlaps or intersects with another Element.
// Can initialize it with either a StyleBox or another BoxPosition.
function BoxPosition(obj) {
  // Either a BoxPosition was passed in and we need to copy it, or a StyleBox
  // was passed in and we need to copy the results of 'getBoundingClientRect'
  // as the object returned is readonly. All co-ordinate values are in reference
  // to the viewport origin (top left).
  var lh, height, width, top;
  if (obj.div) {
    height = obj.div.offsetHeight;
    width = obj.div.offsetWidth;
    top = obj.div.offsetTop;
    var rects = (rects = obj.div.childNodes) && (rects = rects[0]) && rects.getClientRects && rects.getClientRects();
    obj = obj.div.getBoundingClientRect();
    // In certain cases the outter div will be slightly larger then the sum of
    // the inner div's lines. This could be due to bold text, etc, on some platforms.
    // In this case we should get the average line height and use that. This will
    // result in the desired behaviour.
    lh = rects ? Math.max(rects[0] && rects[0].height || 0, obj.height / rects.length) : 0;
  }
  this.left = obj.left;
  this.right = obj.right;
  this.top = obj.top || top;
  this.height = obj.height || height;
  this.bottom = obj.bottom || top + (obj.height || height);
  this.width = obj.width || width;
  this.lineHeight = lh !== undefined ? lh : obj.lineHeight;
}

// Move the box along a particular axis. Optionally pass in an amount to move
// the box. If no amount is passed then the default is the line height of the
// box.
BoxPosition.prototype.move = function (axis, toMove) {
  toMove = toMove !== undefined ? toMove : this.lineHeight;
  switch (axis) {
    case "+x":
      this.left += toMove;
      this.right += toMove;
      break;
    case "-x":
      this.left -= toMove;
      this.right -= toMove;
      break;
    case "+y":
      this.top += toMove;
      this.bottom += toMove;
      break;
    case "-y":
      this.top -= toMove;
      this.bottom -= toMove;
      break;
  }
};

// Check if this box overlaps another box, b2.
BoxPosition.prototype.overlaps = function (b2) {
  return this.left < b2.right && this.right > b2.left && this.top < b2.bottom && this.bottom > b2.top;
};

// Check if this box overlaps any other boxes in boxes.
BoxPosition.prototype.overlapsAny = function (boxes) {
  for (var i = 0; i < boxes.length; i++) {
    if (this.overlaps(boxes[i])) {
      return true;
    }
  }
  return false;
};

// Check if this box is within another box.
BoxPosition.prototype.within = function (container) {
  return this.top >= container.top && this.bottom <= container.bottom && this.left >= container.left && this.right <= container.right;
};

// Check if this box is entirely within the container or it is overlapping
// on the edge opposite of the axis direction passed. For example, if "+x" is
// passed and the box is overlapping on the left edge of the container, then
// return true.
BoxPosition.prototype.overlapsOppositeAxis = function (container, axis) {
  switch (axis) {
    case "+x":
      return this.left < container.left;
    case "-x":
      return this.right > container.right;
    case "+y":
      return this.top < container.top;
    case "-y":
      return this.bottom > container.bottom;
  }
};

// Find the percentage of the area that this box is overlapping with another
// box.
BoxPosition.prototype.intersectPercentage = function (b2) {
  var x = Math.max(0, Math.min(this.right, b2.right) - Math.max(this.left, b2.left)),
    y = Math.max(0, Math.min(this.bottom, b2.bottom) - Math.max(this.top, b2.top)),
    intersectArea = x * y;
  return intersectArea / (this.height * this.width);
};

// Convert the positions from this box to CSS compatible positions using
// the reference container's positions. This has to be done because this
// box's positions are in reference to the viewport origin, whereas, CSS
// values are in referecne to their respective edges.
BoxPosition.prototype.toCSSCompatValues = function (reference) {
  return {
    top: this.top - reference.top,
    bottom: reference.bottom - this.bottom,
    left: this.left - reference.left,
    right: reference.right - this.right,
    height: this.height,
    width: this.width
  };
};

// Get an object that represents the box's position without anything extra.
// Can pass a StyleBox, HTMLElement, or another BoxPositon.
BoxPosition.getSimpleBoxPosition = function (obj) {
  var height = obj.div ? obj.div.offsetHeight : obj.tagName ? obj.offsetHeight : 0;
  var width = obj.div ? obj.div.offsetWidth : obj.tagName ? obj.offsetWidth : 0;
  var top = obj.div ? obj.div.offsetTop : obj.tagName ? obj.offsetTop : 0;
  obj = obj.div ? obj.div.getBoundingClientRect() : obj.tagName ? obj.getBoundingClientRect() : obj;
  var ret = {
    left: obj.left,
    right: obj.right,
    top: obj.top || top,
    height: obj.height || height,
    bottom: obj.bottom || top + (obj.height || height),
    width: obj.width || width
  };
  return ret;
};

// Move a StyleBox to its specified, or next best, position. The containerBox
// is the box that contains the StyleBox, such as a div. boxPositions are
// a list of other boxes that the styleBox can't overlap with.
function moveBoxToLinePosition(window, styleBox, containerBox, boxPositions) {
  // Find the best position for a cue box, b, on the video. The axis parameter
  // is a list of axis, the order of which, it will move the box along. For example:
  // Passing ["+x", "-x"] will move the box first along the x axis in the positive
  // direction. If it doesn't find a good position for it there it will then move
  // it along the x axis in the negative direction.
  function findBestPosition(b, axis) {
    var bestPosition,
      specifiedPosition = new BoxPosition(b),
      percentage = 1; // Highest possible so the first thing we get is better.

    for (var i = 0; i < axis.length; i++) {
      while (b.overlapsOppositeAxis(containerBox, axis[i]) || b.within(containerBox) && b.overlapsAny(boxPositions)) {
        b.move(axis[i]);
      }
      // We found a spot where we aren't overlapping anything. This is our
      // best position.
      if (b.within(containerBox)) {
        return b;
      }
      var p = b.intersectPercentage(containerBox);
      // If we're outside the container box less then we were on our last try
      // then remember this position as the best position.
      if (percentage > p) {
        bestPosition = new BoxPosition(b);
        percentage = p;
      }
      // Reset the box position to the specified position.
      b = new BoxPosition(specifiedPosition);
    }
    return bestPosition || specifiedPosition;
  }
  var boxPosition = new BoxPosition(styleBox),
    cue = styleBox.cue,
    linePos = computeLinePos(cue),
    axis = [];

  // If we have a line number to align the cue to.
  if (cue.snapToLines) {
    var size;
    switch (cue.vertical) {
      case "":
        axis = ["+y", "-y"];
        size = "height";
        break;
      case "rl":
        axis = ["+x", "-x"];
        size = "width";
        break;
      case "lr":
        axis = ["-x", "+x"];
        size = "width";
        break;
    }
    var step = boxPosition.lineHeight,
      position = step * Math.round(linePos),
      maxPosition = containerBox[size] + step,
      initialAxis = axis[0];

    // If the specified intial position is greater then the max position then
    // clamp the box to the amount of steps it would take for the box to
    // reach the max position.
    if (Math.abs(position) > maxPosition) {
      position = position < 0 ? -1 : 1;
      position *= Math.ceil(maxPosition / step) * step;
    }

    // If computed line position returns negative then line numbers are
    // relative to the bottom of the video instead of the top. Therefore, we
    // need to increase our initial position by the length or width of the
    // video, depending on the writing direction, and reverse our axis directions.
    if (linePos < 0) {
      position += cue.vertical === "" ? containerBox.height : containerBox.width;
      axis = axis.reverse();
    }

    // Move the box to the specified position. This may not be its best
    // position.
    boxPosition.move(initialAxis, position);
  } else {
    // If we have a percentage line value for the cue.
    var calculatedPercentage = boxPosition.lineHeight / containerBox.height * 100;
    switch (cue.lineAlign) {
      case "center":
        linePos -= calculatedPercentage / 2;
        break;
      case "end":
        linePos -= calculatedPercentage;
        break;
    }

    // Apply initial line position to the cue box.
    switch (cue.vertical) {
      case "":
        styleBox.applyStyles({
          top: styleBox.formatStyle(linePos, "%")
        });
        break;
      case "rl":
        styleBox.applyStyles({
          left: styleBox.formatStyle(linePos, "%")
        });
        break;
      case "lr":
        styleBox.applyStyles({
          right: styleBox.formatStyle(linePos, "%")
        });
        break;
    }
    axis = ["+y", "-x", "+x", "-y"];

    // Get the box position again after we've applied the specified positioning
    // to it.
    boxPosition = new BoxPosition(styleBox);
  }
  var bestPosition = findBestPosition(boxPosition, axis);
  styleBox.move(bestPosition.toCSSCompatValues(containerBox));
}
function WebVTT() {
  // Nothing
}

// Helper to allow strings to be decoded instead of the default binary utf8 data.
WebVTT.StringDecoder = function () {
  return {
    decode: function decode(data) {
      if (!data) {
        return "";
      }
      if (typeof data !== "string") {
        throw new Error("Error - expected string data.");
      }
      return decodeURIComponent(encodeURIComponent(data));
    }
  };
};
WebVTT.convertCueToDOMTree = function (window, cuetext) {
  if (!window || !cuetext) {
    return null;
  }
  return parseContent(window, cuetext);
};
var FONT_SIZE_PERCENT = 0.05;
var FONT_STYLE = "sans-serif";
var CUE_BACKGROUND_PADDING = "1.5%";

// Runs the processing model over the cues and regions passed to it.
// @param overlay A block level element (usually a div) that the computed cues
//                and regions will be placed into.
WebVTT.processCues = function (window, cues, overlay) {
  if (!window || !cues || !overlay) {
    return null;
  }

  // Remove all previous children.
  while (overlay.firstChild) {
    overlay.removeChild(overlay.firstChild);
  }
  var paddedOverlay = window.document.createElement("div");
  paddedOverlay.style.position = "absolute";
  paddedOverlay.style.left = "0";
  paddedOverlay.style.right = "0";
  paddedOverlay.style.top = "0";
  paddedOverlay.style.bottom = "0";
  paddedOverlay.style.margin = CUE_BACKGROUND_PADDING;
  overlay.appendChild(paddedOverlay);

  // Determine if we need to compute the display states of the cues. This could
  // be the case if a cue's state has been changed since the last computation or
  // if it has not been computed yet.
  function shouldCompute(cues) {
    for (var i = 0; i < cues.length; i++) {
      if (cues[i].hasBeenReset || !cues[i].displayState) {
        return true;
      }
    }
    return false;
  }

  // We don't need to recompute the cues' display states. Just reuse them.
  if (!shouldCompute(cues)) {
    for (var i = 0; i < cues.length; i++) {
      paddedOverlay.appendChild(cues[i].displayState);
    }
    return;
  }
  var boxPositions = [],
    containerBox = BoxPosition.getSimpleBoxPosition(paddedOverlay),
    fontSize = Math.round(containerBox.height * FONT_SIZE_PERCENT * 100) / 100;
  var styleOptions = {
    font: fontSize + "px " + FONT_STYLE
  };
  (function () {
    var styleBox, cue;
    for (var i = 0; i < cues.length; i++) {
      cue = cues[i];

      // Compute the intial position and styles of the cue div.
      styleBox = new CueStyleBox(window, cue, styleOptions);
      paddedOverlay.appendChild(styleBox.div);

      // Move the cue div to it's correct line position.
      moveBoxToLinePosition(window, styleBox, containerBox, boxPositions);

      // Remember the computed div so that we don't have to recompute it later
      // if we don't have too.
      cue.displayState = styleBox.div;
      boxPositions.push(BoxPosition.getSimpleBoxPosition(styleBox));
    }
  })();
};
WebVTT.Parser = function (window, vttjs, decoder) {
  if (!decoder) {
    decoder = vttjs;
    vttjs = {};
  }
  if (!vttjs) {
    vttjs = {};
  }
  this.window = window;
  this.vttjs = vttjs;
  this.state = "INITIAL";
  this.buffer = "";
  this.decoder = decoder || new TextDecoder("utf8");
  this.regionList = [];
};
WebVTT.Parser.prototype = {
  // If the error is a ParsingError then report it to the consumer if
  // possible. If it's not a ParsingError then throw it like normal.
  reportOrThrowError: function reportOrThrowError(e) {
    if (e instanceof ParsingError) {
      this.onparsingerror && this.onparsingerror(e);
    } else {
      throw e;
    }
  },
  parse: function parse(data) {
    var self = this;

    // If there is no data then we won't decode it, but will just try to parse
    // whatever is in buffer already. This may occur in circumstances, for
    // example when flush() is called.
    if (data) {
      // Try to decode the data that we received.
      self.buffer += self.decoder.decode(data, {
        stream: true
      });
    }
    function collectNextLine() {
      var buffer = self.buffer;
      var pos = 0;
      while (pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n') {
        ++pos;
      }
      var line = buffer.substr(0, pos);
      // Advance the buffer early in case we fail below.
      if (buffer[pos] === '\r') {
        ++pos;
      }
      if (buffer[pos] === '\n') {
        ++pos;
      }
      self.buffer = buffer.substr(pos);
      return line;
    }

    // 3.4 WebVTT region and WebVTT region settings syntax
    function parseRegion(input) {
      var settings = new Settings();
      parseOptions(input, function (k, v) {
        switch (k) {
          case "id":
            settings.set(k, v);
            break;
          case "width":
            settings.percent(k, v);
            break;
          case "lines":
            settings.integer(k, v);
            break;
          case "regionanchor":
          case "viewportanchor":
            var xy = v.split(',');
            if (xy.length !== 2) {
              break;
            }
            // We have to make sure both x and y parse, so use a temporary
            // settings object here.
            var anchor = new Settings();
            anchor.percent("x", xy[0]);
            anchor.percent("y", xy[1]);
            if (!anchor.has("x") || !anchor.has("y")) {
              break;
            }
            settings.set(k + "X", anchor.get("x"));
            settings.set(k + "Y", anchor.get("y"));
            break;
          case "scroll":
            settings.alt(k, v, ["up"]);
            break;
        }
      }, /=/, /\s/);

      // Create the region, using default values for any values that were not
      // specified.
      if (settings.has("id")) {
        var region = new (self.vttjs.VTTRegion || self.window.VTTRegion)();
        region.width = settings.get("width", 100);
        region.lines = settings.get("lines", 3);
        region.regionAnchorX = settings.get("regionanchorX", 0);
        region.regionAnchorY = settings.get("regionanchorY", 100);
        region.viewportAnchorX = settings.get("viewportanchorX", 0);
        region.viewportAnchorY = settings.get("viewportanchorY", 100);
        region.scroll = settings.get("scroll", "");
        // Register the region.
        self.onregion && self.onregion(region);
        // Remember the VTTRegion for later in case we parse any VTTCues that
        // reference it.
        self.regionList.push({
          id: settings.get("id"),
          region: region
        });
      }
    }

    // draft-pantos-http-live-streaming-20
    // https://tools.ietf.org/html/draft-pantos-http-live-streaming-20#section-3.5
    // 3.5 WebVTT
    function parseTimestampMap(input) {
      var settings = new Settings();
      parseOptions(input, function (k, v) {
        switch (k) {
          case "MPEGT":
            settings.integer(k + 'S', v);
            break;
          case "LOCA":
            settings.set(k + 'L', parseTimeStamp(v));
            break;
        }
      }, /[^\d]:/, /,/);
      self.ontimestampmap && self.ontimestampmap({
        "MPEGTS": settings.get("MPEGTS"),
        "LOCAL": settings.get("LOCAL")
      });
    }

    // 3.2 WebVTT metadata header syntax
    function parseHeader(input) {
      if (input.match(/X-TIMESTAMP-MAP/)) {
        // This line contains HLS X-TIMESTAMP-MAP metadata
        parseOptions(input, function (k, v) {
          switch (k) {
            case "X-TIMESTAMP-MAP":
              parseTimestampMap(v);
              break;
          }
        }, /=/);
      } else {
        parseOptions(input, function (k, v) {
          switch (k) {
            case "Region":
              // 3.3 WebVTT region metadata header syntax
              parseRegion(v);
              break;
          }
        }, /:/);
      }
    }

    // 5.1 WebVTT file parsing.
    try {
      var line;
      if (self.state === "INITIAL") {
        // We can't start parsing until we have the first line.
        if (!/\r\n|\n/.test(self.buffer)) {
          return this;
        }
        line = collectNextLine();
        var m = line.match(/^WEBVTT([ \t].*)?$/);
        if (!m || !m[0]) {
          throw new ParsingError(ParsingError.Errors.BadSignature);
        }
        self.state = "HEADER";
      }
      var alreadyCollectedLine = false;
      while (self.buffer) {
        // We can't parse a line until we have the full line.
        if (!/\r\n|\n/.test(self.buffer)) {
          return this;
        }
        if (!alreadyCollectedLine) {
          line = collectNextLine();
        } else {
          alreadyCollectedLine = false;
        }
        switch (self.state) {
          case "HEADER":
            // 13-18 - Allow a header (metadata) under the WEBVTT line.
            if (/:/.test(line)) {
              parseHeader(line);
            } else if (!line) {
              // An empty line terminates the header and starts the body (cues).
              self.state = "ID";
            }
            continue;
          case "NOTE":
            // Ignore NOTE blocks.
            if (!line) {
              self.state = "ID";
            }
            continue;
          case "ID":
            // Check for the start of NOTE blocks.
            if (/^NOTE($|[ \t])/.test(line)) {
              self.state = "NOTE";
              break;
            }
            // 19-29 - Allow any number of line terminators, then initialize new cue values.
            if (!line) {
              continue;
            }
            self.cue = new (self.vttjs.VTTCue || self.window.VTTCue)(0, 0, "");
            // Safari still uses the old middle value and won't accept center
            try {
              self.cue.align = "center";
            } catch (e) {
              self.cue.align = "middle";
            }
            self.state = "CUE";
            // 30-39 - Check if self line contains an optional identifier or timing data.
            if (line.indexOf("-->") === -1) {
              self.cue.id = line;
              continue;
            }
          // Process line as start of a cue.
          /*falls through*/
          case "CUE":
            // 40 - Collect cue timings and settings.
            try {
              parseCue(line, self.cue, self.regionList);
            } catch (e) {
              self.reportOrThrowError(e);
              // In case of an error ignore rest of the cue.
              self.cue = null;
              self.state = "BADCUE";
              continue;
            }
            self.state = "CUETEXT";
            continue;
          case "CUETEXT":
            var hasSubstring = line.indexOf("-->") !== -1;
            // 34 - If we have an empty line then report the cue.
            // 35 - If we have the special substring '-->' then report the cue,
            // but do not collect the line as we need to process the current
            // one as a new cue.
            if (!line || hasSubstring && (alreadyCollectedLine = true)) {
              // We are done parsing self cue.
              self.oncue && self.oncue(self.cue);
              self.cue = null;
              self.state = "ID";
              continue;
            }
            if (self.cue.text) {
              self.cue.text += "\n";
            }
            self.cue.text += line.replace(/\u2028/g, '\n').replace(/u2029/g, '\n');
            continue;
          case "BADCUE":
            // BADCUE
            // 54-62 - Collect and discard the remaining cue.
            if (!line) {
              self.state = "ID";
            }
            continue;
        }
      }
    } catch (e) {
      self.reportOrThrowError(e);

      // If we are currently parsing a cue, report what we have.
      if (self.state === "CUETEXT" && self.cue && self.oncue) {
        self.oncue(self.cue);
      }
      self.cue = null;
      // Enter BADWEBVTT state if header was not parsed correctly otherwise
      // another exception occurred so enter BADCUE state.
      self.state = self.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
    }
    return this;
  },
  flush: function flush() {
    var self = this;
    try {
      // Finish decoding the stream.
      self.buffer += self.decoder.decode();
      // Synthesize the end of the current cue or region.
      if (self.cue || self.state === "HEADER") {
        self.buffer += "\n\n";
        self.parse();
      }
      // If we've flushed, parsed, and we're still on the INITIAL state then
      // that means we don't have enough of the stream to parse the first
      // line.
      if (self.state === "INITIAL") {
        throw new ParsingError(ParsingError.Errors.BadSignature);
      }
    } catch (e) {
      self.reportOrThrowError(e);
    }
    self.onflush && self.onflush();
    return this;
  }
};
module.exports = WebVTT;

/***/ }),

/***/ 26456:
/***/ ((module) => {

/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var autoKeyword = "auto";
var directionSetting = {
  "": 1,
  "lr": 1,
  "rl": 1
};
var alignSetting = {
  "start": 1,
  "center": 1,
  "end": 1,
  "left": 1,
  "right": 1,
  "auto": 1,
  "line-left": 1,
  "line-right": 1
};
function findDirectionSetting(value) {
  if (typeof value !== "string") {
    return false;
  }
  var dir = directionSetting[value.toLowerCase()];
  return dir ? value.toLowerCase() : false;
}
function findAlignSetting(value) {
  if (typeof value !== "string") {
    return false;
  }
  var align = alignSetting[value.toLowerCase()];
  return align ? value.toLowerCase() : false;
}
function VTTCue(startTime, endTime, text) {
  /**
   * Shim implementation specific properties. These properties are not in
   * the spec.
   */

  // Lets us know when the VTTCue's data has changed in such a way that we need
  // to recompute its display state. This lets us compute its display state
  // lazily.
  this.hasBeenReset = false;

  /**
   * VTTCue and TextTrackCue properties
   * http://dev.w3.org/html5/webvtt/#vttcue-interface
   */

  var _id = "";
  var _pauseOnExit = false;
  var _startTime = startTime;
  var _endTime = endTime;
  var _text = text;
  var _region = null;
  var _vertical = "";
  var _snapToLines = true;
  var _line = "auto";
  var _lineAlign = "start";
  var _position = "auto";
  var _positionAlign = "auto";
  var _size = 100;
  var _align = "center";
  Object.defineProperties(this, {
    "id": {
      enumerable: true,
      get: function get() {
        return _id;
      },
      set: function set(value) {
        _id = "" + value;
      }
    },
    "pauseOnExit": {
      enumerable: true,
      get: function get() {
        return _pauseOnExit;
      },
      set: function set(value) {
        _pauseOnExit = !!value;
      }
    },
    "startTime": {
      enumerable: true,
      get: function get() {
        return _startTime;
      },
      set: function set(value) {
        if (typeof value !== "number") {
          throw new TypeError("Start time must be set to a number.");
        }
        _startTime = value;
        this.hasBeenReset = true;
      }
    },
    "endTime": {
      enumerable: true,
      get: function get() {
        return _endTime;
      },
      set: function set(value) {
        if (typeof value !== "number") {
          throw new TypeError("End time must be set to a number.");
        }
        _endTime = value;
        this.hasBeenReset = true;
      }
    },
    "text": {
      enumerable: true,
      get: function get() {
        return _text;
      },
      set: function set(value) {
        _text = "" + value;
        this.hasBeenReset = true;
      }
    },
    "region": {
      enumerable: true,
      get: function get() {
        return _region;
      },
      set: function set(value) {
        _region = value;
        this.hasBeenReset = true;
      }
    },
    "vertical": {
      enumerable: true,
      get: function get() {
        return _vertical;
      },
      set: function set(value) {
        var setting = findDirectionSetting(value);
        // Have to check for false because the setting an be an empty string.
        if (setting === false) {
          throw new SyntaxError("Vertical: an invalid or illegal direction string was specified.");
        }
        _vertical = setting;
        this.hasBeenReset = true;
      }
    },
    "snapToLines": {
      enumerable: true,
      get: function get() {
        return _snapToLines;
      },
      set: function set(value) {
        _snapToLines = !!value;
        this.hasBeenReset = true;
      }
    },
    "line": {
      enumerable: true,
      get: function get() {
        return _line;
      },
      set: function set(value) {
        if (typeof value !== "number" && value !== autoKeyword) {
          throw new SyntaxError("Line: an invalid number or illegal string was specified.");
        }
        _line = value;
        this.hasBeenReset = true;
      }
    },
    "lineAlign": {
      enumerable: true,
      get: function get() {
        return _lineAlign;
      },
      set: function set(value) {
        var setting = findAlignSetting(value);
        if (!setting) {
          console.warn("lineAlign: an invalid or illegal string was specified.");
        } else {
          _lineAlign = setting;
          this.hasBeenReset = true;
        }
      }
    },
    "position": {
      enumerable: true,
      get: function get() {
        return _position;
      },
      set: function set(value) {
        if (value < 0 || value > 100) {
          throw new Error("Position must be between 0 and 100.");
        }
        _position = value;
        this.hasBeenReset = true;
      }
    },
    "positionAlign": {
      enumerable: true,
      get: function get() {
        return _positionAlign;
      },
      set: function set(value) {
        var setting = findAlignSetting(value);
        if (!setting) {
          console.warn("positionAlign: an invalid or illegal string was specified.");
        } else {
          _positionAlign = setting;
          this.hasBeenReset = true;
        }
      }
    },
    "size": {
      enumerable: true,
      get: function get() {
        return _size;
      },
      set: function set(value) {
        if (value < 0 || value > 100) {
          throw new Error("Size must be between 0 and 100.");
        }
        _size = value;
        this.hasBeenReset = true;
      }
    },
    "align": {
      enumerable: true,
      get: function get() {
        return _align;
      },
      set: function set(value) {
        var setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError("align: an invalid or illegal alignment string was specified.");
        }
        _align = setting;
        this.hasBeenReset = true;
      }
    }
  });

  /**
   * Other <track> spec defined properties
   */

  // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
  this.displayState = undefined;
}

/**
 * VTTCue methods
 */

VTTCue.prototype.getCueAsHTML = function () {
  // Assume WebVTT.convertCueToDOMTree is on the global.
  return WebVTT.convertCueToDOMTree(window, this.text);
};
module.exports = VTTCue;

/***/ }),

/***/ 55787:
/***/ ((module) => {

/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var scrollSetting = {
  "": true,
  "up": true
};
function findScrollSetting(value) {
  if (typeof value !== "string") {
    return false;
  }
  var scroll = scrollSetting[value.toLowerCase()];
  return scroll ? value.toLowerCase() : false;
}
function isValidPercentValue(value) {
  return typeof value === "number" && value >= 0 && value <= 100;
}

// VTTRegion shim http://dev.w3.org/html5/webvtt/#vttregion-interface
function VTTRegion() {
  var _width = 100;
  var _lines = 3;
  var _regionAnchorX = 0;
  var _regionAnchorY = 100;
  var _viewportAnchorX = 0;
  var _viewportAnchorY = 100;
  var _scroll = "";
  Object.defineProperties(this, {
    "width": {
      enumerable: true,
      get: function get() {
        return _width;
      },
      set: function set(value) {
        if (!isValidPercentValue(value)) {
          throw new Error("Width must be between 0 and 100.");
        }
        _width = value;
      }
    },
    "lines": {
      enumerable: true,
      get: function get() {
        return _lines;
      },
      set: function set(value) {
        if (typeof value !== "number") {
          throw new TypeError("Lines must be set to a number.");
        }
        _lines = value;
      }
    },
    "regionAnchorY": {
      enumerable: true,
      get: function get() {
        return _regionAnchorY;
      },
      set: function set(value) {
        if (!isValidPercentValue(value)) {
          throw new Error("RegionAnchorX must be between 0 and 100.");
        }
        _regionAnchorY = value;
      }
    },
    "regionAnchorX": {
      enumerable: true,
      get: function get() {
        return _regionAnchorX;
      },
      set: function set(value) {
        if (!isValidPercentValue(value)) {
          throw new Error("RegionAnchorY must be between 0 and 100.");
        }
        _regionAnchorX = value;
      }
    },
    "viewportAnchorY": {
      enumerable: true,
      get: function get() {
        return _viewportAnchorY;
      },
      set: function set(value) {
        if (!isValidPercentValue(value)) {
          throw new Error("ViewportAnchorY must be between 0 and 100.");
        }
        _viewportAnchorY = value;
      }
    },
    "viewportAnchorX": {
      enumerable: true,
      get: function get() {
        return _viewportAnchorX;
      },
      set: function set(value) {
        if (!isValidPercentValue(value)) {
          throw new Error("ViewportAnchorX must be between 0 and 100.");
        }
        _viewportAnchorX = value;
      }
    },
    "scroll": {
      enumerable: true,
      get: function get() {
        return _scroll;
      },
      set: function set(value) {
        var setting = findScrollSetting(value);
        // Have to check for false as an empty string is a legal value.
        if (setting === false) {
          console.warn("Scroll: an invalid or illegal string was specified.");
        } else {
          _scroll = setting;
        }
      }
    }
  });
}
module.exports = VTTRegion;

/***/ }),

/***/ 98939:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(92222);
var __DEV__ = "production" !== 'production';
var warning = function warning() {};
if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
  warning = function warning(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}
module.exports = warning;

/***/ }),

/***/ 72863:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;__webpack_require__(68309);
__webpack_require__(43290);
__webpack_require__(41539);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(4129);
__webpack_require__(38880);
__webpack_require__(12419);
__webpack_require__(30489);
__webpack_require__(54747);
__webpack_require__(26699);
__webpack_require__(32023);
__webpack_require__(57327);
__webpack_require__(21249);
__webpack_require__(74819);
__webpack_require__(47941);
__webpack_require__(92222);
__webpack_require__(2707);
__webpack_require__(39714);
__webpack_require__(9653);
__webpack_require__(40561);
__webpack_require__(19601);
__webpack_require__(36210);
__webpack_require__(69600);
function _typeof2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }
/*!
 * wavesurfer.js 4.6.0 (2021-03-05)
 * https://wavesurfer-js.org
 * @license BSD-3-Clause
 */
(function webpackUniversalModuleDefinition(root, factory) {
  if (( false ? 0 : _typeof2(exports)) === 'object' && ( false ? 0 : _typeof2(module)) === 'object') module.exports = factory();else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {}
})(this, function () {
  return (/******/function () {
      // webpackBootstrap
      /******/
      var __webpack_modules__ = {
        /***/"./src/drawer.canvasentry.js": function srcDrawerCanvasentryJs(module, exports, __nested_webpack_require_2620__) {
          "use strict";

          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports.default = void 0;
          var _style = _interopRequireDefault(__nested_webpack_require_2620__( /*! ./util/style */"./src/util/style.js"));
          var _getId = _interopRequireDefault(__nested_webpack_require_2620__( /*! ./util/get-id */"./src/util/get-id.js"));
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
              default: obj
            };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) _defineProperties(Constructor.prototype, protoProps);
            if (staticProps) _defineProperties(Constructor, staticProps);
            return Constructor;
          }

          /**
           * The `CanvasEntry` class represents an element consisting of a wave `canvas`
           * and an (optional) progress wave `canvas`.
           *
           * The `MultiCanvas` renderer uses one or more `CanvasEntry` instances to
           * render a waveform, depending on the zoom level.
           */
          var CanvasEntry = /*#__PURE__*/function () {
            function CanvasEntry() {
              _classCallCheck(this, CanvasEntry);

              /**
               * The wave node
               *
               * @type {HTMLCanvasElement}
               */
              this.wave = null;
              /**
               * The wave canvas rendering context
               *
               * @type {CanvasRenderingContext2D}
               */

              this.waveCtx = null;
              /**
               * The (optional) progress wave node
               *
               * @type {HTMLCanvasElement}
               */

              this.progress = null;
              /**
               * The (optional) progress wave canvas rendering context
               *
               * @type {CanvasRenderingContext2D}
               */

              this.progressCtx = null;
              /**
               * Start of the area the canvas should render, between 0 and 1
               *
               * @type {number}
               */

              this.start = 0;
              /**
               * End of the area the canvas should render, between 0 and 1
               *
               * @type {number}
               */

              this.end = 1;
              /**
               * Unique identifier for this entry
               *
               * @type {string}
               */

              this.id = (0, _getId.default)(typeof this.constructor.name !== 'undefined' ? this.constructor.name.toLowerCase() + '_' : 'canvasentry_');
              /**
               * Canvas 2d context attributes
               *
               * @type {object}
               */

              this.canvasContextAttributes = {};
            }
            /**
             * Store the wave canvas element and create the 2D rendering context
             *
             * @param {HTMLCanvasElement} element The wave `canvas` element.
             */

            _createClass(CanvasEntry, [{
              key: "initWave",
              value: function initWave(element) {
                this.wave = element;
                this.waveCtx = this.wave.getContext('2d', this.canvasContextAttributes);
              }
              /**
               * Store the progress wave canvas element and create the 2D rendering
               * context
               *
               * @param {HTMLCanvasElement} element The progress wave `canvas` element.
               */
            }, {
              key: "initProgress",
              value: function initProgress(element) {
                this.progress = element;
                this.progressCtx = this.progress.getContext('2d', this.canvasContextAttributes);
              }
              /**
               * Update the dimensions
               *
               * @param {number} elementWidth Width of the entry
               * @param {number} totalWidth Total width of the multi canvas renderer
               * @param {number} width The new width of the element
               * @param {number} height The new height of the element
               */
            }, {
              key: "updateDimensions",
              value: function updateDimensions(elementWidth, totalWidth, width, height) {
                // where the canvas starts and ends in the waveform, represented as a
                // decimal between 0 and 1
                this.start = this.wave.offsetLeft / totalWidth || 0;
                this.end = this.start + elementWidth / totalWidth; // set wave canvas dimensions

                this.wave.width = width;
                this.wave.height = height;
                var elementSize = {
                  width: elementWidth + 'px'
                };
                (0, _style.default)(this.wave, elementSize);
                if (this.hasProgressCanvas) {
                  // set progress canvas dimensions
                  this.progress.width = width;
                  this.progress.height = height;
                  (0, _style.default)(this.progress, elementSize);
                }
              }
              /**
               * Clear the wave and progress rendering contexts
               */
            }, {
              key: "clearWave",
              value: function clearWave() {
                // wave
                this.waveCtx.clearRect(0, 0, this.waveCtx.canvas.width, this.waveCtx.canvas.height); // progress

                if (this.hasProgressCanvas) {
                  this.progressCtx.clearRect(0, 0, this.progressCtx.canvas.width, this.progressCtx.canvas.height);
                }
              }
              /**
               * Set the fill styles for wave and progress
               *
               * @param {string} waveColor Fill color for the wave canvas
               * @param {?string} progressColor Fill color for the progress canvas
               */
            }, {
              key: "setFillStyles",
              value: function setFillStyles(waveColor, progressColor) {
                this.waveCtx.fillStyle = waveColor;
                if (this.hasProgressCanvas) {
                  this.progressCtx.fillStyle = progressColor;
                }
              }
              /**
               * Draw a rectangle for wave and progress
               *
               * @param {number} x X start position
               * @param {number} y Y start position
               * @param {number} width Width of the rectangle
               * @param {number} height Height of the rectangle
               * @param {number} radius Radius of the rectangle
               */
            }, {
              key: "fillRects",
              value: function fillRects(x, y, width, height, radius) {
                this.fillRectToContext(this.waveCtx, x, y, width, height, radius);
                if (this.hasProgressCanvas) {
                  this.fillRectToContext(this.progressCtx, x, y, width, height, radius);
                }
              }
              /**
               * Draw the actual rectangle on a `canvas` element
               *
               * @param {CanvasRenderingContext2D} ctx Rendering context of target canvas
               * @param {number} x X start position
               * @param {number} y Y start position
               * @param {number} width Width of the rectangle
               * @param {number} height Height of the rectangle
               * @param {number} radius Radius of the rectangle
               */
            }, {
              key: "fillRectToContext",
              value: function fillRectToContext(ctx, x, y, width, height, radius) {
                if (!ctx) {
                  return;
                }
                if (radius) {
                  this.drawRoundedRect(ctx, x, y, width, height, radius);
                } else {
                  ctx.fillRect(x, y, width, height);
                }
              }
              /**
               * Draw a rounded rectangle on Canvas
               *
               * @param {CanvasRenderingContext2D} ctx Canvas context
               * @param {number} x X-position of the rectangle
               * @param {number} y Y-position of the rectangle
               * @param {number} width Width of the rectangle
               * @param {number} height Height of the rectangle
               * @param {number} radius Radius of the rectangle
               *
               * @return {void}
               * @example drawRoundedRect(ctx, 50, 50, 5, 10, 3)
               */
            }, {
              key: "drawRoundedRect",
              value: function drawRoundedRect(ctx, x, y, width, height, radius) {
                if (height === 0) {
                  return;
                } // peaks are float values from -1 to 1. Use absolute height values in
                // order to correctly calculate rounded rectangle coordinates

                if (height < 0) {
                  height *= -1;
                  y -= height;
                }
                ctx.beginPath();
                ctx.moveTo(x + radius, y);
                ctx.lineTo(x + width - radius, y);
                ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
                ctx.lineTo(x + width, y + height - radius);
                ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
                ctx.lineTo(x + radius, y + height);
                ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
                ctx.lineTo(x, y + radius);
                ctx.quadraticCurveTo(x, y, x + radius, y);
                ctx.closePath();
                ctx.fill();
              }
              /**
               * Render the actual wave and progress lines
               *
               * @param {number[]} peaks Array with peaks data
               * @param {number} absmax Maximum peak value (absolute)
               * @param {number} halfH Half the height of the waveform
               * @param {number} offsetY Offset to the top
               * @param {number} start The x-offset of the beginning of the area that
               * should be rendered
               * @param {number} end The x-offset of the end of the area that
               * should be rendered
               */
            }, {
              key: "drawLines",
              value: function drawLines(peaks, absmax, halfH, offsetY, start, end) {
                this.drawLineToContext(this.waveCtx, peaks, absmax, halfH, offsetY, start, end);
                if (this.hasProgressCanvas) {
                  this.drawLineToContext(this.progressCtx, peaks, absmax, halfH, offsetY, start, end);
                }
              }
              /**
               * Render the actual waveform line on a `canvas` element
               *
               * @param {CanvasRenderingContext2D} ctx Rendering context of target canvas
               * @param {number[]} peaks Array with peaks data
               * @param {number} absmax Maximum peak value (absolute)
               * @param {number} halfH Half the height of the waveform
               * @param {number} offsetY Offset to the top
               * @param {number} start The x-offset of the beginning of the area that
               * should be rendered
               * @param {number} end The x-offset of the end of the area that
               * should be rendered
               */
            }, {
              key: "drawLineToContext",
              value: function drawLineToContext(ctx, peaks, absmax, halfH, offsetY, start, end) {
                if (!ctx) {
                  return;
                }
                var length = peaks.length / 2;
                var first = Math.round(length * this.start); // use one more peak value to make sure we join peaks at ends -- unless,
                // of course, this is the last canvas

                var last = Math.round(length * this.end) + 1;
                var canvasStart = first;
                var canvasEnd = last;
                var scale = this.wave.width / (canvasEnd - canvasStart - 1); // optimization

                var halfOffset = halfH + offsetY;
                var absmaxHalf = absmax / halfH;
                ctx.beginPath();
                ctx.moveTo((canvasStart - first) * scale, halfOffset);
                ctx.lineTo((canvasStart - first) * scale, halfOffset - Math.round((peaks[2 * canvasStart] || 0) / absmaxHalf));
                var i, peak, h;
                for (i = canvasStart; i < canvasEnd; i++) {
                  peak = peaks[2 * i] || 0;
                  h = Math.round(peak / absmaxHalf);
                  ctx.lineTo((i - first) * scale + this.halfPixel, halfOffset - h);
                } // draw the bottom edge going backwards, to make a single
                // closed hull to fill

                var j = canvasEnd - 1;
                for (j; j >= canvasStart; j--) {
                  peak = peaks[2 * j + 1] || 0;
                  h = Math.round(peak / absmaxHalf);
                  ctx.lineTo((j - first) * scale + this.halfPixel, halfOffset - h);
                }
                ctx.lineTo((canvasStart - first) * scale, halfOffset - Math.round((peaks[2 * canvasStart + 1] || 0) / absmaxHalf));
                ctx.closePath();
                ctx.fill();
              }
              /**
               * Destroys this entry
               */
            }, {
              key: "destroy",
              value: function destroy() {
                this.waveCtx = null;
                this.wave = null;
                this.progressCtx = null;
                this.progress = null;
              }
              /**
               * Return image data of the wave `canvas` element
               *
               * When using a `type` of `'blob'`, this will return a `Promise` that
               * resolves with a `Blob` instance.
               *
               * @param {string} format='image/png' An optional value of a format type.
               * @param {number} quality=0.92 An optional value between 0 and 1.
               * @param {string} type='dataURL' Either 'dataURL' or 'blob'.
               * @return {string|Promise} When using the default `'dataURL'` `type` this
               * returns a data URL. When using the `'blob'` `type` this returns a
               * `Promise` that resolves with a `Blob` instance.
               */
            }, {
              key: "getImage",
              value: function getImage(format, quality, type) {
                var _this = this;
                if (type === 'blob') {
                  return new Promise(function (resolve) {
                    _this.wave.toBlob(resolve, format, quality);
                  });
                } else if (type === 'dataURL') {
                  return this.wave.toDataURL(format, quality);
                }
              }
            }]);
            return CanvasEntry;
          }();
          exports.default = CanvasEntry;
          module.exports = exports.default;

          /***/
        },

        /***/"./src/drawer.js": function srcDrawerJs(module, exports, __nested_webpack_require_18548__) {
          "use strict";

          function _typeof(obj) {
            "@babel/helpers - typeof";

            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              _typeof = function _typeof(obj) {
                return typeof obj;
              };
            } else {
              _typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
              };
            }
            return _typeof(obj);
          }
          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports.default = void 0;
          var util = _interopRequireWildcard(__nested_webpack_require_18548__( /*! ./util */"./src/util/index.js"));
          function _getRequireWildcardCache() {
            if (typeof WeakMap !== "function") return null;
            var cache = new WeakMap();
            _getRequireWildcardCache = function _getRequireWildcardCache() {
              return cache;
            };
            return cache;
          }
          function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
              return obj;
            }
            if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
              return {
                default: obj
              };
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
              return cache.get(obj);
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                if (desc && (desc.get || desc.set)) {
                  Object.defineProperty(newObj, key, desc);
                } else {
                  newObj[key] = obj[key];
                }
              }
            }
            newObj.default = obj;
            if (cache) {
              cache.set(obj, newObj);
            }
            return newObj;
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) _defineProperties(Constructor.prototype, protoProps);
            if (staticProps) _defineProperties(Constructor, staticProps);
            return Constructor;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function");
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, {
              constructor: {
                value: subClass,
                writable: true,
                configurable: true
              }
            });
            if (superClass) _setPrototypeOf(subClass, superClass);
          }
          function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
              o.__proto__ = p;
              return o;
            };
            return _setPrototypeOf(o, p);
          }
          function _createSuper(Derived) {
            var hasNativeReflectConstruct = _isNativeReflectConstruct();
            return function _createSuperInternal() {
              var Super = _getPrototypeOf(Derived),
                result;
              if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
              } else {
                result = Super.apply(this, arguments);
              }
              return _possibleConstructorReturn(this, result);
            };
          }
          function _possibleConstructorReturn(self, call) {
            if (call && (_typeof(call) === "object" || typeof call === "function")) {
              return call;
            }
            return _assertThisInitialized(self);
          }
          function _assertThisInitialized(self) {
            if (self === void 0) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return self;
          }
          function _isNativeReflectConstruct() {
            if (typeof Reflect === "undefined" || !Reflect.construct) return false;
            if (Reflect.construct.sham) return false;
            if (typeof Proxy === "function") return true;
            try {
              Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
              return true;
            } catch (e) {
              return false;
            }
          }
          function _getPrototypeOf(o) {
            _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
              return o.__proto__ || Object.getPrototypeOf(o);
            };
            return _getPrototypeOf(o);
          }

          /**
           * Parent class for renderers
           *
           * @extends {Observer}
           */
          var Drawer = /*#__PURE__*/function (_util$Observer) {
            _inherits(Drawer, _util$Observer);
            var _super = _createSuper(Drawer);

            /**
             * @param {HTMLElement} container The container node of the wavesurfer instance
             * @param {WavesurferParams} params The wavesurfer initialisation options
             */
            function Drawer(container, params) {
              var _this;
              _classCallCheck(this, Drawer);
              _this = _super.call(this);
              _this.container = container;
              /**
               * @type {WavesurferParams}
               */

              _this.params = params;
              /**
               * The width of the renderer
               * @type {number}
               */

              _this.width = 0;
              /**
               * The height of the renderer
               * @type {number}
               */

              _this.height = params.height * _this.params.pixelRatio;
              _this.lastPos = 0;
              /**
               * The `<wave>` element which is added to the container
               * @type {HTMLElement}
               */

              _this.wrapper = null;
              return _this;
            }
            /**
             * Alias of `util.style`
             *
             * @param {HTMLElement} el The element that the styles will be applied to
             * @param {Object} styles The map of propName: attribute, both are used as-is
             * @return {HTMLElement} el
             */

            _createClass(Drawer, [{
              key: "style",
              value: function style(el, styles) {
                return util.style(el, styles);
              }
              /**
               * Create the wrapper `<wave>` element, style it and set up the events for
               * interaction
               */
            }, {
              key: "createWrapper",
              value: function createWrapper() {
                this.wrapper = this.container.appendChild(document.createElement('wave'));
                this.style(this.wrapper, {
                  display: 'block',
                  position: 'relative',
                  userSelect: 'none',
                  webkitUserSelect: 'none',
                  height: this.params.height + 'px'
                });
                if (this.params.fillParent || this.params.scrollParent) {
                  this.style(this.wrapper, {
                    width: '100%',
                    overflowX: this.params.hideScrollbar ? 'hidden' : 'auto',
                    overflowY: 'hidden'
                  });
                }
                this.setupWrapperEvents();
              }
              /**
               * Handle click event
               *
               * @param {Event} e Click event
               * @param {?boolean} noPrevent Set to true to not call `e.preventDefault()`
               * @return {number} Playback position from 0 to 1
               */
            }, {
              key: "handleEvent",
              value: function handleEvent(e, noPrevent) {
                !noPrevent && e.preventDefault();
                var clientX = e.targetTouches ? e.targetTouches[0].clientX : e.clientX;
                var bbox = this.wrapper.getBoundingClientRect();
                var nominalWidth = this.width;
                var parentWidth = this.getWidth();
                var progress;
                if (!this.params.fillParent && nominalWidth < parentWidth) {
                  progress = (this.params.rtl ? bbox.right - clientX : clientX - bbox.left) * (this.params.pixelRatio / nominalWidth) || 0;
                } else {
                  progress = ((this.params.rtl ? bbox.right - clientX : clientX - bbox.left) + this.wrapper.scrollLeft) / this.wrapper.scrollWidth || 0;
                }
                return util.clamp(progress, 0, 1);
              }
            }, {
              key: "setupWrapperEvents",
              value: function setupWrapperEvents() {
                var _this2 = this;
                this.wrapper.addEventListener('click', function (e) {
                  var scrollbarHeight = _this2.wrapper.offsetHeight - _this2.wrapper.clientHeight;
                  if (scrollbarHeight !== 0) {
                    // scrollbar is visible.  Check if click was on it
                    var bbox = _this2.wrapper.getBoundingClientRect();
                    if (e.clientY >= bbox.bottom - scrollbarHeight) {
                      // ignore mousedown as it was on the scrollbar
                      return;
                    }
                  }
                  if (_this2.params.interact) {
                    _this2.fireEvent('click', e, _this2.handleEvent(e));
                  }
                });
                this.wrapper.addEventListener('dblclick', function (e) {
                  if (_this2.params.interact) {
                    _this2.fireEvent('dblclick', e, _this2.handleEvent(e));
                  }
                });
                this.wrapper.addEventListener('scroll', function (e) {
                  return _this2.fireEvent('scroll', e);
                });
              }
              /**
               * Draw peaks on the canvas
               *
               * @param {number[]|Number.<Array[]>} peaks Can also be an array of arrays
               * for split channel rendering
               * @param {number} length The width of the area that should be drawn
               * @param {number} start The x-offset of the beginning of the area that
               * should be rendered
               * @param {number} end The x-offset of the end of the area that should be
               * rendered
               */
            }, {
              key: "drawPeaks",
              value: function drawPeaks(peaks, length, start, end) {
                if (!this.setWidth(length)) {
                  this.clearWave();
                }
                this.params.barWidth ? this.drawBars(peaks, 0, start, end) : this.drawWave(peaks, 0, start, end);
              }
              /**
               * Scroll to the beginning
               */
            }, {
              key: "resetScroll",
              value: function resetScroll() {
                if (this.wrapper !== null) {
                  this.wrapper.scrollLeft = 0;
                }
              }
              /**
               * Recenter the view-port at a certain percent of the waveform
               *
               * @param {number} percent Value from 0 to 1 on the waveform
               */
            }, {
              key: "recenter",
              value: function recenter(percent) {
                var position = this.wrapper.scrollWidth * percent;
                this.recenterOnPosition(position, true);
              }
              /**
               * Recenter the view-port on a position, either scroll there immediately or
               * in steps of 5 pixels
               *
               * @param {number} position X-offset in pixels
               * @param {boolean} immediate Set to true to immediately scroll somewhere
               */
            }, {
              key: "recenterOnPosition",
              value: function recenterOnPosition(position, immediate) {
                var scrollLeft = this.wrapper.scrollLeft;
                var half = ~~(this.wrapper.clientWidth / 2);
                var maxScroll = this.wrapper.scrollWidth - this.wrapper.clientWidth;
                var target = position - half;
                var offset = target - scrollLeft;
                if (maxScroll == 0) {
                  // no need to continue if scrollbar is not there
                  return;
                } // if the cursor is currently visible...

                if (!immediate && -half <= offset && offset < half) {
                  // set rate at which waveform is centered
                  var rate = this.params.autoCenterRate; // make rate depend on width of view and length of waveform

                  rate /= half;
                  rate *= maxScroll;
                  offset = Math.max(-rate, Math.min(rate, offset));
                  target = scrollLeft + offset;
                } // limit target to valid range (0 to maxScroll)

                target = Math.max(0, Math.min(maxScroll, target)); // no use attempting to scroll if we're not moving

                if (target != scrollLeft) {
                  this.wrapper.scrollLeft = target;
                }
              }
              /**
               * Get the current scroll position in pixels
               *
               * @return {number} Horizontal scroll position in pixels
               */
            }, {
              key: "getScrollX",
              value: function getScrollX() {
                var x = 0;
                if (this.wrapper) {
                  var pixelRatio = this.params.pixelRatio;
                  x = Math.round(this.wrapper.scrollLeft * pixelRatio); // In cases of elastic scroll (safari with mouse wheel) you can
                  // scroll beyond the limits of the container
                  // Calculate and floor the scrollable extent to make sure an out
                  // of bounds value is not returned
                  // Ticket #1312

                  if (this.params.scrollParent) {
                    var maxScroll = ~~(this.wrapper.scrollWidth * pixelRatio - this.getWidth());
                    x = Math.min(maxScroll, Math.max(0, x));
                  }
                }
                return x;
              }
              /**
               * Get the width of the container
               *
               * @return {number} The width of the container
               */
            }, {
              key: "getWidth",
              value: function getWidth() {
                return Math.round(this.container.clientWidth * this.params.pixelRatio);
              }
              /**
               * Set the width of the container
               *
               * @param {number} width The new width of the container
               * @return {boolean} Whether the width of the container was updated or not
               */
            }, {
              key: "setWidth",
              value: function setWidth(width) {
                if (this.width == width) {
                  return false;
                }
                this.width = width;
                if (this.params.fillParent || this.params.scrollParent) {
                  this.style(this.wrapper, {
                    width: ''
                  });
                } else {
                  this.style(this.wrapper, {
                    width: ~~(this.width / this.params.pixelRatio) + 'px'
                  });
                }
                this.updateSize();
                return true;
              }
              /**
               * Set the height of the container
               *
               * @param {number} height The new height of the container.
               * @return {boolean} Whether the height of the container was updated or not
               */
            }, {
              key: "setHeight",
              value: function setHeight(height) {
                if (height == this.height) {
                  return false;
                }
                this.height = height;
                this.style(this.wrapper, {
                  height: ~~(this.height / this.params.pixelRatio) + 'px'
                });
                this.updateSize();
                return true;
              }
              /**
               * Called by wavesurfer when progress should be rendered
               *
               * @param {number} progress From 0 to 1
               */
            }, {
              key: "progress",
              value: function progress(_progress) {
                var minPxDelta = 1 / this.params.pixelRatio;
                var pos = Math.round(_progress * this.width) * minPxDelta;
                if (pos < this.lastPos || pos - this.lastPos >= minPxDelta) {
                  this.lastPos = pos;
                  if (this.params.scrollParent && this.params.autoCenter) {
                    var newPos = ~~(this.wrapper.scrollWidth * _progress);
                    this.recenterOnPosition(newPos, this.params.autoCenterImmediately);
                  }
                  this.updateProgress(pos);
                }
              }
              /**
               * This is called when wavesurfer is destroyed
               */
            }, {
              key: "destroy",
              value: function destroy() {
                this.unAll();
                if (this.wrapper) {
                  if (this.wrapper.parentNode == this.container) {
                    this.container.removeChild(this.wrapper);
                  }
                  this.wrapper = null;
                }
              }
              /* Renderer-specific methods */

              /**
               * Called after cursor related params have changed.
               *
               * @abstract
               */
            }, {
              key: "updateCursor",
              value: function updateCursor() {}
              /**
               * Called when the size of the container changes so the renderer can adjust
               *
               * @abstract
               */
            }, {
              key: "updateSize",
              value: function updateSize() {}
              /**
               * Draw a waveform with bars
               *
               * @abstract
               * @param {number[]|Number.<Array[]>} peaks Can also be an array of arrays for split channel
               * rendering
               * @param {number} channelIndex The index of the current channel. Normally
               * should be 0
               * @param {number} start The x-offset of the beginning of the area that
               * should be rendered
               * @param {number} end The x-offset of the end of the area that should be
               * rendered
               */
            }, {
              key: "drawBars",
              value: function drawBars(peaks, channelIndex, start, end) {}
              /**
               * Draw a waveform
               *
               * @abstract
               * @param {number[]|Number.<Array[]>} peaks Can also be an array of arrays for split channel
               * rendering
               * @param {number} channelIndex The index of the current channel. Normally
               * should be 0
               * @param {number} start The x-offset of the beginning of the area that
               * should be rendered
               * @param {number} end The x-offset of the end of the area that should be
               * rendered
               */
            }, {
              key: "drawWave",
              value: function drawWave(peaks, channelIndex, start, end) {}
              /**
               * Clear the waveform
               *
               * @abstract
               */
            }, {
              key: "clearWave",
              value: function clearWave() {}
              /**
               * Render the new progress
               *
               * @abstract
               * @param {number} position X-Offset of progress position in pixels
               */
            }, {
              key: "updateProgress",
              value: function updateProgress(position) {}
            }]);
            return Drawer;
          }(util.Observer);
          exports.default = Drawer;
          module.exports = exports.default;

          /***/
        },

        /***/"./src/drawer.multicanvas.js": function srcDrawerMulticanvasJs(module, exports, __nested_webpack_require_40294__) {
          "use strict";

          function _typeof(obj) {
            "@babel/helpers - typeof";

            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              _typeof = function _typeof(obj) {
                return typeof obj;
              };
            } else {
              _typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
              };
            }
            return _typeof(obj);
          }
          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports.default = void 0;
          var _drawer = _interopRequireDefault(__nested_webpack_require_40294__( /*! ./drawer */"./src/drawer.js"));
          var util = _interopRequireWildcard(__nested_webpack_require_40294__( /*! ./util */"./src/util/index.js"));
          var _drawer2 = _interopRequireDefault(__nested_webpack_require_40294__( /*! ./drawer.canvasentry */"./src/drawer.canvasentry.js"));
          function _getRequireWildcardCache() {
            if (typeof WeakMap !== "function") return null;
            var cache = new WeakMap();
            _getRequireWildcardCache = function _getRequireWildcardCache() {
              return cache;
            };
            return cache;
          }
          function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
              return obj;
            }
            if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
              return {
                default: obj
              };
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
              return cache.get(obj);
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                if (desc && (desc.get || desc.set)) {
                  Object.defineProperty(newObj, key, desc);
                } else {
                  newObj[key] = obj[key];
                }
              }
            }
            newObj.default = obj;
            if (cache) {
              cache.set(obj, newObj);
            }
            return newObj;
          }
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
              default: obj
            };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) _defineProperties(Constructor.prototype, protoProps);
            if (staticProps) _defineProperties(Constructor, staticProps);
            return Constructor;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function");
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, {
              constructor: {
                value: subClass,
                writable: true,
                configurable: true
              }
            });
            if (superClass) _setPrototypeOf(subClass, superClass);
          }
          function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
              o.__proto__ = p;
              return o;
            };
            return _setPrototypeOf(o, p);
          }
          function _createSuper(Derived) {
            var hasNativeReflectConstruct = _isNativeReflectConstruct();
            return function _createSuperInternal() {
              var Super = _getPrototypeOf(Derived),
                result;
              if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
              } else {
                result = Super.apply(this, arguments);
              }
              return _possibleConstructorReturn(this, result);
            };
          }
          function _possibleConstructorReturn(self, call) {
            if (call && (_typeof(call) === "object" || typeof call === "function")) {
              return call;
            }
            return _assertThisInitialized(self);
          }
          function _assertThisInitialized(self) {
            if (self === void 0) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return self;
          }
          function _isNativeReflectConstruct() {
            if (typeof Reflect === "undefined" || !Reflect.construct) return false;
            if (Reflect.construct.sham) return false;
            if (typeof Proxy === "function") return true;
            try {
              Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
              return true;
            } catch (e) {
              return false;
            }
          }
          function _getPrototypeOf(o) {
            _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
              return o.__proto__ || Object.getPrototypeOf(o);
            };
            return _getPrototypeOf(o);
          }

          /**
           * MultiCanvas renderer for wavesurfer. Is currently the default and sole
           * builtin renderer.
           *
           * A `MultiCanvas` consists of one or more `CanvasEntry` instances, depending
           * on the zoom level.
           */
          var MultiCanvas = /*#__PURE__*/function (_Drawer) {
            _inherits(MultiCanvas, _Drawer);
            var _super = _createSuper(MultiCanvas);

            /**
             * @param {HTMLElement} container The container node of the wavesurfer instance
             * @param {WavesurferParams} params The wavesurfer initialisation options
             */
            function MultiCanvas(container, params) {
              var _this;
              _classCallCheck(this, MultiCanvas);
              _this = _super.call(this, container, params);
              /**
               * @type {number}
               */

              _this.maxCanvasWidth = params.maxCanvasWidth;
              /**
               * @type {number}
               */

              _this.maxCanvasElementWidth = Math.round(params.maxCanvasWidth / params.pixelRatio);
              /**
               * Whether or not the progress wave is rendered. If the `waveColor`
               * and `progressColor` are the same color it is not.
               *
               * @type {boolean}
               */

              _this.hasProgressCanvas = params.waveColor != params.progressColor;
              /**
               * @type {number}
               */

              _this.halfPixel = 0.5 / params.pixelRatio;
              /**
               * List of `CanvasEntry` instances.
               *
               * @type {Array}
               */

              _this.canvases = [];
              /**
               * @type {HTMLElement}
               */

              _this.progressWave = null;
              /**
               * Class used to generate entries.
               *
               * @type {function}
               */

              _this.EntryClass = _drawer2.default;
              /**
               * Canvas 2d context attributes.
               *
               * @type {object}
               */

              _this.canvasContextAttributes = params.drawingContextAttributes;
              /**
               * Overlap added between entries to prevent vertical white stripes
               * between `canvas` elements.
               *
               * @type {number}
               */

              _this.overlap = 2 * Math.ceil(params.pixelRatio / 2);
              /**
               * The radius of the wave bars. Makes bars rounded
               *
               * @type {number}
               */

              _this.barRadius = params.barRadius || 0;
              return _this;
            }
            /**
             * Initialize the drawer
             */

            _createClass(MultiCanvas, [{
              key: "init",
              value: function init() {
                this.createWrapper();
                this.createElements();
              }
              /**
               * Create the canvas elements and style them
               *
               */
            }, {
              key: "createElements",
              value: function createElements() {
                this.progressWave = this.wrapper.appendChild(this.style(document.createElement('wave'), {
                  position: 'absolute',
                  zIndex: 3,
                  left: 0,
                  top: 0,
                  bottom: 0,
                  overflow: 'hidden',
                  width: '0',
                  display: 'none',
                  boxSizing: 'border-box',
                  borderRightStyle: 'solid',
                  pointerEvents: 'none'
                }));
                this.addCanvas();
                this.updateCursor();
              }
              /**
               * Update cursor style
               */
            }, {
              key: "updateCursor",
              value: function updateCursor() {
                this.style(this.progressWave, {
                  borderRightWidth: this.params.cursorWidth + 'px',
                  borderRightColor: this.params.cursorColor
                });
              }
              /**
               * Adjust to the updated size by adding or removing canvases
               */
            }, {
              key: "updateSize",
              value: function updateSize() {
                var _this2 = this;
                var totalWidth = Math.round(this.width / this.params.pixelRatio);
                var requiredCanvases = Math.ceil(totalWidth / (this.maxCanvasElementWidth + this.overlap)); // add required canvases

                while (this.canvases.length < requiredCanvases) {
                  this.addCanvas();
                } // remove older existing canvases, if any

                while (this.canvases.length > requiredCanvases) {
                  this.removeCanvas();
                }
                var canvasWidth = this.maxCanvasWidth + this.overlap;
                var lastCanvas = this.canvases.length - 1;
                this.canvases.forEach(function (entry, i) {
                  if (i == lastCanvas) {
                    canvasWidth = _this2.width - _this2.maxCanvasWidth * lastCanvas;
                  }
                  _this2.updateDimensions(entry, canvasWidth, _this2.height);
                  entry.clearWave();
                });
              }
              /**
               * Add a canvas to the canvas list
               *
               */
            }, {
              key: "addCanvas",
              value: function addCanvas() {
                var entry = new this.EntryClass();
                entry.canvasContextAttributes = this.canvasContextAttributes;
                entry.hasProgressCanvas = this.hasProgressCanvas;
                entry.halfPixel = this.halfPixel;
                var leftOffset = this.maxCanvasElementWidth * this.canvases.length; // wave

                entry.initWave(this.wrapper.appendChild(this.style(document.createElement('canvas'), {
                  position: 'absolute',
                  zIndex: 2,
                  left: leftOffset + 'px',
                  top: 0,
                  bottom: 0,
                  height: '100%',
                  pointerEvents: 'none'
                }))); // progress

                if (this.hasProgressCanvas) {
                  entry.initProgress(this.progressWave.appendChild(this.style(document.createElement('canvas'), {
                    position: 'absolute',
                    left: leftOffset + 'px',
                    top: 0,
                    bottom: 0,
                    height: '100%'
                  })));
                }
                this.canvases.push(entry);
              }
              /**
               * Pop single canvas from the list
               *
               */
            }, {
              key: "removeCanvas",
              value: function removeCanvas() {
                var lastEntry = this.canvases[this.canvases.length - 1]; // wave

                lastEntry.wave.parentElement.removeChild(lastEntry.wave); // progress

                if (this.hasProgressCanvas) {
                  lastEntry.progress.parentElement.removeChild(lastEntry.progress);
                } // cleanup

                if (lastEntry) {
                  lastEntry.destroy();
                  lastEntry = null;
                }
                this.canvases.pop();
              }
              /**
               * Update the dimensions of a canvas element
               *
               * @param {CanvasEntry} entry Target entry
               * @param {number} width The new width of the element
               * @param {number} height The new height of the element
               */
            }, {
              key: "updateDimensions",
              value: function updateDimensions(entry, width, height) {
                var elementWidth = Math.round(width / this.params.pixelRatio);
                var totalWidth = Math.round(this.width / this.params.pixelRatio); // update canvas dimensions

                entry.updateDimensions(elementWidth, totalWidth, width, height); // style element

                this.style(this.progressWave, {
                  display: 'block'
                });
              }
              /**
               * Clear the whole multi-canvas
               */
            }, {
              key: "clearWave",
              value: function clearWave() {
                var _this3 = this;
                util.frame(function () {
                  _this3.canvases.forEach(function (entry) {
                    return entry.clearWave();
                  });
                })();
              }
              /**
               * Draw a waveform with bars
               *
               * @param {number[]|Number.<Array[]>} peaks Can also be an array of arrays
               * for split channel rendering
               * @param {number} channelIndex The index of the current channel. Normally
               * should be 0. Must be an integer.
               * @param {number} start The x-offset of the beginning of the area that
               * should be rendered
               * @param {number} end The x-offset of the end of the area that should be
               * rendered
               * @returns {void}
               */
            }, {
              key: "drawBars",
              value: function drawBars(peaks, channelIndex, start, end) {
                var _this4 = this;
                return this.prepareDraw(peaks, channelIndex, start, end, function (_ref) {
                  var absmax = _ref.absmax,
                    hasMinVals = _ref.hasMinVals,
                    height = _ref.height,
                    offsetY = _ref.offsetY,
                    halfH = _ref.halfH,
                    peaks = _ref.peaks,
                    ch = _ref.channelIndex;

                  // if drawBars was called within ws.empty we don't pass a start and
                  // don't want anything to happen
                  if (start === undefined) {
                    return;
                  } // Skip every other value if there are negatives.

                  var peakIndexScale = hasMinVals ? 2 : 1;
                  var length = peaks.length / peakIndexScale;
                  var bar = _this4.params.barWidth * _this4.params.pixelRatio;
                  var gap = _this4.params.barGap === null ? Math.max(_this4.params.pixelRatio, ~~(bar / 2)) : Math.max(_this4.params.pixelRatio, _this4.params.barGap * _this4.params.pixelRatio);
                  var step = bar + gap;
                  var scale = length / _this4.width;
                  var first = start;
                  var last = end;
                  var i = first;
                  for (i; i < last; i += step) {
                    var peak = peaks[Math.floor(i * scale * peakIndexScale)] || 0;
                    var h = Math.round(peak / absmax * halfH);
                    /* in case of silences, allow the user to specify that we
                     * always draw *something* (normally a 1px high bar) */

                    if (h == 0 && _this4.params.barMinHeight) h = _this4.params.barMinHeight;
                    _this4.fillRect(i + _this4.halfPixel, halfH - h + offsetY, bar + _this4.halfPixel, h * 2, _this4.barRadius, ch);
                  }
                });
              }
              /**
               * Draw a waveform
               *
               * @param {number[]|Number.<Array[]>} peaks Can also be an array of arrays
               * for split channel rendering
               * @param {number} channelIndex The index of the current channel. Normally
               * should be 0
               * @param {number?} start The x-offset of the beginning of the area that
               * should be rendered (If this isn't set only a flat line is rendered)
               * @param {number?} end The x-offset of the end of the area that should be
               * rendered
               * @returns {void}
               */
            }, {
              key: "drawWave",
              value: function drawWave(peaks, channelIndex, start, end) {
                var _this5 = this;
                return this.prepareDraw(peaks, channelIndex, start, end, function (_ref2) {
                  var absmax = _ref2.absmax,
                    hasMinVals = _ref2.hasMinVals,
                    height = _ref2.height,
                    offsetY = _ref2.offsetY,
                    halfH = _ref2.halfH,
                    peaks = _ref2.peaks,
                    channelIndex = _ref2.channelIndex;
                  if (!hasMinVals) {
                    var reflectedPeaks = [];
                    var len = peaks.length;
                    var i = 0;
                    for (i; i < len; i++) {
                      reflectedPeaks[2 * i] = peaks[i];
                      reflectedPeaks[2 * i + 1] = -peaks[i];
                    }
                    peaks = reflectedPeaks;
                  } // if drawWave was called within ws.empty we don't pass a start and
                  // end and simply want a flat line

                  if (start !== undefined) {
                    _this5.drawLine(peaks, absmax, halfH, offsetY, start, end, channelIndex);
                  } // always draw a median line

                  _this5.fillRect(0, halfH + offsetY - _this5.halfPixel, _this5.width, _this5.halfPixel, _this5.barRadius, channelIndex);
                });
              }
              /**
               * Tell the canvas entries to render their portion of the waveform
               *
               * @param {number[]} peaks Peaks data
               * @param {number} absmax Maximum peak value (absolute)
               * @param {number} halfH Half the height of the waveform
               * @param {number} offsetY Offset to the top
               * @param {number} start The x-offset of the beginning of the area that
               * should be rendered
               * @param {number} end The x-offset of the end of the area that
               * should be rendered
               * @param {channelIndex} channelIndex The channel index of the line drawn
               */
            }, {
              key: "drawLine",
              value: function drawLine(peaks, absmax, halfH, offsetY, start, end, channelIndex) {
                var _this6 = this;
                var _ref3 = this.params.splitChannelsOptions.channelColors[channelIndex] || {},
                  waveColor = _ref3.waveColor,
                  progressColor = _ref3.progressColor;
                this.canvases.forEach(function (entry, i) {
                  _this6.setFillStyles(entry, waveColor, progressColor);
                  entry.drawLines(peaks, absmax, halfH, offsetY, start, end);
                });
              }
              /**
               * Draw a rectangle on the multi-canvas
               *
               * @param {number} x X-position of the rectangle
               * @param {number} y Y-position of the rectangle
               * @param {number} width Width of the rectangle
               * @param {number} height Height of the rectangle
               * @param {number} radius Radius of the rectangle
               * @param {channelIndex} channelIndex The channel index of the bar drawn
               */
            }, {
              key: "fillRect",
              value: function fillRect(x, y, width, height, radius, channelIndex) {
                var startCanvas = Math.floor(x / this.maxCanvasWidth);
                var endCanvas = Math.min(Math.ceil((x + width) / this.maxCanvasWidth) + 1, this.canvases.length);
                var i = startCanvas;
                for (i; i < endCanvas; i++) {
                  var entry = this.canvases[i];
                  var leftOffset = i * this.maxCanvasWidth;
                  var intersection = {
                    x1: Math.max(x, i * this.maxCanvasWidth),
                    y1: y,
                    x2: Math.min(x + width, i * this.maxCanvasWidth + entry.wave.width),
                    y2: y + height
                  };
                  if (intersection.x1 < intersection.x2) {
                    var _ref4 = this.params.splitChannelsOptions.channelColors[channelIndex] || {},
                      waveColor = _ref4.waveColor,
                      progressColor = _ref4.progressColor;
                    this.setFillStyles(entry, waveColor, progressColor);
                    entry.fillRects(intersection.x1 - leftOffset, intersection.y1, intersection.x2 - intersection.x1, intersection.y2 - intersection.y1, radius);
                  }
                }
              }
              /**
               * Returns whether to hide the channel from being drawn based on params.
               *
               * @param {number} channelIndex The index of the current channel.
               * @returns {bool} True to hide the channel, false to draw.
               */
            }, {
              key: "hideChannel",
              value: function hideChannel(channelIndex) {
                return this.params.splitChannels && this.params.splitChannelsOptions.filterChannels.includes(channelIndex);
              }
              /**
               * Performs preparation tasks and calculations which are shared by `drawBars`
               * and `drawWave`
               *
               * @param {number[]|Number.<Array[]>} peaks Can also be an array of arrays for
               * split channel rendering
               * @param {number} channelIndex The index of the current channel. Normally
               * should be 0
               * @param {number?} start The x-offset of the beginning of the area that
               * should be rendered. If this isn't set only a flat line is rendered
               * @param {number?} end The x-offset of the end of the area that should be
               * rendered
               * @param {function} fn The render function to call, e.g. `drawWave`
               * @param {number} drawIndex The index of the current channel after filtering.
               * @param {number?} normalizedMax Maximum modulation value across channels for use with relativeNormalization. Ignored when undefined
               * @returns {void}
               */
            }, {
              key: "prepareDraw",
              value: function prepareDraw(peaks, channelIndex, start, end, fn, drawIndex, normalizedMax) {
                var _this7 = this;
                return util.frame(function () {
                  // Split channels and call this function with the channelIndex set
                  if (peaks[0] instanceof Array) {
                    var channels = peaks;
                    if (_this7.params.splitChannels) {
                      var filteredChannels = channels.filter(function (c, i) {
                        return !_this7.hideChannel(i);
                      });
                      if (!_this7.params.splitChannelsOptions.overlay) {
                        _this7.setHeight(Math.max(filteredChannels.length, 1) * _this7.params.height * _this7.params.pixelRatio);
                      }
                      var overallAbsMax;
                      if (_this7.params.splitChannelsOptions && _this7.params.splitChannelsOptions.relativeNormalization) {
                        // calculate maximum peak across channels to use for normalization
                        overallAbsMax = util.max(channels.map(function (channelPeaks) {
                          return util.absMax(channelPeaks);
                        }));
                      }
                      return channels.forEach(function (channelPeaks, i) {
                        return _this7.prepareDraw(channelPeaks, i, start, end, fn, filteredChannels.indexOf(channelPeaks), overallAbsMax);
                      });
                    }
                    peaks = channels[0];
                  } // Return and do not draw channel peaks if hidden.

                  if (_this7.hideChannel(channelIndex)) {
                    return;
                  } // calculate maximum modulation value, either from the barHeight
                  // parameter or if normalize=true from the largest value in the peak
                  // set

                  var absmax = 1 / _this7.params.barHeight;
                  if (_this7.params.normalize) {
                    absmax = normalizedMax === undefined ? util.absMax(peaks) : normalizedMax;
                  } // Bar wave draws the bottom only as a reflection of the top,
                  // so we don't need negative values

                  var hasMinVals = [].some.call(peaks, function (val) {
                    return val < 0;
                  });
                  var height = _this7.params.height * _this7.params.pixelRatio;
                  var halfH = height / 2;
                  var offsetY = height * drawIndex || 0; // Override offsetY if overlay is true

                  if (_this7.params.splitChannelsOptions && _this7.params.splitChannelsOptions.overlay) {
                    offsetY = 0;
                  }
                  return fn({
                    absmax: absmax,
                    hasMinVals: hasMinVals,
                    height: height,
                    offsetY: offsetY,
                    halfH: halfH,
                    peaks: peaks,
                    channelIndex: channelIndex
                  });
                })();
              }
              /**
               * Set the fill styles for a certain entry (wave and progress)
               *
               * @param {CanvasEntry} entry Target entry
               * @param {string} waveColor Wave color to draw this entry
               * @param {string} progressColor Progress color to draw this entry
               */
            }, {
              key: "setFillStyles",
              value: function setFillStyles(entry) {
                var waveColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.params.waveColor;
                var progressColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.params.progressColor;
                entry.setFillStyles(waveColor, progressColor);
              }
              /**
               * Return image data of the multi-canvas
               *
               * When using a `type` of `'blob'`, this will return a `Promise`.
               *
               * @param {string} format='image/png' An optional value of a format type.
               * @param {number} quality=0.92 An optional value between 0 and 1.
               * @param {string} type='dataURL' Either 'dataURL' or 'blob'.
               * @return {string|string[]|Promise} When using the default `'dataURL'`
               * `type` this returns a single data URL or an array of data URLs,
               * one for each canvas. When using the `'blob'` `type` this returns a
               * `Promise` that resolves with an array of `Blob` instances, one for each
               * canvas.
               */
            }, {
              key: "getImage",
              value: function getImage(format, quality, type) {
                if (type === 'blob') {
                  return Promise.all(this.canvases.map(function (entry) {
                    return entry.getImage(format, quality, type);
                  }));
                } else if (type === 'dataURL') {
                  var images = this.canvases.map(function (entry) {
                    return entry.getImage(format, quality, type);
                  });
                  return images.length > 1 ? images : images[0];
                }
              }
              /**
               * Render the new progress
               *
               * @param {number} position X-offset of progress position in pixels
               */
            }, {
              key: "updateProgress",
              value: function updateProgress(position) {
                this.style(this.progressWave, {
                  width: position + 'px'
                });
              }
            }]);
            return MultiCanvas;
          }(_drawer.default);
          exports.default = MultiCanvas;
          module.exports = exports.default;

          /***/
        },

        /***/"./src/mediaelement-webaudio.js": function srcMediaelementWebaudioJs(module, exports, __nested_webpack_require_71067__) {
          "use strict";

          function _typeof(obj) {
            "@babel/helpers - typeof";

            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              _typeof = function _typeof(obj) {
                return typeof obj;
              };
            } else {
              _typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
              };
            }
            return _typeof(obj);
          }
          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports.default = void 0;
          var _mediaelement = _interopRequireDefault(__nested_webpack_require_71067__( /*! ./mediaelement */"./src/mediaelement.js"));
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
              default: obj
            };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) _defineProperties(Constructor.prototype, protoProps);
            if (staticProps) _defineProperties(Constructor, staticProps);
            return Constructor;
          }
          function _get(target, property, receiver) {
            if (typeof Reflect !== "undefined" && Reflect.get) {
              _get = Reflect.get;
            } else {
              _get = function _get(target, property, receiver) {
                var base = _superPropBase(target, property);
                if (!base) return;
                var desc = Object.getOwnPropertyDescriptor(base, property);
                if (desc.get) {
                  return desc.get.call(receiver);
                }
                return desc.value;
              };
            }
            return _get(target, property, receiver || target);
          }
          function _superPropBase(object, property) {
            while (!Object.prototype.hasOwnProperty.call(object, property)) {
              object = _getPrototypeOf(object);
              if (object === null) break;
            }
            return object;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function");
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, {
              constructor: {
                value: subClass,
                writable: true,
                configurable: true
              }
            });
            if (superClass) _setPrototypeOf(subClass, superClass);
          }
          function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
              o.__proto__ = p;
              return o;
            };
            return _setPrototypeOf(o, p);
          }
          function _createSuper(Derived) {
            var hasNativeReflectConstruct = _isNativeReflectConstruct();
            return function _createSuperInternal() {
              var Super = _getPrototypeOf(Derived),
                result;
              if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
              } else {
                result = Super.apply(this, arguments);
              }
              return _possibleConstructorReturn(this, result);
            };
          }
          function _possibleConstructorReturn(self, call) {
            if (call && (_typeof(call) === "object" || typeof call === "function")) {
              return call;
            }
            return _assertThisInitialized(self);
          }
          function _assertThisInitialized(self) {
            if (self === void 0) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return self;
          }
          function _isNativeReflectConstruct() {
            if (typeof Reflect === "undefined" || !Reflect.construct) return false;
            if (Reflect.construct.sham) return false;
            if (typeof Proxy === "function") return true;
            try {
              Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
              return true;
            } catch (e) {
              return false;
            }
          }
          function _getPrototypeOf(o) {
            _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
              return o.__proto__ || Object.getPrototypeOf(o);
            };
            return _getPrototypeOf(o);
          }

          /**
           * MediaElementWebAudio backend: load audio via an HTML5 audio tag, but playback with the WebAudio API.
           * The advantage here is that the html5 <audio> tag can perform range requests on the server and not
           * buffer the entire file in one request, and you still get the filtering and scripting functionality
           * of the webaudio API.
           * Note that in order to use range requests and prevent buffering, you must provide peak data.
           *
           * @since 3.2.0
           */
          var MediaElementWebAudio = /*#__PURE__*/function (_MediaElement) {
            _inherits(MediaElementWebAudio, _MediaElement);
            var _super = _createSuper(MediaElementWebAudio);

            /**
             * Construct the backend
             *
             * @param {WavesurferParams} params Wavesurfer parameters
             */
            function MediaElementWebAudio(params) {
              var _this;
              _classCallCheck(this, MediaElementWebAudio);
              _this = _super.call(this, params);
              /** @private */

              _this.params = params;
              /** @private */

              _this.sourceMediaElement = null;
              return _this;
            }
            /**
             * Initialise the backend, called in `wavesurfer.createBackend()`
             */

            _createClass(MediaElementWebAudio, [{
              key: "init",
              value: function init() {
                this.setPlaybackRate(this.params.audioRate);
                this.createTimer();
                this.createVolumeNode();
                this.createScriptNode();
                this.createAnalyserNode();
              }
              /**
               * Private method called by both `load` (from url)
               * and `loadElt` (existing media element) methods.
               *
               * @param {HTMLMediaElement} media HTML5 Audio or Video element
               * @param {number[]|Number.<Array[]>} peaks Array of peak data
               * @param {string} preload HTML 5 preload attribute value
               * @private
               */
            }, {
              key: "_load",
              value: function _load(media, peaks, preload) {
                _get(_getPrototypeOf(MediaElementWebAudio.prototype), "_load", this).call(this, media, peaks, preload);
                this.createMediaElementSource(media);
              }
              /**
               * Create MediaElementSource node
               *
               * @since 3.2.0
               * @param {HTMLMediaElement} mediaElement HTML5 Audio to load
               */
            }, {
              key: "createMediaElementSource",
              value: function createMediaElementSource(mediaElement) {
                this.sourceMediaElement = this.ac.createMediaElementSource(mediaElement);
                this.sourceMediaElement.connect(this.analyser);
              }
            }, {
              key: "play",
              value: function play(start, end) {
                this.resumeAudioContext();
                return _get(_getPrototypeOf(MediaElementWebAudio.prototype), "play", this).call(this, start, end);
              }
              /**
               * This is called when wavesurfer is destroyed
               *
               */
            }, {
              key: "destroy",
              value: function destroy() {
                _get(_getPrototypeOf(MediaElementWebAudio.prototype), "destroy", this).call(this);
                this.destroyWebAudio();
              }
            }]);
            return MediaElementWebAudio;
          }(_mediaelement.default);
          exports.default = MediaElementWebAudio;
          module.exports = exports.default;

          /***/
        },

        /***/"./src/mediaelement.js": function srcMediaelementJs(module, exports, __nested_webpack_require_80468__) {
          "use strict";

          function _typeof(obj) {
            "@babel/helpers - typeof";

            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              _typeof = function _typeof(obj) {
                return typeof obj;
              };
            } else {
              _typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
              };
            }
            return _typeof(obj);
          }
          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports.default = void 0;
          var _webaudio = _interopRequireDefault(__nested_webpack_require_80468__( /*! ./webaudio */"./src/webaudio.js"));
          var util = _interopRequireWildcard(__nested_webpack_require_80468__( /*! ./util */"./src/util/index.js"));
          function _getRequireWildcardCache() {
            if (typeof WeakMap !== "function") return null;
            var cache = new WeakMap();
            _getRequireWildcardCache = function _getRequireWildcardCache() {
              return cache;
            };
            return cache;
          }
          function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
              return obj;
            }
            if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
              return {
                default: obj
              };
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
              return cache.get(obj);
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                if (desc && (desc.get || desc.set)) {
                  Object.defineProperty(newObj, key, desc);
                } else {
                  newObj[key] = obj[key];
                }
              }
            }
            newObj.default = obj;
            if (cache) {
              cache.set(obj, newObj);
            }
            return newObj;
          }
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
              default: obj
            };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) _defineProperties(Constructor.prototype, protoProps);
            if (staticProps) _defineProperties(Constructor, staticProps);
            return Constructor;
          }
          function _get(target, property, receiver) {
            if (typeof Reflect !== "undefined" && Reflect.get) {
              _get = Reflect.get;
            } else {
              _get = function _get(target, property, receiver) {
                var base = _superPropBase(target, property);
                if (!base) return;
                var desc = Object.getOwnPropertyDescriptor(base, property);
                if (desc.get) {
                  return desc.get.call(receiver);
                }
                return desc.value;
              };
            }
            return _get(target, property, receiver || target);
          }
          function _superPropBase(object, property) {
            while (!Object.prototype.hasOwnProperty.call(object, property)) {
              object = _getPrototypeOf(object);
              if (object === null) break;
            }
            return object;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function");
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, {
              constructor: {
                value: subClass,
                writable: true,
                configurable: true
              }
            });
            if (superClass) _setPrototypeOf(subClass, superClass);
          }
          function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
              o.__proto__ = p;
              return o;
            };
            return _setPrototypeOf(o, p);
          }
          function _createSuper(Derived) {
            var hasNativeReflectConstruct = _isNativeReflectConstruct();
            return function _createSuperInternal() {
              var Super = _getPrototypeOf(Derived),
                result;
              if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
              } else {
                result = Super.apply(this, arguments);
              }
              return _possibleConstructorReturn(this, result);
            };
          }
          function _possibleConstructorReturn(self, call) {
            if (call && (_typeof(call) === "object" || typeof call === "function")) {
              return call;
            }
            return _assertThisInitialized(self);
          }
          function _assertThisInitialized(self) {
            if (self === void 0) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return self;
          }
          function _isNativeReflectConstruct() {
            if (typeof Reflect === "undefined" || !Reflect.construct) return false;
            if (Reflect.construct.sham) return false;
            if (typeof Proxy === "function") return true;
            try {
              Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
              return true;
            } catch (e) {
              return false;
            }
          }
          function _getPrototypeOf(o) {
            _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
              return o.__proto__ || Object.getPrototypeOf(o);
            };
            return _getPrototypeOf(o);
          }

          /**
           * MediaElement backend
           */
          var MediaElement = /*#__PURE__*/function (_WebAudio) {
            _inherits(MediaElement, _WebAudio);
            var _super = _createSuper(MediaElement);

            /**
             * Construct the backend
             *
             * @param {WavesurferParams} params Wavesurfer parameters
             */
            function MediaElement(params) {
              var _this;
              _classCallCheck(this, MediaElement);
              _this = _super.call(this, params);
              /** @private */

              _this.params = params;
              /**
               * Initially a dummy media element to catch errors. Once `_load` is
               * called, this will contain the actual `HTMLMediaElement`.
               * @private
               */

              _this.media = {
                currentTime: 0,
                duration: 0,
                paused: true,
                playbackRate: 1,
                play: function play() {},
                pause: function pause() {},
                volume: 0
              };
              /** @private */

              _this.mediaType = params.mediaType.toLowerCase();
              /** @private */

              _this.elementPosition = params.elementPosition;
              /** @private */

              _this.peaks = null;
              /** @private */

              _this.playbackRate = 1;
              /** @private */

              _this.volume = 1;
              /** @private */

              _this.isMuted = false;
              /** @private */

              _this.buffer = null;
              /** @private */

              _this.onPlayEnd = null;
              /** @private */

              _this.mediaListeners = {};
              return _this;
            }
            /**
             * Initialise the backend, called in `wavesurfer.createBackend()`
             */

            _createClass(MediaElement, [{
              key: "init",
              value: function init() {
                this.setPlaybackRate(this.params.audioRate);
                this.createTimer();
              }
              /**
               * Attach event listeners to media element.
               */
            }, {
              key: "_setupMediaListeners",
              value: function _setupMediaListeners() {
                var _this2 = this;
                this.mediaListeners.error = function () {
                  _this2.fireEvent('error', 'Error loading media element');
                };
                this.mediaListeners.canplay = function () {
                  _this2.fireEvent('canplay');
                };
                this.mediaListeners.ended = function () {
                  _this2.fireEvent('finish');
                }; // listen to and relay play, pause and seeked events to enable
                // playback control from the external media element

                this.mediaListeners.play = function () {
                  _this2.fireEvent('play');
                };
                this.mediaListeners.pause = function () {
                  _this2.fireEvent('pause');
                };
                this.mediaListeners.seeked = function (event) {
                  _this2.fireEvent('seek');
                };
                this.mediaListeners.volumechange = function (event) {
                  _this2.isMuted = _this2.media.muted;
                  if (_this2.isMuted) {
                    _this2.volume = 0;
                  } else {
                    _this2.volume = _this2.media.volume;
                  }
                  _this2.fireEvent('volume');
                }; // reset event listeners

                Object.keys(this.mediaListeners).forEach(function (id) {
                  _this2.media.removeEventListener(id, _this2.mediaListeners[id]);
                  _this2.media.addEventListener(id, _this2.mediaListeners[id]);
                });
              }
              /**
               * Create a timer to provide a more precise `audioprocess` event.
               */
            }, {
              key: "createTimer",
              value: function createTimer() {
                var _this3 = this;
                var onAudioProcess = function onAudioProcess() {
                  if (_this3.isPaused()) {
                    return;
                  }
                  _this3.fireEvent('audioprocess', _this3.getCurrentTime()); // Call again in the next frame

                  util.frame(onAudioProcess)();
                };
                this.on('play', onAudioProcess); // Update the progress one more time to prevent it from being stuck in
                // case of lower framerates

                this.on('pause', function () {
                  _this3.fireEvent('audioprocess', _this3.getCurrentTime());
                });
              }
              /**
               * Create media element with url as its source,
               * and append to container element.
               *
               * @param {string} url Path to media file
               * @param {HTMLElement} container HTML element
               * @param {number[]|Number.<Array[]>} peaks Array of peak data
               * @param {string} preload HTML 5 preload attribute value
               * @throws Will throw an error if the `url` argument is not a valid media
               * element.
               */
            }, {
              key: "load",
              value: function load(url, container, peaks, preload) {
                var media = document.createElement(this.mediaType);
                media.controls = this.params.mediaControls;
                media.autoplay = this.params.autoplay || false;
                media.preload = preload == null ? 'auto' : preload;
                media.src = url;
                media.style.width = '100%';
                var prevMedia = container.querySelector(this.mediaType);
                if (prevMedia) {
                  container.removeChild(prevMedia);
                }
                container.appendChild(media);
                this._load(media, peaks, preload);
              }
              /**
               * Load existing media element.
               *
               * @param {HTMLMediaElement} elt HTML5 Audio or Video element
               * @param {number[]|Number.<Array[]>} peaks Array of peak data
               */
            }, {
              key: "loadElt",
              value: function loadElt(elt, peaks) {
                elt.controls = this.params.mediaControls;
                elt.autoplay = this.params.autoplay || false;
                this._load(elt, peaks, elt.preload);
              }
              /**
               * Method called by both `load` (from url)
               * and `loadElt` (existing media element) methods.
               *
               * @param {HTMLMediaElement} media HTML5 Audio or Video element
               * @param {number[]|Number.<Array[]>} peaks Array of peak data
               * @param {string} preload HTML 5 preload attribute value
               * @throws Will throw an error if the `media` argument is not a valid media
               * element.
               * @private
               */
            }, {
              key: "_load",
              value: function _load(media, peaks, preload) {
                // verify media element is valid
                if (!(media instanceof HTMLMediaElement) || typeof media.addEventListener === 'undefined') {
                  throw new Error('media parameter is not a valid media element');
                } // load must be called manually on iOS, otherwise peaks won't draw
                // until a user interaction triggers load --> 'ready' event
                //
                // note that we avoid calling media.load here when given peaks and preload == 'none'
                // as this almost always triggers some browser fetch of the media.

                if (typeof media.load == 'function' && !(peaks && preload == 'none')) {
                  // Resets the media element and restarts the media resource. Any
                  // pending events are discarded. How much media data is fetched is
                  // still affected by the preload attribute.
                  media.load();
                }
                this.media = media;
                this._setupMediaListeners();
                this.peaks = peaks;
                this.onPlayEnd = null;
                this.buffer = null;
                this.isMuted = media.muted;
                this.setPlaybackRate(this.playbackRate);
                this.setVolume(this.volume);
              }
              /**
               * Used by `wavesurfer.isPlaying()` and `wavesurfer.playPause()`
               *
               * @return {boolean} Media paused or not
               */
            }, {
              key: "isPaused",
              value: function isPaused() {
                return !this.media || this.media.paused;
              }
              /**
               * Used by `wavesurfer.getDuration()`
               *
               * @return {number} Duration
               */
            }, {
              key: "getDuration",
              value: function getDuration() {
                if (this.explicitDuration) {
                  return this.explicitDuration;
                }
                var duration = (this.buffer || this.media).duration;
                if (duration >= Infinity) {
                  // streaming audio
                  duration = this.media.seekable.end(0);
                }
                return duration;
              }
              /**
               * Returns the current time in seconds relative to the audio-clip's
               * duration.
               *
               * @return {number} Current time
               */
            }, {
              key: "getCurrentTime",
              value: function getCurrentTime() {
                return this.media && this.media.currentTime;
              }
              /**
               * Get the position from 0 to 1
               *
               * @return {number} Current position
               */
            }, {
              key: "getPlayedPercents",
              value: function getPlayedPercents() {
                return this.getCurrentTime() / this.getDuration() || 0;
              }
              /**
               * Get the audio source playback rate.
               *
               * @return {number} Playback rate
               */
            }, {
              key: "getPlaybackRate",
              value: function getPlaybackRate() {
                return this.playbackRate || this.media.playbackRate;
              }
              /**
               * Set the audio source playback rate.
               *
               * @param {number} value Playback rate
               */
            }, {
              key: "setPlaybackRate",
              value: function setPlaybackRate(value) {
                this.playbackRate = value || 1;
                this.media.playbackRate = this.playbackRate;
              }
              /**
               * Used by `wavesurfer.seekTo()`
               *
               * @param {number} start Position to start at in seconds
               */
            }, {
              key: "seekTo",
              value: function seekTo(start) {
                if (start != null) {
                  this.media.currentTime = start;
                }
                this.clearPlayEnd();
              }
              /**
               * Plays the loaded audio region.
               *
               * @param {number} start Start offset in seconds, relative to the beginning
               * of a clip.
               * @param {number} end When to stop, relative to the beginning of a clip.
               * @emits MediaElement#play
               * @return {Promise} Result
               */
            }, {
              key: "play",
              value: function play(start, end) {
                this.seekTo(start);
                var promise = this.media.play();
                end && this.setPlayEnd(end);
                return promise;
              }
              /**
               * Pauses the loaded audio.
               *
               * @emits MediaElement#pause
               * @return {Promise} Result
               */
            }, {
              key: "pause",
              value: function pause() {
                var promise;
                if (this.media) {
                  promise = this.media.pause();
                }
                this.clearPlayEnd();
                return promise;
              }
              /**
               * Set the play end
               *
               * @param {number} end Where to end
               */
            }, {
              key: "setPlayEnd",
              value: function setPlayEnd(end) {
                var _this4 = this;
                this.clearPlayEnd();
                this._onPlayEnd = function (time) {
                  if (time >= end) {
                    _this4.pause();
                    _this4.seekTo(end);
                  }
                };
                this.on('audioprocess', this._onPlayEnd);
              }
              /** @private */
            }, {
              key: "clearPlayEnd",
              value: function clearPlayEnd() {
                if (this._onPlayEnd) {
                  this.un('audioprocess', this._onPlayEnd);
                  this._onPlayEnd = null;
                }
              }
              /**
               * Compute the max and min value of the waveform when broken into
               * <length> subranges.
               *
               * @param {number} length How many subranges to break the waveform into.
               * @param {number} first First sample in the required range.
               * @param {number} last Last sample in the required range.
               * @return {number[]|Number.<Array[]>} Array of 2*<length> peaks or array of
               * arrays of peaks consisting of (max, min) values for each subrange.
               */
            }, {
              key: "getPeaks",
              value: function getPeaks(length, first, last) {
                if (this.buffer) {
                  return _get(_getPrototypeOf(MediaElement.prototype), "getPeaks", this).call(this, length, first, last);
                }
                return this.peaks || [];
              }
              /**
               * Set the sink id for the media player
               *
               * @param {string} deviceId String value representing audio device id.
               * @returns {Promise} A Promise that resolves to `undefined` when there
               * are no errors.
               */
            }, {
              key: "setSinkId",
              value: function setSinkId(deviceId) {
                if (deviceId) {
                  if (!this.media.setSinkId) {
                    return Promise.reject(new Error('setSinkId is not supported in your browser'));
                  }
                  return this.media.setSinkId(deviceId);
                }
                return Promise.reject(new Error('Invalid deviceId: ' + deviceId));
              }
              /**
               * Get the current volume
               *
               * @return {number} value A floating point value between 0 and 1.
               */
            }, {
              key: "getVolume",
              value: function getVolume() {
                return this.volume;
              }
              /**
               * Set the audio volume
               *
               * @param {number} value A floating point value between 0 and 1.
               */
            }, {
              key: "setVolume",
              value: function setVolume(value) {
                this.volume = value; // no need to change when it's already at that volume

                if (this.media.volume !== this.volume) {
                  this.media.volume = this.volume;
                }
              }
              /**
               * Enable or disable muted audio
               *
               * @since 4.0.0
               * @param {boolean} muted Specify `true` to mute audio.
               */
            }, {
              key: "setMute",
              value: function setMute(muted) {
                // This causes a volume change to be emitted too through the
                // volumechange event listener.
                this.isMuted = this.media.muted = muted;
              }
              /**
               * This is called when wavesurfer is destroyed
               *
               */
            }, {
              key: "destroy",
              value: function destroy() {
                var _this5 = this;
                this.pause();
                this.unAll();
                this.destroyed = true; // cleanup media event listeners

                Object.keys(this.mediaListeners).forEach(function (id) {
                  if (_this5.media) {
                    _this5.media.removeEventListener(id, _this5.mediaListeners[id]);
                  }
                });
                if (this.params.removeMediaElementOnDestroy && this.media && this.media.parentNode) {
                  this.media.parentNode.removeChild(this.media);
                }
                this.media = null;
              }
            }]);
            return MediaElement;
          }(_webaudio.default);
          exports.default = MediaElement;
          module.exports = exports.default;

          /***/
        },

        /***/"./src/peakcache.js": function srcPeakcacheJs(module, exports) {
          "use strict";

          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports.default = void 0;
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) _defineProperties(Constructor.prototype, protoProps);
            if (staticProps) _defineProperties(Constructor, staticProps);
            return Constructor;
          }

          /**
           * Caches the decoded peaks data to improve rendering speed for large audio
           *
           * Is used if the option parameter `partialRender` is set to `true`
           */
          var PeakCache = /*#__PURE__*/function () {
            /**
             * Instantiate cache
             */
            function PeakCache() {
              _classCallCheck(this, PeakCache);
              this.clearPeakCache();
            }
            /**
             * Empty the cache
             */

            _createClass(PeakCache, [{
              key: "clearPeakCache",
              value: function clearPeakCache() {
                /**
                 * Flat array with entries that are always in pairs to mark the
                 * beginning and end of each subrange.  This is a convenience so we can
                 * iterate over the pairs for easy set difference operations.
                 * @private
                 */
                this.peakCacheRanges = [];
                /**
                 * Length of the entire cachable region, used for resetting the cache
                 * when this changes (zoom events, for instance).
                 * @private
                 */

                this.peakCacheLength = -1;
              }
              /**
               * Add a range of peaks to the cache
               *
               * @param {number} length The length of the range
               * @param {number} start The x offset of the start of the range
               * @param {number} end The x offset of the end of the range
               * @return {Number.<Array[]>} Array with arrays of numbers
               */
            }, {
              key: "addRangeToPeakCache",
              value: function addRangeToPeakCache(length, start, end) {
                if (length != this.peakCacheLength) {
                  this.clearPeakCache();
                  this.peakCacheLength = length;
                } // Return ranges that weren't in the cache before the call.

                var uncachedRanges = [];
                var i = 0; // Skip ranges before the current start.

                while (i < this.peakCacheRanges.length && this.peakCacheRanges[i] < start) {
                  i++;
                } // If |i| is even, |start| falls after an existing range.  Otherwise,
                // |start| falls between an existing range, and the uncached region
                // starts when we encounter the next node in |peakCacheRanges| or
                // |end|, whichever comes first.

                if (i % 2 == 0) {
                  uncachedRanges.push(start);
                }
                while (i < this.peakCacheRanges.length && this.peakCacheRanges[i] <= end) {
                  uncachedRanges.push(this.peakCacheRanges[i]);
                  i++;
                } // If |i| is even, |end| is after all existing ranges.

                if (i % 2 == 0) {
                  uncachedRanges.push(end);
                } // Filter out the 0-length ranges.

                uncachedRanges = uncachedRanges.filter(function (item, pos, arr) {
                  if (pos == 0) {
                    return item != arr[pos + 1];
                  } else if (pos == arr.length - 1) {
                    return item != arr[pos - 1];
                  }
                  return item != arr[pos - 1] && item != arr[pos + 1];
                }); // Merge the two ranges together, uncachedRanges will either contain
                // wholly new points, or duplicates of points in peakCacheRanges.  If
                // duplicates are detected, remove both and extend the range.

                this.peakCacheRanges = this.peakCacheRanges.concat(uncachedRanges);
                this.peakCacheRanges = this.peakCacheRanges.sort(function (a, b) {
                  return a - b;
                }).filter(function (item, pos, arr) {
                  if (pos == 0) {
                    return item != arr[pos + 1];
                  } else if (pos == arr.length - 1) {
                    return item != arr[pos - 1];
                  }
                  return item != arr[pos - 1] && item != arr[pos + 1];
                }); // Push the uncached ranges into an array of arrays for ease of
                // iteration in the functions that call this.

                var uncachedRangePairs = [];
                for (i = 0; i < uncachedRanges.length; i += 2) {
                  uncachedRangePairs.push([uncachedRanges[i], uncachedRanges[i + 1]]);
                }
                return uncachedRangePairs;
              }
              /**
               * For testing
               *
               * @return {Number.<Array[]>} Array with arrays of numbers
               */
            }, {
              key: "getCacheRanges",
              value: function getCacheRanges() {
                var peakCacheRangePairs = [];
                var i;
                for (i = 0; i < this.peakCacheRanges.length; i += 2) {
                  peakCacheRangePairs.push([this.peakCacheRanges[i], this.peakCacheRanges[i + 1]]);
                }
                return peakCacheRangePairs;
              }
            }]);
            return PeakCache;
          }();
          exports.default = PeakCache;
          module.exports = exports.default;

          /***/
        },

        /***/"./src/util/absMax.js": function srcUtilAbsMaxJs(module, exports, __nested_webpack_require_111758__) {
          "use strict";

          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports.default = absMax;
          var _max = _interopRequireDefault(__nested_webpack_require_111758__( /*! ./max */"./src/util/max.js"));
          var _min = _interopRequireDefault(__nested_webpack_require_111758__( /*! ./min */"./src/util/min.js"));
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
              default: obj
            };
          }

          /**
           * Get the largest absolute value in an array
           *
           * @param   {Array} values Array of numbers
           * @returns {Number} Largest number found
           * @example console.log(max([-3, 2, 1]), max([-3, 2, 4])); // logs 3 4
           * @since 4.3.0
           */
          function absMax(values) {
            var max = (0, _max.default)(values);
            var min = (0, _min.default)(values);
            return -min > max ? -min : max;
          }
          module.exports = exports.default;

          /***/
        },

        /***/"./src/util/clamp.js": function srcUtilClampJs(module, exports) {
          "use strict";

          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports.default = clamp;

          /**
           * Returns a number limited to the given range.
           *
           * @param {number} val The number to be limited to a range
           * @param {number} min The lower boundary of the limit range
           * @param {number} max The upper boundary of the limit range
           * @returns {number} A number in the range [min, max]
           */
          function clamp(val, min, max) {
            return Math.min(Math.max(min, val), max);
          }
          module.exports = exports.default;

          /***/
        },

        /***/"./src/util/fetch.js": function srcUtilFetchJs(module, exports, __nested_webpack_require_113739__) {
          "use strict";

          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports.default = fetchFile;
          var _observer = _interopRequireDefault(__nested_webpack_require_113739__( /*! ./observer */"./src/util/observer.js"));
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
              default: obj
            };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) _defineProperties(Constructor.prototype, protoProps);
            if (staticProps) _defineProperties(Constructor, staticProps);
            return Constructor;
          }
          var ProgressHandler = /*#__PURE__*/function () {
            /**
             * Instantiate ProgressHandler
             *
             * @param {Observer} instance The `fetchFile` observer instance.
             * @param {Number} contentLength Content length.
             * @param {Response} response Response object.
             */
            function ProgressHandler(instance, contentLength, response) {
              _classCallCheck(this, ProgressHandler);
              this.instance = instance;
              this.instance._reader = response.body.getReader();
              this.total = parseInt(contentLength, 10);
              this.loaded = 0;
            }
            /**
             * A method that is called once, immediately after the `ReadableStream``
             * is constructed.
             *
             * @param {ReadableStreamDefaultController} controller Controller instance
             *     used to control the stream.
             */

            _createClass(ProgressHandler, [{
              key: "start",
              value: function start(controller) {
                var _this = this;
                var read = function read() {
                  // instance._reader.read() returns a promise that resolves
                  // when a value has been received
                  _this.instance._reader.read().then(function (_ref) {
                    var done = _ref.done,
                      value = _ref.value;

                    // result objects contain two properties:
                    // done  - true if the stream has already given you all its data.
                    // value - some data. Always undefined when done is true.
                    if (done) {
                      // ensure onProgress called when content-length=0
                      if (_this.total === 0) {
                        _this.instance.onProgress.call(_this.instance, {
                          loaded: _this.loaded,
                          total: _this.total,
                          lengthComputable: false
                        });
                      } // no more data needs to be consumed, close the stream

                      controller.close();
                      return;
                    }
                    _this.loaded += value.byteLength;
                    _this.instance.onProgress.call(_this.instance, {
                      loaded: _this.loaded,
                      total: _this.total,
                      lengthComputable: !(_this.total === 0)
                    }); // enqueue the next data chunk into our target stream

                    controller.enqueue(value);
                    read();
                  }).catch(function (error) {
                    controller.error(error);
                  });
                };
                read();
              }
            }]);
            return ProgressHandler;
          }();
          /**
           * Load a file using `fetch`.
           *
           * @param {object} options Request options to use. See example below.
           * @returns {Observer} Observer instance
           * @example
           * // default options
           * let options = {
           *     url: undefined,
           *     method: 'GET',
           *     mode: 'cors',
           *     credentials: 'same-origin',
           *     cache: 'default',
           *     responseType: 'json',
           *     requestHeaders: [],
           *     redirect: 'follow',
           *     referrer: 'client'
           * };
           *
           * // override some options
           * options.url = '../media/demo.wav';
          
           * // available types: 'arraybuffer', 'blob', 'json' or 'text'
           * options.responseType = 'arraybuffer';
           *
           * // make fetch call
           * let request = util.fetchFile(options);
           *
           * // listen for events
           * request.on('progress', e => {
           *     console.log('progress', e);
           * });
           *
           * request.on('success', data => {
           *     console.log('success!', data);
           * });
           *
           * request.on('error', e => {
           *     console.warn('fetchFile error: ', e);
           * });
           */

          function fetchFile(options) {
            if (!options) {
              throw new Error('fetch options missing');
            } else if (!options.url) {
              throw new Error('fetch url missing');
            }
            var instance = new _observer.default();
            var fetchHeaders = new Headers();
            var fetchRequest = new Request(options.url); // add ability to abort

            instance.controller = new AbortController(); // check if headers have to be added

            if (options && options.requestHeaders) {
              // add custom request headers
              options.requestHeaders.forEach(function (header) {
                fetchHeaders.append(header.key, header.value);
              });
            } // parse fetch options

            var responseType = options.responseType || 'json';
            var fetchOptions = {
              method: options.method || 'GET',
              headers: fetchHeaders,
              mode: options.mode || 'cors',
              credentials: options.credentials || 'same-origin',
              cache: options.cache || 'default',
              redirect: options.redirect || 'follow',
              referrer: options.referrer || 'client',
              signal: instance.controller.signal
            };
            fetch(fetchRequest, fetchOptions).then(function (response) {
              // store response reference
              instance.response = response;
              var progressAvailable = true;
              if (!response.body) {
                // ReadableStream is not yet supported in this browser
                // see https://developer.mozilla.org/en-US/docs/Web/API/ReadableStream
                progressAvailable = false;
              } // Server must send CORS header "Access-Control-Expose-Headers: content-length"

              var contentLength = response.headers.get('content-length');
              if (contentLength === null) {
                // Content-Length server response header missing.
                // Don't evaluate download progress if we can't compare against a total size
                // see https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Access-Control-Expose-Headers
                progressAvailable = false;
              }
              if (!progressAvailable) {
                // not able to check download progress so skip it
                return response;
              } // fire progress event when during load

              instance.onProgress = function (e) {
                instance.fireEvent('progress', e);
              };
              return new Response(new ReadableStream(new ProgressHandler(instance, contentLength, response)), fetchOptions);
            }).then(function (response) {
              var errMsg;
              if (response.ok) {
                switch (responseType) {
                  case 'arraybuffer':
                    return response.arrayBuffer();
                  case 'json':
                    return response.json();
                  case 'blob':
                    return response.blob();
                  case 'text':
                    return response.text();
                  default:
                    errMsg = 'Unknown responseType: ' + responseType;
                    break;
                }
              }
              if (!errMsg) {
                errMsg = 'HTTP error status: ' + response.status;
              }
              throw new Error(errMsg);
            }).then(function (response) {
              instance.fireEvent('success', response);
            }).catch(function (error) {
              instance.fireEvent('error', error);
            }); // return the fetch request

            instance.fetchRequest = fetchRequest;
            return instance;
          }
          module.exports = exports.default;

          /***/
        },

        /***/"./src/util/frame.js": function srcUtilFrameJs(module, exports, __nested_webpack_require_123351__) {
          "use strict";

          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports.default = frame;
          var _requestAnimationFrame = _interopRequireDefault(__nested_webpack_require_123351__( /*! ./request-animation-frame */"./src/util/request-animation-frame.js"));
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
              default: obj
            };
          }

          /**
           * Create a function which will be called at the next requestAnimationFrame
           * cycle
           *
           * @param {function} func The function to call
           *
           * @return {func} The function wrapped within a requestAnimationFrame
           */
          function frame(func) {
            return function () {
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              return (0, _requestAnimationFrame.default)(function () {
                return func.apply(void 0, args);
              });
            };
          }
          module.exports = exports.default;

          /***/
        },

        /***/"./src/util/get-id.js": function srcUtilGetIdJs(module, exports) {
          "use strict";

          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports.default = getId;

          /**
           * Get a random prefixed ID
           *
           * @param {String} prefix Prefix to use. Default is `'wavesurfer_'`.
           * @returns {String} Random prefixed ID
           * @example
           * console.log(getId()); // logs 'wavesurfer_b5pors4ru6g'
           *
           * let prefix = 'foo-';
           * console.log(getId(prefix)); // logs 'foo-b5pors4ru6g'
           */
          function getId(prefix) {
            if (prefix === undefined) {
              prefix = 'wavesurfer_';
            }
            return prefix + Math.random().toString(32).substring(2);
          }
          module.exports = exports.default;

          /***/
        },

        /***/"./src/util/index.js": function srcUtilIndexJs(__unused_webpack_module, exports, __nested_webpack_require_125632__) {
          "use strict";

          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          Object.defineProperty(exports, "getId", {
            enumerable: true,
            get: function get() {
              return _getId.default;
            }
          });
          Object.defineProperty(exports, "max", {
            enumerable: true,
            get: function get() {
              return _max.default;
            }
          });
          Object.defineProperty(exports, "min", {
            enumerable: true,
            get: function get() {
              return _min.default;
            }
          });
          Object.defineProperty(exports, "absMax", {
            enumerable: true,
            get: function get() {
              return _absMax.default;
            }
          });
          Object.defineProperty(exports, "Observer", {
            enumerable: true,
            get: function get() {
              return _observer.default;
            }
          });
          Object.defineProperty(exports, "style", {
            enumerable: true,
            get: function get() {
              return _style.default;
            }
          });
          Object.defineProperty(exports, "requestAnimationFrame", {
            enumerable: true,
            get: function get() {
              return _requestAnimationFrame.default;
            }
          });
          Object.defineProperty(exports, "frame", {
            enumerable: true,
            get: function get() {
              return _frame.default;
            }
          });
          Object.defineProperty(exports, "debounce", {
            enumerable: true,
            get: function get() {
              return _debounce.default;
            }
          });
          Object.defineProperty(exports, "preventClick", {
            enumerable: true,
            get: function get() {
              return _preventClick.default;
            }
          });
          Object.defineProperty(exports, "fetchFile", {
            enumerable: true,
            get: function get() {
              return _fetch.default;
            }
          });
          Object.defineProperty(exports, "clamp", {
            enumerable: true,
            get: function get() {
              return _clamp.default;
            }
          });
          var _getId = _interopRequireDefault(__nested_webpack_require_125632__( /*! ./get-id */"./src/util/get-id.js"));
          var _max = _interopRequireDefault(__nested_webpack_require_125632__( /*! ./max */"./src/util/max.js"));
          var _min = _interopRequireDefault(__nested_webpack_require_125632__( /*! ./min */"./src/util/min.js"));
          var _absMax = _interopRequireDefault(__nested_webpack_require_125632__( /*! ./absMax */"./src/util/absMax.js"));
          var _observer = _interopRequireDefault(__nested_webpack_require_125632__( /*! ./observer */"./src/util/observer.js"));
          var _style = _interopRequireDefault(__nested_webpack_require_125632__( /*! ./style */"./src/util/style.js"));
          var _requestAnimationFrame = _interopRequireDefault(__nested_webpack_require_125632__( /*! ./request-animation-frame */"./src/util/request-animation-frame.js"));
          var _frame = _interopRequireDefault(__nested_webpack_require_125632__( /*! ./frame */"./src/util/frame.js"));
          var _debounce = _interopRequireDefault(__nested_webpack_require_125632__( /*! debounce */"./node_modules/debounce/index.js"));
          var _preventClick = _interopRequireDefault(__nested_webpack_require_125632__( /*! ./prevent-click */"./src/util/prevent-click.js"));
          var _fetch = _interopRequireDefault(__nested_webpack_require_125632__( /*! ./fetch */"./src/util/fetch.js"));
          var _clamp = _interopRequireDefault(__nested_webpack_require_125632__( /*! ./clamp */"./src/util/clamp.js"));
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
              default: obj
            };
          }

          /***/
        },

        /***/"./src/util/max.js": function srcUtilMaxJs(module, exports) {
          "use strict";

          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports.default = max;

          /**
           * Get the largest value
           *
           * @param   {Array} values Array of numbers
           * @returns {Number} Largest number found
           * @example console.log(max([1, 2, 3])); // logs 3
           */
          function max(values) {
            var largest = -Infinity;
            Object.keys(values).forEach(function (i) {
              if (values[i] > largest) {
                largest = values[i];
              }
            });
            return largest;
          }
          module.exports = exports.default;

          /***/
        },

        /***/"./src/util/min.js": function srcUtilMinJs(module, exports) {
          "use strict";

          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports.default = min;

          /**
           * Get the smallest value
           *
           * @param   {Array} values Array of numbers
           * @returns {Number} Smallest number found
           * @example console.log(min([1, 2, 3])); // logs 1
           */
          function min(values) {
            var smallest = Number(Infinity);
            Object.keys(values).forEach(function (i) {
              if (values[i] < smallest) {
                smallest = values[i];
              }
            });
            return smallest;
          }
          module.exports = exports.default;

          /***/
        },

        /***/"./src/util/observer.js": function srcUtilObserverJs(module, exports) {
          "use strict";

          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports.default = void 0;
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) _defineProperties(Constructor.prototype, protoProps);
            if (staticProps) _defineProperties(Constructor, staticProps);
            return Constructor;
          }

          /**
           * @typedef {Object} ListenerDescriptor
           * @property {string} name The name of the event
           * @property {function} callback The callback
           * @property {function} un The function to call to remove the listener
           */

          /**
           * Observer class
           */
          var Observer = /*#__PURE__*/function () {
            /**
             * Instantiate Observer
             */
            function Observer() {
              _classCallCheck(this, Observer);

              /**
               * @private
               * @todo Initialise the handlers here already and remove the conditional
               * assignment in `on()`
               */
              this._disabledEventEmissions = [];
              this.handlers = null;
            }
            /**
             * Attach a handler function for an event.
             *
             * @param {string} event Name of the event to listen to
             * @param {function} fn The callback to trigger when the event is fired
             * @return {ListenerDescriptor} The event descriptor
             */

            _createClass(Observer, [{
              key: "on",
              value: function on(event, fn) {
                var _this = this;
                if (!this.handlers) {
                  this.handlers = {};
                }
                var handlers = this.handlers[event];
                if (!handlers) {
                  handlers = this.handlers[event] = [];
                }
                handlers.push(fn); // Return an event descriptor

                return {
                  name: event,
                  callback: fn,
                  un: function un(e, fn) {
                    return _this.un(e, fn);
                  }
                };
              }
              /**
               * Remove an event handler.
               *
               * @param {string} event Name of the event the listener that should be
               * removed listens to
               * @param {function} fn The callback that should be removed
               */
            }, {
              key: "un",
              value: function un(event, fn) {
                if (!this.handlers) {
                  return;
                }
                var handlers = this.handlers[event];
                var i;
                if (handlers) {
                  if (fn) {
                    for (i = handlers.length - 1; i >= 0; i--) {
                      if (handlers[i] == fn) {
                        handlers.splice(i, 1);
                      }
                    }
                  } else {
                    handlers.length = 0;
                  }
                }
              }
              /**
               * Remove all event handlers.
               */
            }, {
              key: "unAll",
              value: function unAll() {
                this.handlers = null;
              }
              /**
               * Attach a handler to an event. The handler is executed at most once per
               * event type.
               *
               * @param {string} event The event to listen to
               * @param {function} handler The callback that is only to be called once
               * @return {ListenerDescriptor} The event descriptor
               */
            }, {
              key: "once",
              value: function once(event, handler) {
                var _this2 = this;
                var fn = function fn() {
                  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                  }

                  /*  eslint-disable no-invalid-this */
                  handler.apply(_this2, args);
                  /*  eslint-enable no-invalid-this */

                  setTimeout(function () {
                    _this2.un(event, fn);
                  }, 0);
                };
                return this.on(event, fn);
              }
              /**
               * Disable firing a list of events by name. When specified, event handlers for any event type
               * passed in here will not be called.
               *
               * @since 4.0.0
               * @param {string[]} eventNames an array of event names to disable emissions for
               * @example
               * // disable seek and interaction events
               * wavesurfer.setDisabledEventEmissions(['seek', 'interaction']);
               */
            }, {
              key: "setDisabledEventEmissions",
              value: function setDisabledEventEmissions(eventNames) {
                this._disabledEventEmissions = eventNames;
              }
              /**
               * plugins borrow part of this class without calling the constructor,
               * so we have to be careful about _disabledEventEmissions
               */
            }, {
              key: "_isDisabledEventEmission",
              value: function _isDisabledEventEmission(event) {
                return this._disabledEventEmissions && this._disabledEventEmissions.includes(event);
              }
              /**
               * Manually fire an event
               *
               * @param {string} event The event to fire manually
               * @param {...any} args The arguments with which to call the listeners
               */
            }, {
              key: "fireEvent",
              value: function fireEvent(event) {
                for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                  args[_key2 - 1] = arguments[_key2];
                }
                if (!this.handlers || this._isDisabledEventEmission(event)) {
                  return;
                }
                var handlers = this.handlers[event];
                handlers && handlers.forEach(function (fn) {
                  fn.apply(void 0, args);
                });
              }
            }]);
            return Observer;
          }();
          exports.default = Observer;
          module.exports = exports.default;

          /***/
        },

        /***/"./src/util/prevent-click.js": function srcUtilPreventClickJs(module, exports) {
          "use strict";

          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports.default = preventClick;

          /**
           * Stops propagation of click event and removes event listener
           *
           * @private
           * @param {object} event The click event
           */
          function preventClickHandler(event) {
            event.stopPropagation();
            document.body.removeEventListener('click', preventClickHandler, true);
          }
          /**
           * Starts listening for click event and prevent propagation
           *
           * @param {object} values Values
           */

          function preventClick(values) {
            document.body.addEventListener('click', preventClickHandler, true);
          }
          module.exports = exports.default;

          /***/
        },

        /***/"./src/util/request-animation-frame.js": function srcUtilRequestAnimationFrameJs(module, exports) {
          "use strict";

          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports.default = void 0;

          /* eslint-disable valid-jsdoc */

          /**
           * Returns the `requestAnimationFrame` function for the browser, or a shim with
           * `setTimeout` if the function is not found
           *
           * @return {function} Available `requestAnimationFrame` function for the browser
           */
          var _default = (window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback, element) {
            return setTimeout(callback, 1000 / 60);
          }).bind(window);
          exports.default = _default;
          module.exports = exports.default;

          /***/
        },

        /***/"./src/util/style.js": function srcUtilStyleJs(module, exports) {
          "use strict";

          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports.default = style;

          /**
           * Apply a map of styles to an element
           *
           * @param {HTMLElement} el The element that the styles will be applied to
           * @param {Object} styles The map of propName: attribute, both are used as-is
           *
           * @return {HTMLElement} el
           */
          function style(el, styles) {
            Object.keys(styles).forEach(function (prop) {
              if (el.style[prop] !== styles[prop]) {
                el.style[prop] = styles[prop];
              }
            });
            return el;
          }
          module.exports = exports.default;

          /***/
        },

        /***/"./src/wavesurfer.js": function srcWavesurferJs(module, exports, __nested_webpack_require_141562__) {
          "use strict";

          function _typeof(obj) {
            "@babel/helpers - typeof";

            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              _typeof = function _typeof(obj) {
                return typeof obj;
              };
            } else {
              _typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
              };
            }
            return _typeof(obj);
          }
          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports.default = void 0;
          var util = _interopRequireWildcard(__nested_webpack_require_141562__( /*! ./util */"./src/util/index.js"));
          var _drawer = _interopRequireDefault(__nested_webpack_require_141562__( /*! ./drawer.multicanvas */"./src/drawer.multicanvas.js"));
          var _webaudio = _interopRequireDefault(__nested_webpack_require_141562__( /*! ./webaudio */"./src/webaudio.js"));
          var _mediaelement = _interopRequireDefault(__nested_webpack_require_141562__( /*! ./mediaelement */"./src/mediaelement.js"));
          var _peakcache = _interopRequireDefault(__nested_webpack_require_141562__( /*! ./peakcache */"./src/peakcache.js"));
          var _mediaelementWebaudio = _interopRequireDefault(__nested_webpack_require_141562__( /*! ./mediaelement-webaudio */"./src/mediaelement-webaudio.js"));
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
              default: obj
            };
          }
          function _getRequireWildcardCache() {
            if (typeof WeakMap !== "function") return null;
            var cache = new WeakMap();
            _getRequireWildcardCache = function _getRequireWildcardCache() {
              return cache;
            };
            return cache;
          }
          function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
              return obj;
            }
            if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
              return {
                default: obj
              };
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
              return cache.get(obj);
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                if (desc && (desc.get || desc.set)) {
                  Object.defineProperty(newObj, key, desc);
                } else {
                  newObj[key] = obj[key];
                }
              }
            }
            newObj.default = obj;
            if (cache) {
              cache.set(obj, newObj);
            }
            return newObj;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function");
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, {
              constructor: {
                value: subClass,
                writable: true,
                configurable: true
              }
            });
            if (superClass) _setPrototypeOf(subClass, superClass);
          }
          function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
              o.__proto__ = p;
              return o;
            };
            return _setPrototypeOf(o, p);
          }
          function _createSuper(Derived) {
            var hasNativeReflectConstruct = _isNativeReflectConstruct();
            return function _createSuperInternal() {
              var Super = _getPrototypeOf(Derived),
                result;
              if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
              } else {
                result = Super.apply(this, arguments);
              }
              return _possibleConstructorReturn(this, result);
            };
          }
          function _possibleConstructorReturn(self, call) {
            if (call && (_typeof(call) === "object" || typeof call === "function")) {
              return call;
            }
            return _assertThisInitialized(self);
          }
          function _assertThisInitialized(self) {
            if (self === void 0) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return self;
          }
          function _isNativeReflectConstruct() {
            if (typeof Reflect === "undefined" || !Reflect.construct) return false;
            if (Reflect.construct.sham) return false;
            if (typeof Proxy === "function") return true;
            try {
              Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
              return true;
            } catch (e) {
              return false;
            }
          }
          function _getPrototypeOf(o) {
            _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
              return o.__proto__ || Object.getPrototypeOf(o);
            };
            return _getPrototypeOf(o);
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) _defineProperties(Constructor.prototype, protoProps);
            if (staticProps) _defineProperties(Constructor, staticProps);
            return Constructor;
          }

          /*
           * This work is licensed under a BSD-3-Clause License.
           */

          /** @external {HTMLElement} https://developer.mozilla.org/en/docs/Web/API/HTMLElement */

          /** @external {OfflineAudioContext} https://developer.mozilla.org/en-US/docs/Web/API/OfflineAudioContext */

          /** @external {File} https://developer.mozilla.org/en-US/docs/Web/API/File */

          /** @external {Blob} https://developer.mozilla.org/en-US/docs/Web/API/Blob */

          /** @external {CanvasRenderingContext2D} https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D */

          /** @external {MediaStreamConstraints} https://developer.mozilla.org/en-US/docs/Web/API/MediaStreamConstraints */

          /** @external {AudioNode} https://developer.mozilla.org/de/docs/Web/API/AudioNode */

          /**
           * @typedef {Object} WavesurferParams
           * @property {AudioContext} audioContext=null Use your own previously
           * initialized AudioContext or leave blank.
           * @property {number} audioRate=1 Speed at which to play audio. Lower number is
           * slower.
           * @property {ScriptProcessorNode} audioScriptProcessor=null Use your own previously
           * initialized ScriptProcessorNode or leave blank.
           * @property {boolean} autoCenter=true If a scrollbar is present, center the
           * waveform on current progress
           * @property {number} autoCenterRate=5 If autoCenter is active, rate at which the
           * waveform is centered
           * @property {boolean} autoCenterImmediately=false If autoCenter is active, immediately
           * center waveform on current progress
           * @property {string} backend='WebAudio' `'WebAudio'|'MediaElement'|'MediaElementWebAudio'` In most cases
           * you don't have to set this manually. MediaElement is a fallback for unsupported browsers.
           * MediaElementWebAudio allows to use WebAudio API also with big audio files, loading audio like with
           * MediaElement backend (HTML5 audio tag). You have to use the same methods of MediaElement backend for loading and
           * playback, giving also peaks, so the audio data are not decoded. In this way you can use WebAudio features, like filters,
           * also with audio with big duration. For example:
           * ` wavesurfer.load(url | HTMLMediaElement, peaks, preload, duration);
           *   wavesurfer.play();
           *   wavesurfer.setFilter(customFilter);
           * `
           * @property {string} backgroundColor=null Change background color of the
           * waveform container.
           * @property {number} barHeight=1 The height of the wave bars.
           * @property {number} barRadius=0 The radius of the wave bars. Makes bars rounded
           * @property {number} barGap=null The optional spacing between bars of the wave,
           * if not provided will be calculated in legacy format.
           * @property {number} barWidth=null Draw the waveform using bars.
           * @property {number} barMinHeight=null If specified, draw at least a bar of this height,
           * eliminating waveform gaps
           * @property {boolean} closeAudioContext=false Close and nullify all audio
           * contexts when the destroy method is called.
           * @property {!string|HTMLElement} container CSS selector or HTML element where
           * the waveform should be drawn. This is the only required parameter.
           * @property {string} cursorColor='#333' The fill color of the cursor indicating
           * the playhead position.
           * @property {number} cursorWidth=1 Measured in pixels.
           * @property {object} drawingContextAttributes={desynchronized: false} Drawing context
           * attributes.
           * @property {number} duration=null Optional audio length so pre-rendered peaks
           * can be display immediately for example.
           * @property {boolean} fillParent=true Whether to fill the entire container or
           * draw only according to `minPxPerSec`.
           * @property {boolean} forceDecode=false Force decoding of audio using web audio
           * when zooming to get a more detailed waveform.
           * @property {number} height=128 The height of the waveform. Measured in
           * pixels.
           * @property {boolean} hideScrollbar=false Whether to hide the horizontal
           * scrollbar when one would normally be shown.
           * @property {boolean} interact=true Whether the mouse interaction will be
           * enabled at initialization. You can switch this parameter at any time later
           * on.
           * @property {boolean} loopSelection=true (Use with regions plugin) Enable
           * looping of selected regions
           * @property {number} maxCanvasWidth=4000 Maximum width of a single canvas in
           * pixels, excluding a small overlap (2 * `pixelRatio`, rounded up to the next
           * even integer). If the waveform is longer than this value, additional canvases
           * will be used to render the waveform, which is useful for very large waveforms
           * that may be too wide for browsers to draw on a single canvas.
           * @property {boolean} mediaControls=false (Use with backend `MediaElement` or `MediaElementWebAudio`)
           * this enables the native controls for the media element
           * @property {string} mediaType='audio' (Use with backend `MediaElement` or `MediaElementWebAudio`)
           * `'audio'|'video'` ('video' only for `MediaElement`)
           * @property {number} minPxPerSec=20 Minimum number of pixels per second of
           * audio.
           * @property {boolean} normalize=false If true, normalize by the maximum peak
           * instead of 1.0.
           * @property {boolean} partialRender=false Use the PeakCache to improve
           * rendering speed of large waveforms
           * @property {number} pixelRatio=window.devicePixelRatio The pixel ratio used to
           * calculate display
           * @property {PluginDefinition[]} plugins=[] An array of plugin definitions to
           * register during instantiation, they will be directly initialised unless they
           * are added with the `deferInit` property set to true.
           * @property {string} progressColor='#555' The fill color of the part of the
           * waveform behind the cursor. When `progressColor` and `waveColor` are the same
           * the progress wave is not rendered at all.
           * @property {boolean} removeMediaElementOnDestroy=true Set to false to keep the
           * media element in the DOM when the player is destroyed. This is useful when
           * reusing an existing media element via the `loadMediaElement` method.
           * @property {Object} renderer=MultiCanvas Can be used to inject a custom
           * renderer.
           * @property {boolean|number} responsive=false If set to `true` resize the
           * waveform, when the window is resized. This is debounced with a `100ms`
           * timeout by default. If this parameter is a number it represents that timeout.
           * @property {boolean} rtl=false If set to `true`, renders waveform from
           * right-to-left.
           * @property {boolean} scrollParent=false Whether to scroll the container with a
           * lengthy waveform. Otherwise the waveform is shrunk to the container width
           * (see fillParent).
           * @property {number} skipLength=2 Number of seconds to skip with the
           * skipForward() and skipBackward() methods.
           * @property {boolean} splitChannels=false Render with separate waveforms for
           * the channels of the audio
           * @property {SplitChannelOptions} splitChannelsOptions={} Options for splitChannel rendering
           * @property {string} waveColor='#999' The fill color of the waveform after the
           * cursor.
           * @property {object} xhr={} XHR options. For example:
           * `let xhr = {
           *     cache: 'default',
           *     mode: 'cors',
           *     method: 'GET',
           *     credentials: 'same-origin',
           *     redirect: 'follow',
           *     referrer: 'client',
           *     requestHeaders: [
           *         {
           *             key: 'Authorization',
           *             value: 'my-token'
           *         }
           *     ]
           * };`
           */

          /**
           * @typedef {Object} PluginDefinition
           * @desc The Object used to describe a plugin
           * @example wavesurfer.addPlugin(pluginDefinition);
           * @property {string} name The name of the plugin, the plugin instance will be
           * added as a property to the wavesurfer instance under this name
           * @property {?Object} staticProps The properties that should be added to the
           * wavesurfer instance as static properties
           * @property {?boolean} deferInit Don't initialise plugin
           * automatically
           * @property {Object} params={} The plugin parameters, they are the first parameter
           * passed to the plugin class constructor function
           * @property {PluginClass} instance The plugin instance factory, is called with
           * the dependency specified in extends. Returns the plugin class.
           */

          /**
           * @typedef {Object} SplitChannelOptions
           * @desc parameters applied when splitChannels option is true
           * @property {boolean} overlay=false determines whether channels are rendered on top of each other or on separate tracks
           * @property {object} channelColors={} object describing color for each channel. Example:
           * {
           *     0: {
           *         progressColor: 'green',
           *         waveColor: 'pink'
           *     },
           *     1: {
           *         progressColor: 'orange',
           *         waveColor: 'purple'
           *     }
           * }
           * @property {number[]} filterChannels=[] indexes of channels to be hidden from rendering
           * @property {boolean} relativeNormalization=false determines whether
           * normalization is done per channel or maintains proportionality between
           * channels. Only applied when normalize and splitChannels are both true.
           * @since 4.3.0
           */

          /**
           * @interface PluginClass
           *
           * @desc This is the interface which is implemented by all plugin classes. Note
           * that this only turns into an observer after being passed through
           * `wavesurfer.addPlugin`.
           *
           * @extends {Observer}
           */
          var PluginClass = /*#__PURE__*/function () {
            /**
             * Construct the plugin
             *
             * @param {Object} params={} The plugin params (specific to the plugin)
             * @param {Object} ws The wavesurfer instance
             */
            function PluginClass(params, ws) {
              _classCallCheck(this, PluginClass);
            }
            /**
             * Initialise the plugin
             *
             * Start doing something. This is called by
             * `wavesurfer.initPlugin(pluginName)`
             */

            _createClass(PluginClass, [{
              key: "create",
              value:
              /**
               * Plugin definition factory
               *
               * This function must be used to create a plugin definition which can be
               * used by wavesurfer to correctly instantiate the plugin.
               *
               * It returns a `PluginDefinition` object representing the plugin.
               *
               * @param {Object} params={} The plugin params (specific to the plugin)
               */
              function create(params) {}
            }, {
              key: "init",
              value: function init() {}
              /**
               * Destroy the plugin instance
               *
               * Stop doing something. This is called by
               * `wavesurfer.destroyPlugin(pluginName)`
               */
            }, {
              key: "destroy",
              value: function destroy() {}
            }]);
            return PluginClass;
          }();
          /**
           * WaveSurfer core library class
           *
           * @extends {Observer}
           * @example
           * const params = {
           *   container: '#waveform',
           *   waveColor: 'violet',
           *   progressColor: 'purple'
           * };
           *
           * // initialise like this
           * const wavesurfer = WaveSurfer.create(params);
           *
           * // or like this ...
           * const wavesurfer = new WaveSurfer(params);
           * wavesurfer.init();
           *
           * // load audio file
           * wavesurfer.load('example/media/demo.wav');
           */

          var WaveSurfer = /*#__PURE__*/function (_util$Observer) {
            _inherits(WaveSurfer, _util$Observer);
            var _super = _createSuper(WaveSurfer);

            /**
             * Initialise wavesurfer instance
             *
             * @param {WavesurferParams} params Instantiation options for wavesurfer
             * @example
             * const wavesurfer = new WaveSurfer(params);
             * @returns {this} Wavesurfer instance
             */
            function WaveSurfer(params) {
              var _this;
              _classCallCheck(this, WaveSurfer);
              _this = _super.call(this);
              /**
               * Extract relevant parameters (or defaults)
               * @private
               */

              _this.defaultParams = {
                audioContext: null,
                audioScriptProcessor: null,
                audioRate: 1,
                autoCenter: true,
                autoCenterRate: 5,
                autoCenterImmediately: false,
                backend: 'WebAudio',
                backgroundColor: null,
                barHeight: 1,
                barRadius: 0,
                barGap: null,
                barMinHeight: null,
                container: null,
                cursorColor: '#333',
                cursorWidth: 1,
                dragSelection: true,
                drawingContextAttributes: {
                  // Boolean that hints the user agent to reduce the latency
                  // by desynchronizing the canvas paint cycle from the event
                  // loop
                  desynchronized: false
                },
                duration: null,
                fillParent: true,
                forceDecode: false,
                height: 128,
                hideScrollbar: false,
                interact: true,
                loopSelection: true,
                maxCanvasWidth: 4000,
                mediaContainer: null,
                mediaControls: false,
                mediaType: 'audio',
                minPxPerSec: 20,
                normalize: false,
                partialRender: false,
                pixelRatio: window.devicePixelRatio || screen.deviceXDPI / screen.logicalXDPI,
                plugins: [],
                progressColor: '#555',
                removeMediaElementOnDestroy: true,
                renderer: _drawer.default,
                responsive: false,
                rtl: false,
                scrollParent: false,
                skipLength: 2,
                splitChannels: false,
                splitChannelsOptions: {
                  overlay: false,
                  channelColors: {},
                  filterChannels: [],
                  relativeNormalization: false
                },
                waveColor: '#999',
                xhr: {}
              };
              _this.backends = {
                MediaElement: _mediaelement.default,
                WebAudio: _webaudio.default,
                MediaElementWebAudio: _mediaelementWebaudio.default
              };
              _this.util = util;
              _this.params = Object.assign({}, _this.defaultParams, params);
              _this.params.splitChannelsOptions = Object.assign({}, _this.defaultParams.splitChannelsOptions, params.splitChannelsOptions);
              /** @private */

              _this.container = 'string' == typeof params.container ? document.querySelector(_this.params.container) : _this.params.container;
              if (!_this.container) {
                throw new Error('Container element not found');
              }
              if (_this.params.mediaContainer == null) {
                /** @private */
                _this.mediaContainer = _this.container;
              } else if (typeof _this.params.mediaContainer == 'string') {
                /** @private */
                _this.mediaContainer = document.querySelector(_this.params.mediaContainer);
              } else {
                /** @private */
                _this.mediaContainer = _this.params.mediaContainer;
              }
              if (!_this.mediaContainer) {
                throw new Error('Media Container element not found');
              }
              if (_this.params.maxCanvasWidth <= 1) {
                throw new Error('maxCanvasWidth must be greater than 1');
              } else if (_this.params.maxCanvasWidth % 2 == 1) {
                throw new Error('maxCanvasWidth must be an even number');
              }
              if (_this.params.rtl === true) {
                util.style(_this.container, {
                  transform: 'rotateY(180deg)'
                });
              }
              if (_this.params.backgroundColor) {
                _this.setBackgroundColor(_this.params.backgroundColor);
              }
              /**
               * @private Used to save the current volume when muting so we can
               * restore once unmuted
               * @type {number}
               */

              _this.savedVolume = 0;
              /**
               * @private The current muted state
               * @type {boolean}
               */

              _this.isMuted = false;
              /**
               * @private Will hold a list of event descriptors that need to be
               * canceled on subsequent loads of audio
               * @type {Object[]}
               */

              _this.tmpEvents = [];
              /**
               * @private Holds any running audio downloads
               * @type {Observer}
               */

              _this.currentRequest = null;
              /** @private */

              _this.arraybuffer = null;
              /** @private */

              _this.drawer = null;
              /** @private */

              _this.backend = null;
              /** @private */

              _this.peakCache = null; // cache constructor objects

              if (typeof _this.params.renderer !== 'function') {
                throw new Error('Renderer parameter is invalid');
              }
              /**
               * @private The uninitialised Drawer class
               */

              _this.Drawer = _this.params.renderer;
              /**
               * @private The uninitialised Backend class
               */
              // Back compat

              if (_this.params.backend == 'AudioElement') {
                _this.params.backend = 'MediaElement';
              }
              if ((_this.params.backend == 'WebAudio' || _this.params.backend === 'MediaElementWebAudio') && !_webaudio.default.prototype.supportsWebAudio.call(null)) {
                _this.params.backend = 'MediaElement';
              }
              _this.Backend = _this.backends[_this.params.backend];
              /**
               * @private map of plugin names that are currently initialised
               */

              _this.initialisedPluginList = {};
              /** @private */

              _this.isDestroyed = false;
              /**
               * Get the current ready status.
               *
               * @example const isReady = wavesurfer.isReady;
               * @return {boolean}
               */

              _this.isReady = false; // responsive debounced event listener. If this.params.responsive is not
              // set, this is never called. Use 100ms or this.params.responsive as
              // timeout for the debounce function.

              var prevWidth = 0;
              _this._onResize = util.debounce(function () {
                if (prevWidth != _this.drawer.wrapper.clientWidth && !_this.params.scrollParent) {
                  prevWidth = _this.drawer.wrapper.clientWidth;
                  _this.drawer.fireEvent('redraw');
                }
              }, typeof _this.params.responsive === 'number' ? _this.params.responsive : 100);
              return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
            }
            /**
             * Initialise the wave
             *
             * @example
             * var wavesurfer = new WaveSurfer(params);
             * wavesurfer.init();
             * @return {this} The wavesurfer instance
             */

            _createClass(WaveSurfer, [{
              key: "init",
              value: function init() {
                this.registerPlugins(this.params.plugins);
                this.createDrawer();
                this.createBackend();
                this.createPeakCache();
                return this;
              }
              /**
               * Add and initialise array of plugins (if `plugin.deferInit` is falsey),
               * this function is called in the init function of wavesurfer
               *
               * @param {PluginDefinition[]} plugins An array of plugin definitions
               * @emits {WaveSurfer#plugins-registered} Called with the array of plugin definitions
               * @return {this} The wavesurfer instance
               */
            }, {
              key: "registerPlugins",
              value: function registerPlugins(plugins) {
                var _this2 = this;

                // first instantiate all the plugins
                plugins.forEach(function (plugin) {
                  return _this2.addPlugin(plugin);
                }); // now run the init functions

                plugins.forEach(function (plugin) {
                  // call init function of the plugin if deferInit is falsey
                  // in that case you would manually use initPlugins()
                  if (!plugin.deferInit) {
                    _this2.initPlugin(plugin.name);
                  }
                });
                this.fireEvent('plugins-registered', plugins);
                return this;
              }
              /**
               * Get a map of plugin names that are currently initialised
               *
               * @example wavesurfer.getPlugins();
               * @return {Object} Object with plugin names
               */
            }, {
              key: "getActivePlugins",
              value: function getActivePlugins() {
                return this.initialisedPluginList;
              }
              /**
               * Add a plugin object to wavesurfer
               *
               * @param {PluginDefinition} plugin A plugin definition
               * @emits {WaveSurfer#plugin-added} Called with the name of the plugin that was added
               * @example wavesurfer.addPlugin(WaveSurfer.minimap());
               * @return {this} The wavesurfer instance
               */
            }, {
              key: "addPlugin",
              value: function addPlugin(plugin) {
                var _this3 = this;
                if (!plugin.name) {
                  throw new Error('Plugin does not have a name!');
                }
                if (!plugin.instance) {
                  throw new Error("Plugin ".concat(plugin.name, " does not have an instance property!"));
                } // staticProps properties are applied to wavesurfer instance

                if (plugin.staticProps) {
                  Object.keys(plugin.staticProps).forEach(function (pluginStaticProp) {
                    /**
                     * Properties defined in a plugin definition's `staticProps` property are added as
                     * staticProps properties of the WaveSurfer instance
                     */
                    _this3[pluginStaticProp] = plugin.staticProps[pluginStaticProp];
                  });
                }
                var Instance = plugin.instance; // turn the plugin instance into an observer

                var observerPrototypeKeys = Object.getOwnPropertyNames(util.Observer.prototype);
                observerPrototypeKeys.forEach(function (key) {
                  Instance.prototype[key] = util.Observer.prototype[key];
                });
                /**
                 * Instantiated plugin classes are added as a property of the wavesurfer
                 * instance
                 * @type {Object}
                 */

                this[plugin.name] = new Instance(plugin.params || {}, this);
                this.fireEvent('plugin-added', plugin.name);
                return this;
              }
              /**
               * Initialise a plugin
               *
               * @param {string} name A plugin name
               * @emits WaveSurfer#plugin-initialised
               * @example wavesurfer.initPlugin('minimap');
               * @return {this} The wavesurfer instance
               */
            }, {
              key: "initPlugin",
              value: function initPlugin(name) {
                if (!this[name]) {
                  throw new Error("Plugin ".concat(name, " has not been added yet!"));
                }
                if (this.initialisedPluginList[name]) {
                  // destroy any already initialised plugins
                  this.destroyPlugin(name);
                }
                this[name].init();
                this.initialisedPluginList[name] = true;
                this.fireEvent('plugin-initialised', name);
                return this;
              }
              /**
               * Destroy a plugin
               *
               * @param {string} name A plugin name
               * @emits WaveSurfer#plugin-destroyed
               * @example wavesurfer.destroyPlugin('minimap');
               * @returns {this} The wavesurfer instance
               */
            }, {
              key: "destroyPlugin",
              value: function destroyPlugin(name) {
                if (!this[name]) {
                  throw new Error("Plugin ".concat(name, " has not been added yet and cannot be destroyed!"));
                }
                if (!this.initialisedPluginList[name]) {
                  throw new Error("Plugin ".concat(name, " is not active and cannot be destroyed!"));
                }
                if (typeof this[name].destroy !== 'function') {
                  throw new Error("Plugin ".concat(name, " does not have a destroy function!"));
                }
                this[name].destroy();
                delete this.initialisedPluginList[name];
                this.fireEvent('plugin-destroyed', name);
                return this;
              }
              /**
               * Destroy all initialised plugins. Convenience function to use when
               * wavesurfer is removed
               *
               * @private
               */
            }, {
              key: "destroyAllPlugins",
              value: function destroyAllPlugins() {
                var _this4 = this;
                Object.keys(this.initialisedPluginList).forEach(function (name) {
                  return _this4.destroyPlugin(name);
                });
              }
              /**
               * Create the drawer and draw the waveform
               *
               * @private
               * @emits WaveSurfer#drawer-created
               */
            }, {
              key: "createDrawer",
              value: function createDrawer() {
                var _this5 = this;
                this.drawer = new this.Drawer(this.container, this.params);
                this.drawer.init();
                this.fireEvent('drawer-created', this.drawer);
                if (this.params.responsive !== false) {
                  window.addEventListener('resize', this._onResize, true);
                  window.addEventListener('orientationchange', this._onResize, true);
                }
                this.drawer.on('redraw', function () {
                  _this5.drawBuffer();
                  _this5.drawer.progress(_this5.backend.getPlayedPercents());
                }); // Click-to-seek

                this.drawer.on('click', function (e, progress) {
                  setTimeout(function () {
                    return _this5.seekTo(progress);
                  }, 0);
                }); // Relay the scroll event from the drawer

                this.drawer.on('scroll', function (e) {
                  if (_this5.params.partialRender) {
                    _this5.drawBuffer();
                  }
                  _this5.fireEvent('scroll', e);
                });
              }
              /**
               * Create the backend
               *
               * @private
               * @emits WaveSurfer#backend-created
               */
            }, {
              key: "createBackend",
              value: function createBackend() {
                var _this6 = this;
                if (this.backend) {
                  this.backend.destroy();
                }
                this.backend = new this.Backend(this.params);
                this.backend.init();
                this.fireEvent('backend-created', this.backend);
                this.backend.on('finish', function () {
                  _this6.drawer.progress(_this6.backend.getPlayedPercents());
                  _this6.fireEvent('finish');
                });
                this.backend.on('play', function () {
                  return _this6.fireEvent('play');
                });
                this.backend.on('pause', function () {
                  return _this6.fireEvent('pause');
                });
                this.backend.on('audioprocess', function (time) {
                  _this6.drawer.progress(_this6.backend.getPlayedPercents());
                  _this6.fireEvent('audioprocess', time);
                }); // only needed for MediaElement and MediaElementWebAudio backend

                if (this.params.backend === 'MediaElement' || this.params.backend === 'MediaElementWebAudio') {
                  this.backend.on('seek', function () {
                    _this6.drawer.progress(_this6.backend.getPlayedPercents());
                  });
                  this.backend.on('volume', function () {
                    var newVolume = _this6.getVolume();
                    _this6.fireEvent('volume', newVolume);
                    if (_this6.backend.isMuted !== _this6.isMuted) {
                      _this6.isMuted = _this6.backend.isMuted;
                      _this6.fireEvent('mute', _this6.isMuted);
                    }
                  });
                }
              }
              /**
               * Create the peak cache
               *
               * @private
               */
            }, {
              key: "createPeakCache",
              value: function createPeakCache() {
                if (this.params.partialRender) {
                  this.peakCache = new _peakcache.default();
                }
              }
              /**
               * Get the duration of the audio clip
               *
               * @example const duration = wavesurfer.getDuration();
               * @return {number} Duration in seconds
               */
            }, {
              key: "getDuration",
              value: function getDuration() {
                return this.backend.getDuration();
              }
              /**
               * Get the current playback position
               *
               * @example const currentTime = wavesurfer.getCurrentTime();
               * @return {number} Playback position in seconds
               */
            }, {
              key: "getCurrentTime",
              value: function getCurrentTime() {
                return this.backend.getCurrentTime();
              }
              /**
               * Set the current play time in seconds.
               *
               * @param {number} seconds A positive number in seconds. E.g. 10 means 10
               * seconds, 60 means 1 minute
               */
            }, {
              key: "setCurrentTime",
              value: function setCurrentTime(seconds) {
                if (seconds >= this.getDuration()) {
                  this.seekTo(1);
                } else {
                  this.seekTo(seconds / this.getDuration());
                }
              }
              /**
               * Starts playback from the current position. Optional start and end
               * measured in seconds can be used to set the range of audio to play.
               *
               * @param {?number} start Position to start at
               * @param {?number} end Position to end at
               * @emits WaveSurfer#interaction
               * @return {Promise} Result of the backend play method
               * @example
               * // play from second 1 to 5
               * wavesurfer.play(1, 5);
               */
            }, {
              key: "play",
              value: function play(start, end) {
                var _this7 = this;
                this.fireEvent('interaction', function () {
                  return _this7.play(start, end);
                });
                return this.backend.play(start, end);
              }
              /**
               * Set a point in seconds for playback to stop at.
               *
               * @param {number} position Position (in seconds) to stop at
               * @version 3.3.0
               */
            }, {
              key: "setPlayEnd",
              value: function setPlayEnd(position) {
                this.backend.setPlayEnd(position);
              }
              /**
               * Stops and pauses playback
               *
               * @example wavesurfer.pause();
               * @return {Promise} Result of the backend pause method
               */
            }, {
              key: "pause",
              value: function pause() {
                if (!this.backend.isPaused()) {
                  return this.backend.pause();
                }
              }
              /**
               * Toggle playback
               *
               * @example wavesurfer.playPause();
               * @return {Promise} Result of the backend play or pause method
               */
            }, {
              key: "playPause",
              value: function playPause() {
                return this.backend.isPaused() ? this.play() : this.pause();
              }
              /**
               * Get the current playback state
               *
               * @example const isPlaying = wavesurfer.isPlaying();
               * @return {boolean} False if paused, true if playing
               */
            }, {
              key: "isPlaying",
              value: function isPlaying() {
                return !this.backend.isPaused();
              }
              /**
               * Skip backward
               *
               * @param {?number} seconds Amount to skip back, if not specified `skipLength`
               * is used
               * @example wavesurfer.skipBackward();
               */
            }, {
              key: "skipBackward",
              value: function skipBackward(seconds) {
                this.skip(-seconds || -this.params.skipLength);
              }
              /**
               * Skip forward
               *
               * @param {?number} seconds Amount to skip back, if not specified `skipLength`
               * is used
               * @example wavesurfer.skipForward();
               */
            }, {
              key: "skipForward",
              value: function skipForward(seconds) {
                this.skip(seconds || this.params.skipLength);
              }
              /**
               * Skip a number of seconds from the current position (use a negative value
               * to go backwards).
               *
               * @param {number} offset Amount to skip back or forwards
               * @example
               * // go back 2 seconds
               * wavesurfer.skip(-2);
               */
            }, {
              key: "skip",
              value: function skip(offset) {
                var duration = this.getDuration() || 1;
                var position = this.getCurrentTime() || 0;
                position = Math.max(0, Math.min(duration, position + (offset || 0)));
                this.seekAndCenter(position / duration);
              }
              /**
               * Seeks to a position and centers the view
               *
               * @param {number} progress Between 0 (=beginning) and 1 (=end)
               * @example
               * // seek and go to the middle of the audio
               * wavesurfer.seekTo(0.5);
               */
            }, {
              key: "seekAndCenter",
              value: function seekAndCenter(progress) {
                this.seekTo(progress);
                this.drawer.recenter(progress);
              }
              /**
               * Seeks to a position
               *
               * @param {number} progress Between 0 (=beginning) and 1 (=end)
               * @emits WaveSurfer#interaction
               * @emits WaveSurfer#seek
               * @example
               * // seek to the middle of the audio
               * wavesurfer.seekTo(0.5);
               */
            }, {
              key: "seekTo",
              value: function seekTo(progress) {
                var _this8 = this;

                // return an error if progress is not a number between 0 and 1
                if (typeof progress !== 'number' || !isFinite(progress) || progress < 0 || progress > 1) {
                  throw new Error('Error calling wavesurfer.seekTo, parameter must be a number between 0 and 1!');
                }
                this.fireEvent('interaction', function () {
                  return _this8.seekTo(progress);
                });
                var isWebAudioBackend = this.params.backend === 'WebAudio';
                var paused = this.backend.isPaused();
                if (isWebAudioBackend && !paused) {
                  this.backend.pause();
                } // avoid small scrolls while paused seeking

                var oldScrollParent = this.params.scrollParent;
                this.params.scrollParent = false;
                this.backend.seekTo(progress * this.getDuration());
                this.drawer.progress(progress);
                if (isWebAudioBackend && !paused) {
                  this.backend.play();
                }
                this.params.scrollParent = oldScrollParent;
                this.fireEvent('seek', progress);
              }
              /**
               * Stops and goes to the beginning.
               *
               * @example wavesurfer.stop();
               */
            }, {
              key: "stop",
              value: function stop() {
                this.pause();
                this.seekTo(0);
                this.drawer.progress(0);
              }
              /**
               * Sets the ID of the audio device to use for output and returns a Promise.
               *
               * @param {string} deviceId String value representing underlying output
               * device
               * @returns {Promise} `Promise` that resolves to `undefined` when there are
               * no errors detected.
               */
            }, {
              key: "setSinkId",
              value: function setSinkId(deviceId) {
                return this.backend.setSinkId(deviceId);
              }
              /**
               * Set the playback volume.
               *
               * @param {number} newVolume A value between 0 and 1, 0 being no
               * volume and 1 being full volume.
               * @emits WaveSurfer#volume
               */
            }, {
              key: "setVolume",
              value: function setVolume(newVolume) {
                this.backend.setVolume(newVolume);
                this.fireEvent('volume', newVolume);
              }
              /**
               * Get the playback volume.
               *
               * @return {number} A value between 0 and 1, 0 being no
               * volume and 1 being full volume.
               */
            }, {
              key: "getVolume",
              value: function getVolume() {
                return this.backend.getVolume();
              }
              /**
               * Set the playback rate.
               *
               * @param {number} rate A positive number. E.g. 0.5 means half the normal
               * speed, 2 means double speed and so on.
               * @example wavesurfer.setPlaybackRate(2);
               */
            }, {
              key: "setPlaybackRate",
              value: function setPlaybackRate(rate) {
                this.backend.setPlaybackRate(rate);
              }
              /**
               * Get the playback rate.
               *
               * @return {number} The current playback rate.
               */
            }, {
              key: "getPlaybackRate",
              value: function getPlaybackRate() {
                return this.backend.getPlaybackRate();
              }
              /**
               * Toggle the volume on and off. If not currently muted it will save the
               * current volume value and turn the volume off. If currently muted then it
               * will restore the volume to the saved value, and then rest the saved
               * value.
               *
               * @example wavesurfer.toggleMute();
               */
            }, {
              key: "toggleMute",
              value: function toggleMute() {
                this.setMute(!this.isMuted);
              }
              /**
               * Enable or disable muted audio
               *
               * @param {boolean} mute Specify `true` to mute audio.
               * @emits WaveSurfer#volume
               * @emits WaveSurfer#mute
               * @example
               * // unmute
               * wavesurfer.setMute(false);
               * console.log(wavesurfer.getMute()) // logs false
               */
            }, {
              key: "setMute",
              value: function setMute(mute) {
                // ignore all muting requests if the audio is already in that state
                if (mute === this.isMuted) {
                  this.fireEvent('mute', this.isMuted);
                  return;
                }
                if (this.backend.setMute) {
                  // Backends such as the MediaElement backend have their own handling
                  // of mute, let them handle it.
                  this.backend.setMute(mute);
                  this.isMuted = mute;
                } else {
                  if (mute) {
                    // If currently not muted then save current volume,
                    // turn off the volume and update the mute properties
                    this.savedVolume = this.backend.getVolume();
                    this.backend.setVolume(0);
                    this.isMuted = true;
                    this.fireEvent('volume', 0);
                  } else {
                    // If currently muted then restore to the saved volume
                    // and update the mute properties
                    this.backend.setVolume(this.savedVolume);
                    this.isMuted = false;
                    this.fireEvent('volume', this.savedVolume);
                  }
                }
                this.fireEvent('mute', this.isMuted);
              }
              /**
               * Get the current mute status.
               *
               * @example const isMuted = wavesurfer.getMute();
               * @return {boolean} Current mute status
               */
            }, {
              key: "getMute",
              value: function getMute() {
                return this.isMuted;
              }
              /**
               * Get the list of current set filters as an array.
               *
               * Filters must be set with setFilters method first
               *
               * @return {array} List of enabled filters
               */
            }, {
              key: "getFilters",
              value: function getFilters() {
                return this.backend.filters || [];
              }
              /**
               * Toggles `scrollParent` and redraws
               *
               * @example wavesurfer.toggleScroll();
               */
            }, {
              key: "toggleScroll",
              value: function toggleScroll() {
                this.params.scrollParent = !this.params.scrollParent;
                this.drawBuffer();
              }
              /**
               * Toggle mouse interaction
               *
               * @example wavesurfer.toggleInteraction();
               */
            }, {
              key: "toggleInteraction",
              value: function toggleInteraction() {
                this.params.interact = !this.params.interact;
              }
              /**
               * Get the fill color of the waveform after the cursor.
               *
               * @return {string} A CSS color string.
               */
            }, {
              key: "getWaveColor",
              value: function getWaveColor() {
                return this.params.waveColor;
              }
              /**
               * Set the fill color of the waveform after the cursor.
               *
               * @param {string} color A CSS color string.
               * @example wavesurfer.setWaveColor('#ddd');
               */
            }, {
              key: "setWaveColor",
              value: function setWaveColor(color) {
                this.params.waveColor = color;
                this.drawBuffer();
              }
              /**
               * Get the fill color of the waveform behind the cursor.
               *
               * @return {string} A CSS color string.
               */
            }, {
              key: "getProgressColor",
              value: function getProgressColor() {
                return this.params.progressColor;
              }
              /**
               * Set the fill color of the waveform behind the cursor.
               *
               * @param {string} color A CSS color string.
               * @example wavesurfer.setProgressColor('#400');
               */
            }, {
              key: "setProgressColor",
              value: function setProgressColor(color) {
                this.params.progressColor = color;
                this.drawBuffer();
              }
              /**
               * Get the background color of the waveform container.
               *
               * @return {string} A CSS color string.
               */
            }, {
              key: "getBackgroundColor",
              value: function getBackgroundColor() {
                return this.params.backgroundColor;
              }
              /**
               * Set the background color of the waveform container.
               *
               * @param {string} color A CSS color string.
               * @example wavesurfer.setBackgroundColor('#FF00FF');
               */
            }, {
              key: "setBackgroundColor",
              value: function setBackgroundColor(color) {
                this.params.backgroundColor = color;
                util.style(this.container, {
                  background: this.params.backgroundColor
                });
              }
              /**
               * Get the fill color of the cursor indicating the playhead
               * position.
               *
               * @return {string} A CSS color string.
               */
            }, {
              key: "getCursorColor",
              value: function getCursorColor() {
                return this.params.cursorColor;
              }
              /**
               * Set the fill color of the cursor indicating the playhead
               * position.
               *
               * @param {string} color A CSS color string.
               * @example wavesurfer.setCursorColor('#222');
               */
            }, {
              key: "setCursorColor",
              value: function setCursorColor(color) {
                this.params.cursorColor = color;
                this.drawer.updateCursor();
              }
              /**
               * Get the height of the waveform.
               *
               * @return {number} Height measured in pixels.
               */
            }, {
              key: "getHeight",
              value: function getHeight() {
                return this.params.height;
              }
              /**
               * Set the height of the waveform.
               *
               * @param {number} height Height measured in pixels.
               * @example wavesurfer.setHeight(200);
               */
            }, {
              key: "setHeight",
              value: function setHeight(height) {
                this.params.height = height;
                this.drawer.setHeight(height * this.params.pixelRatio);
                this.drawBuffer();
              }
              /**
               * Hide channels from being drawn on the waveform if splitting channels.
               *
               * For example, if we want to draw only the peaks for the right stereo channel:
               *
               * const wavesurfer = new WaveSurfer.create({...splitChannels: true});
               * wavesurfer.load('stereo_audio.mp3');
               *
               * wavesurfer.setFilteredChannel([0]); <-- hide left channel peaks.
               *
               * @param {array} channelIndices Channels to be filtered out from drawing.
               * @version 4.0.0
               */
            }, {
              key: "setFilteredChannels",
              value: function setFilteredChannels(channelIndices) {
                this.params.splitChannelsOptions.filterChannels = channelIndices;
                this.drawBuffer();
              }
              /**
               * Get the correct peaks for current wave view-port and render wave
               *
               * @private
               * @emits WaveSurfer#redraw
               */
            }, {
              key: "drawBuffer",
              value: function drawBuffer() {
                var nominalWidth = Math.round(this.getDuration() * this.params.minPxPerSec * this.params.pixelRatio);
                var parentWidth = this.drawer.getWidth();
                var width = nominalWidth; // always start at 0 after zooming for scrolling : issue redraw left part

                var start = 0;
                var end = Math.max(start + parentWidth, width); // Fill container

                if (this.params.fillParent && (!this.params.scrollParent || nominalWidth < parentWidth)) {
                  width = parentWidth;
                  start = 0;
                  end = width;
                }
                var peaks;
                if (this.params.partialRender) {
                  var newRanges = this.peakCache.addRangeToPeakCache(width, start, end);
                  var i;
                  for (i = 0; i < newRanges.length; i++) {
                    peaks = this.backend.getPeaks(width, newRanges[i][0], newRanges[i][1]);
                    this.drawer.drawPeaks(peaks, width, newRanges[i][0], newRanges[i][1]);
                  }
                } else {
                  peaks = this.backend.getPeaks(width, start, end);
                  this.drawer.drawPeaks(peaks, width, start, end);
                }
                this.fireEvent('redraw', peaks, width);
              }
              /**
               * Horizontally zooms the waveform in and out. It also changes the parameter
               * `minPxPerSec` and enables the `scrollParent` option. Calling the function
               * with a falsey parameter will reset the zoom state.
               *
               * @param {?number} pxPerSec Number of horizontal pixels per second of
               * audio, if none is set the waveform returns to unzoomed state
               * @emits WaveSurfer#zoom
               * @example wavesurfer.zoom(20);
               */
            }, {
              key: "zoom",
              value: function zoom(pxPerSec) {
                if (!pxPerSec) {
                  this.params.minPxPerSec = this.defaultParams.minPxPerSec;
                  this.params.scrollParent = false;
                } else {
                  this.params.minPxPerSec = pxPerSec;
                  this.params.scrollParent = true;
                }
                this.drawBuffer();
                this.drawer.progress(this.backend.getPlayedPercents());
                this.drawer.recenter(this.getCurrentTime() / this.getDuration());
                this.fireEvent('zoom', pxPerSec);
              }
              /**
               * Decode buffer and load
               *
               * @private
               * @param {ArrayBuffer} arraybuffer Buffer to process
               */
            }, {
              key: "loadArrayBuffer",
              value: function loadArrayBuffer(arraybuffer) {
                var _this9 = this;
                this.decodeArrayBuffer(arraybuffer, function (data) {
                  if (!_this9.isDestroyed) {
                    _this9.loadDecodedBuffer(data);
                  }
                });
              }
              /**
               * Directly load an externally decoded AudioBuffer
               *
               * @private
               * @param {AudioBuffer} buffer Buffer to process
               * @emits WaveSurfer#ready
               */
            }, {
              key: "loadDecodedBuffer",
              value: function loadDecodedBuffer(buffer) {
                this.backend.load(buffer);
                this.drawBuffer();
                this.isReady = true;
                this.fireEvent('ready');
              }
              /**
               * Loads audio data from a Blob or File object
               *
               * @param {Blob|File} blob Audio data
               * @example
               */
            }, {
              key: "loadBlob",
              value: function loadBlob(blob) {
                var _this10 = this;

                // Create file reader
                var reader = new FileReader();
                reader.addEventListener('progress', function (e) {
                  return _this10.onProgress(e);
                });
                reader.addEventListener('load', function (e) {
                  return _this10.loadArrayBuffer(e.target.result);
                });
                reader.addEventListener('error', function () {
                  return _this10.fireEvent('error', 'Error reading file');
                });
                reader.readAsArrayBuffer(blob);
                this.empty();
              }
              /**
               * Loads audio and re-renders the waveform.
               *
               * @param {string|HTMLMediaElement} url The url of the audio file or the
               * audio element with the audio
               * @param {number[]|Number.<Array[]>} peaks Wavesurfer does not have to decode
               * the audio to render the waveform if this is specified
               * @param {?string} preload (Use with backend `MediaElement` and `MediaElementWebAudio`)
               * `'none'|'metadata'|'auto'` Preload attribute for the media element
               * @param {?number} duration The duration of the audio. This is used to
               * render the peaks data in the correct size for the audio duration (as
               * befits the current `minPxPerSec` and zoom value) without having to decode
               * the audio.
               * @returns {void}
               * @throws Will throw an error if the `url` argument is empty.
               * @example
               * // uses fetch or media element to load file (depending on backend)
               * wavesurfer.load('http://example.com/demo.wav');
               *
               * // setting preload attribute with media element backend and supplying
               * // peaks
               * wavesurfer.load(
               *   'http://example.com/demo.wav',
               *   [0.0218, 0.0183, 0.0165, 0.0198, 0.2137, 0.2888],
               *   true
               * );
               */
            }, {
              key: "load",
              value: function load(url, peaks, preload, duration) {
                if (!url) {
                  throw new Error('url parameter cannot be empty');
                }
                this.empty();
                if (preload) {
                  // check whether the preload attribute will be usable and if not log
                  // a warning listing the reasons why not and nullify the variable
                  var preloadIgnoreReasons = {
                    "Preload is not 'auto', 'none' or 'metadata'": ['auto', 'metadata', 'none'].indexOf(preload) === -1,
                    'Peaks are not provided': !peaks,
                    "Backend is not of type 'MediaElement' or 'MediaElementWebAudio'": ['MediaElement', 'MediaElementWebAudio'].indexOf(this.params.backend) === -1,
                    'Url is not of type string': typeof url !== 'string'
                  };
                  var activeReasons = Object.keys(preloadIgnoreReasons).filter(function (reason) {
                    return preloadIgnoreReasons[reason];
                  });
                  if (activeReasons.length) {
                    // eslint-disable-next-line no-console
                    console.warn('Preload parameter of wavesurfer.load will be ignored because:\n\t- ' + activeReasons.join('\n\t- ')); // stop invalid values from being used

                    preload = null;
                  }
                } // loadBuffer(url, peaks, duration) requires that url is a string
                // but users can pass in a HTMLMediaElement to WaveSurfer

                if (this.params.backend === 'WebAudio' && url instanceof HTMLMediaElement) {
                  url = url.src;
                }
                switch (this.params.backend) {
                  case 'WebAudio':
                    return this.loadBuffer(url, peaks, duration);
                  case 'MediaElement':
                  case 'MediaElementWebAudio':
                    return this.loadMediaElement(url, peaks, preload, duration);
                }
              }
              /**
               * Loads audio using Web Audio buffer backend.
               *
               * @private
               * @emits WaveSurfer#waveform-ready
               * @param {string} url URL of audio file
               * @param {number[]|Number.<Array[]>} peaks Peaks data
               * @param {?number} duration Optional duration of audio file
               * @returns {void}
               */
            }, {
              key: "loadBuffer",
              value: function loadBuffer(url, peaks, duration) {
                var _this11 = this;
                var load = function load(action) {
                  if (action) {
                    _this11.tmpEvents.push(_this11.once('ready', action));
                  }
                  return _this11.getArrayBuffer(url, function (data) {
                    return _this11.loadArrayBuffer(data);
                  });
                };
                if (peaks) {
                  this.backend.setPeaks(peaks, duration);
                  this.drawBuffer();
                  this.fireEvent('waveform-ready');
                  this.tmpEvents.push(this.once('interaction', load));
                } else {
                  return load();
                }
              }
              /**
               * Either create a media element, or load an existing media element.
               *
               * @private
               * @emits WaveSurfer#waveform-ready
               * @param {string|HTMLMediaElement} urlOrElt Either a path to a media file, or an
               * existing HTML5 Audio/Video Element
               * @param {number[]|Number.<Array[]>} peaks Array of peaks. Required to bypass web audio
               * dependency
               * @param {?boolean} preload Set to true if the preload attribute of the
               * audio element should be enabled
               * @param {?number} duration Optional duration of audio file
               */
            }, {
              key: "loadMediaElement",
              value: function loadMediaElement(urlOrElt, peaks, preload, duration) {
                var _this12 = this;
                var url = urlOrElt;
                if (typeof urlOrElt === 'string') {
                  this.backend.load(url, this.mediaContainer, peaks, preload);
                } else {
                  var elt = urlOrElt;
                  this.backend.loadElt(elt, peaks); // If peaks are not provided,
                  // url = element.src so we can get peaks with web audio

                  url = elt.src;
                }
                this.tmpEvents.push(this.backend.once('canplay', function () {
                  // ignore when backend was already destroyed
                  if (!_this12.backend.destroyed) {
                    _this12.drawBuffer();
                    _this12.isReady = true;
                    _this12.fireEvent('ready');
                  }
                }), this.backend.once('error', function (err) {
                  return _this12.fireEvent('error', err);
                })); // If peaks are provided, render them and fire the `waveform-ready` event.

                if (peaks) {
                  this.backend.setPeaks(peaks, duration);
                  this.drawBuffer();
                  this.fireEvent('waveform-ready');
                } // If no pre-decoded peaks are provided, or are provided with
                // forceDecode flag, attempt to download the audio file and decode it
                // with Web Audio.

                if ((!peaks || this.params.forceDecode) && this.backend.supportsWebAudio()) {
                  this.getArrayBuffer(url, function (arraybuffer) {
                    _this12.decodeArrayBuffer(arraybuffer, function (buffer) {
                      _this12.backend.buffer = buffer;
                      _this12.backend.setPeaks(null);
                      _this12.drawBuffer();
                      _this12.fireEvent('waveform-ready');
                    });
                  });
                }
              }
              /**
               * Decode an array buffer and pass data to a callback
               *
               * @private
               * @param {Object} arraybuffer The array buffer to decode
               * @param {function} callback The function to call on complete
               */
            }, {
              key: "decodeArrayBuffer",
              value: function decodeArrayBuffer(arraybuffer, callback) {
                var _this13 = this;
                this.arraybuffer = arraybuffer;
                this.backend.decodeArrayBuffer(arraybuffer, function (data) {
                  // Only use the decoded data if we haven't been destroyed or
                  // another decode started in the meantime
                  if (!_this13.isDestroyed && _this13.arraybuffer == arraybuffer) {
                    callback(data);
                    _this13.arraybuffer = null;
                  }
                }, function () {
                  return _this13.fireEvent('error', 'Error decoding audiobuffer');
                });
              }
              /**
               * Load an array buffer using fetch and pass the result to a callback
               *
               * @param {string} url The URL of the file object
               * @param {function} callback The function to call on complete
               * @returns {util.fetchFile} fetch call
               * @private
               */
            }, {
              key: "getArrayBuffer",
              value: function getArrayBuffer(url, callback) {
                var _this14 = this;
                var options = Object.assign({
                  url: url,
                  responseType: 'arraybuffer'
                }, this.params.xhr);
                var request = util.fetchFile(options);
                this.currentRequest = request;
                this.tmpEvents.push(request.on('progress', function (e) {
                  _this14.onProgress(e);
                }), request.on('success', function (data) {
                  callback(data);
                  _this14.currentRequest = null;
                }), request.on('error', function (e) {
                  _this14.fireEvent('error', e);
                  _this14.currentRequest = null;
                }));
                return request;
              }
              /**
               * Called while the audio file is loading
               *
               * @private
               * @param {Event} e Progress event
               * @emits WaveSurfer#loading
               */
            }, {
              key: "onProgress",
              value: function onProgress(e) {
                var percentComplete;
                if (e.lengthComputable) {
                  percentComplete = e.loaded / e.total;
                } else {
                  // Approximate progress with an asymptotic
                  // function, and assume downloads in the 1-3 MB range.
                  percentComplete = e.loaded / (e.loaded + 1000000);
                }
                this.fireEvent('loading', Math.round(percentComplete * 100), e.target);
              }
              /**
               * Exports PCM data into a JSON array and opens in a new window.
               *
               * @param {number} length=1024 The scale in which to export the peaks
               * @param {number} accuracy=10000
               * @param {?boolean} noWindow Set to true to disable opening a new
               * window with the JSON
               * @param {number} start Start index
               * @param {number} end End index
               * @return {Promise} Promise that resolves with array of peaks
               */
            }, {
              key: "exportPCM",
              value: function exportPCM(length, accuracy, noWindow, start, end) {
                length = length || 1024;
                start = start || 0;
                accuracy = accuracy || 10000;
                noWindow = noWindow || false;
                var peaks = this.backend.getPeaks(length, start, end);
                var arr = [].map.call(peaks, function (val) {
                  return Math.round(val * accuracy) / accuracy;
                });
                return new Promise(function (resolve, reject) {
                  var json = JSON.stringify(arr);
                  if (!noWindow) {
                    window.open('data:application/json;charset=utf-8,' + encodeURIComponent(json));
                  }
                  resolve(json);
                });
              }
              /**
               * Save waveform image as data URI.
               *
               * The default format is `'image/png'`. Other supported types are
               * `'image/jpeg'` and `'image/webp'`.
               *
               * @param {string} format='image/png' A string indicating the image format.
               * The default format type is `'image/png'`.
               * @param {number} quality=1 A number between 0 and 1 indicating the image
               * quality to use for image formats that use lossy compression such as
               * `'image/jpeg'`` and `'image/webp'`.
               * @param {string} type Image data type to return. Either 'dataURL' (default)
               * or 'blob'.
               * @return {string|string[]|Promise} When using `'dataURL'` type this returns
               * a single data URL or an array of data URLs, one for each canvas. When using
               * `'blob'` type this returns a `Promise` resolving with an array of `Blob`
               * instances, one for each canvas.
               */
            }, {
              key: "exportImage",
              value: function exportImage(format, quality, type) {
                if (!format) {
                  format = 'image/png';
                }
                if (!quality) {
                  quality = 1;
                }
                if (!type) {
                  type = 'dataURL';
                }
                return this.drawer.getImage(format, quality, type);
              }
              /**
               * Cancel any fetch request currently in progress
               */
            }, {
              key: "cancelAjax",
              value: function cancelAjax() {
                if (this.currentRequest && this.currentRequest.controller) {
                  // If the current request has a ProgressHandler, then its ReadableStream might need to be cancelled too
                  // See: Wavesurfer issue #2042
                  // See Firefox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1583815
                  if (this.currentRequest._reader) {
                    // Ignoring exceptions thrown by call to cancel()
                    this.currentRequest._reader.cancel().catch(function (err) {});
                  }
                  this.currentRequest.controller.abort();
                  this.currentRequest = null;
                }
              }
              /**
               * @private
               */
            }, {
              key: "clearTmpEvents",
              value: function clearTmpEvents() {
                this.tmpEvents.forEach(function (e) {
                  return e.un();
                });
              }
              /**
               * Display empty waveform.
               */
            }, {
              key: "empty",
              value: function empty() {
                if (!this.backend.isPaused()) {
                  this.stop();
                  this.backend.disconnectSource();
                }
                this.isReady = false;
                this.cancelAjax();
                this.clearTmpEvents(); // empty drawer

                this.drawer.progress(0);
                this.drawer.setWidth(0);
                this.drawer.drawPeaks({
                  length: this.drawer.getWidth()
                }, 0);
              }
              /**
               * Remove events, elements and disconnect WebAudio nodes.
               *
               * @emits WaveSurfer#destroy
               */
            }, {
              key: "destroy",
              value: function destroy() {
                this.destroyAllPlugins();
                this.fireEvent('destroy');
                this.cancelAjax();
                this.clearTmpEvents();
                this.unAll();
                if (this.params.responsive !== false) {
                  window.removeEventListener('resize', this._onResize, true);
                  window.removeEventListener('orientationchange', this._onResize, true);
                }
                if (this.backend) {
                  this.backend.destroy(); // clears memory usage

                  this.backend = null;
                }
                if (this.drawer) {
                  this.drawer.destroy();
                }
                this.isDestroyed = true;
                this.isReady = false;
                this.arraybuffer = null;
              }
            }], [{
              key: "create",
              value: /** @private */

              /** @private */

              /**
               * Instantiate this class, call its `init` function and returns it
               *
               * @param {WavesurferParams} params The wavesurfer parameters
               * @return {Object} WaveSurfer instance
               * @example const wavesurfer = WaveSurfer.create(params);
               */
              function create(params) {
                var wavesurfer = new WaveSurfer(params);
                return wavesurfer.init();
              }
              /**
               * The library version number is available as a static property of the
               * WaveSurfer class
               *
               * @type {String}
               * @example
               * console.log('Using wavesurfer.js ' + WaveSurfer.VERSION);
               */
            }]);

            return WaveSurfer;
          }(util.Observer);
          exports.default = WaveSurfer;
          WaveSurfer.VERSION = "4.6.0";
          WaveSurfer.util = util;
          module.exports = exports.default;

          /***/
        },

        /***/"./src/webaudio.js": function srcWebaudioJs(module, exports, __nested_webpack_require_221945__) {
          "use strict";

          function _typeof(obj) {
            "@babel/helpers - typeof";

            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              _typeof = function _typeof(obj) {
                return typeof obj;
              };
            } else {
              _typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
              };
            }
            return _typeof(obj);
          }
          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports.default = void 0;
          var util = _interopRequireWildcard(__nested_webpack_require_221945__( /*! ./util */"./src/util/index.js"));
          function _getRequireWildcardCache() {
            if (typeof WeakMap !== "function") return null;
            var cache = new WeakMap();
            _getRequireWildcardCache = function _getRequireWildcardCache() {
              return cache;
            };
            return cache;
          }
          function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
              return obj;
            }
            if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
              return {
                default: obj
              };
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
              return cache.get(obj);
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                if (desc && (desc.get || desc.set)) {
                  Object.defineProperty(newObj, key, desc);
                } else {
                  newObj[key] = obj[key];
                }
              }
            }
            newObj.default = obj;
            if (cache) {
              cache.set(obj, newObj);
            }
            return newObj;
          }
          function _defineProperty(obj, key, value) {
            if (key in obj) {
              Object.defineProperty(obj, key, {
                value: value,
                enumerable: true,
                configurable: true,
                writable: true
              });
            } else {
              obj[key] = value;
            }
            return obj;
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) _defineProperties(Constructor.prototype, protoProps);
            if (staticProps) _defineProperties(Constructor, staticProps);
            return Constructor;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function");
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, {
              constructor: {
                value: subClass,
                writable: true,
                configurable: true
              }
            });
            if (superClass) _setPrototypeOf(subClass, superClass);
          }
          function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
              o.__proto__ = p;
              return o;
            };
            return _setPrototypeOf(o, p);
          }
          function _createSuper(Derived) {
            var hasNativeReflectConstruct = _isNativeReflectConstruct();
            return function _createSuperInternal() {
              var Super = _getPrototypeOf(Derived),
                result;
              if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
              } else {
                result = Super.apply(this, arguments);
              }
              return _possibleConstructorReturn(this, result);
            };
          }
          function _possibleConstructorReturn(self, call) {
            if (call && (_typeof(call) === "object" || typeof call === "function")) {
              return call;
            }
            return _assertThisInitialized(self);
          }
          function _assertThisInitialized(self) {
            if (self === void 0) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return self;
          }
          function _isNativeReflectConstruct() {
            if (typeof Reflect === "undefined" || !Reflect.construct) return false;
            if (Reflect.construct.sham) return false;
            if (typeof Proxy === "function") return true;
            try {
              Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
              return true;
            } catch (e) {
              return false;
            }
          }
          function _getPrototypeOf(o) {
            _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
              return o.__proto__ || Object.getPrototypeOf(o);
            };
            return _getPrototypeOf(o);
          }

          // using constants to prevent someone writing the string wrong
          var PLAYING = 'playing';
          var PAUSED = 'paused';
          var FINISHED = 'finished';
          /**
           * WebAudio backend
           *
           * @extends {Observer}
           */

          var WebAudio = /*#__PURE__*/function (_util$Observer) {
            _inherits(WebAudio, _util$Observer);
            var _super = _createSuper(WebAudio);

            /**
             * Construct the backend
             *
             * @param {WavesurferParams} params Wavesurfer parameters
             */
            function WebAudio(params) {
              var _this$stateBehaviors, _this$states;
              var _this;
              _classCallCheck(this, WebAudio);
              _this = _super.call(this);
              /** @private */

              _this.audioContext = null;
              _this.offlineAudioContext = null;
              _this.stateBehaviors = (_this$stateBehaviors = {}, _defineProperty(_this$stateBehaviors, PLAYING, {
                init: function init() {
                  this.addOnAudioProcess();
                },
                getPlayedPercents: function getPlayedPercents() {
                  var duration = this.getDuration();
                  return this.getCurrentTime() / duration || 0;
                },
                getCurrentTime: function getCurrentTime() {
                  return this.startPosition + this.getPlayedTime();
                }
              }), _defineProperty(_this$stateBehaviors, PAUSED, {
                init: function init() {
                  this.removeOnAudioProcess();
                },
                getPlayedPercents: function getPlayedPercents() {
                  var duration = this.getDuration();
                  return this.getCurrentTime() / duration || 0;
                },
                getCurrentTime: function getCurrentTime() {
                  return this.startPosition;
                }
              }), _defineProperty(_this$stateBehaviors, FINISHED, {
                init: function init() {
                  this.removeOnAudioProcess();
                  this.fireEvent('finish');
                },
                getPlayedPercents: function getPlayedPercents() {
                  return 1;
                },
                getCurrentTime: function getCurrentTime() {
                  return this.getDuration();
                }
              }), _this$stateBehaviors);
              _this.params = params;
              /** ac: Audio Context instance */

              _this.ac = params.audioContext || (_this.supportsWebAudio() ? _this.getAudioContext() : {});
              /**@private */

              _this.lastPlay = _this.ac.currentTime;
              /** @private */

              _this.startPosition = 0;
              /** @private */

              _this.scheduledPause = null;
              /** @private */

              _this.states = (_this$states = {}, _defineProperty(_this$states, PLAYING, Object.create(_this.stateBehaviors[PLAYING])), _defineProperty(_this$states, PAUSED, Object.create(_this.stateBehaviors[PAUSED])), _defineProperty(_this$states, FINISHED, Object.create(_this.stateBehaviors[FINISHED])), _this$states);
              /** @private */

              _this.buffer = null;
              /** @private */

              _this.filters = [];
              /** gainNode: allows to control audio volume */

              _this.gainNode = null;
              /** @private */

              _this.mergedPeaks = null;
              /** @private */

              _this.offlineAc = null;
              /** @private */

              _this.peaks = null;
              /** @private */

              _this.playbackRate = 1;
              /** analyser: provides audio analysis information */

              _this.analyser = null;
              /** scriptNode: allows processing audio */

              _this.scriptNode = null;
              /** @private */

              _this.source = null;
              /** @private */

              _this.splitPeaks = [];
              /** @private */

              _this.state = null;
              /** @private */

              _this.explicitDuration = params.duration;
              /**
               * Boolean indicating if the backend was destroyed.
               */

              _this.destroyed = false;
              return _this;
            }
            /**
             * Initialise the backend, called in `wavesurfer.createBackend()`
             */

            _createClass(WebAudio, [{
              key: "supportsWebAudio",
              value: /** scriptBufferSize: size of the processing buffer */

              /** audioContext: allows to process audio with WebAudio API */

              /** @private */

              /** @private */

              /**
               * Does the browser support this backend
               *
               * @return {boolean} Whether or not this browser supports this backend
               */
              function supportsWebAudio() {
                return !!(window.AudioContext || window.webkitAudioContext);
              }
              /**
               * Get the audio context used by this backend or create one
               *
               * @return {AudioContext} Existing audio context, or creates a new one
               */
            }, {
              key: "getAudioContext",
              value: function getAudioContext() {
                if (!window.WaveSurferAudioContext) {
                  window.WaveSurferAudioContext = new (window.AudioContext || window.webkitAudioContext)();
                }
                return window.WaveSurferAudioContext;
              }
              /**
               * Get the offline audio context used by this backend or create one
               *
               * @param {number} sampleRate The sample rate to use
               * @return {OfflineAudioContext} Existing offline audio context, or creates
               * a new one
               */
            }, {
              key: "getOfflineAudioContext",
              value: function getOfflineAudioContext(sampleRate) {
                if (!window.WaveSurferOfflineAudioContext) {
                  window.WaveSurferOfflineAudioContext = new (window.OfflineAudioContext || window.webkitOfflineAudioContext)(1, 2, sampleRate);
                }
                return window.WaveSurferOfflineAudioContext;
              }
            }, {
              key: "init",
              value: function init() {
                this.createVolumeNode();
                this.createScriptNode();
                this.createAnalyserNode();
                this.setState(PAUSED);
                this.setPlaybackRate(this.params.audioRate);
                this.setLength(0);
              }
              /** @private */
            }, {
              key: "disconnectFilters",
              value: function disconnectFilters() {
                if (this.filters) {
                  this.filters.forEach(function (filter) {
                    filter && filter.disconnect();
                  });
                  this.filters = null; // Reconnect direct path

                  this.analyser.connect(this.gainNode);
                }
              }
              /**
               * @private
               *
               * @param {string} state The new state
               */
            }, {
              key: "setState",
              value: function setState(state) {
                if (this.state !== this.states[state]) {
                  this.state = this.states[state];
                  this.state.init.call(this);
                }
              }
              /**
               * Unpacked `setFilters()`
               *
               * @param {...AudioNode} filters One or more filters to set
               */
            }, {
              key: "setFilter",
              value: function setFilter() {
                for (var _len = arguments.length, filters = new Array(_len), _key = 0; _key < _len; _key++) {
                  filters[_key] = arguments[_key];
                }
                this.setFilters(filters);
              }
              /**
               * Insert custom Web Audio nodes into the graph
               *
               * @param {AudioNode[]} filters Packed filters array
               * @example
               * const lowpass = wavesurfer.backend.ac.createBiquadFilter();
               * wavesurfer.backend.setFilter(lowpass);
               */
            }, {
              key: "setFilters",
              value: function setFilters(filters) {
                // Remove existing filters
                this.disconnectFilters(); // Insert filters if filter array not empty

                if (filters && filters.length) {
                  this.filters = filters; // Disconnect direct path before inserting filters

                  this.analyser.disconnect(); // Connect each filter in turn

                  filters.reduce(function (prev, curr) {
                    prev.connect(curr);
                    return curr;
                  }, this.analyser).connect(this.gainNode);
                }
              }
              /** Create ScriptProcessorNode to process audio */
            }, {
              key: "createScriptNode",
              value: function createScriptNode() {
                if (this.params.audioScriptProcessor) {
                  this.scriptNode = this.params.audioScriptProcessor;
                } else {
                  if (this.ac.createScriptProcessor) {
                    this.scriptNode = this.ac.createScriptProcessor(WebAudio.scriptBufferSize);
                  } else {
                    this.scriptNode = this.ac.createJavaScriptNode(WebAudio.scriptBufferSize);
                  }
                }
                this.scriptNode.connect(this.ac.destination);
              }
              /** @private */
            }, {
              key: "addOnAudioProcess",
              value: function addOnAudioProcess() {
                var _this2 = this;
                this.scriptNode.onaudioprocess = function () {
                  var time = _this2.getCurrentTime();
                  if (time >= _this2.getDuration()) {
                    _this2.setState(FINISHED);
                    _this2.fireEvent('pause');
                  } else if (time >= _this2.scheduledPause) {
                    _this2.pause();
                  } else if (_this2.state === _this2.states[PLAYING]) {
                    _this2.fireEvent('audioprocess', time);
                  }
                };
              }
              /** @private */
            }, {
              key: "removeOnAudioProcess",
              value: function removeOnAudioProcess() {
                this.scriptNode.onaudioprocess = function () {};
              }
              /** Create analyser node to perform audio analysis */
            }, {
              key: "createAnalyserNode",
              value: function createAnalyserNode() {
                this.analyser = this.ac.createAnalyser();
                this.analyser.connect(this.gainNode);
              }
              /**
               * Create the gain node needed to control the playback volume.
               *
               */
            }, {
              key: "createVolumeNode",
              value: function createVolumeNode() {
                // Create gain node using the AudioContext
                if (this.ac.createGain) {
                  this.gainNode = this.ac.createGain();
                } else {
                  this.gainNode = this.ac.createGainNode();
                } // Add the gain node to the graph

                this.gainNode.connect(this.ac.destination);
              }
              /**
               * Set the sink id for the media player
               *
               * @param {string} deviceId String value representing audio device id.
               * @returns {Promise} A Promise that resolves to `undefined` when there
               * are no errors.
               */
            }, {
              key: "setSinkId",
              value: function setSinkId(deviceId) {
                if (deviceId) {
                  /**
                   * The webaudio API doesn't currently support setting the device
                   * output. Here we create an HTMLAudioElement, connect the
                   * webaudio stream to that element and setSinkId there.
                   */
                  var audio = new window.Audio();
                  if (!audio.setSinkId) {
                    return Promise.reject(new Error('setSinkId is not supported in your browser'));
                  }
                  audio.autoplay = true;
                  var dest = this.ac.createMediaStreamDestination();
                  this.gainNode.disconnect();
                  this.gainNode.connect(dest);
                  audio.srcObject = dest.stream;
                  return audio.setSinkId(deviceId);
                } else {
                  return Promise.reject(new Error('Invalid deviceId: ' + deviceId));
                }
              }
              /**
               * Set the audio volume
               *
               * @param {number} value A floating point value between 0 and 1.
               */
            }, {
              key: "setVolume",
              value: function setVolume(value) {
                this.gainNode.gain.setValueAtTime(value, this.ac.currentTime);
              }
              /**
               * Get the current volume
               *
               * @return {number} value A floating point value between 0 and 1.
               */
            }, {
              key: "getVolume",
              value: function getVolume() {
                return this.gainNode.gain.value;
              }
              /**
               * Decode an array buffer and pass data to a callback
               *
               * @private
               * @param {ArrayBuffer} arraybuffer The array buffer to decode
               * @param {function} callback The function to call on complete.
               * @param {function} errback The function to call on error.
               */
            }, {
              key: "decodeArrayBuffer",
              value: function decodeArrayBuffer(arraybuffer, callback, errback) {
                if (!this.offlineAc) {
                  this.offlineAc = this.getOfflineAudioContext(this.ac && this.ac.sampleRate ? this.ac.sampleRate : 44100);
                }
                if ('webkitAudioContext' in window) {
                  // Safari: no support for Promise-based decodeAudioData enabled
                  // Enable it in Safari using the Experimental Features > Modern WebAudio API option
                  this.offlineAc.decodeAudioData(arraybuffer, function (data) {
                    return callback(data);
                  }, errback);
                } else {
                  this.offlineAc.decodeAudioData(arraybuffer).then(function (data) {
                    return callback(data);
                  }).catch(function (err) {
                    return errback(err);
                  });
                }
              }
              /**
               * Set pre-decoded peaks
               *
               * @param {number[]|Number.<Array[]>} peaks Peaks data
               * @param {?number} duration Explicit duration
               */
            }, {
              key: "setPeaks",
              value: function setPeaks(peaks, duration) {
                if (duration != null) {
                  this.explicitDuration = duration;
                }
                this.peaks = peaks;
              }
              /**
               * Set the rendered length (different from the length of the audio)
               *
               * @param {number} length The rendered length
               */
            }, {
              key: "setLength",
              value: function setLength(length) {
                // No resize, we can preserve the cached peaks.
                if (this.mergedPeaks && length == 2 * this.mergedPeaks.length - 1 + 2) {
                  return;
                }
                this.splitPeaks = [];
                this.mergedPeaks = []; // Set the last element of the sparse array so the peak arrays are
                // appropriately sized for other calculations.

                var channels = this.buffer ? this.buffer.numberOfChannels : 1;
                var c;
                for (c = 0; c < channels; c++) {
                  this.splitPeaks[c] = [];
                  this.splitPeaks[c][2 * (length - 1)] = 0;
                  this.splitPeaks[c][2 * (length - 1) + 1] = 0;
                }
                this.mergedPeaks[2 * (length - 1)] = 0;
                this.mergedPeaks[2 * (length - 1) + 1] = 0;
              }
              /**
               * Compute the max and min value of the waveform when broken into <length> subranges.
               *
               * @param {number} length How many subranges to break the waveform into.
               * @param {number} first First sample in the required range.
               * @param {number} last Last sample in the required range.
               * @return {number[]|Number.<Array[]>} Array of 2*<length> peaks or array of arrays of
               * peaks consisting of (max, min) values for each subrange.
               */
            }, {
              key: "getPeaks",
              value: function getPeaks(length, first, last) {
                if (this.peaks) {
                  return this.peaks;
                }
                if (!this.buffer) {
                  return [];
                }
                first = first || 0;
                last = last || length - 1;
                this.setLength(length);
                if (!this.buffer) {
                  return this.params.splitChannels ? this.splitPeaks : this.mergedPeaks;
                }
                /**
                 * The following snippet fixes a buffering data issue on the Safari
                 * browser which returned undefined It creates the missing buffer based
                 * on 1 channel, 4096 samples and the sampleRate from the current
                 * webaudio context 4096 samples seemed to be the best fit for rendering
                 * will review this code once a stable version of Safari TP is out
                 */

                if (!this.buffer.length) {
                  var newBuffer = this.createBuffer(1, 4096, this.sampleRate);
                  this.buffer = newBuffer.buffer;
                }
                var sampleSize = this.buffer.length / length;
                var sampleStep = ~~(sampleSize / 10) || 1;
                var channels = this.buffer.numberOfChannels;
                var c;
                for (c = 0; c < channels; c++) {
                  var peaks = this.splitPeaks[c];
                  var chan = this.buffer.getChannelData(c);
                  var i = void 0;
                  for (i = first; i <= last; i++) {
                    var start = ~~(i * sampleSize);
                    var end = ~~(start + sampleSize);
                    /**
                     * Initialize the max and min to the first sample of this
                     * subrange, so that even if the samples are entirely
                     * on one side of zero, we still return the true max and
                     * min values in the subrange.
                     */

                    var min = chan[start];
                    var max = min;
                    var j = void 0;
                    for (j = start; j < end; j += sampleStep) {
                      var value = chan[j];
                      if (value > max) {
                        max = value;
                      }
                      if (value < min) {
                        min = value;
                      }
                    }
                    peaks[2 * i] = max;
                    peaks[2 * i + 1] = min;
                    if (c == 0 || max > this.mergedPeaks[2 * i]) {
                      this.mergedPeaks[2 * i] = max;
                    }
                    if (c == 0 || min < this.mergedPeaks[2 * i + 1]) {
                      this.mergedPeaks[2 * i + 1] = min;
                    }
                  }
                }
                return this.params.splitChannels ? this.splitPeaks : this.mergedPeaks;
              }
              /**
               * Get the position from 0 to 1
               *
               * @return {number} Position
               */
            }, {
              key: "getPlayedPercents",
              value: function getPlayedPercents() {
                return this.state.getPlayedPercents.call(this);
              }
              /** @private */
            }, {
              key: "disconnectSource",
              value: function disconnectSource() {
                if (this.source) {
                  this.source.disconnect();
                }
              }
              /**
               * Destroy all references with WebAudio, disconnecting audio nodes and closing Audio Context
               */
            }, {
              key: "destroyWebAudio",
              value: function destroyWebAudio() {
                this.disconnectFilters();
                this.disconnectSource();
                this.gainNode.disconnect();
                this.scriptNode.disconnect();
                this.analyser.disconnect(); // close the audioContext if closeAudioContext option is set to true

                if (this.params.closeAudioContext) {
                  // check if browser supports AudioContext.close()
                  if (typeof this.ac.close === 'function' && this.ac.state != 'closed') {
                    this.ac.close();
                  } // clear the reference to the audiocontext

                  this.ac = null; // clear the actual audiocontext, either passed as param or the
                  // global singleton

                  if (!this.params.audioContext) {
                    window.WaveSurferAudioContext = null;
                  } else {
                    this.params.audioContext = null;
                  } // clear the offlineAudioContext

                  window.WaveSurferOfflineAudioContext = null;
                }
              }
              /**
               * This is called when wavesurfer is destroyed
               */
            }, {
              key: "destroy",
              value: function destroy() {
                if (!this.isPaused()) {
                  this.pause();
                }
                this.unAll();
                this.buffer = null;
                this.destroyed = true;
                this.destroyWebAudio();
              }
              /**
               * Loaded a decoded audio buffer
               *
               * @param {Object} buffer Decoded audio buffer to load
               */
            }, {
              key: "load",
              value: function load(buffer) {
                this.startPosition = 0;
                this.lastPlay = this.ac.currentTime;
                this.buffer = buffer;
                this.createSource();
              }
              /** @private */
            }, {
              key: "createSource",
              value: function createSource() {
                this.disconnectSource();
                this.source = this.ac.createBufferSource(); // adjust for old browsers

                this.source.start = this.source.start || this.source.noteGrainOn;
                this.source.stop = this.source.stop || this.source.noteOff;
                this.setPlaybackRate(this.playbackRate);
                this.source.buffer = this.buffer;
                this.source.connect(this.analyser);
              }
              /**
               * @private
               *
               * some browsers require an explicit call to #resume before they will play back audio
               */
            }, {
              key: "resumeAudioContext",
              value: function resumeAudioContext() {
                if (this.ac.state == 'suspended') {
                  this.ac.resume && this.ac.resume();
                }
              }
              /**
               * Used by `wavesurfer.isPlaying()` and `wavesurfer.playPause()`
               *
               * @return {boolean} Whether or not this backend is currently paused
               */
            }, {
              key: "isPaused",
              value: function isPaused() {
                return this.state !== this.states[PLAYING];
              }
              /**
               * Used by `wavesurfer.getDuration()`
               *
               * @return {number} Duration of loaded buffer
               */
            }, {
              key: "getDuration",
              value: function getDuration() {
                if (this.explicitDuration) {
                  return this.explicitDuration;
                }
                if (!this.buffer) {
                  return 0;
                }
                return this.buffer.duration;
              }
              /**
               * Used by `wavesurfer.seekTo()`
               *
               * @param {number} start Position to start at in seconds
               * @param {number} end Position to end at in seconds
               * @return {{start: number, end: number}} Object containing start and end
               * positions
               */
            }, {
              key: "seekTo",
              value: function seekTo(start, end) {
                if (!this.buffer) {
                  return;
                }
                this.scheduledPause = null;
                if (start == null) {
                  start = this.getCurrentTime();
                  if (start >= this.getDuration()) {
                    start = 0;
                  }
                }
                if (end == null) {
                  end = this.getDuration();
                }
                this.startPosition = start;
                this.lastPlay = this.ac.currentTime;
                if (this.state === this.states[FINISHED]) {
                  this.setState(PAUSED);
                }
                return {
                  start: start,
                  end: end
                };
              }
              /**
               * Get the playback position in seconds
               *
               * @return {number} The playback position in seconds
               */
            }, {
              key: "getPlayedTime",
              value: function getPlayedTime() {
                return (this.ac.currentTime - this.lastPlay) * this.playbackRate;
              }
              /**
               * Plays the loaded audio region.
               *
               * @param {number} start Start offset in seconds, relative to the beginning
               * of a clip.
               * @param {number} end When to stop relative to the beginning of a clip.
               */
            }, {
              key: "play",
              value: function play(start, end) {
                if (!this.buffer) {
                  return;
                } // need to re-create source on each playback

                this.createSource();
                var adjustedTime = this.seekTo(start, end);
                start = adjustedTime.start;
                end = adjustedTime.end;
                this.scheduledPause = end;
                this.source.start(0, start);
                this.resumeAudioContext();
                this.setState(PLAYING);
                this.fireEvent('play');
              }
              /**
               * Pauses the loaded audio.
               */
            }, {
              key: "pause",
              value: function pause() {
                this.scheduledPause = null;
                this.startPosition += this.getPlayedTime();
                this.source && this.source.stop(0);
                this.setState(PAUSED);
                this.fireEvent('pause');
              }
              /**
               * Returns the current time in seconds relative to the audio-clip's
               * duration.
               *
               * @return {number} The current time in seconds
               */
            }, {
              key: "getCurrentTime",
              value: function getCurrentTime() {
                return this.state.getCurrentTime.call(this);
              }
              /**
               * Returns the current playback rate. (0=no playback, 1=normal playback)
               *
               * @return {number} The current playback rate
               */
            }, {
              key: "getPlaybackRate",
              value: function getPlaybackRate() {
                return this.playbackRate;
              }
              /**
               * Set the audio source playback rate.
               *
               * @param {number} value The playback rate to use
               */
            }, {
              key: "setPlaybackRate",
              value: function setPlaybackRate(value) {
                this.playbackRate = value || 1;
                this.source && this.source.playbackRate.setValueAtTime(this.playbackRate, this.ac.currentTime);
              }
              /**
               * Set a point in seconds for playback to stop at.
               *
               * @param {number} end Position to end at
               * @version 3.3.0
               */
            }, {
              key: "setPlayEnd",
              value: function setPlayEnd(end) {
                this.scheduledPause = end;
              }
            }]);
            return WebAudio;
          }(util.Observer);
          exports.default = WebAudio;
          WebAudio.scriptBufferSize = 256;
          module.exports = exports.default;

          /***/
        },

        /***/"./node_modules/debounce/index.js": function node_modulesDebounceIndexJs(module) {
          /**
           * Returns a function, that, as long as it continues to be invoked, will not
           * be triggered. The function will be called after it stops being called for
           * N milliseconds. If `immediate` is passed, trigger the function on the
           * leading edge, instead of the trailing. The function also has a property 'clear' 
           * that is a function which will clear the timer to prevent previously scheduled executions. 
           *
           * @source underscore.js
           * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
           * @param {Function} function to wrap
           * @param {Number} timeout in ms (`100`)
           * @param {Boolean} whether to execute at the beginning (`false`)
           * @api public
           */
          function debounce(func, wait, immediate) {
            var timeout, args, context, timestamp, result;
            if (null == wait) wait = 100;
            function later() {
              var last = Date.now() - timestamp;
              if (last < wait && last >= 0) {
                timeout = setTimeout(later, wait - last);
              } else {
                timeout = null;
                if (!immediate) {
                  result = func.apply(context, args);
                  context = args = null;
                }
              }
            }
            ;
            var debounced = function debounced() {
              context = this;
              args = arguments;
              timestamp = Date.now();
              var callNow = immediate && !timeout;
              if (!timeout) timeout = setTimeout(later, wait);
              if (callNow) {
                result = func.apply(context, args);
                context = args = null;
              }
              return result;
            };
            debounced.clear = function () {
              if (timeout) {
                clearTimeout(timeout);
                timeout = null;
              }
            };
            debounced.flush = function () {
              if (timeout) {
                result = func.apply(context, args);
                context = args = null;
                clearTimeout(timeout);
                timeout = null;
              }
            };
            return debounced;
          }
          ;

          // Adds compatibility for ES modules
          debounce.debounce = debounce;
          module.exports = debounce;

          /***/
        }

        /******/
      };
      /************************************************************************/
      /******/ // The module cache
      /******/
      var __webpack_module_cache__ = {};
      /******/
      /******/ // The require function
      /******/
      function __nested_webpack_require_261051__(moduleId) {
        /******/ // Check if module is in cache
        /******/if (__webpack_module_cache__[moduleId]) {
          /******/return __webpack_module_cache__[moduleId].exports;
          /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/
        var module = __webpack_module_cache__[moduleId] = {
          /******/ // no module.id needed
          /******/ // no module.loaded needed
          /******/exports: {}
          /******/
        };
        /******/
        /******/ // Execute the module function
        /******/
        __webpack_modules__[moduleId](module, module.exports, __nested_webpack_require_261051__);
        /******/
        /******/ // Return the exports of the module
        /******/
        return module.exports;
        /******/
      }
      /******/
      /************************************************************************/
      /******/
      /******/ // startup
      /******/ // Load entry module and return exports
      /******/ // This entry module is referenced by other modules so it can't be inlined
      /******/
      var __webpack_exports__ = __nested_webpack_require_261051__("./src/wavesurfer.js");
      /******/
      /******/
      return __webpack_exports__;
      /******/
    }()
  );
});

/***/ }),

/***/ 12599:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Headers": () => (/* binding */ Headers),
/* harmony export */   "Request": () => (/* binding */ Request),
/* harmony export */   "Response": () => (/* binding */ Response),
/* harmony export */   "DOMException": () => (/* binding */ DOMException),
/* harmony export */   "fetch": () => (/* binding */ fetch)
/* harmony export */ });
/* harmony import */ var core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65743);
/* harmony import */ var core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_buffer_constructor_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18264);
/* harmony import */ var core_js_modules_es_array_buffer_constructor_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_buffer_constructor_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21249);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_get_own_property_names_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36210);
/* harmony import */ var core_js_modules_es_object_get_own_property_names_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_names_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_typed_array_uint8_array_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(82472);
/* harmony import */ var core_js_modules_es_typed_array_uint8_array_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_uint8_array_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_typed_array_copy_within_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(92990);
/* harmony import */ var core_js_modules_es_typed_array_copy_within_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_copy_within_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_typed_array_every_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(18927);
/* harmony import */ var core_js_modules_es_typed_array_every_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_every_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_typed_array_fill_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(33105);
/* harmony import */ var core_js_modules_es_typed_array_fill_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_fill_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_typed_array_filter_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(35035);
/* harmony import */ var core_js_modules_es_typed_array_filter_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_filter_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_typed_array_find_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(74345);
/* harmony import */ var core_js_modules_es_typed_array_find_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_find_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_typed_array_find_index_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(7174);
/* harmony import */ var core_js_modules_es_typed_array_find_index_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_find_index_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_typed_array_for_each_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(32846);
/* harmony import */ var core_js_modules_es_typed_array_for_each_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_for_each_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_typed_array_includes_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(44731);
/* harmony import */ var core_js_modules_es_typed_array_includes_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_includes_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_typed_array_index_of_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(77209);
/* harmony import */ var core_js_modules_es_typed_array_index_of_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_index_of_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_typed_array_iterator_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(96319);
/* harmony import */ var core_js_modules_es_typed_array_iterator_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_iterator_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_typed_array_join_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(58867);
/* harmony import */ var core_js_modules_es_typed_array_join_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_join_js__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_es_typed_array_last_index_of_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(37789);
/* harmony import */ var core_js_modules_es_typed_array_last_index_of_js__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_last_index_of_js__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_es_typed_array_map_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(33739);
/* harmony import */ var core_js_modules_es_typed_array_map_js__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_map_js__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_es_typed_array_reduce_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(29368);
/* harmony import */ var core_js_modules_es_typed_array_reduce_js__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_reduce_js__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_es_typed_array_reduce_right_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(14483);
/* harmony import */ var core_js_modules_es_typed_array_reduce_right_js__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_reduce_right_js__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_es_typed_array_reverse_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(12056);
/* harmony import */ var core_js_modules_es_typed_array_reverse_js__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_reverse_js__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_es_typed_array_set_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(3462);
/* harmony import */ var core_js_modules_es_typed_array_set_js__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_set_js__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_es_typed_array_slice_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(30678);
/* harmony import */ var core_js_modules_es_typed_array_slice_js__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_slice_js__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_es_typed_array_some_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(27462);
/* harmony import */ var core_js_modules_es_typed_array_some_js__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_some_js__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_es_typed_array_sort_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(33824);
/* harmony import */ var core_js_modules_es_typed_array_sort_js__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_sort_js__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_es_typed_array_subarray_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(55021);
/* harmony import */ var core_js_modules_es_typed_array_subarray_js__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_subarray_js__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_es_typed_array_to_locale_string_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(12974);
/* harmony import */ var core_js_modules_es_typed_array_to_locale_string_js__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_to_locale_string_js__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var core_js_modules_es_typed_array_to_string_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(15016);
/* harmony import */ var core_js_modules_es_typed_array_to_string_js__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_to_string_js__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(69600);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var core_js_modules_web_url_search_params_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(41637);
/* harmony import */ var core_js_modules_web_url_search_params_js__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_search_params_js__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(23123);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(73210);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_44__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }













































var global = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || typeof global !== 'undefined' && global;
var support = {
  searchParams: 'URLSearchParams' in global,
  iterable: 'Symbol' in global && 'iterator' in Symbol,
  blob: 'FileReader' in global && 'Blob' in global && function () {
    try {
      new Blob();
      return true;
    } catch (e) {
      return false;
    }
  }(),
  formData: 'FormData' in global,
  arrayBuffer: 'ArrayBuffer' in global
};
function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj);
}
if (support.arrayBuffer) {
  var viewClasses = ['[object Int8Array]', '[object Uint8Array]', '[object Uint8ClampedArray]', '[object Int16Array]', '[object Uint16Array]', '[object Int32Array]', '[object Uint32Array]', '[object Float32Array]', '[object Float64Array]'];
  var isArrayBufferView = ArrayBuffer.isView || function (obj) {
    return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
  };
}
function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name);
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
    throw new TypeError('Invalid character in header field name: "' + name + '"');
  }
  return name.toLowerCase();
}
function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value);
  }
  return value;
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function next() {
      var value = items.shift();
      return {
        done: value === undefined,
        value: value
      };
    }
  };
  if (support.iterable) {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}
function Headers(headers) {
  this.map = {};
  if (headers instanceof Headers) {
    headers.forEach(function (value, name) {
      this.append(name, value);
    }, this);
  } else if (Array.isArray(headers)) {
    headers.forEach(function (header) {
      this.append(header[0], header[1]);
    }, this);
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function (name) {
      this.append(name, headers[name]);
    }, this);
  }
}
Headers.prototype.append = function (name, value) {
  name = normalizeName(name);
  value = normalizeValue(value);
  var oldValue = this.map[name];
  this.map[name] = oldValue ? oldValue + ', ' + value : value;
};
Headers.prototype['delete'] = function (name) {
  delete this.map[normalizeName(name)];
};
Headers.prototype.get = function (name) {
  name = normalizeName(name);
  return this.has(name) ? this.map[name] : null;
};
Headers.prototype.has = function (name) {
  return this.map.hasOwnProperty(normalizeName(name));
};
Headers.prototype.set = function (name, value) {
  this.map[normalizeName(name)] = normalizeValue(value);
};
Headers.prototype.forEach = function (callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this);
    }
  }
};
Headers.prototype.keys = function () {
  var items = [];
  this.forEach(function (value, name) {
    items.push(name);
  });
  return iteratorFor(items);
};
Headers.prototype.values = function () {
  var items = [];
  this.forEach(function (value) {
    items.push(value);
  });
  return iteratorFor(items);
};
Headers.prototype.entries = function () {
  var items = [];
  this.forEach(function (value, name) {
    items.push([name, value]);
  });
  return iteratorFor(items);
};
if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
}
function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'));
  }
  body.bodyUsed = true;
}
function fileReaderReady(reader) {
  return new Promise(function (resolve, reject) {
    reader.onload = function () {
      resolve(reader.result);
    };
    reader.onerror = function () {
      reject(reader.error);
    };
  });
}
function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader();
  var promise = fileReaderReady(reader);
  reader.readAsArrayBuffer(blob);
  return promise;
}
function readBlobAsText(blob) {
  var reader = new FileReader();
  var promise = fileReaderReady(reader);
  reader.readAsText(blob);
  return promise;
}
function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf);
  var chars = new Array(view.length);
  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i]);
  }
  return chars.join('');
}
function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0);
  } else {
    var view = new Uint8Array(buf.byteLength);
    view.set(new Uint8Array(buf));
    return view.buffer;
  }
}
function Body() {
  this.bodyUsed = false;
  this._initBody = function (body) {
    /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */
    this.bodyUsed = this.bodyUsed;
    this._bodyInit = body;
    if (!body) {
      this._bodyText = '';
    } else if (typeof body === 'string') {
      this._bodyText = body;
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body;
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body;
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString();
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer);
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer]);
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body);
    } else {
      this._bodyText = body = Object.prototype.toString.call(body);
    }
    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8');
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type);
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
      }
    }
  };
  if (support.blob) {
    this.blob = function () {
      var rejected = consumed(this);
      if (rejected) {
        return rejected;
      }
      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob');
      } else {
        return Promise.resolve(new Blob([this._bodyText]));
      }
    };
    this.arrayBuffer = function () {
      if (this._bodyArrayBuffer) {
        var isConsumed = consumed(this);
        if (isConsumed) {
          return isConsumed;
        }
        if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
          return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
        } else {
          return Promise.resolve(this._bodyArrayBuffer);
        }
      } else {
        return this.blob().then(readBlobAsArrayBuffer);
      }
    };
  }
  this.text = function () {
    var rejected = consumed(this);
    if (rejected) {
      return rejected;
    }
    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob);
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text');
    } else {
      return Promise.resolve(this._bodyText);
    }
  };
  if (support.formData) {
    this.formData = function () {
      return this.text().then(decode);
    };
  }
  this.json = function () {
    return this.text().then(JSON.parse);
  };
  return this;
}

// HTTP methods whose capitalization should be normalized
var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
function normalizeMethod(method) {
  var upcased = method.toUpperCase();
  return methods.indexOf(upcased) > -1 ? upcased : method;
}
function Request(input, options) {
  if (!(this instanceof Request)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
  }
  options = options || {};
  var body = options.body;
  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read');
    }
    this.url = input.url;
    this.credentials = input.credentials;
    if (!options.headers) {
      this.headers = new Headers(input.headers);
    }
    this.method = input.method;
    this.mode = input.mode;
    this.signal = input.signal;
    if (!body && input._bodyInit != null) {
      body = input._bodyInit;
      input.bodyUsed = true;
    }
  } else {
    this.url = String(input);
  }
  this.credentials = options.credentials || this.credentials || 'same-origin';
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers);
  }
  this.method = normalizeMethod(options.method || this.method || 'GET');
  this.mode = options.mode || this.mode || null;
  this.signal = options.signal || this.signal;
  this.referrer = null;
  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests');
  }
  this._initBody(body);
  if (this.method === 'GET' || this.method === 'HEAD') {
    if (options.cache === 'no-store' || options.cache === 'no-cache') {
      // Search for a '_' parameter in the query string
      var reParamSearch = /([?&])_=[^&]*/;
      if (reParamSearch.test(this.url)) {
        // If it already exists then set the value with the current time
        this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
      } else {
        // Otherwise add a new '_' parameter to the end with the current time
        var reQueryString = /\?/;
        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
      }
    }
  }
}
Request.prototype.clone = function () {
  return new Request(this, {
    body: this._bodyInit
  });
};
function decode(body) {
  var form = new FormData();
  body.trim().split('&').forEach(function (bytes) {
    if (bytes) {
      var split = bytes.split('=');
      var name = split.shift().replace(/\+/g, ' ');
      var value = split.join('=').replace(/\+/g, ' ');
      form.append(decodeURIComponent(name), decodeURIComponent(value));
    }
  });
  return form;
}
function parseHeaders(rawHeaders) {
  var headers = new Headers();
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
  // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
  // https://github.com/github/fetch/issues/748
  // https://github.com/zloirock/core-js/issues/751
  preProcessedHeaders.split('\r').map(function (header) {
    return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
  }).forEach(function (line) {
    var parts = line.split(':');
    var key = parts.shift().trim();
    if (key) {
      var value = parts.join(':').trim();
      headers.append(key, value);
    }
  });
  return headers;
}
Body.call(Request.prototype);
function Response(bodyInit, options) {
  if (!(this instanceof Response)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
  }
  if (!options) {
    options = {};
  }
  this.type = 'default';
  this.status = options.status === undefined ? 200 : options.status;
  this.ok = this.status >= 200 && this.status < 300;
  this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
  this.headers = new Headers(options.headers);
  this.url = options.url || '';
  this._initBody(bodyInit);
}
Body.call(Response.prototype);
Response.prototype.clone = function () {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  });
};
Response.error = function () {
  var response = new Response(null, {
    status: 0,
    statusText: ''
  });
  response.type = 'error';
  return response;
};
var redirectStatuses = [301, 302, 303, 307, 308];
Response.redirect = function (url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code');
  }
  return new Response(null, {
    status: status,
    headers: {
      location: url
    }
  });
};
var DOMException = global.DOMException;
try {
  new DOMException();
} catch (err) {
  DOMException = function DOMException(message, name) {
    this.message = message;
    this.name = name;
    var error = Error(message);
    this.stack = error.stack;
  };
  DOMException.prototype = Object.create(Error.prototype);
  DOMException.prototype.constructor = DOMException;
}
function fetch(input, init) {
  return new Promise(function (resolve, reject) {
    var request = new Request(input, init);
    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'));
    }
    var xhr = new XMLHttpRequest();
    function abortXhr() {
      xhr.abort();
    }
    xhr.onload = function () {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      };
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
      var body = 'response' in xhr ? xhr.response : xhr.responseText;
      setTimeout(function () {
        resolve(new Response(body, options));
      }, 0);
    };
    xhr.onerror = function () {
      setTimeout(function () {
        reject(new TypeError('Network request failed'));
      }, 0);
    };
    xhr.ontimeout = function () {
      setTimeout(function () {
        reject(new TypeError('Network request failed'));
      }, 0);
    };
    xhr.onabort = function () {
      setTimeout(function () {
        reject(new DOMException('Aborted', 'AbortError'));
      }, 0);
    };
    function fixUrl(url) {
      try {
        return url === '' && global.location.href ? global.location.href : url;
      } catch (e) {
        return url;
      }
    }
    xhr.open(request.method, fixUrl(request.url), true);
    if (request.credentials === 'include') {
      xhr.withCredentials = true;
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false;
    }
    if ('responseType' in xhr) {
      if (support.blob) {
        xhr.responseType = 'blob';
      } else if (support.arrayBuffer && request.headers.get('Content-Type') && request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1) {
        xhr.responseType = 'arraybuffer';
      }
    }
    if (init && _typeof(init.headers) === 'object' && !(init.headers instanceof Headers)) {
      Object.getOwnPropertyNames(init.headers).forEach(function (name) {
        xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
      });
    } else {
      request.headers.forEach(function (value, name) {
        xhr.setRequestHeader(name, value);
      });
    }
    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr);
      xhr.onreadystatechange = function () {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr);
        }
      };
    }
    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
  });
}
fetch.polyfill = true;
if (!global.fetch) {
  global.fetch = fetch;
  global.Headers = Headers;
  global.Request = Request;
  global.Response = Response;
}

/***/ }),

/***/ 58887:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
var isString = __webpack_require__(68210);
var isNumber = __webpack_require__(39943);
var isBoolean = __webpack_require__(57801);
var isSymbol = __webpack_require__(86967);
var isBigInt = __webpack_require__(12783);

// eslint-disable-next-line consistent-return
module.exports = function whichBoxedPrimitive(value) {
  // eslint-disable-next-line eqeqeq
  if (value == null || _typeof(value) !== 'object' && typeof value !== 'function') {
    return null;
  }
  if (isString(value)) {
    return 'String';
  }
  if (isNumber(value)) {
    return 'Number';
  }
  if (isBoolean(value)) {
    return 'Boolean';
  }
  if (isSymbol(value)) {
    return 'Symbol';
  }
  if (isBigInt(value)) {
    return 'BigInt';
  }
};

/***/ }),

/***/ 94555:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
var isMap = __webpack_require__(77088);
var isSet = __webpack_require__(9458);
var isWeakMap = __webpack_require__(77219);
var isWeakSet = __webpack_require__(34301);

/** @type {import('.')} */
module.exports = function whichCollection( /** @type {unknown} */value) {
  if (value && _typeof(value) === 'object') {
    if (isMap(value)) {
      return 'Map';
    }
    if (isSet(value)) {
      return 'Set';
    }
    if (isWeakMap(value)) {
      return 'WeakMap';
    }
    if (isWeakSet(value)) {
      return 'WeakSet';
    }
  }
  return false;
};

/***/ }),

/***/ 43219:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(65743);
__webpack_require__(30489);
__webpack_require__(39341);
__webpack_require__(73706);
__webpack_require__(10408);
__webpack_require__(41539);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(47042);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
var forEach = __webpack_require__(50068);
var availableTypedArrays = __webpack_require__(20260);
var callBind = __webpack_require__(53785);
var callBound = __webpack_require__(73684);
var gOPD = __webpack_require__(12500);

/** @type {(O: object) => string} */
var $toString = callBound('Object.prototype.toString');
var hasToStringTag = __webpack_require__(80297)();
var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;
var typedArrays = availableTypedArrays();
var $slice = callBound('String.prototype.slice');
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');

/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */
var $indexOf = callBound('Array.prototype.indexOf', true) || function indexOf(array, value) {
  for (var i = 0; i < array.length; i += 1) {
    if (array[i] === value) {
      return i;
    }
  }
  return -1;
};

/** @typedef {(receiver: import('.').TypedArray) => string | typeof Uint8Array.prototype.slice.call | typeof Uint8Array.prototype.set.call} Getter */
/** @type {{ [k in `\$${import('.').TypedArrayName}`]?: Getter } & { __proto__: null }} */
var cache = {
  __proto__: null
};
if (hasToStringTag && gOPD && getPrototypeOf) {
  forEach(typedArrays, function (typedArray) {
    var arr = new g[typedArray]();
    if (Symbol.toStringTag in arr) {
      var proto = getPrototypeOf(arr);
      // @ts-expect-error TS won't narrow inside a closure
      var descriptor = gOPD(proto, Symbol.toStringTag);
      if (!descriptor) {
        var superProto = getPrototypeOf(proto);
        // @ts-expect-error TS won't narrow inside a closure
        descriptor = gOPD(superProto, Symbol.toStringTag);
      }
      // @ts-expect-error TODO: fix
      cache['$' + typedArray] = callBind(descriptor.get);
    }
  });
} else {
  forEach(typedArrays, function (typedArray) {
    var arr = new g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) {
      // @ts-expect-error TODO: fix
      cache['$' + typedArray] = callBind(fn);
    }
  });
}

/** @type {(value: object) => false | import('.').TypedArrayName} */
var tryTypedArrays = function tryAllTypedArrays(value) {
  /** @type {ReturnType<typeof tryAllTypedArrays>} */var found = false;
  forEach(cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
  function (getter, typedArray) {
    if (!found) {
      try {
        // @ts-expect-error TODO: fix
        if ('$' + getter(value) === typedArray) {
          found = $slice(typedArray, 1);
        }
      } catch (e) {/**/}
    }
  });
  return found;
};

/** @type {(value: object) => false | import('.').TypedArrayName} */
var trySlices = function tryAllSlices(value) {
  /** @type {ReturnType<typeof tryAllSlices>} */var found = false;
  forEach(cache, /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */function (getter, name) {
    if (!found) {
      try {
        // @ts-expect-error TODO: fix
        getter(value);
        found = $slice(name, 1);
      } catch (e) {/**/}
    }
  });
  return found;
};

/** @type {import('.')} */
module.exports = function whichTypedArray(value) {
  if (!value || _typeof(value) !== 'object') {
    return false;
  }
  if (!hasToStringTag) {
    /** @type {string} */
    var tag = $slice($toString(value), 8, -1);
    if ($indexOf(typedArrays, tag) > -1) {
      return tag;
    }
    if (tag !== 'Object') {
      return false;
    }
    // node < 0.6 hits here on real Typed Arrays
    return trySlices(value);
  }
  if (!gOPD) {
    return null;
  } // unknown engine
  return tryTypedArrays(value);
};

/***/ }),

/***/ 19662:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__(60614);
var tryToString = __webpack_require__(66330);

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ 39483:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isConstructor = __webpack_require__(4411);
var tryToString = __webpack_require__(66330);

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ 96077:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__(60614);

module.exports = function (argument) {
  if (typeof argument === 'object' || isCallable(argument)) return argument;
  throw TypeError("Can't set " + String(argument) + ' as a prototype');
};


/***/ }),

/***/ 51223:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__(5112);
var create = __webpack_require__(70030);
var definePropertyModule = __webpack_require__(3070);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ 31530:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var charAt = __webpack_require__(28710).charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ 25787:
/***/ ((module) => {

module.exports = function (it, Constructor, name) {
  if (it instanceof Constructor) return it;
  throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
};


/***/ }),

/***/ 19670:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(70111);

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};


/***/ }),

/***/ 24019:
/***/ ((module) => {

// eslint-disable-next-line es/no-typed-arrays -- safe
module.exports = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined';


/***/ }),

/***/ 90260:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var NATIVE_ARRAY_BUFFER = __webpack_require__(24019);
var DESCRIPTORS = __webpack_require__(19781);
var global = __webpack_require__(17854);
var isCallable = __webpack_require__(60614);
var isObject = __webpack_require__(70111);
var has = __webpack_require__(86656);
var classof = __webpack_require__(70648);
var tryToString = __webpack_require__(66330);
var createNonEnumerableProperty = __webpack_require__(68880);
var redefine = __webpack_require__(31320);
var defineProperty = __webpack_require__(3070).f;
var getPrototypeOf = __webpack_require__(79518);
var setPrototypeOf = __webpack_require__(27674);
var wellKnownSymbol = __webpack_require__(5112);
var uid = __webpack_require__(69711);

var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var Uint8ClampedArray = global.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
var TypedArray = Int8Array && getPrototypeOf(Int8Array);
var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
var ObjectPrototype = Object.prototype;
var isPrototypeOf = ObjectPrototype.isPrototypeOf;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = uid('TYPED_ARRAY_CONSTRUCTOR');
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(global.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQIRED = false;
var NAME, Constructor, Prototype;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return klass === 'DataView'
    || has(TypedArrayConstructorsList, klass)
    || has(BigIntArrayConstructorsList, klass);
};

var isTypedArray = function (it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return has(TypedArrayConstructorsList, klass)
    || has(BigIntArrayConstructorsList, klass);
};

var aTypedArray = function (it) {
  if (isTypedArray(it)) return it;
  throw TypeError('Target is not a typed array');
};

var aTypedArrayConstructor = function (C) {
  if (isCallable(C) && (!setPrototypeOf || isPrototypeOf.call(TypedArray, C))) return C;
  throw TypeError(tryToString(C) + ' is not a typed array constructor');
};

var exportTypedArrayMethod = function (KEY, property, forced) {
  if (!DESCRIPTORS) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && has(TypedArrayConstructor.prototype, KEY)) try {
      delete TypedArrayConstructor.prototype[KEY];
    } catch (error) { /* empty */ }
  }
  if (!TypedArrayPrototype[KEY] || forced) {
    redefine(TypedArrayPrototype, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property);
  }
};

var exportTypedArrayStaticMethod = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!DESCRIPTORS) return;
  if (setPrototypeOf) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global[ARRAY];
      if (TypedArrayConstructor && has(TypedArrayConstructor, KEY)) try {
        delete TypedArrayConstructor[KEY];
      } catch (error) { /* empty */ }
    }
    if (!TypedArray[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return redefine(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      redefine(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME in TypedArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) createNonEnumerableProperty(Prototype, TYPED_ARRAY_CONSTRUCTOR, Constructor);
  else NATIVE_ARRAY_BUFFER_VIEWS = false;
}

for (NAME in BigIntArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) createNonEnumerableProperty(Prototype, TYPED_ARRAY_CONSTRUCTOR, Constructor);
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray = function TypedArray() {
    throw TypeError('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME], TypedArray);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
  TypedArrayPrototype = TypedArray.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME].prototype, TypedArrayPrototype);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
  setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
}

if (DESCRIPTORS && !has(TypedArrayPrototype, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQIRED = true;
  defineProperty(TypedArrayPrototype, TO_STRING_TAG, { get: function () {
    return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
  } });
  for (NAME in TypedArrayConstructorsList) if (global[NAME]) {
    createNonEnumerableProperty(global[NAME], TYPED_ARRAY_TAG, NAME);
  }
}

module.exports = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
  TYPED_ARRAY_CONSTRUCTOR: TYPED_ARRAY_CONSTRUCTOR,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQIRED && TYPED_ARRAY_TAG,
  aTypedArray: aTypedArray,
  aTypedArrayConstructor: aTypedArrayConstructor,
  exportTypedArrayMethod: exportTypedArrayMethod,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
  isView: isView,
  isTypedArray: isTypedArray,
  TypedArray: TypedArray,
  TypedArrayPrototype: TypedArrayPrototype
};


/***/ }),

/***/ 13331:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(17854);
var DESCRIPTORS = __webpack_require__(19781);
var NATIVE_ARRAY_BUFFER = __webpack_require__(24019);
var FunctionName = __webpack_require__(76530);
var createNonEnumerableProperty = __webpack_require__(68880);
var redefineAll = __webpack_require__(12248);
var fails = __webpack_require__(47293);
var anInstance = __webpack_require__(25787);
var toInteger = __webpack_require__(99958);
var toLength = __webpack_require__(17466);
var toIndex = __webpack_require__(57067);
var IEEE754 = __webpack_require__(11179);
var getPrototypeOf = __webpack_require__(79518);
var setPrototypeOf = __webpack_require__(27674);
var getOwnPropertyNames = __webpack_require__(8006).f;
var defineProperty = __webpack_require__(3070).f;
var arrayFill = __webpack_require__(21285);
var setToStringTag = __webpack_require__(58003);
var InternalStateModule = __webpack_require__(29909);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length';
var WRONG_INDEX = 'Wrong index';
var NativeArrayBuffer = global[ARRAY_BUFFER];
var $ArrayBuffer = NativeArrayBuffer;
var $DataView = global[DATA_VIEW];
var $DataViewPrototype = $DataView && $DataView[PROTOTYPE];
var ObjectPrototype = Object.prototype;
var RangeError = global.RangeError;

var packIEEE754 = IEEE754.pack;
var unpackIEEE754 = IEEE754.unpack;

var packInt8 = function (number) {
  return [number & 0xFF];
};

var packInt16 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF];
};

var packInt32 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
};

var unpackInt32 = function (buffer) {
  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};

var packFloat32 = function (number) {
  return packIEEE754(number, 23, 4);
};

var packFloat64 = function (number) {
  return packIEEE754(number, 52, 8);
};

var addGetter = function (Constructor, key) {
  defineProperty(Constructor[PROTOTYPE], key, { get: function () { return getInternalState(this)[key]; } });
};

var get = function (view, count, index, isLittleEndian) {
  var intIndex = toIndex(index);
  var store = getInternalState(view);
  if (intIndex + count > store.byteLength) throw RangeError(WRONG_INDEX);
  var bytes = getInternalState(store.buffer).bytes;
  var start = intIndex + store.byteOffset;
  var pack = bytes.slice(start, start + count);
  return isLittleEndian ? pack : pack.reverse();
};

var set = function (view, count, index, conversion, value, isLittleEndian) {
  var intIndex = toIndex(index);
  var store = getInternalState(view);
  if (intIndex + count > store.byteLength) throw RangeError(WRONG_INDEX);
  var bytes = getInternalState(store.buffer).bytes;
  var start = intIndex + store.byteOffset;
  var pack = conversion(+value);
  for (var i = 0; i < count; i++) bytes[start + i] = pack[isLittleEndian ? i : count - i - 1];
};

if (!NATIVE_ARRAY_BUFFER) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    setInternalState(this, {
      bytes: arrayFill.call(new Array(byteLength), 0),
      byteLength: byteLength
    });
    if (!DESCRIPTORS) this.byteLength = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = getInternalState(buffer).byteLength;
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    setInternalState(this, {
      buffer: buffer,
      byteLength: byteLength,
      byteOffset: offset
    });
    if (!DESCRIPTORS) {
      this.buffer = buffer;
      this.byteLength = byteLength;
      this.byteOffset = offset;
    }
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, 'byteLength');
    addGetter($DataView, 'buffer');
    addGetter($DataView, 'byteLength');
    addGetter($DataView, 'byteOffset');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined)) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 23);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 52);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : undefined);
    }
  });
} else {
  var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME && NativeArrayBuffer.name !== ARRAY_BUFFER;
  /* eslint-disable no-new -- required for testing */
  if (!fails(function () {
    NativeArrayBuffer(1);
  }) || !fails(function () {
    new NativeArrayBuffer(-1);
  }) || fails(function () {
    new NativeArrayBuffer();
    new NativeArrayBuffer(1.5);
    new NativeArrayBuffer(NaN);
    return INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
  })) {
  /* eslint-enable no-new -- required for testing */
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new NativeArrayBuffer(toIndex(length));
    };
    var ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE] = NativeArrayBuffer[PROTOTYPE];
    for (var keys = getOwnPropertyNames(NativeArrayBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) {
        createNonEnumerableProperty($ArrayBuffer, key, NativeArrayBuffer[key]);
      }
    }
    ArrayBufferPrototype.constructor = $ArrayBuffer;
  } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) {
    createNonEnumerableProperty(NativeArrayBuffer, 'name', ARRAY_BUFFER);
  }

  // WebKit bug - the same parent prototype for typed arrays and data view
  if (setPrototypeOf && getPrototypeOf($DataViewPrototype) !== ObjectPrototype) {
    setPrototypeOf($DataViewPrototype, ObjectPrototype);
  }

  // iOS Safari 7.x bug
  var testView = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataViewPrototype.setInt8;
  testView.setInt8(0, 2147483648);
  testView.setInt8(1, 2147483649);
  if (testView.getInt8(0) || !testView.getInt8(1)) redefineAll($DataViewPrototype, {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, { unsafe: true });
}

setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);

module.exports = {
  ArrayBuffer: $ArrayBuffer,
  DataView: $DataView
};


/***/ }),

/***/ 1048:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toObject = __webpack_require__(47908);
var toAbsoluteIndex = __webpack_require__(51400);
var toLength = __webpack_require__(17466);

var min = Math.min;

// `Array.prototype.copyWithin` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
// eslint-disable-next-line es/no-array-prototype-copywithin -- safe
module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),

/***/ 21285:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toObject = __webpack_require__(47908);
var toAbsoluteIndex = __webpack_require__(51400);
var toLength = __webpack_require__(17466);

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ 18533:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $forEach = __webpack_require__(42092).forEach;
var arrayMethodIsStrict = __webpack_require__(9341);

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ 97745:
/***/ ((module) => {

module.exports = function (Constructor, list) {
  var index = 0;
  var length = list.length;
  var result = new Constructor(length);
  while (length > index) result[index] = list[index++];
  return result;
};


/***/ }),

/***/ 48457:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var bind = __webpack_require__(49974);
var toObject = __webpack_require__(47908);
var callWithSafeIterationClosing = __webpack_require__(53411);
var isArrayIteratorMethod = __webpack_require__(97659);
var isConstructor = __webpack_require__(4411);
var toLength = __webpack_require__(17466);
var createProperty = __webpack_require__(86135);
var getIterator = __webpack_require__(18554);
var getIteratorMethod = __webpack_require__(71246);

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength(O.length);
    result = IS_CONSTRUCTOR ? new this(length) : Array(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ 41318:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toIndexedObject = __webpack_require__(45656);
var toLength = __webpack_require__(17466);
var toAbsoluteIndex = __webpack_require__(51400);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 42092:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var bind = __webpack_require__(49974);
var IndexedObject = __webpack_require__(68361);
var toObject = __webpack_require__(47908);
var toLength = __webpack_require__(17466);
var arraySpeciesCreate = __webpack_require__(65417);

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ 86583:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable es/no-array-prototype-lastindexof -- safe */
var toIndexedObject = __webpack_require__(45656);
var toInteger = __webpack_require__(99958);
var toLength = __webpack_require__(17466);
var arrayMethodIsStrict = __webpack_require__(9341);

var min = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return $lastIndexOf.apply(this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = toLength(O.length);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toInteger(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;


/***/ }),

/***/ 81194:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);
var wellKnownSymbol = __webpack_require__(5112);
var V8_VERSION = __webpack_require__(7392);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ 9341:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(47293);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ 53671:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var aCallable = __webpack_require__(19662);
var toObject = __webpack_require__(47908);
var IndexedObject = __webpack_require__(68361);
var toLength = __webpack_require__(17466);

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = toLength(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),

/***/ 94362:
/***/ ((module) => {

// TODO: use something more complex like timsort?
var floor = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    mergeSort(array.slice(0, middle), comparefn),
    mergeSort(array.slice(middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;
  var result = [];

  while (lindex < llength || rindex < rlength) {
    if (lindex < llength && rindex < rlength) {
      result.push(comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]);
    } else {
      result.push(lindex < llength ? left[lindex++] : right[rindex++]);
    }
  } return result;
};

module.exports = mergeSort;


/***/ }),

/***/ 77475:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isArray = __webpack_require__(43157);
var isConstructor = __webpack_require__(4411);
var isObject = __webpack_require__(70111);
var wellKnownSymbol = __webpack_require__(5112);

var SPECIES = wellKnownSymbol('species');

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ 65417:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arraySpeciesConstructor = __webpack_require__(77475);

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ 53411:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var anObject = __webpack_require__(19670);
var iteratorClose = __webpack_require__(99212);

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};


/***/ }),

/***/ 17072:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__(5112);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ 84326:
/***/ ((module) => {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ 70648:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var TO_STRING_TAG_SUPPORT = __webpack_require__(51694);
var isCallable = __webpack_require__(60614);
var classofRaw = __webpack_require__(84326);
var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ 95631:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineProperty = __webpack_require__(3070).f;
var create = __webpack_require__(70030);
var redefineAll = __webpack_require__(12248);
var bind = __webpack_require__(49974);
var anInstance = __webpack_require__(25787);
var iterate = __webpack_require__(20408);
var defineIterator = __webpack_require__(70654);
var setSpecies = __webpack_require__(96340);
var DESCRIPTORS = __webpack_require__(19781);
var fastKey = __webpack_require__(62423).fastKey;
var InternalStateModule = __webpack_require__(29909);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    redefineAll(C.prototype, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineProperty(C.prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return C;
  },
  setStrong: function (C, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
    // https://tc39.es/ecma262/#sec-map.prototype.entries
    // https://tc39.es/ecma262/#sec-map.prototype.keys
    // https://tc39.es/ecma262/#sec-map.prototype.values
    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
    // https://tc39.es/ecma262/#sec-set.prototype.entries
    // https://tc39.es/ecma262/#sec-set.prototype.keys
    // https://tc39.es/ecma262/#sec-set.prototype.values
    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
    defineIterator(C, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return { value: undefined, done: true };
      }
      // return step by kind
      if (kind == 'keys') return { value: entry.key, done: false };
      if (kind == 'values') return { value: entry.value, done: false };
      return { value: [entry.key, entry.value], done: false };
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // `{ Map, Set }.prototype[@@species]` accessors
    // https://tc39.es/ecma262/#sec-get-map-@@species
    // https://tc39.es/ecma262/#sec-get-set-@@species
    setSpecies(CONSTRUCTOR_NAME);
  }
};


/***/ }),

/***/ 29320:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var redefineAll = __webpack_require__(12248);
var getWeakData = __webpack_require__(62423).getWeakData;
var anObject = __webpack_require__(19670);
var isObject = __webpack_require__(70111);
var anInstance = __webpack_require__(25787);
var iterate = __webpack_require__(20408);
var ArrayIterationModule = __webpack_require__(42092);
var $has = __webpack_require__(86656);
var InternalStateModule = __webpack_require__(29909);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (store) {
  return store.frozen || (store.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function () {
  this.entries = [];
};

var findUncaughtFrozen = function (store, key) {
  return find(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.entries.push([key, value]);
  },
  'delete': function (key) {
    var index = findIndex(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) this.entries.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: undefined
      });
      if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);
      else data[state.id] = value;
      return that;
    };

    redefineAll(C.prototype, {
      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
      'delete': function (key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && $has(data, state.id) && delete data[state.id];
      },
      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
      // https://tc39.es/ecma262/#sec-weakset.prototype.has
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && $has(data, state.id);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // `WeakMap.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
      get: function get(key) {
        var state = getInternalState(this);
        if (isObject(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          return data ? data[state.id] : undefined;
        }
      },
      // `WeakMap.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // `WeakSet.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-weakset.prototype.add
      add: function add(value) {
        return define(this, value, true);
      }
    });

    return C;
  }
};


/***/ }),

/***/ 77710:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var global = __webpack_require__(17854);
var isForced = __webpack_require__(54705);
var redefine = __webpack_require__(31320);
var InternalMetadataModule = __webpack_require__(62423);
var iterate = __webpack_require__(20408);
var anInstance = __webpack_require__(25787);
var isCallable = __webpack_require__(60614);
var isObject = __webpack_require__(70111);
var fails = __webpack_require__(47293);
var checkCorrectnessOfIteration = __webpack_require__(17072);
var setToStringTag = __webpack_require__(58003);
var inheritIfRequired = __webpack_require__(79587);

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var nativeMethod = NativePrototype[KEY];
    redefine(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        nativeMethod.call(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        nativeMethod.call(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.enable();
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, Constructor, CONSTRUCTOR_NAME);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ 99920:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var has = __webpack_require__(86656);
var ownKeys = __webpack_require__(53887);
var getOwnPropertyDescriptorModule = __webpack_require__(31236);
var definePropertyModule = __webpack_require__(3070);

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ 84964:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__(5112);

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),

/***/ 49920:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ 14230:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var requireObjectCoercible = __webpack_require__(84488);
var toString = __webpack_require__(41340);

var quot = /"/g;

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = toString(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + toString(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),

/***/ 24994:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var IteratorPrototype = __webpack_require__(13383).IteratorPrototype;
var create = __webpack_require__(70030);
var createPropertyDescriptor = __webpack_require__(79114);
var setToStringTag = __webpack_require__(58003);
var Iterators = __webpack_require__(97497);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ 68880:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var definePropertyModule = __webpack_require__(3070);
var createPropertyDescriptor = __webpack_require__(79114);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 79114:
/***/ ((module) => {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 86135:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toPropertyKey = __webpack_require__(34948);
var definePropertyModule = __webpack_require__(3070);
var createPropertyDescriptor = __webpack_require__(79114);

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ 38709:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var anObject = __webpack_require__(19670);
var ordinaryToPrimitive = __webpack_require__(92140);

// `Date.prototype[@@toPrimitive](hint)` method implementation
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
module.exports = function (hint) {
  anObject(this);
  if (hint === 'string' || hint === 'default') hint = 'string';
  else if (hint !== 'number') throw TypeError('Incorrect hint');
  return ordinaryToPrimitive(this, hint);
};


/***/ }),

/***/ 70654:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var IS_PURE = __webpack_require__(31913);
var FunctionName = __webpack_require__(76530);
var isCallable = __webpack_require__(60614);
var createIteratorConstructor = __webpack_require__(24994);
var getPrototypeOf = __webpack_require__(79518);
var setPrototypeOf = __webpack_require__(27674);
var setToStringTag = __webpack_require__(58003);
var createNonEnumerableProperty = __webpack_require__(68880);
var redefine = __webpack_require__(31320);
var wellKnownSymbol = __webpack_require__(5112);
var Iterators = __webpack_require__(97497);
var IteratorsCore = __webpack_require__(13383);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          redefine(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return nativeIterator.call(this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    redefine(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ 97235:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var path = __webpack_require__(40857);
var has = __webpack_require__(86656);
var wrappedWellKnownSymbolModule = __webpack_require__(6061);
var defineProperty = __webpack_require__(3070).f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ 19781:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ 80317:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var isObject = __webpack_require__(70111);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 48324:
/***/ ((module) => {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ 98509:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__(80317);

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ 68886:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var userAgent = __webpack_require__(88113);

var firefox = userAgent.match(/firefox\/(\d+)/i);

module.exports = !!firefox && +firefox[1];


/***/ }),

/***/ 30256:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var UA = __webpack_require__(88113);

module.exports = /MSIE|Trident/.test(UA);


/***/ }),

/***/ 6833:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var userAgent = __webpack_require__(88113);

module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);


/***/ }),

/***/ 35268:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var classof = __webpack_require__(84326);
var global = __webpack_require__(17854);

module.exports = classof(global.process) == 'process';


/***/ }),

/***/ 88113:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getBuiltIn = __webpack_require__(35005);

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ 7392:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var userAgent = __webpack_require__(88113);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ 98008:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var userAgent = __webpack_require__(88113);

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

module.exports = !!webkit && +webkit[1];


/***/ }),

/***/ 80748:
/***/ ((module) => {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 82109:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var getOwnPropertyDescriptor = __webpack_require__(31236).f;
var createNonEnumerableProperty = __webpack_require__(68880);
var redefine = __webpack_require__(31320);
var setGlobal = __webpack_require__(83505);
var copyConstructorProperties = __webpack_require__(99920);
var isForced = __webpack_require__(54705);

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ 47293:
/***/ ((module) => {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 27007:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(74916);
var redefine = __webpack_require__(31320);
var regexpExec = __webpack_require__(22261);
var fails = __webpack_require__(47293);
var wellKnownSymbol = __webpack_require__(5112);
var createNonEnumerableProperty = __webpack_require__(68880);

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    });

    redefine(String.prototype, KEY, methods[0]);
    redefine(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ 6790:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isArray = __webpack_require__(43157);
var toLength = __webpack_require__(17466);
var bind = __webpack_require__(49974);

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind(mapper, thisArg, 3) : false;
  var element;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray(element)) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1FFFFFFFFFFFFF) throw TypeError('Exceed the acceptable array length');
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

module.exports = flattenIntoArray;


/***/ }),

/***/ 76677:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ 49974:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var aCallable = __webpack_require__(19662);

// optional / simple context binding
module.exports = function (fn, that, length) {
  aCallable(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 27065:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var aCallable = __webpack_require__(19662);
var isObject = __webpack_require__(70111);

var slice = [].slice;
var factories = {};

var construct = function (C, argsLength, args) {
  if (!(argsLength in factories)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func -- we have no proper alternatives, IE8- only
    factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aCallable(this);
  var partArgs = slice.call(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = partArgs.concat(slice.call(arguments));
    return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
  };
  if (isObject(fn.prototype)) boundFunction.prototype = fn.prototype;
  return boundFunction;
};


/***/ }),

/***/ 76530:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var has = __webpack_require__(86656);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = has(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ 35005:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var isCallable = __webpack_require__(60614);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ 71246:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var classof = __webpack_require__(70648);
var getMethod = __webpack_require__(58173);
var Iterators = __webpack_require__(97497);
var wellKnownSymbol = __webpack_require__(5112);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ 18554:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var aCallable = __webpack_require__(19662);
var anObject = __webpack_require__(19670);
var getIteratorMethod = __webpack_require__(71246);

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(iteratorMethod.call(argument));
  throw TypeError(String(argument) + ' is not iterable');
};


/***/ }),

/***/ 58173:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var aCallable = __webpack_require__(19662);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};


/***/ }),

/***/ 10647:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toObject = __webpack_require__(47908);

var floor = Math.floor;
var replace = ''.replace;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace.call(replacement, symbols, function (match, ch) {
    var capture;
    switch (ch.charAt(0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return str.slice(0, position);
      case "'": return str.slice(tailPos);
      case '<':
        capture = namedCaptures[ch.slice(1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),

/***/ 17854:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();


/***/ }),

/***/ 86656:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toObject = __webpack_require__(47908);

var hasOwnProperty = {}.hasOwnProperty;

module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject(it), key);
};


/***/ }),

/***/ 3501:
/***/ ((module) => {

module.exports = {};


/***/ }),

/***/ 60490:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getBuiltIn = __webpack_require__(35005);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ 64664:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var fails = __webpack_require__(47293);
var createElement = __webpack_require__(80317);

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ 11179:
/***/ ((module) => {

// IEEE754 conversions based on https://github.com/feross/ieee754
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;

var pack = function (number, mantissaLength, bytes) {
  var buffer = new Array(bytes);
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var rt = mantissaLength === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
  var index = 0;
  var exponent, mantissa, c;
  number = abs(number);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (number != number || number === Infinity) {
    // eslint-disable-next-line no-self-compare -- NaN check
    mantissa = number != number ? 1 : 0;
    exponent = eMax;
  } else {
    exponent = floor(log(number) / LN2);
    if (number * (c = pow(2, -exponent)) < 1) {
      exponent--;
      c *= 2;
    }
    if (exponent + eBias >= 1) {
      number += rt / c;
    } else {
      number += rt * pow(2, 1 - eBias);
    }
    if (number * c >= 2) {
      exponent++;
      c /= 2;
    }
    if (exponent + eBias >= eMax) {
      mantissa = 0;
      exponent = eMax;
    } else if (exponent + eBias >= 1) {
      mantissa = (number * c - 1) * pow(2, mantissaLength);
      exponent = exponent + eBias;
    } else {
      mantissa = number * pow(2, eBias - 1) * pow(2, mantissaLength);
      exponent = 0;
    }
  }
  for (; mantissaLength >= 8; buffer[index++] = mantissa & 255, mantissa /= 256, mantissaLength -= 8);
  exponent = exponent << mantissaLength | mantissa;
  exponentLength += mantissaLength;
  for (; exponentLength > 0; buffer[index++] = exponent & 255, exponent /= 256, exponentLength -= 8);
  buffer[--index] |= sign * 128;
  return buffer;
};

var unpack = function (buffer, mantissaLength) {
  var bytes = buffer.length;
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var nBits = exponentLength - 7;
  var index = bytes - 1;
  var sign = buffer[index--];
  var exponent = sign & 127;
  var mantissa;
  sign >>= 7;
  for (; nBits > 0; exponent = exponent * 256 + buffer[index], index--, nBits -= 8);
  mantissa = exponent & (1 << -nBits) - 1;
  exponent >>= -nBits;
  nBits += mantissaLength;
  for (; nBits > 0; mantissa = mantissa * 256 + buffer[index], index--, nBits -= 8);
  if (exponent === 0) {
    exponent = 1 - eBias;
  } else if (exponent === eMax) {
    return mantissa ? NaN : sign ? -Infinity : Infinity;
  } else {
    mantissa = mantissa + pow(2, mantissaLength);
    exponent = exponent - eBias;
  } return (sign ? -1 : 1) * mantissa * pow(2, exponent - mantissaLength);
};

module.exports = {
  pack: pack,
  unpack: unpack
};


/***/ }),

/***/ 68361:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);
var classof = __webpack_require__(84326);

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ 79587:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__(60614);
var isObject = __webpack_require__(70111);
var setPrototypeOf = __webpack_require__(27674);

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ 42788:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__(60614);
var store = __webpack_require__(5465);

var functionToString = Function.toString;

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ 62423:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var hiddenKeys = __webpack_require__(3501);
var isObject = __webpack_require__(70111);
var has = __webpack_require__(86656);
var defineProperty = __webpack_require__(3070).f;
var getOwnPropertyNamesModule = __webpack_require__(8006);
var getOwnPropertyNamesExternalModule = __webpack_require__(1156);
var uid = __webpack_require__(69711);
var FREEZING = __webpack_require__(76677);

var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;

// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
  var splice = [].splice;
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    getOwnPropertyNamesModule.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice.call(result, i, 1);
          break;
        }
      } return result;
    };

    $({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};

var meta = module.exports = {
  enable: enable,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),

/***/ 29909:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var NATIVE_WEAK_MAP = __webpack_require__(68536);
var global = __webpack_require__(17854);
var isObject = __webpack_require__(70111);
var createNonEnumerableProperty = __webpack_require__(68880);
var objectHas = __webpack_require__(86656);
var shared = __webpack_require__(5465);
var sharedKey = __webpack_require__(6200);
var hiddenKeys = __webpack_require__(3501);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ 97659:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__(5112);
var Iterators = __webpack_require__(97497);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ 43157:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var classof = __webpack_require__(84326);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ 60614:
/***/ ((module) => {

// `isCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument === 'function';
};


/***/ }),

/***/ 4411:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);
var isCallable = __webpack_require__(60614);
var classof = __webpack_require__(70648);
var getBuiltIn = __webpack_require__(35005);
var inspectSource = __webpack_require__(42788);

var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = constructorRegExp.exec;
var INCORRECT_TO_STRING = !constructorRegExp.exec(function () { /* empty */ });

var isConstructorModern = function (argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(Object, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function (argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
    // we can't check .prototype since constructors produced by .bind haven't it
  } return INCORRECT_TO_STRING || !!exec.call(constructorRegExp, inspectSource(argument));
};

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ 45032:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var has = __webpack_require__(86656);

module.exports = function (descriptor) {
  return descriptor !== undefined && (has(descriptor, 'value') || has(descriptor, 'writable'));
};


/***/ }),

/***/ 54705:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);
var isCallable = __webpack_require__(60614);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 18730:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(70111);

var floor = Math.floor;

// `Number.isInteger` method implementation
// https://tc39.es/ecma262/#sec-number.isinteger
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ 70111:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__(60614);

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ 31913:
/***/ ((module) => {

module.exports = false;


/***/ }),

/***/ 47850:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(70111);
var classof = __webpack_require__(84326);
var wellKnownSymbol = __webpack_require__(5112);

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ 52190:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__(60614);
var getBuiltIn = __webpack_require__(35005);
var USE_SYMBOL_AS_UID = __webpack_require__(43307);

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && Object(it) instanceof $Symbol;
};


/***/ }),

/***/ 20408:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var anObject = __webpack_require__(19670);
var isArrayIteratorMethod = __webpack_require__(97659);
var toLength = __webpack_require__(17466);
var bind = __webpack_require__(49974);
var getIterator = __webpack_require__(18554);
var getIteratorMethod = __webpack_require__(71246);
var iteratorClose = __webpack_require__(99212);

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw TypeError(String(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};


/***/ }),

/***/ 99212:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var anObject = __webpack_require__(19670);
var getMethod = __webpack_require__(58173);

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = innerResult.call(iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ 13383:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(47293);
var isCallable = __webpack_require__(60614);
var create = __webpack_require__(70030);
var getPrototypeOf = __webpack_require__(79518);
var redefine = __webpack_require__(31320);
var wellKnownSymbol = __webpack_require__(5112);
var IS_PURE = __webpack_require__(31913);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  redefine(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ 97497:
/***/ ((module) => {

module.exports = {};


/***/ }),

/***/ 64310:
/***/ ((module) => {

// `Math.sign` method implementation
// https://tc39.es/ecma262/#sec-math.sign
// eslint-disable-next-line es/no-math-sign -- safe
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),

/***/ 13366:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);

module.exports = global.Promise;


/***/ }),

/***/ 30133:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(7392);
var fails = __webpack_require__(47293);

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 590:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);
var wellKnownSymbol = __webpack_require__(5112);
var IS_PURE = __webpack_require__(31913);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = !fails(function () {
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});


/***/ }),

/***/ 68536:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var isCallable = __webpack_require__(60614);
var inspectSource = __webpack_require__(42788);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ 78523:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var aCallable = __webpack_require__(19662);

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ 3929:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isRegExp = __webpack_require__(47850);

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ 83009:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var fails = __webpack_require__(47293);
var toString = __webpack_require__(41340);
var trim = __webpack_require__(53111).trim;
var whitespaces = __webpack_require__(81361);

var $parseInt = global.parseInt;
var Symbol = global.Symbol;
var ITERATOR = Symbol && Symbol.iterator;
var hex = /^[+-]?0[Xx]/;
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR && !fails(function () { $parseInt(Object(ITERATOR)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
  var S = trim(toString(string));
  return $parseInt(S, (radix >>> 0) || (hex.test(S) ? 16 : 10));
} : $parseInt;


/***/ }),

/***/ 21574:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(19781);
var fails = __webpack_require__(47293);
var objectKeys = __webpack_require__(81956);
var getOwnPropertySymbolsModule = __webpack_require__(25181);
var propertyIsEnumerableModule = __webpack_require__(55296);
var toObject = __webpack_require__(47908);
var IndexedObject = __webpack_require__(68361);

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 70030:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(19670);
var defineProperties = __webpack_require__(36048);
var enumBugKeys = __webpack_require__(80748);
var hiddenKeys = __webpack_require__(3501);
var html = __webpack_require__(60490);
var documentCreateElement = __webpack_require__(80317);
var sharedKey = __webpack_require__(6200);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ 36048:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var definePropertyModule = __webpack_require__(3070);
var anObject = __webpack_require__(19670);
var objectKeys = __webpack_require__(81956);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ 3070:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var IE8_DOM_DEFINE = __webpack_require__(64664);
var anObject = __webpack_require__(19670);
var toPropertyKey = __webpack_require__(34948);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 31236:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var propertyIsEnumerableModule = __webpack_require__(55296);
var createPropertyDescriptor = __webpack_require__(79114);
var toIndexedObject = __webpack_require__(45656);
var toPropertyKey = __webpack_require__(34948);
var has = __webpack_require__(86656);
var IE8_DOM_DEFINE = __webpack_require__(64664);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ 1156:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable es/no-object-getownpropertynames -- safe */
var toIndexedObject = __webpack_require__(45656);
var $getOwnPropertyNames = __webpack_require__(8006).f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ 8006:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var internalObjectKeys = __webpack_require__(16324);
var enumBugKeys = __webpack_require__(80748);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ 25181:
/***/ ((__unused_webpack_module, exports) => {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 79518:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var has = __webpack_require__(86656);
var isCallable = __webpack_require__(60614);
var toObject = __webpack_require__(47908);
var sharedKey = __webpack_require__(6200);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(49920);

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (has(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ 16324:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var has = __webpack_require__(86656);
var toIndexedObject = __webpack_require__(45656);
var indexOf = __webpack_require__(41318).indexOf;
var hiddenKeys = __webpack_require__(3501);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ 81956:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var internalObjectKeys = __webpack_require__(16324);
var enumBugKeys = __webpack_require__(80748);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ 55296:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 27674:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable no-proto -- safe */
var anObject = __webpack_require__(19670);
var aPossiblePrototype = __webpack_require__(96077);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ 44699:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var objectKeys = __webpack_require__(81956);
var toIndexedObject = __webpack_require__(45656);
var propertyIsEnumerable = __webpack_require__(55296).f;

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(O, key)) {
        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),

/***/ 90288:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(51694);
var classof = __webpack_require__(70648);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ 92140:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__(60614);
var isObject = __webpack_require__(70111);

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = fn.call(input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = fn.call(input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 53887:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getBuiltIn = __webpack_require__(35005);
var getOwnPropertyNamesModule = __webpack_require__(8006);
var getOwnPropertySymbolsModule = __webpack_require__(25181);
var anObject = __webpack_require__(19670);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ 40857:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);

module.exports = global;


/***/ }),

/***/ 12534:
/***/ ((module) => {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ 69478:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var anObject = __webpack_require__(19670);
var isObject = __webpack_require__(70111);
var newPromiseCapability = __webpack_require__(78523);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ 12248:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var redefine = __webpack_require__(31320);

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ 31320:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var isCallable = __webpack_require__(60614);
var has = __webpack_require__(86656);
var createNonEnumerableProperty = __webpack_require__(68880);
var setGlobal = __webpack_require__(83505);
var inspectSource = __webpack_require__(42788);
var InternalStateModule = __webpack_require__(29909);
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__(76530).CONFIGURABLE;

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!has(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
      createNonEnumerableProperty(value, 'name', name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ 97651:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var anObject = __webpack_require__(19670);
var isCallable = __webpack_require__(60614);
var classof = __webpack_require__(84326);
var regexpExec = __webpack_require__(22261);

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = exec.call(R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === 'RegExp') return regexpExec.call(R, S);
  throw TypeError('RegExp#exec called on incompatible receiver');
};


/***/ }),

/***/ 22261:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var toString = __webpack_require__(41340);
var regexpFlags = __webpack_require__(67066);
var stickyHelpers = __webpack_require__(52999);
var shared = __webpack_require__(72309);
var create = __webpack_require__(70030);
var getInternalState = __webpack_require__(29909).get;
var UNSUPPORTED_DOT_ALL = __webpack_require__(9441);
var UNSUPPORTED_NCG = __webpack_require__(38173);

var nativeExec = RegExp.prototype.exec;
var nativeReplace = shared('native-string-replace', String.prototype.replace);

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  // eslint-disable-next-line max-statements -- TODO
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = patchedExec.call(raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = str.slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str.charAt(re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ 67066:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var anObject = __webpack_require__(19670);

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ 52999:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var fails = __webpack_require__(47293);
var global = __webpack_require__(17854);

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;

exports.UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

exports.BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});


/***/ }),

/***/ 9441:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);
var global = __webpack_require__(17854);

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});


/***/ }),

/***/ 38173:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);
var global = __webpack_require__(17854);

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),

/***/ 84488:
/***/ ((module) => {

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 81150:
/***/ ((module) => {

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),

/***/ 83505:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);

module.exports = function (key, value) {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ 96340:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var getBuiltIn = __webpack_require__(35005);
var definePropertyModule = __webpack_require__(3070);
var wellKnownSymbol = __webpack_require__(5112);
var DESCRIPTORS = __webpack_require__(19781);

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ 58003:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var defineProperty = __webpack_require__(3070).f;
var has = __webpack_require__(86656);
var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ 6200:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var shared = __webpack_require__(72309);
var uid = __webpack_require__(69711);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ 5465:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var setGlobal = __webpack_require__(83505);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ 72309:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var IS_PURE = __webpack_require__(31913);
var store = __webpack_require__(5465);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.18.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ 36707:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var anObject = __webpack_require__(19670);
var aConstructor = __webpack_require__(39483);
var wellKnownSymbol = __webpack_require__(5112);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aConstructor(S);
};


/***/ }),

/***/ 43429:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),

/***/ 28710:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toInteger = __webpack_require__(99958);
var toString = __webpack_require__(41340);
var requireObjectCoercible = __webpack_require__(84488);

// `String.prototype.codePointAt` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ 54986:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// https://github.com/zloirock/core-js/issues/280
var userAgent = __webpack_require__(88113);

// eslint-disable-next-line unicorn/no-unsafe-regex -- safe
module.exports = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(userAgent);


/***/ }),

/***/ 76650:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var repeat = __webpack_require__(38415);
var requireObjectCoercible = __webpack_require__(84488);

var ceil = Math.ceil;

// `String.prototype.{ padStart, padEnd }` methods implementation
var createMethod = function (IS_END) {
  return function ($this, maxLength, fillString) {
    var S = toString(requireObjectCoercible($this));
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : toString(fillString);
    var intMaxLength = toLength(maxLength);
    var fillLen, stringFiller;
    if (intMaxLength <= stringLength || fillStr == '') return S;
    fillLen = intMaxLength - stringLength;
    stringFiller = repeat.call(fillStr, ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
    return IS_END ? S + stringFiller : stringFiller + S;
  };
};

module.exports = {
  // `String.prototype.padStart` method
  // https://tc39.es/ecma262/#sec-string.prototype.padstart
  start: createMethod(false),
  // `String.prototype.padEnd` method
  // https://tc39.es/ecma262/#sec-string.prototype.padend
  end: createMethod(true)
};


/***/ }),

/***/ 33197:
/***/ ((module) => {

"use strict";

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;
var floor = Math.floor;
var stringFromCharCode = String.fromCharCode;

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = string.charCodeAt(counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = string.charCodeAt(counter++);
      if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor(delta / damp) : delta >> 1;
  delta += floor(delta / numPoints);
  for (; delta > baseMinusTMin * tMax >> 1; k += base) {
    delta = floor(delta / baseMinusTMin);
  }
  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
// eslint-disable-next-line max-statements -- TODO
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      output.push(stringFromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    output.push(delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
      throw RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw RangeError(OVERFLOW_ERROR);
      }
      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        for (var k = base; /* no condition */; k += base) {
          var t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor(qMinusT / baseMinusT);
        }

        output.push(stringFromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        ++handledCPCount;
      }
    }

    ++delta;
    ++n;
  }
  return output.join('');
};

module.exports = function (input) {
  var encoded = [];
  var labels = input.toLowerCase().replace(regexSeparators, '\u002E').split('.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    encoded.push(regexNonASCII.test(label) ? 'xn--' + encode(label) : label);
  }
  return encoded.join('.');
};


/***/ }),

/***/ 38415:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toInteger = __webpack_require__(99958);
var toString = __webpack_require__(41340);
var requireObjectCoercible = __webpack_require__(84488);

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
module.exports = function repeat(count) {
  var str = toString(requireObjectCoercible(this));
  var result = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};


/***/ }),

/***/ 76091:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var PROPER_FUNCTION_NAME = __webpack_require__(76530).PROPER;
var fails = __webpack_require__(47293);
var whitespaces = __webpack_require__(81361);

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};


/***/ }),

/***/ 53111:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var requireObjectCoercible = __webpack_require__(84488);
var toString = __webpack_require__(41340);
var whitespaces = __webpack_require__(81361);

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ 20261:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var isCallable = __webpack_require__(60614);
var fails = __webpack_require__(47293);
var bind = __webpack_require__(49974);
var html = __webpack_require__(60490);
var createElement = __webpack_require__(80317);
var IS_IOS = __webpack_require__(6833);
var IS_NODE = __webpack_require__(35268);

var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var location, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  location = global.location;
} catch (error) { /* empty */ }

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins -- safe
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global.postMessage(String(id), location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = [];
    var argumentsLength = arguments.length;
    var i = 1;
    while (argumentsLength > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func -- spec requirement
      (isCallable(fn) ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    isCallable(global.postMessage) &&
    !global.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails(post)
  ) {
    defer = post;
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ 50863:
/***/ ((module) => {

var valueOf = 1.0.valueOf;

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = function (value) {
  return valueOf.call(value);
};


/***/ }),

/***/ 51400:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toInteger = __webpack_require__(99958);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 57067:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toInteger = __webpack_require__(99958);
var toLength = __webpack_require__(17466);

// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length or index');
  return length;
};


/***/ }),

/***/ 45656:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(68361);
var requireObjectCoercible = __webpack_require__(84488);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 99958:
/***/ ((module) => {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ 17466:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toInteger = __webpack_require__(99958);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 47908:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var requireObjectCoercible = __webpack_require__(84488);

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 84590:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toPositiveInteger = __webpack_require__(73002);

module.exports = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw RangeError('Wrong offset');
  return offset;
};


/***/ }),

/***/ 73002:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toInteger = __webpack_require__(99958);

module.exports = function (it) {
  var result = toInteger(it);
  if (result < 0) throw RangeError("The argument can't be less than 0");
  return result;
};


/***/ }),

/***/ 57593:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(70111);
var isSymbol = __webpack_require__(52190);
var getMethod = __webpack_require__(58173);
var ordinaryToPrimitive = __webpack_require__(92140);
var wellKnownSymbol = __webpack_require__(5112);

var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = exoticToPrim.call(input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 34948:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toPrimitive = __webpack_require__(57593);
var isSymbol = __webpack_require__(52190);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : String(key);
};


/***/ }),

/***/ 51694:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ 41340:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var classof = __webpack_require__(70648);

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};


/***/ }),

/***/ 66330:
/***/ ((module) => {

module.exports = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ 19843:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var global = __webpack_require__(17854);
var DESCRIPTORS = __webpack_require__(19781);
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(63832);
var ArrayBufferViewCore = __webpack_require__(90260);
var ArrayBufferModule = __webpack_require__(13331);
var anInstance = __webpack_require__(25787);
var createPropertyDescriptor = __webpack_require__(79114);
var createNonEnumerableProperty = __webpack_require__(68880);
var isInteger = __webpack_require__(18730);
var toLength = __webpack_require__(17466);
var toIndex = __webpack_require__(57067);
var toOffset = __webpack_require__(84590);
var toPropertyKey = __webpack_require__(34948);
var has = __webpack_require__(86656);
var classof = __webpack_require__(70648);
var isObject = __webpack_require__(70111);
var isSymbol = __webpack_require__(52190);
var create = __webpack_require__(70030);
var setPrototypeOf = __webpack_require__(27674);
var getOwnPropertyNames = __webpack_require__(8006).f;
var typedArrayFrom = __webpack_require__(97321);
var forEach = __webpack_require__(42092).forEach;
var setSpecies = __webpack_require__(96340);
var definePropertyModule = __webpack_require__(3070);
var getOwnPropertyDescriptorModule = __webpack_require__(31236);
var InternalStateModule = __webpack_require__(29909);
var inheritIfRequired = __webpack_require__(79587);

var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var round = Math.round;
var RangeError = global.RangeError;
var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
var DataView = ArrayBufferModule.DataView;
var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
var TYPED_ARRAY_CONSTRUCTOR = ArrayBufferViewCore.TYPED_ARRAY_CONSTRUCTOR;
var TYPED_ARRAY_TAG = ArrayBufferViewCore.TYPED_ARRAY_TAG;
var TypedArray = ArrayBufferViewCore.TypedArray;
var TypedArrayPrototype = ArrayBufferViewCore.TypedArrayPrototype;
var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var isTypedArray = ArrayBufferViewCore.isTypedArray;
var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
var WRONG_LENGTH = 'Wrong length';

var fromList = function (C, list) {
  var index = 0;
  var length = list.length;
  var result = new (aTypedArrayConstructor(C))(length);
  while (length > index) result[index] = list[index++];
  return result;
};

var addGetter = function (it, key) {
  nativeDefineProperty(it, key, { get: function () {
    return getInternalState(this)[key];
  } });
};

var isArrayBuffer = function (it) {
  var klass;
  return it instanceof ArrayBuffer || (klass = classof(it)) == 'ArrayBuffer' || klass == 'SharedArrayBuffer';
};

var isTypedArrayIndex = function (target, key) {
  return isTypedArray(target)
    && !isSymbol(key)
    && key in target
    && isInteger(+key)
    && key >= 0;
};

var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
  key = toPropertyKey(key);
  return isTypedArrayIndex(target, key)
    ? createPropertyDescriptor(2, target[key])
    : nativeGetOwnPropertyDescriptor(target, key);
};

var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
  key = toPropertyKey(key);
  if (isTypedArrayIndex(target, key)
    && isObject(descriptor)
    && has(descriptor, 'value')
    && !has(descriptor, 'get')
    && !has(descriptor, 'set')
    // TODO: add validation descriptor w/o calling accessors
    && !descriptor.configurable
    && (!has(descriptor, 'writable') || descriptor.writable)
    && (!has(descriptor, 'enumerable') || descriptor.enumerable)
  ) {
    target[key] = descriptor.value;
    return target;
  } return nativeDefineProperty(target, key, descriptor);
};

if (DESCRIPTORS) {
  if (!NATIVE_ARRAY_BUFFER_VIEWS) {
    getOwnPropertyDescriptorModule.f = wrappedGetOwnPropertyDescriptor;
    definePropertyModule.f = wrappedDefineProperty;
    addGetter(TypedArrayPrototype, 'buffer');
    addGetter(TypedArrayPrototype, 'byteOffset');
    addGetter(TypedArrayPrototype, 'byteLength');
    addGetter(TypedArrayPrototype, 'length');
  }

  $({ target: 'Object', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
    getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
    defineProperty: wrappedDefineProperty
  });

  module.exports = function (TYPE, wrapper, CLAMPED) {
    var BYTES = TYPE.match(/\d+$/)[0] / 8;
    var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + TYPE;
    var SETTER = 'set' + TYPE;
    var NativeTypedArrayConstructor = global[CONSTRUCTOR_NAME];
    var TypedArrayConstructor = NativeTypedArrayConstructor;
    var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
    var exported = {};

    var getter = function (that, index) {
      var data = getInternalState(that);
      return data.view[GETTER](index * BYTES + data.byteOffset, true);
    };

    var setter = function (that, index, value) {
      var data = getInternalState(that);
      if (CLAMPED) value = (value = round(value)) < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
      data.view[SETTER](index * BYTES + data.byteOffset, value, true);
    };

    var addElement = function (that, index) {
      nativeDefineProperty(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };

    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
      TypedArrayConstructor = wrapper(function (that, data, offset, $length) {
        anInstance(that, TypedArrayConstructor, CONSTRUCTOR_NAME);
        var index = 0;
        var byteOffset = 0;
        var buffer, byteLength, length;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new ArrayBuffer(byteLength);
        } else if (isArrayBuffer(data)) {
          buffer = data;
          byteOffset = toOffset(offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - byteOffset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + byteOffset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (isTypedArray(data)) {
          return fromList(TypedArrayConstructor, data);
        } else {
          return typedArrayFrom.call(TypedArrayConstructor, data);
        }
        setInternalState(that, {
          buffer: buffer,
          byteOffset: byteOffset,
          byteLength: byteLength,
          length: length,
          view: new DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = create(TypedArrayPrototype);
    } else if (TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS) {
      TypedArrayConstructor = wrapper(function (dummy, data, typedArrayOffset, $length) {
        anInstance(dummy, TypedArrayConstructor, CONSTRUCTOR_NAME);
        return inheritIfRequired(function () {
          if (!isObject(data)) return new NativeTypedArrayConstructor(toIndex(data));
          if (isArrayBuffer(data)) return $length !== undefined
            ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES), $length)
            : typedArrayOffset !== undefined
              ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES))
              : new NativeTypedArrayConstructor(data);
          if (isTypedArray(data)) return fromList(TypedArrayConstructor, data);
          return typedArrayFrom.call(TypedArrayConstructor, data);
        }(), dummy, TypedArrayConstructor);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function (key) {
        if (!(key in TypedArrayConstructor)) {
          createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
        }
      });
      TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
    }

    if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
    }

    createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_CONSTRUCTOR, TypedArrayConstructor);

    if (TYPED_ARRAY_TAG) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
    }

    exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;

    $({
      global: true, forced: TypedArrayConstructor != NativeTypedArrayConstructor, sham: !NATIVE_ARRAY_BUFFER_VIEWS
    }, exported);

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
      createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
    }

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
    }

    setSpecies(CONSTRUCTOR_NAME);
  };
} else module.exports = function () { /* empty */ };


/***/ }),

/***/ 63832:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable no-new -- required for testing */
var global = __webpack_require__(17854);
var fails = __webpack_require__(47293);
var checkCorrectnessOfIteration = __webpack_require__(17072);
var NATIVE_ARRAY_BUFFER_VIEWS = __webpack_require__(90260).NATIVE_ARRAY_BUFFER_VIEWS;

var ArrayBuffer = global.ArrayBuffer;
var Int8Array = global.Int8Array;

module.exports = !NATIVE_ARRAY_BUFFER_VIEWS || !fails(function () {
  Int8Array(1);
}) || !fails(function () {
  new Int8Array(-1);
}) || !checkCorrectnessOfIteration(function (iterable) {
  new Int8Array();
  new Int8Array(null);
  new Int8Array(1.5);
  new Int8Array(iterable);
}, true) || fails(function () {
  // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
  return new Int8Array(new ArrayBuffer(2), 1, undefined).length !== 1;
});


/***/ }),

/***/ 43074:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayFromConstructorAndList = __webpack_require__(97745);
var typedArraySpeciesConstructor = __webpack_require__(66304);

module.exports = function (instance, list) {
  return arrayFromConstructorAndList(typedArraySpeciesConstructor(instance), list);
};


/***/ }),

/***/ 97321:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var aConstructor = __webpack_require__(39483);
var toObject = __webpack_require__(47908);
var toLength = __webpack_require__(17466);
var getIterator = __webpack_require__(18554);
var getIteratorMethod = __webpack_require__(71246);
var isArrayIteratorMethod = __webpack_require__(97659);
var bind = __webpack_require__(49974);
var aTypedArrayConstructor = __webpack_require__(90260).aTypedArrayConstructor;

module.exports = function from(source /* , mapfn, thisArg */) {
  var C = aConstructor(this);
  var O = toObject(source);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var i, length, result, step, iterator, next;
  if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    O = [];
    while (!(step = next.call(iterator)).done) {
      O.push(step.value);
    }
  }
  if (mapping && argumentsLength > 2) {
    mapfn = bind(mapfn, arguments[2], 2);
  }
  length = toLength(O.length);
  result = new (aTypedArrayConstructor(C))(length);
  for (i = 0; length > i; i++) {
    result[i] = mapping ? mapfn(O[i], i) : O[i];
  }
  return result;
};


/***/ }),

/***/ 66304:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ArrayBufferViewCore = __webpack_require__(90260);
var speciesConstructor = __webpack_require__(36707);

var TYPED_ARRAY_CONSTRUCTOR = ArrayBufferViewCore.TYPED_ARRAY_CONSTRUCTOR;
var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;

// a part of `TypedArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#typedarray-species-create
module.exports = function (originalArray) {
  return aTypedArrayConstructor(speciesConstructor(originalArray, originalArray[TYPED_ARRAY_CONSTRUCTOR]));
};


/***/ }),

/***/ 69711:
/***/ ((module) => {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ 43307:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(30133);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 6061:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__(5112);

exports.f = wellKnownSymbol;


/***/ }),

/***/ 5112:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var shared = __webpack_require__(72309);
var has = __webpack_require__(86656);
var uid = __webpack_require__(69711);
var NATIVE_SYMBOL = __webpack_require__(30133);
var USE_SYMBOL_AS_UID = __webpack_require__(43307);

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 81361:
/***/ ((module) => {

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ 9170:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var getPrototypeOf = __webpack_require__(79518);
var setPrototypeOf = __webpack_require__(27674);
var create = __webpack_require__(70030);
var createNonEnumerableProperty = __webpack_require__(68880);
var createPropertyDescriptor = __webpack_require__(79114);
var iterate = __webpack_require__(20408);
var toString = __webpack_require__(41340);

var $AggregateError = function AggregateError(errors, message) {
  var that = this;
  if (!(that instanceof $AggregateError)) return new $AggregateError(errors, message);
  if (setPrototypeOf) {
    // eslint-disable-next-line unicorn/error-message -- expected
    that = setPrototypeOf(new Error(undefined), getPrototypeOf(that));
  }
  if (message !== undefined) createNonEnumerableProperty(that, 'message', toString(message));
  var errorsArray = [];
  iterate(errors, errorsArray.push, { that: errorsArray });
  createNonEnumerableProperty(that, 'errors', errorsArray);
  return that;
};

$AggregateError.prototype = create(Error.prototype, {
  constructor: createPropertyDescriptor(5, $AggregateError),
  message: createPropertyDescriptor(5, ''),
  name: createPropertyDescriptor(5, 'AggregateError')
});

// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$({ global: true }, {
  AggregateError: $AggregateError
});


/***/ }),

/***/ 18264:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var global = __webpack_require__(17854);
var arrayBufferModule = __webpack_require__(13331);
var setSpecies = __webpack_require__(96340);

var ARRAY_BUFFER = 'ArrayBuffer';
var ArrayBuffer = arrayBufferModule[ARRAY_BUFFER];
var NativeArrayBuffer = global[ARRAY_BUFFER];

// `ArrayBuffer` constructor
// https://tc39.es/ecma262/#sec-arraybuffer-constructor
$({ global: true, forced: NativeArrayBuffer !== ArrayBuffer }, {
  ArrayBuffer: ArrayBuffer
});

setSpecies(ARRAY_BUFFER);


/***/ }),

/***/ 92222:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var fails = __webpack_require__(47293);
var isArray = __webpack_require__(43157);
var isObject = __webpack_require__(70111);
var toObject = __webpack_require__(47908);
var toLength = __webpack_require__(17466);
var createProperty = __webpack_require__(86135);
var arraySpeciesCreate = __webpack_require__(65417);
var arrayMethodHasSpeciesSupport = __webpack_require__(81194);
var wellKnownSymbol = __webpack_require__(5112);
var V8_VERSION = __webpack_require__(7392);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ 50545:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var copyWithin = __webpack_require__(1048);
var addToUnscopables = __webpack_require__(51223);

// `Array.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
$({ target: 'Array', proto: true }, {
  copyWithin: copyWithin
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('copyWithin');


/***/ }),

/***/ 43290:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var fill = __webpack_require__(21285);
var addToUnscopables = __webpack_require__(51223);

// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$({ target: 'Array', proto: true }, {
  fill: fill
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('fill');


/***/ }),

/***/ 57327:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var $filter = __webpack_require__(42092).filter;
var arrayMethodHasSpeciesSupport = __webpack_require__(81194);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 34553:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var $findIndex = __webpack_require__(42092).findIndex;
var addToUnscopables = __webpack_require__(51223);

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),

/***/ 69826:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var $find = __webpack_require__(42092).find;
var addToUnscopables = __webpack_require__(51223);

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ 86535:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var flattenIntoArray = __webpack_require__(6790);
var aCallable = __webpack_require__(19662);
var toObject = __webpack_require__(47908);
var toLength = __webpack_require__(17466);
var arraySpeciesCreate = __webpack_require__(65417);

// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$({ target: 'Array', proto: true }, {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A;
    aCallable(callbackfn);
    A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return A;
  }
});


/***/ }),

/***/ 84944:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var flattenIntoArray = __webpack_require__(6790);
var toObject = __webpack_require__(47908);
var toLength = __webpack_require__(17466);
var toInteger = __webpack_require__(99958);
var arraySpeciesCreate = __webpack_require__(65417);

// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});


/***/ }),

/***/ 91038:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var from = __webpack_require__(48457);
var checkCorrectnessOfIteration = __webpack_require__(17072);

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ 26699:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var $includes = __webpack_require__(41318).includes;
var addToUnscopables = __webpack_require__(51223);

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ 66992:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toIndexedObject = __webpack_require__(45656);
var addToUnscopables = __webpack_require__(51223);
var Iterators = __webpack_require__(97497);
var InternalStateModule = __webpack_require__(29909);
var defineIterator = __webpack_require__(70654);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ 69600:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var IndexedObject = __webpack_require__(68361);
var toIndexedObject = __webpack_require__(45656);
var arrayMethodIsStrict = __webpack_require__(9341);

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ 21249:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var $map = __webpack_require__(42092).map;
var arrayMethodHasSpeciesSupport = __webpack_require__(81194);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 47042:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var isArray = __webpack_require__(43157);
var isConstructor = __webpack_require__(4411);
var isObject = __webpack_require__(70111);
var toAbsoluteIndex = __webpack_require__(51400);
var toLength = __webpack_require__(17466);
var toIndexedObject = __webpack_require__(45656);
var createProperty = __webpack_require__(86135);
var wellKnownSymbol = __webpack_require__(5112);
var arrayMethodHasSpeciesSupport = __webpack_require__(81194);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ 2707:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var aCallable = __webpack_require__(19662);
var toObject = __webpack_require__(47908);
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var fails = __webpack_require__(47293);
var internalSort = __webpack_require__(94362);
var arrayMethodIsStrict = __webpack_require__(9341);
var FF = __webpack_require__(68886);
var IE_OR_EDGE = __webpack_require__(30256);
var V8 = __webpack_require__(7392);
var WEBKIT = __webpack_require__(98008);

var test = [];
var nativeSort = test.sort;

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString(x) > toString(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? nativeSort.call(array) : nativeSort.call(array, comparefn);

    var items = [];
    var arrayLength = toLength(array.length);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) items.push(array[index]);
    }

    items = internalSort(items, getSortCompare(comparefn));
    itemsLength = items.length;
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) delete array[index++];

    return array;
  }
});


/***/ }),

/***/ 40561:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var toAbsoluteIndex = __webpack_require__(51400);
var toInteger = __webpack_require__(99958);
var toLength = __webpack_require__(17466);
var toObject = __webpack_require__(47908);
var arraySpeciesCreate = __webpack_require__(65417);
var createProperty = __webpack_require__(86135);
var arrayMethodHasSpeciesSupport = __webpack_require__(81194);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var max = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),

/***/ 99244:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = __webpack_require__(51223);

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flatMap');


/***/ }),

/***/ 96078:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var redefine = __webpack_require__(31320);
var dateToPrimitive = __webpack_require__(38709);
var wellKnownSymbol = __webpack_require__(5112);

var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var DatePrototype = Date.prototype;

// `Date.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
if (!(TO_PRIMITIVE in DatePrototype)) {
  redefine(DatePrototype, TO_PRIMITIVE, dateToPrimitive);
}


/***/ }),

/***/ 68309:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var FUNCTION_NAME_EXISTS = __webpack_require__(76530).EXISTS;
var defineProperty = __webpack_require__(3070).f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ 35837:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var global = __webpack_require__(17854);

// `globalThis` object
// https://tc39.es/ecma262/#sec-globalthis
$({ global: true }, {
  globalThis: global
});


/***/ }),

/***/ 73706:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var setToStringTag = __webpack_require__(58003);

// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 51532:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var collection = __webpack_require__(77710);
var collectionStrong = __webpack_require__(95631);

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
module.exports = collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ 90332:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var fails = __webpack_require__(47293);

// eslint-disable-next-line es/no-math-imul -- required for testing
var $imul = Math.imul;

var FORCED = fails(function () {
  return $imul(0xFFFFFFFF, 5) != -5 || $imul.length != 2;
});

// `Math.imul` method
// https://tc39.es/ecma262/#sec-math.imul
// some WebKit versions fails with big numbers, some has wrong arity
$({ target: 'Math', stat: true, forced: FORCED }, {
  imul: function imul(x, y) {
    var UINT16 = 0xFFFF;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),

/***/ 40658:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);

var log = Math.log;
var LOG10E = Math.LOG10E;

// `Math.log10` method
// https://tc39.es/ecma262/#sec-math.log10
$({ target: 'Math', stat: true }, {
  log10: function log10(x) {
    return log(x) * LOG10E;
  }
});


/***/ }),

/***/ 44914:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);

var log = Math.log;
var LN2 = Math.LN2;

// `Math.log2` method
// https://tc39.es/ecma262/#sec-math.log2
$({ target: 'Math', stat: true }, {
  log2: function log2(x) {
    return log(x) / LN2;
  }
});


/***/ }),

/***/ 52420:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var sign = __webpack_require__(64310);

// `Math.sign` method
// https://tc39.es/ecma262/#sec-math.sign
$({ target: 'Math', stat: true }, {
  sign: sign
});


/***/ }),

/***/ 10408:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var setToStringTag = __webpack_require__(58003);

// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
setToStringTag(Math, 'Math', true);


/***/ }),

/***/ 73689:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
$({ target: 'Math', stat: true }, {
  trunc: function trunc(it) {
    return (it > 0 ? floor : ceil)(it);
  }
});


/***/ }),

/***/ 9653:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(19781);
var global = __webpack_require__(17854);
var isForced = __webpack_require__(54705);
var redefine = __webpack_require__(31320);
var has = __webpack_require__(86656);
var classof = __webpack_require__(84326);
var inheritIfRequired = __webpack_require__(79587);
var isSymbol = __webpack_require__(52190);
var toPrimitive = __webpack_require__(57593);
var fails = __webpack_require__(47293);
var create = __webpack_require__(70030);
var getOwnPropertyNames = __webpack_require__(8006).f;
var getOwnPropertyDescriptor = __webpack_require__(31236).f;
var defineProperty = __webpack_require__(3070).f;
var trim = __webpack_require__(53111).trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  if (isSymbol(argument)) throw TypeError('Cannot convert a Symbol value to a number');
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ 33161:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var isInteger = __webpack_require__(18730);

// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$({ target: 'Number', stat: true }, {
  isInteger: isInteger
});


/***/ }),

/***/ 44048:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);

// `Number.isNaN` method
// https://tc39.es/ecma262/#sec-number.isnan
$({ target: 'Number', stat: true }, {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return number != number;
  }
});


/***/ }),

/***/ 44363:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);

// `Number.MAX_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.max_safe_integer
$({ target: 'Number', stat: true }, {
  MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
});


/***/ }),

/***/ 55994:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);

// `Number.MIN_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.min_safe_integer
$({ target: 'Number', stat: true }, {
  MIN_SAFE_INTEGER: -0x1FFFFFFFFFFFFF
});


/***/ }),

/***/ 9494:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var parseInt = __webpack_require__(83009);

// `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
// eslint-disable-next-line es/no-number-parseint -- required for testing
$({ target: 'Number', stat: true, forced: Number.parseInt != parseInt }, {
  parseInt: parseInt
});


/***/ }),

/***/ 56977:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var toInteger = __webpack_require__(99958);
var thisNumberValue = __webpack_require__(50863);
var repeat = __webpack_require__(38415);
var fails = __webpack_require__(47293);

var nativeToFixed = 1.0.toFixed;
var floor = Math.floor;

var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = String(data[index]);
      s = s === '' ? t : s + repeat.call('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED = nativeToFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !fails(function () {
  // V8 ~ Android 4.3-
  nativeToFixed.call({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$({ target: 'Number', proto: true, forced: FORCED }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toInteger(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    if (fractDigits < 0 || fractDigits > 20) throw RangeError('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number != number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat.call('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat.call('0', fractDigits - k) + result
        : result.slice(0, k - fractDigits) + '.' + result.slice(k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});


/***/ }),

/***/ 19601:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var assign = __webpack_require__(21574);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ 69720:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var $entries = __webpack_require__(44699).entries;

// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});


/***/ }),

/***/ 43371:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var FREEZING = __webpack_require__(76677);
var fails = __webpack_require__(47293);
var isObject = __webpack_require__(70111);
var onFreeze = __webpack_require__(62423).onFreeze;

// eslint-disable-next-line es/no-object-freeze -- safe
var $freeze = Object.freeze;
var FAILS_ON_PRIMITIVES = fails(function () { $freeze(1); });

// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  freeze: function freeze(it) {
    return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
  }
});


/***/ }),

/***/ 38880:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var fails = __webpack_require__(47293);
var toIndexedObject = __webpack_require__(45656);
var nativeGetOwnPropertyDescriptor = __webpack_require__(31236).f;
var DESCRIPTORS = __webpack_require__(19781);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ 49337:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var DESCRIPTORS = __webpack_require__(19781);
var ownKeys = __webpack_require__(53887);
var toIndexedObject = __webpack_require__(45656);
var getOwnPropertyDescriptorModule = __webpack_require__(31236);
var createProperty = __webpack_require__(86135);

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ 36210:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var fails = __webpack_require__(47293);
var getOwnPropertyNames = __webpack_require__(1156).f;

// eslint-disable-next-line es/no-object-getownpropertynames -- required for testing
var FAILS_ON_PRIMITIVES = fails(function () { return !Object.getOwnPropertyNames(1); });

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  getOwnPropertyNames: getOwnPropertyNames
});


/***/ }),

/***/ 30489:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var fails = __webpack_require__(47293);
var toObject = __webpack_require__(47908);
var nativeGetPrototypeOf = __webpack_require__(79518);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(49920);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ 98410:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var fails = __webpack_require__(47293);
var isObject = __webpack_require__(70111);

// eslint-disable-next-line es/no-object-isfrozen -- safe
var $isFrozen = Object.isFrozen;
var FAILS_ON_PRIMITIVES = fails(function () { $isFrozen(1); });

// `Object.isFrozen` method
// https://tc39.es/ecma262/#sec-object.isfrozen
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  isFrozen: function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  }
});


/***/ }),

/***/ 43304:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var is = __webpack_require__(81150);

// `Object.is` method
// https://tc39.es/ecma262/#sec-object.is
$({ target: 'Object', stat: true }, {
  is: is
});


/***/ }),

/***/ 47941:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var toObject = __webpack_require__(47908);
var nativeKeys = __webpack_require__(81956);
var fails = __webpack_require__(47293);

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ 57227:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var isObject = __webpack_require__(70111);
var onFreeze = __webpack_require__(62423).onFreeze;
var FREEZING = __webpack_require__(76677);
var fails = __webpack_require__(47293);

// eslint-disable-next-line es/no-object-preventextensions -- safe
var $preventExtensions = Object.preventExtensions;
var FAILS_ON_PRIMITIVES = fails(function () { $preventExtensions(1); });

// `Object.preventExtensions` method
// https://tc39.es/ecma262/#sec-object.preventextensions
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  preventExtensions: function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(onFreeze(it)) : it;
  }
});


/***/ }),

/***/ 41539:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var TO_STRING_TAG_SUPPORT = __webpack_require__(51694);
var redefine = __webpack_require__(31320);
var toString = __webpack_require__(90288);

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ 26833:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var $values = __webpack_require__(44699).values;

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});


/***/ }),

/***/ 34668:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var aCallable = __webpack_require__(19662);
var getBuiltIn = __webpack_require__(35005);
var newPromiseCapabilityModule = __webpack_require__(78523);
var perform = __webpack_require__(12534);
var iterate = __webpack_require__(20408);

var PROMISE_ANY_ERROR = 'No one promise resolved';

// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$({ target: 'Promise', stat: true }, {
  any: function any(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable(C.resolve);
      var errors = [];
      var counter = 0;
      var remaining = 1;
      var alreadyResolved = false;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyRejected = false;
        errors.push(undefined);
        remaining++;
        promiseResolve.call(C, promise).then(function (value) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyResolved = true;
          resolve(value);
        }, function (error) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyRejected = true;
          errors[index] = error;
          --remaining || reject(new (getBuiltIn('AggregateError'))(errors, PROMISE_ANY_ERROR));
        });
      });
      --remaining || reject(new (getBuiltIn('AggregateError'))(errors, PROMISE_ANY_ERROR));
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ 17727:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var IS_PURE = __webpack_require__(31913);
var NativePromise = __webpack_require__(13366);
var fails = __webpack_require__(47293);
var getBuiltIn = __webpack_require__(35005);
var isCallable = __webpack_require__(60614);
var speciesConstructor = __webpack_require__(36707);
var promiseResolve = __webpack_require__(69478);
var redefine = __webpack_require__(31320);

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromise && fails(function () {
  NativePromise.prototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = isCallable(onFinally);
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromise)) {
  var method = getBuiltIn('Promise').prototype['finally'];
  if (NativePromise.prototype['finally'] !== method) {
    redefine(NativePromise.prototype, 'finally', method, { unsafe: true });
  }
}


/***/ }),

/***/ 36535:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var getBuiltIn = __webpack_require__(35005);
var aCallable = __webpack_require__(19662);
var anObject = __webpack_require__(19670);
var fails = __webpack_require__(47293);

var nativeApply = getBuiltIn('Reflect', 'apply');
var functionApply = Function.apply;

// MS Edge argumentsList argument is optional
var OPTIONAL_ARGUMENTS_LIST = !fails(function () {
  nativeApply(function () { /* empty */ });
});

// `Reflect.apply` method
// https://tc39.es/ecma262/#sec-reflect.apply
$({ target: 'Reflect', stat: true, forced: OPTIONAL_ARGUMENTS_LIST }, {
  apply: function apply(target, thisArgument, argumentsList) {
    aCallable(target);
    anObject(argumentsList);
    return nativeApply
      ? nativeApply(target, thisArgument, argumentsList)
      : functionApply.call(target, thisArgument, argumentsList);
  }
});


/***/ }),

/***/ 12419:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var getBuiltIn = __webpack_require__(35005);
var aConstructor = __webpack_require__(39483);
var anObject = __webpack_require__(19670);
var isObject = __webpack_require__(70111);
var create = __webpack_require__(70030);
var bind = __webpack_require__(27065);
var fails = __webpack_require__(47293);

var nativeConstruct = getBuiltIn('Reflect', 'construct');

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});
var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aConstructor(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ 39361:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var anObject = __webpack_require__(19670);
var objectGetPrototypeOf = __webpack_require__(79518);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(49920);

// `Reflect.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-reflect.getprototypeof
$({ target: 'Reflect', stat: true, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(target) {
    return objectGetPrototypeOf(anObject(target));
  }
});


/***/ }),

/***/ 74819:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var isObject = __webpack_require__(70111);
var anObject = __webpack_require__(19670);
var isDataDescriptor = __webpack_require__(45032);
var getOwnPropertyDescriptorModule = __webpack_require__(31236);
var getPrototypeOf = __webpack_require__(79518);

// `Reflect.get` method
// https://tc39.es/ecma262/#sec-reflect.get
function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var descriptor, prototype;
  if (anObject(target) === receiver) return target[propertyKey];
  descriptor = getOwnPropertyDescriptorModule.f(target, propertyKey);
  if (descriptor) return isDataDescriptor(descriptor)
    ? descriptor.value
    : descriptor.get === undefined ? undefined : descriptor.get.call(receiver);
  if (isObject(prototype = getPrototypeOf(target))) return get(prototype, propertyKey, receiver);
}

$({ target: 'Reflect', stat: true }, {
  get: get
});


/***/ }),

/***/ 67556:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var ownKeys = __webpack_require__(53887);

// `Reflect.ownKeys` method
// https://tc39.es/ecma262/#sec-reflect.ownkeys
$({ target: 'Reflect', stat: true }, {
  ownKeys: ownKeys
});


/***/ }),

/***/ 24603:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var global = __webpack_require__(17854);
var isForced = __webpack_require__(54705);
var inheritIfRequired = __webpack_require__(79587);
var createNonEnumerableProperty = __webpack_require__(68880);
var defineProperty = __webpack_require__(3070).f;
var getOwnPropertyNames = __webpack_require__(8006).f;
var isRegExp = __webpack_require__(47850);
var toString = __webpack_require__(41340);
var getFlags = __webpack_require__(67066);
var stickyHelpers = __webpack_require__(52999);
var redefine = __webpack_require__(31320);
var fails = __webpack_require__(47293);
var has = __webpack_require__(86656);
var enforceInternalState = __webpack_require__(29909).enforce;
var setSpecies = __webpack_require__(96340);
var wellKnownSymbol = __webpack_require__(5112);
var UNSUPPORTED_DOT_ALL = __webpack_require__(9441);
var UNSUPPORTED_NCG = __webpack_require__(38173);

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
// TODO: Use only propper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS &&
  (!CORRECT_NEW || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = string.charAt(index);
    if (chr === '\\') {
      result += chr + string.charAt(++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = string.charAt(index);
    if (chr === '\\') {
      chr = chr + string.charAt(++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (IS_NCG.test(string.slice(index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || has(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named.push([groupname, groupid]);
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = this instanceof RegExpWrapper;
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || pattern instanceof RegExpWrapper) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = 'flags' in rawPattern ? rawPattern.flags : getFlags.call(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString(pattern);
    flags = flags === undefined ? '' : toString(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
      dotAll = !!flags && flags.indexOf('s') > -1;
      if (dotAll) flags = flags.replace(/s/g, '');
    }

    rawFlags = flags;

    if (UNSUPPORTED_Y && 'sticky' in re1) {
      sticky = !!flags && flags.indexOf('y') > -1;
      if (sticky) flags = flags.replace(/y/g, '');
    }

    if (UNSUPPORTED_NCG) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  var proxy = function (key) {
    key in RegExpWrapper || defineProperty(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };

  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
    proxy(keys[index++]);
  }

  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  redefine(global, 'RegExp', RegExpWrapper);
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');


/***/ }),

/***/ 74916:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var exec = __webpack_require__(22261);

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ 92087:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var objectDefinePropertyModule = __webpack_require__(3070);
var regExpFlags = __webpack_require__(67066);
var fails = __webpack_require__(47293);

var FORCED = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
  return Object.getOwnPropertyDescriptor(RegExp.prototype, 'flags').get.call({ dotAll: true, sticky: true }) !== 'sy';
});

// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if (FORCED) objectDefinePropertyModule.f(RegExp.prototype, 'flags', {
  configurable: true,
  get: regExpFlags
});


/***/ }),

/***/ 39714:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var PROPER_FUNCTION_NAME = __webpack_require__(76530).PROPER;
var redefine = __webpack_require__(31320);
var anObject = __webpack_require__(19670);
var $toString = __webpack_require__(41340);
var fails = __webpack_require__(47293);
var flags = __webpack_require__(67066);

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = $toString(R.source);
    var rf = R.flags;
    var f = $toString(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),

/***/ 70189:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var collection = __webpack_require__(77710);
var collectionStrong = __webpack_require__(95631);

// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
module.exports = collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ 15218:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var createHTML = __webpack_require__(14230);
var forcedStringHTMLMethod = __webpack_require__(43429);

// `String.prototype.anchor` method
// https://tc39.es/ecma262/#sec-string.prototype.anchor
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('anchor') }, {
  anchor: function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  }
});


/***/ }),

/***/ 74475:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var createHTML = __webpack_require__(14230);
var forcedStringHTMLMethod = __webpack_require__(43429);

// `String.prototype.big` method
// https://tc39.es/ecma262/#sec-string.prototype.big
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('big') }, {
  big: function big() {
    return createHTML(this, 'big', '', '');
  }
});


/***/ }),

/***/ 50915:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var createHTML = __webpack_require__(14230);
var forcedStringHTMLMethod = __webpack_require__(43429);

// `String.prototype.bold` method
// https://tc39.es/ecma262/#sec-string.prototype.bold
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('bold') }, {
  bold: function bold() {
    return createHTML(this, 'b', '', '');
  }
});


/***/ }),

/***/ 79841:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var codeAt = __webpack_require__(28710).codeAt;

// `String.prototype.codePointAt` method
// https://tc39.es/ecma262/#sec-string.prototype.codepointat
$({ target: 'String', proto: true }, {
  codePointAt: function codePointAt(pos) {
    return codeAt(this, pos);
  }
});


/***/ }),

/***/ 27852:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var getOwnPropertyDescriptor = __webpack_require__(31236).f;
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var notARegExp = __webpack_require__(3929);
var requireObjectCoercible = __webpack_require__(84488);
var correctIsRegExpLogic = __webpack_require__(84964);
var IS_PURE = __webpack_require__(31913);

// eslint-disable-next-line es/no-string-prototype-endswith -- safe
var $endsWith = ''.endsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
    var search = toString(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),

/***/ 29253:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var createHTML = __webpack_require__(14230);
var forcedStringHTMLMethod = __webpack_require__(43429);

// `String.prototype.fixed` method
// https://tc39.es/ecma262/#sec-string.prototype.fixed
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('fixed') }, {
  fixed: function fixed() {
    return createHTML(this, 'tt', '', '');
  }
});


/***/ }),

/***/ 94953:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var toAbsoluteIndex = __webpack_require__(51400);

var fromCharCode = String.fromCharCode;
// eslint-disable-next-line es/no-string-fromcodepoint -- required for testing
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
var INCORRECT_LENGTH = !!$fromCodePoint && $fromCodePoint.length != 1;

// `String.fromCodePoint` method
// https://tc39.es/ecma262/#sec-string.fromcodepoint
$({ target: 'String', stat: true, forced: INCORRECT_LENGTH }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  fromCodePoint: function fromCodePoint(x) {
    var elements = [];
    var length = arguments.length;
    var i = 0;
    var code;
    while (length > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10FFFF) !== code) throw RangeError(code + ' is not a valid code point');
      elements.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00)
      );
    } return elements.join('');
  }
});


/***/ }),

/***/ 32023:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var notARegExp = __webpack_require__(3929);
var requireObjectCoercible = __webpack_require__(84488);
var toString = __webpack_require__(41340);
var correctIsRegExpLogic = __webpack_require__(84964);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~toString(requireObjectCoercible(this))
      .indexOf(toString(notARegExp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 58734:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var createHTML = __webpack_require__(14230);
var forcedStringHTMLMethod = __webpack_require__(43429);

// `String.prototype.italics` method
// https://tc39.es/ecma262/#sec-string.prototype.italics
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('italics') }, {
  italics: function italics() {
    return createHTML(this, 'i', '', '');
  }
});


/***/ }),

/***/ 78783:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var charAt = __webpack_require__(28710).charAt;
var toString = __webpack_require__(41340);
var InternalStateModule = __webpack_require__(29909);
var defineIterator = __webpack_require__(70654);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ 29254:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var createHTML = __webpack_require__(14230);
var forcedStringHTMLMethod = __webpack_require__(43429);

// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('link') }, {
  link: function link(url) {
    return createHTML(this, 'a', 'href', url);
  }
});


/***/ }),

/***/ 76373:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable es/no-string-prototype-matchall -- safe */
var $ = __webpack_require__(82109);
var createIteratorConstructor = __webpack_require__(24994);
var requireObjectCoercible = __webpack_require__(84488);
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var anObject = __webpack_require__(19670);
var classof = __webpack_require__(84326);
var isRegExp = __webpack_require__(47850);
var getRegExpFlags = __webpack_require__(67066);
var getMethod = __webpack_require__(58173);
var redefine = __webpack_require__(31320);
var fails = __webpack_require__(47293);
var wellKnownSymbol = __webpack_require__(5112);
var speciesConstructor = __webpack_require__(36707);
var advanceStringIndex = __webpack_require__(31530);
var regExpExec = __webpack_require__(97651);
var InternalStateModule = __webpack_require__(29909);
var IS_PURE = __webpack_require__(31913);

var MATCH_ALL = wellKnownSymbol('matchAll');
var REGEXP_STRING = 'RegExp String';
var REGEXP_STRING_ITERATOR = REGEXP_STRING + ' Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(REGEXP_STRING_ITERATOR);
var RegExpPrototype = RegExp.prototype;
var nativeMatchAll = ''.matchAll;

var WORKS_WITH_NON_GLOBAL_REGEX = !!nativeMatchAll && !fails(function () {
  'a'.matchAll(/./);
});

// eslint-disable-next-line max-len -- ignore
var $RegExpStringIterator = createIteratorConstructor(function RegExpStringIterator(regexp, string, global, fullUnicode) {
  setInternalState(this, {
    type: REGEXP_STRING_ITERATOR,
    regexp: regexp,
    string: string,
    global: global,
    unicode: fullUnicode,
    done: false
  });
}, REGEXP_STRING, function next() {
  var state = getInternalState(this);
  if (state.done) return { value: undefined, done: true };
  var R = state.regexp;
  var S = state.string;
  var match = regExpExec(R, S);
  if (match === null) return { value: undefined, done: state.done = true };
  if (state.global) {
    if (toString(match[0]) === '') R.lastIndex = advanceStringIndex(S, toLength(R.lastIndex), state.unicode);
    return { value: match, done: false };
  }
  state.done = true;
  return { value: match, done: false };
});

var $matchAll = function (string) {
  var R = anObject(this);
  var S = toString(string);
  var C, flagsValue, flags, matcher, global, fullUnicode;
  C = speciesConstructor(R, RegExp);
  flagsValue = R.flags;
  if (flagsValue === undefined && R instanceof RegExp && !('flags' in RegExpPrototype)) {
    flagsValue = getRegExpFlags.call(R);
  }
  flags = flagsValue === undefined ? '' : toString(flagsValue);
  matcher = new C(C === RegExp ? R.source : R, flags);
  global = !!~flags.indexOf('g');
  fullUnicode = !!~flags.indexOf('u');
  matcher.lastIndex = toLength(R.lastIndex);
  return new $RegExpStringIterator(matcher, S, global, fullUnicode);
};

// `String.prototype.matchAll` method
// https://tc39.es/ecma262/#sec-string.prototype.matchall
$({ target: 'String', proto: true, forced: WORKS_WITH_NON_GLOBAL_REGEX }, {
  matchAll: function matchAll(regexp) {
    var O = requireObjectCoercible(this);
    var flags, S, matcher, rx;
    if (regexp != null) {
      if (isRegExp(regexp)) {
        flags = toString(requireObjectCoercible('flags' in RegExpPrototype
          ? regexp.flags
          : getRegExpFlags.call(regexp)
        ));
        if (!~flags.indexOf('g')) throw TypeError('`.matchAll` does not allow non-global regexes');
      }
      if (WORKS_WITH_NON_GLOBAL_REGEX) return nativeMatchAll.apply(O, arguments);
      matcher = getMethod(regexp, MATCH_ALL);
      if (matcher === undefined && IS_PURE && classof(regexp) == 'RegExp') matcher = $matchAll;
      if (matcher) return matcher.call(regexp, O);
    } else if (WORKS_WITH_NON_GLOBAL_REGEX) return nativeMatchAll.apply(O, arguments);
    S = toString(O);
    rx = new RegExp(regexp, 'g');
    return IS_PURE ? $matchAll.call(rx, S) : rx[MATCH_ALL](S);
  }
});

IS_PURE || MATCH_ALL in RegExpPrototype || redefine(RegExpPrototype, MATCH_ALL, $matchAll);


/***/ }),

/***/ 4723:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(27007);
var anObject = __webpack_require__(19670);
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var requireObjectCoercible = __webpack_require__(84488);
var getMethod = __webpack_require__(58173);
var advanceStringIndex = __webpack_require__(31530);
var regExpExec = __webpack_require__(97651);

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : getMethod(regexp, MATCH);
      return matcher ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ 66528:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var $padEnd = __webpack_require__(76650).end;
var WEBKIT_BUG = __webpack_require__(54986);

// `String.prototype.padEnd` method
// https://tc39.es/ecma262/#sec-string.prototype.padend
$({ target: 'String', proto: true, forced: WEBKIT_BUG }, {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $padEnd(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 83112:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var $padStart = __webpack_require__(76650).start;
var WEBKIT_BUG = __webpack_require__(54986);

// `String.prototype.padStart` method
// https://tc39.es/ecma262/#sec-string.prototype.padstart
$({ target: 'String', proto: true, forced: WEBKIT_BUG }, {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 83714:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var repeat = __webpack_require__(38415);

// `String.prototype.repeat` method
// https://tc39.es/ecma262/#sec-string.prototype.repeat
$({ target: 'String', proto: true }, {
  repeat: repeat
});


/***/ }),

/***/ 68757:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var requireObjectCoercible = __webpack_require__(84488);
var isCallable = __webpack_require__(60614);
var isRegExp = __webpack_require__(47850);
var toString = __webpack_require__(41340);
var getMethod = __webpack_require__(58173);
var getRegExpFlags = __webpack_require__(67066);
var getSubstitution = __webpack_require__(10647);
var wellKnownSymbol = __webpack_require__(5112);
var IS_PURE = __webpack_require__(31913);

var REPLACE = wellKnownSymbol('replace');
var RegExpPrototype = RegExp.prototype;
var max = Math.max;

var stringIndexOf = function (string, searchValue, fromIndex) {
  if (fromIndex > string.length) return -1;
  if (searchValue === '') return fromIndex;
  return string.indexOf(searchValue, fromIndex);
};

// `String.prototype.replaceAll` method
// https://tc39.es/ecma262/#sec-string.prototype.replaceall
$({ target: 'String', proto: true }, {
  replaceAll: function replaceAll(searchValue, replaceValue) {
    var O = requireObjectCoercible(this);
    var IS_REG_EXP, flags, replacer, string, searchString, functionalReplace, searchLength, advanceBy, replacement;
    var position = 0;
    var endOfLastMatch = 0;
    var result = '';
    if (searchValue != null) {
      IS_REG_EXP = isRegExp(searchValue);
      if (IS_REG_EXP) {
        flags = toString(requireObjectCoercible('flags' in RegExpPrototype
          ? searchValue.flags
          : getRegExpFlags.call(searchValue)
        ));
        if (!~flags.indexOf('g')) throw TypeError('`.replaceAll` does not allow non-global regexes');
      }
      replacer = getMethod(searchValue, REPLACE);
      if (replacer) {
        return replacer.call(searchValue, O, replaceValue);
      } else if (IS_PURE && IS_REG_EXP) {
        return toString(O).replace(searchValue, replaceValue);
      }
    }
    string = toString(O);
    searchString = toString(searchValue);
    functionalReplace = isCallable(replaceValue);
    if (!functionalReplace) replaceValue = toString(replaceValue);
    searchLength = searchString.length;
    advanceBy = max(1, searchLength);
    position = stringIndexOf(string, searchString, 0);
    while (position !== -1) {
      if (functionalReplace) {
        replacement = toString(replaceValue(searchString, position, string));
      } else {
        replacement = getSubstitution(searchString, string, position, [], undefined, replaceValue);
      }
      result += string.slice(endOfLastMatch, position) + replacement;
      endOfLastMatch = position + searchLength;
      position = stringIndexOf(string, searchString, position + advanceBy);
    }
    if (endOfLastMatch < string.length) {
      result += string.slice(endOfLastMatch);
    }
    return result;
  }
});


/***/ }),

/***/ 15306:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(27007);
var fails = __webpack_require__(47293);
var anObject = __webpack_require__(19670);
var isCallable = __webpack_require__(60614);
var toInteger = __webpack_require__(99958);
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var requireObjectCoercible = __webpack_require__(84488);
var advanceStringIndex = __webpack_require__(31530);
var getMethod = __webpack_require__(58173);
var getSubstitution = __webpack_require__(10647);
var regExpExec = __webpack_require__(97651);
var wellKnownSymbol = __webpack_require__(5112);

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (
        typeof replaceValue === 'string' &&
        replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1 &&
        replaceValue.indexOf('$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = toString(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


/***/ }),

/***/ 64765:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(27007);
var anObject = __webpack_require__(19670);
var requireObjectCoercible = __webpack_require__(84488);
var sameValue = __webpack_require__(81150);
var toString = __webpack_require__(41340);
var getMethod = __webpack_require__(58173);
var regExpExec = __webpack_require__(97651);

// @@search logic
fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = regexp == undefined ? undefined : getMethod(regexp, SEARCH);
      return searcher ? searcher.call(regexp, O) : new RegExp(regexp)[SEARCH](toString(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),

/***/ 37268:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var createHTML = __webpack_require__(14230);
var forcedStringHTMLMethod = __webpack_require__(43429);

// `String.prototype.small` method
// https://tc39.es/ecma262/#sec-string.prototype.small
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('small') }, {
  small: function small() {
    return createHTML(this, 'small', '', '');
  }
});


/***/ }),

/***/ 23123:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(27007);
var isRegExp = __webpack_require__(47850);
var anObject = __webpack_require__(19670);
var requireObjectCoercible = __webpack_require__(84488);
var speciesConstructor = __webpack_require__(36707);
var advanceStringIndex = __webpack_require__(31530);
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var getMethod = __webpack_require__(58173);
var callRegExpExec = __webpack_require__(97651);
var regexpExec = __webpack_require__(22261);
var stickyHelpers = __webpack_require__(52999);
var fails = __webpack_require__(47293);

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var arrayPush = [].push;
var min = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? splitter.call(separator, O, limit)
        : internalSplit.call(toString(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? S.slice(q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);


/***/ }),

/***/ 23157:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var getOwnPropertyDescriptor = __webpack_require__(31236).f;
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var notARegExp = __webpack_require__(3929);
var requireObjectCoercible = __webpack_require__(84488);
var correctIsRegExpLogic = __webpack_require__(84964);
var IS_PURE = __webpack_require__(31913);

// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var $startsWith = ''.startsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ 60086:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var createHTML = __webpack_require__(14230);
var forcedStringHTMLMethod = __webpack_require__(43429);

// `String.prototype.sub` method
// https://tc39.es/ecma262/#sec-string.prototype.sub
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('sub') }, {
  sub: function sub() {
    return createHTML(this, 'sub', '', '');
  }
});


/***/ }),

/***/ 48702:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var $trimEnd = __webpack_require__(53111).end;
var forcedStringTrimMethod = __webpack_require__(76091);

var FORCED = forcedStringTrimMethod('trimEnd');

var trimEnd = FORCED ? function trimEnd() {
  return $trimEnd(this);
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : ''.trimEnd;

// `String.prototype.{ trimEnd, trimRight }` methods
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// https://tc39.es/ecma262/#String.prototype.trimright
$({ target: 'String', proto: true, name: 'trimEnd', forced: FORCED }, {
  trimEnd: trimEnd,
  trimRight: trimEnd
});


/***/ }),

/***/ 55674:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var $trimStart = __webpack_require__(53111).start;
var forcedStringTrimMethod = __webpack_require__(76091);

var FORCED = forcedStringTrimMethod('trimStart');

var trimStart = FORCED ? function trimStart() {
  return $trimStart(this);
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : ''.trimStart;

// `String.prototype.{ trimStart, trimLeft }` methods
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// https://tc39.es/ecma262/#String.prototype.trimleft
$({ target: 'String', proto: true, name: 'trimStart', forced: FORCED }, {
  trimStart: trimStart,
  trimLeft: trimStart
});


/***/ }),

/***/ 73210:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var $trim = __webpack_require__(53111).trim;
var forcedStringTrimMethod = __webpack_require__(76091);

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),

/***/ 72443:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var defineWellKnownSymbol = __webpack_require__(97235);

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');


/***/ }),

/***/ 41817:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__(82109);
var DESCRIPTORS = __webpack_require__(19781);
var global = __webpack_require__(17854);
var has = __webpack_require__(86656);
var isCallable = __webpack_require__(60614);
var isObject = __webpack_require__(70111);
var defineProperty = __webpack_require__(3070).f;
var copyConstructorProperties = __webpack_require__(99920);

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var nativeSymbol = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = nativeSymbol ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ 32165:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var defineWellKnownSymbol = __webpack_require__(97235);

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ 82526:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var global = __webpack_require__(17854);
var getBuiltIn = __webpack_require__(35005);
var IS_PURE = __webpack_require__(31913);
var DESCRIPTORS = __webpack_require__(19781);
var NATIVE_SYMBOL = __webpack_require__(30133);
var fails = __webpack_require__(47293);
var has = __webpack_require__(86656);
var isArray = __webpack_require__(43157);
var isCallable = __webpack_require__(60614);
var isObject = __webpack_require__(70111);
var isSymbol = __webpack_require__(52190);
var anObject = __webpack_require__(19670);
var toObject = __webpack_require__(47908);
var toIndexedObject = __webpack_require__(45656);
var toPropertyKey = __webpack_require__(34948);
var $toString = __webpack_require__(41340);
var createPropertyDescriptor = __webpack_require__(79114);
var nativeObjectCreate = __webpack_require__(70030);
var objectKeys = __webpack_require__(81956);
var getOwnPropertyNamesModule = __webpack_require__(8006);
var getOwnPropertyNamesExternal = __webpack_require__(1156);
var getOwnPropertySymbolsModule = __webpack_require__(25181);
var getOwnPropertyDescriptorModule = __webpack_require__(31236);
var definePropertyModule = __webpack_require__(3070);
var propertyIsEnumerableModule = __webpack_require__(55296);
var redefine = __webpack_require__(31320);
var shared = __webpack_require__(72309);
var sharedKey = __webpack_require__(6200);
var hiddenKeys = __webpack_require__(3501);
var uid = __webpack_require__(69711);
var wellKnownSymbol = __webpack_require__(5112);
var wrappedWellKnownSymbolModule = __webpack_require__(6061);
var defineWellKnownSymbol = __webpack_require__(97235);
var setToStringTag = __webpack_require__(58003);
var InternalStateModule = __webpack_require__(29909);
var $forEach = __webpack_require__(42092).forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = $toString(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (isCallable($replacer)) value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  var valueOf = $Symbol[PROTOTYPE].valueOf;
  redefine($Symbol[PROTOTYPE], TO_PRIMITIVE, function () {
    return valueOf.apply(this, arguments);
  });
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ 96649:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var defineWellKnownSymbol = __webpack_require__(97235);

// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol('toPrimitive');


/***/ }),

/***/ 39341:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var defineWellKnownSymbol = __webpack_require__(97235);

// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');


/***/ }),

/***/ 92990:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $copyWithin = __webpack_require__(1048);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin
exportTypedArrayMethod('copyWithin', function copyWithin(target, start /* , end */) {
  return $copyWithin.call(aTypedArray(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
});


/***/ }),

/***/ 18927:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $every = __webpack_require__(42092).every;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.every` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.every
exportTypedArrayMethod('every', function every(callbackfn /* , thisArg */) {
  return $every(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 33105:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $fill = __webpack_require__(21285);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
// eslint-disable-next-line no-unused-vars -- required for `.length`
exportTypedArrayMethod('fill', function fill(value /* , start, end */) {
  return $fill.apply(aTypedArray(this), arguments);
});


/***/ }),

/***/ 35035:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $filter = __webpack_require__(42092).filter;
var fromSpeciesAndList = __webpack_require__(43074);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.filter` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter
exportTypedArrayMethod('filter', function filter(callbackfn /* , thisArg */) {
  var list = $filter(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  return fromSpeciesAndList(this, list);
});


/***/ }),

/***/ 7174:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $findIndex = __webpack_require__(42092).findIndex;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex
exportTypedArrayMethod('findIndex', function findIndex(predicate /* , thisArg */) {
  return $findIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 74345:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $find = __webpack_require__(42092).find;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.find` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.find
exportTypedArrayMethod('find', function find(predicate /* , thisArg */) {
  return $find(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 44197:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var createTypedArrayConstructor = __webpack_require__(19843);

// `Float32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Float32', function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ 76495:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var createTypedArrayConstructor = __webpack_require__(19843);

// `Float64Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Float64', function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ 32846:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $forEach = __webpack_require__(42092).forEach;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.forEach` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach
exportTypedArrayMethod('forEach', function forEach(callbackfn /* , thisArg */) {
  $forEach(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 44731:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $includes = __webpack_require__(41318).includes;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.includes` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes
exportTypedArrayMethod('includes', function includes(searchElement /* , fromIndex */) {
  return $includes(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 77209:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $indexOf = __webpack_require__(41318).indexOf;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof
exportTypedArrayMethod('indexOf', function indexOf(searchElement /* , fromIndex */) {
  return $indexOf(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 35109:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var createTypedArrayConstructor = __webpack_require__(19843);

// `Int16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Int16', function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ 65125:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var createTypedArrayConstructor = __webpack_require__(19843);

// `Int32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Int32', function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ 87145:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var createTypedArrayConstructor = __webpack_require__(19843);

// `Int8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Int8', function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ 96319:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(17854);
var PROPER_FUNCTION_NAME = __webpack_require__(76530).PROPER;
var ArrayBufferViewCore = __webpack_require__(90260);
var ArrayIterators = __webpack_require__(66992);
var wellKnownSymbol = __webpack_require__(5112);

var ITERATOR = wellKnownSymbol('iterator');
var Uint8Array = global.Uint8Array;
var arrayValues = ArrayIterators.values;
var arrayKeys = ArrayIterators.keys;
var arrayEntries = ArrayIterators.entries;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var nativeTypedArrayIterator = Uint8Array && Uint8Array.prototype[ITERATOR];

var PROPER_ARRAY_VALUES_NAME = !!nativeTypedArrayIterator && nativeTypedArrayIterator.name === 'values';

var typedArrayValues = function values() {
  return arrayValues.call(aTypedArray(this));
};

// `%TypedArray%.prototype.entries` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
exportTypedArrayMethod('entries', function entries() {
  return arrayEntries.call(aTypedArray(this));
});
// `%TypedArray%.prototype.keys` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys
exportTypedArrayMethod('keys', function keys() {
  return arrayKeys.call(aTypedArray(this));
});
// `%TypedArray%.prototype.values` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
exportTypedArrayMethod('values', typedArrayValues, PROPER_FUNCTION_NAME && !PROPER_ARRAY_VALUES_NAME);
// `%TypedArray%.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator
exportTypedArrayMethod(ITERATOR, typedArrayValues, PROPER_FUNCTION_NAME && !PROPER_ARRAY_VALUES_NAME);


/***/ }),

/***/ 58867:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $join = [].join;

// `%TypedArray%.prototype.join` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.join
// eslint-disable-next-line no-unused-vars -- required for `.length`
exportTypedArrayMethod('join', function join(separator) {
  return $join.apply(aTypedArray(this), arguments);
});


/***/ }),

/***/ 37789:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $lastIndexOf = __webpack_require__(86583);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof
// eslint-disable-next-line no-unused-vars -- required for `.length`
exportTypedArrayMethod('lastIndexOf', function lastIndexOf(searchElement /* , fromIndex */) {
  return $lastIndexOf.apply(aTypedArray(this), arguments);
});


/***/ }),

/***/ 33739:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $map = __webpack_require__(42092).map;
var typedArraySpeciesConstructor = __webpack_require__(66304);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.map` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.map
exportTypedArrayMethod('map', function map(mapfn /* , thisArg */) {
  return $map(aTypedArray(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, function (O, length) {
    return new (typedArraySpeciesConstructor(O))(length);
  });
});


/***/ }),

/***/ 14483:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $reduceRight = __webpack_require__(53671).right;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduceRicht` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright
exportTypedArrayMethod('reduceRight', function reduceRight(callbackfn /* , initialValue */) {
  return $reduceRight(aTypedArray(this), callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 29368:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $reduce = __webpack_require__(53671).left;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduce` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce
exportTypedArrayMethod('reduce', function reduce(callbackfn /* , initialValue */) {
  return $reduce(aTypedArray(this), callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 12056:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var floor = Math.floor;

// `%TypedArray%.prototype.reverse` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse
exportTypedArrayMethod('reverse', function reverse() {
  var that = this;
  var length = aTypedArray(that).length;
  var middle = floor(length / 2);
  var index = 0;
  var value;
  while (index < middle) {
    value = that[index];
    that[index++] = that[--length];
    that[length] = value;
  } return that;
});


/***/ }),

/***/ 3462:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var toLength = __webpack_require__(17466);
var toOffset = __webpack_require__(84590);
var toObject = __webpack_require__(47908);
var fails = __webpack_require__(47293);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var FORCED = fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  new Int8Array(1).set({});
});

// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
exportTypedArrayMethod('set', function set(arrayLike /* , offset */) {
  aTypedArray(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
  var length = this.length;
  var src = toObject(arrayLike);
  var len = toLength(src.length);
  var index = 0;
  if (len + offset > length) throw RangeError('Wrong length');
  while (index < len) this[offset + index] = src[index++];
}, FORCED);


/***/ }),

/***/ 30678:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var typedArraySpeciesConstructor = __webpack_require__(66304);
var fails = __webpack_require__(47293);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $slice = [].slice;

var FORCED = fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  new Int8Array(1).slice();
});

// `%TypedArray%.prototype.slice` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
exportTypedArrayMethod('slice', function slice(start, end) {
  var list = $slice.call(aTypedArray(this), start, end);
  var C = typedArraySpeciesConstructor(this);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index) result[index] = list[index++];
  return result;
}, FORCED);


/***/ }),

/***/ 27462:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $some = __webpack_require__(42092).some;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.some` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.some
exportTypedArrayMethod('some', function some(callbackfn /* , thisArg */) {
  return $some(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 33824:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var global = __webpack_require__(17854);
var fails = __webpack_require__(47293);
var aCallable = __webpack_require__(19662);
var toLength = __webpack_require__(17466);
var internalSort = __webpack_require__(94362);
var FF = __webpack_require__(68886);
var IE_OR_EDGE = __webpack_require__(30256);
var V8 = __webpack_require__(7392);
var WEBKIT = __webpack_require__(98008);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var Uint16Array = global.Uint16Array;
var nativeSort = Uint16Array && Uint16Array.prototype.sort;

// WebKit
var ACCEPT_INCORRECT_ARGUMENTS = !!nativeSort && !fails(function () {
  var array = new Uint16Array(2);
  array.sort(null);
  array.sort({});
});

var STABLE_SORT = !!nativeSort && !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 74;
  if (FF) return FF < 67;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 602;

  var array = new Uint16Array(516);
  var expected = Array(516);
  var index, mod;

  for (index = 0; index < 516; index++) {
    mod = index % 4;
    array[index] = 515 - index;
    expected[index] = index - 2 * mod + 3;
  }

  array.sort(function (a, b) {
    return (a / 4 | 0) - (b / 4 | 0);
  });

  for (index = 0; index < 516; index++) {
    if (array[index] !== expected[index]) return true;
  }
});

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (y !== y) return -1;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (x !== x) return 1;
    if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
    return x > y;
  };
};

// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
exportTypedArrayMethod('sort', function sort(comparefn) {
  var array = this;
  if (comparefn !== undefined) aCallable(comparefn);
  if (STABLE_SORT) return nativeSort.call(array, comparefn);

  aTypedArray(array);
  var arrayLength = toLength(array.length);
  var items = Array(arrayLength);
  var index;

  for (index = 0; index < arrayLength; index++) {
    items[index] = array[index];
  }

  items = internalSort(array, getSortCompare(comparefn));

  for (index = 0; index < arrayLength; index++) {
    array[index] = items[index];
  }

  return array;
}, !STABLE_SORT || ACCEPT_INCORRECT_ARGUMENTS);


/***/ }),

/***/ 55021:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var toLength = __webpack_require__(17466);
var toAbsoluteIndex = __webpack_require__(51400);
var typedArraySpeciesConstructor = __webpack_require__(66304);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.subarray` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray
exportTypedArrayMethod('subarray', function subarray(begin, end) {
  var O = aTypedArray(this);
  var length = O.length;
  var beginIndex = toAbsoluteIndex(begin, length);
  var C = typedArraySpeciesConstructor(O);
  return new C(
    O.buffer,
    O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT,
    toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - beginIndex)
  );
});


/***/ }),

/***/ 12974:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(17854);
var ArrayBufferViewCore = __webpack_require__(90260);
var fails = __webpack_require__(47293);

var Int8Array = global.Int8Array;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $toLocaleString = [].toLocaleString;
var $slice = [].slice;

// iOS Safari 6.x fails here
var TO_LOCALE_STRING_BUG = !!Int8Array && fails(function () {
  $toLocaleString.call(new Int8Array(1));
});

var FORCED = fails(function () {
  return [1, 2].toLocaleString() != new Int8Array([1, 2]).toLocaleString();
}) || !fails(function () {
  Int8Array.prototype.toLocaleString.call([1, 2]);
});

// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
exportTypedArrayMethod('toLocaleString', function toLocaleString() {
  return $toLocaleString.apply(TO_LOCALE_STRING_BUG ? $slice.call(aTypedArray(this)) : aTypedArray(this), arguments);
}, FORCED);


/***/ }),

/***/ 15016:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var exportTypedArrayMethod = __webpack_require__(90260).exportTypedArrayMethod;
var fails = __webpack_require__(47293);
var global = __webpack_require__(17854);

var Uint8Array = global.Uint8Array;
var Uint8ArrayPrototype = Uint8Array && Uint8Array.prototype || {};
var arrayToString = [].toString;
var arrayJoin = [].join;

if (fails(function () { arrayToString.call({}); })) {
  arrayToString = function toString() {
    return arrayJoin.call(this);
  };
}

var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString != arrayToString;

// `%TypedArray%.prototype.toString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring
exportTypedArrayMethod('toString', arrayToString, IS_NOT_ARRAY_METHOD);


/***/ }),

/***/ 8255:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var createTypedArrayConstructor = __webpack_require__(19843);

// `Uint16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint16', function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ 29135:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var createTypedArrayConstructor = __webpack_require__(19843);

// `Uint32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint32', function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ 82472:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var createTypedArrayConstructor = __webpack_require__(19843);

// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint8', function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ 49743:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var createTypedArrayConstructor = __webpack_require__(19843);

// `Uint8ClampedArray` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint8', function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),

/***/ 4129:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(17854);
var redefineAll = __webpack_require__(12248);
var InternalMetadataModule = __webpack_require__(62423);
var collection = __webpack_require__(77710);
var collectionWeak = __webpack_require__(29320);
var isObject = __webpack_require__(70111);
var enforceIternalState = __webpack_require__(29909).enforce;
var NATIVE_WEAK_MAP = __webpack_require__(68536);

var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = Object.isExtensible;
var InternalWeakMap;

var wrapper = function (init) {
  return function WeakMap() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
};

// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $WeakMap = module.exports = collection('WeakMap', wrapper, collectionWeak);

// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
  InternalMetadataModule.enable();
  var WeakMapPrototype = $WeakMap.prototype;
  var nativeDelete = WeakMapPrototype['delete'];
  var nativeHas = WeakMapPrototype.has;
  var nativeGet = WeakMapPrototype.get;
  var nativeSet = WeakMapPrototype.set;
  redefineAll(WeakMapPrototype, {
    'delete': function (key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeDelete.call(this, key) || state.frozen['delete'](key);
      } return nativeDelete.call(this, key);
    },
    has: function has(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas.call(this, key) || state.frozen.has(key);
      } return nativeHas.call(this, key);
    },
    get: function get(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas.call(this, key) ? nativeGet.call(this, key) : state.frozen.get(key);
      } return nativeGet.call(this, key);
    },
    set: function set(key, value) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        nativeHas.call(this, key) ? nativeSet.call(this, key, value) : state.frozen.set(key, value);
      } else nativeSet.call(this, key, value);
      return this;
    }
  });
}


/***/ }),

/***/ 38478:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var collection = __webpack_require__(77710);
var collectionWeak = __webpack_require__(29320);

// `WeakSet` constructor
// https://tc39.es/ecma262/#sec-weakset-constructor
collection('WeakSet', function (init) {
  return function WeakSet() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionWeak);


/***/ }),

/***/ 8628:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// TODO: Remove from `core-js@4`
__webpack_require__(9170);


/***/ }),

/***/ 65743:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// TODO: Remove from `core-js@4`
__webpack_require__(35837);


/***/ }),

/***/ 96290:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// TODO: Remove from `core-js@4`
__webpack_require__(34668);


/***/ }),

/***/ 13728:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// TODO: Remove from `core-js@4`
__webpack_require__(76373);


/***/ }),

/***/ 27207:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// TODO: Remove from `core-js@4`
__webpack_require__(68757);


/***/ }),

/***/ 54747:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var DOMIterables = __webpack_require__(48324);
var DOMTokenListPrototype = __webpack_require__(98509);
var forEach = __webpack_require__(18533);
var createNonEnumerableProperty = __webpack_require__(68880);

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
}

handlePrototype(DOMTokenListPrototype);


/***/ }),

/***/ 33948:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var DOMIterables = __webpack_require__(48324);
var DOMTokenListPrototype = __webpack_require__(98509);
var ArrayIteratorMethods = __webpack_require__(66992);
var createNonEnumerableProperty = __webpack_require__(68880);
var wellKnownSymbol = __webpack_require__(5112);

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),

/***/ 84633:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var global = __webpack_require__(17854);
var task = __webpack_require__(20261);

var FORCED = !global.setImmediate || !global.clearImmediate;

// http://w3c.github.io/setImmediate/
$({ global: true, bind: true, enumerable: true, forced: FORCED }, {
  // `setImmediate` method
  // http://w3c.github.io/setImmediate/#si-setImmediate
  setImmediate: task.set,
  // `clearImmediate` method
  // http://w3c.github.io/setImmediate/#si-clearImmediate
  clearImmediate: task.clear
});


/***/ }),

/***/ 41637:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(66992);
var $ = __webpack_require__(82109);
var getBuiltIn = __webpack_require__(35005);
var USE_NATIVE_URL = __webpack_require__(590);
var redefine = __webpack_require__(31320);
var redefineAll = __webpack_require__(12248);
var setToStringTag = __webpack_require__(58003);
var createIteratorConstructor = __webpack_require__(24994);
var InternalStateModule = __webpack_require__(29909);
var anInstance = __webpack_require__(25787);
var isCallable = __webpack_require__(60614);
var hasOwn = __webpack_require__(86656);
var bind = __webpack_require__(49974);
var classof = __webpack_require__(70648);
var anObject = __webpack_require__(19670);
var isObject = __webpack_require__(70111);
var $toString = __webpack_require__(41340);
var create = __webpack_require__(70030);
var createPropertyDescriptor = __webpack_require__(79114);
var getIterator = __webpack_require__(18554);
var getIteratorMethod = __webpack_require__(71246);
var wellKnownSymbol = __webpack_require__(5112);

var nativeFetch = getBuiltIn('fetch');
var NativeRequest = getBuiltIn('Request');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var Headers = getBuiltIn('Headers');
var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = it.replace(plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = result.replace(percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replace = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replace[match];
};

var serialize = function (it) {
  return encodeURIComponent(it).replace(find, replacer);
};

var parseSearchParams = function (result, query) {
  if (query) {
    var attributes = query.split('&');
    var index = 0;
    var attribute, entry;
    while (index < attributes.length) {
      attribute = attributes[index++];
      if (attribute.length) {
        entry = attribute.split('=');
        result.push({
          key: deserialize(entry.shift()),
          value: deserialize(entry.join('='))
        });
      }
    }
  }
};

var updateSearchParams = function (query) {
  this.entries.length = 0;
  parseSearchParams(this.entries, query);
};

var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw TypeError('Not enough arguments');
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
});

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsConstructor, URL_SEARCH_PARAMS);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var that = this;
  var entries = [];
  var iteratorMethod, iterator, next, step, entryIterator, entryNext, first, second, key;

  setInternalState(that, {
    type: URL_SEARCH_PARAMS,
    entries: entries,
    updateURL: function () { /* empty */ },
    updateSearchParams: updateSearchParams
  });

  if (init !== undefined) {
    if (isObject(init)) {
      iteratorMethod = getIteratorMethod(init);
      if (iteratorMethod) {
        iterator = getIterator(init, iteratorMethod);
        next = iterator.next;
        while (!(step = next.call(iterator)).done) {
          entryIterator = getIterator(anObject(step.value));
          entryNext = entryIterator.next;
          if (
            (first = entryNext.call(entryIterator)).done ||
            (second = entryNext.call(entryIterator)).done ||
            !entryNext.call(entryIterator).done
          ) throw TypeError('Expected sequence with length 2');
          entries.push({ key: $toString(first.value), value: $toString(second.value) });
        }
      } else for (key in init) if (hasOwn(init, key)) entries.push({ key: key, value: $toString(init[key]) });
    } else {
      parseSearchParams(
        entries,
        typeof init === 'string' ? init.charAt(0) === '?' ? init.slice(1) : init : $toString(init)
      );
    }
  }
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

redefineAll(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    state.entries.push({ key: $toString(name), value: $toString(value) });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = $toString(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) entries.splice(index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) result.push(entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = $toString(name);
    var val = $toString(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) entries.splice(index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) entries.push({ key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    var entries = state.entries;
    // Array#sort is not stable in some engines
    var slice = entries.slice();
    var entry, entriesIndex, sliceIndex;
    entries.length = 0;
    for (sliceIndex = 0; sliceIndex < slice.length; sliceIndex++) {
      entry = slice[sliceIndex];
      for (entriesIndex = 0; entriesIndex < sliceIndex; entriesIndex++) {
        if (entries[entriesIndex].key > entry.key) {
          entries.splice(entriesIndex, 0, entry);
          break;
        }
      }
      if (entriesIndex === sliceIndex) entries.push(entry);
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined, 3);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
redefine(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
redefine(URLSearchParamsPrototype, 'toString', function toString() {
  var entries = getInternalParamsState(this).entries;
  var result = [];
  var index = 0;
  var entry;
  while (index < entries.length) {
    entry = entries[index++];
    result.push(serialize(entry.key) + '=' + serialize(entry.value));
  } return result.join('&');
}, { enumerable: true });

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$({ global: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL && isCallable(Headers)) {
  var wrapRequestOptions = function (init) {
    if (isObject(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headers.has('content-type')) {
          headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create(init, {
          body: createPropertyDescriptor(0, String(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(nativeFetch)) {
    $({ global: true, enumerable: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance(this, RequestConstructor, 'Request');
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $({ global: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

module.exports = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};


/***/ }),

/***/ 60285:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(78783);
var $ = __webpack_require__(82109);
var DESCRIPTORS = __webpack_require__(19781);
var USE_NATIVE_URL = __webpack_require__(590);
var global = __webpack_require__(17854);
var defineProperties = __webpack_require__(36048);
var redefine = __webpack_require__(31320);
var anInstance = __webpack_require__(25787);
var has = __webpack_require__(86656);
var assign = __webpack_require__(21574);
var arrayFrom = __webpack_require__(48457);
var codeAt = __webpack_require__(28710).codeAt;
var toASCII = __webpack_require__(33197);
var $toString = __webpack_require__(41340);
var setToStringTag = __webpack_require__(58003);
var URLSearchParamsModule = __webpack_require__(41637);
var InternalStateModule = __webpack_require__(29909);

var NativeURL = global.URL;
var URLSearchParams = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;
var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var floor = Math.floor;
var pow = Math.pow;

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[A-Za-z]/;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.A-Za-z]/;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\dA-Fa-f]+$/;
/* eslint-disable no-control-regex -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+|[\u0000-\u0020]+$/g;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable no-control-regex -- safe */
var EOF;

var parseHost = function (url, input) {
  var result, codePoints, index;
  if (input.charAt(0) == '[') {
    if (input.charAt(input.length - 1) != ']') return INVALID_HOST;
    result = parseIPv6(input.slice(1, -1));
    if (!result) return INVALID_HOST;
    url.host = result;
  // opaque host
  } else if (!isSpecial(url)) {
    if (FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT.test(input)) return INVALID_HOST;
    result = '';
    codePoints = arrayFrom(input);
    for (index = 0; index < codePoints.length; index++) {
      result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
    }
    url.host = result;
  } else {
    input = toASCII(input);
    if (FORBIDDEN_HOST_CODE_POINT.test(input)) return INVALID_HOST;
    result = parseIPv4(input);
    if (result === null) return INVALID_HOST;
    url.host = result;
  }
};

var parseIPv4 = function (input) {
  var parts = input.split('.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] == '') {
    parts.pop();
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;
    if (part.length > 1 && part.charAt(0) == '0') {
      radix = HEX_START.test(part) ? 16 : 8;
      part = part.slice(radix == 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!(radix == 10 ? DEC : radix == 8 ? OCT : HEX).test(part)) return input;
      number = parseInt(part, radix);
    }
    numbers.push(number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index == partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = numbers.pop();
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function () {
    return input.charAt(pointer);
  };

  if (chr() == ':') {
    if (input.charAt(1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (chr()) {
    if (pieceIndex == 8) return;
    if (chr() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && HEX.test(chr())) {
      value = value * 16 + parseInt(chr(), 16);
      pointer++;
      length++;
    }
    if (chr() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (chr()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (chr() == '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!DIGIT.test(chr())) return;
        while (DIGIT.test(chr())) {
          number = parseInt(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece == 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }
      if (numbersSeen != 4) return;
      break;
    } else if (chr() == ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      result.unshift(host % 256);
      host = floor(host / 256);
    } return result.join('.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += host[index].toString(16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (chr, set) {
  var code = codeAt(chr, 0);
  return code > 0x20 && code < 0x7F && !has(set, chr) ? chr : encodeURIComponent(chr);
};

var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

var isSpecial = function (url) {
  return has(specialSchemes, url.scheme);
};

var includesCredentials = function (url) {
  return url.username != '' || url.password != '';
};

var cannotHaveUsernamePasswordPort = function (url) {
  return !url.host || url.cannotBeABaseURL || url.scheme == 'file';
};

var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length == 2 && ALPHA.test(string.charAt(0))
    && ((second = string.charAt(1)) == ':' || (!normalized && second == '|'));
};

var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(string.slice(0, 2)) && (
    string.length == 2 ||
    ((third = string.charAt(2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

var shortenURLsPath = function (url) {
  var path = url.path;
  var pathSize = path.length;
  if (pathSize && (url.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
    path.pop();
  }
};

var isSingleDot = function (segment) {
  return segment === '.' || segment.toLowerCase() === '%2e';
};

var isDoubleDot = function (segment) {
  segment = segment.toLowerCase();
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

// eslint-disable-next-line max-statements -- TODO
var parseURL = function (url, input, stateOverride, base) {
  var state = stateOverride || SCHEME_START;
  var pointer = 0;
  var buffer = '';
  var seenAt = false;
  var seenBracket = false;
  var seenPasswordToken = false;
  var codePoints, chr, bufferCodePoints, failure;

  if (!stateOverride) {
    url.scheme = '';
    url.username = '';
    url.password = '';
    url.host = null;
    url.port = null;
    url.path = [];
    url.query = null;
    url.fragment = null;
    url.cannotBeABaseURL = false;
    input = input.replace(LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, '');
  }

  input = input.replace(TAB_AND_NEW_LINE, '');

  codePoints = arrayFrom(input);

  while (pointer <= codePoints.length) {
    chr = codePoints[pointer];
    switch (state) {
      case SCHEME_START:
        if (chr && ALPHA.test(chr)) {
          buffer += chr.toLowerCase();
          state = SCHEME;
        } else if (!stateOverride) {
          state = NO_SCHEME;
          continue;
        } else return INVALID_SCHEME;
        break;

      case SCHEME:
        if (chr && (ALPHANUMERIC.test(chr) || chr == '+' || chr == '-' || chr == '.')) {
          buffer += chr.toLowerCase();
        } else if (chr == ':') {
          if (stateOverride && (
            (isSpecial(url) != has(specialSchemes, buffer)) ||
            (buffer == 'file' && (includesCredentials(url) || url.port !== null)) ||
            (url.scheme == 'file' && !url.host)
          )) return;
          url.scheme = buffer;
          if (stateOverride) {
            if (isSpecial(url) && specialSchemes[url.scheme] == url.port) url.port = null;
            return;
          }
          buffer = '';
          if (url.scheme == 'file') {
            state = FILE;
          } else if (isSpecial(url) && base && base.scheme == url.scheme) {
            state = SPECIAL_RELATIVE_OR_AUTHORITY;
          } else if (isSpecial(url)) {
            state = SPECIAL_AUTHORITY_SLASHES;
          } else if (codePoints[pointer + 1] == '/') {
            state = PATH_OR_AUTHORITY;
            pointer++;
          } else {
            url.cannotBeABaseURL = true;
            url.path.push('');
            state = CANNOT_BE_A_BASE_URL_PATH;
          }
        } else if (!stateOverride) {
          buffer = '';
          state = NO_SCHEME;
          pointer = 0;
          continue;
        } else return INVALID_SCHEME;
        break;

      case NO_SCHEME:
        if (!base || (base.cannotBeABaseURL && chr != '#')) return INVALID_SCHEME;
        if (base.cannotBeABaseURL && chr == '#') {
          url.scheme = base.scheme;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          url.cannotBeABaseURL = true;
          state = FRAGMENT;
          break;
        }
        state = base.scheme == 'file' ? FILE : RELATIVE;
        continue;

      case SPECIAL_RELATIVE_OR_AUTHORITY:
        if (chr == '/' && codePoints[pointer + 1] == '/') {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          pointer++;
        } else {
          state = RELATIVE;
          continue;
        } break;

      case PATH_OR_AUTHORITY:
        if (chr == '/') {
          state = AUTHORITY;
          break;
        } else {
          state = PATH;
          continue;
        }

      case RELATIVE:
        url.scheme = base.scheme;
        if (chr == EOF) {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
        } else if (chr == '/' || (chr == '\\' && isSpecial(url))) {
          state = RELATIVE_SLASH;
        } else if (chr == '?') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = '';
          state = QUERY;
        } else if (chr == '#') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          state = FRAGMENT;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.path.pop();
          state = PATH;
          continue;
        } break;

      case RELATIVE_SLASH:
        if (isSpecial(url) && (chr == '/' || chr == '\\')) {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        } else if (chr == '/') {
          state = AUTHORITY;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          state = PATH;
          continue;
        } break;

      case SPECIAL_AUTHORITY_SLASHES:
        state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        if (chr != '/' || buffer.charAt(pointer + 1) != '/') continue;
        pointer++;
        break;

      case SPECIAL_AUTHORITY_IGNORE_SLASHES:
        if (chr != '/' && chr != '\\') {
          state = AUTHORITY;
          continue;
        } break;

      case AUTHORITY:
        if (chr == '@') {
          if (seenAt) buffer = '%40' + buffer;
          seenAt = true;
          bufferCodePoints = arrayFrom(buffer);
          for (var i = 0; i < bufferCodePoints.length; i++) {
            var codePoint = bufferCodePoints[i];
            if (codePoint == ':' && !seenPasswordToken) {
              seenPasswordToken = true;
              continue;
            }
            var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
            if (seenPasswordToken) url.password += encodedCodePoints;
            else url.username += encodedCodePoints;
          }
          buffer = '';
        } else if (
          chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
          (chr == '\\' && isSpecial(url))
        ) {
          if (seenAt && buffer == '') return INVALID_AUTHORITY;
          pointer -= arrayFrom(buffer).length + 1;
          buffer = '';
          state = HOST;
        } else buffer += chr;
        break;

      case HOST:
      case HOSTNAME:
        if (stateOverride && url.scheme == 'file') {
          state = FILE_HOST;
          continue;
        } else if (chr == ':' && !seenBracket) {
          if (buffer == '') return INVALID_HOST;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PORT;
          if (stateOverride == HOSTNAME) return;
        } else if (
          chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
          (chr == '\\' && isSpecial(url))
        ) {
          if (isSpecial(url) && buffer == '') return INVALID_HOST;
          if (stateOverride && buffer == '' && (includesCredentials(url) || url.port !== null)) return;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PATH_START;
          if (stateOverride) return;
          continue;
        } else {
          if (chr == '[') seenBracket = true;
          else if (chr == ']') seenBracket = false;
          buffer += chr;
        } break;

      case PORT:
        if (DIGIT.test(chr)) {
          buffer += chr;
        } else if (
          chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
          (chr == '\\' && isSpecial(url)) ||
          stateOverride
        ) {
          if (buffer != '') {
            var port = parseInt(buffer, 10);
            if (port > 0xFFFF) return INVALID_PORT;
            url.port = (isSpecial(url) && port === specialSchemes[url.scheme]) ? null : port;
            buffer = '';
          }
          if (stateOverride) return;
          state = PATH_START;
          continue;
        } else return INVALID_PORT;
        break;

      case FILE:
        url.scheme = 'file';
        if (chr == '/' || chr == '\\') state = FILE_SLASH;
        else if (base && base.scheme == 'file') {
          if (chr == EOF) {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
          } else if (chr == '?') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            if (!startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
              url.host = base.host;
              url.path = base.path.slice();
              shortenURLsPath(url);
            }
            state = PATH;
            continue;
          }
        } else {
          state = PATH;
          continue;
        } break;

      case FILE_SLASH:
        if (chr == '/' || chr == '\\') {
          state = FILE_HOST;
          break;
        }
        if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
          if (isWindowsDriveLetter(base.path[0], true)) url.path.push(base.path[0]);
          else url.host = base.host;
        }
        state = PATH;
        continue;

      case FILE_HOST:
        if (chr == EOF || chr == '/' || chr == '\\' || chr == '?' || chr == '#') {
          if (!stateOverride && isWindowsDriveLetter(buffer)) {
            state = PATH;
          } else if (buffer == '') {
            url.host = '';
            if (stateOverride) return;
            state = PATH_START;
          } else {
            failure = parseHost(url, buffer);
            if (failure) return failure;
            if (url.host == 'localhost') url.host = '';
            if (stateOverride) return;
            buffer = '';
            state = PATH_START;
          } continue;
        } else buffer += chr;
        break;

      case PATH_START:
        if (isSpecial(url)) {
          state = PATH;
          if (chr != '/' && chr != '\\') continue;
        } else if (!stateOverride && chr == '?') {
          url.query = '';
          state = QUERY;
        } else if (!stateOverride && chr == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (chr != EOF) {
          state = PATH;
          if (chr != '/') continue;
        } break;

      case PATH:
        if (
          chr == EOF || chr == '/' ||
          (chr == '\\' && isSpecial(url)) ||
          (!stateOverride && (chr == '?' || chr == '#'))
        ) {
          if (isDoubleDot(buffer)) {
            shortenURLsPath(url);
            if (chr != '/' && !(chr == '\\' && isSpecial(url))) {
              url.path.push('');
            }
          } else if (isSingleDot(buffer)) {
            if (chr != '/' && !(chr == '\\' && isSpecial(url))) {
              url.path.push('');
            }
          } else {
            if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
              if (url.host) url.host = '';
              buffer = buffer.charAt(0) + ':'; // normalize windows drive letter
            }
            url.path.push(buffer);
          }
          buffer = '';
          if (url.scheme == 'file' && (chr == EOF || chr == '?' || chr == '#')) {
            while (url.path.length > 1 && url.path[0] === '') {
              url.path.shift();
            }
          }
          if (chr == '?') {
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          }
        } else {
          buffer += percentEncode(chr, pathPercentEncodeSet);
        } break;

      case CANNOT_BE_A_BASE_URL_PATH:
        if (chr == '?') {
          url.query = '';
          state = QUERY;
        } else if (chr == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (chr != EOF) {
          url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
        } break;

      case QUERY:
        if (!stateOverride && chr == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (chr != EOF) {
          if (chr == "'" && isSpecial(url)) url.query += '%27';
          else if (chr == '#') url.query += '%23';
          else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
        } break;

      case FRAGMENT:
        if (chr != EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
        break;
    }

    pointer++;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLConstructor, 'URL');
  var base = arguments.length > 1 ? arguments[1] : undefined;
  var urlString = $toString(url);
  var state = setInternalState(that, { type: 'URL' });
  var baseState, failure;
  if (base !== undefined) {
    if (base instanceof URLConstructor) baseState = getInternalURLState(base);
    else {
      failure = parseURL(baseState = {}, $toString(base));
      if (failure) throw TypeError(failure);
    }
  }
  failure = parseURL(state, urlString, null, baseState);
  if (failure) throw TypeError(failure);
  var searchParams = state.searchParams = new URLSearchParams();
  var searchParamsState = getInternalSearchParamsState(searchParams);
  searchParamsState.updateSearchParams(state.query);
  searchParamsState.updateURL = function () {
    state.query = String(searchParams) || null;
  };
  if (!DESCRIPTORS) {
    that.href = serializeURL.call(that);
    that.origin = getOrigin.call(that);
    that.protocol = getProtocol.call(that);
    that.username = getUsername.call(that);
    that.password = getPassword.call(that);
    that.host = getHost.call(that);
    that.hostname = getHostname.call(that);
    that.port = getPort.call(that);
    that.pathname = getPathname.call(that);
    that.search = getSearch.call(that);
    that.searchParams = getSearchParams.call(that);
    that.hash = getHash.call(that);
  }
};

var URLPrototype = URLConstructor.prototype;

var serializeURL = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var username = url.username;
  var password = url.password;
  var host = url.host;
  var port = url.port;
  var path = url.path;
  var query = url.query;
  var fragment = url.fragment;
  var output = scheme + ':';
  if (host !== null) {
    output += '//';
    if (includesCredentials(url)) {
      output += username + (password ? ':' + password : '') + '@';
    }
    output += serializeHost(host);
    if (port !== null) output += ':' + port;
  } else if (scheme == 'file') output += '//';
  output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
  if (query !== null) output += '?' + query;
  if (fragment !== null) output += '#' + fragment;
  return output;
};

var getOrigin = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var port = url.port;
  if (scheme == 'blob') try {
    return new URLConstructor(scheme.path[0]).origin;
  } catch (error) {
    return 'null';
  }
  if (scheme == 'file' || !isSpecial(url)) return 'null';
  return scheme + '://' + serializeHost(url.host) + (port !== null ? ':' + port : '');
};

var getProtocol = function () {
  return getInternalURLState(this).scheme + ':';
};

var getUsername = function () {
  return getInternalURLState(this).username;
};

var getPassword = function () {
  return getInternalURLState(this).password;
};

var getHost = function () {
  var url = getInternalURLState(this);
  var host = url.host;
  var port = url.port;
  return host === null ? ''
    : port === null ? serializeHost(host)
    : serializeHost(host) + ':' + port;
};

var getHostname = function () {
  var host = getInternalURLState(this).host;
  return host === null ? '' : serializeHost(host);
};

var getPort = function () {
  var port = getInternalURLState(this).port;
  return port === null ? '' : String(port);
};

var getPathname = function () {
  var url = getInternalURLState(this);
  var path = url.path;
  return url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
};

var getSearch = function () {
  var query = getInternalURLState(this).query;
  return query ? '?' + query : '';
};

var getSearchParams = function () {
  return getInternalURLState(this).searchParams;
};

var getHash = function () {
  var fragment = getInternalURLState(this).fragment;
  return fragment ? '#' + fragment : '';
};

var accessorDescriptor = function (getter, setter) {
  return { get: getter, set: setter, configurable: true, enumerable: true };
};

if (DESCRIPTORS) {
  defineProperties(URLPrototype, {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    href: accessorDescriptor(serializeURL, function (href) {
      var url = getInternalURLState(this);
      var urlString = $toString(href);
      var failure = parseURL(url, urlString);
      if (failure) throw TypeError(failure);
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    origin: accessorDescriptor(getOrigin),
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    protocol: accessorDescriptor(getProtocol, function (protocol) {
      var url = getInternalURLState(this);
      parseURL(url, $toString(protocol) + ':', SCHEME_START);
    }),
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    username: accessorDescriptor(getUsername, function (username) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom($toString(username));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.username = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    password: accessorDescriptor(getPassword, function (password) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom($toString(password));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.password = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    host: accessorDescriptor(getHost, function (host) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, $toString(host), HOST);
    }),
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    hostname: accessorDescriptor(getHostname, function (hostname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, $toString(hostname), HOSTNAME);
    }),
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    port: accessorDescriptor(getPort, function (port) {
      var url = getInternalURLState(this);
      if (cannotHaveUsernamePasswordPort(url)) return;
      port = $toString(port);
      if (port == '') url.port = null;
      else parseURL(url, port, PORT);
    }),
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    pathname: accessorDescriptor(getPathname, function (pathname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      url.path = [];
      parseURL(url, $toString(pathname), PATH_START);
    }),
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    search: accessorDescriptor(getSearch, function (search) {
      var url = getInternalURLState(this);
      search = $toString(search);
      if (search == '') {
        url.query = null;
      } else {
        if ('?' == search.charAt(0)) search = search.slice(1);
        url.query = '';
        parseURL(url, search, QUERY);
      }
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    searchParams: accessorDescriptor(getSearchParams),
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    hash: accessorDescriptor(getHash, function (hash) {
      var url = getInternalURLState(this);
      hash = $toString(hash);
      if (hash == '') {
        url.fragment = null;
        return;
      }
      if ('#' == hash.charAt(0)) hash = hash.slice(1);
      url.fragment = '';
      parseURL(url, hash, FRAGMENT);
    })
  });
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
redefine(URLPrototype, 'toJSON', function toJSON() {
  return serializeURL.call(this);
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
redefine(URLPrototype, 'toString', function toString() {
  return serializeURL.call(this);
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  if (nativeCreateObjectURL) redefine(URLConstructor, 'createObjectURL', function createObjectURL(blob) {
    return nativeCreateObjectURL.apply(NativeURL, arguments);
  });
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  if (nativeRevokeObjectURL) redefine(URLConstructor, 'revokeObjectURL', function revokeObjectURL(url) {
    return nativeRevokeObjectURL.apply(NativeURL, arguments);
  });
}

setToStringTag(URLConstructor, 'URL');

$({ global: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
  URL: URLConstructor
});


/***/ }),

/***/ 83753:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$({ target: 'URL', proto: true, enumerable: true }, {
  toJSON: function toJSON() {
    return URL.prototype.toString.call(this);
  }
});


/***/ }),

/***/ 22032:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#AEB7B8\" d=\"M8 4l4 4-4 4V4zM4 .889C4 .398 4.448 0 5 0s1 .398 1 .889V15.11c0 .491-.448.889-1 .889s-1-.398-1-.889V.89z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 44859:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic_stroke\" d=\"M9.9094 12.3334H9.75603L9.61808 12.4004C8.82771 12.7844 7.93998 13 6.99998 13C3.68627 13 0.99998 10.3137 0.99998 7.00004C0.99998 3.68633 3.68627 1.00004 6.99998 1.00004C10.3137 1.00004 13 3.68633 13 7.00004C13 7.94004 12.7843 8.82777 12.4003 9.61815L12.3333 9.75609V9.90946V12.3334H9.9094Z\" stroke-width=\"1.33333\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 30245:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#AEB7B8\" d=\"M4 8h8l-4 4-4-4zM.889 6C.398 6 0 5.552 0 5s.398-1 .889-1H15.11c.491 0 .889.448.889 1s-.398 1-.889 1H.89z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 86766:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M1.66683 6.99998C1.66683 4.05446 4.05464 1.66665 7.00016 1.66665C9.94568 1.66665 12.3335 4.05446 12.3335 6.99998C12.3335 9.9455 9.94568 12.3333 7.00016 12.3333C4.05464 12.3333 1.66683 9.9455 1.66683 6.99998ZM7.00016 0.333313C3.31826 0.333313 0.333496 3.31808 0.333496 6.99998C0.333496 10.6819 3.31826 13.6666 7.00016 13.6666C10.6821 13.6666 13.6668 10.6819 13.6668 6.99998C13.6668 3.31808 10.6821 0.333313 7.00016 0.333313ZM10.5123 5.42677C10.748 5.14392 10.7098 4.72354 10.427 4.48783C10.1441 4.25212 9.72372 4.29034 9.48802 4.57319L6.55081 8.09784L4.72099 6.79083C4.42138 6.57682 4.00501 6.64622 3.79101 6.94583C3.577 7.24543 3.6464 7.6618 3.946 7.87581L6.78285 9.90212L10.5123 5.42677Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 44461:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M12.3335 7.00001C12.3335 4.05449 9.94568 1.66668 7.00016 1.66668C4.05464 1.66668 1.66683 4.05449 1.66683 7.00001C1.66683 9.94553 4.05464 12.3333 7.00016 12.3333C9.94568 12.3333 12.3335 9.94553 12.3335 7.00001ZM13.6668 7.00001C13.6668 10.6819 10.6821 13.6667 7.00016 13.6667C3.31826 13.6667 0.333496 10.6819 0.333496 7.00001C0.333496 3.31811 3.31826 0.333344 7.00016 0.333344C10.6821 0.333344 13.6668 3.31811 13.6668 7.00001ZM5.99844 4.73459C5.7869 4.97257 5.66683 5.30872 5.66683 5.66668C5.66683 6.03487 5.36835 6.33334 5.00016 6.33334C4.63197 6.33334 4.3335 6.03487 4.3335 5.66668C4.3335 5.02463 4.54676 4.36079 5.00189 3.84877C5.46793 3.32448 6.15259 3.00001 7.00016 3.00001C7.74335 3.00001 8.41196 3.19655 8.906 3.61763C9.41141 4.0484 9.66683 4.65811 9.66683 5.33334C9.66683 5.76319 9.57758 6.17871 9.34926 6.57034C9.12475 6.95544 8.79108 7.27397 8.36996 7.55471C7.89842 7.86907 7.74592 8.05285 7.69682 8.13467C7.67159 8.17672 7.66683 8.18467 7.66683 8.33334C7.66683 8.70153 7.36835 9.00001 7.00016 9.00001C6.63197 9.00001 6.3335 8.70153 6.3335 8.33334L6.33349 8.32243C6.3334 8.13632 6.33325 7.81577 6.5535 7.44868C6.7544 7.11384 7.10191 6.79761 7.63036 6.44531C7.93768 6.24043 8.10401 6.05896 8.19739 5.8988C8.28696 5.74516 8.3335 5.57017 8.3335 5.33334C8.3335 5.00858 8.2201 4.78495 8.0411 4.63239C7.85073 4.47014 7.51934 4.33334 7.00016 4.33334C6.5144 4.33334 6.19907 4.50888 5.99844 4.73459ZM7.66683 10.3333C7.66683 10.7015 7.36835 11 7.00016 11C6.63197 11 6.3335 10.7015 6.3335 10.3333C6.3335 9.96515 6.63197 9.66668 7.00016 9.66668C7.36835 9.66668 7.66683 9.96515 7.66683 10.3333Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 60251:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"10","height":"13","viewBox":"0 0 10 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.333984 1.24984C0.333984 0.927673 0.595152 0.666504 0.917318 0.666504C0.917839 0.666504 0.91836 0.666505 0.918881 0.666506L3.25065 0.666504C3.98774 0.666504 4.55348 1.04063 4.9667 1.3139L5.01555 1.34617C5.4755 1.64945 5.7833 1.83317 6.16732 1.83317C6.602 1.83317 7.22352 1.6008 7.80228 1.31142C8.0773 1.17391 8.3191 1.03578 8.4922 0.931926C8.57848 0.880156 8.64703 0.837302 8.69333 0.807833C8.71647 0.793109 8.73401 0.781755 8.74539 0.774335L8.75775 0.766235L8.76054 0.764392C8.93952 0.645138 9.16961 0.634042 9.35924 0.735529C9.54891 0.83704 9.66732 1.03471 9.66732 1.24984V6.49984C9.66732 6.69488 9.56984 6.87701 9.40756 6.9852L9.08399 6.49984C9.40756 6.9852 9.40765 6.98514 9.40756 6.9852L9.4051 6.98683L9.40011 6.99014L9.3827 7.00155C9.36788 7.01122 9.34668 7.02493 9.31969 7.04211C9.26574 7.07644 9.18845 7.12473 9.09244 7.18233C8.90095 7.29723 8.63234 7.45076 8.32403 7.60492C7.73612 7.89887 6.8993 8.24984 6.16732 8.24984C5.4082 8.24984 4.81694 7.87335 4.38107 7.59581L4.34897 7.57538C3.86321 7.2664 3.55209 7.08317 3.18583 7.08317H1.50065V11.7498C1.50065 12.072 1.23948 12.3332 0.917318 12.3332C0.595152 12.3332 0.333984 12.072 0.333984 11.7498V1.24984Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 79058:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M6.05558 1.55357C6.36687 0.658012 7.6334 0.658002 7.9447 1.55357L9.04496 4.71887L12.3953 4.78714C13.3433 4.80646 13.7346 6.011 12.9791 6.58381L10.3087 8.60835L11.2791 11.8158C11.5537 12.7233 10.529 13.4678 9.75078 12.9262L7.00014 11.0122L4.24949 12.9262C3.47126 13.4678 2.4466 12.7234 2.72116 11.8158L3.69155 8.60835L1.02117 6.58381C0.265637 6.01101 0.657009 4.80646 1.60494 4.78714L4.95532 4.71887L6.05558 1.55357ZM7.00014 2.89714L6.13858 5.37574C6.00125 5.77081 5.63256 6.03868 5.21439 6.0472L2.59086 6.10066L4.68191 7.68599C5.01521 7.93867 5.15604 8.3721 5.03492 8.77244L4.27506 11.2841L6.42896 9.78526C6.77227 9.54636 7.228 9.54636 7.57132 9.78526L9.72522 11.2841L8.96535 8.77244C8.84424 8.3721 8.98507 7.93867 9.31836 7.68599L11.4094 6.10066L8.78589 6.0472C8.36772 6.03868 7.99903 5.77081 7.8617 5.37574L7.00014 2.89714Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 10812:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 0.666667C0 0.298477 0.298477 0 0.666667 0H11.3333C11.7015 0 12 0.298477 12 0.666667C12 1.03486 11.7015 1.33333 11.3333 1.33333H0.666667C0.298477 1.33333 0 1.03486 0 0.666667ZM0 3.33333C0 2.96514 0.298477 2.66667 0.666667 2.66667H7.33333C7.70152 2.66667 8 2.96514 8 3.33333C8 3.70152 7.70152 4 7.33333 4H0.666667C0.298477 4 0 3.70152 0 3.33333ZM0.666667 5.33333C0.298477 5.33333 0 5.63181 0 6C0 6.36819 0.298477 6.66667 0.666667 6.66667H11.3333C11.7015 6.66667 12 6.36819 12 6C12 5.63181 11.7015 5.33333 11.3333 5.33333H0.666667ZM0 8.66667C0 8.29848 0.298477 8 0.666667 8H7.33333C7.70152 8 8 8.29848 8 8.66667C8 9.03486 7.70152 9.33333 7.33333 9.33333H0.666667C0.298477 9.33333 0 9.03486 0 8.66667ZM0.666667 10.6667C0.298477 10.6667 0 10.9651 0 11.3333C0 11.7015 0.298477 12 0.666667 12H11.3333C11.7015 12 12 11.7015 12 11.3333C12 10.9651 11.7015 10.6667 11.3333 10.6667H0.666667Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 67906:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"10","viewBox":"0 0 14 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.333496 0.99998C0.333496 0.63179 0.631973 0.333313 1.00016 0.333313H13.0002C13.3684 0.333313 13.6668 0.63179 13.6668 0.99998C13.6668 1.36817 13.3684 1.66665 13.0002 1.66665H1.00016C0.631973 1.66665 0.333496 1.36817 0.333496 0.99998ZM0.333496 4.99998C0.333496 4.63179 0.631973 4.33331 1.00016 4.33331H13.0002C13.3684 4.33331 13.6668 4.63179 13.6668 4.99998C13.6668 5.36817 13.3684 5.66665 13.0002 5.66665H1.00016C0.631973 5.66665 0.333496 5.36817 0.333496 4.99998ZM1.00016 8.33331C0.631973 8.33331 0.333496 8.63179 0.333496 8.99998C0.333496 9.36817 0.631973 9.66665 1.00016 9.66665H13.0002C13.3684 9.66665 13.6668 9.36817 13.6668 8.99998C13.6668 8.63179 13.3684 8.33331 13.0002 8.33331H1.00016Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 89959:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"12","viewBox":"0 0 14 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.66651 0.666687C3.96417 0.666687 4.22576 0.864005 4.30753 1.15021L6.9742 10.4835C7.07535 10.8376 6.87035 11.2066 6.51633 11.3077C6.1623 11.4089 5.79331 11.2039 5.69216 10.8498L5.06744 8.6633C5.04521 8.66554 5.02266 8.66669 4.99985 8.66669H2.33318C2.31036 8.66669 2.28781 8.66554 2.26559 8.6633L1.64086 10.8498C1.53971 11.2039 1.17072 11.4089 0.816699 11.3077C0.462675 11.2066 0.257681 10.8376 0.35883 10.4835L3.0255 1.15021C3.10727 0.864005 3.36886 0.666687 3.66651 0.666687ZM2.64557 7.33335H4.68745L3.66651 3.76006L2.64557 7.33335ZM8.33318 1.33335C8.33318 0.965164 8.63166 0.666687 8.99985 0.666687H12.9998C13.2239 0.666687 13.433 0.779276 13.5564 0.96636C13.6798 1.15344 13.7009 1.38999 13.6126 1.59597L10.0109 10H12.9998C13.368 10 13.6665 10.2985 13.6665 10.6667C13.6665 11.0349 13.368 11.3334 12.9998 11.3334H8.99985C8.77575 11.3334 8.56665 11.2208 8.44329 11.0337C8.31992 10.8466 8.29881 10.61 8.38708 10.4041L11.9888 2.00002H8.99985C8.63166 2.00002 8.33318 1.70154 8.33318 1.33335ZM6.99985 6.00002C6.99985 5.63183 7.29832 5.33335 7.66651 5.33335H8.33318C8.70137 5.33335 8.99985 5.63183 8.99985 6.00002C8.99985 6.36821 8.70137 6.66669 8.33318 6.66669H7.66651C7.29832 6.66669 6.99985 6.36821 6.99985 6.00002Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 65216:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"11","viewBox":"0 0 12 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.195287 0.195262C0.455636 -0.0650874 0.877746 -0.0650874 1.1381 0.195262L2.46574 1.52291C2.51433 1.57023 2.55433 1.62356 2.58549 1.68078C2.6819 1.85741 2.69246 2.06845 2.61717 2.25261C2.59251 2.31292 2.55865 2.37035 2.51558 2.42275L1.18727 4.08313C0.957264 4.37064 0.537736 4.41725 0.250228 4.18725C-0.0372801 3.95724 -0.0838944 3.53771 0.146112 3.2502L1.10669 2.04948L0.195287 1.13807C-0.0650629 0.877722 -0.0650629 0.455612 0.195287 0.195262ZM4.00002 2C4.00002 1.63181 4.2985 1.33333 4.66669 1.33333H11.3334C11.7015 1.33333 12 1.63181 12 2C12 2.36819 11.7015 2.66667 11.3334 2.66667H4.66669C4.2985 2.66667 4.00002 2.36819 4.00002 2ZM4.00002 6C4.00002 5.63181 4.2985 5.33333 4.66669 5.33333H11.3334C11.7015 5.33333 12 5.63181 12 6C12 6.36819 11.7015 6.66667 11.3334 6.66667H4.66669C4.2985 6.66667 4.00002 6.36819 4.00002 6ZM4.66669 9.33333C4.2985 9.33333 4.00002 9.63181 4.00002 10C4.00002 10.3682 4.2985 10.6667 4.66669 10.6667H11.3334C11.7015 10.6667 12 10.3682 12 10C12 9.63181 11.7015 9.33333 11.3334 9.33333H4.66669Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 88098:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"9","viewBox":"0 0 11 9","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M5.49633 0.250001C5.29741 0.250001 5.09758 0.286163 4.90966 0.358065L0.815374 1.91133C0.584833 1.99879 0.590791 2.29313 0.820874 2.38059L4.93762 3.87667C5.29828 4.0108 5.70171 4.0108 6.06237 3.87667L10.1791 2.38059C10.4097 2.29818 10.4097 1.99879 10.1846 1.91133L6.07933 0.358065C5.89487 0.28651 5.6966 0.249758 5.49633 0.250001ZM10.725 2.81074C10.6901 2.81095 10.6555 2.81738 10.6232 2.82967L6.03441 4.45988C5.98307 4.47917 5.93912 4.51201 5.90812 4.55422C5.87712 4.59643 5.86046 4.64613 5.86025 4.69703V8.43765C5.86068 8.4786 5.87197 8.51884 5.89315 8.55489C5.91432 8.59095 5.94475 8.62173 5.98179 8.64458C6.01884 8.66743 6.06139 8.68166 6.10577 8.68605C6.15016 8.69043 6.19504 8.68484 6.23654 8.66976L10.8258 7.03408C10.8773 7.01655 10.9216 6.9849 10.9528 6.94345C10.9839 6.902 11.0004 6.85275 11 6.80239V3.06177C10.9995 2.99515 10.9703 2.93141 10.9188 2.88446C10.8673 2.83751 10.7976 2.81116 10.725 2.81116V2.81074ZM0.309833 2.82714C0.269139 2.82582 0.228587 2.83223 0.190726 2.84598C0.152864 2.85973 0.118514 2.88052 0.0898333 2.90703C0.0394166 2.95371 0 3.01005 0 3.07733V6.59047C0 6.77632 0.236042 6.90036 0.416166 6.81753L3.28991 5.55356L3.43062 5.49175L4.79141 4.88793C5.005 4.79543 4.9885 4.50613 4.76345 4.42876L0.404708 2.84522C0.374619 2.83368 0.34244 2.8274 0.309833 2.82672V2.82714Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 32577:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill=\"#F24242\" d=\"M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zM7 10h2v2H7v-2zm0-6h2v5H7V4z\"/>         <path d=\"M0 0h16v16H0z\" opacity=\".486\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 87163:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm3 4a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1zm-2 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4zm2 5a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1zm-2 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 36842:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm0 4a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm1 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4zm-1 5a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm1 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 35596:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm0 4a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm1 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4zm-1 5a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm1 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 4802:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm6 4a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2H10a1 1 0 0 1-1-1zm-5 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4zm5 5a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2H10a1 1 0 0 1-1-1zm-5 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 19379:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#AEB7B8\" d=\"M4 7h8l-4 4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 61177:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path fill=\"#AEB7B8\" d=\"M10 4v8L6 8z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 61093:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"5","height":"6","viewBox":"0 0 5 6","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M0 4.82578V1.17422C0 0.319867 1.00212 -0.141041 1.65079 0.414964L3.78087 2.24074C4.24648 2.63984 4.24648 3.36016 3.78087 3.75926L1.65079 5.58504C1.00212 6.14104 0 5.68013 0 4.82578Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 83675:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path fill=\"#AEB7B8\" d=\"M6 4v8l4-4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 4817:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M18.662 2.059l-4.611 1.536A3 3 0 0 0 12 6.442v8.35c-.849-.507-1.894-.792-3-.792-1.3 0-2.515.394-3.428 1.079C4.658 15.764 4 16.786 4 18c0 1.214.658 2.236 1.572 2.921C6.485 21.606 7.7 22 9 22c1.3 0 2.515-.394 3.428-1.079C13.342 20.236 14 19.214 14 18v-7.279l3.949-1.316A3 3 0 0 0 20 6.559V3.023a.979.979 0 0 0-.126-.509.992.992 0 0 0-1.212-.455zM14 8.613l3.316-1.106A.999.999 0 0 0 18 6.559V4.387l-3.316 1.106a1 1 0 0 0-.684.949v2.171zm-2.772 8.066c.535.401.772.878.772 1.321 0 .443-.237.921-.772 1.321C10.694 19.722 9.909 20 9 20c-.909 0-1.694-.278-2.228-.679C6.237 18.921 6 18.443 6 18c0-.443.237-.92.772-1.321C7.306 16.278 8.091 16 9 16c.909 0 1.694.278 2.228.679z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 69710:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" d=\"M8.0002 2.66665C7.26382 2.66665 6.66687 3.2636 6.66687 3.99998V6.66665C6.66687 7.40303 7.26382 7.99998 8.0002 7.99998C8.73658 7.99998 9.33354 7.40303 9.33354 6.66665V3.99998C9.33354 3.2636 8.73658 2.66665 8.0002 2.66665ZM5.33354 3.99998C5.33354 2.52722 6.52744 1.33331 8.0002 1.33331C9.47296 1.33331 10.6669 2.52722 10.6669 3.99998V6.66665C10.6669 8.13941 9.47296 9.33331 8.0002 9.33331C6.52744 9.33331 5.33354 8.13941 5.33354 6.66665V3.99998ZM4.0002 5.99998C4.0002 5.63179 3.70173 5.33331 3.33354 5.33331C2.96535 5.33331 2.66687 5.63179 2.66687 5.99998V6.66665C2.66687 9.38682 4.70331 11.6314 7.33479 11.9589C7.33396 11.9725 7.33354 11.9862 7.33354 12V13.3333H6.66687C6.29868 13.3333 6.0002 13.6318 6.0002 14C6.0002 14.3682 6.29868 14.6666 6.66687 14.6666H9.33354C9.70173 14.6666 10.0002 14.3682 10.0002 14C10.0002 13.6318 9.70173 13.3333 9.33354 13.3333H8.66687V12C8.66687 11.9862 8.66645 11.9725 8.66562 11.9589C11.2971 11.6314 13.3335 9.38682 13.3335 6.66665V5.99998C13.3335 5.63179 13.0351 5.33331 12.6669 5.33331C12.2987 5.33331 12.0002 5.63179 12.0002 5.99998V6.66665C12.0002 8.87579 10.2093 10.6666 8.0002 10.6666C5.79106 10.6666 4.0002 8.87579 4.0002 6.66665V5.99998Z\" fill=\"#5C6061\" />     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 86306:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.193851 6.46999C0.19432 6.47046 0.194791 6.47093 0.195262 6.4714C0.195376 6.47152 0.19549 6.47163 0.195605 6.47175L5.5286 11.8047C5.78895 12.0651 6.21106 12.0651 6.4714 11.8047C6.73175 11.5444 6.73175 11.1223 6.4714 10.8619L2.27614 6.66667H11.3333C11.7015 6.66667 12 6.36819 12 6C12 5.63181 11.7015 5.33333 11.3333 5.33333H2.27614L6.4714 1.13807C6.73175 0.877722 6.73175 0.455612 6.4714 0.195262C6.21106 -0.0650875 5.78895 -0.0650875 5.5286 0.195262L0.195262 5.5286L0.193851 5.53001C0.0740375 5.65054 0 5.81662 0 6C0 6.09039 0.0179904 6.17659 0.0505859 6.25519C0.052061 6.25875 0.0535685 6.26231 0.0551082 6.26585C0.0872743 6.3399 0.133522 6.4093 0.193851 6.46999Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 11803:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.333 3.333a.667.667 0 1 1 1.334 0c0 .167.061.32.163.437l.009.01.035.042.132.16c.113.136.268.329.438.551.348.454.735.998.964 1.44.253.488.488 1.186.665 1.792a21.283 21.283 0 0 1 .273 1.03l.002.01a.663.663 0 0 0 .18.333l1 1 .53.529H2.942l.528-.529 1-1a.663.663 0 0 0 .181-.332l.002-.01a9.955 9.955 0 0 1 .069-.28c.048-.19.117-.455.204-.751.177-.606.412-1.304.665-1.791.23-.443.616-.987.964-1.441a21.281 21.281 0 0 1 .57-.71l.035-.042.009-.01V3.77a.664.664 0 0 0 .163-.437zm5.272 4.996l.866.866.529.529c.84.84.245 2.276-.943 2.276h-2.39a2.667 2.667 0 0 1-5.334 0h-2.39C1.755 12 1.16 10.564 2 9.724l.529-.529.866-.866.035-.14c.05-.202.125-.482.217-.798.181-.62.446-1.422.761-2.031.286-.552.733-1.174 1.09-1.639.181-.236.346-.44.466-.586l.053-.065a2 2 0 0 1 3.966 0l.053.065c.12.145.285.35.466.586.357.465.804 1.087 1.09 1.639.315.609.58 1.41.761 2.031a22.717 22.717 0 0 1 .252.938zM8 13.333A1.333 1.333 0 0 1 6.667 12h2.666c0 .736-.597 1.333-1.333 1.333z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 38096:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.33337 2.66663C6.59699 2.66663 6.00004 3.26358 6.00004 3.99996V12C6.00004 12.7363 6.59699 13.3333 7.33337 13.3333H8.66671C9.40309 13.3333 10 12.7363 10 12V3.99996C10 3.26358 9.40309 2.66663 8.66671 2.66663H7.33337ZM7.33337 3.99996L8.66671 3.99996V12H7.33337V3.99996Z\" fill=\"black\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.33337 4.66663C1.33337 3.93025 1.93033 3.33329 2.66671 3.33329H4.00004C4.73642 3.33329 5.33337 3.93025 5.33337 4.66663V11.3333C5.33337 12.0697 4.73642 12.6666 4.00004 12.6666H2.66671C1.93033 12.6666 1.33337 12.0697 1.33337 11.3333V4.66663ZM4.00004 4.66663L2.66671 4.66663V11.3333H4.00004V4.66663Z\" fill=\"black\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.6667 4.66663C10.6667 3.93025 11.2637 3.33329 12 3.33329H13.3334C14.0698 3.33329 14.6667 3.93025 14.6667 4.66663V11.3333C14.6667 12.0697 14.0698 12.6666 13.3334 12.6666H12C11.2637 12.6666 10.6667 12.0697 10.6667 11.3333V4.66663ZM13.3334 4.66663L12 4.66663V11.3333H13.3334V4.66663Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 69425:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M6 2.5H4.5v19H14a5.5 5.5 0 0 0 2.532-10.384A5.5 5.5 0 0 0 12 2.5H6zm6 8a2.5 2.5 0 1 0 0-5H7.5v5H12zm-4.5 3v5H14a2.5 2.5 0 1 0 0-5H7.5z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 22793:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"22","height":"28","viewBox":"0 0 22 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.33337 0.666504C2.12404 0.666504 0.333374 2.45717 0.333374 4.6665V25.9998C0.333374 26.3345 0.457374 26.6412 0.661374 26.8758C0.714707 26.9372 0.774707 26.9945 0.840041 27.0465C1.05071 27.2118 1.31071 27.3158 1.59604 27.3318C1.63204 27.3332 1.66937 27.3332 1.70537 27.3332C2.02404 27.3238 2.31471 27.2025 2.54004 27.0078L11 19.7558L19.46 27.0078C19.6854 27.2025 19.976 27.3238 20.2947 27.3332C20.3307 27.3332 20.368 27.3332 20.404 27.3318C20.6894 27.3158 20.9494 27.2118 21.16 27.0465C21.468 26.8025 21.6667 26.4238 21.6667 25.9998V4.6665C21.6667 2.45717 19.876 0.666504 17.6667 0.666504H4.33337ZM3.00004 4.6665C3.00004 3.9305 3.59737 3.33317 4.33337 3.33317H17.6667C18.4027 3.33317 19 3.9305 19 4.6665V23.1012L11.8734 16.9918C11.64 16.7892 11.3347 16.6665 11 16.6665C10.6654 16.6665 10.36 16.7892 10.1267 16.9918L3.00004 23.1012V4.6665Z\" fill=\"#AEB7B8\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 60681:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"10","viewBox":"0 0 14 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.333344 3.66665C0.333344 1.8257 1.82573 0.333313 3.66668 0.333313H10.3333C12.1743 0.333313 13.6667 1.8257 13.6667 3.66665V6.33335C13.6667 8.1743 12.1743 9.66668 10.3333 9.66668H3.66668C1.82573 9.66668 0.333344 8.1743 0.333344 6.33335V3.66665ZM1.71514 4.10621C1.72692 4.15875 1.74077 4.2105 1.75659 4.26139C2.00982 5.07552 2.76921 5.66665 3.66668 5.66665H10.3333C11.2871 5.66665 12.085 4.99897 12.285 4.10551C12.3167 3.96428 12.3333 3.81741 12.3333 3.66665C12.3333 2.56208 11.4379 1.66665 10.3333 1.66665H3.66668C2.56211 1.66665 1.66668 2.56208 1.66668 3.66665C1.66668 3.81766 1.68341 3.96477 1.71514 4.10621Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 74985:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"currentColor\" d=\"M5.333 2c.368 0 .667.298.667.667v.666h4v-.666a.667.667 0 0 1 1.333 0v.666H12a2 2 0 0 1 2 2V12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5.333a2 2 0 0 1 2-2h.667v-.666c0-.369.298-.667.666-.667zM10 4.667v.666a.667.667 0 0 0 1.333 0v-.666H12c.368 0 .667.298.667.666v1.334H3.333V5.333c0-.368.299-.666.667-.666h.667v.666a.667.667 0 0 0 1.333 0v-.666h4zM3.333 8v4c0 .368.299.667.667.667h8a.667.667 0 0 0 .667-.667V8H3.333z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 31887:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"47","height":"46","viewBox":"0 0 47 46","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.1583 11.3914C44.1583 9.56889 42.6808 8.09143 40.8583 8.09143H33.275C32.557 8.09143 31.975 8.67346 31.975 9.39143C31.975 10.1094 32.557 10.6914 33.275 10.6914H40.8583C41.2449 10.6914 41.5583 11.0048 41.5583 11.3914V16.0998C41.5583 16.8177 42.1403 17.3998 42.8583 17.3998C43.5763 17.3998 44.1583 16.8177 44.1583 16.0998V11.3914ZM15.4083 9.39143C15.4083 8.67346 14.8263 8.09143 14.1083 8.09143H6.52497C4.70243 8.09143 3.22498 9.56889 3.22498 11.3914V16.0998C3.22498 16.8177 3.807 17.3998 4.52497 17.3998C5.24295 17.3998 5.82497 16.8177 5.82497 16.0998V11.3914C5.82497 11.0048 6.13837 10.6914 6.52497 10.6914H14.1083C14.8263 10.6914 15.4083 10.1094 15.4083 9.39143ZM42.8583 28.2164C42.1403 28.2164 41.5583 28.7985 41.5583 29.5164V34.2248C41.5583 34.6114 41.2449 34.9248 40.8583 34.9248H33.275C32.557 34.9248 31.975 35.5068 31.975 36.2248C31.975 36.9427 32.557 37.5248 33.275 37.5248H40.8583C42.6808 37.5248 44.1583 36.0473 44.1583 34.2248V29.5164C44.1583 28.7985 43.5763 28.2164 42.8583 28.2164ZM4.52497 28.2164C3.807 28.2164 3.22498 28.7985 3.22498 29.5164V34.2248C3.22498 36.0473 4.70243 37.5248 6.52497 37.5248H14.1083C14.8263 37.5248 15.4083 36.9427 15.4083 36.2248C15.4083 35.5068 14.8263 34.9248 14.1083 34.9248H6.52497C6.13838 34.9248 5.82497 34.6114 5.82497 34.2248V29.5164C5.82497 28.7985 5.24295 28.2164 4.52497 28.2164Z\" fill=\"#00A1B7\"/> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32.5 23C32.5 27.9706 28.4706 32 23.5 32C18.5294 32 14.5 27.9706 14.5 23C14.5 18.0294 18.5294 14 23.5 14C28.4706 14 32.5 18.0294 32.5 23ZM25.8625 20.6375C25.8625 21.9423 24.8048 23 23.5 23C22.1952 23 21.1375 21.9423 21.1375 20.6375C21.1375 19.3327 22.1952 18.275 23.5 18.275C24.8048 18.275 25.8625 19.3327 25.8625 20.6375ZM26.8718 27.0538C27.3662 26.8479 27.5539 26.2508 27.224 25.829C26.3592 24.7233 25.0126 24.0125 23.5 24.0125C21.9874 24.0125 20.6408 24.7233 19.776 25.829C19.4461 26.2508 19.6338 26.8479 20.1281 27.0538C21.1662 27.4862 22.3052 27.725 23.5 27.725C24.6947 27.725 25.8337 27.4862 26.8718 27.0538Z\" fill=\"#00A1B7\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 21088:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"47","height":"46","viewBox":"0 0 47 46","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.1583 11.3914C44.1583 9.56889 42.6808 8.09143 40.8583 8.09143H33.275C32.557 8.09143 31.975 8.67346 31.975 9.39143C31.975 10.1094 32.557 10.6914 33.275 10.6914H40.8583C41.2449 10.6914 41.5583 11.0048 41.5583 11.3914V16.0998C41.5583 16.8177 42.1403 17.3998 42.8583 17.3998C43.5763 17.3998 44.1583 16.8177 44.1583 16.0998V11.3914ZM15.4083 9.39143C15.4083 8.67346 14.8263 8.09143 14.1083 8.09143H6.52497C4.70243 8.09143 3.22498 9.56889 3.22498 11.3914V16.0998C3.22498 16.8177 3.807 17.3998 4.52497 17.3998C5.24295 17.3998 5.82497 16.8177 5.82497 16.0998V11.3914C5.82497 11.0048 6.13837 10.6914 6.52497 10.6914H14.1083C14.8263 10.6914 15.4083 10.1094 15.4083 9.39143ZM42.8583 28.2164C42.1403 28.2164 41.5583 28.7985 41.5583 29.5164V34.2248C41.5583 34.6114 41.2449 34.9248 40.8583 34.9248H33.275C32.557 34.9248 31.975 35.5068 31.975 36.2248C31.975 36.9427 32.557 37.5248 33.275 37.5248H40.8583C42.6808 37.5248 44.1583 36.0473 44.1583 34.2248V29.5164C44.1583 28.7985 43.5763 28.2164 42.8583 28.2164ZM4.52497 28.2164C3.807 28.2164 3.22498 28.7985 3.22498 29.5164V34.2248C3.22498 36.0473 4.70243 37.5248 6.52497 37.5248H14.1083C14.8263 37.5248 15.4083 36.9427 15.4083 36.2248C15.4083 35.5068 14.8263 34.9248 14.1083 34.9248H6.52497C6.13838 34.9248 5.82497 34.6114 5.82497 34.2248V29.5164C5.82497 28.7985 5.24295 28.2164 4.52497 28.2164Z\" fill=\"#A5B3BD\"/> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32.5 23C32.5 27.9706 28.4706 32 23.5 32C18.5294 32 14.5 27.9706 14.5 23C14.5 18.0294 18.5294 14 23.5 14C28.4706 14 32.5 18.0294 32.5 23ZM25.8625 20.6375C25.8625 21.9423 24.8048 23 23.5 23C22.1952 23 21.1375 21.9423 21.1375 20.6375C21.1375 19.3327 22.1952 18.275 23.5 18.275C24.8048 18.275 25.8625 19.3327 25.8625 20.6375ZM26.8718 27.0538C27.3662 26.8479 27.5539 26.2508 27.224 25.829C26.3592 24.7233 25.0126 24.0125 23.5 24.0125C21.9874 24.0125 20.6408 24.7233 19.776 25.829C19.4461 26.2508 19.6338 26.8479 20.1281 27.0538C21.1662 27.4862 22.3052 27.725 23.5 27.725C24.6947 27.725 25.8337 27.4862 26.8718 27.0538Z\" fill=\"#A5B3BD\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 21855:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"10","viewBox":"0 0 14 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.2304 0.914805C13.4908 1.17515 13.4908 1.59726 13.2304 1.85761L5.68792 9.4001C5.42758 9.66045 5.00547 9.66045 4.74512 9.4001L0.528599 5.1836C0.268249 4.92325 0.268248 4.50114 0.528597 4.24079C0.788946 3.98044 1.21106 3.98044 1.47141 4.24079L5.21652 7.98589L12.2876 0.914806C12.5479 0.654456 12.9701 0.654456 13.2304 0.914805Z\" fill=\"#00A1B7\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 41614:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg","style":"color: #00a1b7;"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 0C0.895431 0 0 0.89543 0 2V16C0 17.1046 0.89543 18 2 18H16C17.1046 18 18 17.1046 18 16V2C18 0.895431 17.1046 0 16 0H2ZM14.2682 6.64018C14.6218 6.21591 14.5645 5.58534 14.1402 5.23178C13.7159 4.87821 13.0853 4.93554 12.7318 5.35982L8.32597 10.6468L5.58124 8.68627C5.13182 8.36526 4.50727 8.46935 4.18627 8.91877C3.86526 9.36818 3.96935 9.99273 4.41876 10.3137L7.91876 12.8137L8.67403 13.3532L9.26822 12.6402L14.2682 6.64018Z\" fill=\"currentColor\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 98892:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M6 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6zM5 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6zm12.268 3.64a1 1 0 1 0-1.536-1.28l-4.406 5.287-2.745-1.96a1 1 0 1 0-1.162 1.627l3.5 2.5.755.54.594-.714 5-6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 36598:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M9.70711 3.70711C10.0976 3.31658 10.0976 2.68342 9.70711 2.29289C9.31658 1.90237 8.68342 1.90237 8.29289 2.29289L5 5.58579L3.70711 4.29289C3.31658 3.90237 2.68342 3.90237 2.29289 4.29289C1.90237 4.68342 1.90237 5.31658 2.29289 5.70711L4.29289 7.70711C4.68342 8.09763 5.31658 8.09763 5.70711 7.70711L9.70711 3.70711Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M12 5C11.4477 5 11 5.44772 11 6C11 6.55228 11.4477 7 12 7H21C21.5523 7 22 6.55228 22 6C22 5.44772 21.5523 5 21 5H12Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H21C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11H3Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M3 19C2.44772 19 2 18.5523 2 18C2 17.4477 2.44772 17 3 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H3Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 47904:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#AEB7B8\" fill-rule=\"nonzero\" d=\"M6 9.414l5 5L12.414 13l-5-5 5-5L11 1.586 4.586 8 6 9.414z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 16186:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#AEB7B8\" fill-rule=\"nonzero\" d=\"M11 9.414l-5 5L4.586 13l5-5-5-5L6 1.586 12.414 8 11 9.414z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 57872:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M4 3a1 1 0 0 1 1-1h14a1 1 0 0 1 0 2h-6v6.877l-2-1.913V4H5a1 1 0 0 1-1-1zm.265 3.322a1 1 0 0 1 1.413-.057l13 12a1 1 0 0 1-1.356 1.47L13 15.745V21a1 1 0 0 1-2 0v-7.101L4.322 7.735a1 1 0 0 1-.057-1.413z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 71185:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"30","height":"24","viewBox":"0 0 30 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.25 24C8.50282 24 8.75298 23.9886 9 23.9664V24H22.5V23.9588C22.7463 23.986 22.9965 24 23.25 24C26.9779 24 30 20.9779 30 17.25C30 13.7314 27.3077 10.8416 23.8708 10.5282C23.9557 10.0315 24 9.52091 24 9C24 4.02944 19.9706 0 15 0C10.4404 0 6.67276 3.39066 6.08089 7.78812C2.57683 8.7405 0 11.9443 0 15.75C0 20.3063 3.69365 24 8.25 24ZM9.43934 7.93934C10.0251 7.35355 10.9749 7.35355 11.5607 7.93934L15 11.3787L18.4393 7.93934C19.0251 7.35355 19.9749 7.35355 20.5607 7.93934C21.1464 8.52513 21.1464 9.47487 20.5607 10.0607L17.1213 13.5L20.5607 16.9393C21.1464 17.5251 21.1464 18.4749 20.5607 19.0607C19.9749 19.6464 19.0251 19.6464 18.4393 19.0607L15 15.6213L11.5607 19.0607C10.9749 19.6464 10.0251 19.6464 9.43934 19.0607C8.85355 18.4749 8.85355 17.5251 9.43934 16.9393L12.8787 13.5L9.43934 10.0607C8.85355 9.47487 8.85355 8.52513 9.43934 7.93934Z\" fill=\"#C8C8C8\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 47778:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M14.961 5.275a1 1 0 0 0-1.922-.55l-4 14a1.001 1.001 0 0 0 1.922.55l4-14zm-7.336.944a1 1 0 0 1 .156 1.406L4.28 12l3.5 4.375a1 1 0 0 1-1.562 1.25L2.232 12.64A.986.986 0 0 1 2 12a1 1 0 0 1 .232-.64l3.987-4.985a1 1 0 0 1 1.406-.156zm8.75 0a1 1 0 0 1 1.406.156l3.987 4.985a1.003 1.003 0 0 1 0 1.28l-3.987 4.985a1 1 0 0 1-1.562-1.25L19.72 12l-3.5-4.375a1 1 0 0 1 .156-1.406z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 97368:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"10","viewBox":"0 0 12 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M0.666667 0.333374C0.298477 0.333374 0 0.631851 0 1.00004C0 1.36823 0.298477 1.66671 0.666667 1.66671H4.66667C5.03486 1.66671 5.33333 1.36823 5.33333 1.00004C5.33333 0.631851 5.03486 0.333374 4.66667 0.333374H0.666667Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M0.666667 3.00004C0.298477 3.00004 0 3.29852 0 3.66671C0 4.0349 0.298477 4.33337 0.666667 4.33337H4.66667C5.03486 4.33337 5.33333 4.0349 5.33333 3.66671C5.33333 3.29852 5.03486 3.00004 4.66667 3.00004H0.666667Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M0 6.33337C0 5.96518 0.298477 5.66671 0.666667 5.66671H4.66667C5.03486 5.66671 5.33333 5.96518 5.33333 6.33337C5.33333 6.70156 5.03486 7.00004 4.66667 7.00004H0.666667C0.298477 7.00004 0 6.70156 0 6.33337Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M0.666667 8.33337C0.298477 8.33337 0 8.63185 0 9.00004C0 9.36823 0.298477 9.66671 0.666667 9.66671H4.66667C5.03486 9.66671 5.33333 9.36823 5.33333 9.00004C5.33333 8.63185 5.03486 8.33337 4.66667 8.33337H0.666667Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M6.66667 1.00004C6.66667 0.631851 6.96514 0.333374 7.33333 0.333374H11.3333C11.7015 0.333374 12 0.631851 12 1.00004C12 1.36823 11.7015 1.66671 11.3333 1.66671H7.33333C6.96514 1.66671 6.66667 1.36823 6.66667 1.00004Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M7.33333 3.00004C6.96514 3.00004 6.66667 3.29852 6.66667 3.66671C6.66667 4.0349 6.96514 4.33337 7.33333 4.33337H11.3333C11.7015 4.33337 12 4.0349 12 3.66671C12 3.29852 11.7015 3.00004 11.3333 3.00004H7.33333Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M6.66667 6.33337C6.66667 5.96518 6.96514 5.66671 7.33333 5.66671H11.3333C11.7015 5.66671 12 5.96518 12 6.33337C12 6.70156 11.7015 7.00004 11.3333 7.00004H7.33333C6.96514 7.00004 6.66667 6.70156 6.66667 6.33337Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M7.33333 8.33337C6.96514 8.33337 6.66667 8.63185 6.66667 9.00004C6.66667 9.36823 6.96514 9.66671 7.33333 9.66671H11.3333C11.7015 9.66671 12 9.36823 12 9.00004C12 8.63185 11.7015 8.33337 11.3333 8.33337H7.33333Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 58191:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"19","height":"18","viewBox":"0 0 19 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.3999 1.5C5.25777 1.5 1.8999 4.85786 1.8999 9C1.8999 13.1421 5.25777 16.5 9.3999 16.5C10.5734 16.5 11.6839 16.2305 12.673 15.75H16.1499V12.2731C16.6304 11.284 16.8999 10.1735 16.8999 9C16.8999 4.85786 13.542 1.5 9.3999 1.5Z\" fill=\"#00A1B7\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 7688:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.333313 7C0.333313 3.3181 3.31808 0.333336 6.99998 0.333336C10.6819 0.333336 13.6666 3.3181 13.6666 7C13.6666 8.0431 13.4271 9.03024 13 9.90942V13H9.9094C9.03022 13.4271 8.04308 13.6667 6.99998 13.6667C3.31808 13.6667 0.333313 10.6819 0.333313 7Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 3641:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic_stroke\" d=\"M14.3641 18H14.1341L13.9272 18.1005C12.7416 18.6765 11.41 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10C19 11.41 18.6765 12.7416 18.1005 13.9272L18 14.1341V14.3641V18H14.3641Z\" stroke-width=\"2\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 67012:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M7.33317 2C6.2286 2 5.33317 2.89543 5.33317 4V4.66667H4.6665C3.56193 4.66667 2.6665 5.5621 2.6665 6.66667V12C2.6665 13.1046 3.56193 14 4.6665 14H8.6665C9.77107 14 10.6665 13.1046 10.6665 12V11.3333H11.3332C12.4377 11.3333 13.3332 10.4379 13.3332 9.33333V4C13.3332 2.89543 12.4377 2 11.3332 2H7.33317ZM10.6665 10V6.66667C10.6665 5.5621 9.77107 4.66667 8.6665 4.66667H6.6665V4C6.6665 3.63181 6.96498 3.33333 7.33317 3.33333H11.3332C11.7014 3.33333 11.9998 3.63181 11.9998 4V9.33333C11.9998 9.70152 11.7014 10 11.3332 10H10.6665ZM3.99984 6.66667C3.99984 6.29848 4.29831 6 4.6665 6H8.6665C9.03469 6 9.33317 6.29848 9.33317 6.66667V12C9.33317 12.3682 9.03469 12.6667 8.6665 12.6667H4.6665C4.29831 12.6667 3.99984 12.3682 3.99984 12V6.66667Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 13532:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 2C0 0.895431 0.895431 0 2 0H4C4.62951 0 5.22229 0.296388 5.6 0.8L7 2.66667H10C11.1046 2.66667 12 3.5621 12 4.66667V6.35176C12.055 6.40102 12.1089 6.45207 12.1618 6.5049C13.7239 8.067 13.7239 10.5997 12.1618 12.1618C10.5997 13.7239 8.067 13.7239 6.50491 12.1618C6.45207 12.1089 6.40103 12.055 6.35177 12H2C0.89543 12 0 11.1046 0 10V2ZM10.6667 5.56111C9.25957 5.06486 7.63034 5.37946 6.50491 6.5049C5.37947 7.63034 5.06487 9.25957 5.56111 10.6667H2C1.63181 10.6667 1.33333 10.3682 1.33333 10V4H10C10.3682 4 10.6667 4.29848 10.6667 4.66667V5.56111ZM4.53333 1.6L5.33333 2.66667H1.33333V2C1.33333 1.63181 1.63181 1.33333 2 1.33333H4C4.20984 1.33333 4.40743 1.43213 4.53333 1.6ZM6.67441 9.33112C6.67441 8.96293 6.97288 8.66445 7.34107 8.66445H8.66897V7.33655C8.66897 6.96836 8.96744 6.66988 9.33563 6.66988C9.70382 6.66988 10.0023 6.96836 10.0023 7.33655V8.66445H11.3302C11.6984 8.66445 11.9969 8.96293 11.9969 9.33112C11.9969 9.69931 11.6984 9.99778 11.3302 9.99778H10.0023V11.3257C10.0023 11.6939 9.70382 11.9923 9.33563 11.9923C8.96744 11.9923 8.66897 11.6939 8.66897 11.3257V9.99778H7.34107C6.97288 9.99778 6.67441 9.69931 6.67441 9.33112Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 44744:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"13","height":"16","viewBox":"0 0 13 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.166672 2.51702C0.166672 1.41245 1.0621 0.517017 2.16667 0.517017H8.83334C9.93791 0.517017 10.8333 1.41245 10.8333 2.51702V8.20221C11.6517 8.93464 12.1667 9.99902 12.1667 11.1837C12.1667 13.3928 10.3758 15.1837 8.16667 15.1837C6.98201 15.1837 5.91762 14.6687 5.1852 13.8504H2.16667C1.0621 13.8504 0.166672 12.9549 0.166672 11.8504V2.51702ZM4.39428 12.517C4.24688 12.1 4.16667 11.6512 4.16667 11.1837C4.16667 8.97455 5.95753 7.18368 8.16667 7.18368C8.63419 7.18368 9.08297 7.26389 9.50001 7.41129V2.51702C9.50001 2.14883 9.20153 1.85035 8.83334 1.85035H2.16667C1.79848 1.85035 1.50001 2.14883 1.50001 2.51702V11.8504C1.50001 12.2185 1.79848 12.517 2.16667 12.517H4.39428ZM2.83334 3.85035C2.83334 3.48216 3.13182 3.18368 3.50001 3.18368H7.50001C7.86819 3.18368 8.16667 3.48216 8.16667 3.85035C8.16667 4.21854 7.86819 4.51702 7.50001 4.51702H3.50001C3.13182 4.51702 2.83334 4.21854 2.83334 3.85035ZM3.50001 5.85035C3.13182 5.85035 2.83334 6.14883 2.83334 6.51702C2.83334 6.88521 3.13182 7.18368 3.50001 7.18368H4.83334C5.20153 7.18368 5.50001 6.88521 5.50001 6.51702C5.50001 6.14883 5.20153 5.85035 4.83334 5.85035H3.50001ZM8.83334 9.18368C8.83334 8.81549 8.53486 8.51702 8.16667 8.51702C7.79848 8.51702 7.50001 8.81549 7.50001 9.18368V10.517H6.16667C5.79848 10.517 5.50001 10.8155 5.50001 11.1837C5.50001 11.5519 5.79848 11.8504 6.16667 11.8504H7.50001V13.1837C7.50001 13.5519 7.79848 13.8504 8.16667 13.8504C8.53486 13.8504 8.83334 13.5519 8.83334 13.1837V11.8504H10.1667C10.5349 11.8504 10.8333 11.5519 10.8333 11.1837C10.8333 10.8155 10.5349 10.517 10.1667 10.517H8.83334V9.18368Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 33597:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","viewBox":"0 0 12 12"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h12v12H0z\"/>         <path class=\"graphic\" fill=\"#FFFFFF\" d=\"M6.707 6l2.98 2.98.353.353-.707.707-.353-.353L6 6.707l-2.98 2.98-.353.353-.707-.707.353-.353L5.293 6l-2.98-2.98-.353-.353.707-.707.353.353L6 5.293l2.98-2.98.353-.353.707.707-.353.353L6.707 6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 89883:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 1.33333C1.63181 1.33333 1.33333 1.63181 1.33333 2V3.33333C1.33333 3.70152 1.03486 4 0.666667 4C0.298477 4 0 3.70152 0 3.33333V2C0 0.895431 0.895431 0 2 0H3.33333C3.70152 0 4 0.298477 4 0.666667C4 1.03486 3.70152 1.33333 3.33333 1.33333H2ZM8 0.666667C8 0.298477 8.29848 0 8.66667 0H10C11.1046 0 12 0.895431 12 2V3.33333C12 3.70152 11.7015 4 11.3333 4C10.9651 4 10.6667 3.70152 10.6667 3.33333V2C10.6667 1.63181 10.3682 1.33333 10 1.33333H8.66667C8.29848 1.33333 8 1.03486 8 0.666667ZM0.666667 8C1.03486 8 1.33333 8.29848 1.33333 8.66667V10C1.33333 10.3682 1.63181 10.6667 2 10.6667H3.33333C3.70152 10.6667 4 10.9651 4 11.3333C4 11.7015 3.70152 12 3.33333 12H2C0.895431 12 0 11.1046 0 10V8.66667C0 8.29848 0.298477 8 0.666667 8ZM11.3333 8C11.7015 8 12 8.29848 12 8.66667V10C12 11.1046 11.1046 12 10 12H8.66667C8.29848 12 8 11.7015 8 11.3333C8 10.9651 8.29848 10.6667 8.66667 10.6667H10C10.3682 10.6667 10.6667 10.3682 10.6667 10V8.66667C10.6667 8.29848 10.9651 8 11.3333 8Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 23996:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M3.33329 11.3334C2.9651 11.3334 2.66663 11.6319 2.66663 12C2.66663 12.3682 2.9651 12.6667 3.33329 12.6667H4.66663C5.03482 12.6667 5.33329 12.3682 5.33329 12C5.33329 11.6319 5.03482 11.3334 4.66663 11.3334H3.33329Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M2.66663 8.00004C2.66663 7.63185 2.9651 7.33337 3.33329 7.33337H4.66663C5.03482 7.33337 5.33329 7.63185 5.33329 8.00004C5.33329 8.36823 5.03482 8.66671 4.66663 8.66671H3.33329C2.9651 8.66671 2.66663 8.36823 2.66663 8.00004Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M8.66663 12C8.66663 11.6319 8.9651 11.3334 9.33329 11.3334C9.70148 11.3334 9.99996 11.6319 9.99996 12C9.99996 12.3682 9.70148 12.6667 9.33329 12.6667C8.9651 12.6667 8.66663 12.3682 8.66663 12Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M11.3333 11.3334C10.9651 11.3334 10.6666 11.6319 10.6666 12C10.6666 12.3682 10.9651 12.6667 11.3333 12.6667H12C12.3681 12.6667 12.6666 12.3682 12.6666 12C12.6666 11.6319 12.3681 11.3334 12 11.3334H11.3333Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M9.33329 7.33337C8.9651 7.33337 8.66663 7.63185 8.66663 8.00004C8.66663 8.36823 8.9651 8.66671 9.33329 8.66671C9.70148 8.66671 9.99996 8.36823 9.99996 8.00004C9.99996 7.63185 9.70148 7.33337 9.33329 7.33337Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M10.6666 8.00004C10.6666 7.63185 10.9651 7.33337 11.3333 7.33337H12C12.3681 7.33337 12.6666 7.63185 12.6666 8.00004C12.6666 8.36823 12.3681 8.66671 12 8.66671H11.3333C10.9651 8.66671 10.6666 8.36823 10.6666 8.00004Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M8.66663 4.00004C8.66663 3.63185 8.9651 3.33337 9.33329 3.33337C9.70148 3.33337 9.99996 3.63185 9.99996 4.00004C9.99996 4.36823 9.70148 4.66671 9.33329 4.66671C8.9651 4.66671 8.66663 4.36823 8.66663 4.00004Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M11.3333 3.33337C10.9651 3.33337 10.6666 3.63185 10.6666 4.00004C10.6666 4.36823 10.9651 4.66671 11.3333 4.66671H12C12.3681 4.66671 12.6666 4.36823 12.6666 4.00004C12.6666 3.63185 12.3681 3.33337 12 3.33337H11.3333Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M3.33329 3.33337C2.9651 3.33337 2.66663 3.63185 2.66663 4.00004C2.66663 4.36823 2.9651 4.66671 3.33329 4.66671H4.66663C5.03482 4.66671 5.33329 4.36823 5.33329 4.00004C5.33329 3.63185 5.03482 3.33337 4.66663 3.33337H3.33329Z\" fill=\"black\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.666626 3.33337C0.666626 2.2288 1.56206 1.33337 2.66663 1.33337H13.3333C14.4379 1.33337 15.3333 2.2288 15.3333 3.33337V12.6667C15.3333 13.7713 14.4379 14.6667 13.3333 14.6667H2.66663C1.56206 14.6667 0.666626 13.7713 0.666626 12.6667V3.33337ZM1.99996 10.6667V12.6667C1.99996 13.0349 2.29844 13.3334 2.66663 13.3334H5.99996V10.6667H1.99996ZM5.99996 9.33337H1.99996V6.66671H5.99996V9.33337ZM7.33329 13.3334H13.3333C13.7015 13.3334 14 13.0349 14 12.6667V10.6667H7.33329V13.3334ZM14 9.33337H7.33329V6.66671H14V9.33337ZM7.33329 5.33337H14V3.33337C14 2.96518 13.7015 2.66671 13.3333 2.66671L7.33329 2.66671V5.33337ZM1.99996 5.33337H5.99996V2.66671H2.66663C2.29844 2.66671 1.99996 2.96518 1.99996 3.33337V5.33337Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 28824:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"22","height":"23","viewBox":"0 0 22 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<rect x=\"0.5\" y=\"1\" width=\"21\" height=\"21\" rx=\"1.5\" fill=\"url(#paint0_linear_7154_6246)\"/>   <path d=\"M11.3164 6.4082L7.49316 17.5H5.18164L9.99805 4.70312H11.4746L11.3164 6.4082ZM14.5156 17.5L10.6836 6.4082L10.5166 4.70312H12.002L16.8359 17.5H14.5156ZM14.3311 12.7539V14.5029H7.37012V12.7539H14.3311Z\" fill=\"url(#paint1_linear_7154_6246)\"/>   <rect class=\"graphic_stroke\" x=\"0.5\" y=\"1\" width=\"21\" height=\"21\" rx=\"1.5\" stroke=\"#505050\"/>   <defs>   <linearGradient id=\"paint0_linear_7154_6246\" x1=\"22\" y1=\"4.77778\" x2=\"4.18548e-07\" y2=\"4.77778\" gradientUnits=\"userSpaceOnUse\">   <stop offset=\"0.411458\" stop-color=\"#505050\"/>   <stop offset=\"0.494792\"/>   <stop offset=\"0.494892\" stop-color=\"white\"/>   </linearGradient>   <linearGradient id=\"paint1_linear_7154_6246\" x1=\"2.38462\" y1=\"9\" x2=\"20\" y2=\"9\" gradientUnits=\"userSpaceOnUse\">   <stop offset=\"0.411458\" stop-color=\"#505050\"/>   <stop offset=\"0.494792\"/>   <stop offset=\"0.494892\" stop-color=\"white\"/>   </linearGradient>   </defs>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 41286:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M12 4H7a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-9h-5a1 1 0 0 1-1-1V4zm8 5.008V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h5.992L20 9.008zM14 8V5.414L16.586 8H14zm-6 9a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1zm1-5a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2H9z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 91177:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path fill=\"#00A1B7\" d=\"M7.493 11.87a.997.997 0 0 1-1.105-.079L2.4 8.8a1 1 0 1 1 1.2-1.6l3.306 2.48 6.387-6.387a1 1 0 0 1 1.414 1.414l-6.99 6.99a.993.993 0 0 1-.224.173z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 99635:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M7.493 11.87a.997.997 0 0 1-1.105-.079L2.4 8.8a1 1 0 1 1 1.2-1.6l3.306 2.48 6.387-6.387a1 1 0 0 1 1.414 1.414l-6.99 6.99a.993.993 0 0 1-.224.173z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 27317:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.0002 1.33331C8.36839 1.33331 8.66687 1.63179 8.66687 1.99998L8.66688 9.72383L12.1955 6.19524C12.4558 5.93489 12.8779 5.93489 13.1383 6.19524C13.3986 6.45559 13.3986 6.8777 13.1383 7.13805L8.47386 11.8025C8.46681 11.8096 8.4596 11.8165 8.45223 11.8233C8.39454 11.8766 8.32973 11.9179 8.26102 11.947C8.18149 11.9809 8.09403 11.9997 8.00221 12L8.00021 12L7.99405 12C7.90806 11.9992 7.82595 11.9821 7.75066 11.9517C7.66991 11.9192 7.59424 11.8702 7.5288 11.8047L2.86213 7.13805C2.60178 6.8777 2.60178 6.45559 2.86213 6.19524C3.12248 5.93489 3.54459 5.93489 3.80494 6.19524L7.33355 9.72385L7.33354 1.99998C7.33354 1.63179 7.63201 1.33331 8.0002 1.33331ZM3.33354 13.3333C2.96535 13.3333 2.66687 13.6318 2.66687 14C2.66687 14.3682 2.96535 14.6666 3.33354 14.6666L12.6669 14.6666C13.0351 14.6666 13.3335 14.3682 13.3335 14C13.3335 13.6318 13.0351 13.3333 12.6669 13.3333L3.33354 13.3333Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 97393:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"15","height":"14","viewBox":"0 0 15 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<mask id=\"path-1-outside-1\" maskUnits=\"userSpaceOnUse\" x=\"0.323242\" y=\"0.25\" width=\"14\" height=\"14\" fill=\"black\">   <rect fill=\"white\" x=\"0.323242\" y=\"0.25\" width=\"14\" height=\"14\"/>   <path d=\"M1.32324 10.6322V12.6043C1.32324 12.786 1.46596 12.9287 1.64761 12.9287H3.61974C3.70407 12.9287 3.78841 12.8963 3.8468 12.8314L10.9309 5.75376L8.49818 3.32103L1.42055 10.3987C1.35568 10.4635 1.32324 10.5414 1.32324 10.6322ZM12.8122 3.87245C12.8724 3.81243 12.9201 3.74114 12.9526 3.66266C12.9852 3.58419 13.0019 3.50006 13.0019 3.41509C13.0019 3.33013 12.9852 3.246 12.9526 3.16752C12.9201 3.08905 12.8724 3.01776 12.8122 2.95774L11.2942 1.43972C11.2342 1.37958 11.1629 1.33186 11.0844 1.29931C11.0059 1.26676 10.9218 1.25 10.8368 1.25C10.7519 1.25 10.6677 1.26676 10.5893 1.29931C10.5108 1.33186 10.4395 1.37958 10.3795 1.43972L9.19232 2.62689L11.625 5.05962L12.8122 3.87245Z\"/>   </mask>   <path class=\"graphic\" d=\"M3.8468 12.8314L3.14001 12.124C3.1275 12.1365 3.11533 12.1493 3.1035 12.1624L3.8468 12.8314ZM10.9309 5.75376L11.6377 6.46119C11.8254 6.27368 11.9308 6.01928 11.9309 5.75399C11.931 5.48869 11.8256 5.23425 11.638 5.04665L10.9309 5.75376ZM8.49818 3.32103L9.20528 2.61392C9.01775 2.42639 8.76339 2.32103 8.49818 2.32103C8.23296 2.32103 7.97861 2.42639 7.79107 2.61392L8.49818 3.32103ZM1.42055 10.3987L2.12766 11.1058L1.42055 10.3987ZM12.8122 2.95774L12.1051 3.66485L12.1058 3.66557L12.8122 2.95774ZM11.2942 1.43972L10.5864 2.1461L10.5871 2.14682L11.2942 1.43972ZM10.8368 1.25V0.25V1.25ZM10.3795 1.43972L11.0866 2.14682L11.0873 2.1461L10.3795 1.43972ZM9.19232 2.62689L8.48521 1.91978C8.09469 2.31031 8.09469 2.94347 8.48521 3.334L9.19232 2.62689ZM11.625 5.05962L10.9179 5.76673C11.1055 5.95426 11.3598 6.05962 11.625 6.05962C11.8903 6.05962 12.1446 5.95426 12.3322 5.76673L11.625 5.05962ZM0.323242 10.6322V12.6043H2.32324V10.6322H0.323242ZM0.323242 12.6043C0.323242 13.3383 0.913678 13.9287 1.64761 13.9287V11.9287C2.01825 11.9287 2.32324 12.2337 2.32324 12.6043H0.323242ZM1.64761 13.9287H3.61974V11.9287H1.64761V13.9287ZM3.61974 13.9287C3.95128 13.9287 4.31908 13.8015 4.59009 13.5003L3.1035 12.1624C3.25774 11.991 3.45687 11.9287 3.61974 11.9287V13.9287ZM4.55358 13.5388L11.6377 6.46119L10.2241 5.04633L3.14001 12.124L4.55358 13.5388ZM11.638 5.04665L9.20528 2.61392L7.79107 4.02814L10.2238 6.46087L11.638 5.04665ZM7.79107 2.61392L0.713445 9.69155L2.12766 11.1058L9.20528 4.02814L7.79107 2.61392ZM0.713445 9.69155C0.463178 9.94181 0.323242 10.2731 0.323242 10.6322H2.32324C2.32324 10.7086 2.30901 10.7982 2.27065 10.8903C2.23237 10.9822 2.17941 11.054 2.12766 11.1058L0.713445 9.69155ZM13.5186 4.58028C13.6718 4.42738 13.7934 4.24576 13.8763 4.04582L12.0289 3.27951C12.0468 3.23653 12.0729 3.19749 12.1058 3.16462L13.5186 4.58028ZM13.8763 4.04582C13.9592 3.84588 14.0019 3.63155 14.0019 3.41509H12.0019C12.0019 3.36856 12.0111 3.32249 12.0289 3.27951L13.8763 4.04582ZM14.0019 3.41509C14.0019 3.19864 13.9592 2.9843 13.8763 2.78437L12.0289 3.55068C12.0111 3.5077 12.0019 3.46163 12.0019 3.41509H14.0019ZM13.8763 2.78437C13.7934 2.58443 13.6718 2.40281 13.5186 2.24991L12.1058 3.66557C12.0729 3.6327 12.0468 3.59366 12.0289 3.55068L13.8763 2.78437ZM13.5193 2.25063L12.0013 0.73261L10.5871 2.14682L12.1051 3.66485L13.5193 2.25063ZM12.002 0.733335C11.8491 0.58012 11.6675 0.458565 11.4676 0.375628L10.7013 2.22299C10.6583 2.20517 10.6192 2.17903 10.5864 2.1461L12.002 0.733335ZM11.4676 0.375628C11.2676 0.29269 11.0533 0.25 10.8368 0.25V2.25C10.7903 2.25 10.7442 2.24082 10.7013 2.22299L11.4676 0.375628ZM10.8368 0.25C10.6204 0.25 10.4061 0.29269 10.2061 0.375628L10.9724 2.22299C10.9294 2.24082 10.8834 2.25 10.8368 2.25V0.25ZM10.2061 0.375628C10.0062 0.458565 9.82456 0.58012 9.67166 0.733335L11.0873 2.1461C11.0545 2.17903 11.0154 2.20517 10.9724 2.22299L10.2061 0.375628ZM9.67238 0.73261L8.48521 1.91978L9.89942 3.334L11.0866 2.14682L9.67238 0.73261ZM8.48521 3.334L10.9179 5.76673L12.3322 4.35251L9.89942 1.91978L8.48521 3.334ZM12.3322 5.76673L13.5193 4.57955L12.1051 3.16534L10.9179 4.35251L12.3322 5.76673Z\" fill=\"#161616\" mask=\"url(#path-1-outside-1)\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 13783:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#AEB7B8\" fill-rule=\"nonzero\" d=\"M5.544 13.474L2.5 10.451l9.086-8.865a2 2 0 0 1 2.828 2.828l-8.87 9.06zM2 11l3 3H2z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 55782:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M12 3a1 1 0 0 1 1 1v1h5a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-5v1a1 1 0 0 1-2 0v-1H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h5V4a1 1 0 0 1 1-1zm0 14h6a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 47529:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M20 3a1 1 0 0 1 1 1v16a1 1 0 0 1-2 0v-1.171A2.983 2.983 0 0 1 18 19H6c-.351 0-.687-.06-1-.171V20a1 1 0 0 1-2 0V4a1 1 0 0 1 2 0v1.171A2.983 2.983 0 0 1 6 5h12c.351 0 .687.06 1 .171V4a1 1 0 0 1 1-1zM5 8v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 54970:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M5 4a1 1 0 0 0-2 0v16a1 1 0 0 0 2 0V4zm5 1a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3h-8zM9 8a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V8z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 51093:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M21 4a1 1 0 0 0-2 0v16a1 1 0 0 0 2 0V4zM6 5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H6zM5 8a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V8z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 99474:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"11","viewBox":"0 0 11 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<rect class=\"graphic\" width=\"11\" height=\"11\" rx=\"1\" fill=\"#5C6061\"/>   <path class=\"graphic_stroke_bg\" d=\"M4.5 3L2 5.5L4.5 8\" stroke=\"white\"/>   <path class=\"graphic_stroke_bg\" d=\"M6.5 3L9 5.5L6.5 8\" stroke=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 26258:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"8","viewBox":"0 0 14 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.18725 1.08312C4.41726 0.795615 4.37064 0.376087 4.08313 0.146081C3.79563 -0.0839249 3.3761 -0.0373104 3.14609 0.250198L0.487778 3.57309C0.450835 3.61733 0.420376 3.66551 0.396556 3.71628C0.354065 3.80646 0.333253 3.90345 0.333313 4C0.333253 4.09654 0.354066 4.19353 0.396557 4.28371C0.420375 4.33447 0.450831 4.38266 0.48777 4.42689L3.14609 7.74979C3.3761 8.0373 3.79563 8.08391 4.08313 7.85391C4.37064 7.6239 4.41726 7.20437 4.18725 6.91686L1.85376 4L4.18725 1.08312ZM10.8539 0.250197C10.6239 -0.0373106 10.2044 -0.0839248 9.91687 0.146081C9.62937 0.376088 9.58275 0.795616 9.81276 1.08312L12.1463 3.99999L9.81276 6.91686C9.58275 7.20437 9.62937 7.6239 9.91687 7.85391C10.2044 8.08391 10.6239 8.0373 10.8539 7.74979L13.5123 4.42677C13.5485 4.38342 13.5785 4.33628 13.6021 4.28663C13.6455 4.19563 13.6668 4.09758 13.6667 3.99999C13.6668 3.90241 13.6455 3.80436 13.6021 3.71336C13.5785 3.66371 13.5485 3.61656 13.5123 3.57321L10.8539 0.250197Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 80648:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"36","height":"28","viewBox":"0 0 36 28"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h36v28H0z\"/>         <rect class=\"graphic\" width=\"32\" height=\"26\" x=\"2\" y=\"1\" fill=\"#9DA5A6\" rx=\"2\"/>         <rect class=\"grachic-background\" width=\"30\" height=\"24\" x=\"3\" y=\"2\" fill=\"#FFF\" rx=\"1\"/>         <path class=\"graphic\" fill=\"#9DA5A6\" fill-rule=\"nonzero\" d=\"M18.75 18.833l-2.395 3.222a1 1 0 1 1-1.605-1.193l.907-1.22a2.006 2.006 0 0 1-.064-.055s-3.02-2.673-3.024-2.668L7.744 22.29a1 1 0 0 1-1.488-1.336l4.826-5.372a2.013 2.013 0 0 1 2.825-.169l2.945 2.618.296-.395.928-1.248a1.01 1.01 0 0 1 .077-.092l3.45-4.6a1.88 1.88 0 0 1 2.812-.25l6.264 5.796a1 1 0 1 1-1.358 1.468l-6.186-5.723-4.385 5.846zM10 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 91027:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 47346:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M1.58755 6.14294C1.87625 5.91558 2.29436 5.96478 2.52245 6.25257L2.52342 6.2538C2.52359 6.25401 2.52376 6.25424 2 6.66669L1.47625 7.07915C1.24845 6.78989 1.29828 6.37073 1.58755 6.14294Z\" fill=\"currentColor\"></path> \t<path d=\"M9.47877 9.87784C9.01604 9.95562 8.52288 10 8 10C7.47713 10 6.98397 9.95562 6.52124 9.87784L5.96579 11.5442C5.84936 11.8935 5.47181 12.0822 5.12252 11.9658C4.77322 11.8494 4.58445 11.4718 4.70088 11.1225L5.22344 9.55486C4.60376 9.34849 4.05847 9.08881 3.59023 8.81654L2.5547 10.3698C2.35047 10.6762 1.93656 10.759 1.6302 10.5547C1.32385 10.3505 1.24107 9.93658 1.4453 9.63023L2.49117 8.06143C2.26463 7.87906 2.0757 7.70812 1.92497 7.56196C1.78355 7.42483 1.67517 7.30893 1.60034 7.22504C1.56291 7.18308 1.53382 7.14905 1.51313 7.12431C1.50278 7.11194 1.49453 7.10188 1.48838 7.0943L1.48074 7.08481L1.4781 7.08149L1.47707 7.0802L1.47625 7.07915C1.47605 7.0789 1.47625 7.07915 2 6.66669L2.52342 6.2538L2.52391 6.25439L2.53595 6.26897C2.54793 6.28329 2.56776 6.30656 2.59537 6.33751C2.65062 6.39946 2.73677 6.49189 2.85316 6.60476C3.08633 6.83086 3.43844 7.13659 3.90413 7.44322C4.83433 8.0557 6.20884 8.66669 8 8.66669C9.79117 8.66669 11.1657 8.0557 12.0959 7.44322C12.5616 7.13659 12.9137 6.83086 13.1468 6.60476C13.2632 6.49189 13.3494 6.39946 13.4046 6.33751C13.4322 6.30656 13.4521 6.28329 13.4641 6.26897L13.4761 6.25439L13.4766 6.2538L13.4775 6.25261C13.7056 5.96479 14.1237 5.91557 14.4125 6.14294C14.7017 6.37073 14.7516 6.78989 14.5238 7.07915L14.031 6.69109C14.5238 7.07916 14.524 7.07891 14.5238 7.07915L14.5229 7.0802L14.5219 7.08149L14.5193 7.08481L14.5116 7.0943C14.5055 7.10188 14.4972 7.11194 14.4869 7.12431C14.4662 7.14905 14.4371 7.18308 14.3997 7.22504C14.3248 7.30893 14.2165 7.42483 14.075 7.56196C13.9243 7.70812 13.7354 7.87906 13.5088 8.06143L14.5547 9.63023C14.7589 9.93658 14.6762 10.3505 14.3698 10.5547C14.0635 10.759 13.6495 10.6762 13.4453 10.3698L12.4098 8.81654C11.9415 9.08881 11.3963 9.34849 10.7766 9.55486L11.2991 11.1225C11.4156 11.4718 11.2268 11.8494 10.8775 11.9658C10.5282 12.0822 10.1506 11.8935 10.0342 11.5442L9.47877 9.87784Z\" fill=\"currentColor\"></path>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 75259:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"17","height":"16","viewBox":"0 0 17 16","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.50004 5.3335C7.02728 5.3335 5.83338 6.5274 5.83338 8.00016C5.83338 9.47292 7.02728 10.6668 8.50004 10.6668C9.9728 10.6668 11.1667 9.47292 11.1667 8.00016C11.1667 6.5274 9.9728 5.3335 8.50004 5.3335ZM7.16671 8.00016C7.16671 7.26378 7.76366 6.66683 8.50004 6.66683C9.23642 6.66683 9.83338 7.26378 9.83338 8.00016C9.83338 8.73654 9.23642 9.3335 8.50004 9.3335C7.76366 9.3335 7.16671 8.73654 7.16671 8.00016Z\" fill=\"currentColor\"></path> \t<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.0545 7.63C15.0546 7.63019 15.0547 7.63036 14.5 8.00016C15.0547 8.36996 15.0546 8.37013 15.0545 8.37032L15.0534 8.37195L15.0511 8.37539L15.0435 8.38655C15.0372 8.39586 15.0283 8.40888 15.0169 8.42535C14.994 8.45829 14.961 8.50509 14.9184 8.56377C14.8332 8.68107 14.7093 8.84625 14.5505 9.04338C14.2337 9.43662 13.7739 9.96229 13.2022 10.49C12.082 11.5241 10.4231 12.6668 8.50004 12.6668C6.57701 12.6668 4.91814 11.5241 3.79786 10.49C3.22614 9.96229 2.7664 9.43662 2.44962 9.04338C2.29082 8.84625 2.16688 8.68107 2.0817 8.56377C2.03909 8.50509 2.0061 8.45829 1.98322 8.42535C1.97179 8.40888 1.96287 8.39586 1.95654 8.38655L1.94898 8.37539L1.94667 8.37195L1.94588 8.37077C1.94576 8.37059 1.94534 8.36996 2.50004 8.00016C1.94534 7.63036 1.94546 7.63019 1.94558 7.63L1.94667 7.62838L1.94898 7.62494L1.95654 7.61377C1.96287 7.60446 1.97179 7.59145 1.98322 7.57498C2.0061 7.54204 2.03909 7.49524 2.0817 7.43656C2.16688 7.31926 2.29082 7.15408 2.44962 6.95694C2.7664 6.5637 3.22614 6.03803 3.79786 5.51029C4.91814 4.47619 6.57701 3.3335 8.50004 3.3335C10.4231 3.3335 12.082 4.47619 13.2022 5.51029C13.7739 6.03803 14.2337 6.5637 14.5505 6.95694C14.7093 7.15408 14.8332 7.31926 14.9184 7.43656C14.961 7.49524 14.994 7.54204 15.0169 7.57498C15.0283 7.59145 15.0372 7.60446 15.0435 7.61377L15.0511 7.62494L15.0534 7.62838L15.0545 7.63ZM3.48796 8.20694C3.42779 8.13225 3.37342 8.06295 3.32512 8.00016C3.37342 7.93738 3.42779 7.86807 3.48796 7.79338C3.77535 7.43662 4.19061 6.96229 4.70223 6.49003C5.74862 5.52414 7.08975 4.66683 8.50004 4.66683C9.91034 4.66683 11.2515 5.52414 12.2979 6.49003C12.8095 6.96229 13.2247 7.43662 13.5121 7.79338C13.5723 7.86807 13.6267 7.93738 13.675 8.00016C13.6267 8.06295 13.5723 8.13225 13.5121 8.20694C13.2247 8.5637 12.8095 9.03803 12.2979 9.51029C11.2515 10.4762 9.91034 11.3335 8.50004 11.3335C7.08975 11.3335 5.74862 10.4762 4.70223 9.51029C4.19061 9.03803 3.77535 8.5637 3.48796 8.20694Z\" fill=\"currentColor\"></path> \t<path d=\"M14.5 8.00016L15.0545 7.63C15.2038 7.85394 15.2038 8.14639 15.0545 8.37032L14.5 8.00016Z\" fill=\"currentColor\" fill-opacity=\"0.54\"></path><path d=\"M1.94558 7.63L2.50004 8.00016L1.94534 8.36996C1.79605 8.14603 1.79629 7.85394 1.94558 7.63Z\" fill=\"currentColor\"></path>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 84581:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<path class=\"graphic\" fill=\"#5C6061\" fill-rule=\"evenodd\" d=\"M5 2.667c-1.971 0-3.667 1.648-3.667 3.791 0 1.909.526 3.003 1.986 4.524.166.173.36.35.578.533.384.32.844.651 1.364.991a28.457 28.457 0 0 0 2.435 1.42c.19.098.417.098.608 0l.213-.111a30.197 30.197 0 0 0 2.222-1.308c.52-.34.98-.673 1.364-.992.219-.182.412-.36.578-.533 1.46-1.52 1.986-2.615 1.986-4.524 0-2.143-1.696-3.791-3.667-3.791-1.035 0-2.156.456-3 1.12-.844-.664-1.965-1.12-3-1.12zm3.49 2.466C9.116 4.493 10.146 4 11 4c1.243 0 2.333 1.06 2.333 2.458 0 1.53-.374 2.31-1.614 3.601a5.78 5.78 0 0 1-.47.431c-.34.283-.76.586-1.24.9A27.154 27.154 0 0 1 8 12.58a29.668 29.668 0 0 1-2.01-1.19c-.48-.314-.9-.617-1.24-.9a5.78 5.78 0 0 1-.47-.43C3.042 8.767 2.668 7.986 2.668 6.457 2.667 5.06 3.757 4 5 4c.854 0 1.884.494 2.51 1.133a.665.665 0 0 0 .49.2.665.665 0 0 0 .49-.2z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 23953:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M14 4C14 2.89543 13.1046 2 12 2H4C2.89543 2 2 2.89543 2 4V9.33333C2 10.4379 2.89543 11.3333 4 11.3333V13.3333C4 13.5896 4.1469 13.8232 4.37787 13.9342C4.60885 14.0452 4.88302 14.014 5.08313 13.8539L8.05124 11.4794C8.16945 11.3849 8.31633 11.3333 8.46771 11.3333H12C13.1046 11.3333 14 10.4379 14 9.33333V4ZM12 3.33333C12.3682 3.33333 12.6667 3.63181 12.6667 4V9.33333C12.6667 9.70152 12.3682 10 12 10H8.46771C8.01357 10 7.57294 10.1546 7.21832 10.4383L5.33333 11.9463V10.6667C5.33333 10.2985 5.03486 10 4.66667 10H4C3.63181 10 3.33333 9.70152 3.33333 9.33333V4C3.33333 3.63181 3.63181 3.33333 4 3.33333H12Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 83763:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M4 4C4 5.10457 4.89543 6 6 6H8V2H6C4.89543 2 4 2.89543 4 4Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M8 2V6H10C11.1046 6 12 5.10457 12 4C12 2.89543 11.1046 2 10 2H8Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M4 8C4 6.89543 4.89543 6 6 6H8V10H6C4.89543 10 4 9.10457 4 8Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M4 12C4 10.8954 4.89543 10 6 10H8V12C8 13.1046 7.10457 14 6 14C4.89543 14 4 13.1046 4 12Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M8 8C8 6.89543 8.89543 6 10 6C11.1046 6 12 6.89543 12 8C12 9.10457 11.1046 10 10 10C8.89543 10 8 9.10457 8 8Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 42020:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<g id=\"file-check-alt-svgrepo-com 1\"> <path id=\"Vector\" d=\"M10.0002 12.6667L11.3335 14L14.0002 11.3333M8.66683 2H5.46683C4.7201 2 4.34672 2 4.06151 2.14533C3.81062 2.27315 3.60665 2.47713 3.47882 2.72801C3.3335 3.01323 3.3335 3.3866 3.3335 4.13333V11.8667C3.3335 12.6134 3.3335 12.9868 3.47882 13.272C3.60665 13.5229 3.81062 13.7269 4.06151 13.8547C4.34672 14 4.7201 14 5.46683 14H7.66683M8.66683 2L12.6668 6M8.66683 2V4.93333C8.66683 5.3067 8.66683 5.49339 8.7395 5.63599C8.80343 5.76143 8.90536 5.86342 9.03083 5.92734C9.17343 6 9.3601 6 9.7335 6H12.6668M12.6668 6V8.93333M6.00016 11.3333H7.66683M6.00016 8.66667H10.0002M6.00016 6H6.66683\" stroke=\"#737373\" stroke-width=\"1.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/> </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 62012:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M5.33329 11.3334C5.33329 10.9652 5.63177 10.6667 5.99996 10.6667H9.99996C10.3681 10.6667 10.6666 10.9652 10.6666 11.3334C10.6666 11.7016 10.3681 12 9.99996 12H5.99996C5.63177 12 5.33329 11.7016 5.33329 11.3334Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M5.99996 8.00004C5.63177 8.00004 5.33329 8.29852 5.33329 8.66671C5.33329 9.0349 5.63177 9.33337 5.99996 9.33337H9.99996C10.3681 9.33337 10.6666 9.0349 10.6666 8.66671C10.6666 8.29852 10.3681 8.00004 9.99996 8.00004H5.99996Z\" fill=\"black\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.3333 6.00531V12.6667C13.3333 13.7713 12.4379 14.6667 11.3333 14.6667H4.66663C3.56206 14.6667 2.66663 13.7713 2.66663 12.6667V3.33337C2.66663 2.2288 3.56206 1.33337 4.66663 1.33337H8.66139L13.3333 6.00531ZM7.99996 2.66671H4.66663C4.29844 2.66671 3.99996 2.96518 3.99996 3.33337V12.6667C3.99996 13.0349 4.29844 13.3334 4.66663 13.3334H11.3333C11.7015 13.3334 12 13.0349 12 12.6667V6.66671H8.66663C8.29844 6.66671 7.99996 6.36823 7.99996 6.00004V2.66671ZM9.33329 5.33337V3.60952L11.0571 5.33337H9.33329Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 51392:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M6 5a1 1 0 0 1 1-1h1v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-.586l3.707 3.707a1 1 0 0 1 .293.707V19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5zm6-1h-2v2h2V4zM7 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V9.828a3 3 0 0 0-.879-2.121l-4.828-4.828A3 3 0 0 0 12.172 2H7zm3 12a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm-1-3a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 7086:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M11.522 4.72a4.433 4.433 0 0 1 6.269 6.269l-4.924 4.925-.886.885a2.745 2.745 0 1 1-3.882-3.882l4.595-4.595a1 1 0 1 1 1.414 1.415L9.513 14.33a.746.746 0 0 0 1.054 1.054l.219-.22a.015.015 0 0 0 .004-.003l5.587-5.587a2.433 2.433 0 0 0-3.44-3.44l-.487.486-5.443 5.443a3.667 3.667 0 0 0 0 5.186l.454.454a3.667 3.667 0 0 0 5.186 0l4.714-4.714a1 1 0 1 1 1.414 1.414l-4.714 4.714a5.667 5.667 0 0 1-8.014 0l-.454-.454a5.667 5.667 0 0 1 0-8.014l5.443-5.443.486-.487z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 80124:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.25 4.5C2.25 4.08579 2.58579 3.75 3 3.75H15C15.4142 3.75 15.75 4.08579 15.75 4.5C15.75 4.91421 15.4142 5.25 15 5.25H3C2.58579 5.25 2.25 4.91421 2.25 4.5ZM5.25 9C5.25 8.58579 5.58579 8.25 6 8.25H12C12.4142 8.25 12.75 8.58579 12.75 9C12.75 9.41421 12.4142 9.75 12 9.75H6C5.58579 9.75 5.25 9.41421 5.25 9ZM8.25 12.75C7.83579 12.75 7.5 13.0858 7.5 13.5C7.5 13.9142 7.83579 14.25 8.25 14.25H10.5C10.9142 14.25 11.25 13.9142 11.25 13.5C11.25 13.0858 10.9142 12.75 10.5 12.75H8.25Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 32472:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M4 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6.667a2 2 0 0 0-2-2H9L7.6 2.8A2 2 0 0 0 6 2H4zm3.333 2.667l-.8-1.067A.667.667 0 0 0 6 3.333H4A.667.667 0 0 0 3.333 4v.667h4zm-4 7.333V6H12c.368 0 .667.298.667.667V12a.667.667 0 0 1-.667.667H4A.667.667 0 0 1 3.333 12z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 89129:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"20","height":"18","viewBox":"0 0 20 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 0C5.55228 0 6 0.447715 6 1V2H14V1C14 0.447715 14.4477 0 15 0C15.5523 0 16 0.447715 16 1V2H17C18.6569 2 20 3.34315 20 5V13C20 14.6569 18.6569 16 17 16H16V17C16 17.5523 15.5523 18 15 18C14.4477 18 14 17.5523 14 17V16H6V17C6 17.5523 5.55228 18 5 18C4.44772 18 4 17.5523 4 17V16H3C1.34315 16 0 14.6569 0 13V5C0 3.34315 1.34315 2 3 2H4V1C4 0.447715 4.44772 0 5 0ZM17 14C17.5523 14 18 13.5523 18 13V5C18 4.44772 17.5523 4 17 4H3C2.44772 4 2 4.44772 2 5V13C2 13.5523 2.44772 14 3 14H17Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 71492:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"9","viewBox":"0 0 11 9","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M7.40109 4.92674C6.97185 4.92674 6.62391 5.36322 6.62391 5.89976C6.62391 6.43738 6.97185 6.87386 7.40109 6.87386C7.83033 6.87386 8.17826 6.43738 8.17826 5.89976C8.17766 5.36322 7.83033 4.92674 7.40109 4.92674ZM10.1068 2.39387C10.1959 2.19645 10.1995 1.0747 9.72723 0C9.72723 0 8.64456 0.107632 7.00652 1.125C6.66277 1.03846 6.08109 0.996274 5.5006 0.996274C4.91891 0.996274 4.33783 1.03846 3.99408 1.125C2.35543 0.107632 1.27277 0 1.27277 0C0.801087 1.0747 0.80587 2.19645 0.89375 2.39387C0.338967 2.93906 0 3.59405 0 4.48756C0 8.37422 3.56484 8.43642 4.46397 8.43642L5.5006 8.4375L6.53603 8.43642C7.43636 8.43642 11 8.37422 11 4.48756C11 3.59405 10.6616 2.93906 10.1068 2.39387ZM5.51674 7.95884H5.48326C3.22886 7.95884 1.47245 7.71599 1.47245 5.73317C1.47245 5.25775 1.65777 4.81749 2.09837 4.45186C2.8319 3.84231 4.07418 4.16466 5.48326 4.16466H5.51674C6.92581 4.16466 8.1687 3.84231 8.90283 4.45186C9.34223 4.81749 9.52755 5.25775 9.52755 5.73317C9.52755 7.71599 7.77174 7.95884 5.51674 7.95884ZM3.59951 4.92674C3.17027 4.92674 2.82234 5.36322 2.82234 5.89976C2.82234 6.43738 3.17027 6.87386 3.59951 6.87386C4.02935 6.87386 4.37728 6.43738 4.37728 5.89976C4.37728 5.36322 4.02935 4.92674 3.59951 4.92674Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 55551:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 0.666656H4L8 7.33332H11.6667L8 0.666656ZM5.66667 4.99999L3.66667 1.66666L0 7.99999L2 11.3333L5.66667 4.99999ZM12 7.99999H4.66667L2.66667 11.3333H10.3333L12 7.99999Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 517:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"12","viewBox":"0 0 11 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M7.23684 2.78571C7.23684 3.08571 7.35263 3.34286 7.57263 3.55179C7.78684 3.76071 8.05895 3.85714 8.39474 3.85714C8.71316 3.85714 8.97368 3.76071 9.21105 3.55179C9.43684 3.34286 9.55263 3.08571 9.55263 2.78571C9.55263 2.50179 9.43684 2.25 9.19947 2.03036C8.97368 1.81607 8.68421 1.71429 8.39474 1.71429C8.07632 1.71429 7.81579 1.81607 7.58421 2.03036C7.35842 2.25 7.23684 2.50179 7.23684 2.78571ZM11 2.78571C11 3.32143 10.7742 3.95893 10.34 4.69286C9.90579 5.43214 9.47158 6.03214 9.03737 6.50357L8.39474 7.20536C8.18632 7.00714 7.94316 6.74464 7.65368 6.42857C7.36421 6.10714 6.97632 5.55536 6.50158 4.76786C6.02105 3.98036 5.78947 3.32143 5.78947 2.78571C5.78947 2.11607 6.03263 1.54821 6.54211 1.07679C7.04579 0.610714 7.65947 0.375 8.39474 0.375C9.10684 0.375 9.72632 0.610714 10.23 1.07679C10.7395 1.54821 11 2.11607 11 2.78571ZM10.4211 6.57857V10.5536C10.4211 10.8214 10.3053 11.0893 10.0679 11.2982C9.8421 11.5179 9.55263 11.625 9.26316 11.625H1.15789C0.868421 11.625 0.578947 11.5179 0.353158 11.2982C0.115789 11.0893 0 10.8214 0 10.5536V3.05357C0 2.78571 0.115789 2.51786 0.353158 2.30893C0.578947 2.08929 0.868421 1.98214 1.15789 1.98214H4.74737C4.67789 2.31964 4.63158 2.5875 4.63158 2.78571C4.63158 3.42321 4.88632 4.17321 5.37263 5.03571C5.86474 5.89286 6.27579 6.53571 6.60579 6.91607C6.94737 7.3125 7.25421 7.65 7.54368 7.93393L8.39474 8.78571L9.26316 7.93393C9.99842 7.07143 10.3863 6.61071 10.4211 6.57857ZM3.47368 8.14286V8.8875H4.77632C4.63158 9.48214 4.19737 9.76607 3.47368 9.76607C3.07421 9.76607 2.73842 9.63214 2.47211 9.36429C2.20419 9.10924 2.05638 8.76637 2.06105 8.41071C2.06105 8.04107 2.2 7.725 2.47211 7.45714C2.73842 7.18929 3.07421 7.05536 3.47368 7.05536C3.85579 7.05536 4.16263 7.1625 4.39421 7.38214L5.01947 6.83036C4.58526 6.46071 4.08158 6.26786 3.50263 6.26786H3.47368C2.84263 6.26786 2.29842 6.4875 1.84684 6.90536C1.39526 7.32321 1.15789 7.82679 1.15789 8.41071C1.15789 8.99464 1.39526 9.49821 1.84684 9.91607C2.29842 10.3339 2.84263 10.5536 3.47368 10.5536C4.14526 10.5536 4.68368 10.3554 5.08895 9.96964C5.5 9.58393 5.69684 9.08036 5.69684 8.45893C5.69684 8.30893 5.69105 8.20179 5.67368 8.14286H3.47368Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 1305:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M6 5a1 1 0 0 0-2 0v14a1 1 0 0 0 2 0v-6h4v6a1 1 0 0 0 2 0V5a1 1 0 0 0-2 0v6H6V5zm9 7a1 1 0 0 1 1 1v5h3a1 1 0 0 1 0 2h-4a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 41701:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M5 4a1 1 0 0 1 1 1v6h4V5a1 1 0 0 1 2 0v14a1 1 0 0 1-2 0v-6H6v6a1 1 0 0 1-2 0V5a1 1 0 0 1 1-1zm16.371 8.071a.997.997 0 0 0-1.18.341L18 15.333l-2.193-2.924-.041-.052a.99.99 0 0 0-.711-.356 1.019 1.019 0 0 0-.698.233.99.99 0 0 0-.356.711l-.001.067V19a1 1 0 0 0 2 0v-3l1.186 1.581a.997.997 0 0 0 1.628 0L20 16v3a1 1 0 0 0 2 0v-5.985a.997.997 0 0 0-.629-.944z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 70191:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M6 5a1 1 0 0 0-2 0v14a1 1 0 0 0 2 0v-6h4v6a1 1 0 0 0 2 0V5a1 1 0 0 0-2 0v6H6V5zm11 7a1 1 0 0 0 0 2h.003a3 3 0 1 1-2.559 4.572 1 1 0 0 1 1.703-1.049A1 1 0 1 0 17 16h-.003a3 3 0 1 1 1.988-5.25 1.001 1.001 0 0 1-1.324 1.5A.994.994 0 0 0 17 12z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 81740:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M14.701 3.279a3 3 0 1 1 4.76 3.653L10.96 18.01a3 3 0 0 1-3.252 1.045L7 20h12a1 1 0 0 1 0 2H5a1 1 0 0 1-.794-1.609l1.891-2.52a3.002 3.002 0 0 1 .102-3.512l6.373-8.305L11.7 5.4 9.3 8.6a1 1 0 1 1-1.6-1.2l2.997-3.996.003-.004a1 1 0 0 1 1.4-.2l.002.001 1.687 1.266.912-1.188zM7.786 15.576l6.386-8.322 1.6 1.2-6.399 8.34a1 1 0 0 1-1.376.204l-.034-.026a1 1 0 0 1-.177-1.396zm10.089-9.862l-.885 1.153-1.6-1.2.898-1.17a1 1 0 1 1 1.587 1.217z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 82052:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M7.33337 5.33337C7.33337 4.96518 7.63185 4.66671 8.00004 4.66671C8.36823 4.66671 8.66671 4.96518 8.66671 5.33337V8.66671C8.66671 9.0349 8.36823 9.33337 8.00004 9.33337C7.63185 9.33337 7.33337 9.0349 7.33337 8.66671V5.33337Z\" fill=\"black\"/>     <path class=\"graphic\" d=\"M8.00004 10.6667C7.63185 10.6667 7.33337 10.9652 7.33337 11.3334C7.33337 11.7016 7.63185 12 8.00004 12C8.36823 12 8.66671 11.7016 8.66671 11.3334C8.66671 10.9652 8.36823 10.6667 8.00004 10.6667Z\" fill=\"black\"/>     <path class=\"graphic\" d=\"M1.33337 8.00004C1.33337 11.6819 4.31814 14.6667 8.00004 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8.00004C14.6667 4.31814 11.6819 1.33337 8.00004 1.33337C4.31814 1.33337 1.33337 4.31814 1.33337 8.00004ZM8.00004 13.3334C5.05452 13.3334 2.66671 10.9456 2.66671 8.00004C2.66671 5.05452 5.05452 2.66671 8.00004 2.66671C10.9456 2.66671 13.3334 5.05452 13.3334 8.00004C13.3334 10.9456 10.9456 13.3334 8.00004 13.3334Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 28444:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 0.666626C8.36819 0.666626 8.66667 0.965103 8.66667 1.33329V3.33329H10.3831C10.6982 3.33329 10.8374 3.73008 10.5913 3.92692L8.20823 5.83337C8.08649 5.93077 7.91351 5.93077 7.79177 5.83337L5.4087 3.92692C5.16265 3.73008 5.30183 3.33329 5.61693 3.33329H7.33333V1.33329C7.33333 0.965103 7.63181 0.666626 8 0.666626ZM2 7.99996C2 7.63177 2.29848 7.33329 2.66667 7.33329H13.3333C13.7015 7.33329 14 7.63177 14 7.99996C14 8.36815 13.7015 8.66663 13.3333 8.66663H2.66667C2.29848 8.66663 2 8.36815 2 7.99996ZM7.33333 12.6666H5.61693C5.30183 12.6666 5.16265 12.2698 5.4087 12.073L7.79177 10.1665C7.91351 10.0692 8.08649 10.0692 8.20823 10.1665L10.5913 12.073C10.8374 12.2698 10.6982 12.6666 10.3831 12.6666H8.66667V14.6666C8.66667 15.0348 8.36819 15.3333 8 15.3333C7.63181 15.3333 7.33333 15.0348 7.33333 14.6666V12.6666Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 91527:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.8047 7.5286C14.0651 7.78895 14.0651 8.21106 13.8047 8.4714L8.66588 13.3658C8.66579 13.3676 8.6657 13.3694 8.6656 13.3712L13.8047 8.4714L8.47141 13.8047C8.3428 13.9333 8.17471 13.9984 8.00615 14C8.0041 14 8.00205 14 8 14C7.98934 14 7.97867 13.9997 7.96802 13.9992C7.80822 13.9916 7.65063 13.9268 7.5286 13.8047L2.19526 8.4714C1.93491 8.21106 1.93491 7.78895 2.19526 7.5286C2.45561 7.26825 2.87772 7.26825 3.13807 7.5286L7.33333 11.7239V2.66667C7.33333 2.29848 7.63181 2 8 2C8.36819 2 8.66667 2.29848 8.66667 2.66667V11.7239L12.8619 7.5286C13.1223 7.26825 13.5444 7.26825 13.8047 7.5286Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 79611:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.19526 8.4714C1.93491 8.21106 1.93491 7.78895 2.19526 7.5286L7.33412 2.6342C7.33421 2.63239 7.3343 2.63057 7.33441 2.62876L2.19526 7.5286L7.5286 2.19526C7.65721 2.06665 7.82529 2.00157 7.99385 2.00003C7.9959 2.00001 7.99795 2 8 2C8.01066 2 8.02133 2.00025 8.03198 2.00076C8.19178 2.00839 8.34937 2.07322 8.4714 2.19526L13.8047 7.5286C14.0651 7.78895 14.0651 8.21106 13.8047 8.4714C13.5444 8.73175 13.1223 8.73175 12.8619 8.4714L8.66667 4.27614V13.3333C8.66667 13.7015 8.36819 14 8 14C7.63181 14 7.33333 13.7015 7.33333 13.3333V4.27614L3.13807 8.4714C2.87772 8.73175 2.45561 8.73175 2.19526 8.4714Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 66995:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M8 6.586l5.293-5.293a1 1 0 0 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 1 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 1 1 1.414-1.414L8 6.586z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 5952:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M6.25914 3.9476C6.53567 3.83076 6.76197 3.65513 6.94152 3.49539C7.05669 3.39292 7.18212 3.26868 7.28932 3.16249C7.33767 3.1146 7.38234 3.07035 7.42066 3.03346C7.72916 2.73646 7.87696 2.66683 7.99967 2.66683C8.09746 2.66683 8.24753 2.7344 8.57809 3.04753C8.61723 3.0846 8.66154 3.12761 8.70899 3.17367C8.82054 3.28196 8.94953 3.40718 9.0694 3.51161C9.24876 3.66788 9.47719 3.84252 9.75208 3.95248C10.0252 4.06172 10.3022 4.09263 10.5326 4.10266C10.6773 4.10897 10.8469 4.10721 10.9899 4.10573C11.0559 4.10505 11.1163 4.10443 11.1659 4.10468C11.5669 4.10673 11.7009 4.15861 11.7791 4.23709C11.8336 4.2919 11.8827 4.39992 11.8812 4.81614C11.8811 4.85816 11.8804 4.90545 11.8797 4.9563C11.8776 5.10852 11.8751 5.29266 11.8843 5.46209C11.8973 5.70032 11.9346 5.98124 12.0522 6.25963C12.1691 6.53616 12.3447 6.76246 12.5044 6.94201C12.6069 7.05718 12.7312 7.1826 12.8373 7.28981C12.8852 7.33817 12.9295 7.38282 12.9664 7.42115C13.2634 7.72964 13.333 7.87744 13.333 8.00016C13.333 8.12288 13.2634 8.27068 12.9664 8.57917C12.9295 8.61749 12.8853 8.66211 12.8374 8.71044C12.7312 8.81765 12.6069 8.94315 12.5044 9.05832C12.3447 9.23787 12.1691 9.46416 12.0522 9.7407C11.9346 10.019 11.8975 10.2999 11.8848 10.5379C11.8757 10.7075 11.8785 10.8916 11.8808 11.0437C11.8815 11.0943 11.8822 11.1414 11.8824 11.1832C11.8844 11.5993 11.8355 11.7065 11.7818 11.7605C11.7048 11.8379 11.5913 11.8842 11.202 11.883C11.1589 11.8828 11.1104 11.8818 11.0574 11.8806C10.7252 11.8735 10.2154 11.8625 9.75208 12.0478C9.47719 12.1578 9.24876 12.3324 9.0694 12.4887C8.94954 12.5931 8.82065 12.7183 8.7091 12.8265C8.66166 12.8726 8.61722 12.9157 8.57809 12.9528C8.24753 13.2659 8.09746 13.3335 7.99967 13.3335C7.87696 13.3335 7.72916 13.2639 7.42066 12.9669C7.38233 12.93 7.33768 12.8857 7.28932 12.8378C7.18212 12.7316 7.05669 12.6074 6.94152 12.5049C6.76197 12.3452 6.53567 12.1696 6.25914 12.0527C5.98025 11.9349 5.69878 11.896 5.45919 11.8814C5.29079 11.8711 5.1072 11.8721 4.95473 11.8729C4.90179 11.8732 4.85257 11.8735 4.80906 11.8732C4.39175 11.871 4.27756 11.8208 4.2176 11.7605C4.16384 11.7065 4.11491 11.5993 4.11692 11.1832C4.11712 11.1414 4.11783 11.0943 4.11859 11.0437C4.12089 10.8916 4.12366 10.7075 4.11458 10.5379C4.10184 10.2999 4.0647 10.019 3.94711 9.7407C3.83027 9.46416 3.65464 9.23787 3.4949 9.05832C3.39244 8.94315 3.2682 8.81773 3.16201 8.71053C3.11411 8.66217 3.06987 8.6175 3.03297 8.57917C2.73598 8.27068 2.66634 8.12288 2.66634 8.00016C2.66634 7.87744 2.73598 7.72964 3.03297 7.42115C3.06987 7.38283 3.11409 7.33818 3.16198 7.28983C3.26817 7.18263 3.39243 7.05718 3.4949 6.94201C3.65464 6.76246 3.83027 6.53616 3.94711 6.25963C4.0647 5.98131 4.10184 5.70046 4.11458 5.46243C4.12366 5.29287 4.12089 5.10878 4.11859 4.95661C4.11783 4.90602 4.11712 4.8589 4.11692 4.81708C4.11491 4.401 4.16384 4.29387 4.2176 4.2398C4.27756 4.17949 4.39175 4.12935 4.80906 4.1271C4.85256 4.12686 4.90175 4.12713 4.9547 4.12741C5.10717 4.12822 5.29078 4.1292 5.45919 4.11894C5.69878 4.10435 5.98025 4.06543 6.25914 3.9476ZM7.99967 1.3335C7.29479 1.3335 6.80122 1.779 6.49593 2.07292C6.42621 2.14003 6.36692 2.19895 6.31221 2.25331C6.22285 2.34211 6.14569 2.41878 6.05525 2.49924C5.92187 2.61791 5.8223 2.68471 5.74021 2.71939C5.65706 2.75452 5.54391 2.77798 5.37814 2.78807C5.25649 2.79548 5.14266 2.79485 5.00772 2.7941C4.94469 2.79375 4.87705 2.79338 4.80186 2.79378C4.40926 2.79591 3.75807 2.81093 3.2721 3.29969C2.78803 3.78653 2.78174 4.43795 2.7836 4.82353C2.78395 4.89557 2.78493 4.9606 2.78585 5.02124C2.7879 5.15689 2.78961 5.2705 2.78316 5.39117C2.77446 5.55369 2.752 5.66237 2.7189 5.7407C2.68422 5.82279 2.61742 5.92236 2.49875 6.05574C2.41829 6.14618 2.34162 6.22333 2.25282 6.3127C2.19846 6.36741 2.13953 6.42671 2.07243 6.49641C1.77852 6.80171 1.33301 7.29528 1.33301 8.00016C1.33301 8.70505 1.77852 9.19862 2.07243 9.50391C2.13954 9.57362 2.19845 9.63291 2.25282 9.68762C2.34161 9.77698 2.4183 9.85415 2.49875 9.94458C2.61742 10.078 2.68422 10.1775 2.7189 10.2596C2.752 10.338 2.77446 10.4466 2.78316 10.6092C2.78961 10.7298 2.7879 10.8434 2.78585 10.9791C2.78493 11.0397 2.78395 11.1048 2.7836 11.1768C2.78174 11.5624 2.78803 12.2138 3.2721 12.7006C3.75807 13.1894 4.40926 13.2044 4.80186 13.2065C4.87704 13.2069 4.94468 13.2066 5.0077 13.2062C5.14265 13.2055 5.25649 13.2048 5.37814 13.2123C5.54391 13.2223 5.65706 13.2458 5.74021 13.2809C5.8223 13.3156 5.92187 13.3824 6.05525 13.5011C6.14569 13.5815 6.22285 13.6582 6.31222 13.747C6.36692 13.8014 6.42623 13.8603 6.49593 13.9274C6.80122 14.2213 7.29479 14.6668 7.99967 14.6668C8.68889 14.6668 9.1945 14.2055 9.49503 13.9208C9.56141 13.8579 9.61946 13.8014 9.67338 13.749C9.76921 13.6558 9.85202 13.5753 9.94526 13.494C10.0825 13.3745 10.1778 13.3136 10.2473 13.2858C10.4395 13.2089 10.6402 13.211 10.9824 13.2146C11.0486 13.2153 11.1201 13.216 11.1978 13.2163C11.6011 13.2175 12.2317 13.199 12.7273 12.7006C13.2113 12.2138 13.2176 11.5624 13.2157 11.1768C13.2154 11.1049 13.2144 11.0399 13.2135 10.9793C13.2115 10.8437 13.2097 10.7298 13.2162 10.6092C13.2249 10.4466 13.2473 10.338 13.2804 10.2596C13.3151 10.1775 13.3819 10.078 13.5006 9.94458C13.5811 9.85415 13.6577 9.77699 13.7465 9.68762C13.8009 9.63292 13.8598 9.57361 13.9269 9.50391C14.2208 9.19862 14.6663 8.70505 14.6663 8.00016C14.6663 7.29528 14.2208 6.80171 13.9269 6.49641C13.8598 6.42671 13.8009 6.36744 13.7466 6.31273C13.6578 6.22336 13.5811 6.14618 13.5006 6.05574C13.3819 5.92236 13.3151 5.82279 13.2804 5.7407C13.2471 5.66177 13.2245 5.55253 13.2156 5.3896C13.2091 5.26881 13.2106 5.15517 13.2125 5.01961C13.2134 4.95873 13.2143 4.89324 13.2145 4.82089C13.2159 4.43443 13.2085 3.78304 12.7239 3.29631C12.2302 2.80046 11.5826 2.77346 11.1728 2.77136C11.0752 2.77086 10.9931 2.77189 10.9181 2.77283C10.8023 2.77427 10.7035 2.77551 10.5906 2.77059C10.4236 2.76332 10.3185 2.743 10.2473 2.71451C10.1778 2.68674 10.0825 2.62586 9.94526 2.5063C9.85201 2.42506 9.76924 2.34455 9.67339 2.25133C9.61947 2.19889 9.56141 2.14242 9.49503 2.07954C9.1945 1.79486 8.68889 1.3335 7.99967 1.3335ZM9.33301 8.00016C9.33301 7.26378 8.73605 6.66683 7.99967 6.66683C7.2633 6.66683 6.66634 7.26378 6.66634 8.00016C6.66634 8.73654 7.2633 9.3335 7.99967 9.3335C8.73605 9.3335 9.33301 8.73654 9.33301 8.00016ZM10.6663 8.00016C10.6663 9.47292 9.47243 10.6668 7.99967 10.6668C6.52692 10.6668 5.33301 9.47292 5.33301 8.00016C5.33301 6.5274 6.52692 5.3335 7.99967 5.3335C9.47243 5.3335 10.6663 6.5274 10.6663 8.00016Z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 50375:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M5 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H5zM4 7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7zm6 3a2 2 0 1 1-3.999.001A2 2 0 0 1 10 10zm4.747 2.341a.998.998 0 0 0-1.494 0L10 16l-1.626-1.832a.5.5 0 0 0-.748 0L6 16h12l-3.253-3.659z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 93034:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"36","height":"28","viewBox":"0 0 36 28"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h36v28H0z\"/>         <rect width=\"32\" height=\"26\" x=\"2\" y=\"1\" fill=\"#9DA5A6\" rx=\"2\"/>         <rect width=\"30\" height=\"24\" x=\"3\" y=\"2\" fill=\"#FFF\" rx=\"1\"/>         <path fill=\"#9DA5A6\" fill-rule=\"nonzero\" d=\"M18.75 18.833l-2.395 3.222a1 1 0 1 1-1.605-1.193l.907-1.22a2.006 2.006 0 0 1-.064-.055s-3.02-2.673-3.024-2.668L7.744 22.29a1 1 0 0 1-1.488-1.336l4.826-5.372a2.013 2.013 0 0 1 2.825-.169l2.945 2.618.296-.395.928-1.248a1.01 1.01 0 0 1 .077-.092l3.45-4.6a1.88 1.88 0 0 1 2.812-.25l6.264 5.796a1 1 0 1 1-1.358 1.468l-6.186-5.723-4.385 5.846zM10 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 11894:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M4 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4zm6 4a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2H10zm-1 5a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2H10a1 1 0 0 1-1-1zm1 3a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2H10zm-7 5a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm.89-11.887a.5.5 0 0 0-.89.312v7.15a.5.5 0 0 0 .89.312l2.86-3.575a.5.5 0 0 0 0-.624L3.89 8.113z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 13669:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"11","viewBox":"0 0 11 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M10.0018 0.312501H0.996942C0.445872 0.312501 0 0.730505 0 1.24713V9.68979C0 10.2058 0.445872 10.625 0.996942 10.625H10.0024C10.5529 10.625 11 10.2064 11 9.68979V1.24713C11 1.1243 10.9742 1.00267 10.924 0.8892C10.8738 0.77573 10.8003 0.672646 10.7076 0.585843C10.6149 0.499039 10.5048 0.430218 10.3837 0.383316C10.2626 0.336414 10.1329 0.31235 10.0018 0.312501ZM3.67584 2.31766C4.04098 2.31766 4.3474 2.5883 4.3474 2.93578C4.3474 3.28899 4.04098 3.55505 3.67584 3.55505V3.56766C3.30642 3.56766 3.00917 3.28899 3.00917 2.94381C3.00917 2.5969 3.30642 2.31766 3.67584 2.31766ZM8.1737 8.25344C7.49358 8.25344 7.16391 7.87385 7.16391 7.35551C7.16391 7.20642 7.1841 7.04989 7.23364 6.88991L7.55657 5.79702C7.59816 5.67775 7.60917 5.56479 7.60917 5.46388C7.60917 5.11124 7.37982 4.89966 7.01529 4.89966C6.54985 4.89966 6.24465 5.21101 6.08563 5.81594L5.45382 8.19323H4.34618L4.54618 7.4461C4.21957 7.94668 3.76881 8.25573 3.21101 8.25573C2.537 8.25573 2.22202 7.89335 2.22202 7.34748C2.2247 7.191 2.24437 7.03519 2.28073 6.88245L2.78593 4.95241H2.00428L2.24159 4.13245H4.12232L3.37859 6.88704C3.32966 7.06422 3.31132 7.20757 3.31132 7.31021C3.31132 7.48624 3.40183 7.53727 3.54679 7.56938C3.63609 7.58658 4.33884 7.57569 4.71988 6.78039L5.20795 4.95241H4.41651L4.65566 4.14736H6.36024L6.14067 5.07454C6.4367 4.55906 7.02875 4.06422 7.61223 4.06422C8.23119 4.06422 8.74679 4.48165 8.74679 5.27466C8.74679 5.50401 8.70826 5.73108 8.6367 5.95126L8.31865 7.01663C8.29246 7.10882 8.27708 7.20342 8.27278 7.29874C8.27278 7.48567 8.35596 7.57626 8.49786 7.57626C8.64343 7.57626 8.83609 7.47248 9.04771 6.90424L9.48073 7.06021C9.22752 7.90482 8.7578 8.25344 8.1737 8.25344Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 44819:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M13.0043 5.41667C13.0043 7.94797 10.5043 10 8.83768 10C7.17101 10 4.67101 7.94797 4.67101 5.41667C4.67101 2.88536 6.53649 0.833336 8.83768 0.833336C11.1389 0.833336 13.0043 2.88536 13.0043 5.41667ZM11.3377 5.41667C11.3377 3.6528 10.0725 2.5 8.83768 2.5C7.60289 2.5 6.33768 3.6528 6.33768 5.41667C6.33768 6.12695 6.69657 6.87065 7.30508 7.47629C7.95128 8.11947 8.59479 8.33333 8.83768 8.33333C9.08056 8.33333 9.72407 8.11947 10.3703 7.47629C10.9788 6.87065 11.3377 6.12695 11.3377 5.41667Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M9.68229 10.8333C9.92306 10.8333 10.162 10.8494 10.3977 10.8808C10.4721 10.7956 10.5499 10.7123 10.6311 10.6311C12.5838 8.67851 15.7496 8.67851 17.7022 10.6311C19.6548 12.5838 19.6548 15.7496 17.7022 17.7022C15.7496 19.6548 12.5838 19.6548 10.6311 17.7022C10.5651 17.6362 10.5013 17.5687 10.4397 17.5H3.83676C2.98192 17.5 2.34692 16.7084 2.53236 15.8739L2.78398 14.7416C2.9294 14.0873 3.20515 13.4689 3.59478 12.9234C4.53166 11.6118 6.04429 10.8333 7.65614 10.8333H9.68229ZM7.65614 12.5C6.58254 12.5 5.57503 13.0185 4.95101 13.8921C4.69148 14.2554 4.50781 14.6673 4.41095 15.1032L4.2487 15.8333H9.45139C9.07176 14.7569 9.07176 13.5764 9.45139 12.5H7.65614ZM17.357 14.1667C17.357 13.7064 16.9839 13.3333 16.5237 13.3333H15V11.8096C15 11.3494 14.6269 10.9763 14.1667 10.9763C13.7064 10.9763 13.3333 11.3494 13.3333 11.8096V13.3333H11.8096C11.3494 13.3333 10.9763 13.7064 10.9763 14.1667C10.9763 14.6269 11.3494 15 11.8096 15H13.3333V16.5237C13.3333 16.9839 13.7064 17.357 14.1667 17.357C14.6269 17.357 15 16.9839 15 16.5237V15H16.5237C16.9839 15 17.357 14.6269 17.357 14.1667Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 34061:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M12.753 4L9.198 20H7a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-1.753l3.555-16H17a1 1 0 0 0 0-2h-6a1 1 0 0 0 0 2h1.753z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 78018:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"19","height":"16","viewBox":"0 0 19 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M6 0C6.55228 0 7 0.447715 7 1V7H11V1C11 0.447715 11.4477 0 12 0C12.5523 0 13 0.447715 13 1V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V9H7V15C7 15.5523 6.55228 16 6 16C5.44772 16 5 15.5523 5 15V1C5 0.447715 5.44772 0 6 0Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M15 9C15.5523 9 16 9.44771 16 10V14H18C18.5523 14 19 14.4477 19 15C19 15.5523 18.5523 16 18 16H15C14.4477 16 14 15.5523 14 15V10C14 9.44771 14.4477 9 15 9Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M2.31204 9.6109C2.15191 9.81056 1.84807 9.81056 1.68794 9.6109L0.11556 7.65025C-0.0944184 7.38842 0.0919813 7 0.427607 7H3.57237C3.908 7 4.0944 7.38842 3.88442 7.65025L2.31204 9.6109Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 76767:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M8.3238 2.75064C8.12245 2.63878 7.87763 2.63878 7.67628 2.75064L1.68792 6.07751C1.64715 6.09915 1.6089 6.12489 1.57372 6.15419C1.54546 6.17769 1.51934 6.20337 1.49556 6.23091C1.3945 6.34777 1.33337 6.50012 1.33337 6.66675V11.3334C1.33337 11.7016 1.63185 12.0001 2.00004 12.0001C2.36823 12.0001 2.66671 11.7016 2.66671 11.3334V7.79976L4.66671 8.91087V11.3334C4.66629 11.3439 4.66671 11.3546 4.66671 11.3655C4.66671 12.286 6.15909 13.3655 8.00004 13.3655C9.84099 13.3655 11.3334 12.286 11.3334 11.3655C11.3334 11.3546 11.3332 11.3439 11.3328 11.3334L11.3334 8.91087L14.3238 7.24952C14.5354 7.13194 14.6667 6.90886 14.6667 6.66675C14.6667 6.42464 14.5354 6.20156 14.3238 6.08398L8.3238 2.75064ZM8.00004 9.23744L3.37279 6.66675L8.00004 4.09605L12.6273 6.66675L8.00004 9.23744Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 4718:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.22881 8.9428C3.44776 9.72384 3.44776 10.9902 4.22881 11.7712C5.00986 12.5523 6.27619 12.5523 7.05724 11.7712L8.47145 10.357C8.7318 10.0967 9.15391 10.0967 9.41426 10.357C9.67461 10.6174 9.67461 11.0395 9.41426 11.2998L8.00005 12.714C6.6983 14.0158 4.58775 14.0158 3.286 12.714C1.98426 11.4123 1.98426 9.30173 3.286 7.99999L4.70022 6.58577C4.96057 6.32542 5.38268 6.32542 5.64303 6.58577C5.90337 6.84612 5.90337 7.26823 5.64303 7.52858L4.22881 8.9428ZM6.11443 9.8856C5.85408 9.62526 5.85408 9.20315 6.11443 8.9428L8.94286 6.11437C9.20321 5.85402 9.62532 5.85402 9.88567 6.11437C10.146 6.37472 10.146 6.79683 9.88567 7.05718L7.05724 9.8856C6.79689 10.146 6.37478 10.146 6.11443 9.8856ZM6.58583 4.70016C6.32548 4.96051 6.32548 5.38261 6.58583 5.64296C6.84618 5.90331 7.26829 5.90331 7.52864 5.64296L8.94286 4.22875C9.72391 3.4477 10.9902 3.4477 11.7713 4.22875C12.5523 5.0098 12.5523 6.27613 11.7713 7.05718L10.3571 8.47139C10.0967 8.73174 10.0967 9.15385 10.3571 9.4142C10.6174 9.67455 11.0395 9.67455 11.2999 9.4142L12.7141 7.99999C14.0158 6.69824 14.0158 4.58769 12.7141 3.28594C11.4123 1.98419 9.3018 1.98419 8.00005 3.28594L6.58583 4.70016Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 60623:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M7 9a3 3 0 1 0 0 6h3a1 1 0 0 1 0 2H7A5 5 0 0 1 7 7h3a1 1 0 0 1 0 2H7zm1 3a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1zm6-5a1 1 0 0 0 0 2h3a3 3 0 1 1 0 6h-3a1 1 0 0 0 0 2h3a5 5 0 0 0 0-10h-3z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 12479:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path class=\"graphic\" fill=\"#5C6061\" fill-rule=\"evenodd\" d=\"M11.293 3.293a1 1 0 0 1 1.414 0L20.05 11h.008l-7.35-7.708 8 8c.193.193.29.445.293.698V12l-.001.048a.997.997 0 0 1-.292.66l-8 8a1 1 0 0 1-1.414-1.415L17.586 13H4a1 1 0 1 1 0-2h13.586l-6.293-6.293a1 1 0 0 1 0-1.414z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 95161:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M4 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm4-2a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2H8zm0 6a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2H8zm-1 7a1 1 0 0 1 1-1h12a1 1 0 0 1 0 2H8a1 1 0 0 1-1-1zm-2-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-1 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 30350:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <circle class=\"graphic\" cx=\"12\" cy=\"12\" r=\"10\" fill=\"#5C6061\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 98854:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"8","height":"5","viewBox":"0 0 8 5","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M1.44948 0L6.55052 0C7.12009 0 7.42736 0.668079 7.05669 1.10053L4.50617 4.07613C4.24011 4.38654 3.75989 4.38654 3.49383 4.07613L0.943309 1.10053C0.572639 0.668079 0.879912 0 1.44948 0Z\" fill=\"#AEB7B8\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 35235:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M21.12 11.069L3.459 4.158c-.91-.357-1.74.672-1.196 1.486l3.867 5.801c.224.336.224.774 0 1.11l-3.867 5.801c-.543.814.285 1.843 1.196 1.486l17.661-6.911c.848-.331.848-1.531 0-1.862z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 59481:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M3.414 10.586l7.172-7.172a2 2 0 0 1 2.828 0l7.172 7.172a2 2 0 0 1 0 2.828l-7.172 7.172a2 2 0 0 1-2.828 0l-7.172-7.172a2 2 0 0 1 0-2.828z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 47238:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M4.5 4a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V5.707l-.146.147a.502.502 0 0 1-.708-.708l1-1A.502.502 0 0 1 4.5 4zM9 5h11a1 1 0 0 1 0 2H9a1 1 0 0 1 0-2zm0 6h11a1 1 0 0 1 0 2H9a1 1 0 0 1 0-2zm-1 7a1 1 0 0 1 1-1h11a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1zm-3.933-1.75a.5.5 0 1 1-.866-.5 1.5 1.5 0 1 1 2.417 1.75A1.5 1.5 0 1 1 3 18.5a.5.5 0 0 1 1 0 .5.5 0 1 0 .5-.5.5.5 0 0 1 0-1 .5.5 0 1 0-.433-.75zM4.5 10.5a.5.5 0 0 0-.495.428.5.5 0 1 1-.99-.141A1.501 1.501 0 0 1 6 11c0 .427-.179.813-.465 1.085L4.666 13H5.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.362-.845l1.692-1.779.011-.01A.5.5 0 0 0 4.5 10.5z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 56987:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 74107:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-2a8 8 0 1 1 0-16 8 8 0 0 1 0 16z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 60965:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path class=\"graphic\" fill=\"#5C6061\" fill-rule=\"evenodd\" d=\"M10.548 3.807c.467-1.343 2.367-1.343 2.834 0l1.65 4.748 5.026.103c1.422.029 2.009 1.836.875 2.695l-4.005 3.037 1.455 4.81c.412 1.362-1.125 2.479-2.292 1.666l-4.126-2.87-4.126 2.87c-1.167.813-2.704-.304-2.293-1.665l1.456-4.811-4.006-3.037c-1.133-.86-.546-2.666.876-2.695l5.026-.103 1.65-4.748z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 8941:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"20","viewBox":"0 0 16 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M4 4C4 1.79086 5.79086 0 8 0C10.2091 0 12 1.79086 12 4V6H13C14.6569 6 16 7.34315 16 9V17C16 18.6569 14.6569 20 13 20H3C1.34315 20 0 18.6569 0 17V9C0 7.34315 1.34315 6 3 6H4V4ZM10 4C10 2.89543 9.10457 2 8 2C6.89543 2 6 2.89543 6 4V6H10V4ZM3 8C2.44772 8 2 8.44772 2 9V17C2 17.5523 2.44772 18 3 18H13C13.5523 18 14 17.5523 14 17V9C14 8.44772 13.5523 8 13 8H3ZM10 12C10 12.7403 9.5978 13.3866 9 13.7324V15C9 15.5523 8.55228 16 8 16C7.44772 16 7 15.5523 7 15V13.7324C6.4022 13.3866 6 12.7403 6 12C6 10.8954 6.89543 10 8 10C9.10457 10 10 10.8954 10 12Z\" fill=\"rgb(0, 161, 183)\" fill-opacity=\"0.6\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 72102:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"20","viewBox":"0 0 16 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M4 4C4 1.79086 5.79086 0 8 0C10.2091 0 12 1.79086 12 4V6H13C14.6569 6 16 7.34315 16 9V17C16 18.6569 14.6569 20 13 20H3C1.34315 20 0 18.6569 0 17V9C0 7.34315 1.34315 6 3 6H4V4ZM10 4C10 2.89543 9.10457 2 8 2C6.89543 2 6 2.89543 6 4V6H10V4ZM3 8C2.44772 8 2 8.44772 2 9V17C2 17.5523 2.44772 18 3 18H13C13.5523 18 14 17.5523 14 17V9C14 8.44772 13.5523 8 13 8H3ZM10 12C10 12.7403 9.5978 13.3866 9 13.7324V15C9 15.5523 8.55228 16 8 16C7.44772 16 7 15.5523 7 15V13.7324C6.4022 13.3866 6 12.7403 6 12C6 10.8954 6.89543 10 8 10C9.10457 10 10 10.8954 10 12Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 29828:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 1C0 0.447715 0.447715 0 1 0H4C4.55228 0 5 0.447715 5 1C5 1.55228 4.55228 2 4 2H2V4C2 4.55228 1.55228 5 1 5C0.447715 5 0 4.55228 0 4V1ZM9 1C9 0.447715 9.44771 0 10 0H13C13.5523 0 14 0.447715 14 1V4C14 4.55228 13.5523 5 13 5C12.4477 5 12 4.55228 12 4V2H10C9.44771 2 9 1.55228 9 1ZM1 9C1.55228 9 2 9.44771 2 10V12H4C4.55228 12 5 12.4477 5 13C5 13.5523 4.55228 14 4 14H1C0.447715 14 0 13.5523 0 13V10C0 9.44771 0.447715 9 1 9ZM13 9C13.5523 9 14 9.44771 14 10V13C14 13.5523 13.5523 14 13 14H10C9.44771 14 9 13.5523 9 13C9 12.4477 9.44771 12 10 12H12V10C12 9.44771 12.4477 9 13 9Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 37871:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"21","height":"16","viewBox":"0 0 21 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M6 0C6.55228 0 7 0.447715 7 1V7H11V1C11 0.447715 11.4477 0 12 0C12.5523 0 13 0.447715 13 1V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V9H7V15C7 15.5523 6.55228 16 6 16C5.44772 16 5 15.5523 5 15V1C5 0.447715 5.44772 0 6 0Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M14.6838 9.05132C15.0921 8.9152 15.5417 9.05566 15.8 9.4L17.5 11.6667L19.2 9.4C19.4583 9.05566 19.9079 8.9152 20.3162 9.05132C20.7246 9.18743 21 9.56957 21 10V15C21 15.5523 20.5523 16 20 16C19.4477 16 19 15.5523 19 15V13L18.3 13.9333C18.1111 14.1851 17.8148 14.3333 17.5 14.3333C17.1852 14.3333 16.8889 14.1851 16.7 13.9333L16 13V15C16 15.5523 15.5523 16 15 16C14.4477 16 14 15.5523 14 15V10C14 9.56957 14.2754 9.18743 14.6838 9.05132Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M2.31204 9.6109C2.15191 9.81056 1.84807 9.81056 1.68794 9.6109L0.11556 7.65025C-0.0944184 7.38842 0.0919813 7 0.427607 7H3.57237C3.908 7 4.0944 7.38842 3.88442 7.65025L2.31204 9.6109Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 94384:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M12 4a8 8 0 1 0 3.555 15.169 1 1 0 1 1 .89 1.791A9.961 9.961 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10v.571c0 1.297-.317 2.395-.948 3.193A3.199 3.199 0 0 1 18.5 17c-1.216 0-2.192-.685-2.801-1.636A5 5 0 1 1 15 8a1 1 0 0 1 2 0v5c0 1.222.85 2 1.5 2a1.2 1.2 0 0 0 .984-.478c.273-.345.516-.961.516-1.951V12a8 8 0 0 0-8-8zm3 8a3 3 0 1 0-6 0 3 3 0 0 0 6 0z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 16357:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"8","viewBox":"0 0 14 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.4714 0.861888C13.7318 1.12224 13.7318 1.54435 13.4714 1.8047L7.47142 7.8047C7.21108 8.06505 6.78897 8.06505 6.52862 7.8047L0.528615 1.8047C0.268266 1.54435 0.268266 1.12224 0.528615 0.861888C0.788965 0.601539 1.21107 0.601539 1.47143 0.861888L7.00002 6.39048L12.5286 0.861888C12.789 0.601539 13.2111 0.601539 13.4714 0.861888Z\" fill=\"#AEB7B8\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 63821:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"15","height":"14","viewBox":"0 0 15 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 0C4.55228 0 5 0.447715 5 1V4C5 4.55228 4.55228 5 4 5H1C0.447715 5 0 4.55228 0 4C0 3.44772 0.447715 3 1 3H3V1C3 0.447715 3.44772 0 4 0ZM10.5 0C11.0523 0 11.5 0.447715 11.5 1V3H13.5C14.0523 3 14.5 3.44772 14.5 4C14.5 4.55228 14.0523 5 13.5 5H10.5C9.94771 5 9.5 4.55228 9.5 4V1C9.5 0.447715 9.94771 0 10.5 0ZM0 10C0 9.44771 0.447715 9 1 9H4C4.55228 9 5 9.44771 5 10V13C5 13.5523 4.55228 14 4 14C3.44772 14 3 13.5523 3 13V11H1C0.447715 11 0 10.5523 0 10ZM9.5 10C9.5 9.44771 9.94771 9 10.5 9H13.5C14.0523 9 14.5 9.44771 14.5 10C14.5 10.5523 14.0523 11 13.5 11H11.5V13C11.5 13.5523 11.0523 14 10.5 14C9.94771 14 9.5 13.5523 9.5 13V10Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 31958:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M2 8c0-.368.298-.667.667-.667h10.666a.667.667 0 1 1 0 1.334H2.667A.667.667 0 0 1 2 8z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 26934:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M2 2H4L7.5 5.5L5.5 2H7.5L11 4.5L9 2H11L14 4L11 14H9L11 4.5L7.5 14H5.5L7.5 5.5L4 14H2L4 6L2 2Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 46605:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M7.5 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 92688:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"11","viewBox":"0 0 11 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<rect class=\"graphic\" width=\"11\" height=\"11\" rx=\"1\" fill=\"#5C6061\"/>   <path class=\"graphic_stroke_bg graphic_bg\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.27444 4.09162C4.4421 4.48418 4.57964 4.91014 4.88142 5.92473L4.88391 5.93307C5.18869 6.95775 5.32589 7.38581 5.50938 7.83045C5.63543 8.13585 5.76037 8.37659 5.897 8.56076C6.09828 8.83209 6.33766 8.99992 6.63376 8.99992C7.02753 8.99992 7.35911 8.8112 7.58923 8.47347C7.77042 8.20748 7.8816 7.86402 7.9424 7.44739C8.03504 6.81257 8.01171 6.00699 7.90265 5.02681C7.77939 3.9186 7.57845 3.02221 7.29363 2.33322C7.17562 2.04777 6.8691 1.92134 6.60896 2.05083C6.34884 2.18033 6.23362 2.5167 6.35163 2.80217C6.58752 3.37277 6.76436 4.16166 6.8759 5.16433C6.97415 6.0476 6.99484 6.76203 6.92103 7.26793C6.88444 7.51871 6.82674 7.69695 6.76077 7.79378C6.74119 7.82253 6.72453 7.84052 6.70449 7.85119C6.70276 7.84895 6.701 7.84659 6.69919 7.84415C6.62859 7.74897 6.54412 7.58625 6.45164 7.36215C6.29005 6.97058 6.15885 6.56128 5.86723 5.58084L5.86475 5.57252C5.54809 4.50793 5.40402 4.06171 5.21111 3.60996C5.07642 3.29453 4.94181 3.05136 4.79023 2.87167C4.55843 2.59684 4.26896 2.4538 3.94268 2.53586C3.59719 2.62276 3.353 2.90101 3.20629 3.30131C3.09221 3.61263 3.02918 4.01532 3.00803 4.5188C2.96864 5.45512 3.07431 6.78482 3.32264 8.52041C3.36694 8.83005 3.63161 9.04166 3.91379 8.99305C4.19597 8.94444 4.3888 8.65399 4.3445 8.34432C4.10605 6.6778 4.00579 5.4159 4.04132 4.57113C4.05521 4.24081 4.08973 3.98467 4.13918 3.80852C4.18103 3.88469 4.22654 3.97944 4.27444 4.09162Z\" stroke=\"white\" stroke-width=\"0.2\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 36771:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M0.500061 6C0.500061 2.96243 2.96249 0.5 6.00006 0.5C9.03763 0.5 11.5001 2.96243 11.5001 6C11.5001 9.03757 9.03763 11.5 6.00006 11.5C2.96249 11.5 0.500061 9.03757 0.500061 6Z\" stroke=\"#AEB7B8\"/>   <path d=\"M6.00002 6.00002C8.34317 3.65686 8.37091 3.62912 10.2427 1.75736C7.89952 -0.585793 4.10052 -0.585793 1.75736 1.75736C-0.585795 4.10052 -0.585795 7.89952 1.75736 10.2427C3.62912 8.37092 3.65686 8.34317 6.00002 6.00002Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 99562:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6Z\" stroke=\"#EDEDED\"/>   <path d=\"M6.00004 5.99998C3.65689 8.34314 3.62915 8.37088 1.75739 10.2426C4.10054 12.5858 7.89955 12.5858 10.2427 10.2426C12.5859 7.89948 12.5859 4.10048 10.2427 1.75732C8.37094 3.62908 8.3432 3.65683 6.00004 5.99998Z\" fill=\"#404B4C\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 42477:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g class=\"graphic_stroke\" fill=\"none\" fill-rule=\"nonzero\" stroke=\"#5C6061\" stroke-width=\"1.333\">         <circle cx=\"8\" cy=\"8\" r=\"7.333\"/>         <path stroke-linecap=\"square\" d=\"M3.333 12.667l9.334-9.334\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 8386:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M4.667 1.333a2 2 0 0 0-2 2v9.334a2 2 0 0 0 2 2h6.666a2 2 0 0 0 2-2V3.333a2 2 0 0 0-2-2H4.667zm-.667 2c0-.368.299-.666.667-.666h6.666c.368 0 .667.298.667.666v9.334a.667.667 0 0 1-.667.666H4.667A.667.667 0 0 1 4 12.667V3.333zM6 4a.667.667 0 0 0 0 1.333h4A.667.667 0 0 0 10 4H6zm-.667 3.333c0-.368.299-.666.667-.666h4A.667.667 0 0 1 10 8H6a.667.667 0 0 1-.667-.667zm.667 2a.667.667 0 0 0 0 1.334h2.667a.667.667 0 0 0 0-1.334H6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 7306:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path class=\"graphic\" fill=\"#5C6061\" fill-rule=\"evenodd\" d=\"M4 3a1 1 0 0 0 0 2h16a1 1 0 1 0 0-2H4zm6 4a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2H10zm-1 5a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1zm1 3a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H10zm-7 5a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1zm3.11-4.113a.5.5 0 0 0 .89-.312v-7.15a.5.5 0 0 0-.89-.312l-2.86 3.575a.5.5 0 0 0 0 .624l2.86 3.575z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 68234:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 2C2.89543 2 2 2.89543 2 4V12C2 13.1046 2.89543 14 4 14H12C13.1046 14 14 13.1046 14 12V4C14 2.89543 13.1046 2 12 2H4ZM12 3.33333H4C3.63181 3.33333 3.33333 3.63181 3.33333 4V12C3.33333 12.3682 3.63181 12.6667 4 12.6667H12C12.3682 12.6667 12.6667 12.3682 12.6667 12V4C12.6667 3.63181 12.3682 3.33333 12 3.33333Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 69435:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"7","height":"14","viewBox":"0 0 7 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.80346 4.98904C1.78031 4.97102 1.75769 4.95282 1.73564 4.93441C1.50696 4.74347 1.31117 4.51221 1.17845 4.21436C1.04746 3.92039 0.995605 3.60128 0.995605 3.25826C0.995605 1.78514 2.19097 0.590942 3.66552 0.590942C5.14007 0.590942 6.33543 1.78514 6.33543 3.25826C6.33543 3.62654 6.03659 3.92509 5.66796 3.92509C5.29932 3.92509 5.00048 3.62654 5.00048 3.25826C5.00048 2.5217 4.4028 1.9246 3.66552 1.9246C2.92824 1.9246 2.33056 2.5217 2.33056 3.25826C2.33056 3.46766 2.36215 3.59146 2.39802 3.67197C2.43217 3.7486 2.48668 3.82338 2.59174 3.9111C2.80358 4.08798 3.10896 4.23895 3.61983 4.49152C3.7236 4.54282 3.83596 4.59836 3.95762 4.65912C3.95976 4.66018 3.9619 4.66124 3.96404 4.66231C4.06208 4.71129 4.16009 4.75942 4.25727 4.80713C4.76491 5.0564 5.24972 5.29446 5.59539 5.58308C5.82407 5.77402 6.01986 6.00527 6.15259 6.30312C6.28358 6.59709 6.33543 6.9162 6.33543 7.25922C6.33543 7.91312 6.14432 8.73277 5.70168 9.32347C5.64876 9.3941 5.59078 9.46328 5.52759 9.5294C5.55073 9.54741 5.57335 9.56561 5.5954 9.58402C5.82408 9.77496 6.01986 10.0062 6.15259 10.3041C6.28358 10.598 6.33543 10.9172 6.33543 11.2602C6.33543 12.7333 5.14007 13.9275 3.66552 13.9275C2.19097 13.9275 0.995605 12.7333 0.995605 11.2602C0.995605 10.8919 1.29445 10.5933 1.66308 10.5933C2.03172 10.5933 2.33056 10.8919 2.33056 11.2602C2.33056 11.9967 2.92824 12.5938 3.66552 12.5938C4.4028 12.5938 5.00048 11.9967 5.00048 11.2602C5.00048 11.0508 4.96889 10.927 4.93302 10.8465C4.89887 10.7698 4.84436 10.6951 4.7393 10.6073C4.52746 10.4305 4.22208 10.2795 3.71121 10.0269C3.60831 9.97605 3.49675 9.92089 3.37627 9.86074L3.36701 9.85613C3.26899 9.80717 3.17099 9.75905 3.07382 9.71134C2.56617 9.46207 2.08132 9.224 1.73564 8.93537C1.50697 8.74443 1.31118 8.51317 1.17845 8.21532C1.04746 7.92135 0.995605 7.60224 0.995605 7.25922C0.995605 6.60532 1.18671 5.78567 1.62936 5.19496C1.68228 5.12434 1.74026 5.05515 1.80346 4.98904ZM3.36256 5.85295C3.14984 5.74768 3.02999 5.75981 2.96932 5.77677C2.89844 5.79659 2.80352 5.85344 2.69803 5.99421C2.47319 6.29426 2.33056 6.80828 2.33056 7.25922C2.33056 7.46862 2.36215 7.59242 2.39802 7.67293C2.43217 7.74955 2.48668 7.82433 2.59174 7.91205C2.80356 8.08892 3.10891 8.23988 3.6197 8.49241L3.62032 8.49272C3.72447 8.54421 3.83717 8.59993 3.95935 8.66094L3.96403 8.66326L3.97073 8.6666C4.18204 8.77067 4.30126 8.75857 4.36172 8.74167C4.4326 8.72185 4.52752 8.665 4.63301 8.52422C4.85785 8.22418 5.00048 7.71016 5.00048 7.25922C5.00048 7.04982 4.96889 6.92602 4.93302 6.84552C4.89888 6.7689 4.84436 6.69412 4.7393 6.6064C4.52749 6.42954 4.22216 6.27859 3.71141 6.02607C3.60665 5.97428 3.4931 5.91814 3.37009 5.8567C3.36906 5.8562 3.36804 5.85569 3.36701 5.85518C3.36553 5.85443 3.36404 5.85369 3.36256 5.85295Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 36419:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M4 9a6 6 0 0 1 6-6h9a1 1 0 0 1 0 2h-3.057v15a.943.943 0 1 1-1.886 0V5h-2.114v15a.943.943 0 1 1-1.886 0v-5H10a6 6 0 0 1-6-6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 46015:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"54","height":"54","viewBox":"0 0 54 54","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<circle cx=\"27\" cy=\"27\" r=\"27\" fill=\"black\" fill-opacity=\"0.32\"/> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M24 19.5C24 17.8431 22.6569 16.5 21 16.5C19.3431 16.5 18 17.8431 18 19.5V34.5C18 36.1569 19.3431 37.5 21 37.5C22.6569 37.5 24 36.1569 24 34.5V19.5ZM36 19.5C36 17.8431 34.6569 16.5 33 16.5C31.3431 16.5 30 17.8431 30 19.5V34.5C30 36.1569 31.3431 37.5 33 37.5C34.6569 37.5 36 36.1569 36 34.5V19.5Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 10231:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"33","height":"32","viewBox":"0 0 33 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"player\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.3189 32C25.1555 32 32.3189 24.8366 32.3189 16C32.3189 7.16344 25.1555 0 16.3189 0C7.48235 0 0.318909 7.16344 0.318909 16C0.318909 24.8366 7.48235 32 16.3189 32Z\" fill=\"#00A1B7\"/> <rect class=\"player2\" x=\"18.3189\" y=\"11\" width=\"2\" height=\"10\" rx=\"1\" fill=\"white\"/> <rect class=\"player2\" x=\"12.3189\" y=\"11\" width=\"2\" height=\"10\" rx=\"1\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 26143:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"14","viewBox":"0 0 12 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 2C4 0.89543 3.10457 0 2 0C0.89543 0 0 0.89543 0 2V12C0 13.1046 0.89543 14 2 14C3.10457 14 4 13.1046 4 12V2ZM12 2C12 0.89543 11.1046 0 10 0C8.89543 0 8 0.89543 8 2V12C8 13.1046 8.89543 14 10 14C11.1046 14 12 13.1046 12 12V2Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 68278:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M16.6472 3.83988C15.6711 2.86334 14.0884 2.86326 13.1123 3.8397L11.8314 5.12111C11.8262 5.12606 11.821 5.13109 11.8159 5.13621C11.8107 5.14139 11.8056 5.14663 11.8006 5.15192L2.74401 14.2117C2.58776 14.368 2.49999 14.58 2.5 14.8011L2.50013 17.2764C2.50014 17.4974 2.58793 17.7094 2.74419 17.8658C2.90046 18.0221 3.11239 18.1099 3.33336 18.1099L5.80776 18.11C6.02873 18.11 6.24064 18.0222 6.39688 17.8659L16.7652 7.49389C17.7413 6.51746 17.7412 4.93426 16.7651 3.95773L16.6472 3.83988ZM12.4055 6.90432L13.7019 8.2007L5.46254 16.443L4.16645 16.443L4.16639 15.1464L12.4055 6.90432ZM14.8802 7.02198L13.5838 5.7256L14.2907 5.01848C14.6161 4.693 15.1436 4.69303 15.469 5.01854L15.5868 5.13639C15.9122 5.4619 15.9122 5.98963 15.5869 6.31511L14.8802 7.02198Z\" fill=\"currentColor\"></path>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 53686:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"14","viewBox":"0 0 12 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.00001 3.99999C8.00001 4.56822 7.71289 5.16318 7.22609 5.64769C6.70912 6.16223 6.19432 6.33333 6.00001 6.33333C5.8057 6.33333 5.2909 6.16223 4.77393 5.64769C4.28713 5.16318 4.00001 4.56822 4.00001 3.99999C4.00001 2.5889 5.01218 1.66666 6.00001 1.66666C6.98784 1.66666 8.00001 2.5889 8.00001 3.99999ZM9.33334 3.99999C9.33334 6.02504 7.33334 7.66666 6.00001 7.66666C4.66668 7.66666 2.66668 6.02504 2.66668 3.99999C2.66668 1.97495 4.15906 0.333328 6.00001 0.333328C7.84096 0.333328 9.33334 1.97495 9.33334 3.99999ZM5.05478 9.66666H6.6757C7.55016 9.66666 8.38096 10.0488 8.95005 10.7127C9.27003 11.086 9.4932 11.5324 9.59986 12.0123L9.67119 12.3333H2.32883L2.45863 11.7492C2.53612 11.4005 2.68306 11.071 2.89068 10.7803C3.38989 10.0814 4.1959 9.66666 5.05478 9.66666ZM1.8057 10.0054C2.5552 8.95607 3.7653 8.33333 5.05478 8.33333H6.6757C7.93939 8.33333 9.13999 8.88552 9.96239 9.84499C10.4248 10.3845 10.7473 11.0295 10.9014 11.7231L11.0774 12.5147C11.2087 13.1059 10.7589 13.6667 10.1533 13.6667H1.99928C1.31541 13.6667 0.807406 13.0334 0.95576 12.3658L1.15705 11.46C1.27339 10.9365 1.49399 10.4418 1.8057 10.0054Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 4421:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M6 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm8 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm6 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 88398:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<g clip-path=\"url(#clip0)\"> <path d=\"M0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z\" fill=\"#00A1B7\"/> <path d=\"M12.0834 9.16663C10.9622 9.16663 10.4864 10.5939 11.3834 11.2666L11.85 11.6166C11.9969 11.7268 12.0834 11.8997 12.0834 12.0833V14.4166C12.0834 14.6002 11.9969 14.7731 11.85 14.8833L11.3834 15.2333C10.4864 15.906 10.9622 17.3333 12.0834 17.3333H14.4167V20.25C14.4167 20.5721 14.6779 20.8333 15 20.8333C15.3222 20.8333 15.5834 20.5721 15.5834 20.25V17.3333H17.9167C19.0379 17.3333 19.5136 15.906 18.6167 15.2333L18.15 14.8833C18.0031 14.7731 17.9167 14.6002 17.9167 14.4166V12.0833C17.9167 11.8997 18.0031 11.7268 18.15 11.6166L18.6167 11.2666C19.5136 10.5939 19.0379 9.16663 17.9167 9.16663H12.0834ZM12.0834 10.3333H17.9167L17.45 10.6833C17.0094 11.0138 16.75 11.5325 16.75 12.0833V14.4166C16.75 14.9675 17.0094 15.4861 17.45 15.8166L17.9167 16.1666H12.0834L12.55 15.8166C12.9907 15.4861 13.25 14.9675 13.25 14.4166V12.0833C13.25 11.5325 12.9907 11.0138 12.55 10.6833L12.0834 10.3333Z\" fill=\"#F5F8FA\"/> </g> <defs> <clipPath id=\"clip0\"> <path d=\"M0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z\" fill=\"white\"/> </clipPath> </defs>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 7393:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.33333 0.666667C1.33333 1.03486 1.03486 1.33333 0.666667 1.33333C0.298477 1.33333 0 1.03486 0 0.666667C0 0.298477 0.298477 0 0.666667 0C1.03486 0 1.33333 0.298477 1.33333 0.666667ZM4 0.666667C4 1.03486 3.70152 1.33333 3.33333 1.33333C2.96514 1.33333 2.66667 1.03486 2.66667 0.666667C2.66667 0.298477 2.96514 0 3.33333 0C3.70152 0 4 0.298477 4 0.666667ZM9.33333 0.666667C9.33333 1.03486 9.03486 1.33333 8.66667 1.33333C8.29848 1.33333 8 1.03486 8 0.666667C8 0.298477 8.29848 0 8.66667 0C9.03486 0 9.33333 0.298477 9.33333 0.666667ZM6 1.33333C6.36819 1.33333 6.66667 1.03486 6.66667 0.666667C6.66667 0.298477 6.36819 0 6 0C5.63181 0 5.33333 0.298477 5.33333 0.666667C5.33333 1.03486 5.63181 1.33333 6 1.33333ZM0.666667 6.66667C1.03486 6.66667 1.33333 6.36819 1.33333 6C1.33333 5.63181 1.03486 5.33333 0.666667 5.33333C0.298477 5.33333 0 5.63181 0 6C0 6.36819 0.298477 6.66667 0.666667 6.66667ZM1.33333 3.33333C1.33333 3.70152 1.03486 4 0.666667 4C0.298477 4 0 3.70152 0 3.33333C0 2.96514 0.298477 2.66667 0.666667 2.66667C1.03486 2.66667 1.33333 2.96514 1.33333 3.33333ZM0.666667 12C1.03486 12 1.33333 11.7015 1.33333 11.3333C1.33333 10.9651 1.03486 10.6667 0.666667 10.6667C0.298477 10.6667 0 10.9651 0 11.3333C0 11.7015 0.298477 12 0.666667 12ZM1.33333 8.66667C1.33333 9.03486 1.03486 9.33333 0.666667 9.33333C0.298477 9.33333 0 9.03486 0 8.66667C0 8.29848 0.298477 8 0.666667 8C1.03486 8 1.33333 8.29848 1.33333 8.66667ZM3.33333 12C3.70152 12 4 11.7015 4 11.3333C4 10.9651 3.70152 10.6667 3.33333 10.6667C2.96514 10.6667 2.66667 10.9651 2.66667 11.3333C2.66667 11.7015 2.96514 12 3.33333 12ZM9.33333 11.3333C9.33333 11.7015 9.03486 12 8.66667 12C8.29848 12 8 11.7015 8 11.3333C8 10.9651 8.29848 10.6667 8.66667 10.6667C9.03486 10.6667 9.33333 10.9651 9.33333 11.3333ZM11.3333 12C11.7015 12 12 11.7015 12 11.3333C12 10.9651 11.7015 10.6667 11.3333 10.6667C10.9651 10.6667 10.6667 10.9651 10.6667 11.3333C10.6667 11.7015 10.9651 12 11.3333 12ZM6.66667 11.3333C6.66667 11.7015 6.36819 12 6 12C5.63181 12 5.33333 11.7015 5.33333 11.3333C5.33333 10.9651 5.63181 10.6667 6 10.6667C6.36819 10.6667 6.66667 10.9651 6.66667 11.3333ZM11.3333 9.33333C11.7015 9.33333 12 9.03486 12 8.66667C12 8.29848 11.7015 8 11.3333 8C10.9651 8 10.6667 8.29848 10.6667 8.66667C10.6667 9.03486 10.9651 9.33333 11.3333 9.33333ZM12 6C12 6.36819 11.7015 6.66667 11.3333 6.66667C10.9651 6.66667 10.6667 6.36819 10.6667 6C10.6667 5.63181 10.9651 5.33333 11.3333 5.33333C11.7015 5.33333 12 5.63181 12 6ZM11.3333 1.33333C11.7015 1.33333 12 1.03486 12 0.666667C12 0.298477 11.7015 0 11.3333 0C10.9651 0 10.6667 0.298477 10.6667 0.666667C10.6667 1.03486 10.9651 1.33333 11.3333 1.33333ZM12 3.33333C12 3.70152 11.7015 4 11.3333 4C10.9651 4 10.6667 3.70152 10.6667 3.33333C10.6667 2.96514 10.9651 2.66667 11.3333 2.66667C11.7015 2.66667 12 2.96514 12 3.33333ZM2.66667 3.33333C2.66667 2.96514 2.96514 2.66667 3.33333 2.66667H8.66667C9.03486 2.66667 9.33333 2.96514 9.33333 3.33333C9.33333 3.70152 9.03486 4 8.66667 4H6.66667V8.66667C6.66667 9.03486 6.36819 9.33333 6 9.33333C5.63181 9.33333 5.33333 9.03486 5.33333 8.66667V4H3.33333C2.96514 4 2.66667 3.70152 2.66667 3.33333Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 69499:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"19","height":"22","viewBox":"0 0 19 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M18.1667 9.55666C19.2778 10.1982 19.2778 11.8019 18.1667 12.4434L3.16666 21.1037C2.05554 21.7452 0.666656 20.9433 0.666656 19.6603L0.666657 2.33978C0.666657 1.05678 2.05555 0.254901 3.16666 0.896401L18.1667 9.55666Z\" fill=\"#00BCD4\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 51195:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"33","height":"32","viewBox":"0 0 33 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"player\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.3189 32C25.1555 32 32.3189 24.8366 32.3189 16C32.3189 7.16344 25.1555 0 16.3189 0C7.48235 0 0.318909 7.16344 0.318909 16C0.318909 24.8366 7.48235 32 16.3189 32Z\" fill=\"#00A1B7\"/> <path class=\"player2\" d=\"M23.0538 15.5606C23.4073 15.7559 23.4073 16.2441 23.0538 16.4394L13.1141 21.9313C12.7607 22.1265 12.3189 21.8825 12.3189 21.4919L12.3189 10.5081C12.3189 10.1175 12.7607 9.87346 13.1141 10.0687L23.0538 15.5606Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 1250:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"14","viewBox":"0 0 11 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M1.53688 0.978013C0.871153 0.55437 0 1.03258 0 1.82167V12.1783C0 12.9674 0.87115 13.4456 1.53688 13.022L9.67424 7.84366C10.2917 7.45071 10.2917 6.54929 9.67425 6.15634L1.53688 0.978013Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 25637:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"20","viewBox":"0 0 16 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M8 0C8.55228 0 9 0.447714 9 0.999999L9.00001 12.5858L14.2929 7.29289C14.6834 6.90237 15.3166 6.90237 15.7071 7.29289C16.0976 7.68342 16.0976 8.31658 15.7071 8.70711L8.71049 15.7037C8.69991 15.7144 8.68909 15.7249 8.67804 15.735C8.59151 15.815 8.49429 15.8768 8.39122 15.9206C8.27192 15.9713 8.14074 15.9996 8.00301 16L8.00002 16L7.99078 16C7.86178 15.9988 7.73861 15.9732 7.62569 15.9276C7.50456 15.8788 7.39106 15.8053 7.29289 15.7071L0.292893 8.70711C-0.0976311 8.31658 -0.0976311 7.68342 0.292893 7.29289C0.683417 6.90237 1.31658 6.90237 1.70711 7.29289L7.00001 12.5858L7 1C7 0.447716 7.44771 0 8 0Z\" fill=\"white\"/>   <path class=\"graphic\" d=\"M1 18C0.447715 18 7.45058e-09 18.4477 7.45058e-09 19C7.45058e-09 19.5523 0.447715 20 1 20L15 20C15.5523 20 16 19.5523 16 19C16 18.4477 15.5523 18 15 18L1 18Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 47137:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M12.2292 3.14583C12.2292 2.6856 11.8562 2.3125 11.3959 2.3125C10.9357 2.3125 10.5626 2.6856 10.5626 3.14583L10.5626 18.1458C10.5626 18.6061 10.9357 18.9792 11.3959 18.9792C11.8562 18.9792 12.2292 18.6061 12.2292 18.1458V3.14583Z\" fill=\"white\"/>   <path d=\"M8.89592 3.97917H4.72925C3.34854 3.97917 2.22925 5.09845 2.22925 6.47917V14.8125C2.22925 16.1932 3.34854 17.3125 4.72925 17.3125H8.89592C9.35615 17.3125 9.72925 16.9394 9.72925 16.4792C9.72925 16.0189 9.35615 15.6458 8.89592 15.6458H4.72925C4.26901 15.6458 3.89591 15.2727 3.89591 14.8125V6.47917C3.89591 6.01893 4.26901 5.64583 4.72925 5.64583H8.89592C9.35615 5.64583 9.72925 5.27274 9.72925 4.8125C9.72925 4.35226 9.35615 3.97917 8.89592 3.97917Z\" fill=\"white\"/>   <path d=\"M16.3959 15.6458H13.8959C13.4357 15.6458 13.0626 16.0189 13.0626 16.4792C13.0626 16.9394 13.4357 17.3125 13.8959 17.3125H16.3959C17.7766 17.3125 18.8959 16.1932 18.8959 14.8125V6.47917C18.8959 5.09845 17.7766 3.97917 16.3959 3.97917H13.8959C13.4357 3.97917 13.0626 4.35226 13.0626 4.8125C13.0626 5.27274 13.4357 5.64583 13.8959 5.64583H16.3959C16.8562 5.64583 17.2292 6.01893 17.2292 6.47917V14.8125C17.2292 15.2727 16.8562 15.6458 16.3959 15.6458Z\" fill=\"white\"/>   <path d=\"M13.8959 7.3125C13.4357 7.3125 13.0626 7.6856 13.0626 8.14583C13.0626 8.60607 13.4357 8.97917 13.8959 8.97917H15.5626C16.0228 8.97917 16.3959 8.60607 16.3959 8.14583C16.3959 7.6856 16.0228 7.3125 15.5626 7.3125H13.8959Z\" fill=\"white\"/>   <path d=\"M13.0626 13.1458C13.0626 12.6856 13.4357 12.3125 13.8959 12.3125H15.5626C16.0228 12.3125 16.3959 12.6856 16.3959 13.1458C16.3959 13.6061 16.0228 13.9792 15.5626 13.9792H13.8959C13.4357 13.9792 13.0626 13.6061 13.0626 13.1458Z\" fill=\"white\"/>   <path d=\"M13.8959 9.8125C13.4357 9.8125 13.0626 10.1856 13.0626 10.6458C13.0626 11.1061 13.4357 11.4792 13.8959 11.4792H15.5626C16.0228 11.4792 16.3959 11.1061 16.3959 10.6458C16.3959 10.1856 16.0228 9.8125 15.5626 9.8125H13.8959Z\" fill=\"white\"/>   <path d=\"M8.9625 10.4661C9.22917 10.62 9.22917 11.005 8.9625 11.1589L6.4125 12.6312C6.14583 12.7851 5.8125 12.5927 5.8125 12.2847V9.34026C5.8125 9.03234 6.14583 8.83989 6.4125 8.99385L8.9625 10.4661Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 36520:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M9 7h4a1 1 0 0 1 0 2H9v4a1 1 0 0 1-2 0V9H3a1 1 0 1 1 0-2h4V3a1 1 0 1 1 2 0v4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 14211:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"10","viewBox":"0 0 21 10"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill=\"#ED5454\" d=\"M3 0h1v10H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z\"/>         <path fill=\"#8BC34A\" d=\"M18 0h-1v10h1a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3z\"/>         <path fill=\"#FDA639\" d=\"M4 0h13v10H4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 49962:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"10","viewBox":"0 0 21 10"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <rect width=\"21\" height=\"10\" fill=\"#F5F5F5\" rx=\"3\"/>         <path fill=\"#8BC34A\" d=\"M3 0h13v10H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 54958:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 2C2.89543 2 2 2.89543 2 4V6C2 7.10457 2.89543 8 4 8H20C21.1046 8 22 7.10457 22 6V4C22 2.89543 21.1046 2 20 2H4ZM8 4H20V6H8V4Z\" fill=\"black\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 11C2 9.89543 2.89543 9 4 9H20C21.1046 9 22 9.89543 22 11V13C22 14.1046 21.1046 15 20 15H4C2.89543 15 2 14.1046 2 13V11ZM20 11H12V13H20V11Z\" fill=\"black\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 18C2 16.8954 2.89543 16 4 16H20C21.1046 16 22 16.8954 22 18V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V18ZM16 18H20V20H16V18Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 38312:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M11.375 4.37437L10.5059 5.24354L8.75586 3.49354L9.62503 2.62437C9.87003 2.37937 10.185 2.2627 10.5 2.2627C10.815 2.2627 11.13 2.37937 11.375 2.62437C11.8592 3.10854 11.8592 3.8902 11.375 4.37437Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M10.0967 5.65788L3.79086 11.9579C3.30669 12.442 2.52503 12.442 2.04086 11.9579C1.55669 11.4737 1.55669 10.692 2.04086 10.2079L8.34672 3.90788L10.0967 5.65788Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M5.80511 2.04197L6.04427 1.23113C6.06761 1.1553 6.04427 1.07363 5.99177 1.0153C5.93927 0.956966 5.84594 0.933633 5.77011 0.956966L4.95928 1.19613L4.14845 0.956966C4.07261 0.933633 3.99095 0.956966 3.93261 1.00947C3.87428 1.0678 3.85678 1.14947 3.88011 1.2253L4.11345 2.04197L3.87428 2.8528C3.85095 2.92863 3.87428 3.0103 3.92678 3.06863C3.98511 3.12697 4.06678 3.14447 4.14261 3.12113L4.95928 2.8878L5.77011 3.12697C5.79345 3.1328 5.81095 3.13863 5.83427 3.13863C5.89261 3.13863 5.94511 3.1153 5.99177 3.07447C6.05011 3.01613 6.06761 2.93447 6.04427 2.85863L5.80511 2.04197Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M3.47113 5.54197L3.71029 4.73113C3.73363 4.65529 3.71029 4.57363 3.65779 4.5153C3.59946 4.45697 3.51779 4.43947 3.44196 4.4628L2.62529 4.69613L1.81446 4.45697C1.73862 4.43363 1.65696 4.45697 1.59863 4.50947C1.54029 4.5678 1.52279 4.64947 1.54613 4.7253L1.77946 5.54197L1.54029 6.35279C1.51696 6.42863 1.54029 6.51029 1.59279 6.56863C1.65113 6.62696 1.73279 6.64446 1.80862 6.62113L2.61946 6.38196L3.43029 6.62113C3.44779 6.62696 3.47113 6.62696 3.49446 6.62696C3.55279 6.62696 3.60529 6.60363 3.65196 6.56279C3.71029 6.50446 3.72779 6.42279 3.70446 6.34696L3.47113 5.54197Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M12.2202 8.45834L12.4593 7.6475C12.4827 7.57167 12.4593 7.49 12.4068 7.43167C12.3485 7.37334 12.2668 7.35584 12.191 7.37917L11.3802 7.61834L10.5693 7.37917C10.4935 7.35584 10.4118 7.37917 10.3535 7.43167C10.2952 7.49 10.2777 7.57167 10.301 7.6475L10.5402 8.45834L10.301 9.26917C10.2777 9.34501 10.301 9.42667 10.3535 9.485C10.4118 9.54334 10.4935 9.56084 10.5693 9.5375L11.3802 9.29834L12.191 9.5375C12.2085 9.54334 12.2318 9.54334 12.2552 9.54334C12.3135 9.54334 12.366 9.52 12.4127 9.47917C12.471 9.42084 12.4885 9.33917 12.4652 9.26334L12.2202 8.45834Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 40286:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<path class=\"graphics\" fill=\"#AEB7B8\" fill-rule=\"evenodd\" d=\"M13.333 8A5.333 5.333 0 1 1 2.667 8a5.333 5.333 0 0 1 10.666 0zm1.334 0A6.667 6.667 0 1 1 1.333 8a6.667 6.667 0 0 1 13.334 0zM6.998 5.735a1.406 1.406 0 0 0-.331.932.667.667 0 0 1-1.334 0c0-.642.214-1.306.669-1.818C6.468 4.324 7.152 4 8 4c1.687 0 2.667 1.357 2.667 2.667 0 .417-.106.781-.372 1.116-.232.292-.565.532-.925.772-.472.314-.624.498-.673.58-.026.042-.03.05-.03.198a.667.667 0 0 1-1.334 0v-.01c0-.187 0-.507.22-.874.201-.335.549-.651 1.077-1.004.369-.246.535-.383.621-.491.052-.065.082-.125.082-.287 0-.69-.495-1.334-1.333-1.334-.486 0-.801.176-1.002.402zm1.669 5.598a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 67308:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M7.608 13.954a9.589 9.589 0 0 1-1.255 1.265 7.536 7.536 0 0 1-1.765 1.118 1 1 0 1 0 .824 1.822 9.455 9.455 0 0 0 2.235-1.416C9.639 15.051 11 12.969 11 10a4 4 0 1 0-3.392 3.954zm8.745 1.265a9.589 9.589 0 0 0 1.255-1.265A4 4 0 1 1 21 10c0 2.969-1.361 5.051-3.353 6.743a9.455 9.455 0 0 1-2.235 1.416.999.999 0 1 1-.824-1.822 7.536 7.536 0 0 0 1.765-1.118z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 8507:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#00a1b7\" d=\"M4 12V3a1 1 0 0 1 1-1h4c1.264 0 2.233.641 2.942 1.11l.084.055C12.814 3.685 13.342 4 14 4c.745 0 1.811-.398 2.803-.894a18.198 18.198 0 0 0 1.617-.921l.021-.014.005-.003A.998.998 0 0 1 20 3v9a1 1 0 0 1-.445.832L19 12l.555.832-.005.003-.008.006-.03.019-.108.07a20.529 20.529 0 0 1-1.707.964C16.689 14.398 15.255 15 14 15c-1.301 0-2.315-.645-3.062-1.121l-.055-.035C10.05 13.314 9.517 13 8.889 13H6v8a1 1 0 0 1-2 0v-9z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 80764:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#AEB7B8\" d=\"M4 12V3a1 1 0 0 1 1-1h4c1.264 0 2.233.641 2.942 1.11l.084.055C12.814 3.685 13.342 4 14 4c.745 0 1.811-.398 2.803-.894a18.198 18.198 0 0 0 1.617-.921l.021-.014.005-.003A.998.998 0 0 1 20 3v9a1 1 0 0 1-.445.832L19 12l.555.832-.005.003-.008.006-.03.019-.108.07a20.529 20.529 0 0 1-1.707.964C16.689 14.398 15.255 15 14 15c-1.301 0-2.315-.645-3.062-1.121l-.055-.035C10.05 13.314 9.517 13 8.889 13H6v8a1 1 0 0 1-2 0v-9z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 98763:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#e8e8e8\" d=\"M4 12V3a1 1 0 0 1 1-1h4c1.264 0 2.233.641 2.942 1.11l.084.055C12.814 3.685 13.342 4 14 4c.745 0 1.811-.398 2.803-.894a18.198 18.198 0 0 0 1.617-.921l.021-.014.005-.003A.998.998 0 0 1 20 3v9a1 1 0 0 1-.445.832L19 12l.555.832-.005.003-.008.006-.03.019-.108.07a20.529 20.529 0 0 1-1.707.964C16.689 14.398 15.255 15 14 15c-1.301 0-2.315-.645-3.062-1.121l-.055-.035C10.05 13.314 9.517 13 8.889 13H6v8a1 1 0 0 1-2 0v-9z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 55009:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#ed5454\" d=\"M4 12V3a1 1 0 0 1 1-1h4c1.264 0 2.233.641 2.942 1.11l.084.055C12.814 3.685 13.342 4 14 4c.745 0 1.811-.398 2.803-.894a18.198 18.198 0 0 0 1.617-.921l.021-.014.005-.003A.998.998 0 0 1 20 3v9a1 1 0 0 1-.445.832L19 12l.555.832-.005.003-.008.006-.03.019-.108.07a20.529 20.529 0 0 1-1.707.964C16.689 14.398 15.255 15 14 15c-1.301 0-2.315-.645-3.062-1.121l-.055-.035C10.05 13.314 9.517 13 8.889 13H6v8a1 1 0 0 1-2 0v-9z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 71138:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path fill=\"#00a1b7\" fill-rule=\"evenodd\" d=\"M12 5.683C10.842 4.777 9.185 4 7.5 4 4.724 4 2 6.296 2 9.688c0 1.52.245 2.73.773 3.83.52 1.084 1.285 1.996 2.206 2.956 1.036 1.08 2.713 2.192 4.056 3.004a47.811 47.811 0 0 0 2.454 1.383l.04.021.01.006.005.002L12 20l-.456.89c.286.146.626.147.912 0L12 20l.456.89.004-.002.011-.006.04-.02.15-.079c.128-.068.313-.166.54-.29.453-.248 1.078-.6 1.764-1.015 1.343-.812 3.02-1.925 4.056-3.004.921-.96 1.685-1.872 2.206-2.955.528-1.101.773-2.31.773-3.832C22 6.297 19.276 4 16.5 4c-1.685 0-3.342.777-4.5 1.683z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 85625:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path fill=\"#AEB7B8\" fill-rule=\"evenodd\" d=\"M12 5.683C10.842 4.777 9.185 4 7.5 4 4.724 4 2 6.296 2 9.688c0 1.52.245 2.73.773 3.83.52 1.084 1.285 1.996 2.206 2.956 1.036 1.08 2.713 2.192 4.056 3.004a47.811 47.811 0 0 0 2.454 1.383l.04.021.01.006.005.002L12 20l-.456.89c.286.146.626.147.912 0L12 20l.456.89.004-.002.011-.006.04-.02.15-.079c.128-.068.313-.166.54-.29.453-.248 1.078-.6 1.764-1.015 1.343-.812 3.02-1.925 4.056-3.004.921-.96 1.685-1.872 2.206-2.955.528-1.101.773-2.31.773-3.832C22 6.297 19.276 4 16.5 4c-1.685 0-3.342.777-4.5 1.683z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 16030:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path fill=\"#e8e8e8\" fill-rule=\"evenodd\" d=\"M12 5.683C10.842 4.777 9.185 4 7.5 4 4.724 4 2 6.296 2 9.688c0 1.52.245 2.73.773 3.83.52 1.084 1.285 1.996 2.206 2.956 1.036 1.08 2.713 2.192 4.056 3.004a47.811 47.811 0 0 0 2.454 1.383l.04.021.01.006.005.002L12 20l-.456.89c.286.146.626.147.912 0L12 20l.456.89.004-.002.011-.006.04-.02.15-.079c.128-.068.313-.166.54-.29.453-.248 1.078-.6 1.764-1.015 1.343-.812 3.02-1.925 4.056-3.004.921-.96 1.685-1.872 2.206-2.955.528-1.101.773-2.31.773-3.832C22 6.297 19.276 4 16.5 4c-1.685 0-3.342.777-4.5 1.683z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 61335:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path fill=\"#ed5454\" fill-rule=\"evenodd\" d=\"M12 5.683C10.842 4.777 9.185 4 7.5 4 4.724 4 2 6.296 2 9.688c0 1.52.245 2.73.773 3.83.52 1.084 1.285 1.996 2.206 2.956 1.036 1.08 2.713 2.192 4.056 3.004a47.811 47.811 0 0 0 2.454 1.383l.04.021.01.006.005.002L12 20l-.456.89c.286.146.626.147.912 0L12 20l.456.89.004-.002.011-.006.04-.02.15-.079c.128-.068.313-.166.54-.29.453-.248 1.078-.6 1.764-1.015 1.343-.812 3.02-1.925 4.056-3.004.921-.96 1.685-1.872 2.206-2.955.528-1.101.773-2.31.773-3.832C22 6.297 19.276 4 16.5 4c-1.685 0-3.342.777-4.5 1.683z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 37322:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path fill=\"#00a1b7\" fill-rule=\"evenodd\" d=\"M10.548 3.807c.467-1.343 2.367-1.343 2.834 0l1.65 4.748 5.026.103c1.422.029 2.009 1.836.875 2.695l-4.005 3.037 1.455 4.81c.412 1.362-1.125 2.479-2.292 1.666l-4.126-2.87-4.126 2.87c-1.167.813-2.704-.304-2.293-1.665l1.456-4.811-4.006-3.037c-1.133-.86-.546-2.666.876-2.695l5.026-.103 1.65-4.748z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 75851:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path fill=\"#AEB7B8\" fill-rule=\"evenodd\" d=\"M10.548 3.807c.467-1.343 2.367-1.343 2.834 0l1.65 4.748 5.026.103c1.422.029 2.009 1.836.875 2.695l-4.005 3.037 1.455 4.81c.412 1.362-1.125 2.479-2.292 1.666l-4.126-2.87-4.126 2.87c-1.167.813-2.704-.304-2.293-1.665l1.456-4.811-4.006-3.037c-1.133-.86-.546-2.666.876-2.695l5.026-.103 1.65-4.748z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 4735:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path fill=\"#e8e8e8\" fill-rule=\"evenodd\" d=\"M10.548 3.807c.467-1.343 2.367-1.343 2.834 0l1.65 4.748 5.026.103c1.422.029 2.009 1.836.875 2.695l-4.005 3.037 1.455 4.81c.412 1.362-1.125 2.479-2.292 1.666l-4.126-2.87-4.126 2.87c-1.167.813-2.704-.304-2.293-1.665l1.456-4.811-4.006-3.037c-1.133-.86-.546-2.666.876-2.695l5.026-.103 1.65-4.748z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 76936:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path fill=\"#fda639\" fill-rule=\"evenodd\" d=\"M10.548 3.807c.467-1.343 2.367-1.343 2.834 0l1.65 4.748 5.026.103c1.422.029 2.009 1.836.875 2.695l-4.005 3.037 1.455 4.81c.412 1.362-1.125 2.479-2.292 1.666l-4.126-2.87-4.126 2.87c-1.167.813-2.704-.304-2.293-1.665l1.456-4.811-4.006-3.037c-1.133-.86-.546-2.666.876-2.695l5.026-.103 1.65-4.748z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 14698:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.0002 32C24.8368 32 32.0002 24.8366 32.0002 16C32.0002 7.16344 24.8368 0 16.0002 0C7.16369 0 0.000244141 7.16344 0.000244141 16C0.000244141 24.8366 7.16369 32 16.0002 32Z\" fill=\"#00A1B7\"/> <rect x=\"11.0002\" y=\"11\" width=\"10\" height=\"10\" rx=\"5\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 20065:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.58963 3.36764C4.85564 3.10011 5.28727 3.10011 5.55328 3.36764C5.81876 3.63464 5.81876 4.06716 5.55328 4.33416L4.65667 5.23596H10.5572C12.8277 5.23596 14.6667 7.0869 14.6667 9.36814C14.6667 11.6494 12.8277 13.5003 10.5572 13.5003H5.75717C5.3802 13.5003 5.07622 13.1932 5.07622 12.8164C5.07622 12.4396 5.3802 12.1325 5.75717 12.1325H10.5572C12.0737 12.1325 13.3048 10.8958 13.3048 9.36814C13.3048 7.84052 12.0737 6.60377 10.5572 6.60377H4.65667L5.55328 7.50557C5.81876 7.77258 5.81876 8.20506 5.55328 8.47207C5.28727 8.73961 4.85564 8.73961 4.58963 8.47207L2.53249 6.40312C2.267 6.13612 2.267 5.70361 2.53249 5.43661L4.58963 3.36764Z\" fill=\"currentColor\"></path>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 88170:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z\" fill=\"#00A1B7\"/> <path d=\"M15.3333 9.33337C14.2288 9.33337 13.3333 10.2288 13.3333 11.3334V12H11.3333C10.9651 12 10.6667 12.2985 10.6667 12.6667C10.6667 13.0349 10.9651 13.3334 11.3333 13.3334V20.6667C11.3333 21.7713 12.2288 22.6667 13.3333 22.6667H18.6667C19.7712 22.6667 20.6667 21.7713 20.6667 20.6667V13.3334C21.0348 13.3334 21.3333 13.0349 21.3333 12.6667C21.3333 12.2985 21.0348 12 20.6667 12H18.6667V11.3334C18.6667 10.2288 17.7712 9.33337 16.6667 9.33337H15.3333ZM17.3333 12H14.6667V11.3334C14.6667 10.9652 14.9651 10.6667 15.3333 10.6667H16.6667C17.0348 10.6667 17.3333 10.9652 17.3333 11.3334V12ZM12.6667 13.3334L19.3333 13.3334V20.6667C19.3333 21.0349 19.0348 21.3334 18.6667 21.3334H13.3333C12.9651 21.3334 12.6667 21.0349 12.6667 20.6667V13.3334ZM15.3333 15.3334V19.3334C15.3333 19.7016 15.0348 20 14.6667 20C14.2985 20 14 19.7016 14 19.3334V15.3334C14 14.9652 14.2985 14.6667 14.6667 14.6667C15.0348 14.6667 15.3333 14.9652 15.3333 15.3334ZM17.3333 14.6667C16.9651 14.6667 16.6667 14.9652 16.6667 15.3334V19.3334C16.6667 19.7016 16.9651 20 17.3333 20C17.7015 20 18 19.7016 18 19.3334V15.3334C18 14.9652 17.7015 14.6667 17.3333 14.6667Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 36039:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M4.66683 4C4.29864 4 4.00016 4.29848 4.00016 4.66667C4.00016 5.03486 4.29864 5.33333 4.66683 5.33333H9.3335C10.5761 5.33333 11.6201 6.18318 11.9162 7.33333H11.0819C10.728 7.33333 10.537 7.7762 10.7674 8.06287L12.1007 9.72221C12.3983 10.0926 12.9354 10.0926 13.233 9.72221L14.5663 8.06287C14.7966 7.7762 14.6057 7.33333 14.2518 7.33333H13.2782C12.9608 5.44152 11.3155 4 9.3335 4H4.66683Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M12.0002 11.3333C12.0002 11.7015 11.7017 12 11.3335 12H6.66683C4.68483 12 3.03952 10.5585 2.72213 8.66667H1.74857C1.39463 8.66667 1.20369 8.2238 1.43403 7.93713L2.76732 6.27779C3.06493 5.9074 3.60207 5.9074 3.89967 6.27779L5.23296 7.93713C5.4633 8.2238 5.27236 8.66667 4.91842 8.66667H4.08417C4.3802 9.81682 5.42427 10.6667 6.66683 10.6667H11.3335C11.7017 10.6667 12.0002 10.9651 12.0002 11.3333Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 91323:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#AEB7B8\" d=\"M12 6v6H6zM4 4h6l-6 6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 61762:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"47","height":"46","viewBox":"0 0 47 46","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.1583 11.3914C44.1583 9.56889 42.6808 8.09143 40.8583 8.09143H33.275C32.557 8.09143 31.975 8.67346 31.975 9.39143C31.975 10.1094 32.557 10.6914 33.275 10.6914H40.8583C41.2449 10.6914 41.5583 11.0048 41.5583 11.3914V16.0998C41.5583 16.8177 42.1403 17.3998 42.8583 17.3998C43.5763 17.3998 44.1583 16.8177 44.1583 16.0998V11.3914ZM15.4083 9.39143C15.4083 8.67346 14.8263 8.09143 14.1083 8.09143H6.52497C4.70243 8.09143 3.22498 9.56889 3.22498 11.3914V16.0998C3.22498 16.8177 3.807 17.3998 4.52497 17.3998C5.24295 17.3998 5.82497 16.8177 5.82497 16.0998V11.3914C5.82497 11.0048 6.13837 10.6914 6.52497 10.6914H14.1083C14.8263 10.6914 15.4083 10.1094 15.4083 9.39143ZM42.8583 28.2164C42.1403 28.2164 41.5583 28.7985 41.5583 29.5164V34.2248C41.5583 34.6114 41.2449 34.9248 40.8583 34.9248H33.275C32.557 34.9248 31.975 35.5068 31.975 36.2248C31.975 36.9427 32.557 37.5248 33.275 37.5248H40.8583C42.6808 37.5248 44.1583 36.0473 44.1583 34.2248V29.5164C44.1583 28.7985 43.5763 28.2164 42.8583 28.2164Z\" fill=\"#00A1B7\"/> <path d=\"M29.5833 23C29.5833 21.8 28.1274 21.0236 25.2157 19.4706C22.5888 18.0696 21.2753 17.3691 20.3043 17.9517L20.3043 17.9517C19.3333 18.5343 19.3333 20.0229 19.3333 23C19.3333 25.9772 19.3333 27.4658 20.3043 28.0484C21.2753 28.631 22.5888 27.9305 25.2157 26.5295C28.1274 24.9765 29.5833 24.2 29.5833 23Z\" fill=\"#00A1B7\"/> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.5 33C19.5 37.9706 15.4706 42 10.5 42C5.52944 42 1.5 37.9706 1.5 33C1.5 28.0294 5.52944 24 10.5 24C15.4706 24 19.5 28.0294 19.5 33ZM12.8625 30.6375C12.8625 31.9423 11.8048 33 10.5 33C9.19523 33 8.1375 31.9423 8.1375 30.6375C8.1375 29.3327 9.19523 28.275 10.5 28.275C11.8048 28.275 12.8625 29.3327 12.8625 30.6375ZM13.8718 37.0538C14.3662 36.8479 14.5539 36.2508 14.224 35.829C13.3592 34.7233 12.0126 34.0125 10.5 34.0125C8.98738 34.0125 7.64079 34.7233 6.77596 35.829C6.44606 36.2508 6.6338 36.8479 7.12812 37.0538C8.16623 37.4862 9.30522 37.725 10.5 37.725C11.6947 37.725 12.8337 37.4862 13.8718 37.0538Z\" fill=\"#00A1B7\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 80562:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"47","height":"46","viewBox":"0 0 47 46","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.1583 11.3914C44.1583 9.56889 42.6808 8.09143 40.8583 8.09143H33.275C32.557 8.09143 31.975 8.67346 31.975 9.39143C31.975 10.1094 32.557 10.6914 33.275 10.6914H40.8583C41.2449 10.6914 41.5583 11.0048 41.5583 11.3914V16.0998C41.5583 16.8177 42.1403 17.3998 42.8583 17.3998C43.5763 17.3998 44.1583 16.8177 44.1583 16.0998V11.3914ZM15.4083 9.39143C15.4083 8.67346 14.8263 8.09143 14.1083 8.09143H6.52497C4.70243 8.09143 3.22498 9.56889 3.22498 11.3914V16.0998C3.22498 16.8177 3.807 17.3998 4.52497 17.3998C5.24295 17.3998 5.82497 16.8177 5.82497 16.0998V11.3914C5.82497 11.0048 6.13837 10.6914 6.52497 10.6914H14.1083C14.8263 10.6914 15.4083 10.1094 15.4083 9.39143ZM42.8583 28.2164C42.1403 28.2164 41.5583 28.7985 41.5583 29.5164V34.2248C41.5583 34.6114 41.2449 34.9248 40.8583 34.9248H33.275C32.557 34.9248 31.975 35.5068 31.975 36.2248C31.975 36.9427 32.557 37.5248 33.275 37.5248H40.8583C42.6808 37.5248 44.1583 36.0473 44.1583 34.2248V29.5164C44.1583 28.7985 43.5763 28.2164 42.8583 28.2164Z\" fill=\"#A5B3BD\"/> <path d=\"M29.5833 23C29.5833 21.8 28.1274 21.0236 25.2157 19.4706C22.5888 18.0696 21.2753 17.3691 20.3043 17.9517L20.3043 17.9517C19.3333 18.5343 19.3333 20.0229 19.3333 23C19.3333 25.9772 19.3333 27.4658 20.3043 28.0484C21.2753 28.631 22.5888 27.9305 25.2157 26.5295C28.1274 24.9765 29.5833 24.2 29.5833 23Z\" fill=\"#A5B3BD\"/> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.5 33C19.5 37.9706 15.4706 42 10.5 42C5.52944 42 1.5 37.9706 1.5 33C1.5 28.0294 5.52944 24 10.5 24C15.4706 24 19.5 28.0294 19.5 33ZM12.8625 30.6375C12.8625 31.9423 11.8048 33 10.5 33C9.19523 33 8.1375 31.9423 8.1375 30.6375C8.1375 29.3327 9.19523 28.275 10.5 28.275C11.8048 28.275 12.8625 29.3327 12.8625 30.6375ZM13.8718 37.0538C14.3662 36.8479 14.5539 36.2508 14.224 35.829C13.3592 34.7233 12.0126 34.0125 10.5 34.0125C8.98738 34.0125 7.64079 34.7233 6.77596 35.829C6.44606 36.2508 6.6338 36.8479 7.12812 37.0538C8.16623 37.4862 9.30522 37.725 10.5 37.725C11.6947 37.725 12.8337 37.4862 13.8718 37.0538Z\" fill=\"#A5B3BD\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 77142:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"47","height":"46","viewBox":"0 0 47 46","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.1583 11.3914C44.1583 9.56889 42.6808 8.09143 40.8583 8.09143H33.275C32.557 8.09143 31.975 8.67346 31.975 9.39143C31.975 10.1094 32.557 10.6914 33.275 10.6914H40.8583C41.2449 10.6914 41.5583 11.0048 41.5583 11.3914V16.0998C41.5583 16.8177 42.1403 17.3998 42.8583 17.3998C43.5763 17.3998 44.1583 16.8177 44.1583 16.0998V11.3914ZM15.4083 9.39143C15.4083 8.67346 14.8263 8.09143 14.1083 8.09143H6.52497C4.70243 8.09143 3.22498 9.56889 3.22498 11.3914V16.0998C3.22498 16.8177 3.807 17.3998 4.52497 17.3998C5.24295 17.3998 5.82497 16.8177 5.82497 16.0998V11.3914C5.82497 11.0048 6.13837 10.6914 6.52497 10.6914H14.1083C14.8263 10.6914 15.4083 10.1094 15.4083 9.39143ZM42.8583 28.2164C42.1403 28.2164 41.5583 28.7985 41.5583 29.5164V34.2248C41.5583 34.6114 41.2449 34.9248 40.8583 34.9248H33.275C32.557 34.9248 31.975 35.5068 31.975 36.2248C31.975 36.9427 32.557 37.5248 33.275 37.5248H40.8583C42.6808 37.5248 44.1583 36.0473 44.1583 34.2248V29.5164C44.1583 28.7985 43.5763 28.2164 42.8583 28.2164ZM4.52497 28.2164C3.807 28.2164 3.22498 28.7985 3.22498 29.5164V34.2248C3.22498 36.0473 4.70243 37.5248 6.52497 37.5248H14.1083C14.8263 37.5248 15.4083 36.9427 15.4083 36.2248C15.4083 35.5068 14.8263 34.9248 14.1083 34.9248H6.52497C6.13838 34.9248 5.82497 34.6114 5.82497 34.2248V29.5164C5.82497 28.7985 5.24295 28.2164 4.52497 28.2164Z\" fill=\"#00A1B7\"/> <path d=\"M29.5833 23C29.5833 21.8 28.1274 21.0236 25.2157 19.4706C22.5888 18.0696 21.2753 17.3691 20.3043 17.9517L20.3043 17.9517C19.3333 18.5343 19.3333 20.0229 19.3333 23C19.3333 25.9772 19.3333 27.4658 20.3043 28.0484C21.2753 28.631 22.5888 27.9305 25.2157 26.5295C28.1274 24.9765 29.5833 24.2 29.5833 23Z\" fill=\"#00A1B7\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 30315:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"47","height":"46","viewBox":"0 0 47 46","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.1583 11.3914C44.1583 9.56889 42.6808 8.09143 40.8583 8.09143H33.275C32.557 8.09143 31.975 8.67346 31.975 9.39143C31.975 10.1094 32.557 10.6914 33.275 10.6914H40.8583C41.2449 10.6914 41.5583 11.0048 41.5583 11.3914V16.0998C41.5583 16.8177 42.1403 17.3998 42.8583 17.3998C43.5763 17.3998 44.1583 16.8177 44.1583 16.0998V11.3914ZM15.4083 9.39143C15.4083 8.67346 14.8263 8.09143 14.1083 8.09143H6.52497C4.70243 8.09143 3.22498 9.56889 3.22498 11.3914V16.0998C3.22498 16.8177 3.807 17.3998 4.52497 17.3998C5.24295 17.3998 5.82497 16.8177 5.82497 16.0998V11.3914C5.82497 11.0048 6.13837 10.6914 6.52497 10.6914H14.1083C14.8263 10.6914 15.4083 10.1094 15.4083 9.39143ZM42.8583 28.2164C42.1403 28.2164 41.5583 28.7985 41.5583 29.5164V34.2248C41.5583 34.6114 41.2449 34.9248 40.8583 34.9248H33.275C32.557 34.9248 31.975 35.5068 31.975 36.2248C31.975 36.9427 32.557 37.5248 33.275 37.5248H40.8583C42.6808 37.5248 44.1583 36.0473 44.1583 34.2248V29.5164C44.1583 28.7985 43.5763 28.2164 42.8583 28.2164ZM4.52497 28.2164C3.807 28.2164 3.22498 28.7985 3.22498 29.5164V34.2248C3.22498 36.0473 4.70243 37.5248 6.52497 37.5248H14.1083C14.8263 37.5248 15.4083 36.9427 15.4083 36.2248C15.4083 35.5068 14.8263 34.9248 14.1083 34.9248H6.52497C6.13838 34.9248 5.82497 34.6114 5.82497 34.2248V29.5164C5.82497 28.7985 5.24295 28.2164 4.52497 28.2164Z\" fill=\"#A5B3BD\"/> <path d=\"M29.5833 23C29.5833 21.8 28.1274 21.0236 25.2157 19.4706C22.5888 18.0696 21.2753 17.3691 20.3043 17.9517L20.3043 17.9517C19.3333 18.5343 19.3333 20.0229 19.3333 23C19.3333 25.9772 19.3333 27.4658 20.3043 28.0484C21.2753 28.631 22.5888 27.9305 25.2157 26.5295C28.1274 24.9765 29.5833 24.2 29.5833 23Z\" fill=\"#A5B3BD\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 26350:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <circle cx=\"9.5\" cy=\"6.5\" r=\"5\" stroke=\"#5C6061\"/>         <path class=\"graphic\" stroke=\"#5C6061\" stroke-linecap=\"round\" stroke-width=\"2\" d=\"M5 11l-2.5 2.5\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 31665:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M10.667 3.333a1.333 1.333 0 1 0 0 2.667 1.333 1.333 0 0 0 0-2.667zM8 4.667a2.667 2.667 0 1 1 .487 1.537l-1.356.775c.13.314.202.659.202 1.021 0 .362-.072.707-.202 1.021l1.356.775a2.667 2.667 0 1 1-.474 1.265l-1.694-.968a2.667 2.667 0 1 1 0-4.187l1.695-.967A2.712 2.712 0 0 1 8 4.667zm-3.333 2a1.333 1.333 0 1 0 0 2.666 1.333 1.333 0 0 0 0-2.666zm4.666 4.666a1.333 1.333 0 1 1 2.667 0 1.333 1.333 0 0 1-2.667 0z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 71571:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"19","height":"17","viewBox":"0 0 19 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M6 0C6.55228 0 7 0.447715 7 1V7H11V1C11 0.447715 11.4477 0 12 0C12.5523 0 13 0.447715 13 1V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V9H7V15C7 15.5523 6.55228 16 6 16C5.44772 16 5 15.5523 5 15V1C5 0.447715 5.44772 0 6 0Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M16.4592 11C16.3183 11 16.1852 11.0647 16.0981 11.1755C16.0819 11.1962 16.0697 11.2148 16.0612 11.23C16.0942 11.3176 16.134 11.3773 16.1718 11.4124C16.1919 11.4311 16.2178 11.4492 16.2583 11.4646C16.2998 11.4803 16.3751 11.5 16.5 11.5C17.1025 11.5 17.6161 11.654 18.0266 11.942C18.4313 12.2259 18.6665 12.5912 18.8005 12.904C19.1429 13.7037 18.7843 14.4426 18.5198 14.8273C17.5437 16.2471 15.5124 16.4183 14.3124 15.1819L14.2824 15.151C13.8978 14.7547 13.9072 14.1216 14.3035 13.737C14.6998 13.3523 15.3329 13.3618 15.7176 13.7581L15.7476 13.789C16.0682 14.1193 16.6109 14.0736 16.8717 13.6942C16.8916 13.6653 16.907 13.6392 16.9184 13.6169C16.9059 13.6016 16.8924 13.5894 16.878 13.5793C16.8514 13.5606 16.7533 13.5 16.5 13.5C15.7988 13.5 15.2293 13.2667 14.8105 12.8776C14.4138 12.5091 14.2197 12.0641 14.1223 11.7345C13.9022 10.9897 14.2163 10.3334 14.5255 9.93987C14.9917 9.34648 15.7046 9 16.4592 9H16.5432C16.8963 9 17.2459 9.07108 17.571 9.20902L18.0156 9.3976C18.524 9.61329 18.7613 10.2003 18.5456 10.7087C18.3299 11.2172 17.7429 11.4545 17.2344 11.2388L16.7899 11.0502C16.7119 11.0171 16.628 11 16.5432 11H16.4592Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M2.31204 9.6109C2.15191 9.81056 1.84807 9.81056 1.68794 9.6109L0.11556 7.65025C-0.0944184 7.38842 0.0919813 7 0.427607 7H3.57237C3.908 7 4.0944 7.38842 3.88442 7.65025L2.31204 9.6109Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 37620:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#AEB7B8\" d=\"M8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10zm0 1A6 6 0 1 1 8 2a6 6 0 0 1 0 12zM6 9h4c0 1.333-.667 2-2 2s-2-.667-2-2zm4-1c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8zM6 8c-.552 0-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5S6.552 8 6 8z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 17884:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<path class=\"graphic\" fill=\"#FFF\" fill-rule=\"evenodd\" d=\"M2.667 3.333a.667.667 0 0 0 0 1.334H8a.667.667 0 1 0 0-1.334H2.667zM2 8c0-.368.298-.667.667-.667h8a.667.667 0 1 1 0 1.334h-8A.667.667 0 0 1 2 8zm0 4c0-.368.298-.667.667-.667h10.666a.667.667 0 1 1 0 1.334H2.667A.667.667 0 0 1 2 12z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 59681:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<path class=\"graphic\" fill=\"#FFF\" fill-rule=\"evenodd\" d=\"M2 4c0-.368.298-.667.667-.667h10.666a.667.667 0 1 1 0 1.334H2.667A.667.667 0 0 1 2 4zm0 4c0-.368.298-.667.667-.667h8a.667.667 0 1 1 0 1.334h-8A.667.667 0 0 1 2 8zm.667 3.333a.667.667 0 1 0 0 1.334H8a.667.667 0 1 0 0-1.334H2.667z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 24570:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"19","height":"14","viewBox":"0 0 19 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"player\" d=\"M1.13867 8.89784C0.437787 7.7297 0.437786 6.27037 1.13867 5.10223C1.36726 4.72125 1.75537 4.46355 2.19521 4.40072L4.5262 4.06772C4.82768 4.02465 5.09654 3.85521 5.26546 3.60182L5.63256 3.05118C5.9233 2.61507 6.06869 2.39699 6.23034 2.20094C6.80071 1.50925 7.54656 0.983633 8.38979 0.679139C8.62879 0.592836 8.88304 0.529272 9.39155 0.402145L10.0046 0.248883C10.3447 0.163862 10.5147 0.121352 10.6486 0.163014C10.7648 0.199186 10.8638 0.276507 10.9271 0.38048C11 0.500235 11 0.675509 11 1.02606V12.974C11 13.3246 11 13.4998 10.9271 13.6196C10.8638 13.7236 10.7648 13.8009 10.6486 13.8371C10.5147 13.8787 10.3447 13.8362 10.0046 13.7512L9.39155 13.5979C8.88304 13.4708 8.62879 13.4072 8.38979 13.3209C7.54656 13.0164 6.80071 12.4908 6.23034 11.7991C6.06868 11.6031 5.92331 11.385 5.63256 10.9489L5.26546 10.3983C5.09654 10.1449 4.82768 9.97542 4.5262 9.93235L2.19521 9.59935C1.75537 9.53652 1.36726 9.27883 1.13867 8.89784Z\" fill=\"#00A1B7\"/> <path class=\"player\" d=\"M18.7071 4.29293C19.0976 4.68345 19.0976 5.31662 18.7071 5.70714L17.4142 7.00004L18.7071 8.29293C19.0976 8.68345 19.0976 9.31662 18.7071 9.70714C18.3166 10.0977 17.6834 10.0977 17.2929 9.70714L16 8.41425L14.7071 9.70714C14.3166 10.0977 13.6834 10.0977 13.2929 9.70714C12.9024 9.31662 12.9024 8.68345 13.2929 8.29293L14.5858 7.00004L13.2929 5.70714C12.9024 5.31662 12.9024 4.68345 13.2929 4.29293C13.6834 3.90241 14.3166 3.90241 14.7071 4.29293L16 5.58582L17.2929 4.29293C17.6834 3.90241 18.3166 3.90241 18.7071 4.29293Z\" fill=\"#00A1B7\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 10653:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"14","viewBox":"0 0 16 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"player\" d=\"M1.13867 8.89784C0.437787 7.7297 0.437786 6.27037 1.13867 5.10223C1.36726 4.72125 1.75537 4.46355 2.19521 4.40072L4.5262 4.06772C4.82768 4.02465 5.09654 3.85521 5.26546 3.60182L5.63256 3.05118C5.92331 2.61505 6.06868 2.39699 6.23034 2.20094C6.80071 1.50925 7.54656 0.983633 8.38979 0.679139C8.62879 0.592835 8.88304 0.529272 9.39155 0.402145L10.0046 0.248883C10.3447 0.163862 10.5147 0.121352 10.6486 0.163014C10.7648 0.199186 10.8638 0.276507 10.9271 0.38048C11 0.500235 11 0.675509 11 1.02606V12.974C11 13.3246 11 13.4998 10.9271 13.6196C10.8638 13.7236 10.7648 13.8009 10.6486 13.8371C10.5147 13.8787 10.3447 13.8362 10.0046 13.7512L9.39155 13.5979C8.88304 13.4708 8.62879 13.4072 8.38979 13.3209C7.54656 13.0164 6.80071 12.4908 6.23034 11.7991C6.06868 11.6031 5.92331 11.385 5.63256 10.9489L5.26546 10.3983C5.09654 10.1449 4.82768 9.97542 4.5262 9.93235L2.19521 9.59935C1.75537 9.53652 1.36726 9.27883 1.13867 8.89784Z\" fill=\"#00A1B7\"/> <path class=\"player\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.0052 2.93417C13.2981 2.64128 13.773 2.64128 14.0658 2.93417C15.1386 4.00696 15.744 5.46025 15.7499 6.97738C15.7559 8.49452 15.1621 9.95254 14.0978 11.0337C13.8072 11.3289 13.3323 11.3327 13.0371 11.0421C12.7419 10.7515 12.7382 10.2767 13.0288 9.98147C13.8154 9.18232 14.2544 8.10465 14.25 6.98329C14.2455 5.86193 13.7981 4.78776 13.0052 3.99483C12.7123 3.70194 12.7123 3.22707 13.0052 2.93417Z\" fill=\"#00A1B7\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 42941:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M8.81935 3.19213C9.20847 2.07268 10.7916 2.07267 11.1808 3.19213L12.5561 7.14875L16.7441 7.2341C17.929 7.25824 18.4182 8.76392 17.4738 9.47993L14.1358 12.0106L15.3488 16.02C15.692 17.1543 14.4112 18.0849 13.4384 17.408L10.0001 15.0154L6.56175 17.408C5.58895 18.0849 4.30813 17.1544 4.65132 16.02L5.86431 12.0106L2.52634 9.47993C1.58192 8.76393 2.07114 7.25824 3.25605 7.2341L7.44402 7.14875L8.81935 3.19213ZM10.0001 4.87159L8.9231 7.96984C8.75144 8.46368 8.29058 8.79851 7.76786 8.80917L4.48845 8.876L7.10227 10.8577C7.51889 11.1735 7.69493 11.7153 7.54353 12.2157L6.5937 15.3553L9.28608 13.4817C9.71522 13.1831 10.2849 13.1831 10.714 13.4817L13.4064 15.3553L12.4566 12.2157C12.3052 11.7153 12.4812 11.1735 12.8978 10.8577L15.5116 8.876L12.2322 8.80917C11.7095 8.79851 11.2487 8.46368 11.077 7.96984L10.0001 4.87159Z\" fill=\"black\" fill-opacity=\"0.54\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 57551:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.10057 3.88063C3.22336 3.98697 3.22336 4.17746 3.10057 4.2838L1.77458 5.43214C1.60187 5.58171 1.33334 5.45903 1.33334 5.23056V2.93387C1.33334 2.7054 1.60187 2.58272 1.77458 2.73229L3.10057 3.88063ZM6.66667 3.41555C6.29848 3.41555 6 3.71402 6 4.08221C6 4.4504 6.29848 4.74888 6.66667 4.74888H14C14.3682 4.74888 14.6667 4.4504 14.6667 4.08221C14.6667 3.71402 14.3682 3.41555 14 3.41555H6.66667ZM6.66667 7.41555C6.29848 7.41555 6 7.71402 6 8.08221C6 8.4504 6.29848 8.74888 6.66667 8.74888H14C14.3682 8.74888 14.6667 8.4504 14.6667 8.08221C14.6667 7.71402 14.3682 7.41555 14 7.41555H6.66667ZM6 12.0822C6 11.714 6.29848 11.4155 6.66667 11.4155H14C14.3682 11.4155 14.6667 11.714 14.6667 12.0822C14.6667 12.4504 14.3682 12.7489 14 12.7489H6.66667C6.29848 12.7489 6 12.4504 6 12.0822Z\" fill=\"#737373\"/>   <path class=\"graphic\" d=\"M5 2.66669C5.18409 2.66669 5.33333 2.81593 5.33333 3.00002V5.00002C5.33333 5.18412 5.18409 5.33335 5 5.33335C4.81591 5.33335 4.66667 5.18412 4.66667 5.00002V3.80476L4.56904 3.90239C4.43886 4.03256 4.22781 4.03256 4.09763 3.90239C3.96746 3.77221 3.96746 3.56116 4.09763 3.43098L4.7643 2.76432C4.82462 2.704 4.90795 2.66669 5 2.66669Z\" fill=\"#737373\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 14345:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.0002 32C24.8368 32 32.0002 24.8366 32.0002 16C32.0002 7.16344 24.8368 0 16.0002 0C7.16369 0 0.000244141 7.16344 0.000244141 16C0.000244141 24.8366 7.16369 32 16.0002 32Z\" fill=\"#00A1B7\"/> <rect x=\"11.0002\" y=\"11\" width=\"10\" height=\"10\" rx=\"1\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 27501:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M12.073 4.245c-2.44 0-4.145 1.665-4.145 3.409 0 .866.421 1.713 1.144 2.346H6.526a4.867 4.867 0 0 1-.598-2.346c0-3.127 2.902-5.409 6.145-5.409 2.685 0 5.082 1.533 5.877 3.821a1 1 0 0 1-1.889.656c-.471-1.355-2.011-2.477-3.988-2.477zm-.345 8.809a.955.955 0 0 0 .132.008c2.44 0 4.145 1.666 4.145 3.409 0 1.744-1.705 3.409-4.145 3.409-1.164 0-2.196-.395-2.936-1.007a3.354 3.354 0 0 1-1.052-1.47 1 1 0 1 0-1.889.656 5.36 5.36 0 0 0 1.666 2.355c1.112.92 2.599 1.466 4.211 1.466 3.243 0 6.145-2.282 6.145-5.409 0-1.354-.544-2.55-1.426-3.471H19a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2h6.146c.192.026.386.044.582.054z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 62428:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M4.00004 6C4.00004 3.79086 5.7909 2 8.00004 2C10.2092 2 12 3.79086 12 6V6.66667C12.7364 6.66667 13.3334 7.26362 13.3334 8V9.33333C13.3334 9.84269 13.0478 10.2853 12.628 10.5099C12.3825 12.1088 11.001 13.3333 9.33337 13.3333H9.155C8.92446 13.7319 8.49356 14 8.00004 14C7.26366 14 6.66671 13.403 6.66671 12.6667C6.66671 11.9303 7.26366 11.3333 8.00004 11.3333C8.49356 11.3333 8.92446 11.6015 9.155 12H9.33337C10.2076 12 10.9508 11.4391 11.2228 10.6575C10.9072 10.6048 10.6667 10.3305 10.6667 10V6C10.6667 4.52724 9.4728 3.33333 8.00004 3.33333C6.52728 3.33333 5.33337 4.52724 5.33337 6V10C5.33337 10.3682 5.0349 10.6667 4.66671 10.6667H4.00004C3.26366 10.6667 2.66671 10.0697 2.66671 9.33333V8C2.66671 7.26362 3.26366 6.66667 4.00004 6.66667V6Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 82481:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M5.68824 3.06668C5.51046 3.20002 5.51046 3.46668 5.68824 3.60002L7.46602 4.93335C7.68576 5.09816 7.99935 4.94136 7.99935 4.66668V4.00002C10.2085 4.00002 11.9993 5.79088 11.9993 8.00002C11.9993 8.75518 11.7907 9.45958 11.4283 10.061C11.2383 10.3764 11.3399 10.7861 11.6553 10.9761C11.9706 11.1661 12.3803 11.0645 12.5704 10.7491C13.0544 9.94584 13.3327 9.00441 13.3327 8.00002C13.3327 5.0545 10.9449 2.66668 7.99935 2.66668V2.00002C7.99935 1.72533 7.68576 1.56854 7.46602 1.73335L5.68824 3.06668ZM4.29082 5.08961C4.60952 5.27397 4.71843 5.68179 4.53407 6.0005C4.19412 6.58817 3.99935 7.27033 3.99935 8.00002C3.99935 10.2092 5.79021 12 7.99935 12V11.3333C7.99935 11.0587 8.31294 10.9019 8.53268 11.0667L10.3105 12.4C10.4882 12.5333 10.4882 12.8 10.3105 12.9333L8.53268 14.2667C8.31294 14.4315 7.99935 14.2747 7.99935 14V13.3333C5.05383 13.3333 2.66602 10.9455 2.66602 8.00002C2.66602 7.02969 2.92575 6.11801 3.37993 5.33286C3.56429 5.01416 3.97211 4.90525 4.29082 5.08961Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 18294:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.97429 3.51649C10.0754 3.16247 9.87045 2.79348 9.51642 2.69233C9.1624 2.59118 8.79341 2.79617 8.69226 3.15019L6.02559 12.4835C5.92444 12.8376 6.12944 13.2065 6.48346 13.3077C6.83749 13.4088 7.20648 13.2038 7.30763 12.8498L9.97429 3.51649ZM5.08307 4.1461C5.37058 4.3761 5.4172 4.79563 5.18719 5.08314L2.85369 8.00001L5.18719 10.9169C5.4172 11.2044 5.37058 11.6239 5.08307 11.8539C4.79557 12.0839 4.37604 12.0373 4.14603 11.7498L1.48772 8.42691C1.45077 8.38268 1.42032 8.33449 1.3965 8.28373C1.354 8.19355 1.33319 8.09656 1.33325 8.00001C1.33319 7.90346 1.354 7.80647 1.39649 7.71629C1.42031 7.66553 1.45077 7.61734 1.48772 7.57311L4.14603 4.25021C4.37604 3.9627 4.79556 3.91609 5.08307 4.1461ZM10.9168 4.1461C11.2043 3.91609 11.6238 3.9627 11.8539 4.25021L14.5123 7.57322C14.5485 7.61657 14.5784 7.66372 14.602 7.71337C14.6454 7.80438 14.6667 7.90242 14.6666 8.00001C14.6667 8.0976 14.6454 8.19564 14.602 8.28665C14.5784 8.33629 14.5485 8.38344 14.5123 8.42679L11.8539 11.7498C11.6238 12.0373 11.2043 12.0839 10.9168 11.8539C10.6293 11.6239 10.5827 11.2044 10.8127 10.9169L13.1462 8.00001L10.8127 5.08314C10.5827 4.79563 10.6293 4.3761 10.9168 4.1461Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 20913:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M2 7a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7zm3-1a1 1 0 0 0-1 1v4h7V6H5zm6 7H4v4a1 1 0 0 0 1 1h6v-5zm2 0h7v4a1 1 0 0 1-1 1h-6v-5zm7-2V7a1 1 0 0 0-1-1h-6v5h7z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 12216:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M5 3a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5zm0 2h4v4H5V5zm0 8a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H5zm0 2h4v4H5v-4zm8-6a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1-1-1zm1-5a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-6zm-1 11a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1-1-1zm1 3a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 64268:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M2.5 4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5H7.5C8.42047 2.5 9.16667 3.24619 9.16667 4.16667V7.5C9.16667 8.42047 8.42047 9.16667 7.5 9.16667H4.16667C3.24619 9.16667 2.5 8.42047 2.5 7.5V4.16667ZM7.5 4.16667H4.16667V7.5H7.5V4.16667Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M2.5 12.5C2.5 11.5795 3.24619 10.8333 4.16667 10.8333H7.5C8.42047 10.8333 9.16667 11.5795 9.16667 12.5V15.8333C9.16667 16.7538 8.42047 17.5 7.5 17.5H4.16667C3.24619 17.5 2.5 16.7538 2.5 15.8333V12.5ZM7.5 12.5H4.16667V15.8333H7.5V12.5Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M12.5 2.5C11.5795 2.5 10.8333 3.24619 10.8333 4.16667V15.8333C10.8333 16.7538 11.5795 17.5 12.5 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8333V4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5H12.5ZM12.5 4.16667H15.8333V15.8333H12.5V4.16667Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 62171:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"31","height":"35","viewBox":"0 0 31 35","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 23.9C0 23.4029 0.402944 23 0.9 23H26.9272C27.4242 23 27.8272 23.4029 27.8272 23.9V24.2C27.8272 24.6971 27.4242 25.1 26.9272 25.1H0.9C0.402943 25.1 0 24.6971 0 24.2V23.9ZM0 28.4C0 27.9029 0.402944 27.5 0.9 27.5H26.9272C27.4242 27.5 27.8272 27.9029 27.8272 28.4V28.7C27.8272 29.1971 27.4242 29.6 26.9272 29.6H0.9C0.402943 29.6 0 29.1971 0 28.7V28.4ZM0.9 32C0.402944 32 0 32.4029 0 32.9V33.2C0 33.6971 0.402944 34.1 0.900001 34.1H19.063C19.56 34.1 19.963 33.6971 19.963 33.2V32.9C19.963 32.4029 19.56 32 19.063 32H0.9Z\" fill=\"#E8E8E8\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z\" fill=\"#E8E8E8\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.3152 4.88556L16.9452 16.0355L30.9733 7.36356L19.3152 4.88556Z\" fill=\"#E8E8E8\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 76094:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"9","height":"10","viewBox":"0 0 9 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M5.65527 10V2.71289H8.30225V0.840332H0.691406V2.71289H3.33203V10H5.65527Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 88536:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M3.333 2C2.597 2 2 2.597 2 3.333V6c0 .736.597 1.333 1.333 1.333H6c.737 0 1.333-.597 1.333-1.333V3.333C7.333 2.597 6.737 2 6 2H3.333zm0 1.333H6V6H3.333V3.333zm0 5.334C2.597 8.667 2 9.264 2 10v2.667C2 13.403 2.597 14 3.333 14H6c.737 0 1.333-.597 1.333-1.333V10c0-.736-.596-1.333-1.333-1.333H3.333zm0 1.333H6v2.667H3.333V10zm5.334-4c0-.368.298-.667.666-.667h4a.667.667 0 0 1 0 1.334h-4A.667.667 0 0 1 8.667 6zm.666-3.333a.667.667 0 0 0 0 1.333h4a.667.667 0 0 0 0-1.333h-4zM8.667 10c0-.368.298-.667.666-.667h4a.667.667 0 0 1 0 1.334h-4A.667.667 0 0 1 8.667 10zm.666 2a.667.667 0 0 0 0 1.333h4a.667.667 0 0 0 0-1.333h-4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 33277:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"11","viewBox":"0 0 12 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.195287 0.195262C0.455636 -0.0650874 0.877746 -0.0650874 1.1381 0.195262L2.46574 1.52291C2.51433 1.57023 2.55433 1.62356 2.58549 1.68078C2.6819 1.85741 2.69246 2.06845 2.61717 2.25261C2.59251 2.31292 2.55865 2.37035 2.51558 2.42275L1.18727 4.08313C0.957264 4.37064 0.537736 4.41725 0.250228 4.18725C-0.0372801 3.95724 -0.0838944 3.53771 0.146112 3.2502L1.10669 2.04948L0.195287 1.13807C-0.0650629 0.877722 -0.0650629 0.455612 0.195287 0.195262ZM4.00002 2C4.00002 1.63181 4.2985 1.33333 4.66669 1.33333H11.3334C11.7015 1.33333 12 1.63181 12 2C12 2.36819 11.7015 2.66667 11.3334 2.66667H4.66669C4.2985 2.66667 4.00002 2.36819 4.00002 2ZM4.00002 6C4.00002 5.63181 4.2985 5.33333 4.66669 5.33333H11.3334C11.7015 5.33333 12 5.63181 12 6C12 6.36819 11.7015 6.66667 11.3334 6.66667H4.66669C4.2985 6.66667 4.00002 6.36819 4.00002 6ZM4.66669 9.33333C4.2985 9.33333 4.00002 9.63181 4.00002 10C4.00002 10.3682 4.2985 10.6667 4.66669 10.6667H11.3334C11.7015 10.6667 12 10.3682 12 10C12 9.63181 11.7015 9.33333 11.3334 9.33333H4.66669Z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 60302:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<g clip-path=\"url(#clip0_304_117572)\">   <path class=\"graphic\" d=\"M4.18988 0.418762C3.95588 -0.140238 3.04388 -0.140238 2.80888 0.418762L0.0598756 6.95176C-0.102124 7.33476 0.0758756 7.77776 0.457876 7.93976C0.835876 8.10176 1.27888 7.92276 1.43988 7.53876L2.08888 5.99976H4.91188L5.55988 7.53876C5.68088 7.82676 5.95788 7.99876 6.24988 7.99876C6.34788 7.99876 6.44688 7.97976 6.54187 7.93976C6.92387 7.77776 7.10188 7.33476 6.93988 6.95176L4.18988 0.418762ZM2.71988 4.49976L3.49988 2.64676L4.27988 4.49976H2.71988Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M9.75 3.5C11.267 3.5 12.5 4.733 12.5 6.25C12.5 6.664 12.836 7 13.25 7C13.664 7 14 6.664 14 6.25C14 3.907 12.094 2 9.75 2C9.336 2 9 2.336 9 2.75C9 3.164 9.336 3.5 9.75 3.5Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M6.25 12.5C4.733 12.5 3.5 11.267 3.5 9.75C3.5 9.336 3.164 9 2.75 9C2.336 9 2 9.336 2 9.75C2 12.093 3.906 14 6.25 14C6.664 14 7 13.664 7 13.25C7 12.836 6.664 12.5 6.25 12.5Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M15.5207 14.551L14.0487 13.979C13.9227 13.93 13.8067 13.867 13.6887 13.807C14.3577 13.021 14.8017 12.056 14.9437 11H15.2497C15.6637 11 15.9997 10.664 15.9997 10.25C15.9997 9.836 15.6637 9.5 15.2497 9.5H13.2497V8.75C13.2497 8.336 12.9137 8 12.4997 8C12.0857 8 11.7497 8.336 11.7497 8.75V9.5H9.74966C9.33566 9.5 8.99966 9.836 8.99966 10.25C8.99966 10.664 9.33566 11 9.74966 11H10.0557C10.1977 12.056 10.6417 13.02 11.3107 13.807C11.1927 13.867 11.0767 13.93 10.9507 13.979L9.47866 14.551C9.09166 14.701 8.90066 15.136 9.05066 15.522C9.16666 15.818 9.45066 16 9.75066 16C9.84166 16 9.93366 15.984 10.0217 15.949L11.4937 15.377C11.8547 15.237 12.1847 15.051 12.4997 14.847C12.8147 15.051 13.1447 15.236 13.5057 15.377L14.9777 15.949C15.0667 15.984 15.1587 16 15.2487 16C15.5487 16 15.8327 15.818 15.9477 15.522C16.0987 15.136 15.9077 14.701 15.5207 14.551ZM13.4227 11C13.2887 11.713 12.9687 12.364 12.4997 12.895C12.0297 12.364 11.7107 11.713 11.5767 11H13.4227Z\" fill=\"black\"/>   </g>   <defs>   <clipPath id=\"clip0_304_117572\">   <rect width=\"16\" height=\"16\" fill=\"white\"/>   </clipPath>   </defs>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 77242:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M11 2a3 3 0 0 0-3 3v1H5a1 1 0 0 0 0 2v11a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a1 1 0 0 0 0-2h-3V5a3 3 0 0 0-3-3h-2zm3 4V5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v1h4zM8 8H7v11a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8H8zm3 3v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 2 0zm3-1a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 35783:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"11","viewBox":"0 0 11 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M9.82143 0.3125H1.17857C0.527902 0.3125 0 0.807408 0 1.41741V9.52009C0 10.1301 0.527902 10.625 1.17857 10.625H9.82143C10.4721 10.625 11 10.1301 11 9.52009V1.41741C11 0.807408 10.4721 0.3125 9.82143 0.3125ZM8.62076 3.96791C8.62567 4.03237 8.62567 4.09912 8.62567 4.16357C8.62567 6.15932 7.00513 8.45891 4.04397 8.45891C3.13058 8.45891 2.28348 8.21031 1.57143 7.78216C1.70156 7.79597 1.82679 7.80057 1.95938 7.80057C2.71317 7.80057 3.40558 7.56117 3.95804 7.15604C3.25089 7.14223 2.6567 6.70717 2.4529 6.10868C2.70089 6.14321 2.92433 6.14321 3.17969 6.08105C2.44308 5.94064 1.89062 5.33294 1.89062 4.59863V4.58022C2.10424 4.69301 2.35469 4.76207 2.61741 4.77128C2.39653 4.63354 2.21546 4.44668 2.09036 4.22737C1.96526 4.00807 1.90001 3.76314 1.90045 3.51444C1.90045 3.23361 1.97902 2.9758 2.11897 2.75251C2.91205 3.66867 4.1029 4.26716 5.43862 4.33161C5.21027 3.30727 6.0279 2.47628 7.01004 2.47628C7.47411 2.47628 7.89152 2.65813 8.18616 2.95278C8.54955 2.88832 8.89821 2.76172 9.20759 2.58908C9.08728 2.93896 8.83438 3.23361 8.50045 3.42006C8.82455 3.38783 9.13884 3.30266 9.42857 3.18527C9.21004 3.48682 8.93504 3.75384 8.62076 3.96791Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 93858:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M11.522 4.72a4.433 4.433 0 0 1 6.269 6.269l-4.924 4.925-.886.885a2.745 2.745 0 1 1-3.882-3.882l4.595-4.595a1 1 0 1 1 1.414 1.415L9.513 14.33a.746.746 0 0 0 1.054 1.054l.219-.22a.015.015 0 0 0 .004-.003l5.587-5.587a2.433 2.433 0 0 0-3.44-3.44l-.487.486-5.443 5.443a3.667 3.667 0 0 0 0 5.186l.454.454a3.667 3.667 0 0 0 5.186 0l4.714-4.714a1 1 0 1 1 1.414 1.414l-4.714 4.714a5.667 5.667 0 0 1-8.014 0l-.454-.454a5.667 5.667 0 0 1 0-8.014l5.443-5.443.486-.487z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 64631:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M6 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6zM5 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6zm12.268 3.64a1 1 0 1 0-1.536-1.28l-4.406 5.287-2.745-1.96a1 1 0 1 0-1.162 1.627l3.5 2.5.755.54.594-.714 5-6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 33753:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M15 7.5c0 .852-.431 1.745-1.161 2.472C13.064 10.743 12.291 11 12 11c-.291 0-1.064-.257-1.839-1.028C9.431 9.245 9 8.352 9 7.5 9 5.383 10.518 4 12 4s3 1.383 3 3.5zm2 0c0 3.038-3 5.5-5 5.5s-5-2.462-5-5.5S9.239 2 12 2s5 2.462 5 5.5zM10.582 16h2.432a4.494 4.494 0 0 1 4.386 3.518l.107.482H6.493l.195-.876A3.993 3.993 0 0 1 10.582 16zm-4.873.508A5.988 5.988 0 0 1 10.582 14h2.432a6.495 6.495 0 0 1 6.338 5.085l.264 1.187A1.42 1.42 0 0 1 18.23 22H5.999a1.603 1.603 0 0 1-1.565-1.951l.302-1.359a5.973 5.973 0 0 1 .973-2.182z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 325:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M11 17.887v-4.99c-2.268-.436-4-2.212-4-4.397s1.732-3.961 4-4.397V3a1 1 0 0 1 2 0v1.073c1.839.296 3.38 1.472 3.945 3.099a1 1 0 1 1-1.89.656c-.283-.815-1.063-1.463-2.055-1.715v4.99c2.268.436 4 2.212 4 4.397s-1.732 3.961-4 4.397V21a1 1 0 0 1-2 0v-1.073a5.34 5.34 0 0 1-2.558-1.138 4.453 4.453 0 0 1-1.387-1.961 1 1 0 0 1 1.89-.656c.139.4.404.772.771 1.076.36.297.8.516 1.284.64zm2-.046c1.182-.362 2-1.295 2-2.341 0-1.046-.818-1.979-2-2.34v4.68zm-2-7V6.159C9.818 6.521 9 7.454 9 8.5c0 1.046.818 1.979 2 2.34z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 24655:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M8 3a1 1 0 0 1 1 1v1h6V4a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h1V4a1 1 0 0 1 1-1zm7 4v1a1 1 0 0 0 2 0V7h1a1 1 0 0 1 1 1v2H5V8a1 1 0 0 1 1-1h1v1a1 1 0 0 0 2 0V7h6zM5 12v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6H5z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 52124:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M7 9a3 3 0 1 0 0 6h3a1 1 0 0 1 0 2H7A5 5 0 0 1 7 7h3a1 1 0 0 1 0 2H7zm1 3a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1zm6-5a1 1 0 0 0 0 2h3a3 3 0 1 1 0 6h-3a1 1 0 0 0 0 2h3a5 5 0 0 0 0-10h-3z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 66339:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M12 4a8 8 0 1 0 3.555 15.169 1 1 0 1 1 .89 1.791A9.961 9.961 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10v.571c0 1.297-.317 2.395-.948 3.193A3.199 3.199 0 0 1 18.5 17c-1.216 0-2.192-.685-2.801-1.636A5 5 0 1 1 15 8a1 1 0 0 1 2 0v5c0 1.222.85 2 1.5 2a1.2 1.2 0 0 0 .984-.478c.273-.345.516-.961.516-1.951V12a8 8 0 0 0-8-8zm3 8a3 3 0 1 0-6 0 3 3 0 0 0 6 0z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 12154:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M7 5h10a2 2 0 1 1 0 4H7a2 2 0 1 1 0-4zM3 7a4 4 0 0 1 4-4h10a4 4 0 0 1 0 8H7a4 4 0 0 1-4-4zm4 8h10a2 2 0 1 1 0 4H7a2 2 0 1 1 0-4zm-4 2a4 4 0 0 1 4-4h10a4 4 0 0 1 0 8H7a4 4 0 0 1-4-4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 39046:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M17.243 3.03a1 1 0 0 1 .727 1.212L17.031 8H20a1 1 0 0 1 0 2h-3.47l-1 4H18a1 1 0 0 1 0 2h-2.97l-1.06 4.242a1 1 0 0 1-1.94-.485L12.97 16H9.03l-1.06 4.242a1 1 0 0 1-1.94-.485L6.97 16H4a1 1 0 1 1 0-2h3.47l1-4H6a1 1 0 1 1 0-2h2.97l1.06-4.242a1 1 0 1 1 1.94.484L11.03 8h3.94l1.06-4.242a1 1 0 0 1 1.213-.728zM10.531 10l-1 4h3.938l1-4h-3.938z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 92702:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M20.707 3.293a1 1 0 0 1 0 1.414l-16 16a1 1 0 1 1-1.414-1.414l16-16a1 1 0 0 1 1.414 0zM6.5 5C5.835 5 5 5.717 5 7s.835 2 1.5 2S8 8.283 8 7s-.835-2-1.5-2zM3 7c0-2.03 1.404-4 3.5-4S10 4.97 10 7c0 2.03-1.404 4-3.5 4S3 9.03 3 7zm13 10c0-1.283.835-2 1.5-2s1.5.717 1.5 2-.835 2-1.5 2-1.5-.717-1.5-2zm1.5-4c-2.096 0-3.5 1.97-3.5 4 0 2.03 1.404 4 3.5 4s3.5-1.97 3.5-4c0-2.03-1.404-4-3.5-4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 21685:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M8.933 8.578l1.65-4.748c.466-1.343 2.368-1.343 2.834 0l1.65 4.748 5.025.103c1.422.029 2.01 1.836.876 2.695l-4.005 3.036 1.455 4.81c.414 1.362-1.125 2.48-2.292 1.667L12 18.018l-4.126 2.871c-1.167.813-2.706-.305-2.292-1.665l1.455-4.812-4.005-3.036c-1.134-.86-.546-2.666.876-2.695l5.025-.103zM12 5.846l-1.293 3.72a1.5 1.5 0 0 1-1.386 1.005l-3.935.08 3.139 2.38a1.5 1.5 0 0 1 .527 1.628l-1.14 3.767 3.232-2.249a1.502 1.502 0 0 1 1.713 0l3.23 2.249-1.139-3.765a1.5 1.5 0 0 1 .529-1.632l3.137-2.378-3.936-.08a1.5 1.5 0 0 1-1.386-1.007L12 5.846z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 56486:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M7 8h10a4 4 0 1 1 0 8H7a4 4 0 1 1 0-8zm0 2a2 2 0 1 0 0 4h10a2 2 0 1 0 0-4H7z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 85265:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M3 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2h-5v15a1 1 0 1 1-2 0V5H4a1 1 0 0 1-1-1zm14 9h3a1 1 0 1 1 0 2h-2v5a1 1 0 1 1-2 0v-5h-2a1 1 0 1 1 0-2h3z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 61615:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"10","viewBox":"0 0 11 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M5.28098 9.83974C4.07416 9.80988 3.00875 9.4217 2.05904 8.74237C1.41465 8.28102 0.865071 7.73756 0.472974 7.06869C0.0856979 6.40727 -0.0637489 5.70257 0.0246336 4.95157C0.103374 4.28419 0.416731 3.71833 0.902031 3.23907C1.24271 2.90314 1.6107 2.5896 1.97708 2.27756C2.39007 1.92371 2.8127 1.57882 3.23694 1.23543C3.56797 0.966682 3.91989 0.729291 4.3152 0.550127C4.82782 0.318708 5.37097 0.232112 5.93662 0.253015C7.00525 0.293327 7.94853 0.65016 8.79861 1.23692C9.47192 1.70125 10.0456 2.25666 10.4538 2.94196C11.0291 3.90795 11.156 4.9247 10.8057 5.98325C10.6402 6.48043 10.3333 6.90893 9.95883 7.29115C9.28873 7.97645 8.54792 8.58859 7.73641 9.12608C7.25593 9.44409 6.73046 9.677 6.14552 9.77107C5.86109 9.81586 5.57184 9.83079 5.2858 9.85915C5.2842 9.85169 5.28259 9.84572 5.28098 9.83974ZM5.16207 7.35983C5.36937 7.35983 5.5622 7.35535 5.75343 7.36132C5.8386 7.3643 5.85306 7.33594 5.85306 7.26427C5.85145 6.16988 5.85145 5.074 5.85145 3.97961C5.85145 3.94826 5.85145 3.9169 5.85145 3.8751C6.31747 3.8751 6.77063 3.8751 7.22218 3.8751C7.22218 3.66608 7.22218 3.469 7.22218 3.27192C6.07321 3.27192 4.93227 3.27192 3.78169 3.27192C3.78169 3.4466 3.78491 3.61531 3.78009 3.78402C3.77687 3.85718 3.79776 3.88256 3.88133 3.88107C4.27021 3.87659 4.65748 3.87958 5.04637 3.87958C5.16046 3.87958 5.16046 3.87958 5.16046 3.9826C5.16046 5.07251 5.16046 6.16242 5.16046 7.25233C5.16207 7.28368 5.16207 7.31653 5.16207 7.35983Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 78555:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M8 3a1 1 0 0 0-2 0v9a6 6 0 1 0 12 0V3a1 1 0 0 0-2 0v9a4 4 0 0 1-8 0V3zM7 20a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2H7z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 69206:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.58963 3.36764C4.85564 3.10011 5.28727 3.10011 5.55328 3.36764C5.81876 3.63464 5.81876 4.06716 5.55328 4.33416L4.65667 5.23596H10.5572C12.8277 5.23596 14.6667 7.0869 14.6667 9.36814C14.6667 11.6494 12.8277 13.5003 10.5572 13.5003H5.75717C5.3802 13.5003 5.07622 13.1932 5.07622 12.8164C5.07622 12.4396 5.3802 12.1325 5.75717 12.1325H10.5572C12.0737 12.1325 13.3048 10.8958 13.3048 9.36814C13.3048 7.84052 12.0737 6.60377 10.5572 6.60377H4.65667L5.55328 7.50557C5.81876 7.77258 5.81876 8.20506 5.55328 8.47207C5.28727 8.73961 4.85564 8.73961 4.58963 8.47207L2.53249 6.40312C2.267 6.13612 2.267 5.70361 2.53249 5.43661L4.58963 3.36764Z\" fill=\"currentColor\"></path>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 29300:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<g clip-path=\"url(#clip0)\"> <path d=\"M0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z\" fill=\"#00A1B7\"/> <path d=\"M12.0833 9.16663C10.9621 9.16663 10.4864 10.5939 11.3833 11.2666L11.85 11.6166C11.9969 11.7268 12.0833 11.8997 12.0833 12.0833V14.4166C12.0833 14.6002 11.9969 14.7731 11.85 14.8833L11.3833 15.2333C10.4864 15.906 10.9621 17.3333 12.0833 17.3333H14.4167V20.25C14.4167 20.5721 14.6778 20.8333 15 20.8333C15.3222 20.8333 15.5833 20.5721 15.5833 20.25V17.3333H17.9167C19.0378 17.3333 19.5136 15.906 18.6167 15.2333L18.15 14.8833C18.0031 14.7731 17.9167 14.6002 17.9167 14.4166V12.0833C17.9167 11.8997 18.0031 11.7268 18.15 11.6166L18.6167 11.2666C19.5136 10.5939 19.0378 9.16663 17.9167 9.16663H12.0833Z\" fill=\"#F5F8FA\"/> </g> <defs> <clipPath id=\"clip0\"> <path d=\"M0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z\" fill=\"white\"/> </clipPath> </defs>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 26798:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<circle class=\"graphic_stroke\" cx=\"18\" cy=\"18\" r=\"17\" stroke=\"#5C6061\" stroke-width=\"2\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18 8.625C18.5178 8.625 18.9375 9.04473 18.9375 9.5625L18.9375 20.4242L23.8996 15.4621C24.2657 15.096 24.8593 15.096 25.2254 15.4621C25.5915 15.8282 25.5915 16.4218 25.2254 16.7879L18.6661 23.3472C18.6562 23.3573 18.646 23.367 18.6357 23.3766C18.5545 23.4515 18.4634 23.5095 18.3668 23.5505C18.2549 23.5981 18.1319 23.6246 18.0028 23.625L18 23.625L17.9914 23.625C17.8704 23.6239 17.755 23.5999 17.6491 23.5571C17.5355 23.5113 17.4291 23.4424 17.3371 23.3504L10.7746 16.7879C10.4085 16.4218 10.4085 15.8282 10.7746 15.4621C11.1407 15.096 11.7343 15.096 12.1004 15.4621L17.0625 20.4242L17.0625 9.5625C17.0625 9.04473 17.4822 8.625 18 8.625ZM11.4375 25.5C10.9197 25.5 10.5 25.9197 10.5 26.4375C10.5 26.9553 10.9197 27.375 11.4375 27.375L24.5625 27.375C25.0803 27.375 25.5 26.9553 25.5 26.4375C25.5 25.9197 25.0803 25.5 24.5625 25.5L11.4375 25.5Z\" fill=\"black\" fill-opacity=\"0.6\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 29672:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<rect class=\"graphic_stroke\" x=\"1\" y=\"1\" width=\"11\" height=\"11\" rx=\"1\" stroke=\"#5C6061\"/>   <path class=\"graphic_stroke\" d=\"M5.5 4L3 6.5L5.5 9\" stroke=\"#5C6061\"/>   <path class=\"graphic_stroke\" d=\"M7.5 4L10 6.5L7.5 9\" stroke=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 77586:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M2.66675 14C2.66675 11.4227 4.75609 9.33333 7.33341 9.33333C7.55975 9.33333 7.78235 9.34947 8.00008 9.3806M10.0001 4.66667C10.0001 6.13943 8.80615 7.33333 7.33341 7.33333C5.86065 7.33333 4.66675 6.13943 4.66675 4.66667C4.66675 3.19391 5.86065 2 7.33341 2C8.80615 2 10.0001 3.19391 10.0001 4.66667Z\" stroke=\"#737373\" stroke-width=\"1.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.9236 9.30999L13.5424 9.92871C13.8841 10.2704 13.8841 10.8244 13.5424 11.1661L13.0164 11.6921L11.1603 9.83592L11.6862 9.30999C12.0279 8.96828 12.5819 8.96828 12.9236 9.30999ZM10.8509 10.1453L8.48041 12.5158C8.33946 12.6567 8.25086 12.8416 8.22928 13.0397L8.11436 14.0949C8.074 14.4655 8.38683 14.7783 8.75742 14.738L9.81258 14.6231C10.0108 14.6015 10.1956 14.5129 10.3366 14.3719L12.7071 12.0014L10.8509 10.1453Z\" fill=\"#737373\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 24327:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M10.4035 4.33268C10.4035 6.35773 8.40347 7.99935 7.07014 7.99935C5.73681 7.99935 3.73681 6.35773 3.73681 4.33268C3.73681 2.30764 5.22919 0.666016 7.07014 0.666016C8.91109 0.666016 10.4035 2.30764 10.4035 4.33268ZM9.07014 4.33268C9.07014 2.92159 8.05797 1.99935 7.07014 1.99935C6.08231 1.99935 5.07014 2.92159 5.07014 4.33268C5.07014 4.9009 5.35726 5.49586 5.84406 5.98038C6.36103 6.49492 6.87583 6.66602 7.07014 6.66602C7.26445 6.66602 7.77925 6.49492 8.29622 5.98038C8.78302 5.49586 9.07014 4.9009 9.07014 4.33268Z\" fill=\"currentColor\"/>   <path class=\"graphic\" d=\"M7.74583 8.66602C7.93845 8.66602 8.1296 8.67884 8.31817 8.70399C8.37771 8.63583 8.43996 8.5692 8.50491 8.50425C10.067 6.94216 12.5997 6.94216 14.1618 8.50425C15.7239 10.0663 15.7239 12.599 14.1618 14.1611C12.5997 15.7232 10.067 15.7232 8.50491 14.1611C8.45207 14.1083 8.40102 14.0543 8.35176 13.9993H3.06941C2.38554 13.9993 1.87754 13.3661 2.02589 12.6985L2.22718 11.7927C2.34352 11.2692 2.56412 10.7744 2.87583 10.3381C3.62532 9.28876 4.83543 8.66602 6.12491 8.66602H7.74583ZM6.12491 9.99935C5.26603 9.99935 4.46002 10.4141 3.96081 11.113C3.75319 11.4037 3.60625 11.7332 3.52876 12.0819L3.39896 12.666H7.56111C7.25741 11.8049 7.25741 10.8605 7.56111 9.99935H6.12491ZM13.8856 11.3327C13.8856 10.9645 13.5871 10.666 13.219 10.666H12V9.44707C12 9.07888 11.7015 8.7804 11.3333 8.7804C10.9651 8.7804 10.6667 9.07888 10.6667 9.44707V10.666H9.44771C9.07952 10.666 8.78105 10.9645 8.78105 11.3327C8.78105 11.7009 9.07952 11.9994 9.44771 11.9994H10.6667V13.2183C10.6667 13.5865 10.9651 13.885 11.3333 13.885C11.7015 13.885 12 13.5865 12 13.2183V11.9994H13.219C13.5871 11.9994 13.8856 11.7009 13.8856 11.3327Z\" fill=\"currentColor\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 59146:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M12 3a1 1 0 0 1 1 1v9h2.575a.5.5 0 0 1 .312.89l-3.575 2.86a.5.5 0 0 1-.624 0l-3.575-2.86a.5.5 0 0 1 .312-.89H11V4a1 1 0 0 1 1-1zM3 20a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 52725:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M12 1a1 1 0 0 1 1 1v3h2.575a.5.5 0 0 1 .312.89l-3.575 2.86a.5.5 0 0 1-.624 0L8.113 5.89A.5.5 0 0 1 8.425 5H11V2a1 1 0 0 1 1-1zM3 12a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm8 7H8.425a.5.5 0 0 1-.312-.89l3.575-2.86a.5.5 0 0 1 .624 0l3.575 2.86a.5.5 0 0 1-.312.89H13v3a1 1 0 0 1-2 0v-3z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 10226:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm10 7h2.575a.5.5 0 0 0 .312-.89l-3.575-2.86a.5.5 0 0 0-.624 0l-3.575 2.86a.5.5 0 0 0 .312.89H11v9a1 1 0 0 0 2 0v-9z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 22220:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M5 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H5zM4 7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7zm6.757 2.454a.5.5 0 0 0-.757.429v4.234a.5.5 0 0 0 .757.429l3.528-2.117a.5.5 0 0 0 0-.858l-3.528-2.117z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 27237:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"</svg> <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">     <g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" d=\"M14.667 4C14.667 3.73036 14.5045 3.48727 14.2554 3.38408C14.0063 3.28089 13.7195 3.33793 13.5289 3.52859L10.667 6.39052V5.33333C10.667 4.22876 9.77152 3.33333 8.66695 3.33333H3.33362C2.22905 3.33333 1.33362 4.22876 1.33362 5.33333V10.6667C1.33362 11.7712 2.22905 12.6667 3.33362 12.6667H8.66695C9.77152 12.6667 10.667 11.7712 10.667 10.6667V9.60948L13.5289 12.4714C13.7195 12.6621 14.0063 12.7191 14.2554 12.6159C14.5045 12.5127 14.667 12.2696 14.667 12V4ZM9.33362 5.33333V10.6667C9.33362 11.0349 9.03514 11.3333 8.66695 11.3333H3.33362C2.96543 11.3333 2.66695 11.0349 2.66695 10.6667V5.33333C2.66695 4.96514 2.96543 4.66667 3.33362 4.66667H8.66695C9.03514 4.66667 9.33362 4.96514 9.33362 5.33333ZM13.3336 10.3905L10.9431 8L13.3336 5.60947V10.3905Z\" fill=\"#5C6061\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 89713:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"11","viewBox":"0 0 11 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M9.9 0.3125H1.1C0.493527 0.3125 0 0.775181 0 1.34375V9.59375C0 10.1623 0.493527 10.625 1.1 10.625H9.9C10.5065 10.625 11 10.1623 11 9.59375V1.34375C11 0.775181 10.5065 0.3125 9.9 0.3125ZM9.2567 3.73772C9.22232 4.46282 8.68214 5.45724 7.63616 6.71638C6.5558 8.03306 5.63996 8.69141 4.89353 8.69141C4.42946 8.69141 4.03906 8.29088 3.71741 7.48751C3.09129 5.33984 2.82366 4.08071 2.30804 4.08071C2.24911 4.08071 2.0404 4.1981 1.68437 4.43059L1.31116 3.97942C2.22701 3.2244 3.10112 2.38651 3.64866 2.34047C4.26741 2.28523 4.64799 2.68115 4.7904 3.53055C5.29866 6.55064 5.52455 7.00642 6.45022 5.63909C6.7817 5.14648 6.96094 4.77128 6.98549 4.51346C7.07143 3.74923 6.34955 3.80218 5.86094 3.99784C6.25134 2.79855 6.99777 2.21617 8.10022 2.2484C8.91786 2.26911 9.30335 2.76632 9.2567 3.73772Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 4311:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M5 11.0415L8.5 13.0622C9.16667 13.4471 10 12.966 10 12.1962L10 1.80386C10 1.03406 9.16667 0.552935 8.5 0.937835L5 2.95856V3H1C0.447715 3 0 3.44772 0 4V10C0 10.5523 0.447715 11 1 11H5V11.0415Z\" fill=\"white\"/>   <path class=\"graphic\" d=\"M14 7C14 8.10457 13.1046 9 12 9V5C13.1046 5 14 5.89543 14 7Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 84005:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"18","height":"14","viewBox":"0 0 18 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M4.92822 3H1C0.447715 3 0 3.44772 0 4V10C0 10.5523 0.447715 11 1 11H4.92818L8.5 13.0622C9.16667 13.4471 10 12.966 10 12.1962L10 1.80386C10 1.03406 9.16667 0.552935 8.5 0.937835L4.92822 3Z\" fill=\"white\"/>   <path class=\"graphic\" d=\"M12 9C13.1046 9 14 8.10457 14 7C14 5.89543 13.1046 5 12 5V9Z\" fill=\"white\"/>   <path class=\"graphic\" d=\"M12 3C14.2091 3 16 4.79086 16 7C16 9.20914 14.2091 11 12 11V13C15.3137 13 18 10.3137 18 7C18 3.68629 15.3137 1 12 1V3Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 80347:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"17","height":"14","viewBox":"0 0 17 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M1 3H4.92822L8.5 0.937835C9.16667 0.552935 10 1.03406 10 1.80386L10 12.1962C10 12.966 9.16667 13.4471 8.5 13.0622L4.92818 11H1C0.447715 11 0 10.5523 0 10V4C0 3.44772 0.447715 3 1 3Z\" fill=\"white\"/>   <path class=\"graphic\" d=\"M16.7071 4.29289C16.3166 3.90237 15.6834 3.90237 15.2929 4.29289L14 5.58579L12.7071 4.29289C12.3166 3.90237 11.6834 3.90237 11.2929 4.29289C10.9024 4.68342 10.9024 5.31658 11.2929 5.70711L12.5858 7L11.2929 8.29289C10.9024 8.68342 10.9024 9.31658 11.2929 9.70711C11.6834 10.0976 12.3166 10.0976 12.7071 9.70711L14 8.41421L15.2929 9.70711C15.6834 10.0976 16.3166 10.0976 16.7071 9.70711C17.0976 9.31658 17.0976 8.68342 16.7071 8.29289L15.4142 7L16.7071 5.70711C17.0976 5.31658 17.0976 4.68342 16.7071 4.29289Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 77445:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.68885 3.06662C5.51107 3.19995 5.51107 3.46662 5.68885 3.59995L7.46663 4.93329C7.68637 5.0981 7.99996 4.9413 7.99996 4.66662V3.99995C10.2091 3.99995 12 5.79081 12 7.99995C12 10.2091 10.2091 12 7.99996 12C5.79082 12 3.99996 10.2091 3.99996 7.99995C3.99996 7.63176 3.70148 7.33329 3.33329 7.33329C2.9651 7.33329 2.66663 7.63176 2.66663 7.99995C2.66663 10.9455 5.05444 13.3333 7.99996 13.3333C10.9455 13.3333 13.3333 10.9455 13.3333 7.99995C13.3333 5.05444 10.9455 2.66662 7.99996 2.66662V1.99995C7.99996 1.72527 7.68637 1.56848 7.46663 1.73329L5.68885 3.06662Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 7294:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 1.33333C4.89543 1.33333 4 2.22876 4 3.33333C4 4.4379 4.89543 5.33333 6 5.33333C7.10457 5.33333 8 4.4379 8 3.33333C8 2.22876 7.10457 1.33333 6 1.33333ZM2.66667 3.33333C2.66667 1.49238 4.15905 0 6 0C7.84095 0 9.33333 1.49238 9.33333 3.33333C9.33333 3.8157 9.23087 4.27414 9.04653 4.68807C10.7086 4.87662 12 6.2875 12 8C12 9.84095 10.5076 11.3333 8.66667 11.3333C7.57627 11.3333 6.60815 10.8098 6 10.0003C5.39185 10.8098 4.42373 11.3333 3.33333 11.3333C1.49238 11.3333 0 9.84095 0 8C0 6.2875 1.2914 4.87662 2.95347 4.68807C2.76913 4.27414 2.66667 3.8157 2.66667 3.33333ZM5.33333 8C5.33333 6.89543 4.4379 6 3.33333 6C2.22876 6 1.33333 6.89543 1.33333 8C1.33333 9.10457 2.22876 10 3.33333 10C4.4379 10 5.33333 9.10457 5.33333 8ZM6.66667 8C6.66667 9.10457 7.5621 10 8.66667 10C9.77124 10 10.6667 9.10457 10.6667 8C10.6667 6.89543 9.77124 6 8.66667 6C7.5621 6 6.66667 6.89543 6.66667 8Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 46921:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"8","viewBox":"0 0 11 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M10.7762 1.2108C10.6498 0.739231 10.2788 0.367144 9.80781 0.240184C8.94712 0.00385134 5.50381 4.17513e-06 5.50381 4.17513e-06C5.50381 4.17513e-06 2.06104 -0.00384321 1.1998 0.222047C0.738129 0.347908 0.356699 0.728239 0.229189 1.19926C0.00219935 2.05995 8.0526e-07 3.84508 8.0526e-07 3.84508C8.0526e-07 3.84508 -0.00219763 5.63901 0.223143 6.49091C0.349554 6.96193 0.720541 7.33401 1.19211 7.46097C2.06159 7.69731 5.49556 7.70115 5.49556 7.70115C5.49556 7.70115 8.93888 7.705 9.79957 7.47966C10.27 7.35325 10.6427 6.98171 10.7707 6.5107C10.9983 5.65056 10.9999 3.86597 10.9999 3.86597C10.9999 3.86597 11.0109 2.07149 10.7762 1.2108ZM4.40239 5.49886L4.40514 2.2012L7.26696 3.85278L4.40239 5.49886Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 29184:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"38","height":"38","viewBox":"0 0 38 38","xmlns":"http://www.w3.org/2000/svg","stroke":"#aaa"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <g transform=\"translate(1 1)\" stroke-width=\"2\">             <circle stroke-opacity=\".5\" cx=\"18\" cy=\"18\" r=\"18\"/>             <path d=\"M36 18c0-9.94-8.06-18-18-18\">                 <animateTransform                     attributeName=\"transform\"                     type=\"rotate\"                     from=\"0 18 18\"                     to=\"360 18 18\"                     dur=\"1s\"                     repeatCount=\"indefinite\"/>             </path>         </g>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 76922:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 21324:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"opacityLight":".4","opacityDark":".4","aqua":"#42a5f5","carrot":"#fda639","yellow":"#fac92f","red":"#ed5454","light-green":"#8bc34a","thistle":"#b39ddb","ucla-blue":"#5573a7","blue":"#759ee6","cherry":"#e91e63","orange":"#ff6b00","yellow-green":"#b5d200","green":"#3dca43","jade":"#00c27c","green-sea":"#26a69a","aquamarine":"#00bcd4","dark-sky":"#5a9baf","purple":"#7e75e6","pink":"#e675b8","cloudy":"#607d8b","grey":"#757575","brown":"#795548","black":"#161616","white":"#f5f5f5","paletteAttrBg":"data-palette-bg","paletteAttrBgRGB":"data-palette-bg-rgb","paletteAttrFont":"data-font-color","extraOpacityLight":".12","extraOpacityDark":".2","nimbusWhite":"#e8e8e8","popupAppearDuration":"200","scrollBlotClass":"nedit-root","blotMargin":"18","gunMetal":"#5c6061","linGrad1":"rgba(31,31,31,.2)","linGrad1dark":"rgba(243,246,250,.2)","linGrad2":"#00a1b7","progressColor":"#00a1b7","pageWidth":"1000px","embeddedMenuAppearDuration":"200","moreItemsMenuAppearDuration":"200","blockMenuPinAppearDuration":"200","blockMenuListAppearDuration":"200","blockMenuPinButtonSize":"24"};

/***/ }),

/***/ 36372:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"opacityLight":".4","opacityDark":".4","aqua":"#42a5f5","carrot":"#fda639","yellow":"#fac92f","red":"#ed5454","light-green":"#8bc34a","thistle":"#b39ddb","ucla-blue":"#5573a7","blue":"#759ee6","cherry":"#e91e63","orange":"#ff6b00","yellow-green":"#b5d200","green":"#3dca43","jade":"#00c27c","green-sea":"#26a69a","aquamarine":"#00bcd4","dark-sky":"#5a9baf","purple":"#7e75e6","pink":"#e675b8","cloudy":"#607d8b","grey":"#757575","brown":"#795548","black":"#161616","white":"#f5f5f5","paletteAttrBg":"data-palette-bg","paletteAttrBgRGB":"data-palette-bg-rgb","paletteAttrFont":"data-font-color","extraOpacityLight":".12","extraOpacityDark":".2","nimbusWhite":"#e8e8e8","popupAppearDuration":"200","scrollBlotClass":"nedit-root","blotMargin":"18","gunMetal":"#5c6061","linGrad1":"rgba(31,31,31,.2)","linGrad1dark":"rgba(243,246,250,.2)","linGrad2":"#00a1b7","progressColor":"#00a1b7","pageWidth":"1000px","embeddedMenuAppearDuration":"200","moreItemsMenuAppearDuration":"200"};

/***/ }),

/***/ 26158:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"fileHorizontalPadding":"10","fileBorderWidth":"1px"};

/***/ }),

/***/ 84806:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"opacityLight":".4","opacityDark":".4","aqua":"#42a5f5","carrot":"#fda639","yellow":"#fac92f","red":"#ed5454","light-green":"#8bc34a","thistle":"#b39ddb","ucla-blue":"#5573a7","blue":"#759ee6","cherry":"#e91e63","orange":"#ff6b00","yellow-green":"#b5d200","green":"#3dca43","jade":"#00c27c","green-sea":"#26a69a","aquamarine":"#00bcd4","dark-sky":"#5a9baf","purple":"#7e75e6","pink":"#e675b8","cloudy":"#607d8b","grey":"#757575","brown":"#795548","black":"#161616","white":"#f5f5f5","paletteAttrBg":"data-palette-bg","paletteAttrBgRGB":"data-palette-bg-rgb","paletteAttrFont":"data-font-color","extraOpacityLight":".12","extraOpacityDark":".2","nimbusWhite":"#e8e8e8","popupAppearDuration":"200","scrollBlotClass":"nedit-root","blotMargin":"18","gunMetal":"#5c6061","linGrad1":"rgba(31,31,31,.2)","linGrad1dark":"rgba(243,246,250,.2)","linGrad2":"#00a1b7","progressColor":"#00a1b7","pageWidth":"1000px","floatingToolbarHeight":"36","floatingToolbarAppearDuration":"200","colorPickerAppearDuration":"200"};

/***/ }),

/***/ 50450:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"nimbusWhite":"#e8e8e8","popupAppearDuration":"200","scrollBlotClass":"nedit-root","blotMargin":"18","gunMetal":"#5c6061","linGrad1":"rgba(31,31,31,.2)","linGrad1dark":"rgba(243,246,250,.2)","linGrad2":"#00a1b7","progressColor":"#00a1b7","pageWidth":"1000px","fullwidthTransition":"350ms"};

/***/ }),

/***/ 32806:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"opacityLight":".4","opacityDark":".4","aqua":"#42a5f5","carrot":"#fda639","yellow":"#fac92f","red":"#ed5454","light-green":"#8bc34a","thistle":"#b39ddb","ucla-blue":"#5573a7","blue":"#759ee6","cherry":"#e91e63","orange":"#ff6b00","yellow-green":"#b5d200","green":"#3dca43","jade":"#00c27c","green-sea":"#26a69a","aquamarine":"#00bcd4","dark-sky":"#5a9baf","purple":"#7e75e6","pink":"#e675b8","cloudy":"#607d8b","grey":"#757575","brown":"#795548","black":"#161616","white":"#f5f5f5","paletteAttrBg":"data-palette-bg","paletteAttrBgRGB":"data-palette-bg-rgb","paletteAttrFont":"data-font-color","extraOpacityLight":".12","extraOpacityDark":".2","nimbusWhite":"#e8e8e8","popupAppearDuration":"200","scrollBlotClass":"nedit-root","blotMargin":"18","gunMetal":"#5c6061","linGrad1":"rgba(31,31,31,.2)","linGrad1dark":"rgba(243,246,250,.2)","linGrad2":"#00a1b7","progressColor":"#00a1b7","pageWidth":"1000px","gridColSidePadding":"35"};

/***/ }),

/***/ 29199:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"opacityLight":".4","opacityDark":".4","aqua":"#42a5f5","carrot":"#fda639","yellow":"#fac92f","red":"#ed5454","light-green":"#8bc34a","thistle":"#b39ddb","ucla-blue":"#5573a7","blue":"#759ee6","cherry":"#e91e63","orange":"#ff6b00","yellow-green":"#b5d200","green":"#3dca43","jade":"#00c27c","green-sea":"#26a69a","aquamarine":"#00bcd4","dark-sky":"#5a9baf","purple":"#7e75e6","pink":"#e675b8","cloudy":"#607d8b","grey":"#757575","brown":"#795548","black":"#161616","white":"#f5f5f5","paletteAttrBg":"data-palette-bg","paletteAttrBgRGB":"data-palette-bg-rgb","paletteAttrFont":"data-font-color","extraOpacityLight":".12","extraOpacityDark":".2","nimbusWhite":"#e8e8e8","popupAppearDuration":"200","scrollBlotClass":"nedit-root","blotMargin":"18","gunMetal":"#5c6061","linGrad1":"rgba(31,31,31,.2)","linGrad1dark":"rgba(243,246,250,.2)","linGrad2":"#00a1b7","progressColor":"#00a1b7","pageWidth":"1000px","linkFormAppearDuration":"200"};

/***/ }),

/***/ 49851:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"opacityLight":".4","opacityDark":".4","aqua":"#42a5f5","carrot":"#fda639","yellow":"#fac92f","red":"#ed5454","light-green":"#8bc34a","thistle":"#b39ddb","ucla-blue":"#5573a7","blue":"#759ee6","cherry":"#e91e63","orange":"#ff6b00","yellow-green":"#b5d200","green":"#3dca43","jade":"#00c27c","green-sea":"#26a69a","aquamarine":"#00bcd4","dark-sky":"#5a9baf","purple":"#7e75e6","pink":"#e675b8","cloudy":"#607d8b","grey":"#757575","brown":"#795548","black":"#161616","white":"#f5f5f5","paletteAttrBg":"data-palette-bg","paletteAttrBgRGB":"data-palette-bg-rgb","paletteAttrFont":"data-font-color","extraOpacityLight":".12","extraOpacityDark":".2","nimbusWhite":"#e8e8e8","popupAppearDuration":"200","scrollBlotClass":"nedit-root","blotMargin":"18","gunMetal":"#5c6061","linGrad1":"rgba(31,31,31,.2)","linGrad1dark":"rgba(243,246,250,.2)","linGrad2":"#00a1b7","progressColor":"#00a1b7","pageWidth":"1000px","listMarginLeft":"52","listCollapseIconWidth":"24","spaceBetweenCheckboxAndText":"8","smallCheckboxSize":"18","normalCheckboxSize":"20","largeCheckboxSize":"22","spaceBetweenBulletAndText":"8","smallBulletSize":"18","normalBulletSize":"20","largeBulletSize":"22","spaceBetweenNumberAndText":"3"};

/***/ }),

/***/ 84221:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"aqua":"light-blue","carrot":"orange","thistle":"purple","ucla-blue":"indigo","yellow-green":"lime","aquamarine":"cyan","jade":"teal","green-sea":"teal","cloudy":"blue-grey","dark-sky":"blue-grey","cherry":"pink","dark-sky-blue":"light-blue","macaroni-and-cheese":"amber","mango":"orange","coral":"pink","turtle-green":"green","pale-purple":"purple","stormy-blue":"blue","macaroni-and-cheese-highlight":"amber","dark-sky-blue-highlight":"light-blue","mango-highlight":"orange","coral-highlight":"pink","turtle-green-highlight":"green","pale-purple-highlight":"purple","stormy-blue-highlight":"blue","deeed4":"green","ffdbd8":"red","cbefff":"light-blue","feebd3":"amber","f8d3df":"pink","rgba(66, 165, 245, 0.32)":"light-blue","var(--bleu-de-france-32)":"light-blue","rgba(250, 201, 47, 0.32)":"amber","var(--sunglow-32)":"amber","rgba(253, 166, 57, 0.32)":"orange","var(--neon-carrot-32)":"orange","rgba(237, 84, 84, 0.32)":"pink","var(--carmine-pink-32)":"pink","rgba(139, 195, 74, 0.32)":"green","var(--dollar-bill-32)":"green","rgba(179, 157, 219, 0.32)":"purple","var(--light-pastel-purple-32)":"purple","rgba(85, 115, 167, 0.32)":"blue","var(--ucla-blue-32)":"blue"};

/***/ }),

/***/ 13916:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"red":"red","pink":"pink","purple":"purple","deep-purple":"deep-purple","indigo":"indigo","blue":"blue","light-blue":"light-blue","cyan":"cyan","teal":"teal","green":"green","light-green":"light-green","lime":"lime","yellow":"yellow","amber":"amber","orange":"orange","deep-orange":"deep-orange","brown":"brown","grey":"grey","blue-grey":"blue-grey"};

/***/ }),

/***/ 68055:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"red":"#d32f2f","pink":"#c2185b","purple":"#7b1fa2","deep-purple":"#512da8","indigo":"#303f9f","blue":"#1976d2","light-blue":"#0288d1","cyan":"#0097a7","teal":"#00796b","green":"#388e3c","light-green":"#689f38","lime":"#afb42b","yellow":"#fbc02d","amber":"#ffa000","orange":"#f57c00","deep-orange":"#e64a19","brown":"#5d4037","grey":"#616161","blue-grey":"#455a64"};

/***/ }),

/***/ 62775:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"extra-cherry":"extra-pink","orange-red":"extra-red","yellow-carrot":"extra-orange","yellow-green-jade":"extra-green","extra-aquamarine":"extra-cyan","purple-aqua":"extra-light-blue","extra-purple":"extra-deep-purple"};

/***/ }),

/***/ 57673:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"extra-pink":"extra-pink","extra-red":"extra-red","extra-orange":"extra-orange","extra-green":"extra-green","extra-cyan":"extra-cyan","extra-light-blue":"extra-light-blue","extra-deep-purple":"extra-deep-purple"};

/***/ }),

/***/ 84087:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"red":"#ef9a9a","pink":"#f48fb1","purple":"#ce93d8","deep-purple":"#b39ddb","indigo":"#9fa8da","blue":"#90caf9","light-blue":"#81d4fa","cyan":"#80deea","teal":"#80cbc4","green":"#a5d6a7","light-green":"#c5e1a5","lime":"#e6ee9c","yellow":"#fff59d","amber":"#ffe082","orange":"#ffcc80","deep-orange":"#ffab91","brown":"#bcaaa4","grey":"#eee","blue-grey":"#b0bec5"};

/***/ }),

/***/ 70133:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"red":"#f44336","pink":"#e91e63","purple":"#9c27b0","deep-purple":"#673ab7","indigo":"#3f51b5","blue":"#2196f3","light-blue":"#03a9f4","cyan":"#00bcd4","teal":"#009688","green":"#4caf50","light-green":"#8bc34a","lime":"#cddc39","yellow":"#ffeb3b","amber":"#ffc107","orange":"#ff9800","deep-orange":"#ff5722","brown":"#795548","grey":"#9e9e9e","blue-grey":"#607d8b"};

/***/ }),

/***/ 9281:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"opacityLight":".4","opacityDark":".4","aqua":"#42a5f5","carrot":"#fda639","yellow":"#fac92f","red":"#ed5454","light-green":"#8bc34a","thistle":"#b39ddb","ucla-blue":"#5573a7","blue":"#759ee6","cherry":"#e91e63","orange":"#ff6b00","yellow-green":"#b5d200","green":"#3dca43","jade":"#00c27c","green-sea":"#26a69a","aquamarine":"#00bcd4","dark-sky":"#5a9baf","purple":"#7e75e6","pink":"#e675b8","cloudy":"#607d8b","grey":"#757575","brown":"#795548","black":"#161616","white":"#f5f5f5","paletteAttrBg":"data-palette-bg","paletteAttrBgRGB":"data-palette-bg-rgb","paletteAttrFont":"data-font-color","extraOpacityLight":".12","extraOpacityDark":".2","nimbusWhite":"#e8e8e8","popupAppearDuration":"200","scrollBlotClass":"nedit-root","blotMargin":"18","gunMetal":"#5c6061","linGrad1":"rgba(31,31,31,.2)","linGrad1dark":"rgba(243,246,250,.2)","linGrad2":"#00a1b7","progressColor":"#00a1b7","pageWidth":"1000px","mentionListMaxHeight":"370","mentionListPadding":"16"};

/***/ }),

/***/ 22492:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"opacityLight":".4","opacityDark":".4","aqua":"#42a5f5","carrot":"#fda639","yellow":"#fac92f","red":"#ed5454","light-green":"#8bc34a","thistle":"#b39ddb","ucla-blue":"#5573a7","blue":"#759ee6","cherry":"#e91e63","orange":"#ff6b00","yellow-green":"#b5d200","green":"#3dca43","jade":"#00c27c","green-sea":"#26a69a","aquamarine":"#00bcd4","dark-sky":"#5a9baf","purple":"#7e75e6","pink":"#e675b8","cloudy":"#607d8b","grey":"#757575","brown":"#795548","black":"#161616","white":"#f5f5f5","paletteAttrBg":"data-palette-bg","paletteAttrBgRGB":"data-palette-bg-rgb","paletteAttrFont":"data-font-color","extraOpacityLight":".12","extraOpacityDark":".2","nimbusWhite":"#e8e8e8","popupAppearDuration":"200","scrollBlotClass":"nedit-root","blotMargin":"18","gunMetal":"#5c6061","linGrad1":"rgba(31,31,31,.2)","linGrad1dark":"rgba(243,246,250,.2)","linGrad2":"#00a1b7","progressColor":"#00a1b7","pageWidth":"1000px","PALETTE_ATTR_BG":"data-palette-bg","PALETTE_ATTR_BG_RGB":"data-palette-bg-rgb","PALETTE_ATTR_FONT":"data-font-color"};

/***/ }),

/***/ 62297:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"opacityLight":".4","opacityDark":".4","aqua":"#42a5f5","carrot":"#fda639","yellow":"#fac92f","red":"#ed5454","light-green":"#8bc34a","thistle":"#b39ddb","ucla-blue":"#5573a7","blue":"#759ee6","cherry":"#e91e63","orange":"#ff6b00","yellow-green":"#b5d200","green":"#3dca43","jade":"#00c27c","green-sea":"#26a69a","aquamarine":"#00bcd4","dark-sky":"#5a9baf","purple":"#7e75e6","pink":"#e675b8","cloudy":"#607d8b","grey":"#757575","brown":"#795548","black":"#161616","white":"#f5f5f5"};

/***/ }),

/***/ 81578:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"menuItemHeight":"32","menuPadding":"7"};

/***/ }),

/***/ 14016:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"opacityLight":".4","opacityDark":".4","aqua":"#42a5f5","carrot":"#fda639","yellow":"#fac92f","red":"#ed5454","light-green":"#8bc34a","thistle":"#b39ddb","ucla-blue":"#5573a7","blue":"#759ee6","cherry":"#e91e63","orange":"#ff6b00","yellow-green":"#b5d200","green":"#3dca43","jade":"#00c27c","green-sea":"#26a69a","aquamarine":"#00bcd4","dark-sky":"#5a9baf","purple":"#7e75e6","pink":"#e675b8","cloudy":"#607d8b","grey":"#757575","brown":"#795548","black":"#161616","white":"#f5f5f5","paletteAttrBg":"data-palette-bg","paletteAttrBgRGB":"data-palette-bg-rgb","paletteAttrFont":"data-font-color","extraOpacityLight":".12","extraOpacityDark":".2","nimbusWhite":"#e8e8e8","popupAppearDuration":"200","scrollBlotClass":"nedit-root","blotMargin":"18","gunMetal":"#5c6061","linGrad1":"rgba(31,31,31,.2)","linGrad1dark":"rgba(243,246,250,.2)","linGrad2":"#00a1b7","progressColor":"#00a1b7","pageWidth":"1000px","professionTransitionDuration":"200"};

/***/ }),

/***/ 46804:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"opacityLight":".4","opacityDark":".4","aqua":"#42a5f5","carrot":"#fda639","yellow":"#fac92f","red":"#ed5454","light-green":"#8bc34a","thistle":"#b39ddb","ucla-blue":"#5573a7","blue":"#759ee6","cherry":"#e91e63","orange":"#ff6b00","yellow-green":"#b5d200","green":"#3dca43","jade":"#00c27c","green-sea":"#26a69a","aquamarine":"#00bcd4","dark-sky":"#5a9baf","purple":"#7e75e6","pink":"#e675b8","cloudy":"#607d8b","grey":"#757575","brown":"#795548","black":"#161616","white":"#f5f5f5","paletteAttrBg":"data-palette-bg","paletteAttrBgRGB":"data-palette-bg-rgb","paletteAttrFont":"data-font-color","extraOpacityLight":".12","extraOpacityDark":".2","nimbusWhite":"#e8e8e8","popupAppearDuration":"200","scrollBlotClass":"nedit-root","blotMargin":"18","gunMetal":"#5c6061","linGrad1":"rgba(31,31,31,.2)","linGrad1dark":"rgba(243,246,250,.2)","linGrad2":"#00a1b7","progressColor":"#00a1b7","pageWidth":"1000px","searchTermHighlightColor":"rgba(1,161,183,.32)"};

/***/ }),

/***/ 80453:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"opacityLight":".4","opacityDark":".4","aqua":"#42a5f5","carrot":"#fda639","yellow":"#fac92f","red":"#ed5454","light-green":"#8bc34a","thistle":"#b39ddb","ucla-blue":"#5573a7","blue":"#759ee6","cherry":"#e91e63","orange":"#ff6b00","yellow-green":"#b5d200","green":"#3dca43","jade":"#00c27c","green-sea":"#26a69a","aquamarine":"#00bcd4","dark-sky":"#5a9baf","purple":"#7e75e6","pink":"#e675b8","cloudy":"#607d8b","grey":"#757575","brown":"#795548","black":"#161616","white":"#f5f5f5","paletteAttrBg":"data-palette-bg","paletteAttrBgRGB":"data-palette-bg-rgb","paletteAttrFont":"data-font-color","extraOpacityLight":".12","extraOpacityDark":".2","nimbusWhite":"#e8e8e8","popupAppearDuration":"200","scrollBlotClass":"nedit-root","blotMargin":"18","gunMetal":"#5c6061","linGrad1":"rgba(31,31,31,.2)","linGrad1dark":"rgba(243,246,250,.2)","linGrad2":"#00a1b7","progressColor":"#00a1b7","pageWidth":"1000px","toolbarMargin":"36","scrollItemsPaddingBottom":"12","tableTopMargin":"22","tableWrapTransition":"350"};

/***/ }),

/***/ 29650:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"transitionDuration":"400"};

/***/ }),

/***/ 20199:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"nimbusWhite":"#e8e8e8","popupAppearDuration":"200","scrollBlotClass":"nedit-root","blotMargin":"18","gunMetal":"#5c6061","linGrad1":"rgba(31,31,31,.2)","linGrad1dark":"rgba(243,246,250,.2)","linGrad2":"#00a1b7","progressColor":"#00a1b7","pageWidth":"1000px"};

/***/ }),

/***/ 29197:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"nimbusWhite":"#e8e8e8","popupAppearDuration":"200","scrollBlotClass":"nedit-root","blotMargin":"18","gunMetal":"#5c6061","linGrad1":"rgba(31,31,31,.2)","linGrad1dark":"rgba(243,246,250,.2)","linGrad2":"#00a1b7","progressColor":"#00a1b7","pageWidth":"1000px"};

/***/ }),

/***/ 12934:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"nimbusWhite":"#e8e8e8","popupAppearDuration":"200","scrollBlotClass":"nedit-root","blotMargin":"18","gunMetal":"#5c6061","linGrad1":"rgba(31,31,31,.2)","linGrad1dark":"rgba(243,246,250,.2)","linGrad2":"#00a1b7","progressColor":"#00a1b7","pageWidth":"1000px","fileHorizontalPadding":"10","fileBorderWidth":"1px","fullScreenViewerPagesMargin":"20","fullScreenViewerFirstPageTopMargin":"10","fullScreenViewerPreviewsMargin":"15","fullScreenViewerPreviewsTopMargin":"15"};

/***/ }),

/***/ 8523:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"ctaButtonPadding":"14px"};

/***/ }),

/***/ 95306:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 42742:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 83473:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 53893:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 57167:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 39727:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 80049:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 36663:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 10962:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 82102:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 2769:
/***/ ((module) => {

module.exports = ".pdf-viewer-printing-pages {\n  display: none;\n}\n.pdf-viewer-printing-pages .pdf-viewer-printing-page {\n  position: relative;\n  top: 0;\n  left: 0;\n  width: 1px;\n  height: 1px;\n  overflow: visible;\n  page-break-after: always;\n  page-break-inside: avoid;\n}\n.pdf-viewer-printing-pages .pdf-viewer-printing-page img {\n  display: block;\n  max-width: unset;\n  height: unset;\n}\n\n@media print {\n  html {\n  width: 100%;\n    height: 100%;\n  }\n  body {\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    background: transparent none;\n  }\n\n  * {\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n\n  body > * {\n    display: none !important;\n  }\n\n  body > .pdf-viewer-printing-pages {\n    display: block !important;\n    width: 100%;\n    height: 100%;\n  }\n}"

/***/ }),

/***/ 28492:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getDumpByURL = exports.Y = exports.DummyProvider = exports.nimbusInitEditor = exports.initEditor = exports.generateRandomUint32 = void 0;
const editor_1 = __webpack_require__(62785);
Object.defineProperty(exports, "nimbusInitEditor", ({ enumerable: true, get: function () { return editor_1.initEditor; } }));
const pdf_1 = __importDefault(__webpack_require__(71372));
const image_1 = __importDefault(__webpack_require__(5371));
const video_1 = __importStar(__webpack_require__(11526));
const websocket_1 = __webpack_require__(65224);
const lodash_merge_1 = __importDefault(__webpack_require__(3260));
const PCancelable = __webpack_require__(75419);
var customDisplayableError_js_1 = __webpack_require__(41552);
Object.defineProperty(exports, "CustomDisplayableError", ({ enumerable: true, get: function () { return customDisplayableError_js_1.default; } }));
var attachmentNotFoundError_js_1 = __webpack_require__(45405);
Object.defineProperty(exports, "AttachmentNotFoundError", ({ enumerable: true, get: function () { return attachmentNotFoundError_js_1.default; } }));
const editorInitCancelled_js_1 = __importDefault(__webpack_require__(56289));
__webpack_require__(12599);
const db_js_1 = __importDefault(__webpack_require__(87159));
const persistence_js_1 = __webpack_require__(47704);
const onAfterPersistenceBindState_js_1 = __importDefault(__webpack_require__(37167));
const origin_js_1 = __webpack_require__(85921);
const noteSyncStatus_js_1 = __webpack_require__(31900);
const Y = __importStar(__webpack_require__(87648));
exports.Y = Y;
const attachmentManagerWrapper_1 = __importDefault(__webpack_require__(85981));
const DummyProvider_1 = __webpack_require__(36790);
Object.defineProperty(exports, "DummyProvider", ({ enumerable: true, get: function () { return DummyProvider_1.DummyProvider; } }));
const util_1 = __webpack_require__(2049);
Object.defineProperty(exports, "getDumpByURL", ({ enumerable: true, get: function () { return util_1.getDumpByURL; } }));
// если в переменную окружения env.PLATFORM передано значение desktop то сборка проекта собирается под desktop версию
const isDesktopBuild = undefined === 'desktop';
const DEFAULT_IFRAMELY_HOST = 'https://iframely.nimbusweb.me';
function httpGetRequest(url) {
    return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        xhr.open('GET', url);
        xhr.onloadend = (e) => {
            try {
                let response = JSON.parse(xhr.response);
                resolve(response.body);
            }
            catch (error) {
                reject(error);
            }
        };
        xhr.onerror = (error) => { reject(error); };
        xhr.send(null);
    });
}
function getHost(url) {
    return url.replace(/https?:\/\//i, '')
        .split('/')[0];
}
exports.generateRandomUint32 = () => {
    if (typeof crypto !== 'undefined' && crypto.getRandomValues != null) {
        let arr = new Uint32Array(1);
        crypto.getRandomValues(arr);
        return arr[0];
    }
    else {
        return Math.ceil(Math.random() * 0xFFFFFFFF);
    }
};
class PCancelableEditorPromise extends (/* unused pure expression or super */ null && (PCancelable)) {
    constructor() {
        super(...arguments);
        this.editorId = 0;
    }
}
const getNoteTokenUrl = ({ workspaceId, textId, }) => `/api/workspaces/${workspaceId}/texts/${textId}/tokens`;
const getShareTokenUrl = ({ shareId, securityKey, textId, }) => `/share/api/shares/${shareId}/textToken?securityKey=${securityKey}&nodeId=${textId}`;
const developGetSocketUrlFunction = ({ workspaceId, textId, cid, }) => (token) => !token && isDesktopBuild ? `` : // в режиме сборки для desktop если токен не установлен то возвращаем пустую строку
    `wss://text.dev-nimbustest.com/socket.io.ws/${workspaceId}/${textId}?token=${token}&cid=${cid}`;
// identified of the current tab
const gFrameId = exports.generateRandomUint32().toString(36);
function fetchToken({ workspaceId, textId, shareId, securityKey, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const tokenUrl = shareId
            ? getShareTokenUrl({
                shareId,
                securityKey,
                textId,
            })
            : getNoteTokenUrl({
                workspaceId,
                textId,
            });
        const response = yield window.fetch(tokenUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        });
        const result = yield response.json();
        return result;
    });
}
let instancePromise;
// identificator of current editor initialization process
// it is needed for detecting stale initializations and aborting them
let lastEditorInitId = 0;
function initEditor(config, prepareEditorConfigFn) {
    return __awaiter(this, void 0, void 0, function* () {
        let editorInitId = ++lastEditorInitId;
        if (instancePromise && !config.shareId) {
            console.log('cancelling instance promise for editor', instancePromise.editorId);
            instancePromise.cancel();
        }
        const { workspaceId, noteId, shareId, securityKey, element, plugins, isShare, mode, blots, serverRoom, scrollingContainer, markdown, theme, manageBlotsLock, user, note, // для desktop
        options, // для desktop
        disableAddNote = false, isMobileDevice = false, applyTemplate = () => { } } = config;
        let { baseUrl } = config;
        if (isDesktopBuild) {
            noteSyncStatus_js_1.setNoteSyncStatus(noteId, note.synced);
        }
        lodash_merge_1.default(blots, {
            file: {
                viewers: [{
                        mime: ['application/pdf'],
                        class: pdf_1.default,
                        options: {
                            workerPath: "/static" + '/assets/pdf_viewer.worker.js',
                            cMapUrl: "/static" + '/assets/cmaps/'
                        },
                    }, {
                        mime: video_1.getVideoTypes(),
                        class: video_1.default,
                        options: {
                            motion: true
                        },
                    }, {
                        mime: ['image/png', 'image/jpeg', 'image/gif'],
                        class: image_1.default,
                        options: {},
                    }, {
                        mime: ['audio/aac', 'audio/mpeg', 'audio/ogg', 'audio/flac', 'audio/wav'],
                        class: 'AudioWiewer',
                        options: {
                            audioPlayerEnabled: true
                        }
                    }]
            },
            'remote-frame': {
                iframelyHost: config.iframelyHost || DEFAULT_IFRAMELY_HOST,
                iframelyPort: config.iframelyPort
            }
        });
        let bookmarkManager = {
            getPreviews: url => {
                return httpGetRequest(`https://nimbusweb.me/sdpreviews/listing.php?p=0&order=best&host=${getHost(url)}&ag=1`).catch(err => {
                    return 'bookmark.error.unknown_error';
                });
            },
            getFavicon: url => {
                return httpGetRequest(`https://www.google.com/s2/favicons?domain=${url}`).catch(err => {
                    return 'bookmark.error.unknown_error';
                });
            },
            iframelyHost: config.iframelyHost || DEFAULT_IFRAMELY_HOST,
            iframelyPort: config.iframelyPort,
            extendedMetaRequest: true
        };
        if (plugins.bookmarkManager) {
            Object.assign(plugins.bookmarkManager, bookmarkManager);
        }
        const cid = exports.generateRandomUint32();
        const textId = config.textId ? config.textId : noteId;
        const showLinkPanel = config.showLinkPanel === undefined ? true : config.showLinkPanel;
        const getSocketUrlFunction = config.getSocketUrlFunction || developGetSocketUrlFunction;
        const appName = options && options.appName && isDesktopBuild ? options.appName : (shareId ? 'shares' : 'web');
        const providerConfig = Object.assign({
            enableSwitch: true,
            startFromEmptyState: true
        }, config.providerConfig);
        const getTokenResponse = (isDesktopBuild) => __awaiter(this, void 0, void 0, function* () {
            let nodeId, token, ttl, baseUrl;
            const tokenResponse = yield fetchToken({
                workspaceId,
                shareId,
                textId,
                securityKey,
            });
            // для сборки под desktop проверяем node.synced
            if (!isDesktopBuild || isDesktopBuild && note.synced) {
                nodeId = tokenResponse.nodeId;
                token = tokenResponse.token;
                ttl = tokenResponse.ttl;
                baseUrl = tokenResponse.url;
            }
            return { nodeId, token, ttl, baseUrl };
        });
        let nodeId = noteId;
        let token = '';
        let ttl = '';
        if (providerConfig.connectToSocket !== false) {
            if (isDesktopBuild) {
                getTokenResponse(isDesktopBuild).then((tokenResponce) => {
                    ;
                    ({ nodeId, token, ttl, baseUrl } = tokenResponce);
                });
            }
            else {
                ;
                ({ nodeId, token, ttl } = yield getTokenResponse(isDesktopBuild));
            }
        }
        if (editorInitId !== lastEditorInitId) {
            // there is a concurrent editor initialization, abort the initialization process
            return;
        }
        const socketUrl = !token && isDesktopBuild ? `` :
            getSocketUrlFunction({
                workspaceId,
                textId,
                cid,
            })(token) + `&app=${appName}&reason=editor&web-editor=${"1.1.10"}&frame_id=${gFrameId}`;
        const editorConfig = Object.assign(Object.assign({ elem: element, createDocument: websocket_1.createDocument,
            plugins,
            isShare, mode: mode || 'edit', showLinkPanel,
            blots,
            providerConfig,
            serverRoom,
            scrollingContainer, url: socketUrl, baseUrl,
            markdown,
            theme,
            manageBlotsLock,
            user,
            disableAddNote }, (config.dump ? { dump: config.dump } : {})), { isMobileDevice,
            applyTemplate });
        editorConfig.plugins.attachmentManager = attachmentManagerWrapper_1.default(editorConfig.plugins.attachmentManager, isDesktopBuild);
        // если сборка под desktop
        if (isDesktopBuild) {
            const localDb = new db_js_1.default();
            const persistence = new (persistence_js_1.getPersistence(Y, localDb))();
            // настройки для desktop версии
            let desktopConfig = Object.assign(Object.assign({ providerConfig: {
                    persistence,
                    noteId,
                    workspaceId,
                    docName: workspaceId + '_' + noteId,
                    onAfterPersistenceBindState: onAfterPersistenceBindState_js_1.default,
                    getUpdateOrigin: // событие после persistence.bindState,
                    origin_js_1.getUpdateOrigin,
                }, blots: {
                    bookmark: { showMenuItemParameters: false },
                    image: {
                        showLeftMenuItemCopyLink: true,
                        showMenuItemOpenInNewTab: false,
                        showMenuItemGetTextFromImage: false,
                        showImageUrlDependOfDisplayUrl: true
                    },
                    file: {
                        viewers: [{
                                mime: ['application/pdf'],
                                options: {
                                    onPrint: options && options.onPrint ? options.onPrint : undefined
                                },
                            }],
                        showMenuItemOpenInNewTab: false,
                        showRightMenuItemCopyLink: false,
                        showLeftMenuItemCopyLink: true,
                        showMenuItemGetTextFromImage: false,
                    },
                    html: {
                        exportBlot: false
                    },
                    hint: {
                        showMenuItem: true
                    }
                }, plugins: {
                    undoManager: {
                        throwExceptionWhenError: false
                    },
                    notificationManager: {
                        showError: ({ message }) => {
                            // @ts-ignore
                            const textEditor = window.textEditor;
                            if (textEditor && textEditor.showError) {
                                textEditor.showError({ message });
                            }
                        }
                    },
                    awarenessPlugin: {
                        enabled: false
                    },
                } }, options), { workspaceId,
                noteId,
                note,
                appName, disableAddNote: false // отключает показ кнопок добавить папку и заметку в mentionList
             });
            lodash_merge_1.default(editorConfig, desktopConfig); // мерджим конфиги
        }
        console.log(`[web-editor] started for ${textId} with token: ${token} and elem: "${editorConfig.elem}"`);
        if (prepareEditorConfigFn) {
            prepareEditorConfigFn(editorConfig);
        }
        instancePromise = editor_1.initEditor(editorConfig);
        console.log('[web-editor] received instance promise for editor', instancePromise.editorId);
        let instance;
        try {
            if (config.onEditorInit && typeof config.onEditorInit == 'function') {
                config.onEditorInit(instance);
            }
            instance = yield instancePromise;
            if (!shareId && config.dump && providerConfig.connectToSocketWithDump === true) {
                getTokenResponse(isDesktopBuild).then(({ token }) => {
                    const newSocketUrl = getSocketUrlFunction({
                        workspaceId,
                        textId,
                        cid,
                    })(token) + `&app=${appName}&reason=editor&web-editor=${"1.1.10"}&frame_id=${gFrameId}`;
                    instance.store.y.sendSyncToken(token, newSocketUrl);
                });
            }
            // в плагин attachmentManager передаём instance редактора
            editorConfig.plugins.attachmentManager.editorInstance = instance;
        }
        catch (err) {
            if (err instanceof editorInitCancelled_js_1.default) {
                return;
            }
            throw err;
        }
        const tokenFreshConfig = {
            workspaceId,
            shareId,
            textId,
            securityKey,
            nodeId,
            cid,
            appName,
        };
        if (isDesktopBuild) {
            noteSyncStatus_js_1.initGetNoteSyncStatus();
            noteSyncStatus_js_1.initSetNoteSyncStatus((globalId, syncStatus) => {
                if (instance.options && syncStatus) {
                    const { note } = instance.options || {};
                    if (note && note.globalId === globalId) {
                        instance.options.note.synced = syncStatus;
                        !shareId && keepTokenFresh(instance, tokenFreshConfig, ttl, getSocketUrlFunction);
                    }
                }
            });
        }
        !shareId && keepTokenFresh(instance, tokenFreshConfig, ttl, getSocketUrlFunction);
        !shareId && watchAttachments(instance);
        return instance;
    });
}
exports.initEditor = initEditor;
/**
 * Watches attachments updates (deletions/restores) and sends them to the server over the socket
 * @param instance editor instance to watch attachments updates for
 */
function watchAttachments(instance) {
    instance.on('attachments-update', (update) => {
        try {
            instance.store.y.sendCustomMessage('attachments-update', update);
        }
        catch (err) {
            console.error('Failed to send attachments update to the server', err);
            throw err;
        }
    });
}
let intervalId;
function keepTokenFresh(instance, config, ttl, socketUrlFn) {
    intervalId && clearInterval(intervalId);
    const { workspaceId, shareId, textId, securityKey, nodeId, cid, appName, } = config;
    console.log('[web-editor] start token fresh keeping for', textId);
    const intervalTimeout = 10000;
    const timeToRefresh = Date.now() + (ttl - 30) * 1000;
    intervalId = setInterval(() => __awaiter(this, void 0, void 0, function* () {
        if (isDesktopBuild) {
            if (!navigator.onLine) {
                return;
            }
            if (!instance.options) {
                return;
            }
            const { note } = instance.options || {};
            if (!note) {
                return;
            }
            if (!note.synced) {
                return;
            }
        }
        console.log('[web-editor] check token for', textId);
        if (instance.destroyed) {
            return clearInterval(intervalId);
        }
        if (Date.now() < timeToRefresh) {
            return;
        }
        console.log('[web-editor] refresh token for', textId);
        const { ttl: newTtl, token: newToken, url: baseUrl } = yield fetchToken({
            workspaceId,
            shareId,
            textId,
            securityKey,
        });
        if (instance.destroyed) {
            return clearInterval(intervalId);
        }
        console.log('[web-editor] keepTokenFresh => nodeId, workspaceId, textId, cid?', nodeId, workspaceId, textId, cid);
        const url = socketUrlFn({
            nodeId,
            workspaceId,
            textId,
            cid,
            baseUrl,
        })(newToken);
        console.log('[web-editor] keepTokenFresh => url?', url);
        const newSocketUrl = url ? url + `&app=${appName}&reason=editor&web-editor=${"1.1.10"}&frame_id=${gFrameId}` : ``;
        console.log('[web-editor] refreshed token for', textId, 'with', newToken);
        if (!isDesktopBuild || isDesktopBuild && newSocketUrl) {
            instance.store.y.sendSyncToken(newToken, newSocketUrl);
            keepTokenFresh(instance, config, newTtl, socketUrlFn);
        }
    }), intervalTimeout);
}


/***/ }),

/***/ 25893:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 47165:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 36413:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(19601);
function _extends() {
  return module.exports = _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) {
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
    }
    return n;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 20260:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(65743);
var possibleNames = __webpack_require__(82212);
var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;

/** @type {import('.')} */
module.exports = function availableTypedArrays() {
  var /** @type {ReturnType<typeof availableTypedArrays>} */out = [];
  for (var i = 0; i < possibleNames.length; i++) {
    if (typeof g[possibleNames[i]] === 'function') {
      // @ts-expect-error
      out[out.length] = possibleNames[i];
    }
  }
  return out;
};

/***/ }),

/***/ 3770:
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;__webpack_require__(41539);
__webpack_require__(39714);
__webpack_require__(26699);
__webpack_require__(32023);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
  'use strict';

  var hasOwn = {}.hasOwnProperty;
  function classNames() {
    var classes = '';
    for (var i = 0; i < arguments.length; i++) {
      var arg = arguments[i];
      if (arg) {
        classes = appendClass(classes, parseValue(arg));
      }
    }
    return classes;
  }
  function parseValue(arg) {
    if (typeof arg === 'string' || typeof arg === 'number') {
      return arg;
    }
    if (_typeof(arg) !== 'object') {
      return '';
    }
    if (Array.isArray(arg)) {
      return classNames.apply(null, arg);
    }
    if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
      return arg.toString();
    }
    var classes = '';
    for (var key in arg) {
      if (hasOwn.call(arg, key) && arg[key]) {
        classes = appendClass(classes, key);
      }
    }
    return classes;
  }
  function appendClass(value, newClass) {
    if (!newClass) {
      return value;
    }
    if (value) {
      return value + ' ' + newClass;
    }
    return value + newClass;
  }
  if ( true && module.exports) {
    classNames.default = classNames;
    module.exports = classNames;
  } else if ( true && _typeof(__webpack_require__.amdO) === 'object' && __webpack_require__.amdO) {
    // register as 'classnames', consistent with npm package name
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return classNames;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    window.classNames = classNames;
  }
})();

/***/ }),

/***/ 92538:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* eslint global-require: 0 */
// the code is structured this way so that bundlers can
// alias out `has-symbols` to `() => true` or `() => false` if your target
// environments' Symbol capabilities are known, and then use
// dead code elimination on the rest of this module.
//
// Similarly, `isarray` can be aliased to `Array.isArray` if
// available in all target environments.
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(41539);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(82526);
__webpack_require__(41817);
var isArguments = __webpack_require__(99719);
var getStopIterationIterator = __webpack_require__(27154);
if (__webpack_require__(98949)() || __webpack_require__(3810)()) {
  var $iterator = Symbol.iterator;
  // Symbol is available natively or shammed
  // natively:
  //  - Chrome >= 38
  //  - Edge 12-14?, Edge >= 15 for sure
  //  - FF >= 36
  //  - Safari >= 9
  //  - node >= 0.12
  module.exports = function getIterator(iterable) {
    // alternatively, `iterable[$iterator]?.()`
    if (iterable != null && typeof iterable[$iterator] !== 'undefined') {
      return iterable[$iterator]();
    }
    if (isArguments(iterable)) {
      // arguments objects lack Symbol.iterator
      // - node 0.12
      return Array.prototype[$iterator].call(iterable);
    }
  };
} else {
  // Symbol is not available, native or shammed
  var isArray = __webpack_require__(98597);
  var isString = __webpack_require__(68210);
  var GetIntrinsic = __webpack_require__(37555);
  var $Map = GetIntrinsic('%Map%', true);
  var $Set = GetIntrinsic('%Set%', true);
  var callBound = __webpack_require__(73684);
  var $arrayPush = callBound('Array.prototype.push');
  var $charCodeAt = callBound('String.prototype.charCodeAt');
  var $stringSlice = callBound('String.prototype.slice');
  var advanceStringIndex = function advanceStringIndex(S, index) {
    var length = S.length;
    if (index + 1 >= length) {
      return index + 1;
    }
    var first = $charCodeAt(S, index);
    if (first < 0xD800 || first > 0xDBFF) {
      return index + 1;
    }
    var second = $charCodeAt(S, index + 1);
    if (second < 0xDC00 || second > 0xDFFF) {
      return index + 1;
    }
    return index + 2;
  };
  var getArrayIterator = function getArrayIterator(arraylike) {
    var i = 0;
    return {
      next: function next() {
        var done = i >= arraylike.length;
        var value;
        if (!done) {
          value = arraylike[i];
          i += 1;
        }
        return {
          done: done,
          value: value
        };
      }
    };
  };
  var getNonCollectionIterator = function getNonCollectionIterator(iterable, noPrimordialCollections) {
    if (isArray(iterable) || isArguments(iterable)) {
      return getArrayIterator(iterable);
    }
    if (isString(iterable)) {
      var i = 0;
      return {
        next: function next() {
          var nextIndex = advanceStringIndex(iterable, i);
          var value = $stringSlice(iterable, i, nextIndex);
          i = nextIndex;
          return {
            done: nextIndex > iterable.length,
            value: value
          };
        }
      };
    }

    // es6-shim and es-shims' es-map use a string "_es6-shim iterator_" property on different iterables, such as MapIterator.
    if (noPrimordialCollections && typeof iterable['_es6-shim iterator_'] !== 'undefined') {
      return iterable['_es6-shim iterator_']();
    }
  };
  if (!$Map && !$Set) {
    // the only language iterables are Array, String, arguments
    // - Safari <= 6.0
    // - Chrome < 38
    // - node < 0.12
    // - FF < 13
    // - IE < 11
    // - Edge < 11

    module.exports = function getIterator(iterable) {
      if (iterable != null) {
        return getNonCollectionIterator(iterable, true);
      }
    };
  } else {
    // either Map or Set are available, but Symbol is not
    // - es6-shim on an ES5 browser
    // - Safari 6.2 (maybe 6.1?)
    // - FF v[13, 36)
    // - IE 11
    // - Edge 11
    // - Safari v[6, 9)

    var isMap = __webpack_require__(77088);
    var isSet = __webpack_require__(9458);

    // Firefox >= 27, IE 11, Safari 6.2 - 9, Edge 11, es6-shim in older envs, all have forEach
    var $mapForEach = callBound('Map.prototype.forEach', true);
    var $setForEach = callBound('Set.prototype.forEach', true);
    if (typeof process === 'undefined' || !process.versions || !process.versions.node) {
      // "if is not node"

      // Firefox 17 - 26 has `.iterator()`, whose iterator `.next()` either
      // returns a value, or throws a StopIteration object. These browsers
      // do not have any other mechanism for iteration.
      var $mapIterator = callBound('Map.prototype.iterator', true);
      var $setIterator = callBound('Set.prototype.iterator', true);
    }
    // Firefox 27-35, and some older es6-shim versions, use a string "@@iterator" property
    // this returns a proper iterator object, so we should use it instead of forEach.
    // newer es6-shim versions use a string "_es6-shim iterator_" property.
    var $mapAtAtIterator = callBound('Map.prototype.@@iterator', true) || callBound('Map.prototype._es6-shim iterator_', true);
    var $setAtAtIterator = callBound('Set.prototype.@@iterator', true) || callBound('Set.prototype._es6-shim iterator_', true);
    var getCollectionIterator = function getCollectionIterator(iterable) {
      if (isMap(iterable)) {
        if ($mapIterator) {
          return getStopIterationIterator($mapIterator(iterable));
        }
        if ($mapAtAtIterator) {
          return $mapAtAtIterator(iterable);
        }
        if ($mapForEach) {
          var entries = [];
          $mapForEach(iterable, function (v, k) {
            $arrayPush(entries, [k, v]);
          });
          return getArrayIterator(entries);
        }
      }
      if (isSet(iterable)) {
        if ($setIterator) {
          return getStopIterationIterator($setIterator(iterable));
        }
        if ($setAtAtIterator) {
          return $setAtAtIterator(iterable);
        }
        if ($setForEach) {
          var values = [];
          $setForEach(iterable, function (v) {
            $arrayPush(values, v);
          });
          return getArrayIterator(values);
        }
      }
    };
    module.exports = function getIterator(iterable) {
      return getCollectionIterator(iterable) || getNonCollectionIterator(iterable);
    };
  }
}

/***/ }),

/***/ 87648:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var observable = __webpack_require__(1058);
var array = __webpack_require__(64706);
var math = __webpack_require__(97757);
var map = __webpack_require__(23678);
var encoding = __webpack_require__(32979);
var decoding = __webpack_require__(60865);
var random = __webpack_require__(39163);
var promise = __webpack_require__(23291);
var buffer = __webpack_require__(41028);
var error = __webpack_require__(4560);
var binary = __webpack_require__(13149);
var f = __webpack_require__(13039);
var set = __webpack_require__(33930);
var logging = __webpack_require__(96759);
var time = __webpack_require__(57831);
var iterator = __webpack_require__(18263);
var object = __webpack_require__(418);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var array__namespace = /*#__PURE__*/_interopNamespace(array);
var math__namespace = /*#__PURE__*/_interopNamespace(math);
var map__namespace = /*#__PURE__*/_interopNamespace(map);
var encoding__namespace = /*#__PURE__*/_interopNamespace(encoding);
var decoding__namespace = /*#__PURE__*/_interopNamespace(decoding);
var random__namespace = /*#__PURE__*/_interopNamespace(random);
var promise__namespace = /*#__PURE__*/_interopNamespace(promise);
var buffer__namespace = /*#__PURE__*/_interopNamespace(buffer);
var error__namespace = /*#__PURE__*/_interopNamespace(error);
var binary__namespace = /*#__PURE__*/_interopNamespace(binary);
var f__namespace = /*#__PURE__*/_interopNamespace(f);
var set__namespace = /*#__PURE__*/_interopNamespace(set);
var logging__namespace = /*#__PURE__*/_interopNamespace(logging);
var time__namespace = /*#__PURE__*/_interopNamespace(time);
var iterator__namespace = /*#__PURE__*/_interopNamespace(iterator);
var object__namespace = /*#__PURE__*/_interopNamespace(object);

/**
 * This is an abstract interface that all Connectors should implement to keep them interchangeable.
 *
 * @note This interface is experimental and it is not advised to actually inherit this class.
 *       It just serves as typing information.
 *
 * @extends {Observable<any>}
 */
class AbstractConnector extends observable.Observable {
  /**
   * @param {Doc} ydoc
   * @param {any} awareness
   */
  constructor (ydoc, awareness) {
    super();
    this.doc = ydoc;
    this.awareness = awareness;
  }
}

class DeleteItem {
  /**
   * @param {number} clock
   * @param {number} len
   */
  constructor (clock, len) {
    /**
     * @type {number}
     */
    this.clock = clock;
    /**
     * @type {number}
     */
    this.len = len;
  }
}

/**
 * We no longer maintain a DeleteStore. DeleteSet is a temporary object that is created when needed.
 * - When created in a transaction, it must only be accessed after sorting, and merging
 *   - This DeleteSet is send to other clients
 * - We do not create a DeleteSet when we send a sync message. The DeleteSet message is created directly from StructStore
 * - We read a DeleteSet as part of a sync/update message. In this case the DeleteSet is already sorted and merged.
 */
class DeleteSet {
  constructor () {
    /**
     * @type {Map<number,Array<DeleteItem>>}
     */
    this.clients = new Map();
  }
}

/**
 * Iterate over all structs that the DeleteSet gc's.
 *
 * @param {Transaction} transaction
 * @param {DeleteSet} ds
 * @param {function(GC|Item):void} f
 *
 * @function
 */
const iterateDeletedStructs = (transaction, ds, f) =>
  ds.clients.forEach((deletes, clientid) => {
    const structs = /** @type {Array<GC|Item>} */ (transaction.doc.store.clients.get(clientid));
    for (let i = 0; i < deletes.length; i++) {
      const del = deletes[i];
      iterateStructs(transaction, structs, del.clock, del.len, f);
    }
  });

/**
 * @param {Array<DeleteItem>} dis
 * @param {number} clock
 * @return {number|null}
 *
 * @private
 * @function
 */
const findIndexDS = (dis, clock) => {
  let left = 0;
  let right = dis.length - 1;
  while (left <= right) {
    const midindex = math__namespace.floor((left + right) / 2);
    const mid = dis[midindex];
    const midclock = mid.clock;
    if (midclock <= clock) {
      if (clock < midclock + mid.len) {
        return midindex
      }
      left = midindex + 1;
    } else {
      right = midindex - 1;
    }
  }
  return null
};

/**
 * @param {DeleteSet} ds
 * @param {ID} id
 * @return {boolean}
 *
 * @private
 * @function
 */
const isDeleted = (ds, id) => {
  const dis = ds.clients.get(id.client);
  return dis !== undefined && findIndexDS(dis, id.clock) !== null
};

/**
 * @param {DeleteSet} ds
 *
 * @private
 * @function
 */
const sortAndMergeDeleteSet = ds => {
  ds.clients.forEach(dels => {
    dels.sort((a, b) => a.clock - b.clock);
    // merge items without filtering or splicing the array
    // i is the current pointer
    // j refers to the current insert position for the pointed item
    // try to merge dels[i] into dels[j-1] or set dels[j]=dels[i]
    let i, j;
    for (i = 1, j = 1; i < dels.length; i++) {
      const left = dels[j - 1];
      const right = dels[i];
      if (left.clock + left.len >= right.clock) {
        left.len = math__namespace.max(left.len, right.clock + right.len - left.clock);
      } else {
        if (j < i) {
          dels[j] = right;
        }
        j++;
      }
    }
    dels.length = j;
  });
};

/**
 * @param {Array<DeleteSet>} dss
 * @return {DeleteSet} A fresh DeleteSet
 */
const mergeDeleteSets = dss => {
  const merged = new DeleteSet();
  for (let dssI = 0; dssI < dss.length; dssI++) {
    dss[dssI].clients.forEach((delsLeft, client) => {
      if (!merged.clients.has(client)) {
        // Write all missing keys from current ds and all following.
        // If merged already contains `client` current ds has already been added.
        /**
         * @type {Array<DeleteItem>}
         */
        const dels = delsLeft.slice();
        for (let i = dssI + 1; i < dss.length; i++) {
          array__namespace.appendTo(dels, dss[i].clients.get(client) || []);
        }
        merged.clients.set(client, dels);
      }
    });
  }
  sortAndMergeDeleteSet(merged);
  return merged
};

/**
 * @param {DeleteSet} ds
 * @param {number} client
 * @param {number} clock
 * @param {number} length
 *
 * @private
 * @function
 */
const addToDeleteSet = (ds, client, clock, length) => {
  map__namespace.setIfUndefined(ds.clients, client, () => []).push(new DeleteItem(clock, length));
};

const createDeleteSet = () => new DeleteSet();

/**
 * @param {StructStore} ss
 * @return {DeleteSet} Merged and sorted DeleteSet
 *
 * @private
 * @function
 */
const createDeleteSetFromStructStore = ss => {
  const ds = createDeleteSet();
  ss.clients.forEach((structs, client) => {
    /**
     * @type {Array<DeleteItem>}
     */
    const dsitems = [];
    for (let i = 0; i < structs.length; i++) {
      const struct = structs[i];
      if (struct.deleted) {
        const clock = struct.id.clock;
        let len = struct.length;
        if (i + 1 < structs.length) {
          for (let next = structs[i + 1]; i + 1 < structs.length && next.deleted; next = structs[++i + 1]) {
            len += next.length;
          }
        }
        dsitems.push(new DeleteItem(clock, len));
      }
    }
    if (dsitems.length > 0) {
      ds.clients.set(client, dsitems);
    }
  });
  return ds
};

/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {DeleteSet} ds
 *
 * @private
 * @function
 */
const writeDeleteSet = (encoder, ds) => {
  encoding__namespace.writeVarUint(encoder.restEncoder, ds.clients.size);
  ds.clients.forEach((dsitems, client) => {
    encoder.resetDsCurVal();
    encoding__namespace.writeVarUint(encoder.restEncoder, client);
    const len = dsitems.length;
    encoding__namespace.writeVarUint(encoder.restEncoder, len);
    for (let i = 0; i < len; i++) {
      const item = dsitems[i];
      encoder.writeDsClock(item.clock);
      encoder.writeDsLen(item.len);
    }
  });
};

/**
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @return {DeleteSet}
 *
 * @private
 * @function
 */
const readDeleteSet = decoder => {
  const ds = new DeleteSet();
  const numClients = decoding__namespace.readVarUint(decoder.restDecoder);
  for (let i = 0; i < numClients; i++) {
    decoder.resetDsCurVal();
    const client = decoding__namespace.readVarUint(decoder.restDecoder);
    const numberOfDeletes = decoding__namespace.readVarUint(decoder.restDecoder);
    if (numberOfDeletes > 0) {
      const dsField = map__namespace.setIfUndefined(ds.clients, client, () => []);
      for (let i = 0; i < numberOfDeletes; i++) {
        dsField.push(new DeleteItem(decoder.readDsClock(), decoder.readDsLen()));
      }
    }
  }
  return ds
};

/**
 * @todo YDecoder also contains references to String and other Decoders. Would make sense to exchange YDecoder.toUint8Array for YDecoder.DsToUint8Array()..
 */

/**
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @return {Uint8Array|null} Returns a v2 update containing all deletes that couldn't be applied yet; or null if all deletes were applied successfully.
 *
 * @private
 * @function
 */
const readAndApplyDeleteSet = (decoder, transaction, store) => {
  const unappliedDS = new DeleteSet();
  const numClients = decoding__namespace.readVarUint(decoder.restDecoder);
  for (let i = 0; i < numClients; i++) {
    decoder.resetDsCurVal();
    const client = decoding__namespace.readVarUint(decoder.restDecoder);
    const numberOfDeletes = decoding__namespace.readVarUint(decoder.restDecoder);
    const structs = store.clients.get(client) || [];
    const state = getState(store, client);
    for (let i = 0; i < numberOfDeletes; i++) {
      const clock = decoder.readDsClock();
      const clockEnd = clock + decoder.readDsLen();
      if (clock < state) {
        if (state < clockEnd) {
          addToDeleteSet(unappliedDS, client, state, clockEnd - state);
        }
        let index = findIndexSS(structs, clock);
        /**
         * We can ignore the case of GC and Delete structs, because we are going to skip them
         * @type {Item}
         */
        // @ts-ignore
        let struct = structs[index];
        // split the first item if necessary
        if (!struct.deleted && struct.id.clock < clock) {
          structs.splice(index + 1, 0, splitItem(transaction, struct, clock - struct.id.clock));
          index++; // increase we now want to use the next struct
        }
        while (index < structs.length) {
          // @ts-ignore
          struct = structs[index++];
          if (struct.id.clock < clockEnd) {
            if (!struct.deleted) {
              if (clockEnd < struct.id.clock + struct.length) {
                structs.splice(index, 0, splitItem(transaction, struct, clockEnd - struct.id.clock));
              }
              struct.delete(transaction);
            }
          } else {
            break
          }
        }
      } else {
        addToDeleteSet(unappliedDS, client, clock, clockEnd - clock);
      }
    }
  }
  if (unappliedDS.clients.size > 0) {
    const ds = new UpdateEncoderV2();
    encoding__namespace.writeVarUint(ds.restEncoder, 0); // encode 0 structs
    writeDeleteSet(ds, unappliedDS);
    return ds.toUint8Array()
  }
  return null
};

/**
 * @module Y
 */

const generateNewClientId = random__namespace.uint32;

/**
 * @typedef {Object} DocOpts
 * @property {boolean} [DocOpts.gc=true] Disable garbage collection (default: gc=true)
 * @property {function(Item):boolean} [DocOpts.gcFilter] Will be called before an Item is garbage collected. Return false to keep the Item.
 * @property {string} [DocOpts.guid] Define a globally unique identifier for this document
 * @property {string | null} [DocOpts.collectionid] Associate this document with a collection. This only plays a role if your provider has a concept of collection.
 * @property {any} [DocOpts.meta] Any kind of meta information you want to associate with this document. If this is a subdocument, remote peers will store the meta information as well.
 * @property {boolean} [DocOpts.autoLoad] If a subdocument, automatically load document. If this is a subdocument, remote peers will load the document as well automatically.
 * @property {boolean} [DocOpts.shouldLoad] Whether the document should be synced by the provider now. This is toggled to true when you call ydoc.load()
 */

/**
 * A Yjs instance handles the state of shared data.
 * @extends Observable<string>
 */
class Doc extends observable.Observable {
  /**
   * @param {DocOpts} [opts] configuration
   */
  constructor ({ guid = random__namespace.uuidv4(), collectionid = null, gc = true, gcFilter = () => true, meta = null, autoLoad = false, shouldLoad = true } = {}) {
    super();
    this.gc = gc;
    this.gcFilter = gcFilter;
    this.clientID = generateNewClientId();
    this.guid = guid;
    this.collectionid = collectionid;
    /**
     * @type {Map<string, AbstractType<YEvent<any>>>}
     */
    this.share = new Map();
    this.store = new StructStore();
    /**
     * @type {Transaction | null}
     */
    this._transaction = null;
    /**
     * @type {Array<Transaction>}
     */
    this._transactionCleanups = [];
    /**
     * @type {Set<Doc>}
     */
    this.subdocs = new Set();
    /**
     * If this document is a subdocument - a document integrated into another document - then _item is defined.
     * @type {Item?}
     */
    this._item = null;
    this.shouldLoad = shouldLoad;
    this.autoLoad = autoLoad;
    this.meta = meta;
    this.isLoaded = false;
    this.whenLoaded = promise__namespace.create(resolve => {
      this.on('load', () => {
        this.isLoaded = true;
        resolve(this);
      });
    });
  }

  /**
   * Notify the parent document that you request to load data into this subdocument (if it is a subdocument).
   *
   * `load()` might be used in the future to request any provider to load the most current data.
   *
   * It is safe to call `load()` multiple times.
   */
  load () {
    const item = this._item;
    if (item !== null && !this.shouldLoad) {
      transact(/** @type {any} */ (item.parent).doc, transaction => {
        transaction.subdocsLoaded.add(this);
      }, null, true);
    }
    this.shouldLoad = true;
  }

  getSubdocs () {
    return this.subdocs
  }

  getSubdocGuids () {
    return new Set(Array.from(this.subdocs).map(doc => doc.guid))
  }

  /**
   * Changes that happen inside of a transaction are bundled. This means that
   * the observer fires _after_ the transaction is finished and that all changes
   * that happened inside of the transaction are sent as one message to the
   * other peers.
   *
   * @param {function(Transaction):void} f The function that should be executed as a transaction
   * @param {any} [origin] Origin of who started the transaction. Will be stored on transaction.origin
   *
   * @public
   */
  transact (f, origin = null) {
    transact(this, f, origin);
  }

  /**
   * Define a shared data type.
   *
   * Multiple calls of `y.get(name, TypeConstructor)` yield the same result
   * and do not overwrite each other. I.e.
   * `y.define(name, Y.Array) === y.define(name, Y.Array)`
   *
   * After this method is called, the type is also available on `y.share.get(name)`.
   *
   * *Best Practices:*
   * Define all types right after the Yjs instance is created and store them in a separate object.
   * Also use the typed methods `getText(name)`, `getArray(name)`, ..
   *
   * @example
   *   const y = new Y(..)
   *   const appState = {
   *     document: y.getText('document')
   *     comments: y.getArray('comments')
   *   }
   *
   * @param {string} name
   * @param {Function} TypeConstructor The constructor of the type definition. E.g. Y.Text, Y.Array, Y.Map, ...
   * @return {AbstractType<any>} The created type. Constructed with TypeConstructor
   *
   * @public
   */
  get (name, TypeConstructor = AbstractType) {
    const type = map__namespace.setIfUndefined(this.share, name, () => {
      // @ts-ignore
      const t = new TypeConstructor();
      t._integrate(this, null);
      return t
    });
    const Constr = type.constructor;
    if (TypeConstructor !== AbstractType && Constr !== TypeConstructor) {
      if (Constr === AbstractType) {
        // @ts-ignore
        const t = new TypeConstructor();
        t._map = type._map;
        type._map.forEach(/** @param {Item?} n */ n => {
          for (; n !== null; n = n.left) {
            // @ts-ignore
            n.parent = t;
          }
        });
        t._start = type._start;
        for (let n = t._start; n !== null; n = n.right) {
          n.parent = t;
        }
        t._length = type._length;
        this.share.set(name, t);
        t._integrate(this, null);
        return t
      } else {
        throw new Error(`Type with the name ${name} has already been defined with a different constructor`)
      }
    }
    return type
  }

  /**
   * @template T
   * @param {string} [name]
   * @return {YArray<T>}
   *
   * @public
   */
  getArray (name = '') {
    // @ts-ignore
    return this.get(name, YArray)
  }

  /**
   * @param {string} [name]
   * @return {YText}
   *
   * @public
   */
  getText (name = '') {
    // @ts-ignore
    return this.get(name, YText)
  }

  /**
   * @template T
   * @param {string} [name]
   * @return {YMap<T>}
   *
   * @public
   */
  getMap (name = '') {
    // @ts-ignore
    return this.get(name, YMap)
  }

  /**
   * @param {string} [name]
   * @return {YXmlFragment}
   *
   * @public
   */
  getXmlFragment (name = '') {
    // @ts-ignore
    return this.get(name, YXmlFragment)
  }

  /**
   * Converts the entire document into a js object, recursively traversing each yjs type
   * Doesn't log types that have not been defined (using ydoc.getType(..)).
   *
   * @deprecated Do not use this method and rather call toJSON directly on the shared types.
   *
   * @return {Object<string, any>}
   */
  toJSON () {
    /**
     * @type {Object<string, any>}
     */
    const doc = {};

    this.share.forEach((value, key) => {
      doc[key] = value.toJSON();
    });

    return doc
  }

  /**
   * Emit `destroy` event and unregister all event handlers.
   */
  destroy () {
    array__namespace.from(this.subdocs).forEach(subdoc => subdoc.destroy());
    const item = this._item;
    if (item !== null) {
      this._item = null;
      const content = /** @type {ContentDoc} */ (item.content);
      content.doc = new Doc({ guid: this.guid, ...content.opts, shouldLoad: false });
      content.doc._item = item;
      transact(/** @type {any} */ (item).parent.doc, transaction => {
        const doc = content.doc;
        if (!item.deleted) {
          transaction.subdocsAdded.add(doc);
        }
        transaction.subdocsRemoved.add(this);
      }, null, true);
    }
    this.emit('destroyed', [true]);
    this.emit('destroy', [this]);
    super.destroy();
  }

  /**
   * @param {string} eventName
   * @param {function(...any):any} f
   */
  on (eventName, f) {
    super.on(eventName, f);
  }

  /**
   * @param {string} eventName
   * @param {function} f
   */
  off (eventName, f) {
    super.off(eventName, f);
  }
}

class DSDecoderV1 {
  /**
   * @param {decoding.Decoder} decoder
   */
  constructor (decoder) {
    this.restDecoder = decoder;
  }

  resetDsCurVal () {
    // nop
  }

  /**
   * @return {number}
   */
  readDsClock () {
    return decoding__namespace.readVarUint(this.restDecoder)
  }

  /**
   * @return {number}
   */
  readDsLen () {
    return decoding__namespace.readVarUint(this.restDecoder)
  }
}

class UpdateDecoderV1 extends DSDecoderV1 {
  /**
   * @return {ID}
   */
  readLeftID () {
    return createID(decoding__namespace.readVarUint(this.restDecoder), decoding__namespace.readVarUint(this.restDecoder))
  }

  /**
   * @return {ID}
   */
  readRightID () {
    return createID(decoding__namespace.readVarUint(this.restDecoder), decoding__namespace.readVarUint(this.restDecoder))
  }

  /**
   * Read the next client id.
   * Use this in favor of readID whenever possible to reduce the number of objects created.
   */
  readClient () {
    return decoding__namespace.readVarUint(this.restDecoder)
  }

  /**
   * @return {number} info An unsigned 8-bit integer
   */
  readInfo () {
    return decoding__namespace.readUint8(this.restDecoder)
  }

  /**
   * @return {string}
   */
  readString () {
    return decoding__namespace.readVarString(this.restDecoder)
  }

  /**
   * @return {boolean} isKey
   */
  readParentInfo () {
    return decoding__namespace.readVarUint(this.restDecoder) === 1
  }

  /**
   * @return {number} info An unsigned 8-bit integer
   */
  readTypeRef () {
    return decoding__namespace.readVarUint(this.restDecoder)
  }

  /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @return {number} len
   */
  readLen () {
    return decoding__namespace.readVarUint(this.restDecoder)
  }

  /**
   * @return {any}
   */
  readAny () {
    return decoding__namespace.readAny(this.restDecoder)
  }

  /**
   * @return {Uint8Array}
   */
  readBuf () {
    return buffer__namespace.copyUint8Array(decoding__namespace.readVarUint8Array(this.restDecoder))
  }

  /**
   * Legacy implementation uses JSON parse. We use any-decoding in v2.
   *
   * @return {any}
   */
  readJSON () {
    return JSON.parse(decoding__namespace.readVarString(this.restDecoder))
  }

  /**
   * @return {string}
   */
  readKey () {
    return decoding__namespace.readVarString(this.restDecoder)
  }
}

class DSDecoderV2 {
  /**
   * @param {decoding.Decoder} decoder
   */
  constructor (decoder) {
    /**
     * @private
     */
    this.dsCurrVal = 0;
    this.restDecoder = decoder;
  }

  resetDsCurVal () {
    this.dsCurrVal = 0;
  }

  /**
   * @return {number}
   */
  readDsClock () {
    this.dsCurrVal += decoding__namespace.readVarUint(this.restDecoder);
    return this.dsCurrVal
  }

  /**
   * @return {number}
   */
  readDsLen () {
    const diff = decoding__namespace.readVarUint(this.restDecoder) + 1;
    this.dsCurrVal += diff;
    return diff
  }
}

class UpdateDecoderV2 extends DSDecoderV2 {
  /**
   * @param {decoding.Decoder} decoder
   */
  constructor (decoder) {
    super(decoder);
    /**
     * List of cached keys. If the keys[id] does not exist, we read a new key
     * from stringEncoder and push it to keys.
     *
     * @type {Array<string>}
     */
    this.keys = [];
    decoding__namespace.readVarUint(decoder); // read feature flag - currently unused
    this.keyClockDecoder = new decoding__namespace.IntDiffOptRleDecoder(decoding__namespace.readVarUint8Array(decoder));
    this.clientDecoder = new decoding__namespace.UintOptRleDecoder(decoding__namespace.readVarUint8Array(decoder));
    this.leftClockDecoder = new decoding__namespace.IntDiffOptRleDecoder(decoding__namespace.readVarUint8Array(decoder));
    this.rightClockDecoder = new decoding__namespace.IntDiffOptRleDecoder(decoding__namespace.readVarUint8Array(decoder));
    this.infoDecoder = new decoding__namespace.RleDecoder(decoding__namespace.readVarUint8Array(decoder), decoding__namespace.readUint8);
    this.stringDecoder = new decoding__namespace.StringDecoder(decoding__namespace.readVarUint8Array(decoder));
    this.parentInfoDecoder = new decoding__namespace.RleDecoder(decoding__namespace.readVarUint8Array(decoder), decoding__namespace.readUint8);
    this.typeRefDecoder = new decoding__namespace.UintOptRleDecoder(decoding__namespace.readVarUint8Array(decoder));
    this.lenDecoder = new decoding__namespace.UintOptRleDecoder(decoding__namespace.readVarUint8Array(decoder));
  }

  /**
   * @return {ID}
   */
  readLeftID () {
    return new ID(this.clientDecoder.read(), this.leftClockDecoder.read())
  }

  /**
   * @return {ID}
   */
  readRightID () {
    return new ID(this.clientDecoder.read(), this.rightClockDecoder.read())
  }

  /**
   * Read the next client id.
   * Use this in favor of readID whenever possible to reduce the number of objects created.
   */
  readClient () {
    return this.clientDecoder.read()
  }

  /**
   * @return {number} info An unsigned 8-bit integer
   */
  readInfo () {
    return /** @type {number} */ (this.infoDecoder.read())
  }

  /**
   * @return {string}
   */
  readString () {
    return this.stringDecoder.read()
  }

  /**
   * @return {boolean}
   */
  readParentInfo () {
    return this.parentInfoDecoder.read() === 1
  }

  /**
   * @return {number} An unsigned 8-bit integer
   */
  readTypeRef () {
    return this.typeRefDecoder.read()
  }

  /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @return {number}
   */
  readLen () {
    return this.lenDecoder.read()
  }

  /**
   * @return {any}
   */
  readAny () {
    return decoding__namespace.readAny(this.restDecoder)
  }

  /**
   * @return {Uint8Array}
   */
  readBuf () {
    return decoding__namespace.readVarUint8Array(this.restDecoder)
  }

  /**
   * This is mainly here for legacy purposes.
   *
   * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
   *
   * @return {any}
   */
  readJSON () {
    return decoding__namespace.readAny(this.restDecoder)
  }

  /**
   * @return {string}
   */
  readKey () {
    const keyClock = this.keyClockDecoder.read();
    if (keyClock < this.keys.length) {
      return this.keys[keyClock]
    } else {
      const key = this.stringDecoder.read();
      this.keys.push(key);
      return key
    }
  }
}

class DSEncoderV1 {
  constructor () {
    this.restEncoder = encoding__namespace.createEncoder();
  }

  toUint8Array () {
    return encoding__namespace.toUint8Array(this.restEncoder)
  }

  resetDsCurVal () {
    // nop
  }

  /**
   * @param {number} clock
   */
  writeDsClock (clock) {
    encoding__namespace.writeVarUint(this.restEncoder, clock);
  }

  /**
   * @param {number} len
   */
  writeDsLen (len) {
    encoding__namespace.writeVarUint(this.restEncoder, len);
  }
}

class UpdateEncoderV1 extends DSEncoderV1 {
  /**
   * @param {ID} id
   */
  writeLeftID (id) {
    encoding__namespace.writeVarUint(this.restEncoder, id.client);
    encoding__namespace.writeVarUint(this.restEncoder, id.clock);
  }

  /**
   * @param {ID} id
   */
  writeRightID (id) {
    encoding__namespace.writeVarUint(this.restEncoder, id.client);
    encoding__namespace.writeVarUint(this.restEncoder, id.clock);
  }

  /**
   * Use writeClient and writeClock instead of writeID if possible.
   * @param {number} client
   */
  writeClient (client) {
    encoding__namespace.writeVarUint(this.restEncoder, client);
  }

  /**
   * @param {number} info An unsigned 8-bit integer
   */
  writeInfo (info) {
    encoding__namespace.writeUint8(this.restEncoder, info);
  }

  /**
   * @param {string} s
   */
  writeString (s) {
    encoding__namespace.writeVarString(this.restEncoder, s);
  }

  /**
   * @param {boolean} isYKey
   */
  writeParentInfo (isYKey) {
    encoding__namespace.writeVarUint(this.restEncoder, isYKey ? 1 : 0);
  }

  /**
   * @param {number} info An unsigned 8-bit integer
   */
  writeTypeRef (info) {
    encoding__namespace.writeVarUint(this.restEncoder, info);
  }

  /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @param {number} len
   */
  writeLen (len) {
    encoding__namespace.writeVarUint(this.restEncoder, len);
  }

  /**
   * @param {any} any
   */
  writeAny (any) {
    encoding__namespace.writeAny(this.restEncoder, any);
  }

  /**
   * @param {Uint8Array} buf
   */
  writeBuf (buf) {
    encoding__namespace.writeVarUint8Array(this.restEncoder, buf);
  }

  /**
   * @param {any} embed
   */
  writeJSON (embed) {
    encoding__namespace.writeVarString(this.restEncoder, JSON.stringify(embed));
  }

  /**
   * @param {string} key
   */
  writeKey (key) {
    encoding__namespace.writeVarString(this.restEncoder, key);
  }
}

class DSEncoderV2 {
  constructor () {
    this.restEncoder = encoding__namespace.createEncoder(); // encodes all the rest / non-optimized
    this.dsCurrVal = 0;
  }

  toUint8Array () {
    return encoding__namespace.toUint8Array(this.restEncoder)
  }

  resetDsCurVal () {
    this.dsCurrVal = 0;
  }

  /**
   * @param {number} clock
   */
  writeDsClock (clock) {
    const diff = clock - this.dsCurrVal;
    this.dsCurrVal = clock;
    encoding__namespace.writeVarUint(this.restEncoder, diff);
  }

  /**
   * @param {number} len
   */
  writeDsLen (len) {
    if (len === 0) {
      error__namespace.unexpectedCase();
    }
    encoding__namespace.writeVarUint(this.restEncoder, len - 1);
    this.dsCurrVal += len;
  }
}

class UpdateEncoderV2 extends DSEncoderV2 {
  constructor () {
    super();
    /**
     * @type {Map<string,number>}
     */
    this.keyMap = new Map();
    /**
     * Refers to the next uniqe key-identifier to me used.
     * See writeKey method for more information.
     *
     * @type {number}
     */
    this.keyClock = 0;
    this.keyClockEncoder = new encoding__namespace.IntDiffOptRleEncoder();
    this.clientEncoder = new encoding__namespace.UintOptRleEncoder();
    this.leftClockEncoder = new encoding__namespace.IntDiffOptRleEncoder();
    this.rightClockEncoder = new encoding__namespace.IntDiffOptRleEncoder();
    this.infoEncoder = new encoding__namespace.RleEncoder(encoding__namespace.writeUint8);
    this.stringEncoder = new encoding__namespace.StringEncoder();
    this.parentInfoEncoder = new encoding__namespace.RleEncoder(encoding__namespace.writeUint8);
    this.typeRefEncoder = new encoding__namespace.UintOptRleEncoder();
    this.lenEncoder = new encoding__namespace.UintOptRleEncoder();
  }

  toUint8Array () {
    const encoder = encoding__namespace.createEncoder();
    encoding__namespace.writeVarUint(encoder, 0); // this is a feature flag that we might use in the future
    encoding__namespace.writeVarUint8Array(encoder, this.keyClockEncoder.toUint8Array());
    encoding__namespace.writeVarUint8Array(encoder, this.clientEncoder.toUint8Array());
    encoding__namespace.writeVarUint8Array(encoder, this.leftClockEncoder.toUint8Array());
    encoding__namespace.writeVarUint8Array(encoder, this.rightClockEncoder.toUint8Array());
    encoding__namespace.writeVarUint8Array(encoder, encoding__namespace.toUint8Array(this.infoEncoder));
    encoding__namespace.writeVarUint8Array(encoder, this.stringEncoder.toUint8Array());
    encoding__namespace.writeVarUint8Array(encoder, encoding__namespace.toUint8Array(this.parentInfoEncoder));
    encoding__namespace.writeVarUint8Array(encoder, this.typeRefEncoder.toUint8Array());
    encoding__namespace.writeVarUint8Array(encoder, this.lenEncoder.toUint8Array());
    // @note The rest encoder is appended! (note the missing var)
    encoding__namespace.writeUint8Array(encoder, encoding__namespace.toUint8Array(this.restEncoder));
    return encoding__namespace.toUint8Array(encoder)
  }

  /**
   * @param {ID} id
   */
  writeLeftID (id) {
    this.clientEncoder.write(id.client);
    this.leftClockEncoder.write(id.clock);
  }

  /**
   * @param {ID} id
   */
  writeRightID (id) {
    this.clientEncoder.write(id.client);
    this.rightClockEncoder.write(id.clock);
  }

  /**
   * @param {number} client
   */
  writeClient (client) {
    this.clientEncoder.write(client);
  }

  /**
   * @param {number} info An unsigned 8-bit integer
   */
  writeInfo (info) {
    this.infoEncoder.write(info);
  }

  /**
   * @param {string} s
   */
  writeString (s) {
    this.stringEncoder.write(s);
  }

  /**
   * @param {boolean} isYKey
   */
  writeParentInfo (isYKey) {
    this.parentInfoEncoder.write(isYKey ? 1 : 0);
  }

  /**
   * @param {number} info An unsigned 8-bit integer
   */
  writeTypeRef (info) {
    this.typeRefEncoder.write(info);
  }

  /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @param {number} len
   */
  writeLen (len) {
    this.lenEncoder.write(len);
  }

  /**
   * @param {any} any
   */
  writeAny (any) {
    encoding__namespace.writeAny(this.restEncoder, any);
  }

  /**
   * @param {Uint8Array} buf
   */
  writeBuf (buf) {
    encoding__namespace.writeVarUint8Array(this.restEncoder, buf);
  }

  /**
   * This is mainly here for legacy purposes.
   *
   * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
   *
   * @param {any} embed
   */
  writeJSON (embed) {
    encoding__namespace.writeAny(this.restEncoder, embed);
  }

  /**
   * Property keys are often reused. For example, in y-prosemirror the key `bold` might
   * occur very often. For a 3d application, the key `position` might occur very often.
   *
   * We cache these keys in a Map and refer to them via a unique number.
   *
   * @param {string} key
   */
  writeKey (key) {
    const clock = this.keyMap.get(key);
    if (clock === undefined) {
      /**
       * @todo uncomment to introduce this feature finally
       *
       * Background. The ContentFormat object was always encoded using writeKey, but the decoder used to use readString.
       * Furthermore, I forgot to set the keyclock. So everything was working fine.
       *
       * However, this feature here is basically useless as it is not being used (it actually only consumes extra memory).
       *
       * I don't know yet how to reintroduce this feature..
       *
       * Older clients won't be able to read updates when we reintroduce this feature. So this should probably be done using a flag.
       *
       */
      // this.keyMap.set(key, this.keyClock)
      this.keyClockEncoder.write(this.keyClock++);
      this.stringEncoder.write(key);
    } else {
      this.keyClockEncoder.write(clock);
    }
  }
}

/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Array<GC|Item>} structs All structs by `client`
 * @param {number} client
 * @param {number} clock write structs starting with `ID(client,clock)`
 *
 * @function
 */
const writeStructs = (encoder, structs, client, clock) => {
  // write first id
  clock = math__namespace.max(clock, structs[0].id.clock); // make sure the first id exists
  const startNewStructs = findIndexSS(structs, clock);
  // write # encoded structs
  encoding__namespace.writeVarUint(encoder.restEncoder, structs.length - startNewStructs);
  encoder.writeClient(client);
  encoding__namespace.writeVarUint(encoder.restEncoder, clock);
  const firstStruct = structs[startNewStructs];
  // write first struct with an offset
  firstStruct.write(encoder, clock - firstStruct.id.clock);
  for (let i = startNewStructs + 1; i < structs.length; i++) {
    structs[i].write(encoder, 0);
  }
};

/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {StructStore} store
 * @param {Map<number,number>} _sm
 *
 * @private
 * @function
 */
const writeClientsStructs = (encoder, store, _sm) => {
  // we filter all valid _sm entries into sm
  const sm = new Map();
  _sm.forEach((clock, client) => {
    // only write if new structs are available
    if (getState(store, client) > clock) {
      sm.set(client, clock);
    }
  });
  getStateVector(store).forEach((clock, client) => {
    if (!_sm.has(client)) {
      sm.set(client, 0);
    }
  });
  // write # states that were updated
  encoding__namespace.writeVarUint(encoder.restEncoder, sm.size);
  // Write items with higher client ids first
  // This heavily improves the conflict algorithm.
  Array.from(sm.entries()).sort((a, b) => b[0] - a[0]).forEach(([client, clock]) => {
    // @ts-ignore
    writeStructs(encoder, store.clients.get(client), client, clock);
  });
};

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder The decoder object to read data from.
 * @param {Doc} doc
 * @return {Map<number, { i: number, refs: Array<Item | GC> }>}
 *
 * @private
 * @function
 */
const readClientsStructRefs = (decoder, doc) => {
  /**
   * @type {Map<number, { i: number, refs: Array<Item | GC> }>}
   */
  const clientRefs = map__namespace.create();
  const numOfStateUpdates = decoding__namespace.readVarUint(decoder.restDecoder);
  for (let i = 0; i < numOfStateUpdates; i++) {
    const numberOfStructs = decoding__namespace.readVarUint(decoder.restDecoder);
    /**
     * @type {Array<GC|Item>}
     */
    const refs = new Array(numberOfStructs);
    const client = decoder.readClient();
    let clock = decoding__namespace.readVarUint(decoder.restDecoder);
    // const start = performance.now()
    clientRefs.set(client, { i: 0, refs });
    for (let i = 0; i < numberOfStructs; i++) {
      const info = decoder.readInfo();
      switch (binary__namespace.BITS5 & info) {
        case 0: { // GC
          const len = decoder.readLen();
          refs[i] = new GC(createID(client, clock), len);
          clock += len;
          break
        }
        case 10: { // Skip Struct (nothing to apply)
          // @todo we could reduce the amount of checks by adding Skip struct to clientRefs so we know that something is missing.
          const len = decoding__namespace.readVarUint(decoder.restDecoder);
          refs[i] = new Skip(createID(client, clock), len);
          clock += len;
          break
        }
        default: { // Item with content
          /**
           * The optimized implementation doesn't use any variables because inlining variables is faster.
           * Below a non-optimized version is shown that implements the basic algorithm with
           * a few comments
           */
          const cantCopyParentInfo = (info & (binary__namespace.BIT7 | binary__namespace.BIT8)) === 0;
          // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
          // and we read the next string as parentYKey.
          // It indicates how we store/retrieve parent from `y.share`
          // @type {string|null}
          const struct = new Item(
            createID(client, clock),
            null, // leftd
            (info & binary__namespace.BIT8) === binary__namespace.BIT8 ? decoder.readLeftID() : null, // origin
            null, // right
            (info & binary__namespace.BIT7) === binary__namespace.BIT7 ? decoder.readRightID() : null, // right origin
            cantCopyParentInfo ? (decoder.readParentInfo() ? doc.get(decoder.readString()) : decoder.readLeftID()) : null, // parent
            cantCopyParentInfo && (info & binary__namespace.BIT6) === binary__namespace.BIT6 ? decoder.readString() : null, // parentSub
            readItemContent(decoder, info) // item content
          );
          /* A non-optimized implementation of the above algorithm:

          // The item that was originally to the left of this item.
          const origin = (info & binary.BIT8) === binary.BIT8 ? decoder.readLeftID() : null
          // The item that was originally to the right of this item.
          const rightOrigin = (info & binary.BIT7) === binary.BIT7 ? decoder.readRightID() : null
          const cantCopyParentInfo = (info & (binary.BIT7 | binary.BIT8)) === 0
          const hasParentYKey = cantCopyParentInfo ? decoder.readParentInfo() : false
          // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
          // and we read the next string as parentYKey.
          // It indicates how we store/retrieve parent from `y.share`
          // @type {string|null}
          const parentYKey = cantCopyParentInfo && hasParentYKey ? decoder.readString() : null

          const struct = new Item(
            createID(client, clock),
            null, // leftd
            origin, // origin
            null, // right
            rightOrigin, // right origin
            cantCopyParentInfo && !hasParentYKey ? decoder.readLeftID() : (parentYKey !== null ? doc.get(parentYKey) : null), // parent
            cantCopyParentInfo && (info & binary.BIT6) === binary.BIT6 ? decoder.readString() : null, // parentSub
            readItemContent(decoder, info) // item content
          )
          */
          refs[i] = struct;
          clock += struct.length;
        }
      }
    }
    // console.log('time to read: ', performance.now() - start) // @todo remove
  }
  return clientRefs
};

/**
 * Resume computing structs generated by struct readers.
 *
 * While there is something to do, we integrate structs in this order
 * 1. top element on stack, if stack is not empty
 * 2. next element from current struct reader (if empty, use next struct reader)
 *
 * If struct causally depends on another struct (ref.missing), we put next reader of
 * `ref.id.client` on top of stack.
 *
 * At some point we find a struct that has no causal dependencies,
 * then we start emptying the stack.
 *
 * It is not possible to have circles: i.e. struct1 (from client1) depends on struct2 (from client2)
 * depends on struct3 (from client1). Therefore the max stack size is eqaul to `structReaders.length`.
 *
 * This method is implemented in a way so that we can resume computation if this update
 * causally depends on another update.
 *
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @param {Map<number, { i: number, refs: (GC | Item)[] }>} clientsStructRefs
 * @return { null | { update: Uint8Array, missing: Map<number,number> } }
 *
 * @private
 * @function
 */
const integrateStructs = (transaction, store, clientsStructRefs) => {
  /**
   * @type {Array<Item | GC>}
   */
  const stack = [];
  // sort them so that we take the higher id first, in case of conflicts the lower id will probably not conflict with the id from the higher user.
  let clientsStructRefsIds = Array.from(clientsStructRefs.keys()).sort((a, b) => a - b);
  if (clientsStructRefsIds.length === 0) {
    return null
  }
  const getNextStructTarget = () => {
    if (clientsStructRefsIds.length === 0) {
      return null
    }
    let nextStructsTarget = /** @type {{i:number,refs:Array<GC|Item>}} */ (clientsStructRefs.get(clientsStructRefsIds[clientsStructRefsIds.length - 1]));
    while (nextStructsTarget.refs.length === nextStructsTarget.i) {
      clientsStructRefsIds.pop();
      if (clientsStructRefsIds.length > 0) {
        nextStructsTarget = /** @type {{i:number,refs:Array<GC|Item>}} */ (clientsStructRefs.get(clientsStructRefsIds[clientsStructRefsIds.length - 1]));
      } else {
        return null
      }
    }
    return nextStructsTarget
  };
  let curStructsTarget = getNextStructTarget();
  if (curStructsTarget === null && stack.length === 0) {
    return null
  }

  /**
   * @type {StructStore}
   */
  const restStructs = new StructStore();
  const missingSV = new Map();
  /**
   * @param {number} client
   * @param {number} clock
   */
  const updateMissingSv = (client, clock) => {
    const mclock = missingSV.get(client);
    if (mclock == null || mclock > clock) {
      missingSV.set(client, clock);
    }
  };
  /**
   * @type {GC|Item}
   */
  let stackHead = /** @type {any} */ (curStructsTarget).refs[/** @type {any} */ (curStructsTarget).i++];
  // caching the state because it is used very often
  const state = new Map();

  const addStackToRestSS = () => {
    for (const item of stack) {
      const client = item.id.client;
      const unapplicableItems = clientsStructRefs.get(client);
      if (unapplicableItems) {
        // decrement because we weren't able to apply previous operation
        unapplicableItems.i--;
        restStructs.clients.set(client, unapplicableItems.refs.slice(unapplicableItems.i));
        clientsStructRefs.delete(client);
        unapplicableItems.i = 0;
        unapplicableItems.refs = [];
      } else {
        // item was the last item on clientsStructRefs and the field was already cleared. Add item to restStructs and continue
        restStructs.clients.set(client, [item]);
      }
      // remove client from clientsStructRefsIds to prevent users from applying the same update again
      clientsStructRefsIds = clientsStructRefsIds.filter(c => c !== client);
    }
    stack.length = 0;
  };

  // iterate over all struct readers until we are done
  while (true) {
    if (stackHead.constructor !== Skip) {
      const localClock = map__namespace.setIfUndefined(state, stackHead.id.client, () => getState(store, stackHead.id.client));
      const offset = localClock - stackHead.id.clock;
      if (offset < 0) {
        // update from the same client is missing
        stack.push(stackHead);
        updateMissingSv(stackHead.id.client, stackHead.id.clock - 1);
        // hid a dead wall, add all items from stack to restSS
        addStackToRestSS();
      } else {
        const missing = stackHead.getMissing(transaction, store);
        if (missing !== null) {
          stack.push(stackHead);
          // get the struct reader that has the missing struct
          /**
           * @type {{ refs: Array<GC|Item>, i: number }}
           */
          const structRefs = clientsStructRefs.get(/** @type {number} */ (missing)) || { refs: [], i: 0 };
          if (structRefs.refs.length === structRefs.i) {
            // This update message causally depends on another update message that doesn't exist yet
            updateMissingSv(/** @type {number} */ (missing), getState(store, missing));
            addStackToRestSS();
          } else {
            stackHead = structRefs.refs[structRefs.i++];
            continue
          }
        } else if (offset === 0 || offset < stackHead.length) {
          // all fine, apply the stackhead
          stackHead.integrate(transaction, offset);
          state.set(stackHead.id.client, stackHead.id.clock + stackHead.length);
        }
      }
    }
    // iterate to next stackHead
    if (stack.length > 0) {
      stackHead = /** @type {GC|Item} */ (stack.pop());
    } else if (curStructsTarget !== null && curStructsTarget.i < curStructsTarget.refs.length) {
      stackHead = /** @type {GC|Item} */ (curStructsTarget.refs[curStructsTarget.i++]);
    } else {
      curStructsTarget = getNextStructTarget();
      if (curStructsTarget === null) {
        // we are done!
        break
      } else {
        stackHead = /** @type {GC|Item} */ (curStructsTarget.refs[curStructsTarget.i++]);
      }
    }
  }
  if (restStructs.clients.size > 0) {
    const encoder = new UpdateEncoderV2();
    writeClientsStructs(encoder, restStructs, new Map());
    // write empty deleteset
    // writeDeleteSet(encoder, new DeleteSet())
    encoding__namespace.writeVarUint(encoder.restEncoder, 0); // => no need for an extra function call, just write 0 deletes
    return { missing: missingSV, update: encoder.toUint8Array() }
  }
  return null
};

/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Transaction} transaction
 *
 * @private
 * @function
 */
const writeStructsFromTransaction = (encoder, transaction) => writeClientsStructs(encoder, transaction.doc.store, transaction.beforeState);

/**
 * Read and apply a document update.
 *
 * This function has the same effect as `applyUpdate` but accepts an decoder.
 *
 * @param {decoding.Decoder} decoder
 * @param {Doc} ydoc
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 * @param {UpdateDecoderV1 | UpdateDecoderV2} [structDecoder]
 *
 * @function
 */
const readUpdateV2 = (decoder, ydoc, transactionOrigin, structDecoder = new UpdateDecoderV2(decoder)) =>
  transact(ydoc, transaction => {
    // force that transaction.local is set to non-local
    transaction.local = false;
    let retry = false;
    const doc = transaction.doc;
    const store = doc.store;
    // let start = performance.now()
    const ss = readClientsStructRefs(structDecoder, doc);
    // console.log('time to read structs: ', performance.now() - start) // @todo remove
    // start = performance.now()
    // console.log('time to merge: ', performance.now() - start) // @todo remove
    // start = performance.now()
    const restStructs = integrateStructs(transaction, store, ss);
    const pending = store.pendingStructs;
    if (pending) {
      // check if we can apply something
      for (const [client, clock] of pending.missing) {
        if (clock < getState(store, client)) {
          retry = true;
          break
        }
      }
      if (restStructs) {
        // merge restStructs into store.pending
        for (const [client, clock] of restStructs.missing) {
          const mclock = pending.missing.get(client);
          if (mclock == null || mclock > clock) {
            pending.missing.set(client, clock);
          }
        }
        pending.update = mergeUpdatesV2([pending.update, restStructs.update]);
      }
    } else {
      store.pendingStructs = restStructs;
    }
    // console.log('time to integrate: ', performance.now() - start) // @todo remove
    // start = performance.now()
    const dsRest = readAndApplyDeleteSet(structDecoder, transaction, store);
    if (store.pendingDs) {
      // @todo we could make a lower-bound state-vector check as we do above
      const pendingDSUpdate = new UpdateDecoderV2(decoding__namespace.createDecoder(store.pendingDs));
      decoding__namespace.readVarUint(pendingDSUpdate.restDecoder); // read 0 structs, because we only encode deletes in pendingdsupdate
      const dsRest2 = readAndApplyDeleteSet(pendingDSUpdate, transaction, store);
      if (dsRest && dsRest2) {
        // case 1: ds1 != null && ds2 != null
        store.pendingDs = mergeUpdatesV2([dsRest, dsRest2]);
      } else {
        // case 2: ds1 != null
        // case 3: ds2 != null
        // case 4: ds1 == null && ds2 == null
        store.pendingDs = dsRest || dsRest2;
      }
    } else {
      // Either dsRest == null && pendingDs == null OR dsRest != null
      store.pendingDs = dsRest;
    }
    // console.log('time to cleanup: ', performance.now() - start) // @todo remove
    // start = performance.now()

    // console.log('time to resume delete readers: ', performance.now() - start) // @todo remove
    // start = performance.now()
    if (retry) {
      const update = /** @type {{update: Uint8Array}} */ (store.pendingStructs).update;
      store.pendingStructs = null;
      applyUpdateV2(transaction.doc, update);
    }
  }, transactionOrigin, false);

/**
 * Read and apply a document update.
 *
 * This function has the same effect as `applyUpdate` but accepts an decoder.
 *
 * @param {decoding.Decoder} decoder
 * @param {Doc} ydoc
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 *
 * @function
 */
const readUpdate = (decoder, ydoc, transactionOrigin) => readUpdateV2(decoder, ydoc, transactionOrigin, new UpdateDecoderV1(decoder));

/**
 * Apply a document update created by, for example, `y.on('update', update => ..)` or `update = encodeStateAsUpdate()`.
 *
 * This function has the same effect as `readUpdate` but accepts an Uint8Array instead of a Decoder.
 *
 * @param {Doc} ydoc
 * @param {Uint8Array} update
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 *
 * @function
 */
const applyUpdateV2 = (ydoc, update, transactionOrigin, YDecoder = UpdateDecoderV2) => {
  const decoder = decoding__namespace.createDecoder(update);
  readUpdateV2(decoder, ydoc, transactionOrigin, new YDecoder(decoder));
};

/**
 * Apply a document update created by, for example, `y.on('update', update => ..)` or `update = encodeStateAsUpdate()`.
 *
 * This function has the same effect as `readUpdate` but accepts an Uint8Array instead of a Decoder.
 *
 * @param {Doc} ydoc
 * @param {Uint8Array} update
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 *
 * @function
 */
const applyUpdate = (ydoc, update, transactionOrigin) => applyUpdateV2(ydoc, update, transactionOrigin, UpdateDecoderV1);

/**
 * Write all the document as a single update message. If you specify the state of the remote client (`targetStateVector`) it will
 * only write the operations that are missing.
 *
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Doc} doc
 * @param {Map<number,number>} [targetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 *
 * @function
 */
const writeStateAsUpdate = (encoder, doc, targetStateVector = new Map()) => {
  writeClientsStructs(encoder, doc.store, targetStateVector);
  writeDeleteSet(encoder, createDeleteSetFromStructStore(doc.store));
};

/**
 * Write all the document as a single update message that can be applied on the remote document. If you specify the state of the remote client (`targetState`) it will
 * only write the operations that are missing.
 *
 * Use `writeStateAsUpdate` instead if you are working with lib0/encoding.js#Encoder
 *
 * @param {Doc} doc
 * @param {Uint8Array} [encodedTargetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 * @param {UpdateEncoderV1 | UpdateEncoderV2} [encoder]
 * @return {Uint8Array}
 *
 * @function
 */
const encodeStateAsUpdateV2 = (doc, encodedTargetStateVector = new Uint8Array([0]), encoder = new UpdateEncoderV2()) => {
  const targetStateVector = decodeStateVector(encodedTargetStateVector);
  writeStateAsUpdate(encoder, doc, targetStateVector);
  const updates = [encoder.toUint8Array()];
  // also add the pending updates (if there are any)
  if (doc.store.pendingDs) {
    updates.push(doc.store.pendingDs);
  }
  if (doc.store.pendingStructs) {
    updates.push(diffUpdateV2(doc.store.pendingStructs.update, encodedTargetStateVector));
  }
  if (updates.length > 1) {
    if (encoder.constructor === UpdateEncoderV1) {
      return mergeUpdates(updates.map((update, i) => i === 0 ? update : convertUpdateFormatV2ToV1(update)))
    } else if (encoder.constructor === UpdateEncoderV2) {
      return mergeUpdatesV2(updates)
    }
  }
  return updates[0]
};

/**
 * Write all the document as a single update message that can be applied on the remote document. If you specify the state of the remote client (`targetState`) it will
 * only write the operations that are missing.
 *
 * Use `writeStateAsUpdate` instead if you are working with lib0/encoding.js#Encoder
 *
 * @param {Doc} doc
 * @param {Uint8Array} [encodedTargetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 * @return {Uint8Array}
 *
 * @function
 */
const encodeStateAsUpdate = (doc, encodedTargetStateVector) => encodeStateAsUpdateV2(doc, encodedTargetStateVector, new UpdateEncoderV1());

/**
 * Read state vector from Decoder and return as Map
 *
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */
const readStateVector = decoder => {
  const ss = new Map();
  const ssLength = decoding__namespace.readVarUint(decoder.restDecoder);
  for (let i = 0; i < ssLength; i++) {
    const client = decoding__namespace.readVarUint(decoder.restDecoder);
    const clock = decoding__namespace.readVarUint(decoder.restDecoder);
    ss.set(client, clock);
  }
  return ss
};

/**
 * Read decodedState and return State as Map.
 *
 * @param {Uint8Array} decodedState
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */
// export const decodeStateVectorV2 = decodedState => readStateVector(new DSDecoderV2(decoding.createDecoder(decodedState)))

/**
 * Read decodedState and return State as Map.
 *
 * @param {Uint8Array} decodedState
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */
const decodeStateVector = decodedState => readStateVector(new DSDecoderV1(decoding__namespace.createDecoder(decodedState)));

/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {Map<number,number>} sv
 * @function
 */
const writeStateVector = (encoder, sv) => {
  encoding__namespace.writeVarUint(encoder.restEncoder, sv.size);
  Array.from(sv.entries()).sort((a, b) => b[0] - a[0]).forEach(([client, clock]) => {
    encoding__namespace.writeVarUint(encoder.restEncoder, client); // @todo use a special client decoder that is based on mapping
    encoding__namespace.writeVarUint(encoder.restEncoder, clock);
  });
  return encoder
};

/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {Doc} doc
 *
 * @function
 */
const writeDocumentStateVector = (encoder, doc) => writeStateVector(encoder, getStateVector(doc.store));

/**
 * Encode State as Uint8Array.
 *
 * @param {Doc|Map<number,number>} doc
 * @param {DSEncoderV1 | DSEncoderV2} [encoder]
 * @return {Uint8Array}
 *
 * @function
 */
const encodeStateVectorV2 = (doc, encoder = new DSEncoderV2()) => {
  if (doc instanceof Map) {
    writeStateVector(encoder, doc);
  } else {
    writeDocumentStateVector(encoder, doc);
  }
  return encoder.toUint8Array()
};

/**
 * Encode State as Uint8Array.
 *
 * @param {Doc|Map<number,number>} doc
 * @return {Uint8Array}
 *
 * @function
 */
const encodeStateVector = doc => encodeStateVectorV2(doc, new DSEncoderV1());

/**
 * General event handler implementation.
 *
 * @template ARG0, ARG1
 *
 * @private
 */
class EventHandler {
  constructor () {
    /**
     * @type {Array<function(ARG0, ARG1):void>}
     */
    this.l = [];
  }
}

/**
 * @template ARG0,ARG1
 * @returns {EventHandler<ARG0,ARG1>}
 *
 * @private
 * @function
 */
const createEventHandler = () => new EventHandler();

/**
 * Adds an event listener that is called when
 * {@link EventHandler#callEventListeners} is called.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {function(ARG0,ARG1):void} f The event handler.
 *
 * @private
 * @function
 */
const addEventHandlerListener = (eventHandler, f) =>
  eventHandler.l.push(f);

/**
 * Removes an event listener.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {function(ARG0,ARG1):void} f The event handler that was added with
 *                     {@link EventHandler#addEventListener}
 *
 * @private
 * @function
 */
const removeEventHandlerListener = (eventHandler, f) => {
  const l = eventHandler.l;
  const len = l.length;
  eventHandler.l = l.filter(g => f !== g);
  if (len === eventHandler.l.length) {
    console.error('[yjs] Tried to remove event handler that doesn\'t exist.');
  }
};

/**
 * Call all event listeners that were added via
 * {@link EventHandler#addEventListener}.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {ARG0} arg0
 * @param {ARG1} arg1
 *
 * @private
 * @function
 */
const callEventHandlerListeners = (eventHandler, arg0, arg1) =>
  f__namespace.callAll(eventHandler.l, [arg0, arg1]);

class ID {
  /**
   * @param {number} client client id
   * @param {number} clock unique per client id, continuous number
   */
  constructor (client, clock) {
    /**
     * Client id
     * @type {number}
     */
    this.client = client;
    /**
     * unique per client id, continuous number
     * @type {number}
     */
    this.clock = clock;
  }
}

/**
 * @param {ID | null} a
 * @param {ID | null} b
 * @return {boolean}
 *
 * @function
 */
const compareIDs = (a, b) => a === b || (a !== null && b !== null && a.client === b.client && a.clock === b.clock);

/**
 * @param {number} client
 * @param {number} clock
 *
 * @private
 * @function
 */
const createID = (client, clock) => new ID(client, clock);

/**
 * @param {encoding.Encoder} encoder
 * @param {ID} id
 *
 * @private
 * @function
 */
const writeID = (encoder, id) => {
  encoding__namespace.writeVarUint(encoder, id.client);
  encoding__namespace.writeVarUint(encoder, id.clock);
};

/**
 * Read ID.
 * * If first varUint read is 0xFFFFFF a RootID is returned.
 * * Otherwise an ID is returned
 *
 * @param {decoding.Decoder} decoder
 * @return {ID}
 *
 * @private
 * @function
 */
const readID = decoder =>
  createID(decoding__namespace.readVarUint(decoder), decoding__namespace.readVarUint(decoder));

/**
 * The top types are mapped from y.share.get(keyname) => type.
 * `type` does not store any information about the `keyname`.
 * This function finds the correct `keyname` for `type` and throws otherwise.
 *
 * @param {AbstractType<any>} type
 * @return {string}
 *
 * @private
 * @function
 */
const findRootTypeKey = type => {
  // @ts-ignore _y must be defined, otherwise unexpected case
  for (const [key, value] of type.doc.share.entries()) {
    if (value === type) {
      return key
    }
  }
  throw error__namespace.unexpectedCase()
};

/**
 * Check if `parent` is a parent of `child`.
 *
 * @param {AbstractType<any>} parent
 * @param {Item|null} child
 * @return {Boolean} Whether `parent` is a parent of `child`.
 *
 * @private
 * @function
 */
const isParentOf = (parent, child) => {
  while (child !== null) {
    if (child.parent === parent) {
      return true
    }
    child = /** @type {AbstractType<any>} */ (child.parent)._item;
  }
  return false
};

/**
 * Convenient helper to log type information.
 *
 * Do not use in productive systems as the output can be immense!
 *
 * @param {AbstractType<any>} type
 */
const logType = type => {
  const res = [];
  let n = type._start;
  while (n) {
    res.push(n);
    n = n.right;
  }
  console.log('Children: ', res);
  console.log('Children content: ', res.filter(m => !m.deleted).map(m => m.content));
};

class PermanentUserData {
  /**
   * @param {Doc} doc
   * @param {YMap<any>} [storeType]
   */
  constructor (doc, storeType = doc.getMap('users')) {
    /**
     * @type {Map<string,DeleteSet>}
     */
    const dss = new Map();
    this.yusers = storeType;
    this.doc = doc;
    /**
     * Maps from clientid to userDescription
     *
     * @type {Map<number,string>}
     */
    this.clients = new Map();
    this.dss = dss;
    /**
     * @param {YMap<any>} user
     * @param {string} userDescription
     */
    const initUser = (user, userDescription) => {
      /**
       * @type {YArray<Uint8Array>}
       */
      const ds = user.get('ds');
      const ids = user.get('ids');
      const addClientId = /** @param {number} clientid */ clientid => this.clients.set(clientid, userDescription);
      ds.observe(/** @param {YArrayEvent<any>} event */ event => {
        event.changes.added.forEach(item => {
          item.content.getContent().forEach(encodedDs => {
            if (encodedDs instanceof Uint8Array) {
              this.dss.set(userDescription, mergeDeleteSets([this.dss.get(userDescription) || createDeleteSet(), readDeleteSet(new DSDecoderV1(decoding__namespace.createDecoder(encodedDs)))]));
            }
          });
        });
      });
      this.dss.set(userDescription, mergeDeleteSets(ds.map(encodedDs => readDeleteSet(new DSDecoderV1(decoding__namespace.createDecoder(encodedDs))))));
      ids.observe(/** @param {YArrayEvent<any>} event */ event =>
        event.changes.added.forEach(item => item.content.getContent().forEach(addClientId))
      );
      ids.forEach(addClientId);
    };
    // observe users
    storeType.observe(event => {
      event.keysChanged.forEach(userDescription =>
        initUser(storeType.get(userDescription), userDescription)
      );
    });
    // add intial data
    storeType.forEach(initUser);
  }

  /**
   * @param {Doc} doc
   * @param {number} clientid
   * @param {string} userDescription
   * @param {Object} [conf]
   * @param {function(Transaction, DeleteSet):boolean} [conf.filter]
   */
  setUserMapping (doc, clientid, userDescription, { filter = () => true } = {}) {
    const users = this.yusers;
    let user = users.get(userDescription);
    if (!user) {
      user = new YMap();
      user.set('ids', new YArray());
      user.set('ds', new YArray());
      users.set(userDescription, user);
    }
    user.get('ids').push([clientid]);
    users.observe(event => {
      setTimeout(() => {
        const userOverwrite = users.get(userDescription);
        if (userOverwrite !== user) {
          // user was overwritten, port all data over to the next user object
          // @todo Experiment with Y.Sets here
          user = userOverwrite;
          // @todo iterate over old type
          this.clients.forEach((_userDescription, clientid) => {
            if (userDescription === _userDescription) {
              user.get('ids').push([clientid]);
            }
          });
          const encoder = new DSEncoderV1();
          const ds = this.dss.get(userDescription);
          if (ds) {
            writeDeleteSet(encoder, ds);
            user.get('ds').push([encoder.toUint8Array()]);
          }
        }
      }, 0);
    });
    doc.on('afterTransaction', /** @param {Transaction} transaction */ transaction => {
      setTimeout(() => {
        const yds = user.get('ds');
        const ds = transaction.deleteSet;
        if (transaction.local && ds.clients.size > 0 && filter(transaction, ds)) {
          const encoder = new DSEncoderV1();
          writeDeleteSet(encoder, ds);
          yds.push([encoder.toUint8Array()]);
        }
      });
    });
  }

  /**
   * @param {number} clientid
   * @return {any}
   */
  getUserByClientId (clientid) {
    return this.clients.get(clientid) || null
  }

  /**
   * @param {ID} id
   * @return {string | null}
   */
  getUserByDeletedId (id) {
    for (const [userDescription, ds] of this.dss.entries()) {
      if (isDeleted(ds, id)) {
        return userDescription
      }
    }
    return null
  }
}

/**
 * A relative position is based on the Yjs model and is not affected by document changes.
 * E.g. If you place a relative position before a certain character, it will always point to this character.
 * If you place a relative position at the end of a type, it will always point to the end of the type.
 *
 * A numeric position is often unsuited for user selections, because it does not change when content is inserted
 * before or after.
 *
 * ```Insert(0, 'x')('a|bc') = 'xa|bc'``` Where | is the relative position.
 *
 * One of the properties must be defined.
 *
 * @example
 *   // Current cursor position is at position 10
 *   const relativePosition = createRelativePositionFromIndex(yText, 10)
 *   // modify yText
 *   yText.insert(0, 'abc')
 *   yText.delete(3, 10)
 *   // Compute the cursor position
 *   const absolutePosition = createAbsolutePositionFromRelativePosition(y, relativePosition)
 *   absolutePosition.type === yText // => true
 *   console.log('cursor location is ' + absolutePosition.index) // => cursor location is 3
 *
 */
class RelativePosition {
  /**
   * @param {ID|null} type
   * @param {string|null} tname
   * @param {ID|null} item
   * @param {number} assoc
   */
  constructor (type, tname, item, assoc = 0) {
    /**
     * @type {ID|null}
     */
    this.type = type;
    /**
     * @type {string|null}
     */
    this.tname = tname;
    /**
     * @type {ID | null}
     */
    this.item = item;
    /**
     * A relative position is associated to a specific character. By default
     * assoc >= 0, the relative position is associated to the character
     * after the meant position.
     * I.e. position 1 in 'ab' is associated to character 'b'.
     *
     * If assoc < 0, then the relative position is associated to the caharacter
     * before the meant position.
     *
     * @type {number}
     */
    this.assoc = assoc;
  }
}

/**
 * @param {RelativePosition} rpos
 * @return {any}
 */
const relativePositionToJSON = rpos => {
  const json = {};
  if (rpos.type) {
    json.type = rpos.type;
  }
  if (rpos.tname) {
    json.tname = rpos.tname;
  }
  if (rpos.item) {
    json.item = rpos.item;
  }
  if (rpos.assoc != null) {
    json.assoc = rpos.assoc;
  }
  return json
};

/**
 * @param {any} json
 * @return {RelativePosition}
 *
 * @function
 */
const createRelativePositionFromJSON = json => new RelativePosition(json.type == null ? null : createID(json.type.client, json.type.clock), json.tname || null, json.item == null ? null : createID(json.item.client, json.item.clock), json.assoc == null ? 0 : json.assoc);

class AbsolutePosition {
  /**
   * @param {AbstractType<any>} type
   * @param {number} index
   * @param {number} [assoc]
   */
  constructor (type, index, assoc = 0) {
    /**
     * @type {AbstractType<any>}
     */
    this.type = type;
    /**
     * @type {number}
     */
    this.index = index;
    this.assoc = assoc;
  }
}

/**
 * @param {AbstractType<any>} type
 * @param {number} index
 * @param {number} [assoc]
 *
 * @function
 */
const createAbsolutePosition = (type, index, assoc = 0) => new AbsolutePosition(type, index, assoc);

/**
 * @param {AbstractType<any>} type
 * @param {ID|null} item
 * @param {number} [assoc]
 *
 * @function
 */
const createRelativePosition = (type, item, assoc) => {
  let typeid = null;
  let tname = null;
  if (type._item === null) {
    tname = findRootTypeKey(type);
  } else {
    typeid = createID(type._item.id.client, type._item.id.clock);
  }
  return new RelativePosition(typeid, tname, item, assoc)
};

/**
 * Create a relativePosition based on a absolute position.
 *
 * @param {AbstractType<any>} type The base type (e.g. YText or YArray).
 * @param {number} index The absolute position.
 * @param {number} [assoc]
 * @return {RelativePosition}
 *
 * @function
 */
const createRelativePositionFromTypeIndex = (type, index, assoc = 0) => {
  let t = type._start;
  if (assoc < 0) {
    // associated to the left character or the beginning of a type, increment index if possible.
    if (index === 0) {
      return createRelativePosition(type, null, assoc)
    }
    index--;
  }
  while (t !== null) {
    if (!t.deleted && t.countable) {
      if (t.length > index) {
        // case 1: found position somewhere in the linked list
        return createRelativePosition(type, createID(t.id.client, t.id.clock + index), assoc)
      }
      index -= t.length;
    }
    if (t.right === null && assoc < 0) {
      // left-associated position, return last available id
      return createRelativePosition(type, t.lastId, assoc)
    }
    t = t.right;
  }
  return createRelativePosition(type, null, assoc)
};

/**
 * @param {encoding.Encoder} encoder
 * @param {RelativePosition} rpos
 *
 * @function
 */
const writeRelativePosition = (encoder, rpos) => {
  const { type, tname, item, assoc } = rpos;
  if (item !== null) {
    encoding__namespace.writeVarUint(encoder, 0);
    writeID(encoder, item);
  } else if (tname !== null) {
    // case 2: found position at the end of the list and type is stored in y.share
    encoding__namespace.writeUint8(encoder, 1);
    encoding__namespace.writeVarString(encoder, tname);
  } else if (type !== null) {
    // case 3: found position at the end of the list and type is attached to an item
    encoding__namespace.writeUint8(encoder, 2);
    writeID(encoder, type);
  } else {
    throw error__namespace.unexpectedCase()
  }
  encoding__namespace.writeVarInt(encoder, assoc);
  return encoder
};

/**
 * @param {RelativePosition} rpos
 * @return {Uint8Array}
 */
const encodeRelativePosition = rpos => {
  const encoder = encoding__namespace.createEncoder();
  writeRelativePosition(encoder, rpos);
  return encoding__namespace.toUint8Array(encoder)
};

/**
 * @param {decoding.Decoder} decoder
 * @return {RelativePosition}
 *
 * @function
 */
const readRelativePosition = decoder => {
  let type = null;
  let tname = null;
  let itemID = null;
  switch (decoding__namespace.readVarUint(decoder)) {
    case 0:
      // case 1: found position somewhere in the linked list
      itemID = readID(decoder);
      break
    case 1:
      // case 2: found position at the end of the list and type is stored in y.share
      tname = decoding__namespace.readVarString(decoder);
      break
    case 2: {
      // case 3: found position at the end of the list and type is attached to an item
      type = readID(decoder);
    }
  }
  const assoc = decoding__namespace.hasContent(decoder) ? decoding__namespace.readVarInt(decoder) : 0;
  return new RelativePosition(type, tname, itemID, assoc)
};

/**
 * @param {Uint8Array} uint8Array
 * @return {RelativePosition}
 */
const decodeRelativePosition = uint8Array => readRelativePosition(decoding__namespace.createDecoder(uint8Array));

/**
 * @param {RelativePosition} rpos
 * @param {Doc} doc
 * @return {AbsolutePosition|null}
 *
 * @function
 */
const createAbsolutePositionFromRelativePosition = (rpos, doc) => {
  const store = doc.store;
  const rightID = rpos.item;
  const typeID = rpos.type;
  const tname = rpos.tname;
  const assoc = rpos.assoc;
  let type = null;
  let index = 0;
  if (rightID !== null) {
    if (getState(store, rightID.client) <= rightID.clock) {
      return null
    }
    const res = followRedone(store, rightID);
    const right = res.item;
    if (!(right instanceof Item)) {
      return null
    }
    type = /** @type {AbstractType<any>} */ (right.parent);
    if (type._item === null || !type._item.deleted) {
      index = (right.deleted || !right.countable) ? 0 : (res.diff + (assoc >= 0 ? 0 : 1)); // adjust position based on left association if necessary
      let n = right.left;
      while (n !== null) {
        if (!n.deleted && n.countable) {
          index += n.length;
        }
        n = n.left;
      }
    }
  } else {
    if (tname !== null) {
      type = doc.get(tname);
    } else if (typeID !== null) {
      if (getState(store, typeID.client) <= typeID.clock) {
        // type does not exist yet
        return null
      }
      const { item } = followRedone(store, typeID);
      if (item instanceof Item && item.content instanceof ContentType) {
        type = item.content.type;
      } else {
        // struct is garbage collected
        return null
      }
    } else {
      throw error__namespace.unexpectedCase()
    }
    if (assoc >= 0) {
      index = type._length;
    } else {
      index = 0;
    }
  }
  return createAbsolutePosition(type, index, rpos.assoc)
};

/**
 * @param {RelativePosition|null} a
 * @param {RelativePosition|null} b
 * @return {boolean}
 *
 * @function
 */
const compareRelativePositions = (a, b) => a === b || (
  a !== null && b !== null && a.tname === b.tname && compareIDs(a.item, b.item) && compareIDs(a.type, b.type) && a.assoc === b.assoc
);

class Snapshot {
  /**
   * @param {DeleteSet} ds
   * @param {Map<number,number>} sv state map
   */
  constructor (ds, sv) {
    /**
     * @type {DeleteSet}
     */
    this.ds = ds;
    /**
     * State Map
     * @type {Map<number,number>}
     */
    this.sv = sv;
  }
}

/**
 * @param {Snapshot} snap1
 * @param {Snapshot} snap2
 * @return {boolean}
 */
const equalSnapshots = (snap1, snap2) => {
  const ds1 = snap1.ds.clients;
  const ds2 = snap2.ds.clients;
  const sv1 = snap1.sv;
  const sv2 = snap2.sv;
  if (sv1.size !== sv2.size || ds1.size !== ds2.size) {
    return false
  }
  for (const [key, value] of sv1.entries()) {
    if (sv2.get(key) !== value) {
      return false
    }
  }
  for (const [client, dsitems1] of ds1.entries()) {
    const dsitems2 = ds2.get(client) || [];
    if (dsitems1.length !== dsitems2.length) {
      return false
    }
    for (let i = 0; i < dsitems1.length; i++) {
      const dsitem1 = dsitems1[i];
      const dsitem2 = dsitems2[i];
      if (dsitem1.clock !== dsitem2.clock || dsitem1.len !== dsitem2.len) {
        return false
      }
    }
  }
  return true
};

/**
 * @param {Snapshot} snapshot
 * @param {DSEncoderV1 | DSEncoderV2} [encoder]
 * @return {Uint8Array}
 */
const encodeSnapshotV2 = (snapshot, encoder = new DSEncoderV2()) => {
  writeDeleteSet(encoder, snapshot.ds);
  writeStateVector(encoder, snapshot.sv);
  return encoder.toUint8Array()
};

/**
 * @param {Snapshot} snapshot
 * @return {Uint8Array}
 */
const encodeSnapshot = snapshot => encodeSnapshotV2(snapshot, new DSEncoderV1());

/**
 * @param {Uint8Array} buf
 * @param {DSDecoderV1 | DSDecoderV2} [decoder]
 * @return {Snapshot}
 */
const decodeSnapshotV2 = (buf, decoder = new DSDecoderV2(decoding__namespace.createDecoder(buf))) => {
  return new Snapshot(readDeleteSet(decoder), readStateVector(decoder))
};

/**
 * @param {Uint8Array} buf
 * @return {Snapshot}
 */
const decodeSnapshot = buf => decodeSnapshotV2(buf, new DSDecoderV1(decoding__namespace.createDecoder(buf)));

/**
 * @param {DeleteSet} ds
 * @param {Map<number,number>} sm
 * @return {Snapshot}
 */
const createSnapshot = (ds, sm) => new Snapshot(ds, sm);

const emptySnapshot = createSnapshot(createDeleteSet(), new Map());

/**
 * @param {Doc} doc
 * @return {Snapshot}
 */
const snapshot = doc => createSnapshot(createDeleteSetFromStructStore(doc.store), getStateVector(doc.store));

/**
 * @param {Item} item
 * @param {Snapshot|undefined} snapshot
 *
 * @protected
 * @function
 */
const isVisible = (item, snapshot) => snapshot === undefined
  ? !item.deleted
  : snapshot.sv.has(item.id.client) && (snapshot.sv.get(item.id.client) || 0) > item.id.clock && !isDeleted(snapshot.ds, item.id);

/**
 * @param {Transaction} transaction
 * @param {Snapshot} snapshot
 */
const splitSnapshotAffectedStructs = (transaction, snapshot) => {
  const meta = map__namespace.setIfUndefined(transaction.meta, splitSnapshotAffectedStructs, set__namespace.create);
  const store = transaction.doc.store;
  // check if we already split for this snapshot
  if (!meta.has(snapshot)) {
    snapshot.sv.forEach((clock, client) => {
      if (clock < getState(store, client)) {
        getItemCleanStart(transaction, createID(client, clock));
      }
    });
    iterateDeletedStructs(transaction, snapshot.ds, item => {});
    meta.add(snapshot);
  }
};

/**
 * @param {Doc} originDoc
 * @param {Snapshot} snapshot
 * @param {Doc} [newDoc] Optionally, you may define the Yjs document that receives the data from originDoc
 * @return {Doc}
 */
const createDocFromSnapshot = (originDoc, snapshot, newDoc = new Doc()) => {
  if (originDoc.gc) {
    // we should not try to restore a GC-ed document, because some of the restored items might have their content deleted
    throw new Error('originDoc must not be garbage collected')
  }
  const { sv, ds } = snapshot;

  const encoder = new UpdateEncoderV2();
  originDoc.transact(transaction => {
    let size = 0;
    sv.forEach(clock => {
      if (clock > 0) {
        size++;
      }
    });
    encoding__namespace.writeVarUint(encoder.restEncoder, size);
    // splitting the structs before writing them to the encoder
    for (const [client, clock] of sv) {
      if (clock === 0) {
        continue
      }
      if (clock < getState(originDoc.store, client)) {
        getItemCleanStart(transaction, createID(client, clock));
      }
      const structs = originDoc.store.clients.get(client) || [];
      const lastStructIndex = findIndexSS(structs, clock - 1);
      // write # encoded structs
      encoding__namespace.writeVarUint(encoder.restEncoder, lastStructIndex + 1);
      encoder.writeClient(client);
      // first clock written is 0
      encoding__namespace.writeVarUint(encoder.restEncoder, 0);
      for (let i = 0; i <= lastStructIndex; i++) {
        structs[i].write(encoder, 0);
      }
    }
    writeDeleteSet(encoder, ds);
  });

  applyUpdateV2(newDoc, encoder.toUint8Array(), 'snapshot');
  return newDoc
};

class StructStore {
  constructor () {
    /**
     * @type {Map<number,Array<GC|Item>>}
     */
    this.clients = new Map();
    /**
     * @type {null | { missing: Map<number, number>, update: Uint8Array }}
     */
    this.pendingStructs = null;
    /**
     * @type {null | Uint8Array}
     */
    this.pendingDs = null;
  }
}

/**
 * Return the states as a Map<client,clock>.
 * Note that clock refers to the next expected clock id.
 *
 * @param {StructStore} store
 * @return {Map<number,number>}
 *
 * @public
 * @function
 */
const getStateVector = store => {
  const sm = new Map();
  store.clients.forEach((structs, client) => {
    const struct = structs[structs.length - 1];
    sm.set(client, struct.id.clock + struct.length);
  });
  return sm
};

/**
 * @param {StructStore} store
 * @param {number} client
 * @return {number}
 *
 * @public
 * @function
 */
const getState = (store, client) => {
  const structs = store.clients.get(client);
  if (structs === undefined) {
    return 0
  }
  const lastStruct = structs[structs.length - 1];
  return lastStruct.id.clock + lastStruct.length
};

/**
 * @param {StructStore} store
 * @param {GC|Item} struct
 *
 * @private
 * @function
 */
const addStruct = (store, struct) => {
  let structs = store.clients.get(struct.id.client);
  if (structs === undefined) {
    structs = [];
    store.clients.set(struct.id.client, structs);
  } else {
    const lastStruct = structs[structs.length - 1];
    if (lastStruct.id.clock + lastStruct.length !== struct.id.clock) {
      throw error__namespace.unexpectedCase()
    }
  }
  structs.push(struct);
};

/**
 * Perform a binary search on a sorted array
 * @param {Array<Item|GC>} structs
 * @param {number} clock
 * @return {number}
 *
 * @private
 * @function
 */
const findIndexSS = (structs, clock) => {
  let left = 0;
  let right = structs.length - 1;
  let mid = structs[right];
  let midclock = mid.id.clock;
  if (midclock === clock) {
    return right
  }
  // @todo does it even make sense to pivot the search?
  // If a good split misses, it might actually increase the time to find the correct item.
  // Currently, the only advantage is that search with pivoting might find the item on the first try.
  let midindex = math__namespace.floor((clock / (midclock + mid.length - 1)) * right); // pivoting the search
  while (left <= right) {
    mid = structs[midindex];
    midclock = mid.id.clock;
    if (midclock <= clock) {
      if (clock < midclock + mid.length) {
        return midindex
      }
      left = midindex + 1;
    } else {
      right = midindex - 1;
    }
    midindex = math__namespace.floor((left + right) / 2);
  }
  // Always check state before looking for a struct in StructStore
  // Therefore the case of not finding a struct is unexpected
  throw error__namespace.unexpectedCase()
};

/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {StructStore} store
 * @param {ID} id
 * @return {GC|Item}
 *
 * @private
 * @function
 */
const find = (store, id) => {
  /**
   * @type {Array<GC|Item>}
   */
  // @ts-ignore
  const structs = store.clients.get(id.client);
  return structs[findIndexSS(structs, id.clock)]
};

/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 * @private
 * @function
 */
const getItem = /** @type {function(StructStore,ID):Item} */ (find);

/**
 * @param {Transaction} transaction
 * @param {Array<Item|GC>} structs
 * @param {number} clock
 */
const findIndexCleanStart = (transaction, structs, clock) => {
  const index = findIndexSS(structs, clock);
  const struct = structs[index];
  if (struct.id.clock < clock && struct instanceof Item) {
    structs.splice(index + 1, 0, splitItem(transaction, struct, clock - struct.id.clock));
    return index + 1
  }
  return index
};

/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {Transaction} transaction
 * @param {ID} id
 * @return {Item}
 *
 * @private
 * @function
 */
const getItemCleanStart = (transaction, id) => {
  const structs = /** @type {Array<Item>} */ (transaction.doc.store.clients.get(id.client));
  return structs[findIndexCleanStart(transaction, structs, id.clock)]
};

/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @param {ID} id
 * @return {Item}
 *
 * @private
 * @function
 */
const getItemCleanEnd = (transaction, store, id) => {
  /**
   * @type {Array<Item>}
   */
  // @ts-ignore
  const structs = store.clients.get(id.client);
  const index = findIndexSS(structs, id.clock);
  const struct = structs[index];
  if (id.clock !== struct.id.clock + struct.length - 1 && struct.constructor !== GC) {
    structs.splice(index + 1, 0, splitItem(transaction, struct, id.clock - struct.id.clock + 1));
  }
  return struct
};

/**
 * Replace `item` with `newitem` in store
 * @param {StructStore} store
 * @param {GC|Item} struct
 * @param {GC|Item} newStruct
 *
 * @private
 * @function
 */
const replaceStruct = (store, struct, newStruct) => {
  const structs = /** @type {Array<GC|Item>} */ (store.clients.get(struct.id.client));
  structs[findIndexSS(structs, struct.id.clock)] = newStruct;
};

/**
 * Iterate over a range of structs
 *
 * @param {Transaction} transaction
 * @param {Array<Item|GC>} structs
 * @param {number} clockStart Inclusive start
 * @param {number} len
 * @param {function(GC|Item):void} f
 *
 * @function
 */
const iterateStructs = (transaction, structs, clockStart, len, f) => {
  if (len === 0) {
    return
  }
  const clockEnd = clockStart + len;
  let index = findIndexCleanStart(transaction, structs, clockStart);
  let struct;
  do {
    struct = structs[index++];
    if (clockEnd < struct.id.clock + struct.length) {
      findIndexCleanStart(transaction, structs, clockEnd);
    }
    f(struct);
  } while (index < structs.length && structs[index].id.clock < clockEnd)
};

/**
 * A transaction is created for every change on the Yjs model. It is possible
 * to bundle changes on the Yjs model in a single transaction to
 * minimize the number on messages sent and the number of observer calls.
 * If possible the user of this library should bundle as many changes as
 * possible. Here is an example to illustrate the advantages of bundling:
 *
 * @example
 * const map = y.define('map', YMap)
 * // Log content when change is triggered
 * map.observe(() => {
 *   console.log('change triggered')
 * })
 * // Each change on the map type triggers a log message:
 * map.set('a', 0) // => "change triggered"
 * map.set('b', 0) // => "change triggered"
 * // When put in a transaction, it will trigger the log after the transaction:
 * y.transact(() => {
 *   map.set('a', 1)
 *   map.set('b', 1)
 * }) // => "change triggered"
 *
 * @public
 */
class Transaction {
  /**
   * @param {Doc} doc
   * @param {any} origin
   * @param {boolean} local
   */
  constructor (doc, origin, local) {
    /**
     * The Yjs instance.
     * @type {Doc}
     */
    this.doc = doc;
    /**
     * Describes the set of deleted items by ids
     * @type {DeleteSet}
     */
    this.deleteSet = new DeleteSet();
    /**
     * Holds the state before the transaction started.
     * @type {Map<Number,Number>}
     */
    this.beforeState = getStateVector(doc.store);
    /**
     * Holds the state after the transaction.
     * @type {Map<Number,Number>}
     */
    this.afterState = new Map();
    /**
     * All types that were directly modified (property added or child
     * inserted/deleted). New types are not included in this Set.
     * Maps from type to parentSubs (`item.parentSub = null` for YArray)
     * @type {Map<AbstractType<YEvent<any>>,Set<String|null>>}
     */
    this.changed = new Map();
    /**
     * Stores the events for the types that observe also child elements.
     * It is mainly used by `observeDeep`.
     * @type {Map<AbstractType<YEvent<any>>,Array<YEvent<any>>>}
     */
    this.changedParentTypes = new Map();
    /**
     * @type {Array<AbstractStruct>}
     */
    this._mergeStructs = [];
    /**
     * @type {any}
     */
    this.origin = origin;
    /**
     * Stores meta information on the transaction
     * @type {Map<any,any>}
     */
    this.meta = new Map();
    /**
     * Whether this change originates from this doc.
     * @type {boolean}
     */
    this.local = local;
    /**
     * @type {Set<Doc>}
     */
    this.subdocsAdded = new Set();
    /**
     * @type {Set<Doc>}
     */
    this.subdocsRemoved = new Set();
    /**
     * @type {Set<Doc>}
     */
    this.subdocsLoaded = new Set();
  }
}

/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Transaction} transaction
 * @return {boolean} Whether data was written.
 */
const writeUpdateMessageFromTransaction = (encoder, transaction) => {
  if (transaction.deleteSet.clients.size === 0 && !map__namespace.any(transaction.afterState, (clock, client) => transaction.beforeState.get(client) !== clock)) {
    return false
  }
  sortAndMergeDeleteSet(transaction.deleteSet);
  writeStructsFromTransaction(encoder, transaction);
  writeDeleteSet(encoder, transaction.deleteSet);
  return true
};

/**
 * If `type.parent` was added in current transaction, `type` technically
 * did not change, it was just added and we should not fire events for `type`.
 *
 * @param {Transaction} transaction
 * @param {AbstractType<YEvent<any>>} type
 * @param {string|null} parentSub
 */
const addChangedTypeToTransaction = (transaction, type, parentSub) => {
  const item = type._item;
  if (item === null || (item.id.clock < (transaction.beforeState.get(item.id.client) || 0) && !item.deleted)) {
    map__namespace.setIfUndefined(transaction.changed, type, set__namespace.create).add(parentSub);
  }
};

/**
 * @param {Array<AbstractStruct>} structs
 * @param {number} pos
 */
const tryToMergeWithLeft = (structs, pos) => {
  const left = structs[pos - 1];
  const right = structs[pos];
  if (left.deleted === right.deleted && left.constructor === right.constructor) {
    if (left.mergeWith(right)) {
      structs.splice(pos, 1);
      if (right instanceof Item && right.parentSub !== null && /** @type {AbstractType<any>} */ (right.parent)._map.get(right.parentSub) === right) {
        /** @type {AbstractType<any>} */ (right.parent)._map.set(right.parentSub, /** @type {Item} */ (left));
      }
    }
  }
};

/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 * @param {function(Item):boolean} gcFilter
 */
const tryGcDeleteSet = (ds, store, gcFilter) => {
  for (const [client, deleteItems] of ds.clients.entries()) {
    const structs = /** @type {Array<GC|Item>} */ (store.clients.get(client));
    for (let di = deleteItems.length - 1; di >= 0; di--) {
      const deleteItem = deleteItems[di];
      const endDeleteItemClock = deleteItem.clock + deleteItem.len;
      for (
        let si = findIndexSS(structs, deleteItem.clock), struct = structs[si];
        si < structs.length && struct.id.clock < endDeleteItemClock;
        struct = structs[++si]
      ) {
        const struct = structs[si];
        if (deleteItem.clock + deleteItem.len <= struct.id.clock) {
          break
        }
        if (struct instanceof Item && struct.deleted && !struct.keep && gcFilter(struct)) {
          struct.gc(store, false);
        }
      }
    }
  }
};

/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 */
const tryMergeDeleteSet = (ds, store) => {
  // try to merge deleted / gc'd items
  // merge from right to left for better efficiecy and so we don't miss any merge targets
  ds.clients.forEach((deleteItems, client) => {
    const structs = /** @type {Array<GC|Item>} */ (store.clients.get(client));
    for (let di = deleteItems.length - 1; di >= 0; di--) {
      const deleteItem = deleteItems[di];
      // start with merging the item next to the last deleted item
      const mostRightIndexToCheck = math__namespace.min(structs.length - 1, 1 + findIndexSS(structs, deleteItem.clock + deleteItem.len - 1));
      for (
        let si = mostRightIndexToCheck, struct = structs[si];
        si > 0 && struct.id.clock >= deleteItem.clock;
        struct = structs[--si]
      ) {
        tryToMergeWithLeft(structs, si);
      }
    }
  });
};

/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 * @param {function(Item):boolean} gcFilter
 */
const tryGc = (ds, store, gcFilter) => {
  tryGcDeleteSet(ds, store, gcFilter);
  tryMergeDeleteSet(ds, store);
};

/**
 * @param {Array<Transaction>} transactionCleanups
 * @param {number} i
 */
const cleanupTransactions = (transactionCleanups, i) => {
  if (i < transactionCleanups.length) {
    const transaction = transactionCleanups[i];
    const doc = transaction.doc;
    const store = doc.store;
    const ds = transaction.deleteSet;
    const mergeStructs = transaction._mergeStructs;
    try {
      sortAndMergeDeleteSet(ds);
      transaction.afterState = getStateVector(transaction.doc.store);
      doc._transaction = null;
      doc.emit('beforeObserverCalls', [transaction, doc]);
      /**
       * An array of event callbacks.
       *
       * Each callback is called even if the other ones throw errors.
       *
       * @type {Array<function():void>}
       */
      const fs = [];
      // observe events on changed types
      transaction.changed.forEach((subs, itemtype) =>
        fs.push(() => {
          if (itemtype._item === null || !itemtype._item.deleted) {
            itemtype._callObserver(transaction, subs);
          }
        })
      );
      fs.push(() => {
        // deep observe events
        transaction.changedParentTypes.forEach((events, type) =>
          fs.push(() => {
            // We need to think about the possibility that the user transforms the
            // Y.Doc in the event.
            if (type._item === null || !type._item.deleted) {
              events = events
                .filter(event =>
                  event.target._item === null || !event.target._item.deleted
                );
              events
                .forEach(event => {
                  event.currentTarget = type;
                });
              // sort events by path length so that top-level events are fired first.
              events
                .sort((event1, event2) => event1.path.length - event2.path.length);
              // We don't need to check for events.length
              // because we know it has at least one element
              callEventHandlerListeners(type._dEH, events, transaction);
            }
          })
        );
        fs.push(() => doc.emit('afterTransaction', [transaction, doc]));
      });
      f.callAll(fs, []);
    } finally {
      // Replace deleted items with ItemDeleted / GC.
      // This is where content is actually remove from the Yjs Doc.
      if (doc.gc) {
        tryGcDeleteSet(ds, store, doc.gcFilter);
      }
      tryMergeDeleteSet(ds, store);

      // on all affected store.clients props, try to merge
      transaction.afterState.forEach((clock, client) => {
        const beforeClock = transaction.beforeState.get(client) || 0;
        if (beforeClock !== clock) {
          const structs = /** @type {Array<GC|Item>} */ (store.clients.get(client));
          // we iterate from right to left so we can safely remove entries
          const firstChangePos = math__namespace.max(findIndexSS(structs, beforeClock), 1);
          for (let i = structs.length - 1; i >= firstChangePos; i--) {
            tryToMergeWithLeft(structs, i);
          }
        }
      });
      // try to merge mergeStructs
      // @todo: it makes more sense to transform mergeStructs to a DS, sort it, and merge from right to left
      //        but at the moment DS does not handle duplicates
      for (let i = 0; i < mergeStructs.length; i++) {
        const { client, clock } = mergeStructs[i].id;
        const structs = /** @type {Array<GC|Item>} */ (store.clients.get(client));
        const replacedStructPos = findIndexSS(structs, clock);
        if (replacedStructPos + 1 < structs.length) {
          tryToMergeWithLeft(structs, replacedStructPos + 1);
        }
        if (replacedStructPos > 0) {
          tryToMergeWithLeft(structs, replacedStructPos);
        }
      }
      if (!transaction.local && transaction.afterState.get(doc.clientID) !== transaction.beforeState.get(doc.clientID)) {
        logging__namespace.print(logging__namespace.ORANGE, logging__namespace.BOLD, '[yjs] ', logging__namespace.UNBOLD, logging__namespace.RED, 'Changed the client-id because another client seems to be using it.');
        doc.clientID = generateNewClientId();
      }
      // @todo Merge all the transactions into one and provide send the data as a single update message
      doc.emit('afterTransactionCleanup', [transaction, doc]);
      if (doc._observers.has('update')) {
        const encoder = new UpdateEncoderV1();
        const hasContent = writeUpdateMessageFromTransaction(encoder, transaction);
        if (hasContent) {
          doc.emit('update', [encoder.toUint8Array(), transaction.origin, doc, transaction]);
        }
      }
      if (doc._observers.has('updateV2')) {
        const encoder = new UpdateEncoderV2();
        const hasContent = writeUpdateMessageFromTransaction(encoder, transaction);
        if (hasContent) {
          doc.emit('updateV2', [encoder.toUint8Array(), transaction.origin, doc, transaction]);
        }
      }
      const { subdocsAdded, subdocsLoaded, subdocsRemoved } = transaction;
      if (subdocsAdded.size > 0 || subdocsRemoved.size > 0 || subdocsLoaded.size > 0) {
        subdocsAdded.forEach(subdoc => {
          subdoc.clientID = doc.clientID;
          if (subdoc.collectionid == null) {
            subdoc.collectionid = doc.collectionid;
          }
          doc.subdocs.add(subdoc);
        });
        subdocsRemoved.forEach(subdoc => doc.subdocs.delete(subdoc));
        doc.emit('subdocs', [{ loaded: subdocsLoaded, added: subdocsAdded, removed: subdocsRemoved }, doc, transaction]);
        subdocsRemoved.forEach(subdoc => subdoc.destroy());
      }

      if (transactionCleanups.length <= i + 1) {
        doc._transactionCleanups = [];
        doc.emit('afterAllTransactions', [doc, transactionCleanups]);
      } else {
        cleanupTransactions(transactionCleanups, i + 1);
      }
    }
  }
};

/**
 * Implements the functionality of `y.transact(()=>{..})`
 *
 * @param {Doc} doc
 * @param {function(Transaction):void} f
 * @param {any} [origin=true]
 *
 * @function
 */
const transact = (doc, f, origin = null, local = true) => {
  const transactionCleanups = doc._transactionCleanups;
  let initialCall = false;
  if (doc._transaction === null) {
    initialCall = true;
    doc._transaction = new Transaction(doc, origin, local);
    transactionCleanups.push(doc._transaction);
    if (transactionCleanups.length === 1) {
      doc.emit('beforeAllTransactions', [doc]);
    }
    doc.emit('beforeTransaction', [doc._transaction, doc]);
  }
  try {
    f(doc._transaction);
  } finally {
    if (initialCall && transactionCleanups[0] === doc._transaction) {
      // The first transaction ended, now process observer calls.
      // Observer call may create new transactions for which we need to call the observers and do cleanup.
      // We don't want to nest these calls, so we execute these calls one after
      // another.
      // Also we need to ensure that all cleanups are called, even if the
      // observes throw errors.
      // This file is full of hacky try {} finally {} blocks to ensure that an
      // event can throw errors and also that the cleanup is called.
      cleanupTransactions(transactionCleanups, 0);
    }
  }
};

class StackItem {
  /**
   * @param {DeleteSet} deletions
   * @param {DeleteSet} insertions
   */
  constructor (deletions, insertions) {
    this.insertions = insertions;
    this.deletions = deletions;
    /**
     * Use this to save and restore metadata like selection range
     */
    this.meta = new Map();
  }
}
/**
 * @param {Transaction} tr
 * @param {UndoManager} um
 * @param {StackItem} stackItem
 */
const clearUndoManagerStackItem = (tr, um, stackItem) => {
  iterateDeletedStructs(tr, stackItem.deletions, item => {
    if (item instanceof Item && um.scope.some(type => isParentOf(type, item))) {
      keepItem(item, false);
    }
  });
};

/**
 * @param {UndoManager} undoManager
 * @param {Array<StackItem>} stack
 * @param {string} eventType
 * @return {StackItem?}
 */
const popStackItem = (undoManager, stack, eventType) => {
  /**
   * Whether a change happened
   * @type {StackItem?}
   */
  let result = null;
  /**
   * Keep a reference to the transaction so we can fire the event with the changedParentTypes
   * @type {any}
   */
  let _tr = null;
  const doc = undoManager.doc;
  const scope = undoManager.scope;
  transact(doc, transaction => {
    while (stack.length > 0 && result === null) {
      const store = doc.store;
      const stackItem = /** @type {StackItem} */ (stack.pop());
      /**
       * @type {Set<Item>}
       */
      const itemsToRedo = new Set();
      /**
       * @type {Array<Item>}
       */
      const itemsToDelete = [];
      let performedChange = false;
      iterateDeletedStructs(transaction, stackItem.insertions, struct => {
        if (struct instanceof Item) {
          if (struct.redone !== null) {
            let { item, diff } = followRedone(store, struct.id);
            if (diff > 0) {
              item = getItemCleanStart(transaction, createID(item.id.client, item.id.clock + diff));
            }
            struct = item;
          }
          if (!struct.deleted && scope.some(type => isParentOf(type, /** @type {Item} */ (struct)))) {
            itemsToDelete.push(struct);
          }
        }
      });
      iterateDeletedStructs(transaction, stackItem.deletions, struct => {
        if (
          struct instanceof Item &&
          scope.some(type => isParentOf(type, struct)) &&
          // Never redo structs in stackItem.insertions because they were created and deleted in the same capture interval.
          !isDeleted(stackItem.insertions, struct.id)
        ) {
          itemsToRedo.add(struct);
        }
      });
      itemsToRedo.forEach(struct => {
        performedChange = redoItem(transaction, struct, itemsToRedo, stackItem.insertions, undoManager.ignoreRemoteMapChanges) !== null || performedChange;
      });
      // We want to delete in reverse order so that children are deleted before
      // parents, so we have more information available when items are filtered.
      for (let i = itemsToDelete.length - 1; i >= 0; i--) {
        const item = itemsToDelete[i];
        if (undoManager.deleteFilter(item)) {
          item.delete(transaction);
          performedChange = true;
        }
      }
      result = performedChange ? stackItem : null;
    }
    transaction.changed.forEach((subProps, type) => {
      // destroy search marker if necessary
      if (subProps.has(null) && type._searchMarker) {
        type._searchMarker.length = 0;
      }
    });
    _tr = transaction;
  }, undoManager);
  if (result != null) {
    const changedParentTypes = _tr.changedParentTypes;
    undoManager.emit('stack-item-popped', [{ stackItem: result, type: eventType, changedParentTypes }, undoManager]);
  }
  return result
};

/**
 * @typedef {Object} UndoManagerOptions
 * @property {number} [UndoManagerOptions.captureTimeout=500]
 * @property {function(Item):boolean} [UndoManagerOptions.deleteFilter=()=>true] Sometimes
 * it is necessary to filter whan an Undo/Redo operation can delete. If this
 * filter returns false, the type/item won't be deleted even it is in the
 * undo/redo scope.
 * @property {Set<any>} [UndoManagerOptions.trackedOrigins=new Set([null])]
 * @property {boolean} [ignoreRemoteMapChanges] Experimental. By default, the UndoManager will never overwrite remote changes. Enable this property to enable overwriting remote changes on key-value changes (Y.Map, properties on Y.Xml, etc..).
 */

/**
 * Fires 'stack-item-added' event when a stack item was added to either the undo- or
 * the redo-stack. You may store additional stack information via the
 * metadata property on `event.stackItem.meta` (it is a `Map` of metadata properties).
 * Fires 'stack-item-popped' event when a stack item was popped from either the
 * undo- or the redo-stack. You may restore the saved stack information from `event.stackItem.meta`.
 *
 * @extends {Observable<'stack-item-added'|'stack-item-popped'|'stack-cleared'|'stack-item-updated'>}
 */
class UndoManager extends observable.Observable {
  /**
   * @param {AbstractType<any>|Array<AbstractType<any>>} typeScope Accepts either a single type, or an array of types
   * @param {UndoManagerOptions} options
   */
  constructor (typeScope, { captureTimeout = 500, deleteFilter = () => true, trackedOrigins = new Set([null]), ignoreRemoteMapChanges = false } = {}) {
    super();
    /**
     * @type {Array<AbstractType<any>>}
     */
    this.scope = [];
    this.addToScope(typeScope);
    this.deleteFilter = deleteFilter;
    trackedOrigins.add(this);
    this.trackedOrigins = trackedOrigins;
    /**
     * @type {Array<StackItem>}
     */
    this.undoStack = [];
    /**
     * @type {Array<StackItem>}
     */
    this.redoStack = [];
    /**
     * Whether the client is currently undoing (calling UndoManager.undo)
     *
     * @type {boolean}
     */
    this.undoing = false;
    this.redoing = false;
    this.doc = /** @type {Doc} */ (this.scope[0].doc);
    this.lastChange = 0;
    this.ignoreRemoteMapChanges = ignoreRemoteMapChanges;
    /**
     * @param {Transaction} transaction
     */
    this.afterTransactionHandler = transaction => {
      // Only track certain transactions
      if (!this.scope.some(type => transaction.changedParentTypes.has(type)) || (!this.trackedOrigins.has(transaction.origin) && (!transaction.origin || !this.trackedOrigins.has(transaction.origin.constructor)))) {
        return
      }
      const undoing = this.undoing;
      const redoing = this.redoing;
      const stack = undoing ? this.redoStack : this.undoStack;
      if (undoing) {
        this.stopCapturing(); // next undo should not be appended to last stack item
      } else if (!redoing) {
        // neither undoing nor redoing: delete redoStack
        this.clear(false, true);
      }
      const insertions = new DeleteSet();
      transaction.afterState.forEach((endClock, client) => {
        const startClock = transaction.beforeState.get(client) || 0;
        const len = endClock - startClock;
        if (len > 0) {
          addToDeleteSet(insertions, client, startClock, len);
        }
      });
      const now = time__namespace.getUnixTime();
      let didAdd = false;
      if (now - this.lastChange < captureTimeout && stack.length > 0 && !undoing && !redoing) {
        // append change to last stack op
        const lastOp = stack[stack.length - 1];
        lastOp.deletions = mergeDeleteSets([lastOp.deletions, transaction.deleteSet]);
        lastOp.insertions = mergeDeleteSets([lastOp.insertions, insertions]);
      } else {
        // create a new stack op
        stack.push(new StackItem(transaction.deleteSet, insertions));
        didAdd = true;
      }
      if (!undoing && !redoing) {
        this.lastChange = now;
      }
      // make sure that deleted structs are not gc'd
      iterateDeletedStructs(transaction, transaction.deleteSet, /** @param {Item|GC} item */ item => {
        if (item instanceof Item && this.scope.some(type => isParentOf(type, item))) {
          keepItem(item, true);
        }
      });
      const changeEvent = [{ stackItem: stack[stack.length - 1], origin: transaction.origin, type: undoing ? 'redo' : 'undo', changedParentTypes: transaction.changedParentTypes }, this];
      if (didAdd) {
        this.emit('stack-item-added', changeEvent);
      } else {
        this.emit('stack-item-updated', changeEvent);
      }
    };
    this.doc.on('afterTransaction', this.afterTransactionHandler);
    this.doc.on('destroy', () => {
      this.destroy();
    });
  }

  /**
   * @param {Array<AbstractType<any>> | AbstractType<any>} ytypes
   */
  addToScope (ytypes) {
    ytypes = array__namespace.isArray(ytypes) ? ytypes : [ytypes];
    ytypes.forEach(ytype => {
      if (this.scope.every(yt => yt !== ytype)) {
        this.scope.push(ytype);
      }
    });
  }

  /**
   * @param {any} origin
   */
  addTrackedOrigin (origin) {
    this.trackedOrigins.add(origin);
  }

  /**
   * @param {any} origin
   */
  removeTrackedOrigin (origin) {
    this.trackedOrigins.delete(origin);
  }

  clear (clearUndoStack = true, clearRedoStack = true) {
    if ((clearUndoStack && this.canUndo()) || (clearRedoStack && this.canRedo())) {
      this.doc.transact(tr => {
        if (clearUndoStack) {
          this.undoStack.forEach(item => clearUndoManagerStackItem(tr, this, item));
          this.undoStack = [];
        }
        if (clearRedoStack) {
          this.redoStack.forEach(item => clearUndoManagerStackItem(tr, this, item));
          this.redoStack = [];
        }
        this.emit('stack-cleared', [{ undoStackCleared: clearUndoStack, redoStackCleared: clearRedoStack }]);
      });
    }
  }

  /**
   * UndoManager merges Undo-StackItem if they are created within time-gap
   * smaller than `options.captureTimeout`. Call `um.stopCapturing()` so that the next
   * StackItem won't be merged.
   *
   *
   * @example
   *     // without stopCapturing
   *     ytext.insert(0, 'a')
   *     ytext.insert(1, 'b')
   *     um.undo()
   *     ytext.toString() // => '' (note that 'ab' was removed)
   *     // with stopCapturing
   *     ytext.insert(0, 'a')
   *     um.stopCapturing()
   *     ytext.insert(0, 'b')
   *     um.undo()
   *     ytext.toString() // => 'a' (note that only 'b' was removed)
   *
   */
  stopCapturing () {
    this.lastChange = 0;
  }

  /**
   * Undo last changes on type.
   *
   * @return {StackItem?} Returns StackItem if a change was applied
   */
  undo () {
    this.undoing = true;
    let res;
    try {
      res = popStackItem(this, this.undoStack, 'undo');
    } finally {
      this.undoing = false;
    }
    return res
  }

  /**
   * Redo last undo operation.
   *
   * @return {StackItem?} Returns StackItem if a change was applied
   */
  redo () {
    this.redoing = true;
    let res;
    try {
      res = popStackItem(this, this.redoStack, 'redo');
    } finally {
      this.redoing = false;
    }
    return res
  }

  /**
   * Are undo steps available?
   *
   * @return {boolean} `true` if undo is possible
   */
  canUndo () {
    return this.undoStack.length > 0
  }

  /**
   * Are redo steps available?
   *
   * @return {boolean} `true` if redo is possible
   */
  canRedo () {
    return this.redoStack.length > 0
  }

  destroy () {
    this.trackedOrigins.delete(this);
    this.doc.off('afterTransaction', this.afterTransactionHandler);
    super.destroy();
  }
}

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 */
function * lazyStructReaderGenerator (decoder) {
  const numOfStateUpdates = decoding__namespace.readVarUint(decoder.restDecoder);
  for (let i = 0; i < numOfStateUpdates; i++) {
    const numberOfStructs = decoding__namespace.readVarUint(decoder.restDecoder);
    const client = decoder.readClient();
    let clock = decoding__namespace.readVarUint(decoder.restDecoder);
    for (let i = 0; i < numberOfStructs; i++) {
      const info = decoder.readInfo();
      // @todo use switch instead of ifs
      if (info === 10) {
        const len = decoding__namespace.readVarUint(decoder.restDecoder);
        yield new Skip(createID(client, clock), len);
        clock += len;
      } else if ((binary__namespace.BITS5 & info) !== 0) {
        const cantCopyParentInfo = (info & (binary__namespace.BIT7 | binary__namespace.BIT8)) === 0;
        // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
        // and we read the next string as parentYKey.
        // It indicates how we store/retrieve parent from `y.share`
        // @type {string|null}
        const struct = new Item(
          createID(client, clock),
          null, // left
          (info & binary__namespace.BIT8) === binary__namespace.BIT8 ? decoder.readLeftID() : null, // origin
          null, // right
          (info & binary__namespace.BIT7) === binary__namespace.BIT7 ? decoder.readRightID() : null, // right origin
          // @ts-ignore Force writing a string here.
          cantCopyParentInfo ? (decoder.readParentInfo() ? decoder.readString() : decoder.readLeftID()) : null, // parent
          cantCopyParentInfo && (info & binary__namespace.BIT6) === binary__namespace.BIT6 ? decoder.readString() : null, // parentSub
          readItemContent(decoder, info) // item content
        );
        yield struct;
        clock += struct.length;
      } else {
        const len = decoder.readLen();
        yield new GC(createID(client, clock), len);
        clock += len;
      }
    }
  }
}

class LazyStructReader {
  /**
   * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
   * @param {boolean} filterSkips
   */
  constructor (decoder, filterSkips) {
    this.gen = lazyStructReaderGenerator(decoder);
    /**
     * @type {null | Item | Skip | GC}
     */
    this.curr = null;
    this.done = false;
    this.filterSkips = filterSkips;
    this.next();
  }

  /**
   * @return {Item | GC | Skip |null}
   */
  next () {
    // ignore "Skip" structs
    do {
      this.curr = this.gen.next().value || null;
    } while (this.filterSkips && this.curr !== null && this.curr.constructor === Skip)
    return this.curr
  }
}

/**
 * @param {Uint8Array} update
 *
 */
const logUpdate = update => logUpdateV2(update, UpdateDecoderV1);

/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} [YDecoder]
 *
 */
const logUpdateV2 = (update, YDecoder = UpdateDecoderV2) => {
  const structs = [];
  const updateDecoder = new YDecoder(decoding__namespace.createDecoder(update));
  const lazyDecoder = new LazyStructReader(updateDecoder, false);
  for (let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next()) {
    structs.push(curr);
  }
  logging__namespace.print('Structs: ', structs);
  const ds = readDeleteSet(updateDecoder);
  logging__namespace.print('DeleteSet: ', ds);
};

/**
 * @param {Uint8Array} update
 *
 */
const decodeUpdate = (update) => decodeUpdateV2(update, UpdateDecoderV1);

/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} [YDecoder]
 *
 */
const decodeUpdateV2 = (update, YDecoder = UpdateDecoderV2) => {
  const structs = [];
  const updateDecoder = new YDecoder(decoding__namespace.createDecoder(update));
  const lazyDecoder = new LazyStructReader(updateDecoder, false);
  for (let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next()) {
    structs.push(curr);
  }
  return {
    structs,
    ds: readDeleteSet(updateDecoder)
  }
};

class LazyStructWriter {
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  constructor (encoder) {
    this.currClient = 0;
    this.startClock = 0;
    this.written = 0;
    this.encoder = encoder;
    /**
     * We want to write operations lazily, but also we need to know beforehand how many operations we want to write for each client.
     *
     * This kind of meta-information (#clients, #structs-per-client-written) is written to the restEncoder.
     *
     * We fragment the restEncoder and store a slice of it per-client until we know how many clients there are.
     * When we flush (toUint8Array) we write the restEncoder using the fragments and the meta-information.
     *
     * @type {Array<{ written: number, restEncoder: Uint8Array }>}
     */
    this.clientStructs = [];
  }
}

/**
 * @param {Array<Uint8Array>} updates
 * @return {Uint8Array}
 */
const mergeUpdates = updates => mergeUpdatesV2(updates, UpdateDecoderV1, UpdateEncoderV1);

/**
 * @param {Uint8Array} update
 * @param {typeof DSEncoderV1 | typeof DSEncoderV2} YEncoder
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} YDecoder
 * @return {Uint8Array}
 */
const encodeStateVectorFromUpdateV2 = (update, YEncoder = DSEncoderV2, YDecoder = UpdateDecoderV2) => {
  const encoder = new YEncoder();
  const updateDecoder = new LazyStructReader(new YDecoder(decoding__namespace.createDecoder(update)), false);
  let curr = updateDecoder.curr;
  if (curr !== null) {
    let size = 0;
    let currClient = curr.id.client;
    let stopCounting = curr.id.clock !== 0; // must start at 0
    let currClock = stopCounting ? 0 : curr.id.clock + curr.length;
    for (; curr !== null; curr = updateDecoder.next()) {
      if (currClient !== curr.id.client) {
        if (currClock !== 0) {
          size++;
          // We found a new client
          // write what we have to the encoder
          encoding__namespace.writeVarUint(encoder.restEncoder, currClient);
          encoding__namespace.writeVarUint(encoder.restEncoder, currClock);
        }
        currClient = curr.id.client;
        currClock = 0;
        stopCounting = curr.id.clock !== 0;
      }
      // we ignore skips
      if (curr.constructor === Skip) {
        stopCounting = true;
      }
      if (!stopCounting) {
        currClock = curr.id.clock + curr.length;
      }
    }
    // write what we have
    if (currClock !== 0) {
      size++;
      encoding__namespace.writeVarUint(encoder.restEncoder, currClient);
      encoding__namespace.writeVarUint(encoder.restEncoder, currClock);
    }
    // prepend the size of the state vector
    const enc = encoding__namespace.createEncoder();
    encoding__namespace.writeVarUint(enc, size);
    encoding__namespace.writeBinaryEncoder(enc, encoder.restEncoder);
    encoder.restEncoder = enc;
    return encoder.toUint8Array()
  } else {
    encoding__namespace.writeVarUint(encoder.restEncoder, 0);
    return encoder.toUint8Array()
  }
};

/**
 * @param {Uint8Array} update
 * @return {Uint8Array}
 */
const encodeStateVectorFromUpdate = update => encodeStateVectorFromUpdateV2(update, DSEncoderV1, UpdateDecoderV1);

/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} YDecoder
 * @return {{ from: Map<number,number>, to: Map<number,number> }}
 */
const parseUpdateMetaV2 = (update, YDecoder = UpdateDecoderV2) => {
  /**
   * @type {Map<number, number>}
   */
  const from = new Map();
  /**
   * @type {Map<number, number>}
   */
  const to = new Map();
  const updateDecoder = new LazyStructReader(new YDecoder(decoding__namespace.createDecoder(update)), false);
  let curr = updateDecoder.curr;
  if (curr !== null) {
    let currClient = curr.id.client;
    let currClock = curr.id.clock;
    // write the beginning to `from`
    from.set(currClient, currClock);
    for (; curr !== null; curr = updateDecoder.next()) {
      if (currClient !== curr.id.client) {
        // We found a new client
        // write the end to `to`
        to.set(currClient, currClock);
        // write the beginning to `from`
        from.set(curr.id.client, curr.id.clock);
        // update currClient
        currClient = curr.id.client;
      }
      currClock = curr.id.clock + curr.length;
    }
    // write the end to `to`
    to.set(currClient, currClock);
  }
  return { from, to }
};

/**
 * @param {Uint8Array} update
 * @return {{ from: Map<number,number>, to: Map<number,number> }}
 */
const parseUpdateMeta = update => parseUpdateMetaV2(update, UpdateDecoderV1);

/**
 * This method is intended to slice any kind of struct and retrieve the right part.
 * It does not handle side-effects, so it should only be used by the lazy-encoder.
 *
 * @param {Item | GC | Skip} left
 * @param {number} diff
 * @return {Item | GC}
 */
const sliceStruct = (left, diff) => {
  if (left.constructor === GC) {
    const { client, clock } = left.id;
    return new GC(createID(client, clock + diff), left.length - diff)
  } else if (left.constructor === Skip) {
    const { client, clock } = left.id;
    return new Skip(createID(client, clock + diff), left.length - diff)
  } else {
    const leftItem = /** @type {Item} */ (left);
    const { client, clock } = leftItem.id;
    return new Item(
      createID(client, clock + diff),
      null,
      createID(client, clock + diff - 1),
      null,
      leftItem.rightOrigin,
      leftItem.parent,
      leftItem.parentSub,
      leftItem.content.splice(diff)
    )
  }
};

/**
 *
 * This function works similarly to `readUpdateV2`.
 *
 * @param {Array<Uint8Array>} updates
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 * @param {typeof UpdateEncoderV1 | typeof UpdateEncoderV2} [YEncoder]
 * @return {Uint8Array}
 */
const mergeUpdatesV2 = (updates, YDecoder = UpdateDecoderV2, YEncoder = UpdateEncoderV2) => {
  if (updates.length === 1) {
    return updates[0]
  }
  const updateDecoders = updates.map(update => new YDecoder(decoding__namespace.createDecoder(update)));
  let lazyStructDecoders = updateDecoders.map(decoder => new LazyStructReader(decoder, true));

  /**
   * @todo we don't need offset because we always slice before
   * @type {null | { struct: Item | GC | Skip, offset: number }}
   */
  let currWrite = null;

  const updateEncoder = new YEncoder();
  // write structs lazily
  const lazyStructEncoder = new LazyStructWriter(updateEncoder);

  // Note: We need to ensure that all lazyStructDecoders are fully consumed
  // Note: Should merge document updates whenever possible - even from different updates
  // Note: Should handle that some operations cannot be applied yet ()

  while (true) {
    // Write higher clients first ⇒ sort by clientID & clock and remove decoders without content
    lazyStructDecoders = lazyStructDecoders.filter(dec => dec.curr !== null);
    lazyStructDecoders.sort(
      /** @type {function(any,any):number} */ (dec1, dec2) => {
        if (dec1.curr.id.client === dec2.curr.id.client) {
          const clockDiff = dec1.curr.id.clock - dec2.curr.id.clock;
          if (clockDiff === 0) {
            // @todo remove references to skip since the structDecoders must filter Skips.
            return dec1.curr.constructor === dec2.curr.constructor
              ? 0
              : dec1.curr.constructor === Skip ? 1 : -1 // we are filtering skips anyway.
          } else {
            return clockDiff
          }
        } else {
          return dec2.curr.id.client - dec1.curr.id.client
        }
      }
    );
    if (lazyStructDecoders.length === 0) {
      break
    }
    const currDecoder = lazyStructDecoders[0];
    // write from currDecoder until the next operation is from another client or if filler-struct
    // then we need to reorder the decoders and find the next operation to write
    const firstClient = /** @type {Item | GC} */ (currDecoder.curr).id.client;

    if (currWrite !== null) {
      let curr = /** @type {Item | GC | null} */ (currDecoder.curr);
      let iterated = false;

      // iterate until we find something that we haven't written already
      // remember: first the high client-ids are written
      while (curr !== null && curr.id.clock + curr.length <= currWrite.struct.id.clock + currWrite.struct.length && curr.id.client >= currWrite.struct.id.client) {
        curr = currDecoder.next();
        iterated = true;
      }
      if (
        curr === null || // current decoder is empty
        curr.id.client !== firstClient || // check whether there is another decoder that has has updates from `firstClient`
        (iterated && curr.id.clock > currWrite.struct.id.clock + currWrite.struct.length) // the above while loop was used and we are potentially missing updates
      ) {
        continue
      }

      if (firstClient !== currWrite.struct.id.client) {
        writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
        currWrite = { struct: curr, offset: 0 };
        currDecoder.next();
      } else {
        if (currWrite.struct.id.clock + currWrite.struct.length < curr.id.clock) {
          // @todo write currStruct & set currStruct = Skip(clock = currStruct.id.clock + currStruct.length, length = curr.id.clock - self.clock)
          if (currWrite.struct.constructor === Skip) {
            // extend existing skip
            currWrite.struct.length = curr.id.clock + curr.length - currWrite.struct.id.clock;
          } else {
            writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
            const diff = curr.id.clock - currWrite.struct.id.clock - currWrite.struct.length;
            /**
             * @type {Skip}
             */
            const struct = new Skip(createID(firstClient, currWrite.struct.id.clock + currWrite.struct.length), diff);
            currWrite = { struct, offset: 0 };
          }
        } else { // if (currWrite.struct.id.clock + currWrite.struct.length >= curr.id.clock) {
          const diff = currWrite.struct.id.clock + currWrite.struct.length - curr.id.clock;
          if (diff > 0) {
            if (currWrite.struct.constructor === Skip) {
              // prefer to slice Skip because the other struct might contain more information
              currWrite.struct.length -= diff;
            } else {
              curr = sliceStruct(curr, diff);
            }
          }
          if (!currWrite.struct.mergeWith(/** @type {any} */ (curr))) {
            writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
            currWrite = { struct: curr, offset: 0 };
            currDecoder.next();
          }
        }
      }
    } else {
      currWrite = { struct: /** @type {Item | GC} */ (currDecoder.curr), offset: 0 };
      currDecoder.next();
    }
    for (
      let next = currDecoder.curr;
      next !== null && next.id.client === firstClient && next.id.clock === currWrite.struct.id.clock + currWrite.struct.length && next.constructor !== Skip;
      next = currDecoder.next()
    ) {
      writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
      currWrite = { struct: next, offset: 0 };
    }
  }
  if (currWrite !== null) {
    writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
    currWrite = null;
  }
  finishLazyStructWriting(lazyStructEncoder);

  const dss = updateDecoders.map(decoder => readDeleteSet(decoder));
  const ds = mergeDeleteSets(dss);
  writeDeleteSet(updateEncoder, ds);
  return updateEncoder.toUint8Array()
};

/**
 * @param {Uint8Array} update
 * @param {Uint8Array} sv
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 * @param {typeof UpdateEncoderV1 | typeof UpdateEncoderV2} [YEncoder]
 */
const diffUpdateV2 = (update, sv, YDecoder = UpdateDecoderV2, YEncoder = UpdateEncoderV2) => {
  const state = decodeStateVector(sv);
  const encoder = new YEncoder();
  const lazyStructWriter = new LazyStructWriter(encoder);
  const decoder = new YDecoder(decoding__namespace.createDecoder(update));
  const reader = new LazyStructReader(decoder, false);
  while (reader.curr) {
    const curr = reader.curr;
    const currClient = curr.id.client;
    const svClock = state.get(currClient) || 0;
    if (reader.curr.constructor === Skip) {
      // the first written struct shouldn't be a skip
      reader.next();
      continue
    }
    if (curr.id.clock + curr.length > svClock) {
      writeStructToLazyStructWriter(lazyStructWriter, curr, math__namespace.max(svClock - curr.id.clock, 0));
      reader.next();
      while (reader.curr && reader.curr.id.client === currClient) {
        writeStructToLazyStructWriter(lazyStructWriter, reader.curr, 0);
        reader.next();
      }
    } else {
      // read until something new comes up
      while (reader.curr && reader.curr.id.client === currClient && reader.curr.id.clock + reader.curr.length <= svClock) {
        reader.next();
      }
    }
  }
  finishLazyStructWriting(lazyStructWriter);
  // write ds
  const ds = readDeleteSet(decoder);
  writeDeleteSet(encoder, ds);
  return encoder.toUint8Array()
};

/**
 * @param {Uint8Array} update
 * @param {Uint8Array} sv
 */
const diffUpdate = (update, sv) => diffUpdateV2(update, sv, UpdateDecoderV1, UpdateEncoderV1);

/**
 * @param {LazyStructWriter} lazyWriter
 */
const flushLazyStructWriter = lazyWriter => {
  if (lazyWriter.written > 0) {
    lazyWriter.clientStructs.push({ written: lazyWriter.written, restEncoder: encoding__namespace.toUint8Array(lazyWriter.encoder.restEncoder) });
    lazyWriter.encoder.restEncoder = encoding__namespace.createEncoder();
    lazyWriter.written = 0;
  }
};

/**
 * @param {LazyStructWriter} lazyWriter
 * @param {Item | GC} struct
 * @param {number} offset
 */
const writeStructToLazyStructWriter = (lazyWriter, struct, offset) => {
  // flush curr if we start another client
  if (lazyWriter.written > 0 && lazyWriter.currClient !== struct.id.client) {
    flushLazyStructWriter(lazyWriter);
  }
  if (lazyWriter.written === 0) {
    lazyWriter.currClient = struct.id.client;
    // write next client
    lazyWriter.encoder.writeClient(struct.id.client);
    // write startClock
    encoding__namespace.writeVarUint(lazyWriter.encoder.restEncoder, struct.id.clock + offset);
  }
  struct.write(lazyWriter.encoder, offset);
  lazyWriter.written++;
};
/**
 * Call this function when we collected all parts and want to
 * put all the parts together. After calling this method,
 * you can continue using the UpdateEncoder.
 *
 * @param {LazyStructWriter} lazyWriter
 */
const finishLazyStructWriting = (lazyWriter) => {
  flushLazyStructWriter(lazyWriter);

  // this is a fresh encoder because we called flushCurr
  const restEncoder = lazyWriter.encoder.restEncoder;

  /**
   * Now we put all the fragments together.
   * This works similarly to `writeClientsStructs`
   */

  // write # states that were updated - i.e. the clients
  encoding__namespace.writeVarUint(restEncoder, lazyWriter.clientStructs.length);

  for (let i = 0; i < lazyWriter.clientStructs.length; i++) {
    const partStructs = lazyWriter.clientStructs[i];
    /**
     * Works similarly to `writeStructs`
     */
    // write # encoded structs
    encoding__namespace.writeVarUint(restEncoder, partStructs.written);
    // write the rest of the fragment
    encoding__namespace.writeUint8Array(restEncoder, partStructs.restEncoder);
  }
};

/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} YDecoder
 * @param {typeof UpdateEncoderV2 | typeof UpdateEncoderV1 } YEncoder
 */
const convertUpdateFormat = (update, YDecoder, YEncoder) => {
  const updateDecoder = new YDecoder(decoding__namespace.createDecoder(update));
  const lazyDecoder = new LazyStructReader(updateDecoder, false);
  const updateEncoder = new YEncoder();
  const lazyWriter = new LazyStructWriter(updateEncoder);

  for (let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next()) {
    writeStructToLazyStructWriter(lazyWriter, curr, 0);
  }
  finishLazyStructWriting(lazyWriter);
  const ds = readDeleteSet(updateDecoder);
  writeDeleteSet(updateEncoder, ds);
  return updateEncoder.toUint8Array()
};

/**
 * @param {Uint8Array} update
 */
const convertUpdateFormatV1ToV2 = update => convertUpdateFormat(update, UpdateDecoderV1, UpdateEncoderV2);

/**
 * @param {Uint8Array} update
 */
const convertUpdateFormatV2ToV1 = update => convertUpdateFormat(update, UpdateDecoderV2, UpdateEncoderV1);

/**
 * @template {AbstractType<any>} T
 * YEvent describes the changes on a YType.
 */
class YEvent {
  /**
   * @param {T} target The changed type.
   * @param {Transaction} transaction
   */
  constructor (target, transaction) {
    /**
     * The type on which this event was created on.
     * @type {T}
     */
    this.target = target;
    /**
     * The current target on which the observe callback is called.
     * @type {AbstractType<any>}
     */
    this.currentTarget = target;
    /**
     * The transaction that triggered this event.
     * @type {Transaction}
     */
    this.transaction = transaction;
    /**
     * @type {Object|null}
     */
    this._changes = null;
    /**
     * @type {null | Map<string, { action: 'add' | 'update' | 'delete', oldValue: any, newValue: any }>}
     */
    this._keys = null;
    /**
     * @type {null | Array<{ insert?: string | Array<any> | object | AbstractType<any>, retain?: number, delete?: number, attributes?: Object<string, any> }>}
     */
    this._delta = null;
  }

  /**
   * Computes the path from `y` to the changed type.
   *
   * @todo v14 should standardize on path: Array<{parent, index}> because that is easier to work with.
   *
   * The following property holds:
   * @example
   *   let type = y
   *   event.path.forEach(dir => {
   *     type = type.get(dir)
   *   })
   *   type === event.target // => true
   */
  get path () {
    // @ts-ignore _item is defined because target is integrated
    return getPathTo(this.currentTarget, this.target)
  }

  /**
   * Check if a struct is deleted by this event.
   *
   * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
   *
   * @param {AbstractStruct} struct
   * @return {boolean}
   */
  deletes (struct) {
    return isDeleted(this.transaction.deleteSet, struct.id)
  }

  /**
   * @type {Map<string, { action: 'add' | 'update' | 'delete', oldValue: any, newValue: any }>}
   */
  get keys () {
    if (this._keys === null) {
      const keys = new Map();
      const target = this.target;
      const changed = /** @type Set<string|null> */ (this.transaction.changed.get(target));
      changed.forEach(key => {
        if (key !== null) {
          const item = /** @type {Item} */ (target._map.get(key));
          /**
           * @type {'delete' | 'add' | 'update'}
           */
          let action;
          let oldValue;
          if (this.adds(item)) {
            let prev = item.left;
            while (prev !== null && this.adds(prev)) {
              prev = prev.left;
            }
            if (this.deletes(item)) {
              if (prev !== null && this.deletes(prev)) {
                action = 'delete';
                oldValue = array__namespace.last(prev.content.getContent());
              } else {
                return
              }
            } else {
              if (prev !== null && this.deletes(prev)) {
                action = 'update';
                oldValue = array__namespace.last(prev.content.getContent());
              } else {
                action = 'add';
                oldValue = undefined;
              }
            }
          } else {
            if (this.deletes(item)) {
              action = 'delete';
              oldValue = array__namespace.last(/** @type {Item} */ item.content.getContent());
            } else {
              return // nop
            }
          }
          keys.set(key, { action, oldValue });
        }
      });
      this._keys = keys;
    }
    return this._keys
  }

  /**
   * @type {Array<{insert?: string | Array<any> | object | AbstractType<any>, retain?: number, delete?: number, attributes?: Object<string, any>}>}
   */
  get delta () {
    return this.changes.delta
  }

  /**
   * Check if a struct is added by this event.
   *
   * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
   *
   * @param {AbstractStruct} struct
   * @return {boolean}
   */
  adds (struct) {
    return struct.id.clock >= (this.transaction.beforeState.get(struct.id.client) || 0)
  }

  /**
   * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
   */
  get changes () {
    let changes = this._changes;
    if (changes === null) {
      const target = this.target;
      const added = set__namespace.create();
      const deleted = set__namespace.create();
      /**
       * @type {Array<{insert:Array<any>}|{delete:number}|{retain:number}>}
       */
      const delta = [];
      changes = {
        added,
        deleted,
        delta,
        keys: this.keys
      };
      const changed = /** @type Set<string|null> */ (this.transaction.changed.get(target));
      if (changed.has(null)) {
        /**
         * @type {any}
         */
        let lastOp = null;
        const packOp = () => {
          if (lastOp) {
            delta.push(lastOp);
          }
        };
        for (let item = target._start; item !== null; item = item.right) {
          if (item.deleted) {
            if (this.deletes(item) && !this.adds(item)) {
              if (lastOp === null || lastOp.delete === undefined) {
                packOp();
                lastOp = { delete: 0 };
              }
              lastOp.delete += item.length;
              deleted.add(item);
            } // else nop
          } else {
            if (this.adds(item)) {
              if (lastOp === null || lastOp.insert === undefined) {
                packOp();
                lastOp = { insert: [] };
              }
              lastOp.insert = lastOp.insert.concat(item.content.getContent());
              added.add(item);
            } else {
              if (lastOp === null || lastOp.retain === undefined) {
                packOp();
                lastOp = { retain: 0 };
              }
              lastOp.retain += item.length;
            }
          }
        }
        if (lastOp !== null && lastOp.retain === undefined) {
          packOp();
        }
      }
      this._changes = changes;
    }
    return /** @type {any} */ (changes)
  }
}

/**
 * Compute the path from this type to the specified target.
 *
 * @example
 *   // `child` should be accessible via `type.get(path[0]).get(path[1])..`
 *   const path = type.getPathTo(child)
 *   // assuming `type instanceof YArray`
 *   console.log(path) // might look like => [2, 'key1']
 *   child === type.get(path[0]).get(path[1])
 *
 * @param {AbstractType<any>} parent
 * @param {AbstractType<any>} child target
 * @return {Array<string|number>} Path to the target
 *
 * @private
 * @function
 */
const getPathTo = (parent, child) => {
  const path = [];
  while (child._item !== null && child !== parent) {
    if (child._item.parentSub !== null) {
      // parent is map-ish
      path.unshift(child._item.parentSub);
    } else {
      // parent is array-ish
      let i = 0;
      let c = /** @type {AbstractType<any>} */ (child._item.parent)._start;
      while (c !== child._item && c !== null) {
        if (!c.deleted) {
          i++;
        }
        c = c.right;
      }
      path.unshift(i);
    }
    child = /** @type {AbstractType<any>} */ (child._item.parent);
  }
  return path
};

const maxSearchMarker = 80;

/**
 * A unique timestamp that identifies each marker.
 *
 * Time is relative,.. this is more like an ever-increasing clock.
 *
 * @type {number}
 */
let globalSearchMarkerTimestamp = 0;

class ArraySearchMarker {
  /**
   * @param {Item} p
   * @param {number} index
   */
  constructor (p, index) {
    p.marker = true;
    this.p = p;
    this.index = index;
    this.timestamp = globalSearchMarkerTimestamp++;
  }
}

/**
 * @param {ArraySearchMarker} marker
 */
const refreshMarkerTimestamp = marker => { marker.timestamp = globalSearchMarkerTimestamp++; };

/**
 * This is rather complex so this function is the only thing that should overwrite a marker
 *
 * @param {ArraySearchMarker} marker
 * @param {Item} p
 * @param {number} index
 */
const overwriteMarker = (marker, p, index) => {
  marker.p.marker = false;
  marker.p = p;
  p.marker = true;
  marker.index = index;
  marker.timestamp = globalSearchMarkerTimestamp++;
};

/**
 * @param {Array<ArraySearchMarker>} searchMarker
 * @param {Item} p
 * @param {number} index
 */
const markPosition = (searchMarker, p, index) => {
  if (searchMarker.length >= maxSearchMarker) {
    // override oldest marker (we don't want to create more objects)
    const marker = searchMarker.reduce((a, b) => a.timestamp < b.timestamp ? a : b);
    overwriteMarker(marker, p, index);
    return marker
  } else {
    // create new marker
    const pm = new ArraySearchMarker(p, index);
    searchMarker.push(pm);
    return pm
  }
};

/**
 * Search marker help us to find positions in the associative array faster.
 *
 * They speed up the process of finding a position without much bookkeeping.
 *
 * A maximum of `maxSearchMarker` objects are created.
 *
 * This function always returns a refreshed marker (updated timestamp)
 *
 * @param {AbstractType<any>} yarray
 * @param {number} index
 */
const findMarker = (yarray, index) => {
  if (yarray._start === null || index === 0 || yarray._searchMarker === null) {
    return null
  }
  const marker = yarray._searchMarker.length === 0 ? null : yarray._searchMarker.reduce((a, b) => math__namespace.abs(index - a.index) < math__namespace.abs(index - b.index) ? a : b);
  let p = yarray._start;
  let pindex = 0;
  if (marker !== null) {
    p = marker.p;
    pindex = marker.index;
    refreshMarkerTimestamp(marker); // we used it, we might need to use it again
  }
  // iterate to right if possible
  while (p.right !== null && pindex < index) {
    if (!p.deleted && p.countable) {
      if (index < pindex + p.length) {
        break
      }
      pindex += p.length;
    }
    p = p.right;
  }
  // iterate to left if necessary (might be that pindex > index)
  while (p.left !== null && pindex > index) {
    p = p.left;
    if (!p.deleted && p.countable) {
      pindex -= p.length;
    }
  }
  // we want to make sure that p can't be merged with left, because that would screw up everything
  // in that cas just return what we have (it is most likely the best marker anyway)
  // iterate to left until p can't be merged with left
  while (p.left !== null && p.left.id.client === p.id.client && p.left.id.clock + p.left.length === p.id.clock) {
    p = p.left;
    if (!p.deleted && p.countable) {
      pindex -= p.length;
    }
  }

  // @todo remove!
  // assure position
  // {
  //   let start = yarray._start
  //   let pos = 0
  //   while (start !== p) {
  //     if (!start.deleted && start.countable) {
  //       pos += start.length
  //     }
  //     start = /** @type {Item} */ (start.right)
  //   }
  //   if (pos !== pindex) {
  //     debugger
  //     throw new Error('Gotcha position fail!')
  //   }
  // }
  // if (marker) {
  //   if (window.lengthes == null) {
  //     window.lengthes = []
  //     window.getLengthes = () => window.lengthes.sort((a, b) => a - b)
  //   }
  //   window.lengthes.push(marker.index - pindex)
  //   console.log('distance', marker.index - pindex, 'len', p && p.parent.length)
  // }
  if (marker !== null && math__namespace.abs(marker.index - pindex) < /** @type {YText|YArray<any>} */ (p.parent).length / maxSearchMarker) {
    // adjust existing marker
    overwriteMarker(marker, p, pindex);
    return marker
  } else {
    // create new marker
    return markPosition(yarray._searchMarker, p, pindex)
  }
};

/**
 * Update markers when a change happened.
 *
 * This should be called before doing a deletion!
 *
 * @param {Array<ArraySearchMarker>} searchMarker
 * @param {number} index
 * @param {number} len If insertion, len is positive. If deletion, len is negative.
 */
const updateMarkerChanges = (searchMarker, index, len) => {
  for (let i = searchMarker.length - 1; i >= 0; i--) {
    const m = searchMarker[i];
    if (len > 0) {
      /**
       * @type {Item|null}
       */
      let p = m.p;
      p.marker = false;
      // Ideally we just want to do a simple position comparison, but this will only work if
      // search markers don't point to deleted items for formats.
      // Iterate marker to prev undeleted countable position so we know what to do when updating a position
      while (p && (p.deleted || !p.countable)) {
        p = p.left;
        if (p && !p.deleted && p.countable) {
          // adjust position. the loop should break now
          m.index -= p.length;
        }
      }
      if (p === null || p.marker === true) {
        // remove search marker if updated position is null or if position is already marked
        searchMarker.splice(i, 1);
        continue
      }
      m.p = p;
      p.marker = true;
    }
    if (index < m.index || (len > 0 && index === m.index)) { // a simple index <= m.index check would actually suffice
      m.index = math__namespace.max(index, m.index + len);
    }
  }
};

/**
 * Accumulate all (list) children of a type and return them as an Array.
 *
 * @param {AbstractType<any>} t
 * @return {Array<Item>}
 */
const getTypeChildren = t => {
  let s = t._start;
  const arr = [];
  while (s) {
    arr.push(s);
    s = s.right;
  }
  return arr
};

/**
 * Call event listeners with an event. This will also add an event to all
 * parents (for `.observeDeep` handlers).
 *
 * @template EventType
 * @param {AbstractType<EventType>} type
 * @param {Transaction} transaction
 * @param {EventType} event
 */
const callTypeObservers = (type, transaction, event) => {
  const changedType = type;
  const changedParentTypes = transaction.changedParentTypes;
  while (true) {
    // @ts-ignore
    map__namespace.setIfUndefined(changedParentTypes, type, () => []).push(event);
    if (type._item === null) {
      break
    }
    type = /** @type {AbstractType<any>} */ (type._item.parent);
  }
  callEventHandlerListeners(changedType._eH, event, transaction);
};

/**
 * @template EventType
 * Abstract Yjs Type class
 */
class AbstractType {
  constructor () {
    /**
     * @type {Item|null}
     */
    this._item = null;
    /**
     * @type {Map<string,Item>}
     */
    this._map = new Map();
    /**
     * @type {Item|null}
     */
    this._start = null;
    /**
     * @type {Doc|null}
     */
    this.doc = null;
    this._length = 0;
    /**
     * Event handlers
     * @type {EventHandler<EventType,Transaction>}
     */
    this._eH = createEventHandler();
    /**
     * Deep event handlers
     * @type {EventHandler<Array<YEvent<any>>,Transaction>}
     */
    this._dEH = createEventHandler();
    /**
     * @type {null | Array<ArraySearchMarker>}
     */
    this._searchMarker = null;
  }

  /**
   * @return {AbstractType<any>|null}
   */
  get parent () {
    return this._item ? /** @type {AbstractType<any>} */ (this._item.parent) : null
  }

  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item|null} item
   */
  _integrate (y, item) {
    this.doc = y;
    this._item = item;
  }

  /**
   * @return {AbstractType<EventType>}
   */
  _copy () {
    throw error__namespace.methodUnimplemented()
  }

  /**
   * @return {AbstractType<EventType>}
   */
  clone () {
    throw error__namespace.methodUnimplemented()
  }

  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  _write (encoder) { }

  /**
   * The first non-deleted item
   */
  get _first () {
    let n = this._start;
    while (n !== null && n.deleted) {
      n = n.right;
    }
    return n
  }

  /**
   * Creates YEvent and calls all type observers.
   * Must be implemented by each type.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver (transaction, parentSubs) {
    if (!transaction.local && this._searchMarker) {
      this._searchMarker.length = 0;
    }
  }

  /**
   * Observe all events that are created on this type.
   *
   * @param {function(EventType, Transaction):void} f Observer function
   */
  observe (f) {
    addEventHandlerListener(this._eH, f);
  }

  /**
   * Observe all events that are created by this type and its children.
   *
   * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
   */
  observeDeep (f) {
    addEventHandlerListener(this._dEH, f);
  }

  /**
   * Unregister an observer function.
   *
   * @param {function(EventType,Transaction):void} f Observer function
   */
  unobserve (f) {
    removeEventHandlerListener(this._eH, f);
  }

  /**
   * Unregister an observer function.
   *
   * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
   */
  unobserveDeep (f) {
    removeEventHandlerListener(this._dEH, f);
  }

  /**
   * @abstract
   * @return {any}
   */
  toJSON () {}
}

/**
 * @param {AbstractType<any>} type
 * @param {number} start
 * @param {number} end
 * @return {Array<any>}
 *
 * @private
 * @function
 */
const typeListSlice = (type, start, end) => {
  if (start < 0) {
    start = type._length + start;
  }
  if (end < 0) {
    end = type._length + end;
  }
  let len = end - start;
  const cs = [];
  let n = type._start;
  while (n !== null && len > 0) {
    if (n.countable && !n.deleted) {
      const c = n.content.getContent();
      if (c.length <= start) {
        start -= c.length;
      } else {
        for (let i = start; i < c.length && len > 0; i++) {
          cs.push(c[i]);
          len--;
        }
        start = 0;
      }
    }
    n = n.right;
  }
  return cs
};

/**
 * @param {AbstractType<any>} type
 * @return {Array<any>}
 *
 * @private
 * @function
 */
const typeListToArray = type => {
  const cs = [];
  let n = type._start;
  while (n !== null) {
    if (n.countable && !n.deleted) {
      const c = n.content.getContent();
      for (let i = 0; i < c.length; i++) {
        cs.push(c[i]);
      }
    }
    n = n.right;
  }
  return cs
};

/**
 * @param {AbstractType<any>} type
 * @param {Snapshot} snapshot
 * @return {Array<any>}
 *
 * @private
 * @function
 */
const typeListToArraySnapshot = (type, snapshot) => {
  const cs = [];
  let n = type._start;
  while (n !== null) {
    if (n.countable && isVisible(n, snapshot)) {
      const c = n.content.getContent();
      for (let i = 0; i < c.length; i++) {
        cs.push(c[i]);
      }
    }
    n = n.right;
  }
  return cs
};

/**
 * Executes a provided function on once on overy element of this YArray.
 *
 * @param {AbstractType<any>} type
 * @param {function(any,number,any):void} f A function to execute on every element of this YArray.
 *
 * @private
 * @function
 */
const typeListForEach = (type, f) => {
  let index = 0;
  let n = type._start;
  while (n !== null) {
    if (n.countable && !n.deleted) {
      const c = n.content.getContent();
      for (let i = 0; i < c.length; i++) {
        f(c[i], index++, type);
      }
    }
    n = n.right;
  }
};

/**
 * @template C,R
 * @param {AbstractType<any>} type
 * @param {function(C,number,AbstractType<any>):R} f
 * @return {Array<R>}
 *
 * @private
 * @function
 */
const typeListMap = (type, f) => {
  /**
   * @type {Array<any>}
   */
  const result = [];
  typeListForEach(type, (c, i) => {
    result.push(f(c, i, type));
  });
  return result
};

/**
 * @param {AbstractType<any>} type
 * @return {IterableIterator<any>}
 *
 * @private
 * @function
 */
const typeListCreateIterator = type => {
  let n = type._start;
  /**
   * @type {Array<any>|null}
   */
  let currentContent = null;
  let currentContentIndex = 0;
  return {
    [Symbol.iterator] () {
      return this
    },
    next: () => {
      // find some content
      if (currentContent === null) {
        while (n !== null && n.deleted) {
          n = n.right;
        }
        // check if we reached the end, no need to check currentContent, because it does not exist
        if (n === null) {
          return {
            done: true,
            value: undefined
          }
        }
        // we found n, so we can set currentContent
        currentContent = n.content.getContent();
        currentContentIndex = 0;
        n = n.right; // we used the content of n, now iterate to next
      }
      const value = currentContent[currentContentIndex++];
      // check if we need to empty currentContent
      if (currentContent.length <= currentContentIndex) {
        currentContent = null;
      }
      return {
        done: false,
        value
      }
    }
  }
};

/**
 * @param {AbstractType<any>} type
 * @param {number} index
 * @return {any}
 *
 * @private
 * @function
 */
const typeListGet = (type, index) => {
  const marker = findMarker(type, index);
  let n = type._start;
  if (marker !== null) {
    n = marker.p;
    index -= marker.index;
  }
  for (; n !== null; n = n.right) {
    if (!n.deleted && n.countable) {
      if (index < n.length) {
        return n.content.getContent()[index]
      }
      index -= n.length;
    }
  }
};

/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {Item?} referenceItem
 * @param {Array<Object<string,any>|Array<any>|boolean|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */
const typeListInsertGenericsAfter = (transaction, parent, referenceItem, content) => {
  let left = referenceItem;
  const doc = transaction.doc;
  const ownClientId = doc.clientID;
  const store = doc.store;
  const right = referenceItem === null ? parent._start : referenceItem.right;
  /**
   * @type {Array<Object|Array<any>|number|null>}
   */
  let jsonContent = [];
  const packJsonContent = () => {
    if (jsonContent.length > 0) {
      left = new Item(createID(ownClientId, getState(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new ContentAny(jsonContent));
      left.integrate(transaction, 0);
      jsonContent = [];
    }
  };
  content.forEach(c => {
    if (c === null) {
      jsonContent.push(c);
    } else {
      switch (c.constructor) {
        case Number:
        case Object:
        case Boolean:
        case Array:
        case String:
          jsonContent.push(c);
          break
        default:
          packJsonContent();
          switch (c.constructor) {
            case Uint8Array:
            case ArrayBuffer:
              left = new Item(createID(ownClientId, getState(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new ContentBinary(new Uint8Array(/** @type {Uint8Array} */ (c))));
              left.integrate(transaction, 0);
              break
            case Doc:
              left = new Item(createID(ownClientId, getState(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new ContentDoc(/** @type {Doc} */ (c)));
              left.integrate(transaction, 0);
              break
            default:
              if (c instanceof AbstractType) {
                left = new Item(createID(ownClientId, getState(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new ContentType(c));
                left.integrate(transaction, 0);
              } else {
                throw new Error('Unexpected content type in insert operation')
              }
          }
      }
    }
  });
  packJsonContent();
};

const lengthExceeded = error__namespace.create('Length exceeded!');

/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @param {Array<Object<string,any>|Array<any>|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */
const typeListInsertGenerics = (transaction, parent, index, content) => {
  if (index > parent._length) {
    throw lengthExceeded
  }
  if (index === 0) {
    if (parent._searchMarker) {
      updateMarkerChanges(parent._searchMarker, index, content.length);
    }
    return typeListInsertGenericsAfter(transaction, parent, null, content)
  }
  const startIndex = index;
  const marker = findMarker(parent, index);
  let n = parent._start;
  if (marker !== null) {
    n = marker.p;
    index -= marker.index;
    // we need to iterate one to the left so that the algorithm works
    if (index === 0) {
      // @todo refactor this as it actually doesn't consider formats
      n = n.prev; // important! get the left undeleted item so that we can actually decrease index
      index += (n && n.countable && !n.deleted) ? n.length : 0;
    }
  }
  for (; n !== null; n = n.right) {
    if (!n.deleted && n.countable) {
      if (index <= n.length) {
        if (index < n.length) {
          // insert in-between
          getItemCleanStart(transaction, createID(n.id.client, n.id.clock + index));
        }
        break
      }
      index -= n.length;
    }
  }
  if (parent._searchMarker) {
    updateMarkerChanges(parent._searchMarker, startIndex, content.length);
  }
  return typeListInsertGenericsAfter(transaction, parent, n, content)
};

/**
 * Pushing content is special as we generally want to push after the last item. So we don't have to update
 * the serach marker.
 *
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {Array<Object<string,any>|Array<any>|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */
const typeListPushGenerics = (transaction, parent, content) => {
  // Use the marker with the highest index and iterate to the right.
  const marker = (parent._searchMarker || []).reduce((maxMarker, currMarker) => currMarker.index > maxMarker.index ? currMarker : maxMarker, { index: 0, p: parent._start });
  let n = marker.p;
  if (n) {
    while (n.right) {
      n = n.right;
    }
  }
  return typeListInsertGenericsAfter(transaction, parent, n, content)
};

/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @param {number} length
 *
 * @private
 * @function
 */
const typeListDelete = (transaction, parent, index, length) => {
  if (length === 0) { return }
  const startIndex = index;
  const startLength = length;
  const marker = findMarker(parent, index);
  let n = parent._start;
  if (marker !== null) {
    n = marker.p;
    index -= marker.index;
  }
  // compute the first item to be deleted
  for (; n !== null && index > 0; n = n.right) {
    if (!n.deleted && n.countable) {
      if (index < n.length) {
        getItemCleanStart(transaction, createID(n.id.client, n.id.clock + index));
      }
      index -= n.length;
    }
  }
  // delete all items until done
  while (length > 0 && n !== null) {
    if (!n.deleted) {
      if (length < n.length) {
        getItemCleanStart(transaction, createID(n.id.client, n.id.clock + length));
      }
      n.delete(transaction);
      length -= n.length;
    }
    n = n.right;
  }
  if (length > 0) {
    throw lengthExceeded
  }
  if (parent._searchMarker) {
    updateMarkerChanges(parent._searchMarker, startIndex, -startLength + length /* in case we remove the above exception */);
  }
};

/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {string} key
 *
 * @private
 * @function
 */
const typeMapDelete = (transaction, parent, key) => {
  const c = parent._map.get(key);
  if (c !== undefined) {
    c.delete(transaction);
  }
};

/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @param {Object|number|null|Array<any>|string|Uint8Array|AbstractType<any>} value
 *
 * @private
 * @function
 */
const typeMapSet = (transaction, parent, key, value) => {
  const left = parent._map.get(key) || null;
  const doc = transaction.doc;
  const ownClientId = doc.clientID;
  let content;
  if (value == null) {
    content = new ContentAny([value]);
  } else {
    switch (value.constructor) {
      case Number:
      case Object:
      case Boolean:
      case Array:
      case String:
        content = new ContentAny([value]);
        break
      case Uint8Array:
        content = new ContentBinary(/** @type {Uint8Array} */ (value));
        break
      case Doc:
        content = new ContentDoc(/** @type {Doc} */ (value));
        break
      default:
        if (value instanceof AbstractType) {
          content = new ContentType(value);
        } else {
          throw new Error('Unexpected content type')
        }
    }
  }
  new Item(createID(ownClientId, getState(doc.store, ownClientId)), left, left && left.lastId, null, null, parent, key, content).integrate(transaction, 0);
};

/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @return {Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined}
 *
 * @private
 * @function
 */
const typeMapGet = (parent, key) => {
  const val = parent._map.get(key);
  return val !== undefined && !val.deleted ? val.content.getContent()[val.length - 1] : undefined
};

/**
 * @param {AbstractType<any>} parent
 * @return {Object<string,Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined>}
 *
 * @private
 * @function
 */
const typeMapGetAll = (parent) => {
  /**
   * @type {Object<string,any>}
   */
  const res = {};
  parent._map.forEach((value, key) => {
    if (!value.deleted) {
      res[key] = value.content.getContent()[value.length - 1];
    }
  });
  return res
};

/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @return {boolean}
 *
 * @private
 * @function
 */
const typeMapHas = (parent, key) => {
  const val = parent._map.get(key);
  return val !== undefined && !val.deleted
};

/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @param {Snapshot} snapshot
 * @return {Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined}
 *
 * @private
 * @function
 */
const typeMapGetSnapshot = (parent, key, snapshot) => {
  let v = parent._map.get(key) || null;
  while (v !== null && (!snapshot.sv.has(v.id.client) || v.id.clock >= (snapshot.sv.get(v.id.client) || 0))) {
    v = v.left;
  }
  return v !== null && isVisible(v, snapshot) ? v.content.getContent()[v.length - 1] : undefined
};

/**
 * @param {Map<string,Item>} map
 * @return {IterableIterator<Array<any>>}
 *
 * @private
 * @function
 */
const createMapIterator = map => iterator__namespace.iteratorFilter(map.entries(), /** @param {any} entry */ entry => !entry[1].deleted);

/**
 * @module YArray
 */

/**
 * Event that describes the changes on a YArray
 * @template T
 * @extends YEvent<YArray<T>>
 */
class YArrayEvent extends YEvent {
  /**
   * @param {YArray<T>} yarray The changed type
   * @param {Transaction} transaction The transaction object
   */
  constructor (yarray, transaction) {
    super(yarray, transaction);
    this._transaction = transaction;
  }
}

/**
 * A shared Array implementation.
 * @template T
 * @extends AbstractType<YArrayEvent<T>>
 * @implements {Iterable<T>}
 */
class YArray extends AbstractType {
  constructor () {
    super();
    /**
     * @type {Array<any>?}
     * @private
     */
    this._prelimContent = [];
    /**
     * @type {Array<ArraySearchMarker>}
     */
    this._searchMarker = [];
  }

  /**
   * Construct a new YArray containing the specified items.
   * @template T
   * @param {Array<T>} items
   * @return {YArray<T>}
   */
  static from (items) {
    const a = new YArray();
    a.push(items);
    return a
  }

  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */
  _integrate (y, item) {
    super._integrate(y, item);
    this.insert(0, /** @type {Array<any>} */ (this._prelimContent));
    this._prelimContent = null;
  }

  _copy () {
    return new YArray()
  }

  /**
   * @return {YArray<T>}
   */
  clone () {
    const arr = new YArray();
    arr.insert(0, this.toArray().map(el =>
      el instanceof AbstractType ? el.clone() : el
    ));
    return arr
  }

  get length () {
    return this._prelimContent === null ? this._length : this._prelimContent.length
  }

  /**
   * Creates YArrayEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver (transaction, parentSubs) {
    super._callObserver(transaction, parentSubs);
    callTypeObservers(this, transaction, new YArrayEvent(this, transaction));
  }

  /**
   * Inserts new content at an index.
   *
   * Important: This function expects an array of content. Not just a content
   * object. The reason for this "weirdness" is that inserting several elements
   * is very efficient when it is done as a single operation.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  yarray.insert(0, ['a'])
   *  // Insert numbers 1, 2 at position 1
   *  yarray.insert(1, [1, 2])
   *
   * @param {number} index The index to insert content at.
   * @param {Array<T>} content The array of content
   */
  insert (index, content) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        typeListInsertGenerics(transaction, this, index, content);
      });
    } else {
      /** @type {Array<any>} */ (this._prelimContent).splice(index, 0, ...content);
    }
  }

  /**
   * Appends content to this YArray.
   *
   * @param {Array<T>} content Array of content to append.
   *
   * @todo Use the following implementation in all types.
   */
  push (content) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        typeListPushGenerics(transaction, this, content);
      });
    } else {
      /** @type {Array<any>} */ (this._prelimContent).push(...content);
    }
  }

  /**
   * Preppends content to this YArray.
   *
   * @param {Array<T>} content Array of content to preppend.
   */
  unshift (content) {
    this.insert(0, content);
  }

  /**
   * Deletes elements starting from an index.
   *
   * @param {number} index Index at which to start deleting elements
   * @param {number} length The number of elements to remove. Defaults to 1.
   */
  delete (index, length = 1) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        typeListDelete(transaction, this, index, length);
      });
    } else {
      /** @type {Array<any>} */ (this._prelimContent).splice(index, length);
    }
  }

  /**
   * Returns the i-th element from a YArray.
   *
   * @param {number} index The index of the element to return from the YArray
   * @return {T}
   */
  get (index) {
    return typeListGet(this, index)
  }

  /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @return {Array<T>}
   */
  toArray () {
    return typeListToArray(this)
  }

  /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @param {number} [start]
   * @param {number} [end]
   * @return {Array<T>}
   */
  slice (start = 0, end = this.length) {
    return typeListSlice(this, start, end)
  }

  /**
   * Transforms this Shared Type to a JSON object.
   *
   * @return {Array<any>}
   */
  toJSON () {
    return this.map(c => c instanceof AbstractType ? c.toJSON() : c)
  }

  /**
   * Returns an Array with the result of calling a provided function on every
   * element of this YArray.
   *
   * @template M
   * @param {function(T,number,YArray<T>):M} f Function that produces an element of the new Array
   * @return {Array<M>} A new array with each element being the result of the
   *                 callback function
   */
  map (f) {
    return typeListMap(this, /** @type {any} */ (f))
  }

  /**
   * Executes a provided function on once on overy element of this YArray.
   *
   * @param {function(T,number,YArray<T>):void} f A function to execute on every element of this YArray.
   */
  forEach (f) {
    typeListForEach(this, f);
  }

  /**
   * @return {IterableIterator<T>}
   */
  [Symbol.iterator] () {
    return typeListCreateIterator(this)
  }

  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  _write (encoder) {
    encoder.writeTypeRef(YArrayRefID);
  }
}

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 *
 * @private
 * @function
 */
const readYArray = decoder => new YArray();

/**
 * @template T
 * @extends YEvent<YMap<T>>
 * Event that describes the changes on a YMap.
 */
class YMapEvent extends YEvent {
  /**
   * @param {YMap<T>} ymap The YArray that changed.
   * @param {Transaction} transaction
   * @param {Set<any>} subs The keys that changed.
   */
  constructor (ymap, transaction, subs) {
    super(ymap, transaction);
    this.keysChanged = subs;
  }
}

/**
 * @template MapType
 * A shared Map implementation.
 *
 * @extends AbstractType<YMapEvent<MapType>>
 * @implements {Iterable<MapType>}
 */
class YMap extends AbstractType {
  /**
   *
   * @param {Iterable<readonly [string, any]>=} entries - an optional iterable to initialize the YMap
   */
  constructor (entries) {
    super();
    /**
     * @type {Map<string,any>?}
     * @private
     */
    this._prelimContent = null;

    if (entries === undefined) {
      this._prelimContent = new Map();
    } else {
      this._prelimContent = new Map(entries);
    }
  }

  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */
  _integrate (y, item) {
    super._integrate(y, item)
    ;/** @type {Map<string, any>} */ (this._prelimContent).forEach((value, key) => {
      this.set(key, value);
    });
    this._prelimContent = null;
  }

  _copy () {
    return new YMap()
  }

  /**
   * @return {YMap<MapType>}
   */
  clone () {
    const map = new YMap();
    this.forEach((value, key) => {
      map.set(key, value instanceof AbstractType ? value.clone() : value);
    });
    return map
  }

  /**
   * Creates YMapEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver (transaction, parentSubs) {
    callTypeObservers(this, transaction, new YMapEvent(this, transaction, parentSubs));
  }

  /**
   * Transforms this Shared Type to a JSON object.
   *
   * @return {Object<string,any>}
   */
  toJSON () {
    /**
     * @type {Object<string,MapType>}
     */
    const map = {};
    this._map.forEach((item, key) => {
      if (!item.deleted) {
        const v = item.content.getContent()[item.length - 1];
        map[key] = v instanceof AbstractType ? v.toJSON() : v;
      }
    });
    return map
  }

  /**
   * Returns the size of the YMap (count of key/value pairs)
   *
   * @return {number}
   */
  get size () {
    return [...createMapIterator(this._map)].length
  }

  /**
   * Returns the keys for each element in the YMap Type.
   *
   * @return {IterableIterator<string>}
   */
  keys () {
    return iterator__namespace.iteratorMap(createMapIterator(this._map), /** @param {any} v */ v => v[0])
  }

  /**
   * Returns the values for each element in the YMap Type.
   *
   * @return {IterableIterator<any>}
   */
  values () {
    return iterator__namespace.iteratorMap(createMapIterator(this._map), /** @param {any} v */ v => v[1].content.getContent()[v[1].length - 1])
  }

  /**
   * Returns an Iterator of [key, value] pairs
   *
   * @return {IterableIterator<any>}
   */
  entries () {
    return iterator__namespace.iteratorMap(createMapIterator(this._map), /** @param {any} v */ v => [v[0], v[1].content.getContent()[v[1].length - 1]])
  }

  /**
   * Executes a provided function on once on every key-value pair.
   *
   * @param {function(MapType,string,YMap<MapType>):void} f A function to execute on every element of this YArray.
   */
  forEach (f) {
    /**
     * @type {Object<string,MapType>}
     */
    const map = {};
    this._map.forEach((item, key) => {
      if (!item.deleted) {
        f(item.content.getContent()[item.length - 1], key, this);
      }
    });
    return map
  }

  /**
   * Returns an Iterator of [key, value] pairs
   *
   * @return {IterableIterator<any>}
   */
  [Symbol.iterator] () {
    return this.entries()
  }

  /**
   * Remove a specified element from this YMap.
   *
   * @param {string} key The key of the element to remove.
   */
  delete (key) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        typeMapDelete(transaction, this, key);
      });
    } else {
      /** @type {Map<string, any>} */ (this._prelimContent).delete(key);
    }
  }

  /**
   * Adds or updates an element with a specified key and value.
   *
   * @param {string} key The key of the element to add to this YMap
   * @param {MapType} value The value of the element to add
   */
  set (key, value) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        typeMapSet(transaction, this, key, value);
      });
    } else {
      /** @type {Map<string, any>} */ (this._prelimContent).set(key, value);
    }
    return value
  }

  /**
   * Returns a specified element from this YMap.
   *
   * @param {string} key
   * @return {MapType|undefined}
   */
  get (key) {
    return /** @type {any} */ (typeMapGet(this, key))
  }

  /**
   * Returns a boolean indicating whether the specified key exists or not.
   *
   * @param {string} key The key to test.
   * @return {boolean}
   */
  has (key) {
    return typeMapHas(this, key)
  }

  /**
   * Removes all elements from this YMap.
   */
  clear () {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        this.forEach(function (value, key, map) {
          typeMapDelete(transaction, map, key);
        });
      });
    } else {
      /** @type {Map<string, any>} */ (this._prelimContent).clear();
    }
  }

  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  _write (encoder) {
    encoder.writeTypeRef(YMapRefID);
  }
}

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 *
 * @private
 * @function
 */
const readYMap = decoder => new YMap();

/**
 * @param {any} a
 * @param {any} b
 * @return {boolean}
 */
const equalAttrs = (a, b) => a === b || (typeof a === 'object' && typeof b === 'object' && a && b && object__namespace.equalFlat(a, b));

class ItemTextListPosition {
  /**
   * @param {Item|null} left
   * @param {Item|null} right
   * @param {number} index
   * @param {Map<string,any>} currentAttributes
   */
  constructor (left, right, index, currentAttributes) {
    this.left = left;
    this.right = right;
    this.index = index;
    this.currentAttributes = currentAttributes;
  }

  /**
   * Only call this if you know that this.right is defined
   */
  forward () {
    if (this.right === null) {
      error__namespace.unexpectedCase();
    }
    switch (this.right.content.constructor) {
      case ContentFormat:
        if (!this.right.deleted) {
          updateCurrentAttributes(this.currentAttributes, /** @type {ContentFormat} */ (this.right.content));
        }
        break
      default:
        if (!this.right.deleted) {
          this.index += this.right.length;
        }
        break
    }
    this.left = this.right;
    this.right = this.right.right;
  }
}

/**
 * @param {Transaction} transaction
 * @param {ItemTextListPosition} pos
 * @param {number} count steps to move forward
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */
const findNextPosition = (transaction, pos, count) => {
  while (pos.right !== null && count > 0) {
    switch (pos.right.content.constructor) {
      case ContentFormat:
        if (!pos.right.deleted) {
          updateCurrentAttributes(pos.currentAttributes, /** @type {ContentFormat} */ (pos.right.content));
        }
        break
      default:
        if (!pos.right.deleted) {
          if (count < pos.right.length) {
            // split right
            getItemCleanStart(transaction, createID(pos.right.id.client, pos.right.id.clock + count));
          }
          pos.index += pos.right.length;
          count -= pos.right.length;
        }
        break
    }
    pos.left = pos.right;
    pos.right = pos.right.right;
    // pos.forward() - we don't forward because that would halve the performance because we already do the checks above
  }
  return pos
};

/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */
const findPosition = (transaction, parent, index) => {
  const currentAttributes = new Map();
  const marker = findMarker(parent, index);
  if (marker) {
    const pos = new ItemTextListPosition(marker.p.left, marker.p, marker.index, currentAttributes);
    return findNextPosition(transaction, pos, index - marker.index)
  } else {
    const pos = new ItemTextListPosition(null, parent._start, 0, currentAttributes);
    return findNextPosition(transaction, pos, index)
  }
};

/**
 * Negate applied formats
 *
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {Map<string,any>} negatedAttributes
 *
 * @private
 * @function
 */
const insertNegatedAttributes = (transaction, parent, currPos, negatedAttributes) => {
  // check if we really need to remove attributes
  while (
    currPos.right !== null && (
      currPos.right.deleted === true || (
        currPos.right.content.constructor === ContentFormat &&
        equalAttrs(negatedAttributes.get(/** @type {ContentFormat} */ (currPos.right.content).key), /** @type {ContentFormat} */ (currPos.right.content).value)
      )
    )
  ) {
    if (!currPos.right.deleted) {
      negatedAttributes.delete(/** @type {ContentFormat} */ (currPos.right.content).key);
    }
    currPos.forward();
  }
  const doc = transaction.doc;
  const ownClientId = doc.clientID;
  negatedAttributes.forEach((val, key) => {
    const left = currPos.left;
    const right = currPos.right;
    const nextFormat = new Item(createID(ownClientId, getState(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new ContentFormat(key, val));
    nextFormat.integrate(transaction, 0);
    currPos.right = nextFormat;
    currPos.forward();
  });
};

/**
 * @param {Map<string,any>} currentAttributes
 * @param {ContentFormat} format
 *
 * @private
 * @function
 */
const updateCurrentAttributes = (currentAttributes, format) => {
  const { key, value } = format;
  if (value === null) {
    currentAttributes.delete(key);
  } else {
    currentAttributes.set(key, value);
  }
};

/**
 * @param {ItemTextListPosition} currPos
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 */
const minimizeAttributeChanges = (currPos, attributes) => {
  // go right while attributes[right.key] === right.value (or right is deleted)
  while (true) {
    if (currPos.right === null) {
      break
    } else if (currPos.right.deleted || (currPos.right.content.constructor === ContentFormat && equalAttrs(attributes[(/** @type {ContentFormat} */ (currPos.right.content)).key] || null, /** @type {ContentFormat} */ (currPos.right.content).value))) ; else {
      break
    }
    currPos.forward();
  }
};

/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {Object<string,any>} attributes
 * @return {Map<string,any>}
 *
 * @private
 * @function
 **/
const insertAttributes = (transaction, parent, currPos, attributes) => {
  const doc = transaction.doc;
  const ownClientId = doc.clientID;
  const negatedAttributes = new Map();
  // insert format-start items
  for (const key in attributes) {
    const val = attributes[key];
    const currentVal = currPos.currentAttributes.get(key) || null;
    if (!equalAttrs(currentVal, val)) {
      // save negated attribute (set null if currentVal undefined)
      negatedAttributes.set(key, currentVal);
      const { left, right } = currPos;
      currPos.right = new Item(createID(ownClientId, getState(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new ContentFormat(key, val));
      currPos.right.integrate(transaction, 0);
      currPos.forward();
    }
  }
  return negatedAttributes
};

/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {string|object|AbstractType<any>} text
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 **/
const insertText = (transaction, parent, currPos, text, attributes) => {
  currPos.currentAttributes.forEach((val, key) => {
    if (attributes[key] === undefined) {
      attributes[key] = null;
    }
  });
  const doc = transaction.doc;
  const ownClientId = doc.clientID;
  minimizeAttributeChanges(currPos, attributes);
  const negatedAttributes = insertAttributes(transaction, parent, currPos, attributes);
  // insert content
  const content = text.constructor === String ? new ContentString(/** @type {string} */ (text)) : (text instanceof AbstractType ? new ContentType(text) : new ContentEmbed(text));
  let { left, right, index } = currPos;
  if (parent._searchMarker) {
    updateMarkerChanges(parent._searchMarker, currPos.index, content.getLength());
  }
  right = new Item(createID(ownClientId, getState(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, content);
  right.integrate(transaction, 0);
  currPos.right = right;
  currPos.index = index;
  currPos.forward();
  insertNegatedAttributes(transaction, parent, currPos, negatedAttributes);
};

/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {number} length
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 */
const formatText = (transaction, parent, currPos, length, attributes) => {
  const doc = transaction.doc;
  const ownClientId = doc.clientID;
  minimizeAttributeChanges(currPos, attributes);
  const negatedAttributes = insertAttributes(transaction, parent, currPos, attributes);
  // iterate until first non-format or null is found
  // delete all formats with attributes[format.key] != null
  // also check the attributes after the first non-format as we do not want to insert redundant negated attributes there
  while (currPos.right !== null && (length > 0 || currPos.right.content.constructor === ContentFormat)) {
    if (!currPos.right.deleted) {
      switch (currPos.right.content.constructor) {
        case ContentFormat: {
          const { key, value } = /** @type {ContentFormat} */ (currPos.right.content);
          const attr = attributes[key];
          if (attr !== undefined) {
            if (equalAttrs(attr, value)) {
              negatedAttributes.delete(key);
            } else {
              negatedAttributes.set(key, value);
            }
            currPos.right.delete(transaction);
          }
          break
        }
        default:
          if (length < currPos.right.length) {
            getItemCleanStart(transaction, createID(currPos.right.id.client, currPos.right.id.clock + length));
          }
          length -= currPos.right.length;
          break
      }
    }
    currPos.forward();
  }
  // Quill just assumes that the editor starts with a newline and that it always
  // ends with a newline. We only insert that newline when a new newline is
  // inserted - i.e when length is bigger than type.length
  if (length > 0) {
    let newlines = '';
    for (; length > 0; length--) {
      newlines += '\n';
    }
    currPos.right = new Item(createID(ownClientId, getState(doc.store, ownClientId)), currPos.left, currPos.left && currPos.left.lastId, currPos.right, currPos.right && currPos.right.id, parent, null, new ContentString(newlines));
    currPos.right.integrate(transaction, 0);
    currPos.forward();
  }
  insertNegatedAttributes(transaction, parent, currPos, negatedAttributes);
};

/**
 * Call this function after string content has been deleted in order to
 * clean up formatting Items.
 *
 * @param {Transaction} transaction
 * @param {Item} start
 * @param {Item|null} curr exclusive end, automatically iterates to the next Content Item
 * @param {Map<string,any>} startAttributes
 * @param {Map<string,any>} currAttributes
 * @return {number} The amount of formatting Items deleted.
 *
 * @function
 */
const cleanupFormattingGap = (transaction, start, curr, startAttributes, currAttributes) => {
  let end = curr;
  const endAttributes = map__namespace.copy(currAttributes);
  while (end && (!end.countable || end.deleted)) {
    if (!end.deleted && end.content.constructor === ContentFormat) {
      updateCurrentAttributes(endAttributes, /** @type {ContentFormat} */ (end.content));
    }
    end = end.right;
  }
  let cleanups = 0;
  let reachedEndOfCurr = false;
  while (start !== end) {
    if (curr === start) {
      reachedEndOfCurr = true;
    }
    if (!start.deleted) {
      const content = start.content;
      switch (content.constructor) {
        case ContentFormat: {
          const { key, value } = /** @type {ContentFormat} */ (content);
          if ((endAttributes.get(key) || null) !== value || (startAttributes.get(key) || null) === value) {
            // Either this format is overwritten or it is not necessary because the attribute already existed.
            start.delete(transaction);
            cleanups++;
            if (!reachedEndOfCurr && (currAttributes.get(key) || null) === value && (startAttributes.get(key) || null) !== value) {
              currAttributes.delete(key);
            }
          }
          break
        }
      }
    }
    start = /** @type {Item} */ (start.right);
  }
  return cleanups
};

/**
 * @param {Transaction} transaction
 * @param {Item | null} item
 */
const cleanupContextlessFormattingGap = (transaction, item) => {
  // iterate until item.right is null or content
  while (item && item.right && (item.right.deleted || !item.right.countable)) {
    item = item.right;
  }
  const attrs = new Set();
  // iterate back until a content item is found
  while (item && (item.deleted || !item.countable)) {
    if (!item.deleted && item.content.constructor === ContentFormat) {
      const key = /** @type {ContentFormat} */ (item.content).key;
      if (attrs.has(key)) {
        item.delete(transaction);
      } else {
        attrs.add(key);
      }
    }
    item = item.left;
  }
};

/**
 * This function is experimental and subject to change / be removed.
 *
 * Ideally, we don't need this function at all. Formatting attributes should be cleaned up
 * automatically after each change. This function iterates twice over the complete YText type
 * and removes unnecessary formatting attributes. This is also helpful for testing.
 *
 * This function won't be exported anymore as soon as there is confidence that the YText type works as intended.
 *
 * @param {YText} type
 * @return {number} How many formatting attributes have been cleaned up.
 */
const cleanupYTextFormatting = type => {
  let res = 0;
  transact(/** @type {Doc} */ (type.doc), transaction => {
    let start = /** @type {Item} */ (type._start);
    let end = type._start;
    let startAttributes = map__namespace.create();
    const currentAttributes = map__namespace.copy(startAttributes);
    while (end) {
      if (end.deleted === false) {
        switch (end.content.constructor) {
          case ContentFormat:
            updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ (end.content));
            break
          default:
            res += cleanupFormattingGap(transaction, start, end, startAttributes, currentAttributes);
            startAttributes = map__namespace.copy(currentAttributes);
            start = end;
            break
        }
      }
      end = end.right;
    }
  });
  return res
};

/**
 * @param {Transaction} transaction
 * @param {ItemTextListPosition} currPos
 * @param {number} length
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */
const deleteText = (transaction, currPos, length) => {
  const startLength = length;
  const startAttrs = map__namespace.copy(currPos.currentAttributes);
  const start = currPos.right;
  while (length > 0 && currPos.right !== null) {
    if (currPos.right.deleted === false) {
      switch (currPos.right.content.constructor) {
        case ContentType:
        case ContentEmbed:
        case ContentString:
          if (length < currPos.right.length) {
            getItemCleanStart(transaction, createID(currPos.right.id.client, currPos.right.id.clock + length));
          }
          length -= currPos.right.length;
          currPos.right.delete(transaction);
          break
      }
    }
    currPos.forward();
  }
  if (start) {
    cleanupFormattingGap(transaction, start, currPos.right, startAttrs, currPos.currentAttributes);
  }
  const parent = /** @type {AbstractType<any>} */ (/** @type {Item} */ (currPos.left || currPos.right).parent);
  if (parent._searchMarker) {
    updateMarkerChanges(parent._searchMarker, currPos.index, -startLength + length);
  }
  return currPos
};

/**
 * The Quill Delta format represents changes on a text document with
 * formatting information. For mor information visit {@link https://quilljs.com/docs/delta/|Quill Delta}
 *
 * @example
 *   {
 *     ops: [
 *       { insert: 'Gandalf', attributes: { bold: true } },
 *       { insert: ' the ' },
 *       { insert: 'Grey', attributes: { color: '#cccccc' } }
 *     ]
 *   }
 *
 */

/**
  * Attributes that can be assigned to a selection of text.
  *
  * @example
  *   {
  *     bold: true,
  *     font-size: '40px'
  *   }
  *
  * @typedef {Object} TextAttributes
  */

/**
 * @extends YEvent<YText>
 * Event that describes the changes on a YText type.
 */
class YTextEvent extends YEvent {
  /**
   * @param {YText} ytext
   * @param {Transaction} transaction
   * @param {Set<any>} subs The keys that changed
   */
  constructor (ytext, transaction, subs) {
    super(ytext, transaction);
    /**
     * Whether the children changed.
     * @type {Boolean}
     * @private
     */
    this.childListChanged = false;
    /**
     * Set of all changed attributes.
     * @type {Set<string>}
     */
    this.keysChanged = new Set();
    subs.forEach((sub) => {
      if (sub === null) {
        this.childListChanged = true;
      } else {
        this.keysChanged.add(sub);
      }
    });
  }

  /**
   * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
   */
  get changes () {
    if (this._changes === null) {
      /**
       * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string|AbstractType<any>|object, delete?:number, retain?:number}>}}
       */
      const changes = {
        keys: this.keys,
        delta: this.delta,
        added: new Set(),
        deleted: new Set()
      };
      this._changes = changes;
    }
    return /** @type {any} */ (this._changes)
  }

  /**
   * Compute the changes in the delta format.
   * A {@link https://quilljs.com/docs/delta/|Quill Delta}) that represents the changes on the document.
   *
   * @type {Array<{insert?:string|object|AbstractType<any>, delete?:number, retain?:number, attributes?: Object<string,any>}>}
   *
   * @public
   */
  get delta () {
    if (this._delta === null) {
      const y = /** @type {Doc} */ (this.target.doc);
      /**
       * @type {Array<{insert?:string|object|AbstractType<any>, delete?:number, retain?:number, attributes?: Object<string,any>}>}
       */
      const delta = [];
      transact(y, transaction => {
        const currentAttributes = new Map(); // saves all current attributes for insert
        const oldAttributes = new Map();
        let item = this.target._start;
        /**
         * @type {string?}
         */
        let action = null;
        /**
         * @type {Object<string,any>}
         */
        const attributes = {}; // counts added or removed new attributes for retain
        /**
         * @type {string|object}
         */
        let insert = '';
        let retain = 0;
        let deleteLen = 0;
        const addOp = () => {
          if (action !== null) {
            /**
             * @type {any}
             */
            let op;
            switch (action) {
              case 'delete':
                op = { delete: deleteLen };
                deleteLen = 0;
                break
              case 'insert':
                op = { insert };
                if (currentAttributes.size > 0) {
                  op.attributes = {};
                  currentAttributes.forEach((value, key) => {
                    if (value !== null) {
                      op.attributes[key] = value;
                    }
                  });
                }
                insert = '';
                break
              case 'retain':
                op = { retain };
                if (Object.keys(attributes).length > 0) {
                  op.attributes = {};
                  for (const key in attributes) {
                    op.attributes[key] = attributes[key];
                  }
                }
                retain = 0;
                break
            }
            delta.push(op);
            action = null;
          }
        };
        while (item !== null) {
          switch (item.content.constructor) {
            case ContentType:
            case ContentEmbed:
              if (this.adds(item)) {
                if (!this.deletes(item)) {
                  addOp();
                  action = 'insert';
                  insert = item.content.getContent()[0];
                  addOp();
                }
              } else if (this.deletes(item)) {
                if (action !== 'delete') {
                  addOp();
                  action = 'delete';
                }
                deleteLen += 1;
              } else if (!item.deleted) {
                if (action !== 'retain') {
                  addOp();
                  action = 'retain';
                }
                retain += 1;
              }
              break
            case ContentString:
              if (this.adds(item)) {
                if (!this.deletes(item)) {
                  if (action !== 'insert') {
                    addOp();
                    action = 'insert';
                  }
                  insert += /** @type {ContentString} */ (item.content).str;
                }
              } else if (this.deletes(item)) {
                if (action !== 'delete') {
                  addOp();
                  action = 'delete';
                }
                deleteLen += item.length;
              } else if (!item.deleted) {
                if (action !== 'retain') {
                  addOp();
                  action = 'retain';
                }
                retain += item.length;
              }
              break
            case ContentFormat: {
              const { key, value } = /** @type {ContentFormat} */ (item.content);
              if (this.adds(item)) {
                if (!this.deletes(item)) {
                  const curVal = currentAttributes.get(key) || null;
                  if (!equalAttrs(curVal, value)) {
                    if (action === 'retain') {
                      addOp();
                    }
                    if (equalAttrs(value, (oldAttributes.get(key) || null))) {
                      delete attributes[key];
                    } else {
                      attributes[key] = value;
                    }
                  } else if (value !== null) {
                    item.delete(transaction);
                  }
                }
              } else if (this.deletes(item)) {
                oldAttributes.set(key, value);
                const curVal = currentAttributes.get(key) || null;
                if (!equalAttrs(curVal, value)) {
                  if (action === 'retain') {
                    addOp();
                  }
                  attributes[key] = curVal;
                }
              } else if (!item.deleted) {
                oldAttributes.set(key, value);
                const attr = attributes[key];
                if (attr !== undefined) {
                  if (!equalAttrs(attr, value)) {
                    if (action === 'retain') {
                      addOp();
                    }
                    if (value === null) {
                      delete attributes[key];
                    } else {
                      attributes[key] = value;
                    }
                  } else if (attr !== null) { // this will be cleaned up automatically by the contextless cleanup function
                    item.delete(transaction);
                  }
                }
              }
              if (!item.deleted) {
                if (action === 'insert') {
                  addOp();
                }
                updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ (item.content));
              }
              break
            }
          }
          item = item.right;
        }
        addOp();
        while (delta.length > 0) {
          const lastOp = delta[delta.length - 1];
          if (lastOp.retain !== undefined && lastOp.attributes === undefined) {
            // retain delta's if they don't assign attributes
            delta.pop();
          } else {
            break
          }
        }
      });
      this._delta = delta;
    }
    return /** @type {any} */ (this._delta)
  }
}

/**
 * Type that represents text with formatting information.
 *
 * This type replaces y-richtext as this implementation is able to handle
 * block formats (format information on a paragraph), embeds (complex elements
 * like pictures and videos), and text formats (**bold**, *italic*).
 *
 * @extends AbstractType<YTextEvent>
 */
class YText extends AbstractType {
  /**
   * @param {String} [string] The initial value of the YText.
   */
  constructor (string) {
    super();
    /**
     * Array of pending operations on this type
     * @type {Array<function():void>?}
     */
    this._pending = string !== undefined ? [() => this.insert(0, string)] : [];
    /**
     * @type {Array<ArraySearchMarker>}
     */
    this._searchMarker = [];
  }

  /**
   * Number of characters of this text type.
   *
   * @type {number}
   */
  get length () {
    return this._length
  }

  /**
   * @param {Doc} y
   * @param {Item} item
   */
  _integrate (y, item) {
    super._integrate(y, item);
    try {
      /** @type {Array<function>} */ (this._pending).forEach(f => f());
    } catch (e) {
      console.error(e);
    }
    this._pending = null;
  }

  _copy () {
    return new YText()
  }

  /**
   * @return {YText}
   */
  clone () {
    const text = new YText();
    text.applyDelta(this.toDelta());
    return text
  }

  /**
   * Creates YTextEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver (transaction, parentSubs) {
    super._callObserver(transaction, parentSubs);
    const event = new YTextEvent(this, transaction, parentSubs);
    const doc = transaction.doc;
    callTypeObservers(this, transaction, event);
    // If a remote change happened, we try to cleanup potential formatting duplicates.
    if (!transaction.local) {
      // check if another formatting item was inserted
      let foundFormattingItem = false;
      for (const [client, afterClock] of transaction.afterState.entries()) {
        const clock = transaction.beforeState.get(client) || 0;
        if (afterClock === clock) {
          continue
        }
        iterateStructs(transaction, /** @type {Array<Item|GC>} */ (doc.store.clients.get(client)), clock, afterClock, item => {
          if (!item.deleted && /** @type {Item} */ (item).content.constructor === ContentFormat) {
            foundFormattingItem = true;
          }
        });
        if (foundFormattingItem) {
          break
        }
      }
      if (!foundFormattingItem) {
        iterateDeletedStructs(transaction, transaction.deleteSet, item => {
          if (item instanceof GC || foundFormattingItem) {
            return
          }
          if (item.parent === this && item.content.constructor === ContentFormat) {
            foundFormattingItem = true;
          }
        });
      }
      transact(doc, (t) => {
        if (foundFormattingItem) {
          // If a formatting item was inserted, we simply clean the whole type.
          // We need to compute currentAttributes for the current position anyway.
          cleanupYTextFormatting(this);
        } else {
          // If no formatting attribute was inserted, we can make due with contextless
          // formatting cleanups.
          // Contextless: it is not necessary to compute currentAttributes for the affected position.
          iterateDeletedStructs(t, t.deleteSet, item => {
            if (item instanceof GC) {
              return
            }
            if (item.parent === this) {
              cleanupContextlessFormattingGap(t, item);
            }
          });
        }
      });
    }
  }

  /**
   * Returns the unformatted string representation of this YText type.
   *
   * @public
   */
  toString () {
    let str = '';
    /**
     * @type {Item|null}
     */
    let n = this._start;
    while (n !== null) {
      if (!n.deleted && n.countable && n.content.constructor === ContentString) {
        str += /** @type {ContentString} */ (n.content).str;
      }
      n = n.right;
    }
    return str
  }

  /**
   * Returns the unformatted string representation of this YText type.
   *
   * @return {string}
   * @public
   */
  toJSON () {
    return this.toString()
  }

  /**
   * Apply a {@link Delta} on this shared YText type.
   *
   * @param {any} delta The changes to apply on this element.
   * @param {object}  [opts]
   * @param {boolean} [opts.sanitize] Sanitize input delta. Removes ending newlines if set to true.
   *
   *
   * @public
   */
  applyDelta (delta, { sanitize = true } = {}) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        const currPos = new ItemTextListPosition(null, this._start, 0, new Map());
        for (let i = 0; i < delta.length; i++) {
          const op = delta[i];
          if (op.insert !== undefined) {
            // Quill assumes that the content starts with an empty paragraph.
            // Yjs/Y.Text assumes that it starts empty. We always hide that
            // there is a newline at the end of the content.
            // If we omit this step, clients will see a different number of
            // paragraphs, but nothing bad will happen.
            const ins = (!sanitize && typeof op.insert === 'string' && i === delta.length - 1 && currPos.right === null && op.insert.slice(-1) === '\n') ? op.insert.slice(0, -1) : op.insert;
            if (typeof ins !== 'string' || ins.length > 0) {
              insertText(transaction, this, currPos, ins, op.attributes || {});
            }
          } else if (op.retain !== undefined) {
            formatText(transaction, this, currPos, op.retain, op.attributes || {});
          } else if (op.delete !== undefined) {
            deleteText(transaction, currPos, op.delete);
          }
        }
      });
    } else {
      /** @type {Array<function>} */ (this._pending).push(() => this.applyDelta(delta));
    }
  }

  /**
   * Returns the Delta representation of this YText type.
   *
   * @param {Snapshot} [snapshot]
   * @param {Snapshot} [prevSnapshot]
   * @param {function('removed' | 'added', ID):any} [computeYChange]
   * @return {any} The Delta representation of this type.
   *
   * @public
   */
  toDelta (snapshot, prevSnapshot, computeYChange) {
    /**
     * @type{Array<any>}
     */
    const ops = [];
    const currentAttributes = new Map();
    const doc = /** @type {Doc} */ (this.doc);
    let str = '';
    let n = this._start;
    function packStr () {
      if (str.length > 0) {
        // pack str with attributes to ops
        /**
         * @type {Object<string,any>}
         */
        const attributes = {};
        let addAttributes = false;
        currentAttributes.forEach((value, key) => {
          addAttributes = true;
          attributes[key] = value;
        });
        /**
         * @type {Object<string,any>}
         */
        const op = { insert: str };
        if (addAttributes) {
          op.attributes = attributes;
        }
        ops.push(op);
        str = '';
      }
    }
    // snapshots are merged again after the transaction, so we need to keep the
    // transalive until we are done
    transact(doc, transaction => {
      if (snapshot) {
        splitSnapshotAffectedStructs(transaction, snapshot);
      }
      if (prevSnapshot) {
        splitSnapshotAffectedStructs(transaction, prevSnapshot);
      }
      while (n !== null) {
        if (isVisible(n, snapshot) || (prevSnapshot !== undefined && isVisible(n, prevSnapshot))) {
          switch (n.content.constructor) {
            case ContentString: {
              const cur = currentAttributes.get('ychange');
              if (snapshot !== undefined && !isVisible(n, snapshot)) {
                if (cur === undefined || cur.user !== n.id.client || cur.state !== 'removed') {
                  packStr();
                  currentAttributes.set('ychange', computeYChange ? computeYChange('removed', n.id) : { type: 'removed' });
                }
              } else if (prevSnapshot !== undefined && !isVisible(n, prevSnapshot)) {
                if (cur === undefined || cur.user !== n.id.client || cur.state !== 'added') {
                  packStr();
                  currentAttributes.set('ychange', computeYChange ? computeYChange('added', n.id) : { type: 'added' });
                }
              } else if (cur !== undefined) {
                packStr();
                currentAttributes.delete('ychange');
              }
              str += /** @type {ContentString} */ (n.content).str;
              break
            }
            case ContentType:
            case ContentEmbed: {
              packStr();
              /**
               * @type {Object<string,any>}
               */
              const op = {
                insert: n.content.getContent()[0]
              };
              if (currentAttributes.size > 0) {
                const attrs = /** @type {Object<string,any>} */ ({});
                op.attributes = attrs;
                currentAttributes.forEach((value, key) => {
                  attrs[key] = value;
                });
              }
              ops.push(op);
              break
            }
            case ContentFormat:
              if (isVisible(n, snapshot)) {
                packStr();
                updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ (n.content));
              }
              break
          }
        }
        n = n.right;
      }
      packStr();
    }, splitSnapshotAffectedStructs);
    return ops
  }

  /**
   * Insert text at a given index.
   *
   * @param {number} index The index at which to start inserting.
   * @param {String} text The text to insert at the specified position.
   * @param {TextAttributes} [attributes] Optionally define some formatting
   *                                    information to apply on the inserted
   *                                    Text.
   * @public
   */
  insert (index, text, attributes) {
    if (text.length <= 0) {
      return
    }
    const y = this.doc;
    if (y !== null) {
      transact(y, transaction => {
        const pos = findPosition(transaction, this, index);
        if (!attributes) {
          attributes = {};
          // @ts-ignore
          pos.currentAttributes.forEach((v, k) => { attributes[k] = v; });
        }
        insertText(transaction, this, pos, text, attributes);
      });
    } else {
      /** @type {Array<function>} */ (this._pending).push(() => this.insert(index, text, attributes));
    }
  }

  /**
   * Inserts an embed at a index.
   *
   * @param {number} index The index to insert the embed at.
   * @param {Object | AbstractType<any>} embed The Object that represents the embed.
   * @param {TextAttributes} attributes Attribute information to apply on the
   *                                    embed
   *
   * @public
   */
  insertEmbed (index, embed, attributes = {}) {
    const y = this.doc;
    if (y !== null) {
      transact(y, transaction => {
        const pos = findPosition(transaction, this, index);
        insertText(transaction, this, pos, embed, attributes);
      });
    } else {
      /** @type {Array<function>} */ (this._pending).push(() => this.insertEmbed(index, embed, attributes));
    }
  }

  /**
   * Deletes text starting from an index.
   *
   * @param {number} index Index at which to start deleting.
   * @param {number} length The number of characters to remove. Defaults to 1.
   *
   * @public
   */
  delete (index, length) {
    if (length === 0) {
      return
    }
    const y = this.doc;
    if (y !== null) {
      transact(y, transaction => {
        deleteText(transaction, findPosition(transaction, this, index), length);
      });
    } else {
      /** @type {Array<function>} */ (this._pending).push(() => this.delete(index, length));
    }
  }

  /**
   * Assigns properties to a range of text.
   *
   * @param {number} index The position where to start formatting.
   * @param {number} length The amount of characters to assign properties to.
   * @param {TextAttributes} attributes Attribute information to apply on the
   *                                    text.
   *
   * @public
   */
  format (index, length, attributes) {
    if (length === 0) {
      return
    }
    const y = this.doc;
    if (y !== null) {
      transact(y, transaction => {
        const pos = findPosition(transaction, this, index);
        if (pos.right === null) {
          return
        }
        formatText(transaction, this, pos, length, attributes);
      });
    } else {
      /** @type {Array<function>} */ (this._pending).push(() => this.format(index, length, attributes));
    }
  }

  /**
   * Removes an attribute.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that is to be removed.
   *
   * @public
   */
  removeAttribute (attributeName) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        typeMapDelete(transaction, this, attributeName);
      });
    } else {
      /** @type {Array<function>} */ (this._pending).push(() => this.removeAttribute(attributeName));
    }
  }

  /**
   * Sets or updates an attribute.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that is to be set.
   * @param {any} attributeValue The attribute value that is to be set.
   *
   * @public
   */
  setAttribute (attributeName, attributeValue) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        typeMapSet(transaction, this, attributeName, attributeValue);
      });
    } else {
      /** @type {Array<function>} */ (this._pending).push(() => this.setAttribute(attributeName, attributeValue));
    }
  }

  /**
   * Returns an attribute value that belongs to the attribute name.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that identifies the
   *                               queried value.
   * @return {any} The queried attribute value.
   *
   * @public
   */
  getAttribute (attributeName) {
    return /** @type {any} */ (typeMapGet(this, attributeName))
  }

  /**
   * Returns all attribute name/value pairs in a JSON Object.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {Snapshot} [snapshot]
   * @return {Object<string, any>} A JSON Object that describes the attributes.
   *
   * @public
   */
  getAttributes (snapshot) {
    return typeMapGetAll(this)
  }

  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  _write (encoder) {
    encoder.writeTypeRef(YTextRefID);
  }
}

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YText}
 *
 * @private
 * @function
 */
const readYText = decoder => new YText();

/**
 * @module YXml
 */

/**
 * Define the elements to which a set of CSS queries apply.
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Selectors|CSS_Selectors}
 *
 * @example
 *   query = '.classSelector'
 *   query = 'nodeSelector'
 *   query = '#idSelector'
 *
 * @typedef {string} CSS_Selector
 */

/**
 * Dom filter function.
 *
 * @callback domFilter
 * @param {string} nodeName The nodeName of the element
 * @param {Map} attributes The map of attributes.
 * @return {boolean} Whether to include the Dom node in the YXmlElement.
 */

/**
 * Represents a subset of the nodes of a YXmlElement / YXmlFragment and a
 * position within them.
 *
 * Can be created with {@link YXmlFragment#createTreeWalker}
 *
 * @public
 * @implements {Iterable<YXmlElement|YXmlText|YXmlElement|YXmlHook>}
 */
class YXmlTreeWalker {
  /**
   * @param {YXmlFragment | YXmlElement} root
   * @param {function(AbstractType<any>):boolean} [f]
   */
  constructor (root, f = () => true) {
    this._filter = f;
    this._root = root;
    /**
     * @type {Item}
     */
    this._currentNode = /** @type {Item} */ (root._start);
    this._firstCall = true;
  }

  [Symbol.iterator] () {
    return this
  }

  /**
   * Get the next node.
   *
   * @return {IteratorResult<YXmlElement|YXmlText|YXmlHook>} The next node.
   *
   * @public
   */
  next () {
    /**
     * @type {Item|null}
     */
    let n = this._currentNode;
    let type = n && n.content && /** @type {any} */ (n.content).type;
    if (n !== null && (!this._firstCall || n.deleted || !this._filter(type))) { // if first call, we check if we can use the first item
      do {
        type = /** @type {any} */ (n.content).type;
        if (!n.deleted && (type.constructor === YXmlElement || type.constructor === YXmlFragment) && type._start !== null) {
          // walk down in the tree
          n = type._start;
        } else {
          // walk right or up in the tree
          while (n !== null) {
            if (n.right !== null) {
              n = n.right;
              break
            } else if (n.parent === this._root) {
              n = null;
            } else {
              n = /** @type {AbstractType<any>} */ (n.parent)._item;
            }
          }
        }
      } while (n !== null && (n.deleted || !this._filter(/** @type {ContentType} */ (n.content).type)))
    }
    this._firstCall = false;
    if (n === null) {
      // @ts-ignore
      return { value: undefined, done: true }
    }
    this._currentNode = n;
    return { value: /** @type {any} */ (n.content).type, done: false }
  }
}

/**
 * Represents a list of {@link YXmlElement}.and {@link YXmlText} types.
 * A YxmlFragment is similar to a {@link YXmlElement}, but it does not have a
 * nodeName and it does not have attributes. Though it can be bound to a DOM
 * element - in this case the attributes and the nodeName are not shared.
 *
 * @public
 * @extends AbstractType<YXmlEvent>
 */
class YXmlFragment extends AbstractType {
  constructor () {
    super();
    /**
     * @type {Array<any>|null}
     */
    this._prelimContent = [];
  }

  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get firstChild () {
    const first = this._first;
    return first ? first.content.getContent()[0] : null
  }

  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */
  _integrate (y, item) {
    super._integrate(y, item);
    this.insert(0, /** @type {Array<any>} */ (this._prelimContent));
    this._prelimContent = null;
  }

  _copy () {
    return new YXmlFragment()
  }

  /**
   * @return {YXmlFragment}
   */
  clone () {
    const el = new YXmlFragment();
    // @ts-ignore
    el.insert(0, this.toArray().map(item => item instanceof AbstractType ? item.clone() : item));
    return el
  }

  get length () {
    return this._prelimContent === null ? this._length : this._prelimContent.length
  }

  /**
   * Create a subtree of childNodes.
   *
   * @example
   * const walker = elem.createTreeWalker(dom => dom.nodeName === 'div')
   * for (let node in walker) {
   *   // `node` is a div node
   *   nop(node)
   * }
   *
   * @param {function(AbstractType<any>):boolean} filter Function that is called on each child element and
   *                          returns a Boolean indicating whether the child
   *                          is to be included in the subtree.
   * @return {YXmlTreeWalker} A subtree and a position within it.
   *
   * @public
   */
  createTreeWalker (filter) {
    return new YXmlTreeWalker(this, filter)
  }

  /**
   * Returns the first YXmlElement that matches the query.
   * Similar to DOM's {@link querySelector}.
   *
   * Query support:
   *   - tagname
   * TODO:
   *   - id
   *   - attribute
   *
   * @param {CSS_Selector} query The query on the children.
   * @return {YXmlElement|YXmlText|YXmlHook|null} The first element that matches the query or null.
   *
   * @public
   */
  querySelector (query) {
    query = query.toUpperCase();
    // @ts-ignore
    const iterator = new YXmlTreeWalker(this, element => element.nodeName && element.nodeName.toUpperCase() === query);
    const next = iterator.next();
    if (next.done) {
      return null
    } else {
      return next.value
    }
  }

  /**
   * Returns all YXmlElements that match the query.
   * Similar to Dom's {@link querySelectorAll}.
   *
   * @todo Does not yet support all queries. Currently only query by tagName.
   *
   * @param {CSS_Selector} query The query on the children
   * @return {Array<YXmlElement|YXmlText|YXmlHook|null>} The elements that match this query.
   *
   * @public
   */
  querySelectorAll (query) {
    query = query.toUpperCase();
    // @ts-ignore
    return Array.from(new YXmlTreeWalker(this, element => element.nodeName && element.nodeName.toUpperCase() === query))
  }

  /**
   * Creates YXmlEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver (transaction, parentSubs) {
    callTypeObservers(this, transaction, new YXmlEvent(this, parentSubs, transaction));
  }

  /**
   * Get the string representation of all the children of this YXmlFragment.
   *
   * @return {string} The string representation of all children.
   */
  toString () {
    return typeListMap(this, xml => xml.toString()).join('')
  }

  /**
   * @return {string}
   */
  toJSON () {
    return this.toString()
  }

  /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */
  toDOM (_document = document, hooks = {}, binding) {
    const fragment = _document.createDocumentFragment();
    if (binding !== undefined) {
      binding._createAssociation(fragment, this);
    }
    typeListForEach(this, xmlType => {
      fragment.insertBefore(xmlType.toDOM(_document, hooks, binding), null);
    });
    return fragment
  }

  /**
   * Inserts new content at an index.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  xml.insert(0, [new Y.XmlText('text')])
   *
   * @param {number} index The index to insert content at
   * @param {Array<YXmlElement|YXmlText>} content The array of content
   */
  insert (index, content) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        typeListInsertGenerics(transaction, this, index, content);
      });
    } else {
      // @ts-ignore _prelimContent is defined because this is not yet integrated
      this._prelimContent.splice(index, 0, ...content);
    }
  }

  /**
   * Inserts new content at an index.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  xml.insert(0, [new Y.XmlText('text')])
   *
   * @param {null|Item|YXmlElement|YXmlText} ref The index to insert content at
   * @param {Array<YXmlElement|YXmlText>} content The array of content
   */
  insertAfter (ref, content) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        const refItem = (ref && ref instanceof AbstractType) ? ref._item : ref;
        typeListInsertGenericsAfter(transaction, this, refItem, content);
      });
    } else {
      const pc = /** @type {Array<any>} */ (this._prelimContent);
      const index = ref === null ? 0 : pc.findIndex(el => el === ref) + 1;
      if (index === 0 && ref !== null) {
        throw error__namespace.create('Reference item not found')
      }
      pc.splice(index, 0, ...content);
    }
  }

  /**
   * Deletes elements starting from an index.
   *
   * @param {number} index Index at which to start deleting elements
   * @param {number} [length=1] The number of elements to remove. Defaults to 1.
   */
  delete (index, length = 1) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        typeListDelete(transaction, this, index, length);
      });
    } else {
      // @ts-ignore _prelimContent is defined because this is not yet integrated
      this._prelimContent.splice(index, length);
    }
  }

  /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @return {Array<YXmlElement|YXmlText|YXmlHook>}
   */
  toArray () {
    return typeListToArray(this)
  }

  /**
   * Appends content to this YArray.
   *
   * @param {Array<YXmlElement|YXmlText>} content Array of content to append.
   */
  push (content) {
    this.insert(this.length, content);
  }

  /**
   * Preppends content to this YArray.
   *
   * @param {Array<YXmlElement|YXmlText>} content Array of content to preppend.
   */
  unshift (content) {
    this.insert(0, content);
  }

  /**
   * Returns the i-th element from a YArray.
   *
   * @param {number} index The index of the element to return from the YArray
   * @return {YXmlElement|YXmlText}
   */
  get (index) {
    return typeListGet(this, index)
  }

  /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @param {number} [start]
   * @param {number} [end]
   * @return {Array<YXmlElement|YXmlText>}
   */
  slice (start = 0, end = this.length) {
    return typeListSlice(this, start, end)
  }

  /**
   * Executes a provided function on once on overy child element.
   *
   * @param {function(YXmlElement|YXmlText,number, typeof this):void} f A function to execute on every element of this YArray.
   */
  forEach (f) {
    typeListForEach(this, f);
  }

  /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */
  _write (encoder) {
    encoder.writeTypeRef(YXmlFragmentRefID);
  }
}

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlFragment}
 *
 * @private
 * @function
 */
const readYXmlFragment = decoder => new YXmlFragment();

/**
 * An YXmlElement imitates the behavior of a
 * {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}.
 *
 * * An YXmlElement has attributes (key value pairs)
 * * An YXmlElement has childElements that must inherit from YXmlElement
 */
class YXmlElement extends YXmlFragment {
  constructor (nodeName = 'UNDEFINED') {
    super();
    this.nodeName = nodeName;
    /**
     * @type {Map<string, any>|null}
     */
    this._prelimAttrs = new Map();
  }

  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get nextSibling () {
    const n = this._item ? this._item.next : null;
    return n ? /** @type {YXmlElement|YXmlText} */ (/** @type {ContentType} */ (n.content).type) : null
  }

  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get prevSibling () {
    const n = this._item ? this._item.prev : null;
    return n ? /** @type {YXmlElement|YXmlText} */ (/** @type {ContentType} */ (n.content).type) : null
  }

  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */
  _integrate (y, item) {
    super._integrate(y, item)
    ;(/** @type {Map<string, any>} */ (this._prelimAttrs)).forEach((value, key) => {
      this.setAttribute(key, value);
    });
    this._prelimAttrs = null;
  }

  /**
   * Creates an Item with the same effect as this Item (without position effect)
   *
   * @return {YXmlElement}
   */
  _copy () {
    return new YXmlElement(this.nodeName)
  }

  /**
   * @return {YXmlElement}
   */
  clone () {
    const el = new YXmlElement(this.nodeName);
    const attrs = this.getAttributes();
    for (const key in attrs) {
      el.setAttribute(key, attrs[key]);
    }
    // @ts-ignore
    el.insert(0, this.toArray().map(item => item instanceof AbstractType ? item.clone() : item));
    return el
  }

  /**
   * Returns the XML serialization of this YXmlElement.
   * The attributes are ordered by attribute-name, so you can easily use this
   * method to compare YXmlElements
   *
   * @return {string} The string representation of this type.
   *
   * @public
   */
  toString () {
    const attrs = this.getAttributes();
    const stringBuilder = [];
    const keys = [];
    for (const key in attrs) {
      keys.push(key);
    }
    keys.sort();
    const keysLen = keys.length;
    for (let i = 0; i < keysLen; i++) {
      const key = keys[i];
      stringBuilder.push(key + '="' + attrs[key] + '"');
    }
    const nodeName = this.nodeName.toLocaleLowerCase();
    const attrsString = stringBuilder.length > 0 ? ' ' + stringBuilder.join(' ') : '';
    return `<${nodeName}${attrsString}>${super.toString()}</${nodeName}>`
  }

  /**
   * Removes an attribute from this YXmlElement.
   *
   * @param {String} attributeName The attribute name that is to be removed.
   *
   * @public
   */
  removeAttribute (attributeName) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        typeMapDelete(transaction, this, attributeName);
      });
    } else {
      /** @type {Map<string,any>} */ (this._prelimAttrs).delete(attributeName);
    }
  }

  /**
   * Sets or updates an attribute.
   *
   * @param {String} attributeName The attribute name that is to be set.
   * @param {String} attributeValue The attribute value that is to be set.
   *
   * @public
   */
  setAttribute (attributeName, attributeValue) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        typeMapSet(transaction, this, attributeName, attributeValue);
      });
    } else {
      /** @type {Map<string, any>} */ (this._prelimAttrs).set(attributeName, attributeValue);
    }
  }

  /**
   * Returns an attribute value that belongs to the attribute name.
   *
   * @param {String} attributeName The attribute name that identifies the
   *                               queried value.
   * @return {String} The queried attribute value.
   *
   * @public
   */
  getAttribute (attributeName) {
    return /** @type {any} */ (typeMapGet(this, attributeName))
  }

  /**
   * Returns whether an attribute exists
   *
   * @param {String} attributeName The attribute name to check for existence.
   * @return {boolean} whether the attribute exists.
   *
   * @public
   */
  hasAttribute (attributeName) {
    return /** @type {any} */ (typeMapHas(this, attributeName))
  }

  /**
   * Returns all attribute name/value pairs in a JSON Object.
   *
   * @param {Snapshot} [snapshot]
   * @return {Object<string, any>} A JSON Object that describes the attributes.
   *
   * @public
   */
  getAttributes (snapshot) {
    return typeMapGetAll(this)
  }

  /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */
  toDOM (_document = document, hooks = {}, binding) {
    const dom = _document.createElement(this.nodeName);
    const attrs = this.getAttributes();
    for (const key in attrs) {
      dom.setAttribute(key, attrs[key]);
    }
    typeListForEach(this, yxml => {
      dom.appendChild(yxml.toDOM(_document, hooks, binding));
    });
    if (binding !== undefined) {
      binding._createAssociation(dom, this);
    }
    return dom
  }

  /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */
  _write (encoder) {
    encoder.writeTypeRef(YXmlElementRefID);
    encoder.writeKey(this.nodeName);
  }
}

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlElement}
 *
 * @function
 */
const readYXmlElement = decoder => new YXmlElement(decoder.readKey());

/**
 * @extends YEvent<YXmlElement|YXmlText|YXmlFragment>
 * An Event that describes changes on a YXml Element or Yxml Fragment
 */
class YXmlEvent extends YEvent {
  /**
   * @param {YXmlElement|YXmlText|YXmlFragment} target The target on which the event is created.
   * @param {Set<string|null>} subs The set of changed attributes. `null` is included if the
   *                   child list changed.
   * @param {Transaction} transaction The transaction instance with wich the
   *                                  change was created.
   */
  constructor (target, subs, transaction) {
    super(target, transaction);
    /**
     * Whether the children changed.
     * @type {Boolean}
     * @private
     */
    this.childListChanged = false;
    /**
     * Set of all changed attributes.
     * @type {Set<string>}
     */
    this.attributesChanged = new Set();
    subs.forEach((sub) => {
      if (sub === null) {
        this.childListChanged = true;
      } else {
        this.attributesChanged.add(sub);
      }
    });
  }
}

/**
 * You can manage binding to a custom type with YXmlHook.
 *
 * @extends {YMap<any>}
 */
class YXmlHook extends YMap {
  /**
   * @param {string} hookName nodeName of the Dom Node.
   */
  constructor (hookName) {
    super();
    /**
     * @type {string}
     */
    this.hookName = hookName;
  }

  /**
   * Creates an Item with the same effect as this Item (without position effect)
   */
  _copy () {
    return new YXmlHook(this.hookName)
  }

  /**
   * @return {YXmlHook}
   */
  clone () {
    const el = new YXmlHook(this.hookName);
    this.forEach((value, key) => {
      el.set(key, value);
    });
    return el
  }

  /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object.<string, any>} [hooks] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type
   * @return {Element} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */
  toDOM (_document = document, hooks = {}, binding) {
    const hook = hooks[this.hookName];
    let dom;
    if (hook !== undefined) {
      dom = hook.createDom(this);
    } else {
      dom = document.createElement(this.hookName);
    }
    dom.setAttribute('data-yjs-hook', this.hookName);
    if (binding !== undefined) {
      binding._createAssociation(dom, this);
    }
    return dom
  }

  /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */
  _write (encoder) {
    encoder.writeTypeRef(YXmlHookRefID);
    encoder.writeKey(this.hookName);
  }
}

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlHook}
 *
 * @private
 * @function
 */
const readYXmlHook = decoder =>
  new YXmlHook(decoder.readKey());

/**
 * Represents text in a Dom Element. In the future this type will also handle
 * simple formatting information like bold and italic.
 */
class YXmlText extends YText {
  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get nextSibling () {
    const n = this._item ? this._item.next : null;
    return n ? /** @type {YXmlElement|YXmlText} */ (/** @type {ContentType} */ (n.content).type) : null
  }

  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get prevSibling () {
    const n = this._item ? this._item.prev : null;
    return n ? /** @type {YXmlElement|YXmlText} */ (/** @type {ContentType} */ (n.content).type) : null
  }

  _copy () {
    return new YXmlText()
  }

  /**
   * @return {YXmlText}
   */
  clone () {
    const text = new YXmlText();
    text.applyDelta(this.toDelta());
    return text
  }

  /**
   * Creates a Dom Element that mirrors this YXmlText.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Text} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */
  toDOM (_document = document, hooks, binding) {
    const dom = _document.createTextNode(this.toString());
    if (binding !== undefined) {
      binding._createAssociation(dom, this);
    }
    return dom
  }

  toString () {
    // @ts-ignore
    return this.toDelta().map(delta => {
      const nestedNodes = [];
      for (const nodeName in delta.attributes) {
        const attrs = [];
        for (const key in delta.attributes[nodeName]) {
          attrs.push({ key, value: delta.attributes[nodeName][key] });
        }
        // sort attributes to get a unique order
        attrs.sort((a, b) => a.key < b.key ? -1 : 1);
        nestedNodes.push({ nodeName, attrs });
      }
      // sort node order to get a unique order
      nestedNodes.sort((a, b) => a.nodeName < b.nodeName ? -1 : 1);
      // now convert to dom string
      let str = '';
      for (let i = 0; i < nestedNodes.length; i++) {
        const node = nestedNodes[i];
        str += `<${node.nodeName}`;
        for (let j = 0; j < node.attrs.length; j++) {
          const attr = node.attrs[j];
          str += ` ${attr.key}="${attr.value}"`;
        }
        str += '>';
      }
      str += delta.insert;
      for (let i = nestedNodes.length - 1; i >= 0; i--) {
        str += `</${nestedNodes[i].nodeName}>`;
      }
      return str
    }).join('')
  }

  /**
   * @return {string}
   */
  toJSON () {
    return this.toString()
  }

  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  _write (encoder) {
    encoder.writeTypeRef(YXmlTextRefID);
  }
}

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlText}
 *
 * @private
 * @function
 */
const readYXmlText = decoder => new YXmlText();

class AbstractStruct {
  /**
   * @param {ID} id
   * @param {number} length
   */
  constructor (id, length) {
    this.id = id;
    this.length = length;
  }

  /**
   * @type {boolean}
   */
  get deleted () {
    throw error__namespace.methodUnimplemented()
  }

  /**
   * Merge this struct with the item to the right.
   * This method is already assuming that `this.id.clock + this.length === this.id.clock`.
   * Also this method does *not* remove right from StructStore!
   * @param {AbstractStruct} right
   * @return {boolean} wether this merged with right
   */
  mergeWith (right) {
    return false
  }

  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   * @param {number} offset
   * @param {number} encodingRef
   */
  write (encoder, offset, encodingRef) {
    throw error__namespace.methodUnimplemented()
  }

  /**
   * @param {Transaction} transaction
   * @param {number} offset
   */
  integrate (transaction, offset) {
    throw error__namespace.methodUnimplemented()
  }
}

const structGCRefNumber = 0;

/**
 * @private
 */
class GC extends AbstractStruct {
  get deleted () {
    return true
  }

  delete () {}

  /**
   * @param {GC} right
   * @return {boolean}
   */
  mergeWith (right) {
    if (this.constructor !== right.constructor) {
      return false
    }
    this.length += right.length;
    return true
  }

  /**
   * @param {Transaction} transaction
   * @param {number} offset
   */
  integrate (transaction, offset) {
    if (offset > 0) {
      this.id.clock += offset;
      this.length -= offset;
    }
    addStruct(transaction.doc.store, this);
  }

  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write (encoder, offset) {
    encoder.writeInfo(structGCRefNumber);
    encoder.writeLen(this.length - offset);
  }

  /**
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */
  getMissing (transaction, store) {
    return null
  }
}

class ContentBinary {
  /**
   * @param {Uint8Array} content
   */
  constructor (content) {
    this.content = content;
  }

  /**
   * @return {number}
   */
  getLength () {
    return 1
  }

  /**
   * @return {Array<any>}
   */
  getContent () {
    return [this.content]
  }

  /**
   * @return {boolean}
   */
  isCountable () {
    return true
  }

  /**
   * @return {ContentBinary}
   */
  copy () {
    return new ContentBinary(this.content)
  }

  /**
   * @param {number} offset
   * @return {ContentBinary}
   */
  splice (offset) {
    throw error__namespace.methodUnimplemented()
  }

  /**
   * @param {ContentBinary} right
   * @return {boolean}
   */
  mergeWith (right) {
    return false
  }

  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate (transaction, item) {}
  /**
   * @param {Transaction} transaction
   */
  delete (transaction) {}
  /**
   * @param {StructStore} store
   */
  gc (store) {}
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write (encoder, offset) {
    encoder.writeBuf(this.content);
  }

  /**
   * @return {number}
   */
  getRef () {
    return 3
  }
}

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2 } decoder
 * @return {ContentBinary}
 */
const readContentBinary = decoder => new ContentBinary(decoder.readBuf());

class ContentDeleted {
  /**
   * @param {number} len
   */
  constructor (len) {
    this.len = len;
  }

  /**
   * @return {number}
   */
  getLength () {
    return this.len
  }

  /**
   * @return {Array<any>}
   */
  getContent () {
    return []
  }

  /**
   * @return {boolean}
   */
  isCountable () {
    return false
  }

  /**
   * @return {ContentDeleted}
   */
  copy () {
    return new ContentDeleted(this.len)
  }

  /**
   * @param {number} offset
   * @return {ContentDeleted}
   */
  splice (offset) {
    const right = new ContentDeleted(this.len - offset);
    this.len = offset;
    return right
  }

  /**
   * @param {ContentDeleted} right
   * @return {boolean}
   */
  mergeWith (right) {
    this.len += right.len;
    return true
  }

  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate (transaction, item) {
    addToDeleteSet(transaction.deleteSet, item.id.client, item.id.clock, this.len);
    item.markDeleted();
  }

  /**
   * @param {Transaction} transaction
   */
  delete (transaction) {}
  /**
   * @param {StructStore} store
   */
  gc (store) {}
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write (encoder, offset) {
    encoder.writeLen(this.len - offset);
  }

  /**
   * @return {number}
   */
  getRef () {
    return 1
  }
}

/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2 } decoder
 * @return {ContentDeleted}
 */
const readContentDeleted = decoder => new ContentDeleted(decoder.readLen());

/**
 * @param {string} guid
 * @param {Object<string, any>} opts
 */
const createDocFromOpts = (guid, opts) => new Doc({ guid, ...opts, shouldLoad: opts.shouldLoad || opts.autoLoad || false });

/**
 * @private
 */
class ContentDoc {
  /**
   * @param {Doc} doc
   */
  constructor (doc) {
    if (doc._item) {
      console.error('This document was already integrated as a sub-document. You should create a second instance instead with the same guid.');
    }
    /**
     * @type {Doc}
     */
    this.doc = doc;
    /**
     * @type {any}
     */
    const opts = {};
    this.opts = opts;
    if (!doc.gc) {
      opts.gc = false;
    }
    if (doc.autoLoad) {
      opts.autoLoad = true;
    }
    if (doc.meta !== null) {
      opts.meta = doc.meta;
    }
  }

  /**
   * @return {number}
   */
  getLength () {
    return 1
  }

  /**
   * @return {Array<any>}
   */
  getContent () {
    return [this.doc]
  }

  /**
   * @return {boolean}
   */
  isCountable () {
    return true
  }

  /**
   * @return {ContentDoc}
   */
  copy () {
    return new ContentDoc(createDocFromOpts(this.doc.guid, this.opts))
  }

  /**
   * @param {number} offset
   * @return {ContentDoc}
   */
  splice (offset) {
    throw error__namespace.methodUnimplemented()
  }

  /**
   * @param {ContentDoc} right
   * @return {boolean}
   */
  mergeWith (right) {
    return false
  }

  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate (transaction, item) {
    // this needs to be reflected in doc.destroy as well
    this.doc._item = item;
    transaction.subdocsAdded.add(this.doc);
    if (this.doc.shouldLoad) {
      transaction.subdocsLoaded.add(this.doc);
    }
  }

  /**
   * @param {Transaction} transaction
   */
  delete (transaction) {
    if (transaction.subdocsAdded.has(this.doc)) {
      transaction.subdocsAdded.delete(this.doc);
    } else {
      transaction.subdocsRemoved.add(this.doc);
    }
  }

  /**
   * @param {StructStore} store
   */
  gc (store) { }

  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write (encoder, offset) {
    encoder.writeString(this.doc.guid);
    encoder.writeAny(this.opts);
  }

  /**
   * @return {number}
   */
  getRef () {
    return 9
  }
}

/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentDoc}
 */
const readContentDoc = decoder => new ContentDoc(createDocFromOpts(decoder.readString(), decoder.readAny()));

/**
 * @private
 */
class ContentEmbed {
  /**
   * @param {Object} embed
   */
  constructor (embed) {
    this.embed = embed;
  }

  /**
   * @return {number}
   */
  getLength () {
    return 1
  }

  /**
   * @return {Array<any>}
   */
  getContent () {
    return [this.embed]
  }

  /**
   * @return {boolean}
   */
  isCountable () {
    return true
  }

  /**
   * @return {ContentEmbed}
   */
  copy () {
    return new ContentEmbed(this.embed)
  }

  /**
   * @param {number} offset
   * @return {ContentEmbed}
   */
  splice (offset) {
    throw error__namespace.methodUnimplemented()
  }

  /**
   * @param {ContentEmbed} right
   * @return {boolean}
   */
  mergeWith (right) {
    return false
  }

  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate (transaction, item) {}
  /**
   * @param {Transaction} transaction
   */
  delete (transaction) {}
  /**
   * @param {StructStore} store
   */
  gc (store) {}
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write (encoder, offset) {
    encoder.writeJSON(this.embed);
  }

  /**
   * @return {number}
   */
  getRef () {
    return 5
  }
}

/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentEmbed}
 */
const readContentEmbed = decoder => new ContentEmbed(decoder.readJSON());

/**
 * @private
 */
class ContentFormat {
  /**
   * @param {string} key
   * @param {Object} value
   */
  constructor (key, value) {
    this.key = key;
    this.value = value;
  }

  /**
   * @return {number}
   */
  getLength () {
    return 1
  }

  /**
   * @return {Array<any>}
   */
  getContent () {
    return []
  }

  /**
   * @return {boolean}
   */
  isCountable () {
    return false
  }

  /**
   * @return {ContentFormat}
   */
  copy () {
    return new ContentFormat(this.key, this.value)
  }

  /**
   * @param {number} offset
   * @return {ContentFormat}
   */
  splice (offset) {
    throw error__namespace.methodUnimplemented()
  }

  /**
   * @param {ContentFormat} right
   * @return {boolean}
   */
  mergeWith (right) {
    return false
  }

  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate (transaction, item) {
    // @todo searchmarker are currently unsupported for rich text documents
    /** @type {AbstractType<any>} */ (item.parent)._searchMarker = null;
  }

  /**
   * @param {Transaction} transaction
   */
  delete (transaction) {}
  /**
   * @param {StructStore} store
   */
  gc (store) {}
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write (encoder, offset) {
    encoder.writeKey(this.key);
    encoder.writeJSON(this.value);
  }

  /**
   * @return {number}
   */
  getRef () {
    return 6
  }
}

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentFormat}
 */
const readContentFormat = decoder => new ContentFormat(decoder.readKey(), decoder.readJSON());

/**
 * @private
 */
class ContentJSON {
  /**
   * @param {Array<any>} arr
   */
  constructor (arr) {
    /**
     * @type {Array<any>}
     */
    this.arr = arr;
  }

  /**
   * @return {number}
   */
  getLength () {
    return this.arr.length
  }

  /**
   * @return {Array<any>}
   */
  getContent () {
    return this.arr
  }

  /**
   * @return {boolean}
   */
  isCountable () {
    return true
  }

  /**
   * @return {ContentJSON}
   */
  copy () {
    return new ContentJSON(this.arr)
  }

  /**
   * @param {number} offset
   * @return {ContentJSON}
   */
  splice (offset) {
    const right = new ContentJSON(this.arr.slice(offset));
    this.arr = this.arr.slice(0, offset);
    return right
  }

  /**
   * @param {ContentJSON} right
   * @return {boolean}
   */
  mergeWith (right) {
    this.arr = this.arr.concat(right.arr);
    return true
  }

  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate (transaction, item) {}
  /**
   * @param {Transaction} transaction
   */
  delete (transaction) {}
  /**
   * @param {StructStore} store
   */
  gc (store) {}
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write (encoder, offset) {
    const len = this.arr.length;
    encoder.writeLen(len - offset);
    for (let i = offset; i < len; i++) {
      const c = this.arr[i];
      encoder.writeString(c === undefined ? 'undefined' : JSON.stringify(c));
    }
  }

  /**
   * @return {number}
   */
  getRef () {
    return 2
  }
}

/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentJSON}
 */
const readContentJSON = decoder => {
  const len = decoder.readLen();
  const cs = [];
  for (let i = 0; i < len; i++) {
    const c = decoder.readString();
    if (c === 'undefined') {
      cs.push(undefined);
    } else {
      cs.push(JSON.parse(c));
    }
  }
  return new ContentJSON(cs)
};

class ContentAny {
  /**
   * @param {Array<any>} arr
   */
  constructor (arr) {
    /**
     * @type {Array<any>}
     */
    this.arr = arr;
  }

  /**
   * @return {number}
   */
  getLength () {
    return this.arr.length
  }

  /**
   * @return {Array<any>}
   */
  getContent () {
    return this.arr
  }

  /**
   * @return {boolean}
   */
  isCountable () {
    return true
  }

  /**
   * @return {ContentAny}
   */
  copy () {
    return new ContentAny(this.arr)
  }

  /**
   * @param {number} offset
   * @return {ContentAny}
   */
  splice (offset) {
    const right = new ContentAny(this.arr.slice(offset));
    this.arr = this.arr.slice(0, offset);
    return right
  }

  /**
   * @param {ContentAny} right
   * @return {boolean}
   */
  mergeWith (right) {
    this.arr = this.arr.concat(right.arr);
    return true
  }

  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate (transaction, item) {}
  /**
   * @param {Transaction} transaction
   */
  delete (transaction) {}
  /**
   * @param {StructStore} store
   */
  gc (store) {}
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write (encoder, offset) {
    const len = this.arr.length;
    encoder.writeLen(len - offset);
    for (let i = offset; i < len; i++) {
      const c = this.arr[i];
      encoder.writeAny(c);
    }
  }

  /**
   * @return {number}
   */
  getRef () {
    return 8
  }
}

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentAny}
 */
const readContentAny = decoder => {
  const len = decoder.readLen();
  const cs = [];
  for (let i = 0; i < len; i++) {
    cs.push(decoder.readAny());
  }
  return new ContentAny(cs)
};

/**
 * @private
 */
class ContentString {
  /**
   * @param {string} str
   */
  constructor (str) {
    /**
     * @type {string}
     */
    this.str = str;
  }

  /**
   * @return {number}
   */
  getLength () {
    return this.str.length
  }

  /**
   * @return {Array<any>}
   */
  getContent () {
    return this.str.split('')
  }

  /**
   * @return {boolean}
   */
  isCountable () {
    return true
  }

  /**
   * @return {ContentString}
   */
  copy () {
    return new ContentString(this.str)
  }

  /**
   * @param {number} offset
   * @return {ContentString}
   */
  splice (offset) {
    const right = new ContentString(this.str.slice(offset));
    this.str = this.str.slice(0, offset);

    // Prevent encoding invalid documents because of splitting of surrogate pairs: https://github.com/yjs/yjs/issues/248
    const firstCharCode = this.str.charCodeAt(offset - 1);
    if (firstCharCode >= 0xD800 && firstCharCode <= 0xDBFF) {
      // Last character of the left split is the start of a surrogate utf16/ucs2 pair.
      // We don't support splitting of surrogate pairs because this may lead to invalid documents.
      // Replace the invalid character with a unicode replacement character (� / U+FFFD)
      this.str = this.str.slice(0, offset - 1) + '�';
      // replace right as well
      right.str = '�' + right.str.slice(1);
    }
    return right
  }

  /**
   * @param {ContentString} right
   * @return {boolean}
   */
  mergeWith (right) {
    this.str += right.str;
    return true
  }

  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate (transaction, item) {}
  /**
   * @param {Transaction} transaction
   */
  delete (transaction) {}
  /**
   * @param {StructStore} store
   */
  gc (store) {}
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write (encoder, offset) {
    encoder.writeString(offset === 0 ? this.str : this.str.slice(offset));
  }

  /**
   * @return {number}
   */
  getRef () {
    return 4
  }
}

/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentString}
 */
const readContentString = decoder => new ContentString(decoder.readString());

/**
 * @type {Array<function(UpdateDecoderV1 | UpdateDecoderV2):AbstractType<any>>}
 * @private
 */
const typeRefs = [
  readYArray,
  readYMap,
  readYText,
  readYXmlElement,
  readYXmlFragment,
  readYXmlHook,
  readYXmlText
];

const YArrayRefID = 0;
const YMapRefID = 1;
const YTextRefID = 2;
const YXmlElementRefID = 3;
const YXmlFragmentRefID = 4;
const YXmlHookRefID = 5;
const YXmlTextRefID = 6;

/**
 * @private
 */
class ContentType {
  /**
   * @param {AbstractType<any>} type
   */
  constructor (type) {
    /**
     * @type {AbstractType<any>}
     */
    this.type = type;
  }

  /**
   * @return {number}
   */
  getLength () {
    return 1
  }

  /**
   * @return {Array<any>}
   */
  getContent () {
    return [this.type]
  }

  /**
   * @return {boolean}
   */
  isCountable () {
    return true
  }

  /**
   * @return {ContentType}
   */
  copy () {
    return new ContentType(this.type._copy())
  }

  /**
   * @param {number} offset
   * @return {ContentType}
   */
  splice (offset) {
    throw error__namespace.methodUnimplemented()
  }

  /**
   * @param {ContentType} right
   * @return {boolean}
   */
  mergeWith (right) {
    return false
  }

  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate (transaction, item) {
    this.type._integrate(transaction.doc, item);
  }

  /**
   * @param {Transaction} transaction
   */
  delete (transaction) {
    let item = this.type._start;
    while (item !== null) {
      if (!item.deleted) {
        item.delete(transaction);
      } else {
        // This will be gc'd later and we want to merge it if possible
        // We try to merge all deleted items after each transaction,
        // but we have no knowledge about that this needs to be merged
        // since it is not in transaction.ds. Hence we add it to transaction._mergeStructs
        transaction._mergeStructs.push(item);
      }
      item = item.right;
    }
    this.type._map.forEach(item => {
      if (!item.deleted) {
        item.delete(transaction);
      } else {
        // same as above
        transaction._mergeStructs.push(item);
      }
    });
    transaction.changed.delete(this.type);
  }

  /**
   * @param {StructStore} store
   */
  gc (store) {
    let item = this.type._start;
    while (item !== null) {
      item.gc(store, true);
      item = item.right;
    }
    this.type._start = null;
    this.type._map.forEach(/** @param {Item | null} item */ (item) => {
      while (item !== null) {
        item.gc(store, true);
        item = item.left;
      }
    });
    this.type._map = new Map();
  }

  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write (encoder, offset) {
    this.type._write(encoder);
  }

  /**
   * @return {number}
   */
  getRef () {
    return 7
  }
}

/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentType}
 */
const readContentType = decoder => new ContentType(typeRefs[decoder.readTypeRef()](decoder));

/**
 * @todo This should return several items
 *
 * @param {StructStore} store
 * @param {ID} id
 * @return {{item:Item, diff:number}}
 */
const followRedone = (store, id) => {
  /**
   * @type {ID|null}
   */
  let nextID = id;
  let diff = 0;
  let item;
  do {
    if (diff > 0) {
      nextID = createID(nextID.client, nextID.clock + diff);
    }
    item = getItem(store, nextID);
    diff = nextID.clock - item.id.clock;
    nextID = item.redone;
  } while (nextID !== null && item instanceof Item)
  return {
    item, diff
  }
};

/**
 * Make sure that neither item nor any of its parents is ever deleted.
 *
 * This property does not persist when storing it into a database or when
 * sending it to other peers
 *
 * @param {Item|null} item
 * @param {boolean} keep
 */
const keepItem = (item, keep) => {
  while (item !== null && item.keep !== keep) {
    item.keep = keep;
    item = /** @type {AbstractType<any>} */ (item.parent)._item;
  }
};

/**
 * Split leftItem into two items
 * @param {Transaction} transaction
 * @param {Item} leftItem
 * @param {number} diff
 * @return {Item}
 *
 * @function
 * @private
 */
const splitItem = (transaction, leftItem, diff) => {
  // create rightItem
  const { client, clock } = leftItem.id;
  const rightItem = new Item(
    createID(client, clock + diff),
    leftItem,
    createID(client, clock + diff - 1),
    leftItem.right,
    leftItem.rightOrigin,
    leftItem.parent,
    leftItem.parentSub,
    leftItem.content.splice(diff)
  );
  if (leftItem.deleted) {
    rightItem.markDeleted();
  }
  if (leftItem.keep) {
    rightItem.keep = true;
  }
  if (leftItem.redone !== null) {
    rightItem.redone = createID(leftItem.redone.client, leftItem.redone.clock + diff);
  }
  // update left (do not set leftItem.rightOrigin as it will lead to problems when syncing)
  leftItem.right = rightItem;
  // update right
  if (rightItem.right !== null) {
    rightItem.right.left = rightItem;
  }
  // right is more specific.
  transaction._mergeStructs.push(rightItem);
  // update parent._map
  if (rightItem.parentSub !== null && rightItem.right === null) {
    /** @type {AbstractType<any>} */ (rightItem.parent)._map.set(rightItem.parentSub, rightItem);
  }
  leftItem.length = diff;
  return rightItem
};

/**
 * Redoes the effect of this operation.
 *
 * @param {Transaction} transaction The Yjs instance.
 * @param {Item} item
 * @param {Set<Item>} redoitems
 * @param {DeleteSet} itemsToDelete
 * @param {boolean} ignoreRemoteMapChanges
 *
 * @return {Item|null}
 *
 * @private
 */
const redoItem = (transaction, item, redoitems, itemsToDelete, ignoreRemoteMapChanges) => {
  const doc = transaction.doc;
  const store = doc.store;
  const ownClientID = doc.clientID;
  const redone = item.redone;
  if (redone !== null) {
    return getItemCleanStart(transaction, redone)
  }
  let parentItem = /** @type {AbstractType<any>} */ (item.parent)._item;
  /**
   * @type {Item|null}
   */
  let left = null;
  /**
   * @type {Item|null}
   */
  let right;
  // make sure that parent is redone
  if (parentItem !== null && parentItem.deleted === true) {
    // try to undo parent if it will be undone anyway
    if (parentItem.redone === null && (!redoitems.has(parentItem) || redoItem(transaction, parentItem, redoitems, itemsToDelete, ignoreRemoteMapChanges) === null)) {
      return null
    }
    while (parentItem.redone !== null) {
      parentItem = getItemCleanStart(transaction, parentItem.redone);
    }
  }
  const parentType = parentItem === null ? /** @type {AbstractType<any>} */ (item.parent) : /** @type {ContentType} */ (parentItem.content).type;

  if (item.parentSub === null) {
    // Is an array item. Insert at the old position
    left = item.left;
    right = item;
    // find next cloned_redo items
    while (left !== null) {
      /**
       * @type {Item|null}
       */
      let leftTrace = left;
      // trace redone until parent matches
      while (leftTrace !== null && /** @type {AbstractType<any>} */ (leftTrace.parent)._item !== parentItem) {
        leftTrace = leftTrace.redone === null ? null : getItemCleanStart(transaction, leftTrace.redone);
      }
      if (leftTrace !== null && /** @type {AbstractType<any>} */ (leftTrace.parent)._item === parentItem) {
        left = leftTrace;
        break
      }
      left = left.left;
    }
    while (right !== null) {
      /**
       * @type {Item|null}
       */
      let rightTrace = right;
      // trace redone until parent matches
      while (rightTrace !== null && /** @type {AbstractType<any>} */ (rightTrace.parent)._item !== parentItem) {
        rightTrace = rightTrace.redone === null ? null : getItemCleanStart(transaction, rightTrace.redone);
      }
      if (rightTrace !== null && /** @type {AbstractType<any>} */ (rightTrace.parent)._item === parentItem) {
        right = rightTrace;
        break
      }
      right = right.right;
    }
  } else {
    right = null;
    if (item.right && !ignoreRemoteMapChanges) {
      left = item;
      // Iterate right while right is in itemsToDelete
      // If it is intended to delete right while item is redone, we can expect that item should replace right.
      while (left !== null && left.right !== null && isDeleted(itemsToDelete, left.right.id)) {
        left = left.right;
      }
      // follow redone
      // trace redone until parent matches
      while (left !== null && left.redone !== null) {
        left = getItemCleanStart(transaction, left.redone);
      }
      // check wether we were allowed to follow right (indicating that originally this op was replaced by another item)
      if (left === null || /** @type {AbstractType<any>} */ (left.parent)._item !== parentItem) {
        // invalid parent; should never happen
        return null
      }
      if (left && left.right !== null) {
        // It is not possible to redo this item because it conflicts with a
        // change from another client
        return null
      }
    } else {
      left = parentType._map.get(item.parentSub) || null;
    }
  }
  const nextClock = getState(store, ownClientID);
  const nextId = createID(ownClientID, nextClock);
  const redoneItem = new Item(
    nextId,
    left, left && left.lastId,
    right, right && right.id,
    parentType,
    item.parentSub,
    item.content.copy()
  );
  item.redone = nextId;
  keepItem(redoneItem, true);
  redoneItem.integrate(transaction, 0);
  return redoneItem
};

/**
 * Abstract class that represents any content.
 */
class Item extends AbstractStruct {
  /**
   * @param {ID} id
   * @param {Item | null} left
   * @param {ID | null} origin
   * @param {Item | null} right
   * @param {ID | null} rightOrigin
   * @param {AbstractType<any>|ID|null} parent Is a type if integrated, is null if it is possible to copy parent from left or right, is ID before integration to search for it.
   * @param {string | null} parentSub
   * @param {AbstractContent} content
   */
  constructor (id, left, origin, right, rightOrigin, parent, parentSub, content) {
    super(id, content.getLength());
    /**
     * The item that was originally to the left of this item.
     * @type {ID | null}
     */
    this.origin = origin;
    /**
     * The item that is currently to the left of this item.
     * @type {Item | null}
     */
    this.left = left;
    /**
     * The item that is currently to the right of this item.
     * @type {Item | null}
     */
    this.right = right;
    /**
     * The item that was originally to the right of this item.
     * @type {ID | null}
     */
    this.rightOrigin = rightOrigin;
    /**
     * @type {AbstractType<any>|ID|null}
     */
    this.parent = parent;
    /**
     * If the parent refers to this item with some kind of key (e.g. YMap, the
     * key is specified here. The key is then used to refer to the list in which
     * to insert this item. If `parentSub = null` type._start is the list in
     * which to insert to. Otherwise it is `parent._map`.
     * @type {String | null}
     */
    this.parentSub = parentSub;
    /**
     * If this type's effect is redone this type refers to the type that undid
     * this operation.
     * @type {ID | null}
     */
    this.redone = null;
    /**
     * @type {AbstractContent}
     */
    this.content = content;
    /**
     * bit1: keep
     * bit2: countable
     * bit3: deleted
     * bit4: mark - mark node as fast-search-marker
     * @type {number} byte
     */
    this.info = this.content.isCountable() ? binary__namespace.BIT2 : 0;
  }

  /**
   * This is used to mark the item as an indexed fast-search marker
   *
   * @type {boolean}
   */
  set marker (isMarked) {
    if (((this.info & binary__namespace.BIT4) > 0) !== isMarked) {
      this.info ^= binary__namespace.BIT4;
    }
  }

  get marker () {
    return (this.info & binary__namespace.BIT4) > 0
  }

  /**
   * If true, do not garbage collect this Item.
   */
  get keep () {
    return (this.info & binary__namespace.BIT1) > 0
  }

  set keep (doKeep) {
    if (this.keep !== doKeep) {
      this.info ^= binary__namespace.BIT1;
    }
  }

  get countable () {
    return (this.info & binary__namespace.BIT2) > 0
  }

  /**
   * Whether this item was deleted or not.
   * @type {Boolean}
   */
  get deleted () {
    return (this.info & binary__namespace.BIT3) > 0
  }

  set deleted (doDelete) {
    if (this.deleted !== doDelete) {
      this.info ^= binary__namespace.BIT3;
    }
  }

  markDeleted () {
    this.info |= binary__namespace.BIT3;
  }

  /**
   * Return the creator clientID of the missing op or define missing items and return null.
   *
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */
  getMissing (transaction, store) {
    if (this.origin && this.origin.client !== this.id.client && this.origin.clock >= getState(store, this.origin.client)) {
      return this.origin.client
    }
    if (this.rightOrigin && this.rightOrigin.client !== this.id.client && this.rightOrigin.clock >= getState(store, this.rightOrigin.client)) {
      return this.rightOrigin.client
    }
    if (this.parent && this.parent.constructor === ID && this.id.client !== this.parent.client && this.parent.clock >= getState(store, this.parent.client)) {
      return this.parent.client
    }

    // We have all missing ids, now find the items

    if (this.origin) {
      this.left = getItemCleanEnd(transaction, store, this.origin);
      this.origin = this.left.lastId;
    }
    if (this.rightOrigin) {
      this.right = getItemCleanStart(transaction, this.rightOrigin);
      this.rightOrigin = this.right.id;
    }
    if ((this.left && this.left.constructor === GC) || (this.right && this.right.constructor === GC)) {
      this.parent = null;
    }
    // only set parent if this shouldn't be garbage collected
    if (!this.parent) {
      if (this.left && this.left.constructor === Item) {
        this.parent = this.left.parent;
        this.parentSub = this.left.parentSub;
      }
      if (this.right && this.right.constructor === Item) {
        this.parent = this.right.parent;
        this.parentSub = this.right.parentSub;
      }
    } else if (this.parent.constructor === ID) {
      const parentItem = getItem(store, this.parent);
      if (parentItem.constructor === GC) {
        this.parent = null;
      } else {
        this.parent = /** @type {ContentType} */ (parentItem.content).type;
      }
    }
    return null
  }

  /**
   * @param {Transaction} transaction
   * @param {number} offset
   */
  integrate (transaction, offset) {
    if (offset > 0) {
      this.id.clock += offset;
      this.left = getItemCleanEnd(transaction, transaction.doc.store, createID(this.id.client, this.id.clock - 1));
      this.origin = this.left.lastId;
      this.content = this.content.splice(offset);
      this.length -= offset;
    }

    if (this.parent) {
      if ((!this.left && (!this.right || this.right.left !== null)) || (this.left && this.left.right !== this.right)) {
        /**
         * @type {Item|null}
         */
        let left = this.left;

        /**
         * @type {Item|null}
         */
        let o;
        // set o to the first conflicting item
        if (left !== null) {
          o = left.right;
        } else if (this.parentSub !== null) {
          o = /** @type {AbstractType<any>} */ (this.parent)._map.get(this.parentSub) || null;
          while (o !== null && o.left !== null) {
            o = o.left;
          }
        } else {
          o = /** @type {AbstractType<any>} */ (this.parent)._start;
        }
        // TODO: use something like DeleteSet here (a tree implementation would be best)
        // @todo use global set definitions
        /**
         * @type {Set<Item>}
         */
        const conflictingItems = new Set();
        /**
         * @type {Set<Item>}
         */
        const itemsBeforeOrigin = new Set();
        // Let c in conflictingItems, b in itemsBeforeOrigin
        // ***{origin}bbbb{this}{c,b}{c,b}{o}***
        // Note that conflictingItems is a subset of itemsBeforeOrigin
        while (o !== null && o !== this.right) {
          itemsBeforeOrigin.add(o);
          conflictingItems.add(o);
          if (compareIDs(this.origin, o.origin)) {
            // case 1
            if (o.id.client < this.id.client) {
              left = o;
              conflictingItems.clear();
            } else if (compareIDs(this.rightOrigin, o.rightOrigin)) {
              // this and o are conflicting and point to the same integration points. The id decides which item comes first.
              // Since this is to the left of o, we can break here
              break
            } // else, o might be integrated before an item that this conflicts with. If so, we will find it in the next iterations
          } else if (o.origin !== null && itemsBeforeOrigin.has(getItem(transaction.doc.store, o.origin))) { // use getItem instead of getItemCleanEnd because we don't want / need to split items.
            // case 2
            if (!conflictingItems.has(getItem(transaction.doc.store, o.origin))) {
              left = o;
              conflictingItems.clear();
            }
          } else {
            break
          }
          o = o.right;
        }
        this.left = left;
      }
      // reconnect left/right + update parent map/start if necessary
      if (this.left !== null) {
        const right = this.left.right;
        this.right = right;
        this.left.right = this;
      } else {
        let r;
        if (this.parentSub !== null) {
          r = /** @type {AbstractType<any>} */ (this.parent)._map.get(this.parentSub) || null;
          while (r !== null && r.left !== null) {
            r = r.left;
          }
        } else {
          r = /** @type {AbstractType<any>} */ (this.parent)._start
          ;/** @type {AbstractType<any>} */ (this.parent)._start = this;
        }
        this.right = r;
      }
      if (this.right !== null) {
        this.right.left = this;
      } else if (this.parentSub !== null) {
        // set as current parent value if right === null and this is parentSub
        /** @type {AbstractType<any>} */ (this.parent)._map.set(this.parentSub, this);
        if (this.left !== null) {
          // this is the current attribute value of parent. delete right
          this.left.delete(transaction);
        }
      }
      // adjust length of parent
      if (this.parentSub === null && this.countable && !this.deleted) {
        /** @type {AbstractType<any>} */ (this.parent)._length += this.length;
      }
      addStruct(transaction.doc.store, this);
      this.content.integrate(transaction, this);
      // add parent to transaction.changed
      addChangedTypeToTransaction(transaction, /** @type {AbstractType<any>} */ (this.parent), this.parentSub);
      if ((/** @type {AbstractType<any>} */ (this.parent)._item !== null && /** @type {AbstractType<any>} */ (this.parent)._item.deleted) || (this.parentSub !== null && this.right !== null)) {
        // delete if parent is deleted or if this is not the current attribute value of parent
        this.delete(transaction);
      }
    } else {
      // parent is not defined. Integrate GC struct instead
      new GC(this.id, this.length).integrate(transaction, 0);
    }
  }

  /**
   * Returns the next non-deleted item
   */
  get next () {
    let n = this.right;
    while (n !== null && n.deleted) {
      n = n.right;
    }
    return n
  }

  /**
   * Returns the previous non-deleted item
   */
  get prev () {
    let n = this.left;
    while (n !== null && n.deleted) {
      n = n.left;
    }
    return n
  }

  /**
   * Computes the last content address of this Item.
   */
  get lastId () {
    // allocating ids is pretty costly because of the amount of ids created, so we try to reuse whenever possible
    return this.length === 1 ? this.id : createID(this.id.client, this.id.clock + this.length - 1)
  }

  /**
   * Try to merge two items
   *
   * @param {Item} right
   * @return {boolean}
   */
  mergeWith (right) {
    if (
      this.constructor === right.constructor &&
      compareIDs(right.origin, this.lastId) &&
      this.right === right &&
      compareIDs(this.rightOrigin, right.rightOrigin) &&
      this.id.client === right.id.client &&
      this.id.clock + this.length === right.id.clock &&
      this.deleted === right.deleted &&
      this.redone === null &&
      right.redone === null &&
      this.content.constructor === right.content.constructor &&
      this.content.mergeWith(right.content)
    ) {
      const searchMarker = /** @type {AbstractType<any>} */ (this.parent)._searchMarker;
      if (searchMarker) {
        searchMarker.forEach(marker => {
          if (marker.p === right) {
            // right is going to be "forgotten" so we need to update the marker
            marker.p = this;
            // adjust marker index
            if (!this.deleted && this.countable) {
              marker.index -= this.length;
            }
          }
        });
      }
      if (right.keep) {
        this.keep = true;
      }
      this.right = right.right;
      if (this.right !== null) {
        this.right.left = this;
      }
      this.length += right.length;
      return true
    }
    return false
  }

  /**
   * Mark this Item as deleted.
   *
   * @param {Transaction} transaction
   */
  delete (transaction) {
    if (!this.deleted) {
      const parent = /** @type {AbstractType<any>} */ (this.parent);
      // adjust the length of parent
      if (this.countable && this.parentSub === null) {
        parent._length -= this.length;
      }
      this.markDeleted();
      addToDeleteSet(transaction.deleteSet, this.id.client, this.id.clock, this.length);
      addChangedTypeToTransaction(transaction, parent, this.parentSub);
      this.content.delete(transaction);
    }
  }

  /**
   * @param {StructStore} store
   * @param {boolean} parentGCd
   */
  gc (store, parentGCd) {
    if (!this.deleted) {
      throw error__namespace.unexpectedCase()
    }
    this.content.gc(store);
    if (parentGCd) {
      replaceStruct(store, this, new GC(this.id, this.length));
    } else {
      this.content = new ContentDeleted(this.length);
    }
  }

  /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   * @param {number} offset
   */
  write (encoder, offset) {
    const origin = offset > 0 ? createID(this.id.client, this.id.clock + offset - 1) : this.origin;
    const rightOrigin = this.rightOrigin;
    const parentSub = this.parentSub;
    const info = (this.content.getRef() & binary__namespace.BITS5) |
      (origin === null ? 0 : binary__namespace.BIT8) | // origin is defined
      (rightOrigin === null ? 0 : binary__namespace.BIT7) | // right origin is defined
      (parentSub === null ? 0 : binary__namespace.BIT6); // parentSub is non-null
    encoder.writeInfo(info);
    if (origin !== null) {
      encoder.writeLeftID(origin);
    }
    if (rightOrigin !== null) {
      encoder.writeRightID(rightOrigin);
    }
    if (origin === null && rightOrigin === null) {
      const parent = /** @type {AbstractType<any>} */ (this.parent);
      if (parent._item !== undefined) {
        const parentItem = parent._item;
        if (parentItem === null) {
          // parent type on y._map
          // find the correct key
          const ykey = findRootTypeKey(parent);
          encoder.writeParentInfo(true); // write parentYKey
          encoder.writeString(ykey);
        } else {
          encoder.writeParentInfo(false); // write parent id
          encoder.writeLeftID(parentItem.id);
        }
      } else if (parent.constructor === String) { // this edge case was added by differential updates
        encoder.writeParentInfo(true); // write parentYKey
        encoder.writeString(parent);
      } else if (parent.constructor === ID) {
        encoder.writeParentInfo(false); // write parent id
        encoder.writeLeftID(parent);
      } else {
        error__namespace.unexpectedCase();
      }
      if (parentSub !== null) {
        encoder.writeString(parentSub);
      }
    }
    this.content.write(encoder, offset);
  }
}

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @param {number} info
 */
const readItemContent = (decoder, info) => contentRefs[info & binary__namespace.BITS5](decoder);

/**
 * A lookup map for reading Item content.
 *
 * @type {Array<function(UpdateDecoderV1 | UpdateDecoderV2):AbstractContent>}
 */
const contentRefs = [
  () => { error__namespace.unexpectedCase(); }, // GC is not ItemContent
  readContentDeleted, // 1
  readContentJSON, // 2
  readContentBinary, // 3
  readContentString, // 4
  readContentEmbed, // 5
  readContentFormat, // 6
  readContentType, // 7
  readContentAny, // 8
  readContentDoc, // 9
  () => { error__namespace.unexpectedCase(); } // 10 - Skip is not ItemContent
];

const structSkipRefNumber = 10;

/**
 * @private
 */
class Skip extends AbstractStruct {
  get deleted () {
    return true
  }

  delete () {}

  /**
   * @param {Skip} right
   * @return {boolean}
   */
  mergeWith (right) {
    if (this.constructor !== right.constructor) {
      return false
    }
    this.length += right.length;
    return true
  }

  /**
   * @param {Transaction} transaction
   * @param {number} offset
   */
  integrate (transaction, offset) {
    // skip structs cannot be integrated
    error__namespace.unexpectedCase();
  }

  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write (encoder, offset) {
    encoder.writeInfo(structSkipRefNumber);
    // write as VarUint because Skips can't make use of predictable length-encoding
    encoding__namespace.writeVarUint(encoder.restEncoder, this.length - offset);
  }

  /**
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */
  getMissing (transaction, store) {
    return null
  }
}

/** eslint-env browser */

const glo = /** @type {any} */ (typeof window !== 'undefined'
  ? window
  // @ts-ignore
  : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : {});

const importIdentifier = '__ $YJS$ __';

if (glo[importIdentifier] === true) {
  /**
   * Dear reader of this warning message. Please take this seriously.
   *
   * If you see this message, please make sure that you only import one version of Yjs. In many cases,
   * your package manager installs two versions of Yjs that are used by different packages within your project.
   * Another reason for this message is that some parts of your project use the commonjs version of Yjs
   * and others use the EcmaScript version of Yjs.
   *
   * This often leads to issues that are hard to debug. We often need to perform constructor checks,
   * e.g. `struct instanceof GC`. If you imported different versions of Yjs, it is impossible for us to
   * do the constructor checks anymore - which might break the CRDT algorithm.
   */
  console.warn('Yjs was already imported. Importing different versions of Yjs often leads to issues.');
}
glo[importIdentifier] = true;

exports.AbsolutePosition = AbsolutePosition;
exports.AbstractConnector = AbstractConnector;
exports.AbstractStruct = AbstractStruct;
exports.AbstractType = AbstractType;
exports.Array = YArray;
exports.ContentAny = ContentAny;
exports.ContentBinary = ContentBinary;
exports.ContentDeleted = ContentDeleted;
exports.ContentEmbed = ContentEmbed;
exports.ContentFormat = ContentFormat;
exports.ContentJSON = ContentJSON;
exports.ContentString = ContentString;
exports.ContentType = ContentType;
exports.Doc = Doc;
exports.GC = GC;
exports.ID = ID;
exports.Item = Item;
exports.Map = YMap;
exports.PermanentUserData = PermanentUserData;
exports.RelativePosition = RelativePosition;
exports.Snapshot = Snapshot;
exports.Text = YText;
exports.Transaction = Transaction;
exports.UndoManager = UndoManager;
exports.XmlElement = YXmlElement;
exports.XmlFragment = YXmlFragment;
exports.XmlHook = YXmlHook;
exports.XmlText = YXmlText;
exports.YArrayEvent = YArrayEvent;
exports.YEvent = YEvent;
exports.YMapEvent = YMapEvent;
exports.YTextEvent = YTextEvent;
exports.YXmlEvent = YXmlEvent;
exports.applyUpdate = applyUpdate;
exports.applyUpdateV2 = applyUpdateV2;
exports.cleanupYTextFormatting = cleanupYTextFormatting;
exports.compareIDs = compareIDs;
exports.compareRelativePositions = compareRelativePositions;
exports.convertUpdateFormatV1ToV2 = convertUpdateFormatV1ToV2;
exports.convertUpdateFormatV2ToV1 = convertUpdateFormatV2ToV1;
exports.createAbsolutePositionFromRelativePosition = createAbsolutePositionFromRelativePosition;
exports.createDeleteSet = createDeleteSet;
exports.createDeleteSetFromStructStore = createDeleteSetFromStructStore;
exports.createDocFromSnapshot = createDocFromSnapshot;
exports.createID = createID;
exports.createRelativePositionFromJSON = createRelativePositionFromJSON;
exports.createRelativePositionFromTypeIndex = createRelativePositionFromTypeIndex;
exports.createSnapshot = createSnapshot;
exports.decodeRelativePosition = decodeRelativePosition;
exports.decodeSnapshot = decodeSnapshot;
exports.decodeSnapshotV2 = decodeSnapshotV2;
exports.decodeStateVector = decodeStateVector;
exports.decodeUpdate = decodeUpdate;
exports.decodeUpdateV2 = decodeUpdateV2;
exports.diffUpdate = diffUpdate;
exports.diffUpdateV2 = diffUpdateV2;
exports.emptySnapshot = emptySnapshot;
exports.encodeRelativePosition = encodeRelativePosition;
exports.encodeSnapshot = encodeSnapshot;
exports.encodeSnapshotV2 = encodeSnapshotV2;
exports.encodeStateAsUpdate = encodeStateAsUpdate;
exports.encodeStateAsUpdateV2 = encodeStateAsUpdateV2;
exports.encodeStateVector = encodeStateVector;
exports.encodeStateVectorFromUpdate = encodeStateVectorFromUpdate;
exports.encodeStateVectorFromUpdateV2 = encodeStateVectorFromUpdateV2;
exports.equalSnapshots = equalSnapshots;
exports.findIndexSS = findIndexSS;
exports.findRootTypeKey = findRootTypeKey;
exports.getItem = getItem;
exports.getState = getState;
exports.getTypeChildren = getTypeChildren;
exports.isDeleted = isDeleted;
exports.isParentOf = isParentOf;
exports.iterateDeletedStructs = iterateDeletedStructs;
exports.logType = logType;
exports.logUpdate = logUpdate;
exports.logUpdateV2 = logUpdateV2;
exports.mergeUpdates = mergeUpdates;
exports.mergeUpdatesV2 = mergeUpdatesV2;
exports.parseUpdateMeta = parseUpdateMeta;
exports.parseUpdateMetaV2 = parseUpdateMetaV2;
exports.readUpdate = readUpdate;
exports.readUpdateV2 = readUpdateV2;
exports.relativePositionToJSON = relativePositionToJSON;
exports.snapshot = snapshot;
exports.transact = transact;
exports.tryGc = tryGc;
exports.typeListToArraySnapshot = typeListToArraySnapshot;
exports.typeMapGetSnapshot = typeMapGetSnapshot;
//# sourceMappingURL=yjs.cjs.map


/***/ }),

/***/ 99915:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


/**
 * Utility module to work with Arrays.
 *
 * @module array
 */

/**
 * Return the last element of an array. The element must exist
 *
 * @template L
 * @param {Array<L>} arr
 * @return {L}
 */
const last = arr => arr[arr.length - 1];

/**
 * @template C
 * @return {Array<C>}
 */
const create = () => /** @type {Array<C>} */ ([]);

/**
 * @template D
 * @param {Array<D>} a
 * @return {Array<D>}
 */
const copy = a => /** @type {Array<D>} */ (a.slice());

/**
 * Append elements from src to dest
 *
 * @template M
 * @param {Array<M>} dest
 * @param {Array<M>} src
 */
const appendTo = (dest, src) => {
  for (let i = 0; i < src.length; i++) {
    dest.push(src[i]);
  }
};

/**
 * Transforms something array-like to an actual Array.
 *
 * @function
 * @template T
 * @param {ArrayLike<T>|Iterable<T>} arraylike
 * @return {T}
 */
const from = Array.from;

/**
 * True iff condition holds on every element in the Array.
 *
 * @function
 * @template ITEM
 *
 * @param {Array<ITEM>} arr
 * @param {function(ITEM, number, Array<ITEM>):boolean} f
 * @return {boolean}
 */
const every = (arr, f) => arr.every(f);

/**
 * True iff condition holds on some element in the Array.
 *
 * @function
 * @template S
 * @param {Array<S>} arr
 * @param {function(S, number, Array<S>):boolean} f
 * @return {boolean}
 */
const some = (arr, f) => arr.some(f);

/**
 * @template ELEM
 *
 * @param {Array<ELEM>} a
 * @param {Array<ELEM>} b
 * @return {boolean}
 */
const equalFlat = (a, b) => a.length === b.length && every(a, (item, index) => item === b[index]);

/**
 * @template ELEM
 * @param {Array<Array<ELEM>>} arr
 * @return {Array<ELEM>}
 */
const flatten = arr => arr.reduce((acc, val) => acc.concat(val), []);

const isArray = Array.isArray;

var array = /*#__PURE__*/Object.freeze({
  __proto__: null,
  last: last,
  create: create,
  copy: copy,
  appendTo: appendTo,
  from: from,
  every: every,
  some: some,
  equalFlat: equalFlat,
  flatten: flatten,
  isArray: isArray
});

exports.appendTo = appendTo;
exports.array = array;
exports.copy = copy;
exports.create = create;
exports.equalFlat = equalFlat;
exports.every = every;
exports.flatten = flatten;
exports.from = from;
exports.isArray = isArray;
exports.last = last;
exports.some = some;
//# sourceMappingURL=array-acefe0f2.cjs.map


/***/ }),

/***/ 64706:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var array = __webpack_require__(99915);



exports.appendTo = array.appendTo;
exports.copy = array.copy;
exports.create = array.create;
exports.equalFlat = array.equalFlat;
exports.every = array.every;
exports.flatten = array.flatten;
exports.from = array.from;
exports.isArray = array.isArray;
exports.last = array.last;
exports.some = array.some;
//# sourceMappingURL=array.cjs.map


/***/ }),

/***/ 53115:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


/* eslint-env browser */

/**
 * Binary data constants.
 *
 * @module binary
 */

/**
 * n-th bit activated.
 *
 * @type {number}
 */
const BIT1 = 1;
const BIT2 = 2;
const BIT3 = 4;
const BIT4 = 8;
const BIT5 = 16;
const BIT6 = 32;
const BIT7 = 64;
const BIT8 = 128;
const BIT9 = 256;
const BIT10 = 512;
const BIT11 = 1024;
const BIT12 = 2048;
const BIT13 = 4096;
const BIT14 = 8192;
const BIT15 = 16384;
const BIT16 = 32768;
const BIT17 = 65536;
const BIT18 = 1 << 17;
const BIT19 = 1 << 18;
const BIT20 = 1 << 19;
const BIT21 = 1 << 20;
const BIT22 = 1 << 21;
const BIT23 = 1 << 22;
const BIT24 = 1 << 23;
const BIT25 = 1 << 24;
const BIT26 = 1 << 25;
const BIT27 = 1 << 26;
const BIT28 = 1 << 27;
const BIT29 = 1 << 28;
const BIT30 = 1 << 29;
const BIT31 = 1 << 30;
const BIT32 = 1 << 31;

/**
 * First n bits activated.
 *
 * @type {number}
 */
const BITS0 = 0;
const BITS1 = 1;
const BITS2 = 3;
const BITS3 = 7;
const BITS4 = 15;
const BITS5 = 31;
const BITS6 = 63;
const BITS7 = 127;
const BITS8 = 255;
const BITS9 = 511;
const BITS10 = 1023;
const BITS11 = 2047;
const BITS12 = 4095;
const BITS13 = 8191;
const BITS14 = 16383;
const BITS15 = 32767;
const BITS16 = 65535;
const BITS17 = BIT18 - 1;
const BITS18 = BIT19 - 1;
const BITS19 = BIT20 - 1;
const BITS20 = BIT21 - 1;
const BITS21 = BIT22 - 1;
const BITS22 = BIT23 - 1;
const BITS23 = BIT24 - 1;
const BITS24 = BIT25 - 1;
const BITS25 = BIT26 - 1;
const BITS26 = BIT27 - 1;
const BITS27 = BIT28 - 1;
const BITS28 = BIT29 - 1;
const BITS29 = BIT30 - 1;
const BITS30 = BIT31 - 1;
/**
 * @type {number}
 */
const BITS31 = 0x7FFFFFFF;
/**
 * @type {number}
 */
const BITS32 = 0xFFFFFFFF;

var binary = /*#__PURE__*/Object.freeze({
	__proto__: null,
	BIT1: BIT1,
	BIT2: BIT2,
	BIT3: BIT3,
	BIT4: BIT4,
	BIT5: BIT5,
	BIT6: BIT6,
	BIT7: BIT7,
	BIT8: BIT8,
	BIT9: BIT9,
	BIT10: BIT10,
	BIT11: BIT11,
	BIT12: BIT12,
	BIT13: BIT13,
	BIT14: BIT14,
	BIT15: BIT15,
	BIT16: BIT16,
	BIT17: BIT17,
	BIT18: BIT18,
	BIT19: BIT19,
	BIT20: BIT20,
	BIT21: BIT21,
	BIT22: BIT22,
	BIT23: BIT23,
	BIT24: BIT24,
	BIT25: BIT25,
	BIT26: BIT26,
	BIT27: BIT27,
	BIT28: BIT28,
	BIT29: BIT29,
	BIT30: BIT30,
	BIT31: BIT31,
	BIT32: BIT32,
	BITS0: BITS0,
	BITS1: BITS1,
	BITS2: BITS2,
	BITS3: BITS3,
	BITS4: BITS4,
	BITS5: BITS5,
	BITS6: BITS6,
	BITS7: BITS7,
	BITS8: BITS8,
	BITS9: BITS9,
	BITS10: BITS10,
	BITS11: BITS11,
	BITS12: BITS12,
	BITS13: BITS13,
	BITS14: BITS14,
	BITS15: BITS15,
	BITS16: BITS16,
	BITS17: BITS17,
	BITS18: BITS18,
	BITS19: BITS19,
	BITS20: BITS20,
	BITS21: BITS21,
	BITS22: BITS22,
	BITS23: BITS23,
	BITS24: BITS24,
	BITS25: BITS25,
	BITS26: BITS26,
	BITS27: BITS27,
	BITS28: BITS28,
	BITS29: BITS29,
	BITS30: BITS30,
	BITS31: BITS31,
	BITS32: BITS32
});

exports.BIT1 = BIT1;
exports.BIT10 = BIT10;
exports.BIT11 = BIT11;
exports.BIT12 = BIT12;
exports.BIT13 = BIT13;
exports.BIT14 = BIT14;
exports.BIT15 = BIT15;
exports.BIT16 = BIT16;
exports.BIT17 = BIT17;
exports.BIT18 = BIT18;
exports.BIT19 = BIT19;
exports.BIT2 = BIT2;
exports.BIT20 = BIT20;
exports.BIT21 = BIT21;
exports.BIT22 = BIT22;
exports.BIT23 = BIT23;
exports.BIT24 = BIT24;
exports.BIT25 = BIT25;
exports.BIT26 = BIT26;
exports.BIT27 = BIT27;
exports.BIT28 = BIT28;
exports.BIT29 = BIT29;
exports.BIT3 = BIT3;
exports.BIT30 = BIT30;
exports.BIT31 = BIT31;
exports.BIT32 = BIT32;
exports.BIT4 = BIT4;
exports.BIT5 = BIT5;
exports.BIT6 = BIT6;
exports.BIT7 = BIT7;
exports.BIT8 = BIT8;
exports.BIT9 = BIT9;
exports.BITS0 = BITS0;
exports.BITS1 = BITS1;
exports.BITS10 = BITS10;
exports.BITS11 = BITS11;
exports.BITS12 = BITS12;
exports.BITS13 = BITS13;
exports.BITS14 = BITS14;
exports.BITS15 = BITS15;
exports.BITS16 = BITS16;
exports.BITS17 = BITS17;
exports.BITS18 = BITS18;
exports.BITS19 = BITS19;
exports.BITS2 = BITS2;
exports.BITS20 = BITS20;
exports.BITS21 = BITS21;
exports.BITS22 = BITS22;
exports.BITS23 = BITS23;
exports.BITS24 = BITS24;
exports.BITS25 = BITS25;
exports.BITS26 = BITS26;
exports.BITS27 = BITS27;
exports.BITS28 = BITS28;
exports.BITS29 = BITS29;
exports.BITS3 = BITS3;
exports.BITS30 = BITS30;
exports.BITS31 = BITS31;
exports.BITS32 = BITS32;
exports.BITS4 = BITS4;
exports.BITS5 = BITS5;
exports.BITS6 = BITS6;
exports.BITS7 = BITS7;
exports.BITS8 = BITS8;
exports.BITS9 = BITS9;
exports.binary = binary;
//# sourceMappingURL=binary-ac8e39e2.cjs.map


/***/ }),

/***/ 13149:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var binary = __webpack_require__(53115);



exports.BIT1 = binary.BIT1;
exports.BIT10 = binary.BIT10;
exports.BIT11 = binary.BIT11;
exports.BIT12 = binary.BIT12;
exports.BIT13 = binary.BIT13;
exports.BIT14 = binary.BIT14;
exports.BIT15 = binary.BIT15;
exports.BIT16 = binary.BIT16;
exports.BIT17 = binary.BIT17;
exports.BIT18 = binary.BIT18;
exports.BIT19 = binary.BIT19;
exports.BIT2 = binary.BIT2;
exports.BIT20 = binary.BIT20;
exports.BIT21 = binary.BIT21;
exports.BIT22 = binary.BIT22;
exports.BIT23 = binary.BIT23;
exports.BIT24 = binary.BIT24;
exports.BIT25 = binary.BIT25;
exports.BIT26 = binary.BIT26;
exports.BIT27 = binary.BIT27;
exports.BIT28 = binary.BIT28;
exports.BIT29 = binary.BIT29;
exports.BIT3 = binary.BIT3;
exports.BIT30 = binary.BIT30;
exports.BIT31 = binary.BIT31;
exports.BIT32 = binary.BIT32;
exports.BIT4 = binary.BIT4;
exports.BIT5 = binary.BIT5;
exports.BIT6 = binary.BIT6;
exports.BIT7 = binary.BIT7;
exports.BIT8 = binary.BIT8;
exports.BIT9 = binary.BIT9;
exports.BITS0 = binary.BITS0;
exports.BITS1 = binary.BITS1;
exports.BITS10 = binary.BITS10;
exports.BITS11 = binary.BITS11;
exports.BITS12 = binary.BITS12;
exports.BITS13 = binary.BITS13;
exports.BITS14 = binary.BITS14;
exports.BITS15 = binary.BITS15;
exports.BITS16 = binary.BITS16;
exports.BITS17 = binary.BITS17;
exports.BITS18 = binary.BITS18;
exports.BITS19 = binary.BITS19;
exports.BITS2 = binary.BITS2;
exports.BITS20 = binary.BITS20;
exports.BITS21 = binary.BITS21;
exports.BITS22 = binary.BITS22;
exports.BITS23 = binary.BITS23;
exports.BITS24 = binary.BITS24;
exports.BITS25 = binary.BITS25;
exports.BITS26 = binary.BITS26;
exports.BITS27 = binary.BITS27;
exports.BITS28 = binary.BITS28;
exports.BITS29 = binary.BITS29;
exports.BITS3 = binary.BITS3;
exports.BITS30 = binary.BITS30;
exports.BITS31 = binary.BITS31;
exports.BITS32 = binary.BITS32;
exports.BITS4 = binary.BITS4;
exports.BITS5 = binary.BITS5;
exports.BITS6 = binary.BITS6;
exports.BITS7 = binary.BITS7;
exports.BITS8 = binary.BITS8;
exports.BITS9 = binary.BITS9;
//# sourceMappingURL=binary.cjs.map


/***/ }),

/***/ 69731:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(13423)["Buffer"];


var string = __webpack_require__(31314);
var environment = __webpack_require__(88139);
var binary = __webpack_require__(53115);
var math = __webpack_require__(36482);
var number = __webpack_require__(91869);
var error = __webpack_require__(10219);

/**
 * Efficient schema-less binary encoding with support for variable length encoding.
 *
 * Use [lib0/encoding] with [lib0/decoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = new encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = new decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module encoding
 */

/**
 * A BinaryEncoder handles the encoding to an Uint8Array.
 */
class Encoder {
  constructor () {
    this.cpos = 0;
    this.cbuf = new Uint8Array(100);
    /**
     * @type {Array<Uint8Array>}
     */
    this.bufs = [];
  }
}

/**
 * @function
 * @return {Encoder}
 */
const createEncoder = () => new Encoder();

/**
 * The current length of the encoded data.
 *
 * @function
 * @param {Encoder} encoder
 * @return {number}
 */
const length = encoder => {
  let len = encoder.cpos;
  for (let i = 0; i < encoder.bufs.length; i++) {
    len += encoder.bufs[i].length;
  }
  return len
};

/**
 * Transform to Uint8Array.
 *
 * @function
 * @param {Encoder} encoder
 * @return {Uint8Array} The created ArrayBuffer.
 */
const toUint8Array = encoder => {
  const uint8arr = new Uint8Array(length(encoder));
  let curPos = 0;
  for (let i = 0; i < encoder.bufs.length; i++) {
    const d = encoder.bufs[i];
    uint8arr.set(d, curPos);
    curPos += d.length;
  }
  uint8arr.set(createUint8ArrayViewFromArrayBuffer(encoder.cbuf.buffer, 0, encoder.cpos), curPos);
  return uint8arr
};

/**
 * Verify that it is possible to write `len` bytes wtihout checking. If
 * necessary, a new Buffer with the required length is attached.
 *
 * @param {Encoder} encoder
 * @param {number} len
 */
const verifyLen = (encoder, len) => {
  const bufferLen = encoder.cbuf.length;
  if (bufferLen - encoder.cpos < len) {
    encoder.bufs.push(createUint8ArrayViewFromArrayBuffer(encoder.cbuf.buffer, 0, encoder.cpos));
    encoder.cbuf = new Uint8Array(math.max(bufferLen, len) * 2);
    encoder.cpos = 0;
  }
};

/**
 * Write one byte to the encoder.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The byte that is to be encoded.
 */
const write = (encoder, num) => {
  const bufferLen = encoder.cbuf.length;
  if (encoder.cpos === bufferLen) {
    encoder.bufs.push(encoder.cbuf);
    encoder.cbuf = new Uint8Array(bufferLen * 2);
    encoder.cpos = 0;
  }
  encoder.cbuf[encoder.cpos++] = num;
};

/**
 * Write one byte at a specific position.
 * Position must already be written (i.e. encoder.length > pos)
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} pos Position to which to write data
 * @param {number} num Unsigned 8-bit integer
 */
const set = (encoder, pos, num) => {
  let buffer = null;
  // iterate all buffers and adjust position
  for (let i = 0; i < encoder.bufs.length && buffer === null; i++) {
    const b = encoder.bufs[i];
    if (pos < b.length) {
      buffer = b; // found buffer
    } else {
      pos -= b.length;
    }
  }
  if (buffer === null) {
    // use current buffer
    buffer = encoder.cbuf;
  }
  buffer[pos] = num;
};

/**
 * Write one byte as an unsigned integer.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
const writeUint8 = write;

/**
 * Write one byte as an unsigned Integer at a specific location.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} pos The location where the data will be written.
 * @param {number} num The number that is to be encoded.
 */
const setUint8 = set;

/**
 * Write two bytes as an unsigned integer.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
const writeUint16 = (encoder, num) => {
  write(encoder, num & binary.BITS8);
  write(encoder, (num >>> 8) & binary.BITS8);
};
/**
 * Write two bytes as an unsigned integer at a specific location.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} pos The location where the data will be written.
 * @param {number} num The number that is to be encoded.
 */
const setUint16 = (encoder, pos, num) => {
  set(encoder, pos, num & binary.BITS8);
  set(encoder, pos + 1, (num >>> 8) & binary.BITS8);
};

/**
 * Write two bytes as an unsigned integer
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
const writeUint32 = (encoder, num) => {
  for (let i = 0; i < 4; i++) {
    write(encoder, num & binary.BITS8);
    num >>>= 8;
  }
};

/**
 * Write two bytes as an unsigned integer in big endian order.
 * (most significant byte first)
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
const writeUint32BigEndian = (encoder, num) => {
  for (let i = 3; i >= 0; i--) {
    write(encoder, (num >>> (8 * i)) & binary.BITS8);
  }
};

/**
 * Write two bytes as an unsigned integer at a specific location.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} pos The location where the data will be written.
 * @param {number} num The number that is to be encoded.
 */
const setUint32 = (encoder, pos, num) => {
  for (let i = 0; i < 4; i++) {
    set(encoder, pos + i, num & binary.BITS8);
    num >>>= 8;
  }
};

/**
 * Write a variable length unsigned integer. Max encodable integer is 2^53.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
const writeVarUint = (encoder, num) => {
  while (num > binary.BITS7) {
    write(encoder, binary.BIT8 | (binary.BITS7 & num));
    num = math.floor(num / 128); // shift >>> 7
  }
  write(encoder, binary.BITS7 & num);
};

/**
 * Write a variable length integer.
 *
 * We use the 7th bit instead for signaling that this is a negative number.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
const writeVarInt = (encoder, num) => {
  const isNegative = math.isNegativeZero(num);
  if (isNegative) {
    num = -num;
  }
  //             |- whether to continue reading         |- whether is negative     |- number
  write(encoder, (num > binary.BITS6 ? binary.BIT8 : 0) | (isNegative ? binary.BIT7 : 0) | (binary.BITS6 & num));
  num = math.floor(num / 64); // shift >>> 6
  // We don't need to consider the case of num === 0 so we can use a different
  // pattern here than above.
  while (num > 0) {
    write(encoder, (num > binary.BITS7 ? binary.BIT8 : 0) | (binary.BITS7 & num));
    num = math.floor(num / 128); // shift >>> 7
  }
};

/**
 * A cache to store strings temporarily
 */
const _strBuffer = new Uint8Array(30000);
const _maxStrBSize = _strBuffer.length / 3;

/**
 * Write a variable length string.
 *
 * @function
 * @param {Encoder} encoder
 * @param {String} str The string that is to be encoded.
 */
const _writeVarStringNative = (encoder, str) => {
  if (str.length < _maxStrBSize) {
    // We can encode the string into the existing buffer
    /* istanbul ignore else */
    const written = string.utf8TextEncoder.encodeInto(str, _strBuffer).written || 0;
    writeVarUint(encoder, written);
    for (let i = 0; i < written; i++) {
      write(encoder, _strBuffer[i]);
    }
  } else {
    writeVarUint8Array(encoder, string.encodeUtf8(str));
  }
};

/**
 * Write a variable length string.
 *
 * @function
 * @param {Encoder} encoder
 * @param {String} str The string that is to be encoded.
 */
const _writeVarStringPolyfill = (encoder, str) => {
  const encodedString = unescape(encodeURIComponent(str));
  const len = encodedString.length;
  writeVarUint(encoder, len);
  for (let i = 0; i < len; i++) {
    write(encoder, /** @type {number} */ (encodedString.codePointAt(i)));
  }
};

/**
 * Write a variable length string.
 *
 * @function
 * @param {Encoder} encoder
 * @param {String} str The string that is to be encoded.
 */
/* istanbul ignore next */
const writeVarString = (string.utf8TextEncoder && string.utf8TextEncoder.encodeInto) ? _writeVarStringNative : _writeVarStringPolyfill;

/**
 * Write the content of another Encoder.
 *
 * @TODO: can be improved!
 *        - Note: Should consider that when appending a lot of small Encoders, we should rather clone than referencing the old structure.
 *                Encoders start with a rather big initial buffer.
 *
 * @function
 * @param {Encoder} encoder The enUint8Arr
 * @param {Encoder} append The BinaryEncoder to be written.
 */
const writeBinaryEncoder = (encoder, append) => writeUint8Array(encoder, toUint8Array(append));

/**
 * Append fixed-length Uint8Array to the encoder.
 *
 * @function
 * @param {Encoder} encoder
 * @param {Uint8Array} uint8Array
 */
const writeUint8Array = (encoder, uint8Array) => {
  const bufferLen = encoder.cbuf.length;
  const cpos = encoder.cpos;
  const leftCopyLen = math.min(bufferLen - cpos, uint8Array.length);
  const rightCopyLen = uint8Array.length - leftCopyLen;
  encoder.cbuf.set(uint8Array.subarray(0, leftCopyLen), cpos);
  encoder.cpos += leftCopyLen;
  if (rightCopyLen > 0) {
    // Still something to write, write right half..
    // Append new buffer
    encoder.bufs.push(encoder.cbuf);
    // must have at least size of remaining buffer
    encoder.cbuf = new Uint8Array(math.max(bufferLen * 2, rightCopyLen));
    // copy array
    encoder.cbuf.set(uint8Array.subarray(leftCopyLen));
    encoder.cpos = rightCopyLen;
  }
};

/**
 * Append an Uint8Array to Encoder.
 *
 * @function
 * @param {Encoder} encoder
 * @param {Uint8Array} uint8Array
 */
const writeVarUint8Array = (encoder, uint8Array) => {
  writeVarUint(encoder, uint8Array.byteLength);
  writeUint8Array(encoder, uint8Array);
};

/**
 * Create an DataView of the next `len` bytes. Use it to write data after
 * calling this function.
 *
 * ```js
 * // write float32 using DataView
 * const dv = writeOnDataView(encoder, 4)
 * dv.setFloat32(0, 1.1)
 * // read float32 using DataView
 * const dv = readFromDataView(encoder, 4)
 * dv.getFloat32(0) // => 1.100000023841858 (leaving it to the reader to find out why this is the correct result)
 * ```
 *
 * @param {Encoder} encoder
 * @param {number} len
 * @return {DataView}
 */
const writeOnDataView = (encoder, len) => {
  verifyLen(encoder, len);
  const dview = new DataView(encoder.cbuf.buffer, encoder.cpos, len);
  encoder.cpos += len;
  return dview
};

/**
 * @param {Encoder} encoder
 * @param {number} num
 */
const writeFloat32 = (encoder, num) => writeOnDataView(encoder, 4).setFloat32(0, num, false);

/**
 * @param {Encoder} encoder
 * @param {number} num
 */
const writeFloat64 = (encoder, num) => writeOnDataView(encoder, 8).setFloat64(0, num, false);

/**
 * @param {Encoder} encoder
 * @param {bigint} num
 */
const writeBigInt64 = (encoder, num) => /** @type {any} */ (writeOnDataView(encoder, 8)).setBigInt64(0, num, false);

/**
 * @param {Encoder} encoder
 * @param {bigint} num
 */
const writeBigUint64 = (encoder, num) => /** @type {any} */ (writeOnDataView(encoder, 8)).setBigUint64(0, num, false);

const floatTestBed = new DataView(new ArrayBuffer(4));
/**
 * Check if a number can be encoded as a 32 bit float.
 *
 * @param {number} num
 * @return {boolean}
 */
const isFloat32 = num => {
  floatTestBed.setFloat32(0, num);
  return floatTestBed.getFloat32(0) === num
};

/**
 * Encode data with efficient binary format.
 *
 * Differences to JSON:
 * • Transforms data to a binary format (not to a string)
 * • Encodes undefined, NaN, and ArrayBuffer (these can't be represented in JSON)
 * • Numbers are efficiently encoded either as a variable length integer, as a
 *   32 bit float, as a 64 bit float, or as a 64 bit bigint.
 *
 * Encoding table:
 *
 * | Data Type           | Prefix   | Encoding Method    | Comment |
 * | ------------------- | -------- | ------------------ | ------- |
 * | undefined           | 127      |                    | Functions, symbol, and everything that cannot be identified is encoded as undefined |
 * | null                | 126      |                    | |
 * | integer             | 125      | writeVarInt        | Only encodes 32 bit signed integers |
 * | float32             | 124      | writeFloat32       | |
 * | float64             | 123      | writeFloat64       | |
 * | bigint              | 122      | writeBigInt64      | |
 * | boolean (false)     | 121      |                    | True and false are different data types so we save the following byte |
 * | boolean (true)      | 120      |                    | - 0b01111000 so the last bit determines whether true or false |
 * | string              | 119      | writeVarString     | |
 * | object<string,any>  | 118      | custom             | Writes {length} then {length} key-value pairs |
 * | array<any>          | 117      | custom             | Writes {length} then {length} json values |
 * | Uint8Array          | 116      | writeVarUint8Array | We use Uint8Array for any kind of binary data |
 *
 * Reasons for the decreasing prefix:
 * We need the first bit for extendability (later we may want to encode the
 * prefix with writeVarUint). The remaining 7 bits are divided as follows:
 * [0-30]   the beginning of the data range is used for custom purposes
 *          (defined by the function that uses this library)
 * [31-127] the end of the data range is used for data encoding by
 *          lib0/encoding.js
 *
 * @param {Encoder} encoder
 * @param {undefined|null|number|bigint|boolean|string|Object<string,any>|Array<any>|Uint8Array} data
 */
const writeAny = (encoder, data) => {
  switch (typeof data) {
    case 'string':
      // TYPE 119: STRING
      write(encoder, 119);
      writeVarString(encoder, data);
      break
    case 'number':
      if (number.isInteger(data) && math.abs(data) <= binary.BITS31) {
        // TYPE 125: INTEGER
        write(encoder, 125);
        writeVarInt(encoder, data);
      } else if (isFloat32(data)) {
        // TYPE 124: FLOAT32
        write(encoder, 124);
        writeFloat32(encoder, data);
      } else {
        // TYPE 123: FLOAT64
        write(encoder, 123);
        writeFloat64(encoder, data);
      }
      break
    case 'bigint':
      // TYPE 122: BigInt
      write(encoder, 122);
      writeBigInt64(encoder, data);
      break
    case 'object':
      if (data === null) {
        // TYPE 126: null
        write(encoder, 126);
      } else if (data instanceof Array) {
        // TYPE 117: Array
        write(encoder, 117);
        writeVarUint(encoder, data.length);
        for (let i = 0; i < data.length; i++) {
          writeAny(encoder, data[i]);
        }
      } else if (data instanceof Uint8Array) {
        // TYPE 116: ArrayBuffer
        write(encoder, 116);
        writeVarUint8Array(encoder, data);
      } else {
        // TYPE 118: Object
        write(encoder, 118);
        const keys = Object.keys(data);
        writeVarUint(encoder, keys.length);
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          writeVarString(encoder, key);
          writeAny(encoder, data[key]);
        }
      }
      break
    case 'boolean':
      // TYPE 120/121: boolean (true/false)
      write(encoder, data ? 120 : 121);
      break
    default:
      // TYPE 127: undefined
      write(encoder, 127);
  }
};

/**
 * Now come a few stateful encoder that have their own classes.
 */

/**
 * Basic Run Length Encoder - a basic compression implementation.
 *
 * Encodes [1,1,1,7] to [1,3,7,1] (3 times 1, 1 time 7). This encoder might do more harm than good if there are a lot of values that are not repeated.
 *
 * It was originally used for image compression. Cool .. article http://csbruce.com/cbm/transactor/pdfs/trans_v7_i06.pdf
 *
 * @note T must not be null!
 *
 * @template T
 */
class RleEncoder extends Encoder {
  /**
   * @param {function(Encoder, T):void} writer
   */
  constructor (writer) {
    super();
    /**
     * The writer
     */
    this.w = writer;
    /**
     * Current state
     * @type {T|null}
     */
    this.s = null;
    this.count = 0;
  }

  /**
   * @param {T} v
   */
  write (v) {
    if (this.s === v) {
      this.count++;
    } else {
      if (this.count > 0) {
        // flush counter, unless this is the first value (count = 0)
        writeVarUint(this, this.count - 1); // since count is always > 0, we can decrement by one. non-standard encoding ftw
      }
      this.count = 1;
      // write first value
      this.w(this, v);
      this.s = v;
    }
  }
}

/**
 * Basic diff decoder using variable length encoding.
 *
 * Encodes the values [3, 1100, 1101, 1050, 0] to [3, 1097, 1, -51, -1050] using writeVarInt.
 */
class IntDiffEncoder extends Encoder {
  /**
   * @param {number} start
   */
  constructor (start) {
    super();
    /**
     * Current state
     * @type {number}
     */
    this.s = start;
  }

  /**
   * @param {number} v
   */
  write (v) {
    writeVarInt(this, v - this.s);
    this.s = v;
  }
}

/**
 * A combination of IntDiffEncoder and RleEncoder.
 *
 * Basically first writes the IntDiffEncoder and then counts duplicate diffs using RleEncoding.
 *
 * Encodes the values [1,1,1,2,3,4,5,6] as [1,1,0,2,1,5] (RLE([1,0,0,1,1,1,1,1]) ⇒ RleIntDiff[1,1,0,2,1,5])
 */
class RleIntDiffEncoder extends Encoder {
  /**
   * @param {number} start
   */
  constructor (start) {
    super();
    /**
     * Current state
     * @type {number}
     */
    this.s = start;
    this.count = 0;
  }

  /**
   * @param {number} v
   */
  write (v) {
    if (this.s === v && this.count > 0) {
      this.count++;
    } else {
      if (this.count > 0) {
        // flush counter, unless this is the first value (count = 0)
        writeVarUint(this, this.count - 1); // since count is always > 0, we can decrement by one. non-standard encoding ftw
      }
      this.count = 1;
      // write first value
      writeVarInt(this, v - this.s);
      this.s = v;
    }
  }
}

/**
 * @param {UintOptRleEncoder} encoder
 */
const flushUintOptRleEncoder = encoder => {
  /* istanbul ignore else */
  if (encoder.count > 0) {
    // flush counter, unless this is the first value (count = 0)
    // case 1: just a single value. set sign to positive
    // case 2: write several values. set sign to negative to indicate that there is a length coming
    writeVarInt(encoder.encoder, encoder.count === 1 ? encoder.s : -encoder.s);
    if (encoder.count > 1) {
      writeVarUint(encoder.encoder, encoder.count - 2); // since count is always > 1, we can decrement by one. non-standard encoding ftw
    }
  }
};

/**
 * Optimized Rle encoder that does not suffer from the mentioned problem of the basic Rle encoder.
 *
 * Internally uses VarInt encoder to write unsigned integers. If the input occurs multiple times, we write
 * write it as a negative number. The UintOptRleDecoder then understands that it needs to read a count.
 *
 * Encodes [1,2,3,3,3] as [1,2,-3,3] (once 1, once 2, three times 3)
 */
class UintOptRleEncoder {
  constructor () {
    this.encoder = new Encoder();
    /**
     * @type {number}
     */
    this.s = 0;
    this.count = 0;
  }

  /**
   * @param {number} v
   */
  write (v) {
    if (this.s === v) {
      this.count++;
    } else {
      flushUintOptRleEncoder(this);
      this.count = 1;
      this.s = v;
    }
  }

  toUint8Array () {
    flushUintOptRleEncoder(this);
    return toUint8Array(this.encoder)
  }
}

/**
 * Increasing Uint Optimized RLE Encoder
 *
 * The RLE encoder counts the number of same occurences of the same value.
 * The IncUintOptRle encoder counts if the value increases.
 * I.e. 7, 8, 9, 10 will be encoded as [-7, 4]. 1, 3, 5 will be encoded
 * as [1, 3, 5].
 */
class IncUintOptRleEncoder {
  constructor () {
    this.encoder = new Encoder();
    /**
     * @type {number}
     */
    this.s = 0;
    this.count = 0;
  }

  /**
   * @param {number} v
   */
  write (v) {
    if (this.s + this.count === v) {
      this.count++;
    } else {
      flushUintOptRleEncoder(this);
      this.count = 1;
      this.s = v;
    }
  }

  toUint8Array () {
    flushUintOptRleEncoder(this);
    return toUint8Array(this.encoder)
  }
}

/**
 * @param {IntDiffOptRleEncoder} encoder
 */
const flushIntDiffOptRleEncoder = encoder => {
  if (encoder.count > 0) {
    //          31 bit making up the diff | wether to write the counter
    // const encodedDiff = encoder.diff << 1 | (encoder.count === 1 ? 0 : 1)
    const encodedDiff = encoder.diff * 2 + (encoder.count === 1 ? 0 : 1);
    // flush counter, unless this is the first value (count = 0)
    // case 1: just a single value. set first bit to positive
    // case 2: write several values. set first bit to negative to indicate that there is a length coming
    writeVarInt(encoder.encoder, encodedDiff);
    if (encoder.count > 1) {
      writeVarUint(encoder.encoder, encoder.count - 2); // since count is always > 1, we can decrement by one. non-standard encoding ftw
    }
  }
};

/**
 * A combination of the IntDiffEncoder and the UintOptRleEncoder.
 *
 * The count approach is similar to the UintDiffOptRleEncoder, but instead of using the negative bitflag, it encodes
 * in the LSB whether a count is to be read. Therefore this Encoder only supports 31 bit integers!
 *
 * Encodes [1, 2, 3, 2] as [3, 1, 6, -1] (more specifically [(1 << 1) | 1, (3 << 0) | 0, -1])
 *
 * Internally uses variable length encoding. Contrary to normal UintVar encoding, the first byte contains:
 * * 1 bit that denotes whether the next value is a count (LSB)
 * * 1 bit that denotes whether this value is negative (MSB - 1)
 * * 1 bit that denotes whether to continue reading the variable length integer (MSB)
 *
 * Therefore, only five bits remain to encode diff ranges.
 *
 * Use this Encoder only when appropriate. In most cases, this is probably a bad idea.
 */
class IntDiffOptRleEncoder {
  constructor () {
    this.encoder = new Encoder();
    /**
     * @type {number}
     */
    this.s = 0;
    this.count = 0;
    this.diff = 0;
  }

  /**
   * @param {number} v
   */
  write (v) {
    if (this.diff === v - this.s) {
      this.s = v;
      this.count++;
    } else {
      flushIntDiffOptRleEncoder(this);
      this.count = 1;
      this.diff = v - this.s;
      this.s = v;
    }
  }

  toUint8Array () {
    flushIntDiffOptRleEncoder(this);
    return toUint8Array(this.encoder)
  }
}

/**
 * Optimized String Encoder.
 *
 * Encoding many small strings in a simple Encoder is not very efficient. The function call to decode a string takes some time and creates references that must be eventually deleted.
 * In practice, when decoding several million small strings, the GC will kick in more and more often to collect orphaned string objects (or maybe there is another reason?).
 *
 * This string encoder solves the above problem. All strings are concatenated and written as a single string using a single encoding call.
 *
 * The lengths are encoded using a UintOptRleEncoder.
 */
class StringEncoder {
  constructor () {
    /**
     * @type {Array<string>}
     */
    this.sarr = [];
    this.s = '';
    this.lensE = new UintOptRleEncoder();
  }

  /**
   * @param {string} string
   */
  write (string) {
    this.s += string;
    if (this.s.length > 19) {
      this.sarr.push(this.s);
      this.s = '';
    }
    this.lensE.write(string.length);
  }

  toUint8Array () {
    const encoder = new Encoder();
    this.sarr.push(this.s);
    this.s = '';
    writeVarString(encoder, this.sarr.join(''));
    writeUint8Array(encoder, this.lensE.toUint8Array());
    return toUint8Array(encoder)
  }
}

var encoding = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Encoder: Encoder,
  createEncoder: createEncoder,
  length: length,
  toUint8Array: toUint8Array,
  verifyLen: verifyLen,
  write: write,
  set: set,
  writeUint8: writeUint8,
  setUint8: setUint8,
  writeUint16: writeUint16,
  setUint16: setUint16,
  writeUint32: writeUint32,
  writeUint32BigEndian: writeUint32BigEndian,
  setUint32: setUint32,
  writeVarUint: writeVarUint,
  writeVarInt: writeVarInt,
  _writeVarStringNative: _writeVarStringNative,
  _writeVarStringPolyfill: _writeVarStringPolyfill,
  writeVarString: writeVarString,
  writeBinaryEncoder: writeBinaryEncoder,
  writeUint8Array: writeUint8Array,
  writeVarUint8Array: writeVarUint8Array,
  writeOnDataView: writeOnDataView,
  writeFloat32: writeFloat32,
  writeFloat64: writeFloat64,
  writeBigInt64: writeBigInt64,
  writeBigUint64: writeBigUint64,
  writeAny: writeAny,
  RleEncoder: RleEncoder,
  IntDiffEncoder: IntDiffEncoder,
  RleIntDiffEncoder: RleIntDiffEncoder,
  UintOptRleEncoder: UintOptRleEncoder,
  IncUintOptRleEncoder: IncUintOptRleEncoder,
  IntDiffOptRleEncoder: IntDiffOptRleEncoder,
  StringEncoder: StringEncoder
});

/**
 * Efficient schema-less binary decoding with support for variable length encoding.
 *
 * Use [lib0/decoding] with [lib0/encoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = new encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = new decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module decoding
 */

const errorUnexpectedEndOfArray = error.create('Unexpected end of array');
const errorIntegerOutOfRange = error.create('Integer out of Range');

/**
 * A Decoder handles the decoding of an Uint8Array.
 */
class Decoder {
  /**
   * @param {Uint8Array} uint8Array Binary data to decode
   */
  constructor (uint8Array) {
    /**
     * Decoding target.
     *
     * @type {Uint8Array}
     */
    this.arr = uint8Array;
    /**
     * Current decoding position.
     *
     * @type {number}
     */
    this.pos = 0;
  }
}

/**
 * @function
 * @param {Uint8Array} uint8Array
 * @return {Decoder}
 */
const createDecoder = uint8Array => new Decoder(uint8Array);

/**
 * @function
 * @param {Decoder} decoder
 * @return {boolean}
 */
const hasContent = decoder => decoder.pos !== decoder.arr.length;

/**
 * Clone a decoder instance.
 * Optionally set a new position parameter.
 *
 * @function
 * @param {Decoder} decoder The decoder instance
 * @param {number} [newPos] Defaults to current position
 * @return {Decoder} A clone of `decoder`
 */
const clone = (decoder, newPos = decoder.pos) => {
  const _decoder = createDecoder(decoder.arr);
  _decoder.pos = newPos;
  return _decoder
};

/**
 * Create an Uint8Array view of the next `len` bytes and advance the position by `len`.
 *
 * Important: The Uint8Array still points to the underlying ArrayBuffer. Make sure to discard the result as soon as possible to prevent any memory leaks.
 *            Use `buffer.copyUint8Array` to copy the result into a new Uint8Array.
 *
 * @function
 * @param {Decoder} decoder The decoder instance
 * @param {number} len The length of bytes to read
 * @return {Uint8Array}
 */
const readUint8Array = (decoder, len) => {
  const view = createUint8ArrayViewFromArrayBuffer(decoder.arr.buffer, decoder.pos + decoder.arr.byteOffset, len);
  decoder.pos += len;
  return view
};

/**
 * Read variable length Uint8Array.
 *
 * Important: The Uint8Array still points to the underlying ArrayBuffer. Make sure to discard the result as soon as possible to prevent any memory leaks.
 *            Use `buffer.copyUint8Array` to copy the result into a new Uint8Array.
 *
 * @function
 * @param {Decoder} decoder
 * @return {Uint8Array}
 */
const readVarUint8Array = decoder => readUint8Array(decoder, readVarUint(decoder));

/**
 * Read the rest of the content as an ArrayBuffer
 * @function
 * @param {Decoder} decoder
 * @return {Uint8Array}
 */
const readTailAsUint8Array = decoder => readUint8Array(decoder, decoder.arr.length - decoder.pos);

/**
 * Skip one byte, jump to the next position.
 * @function
 * @param {Decoder} decoder The decoder instance
 * @return {number} The next position
 */
const skip8 = decoder => decoder.pos++;

/**
 * Read one byte as unsigned integer.
 * @function
 * @param {Decoder} decoder The decoder instance
 * @return {number} Unsigned 8-bit integer
 */
const readUint8 = decoder => decoder.arr[decoder.pos++];

/**
 * Read 2 bytes as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
const readUint16 = decoder => {
  const uint =
    decoder.arr[decoder.pos] +
    (decoder.arr[decoder.pos + 1] << 8);
  decoder.pos += 2;
  return uint
};

/**
 * Read 4 bytes as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
const readUint32 = decoder => {
  const uint =
    (decoder.arr[decoder.pos] +
    (decoder.arr[decoder.pos + 1] << 8) +
    (decoder.arr[decoder.pos + 2] << 16) +
    (decoder.arr[decoder.pos + 3] << 24)) >>> 0;
  decoder.pos += 4;
  return uint
};

/**
 * Read 4 bytes as unsigned integer in big endian order.
 * (most significant byte first)
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
const readUint32BigEndian = decoder => {
  const uint =
    (decoder.arr[decoder.pos + 3] +
    (decoder.arr[decoder.pos + 2] << 8) +
    (decoder.arr[decoder.pos + 1] << 16) +
    (decoder.arr[decoder.pos] << 24)) >>> 0;
  decoder.pos += 4;
  return uint
};

/**
 * Look ahead without incrementing the position
 * to the next byte and read it as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
const peekUint8 = decoder => decoder.arr[decoder.pos];

/**
 * Look ahead without incrementing the position
 * to the next byte and read it as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
const peekUint16 = decoder =>
  decoder.arr[decoder.pos] +
  (decoder.arr[decoder.pos + 1] << 8);

/**
 * Look ahead without incrementing the position
 * to the next byte and read it as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
const peekUint32 = decoder => (
  decoder.arr[decoder.pos] +
  (decoder.arr[decoder.pos + 1] << 8) +
  (decoder.arr[decoder.pos + 2] << 16) +
  (decoder.arr[decoder.pos + 3] << 24)
) >>> 0;

/**
 * Read unsigned integer (32bit) with variable length.
 * 1/8th of the storage is used as encoding overhead.
 *  * numbers < 2^7 is stored in one bytlength
 *  * numbers < 2^14 is stored in two bylength
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.length
 */
const readVarUint = decoder => {
  let num = 0;
  let mult = 1;
  const len = decoder.arr.length;
  while (decoder.pos < len) {
    const r = decoder.arr[decoder.pos++];
    // num = num | ((r & binary.BITS7) << len)
    num = num + (r & binary.BITS7) * mult; // shift $r << (7*#iterations) and add it to num
    mult *= 128; // next iteration, shift 7 "more" to the left
    if (r < binary.BIT8) {
      return num
    }
    /* istanbul ignore if */
    if (num > number.MAX_SAFE_INTEGER) {
      throw errorIntegerOutOfRange
    }
  }
  throw errorUnexpectedEndOfArray
};

/**
 * Read signed integer (32bit) with variable length.
 * 1/8th of the storage is used as encoding overhead.
 *  * numbers < 2^7 is stored in one bytlength
 *  * numbers < 2^14 is stored in two bylength
 * @todo This should probably create the inverse ~num if number is negative - but this would be a breaking change.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.length
 */
const readVarInt = decoder => {
  let r = decoder.arr[decoder.pos++];
  let num = r & binary.BITS6;
  let mult = 64;
  const sign = (r & binary.BIT7) > 0 ? -1 : 1;
  if ((r & binary.BIT8) === 0) {
    // don't continue reading
    return sign * num
  }
  const len = decoder.arr.length;
  while (decoder.pos < len) {
    r = decoder.arr[decoder.pos++];
    // num = num | ((r & binary.BITS7) << len)
    num = num + (r & binary.BITS7) * mult;
    mult *= 128;
    if (r < binary.BIT8) {
      return sign * num
    }
    /* istanbul ignore if */
    if (num > number.MAX_SAFE_INTEGER) {
      throw errorIntegerOutOfRange
    }
  }
  throw errorUnexpectedEndOfArray
};

/**
 * Look ahead and read varUint without incrementing position
 *
 * @function
 * @param {Decoder} decoder
 * @return {number}
 */
const peekVarUint = decoder => {
  const pos = decoder.pos;
  const s = readVarUint(decoder);
  decoder.pos = pos;
  return s
};

/**
 * Look ahead and read varUint without incrementing position
 *
 * @function
 * @param {Decoder} decoder
 * @return {number}
 */
const peekVarInt = decoder => {
  const pos = decoder.pos;
  const s = readVarInt(decoder);
  decoder.pos = pos;
  return s
};

/**
 * We don't test this function anymore as we use native decoding/encoding by default now.
 * Better not modify this anymore..
 *
 * Transforming utf8 to a string is pretty expensive. The code performs 10x better
 * when String.fromCodePoint is fed with all characters as arguments.
 * But most environments have a maximum number of arguments per functions.
 * For effiency reasons we apply a maximum of 10000 characters at once.
 *
 * @function
 * @param {Decoder} decoder
 * @return {String} The read String.
 */
/* istanbul ignore next */
const _readVarStringPolyfill = decoder => {
  let remainingLen = readVarUint(decoder);
  if (remainingLen === 0) {
    return ''
  } else {
    let encodedString = String.fromCodePoint(readUint8(decoder)); // remember to decrease remainingLen
    if (--remainingLen < 100) { // do not create a Uint8Array for small strings
      while (remainingLen--) {
        encodedString += String.fromCodePoint(readUint8(decoder));
      }
    } else {
      while (remainingLen > 0) {
        const nextLen = remainingLen < 10000 ? remainingLen : 10000;
        // this is dangerous, we create a fresh array view from the existing buffer
        const bytes = decoder.arr.subarray(decoder.pos, decoder.pos + nextLen);
        decoder.pos += nextLen;
        // Starting with ES5.1 we can supply a generic array-like object as arguments
        encodedString += String.fromCodePoint.apply(null, /** @type {any} */ (bytes));
        remainingLen -= nextLen;
      }
    }
    return decodeURIComponent(escape(encodedString))
  }
};

/**
 * @function
 * @param {Decoder} decoder
 * @return {String} The read String
 */
const _readVarStringNative = decoder =>
  /** @type any */ (string.utf8TextDecoder).decode(readVarUint8Array(decoder));

/**
 * Read string of variable length
 * * varUint is used to store the length of the string
 *
 * @function
 * @param {Decoder} decoder
 * @return {String} The read String
 *
 */
/* istanbul ignore next */
const readVarString = string.utf8TextDecoder ? _readVarStringNative : _readVarStringPolyfill;

/**
 * Look ahead and read varString without incrementing position
 *
 * @function
 * @param {Decoder} decoder
 * @return {string}
 */
const peekVarString = decoder => {
  const pos = decoder.pos;
  const s = readVarString(decoder);
  decoder.pos = pos;
  return s
};

/**
 * @param {Decoder} decoder
 * @param {number} len
 * @return {DataView}
 */
const readFromDataView = (decoder, len) => {
  const dv = new DataView(decoder.arr.buffer, decoder.arr.byteOffset + decoder.pos, len);
  decoder.pos += len;
  return dv
};

/**
 * @param {Decoder} decoder
 */
const readFloat32 = decoder => readFromDataView(decoder, 4).getFloat32(0, false);

/**
 * @param {Decoder} decoder
 */
const readFloat64 = decoder => readFromDataView(decoder, 8).getFloat64(0, false);

/**
 * @param {Decoder} decoder
 */
const readBigInt64 = decoder => /** @type {any} */ (readFromDataView(decoder, 8)).getBigInt64(0, false);

/**
 * @param {Decoder} decoder
 */
const readBigUint64 = decoder => /** @type {any} */ (readFromDataView(decoder, 8)).getBigUint64(0, false);

/**
 * @type {Array<function(Decoder):any>}
 */
const readAnyLookupTable = [
  decoder => undefined, // CASE 127: undefined
  decoder => null, // CASE 126: null
  readVarInt, // CASE 125: integer
  readFloat32, // CASE 124: float32
  readFloat64, // CASE 123: float64
  readBigInt64, // CASE 122: bigint
  decoder => false, // CASE 121: boolean (false)
  decoder => true, // CASE 120: boolean (true)
  readVarString, // CASE 119: string
  decoder => { // CASE 118: object<string,any>
    const len = readVarUint(decoder);
    /**
     * @type {Object<string,any>}
     */
    const obj = {};
    for (let i = 0; i < len; i++) {
      const key = readVarString(decoder);
      obj[key] = readAny(decoder);
    }
    return obj
  },
  decoder => { // CASE 117: array<any>
    const len = readVarUint(decoder);
    const arr = [];
    for (let i = 0; i < len; i++) {
      arr.push(readAny(decoder));
    }
    return arr
  },
  readVarUint8Array // CASE 116: Uint8Array
];

/**
 * @param {Decoder} decoder
 */
const readAny = decoder => readAnyLookupTable[127 - readUint8(decoder)](decoder);

/**
 * T must not be null.
 *
 * @template T
 */
class RleDecoder extends Decoder {
  /**
   * @param {Uint8Array} uint8Array
   * @param {function(Decoder):T} reader
   */
  constructor (uint8Array, reader) {
    super(uint8Array);
    /**
     * The reader
     */
    this.reader = reader;
    /**
     * Current state
     * @type {T|null}
     */
    this.s = null;
    this.count = 0;
  }

  read () {
    if (this.count === 0) {
      this.s = this.reader(this);
      if (hasContent(this)) {
        this.count = readVarUint(this) + 1; // see encoder implementation for the reason why this is incremented
      } else {
        this.count = -1; // read the current value forever
      }
    }
    this.count--;
    return /** @type {T} */ (this.s)
  }
}

class IntDiffDecoder extends Decoder {
  /**
   * @param {Uint8Array} uint8Array
   * @param {number} start
   */
  constructor (uint8Array, start) {
    super(uint8Array);
    /**
     * Current state
     * @type {number}
     */
    this.s = start;
  }

  /**
   * @return {number}
   */
  read () {
    this.s += readVarInt(this);
    return this.s
  }
}

class RleIntDiffDecoder extends Decoder {
  /**
   * @param {Uint8Array} uint8Array
   * @param {number} start
   */
  constructor (uint8Array, start) {
    super(uint8Array);
    /**
     * Current state
     * @type {number}
     */
    this.s = start;
    this.count = 0;
  }

  /**
   * @return {number}
   */
  read () {
    if (this.count === 0) {
      this.s += readVarInt(this);
      if (hasContent(this)) {
        this.count = readVarUint(this) + 1; // see encoder implementation for the reason why this is incremented
      } else {
        this.count = -1; // read the current value forever
      }
    }
    this.count--;
    return /** @type {number} */ (this.s)
  }
}

class UintOptRleDecoder extends Decoder {
  /**
   * @param {Uint8Array} uint8Array
   */
  constructor (uint8Array) {
    super(uint8Array);
    /**
     * @type {number}
     */
    this.s = 0;
    this.count = 0;
  }

  read () {
    if (this.count === 0) {
      this.s = readVarInt(this);
      // if the sign is negative, we read the count too, otherwise count is 1
      const isNegative = math.isNegativeZero(this.s);
      this.count = 1;
      if (isNegative) {
        this.s = -this.s;
        this.count = readVarUint(this) + 2;
      }
    }
    this.count--;
    return /** @type {number} */ (this.s)
  }
}

class IncUintOptRleDecoder extends Decoder {
  /**
   * @param {Uint8Array} uint8Array
   */
  constructor (uint8Array) {
    super(uint8Array);
    /**
     * @type {number}
     */
    this.s = 0;
    this.count = 0;
  }

  read () {
    if (this.count === 0) {
      this.s = readVarInt(this);
      // if the sign is negative, we read the count too, otherwise count is 1
      const isNegative = math.isNegativeZero(this.s);
      this.count = 1;
      if (isNegative) {
        this.s = -this.s;
        this.count = readVarUint(this) + 2;
      }
    }
    this.count--;
    return /** @type {number} */ (this.s++)
  }
}

class IntDiffOptRleDecoder extends Decoder {
  /**
   * @param {Uint8Array} uint8Array
   */
  constructor (uint8Array) {
    super(uint8Array);
    /**
     * @type {number}
     */
    this.s = 0;
    this.count = 0;
    this.diff = 0;
  }

  /**
   * @return {number}
   */
  read () {
    if (this.count === 0) {
      const diff = readVarInt(this);
      // if the first bit is set, we read more data
      const hasCount = diff & 1;
      this.diff = math.floor(diff / 2); // shift >> 1
      this.count = 1;
      if (hasCount) {
        this.count = readVarUint(this) + 2;
      }
    }
    this.s += this.diff;
    this.count--;
    return this.s
  }
}

class StringDecoder {
  /**
   * @param {Uint8Array} uint8Array
   */
  constructor (uint8Array) {
    this.decoder = new UintOptRleDecoder(uint8Array);
    this.str = readVarString(this.decoder);
    /**
     * @type {number}
     */
    this.spos = 0;
  }

  /**
   * @return {string}
   */
  read () {
    const end = this.spos + this.decoder.read();
    const res = this.str.slice(this.spos, end);
    this.spos = end;
    return res
  }
}

var decoding = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Decoder: Decoder,
  createDecoder: createDecoder,
  hasContent: hasContent,
  clone: clone,
  readUint8Array: readUint8Array,
  readVarUint8Array: readVarUint8Array,
  readTailAsUint8Array: readTailAsUint8Array,
  skip8: skip8,
  readUint8: readUint8,
  readUint16: readUint16,
  readUint32: readUint32,
  readUint32BigEndian: readUint32BigEndian,
  peekUint8: peekUint8,
  peekUint16: peekUint16,
  peekUint32: peekUint32,
  readVarUint: readVarUint,
  readVarInt: readVarInt,
  peekVarUint: peekVarUint,
  peekVarInt: peekVarInt,
  _readVarStringPolyfill: _readVarStringPolyfill,
  _readVarStringNative: _readVarStringNative,
  readVarString: readVarString,
  peekVarString: peekVarString,
  readFromDataView: readFromDataView,
  readFloat32: readFloat32,
  readFloat64: readFloat64,
  readBigInt64: readBigInt64,
  readBigUint64: readBigUint64,
  readAny: readAny,
  RleDecoder: RleDecoder,
  IntDiffDecoder: IntDiffDecoder,
  RleIntDiffDecoder: RleIntDiffDecoder,
  UintOptRleDecoder: UintOptRleDecoder,
  IncUintOptRleDecoder: IncUintOptRleDecoder,
  IntDiffOptRleDecoder: IntDiffOptRleDecoder,
  StringDecoder: StringDecoder
});

/**
 * Utility functions to work with buffers (Uint8Array).
 *
 * @module buffer
 */

/**
 * @param {number} len
 */
const createUint8ArrayFromLen = len => new Uint8Array(len);

/**
 * Create Uint8Array with initial content from buffer
 *
 * @param {ArrayBuffer} buffer
 * @param {number} byteOffset
 * @param {number} length
 */
const createUint8ArrayViewFromArrayBuffer = (buffer, byteOffset, length) => new Uint8Array(buffer, byteOffset, length);

/**
 * Create Uint8Array with initial content from buffer
 *
 * @param {ArrayBuffer} buffer
 */
const createUint8ArrayFromArrayBuffer = buffer => new Uint8Array(buffer);

/* istanbul ignore next */
/**
 * @param {Uint8Array} bytes
 * @return {string}
 */
const toBase64Browser = bytes => {
  let s = '';
  for (let i = 0; i < bytes.byteLength; i++) {
    s += string.fromCharCode(bytes[i]);
  }
  // eslint-disable-next-line no-undef
  return btoa(s)
};

/**
 * @param {Uint8Array} bytes
 * @return {string}
 */
const toBase64Node = bytes => Buffer.from(bytes.buffer, bytes.byteOffset, bytes.byteLength).toString('base64');

/* istanbul ignore next */
/**
 * @param {string} s
 * @return {Uint8Array}
 */
const fromBase64Browser = s => {
  // eslint-disable-next-line no-undef
  const a = atob(s);
  const bytes = createUint8ArrayFromLen(a.length);
  for (let i = 0; i < a.length; i++) {
    bytes[i] = a.charCodeAt(i);
  }
  return bytes
};

/**
 * @param {string} s
 */
const fromBase64Node = s => {
  const buf = Buffer.from(s, 'base64');
  return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength)
};

/* istanbul ignore next */
const toBase64 = environment.isBrowser ? toBase64Browser : toBase64Node;

/* istanbul ignore next */
const fromBase64 = environment.isBrowser ? fromBase64Browser : fromBase64Node;

/**
 * Copy the content of an Uint8Array view to a new ArrayBuffer.
 *
 * @param {Uint8Array} uint8Array
 * @return {Uint8Array}
 */
const copyUint8Array = uint8Array => {
  const newBuf = createUint8ArrayFromLen(uint8Array.byteLength);
  newBuf.set(uint8Array);
  return newBuf
};

/**
 * Encode anything as a UInt8Array. It's a pun on typescripts's `any` type.
 * See encoding.writeAny for more information.
 *
 * @param {any} data
 * @return {Uint8Array}
 */
const encodeAny = data => {
  const encoder = createEncoder();
  writeAny(encoder, data);
  return toUint8Array(encoder)
};

/**
 * Decode an any-encoded value.
 *
 * @param {Uint8Array} buf
 * @return {any}
 */
const decodeAny = buf => readAny(createDecoder(buf));

var buffer = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createUint8ArrayFromLen: createUint8ArrayFromLen,
  createUint8ArrayViewFromArrayBuffer: createUint8ArrayViewFromArrayBuffer,
  createUint8ArrayFromArrayBuffer: createUint8ArrayFromArrayBuffer,
  toBase64: toBase64,
  fromBase64: fromBase64,
  copyUint8Array: copyUint8Array,
  encodeAny: encodeAny,
  decodeAny: decodeAny
});

exports.Decoder = Decoder;
exports.Encoder = Encoder;
exports.IncUintOptRleDecoder = IncUintOptRleDecoder;
exports.IncUintOptRleEncoder = IncUintOptRleEncoder;
exports.IntDiffDecoder = IntDiffDecoder;
exports.IntDiffEncoder = IntDiffEncoder;
exports.IntDiffOptRleDecoder = IntDiffOptRleDecoder;
exports.IntDiffOptRleEncoder = IntDiffOptRleEncoder;
exports.RleDecoder = RleDecoder;
exports.RleEncoder = RleEncoder;
exports.RleIntDiffDecoder = RleIntDiffDecoder;
exports.RleIntDiffEncoder = RleIntDiffEncoder;
exports.StringDecoder = StringDecoder;
exports.StringEncoder = StringEncoder;
exports.UintOptRleDecoder = UintOptRleDecoder;
exports.UintOptRleEncoder = UintOptRleEncoder;
exports._readVarStringNative = _readVarStringNative;
exports._readVarStringPolyfill = _readVarStringPolyfill;
exports._writeVarStringNative = _writeVarStringNative;
exports._writeVarStringPolyfill = _writeVarStringPolyfill;
exports.buffer = buffer;
exports.clone = clone;
exports.copyUint8Array = copyUint8Array;
exports.createDecoder = createDecoder;
exports.createEncoder = createEncoder;
exports.createUint8ArrayFromArrayBuffer = createUint8ArrayFromArrayBuffer;
exports.createUint8ArrayFromLen = createUint8ArrayFromLen;
exports.createUint8ArrayViewFromArrayBuffer = createUint8ArrayViewFromArrayBuffer;
exports.decodeAny = decodeAny;
exports.decoding = decoding;
exports.encodeAny = encodeAny;
exports.encoding = encoding;
exports.fromBase64 = fromBase64;
exports.hasContent = hasContent;
exports.length = length;
exports.peekUint16 = peekUint16;
exports.peekUint32 = peekUint32;
exports.peekUint8 = peekUint8;
exports.peekVarInt = peekVarInt;
exports.peekVarString = peekVarString;
exports.peekVarUint = peekVarUint;
exports.readAny = readAny;
exports.readBigInt64 = readBigInt64;
exports.readBigUint64 = readBigUint64;
exports.readFloat32 = readFloat32;
exports.readFloat64 = readFloat64;
exports.readFromDataView = readFromDataView;
exports.readTailAsUint8Array = readTailAsUint8Array;
exports.readUint16 = readUint16;
exports.readUint32 = readUint32;
exports.readUint32BigEndian = readUint32BigEndian;
exports.readUint8 = readUint8;
exports.readUint8Array = readUint8Array;
exports.readVarInt = readVarInt;
exports.readVarString = readVarString;
exports.readVarUint = readVarUint;
exports.readVarUint8Array = readVarUint8Array;
exports.set = set;
exports.setUint16 = setUint16;
exports.setUint32 = setUint32;
exports.setUint8 = setUint8;
exports.skip8 = skip8;
exports.toBase64 = toBase64;
exports.toUint8Array = toUint8Array;
exports.verifyLen = verifyLen;
exports.write = write;
exports.writeAny = writeAny;
exports.writeBigInt64 = writeBigInt64;
exports.writeBigUint64 = writeBigUint64;
exports.writeBinaryEncoder = writeBinaryEncoder;
exports.writeFloat32 = writeFloat32;
exports.writeFloat64 = writeFloat64;
exports.writeOnDataView = writeOnDataView;
exports.writeUint16 = writeUint16;
exports.writeUint32 = writeUint32;
exports.writeUint32BigEndian = writeUint32BigEndian;
exports.writeUint8 = writeUint8;
exports.writeUint8Array = writeUint8Array;
exports.writeVarInt = writeVarInt;
exports.writeVarString = writeVarString;
exports.writeVarUint = writeVarUint;
exports.writeVarUint8Array = writeVarUint8Array;
//# sourceMappingURL=buffer-5ebf4ddb.cjs.map


/***/ }),

/***/ 41028:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

__webpack_require__(31314);
__webpack_require__(88139);
var encoding = __webpack_require__(69731);
__webpack_require__(74268);
__webpack_require__(21291);
__webpack_require__(54001);
__webpack_require__(45163);
__webpack_require__(99915);
__webpack_require__(1507);
__webpack_require__(53115);
__webpack_require__(36482);
__webpack_require__(91869);
__webpack_require__(10219);



exports.copyUint8Array = encoding.copyUint8Array;
exports.createUint8ArrayFromArrayBuffer = encoding.createUint8ArrayFromArrayBuffer;
exports.createUint8ArrayFromLen = encoding.createUint8ArrayFromLen;
exports.createUint8ArrayViewFromArrayBuffer = encoding.createUint8ArrayViewFromArrayBuffer;
exports.decodeAny = encoding.decodeAny;
exports.encodeAny = encoding.encodeAny;
exports.fromBase64 = encoding.fromBase64;
exports.toBase64 = encoding.toBase64;
//# sourceMappingURL=buffer.cjs.map


/***/ }),

/***/ 21291:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


/**
 * Often used conditions.
 *
 * @module conditions
 */

/**
 * @template T
 * @param {T|null|undefined} v
 * @return {T|null}
 */
/* istanbul ignore next */
const undefinedToNull = v => v === undefined ? null : v;

var conditions = /*#__PURE__*/Object.freeze({
	__proto__: null,
	undefinedToNull: undefinedToNull
});

exports.conditions = conditions;
exports.undefinedToNull = undefinedToNull;
//# sourceMappingURL=conditions-fb475c70.cjs.map


/***/ }),

/***/ 60865:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var encoding = __webpack_require__(69731);
__webpack_require__(53115);
__webpack_require__(36482);
__webpack_require__(91869);
__webpack_require__(31314);
__webpack_require__(10219);
__webpack_require__(88139);
__webpack_require__(74268);
__webpack_require__(21291);
__webpack_require__(54001);
__webpack_require__(45163);
__webpack_require__(99915);
__webpack_require__(1507);



exports.Decoder = encoding.Decoder;
exports.IncUintOptRleDecoder = encoding.IncUintOptRleDecoder;
exports.IntDiffDecoder = encoding.IntDiffDecoder;
exports.IntDiffOptRleDecoder = encoding.IntDiffOptRleDecoder;
exports.RleDecoder = encoding.RleDecoder;
exports.RleIntDiffDecoder = encoding.RleIntDiffDecoder;
exports.StringDecoder = encoding.StringDecoder;
exports.UintOptRleDecoder = encoding.UintOptRleDecoder;
exports._readVarStringNative = encoding._readVarStringNative;
exports._readVarStringPolyfill = encoding._readVarStringPolyfill;
exports.clone = encoding.clone;
exports.createDecoder = encoding.createDecoder;
exports.hasContent = encoding.hasContent;
exports.peekUint16 = encoding.peekUint16;
exports.peekUint32 = encoding.peekUint32;
exports.peekUint8 = encoding.peekUint8;
exports.peekVarInt = encoding.peekVarInt;
exports.peekVarString = encoding.peekVarString;
exports.peekVarUint = encoding.peekVarUint;
exports.readAny = encoding.readAny;
exports.readBigInt64 = encoding.readBigInt64;
exports.readBigUint64 = encoding.readBigUint64;
exports.readFloat32 = encoding.readFloat32;
exports.readFloat64 = encoding.readFloat64;
exports.readFromDataView = encoding.readFromDataView;
exports.readTailAsUint8Array = encoding.readTailAsUint8Array;
exports.readUint16 = encoding.readUint16;
exports.readUint32 = encoding.readUint32;
exports.readUint32BigEndian = encoding.readUint32BigEndian;
exports.readUint8 = encoding.readUint8;
exports.readUint8Array = encoding.readUint8Array;
exports.readVarInt = encoding.readVarInt;
exports.readVarString = encoding.readVarString;
exports.readVarUint = encoding.readVarUint;
exports.readVarUint8Array = encoding.readVarUint8Array;
exports.skip8 = encoding.skip8;
//# sourceMappingURL=decoding.cjs.map


/***/ }),

/***/ 42081:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var pair = __webpack_require__(77505);
var map = __webpack_require__(74268);

/* eslint-env browser */

/* istanbul ignore next */
/**
 * @type {Document}
 */
const doc = /** @type {Document} */ (typeof document !== 'undefined' ? document : {});

/**
 * @param {string} name
 * @return {HTMLElement}
 */
/* istanbul ignore next */
const createElement = name => doc.createElement(name);

/**
 * @return {DocumentFragment}
 */
/* istanbul ignore next */
const createDocumentFragment = () => doc.createDocumentFragment();

/**
 * @param {string} text
 * @return {Text}
 */
/* istanbul ignore next */
const createTextNode = text => doc.createTextNode(text);

/* istanbul ignore next */
const domParser = /** @type {DOMParser} */ (typeof DOMParser !== 'undefined' ? new DOMParser() : null);

/**
 * @param {HTMLElement} el
 * @param {string} name
 * @param {Object} opts
 */
/* istanbul ignore next */
const emitCustomEvent = (el, name, opts) => el.dispatchEvent(new CustomEvent(name, opts));

/**
 * @param {Element} el
 * @param {Array<pair.Pair<string,string|boolean>>} attrs Array of key-value pairs
 * @return {Element}
 */
/* istanbul ignore next */
const setAttributes = (el, attrs) => {
  pair.forEach(attrs, (key, value) => {
    if (value === false) {
      el.removeAttribute(key);
    } else if (value === true) {
      el.setAttribute(key, '');
    } else {
      // @ts-ignore
      el.setAttribute(key, value);
    }
  });
  return el
};

/**
 * @param {Element} el
 * @param {Map<string, string>} attrs Array of key-value pairs
 * @return {Element}
 */
/* istanbul ignore next */
const setAttributesMap = (el, attrs) => {
  attrs.forEach((value, key) => { el.setAttribute(key, value); });
  return el
};

/**
 * @param {Array<Node>|HTMLCollection} children
 * @return {DocumentFragment}
 */
/* istanbul ignore next */
const fragment = children => {
  const fragment = createDocumentFragment();
  for (let i = 0; i < children.length; i++) {
    appendChild(fragment, children[i]);
  }
  return fragment
};

/**
 * @param {Element} parent
 * @param {Array<Node>} nodes
 * @return {Element}
 */
/* istanbul ignore next */
const append = (parent, nodes) => {
  appendChild(parent, fragment(nodes));
  return parent
};

/**
 * @param {HTMLElement} el
 */
/* istanbul ignore next */
const remove = el => el.remove();

/**
 * @param {EventTarget} el
 * @param {string} name
 * @param {EventListener} f
 */
/* istanbul ignore next */
const addEventListener = (el, name, f) => el.addEventListener(name, f);

/**
 * @param {EventTarget} el
 * @param {string} name
 * @param {EventListener} f
 */
/* istanbul ignore next */
const removeEventListener = (el, name, f) => el.removeEventListener(name, f);

/**
 * @param {Node} node
 * @param {Array<pair.Pair<string,EventListener>>} listeners
 * @return {Node}
 */
/* istanbul ignore next */
const addEventListeners = (node, listeners) => {
  pair.forEach(listeners, (name, f) => addEventListener(node, name, f));
  return node
};

/**
 * @param {Node} node
 * @param {Array<pair.Pair<string,EventListener>>} listeners
 * @return {Node}
 */
/* istanbul ignore next */
const removeEventListeners = (node, listeners) => {
  pair.forEach(listeners, (name, f) => removeEventListener(node, name, f));
  return node
};

/**
 * @param {string} name
 * @param {Array<pair.Pair<string,string>|pair.Pair<string,boolean>>} attrs Array of key-value pairs
 * @param {Array<Node>} children
 * @return {Element}
 */
/* istanbul ignore next */
const element = (name, attrs = [], children = []) =>
  append(setAttributes(createElement(name), attrs), children);

/**
 * @param {number} width
 * @param {number} height
 */
/* istanbul ignore next */
const canvas = (width, height) => {
  const c = /** @type {HTMLCanvasElement} */ (createElement('canvas'));
  c.height = height;
  c.width = width;
  return c
};

/**
 * @param {string} t
 * @return {Text}
 */
/* istanbul ignore next */
const text = createTextNode;

/**
 * @param {pair.Pair<string,string>} pair
 */
/* istanbul ignore next */
const pairToStyleString = pair => `${pair.left}:${pair.right};`;

/**
 * @param {Array<pair.Pair<string,string>>} pairs
 * @return {string}
 */
/* istanbul ignore next */
const pairsToStyleString = pairs => pairs.map(pairToStyleString).join('');

/**
 * @param {Map<string,string>} m
 * @return {string}
 */
/* istanbul ignore next */
const mapToStyleString = m => map.map(m, (value, key) => `${key}:${value};`).join('');

/**
 * @todo should always query on a dom element
 *
 * @param {HTMLElement|ShadowRoot} el
 * @param {string} query
 * @return {HTMLElement | null}
 */
/* istanbul ignore next */
const querySelector = (el, query) => el.querySelector(query);

/**
 * @param {HTMLElement|ShadowRoot} el
 * @param {string} query
 * @return {NodeListOf<HTMLElement>}
 */
/* istanbul ignore next */
const querySelectorAll = (el, query) => el.querySelectorAll(query);

/**
 * @param {string} id
 * @return {HTMLElement}
 */
/* istanbul ignore next */
const getElementById = id => /** @type {HTMLElement} */ (doc.getElementById(id));

/**
 * @param {string} html
 * @return {HTMLElement}
 */
/* istanbul ignore next */
const _parse = html => domParser.parseFromString(`<html><body>${html}</body></html>`, 'text/html').body;

/**
 * @param {string} html
 * @return {DocumentFragment}
 */
/* istanbul ignore next */
const parseFragment = html => fragment(/** @type {any} */ (_parse(html).childNodes));

/**
 * @param {string} html
 * @return {HTMLElement}
 */
/* istanbul ignore next */
const parseElement = html => /** @type HTMLElement */ (_parse(html).firstElementChild);

/**
 * @param {HTMLElement} oldEl
 * @param {HTMLElement|DocumentFragment} newEl
 */
/* istanbul ignore next */
const replaceWith = (oldEl, newEl) => oldEl.replaceWith(newEl);

/**
 * @param {HTMLElement} parent
 * @param {HTMLElement} el
 * @param {Node|null} ref
 * @return {HTMLElement}
 */
/* istanbul ignore next */
const insertBefore = (parent, el, ref) => parent.insertBefore(el, ref);

/**
 * @param {Node} parent
 * @param {Node} child
 * @return {Node}
 */
/* istanbul ignore next */
const appendChild = (parent, child) => parent.appendChild(child);

const ELEMENT_NODE = doc.ELEMENT_NODE;
const TEXT_NODE = doc.TEXT_NODE;
const CDATA_SECTION_NODE = doc.CDATA_SECTION_NODE;
const COMMENT_NODE = doc.COMMENT_NODE;
const DOCUMENT_NODE = doc.DOCUMENT_NODE;
const DOCUMENT_TYPE_NODE = doc.DOCUMENT_TYPE_NODE;
const DOCUMENT_FRAGMENT_NODE = doc.DOCUMENT_FRAGMENT_NODE;

/**
 * @param {any} node
 * @param {number} type
 */
const checkNodeType = (node, type) => node.nodeType === type;

/**
 * @param {Node} parent
 * @param {HTMLElement} child
 */
const isParentOf = (parent, child) => {
  let p = child.parentNode;
  while (p && p !== parent) {
    p = p.parentNode;
  }
  return p === parent
};

var dom = /*#__PURE__*/Object.freeze({
  __proto__: null,
  doc: doc,
  createElement: createElement,
  createDocumentFragment: createDocumentFragment,
  createTextNode: createTextNode,
  domParser: domParser,
  emitCustomEvent: emitCustomEvent,
  setAttributes: setAttributes,
  setAttributesMap: setAttributesMap,
  fragment: fragment,
  append: append,
  remove: remove,
  addEventListener: addEventListener,
  removeEventListener: removeEventListener,
  addEventListeners: addEventListeners,
  removeEventListeners: removeEventListeners,
  element: element,
  canvas: canvas,
  text: text,
  pairToStyleString: pairToStyleString,
  pairsToStyleString: pairsToStyleString,
  mapToStyleString: mapToStyleString,
  querySelector: querySelector,
  querySelectorAll: querySelectorAll,
  getElementById: getElementById,
  parseFragment: parseFragment,
  parseElement: parseElement,
  replaceWith: replaceWith,
  insertBefore: insertBefore,
  appendChild: appendChild,
  ELEMENT_NODE: ELEMENT_NODE,
  TEXT_NODE: TEXT_NODE,
  CDATA_SECTION_NODE: CDATA_SECTION_NODE,
  COMMENT_NODE: COMMENT_NODE,
  DOCUMENT_NODE: DOCUMENT_NODE,
  DOCUMENT_TYPE_NODE: DOCUMENT_TYPE_NODE,
  DOCUMENT_FRAGMENT_NODE: DOCUMENT_FRAGMENT_NODE,
  checkNodeType: checkNodeType,
  isParentOf: isParentOf
});

exports.CDATA_SECTION_NODE = CDATA_SECTION_NODE;
exports.COMMENT_NODE = COMMENT_NODE;
exports.DOCUMENT_FRAGMENT_NODE = DOCUMENT_FRAGMENT_NODE;
exports.DOCUMENT_NODE = DOCUMENT_NODE;
exports.DOCUMENT_TYPE_NODE = DOCUMENT_TYPE_NODE;
exports.ELEMENT_NODE = ELEMENT_NODE;
exports.TEXT_NODE = TEXT_NODE;
exports.addEventListener = addEventListener;
exports.addEventListeners = addEventListeners;
exports.append = append;
exports.appendChild = appendChild;
exports.canvas = canvas;
exports.checkNodeType = checkNodeType;
exports.createDocumentFragment = createDocumentFragment;
exports.createElement = createElement;
exports.createTextNode = createTextNode;
exports.doc = doc;
exports.dom = dom;
exports.domParser = domParser;
exports.element = element;
exports.emitCustomEvent = emitCustomEvent;
exports.fragment = fragment;
exports.getElementById = getElementById;
exports.insertBefore = insertBefore;
exports.isParentOf = isParentOf;
exports.mapToStyleString = mapToStyleString;
exports.pairToStyleString = pairToStyleString;
exports.pairsToStyleString = pairsToStyleString;
exports.parseElement = parseElement;
exports.parseFragment = parseFragment;
exports.querySelector = querySelector;
exports.querySelectorAll = querySelectorAll;
exports.remove = remove;
exports.removeEventListener = removeEventListener;
exports.removeEventListeners = removeEventListeners;
exports.replaceWith = replaceWith;
exports.setAttributes = setAttributes;
exports.setAttributesMap = setAttributesMap;
exports.text = text;
//# sourceMappingURL=dom-58958c04.cjs.map


/***/ }),

/***/ 32979:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var encoding = __webpack_require__(69731);
__webpack_require__(36482);
__webpack_require__(91869);
__webpack_require__(53115);
__webpack_require__(31314);
__webpack_require__(88139);
__webpack_require__(74268);
__webpack_require__(21291);
__webpack_require__(54001);
__webpack_require__(45163);
__webpack_require__(99915);
__webpack_require__(1507);
__webpack_require__(10219);



exports.Encoder = encoding.Encoder;
exports.IncUintOptRleEncoder = encoding.IncUintOptRleEncoder;
exports.IntDiffEncoder = encoding.IntDiffEncoder;
exports.IntDiffOptRleEncoder = encoding.IntDiffOptRleEncoder;
exports.RleEncoder = encoding.RleEncoder;
exports.RleIntDiffEncoder = encoding.RleIntDiffEncoder;
exports.StringEncoder = encoding.StringEncoder;
exports.UintOptRleEncoder = encoding.UintOptRleEncoder;
exports._writeVarStringNative = encoding._writeVarStringNative;
exports._writeVarStringPolyfill = encoding._writeVarStringPolyfill;
exports.createEncoder = encoding.createEncoder;
exports.length = encoding.length;
exports.set = encoding.set;
exports.setUint16 = encoding.setUint16;
exports.setUint32 = encoding.setUint32;
exports.setUint8 = encoding.setUint8;
exports.toUint8Array = encoding.toUint8Array;
exports.verifyLen = encoding.verifyLen;
exports.write = encoding.write;
exports.writeAny = encoding.writeAny;
exports.writeBigInt64 = encoding.writeBigInt64;
exports.writeBigUint64 = encoding.writeBigUint64;
exports.writeBinaryEncoder = encoding.writeBinaryEncoder;
exports.writeFloat32 = encoding.writeFloat32;
exports.writeFloat64 = encoding.writeFloat64;
exports.writeOnDataView = encoding.writeOnDataView;
exports.writeUint16 = encoding.writeUint16;
exports.writeUint32 = encoding.writeUint32;
exports.writeUint32BigEndian = encoding.writeUint32BigEndian;
exports.writeUint8 = encoding.writeUint8;
exports.writeUint8Array = encoding.writeUint8Array;
exports.writeVarInt = encoding.writeVarInt;
exports.writeVarString = encoding.writeVarString;
exports.writeVarUint = encoding.writeVarUint;
exports.writeVarUint8Array = encoding.writeVarUint8Array;
//# sourceMappingURL=encoding.cjs.map


/***/ }),

/***/ 88139:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var map = __webpack_require__(74268);
var string = __webpack_require__(31314);
var conditions = __webpack_require__(21291);
var storage = __webpack_require__(54001);
var _function = __webpack_require__(45163);

/**
 * Isomorphic module to work access the environment (query params, env variables).
 *
 * @module map
 */

/* istanbul ignore next */
// @ts-ignore
const isNode = typeof process !== 'undefined' && process.release &&
  /node|io\.js/.test(process.release.name);
/* istanbul ignore next */
const isBrowser = typeof window !== 'undefined' && !isNode;
/* istanbul ignore next */
const isMac = typeof navigator !== 'undefined'
  ? /Mac/.test(navigator.platform)
  : false;

/**
 * @type {Map<string,string>}
 */
let params;

/* istanbul ignore next */
const computeParams = () => {
  if (params === undefined) {
    if (isNode) {
      params = map.create();
      const pargs = process.argv;
      let currParamName = null;
      /* istanbul ignore next */
      for (let i = 0; i < pargs.length; i++) {
        const parg = pargs[i];
        if (parg[0] === '-') {
          if (currParamName !== null) {
            params.set(currParamName, '');
          }
          currParamName = parg;
        } else {
          if (currParamName !== null) {
            params.set(currParamName, parg);
            currParamName = null;
          }
        }
      }
      if (currParamName !== null) {
        params.set(currParamName, '');
      }
      // in ReactNative for example this would not be true (unless connected to the Remote Debugger)
    } else if (typeof location === 'object') {
      params = map.create(); // eslint-disable-next-line no-undef
      (location.search || '?').slice(1).split('&').forEach((kv) => {
        if (kv.length !== 0) {
          const [key, value] = kv.split('=');
          params.set(`--${string.fromCamelCase(key, '-')}`, value);
          params.set(`-${string.fromCamelCase(key, '-')}`, value);
        }
      });
    } else {
      params = map.create();
    }
  }
  return params
};

/**
 * @param {string} name
 * @return {boolean}
 */
/* istanbul ignore next */
const hasParam = (name) => computeParams().has(name);

/**
 * @param {string} name
 * @param {string} defaultVal
 * @return {string}
 */
/* istanbul ignore next */
const getParam = (name, defaultVal) =>
  computeParams().get(name) || defaultVal;
// export const getArgs = name => computeParams() && args

/**
 * @param {string} name
 * @return {string|null}
 */
/* istanbul ignore next */
const getVariable = (name) =>
  isNode
    ? conditions.undefinedToNull(process.env[name.toUpperCase()])
    : conditions.undefinedToNull(storage.varStorage.getItem(name));

/**
 * @param {string} name
 * @return {string|null}
 */
const getConf = (name) =>
  computeParams().get('--' + name) || getVariable(name);

/**
 * @param {string} name
 * @return {boolean}
 */
/* istanbul ignore next */
const hasConf = (name) =>
  hasParam('--' + name) || getVariable(name) !== null;

/* istanbul ignore next */
const production = hasConf('production');

/* istanbul ignore next */
const forceColor = isNode &&
  _function.isOneOf(process.env.FORCE_COLOR, ['true', '1', '2']);

/* istanbul ignore next */
const supportsColor = !hasParam('no-colors') &&
  (!isNode || process.stdout.isTTY || forceColor) && (
  !isNode || hasParam('color') || forceColor ||
    getVariable('COLORTERM') !== null ||
    (getVariable('TERM') || '').includes('color')
);

var environment = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isNode: isNode,
  isBrowser: isBrowser,
  isMac: isMac,
  hasParam: hasParam,
  getParam: getParam,
  getVariable: getVariable,
  getConf: getConf,
  hasConf: hasConf,
  production: production,
  supportsColor: supportsColor
});

exports.environment = environment;
exports.getConf = getConf;
exports.getParam = getParam;
exports.getVariable = getVariable;
exports.hasConf = hasConf;
exports.hasParam = hasParam;
exports.isBrowser = isBrowser;
exports.isMac = isMac;
exports.isNode = isNode;
exports.production = production;
exports.supportsColor = supportsColor;
//# sourceMappingURL=environment-9ecc1776.cjs.map


/***/ }),

/***/ 10219:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


/**
 * Error helpers.
 *
 * @module error
 */

/* istanbul ignore next */
/**
 * @param {string} s
 * @return {Error}
 */
const create = s => new Error(s);

/* istanbul ignore next */
/**
 * @throws {Error}
 * @return {never}
 */
const methodUnimplemented = () => {
  throw create('Method unimplemented')
};

/* istanbul ignore next */
/**
 * @throws {Error}
 * @return {never}
 */
const unexpectedCase = () => {
  throw create('Unexpected case')
};

var error = /*#__PURE__*/Object.freeze({
  __proto__: null,
  create: create,
  methodUnimplemented: methodUnimplemented,
  unexpectedCase: unexpectedCase
});

exports.create = create;
exports.error = error;
exports.methodUnimplemented = methodUnimplemented;
exports.unexpectedCase = unexpectedCase;
//# sourceMappingURL=error-873c9cbf.cjs.map


/***/ }),

/***/ 4560:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var error = __webpack_require__(10219);



exports.create = error.create;
exports.methodUnimplemented = error.methodUnimplemented;
exports.unexpectedCase = error.unexpectedCase;
//# sourceMappingURL=error.cjs.map


/***/ }),

/***/ 60396:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


/* global requestIdleCallback, requestAnimationFrame, cancelIdleCallback, cancelAnimationFrame */

/**
 * Utility module to work with EcmaScript's event loop.
 *
 * @module eventloop
 */

/**
 * @type {Array<function>}
 */
let queue = [];

const _runQueue = () => {
  for (let i = 0; i < queue.length; i++) {
    queue[i]();
  }
  queue = [];
};

/**
 * @param {function():void} f
 */
const enqueue = f => {
  queue.push(f);
  if (queue.length === 1) {
    setTimeout(_runQueue, 0);
  }
};

/**
 * @typedef {Object} TimeoutObject
 * @property {function} TimeoutObject.destroy
 */

/**
 * @param {function(number):void} clearFunction
 */
const createTimeoutClass = clearFunction => class TT {
  /**
   * @param {number} timeoutId
   */
  constructor (timeoutId) {
    this._ = timeoutId;
  }

  destroy () {
    clearFunction(this._);
  }
};

const Timeout = createTimeoutClass(clearTimeout);

/**
 * @param {number} timeout
 * @param {function} callback
 * @return {TimeoutObject}
 */
const timeout = (timeout, callback) => new Timeout(setTimeout(callback, timeout));

const Interval = createTimeoutClass(clearInterval);

/**
 * @param {number} timeout
 * @param {function} callback
 * @return {TimeoutObject}
 */
const interval = (timeout, callback) => new Interval(setInterval(callback, timeout));

/* istanbul ignore next */
const Animation = createTimeoutClass(arg => typeof requestAnimationFrame !== 'undefined' && cancelAnimationFrame(arg));

/* istanbul ignore next */
/**
 * @param {function(number):void} cb
 * @return {TimeoutObject}
 */
const animationFrame = cb => typeof requestAnimationFrame === 'undefined' ? timeout(0, cb) : new Animation(requestAnimationFrame(cb));

/* istanbul ignore next */
// @ts-ignore
const Idle = createTimeoutClass(arg => typeof cancelIdleCallback !== 'undefined' && cancelIdleCallback(arg));

/* istanbul ignore next */
/**
 * Note: this is experimental and is probably only useful in browsers.
 *
 * @param {function} cb
 * @return {TimeoutObject}
 */
// @ts-ignore
const idleCallback = cb => typeof requestIdleCallback !== 'undefined' ? new Idle(requestIdleCallback(cb)) : timeout(1000, cb);

/**
 * @param {number} timeout Timeout of the debounce action
 * @return {function(function():void):void}
 */
const createDebouncer = timeout => {
  let timer = -1;
  return f => {
    clearTimeout(timer);
    if (f) {
      timer = /** @type {any} */ (setTimeout(f, timeout));
    }
  }
};

var eventloop = /*#__PURE__*/Object.freeze({
  __proto__: null,
  enqueue: enqueue,
  timeout: timeout,
  interval: interval,
  Animation: Animation,
  animationFrame: animationFrame,
  idleCallback: idleCallback,
  createDebouncer: createDebouncer
});

exports.Animation = Animation;
exports.animationFrame = animationFrame;
exports.createDebouncer = createDebouncer;
exports.enqueue = enqueue;
exports.eventloop = eventloop;
exports.idleCallback = idleCallback;
exports.interval = interval;
exports.timeout = timeout;
//# sourceMappingURL=eventloop-c60b5658.cjs.map


/***/ }),

/***/ 45163:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var array = __webpack_require__(99915);
var object = __webpack_require__(1507);

/**
 * Common functions and function call helpers.
 *
 * @module function
 */

/**
 * Calls all functions in `fs` with args. Only throws after all functions were called.
 *
 * @param {Array<function>} fs
 * @param {Array<any>} args
 */
const callAll = (fs, args, i = 0) => {
  try {
    for (; i < fs.length; i++) {
      fs[i](...args);
    }
  } finally {
    if (i < fs.length) {
      callAll(fs, args, i + 1);
    }
  }
};

const nop = () => {};

/**
 * @template T
 * @param {function():T} f
 * @return {T}
 */
const apply = f => f();

/**
 * @template A
 *
 * @param {A} a
 * @return {A}
 */
const id = a => a;

/**
 * @template T
 *
 * @param {T} a
 * @param {T} b
 * @return {boolean}
 */
const equalityStrict = (a, b) => a === b;

/**
 * @template T
 *
 * @param {Array<T>|object} a
 * @param {Array<T>|object} b
 * @return {boolean}
 */
const equalityFlat = (a, b) => a === b || (a != null && b != null && a.constructor === b.constructor && ((a instanceof Array && array.equalFlat(a, /** @type {Array<T>} */ (b))) || (typeof a === 'object' && object.equalFlat(a, b))));

/**
 * @param {any} a
 * @param {any} b
 * @return {boolean}
 */
const equalityDeep = (a, b) => {
  if (a == null || b == null) {
    return equalityStrict(a, b)
  }
  if (a.constructor !== b.constructor) {
    return false
  }
  if (a === b) {
    return true
  }
  switch (a.constructor) {
    case ArrayBuffer:
      a = new Uint8Array(a);
      b = new Uint8Array(b);
    // eslint-disable-next-line no-fallthrough
    case Uint8Array: {
      if (a.byteLength !== b.byteLength) {
        return false
      }
      for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) {
          return false
        }
      }
      break
    }
    case Set: {
      if (a.size !== b.size) {
        return false
      }
      for (const value of a) {
        if (!b.has(value)) {
          return false
        }
      }
      break
    }
    case Map: {
      if (a.size !== b.size) {
        return false
      }
      for (const key of a.keys()) {
        if (!b.has(key) || !equalityDeep(a.get(key), b.get(key))) {
          return false
        }
      }
      break
    }
    case Object:
      if (object.length(a) !== object.length(b)) {
        return false
      }
      for (const key in a) {
        if (!object.hasProperty(a, key) || !equalityDeep(a[key], b[key])) {
          return false
        }
      }
      break
    case Array:
      if (a.length !== b.length) {
        return false
      }
      for (let i = 0; i < a.length; i++) {
        if (!equalityDeep(a[i], b[i])) {
          return false
        }
      }
      break
    default:
      return false
  }
  return true
};

/**
 * @template V
 * @template {V} OPTS
 *
 * @param {V} value
 * @param {Array<OPTS>} options
 */
// @ts-ignore
const isOneOf = (value, options) => options.includes(value);

var _function = /*#__PURE__*/Object.freeze({
  __proto__: null,
  callAll: callAll,
  nop: nop,
  apply: apply,
  id: id,
  equalityStrict: equalityStrict,
  equalityFlat: equalityFlat,
  equalityDeep: equalityDeep,
  isOneOf: isOneOf
});

exports._function = _function;
exports.apply = apply;
exports.callAll = callAll;
exports.equalityDeep = equalityDeep;
exports.equalityFlat = equalityFlat;
exports.equalityStrict = equalityStrict;
exports.id = id;
exports.isOneOf = isOneOf;
exports.nop = nop;
//# sourceMappingURL=function-0da7a13f.cjs.map


/***/ }),

/***/ 13039:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

__webpack_require__(99915);
__webpack_require__(1507);
var _function = __webpack_require__(45163);



exports.apply = _function.apply;
exports.callAll = _function.callAll;
exports.equalityDeep = _function.equalityDeep;
exports.equalityFlat = _function.equalityFlat;
exports.equalityStrict = _function.equalityStrict;
exports.id = _function.id;
exports.isOneOf = _function.isOneOf;
exports.nop = _function.nop;
//# sourceMappingURL=function.cjs.map


/***/ }),

/***/ 76073:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


/**
 * Utility module to create and manipulate Iterators.
 *
 * @module iterator
 */

/**
 * @template T,R
 * @param {Iterator<T>} iterator
 * @param {function(T):R} f
 * @return {IterableIterator<R>}
 */
const mapIterator = (iterator, f) => ({
  [Symbol.iterator] () {
    return this
  },
  // @ts-ignore
  next () {
    const r = iterator.next();
    return { value: r.done ? undefined : f(r.value), done: r.done }
  }
});

/**
 * @template T
 * @param {function():IteratorResult<T>} next
 * @return {IterableIterator<T>}
 */
const createIterator = next => ({
  /**
   * @return {IterableIterator<T>}
   */
  [Symbol.iterator] () {
    return this
  },
  // @ts-ignore
  next
});

/**
 * @template T
 * @param {Iterator<T>} iterator
 * @param {function(T):boolean} filter
 */
const iteratorFilter = (iterator, filter) => createIterator(() => {
  let res;
  do {
    res = iterator.next();
  } while (!res.done && !filter(res.value))
  return res
});

/**
 * @template T,M
 * @param {Iterator<T>} iterator
 * @param {function(T):M} fmap
 */
const iteratorMap = (iterator, fmap) => createIterator(() => {
  const { done, value } = iterator.next();
  return { done, value: done ? undefined : fmap(value) }
});

var iterator = /*#__PURE__*/Object.freeze({
  __proto__: null,
  mapIterator: mapIterator,
  createIterator: createIterator,
  iteratorFilter: iteratorFilter,
  iteratorMap: iteratorMap
});

exports.createIterator = createIterator;
exports.iterator = iterator;
exports.iteratorFilter = iteratorFilter;
exports.iteratorMap = iteratorMap;
exports.mapIterator = mapIterator;
//# sourceMappingURL=iterator-9fc627c1.cjs.map


/***/ }),

/***/ 18263:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var iterator = __webpack_require__(76073);



exports.createIterator = iterator.createIterator;
exports.iteratorFilter = iterator.iteratorFilter;
exports.iteratorMap = iterator.iteratorMap;
exports.mapIterator = iterator.mapIterator;
//# sourceMappingURL=iterator.cjs.map


/***/ }),

/***/ 68447:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


/**
 * JSON utility functions.
 *
 * @module json
 */

/**
 * Transform JavaScript object to JSON.
 *
 * @param {any} object
 * @return {string}
 */
const stringify = JSON.stringify;

/**
 * Parse JSON object.
 *
 * @param {string} json
 * @return {any}
 */
const parse = JSON.parse;

var json = /*#__PURE__*/Object.freeze({
	__proto__: null,
	stringify: stringify,
	parse: parse
});

exports.json = json;
exports.parse = parse;
exports.stringify = stringify;
//# sourceMappingURL=json-092190a1.cjs.map


/***/ }),

/***/ 98850:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var environment = __webpack_require__(88139);
var symbol = __webpack_require__(26096);
var pair = __webpack_require__(77505);
var dom = __webpack_require__(42081);
var json = __webpack_require__(68447);
var map = __webpack_require__(74268);
var eventloop = __webpack_require__(60396);
var math = __webpack_require__(36482);
var time = __webpack_require__(35331);
var _function = __webpack_require__(45163);

/**
 * Isomorphic logging module with support for colors!
 *
 * @module logging
 */

const BOLD = symbol.create();
const UNBOLD = symbol.create();
const BLUE = symbol.create();
const GREY = symbol.create();
const GREEN = symbol.create();
const RED = symbol.create();
const PURPLE = symbol.create();
const ORANGE = symbol.create();
const UNCOLOR = symbol.create();

/**
 * @type {Object<Symbol,pair.Pair<string,string>>}
 */
const _browserStyleMap = {
  [BOLD]: pair.create('font-weight', 'bold'),
  [UNBOLD]: pair.create('font-weight', 'normal'),
  [BLUE]: pair.create('color', 'blue'),
  [GREEN]: pair.create('color', 'green'),
  [GREY]: pair.create('color', 'grey'),
  [RED]: pair.create('color', 'red'),
  [PURPLE]: pair.create('color', 'purple'),
  [ORANGE]: pair.create('color', 'orange'), // not well supported in chrome when debugging node with inspector - TODO: deprecate
  [UNCOLOR]: pair.create('color', 'black')
};

const _nodeStyleMap = {
  [BOLD]: '\u001b[1m',
  [UNBOLD]: '\u001b[2m',
  [BLUE]: '\x1b[34m',
  [GREEN]: '\x1b[32m',
  [GREY]: '\u001b[37m',
  [RED]: '\x1b[31m',
  [PURPLE]: '\x1b[35m',
  [ORANGE]: '\x1b[38;5;208m',
  [UNCOLOR]: '\x1b[0m'
};

/* istanbul ignore next */
/**
 * @param {Array<string|Symbol|Object|number>} args
 * @return {Array<string|object|number>}
 */
const computeBrowserLoggingArgs = (args) => {
  const strBuilder = [];
  const styles = [];
  const currentStyle = map.create();
  /**
   * @type {Array<string|Object|number>}
   */
  let logArgs = [];
  // try with formatting until we find something unsupported
  let i = 0;

  for (; i < args.length; i++) {
    const arg = args[i];
    // @ts-ignore
    const style = _browserStyleMap[arg];
    if (style !== undefined) {
      currentStyle.set(style.left, style.right);
    } else {
      if (arg.constructor === String || arg.constructor === Number) {
        const style = dom.mapToStyleString(currentStyle);
        if (i > 0 || style.length > 0) {
          strBuilder.push('%c' + arg);
          styles.push(style);
        } else {
          strBuilder.push(arg);
        }
      } else {
        break
      }
    }
  }

  if (i > 0) {
    // create logArgs with what we have so far
    logArgs = styles;
    logArgs.unshift(strBuilder.join(''));
  }
  // append the rest
  for (; i < args.length; i++) {
    const arg = args[i];
    if (!(arg instanceof Symbol)) {
      logArgs.push(arg);
    }
  }
  return logArgs
};

/* istanbul ignore next */
/**
 * @param {Array<string|Symbol|Object|number>} args
 * @return {Array<string|object|number>}
 */
const computeNoColorLoggingArgs = args => {
  const strBuilder = [];
  const logArgs = [];

  // try with formatting until we find something unsupported
  let i = 0;

  for (; i < args.length; i++) {
    const arg = args[i];
    // @ts-ignore
    const style = _nodeStyleMap[arg];
    if (style === undefined) {
      if (arg.constructor === String || arg.constructor === Number) {
        strBuilder.push(arg);
      } else {
        break
      }
    }
  }
  if (i > 0) {
    logArgs.push(strBuilder.join(''));
  }
  // append the rest
  for (; i < args.length; i++) {
    const arg = args[i];
    /* istanbul ignore else */
    if (!(arg instanceof Symbol)) {
      if (arg.constructor === Object) {
        logArgs.push(JSON.stringify(arg));
      } else {
        logArgs.push(arg);
      }
    }
  }
  return logArgs
};

/* istanbul ignore next */
/**
 * @param {Array<string|Symbol|Object|number>} args
 * @return {Array<string|object|number>}
 */
const computeNodeLoggingArgs = (args) => {
  const strBuilder = [];
  const logArgs = [];

  // try with formatting until we find something unsupported
  let i = 0;

  for (; i < args.length; i++) {
    const arg = args[i];
    // @ts-ignore
    const style = _nodeStyleMap[arg];
    if (style !== undefined) {
      strBuilder.push(style);
    } else {
      if (arg.constructor === String || arg.constructor === Number) {
        strBuilder.push(arg);
      } else {
        break
      }
    }
  }
  if (i > 0) {
    // create logArgs with what we have so far
    strBuilder.push('\x1b[0m');
    logArgs.push(strBuilder.join(''));
  }
  // append the rest
  for (; i < args.length; i++) {
    const arg = args[i];
    /* istanbul ignore else */
    if (!(arg instanceof Symbol)) {
      logArgs.push(arg);
    }
  }
  return logArgs
};

/* istanbul ignore next */
const computeLoggingArgs = environment.supportsColor
  ? (environment.isNode ? computeNodeLoggingArgs : computeBrowserLoggingArgs)
  : computeNoColorLoggingArgs;

/**
 * @param {Array<string|Symbol|Object|number>} args
 */
const print = (...args) => {
  console.log(...computeLoggingArgs(args));
  /* istanbul ignore next */
  vconsoles.forEach((vc) => vc.print(args));
};

/* istanbul ignore next */
/**
 * @param {Array<string|Symbol|Object|number>} args
 */
const warn = (...args) => {
  console.warn(...computeLoggingArgs(args));
  args.unshift(ORANGE);
  vconsoles.forEach((vc) => vc.print(args));
};

/* istanbul ignore next */
/**
 * @param {Error} err
 */
const printError = (err) => {
  console.error(err);
  vconsoles.forEach((vc) => vc.printError(err));
};

/* istanbul ignore next */
/**
 * @param {string} url image location
 * @param {number} height height of the image in pixel
 */
const printImg = (url, height) => {
  if (environment.isBrowser) {
    console.log(
      '%c                      ',
      `font-size: ${height}px; background-size: contain; background-repeat: no-repeat; background-image: url(${url})`
    );
    // console.log('%c                ', `font-size: ${height}x; background: url(${url}) no-repeat;`)
  }
  vconsoles.forEach((vc) => vc.printImg(url, height));
};

/* istanbul ignore next */
/**
 * @param {string} base64
 * @param {number} height
 */
const printImgBase64 = (base64, height) =>
  printImg(`data:image/gif;base64,${base64}`, height);

/**
 * @param {Array<string|Symbol|Object|number>} args
 */
const group = (...args) => {
  console.group(...computeLoggingArgs(args));
  /* istanbul ignore next */
  vconsoles.forEach((vc) => vc.group(args));
};

/**
 * @param {Array<string|Symbol|Object|number>} args
 */
const groupCollapsed = (...args) => {
  console.groupCollapsed(...computeLoggingArgs(args));
  /* istanbul ignore next */
  vconsoles.forEach((vc) => vc.groupCollapsed(args));
};

const groupEnd = () => {
  console.groupEnd();
  /* istanbul ignore next */
  vconsoles.forEach((vc) => vc.groupEnd());
};

/* istanbul ignore next */
/**
 * @param {function():Node} createNode
 */
const printDom = (createNode) =>
  vconsoles.forEach((vc) => vc.printDom(createNode()));

/* istanbul ignore next */
/**
 * @param {HTMLCanvasElement} canvas
 * @param {number} height
 */
const printCanvas = (canvas, height) =>
  printImg(canvas.toDataURL(), height);

const vconsoles = new Set();

/* istanbul ignore next */
/**
 * @param {Array<string|Symbol|Object|number>} args
 * @return {Array<Element>}
 */
const _computeLineSpans = (args) => {
  const spans = [];
  const currentStyle = new Map();
  // try with formatting until we find something unsupported
  let i = 0;
  for (; i < args.length; i++) {
    const arg = args[i];
    // @ts-ignore
    const style = _browserStyleMap[arg];
    if (style !== undefined) {
      currentStyle.set(style.left, style.right);
    } else {
      if (arg.constructor === String || arg.constructor === Number) {
        // @ts-ignore
        const span = dom.element('span', [
          pair.create('style', dom.mapToStyleString(currentStyle))
        ], [dom.text(arg.toString())]);
        if (span.innerHTML === '') {
          span.innerHTML = '&nbsp;';
        }
        spans.push(span);
      } else {
        break
      }
    }
  }
  // append the rest
  for (; i < args.length; i++) {
    let content = args[i];
    if (!(content instanceof Symbol)) {
      if (content.constructor !== String && content.constructor !== Number) {
        content = ' ' + json.stringify(content) + ' ';
      }
      spans.push(
        dom.element('span', [], [dom.text(/** @type {string} */ (content))])
      );
    }
  }
  return spans
};

const lineStyle =
  'font-family:monospace;border-bottom:1px solid #e2e2e2;padding:2px;';

/* istanbul ignore next */
class VConsole {
  /**
   * @param {Element} dom
   */
  constructor (dom) {
    this.dom = dom;
    /**
     * @type {Element}
     */
    this.ccontainer = this.dom;
    this.depth = 0;
    vconsoles.add(this);
  }

  /**
   * @param {Array<string|Symbol|Object|number>} args
   * @param {boolean} collapsed
   */
  group (args, collapsed = false) {
    eventloop.enqueue(() => {
      const triangleDown = dom.element('span', [
        pair.create('hidden', collapsed),
        pair.create('style', 'color:grey;font-size:120%;')
      ], [dom.text('▼')]);
      const triangleRight = dom.element('span', [
        pair.create('hidden', !collapsed),
        pair.create('style', 'color:grey;font-size:125%;')
      ], [dom.text('▶')]);
      const content = dom.element(
        'div',
        [pair.create(
          'style',
          `${lineStyle};padding-left:${this.depth * 10}px`
        )],
        [triangleDown, triangleRight, dom.text(' ')].concat(
          _computeLineSpans(args)
        )
      );
      const nextContainer = dom.element('div', [
        pair.create('hidden', collapsed)
      ]);
      const nextLine = dom.element('div', [], [content, nextContainer]);
      dom.append(this.ccontainer, [nextLine]);
      this.ccontainer = nextContainer;
      this.depth++;
      // when header is clicked, collapse/uncollapse container
      dom.addEventListener(content, 'click', (_event) => {
        nextContainer.toggleAttribute('hidden');
        triangleDown.toggleAttribute('hidden');
        triangleRight.toggleAttribute('hidden');
      });
    });
  }

  /**
   * @param {Array<string|Symbol|Object|number>} args
   */
  groupCollapsed (args) {
    this.group(args, true);
  }

  groupEnd () {
    eventloop.enqueue(() => {
      if (this.depth > 0) {
        this.depth--;
        // @ts-ignore
        this.ccontainer = this.ccontainer.parentElement.parentElement;
      }
    });
  }

  /**
   * @param {Array<string|Symbol|Object|number>} args
   */
  print (args) {
    eventloop.enqueue(() => {
      dom.append(this.ccontainer, [
        dom.element('div', [
          pair.create(
            'style',
            `${lineStyle};padding-left:${this.depth * 10}px`
          )
        ], _computeLineSpans(args))
      ]);
    });
  }

  /**
   * @param {Error} err
   */
  printError (err) {
    this.print([RED, BOLD, err.toString()]);
  }

  /**
   * @param {string} url
   * @param {number} height
   */
  printImg (url, height) {
    eventloop.enqueue(() => {
      dom.append(this.ccontainer, [
        dom.element('img', [
          pair.create('src', url),
          pair.create('height', `${math.round(height * 1.5)}px`)
        ])
      ]);
    });
  }

  /**
   * @param {Node} node
   */
  printDom (node) {
    eventloop.enqueue(() => {
      dom.append(this.ccontainer, [node]);
    });
  }

  destroy () {
    eventloop.enqueue(() => {
      vconsoles.delete(this);
    });
  }
}

/* istanbul ignore next */
/**
 * @param {Element} dom
 */
const createVConsole = (dom) => new VConsole(dom);

const loggingColors = [GREEN, PURPLE, ORANGE, BLUE];
let nextColor = 0;
let lastLoggingTime = time.getUnixTime();

/**
 * @param {string} moduleName
 * @return {function(...any):void}
 */
const createModuleLogger = (moduleName) => {
  const color = loggingColors[nextColor];
  const debugRegexVar = environment.getVariable('log');
  const doLogging = debugRegexVar !== null &&
    (debugRegexVar === '*' || debugRegexVar === 'true' ||
      new RegExp(debugRegexVar, 'gi').test(moduleName));
  nextColor = (nextColor + 1) % loggingColors.length;
  moduleName += ': ';

  return !doLogging ? _function.nop : (...args) => {
    const timeNow = time.getUnixTime();
    const timeDiff = timeNow - lastLoggingTime;
    lastLoggingTime = timeNow;
    print(
      color,
      moduleName,
      UNCOLOR,
      ...args.map((arg) =>
        (typeof arg === 'string' || typeof arg === 'symbol')
          ? arg
          : JSON.stringify(arg)
      ),
      color,
      ' +' + timeDiff + 'ms'
    );
  }
};

var logging = /*#__PURE__*/Object.freeze({
  __proto__: null,
  BOLD: BOLD,
  UNBOLD: UNBOLD,
  BLUE: BLUE,
  GREY: GREY,
  GREEN: GREEN,
  RED: RED,
  PURPLE: PURPLE,
  ORANGE: ORANGE,
  UNCOLOR: UNCOLOR,
  print: print,
  warn: warn,
  printError: printError,
  printImg: printImg,
  printImgBase64: printImgBase64,
  group: group,
  groupCollapsed: groupCollapsed,
  groupEnd: groupEnd,
  printDom: printDom,
  printCanvas: printCanvas,
  vconsoles: vconsoles,
  VConsole: VConsole,
  createVConsole: createVConsole,
  createModuleLogger: createModuleLogger
});

exports.BLUE = BLUE;
exports.BOLD = BOLD;
exports.GREEN = GREEN;
exports.GREY = GREY;
exports.ORANGE = ORANGE;
exports.PURPLE = PURPLE;
exports.RED = RED;
exports.UNBOLD = UNBOLD;
exports.UNCOLOR = UNCOLOR;
exports.VConsole = VConsole;
exports.createModuleLogger = createModuleLogger;
exports.createVConsole = createVConsole;
exports.group = group;
exports.groupCollapsed = groupCollapsed;
exports.groupEnd = groupEnd;
exports.logging = logging;
exports.print = print;
exports.printCanvas = printCanvas;
exports.printDom = printDom;
exports.printError = printError;
exports.printImg = printImg;
exports.printImgBase64 = printImgBase64;
exports.vconsoles = vconsoles;
exports.warn = warn;
//# sourceMappingURL=logging-00ff6aaf.cjs.map


/***/ }),

/***/ 96759:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

__webpack_require__(88139);
__webpack_require__(26096);
__webpack_require__(77505);
__webpack_require__(42081);
__webpack_require__(68447);
__webpack_require__(74268);
__webpack_require__(60396);
__webpack_require__(36482);
__webpack_require__(35331);
__webpack_require__(45163);
var logging = __webpack_require__(98850);
__webpack_require__(31314);
__webpack_require__(21291);
__webpack_require__(54001);
__webpack_require__(98952);
__webpack_require__(99915);
__webpack_require__(1507);



exports.BLUE = logging.BLUE;
exports.BOLD = logging.BOLD;
exports.GREEN = logging.GREEN;
exports.GREY = logging.GREY;
exports.ORANGE = logging.ORANGE;
exports.PURPLE = logging.PURPLE;
exports.RED = logging.RED;
exports.UNBOLD = logging.UNBOLD;
exports.UNCOLOR = logging.UNCOLOR;
exports.VConsole = logging.VConsole;
exports.createModuleLogger = logging.createModuleLogger;
exports.createVConsole = logging.createVConsole;
exports.group = logging.group;
exports.groupCollapsed = logging.groupCollapsed;
exports.groupEnd = logging.groupEnd;
exports.print = logging.print;
exports.printCanvas = logging.printCanvas;
exports.printDom = logging.printDom;
exports.printError = logging.printError;
exports.printImg = logging.printImg;
exports.printImgBase64 = logging.printImgBase64;
exports.vconsoles = logging.vconsoles;
exports.warn = logging.warn;
//# sourceMappingURL=logging.cjs.map


/***/ }),

/***/ 74268:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


/**
 * Utility module to work with key-value stores.
 *
 * @module map
 */

/**
 * Creates a new Map instance.
 *
 * @function
 * @return {Map<any, any>}
 *
 * @function
 */
const create = () => new Map();

/**
 * Copy a Map object into a fresh Map object.
 *
 * @function
 * @template X,Y
 * @param {Map<X,Y>} m
 * @return {Map<X,Y>}
 */
const copy = m => {
  const r = create();
  m.forEach((v, k) => { r.set(k, v); });
  return r
};

/**
 * Get map property. Create T if property is undefined and set T on map.
 *
 * ```js
 * const listeners = map.setIfUndefined(events, 'eventName', set.create)
 * listeners.add(listener)
 * ```
 *
 * @function
 * @template T,K
 * @param {Map<K, T>} map
 * @param {K} key
 * @param {function():T} createT
 * @return {T}
 */
const setIfUndefined = (map, key, createT) => {
  let set = map.get(key);
  if (set === undefined) {
    map.set(key, set = createT());
  }
  return set
};

/**
 * Creates an Array and populates it with the content of all key-value pairs using the `f(value, key)` function.
 *
 * @function
 * @template K
 * @template V
 * @template R
 * @param {Map<K,V>} m
 * @param {function(V,K):R} f
 * @return {Array<R>}
 */
const map = (m, f) => {
  const res = [];
  for (const [key, value] of m) {
    res.push(f(value, key));
  }
  return res
};

/**
 * Tests whether any key-value pairs pass the test implemented by `f(value, key)`.
 *
 * @todo should rename to some - similarly to Array.some
 *
 * @function
 * @template K
 * @template V
 * @param {Map<K,V>} m
 * @param {function(V,K):boolean} f
 * @return {boolean}
 */
const any = (m, f) => {
  for (const [key, value] of m) {
    if (f(value, key)) {
      return true
    }
  }
  return false
};

/**
 * Tests whether all key-value pairs pass the test implemented by `f(value, key)`.
 *
 * @function
 * @template K
 * @template V
 * @param {Map<K,V>} m
 * @param {function(V,K):boolean} f
 * @return {boolean}
 */
const all = (m, f) => {
  for (const [key, value] of m) {
    if (!f(value, key)) {
      return false
    }
  }
  return true
};

var map$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  create: create,
  copy: copy,
  setIfUndefined: setIfUndefined,
  map: map,
  any: any,
  all: all
});

exports.all = all;
exports.any = any;
exports.copy = copy;
exports.create = create;
exports.map = map;
exports.map$1 = map$1;
exports.setIfUndefined = setIfUndefined;
//# sourceMappingURL=map-28a001c9.cjs.map


/***/ }),

/***/ 23678:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var map = __webpack_require__(74268);



exports.all = map.all;
exports.any = map.any;
exports.copy = map.copy;
exports.create = map.create;
exports.map = map.map;
exports.setIfUndefined = map.setIfUndefined;
//# sourceMappingURL=map.cjs.map


/***/ }),

/***/ 36482:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


/**
 * Common Math expressions.
 *
 * @module math
 */

const floor = Math.floor;
const ceil = Math.ceil;
const abs = Math.abs;
const imul = Math.imul;
const round = Math.round;
const log10 = Math.log10;
const log2 = Math.log2;
const log = Math.log;
const sqrt = Math.sqrt;

/**
 * @function
 * @param {number} a
 * @param {number} b
 * @return {number} The sum of a and b
 */
const add = (a, b) => a + b;

/**
 * @function
 * @param {number} a
 * @param {number} b
 * @return {number} The smaller element of a and b
 */
const min = (a, b) => a < b ? a : b;

/**
 * @function
 * @param {number} a
 * @param {number} b
 * @return {number} The bigger element of a and b
 */
const max = (a, b) => a > b ? a : b;

const isNaN = Number.isNaN;

const pow = Math.pow;
/**
 * Base 10 exponential function. Returns the value of 10 raised to the power of pow.
 *
 * @param {number} exp
 * @return {number}
 */
const exp10 = exp => Math.pow(10, exp);

const sign = Math.sign;

/**
 * @param {number} n
 * @return {boolean} Wether n is negative. This function also differentiates between -0 and +0
 */
const isNegativeZero = n => n !== 0 ? n < 0 : 1 / n < 0;

var math = /*#__PURE__*/Object.freeze({
	__proto__: null,
	floor: floor,
	ceil: ceil,
	abs: abs,
	imul: imul,
	round: round,
	log10: log10,
	log2: log2,
	log: log,
	sqrt: sqrt,
	add: add,
	min: min,
	max: max,
	isNaN: isNaN,
	pow: pow,
	exp10: exp10,
	sign: sign,
	isNegativeZero: isNegativeZero
});

exports.abs = abs;
exports.add = add;
exports.ceil = ceil;
exports.exp10 = exp10;
exports.floor = floor;
exports.imul = imul;
exports.isNaN = isNaN;
exports.isNegativeZero = isNegativeZero;
exports.log = log;
exports.log10 = log10;
exports.log2 = log2;
exports.math = math;
exports.max = max;
exports.min = min;
exports.pow = pow;
exports.round = round;
exports.sign = sign;
exports.sqrt = sqrt;
//# sourceMappingURL=math-08e068f9.cjs.map


/***/ }),

/***/ 97757:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var math = __webpack_require__(36482);



exports.abs = math.abs;
exports.add = math.add;
exports.ceil = math.ceil;
exports.exp10 = math.exp10;
exports.floor = math.floor;
exports.imul = math.imul;
exports.isNaN = math.isNaN;
exports.isNegativeZero = math.isNegativeZero;
exports.log = math.log;
exports.log10 = math.log10;
exports.log2 = math.log2;
exports.max = math.max;
exports.min = math.min;
exports.pow = math.pow;
exports.round = math.round;
exports.sign = math.sign;
exports.sqrt = math.sqrt;
//# sourceMappingURL=math.cjs.map


/***/ }),

/***/ 98952:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var math = __webpack_require__(36482);

/**
 * Utility module to convert metric values.
 *
 * @module metric
 */

const yotta = 1e24;
const zetta = 1e21;
const exa = 1e18;
const peta = 1e15;
const tera = 1e12;
const giga = 1e9;
const mega = 1e6;
const kilo = 1e3;
const hecto = 1e2;
const deca = 10;
const deci = 0.1;
const centi = 0.01;
const milli = 1e-3;
const micro = 1e-6;
const nano = 1e-9;
const pico = 1e-12;
const femto = 1e-15;
const atto = 1e-18;
const zepto = 1e-21;
const yocto = 1e-24;

const prefixUp = ['', 'k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
const prefixDown = ['', 'm', 'μ', 'n', 'p', 'f', 'a', 'z', 'y'];

/**
 * Calculate the metric prefix for a number. Assumes E.g. `prefix(1000) = { n: 1, prefix: 'k' }`
 *
 * @param {number} n
 * @param {number} [baseMultiplier] Multiplier of the base (10^(3*baseMultiplier)). E.g. `convert(time, -3)` if time is already in milli seconds
 * @return {{n:number,prefix:string}}
 */
const prefix = (n, baseMultiplier = 0) => {
  const nPow = n === 0 ? 0 : math.log10(n);
  let mult = 0;
  while (nPow < mult * 3 && baseMultiplier > -8) {
    baseMultiplier--;
    mult--;
  }
  while (nPow >= 3 + mult * 3 && baseMultiplier < 8) {
    baseMultiplier++;
    mult++;
  }
  const prefix = baseMultiplier < 0 ? prefixDown[-baseMultiplier] : prefixUp[baseMultiplier];
  return {
    n: math.round((mult > 0 ? n / math.exp10(mult * 3) : n * math.exp10(mult * -3)) * 1e12) / 1e12,
    prefix
  }
};

exports.atto = atto;
exports.centi = centi;
exports.deca = deca;
exports.deci = deci;
exports.exa = exa;
exports.femto = femto;
exports.giga = giga;
exports.hecto = hecto;
exports.kilo = kilo;
exports.mega = mega;
exports.micro = micro;
exports.milli = milli;
exports.nano = nano;
exports.peta = peta;
exports.pico = pico;
exports.prefix = prefix;
exports.tera = tera;
exports.yocto = yocto;
exports.yotta = yotta;
exports.zepto = zepto;
exports.zetta = zetta;
//# sourceMappingURL=metric.cjs.map


/***/ }),

/***/ 91869:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var math = __webpack_require__(36482);
var binary = __webpack_require__(53115);

/**
 * Utility helpers for working with numbers.
 *
 * @module number
 */

const MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER;
const MIN_SAFE_INTEGER = Number.MIN_SAFE_INTEGER;

const LOWEST_INT32 = 1 << 31;
/**
 * @type {number}
 */
const HIGHEST_INT32 = binary.BITS31;

/**
 * @module number
 */

/* istanbul ignore next */
const isInteger = Number.isInteger || (num => typeof num === 'number' && isFinite(num) && math.floor(num) === num);
const isNaN = Number.isNaN;
const parseInt = Number.parseInt;

var number = /*#__PURE__*/Object.freeze({
	__proto__: null,
	MAX_SAFE_INTEGER: MAX_SAFE_INTEGER,
	MIN_SAFE_INTEGER: MIN_SAFE_INTEGER,
	LOWEST_INT32: LOWEST_INT32,
	HIGHEST_INT32: HIGHEST_INT32,
	isInteger: isInteger,
	isNaN: isNaN,
	parseInt: parseInt
});

exports.HIGHEST_INT32 = HIGHEST_INT32;
exports.LOWEST_INT32 = LOWEST_INT32;
exports.MAX_SAFE_INTEGER = MAX_SAFE_INTEGER;
exports.MIN_SAFE_INTEGER = MIN_SAFE_INTEGER;
exports.isInteger = isInteger;
exports.isNaN = isNaN;
exports.number = number;
exports.parseInt = parseInt;
//# sourceMappingURL=number-e62129bc.cjs.map


/***/ }),

/***/ 1507:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


/**
 * Utility functions for working with EcmaScript objects.
 *
 * @module object
 */

/**
 * @return {Object<string,any>} obj
 */
const create = () => Object.create(null);

/**
 * Object.assign
 */
const assign = Object.assign;

/**
 * @param {Object<string,any>} obj
 */
const keys = Object.keys;

/**
 * @param {Object<string,any>} obj
 * @param {function(any,string):any} f
 */
const forEach = (obj, f) => {
  for (const key in obj) {
    f(obj[key], key);
  }
};

/**
 * @template R
 * @param {Object<string,any>} obj
 * @param {function(any,string):R} f
 * @return {Array<R>}
 */
const map = (obj, f) => {
  const results = [];
  for (const key in obj) {
    results.push(f(obj[key], key));
  }
  return results
};

/**
 * @param {Object<string,any>} obj
 * @return {number}
 */
const length = obj => keys(obj).length;

/**
 * @param {Object<string,any>} obj
 * @param {function(any,string):boolean} f
 * @return {boolean}
 */
const some = (obj, f) => {
  for (const key in obj) {
    if (f(obj[key], key)) {
      return true
    }
  }
  return false
};

/**
 * @param {Object|undefined} obj
 */
const isEmpty = obj => {
  for (const _k in obj) {
    return false
  }
  return true
};

/**
 * @param {Object<string,any>} obj
 * @param {function(any,string):boolean} f
 * @return {boolean}
 */
const every = (obj, f) => {
  for (const key in obj) {
    if (!f(obj[key], key)) {
      return false
    }
  }
  return true
};

/**
 * Calls `Object.prototype.hasOwnProperty`.
 *
 * @param {any} obj
 * @param {string|symbol} key
 * @return {boolean}
 */
const hasProperty = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);

/**
 * @param {Object<string,any>} a
 * @param {Object<string,any>} b
 * @return {boolean}
 */
const equalFlat = (a, b) => a === b || (length(a) === length(b) && every(a, (val, key) => (val !== undefined || hasProperty(b, key)) && b[key] === val));

var object = /*#__PURE__*/Object.freeze({
  __proto__: null,
  create: create,
  assign: assign,
  keys: keys,
  forEach: forEach,
  map: map,
  length: length,
  some: some,
  isEmpty: isEmpty,
  every: every,
  hasProperty: hasProperty,
  equalFlat: equalFlat
});

exports.assign = assign;
exports.create = create;
exports.equalFlat = equalFlat;
exports.every = every;
exports.forEach = forEach;
exports.hasProperty = hasProperty;
exports.isEmpty = isEmpty;
exports.keys = keys;
exports.length = length;
exports.map = map;
exports.object = object;
exports.some = some;
//# sourceMappingURL=object-fe9c0021.cjs.map


/***/ }),

/***/ 418:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var object = __webpack_require__(1507);



exports.assign = object.assign;
exports.create = object.create;
exports.equalFlat = object.equalFlat;
exports.every = object.every;
exports.forEach = object.forEach;
exports.hasProperty = object.hasProperty;
exports.isEmpty = object.isEmpty;
exports.keys = object.keys;
exports.length = object.length;
exports.map = object.map;
exports.some = object.some;
//# sourceMappingURL=object.cjs.map


/***/ }),

/***/ 1058:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var map = __webpack_require__(74268);
var set = __webpack_require__(9077);
var array = __webpack_require__(99915);

/**
 * Observable class prototype.
 *
 * @module observable
 */

/**
 * Handles named events.
 *
 * @template N
 */
class Observable {
  constructor () {
    /**
     * Some desc.
     * @type {Map<N, any>}
     */
    this._observers = map.create();
  }

  /**
   * @param {N} name
   * @param {function} f
   */
  on (name, f) {
    map.setIfUndefined(this._observers, name, set.create).add(f);
  }

  /**
   * @param {N} name
   * @param {function} f
   */
  once (name, f) {
    /**
     * @param  {...any} args
     */
    const _f = (...args) => {
      this.off(name, _f);
      f(...args);
    };
    this.on(name, _f);
  }

  /**
   * @param {N} name
   * @param {function} f
   */
  off (name, f) {
    const observers = this._observers.get(name);
    if (observers !== undefined) {
      observers.delete(f);
      if (observers.size === 0) {
        this._observers.delete(name);
      }
    }
  }

  /**
   * Emit a named event. All registered event listeners that listen to the
   * specified name will receive the event.
   *
   * @todo This should catch exceptions
   *
   * @param {N} name The event name.
   * @param {Array<any>} args The arguments that are applied to the event listener.
   */
  emit (name, args) {
    // copy all listeners to an array first to make sure that no event is emitted to listeners that are subscribed while the event handler is called.
    return array.from((this._observers.get(name) || map.create()).values()).forEach(f => f(...args))
  }

  destroy () {
    this._observers = map.create();
  }
}

exports.Observable = Observable;
//# sourceMappingURL=observable.cjs.map


/***/ }),

/***/ 77505:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


/**
 * Working with value pairs.
 *
 * @module pair
 */

/**
 * @template L,R
 */
class Pair {
  /**
   * @param {L} left
   * @param {R} right
   */
  constructor (left, right) {
    this.left = left;
    this.right = right;
  }
}

/**
 * @template L,R
 * @param {L} left
 * @param {R} right
 * @return {Pair<L,R>}
 */
const create = (left, right) => new Pair(left, right);

/**
 * @template L,R
 * @param {R} right
 * @param {L} left
 * @return {Pair<L,R>}
 */
const createReversed = (right, left) => new Pair(left, right);

/**
 * @template L,R
 * @param {Array<Pair<L,R>>} arr
 * @param {function(L, R):any} f
 */
const forEach = (arr, f) => arr.forEach(p => f(p.left, p.right));

/**
 * @template L,R,X
 * @param {Array<Pair<L,R>>} arr
 * @param {function(L, R):X} f
 * @return {Array<X>}
 */
const map = (arr, f) => arr.map(p => f(p.left, p.right));

var pair = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Pair: Pair,
  create: create,
  createReversed: createReversed,
  forEach: forEach,
  map: map
});

exports.Pair = Pair;
exports.create = create;
exports.createReversed = createReversed;
exports.forEach = forEach;
exports.map = map;
exports.pair = pair;
//# sourceMappingURL=pair-ab022bc3.cjs.map


/***/ }),

/***/ 2069:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var time = __webpack_require__(35331);

/**
 * Utility helpers to work with promises.
 *
 * @module promise
 */

/**
 * @template T
 * @callback PromiseResolve
 * @param {T|PromiseLike<T>} [result]
 */

/**
 * @template T
 * @param {function(PromiseResolve<T>,function(Error):void):any} f
 * @return {Promise<T>}
 */
const create = f => /** @type {Promise<T>} */ (new Promise(f));

/**
 * @param {function(function():void,function(Error):void):void} f
 * @return {Promise<void>}
 */
const createEmpty = f => new Promise(f);

/**
 * `Promise.all` wait for all promises in the array to resolve and return the result
 * @template T
 * @param {Array<Promise<T>>} arrp
 * @return {Promise<Array<T>>}
 */
const all = arrp => Promise.all(arrp);

/**
 * @param {Error} [reason]
 * @return {Promise<never>}
 */
const reject = reason => Promise.reject(reason);

/**
 * @template T
 * @param {T|void} res
 * @return {Promise<T|void>}
 */
const resolve = res => Promise.resolve(res);

/**
 * @template T
 * @param {T} res
 * @return {Promise<T>}
 */
const resolveWith = res => Promise.resolve(res);

/**
 * @todo Next version, reorder parameters: check, [timeout, [intervalResolution]]
 *
 * @param {number} timeout
 * @param {function():boolean} check
 * @param {number} [intervalResolution]
 * @return {Promise<void>}
 */
const until = (timeout, check, intervalResolution = 10) => create((resolve, reject) => {
  const startTime = time.getUnixTime();
  const hasTimeout = timeout > 0;
  const untilInterval = () => {
    if (check()) {
      clearInterval(intervalHandle);
      resolve();
    } else if (hasTimeout) {
      /* istanbul ignore else */
      if (time.getUnixTime() - startTime > timeout) {
        clearInterval(intervalHandle);
        reject(new Error('Timeout'));
      }
    }
  };
  const intervalHandle = setInterval(untilInterval, intervalResolution);
});

/**
 * @param {number} timeout
 * @return {Promise<undefined>}
 */
const wait = timeout => create((resolve, reject) => setTimeout(resolve, timeout));

/**
 * Checks if an object is a promise using ducktyping.
 *
 * Promises are often polyfilled, so it makes sense to add some additional guarantees if the user of this
 * library has some insane environment where global Promise objects are overwritten.
 *
 * @param {any} p
 * @return {boolean}
 */
const isPromise = p => p instanceof Promise || (p && p.then && p.catch && p.finally);

var promise = /*#__PURE__*/Object.freeze({
  __proto__: null,
  create: create,
  createEmpty: createEmpty,
  all: all,
  reject: reject,
  resolve: resolve,
  resolveWith: resolveWith,
  until: until,
  wait: wait,
  isPromise: isPromise
});

exports.all = all;
exports.create = create;
exports.createEmpty = createEmpty;
exports.isPromise = isPromise;
exports.promise = promise;
exports.reject = reject;
exports.resolve = resolve;
exports.resolveWith = resolveWith;
exports.until = until;
exports.wait = wait;
//# sourceMappingURL=promise-1a9fe712.cjs.map


/***/ }),

/***/ 23291:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

__webpack_require__(35331);
var promise = __webpack_require__(2069);
__webpack_require__(98952);
__webpack_require__(36482);



exports.all = promise.all;
exports.create = promise.create;
exports.createEmpty = promise.createEmpty;
exports.isPromise = promise.isPromise;
exports.reject = promise.reject;
exports.resolve = promise.resolve;
exports.resolveWith = promise.resolveWith;
exports.until = promise.until;
exports.wait = promise.wait;
//# sourceMappingURL=promise.cjs.map


/***/ }),

/***/ 39163:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var math = __webpack_require__(36482);
var binary = __webpack_require__(53115);
var isomorphic_js = __webpack_require__(47765);

const rand = Math.random;

const uint32 = () => new Uint32Array(isomorphic_js.cryptoRandomBuffer(4))[0];

const uint53 = () => {
  const arr = new Uint32Array(isomorphic_js.cryptoRandomBuffer(8));
  return (arr[0] & binary.BITS21) * (binary.BITS32 + 1) + (arr[1] >>> 0)
};

/**
 * @template T
 * @param {Array<T>} arr
 * @return {T}
 */
const oneOf = arr => arr[math.floor(rand() * arr.length)];

// @ts-ignore
const uuidv4Template = [1e7] + -1e3 + -4e3 + -8e3 + -1e11;
const uuidv4 = () => uuidv4Template.replace(/[018]/g, /** @param {number} c */ c =>
  (c ^ uint32() & 15 >> c / 4).toString(16)
);

exports.oneOf = oneOf;
exports.rand = rand;
exports.uint32 = uint32;
exports.uint53 = uint53;
exports.uuidv4 = uuidv4;
//# sourceMappingURL=random.cjs.map


/***/ }),

/***/ 9077:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


/**
 * Utility module to work with sets.
 *
 * @module set
 */

const create = () => new Set();

/**
 * @template T
 * @param {Set<T>} set
 * @return {Array<T>}
 */
const toArray = set => Array.from(set);

/**
 * @template T
 * @param {Set<T>} set
 * @return {T}
 */
const first = set => {
  return set.values().next().value || undefined
};

/**
 * @template T
 * @param {Iterable<T>} entries
 * @return {Set<T>}
 */
const from = entries => {
  return new Set(entries)
};

var set = /*#__PURE__*/Object.freeze({
  __proto__: null,
  create: create,
  toArray: toArray,
  first: first,
  from: from
});

exports.create = create;
exports.first = first;
exports.from = from;
exports.set = set;
exports.toArray = toArray;
//# sourceMappingURL=set-b596ef38.cjs.map


/***/ }),

/***/ 33930:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var set = __webpack_require__(9077);



exports.create = set.create;
exports.first = set.first;
exports.from = set.from;
exports.toArray = set.toArray;
//# sourceMappingURL=set.cjs.map


/***/ }),

/***/ 54001:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

/* global localStorage, addEventListener */

/**
 * Isomorphic variable storage.
 *
 * Uses LocalStorage in the browser and falls back to in-memory storage.
 *
 * @module storage
 */

/* istanbul ignore next */
class VarStoragePolyfill {
  constructor () {
    this.map = new Map();
  }

  /**
   * @param {string} key
   * @param {any} newValue
   */
  setItem (key, newValue) {
    this.map.set(key, newValue);
  }

  /**
   * @param {string} key
   */
  getItem (key) {
    return this.map.get(key)
  }
}

/* istanbul ignore next */
/**
 * @type {any}
 */
let _localStorage = new VarStoragePolyfill();
let usePolyfill = true;

try {
  // if the same-origin rule is violated, accessing localStorage might thrown an error
  /* istanbul ignore next */
  if (typeof localStorage !== 'undefined') {
    _localStorage = localStorage;
    usePolyfill = false;
  }
} catch (e) { }

/* istanbul ignore next */
/**
 * This is basically localStorage in browser, or a polyfill in nodejs
 */
const varStorage = _localStorage;

/* istanbul ignore next */
/**
 * A polyfill for `addEventListener('storage', event => {..})` that does nothing if the polyfill is being used.
 *
 * @param {function({ key: string, newValue: string, oldValue: string }): void} eventHandler
 * @function
 */
const onChange = eventHandler => usePolyfill || addEventListener('storage', /** @type {any} */ (eventHandler));

exports.onChange = onChange;
exports.varStorage = varStorage;
//# sourceMappingURL=storage.cjs.map


/***/ }),

/***/ 31314:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


/**
 * Utility module to work with strings.
 *
 * @module string
 */

const fromCharCode = String.fromCharCode;
const fromCodePoint = String.fromCodePoint;

/**
 * @param {string} s
 * @return {string}
 */
const toLowerCase = s => s.toLowerCase();

const trimLeftRegex = /^\s*/g;

/**
 * @param {string} s
 * @return {string}
 */
const trimLeft = s => s.replace(trimLeftRegex, '');

const fromCamelCaseRegex = /([A-Z])/g;

/**
 * @param {string} s
 * @param {string} separator
 * @return {string}
 */
const fromCamelCase = (s, separator) => trimLeft(s.replace(fromCamelCaseRegex, match => `${separator}${toLowerCase(match)}`));

/**
 * Compute the utf8ByteLength
 * @param {string} str
 * @return {number}
 */
const utf8ByteLength = str => unescape(encodeURIComponent(str)).length;

/**
 * @param {string} str
 * @return {Uint8Array}
 */
const _encodeUtf8Polyfill = str => {
  const encodedString = unescape(encodeURIComponent(str));
  const len = encodedString.length;
  const buf = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    buf[i] = /** @type {number} */ (encodedString.codePointAt(i));
  }
  return buf
};

/* istanbul ignore next */
const utf8TextEncoder = /** @type {TextEncoder} */ (typeof TextEncoder !== 'undefined' ? new TextEncoder() : null);

/**
 * @param {string} str
 * @return {Uint8Array}
 */
const _encodeUtf8Native = str => utf8TextEncoder.encode(str);

/**
 * @param {string} str
 * @return {Uint8Array}
 */
/* istanbul ignore next */
const encodeUtf8 = utf8TextEncoder ? _encodeUtf8Native : _encodeUtf8Polyfill;

/**
 * @param {Uint8Array} buf
 * @return {string}
 */
const _decodeUtf8Polyfill = buf => {
  let remainingLen = buf.length;
  let encodedString = '';
  let bufPos = 0;
  while (remainingLen > 0) {
    const nextLen = remainingLen < 10000 ? remainingLen : 10000;
    const bytes = buf.subarray(bufPos, bufPos + nextLen);
    bufPos += nextLen;
    // Starting with ES5.1 we can supply a generic array-like object as arguments
    encodedString += String.fromCodePoint.apply(null, /** @type {any} */ (bytes));
    remainingLen -= nextLen;
  }
  return decodeURIComponent(escape(encodedString))
};

/* istanbul ignore next */
exports.utf8TextDecoder = typeof TextDecoder === 'undefined' ? null : new TextDecoder('utf-8', { fatal: true, ignoreBOM: true });

/* istanbul ignore next */
if (exports.utf8TextDecoder && exports.utf8TextDecoder.decode(new Uint8Array()).length === 1) {
  // Safari doesn't handle BOM correctly.
  // This fixes a bug in Safari 13.0.5 where it produces a BOM the first time it is called.
  // utf8TextDecoder.decode(new Uint8Array()).length === 1 on the first call and
  // utf8TextDecoder.decode(new Uint8Array()).length === 1 on the second call
  // Another issue is that from then on no BOM chars are recognized anymore
  /* istanbul ignore next */
  exports.utf8TextDecoder = null;
}

/**
 * @param {Uint8Array} buf
 * @return {string}
 */
const _decodeUtf8Native = buf => /** @type {TextDecoder} */ (exports.utf8TextDecoder).decode(buf);

/**
 * @param {Uint8Array} buf
 * @return {string}
 */
/* istanbul ignore next */
const decodeUtf8 = exports.utf8TextDecoder ? _decodeUtf8Native : _decodeUtf8Polyfill;

/**
 * @param {string} str The initial string
 * @param {number} index Starting position
 * @param {number} remove Number of characters to remove
 * @param {string} insert New content to insert
 */
const splice = (str, index, remove, insert = '') => str.slice(0, index) + insert + str.slice(index + remove);

var string = /*#__PURE__*/Object.freeze({
  __proto__: null,
  fromCharCode: fromCharCode,
  fromCodePoint: fromCodePoint,
  trimLeft: trimLeft,
  fromCamelCase: fromCamelCase,
  utf8ByteLength: utf8ByteLength,
  _encodeUtf8Polyfill: _encodeUtf8Polyfill,
  utf8TextEncoder: utf8TextEncoder,
  _encodeUtf8Native: _encodeUtf8Native,
  encodeUtf8: encodeUtf8,
  _decodeUtf8Polyfill: _decodeUtf8Polyfill,
  get utf8TextDecoder () { return exports.utf8TextDecoder; },
  _decodeUtf8Native: _decodeUtf8Native,
  decodeUtf8: decodeUtf8,
  splice: splice
});

exports._decodeUtf8Native = _decodeUtf8Native;
exports._decodeUtf8Polyfill = _decodeUtf8Polyfill;
exports._encodeUtf8Native = _encodeUtf8Native;
exports._encodeUtf8Polyfill = _encodeUtf8Polyfill;
exports.decodeUtf8 = decodeUtf8;
exports.encodeUtf8 = encodeUtf8;
exports.fromCamelCase = fromCamelCase;
exports.fromCharCode = fromCharCode;
exports.fromCodePoint = fromCodePoint;
exports.splice = splice;
exports.string = string;
exports.trimLeft = trimLeft;
exports.utf8ByteLength = utf8ByteLength;
exports.utf8TextEncoder = utf8TextEncoder;
//# sourceMappingURL=string-ad04f734.cjs.map


/***/ }),

/***/ 26096:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


/**
 * Utility module to work with EcmaScript Symbols.
 *
 * @module symbol
 */

/**
 * Return fresh symbol.
 *
 * @return {Symbol}
 */
const create = Symbol;

/**
 * @param {any} s
 * @return {boolean}
 */
const isSymbol = s => typeof s === 'symbol';

var symbol = /*#__PURE__*/Object.freeze({
	__proto__: null,
	create: create,
	isSymbol: isSymbol
});

exports.create = create;
exports.isSymbol = isSymbol;
exports.symbol = symbol;
//# sourceMappingURL=symbol-c5caa724.cjs.map


/***/ }),

/***/ 35331:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var metric = __webpack_require__(98952);
var math = __webpack_require__(36482);

/**
 * Utility module to work with time.
 *
 * @module time
 */

/**
 * Return current time.
 *
 * @return {Date}
 */
const getDate = () => new Date();

/**
 * Return current unix time.
 *
 * @return {number}
 */
const getUnixTime = Date.now;

/**
 * Transform time (in ms) to a human readable format. E.g. 1100 => 1.1s. 60s => 1min. .001 => 10μs.
 *
 * @param {number} d duration in milliseconds
 * @return {string} humanized approximation of time
 */
const humanizeDuration = d => {
  if (d < 60000) {
    const p = metric.prefix(d, -1);
    return math.round(p.n * 100) / 100 + p.prefix + 's'
  }
  d = math.floor(d / 1000);
  const seconds = d % 60;
  const minutes = math.floor(d / 60) % 60;
  const hours = math.floor(d / 3600) % 24;
  const days = math.floor(d / 86400);
  if (days > 0) {
    return days + 'd' + ((hours > 0 || minutes > 30) ? ' ' + (minutes > 30 ? hours + 1 : hours) + 'h' : '')
  }
  if (hours > 0) {
    /* istanbul ignore next */
    return hours + 'h' + ((minutes > 0 || seconds > 30) ? ' ' + (seconds > 30 ? minutes + 1 : minutes) + 'min' : '')
  }
  return minutes + 'min' + (seconds > 0 ? ' ' + seconds + 's' : '')
};

var time = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getDate: getDate,
  getUnixTime: getUnixTime,
  humanizeDuration: humanizeDuration
});

exports.getDate = getDate;
exports.getUnixTime = getUnixTime;
exports.humanizeDuration = humanizeDuration;
exports.time = time;
//# sourceMappingURL=time-e00067da.cjs.map


/***/ }),

/***/ 57831:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

__webpack_require__(98952);
__webpack_require__(36482);
var time = __webpack_require__(35331);



exports.getDate = time.getDate;
exports.getUnixTime = time.getUnixTime;
exports.humanizeDuration = time.humanizeDuration;
//# sourceMappingURL=time.cjs.map


/***/ }),

/***/ 6686:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "rc": () => (/* binding */ BIT7),
/* harmony export */   "x1": () => (/* binding */ BIT8),
/* harmony export */   "$2": () => (/* binding */ BITS6),
/* harmony export */   "jS": () => (/* binding */ BITS7),
/* harmony export */   "x": () => (/* binding */ BITS8),
/* harmony export */   "RP": () => (/* binding */ BITS31)
/* harmony export */ });
/* unused harmony exports BIT1, BIT2, BIT3, BIT4, BIT5, BIT6, BIT9, BIT10, BIT11, BIT12, BIT13, BIT14, BIT15, BIT16, BIT17, BIT18, BIT19, BIT20, BIT21, BIT22, BIT23, BIT24, BIT25, BIT26, BIT27, BIT28, BIT29, BIT30, BIT31, BIT32, BITS0, BITS1, BITS2, BITS3, BITS4, BITS5, BITS9, BITS10, BITS11, BITS12, BITS13, BITS14, BITS15, BITS16, BITS17, BITS18, BITS19, BITS20, BITS21, BITS22, BITS23, BITS24, BITS25, BITS26, BITS27, BITS28, BITS29, BITS30, BITS32 */
/* eslint-env browser */

/**
 * Binary data constants.
 *
 * @module binary
 */

/**
 * n-th bit activated.
 *
 * @type {number}
 */
var BIT1 = 1;
var BIT2 = 2;
var BIT3 = 4;
var BIT4 = 8;
var BIT5 = 16;
var BIT6 = 32;
var BIT7 = 64;
var BIT8 = 128;
var BIT9 = 256;
var BIT10 = 512;
var BIT11 = 1024;
var BIT12 = 2048;
var BIT13 = 4096;
var BIT14 = 8192;
var BIT15 = 16384;
var BIT16 = 32768;
var BIT17 = 65536;
var BIT18 = 1 << 17;
var BIT19 = 1 << 18;
var BIT20 = 1 << 19;
var BIT21 = 1 << 20;
var BIT22 = 1 << 21;
var BIT23 = 1 << 22;
var BIT24 = 1 << 23;
var BIT25 = 1 << 24;
var BIT26 = 1 << 25;
var BIT27 = 1 << 26;
var BIT28 = 1 << 27;
var BIT29 = 1 << 28;
var BIT30 = 1 << 29;
var BIT31 = 1 << 30;
var BIT32 = (/* unused pure expression or super */ null && (1 << 31));

/**
 * First n bits activated.
 *
 * @type {number}
 */
var BITS0 = 0;
var BITS1 = 1;
var BITS2 = 3;
var BITS3 = 7;
var BITS4 = 15;
var BITS5 = 31;
var BITS6 = 63;
var BITS7 = 127;
var BITS8 = 255;
var BITS9 = 511;
var BITS10 = 1023;
var BITS11 = 2047;
var BITS12 = 4095;
var BITS13 = 8191;
var BITS14 = 16383;
var BITS15 = 32767;
var BITS16 = 65535;
var BITS17 = BIT18 - 1;
var BITS18 = BIT19 - 1;
var BITS19 = BIT20 - 1;
var BITS20 = BIT21 - 1;
var BITS21 = BIT22 - 1;
var BITS22 = BIT23 - 1;
var BITS23 = BIT24 - 1;
var BITS24 = BIT25 - 1;
var BITS25 = BIT26 - 1;
var BITS26 = BIT27 - 1;
var BITS27 = BIT28 - 1;
var BITS28 = BIT29 - 1;
var BITS29 = BIT30 - 1;
var BITS30 = BIT31 - 1;
/**
 * @type {number}
 */
var BITS31 = 0x7FFFFFFF;
/**
 * @type {number}
 */
var BITS32 = 0xFFFFFFFF;

/***/ }),

/***/ 83322:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Te": () => (/* binding */ createUint8ArrayViewFromArrayBuffer)
});

// UNUSED EXPORTS: copyUint8Array, createUint8ArrayFromArrayBuffer, createUint8ArrayFromLen, decodeAny, encodeAny, fromBase64, toBase64

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.uint8-array.js
var es_typed_array_uint8_array = __webpack_require__(82472);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.copy-within.js
var es_typed_array_copy_within = __webpack_require__(92990);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.every.js
var es_typed_array_every = __webpack_require__(18927);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.fill.js
var es_typed_array_fill = __webpack_require__(33105);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.filter.js
var es_typed_array_filter = __webpack_require__(35035);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.find.js
var es_typed_array_find = __webpack_require__(74345);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.find-index.js
var es_typed_array_find_index = __webpack_require__(7174);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.for-each.js
var es_typed_array_for_each = __webpack_require__(32846);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.includes.js
var es_typed_array_includes = __webpack_require__(44731);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.index-of.js
var es_typed_array_index_of = __webpack_require__(77209);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.iterator.js
var es_typed_array_iterator = __webpack_require__(96319);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.join.js
var es_typed_array_join = __webpack_require__(58867);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.last-index-of.js
var es_typed_array_last_index_of = __webpack_require__(37789);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.map.js
var es_typed_array_map = __webpack_require__(33739);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reduce.js
var es_typed_array_reduce = __webpack_require__(29368);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reduce-right.js
var es_typed_array_reduce_right = __webpack_require__(14483);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reverse.js
var es_typed_array_reverse = __webpack_require__(12056);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.set.js
var es_typed_array_set = __webpack_require__(3462);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.slice.js
var es_typed_array_slice = __webpack_require__(30678);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.some.js
var es_typed_array_some = __webpack_require__(27462);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.sort.js
var es_typed_array_sort = __webpack_require__(33824);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.subarray.js
var es_typed_array_subarray = __webpack_require__(55021);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.to-locale-string.js
var es_typed_array_to_locale_string = __webpack_require__(12974);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.to-string.js
var es_typed_array_to_string = __webpack_require__(15016);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.from-code-point.js
var es_string_from_code_point = __webpack_require__(94953);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(15306);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.code-point-at.js
var es_string_code_point_at = __webpack_require__(79841);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/node_modules/lib0/string.js































/**
 * Utility module to work with strings.
 *
 * @module string
 */

var fromCharCode = String.fromCharCode;
var fromCodePoint = String.fromCodePoint;

/**
 * @param {string} s
 * @return {string}
 */
var toLowerCase = function toLowerCase(s) {
  return s.toLowerCase();
};
var trimLeftRegex = /^\s*/g;

/**
 * @param {string} s
 * @return {string}
 */
var trimLeft = function trimLeft(s) {
  return s.replace(trimLeftRegex, '');
};
var fromCamelCaseRegex = /([A-Z])/g;

/**
 * @param {string} s
 * @param {string} separator
 * @return {string}
 */
var fromCamelCase = function fromCamelCase(s, separator) {
  return trimLeft(s.replace(fromCamelCaseRegex, function (match) {
    return "".concat(separator).concat(toLowerCase(match));
  }));
};

/**
 * Compute the utf8ByteLength
 * @param {string} str
 * @return {number}
 */
var utf8ByteLength = function utf8ByteLength(str) {
  return unescape(encodeURIComponent(str)).length;
};

/**
 * @param {string} str
 * @return {Uint8Array}
 */
var _encodeUtf8Polyfill = function _encodeUtf8Polyfill(str) {
  var encodedString = unescape(encodeURIComponent(str));
  var len = encodedString.length;
  var buf = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    buf[i] = encodedString.codePointAt(i);
  }
  return buf;
};

/* istanbul ignore next */
var utf8TextEncoder = typeof TextEncoder !== 'undefined' ? new TextEncoder() : null;

/**
 * @param {string} str
 * @return {Uint8Array}
 */
var _encodeUtf8Native = function _encodeUtf8Native(str) {
  return utf8TextEncoder.encode(str);
};

/**
 * @param {string} str
 * @return {Uint8Array}
 */
/* istanbul ignore next */
var encodeUtf8 = (/* unused pure expression or super */ null && (utf8TextEncoder ? _encodeUtf8Native : _encodeUtf8Polyfill));

/**
 * @param {Uint8Array} buf
 * @return {string}
 */
var _decodeUtf8Polyfill = function _decodeUtf8Polyfill(buf) {
  var remainingLen = buf.length;
  var encodedString = '';
  var bufPos = 0;
  while (remainingLen > 0) {
    var nextLen = remainingLen < 10000 ? remainingLen : 10000;
    var bytes = buf.subarray(bufPos, bufPos + nextLen);
    bufPos += nextLen;
    // Starting with ES5.1 we can supply a generic array-like object as arguments
    encodedString += String.fromCodePoint.apply(null, bytes);
    remainingLen -= nextLen;
  }
  return decodeURIComponent(escape(encodedString));
};

/* istanbul ignore next */
var utf8TextDecoder = typeof TextDecoder === 'undefined' ? null : new TextDecoder('utf-8', {
  fatal: true,
  ignoreBOM: true
});

/* istanbul ignore next */
if (utf8TextDecoder && utf8TextDecoder.decode(new Uint8Array()).length === 1) {
  // Safari doesn't handle BOM correctly.
  // This fixes a bug in Safari 13.0.5 where it produces a BOM the first time it is called.
  // utf8TextDecoder.decode(new Uint8Array()).length === 1 on the first call and
  // utf8TextDecoder.decode(new Uint8Array()).length === 1 on the second call
  // Another issue is that from then on no BOM chars are recognized anymore
  /* istanbul ignore next */
  utf8TextDecoder = null;
}

/**
 * @param {Uint8Array} buf
 * @return {string}
 */
var _decodeUtf8Native = function _decodeUtf8Native(buf) {
  return (/** @type {TextDecoder} */utf8TextDecoder.decode(buf)
  );
};

/**
 * @param {Uint8Array} buf
 * @return {string}
 */
/* istanbul ignore next */
var decodeUtf8 = (/* unused pure expression or super */ null && (utf8TextDecoder ? _decodeUtf8Native : _decodeUtf8Polyfill));
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(54747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__(23123);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__(64765);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.map.js
var es_map = __webpack_require__(51532);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/node_modules/lib0/map.js
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }












/**
 * Utility module to work with key-value stores.
 *
 * @module map
 */

/**
 * Creates a new Map instance.
 *
 * @function
 * @return {Map<any, any>}
 *
 * @function
 */
var create = function create() {
  return new Map();
};

/**
 * Copy a Map object into a fresh Map object.
 *
 * @function
 * @template X,Y
 * @param {Map<X,Y>} m
 * @return {Map<X,Y>}
 */
var copy = function copy(m) {
  var r = create();
  m.forEach(function (v, k) {
    r.set(k, v);
  });
  return r;
};

/**
 * Get map property. Create T if property is undefined and set T on map.
 *
 * ```js
 * const listeners = map.setIfUndefined(events, 'eventName', set.create)
 * listeners.add(listener)
 * ```
 *
 * @function
 * @template T,K
 * @param {Map<K, T>} map
 * @param {K} key
 * @param {function():T} createT
 * @return {T}
 */
var setIfUndefined = function setIfUndefined(map, key, createT) {
  var set = map.get(key);
  if (set === undefined) {
    map.set(key, set = createT());
  }
  return set;
};

/**
 * Creates an Array and populates it with the content of all key-value pairs using the `f(value, key)` function.
 *
 * @function
 * @template K
 * @template V
 * @template R
 * @param {Map<K,V>} m
 * @param {function(V,K):R} f
 * @return {Array<R>}
 */
var map = function map(m, f) {
  var res = [];
  var _iterator = _createForOfIteratorHelper(m),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        value = _step$value[1];
      res.push(f(value, key));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return res;
};

/**
 * Tests whether any key-value pairs pass the test implemented by `f(value, key)`.
 *
 * @todo should rename to some - similarly to Array.some
 *
 * @function
 * @template K
 * @template V
 * @param {Map<K,V>} m
 * @param {function(V,K):boolean} f
 * @return {boolean}
 */
var any = function any(m, f) {
  var _iterator2 = _createForOfIteratorHelper(m),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = _slicedToArray(_step2.value, 2),
        key = _step2$value[0],
        value = _step2$value[1];
      if (f(value, key)) {
        return true;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return false;
};

/**
 * Tests whether all key-value pairs pass the test implemented by `f(value, key)`.
 *
 * @function
 * @template K
 * @template V
 * @param {Map<K,V>} m
 * @param {function(V,K):boolean} f
 * @return {boolean}
 */
var map_all = function all(m, f) {
  var _iterator3 = _createForOfIteratorHelper(m),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _step3$value = _slicedToArray(_step3.value, 2),
        key = _step3$value[0],
        value = _step3$value[1];
      if (!f(value, key)) {
        return false;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return true;
};
;// CONCATENATED MODULE: ./node_modules/@lib/editor/node_modules/lib0/conditions.js
/**
 * Often used conditions.
 *
 * @module conditions
 */

/**
 * @template T
 * @param {T|null|undefined} v
 * @return {T|null}
 */
/* istanbul ignore next */
var undefinedToNull = function undefinedToNull(v) {
  return v === undefined ? null : v;
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(21249);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/node_modules/lib0/storage.js






function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
/* global localStorage, addEventListener */
/**
 * Isomorphic variable storage.
 *
 * Uses LocalStorage in the browser and falls back to in-memory storage.
 *
 * @module storage
 */
/* istanbul ignore next */
var VarStoragePolyfill = /*#__PURE__*/function () {
  function VarStoragePolyfill() {
    _classCallCheck(this, VarStoragePolyfill);
    this.map = new Map();
  }

  /**
   * @param {string} key
   * @param {any} newValue
   */
  _createClass(VarStoragePolyfill, [{
    key: "setItem",
    value: function setItem(key, newValue) {
      this.map.set(key, newValue);
    }

    /**
     * @param {string} key
     */
  }, {
    key: "getItem",
    value: function getItem(key) {
      return this.map.get(key);
    }
  }]);
  return VarStoragePolyfill;
}();
/* istanbul ignore next */
/**
 * @type {any}
 */
var _localStorage = new VarStoragePolyfill();
var usePolyfill = true;
try {
  // if the same-origin rule is violated, accessing localStorage might thrown an error
  /* istanbul ignore next */
  if (typeof localStorage !== 'undefined') {
    _localStorage = localStorage;
    usePolyfill = false;
  }
} catch (e) {}

/* istanbul ignore next */
/**
 * This is basically localStorage in browser, or a polyfill in nodejs
 */
var varStorage = _localStorage;

/* istanbul ignore next */
/**
 * A polyfill for `addEventListener('storage', event => {..})` that does nothing if the polyfill is being used.
 *
 * @param {function({ key: string, newValue: string, oldValue: string }): void} eventHandler
 * @function
 */
var onChange = function onChange(eventHandler) {
  return usePolyfill || addEventListener('storage', eventHandler);
};
;// CONCATENATED MODULE: ./node_modules/@lib/editor/node_modules/lib0/environment.js
function environment_slicedToArray(arr, i) { return environment_arrayWithHoles(arr) || environment_iterableToArrayLimit(arr, i) || environment_unsupportedIterableToArray(arr, i) || environment_nonIterableRest(); }
function environment_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function environment_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return environment_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return environment_arrayLikeToArray(o, minLen); }
function environment_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function environment_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function environment_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }














/**
 * Isomorphic module to work access the environment (query params, env variables).
 *
 * @module map
 */






/* istanbul ignore next */
// @ts-ignore
var isNode = typeof process !== 'undefined' && process.release && /node|io\.js/.test(process.release.name);
/* istanbul ignore next */
var isBrowser = typeof window !== 'undefined' && !isNode;
/* istanbul ignore next */
var isMac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;

/**
 * @type {Map<string,string>}
 */
var params;
var args = [];

/* istanbul ignore next */
var computeParams = function computeParams() {
  if (params === undefined) {
    if (isNode) {
      params = create();
      var pargs = process.argv;
      var currParamName = null;
      /* istanbul ignore next */
      for (var i = 0; i < pargs.length; i++) {
        var parg = pargs[i];
        if (parg[0] === '-') {
          if (currParamName !== null) {
            params.set(currParamName, '');
          }
          currParamName = parg;
        } else {
          if (currParamName !== null) {
            params.set(currParamName, parg);
            currParamName = null;
          } else {
            args.push(parg);
          }
        }
      }
      if (currParamName !== null) {
        params.set(currParamName, '');
      }
      // in ReactNative for example this would not be true (unless connected to the Remote Debugger)
    } else if ((typeof location === "undefined" ? "undefined" : _typeof(location)) === 'object') {
      params = create()
      // eslint-disable-next-line no-undef
      ;
      (location.search || '?').slice(1).split('&').forEach(function (kv) {
        if (kv.length !== 0) {
          var _kv$split = kv.split('='),
            _kv$split2 = environment_slicedToArray(_kv$split, 2),
            key = _kv$split2[0],
            value = _kv$split2[1];
          params.set("--".concat(fromCamelCase(key, '-')), value);
          params.set("-".concat(fromCamelCase(key, '-')), value);
        }
      });
    } else {
      params = create();
    }
  }
  return params;
};

/**
 * @param {string} name
 * @return {boolean}
 */
/* istanbul ignore next */
var hasParam = function hasParam(name) {
  return computeParams().has(name);
};

/**
 * @param {string} name
 * @param {string} defaultVal
 * @return {string}
 */
/* istanbul ignore next */
var getParam = function getParam(name, defaultVal) {
  return computeParams().get(name) || defaultVal;
};
// export const getArgs = name => computeParams() && args

/**
 * @param {string} name
 * @return {string|null}
 */
/* istanbul ignore next */
var getVariable = function getVariable(name) {
  return isNode ? undefinedToNull(process.env[name.toUpperCase()]) : undefinedToNull(varStorage.getItem(name));
};

/**
 * @param {string} name
 * @return {string|null}
 */
var getConf = function getConf(name) {
  return computeParams().get('--' + name) || getVariable(name);
};

/**
 * @param {string} name
 * @return {boolean}
 */
/* istanbul ignore next */
var hasConf = function hasConf(name) {
  return hasParam('--' + name) || getVariable(name) !== null;
};

/* istanbul ignore next */
var production = hasConf('production');
;// CONCATENATED MODULE: ./node_modules/@lib/editor/node_modules/lib0/buffer.js
/* provided dependency */ var Buffer = __webpack_require__(13423)["Buffer"];



























/**
 * Utility functions to work with buffers (Uint8Array).
 *
 * @module buffer
 */






/**
 * @param {number} len
 */
var createUint8ArrayFromLen = function createUint8ArrayFromLen(len) {
  return new Uint8Array(len);
};

/**
 * Create Uint8Array with initial content from buffer
 *
 * @param {ArrayBuffer} buffer
 * @param {number} byteOffset
 * @param {number} length
 */
var createUint8ArrayViewFromArrayBuffer = function createUint8ArrayViewFromArrayBuffer(buffer, byteOffset, length) {
  return new Uint8Array(buffer, byteOffset, length);
};

/**
 * Create Uint8Array with initial content from buffer
 *
 * @param {ArrayBuffer} buffer
 */
var createUint8ArrayFromArrayBuffer = function createUint8ArrayFromArrayBuffer(buffer) {
  return new Uint8Array(buffer);
};

/* istanbul ignore next */
/**
 * @param {Uint8Array} bytes
 * @return {string}
 */
var toBase64Browser = function toBase64Browser(bytes) {
  var s = '';
  for (var i = 0; i < bytes.byteLength; i++) {
    s += fromCharCode(bytes[i]);
  }
  // eslint-disable-next-line no-undef
  return btoa(s);
};

/**
 * @param {Uint8Array} bytes
 * @return {string}
 */
var toBase64Node = function toBase64Node(bytes) {
  return Buffer.from(bytes.buffer, bytes.byteOffset, bytes.byteLength).toString('base64');
};

/* istanbul ignore next */
/**
 * @param {string} s
 * @return {Uint8Array}
 */
var fromBase64Browser = function fromBase64Browser(s) {
  // eslint-disable-next-line no-undef
  var a = atob(s);
  var bytes = createUint8ArrayFromLen(a.length);
  for (var i = 0; i < a.length; i++) {
    bytes[i] = a.charCodeAt(i);
  }
  return bytes;
};

/**
 * @param {string} s
 */
var fromBase64Node = function fromBase64Node(s) {
  var buf = Buffer.from(s, 'base64');
  return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
};

/* istanbul ignore next */
var toBase64 = isBrowser ? toBase64Browser : toBase64Node;

/* istanbul ignore next */
var fromBase64 = isBrowser ? fromBase64Browser : fromBase64Node;

/**
 * Copy the content of an Uint8Array view to a new ArrayBuffer.
 *
 * @param {Uint8Array} uint8Array
 * @return {Uint8Array}
 */
var copyUint8Array = function copyUint8Array(uint8Array) {
  var newBuf = createUint8ArrayFromLen(uint8Array.byteLength);
  newBuf.set(uint8Array);
  return newBuf;
};

/**
 * Encode anything as a UInt8Array. It's a pun on typescripts's `any` type.
 * See encoding.writeAny for more information.
 *
 * @param {any} data
 * @return {Uint8Array}
 */
var encodeAny = function encodeAny(data) {
  var encoder = encoding.createEncoder();
  encoding.writeAny(encoder, data);
  return encoding.toUint8Array(encoder);
};

/**
 * Decode an any-encoded value.
 *
 * @param {Uint8Array} buf
 * @return {any}
 */
var decodeAny = function decodeAny(buf) {
  return decoding.readAny(decoding.createDecoder(buf));
};

/***/ }),

/***/ 29693:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Decoder": () => (/* binding */ Decoder),
/* harmony export */   "createDecoder": () => (/* binding */ createDecoder),
/* harmony export */   "hasContent": () => (/* binding */ hasContent),
/* harmony export */   "clone": () => (/* binding */ clone),
/* harmony export */   "readUint8Array": () => (/* binding */ readUint8Array),
/* harmony export */   "readVarUint8Array": () => (/* binding */ readVarUint8Array),
/* harmony export */   "readTailAsUint8Array": () => (/* binding */ readTailAsUint8Array),
/* harmony export */   "skip8": () => (/* binding */ skip8),
/* harmony export */   "readUint8": () => (/* binding */ readUint8),
/* harmony export */   "readUint16": () => (/* binding */ readUint16),
/* harmony export */   "readUint32": () => (/* binding */ readUint32),
/* harmony export */   "readUint32BigEndian": () => (/* binding */ readUint32BigEndian),
/* harmony export */   "peekUint8": () => (/* binding */ peekUint8),
/* harmony export */   "peekUint16": () => (/* binding */ peekUint16),
/* harmony export */   "peekUint32": () => (/* binding */ peekUint32),
/* harmony export */   "readVarUint": () => (/* binding */ readVarUint),
/* harmony export */   "readVarInt": () => (/* binding */ readVarInt),
/* harmony export */   "peekVarUint": () => (/* binding */ peekVarUint),
/* harmony export */   "peekVarInt": () => (/* binding */ peekVarInt),
/* harmony export */   "readVarString": () => (/* binding */ readVarString),
/* harmony export */   "peekVarString": () => (/* binding */ peekVarString),
/* harmony export */   "readFromDataView": () => (/* binding */ readFromDataView),
/* harmony export */   "readFloat32": () => (/* binding */ readFloat32),
/* harmony export */   "readFloat64": () => (/* binding */ readFloat64),
/* harmony export */   "readBigInt64": () => (/* binding */ readBigInt64),
/* harmony export */   "readBigUint64": () => (/* binding */ readBigUint64),
/* harmony export */   "readAny": () => (/* binding */ readAny),
/* harmony export */   "RleDecoder": () => (/* binding */ RleDecoder),
/* harmony export */   "IntDiffDecoder": () => (/* binding */ IntDiffDecoder),
/* harmony export */   "RleIntDiffDecoder": () => (/* binding */ RleIntDiffDecoder),
/* harmony export */   "UintOptRleDecoder": () => (/* binding */ UintOptRleDecoder),
/* harmony export */   "IncUintOptRleDecoder": () => (/* binding */ IncUintOptRleDecoder),
/* harmony export */   "IntDiffOptRleDecoder": () => (/* binding */ IntDiffOptRleDecoder),
/* harmony export */   "StringDecoder": () => (/* binding */ StringDecoder)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_string_from_code_point_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94953);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30489);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12419);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(33948);
/* harmony import */ var _buffer_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83322);
/* harmony import */ var _binary_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6686);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(23862);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }











function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
/**
 * Efficient schema-less binary decoding with support for variable length encoding.
 *
 * Use [lib0/decoding] with [lib0/encoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = new encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = new decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module decoding
 */





/**
 * A Decoder handles the decoding of an Uint8Array.
 */
var Decoder =
/**
 * @param {Uint8Array} uint8Array Binary data to decode
 */
function Decoder(uint8Array) {
  _classCallCheck(this, Decoder);
  /**
   * Decoding target.
   *
   * @type {Uint8Array}
   */
  this.arr = uint8Array;
  /**
   * Current decoding position.
   *
   * @type {number}
   */
  this.pos = 0;
};

/**
 * @function
 * @param {Uint8Array} uint8Array
 * @return {Decoder}
 */
var createDecoder = function createDecoder(uint8Array) {
  return new Decoder(uint8Array);
};

/**
 * @function
 * @param {Decoder} decoder
 * @return {boolean}
 */
var hasContent = function hasContent(decoder) {
  return decoder.pos !== decoder.arr.length;
};

/**
 * Clone a decoder instance.
 * Optionally set a new position parameter.
 *
 * @function
 * @param {Decoder} decoder The decoder instance
 * @param {number} [newPos] Defaults to current position
 * @return {Decoder} A clone of `decoder`
 */
var clone = function clone(decoder) {
  var newPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : decoder.pos;
  var _decoder = createDecoder(decoder.arr);
  _decoder.pos = newPos;
  return _decoder;
};

/**
 * Create an Uint8Array view of the next `len` bytes and advance the position by `len`.
 *
 * Important: The Uint8Array still points to the underlying ArrayBuffer. Make sure to discard the result as soon as possible to prevent any memory leaks.
 *            Use `buffer.copyUint8Array` to copy the result into a new Uint8Array.
 *
 * @function
 * @param {Decoder} decoder The decoder instance
 * @param {number} len The length of bytes to read
 * @return {Uint8Array}
 */
var readUint8Array = function readUint8Array(decoder, len) {
  var view = _buffer_js__WEBPACK_IMPORTED_MODULE_11__/* .createUint8ArrayViewFromArrayBuffer */ .Te(decoder.arr.buffer, decoder.pos + decoder.arr.byteOffset, len);
  decoder.pos += len;
  return view;
};

/**
 * Read variable length Uint8Array.
 *
 * Important: The Uint8Array still points to the underlying ArrayBuffer. Make sure to discard the result as soon as possible to prevent any memory leaks.
 *            Use `buffer.copyUint8Array` to copy the result into a new Uint8Array.
 *
 * @function
 * @param {Decoder} decoder
 * @return {Uint8Array}
 */
var readVarUint8Array = function readVarUint8Array(decoder) {
  return readUint8Array(decoder, readVarUint(decoder));
};

/**
 * Read the rest of the content as an ArrayBuffer
 * @function
 * @param {Decoder} decoder
 * @return {Uint8Array}
 */
var readTailAsUint8Array = function readTailAsUint8Array(decoder) {
  return readUint8Array(decoder, decoder.arr.length - decoder.pos);
};

/**
 * Skip one byte, jump to the next position.
 * @function
 * @param {Decoder} decoder The decoder instance
 * @return {number} The next position
 */
var skip8 = function skip8(decoder) {
  return decoder.pos++;
};

/**
 * Read one byte as unsigned integer.
 * @function
 * @param {Decoder} decoder The decoder instance
 * @return {number} Unsigned 8-bit integer
 */
var readUint8 = function readUint8(decoder) {
  return decoder.arr[decoder.pos++];
};

/**
 * Read 2 bytes as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
var readUint16 = function readUint16(decoder) {
  var uint = decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8);
  decoder.pos += 2;
  return uint;
};

/**
 * Read 4 bytes as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
var readUint32 = function readUint32(decoder) {
  var uint = decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8) + (decoder.arr[decoder.pos + 2] << 16) + (decoder.arr[decoder.pos + 3] << 24) >>> 0;
  decoder.pos += 4;
  return uint;
};

/**
 * Read 4 bytes as unsigned integer in big endian order.
 * (most significant byte first)
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
var readUint32BigEndian = function readUint32BigEndian(decoder) {
  var uint = decoder.arr[decoder.pos + 3] + (decoder.arr[decoder.pos + 2] << 8) + (decoder.arr[decoder.pos + 1] << 16) + (decoder.arr[decoder.pos] << 24) >>> 0;
  decoder.pos += 4;
  return uint;
};

/**
 * Look ahead without incrementing the position
 * to the next byte and read it as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
var peekUint8 = function peekUint8(decoder) {
  return decoder.arr[decoder.pos];
};

/**
 * Look ahead without incrementing the position
 * to the next byte and read it as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
var peekUint16 = function peekUint16(decoder) {
  return decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8);
};

/**
 * Look ahead without incrementing the position
 * to the next byte and read it as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
var peekUint32 = function peekUint32(decoder) {
  return decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8) + (decoder.arr[decoder.pos + 2] << 16) + (decoder.arr[decoder.pos + 3] << 24) >>> 0;
};

/**
 * Read unsigned integer (32bit) with variable length.
 * 1/8th of the storage is used as encoding overhead.
 *  * numbers < 2^7 is stored in one bytlength
 *  * numbers < 2^14 is stored in two bylength
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.length
 */
var readVarUint = function readVarUint(decoder) {
  var num = 0;
  var len = 0;
  while (true) {
    var r = decoder.arr[decoder.pos++];
    num = num | (r & _binary_js__WEBPACK_IMPORTED_MODULE_12__/* .BITS7 */ .jS) << len;
    len += 7;
    if (r < _binary_js__WEBPACK_IMPORTED_MODULE_12__/* .BIT8 */ .x1) {
      return num >>> 0; // return unsigned number!
    }
    /* istanbul ignore if */
    if (len > 35) {
      throw new Error('Integer out of range!');
    }
  }
};

/**
 * Read signed integer (32bit) with variable length.
 * 1/8th of the storage is used as encoding overhead.
 *  * numbers < 2^7 is stored in one bytlength
 *  * numbers < 2^14 is stored in two bylength
 * @todo This should probably create the inverse ~num if number is negative - but this would be a breaking change.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.length
 */
var readVarInt = function readVarInt(decoder) {
  var r = decoder.arr[decoder.pos++];
  var num = r & _binary_js__WEBPACK_IMPORTED_MODULE_12__/* .BITS6 */ .$2;
  var len = 6;
  var sign = (r & _binary_js__WEBPACK_IMPORTED_MODULE_12__/* .BIT7 */ .rc) > 0 ? -1 : 1;
  if ((r & _binary_js__WEBPACK_IMPORTED_MODULE_12__/* .BIT8 */ .x1) === 0) {
    // don't continue reading
    return sign * num;
  }
  while (true) {
    r = decoder.arr[decoder.pos++];
    num = num | (r & _binary_js__WEBPACK_IMPORTED_MODULE_12__/* .BITS7 */ .jS) << len;
    len += 7;
    if (r < _binary_js__WEBPACK_IMPORTED_MODULE_12__/* .BIT8 */ .x1) {
      return sign * (num >>> 0);
    }
    /* istanbul ignore if */
    if (len > 41) {
      throw new Error('Integer out of range!');
    }
  }
};

/**
 * Look ahead and read varUint without incrementing position
 *
 * @function
 * @param {Decoder} decoder
 * @return {number}
 */
var peekVarUint = function peekVarUint(decoder) {
  var pos = decoder.pos;
  var s = readVarUint(decoder);
  decoder.pos = pos;
  return s;
};

/**
 * Look ahead and read varUint without incrementing position
 *
 * @function
 * @param {Decoder} decoder
 * @return {number}
 */
var peekVarInt = function peekVarInt(decoder) {
  var pos = decoder.pos;
  var s = readVarInt(decoder);
  decoder.pos = pos;
  return s;
};

/**
 * Read string of variable length
 * * varUint is used to store the length of the string
 *
 * Transforming utf8 to a string is pretty expensive. The code performs 10x better
 * when String.fromCodePoint is fed with all characters as arguments.
 * But most environments have a maximum number of arguments per functions.
 * For effiency reasons we apply a maximum of 10000 characters at once.
 *
 * @function
 * @param {Decoder} decoder
 * @return {String} The read String.
 */
var readVarString = function readVarString(decoder) {
  var remainingLen = readVarUint(decoder);
  if (remainingLen === 0) {
    return '';
  } else {
    var encodedString = String.fromCodePoint(readUint8(decoder)); // remember to decrease remainingLen
    if (--remainingLen < 100) {
      // do not create a Uint8Array for small strings
      while (remainingLen--) {
        encodedString += String.fromCodePoint(readUint8(decoder));
      }
    } else {
      while (remainingLen > 0) {
        var nextLen = remainingLen < 10000 ? remainingLen : 10000;
        // this is dangerous, we create a fresh array view from the existing buffer
        var bytes = decoder.arr.subarray(decoder.pos, decoder.pos + nextLen);
        decoder.pos += nextLen;
        // Starting with ES5.1 we can supply a generic array-like object as arguments
        encodedString += String.fromCodePoint.apply(null, bytes);
        remainingLen -= nextLen;
      }
    }
    return decodeURIComponent(escape(encodedString));
  }
};

/**
 * Look ahead and read varString without incrementing position
 *
 * @function
 * @param {Decoder} decoder
 * @return {string}
 */
var peekVarString = function peekVarString(decoder) {
  var pos = decoder.pos;
  var s = readVarString(decoder);
  decoder.pos = pos;
  return s;
};

/**
 * @param {Decoder} decoder
 * @param {number} len
 * @return {DataView}
 */
var readFromDataView = function readFromDataView(decoder, len) {
  var dv = new DataView(decoder.arr.buffer, decoder.arr.byteOffset + decoder.pos, len);
  decoder.pos += len;
  return dv;
};

/**
 * @param {Decoder} decoder
 */
var readFloat32 = function readFloat32(decoder) {
  return readFromDataView(decoder, 4).getFloat32(0, false);
};

/**
 * @param {Decoder} decoder
 */
var readFloat64 = function readFloat64(decoder) {
  return readFromDataView(decoder, 8).getFloat64(0, false);
};

/**
 * @param {Decoder} decoder
 */
var readBigInt64 = function readBigInt64(decoder) {
  return (/** @type {any} */readFromDataView(decoder, 8).getBigInt64(0, false)
  );
};

/**
 * @param {Decoder} decoder
 */
var readBigUint64 = function readBigUint64(decoder) {
  return (/** @type {any} */readFromDataView(decoder, 8).getBigUint64(0, false)
  );
};

/**
 * @type {Array<function(Decoder):any>}
 */
var readAnyLookupTable = [function (decoder) {
  return undefined;
},
// CASE 127: undefined
function (decoder) {
  return null;
},
// CASE 126: null
readVarInt,
// CASE 125: integer
readFloat32,
// CASE 124: float32
readFloat64,
// CASE 123: float64
readBigInt64,
// CASE 122: bigint
function (decoder) {
  return false;
},
// CASE 121: boolean (false)
function (decoder) {
  return true;
},
// CASE 120: boolean (true)
readVarString,
// CASE 119: string
function (decoder) {
  // CASE 118: object<string,any>
  var len = readVarUint(decoder);
  /**
   * @type {Object<string,any>}
   */
  var obj = {};
  for (var i = 0; i < len; i++) {
    var key = readVarString(decoder);
    obj[key] = readAny(decoder);
  }
  return obj;
}, function (decoder) {
  // CASE 117: array<any>
  var len = readVarUint(decoder);
  var arr = [];
  for (var i = 0; i < len; i++) {
    arr.push(readAny(decoder));
  }
  return arr;
}, readVarUint8Array // CASE 116: Uint8Array
];

/**
 * @param {Decoder} decoder
 */
var readAny = function readAny(decoder) {
  return readAnyLookupTable[127 - readUint8(decoder)](decoder);
};

/**
 * T must not be null.
 *
 * @template T
 */
var RleDecoder = /*#__PURE__*/function (_Decoder) {
  _inherits(RleDecoder, _Decoder);
  var _super = _createSuper(RleDecoder);
  /**
   * @param {Uint8Array} uint8Array
   * @param {function(Decoder):T} reader
   */
  function RleDecoder(uint8Array, reader) {
    var _this;
    _classCallCheck(this, RleDecoder);
    _this = _super.call(this, uint8Array);
    /**
     * The reader
     */
    _this.reader = reader;
    /**
     * Current state
     * @type {T|null}
     */
    _this.s = null;
    _this.count = 0;
    return _this;
  }
  _createClass(RleDecoder, [{
    key: "read",
    value: function read() {
      if (this.count === 0) {
        this.s = this.reader(this);
        if (hasContent(this)) {
          this.count = readVarUint(this) + 1; // see encoder implementation for the reason why this is incremented
        } else {
          this.count = -1; // read the current value forever
        }
      }

      this.count--;
      return this.s;
    }
  }]);
  return RleDecoder;
}(Decoder);
var IntDiffDecoder = /*#__PURE__*/function (_Decoder2) {
  _inherits(IntDiffDecoder, _Decoder2);
  var _super2 = _createSuper(IntDiffDecoder);
  /**
   * @param {Uint8Array} uint8Array
   * @param {number} start
   */
  function IntDiffDecoder(uint8Array, start) {
    var _this2;
    _classCallCheck(this, IntDiffDecoder);
    _this2 = _super2.call(this, uint8Array);
    /**
     * Current state
     * @type {number}
     */
    _this2.s = start;
    return _this2;
  }

  /**
   * @return {number}
   */
  _createClass(IntDiffDecoder, [{
    key: "read",
    value: function read() {
      this.s += readVarInt(this);
      return this.s;
    }
  }]);
  return IntDiffDecoder;
}(Decoder);
var RleIntDiffDecoder = /*#__PURE__*/function (_Decoder3) {
  _inherits(RleIntDiffDecoder, _Decoder3);
  var _super3 = _createSuper(RleIntDiffDecoder);
  /**
   * @param {Uint8Array} uint8Array
   * @param {number} start
   */
  function RleIntDiffDecoder(uint8Array, start) {
    var _this3;
    _classCallCheck(this, RleIntDiffDecoder);
    _this3 = _super3.call(this, uint8Array);
    /**
     * Current state
     * @type {number}
     */
    _this3.s = start;
    _this3.count = 0;
    return _this3;
  }

  /**
   * @return {number}
   */
  _createClass(RleIntDiffDecoder, [{
    key: "read",
    value: function read() {
      if (this.count === 0) {
        this.s += readVarInt(this);
        if (hasContent(this)) {
          this.count = readVarUint(this) + 1; // see encoder implementation for the reason why this is incremented
        } else {
          this.count = -1; // read the current value forever
        }
      }

      this.count--;
      return this.s;
    }
  }]);
  return RleIntDiffDecoder;
}(Decoder);
var UintOptRleDecoder = /*#__PURE__*/function (_Decoder4) {
  _inherits(UintOptRleDecoder, _Decoder4);
  var _super4 = _createSuper(UintOptRleDecoder);
  /**
   * @param {Uint8Array} uint8Array
   */
  function UintOptRleDecoder(uint8Array) {
    var _this4;
    _classCallCheck(this, UintOptRleDecoder);
    _this4 = _super4.call(this, uint8Array);
    /**
     * @type {number}
     */
    _this4.s = 0;
    _this4.count = 0;
    return _this4;
  }
  _createClass(UintOptRleDecoder, [{
    key: "read",
    value: function read() {
      if (this.count === 0) {
        this.s = readVarInt(this);
        // if the sign is negative, we read the count too, otherwise count is 1
        var isNegative = _math_js__WEBPACK_IMPORTED_MODULE_13__/* .isNegativeZero */ .GR(this.s);
        this.count = 1;
        if (isNegative) {
          this.s = -this.s;
          this.count = readVarUint(this) + 2;
        }
      }
      this.count--;
      return this.s;
    }
  }]);
  return UintOptRleDecoder;
}(Decoder);
var IncUintOptRleDecoder = /*#__PURE__*/function (_Decoder5) {
  _inherits(IncUintOptRleDecoder, _Decoder5);
  var _super5 = _createSuper(IncUintOptRleDecoder);
  /**
   * @param {Uint8Array} uint8Array
   */
  function IncUintOptRleDecoder(uint8Array) {
    var _this5;
    _classCallCheck(this, IncUintOptRleDecoder);
    _this5 = _super5.call(this, uint8Array);
    /**
     * @type {number}
     */
    _this5.s = 0;
    _this5.count = 0;
    return _this5;
  }
  _createClass(IncUintOptRleDecoder, [{
    key: "read",
    value: function read() {
      if (this.count === 0) {
        this.s = readVarInt(this);
        // if the sign is negative, we read the count too, otherwise count is 1
        var isNegative = _math_js__WEBPACK_IMPORTED_MODULE_13__/* .isNegativeZero */ .GR(this.s);
        this.count = 1;
        if (isNegative) {
          this.s = -this.s;
          this.count = readVarUint(this) + 2;
        }
      }
      this.count--;
      return this.s++;
    }
  }]);
  return IncUintOptRleDecoder;
}(Decoder);
var IntDiffOptRleDecoder = /*#__PURE__*/function (_Decoder6) {
  _inherits(IntDiffOptRleDecoder, _Decoder6);
  var _super6 = _createSuper(IntDiffOptRleDecoder);
  /**
   * @param {Uint8Array} uint8Array
   */
  function IntDiffOptRleDecoder(uint8Array) {
    var _this6;
    _classCallCheck(this, IntDiffOptRleDecoder);
    _this6 = _super6.call(this, uint8Array);
    /**
     * @type {number}
     */
    _this6.s = 0;
    _this6.count = 0;
    _this6.diff = 0;
    return _this6;
  }

  /**
   * @return {number}
   */
  _createClass(IntDiffOptRleDecoder, [{
    key: "read",
    value: function read() {
      if (this.count === 0) {
        var diff = readVarInt(this);
        // if the first bit is set, we read more data
        var hasCount = diff & 1;
        this.diff = diff >> 1;
        this.count = 1;
        if (hasCount) {
          this.count = readVarUint(this) + 2;
        }
      }
      this.s += this.diff;
      this.count--;
      return this.s;
    }
  }]);
  return IntDiffOptRleDecoder;
}(Decoder);
var StringDecoder = /*#__PURE__*/function () {
  /**
   * @param {Uint8Array} uint8Array
   */
  function StringDecoder(uint8Array) {
    _classCallCheck(this, StringDecoder);
    this.decoder = new UintOptRleDecoder(uint8Array);
    this.str = readVarString(this.decoder);
    /**
     * @type {number}
     */
    this.spos = 0;
  }

  /**
   * @return {string}
   */
  _createClass(StringDecoder, [{
    key: "read",
    value: function read() {
      var end = this.spos + this.decoder.read();
      var res = this.str.slice(this.spos, end);
      this.spos = end;
      return res;
    }
  }]);
  return StringDecoder;
}();

/***/ }),

/***/ 23862:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GW": () => (/* binding */ floor),
/* harmony export */   "VV": () => (/* binding */ min),
/* harmony export */   "Fp": () => (/* binding */ max),
/* harmony export */   "GR": () => (/* binding */ isNegativeZero)
/* harmony export */ });
/* unused harmony exports ceil, abs, imul, round, log10, log2, log, sqrt, add, isNaN, pow, exp10, sign */
/* harmony import */ var core_js_modules_es_math_imul_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90332);
/* harmony import */ var core_js_modules_es_math_log10_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40658);
/* harmony import */ var core_js_modules_es_math_log2_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44914);
/* harmony import */ var core_js_modules_es_number_is_nan_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44048);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_math_sign_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52420);






/**
 * Common Math expressions.
 *
 * @module math
 */

var floor = Math.floor;
var ceil = Math.ceil;
var abs = Math.abs;
var imul = Math.imul;
var round = Math.round;
var log10 = Math.log10;
var log2 = Math.log2;
var log = Math.log;
var sqrt = Math.sqrt;

/**
 * @function
 * @param {number} a
 * @param {number} b
 * @return {number} The sum of a and b
 */
var add = function add(a, b) {
  return a + b;
};

/**
 * @function
 * @param {number} a
 * @param {number} b
 * @return {number} The smaller element of a and b
 */
var min = function min(a, b) {
  return a < b ? a : b;
};

/**
 * @function
 * @param {number} a
 * @param {number} b
 * @return {number} The bigger element of a and b
 */
var max = function max(a, b) {
  return a > b ? a : b;
};
var isNaN = Number.isNaN;
var pow = Math.pow;
/**
 * Base 10 exponential function. Returns the value of 10 raised to the power of pow.
 *
 * @param {number} exp
 * @return {number}
 */
var exp10 = function exp10(exp) {
  return Math.pow(10, exp);
};
var sign = Math.sign;

/**
 * @param {number} n
 * @return {boolean} Wether n is negative. This function also differentiates between -0 and +0
 */
var isNegativeZero = function isNegativeZero(n) {
  return n !== 0 ? n < 0 : 1 / n < 0;
};

/***/ }),

/***/ 70494:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": () => (/* binding */ createMutex)
/* harmony export */ });
/**
 * Mutual exclude for JavaScript.
 *
 * @module mutex
 */

/**
 * @callback mutex
 * @param {function():void} cb Only executed when this mutex is not in the current stack
 * @param {function():void} [elseCb] Executed when this mutex is in the current stack
 */

/**
 * Creates a mutual exclude function with the following property:
 *
 * ```js
 * const mutex = createMutex()
 * mutex(() => {
 *   // This function is immediately executed
 *   mutex(() => {
 *     // This function is not executed, as the mutex is already active.
 *   })
 * })
 * ```
 *
 * @return {mutex} A mutual exclude function
 * @public
 */
var createMutex = function createMutex() {
  var token = true;
  return function (f, g) {
    if (token) {
      token = false;
      try {
        f();
      } finally {
        token = true;
      }
    } else if (g !== undefined) {
      g();
    }
  };
};

/***/ }),

/***/ 9151:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _typeof)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33948);







function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),

/***/ 46210:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dp": () => (/* binding */ from),
/* harmony export */   "$m": () => (/* binding */ equalFlat),
/* harmony export */   "kJ": () => (/* binding */ isArray)
/* harmony export */ });
/* unused harmony exports last, create, copy, appendTo, every, some, flatten, unfold, fold, unique, uniqueBy, map */
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91038);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92222);




/**
 * Utility module to work with Arrays.
 *
 * @module array
 */



/**
 * Return the last element of an array. The element must exist
 *
 * @template L
 * @param {ArrayLike<L>} arr
 * @return {L}
 */
var last = function last(arr) {
  return arr[arr.length - 1];
};

/**
 * @template C
 * @return {Array<C>}
 */
var create = function /** @type {Array<C>} */ create() {
  return [];
};

/**
 * @template D
 * @param {Array<D>} a
 * @return {Array<D>}
 */
var copy = function /** @type {Array<D>} */ copy(a) {
  return a.slice();
};

/**
 * Append elements from src to dest
 *
 * @template M
 * @param {Array<M>} dest
 * @param {Array<M>} src
 */
var appendTo = function appendTo(dest, src) {
  for (var i = 0; i < src.length; i++) {
    dest.push(src[i]);
  }
};

/**
 * Transforms something array-like to an actual Array.
 *
 * @function
 * @template T
 * @param {ArrayLike<T>|Iterable<T>} arraylike
 * @return {T}
 */
var from = Array.from;

/**
 * True iff condition holds on every element in the Array.
 *
 * @function
 * @template ITEM
 * @template {ArrayLike<ITEM>} ARR
 *
 * @param {ARR} arr
 * @param {function(ITEM, number, ARR):boolean} f
 * @return {boolean}
 */
var every = function every(arr, f) {
  for (var i = 0; i < arr.length; i++) {
    if (!f(arr[i], i, arr)) {
      return false;
    }
  }
  return true;
};

/**
 * True iff condition holds on some element in the Array.
 *
 * @function
 * @template S
 * @template {ArrayLike<S>} ARR
 * @param {ARR} arr
 * @param {function(S, number, ARR):boolean} f
 * @return {boolean}
 */
var some = function some(arr, f) {
  for (var i = 0; i < arr.length; i++) {
    if (f(arr[i], i, arr)) {
      return true;
    }
  }
  return false;
};

/**
 * @template ELEM
 *
 * @param {ArrayLike<ELEM>} a
 * @param {ArrayLike<ELEM>} b
 * @return {boolean}
 */
var equalFlat = function equalFlat(a, b) {
  return a.length === b.length && every(a, function (item, index) {
    return item === b[index];
  });
};

/**
 * @template ELEM
 * @param {Array<Array<ELEM>>} arr
 * @return {Array<ELEM>}
 */
var flatten = function flatten(arr) {
  return fold(arr, [], function (acc, val) {
    return acc.concat(val);
  });
};

/**
 * @template T
 * @param {number} len
 * @param {function(number, Array<T>):T} f
 * @return {Array<T>}
 */
var unfold = function unfold(len, f) {
  var array = new Array(len);
  for (var i = 0; i < len; i++) {
    array[i] = f(i, array);
  }
  return array;
};

/**
 * @template T
 * @template RESULT
 * @param {Array<T>} arr
 * @param {RESULT} seed
 * @param {function(RESULT, T, number):RESULT} folder
 */
var fold = function fold(arr, seed, folder) {
  return arr.reduce(folder, seed);
};
var isArray = Array.isArray;

/**
 * @template T
 * @param {Array<T>} arr
 * @return {Array<T>}
 */
var unique = function unique(arr) {
  return from(set.from(arr));
};

/**
 * @template T
 * @template M
 * @param {ArrayLike<T>} arr
 * @param {function(T):M} mapper
 * @return {Array<T>}
 */
var uniqueBy = function uniqueBy(arr, mapper) {
  /**
   * @type {Set<M>}
   */
  var happened = set.create();
  /**
   * @type {Array<T>}
   */
  var result = [];
  for (var i = 0; i < arr.length; i++) {
    var el = arr[i];
    var mapped = mapper(el);
    if (!happened.has(mapped)) {
      happened.add(mapped);
      result.push(el);
    }
  }
  return result;
};

/**
 * @template {ArrayLike<any>} ARR
 * @template {function(ARR extends ArrayLike<infer T> ? T : never, number, ARR):any} MAPPER
 * @param {ARR} arr
 * @param {MAPPER} mapper
 * @return {Array<MAPPER extends function(...any): infer M ? M : never>}
 */
var map = function map(arr, mapper) {
  /**
   * @type {Array<any>}
   */
  var res = Array(arr.length);
  for (var i = 0; i < arr.length; i++) {
    res[i] = mapper(arr[i], i, arr);
  }
  return res;
};

/***/ }),

/***/ 96750:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "rc": () => (/* binding */ BIT7),
/* harmony export */   "x1": () => (/* binding */ BIT8),
/* harmony export */   "$2": () => (/* binding */ BITS6),
/* harmony export */   "jS": () => (/* binding */ BITS7),
/* harmony export */   "RP": () => (/* binding */ BITS31),
/* harmony export */   "Tg": () => (/* binding */ BITS32)
/* harmony export */ });
/* unused harmony exports BIT1, BIT2, BIT3, BIT4, BIT5, BIT6, BIT9, BIT10, BIT11, BIT12, BIT13, BIT14, BIT15, BIT16, BIT17, BIT18, BIT19, BIT20, BIT21, BIT22, BIT23, BIT24, BIT25, BIT26, BIT27, BIT28, BIT29, BIT30, BIT31, BIT32, BITS0, BITS1, BITS2, BITS3, BITS4, BITS5, BITS8, BITS9, BITS10, BITS11, BITS12, BITS13, BITS14, BITS15, BITS16, BITS17, BITS18, BITS19, BITS20, BITS21, BITS22, BITS23, BITS24, BITS25, BITS26, BITS27, BITS28, BITS29, BITS30 */
/* eslint-env browser */

/**
 * Binary data constants.
 *
 * @module binary
 */

/**
 * n-th bit activated.
 *
 * @type {number}
 */
var BIT1 = 1;
var BIT2 = 2;
var BIT3 = 4;
var BIT4 = 8;
var BIT5 = 16;
var BIT6 = 32;
var BIT7 = 64;
var BIT8 = 128;
var BIT9 = 256;
var BIT10 = 512;
var BIT11 = 1024;
var BIT12 = 2048;
var BIT13 = 4096;
var BIT14 = 8192;
var BIT15 = 16384;
var BIT16 = 32768;
var BIT17 = 65536;
var BIT18 = 1 << 17;
var BIT19 = 1 << 18;
var BIT20 = 1 << 19;
var BIT21 = 1 << 20;
var BIT22 = 1 << 21;
var BIT23 = 1 << 22;
var BIT24 = 1 << 23;
var BIT25 = 1 << 24;
var BIT26 = 1 << 25;
var BIT27 = 1 << 26;
var BIT28 = 1 << 27;
var BIT29 = 1 << 28;
var BIT30 = 1 << 29;
var BIT31 = 1 << 30;
var BIT32 = (/* unused pure expression or super */ null && (1 << 31));

/**
 * First n bits activated.
 *
 * @type {number}
 */
var BITS0 = 0;
var BITS1 = 1;
var BITS2 = 3;
var BITS3 = 7;
var BITS4 = 15;
var BITS5 = 31;
var BITS6 = 63;
var BITS7 = 127;
var BITS8 = 255;
var BITS9 = 511;
var BITS10 = 1023;
var BITS11 = 2047;
var BITS12 = 4095;
var BITS13 = 8191;
var BITS14 = 16383;
var BITS15 = 32767;
var BITS16 = 65535;
var BITS17 = BIT18 - 1;
var BITS18 = BIT19 - 1;
var BITS19 = BIT20 - 1;
var BITS20 = BIT21 - 1;
var BITS21 = BIT22 - 1;
var BITS22 = BIT23 - 1;
var BITS23 = BIT24 - 1;
var BITS24 = BIT25 - 1;
var BITS25 = BIT26 - 1;
var BITS26 = BIT27 - 1;
var BITS27 = BIT28 - 1;
var BITS28 = BIT29 - 1;
var BITS29 = BIT30 - 1;
var BITS30 = BIT31 - 1;
/**
 * @type {number}
 */
var BITS31 = 0x7FFFFFFF;
/**
 * @type {number}
 */
var BITS32 = 0xFFFFFFFF;

/***/ }),

/***/ 49016:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l1": () => (/* binding */ createDecoder),
  "kf": () => (/* binding */ readVarString),
  "yg": () => (/* binding */ readVarUint),
  "HN": () => (/* binding */ readVarUint8Array)
});

// UNUSED EXPORTS: Decoder, IncUintOptRleDecoder, IntDiffDecoder, IntDiffOptRleDecoder, RleDecoder, RleIntDiffDecoder, StringDecoder, UintOptRleDecoder, _readVarStringNative, _readVarStringPolyfill, clone, hasContent, peekUint16, peekUint32, peekUint8, peekVarInt, peekVarString, peekVarUint, readAny, readBigInt64, readBigUint64, readFloat32, readFloat64, readFromDataView, readTailAsUint8Array, readTerminatedString, readTerminatedUint8Array, readUint16, readUint32, readUint32BigEndian, readUint8, readUint8Array, readVarInt, skip8

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.uint8-array.js
var es_typed_array_uint8_array = __webpack_require__(82472);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.copy-within.js
var es_typed_array_copy_within = __webpack_require__(92990);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.every.js
var es_typed_array_every = __webpack_require__(18927);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.fill.js
var es_typed_array_fill = __webpack_require__(33105);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.filter.js
var es_typed_array_filter = __webpack_require__(35035);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.find.js
var es_typed_array_find = __webpack_require__(74345);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.find-index.js
var es_typed_array_find_index = __webpack_require__(7174);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.for-each.js
var es_typed_array_for_each = __webpack_require__(32846);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.includes.js
var es_typed_array_includes = __webpack_require__(44731);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.index-of.js
var es_typed_array_index_of = __webpack_require__(77209);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.iterator.js
var es_typed_array_iterator = __webpack_require__(96319);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.join.js
var es_typed_array_join = __webpack_require__(58867);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.last-index-of.js
var es_typed_array_last_index_of = __webpack_require__(37789);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.map.js
var es_typed_array_map = __webpack_require__(33739);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reduce.js
var es_typed_array_reduce = __webpack_require__(29368);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reduce-right.js
var es_typed_array_reduce_right = __webpack_require__(14483);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reverse.js
var es_typed_array_reverse = __webpack_require__(12056);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.set.js
var es_typed_array_set = __webpack_require__(3462);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.slice.js
var es_typed_array_slice = __webpack_require__(30678);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.some.js
var es_typed_array_some = __webpack_require__(27462);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.sort.js
var es_typed_array_sort = __webpack_require__(33824);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.subarray.js
var es_typed_array_subarray = __webpack_require__(55021);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.to-locale-string.js
var es_typed_array_to_locale_string = __webpack_require__(12974);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.to-string.js
var es_typed_array_to_string = __webpack_require__(15016);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.from-code-point.js
var es_string_from_code_point = __webpack_require__(94953);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(30489);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__(12419);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/lib0/binary.js
var lib0_binary = __webpack_require__(96750);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.max-safe-integer.js
var es_number_max_safe_integer = __webpack_require__(44363);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(9653);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.min-safe-integer.js
var es_number_min_safe_integer = __webpack_require__(55994);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.is-integer.js
var es_number_is_integer = __webpack_require__(33161);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.is-nan.js
var es_number_is_nan = __webpack_require__(44048);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.parse-int.js
var es_number_parse_int = __webpack_require__(9494);
// EXTERNAL MODULE: ./node_modules/lib0/math.js
var lib0_math = __webpack_require__(23251);
;// CONCATENATED MODULE: ./node_modules/lib0/number.js






/**
 * Utility helpers for working with numbers.
 *
 * @module number
 */



var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER;
var MIN_SAFE_INTEGER = Number.MIN_SAFE_INTEGER;
var LOWEST_INT32 = (/* unused pure expression or super */ null && (1 << 31));
var HIGHEST_INT32 = lib0_binary/* BITS31 */.RP;
var HIGHEST_UINT32 = lib0_binary/* BITS32 */.Tg;

/* c8 ignore next */
var isInteger = Number.isInteger || function (num) {
  return typeof num === 'number' && isFinite(num) && lib0_math/* floor */.GW(num) === num;
};
var number_isNaN = Number.isNaN;
var number_parseInt = Number.parseInt;

/**
 * Count the number of "1" bits in an unsigned 32bit number.
 *
 * Super fun bitcount algorithm by Brian Kernighan.
 *
 * @param {number} n
 */
var countBits = function countBits(n) {
  n &= binary.BITS32;
  var count = 0;
  while (n) {
    n &= n - 1;
    count++;
  }
  return count;
};
// EXTERNAL MODULE: ./node_modules/lib0/string.js
var lib0_string = __webpack_require__(94628);
;// CONCATENATED MODULE: ./node_modules/lib0/error.js
/**
 * Error helpers.
 *
 * @module error
 */

/**
 * @param {string} s
 * @return {Error}
 */
/* c8 ignore next */
var create = function create(s) {
  return new Error(s);
};

/**
 * @throws {Error}
 * @return {never}
 */
/* c8 ignore next 3 */
var methodUnimplemented = function methodUnimplemented() {
  throw create('Method unimplemented');
};

/**
 * @throws {Error}
 * @return {never}
 */
/* c8 ignore next 3 */
var unexpectedCase = function unexpectedCase() {
  throw create('Unexpected case');
};
;// CONCATENATED MODULE: ./node_modules/lib0/decoding.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }



































function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
/**
 * Efficient schema-less binary decoding with support for variable length encoding.
 *
 * Use [lib0/decoding] with [lib0/encoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module decoding
 */







var errorUnexpectedEndOfArray = create('Unexpected end of array');
var errorIntegerOutOfRange = create('Integer out of Range');

/**
 * A Decoder handles the decoding of an Uint8Array.
 */
var Decoder =
/**
 * @param {Uint8Array} uint8Array Binary data to decode
 */
function Decoder(uint8Array) {
  _classCallCheck(this, Decoder);
  /**
   * Decoding target.
   *
   * @type {Uint8Array}
   */
  this.arr = uint8Array;
  /**
   * Current decoding position.
   *
   * @type {number}
   */
  this.pos = 0;
};

/**
 * @function
 * @param {Uint8Array} uint8Array
 * @return {Decoder}
 */
var createDecoder = function createDecoder(uint8Array) {
  return new Decoder(uint8Array);
};

/**
 * @function
 * @param {Decoder} decoder
 * @return {boolean}
 */
var hasContent = function hasContent(decoder) {
  return decoder.pos !== decoder.arr.length;
};

/**
 * Clone a decoder instance.
 * Optionally set a new position parameter.
 *
 * @function
 * @param {Decoder} decoder The decoder instance
 * @param {number} [newPos] Defaults to current position
 * @return {Decoder} A clone of `decoder`
 */
var clone = function clone(decoder) {
  var newPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : decoder.pos;
  var _decoder = createDecoder(decoder.arr);
  _decoder.pos = newPos;
  return _decoder;
};

/**
 * Create an Uint8Array view of the next `len` bytes and advance the position by `len`.
 *
 * Important: The Uint8Array still points to the underlying ArrayBuffer. Make sure to discard the result as soon as possible to prevent any memory leaks.
 *            Use `buffer.copyUint8Array` to copy the result into a new Uint8Array.
 *
 * @function
 * @param {Decoder} decoder The decoder instance
 * @param {number} len The length of bytes to read
 * @return {Uint8Array}
 */
var readUint8Array = function readUint8Array(decoder, len) {
  var view = new Uint8Array(decoder.arr.buffer, decoder.pos + decoder.arr.byteOffset, len);
  decoder.pos += len;
  return view;
};

/**
 * Read variable length Uint8Array.
 *
 * Important: The Uint8Array still points to the underlying ArrayBuffer. Make sure to discard the result as soon as possible to prevent any memory leaks.
 *            Use `buffer.copyUint8Array` to copy the result into a new Uint8Array.
 *
 * @function
 * @param {Decoder} decoder
 * @return {Uint8Array}
 */
var readVarUint8Array = function readVarUint8Array(decoder) {
  return readUint8Array(decoder, readVarUint(decoder));
};

/**
 * Read the rest of the content as an ArrayBuffer
 * @function
 * @param {Decoder} decoder
 * @return {Uint8Array}
 */
var readTailAsUint8Array = function readTailAsUint8Array(decoder) {
  return readUint8Array(decoder, decoder.arr.length - decoder.pos);
};

/**
 * Skip one byte, jump to the next position.
 * @function
 * @param {Decoder} decoder The decoder instance
 * @return {number} The next position
 */
var skip8 = function skip8(decoder) {
  return decoder.pos++;
};

/**
 * Read one byte as unsigned integer.
 * @function
 * @param {Decoder} decoder The decoder instance
 * @return {number} Unsigned 8-bit integer
 */
var readUint8 = function readUint8(decoder) {
  return decoder.arr[decoder.pos++];
};

/**
 * Read 2 bytes as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
var readUint16 = function readUint16(decoder) {
  var uint = decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8);
  decoder.pos += 2;
  return uint;
};

/**
 * Read 4 bytes as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
var readUint32 = function readUint32(decoder) {
  var uint = decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8) + (decoder.arr[decoder.pos + 2] << 16) + (decoder.arr[decoder.pos + 3] << 24) >>> 0;
  decoder.pos += 4;
  return uint;
};

/**
 * Read 4 bytes as unsigned integer in big endian order.
 * (most significant byte first)
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
var readUint32BigEndian = function readUint32BigEndian(decoder) {
  var uint = decoder.arr[decoder.pos + 3] + (decoder.arr[decoder.pos + 2] << 8) + (decoder.arr[decoder.pos + 1] << 16) + (decoder.arr[decoder.pos] << 24) >>> 0;
  decoder.pos += 4;
  return uint;
};

/**
 * Look ahead without incrementing the position
 * to the next byte and read it as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
var peekUint8 = function peekUint8(decoder) {
  return decoder.arr[decoder.pos];
};

/**
 * Look ahead without incrementing the position
 * to the next byte and read it as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
var peekUint16 = function peekUint16(decoder) {
  return decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8);
};

/**
 * Look ahead without incrementing the position
 * to the next byte and read it as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
var peekUint32 = function peekUint32(decoder) {
  return decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8) + (decoder.arr[decoder.pos + 2] << 16) + (decoder.arr[decoder.pos + 3] << 24) >>> 0;
};

/**
 * Read unsigned integer (32bit) with variable length.
 * 1/8th of the storage is used as encoding overhead.
 *  * numbers < 2^7 is stored in one bytlength
 *  * numbers < 2^14 is stored in two bylength
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.length
 */
var readVarUint = function readVarUint(decoder) {
  var num = 0;
  var mult = 1;
  var len = decoder.arr.length;
  while (decoder.pos < len) {
    var r = decoder.arr[decoder.pos++];
    // num = num | ((r & binary.BITS7) << len)
    num = num + (r & lib0_binary/* BITS7 */.jS) * mult; // shift $r << (7*#iterations) and add it to num
    mult *= 128; // next iteration, shift 7 "more" to the left
    if (r < lib0_binary/* BIT8 */.x1) {
      return num;
    }
    /* c8 ignore start */
    if (num > MAX_SAFE_INTEGER) {
      throw errorIntegerOutOfRange;
    }
    /* c8 ignore stop */
  }

  throw errorUnexpectedEndOfArray;
};

/**
 * Read signed integer (32bit) with variable length.
 * 1/8th of the storage is used as encoding overhead.
 *  * numbers < 2^7 is stored in one bytlength
 *  * numbers < 2^14 is stored in two bylength
 * @todo This should probably create the inverse ~num if number is negative - but this would be a breaking change.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.length
 */
var readVarInt = function readVarInt(decoder) {
  var r = decoder.arr[decoder.pos++];
  var num = r & lib0_binary/* BITS6 */.$2;
  var mult = 64;
  var sign = (r & lib0_binary/* BIT7 */.rc) > 0 ? -1 : 1;
  if ((r & lib0_binary/* BIT8 */.x1) === 0) {
    // don't continue reading
    return sign * num;
  }
  var len = decoder.arr.length;
  while (decoder.pos < len) {
    r = decoder.arr[decoder.pos++];
    // num = num | ((r & binary.BITS7) << len)
    num = num + (r & lib0_binary/* BITS7 */.jS) * mult;
    mult *= 128;
    if (r < lib0_binary/* BIT8 */.x1) {
      return sign * num;
    }
    /* c8 ignore start */
    if (num > MAX_SAFE_INTEGER) {
      throw errorIntegerOutOfRange;
    }
    /* c8 ignore stop */
  }

  throw errorUnexpectedEndOfArray;
};

/**
 * Look ahead and read varUint without incrementing position
 *
 * @function
 * @param {Decoder} decoder
 * @return {number}
 */
var peekVarUint = function peekVarUint(decoder) {
  var pos = decoder.pos;
  var s = readVarUint(decoder);
  decoder.pos = pos;
  return s;
};

/**
 * Look ahead and read varUint without incrementing position
 *
 * @function
 * @param {Decoder} decoder
 * @return {number}
 */
var peekVarInt = function peekVarInt(decoder) {
  var pos = decoder.pos;
  var s = readVarInt(decoder);
  decoder.pos = pos;
  return s;
};

/**
 * We don't test this function anymore as we use native decoding/encoding by default now.
 * Better not modify this anymore..
 *
 * Transforming utf8 to a string is pretty expensive. The code performs 10x better
 * when String.fromCodePoint is fed with all characters as arguments.
 * But most environments have a maximum number of arguments per functions.
 * For effiency reasons we apply a maximum of 10000 characters at once.
 *
 * @function
 * @param {Decoder} decoder
 * @return {String} The read String.
 */
/* c8 ignore start */
var _readVarStringPolyfill = function _readVarStringPolyfill(decoder) {
  var remainingLen = readVarUint(decoder);
  if (remainingLen === 0) {
    return '';
  } else {
    var encodedString = String.fromCodePoint(readUint8(decoder)); // remember to decrease remainingLen
    if (--remainingLen < 100) {
      // do not create a Uint8Array for small strings
      while (remainingLen--) {
        encodedString += String.fromCodePoint(readUint8(decoder));
      }
    } else {
      while (remainingLen > 0) {
        var nextLen = remainingLen < 10000 ? remainingLen : 10000;
        // this is dangerous, we create a fresh array view from the existing buffer
        var bytes = decoder.arr.subarray(decoder.pos, decoder.pos + nextLen);
        decoder.pos += nextLen;
        // Starting with ES5.1 we can supply a generic array-like object as arguments
        encodedString += String.fromCodePoint.apply(null, bytes);
        remainingLen -= nextLen;
      }
    }
    return decodeURIComponent(escape(encodedString));
  }
};
/* c8 ignore stop */

/**
 * @function
 * @param {Decoder} decoder
 * @return {String} The read String
 */
var _readVarStringNative = function _readVarStringNative(decoder) {
  return (/** @type any */lib0_string/* utf8TextDecoder.decode */.CO.decode(readVarUint8Array(decoder))
  );
};

/**
 * Read string of variable length
 * * varUint is used to store the length of the string
 *
 * @function
 * @param {Decoder} decoder
 * @return {String} The read String
 *
 */
/* c8 ignore next */
var readVarString = lib0_string/* utf8TextDecoder */.CO ? _readVarStringNative : _readVarStringPolyfill;

/**
 * @param {Decoder} decoder
 * @return {Uint8Array}
 */
var readTerminatedUint8Array = function readTerminatedUint8Array(decoder) {
  var encoder = encoding.createEncoder();
  var b;
  while (true) {
    b = readUint8(decoder);
    if (b === 0) {
      return encoding.toUint8Array(encoder);
    }
    if (b === 1) {
      b = readUint8(decoder);
    }
    encoding.write(encoder, b);
  }
};

/**
 * @param {Decoder} decoder
 * @return {string}
 */
var readTerminatedString = function readTerminatedString(decoder) {
  return string.decodeUtf8(readTerminatedUint8Array(decoder));
};

/**
 * Look ahead and read varString without incrementing position
 *
 * @function
 * @param {Decoder} decoder
 * @return {string}
 */
var peekVarString = function peekVarString(decoder) {
  var pos = decoder.pos;
  var s = readVarString(decoder);
  decoder.pos = pos;
  return s;
};

/**
 * @param {Decoder} decoder
 * @param {number} len
 * @return {DataView}
 */
var readFromDataView = function readFromDataView(decoder, len) {
  var dv = new DataView(decoder.arr.buffer, decoder.arr.byteOffset + decoder.pos, len);
  decoder.pos += len;
  return dv;
};

/**
 * @param {Decoder} decoder
 */
var readFloat32 = function readFloat32(decoder) {
  return readFromDataView(decoder, 4).getFloat32(0, false);
};

/**
 * @param {Decoder} decoder
 */
var readFloat64 = function readFloat64(decoder) {
  return readFromDataView(decoder, 8).getFloat64(0, false);
};

/**
 * @param {Decoder} decoder
 */
var readBigInt64 = function readBigInt64(decoder) {
  return (/** @type {any} */readFromDataView(decoder, 8).getBigInt64(0, false)
  );
};

/**
 * @param {Decoder} decoder
 */
var readBigUint64 = function readBigUint64(decoder) {
  return (/** @type {any} */readFromDataView(decoder, 8).getBigUint64(0, false)
  );
};

/**
 * @type {Array<function(Decoder):any>}
 */
var readAnyLookupTable = [function (decoder) {
  return undefined;
},
// CASE 127: undefined
function (decoder) {
  return null;
},
// CASE 126: null
readVarInt,
// CASE 125: integer
readFloat32,
// CASE 124: float32
readFloat64,
// CASE 123: float64
readBigInt64,
// CASE 122: bigint
function (decoder) {
  return false;
},
// CASE 121: boolean (false)
function (decoder) {
  return true;
},
// CASE 120: boolean (true)
readVarString,
// CASE 119: string
function (decoder) {
  // CASE 118: object<string,any>
  var len = readVarUint(decoder);
  /**
   * @type {Object<string,any>}
   */
  var obj = {};
  for (var i = 0; i < len; i++) {
    var key = readVarString(decoder);
    obj[key] = readAny(decoder);
  }
  return obj;
}, function (decoder) {
  // CASE 117: array<any>
  var len = readVarUint(decoder);
  var arr = [];
  for (var i = 0; i < len; i++) {
    arr.push(readAny(decoder));
  }
  return arr;
}, readVarUint8Array // CASE 116: Uint8Array
];

/**
 * @param {Decoder} decoder
 */
var readAny = function readAny(decoder) {
  return readAnyLookupTable[127 - readUint8(decoder)](decoder);
};

/**
 * T must not be null.
 *
 * @template T
 */
var RleDecoder = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_Decoder) {
  _inherits(RleDecoder, _Decoder);
  var _super = _createSuper(RleDecoder);
  /**
   * @param {Uint8Array} uint8Array
   * @param {function(Decoder):T} reader
   */
  function RleDecoder(uint8Array, reader) {
    var _this;
    _classCallCheck(this, RleDecoder);
    _this = _super.call(this, uint8Array);
    /**
     * The reader
     */
    _this.reader = reader;
    /**
     * Current state
     * @type {T|null}
     */
    _this.s = null;
    _this.count = 0;
    return _this;
  }
  _createClass(RleDecoder, [{
    key: "read",
    value: function read() {
      if (this.count === 0) {
        this.s = this.reader(this);
        if (hasContent(this)) {
          this.count = readVarUint(this) + 1; // see encoder implementation for the reason why this is incremented
        } else {
          this.count = -1; // read the current value forever
        }
      }

      this.count--;
      return this.s;
    }
  }]);
  return RleDecoder;
}(Decoder)));
var IntDiffDecoder = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_Decoder2) {
  _inherits(IntDiffDecoder, _Decoder2);
  var _super2 = _createSuper(IntDiffDecoder);
  /**
   * @param {Uint8Array} uint8Array
   * @param {number} start
   */
  function IntDiffDecoder(uint8Array, start) {
    var _this2;
    _classCallCheck(this, IntDiffDecoder);
    _this2 = _super2.call(this, uint8Array);
    /**
     * Current state
     * @type {number}
     */
    _this2.s = start;
    return _this2;
  }

  /**
   * @return {number}
   */
  _createClass(IntDiffDecoder, [{
    key: "read",
    value: function read() {
      this.s += readVarInt(this);
      return this.s;
    }
  }]);
  return IntDiffDecoder;
}(Decoder)));
var RleIntDiffDecoder = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_Decoder3) {
  _inherits(RleIntDiffDecoder, _Decoder3);
  var _super3 = _createSuper(RleIntDiffDecoder);
  /**
   * @param {Uint8Array} uint8Array
   * @param {number} start
   */
  function RleIntDiffDecoder(uint8Array, start) {
    var _this3;
    _classCallCheck(this, RleIntDiffDecoder);
    _this3 = _super3.call(this, uint8Array);
    /**
     * Current state
     * @type {number}
     */
    _this3.s = start;
    _this3.count = 0;
    return _this3;
  }

  /**
   * @return {number}
   */
  _createClass(RleIntDiffDecoder, [{
    key: "read",
    value: function read() {
      if (this.count === 0) {
        this.s += readVarInt(this);
        if (hasContent(this)) {
          this.count = readVarUint(this) + 1; // see encoder implementation for the reason why this is incremented
        } else {
          this.count = -1; // read the current value forever
        }
      }

      this.count--;
      return this.s;
    }
  }]);
  return RleIntDiffDecoder;
}(Decoder)));
var UintOptRleDecoder = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_Decoder4) {
  _inherits(UintOptRleDecoder, _Decoder4);
  var _super4 = _createSuper(UintOptRleDecoder);
  /**
   * @param {Uint8Array} uint8Array
   */
  function UintOptRleDecoder(uint8Array) {
    var _this4;
    _classCallCheck(this, UintOptRleDecoder);
    _this4 = _super4.call(this, uint8Array);
    /**
     * @type {number}
     */
    _this4.s = 0;
    _this4.count = 0;
    return _this4;
  }
  _createClass(UintOptRleDecoder, [{
    key: "read",
    value: function read() {
      if (this.count === 0) {
        this.s = readVarInt(this);
        // if the sign is negative, we read the count too, otherwise count is 1
        var isNegative = math.isNegativeZero(this.s);
        this.count = 1;
        if (isNegative) {
          this.s = -this.s;
          this.count = readVarUint(this) + 2;
        }
      }
      this.count--;
      return this.s;
    }
  }]);
  return UintOptRleDecoder;
}(Decoder)));
var IncUintOptRleDecoder = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_Decoder5) {
  _inherits(IncUintOptRleDecoder, _Decoder5);
  var _super5 = _createSuper(IncUintOptRleDecoder);
  /**
   * @param {Uint8Array} uint8Array
   */
  function IncUintOptRleDecoder(uint8Array) {
    var _this5;
    _classCallCheck(this, IncUintOptRleDecoder);
    _this5 = _super5.call(this, uint8Array);
    /**
     * @type {number}
     */
    _this5.s = 0;
    _this5.count = 0;
    return _this5;
  }
  _createClass(IncUintOptRleDecoder, [{
    key: "read",
    value: function read() {
      if (this.count === 0) {
        this.s = readVarInt(this);
        // if the sign is negative, we read the count too, otherwise count is 1
        var isNegative = math.isNegativeZero(this.s);
        this.count = 1;
        if (isNegative) {
          this.s = -this.s;
          this.count = readVarUint(this) + 2;
        }
      }
      this.count--;
      return this.s++;
    }
  }]);
  return IncUintOptRleDecoder;
}(Decoder)));
var IntDiffOptRleDecoder = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_Decoder6) {
  _inherits(IntDiffOptRleDecoder, _Decoder6);
  var _super6 = _createSuper(IntDiffOptRleDecoder);
  /**
   * @param {Uint8Array} uint8Array
   */
  function IntDiffOptRleDecoder(uint8Array) {
    var _this6;
    _classCallCheck(this, IntDiffOptRleDecoder);
    _this6 = _super6.call(this, uint8Array);
    /**
     * @type {number}
     */
    _this6.s = 0;
    _this6.count = 0;
    _this6.diff = 0;
    return _this6;
  }

  /**
   * @return {number}
   */
  _createClass(IntDiffOptRleDecoder, [{
    key: "read",
    value: function read() {
      if (this.count === 0) {
        var diff = readVarInt(this);
        // if the first bit is set, we read more data
        var hasCount = diff & 1;
        this.diff = math.floor(diff / 2); // shift >> 1
        this.count = 1;
        if (hasCount) {
          this.count = readVarUint(this) + 2;
        }
      }
      this.s += this.diff;
      this.count--;
      return this.s;
    }
  }]);
  return IntDiffOptRleDecoder;
}(Decoder)));
var StringDecoder = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  /**
   * @param {Uint8Array} uint8Array
   */
  function StringDecoder(uint8Array) {
    _classCallCheck(this, StringDecoder);
    this.decoder = new UintOptRleDecoder(uint8Array);
    this.str = readVarString(this.decoder);
    /**
     * @type {number}
     */
    this.spos = 0;
  }

  /**
   * @return {string}
   */
  _createClass(StringDecoder, [{
    key: "read",
    value: function read() {
      var end = this.spos + this.decoder.read();
      var res = this.str.slice(this.spos, end);
      this.spos = end;
      return res;
    }
  }]);
  return StringDecoder;
}()));

/***/ }),

/***/ 55529:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mf": () => (/* binding */ createEncoder),
/* harmony export */   "_f": () => (/* binding */ _toUint8Array),
/* harmony export */   "uE": () => (/* binding */ writeVarUint),
/* harmony export */   "uw": () => (/* binding */ writeVarString),
/* harmony export */   "mP": () => (/* binding */ writeVarUint8Array)
/* harmony export */ });
/* unused harmony exports Encoder, encode, length, hasContent, verifyLen, write, set, writeUint8, setUint8, writeUint16, setUint16, writeUint32, writeUint32BigEndian, setUint32, writeVarInt, _writeVarStringNative, _writeVarStringPolyfill, writeTerminatedString, writeTerminatedUint8Array, writeBinaryEncoder, writeUint8Array, writeOnDataView, writeFloat32, writeFloat64, writeBigInt64, writeBigUint64, writeAny, RleEncoder, IntDiffEncoder, RleIntDiffEncoder, UintOptRleEncoder, IncUintOptRleEncoder, IntDiffOptRleEncoder, StringEncoder */
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_typed_array_uint8_array_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82472);
/* harmony import */ var core_js_modules_es_typed_array_copy_within_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92990);
/* harmony import */ var core_js_modules_es_typed_array_every_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18927);
/* harmony import */ var core_js_modules_es_typed_array_fill_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33105);
/* harmony import */ var core_js_modules_es_typed_array_filter_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35035);
/* harmony import */ var core_js_modules_es_typed_array_find_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74345);
/* harmony import */ var core_js_modules_es_typed_array_find_index_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7174);
/* harmony import */ var core_js_modules_es_typed_array_for_each_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32846);
/* harmony import */ var core_js_modules_es_typed_array_includes_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(44731);
/* harmony import */ var core_js_modules_es_typed_array_index_of_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(77209);
/* harmony import */ var core_js_modules_es_typed_array_iterator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96319);
/* harmony import */ var core_js_modules_es_typed_array_join_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(58867);
/* harmony import */ var core_js_modules_es_typed_array_last_index_of_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(37789);
/* harmony import */ var core_js_modules_es_typed_array_map_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(33739);
/* harmony import */ var core_js_modules_es_typed_array_reduce_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(29368);
/* harmony import */ var core_js_modules_es_typed_array_reduce_right_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(14483);
/* harmony import */ var core_js_modules_es_typed_array_reverse_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(12056);
/* harmony import */ var core_js_modules_es_typed_array_set_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(3462);
/* harmony import */ var core_js_modules_es_typed_array_slice_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(30678);
/* harmony import */ var core_js_modules_es_typed_array_some_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(27462);
/* harmony import */ var core_js_modules_es_typed_array_sort_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(33824);
/* harmony import */ var core_js_modules_es_typed_array_subarray_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(55021);
/* harmony import */ var core_js_modules_es_typed_array_to_locale_string_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(12974);
/* harmony import */ var core_js_modules_es_typed_array_to_string_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(15016);
/* harmony import */ var core_js_modules_es_string_code_point_at_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(79841);
/* harmony import */ var core_js_modules_es_array_buffer_constructor_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(18264);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(69600);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(30489);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(12419);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(23251);
/* harmony import */ var _binary_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(96750);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(94628);
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }





































function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
/**
 * Efficient schema-less binary encoding with support for variable length encoding.
 *
 * Use [lib0/encoding] with [lib0/decoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module encoding
 */







/**
 * A BinaryEncoder handles the encoding to an Uint8Array.
 */
var Encoder = function Encoder() {
  _classCallCheck(this, Encoder);
  this.cpos = 0;
  this.cbuf = new Uint8Array(100);
  /**
   * @type {Array<Uint8Array>}
   */
  this.bufs = [];
};

/**
 * @function
 * @return {Encoder}
 */
var createEncoder = function createEncoder() {
  return new Encoder();
};

/**
 * @param {function(Encoder):void} f
 */
var encode = function encode(f) {
  var encoder = createEncoder();
  f(encoder);
  return _toUint8Array(encoder);
};

/**
 * The current length of the encoded data.
 *
 * @function
 * @param {Encoder} encoder
 * @return {number}
 */
var length = function length(encoder) {
  var len = encoder.cpos;
  for (var i = 0; i < encoder.bufs.length; i++) {
    len += encoder.bufs[i].length;
  }
  return len;
};

/**
 * Check whether encoder is empty.
 *
 * @function
 * @param {Encoder} encoder
 * @return {boolean}
 */
var hasContent = function hasContent(encoder) {
  return encoder.cpos > 0 || encoder.bufs.length > 0;
};

/**
 * Transform to Uint8Array.
 *
 * @function
 * @param {Encoder} encoder
 * @return {Uint8Array} The created ArrayBuffer.
 */
var _toUint8Array = function toUint8Array(encoder) {
  var uint8arr = new Uint8Array(length(encoder));
  var curPos = 0;
  for (var i = 0; i < encoder.bufs.length; i++) {
    var d = encoder.bufs[i];
    uint8arr.set(d, curPos);
    curPos += d.length;
  }
  uint8arr.set(new Uint8Array(encoder.cbuf.buffer, 0, encoder.cpos), curPos);
  return uint8arr;
};

/**
 * Verify that it is possible to write `len` bytes wtihout checking. If
 * necessary, a new Buffer with the required length is attached.
 *
 * @param {Encoder} encoder
 * @param {number} len
 */

var verifyLen = function verifyLen(encoder, len) {
  var bufferLen = encoder.cbuf.length;
  if (bufferLen - encoder.cpos < len) {
    encoder.bufs.push(new Uint8Array(encoder.cbuf.buffer, 0, encoder.cpos));
    encoder.cbuf = new Uint8Array(math.max(bufferLen, len) * 2);
    encoder.cpos = 0;
  }
};

/**
 * Write one byte to the encoder.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The byte that is to be encoded.
 */
var write = function write(encoder, num) {
  var bufferLen = encoder.cbuf.length;
  if (encoder.cpos === bufferLen) {
    encoder.bufs.push(encoder.cbuf);
    encoder.cbuf = new Uint8Array(bufferLen * 2);
    encoder.cpos = 0;
  }
  encoder.cbuf[encoder.cpos++] = num;
};

/**
 * Write one byte at a specific position.
 * Position must already be written (i.e. encoder.length > pos)
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} pos Position to which to write data
 * @param {number} num Unsigned 8-bit integer
 */
var set = function set(encoder, pos, num) {
  var buffer = null;
  // iterate all buffers and adjust position
  for (var i = 0; i < encoder.bufs.length && buffer === null; i++) {
    var b = encoder.bufs[i];
    if (pos < b.length) {
      buffer = b; // found buffer
    } else {
      pos -= b.length;
    }
  }
  if (buffer === null) {
    // use current buffer
    buffer = encoder.cbuf;
  }
  buffer[pos] = num;
};

/**
 * Write one byte as an unsigned integer.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
var writeUint8 = (/* unused pure expression or super */ null && (write));

/**
 * Write one byte as an unsigned Integer at a specific location.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} pos The location where the data will be written.
 * @param {number} num The number that is to be encoded.
 */
var setUint8 = (/* unused pure expression or super */ null && (set));

/**
 * Write two bytes as an unsigned integer.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
var writeUint16 = function writeUint16(encoder, num) {
  write(encoder, num & binary.BITS8);
  write(encoder, num >>> 8 & binary.BITS8);
};
/**
 * Write two bytes as an unsigned integer at a specific location.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} pos The location where the data will be written.
 * @param {number} num The number that is to be encoded.
 */
var setUint16 = function setUint16(encoder, pos, num) {
  set(encoder, pos, num & binary.BITS8);
  set(encoder, pos + 1, num >>> 8 & binary.BITS8);
};

/**
 * Write two bytes as an unsigned integer
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
var writeUint32 = function writeUint32(encoder, num) {
  for (var i = 0; i < 4; i++) {
    write(encoder, num & binary.BITS8);
    num >>>= 8;
  }
};

/**
 * Write two bytes as an unsigned integer in big endian order.
 * (most significant byte first)
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
var writeUint32BigEndian = function writeUint32BigEndian(encoder, num) {
  for (var i = 3; i >= 0; i--) {
    write(encoder, num >>> 8 * i & binary.BITS8);
  }
};

/**
 * Write two bytes as an unsigned integer at a specific location.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} pos The location where the data will be written.
 * @param {number} num The number that is to be encoded.
 */
var setUint32 = function setUint32(encoder, pos, num) {
  for (var i = 0; i < 4; i++) {
    set(encoder, pos + i, num & binary.BITS8);
    num >>>= 8;
  }
};

/**
 * Write a variable length unsigned integer. Max encodable integer is 2^53.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
var writeVarUint = function writeVarUint(encoder, num) {
  while (num > _binary_js__WEBPACK_IMPORTED_MODULE_37__/* .BITS7 */ .jS) {
    write(encoder, _binary_js__WEBPACK_IMPORTED_MODULE_37__/* .BIT8 */ .x1 | _binary_js__WEBPACK_IMPORTED_MODULE_37__/* .BITS7 */ .jS & num);
    num = _math_js__WEBPACK_IMPORTED_MODULE_38__/* .floor */ .GW(num / 128); // shift >>> 7
  }

  write(encoder, _binary_js__WEBPACK_IMPORTED_MODULE_37__/* .BITS7 */ .jS & num);
};

/**
 * Write a variable length integer.
 *
 * We use the 7th bit instead for signaling that this is a negative number.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
var writeVarInt = function writeVarInt(encoder, num) {
  var isNegative = math.isNegativeZero(num);
  if (isNegative) {
    num = -num;
  }
  //             |- whether to continue reading         |- whether is negative     |- number
  write(encoder, (num > binary.BITS6 ? binary.BIT8 : 0) | (isNegative ? binary.BIT7 : 0) | binary.BITS6 & num);
  num = math.floor(num / 64); // shift >>> 6
  // We don't need to consider the case of num === 0 so we can use a different
  // pattern here than above.
  while (num > 0) {
    write(encoder, (num > binary.BITS7 ? binary.BIT8 : 0) | binary.BITS7 & num);
    num = math.floor(num / 128); // shift >>> 7
  }
};

/**
 * A cache to store strings temporarily
 */
var _strBuffer = new Uint8Array(30000);
var _maxStrBSize = _strBuffer.length / 3;

/**
 * Write a variable length string.
 *
 * @function
 * @param {Encoder} encoder
 * @param {String} str The string that is to be encoded.
 */
var _writeVarStringNative = function _writeVarStringNative(encoder, str) {
  if (str.length < _maxStrBSize) {
    // We can encode the string into the existing buffer
    /* c8 ignore next */
    var written = _string_js__WEBPACK_IMPORTED_MODULE_39__/* .utf8TextEncoder.encodeInto */ .YZ.encodeInto(str, _strBuffer).written || 0;
    writeVarUint(encoder, written);
    for (var i = 0; i < written; i++) {
      write(encoder, _strBuffer[i]);
    }
  } else {
    writeVarUint8Array(encoder, _string_js__WEBPACK_IMPORTED_MODULE_39__/* .encodeUtf8 */ .lz(str));
  }
};

/**
 * Write a variable length string.
 *
 * @function
 * @param {Encoder} encoder
 * @param {String} str The string that is to be encoded.
 */
var _writeVarStringPolyfill = function _writeVarStringPolyfill(encoder, str) {
  var encodedString = unescape(encodeURIComponent(str));
  var len = encodedString.length;
  writeVarUint(encoder, len);
  for (var i = 0; i < len; i++) {
    write(encoder, encodedString.codePointAt(i));
  }
};

/**
 * Write a variable length string.
 *
 * @function
 * @param {Encoder} encoder
 * @param {String} str The string that is to be encoded.
 */
/* c8 ignore next */
var writeVarString = _string_js__WEBPACK_IMPORTED_MODULE_39__/* .utf8TextEncoder */ .YZ && /** @type {any} */_string_js__WEBPACK_IMPORTED_MODULE_39__/* .utf8TextEncoder.encodeInto */ .YZ.encodeInto ? _writeVarStringNative : _writeVarStringPolyfill;

/**
 * Write a string terminated by a special byte sequence. This is not very performant and is
 * generally discouraged. However, the resulting byte arrays are lexiographically ordered which
 * makes this a nice feature for databases.
 *
 * The string will be encoded using utf8 and then terminated and escaped using writeTerminatingUint8Array.
 *
 * @function
 * @param {Encoder} encoder
 * @param {String} str The string that is to be encoded.
 */
var writeTerminatedString = function writeTerminatedString(encoder, str) {
  return writeTerminatedUint8Array(encoder, string.encodeUtf8(str));
};

/**
 * Write a terminating Uint8Array. Note that this is not performant and is generally
 * discouraged. There are few situations when this is needed.
 *
 * We use 0x0 as a terminating character. 0x1 serves as an escape character for 0x0 and 0x1.
 *
 * Example: [0,1,2] is encoded to [1,0,1,1,2,0]. 0x0, and 0x1 needed to be escaped using 0x1. Then
 * the result is terminated using the 0x0 character.
 *
 * This is basically how many systems implement null terminated strings. However, we use an escape
 * character 0x1 to avoid issues and potenial attacks on our database (if this is used as a key
 * encoder for NoSql databases).
 *
 * @function
 * @param {Encoder} encoder
 * @param {Uint8Array} buf The string that is to be encoded.
 */
var writeTerminatedUint8Array = function writeTerminatedUint8Array(encoder, buf) {
  for (var i = 0; i < buf.length; i++) {
    var b = buf[i];
    if (b === 0 || b === 1) {
      write(encoder, 1);
    }
    write(encoder, buf[i]);
  }
  write(encoder, 0);
};

/**
 * Write the content of another Encoder.
 *
 * @TODO: can be improved!
 *        - Note: Should consider that when appending a lot of small Encoders, we should rather clone than referencing the old structure.
 *                Encoders start with a rather big initial buffer.
 *
 * @function
 * @param {Encoder} encoder The enUint8Arr
 * @param {Encoder} append The BinaryEncoder to be written.
 */
var writeBinaryEncoder = function writeBinaryEncoder(encoder, append) {
  return writeUint8Array(encoder, _toUint8Array(append));
};

/**
 * Append fixed-length Uint8Array to the encoder.
 *
 * @function
 * @param {Encoder} encoder
 * @param {Uint8Array} uint8Array
 */
var writeUint8Array = function writeUint8Array(encoder, uint8Array) {
  var bufferLen = encoder.cbuf.length;
  var cpos = encoder.cpos;
  var leftCopyLen = _math_js__WEBPACK_IMPORTED_MODULE_38__/* .min */ .VV(bufferLen - cpos, uint8Array.length);
  var rightCopyLen = uint8Array.length - leftCopyLen;
  encoder.cbuf.set(uint8Array.subarray(0, leftCopyLen), cpos);
  encoder.cpos += leftCopyLen;
  if (rightCopyLen > 0) {
    // Still something to write, write right half..
    // Append new buffer
    encoder.bufs.push(encoder.cbuf);
    // must have at least size of remaining buffer
    encoder.cbuf = new Uint8Array(_math_js__WEBPACK_IMPORTED_MODULE_38__/* .max */ .Fp(bufferLen * 2, rightCopyLen));
    // copy array
    encoder.cbuf.set(uint8Array.subarray(leftCopyLen));
    encoder.cpos = rightCopyLen;
  }
};

/**
 * Append an Uint8Array to Encoder.
 *
 * @function
 * @param {Encoder} encoder
 * @param {Uint8Array} uint8Array
 */
var writeVarUint8Array = function writeVarUint8Array(encoder, uint8Array) {
  writeVarUint(encoder, uint8Array.byteLength);
  writeUint8Array(encoder, uint8Array);
};

/**
 * Create an DataView of the next `len` bytes. Use it to write data after
 * calling this function.
 *
 * ```js
 * // write float32 using DataView
 * const dv = writeOnDataView(encoder, 4)
 * dv.setFloat32(0, 1.1)
 * // read float32 using DataView
 * const dv = readFromDataView(encoder, 4)
 * dv.getFloat32(0) // => 1.100000023841858 (leaving it to the reader to find out why this is the correct result)
 * ```
 *
 * @param {Encoder} encoder
 * @param {number} len
 * @return {DataView}
 */
var writeOnDataView = function writeOnDataView(encoder, len) {
  verifyLen(encoder, len);
  var dview = new DataView(encoder.cbuf.buffer, encoder.cpos, len);
  encoder.cpos += len;
  return dview;
};

/**
 * @param {Encoder} encoder
 * @param {number} num
 */
var writeFloat32 = function writeFloat32(encoder, num) {
  return writeOnDataView(encoder, 4).setFloat32(0, num, false);
};

/**
 * @param {Encoder} encoder
 * @param {number} num
 */
var writeFloat64 = function writeFloat64(encoder, num) {
  return writeOnDataView(encoder, 8).setFloat64(0, num, false);
};

/**
 * @param {Encoder} encoder
 * @param {bigint} num
 */
var writeBigInt64 = function writeBigInt64(encoder, num) {
  return (/** @type {any} */writeOnDataView(encoder, 8).setBigInt64(0, num, false)
  );
};

/**
 * @param {Encoder} encoder
 * @param {bigint} num
 */
var writeBigUint64 = function writeBigUint64(encoder, num) {
  return (/** @type {any} */writeOnDataView(encoder, 8).setBigUint64(0, num, false)
  );
};
var floatTestBed = new DataView(new ArrayBuffer(4));
/**
 * Check if a number can be encoded as a 32 bit float.
 *
 * @param {number} num
 * @return {boolean}
 */
var isFloat32 = function isFloat32(num) {
  floatTestBed.setFloat32(0, num);
  return floatTestBed.getFloat32(0) === num;
};

/**
 * Encode data with efficient binary format.
 *
 * Differences to JSON:
 * • Transforms data to a binary format (not to a string)
 * • Encodes undefined, NaN, and ArrayBuffer (these can't be represented in JSON)
 * • Numbers are efficiently encoded either as a variable length integer, as a
 *   32 bit float, as a 64 bit float, or as a 64 bit bigint.
 *
 * Encoding table:
 *
 * | Data Type           | Prefix   | Encoding Method    | Comment |
 * | ------------------- | -------- | ------------------ | ------- |
 * | undefined           | 127      |                    | Functions, symbol, and everything that cannot be identified is encoded as undefined |
 * | null                | 126      |                    | |
 * | integer             | 125      | writeVarInt        | Only encodes 32 bit signed integers |
 * | float32             | 124      | writeFloat32       | |
 * | float64             | 123      | writeFloat64       | |
 * | bigint              | 122      | writeBigInt64      | |
 * | boolean (false)     | 121      |                    | True and false are different data types so we save the following byte |
 * | boolean (true)      | 120      |                    | - 0b01111000 so the last bit determines whether true or false |
 * | string              | 119      | writeVarString     | |
 * | object<string,any>  | 118      | custom             | Writes {length} then {length} key-value pairs |
 * | array<any>          | 117      | custom             | Writes {length} then {length} json values |
 * | Uint8Array          | 116      | writeVarUint8Array | We use Uint8Array for any kind of binary data |
 *
 * Reasons for the decreasing prefix:
 * We need the first bit for extendability (later we may want to encode the
 * prefix with writeVarUint). The remaining 7 bits are divided as follows:
 * [0-30]   the beginning of the data range is used for custom purposes
 *          (defined by the function that uses this library)
 * [31-127] the end of the data range is used for data encoding by
 *          lib0/encoding.js
 *
 * @param {Encoder} encoder
 * @param {undefined|null|number|bigint|boolean|string|Object<string,any>|Array<any>|Uint8Array} data
 */
var writeAny = function writeAny(encoder, data) {
  switch (_typeof(data)) {
    case 'string':
      // TYPE 119: STRING
      write(encoder, 119);
      writeVarString(encoder, data);
      break;
    case 'number':
      if (number.isInteger(data) && math.abs(data) <= binary.BITS31) {
        // TYPE 125: INTEGER
        write(encoder, 125);
        writeVarInt(encoder, data);
      } else if (isFloat32(data)) {
        // TYPE 124: FLOAT32
        write(encoder, 124);
        writeFloat32(encoder, data);
      } else {
        // TYPE 123: FLOAT64
        write(encoder, 123);
        writeFloat64(encoder, data);
      }
      break;
    case 'bigint':
      // TYPE 122: BigInt
      write(encoder, 122);
      writeBigInt64(encoder, data);
      break;
    case 'object':
      if (data === null) {
        // TYPE 126: null
        write(encoder, 126);
      } else if (array.isArray(data)) {
        // TYPE 117: Array
        write(encoder, 117);
        writeVarUint(encoder, data.length);
        for (var i = 0; i < data.length; i++) {
          writeAny(encoder, data[i]);
        }
      } else if (data instanceof Uint8Array) {
        // TYPE 116: ArrayBuffer
        write(encoder, 116);
        writeVarUint8Array(encoder, data);
      } else {
        // TYPE 118: Object
        write(encoder, 118);
        var keys = Object.keys(data);
        writeVarUint(encoder, keys.length);
        for (var _i = 0; _i < keys.length; _i++) {
          var key = keys[_i];
          writeVarString(encoder, key);
          writeAny(encoder, data[key]);
        }
      }
      break;
    case 'boolean':
      // TYPE 120/121: boolean (true/false)
      write(encoder, data ? 120 : 121);
      break;
    default:
      // TYPE 127: undefined
      write(encoder, 127);
  }
};

/**
 * Now come a few stateful encoder that have their own classes.
 */

/**
 * Basic Run Length Encoder - a basic compression implementation.
 *
 * Encodes [1,1,1,7] to [1,3,7,1] (3 times 1, 1 time 7). This encoder might do more harm than good if there are a lot of values that are not repeated.
 *
 * It was originally used for image compression. Cool .. article http://csbruce.com/cbm/transactor/pdfs/trans_v7_i06.pdf
 *
 * @note T must not be null!
 *
 * @template T
 */
var RleEncoder = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_Encoder) {
  _inherits(RleEncoder, _Encoder);
  var _super = _createSuper(RleEncoder);
  /**
   * @param {function(Encoder, T):void} writer
   */
  function RleEncoder(writer) {
    var _this;
    _classCallCheck(this, RleEncoder);
    _this = _super.call(this);
    /**
     * The writer
     */
    _this.w = writer;
    /**
     * Current state
     * @type {T|null}
     */
    _this.s = null;
    _this.count = 0;
    return _this;
  }

  /**
   * @param {T} v
   */
  _createClass(RleEncoder, [{
    key: "write",
    value: function write(v) {
      if (this.s === v) {
        this.count++;
      } else {
        if (this.count > 0) {
          // flush counter, unless this is the first value (count = 0)
          writeVarUint(this, this.count - 1); // since count is always > 0, we can decrement by one. non-standard encoding ftw
        }

        this.count = 1;
        // write first value
        this.w(this, v);
        this.s = v;
      }
    }
  }]);
  return RleEncoder;
}(Encoder)));

/**
 * Basic diff decoder using variable length encoding.
 *
 * Encodes the values [3, 1100, 1101, 1050, 0] to [3, 1097, 1, -51, -1050] using writeVarInt.
 */
var IntDiffEncoder = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_Encoder2) {
  _inherits(IntDiffEncoder, _Encoder2);
  var _super2 = _createSuper(IntDiffEncoder);
  /**
   * @param {number} start
   */
  function IntDiffEncoder(start) {
    var _this2;
    _classCallCheck(this, IntDiffEncoder);
    _this2 = _super2.call(this);
    /**
     * Current state
     * @type {number}
     */
    _this2.s = start;
    return _this2;
  }

  /**
   * @param {number} v
   */
  _createClass(IntDiffEncoder, [{
    key: "write",
    value: function write(v) {
      writeVarInt(this, v - this.s);
      this.s = v;
    }
  }]);
  return IntDiffEncoder;
}(Encoder)));

/**
 * A combination of IntDiffEncoder and RleEncoder.
 *
 * Basically first writes the IntDiffEncoder and then counts duplicate diffs using RleEncoding.
 *
 * Encodes the values [1,1,1,2,3,4,5,6] as [1,1,0,2,1,5] (RLE([1,0,0,1,1,1,1,1]) ⇒ RleIntDiff[1,1,0,2,1,5])
 */
var RleIntDiffEncoder = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_Encoder3) {
  _inherits(RleIntDiffEncoder, _Encoder3);
  var _super3 = _createSuper(RleIntDiffEncoder);
  /**
   * @param {number} start
   */
  function RleIntDiffEncoder(start) {
    var _this3;
    _classCallCheck(this, RleIntDiffEncoder);
    _this3 = _super3.call(this);
    /**
     * Current state
     * @type {number}
     */
    _this3.s = start;
    _this3.count = 0;
    return _this3;
  }

  /**
   * @param {number} v
   */
  _createClass(RleIntDiffEncoder, [{
    key: "write",
    value: function write(v) {
      if (this.s === v && this.count > 0) {
        this.count++;
      } else {
        if (this.count > 0) {
          // flush counter, unless this is the first value (count = 0)
          writeVarUint(this, this.count - 1); // since count is always > 0, we can decrement by one. non-standard encoding ftw
        }

        this.count = 1;
        // write first value
        writeVarInt(this, v - this.s);
        this.s = v;
      }
    }
  }]);
  return RleIntDiffEncoder;
}(Encoder)));

/**
 * @param {UintOptRleEncoder} encoder
 */
var flushUintOptRleEncoder = function flushUintOptRleEncoder(encoder) {
  if (encoder.count > 0) {
    // flush counter, unless this is the first value (count = 0)
    // case 1: just a single value. set sign to positive
    // case 2: write several values. set sign to negative to indicate that there is a length coming
    writeVarInt(encoder.encoder, encoder.count === 1 ? encoder.s : -encoder.s);
    if (encoder.count > 1) {
      writeVarUint(encoder.encoder, encoder.count - 2); // since count is always > 1, we can decrement by one. non-standard encoding ftw
    }
  }
};

/**
 * Optimized Rle encoder that does not suffer from the mentioned problem of the basic Rle encoder.
 *
 * Internally uses VarInt encoder to write unsigned integers. If the input occurs multiple times, we write
 * write it as a negative number. The UintOptRleDecoder then understands that it needs to read a count.
 *
 * Encodes [1,2,3,3,3] as [1,2,-3,3] (once 1, once 2, three times 3)
 */
var UintOptRleEncoder = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  function UintOptRleEncoder() {
    _classCallCheck(this, UintOptRleEncoder);
    this.encoder = new Encoder();
    /**
     * @type {number}
     */
    this.s = 0;
    this.count = 0;
  }

  /**
   * @param {number} v
   */
  _createClass(UintOptRleEncoder, [{
    key: "write",
    value: function write(v) {
      if (this.s === v) {
        this.count++;
      } else {
        flushUintOptRleEncoder(this);
        this.count = 1;
        this.s = v;
      }
    }

    /**
     * Flush the encoded state and transform this to a Uint8Array.
     *
     * Note that this should only be called once.
     */
  }, {
    key: "toUint8Array",
    value: function toUint8Array() {
      flushUintOptRleEncoder(this);
      return _toUint8Array(this.encoder);
    }
  }]);
  return UintOptRleEncoder;
}()));

/**
 * Increasing Uint Optimized RLE Encoder
 *
 * The RLE encoder counts the number of same occurences of the same value.
 * The IncUintOptRle encoder counts if the value increases.
 * I.e. 7, 8, 9, 10 will be encoded as [-7, 4]. 1, 3, 5 will be encoded
 * as [1, 3, 5].
 */
var IncUintOptRleEncoder = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  function IncUintOptRleEncoder() {
    _classCallCheck(this, IncUintOptRleEncoder);
    this.encoder = new Encoder();
    /**
     * @type {number}
     */
    this.s = 0;
    this.count = 0;
  }

  /**
   * @param {number} v
   */
  _createClass(IncUintOptRleEncoder, [{
    key: "write",
    value: function write(v) {
      if (this.s + this.count === v) {
        this.count++;
      } else {
        flushUintOptRleEncoder(this);
        this.count = 1;
        this.s = v;
      }
    }

    /**
     * Flush the encoded state and transform this to a Uint8Array.
     *
     * Note that this should only be called once.
     */
  }, {
    key: "toUint8Array",
    value: function toUint8Array() {
      flushUintOptRleEncoder(this);
      return _toUint8Array(this.encoder);
    }
  }]);
  return IncUintOptRleEncoder;
}()));

/**
 * @param {IntDiffOptRleEncoder} encoder
 */
var flushIntDiffOptRleEncoder = function flushIntDiffOptRleEncoder(encoder) {
  if (encoder.count > 0) {
    //          31 bit making up the diff | wether to write the counter
    // const encodedDiff = encoder.diff << 1 | (encoder.count === 1 ? 0 : 1)
    var encodedDiff = encoder.diff * 2 + (encoder.count === 1 ? 0 : 1);
    // flush counter, unless this is the first value (count = 0)
    // case 1: just a single value. set first bit to positive
    // case 2: write several values. set first bit to negative to indicate that there is a length coming
    writeVarInt(encoder.encoder, encodedDiff);
    if (encoder.count > 1) {
      writeVarUint(encoder.encoder, encoder.count - 2); // since count is always > 1, we can decrement by one. non-standard encoding ftw
    }
  }
};

/**
 * A combination of the IntDiffEncoder and the UintOptRleEncoder.
 *
 * The count approach is similar to the UintDiffOptRleEncoder, but instead of using the negative bitflag, it encodes
 * in the LSB whether a count is to be read. Therefore this Encoder only supports 31 bit integers!
 *
 * Encodes [1, 2, 3, 2] as [3, 1, 6, -1] (more specifically [(1 << 1) | 1, (3 << 0) | 0, -1])
 *
 * Internally uses variable length encoding. Contrary to normal UintVar encoding, the first byte contains:
 * * 1 bit that denotes whether the next value is a count (LSB)
 * * 1 bit that denotes whether this value is negative (MSB - 1)
 * * 1 bit that denotes whether to continue reading the variable length integer (MSB)
 *
 * Therefore, only five bits remain to encode diff ranges.
 *
 * Use this Encoder only when appropriate. In most cases, this is probably a bad idea.
 */
var IntDiffOptRleEncoder = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  function IntDiffOptRleEncoder() {
    _classCallCheck(this, IntDiffOptRleEncoder);
    this.encoder = new Encoder();
    /**
     * @type {number}
     */
    this.s = 0;
    this.count = 0;
    this.diff = 0;
  }

  /**
   * @param {number} v
   */
  _createClass(IntDiffOptRleEncoder, [{
    key: "write",
    value: function write(v) {
      if (this.diff === v - this.s) {
        this.s = v;
        this.count++;
      } else {
        flushIntDiffOptRleEncoder(this);
        this.count = 1;
        this.diff = v - this.s;
        this.s = v;
      }
    }

    /**
     * Flush the encoded state and transform this to a Uint8Array.
     *
     * Note that this should only be called once.
     */
  }, {
    key: "toUint8Array",
    value: function toUint8Array() {
      flushIntDiffOptRleEncoder(this);
      return _toUint8Array(this.encoder);
    }
  }]);
  return IntDiffOptRleEncoder;
}()));

/**
 * Optimized String Encoder.
 *
 * Encoding many small strings in a simple Encoder is not very efficient. The function call to decode a string takes some time and creates references that must be eventually deleted.
 * In practice, when decoding several million small strings, the GC will kick in more and more often to collect orphaned string objects (or maybe there is another reason?).
 *
 * This string encoder solves the above problem. All strings are concatenated and written as a single string using a single encoding call.
 *
 * The lengths are encoded using a UintOptRleEncoder.
 */
var StringEncoder = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  function StringEncoder() {
    _classCallCheck(this, StringEncoder);
    /**
     * @type {Array<string>}
     */
    this.sarr = [];
    this.s = '';
    this.lensE = new UintOptRleEncoder();
  }

  /**
   * @param {string} string
   */
  _createClass(StringEncoder, [{
    key: "write",
    value: function write(string) {
      this.s += string;
      if (this.s.length > 19) {
        this.sarr.push(this.s);
        this.s = '';
      }
      this.lensE.write(string.length);
    }
  }, {
    key: "toUint8Array",
    value: function toUint8Array() {
      var encoder = new Encoder();
      this.sarr.push(this.s);
      this.s = '';
      writeVarString(encoder, this.sarr.join(''));
      writeUint8Array(encoder, this.lensE.toUint8Array());
      return _toUint8Array(encoder);
    }
  }]);
  return StringEncoder;
}()));

/***/ }),

/***/ 36345:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Hi": () => (/* binding */ equalityDeep),
  "UV": () => (/* binding */ equalityFlat)
});

// UNUSED EXPORTS: apply, callAll, equalityStrict, id, is, isArray, isNumber, isOneOf, isString, isTemplate, nop

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array-buffer.constructor.js
var es_array_buffer_constructor = __webpack_require__(18264);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.uint8-array.js
var es_typed_array_uint8_array = __webpack_require__(82472);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.copy-within.js
var es_typed_array_copy_within = __webpack_require__(92990);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.every.js
var es_typed_array_every = __webpack_require__(18927);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.fill.js
var es_typed_array_fill = __webpack_require__(33105);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.filter.js
var es_typed_array_filter = __webpack_require__(35035);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.find.js
var es_typed_array_find = __webpack_require__(74345);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.find-index.js
var es_typed_array_find_index = __webpack_require__(7174);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.for-each.js
var es_typed_array_for_each = __webpack_require__(32846);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.includes.js
var es_typed_array_includes = __webpack_require__(44731);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.index-of.js
var es_typed_array_index_of = __webpack_require__(77209);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.iterator.js
var es_typed_array_iterator = __webpack_require__(96319);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.join.js
var es_typed_array_join = __webpack_require__(58867);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.last-index-of.js
var es_typed_array_last_index_of = __webpack_require__(37789);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.map.js
var es_typed_array_map = __webpack_require__(33739);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reduce.js
var es_typed_array_reduce = __webpack_require__(29368);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reduce-right.js
var es_typed_array_reduce_right = __webpack_require__(14483);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reverse.js
var es_typed_array_reverse = __webpack_require__(12056);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.set.js
var es_typed_array_set = __webpack_require__(3462);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.slice.js
var es_typed_array_slice = __webpack_require__(30678);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.some.js
var es_typed_array_some = __webpack_require__(27462);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.sort.js
var es_typed_array_sort = __webpack_require__(33824);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.subarray.js
var es_typed_array_subarray = __webpack_require__(55021);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.to-locale-string.js
var es_typed_array_to_locale_string = __webpack_require__(12974);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.to-string.js
var es_typed_array_to_string = __webpack_require__(15016);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__(70189);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.map.js
var es_map = __webpack_require__(51532);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(32023);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(9653);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/lib0/array.js
var array = __webpack_require__(46210);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(19601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.freeze.js
var es_object_freeze = __webpack_require__(43371);
;// CONCATENATED MODULE: ./node_modules/lib0/object.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }










/**
 * Utility functions for working with EcmaScript objects.
 *
 * @module object
 */

/**
 * @return {Object<string,any>} obj
 */
var create = function create() {
  return Object.create(null);
};

/**
 * Object.assign
 */
var object_assign = Object.assign;

/**
 * @param {Object<string,any>} obj
 */
var keys = Object.keys;

/**
 * @template V
 * @param {{[k:string]:V}} obj
 * @param {function(V,string):any} f
 */
var forEach = function forEach(obj, f) {
  for (var key in obj) {
    f(obj[key], key);
  }
};

/**
 * @todo implement mapToArray & map
 *
 * @template R
 * @param {Object<string,any>} obj
 * @param {function(any,string):R} f
 * @return {Array<R>}
 */
var map = function map(obj, f) {
  var results = [];
  for (var key in obj) {
    results.push(f(obj[key], key));
  }
  return results;
};

/**
 * @deprecated use object.size instead
 * @param {Object<string,any>} obj
 * @return {number}
 */
var object_length = function length(obj) {
  return keys(obj).length;
};

/**
 * @param {Object<string,any>} obj
 * @return {number}
 */
var size = function size(obj) {
  return keys(obj).length;
};

/**
 * @param {Object<string,any>} obj
 * @param {function(any,string):boolean} f
 * @return {boolean}
 */
var some = function some(obj, f) {
  for (var key in obj) {
    if (f(obj[key], key)) {
      return true;
    }
  }
  return false;
};

/**
 * @param {Object|undefined} obj
 */
var isEmpty = function isEmpty(obj) {
  // eslint-disable-next-line
  for (var _k in obj) {
    return false;
  }
  return true;
};

/**
 * @param {Object<string,any>} obj
 * @param {function(any,string):boolean} f
 * @return {boolean}
 */
var every = function every(obj, f) {
  for (var key in obj) {
    if (!f(obj[key], key)) {
      return false;
    }
  }
  return true;
};

/**
 * Calls `Object.prototype.hasOwnProperty`.
 *
 * @param {any} obj
 * @param {string|symbol} key
 * @return {boolean}
 */
var hasProperty = function hasProperty(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
};

/**
 * @param {Object<string,any>} a
 * @param {Object<string,any>} b
 * @return {boolean}
 */
var equalFlat = function equalFlat(a, b) {
  return a === b || size(a) === size(b) && every(a, function (val, key) {
    return (val !== undefined || hasProperty(b, key)) && b[key] === val;
  });
};

/**
 * Make an object immutable. This hurts performance and is usually not needed if you perform good
 * coding practices.
 */
var freeze = Object.freeze;

/**
 * Make an object and all its children immutable.
 * This *really* hurts performance and is usually not needed if you perform good coding practices.
 *
 * @template {any} T
 * @param {T} o
 * @return {Readonly<T>}
 */
var deepFreeze = function deepFreeze(o) {
  for (var key in o) {
    var c = o[key];
    if (_typeof(c) === 'object' || typeof c === 'function') {
      deepFreeze(o[key]);
    }
  }
  return freeze(o);
};
;// CONCATENATED MODULE: ./node_modules/lib0/function.js
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }








































function function_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { function_typeof = function _typeof(obj) { return typeof obj; }; } else { function_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return function_typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
/**
 * Common functions and function call helpers.
 *
 * @module function
 */




/**
 * Calls all functions in `fs` with args. Only throws after all functions were called.
 *
 * @param {Array<function>} fs
 * @param {Array<any>} args
 */
var callAll = function callAll(fs, args) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  try {
    for (; i < fs.length; i++) {
      fs[i].apply(fs, _toConsumableArray(args));
    }
  } finally {
    if (i < fs.length) {
      callAll(fs, args, i + 1);
    }
  }
};
var nop = function nop() {};

/**
 * @template T
 * @param {function():T} f
 * @return {T}
 */
var apply = function apply(f) {
  return f();
};

/**
 * @template A
 *
 * @param {A} a
 * @return {A}
 */
var id = function id(a) {
  return a;
};

/**
 * @template T
 *
 * @param {T} a
 * @param {T} b
 * @return {boolean}
 */
var equalityStrict = function equalityStrict(a, b) {
  return a === b;
};

/**
 * @template T
 *
 * @param {Array<T>|object} a
 * @param {Array<T>|object} b
 * @return {boolean}
 */
var equalityFlat = function equalityFlat(a, b) {
  return a === b || a != null && b != null && a.constructor === b.constructor && (array/* isArray */.kJ(a) && array/* equalFlat */.$m(a, b) || function_typeof(a) === 'object' && equalFlat(a, b));
};

/* c8 ignore start */

/**
 * @param {any} a
 * @param {any} b
 * @return {boolean}
 */
var equalityDeep = function equalityDeep(a, b) {
  if (a == null || b == null) {
    return equalityStrict(a, b);
  }
  if (a.constructor !== b.constructor) {
    return false;
  }
  if (a === b) {
    return true;
  }
  switch (a.constructor) {
    case ArrayBuffer:
      a = new Uint8Array(a);
      b = new Uint8Array(b);
    // eslint-disable-next-line no-fallthrough
    case Uint8Array:
      {
        if (a.byteLength !== b.byteLength) {
          return false;
        }
        for (var i = 0; i < a.length; i++) {
          if (a[i] !== b[i]) {
            return false;
          }
        }
        break;
      }
    case Set:
      {
        if (a.size !== b.size) {
          return false;
        }
        var _iterator = _createForOfIteratorHelper(a),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var value = _step.value;
            if (!b.has(value)) {
              return false;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        break;
      }
    case Map:
      {
        if (a.size !== b.size) {
          return false;
        }
        var _iterator2 = _createForOfIteratorHelper(a.keys()),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var key = _step2.value;
            if (!b.has(key) || !equalityDeep(a.get(key), b.get(key))) {
              return false;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        break;
      }
    case Object:
      if (object_length(a) !== object_length(b)) {
        return false;
      }
      for (var _key in a) {
        if (!hasProperty(a, _key) || !equalityDeep(a[_key], b[_key])) {
          return false;
        }
      }
      break;
    case Array:
      if (a.length !== b.length) {
        return false;
      }
      for (var _i = 0; _i < a.length; _i++) {
        if (!equalityDeep(a[_i], b[_i])) {
          return false;
        }
      }
      break;
    default:
      return false;
  }
  return true;
};

/**
 * @template V
 * @template {V} OPTS
 *
 * @param {V} value
 * @param {Array<OPTS>} options
 */
// @ts-ignore
var isOneOf = function isOneOf(value, options) {
  return options.includes(value);
};
/* c8 ignore stop */

var isArray = array/* isArray */.kJ;

/**
 * @param {any} s
 * @return {s is String}
 */
var isString = function isString(s) {
  return s && s.constructor === String;
};

/**
 * @param {any} n
 * @return {n is Number}
 */
var isNumber = function isNumber(n) {
  return n != null && n.constructor === Number;
};

/**
 * @template {abstract new (...args: any) => any} TYPE
 * @param {any} n
 * @param {TYPE} T
 * @return {n is InstanceType<TYPE>}
 */
var is = function is(n, T) {
  return n && n.constructor === T;
};

/**
 * @template {abstract new (...args: any) => any} TYPE
 * @param {TYPE} T
 */
var isTemplate = function isTemplate(T) {
  return (
    /**
     * @param {any} n
     * @return {n is InstanceType<TYPE>}
     **/
    function (n) {
      return n && n.constructor === T;
    }
  );
};

/***/ }),

/***/ 23251:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GW": () => (/* binding */ floor),
/* harmony export */   "IH": () => (/* binding */ add),
/* harmony export */   "VV": () => (/* binding */ min),
/* harmony export */   "Fp": () => (/* binding */ max)
/* harmony export */ });
/* unused harmony exports ceil, abs, imul, round, log10, log2, log, sqrt, isNaN, pow, exp10, sign, isNegativeZero */
/* harmony import */ var core_js_modules_es_math_imul_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90332);
/* harmony import */ var core_js_modules_es_math_log10_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40658);
/* harmony import */ var core_js_modules_es_math_log2_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44914);
/* harmony import */ var core_js_modules_es_number_is_nan_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44048);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_math_sign_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52420);






/**
 * Common Math expressions.
 *
 * @module math
 */

var floor = Math.floor;
var ceil = Math.ceil;
var abs = Math.abs;
var imul = Math.imul;
var round = Math.round;
var log10 = Math.log10;
var log2 = Math.log2;
var log = Math.log;
var sqrt = Math.sqrt;

/**
 * @function
 * @param {number} a
 * @param {number} b
 * @return {number} The sum of a and b
 */
var add = function add(a, b) {
  return a + b;
};

/**
 * @function
 * @param {number} a
 * @param {number} b
 * @return {number} The smaller element of a and b
 */
var min = function min(a, b) {
  return a < b ? a : b;
};

/**
 * @function
 * @param {number} a
 * @param {number} b
 * @return {number} The bigger element of a and b
 */
var max = function max(a, b) {
  return a > b ? a : b;
};
var isNaN = Number.isNaN;
var pow = Math.pow;
/**
 * Base 10 exponential function. Returns the value of 10 raised to the power of pow.
 *
 * @param {number} exp
 * @return {number}
 */
var exp10 = function exp10(exp) {
  return Math.pow(10, exp);
};
var sign = Math.sign;

/**
 * @param {number} n
 * @return {boolean} Wether n is negative. This function also differentiates between -0 and +0
 */
var isNegativeZero = function isNegativeZero(n) {
  return n !== 0 ? n < 0 : 1 / n < 0;
};

/***/ }),

/***/ 94628:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YZ": () => (/* binding */ utf8TextEncoder),
/* harmony export */   "lz": () => (/* binding */ encodeUtf8),
/* harmony export */   "CO": () => (/* binding */ utf8TextDecoder)
/* harmony export */ });
/* unused harmony exports fromCharCode, fromCodePoint, MAX_UTF16_CHARACTER, trimLeft, fromCamelCase, utf8ByteLength, _encodeUtf8Polyfill, _encodeUtf8Native, _decodeUtf8Polyfill, _decodeUtf8Native, decodeUtf8, splice, repeat */
/* harmony import */ var core_js_modules_es_string_from_code_point_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94953);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_typed_array_uint8_array_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82472);
/* harmony import */ var core_js_modules_es_typed_array_copy_within_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92990);
/* harmony import */ var core_js_modules_es_typed_array_every_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18927);
/* harmony import */ var core_js_modules_es_typed_array_fill_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(33105);
/* harmony import */ var core_js_modules_es_typed_array_filter_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35035);
/* harmony import */ var core_js_modules_es_typed_array_find_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(74345);
/* harmony import */ var core_js_modules_es_typed_array_find_index_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7174);
/* harmony import */ var core_js_modules_es_typed_array_for_each_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(32846);
/* harmony import */ var core_js_modules_es_typed_array_includes_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(44731);
/* harmony import */ var core_js_modules_es_typed_array_index_of_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(77209);
/* harmony import */ var core_js_modules_es_typed_array_iterator_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(96319);
/* harmony import */ var core_js_modules_es_typed_array_join_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(58867);
/* harmony import */ var core_js_modules_es_typed_array_last_index_of_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(37789);
/* harmony import */ var core_js_modules_es_typed_array_map_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(33739);
/* harmony import */ var core_js_modules_es_typed_array_reduce_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(29368);
/* harmony import */ var core_js_modules_es_typed_array_reduce_right_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(14483);
/* harmony import */ var core_js_modules_es_typed_array_reverse_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(12056);
/* harmony import */ var core_js_modules_es_typed_array_set_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(3462);
/* harmony import */ var core_js_modules_es_typed_array_slice_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(30678);
/* harmony import */ var core_js_modules_es_typed_array_some_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(27462);
/* harmony import */ var core_js_modules_es_typed_array_sort_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(33824);
/* harmony import */ var core_js_modules_es_typed_array_subarray_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(55021);
/* harmony import */ var core_js_modules_es_typed_array_to_locale_string_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(12974);
/* harmony import */ var core_js_modules_es_typed_array_to_string_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(15016);
/* harmony import */ var core_js_modules_es_string_code_point_at_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(79841);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(69600);



































/**
 * Utility module to work with strings.
 *
 * @module string
 */

var fromCharCode = String.fromCharCode;
var fromCodePoint = String.fromCodePoint;

/**
 * The largest utf16 character.
 * Corresponds to Uint8Array([255, 255]) or charcodeof(2x2^8)
 */
var MAX_UTF16_CHARACTER = fromCharCode(65535);

/**
 * @param {string} s
 * @return {string}
 */
var toLowerCase = function toLowerCase(s) {
  return s.toLowerCase();
};
var trimLeftRegex = /^\s*/g;

/**
 * @param {string} s
 * @return {string}
 */
var trimLeft = function trimLeft(s) {
  return s.replace(trimLeftRegex, '');
};
var fromCamelCaseRegex = /([A-Z])/g;

/**
 * @param {string} s
 * @param {string} separator
 * @return {string}
 */
var fromCamelCase = function fromCamelCase(s, separator) {
  return trimLeft(s.replace(fromCamelCaseRegex, function (match) {
    return "".concat(separator).concat(toLowerCase(match));
  }));
};

/**
 * Compute the utf8ByteLength
 * @param {string} str
 * @return {number}
 */
var utf8ByteLength = function utf8ByteLength(str) {
  return unescape(encodeURIComponent(str)).length;
};

/**
 * @param {string} str
 * @return {Uint8Array}
 */
var _encodeUtf8Polyfill = function _encodeUtf8Polyfill(str) {
  var encodedString = unescape(encodeURIComponent(str));
  var len = encodedString.length;
  var buf = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    buf[i] = encodedString.codePointAt(i);
  }
  return buf;
};

/* c8 ignore next */
var utf8TextEncoder = typeof TextEncoder !== 'undefined' ? new TextEncoder() : null;

/**
 * @param {string} str
 * @return {Uint8Array}
 */
var _encodeUtf8Native = function _encodeUtf8Native(str) {
  return utf8TextEncoder.encode(str);
};

/**
 * @param {string} str
 * @return {Uint8Array}
 */
/* c8 ignore next */
var encodeUtf8 = utf8TextEncoder ? _encodeUtf8Native : _encodeUtf8Polyfill;

/**
 * @param {Uint8Array} buf
 * @return {string}
 */
var _decodeUtf8Polyfill = function _decodeUtf8Polyfill(buf) {
  var remainingLen = buf.length;
  var encodedString = '';
  var bufPos = 0;
  while (remainingLen > 0) {
    var nextLen = remainingLen < 10000 ? remainingLen : 10000;
    var bytes = buf.subarray(bufPos, bufPos + nextLen);
    bufPos += nextLen;
    // Starting with ES5.1 we can supply a generic array-like object as arguments
    encodedString += String.fromCodePoint.apply(null, bytes);
    remainingLen -= nextLen;
  }
  return decodeURIComponent(escape(encodedString));
};

/* c8 ignore next */
var utf8TextDecoder = typeof TextDecoder === 'undefined' ? null : new TextDecoder('utf-8', {
  fatal: true,
  ignoreBOM: true
});

/* c8 ignore start */
if (utf8TextDecoder && utf8TextDecoder.decode(new Uint8Array()).length === 1) {
  // Safari doesn't handle BOM correctly.
  // This fixes a bug in Safari 13.0.5 where it produces a BOM the first time it is called.
  // utf8TextDecoder.decode(new Uint8Array()).length === 1 on the first call and
  // utf8TextDecoder.decode(new Uint8Array()).length === 1 on the second call
  // Another issue is that from then on no BOM chars are recognized anymore
  /* c8 ignore next */
  utf8TextDecoder = null;
}
/* c8 ignore stop */

/**
 * @param {Uint8Array} buf
 * @return {string}
 */
var _decodeUtf8Native = function _decodeUtf8Native(buf) {
  return (/** @type {TextDecoder} */utf8TextDecoder.decode(buf)
  );
};

/**
 * @param {Uint8Array} buf
 * @return {string}
 */
/* c8 ignore next */
var decodeUtf8 = (/* unused pure expression or super */ null && (utf8TextDecoder ? _decodeUtf8Native : _decodeUtf8Polyfill));

/**
 * @param {string} str The initial string
 * @param {number} index Starting position
 * @param {number} remove Number of characters to remove
 * @param {string} insert New content to insert
 */
var splice = function splice(str, index, remove) {
  var insert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  return str.slice(0, index) + insert + str.slice(index + remove);
};

/**
 * @param {string} source
 * @param {number} n
 */
var repeat = function repeat(source, n) {
  return array.unfold(n, function () {
    return source;
  }).join('');
};

/***/ }),

/***/ 15264:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Awareness": () => (/* binding */ Awareness),
  "applyAwarenessUpdate": () => (/* binding */ applyAwarenessUpdate),
  "encodeAwarenessUpdate": () => (/* binding */ encodeAwarenessUpdate),
  "modifyAwarenessUpdate": () => (/* binding */ modifyAwarenessUpdate),
  "outdatedTimeout": () => (/* binding */ outdatedTimeout),
  "removeAwarenessStates": () => (/* binding */ removeAwarenessStates)
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.map.js
var es_map = __webpack_require__(51532);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(54747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(30489);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__(12419);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.get.js
var es_reflect_get = __webpack_require__(74819);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__(38880);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(57327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__(49337);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/lib0/encoding.js
var encoding = __webpack_require__(55529);
// EXTERNAL MODULE: ./node_modules/lib0/decoding.js + 2 modules
var decoding = __webpack_require__(49016);
;// CONCATENATED MODULE: ./node_modules/lib0/time.js
/**
 * Utility module to work with time.
 *
 * @module time
 */




/**
 * Return current time.
 *
 * @return {Date}
 */
var getDate = function getDate() {
  return new Date();
};

/**
 * Return current unix time.
 *
 * @return {number}
 */
var getUnixTime = Date.now;

/**
 * Transform time (in ms) to a human readable format. E.g. 1100 => 1.1s. 60s => 1min. .001 => 10μs.
 *
 * @param {number} d duration in milliseconds
 * @return {string} humanized approximation of time
 */
var humanizeDuration = function humanizeDuration(d) {
  if (d < 60000) {
    var p = metric.prefix(d, -1);
    return math.round(p.n * 100) / 100 + p.prefix + 's';
  }
  d = math.floor(d / 1000);
  var seconds = d % 60;
  var minutes = math.floor(d / 60) % 60;
  var hours = math.floor(d / 3600) % 24;
  var days = math.floor(d / 86400);
  if (days > 0) {
    return days + 'd' + (hours > 0 || minutes > 30 ? ' ' + (minutes > 30 ? hours + 1 : hours) + 'h' : '');
  }
  if (hours > 0) {
    /* c8 ignore next */
    return hours + 'h' + (minutes > 0 || seconds > 30 ? ' ' + (seconds > 30 ? minutes + 1 : minutes) + 'min' : '');
  }
  return minutes + 'min' + (seconds > 0 ? ' ' + seconds + 's' : '');
};
// EXTERNAL MODULE: ./node_modules/lib0/math.js
var lib0_math = __webpack_require__(23251);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
;// CONCATENATED MODULE: ./node_modules/lib0/map.js
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }












/**
 * Utility module to work with key-value stores.
 *
 * @module map
 */

/**
 * Creates a new Map instance.
 *
 * @function
 * @return {Map<any, any>}
 *
 * @function
 */
var create = function create() {
  return new Map();
};

/**
 * Copy a Map object into a fresh Map object.
 *
 * @function
 * @template K,V
 * @param {Map<K,V>} m
 * @return {Map<K,V>}
 */
var copy = function copy(m) {
  var r = create();
  m.forEach(function (v, k) {
    r.set(k, v);
  });
  return r;
};

/**
 * Get map property. Create T if property is undefined and set T on map.
 *
 * ```js
 * const listeners = map.setIfUndefined(events, 'eventName', set.create)
 * listeners.add(listener)
 * ```
 *
 * @function
 * @template {Map<any, any>} MAP
 * @template {MAP extends Map<any,infer V> ? function():V : unknown} CF
 * @param {MAP} map
 * @param {MAP extends Map<infer K,any> ? K : unknown} key
 * @param {CF} createT
 * @return {ReturnType<CF>}
 */
var setIfUndefined = function setIfUndefined(map, key, createT) {
  var set = map.get(key);
  if (set === undefined) {
    map.set(key, set = createT());
  }
  return set;
};

/**
 * Creates an Array and populates it with the content of all key-value pairs using the `f(value, key)` function.
 *
 * @function
 * @template K
 * @template V
 * @template R
 * @param {Map<K,V>} m
 * @param {function(V,K):R} f
 * @return {Array<R>}
 */
var map_map = function map(m, f) {
  var res = [];
  var _iterator = _createForOfIteratorHelper(m),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        value = _step$value[1];
      res.push(f(value, key));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return res;
};

/**
 * Tests whether any key-value pairs pass the test implemented by `f(value, key)`.
 *
 * @todo should rename to some - similarly to Array.some
 *
 * @function
 * @template K
 * @template V
 * @param {Map<K,V>} m
 * @param {function(V,K):boolean} f
 * @return {boolean}
 */
var any = function any(m, f) {
  var _iterator2 = _createForOfIteratorHelper(m),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = _slicedToArray(_step2.value, 2),
        key = _step2$value[0],
        value = _step2$value[1];
      if (f(value, key)) {
        return true;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return false;
};

/**
 * Tests whether all key-value pairs pass the test implemented by `f(value, key)`.
 *
 * @function
 * @template K
 * @template V
 * @param {Map<K,V>} m
 * @param {function(V,K):boolean} f
 * @return {boolean}
 */
var map_all = function all(m, f) {
  var _iterator3 = _createForOfIteratorHelper(m),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _step3$value = _slicedToArray(_step3.value, 2),
        key = _step3$value[0],
        value = _step3$value[1];
      if (!f(value, key)) {
        return false;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return true;
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__(70189);
;// CONCATENATED MODULE: ./node_modules/lib0/set.js






/**
 * Utility module to work with sets.
 *
 * @module set
 */

var set_create = function create() {
  return new Set();
};

/**
 * @template T
 * @param {Set<T>} set
 * @return {Array<T>}
 */
var toArray = function toArray(set) {
  return Array.from(set);
};

/**
 * @template T
 * @param {Set<T>} set
 * @return {T}
 */
var first = function first(set) {
  var _set$values$next$valu;
  return (_set$values$next$valu = set.values().next().value) !== null && _set$values$next$valu !== void 0 ? _set$values$next$valu : undefined;
};

/**
 * @template T
 * @param {Iterable<T>} entries
 * @return {Set<T>}
 */
var from = function from(entries) {
  return new Set(entries);
};
// EXTERNAL MODULE: ./node_modules/lib0/array.js
var lib0_array = __webpack_require__(46210);
;// CONCATENATED MODULE: ./node_modules/lib0/observable.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || observable_unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function observable_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return observable_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return observable_arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return observable_arrayLikeToArray(arr); }
function observable_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }











function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
/**
 * Observable class prototype.
 *
 * @module observable
 */





/**
 * Handles named events.
 * @experimental
 *
 * This is basically a (better typed) duplicate of Observable, which will replace Observable in the
 * next release.
 *
 * @template {{[key in keyof EVENTS]: function(...any):void}} EVENTS
 */
var ObservableV2 = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  function ObservableV2() {
    _classCallCheck(this, ObservableV2);
    /**
     * Some desc.
     * @type {Map<string, Set<any>>}
     */
    this._observers = map.create();
  }

  /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */
  _createClass(ObservableV2, [{
    key: "on",
    value: function on(name, f) {
      map.setIfUndefined(this._observers, name, set.create).add(f);
      return f;
    }

    /**
     * @template {keyof EVENTS & string} NAME
     * @param {NAME} name
     * @param {EVENTS[NAME]} f
     */
  }, {
    key: "once",
    value: function once(name, f) {
      var _this = this;
      /**
       * @param  {...any} args
       */
      var _f = function _f() {
        _this.off(name, _f);
        f.apply(void 0, arguments);
      };
      this.on(name, _f);
    }

    /**
     * @template {keyof EVENTS & string} NAME
     * @param {NAME} name
     * @param {EVENTS[NAME]} f
     */
  }, {
    key: "off",
    value: function off(name, f) {
      var observers = this._observers.get(name);
      if (observers !== undefined) {
        observers.delete(f);
        if (observers.size === 0) {
          this._observers.delete(name);
        }
      }
    }

    /**
     * Emit a named event. All registered event listeners that listen to the
     * specified name will receive the event.
     *
     * @todo This should catch exceptions
     *
     * @template {keyof EVENTS & string} NAME
     * @param {NAME} name The event name.
     * @param {Parameters<EVENTS[NAME]>} args The arguments that are applied to the event listener.
     */
  }, {
    key: "emit",
    value: function emit(name, args) {
      // copy all listeners to an array first to make sure that no event is emitted to listeners that are subscribed while the event handler is called.
      return array.from((this._observers.get(name) || map.create()).values()).forEach(function (f) {
        return f.apply(void 0, _toConsumableArray(args));
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._observers = map.create();
    }
  }]);
  return ObservableV2;
}()));

/* c8 ignore start */
/**
 * Handles named events.
 *
 * @deprecated
 * @template N
 */
var Observable = /*#__PURE__*/function () {
  function Observable() {
    _classCallCheck(this, Observable);
    /**
     * Some desc.
     * @type {Map<N, any>}
     */
    this._observers = create();
  }

  /**
   * @param {N} name
   * @param {function} f
   */
  _createClass(Observable, [{
    key: "on",
    value: function on(name, f) {
      setIfUndefined(this._observers, name, set_create).add(f);
    }

    /**
     * @param {N} name
     * @param {function} f
     */
  }, {
    key: "once",
    value: function once(name, f) {
      var _this2 = this;
      /**
       * @param  {...any} args
       */
      var _f = function _f() {
        _this2.off(name, _f);
        f.apply(void 0, arguments);
      };
      this.on(name, _f);
    }

    /**
     * @param {N} name
     * @param {function} f
     */
  }, {
    key: "off",
    value: function off(name, f) {
      var observers = this._observers.get(name);
      if (observers !== undefined) {
        observers.delete(f);
        if (observers.size === 0) {
          this._observers.delete(name);
        }
      }
    }

    /**
     * Emit a named event. All registered event listeners that listen to the
     * specified name will receive the event.
     *
     * @todo This should catch exceptions
     *
     * @param {N} name The event name.
     * @param {Array<any>} args The arguments that are applied to the event listener.
     */
  }, {
    key: "emit",
    value: function emit(name, args) {
      // copy all listeners to an array first to make sure that no event is emitted to listeners that are subscribed while the event handler is called.
      return lib0_array/* from */.Dp((this._observers.get(name) || create()).values()).forEach(function (f) {
        return f.apply(void 0, _toConsumableArray(args));
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._observers = create();
    }
  }]);
  return Observable;
}();
/* c8 ignore end */
// EXTERNAL MODULE: ./node_modules/lib0/function.js + 1 modules
var lib0_function = __webpack_require__(36345);
;// CONCATENATED MODULE: ./node_modules/y-protocols/awareness.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
















function awareness_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function awareness_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function awareness_createClass(Constructor, protoProps, staticProps) { if (protoProps) awareness_defineProperties(Constructor.prototype, protoProps); if (staticProps) awareness_defineProperties(Constructor, staticProps); return Constructor; }
function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/**
 * @module awareness-protocol
 */







 // eslint-disable-line

var outdatedTimeout = 30000;

/**
 * @typedef {Object} MetaClientState
 * @property {number} MetaClientState.clock
 * @property {number} MetaClientState.lastUpdated unix timestamp
 */

/**
 * The Awareness class implements a simple shared state protocol that can be used for non-persistent data like awareness information
 * (cursor, username, status, ..). Each client can update its own local state and listen to state changes of
 * remote clients. Every client may set a state of a remote peer to `null` to mark the client as offline.
 *
 * Each client is identified by a unique client id (something we borrow from `doc.clientID`). A client can override
 * its own state by propagating a message with an increasing timestamp (`clock`). If such a message is received, it is
 * applied if the known state of that client is older than the new state (`clock < newClock`). If a client thinks that
 * a remote client is offline, it may propagate a message with
 * `{ clock: currentClientClock, state: null, client: remoteClient }`. If such a
 * message is received, and the known clock of that client equals the received clock, it will override the state with `null`.
 *
 * Before a client disconnects, it should propagate a `null` state with an updated clock.
 *
 * Awareness states must be updated every 30 seconds. Otherwise the Awareness instance will delete the client state.
 *
 * @extends {Observable<string>}
 */
var Awareness = /*#__PURE__*/function (_Observable) {
  _inherits(Awareness, _Observable);
  var _super = _createSuper(Awareness);
  /**
   * @param {Y.Doc} doc
   */
  function Awareness(doc) {
    var _this;
    awareness_classCallCheck(this, Awareness);
    _this = _super.call(this);
    _this.doc = doc;
    /**
     * @type {number}
     */
    _this.clientID = doc.clientID;
    /**
     * Maps from client id to client state
     * @type {Map<number, Object<string, any>>}
     */
    _this.states = new Map();
    /**
     * @type {Map<number, MetaClientState>}
     */
    _this.meta = new Map();
    _this._checkInterval = setInterval(function () {
      var now = getUnixTime();
      if (_this.getLocalState() !== null && outdatedTimeout / 2 <= now - /** @type {{lastUpdated:number}} */_this.meta.get(_this.clientID).lastUpdated) {
        // renew local clock
        _this.setLocalState(_this.getLocalState());
      }
      /**
       * @type {Array<number>}
       */
      var remove = [];
      _this.meta.forEach(function (meta, clientid) {
        if (clientid !== _this.clientID && outdatedTimeout <= now - meta.lastUpdated && _this.states.has(clientid)) {
          remove.push(clientid);
        }
      });
      if (remove.length > 0) {
        removeAwarenessStates(_assertThisInitialized(_this), remove, 'timeout');
      }
    }, lib0_math/* floor */.GW(outdatedTimeout / 10));
    doc.on('destroy', function () {
      _this.destroy();
    });
    _this.setLocalState({});
    return _this;
  }
  awareness_createClass(Awareness, [{
    key: "destroy",
    value: function destroy() {
      this.emit('destroy', [this]);
      this.setLocalState(null);
      _get(_getPrototypeOf(Awareness.prototype), "destroy", this).call(this);
      clearInterval(this._checkInterval);
    }

    /**
     * @return {Object<string,any>|null}
     */
  }, {
    key: "getLocalState",
    value: function getLocalState() {
      return this.states.get(this.clientID) || null;
    }

    /**
     * @param {Object<string,any>|null} state
     */
  }, {
    key: "setLocalState",
    value: function setLocalState(state) {
      var clientID = this.clientID;
      var currLocalMeta = this.meta.get(clientID);
      var clock = currLocalMeta === undefined ? 0 : currLocalMeta.clock + 1;
      var prevState = this.states.get(clientID);
      if (state === null) {
        this.states.delete(clientID);
      } else {
        this.states.set(clientID, state);
      }
      this.meta.set(clientID, {
        clock: clock,
        lastUpdated: getUnixTime()
      });
      var added = [];
      var updated = [];
      var filteredUpdated = [];
      var removed = [];
      if (state === null) {
        removed.push(clientID);
      } else if (prevState == null) {
        if (state != null) {
          added.push(clientID);
        }
      } else {
        updated.push(clientID);
        if (!lib0_function/* equalityDeep */.Hi(prevState, state)) {
          filteredUpdated.push(clientID);
        }
      }
      if (added.length > 0 || filteredUpdated.length > 0 || removed.length > 0) {
        this.emit('change', [{
          added: added,
          updated: filteredUpdated,
          removed: removed
        }, 'local']);
      }
      this.emit('update', [{
        added: added,
        updated: updated,
        removed: removed
      }, 'local']);
    }

    /**
     * @param {string} field
     * @param {any} value
     */
  }, {
    key: "setLocalStateField",
    value: function setLocalStateField(field, value) {
      var state = this.getLocalState();
      if (state !== null) {
        this.setLocalState(_objectSpread(_objectSpread({}, state), {}, _defineProperty({}, field, value)));
      }
    }

    /**
     * @return {Map<number,Object<string,any>>}
     */
  }, {
    key: "getStates",
    value: function getStates() {
      return this.states;
    }
  }]);
  return Awareness;
}(Observable);

/**
 * Mark (remote) clients as inactive and remove them from the list of active peers.
 * This change will be propagated to remote clients.
 *
 * @param {Awareness} awareness
 * @param {Array<number>} clients
 * @param {any} origin
 */
var removeAwarenessStates = function removeAwarenessStates(awareness, clients, origin) {
  var removed = [];
  for (var i = 0; i < clients.length; i++) {
    var clientID = clients[i];
    if (awareness.states.has(clientID)) {
      awareness.states.delete(clientID);
      if (clientID === awareness.clientID) {
        var curMeta = awareness.meta.get(clientID);
        awareness.meta.set(clientID, {
          clock: curMeta.clock + 1,
          lastUpdated: getUnixTime()
        });
      }
      removed.push(clientID);
    }
  }
  if (removed.length > 0) {
    awareness.emit('change', [{
      added: [],
      updated: [],
      removed: removed
    }, origin]);
    awareness.emit('update', [{
      added: [],
      updated: [],
      removed: removed
    }, origin]);
  }
};

/**
 * @param {Awareness} awareness
 * @param {Array<number>} clients
 * @return {Uint8Array}
 */
var encodeAwarenessUpdate = function encodeAwarenessUpdate(awareness, clients) {
  var states = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : awareness.states;
  var len = clients.length;
  var encoder = encoding/* createEncoder */.Mf();
  encoding/* writeVarUint */.uE(encoder, len);
  for (var i = 0; i < len; i++) {
    var clientID = clients[i];
    var state = states.get(clientID) || null;
    var clock = /** @type {MetaClientState} */awareness.meta.get(clientID).clock;
    encoding/* writeVarUint */.uE(encoder, clientID);
    encoding/* writeVarUint */.uE(encoder, clock);
    encoding/* writeVarString */.uw(encoder, JSON.stringify(state));
  }
  return encoding/* toUint8Array */._f(encoder);
};

/**
 * Modify the content of an awareness update before re-encoding it to an awareness update.
 *
 * This might be useful when you have a central server that wants to ensure that clients
 * cant hijack somebody elses identity.
 *
 * @param {Uint8Array} update
 * @param {function(any):any} modify
 * @return {Uint8Array}
 */
var modifyAwarenessUpdate = function modifyAwarenessUpdate(update, modify) {
  var decoder = decoding/* createDecoder */.l1(update);
  var encoder = encoding/* createEncoder */.Mf();
  var len = decoding/* readVarUint */.yg(decoder);
  encoding/* writeVarUint */.uE(encoder, len);
  for (var i = 0; i < len; i++) {
    var clientID = decoding/* readVarUint */.yg(decoder);
    var clock = decoding/* readVarUint */.yg(decoder);
    var state = JSON.parse(decoding/* readVarString */.kf(decoder));
    var modifiedState = modify(state);
    encoding/* writeVarUint */.uE(encoder, clientID);
    encoding/* writeVarUint */.uE(encoder, clock);
    encoding/* writeVarString */.uw(encoder, JSON.stringify(modifiedState));
  }
  return encoding/* toUint8Array */._f(encoder);
};

/**
 * @param {Awareness} awareness
 * @param {Uint8Array} update
 * @param {any} origin This will be added to the emitted change event
 */
var applyAwarenessUpdate = function applyAwarenessUpdate(awareness, update, origin) {
  var decoder = decoding/* createDecoder */.l1(update);
  var timestamp = getUnixTime();
  var added = [];
  var updated = [];
  var filteredUpdated = [];
  var removed = [];
  var len = decoding/* readVarUint */.yg(decoder);
  for (var i = 0; i < len; i++) {
    var clientID = decoding/* readVarUint */.yg(decoder);
    var clock = decoding/* readVarUint */.yg(decoder);
    var state = JSON.parse(decoding/* readVarString */.kf(decoder));
    var clientMeta = awareness.meta.get(clientID);
    var prevState = awareness.states.get(clientID);
    var currClock = clientMeta === undefined ? 0 : clientMeta.clock;
    if (currClock < clock || currClock === clock && state === null && awareness.states.has(clientID)) {
      if (state === null) {
        // never let a remote client remove this local state
        if (clientID === awareness.clientID && awareness.getLocalState() != null) {
          // remote client removed the local state. Do not remote state. Broadcast a message indicating
          // that this client still exists by increasing the clock
          clock++;
        } else {
          awareness.states.delete(clientID);
        }
      } else {
        awareness.states.set(clientID, state);
      }
      awareness.meta.set(clientID, {
        clock: clock,
        lastUpdated: timestamp
      });
      if (clientMeta === undefined && state !== null) {
        added.push(clientID);
      } else if (clientMeta !== undefined && state === null) {
        removed.push(clientID);
      } else if (state !== null) {
        if (!lib0_function/* equalityDeep */.Hi(state, prevState)) {
          filteredUpdated.push(clientID);
        }
        updated.push(clientID);
      }
    }
  }
  if (added.length > 0 || filteredUpdated.length > 0 || removed.length > 0) {
    awareness.emit('change', [{
      added: added,
      updated: filteredUpdated,
      removed: removed
    }, origin]);
  }
  if (added.length > 0 || updated.length > 0 || removed.length > 0) {
    awareness.emit('update', [{
      added: added,
      updated: updated,
      removed: removed
    }, origin]);
  }
};

/***/ }),

/***/ 53665:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "messageYjsSyncStep1": () => (/* binding */ messageYjsSyncStep1),
/* harmony export */   "messageYjsSyncStep2": () => (/* binding */ messageYjsSyncStep2),
/* harmony export */   "messageYjsUpdate": () => (/* binding */ messageYjsUpdate),
/* harmony export */   "writeSyncStep1": () => (/* binding */ writeSyncStep1),
/* harmony export */   "writeSyncStep2": () => (/* binding */ writeSyncStep2),
/* harmony export */   "readSyncStep1": () => (/* binding */ readSyncStep1),
/* harmony export */   "readSyncStep2": () => (/* binding */ readSyncStep2),
/* harmony export */   "writeUpdate": () => (/* binding */ writeUpdate),
/* harmony export */   "readUpdate": () => (/* binding */ readUpdate),
/* harmony export */   "readSyncMessage": () => (/* binding */ readSyncMessage)
/* harmony export */ });
/* harmony import */ var lib0_encoding__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55529);
/* harmony import */ var lib0_decoding__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49016);
/* harmony import */ var yjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51718);
/**
 * @module sync-protocol
 */





/**
 * @typedef {Map<number, number>} StateMap
 */

/**
 * Core Yjs defines two message types:
 * • YjsSyncStep1: Includes the State Set of the sending client. When received, the client should reply with YjsSyncStep2.
 * • YjsSyncStep2: Includes all missing structs and the complete delete set. When received, the client is assured that it
 *   received all information from the remote client.
 *
 * In a peer-to-peer network, you may want to introduce a SyncDone message type. Both parties should initiate the connection
 * with SyncStep1. When a client received SyncStep2, it should reply with SyncDone. When the local client received both
 * SyncStep2 and SyncDone, it is assured that it is synced to the remote client.
 *
 * In a client-server model, you want to handle this differently: The client should initiate the connection with SyncStep1.
 * When the server receives SyncStep1, it should reply with SyncStep2 immediately followed by SyncStep1. The client replies
 * with SyncStep2 when it receives SyncStep1. Optionally the server may send a SyncDone after it received SyncStep2, so the
 * client knows that the sync is finished.  There are two reasons for this more elaborated sync model: 1. This protocol can
 * easily be implemented on top of http and websockets. 2. The server shoul only reply to requests, and not initiate them.
 * Therefore it is necesarry that the client initiates the sync.
 *
 * Construction of a message:
 * [messageType : varUint, message definition..]
 *
 * Note: A message does not include information about the room name. This must to be handled by the upper layer protocol!
 *
 * stringify[messageType] stringifies a message definition (messageType is already read from the bufffer)
 */

var messageYjsSyncStep1 = 0;
var messageYjsSyncStep2 = 1;
var messageYjsUpdate = 2;

/**
 * Create a sync step 1 message based on the state of the current shared document.
 *
 * @param {encoding.Encoder} encoder
 * @param {Y.Doc} doc
 */
var writeSyncStep1 = function writeSyncStep1(encoder, doc) {
  lib0_encoding__WEBPACK_IMPORTED_MODULE_0__/* .writeVarUint */ .uE(encoder, messageYjsSyncStep1);
  var sv = yjs__WEBPACK_IMPORTED_MODULE_1__.encodeStateVector(doc);
  lib0_encoding__WEBPACK_IMPORTED_MODULE_0__/* .writeVarUint8Array */ .mP(encoder, sv);
};

/**
 * @param {encoding.Encoder} encoder
 * @param {Y.Doc} doc
 * @param {Uint8Array} [encodedStateVector]
 * @param {Object} [opts]
 * @param {Number} [opts.updateEncoderVersion] Version of update encoder, either 1 or 2. By default 1
 */
var writeSyncStep2 = function writeSyncStep2(encoder, doc, encodedStateVector) {
  var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  lib0_encoding__WEBPACK_IMPORTED_MODULE_0__/* .writeVarUint */ .uE(encoder, messageYjsSyncStep2);
  var encodeStateAsUpdate = yjs__WEBPACK_IMPORTED_MODULE_1__.encodeStateAsUpdate;
  if (opts.updateEncoderVersion === 2) {
    encodeStateAsUpdate = yjs__WEBPACK_IMPORTED_MODULE_1__.encodeStateAsUpdateV2;
  }
  lib0_encoding__WEBPACK_IMPORTED_MODULE_0__/* .writeVarUint8Array */ .mP(encoder, encodeStateAsUpdate(doc, encodedStateVector));
};

/**
 * Read SyncStep1 message and reply with SyncStep2.
 *
 * @param {decoding.Decoder} decoder The reply to the received message
 * @param {encoding.Encoder} encoder The received message
 * @param {Y.Doc} doc
 * @param {Object} [opts]
 * @param {Number} [opts.updateEncoderVersion] Version of update encoder, either 1 or 2. By default 1
 */
var readSyncStep1 = function readSyncStep1(decoder, encoder, doc) {
  var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  writeSyncStep2(encoder, doc, lib0_decoding__WEBPACK_IMPORTED_MODULE_2__/* .readVarUint8Array */ .HN(decoder), opts);
};

/**
 * Read and apply Structs and then DeleteStore to a y instance.
 *
 * @param {decoding.Decoder} decoder
 * @param {Y.Doc} doc
 * @param {any} transactionOrigin
 * @param {Object} [opts]
 * @param {Number} [opts.updateEncoderVersion] Version of update encoder, either 1 or 2. By default 1
 */
var readSyncStep2 = function readSyncStep2(decoder, doc, transactionOrigin) {
  var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  try {
    var applyUpdate = yjs__WEBPACK_IMPORTED_MODULE_1__.applyUpdate;
    if (opts.updateEncoderVersion === 2) {
      applyUpdate = yjs__WEBPACK_IMPORTED_MODULE_1__.applyUpdateV2;
    }
    applyUpdate(doc, lib0_decoding__WEBPACK_IMPORTED_MODULE_2__/* .readVarUint8Array */ .HN(decoder), transactionOrigin);
  } catch (error) {
    // This catches errors that are thrown by event handlers
    console.error('Caught error while handling a Yjs update', error);
  }
};

/**
 * @param {encoding.Encoder} encoder
 * @param {Uint8Array} update
 */
var writeUpdate = function writeUpdate(encoder, update) {
  lib0_encoding__WEBPACK_IMPORTED_MODULE_0__/* .writeVarUint */ .uE(encoder, messageYjsUpdate);
  lib0_encoding__WEBPACK_IMPORTED_MODULE_0__/* .writeVarUint8Array */ .mP(encoder, update);
};

/**
 * Read and apply Structs and then DeleteStore to a y instance.
 *
 * @param {decoding.Decoder} decoder
 * @param {Y.Doc} doc
 * @param {any} transactionOrigin
 */
var readUpdate = readSyncStep2;

/**
 * @param {decoding.Decoder} decoder A message received from another client
 * @param {encoding.Encoder} encoder The reply message. Will not be sent if empty.
 * @param {Y.Doc} doc
 * @param {any} transactionOrigin
 * @param {Object} [opts]
 * @param {Number} [opts.updateEncoderVersion] Version of update encoder, either 1 or 2. By default 1. Only for sync step 1 and 2
 */
var readSyncMessage = function readSyncMessage(decoder, encoder, doc, transactionOrigin) {
  var opts = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var messageType = lib0_decoding__WEBPACK_IMPORTED_MODULE_2__/* .readVarUint */ .yg(decoder);
  switch (messageType) {
    case messageYjsSyncStep1:
      readSyncStep1(decoder, encoder, doc, opts);
      break;
    case messageYjsSyncStep2:
      readSyncStep2(decoder, doc, transactionOrigin, opts);
      break;
    case messageYjsUpdate:
      readUpdate(decoder, doc, transactionOrigin);
      break;
    default:
      throw new Error('Unknown message type');
  }
  return messageType;
};

/***/ }),

/***/ 49839:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79758);
function s(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function h(t,i){var n=t.i||(t.i={});return n[i]||(n[i]=function(n){t.refs[i]=n})}function e(t){for(var i={},n=0;n<t.length;n++)null!=t[n]&&(i[(r=t[n],s=n.toString(36),void 0,h=r&&r.key,null==h?s:h)]=t[n]);var r,s,h;return i}function a(t,i){t=t||{},i=i||{};var n=function(n){return i.hasOwnProperty(n)?i[n]:t[n]},r={},s=[];for(var h in t)i.hasOwnProperty(h)?s.length&&(r[h]=s,s=[]):s.push(h);var e={};for(var a in i){if(r.hasOwnProperty(a))for(var o=0;o<r[a].length;o++)e[r[a][o]]=n(r[a][o]);e[a]=n(a)}for(var f=0;f<s.length;f++)e[s[f]]=n(s[f]);return e}var o=function(r){var o,f;function u(i,n){var h;return(h=r.call(this,i,n)||this).refs={},h.state={children:e((0,preact__WEBPACK_IMPORTED_MODULE_0__/* .toChildArray */ .bR)((0,preact__WEBPACK_IMPORTED_MODULE_0__/* .toChildArray */ .bR)(h.props.children))||[])},h.performAppear=h.performAppear.bind(s(h)),h.performEnter=h.performEnter.bind(s(h)),h.performLeave=h.performLeave.bind(s(h)),h}f=r,(o=u).prototype=Object.create(f.prototype),o.prototype.constructor=o,o.__proto__=f;var v=u.prototype;return v.componentWillMount=function(){this.currentlyTransitioningKeys={},this.keysToAbortLeave=[],this.keysToEnter=[],this.keysToLeave=[]},v.componentDidMount=function(){var t=this.state.children;for(var i in t)t[i]&&this.performAppear(i)},v.componentWillReceiveProps=function(i){var n,r=e((0,preact__WEBPACK_IMPORTED_MODULE_0__/* .toChildArray */ .bR)(i.children)||[]),s=this.state.children;for(n in this.setState(function(t){return{children:a(t.children,r)}}),r)if(r.hasOwnProperty(n)){var h=s&&s.hasOwnProperty(n);r[n]&&h&&this.currentlyTransitioningKeys[n]?(this.keysToEnter.push(n),this.keysToAbortLeave.push(n)):!r[n]||h||this.currentlyTransitioningKeys[n]||this.keysToEnter.push(n)}for(n in s)if(s.hasOwnProperty(n)){var o=r&&r.hasOwnProperty(n);!s[n]||o||this.currentlyTransitioningKeys[n]||this.keysToLeave.push(n)}},v.componentDidUpdate=function(){var t=this.keysToEnter;this.keysToEnter=[],t.forEach(this.performEnter);var i=this.keysToLeave;this.keysToLeave=[],i.forEach(this.performLeave)},v.t=function(t){var i=this.keysToAbortLeave.indexOf(t);-1!==i&&this.keysToAbortLeave.splice(i,1)},v.performAppear=function(t){this.currentlyTransitioningKeys[t]=!0;var i=this.refs[t];i.componentWillAppear?i.componentWillAppear(this.n.bind(this,t)):this.n(t)},v.n=function(i){var n=this.refs[i];n.componentDidAppear&&n.componentDidAppear(),delete this.currentlyTransitioningKeys[i],this.t(i);var r=e((0,preact__WEBPACK_IMPORTED_MODULE_0__/* .toChildArray */ .bR)(this.props.children)||[]);r&&r.hasOwnProperty(i)||this.performLeave(i)},v.performEnter=function(t){this.currentlyTransitioningKeys[t]=!0;var i=this.refs[t];i.componentWillEnter?i.componentWillEnter(this.r.bind(this,t)):this.r(t)},v.r=function(i){var n=this.refs[i];n.componentDidEnter&&n.componentDidEnter(),delete this.currentlyTransitioningKeys[i],this.t(i);var r=e((0,preact__WEBPACK_IMPORTED_MODULE_0__/* .toChildArray */ .bR)(this.props.children)||[]);r&&r.hasOwnProperty(i)||this.performLeave(i)},v.performLeave=function(t){if(-1===this.keysToAbortLeave.indexOf(t)){this.currentlyTransitioningKeys[t]=!0;var i=this.refs[t];i.componentWillLeave?i.componentWillLeave(this.s.bind(this,t)):this.s(t)}},v.s=function(i){if(-1===this.keysToAbortLeave.indexOf(i)){var n=this.refs[i];n.componentDidLeave&&n.componentDidLeave(),delete this.currentlyTransitioningKeys[i];var r=e((0,preact__WEBPACK_IMPORTED_MODULE_0__/* .toChildArray */ .bR)(this.props.children)||[]);if(r&&r.hasOwnProperty(i))this.performEnter(i);else{var s=function(t,i){for(var n in i)i.hasOwnProperty(n)&&(t[n]=i[n]);return t}({},this.state.children);delete s[i],this.setState({children:s})}}},v.render=function(t,r){var s=t.childFactory,e=t.component,a=function(t,i){if(null==t)return{};var n,r,s={},h=Object.keys(t);for(r=0;r<h.length;r++)i.indexOf(n=h[r])>=0||(s[n]=t[n]);return s}(t,["childFactory","transitionLeave","transitionName","transitionAppear","transitionEnter","transitionLeaveTimeout","transitionEnterTimeout","transitionAppearTimeout","component"]),o=r.children,f=[];for(var u in o)if(o.hasOwnProperty(u)){var v=o[u];if(v){var c=h(this,u),l=(0,preact__WEBPACK_IMPORTED_MODULE_0__/* .cloneElement */ .Tm)(s(v),{ref:c,key:u});f.push(l)}}return (0,preact__WEBPACK_IMPORTED_MODULE_0__.h)(e,a,f)},u}(preact__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .wA);o.defaultProps={component:"span",childFactory:function(t){return t}};/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (o);
//# sourceMappingURL=preact-transition-group.mjs.map


/***/ }),

/***/ 51718:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AbsolutePosition": () => (/* binding */ AbsolutePosition),
  "AbstractConnector": () => (/* binding */ AbstractConnector),
  "AbstractStruct": () => (/* binding */ AbstractStruct),
  "AbstractType": () => (/* binding */ AbstractType),
  "Array": () => (/* binding */ YArray),
  "ContentAny": () => (/* binding */ ContentAny),
  "ContentBinary": () => (/* binding */ ContentBinary),
  "ContentDeleted": () => (/* binding */ ContentDeleted),
  "ContentEmbed": () => (/* binding */ ContentEmbed),
  "ContentFormat": () => (/* binding */ ContentFormat),
  "ContentJSON": () => (/* binding */ ContentJSON),
  "ContentString": () => (/* binding */ ContentString),
  "ContentType": () => (/* binding */ ContentType),
  "Doc": () => (/* binding */ Doc),
  "GC": () => (/* binding */ GC),
  "ID": () => (/* binding */ ID),
  "Item": () => (/* binding */ Item),
  "Map": () => (/* binding */ YMap),
  "PermanentUserData": () => (/* binding */ PermanentUserData),
  "RelativePosition": () => (/* binding */ RelativePosition),
  "Snapshot": () => (/* binding */ Snapshot),
  "Text": () => (/* binding */ YText),
  "Transaction": () => (/* binding */ Transaction),
  "UndoManager": () => (/* binding */ UndoManager),
  "XmlElement": () => (/* binding */ YXmlElement),
  "XmlFragment": () => (/* binding */ YXmlFragment),
  "XmlHook": () => (/* binding */ YXmlHook),
  "XmlText": () => (/* binding */ YXmlText),
  "YArrayEvent": () => (/* binding */ YArrayEvent),
  "YEvent": () => (/* binding */ YEvent),
  "YMapEvent": () => (/* binding */ YMapEvent),
  "YTextEvent": () => (/* binding */ YTextEvent),
  "YXmlEvent": () => (/* binding */ YXmlEvent),
  "applyUpdate": () => (/* binding */ applyUpdate),
  "applyUpdateV2": () => (/* binding */ applyUpdateV2),
  "cleanupYTextFormatting": () => (/* binding */ cleanupYTextFormatting),
  "compareIDs": () => (/* binding */ compareIDs),
  "compareRelativePositions": () => (/* binding */ compareRelativePositions),
  "convertUpdateFormatV1ToV2": () => (/* binding */ convertUpdateFormatV1ToV2),
  "convertUpdateFormatV2ToV1": () => (/* binding */ convertUpdateFormatV2ToV1),
  "createAbsolutePositionFromRelativePosition": () => (/* binding */ createAbsolutePositionFromRelativePosition),
  "createDeleteSet": () => (/* binding */ createDeleteSet),
  "createDeleteSetFromStructStore": () => (/* binding */ createDeleteSetFromStructStore),
  "createDocFromSnapshot": () => (/* binding */ createDocFromSnapshot),
  "createID": () => (/* binding */ createID),
  "createRelativePositionFromJSON": () => (/* binding */ createRelativePositionFromJSON),
  "createRelativePositionFromTypeIndex": () => (/* binding */ createRelativePositionFromTypeIndex),
  "createSnapshot": () => (/* binding */ createSnapshot),
  "decodeRelativePosition": () => (/* binding */ decodeRelativePosition),
  "decodeSnapshot": () => (/* binding */ decodeSnapshot),
  "decodeSnapshotV2": () => (/* binding */ decodeSnapshotV2),
  "decodeStateVector": () => (/* binding */ decodeStateVector),
  "decodeUpdate": () => (/* binding */ decodeUpdate),
  "decodeUpdateV2": () => (/* binding */ decodeUpdateV2),
  "diffUpdate": () => (/* binding */ diffUpdate),
  "diffUpdateV2": () => (/* binding */ diffUpdateV2),
  "emptySnapshot": () => (/* binding */ emptySnapshot),
  "encodeRelativePosition": () => (/* binding */ encodeRelativePosition),
  "encodeSnapshot": () => (/* binding */ encodeSnapshot),
  "encodeSnapshotV2": () => (/* binding */ encodeSnapshotV2),
  "encodeStateAsUpdate": () => (/* binding */ encodeStateAsUpdate),
  "encodeStateAsUpdateV2": () => (/* binding */ encodeStateAsUpdateV2),
  "encodeStateVector": () => (/* binding */ encodeStateVector),
  "encodeStateVectorFromUpdate": () => (/* binding */ encodeStateVectorFromUpdate),
  "encodeStateVectorFromUpdateV2": () => (/* binding */ encodeStateVectorFromUpdateV2),
  "equalSnapshots": () => (/* binding */ equalSnapshots),
  "findIndexSS": () => (/* binding */ findIndexSS),
  "findRootTypeKey": () => (/* binding */ findRootTypeKey),
  "getItem": () => (/* binding */ getItem),
  "getState": () => (/* binding */ getState),
  "getTypeChildren": () => (/* binding */ getTypeChildren),
  "isDeleted": () => (/* binding */ isDeleted),
  "isParentOf": () => (/* binding */ yjs_isParentOf),
  "iterateDeletedStructs": () => (/* binding */ iterateDeletedStructs),
  "logType": () => (/* binding */ logType),
  "logUpdate": () => (/* binding */ logUpdate),
  "logUpdateV2": () => (/* binding */ logUpdateV2),
  "mergeUpdates": () => (/* binding */ mergeUpdates),
  "mergeUpdatesV2": () => (/* binding */ mergeUpdatesV2),
  "parseUpdateMeta": () => (/* binding */ parseUpdateMeta),
  "parseUpdateMetaV2": () => (/* binding */ parseUpdateMetaV2),
  "readUpdate": () => (/* binding */ readUpdate),
  "readUpdateV2": () => (/* binding */ readUpdateV2),
  "relativePositionToJSON": () => (/* binding */ relativePositionToJSON),
  "snapshot": () => (/* binding */ snapshot),
  "transact": () => (/* binding */ transact),
  "tryGc": () => (/* binding */ tryGc),
  "typeListToArraySnapshot": () => (/* binding */ typeListToArraySnapshot),
  "typeMapGetSnapshot": () => (/* binding */ typeMapGetSnapshot)
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(54747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.map.js
var es_map = __webpack_require__(51532);
;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/map.js
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }












/**
 * Utility module to work with key-value stores.
 *
 * @module map
 */

/**
 * Creates a new Map instance.
 *
 * @function
 * @return {Map<any, any>}
 *
 * @function
 */
var create = function create() {
  return new Map();
};

/**
 * Copy a Map object into a fresh Map object.
 *
 * @function
 * @template X,Y
 * @param {Map<X,Y>} m
 * @return {Map<X,Y>}
 */
var copy = function copy(m) {
  var r = create();
  m.forEach(function (v, k) {
    r.set(k, v);
  });
  return r;
};

/**
 * Get map property. Create T if property is undefined and set T on map.
 *
 * ```js
 * const listeners = map.setIfUndefined(events, 'eventName', set.create)
 * listeners.add(listener)
 * ```
 *
 * @function
 * @template T,K
 * @param {Map<K, T>} map
 * @param {K} key
 * @param {function():T} createT
 * @return {T}
 */
var setIfUndefined = function setIfUndefined(map, key, createT) {
  var set = map.get(key);
  if (set === undefined) {
    map.set(key, set = createT());
  }
  return set;
};

/**
 * Creates an Array and populates it with the content of all key-value pairs using the `f(value, key)` function.
 *
 * @function
 * @template K
 * @template V
 * @template R
 * @param {Map<K,V>} m
 * @param {function(V,K):R} f
 * @return {Array<R>}
 */
var map = function map(m, f) {
  var res = [];
  var _iterator = _createForOfIteratorHelper(m),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        value = _step$value[1];
      res.push(f(value, key));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return res;
};

/**
 * Tests whether any key-value pairs pass the test implemented by `f(value, key)`.
 *
 * @todo should rename to some - similarly to Array.some
 *
 * @function
 * @template K
 * @template V
 * @param {Map<K,V>} m
 * @param {function(V,K):boolean} f
 * @return {boolean}
 */
var any = function any(m, f) {
  var _iterator2 = _createForOfIteratorHelper(m),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = _slicedToArray(_step2.value, 2),
        key = _step2$value[0],
        value = _step2$value[1];
      if (f(value, key)) {
        return true;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return false;
};

/**
 * Tests whether all key-value pairs pass the test implemented by `f(value, key)`.
 *
 * @function
 * @template K
 * @template V
 * @param {Map<K,V>} m
 * @param {function(V,K):boolean} f
 * @return {boolean}
 */
var map_all = function all(m, f) {
  var _iterator3 = _createForOfIteratorHelper(m),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _step3$value = _slicedToArray(_step3.value, 2),
        key = _step3$value[0],
        value = _step3$value[1];
      if (!f(value, key)) {
        return false;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return true;
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__(70189);
;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/set.js






/**
 * Utility module to work with sets.
 *
 * @module set
 */

var set_create = function create() {
  return new Set();
};

/**
 * @template T
 * @param {Set<T>} set
 * @return {Array<T>}
 */
var toArray = function toArray(set) {
  return Array.from(set);
};

/**
 * @template T
 * @param {Set<T>} set
 * @return {T}
 */
var first = function first(set) {
  return set.values().next().value || undefined;
};

/**
 * @template T
 * @param {Iterable<T>} entries
 * @return {Set<T>}
 */
var from = function from(entries) {
  return new Set(entries);
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/array.js




/**
 * Utility module to work with Arrays.
 *
 * @module array
 */

/**
 * Return the last element of an array. The element must exist
 *
 * @template L
 * @param {Array<L>} arr
 * @return {L}
 */
var last = function last(arr) {
  return arr[arr.length - 1];
};

/**
 * @template C
 * @return {Array<C>}
 */
var array_create = function /** @type {Array<C>} */ create() {
  return [];
};

/**
 * @template D
 * @param {Array<D>} a
 * @return {Array<D>}
 */
var array_copy = function /** @type {Array<D>} */ copy(a) {
  return a.slice();
};

/**
 * Append elements from src to dest
 *
 * @template M
 * @param {Array<M>} dest
 * @param {Array<M>} src
 */
var appendTo = function appendTo(dest, src) {
  for (var i = 0; i < src.length; i++) {
    dest.push(src[i]);
  }
};

/**
 * Transforms something array-like to an actual Array.
 *
 * @function
 * @template T
 * @param {ArrayLike<T>|Iterable<T>} arraylike
 * @return {T}
 */
var array_from = Array.from;

/**
 * True iff condition holds on every element in the Array.
 *
 * @function
 * @template ITEM
 *
 * @param {Array<ITEM>} arr
 * @param {function(ITEM, number, Array<ITEM>):boolean} f
 * @return {boolean}
 */
var every = function every(arr, f) {
  return arr.every(f);
};

/**
 * True iff condition holds on some element in the Array.
 *
 * @function
 * @template S
 * @param {Array<S>} arr
 * @param {function(S, number, Array<S>):boolean} f
 * @return {boolean}
 */
var some = function some(arr, f) {
  return arr.some(f);
};

/**
 * @template ELEM
 *
 * @param {Array<ELEM>} a
 * @param {Array<ELEM>} b
 * @return {boolean}
 */
var equalFlat = function equalFlat(a, b) {
  return a.length === b.length && every(a, function (item, index) {
    return item === b[index];
  });
};

/**
 * @template ELEM
 * @param {Array<Array<ELEM>>} arr
 * @return {Array<ELEM>}
 */
var flatten = function flatten(arr) {
  return arr.reduce(function (acc, val) {
    return acc.concat(val);
  }, []);
};
var isArray = Array.isArray;
;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/observable.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || observable_unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function observable_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return observable_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return observable_arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return observable_arrayLikeToArray(arr); }
function observable_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }











function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
/**
 * Observable class prototype.
 *
 * @module observable
 */





/**
 * Handles named events.
 *
 * @template N
 */
var Observable = /*#__PURE__*/function () {
  function Observable() {
    _classCallCheck(this, Observable);
    /**
     * Some desc.
     * @type {Map<N, any>}
     */
    this._observers = create();
  }

  /**
   * @param {N} name
   * @param {function} f
   */
  _createClass(Observable, [{
    key: "on",
    value: function on(name, f) {
      setIfUndefined(this._observers, name, set_create).add(f);
    }

    /**
     * @param {N} name
     * @param {function} f
     */
  }, {
    key: "once",
    value: function once(name, f) {
      var _this = this;
      /**
       * @param  {...any} args
       */
      var _f = function _f() {
        _this.off(name, _f);
        f.apply(void 0, arguments);
      };
      this.on(name, _f);
    }

    /**
     * @param {N} name
     * @param {function} f
     */
  }, {
    key: "off",
    value: function off(name, f) {
      var observers = this._observers.get(name);
      if (observers !== undefined) {
        observers.delete(f);
        if (observers.size === 0) {
          this._observers.delete(name);
        }
      }
    }

    /**
     * Emit a named event. All registered event listeners that listen to the
     * specified name will receive the event.
     *
     * @todo This should catch exceptions
     *
     * @param {N} name The event name.
     * @param {Array<any>} args The arguments that are applied to the event listener.
     */
  }, {
    key: "emit",
    value: function emit(name, args) {
      // copy all listeners to an array first to make sure that no event is emitted to listeners that are subscribed while the event handler is called.
      return array_from((this._observers.get(name) || create()).values()).forEach(function (f) {
        return f.apply(void 0, _toConsumableArray(args));
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._observers = create();
    }
  }]);
  return Observable;
}();
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.imul.js
var es_math_imul = __webpack_require__(90332);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.log10.js
var es_math_log10 = __webpack_require__(40658);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.log2.js
var es_math_log2 = __webpack_require__(44914);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.is-nan.js
var es_number_is_nan = __webpack_require__(44048);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(9653);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.sign.js
var es_math_sign = __webpack_require__(52420);
;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/math.js






/**
 * Common Math expressions.
 *
 * @module math
 */

var floor = Math.floor;
var ceil = Math.ceil;
var abs = Math.abs;
var imul = Math.imul;
var round = Math.round;
var log10 = Math.log10;
var log2 = Math.log2;
var log = Math.log;
var sqrt = Math.sqrt;

/**
 * @function
 * @param {number} a
 * @param {number} b
 * @return {number} The sum of a and b
 */
var add = function add(a, b) {
  return a + b;
};

/**
 * @function
 * @param {number} a
 * @param {number} b
 * @return {number} The smaller element of a and b
 */
var min = function min(a, b) {
  return a < b ? a : b;
};

/**
 * @function
 * @param {number} a
 * @param {number} b
 * @return {number} The bigger element of a and b
 */
var max = function max(a, b) {
  return a > b ? a : b;
};
var math_isNaN = Number.isNaN;
var pow = Math.pow;
/**
 * Base 10 exponential function. Returns the value of 10 raised to the power of pow.
 *
 * @param {number} exp
 * @return {number}
 */
var exp10 = function exp10(exp) {
  return Math.pow(10, exp);
};
var sign = Math.sign;

/**
 * @param {number} n
 * @return {boolean} Wether n is negative. This function also differentiates between -0 and +0
 */
var isNegativeZero = function isNegativeZero(n) {
  return n !== 0 ? n < 0 : 1 / n < 0;
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.uint8-array.js
var es_typed_array_uint8_array = __webpack_require__(82472);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.copy-within.js
var es_typed_array_copy_within = __webpack_require__(92990);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.every.js
var es_typed_array_every = __webpack_require__(18927);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.fill.js
var es_typed_array_fill = __webpack_require__(33105);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.filter.js
var es_typed_array_filter = __webpack_require__(35035);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.find.js
var es_typed_array_find = __webpack_require__(74345);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.find-index.js
var es_typed_array_find_index = __webpack_require__(7174);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.for-each.js
var es_typed_array_for_each = __webpack_require__(32846);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.includes.js
var es_typed_array_includes = __webpack_require__(44731);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.index-of.js
var es_typed_array_index_of = __webpack_require__(77209);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.iterator.js
var es_typed_array_iterator = __webpack_require__(96319);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.join.js
var es_typed_array_join = __webpack_require__(58867);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.last-index-of.js
var es_typed_array_last_index_of = __webpack_require__(37789);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.map.js
var es_typed_array_map = __webpack_require__(33739);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reduce.js
var es_typed_array_reduce = __webpack_require__(29368);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reduce-right.js
var es_typed_array_reduce_right = __webpack_require__(14483);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reverse.js
var es_typed_array_reverse = __webpack_require__(12056);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.set.js
var es_typed_array_set = __webpack_require__(3462);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.slice.js
var es_typed_array_slice = __webpack_require__(30678);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.some.js
var es_typed_array_some = __webpack_require__(27462);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.sort.js
var es_typed_array_sort = __webpack_require__(33824);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.subarray.js
var es_typed_array_subarray = __webpack_require__(55021);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.to-locale-string.js
var es_typed_array_to_locale_string = __webpack_require__(12974);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.to-string.js
var es_typed_array_to_string = __webpack_require__(15016);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.code-point-at.js
var es_string_code_point_at = __webpack_require__(79841);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array-buffer.constructor.js
var es_array_buffer_constructor = __webpack_require__(18264);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(69600);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(30489);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__(12419);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.from-code-point.js
var es_string_from_code_point = __webpack_require__(94953);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(15306);
;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/string.js
































/**
 * Utility module to work with strings.
 *
 * @module string
 */

var fromCharCode = String.fromCharCode;
var fromCodePoint = String.fromCodePoint;

/**
 * @param {string} s
 * @return {string}
 */
var toLowerCase = function toLowerCase(s) {
  return s.toLowerCase();
};
var trimLeftRegex = /^\s*/g;

/**
 * @param {string} s
 * @return {string}
 */
var trimLeft = function trimLeft(s) {
  return s.replace(trimLeftRegex, '');
};
var fromCamelCaseRegex = /([A-Z])/g;

/**
 * @param {string} s
 * @param {string} separator
 * @return {string}
 */
var fromCamelCase = function fromCamelCase(s, separator) {
  return trimLeft(s.replace(fromCamelCaseRegex, function (match) {
    return "".concat(separator).concat(toLowerCase(match));
  }));
};

/**
 * Compute the utf8ByteLength
 * @param {string} str
 * @return {number}
 */
var utf8ByteLength = function utf8ByteLength(str) {
  return unescape(encodeURIComponent(str)).length;
};

/**
 * @param {string} str
 * @return {Uint8Array}
 */
var _encodeUtf8Polyfill = function _encodeUtf8Polyfill(str) {
  var encodedString = unescape(encodeURIComponent(str));
  var len = encodedString.length;
  var buf = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    buf[i] = encodedString.codePointAt(i);
  }
  return buf;
};

/* istanbul ignore next */
var utf8TextEncoder = typeof TextEncoder !== 'undefined' ? new TextEncoder() : null;

/**
 * @param {string} str
 * @return {Uint8Array}
 */
var _encodeUtf8Native = function _encodeUtf8Native(str) {
  return utf8TextEncoder.encode(str);
};

/**
 * @param {string} str
 * @return {Uint8Array}
 */
/* istanbul ignore next */
var encodeUtf8 = utf8TextEncoder ? _encodeUtf8Native : _encodeUtf8Polyfill;

/**
 * @param {Uint8Array} buf
 * @return {string}
 */
var _decodeUtf8Polyfill = function _decodeUtf8Polyfill(buf) {
  var remainingLen = buf.length;
  var encodedString = '';
  var bufPos = 0;
  while (remainingLen > 0) {
    var nextLen = remainingLen < 10000 ? remainingLen : 10000;
    var bytes = buf.subarray(bufPos, bufPos + nextLen);
    bufPos += nextLen;
    // Starting with ES5.1 we can supply a generic array-like object as arguments
    encodedString += String.fromCodePoint.apply(null, bytes);
    remainingLen -= nextLen;
  }
  return decodeURIComponent(escape(encodedString));
};

/* istanbul ignore next */
var utf8TextDecoder = typeof TextDecoder === 'undefined' ? null : new TextDecoder('utf-8', {
  fatal: true,
  ignoreBOM: true
});

/* istanbul ignore next */
if (utf8TextDecoder && utf8TextDecoder.decode(new Uint8Array()).length === 1) {
  // Safari doesn't handle BOM correctly.
  // This fixes a bug in Safari 13.0.5 where it produces a BOM the first time it is called.
  // utf8TextDecoder.decode(new Uint8Array()).length === 1 on the first call and
  // utf8TextDecoder.decode(new Uint8Array()).length === 1 on the second call
  // Another issue is that from then on no BOM chars are recognized anymore
  /* istanbul ignore next */
  utf8TextDecoder = null;
}

/**
 * @param {Uint8Array} buf
 * @return {string}
 */
var _decodeUtf8Native = function _decodeUtf8Native(buf) {
  return (/** @type {TextDecoder} */utf8TextDecoder.decode(buf)
  );
};

/**
 * @param {Uint8Array} buf
 * @return {string}
 */
/* istanbul ignore next */
var decodeUtf8 = (/* unused pure expression or super */ null && (utf8TextDecoder ? _decodeUtf8Native : _decodeUtf8Polyfill));

/**
 * @param {string} str The initial string
 * @param {number} index Starting position
 * @param {number} remove Number of characters to remove
 * @param {string} insert New content to insert
 */
var splice = function splice(str, index, remove) {
  var insert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  return str.slice(0, index) + insert + str.slice(index + remove);
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__(23123);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__(64765);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(32023);
;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/conditions.js
/**
 * Often used conditions.
 *
 * @module conditions
 */

/**
 * @template T
 * @param {T|null|undefined} v
 * @return {T|null}
 */
/* istanbul ignore next */
var undefinedToNull = function undefinedToNull(v) {
  return v === undefined ? null : v;
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(21249);
;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/storage.js






function storage_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function storage_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function storage_createClass(Constructor, protoProps, staticProps) { if (protoProps) storage_defineProperties(Constructor.prototype, protoProps); if (staticProps) storage_defineProperties(Constructor, staticProps); return Constructor; }
/* global localStorage, addEventListener */
/**
 * Isomorphic variable storage.
 *
 * Uses LocalStorage in the browser and falls back to in-memory storage.
 *
 * @module storage
 */
/* istanbul ignore next */
var VarStoragePolyfill = /*#__PURE__*/function () {
  function VarStoragePolyfill() {
    storage_classCallCheck(this, VarStoragePolyfill);
    this.map = new Map();
  }

  /**
   * @param {string} key
   * @param {any} newValue
   */
  storage_createClass(VarStoragePolyfill, [{
    key: "setItem",
    value: function setItem(key, newValue) {
      this.map.set(key, newValue);
    }

    /**
     * @param {string} key
     */
  }, {
    key: "getItem",
    value: function getItem(key) {
      return this.map.get(key);
    }
  }]);
  return VarStoragePolyfill;
}();
/* istanbul ignore next */
/**
 * @type {any}
 */
var _localStorage = new VarStoragePolyfill();
var usePolyfill = true;
try {
  // if the same-origin rule is violated, accessing localStorage might thrown an error
  /* istanbul ignore next */
  if (typeof localStorage !== 'undefined') {
    _localStorage = localStorage;
    usePolyfill = false;
  }
} catch (e) {}

/* istanbul ignore next */
/**
 * This is basically localStorage in browser, or a polyfill in nodejs
 */
var varStorage = _localStorage;

/* istanbul ignore next */
/**
 * A polyfill for `addEventListener('storage', event => {..})` that does nothing if the polyfill is being used.
 *
 * @param {function({ key: string, newValue: string, oldValue: string }): void} eventHandler
 * @function
 */
var onChange = function onChange(eventHandler) {
  return usePolyfill || addEventListener('storage', eventHandler);
};
;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/function.js
function function_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = function_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }







































function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
function function_toConsumableArray(arr) { return function_arrayWithoutHoles(arr) || function_iterableToArray(arr) || function_unsupportedIterableToArray(arr) || function_nonIterableSpread(); }
function function_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function function_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return function_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return function_arrayLikeToArray(o, minLen); }
function function_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function function_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return function_arrayLikeToArray(arr); }
function function_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
/**
 * Common functions and function call helpers.
 *
 * @module function
 */




/**
 * Calls all functions in `fs` with args. Only throws after all functions were called.
 *
 * @param {Array<function>} fs
 * @param {Array<any>} args
 */
var callAll = function callAll(fs, args) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  try {
    for (; i < fs.length; i++) {
      fs[i].apply(fs, function_toConsumableArray(args));
    }
  } finally {
    if (i < fs.length) {
      callAll(fs, args, i + 1);
    }
  }
};
var nop = function nop() {};

/**
 * @template T
 * @param {function():T} f
 * @return {T}
 */
var apply = function apply(f) {
  return f();
};

/**
 * @template A
 *
 * @param {A} a
 * @return {A}
 */
var id = function id(a) {
  return a;
};

/**
 * @template T
 *
 * @param {T} a
 * @param {T} b
 * @return {boolean}
 */
var equalityStrict = function equalityStrict(a, b) {
  return a === b;
};

/**
 * @template T
 *
 * @param {Array<T>|object} a
 * @param {Array<T>|object} b
 * @return {boolean}
 */
var equalityFlat = function equalityFlat(a, b) {
  return a === b || a != null && b != null && a.constructor === b.constructor && (a instanceof Array && array.equalFlat(a, b) || _typeof(a) === 'object' && object.equalFlat(a, b));
};

/**
 * @param {any} a
 * @param {any} b
 * @return {boolean}
 */
var equalityDeep = function equalityDeep(a, b) {
  if (a == null || b == null) {
    return equalityStrict(a, b);
  }
  if (a.constructor !== b.constructor) {
    return false;
  }
  if (a === b) {
    return true;
  }
  switch (a.constructor) {
    case ArrayBuffer:
      a = new Uint8Array(a);
      b = new Uint8Array(b);
    // eslint-disable-next-line no-fallthrough
    case Uint8Array:
      {
        if (a.byteLength !== b.byteLength) {
          return false;
        }
        for (var i = 0; i < a.length; i++) {
          if (a[i] !== b[i]) {
            return false;
          }
        }
        break;
      }
    case Set:
      {
        if (a.size !== b.size) {
          return false;
        }
        var _iterator = function_createForOfIteratorHelper(a),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var value = _step.value;
            if (!b.has(value)) {
              return false;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        break;
      }
    case Map:
      {
        if (a.size !== b.size) {
          return false;
        }
        var _iterator2 = function_createForOfIteratorHelper(a.keys()),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var key = _step2.value;
            if (!b.has(key) || !equalityDeep(a.get(key), b.get(key))) {
              return false;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        break;
      }
    case Object:
      if (object.length(a) !== object.length(b)) {
        return false;
      }
      for (var _key in a) {
        if (!object.hasProperty(a, _key) || !equalityDeep(a[_key], b[_key])) {
          return false;
        }
      }
      break;
    case Array:
      if (a.length !== b.length) {
        return false;
      }
      for (var _i = 0; _i < a.length; _i++) {
        if (!equalityDeep(a[_i], b[_i])) {
          return false;
        }
      }
      break;
    default:
      return false;
  }
  return true;
};

/**
 * @template V
 * @template {V} OPTS
 *
 * @param {V} value
 * @param {Array<OPTS>} options
 */
// @ts-ignore
var isOneOf = function isOneOf(value, options) {
  return options.includes(value);
};
;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/environment.js
function environment_slicedToArray(arr, i) { return environment_arrayWithHoles(arr) || environment_iterableToArrayLimit(arr, i) || environment_unsupportedIterableToArray(arr, i) || environment_nonIterableRest(); }
function environment_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function environment_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return environment_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return environment_arrayLikeToArray(o, minLen); }
function environment_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function environment_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function environment_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function environment_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { environment_typeof = function _typeof(obj) { return typeof obj; }; } else { environment_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return environment_typeof(obj); }
















/**
 * Isomorphic module to work access the environment (query params, env variables).
 *
 * @module map
 */







/* istanbul ignore next */
// @ts-ignore
var isNode = typeof process !== 'undefined' && process.release && /node|io\.js/.test(process.release.name);
/* istanbul ignore next */
var isBrowser = typeof window !== 'undefined' && !isNode;
/* istanbul ignore next */
var isMac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;

/**
 * @type {Map<string,string>}
 */
var params;
var args = [];

/* istanbul ignore next */
var computeParams = function computeParams() {
  if (params === undefined) {
    if (isNode) {
      params = create();
      var pargs = process.argv;
      var currParamName = null;
      /* istanbul ignore next */
      for (var i = 0; i < pargs.length; i++) {
        var parg = pargs[i];
        if (parg[0] === '-') {
          if (currParamName !== null) {
            params.set(currParamName, '');
          }
          currParamName = parg;
        } else {
          if (currParamName !== null) {
            params.set(currParamName, parg);
            currParamName = null;
          } else {
            args.push(parg);
          }
        }
      }
      if (currParamName !== null) {
        params.set(currParamName, '');
      }
      // in ReactNative for example this would not be true (unless connected to the Remote Debugger)
    } else if ((typeof location === "undefined" ? "undefined" : environment_typeof(location)) === 'object') {
      params = create(); // eslint-disable-next-line no-undef
      (location.search || '?').slice(1).split('&').forEach(function (kv) {
        if (kv.length !== 0) {
          var _kv$split = kv.split('='),
            _kv$split2 = environment_slicedToArray(_kv$split, 2),
            key = _kv$split2[0],
            value = _kv$split2[1];
          params.set("--".concat(fromCamelCase(key, '-')), value);
          params.set("-".concat(fromCamelCase(key, '-')), value);
        }
      });
    } else {
      params = create();
    }
  }
  return params;
};

/**
 * @param {string} name
 * @return {boolean}
 */
/* istanbul ignore next */
var hasParam = function hasParam(name) {
  return computeParams().has(name);
};

/**
 * @param {string} name
 * @param {string} defaultVal
 * @return {string}
 */
/* istanbul ignore next */
var getParam = function getParam(name, defaultVal) {
  return computeParams().get(name) || defaultVal;
};
// export const getArgs = name => computeParams() && args

/**
 * @param {string} name
 * @return {string|null}
 */
/* istanbul ignore next */
var getVariable = function getVariable(name) {
  return isNode ? undefinedToNull(process.env[name.toUpperCase()]) : undefinedToNull(varStorage.getItem(name));
};

/**
 * @param {string} name
 * @return {string|null}
 */
var getConf = function getConf(name) {
  return computeParams().get('--' + name) || getVariable(name);
};

/**
 * @param {string} name
 * @return {boolean}
 */
/* istanbul ignore next */
var hasConf = function hasConf(name) {
  return hasParam('--' + name) || getVariable(name) !== null;
};

/* istanbul ignore next */
var production = hasConf('production');

/* istanbul ignore next */
var forceColor = isNode && isOneOf(process.env.FORCE_COLOR, ['true', '1', '2']);

/* istanbul ignore next */
var supportsColor = !hasParam('no-colors') && (!isNode || process.stdout.isTTY || forceColor) && (!isNode || hasParam('color') || forceColor || getVariable('COLORTERM') !== null || (getVariable('TERM') || '').includes('color'));
;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/buffer.js
/* provided dependency */ var Buffer = __webpack_require__(13423)["Buffer"];



























/**
 * Utility functions to work with buffers (Uint8Array).
 *
 * @module buffer
 */






/**
 * @param {number} len
 */
var createUint8ArrayFromLen = function createUint8ArrayFromLen(len) {
  return new Uint8Array(len);
};

/**
 * Create Uint8Array with initial content from buffer
 *
 * @param {ArrayBuffer} buffer
 * @param {number} byteOffset
 * @param {number} length
 */
var createUint8ArrayViewFromArrayBuffer = function createUint8ArrayViewFromArrayBuffer(buffer, byteOffset, length) {
  return new Uint8Array(buffer, byteOffset, length);
};

/**
 * Create Uint8Array with initial content from buffer
 *
 * @param {ArrayBuffer} buffer
 */
var createUint8ArrayFromArrayBuffer = function createUint8ArrayFromArrayBuffer(buffer) {
  return new Uint8Array(buffer);
};

/* istanbul ignore next */
/**
 * @param {Uint8Array} bytes
 * @return {string}
 */
var toBase64Browser = function toBase64Browser(bytes) {
  var s = '';
  for (var i = 0; i < bytes.byteLength; i++) {
    s += fromCharCode(bytes[i]);
  }
  // eslint-disable-next-line no-undef
  return btoa(s);
};

/**
 * @param {Uint8Array} bytes
 * @return {string}
 */
var toBase64Node = function toBase64Node(bytes) {
  return Buffer.from(bytes.buffer, bytes.byteOffset, bytes.byteLength).toString('base64');
};

/* istanbul ignore next */
/**
 * @param {string} s
 * @return {Uint8Array}
 */
var fromBase64Browser = function fromBase64Browser(s) {
  // eslint-disable-next-line no-undef
  var a = atob(s);
  var bytes = createUint8ArrayFromLen(a.length);
  for (var i = 0; i < a.length; i++) {
    bytes[i] = a.charCodeAt(i);
  }
  return bytes;
};

/**
 * @param {string} s
 */
var fromBase64Node = function fromBase64Node(s) {
  var buf = Buffer.from(s, 'base64');
  return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
};

/* istanbul ignore next */
var toBase64 = isBrowser ? toBase64Browser : toBase64Node;

/* istanbul ignore next */
var fromBase64 = isBrowser ? fromBase64Browser : fromBase64Node;

/**
 * Copy the content of an Uint8Array view to a new ArrayBuffer.
 *
 * @param {Uint8Array} uint8Array
 * @return {Uint8Array}
 */
var copyUint8Array = function copyUint8Array(uint8Array) {
  var newBuf = createUint8ArrayFromLen(uint8Array.byteLength);
  newBuf.set(uint8Array);
  return newBuf;
};

/**
 * Encode anything as a UInt8Array. It's a pun on typescripts's `any` type.
 * See encoding.writeAny for more information.
 *
 * @param {any} data
 * @return {Uint8Array}
 */
var encodeAny = function encodeAny(data) {
  var encoder = encoding.createEncoder();
  encoding.writeAny(encoder, data);
  return encoding.toUint8Array(encoder);
};

/**
 * Decode an any-encoded value.
 *
 * @param {Uint8Array} buf
 * @return {any}
 */
var decodeAny = function decodeAny(buf) {
  return decoding.readAny(decoding.createDecoder(buf));
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.max-safe-integer.js
var es_number_max_safe_integer = __webpack_require__(44363);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.min-safe-integer.js
var es_number_min_safe_integer = __webpack_require__(55994);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.is-integer.js
var es_number_is_integer = __webpack_require__(33161);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.parse-int.js
var es_number_parse_int = __webpack_require__(9494);
;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/binary.js
/* eslint-env browser */

/**
 * Binary data constants.
 *
 * @module binary
 */

/**
 * n-th bit activated.
 *
 * @type {number}
 */
var BIT1 = 1;
var BIT2 = 2;
var BIT3 = 4;
var BIT4 = 8;
var BIT5 = 16;
var BIT6 = 32;
var BIT7 = 64;
var BIT8 = 128;
var BIT9 = 256;
var BIT10 = 512;
var BIT11 = 1024;
var BIT12 = 2048;
var BIT13 = 4096;
var BIT14 = 8192;
var BIT15 = 16384;
var BIT16 = 32768;
var BIT17 = 65536;
var BIT18 = 1 << 17;
var BIT19 = 1 << 18;
var BIT20 = 1 << 19;
var BIT21 = 1 << 20;
var BIT22 = 1 << 21;
var BIT23 = 1 << 22;
var BIT24 = 1 << 23;
var BIT25 = 1 << 24;
var BIT26 = 1 << 25;
var BIT27 = 1 << 26;
var BIT28 = 1 << 27;
var BIT29 = 1 << 28;
var BIT30 = 1 << 29;
var BIT31 = 1 << 30;
var BIT32 = (/* unused pure expression or super */ null && (1 << 31));

/**
 * First n bits activated.
 *
 * @type {number}
 */
var BITS0 = 0;
var BITS1 = 1;
var BITS2 = 3;
var BITS3 = 7;
var BITS4 = 15;
var BITS5 = 31;
var BITS6 = 63;
var BITS7 = 127;
var BITS8 = 255;
var BITS9 = 511;
var BITS10 = 1023;
var BITS11 = 2047;
var BITS12 = 4095;
var BITS13 = 8191;
var BITS14 = 16383;
var BITS15 = 32767;
var BITS16 = 65535;
var BITS17 = BIT18 - 1;
var BITS18 = BIT19 - 1;
var BITS19 = BIT20 - 1;
var BITS20 = BIT21 - 1;
var BITS21 = BIT22 - 1;
var BITS22 = BIT23 - 1;
var BITS23 = BIT24 - 1;
var BITS24 = BIT25 - 1;
var BITS25 = BIT26 - 1;
var BITS26 = BIT27 - 1;
var BITS27 = BIT28 - 1;
var BITS28 = BIT29 - 1;
var BITS29 = BIT30 - 1;
var BITS30 = BIT31 - 1;
/**
 * @type {number}
 */
var BITS31 = 0x7FFFFFFF;
/**
 * @type {number}
 */
var BITS32 = 0xFFFFFFFF;
;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/number.js






/**
 * Utility helpers for working with numbers.
 *
 * @module number
 */



var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER;
var MIN_SAFE_INTEGER = Number.MIN_SAFE_INTEGER;
var LOWEST_INT32 = (/* unused pure expression or super */ null && (1 << 31));
/**
 * @type {number}
 */
var HIGHEST_INT32 = BITS31;

/**
 * @module number
 */

/* istanbul ignore next */
var isInteger = Number.isInteger || function (num) {
  return typeof num === 'number' && isFinite(num) && floor(num) === num;
};
var number_isNaN = Number.isNaN;
var number_parseInt = Number.parseInt;
;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/encoding.js
function encoding_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function encoding_createClass(Constructor, protoProps, staticProps) { if (protoProps) encoding_defineProperties(Constructor.prototype, protoProps); if (staticProps) encoding_defineProperties(Constructor, staticProps); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (encoding_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function encoding_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { encoding_typeof = function _typeof(obj) { return typeof obj; }; } else { encoding_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return encoding_typeof(obj); }





































function encoding_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
/**
 * Efficient schema-less binary encoding with support for variable length encoding.
 *
 * Use [lib0/encoding] with [lib0/decoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = new encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = new decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module encoding
 */







/**
 * A BinaryEncoder handles the encoding to an Uint8Array.
 */
var Encoder = function Encoder() {
  encoding_classCallCheck(this, Encoder);
  this.cpos = 0;
  this.cbuf = new Uint8Array(100);
  /**
   * @type {Array<Uint8Array>}
   */
  this.bufs = [];
};

/**
 * @function
 * @return {Encoder}
 */
var createEncoder = function createEncoder() {
  return new Encoder();
};

/**
 * The current length of the encoded data.
 *
 * @function
 * @param {Encoder} encoder
 * @return {number}
 */
var encoding_length = function length(encoder) {
  var len = encoder.cpos;
  for (var i = 0; i < encoder.bufs.length; i++) {
    len += encoder.bufs[i].length;
  }
  return len;
};

/**
 * Transform to Uint8Array.
 *
 * @function
 * @param {Encoder} encoder
 * @return {Uint8Array} The created ArrayBuffer.
 */
var _toUint8Array = function toUint8Array(encoder) {
  var uint8arr = new Uint8Array(encoding_length(encoder));
  var curPos = 0;
  for (var i = 0; i < encoder.bufs.length; i++) {
    var d = encoder.bufs[i];
    uint8arr.set(d, curPos);
    curPos += d.length;
  }
  uint8arr.set(createUint8ArrayViewFromArrayBuffer(encoder.cbuf.buffer, 0, encoder.cpos), curPos);
  return uint8arr;
};

/**
 * Verify that it is possible to write `len` bytes wtihout checking. If
 * necessary, a new Buffer with the required length is attached.
 *
 * @param {Encoder} encoder
 * @param {number} len
 */

var verifyLen = function verifyLen(encoder, len) {
  var bufferLen = encoder.cbuf.length;
  if (bufferLen - encoder.cpos < len) {
    encoder.bufs.push(createUint8ArrayViewFromArrayBuffer(encoder.cbuf.buffer, 0, encoder.cpos));
    encoder.cbuf = new Uint8Array(max(bufferLen, len) * 2);
    encoder.cpos = 0;
  }
};

/**
 * Write one byte to the encoder.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The byte that is to be encoded.
 */
var write = function write(encoder, num) {
  var bufferLen = encoder.cbuf.length;
  if (encoder.cpos === bufferLen) {
    encoder.bufs.push(encoder.cbuf);
    encoder.cbuf = new Uint8Array(bufferLen * 2);
    encoder.cpos = 0;
  }
  encoder.cbuf[encoder.cpos++] = num;
};

/**
 * Write one byte at a specific position.
 * Position must already be written (i.e. encoder.length > pos)
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} pos Position to which to write data
 * @param {number} num Unsigned 8-bit integer
 */
var set = function set(encoder, pos, num) {
  var buffer = null;
  // iterate all buffers and adjust position
  for (var i = 0; i < encoder.bufs.length && buffer === null; i++) {
    var b = encoder.bufs[i];
    if (pos < b.length) {
      buffer = b; // found buffer
    } else {
      pos -= b.length;
    }
  }
  if (buffer === null) {
    // use current buffer
    buffer = encoder.cbuf;
  }
  buffer[pos] = num;
};

/**
 * Write one byte as an unsigned integer.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
var writeUint8 = write;

/**
 * Write one byte as an unsigned Integer at a specific location.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} pos The location where the data will be written.
 * @param {number} num The number that is to be encoded.
 */
var setUint8 = (/* unused pure expression or super */ null && (set));

/**
 * Write two bytes as an unsigned integer.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
var writeUint16 = function writeUint16(encoder, num) {
  write(encoder, num & binary.BITS8);
  write(encoder, num >>> 8 & binary.BITS8);
};
/**
 * Write two bytes as an unsigned integer at a specific location.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} pos The location where the data will be written.
 * @param {number} num The number that is to be encoded.
 */
var setUint16 = function setUint16(encoder, pos, num) {
  set(encoder, pos, num & binary.BITS8);
  set(encoder, pos + 1, num >>> 8 & binary.BITS8);
};

/**
 * Write two bytes as an unsigned integer
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
var writeUint32 = function writeUint32(encoder, num) {
  for (var i = 0; i < 4; i++) {
    write(encoder, num & binary.BITS8);
    num >>>= 8;
  }
};

/**
 * Write two bytes as an unsigned integer in big endian order.
 * (most significant byte first)
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
var writeUint32BigEndian = function writeUint32BigEndian(encoder, num) {
  for (var i = 3; i >= 0; i--) {
    write(encoder, num >>> 8 * i & binary.BITS8);
  }
};

/**
 * Write two bytes as an unsigned integer at a specific location.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} pos The location where the data will be written.
 * @param {number} num The number that is to be encoded.
 */
var setUint32 = function setUint32(encoder, pos, num) {
  for (var i = 0; i < 4; i++) {
    set(encoder, pos + i, num & binary.BITS8);
    num >>>= 8;
  }
};

/**
 * Write a variable length unsigned integer. Max encodable integer is 2^53.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
var writeVarUint = function writeVarUint(encoder, num) {
  while (num > BITS7) {
    write(encoder, BIT8 | BITS7 & num);
    num = floor(num / 128); // shift >>> 7
  }

  write(encoder, BITS7 & num);
};

/**
 * Write a variable length integer.
 *
 * We use the 7th bit instead for signaling that this is a negative number.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
var writeVarInt = function writeVarInt(encoder, num) {
  var isNegative = isNegativeZero(num);
  if (isNegative) {
    num = -num;
  }
  //             |- whether to continue reading         |- whether is negative     |- number
  write(encoder, (num > BITS6 ? BIT8 : 0) | (isNegative ? BIT7 : 0) | BITS6 & num);
  num = floor(num / 64); // shift >>> 6
  // We don't need to consider the case of num === 0 so we can use a different
  // pattern here than above.
  while (num > 0) {
    write(encoder, (num > BITS7 ? BIT8 : 0) | BITS7 & num);
    num = floor(num / 128); // shift >>> 7
  }
};

/**
 * A cache to store strings temporarily
 */
var _strBuffer = new Uint8Array(30000);
var _maxStrBSize = _strBuffer.length / 3;

/**
 * Write a variable length string.
 *
 * @function
 * @param {Encoder} encoder
 * @param {String} str The string that is to be encoded.
 */
var _writeVarStringNative = function _writeVarStringNative(encoder, str) {
  if (str.length < _maxStrBSize) {
    // We can encode the string into the existing buffer
    /* istanbul ignore else */
    var written = utf8TextEncoder.encodeInto(str, _strBuffer).written || 0;
    writeVarUint(encoder, written);
    for (var i = 0; i < written; i++) {
      write(encoder, _strBuffer[i]);
    }
  } else {
    writeVarUint8Array(encoder, encodeUtf8(str));
  }
};

/**
 * Write a variable length string.
 *
 * @function
 * @param {Encoder} encoder
 * @param {String} str The string that is to be encoded.
 */
var _writeVarStringPolyfill = function _writeVarStringPolyfill(encoder, str) {
  var encodedString = unescape(encodeURIComponent(str));
  var len = encodedString.length;
  writeVarUint(encoder, len);
  for (var i = 0; i < len; i++) {
    write(encoder, encodedString.codePointAt(i));
  }
};

/**
 * Write a variable length string.
 *
 * @function
 * @param {Encoder} encoder
 * @param {String} str The string that is to be encoded.
 */
/* istanbul ignore next */
var writeVarString = utf8TextEncoder && utf8TextEncoder.encodeInto ? _writeVarStringNative : _writeVarStringPolyfill;

/**
 * Write the content of another Encoder.
 *
 * @TODO: can be improved!
 *        - Note: Should consider that when appending a lot of small Encoders, we should rather clone than referencing the old structure.
 *                Encoders start with a rather big initial buffer.
 *
 * @function
 * @param {Encoder} encoder The enUint8Arr
 * @param {Encoder} append The BinaryEncoder to be written.
 */
var writeBinaryEncoder = function writeBinaryEncoder(encoder, append) {
  return writeUint8Array(encoder, _toUint8Array(append));
};

/**
 * Append fixed-length Uint8Array to the encoder.
 *
 * @function
 * @param {Encoder} encoder
 * @param {Uint8Array} uint8Array
 */
var writeUint8Array = function writeUint8Array(encoder, uint8Array) {
  var bufferLen = encoder.cbuf.length;
  var cpos = encoder.cpos;
  var leftCopyLen = min(bufferLen - cpos, uint8Array.length);
  var rightCopyLen = uint8Array.length - leftCopyLen;
  encoder.cbuf.set(uint8Array.subarray(0, leftCopyLen), cpos);
  encoder.cpos += leftCopyLen;
  if (rightCopyLen > 0) {
    // Still something to write, write right half..
    // Append new buffer
    encoder.bufs.push(encoder.cbuf);
    // must have at least size of remaining buffer
    encoder.cbuf = new Uint8Array(max(bufferLen * 2, rightCopyLen));
    // copy array
    encoder.cbuf.set(uint8Array.subarray(leftCopyLen));
    encoder.cpos = rightCopyLen;
  }
};

/**
 * Append an Uint8Array to Encoder.
 *
 * @function
 * @param {Encoder} encoder
 * @param {Uint8Array} uint8Array
 */
var writeVarUint8Array = function writeVarUint8Array(encoder, uint8Array) {
  writeVarUint(encoder, uint8Array.byteLength);
  writeUint8Array(encoder, uint8Array);
};

/**
 * Create an DataView of the next `len` bytes. Use it to write data after
 * calling this function.
 *
 * ```js
 * // write float32 using DataView
 * const dv = writeOnDataView(encoder, 4)
 * dv.setFloat32(0, 1.1)
 * // read float32 using DataView
 * const dv = readFromDataView(encoder, 4)
 * dv.getFloat32(0) // => 1.100000023841858 (leaving it to the reader to find out why this is the correct result)
 * ```
 *
 * @param {Encoder} encoder
 * @param {number} len
 * @return {DataView}
 */
var writeOnDataView = function writeOnDataView(encoder, len) {
  verifyLen(encoder, len);
  var dview = new DataView(encoder.cbuf.buffer, encoder.cpos, len);
  encoder.cpos += len;
  return dview;
};

/**
 * @param {Encoder} encoder
 * @param {number} num
 */
var writeFloat32 = function writeFloat32(encoder, num) {
  return writeOnDataView(encoder, 4).setFloat32(0, num, false);
};

/**
 * @param {Encoder} encoder
 * @param {number} num
 */
var writeFloat64 = function writeFloat64(encoder, num) {
  return writeOnDataView(encoder, 8).setFloat64(0, num, false);
};

/**
 * @param {Encoder} encoder
 * @param {bigint} num
 */
var writeBigInt64 = function writeBigInt64(encoder, num) {
  return (/** @type {any} */writeOnDataView(encoder, 8).setBigInt64(0, num, false)
  );
};

/**
 * @param {Encoder} encoder
 * @param {bigint} num
 */
var writeBigUint64 = function writeBigUint64(encoder, num) {
  return (/** @type {any} */writeOnDataView(encoder, 8).setBigUint64(0, num, false)
  );
};
var floatTestBed = new DataView(new ArrayBuffer(4));
/**
 * Check if a number can be encoded as a 32 bit float.
 *
 * @param {number} num
 * @return {boolean}
 */
var isFloat32 = function isFloat32(num) {
  floatTestBed.setFloat32(0, num);
  return floatTestBed.getFloat32(0) === num;
};

/**
 * Encode data with efficient binary format.
 *
 * Differences to JSON:
 * • Transforms data to a binary format (not to a string)
 * • Encodes undefined, NaN, and ArrayBuffer (these can't be represented in JSON)
 * • Numbers are efficiently encoded either as a variable length integer, as a
 *   32 bit float, as a 64 bit float, or as a 64 bit bigint.
 *
 * Encoding table:
 *
 * | Data Type           | Prefix   | Encoding Method    | Comment |
 * | ------------------- | -------- | ------------------ | ------- |
 * | undefined           | 127      |                    | Functions, symbol, and everything that cannot be identified is encoded as undefined |
 * | null                | 126      |                    | |
 * | integer             | 125      | writeVarInt        | Only encodes 32 bit signed integers |
 * | float32             | 124      | writeFloat32       | |
 * | float64             | 123      | writeFloat64       | |
 * | bigint              | 122      | writeBigInt64      | |
 * | boolean (false)     | 121      |                    | True and false are different data types so we save the following byte |
 * | boolean (true)      | 120      |                    | - 0b01111000 so the last bit determines whether true or false |
 * | string              | 119      | writeVarString     | |
 * | object<string,any>  | 118      | custom             | Writes {length} then {length} key-value pairs |
 * | array<any>          | 117      | custom             | Writes {length} then {length} json values |
 * | Uint8Array          | 116      | writeVarUint8Array | We use Uint8Array for any kind of binary data |
 *
 * Reasons for the decreasing prefix:
 * We need the first bit for extendability (later we may want to encode the
 * prefix with writeVarUint). The remaining 7 bits are divided as follows:
 * [0-30]   the beginning of the data range is used for custom purposes
 *          (defined by the function that uses this library)
 * [31-127] the end of the data range is used for data encoding by
 *          lib0/encoding.js
 *
 * @param {Encoder} encoder
 * @param {undefined|null|number|bigint|boolean|string|Object<string,any>|Array<any>|Uint8Array} data
 */
var writeAny = function writeAny(encoder, data) {
  switch (encoding_typeof(data)) {
    case 'string':
      // TYPE 119: STRING
      write(encoder, 119);
      writeVarString(encoder, data);
      break;
    case 'number':
      if (isInteger(data) && abs(data) <= BITS31) {
        // TYPE 125: INTEGER
        write(encoder, 125);
        writeVarInt(encoder, data);
      } else if (isFloat32(data)) {
        // TYPE 124: FLOAT32
        write(encoder, 124);
        writeFloat32(encoder, data);
      } else {
        // TYPE 123: FLOAT64
        write(encoder, 123);
        writeFloat64(encoder, data);
      }
      break;
    case 'bigint':
      // TYPE 122: BigInt
      write(encoder, 122);
      writeBigInt64(encoder, data);
      break;
    case 'object':
      if (data === null) {
        // TYPE 126: null
        write(encoder, 126);
      } else if (data instanceof Array) {
        // TYPE 117: Array
        write(encoder, 117);
        writeVarUint(encoder, data.length);
        for (var i = 0; i < data.length; i++) {
          writeAny(encoder, data[i]);
        }
      } else if (data instanceof Uint8Array) {
        // TYPE 116: ArrayBuffer
        write(encoder, 116);
        writeVarUint8Array(encoder, data);
      } else {
        // TYPE 118: Object
        write(encoder, 118);
        var keys = Object.keys(data);
        writeVarUint(encoder, keys.length);
        for (var _i = 0; _i < keys.length; _i++) {
          var key = keys[_i];
          writeVarString(encoder, key);
          writeAny(encoder, data[key]);
        }
      }
      break;
    case 'boolean':
      // TYPE 120/121: boolean (true/false)
      write(encoder, data ? 120 : 121);
      break;
    default:
      // TYPE 127: undefined
      write(encoder, 127);
  }
};

/**
 * Now come a few stateful encoder that have their own classes.
 */

/**
 * Basic Run Length Encoder - a basic compression implementation.
 *
 * Encodes [1,1,1,7] to [1,3,7,1] (3 times 1, 1 time 7). This encoder might do more harm than good if there are a lot of values that are not repeated.
 *
 * It was originally used for image compression. Cool .. article http://csbruce.com/cbm/transactor/pdfs/trans_v7_i06.pdf
 *
 * @note T must not be null!
 *
 * @template T
 */
var RleEncoder = /*#__PURE__*/function (_Encoder) {
  _inherits(RleEncoder, _Encoder);
  var _super = _createSuper(RleEncoder);
  /**
   * @param {function(Encoder, T):void} writer
   */
  function RleEncoder(writer) {
    var _this;
    encoding_classCallCheck(this, RleEncoder);
    _this = _super.call(this);
    /**
     * The writer
     */
    _this.w = writer;
    /**
     * Current state
     * @type {T|null}
     */
    _this.s = null;
    _this.count = 0;
    return _this;
  }

  /**
   * @param {T} v
   */
  encoding_createClass(RleEncoder, [{
    key: "write",
    value: function write(v) {
      if (this.s === v) {
        this.count++;
      } else {
        if (this.count > 0) {
          // flush counter, unless this is the first value (count = 0)
          writeVarUint(this, this.count - 1); // since count is always > 0, we can decrement by one. non-standard encoding ftw
        }

        this.count = 1;
        // write first value
        this.w(this, v);
        this.s = v;
      }
    }
  }]);
  return RleEncoder;
}(Encoder);

/**
 * Basic diff decoder using variable length encoding.
 *
 * Encodes the values [3, 1100, 1101, 1050, 0] to [3, 1097, 1, -51, -1050] using writeVarInt.
 */
var IntDiffEncoder = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_Encoder2) {
  _inherits(IntDiffEncoder, _Encoder2);
  var _super2 = _createSuper(IntDiffEncoder);
  /**
   * @param {number} start
   */
  function IntDiffEncoder(start) {
    var _this2;
    encoding_classCallCheck(this, IntDiffEncoder);
    _this2 = _super2.call(this);
    /**
     * Current state
     * @type {number}
     */
    _this2.s = start;
    return _this2;
  }

  /**
   * @param {number} v
   */
  encoding_createClass(IntDiffEncoder, [{
    key: "write",
    value: function write(v) {
      writeVarInt(this, v - this.s);
      this.s = v;
    }
  }]);
  return IntDiffEncoder;
}(Encoder)));

/**
 * A combination of IntDiffEncoder and RleEncoder.
 *
 * Basically first writes the IntDiffEncoder and then counts duplicate diffs using RleEncoding.
 *
 * Encodes the values [1,1,1,2,3,4,5,6] as [1,1,0,2,1,5] (RLE([1,0,0,1,1,1,1,1]) ⇒ RleIntDiff[1,1,0,2,1,5])
 */
var RleIntDiffEncoder = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_Encoder3) {
  _inherits(RleIntDiffEncoder, _Encoder3);
  var _super3 = _createSuper(RleIntDiffEncoder);
  /**
   * @param {number} start
   */
  function RleIntDiffEncoder(start) {
    var _this3;
    encoding_classCallCheck(this, RleIntDiffEncoder);
    _this3 = _super3.call(this);
    /**
     * Current state
     * @type {number}
     */
    _this3.s = start;
    _this3.count = 0;
    return _this3;
  }

  /**
   * @param {number} v
   */
  encoding_createClass(RleIntDiffEncoder, [{
    key: "write",
    value: function write(v) {
      if (this.s === v && this.count > 0) {
        this.count++;
      } else {
        if (this.count > 0) {
          // flush counter, unless this is the first value (count = 0)
          writeVarUint(this, this.count - 1); // since count is always > 0, we can decrement by one. non-standard encoding ftw
        }

        this.count = 1;
        // write first value
        writeVarInt(this, v - this.s);
        this.s = v;
      }
    }
  }]);
  return RleIntDiffEncoder;
}(Encoder)));

/**
 * @param {UintOptRleEncoder} encoder
 */
var flushUintOptRleEncoder = function flushUintOptRleEncoder(encoder) {
  /* istanbul ignore else */
  if (encoder.count > 0) {
    // flush counter, unless this is the first value (count = 0)
    // case 1: just a single value. set sign to positive
    // case 2: write several values. set sign to negative to indicate that there is a length coming
    writeVarInt(encoder.encoder, encoder.count === 1 ? encoder.s : -encoder.s);
    if (encoder.count > 1) {
      writeVarUint(encoder.encoder, encoder.count - 2); // since count is always > 1, we can decrement by one. non-standard encoding ftw
    }
  }
};

/**
 * Optimized Rle encoder that does not suffer from the mentioned problem of the basic Rle encoder.
 *
 * Internally uses VarInt encoder to write unsigned integers. If the input occurs multiple times, we write
 * write it as a negative number. The UintOptRleDecoder then understands that it needs to read a count.
 *
 * Encodes [1,2,3,3,3] as [1,2,-3,3] (once 1, once 2, three times 3)
 */
var UintOptRleEncoder = /*#__PURE__*/function () {
  function UintOptRleEncoder() {
    encoding_classCallCheck(this, UintOptRleEncoder);
    this.encoder = new Encoder();
    /**
     * @type {number}
     */
    this.s = 0;
    this.count = 0;
  }

  /**
   * @param {number} v
   */
  encoding_createClass(UintOptRleEncoder, [{
    key: "write",
    value: function write(v) {
      if (this.s === v) {
        this.count++;
      } else {
        flushUintOptRleEncoder(this);
        this.count = 1;
        this.s = v;
      }
    }
  }, {
    key: "toUint8Array",
    value: function toUint8Array() {
      flushUintOptRleEncoder(this);
      return _toUint8Array(this.encoder);
    }
  }]);
  return UintOptRleEncoder;
}();

/**
 * Increasing Uint Optimized RLE Encoder
 *
 * The RLE encoder counts the number of same occurences of the same value.
 * The IncUintOptRle encoder counts if the value increases.
 * I.e. 7, 8, 9, 10 will be encoded as [-7, 4]. 1, 3, 5 will be encoded
 * as [1, 3, 5].
 */
var IncUintOptRleEncoder = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  function IncUintOptRleEncoder() {
    encoding_classCallCheck(this, IncUintOptRleEncoder);
    this.encoder = new Encoder();
    /**
     * @type {number}
     */
    this.s = 0;
    this.count = 0;
  }

  /**
   * @param {number} v
   */
  encoding_createClass(IncUintOptRleEncoder, [{
    key: "write",
    value: function write(v) {
      if (this.s + this.count === v) {
        this.count++;
      } else {
        flushUintOptRleEncoder(this);
        this.count = 1;
        this.s = v;
      }
    }
  }, {
    key: "toUint8Array",
    value: function toUint8Array() {
      flushUintOptRleEncoder(this);
      return _toUint8Array(this.encoder);
    }
  }]);
  return IncUintOptRleEncoder;
}()));

/**
 * @param {IntDiffOptRleEncoder} encoder
 */
var flushIntDiffOptRleEncoder = function flushIntDiffOptRleEncoder(encoder) {
  if (encoder.count > 0) {
    //          31 bit making up the diff | wether to write the counter
    // const encodedDiff = encoder.diff << 1 | (encoder.count === 1 ? 0 : 1)
    var encodedDiff = encoder.diff * 2 + (encoder.count === 1 ? 0 : 1);
    // flush counter, unless this is the first value (count = 0)
    // case 1: just a single value. set first bit to positive
    // case 2: write several values. set first bit to negative to indicate that there is a length coming
    writeVarInt(encoder.encoder, encodedDiff);
    if (encoder.count > 1) {
      writeVarUint(encoder.encoder, encoder.count - 2); // since count is always > 1, we can decrement by one. non-standard encoding ftw
    }
  }
};

/**
 * A combination of the IntDiffEncoder and the UintOptRleEncoder.
 *
 * The count approach is similar to the UintDiffOptRleEncoder, but instead of using the negative bitflag, it encodes
 * in the LSB whether a count is to be read. Therefore this Encoder only supports 31 bit integers!
 *
 * Encodes [1, 2, 3, 2] as [3, 1, 6, -1] (more specifically [(1 << 1) | 1, (3 << 0) | 0, -1])
 *
 * Internally uses variable length encoding. Contrary to normal UintVar encoding, the first byte contains:
 * * 1 bit that denotes whether the next value is a count (LSB)
 * * 1 bit that denotes whether this value is negative (MSB - 1)
 * * 1 bit that denotes whether to continue reading the variable length integer (MSB)
 *
 * Therefore, only five bits remain to encode diff ranges.
 *
 * Use this Encoder only when appropriate. In most cases, this is probably a bad idea.
 */
var IntDiffOptRleEncoder = /*#__PURE__*/function () {
  function IntDiffOptRleEncoder() {
    encoding_classCallCheck(this, IntDiffOptRleEncoder);
    this.encoder = new Encoder();
    /**
     * @type {number}
     */
    this.s = 0;
    this.count = 0;
    this.diff = 0;
  }

  /**
   * @param {number} v
   */
  encoding_createClass(IntDiffOptRleEncoder, [{
    key: "write",
    value: function write(v) {
      if (this.diff === v - this.s) {
        this.s = v;
        this.count++;
      } else {
        flushIntDiffOptRleEncoder(this);
        this.count = 1;
        this.diff = v - this.s;
        this.s = v;
      }
    }
  }, {
    key: "toUint8Array",
    value: function toUint8Array() {
      flushIntDiffOptRleEncoder(this);
      return _toUint8Array(this.encoder);
    }
  }]);
  return IntDiffOptRleEncoder;
}();

/**
 * Optimized String Encoder.
 *
 * Encoding many small strings in a simple Encoder is not very efficient. The function call to decode a string takes some time and creates references that must be eventually deleted.
 * In practice, when decoding several million small strings, the GC will kick in more and more often to collect orphaned string objects (or maybe there is another reason?).
 *
 * This string encoder solves the above problem. All strings are concatenated and written as a single string using a single encoding call.
 *
 * The lengths are encoded using a UintOptRleEncoder.
 */
var StringEncoder = /*#__PURE__*/function () {
  function StringEncoder() {
    encoding_classCallCheck(this, StringEncoder);
    /**
     * @type {Array<string>}
     */
    this.sarr = [];
    this.s = '';
    this.lensE = new UintOptRleEncoder();
  }

  /**
   * @param {string} string
   */
  encoding_createClass(StringEncoder, [{
    key: "write",
    value: function write(string) {
      this.s += string;
      if (this.s.length > 19) {
        this.sarr.push(this.s);
        this.s = '';
      }
      this.lensE.write(string.length);
    }
  }, {
    key: "toUint8Array",
    value: function toUint8Array() {
      var encoder = new Encoder();
      this.sarr.push(this.s);
      this.s = '';
      writeVarString(encoder, this.sarr.join(''));
      writeUint8Array(encoder, this.lensE.toUint8Array());
      return _toUint8Array(encoder);
    }
  }]);
  return StringEncoder;
}();
;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/error.js
/**
 * Error helpers.
 *
 * @module error
 */

/* istanbul ignore next */
/**
 * @param {string} s
 * @return {Error}
 */
var error_create = function create(s) {
  return new Error(s);
};

/* istanbul ignore next */
/**
 * @throws {Error}
 * @return {never}
 */
var methodUnimplemented = function methodUnimplemented() {
  throw error_create('Method unimplemented');
};

/* istanbul ignore next */
/**
 * @throws {Error}
 * @return {never}
 */
var unexpectedCase = function unexpectedCase() {
  throw error_create('Unexpected case');
};
;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/decoding.js
function decoding_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { decoding_typeof = function _typeof(obj) { return typeof obj; }; } else { decoding_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return decoding_typeof(obj); }
function decoding_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function decoding_createClass(Constructor, protoProps, staticProps) { if (protoProps) decoding_defineProperties(Constructor.prototype, protoProps); if (staticProps) decoding_defineProperties(Constructor, staticProps); return Constructor; }
function decoding_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) decoding_setPrototypeOf(subClass, superClass); }
function decoding_setPrototypeOf(o, p) { decoding_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return decoding_setPrototypeOf(o, p); }
function decoding_createSuper(Derived) { var hasNativeReflectConstruct = decoding_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = decoding_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = decoding_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return decoding_possibleConstructorReturn(this, result); }; }
function decoding_possibleConstructorReturn(self, call) { if (call && (decoding_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return decoding_assertThisInitialized(self); }
function decoding_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function decoding_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function decoding_getPrototypeOf(o) { decoding_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return decoding_getPrototypeOf(o); }











function decoding_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
/**
 * Efficient schema-less binary decoding with support for variable length encoding.
 *
 * Use [lib0/decoding] with [lib0/encoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = new encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = new decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module decoding
 */







var errorUnexpectedEndOfArray = error_create('Unexpected end of array');
var errorIntegerOutOfRange = error_create('Integer out of Range');

/**
 * A Decoder handles the decoding of an Uint8Array.
 */
var Decoder =
/**
 * @param {Uint8Array} uint8Array Binary data to decode
 */
function Decoder(uint8Array) {
  decoding_classCallCheck(this, Decoder);
  /**
   * Decoding target.
   *
   * @type {Uint8Array}
   */
  this.arr = uint8Array;
  /**
   * Current decoding position.
   *
   * @type {number}
   */
  this.pos = 0;
};

/**
 * @function
 * @param {Uint8Array} uint8Array
 * @return {Decoder}
 */
var createDecoder = function createDecoder(uint8Array) {
  return new Decoder(uint8Array);
};

/**
 * @function
 * @param {Decoder} decoder
 * @return {boolean}
 */
var hasContent = function hasContent(decoder) {
  return decoder.pos !== decoder.arr.length;
};

/**
 * Clone a decoder instance.
 * Optionally set a new position parameter.
 *
 * @function
 * @param {Decoder} decoder The decoder instance
 * @param {number} [newPos] Defaults to current position
 * @return {Decoder} A clone of `decoder`
 */
var clone = function clone(decoder) {
  var newPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : decoder.pos;
  var _decoder = createDecoder(decoder.arr);
  _decoder.pos = newPos;
  return _decoder;
};

/**
 * Create an Uint8Array view of the next `len` bytes and advance the position by `len`.
 *
 * Important: The Uint8Array still points to the underlying ArrayBuffer. Make sure to discard the result as soon as possible to prevent any memory leaks.
 *            Use `buffer.copyUint8Array` to copy the result into a new Uint8Array.
 *
 * @function
 * @param {Decoder} decoder The decoder instance
 * @param {number} len The length of bytes to read
 * @return {Uint8Array}
 */
var readUint8Array = function readUint8Array(decoder, len) {
  var view = createUint8ArrayViewFromArrayBuffer(decoder.arr.buffer, decoder.pos + decoder.arr.byteOffset, len);
  decoder.pos += len;
  return view;
};

/**
 * Read variable length Uint8Array.
 *
 * Important: The Uint8Array still points to the underlying ArrayBuffer. Make sure to discard the result as soon as possible to prevent any memory leaks.
 *            Use `buffer.copyUint8Array` to copy the result into a new Uint8Array.
 *
 * @function
 * @param {Decoder} decoder
 * @return {Uint8Array}
 */
var readVarUint8Array = function readVarUint8Array(decoder) {
  return readUint8Array(decoder, readVarUint(decoder));
};

/**
 * Read the rest of the content as an ArrayBuffer
 * @function
 * @param {Decoder} decoder
 * @return {Uint8Array}
 */
var readTailAsUint8Array = function readTailAsUint8Array(decoder) {
  return readUint8Array(decoder, decoder.arr.length - decoder.pos);
};

/**
 * Skip one byte, jump to the next position.
 * @function
 * @param {Decoder} decoder The decoder instance
 * @return {number} The next position
 */
var skip8 = function skip8(decoder) {
  return decoder.pos++;
};

/**
 * Read one byte as unsigned integer.
 * @function
 * @param {Decoder} decoder The decoder instance
 * @return {number} Unsigned 8-bit integer
 */
var readUint8 = function readUint8(decoder) {
  return decoder.arr[decoder.pos++];
};

/**
 * Read 2 bytes as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
var readUint16 = function readUint16(decoder) {
  var uint = decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8);
  decoder.pos += 2;
  return uint;
};

/**
 * Read 4 bytes as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
var readUint32 = function readUint32(decoder) {
  var uint = decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8) + (decoder.arr[decoder.pos + 2] << 16) + (decoder.arr[decoder.pos + 3] << 24) >>> 0;
  decoder.pos += 4;
  return uint;
};

/**
 * Read 4 bytes as unsigned integer in big endian order.
 * (most significant byte first)
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
var readUint32BigEndian = function readUint32BigEndian(decoder) {
  var uint = decoder.arr[decoder.pos + 3] + (decoder.arr[decoder.pos + 2] << 8) + (decoder.arr[decoder.pos + 1] << 16) + (decoder.arr[decoder.pos] << 24) >>> 0;
  decoder.pos += 4;
  return uint;
};

/**
 * Look ahead without incrementing the position
 * to the next byte and read it as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
var peekUint8 = function peekUint8(decoder) {
  return decoder.arr[decoder.pos];
};

/**
 * Look ahead without incrementing the position
 * to the next byte and read it as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
var peekUint16 = function peekUint16(decoder) {
  return decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8);
};

/**
 * Look ahead without incrementing the position
 * to the next byte and read it as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
var peekUint32 = function peekUint32(decoder) {
  return decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8) + (decoder.arr[decoder.pos + 2] << 16) + (decoder.arr[decoder.pos + 3] << 24) >>> 0;
};

/**
 * Read unsigned integer (32bit) with variable length.
 * 1/8th of the storage is used as encoding overhead.
 *  * numbers < 2^7 is stored in one bytlength
 *  * numbers < 2^14 is stored in two bylength
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.length
 */
var readVarUint = function readVarUint(decoder) {
  var num = 0;
  var mult = 1;
  var len = decoder.arr.length;
  while (decoder.pos < len) {
    var r = decoder.arr[decoder.pos++];
    // num = num | ((r & binary.BITS7) << len)
    num = num + (r & BITS7) * mult; // shift $r << (7*#iterations) and add it to num
    mult *= 128; // next iteration, shift 7 "more" to the left
    if (r < BIT8) {
      return num;
    }
    /* istanbul ignore if */
    if (num > MAX_SAFE_INTEGER) {
      throw errorIntegerOutOfRange;
    }
  }
  throw errorUnexpectedEndOfArray;
};

/**
 * Read signed integer (32bit) with variable length.
 * 1/8th of the storage is used as encoding overhead.
 *  * numbers < 2^7 is stored in one bytlength
 *  * numbers < 2^14 is stored in two bylength
 * @todo This should probably create the inverse ~num if number is negative - but this would be a breaking change.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.length
 */
var readVarInt = function readVarInt(decoder) {
  var r = decoder.arr[decoder.pos++];
  var num = r & BITS6;
  var mult = 64;
  var sign = (r & BIT7) > 0 ? -1 : 1;
  if ((r & BIT8) === 0) {
    // don't continue reading
    return sign * num;
  }
  var len = decoder.arr.length;
  while (decoder.pos < len) {
    r = decoder.arr[decoder.pos++];
    // num = num | ((r & binary.BITS7) << len)
    num = num + (r & BITS7) * mult;
    mult *= 128;
    if (r < BIT8) {
      return sign * num;
    }
    /* istanbul ignore if */
    if (num > MAX_SAFE_INTEGER) {
      throw errorIntegerOutOfRange;
    }
  }
  throw errorUnexpectedEndOfArray;
};

/**
 * Look ahead and read varUint without incrementing position
 *
 * @function
 * @param {Decoder} decoder
 * @return {number}
 */
var peekVarUint = function peekVarUint(decoder) {
  var pos = decoder.pos;
  var s = readVarUint(decoder);
  decoder.pos = pos;
  return s;
};

/**
 * Look ahead and read varUint without incrementing position
 *
 * @function
 * @param {Decoder} decoder
 * @return {number}
 */
var peekVarInt = function peekVarInt(decoder) {
  var pos = decoder.pos;
  var s = readVarInt(decoder);
  decoder.pos = pos;
  return s;
};

/**
 * We don't test this function anymore as we use native decoding/encoding by default now.
 * Better not modify this anymore..
 *
 * Transforming utf8 to a string is pretty expensive. The code performs 10x better
 * when String.fromCodePoint is fed with all characters as arguments.
 * But most environments have a maximum number of arguments per functions.
 * For effiency reasons we apply a maximum of 10000 characters at once.
 *
 * @function
 * @param {Decoder} decoder
 * @return {String} The read String.
 */
/* istanbul ignore next */
var _readVarStringPolyfill = function _readVarStringPolyfill(decoder) {
  var remainingLen = readVarUint(decoder);
  if (remainingLen === 0) {
    return '';
  } else {
    var encodedString = String.fromCodePoint(readUint8(decoder)); // remember to decrease remainingLen
    if (--remainingLen < 100) {
      // do not create a Uint8Array for small strings
      while (remainingLen--) {
        encodedString += String.fromCodePoint(readUint8(decoder));
      }
    } else {
      while (remainingLen > 0) {
        var nextLen = remainingLen < 10000 ? remainingLen : 10000;
        // this is dangerous, we create a fresh array view from the existing buffer
        var bytes = decoder.arr.subarray(decoder.pos, decoder.pos + nextLen);
        decoder.pos += nextLen;
        // Starting with ES5.1 we can supply a generic array-like object as arguments
        encodedString += String.fromCodePoint.apply(null, bytes);
        remainingLen -= nextLen;
      }
    }
    return decodeURIComponent(escape(encodedString));
  }
};

/**
 * @function
 * @param {Decoder} decoder
 * @return {String} The read String
 */
var _readVarStringNative = function _readVarStringNative(decoder) {
  return (/** @type any */utf8TextDecoder.decode(readVarUint8Array(decoder))
  );
};

/**
 * Read string of variable length
 * * varUint is used to store the length of the string
 *
 * @function
 * @param {Decoder} decoder
 * @return {String} The read String
 *
 */
/* istanbul ignore next */
var readVarString = utf8TextDecoder ? _readVarStringNative : _readVarStringPolyfill;

/**
 * Look ahead and read varString without incrementing position
 *
 * @function
 * @param {Decoder} decoder
 * @return {string}
 */
var peekVarString = function peekVarString(decoder) {
  var pos = decoder.pos;
  var s = readVarString(decoder);
  decoder.pos = pos;
  return s;
};

/**
 * @param {Decoder} decoder
 * @param {number} len
 * @return {DataView}
 */
var readFromDataView = function readFromDataView(decoder, len) {
  var dv = new DataView(decoder.arr.buffer, decoder.arr.byteOffset + decoder.pos, len);
  decoder.pos += len;
  return dv;
};

/**
 * @param {Decoder} decoder
 */
var readFloat32 = function readFloat32(decoder) {
  return readFromDataView(decoder, 4).getFloat32(0, false);
};

/**
 * @param {Decoder} decoder
 */
var readFloat64 = function readFloat64(decoder) {
  return readFromDataView(decoder, 8).getFloat64(0, false);
};

/**
 * @param {Decoder} decoder
 */
var readBigInt64 = function readBigInt64(decoder) {
  return (/** @type {any} */readFromDataView(decoder, 8).getBigInt64(0, false)
  );
};

/**
 * @param {Decoder} decoder
 */
var readBigUint64 = function readBigUint64(decoder) {
  return (/** @type {any} */readFromDataView(decoder, 8).getBigUint64(0, false)
  );
};

/**
 * @type {Array<function(Decoder):any>}
 */
var readAnyLookupTable = [function (decoder) {
  return undefined;
},
// CASE 127: undefined
function (decoder) {
  return null;
},
// CASE 126: null
readVarInt,
// CASE 125: integer
readFloat32,
// CASE 124: float32
readFloat64,
// CASE 123: float64
readBigInt64,
// CASE 122: bigint
function (decoder) {
  return false;
},
// CASE 121: boolean (false)
function (decoder) {
  return true;
},
// CASE 120: boolean (true)
readVarString,
// CASE 119: string
function (decoder) {
  // CASE 118: object<string,any>
  var len = readVarUint(decoder);
  /**
   * @type {Object<string,any>}
   */
  var obj = {};
  for (var i = 0; i < len; i++) {
    var key = readVarString(decoder);
    obj[key] = readAny(decoder);
  }
  return obj;
}, function (decoder) {
  // CASE 117: array<any>
  var len = readVarUint(decoder);
  var arr = [];
  for (var i = 0; i < len; i++) {
    arr.push(readAny(decoder));
  }
  return arr;
}, readVarUint8Array // CASE 116: Uint8Array
];

/**
 * @param {Decoder} decoder
 */
var readAny = function readAny(decoder) {
  return readAnyLookupTable[127 - readUint8(decoder)](decoder);
};

/**
 * T must not be null.
 *
 * @template T
 */
var RleDecoder = /*#__PURE__*/function (_Decoder) {
  decoding_inherits(RleDecoder, _Decoder);
  var _super = decoding_createSuper(RleDecoder);
  /**
   * @param {Uint8Array} uint8Array
   * @param {function(Decoder):T} reader
   */
  function RleDecoder(uint8Array, reader) {
    var _this;
    decoding_classCallCheck(this, RleDecoder);
    _this = _super.call(this, uint8Array);
    /**
     * The reader
     */
    _this.reader = reader;
    /**
     * Current state
     * @type {T|null}
     */
    _this.s = null;
    _this.count = 0;
    return _this;
  }
  decoding_createClass(RleDecoder, [{
    key: "read",
    value: function read() {
      if (this.count === 0) {
        this.s = this.reader(this);
        if (hasContent(this)) {
          this.count = readVarUint(this) + 1; // see encoder implementation for the reason why this is incremented
        } else {
          this.count = -1; // read the current value forever
        }
      }

      this.count--;
      return this.s;
    }
  }]);
  return RleDecoder;
}(Decoder);
var IntDiffDecoder = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_Decoder2) {
  decoding_inherits(IntDiffDecoder, _Decoder2);
  var _super2 = decoding_createSuper(IntDiffDecoder);
  /**
   * @param {Uint8Array} uint8Array
   * @param {number} start
   */
  function IntDiffDecoder(uint8Array, start) {
    var _this2;
    decoding_classCallCheck(this, IntDiffDecoder);
    _this2 = _super2.call(this, uint8Array);
    /**
     * Current state
     * @type {number}
     */
    _this2.s = start;
    return _this2;
  }

  /**
   * @return {number}
   */
  decoding_createClass(IntDiffDecoder, [{
    key: "read",
    value: function read() {
      this.s += readVarInt(this);
      return this.s;
    }
  }]);
  return IntDiffDecoder;
}(Decoder)));
var RleIntDiffDecoder = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_Decoder3) {
  decoding_inherits(RleIntDiffDecoder, _Decoder3);
  var _super3 = decoding_createSuper(RleIntDiffDecoder);
  /**
   * @param {Uint8Array} uint8Array
   * @param {number} start
   */
  function RleIntDiffDecoder(uint8Array, start) {
    var _this3;
    decoding_classCallCheck(this, RleIntDiffDecoder);
    _this3 = _super3.call(this, uint8Array);
    /**
     * Current state
     * @type {number}
     */
    _this3.s = start;
    _this3.count = 0;
    return _this3;
  }

  /**
   * @return {number}
   */
  decoding_createClass(RleIntDiffDecoder, [{
    key: "read",
    value: function read() {
      if (this.count === 0) {
        this.s += readVarInt(this);
        if (hasContent(this)) {
          this.count = readVarUint(this) + 1; // see encoder implementation for the reason why this is incremented
        } else {
          this.count = -1; // read the current value forever
        }
      }

      this.count--;
      return this.s;
    }
  }]);
  return RleIntDiffDecoder;
}(Decoder)));
var UintOptRleDecoder = /*#__PURE__*/function (_Decoder4) {
  decoding_inherits(UintOptRleDecoder, _Decoder4);
  var _super4 = decoding_createSuper(UintOptRleDecoder);
  /**
   * @param {Uint8Array} uint8Array
   */
  function UintOptRleDecoder(uint8Array) {
    var _this4;
    decoding_classCallCheck(this, UintOptRleDecoder);
    _this4 = _super4.call(this, uint8Array);
    /**
     * @type {number}
     */
    _this4.s = 0;
    _this4.count = 0;
    return _this4;
  }
  decoding_createClass(UintOptRleDecoder, [{
    key: "read",
    value: function read() {
      if (this.count === 0) {
        this.s = readVarInt(this);
        // if the sign is negative, we read the count too, otherwise count is 1
        var isNegative = isNegativeZero(this.s);
        this.count = 1;
        if (isNegative) {
          this.s = -this.s;
          this.count = readVarUint(this) + 2;
        }
      }
      this.count--;
      return this.s;
    }
  }]);
  return UintOptRleDecoder;
}(Decoder);
var IncUintOptRleDecoder = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_Decoder5) {
  decoding_inherits(IncUintOptRleDecoder, _Decoder5);
  var _super5 = decoding_createSuper(IncUintOptRleDecoder);
  /**
   * @param {Uint8Array} uint8Array
   */
  function IncUintOptRleDecoder(uint8Array) {
    var _this5;
    decoding_classCallCheck(this, IncUintOptRleDecoder);
    _this5 = _super5.call(this, uint8Array);
    /**
     * @type {number}
     */
    _this5.s = 0;
    _this5.count = 0;
    return _this5;
  }
  decoding_createClass(IncUintOptRleDecoder, [{
    key: "read",
    value: function read() {
      if (this.count === 0) {
        this.s = readVarInt(this);
        // if the sign is negative, we read the count too, otherwise count is 1
        var isNegative = math.isNegativeZero(this.s);
        this.count = 1;
        if (isNegative) {
          this.s = -this.s;
          this.count = readVarUint(this) + 2;
        }
      }
      this.count--;
      return this.s++;
    }
  }]);
  return IncUintOptRleDecoder;
}(Decoder)));
var IntDiffOptRleDecoder = /*#__PURE__*/function (_Decoder6) {
  decoding_inherits(IntDiffOptRleDecoder, _Decoder6);
  var _super6 = decoding_createSuper(IntDiffOptRleDecoder);
  /**
   * @param {Uint8Array} uint8Array
   */
  function IntDiffOptRleDecoder(uint8Array) {
    var _this6;
    decoding_classCallCheck(this, IntDiffOptRleDecoder);
    _this6 = _super6.call(this, uint8Array);
    /**
     * @type {number}
     */
    _this6.s = 0;
    _this6.count = 0;
    _this6.diff = 0;
    return _this6;
  }

  /**
   * @return {number}
   */
  decoding_createClass(IntDiffOptRleDecoder, [{
    key: "read",
    value: function read() {
      if (this.count === 0) {
        var diff = readVarInt(this);
        // if the first bit is set, we read more data
        var hasCount = diff & 1;
        this.diff = floor(diff / 2); // shift >> 1
        this.count = 1;
        if (hasCount) {
          this.count = readVarUint(this) + 2;
        }
      }
      this.s += this.diff;
      this.count--;
      return this.s;
    }
  }]);
  return IntDiffOptRleDecoder;
}(Decoder);
var StringDecoder = /*#__PURE__*/function () {
  /**
   * @param {Uint8Array} uint8Array
   */
  function StringDecoder(uint8Array) {
    decoding_classCallCheck(this, StringDecoder);
    this.decoder = new UintOptRleDecoder(uint8Array);
    this.str = readVarString(this.decoder);
    /**
     * @type {number}
     */
    this.spos = 0;
  }

  /**
   * @return {string}
   */
  decoding_createClass(StringDecoder, [{
    key: "read",
    value: function read() {
      var end = this.spos + this.decoder.read();
      var res = this.str.slice(this.spos, end);
      this.spos = end;
      return res;
    }
  }]);
  return StringDecoder;
}();
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.uint32-array.js
var es_typed_array_uint32_array = __webpack_require__(29135);
;// CONCATENATED MODULE: ./node_modules/isomorphic.js/browser.mjs
/* eslint-env browser */
const performance = typeof window === 'undefined' ? null : (typeof window.performance !== 'undefined' && window.performance) || null

const isoCrypto = typeof crypto === 'undefined' ? null : crypto

/**
 * @type {function(number):ArrayBuffer}
 */
const browser_cryptoRandomBuffer = isoCrypto !== null
  ? len => {
    // browser
    const buf = new ArrayBuffer(len)
    const arr = new Uint8Array(buf)
    isoCrypto.getRandomValues(arr)
    return buf
  }
  : len => {
    // polyfill
    const buf = new ArrayBuffer(len)
    const arr = new Uint8Array(buf)
    for (let i = 0; i < len; i++) {
      arr[i] = Math.ceil((Math.random() * 0xFFFFFFFF) >>> 0)
    }
    return buf
  }

;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/random.js





























/**
 * Isomorphic module for true random numbers / buffers / uuids.
 *
 * Attention: falls back to Math.random if the browser does not support crypto.
 *
 * @module random
 */




var rand = Math.random;
var uint32 = function uint32() {
  return new Uint32Array(browser_cryptoRandomBuffer(4))[0];
};
var uint53 = function uint53() {
  var arr = new Uint32Array(cryptoRandomBuffer(8));
  return (arr[0] & binary.BITS21) * (binary.BITS32 + 1) + (arr[1] >>> 0);
};

/**
 * @template T
 * @param {Array<T>} arr
 * @return {T}
 */
var oneOf = function oneOf(arr) {
  return arr[math.floor(rand() * arr.length)];
};

// @ts-ignore
var uuidv4Template = [1e7] + -1e3 + -4e3 + -8e3 + -1e11;
var uuidv4 = function uuidv4() {
  return uuidv4Template.replace(/[018]/g, /** @param {number} c */function (c) {
    return (c ^ uint32() & 15 >> c / 4).toString(16);
  });
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.finally.js
var es_promise_finally = __webpack_require__(17727);
;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/promise.js





/**
 * Utility helpers to work with promises.
 *
 * @module promise
 */



/**
 * @template T
 * @callback PromiseResolve
 * @param {T|PromiseLike<T>} [result]
 */

/**
 * @template T
 * @param {function(PromiseResolve<T>,function(Error):void):any} f
 * @return {Promise<T>}
 */
var promise_create = function /** @type {Promise<T>} */ create(f) {
  return new Promise(f);
};

/**
 * @param {function(function():void,function(Error):void):void} f
 * @return {Promise<void>}
 */
var createEmpty = function createEmpty(f) {
  return new Promise(f);
};

/**
 * `Promise.all` wait for all promises in the array to resolve and return the result
 * @template T
 * @param {Array<Promise<T>>} arrp
 * @return {Promise<Array<T>>}
 */
var promise_all = function all(arrp) {
  return Promise.all(arrp);
};

/**
 * @param {Error} [reason]
 * @return {Promise<never>}
 */
var reject = function reject(reason) {
  return Promise.reject(reason);
};

/**
 * @template T
 * @param {T|void} res
 * @return {Promise<T|void>}
 */
var resolve = function resolve(res) {
  return Promise.resolve(res);
};

/**
 * @template T
 * @param {T} res
 * @return {Promise<T>}
 */
var resolveWith = function resolveWith(res) {
  return Promise.resolve(res);
};

/**
 * @todo Next version, reorder parameters: check, [timeout, [intervalResolution]]
 *
 * @param {number} timeout
 * @param {function():boolean} check
 * @param {number} [intervalResolution]
 * @return {Promise<void>}
 */
var until = function until(timeout, check) {
  var intervalResolution = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  return promise_create(function (resolve, reject) {
    var startTime = time.getUnixTime();
    var hasTimeout = timeout > 0;
    var untilInterval = function untilInterval() {
      if (check()) {
        clearInterval(intervalHandle);
        resolve();
      } else if (hasTimeout) {
        /* istanbul ignore else */
        if (time.getUnixTime() - startTime > timeout) {
          clearInterval(intervalHandle);
          reject(new Error('Timeout'));
        }
      }
    };
    var intervalHandle = setInterval(untilInterval, intervalResolution);
  });
};

/**
 * @param {number} timeout
 * @return {Promise<undefined>}
 */
var wait = function wait(timeout) {
  return promise_create(function (resolve, reject) {
    return setTimeout(resolve, timeout);
  });
};

/**
 * Checks if an object is a promise using ducktyping.
 *
 * Promises are often polyfilled, so it makes sense to add some additional guarantees if the user of this
 * library has some insane environment where global Promise objects are overwritten.
 *
 * @param {any} p
 * @return {boolean}
 */
var isPromise = function isPromise(p) {
  return p instanceof Promise || p && p.then && p.catch && p.finally;
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__(24603);
;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/symbol.js
function symbol_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { symbol_typeof = function _typeof(obj) { return typeof obj; }; } else { symbol_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return symbol_typeof(obj); }







/**
 * Utility module to work with EcmaScript Symbols.
 *
 * @module symbol
 */

/**
 * Return fresh symbol.
 *
 * @return {Symbol}
 */
var symbol_create = Symbol;

/**
 * @param {any} s
 * @return {boolean}
 */
var isSymbol = function isSymbol(s) {
  return symbol_typeof(s) === 'symbol';
};
;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/pair.js


function pair_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
/**
 * Working with value pairs.
 *
 * @module pair
 */

/**
 * @template L,R
 */
var Pair =
/**
 * @param {L} left
 * @param {R} right
 */
function Pair(left, right) {
  pair_classCallCheck(this, Pair);
  this.left = left;
  this.right = right;
};

/**
 * @template L,R
 * @param {L} left
 * @param {R} right
 * @return {Pair<L,R>}
 */
var pair_create = function create(left, right) {
  return new Pair(left, right);
};

/**
 * @template L,R
 * @param {R} right
 * @param {L} left
 * @return {Pair<L,R>}
 */
var createReversed = function createReversed(right, left) {
  return new Pair(left, right);
};

/**
 * @template L,R
 * @param {Array<Pair<L,R>>} arr
 * @param {function(L, R):any} f
 */
var forEach = function forEach(arr, f) {
  return arr.forEach(function (p) {
    return f(p.left, p.right);
  });
};

/**
 * @template L,R,X
 * @param {Array<Pair<L,R>>} arr
 * @param {function(L, R):X} f
 * @return {Array<X>}
 */
var pair_map = function map(arr, f) {
  return arr.map(function (p) {
    return f(p.left, p.right);
  });
};
;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/dom.js




/* eslint-env browser */

/**
 * Utility module to work with the DOM.
 *
 * @module dom
 */




/* istanbul ignore next */
/**
 * @type {Document}
 */
var doc = typeof document !== 'undefined' ? document : {};

/**
 * @param {string} name
 * @return {HTMLElement}
 */
/* istanbul ignore next */
var createElement = function createElement(name) {
  return doc.createElement(name);
};

/**
 * @return {DocumentFragment}
 */
/* istanbul ignore next */
var createDocumentFragment = function createDocumentFragment() {
  return doc.createDocumentFragment();
};

/**
 * @param {string} text
 * @return {Text}
 */
/* istanbul ignore next */
var createTextNode = function createTextNode(text) {
  return doc.createTextNode(text);
};

/* istanbul ignore next */
var domParser = typeof DOMParser !== 'undefined' ? new DOMParser() : null;

/**
 * @param {HTMLElement} el
 * @param {string} name
 * @param {Object} opts
 */
/* istanbul ignore next */
var emitCustomEvent = function emitCustomEvent(el, name, opts) {
  return el.dispatchEvent(new CustomEvent(name, opts));
};

/**
 * @param {Element} el
 * @param {Array<pair.Pair<string,string|boolean>>} attrs Array of key-value pairs
 * @return {Element}
 */
/* istanbul ignore next */
var setAttributes = function setAttributes(el, attrs) {
  pair.forEach(attrs, function (key, value) {
    if (value === false) {
      el.removeAttribute(key);
    } else if (value === true) {
      el.setAttribute(key, '');
    } else {
      // @ts-ignore
      el.setAttribute(key, value);
    }
  });
  return el;
};

/**
 * @param {Element} el
 * @param {Map<string, string>} attrs Array of key-value pairs
 * @return {Element}
 */
/* istanbul ignore next */
var setAttributesMap = function setAttributesMap(el, attrs) {
  attrs.forEach(function (value, key) {
    el.setAttribute(key, value);
  });
  return el;
};

/**
 * @param {Array<Node>|HTMLCollection} children
 * @return {DocumentFragment}
 */
/* istanbul ignore next */
var fragment = function fragment(children) {
  var fragment = createDocumentFragment();
  for (var i = 0; i < children.length; i++) {
    appendChild(fragment, children[i]);
  }
  return fragment;
};

/**
 * @param {Element} parent
 * @param {Array<Node>} nodes
 * @return {Element}
 */
/* istanbul ignore next */
var append = function append(parent, nodes) {
  appendChild(parent, fragment(nodes));
  return parent;
};

/**
 * @param {HTMLElement} el
 */
/* istanbul ignore next */
var remove = function remove(el) {
  return el.remove();
};

/**
 * @param {EventTarget} el
 * @param {string} name
 * @param {EventListener} f
 */
/* istanbul ignore next */
var dom_addEventListener = function addEventListener(el, name, f) {
  return el.addEventListener(name, f);
};

/**
 * @param {EventTarget} el
 * @param {string} name
 * @param {EventListener} f
 */
/* istanbul ignore next */
var removeEventListener = function removeEventListener(el, name, f) {
  return el.removeEventListener(name, f);
};

/**
 * @param {Node} node
 * @param {Array<pair.Pair<string,EventListener>>} listeners
 * @return {Node}
 */
/* istanbul ignore next */
var addEventListeners = function addEventListeners(node, listeners) {
  pair.forEach(listeners, function (name, f) {
    return dom_addEventListener(node, name, f);
  });
  return node;
};

/**
 * @param {Node} node
 * @param {Array<pair.Pair<string,EventListener>>} listeners
 * @return {Node}
 */
/* istanbul ignore next */
var removeEventListeners = function removeEventListeners(node, listeners) {
  pair.forEach(listeners, function (name, f) {
    return removeEventListener(node, name, f);
  });
  return node;
};

/**
 * @param {string} name
 * @param {Array<pair.Pair<string,string>|pair.Pair<string,boolean>>} attrs Array of key-value pairs
 * @param {Array<Node>} children
 * @return {Element}
 */
/* istanbul ignore next */
var dom_element = function element(name) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var children = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return append(setAttributes(createElement(name), attrs), children);
};

/**
 * @param {number} width
 * @param {number} height
 */
/* istanbul ignore next */
var canvas = function canvas(width, height) {
  var c = createElement('canvas');
  c.height = height;
  c.width = width;
  return c;
};

/**
 * @param {string} t
 * @return {Text}
 */
/* istanbul ignore next */
var dom_text = (/* unused pure expression or super */ null && (createTextNode));

/**
 * @param {pair.Pair<string,string>} pair
 */
/* istanbul ignore next */
var pairToStyleString = function pairToStyleString(pair) {
  return "".concat(pair.left, ":").concat(pair.right, ";");
};

/**
 * @param {Array<pair.Pair<string,string>>} pairs
 * @return {string}
 */
/* istanbul ignore next */
var pairsToStyleString = function pairsToStyleString(pairs) {
  return pairs.map(pairToStyleString).join('');
};

/**
 * @param {Map<string,string>} m
 * @return {string}
 */
/* istanbul ignore next */
var mapToStyleString = function mapToStyleString(m) {
  return map(m, function (value, key) {
    return "".concat(key, ":").concat(value, ";");
  }).join('');
};

/**
 * @todo should always query on a dom element
 *
 * @param {HTMLElement|ShadowRoot} el
 * @param {string} query
 * @return {HTMLElement | null}
 */
/* istanbul ignore next */
var querySelector = function querySelector(el, query) {
  return el.querySelector(query);
};

/**
 * @param {HTMLElement|ShadowRoot} el
 * @param {string} query
 * @return {NodeListOf<HTMLElement>}
 */
/* istanbul ignore next */
var querySelectorAll = function querySelectorAll(el, query) {
  return el.querySelectorAll(query);
};

/**
 * @param {string} id
 * @return {HTMLElement}
 */
/* istanbul ignore next */
var getElementById = function /** @type {HTMLElement} */ getElementById(id) {
  return doc.getElementById(id);
};

/**
 * @param {string} html
 * @return {HTMLElement}
 */
/* istanbul ignore next */
var _parse = function _parse(html) {
  return domParser.parseFromString("<html><body>".concat(html, "</body></html>"), 'text/html').body;
};

/**
 * @param {string} html
 * @return {DocumentFragment}
 */
/* istanbul ignore next */
var parseFragment = function parseFragment(html) {
  return fragment(_parse(html).childNodes);
};

/**
 * @param {string} html
 * @return {HTMLElement}
 */
/* istanbul ignore next */
var parseElement = function /** @type HTMLElement */ parseElement(html) {
  return _parse(html).firstElementChild;
};

/**
 * @param {HTMLElement} oldEl
 * @param {HTMLElement|DocumentFragment} newEl
 */
/* istanbul ignore next */
var replaceWith = function replaceWith(oldEl, newEl) {
  return oldEl.replaceWith(newEl);
};

/**
 * @param {HTMLElement} parent
 * @param {HTMLElement} el
 * @param {Node|null} ref
 * @return {HTMLElement}
 */
/* istanbul ignore next */
var insertBefore = function insertBefore(parent, el, ref) {
  return parent.insertBefore(el, ref);
};

/**
 * @param {Node} parent
 * @param {Node} child
 * @return {Node}
 */
/* istanbul ignore next */
var appendChild = function appendChild(parent, child) {
  return parent.appendChild(child);
};
var ELEMENT_NODE = doc.ELEMENT_NODE;
var TEXT_NODE = doc.TEXT_NODE;
var CDATA_SECTION_NODE = doc.CDATA_SECTION_NODE;
var COMMENT_NODE = doc.COMMENT_NODE;
var DOCUMENT_NODE = doc.DOCUMENT_NODE;
var DOCUMENT_TYPE_NODE = doc.DOCUMENT_TYPE_NODE;
var DOCUMENT_FRAGMENT_NODE = doc.DOCUMENT_FRAGMENT_NODE;

/**
 * @param {any} node
 * @param {number} type
 */
var checkNodeType = function checkNodeType(node, type) {
  return node.nodeType === type;
};

/**
 * @param {Node} parent
 * @param {HTMLElement} child
 */
var isParentOf = function isParentOf(parent, child) {
  var p = child.parentNode;
  while (p && p !== parent) {
    p = p.parentNode;
  }
  return p === parent;
};
;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/time.js
/**
 * Utility module to work with time.
 *
 * @module time
 */




/**
 * Return current time.
 *
 * @return {Date}
 */
var getDate = function getDate() {
  return new Date();
};

/**
 * Return current unix time.
 *
 * @return {number}
 */
var getUnixTime = Date.now;

/**
 * Transform time (in ms) to a human readable format. E.g. 1100 => 1.1s. 60s => 1min. .001 => 10μs.
 *
 * @param {number} d duration in milliseconds
 * @return {string} humanized approximation of time
 */
var humanizeDuration = function humanizeDuration(d) {
  if (d < 60000) {
    var p = metric.prefix(d, -1);
    return math.round(p.n * 100) / 100 + p.prefix + 's';
  }
  d = math.floor(d / 1000);
  var seconds = d % 60;
  var minutes = math.floor(d / 60) % 60;
  var hours = math.floor(d / 3600) % 24;
  var days = math.floor(d / 86400);
  if (days > 0) {
    return days + 'd' + (hours > 0 || minutes > 30 ? ' ' + (minutes > 30 ? hours + 1 : hours) + 'h' : '');
  }
  if (hours > 0) {
    /* istanbul ignore next */
    return hours + 'h' + (minutes > 0 || seconds > 30 ? ' ' + (seconds > 30 ? minutes + 1 : minutes) + 'min' : '');
  }
  return minutes + 'min' + (seconds > 0 ? ' ' + seconds + 's' : '');
};
;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/logging.js




var _browserStyleMap2, _nodeStyleMap2;
function logging_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { logging_typeof = function _typeof(obj) { return typeof obj; }; } else { logging_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return logging_typeof(obj); }
function logging_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function logging_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function logging_createClass(Constructor, protoProps, staticProps) { if (protoProps) logging_defineProperties(Constructor.prototype, protoProps); if (staticProps) logging_defineProperties(Constructor, staticProps); return Constructor; }
function logging_toConsumableArray(arr) { return logging_arrayWithoutHoles(arr) || logging_iterableToArray(arr) || logging_unsupportedIterableToArray(arr) || logging_nonIterableSpread(); }
function logging_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function logging_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return logging_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return logging_arrayLikeToArray(o, minLen); }
function logging_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function logging_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return logging_arrayLikeToArray(arr); }
function logging_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
















function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/**
 * Isomorphic logging module with support for colors!
 *
 * @module logging
 */











var BOLD = symbol_create();
var UNBOLD = symbol_create();
var BLUE = symbol_create();
var GREY = symbol_create();
var GREEN = symbol_create();
var RED = symbol_create();
var PURPLE = symbol_create();
var ORANGE = symbol_create();
var UNCOLOR = symbol_create();

/**
 * @type {Object<Symbol,pair.Pair<string,string>>}
 */
var _browserStyleMap = (_browserStyleMap2 = {}, _defineProperty(_browserStyleMap2, BOLD, pair_create('font-weight', 'bold')), _defineProperty(_browserStyleMap2, UNBOLD, pair_create('font-weight', 'normal')), _defineProperty(_browserStyleMap2, BLUE, pair_create('color', 'blue')), _defineProperty(_browserStyleMap2, GREEN, pair_create('color', 'green')), _defineProperty(_browserStyleMap2, GREY, pair_create('color', 'grey')), _defineProperty(_browserStyleMap2, RED, pair_create('color', 'red')), _defineProperty(_browserStyleMap2, PURPLE, pair_create('color', 'purple')), _defineProperty(_browserStyleMap2, ORANGE, pair_create('color', 'orange')), _defineProperty(_browserStyleMap2, UNCOLOR, pair_create('color', 'black')), _browserStyleMap2);
var _nodeStyleMap = (_nodeStyleMap2 = {}, _defineProperty(_nodeStyleMap2, BOLD, "\x1B[1m"), _defineProperty(_nodeStyleMap2, UNBOLD, "\x1B[2m"), _defineProperty(_nodeStyleMap2, BLUE, '\x1b[34m'), _defineProperty(_nodeStyleMap2, GREEN, '\x1b[32m'), _defineProperty(_nodeStyleMap2, GREY, "\x1B[37m"), _defineProperty(_nodeStyleMap2, RED, '\x1b[31m'), _defineProperty(_nodeStyleMap2, PURPLE, '\x1b[35m'), _defineProperty(_nodeStyleMap2, ORANGE, '\x1b[38;5;208m'), _defineProperty(_nodeStyleMap2, UNCOLOR, '\x1b[0m'), _nodeStyleMap2);

/* istanbul ignore next */
/**
 * @param {Array<string|Symbol|Object|number>} args
 * @return {Array<string|object|number>}
 */
var computeBrowserLoggingArgs = function computeBrowserLoggingArgs(args) {
  var strBuilder = [];
  var styles = [];
  var currentStyle = create();
  /**
   * @type {Array<string|Object|number>}
   */
  var logArgs = [];
  // try with formatting until we find something unsupported
  var i = 0;
  for (; i < args.length; i++) {
    var arg = args[i];
    // @ts-ignore
    var style = _browserStyleMap[arg];
    if (style !== undefined) {
      currentStyle.set(style.left, style.right);
    } else {
      if (arg.constructor === String || arg.constructor === Number) {
        var _style = mapToStyleString(currentStyle);
        if (i > 0 || _style.length > 0) {
          strBuilder.push('%c' + arg);
          styles.push(_style);
        } else {
          strBuilder.push(arg);
        }
      } else {
        break;
      }
    }
  }
  if (i > 0) {
    // create logArgs with what we have so far
    logArgs = styles;
    logArgs.unshift(strBuilder.join(''));
  }
  // append the rest
  for (; i < args.length; i++) {
    var _arg = args[i];
    if (!(_arg instanceof Symbol)) {
      logArgs.push(_arg);
    }
  }
  return logArgs;
};

/* istanbul ignore next */
/**
 * @param {Array<string|Symbol|Object|number>} args
 * @return {Array<string|object|number>}
 */
var computeNoColorLoggingArgs = function computeNoColorLoggingArgs(args) {
  var strBuilder = [];
  var logArgs = [];

  // try with formatting until we find something unsupported
  var i = 0;
  for (; i < args.length; i++) {
    var arg = args[i];
    // @ts-ignore
    var style = _nodeStyleMap[arg];
    if (style === undefined) {
      if (arg.constructor === String || arg.constructor === Number) {
        strBuilder.push(arg);
      } else {
        break;
      }
    }
  }
  if (i > 0) {
    logArgs.push(strBuilder.join(''));
  }
  // append the rest
  for (; i < args.length; i++) {
    var _arg2 = args[i];
    /* istanbul ignore else */
    if (!(_arg2 instanceof Symbol)) {
      if (_arg2.constructor === Object) {
        logArgs.push(JSON.stringify(_arg2));
      } else {
        logArgs.push(_arg2);
      }
    }
  }
  return logArgs;
};

/* istanbul ignore next */
/**
 * @param {Array<string|Symbol|Object|number>} args
 * @return {Array<string|object|number>}
 */
var computeNodeLoggingArgs = function computeNodeLoggingArgs(args) {
  var strBuilder = [];
  var logArgs = [];

  // try with formatting until we find something unsupported
  var i = 0;
  for (; i < args.length; i++) {
    var arg = args[i];
    // @ts-ignore
    var style = _nodeStyleMap[arg];
    if (style !== undefined) {
      strBuilder.push(style);
    } else {
      if (arg.constructor === String || arg.constructor === Number) {
        strBuilder.push(arg);
      } else {
        break;
      }
    }
  }
  if (i > 0) {
    // create logArgs with what we have so far
    strBuilder.push('\x1b[0m');
    logArgs.push(strBuilder.join(''));
  }
  // append the rest
  for (; i < args.length; i++) {
    var _arg3 = args[i];
    /* istanbul ignore else */
    if (!(_arg3 instanceof Symbol)) {
      logArgs.push(_arg3);
    }
  }
  return logArgs;
};

/* istanbul ignore next */
var computeLoggingArgs = supportsColor ? isNode ? computeNodeLoggingArgs : computeBrowserLoggingArgs : computeNoColorLoggingArgs;

/**
 * @param {Array<string|Symbol|Object|number>} args
 */
var print = function print() {
  var _console;
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  (_console = console).log.apply(_console, logging_toConsumableArray(computeLoggingArgs(args)));
  /* istanbul ignore next */
  vconsoles.forEach(function (vc) {
    return vc.print(args);
  });
};

/* istanbul ignore next */
/**
 * @param {Array<string|Symbol|Object|number>} args
 */
var warn = function warn() {
  var _console2;
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  (_console2 = console).warn.apply(_console2, logging_toConsumableArray(computeLoggingArgs(args)));
  args.unshift(ORANGE);
  vconsoles.forEach(function (vc) {
    return vc.print(args);
  });
};

/* istanbul ignore next */
/**
 * @param {Error} err
 */
var printError = function printError(err) {
  console.error(err);
  vconsoles.forEach(function (vc) {
    return vc.printError(err);
  });
};

/* istanbul ignore next */
/**
 * @param {string} url image location
 * @param {number} height height of the image in pixel
 */
var printImg = function printImg(url, height) {
  if (env.isBrowser) {
    console.log('%c                      ', "font-size: ".concat(height, "px; background-size: contain; background-repeat: no-repeat; background-image: url(").concat(url, ")"));
    // console.log('%c                ', `font-size: ${height}x; background: url(${url}) no-repeat;`)
  }

  vconsoles.forEach(function (vc) {
    return vc.printImg(url, height);
  });
};

/* istanbul ignore next */
/**
 * @param {string} base64
 * @param {number} height
 */
var printImgBase64 = function printImgBase64(base64, height) {
  return printImg("data:image/gif;base64,".concat(base64), height);
};

/**
 * @param {Array<string|Symbol|Object|number>} args
 */
var group = function group() {
  var _console3;
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  (_console3 = console).group.apply(_console3, logging_toConsumableArray(computeLoggingArgs(args)));
  /* istanbul ignore next */
  vconsoles.forEach(function (vc) {
    return vc.group(args);
  });
};

/**
 * @param {Array<string|Symbol|Object|number>} args
 */
var groupCollapsed = function groupCollapsed() {
  var _console4;
  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }
  (_console4 = console).groupCollapsed.apply(_console4, logging_toConsumableArray(computeLoggingArgs(args)));
  /* istanbul ignore next */
  vconsoles.forEach(function (vc) {
    return vc.groupCollapsed(args);
  });
};
var groupEnd = function groupEnd() {
  console.groupEnd();
  /* istanbul ignore next */
  vconsoles.forEach(function (vc) {
    return vc.groupEnd();
  });
};

/* istanbul ignore next */
/**
 * @param {function():Node} createNode
 */
var printDom = function printDom(createNode) {
  return vconsoles.forEach(function (vc) {
    return vc.printDom(createNode());
  });
};

/* istanbul ignore next */
/**
 * @param {HTMLCanvasElement} canvas
 * @param {number} height
 */
var printCanvas = function printCanvas(canvas, height) {
  return printImg(canvas.toDataURL(), height);
};
var vconsoles = new Set();

/* istanbul ignore next */
/**
 * @param {Array<string|Symbol|Object|number>} args
 * @return {Array<Element>}
 */
var _computeLineSpans = function _computeLineSpans(args) {
  var spans = [];
  var currentStyle = new Map();
  // try with formatting until we find something unsupported
  var i = 0;
  for (; i < args.length; i++) {
    var arg = args[i];
    // @ts-ignore
    var style = _browserStyleMap[arg];
    if (style !== undefined) {
      currentStyle.set(style.left, style.right);
    } else {
      if (arg.constructor === String || arg.constructor === Number) {
        // @ts-ignore
        var span = dom.element('span', [pair.create('style', dom.mapToStyleString(currentStyle))], [dom.text(arg.toString())]);
        if (span.innerHTML === '') {
          span.innerHTML = '&nbsp;';
        }
        spans.push(span);
      } else {
        break;
      }
    }
  }
  // append the rest
  for (; i < args.length; i++) {
    var content = args[i];
    if (!(content instanceof Symbol)) {
      if (content.constructor !== String && content.constructor !== Number) {
        content = ' ' + json.stringify(content) + ' ';
      }
      spans.push(dom.element('span', [], [dom.text(content)]));
    }
  }
  return spans;
};
var lineStyle = 'font-family:monospace;border-bottom:1px solid #e2e2e2;padding:2px;';

/* istanbul ignore next */
var VConsole = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  /**
   * @param {Element} dom
   */
  function VConsole(dom) {
    logging_classCallCheck(this, VConsole);
    this.dom = dom;
    /**
     * @type {Element}
     */
    this.ccontainer = this.dom;
    this.depth = 0;
    vconsoles.add(this);
  }

  /**
   * @param {Array<string|Symbol|Object|number>} args
   * @param {boolean} collapsed
   */
  logging_createClass(VConsole, [{
    key: "group",
    value: function group(args) {
      var _this = this;
      var collapsed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      eventloop.enqueue(function () {
        var triangleDown = dom.element('span', [pair.create('hidden', collapsed), pair.create('style', 'color:grey;font-size:120%;')], [dom.text('▼')]);
        var triangleRight = dom.element('span', [pair.create('hidden', !collapsed), pair.create('style', 'color:grey;font-size:125%;')], [dom.text('▶')]);
        var content = dom.element('div', [pair.create('style', "".concat(lineStyle, ";padding-left:").concat(_this.depth * 10, "px"))], [triangleDown, triangleRight, dom.text(' ')].concat(_computeLineSpans(args)));
        var nextContainer = dom.element('div', [pair.create('hidden', collapsed)]);
        var nextLine = dom.element('div', [], [content, nextContainer]);
        dom.append(_this.ccontainer, [nextLine]);
        _this.ccontainer = nextContainer;
        _this.depth++;
        // when header is clicked, collapse/uncollapse container
        dom.addEventListener(content, 'click', function (_event) {
          nextContainer.toggleAttribute('hidden');
          triangleDown.toggleAttribute('hidden');
          triangleRight.toggleAttribute('hidden');
        });
      });
    }

    /**
     * @param {Array<string|Symbol|Object|number>} args
     */
  }, {
    key: "groupCollapsed",
    value: function groupCollapsed(args) {
      this.group(args, true);
    }
  }, {
    key: "groupEnd",
    value: function groupEnd() {
      var _this2 = this;
      eventloop.enqueue(function () {
        if (_this2.depth > 0) {
          _this2.depth--;
          // @ts-ignore
          _this2.ccontainer = _this2.ccontainer.parentElement.parentElement;
        }
      });
    }

    /**
     * @param {Array<string|Symbol|Object|number>} args
     */
  }, {
    key: "print",
    value: function print(args) {
      var _this3 = this;
      eventloop.enqueue(function () {
        dom.append(_this3.ccontainer, [dom.element('div', [pair.create('style', "".concat(lineStyle, ";padding-left:").concat(_this3.depth * 10, "px"))], _computeLineSpans(args))]);
      });
    }

    /**
     * @param {Error} err
     */
  }, {
    key: "printError",
    value: function printError(err) {
      this.print([RED, BOLD, err.toString()]);
    }

    /**
     * @param {string} url
     * @param {number} height
     */
  }, {
    key: "printImg",
    value: function printImg(url, height) {
      var _this4 = this;
      eventloop.enqueue(function () {
        dom.append(_this4.ccontainer, [dom.element('img', [pair.create('src', url), pair.create('height', "".concat(math.round(height * 1.5), "px"))])]);
      });
    }

    /**
     * @param {Node} node
     */
  }, {
    key: "printDom",
    value: function printDom(node) {
      var _this5 = this;
      eventloop.enqueue(function () {
        dom.append(_this5.ccontainer, [node]);
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this6 = this;
      eventloop.enqueue(function () {
        vconsoles.delete(_this6);
      });
    }
  }]);
  return VConsole;
}()));

/* istanbul ignore next */
/**
 * @param {Element} dom
 */
var createVConsole = function createVConsole(dom) {
  return new VConsole(dom);
};
var loggingColors = [GREEN, PURPLE, ORANGE, BLUE];
var nextColor = 0;
var lastLoggingTime = getUnixTime();

/**
 * @param {string} moduleName
 * @return {function(...any):void}
 */
var createModuleLogger = function createModuleLogger(moduleName) {
  var color = loggingColors[nextColor];
  var debugRegexVar = env.getVariable('log');
  var doLogging = debugRegexVar !== null && (debugRegexVar === '*' || debugRegexVar === 'true' || new RegExp(debugRegexVar, 'gi').test(moduleName));
  nextColor = (nextColor + 1) % loggingColors.length;
  moduleName += ': ';
  return !doLogging ? func.nop : function () {
    var timeNow = time.getUnixTime();
    var timeDiff = timeNow - lastLoggingTime;
    lastLoggingTime = timeNow;
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }
    print.apply(void 0, [color, moduleName, UNCOLOR].concat(logging_toConsumableArray(args.map(function (arg) {
      return typeof arg === 'string' || logging_typeof(arg) === 'symbol' ? arg : JSON.stringify(arg);
    })), [color, ' +' + timeDiff + 'ms']));
  };
};
;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/iterator.js
function iterator_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







/**
 * Utility module to create and manipulate Iterators.
 *
 * @module iterator
 */

/**
 * @template T,R
 * @param {Iterator<T>} iterator
 * @param {function(T):R} f
 * @return {IterableIterator<R>}
 */
var mapIterator = function mapIterator(iterator, f) {
  var _ref;
  return _ref = {}, iterator_defineProperty(_ref, Symbol.iterator, function () {
    return this;
  }), iterator_defineProperty(_ref, "next", function next() {
    var r = iterator.next();
    return {
      value: r.done ? undefined : f(r.value),
      done: r.done
    };
  }), _ref;
};

/**
 * @template T
 * @param {function():IteratorResult<T>} next
 * @return {IterableIterator<T>}
 */
var createIterator = function createIterator(next) {
  var _ref2;
  return _ref2 = {}, iterator_defineProperty(_ref2, Symbol.iterator, function () {
    return this;
  }), iterator_defineProperty(_ref2, "next", next), _ref2;
};

/**
 * @template T
 * @param {Iterator<T>} iterator
 * @param {function(T):boolean} filter
 */
var iteratorFilter = function iteratorFilter(iterator, filter) {
  return createIterator(function () {
    var res;
    do {
      res = iterator.next();
    } while (!res.done && !filter(res.value));
    return res;
  });
};

/**
 * @template T,M
 * @param {Iterator<T>} iterator
 * @param {function(T):M} fmap
 */
var iteratorMap = function iteratorMap(iterator, fmap) {
  return createIterator(function () {
    var _iterator$next = iterator.next(),
      done = _iterator$next.done,
      value = _iterator$next.value;
    return {
      done: done,
      value: done ? undefined : fmap(value)
    };
  });
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(19601);
;// CONCATENATED MODULE: ./node_modules/yjs/node_modules/lib0/object.js


/**
 * Utility functions for working with EcmaScript objects.
 *
 * @module object
 */

/**
 * @return {Object<string,any>} obj
 */
var object_create = function create() {
  return Object.create(null);
};

/**
 * Object.assign
 */
var object_assign = Object.assign;

/**
 * @param {Object<string,any>} obj
 */
var keys = Object.keys;

/**
 * @param {Object<string,any>} obj
 * @param {function(any,string):any} f
 */
var object_forEach = function forEach(obj, f) {
  for (var key in obj) {
    f(obj[key], key);
  }
};

/**
 * @template R
 * @param {Object<string,any>} obj
 * @param {function(any,string):R} f
 * @return {Array<R>}
 */
var object_map = function map(obj, f) {
  var results = [];
  for (var key in obj) {
    results.push(f(obj[key], key));
  }
  return results;
};

/**
 * @param {Object<string,any>} obj
 * @return {number}
 */
var object_length = function length(obj) {
  return keys(obj).length;
};

/**
 * @param {Object<string,any>} obj
 * @param {function(any,string):boolean} f
 * @return {boolean}
 */
var object_some = function some(obj, f) {
  for (var key in obj) {
    if (f(obj[key], key)) {
      return true;
    }
  }
  return false;
};

/**
 * @param {Object|undefined} obj
 */
var isEmpty = function isEmpty(obj) {
  for (var _k in obj) {
    return false;
  }
  return true;
};

/**
 * @param {Object<string,any>} obj
 * @param {function(any,string):boolean} f
 * @return {boolean}
 */
var object_every = function every(obj, f) {
  for (var key in obj) {
    if (!f(obj[key], key)) {
      return false;
    }
  }
  return true;
};

/**
 * Calls `Object.prototype.hasOwnProperty`.
 *
 * @param {any} obj
 * @param {string|symbol} key
 * @return {boolean}
 */
var hasProperty = function hasProperty(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
};

/**
 * @param {Object<string,any>} a
 * @param {Object<string,any>} b
 * @return {boolean}
 */
var object_equalFlat = function equalFlat(a, b) {
  return a === b || object_length(a) === object_length(b) && object_every(a, function (val, key) {
    return (val !== undefined || hasProperty(b, key)) && b[key] === val;
  });
};
;// CONCATENATED MODULE: ./node_modules/yjs/dist/yjs.mjs



















/**
 * This is an abstract interface that all Connectors should implement to keep them interchangeable.
 *
 * @note This interface is experimental and it is not advised to actually inherit this class.
 *       It just serves as typing information.
 *
 * @extends {Observable<any>}
 */
class AbstractConnector extends Observable {
  /**
   * @param {Doc} ydoc
   * @param {any} awareness
   */
  constructor (ydoc, awareness) {
    super();
    this.doc = ydoc;
    this.awareness = awareness;
  }
}

class DeleteItem {
  /**
   * @param {number} clock
   * @param {number} len
   */
  constructor (clock, len) {
    /**
     * @type {number}
     */
    this.clock = clock;
    /**
     * @type {number}
     */
    this.len = len;
  }
}

/**
 * We no longer maintain a DeleteStore. DeleteSet is a temporary object that is created when needed.
 * - When created in a transaction, it must only be accessed after sorting, and merging
 *   - This DeleteSet is send to other clients
 * - We do not create a DeleteSet when we send a sync message. The DeleteSet message is created directly from StructStore
 * - We read a DeleteSet as part of a sync/update message. In this case the DeleteSet is already sorted and merged.
 */
class DeleteSet {
  constructor () {
    /**
     * @type {Map<number,Array<DeleteItem>>}
     */
    this.clients = new Map();
  }
}

/**
 * Iterate over all structs that the DeleteSet gc's.
 *
 * @param {Transaction} transaction
 * @param {DeleteSet} ds
 * @param {function(GC|Item):void} f
 *
 * @function
 */
const iterateDeletedStructs = (transaction, ds, f) =>
  ds.clients.forEach((deletes, clientid) => {
    const structs = /** @type {Array<GC|Item>} */ (transaction.doc.store.clients.get(clientid));
    for (let i = 0; i < deletes.length; i++) {
      const del = deletes[i];
      iterateStructs(transaction, structs, del.clock, del.len, f);
    }
  });

/**
 * @param {Array<DeleteItem>} dis
 * @param {number} clock
 * @return {number|null}
 *
 * @private
 * @function
 */
const findIndexDS = (dis, clock) => {
  let left = 0;
  let right = dis.length - 1;
  while (left <= right) {
    const midindex = floor((left + right) / 2);
    const mid = dis[midindex];
    const midclock = mid.clock;
    if (midclock <= clock) {
      if (clock < midclock + mid.len) {
        return midindex
      }
      left = midindex + 1;
    } else {
      right = midindex - 1;
    }
  }
  return null
};

/**
 * @param {DeleteSet} ds
 * @param {ID} id
 * @return {boolean}
 *
 * @private
 * @function
 */
const isDeleted = (ds, id) => {
  const dis = ds.clients.get(id.client);
  return dis !== undefined && findIndexDS(dis, id.clock) !== null
};

/**
 * @param {DeleteSet} ds
 *
 * @private
 * @function
 */
const sortAndMergeDeleteSet = ds => {
  ds.clients.forEach(dels => {
    dels.sort((a, b) => a.clock - b.clock);
    // merge items without filtering or splicing the array
    // i is the current pointer
    // j refers to the current insert position for the pointed item
    // try to merge dels[i] into dels[j-1] or set dels[j]=dels[i]
    let i, j;
    for (i = 1, j = 1; i < dels.length; i++) {
      const left = dels[j - 1];
      const right = dels[i];
      if (left.clock + left.len >= right.clock) {
        left.len = max(left.len, right.clock + right.len - left.clock);
      } else {
        if (j < i) {
          dels[j] = right;
        }
        j++;
      }
    }
    dels.length = j;
  });
};

/**
 * @param {Array<DeleteSet>} dss
 * @return {DeleteSet} A fresh DeleteSet
 */
const mergeDeleteSets = dss => {
  const merged = new DeleteSet();
  for (let dssI = 0; dssI < dss.length; dssI++) {
    dss[dssI].clients.forEach((delsLeft, client) => {
      if (!merged.clients.has(client)) {
        // Write all missing keys from current ds and all following.
        // If merged already contains `client` current ds has already been added.
        /**
         * @type {Array<DeleteItem>}
         */
        const dels = delsLeft.slice();
        for (let i = dssI + 1; i < dss.length; i++) {
          appendTo(dels, dss[i].clients.get(client) || []);
        }
        merged.clients.set(client, dels);
      }
    });
  }
  sortAndMergeDeleteSet(merged);
  return merged
};

/**
 * @param {DeleteSet} ds
 * @param {number} client
 * @param {number} clock
 * @param {number} length
 *
 * @private
 * @function
 */
const addToDeleteSet = (ds, client, clock, length) => {
  setIfUndefined(ds.clients, client, () => []).push(new DeleteItem(clock, length));
};

const createDeleteSet = () => new DeleteSet();

/**
 * @param {StructStore} ss
 * @return {DeleteSet} Merged and sorted DeleteSet
 *
 * @private
 * @function
 */
const createDeleteSetFromStructStore = ss => {
  const ds = createDeleteSet();
  ss.clients.forEach((structs, client) => {
    /**
     * @type {Array<DeleteItem>}
     */
    const dsitems = [];
    for (let i = 0; i < structs.length; i++) {
      const struct = structs[i];
      if (struct.deleted) {
        const clock = struct.id.clock;
        let len = struct.length;
        if (i + 1 < structs.length) {
          for (let next = structs[i + 1]; i + 1 < structs.length && next.deleted; next = structs[++i + 1]) {
            len += next.length;
          }
        }
        dsitems.push(new DeleteItem(clock, len));
      }
    }
    if (dsitems.length > 0) {
      ds.clients.set(client, dsitems);
    }
  });
  return ds
};

/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {DeleteSet} ds
 *
 * @private
 * @function
 */
const writeDeleteSet = (encoder, ds) => {
  writeVarUint(encoder.restEncoder, ds.clients.size);
  ds.clients.forEach((dsitems, client) => {
    encoder.resetDsCurVal();
    writeVarUint(encoder.restEncoder, client);
    const len = dsitems.length;
    writeVarUint(encoder.restEncoder, len);
    for (let i = 0; i < len; i++) {
      const item = dsitems[i];
      encoder.writeDsClock(item.clock);
      encoder.writeDsLen(item.len);
    }
  });
};

/**
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @return {DeleteSet}
 *
 * @private
 * @function
 */
const readDeleteSet = decoder => {
  const ds = new DeleteSet();
  const numClients = readVarUint(decoder.restDecoder);
  for (let i = 0; i < numClients; i++) {
    decoder.resetDsCurVal();
    const client = readVarUint(decoder.restDecoder);
    const numberOfDeletes = readVarUint(decoder.restDecoder);
    if (numberOfDeletes > 0) {
      const dsField = setIfUndefined(ds.clients, client, () => []);
      for (let i = 0; i < numberOfDeletes; i++) {
        dsField.push(new DeleteItem(decoder.readDsClock(), decoder.readDsLen()));
      }
    }
  }
  return ds
};

/**
 * @todo YDecoder also contains references to String and other Decoders. Would make sense to exchange YDecoder.toUint8Array for YDecoder.DsToUint8Array()..
 */

/**
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @return {Uint8Array|null} Returns a v2 update containing all deletes that couldn't be applied yet; or null if all deletes were applied successfully.
 *
 * @private
 * @function
 */
const readAndApplyDeleteSet = (decoder, transaction, store) => {
  const unappliedDS = new DeleteSet();
  const numClients = readVarUint(decoder.restDecoder);
  for (let i = 0; i < numClients; i++) {
    decoder.resetDsCurVal();
    const client = readVarUint(decoder.restDecoder);
    const numberOfDeletes = readVarUint(decoder.restDecoder);
    const structs = store.clients.get(client) || [];
    const state = getState(store, client);
    for (let i = 0; i < numberOfDeletes; i++) {
      const clock = decoder.readDsClock();
      const clockEnd = clock + decoder.readDsLen();
      if (clock < state) {
        if (state < clockEnd) {
          addToDeleteSet(unappliedDS, client, state, clockEnd - state);
        }
        let index = findIndexSS(structs, clock);
        /**
         * We can ignore the case of GC and Delete structs, because we are going to skip them
         * @type {Item}
         */
        // @ts-ignore
        let struct = structs[index];
        // split the first item if necessary
        if (!struct.deleted && struct.id.clock < clock) {
          structs.splice(index + 1, 0, splitItem(transaction, struct, clock - struct.id.clock));
          index++; // increase we now want to use the next struct
        }
        while (index < structs.length) {
          // @ts-ignore
          struct = structs[index++];
          if (struct.id.clock < clockEnd) {
            if (!struct.deleted) {
              if (clockEnd < struct.id.clock + struct.length) {
                structs.splice(index, 0, splitItem(transaction, struct, clockEnd - struct.id.clock));
              }
              struct.delete(transaction);
            }
          } else {
            break
          }
        }
      } else {
        addToDeleteSet(unappliedDS, client, clock, clockEnd - clock);
      }
    }
  }
  if (unappliedDS.clients.size > 0) {
    const ds = new UpdateEncoderV2();
    writeVarUint(ds.restEncoder, 0); // encode 0 structs
    writeDeleteSet(ds, unappliedDS);
    return ds.toUint8Array()
  }
  return null
};

/**
 * @module Y
 */

const generateNewClientId = uint32;

/**
 * @typedef {Object} DocOpts
 * @property {boolean} [DocOpts.gc=true] Disable garbage collection (default: gc=true)
 * @property {function(Item):boolean} [DocOpts.gcFilter] Will be called before an Item is garbage collected. Return false to keep the Item.
 * @property {string} [DocOpts.guid] Define a globally unique identifier for this document
 * @property {string | null} [DocOpts.collectionid] Associate this document with a collection. This only plays a role if your provider has a concept of collection.
 * @property {any} [DocOpts.meta] Any kind of meta information you want to associate with this document. If this is a subdocument, remote peers will store the meta information as well.
 * @property {boolean} [DocOpts.autoLoad] If a subdocument, automatically load document. If this is a subdocument, remote peers will load the document as well automatically.
 * @property {boolean} [DocOpts.shouldLoad] Whether the document should be synced by the provider now. This is toggled to true when you call ydoc.load()
 */

/**
 * A Yjs instance handles the state of shared data.
 * @extends Observable<string>
 */
class Doc extends Observable {
  /**
   * @param {DocOpts} [opts] configuration
   */
  constructor ({ guid = uuidv4(), collectionid = null, gc = true, gcFilter = () => true, meta = null, autoLoad = false, shouldLoad = true } = {}) {
    super();
    this.gc = gc;
    this.gcFilter = gcFilter;
    this.clientID = generateNewClientId();
    this.guid = guid;
    this.collectionid = collectionid;
    /**
     * @type {Map<string, AbstractType<YEvent<any>>>}
     */
    this.share = new Map();
    this.store = new StructStore();
    /**
     * @type {Transaction | null}
     */
    this._transaction = null;
    /**
     * @type {Array<Transaction>}
     */
    this._transactionCleanups = [];
    /**
     * @type {Set<Doc>}
     */
    this.subdocs = new Set();
    /**
     * If this document is a subdocument - a document integrated into another document - then _item is defined.
     * @type {Item?}
     */
    this._item = null;
    this.shouldLoad = shouldLoad;
    this.autoLoad = autoLoad;
    this.meta = meta;
    this.isLoaded = false;
    this.whenLoaded = promise_create(resolve => {
      this.on('load', () => {
        this.isLoaded = true;
        resolve(this);
      });
    });
  }

  /**
   * Notify the parent document that you request to load data into this subdocument (if it is a subdocument).
   *
   * `load()` might be used in the future to request any provider to load the most current data.
   *
   * It is safe to call `load()` multiple times.
   */
  load () {
    const item = this._item;
    if (item !== null && !this.shouldLoad) {
      transact(/** @type {any} */ (item.parent).doc, transaction => {
        transaction.subdocsLoaded.add(this);
      }, null, true);
    }
    this.shouldLoad = true;
  }

  getSubdocs () {
    return this.subdocs
  }

  getSubdocGuids () {
    return new Set(Array.from(this.subdocs).map(doc => doc.guid))
  }

  /**
   * Changes that happen inside of a transaction are bundled. This means that
   * the observer fires _after_ the transaction is finished and that all changes
   * that happened inside of the transaction are sent as one message to the
   * other peers.
   *
   * @param {function(Transaction):void} f The function that should be executed as a transaction
   * @param {any} [origin] Origin of who started the transaction. Will be stored on transaction.origin
   *
   * @public
   */
  transact (f, origin = null) {
    transact(this, f, origin);
  }

  /**
   * Define a shared data type.
   *
   * Multiple calls of `y.get(name, TypeConstructor)` yield the same result
   * and do not overwrite each other. I.e.
   * `y.define(name, Y.Array) === y.define(name, Y.Array)`
   *
   * After this method is called, the type is also available on `y.share.get(name)`.
   *
   * *Best Practices:*
   * Define all types right after the Yjs instance is created and store them in a separate object.
   * Also use the typed methods `getText(name)`, `getArray(name)`, ..
   *
   * @example
   *   const y = new Y(..)
   *   const appState = {
   *     document: y.getText('document')
   *     comments: y.getArray('comments')
   *   }
   *
   * @param {string} name
   * @param {Function} TypeConstructor The constructor of the type definition. E.g. Y.Text, Y.Array, Y.Map, ...
   * @return {AbstractType<any>} The created type. Constructed with TypeConstructor
   *
   * @public
   */
  get (name, TypeConstructor = AbstractType) {
    const type = setIfUndefined(this.share, name, () => {
      // @ts-ignore
      const t = new TypeConstructor();
      t._integrate(this, null);
      return t
    });
    const Constr = type.constructor;
    if (TypeConstructor !== AbstractType && Constr !== TypeConstructor) {
      if (Constr === AbstractType) {
        // @ts-ignore
        const t = new TypeConstructor();
        t._map = type._map;
        type._map.forEach(/** @param {Item?} n */ n => {
          for (; n !== null; n = n.left) {
            // @ts-ignore
            n.parent = t;
          }
        });
        t._start = type._start;
        for (let n = t._start; n !== null; n = n.right) {
          n.parent = t;
        }
        t._length = type._length;
        this.share.set(name, t);
        t._integrate(this, null);
        return t
      } else {
        throw new Error(`Type with the name ${name} has already been defined with a different constructor`)
      }
    }
    return type
  }

  /**
   * @template T
   * @param {string} [name]
   * @return {YArray<T>}
   *
   * @public
   */
  getArray (name = '') {
    // @ts-ignore
    return this.get(name, YArray)
  }

  /**
   * @param {string} [name]
   * @return {YText}
   *
   * @public
   */
  getText (name = '') {
    // @ts-ignore
    return this.get(name, YText)
  }

  /**
   * @template T
   * @param {string} [name]
   * @return {YMap<T>}
   *
   * @public
   */
  getMap (name = '') {
    // @ts-ignore
    return this.get(name, YMap)
  }

  /**
   * @param {string} [name]
   * @return {YXmlFragment}
   *
   * @public
   */
  getXmlFragment (name = '') {
    // @ts-ignore
    return this.get(name, YXmlFragment)
  }

  /**
   * Converts the entire document into a js object, recursively traversing each yjs type
   * Doesn't log types that have not been defined (using ydoc.getType(..)).
   *
   * @deprecated Do not use this method and rather call toJSON directly on the shared types.
   *
   * @return {Object<string, any>}
   */
  toJSON () {
    /**
     * @type {Object<string, any>}
     */
    const doc = {};

    this.share.forEach((value, key) => {
      doc[key] = value.toJSON();
    });

    return doc
  }

  /**
   * Emit `destroy` event and unregister all event handlers.
   */
  destroy () {
    array_from(this.subdocs).forEach(subdoc => subdoc.destroy());
    const item = this._item;
    if (item !== null) {
      this._item = null;
      const content = /** @type {ContentDoc} */ (item.content);
      content.doc = new Doc({ guid: this.guid, ...content.opts, shouldLoad: false });
      content.doc._item = item;
      transact(/** @type {any} */ (item).parent.doc, transaction => {
        const doc = content.doc;
        if (!item.deleted) {
          transaction.subdocsAdded.add(doc);
        }
        transaction.subdocsRemoved.add(this);
      }, null, true);
    }
    this.emit('destroyed', [true]);
    this.emit('destroy', [this]);
    super.destroy();
  }

  /**
   * @param {string} eventName
   * @param {function(...any):any} f
   */
  on (eventName, f) {
    super.on(eventName, f);
  }

  /**
   * @param {string} eventName
   * @param {function} f
   */
  off (eventName, f) {
    super.off(eventName, f);
  }
}

class DSDecoderV1 {
  /**
   * @param {decoding.Decoder} decoder
   */
  constructor (decoder) {
    this.restDecoder = decoder;
  }

  resetDsCurVal () {
    // nop
  }

  /**
   * @return {number}
   */
  readDsClock () {
    return readVarUint(this.restDecoder)
  }

  /**
   * @return {number}
   */
  readDsLen () {
    return readVarUint(this.restDecoder)
  }
}

class UpdateDecoderV1 extends DSDecoderV1 {
  /**
   * @return {ID}
   */
  readLeftID () {
    return createID(readVarUint(this.restDecoder), readVarUint(this.restDecoder))
  }

  /**
   * @return {ID}
   */
  readRightID () {
    return createID(readVarUint(this.restDecoder), readVarUint(this.restDecoder))
  }

  /**
   * Read the next client id.
   * Use this in favor of readID whenever possible to reduce the number of objects created.
   */
  readClient () {
    return readVarUint(this.restDecoder)
  }

  /**
   * @return {number} info An unsigned 8-bit integer
   */
  readInfo () {
    return readUint8(this.restDecoder)
  }

  /**
   * @return {string}
   */
  readString () {
    return readVarString(this.restDecoder)
  }

  /**
   * @return {boolean} isKey
   */
  readParentInfo () {
    return readVarUint(this.restDecoder) === 1
  }

  /**
   * @return {number} info An unsigned 8-bit integer
   */
  readTypeRef () {
    return readVarUint(this.restDecoder)
  }

  /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @return {number} len
   */
  readLen () {
    return readVarUint(this.restDecoder)
  }

  /**
   * @return {any}
   */
  readAny () {
    return readAny(this.restDecoder)
  }

  /**
   * @return {Uint8Array}
   */
  readBuf () {
    return copyUint8Array(readVarUint8Array(this.restDecoder))
  }

  /**
   * Legacy implementation uses JSON parse. We use any-decoding in v2.
   *
   * @return {any}
   */
  readJSON () {
    return JSON.parse(readVarString(this.restDecoder))
  }

  /**
   * @return {string}
   */
  readKey () {
    return readVarString(this.restDecoder)
  }
}

class DSDecoderV2 {
  /**
   * @param {decoding.Decoder} decoder
   */
  constructor (decoder) {
    /**
     * @private
     */
    this.dsCurrVal = 0;
    this.restDecoder = decoder;
  }

  resetDsCurVal () {
    this.dsCurrVal = 0;
  }

  /**
   * @return {number}
   */
  readDsClock () {
    this.dsCurrVal += readVarUint(this.restDecoder);
    return this.dsCurrVal
  }

  /**
   * @return {number}
   */
  readDsLen () {
    const diff = readVarUint(this.restDecoder) + 1;
    this.dsCurrVal += diff;
    return diff
  }
}

class UpdateDecoderV2 extends DSDecoderV2 {
  /**
   * @param {decoding.Decoder} decoder
   */
  constructor (decoder) {
    super(decoder);
    /**
     * List of cached keys. If the keys[id] does not exist, we read a new key
     * from stringEncoder and push it to keys.
     *
     * @type {Array<string>}
     */
    this.keys = [];
    readVarUint(decoder); // read feature flag - currently unused
    this.keyClockDecoder = new IntDiffOptRleDecoder(readVarUint8Array(decoder));
    this.clientDecoder = new UintOptRleDecoder(readVarUint8Array(decoder));
    this.leftClockDecoder = new IntDiffOptRleDecoder(readVarUint8Array(decoder));
    this.rightClockDecoder = new IntDiffOptRleDecoder(readVarUint8Array(decoder));
    this.infoDecoder = new RleDecoder(readVarUint8Array(decoder), readUint8);
    this.stringDecoder = new StringDecoder(readVarUint8Array(decoder));
    this.parentInfoDecoder = new RleDecoder(readVarUint8Array(decoder), readUint8);
    this.typeRefDecoder = new UintOptRleDecoder(readVarUint8Array(decoder));
    this.lenDecoder = new UintOptRleDecoder(readVarUint8Array(decoder));
  }

  /**
   * @return {ID}
   */
  readLeftID () {
    return new ID(this.clientDecoder.read(), this.leftClockDecoder.read())
  }

  /**
   * @return {ID}
   */
  readRightID () {
    return new ID(this.clientDecoder.read(), this.rightClockDecoder.read())
  }

  /**
   * Read the next client id.
   * Use this in favor of readID whenever possible to reduce the number of objects created.
   */
  readClient () {
    return this.clientDecoder.read()
  }

  /**
   * @return {number} info An unsigned 8-bit integer
   */
  readInfo () {
    return /** @type {number} */ (this.infoDecoder.read())
  }

  /**
   * @return {string}
   */
  readString () {
    return this.stringDecoder.read()
  }

  /**
   * @return {boolean}
   */
  readParentInfo () {
    return this.parentInfoDecoder.read() === 1
  }

  /**
   * @return {number} An unsigned 8-bit integer
   */
  readTypeRef () {
    return this.typeRefDecoder.read()
  }

  /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @return {number}
   */
  readLen () {
    return this.lenDecoder.read()
  }

  /**
   * @return {any}
   */
  readAny () {
    return readAny(this.restDecoder)
  }

  /**
   * @return {Uint8Array}
   */
  readBuf () {
    return readVarUint8Array(this.restDecoder)
  }

  /**
   * This is mainly here for legacy purposes.
   *
   * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
   *
   * @return {any}
   */
  readJSON () {
    return readAny(this.restDecoder)
  }

  /**
   * @return {string}
   */
  readKey () {
    const keyClock = this.keyClockDecoder.read();
    if (keyClock < this.keys.length) {
      return this.keys[keyClock]
    } else {
      const key = this.stringDecoder.read();
      this.keys.push(key);
      return key
    }
  }
}

class DSEncoderV1 {
  constructor () {
    this.restEncoder = createEncoder();
  }

  toUint8Array () {
    return _toUint8Array(this.restEncoder)
  }

  resetDsCurVal () {
    // nop
  }

  /**
   * @param {number} clock
   */
  writeDsClock (clock) {
    writeVarUint(this.restEncoder, clock);
  }

  /**
   * @param {number} len
   */
  writeDsLen (len) {
    writeVarUint(this.restEncoder, len);
  }
}

class UpdateEncoderV1 extends DSEncoderV1 {
  /**
   * @param {ID} id
   */
  writeLeftID (id) {
    writeVarUint(this.restEncoder, id.client);
    writeVarUint(this.restEncoder, id.clock);
  }

  /**
   * @param {ID} id
   */
  writeRightID (id) {
    writeVarUint(this.restEncoder, id.client);
    writeVarUint(this.restEncoder, id.clock);
  }

  /**
   * Use writeClient and writeClock instead of writeID if possible.
   * @param {number} client
   */
  writeClient (client) {
    writeVarUint(this.restEncoder, client);
  }

  /**
   * @param {number} info An unsigned 8-bit integer
   */
  writeInfo (info) {
    writeUint8(this.restEncoder, info);
  }

  /**
   * @param {string} s
   */
  writeString (s) {
    writeVarString(this.restEncoder, s);
  }

  /**
   * @param {boolean} isYKey
   */
  writeParentInfo (isYKey) {
    writeVarUint(this.restEncoder, isYKey ? 1 : 0);
  }

  /**
   * @param {number} info An unsigned 8-bit integer
   */
  writeTypeRef (info) {
    writeVarUint(this.restEncoder, info);
  }

  /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @param {number} len
   */
  writeLen (len) {
    writeVarUint(this.restEncoder, len);
  }

  /**
   * @param {any} any
   */
  writeAny (any) {
    writeAny(this.restEncoder, any);
  }

  /**
   * @param {Uint8Array} buf
   */
  writeBuf (buf) {
    writeVarUint8Array(this.restEncoder, buf);
  }

  /**
   * @param {any} embed
   */
  writeJSON (embed) {
    writeVarString(this.restEncoder, JSON.stringify(embed));
  }

  /**
   * @param {string} key
   */
  writeKey (key) {
    writeVarString(this.restEncoder, key);
  }
}

class DSEncoderV2 {
  constructor () {
    this.restEncoder = createEncoder(); // encodes all the rest / non-optimized
    this.dsCurrVal = 0;
  }

  toUint8Array () {
    return _toUint8Array(this.restEncoder)
  }

  resetDsCurVal () {
    this.dsCurrVal = 0;
  }

  /**
   * @param {number} clock
   */
  writeDsClock (clock) {
    const diff = clock - this.dsCurrVal;
    this.dsCurrVal = clock;
    writeVarUint(this.restEncoder, diff);
  }

  /**
   * @param {number} len
   */
  writeDsLen (len) {
    if (len === 0) {
      unexpectedCase();
    }
    writeVarUint(this.restEncoder, len - 1);
    this.dsCurrVal += len;
  }
}

class UpdateEncoderV2 extends DSEncoderV2 {
  constructor () {
    super();
    /**
     * @type {Map<string,number>}
     */
    this.keyMap = new Map();
    /**
     * Refers to the next uniqe key-identifier to me used.
     * See writeKey method for more information.
     *
     * @type {number}
     */
    this.keyClock = 0;
    this.keyClockEncoder = new IntDiffOptRleEncoder();
    this.clientEncoder = new UintOptRleEncoder();
    this.leftClockEncoder = new IntDiffOptRleEncoder();
    this.rightClockEncoder = new IntDiffOptRleEncoder();
    this.infoEncoder = new RleEncoder(writeUint8);
    this.stringEncoder = new StringEncoder();
    this.parentInfoEncoder = new RleEncoder(writeUint8);
    this.typeRefEncoder = new UintOptRleEncoder();
    this.lenEncoder = new UintOptRleEncoder();
  }

  toUint8Array () {
    const encoder = createEncoder();
    writeVarUint(encoder, 0); // this is a feature flag that we might use in the future
    writeVarUint8Array(encoder, this.keyClockEncoder.toUint8Array());
    writeVarUint8Array(encoder, this.clientEncoder.toUint8Array());
    writeVarUint8Array(encoder, this.leftClockEncoder.toUint8Array());
    writeVarUint8Array(encoder, this.rightClockEncoder.toUint8Array());
    writeVarUint8Array(encoder, _toUint8Array(this.infoEncoder));
    writeVarUint8Array(encoder, this.stringEncoder.toUint8Array());
    writeVarUint8Array(encoder, _toUint8Array(this.parentInfoEncoder));
    writeVarUint8Array(encoder, this.typeRefEncoder.toUint8Array());
    writeVarUint8Array(encoder, this.lenEncoder.toUint8Array());
    // @note The rest encoder is appended! (note the missing var)
    writeUint8Array(encoder, _toUint8Array(this.restEncoder));
    return _toUint8Array(encoder)
  }

  /**
   * @param {ID} id
   */
  writeLeftID (id) {
    this.clientEncoder.write(id.client);
    this.leftClockEncoder.write(id.clock);
  }

  /**
   * @param {ID} id
   */
  writeRightID (id) {
    this.clientEncoder.write(id.client);
    this.rightClockEncoder.write(id.clock);
  }

  /**
   * @param {number} client
   */
  writeClient (client) {
    this.clientEncoder.write(client);
  }

  /**
   * @param {number} info An unsigned 8-bit integer
   */
  writeInfo (info) {
    this.infoEncoder.write(info);
  }

  /**
   * @param {string} s
   */
  writeString (s) {
    this.stringEncoder.write(s);
  }

  /**
   * @param {boolean} isYKey
   */
  writeParentInfo (isYKey) {
    this.parentInfoEncoder.write(isYKey ? 1 : 0);
  }

  /**
   * @param {number} info An unsigned 8-bit integer
   */
  writeTypeRef (info) {
    this.typeRefEncoder.write(info);
  }

  /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @param {number} len
   */
  writeLen (len) {
    this.lenEncoder.write(len);
  }

  /**
   * @param {any} any
   */
  writeAny (any) {
    writeAny(this.restEncoder, any);
  }

  /**
   * @param {Uint8Array} buf
   */
  writeBuf (buf) {
    writeVarUint8Array(this.restEncoder, buf);
  }

  /**
   * This is mainly here for legacy purposes.
   *
   * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
   *
   * @param {any} embed
   */
  writeJSON (embed) {
    writeAny(this.restEncoder, embed);
  }

  /**
   * Property keys are often reused. For example, in y-prosemirror the key `bold` might
   * occur very often. For a 3d application, the key `position` might occur very often.
   *
   * We cache these keys in a Map and refer to them via a unique number.
   *
   * @param {string} key
   */
  writeKey (key) {
    const clock = this.keyMap.get(key);
    if (clock === undefined) {
      /**
       * @todo uncomment to introduce this feature finally
       *
       * Background. The ContentFormat object was always encoded using writeKey, but the decoder used to use readString.
       * Furthermore, I forgot to set the keyclock. So everything was working fine.
       *
       * However, this feature here is basically useless as it is not being used (it actually only consumes extra memory).
       *
       * I don't know yet how to reintroduce this feature..
       *
       * Older clients won't be able to read updates when we reintroduce this feature. So this should probably be done using a flag.
       *
       */
      // this.keyMap.set(key, this.keyClock)
      this.keyClockEncoder.write(this.keyClock++);
      this.stringEncoder.write(key);
    } else {
      this.keyClockEncoder.write(clock);
    }
  }
}

/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Array<GC|Item>} structs All structs by `client`
 * @param {number} client
 * @param {number} clock write structs starting with `ID(client,clock)`
 *
 * @function
 */
const writeStructs = (encoder, structs, client, clock) => {
  // write first id
  clock = max(clock, structs[0].id.clock); // make sure the first id exists
  const startNewStructs = findIndexSS(structs, clock);
  // write # encoded structs
  writeVarUint(encoder.restEncoder, structs.length - startNewStructs);
  encoder.writeClient(client);
  writeVarUint(encoder.restEncoder, clock);
  const firstStruct = structs[startNewStructs];
  // write first struct with an offset
  firstStruct.write(encoder, clock - firstStruct.id.clock);
  for (let i = startNewStructs + 1; i < structs.length; i++) {
    structs[i].write(encoder, 0);
  }
};

/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {StructStore} store
 * @param {Map<number,number>} _sm
 *
 * @private
 * @function
 */
const writeClientsStructs = (encoder, store, _sm) => {
  // we filter all valid _sm entries into sm
  const sm = new Map();
  _sm.forEach((clock, client) => {
    // only write if new structs are available
    if (getState(store, client) > clock) {
      sm.set(client, clock);
    }
  });
  getStateVector(store).forEach((clock, client) => {
    if (!_sm.has(client)) {
      sm.set(client, 0);
    }
  });
  // write # states that were updated
  writeVarUint(encoder.restEncoder, sm.size);
  // Write items with higher client ids first
  // This heavily improves the conflict algorithm.
  Array.from(sm.entries()).sort((a, b) => b[0] - a[0]).forEach(([client, clock]) => {
    // @ts-ignore
    writeStructs(encoder, store.clients.get(client), client, clock);
  });
};

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder The decoder object to read data from.
 * @param {Doc} doc
 * @return {Map<number, { i: number, refs: Array<Item | GC> }>}
 *
 * @private
 * @function
 */
const readClientsStructRefs = (decoder, doc) => {
  /**
   * @type {Map<number, { i: number, refs: Array<Item | GC> }>}
   */
  const clientRefs = create();
  const numOfStateUpdates = readVarUint(decoder.restDecoder);
  for (let i = 0; i < numOfStateUpdates; i++) {
    const numberOfStructs = readVarUint(decoder.restDecoder);
    /**
     * @type {Array<GC|Item>}
     */
    const refs = new Array(numberOfStructs);
    const client = decoder.readClient();
    let clock = readVarUint(decoder.restDecoder);
    // const start = performance.now()
    clientRefs.set(client, { i: 0, refs });
    for (let i = 0; i < numberOfStructs; i++) {
      const info = decoder.readInfo();
      switch (BITS5 & info) {
        case 0: { // GC
          const len = decoder.readLen();
          refs[i] = new GC(createID(client, clock), len);
          clock += len;
          break
        }
        case 10: { // Skip Struct (nothing to apply)
          // @todo we could reduce the amount of checks by adding Skip struct to clientRefs so we know that something is missing.
          const len = readVarUint(decoder.restDecoder);
          refs[i] = new Skip(createID(client, clock), len);
          clock += len;
          break
        }
        default: { // Item with content
          /**
           * The optimized implementation doesn't use any variables because inlining variables is faster.
           * Below a non-optimized version is shown that implements the basic algorithm with
           * a few comments
           */
          const cantCopyParentInfo = (info & (BIT7 | BIT8)) === 0;
          // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
          // and we read the next string as parentYKey.
          // It indicates how we store/retrieve parent from `y.share`
          // @type {string|null}
          const struct = new Item(
            createID(client, clock),
            null, // leftd
            (info & BIT8) === BIT8 ? decoder.readLeftID() : null, // origin
            null, // right
            (info & BIT7) === BIT7 ? decoder.readRightID() : null, // right origin
            cantCopyParentInfo ? (decoder.readParentInfo() ? doc.get(decoder.readString()) : decoder.readLeftID()) : null, // parent
            cantCopyParentInfo && (info & BIT6) === BIT6 ? decoder.readString() : null, // parentSub
            readItemContent(decoder, info) // item content
          );
          /* A non-optimized implementation of the above algorithm:

          // The item that was originally to the left of this item.
          const origin = (info & binary.BIT8) === binary.BIT8 ? decoder.readLeftID() : null
          // The item that was originally to the right of this item.
          const rightOrigin = (info & binary.BIT7) === binary.BIT7 ? decoder.readRightID() : null
          const cantCopyParentInfo = (info & (binary.BIT7 | binary.BIT8)) === 0
          const hasParentYKey = cantCopyParentInfo ? decoder.readParentInfo() : false
          // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
          // and we read the next string as parentYKey.
          // It indicates how we store/retrieve parent from `y.share`
          // @type {string|null}
          const parentYKey = cantCopyParentInfo && hasParentYKey ? decoder.readString() : null

          const struct = new Item(
            createID(client, clock),
            null, // leftd
            origin, // origin
            null, // right
            rightOrigin, // right origin
            cantCopyParentInfo && !hasParentYKey ? decoder.readLeftID() : (parentYKey !== null ? doc.get(parentYKey) : null), // parent
            cantCopyParentInfo && (info & binary.BIT6) === binary.BIT6 ? decoder.readString() : null, // parentSub
            readItemContent(decoder, info) // item content
          )
          */
          refs[i] = struct;
          clock += struct.length;
        }
      }
    }
    // console.log('time to read: ', performance.now() - start) // @todo remove
  }
  return clientRefs
};

/**
 * Resume computing structs generated by struct readers.
 *
 * While there is something to do, we integrate structs in this order
 * 1. top element on stack, if stack is not empty
 * 2. next element from current struct reader (if empty, use next struct reader)
 *
 * If struct causally depends on another struct (ref.missing), we put next reader of
 * `ref.id.client` on top of stack.
 *
 * At some point we find a struct that has no causal dependencies,
 * then we start emptying the stack.
 *
 * It is not possible to have circles: i.e. struct1 (from client1) depends on struct2 (from client2)
 * depends on struct3 (from client1). Therefore the max stack size is eqaul to `structReaders.length`.
 *
 * This method is implemented in a way so that we can resume computation if this update
 * causally depends on another update.
 *
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @param {Map<number, { i: number, refs: (GC | Item)[] }>} clientsStructRefs
 * @return { null | { update: Uint8Array, missing: Map<number,number> } }
 *
 * @private
 * @function
 */
const integrateStructs = (transaction, store, clientsStructRefs) => {
  /**
   * @type {Array<Item | GC>}
   */
  const stack = [];
  // sort them so that we take the higher id first, in case of conflicts the lower id will probably not conflict with the id from the higher user.
  let clientsStructRefsIds = Array.from(clientsStructRefs.keys()).sort((a, b) => a - b);
  if (clientsStructRefsIds.length === 0) {
    return null
  }
  const getNextStructTarget = () => {
    if (clientsStructRefsIds.length === 0) {
      return null
    }
    let nextStructsTarget = /** @type {{i:number,refs:Array<GC|Item>}} */ (clientsStructRefs.get(clientsStructRefsIds[clientsStructRefsIds.length - 1]));
    while (nextStructsTarget.refs.length === nextStructsTarget.i) {
      clientsStructRefsIds.pop();
      if (clientsStructRefsIds.length > 0) {
        nextStructsTarget = /** @type {{i:number,refs:Array<GC|Item>}} */ (clientsStructRefs.get(clientsStructRefsIds[clientsStructRefsIds.length - 1]));
      } else {
        return null
      }
    }
    return nextStructsTarget
  };
  let curStructsTarget = getNextStructTarget();
  if (curStructsTarget === null && stack.length === 0) {
    return null
  }

  /**
   * @type {StructStore}
   */
  const restStructs = new StructStore();
  const missingSV = new Map();
  /**
   * @param {number} client
   * @param {number} clock
   */
  const updateMissingSv = (client, clock) => {
    const mclock = missingSV.get(client);
    if (mclock == null || mclock > clock) {
      missingSV.set(client, clock);
    }
  };
  /**
   * @type {GC|Item}
   */
  let stackHead = /** @type {any} */ (curStructsTarget).refs[/** @type {any} */ (curStructsTarget).i++];
  // caching the state because it is used very often
  const state = new Map();

  const addStackToRestSS = () => {
    for (const item of stack) {
      const client = item.id.client;
      const unapplicableItems = clientsStructRefs.get(client);
      if (unapplicableItems) {
        // decrement because we weren't able to apply previous operation
        unapplicableItems.i--;
        restStructs.clients.set(client, unapplicableItems.refs.slice(unapplicableItems.i));
        clientsStructRefs.delete(client);
        unapplicableItems.i = 0;
        unapplicableItems.refs = [];
      } else {
        // item was the last item on clientsStructRefs and the field was already cleared. Add item to restStructs and continue
        restStructs.clients.set(client, [item]);
      }
      // remove client from clientsStructRefsIds to prevent users from applying the same update again
      clientsStructRefsIds = clientsStructRefsIds.filter(c => c !== client);
    }
    stack.length = 0;
  };

  // iterate over all struct readers until we are done
  while (true) {
    if (stackHead.constructor !== Skip) {
      const localClock = setIfUndefined(state, stackHead.id.client, () => getState(store, stackHead.id.client));
      const offset = localClock - stackHead.id.clock;
      if (offset < 0) {
        // update from the same client is missing
        stack.push(stackHead);
        updateMissingSv(stackHead.id.client, stackHead.id.clock - 1);
        // hid a dead wall, add all items from stack to restSS
        addStackToRestSS();
      } else {
        const missing = stackHead.getMissing(transaction, store);
        if (missing !== null) {
          stack.push(stackHead);
          // get the struct reader that has the missing struct
          /**
           * @type {{ refs: Array<GC|Item>, i: number }}
           */
          const structRefs = clientsStructRefs.get(/** @type {number} */ (missing)) || { refs: [], i: 0 };
          if (structRefs.refs.length === structRefs.i) {
            // This update message causally depends on another update message that doesn't exist yet
            updateMissingSv(/** @type {number} */ (missing), getState(store, missing));
            addStackToRestSS();
          } else {
            stackHead = structRefs.refs[structRefs.i++];
            continue
          }
        } else if (offset === 0 || offset < stackHead.length) {
          // all fine, apply the stackhead
          stackHead.integrate(transaction, offset);
          state.set(stackHead.id.client, stackHead.id.clock + stackHead.length);
        }
      }
    }
    // iterate to next stackHead
    if (stack.length > 0) {
      stackHead = /** @type {GC|Item} */ (stack.pop());
    } else if (curStructsTarget !== null && curStructsTarget.i < curStructsTarget.refs.length) {
      stackHead = /** @type {GC|Item} */ (curStructsTarget.refs[curStructsTarget.i++]);
    } else {
      curStructsTarget = getNextStructTarget();
      if (curStructsTarget === null) {
        // we are done!
        break
      } else {
        stackHead = /** @type {GC|Item} */ (curStructsTarget.refs[curStructsTarget.i++]);
      }
    }
  }
  if (restStructs.clients.size > 0) {
    const encoder = new UpdateEncoderV2();
    writeClientsStructs(encoder, restStructs, new Map());
    // write empty deleteset
    // writeDeleteSet(encoder, new DeleteSet())
    writeVarUint(encoder.restEncoder, 0); // => no need for an extra function call, just write 0 deletes
    return { missing: missingSV, update: encoder.toUint8Array() }
  }
  return null
};

/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Transaction} transaction
 *
 * @private
 * @function
 */
const writeStructsFromTransaction = (encoder, transaction) => writeClientsStructs(encoder, transaction.doc.store, transaction.beforeState);

/**
 * Read and apply a document update.
 *
 * This function has the same effect as `applyUpdate` but accepts an decoder.
 *
 * @param {decoding.Decoder} decoder
 * @param {Doc} ydoc
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 * @param {UpdateDecoderV1 | UpdateDecoderV2} [structDecoder]
 *
 * @function
 */
const readUpdateV2 = (decoder, ydoc, transactionOrigin, structDecoder = new UpdateDecoderV2(decoder)) =>
  transact(ydoc, transaction => {
    // force that transaction.local is set to non-local
    transaction.local = false;
    let retry = false;
    const doc = transaction.doc;
    const store = doc.store;
    // let start = performance.now()
    const ss = readClientsStructRefs(structDecoder, doc);
    // console.log('time to read structs: ', performance.now() - start) // @todo remove
    // start = performance.now()
    // console.log('time to merge: ', performance.now() - start) // @todo remove
    // start = performance.now()
    const restStructs = integrateStructs(transaction, store, ss);
    const pending = store.pendingStructs;
    if (pending) {
      // check if we can apply something
      for (const [client, clock] of pending.missing) {
        if (clock < getState(store, client)) {
          retry = true;
          break
        }
      }
      if (restStructs) {
        // merge restStructs into store.pending
        for (const [client, clock] of restStructs.missing) {
          const mclock = pending.missing.get(client);
          if (mclock == null || mclock > clock) {
            pending.missing.set(client, clock);
          }
        }
        pending.update = mergeUpdatesV2([pending.update, restStructs.update]);
      }
    } else {
      store.pendingStructs = restStructs;
    }
    // console.log('time to integrate: ', performance.now() - start) // @todo remove
    // start = performance.now()
    const dsRest = readAndApplyDeleteSet(structDecoder, transaction, store);
    if (store.pendingDs) {
      // @todo we could make a lower-bound state-vector check as we do above
      const pendingDSUpdate = new UpdateDecoderV2(createDecoder(store.pendingDs));
      readVarUint(pendingDSUpdate.restDecoder); // read 0 structs, because we only encode deletes in pendingdsupdate
      const dsRest2 = readAndApplyDeleteSet(pendingDSUpdate, transaction, store);
      if (dsRest && dsRest2) {
        // case 1: ds1 != null && ds2 != null
        store.pendingDs = mergeUpdatesV2([dsRest, dsRest2]);
      } else {
        // case 2: ds1 != null
        // case 3: ds2 != null
        // case 4: ds1 == null && ds2 == null
        store.pendingDs = dsRest || dsRest2;
      }
    } else {
      // Either dsRest == null && pendingDs == null OR dsRest != null
      store.pendingDs = dsRest;
    }
    // console.log('time to cleanup: ', performance.now() - start) // @todo remove
    // start = performance.now()

    // console.log('time to resume delete readers: ', performance.now() - start) // @todo remove
    // start = performance.now()
    if (retry) {
      const update = /** @type {{update: Uint8Array}} */ (store.pendingStructs).update;
      store.pendingStructs = null;
      applyUpdateV2(transaction.doc, update);
    }
  }, transactionOrigin, false);

/**
 * Read and apply a document update.
 *
 * This function has the same effect as `applyUpdate` but accepts an decoder.
 *
 * @param {decoding.Decoder} decoder
 * @param {Doc} ydoc
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 *
 * @function
 */
const readUpdate = (decoder, ydoc, transactionOrigin) => readUpdateV2(decoder, ydoc, transactionOrigin, new UpdateDecoderV1(decoder));

/**
 * Apply a document update created by, for example, `y.on('update', update => ..)` or `update = encodeStateAsUpdate()`.
 *
 * This function has the same effect as `readUpdate` but accepts an Uint8Array instead of a Decoder.
 *
 * @param {Doc} ydoc
 * @param {Uint8Array} update
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 *
 * @function
 */
const applyUpdateV2 = (ydoc, update, transactionOrigin, YDecoder = UpdateDecoderV2) => {
  const decoder = createDecoder(update);
  readUpdateV2(decoder, ydoc, transactionOrigin, new YDecoder(decoder));
};

/**
 * Apply a document update created by, for example, `y.on('update', update => ..)` or `update = encodeStateAsUpdate()`.
 *
 * This function has the same effect as `readUpdate` but accepts an Uint8Array instead of a Decoder.
 *
 * @param {Doc} ydoc
 * @param {Uint8Array} update
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 *
 * @function
 */
const applyUpdate = (ydoc, update, transactionOrigin) => applyUpdateV2(ydoc, update, transactionOrigin, UpdateDecoderV1);

/**
 * Write all the document as a single update message. If you specify the state of the remote client (`targetStateVector`) it will
 * only write the operations that are missing.
 *
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Doc} doc
 * @param {Map<number,number>} [targetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 *
 * @function
 */
const writeStateAsUpdate = (encoder, doc, targetStateVector = new Map()) => {
  writeClientsStructs(encoder, doc.store, targetStateVector);
  writeDeleteSet(encoder, createDeleteSetFromStructStore(doc.store));
};

/**
 * Write all the document as a single update message that can be applied on the remote document. If you specify the state of the remote client (`targetState`) it will
 * only write the operations that are missing.
 *
 * Use `writeStateAsUpdate` instead if you are working with lib0/encoding.js#Encoder
 *
 * @param {Doc} doc
 * @param {Uint8Array} [encodedTargetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 * @param {UpdateEncoderV1 | UpdateEncoderV2} [encoder]
 * @return {Uint8Array}
 *
 * @function
 */
const encodeStateAsUpdateV2 = (doc, encodedTargetStateVector = new Uint8Array([0]), encoder = new UpdateEncoderV2()) => {
  const targetStateVector = decodeStateVector(encodedTargetStateVector);
  writeStateAsUpdate(encoder, doc, targetStateVector);
  const updates = [encoder.toUint8Array()];
  // also add the pending updates (if there are any)
  if (doc.store.pendingDs) {
    updates.push(doc.store.pendingDs);
  }
  if (doc.store.pendingStructs) {
    updates.push(diffUpdateV2(doc.store.pendingStructs.update, encodedTargetStateVector));
  }
  if (updates.length > 1) {
    if (encoder.constructor === UpdateEncoderV1) {
      return mergeUpdates(updates.map((update, i) => i === 0 ? update : convertUpdateFormatV2ToV1(update)))
    } else if (encoder.constructor === UpdateEncoderV2) {
      return mergeUpdatesV2(updates)
    }
  }
  return updates[0]
};

/**
 * Write all the document as a single update message that can be applied on the remote document. If you specify the state of the remote client (`targetState`) it will
 * only write the operations that are missing.
 *
 * Use `writeStateAsUpdate` instead if you are working with lib0/encoding.js#Encoder
 *
 * @param {Doc} doc
 * @param {Uint8Array} [encodedTargetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 * @return {Uint8Array}
 *
 * @function
 */
const encodeStateAsUpdate = (doc, encodedTargetStateVector) => encodeStateAsUpdateV2(doc, encodedTargetStateVector, new UpdateEncoderV1());

/**
 * Read state vector from Decoder and return as Map
 *
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */
const readStateVector = decoder => {
  const ss = new Map();
  const ssLength = readVarUint(decoder.restDecoder);
  for (let i = 0; i < ssLength; i++) {
    const client = readVarUint(decoder.restDecoder);
    const clock = readVarUint(decoder.restDecoder);
    ss.set(client, clock);
  }
  return ss
};

/**
 * Read decodedState and return State as Map.
 *
 * @param {Uint8Array} decodedState
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */
// export const decodeStateVectorV2 = decodedState => readStateVector(new DSDecoderV2(decoding.createDecoder(decodedState)))

/**
 * Read decodedState and return State as Map.
 *
 * @param {Uint8Array} decodedState
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */
const decodeStateVector = decodedState => readStateVector(new DSDecoderV1(createDecoder(decodedState)));

/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {Map<number,number>} sv
 * @function
 */
const writeStateVector = (encoder, sv) => {
  writeVarUint(encoder.restEncoder, sv.size);
  Array.from(sv.entries()).sort((a, b) => b[0] - a[0]).forEach(([client, clock]) => {
    writeVarUint(encoder.restEncoder, client); // @todo use a special client decoder that is based on mapping
    writeVarUint(encoder.restEncoder, clock);
  });
  return encoder
};

/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {Doc} doc
 *
 * @function
 */
const writeDocumentStateVector = (encoder, doc) => writeStateVector(encoder, getStateVector(doc.store));

/**
 * Encode State as Uint8Array.
 *
 * @param {Doc|Map<number,number>} doc
 * @param {DSEncoderV1 | DSEncoderV2} [encoder]
 * @return {Uint8Array}
 *
 * @function
 */
const encodeStateVectorV2 = (doc, encoder = new DSEncoderV2()) => {
  if (doc instanceof Map) {
    writeStateVector(encoder, doc);
  } else {
    writeDocumentStateVector(encoder, doc);
  }
  return encoder.toUint8Array()
};

/**
 * Encode State as Uint8Array.
 *
 * @param {Doc|Map<number,number>} doc
 * @return {Uint8Array}
 *
 * @function
 */
const encodeStateVector = doc => encodeStateVectorV2(doc, new DSEncoderV1());

/**
 * General event handler implementation.
 *
 * @template ARG0, ARG1
 *
 * @private
 */
class EventHandler {
  constructor () {
    /**
     * @type {Array<function(ARG0, ARG1):void>}
     */
    this.l = [];
  }
}

/**
 * @template ARG0,ARG1
 * @returns {EventHandler<ARG0,ARG1>}
 *
 * @private
 * @function
 */
const createEventHandler = () => new EventHandler();

/**
 * Adds an event listener that is called when
 * {@link EventHandler#callEventListeners} is called.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {function(ARG0,ARG1):void} f The event handler.
 *
 * @private
 * @function
 */
const addEventHandlerListener = (eventHandler, f) =>
  eventHandler.l.push(f);

/**
 * Removes an event listener.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {function(ARG0,ARG1):void} f The event handler that was added with
 *                     {@link EventHandler#addEventListener}
 *
 * @private
 * @function
 */
const removeEventHandlerListener = (eventHandler, f) => {
  const l = eventHandler.l;
  const len = l.length;
  eventHandler.l = l.filter(g => f !== g);
  if (len === eventHandler.l.length) {
    console.error('[yjs] Tried to remove event handler that doesn\'t exist.');
  }
};

/**
 * Call all event listeners that were added via
 * {@link EventHandler#addEventListener}.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {ARG0} arg0
 * @param {ARG1} arg1
 *
 * @private
 * @function
 */
const callEventHandlerListeners = (eventHandler, arg0, arg1) =>
  callAll(eventHandler.l, [arg0, arg1]);

class ID {
  /**
   * @param {number} client client id
   * @param {number} clock unique per client id, continuous number
   */
  constructor (client, clock) {
    /**
     * Client id
     * @type {number}
     */
    this.client = client;
    /**
     * unique per client id, continuous number
     * @type {number}
     */
    this.clock = clock;
  }
}

/**
 * @param {ID | null} a
 * @param {ID | null} b
 * @return {boolean}
 *
 * @function
 */
const compareIDs = (a, b) => a === b || (a !== null && b !== null && a.client === b.client && a.clock === b.clock);

/**
 * @param {number} client
 * @param {number} clock
 *
 * @private
 * @function
 */
const createID = (client, clock) => new ID(client, clock);

/**
 * @param {encoding.Encoder} encoder
 * @param {ID} id
 *
 * @private
 * @function
 */
const writeID = (encoder, id) => {
  writeVarUint(encoder, id.client);
  writeVarUint(encoder, id.clock);
};

/**
 * Read ID.
 * * If first varUint read is 0xFFFFFF a RootID is returned.
 * * Otherwise an ID is returned
 *
 * @param {decoding.Decoder} decoder
 * @return {ID}
 *
 * @private
 * @function
 */
const readID = decoder =>
  createID(readVarUint(decoder), readVarUint(decoder));

/**
 * The top types are mapped from y.share.get(keyname) => type.
 * `type` does not store any information about the `keyname`.
 * This function finds the correct `keyname` for `type` and throws otherwise.
 *
 * @param {AbstractType<any>} type
 * @return {string}
 *
 * @private
 * @function
 */
const findRootTypeKey = type => {
  // @ts-ignore _y must be defined, otherwise unexpected case
  for (const [key, value] of type.doc.share.entries()) {
    if (value === type) {
      return key
    }
  }
  throw unexpectedCase()
};

/**
 * Check if `parent` is a parent of `child`.
 *
 * @param {AbstractType<any>} parent
 * @param {Item|null} child
 * @return {Boolean} Whether `parent` is a parent of `child`.
 *
 * @private
 * @function
 */
const yjs_isParentOf = (parent, child) => {
  while (child !== null) {
    if (child.parent === parent) {
      return true
    }
    child = /** @type {AbstractType<any>} */ (child.parent)._item;
  }
  return false
};

/**
 * Convenient helper to log type information.
 *
 * Do not use in productive systems as the output can be immense!
 *
 * @param {AbstractType<any>} type
 */
const logType = type => {
  const res = [];
  let n = type._start;
  while (n) {
    res.push(n);
    n = n.right;
  }
  console.log('Children: ', res);
  console.log('Children content: ', res.filter(m => !m.deleted).map(m => m.content));
};

class PermanentUserData {
  /**
   * @param {Doc} doc
   * @param {YMap<any>} [storeType]
   */
  constructor (doc, storeType = doc.getMap('users')) {
    /**
     * @type {Map<string,DeleteSet>}
     */
    const dss = new Map();
    this.yusers = storeType;
    this.doc = doc;
    /**
     * Maps from clientid to userDescription
     *
     * @type {Map<number,string>}
     */
    this.clients = new Map();
    this.dss = dss;
    /**
     * @param {YMap<any>} user
     * @param {string} userDescription
     */
    const initUser = (user, userDescription) => {
      /**
       * @type {YArray<Uint8Array>}
       */
      const ds = user.get('ds');
      const ids = user.get('ids');
      const addClientId = /** @param {number} clientid */ clientid => this.clients.set(clientid, userDescription);
      ds.observe(/** @param {YArrayEvent<any>} event */ event => {
        event.changes.added.forEach(item => {
          item.content.getContent().forEach(encodedDs => {
            if (encodedDs instanceof Uint8Array) {
              this.dss.set(userDescription, mergeDeleteSets([this.dss.get(userDescription) || createDeleteSet(), readDeleteSet(new DSDecoderV1(createDecoder(encodedDs)))]));
            }
          });
        });
      });
      this.dss.set(userDescription, mergeDeleteSets(ds.map(encodedDs => readDeleteSet(new DSDecoderV1(createDecoder(encodedDs))))));
      ids.observe(/** @param {YArrayEvent<any>} event */ event =>
        event.changes.added.forEach(item => item.content.getContent().forEach(addClientId))
      );
      ids.forEach(addClientId);
    };
    // observe users
    storeType.observe(event => {
      event.keysChanged.forEach(userDescription =>
        initUser(storeType.get(userDescription), userDescription)
      );
    });
    // add intial data
    storeType.forEach(initUser);
  }

  /**
   * @param {Doc} doc
   * @param {number} clientid
   * @param {string} userDescription
   * @param {Object} [conf]
   * @param {function(Transaction, DeleteSet):boolean} [conf.filter]
   */
  setUserMapping (doc, clientid, userDescription, { filter = () => true } = {}) {
    const users = this.yusers;
    let user = users.get(userDescription);
    if (!user) {
      user = new YMap();
      user.set('ids', new YArray());
      user.set('ds', new YArray());
      users.set(userDescription, user);
    }
    user.get('ids').push([clientid]);
    users.observe(event => {
      setTimeout(() => {
        const userOverwrite = users.get(userDescription);
        if (userOverwrite !== user) {
          // user was overwritten, port all data over to the next user object
          // @todo Experiment with Y.Sets here
          user = userOverwrite;
          // @todo iterate over old type
          this.clients.forEach((_userDescription, clientid) => {
            if (userDescription === _userDescription) {
              user.get('ids').push([clientid]);
            }
          });
          const encoder = new DSEncoderV1();
          const ds = this.dss.get(userDescription);
          if (ds) {
            writeDeleteSet(encoder, ds);
            user.get('ds').push([encoder.toUint8Array()]);
          }
        }
      }, 0);
    });
    doc.on('afterTransaction', /** @param {Transaction} transaction */ transaction => {
      setTimeout(() => {
        const yds = user.get('ds');
        const ds = transaction.deleteSet;
        if (transaction.local && ds.clients.size > 0 && filter(transaction, ds)) {
          const encoder = new DSEncoderV1();
          writeDeleteSet(encoder, ds);
          yds.push([encoder.toUint8Array()]);
        }
      });
    });
  }

  /**
   * @param {number} clientid
   * @return {any}
   */
  getUserByClientId (clientid) {
    return this.clients.get(clientid) || null
  }

  /**
   * @param {ID} id
   * @return {string | null}
   */
  getUserByDeletedId (id) {
    for (const [userDescription, ds] of this.dss.entries()) {
      if (isDeleted(ds, id)) {
        return userDescription
      }
    }
    return null
  }
}

/**
 * A relative position is based on the Yjs model and is not affected by document changes.
 * E.g. If you place a relative position before a certain character, it will always point to this character.
 * If you place a relative position at the end of a type, it will always point to the end of the type.
 *
 * A numeric position is often unsuited for user selections, because it does not change when content is inserted
 * before or after.
 *
 * ```Insert(0, 'x')('a|bc') = 'xa|bc'``` Where | is the relative position.
 *
 * One of the properties must be defined.
 *
 * @example
 *   // Current cursor position is at position 10
 *   const relativePosition = createRelativePositionFromIndex(yText, 10)
 *   // modify yText
 *   yText.insert(0, 'abc')
 *   yText.delete(3, 10)
 *   // Compute the cursor position
 *   const absolutePosition = createAbsolutePositionFromRelativePosition(y, relativePosition)
 *   absolutePosition.type === yText // => true
 *   console.log('cursor location is ' + absolutePosition.index) // => cursor location is 3
 *
 */
class RelativePosition {
  /**
   * @param {ID|null} type
   * @param {string|null} tname
   * @param {ID|null} item
   * @param {number} assoc
   */
  constructor (type, tname, item, assoc = 0) {
    /**
     * @type {ID|null}
     */
    this.type = type;
    /**
     * @type {string|null}
     */
    this.tname = tname;
    /**
     * @type {ID | null}
     */
    this.item = item;
    /**
     * A relative position is associated to a specific character. By default
     * assoc >= 0, the relative position is associated to the character
     * after the meant position.
     * I.e. position 1 in 'ab' is associated to character 'b'.
     *
     * If assoc < 0, then the relative position is associated to the caharacter
     * before the meant position.
     *
     * @type {number}
     */
    this.assoc = assoc;
  }
}

/**
 * @param {RelativePosition} rpos
 * @return {any}
 */
const relativePositionToJSON = rpos => {
  const json = {};
  if (rpos.type) {
    json.type = rpos.type;
  }
  if (rpos.tname) {
    json.tname = rpos.tname;
  }
  if (rpos.item) {
    json.item = rpos.item;
  }
  if (rpos.assoc != null) {
    json.assoc = rpos.assoc;
  }
  return json
};

/**
 * @param {any} json
 * @return {RelativePosition}
 *
 * @function
 */
const createRelativePositionFromJSON = json => new RelativePosition(json.type == null ? null : createID(json.type.client, json.type.clock), json.tname || null, json.item == null ? null : createID(json.item.client, json.item.clock), json.assoc == null ? 0 : json.assoc);

class AbsolutePosition {
  /**
   * @param {AbstractType<any>} type
   * @param {number} index
   * @param {number} [assoc]
   */
  constructor (type, index, assoc = 0) {
    /**
     * @type {AbstractType<any>}
     */
    this.type = type;
    /**
     * @type {number}
     */
    this.index = index;
    this.assoc = assoc;
  }
}

/**
 * @param {AbstractType<any>} type
 * @param {number} index
 * @param {number} [assoc]
 *
 * @function
 */
const createAbsolutePosition = (type, index, assoc = 0) => new AbsolutePosition(type, index, assoc);

/**
 * @param {AbstractType<any>} type
 * @param {ID|null} item
 * @param {number} [assoc]
 *
 * @function
 */
const createRelativePosition = (type, item, assoc) => {
  let typeid = null;
  let tname = null;
  if (type._item === null) {
    tname = findRootTypeKey(type);
  } else {
    typeid = createID(type._item.id.client, type._item.id.clock);
  }
  return new RelativePosition(typeid, tname, item, assoc)
};

/**
 * Create a relativePosition based on a absolute position.
 *
 * @param {AbstractType<any>} type The base type (e.g. YText or YArray).
 * @param {number} index The absolute position.
 * @param {number} [assoc]
 * @return {RelativePosition}
 *
 * @function
 */
const createRelativePositionFromTypeIndex = (type, index, assoc = 0) => {
  let t = type._start;
  if (assoc < 0) {
    // associated to the left character or the beginning of a type, increment index if possible.
    if (index === 0) {
      return createRelativePosition(type, null, assoc)
    }
    index--;
  }
  while (t !== null) {
    if (!t.deleted && t.countable) {
      if (t.length > index) {
        // case 1: found position somewhere in the linked list
        return createRelativePosition(type, createID(t.id.client, t.id.clock + index), assoc)
      }
      index -= t.length;
    }
    if (t.right === null && assoc < 0) {
      // left-associated position, return last available id
      return createRelativePosition(type, t.lastId, assoc)
    }
    t = t.right;
  }
  return createRelativePosition(type, null, assoc)
};

/**
 * @param {encoding.Encoder} encoder
 * @param {RelativePosition} rpos
 *
 * @function
 */
const writeRelativePosition = (encoder, rpos) => {
  const { type, tname, item, assoc } = rpos;
  if (item !== null) {
    writeVarUint(encoder, 0);
    writeID(encoder, item);
  } else if (tname !== null) {
    // case 2: found position at the end of the list and type is stored in y.share
    writeUint8(encoder, 1);
    writeVarString(encoder, tname);
  } else if (type !== null) {
    // case 3: found position at the end of the list and type is attached to an item
    writeUint8(encoder, 2);
    writeID(encoder, type);
  } else {
    throw unexpectedCase()
  }
  writeVarInt(encoder, assoc);
  return encoder
};

/**
 * @param {RelativePosition} rpos
 * @return {Uint8Array}
 */
const encodeRelativePosition = rpos => {
  const encoder = createEncoder();
  writeRelativePosition(encoder, rpos);
  return _toUint8Array(encoder)
};

/**
 * @param {decoding.Decoder} decoder
 * @return {RelativePosition}
 *
 * @function
 */
const readRelativePosition = decoder => {
  let type = null;
  let tname = null;
  let itemID = null;
  switch (readVarUint(decoder)) {
    case 0:
      // case 1: found position somewhere in the linked list
      itemID = readID(decoder);
      break
    case 1:
      // case 2: found position at the end of the list and type is stored in y.share
      tname = readVarString(decoder);
      break
    case 2: {
      // case 3: found position at the end of the list and type is attached to an item
      type = readID(decoder);
    }
  }
  const assoc = hasContent(decoder) ? readVarInt(decoder) : 0;
  return new RelativePosition(type, tname, itemID, assoc)
};

/**
 * @param {Uint8Array} uint8Array
 * @return {RelativePosition}
 */
const decodeRelativePosition = uint8Array => readRelativePosition(createDecoder(uint8Array));

/**
 * @param {RelativePosition} rpos
 * @param {Doc} doc
 * @return {AbsolutePosition|null}
 *
 * @function
 */
const createAbsolutePositionFromRelativePosition = (rpos, doc) => {
  const store = doc.store;
  const rightID = rpos.item;
  const typeID = rpos.type;
  const tname = rpos.tname;
  const assoc = rpos.assoc;
  let type = null;
  let index = 0;
  if (rightID !== null) {
    if (getState(store, rightID.client) <= rightID.clock) {
      return null
    }
    const res = followRedone(store, rightID);
    const right = res.item;
    if (!(right instanceof Item)) {
      return null
    }
    type = /** @type {AbstractType<any>} */ (right.parent);
    if (type._item === null || !type._item.deleted) {
      index = (right.deleted || !right.countable) ? 0 : (res.diff + (assoc >= 0 ? 0 : 1)); // adjust position based on left association if necessary
      let n = right.left;
      while (n !== null) {
        if (!n.deleted && n.countable) {
          index += n.length;
        }
        n = n.left;
      }
    }
  } else {
    if (tname !== null) {
      type = doc.get(tname);
    } else if (typeID !== null) {
      if (getState(store, typeID.client) <= typeID.clock) {
        // type does not exist yet
        return null
      }
      const { item } = followRedone(store, typeID);
      if (item instanceof Item && item.content instanceof ContentType) {
        type = item.content.type;
      } else {
        // struct is garbage collected
        return null
      }
    } else {
      throw unexpectedCase()
    }
    if (assoc >= 0) {
      index = type._length;
    } else {
      index = 0;
    }
  }
  return createAbsolutePosition(type, index, rpos.assoc)
};

/**
 * @param {RelativePosition|null} a
 * @param {RelativePosition|null} b
 * @return {boolean}
 *
 * @function
 */
const compareRelativePositions = (a, b) => a === b || (
  a !== null && b !== null && a.tname === b.tname && compareIDs(a.item, b.item) && compareIDs(a.type, b.type) && a.assoc === b.assoc
);

class Snapshot {
  /**
   * @param {DeleteSet} ds
   * @param {Map<number,number>} sv state map
   */
  constructor (ds, sv) {
    /**
     * @type {DeleteSet}
     */
    this.ds = ds;
    /**
     * State Map
     * @type {Map<number,number>}
     */
    this.sv = sv;
  }
}

/**
 * @param {Snapshot} snap1
 * @param {Snapshot} snap2
 * @return {boolean}
 */
const equalSnapshots = (snap1, snap2) => {
  const ds1 = snap1.ds.clients;
  const ds2 = snap2.ds.clients;
  const sv1 = snap1.sv;
  const sv2 = snap2.sv;
  if (sv1.size !== sv2.size || ds1.size !== ds2.size) {
    return false
  }
  for (const [key, value] of sv1.entries()) {
    if (sv2.get(key) !== value) {
      return false
    }
  }
  for (const [client, dsitems1] of ds1.entries()) {
    const dsitems2 = ds2.get(client) || [];
    if (dsitems1.length !== dsitems2.length) {
      return false
    }
    for (let i = 0; i < dsitems1.length; i++) {
      const dsitem1 = dsitems1[i];
      const dsitem2 = dsitems2[i];
      if (dsitem1.clock !== dsitem2.clock || dsitem1.len !== dsitem2.len) {
        return false
      }
    }
  }
  return true
};

/**
 * @param {Snapshot} snapshot
 * @param {DSEncoderV1 | DSEncoderV2} [encoder]
 * @return {Uint8Array}
 */
const encodeSnapshotV2 = (snapshot, encoder = new DSEncoderV2()) => {
  writeDeleteSet(encoder, snapshot.ds);
  writeStateVector(encoder, snapshot.sv);
  return encoder.toUint8Array()
};

/**
 * @param {Snapshot} snapshot
 * @return {Uint8Array}
 */
const encodeSnapshot = snapshot => encodeSnapshotV2(snapshot, new DSEncoderV1());

/**
 * @param {Uint8Array} buf
 * @param {DSDecoderV1 | DSDecoderV2} [decoder]
 * @return {Snapshot}
 */
const decodeSnapshotV2 = (buf, decoder = new DSDecoderV2(createDecoder(buf))) => {
  return new Snapshot(readDeleteSet(decoder), readStateVector(decoder))
};

/**
 * @param {Uint8Array} buf
 * @return {Snapshot}
 */
const decodeSnapshot = buf => decodeSnapshotV2(buf, new DSDecoderV1(createDecoder(buf)));

/**
 * @param {DeleteSet} ds
 * @param {Map<number,number>} sm
 * @return {Snapshot}
 */
const createSnapshot = (ds, sm) => new Snapshot(ds, sm);

const emptySnapshot = createSnapshot(createDeleteSet(), new Map());

/**
 * @param {Doc} doc
 * @return {Snapshot}
 */
const snapshot = doc => createSnapshot(createDeleteSetFromStructStore(doc.store), getStateVector(doc.store));

/**
 * @param {Item} item
 * @param {Snapshot|undefined} snapshot
 *
 * @protected
 * @function
 */
const isVisible = (item, snapshot) => snapshot === undefined
  ? !item.deleted
  : snapshot.sv.has(item.id.client) && (snapshot.sv.get(item.id.client) || 0) > item.id.clock && !isDeleted(snapshot.ds, item.id);

/**
 * @param {Transaction} transaction
 * @param {Snapshot} snapshot
 */
const splitSnapshotAffectedStructs = (transaction, snapshot) => {
  const meta = setIfUndefined(transaction.meta, splitSnapshotAffectedStructs, set_create);
  const store = transaction.doc.store;
  // check if we already split for this snapshot
  if (!meta.has(snapshot)) {
    snapshot.sv.forEach((clock, client) => {
      if (clock < getState(store, client)) {
        getItemCleanStart(transaction, createID(client, clock));
      }
    });
    iterateDeletedStructs(transaction, snapshot.ds, item => {});
    meta.add(snapshot);
  }
};

/**
 * @param {Doc} originDoc
 * @param {Snapshot} snapshot
 * @param {Doc} [newDoc] Optionally, you may define the Yjs document that receives the data from originDoc
 * @return {Doc}
 */
const createDocFromSnapshot = (originDoc, snapshot, newDoc = new Doc()) => {
  if (originDoc.gc) {
    // we should not try to restore a GC-ed document, because some of the restored items might have their content deleted
    throw new Error('originDoc must not be garbage collected')
  }
  const { sv, ds } = snapshot;

  const encoder = new UpdateEncoderV2();
  originDoc.transact(transaction => {
    let size = 0;
    sv.forEach(clock => {
      if (clock > 0) {
        size++;
      }
    });
    writeVarUint(encoder.restEncoder, size);
    // splitting the structs before writing them to the encoder
    for (const [client, clock] of sv) {
      if (clock === 0) {
        continue
      }
      if (clock < getState(originDoc.store, client)) {
        getItemCleanStart(transaction, createID(client, clock));
      }
      const structs = originDoc.store.clients.get(client) || [];
      const lastStructIndex = findIndexSS(structs, clock - 1);
      // write # encoded structs
      writeVarUint(encoder.restEncoder, lastStructIndex + 1);
      encoder.writeClient(client);
      // first clock written is 0
      writeVarUint(encoder.restEncoder, 0);
      for (let i = 0; i <= lastStructIndex; i++) {
        structs[i].write(encoder, 0);
      }
    }
    writeDeleteSet(encoder, ds);
  });

  applyUpdateV2(newDoc, encoder.toUint8Array(), 'snapshot');
  return newDoc
};

class StructStore {
  constructor () {
    /**
     * @type {Map<number,Array<GC|Item>>}
     */
    this.clients = new Map();
    /**
     * @type {null | { missing: Map<number, number>, update: Uint8Array }}
     */
    this.pendingStructs = null;
    /**
     * @type {null | Uint8Array}
     */
    this.pendingDs = null;
  }
}

/**
 * Return the states as a Map<client,clock>.
 * Note that clock refers to the next expected clock id.
 *
 * @param {StructStore} store
 * @return {Map<number,number>}
 *
 * @public
 * @function
 */
const getStateVector = store => {
  const sm = new Map();
  store.clients.forEach((structs, client) => {
    const struct = structs[structs.length - 1];
    sm.set(client, struct.id.clock + struct.length);
  });
  return sm
};

/**
 * @param {StructStore} store
 * @param {number} client
 * @return {number}
 *
 * @public
 * @function
 */
const getState = (store, client) => {
  const structs = store.clients.get(client);
  if (structs === undefined) {
    return 0
  }
  const lastStruct = structs[structs.length - 1];
  return lastStruct.id.clock + lastStruct.length
};

/**
 * @param {StructStore} store
 * @param {GC|Item} struct
 *
 * @private
 * @function
 */
const addStruct = (store, struct) => {
  let structs = store.clients.get(struct.id.client);
  if (structs === undefined) {
    structs = [];
    store.clients.set(struct.id.client, structs);
  } else {
    const lastStruct = structs[structs.length - 1];
    if (lastStruct.id.clock + lastStruct.length !== struct.id.clock) {
      throw unexpectedCase()
    }
  }
  structs.push(struct);
};

/**
 * Perform a binary search on a sorted array
 * @param {Array<Item|GC>} structs
 * @param {number} clock
 * @return {number}
 *
 * @private
 * @function
 */
const findIndexSS = (structs, clock) => {
  let left = 0;
  let right = structs.length - 1;
  let mid = structs[right];
  let midclock = mid.id.clock;
  if (midclock === clock) {
    return right
  }
  // @todo does it even make sense to pivot the search?
  // If a good split misses, it might actually increase the time to find the correct item.
  // Currently, the only advantage is that search with pivoting might find the item on the first try.
  let midindex = floor((clock / (midclock + mid.length - 1)) * right); // pivoting the search
  while (left <= right) {
    mid = structs[midindex];
    midclock = mid.id.clock;
    if (midclock <= clock) {
      if (clock < midclock + mid.length) {
        return midindex
      }
      left = midindex + 1;
    } else {
      right = midindex - 1;
    }
    midindex = floor((left + right) / 2);
  }
  // Always check state before looking for a struct in StructStore
  // Therefore the case of not finding a struct is unexpected
  throw unexpectedCase()
};

/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {StructStore} store
 * @param {ID} id
 * @return {GC|Item}
 *
 * @private
 * @function
 */
const find = (store, id) => {
  /**
   * @type {Array<GC|Item>}
   */
  // @ts-ignore
  const structs = store.clients.get(id.client);
  return structs[findIndexSS(structs, id.clock)]
};

/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 * @private
 * @function
 */
const getItem = /** @type {function(StructStore,ID):Item} */ (find);

/**
 * @param {Transaction} transaction
 * @param {Array<Item|GC>} structs
 * @param {number} clock
 */
const findIndexCleanStart = (transaction, structs, clock) => {
  const index = findIndexSS(structs, clock);
  const struct = structs[index];
  if (struct.id.clock < clock && struct instanceof Item) {
    structs.splice(index + 1, 0, splitItem(transaction, struct, clock - struct.id.clock));
    return index + 1
  }
  return index
};

/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {Transaction} transaction
 * @param {ID} id
 * @return {Item}
 *
 * @private
 * @function
 */
const getItemCleanStart = (transaction, id) => {
  const structs = /** @type {Array<Item>} */ (transaction.doc.store.clients.get(id.client));
  return structs[findIndexCleanStart(transaction, structs, id.clock)]
};

/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @param {ID} id
 * @return {Item}
 *
 * @private
 * @function
 */
const getItemCleanEnd = (transaction, store, id) => {
  /**
   * @type {Array<Item>}
   */
  // @ts-ignore
  const structs = store.clients.get(id.client);
  const index = findIndexSS(structs, id.clock);
  const struct = structs[index];
  if (id.clock !== struct.id.clock + struct.length - 1 && struct.constructor !== GC) {
    structs.splice(index + 1, 0, splitItem(transaction, struct, id.clock - struct.id.clock + 1));
  }
  return struct
};

/**
 * Replace `item` with `newitem` in store
 * @param {StructStore} store
 * @param {GC|Item} struct
 * @param {GC|Item} newStruct
 *
 * @private
 * @function
 */
const replaceStruct = (store, struct, newStruct) => {
  const structs = /** @type {Array<GC|Item>} */ (store.clients.get(struct.id.client));
  structs[findIndexSS(structs, struct.id.clock)] = newStruct;
};

/**
 * Iterate over a range of structs
 *
 * @param {Transaction} transaction
 * @param {Array<Item|GC>} structs
 * @param {number} clockStart Inclusive start
 * @param {number} len
 * @param {function(GC|Item):void} f
 *
 * @function
 */
const iterateStructs = (transaction, structs, clockStart, len, f) => {
  if (len === 0) {
    return
  }
  const clockEnd = clockStart + len;
  let index = findIndexCleanStart(transaction, structs, clockStart);
  let struct;
  do {
    struct = structs[index++];
    if (clockEnd < struct.id.clock + struct.length) {
      findIndexCleanStart(transaction, structs, clockEnd);
    }
    f(struct);
  } while (index < structs.length && structs[index].id.clock < clockEnd)
};

/**
 * A transaction is created for every change on the Yjs model. It is possible
 * to bundle changes on the Yjs model in a single transaction to
 * minimize the number on messages sent and the number of observer calls.
 * If possible the user of this library should bundle as many changes as
 * possible. Here is an example to illustrate the advantages of bundling:
 *
 * @example
 * const map = y.define('map', YMap)
 * // Log content when change is triggered
 * map.observe(() => {
 *   console.log('change triggered')
 * })
 * // Each change on the map type triggers a log message:
 * map.set('a', 0) // => "change triggered"
 * map.set('b', 0) // => "change triggered"
 * // When put in a transaction, it will trigger the log after the transaction:
 * y.transact(() => {
 *   map.set('a', 1)
 *   map.set('b', 1)
 * }) // => "change triggered"
 *
 * @public
 */
class Transaction {
  /**
   * @param {Doc} doc
   * @param {any} origin
   * @param {boolean} local
   */
  constructor (doc, origin, local) {
    /**
     * The Yjs instance.
     * @type {Doc}
     */
    this.doc = doc;
    /**
     * Describes the set of deleted items by ids
     * @type {DeleteSet}
     */
    this.deleteSet = new DeleteSet();
    /**
     * Holds the state before the transaction started.
     * @type {Map<Number,Number>}
     */
    this.beforeState = getStateVector(doc.store);
    /**
     * Holds the state after the transaction.
     * @type {Map<Number,Number>}
     */
    this.afterState = new Map();
    /**
     * All types that were directly modified (property added or child
     * inserted/deleted). New types are not included in this Set.
     * Maps from type to parentSubs (`item.parentSub = null` for YArray)
     * @type {Map<AbstractType<YEvent<any>>,Set<String|null>>}
     */
    this.changed = new Map();
    /**
     * Stores the events for the types that observe also child elements.
     * It is mainly used by `observeDeep`.
     * @type {Map<AbstractType<YEvent<any>>,Array<YEvent<any>>>}
     */
    this.changedParentTypes = new Map();
    /**
     * @type {Array<AbstractStruct>}
     */
    this._mergeStructs = [];
    /**
     * @type {any}
     */
    this.origin = origin;
    /**
     * Stores meta information on the transaction
     * @type {Map<any,any>}
     */
    this.meta = new Map();
    /**
     * Whether this change originates from this doc.
     * @type {boolean}
     */
    this.local = local;
    /**
     * @type {Set<Doc>}
     */
    this.subdocsAdded = new Set();
    /**
     * @type {Set<Doc>}
     */
    this.subdocsRemoved = new Set();
    /**
     * @type {Set<Doc>}
     */
    this.subdocsLoaded = new Set();
  }
}

/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Transaction} transaction
 * @return {boolean} Whether data was written.
 */
const writeUpdateMessageFromTransaction = (encoder, transaction) => {
  if (transaction.deleteSet.clients.size === 0 && !any(transaction.afterState, (clock, client) => transaction.beforeState.get(client) !== clock)) {
    return false
  }
  sortAndMergeDeleteSet(transaction.deleteSet);
  writeStructsFromTransaction(encoder, transaction);
  writeDeleteSet(encoder, transaction.deleteSet);
  return true
};

/**
 * If `type.parent` was added in current transaction, `type` technically
 * did not change, it was just added and we should not fire events for `type`.
 *
 * @param {Transaction} transaction
 * @param {AbstractType<YEvent<any>>} type
 * @param {string|null} parentSub
 */
const addChangedTypeToTransaction = (transaction, type, parentSub) => {
  const item = type._item;
  if (item === null || (item.id.clock < (transaction.beforeState.get(item.id.client) || 0) && !item.deleted)) {
    setIfUndefined(transaction.changed, type, set_create).add(parentSub);
  }
};

/**
 * @param {Array<AbstractStruct>} structs
 * @param {number} pos
 */
const tryToMergeWithLeft = (structs, pos) => {
  const left = structs[pos - 1];
  const right = structs[pos];
  if (left.deleted === right.deleted && left.constructor === right.constructor) {
    if (left.mergeWith(right)) {
      structs.splice(pos, 1);
      if (right instanceof Item && right.parentSub !== null && /** @type {AbstractType<any>} */ (right.parent)._map.get(right.parentSub) === right) {
        /** @type {AbstractType<any>} */ (right.parent)._map.set(right.parentSub, /** @type {Item} */ (left));
      }
    }
  }
};

/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 * @param {function(Item):boolean} gcFilter
 */
const tryGcDeleteSet = (ds, store, gcFilter) => {
  for (const [client, deleteItems] of ds.clients.entries()) {
    const structs = /** @type {Array<GC|Item>} */ (store.clients.get(client));
    for (let di = deleteItems.length - 1; di >= 0; di--) {
      const deleteItem = deleteItems[di];
      const endDeleteItemClock = deleteItem.clock + deleteItem.len;
      for (
        let si = findIndexSS(structs, deleteItem.clock), struct = structs[si];
        si < structs.length && struct.id.clock < endDeleteItemClock;
        struct = structs[++si]
      ) {
        const struct = structs[si];
        if (deleteItem.clock + deleteItem.len <= struct.id.clock) {
          break
        }
        if (struct instanceof Item && struct.deleted && !struct.keep && gcFilter(struct)) {
          struct.gc(store, false);
        }
      }
    }
  }
};

/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 */
const tryMergeDeleteSet = (ds, store) => {
  // try to merge deleted / gc'd items
  // merge from right to left for better efficiecy and so we don't miss any merge targets
  ds.clients.forEach((deleteItems, client) => {
    const structs = /** @type {Array<GC|Item>} */ (store.clients.get(client));
    for (let di = deleteItems.length - 1; di >= 0; di--) {
      const deleteItem = deleteItems[di];
      // start with merging the item next to the last deleted item
      const mostRightIndexToCheck = min(structs.length - 1, 1 + findIndexSS(structs, deleteItem.clock + deleteItem.len - 1));
      for (
        let si = mostRightIndexToCheck, struct = structs[si];
        si > 0 && struct.id.clock >= deleteItem.clock;
        struct = structs[--si]
      ) {
        tryToMergeWithLeft(structs, si);
      }
    }
  });
};

/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 * @param {function(Item):boolean} gcFilter
 */
const tryGc = (ds, store, gcFilter) => {
  tryGcDeleteSet(ds, store, gcFilter);
  tryMergeDeleteSet(ds, store);
};

/**
 * @param {Array<Transaction>} transactionCleanups
 * @param {number} i
 */
const cleanupTransactions = (transactionCleanups, i) => {
  if (i < transactionCleanups.length) {
    const transaction = transactionCleanups[i];
    const doc = transaction.doc;
    const store = doc.store;
    const ds = transaction.deleteSet;
    const mergeStructs = transaction._mergeStructs;
    try {
      sortAndMergeDeleteSet(ds);
      transaction.afterState = getStateVector(transaction.doc.store);
      doc._transaction = null;
      doc.emit('beforeObserverCalls', [transaction, doc]);
      /**
       * An array of event callbacks.
       *
       * Each callback is called even if the other ones throw errors.
       *
       * @type {Array<function():void>}
       */
      const fs = [];
      // observe events on changed types
      transaction.changed.forEach((subs, itemtype) =>
        fs.push(() => {
          if (itemtype._item === null || !itemtype._item.deleted) {
            itemtype._callObserver(transaction, subs);
          }
        })
      );
      fs.push(() => {
        // deep observe events
        transaction.changedParentTypes.forEach((events, type) =>
          fs.push(() => {
            // We need to think about the possibility that the user transforms the
            // Y.Doc in the event.
            if (type._item === null || !type._item.deleted) {
              events = events
                .filter(event =>
                  event.target._item === null || !event.target._item.deleted
                );
              events
                .forEach(event => {
                  event.currentTarget = type;
                });
              // sort events by path length so that top-level events are fired first.
              events
                .sort((event1, event2) => event1.path.length - event2.path.length);
              // We don't need to check for events.length
              // because we know it has at least one element
              callEventHandlerListeners(type._dEH, events, transaction);
            }
          })
        );
        fs.push(() => doc.emit('afterTransaction', [transaction, doc]));
      });
      callAll(fs, []);
    } finally {
      // Replace deleted items with ItemDeleted / GC.
      // This is where content is actually remove from the Yjs Doc.
      if (doc.gc) {
        tryGcDeleteSet(ds, store, doc.gcFilter);
      }
      tryMergeDeleteSet(ds, store);

      // on all affected store.clients props, try to merge
      transaction.afterState.forEach((clock, client) => {
        const beforeClock = transaction.beforeState.get(client) || 0;
        if (beforeClock !== clock) {
          const structs = /** @type {Array<GC|Item>} */ (store.clients.get(client));
          // we iterate from right to left so we can safely remove entries
          const firstChangePos = max(findIndexSS(structs, beforeClock), 1);
          for (let i = structs.length - 1; i >= firstChangePos; i--) {
            tryToMergeWithLeft(structs, i);
          }
        }
      });
      // try to merge mergeStructs
      // @todo: it makes more sense to transform mergeStructs to a DS, sort it, and merge from right to left
      //        but at the moment DS does not handle duplicates
      for (let i = 0; i < mergeStructs.length; i++) {
        const { client, clock } = mergeStructs[i].id;
        const structs = /** @type {Array<GC|Item>} */ (store.clients.get(client));
        const replacedStructPos = findIndexSS(structs, clock);
        if (replacedStructPos + 1 < structs.length) {
          tryToMergeWithLeft(structs, replacedStructPos + 1);
        }
        if (replacedStructPos > 0) {
          tryToMergeWithLeft(structs, replacedStructPos);
        }
      }
      if (!transaction.local && transaction.afterState.get(doc.clientID) !== transaction.beforeState.get(doc.clientID)) {
        print(ORANGE, BOLD, '[yjs] ', UNBOLD, RED, 'Changed the client-id because another client seems to be using it.');
        doc.clientID = generateNewClientId();
      }
      // @todo Merge all the transactions into one and provide send the data as a single update message
      doc.emit('afterTransactionCleanup', [transaction, doc]);
      if (doc._observers.has('update')) {
        const encoder = new UpdateEncoderV1();
        const hasContent = writeUpdateMessageFromTransaction(encoder, transaction);
        if (hasContent) {
          doc.emit('update', [encoder.toUint8Array(), transaction.origin, doc, transaction]);
        }
      }
      if (doc._observers.has('updateV2')) {
        const encoder = new UpdateEncoderV2();
        const hasContent = writeUpdateMessageFromTransaction(encoder, transaction);
        if (hasContent) {
          doc.emit('updateV2', [encoder.toUint8Array(), transaction.origin, doc, transaction]);
        }
      }
      const { subdocsAdded, subdocsLoaded, subdocsRemoved } = transaction;
      if (subdocsAdded.size > 0 || subdocsRemoved.size > 0 || subdocsLoaded.size > 0) {
        subdocsAdded.forEach(subdoc => {
          subdoc.clientID = doc.clientID;
          if (subdoc.collectionid == null) {
            subdoc.collectionid = doc.collectionid;
          }
          doc.subdocs.add(subdoc);
        });
        subdocsRemoved.forEach(subdoc => doc.subdocs.delete(subdoc));
        doc.emit('subdocs', [{ loaded: subdocsLoaded, added: subdocsAdded, removed: subdocsRemoved }, doc, transaction]);
        subdocsRemoved.forEach(subdoc => subdoc.destroy());
      }

      if (transactionCleanups.length <= i + 1) {
        doc._transactionCleanups = [];
        doc.emit('afterAllTransactions', [doc, transactionCleanups]);
      } else {
        cleanupTransactions(transactionCleanups, i + 1);
      }
    }
  }
};

/**
 * Implements the functionality of `y.transact(()=>{..})`
 *
 * @param {Doc} doc
 * @param {function(Transaction):void} f
 * @param {any} [origin=true]
 *
 * @function
 */
const transact = (doc, f, origin = null, local = true) => {
  const transactionCleanups = doc._transactionCleanups;
  let initialCall = false;
  if (doc._transaction === null) {
    initialCall = true;
    doc._transaction = new Transaction(doc, origin, local);
    transactionCleanups.push(doc._transaction);
    if (transactionCleanups.length === 1) {
      doc.emit('beforeAllTransactions', [doc]);
    }
    doc.emit('beforeTransaction', [doc._transaction, doc]);
  }
  try {
    f(doc._transaction);
  } finally {
    if (initialCall && transactionCleanups[0] === doc._transaction) {
      // The first transaction ended, now process observer calls.
      // Observer call may create new transactions for which we need to call the observers and do cleanup.
      // We don't want to nest these calls, so we execute these calls one after
      // another.
      // Also we need to ensure that all cleanups are called, even if the
      // observes throw errors.
      // This file is full of hacky try {} finally {} blocks to ensure that an
      // event can throw errors and also that the cleanup is called.
      cleanupTransactions(transactionCleanups, 0);
    }
  }
};

class StackItem {
  /**
   * @param {DeleteSet} deletions
   * @param {DeleteSet} insertions
   */
  constructor (deletions, insertions) {
    this.insertions = insertions;
    this.deletions = deletions;
    /**
     * Use this to save and restore metadata like selection range
     */
    this.meta = new Map();
  }
}
/**
 * @param {Transaction} tr
 * @param {UndoManager} um
 * @param {StackItem} stackItem
 */
const clearUndoManagerStackItem = (tr, um, stackItem) => {
  iterateDeletedStructs(tr, stackItem.deletions, item => {
    if (item instanceof Item && um.scope.some(type => yjs_isParentOf(type, item))) {
      keepItem(item, false);
    }
  });
};

/**
 * @param {UndoManager} undoManager
 * @param {Array<StackItem>} stack
 * @param {string} eventType
 * @return {StackItem?}
 */
const popStackItem = (undoManager, stack, eventType) => {
  /**
   * Whether a change happened
   * @type {StackItem?}
   */
  let result = null;
  /**
   * Keep a reference to the transaction so we can fire the event with the changedParentTypes
   * @type {any}
   */
  let _tr = null;
  const doc = undoManager.doc;
  const scope = undoManager.scope;
  transact(doc, transaction => {
    while (stack.length > 0 && result === null) {
      const store = doc.store;
      const stackItem = /** @type {StackItem} */ (stack.pop());
      /**
       * @type {Set<Item>}
       */
      const itemsToRedo = new Set();
      /**
       * @type {Array<Item>}
       */
      const itemsToDelete = [];
      let performedChange = false;
      iterateDeletedStructs(transaction, stackItem.insertions, struct => {
        if (struct instanceof Item) {
          if (struct.redone !== null) {
            let { item, diff } = followRedone(store, struct.id);
            if (diff > 0) {
              item = getItemCleanStart(transaction, createID(item.id.client, item.id.clock + diff));
            }
            struct = item;
          }
          if (!struct.deleted && scope.some(type => yjs_isParentOf(type, /** @type {Item} */ (struct)))) {
            itemsToDelete.push(struct);
          }
        }
      });
      iterateDeletedStructs(transaction, stackItem.deletions, struct => {
        if (
          struct instanceof Item &&
          scope.some(type => yjs_isParentOf(type, struct)) &&
          // Never redo structs in stackItem.insertions because they were created and deleted in the same capture interval.
          !isDeleted(stackItem.insertions, struct.id)
        ) {
          itemsToRedo.add(struct);
        }
      });
      itemsToRedo.forEach(struct => {
        performedChange = redoItem(transaction, struct, itemsToRedo, stackItem.insertions, undoManager.ignoreRemoteMapChanges) !== null || performedChange;
      });
      // We want to delete in reverse order so that children are deleted before
      // parents, so we have more information available when items are filtered.
      for (let i = itemsToDelete.length - 1; i >= 0; i--) {
        const item = itemsToDelete[i];
        if (undoManager.deleteFilter(item)) {
          item.delete(transaction);
          performedChange = true;
        }
      }
      result = performedChange ? stackItem : null;
    }
    transaction.changed.forEach((subProps, type) => {
      // destroy search marker if necessary
      if (subProps.has(null) && type._searchMarker) {
        type._searchMarker.length = 0;
      }
    });
    _tr = transaction;
  }, undoManager);
  if (result != null) {
    const changedParentTypes = _tr.changedParentTypes;
    undoManager.emit('stack-item-popped', [{ stackItem: result, type: eventType, changedParentTypes }, undoManager]);
  }
  return result
};

/**
 * @typedef {Object} UndoManagerOptions
 * @property {number} [UndoManagerOptions.captureTimeout=500]
 * @property {function(Item):boolean} [UndoManagerOptions.deleteFilter=()=>true] Sometimes
 * it is necessary to filter whan an Undo/Redo operation can delete. If this
 * filter returns false, the type/item won't be deleted even it is in the
 * undo/redo scope.
 * @property {Set<any>} [UndoManagerOptions.trackedOrigins=new Set([null])]
 * @property {boolean} [ignoreRemoteMapChanges] Experimental. By default, the UndoManager will never overwrite remote changes. Enable this property to enable overwriting remote changes on key-value changes (Y.Map, properties on Y.Xml, etc..).
 */

/**
 * Fires 'stack-item-added' event when a stack item was added to either the undo- or
 * the redo-stack. You may store additional stack information via the
 * metadata property on `event.stackItem.meta` (it is a `Map` of metadata properties).
 * Fires 'stack-item-popped' event when a stack item was popped from either the
 * undo- or the redo-stack. You may restore the saved stack information from `event.stackItem.meta`.
 *
 * @extends {Observable<'stack-item-added'|'stack-item-popped'|'stack-cleared'|'stack-item-updated'>}
 */
class UndoManager extends Observable {
  /**
   * @param {AbstractType<any>|Array<AbstractType<any>>} typeScope Accepts either a single type, or an array of types
   * @param {UndoManagerOptions} options
   */
  constructor (typeScope, { captureTimeout = 500, deleteFilter = () => true, trackedOrigins = new Set([null]), ignoreRemoteMapChanges = false } = {}) {
    super();
    /**
     * @type {Array<AbstractType<any>>}
     */
    this.scope = [];
    this.addToScope(typeScope);
    this.deleteFilter = deleteFilter;
    trackedOrigins.add(this);
    this.trackedOrigins = trackedOrigins;
    /**
     * @type {Array<StackItem>}
     */
    this.undoStack = [];
    /**
     * @type {Array<StackItem>}
     */
    this.redoStack = [];
    /**
     * Whether the client is currently undoing (calling UndoManager.undo)
     *
     * @type {boolean}
     */
    this.undoing = false;
    this.redoing = false;
    this.doc = /** @type {Doc} */ (this.scope[0].doc);
    this.lastChange = 0;
    this.ignoreRemoteMapChanges = ignoreRemoteMapChanges;
    /**
     * @param {Transaction} transaction
     */
    this.afterTransactionHandler = transaction => {
      // Only track certain transactions
      if (!this.scope.some(type => transaction.changedParentTypes.has(type)) || (!this.trackedOrigins.has(transaction.origin) && (!transaction.origin || !this.trackedOrigins.has(transaction.origin.constructor)))) {
        return
      }
      const undoing = this.undoing;
      const redoing = this.redoing;
      const stack = undoing ? this.redoStack : this.undoStack;
      if (undoing) {
        this.stopCapturing(); // next undo should not be appended to last stack item
      } else if (!redoing) {
        // neither undoing nor redoing: delete redoStack
        this.clear(false, true);
      }
      const insertions = new DeleteSet();
      transaction.afterState.forEach((endClock, client) => {
        const startClock = transaction.beforeState.get(client) || 0;
        const len = endClock - startClock;
        if (len > 0) {
          addToDeleteSet(insertions, client, startClock, len);
        }
      });
      const now = getUnixTime();
      let didAdd = false;
      if (now - this.lastChange < captureTimeout && stack.length > 0 && !undoing && !redoing) {
        // append change to last stack op
        const lastOp = stack[stack.length - 1];
        lastOp.deletions = mergeDeleteSets([lastOp.deletions, transaction.deleteSet]);
        lastOp.insertions = mergeDeleteSets([lastOp.insertions, insertions]);
      } else {
        // create a new stack op
        stack.push(new StackItem(transaction.deleteSet, insertions));
        didAdd = true;
      }
      if (!undoing && !redoing) {
        this.lastChange = now;
      }
      // make sure that deleted structs are not gc'd
      iterateDeletedStructs(transaction, transaction.deleteSet, /** @param {Item|GC} item */ item => {
        if (item instanceof Item && this.scope.some(type => yjs_isParentOf(type, item))) {
          keepItem(item, true);
        }
      });
      const changeEvent = [{ stackItem: stack[stack.length - 1], origin: transaction.origin, type: undoing ? 'redo' : 'undo', changedParentTypes: transaction.changedParentTypes }, this];
      if (didAdd) {
        this.emit('stack-item-added', changeEvent);
      } else {
        this.emit('stack-item-updated', changeEvent);
      }
    };
    this.doc.on('afterTransaction', this.afterTransactionHandler);
    this.doc.on('destroy', () => {
      this.destroy();
    });
  }

  /**
   * @param {Array<AbstractType<any>> | AbstractType<any>} ytypes
   */
  addToScope (ytypes) {
    ytypes = isArray(ytypes) ? ytypes : [ytypes];
    ytypes.forEach(ytype => {
      if (this.scope.every(yt => yt !== ytype)) {
        this.scope.push(ytype);
      }
    });
  }

  /**
   * @param {any} origin
   */
  addTrackedOrigin (origin) {
    this.trackedOrigins.add(origin);
  }

  /**
   * @param {any} origin
   */
  removeTrackedOrigin (origin) {
    this.trackedOrigins.delete(origin);
  }

  clear (clearUndoStack = true, clearRedoStack = true) {
    if ((clearUndoStack && this.canUndo()) || (clearRedoStack && this.canRedo())) {
      this.doc.transact(tr => {
        if (clearUndoStack) {
          this.undoStack.forEach(item => clearUndoManagerStackItem(tr, this, item));
          this.undoStack = [];
        }
        if (clearRedoStack) {
          this.redoStack.forEach(item => clearUndoManagerStackItem(tr, this, item));
          this.redoStack = [];
        }
        this.emit('stack-cleared', [{ undoStackCleared: clearUndoStack, redoStackCleared: clearRedoStack }]);
      });
    }
  }

  /**
   * UndoManager merges Undo-StackItem if they are created within time-gap
   * smaller than `options.captureTimeout`. Call `um.stopCapturing()` so that the next
   * StackItem won't be merged.
   *
   *
   * @example
   *     // without stopCapturing
   *     ytext.insert(0, 'a')
   *     ytext.insert(1, 'b')
   *     um.undo()
   *     ytext.toString() // => '' (note that 'ab' was removed)
   *     // with stopCapturing
   *     ytext.insert(0, 'a')
   *     um.stopCapturing()
   *     ytext.insert(0, 'b')
   *     um.undo()
   *     ytext.toString() // => 'a' (note that only 'b' was removed)
   *
   */
  stopCapturing () {
    this.lastChange = 0;
  }

  /**
   * Undo last changes on type.
   *
   * @return {StackItem?} Returns StackItem if a change was applied
   */
  undo () {
    this.undoing = true;
    let res;
    try {
      res = popStackItem(this, this.undoStack, 'undo');
    } finally {
      this.undoing = false;
    }
    return res
  }

  /**
   * Redo last undo operation.
   *
   * @return {StackItem?} Returns StackItem if a change was applied
   */
  redo () {
    this.redoing = true;
    let res;
    try {
      res = popStackItem(this, this.redoStack, 'redo');
    } finally {
      this.redoing = false;
    }
    return res
  }

  /**
   * Are undo steps available?
   *
   * @return {boolean} `true` if undo is possible
   */
  canUndo () {
    return this.undoStack.length > 0
  }

  /**
   * Are redo steps available?
   *
   * @return {boolean} `true` if redo is possible
   */
  canRedo () {
    return this.redoStack.length > 0
  }

  destroy () {
    this.trackedOrigins.delete(this);
    this.doc.off('afterTransaction', this.afterTransactionHandler);
    super.destroy();
  }
}

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 */
function * lazyStructReaderGenerator (decoder) {
  const numOfStateUpdates = readVarUint(decoder.restDecoder);
  for (let i = 0; i < numOfStateUpdates; i++) {
    const numberOfStructs = readVarUint(decoder.restDecoder);
    const client = decoder.readClient();
    let clock = readVarUint(decoder.restDecoder);
    for (let i = 0; i < numberOfStructs; i++) {
      const info = decoder.readInfo();
      // @todo use switch instead of ifs
      if (info === 10) {
        const len = readVarUint(decoder.restDecoder);
        yield new Skip(createID(client, clock), len);
        clock += len;
      } else if ((BITS5 & info) !== 0) {
        const cantCopyParentInfo = (info & (BIT7 | BIT8)) === 0;
        // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
        // and we read the next string as parentYKey.
        // It indicates how we store/retrieve parent from `y.share`
        // @type {string|null}
        const struct = new Item(
          createID(client, clock),
          null, // left
          (info & BIT8) === BIT8 ? decoder.readLeftID() : null, // origin
          null, // right
          (info & BIT7) === BIT7 ? decoder.readRightID() : null, // right origin
          // @ts-ignore Force writing a string here.
          cantCopyParentInfo ? (decoder.readParentInfo() ? decoder.readString() : decoder.readLeftID()) : null, // parent
          cantCopyParentInfo && (info & BIT6) === BIT6 ? decoder.readString() : null, // parentSub
          readItemContent(decoder, info) // item content
        );
        yield struct;
        clock += struct.length;
      } else {
        const len = decoder.readLen();
        yield new GC(createID(client, clock), len);
        clock += len;
      }
    }
  }
}

class LazyStructReader {
  /**
   * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
   * @param {boolean} filterSkips
   */
  constructor (decoder, filterSkips) {
    this.gen = lazyStructReaderGenerator(decoder);
    /**
     * @type {null | Item | Skip | GC}
     */
    this.curr = null;
    this.done = false;
    this.filterSkips = filterSkips;
    this.next();
  }

  /**
   * @return {Item | GC | Skip |null}
   */
  next () {
    // ignore "Skip" structs
    do {
      this.curr = this.gen.next().value || null;
    } while (this.filterSkips && this.curr !== null && this.curr.constructor === Skip)
    return this.curr
  }
}

/**
 * @param {Uint8Array} update
 *
 */
const logUpdate = update => logUpdateV2(update, UpdateDecoderV1);

/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} [YDecoder]
 *
 */
const logUpdateV2 = (update, YDecoder = UpdateDecoderV2) => {
  const structs = [];
  const updateDecoder = new YDecoder(createDecoder(update));
  const lazyDecoder = new LazyStructReader(updateDecoder, false);
  for (let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next()) {
    structs.push(curr);
  }
  print('Structs: ', structs);
  const ds = readDeleteSet(updateDecoder);
  print('DeleteSet: ', ds);
};

/**
 * @param {Uint8Array} update
 *
 */
const decodeUpdate = (update) => decodeUpdateV2(update, UpdateDecoderV1);

/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} [YDecoder]
 *
 */
const decodeUpdateV2 = (update, YDecoder = UpdateDecoderV2) => {
  const structs = [];
  const updateDecoder = new YDecoder(createDecoder(update));
  const lazyDecoder = new LazyStructReader(updateDecoder, false);
  for (let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next()) {
    structs.push(curr);
  }
  return {
    structs,
    ds: readDeleteSet(updateDecoder)
  }
};

class LazyStructWriter {
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  constructor (encoder) {
    this.currClient = 0;
    this.startClock = 0;
    this.written = 0;
    this.encoder = encoder;
    /**
     * We want to write operations lazily, but also we need to know beforehand how many operations we want to write for each client.
     *
     * This kind of meta-information (#clients, #structs-per-client-written) is written to the restEncoder.
     *
     * We fragment the restEncoder and store a slice of it per-client until we know how many clients there are.
     * When we flush (toUint8Array) we write the restEncoder using the fragments and the meta-information.
     *
     * @type {Array<{ written: number, restEncoder: Uint8Array }>}
     */
    this.clientStructs = [];
  }
}

/**
 * @param {Array<Uint8Array>} updates
 * @return {Uint8Array}
 */
const mergeUpdates = updates => mergeUpdatesV2(updates, UpdateDecoderV1, UpdateEncoderV1);

/**
 * @param {Uint8Array} update
 * @param {typeof DSEncoderV1 | typeof DSEncoderV2} YEncoder
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} YDecoder
 * @return {Uint8Array}
 */
const encodeStateVectorFromUpdateV2 = (update, YEncoder = DSEncoderV2, YDecoder = UpdateDecoderV2) => {
  const encoder = new YEncoder();
  const updateDecoder = new LazyStructReader(new YDecoder(createDecoder(update)), false);
  let curr = updateDecoder.curr;
  if (curr !== null) {
    let size = 0;
    let currClient = curr.id.client;
    let stopCounting = curr.id.clock !== 0; // must start at 0
    let currClock = stopCounting ? 0 : curr.id.clock + curr.length;
    for (; curr !== null; curr = updateDecoder.next()) {
      if (currClient !== curr.id.client) {
        if (currClock !== 0) {
          size++;
          // We found a new client
          // write what we have to the encoder
          writeVarUint(encoder.restEncoder, currClient);
          writeVarUint(encoder.restEncoder, currClock);
        }
        currClient = curr.id.client;
        currClock = 0;
        stopCounting = curr.id.clock !== 0;
      }
      // we ignore skips
      if (curr.constructor === Skip) {
        stopCounting = true;
      }
      if (!stopCounting) {
        currClock = curr.id.clock + curr.length;
      }
    }
    // write what we have
    if (currClock !== 0) {
      size++;
      writeVarUint(encoder.restEncoder, currClient);
      writeVarUint(encoder.restEncoder, currClock);
    }
    // prepend the size of the state vector
    const enc = createEncoder();
    writeVarUint(enc, size);
    writeBinaryEncoder(enc, encoder.restEncoder);
    encoder.restEncoder = enc;
    return encoder.toUint8Array()
  } else {
    writeVarUint(encoder.restEncoder, 0);
    return encoder.toUint8Array()
  }
};

/**
 * @param {Uint8Array} update
 * @return {Uint8Array}
 */
const encodeStateVectorFromUpdate = update => encodeStateVectorFromUpdateV2(update, DSEncoderV1, UpdateDecoderV1);

/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} YDecoder
 * @return {{ from: Map<number,number>, to: Map<number,number> }}
 */
const parseUpdateMetaV2 = (update, YDecoder = UpdateDecoderV2) => {
  /**
   * @type {Map<number, number>}
   */
  const from = new Map();
  /**
   * @type {Map<number, number>}
   */
  const to = new Map();
  const updateDecoder = new LazyStructReader(new YDecoder(createDecoder(update)), false);
  let curr = updateDecoder.curr;
  if (curr !== null) {
    let currClient = curr.id.client;
    let currClock = curr.id.clock;
    // write the beginning to `from`
    from.set(currClient, currClock);
    for (; curr !== null; curr = updateDecoder.next()) {
      if (currClient !== curr.id.client) {
        // We found a new client
        // write the end to `to`
        to.set(currClient, currClock);
        // write the beginning to `from`
        from.set(curr.id.client, curr.id.clock);
        // update currClient
        currClient = curr.id.client;
      }
      currClock = curr.id.clock + curr.length;
    }
    // write the end to `to`
    to.set(currClient, currClock);
  }
  return { from, to }
};

/**
 * @param {Uint8Array} update
 * @return {{ from: Map<number,number>, to: Map<number,number> }}
 */
const parseUpdateMeta = update => parseUpdateMetaV2(update, UpdateDecoderV1);

/**
 * This method is intended to slice any kind of struct and retrieve the right part.
 * It does not handle side-effects, so it should only be used by the lazy-encoder.
 *
 * @param {Item | GC | Skip} left
 * @param {number} diff
 * @return {Item | GC}
 */
const sliceStruct = (left, diff) => {
  if (left.constructor === GC) {
    const { client, clock } = left.id;
    return new GC(createID(client, clock + diff), left.length - diff)
  } else if (left.constructor === Skip) {
    const { client, clock } = left.id;
    return new Skip(createID(client, clock + diff), left.length - diff)
  } else {
    const leftItem = /** @type {Item} */ (left);
    const { client, clock } = leftItem.id;
    return new Item(
      createID(client, clock + diff),
      null,
      createID(client, clock + diff - 1),
      null,
      leftItem.rightOrigin,
      leftItem.parent,
      leftItem.parentSub,
      leftItem.content.splice(diff)
    )
  }
};

/**
 *
 * This function works similarly to `readUpdateV2`.
 *
 * @param {Array<Uint8Array>} updates
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 * @param {typeof UpdateEncoderV1 | typeof UpdateEncoderV2} [YEncoder]
 * @return {Uint8Array}
 */
const mergeUpdatesV2 = (updates, YDecoder = UpdateDecoderV2, YEncoder = UpdateEncoderV2) => {
  if (updates.length === 1) {
    return updates[0]
  }
  const updateDecoders = updates.map(update => new YDecoder(createDecoder(update)));
  let lazyStructDecoders = updateDecoders.map(decoder => new LazyStructReader(decoder, true));

  /**
   * @todo we don't need offset because we always slice before
   * @type {null | { struct: Item | GC | Skip, offset: number }}
   */
  let currWrite = null;

  const updateEncoder = new YEncoder();
  // write structs lazily
  const lazyStructEncoder = new LazyStructWriter(updateEncoder);

  // Note: We need to ensure that all lazyStructDecoders are fully consumed
  // Note: Should merge document updates whenever possible - even from different updates
  // Note: Should handle that some operations cannot be applied yet ()

  while (true) {
    // Write higher clients first ⇒ sort by clientID & clock and remove decoders without content
    lazyStructDecoders = lazyStructDecoders.filter(dec => dec.curr !== null);
    lazyStructDecoders.sort(
      /** @type {function(any,any):number} */ (dec1, dec2) => {
        if (dec1.curr.id.client === dec2.curr.id.client) {
          const clockDiff = dec1.curr.id.clock - dec2.curr.id.clock;
          if (clockDiff === 0) {
            // @todo remove references to skip since the structDecoders must filter Skips.
            return dec1.curr.constructor === dec2.curr.constructor
              ? 0
              : dec1.curr.constructor === Skip ? 1 : -1 // we are filtering skips anyway.
          } else {
            return clockDiff
          }
        } else {
          return dec2.curr.id.client - dec1.curr.id.client
        }
      }
    );
    if (lazyStructDecoders.length === 0) {
      break
    }
    const currDecoder = lazyStructDecoders[0];
    // write from currDecoder until the next operation is from another client or if filler-struct
    // then we need to reorder the decoders and find the next operation to write
    const firstClient = /** @type {Item | GC} */ (currDecoder.curr).id.client;

    if (currWrite !== null) {
      let curr = /** @type {Item | GC | null} */ (currDecoder.curr);
      let iterated = false;

      // iterate until we find something that we haven't written already
      // remember: first the high client-ids are written
      while (curr !== null && curr.id.clock + curr.length <= currWrite.struct.id.clock + currWrite.struct.length && curr.id.client >= currWrite.struct.id.client) {
        curr = currDecoder.next();
        iterated = true;
      }
      if (
        curr === null || // current decoder is empty
        curr.id.client !== firstClient || // check whether there is another decoder that has has updates from `firstClient`
        (iterated && curr.id.clock > currWrite.struct.id.clock + currWrite.struct.length) // the above while loop was used and we are potentially missing updates
      ) {
        continue
      }

      if (firstClient !== currWrite.struct.id.client) {
        writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
        currWrite = { struct: curr, offset: 0 };
        currDecoder.next();
      } else {
        if (currWrite.struct.id.clock + currWrite.struct.length < curr.id.clock) {
          // @todo write currStruct & set currStruct = Skip(clock = currStruct.id.clock + currStruct.length, length = curr.id.clock - self.clock)
          if (currWrite.struct.constructor === Skip) {
            // extend existing skip
            currWrite.struct.length = curr.id.clock + curr.length - currWrite.struct.id.clock;
          } else {
            writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
            const diff = curr.id.clock - currWrite.struct.id.clock - currWrite.struct.length;
            /**
             * @type {Skip}
             */
            const struct = new Skip(createID(firstClient, currWrite.struct.id.clock + currWrite.struct.length), diff);
            currWrite = { struct, offset: 0 };
          }
        } else { // if (currWrite.struct.id.clock + currWrite.struct.length >= curr.id.clock) {
          const diff = currWrite.struct.id.clock + currWrite.struct.length - curr.id.clock;
          if (diff > 0) {
            if (currWrite.struct.constructor === Skip) {
              // prefer to slice Skip because the other struct might contain more information
              currWrite.struct.length -= diff;
            } else {
              curr = sliceStruct(curr, diff);
            }
          }
          if (!currWrite.struct.mergeWith(/** @type {any} */ (curr))) {
            writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
            currWrite = { struct: curr, offset: 0 };
            currDecoder.next();
          }
        }
      }
    } else {
      currWrite = { struct: /** @type {Item | GC} */ (currDecoder.curr), offset: 0 };
      currDecoder.next();
    }
    for (
      let next = currDecoder.curr;
      next !== null && next.id.client === firstClient && next.id.clock === currWrite.struct.id.clock + currWrite.struct.length && next.constructor !== Skip;
      next = currDecoder.next()
    ) {
      writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
      currWrite = { struct: next, offset: 0 };
    }
  }
  if (currWrite !== null) {
    writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
    currWrite = null;
  }
  finishLazyStructWriting(lazyStructEncoder);

  const dss = updateDecoders.map(decoder => readDeleteSet(decoder));
  const ds = mergeDeleteSets(dss);
  writeDeleteSet(updateEncoder, ds);
  return updateEncoder.toUint8Array()
};

/**
 * @param {Uint8Array} update
 * @param {Uint8Array} sv
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 * @param {typeof UpdateEncoderV1 | typeof UpdateEncoderV2} [YEncoder]
 */
const diffUpdateV2 = (update, sv, YDecoder = UpdateDecoderV2, YEncoder = UpdateEncoderV2) => {
  const state = decodeStateVector(sv);
  const encoder = new YEncoder();
  const lazyStructWriter = new LazyStructWriter(encoder);
  const decoder = new YDecoder(createDecoder(update));
  const reader = new LazyStructReader(decoder, false);
  while (reader.curr) {
    const curr = reader.curr;
    const currClient = curr.id.client;
    const svClock = state.get(currClient) || 0;
    if (reader.curr.constructor === Skip) {
      // the first written struct shouldn't be a skip
      reader.next();
      continue
    }
    if (curr.id.clock + curr.length > svClock) {
      writeStructToLazyStructWriter(lazyStructWriter, curr, max(svClock - curr.id.clock, 0));
      reader.next();
      while (reader.curr && reader.curr.id.client === currClient) {
        writeStructToLazyStructWriter(lazyStructWriter, reader.curr, 0);
        reader.next();
      }
    } else {
      // read until something new comes up
      while (reader.curr && reader.curr.id.client === currClient && reader.curr.id.clock + reader.curr.length <= svClock) {
        reader.next();
      }
    }
  }
  finishLazyStructWriting(lazyStructWriter);
  // write ds
  const ds = readDeleteSet(decoder);
  writeDeleteSet(encoder, ds);
  return encoder.toUint8Array()
};

/**
 * @param {Uint8Array} update
 * @param {Uint8Array} sv
 */
const diffUpdate = (update, sv) => diffUpdateV2(update, sv, UpdateDecoderV1, UpdateEncoderV1);

/**
 * @param {LazyStructWriter} lazyWriter
 */
const flushLazyStructWriter = lazyWriter => {
  if (lazyWriter.written > 0) {
    lazyWriter.clientStructs.push({ written: lazyWriter.written, restEncoder: _toUint8Array(lazyWriter.encoder.restEncoder) });
    lazyWriter.encoder.restEncoder = createEncoder();
    lazyWriter.written = 0;
  }
};

/**
 * @param {LazyStructWriter} lazyWriter
 * @param {Item | GC} struct
 * @param {number} offset
 */
const writeStructToLazyStructWriter = (lazyWriter, struct, offset) => {
  // flush curr if we start another client
  if (lazyWriter.written > 0 && lazyWriter.currClient !== struct.id.client) {
    flushLazyStructWriter(lazyWriter);
  }
  if (lazyWriter.written === 0) {
    lazyWriter.currClient = struct.id.client;
    // write next client
    lazyWriter.encoder.writeClient(struct.id.client);
    // write startClock
    writeVarUint(lazyWriter.encoder.restEncoder, struct.id.clock + offset);
  }
  struct.write(lazyWriter.encoder, offset);
  lazyWriter.written++;
};
/**
 * Call this function when we collected all parts and want to
 * put all the parts together. After calling this method,
 * you can continue using the UpdateEncoder.
 *
 * @param {LazyStructWriter} lazyWriter
 */
const finishLazyStructWriting = (lazyWriter) => {
  flushLazyStructWriter(lazyWriter);

  // this is a fresh encoder because we called flushCurr
  const restEncoder = lazyWriter.encoder.restEncoder;

  /**
   * Now we put all the fragments together.
   * This works similarly to `writeClientsStructs`
   */

  // write # states that were updated - i.e. the clients
  writeVarUint(restEncoder, lazyWriter.clientStructs.length);

  for (let i = 0; i < lazyWriter.clientStructs.length; i++) {
    const partStructs = lazyWriter.clientStructs[i];
    /**
     * Works similarly to `writeStructs`
     */
    // write # encoded structs
    writeVarUint(restEncoder, partStructs.written);
    // write the rest of the fragment
    writeUint8Array(restEncoder, partStructs.restEncoder);
  }
};

/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} YDecoder
 * @param {typeof UpdateEncoderV2 | typeof UpdateEncoderV1 } YEncoder
 */
const convertUpdateFormat = (update, YDecoder, YEncoder) => {
  const updateDecoder = new YDecoder(createDecoder(update));
  const lazyDecoder = new LazyStructReader(updateDecoder, false);
  const updateEncoder = new YEncoder();
  const lazyWriter = new LazyStructWriter(updateEncoder);

  for (let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next()) {
    writeStructToLazyStructWriter(lazyWriter, curr, 0);
  }
  finishLazyStructWriting(lazyWriter);
  const ds = readDeleteSet(updateDecoder);
  writeDeleteSet(updateEncoder, ds);
  return updateEncoder.toUint8Array()
};

/**
 * @param {Uint8Array} update
 */
const convertUpdateFormatV1ToV2 = update => convertUpdateFormat(update, UpdateDecoderV1, UpdateEncoderV2);

/**
 * @param {Uint8Array} update
 */
const convertUpdateFormatV2ToV1 = update => convertUpdateFormat(update, UpdateDecoderV2, UpdateEncoderV1);

/**
 * @template {AbstractType<any>} T
 * YEvent describes the changes on a YType.
 */
class YEvent {
  /**
   * @param {T} target The changed type.
   * @param {Transaction} transaction
   */
  constructor (target, transaction) {
    /**
     * The type on which this event was created on.
     * @type {T}
     */
    this.target = target;
    /**
     * The current target on which the observe callback is called.
     * @type {AbstractType<any>}
     */
    this.currentTarget = target;
    /**
     * The transaction that triggered this event.
     * @type {Transaction}
     */
    this.transaction = transaction;
    /**
     * @type {Object|null}
     */
    this._changes = null;
    /**
     * @type {null | Map<string, { action: 'add' | 'update' | 'delete', oldValue: any, newValue: any }>}
     */
    this._keys = null;
    /**
     * @type {null | Array<{ insert?: string | Array<any> | object | AbstractType<any>, retain?: number, delete?: number, attributes?: Object<string, any> }>}
     */
    this._delta = null;
  }

  /**
   * Computes the path from `y` to the changed type.
   *
   * @todo v14 should standardize on path: Array<{parent, index}> because that is easier to work with.
   *
   * The following property holds:
   * @example
   *   let type = y
   *   event.path.forEach(dir => {
   *     type = type.get(dir)
   *   })
   *   type === event.target // => true
   */
  get path () {
    // @ts-ignore _item is defined because target is integrated
    return getPathTo(this.currentTarget, this.target)
  }

  /**
   * Check if a struct is deleted by this event.
   *
   * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
   *
   * @param {AbstractStruct} struct
   * @return {boolean}
   */
  deletes (struct) {
    return isDeleted(this.transaction.deleteSet, struct.id)
  }

  /**
   * @type {Map<string, { action: 'add' | 'update' | 'delete', oldValue: any, newValue: any }>}
   */
  get keys () {
    if (this._keys === null) {
      const keys = new Map();
      const target = this.target;
      const changed = /** @type Set<string|null> */ (this.transaction.changed.get(target));
      changed.forEach(key => {
        if (key !== null) {
          const item = /** @type {Item} */ (target._map.get(key));
          /**
           * @type {'delete' | 'add' | 'update'}
           */
          let action;
          let oldValue;
          if (this.adds(item)) {
            let prev = item.left;
            while (prev !== null && this.adds(prev)) {
              prev = prev.left;
            }
            if (this.deletes(item)) {
              if (prev !== null && this.deletes(prev)) {
                action = 'delete';
                oldValue = last(prev.content.getContent());
              } else {
                return
              }
            } else {
              if (prev !== null && this.deletes(prev)) {
                action = 'update';
                oldValue = last(prev.content.getContent());
              } else {
                action = 'add';
                oldValue = undefined;
              }
            }
          } else {
            if (this.deletes(item)) {
              action = 'delete';
              oldValue = last(/** @type {Item} */ item.content.getContent());
            } else {
              return // nop
            }
          }
          keys.set(key, { action, oldValue });
        }
      });
      this._keys = keys;
    }
    return this._keys
  }

  /**
   * @type {Array<{insert?: string | Array<any> | object | AbstractType<any>, retain?: number, delete?: number, attributes?: Object<string, any>}>}
   */
  get delta () {
    return this.changes.delta
  }

  /**
   * Check if a struct is added by this event.
   *
   * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
   *
   * @param {AbstractStruct} struct
   * @return {boolean}
   */
  adds (struct) {
    return struct.id.clock >= (this.transaction.beforeState.get(struct.id.client) || 0)
  }

  /**
   * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
   */
  get changes () {
    let changes = this._changes;
    if (changes === null) {
      const target = this.target;
      const added = set_create();
      const deleted = set_create();
      /**
       * @type {Array<{insert:Array<any>}|{delete:number}|{retain:number}>}
       */
      const delta = [];
      changes = {
        added,
        deleted,
        delta,
        keys: this.keys
      };
      const changed = /** @type Set<string|null> */ (this.transaction.changed.get(target));
      if (changed.has(null)) {
        /**
         * @type {any}
         */
        let lastOp = null;
        const packOp = () => {
          if (lastOp) {
            delta.push(lastOp);
          }
        };
        for (let item = target._start; item !== null; item = item.right) {
          if (item.deleted) {
            if (this.deletes(item) && !this.adds(item)) {
              if (lastOp === null || lastOp.delete === undefined) {
                packOp();
                lastOp = { delete: 0 };
              }
              lastOp.delete += item.length;
              deleted.add(item);
            } // else nop
          } else {
            if (this.adds(item)) {
              if (lastOp === null || lastOp.insert === undefined) {
                packOp();
                lastOp = { insert: [] };
              }
              lastOp.insert = lastOp.insert.concat(item.content.getContent());
              added.add(item);
            } else {
              if (lastOp === null || lastOp.retain === undefined) {
                packOp();
                lastOp = { retain: 0 };
              }
              lastOp.retain += item.length;
            }
          }
        }
        if (lastOp !== null && lastOp.retain === undefined) {
          packOp();
        }
      }
      this._changes = changes;
    }
    return /** @type {any} */ (changes)
  }
}

/**
 * Compute the path from this type to the specified target.
 *
 * @example
 *   // `child` should be accessible via `type.get(path[0]).get(path[1])..`
 *   const path = type.getPathTo(child)
 *   // assuming `type instanceof YArray`
 *   console.log(path) // might look like => [2, 'key1']
 *   child === type.get(path[0]).get(path[1])
 *
 * @param {AbstractType<any>} parent
 * @param {AbstractType<any>} child target
 * @return {Array<string|number>} Path to the target
 *
 * @private
 * @function
 */
const getPathTo = (parent, child) => {
  const path = [];
  while (child._item !== null && child !== parent) {
    if (child._item.parentSub !== null) {
      // parent is map-ish
      path.unshift(child._item.parentSub);
    } else {
      // parent is array-ish
      let i = 0;
      let c = /** @type {AbstractType<any>} */ (child._item.parent)._start;
      while (c !== child._item && c !== null) {
        if (!c.deleted) {
          i++;
        }
        c = c.right;
      }
      path.unshift(i);
    }
    child = /** @type {AbstractType<any>} */ (child._item.parent);
  }
  return path
};

const maxSearchMarker = 80;

/**
 * A unique timestamp that identifies each marker.
 *
 * Time is relative,.. this is more like an ever-increasing clock.
 *
 * @type {number}
 */
let globalSearchMarkerTimestamp = 0;

class ArraySearchMarker {
  /**
   * @param {Item} p
   * @param {number} index
   */
  constructor (p, index) {
    p.marker = true;
    this.p = p;
    this.index = index;
    this.timestamp = globalSearchMarkerTimestamp++;
  }
}

/**
 * @param {ArraySearchMarker} marker
 */
const refreshMarkerTimestamp = marker => { marker.timestamp = globalSearchMarkerTimestamp++; };

/**
 * This is rather complex so this function is the only thing that should overwrite a marker
 *
 * @param {ArraySearchMarker} marker
 * @param {Item} p
 * @param {number} index
 */
const overwriteMarker = (marker, p, index) => {
  marker.p.marker = false;
  marker.p = p;
  p.marker = true;
  marker.index = index;
  marker.timestamp = globalSearchMarkerTimestamp++;
};

/**
 * @param {Array<ArraySearchMarker>} searchMarker
 * @param {Item} p
 * @param {number} index
 */
const markPosition = (searchMarker, p, index) => {
  if (searchMarker.length >= maxSearchMarker) {
    // override oldest marker (we don't want to create more objects)
    const marker = searchMarker.reduce((a, b) => a.timestamp < b.timestamp ? a : b);
    overwriteMarker(marker, p, index);
    return marker
  } else {
    // create new marker
    const pm = new ArraySearchMarker(p, index);
    searchMarker.push(pm);
    return pm
  }
};

/**
 * Search marker help us to find positions in the associative array faster.
 *
 * They speed up the process of finding a position without much bookkeeping.
 *
 * A maximum of `maxSearchMarker` objects are created.
 *
 * This function always returns a refreshed marker (updated timestamp)
 *
 * @param {AbstractType<any>} yarray
 * @param {number} index
 */
const findMarker = (yarray, index) => {
  if (yarray._start === null || index === 0 || yarray._searchMarker === null) {
    return null
  }
  const marker = yarray._searchMarker.length === 0 ? null : yarray._searchMarker.reduce((a, b) => abs(index - a.index) < abs(index - b.index) ? a : b);
  let p = yarray._start;
  let pindex = 0;
  if (marker !== null) {
    p = marker.p;
    pindex = marker.index;
    refreshMarkerTimestamp(marker); // we used it, we might need to use it again
  }
  // iterate to right if possible
  while (p.right !== null && pindex < index) {
    if (!p.deleted && p.countable) {
      if (index < pindex + p.length) {
        break
      }
      pindex += p.length;
    }
    p = p.right;
  }
  // iterate to left if necessary (might be that pindex > index)
  while (p.left !== null && pindex > index) {
    p = p.left;
    if (!p.deleted && p.countable) {
      pindex -= p.length;
    }
  }
  // we want to make sure that p can't be merged with left, because that would screw up everything
  // in that cas just return what we have (it is most likely the best marker anyway)
  // iterate to left until p can't be merged with left
  while (p.left !== null && p.left.id.client === p.id.client && p.left.id.clock + p.left.length === p.id.clock) {
    p = p.left;
    if (!p.deleted && p.countable) {
      pindex -= p.length;
    }
  }

  // @todo remove!
  // assure position
  // {
  //   let start = yarray._start
  //   let pos = 0
  //   while (start !== p) {
  //     if (!start.deleted && start.countable) {
  //       pos += start.length
  //     }
  //     start = /** @type {Item} */ (start.right)
  //   }
  //   if (pos !== pindex) {
  //     debugger
  //     throw new Error('Gotcha position fail!')
  //   }
  // }
  // if (marker) {
  //   if (window.lengthes == null) {
  //     window.lengthes = []
  //     window.getLengthes = () => window.lengthes.sort((a, b) => a - b)
  //   }
  //   window.lengthes.push(marker.index - pindex)
  //   console.log('distance', marker.index - pindex, 'len', p && p.parent.length)
  // }
  if (marker !== null && abs(marker.index - pindex) < /** @type {YText|YArray<any>} */ (p.parent).length / maxSearchMarker) {
    // adjust existing marker
    overwriteMarker(marker, p, pindex);
    return marker
  } else {
    // create new marker
    return markPosition(yarray._searchMarker, p, pindex)
  }
};

/**
 * Update markers when a change happened.
 *
 * This should be called before doing a deletion!
 *
 * @param {Array<ArraySearchMarker>} searchMarker
 * @param {number} index
 * @param {number} len If insertion, len is positive. If deletion, len is negative.
 */
const updateMarkerChanges = (searchMarker, index, len) => {
  for (let i = searchMarker.length - 1; i >= 0; i--) {
    const m = searchMarker[i];
    if (len > 0) {
      /**
       * @type {Item|null}
       */
      let p = m.p;
      p.marker = false;
      // Ideally we just want to do a simple position comparison, but this will only work if
      // search markers don't point to deleted items for formats.
      // Iterate marker to prev undeleted countable position so we know what to do when updating a position
      while (p && (p.deleted || !p.countable)) {
        p = p.left;
        if (p && !p.deleted && p.countable) {
          // adjust position. the loop should break now
          m.index -= p.length;
        }
      }
      if (p === null || p.marker === true) {
        // remove search marker if updated position is null or if position is already marked
        searchMarker.splice(i, 1);
        continue
      }
      m.p = p;
      p.marker = true;
    }
    if (index < m.index || (len > 0 && index === m.index)) { // a simple index <= m.index check would actually suffice
      m.index = max(index, m.index + len);
    }
  }
};

/**
 * Accumulate all (list) children of a type and return them as an Array.
 *
 * @param {AbstractType<any>} t
 * @return {Array<Item>}
 */
const getTypeChildren = t => {
  let s = t._start;
  const arr = [];
  while (s) {
    arr.push(s);
    s = s.right;
  }
  return arr
};

/**
 * Call event listeners with an event. This will also add an event to all
 * parents (for `.observeDeep` handlers).
 *
 * @template EventType
 * @param {AbstractType<EventType>} type
 * @param {Transaction} transaction
 * @param {EventType} event
 */
const callTypeObservers = (type, transaction, event) => {
  const changedType = type;
  const changedParentTypes = transaction.changedParentTypes;
  while (true) {
    // @ts-ignore
    setIfUndefined(changedParentTypes, type, () => []).push(event);
    if (type._item === null) {
      break
    }
    type = /** @type {AbstractType<any>} */ (type._item.parent);
  }
  callEventHandlerListeners(changedType._eH, event, transaction);
};

/**
 * @template EventType
 * Abstract Yjs Type class
 */
class AbstractType {
  constructor () {
    /**
     * @type {Item|null}
     */
    this._item = null;
    /**
     * @type {Map<string,Item>}
     */
    this._map = new Map();
    /**
     * @type {Item|null}
     */
    this._start = null;
    /**
     * @type {Doc|null}
     */
    this.doc = null;
    this._length = 0;
    /**
     * Event handlers
     * @type {EventHandler<EventType,Transaction>}
     */
    this._eH = createEventHandler();
    /**
     * Deep event handlers
     * @type {EventHandler<Array<YEvent<any>>,Transaction>}
     */
    this._dEH = createEventHandler();
    /**
     * @type {null | Array<ArraySearchMarker>}
     */
    this._searchMarker = null;
  }

  /**
   * @return {AbstractType<any>|null}
   */
  get parent () {
    return this._item ? /** @type {AbstractType<any>} */ (this._item.parent) : null
  }

  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item|null} item
   */
  _integrate (y, item) {
    this.doc = y;
    this._item = item;
  }

  /**
   * @return {AbstractType<EventType>}
   */
  _copy () {
    throw methodUnimplemented()
  }

  /**
   * @return {AbstractType<EventType>}
   */
  clone () {
    throw methodUnimplemented()
  }

  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  _write (encoder) { }

  /**
   * The first non-deleted item
   */
  get _first () {
    let n = this._start;
    while (n !== null && n.deleted) {
      n = n.right;
    }
    return n
  }

  /**
   * Creates YEvent and calls all type observers.
   * Must be implemented by each type.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver (transaction, parentSubs) {
    if (!transaction.local && this._searchMarker) {
      this._searchMarker.length = 0;
    }
  }

  /**
   * Observe all events that are created on this type.
   *
   * @param {function(EventType, Transaction):void} f Observer function
   */
  observe (f) {
    addEventHandlerListener(this._eH, f);
  }

  /**
   * Observe all events that are created by this type and its children.
   *
   * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
   */
  observeDeep (f) {
    addEventHandlerListener(this._dEH, f);
  }

  /**
   * Unregister an observer function.
   *
   * @param {function(EventType,Transaction):void} f Observer function
   */
  unobserve (f) {
    removeEventHandlerListener(this._eH, f);
  }

  /**
   * Unregister an observer function.
   *
   * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
   */
  unobserveDeep (f) {
    removeEventHandlerListener(this._dEH, f);
  }

  /**
   * @abstract
   * @return {any}
   */
  toJSON () {}
}

/**
 * @param {AbstractType<any>} type
 * @param {number} start
 * @param {number} end
 * @return {Array<any>}
 *
 * @private
 * @function
 */
const typeListSlice = (type, start, end) => {
  if (start < 0) {
    start = type._length + start;
  }
  if (end < 0) {
    end = type._length + end;
  }
  let len = end - start;
  const cs = [];
  let n = type._start;
  while (n !== null && len > 0) {
    if (n.countable && !n.deleted) {
      const c = n.content.getContent();
      if (c.length <= start) {
        start -= c.length;
      } else {
        for (let i = start; i < c.length && len > 0; i++) {
          cs.push(c[i]);
          len--;
        }
        start = 0;
      }
    }
    n = n.right;
  }
  return cs
};

/**
 * @param {AbstractType<any>} type
 * @return {Array<any>}
 *
 * @private
 * @function
 */
const typeListToArray = type => {
  const cs = [];
  let n = type._start;
  while (n !== null) {
    if (n.countable && !n.deleted) {
      const c = n.content.getContent();
      for (let i = 0; i < c.length; i++) {
        cs.push(c[i]);
      }
    }
    n = n.right;
  }
  return cs
};

/**
 * @param {AbstractType<any>} type
 * @param {Snapshot} snapshot
 * @return {Array<any>}
 *
 * @private
 * @function
 */
const typeListToArraySnapshot = (type, snapshot) => {
  const cs = [];
  let n = type._start;
  while (n !== null) {
    if (n.countable && isVisible(n, snapshot)) {
      const c = n.content.getContent();
      for (let i = 0; i < c.length; i++) {
        cs.push(c[i]);
      }
    }
    n = n.right;
  }
  return cs
};

/**
 * Executes a provided function on once on overy element of this YArray.
 *
 * @param {AbstractType<any>} type
 * @param {function(any,number,any):void} f A function to execute on every element of this YArray.
 *
 * @private
 * @function
 */
const typeListForEach = (type, f) => {
  let index = 0;
  let n = type._start;
  while (n !== null) {
    if (n.countable && !n.deleted) {
      const c = n.content.getContent();
      for (let i = 0; i < c.length; i++) {
        f(c[i], index++, type);
      }
    }
    n = n.right;
  }
};

/**
 * @template C,R
 * @param {AbstractType<any>} type
 * @param {function(C,number,AbstractType<any>):R} f
 * @return {Array<R>}
 *
 * @private
 * @function
 */
const typeListMap = (type, f) => {
  /**
   * @type {Array<any>}
   */
  const result = [];
  typeListForEach(type, (c, i) => {
    result.push(f(c, i, type));
  });
  return result
};

/**
 * @param {AbstractType<any>} type
 * @return {IterableIterator<any>}
 *
 * @private
 * @function
 */
const typeListCreateIterator = type => {
  let n = type._start;
  /**
   * @type {Array<any>|null}
   */
  let currentContent = null;
  let currentContentIndex = 0;
  return {
    [Symbol.iterator] () {
      return this
    },
    next: () => {
      // find some content
      if (currentContent === null) {
        while (n !== null && n.deleted) {
          n = n.right;
        }
        // check if we reached the end, no need to check currentContent, because it does not exist
        if (n === null) {
          return {
            done: true,
            value: undefined
          }
        }
        // we found n, so we can set currentContent
        currentContent = n.content.getContent();
        currentContentIndex = 0;
        n = n.right; // we used the content of n, now iterate to next
      }
      const value = currentContent[currentContentIndex++];
      // check if we need to empty currentContent
      if (currentContent.length <= currentContentIndex) {
        currentContent = null;
      }
      return {
        done: false,
        value
      }
    }
  }
};

/**
 * @param {AbstractType<any>} type
 * @param {number} index
 * @return {any}
 *
 * @private
 * @function
 */
const typeListGet = (type, index) => {
  const marker = findMarker(type, index);
  let n = type._start;
  if (marker !== null) {
    n = marker.p;
    index -= marker.index;
  }
  for (; n !== null; n = n.right) {
    if (!n.deleted && n.countable) {
      if (index < n.length) {
        return n.content.getContent()[index]
      }
      index -= n.length;
    }
  }
};

/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {Item?} referenceItem
 * @param {Array<Object<string,any>|Array<any>|boolean|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */
const typeListInsertGenericsAfter = (transaction, parent, referenceItem, content) => {
  let left = referenceItem;
  const doc = transaction.doc;
  const ownClientId = doc.clientID;
  const store = doc.store;
  const right = referenceItem === null ? parent._start : referenceItem.right;
  /**
   * @type {Array<Object|Array<any>|number|null>}
   */
  let jsonContent = [];
  const packJsonContent = () => {
    if (jsonContent.length > 0) {
      left = new Item(createID(ownClientId, getState(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new ContentAny(jsonContent));
      left.integrate(transaction, 0);
      jsonContent = [];
    }
  };
  content.forEach(c => {
    if (c === null) {
      jsonContent.push(c);
    } else {
      switch (c.constructor) {
        case Number:
        case Object:
        case Boolean:
        case Array:
        case String:
          jsonContent.push(c);
          break
        default:
          packJsonContent();
          switch (c.constructor) {
            case Uint8Array:
            case ArrayBuffer:
              left = new Item(createID(ownClientId, getState(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new ContentBinary(new Uint8Array(/** @type {Uint8Array} */ (c))));
              left.integrate(transaction, 0);
              break
            case Doc:
              left = new Item(createID(ownClientId, getState(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new ContentDoc(/** @type {Doc} */ (c)));
              left.integrate(transaction, 0);
              break
            default:
              if (c instanceof AbstractType) {
                left = new Item(createID(ownClientId, getState(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new ContentType(c));
                left.integrate(transaction, 0);
              } else {
                throw new Error('Unexpected content type in insert operation')
              }
          }
      }
    }
  });
  packJsonContent();
};

const lengthExceeded = error_create('Length exceeded!');

/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @param {Array<Object<string,any>|Array<any>|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */
const typeListInsertGenerics = (transaction, parent, index, content) => {
  if (index > parent._length) {
    throw lengthExceeded
  }
  if (index === 0) {
    if (parent._searchMarker) {
      updateMarkerChanges(parent._searchMarker, index, content.length);
    }
    return typeListInsertGenericsAfter(transaction, parent, null, content)
  }
  const startIndex = index;
  const marker = findMarker(parent, index);
  let n = parent._start;
  if (marker !== null) {
    n = marker.p;
    index -= marker.index;
    // we need to iterate one to the left so that the algorithm works
    if (index === 0) {
      // @todo refactor this as it actually doesn't consider formats
      n = n.prev; // important! get the left undeleted item so that we can actually decrease index
      index += (n && n.countable && !n.deleted) ? n.length : 0;
    }
  }
  for (; n !== null; n = n.right) {
    if (!n.deleted && n.countable) {
      if (index <= n.length) {
        if (index < n.length) {
          // insert in-between
          getItemCleanStart(transaction, createID(n.id.client, n.id.clock + index));
        }
        break
      }
      index -= n.length;
    }
  }
  if (parent._searchMarker) {
    updateMarkerChanges(parent._searchMarker, startIndex, content.length);
  }
  return typeListInsertGenericsAfter(transaction, parent, n, content)
};

/**
 * Pushing content is special as we generally want to push after the last item. So we don't have to update
 * the serach marker.
 *
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {Array<Object<string,any>|Array<any>|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */
const typeListPushGenerics = (transaction, parent, content) => {
  // Use the marker with the highest index and iterate to the right.
  const marker = (parent._searchMarker || []).reduce((maxMarker, currMarker) => currMarker.index > maxMarker.index ? currMarker : maxMarker, { index: 0, p: parent._start });
  let n = marker.p;
  if (n) {
    while (n.right) {
      n = n.right;
    }
  }
  return typeListInsertGenericsAfter(transaction, parent, n, content)
};

/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @param {number} length
 *
 * @private
 * @function
 */
const typeListDelete = (transaction, parent, index, length) => {
  if (length === 0) { return }
  const startIndex = index;
  const startLength = length;
  const marker = findMarker(parent, index);
  let n = parent._start;
  if (marker !== null) {
    n = marker.p;
    index -= marker.index;
  }
  // compute the first item to be deleted
  for (; n !== null && index > 0; n = n.right) {
    if (!n.deleted && n.countable) {
      if (index < n.length) {
        getItemCleanStart(transaction, createID(n.id.client, n.id.clock + index));
      }
      index -= n.length;
    }
  }
  // delete all items until done
  while (length > 0 && n !== null) {
    if (!n.deleted) {
      if (length < n.length) {
        getItemCleanStart(transaction, createID(n.id.client, n.id.clock + length));
      }
      n.delete(transaction);
      length -= n.length;
    }
    n = n.right;
  }
  if (length > 0) {
    throw lengthExceeded
  }
  if (parent._searchMarker) {
    updateMarkerChanges(parent._searchMarker, startIndex, -startLength + length /* in case we remove the above exception */);
  }
};

/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {string} key
 *
 * @private
 * @function
 */
const typeMapDelete = (transaction, parent, key) => {
  const c = parent._map.get(key);
  if (c !== undefined) {
    c.delete(transaction);
  }
};

/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @param {Object|number|null|Array<any>|string|Uint8Array|AbstractType<any>} value
 *
 * @private
 * @function
 */
const typeMapSet = (transaction, parent, key, value) => {
  const left = parent._map.get(key) || null;
  const doc = transaction.doc;
  const ownClientId = doc.clientID;
  let content;
  if (value == null) {
    content = new ContentAny([value]);
  } else {
    switch (value.constructor) {
      case Number:
      case Object:
      case Boolean:
      case Array:
      case String:
        content = new ContentAny([value]);
        break
      case Uint8Array:
        content = new ContentBinary(/** @type {Uint8Array} */ (value));
        break
      case Doc:
        content = new ContentDoc(/** @type {Doc} */ (value));
        break
      default:
        if (value instanceof AbstractType) {
          content = new ContentType(value);
        } else {
          throw new Error('Unexpected content type')
        }
    }
  }
  new Item(createID(ownClientId, getState(doc.store, ownClientId)), left, left && left.lastId, null, null, parent, key, content).integrate(transaction, 0);
};

/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @return {Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined}
 *
 * @private
 * @function
 */
const typeMapGet = (parent, key) => {
  const val = parent._map.get(key);
  return val !== undefined && !val.deleted ? val.content.getContent()[val.length - 1] : undefined
};

/**
 * @param {AbstractType<any>} parent
 * @return {Object<string,Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined>}
 *
 * @private
 * @function
 */
const typeMapGetAll = (parent) => {
  /**
   * @type {Object<string,any>}
   */
  const res = {};
  parent._map.forEach((value, key) => {
    if (!value.deleted) {
      res[key] = value.content.getContent()[value.length - 1];
    }
  });
  return res
};

/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @return {boolean}
 *
 * @private
 * @function
 */
const typeMapHas = (parent, key) => {
  const val = parent._map.get(key);
  return val !== undefined && !val.deleted
};

/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @param {Snapshot} snapshot
 * @return {Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined}
 *
 * @private
 * @function
 */
const typeMapGetSnapshot = (parent, key, snapshot) => {
  let v = parent._map.get(key) || null;
  while (v !== null && (!snapshot.sv.has(v.id.client) || v.id.clock >= (snapshot.sv.get(v.id.client) || 0))) {
    v = v.left;
  }
  return v !== null && isVisible(v, snapshot) ? v.content.getContent()[v.length - 1] : undefined
};

/**
 * @param {Map<string,Item>} map
 * @return {IterableIterator<Array<any>>}
 *
 * @private
 * @function
 */
const createMapIterator = map => iteratorFilter(map.entries(), /** @param {any} entry */ entry => !entry[1].deleted);

/**
 * @module YArray
 */

/**
 * Event that describes the changes on a YArray
 * @template T
 * @extends YEvent<YArray<T>>
 */
class YArrayEvent extends YEvent {
  /**
   * @param {YArray<T>} yarray The changed type
   * @param {Transaction} transaction The transaction object
   */
  constructor (yarray, transaction) {
    super(yarray, transaction);
    this._transaction = transaction;
  }
}

/**
 * A shared Array implementation.
 * @template T
 * @extends AbstractType<YArrayEvent<T>>
 * @implements {Iterable<T>}
 */
class YArray extends AbstractType {
  constructor () {
    super();
    /**
     * @type {Array<any>?}
     * @private
     */
    this._prelimContent = [];
    /**
     * @type {Array<ArraySearchMarker>}
     */
    this._searchMarker = [];
  }

  /**
   * Construct a new YArray containing the specified items.
   * @template T
   * @param {Array<T>} items
   * @return {YArray<T>}
   */
  static from (items) {
    const a = new YArray();
    a.push(items);
    return a
  }

  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */
  _integrate (y, item) {
    super._integrate(y, item);
    this.insert(0, /** @type {Array<any>} */ (this._prelimContent));
    this._prelimContent = null;
  }

  _copy () {
    return new YArray()
  }

  /**
   * @return {YArray<T>}
   */
  clone () {
    const arr = new YArray();
    arr.insert(0, this.toArray().map(el =>
      el instanceof AbstractType ? el.clone() : el
    ));
    return arr
  }

  get length () {
    return this._prelimContent === null ? this._length : this._prelimContent.length
  }

  /**
   * Creates YArrayEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver (transaction, parentSubs) {
    super._callObserver(transaction, parentSubs);
    callTypeObservers(this, transaction, new YArrayEvent(this, transaction));
  }

  /**
   * Inserts new content at an index.
   *
   * Important: This function expects an array of content. Not just a content
   * object. The reason for this "weirdness" is that inserting several elements
   * is very efficient when it is done as a single operation.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  yarray.insert(0, ['a'])
   *  // Insert numbers 1, 2 at position 1
   *  yarray.insert(1, [1, 2])
   *
   * @param {number} index The index to insert content at.
   * @param {Array<T>} content The array of content
   */
  insert (index, content) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        typeListInsertGenerics(transaction, this, index, content);
      });
    } else {
      /** @type {Array<any>} */ (this._prelimContent).splice(index, 0, ...content);
    }
  }

  /**
   * Appends content to this YArray.
   *
   * @param {Array<T>} content Array of content to append.
   *
   * @todo Use the following implementation in all types.
   */
  push (content) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        typeListPushGenerics(transaction, this, content);
      });
    } else {
      /** @type {Array<any>} */ (this._prelimContent).push(...content);
    }
  }

  /**
   * Preppends content to this YArray.
   *
   * @param {Array<T>} content Array of content to preppend.
   */
  unshift (content) {
    this.insert(0, content);
  }

  /**
   * Deletes elements starting from an index.
   *
   * @param {number} index Index at which to start deleting elements
   * @param {number} length The number of elements to remove. Defaults to 1.
   */
  delete (index, length = 1) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        typeListDelete(transaction, this, index, length);
      });
    } else {
      /** @type {Array<any>} */ (this._prelimContent).splice(index, length);
    }
  }

  /**
   * Returns the i-th element from a YArray.
   *
   * @param {number} index The index of the element to return from the YArray
   * @return {T}
   */
  get (index) {
    return typeListGet(this, index)
  }

  /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @return {Array<T>}
   */
  toArray () {
    return typeListToArray(this)
  }

  /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @param {number} [start]
   * @param {number} [end]
   * @return {Array<T>}
   */
  slice (start = 0, end = this.length) {
    return typeListSlice(this, start, end)
  }

  /**
   * Transforms this Shared Type to a JSON object.
   *
   * @return {Array<any>}
   */
  toJSON () {
    return this.map(c => c instanceof AbstractType ? c.toJSON() : c)
  }

  /**
   * Returns an Array with the result of calling a provided function on every
   * element of this YArray.
   *
   * @template M
   * @param {function(T,number,YArray<T>):M} f Function that produces an element of the new Array
   * @return {Array<M>} A new array with each element being the result of the
   *                 callback function
   */
  map (f) {
    return typeListMap(this, /** @type {any} */ (f))
  }

  /**
   * Executes a provided function on once on overy element of this YArray.
   *
   * @param {function(T,number,YArray<T>):void} f A function to execute on every element of this YArray.
   */
  forEach (f) {
    typeListForEach(this, f);
  }

  /**
   * @return {IterableIterator<T>}
   */
  [Symbol.iterator] () {
    return typeListCreateIterator(this)
  }

  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  _write (encoder) {
    encoder.writeTypeRef(YArrayRefID);
  }
}

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 *
 * @private
 * @function
 */
const readYArray = decoder => new YArray();

/**
 * @template T
 * @extends YEvent<YMap<T>>
 * Event that describes the changes on a YMap.
 */
class YMapEvent extends YEvent {
  /**
   * @param {YMap<T>} ymap The YArray that changed.
   * @param {Transaction} transaction
   * @param {Set<any>} subs The keys that changed.
   */
  constructor (ymap, transaction, subs) {
    super(ymap, transaction);
    this.keysChanged = subs;
  }
}

/**
 * @template MapType
 * A shared Map implementation.
 *
 * @extends AbstractType<YMapEvent<MapType>>
 * @implements {Iterable<MapType>}
 */
class YMap extends AbstractType {
  /**
   *
   * @param {Iterable<readonly [string, any]>=} entries - an optional iterable to initialize the YMap
   */
  constructor (entries) {
    super();
    /**
     * @type {Map<string,any>?}
     * @private
     */
    this._prelimContent = null;

    if (entries === undefined) {
      this._prelimContent = new Map();
    } else {
      this._prelimContent = new Map(entries);
    }
  }

  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */
  _integrate (y, item) {
    super._integrate(y, item)
    ;/** @type {Map<string, any>} */ (this._prelimContent).forEach((value, key) => {
      this.set(key, value);
    });
    this._prelimContent = null;
  }

  _copy () {
    return new YMap()
  }

  /**
   * @return {YMap<MapType>}
   */
  clone () {
    const map = new YMap();
    this.forEach((value, key) => {
      map.set(key, value instanceof AbstractType ? value.clone() : value);
    });
    return map
  }

  /**
   * Creates YMapEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver (transaction, parentSubs) {
    callTypeObservers(this, transaction, new YMapEvent(this, transaction, parentSubs));
  }

  /**
   * Transforms this Shared Type to a JSON object.
   *
   * @return {Object<string,any>}
   */
  toJSON () {
    /**
     * @type {Object<string,MapType>}
     */
    const map = {};
    this._map.forEach((item, key) => {
      if (!item.deleted) {
        const v = item.content.getContent()[item.length - 1];
        map[key] = v instanceof AbstractType ? v.toJSON() : v;
      }
    });
    return map
  }

  /**
   * Returns the size of the YMap (count of key/value pairs)
   *
   * @return {number}
   */
  get size () {
    return [...createMapIterator(this._map)].length
  }

  /**
   * Returns the keys for each element in the YMap Type.
   *
   * @return {IterableIterator<string>}
   */
  keys () {
    return iteratorMap(createMapIterator(this._map), /** @param {any} v */ v => v[0])
  }

  /**
   * Returns the values for each element in the YMap Type.
   *
   * @return {IterableIterator<any>}
   */
  values () {
    return iteratorMap(createMapIterator(this._map), /** @param {any} v */ v => v[1].content.getContent()[v[1].length - 1])
  }

  /**
   * Returns an Iterator of [key, value] pairs
   *
   * @return {IterableIterator<any>}
   */
  entries () {
    return iteratorMap(createMapIterator(this._map), /** @param {any} v */ v => [v[0], v[1].content.getContent()[v[1].length - 1]])
  }

  /**
   * Executes a provided function on once on every key-value pair.
   *
   * @param {function(MapType,string,YMap<MapType>):void} f A function to execute on every element of this YArray.
   */
  forEach (f) {
    /**
     * @type {Object<string,MapType>}
     */
    const map = {};
    this._map.forEach((item, key) => {
      if (!item.deleted) {
        f(item.content.getContent()[item.length - 1], key, this);
      }
    });
    return map
  }

  /**
   * Returns an Iterator of [key, value] pairs
   *
   * @return {IterableIterator<any>}
   */
  [Symbol.iterator] () {
    return this.entries()
  }

  /**
   * Remove a specified element from this YMap.
   *
   * @param {string} key The key of the element to remove.
   */
  delete (key) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        typeMapDelete(transaction, this, key);
      });
    } else {
      /** @type {Map<string, any>} */ (this._prelimContent).delete(key);
    }
  }

  /**
   * Adds or updates an element with a specified key and value.
   *
   * @param {string} key The key of the element to add to this YMap
   * @param {MapType} value The value of the element to add
   */
  set (key, value) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        typeMapSet(transaction, this, key, value);
      });
    } else {
      /** @type {Map<string, any>} */ (this._prelimContent).set(key, value);
    }
    return value
  }

  /**
   * Returns a specified element from this YMap.
   *
   * @param {string} key
   * @return {MapType|undefined}
   */
  get (key) {
    return /** @type {any} */ (typeMapGet(this, key))
  }

  /**
   * Returns a boolean indicating whether the specified key exists or not.
   *
   * @param {string} key The key to test.
   * @return {boolean}
   */
  has (key) {
    return typeMapHas(this, key)
  }

  /**
   * Removes all elements from this YMap.
   */
  clear () {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        this.forEach(function (value, key, map) {
          typeMapDelete(transaction, map, key);
        });
      });
    } else {
      /** @type {Map<string, any>} */ (this._prelimContent).clear();
    }
  }

  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  _write (encoder) {
    encoder.writeTypeRef(YMapRefID);
  }
}

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 *
 * @private
 * @function
 */
const readYMap = decoder => new YMap();

/**
 * @param {any} a
 * @param {any} b
 * @return {boolean}
 */
const equalAttrs = (a, b) => a === b || (typeof a === 'object' && typeof b === 'object' && a && b && object_equalFlat(a, b));

class ItemTextListPosition {
  /**
   * @param {Item|null} left
   * @param {Item|null} right
   * @param {number} index
   * @param {Map<string,any>} currentAttributes
   */
  constructor (left, right, index, currentAttributes) {
    this.left = left;
    this.right = right;
    this.index = index;
    this.currentAttributes = currentAttributes;
  }

  /**
   * Only call this if you know that this.right is defined
   */
  forward () {
    if (this.right === null) {
      unexpectedCase();
    }
    switch (this.right.content.constructor) {
      case ContentFormat:
        if (!this.right.deleted) {
          updateCurrentAttributes(this.currentAttributes, /** @type {ContentFormat} */ (this.right.content));
        }
        break
      default:
        if (!this.right.deleted) {
          this.index += this.right.length;
        }
        break
    }
    this.left = this.right;
    this.right = this.right.right;
  }
}

/**
 * @param {Transaction} transaction
 * @param {ItemTextListPosition} pos
 * @param {number} count steps to move forward
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */
const findNextPosition = (transaction, pos, count) => {
  while (pos.right !== null && count > 0) {
    switch (pos.right.content.constructor) {
      case ContentFormat:
        if (!pos.right.deleted) {
          updateCurrentAttributes(pos.currentAttributes, /** @type {ContentFormat} */ (pos.right.content));
        }
        break
      default:
        if (!pos.right.deleted) {
          if (count < pos.right.length) {
            // split right
            getItemCleanStart(transaction, createID(pos.right.id.client, pos.right.id.clock + count));
          }
          pos.index += pos.right.length;
          count -= pos.right.length;
        }
        break
    }
    pos.left = pos.right;
    pos.right = pos.right.right;
    // pos.forward() - we don't forward because that would halve the performance because we already do the checks above
  }
  return pos
};

/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */
const findPosition = (transaction, parent, index) => {
  const currentAttributes = new Map();
  const marker = findMarker(parent, index);
  if (marker) {
    const pos = new ItemTextListPosition(marker.p.left, marker.p, marker.index, currentAttributes);
    return findNextPosition(transaction, pos, index - marker.index)
  } else {
    const pos = new ItemTextListPosition(null, parent._start, 0, currentAttributes);
    return findNextPosition(transaction, pos, index)
  }
};

/**
 * Negate applied formats
 *
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {Map<string,any>} negatedAttributes
 *
 * @private
 * @function
 */
const insertNegatedAttributes = (transaction, parent, currPos, negatedAttributes) => {
  // check if we really need to remove attributes
  while (
    currPos.right !== null && (
      currPos.right.deleted === true || (
        currPos.right.content.constructor === ContentFormat &&
        equalAttrs(negatedAttributes.get(/** @type {ContentFormat} */ (currPos.right.content).key), /** @type {ContentFormat} */ (currPos.right.content).value)
      )
    )
  ) {
    if (!currPos.right.deleted) {
      negatedAttributes.delete(/** @type {ContentFormat} */ (currPos.right.content).key);
    }
    currPos.forward();
  }
  const doc = transaction.doc;
  const ownClientId = doc.clientID;
  negatedAttributes.forEach((val, key) => {
    const left = currPos.left;
    const right = currPos.right;
    const nextFormat = new Item(createID(ownClientId, getState(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new ContentFormat(key, val));
    nextFormat.integrate(transaction, 0);
    currPos.right = nextFormat;
    currPos.forward();
  });
};

/**
 * @param {Map<string,any>} currentAttributes
 * @param {ContentFormat} format
 *
 * @private
 * @function
 */
const updateCurrentAttributes = (currentAttributes, format) => {
  const { key, value } = format;
  if (value === null) {
    currentAttributes.delete(key);
  } else {
    currentAttributes.set(key, value);
  }
};

/**
 * @param {ItemTextListPosition} currPos
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 */
const minimizeAttributeChanges = (currPos, attributes) => {
  // go right while attributes[right.key] === right.value (or right is deleted)
  while (true) {
    if (currPos.right === null) {
      break
    } else if (currPos.right.deleted || (currPos.right.content.constructor === ContentFormat && equalAttrs(attributes[(/** @type {ContentFormat} */ (currPos.right.content)).key] || null, /** @type {ContentFormat} */ (currPos.right.content).value))) ; else {
      break
    }
    currPos.forward();
  }
};

/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {Object<string,any>} attributes
 * @return {Map<string,any>}
 *
 * @private
 * @function
 **/
const insertAttributes = (transaction, parent, currPos, attributes) => {
  const doc = transaction.doc;
  const ownClientId = doc.clientID;
  const negatedAttributes = new Map();
  // insert format-start items
  for (const key in attributes) {
    const val = attributes[key];
    const currentVal = currPos.currentAttributes.get(key) || null;
    if (!equalAttrs(currentVal, val)) {
      // save negated attribute (set null if currentVal undefined)
      negatedAttributes.set(key, currentVal);
      const { left, right } = currPos;
      currPos.right = new Item(createID(ownClientId, getState(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new ContentFormat(key, val));
      currPos.right.integrate(transaction, 0);
      currPos.forward();
    }
  }
  return negatedAttributes
};

/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {string|object|AbstractType<any>} text
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 **/
const insertText = (transaction, parent, currPos, text, attributes) => {
  currPos.currentAttributes.forEach((val, key) => {
    if (attributes[key] === undefined) {
      attributes[key] = null;
    }
  });
  const doc = transaction.doc;
  const ownClientId = doc.clientID;
  minimizeAttributeChanges(currPos, attributes);
  const negatedAttributes = insertAttributes(transaction, parent, currPos, attributes);
  // insert content
  const content = text.constructor === String ? new ContentString(/** @type {string} */ (text)) : (text instanceof AbstractType ? new ContentType(text) : new ContentEmbed(text));
  let { left, right, index } = currPos;
  if (parent._searchMarker) {
    updateMarkerChanges(parent._searchMarker, currPos.index, content.getLength());
  }
  right = new Item(createID(ownClientId, getState(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, content);
  right.integrate(transaction, 0);
  currPos.right = right;
  currPos.index = index;
  currPos.forward();
  insertNegatedAttributes(transaction, parent, currPos, negatedAttributes);
};

/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {number} length
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 */
const formatText = (transaction, parent, currPos, length, attributes) => {
  const doc = transaction.doc;
  const ownClientId = doc.clientID;
  minimizeAttributeChanges(currPos, attributes);
  const negatedAttributes = insertAttributes(transaction, parent, currPos, attributes);
  // iterate until first non-format or null is found
  // delete all formats with attributes[format.key] != null
  // also check the attributes after the first non-format as we do not want to insert redundant negated attributes there
  while (currPos.right !== null && (length > 0 || currPos.right.content.constructor === ContentFormat)) {
    if (!currPos.right.deleted) {
      switch (currPos.right.content.constructor) {
        case ContentFormat: {
          const { key, value } = /** @type {ContentFormat} */ (currPos.right.content);
          const attr = attributes[key];
          if (attr !== undefined) {
            if (equalAttrs(attr, value)) {
              negatedAttributes.delete(key);
            } else {
              negatedAttributes.set(key, value);
            }
            currPos.right.delete(transaction);
          }
          break
        }
        default:
          if (length < currPos.right.length) {
            getItemCleanStart(transaction, createID(currPos.right.id.client, currPos.right.id.clock + length));
          }
          length -= currPos.right.length;
          break
      }
    }
    currPos.forward();
  }
  // Quill just assumes that the editor starts with a newline and that it always
  // ends with a newline. We only insert that newline when a new newline is
  // inserted - i.e when length is bigger than type.length
  if (length > 0) {
    let newlines = '';
    for (; length > 0; length--) {
      newlines += '\n';
    }
    currPos.right = new Item(createID(ownClientId, getState(doc.store, ownClientId)), currPos.left, currPos.left && currPos.left.lastId, currPos.right, currPos.right && currPos.right.id, parent, null, new ContentString(newlines));
    currPos.right.integrate(transaction, 0);
    currPos.forward();
  }
  insertNegatedAttributes(transaction, parent, currPos, negatedAttributes);
};

/**
 * Call this function after string content has been deleted in order to
 * clean up formatting Items.
 *
 * @param {Transaction} transaction
 * @param {Item} start
 * @param {Item|null} curr exclusive end, automatically iterates to the next Content Item
 * @param {Map<string,any>} startAttributes
 * @param {Map<string,any>} currAttributes
 * @return {number} The amount of formatting Items deleted.
 *
 * @function
 */
const cleanupFormattingGap = (transaction, start, curr, startAttributes, currAttributes) => {
  let end = curr;
  const endAttributes = copy(currAttributes);
  while (end && (!end.countable || end.deleted)) {
    if (!end.deleted && end.content.constructor === ContentFormat) {
      updateCurrentAttributes(endAttributes, /** @type {ContentFormat} */ (end.content));
    }
    end = end.right;
  }
  let cleanups = 0;
  let reachedEndOfCurr = false;
  while (start !== end) {
    if (curr === start) {
      reachedEndOfCurr = true;
    }
    if (!start.deleted) {
      const content = start.content;
      switch (content.constructor) {
        case ContentFormat: {
          const { key, value } = /** @type {ContentFormat} */ (content);
          if ((endAttributes.get(key) || null) !== value || (startAttributes.get(key) || null) === value) {
            // Either this format is overwritten or it is not necessary because the attribute already existed.
            start.delete(transaction);
            cleanups++;
            if (!reachedEndOfCurr && (currAttributes.get(key) || null) === value && (startAttributes.get(key) || null) !== value) {
              currAttributes.delete(key);
            }
          }
          break
        }
      }
    }
    start = /** @type {Item} */ (start.right);
  }
  return cleanups
};

/**
 * @param {Transaction} transaction
 * @param {Item | null} item
 */
const cleanupContextlessFormattingGap = (transaction, item) => {
  // iterate until item.right is null or content
  while (item && item.right && (item.right.deleted || !item.right.countable)) {
    item = item.right;
  }
  const attrs = new Set();
  // iterate back until a content item is found
  while (item && (item.deleted || !item.countable)) {
    if (!item.deleted && item.content.constructor === ContentFormat) {
      const key = /** @type {ContentFormat} */ (item.content).key;
      if (attrs.has(key)) {
        item.delete(transaction);
      } else {
        attrs.add(key);
      }
    }
    item = item.left;
  }
};

/**
 * This function is experimental and subject to change / be removed.
 *
 * Ideally, we don't need this function at all. Formatting attributes should be cleaned up
 * automatically after each change. This function iterates twice over the complete YText type
 * and removes unnecessary formatting attributes. This is also helpful for testing.
 *
 * This function won't be exported anymore as soon as there is confidence that the YText type works as intended.
 *
 * @param {YText} type
 * @return {number} How many formatting attributes have been cleaned up.
 */
const cleanupYTextFormatting = type => {
  let res = 0;
  transact(/** @type {Doc} */ (type.doc), transaction => {
    let start = /** @type {Item} */ (type._start);
    let end = type._start;
    let startAttributes = create();
    const currentAttributes = copy(startAttributes);
    while (end) {
      if (end.deleted === false) {
        switch (end.content.constructor) {
          case ContentFormat:
            updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ (end.content));
            break
          default:
            res += cleanupFormattingGap(transaction, start, end, startAttributes, currentAttributes);
            startAttributes = copy(currentAttributes);
            start = end;
            break
        }
      }
      end = end.right;
    }
  });
  return res
};

/**
 * @param {Transaction} transaction
 * @param {ItemTextListPosition} currPos
 * @param {number} length
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */
const deleteText = (transaction, currPos, length) => {
  const startLength = length;
  const startAttrs = copy(currPos.currentAttributes);
  const start = currPos.right;
  while (length > 0 && currPos.right !== null) {
    if (currPos.right.deleted === false) {
      switch (currPos.right.content.constructor) {
        case ContentType:
        case ContentEmbed:
        case ContentString:
          if (length < currPos.right.length) {
            getItemCleanStart(transaction, createID(currPos.right.id.client, currPos.right.id.clock + length));
          }
          length -= currPos.right.length;
          currPos.right.delete(transaction);
          break
      }
    }
    currPos.forward();
  }
  if (start) {
    cleanupFormattingGap(transaction, start, currPos.right, startAttrs, currPos.currentAttributes);
  }
  const parent = /** @type {AbstractType<any>} */ (/** @type {Item} */ (currPos.left || currPos.right).parent);
  if (parent._searchMarker) {
    updateMarkerChanges(parent._searchMarker, currPos.index, -startLength + length);
  }
  return currPos
};

/**
 * The Quill Delta format represents changes on a text document with
 * formatting information. For mor information visit {@link https://quilljs.com/docs/delta/|Quill Delta}
 *
 * @example
 *   {
 *     ops: [
 *       { insert: 'Gandalf', attributes: { bold: true } },
 *       { insert: ' the ' },
 *       { insert: 'Grey', attributes: { color: '#cccccc' } }
 *     ]
 *   }
 *
 */

/**
  * Attributes that can be assigned to a selection of text.
  *
  * @example
  *   {
  *     bold: true,
  *     font-size: '40px'
  *   }
  *
  * @typedef {Object} TextAttributes
  */

/**
 * @extends YEvent<YText>
 * Event that describes the changes on a YText type.
 */
class YTextEvent extends YEvent {
  /**
   * @param {YText} ytext
   * @param {Transaction} transaction
   * @param {Set<any>} subs The keys that changed
   */
  constructor (ytext, transaction, subs) {
    super(ytext, transaction);
    /**
     * Whether the children changed.
     * @type {Boolean}
     * @private
     */
    this.childListChanged = false;
    /**
     * Set of all changed attributes.
     * @type {Set<string>}
     */
    this.keysChanged = new Set();
    subs.forEach((sub) => {
      if (sub === null) {
        this.childListChanged = true;
      } else {
        this.keysChanged.add(sub);
      }
    });
  }

  /**
   * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
   */
  get changes () {
    if (this._changes === null) {
      /**
       * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string|AbstractType<any>|object, delete?:number, retain?:number}>}}
       */
      const changes = {
        keys: this.keys,
        delta: this.delta,
        added: new Set(),
        deleted: new Set()
      };
      this._changes = changes;
    }
    return /** @type {any} */ (this._changes)
  }

  /**
   * Compute the changes in the delta format.
   * A {@link https://quilljs.com/docs/delta/|Quill Delta}) that represents the changes on the document.
   *
   * @type {Array<{insert?:string|object|AbstractType<any>, delete?:number, retain?:number, attributes?: Object<string,any>}>}
   *
   * @public
   */
  get delta () {
    if (this._delta === null) {
      const y = /** @type {Doc} */ (this.target.doc);
      /**
       * @type {Array<{insert?:string|object|AbstractType<any>, delete?:number, retain?:number, attributes?: Object<string,any>}>}
       */
      const delta = [];
      transact(y, transaction => {
        const currentAttributes = new Map(); // saves all current attributes for insert
        const oldAttributes = new Map();
        let item = this.target._start;
        /**
         * @type {string?}
         */
        let action = null;
        /**
         * @type {Object<string,any>}
         */
        const attributes = {}; // counts added or removed new attributes for retain
        /**
         * @type {string|object}
         */
        let insert = '';
        let retain = 0;
        let deleteLen = 0;
        const addOp = () => {
          if (action !== null) {
            /**
             * @type {any}
             */
            let op;
            switch (action) {
              case 'delete':
                op = { delete: deleteLen };
                deleteLen = 0;
                break
              case 'insert':
                op = { insert };
                if (currentAttributes.size > 0) {
                  op.attributes = {};
                  currentAttributes.forEach((value, key) => {
                    if (value !== null) {
                      op.attributes[key] = value;
                    }
                  });
                }
                insert = '';
                break
              case 'retain':
                op = { retain };
                if (Object.keys(attributes).length > 0) {
                  op.attributes = {};
                  for (const key in attributes) {
                    op.attributes[key] = attributes[key];
                  }
                }
                retain = 0;
                break
            }
            delta.push(op);
            action = null;
          }
        };
        while (item !== null) {
          switch (item.content.constructor) {
            case ContentType:
            case ContentEmbed:
              if (this.adds(item)) {
                if (!this.deletes(item)) {
                  addOp();
                  action = 'insert';
                  insert = item.content.getContent()[0];
                  addOp();
                }
              } else if (this.deletes(item)) {
                if (action !== 'delete') {
                  addOp();
                  action = 'delete';
                }
                deleteLen += 1;
              } else if (!item.deleted) {
                if (action !== 'retain') {
                  addOp();
                  action = 'retain';
                }
                retain += 1;
              }
              break
            case ContentString:
              if (this.adds(item)) {
                if (!this.deletes(item)) {
                  if (action !== 'insert') {
                    addOp();
                    action = 'insert';
                  }
                  insert += /** @type {ContentString} */ (item.content).str;
                }
              } else if (this.deletes(item)) {
                if (action !== 'delete') {
                  addOp();
                  action = 'delete';
                }
                deleteLen += item.length;
              } else if (!item.deleted) {
                if (action !== 'retain') {
                  addOp();
                  action = 'retain';
                }
                retain += item.length;
              }
              break
            case ContentFormat: {
              const { key, value } = /** @type {ContentFormat} */ (item.content);
              if (this.adds(item)) {
                if (!this.deletes(item)) {
                  const curVal = currentAttributes.get(key) || null;
                  if (!equalAttrs(curVal, value)) {
                    if (action === 'retain') {
                      addOp();
                    }
                    if (equalAttrs(value, (oldAttributes.get(key) || null))) {
                      delete attributes[key];
                    } else {
                      attributes[key] = value;
                    }
                  } else if (value !== null) {
                    item.delete(transaction);
                  }
                }
              } else if (this.deletes(item)) {
                oldAttributes.set(key, value);
                const curVal = currentAttributes.get(key) || null;
                if (!equalAttrs(curVal, value)) {
                  if (action === 'retain') {
                    addOp();
                  }
                  attributes[key] = curVal;
                }
              } else if (!item.deleted) {
                oldAttributes.set(key, value);
                const attr = attributes[key];
                if (attr !== undefined) {
                  if (!equalAttrs(attr, value)) {
                    if (action === 'retain') {
                      addOp();
                    }
                    if (value === null) {
                      delete attributes[key];
                    } else {
                      attributes[key] = value;
                    }
                  } else if (attr !== null) { // this will be cleaned up automatically by the contextless cleanup function
                    item.delete(transaction);
                  }
                }
              }
              if (!item.deleted) {
                if (action === 'insert') {
                  addOp();
                }
                updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ (item.content));
              }
              break
            }
          }
          item = item.right;
        }
        addOp();
        while (delta.length > 0) {
          const lastOp = delta[delta.length - 1];
          if (lastOp.retain !== undefined && lastOp.attributes === undefined) {
            // retain delta's if they don't assign attributes
            delta.pop();
          } else {
            break
          }
        }
      });
      this._delta = delta;
    }
    return /** @type {any} */ (this._delta)
  }
}

/**
 * Type that represents text with formatting information.
 *
 * This type replaces y-richtext as this implementation is able to handle
 * block formats (format information on a paragraph), embeds (complex elements
 * like pictures and videos), and text formats (**bold**, *italic*).
 *
 * @extends AbstractType<YTextEvent>
 */
class YText extends AbstractType {
  /**
   * @param {String} [string] The initial value of the YText.
   */
  constructor (string) {
    super();
    /**
     * Array of pending operations on this type
     * @type {Array<function():void>?}
     */
    this._pending = string !== undefined ? [() => this.insert(0, string)] : [];
    /**
     * @type {Array<ArraySearchMarker>}
     */
    this._searchMarker = [];
  }

  /**
   * Number of characters of this text type.
   *
   * @type {number}
   */
  get length () {
    return this._length
  }

  /**
   * @param {Doc} y
   * @param {Item} item
   */
  _integrate (y, item) {
    super._integrate(y, item);
    try {
      /** @type {Array<function>} */ (this._pending).forEach(f => f());
    } catch (e) {
      console.error(e);
    }
    this._pending = null;
  }

  _copy () {
    return new YText()
  }

  /**
   * @return {YText}
   */
  clone () {
    const text = new YText();
    text.applyDelta(this.toDelta());
    return text
  }

  /**
   * Creates YTextEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver (transaction, parentSubs) {
    super._callObserver(transaction, parentSubs);
    const event = new YTextEvent(this, transaction, parentSubs);
    const doc = transaction.doc;
    callTypeObservers(this, transaction, event);
    // If a remote change happened, we try to cleanup potential formatting duplicates.
    if (!transaction.local) {
      // check if another formatting item was inserted
      let foundFormattingItem = false;
      for (const [client, afterClock] of transaction.afterState.entries()) {
        const clock = transaction.beforeState.get(client) || 0;
        if (afterClock === clock) {
          continue
        }
        iterateStructs(transaction, /** @type {Array<Item|GC>} */ (doc.store.clients.get(client)), clock, afterClock, item => {
          if (!item.deleted && /** @type {Item} */ (item).content.constructor === ContentFormat) {
            foundFormattingItem = true;
          }
        });
        if (foundFormattingItem) {
          break
        }
      }
      if (!foundFormattingItem) {
        iterateDeletedStructs(transaction, transaction.deleteSet, item => {
          if (item instanceof GC || foundFormattingItem) {
            return
          }
          if (item.parent === this && item.content.constructor === ContentFormat) {
            foundFormattingItem = true;
          }
        });
      }
      transact(doc, (t) => {
        if (foundFormattingItem) {
          // If a formatting item was inserted, we simply clean the whole type.
          // We need to compute currentAttributes for the current position anyway.
          cleanupYTextFormatting(this);
        } else {
          // If no formatting attribute was inserted, we can make due with contextless
          // formatting cleanups.
          // Contextless: it is not necessary to compute currentAttributes for the affected position.
          iterateDeletedStructs(t, t.deleteSet, item => {
            if (item instanceof GC) {
              return
            }
            if (item.parent === this) {
              cleanupContextlessFormattingGap(t, item);
            }
          });
        }
      });
    }
  }

  /**
   * Returns the unformatted string representation of this YText type.
   *
   * @public
   */
  toString () {
    let str = '';
    /**
     * @type {Item|null}
     */
    let n = this._start;
    while (n !== null) {
      if (!n.deleted && n.countable && n.content.constructor === ContentString) {
        str += /** @type {ContentString} */ (n.content).str;
      }
      n = n.right;
    }
    return str
  }

  /**
   * Returns the unformatted string representation of this YText type.
   *
   * @return {string}
   * @public
   */
  toJSON () {
    return this.toString()
  }

  /**
   * Apply a {@link Delta} on this shared YText type.
   *
   * @param {any} delta The changes to apply on this element.
   * @param {object}  [opts]
   * @param {boolean} [opts.sanitize] Sanitize input delta. Removes ending newlines if set to true.
   *
   *
   * @public
   */
  applyDelta (delta, { sanitize = true } = {}) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        const currPos = new ItemTextListPosition(null, this._start, 0, new Map());
        for (let i = 0; i < delta.length; i++) {
          const op = delta[i];
          if (op.insert !== undefined) {
            // Quill assumes that the content starts with an empty paragraph.
            // Yjs/Y.Text assumes that it starts empty. We always hide that
            // there is a newline at the end of the content.
            // If we omit this step, clients will see a different number of
            // paragraphs, but nothing bad will happen.
            const ins = (!sanitize && typeof op.insert === 'string' && i === delta.length - 1 && currPos.right === null && op.insert.slice(-1) === '\n') ? op.insert.slice(0, -1) : op.insert;
            if (typeof ins !== 'string' || ins.length > 0) {
              insertText(transaction, this, currPos, ins, op.attributes || {});
            }
          } else if (op.retain !== undefined) {
            formatText(transaction, this, currPos, op.retain, op.attributes || {});
          } else if (op.delete !== undefined) {
            deleteText(transaction, currPos, op.delete);
          }
        }
      });
    } else {
      /** @type {Array<function>} */ (this._pending).push(() => this.applyDelta(delta));
    }
  }

  /**
   * Returns the Delta representation of this YText type.
   *
   * @param {Snapshot} [snapshot]
   * @param {Snapshot} [prevSnapshot]
   * @param {function('removed' | 'added', ID):any} [computeYChange]
   * @return {any} The Delta representation of this type.
   *
   * @public
   */
  toDelta (snapshot, prevSnapshot, computeYChange) {
    /**
     * @type{Array<any>}
     */
    const ops = [];
    const currentAttributes = new Map();
    const doc = /** @type {Doc} */ (this.doc);
    let str = '';
    let n = this._start;
    function packStr () {
      if (str.length > 0) {
        // pack str with attributes to ops
        /**
         * @type {Object<string,any>}
         */
        const attributes = {};
        let addAttributes = false;
        currentAttributes.forEach((value, key) => {
          addAttributes = true;
          attributes[key] = value;
        });
        /**
         * @type {Object<string,any>}
         */
        const op = { insert: str };
        if (addAttributes) {
          op.attributes = attributes;
        }
        ops.push(op);
        str = '';
      }
    }
    // snapshots are merged again after the transaction, so we need to keep the
    // transalive until we are done
    transact(doc, transaction => {
      if (snapshot) {
        splitSnapshotAffectedStructs(transaction, snapshot);
      }
      if (prevSnapshot) {
        splitSnapshotAffectedStructs(transaction, prevSnapshot);
      }
      while (n !== null) {
        if (isVisible(n, snapshot) || (prevSnapshot !== undefined && isVisible(n, prevSnapshot))) {
          switch (n.content.constructor) {
            case ContentString: {
              const cur = currentAttributes.get('ychange');
              if (snapshot !== undefined && !isVisible(n, snapshot)) {
                if (cur === undefined || cur.user !== n.id.client || cur.state !== 'removed') {
                  packStr();
                  currentAttributes.set('ychange', computeYChange ? computeYChange('removed', n.id) : { type: 'removed' });
                }
              } else if (prevSnapshot !== undefined && !isVisible(n, prevSnapshot)) {
                if (cur === undefined || cur.user !== n.id.client || cur.state !== 'added') {
                  packStr();
                  currentAttributes.set('ychange', computeYChange ? computeYChange('added', n.id) : { type: 'added' });
                }
              } else if (cur !== undefined) {
                packStr();
                currentAttributes.delete('ychange');
              }
              str += /** @type {ContentString} */ (n.content).str;
              break
            }
            case ContentType:
            case ContentEmbed: {
              packStr();
              /**
               * @type {Object<string,any>}
               */
              const op = {
                insert: n.content.getContent()[0]
              };
              if (currentAttributes.size > 0) {
                const attrs = /** @type {Object<string,any>} */ ({});
                op.attributes = attrs;
                currentAttributes.forEach((value, key) => {
                  attrs[key] = value;
                });
              }
              ops.push(op);
              break
            }
            case ContentFormat:
              if (isVisible(n, snapshot)) {
                packStr();
                updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ (n.content));
              }
              break
          }
        }
        n = n.right;
      }
      packStr();
    }, splitSnapshotAffectedStructs);
    return ops
  }

  /**
   * Insert text at a given index.
   *
   * @param {number} index The index at which to start inserting.
   * @param {String} text The text to insert at the specified position.
   * @param {TextAttributes} [attributes] Optionally define some formatting
   *                                    information to apply on the inserted
   *                                    Text.
   * @public
   */
  insert (index, text, attributes) {
    if (text.length <= 0) {
      return
    }
    const y = this.doc;
    if (y !== null) {
      transact(y, transaction => {
        const pos = findPosition(transaction, this, index);
        if (!attributes) {
          attributes = {};
          // @ts-ignore
          pos.currentAttributes.forEach((v, k) => { attributes[k] = v; });
        }
        insertText(transaction, this, pos, text, attributes);
      });
    } else {
      /** @type {Array<function>} */ (this._pending).push(() => this.insert(index, text, attributes));
    }
  }

  /**
   * Inserts an embed at a index.
   *
   * @param {number} index The index to insert the embed at.
   * @param {Object | AbstractType<any>} embed The Object that represents the embed.
   * @param {TextAttributes} attributes Attribute information to apply on the
   *                                    embed
   *
   * @public
   */
  insertEmbed (index, embed, attributes = {}) {
    const y = this.doc;
    if (y !== null) {
      transact(y, transaction => {
        const pos = findPosition(transaction, this, index);
        insertText(transaction, this, pos, embed, attributes);
      });
    } else {
      /** @type {Array<function>} */ (this._pending).push(() => this.insertEmbed(index, embed, attributes));
    }
  }

  /**
   * Deletes text starting from an index.
   *
   * @param {number} index Index at which to start deleting.
   * @param {number} length The number of characters to remove. Defaults to 1.
   *
   * @public
   */
  delete (index, length) {
    if (length === 0) {
      return
    }
    const y = this.doc;
    if (y !== null) {
      transact(y, transaction => {
        deleteText(transaction, findPosition(transaction, this, index), length);
      });
    } else {
      /** @type {Array<function>} */ (this._pending).push(() => this.delete(index, length));
    }
  }

  /**
   * Assigns properties to a range of text.
   *
   * @param {number} index The position where to start formatting.
   * @param {number} length The amount of characters to assign properties to.
   * @param {TextAttributes} attributes Attribute information to apply on the
   *                                    text.
   *
   * @public
   */
  format (index, length, attributes) {
    if (length === 0) {
      return
    }
    const y = this.doc;
    if (y !== null) {
      transact(y, transaction => {
        const pos = findPosition(transaction, this, index);
        if (pos.right === null) {
          return
        }
        formatText(transaction, this, pos, length, attributes);
      });
    } else {
      /** @type {Array<function>} */ (this._pending).push(() => this.format(index, length, attributes));
    }
  }

  /**
   * Removes an attribute.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that is to be removed.
   *
   * @public
   */
  removeAttribute (attributeName) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        typeMapDelete(transaction, this, attributeName);
      });
    } else {
      /** @type {Array<function>} */ (this._pending).push(() => this.removeAttribute(attributeName));
    }
  }

  /**
   * Sets or updates an attribute.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that is to be set.
   * @param {any} attributeValue The attribute value that is to be set.
   *
   * @public
   */
  setAttribute (attributeName, attributeValue) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        typeMapSet(transaction, this, attributeName, attributeValue);
      });
    } else {
      /** @type {Array<function>} */ (this._pending).push(() => this.setAttribute(attributeName, attributeValue));
    }
  }

  /**
   * Returns an attribute value that belongs to the attribute name.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that identifies the
   *                               queried value.
   * @return {any} The queried attribute value.
   *
   * @public
   */
  getAttribute (attributeName) {
    return /** @type {any} */ (typeMapGet(this, attributeName))
  }

  /**
   * Returns all attribute name/value pairs in a JSON Object.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {Snapshot} [snapshot]
   * @return {Object<string, any>} A JSON Object that describes the attributes.
   *
   * @public
   */
  getAttributes (snapshot) {
    return typeMapGetAll(this)
  }

  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  _write (encoder) {
    encoder.writeTypeRef(YTextRefID);
  }
}

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YText}
 *
 * @private
 * @function
 */
const readYText = decoder => new YText();

/**
 * @module YXml
 */

/**
 * Define the elements to which a set of CSS queries apply.
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Selectors|CSS_Selectors}
 *
 * @example
 *   query = '.classSelector'
 *   query = 'nodeSelector'
 *   query = '#idSelector'
 *
 * @typedef {string} CSS_Selector
 */

/**
 * Dom filter function.
 *
 * @callback domFilter
 * @param {string} nodeName The nodeName of the element
 * @param {Map} attributes The map of attributes.
 * @return {boolean} Whether to include the Dom node in the YXmlElement.
 */

/**
 * Represents a subset of the nodes of a YXmlElement / YXmlFragment and a
 * position within them.
 *
 * Can be created with {@link YXmlFragment#createTreeWalker}
 *
 * @public
 * @implements {Iterable<YXmlElement|YXmlText|YXmlElement|YXmlHook>}
 */
class YXmlTreeWalker {
  /**
   * @param {YXmlFragment | YXmlElement} root
   * @param {function(AbstractType<any>):boolean} [f]
   */
  constructor (root, f = () => true) {
    this._filter = f;
    this._root = root;
    /**
     * @type {Item}
     */
    this._currentNode = /** @type {Item} */ (root._start);
    this._firstCall = true;
  }

  [Symbol.iterator] () {
    return this
  }

  /**
   * Get the next node.
   *
   * @return {IteratorResult<YXmlElement|YXmlText|YXmlHook>} The next node.
   *
   * @public
   */
  next () {
    /**
     * @type {Item|null}
     */
    let n = this._currentNode;
    let type = n && n.content && /** @type {any} */ (n.content).type;
    if (n !== null && (!this._firstCall || n.deleted || !this._filter(type))) { // if first call, we check if we can use the first item
      do {
        type = /** @type {any} */ (n.content).type;
        if (!n.deleted && (type.constructor === YXmlElement || type.constructor === YXmlFragment) && type._start !== null) {
          // walk down in the tree
          n = type._start;
        } else {
          // walk right or up in the tree
          while (n !== null) {
            if (n.right !== null) {
              n = n.right;
              break
            } else if (n.parent === this._root) {
              n = null;
            } else {
              n = /** @type {AbstractType<any>} */ (n.parent)._item;
            }
          }
        }
      } while (n !== null && (n.deleted || !this._filter(/** @type {ContentType} */ (n.content).type)))
    }
    this._firstCall = false;
    if (n === null) {
      // @ts-ignore
      return { value: undefined, done: true }
    }
    this._currentNode = n;
    return { value: /** @type {any} */ (n.content).type, done: false }
  }
}

/**
 * Represents a list of {@link YXmlElement}.and {@link YXmlText} types.
 * A YxmlFragment is similar to a {@link YXmlElement}, but it does not have a
 * nodeName and it does not have attributes. Though it can be bound to a DOM
 * element - in this case the attributes and the nodeName are not shared.
 *
 * @public
 * @extends AbstractType<YXmlEvent>
 */
class YXmlFragment extends AbstractType {
  constructor () {
    super();
    /**
     * @type {Array<any>|null}
     */
    this._prelimContent = [];
  }

  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get firstChild () {
    const first = this._first;
    return first ? first.content.getContent()[0] : null
  }

  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */
  _integrate (y, item) {
    super._integrate(y, item);
    this.insert(0, /** @type {Array<any>} */ (this._prelimContent));
    this._prelimContent = null;
  }

  _copy () {
    return new YXmlFragment()
  }

  /**
   * @return {YXmlFragment}
   */
  clone () {
    const el = new YXmlFragment();
    // @ts-ignore
    el.insert(0, this.toArray().map(item => item instanceof AbstractType ? item.clone() : item));
    return el
  }

  get length () {
    return this._prelimContent === null ? this._length : this._prelimContent.length
  }

  /**
   * Create a subtree of childNodes.
   *
   * @example
   * const walker = elem.createTreeWalker(dom => dom.nodeName === 'div')
   * for (let node in walker) {
   *   // `node` is a div node
   *   nop(node)
   * }
   *
   * @param {function(AbstractType<any>):boolean} filter Function that is called on each child element and
   *                          returns a Boolean indicating whether the child
   *                          is to be included in the subtree.
   * @return {YXmlTreeWalker} A subtree and a position within it.
   *
   * @public
   */
  createTreeWalker (filter) {
    return new YXmlTreeWalker(this, filter)
  }

  /**
   * Returns the first YXmlElement that matches the query.
   * Similar to DOM's {@link querySelector}.
   *
   * Query support:
   *   - tagname
   * TODO:
   *   - id
   *   - attribute
   *
   * @param {CSS_Selector} query The query on the children.
   * @return {YXmlElement|YXmlText|YXmlHook|null} The first element that matches the query or null.
   *
   * @public
   */
  querySelector (query) {
    query = query.toUpperCase();
    // @ts-ignore
    const iterator = new YXmlTreeWalker(this, element => element.nodeName && element.nodeName.toUpperCase() === query);
    const next = iterator.next();
    if (next.done) {
      return null
    } else {
      return next.value
    }
  }

  /**
   * Returns all YXmlElements that match the query.
   * Similar to Dom's {@link querySelectorAll}.
   *
   * @todo Does not yet support all queries. Currently only query by tagName.
   *
   * @param {CSS_Selector} query The query on the children
   * @return {Array<YXmlElement|YXmlText|YXmlHook|null>} The elements that match this query.
   *
   * @public
   */
  querySelectorAll (query) {
    query = query.toUpperCase();
    // @ts-ignore
    return Array.from(new YXmlTreeWalker(this, element => element.nodeName && element.nodeName.toUpperCase() === query))
  }

  /**
   * Creates YXmlEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver (transaction, parentSubs) {
    callTypeObservers(this, transaction, new YXmlEvent(this, parentSubs, transaction));
  }

  /**
   * Get the string representation of all the children of this YXmlFragment.
   *
   * @return {string} The string representation of all children.
   */
  toString () {
    return typeListMap(this, xml => xml.toString()).join('')
  }

  /**
   * @return {string}
   */
  toJSON () {
    return this.toString()
  }

  /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */
  toDOM (_document = document, hooks = {}, binding) {
    const fragment = _document.createDocumentFragment();
    if (binding !== undefined) {
      binding._createAssociation(fragment, this);
    }
    typeListForEach(this, xmlType => {
      fragment.insertBefore(xmlType.toDOM(_document, hooks, binding), null);
    });
    return fragment
  }

  /**
   * Inserts new content at an index.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  xml.insert(0, [new Y.XmlText('text')])
   *
   * @param {number} index The index to insert content at
   * @param {Array<YXmlElement|YXmlText>} content The array of content
   */
  insert (index, content) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        typeListInsertGenerics(transaction, this, index, content);
      });
    } else {
      // @ts-ignore _prelimContent is defined because this is not yet integrated
      this._prelimContent.splice(index, 0, ...content);
    }
  }

  /**
   * Inserts new content at an index.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  xml.insert(0, [new Y.XmlText('text')])
   *
   * @param {null|Item|YXmlElement|YXmlText} ref The index to insert content at
   * @param {Array<YXmlElement|YXmlText>} content The array of content
   */
  insertAfter (ref, content) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        const refItem = (ref && ref instanceof AbstractType) ? ref._item : ref;
        typeListInsertGenericsAfter(transaction, this, refItem, content);
      });
    } else {
      const pc = /** @type {Array<any>} */ (this._prelimContent);
      const index = ref === null ? 0 : pc.findIndex(el => el === ref) + 1;
      if (index === 0 && ref !== null) {
        throw error_create('Reference item not found')
      }
      pc.splice(index, 0, ...content);
    }
  }

  /**
   * Deletes elements starting from an index.
   *
   * @param {number} index Index at which to start deleting elements
   * @param {number} [length=1] The number of elements to remove. Defaults to 1.
   */
  delete (index, length = 1) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        typeListDelete(transaction, this, index, length);
      });
    } else {
      // @ts-ignore _prelimContent is defined because this is not yet integrated
      this._prelimContent.splice(index, length);
    }
  }

  /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @return {Array<YXmlElement|YXmlText|YXmlHook>}
   */
  toArray () {
    return typeListToArray(this)
  }

  /**
   * Appends content to this YArray.
   *
   * @param {Array<YXmlElement|YXmlText>} content Array of content to append.
   */
  push (content) {
    this.insert(this.length, content);
  }

  /**
   * Preppends content to this YArray.
   *
   * @param {Array<YXmlElement|YXmlText>} content Array of content to preppend.
   */
  unshift (content) {
    this.insert(0, content);
  }

  /**
   * Returns the i-th element from a YArray.
   *
   * @param {number} index The index of the element to return from the YArray
   * @return {YXmlElement|YXmlText}
   */
  get (index) {
    return typeListGet(this, index)
  }

  /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @param {number} [start]
   * @param {number} [end]
   * @return {Array<YXmlElement|YXmlText>}
   */
  slice (start = 0, end = this.length) {
    return typeListSlice(this, start, end)
  }

  /**
   * Executes a provided function on once on overy child element.
   *
   * @param {function(YXmlElement|YXmlText,number, typeof this):void} f A function to execute on every element of this YArray.
   */
  forEach (f) {
    typeListForEach(this, f);
  }

  /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */
  _write (encoder) {
    encoder.writeTypeRef(YXmlFragmentRefID);
  }
}

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlFragment}
 *
 * @private
 * @function
 */
const readYXmlFragment = decoder => new YXmlFragment();

/**
 * An YXmlElement imitates the behavior of a
 * {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}.
 *
 * * An YXmlElement has attributes (key value pairs)
 * * An YXmlElement has childElements that must inherit from YXmlElement
 */
class YXmlElement extends YXmlFragment {
  constructor (nodeName = 'UNDEFINED') {
    super();
    this.nodeName = nodeName;
    /**
     * @type {Map<string, any>|null}
     */
    this._prelimAttrs = new Map();
  }

  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get nextSibling () {
    const n = this._item ? this._item.next : null;
    return n ? /** @type {YXmlElement|YXmlText} */ (/** @type {ContentType} */ (n.content).type) : null
  }

  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get prevSibling () {
    const n = this._item ? this._item.prev : null;
    return n ? /** @type {YXmlElement|YXmlText} */ (/** @type {ContentType} */ (n.content).type) : null
  }

  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */
  _integrate (y, item) {
    super._integrate(y, item)
    ;(/** @type {Map<string, any>} */ (this._prelimAttrs)).forEach((value, key) => {
      this.setAttribute(key, value);
    });
    this._prelimAttrs = null;
  }

  /**
   * Creates an Item with the same effect as this Item (without position effect)
   *
   * @return {YXmlElement}
   */
  _copy () {
    return new YXmlElement(this.nodeName)
  }

  /**
   * @return {YXmlElement}
   */
  clone () {
    const el = new YXmlElement(this.nodeName);
    const attrs = this.getAttributes();
    for (const key in attrs) {
      el.setAttribute(key, attrs[key]);
    }
    // @ts-ignore
    el.insert(0, this.toArray().map(item => item instanceof AbstractType ? item.clone() : item));
    return el
  }

  /**
   * Returns the XML serialization of this YXmlElement.
   * The attributes are ordered by attribute-name, so you can easily use this
   * method to compare YXmlElements
   *
   * @return {string} The string representation of this type.
   *
   * @public
   */
  toString () {
    const attrs = this.getAttributes();
    const stringBuilder = [];
    const keys = [];
    for (const key in attrs) {
      keys.push(key);
    }
    keys.sort();
    const keysLen = keys.length;
    for (let i = 0; i < keysLen; i++) {
      const key = keys[i];
      stringBuilder.push(key + '="' + attrs[key] + '"');
    }
    const nodeName = this.nodeName.toLocaleLowerCase();
    const attrsString = stringBuilder.length > 0 ? ' ' + stringBuilder.join(' ') : '';
    return `<${nodeName}${attrsString}>${super.toString()}</${nodeName}>`
  }

  /**
   * Removes an attribute from this YXmlElement.
   *
   * @param {String} attributeName The attribute name that is to be removed.
   *
   * @public
   */
  removeAttribute (attributeName) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        typeMapDelete(transaction, this, attributeName);
      });
    } else {
      /** @type {Map<string,any>} */ (this._prelimAttrs).delete(attributeName);
    }
  }

  /**
   * Sets or updates an attribute.
   *
   * @param {String} attributeName The attribute name that is to be set.
   * @param {String} attributeValue The attribute value that is to be set.
   *
   * @public
   */
  setAttribute (attributeName, attributeValue) {
    if (this.doc !== null) {
      transact(this.doc, transaction => {
        typeMapSet(transaction, this, attributeName, attributeValue);
      });
    } else {
      /** @type {Map<string, any>} */ (this._prelimAttrs).set(attributeName, attributeValue);
    }
  }

  /**
   * Returns an attribute value that belongs to the attribute name.
   *
   * @param {String} attributeName The attribute name that identifies the
   *                               queried value.
   * @return {String} The queried attribute value.
   *
   * @public
   */
  getAttribute (attributeName) {
    return /** @type {any} */ (typeMapGet(this, attributeName))
  }

  /**
   * Returns whether an attribute exists
   *
   * @param {String} attributeName The attribute name to check for existence.
   * @return {boolean} whether the attribute exists.
   *
   * @public
   */
  hasAttribute (attributeName) {
    return /** @type {any} */ (typeMapHas(this, attributeName))
  }

  /**
   * Returns all attribute name/value pairs in a JSON Object.
   *
   * @param {Snapshot} [snapshot]
   * @return {Object<string, any>} A JSON Object that describes the attributes.
   *
   * @public
   */
  getAttributes (snapshot) {
    return typeMapGetAll(this)
  }

  /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */
  toDOM (_document = document, hooks = {}, binding) {
    const dom = _document.createElement(this.nodeName);
    const attrs = this.getAttributes();
    for (const key in attrs) {
      dom.setAttribute(key, attrs[key]);
    }
    typeListForEach(this, yxml => {
      dom.appendChild(yxml.toDOM(_document, hooks, binding));
    });
    if (binding !== undefined) {
      binding._createAssociation(dom, this);
    }
    return dom
  }

  /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */
  _write (encoder) {
    encoder.writeTypeRef(YXmlElementRefID);
    encoder.writeKey(this.nodeName);
  }
}

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlElement}
 *
 * @function
 */
const readYXmlElement = decoder => new YXmlElement(decoder.readKey());

/**
 * @extends YEvent<YXmlElement|YXmlText|YXmlFragment>
 * An Event that describes changes on a YXml Element or Yxml Fragment
 */
class YXmlEvent extends YEvent {
  /**
   * @param {YXmlElement|YXmlText|YXmlFragment} target The target on which the event is created.
   * @param {Set<string|null>} subs The set of changed attributes. `null` is included if the
   *                   child list changed.
   * @param {Transaction} transaction The transaction instance with wich the
   *                                  change was created.
   */
  constructor (target, subs, transaction) {
    super(target, transaction);
    /**
     * Whether the children changed.
     * @type {Boolean}
     * @private
     */
    this.childListChanged = false;
    /**
     * Set of all changed attributes.
     * @type {Set<string>}
     */
    this.attributesChanged = new Set();
    subs.forEach((sub) => {
      if (sub === null) {
        this.childListChanged = true;
      } else {
        this.attributesChanged.add(sub);
      }
    });
  }
}

/**
 * You can manage binding to a custom type with YXmlHook.
 *
 * @extends {YMap<any>}
 */
class YXmlHook extends YMap {
  /**
   * @param {string} hookName nodeName of the Dom Node.
   */
  constructor (hookName) {
    super();
    /**
     * @type {string}
     */
    this.hookName = hookName;
  }

  /**
   * Creates an Item with the same effect as this Item (without position effect)
   */
  _copy () {
    return new YXmlHook(this.hookName)
  }

  /**
   * @return {YXmlHook}
   */
  clone () {
    const el = new YXmlHook(this.hookName);
    this.forEach((value, key) => {
      el.set(key, value);
    });
    return el
  }

  /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object.<string, any>} [hooks] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type
   * @return {Element} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */
  toDOM (_document = document, hooks = {}, binding) {
    const hook = hooks[this.hookName];
    let dom;
    if (hook !== undefined) {
      dom = hook.createDom(this);
    } else {
      dom = document.createElement(this.hookName);
    }
    dom.setAttribute('data-yjs-hook', this.hookName);
    if (binding !== undefined) {
      binding._createAssociation(dom, this);
    }
    return dom
  }

  /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */
  _write (encoder) {
    encoder.writeTypeRef(YXmlHookRefID);
    encoder.writeKey(this.hookName);
  }
}

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlHook}
 *
 * @private
 * @function
 */
const readYXmlHook = decoder =>
  new YXmlHook(decoder.readKey());

/**
 * Represents text in a Dom Element. In the future this type will also handle
 * simple formatting information like bold and italic.
 */
class YXmlText extends YText {
  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get nextSibling () {
    const n = this._item ? this._item.next : null;
    return n ? /** @type {YXmlElement|YXmlText} */ (/** @type {ContentType} */ (n.content).type) : null
  }

  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get prevSibling () {
    const n = this._item ? this._item.prev : null;
    return n ? /** @type {YXmlElement|YXmlText} */ (/** @type {ContentType} */ (n.content).type) : null
  }

  _copy () {
    return new YXmlText()
  }

  /**
   * @return {YXmlText}
   */
  clone () {
    const text = new YXmlText();
    text.applyDelta(this.toDelta());
    return text
  }

  /**
   * Creates a Dom Element that mirrors this YXmlText.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Text} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */
  toDOM (_document = document, hooks, binding) {
    const dom = _document.createTextNode(this.toString());
    if (binding !== undefined) {
      binding._createAssociation(dom, this);
    }
    return dom
  }

  toString () {
    // @ts-ignore
    return this.toDelta().map(delta => {
      const nestedNodes = [];
      for (const nodeName in delta.attributes) {
        const attrs = [];
        for (const key in delta.attributes[nodeName]) {
          attrs.push({ key, value: delta.attributes[nodeName][key] });
        }
        // sort attributes to get a unique order
        attrs.sort((a, b) => a.key < b.key ? -1 : 1);
        nestedNodes.push({ nodeName, attrs });
      }
      // sort node order to get a unique order
      nestedNodes.sort((a, b) => a.nodeName < b.nodeName ? -1 : 1);
      // now convert to dom string
      let str = '';
      for (let i = 0; i < nestedNodes.length; i++) {
        const node = nestedNodes[i];
        str += `<${node.nodeName}`;
        for (let j = 0; j < node.attrs.length; j++) {
          const attr = node.attrs[j];
          str += ` ${attr.key}="${attr.value}"`;
        }
        str += '>';
      }
      str += delta.insert;
      for (let i = nestedNodes.length - 1; i >= 0; i--) {
        str += `</${nestedNodes[i].nodeName}>`;
      }
      return str
    }).join('')
  }

  /**
   * @return {string}
   */
  toJSON () {
    return this.toString()
  }

  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  _write (encoder) {
    encoder.writeTypeRef(YXmlTextRefID);
  }
}

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlText}
 *
 * @private
 * @function
 */
const readYXmlText = decoder => new YXmlText();

class AbstractStruct {
  /**
   * @param {ID} id
   * @param {number} length
   */
  constructor (id, length) {
    this.id = id;
    this.length = length;
  }

  /**
   * @type {boolean}
   */
  get deleted () {
    throw methodUnimplemented()
  }

  /**
   * Merge this struct with the item to the right.
   * This method is already assuming that `this.id.clock + this.length === this.id.clock`.
   * Also this method does *not* remove right from StructStore!
   * @param {AbstractStruct} right
   * @return {boolean} wether this merged with right
   */
  mergeWith (right) {
    return false
  }

  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   * @param {number} offset
   * @param {number} encodingRef
   */
  write (encoder, offset, encodingRef) {
    throw methodUnimplemented()
  }

  /**
   * @param {Transaction} transaction
   * @param {number} offset
   */
  integrate (transaction, offset) {
    throw methodUnimplemented()
  }
}

const structGCRefNumber = 0;

/**
 * @private
 */
class GC extends AbstractStruct {
  get deleted () {
    return true
  }

  delete () {}

  /**
   * @param {GC} right
   * @return {boolean}
   */
  mergeWith (right) {
    if (this.constructor !== right.constructor) {
      return false
    }
    this.length += right.length;
    return true
  }

  /**
   * @param {Transaction} transaction
   * @param {number} offset
   */
  integrate (transaction, offset) {
    if (offset > 0) {
      this.id.clock += offset;
      this.length -= offset;
    }
    addStruct(transaction.doc.store, this);
  }

  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write (encoder, offset) {
    encoder.writeInfo(structGCRefNumber);
    encoder.writeLen(this.length - offset);
  }

  /**
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */
  getMissing (transaction, store) {
    return null
  }
}

class ContentBinary {
  /**
   * @param {Uint8Array} content
   */
  constructor (content) {
    this.content = content;
  }

  /**
   * @return {number}
   */
  getLength () {
    return 1
  }

  /**
   * @return {Array<any>}
   */
  getContent () {
    return [this.content]
  }

  /**
   * @return {boolean}
   */
  isCountable () {
    return true
  }

  /**
   * @return {ContentBinary}
   */
  copy () {
    return new ContentBinary(this.content)
  }

  /**
   * @param {number} offset
   * @return {ContentBinary}
   */
  splice (offset) {
    throw methodUnimplemented()
  }

  /**
   * @param {ContentBinary} right
   * @return {boolean}
   */
  mergeWith (right) {
    return false
  }

  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate (transaction, item) {}
  /**
   * @param {Transaction} transaction
   */
  delete (transaction) {}
  /**
   * @param {StructStore} store
   */
  gc (store) {}
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write (encoder, offset) {
    encoder.writeBuf(this.content);
  }

  /**
   * @return {number}
   */
  getRef () {
    return 3
  }
}

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2 } decoder
 * @return {ContentBinary}
 */
const readContentBinary = decoder => new ContentBinary(decoder.readBuf());

class ContentDeleted {
  /**
   * @param {number} len
   */
  constructor (len) {
    this.len = len;
  }

  /**
   * @return {number}
   */
  getLength () {
    return this.len
  }

  /**
   * @return {Array<any>}
   */
  getContent () {
    return []
  }

  /**
   * @return {boolean}
   */
  isCountable () {
    return false
  }

  /**
   * @return {ContentDeleted}
   */
  copy () {
    return new ContentDeleted(this.len)
  }

  /**
   * @param {number} offset
   * @return {ContentDeleted}
   */
  splice (offset) {
    const right = new ContentDeleted(this.len - offset);
    this.len = offset;
    return right
  }

  /**
   * @param {ContentDeleted} right
   * @return {boolean}
   */
  mergeWith (right) {
    this.len += right.len;
    return true
  }

  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate (transaction, item) {
    addToDeleteSet(transaction.deleteSet, item.id.client, item.id.clock, this.len);
    item.markDeleted();
  }

  /**
   * @param {Transaction} transaction
   */
  delete (transaction) {}
  /**
   * @param {StructStore} store
   */
  gc (store) {}
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write (encoder, offset) {
    encoder.writeLen(this.len - offset);
  }

  /**
   * @return {number}
   */
  getRef () {
    return 1
  }
}

/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2 } decoder
 * @return {ContentDeleted}
 */
const readContentDeleted = decoder => new ContentDeleted(decoder.readLen());

/**
 * @param {string} guid
 * @param {Object<string, any>} opts
 */
const createDocFromOpts = (guid, opts) => new Doc({ guid, ...opts, shouldLoad: opts.shouldLoad || opts.autoLoad || false });

/**
 * @private
 */
class ContentDoc {
  /**
   * @param {Doc} doc
   */
  constructor (doc) {
    if (doc._item) {
      console.error('This document was already integrated as a sub-document. You should create a second instance instead with the same guid.');
    }
    /**
     * @type {Doc}
     */
    this.doc = doc;
    /**
     * @type {any}
     */
    const opts = {};
    this.opts = opts;
    if (!doc.gc) {
      opts.gc = false;
    }
    if (doc.autoLoad) {
      opts.autoLoad = true;
    }
    if (doc.meta !== null) {
      opts.meta = doc.meta;
    }
  }

  /**
   * @return {number}
   */
  getLength () {
    return 1
  }

  /**
   * @return {Array<any>}
   */
  getContent () {
    return [this.doc]
  }

  /**
   * @return {boolean}
   */
  isCountable () {
    return true
  }

  /**
   * @return {ContentDoc}
   */
  copy () {
    return new ContentDoc(createDocFromOpts(this.doc.guid, this.opts))
  }

  /**
   * @param {number} offset
   * @return {ContentDoc}
   */
  splice (offset) {
    throw methodUnimplemented()
  }

  /**
   * @param {ContentDoc} right
   * @return {boolean}
   */
  mergeWith (right) {
    return false
  }

  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate (transaction, item) {
    // this needs to be reflected in doc.destroy as well
    this.doc._item = item;
    transaction.subdocsAdded.add(this.doc);
    if (this.doc.shouldLoad) {
      transaction.subdocsLoaded.add(this.doc);
    }
  }

  /**
   * @param {Transaction} transaction
   */
  delete (transaction) {
    if (transaction.subdocsAdded.has(this.doc)) {
      transaction.subdocsAdded.delete(this.doc);
    } else {
      transaction.subdocsRemoved.add(this.doc);
    }
  }

  /**
   * @param {StructStore} store
   */
  gc (store) { }

  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write (encoder, offset) {
    encoder.writeString(this.doc.guid);
    encoder.writeAny(this.opts);
  }

  /**
   * @return {number}
   */
  getRef () {
    return 9
  }
}

/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentDoc}
 */
const readContentDoc = decoder => new ContentDoc(createDocFromOpts(decoder.readString(), decoder.readAny()));

/**
 * @private
 */
class ContentEmbed {
  /**
   * @param {Object} embed
   */
  constructor (embed) {
    this.embed = embed;
  }

  /**
   * @return {number}
   */
  getLength () {
    return 1
  }

  /**
   * @return {Array<any>}
   */
  getContent () {
    return [this.embed]
  }

  /**
   * @return {boolean}
   */
  isCountable () {
    return true
  }

  /**
   * @return {ContentEmbed}
   */
  copy () {
    return new ContentEmbed(this.embed)
  }

  /**
   * @param {number} offset
   * @return {ContentEmbed}
   */
  splice (offset) {
    throw methodUnimplemented()
  }

  /**
   * @param {ContentEmbed} right
   * @return {boolean}
   */
  mergeWith (right) {
    return false
  }

  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate (transaction, item) {}
  /**
   * @param {Transaction} transaction
   */
  delete (transaction) {}
  /**
   * @param {StructStore} store
   */
  gc (store) {}
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write (encoder, offset) {
    encoder.writeJSON(this.embed);
  }

  /**
   * @return {number}
   */
  getRef () {
    return 5
  }
}

/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentEmbed}
 */
const readContentEmbed = decoder => new ContentEmbed(decoder.readJSON());

/**
 * @private
 */
class ContentFormat {
  /**
   * @param {string} key
   * @param {Object} value
   */
  constructor (key, value) {
    this.key = key;
    this.value = value;
  }

  /**
   * @return {number}
   */
  getLength () {
    return 1
  }

  /**
   * @return {Array<any>}
   */
  getContent () {
    return []
  }

  /**
   * @return {boolean}
   */
  isCountable () {
    return false
  }

  /**
   * @return {ContentFormat}
   */
  copy () {
    return new ContentFormat(this.key, this.value)
  }

  /**
   * @param {number} offset
   * @return {ContentFormat}
   */
  splice (offset) {
    throw methodUnimplemented()
  }

  /**
   * @param {ContentFormat} right
   * @return {boolean}
   */
  mergeWith (right) {
    return false
  }

  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate (transaction, item) {
    // @todo searchmarker are currently unsupported for rich text documents
    /** @type {AbstractType<any>} */ (item.parent)._searchMarker = null;
  }

  /**
   * @param {Transaction} transaction
   */
  delete (transaction) {}
  /**
   * @param {StructStore} store
   */
  gc (store) {}
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write (encoder, offset) {
    encoder.writeKey(this.key);
    encoder.writeJSON(this.value);
  }

  /**
   * @return {number}
   */
  getRef () {
    return 6
  }
}

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentFormat}
 */
const readContentFormat = decoder => new ContentFormat(decoder.readKey(), decoder.readJSON());

/**
 * @private
 */
class ContentJSON {
  /**
   * @param {Array<any>} arr
   */
  constructor (arr) {
    /**
     * @type {Array<any>}
     */
    this.arr = arr;
  }

  /**
   * @return {number}
   */
  getLength () {
    return this.arr.length
  }

  /**
   * @return {Array<any>}
   */
  getContent () {
    return this.arr
  }

  /**
   * @return {boolean}
   */
  isCountable () {
    return true
  }

  /**
   * @return {ContentJSON}
   */
  copy () {
    return new ContentJSON(this.arr)
  }

  /**
   * @param {number} offset
   * @return {ContentJSON}
   */
  splice (offset) {
    const right = new ContentJSON(this.arr.slice(offset));
    this.arr = this.arr.slice(0, offset);
    return right
  }

  /**
   * @param {ContentJSON} right
   * @return {boolean}
   */
  mergeWith (right) {
    this.arr = this.arr.concat(right.arr);
    return true
  }

  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate (transaction, item) {}
  /**
   * @param {Transaction} transaction
   */
  delete (transaction) {}
  /**
   * @param {StructStore} store
   */
  gc (store) {}
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write (encoder, offset) {
    const len = this.arr.length;
    encoder.writeLen(len - offset);
    for (let i = offset; i < len; i++) {
      const c = this.arr[i];
      encoder.writeString(c === undefined ? 'undefined' : JSON.stringify(c));
    }
  }

  /**
   * @return {number}
   */
  getRef () {
    return 2
  }
}

/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentJSON}
 */
const readContentJSON = decoder => {
  const len = decoder.readLen();
  const cs = [];
  for (let i = 0; i < len; i++) {
    const c = decoder.readString();
    if (c === 'undefined') {
      cs.push(undefined);
    } else {
      cs.push(JSON.parse(c));
    }
  }
  return new ContentJSON(cs)
};

class ContentAny {
  /**
   * @param {Array<any>} arr
   */
  constructor (arr) {
    /**
     * @type {Array<any>}
     */
    this.arr = arr;
  }

  /**
   * @return {number}
   */
  getLength () {
    return this.arr.length
  }

  /**
   * @return {Array<any>}
   */
  getContent () {
    return this.arr
  }

  /**
   * @return {boolean}
   */
  isCountable () {
    return true
  }

  /**
   * @return {ContentAny}
   */
  copy () {
    return new ContentAny(this.arr)
  }

  /**
   * @param {number} offset
   * @return {ContentAny}
   */
  splice (offset) {
    const right = new ContentAny(this.arr.slice(offset));
    this.arr = this.arr.slice(0, offset);
    return right
  }

  /**
   * @param {ContentAny} right
   * @return {boolean}
   */
  mergeWith (right) {
    this.arr = this.arr.concat(right.arr);
    return true
  }

  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate (transaction, item) {}
  /**
   * @param {Transaction} transaction
   */
  delete (transaction) {}
  /**
   * @param {StructStore} store
   */
  gc (store) {}
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write (encoder, offset) {
    const len = this.arr.length;
    encoder.writeLen(len - offset);
    for (let i = offset; i < len; i++) {
      const c = this.arr[i];
      encoder.writeAny(c);
    }
  }

  /**
   * @return {number}
   */
  getRef () {
    return 8
  }
}

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentAny}
 */
const readContentAny = decoder => {
  const len = decoder.readLen();
  const cs = [];
  for (let i = 0; i < len; i++) {
    cs.push(decoder.readAny());
  }
  return new ContentAny(cs)
};

/**
 * @private
 */
class ContentString {
  /**
   * @param {string} str
   */
  constructor (str) {
    /**
     * @type {string}
     */
    this.str = str;
  }

  /**
   * @return {number}
   */
  getLength () {
    return this.str.length
  }

  /**
   * @return {Array<any>}
   */
  getContent () {
    return this.str.split('')
  }

  /**
   * @return {boolean}
   */
  isCountable () {
    return true
  }

  /**
   * @return {ContentString}
   */
  copy () {
    return new ContentString(this.str)
  }

  /**
   * @param {number} offset
   * @return {ContentString}
   */
  splice (offset) {
    const right = new ContentString(this.str.slice(offset));
    this.str = this.str.slice(0, offset);

    // Prevent encoding invalid documents because of splitting of surrogate pairs: https://github.com/yjs/yjs/issues/248
    const firstCharCode = this.str.charCodeAt(offset - 1);
    if (firstCharCode >= 0xD800 && firstCharCode <= 0xDBFF) {
      // Last character of the left split is the start of a surrogate utf16/ucs2 pair.
      // We don't support splitting of surrogate pairs because this may lead to invalid documents.
      // Replace the invalid character with a unicode replacement character (� / U+FFFD)
      this.str = this.str.slice(0, offset - 1) + '�';
      // replace right as well
      right.str = '�' + right.str.slice(1);
    }
    return right
  }

  /**
   * @param {ContentString} right
   * @return {boolean}
   */
  mergeWith (right) {
    this.str += right.str;
    return true
  }

  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate (transaction, item) {}
  /**
   * @param {Transaction} transaction
   */
  delete (transaction) {}
  /**
   * @param {StructStore} store
   */
  gc (store) {}
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write (encoder, offset) {
    encoder.writeString(offset === 0 ? this.str : this.str.slice(offset));
  }

  /**
   * @return {number}
   */
  getRef () {
    return 4
  }
}

/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentString}
 */
const readContentString = decoder => new ContentString(decoder.readString());

/**
 * @type {Array<function(UpdateDecoderV1 | UpdateDecoderV2):AbstractType<any>>}
 * @private
 */
const typeRefs = [
  readYArray,
  readYMap,
  readYText,
  readYXmlElement,
  readYXmlFragment,
  readYXmlHook,
  readYXmlText
];

const YArrayRefID = 0;
const YMapRefID = 1;
const YTextRefID = 2;
const YXmlElementRefID = 3;
const YXmlFragmentRefID = 4;
const YXmlHookRefID = 5;
const YXmlTextRefID = 6;

/**
 * @private
 */
class ContentType {
  /**
   * @param {AbstractType<any>} type
   */
  constructor (type) {
    /**
     * @type {AbstractType<any>}
     */
    this.type = type;
  }

  /**
   * @return {number}
   */
  getLength () {
    return 1
  }

  /**
   * @return {Array<any>}
   */
  getContent () {
    return [this.type]
  }

  /**
   * @return {boolean}
   */
  isCountable () {
    return true
  }

  /**
   * @return {ContentType}
   */
  copy () {
    return new ContentType(this.type._copy())
  }

  /**
   * @param {number} offset
   * @return {ContentType}
   */
  splice (offset) {
    throw methodUnimplemented()
  }

  /**
   * @param {ContentType} right
   * @return {boolean}
   */
  mergeWith (right) {
    return false
  }

  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate (transaction, item) {
    this.type._integrate(transaction.doc, item);
  }

  /**
   * @param {Transaction} transaction
   */
  delete (transaction) {
    let item = this.type._start;
    while (item !== null) {
      if (!item.deleted) {
        item.delete(transaction);
      } else {
        // This will be gc'd later and we want to merge it if possible
        // We try to merge all deleted items after each transaction,
        // but we have no knowledge about that this needs to be merged
        // since it is not in transaction.ds. Hence we add it to transaction._mergeStructs
        transaction._mergeStructs.push(item);
      }
      item = item.right;
    }
    this.type._map.forEach(item => {
      if (!item.deleted) {
        item.delete(transaction);
      } else {
        // same as above
        transaction._mergeStructs.push(item);
      }
    });
    transaction.changed.delete(this.type);
  }

  /**
   * @param {StructStore} store
   */
  gc (store) {
    let item = this.type._start;
    while (item !== null) {
      item.gc(store, true);
      item = item.right;
    }
    this.type._start = null;
    this.type._map.forEach(/** @param {Item | null} item */ (item) => {
      while (item !== null) {
        item.gc(store, true);
        item = item.left;
      }
    });
    this.type._map = new Map();
  }

  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write (encoder, offset) {
    this.type._write(encoder);
  }

  /**
   * @return {number}
   */
  getRef () {
    return 7
  }
}

/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentType}
 */
const readContentType = decoder => new ContentType(typeRefs[decoder.readTypeRef()](decoder));

/**
 * @todo This should return several items
 *
 * @param {StructStore} store
 * @param {ID} id
 * @return {{item:Item, diff:number}}
 */
const followRedone = (store, id) => {
  /**
   * @type {ID|null}
   */
  let nextID = id;
  let diff = 0;
  let item;
  do {
    if (diff > 0) {
      nextID = createID(nextID.client, nextID.clock + diff);
    }
    item = getItem(store, nextID);
    diff = nextID.clock - item.id.clock;
    nextID = item.redone;
  } while (nextID !== null && item instanceof Item)
  return {
    item, diff
  }
};

/**
 * Make sure that neither item nor any of its parents is ever deleted.
 *
 * This property does not persist when storing it into a database or when
 * sending it to other peers
 *
 * @param {Item|null} item
 * @param {boolean} keep
 */
const keepItem = (item, keep) => {
  while (item !== null && item.keep !== keep) {
    item.keep = keep;
    item = /** @type {AbstractType<any>} */ (item.parent)._item;
  }
};

/**
 * Split leftItem into two items
 * @param {Transaction} transaction
 * @param {Item} leftItem
 * @param {number} diff
 * @return {Item}
 *
 * @function
 * @private
 */
const splitItem = (transaction, leftItem, diff) => {
  // create rightItem
  const { client, clock } = leftItem.id;
  const rightItem = new Item(
    createID(client, clock + diff),
    leftItem,
    createID(client, clock + diff - 1),
    leftItem.right,
    leftItem.rightOrigin,
    leftItem.parent,
    leftItem.parentSub,
    leftItem.content.splice(diff)
  );
  if (leftItem.deleted) {
    rightItem.markDeleted();
  }
  if (leftItem.keep) {
    rightItem.keep = true;
  }
  if (leftItem.redone !== null) {
    rightItem.redone = createID(leftItem.redone.client, leftItem.redone.clock + diff);
  }
  // update left (do not set leftItem.rightOrigin as it will lead to problems when syncing)
  leftItem.right = rightItem;
  // update right
  if (rightItem.right !== null) {
    rightItem.right.left = rightItem;
  }
  // right is more specific.
  transaction._mergeStructs.push(rightItem);
  // update parent._map
  if (rightItem.parentSub !== null && rightItem.right === null) {
    /** @type {AbstractType<any>} */ (rightItem.parent)._map.set(rightItem.parentSub, rightItem);
  }
  leftItem.length = diff;
  return rightItem
};

/**
 * Redoes the effect of this operation.
 *
 * @param {Transaction} transaction The Yjs instance.
 * @param {Item} item
 * @param {Set<Item>} redoitems
 * @param {DeleteSet} itemsToDelete
 * @param {boolean} ignoreRemoteMapChanges
 *
 * @return {Item|null}
 *
 * @private
 */
const redoItem = (transaction, item, redoitems, itemsToDelete, ignoreRemoteMapChanges) => {
  const doc = transaction.doc;
  const store = doc.store;
  const ownClientID = doc.clientID;
  const redone = item.redone;
  if (redone !== null) {
    return getItemCleanStart(transaction, redone)
  }
  let parentItem = /** @type {AbstractType<any>} */ (item.parent)._item;
  /**
   * @type {Item|null}
   */
  let left = null;
  /**
   * @type {Item|null}
   */
  let right;
  // make sure that parent is redone
  if (parentItem !== null && parentItem.deleted === true) {
    // try to undo parent if it will be undone anyway
    if (parentItem.redone === null && (!redoitems.has(parentItem) || redoItem(transaction, parentItem, redoitems, itemsToDelete, ignoreRemoteMapChanges) === null)) {
      return null
    }
    while (parentItem.redone !== null) {
      parentItem = getItemCleanStart(transaction, parentItem.redone);
    }
  }
  const parentType = parentItem === null ? /** @type {AbstractType<any>} */ (item.parent) : /** @type {ContentType} */ (parentItem.content).type;

  if (item.parentSub === null) {
    // Is an array item. Insert at the old position
    left = item.left;
    right = item;
    // find next cloned_redo items
    while (left !== null) {
      /**
       * @type {Item|null}
       */
      let leftTrace = left;
      // trace redone until parent matches
      while (leftTrace !== null && /** @type {AbstractType<any>} */ (leftTrace.parent)._item !== parentItem) {
        leftTrace = leftTrace.redone === null ? null : getItemCleanStart(transaction, leftTrace.redone);
      }
      if (leftTrace !== null && /** @type {AbstractType<any>} */ (leftTrace.parent)._item === parentItem) {
        left = leftTrace;
        break
      }
      left = left.left;
    }
    while (right !== null) {
      /**
       * @type {Item|null}
       */
      let rightTrace = right;
      // trace redone until parent matches
      while (rightTrace !== null && /** @type {AbstractType<any>} */ (rightTrace.parent)._item !== parentItem) {
        rightTrace = rightTrace.redone === null ? null : getItemCleanStart(transaction, rightTrace.redone);
      }
      if (rightTrace !== null && /** @type {AbstractType<any>} */ (rightTrace.parent)._item === parentItem) {
        right = rightTrace;
        break
      }
      right = right.right;
    }
  } else {
    right = null;
    if (item.right && !ignoreRemoteMapChanges) {
      left = item;
      // Iterate right while right is in itemsToDelete
      // If it is intended to delete right while item is redone, we can expect that item should replace right.
      while (left !== null && left.right !== null && isDeleted(itemsToDelete, left.right.id)) {
        left = left.right;
      }
      // follow redone
      // trace redone until parent matches
      while (left !== null && left.redone !== null) {
        left = getItemCleanStart(transaction, left.redone);
      }
      // check wether we were allowed to follow right (indicating that originally this op was replaced by another item)
      if (left === null || /** @type {AbstractType<any>} */ (left.parent)._item !== parentItem) {
        // invalid parent; should never happen
        return null
      }
      if (left && left.right !== null) {
        // It is not possible to redo this item because it conflicts with a
        // change from another client
        return null
      }
    } else {
      left = parentType._map.get(item.parentSub) || null;
    }
  }
  const nextClock = getState(store, ownClientID);
  const nextId = createID(ownClientID, nextClock);
  const redoneItem = new Item(
    nextId,
    left, left && left.lastId,
    right, right && right.id,
    parentType,
    item.parentSub,
    item.content.copy()
  );
  item.redone = nextId;
  keepItem(redoneItem, true);
  redoneItem.integrate(transaction, 0);
  return redoneItem
};

/**
 * Abstract class that represents any content.
 */
class Item extends AbstractStruct {
  /**
   * @param {ID} id
   * @param {Item | null} left
   * @param {ID | null} origin
   * @param {Item | null} right
   * @param {ID | null} rightOrigin
   * @param {AbstractType<any>|ID|null} parent Is a type if integrated, is null if it is possible to copy parent from left or right, is ID before integration to search for it.
   * @param {string | null} parentSub
   * @param {AbstractContent} content
   */
  constructor (id, left, origin, right, rightOrigin, parent, parentSub, content) {
    super(id, content.getLength());
    /**
     * The item that was originally to the left of this item.
     * @type {ID | null}
     */
    this.origin = origin;
    /**
     * The item that is currently to the left of this item.
     * @type {Item | null}
     */
    this.left = left;
    /**
     * The item that is currently to the right of this item.
     * @type {Item | null}
     */
    this.right = right;
    /**
     * The item that was originally to the right of this item.
     * @type {ID | null}
     */
    this.rightOrigin = rightOrigin;
    /**
     * @type {AbstractType<any>|ID|null}
     */
    this.parent = parent;
    /**
     * If the parent refers to this item with some kind of key (e.g. YMap, the
     * key is specified here. The key is then used to refer to the list in which
     * to insert this item. If `parentSub = null` type._start is the list in
     * which to insert to. Otherwise it is `parent._map`.
     * @type {String | null}
     */
    this.parentSub = parentSub;
    /**
     * If this type's effect is redone this type refers to the type that undid
     * this operation.
     * @type {ID | null}
     */
    this.redone = null;
    /**
     * @type {AbstractContent}
     */
    this.content = content;
    /**
     * bit1: keep
     * bit2: countable
     * bit3: deleted
     * bit4: mark - mark node as fast-search-marker
     * @type {number} byte
     */
    this.info = this.content.isCountable() ? BIT2 : 0;
  }

  /**
   * This is used to mark the item as an indexed fast-search marker
   *
   * @type {boolean}
   */
  set marker (isMarked) {
    if (((this.info & BIT4) > 0) !== isMarked) {
      this.info ^= BIT4;
    }
  }

  get marker () {
    return (this.info & BIT4) > 0
  }

  /**
   * If true, do not garbage collect this Item.
   */
  get keep () {
    return (this.info & BIT1) > 0
  }

  set keep (doKeep) {
    if (this.keep !== doKeep) {
      this.info ^= BIT1;
    }
  }

  get countable () {
    return (this.info & BIT2) > 0
  }

  /**
   * Whether this item was deleted or not.
   * @type {Boolean}
   */
  get deleted () {
    return (this.info & BIT3) > 0
  }

  set deleted (doDelete) {
    if (this.deleted !== doDelete) {
      this.info ^= BIT3;
    }
  }

  markDeleted () {
    this.info |= BIT3;
  }

  /**
   * Return the creator clientID of the missing op or define missing items and return null.
   *
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */
  getMissing (transaction, store) {
    if (this.origin && this.origin.client !== this.id.client && this.origin.clock >= getState(store, this.origin.client)) {
      return this.origin.client
    }
    if (this.rightOrigin && this.rightOrigin.client !== this.id.client && this.rightOrigin.clock >= getState(store, this.rightOrigin.client)) {
      return this.rightOrigin.client
    }
    if (this.parent && this.parent.constructor === ID && this.id.client !== this.parent.client && this.parent.clock >= getState(store, this.parent.client)) {
      return this.parent.client
    }

    // We have all missing ids, now find the items

    if (this.origin) {
      this.left = getItemCleanEnd(transaction, store, this.origin);
      this.origin = this.left.lastId;
    }
    if (this.rightOrigin) {
      this.right = getItemCleanStart(transaction, this.rightOrigin);
      this.rightOrigin = this.right.id;
    }
    if ((this.left && this.left.constructor === GC) || (this.right && this.right.constructor === GC)) {
      this.parent = null;
    }
    // only set parent if this shouldn't be garbage collected
    if (!this.parent) {
      if (this.left && this.left.constructor === Item) {
        this.parent = this.left.parent;
        this.parentSub = this.left.parentSub;
      }
      if (this.right && this.right.constructor === Item) {
        this.parent = this.right.parent;
        this.parentSub = this.right.parentSub;
      }
    } else if (this.parent.constructor === ID) {
      const parentItem = getItem(store, this.parent);
      if (parentItem.constructor === GC) {
        this.parent = null;
      } else {
        this.parent = /** @type {ContentType} */ (parentItem.content).type;
      }
    }
    return null
  }

  /**
   * @param {Transaction} transaction
   * @param {number} offset
   */
  integrate (transaction, offset) {
    if (offset > 0) {
      this.id.clock += offset;
      this.left = getItemCleanEnd(transaction, transaction.doc.store, createID(this.id.client, this.id.clock - 1));
      this.origin = this.left.lastId;
      this.content = this.content.splice(offset);
      this.length -= offset;
    }

    if (this.parent) {
      if ((!this.left && (!this.right || this.right.left !== null)) || (this.left && this.left.right !== this.right)) {
        /**
         * @type {Item|null}
         */
        let left = this.left;

        /**
         * @type {Item|null}
         */
        let o;
        // set o to the first conflicting item
        if (left !== null) {
          o = left.right;
        } else if (this.parentSub !== null) {
          o = /** @type {AbstractType<any>} */ (this.parent)._map.get(this.parentSub) || null;
          while (o !== null && o.left !== null) {
            o = o.left;
          }
        } else {
          o = /** @type {AbstractType<any>} */ (this.parent)._start;
        }
        // TODO: use something like DeleteSet here (a tree implementation would be best)
        // @todo use global set definitions
        /**
         * @type {Set<Item>}
         */
        const conflictingItems = new Set();
        /**
         * @type {Set<Item>}
         */
        const itemsBeforeOrigin = new Set();
        // Let c in conflictingItems, b in itemsBeforeOrigin
        // ***{origin}bbbb{this}{c,b}{c,b}{o}***
        // Note that conflictingItems is a subset of itemsBeforeOrigin
        while (o !== null && o !== this.right) {
          itemsBeforeOrigin.add(o);
          conflictingItems.add(o);
          if (compareIDs(this.origin, o.origin)) {
            // case 1
            if (o.id.client < this.id.client) {
              left = o;
              conflictingItems.clear();
            } else if (compareIDs(this.rightOrigin, o.rightOrigin)) {
              // this and o are conflicting and point to the same integration points. The id decides which item comes first.
              // Since this is to the left of o, we can break here
              break
            } // else, o might be integrated before an item that this conflicts with. If so, we will find it in the next iterations
          } else if (o.origin !== null && itemsBeforeOrigin.has(getItem(transaction.doc.store, o.origin))) { // use getItem instead of getItemCleanEnd because we don't want / need to split items.
            // case 2
            if (!conflictingItems.has(getItem(transaction.doc.store, o.origin))) {
              left = o;
              conflictingItems.clear();
            }
          } else {
            break
          }
          o = o.right;
        }
        this.left = left;
      }
      // reconnect left/right + update parent map/start if necessary
      if (this.left !== null) {
        const right = this.left.right;
        this.right = right;
        this.left.right = this;
      } else {
        let r;
        if (this.parentSub !== null) {
          r = /** @type {AbstractType<any>} */ (this.parent)._map.get(this.parentSub) || null;
          while (r !== null && r.left !== null) {
            r = r.left;
          }
        } else {
          r = /** @type {AbstractType<any>} */ (this.parent)._start
          ;/** @type {AbstractType<any>} */ (this.parent)._start = this;
        }
        this.right = r;
      }
      if (this.right !== null) {
        this.right.left = this;
      } else if (this.parentSub !== null) {
        // set as current parent value if right === null and this is parentSub
        /** @type {AbstractType<any>} */ (this.parent)._map.set(this.parentSub, this);
        if (this.left !== null) {
          // this is the current attribute value of parent. delete right
          this.left.delete(transaction);
        }
      }
      // adjust length of parent
      if (this.parentSub === null && this.countable && !this.deleted) {
        /** @type {AbstractType<any>} */ (this.parent)._length += this.length;
      }
      addStruct(transaction.doc.store, this);
      this.content.integrate(transaction, this);
      // add parent to transaction.changed
      addChangedTypeToTransaction(transaction, /** @type {AbstractType<any>} */ (this.parent), this.parentSub);
      if ((/** @type {AbstractType<any>} */ (this.parent)._item !== null && /** @type {AbstractType<any>} */ (this.parent)._item.deleted) || (this.parentSub !== null && this.right !== null)) {
        // delete if parent is deleted or if this is not the current attribute value of parent
        this.delete(transaction);
      }
    } else {
      // parent is not defined. Integrate GC struct instead
      new GC(this.id, this.length).integrate(transaction, 0);
    }
  }

  /**
   * Returns the next non-deleted item
   */
  get next () {
    let n = this.right;
    while (n !== null && n.deleted) {
      n = n.right;
    }
    return n
  }

  /**
   * Returns the previous non-deleted item
   */
  get prev () {
    let n = this.left;
    while (n !== null && n.deleted) {
      n = n.left;
    }
    return n
  }

  /**
   * Computes the last content address of this Item.
   */
  get lastId () {
    // allocating ids is pretty costly because of the amount of ids created, so we try to reuse whenever possible
    return this.length === 1 ? this.id : createID(this.id.client, this.id.clock + this.length - 1)
  }

  /**
   * Try to merge two items
   *
   * @param {Item} right
   * @return {boolean}
   */
  mergeWith (right) {
    if (
      this.constructor === right.constructor &&
      compareIDs(right.origin, this.lastId) &&
      this.right === right &&
      compareIDs(this.rightOrigin, right.rightOrigin) &&
      this.id.client === right.id.client &&
      this.id.clock + this.length === right.id.clock &&
      this.deleted === right.deleted &&
      this.redone === null &&
      right.redone === null &&
      this.content.constructor === right.content.constructor &&
      this.content.mergeWith(right.content)
    ) {
      const searchMarker = /** @type {AbstractType<any>} */ (this.parent)._searchMarker;
      if (searchMarker) {
        searchMarker.forEach(marker => {
          if (marker.p === right) {
            // right is going to be "forgotten" so we need to update the marker
            marker.p = this;
            // adjust marker index
            if (!this.deleted && this.countable) {
              marker.index -= this.length;
            }
          }
        });
      }
      if (right.keep) {
        this.keep = true;
      }
      this.right = right.right;
      if (this.right !== null) {
        this.right.left = this;
      }
      this.length += right.length;
      return true
    }
    return false
  }

  /**
   * Mark this Item as deleted.
   *
   * @param {Transaction} transaction
   */
  delete (transaction) {
    if (!this.deleted) {
      const parent = /** @type {AbstractType<any>} */ (this.parent);
      // adjust the length of parent
      if (this.countable && this.parentSub === null) {
        parent._length -= this.length;
      }
      this.markDeleted();
      addToDeleteSet(transaction.deleteSet, this.id.client, this.id.clock, this.length);
      addChangedTypeToTransaction(transaction, parent, this.parentSub);
      this.content.delete(transaction);
    }
  }

  /**
   * @param {StructStore} store
   * @param {boolean} parentGCd
   */
  gc (store, parentGCd) {
    if (!this.deleted) {
      throw unexpectedCase()
    }
    this.content.gc(store);
    if (parentGCd) {
      replaceStruct(store, this, new GC(this.id, this.length));
    } else {
      this.content = new ContentDeleted(this.length);
    }
  }

  /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   * @param {number} offset
   */
  write (encoder, offset) {
    const origin = offset > 0 ? createID(this.id.client, this.id.clock + offset - 1) : this.origin;
    const rightOrigin = this.rightOrigin;
    const parentSub = this.parentSub;
    const info = (this.content.getRef() & BITS5) |
      (origin === null ? 0 : BIT8) | // origin is defined
      (rightOrigin === null ? 0 : BIT7) | // right origin is defined
      (parentSub === null ? 0 : BIT6); // parentSub is non-null
    encoder.writeInfo(info);
    if (origin !== null) {
      encoder.writeLeftID(origin);
    }
    if (rightOrigin !== null) {
      encoder.writeRightID(rightOrigin);
    }
    if (origin === null && rightOrigin === null) {
      const parent = /** @type {AbstractType<any>} */ (this.parent);
      if (parent._item !== undefined) {
        const parentItem = parent._item;
        if (parentItem === null) {
          // parent type on y._map
          // find the correct key
          const ykey = findRootTypeKey(parent);
          encoder.writeParentInfo(true); // write parentYKey
          encoder.writeString(ykey);
        } else {
          encoder.writeParentInfo(false); // write parent id
          encoder.writeLeftID(parentItem.id);
        }
      } else if (parent.constructor === String) { // this edge case was added by differential updates
        encoder.writeParentInfo(true); // write parentYKey
        encoder.writeString(parent);
      } else if (parent.constructor === ID) {
        encoder.writeParentInfo(false); // write parent id
        encoder.writeLeftID(parent);
      } else {
        unexpectedCase();
      }
      if (parentSub !== null) {
        encoder.writeString(parentSub);
      }
    }
    this.content.write(encoder, offset);
  }
}

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @param {number} info
 */
const readItemContent = (decoder, info) => contentRefs[info & BITS5](decoder);

/**
 * A lookup map for reading Item content.
 *
 * @type {Array<function(UpdateDecoderV1 | UpdateDecoderV2):AbstractContent>}
 */
const contentRefs = [
  () => { unexpectedCase(); }, // GC is not ItemContent
  readContentDeleted, // 1
  readContentJSON, // 2
  readContentBinary, // 3
  readContentString, // 4
  readContentEmbed, // 5
  readContentFormat, // 6
  readContentType, // 7
  readContentAny, // 8
  readContentDoc, // 9
  () => { unexpectedCase(); } // 10 - Skip is not ItemContent
];

const structSkipRefNumber = 10;

/**
 * @private
 */
class Skip extends AbstractStruct {
  get deleted () {
    return true
  }

  delete () {}

  /**
   * @param {Skip} right
   * @return {boolean}
   */
  mergeWith (right) {
    if (this.constructor !== right.constructor) {
      return false
    }
    this.length += right.length;
    return true
  }

  /**
   * @param {Transaction} transaction
   * @param {number} offset
   */
  integrate (transaction, offset) {
    // skip structs cannot be integrated
    unexpectedCase();
  }

  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write (encoder, offset) {
    encoder.writeInfo(structSkipRefNumber);
    // write as VarUint because Skips can't make use of predictable length-encoding
    writeVarUint(encoder.restEncoder, this.length - offset);
  }

  /**
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */
  getMissing (transaction, store) {
    return null
  }
}

/** eslint-env browser */

const glo = /** @type {any} */ (typeof window !== 'undefined'
  ? window
  // @ts-ignore
  : typeof global !== 'undefined' ? global : {});

const importIdentifier = '__ $YJS$ __';

if (glo[importIdentifier] === true) {
  /**
   * Dear reader of this warning message. Please take this seriously.
   *
   * If you see this message, please make sure that you only import one version of Yjs. In many cases,
   * your package manager installs two versions of Yjs that are used by different packages within your project.
   * Another reason for this message is that some parts of your project use the commonjs version of Yjs
   * and others use the EcmaScript version of Yjs.
   *
   * This often leads to issues that are hard to debug. We often need to perform constructor checks,
   * e.g. `struct instanceof GC`. If you imported different versions of Yjs, it is impossible for us to
   * do the constructor checks anymore - which might break the CRDT algorithm.
   */
  console.warn('Yjs was already imported. Importing different versions of Yjs often leads to issues.');
}
glo[importIdentifier] = true;


//# sourceMappingURL=yjs.mjs.map


/***/ }),

/***/ 83285:
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"name":"@lib/editor","version":"2.43.0","description":"Collaborate editing environment","main":"./dist/editor.js","module":"./dist/editor.js","publishConfig":{"registry":"https://gl.nimbusweb.co/api/v4/projects/213/packages/npm/","@lib:registry":"https://gl.nimbusweb.co/api/v4/projects/213/packages/npm/"},"dependencies":{"@babel/node":"^7.14.2","@babel/plugin-transform-classes":"^7.14.4","@babel/runtime":"^7.14.0","@grammarly/editor-sdk":"^2.3.18","async.queue":"^0.5.2","base64-stream":"^1.0.0","clipboard-copy":"^2.0.1","clone":"^2.1.1","codemirror":"^5.59.1","codemirror-asciidoc":"^1.0.4","core-js":"^3.13.1","dayjs":"^1.11.11","deep-equal":"^2.0.3","deepmerge":"^3.2.0","delta-e":"0.0.7","detect-node":"^2.0.4","downloadjs":"^1.4.7","equal":"^0.1.1","events":"^3.3.0","file-saver":"^2.0.0-rc.4","file-system":"^2.2.2","filesize":"^3.6.1","fix-webm-duration":"^1.0.5","fs-web":"^1.0.1","he":"^1.2.0","highlight.js":"^10.0.3","html-webpack-plugin":"^5.3.1","is-hotkey":"^0.1.3","izitoast":"^1.4.0","lib0":"0.2.42","lodash.chunk":"^4.2.0","lodash.debounce":"^4.0.8","lodash.escape":"^4.0.1","lodash.isequal":"^4.5.0","lodash.throttle":"^4.1.1","mark.js":"^8.11.1","markdown-it":"^13.0.1","mime":"^2.4.4","moize":"^5.4.1","p-cancelable":"^2.0.0","papaparse":"^5.3.2","parchment":"https://git@github.com/calibr/parchment#v1.1.6","parse-color":"^1.0.0","pdfjs-dist":"2.9.359","popper.js":"^1.14.6","preact":"^10.5.13","preact-i18n":"2.4.0-preactx","preact-material-components":"^1.6.1","preact-middle-truncate":"https://git@github.com/calibr/react-middle-truncate#v1.0.1","preact-transition-group":"^2.0.0","quill-delta":"^4.2.2","react-autosize-textarea":"^7.1.0","react-datepicker":"^4.8.0","react-responsive-masonry":"^2.1.7","rgb-lab":"^1.0.0","selection-range":"^1.1.0","simple-color-picker":"^0.1.2","ts-ebml":"^2.0.2","unsplash-js":"^7.0.15","video.js":"^7.19.2","videojs-errors":"^5.0.0","wavesurfer.js":"^4.2.0","word-wrap":"^1.2.3","y-codemirror":"^2.1.0","y-protocols":"npm:@nnote/y-protocols@1.0.5-nim4","y-websockets-client":"^9.0.0-4"},"devDependencies":{"@angular/cdk":"^13.2.0","@angular/material":"^12.2.11","@babel/cli":"^7.4.4","@babel/core":"^7.14.3","@babel/plugin-proposal-class-properties":"^7.13.0","@babel/plugin-syntax-dynamic-import":"^7.8.3","@babel/plugin-transform-react-jsx":"^7.14.3","@babel/preset-env":"^7.14.4","@google-cloud/bigquery":"^5.6.0","@wdio/cli":"^5.18.6","@wdio/local-runner":"^5.18.6","@wdio/mocha-framework":"^5.18.6","@wdio/spec-reporter":"^5.18.6","@wdio/sync":"^5.18.6","archiver":"^3.1.1","aws-sdk":"^2.618.0","axios":"^0.19.2","babel-eslint":"^10.0.1","babel-loader":"^8.0.5","body-parser":"^1.19.0","byte-base64":"^1.1.0","cache-loader":"^4.1.0","chromedriver":"2.42.1","clean-webpack-plugin":"^3.0.0","connect-busboy":"0.0.2","copy-webpack-plugin":"^5.0.5","css-loader":"^1.0.0","debug":"^3.1.0","desvg-loader":"https://git@github.com/calibr/desvg-loader","dom-storage":"^2.1.0","eh-guid":"^0.12.0","escape-html":"^1.0.3","express":"^4.16.3","fibers":"^4.0.1","fs-extra":"^8.1.0","html-pdf-chrome":"^0.6.0","install":"^0.12.2","jsdom":"^16.2.1","karma":"^6.4.3","karma-chrome-launcher":"^2.2.0","karma-firefox-launcher":"^1.1.0","karma-mocha":"^1.3.0","karma-source-map-support":"^1.3.0","karma-spec-reporter":"0.0.32","mini-css-extract-plugin":"^0.4.2","mocha":"^6.2.2","morgan":"^1.9.0","optimize-css-assets-webpack-plugin":"^5.0.1","postcss-assets":"^5.0.0","postcss-loader":"^3.0.0","pretty":"^2.0.0","puppeteer":"^8.0.0","queue":"^6.0.1","rangefix":"^0.2.9","raw-loader":"^0.5.1","react-modal":"^3.11.2","regenerator-runtime":"^0.13.7","request":"^2.88.0","sass":"^1.49.4","sass-loader":"^12.4.0","sax":"^1.2.4","should":"^13.2.3","sinon":"^6.2.0","style-loader":"^0.22.1","svg-loader":"0.0.2","temp-dir":"^2.0.0","terser-webpack-plugin":"^1.2.1","tinycolor2":"^1.4.2","tmp":"^0.1.0","uglifyjs-webpack-plugin":"^2.1.1","wdio-chromedriver-service":"^5.0.2","wdio-performancetotal-service":"^2.0.2","webdriverio":"^5.18.6","webpack":"^5.38.1","webpack-bundle-analyzer":"^3.6.1","webpack-cli":"^3.3.0","webpack-dev-server":"^3.11.2","yjs":"13.5.39"},"peerDependencies":{"yjs":"13.5.39"},"scripts":{"start":"http-server -c-1 -p 3000 public","start:dev":"webpack-dev-server --mode=development --type=editor-web --progress","start:devServer":"webpack --mode=development --type=editor-node && PORT=1235 node dev-server/server","start:devServerWin":"webpack --mode=development --type=editor-node && set PORT=1235 && node dev-server/server","start:devUnit":"webpack --watch --mode=development --type=unit","build":"rm -rf dist/*; webpack; npm run buildProvidersNode","buildBrowser":"rm -rf dist/*; BROWSER=1 webpack","buildWin":"del /Q/F dist\\\\* && webpack && npm run buildProvidersNode","buildProvidersNode":"babel --verbose --config-file ./node.babelrc.json ./providers --out-dir dist/providers --plugins=@babel/plugin-proposal-class-properties","buildDev":"NODE_OPTIONS=--max-old-space-size=4096 webpack --mode=development --buildTarget=node && NODE_OPTIONS=--max-old-space-size=4096 webpack --mode=development --buildTarget=web","watch":"webpack --watch --mode=development --progress","watch:cache":"webpack --watch --mode=development --progress --optimize=cache-loader","server":"PORT=1234 node dev-server/server","serverWin":"set PORT=1234 && node dev-server/server","buildTheme":"sass ./src/theme/scss/main.scss ./src/theme/css/theme.css","test":"karma start","testWin":"karma start ./karma-win.conf.js","testDev":"karma start ./karma-dev.conf.js","testE2E":"wdio wdio.conf.js && wdio wdio.collaborate.conf.js","testE2Esingle":"wdio wdio.conf.js","testE2Eclbt":"wdio wdio.collaborate.conf.js","testE2EServer":"wdio wdio.server.conf.js","testE2EclbtServer":"TEST_TYPE=collaborate wdio wdio.server.conf.js","performance":"rm -rf performance-results/* && wdio wdio.performance.conf.js && GOOGLE_APPLICATION_CREDENTIALS=credentials.json LAUNCH=local npm run performanceToBQ","performanceWin":"del /Q/F  performance-results\\\\* & wdio wdio.performance.conf.js && set GOOGLE_APPLICATION_CREDENTIALS=credentials.json LAUNCH=local npm run performanceToBQ","performanceToBQ":"node test/performance/bigquery","performanceServer":"TEST_TYPE=performance wdio wdio.server.conf.js","lng":"node ./util/localization/localization.js","lngSave":"node ./util/localization/localization.js --save"},"author":"as.stolbov@gmail.com","license":"SEE LICENSE IN LICENSE"}');

/***/ }),

/***/ 46673:
/***/ ((module) => {

"use strict";
module.exports = "[\"abandon\",\"abate\",\"abduct\",\"abide\",\"able\",\"abnormal\",\"aboard\",\"abolish\",\"abort\",\"abound\",\"about\",\"abroad\",\"abrupt\",\"absent\",\"absorb\",\"abundant\",\"abuse\",\"abuse\",\"abuse\",\"accelerate\",\"accept\",\"access\",\"accessory\",\"accident\",\"accident\",\"acclaim\",\"accommodate\",\"accompany\",\"accomplish\",\"accord\",\"according to\",\"account\",\"account\",\"account for\",\"accurate\",\"accuse\",\"accustom\",\"ache\",\"achieve\",\"acid\",\"acknowledge\",\"acquaint\",\"acquire\",\"acquit\",\"across\",\"act\",\"act on\",\"acute\",\"adamant\",\"add to\",\"add up\",\"addict\",\"addition\",\"adhere\",\"adjacent\",\"adjective\",\"adjust\",\"admire\",\"admit\",\"adolescent\",\"adopt\",\"adopt\",\"adore\",\"adorn\",\"adult\",\"adultery\",\"advance\",\"advantage\",\"adventure\",\"adverb\",\"adversary\",\"adverse\",\"advertise\",\"advice\",\"advise\",\"advocate\",\"aerial\",\"aerial\",\"affair\",\"affair\",\"affect\",\"affection\",\"affiliate\",\"affirm\",\"afflict\",\"affluent\",\"afford\",\"afraid\",\"after all\",\"aftermath\",\"age\",\"age\",\"agenda\",\"aggravate\",\"aggregate\",\"agile\",\"agitate\",\"agree\",\"agreement\",\"agriculture\",\"ahead\",\"aid\",\"ailment\",\"aim\",\"air\",\"airborne\",\"aircraft\",\"airline\",\"aisle\",\"akin\",\"alarm\",\"alas\",\"albeit\",\"alert\",\"alien\",\"alienate\",\"align\",\"alike\",\"alive\",\"all along\",\"allege\",\"allegiance\",\"allocate\",\"allot\",\"allow\",\"allow for\",\"allowance\",\"allude\",\"allure\",\"ally\",\"almost\",\"alone\",\"alongside\",\"aloud\",\"alter\",\"alternate\",\"although\",\"altitude\",\"altogether\",\"amateur\",\"amaze\",\"ambassador\",\"amber\",\"ambiguous\",\"ambulance\",\"ambush\",\"amend\",\"amenity\",\"amid (amidst)\",\"ammunition\",\"amount\",\"ample\",\"amplify\",\"amuse\",\"ancestor\",\"anchor\",\"ancient\",\"anew\",\"anger\",\"angle\",\"angry\",\"anguish\",\"animate\",\"ankle\",\"anniversary\",\"announce\",\"annoy\",\"annual\",\"ant\",\"anthem\",\"anticipate\",\"antique\",\"anxiety\",\"anxious\",\"anymore\",\"anytime\",\"anyway\",\"anywhere\",\"apart\",\"apart from\",\"apartment\",\"ape\",\"apiece\",\"apology\",\"appal\",\"apparent\",\"appeal\",\"appear\",\"appear\",\"applause\",\"appliance\",\"apply\",\"apply\",\"appoint\",\"appraise\",\"appreciate\",\"apprentice\",\"approach\",\"appropriate\",\"appropriate\",\"approve\",\"approve of\",\"approximate\",\"apron\",\"apt\",\"aquatic\",\"arbitrary\",\"arc\",\"arch\",\"archive\",\"area\",\"argue\",\"arise (arose, arisen)\",\"arm\",\"armor (armour)\",\"arms\",\"arouse\",\"arrange\",\"array\",\"arrest\",\"arrive\",\"arrogant\",\"arrow\",\"arson\",\"article\",\"article\",\"artificial\",\"as though\",\"as well\",\"as well as\",\"ascend\",\"ascertain\",\"ash\",\"ashamed\",\"ashtray\",\"aside\",\"aside from\",\"ask around\",\"ask out\",\"asleep\",\"aspire\",\"ass\",\"assassin\",\"assault\",\"assemble\",\"assert\",\"assess\",\"asset\",\"assign\",\"assimilate\",\"assist\",\"associate\",\"assume\",\"assume\",\"assure\",\"astonish\",\"astound\",\"asylum\",\"at all\",\"at first\",\"at last\",\"at least\",\"at odds with\",\"at once\",\"at the moment\",\"atop\",\"atrocity\",\"attach\",\"attack\",\"attain\",\"attempt\",\"attend\",\"attic\",\"attitude\",\"attorney\",\"attract\",\"attribute\",\"audible\",\"audience\",\"augment\",\"aunt\",\"authorities\",\"authority\",\"authorize\",\"available\",\"avalanche\",\"average\",\"avert\",\"avid\",\"avoid\",\"await\",\"awake\",\"award\",\"aware\",\"awe\",\"awesome\",\"awful\",\"awhile\",\"awkward\",\"axe (ax)\",\"axis\",\"bachelor\",\"bachelor\",\"back down\",\"back then\",\"back up\",\"backbone\",\"backdrop\",\"background\",\"background\",\"backpack\",\"badge\",\"baffled\",\"bag\",\"bail\",\"bait\",\"bake\",\"bald\",\"bale\",\"balloon\",\"ballot\",\"ban\",\"band\",\"bandage\",\"bang\",\"banish\",\"bank\",\"bank on\",\"bankrupt\",\"banner\",\"baptize\",\"bar\",\"bar\",\"barb\",\"barber\",\"bare\",\"barefoot\",\"barely\",\"bargain\",\"bark\",\"bark\",\"barn\",\"barrel\",\"barren\",\"bartender\",\"base\",\"basement\",\"bash\",\"basket\",\"bastard\",\"bat\",\"bat\",\"batch\",\"bath\",\"bathe\",\"batter\",\"battle\",\"bay\",\"be after\",\"be back\",\"be in\",\"be into\",\"be keen to\",\"be late\",\"be off\",\"be on fire\",\"be over\",\"be up to\",\"bead\",\"beak\",\"beam\",\"beam\",\"bean\",\"bear (bore, born)\",\"bear (bore, born)\",\"beard\",\"beast\",\"beat (beat, beaten)\",\"beat (beat, beaten)\",\"beat up\",\"beauty\",\"beaver\",\"beckon\",\"become of\",\"beef\",\"beep\",\"beetle\",\"beforehand\",\"beg\",\"behave\",\"behavior\",\"behold\",\"beige\",\"belief\",\"bell\",\"bellow\",\"belly\",\"belong to\",\"beloved\",\"below\",\"belt\",\"bench\",\"bend (bent, bent)\",\"bend down\",\"beneath\",\"benefit\",\"benevolent\",\"berry\",\"berth\",\"beside\",\"besides\",\"bestow\",\"bet\",\"betray\",\"beverage\",\"beware\",\"bewilder\",\"beyond\",\"bias\",\"bicycle\",\"bid\",\"bigot\",\"bill\",\"bill\",\"billboard\",\"billion\",\"bin\",\"bind (bound, bound)\",\"binge\",\"birth\",\"bishop\",\"bitch\",\"bite (bit, bitten)\",\"bitter\",\"bizarre\",\"black out\",\"blackmail\",\"blade\",\"blame\",\"bland\",\"blank\",\"blanket\",\"blast\",\"blast\",\"blatant\",\"blaze\",\"bleach\",\"bleak\",\"bleed (bled, bled)\",\"blend\",\"bless\",\"blind\",\"blink\",\"bliss\",\"blizzard\",\"bloat\",\"block\",\"block\",\"block out\",\"block up\",\"blonde\",\"bloom\",\"blossom\",\"blouse\",\"blow (blew blown)\",\"blow (blew blown)\",\"blow out\",\"blow over\",\"blow up\",\"blow up\",\"bluff\",\"blunt\",\"blur\",\"blush\",\"board\",\"board\",\"board\",\"boast\",\"boat\",\"bog\",\"boil\",\"bold\",\"bolster\",\"bond\",\"bond\",\"bone\",\"bonfire\",\"boobs\",\"book\",\"boom\",\"boost\",\"boot\",\"booth\",\"booze\",\"border\",\"bore\",\"borough\",\"borrow\",\"both\",\"bother\",\"bottom\",\"boulder\",\"bounce\",\"bound\",\"boundary\",\"bounds\",\"bounty\",\"bout\",\"bout\",\"bow\",\"bow\",\"bow\",\"bow out\",\"bowel\",\"bowl\",\"brace\",\"bracket\",\"brag\",\"braid\",\"brake\",\"branch\",\"branch\",\"brass\",\"brassiere (bra)\",\"brave\",\"brawl\",\"brazen\",\"breach\",\"breadth\",\"break\",\"break (broke, broken)\",\"break away\",\"break down\",\"break into (break in)\",\"break out\",\"break out\",\"break up\",\"breakthrough\",\"breast\",\"breath\",\"breathe\",\"breed\",\"breed (bred, bred)\",\"brew\",\"bribe\",\"brick\",\"bride\",\"bridge\",\"brief\",\"briefcase\",\"bright\",\"brilliant\",\"brim\",\"bring (brought, brought)\",\"bring along\",\"bring around\",\"bring back\",\"bring down\",\"bring in\",\"bring out\",\"bring up\",\"bring up\",\"brink\",\"brisk\",\"bristle\",\"brittle\",\"broad\",\"broadcast\",\"broom\",\"broth\",\"bruise\",\"brush\",\"brute\",\"bubble\",\"buck\",\"bucket\",\"buckle\",\"buckle up\",\"bud\",\"buddy\",\"budge\",\"buffalo\",\"bug\",\"build on\",\"built-in\",\"bulb\",\"bulge\",\"bulk\",\"bullet\",\"bullshit\",\"bully\",\"bum\",\"bump\",\"bump\",\"bun\",\"bunch\",\"bundle\",\"bunk\",\"bunny\",\"burden\",\"burglar\",\"burn\",\"burn down\",\"burn out\",\"burrow\",\"burst\",\"bury\",\"bush\",\"bustle\",\"busy\",\"butcher\",\"butt\",\"butt\",\"butt in\",\"butter\",\"butterfly\",\"button\",\"buy\",\"buy up\",\"buzz\",\"by chance\",\"by far\",\"by heart\",\"by oneself\",\"by the way\",\"bypass\",\"cab\",\"cabbage\",\"cabin\",\"cable\",\"cage\",\"calf (pl:calves)\",\"call back\",\"call for\",\"call off\",\"call on\",\"calm\",\"calm down\",\"camp\",\"can\",\"cancel\",\"cancer\",\"candid\",\"candle\",\"candy\",\"cane\",\"cannon\",\"canopy\",\"canvas\",\"cap\",\"capable\",\"capacity\",\"capacity\",\"cape\",\"capital\",\"captive\",\"capture\",\"carbohydrate\",\"carbon\",\"carcass\",\"cardboard\",\"care\",\"care\",\"career\",\"caress\",\"cargo\",\"carpenter\",\"carpet\",\"carriage\",\"carrot\",\"carry\",\"carry out\",\"cart\",\"cartoon\",\"carve\",\"case\",\"case\",\"cash\",\"casket\",\"cast (cast, cast)\",\"cast (cast, cast)\",\"casual\",\"casualty\",\"catch\",\"catch (caught, caught)\",\"catch on\",\"catch on\",\"catch up on\",\"catch up with\",\"cater\",\"catering\",\"cathedral\",\"cattle\",\"cause\",\"caution\",\"cave\",\"caviar\",\"cavity\",\"cease\",\"cedar\",\"ceiling\",\"celebrate\",\"celebrity\",\"celestial\",\"cell\",\"cellar\",\"cellular\",\"cemetery\",\"censorship\",\"census\",\"century\",\"cereal\",\"certain\",\"chain\",\"chair\",\"chairman\",\"chalk\",\"challenge\",\"chamber\",\"chancellor\",\"change\",\"chant\",\"chaos\",\"chap\",\"chapel\",\"chapter\",\"character\",\"charge\",\"charge\",\"charge\",\"charity\",\"charm\",\"chart\",\"chase\",\"chat\",\"chatter\",\"cheat\",\"cheat on\",\"check\",\"check in\",\"check into\",\"check on\",\"check out\",\"check out\",\"checkup\",\"cheek\",\"cheer\",\"cheer on\",\"cheer up\",\"cheerful\",\"chef\",\"chemistry\",\"cherish\",\"chess\",\"chest\",\"chest\",\"chestnut\",\"chew\",\"chief\",\"childhood\",\"chill\",\"chill out\",\"chimney\",\"chin\",\"chip\",\"choice\",\"choir\",\"choke\",\"chop\",\"chop down\",\"chop up\",\"chord\",\"chore\",\"chorus\",\"Christmas\",\"chuck\",\"chuckle\",\"chunk\",\"church\",\"cinema\",\"cinnamon\",\"circle\",\"circuit\",\"circumstance\",\"circus\",\"cite\",\"citizen\",\"civic\",\"civil\",\"civilian\",\"claim\",\"claim\",\"clam\",\"clamour\",\"clamp\",\"clap\",\"clarify\",\"clash\",\"clasp\",\"clause\",\"claw\",\"clay\",\"clean up\",\"cleanse\",\"clear\",\"clear off\",\"clear out\",\"clear up\",\"cleave\",\"clench\",\"clergy\",\"clerical\",\"clever\",\"click\",\"cliff\",\"climax\",\"climb\",\"cling (clung, clung)\",\"clip\",\"clip\",\"cloak\",\"clockwise\",\"clog\",\"close down\",\"close in on\",\"closet\",\"closure\",\"cloth\",\"clothe\",\"cloud\",\"clout\",\"clove\",\"clue\",\"clump\",\"clumsy\",\"clutch\",\"clutter\",\"coach\",\"coach\",\"coal\",\"coarse\",\"coast\",\"coaster\",\"coat\",\"coat\",\"coax\",\"coconut\",\"coerce\",\"coffin\",\"coherent\",\"cohesion\",\"coil\",\"coincide\",\"coincidence\",\"cold\",\"collaborate\",\"collapse\",\"collar\",\"collect\",\"collide\",\"colon\",\"colonel\",\"column\",\"comb\",\"combat\",\"combine\",\"come about\",\"come across\",\"come along\",\"come along\",\"come by\",\"come by\",\"come down\",\"come from\",\"come into\",\"come off\",\"come off\",\"come on\",\"come out\",\"come out\",\"come over\",\"come through\",\"come to\",\"come to\",\"come to life\",\"come true\",\"come under\",\"come up\",\"come up\",\"come up to\",\"come up with\",\"come with\",\"comedian\",\"comfort\",\"commemorate\",\"commence\",\"commend\",\"commercial\",\"commission\",\"commit\",\"commitment\",\"commitment\",\"commodity\",\"common\",\"common\",\"commonplace\",\"commonwealth\",\"communicate\",\"community\",\"commute\",\"compact\",\"compare\",\"comparison\",\"compartment\",\"compassion\",\"compatible\",\"compel\",\"compete\",\"complain\",\"complement\",\"complement\",\"complete\",\"complex\",\"complicate\",\"comply\",\"compose\",\"compound\",\"comprehend\",\"comprehensive\",\"compress\",\"comprise\",\"compulsory\",\"comrade\",\"conceal\",\"concede\",\"conceive\",\"concept\",\"concern\",\"conclude\",\"concrete\",\"concur\",\"condemn\",\"condition\",\"condition\",\"conduct\",\"cone\",\"confer\",\"confer\",\"confess\",\"confide\",\"confident\",\"confine\",\"confirm\",\"conform\",\"confront\",\"confuse\",\"congestion\",\"congratulate\",\"conjunction\",\"connect\",\"conquer\",\"conquest\",\"conscience\",\"conscious\",\"consecutive\",\"consent\",\"consequence\",\"consequent\",\"conserve\",\"consider\",\"consider\",\"considerable\",\"consist of\",\"consistent\",\"console\",\"conspicuous\",\"conspire\",\"constant\",\"constellation\",\"constitute\",\"constrain\",\"construct\",\"construction (site)\",\"consult\",\"consume\",\"contain\",\"contaminate\",\"contemplate\",\"contemporary\",\"contempt\",\"contend\",\"content\",\"content with\",\"contest\",\"contingency\",\"continue\",\"contract\",\"contradict\",\"contrary\",\"contribute\",\"controversy\",\"convene\",\"convenient\",\"conventional\",\"converge\",\"converse\",\"convert\",\"convey\",\"convict\",\"conviction\",\"convince\",\"cookie\",\"cool\",\"cool down\",\"cooperate\",\"cope with\",\"copper\",\"cord\",\"core\",\"cork\",\"corn\",\"corner\",\"corps\",\"corpse\",\"correct\",\"correlate\",\"correspond\",\"corrupt\",\"cost (cost, cost)\",\"cotton\",\"couch\",\"cough\",\"council\",\"counsel\",\"count\",\"count\",\"count on\",\"counter\",\"counter\",\"counterfeit\",\"counterpart\",\"countryside\",\"county\",\"coup\",\"couple\",\"courage\",\"court\",\"court\",\"court\",\"courtesy\",\"courtyard\",\"cover\",\"coverage\",\"covet\",\"coward\",\"co-worker\",\"cozy\",\"crack\",\"crackle\",\"cradle\",\"craft\",\"cram\",\"cramp\",\"crane\",\"crank\",\"crap\",\"crash\",\"crate\",\"crave\",\"crawl\",\"crayon\",\"creak\",\"cream\",\"crease\",\"create\",\"creature\",\"credential\",\"credible\",\"creed\",\"creek\",\"creep\",\"creep (crept, crept)\",\"creepy\",\"crest\",\"crew\",\"crib\",\"crime\",\"criminal\",\"crimson\",\"cringe\",\"cripple\",\"crisp\",\"crook\",\"crop\",\"cross\",\"cross out\",\"crossroads\",\"crouch\",\"crow\",\"crowd\",\"crown\",\"crucial\",\"crude\",\"cruel\",\"crumb\",\"crumble\",\"crumple\",\"crunch\",\"crusade\",\"crush\",\"crust\",\"cry out\",\"cub\",\"cubicle\",\"cucumber\",\"cuddle\",\"cue\",\"cuisine\",\"cup\",\"cupboard\",\"curb\",\"curb\",\"cure\",\"curious\",\"curl\",\"currency\",\"current\",\"current\",\"curriculum vitae\",\"curse\",\"curtain\",\"curve\",\"cushion\",\"custody\",\"custom\",\"custom\",\"customer\",\"customs\",\"cut across\",\"cut down\",\"cut off\",\"cute\",\"dagger\",\"daily\",\"dairy\",\"dam\",\"damage\",\"damn\",\"damp\",\"dangle\",\"dare\",\"darling\",\"darn\",\"dash\",\"dash\",\"dash\",\"data\",\"database\",\"date\",\"daunt\",\"dawn\",\"dawn on\",\"day off\",\"daze\",\"dazzle\",\"dead end\",\"deaf\",\"deal\",\"deal in\",\"deal with\",\"debate\",\"debris\",\"debt\",\"decade\",\"decay\",\"deceased\",\"deceive\",\"decent\",\"deception\",\"decide\",\"decisive\",\"deck\",\"declare\",\"decline\",\"decline\",\"decorate\",\"decrease\",\"decree\",\"dedicate\",\"deduct\",\"deed\",\"deem\",\"deep\",\"deer (pl:deer)\",\"defeat\",\"defence (defense)\",\"defend\",\"deficient\",\"define\",\"definite\",\"deflect\",\"deft\",\"defy\",\"degree\",\"degree\",\"deity\",\"delay\",\"deliberate\",\"delicate\",\"delicious\",\"delight\",\"delinquent\",\"deliver\",\"deliver\",\"delusion\",\"demand\",\"demand\",\"demise\",\"demolish\",\"den\",\"denote\",\"denounce\",\"dense\",\"dent\",\"dental\",\"deny\",\"depart\",\"department\",\"depend\",\"dependent\",\"depict\",\"deplete\",\"deploy\",\"depot\",\"depress\",\"deprive\",\"depth\",\"deputy\",\"derive\",\"descend\",\"descend from\",\"describe\",\"desert\",\"desert\",\"deserve\",\"designate\",\"desire\",\"desk\",\"desktop\",\"desolate\",\"despair\",\"desperate\",\"despise\",\"despite\",\"destination\",\"destiny\",\"destroy\",\"detach\",\"detain\",\"detect\",\"detention\",\"deter\",\"deteriorate\",\"determine\",\"determined\",\"detriment\",\"devastate\",\"develop\",\"deviate\",\"devise\",\"devoid\",\"devote\",\"devour\",\"dial\",\"diamond\",\"diary\",\"dice (pl: dice)\",\"dictionary\",\"die down\",\"die out\",\"differ\",\"different\",\"difficulty\",\"diffuse\",\"dig (dug, dug)\",\"dig up\",\"digest\",\"digit\",\"dignity\",\"diligent\",\"dilute\",\"dim\",\"dimension\",\"diminish\",\"dine\",\"dip\",\"dire\",\"direct\",\"direct\",\"directory\",\"disable\",\"disabled\",\"disappoint\",\"disaster\",\"discard\",\"discern\",\"disciple\",\"disclose\",\"discount\",\"discourage\",\"discourse\",\"discover\",\"discreet\",\"discrepancy\",\"discrete\",\"discretion\",\"discriminate\",\"discuss\",\"disdain\",\"disease\",\"disgrace\",\"disguise\",\"disgust\",\"dish\",\"dish\",\"disillusion\",\"dislocate\",\"dismantle\",\"dismay\",\"dismiss\",\"dismiss\",\"disorder\",\"disparity\",\"dispatch\",\"dispel\",\"dispense\",\"dispense with\",\"disperse\",\"displace\",\"display\",\"dispose of\",\"dispose of\",\"dispute\",\"disrupt\",\"dissent\",\"dissipate\",\"dissolve\",\"distant\",\"distinct\",\"distinguish\",\"distort\",\"distract\",\"distress\",\"distribute\",\"district\",\"disturb\",\"ditch\",\"dive\",\"diverge\",\"diverse\",\"divert\",\"divide\",\"divine\",\"divorce\",\"dizzy\",\"do about\",\"do away with\",\"do up\",\"do without\",\"dock\",\"dodge\",\"dole\",\"doll\",\"domain\",\"dome\",\"domestic\",\"domestic\",\"donate\",\"donkey\",\"doom\",\"doorway\",\"dope\",\"dormitory\",\"dot\",\"double\",\"doubt\",\"dough\",\"doughnut\",\"downtown\",\"downturn\",\"dozen\",\"draft\",\"draft\",\"drag\",\"drag on\",\"drain\",\"drastic\",\"draw (drew, drawn)\",\"draw up\",\"drawback\",\"drawer\",\"dread\",\"dream\",\"dream up\",\"dress\",\"dress up\",\"drift\",\"drill\",\"drills\",\"drip\",\"drive (drove, driven)\",\"drive (drove, driven)\",\"drive out\",\"drizzle\",\"drop\",\"drop\",\"drop by\",\"drop off\",\"drop out of\",\"drought\",\"drown\",\"drug\",\"drum\",\"dry\",\"dry up\",\"dual\",\"dub\",\"dubious\",\"duckling\",\"dude\",\"due\",\"due to\",\"duke\",\"dull\",\"dumb\",\"dumb\",\"dummy\",\"dump\",\"dump\",\"duo\",\"duplicate\",\"durable\",\"duration\",\"during\",\"dusk\",\"dust\",\"duty\",\"dwarf\",\"dwell\",\"dwell on\",\"dwindle\",\"dye\",\"eager\",\"early\",\"earn\",\"earnest\",\"earring\",\"earth\",\"earthquake (quake)\",\"ease\",\"east\",\"Easter\",\"eat out\",\"eat up\",\"echo\",\"eclipse\",\"edge\",\"edible\",\"edit\",\"educate\",\"efficacy\",\"efficient\",\"effort\",\"either\",\"either\",\"either\",\"eject\",\"elaborate\",\"elbow\",\"elder\",\"elect\",\"elevate\",\"elicit\",\"eligible\",\"eliminate\",\"elk\",\"eloquent\",\"elude\",\"embark on\",\"embarrass\",\"embassy\",\"embed\",\"embody\",\"embrace\",\"emerge\",\"emergency\",\"eminent\",\"emit\",\"emperor\",\"emphasis\",\"empire\",\"employ\",\"employ\",\"empower\",\"empty\",\"enable\",\"enact\",\"enchant\",\"enclose\",\"encompass\",\"encounter\",\"encourage\",\"end up\",\"endanger\",\"endeavor (endeavour)\",\"endorse\",\"endow\",\"endure\",\"enforce\",\"engage in\",\"engaged\",\"engender\",\"engine\",\"enhance\",\"enlarge\",\"enlighten\",\"enlist\",\"enormous\",\"enrich\",\"enrol (enroll)\",\"ensemble\",\"ensue\",\"ensure\",\"entail\",\"enter\",\"enterprise\",\"entertain\",\"entice\",\"entire\",\"entitle\",\"entitle\",\"entity\",\"entrepreneur\",\"envelope\",\"environment\",\"envision\",\"envy\",\"equal\",\"equation\",\"equip\",\"equity\",\"eradicate\",\"erase\",\"erect\",\"erode\",\"errand\",\"error\",\"erupt\",\"escape\",\"essence\",\"essential\",\"establish\",\"esteem\",\"estimate\",\"eternal\",\"evade\",\"evaluate\",\"evaporate\",\"eve\",\"even\",\"event\",\"eventual\",\"ever\",\"evidence\",\"evident\",\"evil\",\"evoke\",\"evolve\",\"exact\",\"exaggerate\",\"examine\",\"example\",\"excavate\",\"exceed\",\"excel\",\"excellent\",\"except\",\"excerpt\",\"excess\",\"exchange\",\"excite\",\"exclaim\",\"exclude\",\"excuse\",\"execute\",\"execute\",\"exempt\",\"exercise\",\"exert\",\"exhale\",\"exhaust\",\"exhaust\",\"exhibit\",\"exile\",\"exist\",\"exit\",\"expand\",\"expanse\",\"expect\",\"expel\",\"expenditure\",\"expense\",\"experience\",\"expertise\",\"expire\",\"explain\",\"explicit\",\"explode\",\"exploit\",\"explore\",\"expose\",\"express\",\"exquisite\",\"extend\",\"extent\",\"exterior\",\"external\",\"extinct\",\"extinguish\",\"extort\",\"extra\",\"extract\",\"extreme\",\"exuberant\",\"eyebrow\",\"eyelid\",\"fable\",\"fabric\",\"fabulous\",\"face\",\"face up to\",\"facet\",\"facial\",\"facilitate\",\"facility\",\"facility\",\"faction\",\"factory\",\"faculty\",\"fade\",\"fail\",\"failure\",\"faint\",\"faint\",\"fair\",\"fair\",\"fairly\",\"fairy\",\"faith\",\"fall\",\"fall apart\",\"fall asleep\",\"fall back on\",\"fall behind\",\"fall for\",\"fall for\",\"fall in love with\",\"fall out\",\"fall over\",\"fall through\",\"false\",\"falter\",\"fame\",\"familiar\",\"famine\",\"famous\",\"fan\",\"fancy\",\"fancy\",\"faraway\",\"fare\",\"farewell\",\"farm\",\"fascinate\",\"fashion\",\"fashion\",\"fasten\",\"fat\",\"fate\",\"fatigue\",\"faucet\",\"fault\",\"fault\",\"favor\",\"favor (favour)\",\"fear\",\"feasible\",\"feast\",\"feat\",\"feather\",\"feature\",\"fee\",\"feeble\",\"feed (fed, fed)\",\"feed on\",\"feedback\",\"feel (felt, felt)\",\"feel for\",\"feel like\",\"fellow\",\"fellow\",\"felon\",\"female\",\"feminine\",\"fence\",\"fend for (oneself)\",\"fend off\",\"ferocious\",\"ferry\",\"fertile\",\"fetch\",\"fetus\",\"fever\",\"fibre\",\"fiction\",\"fiddle\",\"fidelity\",\"field\",\"fierce\",\"fight back\",\"fight off\",\"figure\",\"figure out\",\"fill in\",\"fill in on\",\"fill up\",\"film\",\"filth\",\"fin\",\"find out\",\"fine\",\"fine\",\"fine\",\"fingertip\",\"fir\",\"firefighter\",\"fireplace\",\"firework\",\"firm\",\"fisherman\",\"fishing\",\"fist\",\"fit\",\"fit (fit, fit)\",\"fit in with\",\"fix\",\"fixture\",\"flair\",\"flake\",\"flakes\",\"flame\",\"flank\",\"flap\",\"flare\",\"flash\",\"flashlight\",\"flat\",\"flat\",\"flatter\",\"flavor\",\"flaw\",\"flea\",\"flee (fled, fled)\",\"fleet\",\"fleeting\",\"flesh\",\"flex\",\"flick\",\"flick\",\"flick through\",\"flicker\",\"flight\",\"flight\",\"flight attendant\",\"flinch\",\"fling (flung, flung)\",\"flip\",\"float\",\"flock\",\"flood\",\"flood in\",\"floor\",\"floor\",\"flop\",\"flour\",\"flourish\",\"flow\",\"flu\",\"fluctuate\",\"fluent\",\"fluffy\",\"fluid\",\"flurry\",\"flush\",\"flush\",\"flute\",\"flutter\",\"fly\",\"foam\",\"focus\",\"foe\",\"fog\",\"foil\",\"foil\",\"fold\",\"folder\",\"foliage\",\"folk\",\"follow\",\"folly\",\"fond of\",\"fool\",\"fool around\",\"footage\",\"footing\",\"footprint\",\"for real\",\"for sure\",\"for the sake of\",\"forbid (forbade, forbidden)\",\"forcible\",\"forecast\",\"forehead\",\"foreign\",\"foreman\",\"foremost\",\"foresee\",\"forge\",\"forge\",\"forgive (forgave, forgiven)\",\"fork\",\"former\",\"former\",\"formidable\",\"forth\",\"forthcoming\",\"fortify\",\"fortunate\",\"fortune\",\"fortune\",\"fossil\",\"foster\",\"foster\",\"foul\",\"found\",\"foundation\",\"fountain\",\"foyer\",\"fraction\",\"fracture\",\"fragile\",\"fragrant\",\"frail\",\"frame\",\"framework\",\"frank\",\"frantic\",\"fraud\",\"fray\",\"frayed\",\"freak\",\"freak out\",\"free\",\"free up\",\"freeway\",\"freeze (froze, frozen)\",\"freight\",\"frenzy\",\"frequent\",\"freshen up\",\"fret\",\"friction\",\"friendly\",\"fright\",\"frighten off\",\"fringe\",\"frog\",\"front\",\"frontier\",\"frost\",\"frown\",\"fruitless\",\"frustrate\",\"fry\",\"fuck with\",\"fuel\",\"fugitive\",\"fulfil\",\"fumble\",\"fume\",\"fund\",\"funeral\",\"fungus\",\"funnel\",\"fur\",\"furnace\",\"furnish\",\"furnish\",\"furniture\",\"further\",\"fury\",\"fuse\",\"fuss\",\"futile\",\"future\",\"fuzzy\",\"gain\",\"gait\",\"gala\",\"gamble\",\"gang\",\"gap\",\"garbage\",\"garden\",\"garlic\",\"garment\",\"garnish\",\"gas\",\"gasp\",\"gates\",\"gather\",\"gauge\",\"gaze\",\"gear\",\"geared to\",\"gem\",\"gender\",\"gene\",\"general\",\"generation\",\"generous\",\"gentle\",\"genuine\",\"germ\",\"gesture\",\"get\",\"get about\",\"get ahead\",\"get ahead of\",\"get along\",\"get at\",\"get away with\",\"get back at\",\"get by\",\"get down\",\"get in\",\"get lost\",\"get off\",\"get off with\",\"get on\",\"get out of\",\"get over\",\"get rid of\",\"get stuck\",\"get through\",\"get together\",\"get used to\",\"ghost\",\"giant\",\"gift\",\"giggle\",\"give a ride\",\"give away\",\"give away\",\"give birth to\",\"give off\",\"give out\",\"give up\",\"give up\",\"glacier\",\"glamour\",\"glance\",\"glare\",\"glass\",\"glasses\",\"glaze\",\"gleam\",\"glide\",\"glimpse\",\"glint\",\"glitter\",\"globe\",\"gloom\",\"glory\",\"gloss\",\"glove\",\"glow\",\"glue\",\"gnaw on\",\"go about\",\"go against\",\"go ahead\",\"go along\",\"go bad\",\"go down\",\"go for\",\"go for\",\"go into\",\"go off\",\"go off\",\"go on\",\"go on\",\"go out\",\"go over\",\"go through\",\"go together\",\"go under\",\"goal\",\"goat\",\"goddess\",\"goods\",\"goof\",\"gorgeous\",\"gospel\",\"gossip\",\"govern\",\"gown\",\"grab\",\"grace\",\"grade\",\"grade\",\"gradual\",\"graduate\",\"grain\",\"grand\",\"grant\",\"grape\",\"graph\",\"grapple\",\"grasp\",\"grate\",\"grateful\",\"gratify\",\"gratitude\",\"grave\",\"grave\",\"gravel\",\"gravy\",\"graze\",\"grease\",\"greed\",\"greenhouse\",\"greet\",\"grid\",\"grief\",\"grievance\",\"grieve\",\"grim\",\"grin\",\"grind (ground, groud)\",\"grip\",\"grit\",\"grit\",\"groan\",\"grocery\",\"groom\",\"groove\",\"grope\",\"gross\",\"gross\",\"grove\",\"grow (grew, grown)\",\"grow (grew, grown)\",\"grow up\",\"growl\",\"grudge\",\"grumble\",\"grunt\",\"guard\",\"guess\",\"guest\",\"guide\",\"guideline\",\"guilt\",\"guise\",\"gulf\",\"gulf\",\"gulp\",\"gum\",\"gun\",\"gust\",\"gut\",\"gutter\",\"gym\",\"Gypsy\",\"habit\",\"habitat\",\"hack\",\"hail\",\"hail\",\"hail\",\"haircut\",\"hall\",\"hallmark\",\"halt\",\"halve\",\"ham\",\"hammer\",\"hamper\",\"hand down\",\"hand in\",\"hand over\",\"handbook\",\"handcuffs\",\"handful\",\"handicap\",\"handkerchief\",\"handle\",\"handle\",\"handsome\",\"handwriting\",\"handy\",\"hang (hung, hung)\",\"hang around\",\"hang out\",\"hangover\",\"happen\",\"harass\",\"harbor (harbour)\",\"hardly\",\"hardware\",\"hardy\",\"harm\",\"harness\",\"harp\",\"harsh\",\"harvest\",\"hassle\",\"haste\",\"hat\",\"hatch\",\"hatred\",\"haul\",\"haunt\",\"hawk\",\"hay\",\"hazard\",\"haze\",\"head for\",\"head off\",\"headlight\",\"headline\",\"headquarters\",\"heal\",\"health\",\"healthcare\",\"heap\",\"heat\",\"heat up\",\"heave\",\"heaven\",\"hebrew\",\"hectic\",\"hedge\",\"heed\",\"heel\",\"hefty\",\"height\",\"heir\",\"helicopter\",\"helm\",\"helmet (helm)\",\"help out\",\"helpful\",\"helpless\",\"hemisphere\",\"hen\",\"hence\",\"herald\",\"herb\",\"herd\",\"heritage\",\"hero\",\"hesitate\",\"hide (hid, hidden)\",\"hideous\",\"hierarchy\",\"high-end\",\"highlight\",\"highway\",\"hijack\",\"hike\",\"hilarious\",\"hill\",\"hinder\",\"hinge\",\"hint\",\"hip\",\"hire\",\"hiss\",\"hit (hit, hit)\",\"hit (hit, hit)\",\"hit back\",\"hit on\",\"hitch\",\"hoard\",\"hobble\",\"hog\",\"hoist\",\"hold back\",\"hold on\",\"hold on\",\"hold up\",\"hole\",\"holler\",\"hollow\",\"holy\",\"homeland\",\"homicide\",\"honest\",\"honey\",\"honor (honour)\",\"hood\",\"hood\",\"hoof\",\"hook\",\"hook up\",\"hook up\",\"hoop\",\"hop\",\"hopeful\",\"horizon\",\"horn\",\"horrible\",\"horrify\",\"horseback\",\"hose\",\"hospitality\",\"host\",\"host\",\"hostage\",\"hostile\",\"hound\",\"household\",\"housewife\",\"hover\",\"however\",\"howl\",\"huddle\",\"hue\",\"hug\",\"huge\",\"hull\",\"hum\",\"human\",\"humble\",\"humid\",\"humiliate\",\"hump\",\"hunch\",\"hunch\",\"hunger\",\"hunk\",\"hurdle\",\"hurl\",\"hurricane\",\"hurry\",\"hurt (hurt, hurt)\",\"hush\",\"hustle\",\"hustle\",\"hut\",\"hydrogen\",\"hypocrite\",\"ID\",\"idle\",\"ignite\",\"ignorant\",\"ill\",\"ill\",\"illicit\",\"illuminate\",\"image\",\"imagine\",\"immediate\",\"immense\",\"immerse\",\"imminent\",\"impact\",\"impair\",\"impede\",\"impending\",\"imperative\",\"implement\",\"implicate\",\"implicit\",\"imply\",\"importance\",\"impose\",\"imposing\",\"impress\",\"imprint\",\"improve\",\"in a row\",\"in advance\",\"in charge\",\"in spite of\",\"incentive\",\"inch\",\"incidence\",\"incline\",\"include\",\"income\",\"incoming\",\"incorporate\",\"increase\",\"incredible\",\"incumbent\",\"incur\",\"indeed\",\"indicate\",\"indifferent\",\"indigenous\",\"induce\",\"indulge\",\"industry\",\"inevitable\",\"inexplicable\",\"infamous\",\"infant\",\"infantry\",\"infect\",\"infer\",\"inferior\",\"infinite\",\"inflame\",\"inflate\",\"inflict\",\"influence\",\"infuse\",\"ingenious\",\"inhabit\",\"inhale\",\"inherent\",\"inherit\",\"inhibit\",\"initial\",\"inject\",\"injure\",\"ink\",\"inland\",\"inmate\",\"inn\",\"inner\",\"innocent\",\"input\",\"inquire\",\"insect\",\"insert\",\"inside\",\"inside out\",\"insight\",\"insist\",\"inspect\",\"inspire\",\"install\",\"instance\",\"instant\",\"instead\",\"insulate\",\"insult\",\"insure\",\"insurgent\",\"intact\",\"intake\",\"integral\",\"integrity\",\"integrity\",\"intelligence\",\"intelligent\",\"intelligible\",\"intend\",\"intended\",\"interact\",\"intercept\",\"intercourse\",\"interfere\",\"interim\",\"interior\",\"intermediate\",\"intern\",\"internal\",\"interpret\",\"interpreter\",\"interrogate\",\"interrupt\",\"intersect\",\"intervene\",\"intestine\",\"intimate\",\"intimidate\",\"intricate\",\"intrinsic\",\"introduce\",\"introduce\",\"intrude on\",\"invade\",\"invent\",\"inventory\",\"invert\",\"investigate\",\"invite\",\"invoke\",\"involve\",\"involve\",\"inward\",\"iron\",\"iron\",\"irritate\",\"island\",\"issue\",\"issue\",\"itch\",\"item\",\"ivory\",\"ivy\",\"jab\",\"jacket\",\"jail\",\"janitor\",\"jar\",\"jaw\",\"jealous\",\"jelly\",\"jeopardy\",\"jerk\",\"jerk\",\"jet\",\"jet\",\"Jew\",\"jewel\",\"jingle\",\"jog\",\"join\",\"joint\",\"joint\",\"jolly\",\"jolt\",\"journalism\",\"journey\",\"joy\",\"judge\",\"judicial\",\"jug\",\"jumble\",\"jump at\",\"jump in\",\"jumper\",\"junction\",\"junior\",\"junk\",\"junkie\",\"jury\",\"just\",\"justice\",\"justify\",\"jut\",\"keen\",\"keep away\",\"keep off\",\"keep on\",\"keep out of\",\"keep up\",\"kernel\",\"kettle\",\"kick\",\"kick around\",\"kick back\",\"kid\",\"kid\",\"kidnap\",\"kidney\",\"kin (pl:kin)\",\"kind\",\"kind\",\"kindergarten\",\"kit\",\"kite\",\"kitten\",\"knack\",\"knee\",\"kneel\",\"knight\",\"knit\",\"knob\",\"knock\",\"knock down\",\"knock out\",\"knock together\",\"knot\",\"knowledge\",\"label\",\"labour\",\"lace\",\"lack\",\"lad\",\"ladder\",\"laden\",\"lag\",\"lamb\",\"lame\",\"lament\",\"land\",\"landlord\",\"landmark\",\"landscape\",\"lane\",\"lantern\",\"lap\",\"lapse\",\"lapse\",\"laptop\",\"large\",\"lash (eyelash)\",\"lash out\",\"last\",\"latch\",\"late\",\"late\",\"lateral\",\"latter\",\"laugh\",\"laughter\",\"launch\",\"laundry\",\"lavish\",\"law\",\"lawn\",\"lawsuit\",\"lay (laid, laid)\",\"lay down\",\"lay off\",\"lay out\",\"layer\",\"layout\",\"lazy\",\"lead\",\"lead up to\",\"leaf (pl: leaves)\",\"leak\",\"lean\",\"lean against\",\"lean over\",\"leap\",\"lease\",\"leash\",\"leather\",\"leave (left, left)\",\"leave behind\",\"ledge\",\"leek\",\"leftover\",\"leg\",\"legacy\",\"legal\",\"legislation\",\"legitimate\",\"leisure\",\"lend (lent, lent)\",\"length\",\"lens\",\"lessen\",\"lest\",\"let in on\",\"let off\",\"let smb down\",\"let smb in\",\"let up\",\"letter\",\"lettuce\",\"level\",\"lever\",\"liable\",\"liaison\",\"liberate\",\"liberty\",\"library\",\"licence (license)\",\"lick\",\"lid\",\"lie\",\"lie (lay, lain)\",\"lifelong\",\"lift\",\"light (lit, lit)\",\"light up\",\"lightning\",\"like\",\"like that\",\"likely\",\"likewise\",\"limb\",\"limit\",\"limp\",\"line\",\"line\",\"line up\",\"lineage\",\"linen\",\"linen\",\"lineup\",\"linger\",\"link\",\"lip\",\"lipstick\",\"liquid\",\"list\",\"listen in on\",\"literal\",\"literary\",\"literate\",\"litter\",\"live up to\",\"livelihood\",\"liven up\",\"liver\",\"livestock\",\"lizard\",\"load\",\"loaf\",\"loan\",\"loathe\",\"lobby\",\"lobster\",\"local\",\"locate\",\"lock\",\"lock up\",\"locker\",\"locus\",\"lodge\",\"lodge\",\"loft\",\"log\",\"lone\",\"long ago\",\"long for\",\"longevity\",\"look\",\"look after\",\"look around\",\"look at\",\"look for\",\"look forward\",\"look into\",\"look out\",\"look smb up\",\"look up\",\"look up to\",\"loom\",\"loop\",\"loose\",\"loot\",\"lord\",\"loss\",\"lot\",\"loud\",\"lounge\",\"lounge\",\"lousy\",\"lovely\",\"lower\",\"loyal\",\"lucrative\",\"ludicrous\",\"luggage\",\"lumber\",\"lump\",\"lunar\",\"luncheon\",\"lung\",\"lurch\",\"lure\",\"lurk\",\"lush\",\"lust\",\"luxury\",\"lyrics\",\"magazine\",\"magician\",\"magnificent\",\"magnify\",\"magnitude\",\"maid\",\"maiden\",\"mainland\",\"maintain\",\"majesty\",\"major\",\"make fun of\",\"make into\",\"make of\",\"make out\",\"make out\",\"make sure\",\"make up\",\"make up\",\"make up for\",\"makeup\",\"male\",\"mall\",\"mammal\",\"mammoth\",\"manage\",\"mandatory\",\"manifest\",\"mankind\",\"mansion\",\"mantle\",\"manual\",\"manual\",\"manufacture\",\"manure\",\"map out\",\"maple\",\"marble\",\"margin\",\"margin\",\"marine\",\"marital\",\"maritime\",\"mark\",\"mark down\",\"marry\",\"marsh\",\"martial\",\"martyr\",\"marvel\",\"mash\",\"massacre\",\"master\",\"master\",\"masterpiece\",\"mat\",\"match\",\"match\",\"mate\",\"maternal\",\"matter\",\"matter\",\"matter\",\"mature\",\"may\",\"mayor\",\"maze\",\"meadow\",\"meager\",\"meal\",\"mean\",\"mean (meant, meant)\",\"mean (meant, meant)\",\"mean (meant, meant)\",\"means\",\"meantime\",\"meanwhile\",\"measure\",\"measure\",\"mediate\",\"medicine\",\"medieval\",\"mediocre\",\"meditate\",\"medium\",\"meet (met, met)\",\"melon\",\"melt\",\"member\",\"memoirs\",\"memories\",\"memory\",\"menace\",\"mend\",\"mental\",\"mention\",\"mentor\",\"merchandise\",\"merchant\",\"mercury\",\"mercy\",\"mere\",\"merge\",\"merit\",\"merry\",\"mesh\",\"mess\",\"mess up\",\"mess with\",\"metropolitan\",\"mid\",\"middle\",\"midnight\",\"midst\",\"midwife\",\"might\",\"mild\",\"mileage\",\"military\",\"mill\",\"millennium\",\"mimic\",\"mince\",\"mind\",\"mindful\",\"mine\",\"mine\",\"mingle\",\"minor\",\"minor\",\"mint\",\"miracle\",\"mischief\",\"miserable\",\"misery\",\"misery\",\"miss\",\"miss\",\"missile\",\"missing\",\"mist\",\"mistake\",\"mistake for\",\"mistress\",\"mistress\",\"mitigate\",\"mix up\",\"mixture\",\"moan\",\"mob\",\"mock\",\"mode\",\"moderate\",\"modest\",\"modify\",\"moist\",\"mold (mould)\",\"mold (mould)\",\"mole\",\"mole\",\"molest\",\"monastery\",\"monetary\",\"monk\",\"mood\",\"moose\",\"mop\",\"moreover\",\"moron\",\"mortal\",\"mortgage\",\"mosque\",\"mosquito\",\"moss\",\"mostly\",\"moth\",\"motion\",\"motto\",\"mound\",\"mount\",\"mount\",\"mount\",\"mountain\",\"mourn\",\"move\",\"move out\",\"move over\",\"movie\",\"mow\",\"muck\",\"mud\",\"mug\",\"multiple\",\"multiply\",\"multitude\",\"mumble\",\"mural\",\"murder\",\"murky\",\"murmur\",\"muscle\",\"mushroom\",\"Muslim\",\"mustache (moustache)\",\"mustard\",\"muster\",\"mute\",\"mutter\",\"mutual\",\"muzzle\",\"mystery\",\"nail\",\"nail\",\"naked\",\"name after\",\"nanny\",\"nap\",\"napkin\",\"narrate\",\"narrow\",\"nasty\",\"native\",\"native\",\"natural\",\"naughty\",\"nausea\",\"navigate\",\"navy\",\"neat\",\"necessary\",\"neck\",\"necklace\",\"needle\",\"neglect\",\"negligent\",\"negotiate\",\"neighbour\",\"neither\",\"neither\",\"neither...nor\",\"nephew\",\"nerd\",\"nerve\",\"nest\",\"net\",\"network\",\"never\",\"nevertheless\",\"newcomer\",\"newspaper\",\"nibble on\",\"niche\",\"niece\",\"nightmare\",\"nipple\",\"nitrogen\",\"no matter\",\"noble\",\"nod\",\"noise\",\"nominate\",\"none\",\"nonetheless\",\"noodles\",\"noon\",\"north\",\"nose around\",\"nostril\",\"notch\",\"note\",\"notice\",\"notify\",\"notion\",\"notorious\",\"notwithstanding\",\"noun\",\"nourish\",\"novel\",\"novelty\",\"nuclear\",\"nude\",\"nudge\",\"nuisance\",\"numb\",\"numeric (numerical)\",\"numerous\",\"nun\",\"nurse\",\"nurture\",\"nut\",\"nutrient\",\"nutrition\",\"nuts\",\"oak\",\"oath\",\"oats\",\"obedience\",\"obese\",\"obey\",\"object\",\"objective\",\"oblige\",\"oblique\",\"obscene\",\"obscure\",\"observe\",\"obsess\",\"obsolete\",\"obstacle\",\"obstruct\",\"obtain\",\"obvious\",\"occasion\",\"occupation\",\"occupy\",\"occur\",\"occur to\",\"odd\",\"odds\",\"odor (odour)\",\"offence\",\"offence (offense)\",\"offend\",\"offer\",\"officer\",\"offset\",\"offspring\",\"oil\",\"oil\",\"ominous\",\"omit\",\"on account of\",\"on behalf of\",\"on foot\",\"on purpose\",\"on the contrary\",\"once\",\"ongoing\",\"onion\",\"onset\",\"onward (onwards)\",\"opaque\",\"opening\",\"operate\",\"opinion\",\"opportunity\",\"oppose\",\"opposite\",\"oppress\",\"opt for\",\"option\",\"oral\",\"orchard\",\"order\",\"order\",\"order\",\"ordinary\",\"oriental\",\"origin\",\"original\",\"orphan\",\"ostensibly\",\"otherwise\",\"ought\",\"ounce\",\"out loud\",\"outcome\",\"outdated\",\"outdoor (outdoors)\",\"outer\",\"outfit\",\"outgoing\",\"outing\",\"outlaw\",\"outlet\",\"outline\",\"outlook\",\"outnumber\",\"output\",\"outrage\",\"outright\",\"outset\",\"outskirts\",\"outstanding\",\"outstanding\",\"outweigh\",\"oven\",\"over\",\"overall\",\"overcome\",\"overflow\",\"overhead\",\"overhear\",\"overlap\",\"overlook\",\"overnight\",\"override\",\"overseas\",\"oversee\",\"oversight\",\"overt\",\"overtake\",\"overthrow\",\"overtime\",\"overturn\",\"overview\",\"overwhelm\",\"owe\",\"owe\",\"owl\",\"own\",\"oxygen\",\"oyster\",\"pace\",\"pack\",\"pack\",\"pad\",\"pad\",\"pad\",\"paddle\",\"pagan\",\"pain\",\"pair\",\"pal\",\"palace\",\"pale\",\"palm\",\"pan\",\"pancake\",\"pant\",\"pants\",\"paper\",\"paperwork\",\"paragraph\",\"parcel\",\"pardon\",\"parlor\",\"parrot\",\"parsley\",\"part\",\"part\",\"participate\",\"particle\",\"particular\",\"partisan\",\"partition\",\"part-time\",\"pass\",\"pass away\",\"pass by\",\"pass off as\",\"pass out\",\"pass smth on\",\"pass up\",\"passage\",\"passenger\",\"passion\",\"past\",\"past\",\"pastime\",\"pastry\",\"pasture\",\"pat\",\"patch\",\"path\",\"pathetic\",\"patient\",\"patio\",\"patrol\",\"patron\",\"pattern\",\"pause\",\"pave\",\"paw\",\"pay back\",\"pay off\",\"pay out\",\"payment\",\"pea\",\"peaceful\",\"peacekeeper\",\"peach\",\"peanut\",\"pear\",\"pearl\",\"peasant\",\"pebble\",\"peck\",\"peculiar\",\"peddle\",\"pedestrian\",\"pee\",\"peek\",\"peel\",\"peer\",\"peer\",\"peg\",\"penalty\",\"pending\",\"penetrate\",\"peninsula\",\"pepper\",\"per\",\"perceive\",\"perception\",\"perennial\",\"perfect\",\"perform\",\"perhaps\",\"peril\",\"period\",\"perish\",\"perk\",\"perk up\",\"permanent\",\"permit\",\"perpetual\",\"perplex\",\"persecute\",\"persist\",\"persist\",\"personnel\",\"persuade\",\"pervasive\",\"pervert\",\"pest\",\"pet\",\"petal\",\"petroleum\",\"petty\",\"phony\",\"physician\",\"pick\",\"pick on\",\"pick out\",\"pick up\",\"pick up\",\"pickle\",\"pie\",\"piece\",\"pier\",\"pierce\",\"pigeon\",\"pile\",\"pile up\",\"pill\",\"pillar\",\"pillow\",\"pin\",\"pinch\",\"pine\",\"pineapple\",\"pipe\",\"pipe\",\"piss\",\"piss about\",\"piss off\",\"pit\",\"pitch\",\"pitch\",\"pity\",\"pivot\",\"placement\",\"placid\",\"plague\",\"plain\",\"plain\",\"plain\",\"plane\",\"plank\",\"plant\",\"plant\",\"plaque\",\"plaster\",\"plate\",\"plausible\",\"playground\",\"plea\",\"please\",\"pleasure\",\"pledge\",\"pledge\",\"plenty\",\"plight\",\"plot\",\"plot\",\"plow\",\"pluck\",\"plug\",\"plug in\",\"plum\",\"plumbing\",\"plump\",\"plunge\",\"plural\",\"pocket\",\"point\",\"point\",\"point\",\"point\",\"point\",\"point out\",\"poise\",\"poison\",\"poke\",\"poke out\",\"pole\",\"pole\",\"policy\",\"polish\",\"polite\",\"poll\",\"pollute\",\"pond\",\"ponder\",\"pool\",\"poor\",\"pope\",\"population\",\"porcelain\",\"porch\",\"pork\",\"portable\",\"porter\",\"portray\",\"possess\",\"possible\",\"post\",\"postpone\",\"posture\",\"pot\",\"potato\",\"potent\",\"pouch\",\"poultry\",\"pound\",\"pound\",\"pour\",\"pour in (into)\",\"poverty\",\"powder\",\"powerful\",\"practice\",\"prairie\",\"praise\",\"pray\",\"preach\",\"precarious\",\"precaution\",\"precede\",\"precious\",\"precise\",\"preclude\",\"predator\",\"predecessor\",\"predict\",\"predominant\",\"prefer\",\"pregnant\",\"prejudice\",\"preliminary\",\"premature\",\"premise\",\"premises\",\"preoccupy\",\"prepare\",\"prescribe\",\"present\",\"present\",\"preserve\",\"preside\",\"press\",\"presume\",\"pretend\",\"pretext\",\"pretty\",\"pretty\",\"prevail\",\"prevent\",\"prevent smb from\",\"previous\",\"prey\",\"prick\",\"pride\",\"priest\",\"primary\",\"prime\",\"primitive\",\"principal\",\"prior\",\"prison\",\"pristine\",\"privacy\",\"private\",\"probable\",\"probe\",\"probe\",\"procedure\",\"proceed\",\"process\",\"proclaim\",\"procure\",\"prod\",\"produce\",\"proficient\",\"profit\",\"profound\",\"prohibit\",\"prolong\",\"prominent\",\"promise\",\"promote\",\"prompt\",\"prompt\",\"prone\",\"pronounce\",\"proof\",\"prop\",\"propagate\",\"propel\",\"proper\",\"property\",\"prophet\",\"proponent\",\"propose\",\"prosecute\",\"prosecute\",\"prospect\",\"prosper\",\"protect\",\"proud\",\"prove\",\"proverb\",\"provide\",\"provided\",\"provisional\",\"proximity\",\"prudent\",\"pry\",\"publish\",\"puddle\",\"puff\",\"pull back\",\"pull off\",\"pull over\",\"pull through\",\"pump\",\"pumpkin\",\"punch\",\"punish\",\"pupil\",\"puppet\",\"puppy\",\"purchase\",\"pure\",\"purge\",\"purple\",\"purpose\",\"purse\",\"pursue\",\"pursuit\",\"put aside\",\"put away\",\"put in\",\"put off\",\"put off\",\"put on\",\"put on\",\"put out\",\"put out\",\"put smb down\",\"put smth down to\",\"put through\",\"put together\",\"put up\",\"put up with\",\"puzzle\",\"quaint\",\"quality\",\"quantity\",\"quarrel\",\"quarry\",\"quarter\",\"queer\",\"query\",\"quest\",\"question\",\"questionnaire\",\"queue\",\"quiet\",\"quilt\",\"quit (quit, quit)\",\"quite\",\"quiz\",\"quote\",\"rabbit\",\"race\",\"race\",\"rack\",\"radiate\",\"raft\",\"rag\",\"rage\",\"raid\",\"rail\",\"railway\",\"rainbow\",\"raise\",\"raise\",\"raisin\",\"rake\",\"rally\",\"rally\",\"ram\",\"ramble\",\"ramp\",\"random\",\"range\",\"rank\",\"ransom\",\"rape\",\"rapid\",\"rare\",\"rash\",\"raspberry\",\"rate\",\"rate\",\"rather\",\"ratio\",\"rationale\",\"rattle\",\"ravage\",\"raw\",\"ray\",\"razor\",\"reach\",\"reach out\",\"read out\",\"read up on\",\"real estate\",\"realize\",\"realm\",\"reap\",\"rear\",\"reason\",\"reason\",\"rebel\",\"rebound\",\"recall\",\"recede\",\"receipt\",\"receipt\",\"receive\",\"recent\",\"reception\",\"recess\",\"recess\",\"recipe\",\"recipient\",\"reciprocal\",\"recite\",\"reckless\",\"reckon\",\"recognize\",\"recollection\",\"reconcile\",\"record\",\"recount\",\"recover\",\"recreation\",\"recruit\",\"rectangle\",\"recur\",\"recycle\",\"redeem\",\"reduce\",\"redundant\",\"reed\",\"reel\",\"refer\",\"refine\",\"reflect\",\"refrain\",\"refresh\",\"refrigerator\",\"refuge\",\"refugee\",\"refund\",\"refuse\",\"refute\",\"regain\",\"regard\",\"regard\",\"regiment\",\"register\",\"regret\",\"regular\",\"rehearse\",\"reign\",\"rein\",\"reinforce\",\"reject\",\"rejoice\",\"relate\",\"relative\",\"relative\",\"relay\",\"release\",\"relentless\",\"relevant\",\"relief\",\"relieve\",\"relish\",\"reluctant\",\"rely\",\"remain\",\"remainder\",\"remains\",\"remark\",\"remedy\",\"remind\",\"reminiscent\",\"remnant\",\"remorse\",\"remote\",\"remove\",\"render\",\"render\",\"renew\",\"renovate\",\"renown\",\"rent\",\"repair\",\"repay\",\"repeal\",\"repel\",\"replace\",\"replicate\",\"reply\",\"report\",\"represent\",\"repress\",\"reproduce\",\"request\",\"require\",\"rescue\",\"research\",\"resemble\",\"resent\",\"reserve\",\"reserve\",\"reserved\",\"reside\",\"residue\",\"resign\",\"resilient\",\"resist\",\"resolute\",\"resolve\",\"resolve\",\"resort\",\"resort to\",\"respective\",\"respond\",\"response\",\"responsible\",\"rest\",\"rest\",\"rest\",\"restore\",\"restrain\",\"restrict\",\"result in\",\"resume\",\"resurrect\",\"retail\",\"retain\",\"retaliate\",\"retarded\",\"retention\",\"retire\",\"retract\",\"retreat\",\"retrieve\",\"retrospect\",\"return\",\"reveal\",\"revenge\",\"revenue\",\"revere\",\"reverse\",\"review\",\"revise\",\"revive\",\"revolt\",\"revolve\",\"reward\",\"rhyme\",\"rib\",\"ribbon\",\"rice\",\"rich\",\"rid\",\"riddle\",\"ride\",\"ridge\",\"ridicule\",\"ridiculous\",\"rifle\",\"rift\",\"rig\",\"right away\",\"righteous\",\"rigid\",\"rigorous\",\"rim\",\"ring (rang, rung)\",\"rinse\",\"riot\",\"rip\",\"rip off\",\"ripe\",\"ripple\",\"rise (rose, risen)\",\"rite\",\"rival\",\"rivet\",\"roadside\",\"roadway\",\"roam\",\"roar\",\"roast\",\"rob\",\"robe\",\"robust\",\"rock\",\"rock\",\"rod\",\"rodent\",\"rogue\",\"roll\",\"roll\",\"roll up\",\"roof\",\"room\",\"root\",\"root out\",\"rope\",\"rope in (into)\",\"rot\",\"rotate\",\"rotate\",\"rotten\",\"rough\",\"rough up\",\"round\",\"round down\",\"rouse\",\"route\",\"row\",\"row\",\"royal\",\"rub\",\"rubber\",\"rubbish\",\"rubble\",\"rude\",\"ruffle\",\"rug\",\"rugged\",\"ruin\",\"rule\",\"rule\",\"ruler\",\"rumble\",\"rumor (rumour)\",\"run\",\"run after\",\"run away\",\"run counter\",\"run into\",\"run out of\",\"run over\",\"runaway\",\"runway\",\"rupture\",\"rural\",\"rush\",\"rust\",\"rustic\",\"rustle\",\"rut\",\"ruthless\",\"sack\",\"sacred\",\"sacrifice\",\"saddle\",\"safe\",\"sail\",\"saint\",\"salary\",\"sale\",\"salesperson\",\"salient\",\"saliva\",\"salmon\",\"salt\",\"salvage\",\"salvation\",\"sample\",\"sanctuary\",\"sand\",\"sane\",\"satellite\",\"satisfy\",\"saturated\",\"saucepan\",\"saucer\",\"sausage\",\"savage\",\"save up\",\"savings\",\"savior\",\"savor\",\"scaffold\",\"scale\",\"scale\",\"scale\",\"scales\",\"scant\",\"scar\",\"scarce\",\"scare\",\"scarf\",\"scarlet\",\"scatter\",\"scent\",\"schedule\",\"scheme\",\"scholar\",\"scholarship (money)\",\"science\",\"scissors\",\"scold\",\"scoop\",\"scope\",\"score\",\"scorn\",\"scour\",\"scout\",\"scowl\",\"scramble\",\"scramble\",\"scrambled eggs\",\"scrap\",\"scrape\",\"scrape through\",\"scrape together\",\"scratch\",\"scream\",\"screech\",\"screenplay\",\"screw\",\"screw\",\"screw up\",\"scribble\",\"scrub\",\"scrutiny\",\"scurry\",\"seal\",\"seal\",\"seam\",\"search\",\"seasoning\",\"seat\",\"secular\",\"secure\",\"sediment\",\"seduce\",\"see off\",\"see through\",\"see to\",\"seed\",\"seek (sought, sought)\",\"seem\",\"seep\",\"segregate\",\"seize\",\"seldom\",\"select\",\"selfish\",\"sell out of\",\"send (sent, sent)\",\"send out\",\"senior\",\"sensation\",\"sense\",\"sense\",\"sensible\",\"sensitive\",\"sentence\",\"sentence\",\"sentiment\",\"separate\",\"sequence\",\"serene\",\"series\",\"sermon\",\"serve\",\"serve\",\"serve\",\"set\",\"set (set, set)\",\"set about\",\"set down\",\"set out\",\"set out for\",\"set smb back\",\"set smb back\",\"set smb up\",\"set smb up with\",\"set smb up with\",\"settle\",\"settle\",\"settle for\",\"settle in\",\"settle on\",\"sever\",\"several\",\"severe\",\"sew\",\"sewage\",\"sex\",\"shabby\",\"shack\",\"shade\",\"shade\",\"shadow\",\"shaft\",\"shaft\",\"shake (shook, shaken)\",\"shake (shook, shaken)\",\"shake off\",\"shake up\",\"shallow\",\"shame\",\"shape\",\"share\",\"share\",\"shareholder\",\"shark\",\"sharp\",\"shatter\",\"shave\",\"shed\",\"shed (shed, shed)\",\"sheep (pl:sheep)\",\"sheer\",\"sheer\",\"sheet\",\"shelf (pl: shelves)\",\"shell\",\"shelter\",\"shepherd\",\"shield\",\"shift\",\"shift\",\"shimmer\",\"shine (shone, shined)\",\"ship\",\"shirt\",\"shiver\",\"shoe\",\"shoot (shot, shot)\",\"shoot (shot, shot)\",\"shore\",\"shortage\",\"shoulder\",\"shout\",\"shove\",\"shovel\",\"show around\",\"show off\",\"show up\",\"showcase\",\"shower\",\"shred\",\"shrewd\",\"shriek\",\"shrimp\",\"shrine\",\"shrink (shrank, shrunk)\",\"shroud\",\"shrub\",\"shrug\",\"shudder\",\"shuffle\",\"shun\",\"shut (shut, shut)\",\"shut out\",\"shut up\",\"shy\",\"siblings\",\"sick\",\"sideline\",\"sidewalk\",\"sideways\",\"siege\",\"sift\",\"sigh\",\"sight\",\"sight\",\"sign\",\"sign\",\"sign up\",\"signature\",\"significant\",\"signify\",\"silent\",\"silk\",\"sill\",\"silly\",\"similar\",\"simmer\",\"simple\",\"simulate\",\"simultaneous\",\"sin\",\"since\",\"since\",\"sincere\",\"single\",\"singular\",\"sinister\",\"sink\",\"sink (sank, sunk)\",\"sip\",\"sit around\",\"sit back\",\"sit out\",\"site\",\"situate\",\"size up\",\"skate\",\"sketch\",\"ski\",\"skid\",\"skill\",\"skillet\",\"skim\",\"skin\",\"skinny\",\"skip\",\"skirt\",\"skull\",\"slab\",\"slack\",\"slam\",\"slant\",\"slap\",\"slash\",\"slate\",\"slaughter\",\"slave\",\"slay (slew, slain)\",\"sleek\",\"sleep around\",\"sleeve\",\"slender\",\"slice\",\"slick\",\"slide (slid, slid)\",\"slight\",\"slim\",\"slime\",\"slip\",\"slipper\",\"slippery\",\"slit\",\"slope\",\"sloppy\",\"slot\",\"slow down\",\"sludge\",\"slum\",\"slump\",\"slut\",\"sly\",\"smack\",\"smart\",\"smash\",\"smear\",\"smell\",\"smirk\",\"smooth\",\"smother\",\"smudge\",\"smuggle\",\"snack\",\"snag\",\"snail\",\"snake\",\"snap\",\"snapshot\",\"snarl\",\"snatch\",\"sneak\",\"sneakers\",\"sneer\",\"sneeze\",\"sniff\",\"snore\",\"snort\",\"snowball\",\"snug\",\"so far\",\"soak\",\"soap\",\"soar\",\"sob\",\"sober\",\"sober up\",\"so-called\",\"soccer\",\"society\",\"sock\",\"socket\",\"soften\",\"software\",\"soil\",\"solar\",\"sole\",\"sole\",\"solemn\",\"solid\",\"solid\",\"solitary\",\"solitude\",\"solution\",\"solution\",\"solve\",\"someday\",\"somewhat\",\"soon\",\"soot\",\"soothe\",\"sophisticated\",\"sore\",\"sorrow\",\"sound\",\"sour\",\"source\",\"south\",\"sovereign\",\"sow (sowed, sown)\",\"space\",\"space\",\"spade\",\"span\",\"spare\",\"spare\",\"spare\",\"spark\",\"sparkle\",\"sparse\",\"spawn\",\"speak out\",\"speak up\",\"spear\",\"special\",\"species\",\"specific\",\"specify\",\"specimen\",\"speck\",\"spectacle\",\"spectator\",\"speculate\",\"speed up\",\"spell\",\"spell\",\"spell out\",\"spend (spent, spent)\",\"spice\",\"spike\",\"spill\",\"spin\",\"spine\",\"spirit\",\"spit (spat, spat)\",\"splash\",\"splendid\",\"splinter\",\"split (split, split)\",\"split up\",\"spoil\",\"spokesman\",\"sponge\",\"spooky\",\"spot\",\"spot\",\"spot\",\"spotlight\",\"spouse\",\"sprawl\",\"spread (spread, spread)\",\"spring (sprang, sprung)\",\"spring (sprang, sprung)\",\"sprinkle\",\"sprout\",\"spur\",\"spy (on)\",\"squad\",\"square\",\"square\",\"squash\",\"squat\",\"squeak\",\"squeal\",\"squeeze\",\"squid\",\"squint\",\"squirm\",\"squirrel\",\"squirt\",\"stab\",\"stable\",\"stack\",\"staff\",\"stage\",\"stage\",\"stagger\",\"stain\",\"stairs\",\"stake\",\"stake\",\"stale\",\"stalk\",\"stalk\",\"stall\",\"stall\",\"stamp\",\"stance\",\"stand\",\"stand against\",\"stand by\",\"stand for\",\"stand for\",\"stand out\",\"standpoint\",\"staple\",\"stare\",\"stark\",\"start up\",\"startle\",\"starve\",\"stash\",\"state\",\"state\",\"state\",\"stature\",\"statutory\",\"stay\",\"stay\",\"stay up\",\"steady\",\"steal (stole, stolen)\",\"stealth\",\"steam\",\"steel\",\"steep\",\"steer\",\"stellar\",\"stem\",\"step\",\"step down\",\"step in\",\"stern\",\"stew\",\"stick\",\"stick (stuck, stuck)\",\"stick at\",\"stick out\",\"stick to\",\"stick together\",\"stiff\",\"stifle\",\"still\",\"sting (stung, stung)\",\"stink (stank, stunk)\",\"stir\",\"stir up\",\"stitch\",\"stock\",\"stock\",\"stock up on\",\"stocking\",\"stomach\",\"stomp\",\"stool\",\"stoop\",\"stoop\",\"stop over\",\"store\",\"store\",\"stout\",\"stove\",\"straight\",\"straightforward\",\"strain\",\"strait\",\"strand\",\"strand\",\"strangle\",\"strap\",\"straw\",\"strawberry\",\"stray\",\"streak\",\"stream\",\"strength\",\"stress\",\"stretch\",\"strew (strewn, strewn)\",\"strict\",\"stride (strode, stridden)\",\"strike\",\"strike (struck, struck)\",\"strike out\",\"string\",\"stringent\",\"strip\",\"strip\",\"stripe\",\"strive (strove, striven)\",\"stroke\",\"stroll\",\"struggle\",\"stubborn\",\"stud\",\"stuff\",\"stuffy\",\"stumble\",\"stump\",\"stun\",\"stunt\",\"stupid\",\"sturdy\",\"subdue\",\"subject\",\"subject\",\"sublime\",\"submerge\",\"submit\",\"submit to\",\"subordinate\",\"subscribe\",\"subsequent\",\"subside\",\"subsidiary\",\"subsist\",\"substance\",\"substantial\",\"substantive\",\"substitute\",\"subtitle\",\"subtle\",\"subtract\",\"suburb\",\"subvert\",\"subway\",\"succeed\",\"success\",\"succession\",\"successor\",\"succumb\",\"suck\",\"sudden\",\"sue\",\"suffer\",\"suffice\",\"sufficient\",\"suffocate\",\"suggest\",\"suit\",\"suit\",\"suitcase\",\"suite\",\"sulfur (sulphur)\",\"sum\",\"sum up\",\"summary\",\"summit\",\"summon\",\"sunset\",\"superb\",\"superficial\",\"superintendent\",\"superior\",\"supervise\",\"supplement\",\"supply\",\"supply\",\"support\",\"suppose\",\"suppress\",\"supreme\",\"sure\",\"surf\",\"surface\",\"surge\",\"surgery\",\"surpass\",\"surplus\",\"surprise\",\"surrender\",\"surround\",\"surveillance\",\"survey\",\"survive\",\"susceptible\",\"suspect\",\"suspend\",\"suspicious\",\"sustain\",\"swallow\",\"swamp\",\"swan\",\"swap\",\"swarm\",\"sway\",\"swear\",\"swear\",\"sweat\",\"sweep\",\"sweep (swept, swept)\",\"sweetheart\",\"swell (swelled, swollen)\",\"swift\",\"swing (swung, swung)\",\"swirl\",\"switch\",\"swoop\",\"sword\",\"syllable\",\"symbol\",\"sympathy\",\"syringe\",\"table\",\"tablet\",\"tack\",\"tack\",\"tackle\",\"tackle\",\"tag\",\"tail\",\"tailor\",\"taint\",\"take\",\"take a look\",\"take a walk\",\"take aback\",\"take advantage of\",\"take after\",\"take apart\",\"take away\",\"take care\",\"take down\",\"take in\",\"take off\",\"take off\",\"take on\",\"take on\",\"take over\",\"take part\",\"take place\",\"take up\",\"talk into\",\"talk over\",\"talk smb out\",\"tall\",\"tally\",\"tame\",\"tan\",\"tangible\",\"tangle\",\"tank\",\"tap\",\"tap\",\"tape\",\"tar\",\"target\",\"tart\",\"task\",\"taste\",\"tattered\",\"taunt\",\"tax\",\"team\",\"tear\",\"tear (tore, torn)\",\"tease\",\"tedious\",\"teenage\",\"tell apart\",\"tell from\",\"tell off\",\"tell on\",\"temper\",\"temple\",\"temple\",\"temporary\",\"tempt\",\"tenant\",\"tend\",\"tend\",\"tender\",\"tense\",\"tent\",\"tentative\",\"term\",\"term\",\"terminal\",\"terminate\",\"terms\",\"terms\",\"terrain\",\"terrible\",\"terrify\",\"terror\",\"testament\",\"testify\",\"testimony\",\"text\",\"thank\",\"thaw\",\"theater (theatre)\",\"theft\",\"theme\",\"thereafter\",\"thereby\",\"therefore\",\"thermal\",\"thick\",\"thick\",\"thief (pl: thieves)\",\"thigh\",\"thin\",\"think over\",\"thirst\",\"thorn\",\"thorough\",\"though (even though)\",\"thought\",\"thread\",\"threat\",\"threshold\",\"thrift\",\"thrill\",\"thrive\",\"throat\",\"throng\",\"throw (threw, thrown)\",\"throw away\",\"throw up\",\"thrust\",\"thud\",\"thug\",\"thumb\",\"thump\",\"thunder\",\"thus\",\"thwart\",\"tick\",\"tick\",\"ticket\",\"tickle\",\"tide\",\"tidy\",\"tie\",\"tie\",\"tied up\",\"tier\",\"tight\",\"tile\",\"tilt\",\"timber\",\"timely\",\"timetable\",\"timid\",\"tin\",\"tinker with\",\"tint\",\"tiny\",\"tip\",\"tip\",\"tip (tips)\",\"tip smb off\",\"tire (tyre)\",\"tired\",\"tissue\",\"tissue\",\"title\",\"toddler\",\"toe\",\"toil\",\"token\",\"tolerate\",\"toll\",\"tomb\",\"tongue\",\"tool\",\"tooth (pl: teeth)\",\"topic\",\"topple\",\"tops\",\"torch\",\"torment\",\"torture\",\"toss\",\"total\",\"touch\",\"touch\",\"tough\",\"tournament\",\"tout\",\"tow\",\"toward (towards)\",\"towel\",\"tower\",\"toy with\",\"trace\",\"track\",\"track down\",\"trade\",\"traffic light\",\"trail\",\"train\",\"train\",\"trait\",\"traitor\",\"tram\",\"tramp\",\"tranquil\",\"transcend\",\"transcript\",\"transfer\",\"transition\",\"transmit\",\"transparent\",\"trap\",\"trash\",\"tray\",\"treachery\",\"tread\",\"treasure\",\"treat\",\"treaty\",\"trek\",\"tremble\",\"tremendous\",\"trench\",\"trial\",\"trial\",\"triangle\",\"tribe\",\"tribute\",\"trick\",\"trickle\",\"trigger\",\"trim\",\"trip\",\"triple\",\"troop\",\"trophy\",\"troublesome\",\"trousers\",\"trout\",\"truck\",\"trump\",\"trumpet\",\"trunk\",\"trunk\",\"trunk\",\"trust\",\"try on\",\"try out\",\"tub\",\"tube\",\"tube\",\"tube\",\"tuck\",\"tug\",\"tuition\",\"tumble\",\"tumor (tumour)\",\"tuna\",\"tune\",\"tune\",\"turkey\",\"turmoil\",\"turn\",\"turn away\",\"turn down\",\"turn into\",\"turn off\",\"turn off\",\"turn on\",\"turn on\",\"turn out\",\"turn over\",\"turn up\",\"turnover\",\"turtle\",\"tutor\",\"tweak\",\"twig\",\"twilight\",\"twin\",\"twinkle\",\"twirl\",\"twist\",\"twitch\",\"type\",\"ugly\",\"ultimate\",\"umbrella\",\"unanimous\",\"unbelievable\",\"uncle\",\"undergo\",\"underground\",\"underlie\",\"underline\",\"undermine\",\"underneath\",\"underpants\",\"underscore\",\"undertake\",\"underwear\",\"undo\",\"union\",\"unique\",\"unit\",\"unite\",\"universe\",\"unless\",\"upcoming\",\"update\",\"uphill\",\"uphold\",\"upper\",\"upright\",\"upright\",\"uprising (rising)\",\"upset\",\"upside down\",\"up-to-date\",\"upwards (upward)\",\"urban\",\"urge\",\"urgent\",\"usage\",\"used to\",\"useful\",\"utility\",\"utilize\",\"utter\",\"utter\",\"vacation\",\"vague\",\"vain\",\"vain\",\"valid\",\"valley\",\"value\",\"valve\",\"van\",\"vanish\",\"vapor\",\"variety\",\"various\",\"varnish\",\"vary\",\"vase\",\"vast\",\"vault\",\"vault\",\"veer\",\"vegetable\",\"vegetation\",\"vehicle\",\"veil\",\"vein\",\"velocity\",\"velvet\",\"vendor\",\"vengeance\",\"vent\",\"venture\",\"verb\",\"verge\",\"verge\",\"verify\",\"versatile\",\"verse\",\"vessel\",\"vessel\",\"vest\",\"via\",\"viable\",\"vice\",\"vice versa\",\"vicinity\",\"vicious\",\"victim\",\"view\",\"vigil\",\"vigor\",\"village\",\"villain\",\"vine\",\"vinegar\",\"violate\",\"violent\",\"violet\",\"violin\",\"virgin\",\"virtual\",\"virtue\",\"visible\",\"vision\",\"visit\",\"vital\",\"vivid\",\"vocabulary\",\"vocation\",\"void\",\"volatile\",\"volume\",\"volume\",\"volume\",\"voluntary\",\"vomit\",\"vote\",\"vow\",\"voyage\",\"vulnerable\",\"wad\",\"wade\",\"waffle\",\"wag\",\"wage\",\"wail\",\"waist\",\"waiter\",\"waive\",\"wake (up)\",\"wallet\",\"wallpaper\",\"walnut\",\"wander\",\"wane\",\"ward\",\"ward\",\"ward off\",\"warden\",\"wardrobe\",\"warehouse\",\"warfare\",\"warmth\",\"warn\",\"warp\",\"warrant\",\"warrior\",\"wary\",\"wash down\",\"wash up\",\"wash up\",\"waste\",\"waste\",\"watch\",\"watchful\",\"water down\",\"watercolor\",\"waterfall\",\"wave\",\"wave\",\"waver\",\"wax\",\"way\",\"weak\",\"wealth\",\"weapon\",\"wear\",\"wear off\",\"wear out\",\"weary\",\"weave\",\"wedding\",\"wedge\",\"weed\",\"weep\",\"weigh\",\"weight\",\"weird\",\"welcome\",\"weld\",\"welfare\",\"welfare\",\"well\",\"well-being\",\"well-off\",\"west\",\"wet\",\"whack\",\"whale\",\"whatsoever\",\"wheat\",\"wheel\",\"whereabouts\",\"whereas\",\"whereby\",\"whether\",\"whim\",\"whine\",\"whip\",\"whirl\",\"whisk\",\"whisper\",\"whistle\",\"whiz\",\"whiz\",\"whole\",\"wholesale\",\"whore\",\"wicked\",\"wide\",\"widespread\",\"widow\",\"width\",\"wield\",\"wiggle\",\"wilderness\",\"wildlife\",\"will\",\"willow\",\"wince\",\"wind (wound, wound)\",\"wind up\",\"windowpane\",\"wine\",\"wink\",\"wipe\",\"wipe out\",\"wire\",\"wise\",\"wit\",\"witch\",\"withdraw\",\"wither\",\"withhold\",\"within\",\"within\",\"withstand\",\"witness\",\"wizard\",\"wobble\",\"woe\",\"wonder\",\"wonder\",\"woo\",\"wood\",\"wool\",\"work out\",\"work out\",\"workshop\",\"worldwide\",\"worm\",\"worry\",\"worsen\",\"worship\",\"worth\",\"worthwhile\",\"wound\",\"wrap\",\"wrath\",\"wreath\",\"wreck\",\"wrench\",\"wrestle\",\"wretched\",\"wrinkle\",\"wrist\",\"write out\",\"wrong\",\"wrongdoing\",\"yacht\",\"yank\",\"yard\",\"yawn\",\"yearn\",\"yell\",\"yet\",\"yet\",\"yield\",\"yield\",\"youngster\",\"youth\",\"zeal\",\"zipper\",\"zoo\"]";

/***/ }),

/***/ 95485:
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"\'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\\"","QUOT":"\\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}');

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/amd options */
/******/ 	(() => {
/******/ 		__webpack_require__.amdO = {};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/create fake namespace object */
/******/ 	(() => {
/******/ 		var getProto = Object.getPrototypeOf ? (obj) => (Object.getPrototypeOf(obj)) : (obj) => (obj.__proto__);
/******/ 		var leafPrototypes;
/******/ 		// create a fake namespace object
/******/ 		// mode & 1: value is a module id, require it
/******/ 		// mode & 2: merge all properties of value into the ns
/******/ 		// mode & 4: return value when already ns object
/******/ 		// mode & 16: return value when it's Promise-like
/******/ 		// mode & 8|1: behave like require
/******/ 		__webpack_require__.t = function(value, mode) {
/******/ 			if(mode & 1) value = this(value);
/******/ 			if(mode & 8) return value;
/******/ 			if(typeof value === 'object' && value) {
/******/ 				if((mode & 4) && value.__esModule) return value;
/******/ 				if((mode & 16) && typeof value.then === 'function') return value;
/******/ 			}
/******/ 			var ns = Object.create(null);
/******/ 			__webpack_require__.r(ns);
/******/ 			var def = {};
/******/ 			leafPrototypes = leafPrototypes || [null, getProto({}), getProto([]), getProto(getProto)];
/******/ 			for(var current = mode & 2 && value; typeof current == 'object' && !~leafPrototypes.indexOf(current); current = getProto(current)) {
/******/ 				Object.getOwnPropertyNames(current).forEach((key) => (def[key] = () => (value[key])));
/******/ 			}
/******/ 			def['default'] = () => (value);
/******/ 			__webpack_require__.d(ns, def);
/******/ 			return ns;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	(() => {
/******/ 		__webpack_require__.f = {};
/******/ 		// This file contains only the entry chunk.
/******/ 		// The chunk loading function for additional chunks
/******/ 		__webpack_require__.e = (chunkId) => {
/******/ 			return Promise.all(Object.keys(__webpack_require__.f).reduce((promises, key) => {
/******/ 				__webpack_require__.f[key](chunkId, promises);
/******/ 				return promises;
/******/ 			}, []));
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.u = (chunkId) => {
/******/ 			// return url for filenames not based on template
/******/ 			if (chunkId === 928) return "487a582b76ec969d0b84.vendors.syntax_codemirror.js";
/******/ 			if (chunkId === 997) return "a6794726fa7eda006545.vendors.fs_web.js";
/******/ 			if (chunkId === 744) return "80387f022e44bfe19b6f.vendors.744.js";
/******/ 			if (chunkId === 157) return "ac0cbb28f6ca3e81e73d.vendors.pdfjs-dist.js";
/******/ 			// return url for filenames based on template
/******/ 			return undefined;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	(() => {
/******/ 		var inProgress = {};
/******/ 		var dataWebpackPrefix = "web-editor:";
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = (url, done, key, chunkId) => {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.setAttribute("data-webpack", dataWebpackPrefix + key);
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = (prev, event) => {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach((fn) => (fn(event)));
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			;
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "/static/assets/";
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			856: 0,
/******/ 			471: 0,
/******/ 			375: 0,
/******/ 			827: 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = (chunkId, promises) => {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(true) { // all chunks have JS
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// start chunk loading
/******/ 							var url = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = (event) => {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						} else installedChunks[chunkId] = 0;
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		// no on chunks loaded
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 		
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkweb_editor"] = self["webpackChunkweb_editor"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(28492);
/******/ 	module.exports = __webpack_exports__;
/******/ 	
/******/ })()
;